(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || Object.prototype.hasOwnProperty.call(dest, key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequirebd4c"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequirebd4c"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1etvo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0e5dfc633b3b514c$export$71511d61b312f219; });
function $0e5dfc633b3b514c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $0e5dfc633b3b514c$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $0e5dfc633b3b514c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $0e5dfc633b3b514c$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}

});

parcelRegister("ajWU5", function(module, exports) {

var $1etvo = parcelRequire("1etvo");

var $f2lgg = parcelRequire("f2lgg");

var $iXPoG = parcelRequire("iXPoG");

var $5grPd = parcelRequire("5grPd");

var $kmaE3 = parcelRequire("kmaE3");

var $hDjZy = parcelRequire("hDjZy");

var $2IZAT = parcelRequire("2IZAT");

var $7MsFd = parcelRequire("7MsFd");

var $8fxDh = parcelRequire("8fxDh");

var $aufOL = parcelRequire("aufOL");

var $yQrT8 = parcelRequire("yQrT8");

var $cTSGB = parcelRequire("cTSGB");

var $7d4tS = parcelRequire("7d4tS");

var $a36Ks = parcelRequire("a36Ks");

var $kJBqN = parcelRequire("kJBqN");
var $78395ec40f50896a$require$Buffer = $kJBqN.Buffer;

var $5XqL3 = parcelRequire("5XqL3");










/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2023 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */ (function webpackUniversalModuleDefinition(root, factory) {
    module.exports = root.pdfjsLib = factory();
})(globalThis, ()=>{
    return /******/ (()=>{
        /******/ "use strict";
        /******/ var __webpack_modules__ = [
            ,
            /* 1 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.VerbosityLevel = exports.Util = exports.UnknownErrorException = exports.UnexpectedResponseException = exports.TextRenderingMode = exports.RenderingIntentFlag = exports.PromiseCapability = exports.PermissionFlag = exports.PasswordResponses = exports.PasswordException = exports.PageActionEventType = exports.OPS = exports.MissingPDFException = exports.MAX_IMAGE_SIZE_TO_CACHE = exports.LINE_FACTOR = exports.LINE_DESCENT_FACTOR = exports.InvalidPDFException = exports.ImageKind = exports.IDENTITY_MATRIX = exports.FormatError = exports.FeatureTest = exports.FONT_IDENTITY_MATRIX = exports.DocumentActionEventType = exports.CMapCompressionType = exports.BaseException = exports.BASELINE_FACTOR = exports.AnnotationType = exports.AnnotationReplyType = exports.AnnotationPrefix = exports.AnnotationMode = exports.AnnotationFlag = exports.AnnotationFieldFlag = exports.AnnotationEditorType = exports.AnnotationEditorPrefix = exports.AnnotationEditorParamsType = exports.AnnotationBorderStyleType = exports.AnnotationActionEventType = exports.AbortException = void 0;
                exports.assert = assert;
                exports.bytesToString = bytesToString;
                exports.createValidAbsoluteUrl = createValidAbsoluteUrl;
                exports.getModificationDate = getModificationDate;
                exports.getUuid = getUuid;
                exports.getVerbosityLevel = getVerbosityLevel;
                exports.info = info;
                exports.isArrayBuffer = isArrayBuffer;
                exports.isArrayEqual = isArrayEqual;
                exports.isNodeJS = void 0;
                exports.normalizeUnicode = normalizeUnicode;
                exports.objectFromMap = objectFromMap;
                exports.objectSize = objectSize;
                exports.setVerbosityLevel = setVerbosityLevel;
                exports.shadow = shadow;
                exports.string32 = string32;
                exports.stringToBytes = stringToBytes;
                exports.stringToPDFString = stringToPDFString;
                exports.stringToUTF8String = stringToUTF8String;
                exports.unreachable = unreachable;
                exports.utf8StringToString = utf8StringToString;
                exports.warn = warn;
                const isNodeJS = false;
                exports.isNodeJS = isNodeJS;
                const IDENTITY_MATRIX = [
                    1,
                    0,
                    0,
                    1,
                    0,
                    0
                ];
                exports.IDENTITY_MATRIX = IDENTITY_MATRIX;
                const FONT_IDENTITY_MATRIX = [
                    0.001,
                    0,
                    0,
                    0.001,
                    0,
                    0
                ];
                exports.FONT_IDENTITY_MATRIX = FONT_IDENTITY_MATRIX;
                const MAX_IMAGE_SIZE_TO_CACHE = 10e6;
                exports.MAX_IMAGE_SIZE_TO_CACHE = MAX_IMAGE_SIZE_TO_CACHE;
                const LINE_FACTOR = 1.35;
                exports.LINE_FACTOR = LINE_FACTOR;
                const LINE_DESCENT_FACTOR = 0.35;
                exports.LINE_DESCENT_FACTOR = LINE_DESCENT_FACTOR;
                const BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
                exports.BASELINE_FACTOR = BASELINE_FACTOR;
                const RenderingIntentFlag = {
                    ANY: 0x01,
                    DISPLAY: 0x02,
                    PRINT: 0x04,
                    SAVE: 0x08,
                    ANNOTATIONS_FORMS: 0x10,
                    ANNOTATIONS_STORAGE: 0x20,
                    ANNOTATIONS_DISABLE: 0x40,
                    OPLIST: 0x100
                };
                exports.RenderingIntentFlag = RenderingIntentFlag;
                const AnnotationMode = {
                    DISABLE: 0,
                    ENABLE: 1,
                    ENABLE_FORMS: 2,
                    ENABLE_STORAGE: 3
                };
                exports.AnnotationMode = AnnotationMode;
                const AnnotationEditorPrefix = "pdfjs_internal_editor_";
                exports.AnnotationEditorPrefix = AnnotationEditorPrefix;
                const AnnotationEditorType = {
                    DISABLE: -1,
                    NONE: 0,
                    FREETEXT: 3,
                    STAMP: 13,
                    INK: 15
                };
                exports.AnnotationEditorType = AnnotationEditorType;
                const AnnotationEditorParamsType = {
                    RESIZE: 1,
                    CREATE: 2,
                    FREETEXT_SIZE: 11,
                    FREETEXT_COLOR: 12,
                    FREETEXT_OPACITY: 13,
                    INK_COLOR: 21,
                    INK_THICKNESS: 22,
                    INK_OPACITY: 23
                };
                exports.AnnotationEditorParamsType = AnnotationEditorParamsType;
                const PermissionFlag = {
                    PRINT: 0x04,
                    MODIFY_CONTENTS: 0x08,
                    COPY: 0x10,
                    MODIFY_ANNOTATIONS: 0x20,
                    FILL_INTERACTIVE_FORMS: 0x100,
                    COPY_FOR_ACCESSIBILITY: 0x200,
                    ASSEMBLE: 0x400,
                    PRINT_HIGH_QUALITY: 0x800
                };
                exports.PermissionFlag = PermissionFlag;
                const TextRenderingMode = {
                    FILL: 0,
                    STROKE: 1,
                    FILL_STROKE: 2,
                    INVISIBLE: 3,
                    FILL_ADD_TO_PATH: 4,
                    STROKE_ADD_TO_PATH: 5,
                    FILL_STROKE_ADD_TO_PATH: 6,
                    ADD_TO_PATH: 7,
                    FILL_STROKE_MASK: 3,
                    ADD_TO_PATH_FLAG: 4
                };
                exports.TextRenderingMode = TextRenderingMode;
                const ImageKind = {
                    GRAYSCALE_1BPP: 1,
                    RGB_24BPP: 2,
                    RGBA_32BPP: 3
                };
                exports.ImageKind = ImageKind;
                const AnnotationType = {
                    TEXT: 1,
                    LINK: 2,
                    FREETEXT: 3,
                    LINE: 4,
                    SQUARE: 5,
                    CIRCLE: 6,
                    POLYGON: 7,
                    POLYLINE: 8,
                    HIGHLIGHT: 9,
                    UNDERLINE: 10,
                    SQUIGGLY: 11,
                    STRIKEOUT: 12,
                    STAMP: 13,
                    CARET: 14,
                    INK: 15,
                    POPUP: 16,
                    FILEATTACHMENT: 17,
                    SOUND: 18,
                    MOVIE: 19,
                    WIDGET: 20,
                    SCREEN: 21,
                    PRINTERMARK: 22,
                    TRAPNET: 23,
                    WATERMARK: 24,
                    THREED: 25,
                    REDACT: 26
                };
                exports.AnnotationType = AnnotationType;
                const AnnotationReplyType = {
                    GROUP: "Group",
                    REPLY: "R"
                };
                exports.AnnotationReplyType = AnnotationReplyType;
                const AnnotationFlag = {
                    INVISIBLE: 0x01,
                    HIDDEN: 0x02,
                    PRINT: 0x04,
                    NOZOOM: 0x08,
                    NOROTATE: 0x10,
                    NOVIEW: 0x20,
                    READONLY: 0x40,
                    LOCKED: 0x80,
                    TOGGLENOVIEW: 0x100,
                    LOCKEDCONTENTS: 0x200
                };
                exports.AnnotationFlag = AnnotationFlag;
                const AnnotationFieldFlag = {
                    READONLY: 0x0000001,
                    REQUIRED: 0x0000002,
                    NOEXPORT: 0x0000004,
                    MULTILINE: 0x0001000,
                    PASSWORD: 0x0002000,
                    NOTOGGLETOOFF: 0x0004000,
                    RADIO: 0x0008000,
                    PUSHBUTTON: 0x0010000,
                    COMBO: 0x0020000,
                    EDIT: 0x0040000,
                    SORT: 0x0080000,
                    FILESELECT: 0x0100000,
                    MULTISELECT: 0x0200000,
                    DONOTSPELLCHECK: 0x0400000,
                    DONOTSCROLL: 0x0800000,
                    COMB: 0x1000000,
                    RICHTEXT: 0x2000000,
                    RADIOSINUNISON: 0x2000000,
                    COMMITONSELCHANGE: 0x4000000
                };
                exports.AnnotationFieldFlag = AnnotationFieldFlag;
                const AnnotationBorderStyleType = {
                    SOLID: 1,
                    DASHED: 2,
                    BEVELED: 3,
                    INSET: 4,
                    UNDERLINE: 5
                };
                exports.AnnotationBorderStyleType = AnnotationBorderStyleType;
                const AnnotationActionEventType = {
                    E: "Mouse Enter",
                    X: "Mouse Exit",
                    D: "Mouse Down",
                    U: "Mouse Up",
                    Fo: "Focus",
                    Bl: "Blur",
                    PO: "PageOpen",
                    PC: "PageClose",
                    PV: "PageVisible",
                    PI: "PageInvisible",
                    K: "Keystroke",
                    F: "Format",
                    V: "Validate",
                    C: "Calculate"
                };
                exports.AnnotationActionEventType = AnnotationActionEventType;
                const DocumentActionEventType = {
                    WC: "WillClose",
                    WS: "WillSave",
                    DS: "DidSave",
                    WP: "WillPrint",
                    DP: "DidPrint"
                };
                exports.DocumentActionEventType = DocumentActionEventType;
                const PageActionEventType = {
                    O: "PageOpen",
                    C: "PageClose"
                };
                exports.PageActionEventType = PageActionEventType;
                const VerbosityLevel = {
                    ERRORS: 0,
                    WARNINGS: 1,
                    INFOS: 5
                };
                exports.VerbosityLevel = VerbosityLevel;
                const CMapCompressionType = {
                    NONE: 0,
                    BINARY: 1
                };
                exports.CMapCompressionType = CMapCompressionType;
                const OPS = {
                    dependency: 1,
                    setLineWidth: 2,
                    setLineCap: 3,
                    setLineJoin: 4,
                    setMiterLimit: 5,
                    setDash: 6,
                    setRenderingIntent: 7,
                    setFlatness: 8,
                    setGState: 9,
                    save: 10,
                    restore: 11,
                    transform: 12,
                    moveTo: 13,
                    lineTo: 14,
                    curveTo: 15,
                    curveTo2: 16,
                    curveTo3: 17,
                    closePath: 18,
                    rectangle: 19,
                    stroke: 20,
                    closeStroke: 21,
                    fill: 22,
                    eoFill: 23,
                    fillStroke: 24,
                    eoFillStroke: 25,
                    closeFillStroke: 26,
                    closeEOFillStroke: 27,
                    endPath: 28,
                    clip: 29,
                    eoClip: 30,
                    beginText: 31,
                    endText: 32,
                    setCharSpacing: 33,
                    setWordSpacing: 34,
                    setHScale: 35,
                    setLeading: 36,
                    setFont: 37,
                    setTextRenderingMode: 38,
                    setTextRise: 39,
                    moveText: 40,
                    setLeadingMoveText: 41,
                    setTextMatrix: 42,
                    nextLine: 43,
                    showText: 44,
                    showSpacedText: 45,
                    nextLineShowText: 46,
                    nextLineSetSpacingShowText: 47,
                    setCharWidth: 48,
                    setCharWidthAndBounds: 49,
                    setStrokeColorSpace: 50,
                    setFillColorSpace: 51,
                    setStrokeColor: 52,
                    setStrokeColorN: 53,
                    setFillColor: 54,
                    setFillColorN: 55,
                    setStrokeGray: 56,
                    setFillGray: 57,
                    setStrokeRGBColor: 58,
                    setFillRGBColor: 59,
                    setStrokeCMYKColor: 60,
                    setFillCMYKColor: 61,
                    shadingFill: 62,
                    beginInlineImage: 63,
                    beginImageData: 64,
                    endInlineImage: 65,
                    paintXObject: 66,
                    markPoint: 67,
                    markPointProps: 68,
                    beginMarkedContent: 69,
                    beginMarkedContentProps: 70,
                    endMarkedContent: 71,
                    beginCompat: 72,
                    endCompat: 73,
                    paintFormXObjectBegin: 74,
                    paintFormXObjectEnd: 75,
                    beginGroup: 76,
                    endGroup: 77,
                    beginAnnotation: 80,
                    endAnnotation: 81,
                    paintImageMaskXObject: 83,
                    paintImageMaskXObjectGroup: 84,
                    paintImageXObject: 85,
                    paintInlineImageXObject: 86,
                    paintInlineImageXObjectGroup: 87,
                    paintImageXObjectRepeat: 88,
                    paintImageMaskXObjectRepeat: 89,
                    paintSolidColorImageMask: 90,
                    constructPath: 91
                };
                exports.OPS = OPS;
                const PasswordResponses = {
                    NEED_PASSWORD: 1,
                    INCORRECT_PASSWORD: 2
                };
                exports.PasswordResponses = PasswordResponses;
                let verbosity = VerbosityLevel.WARNINGS;
                function setVerbosityLevel(level) {
                    if (Number.isInteger(level)) verbosity = level;
                }
                function getVerbosityLevel() {
                    return verbosity;
                }
                function info(msg) {
                    if (verbosity >= VerbosityLevel.INFOS) console.log(`Info: ${msg}`);
                }
                function warn(msg) {
                    if (verbosity >= VerbosityLevel.WARNINGS) console.log(`Warning: ${msg}`);
                }
                function unreachable(msg) {
                    throw new Error(msg);
                }
                function assert(cond, msg) {
                    if (!cond) unreachable(msg);
                }
                function _isValidProtocol(url) {
                    switch(url === null || url === void 0 ? void 0 : url.protocol){
                        case "http:":
                        case "https:":
                        case "ftp:":
                        case "mailto:":
                        case "tel:":
                            return true;
                        default:
                            return false;
                    }
                }
                function createValidAbsoluteUrl(url, baseUrl = null, options = null) {
                    if (!url) return null;
                    try {
                        if (options && typeof url === "string") {
                            if (options.addDefaultProtocol && url.startsWith("www.")) {
                                const dots = url.match(/\./g);
                                if ((dots === null || dots === void 0 ? void 0 : dots.length) >= 2) url = `http://${url}`;
                            }
                            if (options.tryConvertEncoding) try {
                                url = stringToUTF8String(url);
                            } catch (e) {}
                        }
                        const absoluteUrl = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        if (_isValidProtocol(absoluteUrl)) return absoluteUrl;
                    } catch (e) {}
                    return null;
                }
                function shadow(obj, prop, value, nonSerializable = false) {
                    Object.defineProperty(obj, prop, {
                        value: value,
                        enumerable: !nonSerializable,
                        configurable: true,
                        writable: false
                    });
                    return value;
                }
                const BaseException = function BaseExceptionClosure() {
                    function BaseException(message, name) {
                        if (this.constructor === BaseException) unreachable("Cannot initialize BaseException.");
                        this.message = message;
                        this.name = name;
                    }
                    BaseException.prototype = new Error();
                    BaseException.constructor = BaseException;
                    return BaseException;
                }();
                exports.BaseException = BaseException;
                class PasswordException extends BaseException {
                    constructor(msg, code){
                        super(msg, "PasswordException");
                        this.code = code;
                    }
                }
                exports.PasswordException = PasswordException;
                class UnknownErrorException extends BaseException {
                    constructor(msg, details){
                        super(msg, "UnknownErrorException");
                        this.details = details;
                    }
                }
                exports.UnknownErrorException = UnknownErrorException;
                class InvalidPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "InvalidPDFException");
                    }
                }
                exports.InvalidPDFException = InvalidPDFException;
                class MissingPDFException extends BaseException {
                    constructor(msg){
                        super(msg, "MissingPDFException");
                    }
                }
                exports.MissingPDFException = MissingPDFException;
                class UnexpectedResponseException extends BaseException {
                    constructor(msg, status){
                        super(msg, "UnexpectedResponseException");
                        this.status = status;
                    }
                }
                exports.UnexpectedResponseException = UnexpectedResponseException;
                class FormatError extends BaseException {
                    constructor(msg){
                        super(msg, "FormatError");
                    }
                }
                exports.FormatError = FormatError;
                class AbortException extends BaseException {
                    constructor(msg){
                        super(msg, "AbortException");
                    }
                }
                exports.AbortException = AbortException;
                function bytesToString(bytes) {
                    if (typeof bytes !== "object" || (bytes === null || bytes === void 0 ? void 0 : bytes.length) === undefined) unreachable("Invalid argument for bytesToString");
                    const length = bytes.length;
                    const MAX_ARGUMENT_COUNT = 8192;
                    if (length < MAX_ARGUMENT_COUNT) return String.fromCharCode.apply(null, bytes);
                    const strBuf = [];
                    for(let i = 0; i < length; i += MAX_ARGUMENT_COUNT){
                        const chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
                        const chunk = bytes.subarray(i, chunkEnd);
                        strBuf.push(String.fromCharCode.apply(null, chunk));
                    }
                    return strBuf.join("");
                }
                function stringToBytes(str) {
                    if (typeof str !== "string") unreachable("Invalid argument for stringToBytes");
                    const length = str.length;
                    const bytes = new Uint8Array(length);
                    for(let i = 0; i < length; ++i)bytes[i] = str.charCodeAt(i) & 0xff;
                    return bytes;
                }
                function string32(value) {
                    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
                }
                function objectSize(obj) {
                    return Object.keys(obj).length;
                }
                function objectFromMap(map) {
                    const obj = Object.create(null);
                    for (const [key, value] of map)obj[key] = value;
                    return obj;
                }
                function isLittleEndian() {
                    const buffer8 = new Uint8Array(4);
                    buffer8[0] = 1;
                    const view32 = new Uint32Array(buffer8.buffer, 0, 1);
                    return view32[0] === 1;
                }
                function isEvalSupported() {
                    try {
                        new Function("");
                        return true;
                    } catch (e) {
                        return false;
                    }
                }
                class FeatureTest {
                    static get isLittleEndian() {
                        return shadow(this, "isLittleEndian", isLittleEndian());
                    }
                    static get isEvalSupported() {
                        return shadow(this, "isEvalSupported", isEvalSupported());
                    }
                    static get isOffscreenCanvasSupported() {
                        return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
                    }
                    static get platform() {
                        if (typeof navigator === "undefined") return shadow(this, "platform", {
                            isWin: false,
                            isMac: false
                        });
                        return shadow(this, "platform", {
                            isWin: navigator.platform.includes("Win"),
                            isMac: navigator.platform.includes("Mac")
                        });
                    }
                    static get isCSSRoundSupported() {
                        var _globalThis_CSS_supports, _globalThis_CSS;
                        return shadow(this, "isCSSRoundSupported", (_globalThis_CSS = globalThis.CSS) === null || _globalThis_CSS === void 0 ? void 0 : (_globalThis_CSS_supports = _globalThis_CSS.supports) === null || _globalThis_CSS_supports === void 0 ? void 0 : _globalThis_CSS_supports.call(_globalThis_CSS, "width: round(1.5px, 1px)"));
                    }
                }
                exports.FeatureTest = FeatureTest;
                const hexNumbers = [
                    ...Array(256).keys()
                ].map((n)=>n.toString(16).padStart(2, "0"));
                class Util {
                    static makeHexColor(r, g, b) {
                        return `#${hexNumbers[r]}${hexNumbers[g]}${hexNumbers[b]}`;
                    }
                    static scaleMinMax(transform, minMax) {
                        let temp;
                        if (transform[0]) {
                            if (transform[0] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[0];
                            minMax[1] *= transform[0];
                            if (transform[3] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[3];
                            minMax[3] *= transform[3];
                        } else {
                            temp = minMax[0];
                            minMax[0] = minMax[2];
                            minMax[2] = temp;
                            temp = minMax[1];
                            minMax[1] = minMax[3];
                            minMax[3] = temp;
                            if (transform[1] < 0) {
                                temp = minMax[2];
                                minMax[2] = minMax[3];
                                minMax[3] = temp;
                            }
                            minMax[2] *= transform[1];
                            minMax[3] *= transform[1];
                            if (transform[2] < 0) {
                                temp = minMax[0];
                                minMax[0] = minMax[1];
                                minMax[1] = temp;
                            }
                            minMax[0] *= transform[2];
                            minMax[1] *= transform[2];
                        }
                        minMax[0] += transform[4];
                        minMax[1] += transform[4];
                        minMax[2] += transform[5];
                        minMax[3] += transform[5];
                    }
                    static transform(m1, m2) {
                        return [
                            m1[0] * m2[0] + m1[2] * m2[1],
                            m1[1] * m2[0] + m1[3] * m2[1],
                            m1[0] * m2[2] + m1[2] * m2[3],
                            m1[1] * m2[2] + m1[3] * m2[3],
                            m1[0] * m2[4] + m1[2] * m2[5] + m1[4],
                            m1[1] * m2[4] + m1[3] * m2[5] + m1[5]
                        ];
                    }
                    static applyTransform(p, m) {
                        const xt = p[0] * m[0] + p[1] * m[2] + m[4];
                        const yt = p[0] * m[1] + p[1] * m[3] + m[5];
                        return [
                            xt,
                            yt
                        ];
                    }
                    static applyInverseTransform(p, m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        const xt = (p[0] * m[3] - p[1] * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
                        const yt = (-p[0] * m[1] + p[1] * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
                        return [
                            xt,
                            yt
                        ];
                    }
                    static getAxialAlignedBoundingBox(r, m) {
                        const p1 = this.applyTransform(r, m);
                        const p2 = this.applyTransform(r.slice(2, 4), m);
                        const p3 = this.applyTransform([
                            r[0],
                            r[3]
                        ], m);
                        const p4 = this.applyTransform([
                            r[2],
                            r[1]
                        ], m);
                        return [
                            Math.min(p1[0], p2[0], p3[0], p4[0]),
                            Math.min(p1[1], p2[1], p3[1], p4[1]),
                            Math.max(p1[0], p2[0], p3[0], p4[0]),
                            Math.max(p1[1], p2[1], p3[1], p4[1])
                        ];
                    }
                    static inverseTransform(m) {
                        const d = m[0] * m[3] - m[1] * m[2];
                        return [
                            m[3] / d,
                            -m[1] / d,
                            -m[2] / d,
                            m[0] / d,
                            (m[2] * m[5] - m[4] * m[3]) / d,
                            (m[4] * m[1] - m[5] * m[0]) / d
                        ];
                    }
                    static singularValueDecompose2dScale(m) {
                        const transpose = [
                            m[0],
                            m[2],
                            m[1],
                            m[3]
                        ];
                        const a = m[0] * transpose[0] + m[1] * transpose[2];
                        const b = m[0] * transpose[1] + m[1] * transpose[3];
                        const c = m[2] * transpose[0] + m[3] * transpose[2];
                        const d = m[2] * transpose[1] + m[3] * transpose[3];
                        const first = (a + d) / 2;
                        const second = Math.sqrt(Math.pow(a + d, 2) - 4 * (a * d - c * b)) / 2;
                        const sx = first + second || 1;
                        const sy = first - second || 1;
                        return [
                            Math.sqrt(sx),
                            Math.sqrt(sy)
                        ];
                    }
                    static normalizeRect(rect) {
                        const r = rect.slice(0);
                        if (rect[0] > rect[2]) {
                            r[0] = rect[2];
                            r[2] = rect[0];
                        }
                        if (rect[1] > rect[3]) {
                            r[1] = rect[3];
                            r[3] = rect[1];
                        }
                        return r;
                    }
                    static intersect(rect1, rect2) {
                        const xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
                        const xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
                        if (xLow > xHigh) return null;
                        const yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
                        const yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
                        if (yLow > yHigh) return null;
                        return [
                            xLow,
                            yLow,
                            xHigh,
                            yHigh
                        ];
                    }
                    static bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3) {
                        const tvalues = [], bounds = [
                            [],
                            []
                        ];
                        let a, b, c, t, t1, t2, b2ac, sqrtb2ac;
                        for(let i = 0; i < 2; ++i){
                            if (i === 0) {
                                b = 6 * x0 - 12 * x1 + 6 * x2;
                                a = -3 * x0 + 9 * x1 - 9 * x2 + 3 * x3;
                                c = 3 * x1 - 3 * x0;
                            } else {
                                b = 6 * y0 - 12 * y1 + 6 * y2;
                                a = -3 * y0 + 9 * y1 - 9 * y2 + 3 * y3;
                                c = 3 * y1 - 3 * y0;
                            }
                            if (Math.abs(a) < 1e-12) {
                                if (Math.abs(b) < 1e-12) continue;
                                t = -c / b;
                                if (0 < t && t < 1) tvalues.push(t);
                                continue;
                            }
                            b2ac = b * b - 4 * c * a;
                            sqrtb2ac = Math.sqrt(b2ac);
                            if (b2ac < 0) continue;
                            t1 = (-b + sqrtb2ac) / (2 * a);
                            if (0 < t1 && t1 < 1) tvalues.push(t1);
                            t2 = (-b - sqrtb2ac) / (2 * a);
                            if (0 < t2 && t2 < 1) tvalues.push(t2);
                        }
                        let j = tvalues.length, mt;
                        const jlen = j;
                        while(j--){
                            t = tvalues[j];
                            mt = 1 - t;
                            bounds[0][j] = mt * mt * mt * x0 + 3 * mt * mt * t * x1 + 3 * mt * t * t * x2 + t * t * t * x3;
                            bounds[1][j] = mt * mt * mt * y0 + 3 * mt * mt * t * y1 + 3 * mt * t * t * y2 + t * t * t * y3;
                        }
                        bounds[0][jlen] = x0;
                        bounds[1][jlen] = y0;
                        bounds[0][jlen + 1] = x3;
                        bounds[1][jlen + 1] = y3;
                        bounds[0].length = bounds[1].length = jlen + 2;
                        return [
                            Math.min(...bounds[0]),
                            Math.min(...bounds[1]),
                            Math.max(...bounds[0]),
                            Math.max(...bounds[1])
                        ];
                    }
                }
                exports.Util = Util;
                const PDFStringTranslateTable = [
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2d8,
                    0x2c7,
                    0x2c6,
                    0x2d9,
                    0x2dd,
                    0x2db,
                    0x2da,
                    0x2dc,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0x2022,
                    0x2020,
                    0x2021,
                    0x2026,
                    0x2014,
                    0x2013,
                    0x192,
                    0x2044,
                    0x2039,
                    0x203a,
                    0x2212,
                    0x2030,
                    0x201e,
                    0x201c,
                    0x201d,
                    0x2018,
                    0x2019,
                    0x201a,
                    0x2122,
                    0xfb01,
                    0xfb02,
                    0x141,
                    0x152,
                    0x160,
                    0x178,
                    0x17d,
                    0x131,
                    0x142,
                    0x153,
                    0x161,
                    0x17e,
                    0,
                    0x20ac
                ];
                function stringToPDFString(str) {
                    if (str[0] >= "\xEF") {
                        let encoding;
                        if (str[0] === "\xFE" && str[1] === "\xFF") encoding = "utf-16be";
                        else if (str[0] === "\xFF" && str[1] === "\xFE") encoding = "utf-16le";
                        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") encoding = "utf-8";
                        if (encoding) try {
                            const decoder = new TextDecoder(encoding, {
                                fatal: true
                            });
                            const buffer = stringToBytes(str);
                            return decoder.decode(buffer);
                        } catch (ex) {
                            warn(`stringToPDFString: "${ex}".`);
                        }
                    }
                    const strBuf = [];
                    for(let i = 0, ii = str.length; i < ii; i++){
                        const code = PDFStringTranslateTable[str.charCodeAt(i)];
                        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
                    }
                    return strBuf.join("");
                }
                function stringToUTF8String(str) {
                    return decodeURIComponent(escape(str));
                }
                function utf8StringToString(str) {
                    return unescape(encodeURIComponent(str));
                }
                function isArrayBuffer(v) {
                    return typeof v === "object" && (v === null || v === void 0 ? void 0 : v.byteLength) !== undefined;
                }
                function isArrayEqual(arr1, arr2) {
                    if (arr1.length !== arr2.length) return false;
                    for(let i = 0, ii = arr1.length; i < ii; i++){
                        if (arr1[i] !== arr2[i]) return false;
                    }
                    return true;
                }
                function getModificationDate(date = new Date()) {
                    const buffer = [
                        date.getUTCFullYear().toString(),
                        (date.getUTCMonth() + 1).toString().padStart(2, "0"),
                        date.getUTCDate().toString().padStart(2, "0"),
                        date.getUTCHours().toString().padStart(2, "0"),
                        date.getUTCMinutes().toString().padStart(2, "0"),
                        date.getUTCSeconds().toString().padStart(2, "0")
                    ];
                    return buffer.join("");
                }
                var _settled = /*#__PURE__*/ new WeakMap();
                class PromiseCapability {
                    get settled() {
                        return (0, $f2lgg._)(this, _settled);
                    }
                    constructor(){
                        (0, $iXPoG._)(this, _settled, {
                            writable: true,
                            value: false
                        });
                        this.promise = new Promise((resolve, reject)=>{
                            this.resolve = (data)=>{
                                (0, $5grPd._)(this, _settled, true);
                                resolve(data);
                            };
                            this.reject = (reason)=>{
                                (0, $5grPd._)(this, _settled, true);
                                reject(reason);
                            };
                        });
                    }
                }
                exports.PromiseCapability = PromiseCapability;
                let NormalizeRegex = null;
                let NormalizationMap = null;
                function normalizeUnicode(str) {
                    if (!NormalizeRegex) {
                        NormalizeRegex = RegExp("([\\u00a0\\u00b5\\u037e\\u0eb3\\u2000-\\u200a\\u202f\\u2126\\ufb00-\\ufb04\\ufb06\\ufb20-\\ufb36\\ufb38-\\ufb3c\\ufb3e\\ufb40-\\ufb41\\ufb43-\\ufb44\\ufb46-\\ufba1\\ufba4-\\ufba9\\ufbae-\\ufbb1\\ufbd3-\\ufbdc\\ufbde-\\ufbe7\\ufbea-\\ufbf8\\ufbfc-\\ufbfd\\ufc00-\\ufc5d\\ufc64-\\ufcf1\\ufcf5-\\ufd3d\\ufd88\\ufdf4\\ufdfa-\\ufdfb\\ufe71\\ufe77\\ufe79\\ufe7b\\ufe7d]+)|(\\ufb05+)", "gu");
                        NormalizationMap = new Map([
                            [
                                "\uFB05",
                                "\u017Ft"
                            ]
                        ]);
                    }
                    return str.replaceAll(NormalizeRegex, (_, p1, p2)=>{
                        return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2);
                    });
                }
                function getUuid() {
                    var _crypto, _crypto1;
                    if (typeof crypto !== "undefined" && typeof ((_crypto = crypto) === null || _crypto === void 0 ? void 0 : _crypto.randomUUID) === "function") return crypto.randomUUID();
                    const buf = new Uint8Array(32);
                    if (typeof crypto !== "undefined" && typeof ((_crypto1 = crypto) === null || _crypto1 === void 0 ? void 0 : _crypto1.getRandomValues) === "function") crypto.getRandomValues(buf);
                    else for(let i = 0; i < 32; i++)buf[i] = Math.floor(Math.random() * 255);
                    return bytesToString(buf);
                }
                const AnnotationPrefix = "pdfjs_internal_id_";
                exports.AnnotationPrefix = AnnotationPrefix;
            /***/ },
            /* 2 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.RenderTask = exports.PDFWorkerUtil = exports.PDFWorker = exports.PDFPageProxy = exports.PDFDocumentProxy = exports.PDFDocumentLoadingTask = exports.PDFDataRangeTransport = exports.LoopbackPort = exports.DefaultStandardFontDataFactory = exports.DefaultFilterFactory = exports.DefaultCanvasFactory = exports.DefaultCMapReaderFactory = void 0;
                Object.defineProperty(exports, "SVGGraphics", {
                    enumerable: true,
                    get: function() {
                        return _displaySvg.SVGGraphics;
                    }
                });
                exports.build = void 0;
                exports.getDocument = getDocument;
                exports.version = void 0;
                var _util = __w_pdfjs_require__(1);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _display_utils = __w_pdfjs_require__(6);
                var _font_loader = __w_pdfjs_require__(9);
                var _displayNode_utils = __w_pdfjs_require__(10);
                var _canvas = __w_pdfjs_require__(11);
                var _worker_options = __w_pdfjs_require__(14);
                var _message_handler = __w_pdfjs_require__(15);
                var _metadata = __w_pdfjs_require__(16);
                var _optional_content_config = __w_pdfjs_require__(17);
                var _transport_stream = __w_pdfjs_require__(18);
                var _displayFetch_stream = __w_pdfjs_require__(19);
                var _displayNetwork = __w_pdfjs_require__(22);
                var _displayNode_stream = __w_pdfjs_require__(23);
                var _displaySvg = __w_pdfjs_require__(24);
                var _xfa_text = __w_pdfjs_require__(25);
                const DEFAULT_RANGE_CHUNK_SIZE = 65536;
                const RENDERING_CANCELLED_TIMEOUT = 100;
                const DELAYED_CLEANUP_TIMEOUT = 5000;
                const DefaultCanvasFactory = _util.isNodeJS ? _displayNode_utils.NodeCanvasFactory : _display_utils.DOMCanvasFactory;
                exports.DefaultCanvasFactory = DefaultCanvasFactory;
                const DefaultCMapReaderFactory = _util.isNodeJS ? _displayNode_utils.NodeCMapReaderFactory : _display_utils.DOMCMapReaderFactory;
                exports.DefaultCMapReaderFactory = DefaultCMapReaderFactory;
                const DefaultFilterFactory = _util.isNodeJS ? _displayNode_utils.NodeFilterFactory : _display_utils.DOMFilterFactory;
                exports.DefaultFilterFactory = DefaultFilterFactory;
                const DefaultStandardFontDataFactory = _util.isNodeJS ? _displayNode_utils.NodeStandardFontDataFactory : _display_utils.DOMStandardFontDataFactory;
                exports.DefaultStandardFontDataFactory = DefaultStandardFontDataFactory;
                function getDocument(src) {
                    if (typeof src === "string" || src instanceof URL) src = {
                        url: src
                    };
                    else if ((0, _util.isArrayBuffer)(src)) src = {
                        data: src
                    };
                    if (typeof src !== "object") throw new Error("Invalid parameter in getDocument, need parameter object.");
                    if (!src.url && !src.data && !src.range) throw new Error("Invalid parameter object: need either .data, .range or .url");
                    const task = new PDFDocumentLoadingTask();
                    const { docId } = task;
                    const url = src.url ? getUrlProp(src.url) : null;
                    const data = src.data ? getDataProp(src.data) : null;
                    const httpHeaders = src.httpHeaders || null;
                    const withCredentials = src.withCredentials === true;
                    var _src_password;
                    const password = (_src_password = src.password) !== null && _src_password !== void 0 ? _src_password : null;
                    const rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
                    const rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
                    let worker = src.worker instanceof PDFWorker ? src.worker : null;
                    const verbosity = src.verbosity;
                    const docBaseUrl = typeof src.docBaseUrl === "string" && !(0, _display_utils.isDataScheme)(src.docBaseUrl) ? src.docBaseUrl : null;
                    const cMapUrl = typeof src.cMapUrl === "string" ? src.cMapUrl : null;
                    const cMapPacked = src.cMapPacked !== false;
                    const CMapReaderFactory = src.CMapReaderFactory || DefaultCMapReaderFactory;
                    const standardFontDataUrl = typeof src.standardFontDataUrl === "string" ? src.standardFontDataUrl : null;
                    const StandardFontDataFactory = src.StandardFontDataFactory || DefaultStandardFontDataFactory;
                    const ignoreErrors = src.stopAtErrors !== true;
                    const maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
                    const isEvalSupported = src.isEvalSupported !== false;
                    const isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !_util.isNodeJS;
                    const canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
                    const disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : _util.isNodeJS;
                    const fontExtraProperties = src.fontExtraProperties === true;
                    const enableXfa = src.enableXfa === true;
                    const ownerDocument = src.ownerDocument || globalThis.document;
                    const disableRange = src.disableRange === true;
                    const disableStream = src.disableStream === true;
                    const disableAutoFetch = src.disableAutoFetch === true;
                    const pdfBug = src.pdfBug === true;
                    var _src_length;
                    const length = rangeTransport ? rangeTransport.length : (_src_length = src.length) !== null && _src_length !== void 0 ? _src_length : NaN;
                    const useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !_util.isNodeJS && !disableFontFace;
                    const useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : CMapReaderFactory === _display_utils.DOMCMapReaderFactory && StandardFontDataFactory === _display_utils.DOMStandardFontDataFactory && cMapUrl && standardFontDataUrl && (0, _display_utils.isValidFetchUrl)(cMapUrl, document.baseURI) && (0, _display_utils.isValidFetchUrl)(standardFontDataUrl, document.baseURI);
                    const canvasFactory = src.canvasFactory || new DefaultCanvasFactory({
                        ownerDocument: ownerDocument
                    });
                    const filterFactory = src.filterFactory || new DefaultFilterFactory({
                        docId: docId,
                        ownerDocument: ownerDocument
                    });
                    const styleElement = null;
                    (0, _util.setVerbosityLevel)(verbosity);
                    const transportFactory = {
                        canvasFactory: canvasFactory,
                        filterFactory: filterFactory
                    };
                    if (!useWorkerFetch) {
                        transportFactory.cMapReaderFactory = new CMapReaderFactory({
                            baseUrl: cMapUrl,
                            isCompressed: cMapPacked
                        });
                        transportFactory.standardFontDataFactory = new StandardFontDataFactory({
                            baseUrl: standardFontDataUrl
                        });
                    }
                    if (!worker) {
                        const workerParams = {
                            verbosity: verbosity,
                            port: _worker_options.GlobalWorkerOptions.workerPort
                        };
                        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
                        task._worker = worker;
                    }
                    const fetchDocParams = {
                        docId: docId,
                        apiVersion: '3.11.174',
                        data: data,
                        password: password,
                        disableAutoFetch: disableAutoFetch,
                        rangeChunkSize: rangeChunkSize,
                        length: length,
                        docBaseUrl: docBaseUrl,
                        enableXfa: enableXfa,
                        evaluatorOptions: {
                            maxImageSize: maxImageSize,
                            disableFontFace: disableFontFace,
                            ignoreErrors: ignoreErrors,
                            isEvalSupported: isEvalSupported,
                            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
                            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
                            fontExtraProperties: fontExtraProperties,
                            useSystemFonts: useSystemFonts,
                            cMapUrl: useWorkerFetch ? cMapUrl : null,
                            standardFontDataUrl: useWorkerFetch ? standardFontDataUrl : null
                        }
                    };
                    const transportParams = {
                        ignoreErrors: ignoreErrors,
                        isEvalSupported: isEvalSupported,
                        disableFontFace: disableFontFace,
                        fontExtraProperties: fontExtraProperties,
                        enableXfa: enableXfa,
                        ownerDocument: ownerDocument,
                        disableAutoFetch: disableAutoFetch,
                        pdfBug: pdfBug,
                        styleElement: styleElement
                    };
                    worker.promise.then(function() {
                        if (task.destroyed) throw new Error("Loading aborted");
                        const workerIdPromise = _fetchDocument(worker, fetchDocParams);
                        const networkStreamPromise = new Promise(function(resolve) {
                            let networkStream;
                            if (rangeTransport) networkStream = new _transport_stream.PDFDataTransportStream({
                                length: length,
                                initialData: rangeTransport.initialData,
                                progressiveDone: rangeTransport.progressiveDone,
                                contentDispositionFilename: rangeTransport.contentDispositionFilename,
                                disableRange: disableRange,
                                disableStream: disableStream
                            }, rangeTransport);
                            else if (!data) {
                                const createPDFNetworkStream = (params)=>{
                                    if (_util.isNodeJS) return new _displayNode_stream.PDFNodeStream(params);
                                    return (0, _display_utils.isValidFetchUrl)(params.url) ? new _displayFetch_stream.PDFFetchStream(params) : new _displayNetwork.PDFNetworkStream(params);
                                };
                                networkStream = createPDFNetworkStream({
                                    url: url,
                                    length: length,
                                    httpHeaders: httpHeaders,
                                    withCredentials: withCredentials,
                                    rangeChunkSize: rangeChunkSize,
                                    disableRange: disableRange,
                                    disableStream: disableStream
                                });
                            }
                            resolve(networkStream);
                        });
                        return Promise.all([
                            workerIdPromise,
                            networkStreamPromise
                        ]).then(function([workerId, networkStream]) {
                            if (task.destroyed) throw new Error("Loading aborted");
                            const messageHandler = new _message_handler.MessageHandler(docId, workerId, worker.port);
                            const transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
                            task._transport = transport;
                            messageHandler.send("Ready", null);
                        });
                    }).catch(task._capability.reject);
                    return task;
                }
                function _fetchDocument(worker, source) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        if (worker.destroyed) throw new Error("Worker was destroyed");
                        const workerId = yield worker.messageHandler.sendWithPromise("GetDocRequest", source, source.data ? [
                            source.data.buffer
                        ] : null);
                        if (worker.destroyed) throw new Error("Worker was destroyed");
                        return workerId;
                    })();
                }
                function getUrlProp(val) {
                    if (val instanceof URL) return val.href;
                    try {
                        return new URL(val, window.location).href;
                    } catch (e) {
                        if (_util.isNodeJS && typeof val === "string") return val;
                    }
                    throw new Error("Invalid PDF url data: either string or URL-object is expected in the url property.");
                }
                function getDataProp(val) {
                    if (_util.isNodeJS && typeof $78395ec40f50896a$require$Buffer !== "undefined" && val instanceof $78395ec40f50896a$require$Buffer) throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
                    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) return val;
                    if (typeof val === "string") return (0, _util.stringToBytes)(val);
                    if (typeof val === "object" && !isNaN(val === null || val === void 0 ? void 0 : val.length) || (0, _util.isArrayBuffer)(val)) return new Uint8Array(val);
                    throw new Error("Invalid PDF binary data: either TypedArray, string, or array-like object is expected in the data property.");
                }
                class PDFDocumentLoadingTask {
                    get promise() {
                        return this._capability.promise;
                    }
                    destroy() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            this.destroyed = true;
                            try {
                                var _this__worker, _this__transport;
                                if ((_this__worker = this._worker) === null || _this__worker === void 0 ? void 0 : _this__worker.port) this._worker._pendingDestroy = true;
                                yield (_this__transport = this._transport) === null || _this__transport === void 0 ? void 0 : _this__transport.destroy();
                            } catch (ex) {
                                var _this__worker1;
                                if ((_this__worker1 = this._worker) === null || _this__worker1 === void 0 ? void 0 : _this__worker1.port) delete this._worker._pendingDestroy;
                                throw ex;
                            }
                            this._transport = null;
                            if (this._worker) {
                                this._worker.destroy();
                                this._worker = null;
                            }
                        }).call(this);
                    }
                    constructor(){
                        this._capability = new _util.PromiseCapability();
                        this._transport = null;
                        this._worker = null;
                        this.docId = `d${(0, $aufOL._)(PDFDocumentLoadingTask, PDFDocumentLoadingTask, _docId).value++}`;
                        this.destroyed = false;
                        this.onPassword = null;
                        this.onProgress = null;
                    }
                }
                var _docId = {
                    writable: true,
                    value: 0
                };
                exports.PDFDocumentLoadingTask = PDFDocumentLoadingTask;
                class PDFDataRangeTransport {
                    addRangeListener(listener) {
                        this._rangeListeners.push(listener);
                    }
                    addProgressListener(listener) {
                        this._progressListeners.push(listener);
                    }
                    addProgressiveReadListener(listener) {
                        this._progressiveReadListeners.push(listener);
                    }
                    addProgressiveDoneListener(listener) {
                        this._progressiveDoneListeners.push(listener);
                    }
                    onDataRange(begin, chunk) {
                        for (const listener of this._rangeListeners)listener(begin, chunk);
                    }
                    onDataProgress(loaded, total) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressListeners)listener(loaded, total);
                        });
                    }
                    onDataProgressiveRead(chunk) {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveReadListeners)listener(chunk);
                        });
                    }
                    onDataProgressiveDone() {
                        this._readyCapability.promise.then(()=>{
                            for (const listener of this._progressiveDoneListeners)listener();
                        });
                    }
                    transportReady() {
                        this._readyCapability.resolve();
                    }
                    requestDataRange(begin, end) {
                        (0, _util.unreachable)("Abstract method PDFDataRangeTransport.requestDataRange");
                    }
                    abort() {}
                    constructor(length, initialData, progressiveDone = false, contentDispositionFilename = null){
                        this.length = length;
                        this.initialData = initialData;
                        this.progressiveDone = progressiveDone;
                        this.contentDispositionFilename = contentDispositionFilename;
                        this._rangeListeners = [];
                        this._progressListeners = [];
                        this._progressiveReadListeners = [];
                        this._progressiveDoneListeners = [];
                        this._readyCapability = new _util.PromiseCapability();
                    }
                }
                exports.PDFDataRangeTransport = PDFDataRangeTransport;
                class PDFDocumentProxy {
                    get annotationStorage() {
                        return this._transport.annotationStorage;
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get numPages() {
                        return this._pdfInfo.numPages;
                    }
                    get fingerprints() {
                        return this._pdfInfo.fingerprints;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    get allXfaHtml() {
                        return this._transport._htmlForXfa;
                    }
                    getPage(pageNumber) {
                        return this._transport.getPage(pageNumber);
                    }
                    getPageIndex(ref) {
                        return this._transport.getPageIndex(ref);
                    }
                    getDestinations() {
                        return this._transport.getDestinations();
                    }
                    getDestination(id) {
                        return this._transport.getDestination(id);
                    }
                    getPageLabels() {
                        return this._transport.getPageLabels();
                    }
                    getPageLayout() {
                        return this._transport.getPageLayout();
                    }
                    getPageMode() {
                        return this._transport.getPageMode();
                    }
                    getViewerPreferences() {
                        return this._transport.getViewerPreferences();
                    }
                    getOpenAction() {
                        return this._transport.getOpenAction();
                    }
                    getAttachments() {
                        return this._transport.getAttachments();
                    }
                    getJSActions() {
                        return this._transport.getDocJSActions();
                    }
                    getOutline() {
                        return this._transport.getOutline();
                    }
                    getOptionalContentConfig() {
                        return this._transport.getOptionalContentConfig();
                    }
                    getPermissions() {
                        return this._transport.getPermissions();
                    }
                    getMetadata() {
                        return this._transport.getMetadata();
                    }
                    getMarkInfo() {
                        return this._transport.getMarkInfo();
                    }
                    getData() {
                        return this._transport.getData();
                    }
                    saveDocument() {
                        return this._transport.saveDocument();
                    }
                    getDownloadInfo() {
                        return this._transport.downloadInfoCapability.promise;
                    }
                    cleanup(keepLoadedFonts = false) {
                        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
                    }
                    destroy() {
                        return this.loadingTask.destroy();
                    }
                    get loadingParams() {
                        return this._transport.loadingParams;
                    }
                    get loadingTask() {
                        return this._transport.loadingTask;
                    }
                    getFieldObjects() {
                        return this._transport.getFieldObjects();
                    }
                    hasJSActions() {
                        return this._transport.hasJSActions();
                    }
                    getCalculationOrderIds() {
                        return this._transport.getCalculationOrderIds();
                    }
                    constructor(pdfInfo, transport){
                        this._pdfInfo = pdfInfo;
                        this._transport = transport;
                        Object.defineProperty(this, "getJavaScript", {
                            value: ()=>{
                                (0, _display_utils.deprecated)("`PDFDocumentProxy.getJavaScript`, please use `PDFDocumentProxy.getJSActions` instead.");
                                return this.getJSActions().then((js)=>{
                                    if (!js) return js;
                                    const jsArr = [];
                                    for(const name in js)jsArr.push(...js[name]);
                                    return jsArr;
                                });
                            }
                        });
                    }
                }
                exports.PDFDocumentProxy = PDFDocumentProxy;
                var _delayedCleanupTimeout = /*#__PURE__*/ new WeakMap(), _pendingCleanup = /*#__PURE__*/ new WeakMap(), _tryCleanup = /*#__PURE__*/ new WeakSet(), _abortDelayedCleanup = /*#__PURE__*/ new WeakSet();
                class PDFPageProxy {
                    get pageNumber() {
                        return this._pageIndex + 1;
                    }
                    get rotate() {
                        return this._pageInfo.rotate;
                    }
                    get ref() {
                        return this._pageInfo.ref;
                    }
                    get userUnit() {
                        return this._pageInfo.userUnit;
                    }
                    get view() {
                        return this._pageInfo.view;
                    }
                    getViewport({ scale, rotation = this.rotate, offsetX = 0, offsetY = 0, dontFlip = false } = {}) {
                        return new _display_utils.PageViewport({
                            viewBox: this.view,
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    getAnnotations({ intent = "display" } = {}) {
                        const intentArgs = this._transport.getRenderingIntent(intent);
                        return this._transport.getAnnotations(this._pageIndex, intentArgs.renderingIntent);
                    }
                    getJSActions() {
                        return this._transport.getPageJSActions(this._pageIndex);
                    }
                    get filterFactory() {
                        return this._transport.filterFactory;
                    }
                    get isPureXfa() {
                        return (0, _util.shadow)(this, "isPureXfa", !!this._transport._htmlForXfa);
                    }
                    getXfa() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            var _this__transport__htmlForXfa;
                            return ((_this__transport__htmlForXfa = this._transport._htmlForXfa) === null || _this__transport__htmlForXfa === void 0 ? void 0 : _this__transport__htmlForXfa.children[this._pageIndex]) || null;
                        }).call(this);
                    }
                    render({ canvasContext, viewport, intent = "display", annotationMode = _util.AnnotationMode.ENABLE, transform = null, background = null, optionalContentConfigPromise = null, annotationCanvasMap = null, pageColors = null, printAnnotationStorage = null }) {
                        var _this__stats;
                        var _intentState;
                        (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Overall");
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage);
                        (0, $5grPd._)(this, _pendingCleanup, false);
                        (0, $hDjZy._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                        if (!optionalContentConfigPromise) optionalContentConfigPromise = this._transport.getOptionalContentConfig();
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        const intentPrint = !!(intentArgs.renderingIntent & _util.RenderingIntentFlag.PRINT);
                        if (!intentState.displayReadyCapability) {
                            var _this__stats1;
                            intentState.displayReadyCapability = new _util.PromiseCapability();
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            (_this__stats1 = this._stats) === null || _this__stats1 === void 0 ? void 0 : _this__stats1.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        const complete = (error)=>{
                            var _this__stats, _this__stats1;
                            intentState.renderTasks.delete(internalRenderTask);
                            if (this._maybeCleanupAfterRender || intentPrint) (0, $5grPd._)(this, _pendingCleanup, true);
                            (0, $hDjZy._)(this, _tryCleanup, tryCleanup).call(this, !intentPrint);
                            if (error) {
                                internalRenderTask.capability.reject(error);
                                this._abortOperatorList({
                                    intentState: intentState,
                                    reason: error instanceof Error ? error : new Error(error)
                                });
                            } else internalRenderTask.capability.resolve();
                            (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.timeEnd("Rendering");
                            (_this__stats1 = this._stats) === null || _this__stats1 === void 0 ? void 0 : _this__stats1.timeEnd("Overall");
                        };
                        const internalRenderTask = new InternalRenderTask({
                            callback: complete,
                            params: {
                                canvasContext: canvasContext,
                                viewport: viewport,
                                transform: transform,
                                background: background
                            },
                            objs: this.objs,
                            commonObjs: this.commonObjs,
                            annotationCanvasMap: annotationCanvasMap,
                            operatorList: intentState.operatorList,
                            pageIndex: this._pageIndex,
                            canvasFactory: this._transport.canvasFactory,
                            filterFactory: this._transport.filterFactory,
                            useRequestAnimationFrame: !intentPrint,
                            pdfBug: this._pdfBug,
                            pageColors: pageColors
                        });
                        ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(internalRenderTask);
                        const renderTask = internalRenderTask.task;
                        Promise.all([
                            intentState.displayReadyCapability.promise,
                            optionalContentConfigPromise
                        ]).then(([transparency, optionalContentConfig])=>{
                            var _this__stats;
                            if (this.destroyed) {
                                complete();
                                return;
                            }
                            (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Rendering");
                            internalRenderTask.initializeGraphics({
                                transparency: transparency,
                                optionalContentConfig: optionalContentConfig
                            });
                            internalRenderTask.operatorListChanged();
                        }).catch(complete);
                        return renderTask;
                    }
                    getOperatorList({ intent = "display", annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null } = {}) {
                        function operatorListChanged() {
                            if (intentState.operatorList.lastChunk) {
                                intentState.opListReadCapability.resolve(intentState.operatorList);
                                intentState.renderTasks.delete(opListTask);
                            }
                        }
                        const intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, true);
                        let intentState = this._intentStates.get(intentArgs.cacheKey);
                        if (!intentState) {
                            intentState = Object.create(null);
                            this._intentStates.set(intentArgs.cacheKey, intentState);
                        }
                        let opListTask;
                        if (!intentState.opListReadCapability) {
                            var _this__stats;
                            var _intentState;
                            opListTask = Object.create(null);
                            opListTask.operatorListChanged = operatorListChanged;
                            intentState.opListReadCapability = new _util.PromiseCapability();
                            ((_intentState = intentState).renderTasks || (_intentState.renderTasks = new Set())).add(opListTask);
                            intentState.operatorList = {
                                fnArray: [],
                                argsArray: [],
                                lastChunk: false,
                                separateAnnots: null
                            };
                            (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.time("Page Request");
                            this._pumpOperatorList(intentArgs);
                        }
                        return intentState.opListReadCapability.promise;
                    }
                    streamTextContent({ includeMarkedContent = false, disableNormalization = false } = {}) {
                        const TEXT_CONTENT_CHUNK_SIZE = 100;
                        return this._transport.messageHandler.sendWithStream("GetTextContent", {
                            pageIndex: this._pageIndex,
                            includeMarkedContent: includeMarkedContent === true,
                            disableNormalization: disableNormalization === true
                        }, {
                            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
                            size (textContent) {
                                return textContent.items.length;
                            }
                        });
                    }
                    getTextContent(params = {}) {
                        if (this._transport._htmlForXfa) return this.getXfa().then((xfa)=>{
                            return _xfa_text.XfaText.textContent(xfa);
                        });
                        const readableStream = this.streamTextContent(params);
                        return new Promise(function(resolve, reject) {
                            function pump() {
                                reader.read().then(function({ value, done }) {
                                    if (done) {
                                        resolve(textContent);
                                        return;
                                    }
                                    Object.assign(textContent.styles, value.styles);
                                    textContent.items.push(...value.items);
                                    pump();
                                }, reject);
                            }
                            const reader = readableStream.getReader();
                            const textContent = {
                                items: [],
                                styles: Object.create(null)
                            };
                            pump();
                        });
                    }
                    getStructTree() {
                        return this._transport.getStructTree(this._pageIndex);
                    }
                    _destroy() {
                        this.destroyed = true;
                        const waitOn = [];
                        for (const intentState of this._intentStates.values()){
                            this._abortOperatorList({
                                intentState: intentState,
                                reason: new Error("Page was destroyed."),
                                force: true
                            });
                            if (intentState.opListReadCapability) continue;
                            for (const internalRenderTask of intentState.renderTasks){
                                waitOn.push(internalRenderTask.completed);
                                internalRenderTask.cancel();
                            }
                        }
                        this.objs.clear();
                        (0, $5grPd._)(this, _pendingCleanup, false);
                        (0, $hDjZy._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                        return Promise.all(waitOn);
                    }
                    cleanup(resetStats = false) {
                        (0, $5grPd._)(this, _pendingCleanup, true);
                        const success = (0, $hDjZy._)(this, _tryCleanup, tryCleanup).call(this, false);
                        if (resetStats && success) this._stats && (this._stats = new _display_utils.StatTimer());
                        return success;
                    }
                    _startRenderPage(transparency, cacheKey) {
                        var _this__stats, _intentState_displayReadyCapability;
                        const intentState = this._intentStates.get(cacheKey);
                        if (!intentState) return;
                        (_this__stats = this._stats) === null || _this__stats === void 0 ? void 0 : _this__stats.timeEnd("Page Request");
                        (_intentState_displayReadyCapability = intentState.displayReadyCapability) === null || _intentState_displayReadyCapability === void 0 ? void 0 : _intentState_displayReadyCapability.resolve(transparency);
                    }
                    _renderPageChunk(operatorListChunk, intentState) {
                        for(let i = 0, ii = operatorListChunk.length; i < ii; i++){
                            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
                            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
                        }
                        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
                        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
                        for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                        if (operatorListChunk.lastChunk) (0, $hDjZy._)(this, _tryCleanup, tryCleanup).call(this, true);
                    }
                    _pumpOperatorList({ renderingIntent, cacheKey, annotationStorageSerializable }) {
                        const { map, transfers } = annotationStorageSerializable;
                        const readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
                            pageIndex: this._pageIndex,
                            intent: renderingIntent,
                            cacheKey: cacheKey,
                            annotationStorage: map
                        }, transfers);
                        const reader = readableStream.getReader();
                        const intentState = this._intentStates.get(cacheKey);
                        intentState.streamReader = reader;
                        const pump = ()=>{
                            reader.read().then(({ value, done })=>{
                                if (done) {
                                    intentState.streamReader = null;
                                    return;
                                }
                                if (this._transport.destroyed) return;
                                this._renderPageChunk(value, intentState);
                                pump();
                            }, (reason)=>{
                                intentState.streamReader = null;
                                if (this._transport.destroyed) return;
                                if (intentState.operatorList) {
                                    intentState.operatorList.lastChunk = true;
                                    for (const internalRenderTask of intentState.renderTasks)internalRenderTask.operatorListChanged();
                                    (0, $hDjZy._)(this, _tryCleanup, tryCleanup).call(this, true);
                                }
                                if (intentState.displayReadyCapability) intentState.displayReadyCapability.reject(reason);
                                else if (intentState.opListReadCapability) intentState.opListReadCapability.reject(reason);
                                else throw reason;
                            });
                        };
                        pump();
                    }
                    _abortOperatorList({ intentState, reason, force = false }) {
                        if (!intentState.streamReader) return;
                        if (intentState.streamReaderCancelTimeout) {
                            clearTimeout(intentState.streamReaderCancelTimeout);
                            intentState.streamReaderCancelTimeout = null;
                        }
                        if (!force) {
                            if (intentState.renderTasks.size > 0) return;
                            if (reason instanceof _display_utils.RenderingCancelledException) {
                                let delay = RENDERING_CANCELLED_TIMEOUT;
                                if (reason.extraDelay > 0 && reason.extraDelay < 1000) delay += reason.extraDelay;
                                intentState.streamReaderCancelTimeout = setTimeout(()=>{
                                    intentState.streamReaderCancelTimeout = null;
                                    this._abortOperatorList({
                                        intentState: intentState,
                                        reason: reason,
                                        force: true
                                    });
                                }, delay);
                                return;
                            }
                        }
                        intentState.streamReader.cancel(new _util.AbortException(reason.message)).catch(()=>{});
                        intentState.streamReader = null;
                        if (this._transport.destroyed) return;
                        for (const [curCacheKey, curIntentState] of this._intentStates)if (curIntentState === intentState) {
                            this._intentStates.delete(curCacheKey);
                            break;
                        }
                        this.cleanup();
                    }
                    get stats() {
                        return this._stats;
                    }
                    constructor(pageIndex, pageInfo, transport, pdfBug = false){
                        (0, $2IZAT._)(this, _tryCleanup);
                        (0, $2IZAT._)(this, _abortDelayedCleanup);
                        (0, $iXPoG._)(this, _delayedCleanupTimeout, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _pendingCleanup, {
                            writable: true,
                            value: false
                        });
                        this._pageIndex = pageIndex;
                        this._pageInfo = pageInfo;
                        this._transport = transport;
                        this._stats = pdfBug ? new _display_utils.StatTimer() : null;
                        this._pdfBug = pdfBug;
                        this.commonObjs = transport.commonObjs;
                        this.objs = new PDFObjects();
                        this._maybeCleanupAfterRender = false;
                        this._intentStates = new Map();
                        this.destroyed = false;
                    }
                }
                function tryCleanup(delayed = false) {
                    (0, $hDjZy._)(this, _abortDelayedCleanup, abortDelayedCleanup).call(this);
                    if (!(0, $f2lgg._)(this, _pendingCleanup) || this.destroyed) return false;
                    if (delayed) {
                        (0, $5grPd._)(this, _delayedCleanupTimeout, setTimeout(()=>{
                            (0, $5grPd._)(this, _delayedCleanupTimeout, null);
                            (0, $hDjZy._)(this, _tryCleanup, tryCleanup).call(this, false);
                        }, DELAYED_CLEANUP_TIMEOUT));
                        return false;
                    }
                    for (const { renderTasks, operatorList } of this._intentStates.values()){
                        if (renderTasks.size > 0 || !operatorList.lastChunk) return false;
                    }
                    this._intentStates.clear();
                    this.objs.clear();
                    (0, $5grPd._)(this, _pendingCleanup, false);
                    return true;
                }
                function abortDelayedCleanup() {
                    if ((0, $f2lgg._)(this, _delayedCleanupTimeout)) {
                        clearTimeout((0, $f2lgg._)(this, _delayedCleanupTimeout));
                        (0, $5grPd._)(this, _delayedCleanupTimeout, null);
                    }
                }
                exports.PDFPageProxy = PDFPageProxy;
                var _listeners = /*#__PURE__*/ new WeakMap(), _deferred = /*#__PURE__*/ new WeakMap();
                class LoopbackPort {
                    postMessage(obj, transfer) {
                        const event = {
                            data: structuredClone(obj, transfer ? {
                                transfer: transfer
                            } : null)
                        };
                        (0, $f2lgg._)(this, _deferred).then(()=>{
                            for (const listener of (0, $f2lgg._)(this, _listeners))listener.call(this, event);
                        });
                    }
                    addEventListener(name, listener) {
                        (0, $f2lgg._)(this, _listeners).add(listener);
                    }
                    removeEventListener(name, listener) {
                        (0, $f2lgg._)(this, _listeners).delete(listener);
                    }
                    terminate() {
                        (0, $f2lgg._)(this, _listeners).clear();
                    }
                    constructor(){
                        (0, $iXPoG._)(this, _listeners, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $iXPoG._)(this, _deferred, {
                            writable: true,
                            value: Promise.resolve()
                        });
                    }
                }
                exports.LoopbackPort = LoopbackPort;
                const PDFWorkerUtil = {
                    isWorkerDisabled: false,
                    fallbackWorkerSrc: null,
                    fakeWorkerId: 0
                };
                exports.PDFWorkerUtil = PDFWorkerUtil;
                if (_util.isNodeJS && true) {
                    PDFWorkerUtil.isWorkerDisabled = true;
                    PDFWorkerUtil.fallbackWorkerSrc = "./pdf.worker.js";
                } else if (typeof document === "object") {
                    var _document_currentScript, _document;
                    const pdfjsFilePath = (_document = document) === null || _document === void 0 ? void 0 : (_document_currentScript = _document.currentScript) === null || _document_currentScript === void 0 ? void 0 : _document_currentScript.src;
                    if (pdfjsFilePath) PDFWorkerUtil.fallbackWorkerSrc = pdfjsFilePath.replace(/(\.(?:min\.)?js)(\?.*)?$/i, ".worker$1$2");
                }
                PDFWorkerUtil.isSameOrigin = function(baseUrl, otherUrl) {
                    let base;
                    try {
                        base = new URL(baseUrl);
                        if (!base.origin || base.origin === "null") return false;
                    } catch (e) {
                        return false;
                    }
                    const other = new URL(otherUrl, base);
                    return base.origin === other.origin;
                };
                PDFWorkerUtil.createCDNWrapper = function(url) {
                    const wrapper = `importScripts("${url}");`;
                    return URL.createObjectURL(new Blob([
                        wrapper
                    ]));
                };
                class PDFWorker {
                    get promise() {
                        return this._readyCapability.promise;
                    }
                    get port() {
                        return this._port;
                    }
                    get messageHandler() {
                        return this._messageHandler;
                    }
                    _initializeFromPort(port) {
                        this._port = port;
                        this._messageHandler = new _message_handler.MessageHandler("main", "worker", port);
                        this._messageHandler.on("ready", function() {});
                        this._readyCapability.resolve();
                        this._messageHandler.send("configure", {
                            verbosity: this.verbosity
                        });
                    }
                    _initialize() {
                        if (!PDFWorkerUtil.isWorkerDisabled && !PDFWorker._mainThreadWorkerMessageHandler) {
                            let { workerSrc } = PDFWorker;
                            try {
                                if (!PDFWorkerUtil.isSameOrigin(window.location.href, workerSrc)) workerSrc = PDFWorkerUtil.createCDNWrapper(new URL(workerSrc, window.location).href);
                                const worker = new Worker(workerSrc);
                                const messageHandler = new _message_handler.MessageHandler("main", "worker", worker);
                                const terminateEarly = ()=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    messageHandler.destroy();
                                    worker.terminate();
                                    if (this.destroyed) this._readyCapability.reject(new Error("Worker was destroyed"));
                                    else this._setupFakeWorker();
                                };
                                const onWorkerError = ()=>{
                                    if (!this._webWorker) terminateEarly();
                                };
                                worker.addEventListener("error", onWorkerError);
                                messageHandler.on("test", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    if (data) {
                                        this._messageHandler = messageHandler;
                                        this._port = worker;
                                        this._webWorker = worker;
                                        this._readyCapability.resolve();
                                        messageHandler.send("configure", {
                                            verbosity: this.verbosity
                                        });
                                    } else {
                                        this._setupFakeWorker();
                                        messageHandler.destroy();
                                        worker.terminate();
                                    }
                                });
                                messageHandler.on("ready", (data)=>{
                                    worker.removeEventListener("error", onWorkerError);
                                    if (this.destroyed) {
                                        terminateEarly();
                                        return;
                                    }
                                    try {
                                        sendTest();
                                    } catch (e) {
                                        this._setupFakeWorker();
                                    }
                                });
                                const sendTest = ()=>{
                                    const testObj = new Uint8Array();
                                    messageHandler.send("test", testObj, [
                                        testObj.buffer
                                    ]);
                                };
                                sendTest();
                                return;
                            } catch (e) {
                                (0, _util.info)("The worker has been disabled.");
                            }
                        }
                        this._setupFakeWorker();
                    }
                    _setupFakeWorker() {
                        if (!PDFWorkerUtil.isWorkerDisabled) {
                            (0, _util.warn)("Setting up fake worker.");
                            PDFWorkerUtil.isWorkerDisabled = true;
                        }
                        PDFWorker._setupFakeWorkerGlobal.then((WorkerMessageHandler)=>{
                            if (this.destroyed) {
                                this._readyCapability.reject(new Error("Worker was destroyed"));
                                return;
                            }
                            const port = new LoopbackPort();
                            this._port = port;
                            const id = `fake${PDFWorkerUtil.fakeWorkerId++}`;
                            const workerHandler = new _message_handler.MessageHandler(id + "_worker", id, port);
                            WorkerMessageHandler.setup(workerHandler, port);
                            const messageHandler = new _message_handler.MessageHandler(id, id + "_worker", port);
                            this._messageHandler = messageHandler;
                            this._readyCapability.resolve();
                            messageHandler.send("configure", {
                                verbosity: this.verbosity
                            });
                        }).catch((reason)=>{
                            this._readyCapability.reject(new Error(`Setting up fake worker failed: "${reason.message}".`));
                        });
                    }
                    destroy() {
                        var _class_static_private_field_spec_get1;
                        this.destroyed = true;
                        if (this._webWorker) {
                            this._webWorker.terminate();
                            this._webWorker = null;
                        }
                        (_class_static_private_field_spec_get1 = (0, $7MsFd._)(PDFWorker, PDFWorker, _workerPorts)) === null || _class_static_private_field_spec_get1 === void 0 ? void 0 : _class_static_private_field_spec_get1.delete(this._port);
                        this._port = null;
                        if (this._messageHandler) {
                            this._messageHandler.destroy();
                            this._messageHandler = null;
                        }
                    }
                    static fromPort(params) {
                        var _class_static_private_field_spec_get1;
                        if (!(params === null || params === void 0 ? void 0 : params.port)) throw new Error("PDFWorker.fromPort - invalid method signature.");
                        const cachedPort = (_class_static_private_field_spec_get1 = (0, $7MsFd._)(this, PDFWorker, _workerPorts)) === null || _class_static_private_field_spec_get1 === void 0 ? void 0 : _class_static_private_field_spec_get1.get(params.port);
                        if (cachedPort) {
                            if (cachedPort._pendingDestroy) throw new Error("PDFWorker.fromPort - the worker is being destroyed.\nPlease remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
                            return cachedPort;
                        }
                        return new PDFWorker(params);
                    }
                    static get workerSrc() {
                        if (_worker_options.GlobalWorkerOptions.workerSrc) return _worker_options.GlobalWorkerOptions.workerSrc;
                        if (PDFWorkerUtil.fallbackWorkerSrc !== null) {
                            if (!_util.isNodeJS) (0, _display_utils.deprecated)('No "GlobalWorkerOptions.workerSrc" specified.');
                            return PDFWorkerUtil.fallbackWorkerSrc;
                        }
                        throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
                    }
                    static get _mainThreadWorkerMessageHandler() {
                        try {
                            var _globalThis_pdfjsWorker;
                            return ((_globalThis_pdfjsWorker = globalThis.pdfjsWorker) === null || _globalThis_pdfjsWorker === void 0 ? void 0 : _globalThis_pdfjsWorker.WorkerMessageHandler) || null;
                        } catch (e) {
                            return null;
                        }
                    }
                    static get _setupFakeWorkerGlobal() {
                        const loader = ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                                const mainWorkerMessageHandler = this._mainThreadWorkerMessageHandler;
                                if (mainWorkerMessageHandler) return mainWorkerMessageHandler;
                                if (_util.isNodeJS && true) {
                                    const worker = eval("require")(this.workerSrc);
                                    return worker.WorkerMessageHandler;
                                }
                                yield (0, _display_utils.loadScript)(this.workerSrc);
                                return window.pdfjsWorker.WorkerMessageHandler;
                            }).call(this);
                        return (0, _util.shadow)(this, "_setupFakeWorkerGlobal", loader());
                    }
                    constructor({ name = null, port = null, verbosity = (0, _util.getVerbosityLevel)() } = {}){
                        var _PDFWorker;
                        this.name = name;
                        this.destroyed = false;
                        this.verbosity = verbosity;
                        this._readyCapability = new _util.PromiseCapability();
                        this._port = null;
                        this._webWorker = null;
                        this._messageHandler = null;
                        if (port) {
                            var _class_static_private_field_spec_get1;
                            if ((_class_static_private_field_spec_get1 = (0, $7MsFd._)(PDFWorker, PDFWorker, _workerPorts)) === null || _class_static_private_field_spec_get1 === void 0 ? void 0 : _class_static_private_field_spec_get1.has(port)) throw new Error("Cannot use more than one PDFWorker per port.");
                            (0, $8fxDh._)(_PDFWorker = PDFWorker, PDFWorker, _workerPorts, (0, $7MsFd._)(PDFWorker, PDFWorker, _workerPorts) || new WeakMap()).set(port, this);
                            this._initializeFromPort(port);
                            return;
                        }
                        this._initialize();
                    }
                }
                var _workerPorts = {
                    writable: true,
                    value: void 0
                };
                exports.PDFWorker = PDFWorker;
                var _methodPromises = /*#__PURE__*/ new WeakMap(), _pageCache = /*#__PURE__*/ new WeakMap(), _pagePromises = /*#__PURE__*/ new WeakMap(), _passwordCapability = /*#__PURE__*/ new WeakMap(), _cacheSimpleMethod = /*#__PURE__*/ new WeakSet();
                class WorkerTransport {
                    get annotationStorage() {
                        return (0, _util.shadow)(this, "annotationStorage", new _annotation_storage.AnnotationStorage());
                    }
                    getRenderingIntent(intent, annotationMode = _util.AnnotationMode.ENABLE, printAnnotationStorage = null, isOpList = false) {
                        let renderingIntent = _util.RenderingIntentFlag.DISPLAY;
                        let annotationStorageSerializable = _annotation_storage.SerializableEmpty;
                        switch(intent){
                            case "any":
                                renderingIntent = _util.RenderingIntentFlag.ANY;
                                break;
                            case "display":
                                break;
                            case "print":
                                renderingIntent = _util.RenderingIntentFlag.PRINT;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid intent: ${intent}`);
                        }
                        switch(annotationMode){
                            case _util.AnnotationMode.DISABLE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_DISABLE;
                                break;
                            case _util.AnnotationMode.ENABLE:
                                break;
                            case _util.AnnotationMode.ENABLE_FORMS:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_FORMS;
                                break;
                            case _util.AnnotationMode.ENABLE_STORAGE:
                                renderingIntent += _util.RenderingIntentFlag.ANNOTATIONS_STORAGE;
                                const annotationStorage = renderingIntent & _util.RenderingIntentFlag.PRINT && printAnnotationStorage instanceof _annotation_storage.PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
                                annotationStorageSerializable = annotationStorage.serializable;
                                break;
                            default:
                                (0, _util.warn)(`getRenderingIntent - invalid annotationMode: ${annotationMode}`);
                        }
                        if (isOpList) renderingIntent += _util.RenderingIntentFlag.OPLIST;
                        return {
                            renderingIntent: renderingIntent,
                            cacheKey: `${renderingIntent}_${annotationStorageSerializable.hash}`,
                            annotationStorageSerializable: annotationStorageSerializable
                        };
                    }
                    destroy() {
                        var _class_private_field_get1;
                        if (this.destroyCapability) return this.destroyCapability.promise;
                        this.destroyed = true;
                        this.destroyCapability = new _util.PromiseCapability();
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _passwordCapability)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.reject(new Error("Worker was destroyed during onPassword callback"));
                        const waitOn = [];
                        for (const page of (0, $f2lgg._)(this, _pageCache).values())waitOn.push(page._destroy());
                        (0, $f2lgg._)(this, _pageCache).clear();
                        (0, $f2lgg._)(this, _pagePromises).clear();
                        if (this.hasOwnProperty("annotationStorage")) this.annotationStorage.resetModified();
                        const terminated = this.messageHandler.sendWithPromise("Terminate", null);
                        waitOn.push(terminated);
                        Promise.all(waitOn).then(()=>{
                            var _this__networkStream;
                            this.commonObjs.clear();
                            this.fontLoader.clear();
                            (0, $f2lgg._)(this, _methodPromises).clear();
                            this.filterFactory.destroy();
                            (_this__networkStream = this._networkStream) === null || _this__networkStream === void 0 ? void 0 : _this__networkStream.cancelAllRequests(new _util.AbortException("Worker was terminated."));
                            if (this.messageHandler) {
                                this.messageHandler.destroy();
                                this.messageHandler = null;
                            }
                            this.destroyCapability.resolve();
                        }, this.destroyCapability.reject);
                        return this.destroyCapability.promise;
                    }
                    setupMessageHandler() {
                        const { messageHandler, loadingTask } = this;
                        messageHandler.on("GetReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetReader - no `IPDFStream` instance available.");
                            this._fullReader = this._networkStream.getFullReader();
                            this._fullReader.onProgress = (evt)=>{
                                this._lastProgress = {
                                    loaded: evt.loaded,
                                    total: evt.total
                                };
                            };
                            sink.onPull = ()=>{
                                this._fullReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                this._fullReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("ReaderHeadersReady", (data)=>{
                            const headersCapability = new _util.PromiseCapability();
                            const fullReader = this._fullReader;
                            fullReader.headersReady.then(()=>{
                                if (!fullReader.isStreamingSupported || !fullReader.isRangeSupported) {
                                    var _loadingTask_onProgress;
                                    if (this._lastProgress) (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, this._lastProgress);
                                    fullReader.onProgress = (evt)=>{
                                        var _loadingTask_onProgress;
                                        (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                            loaded: evt.loaded,
                                            total: evt.total
                                        });
                                    };
                                }
                                headersCapability.resolve({
                                    isStreamingSupported: fullReader.isStreamingSupported,
                                    isRangeSupported: fullReader.isRangeSupported,
                                    contentLength: fullReader.contentLength
                                });
                            }, headersCapability.reject);
                            return headersCapability.promise;
                        });
                        messageHandler.on("GetRangeReader", (data, sink)=>{
                            (0, _util.assert)(this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
                            const rangeReader = this._networkStream.getRangeReader(data.begin, data.end);
                            if (!rangeReader) {
                                sink.close();
                                return;
                            }
                            sink.onPull = ()=>{
                                rangeReader.read().then(function({ value, done }) {
                                    if (done) {
                                        sink.close();
                                        return;
                                    }
                                    (0, _util.assert)(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                                    sink.enqueue(new Uint8Array(value), 1, [
                                        value
                                    ]);
                                }).catch((reason)=>{
                                    sink.error(reason);
                                });
                            };
                            sink.onCancel = (reason)=>{
                                rangeReader.cancel(reason);
                                sink.ready.catch((readyReason)=>{
                                    if (this.destroyed) return;
                                    throw readyReason;
                                });
                            };
                        });
                        messageHandler.on("GetDoc", ({ pdfInfo })=>{
                            this._numPages = pdfInfo.numPages;
                            this._htmlForXfa = pdfInfo.htmlForXfa;
                            delete pdfInfo.htmlForXfa;
                            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, this));
                        });
                        messageHandler.on("DocException", function(ex) {
                            let reason;
                            switch(ex.name){
                                case "PasswordException":
                                    reason = new _util.PasswordException(ex.message, ex.code);
                                    break;
                                case "InvalidPDFException":
                                    reason = new _util.InvalidPDFException(ex.message);
                                    break;
                                case "MissingPDFException":
                                    reason = new _util.MissingPDFException(ex.message);
                                    break;
                                case "UnexpectedResponseException":
                                    reason = new _util.UnexpectedResponseException(ex.message, ex.status);
                                    break;
                                case "UnknownErrorException":
                                    reason = new _util.UnknownErrorException(ex.message, ex.details);
                                    break;
                                default:
                                    (0, _util.unreachable)("DocException - expected a valid Error.");
                            }
                            loadingTask._capability.reject(reason);
                        });
                        messageHandler.on("PasswordRequest", (exception)=>{
                            (0, $5grPd._)(this, _passwordCapability, new _util.PromiseCapability());
                            if (loadingTask.onPassword) {
                                const updatePassword = (password)=>{
                                    if (password instanceof Error) (0, $f2lgg._)(this, _passwordCapability).reject(password);
                                    else (0, $f2lgg._)(this, _passwordCapability).resolve({
                                        password: password
                                    });
                                };
                                try {
                                    loadingTask.onPassword(updatePassword, exception.code);
                                } catch (ex) {
                                    (0, $f2lgg._)(this, _passwordCapability).reject(ex);
                                }
                            } else (0, $f2lgg._)(this, _passwordCapability).reject(new _util.PasswordException(exception.message, exception.code));
                            return (0, $f2lgg._)(this, _passwordCapability).promise;
                        });
                        messageHandler.on("DataLoaded", (data)=>{
                            var _loadingTask_onProgress;
                            (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                loaded: data.length,
                                total: data.length
                            });
                            this.downloadInfoCapability.resolve(data);
                        });
                        messageHandler.on("StartRenderPage", (data)=>{
                            if (this.destroyed) return;
                            const page = (0, $f2lgg._)(this, _pageCache).get(data.pageIndex);
                            page._startRenderPage(data.transparency, data.cacheKey);
                        });
                        messageHandler.on("commonobj", ([id, type, exportedData])=>{
                            if (this.destroyed) return;
                            if (this.commonObjs.has(id)) return;
                            switch(type){
                                case "Font":
                                    var _globalThis_FontInspector;
                                    const params = this._params;
                                    if ("error" in exportedData) {
                                        const exportedError = exportedData.error;
                                        (0, _util.warn)(`Error during font loading: ${exportedError}`);
                                        this.commonObjs.resolve(id, exportedError);
                                        break;
                                    }
                                    const inspectFont = params.pdfBug && ((_globalThis_FontInspector = globalThis.FontInspector) === null || _globalThis_FontInspector === void 0 ? void 0 : _globalThis_FontInspector.enabled) ? (font, url)=>globalThis.FontInspector.fontAdded(font, url) : null;
                                    const font = new _font_loader.FontFaceObject(exportedData, {
                                        isEvalSupported: params.isEvalSupported,
                                        disableFontFace: params.disableFontFace,
                                        ignoreErrors: params.ignoreErrors,
                                        inspectFont: inspectFont
                                    });
                                    this.fontLoader.bind(font).catch((reason)=>{
                                        return messageHandler.sendWithPromise("FontFallback", {
                                            id: id
                                        });
                                    }).finally(()=>{
                                        if (!params.fontExtraProperties && font.data) font.data = null;
                                        this.commonObjs.resolve(id, font);
                                    });
                                    break;
                                case "FontPath":
                                case "Image":
                                case "Pattern":
                                    this.commonObjs.resolve(id, exportedData);
                                    break;
                                default:
                                    throw new Error(`Got unknown common object type ${type}`);
                            }
                        });
                        messageHandler.on("obj", ([id, pageIndex, type, imageData])=>{
                            if (this.destroyed) return;
                            const pageProxy = (0, $f2lgg._)(this, _pageCache).get(pageIndex);
                            if (pageProxy.objs.has(id)) return;
                            switch(type){
                                case "Image":
                                    pageProxy.objs.resolve(id, imageData);
                                    if (imageData) {
                                        var _imageData_data;
                                        let length;
                                        if (imageData.bitmap) {
                                            const { width, height } = imageData;
                                            length = width * height * 4;
                                        } else length = ((_imageData_data = imageData.data) === null || _imageData_data === void 0 ? void 0 : _imageData_data.length) || 0;
                                        if (length > _util.MAX_IMAGE_SIZE_TO_CACHE) pageProxy._maybeCleanupAfterRender = true;
                                    }
                                    break;
                                case "Pattern":
                                    pageProxy.objs.resolve(id, imageData);
                                    break;
                                default:
                                    throw new Error(`Got unknown object type ${type}`);
                            }
                        });
                        messageHandler.on("DocProgress", (data)=>{
                            var _loadingTask_onProgress;
                            if (this.destroyed) return;
                            (_loadingTask_onProgress = loadingTask.onProgress) === null || _loadingTask_onProgress === void 0 ? void 0 : _loadingTask_onProgress.call(loadingTask, {
                                loaded: data.loaded,
                                total: data.total
                            });
                        });
                        messageHandler.on("FetchBuiltInCMap", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.cMapReaderFactory) return Promise.reject(new Error("CMapReaderFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.cMapReaderFactory.fetch(data);
                        });
                        messageHandler.on("FetchStandardFontData", (data)=>{
                            if (this.destroyed) return Promise.reject(new Error("Worker was destroyed."));
                            if (!this.standardFontDataFactory) return Promise.reject(new Error("StandardFontDataFactory not initialized, see the `useWorkerFetch` parameter."));
                            return this.standardFontDataFactory.fetch(data);
                        });
                    }
                    getData() {
                        return this.messageHandler.sendWithPromise("GetData", null);
                    }
                    saveDocument() {
                        var _this__fullReader;
                        if (this.annotationStorage.size <= 0) (0, _util.warn)("saveDocument called while `annotationStorage` is empty, please use the getData-method instead.");
                        const { map, transfers } = this.annotationStorage.serializable;
                        var _this__fullReader_filename;
                        return this.messageHandler.sendWithPromise("SaveDocument", {
                            isPureXfa: !!this._htmlForXfa,
                            numPages: this._numPages,
                            annotationStorage: map,
                            filename: (_this__fullReader_filename = (_this__fullReader = this._fullReader) === null || _this__fullReader === void 0 ? void 0 : _this__fullReader.filename) !== null && _this__fullReader_filename !== void 0 ? _this__fullReader_filename : null
                        }, transfers).finally(()=>{
                            this.annotationStorage.resetModified();
                        });
                    }
                    getPage(pageNumber) {
                        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) return Promise.reject(new Error("Invalid page request."));
                        const pageIndex = pageNumber - 1, cachedPromise = (0, $f2lgg._)(this, _pagePromises).get(pageIndex);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise("GetPage", {
                            pageIndex: pageIndex
                        }).then((pageInfo)=>{
                            if (this.destroyed) throw new Error("Transport destroyed");
                            const page = new PDFPageProxy(pageIndex, pageInfo, this, this._params.pdfBug);
                            (0, $f2lgg._)(this, _pageCache).set(pageIndex, page);
                            return page;
                        });
                        (0, $f2lgg._)(this, _pagePromises).set(pageIndex, promise);
                        return promise;
                    }
                    getPageIndex(ref) {
                        if (typeof ref !== "object" || ref === null || !Number.isInteger(ref.num) || ref.num < 0 || !Number.isInteger(ref.gen) || ref.gen < 0) return Promise.reject(new Error("Invalid pageIndex request."));
                        return this.messageHandler.sendWithPromise("GetPageIndex", {
                            num: ref.num,
                            gen: ref.gen
                        });
                    }
                    getAnnotations(pageIndex, intent) {
                        return this.messageHandler.sendWithPromise("GetAnnotations", {
                            pageIndex: pageIndex,
                            intent: intent
                        });
                    }
                    getFieldObjects() {
                        return (0, $hDjZy._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "GetFieldObjects");
                    }
                    hasJSActions() {
                        return (0, $hDjZy._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "HasJSActions");
                    }
                    getCalculationOrderIds() {
                        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
                    }
                    getDestinations() {
                        return this.messageHandler.sendWithPromise("GetDestinations", null);
                    }
                    getDestination(id) {
                        if (typeof id !== "string") return Promise.reject(new Error("Invalid destination request."));
                        return this.messageHandler.sendWithPromise("GetDestination", {
                            id: id
                        });
                    }
                    getPageLabels() {
                        return this.messageHandler.sendWithPromise("GetPageLabels", null);
                    }
                    getPageLayout() {
                        return this.messageHandler.sendWithPromise("GetPageLayout", null);
                    }
                    getPageMode() {
                        return this.messageHandler.sendWithPromise("GetPageMode", null);
                    }
                    getViewerPreferences() {
                        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
                    }
                    getOpenAction() {
                        return this.messageHandler.sendWithPromise("GetOpenAction", null);
                    }
                    getAttachments() {
                        return this.messageHandler.sendWithPromise("GetAttachments", null);
                    }
                    getDocJSActions() {
                        return (0, $hDjZy._)(this, _cacheSimpleMethod, cacheSimpleMethod).call(this, "GetDocJSActions");
                    }
                    getPageJSActions(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetPageJSActions", {
                            pageIndex: pageIndex
                        });
                    }
                    getStructTree(pageIndex) {
                        return this.messageHandler.sendWithPromise("GetStructTree", {
                            pageIndex: pageIndex
                        });
                    }
                    getOutline() {
                        return this.messageHandler.sendWithPromise("GetOutline", null);
                    }
                    getOptionalContentConfig() {
                        return this.messageHandler.sendWithPromise("GetOptionalContentConfig", null).then((results)=>{
                            return new _optional_content_config.OptionalContentConfig(results);
                        });
                    }
                    getPermissions() {
                        return this.messageHandler.sendWithPromise("GetPermissions", null);
                    }
                    getMetadata() {
                        const name = "GetMetadata", cachedPromise = (0, $f2lgg._)(this, _methodPromises).get(name);
                        if (cachedPromise) return cachedPromise;
                        const promise = this.messageHandler.sendWithPromise(name, null).then((results)=>{
                            var _this__fullReader, _this__fullReader1;
                            var _this__fullReader_filename, _this__fullReader_contentLength;
                            return {
                                info: results[0],
                                metadata: results[1] ? new _metadata.Metadata(results[1]) : null,
                                contentDispositionFilename: (_this__fullReader_filename = (_this__fullReader = this._fullReader) === null || _this__fullReader === void 0 ? void 0 : _this__fullReader.filename) !== null && _this__fullReader_filename !== void 0 ? _this__fullReader_filename : null,
                                contentLength: (_this__fullReader_contentLength = (_this__fullReader1 = this._fullReader) === null || _this__fullReader1 === void 0 ? void 0 : _this__fullReader1.contentLength) !== null && _this__fullReader_contentLength !== void 0 ? _this__fullReader_contentLength : null
                            };
                        });
                        (0, $f2lgg._)(this, _methodPromises).set(name, promise);
                        return promise;
                    }
                    getMarkInfo() {
                        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
                    }
                    startCleanup(keepLoadedFonts = false) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this.destroyed) return;
                            yield this.messageHandler.sendWithPromise("Cleanup", null);
                            for (const page of (0, $f2lgg._)(this, _pageCache).values()){
                                const cleanupSuccessful = page.cleanup();
                                if (!cleanupSuccessful) throw new Error(`startCleanup: Page ${page.pageNumber} is currently rendering.`);
                            }
                            this.commonObjs.clear();
                            if (!keepLoadedFonts) this.fontLoader.clear();
                            (0, $f2lgg._)(this, _methodPromises).clear();
                            this.filterFactory.destroy(true);
                        }).call(this);
                    }
                    get loadingParams() {
                        const { disableAutoFetch, enableXfa } = this._params;
                        return (0, _util.shadow)(this, "loadingParams", {
                            disableAutoFetch: disableAutoFetch,
                            enableXfa: enableXfa
                        });
                    }
                    constructor(messageHandler, loadingTask, networkStream, params, factory){
                        (0, $2IZAT._)(this, _cacheSimpleMethod);
                        (0, $iXPoG._)(this, _methodPromises, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _pageCache, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _pagePromises, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _passwordCapability, {
                            writable: true,
                            value: null
                        });
                        this.messageHandler = messageHandler;
                        this.loadingTask = loadingTask;
                        this.commonObjs = new PDFObjects();
                        this.fontLoader = new _font_loader.FontLoader({
                            ownerDocument: params.ownerDocument,
                            styleElement: params.styleElement
                        });
                        this._params = params;
                        this.canvasFactory = factory.canvasFactory;
                        this.filterFactory = factory.filterFactory;
                        this.cMapReaderFactory = factory.cMapReaderFactory;
                        this.standardFontDataFactory = factory.standardFontDataFactory;
                        this.destroyed = false;
                        this.destroyCapability = null;
                        this._networkStream = networkStream;
                        this._fullReader = null;
                        this._lastProgress = null;
                        this.downloadInfoCapability = new _util.PromiseCapability();
                        this.setupMessageHandler();
                    }
                }
                function cacheSimpleMethod(name, data = null) {
                    const cachedPromise = (0, $f2lgg._)(this, _methodPromises).get(name);
                    if (cachedPromise) return cachedPromise;
                    const promise = this.messageHandler.sendWithPromise(name, data);
                    (0, $f2lgg._)(this, _methodPromises).set(name, promise);
                    return promise;
                }
                var _objs = /*#__PURE__*/ new WeakMap(), _ensureObj = /*#__PURE__*/ new WeakSet();
                class PDFObjects {
                    get(objId, callback = null) {
                        if (callback) {
                            const obj = (0, $hDjZy._)(this, _ensureObj, ensureObj).call(this, objId);
                            obj.capability.promise.then(()=>callback(obj.data));
                            return null;
                        }
                        const obj = (0, $f2lgg._)(this, _objs)[objId];
                        if (!(obj === null || obj === void 0 ? void 0 : obj.capability.settled)) throw new Error(`Requesting object that isn't resolved yet ${objId}.`);
                        return obj.data;
                    }
                    has(objId) {
                        const obj = (0, $f2lgg._)(this, _objs)[objId];
                        return (obj === null || obj === void 0 ? void 0 : obj.capability.settled) || false;
                    }
                    resolve(objId, data = null) {
                        const obj = (0, $hDjZy._)(this, _ensureObj, ensureObj).call(this, objId);
                        obj.data = data;
                        obj.capability.resolve();
                    }
                    clear() {
                        for(const objId in (0, $f2lgg._)(this, _objs)){
                            var _data_bitmap;
                            const { data } = (0, $f2lgg._)(this, _objs)[objId];
                            data === null || data === void 0 ? void 0 : (_data_bitmap = data.bitmap) === null || _data_bitmap === void 0 ? void 0 : _data_bitmap.close();
                        }
                        (0, $5grPd._)(this, _objs, Object.create(null));
                    }
                    constructor(){
                        (0, $2IZAT._)(this, _ensureObj);
                        (0, $iXPoG._)(this, _objs, {
                            writable: true,
                            value: Object.create(null)
                        });
                    }
                }
                function ensureObj(objId) {
                    var _class_private_field_get1, _objId;
                    return (_class_private_field_get1 = (0, $f2lgg._)(this, _objs))[_objId = objId] || (_class_private_field_get1[_objId] = {
                        capability: new _util.PromiseCapability(),
                        data: null
                    });
                }
                var _internalRenderTask = /*#__PURE__*/ new WeakMap();
                class RenderTask {
                    get promise() {
                        return (0, $f2lgg._)(this, _internalRenderTask).capability.promise;
                    }
                    cancel(extraDelay = 0) {
                        (0, $f2lgg._)(this, _internalRenderTask).cancel(null, extraDelay);
                    }
                    get separateAnnots() {
                        const { separateAnnots } = (0, $f2lgg._)(this, _internalRenderTask).operatorList;
                        if (!separateAnnots) return false;
                        const { annotationCanvasMap } = (0, $f2lgg._)(this, _internalRenderTask);
                        return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap === null || annotationCanvasMap === void 0 ? void 0 : annotationCanvasMap.size) > 0;
                    }
                    constructor(internalRenderTask){
                        (0, $iXPoG._)(this, _internalRenderTask, {
                            writable: true,
                            value: null
                        });
                        (0, $5grPd._)(this, _internalRenderTask, internalRenderTask);
                        this.onContinue = null;
                    }
                }
                exports.RenderTask = RenderTask;
                class InternalRenderTask {
                    get completed() {
                        return this.capability.promise.catch(function() {});
                    }
                    initializeGraphics({ transparency = false, optionalContentConfig }) {
                        var _globalThis_StepperManager, _this_graphicsReadyCallback, _this;
                        if (this.cancelled) return;
                        if (this._canvas) {
                            if ((0, $7MsFd._)(InternalRenderTask, InternalRenderTask, _canvasInUse).has(this._canvas)) throw new Error("Cannot use the same canvas during multiple render() operations. Use different canvas or ensure previous operations were cancelled or completed.");
                            (0, $7MsFd._)(InternalRenderTask, InternalRenderTask, _canvasInUse).add(this._canvas);
                        }
                        if (this._pdfBug && ((_globalThis_StepperManager = globalThis.StepperManager) === null || _globalThis_StepperManager === void 0 ? void 0 : _globalThis_StepperManager.enabled)) {
                            this.stepper = globalThis.StepperManager.create(this._pageIndex);
                            this.stepper.init(this.operatorList);
                            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
                        }
                        const { canvasContext, viewport, transform, background } = this.params;
                        this.gfx = new _canvas.CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                            optionalContentConfig: optionalContentConfig
                        }, this.annotationCanvasMap, this.pageColors);
                        this.gfx.beginDrawing({
                            transform: transform,
                            viewport: viewport,
                            transparency: transparency,
                            background: background
                        });
                        this.operatorListIdx = 0;
                        this.graphicsReady = true;
                        (_this_graphicsReadyCallback = (_this = this).graphicsReadyCallback) === null || _this_graphicsReadyCallback === void 0 ? void 0 : _this_graphicsReadyCallback.call(_this);
                    }
                    cancel(error = null, extraDelay = 0) {
                        var _this_gfx;
                        this.running = false;
                        this.cancelled = true;
                        (_this_gfx = this.gfx) === null || _this_gfx === void 0 ? void 0 : _this_gfx.endDrawing();
                        (0, $7MsFd._)(InternalRenderTask, InternalRenderTask, _canvasInUse).delete(this._canvas);
                        this.callback(error || new _display_utils.RenderingCancelledException(`Rendering cancelled, page ${this._pageIndex + 1}`, extraDelay));
                    }
                    operatorListChanged() {
                        var _this_stepper;
                        if (!this.graphicsReady) {
                            this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
                            return;
                        }
                        (_this_stepper = this.stepper) === null || _this_stepper === void 0 ? void 0 : _this_stepper.updateOperatorList(this.operatorList);
                        if (this.running) return;
                        this._continue();
                    }
                    _continue() {
                        this.running = true;
                        if (this.cancelled) return;
                        if (this.task.onContinue) this.task.onContinue(this._scheduleNextBound);
                        else this._scheduleNext();
                    }
                    _scheduleNext() {
                        if (this._useRequestAnimationFrame) window.requestAnimationFrame(()=>{
                            this._nextBound().catch(this._cancelBound);
                        });
                        else Promise.resolve().then(this._nextBound).catch(this._cancelBound);
                    }
                    _next() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this.cancelled) return;
                            this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                            if (this.operatorListIdx === this.operatorList.argsArray.length) {
                                this.running = false;
                                if (this.operatorList.lastChunk) {
                                    this.gfx.endDrawing();
                                    (0, $7MsFd._)(InternalRenderTask, InternalRenderTask, _canvasInUse).delete(this._canvas);
                                    this.callback();
                                }
                            }
                        }).call(this);
                    }
                    constructor({ callback, params, objs, commonObjs, annotationCanvasMap, operatorList, pageIndex, canvasFactory, filterFactory, useRequestAnimationFrame = false, pdfBug = false, pageColors = null }){
                        this.callback = callback;
                        this.params = params;
                        this.objs = objs;
                        this.commonObjs = commonObjs;
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.operatorListIdx = null;
                        this.operatorList = operatorList;
                        this._pageIndex = pageIndex;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this._pdfBug = pdfBug;
                        this.pageColors = pageColors;
                        this.running = false;
                        this.graphicsReadyCallback = null;
                        this.graphicsReady = false;
                        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
                        this.cancelled = false;
                        this.capability = new _util.PromiseCapability();
                        this.task = new RenderTask(this);
                        this._cancelBound = this.cancel.bind(this);
                        this._continueBound = this._continue.bind(this);
                        this._scheduleNextBound = this._scheduleNext.bind(this);
                        this._nextBound = this._next.bind(this);
                        this._canvas = params.canvasContext.canvas;
                    }
                }
                var _canvasInUse = {
                    writable: true,
                    value: new WeakSet()
                };
                const version = '3.11.174';
                exports.version = version;
                const build = 'ce8716743';
                exports.build = build;
            /***/ },
            /* 3 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SerializableEmpty = exports.PrintAnnotationStorage = exports.AnnotationStorage = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _murmurhash = __w_pdfjs_require__(8);
                const SerializableEmpty = Object.freeze({
                    map: null,
                    hash: "",
                    transfers: undefined
                });
                exports.SerializableEmpty = SerializableEmpty;
                var _modified = /*#__PURE__*/ new WeakMap(), _storage = /*#__PURE__*/ new WeakMap(), _setModified = /*#__PURE__*/ new WeakSet();
                class AnnotationStorage {
                    getValue(key, defaultValue) {
                        const value = (0, $f2lgg._)(this, _storage).get(key);
                        if (value === undefined) return defaultValue;
                        return Object.assign(defaultValue, value);
                    }
                    getRawValue(key) {
                        return (0, $f2lgg._)(this, _storage).get(key);
                    }
                    remove(key) {
                        (0, $f2lgg._)(this, _storage).delete(key);
                        if ((0, $f2lgg._)(this, _storage).size === 0) this.resetModified();
                        if (typeof this.onAnnotationEditor === "function") {
                            for (const value of (0, $f2lgg._)(this, _storage).values()){
                                if (value instanceof _editor.AnnotationEditor) return;
                            }
                            this.onAnnotationEditor(null);
                        }
                    }
                    setValue(key, value) {
                        const obj = (0, $f2lgg._)(this, _storage).get(key);
                        let modified = false;
                        if (obj !== undefined) {
                            for (const [entry, val] of Object.entries(value))if (obj[entry] !== val) {
                                modified = true;
                                obj[entry] = val;
                            }
                        } else {
                            modified = true;
                            (0, $f2lgg._)(this, _storage).set(key, value);
                        }
                        if (modified) (0, $hDjZy._)(this, _setModified, setModified).call(this);
                        if (value instanceof _editor.AnnotationEditor && typeof this.onAnnotationEditor === "function") this.onAnnotationEditor(value.constructor._type);
                    }
                    has(key) {
                        return (0, $f2lgg._)(this, _storage).has(key);
                    }
                    getAll() {
                        return (0, $f2lgg._)(this, _storage).size > 0 ? (0, _util.objectFromMap)((0, $f2lgg._)(this, _storage)) : null;
                    }
                    setAll(obj) {
                        for (const [key, val] of Object.entries(obj))this.setValue(key, val);
                    }
                    get size() {
                        return (0, $f2lgg._)(this, _storage).size;
                    }
                    resetModified() {
                        if ((0, $f2lgg._)(this, _modified)) {
                            (0, $5grPd._)(this, _modified, false);
                            if (typeof this.onResetModified === "function") this.onResetModified();
                        }
                    }
                    get print() {
                        return new PrintAnnotationStorage(this);
                    }
                    get serializable() {
                        if ((0, $f2lgg._)(this, _storage).size === 0) return SerializableEmpty;
                        const map = new Map(), hash = new _murmurhash.MurmurHash3_64(), transfers = [];
                        const context = Object.create(null);
                        let hasBitmap = false;
                        for (const [key, val] of (0, $f2lgg._)(this, _storage)){
                            const serialized = val instanceof _editor.AnnotationEditor ? val.serialize(false, context) : val;
                            if (serialized) {
                                map.set(key, serialized);
                                hash.update(`${key}:${JSON.stringify(serialized)}`);
                                hasBitmap || (hasBitmap = !!serialized.bitmap);
                            }
                        }
                        if (hasBitmap) {
                            for (const value of map.values())if (value.bitmap) transfers.push(value.bitmap);
                        }
                        return map.size > 0 ? {
                            map: map,
                            hash: hash.hexdigest(),
                            transfers: transfers
                        } : SerializableEmpty;
                    }
                    constructor(){
                        (0, $2IZAT._)(this, _setModified);
                        (0, $iXPoG._)(this, _modified, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _storage, {
                            writable: true,
                            value: new Map()
                        });
                        this.onSetModified = null;
                        this.onResetModified = null;
                        this.onAnnotationEditor = null;
                    }
                }
                function setModified() {
                    if (!(0, $f2lgg._)(this, _modified)) {
                        (0, $5grPd._)(this, _modified, true);
                        if (typeof this.onSetModified === "function") this.onSetModified();
                    }
                }
                exports.AnnotationStorage = AnnotationStorage;
                var _serializable = /*#__PURE__*/ new WeakMap();
                class PrintAnnotationStorage extends AnnotationStorage {
                    get print() {
                        (0, _util.unreachable)("Should not call PrintAnnotationStorage.print");
                    }
                    get serializable() {
                        return (0, $f2lgg._)(this, _serializable);
                    }
                    constructor(parent){
                        super(), (0, $iXPoG._)(this, _serializable, {
                            writable: true,
                            value: void 0
                        });
                        const { map, hash, transfers } = parent.serializable;
                        const clone = structuredClone(map, transfers ? {
                            transfer: transfers
                        } : null);
                        (0, $5grPd._)(this, _serializable, {
                            map: clone,
                            hash: hash,
                            transfers: transfers
                        });
                    }
                }
                exports.PrintAnnotationStorage = PrintAnnotationStorage;
            /***/ },
            /* 4 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditor = void 0;
                var _tools = __w_pdfjs_require__(5);
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _altText = /*#__PURE__*/ new WeakMap(), _altTextDecorative = /*#__PURE__*/ new WeakMap(), _altTextButton = /*#__PURE__*/ new WeakMap(), _altTextTooltip = /*#__PURE__*/ new WeakMap(), _altTextTooltipTimeout = /*#__PURE__*/ new WeakMap(), _keepAspectRatio = /*#__PURE__*/ new WeakMap(), _resizersDiv = /*#__PURE__*/ new WeakMap(), _boundFocusin = /*#__PURE__*/ new WeakMap(), _boundFocusout = /*#__PURE__*/ new WeakMap(), _hasBeenClicked = /*#__PURE__*/ new WeakMap(), _isEditing = /*#__PURE__*/ new WeakMap(), _isInEditMode = /*#__PURE__*/ new WeakMap(), _isDraggable = /*#__PURE__*/ new WeakMap(), _zIndex = /*#__PURE__*/ new WeakMap(), _translate = /*#__PURE__*/ new WeakSet(), _getBaseTranslation = /*#__PURE__*/ new WeakSet(), _getRotationMatrix = /*#__PURE__*/ new WeakSet(), _createResizers = /*#__PURE__*/ new WeakSet(), _resizerPointerdown = /*#__PURE__*/ new WeakSet(), _resizerPointermove = /*#__PURE__*/ new WeakSet(), _setAltTextButtonState = /*#__PURE__*/ new WeakSet(), _setUpDragSession = /*#__PURE__*/ new WeakSet();
                class AnnotationEditor {
                    get editorType() {
                        return Object.getPrototypeOf(this).constructor._type;
                    }
                    static get _defaultLineColor() {
                        return (0, _util.shadow)(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
                    }
                    static deleteAnnotationElement(editor) {
                        const fakeEditor = new FakeEditor({
                            id: editor.parent.getNextId(),
                            parent: editor.parent,
                            uiManager: editor._uiManager
                        });
                        fakeEditor.annotationElementId = editor.annotationElementId;
                        fakeEditor.deleted = true;
                        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
                    }
                    static initialize(l10n, options = null) {
                        var _AnnotationEditor;
                        (_AnnotationEditor = AnnotationEditor)._l10nPromise || (_AnnotationEditor._l10nPromise = new Map([
                            "editor_alt_text_button_label",
                            "editor_alt_text_edit_button_label",
                            "editor_alt_text_decorative_tooltip"
                        ].map((str)=>[
                                str,
                                l10n.get(str)
                            ])));
                        if (options === null || options === void 0 ? void 0 : options.strings) for (const str of options.strings)AnnotationEditor._l10nPromise.set(str, l10n.get(str));
                        if (AnnotationEditor._borderLineWidth !== -1) return;
                        const style = getComputedStyle(document.documentElement);
                        AnnotationEditor._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
                    }
                    static updateDefaultParams(_type, _value) {}
                    static get defaultPropertiesToUpdate() {
                        return [];
                    }
                    static isHandlingMimeForPasting(mime) {
                        return false;
                    }
                    static paste(item, parent) {
                        (0, _util.unreachable)("Not implemented");
                    }
                    get propertiesToUpdate() {
                        return [];
                    }
                    get _isDraggable() {
                        return (0, $f2lgg._)(this, _isDraggable);
                    }
                    set _isDraggable(value) {
                        var _this_div;
                        (0, $5grPd._)(this, _isDraggable, value);
                        (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.toggle("draggable", value);
                    }
                    center() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        switch(this.parentRotation){
                            case 90:
                                this.x -= this.height * pageHeight / (pageWidth * 2);
                                this.y += this.width * pageWidth / (pageHeight * 2);
                                break;
                            case 180:
                                this.x += this.width / 2;
                                this.y += this.height / 2;
                                break;
                            case 270:
                                this.x += this.height * pageHeight / (pageWidth * 2);
                                this.y -= this.width * pageWidth / (pageHeight * 2);
                                break;
                            default:
                                this.x -= this.width / 2;
                                this.y -= this.height / 2;
                                break;
                        }
                        this.fixAndSetPosition();
                    }
                    addCommands(params) {
                        this._uiManager.addCommands(params);
                    }
                    get currentLayer() {
                        return this._uiManager.currentLayer;
                    }
                    setInBackground() {
                        this.div.style.zIndex = 0;
                    }
                    setInForeground() {
                        this.div.style.zIndex = (0, $f2lgg._)(this, _zIndex);
                    }
                    setParent(parent) {
                        if (parent !== null) {
                            this.pageIndex = parent.pageIndex;
                            this.pageDimensions = parent.pageDimensions;
                        }
                        this.parent = parent;
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        if (!(0, $f2lgg._)(this, _hasBeenClicked)) this.parent.setSelected(this);
                        else (0, $5grPd._)(this, _hasBeenClicked, false);
                    }
                    focusout(event) {
                        var _this_parent;
                        if (!this._focusEventsAllowed) return;
                        if (!this.isAttachedToDOM) return;
                        const target = event.relatedTarget;
                        if (target === null || target === void 0 ? void 0 : target.closest(`#${this.id}`)) return;
                        event.preventDefault();
                        if (!((_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.isMultipleSelection)) this.commitOrRemove();
                    }
                    commitOrRemove() {
                        if (this.isEmpty()) this.remove();
                        else this.commit();
                    }
                    commit() {
                        this.addToAnnotationStorage();
                    }
                    addToAnnotationStorage() {
                        this._uiManager.addToAnnotationStorage(this);
                    }
                    setAt(x, y, tx, ty) {
                        const [width, height] = this.parentDimensions;
                        [tx, ty] = this.screenToPageTranslation(tx, ty);
                        this.x = (x + tx) / width;
                        this.y = (y + ty) / height;
                        this.fixAndSetPosition();
                    }
                    translate(x, y) {
                        (0, $hDjZy._)(this, _translate, translate).call(this, this.parentDimensions, x, y);
                    }
                    translateInPage(x, y) {
                        (0, $hDjZy._)(this, _translate, translate).call(this, this.pageDimensions, x, y);
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    drag(tx, ty) {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.x += tx / parentWidth;
                        this.y += ty / parentHeight;
                        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
                            const { x, y } = this.div.getBoundingClientRect();
                            if (this.parent.findNewParent(this, x, y)) {
                                this.x -= Math.floor(this.x);
                                this.y -= Math.floor(this.y);
                            }
                        }
                        let { x, y } = this;
                        const [bx, by] = (0, $hDjZy._)(this, _getBaseTranslation, getBaseTranslation).call(this);
                        x += bx;
                        y += by;
                        this.div.style.left = `${(100 * x).toFixed(2)}%`;
                        this.div.style.top = `${(100 * y).toFixed(2)}%`;
                        this.div.scrollIntoView({
                            block: "nearest"
                        });
                    }
                    fixAndSetPosition() {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        let { x, y, width, height } = this;
                        width *= pageWidth;
                        height *= pageHeight;
                        x *= pageWidth;
                        y *= pageHeight;
                        switch(this.rotation){
                            case 0:
                                x = Math.max(0, Math.min(pageWidth - width, x));
                                y = Math.max(0, Math.min(pageHeight - height, y));
                                break;
                            case 90:
                                x = Math.max(0, Math.min(pageWidth - height, x));
                                y = Math.min(pageHeight, Math.max(width, y));
                                break;
                            case 180:
                                x = Math.min(pageWidth, Math.max(width, x));
                                y = Math.min(pageHeight, Math.max(height, y));
                                break;
                            case 270:
                                x = Math.min(pageWidth, Math.max(height, x));
                                y = Math.max(0, Math.min(pageHeight - width, y));
                                break;
                        }
                        this.x = x /= pageWidth;
                        this.y = y /= pageHeight;
                        const [bx, by] = (0, $hDjZy._)(this, _getBaseTranslation, getBaseTranslation).call(this);
                        x += bx;
                        y += by;
                        const { style } = this.div;
                        style.left = `${(100 * x).toFixed(2)}%`;
                        style.top = `${(100 * y).toFixed(2)}%`;
                        this.moveInDOM();
                    }
                    screenToPageTranslation(x, y) {
                        return (0, $a36Ks._)(AnnotationEditor, AnnotationEditor, rotatePoint).call(AnnotationEditor, x, y, this.parentRotation);
                    }
                    pageTranslationToScreen(x, y) {
                        return (0, $a36Ks._)(AnnotationEditor, AnnotationEditor, rotatePoint).call(AnnotationEditor, x, y, 360 - this.parentRotation);
                    }
                    get parentScale() {
                        return this._uiManager.viewParameters.realScale;
                    }
                    get parentRotation() {
                        return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
                    }
                    get parentDimensions() {
                        const { parentScale, pageDimensions: [pageWidth, pageHeight] } = this;
                        const scaledWidth = pageWidth * parentScale;
                        const scaledHeight = pageHeight * parentScale;
                        return _util.FeatureTest.isCSSRoundSupported ? [
                            Math.round(scaledWidth),
                            Math.round(scaledHeight)
                        ] : [
                            scaledWidth,
                            scaledHeight
                        ];
                    }
                    setDims(width, height) {
                        var _class_private_field_get1;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.div.style.width = `${(100 * width / parentWidth).toFixed(2)}%`;
                        if (!(0, $f2lgg._)(this, _keepAspectRatio)) this.div.style.height = `${(100 * height / parentHeight).toFixed(2)}%`;
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _altTextButton)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.classList.toggle("small", width < AnnotationEditor.SMALL_EDITOR_SIZE || height < AnnotationEditor.SMALL_EDITOR_SIZE);
                    }
                    fixDims() {
                        const { style } = this.div;
                        const { height, width } = style;
                        const widthPercent = width.endsWith("%");
                        const heightPercent = !(0, $f2lgg._)(this, _keepAspectRatio) && height.endsWith("%");
                        if (widthPercent && heightPercent) return;
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (!widthPercent) style.width = `${(100 * parseFloat(width) / parentWidth).toFixed(2)}%`;
                        if (!(0, $f2lgg._)(this, _keepAspectRatio) && !heightPercent) style.height = `${(100 * parseFloat(height) / parentHeight).toFixed(2)}%`;
                    }
                    getInitialTranslation() {
                        return [
                            0,
                            0
                        ];
                    }
                    addAltTextButton() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if ((0, $f2lgg._)(this, _altTextButton)) return;
                            const altText = (0, $5grPd._)(this, _altTextButton, document.createElement("button"));
                            altText.className = "altText";
                            const msg = yield AnnotationEditor._l10nPromise.get("editor_alt_text_button_label");
                            altText.textContent = msg;
                            altText.setAttribute("aria-label", msg);
                            altText.tabIndex = "0";
                            altText.addEventListener("contextmenu", _display_utils.noContextMenu);
                            altText.addEventListener("pointerdown", (event)=>event.stopPropagation());
                            altText.addEventListener("click", (event)=>{
                                event.preventDefault();
                                this._uiManager.editAltText(this);
                            }, {
                                capture: true
                            });
                            altText.addEventListener("keydown", (event)=>{
                                if (event.target === altText && event.key === "Enter") {
                                    event.preventDefault();
                                    this._uiManager.editAltText(this);
                                }
                            });
                            (0, $hDjZy._)(this, _setAltTextButtonState, setAltTextButtonState).call(this);
                            this.div.append(altText);
                            if (!AnnotationEditor.SMALL_EDITOR_SIZE) {
                                const PERCENT = 40;
                                AnnotationEditor.SMALL_EDITOR_SIZE = Math.min(128, Math.round(altText.getBoundingClientRect().width * (1 + PERCENT / 100)));
                            }
                        }).call(this);
                    }
                    getClientDimensions() {
                        return this.div.getBoundingClientRect();
                    }
                    get altTextData() {
                        return {
                            altText: (0, $f2lgg._)(this, _altText),
                            decorative: (0, $f2lgg._)(this, _altTextDecorative)
                        };
                    }
                    set altTextData({ altText, decorative }) {
                        if ((0, $f2lgg._)(this, _altText) === altText && (0, $f2lgg._)(this, _altTextDecorative) === decorative) return;
                        (0, $5grPd._)(this, _altText, altText);
                        (0, $5grPd._)(this, _altTextDecorative, decorative);
                        (0, $hDjZy._)(this, _setAltTextButtonState, setAltTextButtonState).call(this);
                    }
                    render() {
                        this.div = document.createElement("div");
                        this.div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
                        this.div.className = this.name;
                        this.div.setAttribute("id", this.id);
                        this.div.setAttribute("tabIndex", 0);
                        this.setInForeground();
                        this.div.addEventListener("focusin", (0, $f2lgg._)(this, _boundFocusin));
                        this.div.addEventListener("focusout", (0, $f2lgg._)(this, _boundFocusout));
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        if (this.parentRotation % 180 !== 0) {
                            this.div.style.maxWidth = `${(100 * parentHeight / parentWidth).toFixed(2)}%`;
                            this.div.style.maxHeight = `${(100 * parentWidth / parentHeight).toFixed(2)}%`;
                        }
                        const [tx, ty] = this.getInitialTranslation();
                        this.translate(tx, ty);
                        (0, _tools.bindEvents)(this, this.div, [
                            "pointerdown"
                        ]);
                        return this.div;
                    }
                    pointerdown(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) {
                            event.preventDefault();
                            return;
                        }
                        (0, $5grPd._)(this, _hasBeenClicked, true);
                        (0, $hDjZy._)(this, _setUpDragSession, setUpDragSession).call(this, event);
                    }
                    moveInDOM() {
                        var _this_parent;
                        (_this_parent = this.parent) === null || _this_parent === void 0 ? void 0 : _this_parent.moveEditorInDOM(this);
                    }
                    _setParentAndPosition(parent, x, y) {
                        parent.changeParent(this);
                        this.x = x;
                        this.y = y;
                        this.fixAndSetPosition();
                    }
                    getRect(tx, ty) {
                        const scale = this.parentScale;
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const [pageX, pageY] = this.pageTranslation;
                        const shiftX = tx / scale;
                        const shiftY = ty / scale;
                        const x = this.x * pageWidth;
                        const y = this.y * pageHeight;
                        const width = this.width * pageWidth;
                        const height = this.height * pageHeight;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x + shiftX + pageX,
                                    pageHeight - y - shiftY - height + pageY,
                                    x + shiftX + width + pageX,
                                    pageHeight - y - shiftY + pageY
                                ];
                            case 90:
                                return [
                                    x + shiftY + pageX,
                                    pageHeight - y + shiftX + pageY,
                                    x + shiftY + height + pageX,
                                    pageHeight - y + shiftX + width + pageY
                                ];
                            case 180:
                                return [
                                    x - shiftX - width + pageX,
                                    pageHeight - y + shiftY + pageY,
                                    x - shiftX + pageX,
                                    pageHeight - y + shiftY + height + pageY
                                ];
                            case 270:
                                return [
                                    x - shiftY - height + pageX,
                                    pageHeight - y - shiftX - width + pageY,
                                    x - shiftY + pageX,
                                    pageHeight - y - shiftX + pageY
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    getRectInCurrentCoords(rect, pageHeight) {
                        const [x1, y1, x2, y2] = rect;
                        const width = x2 - x1;
                        const height = y2 - y1;
                        switch(this.rotation){
                            case 0:
                                return [
                                    x1,
                                    pageHeight - y2,
                                    width,
                                    height
                                ];
                            case 90:
                                return [
                                    x1,
                                    pageHeight - y1,
                                    height,
                                    width
                                ];
                            case 180:
                                return [
                                    x2,
                                    pageHeight - y1,
                                    width,
                                    height
                                ];
                            case 270:
                                return [
                                    x2,
                                    pageHeight - y2,
                                    height,
                                    width
                                ];
                            default:
                                throw new Error("Invalid rotation");
                        }
                    }
                    onceAdded() {}
                    isEmpty() {
                        return false;
                    }
                    enableEditMode() {
                        (0, $5grPd._)(this, _isInEditMode, true);
                    }
                    disableEditMode() {
                        (0, $5grPd._)(this, _isInEditMode, false);
                    }
                    isInEditMode() {
                        return (0, $f2lgg._)(this, _isInEditMode);
                    }
                    shouldGetKeyboardEvents() {
                        return false;
                    }
                    needsToBeRebuilt() {
                        return this.div && !this.isAttachedToDOM;
                    }
                    rebuild() {
                        var _this_div, _this_div1;
                        (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.addEventListener("focusin", (0, $f2lgg._)(this, _boundFocusin));
                        (_this_div1 = this.div) === null || _this_div1 === void 0 ? void 0 : _this_div1.addEventListener("focusout", (0, $f2lgg._)(this, _boundFocusout));
                    }
                    serialize(isForCopying = false, context = null) {
                        (0, _util.unreachable)("An editor must be serializable");
                    }
                    static deserialize(data, parent, uiManager) {
                        const editor = new this.prototype.constructor({
                            parent: parent,
                            id: parent.getNextId(),
                            uiManager: uiManager
                        });
                        editor.rotation = data.rotation;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const [x, y, width, height] = editor.getRectInCurrentCoords(data.rect, pageHeight);
                        editor.x = x / pageWidth;
                        editor.y = y / pageHeight;
                        editor.width = width / pageWidth;
                        editor.height = height / pageHeight;
                        return editor;
                    }
                    remove() {
                        var _class_private_field_get1;
                        this.div.removeEventListener("focusin", (0, $f2lgg._)(this, _boundFocusin));
                        this.div.removeEventListener("focusout", (0, $f2lgg._)(this, _boundFocusout));
                        if (!this.isEmpty()) this.commit();
                        if (this.parent) this.parent.remove(this);
                        else this._uiManager.removeEditor(this);
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _altTextButton)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove();
                        (0, $5grPd._)(this, _altTextButton, null);
                        (0, $5grPd._)(this, _altTextTooltip, null);
                    }
                    get isResizable() {
                        return false;
                    }
                    makeResizable() {
                        if (this.isResizable) {
                            (0, $hDjZy._)(this, _createResizers, createResizers).call(this);
                            (0, $f2lgg._)(this, _resizersDiv).classList.remove("hidden");
                        }
                    }
                    select() {
                        var _this_div;
                        this.makeResizable();
                        (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.add("selectedEditor");
                    }
                    unselect() {
                        var _class_private_field_get1, _this_div, _this_div1;
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _resizersDiv)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.classList.add("hidden");
                        (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.classList.remove("selectedEditor");
                        if ((_this_div1 = this.div) === null || _this_div1 === void 0 ? void 0 : _this_div1.contains(document.activeElement)) this._uiManager.currentLayer.div.focus();
                    }
                    updateParams(type, value) {}
                    disableEditing() {
                        if ((0, $f2lgg._)(this, _altTextButton)) (0, $f2lgg._)(this, _altTextButton).hidden = true;
                    }
                    enableEditing() {
                        if ((0, $f2lgg._)(this, _altTextButton)) (0, $f2lgg._)(this, _altTextButton).hidden = false;
                    }
                    enterInEditMode() {}
                    get contentDiv() {
                        return this.div;
                    }
                    get isEditing() {
                        return (0, $f2lgg._)(this, _isEditing);
                    }
                    set isEditing(value) {
                        (0, $5grPd._)(this, _isEditing, value);
                        if (!this.parent) return;
                        if (value) {
                            this.parent.setSelected(this);
                            this.parent.setActiveEditor(this);
                        } else this.parent.setActiveEditor(null);
                    }
                    setAspectRatio(width, height) {
                        (0, $5grPd._)(this, _keepAspectRatio, true);
                        const aspectRatio = width / height;
                        const { style } = this.div;
                        style.aspectRatio = aspectRatio;
                        style.height = "auto";
                    }
                    static get MIN_SIZE() {
                        return 16;
                    }
                    constructor(parameters){
                        (0, $2IZAT._)(this, _translate);
                        (0, $2IZAT._)(this, _getBaseTranslation);
                        (0, $2IZAT._)(this, _getRotationMatrix);
                        (0, $2IZAT._)(this, _createResizers);
                        (0, $2IZAT._)(this, _resizerPointerdown);
                        (0, $2IZAT._)(this, _resizerPointermove);
                        (0, $2IZAT._)(this, _setAltTextButtonState);
                        (0, $2IZAT._)(this, _setUpDragSession);
                        (0, $iXPoG._)(this, _altText, {
                            writable: true,
                            value: ""
                        });
                        (0, $iXPoG._)(this, _altTextDecorative, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _altTextButton, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _altTextTooltip, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _altTextTooltipTimeout, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _keepAspectRatio, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _resizersDiv, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _boundFocusin, {
                            writable: true,
                            value: this.focusin.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundFocusout, {
                            writable: true,
                            value: this.focusout.bind(this)
                        });
                        (0, $iXPoG._)(this, _hasBeenClicked, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _isEditing, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _isInEditMode, {
                            writable: true,
                            value: false
                        });
                        (0, $yQrT8._)(this, "_initialOptions", Object.create(null));
                        (0, $yQrT8._)(this, "_uiManager", null);
                        (0, $yQrT8._)(this, "_focusEventsAllowed", true);
                        (0, $yQrT8._)(this, "_l10nPromise", null);
                        (0, $iXPoG._)(this, _isDraggable, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _zIndex, {
                            writable: true,
                            value: AnnotationEditor._zIndex++
                        });
                        if (this.constructor === AnnotationEditor) (0, _util.unreachable)("Cannot initialize AnnotationEditor.");
                        this.parent = parameters.parent;
                        this.id = parameters.id;
                        this.width = this.height = null;
                        this.pageIndex = parameters.parent.pageIndex;
                        this.name = parameters.name;
                        this.div = null;
                        this._uiManager = parameters.uiManager;
                        this.annotationElementId = null;
                        this._willKeepAspectRatio = false;
                        this._initialOptions.isCentered = parameters.isCentered;
                        this._structTreeParentId = null;
                        const { rotation, rawDims: { pageWidth, pageHeight, pageX, pageY } } = this.parent.viewport;
                        this.rotation = rotation;
                        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
                        this.pageDimensions = [
                            pageWidth,
                            pageHeight
                        ];
                        this.pageTranslation = [
                            pageX,
                            pageY
                        ];
                        const [width, height] = this.parentDimensions;
                        this.x = parameters.x / width;
                        this.y = parameters.y / height;
                        this.isAttachedToDOM = false;
                        this.deleted = false;
                    }
                }
                (0, $yQrT8._)(AnnotationEditor, "_borderLineWidth", -1);
                (0, $yQrT8._)(AnnotationEditor, "_colorManager", new _tools.ColorManager());
                (0, $yQrT8._)(AnnotationEditor, "_zIndex", 1);
                (0, $yQrT8._)(AnnotationEditor, "SMALL_EDITOR_SIZE", 0);
                function translate([width, height], x, y) {
                    [x, y] = this.screenToPageTranslation(x, y);
                    this.x += x / width;
                    this.y += y / height;
                    this.fixAndSetPosition();
                }
                function getBaseTranslation() {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    const { _borderLineWidth } = AnnotationEditor;
                    const x = _borderLineWidth / parentWidth;
                    const y = _borderLineWidth / parentHeight;
                    switch(this.rotation){
                        case 90:
                            return [
                                -x,
                                y
                            ];
                        case 180:
                            return [
                                x,
                                y
                            ];
                        case 270:
                            return [
                                x,
                                -y
                            ];
                        default:
                            return [
                                -x,
                                -y
                            ];
                    }
                }
                function rotatePoint(x, y, angle) {
                    switch(angle){
                        case 90:
                            return [
                                y,
                                -x
                            ];
                        case 180:
                            return [
                                -x,
                                -y
                            ];
                        case 270:
                            return [
                                -y,
                                x
                            ];
                        default:
                            return [
                                x,
                                y
                            ];
                    }
                }
                function getRotationMatrix(rotation) {
                    switch(rotation){
                        case 90:
                            {
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                return [
                                    0,
                                    -pageWidth / pageHeight,
                                    pageHeight / pageWidth,
                                    0
                                ];
                            }
                        case 180:
                            return [
                                -1,
                                0,
                                0,
                                -1
                            ];
                        case 270:
                            {
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                return [
                                    0,
                                    pageWidth / pageHeight,
                                    -pageHeight / pageWidth,
                                    0
                                ];
                            }
                        default:
                            return [
                                1,
                                0,
                                0,
                                1
                            ];
                    }
                }
                function createResizers() {
                    if ((0, $f2lgg._)(this, _resizersDiv)) return;
                    (0, $5grPd._)(this, _resizersDiv, document.createElement("div"));
                    (0, $f2lgg._)(this, _resizersDiv).classList.add("resizers");
                    const classes = [
                        "topLeft",
                        "topRight",
                        "bottomRight",
                        "bottomLeft"
                    ];
                    if (!this._willKeepAspectRatio) classes.push("topMiddle", "middleRight", "bottomMiddle", "middleLeft");
                    for (const name of classes){
                        const div = document.createElement("div");
                        (0, $f2lgg._)(this, _resizersDiv).append(div);
                        div.classList.add("resizer", name);
                        div.addEventListener("pointerdown", (0, $hDjZy._)(this, _resizerPointerdown, resizerPointerdown).bind(this, name));
                        div.addEventListener("contextmenu", _display_utils.noContextMenu);
                    }
                    this.div.prepend((0, $f2lgg._)(this, _resizersDiv));
                }
                function resizerPointerdown(name, event) {
                    event.preventDefault();
                    const { isMac } = _util.FeatureTest.platform;
                    if (event.button !== 0 || event.ctrlKey && isMac) return;
                    const boundResizerPointermove = (0, $hDjZy._)(this, _resizerPointermove, resizerPointermove).bind(this, name);
                    const savedDraggable = this._isDraggable;
                    this._isDraggable = false;
                    const pointerMoveOptions = {
                        passive: true,
                        capture: true
                    };
                    window.addEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                    const savedX = this.x;
                    const savedY = this.y;
                    const savedWidth = this.width;
                    const savedHeight = this.height;
                    const savedParentCursor = this.parent.div.style.cursor;
                    const savedCursor = this.div.style.cursor;
                    this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
                    const pointerUpCallback = ()=>{
                        this._isDraggable = savedDraggable;
                        window.removeEventListener("pointerup", pointerUpCallback);
                        window.removeEventListener("blur", pointerUpCallback);
                        window.removeEventListener("pointermove", boundResizerPointermove, pointerMoveOptions);
                        this.parent.div.style.cursor = savedParentCursor;
                        this.div.style.cursor = savedCursor;
                        const newX = this.x;
                        const newY = this.y;
                        const newWidth = this.width;
                        const newHeight = this.height;
                        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) return;
                        this.addCommands({
                            cmd: ()=>{
                                this.width = newWidth;
                                this.height = newHeight;
                                this.x = newX;
                                this.y = newY;
                                const [parentWidth, parentHeight] = this.parentDimensions;
                                this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                                this.fixAndSetPosition();
                            },
                            undo: ()=>{
                                this.width = savedWidth;
                                this.height = savedHeight;
                                this.x = savedX;
                                this.y = savedY;
                                const [parentWidth, parentHeight] = this.parentDimensions;
                                this.setDims(parentWidth * savedWidth, parentHeight * savedHeight);
                                this.fixAndSetPosition();
                            },
                            mustExec: true
                        });
                    };
                    window.addEventListener("pointerup", pointerUpCallback);
                    window.addEventListener("blur", pointerUpCallback);
                }
                function resizerPointermove(name, event) {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    const savedX = this.x;
                    const savedY = this.y;
                    const savedWidth = this.width;
                    const savedHeight = this.height;
                    const minWidth = AnnotationEditor.MIN_SIZE / parentWidth;
                    const minHeight = AnnotationEditor.MIN_SIZE / parentHeight;
                    const round = (x)=>Math.round(x * 10000) / 10000;
                    const rotationMatrix = (0, $hDjZy._)(this, _getRotationMatrix, getRotationMatrix).call(this, this.rotation);
                    const transf = (x, y)=>[
                            rotationMatrix[0] * x + rotationMatrix[2] * y,
                            rotationMatrix[1] * x + rotationMatrix[3] * y
                        ];
                    const invRotationMatrix = (0, $hDjZy._)(this, _getRotationMatrix, getRotationMatrix).call(this, 360 - this.rotation);
                    const invTransf = (x, y)=>[
                            invRotationMatrix[0] * x + invRotationMatrix[2] * y,
                            invRotationMatrix[1] * x + invRotationMatrix[3] * y
                        ];
                    let getPoint;
                    let getOpposite;
                    let isDiagonal = false;
                    let isHorizontal = false;
                    switch(name){
                        case "topLeft":
                            isDiagonal = true;
                            getPoint = (w, h)=>[
                                    0,
                                    0
                                ];
                            getOpposite = (w, h)=>[
                                    w,
                                    h
                                ];
                            break;
                        case "topMiddle":
                            getPoint = (w, h)=>[
                                    w / 2,
                                    0
                                ];
                            getOpposite = (w, h)=>[
                                    w / 2,
                                    h
                                ];
                            break;
                        case "topRight":
                            isDiagonal = true;
                            getPoint = (w, h)=>[
                                    w,
                                    0
                                ];
                            getOpposite = (w, h)=>[
                                    0,
                                    h
                                ];
                            break;
                        case "middleRight":
                            isHorizontal = true;
                            getPoint = (w, h)=>[
                                    w,
                                    h / 2
                                ];
                            getOpposite = (w, h)=>[
                                    0,
                                    h / 2
                                ];
                            break;
                        case "bottomRight":
                            isDiagonal = true;
                            getPoint = (w, h)=>[
                                    w,
                                    h
                                ];
                            getOpposite = (w, h)=>[
                                    0,
                                    0
                                ];
                            break;
                        case "bottomMiddle":
                            getPoint = (w, h)=>[
                                    w / 2,
                                    h
                                ];
                            getOpposite = (w, h)=>[
                                    w / 2,
                                    0
                                ];
                            break;
                        case "bottomLeft":
                            isDiagonal = true;
                            getPoint = (w, h)=>[
                                    0,
                                    h
                                ];
                            getOpposite = (w, h)=>[
                                    w,
                                    0
                                ];
                            break;
                        case "middleLeft":
                            isHorizontal = true;
                            getPoint = (w, h)=>[
                                    0,
                                    h / 2
                                ];
                            getOpposite = (w, h)=>[
                                    w,
                                    h / 2
                                ];
                            break;
                    }
                    const point = getPoint(savedWidth, savedHeight);
                    const oppositePoint = getOpposite(savedWidth, savedHeight);
                    let transfOppositePoint = transf(...oppositePoint);
                    const oppositeX = round(savedX + transfOppositePoint[0]);
                    const oppositeY = round(savedY + transfOppositePoint[1]);
                    let ratioX = 1;
                    let ratioY = 1;
                    let [deltaX, deltaY] = this.screenToPageTranslation(event.movementX, event.movementY);
                    [deltaX, deltaY] = invTransf(deltaX / parentWidth, deltaY / parentHeight);
                    if (isDiagonal) {
                        const oldDiag = Math.hypot(savedWidth, savedHeight);
                        ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
                    } else if (isHorizontal) ratioX = Math.max(minWidth, Math.min(1, Math.abs(oppositePoint[0] - point[0] - deltaX))) / savedWidth;
                    else ratioY = Math.max(minHeight, Math.min(1, Math.abs(oppositePoint[1] - point[1] - deltaY))) / savedHeight;
                    const newWidth = round(savedWidth * ratioX);
                    const newHeight = round(savedHeight * ratioY);
                    transfOppositePoint = transf(...getOpposite(newWidth, newHeight));
                    const newX = oppositeX - transfOppositePoint[0];
                    const newY = oppositeY - transfOppositePoint[1];
                    this.width = newWidth;
                    this.height = newHeight;
                    this.x = newX;
                    this.y = newY;
                    this.setDims(parentWidth * newWidth, parentHeight * newHeight);
                    this.fixAndSetPosition();
                }
                function setAltTextButtonState() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        const button = (0, $f2lgg._)(this, _altTextButton);
                        if (!button) return;
                        if (!(0, $f2lgg._)(this, _altText) && !(0, $f2lgg._)(this, _altTextDecorative)) {
                            var _class_private_field_get1;
                            button.classList.remove("done");
                            (_class_private_field_get1 = (0, $f2lgg._)(this, _altTextTooltip)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove();
                            return;
                        }
                        AnnotationEditor._l10nPromise.get("editor_alt_text_edit_button_label").then((msg)=>{
                            button.setAttribute("aria-label", msg);
                        });
                        let tooltip = (0, $f2lgg._)(this, _altTextTooltip);
                        if (!tooltip) {
                            (0, $5grPd._)(this, _altTextTooltip, tooltip = document.createElement("span"));
                            tooltip.className = "tooltip";
                            tooltip.setAttribute("role", "tooltip");
                            const id = tooltip.id = `alt-text-tooltip-${this.id}`;
                            button.setAttribute("aria-describedby", id);
                            const DELAY_TO_SHOW_TOOLTIP = 100;
                            button.addEventListener("mouseenter", ()=>{
                                (0, $5grPd._)(this, _altTextTooltipTimeout, setTimeout(()=>{
                                    (0, $5grPd._)(this, _altTextTooltipTimeout, null);
                                    (0, $f2lgg._)(this, _altTextTooltip).classList.add("show");
                                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                                        source: this,
                                        details: {
                                            type: "editing",
                                            subtype: this.editorType,
                                            data: {
                                                action: "alt_text_tooltip"
                                            }
                                        }
                                    });
                                }, DELAY_TO_SHOW_TOOLTIP));
                            });
                            button.addEventListener("mouseleave", ()=>{
                                var _class_private_field_get1;
                                clearTimeout((0, $f2lgg._)(this, _altTextTooltipTimeout));
                                (0, $5grPd._)(this, _altTextTooltipTimeout, null);
                                (_class_private_field_get1 = (0, $f2lgg._)(this, _altTextTooltip)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.classList.remove("show");
                            });
                        }
                        button.classList.add("done");
                        tooltip.innerText = (0, $f2lgg._)(this, _altTextDecorative) ? yield AnnotationEditor._l10nPromise.get("editor_alt_text_decorative_tooltip") : (0, $f2lgg._)(this, _altText);
                        if (!tooltip.parentNode) button.append(tooltip);
                    }).call(this);
                }
                function setUpDragSession(event) {
                    if (!this._isDraggable) return;
                    const isSelected = this._uiManager.isSelected(this);
                    this._uiManager.setUpDragSession();
                    let pointerMoveOptions, pointerMoveCallback;
                    if (isSelected) {
                        pointerMoveOptions = {
                            passive: true,
                            capture: true
                        };
                        pointerMoveCallback = (e)=>{
                            const [tx, ty] = this.screenToPageTranslation(e.movementX, e.movementY);
                            this._uiManager.dragSelectedEditors(tx, ty);
                        };
                        window.addEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                    }
                    const pointerUpCallback = ()=>{
                        window.removeEventListener("pointerup", pointerUpCallback);
                        window.removeEventListener("blur", pointerUpCallback);
                        if (isSelected) window.removeEventListener("pointermove", pointerMoveCallback, pointerMoveOptions);
                        (0, $5grPd._)(this, _hasBeenClicked, false);
                        if (!this._uiManager.endDragSession()) {
                            const { isMac } = _util.FeatureTest.platform;
                            if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) this.parent.toggleSelected(this);
                            else this.parent.setSelected(this);
                        }
                    };
                    window.addEventListener("pointerup", pointerUpCallback);
                    window.addEventListener("blur", pointerUpCallback);
                }
                exports.AnnotationEditor = AnnotationEditor;
                class FakeEditor extends AnnotationEditor {
                    serialize() {
                        return {
                            id: this.annotationElementId,
                            deleted: true,
                            pageIndex: this.pageIndex
                        };
                    }
                    constructor(params){
                        super(params);
                        this.annotationElementId = params.annotationElementId;
                        this.deleted = true;
                    }
                }
            /***/ },
            /* 5 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.KeyboardManager = exports.CommandManager = exports.ColorManager = exports.AnnotationEditorUIManager = void 0;
                exports.bindEvents = bindEvents;
                exports.opacityToHex = opacityToHex;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                function bindEvents(obj, element, names) {
                    for (const name of names)element.addEventListener(name, obj[name].bind(obj));
                }
                function opacityToHex(opacity) {
                    return Math.round(Math.min(255, Math.max(1, 255 * opacity))).toString(16).padStart(2, "0");
                }
                var _id = /*#__PURE__*/ new WeakMap();
                class IdManager {
                    getId() {
                        return `${_util.AnnotationEditorPrefix}${(0, $kmaE3._)(this, _id).value++}`;
                    }
                    constructor(){
                        (0, $iXPoG._)(this, _id, {
                            writable: true,
                            value: 0
                        });
                    }
                }
                var _baseId = /*#__PURE__*/ new WeakMap(), _id1 = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _get = /*#__PURE__*/ new WeakSet();
                class ImageManager {
                    static get _isSVGFittingCanvas() {
                        const svg = `data:image/svg+xml;charset=UTF-8,<svg viewBox="0 0 1 1" width="1" height="1" xmlns="http://www.w3.org/2000/svg"><rect width="1" height="1" style="fill:red;"/></svg>`;
                        const canvas = new OffscreenCanvas(1, 3);
                        const ctx = canvas.getContext("2d");
                        const image = new Image();
                        image.src = svg;
                        const promise = image.decode().then(()=>{
                            ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                            return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
                        });
                        return (0, _util.shadow)(this, "_isSVGFittingCanvas", promise);
                    }
                    getFromFile(file) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            const { lastModified, name, size, type } = file;
                            return (0, $hDjZy._)(this, _get, get).call(this, `${lastModified}_${name}_${size}_${type}`, file);
                        }).call(this);
                    }
                    getFromUrl(url) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            return (0, $hDjZy._)(this, _get, get).call(this, url, url);
                        }).call(this);
                    }
                    getFromId(id) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            (0, $5grPd._)(this, _cache, (0, $f2lgg._)(this, _cache) || new Map());
                            const data = (0, $f2lgg._)(this, _cache).get(id);
                            if (!data) return null;
                            if (data.bitmap) {
                                data.refCounter += 1;
                                return data;
                            }
                            if (data.file) return this.getFromFile(data.file);
                            return this.getFromUrl(data.url);
                        }).call(this);
                    }
                    getSvgUrl(id) {
                        const data = (0, $f2lgg._)(this, _cache).get(id);
                        if (!(data === null || data === void 0 ? void 0 : data.isSvg)) return null;
                        return data.svgUrl;
                    }
                    deleteId(id) {
                        (0, $5grPd._)(this, _cache, (0, $f2lgg._)(this, _cache) || new Map());
                        const data = (0, $f2lgg._)(this, _cache).get(id);
                        if (!data) return;
                        data.refCounter -= 1;
                        if (data.refCounter !== 0) return;
                        data.bitmap = null;
                    }
                    isValidId(id) {
                        return id.startsWith(`image_${(0, $f2lgg._)(this, _baseId)}_`);
                    }
                    constructor(){
                        (0, $2IZAT._)(this, _get);
                        (0, $iXPoG._)(this, _baseId, {
                            writable: true,
                            value: (0, _util.getUuid)()
                        });
                        (0, $iXPoG._)(this, _id1, {
                            writable: true,
                            value: 0
                        });
                        (0, $iXPoG._)(this, _cache, {
                            writable: true,
                            value: null
                        });
                    }
                }
                function get(key, rawData) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        (0, $5grPd._)(this, _cache, (0, $f2lgg._)(this, _cache) || new Map());
                        let data = (0, $f2lgg._)(this, _cache).get(key);
                        if (data === null) return null;
                        if (data === null || data === void 0 ? void 0 : data.bitmap) {
                            data.refCounter += 1;
                            return data;
                        }
                        try {
                            data || (data = {
                                bitmap: null,
                                id: `image_${(0, $f2lgg._)(this, _baseId)}_${(0, $kmaE3._)(this, _id1).value++}`,
                                refCounter: 0,
                                isSvg: false
                            });
                            let image;
                            if (typeof rawData === "string") {
                                data.url = rawData;
                                const response = yield fetch(rawData);
                                if (!response.ok) throw new Error(response.statusText);
                                image = yield response.blob();
                            } else image = data.file = rawData;
                            if (image.type === "image/svg+xml") {
                                const mustRemoveAspectRatioPromise = ImageManager._isSVGFittingCanvas;
                                const fileReader = new FileReader();
                                const imageElement = new Image();
                                const imagePromise = new Promise((resolve, reject)=>{
                                    imageElement.onload = ()=>{
                                        data.bitmap = imageElement;
                                        data.isSvg = true;
                                        resolve();
                                    };
                                    fileReader.onload = ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                                            const url = data.svgUrl = fileReader.result;
                                            imageElement.src = (yield mustRemoveAspectRatioPromise) ? `${url}#svgView(preserveAspectRatio(none))` : url;
                                        })();
                                    imageElement.onerror = fileReader.onerror = reject;
                                });
                                fileReader.readAsDataURL(image);
                                yield imagePromise;
                            } else data.bitmap = yield createImageBitmap(image);
                            data.refCounter = 1;
                        } catch (e) {
                            console.error(e);
                            data = null;
                        }
                        (0, $f2lgg._)(this, _cache).set(key, data);
                        if (data) (0, $f2lgg._)(this, _cache).set(data.id, data);
                        return data;
                    }).call(this);
                }
                var _commands = /*#__PURE__*/ new WeakMap(), _locked = /*#__PURE__*/ new WeakMap(), _maxSize = /*#__PURE__*/ new WeakMap(), _position = /*#__PURE__*/ new WeakMap();
                class CommandManager {
                    add({ cmd, undo, mustExec, type = NaN, overwriteIfSameType = false, keepUndo = false }) {
                        if (mustExec) cmd();
                        if ((0, $f2lgg._)(this, _locked)) return;
                        const save = {
                            cmd: cmd,
                            undo: undo,
                            type: type
                        };
                        if ((0, $f2lgg._)(this, _position) === -1) {
                            if ((0, $f2lgg._)(this, _commands).length > 0) (0, $f2lgg._)(this, _commands).length = 0;
                            (0, $5grPd._)(this, _position, 0);
                            (0, $f2lgg._)(this, _commands).push(save);
                            return;
                        }
                        if (overwriteIfSameType && (0, $f2lgg._)(this, _commands)[(0, $f2lgg._)(this, _position)].type === type) {
                            if (keepUndo) save.undo = (0, $f2lgg._)(this, _commands)[(0, $f2lgg._)(this, _position)].undo;
                            (0, $f2lgg._)(this, _commands)[(0, $f2lgg._)(this, _position)] = save;
                            return;
                        }
                        const next = (0, $f2lgg._)(this, _position) + 1;
                        if (next === (0, $f2lgg._)(this, _maxSize)) (0, $f2lgg._)(this, _commands).splice(0, 1);
                        else {
                            (0, $5grPd._)(this, _position, next);
                            if (next < (0, $f2lgg._)(this, _commands).length) (0, $f2lgg._)(this, _commands).splice(next);
                        }
                        (0, $f2lgg._)(this, _commands).push(save);
                    }
                    undo() {
                        if ((0, $f2lgg._)(this, _position) === -1) return;
                        (0, $5grPd._)(this, _locked, true);
                        (0, $f2lgg._)(this, _commands)[(0, $f2lgg._)(this, _position)].undo();
                        (0, $5grPd._)(this, _locked, false);
                        (0, $5grPd._)(this, _position, (0, $f2lgg._)(this, _position) - 1);
                    }
                    redo() {
                        if ((0, $f2lgg._)(this, _position) < (0, $f2lgg._)(this, _commands).length - 1) {
                            (0, $5grPd._)(this, _position, (0, $f2lgg._)(this, _position) + 1);
                            (0, $5grPd._)(this, _locked, true);
                            (0, $f2lgg._)(this, _commands)[(0, $f2lgg._)(this, _position)].cmd();
                            (0, $5grPd._)(this, _locked, false);
                        }
                    }
                    hasSomethingToUndo() {
                        return (0, $f2lgg._)(this, _position) !== -1;
                    }
                    hasSomethingToRedo() {
                        return (0, $f2lgg._)(this, _position) < (0, $f2lgg._)(this, _commands).length - 1;
                    }
                    destroy() {
                        (0, $5grPd._)(this, _commands, null);
                    }
                    constructor(maxSize = 128){
                        (0, $iXPoG._)(this, _commands, {
                            writable: true,
                            value: []
                        });
                        (0, $iXPoG._)(this, _locked, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _maxSize, {
                            writable: true,
                            value: void 0
                        });
                        (0, $iXPoG._)(this, _position, {
                            writable: true,
                            value: -1
                        });
                        (0, $5grPd._)(this, _maxSize, maxSize);
                    }
                }
                exports.CommandManager = CommandManager;
                var _serialize = /*#__PURE__*/ new WeakSet();
                class KeyboardManager {
                    exec(self, event) {
                        if (!this.allKeys.has(event.key)) return;
                        const info = this.callbacks.get((0, $hDjZy._)(this, _serialize, serialize).call(this, event));
                        if (!info) return;
                        const { callback, options: { bubbles = false, args = [], checker = null } } = info;
                        if (checker && !checker(self, event)) return;
                        callback.bind(self, ...args)();
                        if (!bubbles) {
                            event.stopPropagation();
                            event.preventDefault();
                        }
                    }
                    constructor(callbacks){
                        (0, $2IZAT._)(this, _serialize);
                        this.buffer = [];
                        this.callbacks = new Map();
                        this.allKeys = new Set();
                        const { isMac } = _util.FeatureTest.platform;
                        for (const [keys, callback, options = {}] of callbacks)for (const key of keys){
                            const isMacKey = key.startsWith("mac+");
                            if (isMac && isMacKey) {
                                this.callbacks.set(key.slice(4), {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            } else if (!isMac && !isMacKey) {
                                this.callbacks.set(key, {
                                    callback: callback,
                                    options: options
                                });
                                this.allKeys.add(key.split("+").at(-1));
                            }
                        }
                    }
                }
                function serialize(event) {
                    if (event.altKey) this.buffer.push("alt");
                    if (event.ctrlKey) this.buffer.push("ctrl");
                    if (event.metaKey) this.buffer.push("meta");
                    if (event.shiftKey) this.buffer.push("shift");
                    this.buffer.push(event.key);
                    const str = this.buffer.join("+");
                    this.buffer.length = 0;
                    return str;
                }
                exports.KeyboardManager = KeyboardManager;
                class ColorManager {
                    get _colors() {
                        const colors = new Map([
                            [
                                "CanvasText",
                                null
                            ],
                            [
                                "Canvas",
                                null
                            ]
                        ]);
                        (0, _display_utils.getColorValues)(colors);
                        return (0, _util.shadow)(this, "_colors", colors);
                    }
                    convert(color) {
                        const rgb = (0, _display_utils.getRGB)(color);
                        if (!window.matchMedia("(forced-colors: active)").matches) return rgb;
                        for (const [name, RGB] of this._colors){
                            if (RGB.every((x, i)=>x === rgb[i])) return ColorManager._colorsMapping.get(name);
                        }
                        return rgb;
                    }
                    getHexCode(name) {
                        const rgb = this._colors.get(name);
                        if (!rgb) return name;
                        return _util.Util.makeHexColor(...rgb);
                    }
                }
                (0, $yQrT8._)(ColorManager, "_colorsMapping", new Map([
                    [
                        "CanvasText",
                        [
                            0,
                            0,
                            0
                        ]
                    ],
                    [
                        "Canvas",
                        [
                            255,
                            255,
                            255
                        ]
                    ]
                ]));
                exports.ColorManager = ColorManager;
                var _activeEditor = /*#__PURE__*/ new WeakMap(), _allEditors = /*#__PURE__*/ new WeakMap(), _allLayers = /*#__PURE__*/ new WeakMap(), _altTextManager = /*#__PURE__*/ new WeakMap(), _annotationStorage = /*#__PURE__*/ new WeakMap(), _commandManager = /*#__PURE__*/ new WeakMap(), _currentPageIndex = /*#__PURE__*/ new WeakMap(), _deletedAnnotationsElementIds = /*#__PURE__*/ new WeakMap(), _draggingEditors = /*#__PURE__*/ new WeakMap(), _editorTypes = /*#__PURE__*/ new WeakMap(), _editorsToRescale = /*#__PURE__*/ new WeakMap(), _filterFactory = /*#__PURE__*/ new WeakMap(), _idManager = /*#__PURE__*/ new WeakMap(), _isEnabled = /*#__PURE__*/ new WeakMap(), _isWaiting = /*#__PURE__*/ new WeakMap(), _lastActiveElement = /*#__PURE__*/ new WeakMap(), _mode = /*#__PURE__*/ new WeakMap(), _selectedEditors = /*#__PURE__*/ new WeakMap(), _pageColors = /*#__PURE__*/ new WeakMap(), _boundBlur = /*#__PURE__*/ new WeakMap(), _boundFocus = /*#__PURE__*/ new WeakMap(), _boundCopy = /*#__PURE__*/ new WeakMap(), _boundCut = /*#__PURE__*/ new WeakMap(), _boundPaste = /*#__PURE__*/ new WeakMap(), _boundKeydown = /*#__PURE__*/ new WeakMap(), _boundOnEditingAction = /*#__PURE__*/ new WeakMap(), _boundOnPageChanging = /*#__PURE__*/ new WeakMap(), _boundOnScaleChanging = /*#__PURE__*/ new WeakMap(), _boundOnRotationChanging = /*#__PURE__*/ new WeakMap(), _previousStates = /*#__PURE__*/ new WeakMap(), _translation = /*#__PURE__*/ new WeakMap(), _translationTimeoutId = /*#__PURE__*/ new WeakMap(), _container = /*#__PURE__*/ new WeakMap(), _viewer = /*#__PURE__*/ new WeakMap(), _addFocusManager = /*#__PURE__*/ new WeakSet(), _removeFocusManager = /*#__PURE__*/ new WeakSet(), _addKeyboardManager = /*#__PURE__*/ new WeakSet(), _removeKeyboardManager = /*#__PURE__*/ new WeakSet(), _addCopyPasteListeners = /*#__PURE__*/ new WeakSet(), _removeCopyPasteListeners = /*#__PURE__*/ new WeakSet(), _dispatchUpdateStates = /*#__PURE__*/ new WeakSet(), _dispatchUpdateUI = /*#__PURE__*/ new WeakSet(), _enableAll = /*#__PURE__*/ new WeakSet(), _disableAll = /*#__PURE__*/ new WeakSet(), _addEditorToLayer = /*#__PURE__*/ new WeakSet(), _isEmpty = /*#__PURE__*/ new WeakSet(), _selectEditors = /*#__PURE__*/ new WeakSet();
                class AnnotationEditorUIManager {
                    static get _keyboardManager() {
                        const proto = AnnotationEditorUIManager.prototype;
                        const arrowChecker = (self)=>{
                            const { activeElement } = document;
                            return activeElement && (0, $f2lgg._)(self, _container).contains(activeElement) && self.hasSomethingToControl();
                        };
                        const small = this.TRANSLATE_SMALL;
                        const big = this.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new KeyboardManager([
                            [
                                [
                                    "ctrl+a",
                                    "mac+meta+a"
                                ],
                                proto.selectAll
                            ],
                            [
                                [
                                    "ctrl+z",
                                    "mac+meta+z"
                                ],
                                proto.undo
                            ],
                            [
                                [
                                    "ctrl+y",
                                    "ctrl+shift+z",
                                    "mac+meta+shift+z",
                                    "ctrl+shift+Z",
                                    "mac+meta+shift+Z"
                                ],
                                proto.redo
                            ],
                            [
                                [
                                    "Backspace",
                                    "alt+Backspace",
                                    "ctrl+Backspace",
                                    "shift+Backspace",
                                    "mac+Backspace",
                                    "mac+alt+Backspace",
                                    "mac+ctrl+Backspace",
                                    "Delete",
                                    "ctrl+Delete",
                                    "shift+Delete",
                                    "mac+Delete"
                                ],
                                proto.delete
                            ],
                            [
                                [
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.unselectAll
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto.translateSelectedEditors,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    destroy() {
                        (0, $hDjZy._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                        (0, $hDjZy._)(this, _removeFocusManager, removeFocusManager).call(this);
                        this._eventBus._off("editingaction", (0, $f2lgg._)(this, _boundOnEditingAction));
                        this._eventBus._off("pagechanging", (0, $f2lgg._)(this, _boundOnPageChanging));
                        this._eventBus._off("scalechanging", (0, $f2lgg._)(this, _boundOnScaleChanging));
                        this._eventBus._off("rotationchanging", (0, $f2lgg._)(this, _boundOnRotationChanging));
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values())layer.destroy();
                        (0, $f2lgg._)(this, _allLayers).clear();
                        (0, $f2lgg._)(this, _allEditors).clear();
                        (0, $f2lgg._)(this, _editorsToRescale).clear();
                        (0, $5grPd._)(this, _activeEditor, null);
                        (0, $f2lgg._)(this, _selectedEditors).clear();
                        (0, $f2lgg._)(this, _commandManager).destroy();
                        (0, $f2lgg._)(this, _altTextManager).destroy();
                    }
                    get hcmFilter() {
                        return (0, _util.shadow)(this, "hcmFilter", (0, $f2lgg._)(this, _pageColors) ? (0, $f2lgg._)(this, _filterFactory).addHCMFilter((0, $f2lgg._)(this, _pageColors).foreground, (0, $f2lgg._)(this, _pageColors).background) : "none");
                    }
                    get direction() {
                        return (0, _util.shadow)(this, "direction", getComputedStyle((0, $f2lgg._)(this, _container)).direction);
                    }
                    editAltText(editor) {
                        var _class_private_field_get1;
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _altTextManager)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.editAltText(this, editor);
                    }
                    onPageChanging({ pageNumber }) {
                        (0, $5grPd._)(this, _currentPageIndex, pageNumber - 1);
                    }
                    focusMainContainer() {
                        (0, $f2lgg._)(this, _container).focus();
                    }
                    findParent(x, y) {
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values()){
                            const { x: layerX, y: layerY, width, height } = layer.div.getBoundingClientRect();
                            if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) return layer;
                        }
                        return null;
                    }
                    disableUserSelect(value = false) {
                        (0, $f2lgg._)(this, _viewer).classList.toggle("noUserSelect", value);
                    }
                    addShouldRescale(editor) {
                        (0, $f2lgg._)(this, _editorsToRescale).add(editor);
                    }
                    removeShouldRescale(editor) {
                        (0, $f2lgg._)(this, _editorsToRescale).delete(editor);
                    }
                    onScaleChanging({ scale }) {
                        this.commitOrRemove();
                        this.viewParameters.realScale = scale * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS;
                        for (const editor of (0, $f2lgg._)(this, _editorsToRescale))editor.onScaleChanging();
                    }
                    onRotationChanging({ pagesRotation }) {
                        this.commitOrRemove();
                        this.viewParameters.rotation = pagesRotation;
                    }
                    addToAnnotationStorage(editor) {
                        if (!editor.isEmpty() && (0, $f2lgg._)(this, _annotationStorage) && !(0, $f2lgg._)(this, _annotationStorage).has(editor.id)) (0, $f2lgg._)(this, _annotationStorage).setValue(editor.id, editor);
                    }
                    blur() {
                        if (!this.hasSelection) return;
                        const { activeElement } = document;
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors))if (editor.div.contains(activeElement)) {
                            (0, $5grPd._)(this, _lastActiveElement, [
                                editor,
                                activeElement
                            ]);
                            editor._focusEventsAllowed = false;
                            break;
                        }
                    }
                    focus() {
                        if (!(0, $f2lgg._)(this, _lastActiveElement)) return;
                        const [lastEditor, lastActiveElement] = (0, $f2lgg._)(this, _lastActiveElement);
                        (0, $5grPd._)(this, _lastActiveElement, null);
                        lastActiveElement.addEventListener("focusin", ()=>{
                            lastEditor._focusEventsAllowed = true;
                        }, {
                            once: true
                        });
                        lastActiveElement.focus();
                    }
                    addEditListeners() {
                        (0, $hDjZy._)(this, _addKeyboardManager, addKeyboardManager).call(this);
                        (0, $hDjZy._)(this, _addCopyPasteListeners, addCopyPasteListeners).call(this);
                    }
                    removeEditListeners() {
                        (0, $hDjZy._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                        (0, $hDjZy._)(this, _removeCopyPasteListeners, removeCopyPasteListeners).call(this);
                    }
                    copy(event) {
                        var _class_private_field_get1;
                        event.preventDefault();
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _activeEditor)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [];
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors)){
                            const serialized = editor.serialize(true);
                            if (serialized) editors.push(serialized);
                        }
                        if (editors.length === 0) return;
                        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
                    }
                    cut(event) {
                        this.copy(event);
                        this.delete();
                    }
                    paste(event) {
                        event.preventDefault();
                        const { clipboardData } = event;
                        for (const item of clipboardData.items){
                            for (const editorType of (0, $f2lgg._)(this, _editorTypes))if (editorType.isHandlingMimeForPasting(item.type)) {
                                editorType.paste(item, this.currentLayer);
                                return;
                            }
                        }
                        let data = clipboardData.getData("application/pdfjs");
                        if (!data) return;
                        try {
                            data = JSON.parse(data);
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                            return;
                        }
                        if (!Array.isArray(data)) return;
                        this.unselectAll();
                        const layer = this.currentLayer;
                        try {
                            const newEditors = [];
                            for (const editor of data){
                                const deserializedEditor = layer.deserialize(editor);
                                if (!deserializedEditor) return;
                                newEditors.push(deserializedEditor);
                            }
                            const cmd = ()=>{
                                for (const editor of newEditors)(0, $hDjZy._)(this, _addEditorToLayer, addEditorToLayer).call(this, editor);
                                (0, $hDjZy._)(this, _selectEditors, selectEditors).call(this, newEditors);
                            };
                            const undo = ()=>{
                                for (const editor of newEditors)editor.remove();
                            };
                            this.addCommands({
                                cmd: cmd,
                                undo: undo,
                                mustExec: true
                            });
                        } catch (ex) {
                            (0, _util.warn)(`paste: "${ex.message}".`);
                        }
                    }
                    keydown(event) {
                        var _this_getActive;
                        if (!((_this_getActive = this.getActive()) === null || _this_getActive === void 0 ? void 0 : _this_getActive.shouldGetKeyboardEvents())) AnnotationEditorUIManager._keyboardManager.exec(this, event);
                    }
                    onEditingAction(details) {
                        if ([
                            "undo",
                            "redo",
                            "delete",
                            "selectAll"
                        ].includes(details.name)) this[details.name]();
                    }
                    setEditingState(isEditing) {
                        if (isEditing) {
                            (0, $hDjZy._)(this, _addFocusManager, addFocusManager).call(this);
                            (0, $hDjZy._)(this, _addKeyboardManager, addKeyboardManager).call(this);
                            (0, $hDjZy._)(this, _addCopyPasteListeners, addCopyPasteListeners).call(this);
                            (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                isEditing: (0, $f2lgg._)(this, _mode) !== _util.AnnotationEditorType.NONE,
                                isEmpty: (0, $hDjZy._)(this, _isEmpty, isEmpty).call(this),
                                hasSomethingToUndo: (0, $f2lgg._)(this, _commandManager).hasSomethingToUndo(),
                                hasSomethingToRedo: (0, $f2lgg._)(this, _commandManager).hasSomethingToRedo(),
                                hasSelectedEditor: false
                            });
                        } else {
                            (0, $hDjZy._)(this, _removeFocusManager, removeFocusManager).call(this);
                            (0, $hDjZy._)(this, _removeKeyboardManager, removeKeyboardManager).call(this);
                            (0, $hDjZy._)(this, _removeCopyPasteListeners, removeCopyPasteListeners).call(this);
                            (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                isEditing: false
                            });
                            this.disableUserSelect(false);
                        }
                    }
                    registerEditorTypes(types) {
                        if ((0, $f2lgg._)(this, _editorTypes)) return;
                        (0, $5grPd._)(this, _editorTypes, types);
                        for (const editorType of (0, $f2lgg._)(this, _editorTypes))(0, $hDjZy._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editorType.defaultPropertiesToUpdate);
                    }
                    getId() {
                        return (0, $f2lgg._)(this, _idManager).getId();
                    }
                    get currentLayer() {
                        return (0, $f2lgg._)(this, _allLayers).get((0, $f2lgg._)(this, _currentPageIndex));
                    }
                    getLayer(pageIndex) {
                        return (0, $f2lgg._)(this, _allLayers).get(pageIndex);
                    }
                    get currentPageIndex() {
                        return (0, $f2lgg._)(this, _currentPageIndex);
                    }
                    addLayer(layer) {
                        (0, $f2lgg._)(this, _allLayers).set(layer.pageIndex, layer);
                        if ((0, $f2lgg._)(this, _isEnabled)) layer.enable();
                        else layer.disable();
                    }
                    removeLayer(layer) {
                        (0, $f2lgg._)(this, _allLayers).delete(layer.pageIndex);
                    }
                    updateMode(mode, editId = null) {
                        if ((0, $f2lgg._)(this, _mode) === mode) return;
                        (0, $5grPd._)(this, _mode, mode);
                        if (mode === _util.AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            (0, $hDjZy._)(this, _disableAll, disableAll).call(this);
                            return;
                        }
                        this.setEditingState(true);
                        (0, $hDjZy._)(this, _enableAll, enableAll).call(this);
                        this.unselectAll();
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values())layer.updateMode(mode);
                        if (!editId) return;
                        for (const editor of (0, $f2lgg._)(this, _allEditors).values())if (editor.annotationElementId === editId) {
                            this.setSelected(editor);
                            editor.enterInEditMode();
                            break;
                        }
                    }
                    updateToolbar(mode) {
                        if (mode === (0, $f2lgg._)(this, _mode)) return;
                        this._eventBus.dispatch("switchannotationeditormode", {
                            source: this,
                            mode: mode
                        });
                    }
                    updateParams(type, value) {
                        if (!(0, $f2lgg._)(this, _editorTypes)) return;
                        if (type === _util.AnnotationEditorParamsType.CREATE) {
                            this.currentLayer.addNewEditor(type);
                            return;
                        }
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors))editor.updateParams(type, value);
                        for (const editorType of (0, $f2lgg._)(this, _editorTypes))editorType.updateDefaultParams(type, value);
                    }
                    enableWaiting(mustWait = false) {
                        if ((0, $f2lgg._)(this, _isWaiting) === mustWait) return;
                        (0, $5grPd._)(this, _isWaiting, mustWait);
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values()){
                            if (mustWait) layer.disableClick();
                            else layer.enableClick();
                            layer.div.classList.toggle("waiting", mustWait);
                        }
                    }
                    getEditors(pageIndex) {
                        const editors = [];
                        for (const editor of (0, $f2lgg._)(this, _allEditors).values())if (editor.pageIndex === pageIndex) editors.push(editor);
                        return editors;
                    }
                    getEditor(id) {
                        return (0, $f2lgg._)(this, _allEditors).get(id);
                    }
                    addEditor(editor) {
                        (0, $f2lgg._)(this, _allEditors).set(editor.id, editor);
                    }
                    removeEditor(editor) {
                        var _class_private_field_get1;
                        (0, $f2lgg._)(this, _allEditors).delete(editor.id);
                        this.unselect(editor);
                        if (!editor.annotationElementId || !(0, $f2lgg._)(this, _deletedAnnotationsElementIds).has(editor.annotationElementId)) (_class_private_field_get1 = (0, $f2lgg._)(this, _annotationStorage)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove(editor.id);
                    }
                    addDeletedAnnotationElement(editor) {
                        (0, $f2lgg._)(this, _deletedAnnotationsElementIds).add(editor.annotationElementId);
                        editor.deleted = true;
                    }
                    isDeletedAnnotationElement(annotationElementId) {
                        return (0, $f2lgg._)(this, _deletedAnnotationsElementIds).has(annotationElementId);
                    }
                    removeDeletedAnnotationElement(editor) {
                        (0, $f2lgg._)(this, _deletedAnnotationsElementIds).delete(editor.annotationElementId);
                        editor.deleted = false;
                    }
                    setActiveEditor(editor) {
                        if ((0, $f2lgg._)(this, _activeEditor) === editor) return;
                        (0, $5grPd._)(this, _activeEditor, editor);
                        if (editor) (0, $hDjZy._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                    }
                    toggleSelected(editor) {
                        if ((0, $f2lgg._)(this, _selectedEditors).has(editor)) {
                            (0, $f2lgg._)(this, _selectedEditors).delete(editor);
                            editor.unselect();
                            (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                                hasSelectedEditor: this.hasSelection
                            });
                            return;
                        }
                        (0, $f2lgg._)(this, _selectedEditors).add(editor);
                        editor.select();
                        (0, $hDjZy._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSelectedEditor: true
                        });
                    }
                    setSelected(editor) {
                        for (const ed of (0, $f2lgg._)(this, _selectedEditors))if (ed !== editor) ed.unselect();
                        (0, $f2lgg._)(this, _selectedEditors).clear();
                        (0, $f2lgg._)(this, _selectedEditors).add(editor);
                        editor.select();
                        (0, $hDjZy._)(this, _dispatchUpdateUI, dispatchUpdateUI).call(this, editor.propertiesToUpdate);
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSelectedEditor: true
                        });
                    }
                    isSelected(editor) {
                        return (0, $f2lgg._)(this, _selectedEditors).has(editor);
                    }
                    unselect(editor) {
                        editor.unselect();
                        (0, $f2lgg._)(this, _selectedEditors).delete(editor);
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSelectedEditor: this.hasSelection
                        });
                    }
                    get hasSelection() {
                        return (0, $f2lgg._)(this, _selectedEditors).size !== 0;
                    }
                    undo() {
                        (0, $f2lgg._)(this, _commandManager).undo();
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSomethingToUndo: (0, $f2lgg._)(this, _commandManager).hasSomethingToUndo(),
                            hasSomethingToRedo: true,
                            isEmpty: (0, $hDjZy._)(this, _isEmpty, isEmpty).call(this)
                        });
                    }
                    redo() {
                        (0, $f2lgg._)(this, _commandManager).redo();
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: (0, $f2lgg._)(this, _commandManager).hasSomethingToRedo(),
                            isEmpty: (0, $hDjZy._)(this, _isEmpty, isEmpty).call(this)
                        });
                    }
                    addCommands(params) {
                        (0, $f2lgg._)(this, _commandManager).add(params);
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSomethingToUndo: true,
                            hasSomethingToRedo: false,
                            isEmpty: (0, $hDjZy._)(this, _isEmpty, isEmpty).call(this)
                        });
                    }
                    delete() {
                        this.commitOrRemove();
                        if (!this.hasSelection) return;
                        const editors = [
                            ...(0, $f2lgg._)(this, _selectedEditors)
                        ];
                        const cmd = ()=>{
                            for (const editor of editors)editor.remove();
                        };
                        const undo = ()=>{
                            for (const editor of editors)(0, $hDjZy._)(this, _addEditorToLayer, addEditorToLayer).call(this, editor);
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                    }
                    commitOrRemove() {
                        var _class_private_field_get1;
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _activeEditor)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.commitOrRemove();
                    }
                    hasSomethingToControl() {
                        return (0, $f2lgg._)(this, _activeEditor) || this.hasSelection;
                    }
                    selectAll() {
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors))editor.commit();
                        (0, $hDjZy._)(this, _selectEditors, selectEditors).call(this, (0, $f2lgg._)(this, _allEditors).values());
                    }
                    unselectAll() {
                        if ((0, $f2lgg._)(this, _activeEditor)) {
                            (0, $f2lgg._)(this, _activeEditor).commitOrRemove();
                            return;
                        }
                        if (!this.hasSelection) return;
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors))editor.unselect();
                        (0, $f2lgg._)(this, _selectedEditors).clear();
                        (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                            hasSelectedEditor: false
                        });
                    }
                    translateSelectedEditors(x, y, noCommit = false) {
                        if (!noCommit) this.commitOrRemove();
                        if (!this.hasSelection) return;
                        (0, $f2lgg._)(this, _translation)[0] += x;
                        (0, $f2lgg._)(this, _translation)[1] += y;
                        const [totalX, totalY] = (0, $f2lgg._)(this, _translation);
                        const editors = [
                            ...(0, $f2lgg._)(this, _selectedEditors)
                        ];
                        const TIME_TO_WAIT = 1000;
                        if ((0, $f2lgg._)(this, _translationTimeoutId)) clearTimeout((0, $f2lgg._)(this, _translationTimeoutId));
                        (0, $5grPd._)(this, _translationTimeoutId, setTimeout(()=>{
                            (0, $5grPd._)(this, _translationTimeoutId, null);
                            (0, $f2lgg._)(this, _translation)[0] = (0, $f2lgg._)(this, _translation)[1] = 0;
                            this.addCommands({
                                cmd: ()=>{
                                    for (const editor of editors)if ((0, $f2lgg._)(this, _allEditors).has(editor.id)) editor.translateInPage(totalX, totalY);
                                },
                                undo: ()=>{
                                    for (const editor of editors)if ((0, $f2lgg._)(this, _allEditors).has(editor.id)) editor.translateInPage(-totalX, -totalY);
                                },
                                mustExec: false
                            });
                        }, TIME_TO_WAIT));
                        for (const editor of editors)editor.translateInPage(x, y);
                    }
                    setUpDragSession() {
                        if (!this.hasSelection) return;
                        this.disableUserSelect(true);
                        (0, $5grPd._)(this, _draggingEditors, new Map());
                        for (const editor of (0, $f2lgg._)(this, _selectedEditors))(0, $f2lgg._)(this, _draggingEditors).set(editor, {
                            savedX: editor.x,
                            savedY: editor.y,
                            savedPageIndex: editor.pageIndex,
                            newX: 0,
                            newY: 0,
                            newPageIndex: -1
                        });
                    }
                    endDragSession() {
                        if (!(0, $f2lgg._)(this, _draggingEditors)) return false;
                        this.disableUserSelect(false);
                        const map = (0, $f2lgg._)(this, _draggingEditors);
                        (0, $5grPd._)(this, _draggingEditors, null);
                        let mustBeAddedInUndoStack = false;
                        for (const [{ x, y, pageIndex }, value] of map){
                            value.newX = x;
                            value.newY = y;
                            value.newPageIndex = pageIndex;
                            mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex);
                        }
                        if (!mustBeAddedInUndoStack) return false;
                        const move = (editor, x, y, pageIndex)=>{
                            if ((0, $f2lgg._)(this, _allEditors).has(editor.id)) {
                                const parent = (0, $f2lgg._)(this, _allLayers).get(pageIndex);
                                if (parent) editor._setParentAndPosition(parent, x, y);
                                else {
                                    editor.pageIndex = pageIndex;
                                    editor.x = x;
                                    editor.y = y;
                                }
                            }
                        };
                        this.addCommands({
                            cmd: ()=>{
                                for (const [editor, { newX, newY, newPageIndex }] of map)move(editor, newX, newY, newPageIndex);
                            },
                            undo: ()=>{
                                for (const [editor, { savedX, savedY, savedPageIndex }] of map)move(editor, savedX, savedY, savedPageIndex);
                            },
                            mustExec: true
                        });
                        return true;
                    }
                    dragSelectedEditors(tx, ty) {
                        if (!(0, $f2lgg._)(this, _draggingEditors)) return;
                        for (const editor of (0, $f2lgg._)(this, _draggingEditors).keys())editor.drag(tx, ty);
                    }
                    rebuild(editor) {
                        if (editor.parent === null) {
                            const parent = this.getLayer(editor.pageIndex);
                            if (parent) {
                                parent.changeParent(editor);
                                parent.addOrRebuild(editor);
                            } else {
                                this.addEditor(editor);
                                this.addToAnnotationStorage(editor);
                                editor.rebuild();
                            }
                        } else editor.parent.addOrRebuild(editor);
                    }
                    isActive(editor) {
                        return (0, $f2lgg._)(this, _activeEditor) === editor;
                    }
                    getActive() {
                        return (0, $f2lgg._)(this, _activeEditor);
                    }
                    getMode() {
                        return (0, $f2lgg._)(this, _mode);
                    }
                    get imageManager() {
                        return (0, _util.shadow)(this, "imageManager", new ImageManager());
                    }
                    constructor(container, viewer, altTextManager, eventBus, pdfDocument, pageColors){
                        (0, $2IZAT._)(this, _addFocusManager);
                        (0, $2IZAT._)(this, _removeFocusManager);
                        (0, $2IZAT._)(this, _addKeyboardManager);
                        (0, $2IZAT._)(this, _removeKeyboardManager);
                        (0, $2IZAT._)(this, _addCopyPasteListeners);
                        (0, $2IZAT._)(this, _removeCopyPasteListeners);
                        (0, $2IZAT._)(this, _dispatchUpdateStates);
                        (0, $2IZAT._)(this, _dispatchUpdateUI);
                        (0, $2IZAT._)(this, _enableAll);
                        (0, $2IZAT._)(this, _disableAll);
                        (0, $2IZAT._)(this, _addEditorToLayer);
                        (0, $2IZAT._)(this, _isEmpty);
                        (0, $2IZAT._)(this, _selectEditors);
                        (0, $iXPoG._)(this, _activeEditor, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _allEditors, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _allLayers, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _altTextManager, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _annotationStorage, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _commandManager, {
                            writable: true,
                            value: new CommandManager()
                        });
                        (0, $iXPoG._)(this, _currentPageIndex, {
                            writable: true,
                            value: 0
                        });
                        (0, $iXPoG._)(this, _deletedAnnotationsElementIds, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $iXPoG._)(this, _draggingEditors, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _editorTypes, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _editorsToRescale, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $iXPoG._)(this, _filterFactory, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _idManager, {
                            writable: true,
                            value: new IdManager()
                        });
                        (0, $iXPoG._)(this, _isEnabled, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _isWaiting, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _lastActiveElement, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _mode, {
                            writable: true,
                            value: _util.AnnotationEditorType.NONE
                        });
                        (0, $iXPoG._)(this, _selectedEditors, {
                            writable: true,
                            value: new Set()
                        });
                        (0, $iXPoG._)(this, _pageColors, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _boundBlur, {
                            writable: true,
                            value: this.blur.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundFocus, {
                            writable: true,
                            value: this.focus.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundCopy, {
                            writable: true,
                            value: this.copy.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundCut, {
                            writable: true,
                            value: this.cut.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundPaste, {
                            writable: true,
                            value: this.paste.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundKeydown, {
                            writable: true,
                            value: this.keydown.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundOnEditingAction, {
                            writable: true,
                            value: this.onEditingAction.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundOnPageChanging, {
                            writable: true,
                            value: this.onPageChanging.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundOnScaleChanging, {
                            writable: true,
                            value: this.onScaleChanging.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundOnRotationChanging, {
                            writable: true,
                            value: this.onRotationChanging.bind(this)
                        });
                        (0, $iXPoG._)(this, _previousStates, {
                            writable: true,
                            value: {
                                isEditing: false,
                                isEmpty: true,
                                hasSomethingToUndo: false,
                                hasSomethingToRedo: false,
                                hasSelectedEditor: false
                            }
                        });
                        (0, $iXPoG._)(this, _translation, {
                            writable: true,
                            value: [
                                0,
                                0
                            ]
                        });
                        (0, $iXPoG._)(this, _translationTimeoutId, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _container, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _viewer, {
                            writable: true,
                            value: null
                        });
                        (0, $5grPd._)(this, _container, container);
                        (0, $5grPd._)(this, _viewer, viewer);
                        (0, $5grPd._)(this, _altTextManager, altTextManager);
                        this._eventBus = eventBus;
                        this._eventBus._on("editingaction", (0, $f2lgg._)(this, _boundOnEditingAction));
                        this._eventBus._on("pagechanging", (0, $f2lgg._)(this, _boundOnPageChanging));
                        this._eventBus._on("scalechanging", (0, $f2lgg._)(this, _boundOnScaleChanging));
                        this._eventBus._on("rotationchanging", (0, $f2lgg._)(this, _boundOnRotationChanging));
                        (0, $5grPd._)(this, _annotationStorage, pdfDocument.annotationStorage);
                        (0, $5grPd._)(this, _filterFactory, pdfDocument.filterFactory);
                        (0, $5grPd._)(this, _pageColors, pageColors);
                        this.viewParameters = {
                            realScale: _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS,
                            rotation: 0
                        };
                    }
                }
                (0, $yQrT8._)(AnnotationEditorUIManager, "TRANSLATE_SMALL", 1);
                (0, $yQrT8._)(AnnotationEditorUIManager, "TRANSLATE_BIG", 10);
                function addFocusManager() {
                    window.addEventListener("focus", (0, $f2lgg._)(this, _boundFocus));
                    window.addEventListener("blur", (0, $f2lgg._)(this, _boundBlur));
                }
                function removeFocusManager() {
                    window.removeEventListener("focus", (0, $f2lgg._)(this, _boundFocus));
                    window.removeEventListener("blur", (0, $f2lgg._)(this, _boundBlur));
                }
                function addKeyboardManager() {
                    window.addEventListener("keydown", (0, $f2lgg._)(this, _boundKeydown), {
                        capture: true
                    });
                }
                function removeKeyboardManager() {
                    window.removeEventListener("keydown", (0, $f2lgg._)(this, _boundKeydown), {
                        capture: true
                    });
                }
                function addCopyPasteListeners() {
                    document.addEventListener("copy", (0, $f2lgg._)(this, _boundCopy));
                    document.addEventListener("cut", (0, $f2lgg._)(this, _boundCut));
                    document.addEventListener("paste", (0, $f2lgg._)(this, _boundPaste));
                }
                function removeCopyPasteListeners() {
                    document.removeEventListener("copy", (0, $f2lgg._)(this, _boundCopy));
                    document.removeEventListener("cut", (0, $f2lgg._)(this, _boundCut));
                    document.removeEventListener("paste", (0, $f2lgg._)(this, _boundPaste));
                }
                function dispatchUpdateStates(details) {
                    const hasChanged = Object.entries(details).some(([key, value])=>(0, $f2lgg._)(this, _previousStates)[key] !== value);
                    if (hasChanged) this._eventBus.dispatch("annotationeditorstateschanged", {
                        source: this,
                        details: Object.assign((0, $f2lgg._)(this, _previousStates), details)
                    });
                }
                function dispatchUpdateUI(details) {
                    this._eventBus.dispatch("annotationeditorparamschanged", {
                        source: this,
                        details: details
                    });
                }
                function enableAll() {
                    if (!(0, $f2lgg._)(this, _isEnabled)) {
                        (0, $5grPd._)(this, _isEnabled, true);
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values())layer.enable();
                    }
                }
                function disableAll() {
                    this.unselectAll();
                    if ((0, $f2lgg._)(this, _isEnabled)) {
                        (0, $5grPd._)(this, _isEnabled, false);
                        for (const layer of (0, $f2lgg._)(this, _allLayers).values())layer.disable();
                    }
                }
                function addEditorToLayer(editor) {
                    const layer = (0, $f2lgg._)(this, _allLayers).get(editor.pageIndex);
                    if (layer) layer.addOrRebuild(editor);
                    else this.addEditor(editor);
                }
                function isEmpty() {
                    if ((0, $f2lgg._)(this, _allEditors).size === 0) return true;
                    if ((0, $f2lgg._)(this, _allEditors).size === 1) {
                        for (const editor of (0, $f2lgg._)(this, _allEditors).values())return editor.isEmpty();
                    }
                    return false;
                }
                function selectEditors(editors) {
                    (0, $f2lgg._)(this, _selectedEditors).clear();
                    for (const editor of editors){
                        if (editor.isEmpty()) continue;
                        (0, $f2lgg._)(this, _selectedEditors).add(editor);
                        editor.select();
                    }
                    (0, $hDjZy._)(this, _dispatchUpdateStates, dispatchUpdateStates).call(this, {
                        hasSelectedEditor: true
                    });
                }
                exports.AnnotationEditorUIManager = AnnotationEditorUIManager;
            /***/ },
            /* 6 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StatTimer = exports.RenderingCancelledException = exports.PixelsPerInch = exports.PageViewport = exports.PDFDateString = exports.DOMStandardFontDataFactory = exports.DOMSVGFactory = exports.DOMFilterFactory = exports.DOMCanvasFactory = exports.DOMCMapReaderFactory = void 0;
                exports.deprecated = deprecated;
                exports.getColorValues = getColorValues;
                exports.getCurrentTransform = getCurrentTransform;
                exports.getCurrentTransformInverse = getCurrentTransformInverse;
                exports.getFilenameFromUrl = getFilenameFromUrl;
                exports.getPdfFilenameFromUrl = getPdfFilenameFromUrl;
                exports.getRGB = getRGB1;
                exports.getXfaPageViewport = getXfaPageViewport;
                exports.isDataScheme = isDataScheme;
                exports.isPdfFile = isPdfFile;
                exports.isValidFetchUrl = isValidFetchUrl;
                exports.loadScript = loadScript;
                exports.noContextMenu = noContextMenu;
                exports.setLayerDimensions = setLayerDimensions;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const SVG_NS = "http://www.w3.org/2000/svg";
                class PixelsPerInch {
                }
                (0, $yQrT8._)(PixelsPerInch, "CSS", 96.0);
                (0, $yQrT8._)(PixelsPerInch, "PDF", 72.0);
                (0, $yQrT8._)(PixelsPerInch, "PDF_TO_CSS_UNITS", PixelsPerInch.CSS / PixelsPerInch.PDF);
                exports.PixelsPerInch = PixelsPerInch;
                var __cache = /*#__PURE__*/ new WeakMap(), __defs = /*#__PURE__*/ new WeakMap(), _docId = /*#__PURE__*/ new WeakMap(), _document = /*#__PURE__*/ new WeakMap(), _hcmFilter = /*#__PURE__*/ new WeakMap(), _hcmKey = /*#__PURE__*/ new WeakMap(), _hcmUrl = /*#__PURE__*/ new WeakMap(), _hcmHighlightFilter = /*#__PURE__*/ new WeakMap(), _hcmHighlightKey = /*#__PURE__*/ new WeakMap(), _hcmHighlightUrl = /*#__PURE__*/ new WeakMap(), _id = /*#__PURE__*/ new WeakMap(), _cache = /*#__PURE__*/ new WeakMap(), _defs = /*#__PURE__*/ new WeakMap(), _addGrayConversion = /*#__PURE__*/ new WeakSet(), _createFilter = /*#__PURE__*/ new WeakSet(), _appendFeFunc = /*#__PURE__*/ new WeakSet(), _addTransferMapConversion = /*#__PURE__*/ new WeakSet(), _getRGB = /*#__PURE__*/ new WeakSet();
                class DOMFilterFactory extends _base_factory.BaseFilterFactory {
                    addFilter(maps) {
                        if (!maps) return "none";
                        let value = (0, $f2lgg._)(this, _cache).get(maps);
                        if (value) return value;
                        let tableR, tableG, tableB, key;
                        if (maps.length === 1) {
                            const mapR = maps[0];
                            const buffer = new Array(256);
                            for(let i = 0; i < 256; i++)buffer[i] = mapR[i] / 255;
                            key = tableR = tableG = tableB = buffer.join(",");
                        } else {
                            const [mapR, mapG, mapB] = maps;
                            const bufferR = new Array(256);
                            const bufferG = new Array(256);
                            const bufferB = new Array(256);
                            for(let i = 0; i < 256; i++){
                                bufferR[i] = mapR[i] / 255;
                                bufferG[i] = mapG[i] / 255;
                                bufferB[i] = mapB[i] / 255;
                            }
                            tableR = bufferR.join(",");
                            tableG = bufferG.join(",");
                            tableB = bufferB.join(",");
                            key = `${tableR}${tableG}${tableB}`;
                        }
                        value = (0, $f2lgg._)(this, _cache).get(key);
                        if (value) {
                            (0, $f2lgg._)(this, _cache).set(maps, value);
                            return value;
                        }
                        const id = `g_${(0, $f2lgg._)(this, _docId)}_transfer_map_${(0, $kmaE3._)(this, _id).value++}`;
                        const url = `url(#${id})`;
                        (0, $f2lgg._)(this, _cache).set(maps, url);
                        (0, $f2lgg._)(this, _cache).set(key, url);
                        const filter = (0, $hDjZy._)(this, _createFilter, createFilter).call(this, id);
                        (0, $hDjZy._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, tableR, tableG, tableB, filter);
                        return url;
                    }
                    addHCMFilter(fgColor, bgColor) {
                        var _class_private_field_get1;
                        const key = `${fgColor}-${bgColor}`;
                        if ((0, $f2lgg._)(this, _hcmKey) === key) return (0, $f2lgg._)(this, _hcmUrl);
                        (0, $5grPd._)(this, _hcmKey, key);
                        (0, $5grPd._)(this, _hcmUrl, "none");
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _hcmFilter)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove();
                        if (!fgColor || !bgColor) return (0, $f2lgg._)(this, _hcmUrl);
                        const fgRGB = (0, $hDjZy._)(this, _getRGB, getRGB).call(this, fgColor);
                        fgColor = _util.Util.makeHexColor(...fgRGB);
                        const bgRGB = (0, $hDjZy._)(this, _getRGB, getRGB).call(this, bgColor);
                        bgColor = _util.Util.makeHexColor(...bgRGB);
                        (0, $f2lgg._)(this, _defs).style.color = "";
                        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) return (0, $f2lgg._)(this, _hcmUrl);
                        const map = new Array(256);
                        for(let i = 0; i <= 255; i++){
                            const x = i / 255;
                            map[i] = x <= 0.03928 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
                        }
                        const table = map.join(",");
                        const id = `g_${(0, $f2lgg._)(this, _docId)}_hcm_filter`;
                        const filter = (0, $5grPd._)(this, _hcmHighlightFilter, (0, $hDjZy._)(this, _createFilter, createFilter).call(this, id));
                        (0, $hDjZy._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, table, table, table, filter);
                        (0, $hDjZy._)(this, _addGrayConversion, addGrayConversion).call(this, filter);
                        const getSteps = (c, n)=>{
                            const start = fgRGB[c] / 255;
                            const end = bgRGB[c] / 255;
                            const arr = new Array(n + 1);
                            for(let i = 0; i <= n; i++)arr[i] = start + i / n * (end - start);
                            return arr.join(",");
                        };
                        (0, $hDjZy._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
                        (0, $5grPd._)(this, _hcmUrl, `url(#${id})`);
                        return (0, $f2lgg._)(this, _hcmUrl);
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        var _class_private_field_get1;
                        const key = `${fgColor}-${bgColor}-${newFgColor}-${newBgColor}`;
                        if ((0, $f2lgg._)(this, _hcmHighlightKey) === key) return (0, $f2lgg._)(this, _hcmHighlightUrl);
                        (0, $5grPd._)(this, _hcmHighlightKey, key);
                        (0, $5grPd._)(this, _hcmHighlightUrl, "none");
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _hcmHighlightFilter)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove();
                        if (!fgColor || !bgColor) return (0, $f2lgg._)(this, _hcmHighlightUrl);
                        const [fgRGB, bgRGB] = [
                            fgColor,
                            bgColor
                        ].map((0, $hDjZy._)(this, _getRGB, getRGB).bind(this));
                        let fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
                        let bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
                        let [newFgRGB, newBgRGB] = [
                            newFgColor,
                            newBgColor
                        ].map((0, $hDjZy._)(this, _getRGB, getRGB).bind(this));
                        if (bgGray < fgGray) [fgGray, bgGray, newFgRGB, newBgRGB] = [
                            bgGray,
                            fgGray,
                            newBgRGB,
                            newFgRGB
                        ];
                        (0, $f2lgg._)(this, _defs).style.color = "";
                        const getSteps = (fg, bg, n)=>{
                            const arr = new Array(256);
                            const step = (bgGray - fgGray) / n;
                            const newStart = fg / 255;
                            const newStep = (bg - fg) / (255 * n);
                            let prev = 0;
                            for(let i = 0; i <= n; i++){
                                const k = Math.round(fgGray + i * step);
                                const value = newStart + i * newStep;
                                for(let j = prev; j <= k; j++)arr[j] = value;
                                prev = k + 1;
                            }
                            for(let i = prev; i < 256; i++)arr[i] = arr[prev - 1];
                            return arr.join(",");
                        };
                        const id = `g_${(0, $f2lgg._)(this, _docId)}_hcm_highlight_filter`;
                        const filter = (0, $5grPd._)(this, _hcmHighlightFilter, (0, $hDjZy._)(this, _createFilter, createFilter).call(this, id));
                        (0, $hDjZy._)(this, _addGrayConversion, addGrayConversion).call(this, filter);
                        (0, $hDjZy._)(this, _addTransferMapConversion, addTransferMapConversion).call(this, getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
                        (0, $5grPd._)(this, _hcmHighlightUrl, `url(#${id})`);
                        return (0, $f2lgg._)(this, _hcmHighlightUrl);
                    }
                    destroy(keepHCM = false) {
                        if (keepHCM && ((0, $f2lgg._)(this, _hcmUrl) || (0, $f2lgg._)(this, _hcmHighlightUrl))) return;
                        if ((0, $f2lgg._)(this, __defs)) {
                            (0, $f2lgg._)(this, __defs).parentNode.parentNode.remove();
                            (0, $5grPd._)(this, __defs, null);
                        }
                        if ((0, $f2lgg._)(this, __cache)) {
                            (0, $f2lgg._)(this, __cache).clear();
                            (0, $5grPd._)(this, __cache, null);
                        }
                        (0, $5grPd._)(this, _id, 0);
                    }
                    constructor({ docId, ownerDocument = globalThis.document } = {}){
                        super(), (0, $iXPoG._)(this, _cache, {
                            get: get_cache,
                            set: void 0
                        }), (0, $iXPoG._)(this, _defs, {
                            get: get_defs,
                            set: void 0
                        }), (0, $2IZAT._)(this, _addGrayConversion), (0, $2IZAT._)(this, _createFilter), (0, $2IZAT._)(this, _appendFeFunc), (0, $2IZAT._)(this, _addTransferMapConversion), (0, $2IZAT._)(this, _getRGB), (0, $iXPoG._)(this, __cache, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, __defs, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _docId, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _document, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmFilter, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmKey, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmUrl, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmHighlightFilter, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmHighlightKey, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _hcmHighlightUrl, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _id, {
                            writable: true,
                            value: 0
                        });
                        (0, $5grPd._)(this, _docId, docId);
                        (0, $5grPd._)(this, _document, ownerDocument);
                    }
                }
                function get_cache() {
                    return (0, $5grPd._)(this, __cache, (0, $f2lgg._)(this, __cache) || new Map());
                }
                function get_defs() {
                    if (!(0, $f2lgg._)(this, __defs)) {
                        const div = (0, $f2lgg._)(this, _document).createElement("div");
                        const { style } = div;
                        style.visibility = "hidden";
                        style.contain = "strict";
                        style.width = style.height = 0;
                        style.position = "absolute";
                        style.top = style.left = 0;
                        style.zIndex = -1;
                        const svg = (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, "svg");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        (0, $5grPd._)(this, __defs, (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, "defs"));
                        div.append(svg);
                        svg.append((0, $f2lgg._)(this, __defs));
                        (0, $f2lgg._)(this, _document).body.append(div);
                    }
                    return (0, $f2lgg._)(this, __defs);
                }
                function addGrayConversion(filter) {
                    const feColorMatrix = (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, "feColorMatrix");
                    feColorMatrix.setAttribute("type", "matrix");
                    feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
                    filter.append(feColorMatrix);
                }
                function createFilter(id) {
                    const filter = (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, "filter");
                    filter.setAttribute("color-interpolation-filters", "sRGB");
                    filter.setAttribute("id", id);
                    (0, $f2lgg._)(this, _defs).append(filter);
                    return filter;
                }
                function appendFeFunc(feComponentTransfer, func, table) {
                    const feFunc = (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, func);
                    feFunc.setAttribute("type", "discrete");
                    feFunc.setAttribute("tableValues", table);
                    feComponentTransfer.append(feFunc);
                }
                function addTransferMapConversion(rTable, gTable, bTable, filter) {
                    const feComponentTransfer = (0, $f2lgg._)(this, _document).createElementNS(SVG_NS, "feComponentTransfer");
                    filter.append(feComponentTransfer);
                    (0, $hDjZy._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncR", rTable);
                    (0, $hDjZy._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncG", gTable);
                    (0, $hDjZy._)(this, _appendFeFunc, appendFeFunc).call(this, feComponentTransfer, "feFuncB", bTable);
                }
                function getRGB(color) {
                    (0, $f2lgg._)(this, _defs).style.color = color;
                    return getRGB1(getComputedStyle((0, $f2lgg._)(this, _defs)).getPropertyValue("color"));
                }
                exports.DOMFilterFactory = DOMFilterFactory;
                class DOMCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const canvas = this._document.createElement("canvas");
                        canvas.width = width;
                        canvas.height = height;
                        return canvas;
                    }
                    constructor({ ownerDocument = globalThis.document } = {}){
                        super();
                        this._document = ownerDocument;
                    }
                }
                exports.DOMCanvasFactory = DOMCanvasFactory;
                function fetchData(url, asTypedArray = false) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        if (isValidFetchUrl(url, document.baseURI)) {
                            const response = yield fetch(url);
                            if (!response.ok) throw new Error(response.statusText);
                            return asTypedArray ? new Uint8Array((yield response.arrayBuffer())) : (0, _util.stringToBytes)((yield response.text()));
                        }
                        return new Promise((resolve, reject)=>{
                            const request = new XMLHttpRequest();
                            request.open("GET", url, true);
                            if (asTypedArray) request.responseType = "arraybuffer";
                            request.onreadystatechange = ()=>{
                                if (request.readyState !== XMLHttpRequest.DONE) return;
                                if (request.status === 200 || request.status === 0) {
                                    let data;
                                    if (asTypedArray && request.response) data = new Uint8Array(request.response);
                                    else if (!asTypedArray && request.responseText) data = (0, _util.stringToBytes)(request.responseText);
                                    if (data) {
                                        resolve(data);
                                        return;
                                    }
                                }
                                reject(new Error(request.statusText));
                            };
                            request.send(null);
                        });
                    })();
                }
                class DOMCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url, this.isCompressed).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.DOMCMapReaderFactory = DOMCMapReaderFactory;
                class DOMStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url, true);
                    }
                }
                exports.DOMStandardFontDataFactory = DOMStandardFontDataFactory;
                class DOMSVGFactory extends _base_factory.BaseSVGFactory {
                    _createSVG(type) {
                        return document.createElementNS(SVG_NS, type);
                    }
                }
                exports.DOMSVGFactory = DOMSVGFactory;
                class PageViewport {
                    get rawDims() {
                        const { viewBox } = this;
                        return (0, _util.shadow)(this, "rawDims", {
                            pageWidth: viewBox[2] - viewBox[0],
                            pageHeight: viewBox[3] - viewBox[1],
                            pageX: viewBox[0],
                            pageY: viewBox[1]
                        });
                    }
                    clone({ scale = this.scale, rotation = this.rotation, offsetX = this.offsetX, offsetY = this.offsetY, dontFlip = false } = {}) {
                        return new PageViewport({
                            viewBox: this.viewBox.slice(),
                            scale: scale,
                            rotation: rotation,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            dontFlip: dontFlip
                        });
                    }
                    convertToViewportPoint(x, y) {
                        return _util.Util.applyTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    convertToViewportRectangle(rect) {
                        const topLeft = _util.Util.applyTransform([
                            rect[0],
                            rect[1]
                        ], this.transform);
                        const bottomRight = _util.Util.applyTransform([
                            rect[2],
                            rect[3]
                        ], this.transform);
                        return [
                            topLeft[0],
                            topLeft[1],
                            bottomRight[0],
                            bottomRight[1]
                        ];
                    }
                    convertToPdfPoint(x, y) {
                        return _util.Util.applyInverseTransform([
                            x,
                            y
                        ], this.transform);
                    }
                    constructor({ viewBox, scale, rotation, offsetX = 0, offsetY = 0, dontFlip = false }){
                        this.viewBox = viewBox;
                        this.scale = scale;
                        this.rotation = rotation;
                        this.offsetX = offsetX;
                        this.offsetY = offsetY;
                        const centerX = (viewBox[2] + viewBox[0]) / 2;
                        const centerY = (viewBox[3] + viewBox[1]) / 2;
                        let rotateA, rotateB, rotateC, rotateD;
                        rotation %= 360;
                        if (rotation < 0) rotation += 360;
                        switch(rotation){
                            case 180:
                                rotateA = -1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = 1;
                                break;
                            case 90:
                                rotateA = 0;
                                rotateB = 1;
                                rotateC = 1;
                                rotateD = 0;
                                break;
                            case 270:
                                rotateA = 0;
                                rotateB = -1;
                                rotateC = -1;
                                rotateD = 0;
                                break;
                            case 0:
                                rotateA = 1;
                                rotateB = 0;
                                rotateC = 0;
                                rotateD = -1;
                                break;
                            default:
                                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
                        }
                        if (dontFlip) {
                            rotateC = -rotateC;
                            rotateD = -rotateD;
                        }
                        let offsetCanvasX, offsetCanvasY;
                        let width, height;
                        if (rotateA === 0) {
                            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
                            width = (viewBox[3] - viewBox[1]) * scale;
                            height = (viewBox[2] - viewBox[0]) * scale;
                        } else {
                            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
                            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
                            width = (viewBox[2] - viewBox[0]) * scale;
                            height = (viewBox[3] - viewBox[1]) * scale;
                        }
                        this.transform = [
                            rotateA * scale,
                            rotateB * scale,
                            rotateC * scale,
                            rotateD * scale,
                            offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY,
                            offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY
                        ];
                        this.width = width;
                        this.height = height;
                    }
                }
                exports.PageViewport = PageViewport;
                class RenderingCancelledException extends _util.BaseException {
                    constructor(msg, extraDelay = 0){
                        super(msg, "RenderingCancelledException");
                        this.extraDelay = extraDelay;
                    }
                }
                exports.RenderingCancelledException = RenderingCancelledException;
                function isDataScheme(url) {
                    const ii = url.length;
                    let i = 0;
                    while(i < ii && url[i].trim() === "")i++;
                    return url.substring(i, i + 5).toLowerCase() === "data:";
                }
                function isPdfFile(filename) {
                    return typeof filename === "string" && /\.pdf$/i.test(filename);
                }
                function getFilenameFromUrl(url, onlyStripPath = false) {
                    if (!onlyStripPath) [url] = url.split(/[#?]/, 1);
                    return url.substring(url.lastIndexOf("/") + 1);
                }
                function getPdfFilenameFromUrl(url, defaultFilename = "document.pdf") {
                    if (typeof url !== "string") return defaultFilename;
                    if (isDataScheme(url)) {
                        (0, _util.warn)('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
                        return defaultFilename;
                    }
                    const reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
                    const reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
                    const splitURI = reURI.exec(url);
                    let suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
                    if (suggestedFilename) {
                        suggestedFilename = suggestedFilename[0];
                        if (suggestedFilename.includes("%")) try {
                            suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
                        } catch (e) {}
                    }
                    return suggestedFilename || defaultFilename;
                }
                class StatTimer {
                    time(name) {
                        if (name in this.started) (0, _util.warn)(`Timer is already running for ${name}`);
                        this.started[name] = Date.now();
                    }
                    timeEnd(name) {
                        if (!(name in this.started)) (0, _util.warn)(`Timer has not been started for ${name}`);
                        this.times.push({
                            name: name,
                            start: this.started[name],
                            end: Date.now()
                        });
                        delete this.started[name];
                    }
                    toString() {
                        const outBuf = [];
                        let longest = 0;
                        for (const { name } of this.times)longest = Math.max(name.length, longest);
                        for (const { name, start, end } of this.times)outBuf.push(`${name.padEnd(longest)} ${end - start}ms\n`);
                        return outBuf.join("");
                    }
                    constructor(){
                        (0, $yQrT8._)(this, "started", Object.create(null));
                        (0, $yQrT8._)(this, "times", []);
                    }
                }
                exports.StatTimer = StatTimer;
                function isValidFetchUrl(url, baseUrl) {
                    try {
                        const { protocol } = baseUrl ? new URL(url, baseUrl) : new URL(url);
                        return protocol === "http:" || protocol === "https:";
                    } catch (e) {
                        return false;
                    }
                }
                function noContextMenu(e) {
                    e.preventDefault();
                }
                function loadScript(src, removeScriptElement = false) {
                    return new Promise((resolve, reject)=>{
                        const script = document.createElement("script");
                        script.src = src;
                        script.onload = function(evt) {
                            if (removeScriptElement) script.remove();
                            resolve(evt);
                        };
                        script.onerror = function() {
                            reject(new Error(`Cannot load script at: ${script.src}`));
                        };
                        (document.head || document.documentElement).append(script);
                    });
                }
                function deprecated(details) {
                    console.log("Deprecated API usage: " + details);
                }
                let pdfDateStringRegex;
                class PDFDateString {
                    static toDateObject(input) {
                        if (!input || typeof input !== "string") return null;
                        pdfDateStringRegex || (pdfDateStringRegex = new RegExp("^D:(\\d{4})(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?(\\d{2})?([Z|+|-])?(\\d{2})?'?(\\d{2})?'?"));
                        const matches = pdfDateStringRegex.exec(input);
                        if (!matches) return null;
                        const year = parseInt(matches[1], 10);
                        let month = parseInt(matches[2], 10);
                        month = month >= 1 && month <= 12 ? month - 1 : 0;
                        let day = parseInt(matches[3], 10);
                        day = day >= 1 && day <= 31 ? day : 1;
                        let hour = parseInt(matches[4], 10);
                        hour = hour >= 0 && hour <= 23 ? hour : 0;
                        let minute = parseInt(matches[5], 10);
                        minute = minute >= 0 && minute <= 59 ? minute : 0;
                        let second = parseInt(matches[6], 10);
                        second = second >= 0 && second <= 59 ? second : 0;
                        const universalTimeRelation = matches[7] || "Z";
                        let offsetHour = parseInt(matches[8], 10);
                        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
                        let offsetMinute = parseInt(matches[9], 10) || 0;
                        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
                        if (universalTimeRelation === "-") {
                            hour += offsetHour;
                            minute += offsetMinute;
                        } else if (universalTimeRelation === "+") {
                            hour -= offsetHour;
                            minute -= offsetMinute;
                        }
                        return new Date(Date.UTC(year, month, day, hour, minute, second));
                    }
                }
                exports.PDFDateString = PDFDateString;
                function getXfaPageViewport(xfaPage, { scale = 1, rotation = 0 }) {
                    const { width, height } = xfaPage.attributes.style;
                    const viewBox = [
                        0,
                        0,
                        parseInt(width),
                        parseInt(height)
                    ];
                    return new PageViewport({
                        viewBox: viewBox,
                        scale: scale,
                        rotation: rotation
                    });
                }
                function getRGB1(color) {
                    if (color.startsWith("#")) {
                        const colorRGB = parseInt(color.slice(1), 16);
                        return [
                            (colorRGB & 0xff0000) >> 16,
                            (colorRGB & 0x00ff00) >> 8,
                            colorRGB & 0x0000ff
                        ];
                    }
                    if (color.startsWith("rgb(")) return color.slice(4, -1).split(",").map((x)=>parseInt(x));
                    if (color.startsWith("rgba(")) return color.slice(5, -1).split(",").map((x)=>parseInt(x)).slice(0, 3);
                    (0, _util.warn)(`Not a valid color format: "${color}"`);
                    return [
                        0,
                        0,
                        0
                    ];
                }
                function getColorValues(colors) {
                    const span = document.createElement("span");
                    span.style.visibility = "hidden";
                    document.body.append(span);
                    for (const name of colors.keys()){
                        span.style.color = name;
                        const computedColor = window.getComputedStyle(span).color;
                        colors.set(name, getRGB1(computedColor));
                    }
                    span.remove();
                }
                function getCurrentTransform(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function getCurrentTransformInverse(ctx) {
                    const { a, b, c, d, e, f } = ctx.getTransform().invertSelf();
                    return [
                        a,
                        b,
                        c,
                        d,
                        e,
                        f
                    ];
                }
                function setLayerDimensions(div, viewport, mustFlip = false, mustRotate = true) {
                    if (viewport instanceof PageViewport) {
                        const { pageWidth, pageHeight } = viewport.rawDims;
                        const { style } = div;
                        const useRound = _util.FeatureTest.isCSSRoundSupported;
                        const w = `var(--scale-factor) * ${pageWidth}px`, h = `var(--scale-factor) * ${pageHeight}px`;
                        const widthStr = useRound ? `round(${w}, 1px)` : `calc(${w})`, heightStr = useRound ? `round(${h}, 1px)` : `calc(${h})`;
                        if (!mustFlip || viewport.rotation % 180 === 0) {
                            style.width = widthStr;
                            style.height = heightStr;
                        } else {
                            style.width = heightStr;
                            style.height = widthStr;
                        }
                    }
                    if (mustRotate) div.setAttribute("data-main-rotation", viewport.rotation);
                }
            /***/ },
            /* 7 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.BaseStandardFontDataFactory = exports.BaseSVGFactory = exports.BaseFilterFactory = exports.BaseCanvasFactory = exports.BaseCMapReaderFactory = void 0;
                var _util = __w_pdfjs_require__(1);
                class BaseFilterFactory {
                    addFilter(maps) {
                        return "none";
                    }
                    addHCMFilter(fgColor, bgColor) {
                        return "none";
                    }
                    addHighlightHCMFilter(fgColor, bgColor, newFgColor, newBgColor) {
                        return "none";
                    }
                    destroy(keepHCM = false) {}
                    constructor(){
                        if (this.constructor === BaseFilterFactory) (0, _util.unreachable)("Cannot initialize BaseFilterFactory.");
                    }
                }
                exports.BaseFilterFactory = BaseFilterFactory;
                class BaseCanvasFactory {
                    create(width, height) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        const canvas = this._createCanvas(width, height);
                        return {
                            canvas: canvas,
                            context: canvas.getContext("2d")
                        };
                    }
                    reset(canvasAndContext, width, height) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        if (width <= 0 || height <= 0) throw new Error("Invalid canvas size");
                        canvasAndContext.canvas.width = width;
                        canvasAndContext.canvas.height = height;
                    }
                    destroy(canvasAndContext) {
                        if (!canvasAndContext.canvas) throw new Error("Canvas is not specified");
                        canvasAndContext.canvas.width = 0;
                        canvasAndContext.canvas.height = 0;
                        canvasAndContext.canvas = null;
                        canvasAndContext.context = null;
                    }
                    _createCanvas(width, height) {
                        (0, _util.unreachable)("Abstract method `_createCanvas` called.");
                    }
                    constructor(){
                        if (this.constructor === BaseCanvasFactory) (0, _util.unreachable)("Cannot initialize BaseCanvasFactory.");
                    }
                }
                exports.BaseCanvasFactory = BaseCanvasFactory;
                class BaseCMapReaderFactory {
                    fetch(_0) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*({ name }) {
                            if (!this.baseUrl) throw new Error('The CMap "baseUrl" parameter must be specified, ensure that the "cMapUrl" and "cMapPacked" API parameters are provided.');
                            if (!name) throw new Error("CMap name must be specified.");
                            const url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                            const compressionType = this.isCompressed ? _util.CMapCompressionType.BINARY : _util.CMapCompressionType.NONE;
                            return this._fetchData(url, compressionType).catch((reason)=>{
                                throw new Error(`Unable to load ${this.isCompressed ? "binary " : ""}CMap at: ${url}`);
                            });
                        }).apply(this, arguments);
                    }
                    _fetchData(url, compressionType) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                    constructor({ baseUrl = null, isCompressed = true }){
                        if (this.constructor === BaseCMapReaderFactory) (0, _util.unreachable)("Cannot initialize BaseCMapReaderFactory.");
                        this.baseUrl = baseUrl;
                        this.isCompressed = isCompressed;
                    }
                }
                exports.BaseCMapReaderFactory = BaseCMapReaderFactory;
                class BaseStandardFontDataFactory {
                    fetch(_0) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*({ filename }) {
                            if (!this.baseUrl) throw new Error('The standard font "baseUrl" parameter must be specified, ensure that the "standardFontDataUrl" API parameter is provided.');
                            if (!filename) throw new Error("Font filename must be specified.");
                            const url = `${this.baseUrl}${filename}`;
                            return this._fetchData(url).catch((reason)=>{
                                throw new Error(`Unable to load font data at: ${url}`);
                            });
                        }).apply(this, arguments);
                    }
                    _fetchData(url) {
                        (0, _util.unreachable)("Abstract method `_fetchData` called.");
                    }
                    constructor({ baseUrl = null }){
                        if (this.constructor === BaseStandardFontDataFactory) (0, _util.unreachable)("Cannot initialize BaseStandardFontDataFactory.");
                        this.baseUrl = baseUrl;
                    }
                }
                exports.BaseStandardFontDataFactory = BaseStandardFontDataFactory;
                class BaseSVGFactory {
                    create(width, height, skipDimensions = false) {
                        if (width <= 0 || height <= 0) throw new Error("Invalid SVG dimensions");
                        const svg = this._createSVG("svg:svg");
                        svg.setAttribute("version", "1.1");
                        if (!skipDimensions) {
                            svg.setAttribute("width", `${width}px`);
                            svg.setAttribute("height", `${height}px`);
                        }
                        svg.setAttribute("preserveAspectRatio", "none");
                        svg.setAttribute("viewBox", `0 0 ${width} ${height}`);
                        return svg;
                    }
                    createElement(type) {
                        if (typeof type !== "string") throw new Error("Invalid SVG element type");
                        return this._createSVG(type);
                    }
                    _createSVG(type) {
                        (0, _util.unreachable)("Abstract method `_createSVG` called.");
                    }
                    constructor(){
                        if (this.constructor === BaseSVGFactory) (0, _util.unreachable)("Cannot initialize BaseSVGFactory.");
                    }
                }
                exports.BaseSVGFactory = BaseSVGFactory;
            /***/ },
            /* 8 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MurmurHash3_64 = void 0;
                var _util = __w_pdfjs_require__(1);
                const SEED = 0xc3d2e1f0;
                const MASK_HIGH = 0xffff0000;
                const MASK_LOW = 0xffff;
                class MurmurHash3_64 {
                    update(input) {
                        let data, length;
                        if (typeof input === "string") {
                            data = new Uint8Array(input.length * 2);
                            length = 0;
                            for(let i = 0, ii = input.length; i < ii; i++){
                                const code = input.charCodeAt(i);
                                if (code <= 0xff) data[length++] = code;
                                else {
                                    data[length++] = code >>> 8;
                                    data[length++] = code & 0xff;
                                }
                            }
                        } else if ((0, _util.isArrayBuffer)(input)) {
                            data = input.slice();
                            length = data.byteLength;
                        } else throw new Error("Wrong data format in MurmurHash3_64_update. Input must be a string or array.");
                        const blockCounts = length >> 2;
                        const tailLength = length - blockCounts * 4;
                        const dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
                        let k1 = 0, k2 = 0;
                        let h1 = this.h1, h2 = this.h2;
                        const C1 = 0xcc9e2d51, C2 = 0x1b873593;
                        const C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
                        for(let i = 0; i < blockCounts; i++)if (i & 1) {
                            k1 = dataUint32[i];
                            k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                            k1 = k1 << 15 | k1 >>> 17;
                            k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                            h1 ^= k1;
                            h1 = h1 << 13 | h1 >>> 19;
                            h1 = h1 * 5 + 0xe6546b64;
                        } else {
                            k2 = dataUint32[i];
                            k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                            k2 = k2 << 15 | k2 >>> 17;
                            k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                            h2 ^= k2;
                            h2 = h2 << 13 | h2 >>> 19;
                            h2 = h2 * 5 + 0xe6546b64;
                        }
                        k1 = 0;
                        switch(tailLength){
                            case 3:
                                k1 ^= data[blockCounts * 4 + 2] << 16;
                            case 2:
                                k1 ^= data[blockCounts * 4 + 1] << 8;
                            case 1:
                                k1 ^= data[blockCounts * 4];
                                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                                k1 = k1 << 15 | k1 >>> 17;
                                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                                if (blockCounts & 1) h1 ^= k1;
                                else h2 ^= k1;
                        }
                        this.h1 = h1;
                        this.h2 = h2;
                    }
                    hexdigest() {
                        let h1 = this.h1, h2 = this.h2;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
                        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
                        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
                        h1 ^= h2 >>> 1;
                        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
                    }
                    constructor(seed){
                        this.h1 = seed ? seed & 0xffffffff : SEED;
                        this.h2 = seed ? seed & 0xffffffff : SEED;
                    }
                }
                exports.MurmurHash3_64 = MurmurHash3_64;
            /***/ },
            /* 9 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FontLoader = exports.FontFaceObject = void 0;
                var _util = __w_pdfjs_require__(1);
                var _systemFonts = /*#__PURE__*/ new WeakMap();
                class FontLoader {
                    addNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.add(nativeFontFace);
                        this._document.fonts.add(nativeFontFace);
                    }
                    removeNativeFontFace(nativeFontFace) {
                        this.nativeFontFaces.delete(nativeFontFace);
                        this._document.fonts.delete(nativeFontFace);
                    }
                    insertRule(rule) {
                        if (!this.styleElement) {
                            this.styleElement = this._document.createElement("style");
                            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
                        }
                        const styleSheet = this.styleElement.sheet;
                        styleSheet.insertRule(rule, styleSheet.cssRules.length);
                    }
                    clear() {
                        for (const nativeFontFace of this.nativeFontFaces)this._document.fonts.delete(nativeFontFace);
                        this.nativeFontFaces.clear();
                        (0, $f2lgg._)(this, _systemFonts).clear();
                        if (this.styleElement) {
                            this.styleElement.remove();
                            this.styleElement = null;
                        }
                    }
                    loadSystemFont(info) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (!info || (0, $f2lgg._)(this, _systemFonts).has(info.loadedName)) return;
                            (0, _util.assert)(!this.disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                            if (this.isFontLoadingAPISupported) {
                                const { loadedName, src, style } = info;
                                const fontFace = new FontFace(loadedName, src, style);
                                this.addNativeFontFace(fontFace);
                                try {
                                    yield fontFace.load();
                                    (0, $f2lgg._)(this, _systemFonts).add(loadedName);
                                } catch (e) {
                                    (0, _util.warn)(`Cannot load system font: ${info.baseFontName}, installing it could help to improve PDF rendering.`);
                                    this.removeNativeFontFace(fontFace);
                                }
                                return;
                            }
                            (0, _util.unreachable)("Not implemented: loadSystemFont without the Font Loading API.");
                        }).call(this);
                    }
                    bind(font) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (font.attached || font.missingFile && !font.systemFontInfo) return;
                            font.attached = true;
                            if (font.systemFontInfo) {
                                yield this.loadSystemFont(font.systemFontInfo);
                                return;
                            }
                            if (this.isFontLoadingAPISupported) {
                                const nativeFontFace = font.createNativeFontFace();
                                if (nativeFontFace) {
                                    this.addNativeFontFace(nativeFontFace);
                                    try {
                                        yield nativeFontFace.loaded;
                                    } catch (ex) {
                                        (0, _util.warn)(`Failed to load font '${nativeFontFace.family}': '${ex}'.`);
                                        font.disableFontFace = true;
                                        throw ex;
                                    }
                                }
                                return;
                            }
                            const rule = font.createFontFaceRule();
                            if (rule) {
                                this.insertRule(rule);
                                if (this.isSyncFontLoadingSupported) return;
                                yield new Promise((resolve)=>{
                                    const request = this._queueLoadingCallback(resolve);
                                    this._prepareFontLoadEvent(font, request);
                                });
                            }
                        }).call(this);
                    }
                    get isFontLoadingAPISupported() {
                        var _this__document;
                        const hasFonts = !!((_this__document = this._document) === null || _this__document === void 0 ? void 0 : _this__document.fonts);
                        return (0, _util.shadow)(this, "isFontLoadingAPISupported", hasFonts);
                    }
                    get isSyncFontLoadingSupported() {
                        let supported = false;
                        if (_util.isNodeJS) supported = true;
                        else if (typeof navigator !== "undefined" && /Mozilla\/5.0.*?rv:\d+.*? Gecko/.test(navigator.userAgent)) supported = true;
                        return (0, _util.shadow)(this, "isSyncFontLoadingSupported", supported);
                    }
                    _queueLoadingCallback(callback) {
                        function completeRequest() {
                            (0, _util.assert)(!request.done, "completeRequest() cannot be called twice.");
                            request.done = true;
                            while(loadingRequests.length > 0 && loadingRequests[0].done){
                                const otherRequest = loadingRequests.shift();
                                setTimeout(otherRequest.callback, 0);
                            }
                        }
                        const { loadingRequests } = this;
                        const request = {
                            done: false,
                            complete: completeRequest,
                            callback: callback
                        };
                        loadingRequests.push(request);
                        return request;
                    }
                    get _loadTestFont() {
                        const testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQAFQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAAALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgAAAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACMAooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4DIP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAAAAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUAAQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgABAAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABYAAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAAAC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAAAAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQACAQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTjFQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
                        return (0, _util.shadow)(this, "_loadTestFont", testFont);
                    }
                    _prepareFontLoadEvent(font, request) {
                        function int32(data, offset) {
                            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
                        }
                        function spliceString(s, offset, remove, insert) {
                            const chunk1 = s.substring(0, offset);
                            const chunk2 = s.substring(offset + remove);
                            return chunk1 + insert + chunk2;
                        }
                        let i, ii;
                        const canvas = this._document.createElement("canvas");
                        canvas.width = 1;
                        canvas.height = 1;
                        const ctx = canvas.getContext("2d");
                        let called = 0;
                        function isFontReady(name, callback) {
                            if (++called > 30) {
                                (0, _util.warn)("Load test font never loaded.");
                                callback();
                                return;
                            }
                            ctx.font = "30px " + name;
                            ctx.fillText(".", 0, 20);
                            const imageData = ctx.getImageData(0, 0, 1, 1);
                            if (imageData.data[3] > 0) {
                                callback();
                                return;
                            }
                            setTimeout(isFontReady.bind(null, name, callback));
                        }
                        const loadTestFontId = `lt${Date.now()}${this.loadTestFontId++}`;
                        let data = this._loadTestFont;
                        const COMMENT_OFFSET = 976;
                        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
                        const CFF_CHECKSUM_OFFSET = 16;
                        const XXXX_VALUE = 0x58585858;
                        let checksum = int32(data, CFF_CHECKSUM_OFFSET);
                        for(i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4)checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
                        if (i < loadTestFontId.length) checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
                        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, (0, _util.string32)(checksum));
                        const url = `url(data:font/opentype;base64,${btoa(data)});`;
                        const rule = `@font-face {font-family:"${loadTestFontId}";src:${url}}`;
                        this.insertRule(rule);
                        const div = this._document.createElement("div");
                        div.style.visibility = "hidden";
                        div.style.width = div.style.height = "10px";
                        div.style.position = "absolute";
                        div.style.top = div.style.left = "0px";
                        for (const name of [
                            font.loadedName,
                            loadTestFontId
                        ]){
                            const span = this._document.createElement("span");
                            span.textContent = "Hi";
                            span.style.fontFamily = name;
                            div.append(span);
                        }
                        this._document.body.append(div);
                        isFontReady(loadTestFontId, ()=>{
                            div.remove();
                            request.complete();
                        });
                    }
                    constructor({ ownerDocument = globalThis.document, styleElement = null }){
                        (0, $iXPoG._)(this, _systemFonts, {
                            writable: true,
                            value: new Set()
                        });
                        this._document = ownerDocument;
                        this.nativeFontFaces = new Set();
                        this.styleElement = null;
                        this.loadingRequests = [];
                        this.loadTestFontId = 0;
                    }
                }
                exports.FontLoader = FontLoader;
                class FontFaceObject {
                    createNativeFontFace() {
                        var _this__inspectFont, _this;
                        if (!this.data || this.disableFontFace) return null;
                        let nativeFontFace;
                        if (!this.cssFontInfo) nativeFontFace = new FontFace(this.loadedName, this.data, {});
                        else {
                            const css = {
                                weight: this.cssFontInfo.fontWeight
                            };
                            if (this.cssFontInfo.italicAngle) css.style = `oblique ${this.cssFontInfo.italicAngle}deg`;
                            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
                        }
                        (_this__inspectFont = (_this = this)._inspectFont) === null || _this__inspectFont === void 0 ? void 0 : _this__inspectFont.call(_this, this);
                        return nativeFontFace;
                    }
                    createFontFaceRule() {
                        var _this__inspectFont, _this;
                        if (!this.data || this.disableFontFace) return null;
                        const data = (0, _util.bytesToString)(this.data);
                        const url = `url(data:${this.mimetype};base64,${btoa(data)});`;
                        let rule;
                        if (!this.cssFontInfo) rule = `@font-face {font-family:"${this.loadedName}";src:${url}}`;
                        else {
                            let css = `font-weight: ${this.cssFontInfo.fontWeight};`;
                            if (this.cssFontInfo.italicAngle) css += `font-style: oblique ${this.cssFontInfo.italicAngle}deg;`;
                            rule = `@font-face {font-family:"${this.cssFontInfo.fontFamily}";${css}src:${url}}`;
                        }
                        (_this__inspectFont = (_this = this)._inspectFont) === null || _this__inspectFont === void 0 ? void 0 : _this__inspectFont.call(_this, this, url);
                        return rule;
                    }
                    getPathGenerator(objs, character) {
                        if (this.compiledGlyphs[character] !== undefined) return this.compiledGlyphs[character];
                        let cmds;
                        try {
                            cmds = objs.get(this.loadedName + "_path_" + character);
                        } catch (ex) {
                            if (!this.ignoreErrors) throw ex;
                            (0, _util.warn)(`getPathGenerator - ignoring character: "${ex}".`);
                            return this.compiledGlyphs[character] = function(c, size) {};
                        }
                        if (this.isEvalSupported && _util.FeatureTest.isEvalSupported) {
                            const jsBuf = [];
                            for (const current of cmds){
                                const args = current.args !== undefined ? current.args.join(",") : "";
                                jsBuf.push("c.", current.cmd, "(", args, ");\n");
                            }
                            return this.compiledGlyphs[character] = new Function("c", "size", jsBuf.join(""));
                        }
                        return this.compiledGlyphs[character] = function(c, size) {
                            for (const current of cmds){
                                if (current.cmd === "scale") current.args = [
                                    size,
                                    -size
                                ];
                                c[current.cmd].apply(c, current.args);
                            }
                        };
                    }
                    constructor(translatedData, { isEvalSupported = true, disableFontFace = false, ignoreErrors = false, inspectFont = null }){
                        this.compiledGlyphs = Object.create(null);
                        for(const i in translatedData)this[i] = translatedData[i];
                        this.isEvalSupported = isEvalSupported !== false;
                        this.disableFontFace = disableFontFace === true;
                        this.ignoreErrors = ignoreErrors === true;
                        this._inspectFont = inspectFont;
                    }
                }
                exports.FontFaceObject = FontFaceObject;
            /***/ },
            /* 10 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NodeStandardFontDataFactory = exports.NodeFilterFactory = exports.NodeCanvasFactory = exports.NodeCMapReaderFactory = void 0;
                var _base_factory = __w_pdfjs_require__(7);
                var _util = __w_pdfjs_require__(1);
                const fetchData = function(url) {
                    return new Promise((resolve, reject)=>{
                        const fs = (parcelRequire("hDwn7"));
                        fs.readFile(url, (error, data)=>{
                            if (error || !data) {
                                reject(new Error(error));
                                return;
                            }
                            resolve(new Uint8Array(data));
                        });
                    });
                };
                class NodeFilterFactory extends _base_factory.BaseFilterFactory {
                }
                exports.NodeFilterFactory = NodeFilterFactory;
                class NodeCanvasFactory extends _base_factory.BaseCanvasFactory {
                    _createCanvas(width, height) {
                        const Canvas = (parcelRequire("hDwn7"));
                        return Canvas.createCanvas(width, height);
                    }
                }
                exports.NodeCanvasFactory = NodeCanvasFactory;
                class NodeCMapReaderFactory extends _base_factory.BaseCMapReaderFactory {
                    _fetchData(url, compressionType) {
                        return fetchData(url).then((data)=>{
                            return {
                                cMapData: data,
                                compressionType: compressionType
                            };
                        });
                    }
                }
                exports.NodeCMapReaderFactory = NodeCMapReaderFactory;
                class NodeStandardFontDataFactory extends _base_factory.BaseStandardFontDataFactory {
                    _fetchData(url) {
                        return fetchData(url);
                    }
                }
                exports.NodeStandardFontDataFactory = NodeStandardFontDataFactory;
            /***/ },
            /* 11 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.CanvasGraphics = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _pattern_helper = __w_pdfjs_require__(12);
                var _image_utils = __w_pdfjs_require__(13);
                const MIN_FONT_SIZE = 16;
                const MAX_FONT_SIZE = 100;
                const MAX_GROUP_SIZE = 4096;
                const EXECUTION_TIME = 15;
                const EXECUTION_STEPS = 10;
                const MAX_SIZE_TO_COMPILE = 1000;
                const FULL_CHUNK_HEIGHT = 16;
                function mirrorContextOperations(ctx, destCtx) {
                    if (ctx._removeMirroring) throw new Error("Context is already forwarding operations.");
                    ctx.__originalSave = ctx.save;
                    ctx.__originalRestore = ctx.restore;
                    ctx.__originalRotate = ctx.rotate;
                    ctx.__originalScale = ctx.scale;
                    ctx.__originalTranslate = ctx.translate;
                    ctx.__originalTransform = ctx.transform;
                    ctx.__originalSetTransform = ctx.setTransform;
                    ctx.__originalResetTransform = ctx.resetTransform;
                    ctx.__originalClip = ctx.clip;
                    ctx.__originalMoveTo = ctx.moveTo;
                    ctx.__originalLineTo = ctx.lineTo;
                    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
                    ctx.__originalRect = ctx.rect;
                    ctx.__originalClosePath = ctx.closePath;
                    ctx.__originalBeginPath = ctx.beginPath;
                    ctx._removeMirroring = ()=>{
                        ctx.save = ctx.__originalSave;
                        ctx.restore = ctx.__originalRestore;
                        ctx.rotate = ctx.__originalRotate;
                        ctx.scale = ctx.__originalScale;
                        ctx.translate = ctx.__originalTranslate;
                        ctx.transform = ctx.__originalTransform;
                        ctx.setTransform = ctx.__originalSetTransform;
                        ctx.resetTransform = ctx.__originalResetTransform;
                        ctx.clip = ctx.__originalClip;
                        ctx.moveTo = ctx.__originalMoveTo;
                        ctx.lineTo = ctx.__originalLineTo;
                        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
                        ctx.rect = ctx.__originalRect;
                        ctx.closePath = ctx.__originalClosePath;
                        ctx.beginPath = ctx.__originalBeginPath;
                        delete ctx._removeMirroring;
                    };
                    ctx.save = function ctxSave() {
                        destCtx.save();
                        this.__originalSave();
                    };
                    ctx.restore = function ctxRestore() {
                        destCtx.restore();
                        this.__originalRestore();
                    };
                    ctx.translate = function ctxTranslate(x, y) {
                        destCtx.translate(x, y);
                        this.__originalTranslate(x, y);
                    };
                    ctx.scale = function ctxScale(x, y) {
                        destCtx.scale(x, y);
                        this.__originalScale(x, y);
                    };
                    ctx.transform = function ctxTransform(a, b, c, d, e, f) {
                        destCtx.transform(a, b, c, d, e, f);
                        this.__originalTransform(a, b, c, d, e, f);
                    };
                    ctx.setTransform = function ctxSetTransform(a, b, c, d, e, f) {
                        destCtx.setTransform(a, b, c, d, e, f);
                        this.__originalSetTransform(a, b, c, d, e, f);
                    };
                    ctx.resetTransform = function ctxResetTransform() {
                        destCtx.resetTransform();
                        this.__originalResetTransform();
                    };
                    ctx.rotate = function ctxRotate(angle) {
                        destCtx.rotate(angle);
                        this.__originalRotate(angle);
                    };
                    ctx.clip = function ctxRotate(rule) {
                        destCtx.clip(rule);
                        this.__originalClip(rule);
                    };
                    ctx.moveTo = function(x, y) {
                        destCtx.moveTo(x, y);
                        this.__originalMoveTo(x, y);
                    };
                    ctx.lineTo = function(x, y) {
                        destCtx.lineTo(x, y);
                        this.__originalLineTo(x, y);
                    };
                    ctx.bezierCurveTo = function(cp1x, cp1y, cp2x, cp2y, x, y) {
                        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
                    };
                    ctx.rect = function(x, y, width, height) {
                        destCtx.rect(x, y, width, height);
                        this.__originalRect(x, y, width, height);
                    };
                    ctx.closePath = function() {
                        destCtx.closePath();
                        this.__originalClosePath();
                    };
                    ctx.beginPath = function() {
                        destCtx.beginPath();
                        this.__originalBeginPath();
                    };
                }
                class CachedCanvases {
                    getCanvas(id, width, height) {
                        let canvasEntry;
                        if (this.cache[id] !== undefined) {
                            canvasEntry = this.cache[id];
                            this.canvasFactory.reset(canvasEntry, width, height);
                        } else {
                            canvasEntry = this.canvasFactory.create(width, height);
                            this.cache[id] = canvasEntry;
                        }
                        return canvasEntry;
                    }
                    delete(id) {
                        delete this.cache[id];
                    }
                    clear() {
                        for(const id in this.cache){
                            const canvasEntry = this.cache[id];
                            this.canvasFactory.destroy(canvasEntry);
                            delete this.cache[id];
                        }
                    }
                    constructor(canvasFactory){
                        this.canvasFactory = canvasFactory;
                        this.cache = Object.create(null);
                    }
                }
                function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
                    const [a, b, c, d, tx, ty] = (0, _display_utils.getCurrentTransform)(ctx);
                    if (b === 0 && c === 0) {
                        const tlX = destX * a + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destY * d + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destX + destW) * a + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destY + destH) * d + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rWidth,
                            rHeight
                        ];
                    }
                    if (a === 0 && d === 0) {
                        const tlX = destY * c + tx;
                        const rTlX = Math.round(tlX);
                        const tlY = destX * b + ty;
                        const rTlY = Math.round(tlY);
                        const brX = (destY + destH) * c + tx;
                        const rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
                        const brY = (destX + destW) * b + ty;
                        const rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
                        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
                        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
                        ctx.setTransform(a, b, c, d, tx, ty);
                        return [
                            rHeight,
                            rWidth
                        ];
                    }
                    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
                    const scaleX = Math.hypot(a, b);
                    const scaleY = Math.hypot(c, d);
                    return [
                        scaleX * destW,
                        scaleY * destH
                    ];
                }
                function compileType3Glyph(imgData) {
                    const { width, height } = imgData;
                    if (width > MAX_SIZE_TO_COMPILE || height > MAX_SIZE_TO_COMPILE) return null;
                    const POINT_TO_PROCESS_LIMIT = 1000;
                    const POINT_TYPES = new Uint8Array([
                        0,
                        2,
                        4,
                        0,
                        1,
                        0,
                        5,
                        4,
                        8,
                        10,
                        0,
                        8,
                        0,
                        2,
                        1,
                        0
                    ]);
                    const width1 = width + 1;
                    let points = new Uint8Array(width1 * (height + 1));
                    let i, j, j0;
                    const lineSize = width + 7 & -8;
                    let data = new Uint8Array(lineSize * height), pos = 0;
                    for (const elem of imgData.data){
                        let mask = 128;
                        while(mask > 0){
                            data[pos++] = elem & mask ? 0 : 255;
                            mask >>= 1;
                        }
                    }
                    let count = 0;
                    pos = 0;
                    if (data[pos] !== 0) {
                        points[0] = 1;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j] = data[pos] ? 2 : 1;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j] = 2;
                        ++count;
                    }
                    for(i = 1; i < height; i++){
                        pos = i * lineSize;
                        j0 = i * width1;
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0] = data[pos] ? 1 : 8;
                            ++count;
                        }
                        let sum = (data[pos] ? 4 : 0) + (data[pos - lineSize] ? 8 : 0);
                        for(j = 1; j < width; j++){
                            sum = (sum >> 2) + (data[pos + 1] ? 4 : 0) + (data[pos - lineSize + 1] ? 8 : 0);
                            if (POINT_TYPES[sum]) {
                                points[j0 + j] = POINT_TYPES[sum];
                                ++count;
                            }
                            pos++;
                        }
                        if (data[pos - lineSize] !== data[pos]) {
                            points[j0 + j] = data[pos] ? 2 : 4;
                            ++count;
                        }
                        if (count > POINT_TO_PROCESS_LIMIT) return null;
                    }
                    pos = lineSize * (height - 1);
                    j0 = i * width1;
                    if (data[pos] !== 0) {
                        points[j0] = 8;
                        ++count;
                    }
                    for(j = 1; j < width; j++){
                        if (data[pos] !== data[pos + 1]) {
                            points[j0 + j] = data[pos] ? 4 : 8;
                            ++count;
                        }
                        pos++;
                    }
                    if (data[pos] !== 0) {
                        points[j0 + j] = 4;
                        ++count;
                    }
                    if (count > POINT_TO_PROCESS_LIMIT) return null;
                    const steps = new Int32Array([
                        0,
                        width1,
                        -1,
                        0,
                        -width1,
                        0,
                        0,
                        0,
                        1
                    ]);
                    const path = new Path2D();
                    for(i = 0; count && i <= height; i++){
                        let p = i * width1;
                        const end = p + width;
                        while(p < end && !points[p])p++;
                        if (p === end) continue;
                        path.moveTo(p % width1, i);
                        const p0 = p;
                        let type = points[p];
                        do {
                            const step = steps[type];
                            do p += step;
                            while (!points[p]);
                            const pp = points[p];
                            if (pp !== 5 && pp !== 10) {
                                type = pp;
                                points[p] = 0;
                            } else {
                                type = pp & 0x33 * type >> 4;
                                points[p] &= type >> 2 | type << 2;
                            }
                            path.lineTo(p % width1, p / width1 | 0);
                            if (!points[p]) --count;
                        }while (p0 !== p);
                        --i;
                    }
                    data = null;
                    points = null;
                    const drawOutline = function(c) {
                        c.save();
                        c.scale(1 / width, -1 / height);
                        c.translate(0, -height);
                        c.fill(path);
                        c.beginPath();
                        c.restore();
                    };
                    return drawOutline;
                }
                class CanvasExtraState {
                    clone() {
                        const clone = Object.create(this);
                        clone.clipBox = this.clipBox.slice();
                        return clone;
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    updatePathMinMax(transform, x, y) {
                        [x, y] = _util.Util.applyTransform([
                            x,
                            y
                        ], transform);
                        this.minX = Math.min(this.minX, x);
                        this.minY = Math.min(this.minY, y);
                        this.maxX = Math.max(this.maxX, x);
                        this.maxY = Math.max(this.maxY, y);
                    }
                    updateRectMinMax(transform, rect) {
                        const p1 = _util.Util.applyTransform(rect, transform);
                        const p2 = _util.Util.applyTransform(rect.slice(2), transform);
                        this.minX = Math.min(this.minX, p1[0], p2[0]);
                        this.minY = Math.min(this.minY, p1[1], p2[1]);
                        this.maxX = Math.max(this.maxX, p1[0], p2[0]);
                        this.maxY = Math.max(this.maxY, p1[1], p2[1]);
                    }
                    updateScalingPathMinMax(transform, minMax) {
                        _util.Util.scaleMinMax(transform, minMax);
                        this.minX = Math.min(this.minX, minMax[0]);
                        this.maxX = Math.max(this.maxX, minMax[1]);
                        this.minY = Math.min(this.minY, minMax[2]);
                        this.maxY = Math.max(this.maxY, minMax[3]);
                    }
                    updateCurvePathMinMax(transform, x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
                        const box = _util.Util.bezierBoundingBox(x0, y0, x1, y1, x2, y2, x3, y3);
                        if (minMax) {
                            minMax[0] = Math.min(minMax[0], box[0], box[2]);
                            minMax[1] = Math.max(minMax[1], box[0], box[2]);
                            minMax[2] = Math.min(minMax[2], box[1], box[3]);
                            minMax[3] = Math.max(minMax[3], box[1], box[3]);
                            return;
                        }
                        this.updateRectMinMax(transform, box);
                    }
                    getPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        const box = [
                            this.minX,
                            this.minY,
                            this.maxX,
                            this.maxY
                        ];
                        if (pathType === _pattern_helper.PathType.STROKE) {
                            if (!transform) (0, _util.unreachable)("Stroke bounding box must include transform.");
                            const scale = _util.Util.singularValueDecompose2dScale(transform);
                            const xStrokePad = scale[0] * this.lineWidth / 2;
                            const yStrokePad = scale[1] * this.lineWidth / 2;
                            box[0] -= xStrokePad;
                            box[1] -= yStrokePad;
                            box[2] += xStrokePad;
                            box[3] += yStrokePad;
                        }
                        return box;
                    }
                    updateClipFromPath() {
                        const intersect = _util.Util.intersect(this.clipBox, this.getPathBoundingBox());
                        this.startNewPathAndClipBox(intersect || [
                            0,
                            0,
                            0,
                            0
                        ]);
                    }
                    isEmptyClip() {
                        return this.minX === Infinity;
                    }
                    startNewPathAndClipBox(box) {
                        this.clipBox = box;
                        this.minX = Infinity;
                        this.minY = Infinity;
                        this.maxX = 0;
                        this.maxY = 0;
                    }
                    getClippedPathBoundingBox(pathType = _pattern_helper.PathType.FILL, transform = null) {
                        return _util.Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
                    }
                    constructor(width, height){
                        this.alphaIsShape = false;
                        this.fontSize = 0;
                        this.fontSizeScale = 1;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.textMatrixScale = 1;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textRise = 0;
                        this.fillColor = "#000000";
                        this.strokeColor = "#000000";
                        this.patternFill = false;
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.activeSMask = null;
                        this.transferMaps = "none";
                        this.startNewPathAndClipBox([
                            0,
                            0,
                            width,
                            height
                        ]);
                    }
                }
                function putBinaryImageData(ctx, imgData) {
                    if (typeof ImageData !== "undefined" && imgData instanceof ImageData) {
                        ctx.putImageData(imgData, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0, destPos;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    let i, j, thisChunkHeight, elemsInThisChunk;
                    if (imgData.kind === _util.ImageKind.GRAYSCALE_1BPP) {
                        const srcLength = src.byteLength;
                        const dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
                        const dest32DataLength = dest32.length;
                        const fullSrcDiff = width + 7 >> 3;
                        const white = 0xffffffff;
                        const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                        for(i = 0; i < totalChunks; i++){
                            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                            destPos = 0;
                            for(j = 0; j < thisChunkHeight; j++){
                                const srcDiff = srcLength - srcPos;
                                let k = 0;
                                const kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                                const kEndUnrolled = kEnd & -8;
                                let mask = 0;
                                let srcByte = 0;
                                for(; k < kEndUnrolled; k += 8){
                                    srcByte = src[srcPos++];
                                    dest32[destPos++] = srcByte & 128 ? white : black;
                                    dest32[destPos++] = srcByte & 64 ? white : black;
                                    dest32[destPos++] = srcByte & 32 ? white : black;
                                    dest32[destPos++] = srcByte & 16 ? white : black;
                                    dest32[destPos++] = srcByte & 8 ? white : black;
                                    dest32[destPos++] = srcByte & 4 ? white : black;
                                    dest32[destPos++] = srcByte & 2 ? white : black;
                                    dest32[destPos++] = srcByte & 1 ? white : black;
                                }
                                for(; k < kEnd; k++){
                                    if (mask === 0) {
                                        srcByte = src[srcPos++];
                                        mask = 128;
                                    }
                                    dest32[destPos++] = srcByte & mask ? white : black;
                                    mask >>= 1;
                                }
                            }
                            while(destPos < dest32DataLength)dest32[destPos++] = 0;
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGBA_32BPP) {
                        j = 0;
                        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
                        for(i = 0; i < fullChunks; i++){
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            srcPos += elemsInThisChunk;
                            ctx.putImageData(chunkImgData, 0, j);
                            j += FULL_CHUNK_HEIGHT;
                        }
                        if (i < totalChunks) {
                            elemsInThisChunk = width * partialChunkHeight * 4;
                            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
                            ctx.putImageData(chunkImgData, 0, j);
                        }
                    } else if (imgData.kind === _util.ImageKind.RGB_24BPP) {
                        thisChunkHeight = FULL_CHUNK_HEIGHT;
                        elemsInThisChunk = width * thisChunkHeight;
                        for(i = 0; i < totalChunks; i++){
                            if (i >= fullChunks) {
                                thisChunkHeight = partialChunkHeight;
                                elemsInThisChunk = width * thisChunkHeight;
                            }
                            destPos = 0;
                            for(j = elemsInThisChunk; j--;){
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = src[srcPos++];
                                dest[destPos++] = 255;
                            }
                            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                        }
                    } else throw new Error(`bad image kind: ${imgData.kind}`);
                }
                function putBinaryImageMask(ctx, imgData) {
                    if (imgData.bitmap) {
                        ctx.drawImage(imgData.bitmap, 0, 0);
                        return;
                    }
                    const height = imgData.height, width = imgData.width;
                    const partialChunkHeight = height % FULL_CHUNK_HEIGHT;
                    const fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
                    const totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
                    const chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
                    let srcPos = 0;
                    const src = imgData.data;
                    const dest = chunkImgData.data;
                    for(let i = 0; i < totalChunks; i++){
                        const thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
                        ({ srcPos } = (0, _image_utils.convertBlackAndWhiteToRGBA)({
                            src: src,
                            srcPos: srcPos,
                            dest: dest,
                            width: width,
                            height: thisChunkHeight,
                            nonBlackColor: 0
                        }));
                        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
                    }
                }
                function copyCtxState(sourceCtx, destCtx) {
                    const properties = [
                        "strokeStyle",
                        "fillStyle",
                        "fillRule",
                        "globalAlpha",
                        "lineWidth",
                        "lineCap",
                        "lineJoin",
                        "miterLimit",
                        "globalCompositeOperation",
                        "font",
                        "filter"
                    ];
                    for (const property of properties)if (sourceCtx[property] !== undefined) destCtx[property] = sourceCtx[property];
                    if (sourceCtx.setLineDash !== undefined) {
                        destCtx.setLineDash(sourceCtx.getLineDash());
                        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
                    }
                }
                function resetCtxToDefault(ctx) {
                    ctx.strokeStyle = ctx.fillStyle = "#000000";
                    ctx.fillRule = "nonzero";
                    ctx.globalAlpha = 1;
                    ctx.lineWidth = 1;
                    ctx.lineCap = "butt";
                    ctx.lineJoin = "miter";
                    ctx.miterLimit = 10;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.font = "10px sans-serif";
                    if (ctx.setLineDash !== undefined) {
                        ctx.setLineDash([]);
                        ctx.lineDashOffset = 0;
                    }
                    if (!_util.isNodeJS) {
                        const { filter } = ctx;
                        if (filter !== "none" && filter !== "") ctx.filter = "none";
                    }
                }
                function composeSMaskBackdrop(bytes, r0, g0, b0) {
                    const length = bytes.length;
                    for(let i = 3; i < length; i += 4){
                        const alpha = bytes[i];
                        if (alpha === 0) {
                            bytes[i - 3] = r0;
                            bytes[i - 2] = g0;
                            bytes[i - 1] = b0;
                        } else if (alpha < 255) {
                            const alpha_ = 255 - alpha;
                            bytes[i - 3] = bytes[i - 3] * alpha + r0 * alpha_ >> 8;
                            bytes[i - 2] = bytes[i - 2] * alpha + g0 * alpha_ >> 8;
                            bytes[i - 1] = bytes[i - 1] * alpha + b0 * alpha_ >> 8;
                        }
                    }
                }
                function composeSMaskAlpha(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    const scale = 1 / 255;
                    for(let i = 3; i < length; i += 4){
                        const alpha = transferMap ? transferMap[maskData[i]] : maskData[i];
                        layerData[i] = layerData[i] * alpha * scale | 0;
                    }
                }
                function composeSMaskLuminosity(maskData, layerData, transferMap) {
                    const length = maskData.length;
                    for(let i = 3; i < length; i += 4){
                        const y = maskData[i - 3] * 77 + maskData[i - 2] * 152 + maskData[i - 1] * 28;
                        layerData[i] = transferMap ? layerData[i] * transferMap[y >> 8] >> 8 : layerData[i] * y >> 16;
                    }
                }
                function genericComposeSMask(maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
                    const hasBackdrop = !!backdrop;
                    const r0 = hasBackdrop ? backdrop[0] : 0;
                    const g0 = hasBackdrop ? backdrop[1] : 0;
                    const b0 = hasBackdrop ? backdrop[2] : 0;
                    const composeFn = subtype === "Luminosity" ? composeSMaskLuminosity : composeSMaskAlpha;
                    const PIXELS_TO_PROCESS = 1048576;
                    const chunkSize = Math.min(height, Math.ceil(PIXELS_TO_PROCESS / width));
                    for(let row = 0; row < height; row += chunkSize){
                        const chunkHeight = Math.min(chunkSize, height - row);
                        const maskData = maskCtx.getImageData(layerOffsetX - maskOffsetX, row + (layerOffsetY - maskOffsetY), width, chunkHeight);
                        const layerData = layerCtx.getImageData(layerOffsetX, row + layerOffsetY, width, chunkHeight);
                        if (hasBackdrop) composeSMaskBackdrop(maskData.data, r0, g0, b0);
                        composeFn(maskData.data, layerData.data, transferMap);
                        layerCtx.putImageData(layerData, layerOffsetX, row + layerOffsetY);
                    }
                }
                function composeSMask(ctx, smask, layerCtx, layerBox) {
                    const layerOffsetX = layerBox[0];
                    const layerOffsetY = layerBox[1];
                    const layerWidth = layerBox[2] - layerOffsetX;
                    const layerHeight = layerBox[3] - layerOffsetY;
                    if (layerWidth === 0 || layerHeight === 0) return;
                    genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
                    ctx.save();
                    ctx.globalAlpha = 1;
                    ctx.globalCompositeOperation = "source-over";
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.drawImage(layerCtx.canvas, 0, 0);
                    ctx.restore();
                }
                function getImageSmoothingEnabled(transform, interpolate) {
                    const scale = _util.Util.singularValueDecompose2dScale(transform);
                    scale[0] = Math.fround(scale[0]);
                    scale[1] = Math.fround(scale[1]);
                    const actualScale = Math.fround((globalThis.devicePixelRatio || 1) * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                    if (interpolate !== undefined) return interpolate;
                    else if (scale[0] <= actualScale || scale[1] <= actualScale) return true;
                    return false;
                }
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const NORMAL_CLIP = {};
                const EO_CLIP = {};
                var _restoreInitialState = /*#__PURE__*/ new WeakSet(), _drawFilter = /*#__PURE__*/ new WeakSet();
                class CanvasGraphics {
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    beginDrawing({ transform, viewport, transparency = false, background = null }) {
                        const width = this.ctx.canvas.width;
                        const height = this.ctx.canvas.height;
                        const savedFillStyle = this.ctx.fillStyle;
                        this.ctx.fillStyle = background || "#ffffff";
                        this.ctx.fillRect(0, 0, width, height);
                        this.ctx.fillStyle = savedFillStyle;
                        if (transparency) {
                            const transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
                            this.compositeCtx = this.ctx;
                            this.transparentCanvas = transparentCanvas.canvas;
                            this.ctx = transparentCanvas.context;
                            this.ctx.save();
                            this.ctx.transform(...(0, _display_utils.getCurrentTransform)(this.compositeCtx));
                        }
                        this.ctx.save();
                        resetCtxToDefault(this.ctx);
                        if (transform) {
                            this.ctx.transform(...transform);
                            this.outputScaleX = transform[0];
                            this.outputScaleY = transform[0];
                        }
                        this.ctx.transform(...viewport.transform);
                        this.viewportScale = viewport.scale;
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                    }
                    executeOperatorList(operatorList, executionStartIdx, continueCallback, stepper) {
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        let i = executionStartIdx || 0;
                        const argsArrayLen = argsArray.length;
                        if (argsArrayLen === i) return i;
                        const chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
                        const endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
                        let steps = 0;
                        const commonObjs = this.commonObjs;
                        const objs = this.objs;
                        let fnId;
                        while(true){
                            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                                stepper.breakIt(i, continueCallback);
                                return i;
                            }
                            fnId = fnArray[i];
                            if (fnId !== _util.OPS.dependency) this[fnId].apply(this, argsArray[i]);
                            else for (const depObjId of argsArray[i]){
                                const objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                                if (!objsPool.has(depObjId)) {
                                    objsPool.get(depObjId, continueCallback);
                                    return i;
                                }
                            }
                            i++;
                            if (i === argsArrayLen) return i;
                            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                                if (Date.now() > endTime) {
                                    continueCallback();
                                    return i;
                                }
                                steps = 0;
                            }
                        }
                    }
                    endDrawing() {
                        (0, $hDjZy._)(this, _restoreInitialState, restoreInitialState).call(this);
                        this.cachedCanvases.clear();
                        this.cachedPatterns.clear();
                        for (const cache of this._cachedBitmapsMap.values()){
                            for (const canvas of cache.values())if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) canvas.width = canvas.height = 0;
                            cache.clear();
                        }
                        this._cachedBitmapsMap.clear();
                        (0, $hDjZy._)(this, _drawFilter, drawFilter).call(this);
                    }
                    _scaleImage(img, inverseTransform) {
                        const width = img.width;
                        const height = img.height;
                        let widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
                        let heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
                        let paintWidth = width, paintHeight = height;
                        let tmpCanvasId = "prescale1";
                        let tmpCanvas, tmpCtx;
                        while(widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1){
                            let newWidth = paintWidth, newHeight = paintHeight;
                            if (widthScale > 2 && paintWidth > 1) {
                                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                                widthScale /= paintWidth / newWidth;
                            }
                            if (heightScale > 2 && paintHeight > 1) {
                                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                                heightScale /= paintHeight / newHeight;
                            }
                            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
                            tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, newWidth, newHeight);
                            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
                            img = tmpCanvas.canvas;
                            paintWidth = newWidth;
                            paintHeight = newHeight;
                            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
                        }
                        return {
                            img: img,
                            paintWidth: paintWidth,
                            paintHeight: paintHeight
                        };
                    }
                    _createMaskCanvas(img) {
                        const ctx = this.ctx;
                        const { width, height } = img;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        let cache, cacheKey, scaled, maskCanvas;
                        if ((img.bitmap || img.data) && img.count > 1) {
                            const mainKey = img.bitmap || img.data.buffer;
                            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [
                                currentTransform.slice(0, 4),
                                fillColor
                            ]);
                            cache = this._cachedBitmapsMap.get(mainKey);
                            if (!cache) {
                                cache = new Map();
                                this._cachedBitmapsMap.set(mainKey, cache);
                            }
                            const cachedImage = cache.get(cacheKey);
                            if (cachedImage && !isPatternFill) {
                                const offsetX = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                                const offsetY = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                                return {
                                    canvas: cachedImage,
                                    offsetX: offsetX,
                                    offsetY: offsetY
                                };
                            }
                            scaled = cachedImage;
                        }
                        if (!scaled) {
                            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            putBinaryImageMask(maskCanvas.context, img);
                        }
                        let maskToCanvas = _util.Util.transform(currentTransform, [
                            1 / width,
                            0,
                            0,
                            -1 / height,
                            0,
                            0
                        ]);
                        maskToCanvas = _util.Util.transform(maskToCanvas, [
                            1,
                            0,
                            0,
                            1,
                            0,
                            -height
                        ]);
                        const cord1 = _util.Util.applyTransform([
                            0,
                            0
                        ], maskToCanvas);
                        const cord2 = _util.Util.applyTransform([
                            width,
                            height
                        ], maskToCanvas);
                        const rect = _util.Util.normalizeRect([
                            cord1[0],
                            cord1[1],
                            cord2[0],
                            cord2[1]
                        ]);
                        const drawnWidth = Math.round(rect[2] - rect[0]) || 1;
                        const drawnHeight = Math.round(rect[3] - rect[1]) || 1;
                        const fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
                        const fillCtx = fillCanvas.context;
                        const offsetX = Math.min(cord1[0], cord2[0]);
                        const offsetY = Math.min(cord1[1], cord2[1]);
                        fillCtx.translate(-offsetX, -offsetY);
                        fillCtx.transform(...maskToCanvas);
                        if (!scaled) {
                            scaled = this._scaleImage(maskCanvas.canvas, (0, _display_utils.getCurrentTransformInverse)(fillCtx));
                            scaled = scaled.img;
                            if (cache && isPatternFill) cache.set(cacheKey, scaled);
                        }
                        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(fillCtx), img.interpolate);
                        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
                        fillCtx.globalCompositeOperation = "source-in";
                        const inverse = _util.Util.transform((0, _display_utils.getCurrentTransformInverse)(fillCtx), [
                            1,
                            0,
                            0,
                            1,
                            -offsetX,
                            -offsetY
                        ]);
                        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, _pattern_helper.PathType.FILL) : fillColor;
                        fillCtx.fillRect(0, 0, width, height);
                        if (cache && !isPatternFill) {
                            this.cachedCanvases.delete("fillCanvas");
                            cache.set(cacheKey, fillCanvas.canvas);
                        }
                        return {
                            canvas: fillCanvas.canvas,
                            offsetX: Math.round(offsetX),
                            offsetY: Math.round(offsetY)
                        };
                    }
                    setLineWidth(width) {
                        if (width !== this.current.lineWidth) this._cachedScaleForStroking[0] = -1;
                        this.current.lineWidth = width;
                        this.ctx.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.ctx.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.ctx.miterLimit = limit;
                    }
                    setDash(dashArray, dashPhase) {
                        const ctx = this.ctx;
                        if (ctx.setLineDash !== undefined) {
                            ctx.setLineDash(dashArray);
                            ctx.lineDashOffset = dashPhase;
                        }
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value[0], value[1]);
                                break;
                            case "CA":
                                this.current.strokeAlpha = value;
                                break;
                            case "ca":
                                this.current.fillAlpha = value;
                                this.ctx.globalAlpha = value;
                                break;
                            case "BM":
                                this.ctx.globalCompositeOperation = value;
                                break;
                            case "SMask":
                                this.current.activeSMask = value ? this.tempSMask : null;
                                this.tempSMask = null;
                                this.checkSMaskState();
                                break;
                            case "TR":
                                this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                                break;
                        }
                    }
                    get inSMaskMode() {
                        return !!this.suspendedCtx;
                    }
                    checkSMaskState() {
                        const inSMaskMode = this.inSMaskMode;
                        if (this.current.activeSMask && !inSMaskMode) this.beginSMaskMode();
                        else if (!this.current.activeSMask && inSMaskMode) this.endSMaskMode();
                    }
                    beginSMaskMode() {
                        if (this.inSMaskMode) throw new Error("beginSMaskMode called while already in smask mode");
                        const drawnWidth = this.ctx.canvas.width;
                        const drawnHeight = this.ctx.canvas.height;
                        const cacheId = "smaskGroupAt" + this.groupLevel;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        this.suspendedCtx = this.ctx;
                        this.ctx = scratchCanvas.context;
                        const ctx = this.ctx;
                        ctx.setTransform(...(0, _display_utils.getCurrentTransform)(this.suspendedCtx));
                        copyCtxState(this.suspendedCtx, ctx);
                        mirrorContextOperations(ctx, this.suspendedCtx);
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                    }
                    endSMaskMode() {
                        if (!this.inSMaskMode) throw new Error("endSMaskMode called while not in smask mode");
                        this.ctx._removeMirroring();
                        copyCtxState(this.ctx, this.suspendedCtx);
                        this.ctx = this.suspendedCtx;
                        this.suspendedCtx = null;
                    }
                    compose(dirtyBox) {
                        if (!this.current.activeSMask) return;
                        if (!dirtyBox) dirtyBox = [
                            0,
                            0,
                            this.ctx.canvas.width,
                            this.ctx.canvas.height
                        ];
                        else {
                            dirtyBox[0] = Math.floor(dirtyBox[0]);
                            dirtyBox[1] = Math.floor(dirtyBox[1]);
                            dirtyBox[2] = Math.ceil(dirtyBox[2]);
                            dirtyBox[3] = Math.ceil(dirtyBox[3]);
                        }
                        const smask = this.current.activeSMask;
                        const suspendedCtx = this.suspendedCtx;
                        composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
                        this.ctx.restore();
                    }
                    save() {
                        if (this.inSMaskMode) {
                            copyCtxState(this.ctx, this.suspendedCtx);
                            this.suspendedCtx.save();
                        } else this.ctx.save();
                        const old = this.current;
                        this.stateStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        if (this.stateStack.length === 0 && this.inSMaskMode) this.endSMaskMode();
                        if (this.stateStack.length !== 0) {
                            this.current = this.stateStack.pop();
                            if (this.inSMaskMode) {
                                this.suspendedCtx.restore();
                                copyCtxState(this.suspendedCtx, this.ctx);
                            } else this.ctx.restore();
                            this.checkSMaskState();
                            this.pendingClip = null;
                            this._cachedScaleForStroking[0] = -1;
                            this._cachedGetSinglePixelWidth = null;
                        }
                    }
                    transform(a, b, c, d, e, f) {
                        this.ctx.transform(a, b, c, d, e, f);
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                    }
                    constructPath(ops, args, minMax) {
                        const ctx = this.ctx;
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let startX, startY;
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        const isScalingMatrix = currentTransform[0] === 0 && currentTransform[3] === 0 || currentTransform[1] === 0 && currentTransform[2] === 0;
                        const minMaxForBezier = isScalingMatrix ? minMax.slice(0) : null;
                        for(let i = 0, j = 0, ii = ops.length; i < ii; i++)switch(ops[i] | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                ctx.moveTo(x, y);
                                if (width === 0 || height === 0) ctx.lineTo(xw, yh);
                                else {
                                    ctx.lineTo(xw, y);
                                    ctx.lineTo(xw, yh);
                                    ctx.lineTo(x, yh);
                                }
                                if (!isScalingMatrix) current.updateRectMinMax(currentTransform, [
                                    x,
                                    y,
                                    xw,
                                    yh
                                ]);
                                ctx.closePath();
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.moveTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                ctx.lineTo(x, y);
                                if (!isScalingMatrix) current.updatePathMinMax(currentTransform, x, y);
                                break;
                            case _util.OPS.curveTo:
                                startX = x;
                                startY = y;
                                x = args[j + 4];
                                y = args[j + 5];
                                ctx.bezierCurveTo(args[j], args[j + 1], args[j + 2], args[j + 3], x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], args[j + 2], args[j + 3], x, y, minMaxForBezier);
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                startX = x;
                                startY = y;
                                ctx.bezierCurveTo(x, y, args[j], args[j + 1], args[j + 2], args[j + 3]);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, x, y, args[j], args[j + 1], args[j + 2], args[j + 3], minMaxForBezier);
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                startX = x;
                                startY = y;
                                x = args[j + 2];
                                y = args[j + 3];
                                ctx.bezierCurveTo(args[j], args[j + 1], x, y, x, y);
                                current.updateCurvePathMinMax(currentTransform, startX, startY, args[j], args[j + 1], x, y, x, y, minMaxForBezier);
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                ctx.closePath();
                                break;
                        }
                        if (isScalingMatrix) current.updateScalingPathMinMax(currentTransform, minMaxForBezier);
                        current.setCurrentPoint(x, y);
                    }
                    closePath() {
                        this.ctx.closePath();
                    }
                    stroke(consumePath = true) {
                        const ctx = this.ctx;
                        const strokeColor = this.current.strokeColor;
                        ctx.globalAlpha = this.current.strokeAlpha;
                        if (this.contentVisible) {
                            if (typeof strokeColor === "object" && (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.getPattern)) {
                                ctx.save();
                                ctx.strokeStyle = strokeColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.STROKE);
                                this.rescaleAndStroke(false);
                                ctx.restore();
                            } else this.rescaleAndStroke(true);
                        }
                        if (consumePath) this.consumePath(this.current.getClippedPathBoundingBox());
                        ctx.globalAlpha = this.current.fillAlpha;
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    fill(consumePath = true) {
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        let needRestore = false;
                        if (isPatternFill) {
                            ctx.save();
                            ctx.fillStyle = fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            needRestore = true;
                        }
                        const intersect = this.current.getClippedPathBoundingBox();
                        if (this.contentVisible && intersect !== null) {
                            if (this.pendingEOFill) {
                                ctx.fill("evenodd");
                                this.pendingEOFill = false;
                            } else ctx.fill();
                        }
                        if (needRestore) ctx.restore();
                        if (consumePath) this.consumePath(intersect);
                    }
                    eoFill() {
                        this.pendingEOFill = true;
                        this.fill();
                    }
                    fillStroke() {
                        this.fill(false);
                        this.stroke(false);
                        this.consumePath();
                    }
                    eoFillStroke() {
                        this.pendingEOFill = true;
                        this.fillStroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.pendingEOFill = true;
                        this.closePath();
                        this.fillStroke();
                    }
                    endPath() {
                        this.consumePath();
                    }
                    clip() {
                        this.pendingClip = NORMAL_CLIP;
                    }
                    eoClip() {
                        this.pendingClip = EO_CLIP;
                    }
                    beginText() {
                        this.current.textMatrix = _util.IDENTITY_MATRIX;
                        this.current.textMatrixScale = 1;
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    endText() {
                        const paths = this.pendingTextPaths;
                        const ctx = this.ctx;
                        if (paths === undefined) {
                            ctx.beginPath();
                            return;
                        }
                        ctx.save();
                        ctx.beginPath();
                        for (const path of paths){
                            ctx.setTransform(...path.transform);
                            ctx.translate(path.x, path.y);
                            path.addToPath(ctx, path.fontSize);
                        }
                        ctx.restore();
                        ctx.clip();
                        ctx.beginPath();
                        delete this.pendingTextPaths;
                    }
                    setCharSpacing(spacing) {
                        this.current.charSpacing = spacing;
                    }
                    setWordSpacing(spacing) {
                        this.current.wordSpacing = spacing;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setFont(fontRefName, size) {
                        var _fontObj_systemFontInfo;
                        const fontObj = this.commonObjs.get(fontRefName);
                        const current = this.current;
                        if (!fontObj) throw new Error(`Can't find font for ${fontRefName}`);
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) (0, _util.warn)("Invalid font matrix for font " + fontRefName);
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        this.current.font = fontObj;
                        this.current.fontSize = size;
                        if (fontObj.isType3Font) return;
                        const name = fontObj.loadedName || "sans-serif";
                        const typeface = ((_fontObj_systemFontInfo = fontObj.systemFontInfo) === null || _fontObj_systemFontInfo === void 0 ? void 0 : _fontObj_systemFontInfo.css) || `"${name}", ${fontObj.fallbackName}`;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        let browserFontSize = size;
                        if (size < MIN_FONT_SIZE) browserFontSize = MIN_FONT_SIZE;
                        else if (size > MAX_FONT_SIZE) browserFontSize = MAX_FONT_SIZE;
                        this.current.fontSizeScale = size / browserFontSize;
                        this.ctx.font = `${italic} ${bold} ${browserFontSize}px ${typeface}`;
                    }
                    setTextRenderingMode(mode) {
                        this.current.textRenderingMode = mode;
                    }
                    setTextRise(rise) {
                        this.current.textRise = rise;
                    }
                    moveText(x, y) {
                        this.current.x = this.current.lineX += x;
                        this.current.y = this.current.lineY += y;
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        this.current.textMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.current.textMatrixScale = Math.hypot(a, b);
                        this.current.x = this.current.lineX = 0;
                        this.current.y = this.current.lineY = 0;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    paintChar(character, x, y, patternTransform) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const textRenderingMode = current.textRenderingMode;
                        const fontSize = current.fontSize / current.fontSizeScale;
                        const fillStrokeMode = textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        const isAddToPathSet = !!(textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG);
                        const patternFill = current.patternFill && !font.missingFile;
                        let addToPath;
                        if (font.disableFontFace || isAddToPathSet || patternFill) addToPath = font.getPathGenerator(this.commonObjs, character);
                        if (font.disableFontFace || patternFill) {
                            ctx.save();
                            ctx.translate(x, y);
                            ctx.beginPath();
                            addToPath(ctx, fontSize);
                            if (patternTransform) ctx.setTransform(...patternTransform);
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fill();
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.stroke();
                            ctx.restore();
                        } else {
                            if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.fillText(character, x, y);
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) ctx.strokeText(character, x, y);
                        }
                        if (isAddToPathSet) {
                            const paths = this.pendingTextPaths || (this.pendingTextPaths = []);
                            paths.push({
                                transform: (0, _display_utils.getCurrentTransform)(ctx),
                                x: x,
                                y: y,
                                fontSize: fontSize,
                                addToPath: addToPath
                            });
                        }
                    }
                    get isFontSubpixelAAEnabled() {
                        const { context: ctx } = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10);
                        ctx.scale(1.5, 1);
                        ctx.fillText("I", 0, 10);
                        const data = ctx.getImageData(0, 0, 10, 10).data;
                        let enabled = false;
                        for(let i = 3; i < data.length; i += 4)if (data[i] > 0 && data[i] < 255) {
                            enabled = true;
                            break;
                        }
                        return (0, _util.shadow)(this, "isFontSubpixelAAEnabled", enabled);
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        if (font.isType3Font) return this.showType3Text(glyphs);
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return undefined;
                        const ctx = this.ctx;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const glyphsLength = glyphs.length;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        const simpleFillText = current.textRenderingMode === _util.TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y + current.textRise);
                        if (fontDirection > 0) ctx.scale(textHScale, -1);
                        else ctx.scale(textHScale, 1);
                        let patternTransform;
                        if (current.patternFill) {
                            ctx.save();
                            const pattern = current.fillColor.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL);
                            patternTransform = (0, _display_utils.getCurrentTransform)(ctx);
                            ctx.restore();
                            ctx.fillStyle = pattern;
                        }
                        let lineWidth = current.lineWidth;
                        const scale = current.textMatrixScale;
                        if (scale === 0 || lineWidth === 0) {
                            const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                            if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) lineWidth = this.getSinglePixelWidth();
                        } else lineWidth /= scale;
                        if (fontSizeScale !== 1.0) {
                            ctx.scale(fontSizeScale, fontSizeScale);
                            lineWidth /= fontSizeScale;
                        }
                        ctx.lineWidth = lineWidth;
                        if (font.isInvalidPDFjsFont) {
                            const chars = [];
                            let width = 0;
                            for (const glyph of glyphs){
                                chars.push(glyph.unicode);
                                width += glyph.width;
                            }
                            ctx.fillText(chars.join(""), 0, 0);
                            current.x += width * widthAdvanceScale * textHScale;
                            ctx.restore();
                            this.compose();
                            return undefined;
                        }
                        let x = 0, i;
                        for(i = 0; i < glyphsLength; ++i){
                            const glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            let restoreNeeded = false;
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            const accent = glyph.accent;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                const vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (font.remeasure && width > 0) {
                                const measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                                    const characterScaleX = width / measuredWidth;
                                    restoreNeeded = true;
                                    ctx.save();
                                    ctx.scale(characterScaleX, 1);
                                    scaledX /= characterScaleX;
                                } else if (width !== measuredWidth) scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                            }
                            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                                if (simpleFillText && !accent) ctx.fillText(character, scaledX, scaledY);
                                else {
                                    this.paintChar(character, scaledX, scaledY, patternTransform);
                                    if (accent) {
                                        const scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                                        const scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternTransform);
                                    }
                                }
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                            if (restoreNeeded) ctx.restore();
                        }
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        ctx.restore();
                        this.compose();
                        return undefined;
                    }
                    showType3Text(glyphs) {
                        const ctx = this.ctx;
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        const fontDirection = current.fontDirection;
                        const spacingDir = font.vertical ? 1 : -1;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const textHScale = current.textHScale * fontDirection;
                        const fontMatrix = current.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        const glyphsLength = glyphs.length;
                        const isTextInvisible = current.textRenderingMode === _util.TextRenderingMode.INVISIBLE;
                        let i, glyph, width, spacingLength;
                        if (isTextInvisible || fontSize === 0) return;
                        this._cachedScaleForStroking[0] = -1;
                        this._cachedGetSinglePixelWidth = null;
                        ctx.save();
                        ctx.transform(...current.textMatrix);
                        ctx.translate(current.x, current.y);
                        ctx.scale(textHScale, fontDirection);
                        for(i = 0; i < glyphsLength; ++i){
                            glyph = glyphs[i];
                            if (typeof glyph === "number") {
                                spacingLength = spacingDir * glyph * fontSize / 1000;
                                this.ctx.translate(spacingLength, 0);
                                current.x += spacingLength * textHScale;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const operatorList = font.charProcOperatorList[glyph.operatorListId];
                            if (!operatorList) {
                                (0, _util.warn)(`Type3 character "${glyph.operatorListId}" is not available.`);
                                continue;
                            }
                            if (this.contentVisible) {
                                this.processingType3 = glyph;
                                this.save();
                                ctx.scale(fontSize, fontSize);
                                ctx.transform(...fontMatrix);
                                this.executeOperatorList(operatorList);
                                this.restore();
                            }
                            const transformed = _util.Util.applyTransform([
                                glyph.width,
                                0
                            ], fontMatrix);
                            width = transformed[0] * fontSize + spacing;
                            ctx.translate(width, 0);
                            current.x += width * textHScale;
                        }
                        ctx.restore();
                        this.processingType3 = null;
                    }
                    setCharWidth(xWidth, yWidth) {}
                    setCharWidthAndBounds(xWidth, yWidth, llx, lly, urx, ury) {
                        this.ctx.rect(llx, lly, urx - llx, ury - lly);
                        this.ctx.clip();
                        this.endPath();
                    }
                    getColorN_Pattern(IR) {
                        let pattern;
                        if (IR[0] === "TilingPattern") {
                            const color = IR[1];
                            const baseTransform = this.baseTransform || (0, _display_utils.getCurrentTransform)(this.ctx);
                            const canvasGraphicsFactory = {
                                createCanvasGraphics: (ctx)=>{
                                    return new CanvasGraphics(ctx, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
                                        optionalContentConfig: this.optionalContentConfig,
                                        markedContentStack: this.markedContentStack
                                    });
                                }
                            };
                            pattern = new _pattern_helper.TilingPattern(IR, color, this.ctx, canvasGraphicsFactory, baseTransform);
                        } else pattern = this._getPattern(IR[1], IR[2]);
                        return pattern;
                    }
                    setStrokeColorN() {
                        this.current.strokeColor = this.getColorN_Pattern(arguments);
                    }
                    setFillColorN() {
                        this.current.fillColor = this.getColorN_Pattern(arguments);
                        this.current.patternFill = true;
                    }
                    setStrokeRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.strokeStyle = color;
                        this.current.strokeColor = color;
                    }
                    setFillRGBColor(r, g, b) {
                        const color = _util.Util.makeHexColor(r, g, b);
                        this.ctx.fillStyle = color;
                        this.current.fillColor = color;
                        this.current.patternFill = false;
                    }
                    _getPattern(objId, matrix = null) {
                        let pattern;
                        if (this.cachedPatterns.has(objId)) pattern = this.cachedPatterns.get(objId);
                        else {
                            pattern = (0, _pattern_helper.getShadingPattern)(this.getObject(objId));
                            this.cachedPatterns.set(objId, pattern);
                        }
                        if (matrix) pattern.matrix = matrix;
                        return pattern;
                    }
                    shadingFill(objId) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        this.save();
                        const pattern = this._getPattern(objId);
                        ctx.fillStyle = pattern.getPattern(ctx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.SHADING);
                        const inv = (0, _display_utils.getCurrentTransformInverse)(ctx);
                        if (inv) {
                            const { width, height } = ctx.canvas;
                            const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                width,
                                height
                            ], inv);
                            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
                        } else this.ctx.fillRect(-10000000000, -10000000000, 2e10, 2e10);
                        this.compose(this.current.getClippedPathBoundingBox());
                        this.restore();
                    }
                    beginInlineImage() {
                        (0, _util.unreachable)("Should not call beginInlineImage");
                    }
                    beginImageData() {
                        (0, _util.unreachable)("Should not call beginImageData");
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (!this.contentVisible) return;
                        this.save();
                        this.baseTransformStack.push(this.baseTransform);
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(...matrix);
                        this.baseTransform = (0, _display_utils.getCurrentTransform)(this.ctx);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            this.ctx.rect(bbox[0], bbox[1], width, height);
                            this.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(this.ctx), bbox);
                            this.clip();
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {
                        if (!this.contentVisible) return;
                        this.restore();
                        this.baseTransform = this.baseTransformStack.pop();
                    }
                    beginGroup(group) {
                        if (!this.contentVisible) return;
                        this.save();
                        if (this.inSMaskMode) {
                            this.endSMaskMode();
                            this.current.activeSMask = null;
                        }
                        const currentCtx = this.ctx;
                        if (!group.isolated) (0, _util.info)("TODO: Support non-isolated groups.");
                        if (group.knockout) (0, _util.warn)("Knockout groups not supported.");
                        const currentTransform = (0, _display_utils.getCurrentTransform)(currentCtx);
                        if (group.matrix) currentCtx.transform(...group.matrix);
                        if (!group.bbox) throw new Error("Bounding box is required.");
                        let bounds = _util.Util.getAxialAlignedBoundingBox(group.bbox, (0, _display_utils.getCurrentTransform)(currentCtx));
                        const canvasBounds = [
                            0,
                            0,
                            currentCtx.canvas.width,
                            currentCtx.canvas.height
                        ];
                        bounds = _util.Util.intersect(bounds, canvasBounds) || [
                            0,
                            0,
                            0,
                            0
                        ];
                        const offsetX = Math.floor(bounds[0]);
                        const offsetY = Math.floor(bounds[1]);
                        let drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
                        let drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
                        let scaleX = 1, scaleY = 1;
                        if (drawnWidth > MAX_GROUP_SIZE) {
                            scaleX = drawnWidth / MAX_GROUP_SIZE;
                            drawnWidth = MAX_GROUP_SIZE;
                        }
                        if (drawnHeight > MAX_GROUP_SIZE) {
                            scaleY = drawnHeight / MAX_GROUP_SIZE;
                            drawnHeight = MAX_GROUP_SIZE;
                        }
                        this.current.startNewPathAndClipBox([
                            0,
                            0,
                            drawnWidth,
                            drawnHeight
                        ]);
                        let cacheId = "groupAt" + this.groupLevel;
                        if (group.smask) cacheId += "_smask_" + this.smaskCounter++ % 2;
                        const scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
                        const groupCtx = scratchCanvas.context;
                        groupCtx.scale(1 / scaleX, 1 / scaleY);
                        groupCtx.translate(-offsetX, -offsetY);
                        groupCtx.transform(...currentTransform);
                        if (group.smask) this.smaskStack.push({
                            canvas: scratchCanvas.canvas,
                            context: groupCtx,
                            offsetX: offsetX,
                            offsetY: offsetY,
                            scaleX: scaleX,
                            scaleY: scaleY,
                            subtype: group.smask.subtype,
                            backdrop: group.smask.backdrop,
                            transferMap: group.smask.transferMap || null,
                            startTransformInverse: null
                        });
                        else {
                            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
                            currentCtx.translate(offsetX, offsetY);
                            currentCtx.scale(scaleX, scaleY);
                            currentCtx.save();
                        }
                        copyCtxState(currentCtx, groupCtx);
                        this.ctx = groupCtx;
                        this.setGState([
                            [
                                "BM",
                                "source-over"
                            ],
                            [
                                "ca",
                                1
                            ],
                            [
                                "CA",
                                1
                            ]
                        ]);
                        this.groupStack.push(currentCtx);
                        this.groupLevel++;
                    }
                    endGroup(group) {
                        if (!this.contentVisible) return;
                        this.groupLevel--;
                        const groupCtx = this.ctx;
                        const ctx = this.groupStack.pop();
                        this.ctx = ctx;
                        this.ctx.imageSmoothingEnabled = false;
                        if (group.smask) {
                            this.tempSMask = this.smaskStack.pop();
                            this.restore();
                        } else {
                            this.ctx.restore();
                            const currentMtx = (0, _display_utils.getCurrentTransform)(this.ctx);
                            this.restore();
                            this.ctx.save();
                            this.ctx.setTransform(...currentMtx);
                            const dirtyBox = _util.Util.getAxialAlignedBoundingBox([
                                0,
                                0,
                                groupCtx.canvas.width,
                                groupCtx.canvas.height
                            ], currentMtx);
                            this.ctx.drawImage(groupCtx.canvas, 0, 0);
                            this.ctx.restore();
                            this.compose(dirtyBox);
                        }
                    }
                    beginAnnotation(id, rect, transform, matrix, hasOwnCanvas) {
                        (0, $hDjZy._)(this, _restoreInitialState, restoreInitialState).call(this);
                        resetCtxToDefault(this.ctx);
                        this.ctx.save();
                        this.save();
                        if (this.baseTransform) this.ctx.setTransform(...this.baseTransform);
                        if (Array.isArray(rect) && rect.length === 4) {
                            const width = rect[2] - rect[0];
                            const height = rect[3] - rect[1];
                            if (hasOwnCanvas && this.annotationCanvasMap) {
                                transform = transform.slice();
                                transform[4] -= rect[0];
                                transform[5] -= rect[1];
                                rect = rect.slice();
                                rect[0] = rect[1] = 0;
                                rect[2] = width;
                                rect[3] = height;
                                const [scaleX, scaleY] = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(this.ctx));
                                const { viewportScale } = this;
                                const canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                                const canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                                const { canvas, context } = this.annotationCanvas;
                                this.annotationCanvasMap.set(id, canvas);
                                this.annotationCanvas.savedCtx = this.ctx;
                                this.ctx = context;
                                this.ctx.save();
                                this.ctx.setTransform(scaleX, 0, 0, -scaleY, 0, height * scaleY);
                                resetCtxToDefault(this.ctx);
                            } else {
                                resetCtxToDefault(this.ctx);
                                this.ctx.rect(rect[0], rect[1], width, height);
                                this.ctx.clip();
                                this.endPath();
                            }
                        }
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.transform(...transform);
                        this.transform(...matrix);
                    }
                    endAnnotation() {
                        if (this.annotationCanvas) {
                            this.ctx.restore();
                            (0, $hDjZy._)(this, _drawFilter, drawFilter).call(this);
                            this.ctx = this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas.savedCtx;
                            delete this.annotationCanvas;
                        }
                    }
                    paintImageMaskXObject(img) {
                        if (!this.contentVisible) return;
                        const count = img.count;
                        img = this.getObject(img.data, img);
                        img.count = count;
                        const ctx = this.ctx;
                        const glyph = this.processingType3;
                        if (glyph) {
                            if (glyph.compiled === undefined) glyph.compiled = compileType3Glyph(img);
                            if (glyph.compiled) {
                                glyph.compiled(ctx);
                                return;
                            }
                        }
                        const mask = this._createMaskCanvas(img);
                        const maskCanvas = mask.canvas;
                        ctx.save();
                        ctx.setTransform(1, 0, 0, 1, 0, 0);
                        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectRepeat(img, scaleX, skewX = 0, skewY = 0, scaleY, positions) {
                        if (!this.contentVisible) return;
                        img = this.getObject(img.data, img);
                        const ctx = this.ctx;
                        ctx.save();
                        const currentTransform = (0, _display_utils.getCurrentTransform)(ctx);
                        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
                        const mask = this._createMaskCanvas(img);
                        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
                        for(let i = 0, ii = positions.length; i < ii; i += 2){
                            const trans = _util.Util.transform(currentTransform, [
                                scaleX,
                                skewX,
                                skewY,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ]);
                            const [x, y] = _util.Util.applyTransform([
                                0,
                                0
                            ], trans);
                            ctx.drawImage(mask.canvas, x, y);
                        }
                        ctx.restore();
                        this.compose();
                    }
                    paintImageMaskXObjectGroup(images) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        const fillColor = this.current.fillColor;
                        const isPatternFill = this.current.patternFill;
                        for (const image of images){
                            const { data, width, height, transform } = image;
                            const maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                            const maskCtx = maskCanvas.context;
                            maskCtx.save();
                            const img = this.getObject(data, image);
                            putBinaryImageMask(maskCtx, img);
                            maskCtx.globalCompositeOperation = "source-in";
                            maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, (0, _display_utils.getCurrentTransformInverse)(ctx), _pattern_helper.PathType.FILL) : fillColor;
                            maskCtx.fillRect(0, 0, width, height);
                            maskCtx.restore();
                            ctx.save();
                            ctx.transform(...transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintImageXObject(objId) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintImageXObjectRepeat(objId, scaleX, scaleY, positions) {
                        if (!this.contentVisible) return;
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)("Dependent image isn't ready yet");
                            return;
                        }
                        const width = imgData.width;
                        const height = imgData.height;
                        const map = [];
                        for(let i = 0, ii = positions.length; i < ii; i += 2)map.push({
                            transform: [
                                scaleX,
                                0,
                                0,
                                scaleY,
                                positions[i],
                                positions[i + 1]
                            ],
                            x: 0,
                            y: 0,
                            w: width,
                            h: height
                        });
                        this.paintInlineImageXObjectGroup(imgData, map);
                    }
                    applyTransferMapsToCanvas(ctx) {
                        if (this.current.transferMaps !== "none") {
                            ctx.filter = this.current.transferMaps;
                            ctx.drawImage(ctx.canvas, 0, 0);
                            ctx.filter = "none";
                        }
                        return ctx.canvas;
                    }
                    applyTransferMapsToBitmap(imgData) {
                        if (this.current.transferMaps === "none") return imgData.bitmap;
                        const { bitmap, width, height } = imgData;
                        const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                        const tmpCtx = tmpCanvas.context;
                        tmpCtx.filter = this.current.transferMaps;
                        tmpCtx.drawImage(bitmap, 0, 0);
                        tmpCtx.filter = "none";
                        return tmpCanvas.canvas;
                    }
                    paintInlineImageXObject(imgData) {
                        if (!this.contentVisible) return;
                        const width = imgData.width;
                        const height = imgData.height;
                        const ctx = this.ctx;
                        this.save();
                        if (!_util.isNodeJS) {
                            const { filter } = ctx;
                            if (filter !== "none" && filter !== "") ctx.filter = "none";
                        }
                        ctx.scale(1 / width, -1 / height);
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = this.applyTransferMapsToBitmap(imgData);
                        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) imgToPaint = imgData;
                        else {
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        const scaled = this._scaleImage(imgToPaint, (0, _display_utils.getCurrentTransformInverse)(ctx));
                        ctx.imageSmoothingEnabled = getImageSmoothingEnabled((0, _display_utils.getCurrentTransform)(ctx), imgData.interpolate);
                        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
                        this.compose();
                        this.restore();
                    }
                    paintInlineImageXObjectGroup(imgData, map) {
                        if (!this.contentVisible) return;
                        const ctx = this.ctx;
                        let imgToPaint;
                        if (imgData.bitmap) imgToPaint = imgData.bitmap;
                        else {
                            const w = imgData.width;
                            const h = imgData.height;
                            const tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
                            const tmpCtx = tmpCanvas.context;
                            putBinaryImageData(tmpCtx, imgData);
                            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
                        }
                        for (const entry of map){
                            ctx.save();
                            ctx.transform(...entry.transform);
                            ctx.scale(1, -1);
                            drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                            ctx.restore();
                        }
                        this.compose();
                    }
                    paintSolidColorImageMask() {
                        if (!this.contentVisible) return;
                        this.ctx.fillRect(0, 0, 1, 1);
                        this.compose();
                    }
                    markPoint(tag) {}
                    markPointProps(tag, properties) {}
                    beginMarkedContent(tag) {
                        this.markedContentStack.push({
                            visible: true
                        });
                    }
                    beginMarkedContentProps(tag, properties) {
                        if (tag === "OC") this.markedContentStack.push({
                            visible: this.optionalContentConfig.isVisible(properties)
                        });
                        else this.markedContentStack.push({
                            visible: true
                        });
                        this.contentVisible = this.isContentVisible();
                    }
                    endMarkedContent() {
                        this.markedContentStack.pop();
                        this.contentVisible = this.isContentVisible();
                    }
                    beginCompat() {}
                    endCompat() {}
                    consumePath(clipBox) {
                        const isEmpty = this.current.isEmptyClip();
                        if (this.pendingClip) this.current.updateClipFromPath();
                        if (!this.pendingClip) this.compose(clipBox);
                        const ctx = this.ctx;
                        if (this.pendingClip) {
                            if (!isEmpty) {
                                if (this.pendingClip === EO_CLIP) ctx.clip("evenodd");
                                else ctx.clip();
                            }
                            this.pendingClip = null;
                        }
                        this.current.startNewPathAndClipBox(this.current.clipBox);
                        ctx.beginPath();
                    }
                    getSinglePixelWidth() {
                        if (!this._cachedGetSinglePixelWidth) {
                            const m = (0, _display_utils.getCurrentTransform)(this.ctx);
                            if (m[1] === 0 && m[2] === 0) this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
                            else {
                                const absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                                const normX = Math.hypot(m[0], m[2]);
                                const normY = Math.hypot(m[1], m[3]);
                                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
                            }
                        }
                        return this._cachedGetSinglePixelWidth;
                    }
                    getScaleForStroking() {
                        if (this._cachedScaleForStroking[0] === -1) {
                            const { lineWidth } = this.current;
                            const { a, b, c, d } = this.ctx.getTransform();
                            let scaleX, scaleY;
                            if (b === 0 && c === 0) {
                                const normX = Math.abs(a);
                                const normY = Math.abs(d);
                                if (normX === normY) {
                                    if (lineWidth === 0) scaleX = scaleY = 1 / normX;
                                    else {
                                        const scaledLineWidth = normX * lineWidth;
                                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                                    }
                                } else if (lineWidth === 0) {
                                    scaleX = 1 / normX;
                                    scaleY = 1 / normY;
                                } else {
                                    const scaledXLineWidth = normX * lineWidth;
                                    const scaledYLineWidth = normY * lineWidth;
                                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                                }
                            } else {
                                const absDet = Math.abs(a * d - b * c);
                                const normX = Math.hypot(a, b);
                                const normY = Math.hypot(c, d);
                                if (lineWidth === 0) {
                                    scaleX = normY / absDet;
                                    scaleY = normX / absDet;
                                } else {
                                    const baseArea = lineWidth * absDet;
                                    scaleX = normY > baseArea ? normY / baseArea : 1;
                                    scaleY = normX > baseArea ? normX / baseArea : 1;
                                }
                            }
                            this._cachedScaleForStroking[0] = scaleX;
                            this._cachedScaleForStroking[1] = scaleY;
                        }
                        return this._cachedScaleForStroking;
                    }
                    rescaleAndStroke(saveRestore) {
                        const { ctx } = this;
                        const { lineWidth } = this.current;
                        const [scaleX, scaleY] = this.getScaleForStroking();
                        ctx.lineWidth = lineWidth || 1;
                        if (scaleX === 1 && scaleY === 1) {
                            ctx.stroke();
                            return;
                        }
                        const dashes = ctx.getLineDash();
                        if (saveRestore) ctx.save();
                        ctx.scale(scaleX, scaleY);
                        if (dashes.length > 0) {
                            const scale = Math.max(scaleX, scaleY);
                            ctx.setLineDash(dashes.map((x)=>x / scale));
                            ctx.lineDashOffset /= scale;
                        }
                        ctx.stroke();
                        if (saveRestore) ctx.restore();
                    }
                    isContentVisible() {
                        for(let i = this.markedContentStack.length - 1; i >= 0; i--){
                            if (!this.markedContentStack[i].visible) return false;
                        }
                        return true;
                    }
                    constructor(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, { optionalContentConfig, markedContentStack = null }, annotationCanvasMap, pageColors){
                        (0, $2IZAT._)(this, _restoreInitialState);
                        (0, $2IZAT._)(this, _drawFilter);
                        this.ctx = canvasCtx;
                        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
                        this.stateStack = [];
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.res = null;
                        this.xobjs = null;
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.canvasFactory = canvasFactory;
                        this.filterFactory = filterFactory;
                        this.groupStack = [];
                        this.processingType3 = null;
                        this.baseTransform = null;
                        this.baseTransformStack = [];
                        this.groupLevel = 0;
                        this.smaskStack = [];
                        this.smaskCounter = 0;
                        this.tempSMask = null;
                        this.suspendedCtx = null;
                        this.contentVisible = true;
                        this.markedContentStack = markedContentStack || [];
                        this.optionalContentConfig = optionalContentConfig;
                        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
                        this.cachedPatterns = new Map();
                        this.annotationCanvasMap = annotationCanvasMap;
                        this.viewportScale = 1;
                        this.outputScaleX = 1;
                        this.outputScaleY = 1;
                        this.pageColors = pageColors;
                        this._cachedScaleForStroking = [
                            -1,
                            0
                        ];
                        this._cachedGetSinglePixelWidth = null;
                        this._cachedBitmapsMap = new Map();
                    }
                }
                function restoreInitialState() {
                    while(this.stateStack.length || this.inSMaskMode)this.restore();
                    this.ctx.restore();
                    if (this.transparentCanvas) {
                        this.ctx = this.compositeCtx;
                        this.ctx.save();
                        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
                        this.ctx.drawImage(this.transparentCanvas, 0, 0);
                        this.ctx.restore();
                        this.transparentCanvas = null;
                    }
                }
                function drawFilter() {
                    if (this.pageColors) {
                        const hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
                        if (hcmFilterId !== "none") {
                            const savedFilter = this.ctx.filter;
                            this.ctx.filter = hcmFilterId;
                            this.ctx.drawImage(this.ctx.canvas, 0, 0);
                            this.ctx.filter = savedFilter;
                        }
                    }
                }
                exports.CanvasGraphics = CanvasGraphics;
                for(const op in _util.OPS)if (CanvasGraphics.prototype[op] !== undefined) CanvasGraphics.prototype[_util.OPS[op]] = CanvasGraphics.prototype[op];
            /***/ },
            /* 12 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TilingPattern = exports.PathType = void 0;
                exports.getShadingPattern = getShadingPattern;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const PathType = {
                    FILL: "Fill",
                    STROKE: "Stroke",
                    SHADING: "Shading"
                };
                exports.PathType = PathType;
                function applyBoundingBox(ctx, bbox) {
                    if (!bbox) return;
                    const width = bbox[2] - bbox[0];
                    const height = bbox[3] - bbox[1];
                    const region = new Path2D();
                    region.rect(bbox[0], bbox[1], width, height);
                    ctx.clip(region);
                }
                class BaseShadingPattern {
                    getPattern() {
                        (0, _util.unreachable)("Abstract method `getPattern` called.");
                    }
                    constructor(){
                        if (this.constructor === BaseShadingPattern) (0, _util.unreachable)("Cannot initialize BaseShadingPattern.");
                    }
                }
                class RadialAxialShadingPattern extends BaseShadingPattern {
                    _createGradient(ctx) {
                        let grad;
                        if (this._type === "axial") grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
                        else if (this._type === "radial") grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
                        for (const colorStop of this._colorStops)grad.addColorStop(colorStop[0], colorStop[1]);
                        return grad;
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let pattern;
                        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
                            const ownerBBox = owner.current.getClippedPathBoundingBox(pathType, (0, _display_utils.getCurrentTransform)(ctx)) || [
                                0,
                                0,
                                0,
                                0
                            ];
                            const width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
                            const height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
                            const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height, true);
                            const tmpCtx = tmpCanvas.context;
                            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.beginPath();
                            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
                            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
                            inverse = _util.Util.transform(inverse, [
                                1,
                                0,
                                0,
                                1,
                                ownerBBox[0],
                                ownerBBox[1]
                            ]);
                            tmpCtx.transform(...owner.baseTransform);
                            if (this.matrix) tmpCtx.transform(...this.matrix);
                            applyBoundingBox(tmpCtx, this._bbox);
                            tmpCtx.fillStyle = this._createGradient(tmpCtx);
                            tmpCtx.fill();
                            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
                            const domMatrix = new DOMMatrix(inverse);
                            pattern.setTransform(domMatrix);
                        } else {
                            applyBoundingBox(ctx, this._bbox);
                            pattern = this._createGradient(ctx);
                        }
                        return pattern;
                    }
                    constructor(IR){
                        super();
                        this._type = IR[1];
                        this._bbox = IR[2];
                        this._colorStops = IR[3];
                        this._p0 = IR[4];
                        this._p1 = IR[5];
                        this._r0 = IR[6];
                        this._r1 = IR[7];
                        this.matrix = null;
                    }
                }
                function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
                    const coords = context.coords, colors = context.colors;
                    const bytes = data.data, rowSize = data.width * 4;
                    let tmp;
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    if (coords[p2 + 1] > coords[p3 + 1]) {
                        tmp = p2;
                        p2 = p3;
                        p3 = tmp;
                        tmp = c2;
                        c2 = c3;
                        c3 = tmp;
                    }
                    if (coords[p1 + 1] > coords[p2 + 1]) {
                        tmp = p1;
                        p1 = p2;
                        p2 = tmp;
                        tmp = c1;
                        c1 = c2;
                        c2 = tmp;
                    }
                    const x1 = (coords[p1] + context.offsetX) * context.scaleX;
                    const y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
                    const x2 = (coords[p2] + context.offsetX) * context.scaleX;
                    const y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
                    const x3 = (coords[p3] + context.offsetX) * context.scaleX;
                    const y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
                    if (y1 >= y3) return;
                    const c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
                    const c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
                    const c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
                    const minY = Math.round(y1), maxY = Math.round(y3);
                    let xa, car, cag, cab;
                    let xb, cbr, cbg, cbb;
                    for(let y = minY; y <= maxY; y++){
                        if (y < y2) {
                            const k = y < y1 ? 0 : (y1 - y) / (y1 - y2);
                            xa = x1 - (x1 - x2) * k;
                            car = c1r - (c1r - c2r) * k;
                            cag = c1g - (c1g - c2g) * k;
                            cab = c1b - (c1b - c2b) * k;
                        } else {
                            let k;
                            if (y > y3) k = 1;
                            else if (y2 === y3) k = 0;
                            else k = (y2 - y) / (y2 - y3);
                            xa = x2 - (x2 - x3) * k;
                            car = c2r - (c2r - c3r) * k;
                            cag = c2g - (c2g - c3g) * k;
                            cab = c2b - (c2b - c3b) * k;
                        }
                        let k;
                        if (y < y1) k = 0;
                        else if (y > y3) k = 1;
                        else k = (y1 - y) / (y1 - y3);
                        xb = x1 - (x1 - x3) * k;
                        cbr = c1r - (c1r - c3r) * k;
                        cbg = c1g - (c1g - c3g) * k;
                        cbb = c1b - (c1b - c3b) * k;
                        const x1_ = Math.round(Math.min(xa, xb));
                        const x2_ = Math.round(Math.max(xa, xb));
                        let j = rowSize * y + x1_ * 4;
                        for(let x = x1_; x <= x2_; x++){
                            k = (xa - x) / (xa - xb);
                            if (k < 0) k = 0;
                            else if (k > 1) k = 1;
                            bytes[j++] = car - (car - cbr) * k | 0;
                            bytes[j++] = cag - (cag - cbg) * k | 0;
                            bytes[j++] = cab - (cab - cbb) * k | 0;
                            bytes[j++] = 255;
                        }
                    }
                }
                function drawFigure(data, figure, context) {
                    const ps = figure.coords;
                    const cs = figure.colors;
                    let i, ii;
                    switch(figure.type){
                        case "lattice":
                            const verticesPerRow = figure.verticesPerRow;
                            const rows = Math.floor(ps.length / verticesPerRow) - 1;
                            const cols = verticesPerRow - 1;
                            for(i = 0; i < rows; i++){
                                let q = i * verticesPerRow;
                                for(let j = 0; j < cols; j++, q++){
                                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                                }
                            }
                            break;
                        case "triangles":
                            for(i = 0, ii = ps.length; i < ii; i += 3)drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
                            break;
                        default:
                            throw new Error("illegal figure");
                    }
                }
                class MeshShadingPattern extends BaseShadingPattern {
                    _createMeshCanvas(combinedScale, backgroundColor, cachedCanvases) {
                        const EXPECTED_SCALE = 1.1;
                        const MAX_PATTERN_SIZE = 3000;
                        const BORDER_SIZE = 2;
                        const offsetX = Math.floor(this._bounds[0]);
                        const offsetY = Math.floor(this._bounds[1]);
                        const boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
                        const boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
                        const width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
                        const scaleX = boundsWidth / width;
                        const scaleY = boundsHeight / height;
                        const context = {
                            coords: this._coords,
                            colors: this._colors,
                            offsetX: -offsetX,
                            offsetY: -offsetY,
                            scaleX: 1 / scaleX,
                            scaleY: 1 / scaleY
                        };
                        const paddedWidth = width + BORDER_SIZE * 2;
                        const paddedHeight = height + BORDER_SIZE * 2;
                        const tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight, false);
                        const tmpCtx = tmpCanvas.context;
                        const data = tmpCtx.createImageData(width, height);
                        if (backgroundColor) {
                            const bytes = data.data;
                            for(let i = 0, ii = bytes.length; i < ii; i += 4){
                                bytes[i] = backgroundColor[0];
                                bytes[i + 1] = backgroundColor[1];
                                bytes[i + 2] = backgroundColor[2];
                                bytes[i + 3] = 255;
                            }
                        }
                        for (const figure of this._figures)drawFigure(data, figure, context);
                        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
                        const canvas = tmpCanvas.canvas;
                        return {
                            canvas: canvas,
                            offsetX: offsetX - BORDER_SIZE * scaleX,
                            offsetY: offsetY - BORDER_SIZE * scaleY,
                            scaleX: scaleX,
                            scaleY: scaleY
                        };
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        applyBoundingBox(ctx, this._bbox);
                        let scale;
                        if (pathType === PathType.SHADING) scale = _util.Util.singularValueDecompose2dScale((0, _display_utils.getCurrentTransform)(ctx));
                        else {
                            scale = _util.Util.singularValueDecompose2dScale(owner.baseTransform);
                            if (this.matrix) {
                                const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                                scale = [
                                    scale[0] * matrixScale[0],
                                    scale[1] * matrixScale[1]
                                ];
                            }
                        }
                        const temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
                        if (pathType !== PathType.SHADING) {
                            ctx.setTransform(...owner.baseTransform);
                            if (this.matrix) ctx.transform(...this.matrix);
                        }
                        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
                        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
                    }
                    constructor(IR){
                        super();
                        this._coords = IR[2];
                        this._colors = IR[3];
                        this._figures = IR[4];
                        this._bounds = IR[5];
                        this._bbox = IR[7];
                        this._background = IR[8];
                        this.matrix = null;
                    }
                }
                class DummyShadingPattern extends BaseShadingPattern {
                    getPattern() {
                        return "hotpink";
                    }
                }
                function getShadingPattern(IR) {
                    switch(IR[0]){
                        case "RadialAxial":
                            return new RadialAxialShadingPattern(IR);
                        case "Mesh":
                            return new MeshShadingPattern(IR);
                        case "Dummy":
                            return new DummyShadingPattern();
                    }
                    throw new Error(`Unknown IR type: ${IR[0]}`);
                }
                const PaintType = {
                    COLORED: 1,
                    UNCOLORED: 2
                };
                class TilingPattern {
                    createPatternCanvas(owner) {
                        const operatorList = this.operatorList;
                        const bbox = this.bbox;
                        const xstep = this.xstep;
                        const ystep = this.ystep;
                        const paintType = this.paintType;
                        const tilingType = this.tilingType;
                        const color = this.color;
                        const canvasGraphicsFactory = this.canvasGraphicsFactory;
                        (0, _util.info)("TilingType: " + tilingType);
                        const x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
                        const matrixScale = _util.Util.singularValueDecompose2dScale(this.matrix);
                        const curMatrixScale = _util.Util.singularValueDecompose2dScale(this.baseTransform);
                        const combinedScale = [
                            matrixScale[0] * curMatrixScale[0],
                            matrixScale[1] * curMatrixScale[1]
                        ];
                        const dimx = this.getSizeAndScale(xstep, this.ctx.canvas.width, combinedScale[0]);
                        const dimy = this.getSizeAndScale(ystep, this.ctx.canvas.height, combinedScale[1]);
                        const tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size, true);
                        const tmpCtx = tmpCanvas.context;
                        const graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
                        graphics.groupLevel = owner.groupLevel;
                        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
                        let adjustedX0 = x0;
                        let adjustedY0 = y0;
                        let adjustedX1 = x1;
                        let adjustedY1 = y1;
                        if (x0 < 0) {
                            adjustedX0 = 0;
                            adjustedX1 += Math.abs(x0);
                        }
                        if (y0 < 0) {
                            adjustedY0 = 0;
                            adjustedY1 += Math.abs(y0);
                        }
                        tmpCtx.translate(-(dimx.scale * adjustedX0), -(dimy.scale * adjustedY0));
                        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
                        tmpCtx.save();
                        this.clipBbox(graphics, adjustedX0, adjustedY0, adjustedX1, adjustedY1);
                        graphics.baseTransform = (0, _display_utils.getCurrentTransform)(graphics.ctx);
                        graphics.executeOperatorList(operatorList);
                        graphics.endDrawing();
                        return {
                            canvas: tmpCanvas.canvas,
                            scaleX: dimx.scale,
                            scaleY: dimy.scale,
                            offsetX: adjustedX0,
                            offsetY: adjustedY0
                        };
                    }
                    getSizeAndScale(step, realOutputSize, scale) {
                        step = Math.abs(step);
                        const maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
                        let size = Math.ceil(step * scale);
                        if (size >= maxSize) size = maxSize;
                        else scale = size / step;
                        return {
                            scale: scale,
                            size: size
                        };
                    }
                    clipBbox(graphics, x0, y0, x1, y1) {
                        const bboxWidth = x1 - x0;
                        const bboxHeight = y1 - y0;
                        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
                        graphics.current.updateRectMinMax((0, _display_utils.getCurrentTransform)(graphics.ctx), [
                            x0,
                            y0,
                            x1,
                            y1
                        ]);
                        graphics.clip();
                        graphics.endPath();
                    }
                    setFillAndStrokeStyleToContext(graphics, paintType, color) {
                        const context = graphics.ctx, current = graphics.current;
                        switch(paintType){
                            case PaintType.COLORED:
                                const ctx = this.ctx;
                                context.fillStyle = ctx.fillStyle;
                                context.strokeStyle = ctx.strokeStyle;
                                current.fillColor = ctx.fillStyle;
                                current.strokeColor = ctx.strokeStyle;
                                break;
                            case PaintType.UNCOLORED:
                                const cssColor = _util.Util.makeHexColor(color[0], color[1], color[2]);
                                context.fillStyle = cssColor;
                                context.strokeStyle = cssColor;
                                current.fillColor = cssColor;
                                current.strokeColor = cssColor;
                                break;
                            default:
                                throw new _util.FormatError(`Unsupported paint type: ${paintType}`);
                        }
                    }
                    getPattern(ctx, owner, inverse, pathType) {
                        let matrix = inverse;
                        if (pathType !== PathType.SHADING) {
                            matrix = _util.Util.transform(matrix, owner.baseTransform);
                            if (this.matrix) matrix = _util.Util.transform(matrix, this.matrix);
                        }
                        const temporaryPatternCanvas = this.createPatternCanvas(owner);
                        let domMatrix = new DOMMatrix(matrix);
                        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
                        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
                        const pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
                        pattern.setTransform(domMatrix);
                        return pattern;
                    }
                    constructor(IR, color, ctx, canvasGraphicsFactory, baseTransform){
                        this.operatorList = IR[2];
                        this.matrix = IR[3] || [
                            1,
                            0,
                            0,
                            1,
                            0,
                            0
                        ];
                        this.bbox = IR[4];
                        this.xstep = IR[5];
                        this.ystep = IR[6];
                        this.paintType = IR[7];
                        this.tilingType = IR[8];
                        this.color = color;
                        this.ctx = ctx;
                        this.canvasGraphicsFactory = canvasGraphicsFactory;
                        this.baseTransform = baseTransform;
                    }
                }
                (0, $yQrT8._)(TilingPattern, "MAX_PATTERN_SIZE", 3000);
                exports.TilingPattern = TilingPattern;
            /***/ },
            /* 13 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.convertBlackAndWhiteToRGBA = convertBlackAndWhiteToRGBA;
                exports.convertToRGBA = convertToRGBA;
                exports.grayToRGBA = grayToRGBA;
                var _util = __w_pdfjs_require__(1);
                function convertToRGBA(params) {
                    switch(params.kind){
                        case _util.ImageKind.GRAYSCALE_1BPP:
                            return convertBlackAndWhiteToRGBA(params);
                        case _util.ImageKind.RGB_24BPP:
                            return convertRGBToRGBA(params);
                    }
                    return null;
                }
                function convertBlackAndWhiteToRGBA({ src, srcPos = 0, dest, width, height, nonBlackColor = 0xffffffff, inverseDecode = false }) {
                    const black = _util.FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
                    const [zeroMapping, oneMapping] = inverseDecode ? [
                        nonBlackColor,
                        black
                    ] : [
                        black,
                        nonBlackColor
                    ];
                    const widthInSource = width >> 3;
                    const widthRemainder = width & 7;
                    const srcLength = src.length;
                    dest = new Uint32Array(dest.buffer);
                    let destPos = 0;
                    for(let i = 0; i < height; i++){
                        for(const max = srcPos + widthInSource; srcPos < max; srcPos++){
                            const elem = srcPos < srcLength ? src[srcPos] : 255;
                            dest[destPos++] = elem & 128 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 64 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 32 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 16 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 8 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 4 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 2 ? oneMapping : zeroMapping;
                            dest[destPos++] = elem & 1 ? oneMapping : zeroMapping;
                        }
                        if (widthRemainder === 0) continue;
                        const elem = srcPos < srcLength ? src[srcPos++] : 255;
                        for(let j = 0; j < widthRemainder; j++)dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function convertRGBToRGBA({ src, srcPos = 0, dest, destPos = 0, width, height }) {
                    let i = 0;
                    const len32 = src.length >> 2;
                    const src32 = new Uint32Array(src.buffer, srcPos, len32);
                    if (_util.FeatureTest.isLittleEndian) {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff000000;
                            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
                            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
                            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
                    } else {
                        for(; i < len32 - 2; i += 3, destPos += 4){
                            const s1 = src32[i];
                            const s2 = src32[i + 1];
                            const s3 = src32[i + 2];
                            dest[destPos] = s1 | 0xff;
                            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
                            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
                            dest[destPos + 3] = s3 << 8 | 0xff;
                        }
                        for(let j = i * 4, jj = src.length; j < jj; j += 3)dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
                    }
                    return {
                        srcPos: srcPos,
                        destPos: destPos
                    };
                }
                function grayToRGBA(src, dest) {
                    if (_util.FeatureTest.isLittleEndian) for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x10101 | 0xff000000;
                    else for(let i = 0, ii = src.length; i < ii; i++)dest[i] = src[i] * 0x1010100 | 0x000000ff;
                }
            /***/ },
            /* 14 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.GlobalWorkerOptions = void 0;
                const GlobalWorkerOptions = Object.create(null);
                exports.GlobalWorkerOptions = GlobalWorkerOptions;
                GlobalWorkerOptions.workerPort = null;
                GlobalWorkerOptions.workerSrc = "";
            /***/ },
            /* 15 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.MessageHandler = void 0;
                var _util = __w_pdfjs_require__(1);
                const CallbackKind = {
                    UNKNOWN: 0,
                    DATA: 1,
                    ERROR: 2
                };
                const StreamKind = {
                    UNKNOWN: 0,
                    CANCEL: 1,
                    CANCEL_COMPLETE: 2,
                    CLOSE: 3,
                    ENQUEUE: 4,
                    ERROR: 5,
                    PULL: 6,
                    PULL_COMPLETE: 7,
                    START_COMPLETE: 8
                };
                function wrapReason(reason) {
                    if (!(reason instanceof Error || typeof reason === "object" && reason !== null)) (0, _util.unreachable)('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
                    switch(reason.name){
                        case "AbortException":
                            return new _util.AbortException(reason.message);
                        case "MissingPDFException":
                            return new _util.MissingPDFException(reason.message);
                        case "PasswordException":
                            return new _util.PasswordException(reason.message, reason.code);
                        case "UnexpectedResponseException":
                            return new _util.UnexpectedResponseException(reason.message, reason.status);
                        case "UnknownErrorException":
                            return new _util.UnknownErrorException(reason.message, reason.details);
                        default:
                            return new _util.UnknownErrorException(reason.message, reason.toString());
                    }
                }
                var _createStreamSink = /*#__PURE__*/ new WeakSet(), _processStreamMessage = /*#__PURE__*/ new WeakSet(), _deleteStreamController = /*#__PURE__*/ new WeakSet();
                class MessageHandler {
                    on(actionName, handler) {
                        const ah = this.actionHandler;
                        if (ah[actionName]) throw new Error(`There is already an actionName called "${actionName}"`);
                        ah[actionName] = handler;
                    }
                    send(actionName, data, transfers) {
                        this.comObj.postMessage({
                            sourceName: this.sourceName,
                            targetName: this.targetName,
                            action: actionName,
                            data: data
                        }, transfers);
                    }
                    sendWithPromise(actionName, data, transfers) {
                        const callbackId = this.callbackId++;
                        const capability = new _util.PromiseCapability();
                        this.callbackCapabilities[callbackId] = capability;
                        try {
                            this.comObj.postMessage({
                                sourceName: this.sourceName,
                                targetName: this.targetName,
                                action: actionName,
                                callbackId: callbackId,
                                data: data
                            }, transfers);
                        } catch (ex) {
                            capability.reject(ex);
                        }
                        return capability.promise;
                    }
                    sendWithStream(actionName, data, queueingStrategy, transfers) {
                        const streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
                        return new ReadableStream({
                            start: (controller)=>{
                                const startCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId] = {
                                    controller: controller,
                                    startCall: startCapability,
                                    pullCall: null,
                                    cancelCall: null,
                                    isClosed: false
                                };
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    action: actionName,
                                    streamId: streamId,
                                    data: data,
                                    desiredSize: controller.desiredSize
                                }, transfers);
                                return startCapability.promise;
                            },
                            pull: (controller)=>{
                                const pullCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].pullCall = pullCapability;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL,
                                    streamId: streamId,
                                    desiredSize: controller.desiredSize
                                });
                                return pullCapability.promise;
                            },
                            cancel: (reason)=>{
                                (0, _util.assert)(reason instanceof Error, "cancel must have a valid reason");
                                const cancelCapability = new _util.PromiseCapability();
                                this.streamControllers[streamId].cancelCall = cancelCapability;
                                this.streamControllers[streamId].isClosed = true;
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                                return cancelCapability.promise;
                            }
                        }, queueingStrategy);
                    }
                    destroy() {
                        this.comObj.removeEventListener("message", this._onComObjOnMessage);
                    }
                    constructor(sourceName, targetName, comObj){
                        (0, $2IZAT._)(this, _createStreamSink);
                        (0, $2IZAT._)(this, _processStreamMessage);
                        (0, $2IZAT._)(this, _deleteStreamController);
                        this.sourceName = sourceName;
                        this.targetName = targetName;
                        this.comObj = comObj;
                        this.callbackId = 1;
                        this.streamId = 1;
                        this.streamSinks = Object.create(null);
                        this.streamControllers = Object.create(null);
                        this.callbackCapabilities = Object.create(null);
                        this.actionHandler = Object.create(null);
                        this._onComObjOnMessage = (event)=>{
                            const data = event.data;
                            if (data.targetName !== this.sourceName) return;
                            if (data.stream) {
                                (0, $hDjZy._)(this, _processStreamMessage, processStreamMessage).call(this, data);
                                return;
                            }
                            if (data.callback) {
                                const callbackId = data.callbackId;
                                const capability = this.callbackCapabilities[callbackId];
                                if (!capability) throw new Error(`Cannot resolve callback ${callbackId}`);
                                delete this.callbackCapabilities[callbackId];
                                if (data.callback === CallbackKind.DATA) capability.resolve(data.data);
                                else if (data.callback === CallbackKind.ERROR) capability.reject(wrapReason(data.reason));
                                else throw new Error("Unexpected callback case");
                                return;
                            }
                            const action = this.actionHandler[data.action];
                            if (!action) throw new Error(`Unknown action from worker: ${data.action}`);
                            if (data.callbackId) {
                                const cbSourceName = this.sourceName;
                                const cbTargetName = data.sourceName;
                                new Promise(function(resolve) {
                                    resolve(action(data.data));
                                }).then(function(result) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.DATA,
                                        callbackId: data.callbackId,
                                        data: result
                                    });
                                }, function(reason) {
                                    comObj.postMessage({
                                        sourceName: cbSourceName,
                                        targetName: cbTargetName,
                                        callback: CallbackKind.ERROR,
                                        callbackId: data.callbackId,
                                        reason: wrapReason(reason)
                                    });
                                });
                                return;
                            }
                            if (data.streamId) {
                                (0, $hDjZy._)(this, _createStreamSink, createStreamSink).call(this, data);
                                return;
                            }
                            action(data.data);
                        };
                        comObj.addEventListener("message", this._onComObjOnMessage);
                    }
                }
                function createStreamSink(data) {
                    const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                    const self = this, action = this.actionHandler[data.action];
                    const streamSink = {
                        enqueue (chunk, size = 1, transfers) {
                            if (this.isCancelled) return;
                            const lastDesiredSize = this.desiredSize;
                            this.desiredSize -= size;
                            if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                                this.sinkCapability = new _util.PromiseCapability();
                                this.ready = this.sinkCapability.promise;
                            }
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.ENQUEUE,
                                streamId: streamId,
                                chunk: chunk
                            }, transfers);
                        },
                        close () {
                            if (this.isCancelled) return;
                            this.isCancelled = true;
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.CLOSE,
                                streamId: streamId
                            });
                            delete self.streamSinks[streamId];
                        },
                        error (reason) {
                            (0, _util.assert)(reason instanceof Error, "error must have a valid reason");
                            if (this.isCancelled) return;
                            this.isCancelled = true;
                            comObj.postMessage({
                                sourceName: sourceName,
                                targetName: targetName,
                                stream: StreamKind.ERROR,
                                streamId: streamId,
                                reason: wrapReason(reason)
                            });
                        },
                        sinkCapability: new _util.PromiseCapability(),
                        onPull: null,
                        onCancel: null,
                        isCancelled: false,
                        desiredSize: data.desiredSize,
                        ready: null
                    };
                    streamSink.sinkCapability.resolve();
                    streamSink.ready = streamSink.sinkCapability.promise;
                    this.streamSinks[streamId] = streamSink;
                    new Promise(function(resolve) {
                        resolve(action(data.data, streamSink));
                    }).then(function() {
                        comObj.postMessage({
                            sourceName: sourceName,
                            targetName: targetName,
                            stream: StreamKind.START_COMPLETE,
                            streamId: streamId,
                            success: true
                        });
                    }, function(reason) {
                        comObj.postMessage({
                            sourceName: sourceName,
                            targetName: targetName,
                            stream: StreamKind.START_COMPLETE,
                            streamId: streamId,
                            reason: wrapReason(reason)
                        });
                    });
                }
                function processStreamMessage(data) {
                    const streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
                    const streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
                    switch(data.stream){
                        case StreamKind.START_COMPLETE:
                            if (data.success) streamController.startCall.resolve();
                            else streamController.startCall.reject(wrapReason(data.reason));
                            break;
                        case StreamKind.PULL_COMPLETE:
                            if (data.success) streamController.pullCall.resolve();
                            else streamController.pullCall.reject(wrapReason(data.reason));
                            break;
                        case StreamKind.PULL:
                            if (!streamSink) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                                break;
                            }
                            if (streamSink.desiredSize <= 0 && data.desiredSize > 0) streamSink.sinkCapability.resolve();
                            streamSink.desiredSize = data.desiredSize;
                            new Promise(function(resolve) {
                                var _streamSink_onPull;
                                resolve((_streamSink_onPull = streamSink.onPull) === null || _streamSink_onPull === void 0 ? void 0 : _streamSink_onPull.call(streamSink));
                            }).then(function() {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                            }, function(reason) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.PULL_COMPLETE,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            });
                            break;
                        case StreamKind.ENQUEUE:
                            (0, _util.assert)(streamController, "enqueue should have stream controller");
                            if (streamController.isClosed) break;
                            streamController.controller.enqueue(data.chunk);
                            break;
                        case StreamKind.CLOSE:
                            (0, _util.assert)(streamController, "close should have stream controller");
                            if (streamController.isClosed) break;
                            streamController.isClosed = true;
                            streamController.controller.close();
                            (0, $hDjZy._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.ERROR:
                            (0, _util.assert)(streamController, "error should have stream controller");
                            streamController.controller.error(wrapReason(data.reason));
                            (0, $hDjZy._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.CANCEL_COMPLETE:
                            if (data.success) streamController.cancelCall.resolve();
                            else streamController.cancelCall.reject(wrapReason(data.reason));
                            (0, $hDjZy._)(this, _deleteStreamController, deleteStreamController).call(this, streamController, streamId);
                            break;
                        case StreamKind.CANCEL:
                            if (!streamSink) break;
                            new Promise(function(resolve) {
                                var _streamSink_onCancel;
                                resolve((_streamSink_onCancel = streamSink.onCancel) === null || _streamSink_onCancel === void 0 ? void 0 : _streamSink_onCancel.call(streamSink, wrapReason(data.reason)));
                            }).then(function() {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL_COMPLETE,
                                    streamId: streamId,
                                    success: true
                                });
                            }, function(reason) {
                                comObj.postMessage({
                                    sourceName: sourceName,
                                    targetName: targetName,
                                    stream: StreamKind.CANCEL_COMPLETE,
                                    streamId: streamId,
                                    reason: wrapReason(reason)
                                });
                            });
                            streamSink.sinkCapability.reject(wrapReason(data.reason));
                            streamSink.isCancelled = true;
                            delete this.streamSinks[streamId];
                            break;
                        default:
                            throw new Error("Unexpected stream case");
                    }
                }
                function deleteStreamController(streamController, streamId) {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        var _streamController_startCall, _streamController_pullCall, _streamController_cancelCall;
                        yield Promise.allSettled([
                            (_streamController_startCall = streamController.startCall) === null || _streamController_startCall === void 0 ? void 0 : _streamController_startCall.promise,
                            (_streamController_pullCall = streamController.pullCall) === null || _streamController_pullCall === void 0 ? void 0 : _streamController_pullCall.promise,
                            (_streamController_cancelCall = streamController.cancelCall) === null || _streamController_cancelCall === void 0 ? void 0 : _streamController_cancelCall.promise
                        ]);
                        delete this.streamControllers[streamId];
                    }).call(this);
                }
                exports.MessageHandler = MessageHandler;
            /***/ },
            /* 16 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.Metadata = void 0;
                var _util = __w_pdfjs_require__(1);
                var _metadataMap = /*#__PURE__*/ new WeakMap(), _data = /*#__PURE__*/ new WeakMap();
                class Metadata {
                    getRaw() {
                        return (0, $f2lgg._)(this, _data);
                    }
                    get(name) {
                        var _class_private_field_get_get;
                        return (_class_private_field_get_get = (0, $f2lgg._)(this, _metadataMap).get(name)) !== null && _class_private_field_get_get !== void 0 ? _class_private_field_get_get : null;
                    }
                    getAll() {
                        return (0, _util.objectFromMap)((0, $f2lgg._)(this, _metadataMap));
                    }
                    has(name) {
                        return (0, $f2lgg._)(this, _metadataMap).has(name);
                    }
                    constructor({ parsedData, rawData }){
                        (0, $iXPoG._)(this, _metadataMap, {
                            writable: true,
                            value: void 0
                        });
                        (0, $iXPoG._)(this, _data, {
                            writable: true,
                            value: void 0
                        });
                        (0, $5grPd._)(this, _metadataMap, parsedData);
                        (0, $5grPd._)(this, _data, rawData);
                    }
                }
                exports.Metadata = Metadata;
            /***/ },
            /* 17 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.OptionalContentConfig = void 0;
                var _util = __w_pdfjs_require__(1);
                var _murmurhash = __w_pdfjs_require__(8);
                const INTERNAL = Symbol("INTERNAL");
                var _visible = /*#__PURE__*/ new WeakMap();
                class OptionalContentGroup {
                    get visible() {
                        return (0, $f2lgg._)(this, _visible);
                    }
                    _setVisible(internal, visible) {
                        if (internal !== INTERNAL) (0, _util.unreachable)("Internal method `_setVisible` called.");
                        (0, $5grPd._)(this, _visible, visible);
                    }
                    constructor(name, intent){
                        (0, $iXPoG._)(this, _visible, {
                            writable: true,
                            value: true
                        });
                        this.name = name;
                        this.intent = intent;
                    }
                }
                var _cachedGetHash = /*#__PURE__*/ new WeakMap(), _groups = /*#__PURE__*/ new WeakMap(), _initialHash = /*#__PURE__*/ new WeakMap(), _order = /*#__PURE__*/ new WeakMap(), _evaluateVisibilityExpression = /*#__PURE__*/ new WeakSet();
                class OptionalContentConfig {
                    isVisible(group) {
                        if ((0, $f2lgg._)(this, _groups).size === 0) return true;
                        if (!group) {
                            (0, _util.warn)("Optional content group not defined.");
                            return true;
                        }
                        if (group.type === "OCG") {
                            if (!(0, $f2lgg._)(this, _groups).has(group.id)) {
                                (0, _util.warn)(`Optional content group not found: ${group.id}`);
                                return true;
                            }
                            return (0, $f2lgg._)(this, _groups).get(group.id).visible;
                        } else if (group.type === "OCMD") {
                            if (group.expression) return (0, $hDjZy._)(this, _evaluateVisibilityExpression, evaluateVisibilityExpression).call(this, group.expression);
                            if (!group.policy || group.policy === "AnyOn") {
                                for (const id of group.ids){
                                    if (!(0, $f2lgg._)(this, _groups).has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if ((0, $f2lgg._)(this, _groups).get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOn") {
                                for (const id of group.ids){
                                    if (!(0, $f2lgg._)(this, _groups).has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!(0, $f2lgg._)(this, _groups).get(id).visible) return false;
                                }
                                return true;
                            } else if (group.policy === "AnyOff") {
                                for (const id of group.ids){
                                    if (!(0, $f2lgg._)(this, _groups).has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if (!(0, $f2lgg._)(this, _groups).get(id).visible) return true;
                                }
                                return false;
                            } else if (group.policy === "AllOff") {
                                for (const id of group.ids){
                                    if (!(0, $f2lgg._)(this, _groups).has(id)) {
                                        (0, _util.warn)(`Optional content group not found: ${id}`);
                                        return true;
                                    }
                                    if ((0, $f2lgg._)(this, _groups).get(id).visible) return false;
                                }
                                return true;
                            }
                            (0, _util.warn)(`Unknown optional content policy ${group.policy}.`);
                            return true;
                        }
                        (0, _util.warn)(`Unknown group type ${group.type}.`);
                        return true;
                    }
                    setVisibility(id, visible = true) {
                        if (!(0, $f2lgg._)(this, _groups).has(id)) {
                            (0, _util.warn)(`Optional content group not found: ${id}`);
                            return;
                        }
                        (0, $f2lgg._)(this, _groups).get(id)._setVisible(INTERNAL, !!visible);
                        (0, $5grPd._)(this, _cachedGetHash, null);
                    }
                    get hasInitialVisibility() {
                        return (0, $f2lgg._)(this, _initialHash) === null || this.getHash() === (0, $f2lgg._)(this, _initialHash);
                    }
                    getOrder() {
                        if (!(0, $f2lgg._)(this, _groups).size) return null;
                        if ((0, $f2lgg._)(this, _order)) return (0, $f2lgg._)(this, _order).slice();
                        return [
                            ...(0, $f2lgg._)(this, _groups).keys()
                        ];
                    }
                    getGroups() {
                        return (0, $f2lgg._)(this, _groups).size > 0 ? (0, _util.objectFromMap)((0, $f2lgg._)(this, _groups)) : null;
                    }
                    getGroup(id) {
                        return (0, $f2lgg._)(this, _groups).get(id) || null;
                    }
                    getHash() {
                        if ((0, $f2lgg._)(this, _cachedGetHash) !== null) return (0, $f2lgg._)(this, _cachedGetHash);
                        const hash = new _murmurhash.MurmurHash3_64();
                        for (const [id, group] of (0, $f2lgg._)(this, _groups))hash.update(`${id}:${group.visible}`);
                        return (0, $5grPd._)(this, _cachedGetHash, hash.hexdigest());
                    }
                    constructor(data){
                        (0, $2IZAT._)(this, _evaluateVisibilityExpression);
                        (0, $iXPoG._)(this, _cachedGetHash, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _groups, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _initialHash, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _order, {
                            writable: true,
                            value: null
                        });
                        this.name = null;
                        this.creator = null;
                        if (data === null) return;
                        this.name = data.name;
                        this.creator = data.creator;
                        (0, $5grPd._)(this, _order, data.order);
                        for (const group of data.groups)(0, $f2lgg._)(this, _groups).set(group.id, new OptionalContentGroup(group.name, group.intent));
                        if (data.baseState === "OFF") for (const group of (0, $f2lgg._)(this, _groups).values())group._setVisible(INTERNAL, false);
                        for (const on of data.on)(0, $f2lgg._)(this, _groups).get(on)._setVisible(INTERNAL, true);
                        for (const off of data.off)(0, $f2lgg._)(this, _groups).get(off)._setVisible(INTERNAL, false);
                        (0, $5grPd._)(this, _initialHash, this.getHash());
                    }
                }
                function evaluateVisibilityExpression(array) {
                    const length = array.length;
                    if (length < 2) return true;
                    const operator = array[0];
                    for(let i = 1; i < length; i++){
                        const element = array[i];
                        let state;
                        if (Array.isArray(element)) state = (0, $hDjZy._)(this, _evaluateVisibilityExpression, evaluateVisibilityExpression).call(this, element);
                        else if ((0, $f2lgg._)(this, _groups).has(element)) state = (0, $f2lgg._)(this, _groups).get(element).visible;
                        else {
                            (0, _util.warn)(`Optional content group not found: ${element}`);
                            return true;
                        }
                        switch(operator){
                            case "And":
                                if (!state) return false;
                                break;
                            case "Or":
                                if (state) return true;
                                break;
                            case "Not":
                                return !state;
                            default:
                                return true;
                        }
                    }
                    return operator === "And";
                }
                exports.OptionalContentConfig = OptionalContentConfig;
            /***/ },
            /* 18 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFDataTransportStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                class PDFDataTransportStream {
                    _onReceiveData({ begin, chunk }) {
                        const buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
                        if (begin === undefined) {
                            if (this._fullRequestReader) this._fullRequestReader._enqueue(buffer);
                            else this._queuedChunks.push(buffer);
                        } else {
                            const found = this._rangeReaders.some(function(rangeReader) {
                                if (rangeReader._begin !== begin) return false;
                                rangeReader._enqueue(buffer);
                                return true;
                            });
                            (0, _util.assert)(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
                        }
                    }
                    get _progressiveDataLength() {
                        var _this__fullRequestReader;
                        var _this__fullRequestReader__loaded;
                        return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                    }
                    _onProgress(evt) {
                        var _this__rangeReaders__onProgress, _this__rangeReaders_, _this__fullRequestReader_onProgress, _this__fullRequestReader;
                        if (evt.total === undefined) (_this__rangeReaders_ = this._rangeReaders[0]) === null || _this__rangeReaders_ === void 0 ? void 0 : (_this__rangeReaders__onProgress = _this__rangeReaders_.onProgress) === null || _this__rangeReaders__onProgress === void 0 ? void 0 : _this__rangeReaders__onProgress.call(_this__rangeReaders_, {
                            loaded: evt.loaded
                        });
                        else (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : (_this__fullRequestReader_onProgress = _this__fullRequestReader.onProgress) === null || _this__fullRequestReader_onProgress === void 0 ? void 0 : _this__fullRequestReader_onProgress.call(_this__fullRequestReader, {
                            loaded: evt.loaded,
                            total: evt.total
                        });
                    }
                    _onProgressiveDone() {
                        var _this__fullRequestReader;
                        (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.progressiveDone();
                        this._progressiveDone = true;
                    }
                    _removeRangeReader(reader) {
                        const i = this._rangeReaders.indexOf(reader);
                        if (i >= 0) this._rangeReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
                        const queuedChunks = this._queuedChunks;
                        this._queuedChunks = null;
                        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFDataTransportStreamRangeReader(this, begin, end);
                        this._pdfDataRangeTransport.requestDataRange(begin, end);
                        this._rangeReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        var _this__fullRequestReader;
                        (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                        for (const reader of this._rangeReaders.slice(0))reader.cancel(reason);
                        this._pdfDataRangeTransport.abort();
                    }
                    constructor({ length, initialData, progressiveDone = false, contentDispositionFilename = null, disableRange = false, disableStream = false }, pdfDataRangeTransport){
                        (0, _util.assert)(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
                        this._queuedChunks = [];
                        this._progressiveDone = progressiveDone;
                        this._contentDispositionFilename = contentDispositionFilename;
                        if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
                            const buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
                            this._queuedChunks.push(buffer);
                        }
                        this._pdfDataRangeTransport = pdfDataRangeTransport;
                        this._isStreamingSupported = !disableStream;
                        this._isRangeSupported = !disableRange;
                        this._contentLength = length;
                        this._fullRequestReader = null;
                        this._rangeReaders = [];
                        this._pdfDataRangeTransport.addRangeListener((begin, chunk)=>{
                            this._onReceiveData({
                                begin: begin,
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressListener((loaded, total)=>{
                            this._onProgress({
                                loaded: loaded,
                                total: total
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveReadListener((chunk)=>{
                            this._onReceiveData({
                                chunk: chunk
                            });
                        });
                        this._pdfDataRangeTransport.addProgressiveDoneListener(()=>{
                            this._onProgressiveDone();
                        });
                        this._pdfDataRangeTransport.transportReady();
                    }
                }
                exports.PDFDataTransportStream = PDFDataTransportStream;
                class PDFDataTransportStreamReader {
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunks.push(chunk);
                        this._loaded += chunk.byteLength;
                    }
                    get headersReady() {
                        return this._headersReady;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._stream._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._stream._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._stream._contentLength;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this._queuedChunks.length > 0) {
                                const chunk = this._queuedChunks.shift();
                                return {
                                    value: chunk,
                                    done: false
                                };
                            }
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            const requestCapability = new _util.PromiseCapability();
                            this._requests.push(requestCapability);
                            return requestCapability.promise;
                        }).call(this);
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    progressiveDone() {
                        if (this._done) return;
                        this._done = true;
                    }
                    constructor(stream, queuedChunks, progressiveDone = false, contentDispositionFilename = null){
                        this._stream = stream;
                        this._done = progressiveDone || false;
                        this._filename = (0, _display_utils.isPdfFile)(contentDispositionFilename) ? contentDispositionFilename : null;
                        this._queuedChunks = queuedChunks || [];
                        this._loaded = 0;
                        for (const chunk of this._queuedChunks)this._loaded += chunk.byteLength;
                        this._requests = [];
                        this._headersReady = Promise.resolve();
                        stream._fullRequestReader = this;
                        this.onProgress = null;
                    }
                }
                class PDFDataTransportStreamRangeReader {
                    _enqueue(chunk) {
                        if (this._done) return;
                        if (this._requests.length === 0) this._queuedChunk = chunk;
                        else {
                            const requestsCapability = this._requests.shift();
                            requestsCapability.resolve({
                                value: chunk,
                                done: false
                            });
                            for (const requestCapability of this._requests)requestCapability.resolve({
                                value: undefined,
                                done: true
                            });
                            this._requests.length = 0;
                        }
                        this._done = true;
                        this._stream._removeRangeReader(this);
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this._queuedChunk) {
                                const chunk = this._queuedChunk;
                                this._queuedChunk = null;
                                return {
                                    value: chunk,
                                    done: false
                                };
                            }
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            const requestCapability = new _util.PromiseCapability();
                            this._requests.push(requestCapability);
                            return requestCapability.promise;
                        }).call(this);
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._stream._removeRangeReader(this);
                    }
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._begin = begin;
                        this._end = end;
                        this._queuedChunk = null;
                        this._requests = [];
                        this._done = false;
                        this.onProgress = null;
                    }
                }
            /***/ },
            /* 19 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFFetchStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                function createFetchOptions(headers, withCredentials, abortController) {
                    return {
                        method: "GET",
                        headers: headers,
                        signal: abortController.signal,
                        mode: "cors",
                        credentials: withCredentials ? "include" : "same-origin",
                        redirect: "follow"
                    };
                }
                function createHeaders(httpHeaders) {
                    const headers = new Headers();
                    for(const property in httpHeaders){
                        const value = httpHeaders[property];
                        if (value === undefined) continue;
                        headers.append(property, value);
                    }
                    return headers;
                }
                function getArrayBuffer(val) {
                    if (val instanceof Uint8Array) return val.buffer;
                    if (val instanceof ArrayBuffer) return val;
                    (0, _util.warn)(`getArrayBuffer - unexpected data format: ${val}`);
                    return new Uint8Array(val).buffer;
                }
                class PDFFetchStream {
                    get _progressiveDataLength() {
                        var _this__fullRequestReader;
                        var _this__fullRequestReader__loaded;
                        return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFFetchStreamReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const reader = new PDFFetchStreamRangeReader(this, begin, end);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        var _this__fullRequestReader;
                        (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                    constructor(source){
                        this.source = source;
                        this.isHttp = /^https?:/i.test(source.url);
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                }
                exports.PDFFetchStream = PDFFetchStream;
                class PDFFetchStreamReader {
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            var _this_onProgress, _this;
                            yield this._headersCapability.promise;
                            const { value, done } = yield this._reader.read();
                            if (done) return {
                                value: value,
                                done: done
                            };
                            this._loaded += value.byteLength;
                            (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                loaded: this._loaded,
                                total: this._contentLength
                            });
                            return {
                                value: getArrayBuffer(value),
                                done: false
                            };
                        }).call(this);
                    }
                    cancel(reason) {
                        var _this__reader;
                        (_this__reader = this._reader) === null || _this__reader === void 0 ? void 0 : _this__reader.cancel(reason);
                        this._abortController.abort();
                    }
                    constructor(stream){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        this._filename = null;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._contentLength = source.length;
                        this._headersCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._abortController = new AbortController();
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._headers = createHeaders(this._stream.httpHeaders);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._reader = response.body.getReader();
                            this._headersCapability.resolve();
                            const getResponseHeader = (name)=>{
                                return response.headers.get(name);
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: this._stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                            if (!this._isStreamingSupported && this._isRangeSupported) this.cancel(new _util.AbortException("Streaming is disabled."));
                        }).catch(this._headersCapability.reject);
                        this.onProgress = null;
                    }
                }
                class PDFFetchStreamRangeReader {
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            var _this_onProgress, _this;
                            yield this._readCapability.promise;
                            const { value, done } = yield this._reader.read();
                            if (done) return {
                                value: value,
                                done: done
                            };
                            this._loaded += value.byteLength;
                            (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                loaded: this._loaded
                            });
                            return {
                                value: getArrayBuffer(value),
                                done: false
                            };
                        }).call(this);
                    }
                    cancel(reason) {
                        var _this__reader;
                        (_this__reader = this._reader) === null || _this__reader === void 0 ? void 0 : _this__reader.cancel(reason);
                        this._abortController.abort();
                    }
                    constructor(stream, begin, end){
                        this._stream = stream;
                        this._reader = null;
                        this._loaded = 0;
                        const source = stream.source;
                        this._withCredentials = source.withCredentials || false;
                        this._readCapability = new _util.PromiseCapability();
                        this._isStreamingSupported = !source.disableStream;
                        this._abortController = new AbortController();
                        this._headers = createHeaders(this._stream.httpHeaders);
                        this._headers.append("Range", `bytes=${begin}-${end - 1}`);
                        const url = source.url;
                        fetch(url, createFetchOptions(this._headers, this._withCredentials, this._abortController)).then((response)=>{
                            if (!(0, _network_utils.validateResponseStatus)(response.status)) throw (0, _network_utils.createResponseStatusError)(response.status, url);
                            this._readCapability.resolve();
                            this._reader = response.body.getReader();
                        }).catch(this._readCapability.reject);
                        this.onProgress = null;
                    }
                }
            /***/ },
            /* 20 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.createResponseStatusError = createResponseStatusError;
                exports.extractFilenameFromHeader = extractFilenameFromHeader;
                exports.validateRangeRequestCapabilities = validateRangeRequestCapabilities;
                exports.validateResponseStatus = validateResponseStatus;
                var _util = __w_pdfjs_require__(1);
                var _content_disposition = __w_pdfjs_require__(21);
                var _display_utils = __w_pdfjs_require__(6);
                function validateRangeRequestCapabilities({ getResponseHeader, isHttp, rangeChunkSize, disableRange }) {
                    const returnValues = {
                        allowRangeRequests: false,
                        suggestedLength: undefined
                    };
                    const length = parseInt(getResponseHeader("Content-Length"), 10);
                    if (!Number.isInteger(length)) return returnValues;
                    returnValues.suggestedLength = length;
                    if (length <= 2 * rangeChunkSize) return returnValues;
                    if (disableRange || !isHttp) return returnValues;
                    if (getResponseHeader("Accept-Ranges") !== "bytes") return returnValues;
                    const contentEncoding = getResponseHeader("Content-Encoding") || "identity";
                    if (contentEncoding !== "identity") return returnValues;
                    returnValues.allowRangeRequests = true;
                    return returnValues;
                }
                function extractFilenameFromHeader(getResponseHeader) {
                    const contentDisposition = getResponseHeader("Content-Disposition");
                    if (contentDisposition) {
                        let filename = (0, _content_disposition.getFilenameFromContentDispositionHeader)(contentDisposition);
                        if (filename.includes("%")) try {
                            filename = decodeURIComponent(filename);
                        } catch (e) {}
                        if ((0, _display_utils.isPdfFile)(filename)) return filename;
                    }
                    return null;
                }
                function createResponseStatusError(status, url) {
                    if (status === 404 || status === 0 && url.startsWith("file:")) return new _util.MissingPDFException('Missing PDF "' + url + '".');
                    return new _util.UnexpectedResponseException(`Unexpected server response (${status}) while retrieving PDF "${url}".`, status);
                }
                function validateResponseStatus(status) {
                    return status === 200 || status === 206;
                }
            /***/ },
            /* 21 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.getFilenameFromContentDispositionHeader = getFilenameFromContentDispositionHeader;
                var _util = __w_pdfjs_require__(1);
                function getFilenameFromContentDispositionHeader(contentDisposition) {
                    let needsEncodingFixup = true;
                    let tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = unescape(filename);
                        filename = rfc5987decode(filename);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    tmp = rfc2231getparam(contentDisposition);
                    if (tmp) {
                        const filename = rfc2047decode(tmp);
                        return fixupEncoding(filename);
                    }
                    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
                    if (tmp) {
                        tmp = tmp[1];
                        let filename = rfc2616unquote(tmp);
                        filename = rfc2047decode(filename);
                        return fixupEncoding(filename);
                    }
                    function toParamRegExp(attributePattern, flags) {
                        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
                    }
                    function textdecode(encoding, value) {
                        if (encoding) {
                            if (!/^[\x00-\xFF]+$/.test(value)) return value;
                            try {
                                const decoder = new TextDecoder(encoding, {
                                    fatal: true
                                });
                                const buffer = (0, _util.stringToBytes)(value);
                                value = decoder.decode(buffer);
                                needsEncodingFixup = false;
                            } catch (e) {}
                        }
                        return value;
                    }
                    function fixupEncoding(value) {
                        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
                            value = textdecode("utf-8", value);
                            if (needsEncodingFixup) value = textdecode("iso-8859-1", value);
                        }
                        return value;
                    }
                    function rfc2231getparam(contentDispositionStr) {
                        const matches = [];
                        let match;
                        const iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
                        while((match = iter.exec(contentDispositionStr)) !== null){
                            let [, n, quot, part] = match;
                            n = parseInt(n, 10);
                            if (n in matches) {
                                if (n === 0) break;
                                continue;
                            }
                            matches[n] = [
                                quot,
                                part
                            ];
                        }
                        const parts = [];
                        for(let n = 0; n < matches.length; ++n){
                            if (!(n in matches)) break;
                            let [quot, part] = matches[n];
                            part = rfc2616unquote(part);
                            if (quot) {
                                part = unescape(part);
                                if (n === 0) part = rfc5987decode(part);
                            }
                            parts.push(part);
                        }
                        return parts.join("");
                    }
                    function rfc2616unquote(value) {
                        if (value.startsWith('"')) {
                            const parts = value.slice(1).split('\\"');
                            for(let i = 0; i < parts.length; ++i){
                                const quotindex = parts[i].indexOf('"');
                                if (quotindex !== -1) {
                                    parts[i] = parts[i].slice(0, quotindex);
                                    parts.length = i + 1;
                                }
                                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
                            }
                            value = parts.join('"');
                        }
                        return value;
                    }
                    function rfc5987decode(extvalue) {
                        const encodingend = extvalue.indexOf("'");
                        if (encodingend === -1) return extvalue;
                        const encoding = extvalue.slice(0, encodingend);
                        const langvalue = extvalue.slice(encodingend + 1);
                        const value = langvalue.replace(/^[^']*'/, "");
                        return textdecode(encoding, value);
                    }
                    function rfc2047decode(value) {
                        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) return value;
                        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function(matches, charset, encoding, text) {
                            if (encoding === "q" || encoding === "Q") {
                                text = text.replaceAll("_", " ");
                                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function(match, hex) {
                                    return String.fromCharCode(parseInt(hex, 16));
                                });
                                return textdecode(charset, text);
                            }
                            try {
                                text = atob(text);
                            } catch (e) {}
                            return textdecode(charset, text);
                        });
                    }
                    return "";
                }
            /***/ },
            /* 22 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNetworkStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const OK_RESPONSE = 200;
                const PARTIAL_CONTENT_RESPONSE = 206;
                function getArrayBuffer(xhr) {
                    const data = xhr.response;
                    if (typeof data !== "string") return data;
                    return (0, _util.stringToBytes)(data).buffer;
                }
                class NetworkManager {
                    requestRange(begin, end, listeners) {
                        const args = {
                            begin: begin,
                            end: end
                        };
                        for(const prop in listeners)args[prop] = listeners[prop];
                        return this.request(args);
                    }
                    requestFull(listeners) {
                        return this.request(listeners);
                    }
                    request(args) {
                        const xhr = new XMLHttpRequest();
                        const xhrId = this.currXhrId++;
                        const pendingRequest = this.pendingRequests[xhrId] = {
                            xhr: xhr
                        };
                        xhr.open("GET", this.url);
                        xhr.withCredentials = this.withCredentials;
                        for(const property in this.httpHeaders){
                            const value = this.httpHeaders[property];
                            if (value === undefined) continue;
                            xhr.setRequestHeader(property, value);
                        }
                        if (this.isHttp && "begin" in args && "end" in args) {
                            xhr.setRequestHeader("Range", `bytes=${args.begin}-${args.end - 1}`);
                            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
                        } else pendingRequest.expectedStatus = OK_RESPONSE;
                        xhr.responseType = "arraybuffer";
                        if (args.onError) xhr.onerror = function(evt) {
                            args.onError(xhr.status);
                        };
                        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
                        xhr.onprogress = this.onProgress.bind(this, xhrId);
                        pendingRequest.onHeadersReceived = args.onHeadersReceived;
                        pendingRequest.onDone = args.onDone;
                        pendingRequest.onError = args.onError;
                        pendingRequest.onProgress = args.onProgress;
                        xhr.send(null);
                        return xhrId;
                    }
                    onProgress(xhrId, evt) {
                        var _pendingRequest_onProgress;
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        (_pendingRequest_onProgress = pendingRequest.onProgress) === null || _pendingRequest_onProgress === void 0 ? void 0 : _pendingRequest_onProgress.call(pendingRequest, evt);
                    }
                    onStateChange(xhrId, evt) {
                        var _pendingRequest_onError;
                        const pendingRequest = this.pendingRequests[xhrId];
                        if (!pendingRequest) return;
                        const xhr = pendingRequest.xhr;
                        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
                            pendingRequest.onHeadersReceived();
                            delete pendingRequest.onHeadersReceived;
                        }
                        if (xhr.readyState !== 4) return;
                        if (!(xhrId in this.pendingRequests)) return;
                        delete this.pendingRequests[xhrId];
                        if (xhr.status === 0 && this.isHttp) {
                            var _pendingRequest_onError1;
                            (_pendingRequest_onError1 = pendingRequest.onError) === null || _pendingRequest_onError1 === void 0 ? void 0 : _pendingRequest_onError1.call(pendingRequest, xhr.status);
                            return;
                        }
                        const xhrStatus = xhr.status || OK_RESPONSE;
                        const ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
                        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
                            var _pendingRequest_onError2;
                            (_pendingRequest_onError2 = pendingRequest.onError) === null || _pendingRequest_onError2 === void 0 ? void 0 : _pendingRequest_onError2.call(pendingRequest, xhr.status);
                            return;
                        }
                        const chunk = getArrayBuffer(xhr);
                        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
                            const rangeHeader = xhr.getResponseHeader("Content-Range");
                            const matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
                            pendingRequest.onDone({
                                begin: parseInt(matches[1], 10),
                                chunk: chunk
                            });
                        } else if (chunk) pendingRequest.onDone({
                            begin: 0,
                            chunk: chunk
                        });
                        else (_pendingRequest_onError = pendingRequest.onError) === null || _pendingRequest_onError === void 0 ? void 0 : _pendingRequest_onError.call(pendingRequest, xhr.status);
                    }
                    getRequestXhr(xhrId) {
                        return this.pendingRequests[xhrId].xhr;
                    }
                    isPendingRequest(xhrId) {
                        return xhrId in this.pendingRequests;
                    }
                    abortRequest(xhrId) {
                        const xhr = this.pendingRequests[xhrId].xhr;
                        delete this.pendingRequests[xhrId];
                        xhr.abort();
                    }
                    constructor(url, args = {}){
                        this.url = url;
                        this.isHttp = /^https?:/i.test(url);
                        this.httpHeaders = this.isHttp && args.httpHeaders || Object.create(null);
                        this.withCredentials = args.withCredentials || false;
                        this.currXhrId = 0;
                        this.pendingRequests = Object.create(null);
                    }
                }
                class PDFNetworkStream {
                    _onRangeRequestReaderClosed(reader) {
                        const i = this._rangeRequestReaders.indexOf(reader);
                        if (i >= 0) this._rangeRequestReaders.splice(i, 1);
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
                        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
                        return this._fullRequestReader;
                    }
                    getRangeReader(begin, end) {
                        const reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
                        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
                        this._rangeRequestReaders.push(reader);
                        return reader;
                    }
                    cancelAllRequests(reason) {
                        var _this__fullRequestReader;
                        (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                    constructor(source){
                        this._source = source;
                        this._manager = new NetworkManager(source.url, {
                            httpHeaders: source.httpHeaders,
                            withCredentials: source.withCredentials
                        });
                        this._rangeChunkSize = source.rangeChunkSize;
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                }
                exports.PDFNetworkStream = PDFNetworkStream;
                class PDFNetworkStreamFullRequestReader {
                    _onHeadersReceived() {
                        const fullRequestXhrId = this._fullRequestId;
                        const fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
                        const getResponseHeader = (name)=>{
                            return fullRequestXhr.getResponseHeader(name);
                        };
                        const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                            getResponseHeader: getResponseHeader,
                            isHttp: this._manager.isHttp,
                            rangeChunkSize: this._rangeChunkSize,
                            disableRange: this._disableRange
                        });
                        if (allowRangeRequests) this._isRangeSupported = true;
                        this._contentLength = suggestedLength || this._contentLength;
                        this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        if (this._isRangeSupported) this._manager.abortRequest(fullRequestXhrId);
                        this._headersReceivedCapability.resolve();
                    }
                    _onDone(data) {
                        if (data) {
                            if (this._requests.length > 0) {
                                const requestCapability = this._requests.shift();
                                requestCapability.resolve({
                                    value: data.chunk,
                                    done: false
                                });
                            } else this._cachedChunks.push(data.chunk);
                        }
                        this._done = true;
                        if (this._cachedChunks.length > 0) return;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        this._headersReceivedCapability.reject(this._storedError);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._cachedChunks.length = 0;
                    }
                    _onProgress(evt) {
                        var _this_onProgress, _this;
                        (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                            loaded: evt.loaded,
                            total: evt.lengthComputable ? evt.total : this._contentLength
                        });
                    }
                    get filename() {
                        return this._filename;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get headersReady() {
                        return this._headersReceivedCapability.promise;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this._storedError) throw this._storedError;
                            if (this._cachedChunks.length > 0) {
                                const chunk = this._cachedChunks.shift();
                                return {
                                    value: chunk,
                                    done: false
                                };
                            }
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            const requestCapability = new _util.PromiseCapability();
                            this._requests.push(requestCapability);
                            return requestCapability.promise;
                        }).call(this);
                    }
                    cancel(reason) {
                        this._done = true;
                        this._headersReceivedCapability.reject(reason);
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._fullRequestId)) this._manager.abortRequest(this._fullRequestId);
                        this._fullRequestReader = null;
                    }
                    constructor(manager, source){
                        this._manager = manager;
                        const args = {
                            onHeadersReceived: this._onHeadersReceived.bind(this),
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = source.url;
                        this._fullRequestId = manager.requestFull(args);
                        this._headersReceivedCapability = new _util.PromiseCapability();
                        this._disableRange = source.disableRange || false;
                        this._contentLength = source.length;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = false;
                        this._isRangeSupported = false;
                        this._cachedChunks = [];
                        this._requests = [];
                        this._done = false;
                        this._storedError = undefined;
                        this._filename = null;
                        this.onProgress = null;
                    }
                }
                class PDFNetworkStreamRangeRequestReader {
                    _close() {
                        var _this_onClosed, _this;
                        (_this_onClosed = (_this = this).onClosed) === null || _this_onClosed === void 0 ? void 0 : _this_onClosed.call(_this, this);
                    }
                    _onDone(data) {
                        const chunk = data.chunk;
                        if (this._requests.length > 0) {
                            const requestCapability = this._requests.shift();
                            requestCapability.resolve({
                                value: chunk,
                                done: false
                            });
                        } else this._queuedChunk = chunk;
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        this._close();
                    }
                    _onError(status) {
                        this._storedError = (0, _network_utils.createResponseStatusError)(status, this._url);
                        for (const requestCapability of this._requests)requestCapability.reject(this._storedError);
                        this._requests.length = 0;
                        this._queuedChunk = null;
                    }
                    _onProgress(evt) {
                        var _this_onProgress, _this;
                        if (!this.isStreamingSupported) (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                            loaded: evt.loaded
                        });
                    }
                    get isStreamingSupported() {
                        return false;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            if (this._storedError) throw this._storedError;
                            if (this._queuedChunk !== null) {
                                const chunk = this._queuedChunk;
                                this._queuedChunk = null;
                                return {
                                    value: chunk,
                                    done: false
                                };
                            }
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            const requestCapability = new _util.PromiseCapability();
                            this._requests.push(requestCapability);
                            return requestCapability.promise;
                        }).call(this);
                    }
                    cancel(reason) {
                        this._done = true;
                        for (const requestCapability of this._requests)requestCapability.resolve({
                            value: undefined,
                            done: true
                        });
                        this._requests.length = 0;
                        if (this._manager.isPendingRequest(this._requestId)) this._manager.abortRequest(this._requestId);
                        this._close();
                    }
                    constructor(manager, begin, end){
                        this._manager = manager;
                        const args = {
                            onDone: this._onDone.bind(this),
                            onError: this._onError.bind(this),
                            onProgress: this._onProgress.bind(this)
                        };
                        this._url = manager.url;
                        this._requestId = manager.requestRange(begin, end, args);
                        this._requests = [];
                        this._queuedChunk = null;
                        this._done = false;
                        this._storedError = undefined;
                        this.onProgress = null;
                        this.onClosed = null;
                    }
                }
            /***/ },
            /* 23 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.PDFNodeStream = void 0;
                var _util = __w_pdfjs_require__(1);
                var _network_utils = __w_pdfjs_require__(20);
                const fileUriRegex = /^file:\/\/\/[a-zA-Z]:\//;
                function parseUrl(sourceUrl) {
                    const url = (parcelRequire("hDwn7"));
                    const parsedUrl = url.parse(sourceUrl);
                    if (parsedUrl.protocol === "file:" || parsedUrl.host) return parsedUrl;
                    if (/^[a-z]:[/\\]/i.test(sourceUrl)) return url.parse(`file:///${sourceUrl}`);
                    if (!parsedUrl.host) parsedUrl.protocol = "file:";
                    return parsedUrl;
                }
                class PDFNodeStream {
                    get _progressiveDataLength() {
                        var _this__fullRequestReader;
                        var _this__fullRequestReader__loaded;
                        return (_this__fullRequestReader__loaded = (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader._loaded) !== null && _this__fullRequestReader__loaded !== void 0 ? _this__fullRequestReader__loaded : 0;
                    }
                    getFullReader() {
                        (0, _util.assert)(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
                        this._fullRequestReader = this.isFsUrl ? new PDFNodeStreamFsFullReader(this) : new PDFNodeStreamFullReader(this);
                        return this._fullRequestReader;
                    }
                    getRangeReader(start, end) {
                        if (end <= this._progressiveDataLength) return null;
                        const rangeReader = this.isFsUrl ? new PDFNodeStreamFsRangeReader(this, start, end) : new PDFNodeStreamRangeReader(this, start, end);
                        this._rangeRequestReaders.push(rangeReader);
                        return rangeReader;
                    }
                    cancelAllRequests(reason) {
                        var _this__fullRequestReader;
                        (_this__fullRequestReader = this._fullRequestReader) === null || _this__fullRequestReader === void 0 ? void 0 : _this__fullRequestReader.cancel(reason);
                        for (const reader of this._rangeRequestReaders.slice(0))reader.cancel(reason);
                    }
                    constructor(source){
                        this.source = source;
                        this.url = parseUrl(source.url);
                        this.isHttp = this.url.protocol === "http:" || this.url.protocol === "https:";
                        this.isFsUrl = this.url.protocol === "file:";
                        this.httpHeaders = this.isHttp && source.httpHeaders || {};
                        this._fullRequestReader = null;
                        this._rangeRequestReaders = [];
                    }
                }
                exports.PDFNodeStream = PDFNodeStream;
                class BaseFullReader {
                    get headersReady() {
                        return this._headersCapability.promise;
                    }
                    get filename() {
                        return this._filename;
                    }
                    get contentLength() {
                        return this._contentLength;
                    }
                    get isRangeSupported() {
                        return this._isRangeSupported;
                    }
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            var _this_onProgress, _this;
                            yield this._readCapability.promise;
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            if (this._storedError) throw this._storedError;
                            const chunk = this._readableStream.read();
                            if (chunk === null) {
                                this._readCapability = new _util.PromiseCapability();
                                return this.read();
                            }
                            this._loaded += chunk.length;
                            (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                loaded: this._loaded,
                                total: this._contentLength
                            });
                            const buffer = new Uint8Array(chunk).buffer;
                            return {
                                value: buffer,
                                done: false
                            };
                        }).call(this);
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (!this._isStreamingSupported && this._isRangeSupported) this._error(new _util.AbortException("streaming is disabled"));
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        const source = stream.source;
                        this._contentLength = source.length;
                        this._loaded = 0;
                        this._filename = null;
                        this._disableRange = source.disableRange || false;
                        this._rangeChunkSize = source.rangeChunkSize;
                        if (!this._rangeChunkSize && !this._disableRange) this._disableRange = true;
                        this._isStreamingSupported = !source.disableStream;
                        this._isRangeSupported = !source.disableRange;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        this._headersCapability = new _util.PromiseCapability();
                    }
                }
                class BaseRangeReader {
                    get isStreamingSupported() {
                        return this._isStreamingSupported;
                    }
                    read() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            var _this_onProgress, _this;
                            yield this._readCapability.promise;
                            if (this._done) return {
                                value: undefined,
                                done: true
                            };
                            if (this._storedError) throw this._storedError;
                            const chunk = this._readableStream.read();
                            if (chunk === null) {
                                this._readCapability = new _util.PromiseCapability();
                                return this.read();
                            }
                            this._loaded += chunk.length;
                            (_this_onProgress = (_this = this).onProgress) === null || _this_onProgress === void 0 ? void 0 : _this_onProgress.call(_this, {
                                loaded: this._loaded
                            });
                            const buffer = new Uint8Array(chunk).buffer;
                            return {
                                value: buffer,
                                done: false
                            };
                        }).call(this);
                    }
                    cancel(reason) {
                        if (!this._readableStream) {
                            this._error(reason);
                            return;
                        }
                        this._readableStream.destroy(reason);
                    }
                    _error(reason) {
                        this._storedError = reason;
                        this._readCapability.resolve();
                    }
                    _setReadableStream(readableStream) {
                        this._readableStream = readableStream;
                        readableStream.on("readable", ()=>{
                            this._readCapability.resolve();
                        });
                        readableStream.on("end", ()=>{
                            readableStream.destroy();
                            this._done = true;
                            this._readCapability.resolve();
                        });
                        readableStream.on("error", (reason)=>{
                            this._error(reason);
                        });
                        if (this._storedError) this._readableStream.destroy(this._storedError);
                    }
                    constructor(stream){
                        this._url = stream.url;
                        this._done = false;
                        this._storedError = null;
                        this.onProgress = null;
                        this._loaded = 0;
                        this._readableStream = null;
                        this._readCapability = new _util.PromiseCapability();
                        const source = stream.source;
                        this._isStreamingSupported = !source.disableStream;
                    }
                }
                function createRequestOptions(parsedUrl, headers) {
                    return {
                        protocol: parsedUrl.protocol,
                        auth: parsedUrl.auth,
                        host: parsedUrl.hostname,
                        port: parsedUrl.port,
                        path: parsedUrl.path,
                        method: "GET",
                        headers: headers
                    };
                }
                class PDFNodeStreamFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._headersCapability.resolve();
                            this._setReadableStream(response);
                            const getResponseHeader = (name)=>{
                                return this._readableStream.headers[name.toLowerCase()];
                            };
                            const { allowRangeRequests, suggestedLength } = (0, _network_utils.validateRangeRequestCapabilities)({
                                getResponseHeader: getResponseHeader,
                                isHttp: stream.isHttp,
                                rangeChunkSize: this._rangeChunkSize,
                                disableRange: this._disableRange
                            });
                            this._isRangeSupported = allowRangeRequests;
                            this._contentLength = suggestedLength || this._contentLength;
                            this._filename = (0, _network_utils.extractFilenameFromHeader)(getResponseHeader);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("hDwn7"));
                            this._request = http.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("hDwn7"));
                            this._request = https.request(createRequestOptions(this._url, stream.httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                            this._headersCapability.reject(reason);
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        this._httpHeaders = {};
                        for(const property in stream.httpHeaders){
                            const value = stream.httpHeaders[property];
                            if (value === undefined) continue;
                            this._httpHeaders[property] = value;
                        }
                        this._httpHeaders.Range = `bytes=${start}-${end - 1}`;
                        const handleResponse = (response)=>{
                            if (response.statusCode === 404) {
                                const error = new _util.MissingPDFException(`Missing PDF "${this._url}".`);
                                this._storedError = error;
                                return;
                            }
                            this._setReadableStream(response);
                        };
                        this._request = null;
                        if (this._url.protocol === "http:") {
                            const http = (parcelRequire("hDwn7"));
                            this._request = http.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        } else {
                            const https = (parcelRequire("hDwn7"));
                            this._request = https.request(createRequestOptions(this._url, this._httpHeaders), handleResponse);
                        }
                        this._request.on("error", (reason)=>{
                            this._storedError = reason;
                        });
                        this._request.end();
                    }
                }
                class PDFNodeStreamFsFullReader extends BaseFullReader {
                    constructor(stream){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("hDwn7"));
                        fs.lstat(path, (error, stat)=>{
                            if (error) {
                                if (error.code === "ENOENT") error = new _util.MissingPDFException(`Missing PDF "${path}".`);
                                this._storedError = error;
                                this._headersCapability.reject(error);
                                return;
                            }
                            this._contentLength = stat.size;
                            this._setReadableStream(fs.createReadStream(path));
                            this._headersCapability.resolve();
                        });
                    }
                }
                class PDFNodeStreamFsRangeReader extends BaseRangeReader {
                    constructor(stream, start, end){
                        super(stream);
                        let path = decodeURIComponent(this._url.path);
                        if (fileUriRegex.test(this._url.href)) path = path.replace(/^\//, "");
                        const fs = (parcelRequire("hDwn7"));
                        this._setReadableStream(fs.createReadStream(path, {
                            start: start,
                            end: end - 1
                        }));
                    }
                }
            /***/ },
            /* 24 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.SVGGraphics = void 0;
                var _display_utils = __w_pdfjs_require__(6);
                var _util = __w_pdfjs_require__(1);
                const SVG_DEFAULTS = {
                    fontStyle: "normal",
                    fontWeight: "normal",
                    fillColor: "#000000"
                };
                const XML_NS = "http://www.w3.org/XML/1998/namespace";
                const XLINK_NS = "http://www.w3.org/1999/xlink";
                const LINE_CAP_STYLES = [
                    "butt",
                    "round",
                    "square"
                ];
                const LINE_JOIN_STYLES = [
                    "miter",
                    "round",
                    "bevel"
                ];
                const createObjectURL = function(data, contentType = "", forceDataSchema = false) {
                    if (URL.createObjectURL && typeof Blob !== "undefined" && !forceDataSchema) return URL.createObjectURL(new Blob([
                        data
                    ], {
                        type: contentType
                    }));
                    const digits = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
                    let buffer = `data:${contentType};base64,`;
                    for(let i = 0, ii = data.length; i < ii; i += 3){
                        const b1 = data[i] & 0xff;
                        const b2 = data[i + 1] & 0xff;
                        const b3 = data[i + 2] & 0xff;
                        const d1 = b1 >> 2, d2 = (b1 & 3) << 4 | b2 >> 4;
                        const d3 = i + 1 < ii ? (b2 & 0xf) << 2 | b3 >> 6 : 64;
                        const d4 = i + 2 < ii ? b3 & 0x3f : 64;
                        buffer += digits[d1] + digits[d2] + digits[d3] + digits[d4];
                    }
                    return buffer;
                };
                const convertImgDataToPng = function() {
                    const PNG_HEADER = new Uint8Array([
                        0x89,
                        0x50,
                        0x4e,
                        0x47,
                        0x0d,
                        0x0a,
                        0x1a,
                        0x0a
                    ]);
                    const CHUNK_WRAPPER_SIZE = 12;
                    const crcTable = new Int32Array(256);
                    for(let i = 0; i < 256; i++){
                        let c = i;
                        for(let h = 0; h < 8; h++)c = c & 1 ? 0xedb88320 ^ c >> 1 & 0x7fffffff : c >> 1 & 0x7fffffff;
                        crcTable[i] = c;
                    }
                    function crc32(data, start, end) {
                        let crc = -1;
                        for(let i = start; i < end; i++){
                            const a = (crc ^ data[i]) & 0xff;
                            const b = crcTable[a];
                            crc = crc >>> 8 ^ b;
                        }
                        return crc ^ -1;
                    }
                    function writePngChunk(type, body, data, offset) {
                        let p = offset;
                        const len = body.length;
                        data[p] = len >> 24 & 0xff;
                        data[p + 1] = len >> 16 & 0xff;
                        data[p + 2] = len >> 8 & 0xff;
                        data[p + 3] = len & 0xff;
                        p += 4;
                        data[p] = type.charCodeAt(0) & 0xff;
                        data[p + 1] = type.charCodeAt(1) & 0xff;
                        data[p + 2] = type.charCodeAt(2) & 0xff;
                        data[p + 3] = type.charCodeAt(3) & 0xff;
                        p += 4;
                        data.set(body, p);
                        p += body.length;
                        const crc = crc32(data, offset + 4, p);
                        data[p] = crc >> 24 & 0xff;
                        data[p + 1] = crc >> 16 & 0xff;
                        data[p + 2] = crc >> 8 & 0xff;
                        data[p + 3] = crc & 0xff;
                    }
                    function adler32(data, start, end) {
                        let a = 1;
                        let b = 0;
                        for(let i = start; i < end; ++i){
                            a = (a + (data[i] & 0xff)) % 65521;
                            b = (b + a) % 65521;
                        }
                        return b << 16 | a;
                    }
                    function deflateSync(literals) {
                        if (!_util.isNodeJS) return deflateSyncUncompressed(literals);
                        try {
                            const input = parseInt($5XqL3.versions.node) >= 8 ? literals : $78395ec40f50896a$require$Buffer.from(literals);
                            const output = (parcelRequire("hDwn7")).deflateSync(input, {
                                level: 9
                            });
                            return output instanceof Uint8Array ? output : new Uint8Array(output);
                        } catch (e) {
                            (0, _util.warn)("Not compressing PNG because zlib.deflateSync is unavailable: " + e);
                        }
                        return deflateSyncUncompressed(literals);
                    }
                    function deflateSyncUncompressed(literals) {
                        let len = literals.length;
                        const maxBlockLength = 0xffff;
                        const deflateBlocks = Math.ceil(len / maxBlockLength);
                        const idat = new Uint8Array(2 + len + deflateBlocks * 5 + 4);
                        let pi = 0;
                        idat[pi++] = 0x78;
                        idat[pi++] = 0x9c;
                        let pos = 0;
                        while(len > maxBlockLength){
                            idat[pi++] = 0x00;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0xff;
                            idat[pi++] = 0x00;
                            idat[pi++] = 0x00;
                            idat.set(literals.subarray(pos, pos + maxBlockLength), pi);
                            pi += maxBlockLength;
                            pos += maxBlockLength;
                            len -= maxBlockLength;
                        }
                        idat[pi++] = 0x01;
                        idat[pi++] = len & 0xff;
                        idat[pi++] = len >> 8 & 0xff;
                        idat[pi++] = ~len & 255;
                        idat[pi++] = (~len & 0xffff) >> 8 & 0xff;
                        idat.set(literals.subarray(pos), pi);
                        pi += literals.length - pos;
                        const adler = adler32(literals, 0, literals.length);
                        idat[pi++] = adler >> 24 & 0xff;
                        idat[pi++] = adler >> 16 & 0xff;
                        idat[pi++] = adler >> 8 & 0xff;
                        idat[pi++] = adler & 0xff;
                        return idat;
                    }
                    function encode(imgData, kind, forceDataSchema, isMask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        let bitDepth, colorType, lineSize;
                        const bytes = imgData.data;
                        switch(kind){
                            case _util.ImageKind.GRAYSCALE_1BPP:
                                colorType = 0;
                                bitDepth = 1;
                                lineSize = width + 7 >> 3;
                                break;
                            case _util.ImageKind.RGB_24BPP:
                                colorType = 2;
                                bitDepth = 8;
                                lineSize = width * 3;
                                break;
                            case _util.ImageKind.RGBA_32BPP:
                                colorType = 6;
                                bitDepth = 8;
                                lineSize = width * 4;
                                break;
                            default:
                                throw new Error("invalid format");
                        }
                        const literals = new Uint8Array((1 + lineSize) * height);
                        let offsetLiterals = 0, offsetBytes = 0;
                        for(let y = 0; y < height; ++y){
                            literals[offsetLiterals++] = 0;
                            literals.set(bytes.subarray(offsetBytes, offsetBytes + lineSize), offsetLiterals);
                            offsetBytes += lineSize;
                            offsetLiterals += lineSize;
                        }
                        if (kind === _util.ImageKind.GRAYSCALE_1BPP && isMask) {
                            offsetLiterals = 0;
                            for(let y = 0; y < height; y++){
                                offsetLiterals++;
                                for(let i = 0; i < lineSize; i++)literals[offsetLiterals++] ^= 0xff;
                            }
                        }
                        const ihdr = new Uint8Array([
                            width >> 24 & 0xff,
                            width >> 16 & 0xff,
                            width >> 8 & 0xff,
                            width & 0xff,
                            height >> 24 & 0xff,
                            height >> 16 & 0xff,
                            height >> 8 & 0xff,
                            height & 0xff,
                            bitDepth,
                            colorType,
                            0x00,
                            0x00,
                            0x00
                        ]);
                        const idat = deflateSync(literals);
                        const pngLength = PNG_HEADER.length + CHUNK_WRAPPER_SIZE * 3 + ihdr.length + idat.length;
                        const data = new Uint8Array(pngLength);
                        let offset = 0;
                        data.set(PNG_HEADER, offset);
                        offset += PNG_HEADER.length;
                        writePngChunk("IHDR", ihdr, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + ihdr.length;
                        writePngChunk("IDATA", idat, data, offset);
                        offset += CHUNK_WRAPPER_SIZE + idat.length;
                        writePngChunk("IEND", new Uint8Array(0), data, offset);
                        return createObjectURL(data, "image/png", forceDataSchema);
                    }
                    return function convertImgDataToPng(imgData, forceDataSchema, isMask) {
                        const kind = imgData.kind === undefined ? _util.ImageKind.GRAYSCALE_1BPP : imgData.kind;
                        return encode(imgData, kind, forceDataSchema, isMask);
                    };
                }();
                class SVGExtraState {
                    clone() {
                        return Object.create(this);
                    }
                    setCurrentPoint(x, y) {
                        this.x = x;
                        this.y = y;
                    }
                    constructor(){
                        this.fontSizeScale = 1;
                        this.fontWeight = SVG_DEFAULTS.fontWeight;
                        this.fontSize = 0;
                        this.textMatrix = _util.IDENTITY_MATRIX;
                        this.fontMatrix = _util.FONT_IDENTITY_MATRIX;
                        this.leading = 0;
                        this.textRenderingMode = _util.TextRenderingMode.FILL;
                        this.textMatrixScale = 1;
                        this.x = 0;
                        this.y = 0;
                        this.lineX = 0;
                        this.lineY = 0;
                        this.charSpacing = 0;
                        this.wordSpacing = 0;
                        this.textHScale = 1;
                        this.textRise = 0;
                        this.fillColor = SVG_DEFAULTS.fillColor;
                        this.strokeColor = "#000000";
                        this.fillAlpha = 1;
                        this.strokeAlpha = 1;
                        this.lineWidth = 1;
                        this.lineJoin = "";
                        this.lineCap = "";
                        this.miterLimit = 0;
                        this.dashArray = [];
                        this.dashPhase = 0;
                        this.dependencies = [];
                        this.activeClipUrl = null;
                        this.clipGroup = null;
                        this.maskId = "";
                    }
                }
                function opListToTree(opList) {
                    let opTree = [];
                    const tmp = [];
                    for (const opListElement of opList){
                        if (opListElement.fn === "save") {
                            opTree.push({
                                fnId: 92,
                                fn: "group",
                                items: []
                            });
                            tmp.push(opTree);
                            opTree = opTree.at(-1).items;
                            continue;
                        }
                        if (opListElement.fn === "restore") opTree = tmp.pop();
                        else opTree.push(opListElement);
                    }
                    return opTree;
                }
                function pf(value) {
                    if (Number.isInteger(value)) return value.toString();
                    const s = value.toFixed(10);
                    let i = s.length - 1;
                    if (s[i] !== "0") return s;
                    do i--;
                    while (s[i] === "0");
                    return s.substring(0, s[i] === "." ? i : i + 1);
                }
                function pm(m) {
                    if (m[4] === 0 && m[5] === 0) {
                        if (m[1] === 0 && m[2] === 0) {
                            if (m[0] === 1 && m[3] === 1) return "";
                            return `scale(${pf(m[0])} ${pf(m[3])})`;
                        }
                        if (m[0] === m[3] && m[1] === -m[2]) {
                            const a = Math.acos(m[0]) * 180 / Math.PI;
                            return `rotate(${pf(a)})`;
                        }
                    } else if (m[0] === 1 && m[1] === 0 && m[2] === 0 && m[3] === 1) return `translate(${pf(m[4])} ${pf(m[5])})`;
                    return `matrix(${pf(m[0])} ${pf(m[1])} ${pf(m[2])} ${pf(m[3])} ${pf(m[4])} ` + `${pf(m[5])})`;
                }
                let clipCount = 0;
                let maskCount = 0;
                let shadingCount = 0;
                class SVGGraphics {
                    getObject(data, fallback = null) {
                        if (typeof data === "string") return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
                        return fallback;
                    }
                    save() {
                        this.transformStack.push(this.transformMatrix);
                        const old = this.current;
                        this.extraStack.push(old);
                        this.current = old.clone();
                    }
                    restore() {
                        this.transformMatrix = this.transformStack.pop();
                        this.current = this.extraStack.pop();
                        this.pendingClip = null;
                        this.tgrp = null;
                    }
                    group(items) {
                        this.save();
                        this.executeOpTree(items);
                        this.restore();
                    }
                    loadDependencies(operatorList) {
                        const fnArray = operatorList.fnArray;
                        const argsArray = operatorList.argsArray;
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            if (fnArray[i] !== _util.OPS.dependency) continue;
                            for (const obj of argsArray[i]){
                                const objsPool = obj.startsWith("g_") ? this.commonObjs : this.objs;
                                const promise = new Promise((resolve)=>{
                                    objsPool.get(obj, resolve);
                                });
                                this.current.dependencies.push(promise);
                            }
                        }
                        return Promise.all(this.current.dependencies);
                    }
                    transform(a, b, c, d, e, f) {
                        const transformMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        this.transformMatrix = _util.Util.transform(this.transformMatrix, transformMatrix);
                        this.tgrp = null;
                    }
                    getSVG(operatorList, viewport) {
                        this.viewport = viewport;
                        const svgElement = this._initialize(viewport);
                        return this.loadDependencies(operatorList).then(()=>{
                            this.transformMatrix = _util.IDENTITY_MATRIX;
                            this.executeOpTree(this.convertOpList(operatorList));
                            return svgElement;
                        });
                    }
                    convertOpList(operatorList) {
                        const operatorIdMapping = this._operatorIdMapping;
                        const argsArray = operatorList.argsArray;
                        const fnArray = operatorList.fnArray;
                        const opList = [];
                        for(let i = 0, ii = fnArray.length; i < ii; i++){
                            const fnId = fnArray[i];
                            opList.push({
                                fnId: fnId,
                                fn: operatorIdMapping[fnId],
                                args: argsArray[i]
                            });
                        }
                        return opListToTree(opList);
                    }
                    executeOpTree(opTree) {
                        for (const opTreeElement of opTree){
                            const fn = opTreeElement.fn;
                            const fnId = opTreeElement.fnId;
                            const args = opTreeElement.args;
                            switch(fnId | 0){
                                case _util.OPS.beginText:
                                    this.beginText();
                                    break;
                                case _util.OPS.dependency:
                                    break;
                                case _util.OPS.setLeading:
                                    this.setLeading(args);
                                    break;
                                case _util.OPS.setLeadingMoveText:
                                    this.setLeadingMoveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setFont:
                                    this.setFont(args);
                                    break;
                                case _util.OPS.showText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.showSpacedText:
                                    this.showText(args[0]);
                                    break;
                                case _util.OPS.endText:
                                    this.endText();
                                    break;
                                case _util.OPS.moveText:
                                    this.moveText(args[0], args[1]);
                                    break;
                                case _util.OPS.setCharSpacing:
                                    this.setCharSpacing(args[0]);
                                    break;
                                case _util.OPS.setWordSpacing:
                                    this.setWordSpacing(args[0]);
                                    break;
                                case _util.OPS.setHScale:
                                    this.setHScale(args[0]);
                                    break;
                                case _util.OPS.setTextMatrix:
                                    this.setTextMatrix(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.setTextRise:
                                    this.setTextRise(args[0]);
                                    break;
                                case _util.OPS.setTextRenderingMode:
                                    this.setTextRenderingMode(args[0]);
                                    break;
                                case _util.OPS.setLineWidth:
                                    this.setLineWidth(args[0]);
                                    break;
                                case _util.OPS.setLineJoin:
                                    this.setLineJoin(args[0]);
                                    break;
                                case _util.OPS.setLineCap:
                                    this.setLineCap(args[0]);
                                    break;
                                case _util.OPS.setMiterLimit:
                                    this.setMiterLimit(args[0]);
                                    break;
                                case _util.OPS.setFillRGBColor:
                                    this.setFillRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeRGBColor:
                                    this.setStrokeRGBColor(args[0], args[1], args[2]);
                                    break;
                                case _util.OPS.setStrokeColorN:
                                    this.setStrokeColorN(args);
                                    break;
                                case _util.OPS.setFillColorN:
                                    this.setFillColorN(args);
                                    break;
                                case _util.OPS.shadingFill:
                                    this.shadingFill(args[0]);
                                    break;
                                case _util.OPS.setDash:
                                    this.setDash(args[0], args[1]);
                                    break;
                                case _util.OPS.setRenderingIntent:
                                    this.setRenderingIntent(args[0]);
                                    break;
                                case _util.OPS.setFlatness:
                                    this.setFlatness(args[0]);
                                    break;
                                case _util.OPS.setGState:
                                    this.setGState(args[0]);
                                    break;
                                case _util.OPS.fill:
                                    this.fill();
                                    break;
                                case _util.OPS.eoFill:
                                    this.eoFill();
                                    break;
                                case _util.OPS.stroke:
                                    this.stroke();
                                    break;
                                case _util.OPS.fillStroke:
                                    this.fillStroke();
                                    break;
                                case _util.OPS.eoFillStroke:
                                    this.eoFillStroke();
                                    break;
                                case _util.OPS.clip:
                                    this.clip("nonzero");
                                    break;
                                case _util.OPS.eoClip:
                                    this.clip("evenodd");
                                    break;
                                case _util.OPS.paintSolidColorImageMask:
                                    this.paintSolidColorImageMask();
                                    break;
                                case _util.OPS.paintImageXObject:
                                    this.paintImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintInlineImageXObject:
                                    this.paintInlineImageXObject(args[0]);
                                    break;
                                case _util.OPS.paintImageMaskXObject:
                                    this.paintImageMaskXObject(args[0]);
                                    break;
                                case _util.OPS.paintFormXObjectBegin:
                                    this.paintFormXObjectBegin(args[0], args[1]);
                                    break;
                                case _util.OPS.paintFormXObjectEnd:
                                    this.paintFormXObjectEnd();
                                    break;
                                case _util.OPS.closePath:
                                    this.closePath();
                                    break;
                                case _util.OPS.closeStroke:
                                    this.closeStroke();
                                    break;
                                case _util.OPS.closeFillStroke:
                                    this.closeFillStroke();
                                    break;
                                case _util.OPS.closeEOFillStroke:
                                    this.closeEOFillStroke();
                                    break;
                                case _util.OPS.nextLine:
                                    this.nextLine();
                                    break;
                                case _util.OPS.transform:
                                    this.transform(args[0], args[1], args[2], args[3], args[4], args[5]);
                                    break;
                                case _util.OPS.constructPath:
                                    this.constructPath(args[0], args[1]);
                                    break;
                                case _util.OPS.endPath:
                                    this.endPath();
                                    break;
                                case 92:
                                    this.group(opTreeElement.items);
                                    break;
                                default:
                                    (0, _util.warn)(`Unimplemented operator ${fn}`);
                                    break;
                            }
                        }
                    }
                    setWordSpacing(wordSpacing) {
                        this.current.wordSpacing = wordSpacing;
                    }
                    setCharSpacing(charSpacing) {
                        this.current.charSpacing = charSpacing;
                    }
                    nextLine() {
                        this.moveText(0, this.current.leading);
                    }
                    setTextMatrix(a, b, c, d, e, f) {
                        const current = this.current;
                        current.textMatrix = current.lineMatrix = [
                            a,
                            b,
                            c,
                            d,
                            e,
                            f
                        ];
                        current.textMatrixScale = Math.hypot(a, b);
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtElement.append(current.tspan);
                    }
                    beginText() {
                        const current = this.current;
                        current.x = current.lineX = 0;
                        current.y = current.lineY = 0;
                        current.textMatrix = _util.IDENTITY_MATRIX;
                        current.lineMatrix = _util.IDENTITY_MATRIX;
                        current.textMatrixScale = 1;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.txtElement = this.svgFactory.createElement("svg:text");
                        current.txtgrp = this.svgFactory.createElement("svg:g");
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    moveText(x, y) {
                        const current = this.current;
                        current.x = current.lineX += x;
                        current.y = current.lineY += y;
                        current.xcoords = [];
                        current.ycoords = [];
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                    }
                    showText(glyphs) {
                        const current = this.current;
                        const font = current.font;
                        const fontSize = current.fontSize;
                        if (fontSize === 0) return;
                        const fontSizeScale = current.fontSizeScale;
                        const charSpacing = current.charSpacing;
                        const wordSpacing = current.wordSpacing;
                        const fontDirection = current.fontDirection;
                        const textHScale = current.textHScale * fontDirection;
                        const vertical = font.vertical;
                        const spacingDir = vertical ? 1 : -1;
                        const defaultVMetrics = font.defaultVMetrics;
                        const widthAdvanceScale = fontSize * current.fontMatrix[0];
                        let x = 0;
                        for (const glyph of glyphs){
                            if (glyph === null) {
                                x += fontDirection * wordSpacing;
                                continue;
                            } else if (typeof glyph === "number") {
                                x += spacingDir * glyph * fontSize / 1000;
                                continue;
                            }
                            const spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
                            const character = glyph.fontChar;
                            let scaledX, scaledY;
                            let width = glyph.width;
                            if (vertical) {
                                let vx;
                                const vmetric = glyph.vmetric || defaultVMetrics;
                                vx = glyph.vmetric ? vmetric[1] : width * 0.5;
                                vx = -vx * widthAdvanceScale;
                                const vy = vmetric[2] * widthAdvanceScale;
                                width = vmetric ? -vmetric[0] : width;
                                scaledX = vx / fontSizeScale;
                                scaledY = (x + vy) / fontSizeScale;
                            } else {
                                scaledX = x / fontSizeScale;
                                scaledY = 0;
                            }
                            if (glyph.isInFont || font.missingFile) {
                                current.xcoords.push(current.x + scaledX);
                                if (vertical) current.ycoords.push(-current.y + scaledY);
                                current.tspan.textContent += character;
                            }
                            const charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
                            x += charWidth;
                        }
                        current.tspan.setAttributeNS(null, "x", current.xcoords.map(pf).join(" "));
                        if (vertical) current.tspan.setAttributeNS(null, "y", current.ycoords.map(pf).join(" "));
                        else current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        if (vertical) current.y -= x;
                        else current.x += x * textHScale;
                        current.tspan.setAttributeNS(null, "font-family", current.fontFamily);
                        current.tspan.setAttributeNS(null, "font-size", `${pf(current.fontSize)}px`);
                        if (current.fontStyle !== SVG_DEFAULTS.fontStyle) current.tspan.setAttributeNS(null, "font-style", current.fontStyle);
                        if (current.fontWeight !== SVG_DEFAULTS.fontWeight) current.tspan.setAttributeNS(null, "font-weight", current.fontWeight);
                        const fillStrokeMode = current.textRenderingMode & _util.TextRenderingMode.FILL_STROKE_MASK;
                        if (fillStrokeMode === _util.TextRenderingMode.FILL || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            if (current.fillColor !== SVG_DEFAULTS.fillColor) current.tspan.setAttributeNS(null, "fill", current.fillColor);
                            if (current.fillAlpha < 1) current.tspan.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                        } else if (current.textRenderingMode === _util.TextRenderingMode.ADD_TO_PATH) current.tspan.setAttributeNS(null, "fill", "transparent");
                        else current.tspan.setAttributeNS(null, "fill", "none");
                        if (fillStrokeMode === _util.TextRenderingMode.STROKE || fillStrokeMode === _util.TextRenderingMode.FILL_STROKE) {
                            const lineWidthScale = 1 / (current.textMatrixScale || 1);
                            this._setStrokeAttributes(current.tspan, lineWidthScale);
                        }
                        let textMatrix = current.textMatrix;
                        if (current.textRise !== 0) {
                            textMatrix = textMatrix.slice();
                            textMatrix[5] += current.textRise;
                        }
                        current.txtElement.setAttributeNS(null, "transform", `${pm(textMatrix)} scale(${pf(textHScale)}, -1)`);
                        current.txtElement.setAttributeNS(XML_NS, "xml:space", "preserve");
                        current.txtElement.append(current.tspan);
                        current.txtgrp.append(current.txtElement);
                        this._ensureTransformGroup().append(current.txtElement);
                    }
                    setLeadingMoveText(x, y) {
                        this.setLeading(-y);
                        this.moveText(x, y);
                    }
                    addFontStyle(fontObj) {
                        if (!fontObj.data) throw new Error('addFontStyle: No font data available, ensure that the "fontExtraProperties" API parameter is set.');
                        if (!this.cssStyle) {
                            this.cssStyle = this.svgFactory.createElement("svg:style");
                            this.cssStyle.setAttributeNS(null, "type", "text/css");
                            this.defs.append(this.cssStyle);
                        }
                        const url = createObjectURL(fontObj.data, fontObj.mimetype, this.forceDataSchema);
                        this.cssStyle.textContent += `@font-face { font-family: "${fontObj.loadedName}";` + ` src: url(${url}); }\n`;
                    }
                    setFont(details) {
                        const current = this.current;
                        const fontObj = this.commonObjs.get(details[0]);
                        let size = details[1];
                        current.font = fontObj;
                        if (this.embedFonts && !fontObj.missingFile && !this.embeddedFonts[fontObj.loadedName]) {
                            this.addFontStyle(fontObj);
                            this.embeddedFonts[fontObj.loadedName] = fontObj;
                        }
                        current.fontMatrix = fontObj.fontMatrix || _util.FONT_IDENTITY_MATRIX;
                        let bold = "normal";
                        if (fontObj.black) bold = "900";
                        else if (fontObj.bold) bold = "bold";
                        const italic = fontObj.italic ? "italic" : "normal";
                        if (size < 0) {
                            size = -size;
                            current.fontDirection = -1;
                        } else current.fontDirection = 1;
                        current.fontSize = size;
                        current.fontFamily = fontObj.loadedName;
                        current.fontWeight = bold;
                        current.fontStyle = italic;
                        current.tspan = this.svgFactory.createElement("svg:tspan");
                        current.tspan.setAttributeNS(null, "y", pf(-current.y));
                        current.xcoords = [];
                        current.ycoords = [];
                    }
                    endText() {
                        var _current_txtElement;
                        const current = this.current;
                        if (current.textRenderingMode & _util.TextRenderingMode.ADD_TO_PATH_FLAG && ((_current_txtElement = current.txtElement) === null || _current_txtElement === void 0 ? void 0 : _current_txtElement.hasChildNodes())) {
                            current.element = current.txtElement;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    setLineWidth(width) {
                        if (width > 0) this.current.lineWidth = width;
                    }
                    setLineCap(style) {
                        this.current.lineCap = LINE_CAP_STYLES[style];
                    }
                    setLineJoin(style) {
                        this.current.lineJoin = LINE_JOIN_STYLES[style];
                    }
                    setMiterLimit(limit) {
                        this.current.miterLimit = limit;
                    }
                    setStrokeAlpha(strokeAlpha) {
                        this.current.strokeAlpha = strokeAlpha;
                    }
                    setStrokeRGBColor(r, g, b) {
                        this.current.strokeColor = _util.Util.makeHexColor(r, g, b);
                    }
                    setFillAlpha(fillAlpha) {
                        this.current.fillAlpha = fillAlpha;
                    }
                    setFillRGBColor(r, g, b) {
                        this.current.fillColor = _util.Util.makeHexColor(r, g, b);
                        this.current.tspan = this.svgFactory.createElement("svg:tspan");
                        this.current.xcoords = [];
                        this.current.ycoords = [];
                    }
                    setStrokeColorN(args) {
                        this.current.strokeColor = this._makeColorN_Pattern(args);
                    }
                    setFillColorN(args) {
                        this.current.fillColor = this._makeColorN_Pattern(args);
                    }
                    shadingFill(args) {
                        const { width, height } = this.viewport;
                        const inv = _util.Util.inverseTransform(this.transformMatrix);
                        const [x0, y0, x1, y1] = _util.Util.getAxialAlignedBoundingBox([
                            0,
                            0,
                            width,
                            height
                        ], inv);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", x0);
                        rect.setAttributeNS(null, "y", y0);
                        rect.setAttributeNS(null, "width", x1 - x0);
                        rect.setAttributeNS(null, "height", y1 - y0);
                        rect.setAttributeNS(null, "fill", this._makeShadingPattern(args));
                        if (this.current.fillAlpha < 1) rect.setAttributeNS(null, "fill-opacity", this.current.fillAlpha);
                        this._ensureTransformGroup().append(rect);
                    }
                    _makeColorN_Pattern(args) {
                        if (args[0] === "TilingPattern") return this._makeTilingPattern(args);
                        return this._makeShadingPattern(args);
                    }
                    _makeTilingPattern(args) {
                        const color = args[1];
                        const operatorList = args[2];
                        const matrix = args[3] || _util.IDENTITY_MATRIX;
                        const [x0, y0, x1, y1] = args[4];
                        const xstep = args[5];
                        const ystep = args[6];
                        const paintType = args[7];
                        const tilingId = `shading${shadingCount++}`;
                        const [tx0, ty0, tx1, ty1] = _util.Util.normalizeRect([
                            ..._util.Util.applyTransform([
                                x0,
                                y0
                            ], matrix),
                            ..._util.Util.applyTransform([
                                x1,
                                y1
                            ], matrix)
                        ]);
                        const [xscale, yscale] = _util.Util.singularValueDecompose2dScale(matrix);
                        const txstep = xstep * xscale;
                        const tystep = ystep * yscale;
                        const tiling = this.svgFactory.createElement("svg:pattern");
                        tiling.setAttributeNS(null, "id", tilingId);
                        tiling.setAttributeNS(null, "patternUnits", "userSpaceOnUse");
                        tiling.setAttributeNS(null, "width", txstep);
                        tiling.setAttributeNS(null, "height", tystep);
                        tiling.setAttributeNS(null, "x", `${tx0}`);
                        tiling.setAttributeNS(null, "y", `${ty0}`);
                        const svg = this.svg;
                        const transformMatrix = this.transformMatrix;
                        const fillColor = this.current.fillColor;
                        const strokeColor = this.current.strokeColor;
                        const bbox = this.svgFactory.create(tx1 - tx0, ty1 - ty0);
                        this.svg = bbox;
                        this.transformMatrix = matrix;
                        if (paintType === 2) {
                            const cssColor = _util.Util.makeHexColor(...color);
                            this.current.fillColor = cssColor;
                            this.current.strokeColor = cssColor;
                        }
                        this.executeOpTree(this.convertOpList(operatorList));
                        this.svg = svg;
                        this.transformMatrix = transformMatrix;
                        this.current.fillColor = fillColor;
                        this.current.strokeColor = strokeColor;
                        tiling.append(bbox.childNodes[0]);
                        this.defs.append(tiling);
                        return `url(#${tilingId})`;
                    }
                    _makeShadingPattern(args) {
                        if (typeof args === "string") args = this.objs.get(args);
                        switch(args[0]){
                            case "RadialAxial":
                                const shadingId = `shading${shadingCount++}`;
                                const colorStops = args[3];
                                let gradient;
                                switch(args[1]){
                                    case "axial":
                                        const point0 = args[4];
                                        const point1 = args[5];
                                        gradient = this.svgFactory.createElement("svg:linearGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "x1", point0[0]);
                                        gradient.setAttributeNS(null, "y1", point0[1]);
                                        gradient.setAttributeNS(null, "x2", point1[0]);
                                        gradient.setAttributeNS(null, "y2", point1[1]);
                                        break;
                                    case "radial":
                                        const focalPoint = args[4];
                                        const circlePoint = args[5];
                                        const focalRadius = args[6];
                                        const circleRadius = args[7];
                                        gradient = this.svgFactory.createElement("svg:radialGradient");
                                        gradient.setAttributeNS(null, "id", shadingId);
                                        gradient.setAttributeNS(null, "gradientUnits", "userSpaceOnUse");
                                        gradient.setAttributeNS(null, "cx", circlePoint[0]);
                                        gradient.setAttributeNS(null, "cy", circlePoint[1]);
                                        gradient.setAttributeNS(null, "r", circleRadius);
                                        gradient.setAttributeNS(null, "fx", focalPoint[0]);
                                        gradient.setAttributeNS(null, "fy", focalPoint[1]);
                                        gradient.setAttributeNS(null, "fr", focalRadius);
                                        break;
                                    default:
                                        throw new Error(`Unknown RadialAxial type: ${args[1]}`);
                                }
                                for (const colorStop of colorStops){
                                    const stop = this.svgFactory.createElement("svg:stop");
                                    stop.setAttributeNS(null, "offset", colorStop[0]);
                                    stop.setAttributeNS(null, "stop-color", colorStop[1]);
                                    gradient.append(stop);
                                }
                                this.defs.append(gradient);
                                return `url(#${shadingId})`;
                            case "Mesh":
                                (0, _util.warn)("Unimplemented pattern Mesh");
                                return null;
                            case "Dummy":
                                return "hotpink";
                            default:
                                throw new Error(`Unknown IR type: ${args[0]}`);
                        }
                    }
                    setDash(dashArray, dashPhase) {
                        this.current.dashArray = dashArray;
                        this.current.dashPhase = dashPhase;
                    }
                    constructPath(ops, args) {
                        const current = this.current;
                        let x = current.x, y = current.y;
                        let d = [];
                        let j = 0;
                        for (const op of ops)switch(op | 0){
                            case _util.OPS.rectangle:
                                x = args[j++];
                                y = args[j++];
                                const width = args[j++];
                                const height = args[j++];
                                const xw = x + width;
                                const yh = y + height;
                                d.push("M", pf(x), pf(y), "L", pf(xw), pf(y), "L", pf(xw), pf(yh), "L", pf(x), pf(yh), "Z");
                                break;
                            case _util.OPS.moveTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("M", pf(x), pf(y));
                                break;
                            case _util.OPS.lineTo:
                                x = args[j++];
                                y = args[j++];
                                d.push("L", pf(x), pf(y));
                                break;
                            case _util.OPS.curveTo:
                                x = args[j + 4];
                                y = args[j + 5];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]), pf(x), pf(y));
                                j += 6;
                                break;
                            case _util.OPS.curveTo2:
                                d.push("C", pf(x), pf(y), pf(args[j]), pf(args[j + 1]), pf(args[j + 2]), pf(args[j + 3]));
                                x = args[j + 2];
                                y = args[j + 3];
                                j += 4;
                                break;
                            case _util.OPS.curveTo3:
                                x = args[j + 2];
                                y = args[j + 3];
                                d.push("C", pf(args[j]), pf(args[j + 1]), pf(x), pf(y), pf(x), pf(y));
                                j += 4;
                                break;
                            case _util.OPS.closePath:
                                d.push("Z");
                                break;
                        }
                        d = d.join(" ");
                        if (current.path && ops.length > 0 && ops[0] !== _util.OPS.rectangle && ops[0] !== _util.OPS.moveTo) d = current.path.getAttributeNS(null, "d") + d;
                        else {
                            current.path = this.svgFactory.createElement("svg:path");
                            this._ensureTransformGroup().append(current.path);
                        }
                        current.path.setAttributeNS(null, "d", d);
                        current.path.setAttributeNS(null, "fill", "none");
                        current.element = current.path;
                        current.setCurrentPoint(x, y);
                    }
                    endPath() {
                        const current = this.current;
                        current.path = null;
                        if (!this.pendingClip) return;
                        if (!current.element) {
                            this.pendingClip = null;
                            return;
                        }
                        const clipId = `clippath${clipCount++}`;
                        const clipPath = this.svgFactory.createElement("svg:clipPath");
                        clipPath.setAttributeNS(null, "id", clipId);
                        clipPath.setAttributeNS(null, "transform", pm(this.transformMatrix));
                        const clipElement = current.element.cloneNode(true);
                        if (this.pendingClip === "evenodd") clipElement.setAttributeNS(null, "clip-rule", "evenodd");
                        else clipElement.setAttributeNS(null, "clip-rule", "nonzero");
                        this.pendingClip = null;
                        clipPath.append(clipElement);
                        this.defs.append(clipPath);
                        if (current.activeClipUrl) {
                            current.clipGroup = null;
                            for (const prev of this.extraStack)prev.clipGroup = null;
                            clipPath.setAttributeNS(null, "clip-path", current.activeClipUrl);
                        }
                        current.activeClipUrl = `url(#${clipId})`;
                        this.tgrp = null;
                    }
                    clip(type) {
                        this.pendingClip = type;
                    }
                    closePath() {
                        const current = this.current;
                        if (current.path) {
                            const d = `${current.path.getAttributeNS(null, "d")}Z`;
                            current.path.setAttributeNS(null, "d", d);
                        }
                    }
                    setLeading(leading) {
                        this.current.leading = -leading;
                    }
                    setTextRise(textRise) {
                        this.current.textRise = textRise;
                    }
                    setTextRenderingMode(textRenderingMode) {
                        this.current.textRenderingMode = textRenderingMode;
                    }
                    setHScale(scale) {
                        this.current.textHScale = scale / 100;
                    }
                    setRenderingIntent(intent) {}
                    setFlatness(flatness) {}
                    setGState(states) {
                        for (const [key, value] of states)switch(key){
                            case "LW":
                                this.setLineWidth(value);
                                break;
                            case "LC":
                                this.setLineCap(value);
                                break;
                            case "LJ":
                                this.setLineJoin(value);
                                break;
                            case "ML":
                                this.setMiterLimit(value);
                                break;
                            case "D":
                                this.setDash(value[0], value[1]);
                                break;
                            case "RI":
                                this.setRenderingIntent(value);
                                break;
                            case "FL":
                                this.setFlatness(value);
                                break;
                            case "Font":
                                this.setFont(value);
                                break;
                            case "CA":
                                this.setStrokeAlpha(value);
                                break;
                            case "ca":
                                this.setFillAlpha(value);
                                break;
                            default:
                                (0, _util.warn)(`Unimplemented graphic state operator ${key}`);
                                break;
                        }
                    }
                    fill() {
                        const current = this.current;
                        if (current.element) {
                            current.element.setAttributeNS(null, "fill", current.fillColor);
                            current.element.setAttributeNS(null, "fill-opacity", current.fillAlpha);
                            this.endPath();
                        }
                    }
                    stroke() {
                        const current = this.current;
                        if (current.element) {
                            this._setStrokeAttributes(current.element);
                            current.element.setAttributeNS(null, "fill", "none");
                            this.endPath();
                        }
                    }
                    _setStrokeAttributes(element, lineWidthScale = 1) {
                        const current = this.current;
                        let dashArray = current.dashArray;
                        if (lineWidthScale !== 1 && dashArray.length > 0) dashArray = dashArray.map(function(value) {
                            return lineWidthScale * value;
                        });
                        element.setAttributeNS(null, "stroke", current.strokeColor);
                        element.setAttributeNS(null, "stroke-opacity", current.strokeAlpha);
                        element.setAttributeNS(null, "stroke-miterlimit", pf(current.miterLimit));
                        element.setAttributeNS(null, "stroke-linecap", current.lineCap);
                        element.setAttributeNS(null, "stroke-linejoin", current.lineJoin);
                        element.setAttributeNS(null, "stroke-width", pf(lineWidthScale * current.lineWidth) + "px");
                        element.setAttributeNS(null, "stroke-dasharray", dashArray.map(pf).join(" "));
                        element.setAttributeNS(null, "stroke-dashoffset", pf(lineWidthScale * current.dashPhase) + "px");
                    }
                    eoFill() {
                        var _this_current_element;
                        (_this_current_element = this.current.element) === null || _this_current_element === void 0 ? void 0 : _this_current_element.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fill();
                    }
                    fillStroke() {
                        this.stroke();
                        this.fill();
                    }
                    eoFillStroke() {
                        var _this_current_element;
                        (_this_current_element = this.current.element) === null || _this_current_element === void 0 ? void 0 : _this_current_element.setAttributeNS(null, "fill-rule", "evenodd");
                        this.fillStroke();
                    }
                    closeStroke() {
                        this.closePath();
                        this.stroke();
                    }
                    closeFillStroke() {
                        this.closePath();
                        this.fillStroke();
                    }
                    closeEOFillStroke() {
                        this.closePath();
                        this.eoFillStroke();
                    }
                    paintSolidColorImageMask() {
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", "1px");
                        rect.setAttributeNS(null, "height", "1px");
                        rect.setAttributeNS(null, "fill", this.current.fillColor);
                        this._ensureTransformGroup().append(rect);
                    }
                    paintImageXObject(objId) {
                        const imgData = this.getObject(objId);
                        if (!imgData) {
                            (0, _util.warn)(`Dependent image with object ID ${objId} is not ready yet`);
                            return;
                        }
                        this.paintInlineImageXObject(imgData);
                    }
                    paintInlineImageXObject(imgData, mask) {
                        const width = imgData.width;
                        const height = imgData.height;
                        const imgSrc = convertImgDataToPng(imgData, this.forceDataSchema, !!mask);
                        const cliprect = this.svgFactory.createElement("svg:rect");
                        cliprect.setAttributeNS(null, "x", "0");
                        cliprect.setAttributeNS(null, "y", "0");
                        cliprect.setAttributeNS(null, "width", pf(width));
                        cliprect.setAttributeNS(null, "height", pf(height));
                        this.current.element = cliprect;
                        this.clip("nonzero");
                        const imgEl = this.svgFactory.createElement("svg:image");
                        imgEl.setAttributeNS(XLINK_NS, "xlink:href", imgSrc);
                        imgEl.setAttributeNS(null, "x", "0");
                        imgEl.setAttributeNS(null, "y", pf(-height));
                        imgEl.setAttributeNS(null, "width", pf(width) + "px");
                        imgEl.setAttributeNS(null, "height", pf(height) + "px");
                        imgEl.setAttributeNS(null, "transform", `scale(${pf(1 / width)} ${pf(-1 / height)})`);
                        if (mask) mask.append(imgEl);
                        else this._ensureTransformGroup().append(imgEl);
                    }
                    paintImageMaskXObject(img) {
                        const imgData = this.getObject(img.data, img);
                        if (imgData.bitmap) {
                            (0, _util.warn)("paintImageMaskXObject: ImageBitmap support is not implemented, ensure that the `isOffscreenCanvasSupported` API parameter is disabled.");
                            return;
                        }
                        const current = this.current;
                        const width = imgData.width;
                        const height = imgData.height;
                        const fillColor = current.fillColor;
                        current.maskId = `mask${maskCount++}`;
                        const mask = this.svgFactory.createElement("svg:mask");
                        mask.setAttributeNS(null, "id", current.maskId);
                        const rect = this.svgFactory.createElement("svg:rect");
                        rect.setAttributeNS(null, "x", "0");
                        rect.setAttributeNS(null, "y", "0");
                        rect.setAttributeNS(null, "width", pf(width));
                        rect.setAttributeNS(null, "height", pf(height));
                        rect.setAttributeNS(null, "fill", fillColor);
                        rect.setAttributeNS(null, "mask", `url(#${current.maskId})`);
                        this.defs.append(mask);
                        this._ensureTransformGroup().append(rect);
                        this.paintInlineImageXObject(imgData, mask);
                    }
                    paintFormXObjectBegin(matrix, bbox) {
                        if (Array.isArray(matrix) && matrix.length === 6) this.transform(matrix[0], matrix[1], matrix[2], matrix[3], matrix[4], matrix[5]);
                        if (bbox) {
                            const width = bbox[2] - bbox[0];
                            const height = bbox[3] - bbox[1];
                            const cliprect = this.svgFactory.createElement("svg:rect");
                            cliprect.setAttributeNS(null, "x", bbox[0]);
                            cliprect.setAttributeNS(null, "y", bbox[1]);
                            cliprect.setAttributeNS(null, "width", pf(width));
                            cliprect.setAttributeNS(null, "height", pf(height));
                            this.current.element = cliprect;
                            this.clip("nonzero");
                            this.endPath();
                        }
                    }
                    paintFormXObjectEnd() {}
                    _initialize(viewport) {
                        const svg = this.svgFactory.create(viewport.width, viewport.height);
                        const definitions = this.svgFactory.createElement("svg:defs");
                        svg.append(definitions);
                        this.defs = definitions;
                        const rootGroup = this.svgFactory.createElement("svg:g");
                        rootGroup.setAttributeNS(null, "transform", pm(viewport.transform));
                        svg.append(rootGroup);
                        this.svg = rootGroup;
                        return svg;
                    }
                    _ensureClipGroup() {
                        if (!this.current.clipGroup) {
                            const clipGroup = this.svgFactory.createElement("svg:g");
                            clipGroup.setAttributeNS(null, "clip-path", this.current.activeClipUrl);
                            this.svg.append(clipGroup);
                            this.current.clipGroup = clipGroup;
                        }
                        return this.current.clipGroup;
                    }
                    _ensureTransformGroup() {
                        if (!this.tgrp) {
                            this.tgrp = this.svgFactory.createElement("svg:g");
                            this.tgrp.setAttributeNS(null, "transform", pm(this.transformMatrix));
                            if (this.current.activeClipUrl) this._ensureClipGroup().append(this.tgrp);
                            else this.svg.append(this.tgrp);
                        }
                        return this.tgrp;
                    }
                    constructor(commonObjs, objs, forceDataSchema = false){
                        (0, _display_utils.deprecated)("The SVG back-end is no longer maintained and *may* be removed in the future.");
                        this.svgFactory = new _display_utils.DOMSVGFactory();
                        this.current = new SVGExtraState();
                        this.transformMatrix = _util.IDENTITY_MATRIX;
                        this.transformStack = [];
                        this.extraStack = [];
                        this.commonObjs = commonObjs;
                        this.objs = objs;
                        this.pendingClip = null;
                        this.pendingEOFill = false;
                        this.embedFonts = false;
                        this.embeddedFonts = Object.create(null);
                        this.cssStyle = null;
                        this.forceDataSchema = !!forceDataSchema;
                        this._operatorIdMapping = [];
                        for(const op in _util.OPS)this._operatorIdMapping[_util.OPS[op]] = op;
                    }
                }
                exports.SVGGraphics = SVGGraphics;
            /***/ },
            /* 25 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaText = void 0;
                class XfaText {
                    static textContent(xfa) {
                        const items = [];
                        const output = {
                            items: items,
                            styles: Object.create(null)
                        };
                        function walk(node) {
                            var _node_attributes;
                            if (!node) return;
                            let str = null;
                            const name = node.name;
                            if (name === "#text") str = node.value;
                            else if (!XfaText.shouldBuildText(name)) return;
                            else if (node === null || node === void 0 ? void 0 : (_node_attributes = node.attributes) === null || _node_attributes === void 0 ? void 0 : _node_attributes.textContent) str = node.attributes.textContent;
                            else if (node.value) str = node.value;
                            if (str !== null) items.push({
                                str: str
                            });
                            if (!node.children) return;
                            for (const child of node.children)walk(child);
                        }
                        walk(xfa);
                        return output;
                    }
                    static shouldBuildText(name) {
                        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
                    }
                }
                exports.XfaText = XfaText;
            /***/ },
            /* 26 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.TextLayerRenderTask = void 0;
                exports.renderTextLayer = renderTextLayer;
                exports.updateTextLayer = updateTextLayer;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                const MAX_TEXT_DIVS_TO_RENDER = 100000;
                const DEFAULT_FONT_SIZE = 30;
                const DEFAULT_FONT_ASCENT = 0.8;
                const ascentCache = new Map();
                function getCtx(size, isOffscreenCanvasSupported) {
                    let ctx;
                    if (isOffscreenCanvasSupported && _util.FeatureTest.isOffscreenCanvasSupported) ctx = new OffscreenCanvas(size, size).getContext("2d", {
                        alpha: false
                    });
                    else {
                        const canvas = document.createElement("canvas");
                        canvas.width = canvas.height = size;
                        ctx = canvas.getContext("2d", {
                            alpha: false
                        });
                    }
                    return ctx;
                }
                function getAscent(fontFamily, isOffscreenCanvasSupported) {
                    const cachedAscent = ascentCache.get(fontFamily);
                    if (cachedAscent) return cachedAscent;
                    const ctx = getCtx(DEFAULT_FONT_SIZE, isOffscreenCanvasSupported);
                    ctx.font = `${DEFAULT_FONT_SIZE}px ${fontFamily}`;
                    const metrics = ctx.measureText("");
                    let ascent = metrics.fontBoundingBoxAscent;
                    let descent = Math.abs(metrics.fontBoundingBoxDescent);
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        ctx.canvas.width = ctx.canvas.height = 0;
                        return ratio;
                    }
                    ctx.strokeStyle = "red";
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("g", 0, 0);
                    let pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    descent = 0;
                    for(let i = pixels.length - 1 - 3; i >= 0; i -= 4)if (pixels[i] > 0) {
                        descent = Math.ceil(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.clearRect(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE);
                    ctx.strokeText("A", 0, DEFAULT_FONT_SIZE);
                    pixels = ctx.getImageData(0, 0, DEFAULT_FONT_SIZE, DEFAULT_FONT_SIZE).data;
                    ascent = 0;
                    for(let i = 0, ii = pixels.length; i < ii; i += 4)if (pixels[i] > 0) {
                        ascent = DEFAULT_FONT_SIZE - Math.floor(i / 4 / DEFAULT_FONT_SIZE);
                        break;
                    }
                    ctx.canvas.width = ctx.canvas.height = 0;
                    if (ascent) {
                        const ratio = ascent / (ascent + descent);
                        ascentCache.set(fontFamily, ratio);
                        return ratio;
                    }
                    ascentCache.set(fontFamily, DEFAULT_FONT_ASCENT);
                    return DEFAULT_FONT_ASCENT;
                }
                function appendText(task, geom, styles) {
                    const textDiv = document.createElement("span");
                    const textDivProperties = {
                        angle: 0,
                        canvasWidth: 0,
                        hasText: geom.str !== "",
                        hasEOL: geom.hasEOL,
                        fontSize: 0
                    };
                    task._textDivs.push(textDiv);
                    const tx = _util.Util.transform(task._transform, geom.transform);
                    let angle = Math.atan2(tx[1], tx[0]);
                    const style = styles[geom.fontName];
                    if (style.vertical) angle += Math.PI / 2;
                    const fontHeight = Math.hypot(tx[2], tx[3]);
                    const fontAscent = fontHeight * getAscent(style.fontFamily, task._isOffscreenCanvasSupported);
                    let left, top;
                    if (angle === 0) {
                        left = tx[4];
                        top = tx[5] - fontAscent;
                    } else {
                        left = tx[4] + fontAscent * Math.sin(angle);
                        top = tx[5] - fontAscent * Math.cos(angle);
                    }
                    const scaleFactorStr = "calc(var(--scale-factor)*";
                    const divStyle = textDiv.style;
                    if (task._container === task._rootContainer) {
                        divStyle.left = `${(100 * left / task._pageWidth).toFixed(2)}%`;
                        divStyle.top = `${(100 * top / task._pageHeight).toFixed(2)}%`;
                    } else {
                        divStyle.left = `${scaleFactorStr}${left.toFixed(2)}px)`;
                        divStyle.top = `${scaleFactorStr}${top.toFixed(2)}px)`;
                    }
                    divStyle.fontSize = `${scaleFactorStr}${fontHeight.toFixed(2)}px)`;
                    divStyle.fontFamily = style.fontFamily;
                    textDivProperties.fontSize = fontHeight;
                    textDiv.setAttribute("role", "presentation");
                    textDiv.textContent = geom.str;
                    textDiv.dir = geom.dir;
                    if (task._fontInspectorEnabled) textDiv.dataset.fontName = geom.fontName;
                    if (angle !== 0) textDivProperties.angle = angle * (180 / Math.PI);
                    let shouldScaleText = false;
                    if (geom.str.length > 1) shouldScaleText = true;
                    else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
                        const absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
                        if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) shouldScaleText = true;
                    }
                    if (shouldScaleText) textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
                    task._textDivProperties.set(textDiv, textDivProperties);
                    if (task._isReadableStream) task._layoutText(textDiv);
                }
                function layout(params) {
                    const { div, scale, properties, ctx, prevFontSize, prevFontFamily } = params;
                    const { style } = div;
                    let transform = "";
                    if (properties.canvasWidth !== 0 && properties.hasText) {
                        const { fontFamily } = style;
                        const { canvasWidth, fontSize } = properties;
                        if (prevFontSize !== fontSize || prevFontFamily !== fontFamily) {
                            ctx.font = `${fontSize * scale}px ${fontFamily}`;
                            params.prevFontSize = fontSize;
                            params.prevFontFamily = fontFamily;
                        }
                        const { width } = ctx.measureText(div.textContent);
                        if (width > 0) transform = `scaleX(${canvasWidth * scale / width})`;
                    }
                    if (properties.angle !== 0) transform = `rotate(${properties.angle}deg) ${transform}`;
                    if (transform.length > 0) style.transform = transform;
                }
                function render(task) {
                    if (task._canceled) return;
                    const textDivs = task._textDivs;
                    const capability = task._capability;
                    const textDivsLength = textDivs.length;
                    if (textDivsLength > MAX_TEXT_DIVS_TO_RENDER) {
                        capability.resolve();
                        return;
                    }
                    if (!task._isReadableStream) for (const textDiv of textDivs)task._layoutText(textDiv);
                    capability.resolve();
                }
                class TextLayerRenderTask {
                    get promise() {
                        return this._capability.promise;
                    }
                    cancel() {
                        this._canceled = true;
                        if (this._reader) {
                            this._reader.cancel(new _util.AbortException("TextLayer task cancelled.")).catch(()=>{});
                            this._reader = null;
                        }
                        this._capability.reject(new _util.AbortException("TextLayer task cancelled."));
                    }
                    _processItems(items, styleCache) {
                        for (const item of items){
                            if (item.str === undefined) {
                                if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                                    const parent = this._container;
                                    this._container = document.createElement("span");
                                    this._container.classList.add("markedContent");
                                    if (item.id !== null) this._container.setAttribute("id", `${item.id}`);
                                    parent.append(this._container);
                                } else if (item.type === "endMarkedContent") this._container = this._container.parentNode;
                                continue;
                            }
                            this._textContentItemsStr.push(item.str);
                            appendText(this, item, styleCache);
                        }
                    }
                    _layoutText(textDiv) {
                        const textDivProperties = this._layoutTextParams.properties = this._textDivProperties.get(textDiv);
                        this._layoutTextParams.div = textDiv;
                        layout(this._layoutTextParams);
                        if (textDivProperties.hasText) this._container.append(textDiv);
                        if (textDivProperties.hasEOL) {
                            const br = document.createElement("br");
                            br.setAttribute("role", "presentation");
                            this._container.append(br);
                        }
                    }
                    _render() {
                        const capability = new _util.PromiseCapability();
                        let styleCache = Object.create(null);
                        if (this._isReadableStream) {
                            const pump = ()=>{
                                this._reader.read().then(({ value, done })=>{
                                    if (done) {
                                        capability.resolve();
                                        return;
                                    }
                                    Object.assign(styleCache, value.styles);
                                    this._processItems(value.items, styleCache);
                                    pump();
                                }, capability.reject);
                            };
                            this._reader = this._textContentSource.getReader();
                            pump();
                        } else if (this._textContentSource) {
                            const { items, styles } = this._textContentSource;
                            this._processItems(items, styles);
                            capability.resolve();
                        } else throw new Error('No "textContentSource" parameter specified.');
                        capability.promise.then(()=>{
                            styleCache = null;
                            render(this);
                        }, this._capability.reject);
                    }
                    constructor({ textContentSource, container, viewport, textDivs, textDivProperties, textContentItemsStr, isOffscreenCanvasSupported }){
                        var _globalThis_FontInspector;
                        this._textContentSource = textContentSource;
                        this._isReadableStream = textContentSource instanceof ReadableStream;
                        this._container = this._rootContainer = container;
                        this._textDivs = textDivs || [];
                        this._textContentItemsStr = textContentItemsStr || [];
                        this._isOffscreenCanvasSupported = isOffscreenCanvasSupported;
                        this._fontInspectorEnabled = !!((_globalThis_FontInspector = globalThis.FontInspector) === null || _globalThis_FontInspector === void 0 ? void 0 : _globalThis_FontInspector.enabled);
                        this._reader = null;
                        this._textDivProperties = textDivProperties || new WeakMap();
                        this._canceled = false;
                        this._capability = new _util.PromiseCapability();
                        this._layoutTextParams = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: viewport.scale * (globalThis.devicePixelRatio || 1),
                            properties: null,
                            ctx: getCtx(0, isOffscreenCanvasSupported)
                        };
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        this._transform = [
                            1,
                            0,
                            0,
                            -1,
                            -pageX,
                            pageY + pageHeight
                        ];
                        this._pageWidth = pageWidth;
                        this._pageHeight = pageHeight;
                        (0, _display_utils.setLayerDimensions)(container, viewport);
                        this._capability.promise.finally(()=>{
                            this._layoutTextParams = null;
                        }).catch(()=>{});
                    }
                }
                exports.TextLayerRenderTask = TextLayerRenderTask;
                function renderTextLayer(params) {
                    if (!params.textContentSource && (params.textContent || params.textContentStream)) {
                        (0, _display_utils.deprecated)("The TextLayerRender `textContent`/`textContentStream` parameters will be removed in the future, please use `textContentSource` instead.");
                        params.textContentSource = params.textContent || params.textContentStream;
                    }
                    const { container, viewport } = params;
                    const style = getComputedStyle(container);
                    const visibility = style.getPropertyValue("visibility");
                    const scaleFactor = parseFloat(style.getPropertyValue("--scale-factor"));
                    if (visibility === "visible" && (!scaleFactor || Math.abs(scaleFactor - viewport.scale) > 1e-5)) console.error("The `--scale-factor` CSS-variable must be set, to the same value as `viewport.scale`, either on the `container`-element itself or higher up in the DOM.");
                    const task = new TextLayerRenderTask(params);
                    task._render();
                    return task;
                }
                function updateTextLayer({ container, viewport, textDivs, textDivProperties, isOffscreenCanvasSupported, mustRotate = true, mustRescale = true }) {
                    if (mustRotate) (0, _display_utils.setLayerDimensions)(container, {
                        rotation: viewport.rotation
                    });
                    if (mustRescale) {
                        const ctx = getCtx(0, isOffscreenCanvasSupported);
                        const scale = viewport.scale * (globalThis.devicePixelRatio || 1);
                        const params = {
                            prevFontSize: null,
                            prevFontFamily: null,
                            div: null,
                            scale: scale,
                            properties: null,
                            ctx: ctx
                        };
                        for (const div of textDivs){
                            params.properties = textDivProperties.get(div);
                            params.div = div;
                            layout(params);
                        }
                    }
                }
            /***/ },
            /* 27 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.AnnotationEditorLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _freetext = __w_pdfjs_require__(28);
                var _ink = __w_pdfjs_require__(33);
                var _display_utils = __w_pdfjs_require__(6);
                var _stamp = __w_pdfjs_require__(34);
                var _accessibilityManager = /*#__PURE__*/ new WeakMap(), _allowClick = /*#__PURE__*/ new WeakMap(), _annotationLayer = /*#__PURE__*/ new WeakMap(), _boundPointerup = /*#__PURE__*/ new WeakMap(), _boundPointerdown = /*#__PURE__*/ new WeakMap(), _editors = /*#__PURE__*/ new WeakMap(), _hadPointerDown = /*#__PURE__*/ new WeakMap(), _isCleaningUp = /*#__PURE__*/ new WeakMap(), _isDisabling = /*#__PURE__*/ new WeakMap(), _uiManager = /*#__PURE__*/ new WeakMap(), _createNewEditor = /*#__PURE__*/ new WeakSet(), _createAndAddNewEditor = /*#__PURE__*/ new WeakSet(), _getCenterPoint = /*#__PURE__*/ new WeakSet(), _cleanup = /*#__PURE__*/ new WeakSet();
                class AnnotationEditorLayer {
                    get isEmpty() {
                        return (0, $f2lgg._)(this, _editors).size === 0;
                    }
                    updateToolbar(mode) {
                        (0, $f2lgg._)(this, _uiManager).updateToolbar(mode);
                    }
                    updateMode(mode = (0, $f2lgg._)(this, _uiManager).getMode()) {
                        (0, $hDjZy._)(this, _cleanup, cleanup).call(this);
                        if (mode === _util.AnnotationEditorType.INK) {
                            this.addInkEditorIfNeeded(false);
                            this.disableClick();
                        } else this.enableClick();
                        if (mode !== _util.AnnotationEditorType.NONE) {
                            this.div.classList.toggle("freeTextEditing", mode === _util.AnnotationEditorType.FREETEXT);
                            this.div.classList.toggle("inkEditing", mode === _util.AnnotationEditorType.INK);
                            this.div.classList.toggle("stampEditing", mode === _util.AnnotationEditorType.STAMP);
                            this.div.hidden = false;
                        }
                    }
                    addInkEditorIfNeeded(isCommitting) {
                        if (!isCommitting && (0, $f2lgg._)(this, _uiManager).getMode() !== _util.AnnotationEditorType.INK) return;
                        if (!isCommitting) {
                            for (const editor of (0, $f2lgg._)(this, _editors).values())if (editor.isEmpty()) {
                                editor.setInBackground();
                                return;
                            }
                        }
                        const editor = (0, $hDjZy._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, {
                            offsetX: 0,
                            offsetY: 0
                        }, false);
                        editor.setInBackground();
                    }
                    setEditingState(isEditing) {
                        (0, $f2lgg._)(this, _uiManager).setEditingState(isEditing);
                    }
                    addCommands(params) {
                        (0, $f2lgg._)(this, _uiManager).addCommands(params);
                    }
                    enable() {
                        this.div.style.pointerEvents = "auto";
                        const annotationElementIds = new Set();
                        for (const editor of (0, $f2lgg._)(this, _editors).values()){
                            editor.enableEditing();
                            if (editor.annotationElementId) annotationElementIds.add(editor.annotationElementId);
                        }
                        if (!(0, $f2lgg._)(this, _annotationLayer)) return;
                        const editables = (0, $f2lgg._)(this, _annotationLayer).getEditableAnnotations();
                        for (const editable of editables){
                            editable.hide();
                            if ((0, $f2lgg._)(this, _uiManager).isDeletedAnnotationElement(editable.data.id)) continue;
                            if (annotationElementIds.has(editable.data.id)) continue;
                            const editor = this.deserialize(editable);
                            if (!editor) continue;
                            this.addOrRebuild(editor);
                            editor.enableEditing();
                        }
                    }
                    disable() {
                        (0, $5grPd._)(this, _isDisabling, true);
                        this.div.style.pointerEvents = "none";
                        const hiddenAnnotationIds = new Set();
                        for (const editor of (0, $f2lgg._)(this, _editors).values()){
                            var _this_getEditableAnnotation;
                            editor.disableEditing();
                            if (!editor.annotationElementId || editor.serialize() !== null) {
                                hiddenAnnotationIds.add(editor.annotationElementId);
                                continue;
                            }
                            (_this_getEditableAnnotation = this.getEditableAnnotation(editor.annotationElementId)) === null || _this_getEditableAnnotation === void 0 ? void 0 : _this_getEditableAnnotation.show();
                            editor.remove();
                        }
                        if ((0, $f2lgg._)(this, _annotationLayer)) {
                            const editables = (0, $f2lgg._)(this, _annotationLayer).getEditableAnnotations();
                            for (const editable of editables){
                                const { id } = editable.data;
                                if (hiddenAnnotationIds.has(id) || (0, $f2lgg._)(this, _uiManager).isDeletedAnnotationElement(id)) continue;
                                editable.show();
                            }
                        }
                        (0, $hDjZy._)(this, _cleanup, cleanup).call(this);
                        if (this.isEmpty) this.div.hidden = true;
                        (0, $5grPd._)(this, _isDisabling, false);
                    }
                    getEditableAnnotation(id) {
                        var _class_private_field_get1;
                        return ((_class_private_field_get1 = (0, $f2lgg._)(this, _annotationLayer)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.getEditableAnnotation(id)) || null;
                    }
                    setActiveEditor(editor) {
                        const currentActive = (0, $f2lgg._)(this, _uiManager).getActive();
                        if (currentActive === editor) return;
                        (0, $f2lgg._)(this, _uiManager).setActiveEditor(editor);
                    }
                    enableClick() {
                        this.div.addEventListener("pointerdown", (0, $f2lgg._)(this, _boundPointerdown));
                        this.div.addEventListener("pointerup", (0, $f2lgg._)(this, _boundPointerup));
                    }
                    disableClick() {
                        this.div.removeEventListener("pointerdown", (0, $f2lgg._)(this, _boundPointerdown));
                        this.div.removeEventListener("pointerup", (0, $f2lgg._)(this, _boundPointerup));
                    }
                    attach(editor) {
                        (0, $f2lgg._)(this, _editors).set(editor.id, editor);
                        const { annotationElementId } = editor;
                        if (annotationElementId && (0, $f2lgg._)(this, _uiManager).isDeletedAnnotationElement(annotationElementId)) (0, $f2lgg._)(this, _uiManager).removeDeletedAnnotationElement(editor);
                    }
                    detach(editor) {
                        var _class_private_field_get1;
                        (0, $f2lgg._)(this, _editors).delete(editor.id);
                        (_class_private_field_get1 = (0, $f2lgg._)(this, _accessibilityManager)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.removePointerInTextLayer(editor.contentDiv);
                        if (!(0, $f2lgg._)(this, _isDisabling) && editor.annotationElementId) (0, $f2lgg._)(this, _uiManager).addDeletedAnnotationElement(editor);
                    }
                    remove(editor) {
                        this.detach(editor);
                        (0, $f2lgg._)(this, _uiManager).removeEditor(editor);
                        if (editor.div.contains(document.activeElement)) setTimeout(()=>{
                            (0, $f2lgg._)(this, _uiManager).focusMainContainer();
                        }, 0);
                        editor.div.remove();
                        editor.isAttachedToDOM = false;
                        if (!(0, $f2lgg._)(this, _isCleaningUp)) this.addInkEditorIfNeeded(false);
                    }
                    changeParent(editor) {
                        var _editor_parent;
                        if (editor.parent === this) return;
                        if (editor.annotationElementId) {
                            (0, $f2lgg._)(this, _uiManager).addDeletedAnnotationElement(editor.annotationElementId);
                            _editor.AnnotationEditor.deleteAnnotationElement(editor);
                            editor.annotationElementId = null;
                        }
                        this.attach(editor);
                        (_editor_parent = editor.parent) === null || _editor_parent === void 0 ? void 0 : _editor_parent.detach(editor);
                        editor.setParent(this);
                        if (editor.div && editor.isAttachedToDOM) {
                            editor.div.remove();
                            this.div.append(editor.div);
                        }
                    }
                    add(editor) {
                        this.changeParent(editor);
                        (0, $f2lgg._)(this, _uiManager).addEditor(editor);
                        this.attach(editor);
                        if (!editor.isAttachedToDOM) {
                            const div = editor.render();
                            this.div.append(div);
                            editor.isAttachedToDOM = true;
                        }
                        editor.fixAndSetPosition();
                        editor.onceAdded();
                        (0, $f2lgg._)(this, _uiManager).addToAnnotationStorage(editor);
                    }
                    moveEditorInDOM(editor) {
                        var _class_private_field_get1;
                        if (!editor.isAttachedToDOM) return;
                        const { activeElement } = document;
                        if (editor.div.contains(activeElement)) {
                            editor._focusEventsAllowed = false;
                            setTimeout(()=>{
                                if (!editor.div.contains(document.activeElement)) {
                                    editor.div.addEventListener("focusin", ()=>{
                                        editor._focusEventsAllowed = true;
                                    }, {
                                        once: true
                                    });
                                    activeElement.focus();
                                } else editor._focusEventsAllowed = true;
                            }, 0);
                        }
                        editor._structTreeParentId = (_class_private_field_get1 = (0, $f2lgg._)(this, _accessibilityManager)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
                    }
                    addOrRebuild(editor) {
                        if (editor.needsToBeRebuilt()) editor.rebuild();
                        else this.add(editor);
                    }
                    addUndoableEditor(editor) {
                        const cmd = ()=>editor._uiManager.rebuild(editor);
                        const undo = ()=>{
                            editor.remove();
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: false
                        });
                    }
                    getNextId() {
                        return (0, $f2lgg._)(this, _uiManager).getId();
                    }
                    pasteEditor(mode, params) {
                        (0, $f2lgg._)(this, _uiManager).updateToolbar(mode);
                        (0, $f2lgg._)(this, _uiManager).updateMode(mode);
                        const { offsetX, offsetY } = (0, $hDjZy._)(this, _getCenterPoint, getCenterPoint).call(this);
                        const id = this.getNextId();
                        const editor = (0, $hDjZy._)(this, _createNewEditor, createNewEditor).call(this, (0, $cTSGB._)({
                            parent: this,
                            id: id,
                            x: offsetX,
                            y: offsetY,
                            uiManager: (0, $f2lgg._)(this, _uiManager),
                            isCentered: true
                        }, params));
                        if (editor) this.add(editor);
                    }
                    deserialize(data) {
                        var _data_annotationType;
                        switch((_data_annotationType = data.annotationType) !== null && _data_annotationType !== void 0 ? _data_annotationType : data.annotationEditorType){
                            case _util.AnnotationEditorType.FREETEXT:
                                return _freetext.FreeTextEditor.deserialize(data, this, (0, $f2lgg._)(this, _uiManager));
                            case _util.AnnotationEditorType.INK:
                                return _ink.InkEditor.deserialize(data, this, (0, $f2lgg._)(this, _uiManager));
                            case _util.AnnotationEditorType.STAMP:
                                return _stamp.StampEditor.deserialize(data, this, (0, $f2lgg._)(this, _uiManager));
                        }
                        return null;
                    }
                    addNewEditor() {
                        (0, $hDjZy._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, (0, $hDjZy._)(this, _getCenterPoint, getCenterPoint).call(this), true);
                    }
                    setSelected(editor) {
                        (0, $f2lgg._)(this, _uiManager).setSelected(editor);
                    }
                    toggleSelected(editor) {
                        (0, $f2lgg._)(this, _uiManager).toggleSelected(editor);
                    }
                    isSelected(editor) {
                        return (0, $f2lgg._)(this, _uiManager).isSelected(editor);
                    }
                    unselect(editor) {
                        (0, $f2lgg._)(this, _uiManager).unselect(editor);
                    }
                    pointerup(event) {
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        if (!(0, $f2lgg._)(this, _hadPointerDown)) return;
                        (0, $5grPd._)(this, _hadPointerDown, false);
                        if (!(0, $f2lgg._)(this, _allowClick)) {
                            (0, $5grPd._)(this, _allowClick, true);
                            return;
                        }
                        if ((0, $f2lgg._)(this, _uiManager).getMode() === _util.AnnotationEditorType.STAMP) {
                            (0, $f2lgg._)(this, _uiManager).unselectAll();
                            return;
                        }
                        (0, $hDjZy._)(this, _createAndAddNewEditor, createAndAddNewEditor).call(this, event, false);
                    }
                    pointerdown(event) {
                        if ((0, $f2lgg._)(this, _hadPointerDown)) {
                            (0, $5grPd._)(this, _hadPointerDown, false);
                            return;
                        }
                        const { isMac } = _util.FeatureTest.platform;
                        if (event.button !== 0 || event.ctrlKey && isMac) return;
                        if (event.target !== this.div) return;
                        (0, $5grPd._)(this, _hadPointerDown, true);
                        const editor = (0, $f2lgg._)(this, _uiManager).getActive();
                        (0, $5grPd._)(this, _allowClick, !editor || editor.isEmpty());
                    }
                    findNewParent(editor, x, y) {
                        const layer = (0, $f2lgg._)(this, _uiManager).findParent(x, y);
                        if (layer === null || layer === this) return false;
                        layer.changeParent(editor);
                        return true;
                    }
                    destroy() {
                        var _class_private_field_get_getActive;
                        if (((_class_private_field_get_getActive = (0, $f2lgg._)(this, _uiManager).getActive()) === null || _class_private_field_get_getActive === void 0 ? void 0 : _class_private_field_get_getActive.parent) === this) {
                            (0, $f2lgg._)(this, _uiManager).commitOrRemove();
                            (0, $f2lgg._)(this, _uiManager).setActiveEditor(null);
                        }
                        for (const editor of (0, $f2lgg._)(this, _editors).values()){
                            var _class_private_field_get1;
                            (_class_private_field_get1 = (0, $f2lgg._)(this, _accessibilityManager)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.removePointerInTextLayer(editor.contentDiv);
                            editor.setParent(null);
                            editor.isAttachedToDOM = false;
                            editor.div.remove();
                        }
                        this.div = null;
                        (0, $f2lgg._)(this, _editors).clear();
                        (0, $f2lgg._)(this, _uiManager).removeLayer(this);
                    }
                    render({ viewport }) {
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, viewport);
                        for (const editor of (0, $f2lgg._)(this, _uiManager).getEditors(this.pageIndex))this.add(editor);
                        this.updateMode();
                    }
                    update({ viewport }) {
                        (0, $f2lgg._)(this, _uiManager).commitOrRemove();
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(this.div, {
                            rotation: viewport.rotation
                        });
                        this.updateMode();
                    }
                    get pageDimensions() {
                        const { pageWidth, pageHeight } = this.viewport.rawDims;
                        return [
                            pageWidth,
                            pageHeight
                        ];
                    }
                    constructor({ uiManager, pageIndex, div, accessibilityManager, annotationLayer, viewport, l10n }){
                        (0, $2IZAT._)(this, _createNewEditor);
                        (0, $2IZAT._)(this, _createAndAddNewEditor);
                        (0, $2IZAT._)(this, _getCenterPoint);
                        (0, $2IZAT._)(this, _cleanup);
                        (0, $iXPoG._)(this, _accessibilityManager, {
                            writable: true,
                            value: void 0
                        });
                        (0, $iXPoG._)(this, _allowClick, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _annotationLayer, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _boundPointerup, {
                            writable: true,
                            value: this.pointerup.bind(this)
                        });
                        (0, $iXPoG._)(this, _boundPointerdown, {
                            writable: true,
                            value: this.pointerdown.bind(this)
                        });
                        (0, $iXPoG._)(this, _editors, {
                            writable: true,
                            value: new Map()
                        });
                        (0, $iXPoG._)(this, _hadPointerDown, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _isCleaningUp, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _isDisabling, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _uiManager, {
                            writable: true,
                            value: void 0
                        });
                        const editorTypes = [
                            _freetext.FreeTextEditor,
                            _ink.InkEditor,
                            _stamp.StampEditor
                        ];
                        if (!AnnotationEditorLayer._initialized) {
                            AnnotationEditorLayer._initialized = true;
                            for (const editorType of editorTypes)editorType.initialize(l10n);
                        }
                        uiManager.registerEditorTypes(editorTypes);
                        (0, $5grPd._)(this, _uiManager, uiManager);
                        this.pageIndex = pageIndex;
                        this.div = div;
                        (0, $5grPd._)(this, _accessibilityManager, accessibilityManager);
                        (0, $5grPd._)(this, _annotationLayer, annotationLayer);
                        this.viewport = viewport;
                        (0, $f2lgg._)(this, _uiManager).addLayer(this);
                    }
                }
                (0, $yQrT8._)(AnnotationEditorLayer, "_initialized", false);
                function createNewEditor(params) {
                    switch((0, $f2lgg._)(this, _uiManager).getMode()){
                        case _util.AnnotationEditorType.FREETEXT:
                            return new _freetext.FreeTextEditor(params);
                        case _util.AnnotationEditorType.INK:
                            return new _ink.InkEditor(params);
                        case _util.AnnotationEditorType.STAMP:
                            return new _stamp.StampEditor(params);
                    }
                    return null;
                }
                function createAndAddNewEditor(event, isCentered) {
                    const id = this.getNextId();
                    const editor = (0, $hDjZy._)(this, _createNewEditor, createNewEditor).call(this, {
                        parent: this,
                        id: id,
                        x: event.offsetX,
                        y: event.offsetY,
                        uiManager: (0, $f2lgg._)(this, _uiManager),
                        isCentered: isCentered
                    });
                    if (editor) this.add(editor);
                    return editor;
                }
                function getCenterPoint() {
                    const { x, y, width, height } = this.div.getBoundingClientRect();
                    const tlX = Math.max(0, x);
                    const tlY = Math.max(0, y);
                    const brX = Math.min(window.innerWidth, x + width);
                    const brY = Math.min(window.innerHeight, y + height);
                    const centerX = (tlX + brX) / 2 - x;
                    const centerY = (tlY + brY) / 2 - y;
                    const [offsetX, offsetY] = this.viewport.rotation % 180 === 0 ? [
                        centerX,
                        centerY
                    ] : [
                        centerY,
                        centerX
                    ];
                    return {
                        offsetX: offsetX,
                        offsetY: offsetY
                    };
                }
                function cleanup() {
                    (0, $5grPd._)(this, _isCleaningUp, true);
                    for (const editor of (0, $f2lgg._)(this, _editors).values())if (editor.isEmpty()) editor.remove();
                    (0, $5grPd._)(this, _isCleaningUp, false);
                }
                exports.AnnotationEditorLayer = AnnotationEditorLayer;
            /***/ },
            /* 28 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.FreeTextEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _tools = __w_pdfjs_require__(5);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _boundEditorDivBlur = /*#__PURE__*/ new WeakMap(), _boundEditorDivFocus = /*#__PURE__*/ new WeakMap(), _boundEditorDivInput = /*#__PURE__*/ new WeakMap(), _boundEditorDivKeydown = /*#__PURE__*/ new WeakMap(), _color = /*#__PURE__*/ new WeakMap(), _content = /*#__PURE__*/ new WeakMap(), _editorDivId = /*#__PURE__*/ new WeakMap(), _fontSize = /*#__PURE__*/ new WeakMap(), _initialData = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _updateFontSize = /*#__PURE__*/ new WeakSet(), _updateColor = /*#__PURE__*/ new WeakSet(), _extractText = /*#__PURE__*/ new WeakSet(), _setEditorDimensions = /*#__PURE__*/ new WeakSet(), _setContent = /*#__PURE__*/ new WeakSet(), _hasElementChanged = /*#__PURE__*/ new WeakSet(), _cheatInitialRect = /*#__PURE__*/ new WeakSet();
                class FreeTextEditor extends (_editor_AnnotationEditor = _editor.AnnotationEditor) {
                    static get _keyboardManager() {
                        const proto = FreeTextEditor.prototype;
                        const arrowChecker = (self)=>self.isEmpty();
                        const small = _tools.AnnotationEditorUIManager.TRANSLATE_SMALL;
                        const big = _tools.AnnotationEditorUIManager.TRANSLATE_BIG;
                        return (0, _util.shadow)(this, "_keyboardManager", new _tools.KeyboardManager([
                            [
                                [
                                    "ctrl+s",
                                    "mac+meta+s",
                                    "ctrl+p",
                                    "mac+meta+p"
                                ],
                                proto.commitOrRemove,
                                {
                                    bubbles: true
                                }
                            ],
                            [
                                [
                                    "ctrl+Enter",
                                    "mac+meta+Enter",
                                    "Escape",
                                    "mac+Escape"
                                ],
                                proto.commitOrRemove
                            ],
                            [
                                [
                                    "ArrowLeft",
                                    "mac+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowLeft",
                                    "mac+shift+ArrowLeft"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        -big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowRight",
                                    "mac+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        small,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowRight",
                                    "mac+shift+ArrowRight"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        big,
                                        0
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowUp",
                                    "mac+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowUp",
                                    "mac+shift+ArrowUp"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        -big
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ArrowDown",
                                    "mac+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        small
                                    ],
                                    checker: arrowChecker
                                }
                            ],
                            [
                                [
                                    "ctrl+ArrowDown",
                                    "mac+shift+ArrowDown"
                                ],
                                proto._translateEmpty,
                                {
                                    args: [
                                        0,
                                        big
                                    ],
                                    checker: arrowChecker
                                }
                            ]
                        ]));
                    }
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "free_text2_default_content",
                                "editor_free_text2_aria_label"
                            ]
                        });
                        const style = getComputedStyle(document.documentElement);
                        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                FreeTextEditor._defaultFontSize = value;
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                FreeTextEditor._defaultColor = value;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.FREETEXT_SIZE:
                                (0, $hDjZy._)(this, _updateFontSize, updateFontSize).call(this, value);
                                break;
                            case _util.AnnotationEditorParamsType.FREETEXT_COLOR:
                                (0, $hDjZy._)(this, _updateColor, updateColor).call(this, value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                FreeTextEditor._defaultFontSize
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                                (0, $f2lgg._)(this, _fontSize)
                            ],
                            [
                                _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                                (0, $f2lgg._)(this, _color)
                            ]
                        ];
                    }
                    _translateEmpty(x, y) {
                        this._uiManager.translateSelectedEditors(x, y, true);
                    }
                    getInitialTranslation() {
                        const scale = this.parentScale;
                        return [
                            -FreeTextEditor._internalPadding * scale,
                            -(FreeTextEditor._internalPadding + (0, $f2lgg._)(this, _fontSize)) * scale
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    enableEditMode() {
                        if (this.isInEditMode()) return;
                        this.parent.setEditingState(false);
                        this.parent.updateToolbar(_util.AnnotationEditorType.FREETEXT);
                        super.enableEditMode();
                        this.overlayDiv.classList.remove("enabled");
                        this.editorDiv.contentEditable = true;
                        this._isDraggable = false;
                        this.div.removeAttribute("aria-activedescendant");
                        this.editorDiv.addEventListener("keydown", (0, $f2lgg._)(this, _boundEditorDivKeydown));
                        this.editorDiv.addEventListener("focus", (0, $f2lgg._)(this, _boundEditorDivFocus));
                        this.editorDiv.addEventListener("blur", (0, $f2lgg._)(this, _boundEditorDivBlur));
                        this.editorDiv.addEventListener("input", (0, $f2lgg._)(this, _boundEditorDivInput));
                    }
                    disableEditMode() {
                        if (!this.isInEditMode()) return;
                        this.parent.setEditingState(true);
                        super.disableEditMode();
                        this.overlayDiv.classList.add("enabled");
                        this.editorDiv.contentEditable = false;
                        this.div.setAttribute("aria-activedescendant", (0, $f2lgg._)(this, _editorDivId));
                        this._isDraggable = true;
                        this.editorDiv.removeEventListener("keydown", (0, $f2lgg._)(this, _boundEditorDivKeydown));
                        this.editorDiv.removeEventListener("focus", (0, $f2lgg._)(this, _boundEditorDivFocus));
                        this.editorDiv.removeEventListener("blur", (0, $f2lgg._)(this, _boundEditorDivBlur));
                        this.editorDiv.removeEventListener("input", (0, $f2lgg._)(this, _boundEditorDivInput));
                        this.div.focus({
                            preventScroll: true
                        });
                        this.isEditing = false;
                        this.parent.div.classList.add("freeTextEditing");
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        if (event.target !== this.editorDiv) this.editorDiv.focus();
                    }
                    onceAdded() {
                        var _this__initialOptions;
                        if (this.width) {
                            (0, $hDjZy._)(this, _cheatInitialRect, cheatInitialRect).call(this);
                            return;
                        }
                        this.enableEditMode();
                        this.editorDiv.focus();
                        if ((_this__initialOptions = this._initialOptions) === null || _this__initialOptions === void 0 ? void 0 : _this__initialOptions.isCentered) this.center();
                        this._initialOptions = null;
                    }
                    isEmpty() {
                        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
                    }
                    remove() {
                        this.isEditing = false;
                        if (this.parent) {
                            this.parent.setEditingState(true);
                            this.parent.div.classList.add("freeTextEditing");
                        }
                        super.remove();
                    }
                    commit() {
                        if (!this.isInEditMode()) return;
                        super.commit();
                        this.disableEditMode();
                        const savedText = (0, $f2lgg._)(this, _content);
                        const newText = (0, $5grPd._)(this, _content, (0, $hDjZy._)(this, _extractText, extractText).call(this).trimEnd());
                        if (savedText === newText) return;
                        const setText = (text)=>{
                            (0, $5grPd._)(this, _content, text);
                            if (!text) {
                                this.remove();
                                return;
                            }
                            (0, $hDjZy._)(this, _setContent, setContent).call(this);
                            this._uiManager.rebuild(this);
                            (0, $hDjZy._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                        };
                        this.addCommands({
                            cmd: ()=>{
                                setText(newText);
                            },
                            undo: ()=>{
                                setText(savedText);
                            },
                            mustExec: false
                        });
                        (0, $hDjZy._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                    }
                    shouldGetKeyboardEvents() {
                        return this.isInEditMode();
                    }
                    enterInEditMode() {
                        this.enableEditMode();
                        this.editorDiv.focus();
                    }
                    dblclick(event) {
                        this.enterInEditMode();
                    }
                    keydown(event) {
                        if (event.target === this.div && event.key === "Enter") {
                            this.enterInEditMode();
                            event.preventDefault();
                        }
                    }
                    editorDivKeydown(event) {
                        FreeTextEditor._keyboardManager.exec(this, event);
                    }
                    editorDivFocus(event) {
                        this.isEditing = true;
                    }
                    editorDivBlur(event) {
                        this.isEditing = false;
                    }
                    editorDivInput(event) {
                        this.parent.div.classList.toggle("freeTextEditing", this.isEmpty());
                    }
                    disableEditing() {
                        this.editorDiv.setAttribute("role", "comment");
                        this.editorDiv.removeAttribute("aria-multiline");
                    }
                    enableEditing() {
                        this.editorDiv.setAttribute("role", "textbox");
                        this.editorDiv.setAttribute("aria-multiline", true);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.editorDiv = document.createElement("div");
                        this.editorDiv.className = "internal";
                        this.editorDiv.setAttribute("id", (0, $f2lgg._)(this, _editorDivId));
                        this.enableEditing();
                        _editor.AnnotationEditor._l10nPromise.get("editor_free_text2_aria_label").then((msg)=>{
                            var _this_editorDiv;
                            return (_this_editorDiv = this.editorDiv) === null || _this_editorDiv === void 0 ? void 0 : _this_editorDiv.setAttribute("aria-label", msg);
                        });
                        _editor.AnnotationEditor._l10nPromise.get("free_text2_default_content").then((msg)=>{
                            var _this_editorDiv;
                            return (_this_editorDiv = this.editorDiv) === null || _this_editorDiv === void 0 ? void 0 : _this_editorDiv.setAttribute("default-content", msg);
                        });
                        this.editorDiv.contentEditable = true;
                        const { style } = this.editorDiv;
                        style.fontSize = `calc(${(0, $f2lgg._)(this, _fontSize)}px * var(--scale-factor))`;
                        style.color = (0, $f2lgg._)(this, _color);
                        this.div.append(this.editorDiv);
                        this.overlayDiv = document.createElement("div");
                        this.overlayDiv.classList.add("overlay", "enabled");
                        this.div.append(this.overlayDiv);
                        (0, _tools.bindEvents)(this, this.div, [
                            "dblclick",
                            "keydown"
                        ]);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            if (this.annotationElementId) {
                                const { position } = (0, $f2lgg._)(this, _initialData);
                                let [tx, ty] = this.getInitialTranslation();
                                [tx, ty] = this.pageTranslationToScreen(tx, ty);
                                const [pageWidth, pageHeight] = this.pageDimensions;
                                const [pageX, pageY] = this.pageTranslation;
                                let posX, posY;
                                switch(this.rotation){
                                    case 0:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                                        break;
                                    case 90:
                                        posX = baseX + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            ty,
                                            -tx
                                        ];
                                        break;
                                    case 180:
                                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                                        posY = baseY - (position[1] - pageY) / pageHeight;
                                        [tx, ty] = [
                                            -tx,
                                            -ty
                                        ];
                                        break;
                                    case 270:
                                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                                        [tx, ty] = [
                                            -ty,
                                            tx
                                        ];
                                        break;
                                }
                                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
                            } else this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            (0, $hDjZy._)(this, _setContent, setContent).call(this);
                            this._isDraggable = true;
                            this.editorDiv.contentEditable = false;
                        } else {
                            this._isDraggable = false;
                            this.editorDiv.contentEditable = true;
                        }
                        return this.div;
                    }
                    get contentDiv() {
                        return this.editorDiv;
                    }
                    static deserialize(data, parent, uiManager) {
                        let initialData = null;
                        if (data instanceof _annotation_layer.FreeTextAnnotationElement) {
                            const { data: { defaultAppearanceData: { fontSize, fontColor }, rect, rotation, id }, textContent, textPosition, parent: { page: { pageNumber } } } = data;
                            if (!textContent || textContent.length === 0) return null;
                            initialData = data = {
                                annotationType: _util.AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect,
                                rotation: rotation,
                                id: id,
                                deleted: false
                            };
                        }
                        const editor = super.deserialize(data, parent, uiManager);
                        (0, $5grPd._)(editor, _fontSize, data.fontSize);
                        (0, $5grPd._)(editor, _color, _util.Util.makeHexColor(...data.color));
                        (0, $5grPd._)(editor, _content, data.value);
                        editor.annotationElementId = data.id || null;
                        (0, $5grPd._)(editor, _initialData, initialData);
                        return editor;
                    }
                    serialize(isForCopying = false) {
                        if (this.isEmpty()) return null;
                        if (this.deleted) return {
                            pageIndex: this.pageIndex,
                            id: this.annotationElementId,
                            deleted: true
                        };
                        const padding = FreeTextEditor._internalPadding * this.parentScale;
                        const rect = this.getRect(padding, padding);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : (0, $f2lgg._)(this, _color));
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.FREETEXT,
                            color: color,
                            fontSize: (0, $f2lgg._)(this, _fontSize),
                            value: (0, $f2lgg._)(this, _content),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) return serialized;
                        if (this.annotationElementId && !(0, $hDjZy._)(this, _hasElementChanged, hasElementChanged).call(this, serialized)) return null;
                        serialized.id = this.annotationElementId;
                        return serialized;
                    }
                    constructor(params){
                        super((0, $7d4tS._)((0, $cTSGB._)({}, params), {
                            name: "freeTextEditor"
                        })), (0, $2IZAT._)(this, _updateFontSize), (0, $2IZAT._)(this, _updateColor), (0, $2IZAT._)(this, _extractText), (0, $2IZAT._)(this, _setEditorDimensions), (0, $2IZAT._)(this, _setContent), (0, $2IZAT._)(this, _hasElementChanged), (0, $2IZAT._)(this, _cheatInitialRect), (0, $iXPoG._)(this, _boundEditorDivBlur, {
                            writable: true,
                            value: this.editorDivBlur.bind(this)
                        }), (0, $iXPoG._)(this, _boundEditorDivFocus, {
                            writable: true,
                            value: this.editorDivFocus.bind(this)
                        }), (0, $iXPoG._)(this, _boundEditorDivInput, {
                            writable: true,
                            value: this.editorDivInput.bind(this)
                        }), (0, $iXPoG._)(this, _boundEditorDivKeydown, {
                            writable: true,
                            value: this.editorDivKeydown.bind(this)
                        }), (0, $iXPoG._)(this, _color, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _content, {
                            writable: true,
                            value: ""
                        }), (0, $iXPoG._)(this, _editorDivId, {
                            writable: true,
                            value: `${this.id}-editor`
                        }), (0, $iXPoG._)(this, _fontSize, {
                            writable: true,
                            value: void 0
                        }), (0, $iXPoG._)(this, _initialData, {
                            writable: true,
                            value: null
                        });
                        (0, $5grPd._)(this, _color, params.color || FreeTextEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                        (0, $5grPd._)(this, _fontSize, params.fontSize || FreeTextEditor._defaultFontSize);
                    }
                }
                (0, $yQrT8._)(FreeTextEditor, "_freeTextDefaultContent", "");
                (0, $yQrT8._)(FreeTextEditor, "_internalPadding", 0);
                (0, $yQrT8._)(FreeTextEditor, "_defaultColor", null);
                (0, $yQrT8._)(FreeTextEditor, "_defaultFontSize", 10);
                (0, $yQrT8._)(FreeTextEditor, "_type", "freetext");
                function updateFontSize(fontSize) {
                    const setFontsize = (size)=>{
                        this.editorDiv.style.fontSize = `calc(${size}px * var(--scale-factor))`;
                        this.translate(0, -(size - (0, $f2lgg._)(this, _fontSize)) * this.parentScale);
                        (0, $5grPd._)(this, _fontSize, size);
                        (0, $hDjZy._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                    };
                    const savedFontsize = (0, $f2lgg._)(this, _fontSize);
                    this.addCommands({
                        cmd: ()=>{
                            setFontsize(fontSize);
                        },
                        undo: ()=>{
                            setFontsize(savedFontsize);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.FREETEXT_SIZE,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateColor(color) {
                    const savedColor = (0, $f2lgg._)(this, _color);
                    this.addCommands({
                        cmd: ()=>{
                            (0, $5grPd._)(this, _color, this.editorDiv.style.color = color);
                        },
                        undo: ()=>{
                            (0, $5grPd._)(this, _color, this.editorDiv.style.color = savedColor);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.FREETEXT_COLOR,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function extractText() {
                    const divs = this.editorDiv.getElementsByTagName("div");
                    if (divs.length === 0) return this.editorDiv.innerText;
                    const buffer = [];
                    for (const div of divs)buffer.push(div.innerText.replace(/\r\n?|\n/, ""));
                    return buffer.join("\n");
                }
                function setEditorDimensions() {
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    let rect;
                    if (this.isAttachedToDOM) rect = this.div.getBoundingClientRect();
                    else {
                        const { currentLayer, div } = this;
                        const savedDisplay = div.style.display;
                        div.style.display = "hidden";
                        currentLayer.div.append(this.div);
                        rect = div.getBoundingClientRect();
                        div.remove();
                        div.style.display = savedDisplay;
                    }
                    if (this.rotation % 180 === this.parentRotation % 180) {
                        this.width = rect.width / parentWidth;
                        this.height = rect.height / parentHeight;
                    } else {
                        this.width = rect.height / parentWidth;
                        this.height = rect.width / parentHeight;
                    }
                    this.fixAndSetPosition();
                }
                function setContent() {
                    this.editorDiv.replaceChildren();
                    if (!(0, $f2lgg._)(this, _content)) return;
                    for (const line of (0, $f2lgg._)(this, _content).split("\n")){
                        const div = document.createElement("div");
                        div.append(line ? document.createTextNode(line) : document.createElement("br"));
                        this.editorDiv.append(div);
                    }
                }
                function hasElementChanged(serialized) {
                    const { value, fontSize, color, rect, pageIndex } = (0, $f2lgg._)(this, _initialData);
                    return serialized.value !== value || serialized.fontSize !== fontSize || serialized.rect.some((x, i)=>Math.abs(x - rect[i]) >= 1) || serialized.color.some((c, i)=>c !== color[i]) || serialized.pageIndex !== pageIndex;
                }
                function cheatInitialRect(delayed = false) {
                    if (!this.annotationElementId) return;
                    (0, $hDjZy._)(this, _setEditorDimensions, setEditorDimensions).call(this);
                    if (!delayed && (this.width === 0 || this.height === 0)) {
                        setTimeout(()=>(0, $hDjZy._)(this, _cheatInitialRect, cheatInitialRect).call(this, true), 0);
                        return;
                    }
                    const padding = FreeTextEditor._internalPadding * this.parentScale;
                    (0, $f2lgg._)(this, _initialData).rect = this.getRect(padding, padding);
                }
                exports.FreeTextEditor = FreeTextEditor;
            /***/ },
            /* 29 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampAnnotationElement = exports.InkAnnotationElement = exports.FreeTextAnnotationElement = exports.AnnotationLayer = void 0;
                var _util = __w_pdfjs_require__(1);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_storage = __w_pdfjs_require__(3);
                var _scripting_utils = __w_pdfjs_require__(30);
                var _displayL10n_utils = __w_pdfjs_require__(31);
                var _xfa_layer = __w_pdfjs_require__(32);
                const DEFAULT_TAB_INDEX = 1000;
                const DEFAULT_FONT_SIZE = 9;
                const GetElementsByNameSet = new WeakSet();
                function getRectDims(rect) {
                    return {
                        width: rect[2] - rect[0],
                        height: rect[3] - rect[1]
                    };
                }
                class AnnotationElementFactory {
                    static create(parameters) {
                        const subtype = parameters.data.annotationType;
                        switch(subtype){
                            case _util.AnnotationType.LINK:
                                return new LinkAnnotationElement(parameters);
                            case _util.AnnotationType.TEXT:
                                return new TextAnnotationElement(parameters);
                            case _util.AnnotationType.WIDGET:
                                const fieldType = parameters.data.fieldType;
                                switch(fieldType){
                                    case "Tx":
                                        return new TextWidgetAnnotationElement(parameters);
                                    case "Btn":
                                        if (parameters.data.radioButton) return new RadioButtonWidgetAnnotationElement(parameters);
                                        else if (parameters.data.checkBox) return new CheckboxWidgetAnnotationElement(parameters);
                                        return new PushButtonWidgetAnnotationElement(parameters);
                                    case "Ch":
                                        return new ChoiceWidgetAnnotationElement(parameters);
                                    case "Sig":
                                        return new SignatureWidgetAnnotationElement(parameters);
                                }
                                return new WidgetAnnotationElement(parameters);
                            case _util.AnnotationType.POPUP:
                                return new PopupAnnotationElement(parameters);
                            case _util.AnnotationType.FREETEXT:
                                return new FreeTextAnnotationElement(parameters);
                            case _util.AnnotationType.LINE:
                                return new LineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUARE:
                                return new SquareAnnotationElement(parameters);
                            case _util.AnnotationType.CIRCLE:
                                return new CircleAnnotationElement(parameters);
                            case _util.AnnotationType.POLYLINE:
                                return new PolylineAnnotationElement(parameters);
                            case _util.AnnotationType.CARET:
                                return new CaretAnnotationElement(parameters);
                            case _util.AnnotationType.INK:
                                return new InkAnnotationElement(parameters);
                            case _util.AnnotationType.POLYGON:
                                return new PolygonAnnotationElement(parameters);
                            case _util.AnnotationType.HIGHLIGHT:
                                return new HighlightAnnotationElement(parameters);
                            case _util.AnnotationType.UNDERLINE:
                                return new UnderlineAnnotationElement(parameters);
                            case _util.AnnotationType.SQUIGGLY:
                                return new SquigglyAnnotationElement(parameters);
                            case _util.AnnotationType.STRIKEOUT:
                                return new StrikeOutAnnotationElement(parameters);
                            case _util.AnnotationType.STAMP:
                                return new StampAnnotationElement(parameters);
                            case _util.AnnotationType.FILEATTACHMENT:
                                return new FileAttachmentAnnotationElement(parameters);
                            default:
                                return new AnnotationElement(parameters);
                        }
                    }
                }
                var _hasBorder = /*#__PURE__*/ new WeakMap();
                class AnnotationElement {
                    static _hasPopupData({ titleObj, contentsObj, richText }) {
                        return !!((titleObj === null || titleObj === void 0 ? void 0 : titleObj.str) || (contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || (richText === null || richText === void 0 ? void 0 : richText.str));
                    }
                    get hasPopupData() {
                        return AnnotationElement._hasPopupData(this.data);
                    }
                    _createContainer(ignoreBorder) {
                        const { data, parent: { page, viewport } } = this;
                        const container = document.createElement("section");
                        container.setAttribute("data-annotation-id", data.id);
                        if (!(this instanceof WidgetAnnotationElement)) container.tabIndex = DEFAULT_TAB_INDEX;
                        container.style.zIndex = this.parent.zIndex++;
                        if (this.data.popupRef) container.setAttribute("aria-haspopup", "dialog");
                        if (data.noRotate) container.classList.add("norotate");
                        const { pageWidth, pageHeight, pageX, pageY } = viewport.rawDims;
                        if (!data.rect || this instanceof PopupAnnotationElement) {
                            const { rotation } = data;
                            if (!data.hasOwnCanvas && rotation !== 0) this.setRotation(rotation, container);
                            return container;
                        }
                        const { width, height } = getRectDims(data.rect);
                        const rect = _util.Util.normalizeRect([
                            data.rect[0],
                            page.view[3] - data.rect[1] + page.view[1],
                            data.rect[2],
                            page.view[3] - data.rect[3] + page.view[1]
                        ]);
                        if (!ignoreBorder && data.borderStyle.width > 0) {
                            container.style.borderWidth = `${data.borderStyle.width}px`;
                            const horizontalRadius = data.borderStyle.horizontalCornerRadius;
                            const verticalRadius = data.borderStyle.verticalCornerRadius;
                            if (horizontalRadius > 0 || verticalRadius > 0) {
                                const radius = `calc(${horizontalRadius}px * var(--scale-factor)) / calc(${verticalRadius}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            } else if (this instanceof RadioButtonWidgetAnnotationElement) {
                                const radius = `calc(${width}px * var(--scale-factor)) / calc(${height}px * var(--scale-factor))`;
                                container.style.borderRadius = radius;
                            }
                            switch(data.borderStyle.style){
                                case _util.AnnotationBorderStyleType.SOLID:
                                    container.style.borderStyle = "solid";
                                    break;
                                case _util.AnnotationBorderStyleType.DASHED:
                                    container.style.borderStyle = "dashed";
                                    break;
                                case _util.AnnotationBorderStyleType.BEVELED:
                                    (0, _util.warn)("Unimplemented border style: beveled");
                                    break;
                                case _util.AnnotationBorderStyleType.INSET:
                                    (0, _util.warn)("Unimplemented border style: inset");
                                    break;
                                case _util.AnnotationBorderStyleType.UNDERLINE:
                                    container.style.borderBottomStyle = "solid";
                                    break;
                                default:
                                    break;
                            }
                            const borderColor = data.borderColor || null;
                            if (borderColor) {
                                (0, $5grPd._)(this, _hasBorder, true);
                                container.style.borderColor = _util.Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
                            } else container.style.borderWidth = 0;
                        }
                        container.style.left = `${100 * (rect[0] - pageX) / pageWidth}%`;
                        container.style.top = `${100 * (rect[1] - pageY) / pageHeight}%`;
                        const { rotation } = data;
                        if (data.hasOwnCanvas || rotation === 0) {
                            container.style.width = `${100 * width / pageWidth}%`;
                            container.style.height = `${100 * height / pageHeight}%`;
                        } else this.setRotation(rotation, container);
                        return container;
                    }
                    setRotation(angle, container = this.container) {
                        if (!this.data.rect) return;
                        const { pageWidth, pageHeight } = this.parent.viewport.rawDims;
                        const { width, height } = getRectDims(this.data.rect);
                        let elementWidth, elementHeight;
                        if (angle % 180 === 0) {
                            elementWidth = 100 * width / pageWidth;
                            elementHeight = 100 * height / pageHeight;
                        } else {
                            elementWidth = 100 * height / pageWidth;
                            elementHeight = 100 * width / pageHeight;
                        }
                        container.style.width = `${elementWidth}%`;
                        container.style.height = `${elementHeight}%`;
                        container.setAttribute("data-main-rotation", (360 - angle) % 360);
                    }
                    get _commonActions() {
                        const setColor = (jsName, styleName, event)=>{
                            const color = event.detail[jsName];
                            const colorType = color[0];
                            const colorArray = color.slice(1);
                            event.target.style[styleName] = _scripting_utils.ColorConverters[`${colorType}_HTML`](colorArray);
                            this.annotationStorage.setValue(this.data.id, {
                                [styleName]: _scripting_utils.ColorConverters[`${colorType}_rgb`](colorArray)
                            });
                        };
                        return (0, _util.shadow)(this, "_commonActions", {
                            display: (event)=>{
                                const { display } = event.detail;
                                const hidden = display % 2 === 1;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noView: hidden,
                                    noPrint: display === 1 || display === 2
                                });
                            },
                            print: (event)=>{
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: !event.detail.print
                                });
                            },
                            hidden: (event)=>{
                                const { hidden } = event.detail;
                                this.container.style.visibility = hidden ? "hidden" : "visible";
                                this.annotationStorage.setValue(this.data.id, {
                                    noPrint: hidden,
                                    noView: hidden
                                });
                            },
                            focus: (event)=>{
                                setTimeout(()=>event.target.focus({
                                        preventScroll: false
                                    }), 0);
                            },
                            userName: (event)=>{
                                event.target.title = event.detail.userName;
                            },
                            readonly: (event)=>{
                                event.target.disabled = event.detail.readonly;
                            },
                            required: (event)=>{
                                this._setRequired(event.target, event.detail.required);
                            },
                            bgColor: (event)=>{
                                setColor("bgColor", "backgroundColor", event);
                            },
                            fillColor: (event)=>{
                                setColor("fillColor", "backgroundColor", event);
                            },
                            fgColor: (event)=>{
                                setColor("fgColor", "color", event);
                            },
                            textColor: (event)=>{
                                setColor("textColor", "color", event);
                            },
                            borderColor: (event)=>{
                                setColor("borderColor", "borderColor", event);
                            },
                            strokeColor: (event)=>{
                                setColor("strokeColor", "borderColor", event);
                            },
                            rotation: (event)=>{
                                const angle = event.detail.rotation;
                                this.setRotation(angle);
                                this.annotationStorage.setValue(this.data.id, {
                                    rotation: angle
                                });
                            }
                        });
                    }
                    _dispatchEventFromSandbox(actions, jsEvent) {
                        const commonActions = this._commonActions;
                        for (const name of Object.keys(jsEvent.detail)){
                            const action = actions[name] || commonActions[name];
                            action === null || action === void 0 ? void 0 : action(jsEvent);
                        }
                    }
                    _setDefaultPropertiesFromJS(element) {
                        if (!this.enableScripting) return;
                        const storedData = this.annotationStorage.getRawValue(this.data.id);
                        if (!storedData) return;
                        const commonActions = this._commonActions;
                        for (const [actionName, detail] of Object.entries(storedData)){
                            const action = commonActions[actionName];
                            if (action) {
                                const eventProxy = {
                                    detail: {
                                        [actionName]: detail
                                    },
                                    target: element
                                };
                                action(eventProxy);
                                delete storedData[actionName];
                            }
                        }
                    }
                    _createQuadrilaterals() {
                        if (!this.container) return;
                        const { quadPoints } = this.data;
                        if (!quadPoints) return;
                        const [rectBlX, rectBlY, rectTrX, rectTrY] = this.data.rect;
                        if (quadPoints.length === 1) {
                            const [, { x: trX, y: trY }, { x: blX, y: blY }] = quadPoints[0];
                            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) return;
                        }
                        const { style } = this.container;
                        let svgBuffer;
                        if ((0, $f2lgg._)(this, _hasBorder)) {
                            const { borderColor, borderWidth } = style;
                            style.borderWidth = 0;
                            svgBuffer = [
                                "url('data:image/svg+xml;utf8,",
                                `<svg xmlns="http://www.w3.org/2000/svg"`,
                                ` preserveAspectRatio="none" viewBox="0 0 1 1">`,
                                `<g fill="transparent" stroke="${borderColor}" stroke-width="${borderWidth}">`
                            ];
                            this.container.classList.add("hasBorder");
                        }
                        const width = rectTrX - rectBlX;
                        const height = rectTrY - rectBlY;
                        const { svgFactory } = this;
                        const svg = svgFactory.createElement("svg");
                        svg.classList.add("quadrilateralsContainer");
                        svg.setAttribute("width", 0);
                        svg.setAttribute("height", 0);
                        const defs = svgFactory.createElement("defs");
                        svg.append(defs);
                        const clipPath = svgFactory.createElement("clipPath");
                        const id = `clippath_${this.data.id}`;
                        clipPath.setAttribute("id", id);
                        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
                        defs.append(clipPath);
                        for (const [, { x: trX, y: trY }, { x: blX, y: blY }] of quadPoints){
                            const rect = svgFactory.createElement("rect");
                            const x = (blX - rectBlX) / width;
                            const y = (rectTrY - trY) / height;
                            const rectWidth = (trX - blX) / width;
                            const rectHeight = (trY - blY) / height;
                            rect.setAttribute("x", x);
                            rect.setAttribute("y", y);
                            rect.setAttribute("width", rectWidth);
                            rect.setAttribute("height", rectHeight);
                            clipPath.append(rect);
                            svgBuffer === null || svgBuffer === void 0 ? void 0 : svgBuffer.push(`<rect vector-effect="non-scaling-stroke" x="${x}" y="${y}" width="${rectWidth}" height="${rectHeight}"/>`);
                        }
                        if ((0, $f2lgg._)(this, _hasBorder)) {
                            svgBuffer.push(`</g></svg>')`);
                            style.backgroundImage = svgBuffer.join("");
                        }
                        this.container.append(svg);
                        this.container.style.clipPath = `url(#${id})`;
                    }
                    _createPopup() {
                        const { container, data } = this;
                        container.setAttribute("aria-haspopup", "dialog");
                        const popup = new PopupAnnotationElement({
                            data: {
                                color: data.color,
                                titleObj: data.titleObj,
                                modificationDate: data.modificationDate,
                                contentsObj: data.contentsObj,
                                richText: data.richText,
                                parentRect: data.rect,
                                borderStyle: 0,
                                id: `popup_${data.id}`,
                                rotation: data.rotation
                            },
                            parent: this.parent,
                            elements: [
                                this
                            ]
                        });
                        this.parent.div.append(popup.render());
                    }
                    render() {
                        (0, _util.unreachable)("Abstract method `AnnotationElement.render` called");
                    }
                    _getElementsByName(name, skipId = null) {
                        const fields = [];
                        if (this._fieldObjects) {
                            const fieldObj = this._fieldObjects[name];
                            if (fieldObj) for (const { page, id, exportValues } of fieldObj){
                                if (page === -1) continue;
                                if (id === skipId) continue;
                                const exportValue = typeof exportValues === "string" ? exportValues : null;
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (domElement && !GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_getElementsByName - element not allowed: ${id}`);
                                    continue;
                                }
                                fields.push({
                                    id: id,
                                    exportValue: exportValue,
                                    domElement: domElement
                                });
                            }
                            return fields;
                        }
                        for (const domElement of document.getElementsByName(name)){
                            const { exportValue } = domElement;
                            const id = domElement.getAttribute("data-element-id");
                            if (id === skipId) continue;
                            if (!GetElementsByNameSet.has(domElement)) continue;
                            fields.push({
                                id: id,
                                exportValue: exportValue,
                                domElement: domElement
                            });
                        }
                        return fields;
                    }
                    show() {
                        var _this_popup;
                        if (this.container) this.container.hidden = false;
                        (_this_popup = this.popup) === null || _this_popup === void 0 ? void 0 : _this_popup.maybeShow();
                    }
                    hide() {
                        var _this_popup;
                        if (this.container) this.container.hidden = true;
                        (_this_popup = this.popup) === null || _this_popup === void 0 ? void 0 : _this_popup.forceHide();
                    }
                    getElementsToTriggerPopup() {
                        return this.container;
                    }
                    addHighlightArea() {
                        const triggers = this.getElementsToTriggerPopup();
                        if (Array.isArray(triggers)) for (const element of triggers)element.classList.add("highlightArea");
                        else triggers.classList.add("highlightArea");
                    }
                    _editOnDoubleClick() {
                        const { annotationEditorType: mode, data: { id: editId } } = this;
                        this.container.addEventListener("dblclick", ()=>{
                            var _this_linkService_eventBus;
                            (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("switchannotationeditormode", {
                                source: this,
                                mode: mode,
                                editId: editId
                            });
                        });
                    }
                    constructor(parameters, { isRenderable = false, ignoreBorder = false, createQuadrilaterals = false } = {}){
                        (0, $iXPoG._)(this, _hasBorder, {
                            writable: true,
                            value: false
                        });
                        this.isRenderable = isRenderable;
                        this.data = parameters.data;
                        this.layer = parameters.layer;
                        this.linkService = parameters.linkService;
                        this.downloadManager = parameters.downloadManager;
                        this.imageResourcesPath = parameters.imageResourcesPath;
                        this.renderForms = parameters.renderForms;
                        this.svgFactory = parameters.svgFactory;
                        this.annotationStorage = parameters.annotationStorage;
                        this.enableScripting = parameters.enableScripting;
                        this.hasJSActions = parameters.hasJSActions;
                        this._fieldObjects = parameters.fieldObjects;
                        this.parent = parameters.parent;
                        if (isRenderable) this.container = this._createContainer(ignoreBorder);
                        if (createQuadrilaterals) this._createQuadrilaterals();
                    }
                }
                var _setInternalLink = /*#__PURE__*/ new WeakSet(), _bindSetOCGState = /*#__PURE__*/ new WeakSet();
                class LinkAnnotationElement extends AnnotationElement {
                    render() {
                        const { data, linkService } = this;
                        const link = document.createElement("a");
                        link.setAttribute("data-element-id", data.id);
                        let isBound = false;
                        if (data.url) {
                            linkService.addLinkAttributes(link, data.url, data.newWindow);
                            isBound = true;
                        } else if (data.action) {
                            this._bindNamedAction(link, data.action);
                            isBound = true;
                        } else if (data.attachment) {
                            this._bindAttachment(link, data.attachment);
                            isBound = true;
                        } else if (data.setOCGState) {
                            (0, $hDjZy._)(this, _bindSetOCGState, bindSetOCGState).call(this, link, data.setOCGState);
                            isBound = true;
                        } else if (data.dest) {
                            this._bindLink(link, data.dest);
                            isBound = true;
                        } else {
                            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                                this._bindJSAction(link, data);
                                isBound = true;
                            }
                            if (data.resetForm) {
                                this._bindResetFormAction(link, data.resetForm);
                                isBound = true;
                            } else if (this.isTooltipOnly && !isBound) {
                                this._bindLink(link, "");
                                isBound = true;
                            }
                        }
                        this.container.classList.add("linkAnnotation");
                        if (isBound) this.container.append(link);
                        return this.container;
                    }
                    _bindLink(link, destination) {
                        link.href = this.linkService.getDestinationHash(destination);
                        link.onclick = ()=>{
                            if (destination) this.linkService.goToDestination(destination);
                            return false;
                        };
                        if (destination || destination === "") (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                    }
                    _bindNamedAction(link, action) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            this.linkService.executeNamedAction(action);
                            return false;
                        };
                        (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                    }
                    _bindAttachment(link, attachment) {
                        link.href = this.linkService.getAnchorUrl("");
                        link.onclick = ()=>{
                            var _this_downloadManager;
                            (_this_downloadManager = this.downloadManager) === null || _this_downloadManager === void 0 ? void 0 : _this_downloadManager.openOrDownloadData(this.container, attachment.content, attachment.filename);
                            return false;
                        };
                        (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                    }
                    _bindJSAction(link, data) {
                        link.href = this.linkService.getAnchorUrl("");
                        const map = new Map([
                            [
                                "Action",
                                "onclick"
                            ],
                            [
                                "Mouse Up",
                                "onmouseup"
                            ],
                            [
                                "Mouse Down",
                                "onmousedown"
                            ]
                        ]);
                        for (const name of Object.keys(data.actions)){
                            const jsName = map.get(name);
                            if (!jsName) continue;
                            link[jsName] = ()=>{
                                var _this_linkService_eventBus;
                                (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: data.id,
                                        name: name
                                    }
                                });
                                return false;
                            };
                        }
                        if (!link.onclick) link.onclick = ()=>false;
                        (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                    }
                    _bindResetFormAction(link, resetForm) {
                        const otherClickAction = link.onclick;
                        if (!otherClickAction) link.href = this.linkService.getAnchorUrl("");
                        (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                        if (!this._fieldObjects) {
                            (0, _util.warn)(`_bindResetFormAction - "resetForm" action not supported, ` + "ensure that the `fieldObjects` parameter is provided.");
                            if (!otherClickAction) link.onclick = ()=>false;
                            return;
                        }
                        link.onclick = ()=>{
                            var _this_linkService_eventBus;
                            otherClickAction === null || otherClickAction === void 0 ? void 0 : otherClickAction();
                            const { fields: resetFormFields, refs: resetFormRefs, include } = resetForm;
                            const allFields = [];
                            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                                const fieldIds = new Set(resetFormRefs);
                                for (const fieldName of resetFormFields){
                                    const fields = this._fieldObjects[fieldName] || [];
                                    for (const { id } of fields)fieldIds.add(id);
                                }
                                for (const fields of Object.values(this._fieldObjects)){
                                    for (const field of fields)if (fieldIds.has(field.id) === include) allFields.push(field);
                                }
                            } else for (const fields of Object.values(this._fieldObjects))allFields.push(...fields);
                            const storage = this.annotationStorage;
                            const allIds = [];
                            for (const field of allFields){
                                const { id } = field;
                                allIds.push(id);
                                switch(field.type){
                                    case "text":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "checkbox":
                                    case "radiobutton":
                                        {
                                            const value = field.defaultValue === field.exportValues;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    case "combobox":
                                    case "listbox":
                                        {
                                            const value = field.defaultValue || "";
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            break;
                                        }
                                    default:
                                        continue;
                                }
                                const domElement = document.querySelector(`[data-element-id="${id}"]`);
                                if (!domElement) continue;
                                else if (!GetElementsByNameSet.has(domElement)) {
                                    (0, _util.warn)(`_bindResetFormAction - element not allowed: ${id}`);
                                    continue;
                                }
                                domElement.dispatchEvent(new Event("resetform"));
                            }
                            if (this.enableScripting) (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: "app",
                                    ids: allIds,
                                    name: "ResetForm"
                                }
                            });
                            return false;
                        };
                    }
                    constructor(parameters, options = null){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: !!(options === null || options === void 0 ? void 0 : options.ignoreBorder),
                            createQuadrilaterals: true
                        }), (0, $2IZAT._)(this, _setInternalLink), (0, $2IZAT._)(this, _bindSetOCGState);
                        this.isTooltipOnly = parameters.data.isTooltipOnly;
                    }
                }
                function setInternalLink() {
                    this.container.setAttribute("data-internal-link", "");
                }
                function bindSetOCGState(link, action) {
                    link.href = this.linkService.getAnchorUrl("");
                    link.onclick = ()=>{
                        this.linkService.executeSetOCGState(action);
                        return false;
                    };
                    (0, $hDjZy._)(this, _setInternalLink, setInternalLink).call(this);
                }
                class TextAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("textAnnotation");
                        const image = document.createElement("img");
                        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
                        image.alt = "[{{type}} Annotation]";
                        image.dataset.l10nId = "text_annotation_type";
                        image.dataset.l10nArgs = JSON.stringify({
                            type: this.data.name
                        });
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.append(image);
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true
                        });
                    }
                }
                class WidgetAnnotationElement extends AnnotationElement {
                    render() {
                        if (this.data.alternativeText) this.container.title = this.data.alternativeText;
                        return this.container;
                    }
                    showElementAndHideCanvas(element) {
                        if (this.data.hasOwnCanvas) {
                            var _element_previousSibling;
                            if (((_element_previousSibling = element.previousSibling) === null || _element_previousSibling === void 0 ? void 0 : _element_previousSibling.nodeName) === "CANVAS") element.previousSibling.hidden = true;
                            element.hidden = false;
                        }
                    }
                    _getKeyModifier(event) {
                        const { isWin, isMac } = _util.FeatureTest.platform;
                        return isWin && event.ctrlKey || isMac && event.metaKey;
                    }
                    _setEventListener(element, elementData, baseName, eventName, valueGetter) {
                        if (baseName.includes("mouse")) element.addEventListener(baseName, (event)=>{
                            var _this_linkService_eventBus;
                            (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event),
                                    shift: event.shiftKey,
                                    modifier: this._getKeyModifier(event)
                                }
                            });
                        });
                        else element.addEventListener(baseName, (event)=>{
                            var _this_linkService_eventBus;
                            if (baseName === "blur") {
                                if (!elementData.focused || !event.relatedTarget) return;
                                elementData.focused = false;
                            } else if (baseName === "focus") {
                                if (elementData.focused) return;
                                elementData.focused = true;
                            }
                            if (!valueGetter) return;
                            (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                source: this,
                                detail: {
                                    id: this.data.id,
                                    name: eventName,
                                    value: valueGetter(event)
                                }
                            });
                        });
                    }
                    _setEventListeners(element, elementData, names, getter) {
                        var _this_data_actions;
                        for (const [baseName, eventName] of names)if (eventName === "Action" || ((_this_data_actions = this.data.actions) === null || _this_data_actions === void 0 ? void 0 : _this_data_actions[eventName])) {
                            var _this_data_actions1, _this_data_actions2;
                            if (eventName === "Focus" || eventName === "Blur") elementData || (elementData = {
                                focused: false
                            });
                            this._setEventListener(element, elementData, baseName, eventName, getter);
                            if (eventName === "Focus" && !((_this_data_actions1 = this.data.actions) === null || _this_data_actions1 === void 0 ? void 0 : _this_data_actions1.Blur)) this._setEventListener(element, elementData, "blur", "Blur", null);
                            else if (eventName === "Blur" && !((_this_data_actions2 = this.data.actions) === null || _this_data_actions2 === void 0 ? void 0 : _this_data_actions2.Focus)) this._setEventListener(element, elementData, "focus", "Focus", null);
                        }
                    }
                    _setBackgroundColor(element) {
                        const color = this.data.backgroundColor || null;
                        element.style.backgroundColor = color === null ? "transparent" : _util.Util.makeHexColor(color[0], color[1], color[2]);
                    }
                    _setTextStyle(element) {
                        const TEXT_ALIGNMENT = [
                            "left",
                            "center",
                            "right"
                        ];
                        const { fontColor } = this.data.defaultAppearanceData;
                        const fontSize = this.data.defaultAppearanceData.fontSize || DEFAULT_FONT_SIZE;
                        const style = element.style;
                        let computedFontSize;
                        const BORDER_SIZE = 2;
                        const roundToOneDecimal = (x)=>Math.round(10 * x) / 10;
                        if (this.data.multiLine) {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            const numberOfLines = Math.round(height / (_util.LINE_FACTOR * fontSize)) || 1;
                            const lineHeight = height / numberOfLines;
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / _util.LINE_FACTOR));
                        } else {
                            const height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
                            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / _util.LINE_FACTOR));
                        }
                        style.fontSize = `calc(${computedFontSize}px * var(--scale-factor))`;
                        style.color = _util.Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
                        if (this.data.textAlignment !== null) style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
                    }
                    _setRequired(element, isRequired) {
                        if (isRequired) element.setAttribute("required", true);
                        else element.removeAttribute("required");
                        element.setAttribute("aria-required", isRequired);
                    }
                }
                class TextWidgetAnnotationElement extends WidgetAnnotationElement {
                    setPropertyOnSiblings(base, key, value, keyInStorage) {
                        const storage = this.annotationStorage;
                        for (const element of this._getElementsByName(base.name, base.id)){
                            if (element.domElement) element.domElement[key] = value;
                            storage.setValue(element.id, {
                                [keyInStorage]: value
                            });
                        }
                    }
                    render() {
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        this.container.classList.add("textWidgetAnnotation");
                        let element = null;
                        if (this.renderForms) {
                            var _this_data_textContent;
                            const storedData = storage.getValue(id, {
                                value: this.data.fieldValue
                            });
                            let textContent = storedData.value || "";
                            const maxLen = storage.getValue(id, {
                                charLimit: this.data.maxLen
                            }).charLimit;
                            if (maxLen && textContent.length > maxLen) textContent = textContent.slice(0, maxLen);
                            let fieldFormattedValues = storedData.formattedValue || ((_this_data_textContent = this.data.textContent) === null || _this_data_textContent === void 0 ? void 0 : _this_data_textContent.join("\n")) || null;
                            if (fieldFormattedValues && this.data.comb) fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
                            const elementData = {
                                userValue: textContent,
                                formattedValue: fieldFormattedValues,
                                lastCommittedValue: null,
                                commitKey: 1,
                                focused: false
                            };
                            if (this.data.multiLine) {
                                element = document.createElement("textarea");
                                element.textContent = fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent;
                                if (this.data.doNotScroll) element.style.overflowY = "hidden";
                            } else {
                                element = document.createElement("input");
                                element.type = "text";
                                element.setAttribute("value", fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent);
                                if (this.data.doNotScroll) element.style.overflowX = "hidden";
                            }
                            if (this.data.hasOwnCanvas) element.hidden = true;
                            GetElementsByNameSet.add(element);
                            element.setAttribute("data-element-id", id);
                            element.disabled = this.data.readOnly;
                            element.name = this.data.fieldName;
                            element.tabIndex = DEFAULT_TAB_INDEX;
                            this._setRequired(element, this.data.required);
                            if (maxLen) element.maxLength = maxLen;
                            element.addEventListener("input", (event)=>{
                                storage.setValue(id, {
                                    value: event.target.value
                                });
                                this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                                elementData.formattedValue = null;
                            });
                            element.addEventListener("resetform", (event)=>{
                                var _this_data_defaultFieldValue;
                                const defaultValue = (_this_data_defaultFieldValue = this.data.defaultFieldValue) !== null && _this_data_defaultFieldValue !== void 0 ? _this_data_defaultFieldValue : "";
                                element.value = elementData.userValue = defaultValue;
                                elementData.formattedValue = null;
                            });
                            let blurListener = (event)=>{
                                const { formattedValue } = elementData;
                                if (formattedValue !== null && formattedValue !== undefined) event.target.value = formattedValue;
                                event.target.scrollLeft = 0;
                            };
                            if (this.enableScripting && this.hasJSActions) {
                                var _this_data_actions;
                                element.addEventListener("focus", (event)=>{
                                    if (elementData.focused) return;
                                    const { target } = event;
                                    if (elementData.userValue) target.value = elementData.userValue;
                                    elementData.lastCommittedValue = target.value;
                                    elementData.commitKey = 1;
                                    elementData.focused = true;
                                });
                                element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                    this.showElementAndHideCanvas(jsEvent.target);
                                    const actions = {
                                        value (event) {
                                            var _event_detail_value;
                                            elementData.userValue = (_event_detail_value = event.detail.value) !== null && _event_detail_value !== void 0 ? _event_detail_value : "";
                                            storage.setValue(id, {
                                                value: elementData.userValue.toString()
                                            });
                                            event.target.value = elementData.userValue;
                                        },
                                        formattedValue (event) {
                                            const { formattedValue } = event.detail;
                                            elementData.formattedValue = formattedValue;
                                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) event.target.value = formattedValue;
                                            storage.setValue(id, {
                                                formattedValue: formattedValue
                                            });
                                        },
                                        selRange (event) {
                                            event.target.setSelectionRange(...event.detail.selRange);
                                        },
                                        charLimit: (event)=>{
                                            var _this_linkService_eventBus;
                                            const { charLimit } = event.detail;
                                            const { target } = event;
                                            if (charLimit === 0) {
                                                target.removeAttribute("maxLength");
                                                return;
                                            }
                                            target.setAttribute("maxLength", charLimit);
                                            let value = elementData.userValue;
                                            if (!value || value.length <= charLimit) return;
                                            value = value.slice(0, charLimit);
                                            target.value = elementData.userValue = value;
                                            storage.setValue(id, {
                                                value: value
                                            });
                                            (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                                source: this,
                                                detail: {
                                                    id: id,
                                                    name: "Keystroke",
                                                    value: value,
                                                    willCommit: true,
                                                    commitKey: 1,
                                                    selStart: target.selectionStart,
                                                    selEnd: target.selectionEnd
                                                }
                                            });
                                        }
                                    };
                                    this._dispatchEventFromSandbox(actions, jsEvent);
                                });
                                element.addEventListener("keydown", (event)=>{
                                    var _this_linkService_eventBus;
                                    elementData.commitKey = 1;
                                    let commitKey = -1;
                                    if (event.key === "Escape") commitKey = 0;
                                    else if (event.key === "Enter" && !this.data.multiLine) commitKey = 2;
                                    else if (event.key === "Tab") elementData.commitKey = 3;
                                    if (commitKey === -1) return;
                                    const { value } = event.target;
                                    if (elementData.lastCommittedValue === value) return;
                                    elementData.lastCommittedValue = value;
                                    elementData.userValue = value;
                                    (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                });
                                const _blurListener = blurListener;
                                blurListener = null;
                                element.addEventListener("blur", (event)=>{
                                    var _this_linkService_eventBus;
                                    if (!elementData.focused || !event.relatedTarget) return;
                                    elementData.focused = false;
                                    const { value } = event.target;
                                    elementData.userValue = value;
                                    if (elementData.lastCommittedValue !== value) (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            willCommit: true,
                                            commitKey: elementData.commitKey,
                                            selStart: event.target.selectionStart,
                                            selEnd: event.target.selectionEnd
                                        }
                                    });
                                    _blurListener(event);
                                });
                                if ((_this_data_actions = this.data.actions) === null || _this_data_actions === void 0 ? void 0 : _this_data_actions.Keystroke) element.addEventListener("beforeinput", (event)=>{
                                    var _this_linkService_eventBus;
                                    elementData.lastCommittedValue = null;
                                    const { data, target } = event;
                                    const { value, selectionStart, selectionEnd } = target;
                                    let selStart = selectionStart, selEnd = selectionEnd;
                                    switch(event.inputType){
                                        case "deleteWordBackward":
                                            {
                                                const match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                                if (match) selStart -= match[0].length;
                                                break;
                                            }
                                        case "deleteWordForward":
                                            {
                                                const match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                                if (match) selEnd += match[0].length;
                                                break;
                                            }
                                        case "deleteContentBackward":
                                            if (selectionStart === selectionEnd) selStart -= 1;
                                            break;
                                        case "deleteContentForward":
                                            if (selectionStart === selectionEnd) selEnd += 1;
                                            break;
                                    }
                                    event.preventDefault();
                                    (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                        source: this,
                                        detail: {
                                            id: id,
                                            name: "Keystroke",
                                            value: value,
                                            change: data || "",
                                            willCommit: false,
                                            selStart: selStart,
                                            selEnd: selEnd
                                        }
                                    });
                                });
                                this._setEventListeners(element, elementData, [
                                    [
                                        "focus",
                                        "Focus"
                                    ],
                                    [
                                        "blur",
                                        "Blur"
                                    ],
                                    [
                                        "mousedown",
                                        "Mouse Down"
                                    ],
                                    [
                                        "mouseenter",
                                        "Mouse Enter"
                                    ],
                                    [
                                        "mouseleave",
                                        "Mouse Exit"
                                    ],
                                    [
                                        "mouseup",
                                        "Mouse Up"
                                    ]
                                ], (event)=>event.target.value);
                            }
                            if (blurListener) element.addEventListener("blur", blurListener);
                            if (this.data.comb) {
                                const fieldWidth = this.data.rect[2] - this.data.rect[0];
                                const combWidth = fieldWidth / maxLen;
                                element.classList.add("comb");
                                element.style.letterSpacing = `calc(${combWidth}px * var(--scale-factor) - 1ch)`;
                            }
                        } else {
                            element = document.createElement("div");
                            element.textContent = this.data.fieldValue;
                            element.style.verticalAlign = "middle";
                            element.style.display = "table-cell";
                        }
                        this._setTextStyle(element);
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                    constructor(parameters){
                        const isRenderable = parameters.renderForms || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
                        super(parameters, {
                            isRenderable: isRenderable
                        });
                    }
                }
                class SignatureWidgetAnnotationElement extends WidgetAnnotationElement {
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: !!parameters.data.hasOwnCanvas
                        });
                    }
                }
                class CheckboxWidgetAnnotationElement extends WidgetAnnotationElement {
                    render() {
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.exportValue === data.fieldValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== "Off";
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "checkbox";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.setAttribute("exportValue", data.exportValue);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const checkbox of this._getElementsByName(name, id)){
                                const curChecked = checked && checkbox.exportValue === data.exportValue;
                                if (checkbox.domElement) checkbox.domElement.checked = curChecked;
                                storage.setValue(checkbox.id, {
                                    value: curChecked
                                });
                            }
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue || "Off";
                            event.target.checked = defaultValue === data.exportValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        event.target.checked = event.detail.value !== "Off";
                                        storage.setValue(id, {
                                            value: event.target.checked
                                        });
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                }
                class RadioButtonWidgetAnnotationElement extends WidgetAnnotationElement {
                    render() {
                        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
                        const storage = this.annotationStorage;
                        const data = this.data;
                        const id = data.id;
                        let value = storage.getValue(id, {
                            value: data.fieldValue === data.buttonValue
                        }).value;
                        if (typeof value === "string") {
                            value = value !== data.buttonValue;
                            storage.setValue(id, {
                                value: value
                            });
                        }
                        const element = document.createElement("input");
                        GetElementsByNameSet.add(element);
                        element.setAttribute("data-element-id", id);
                        element.disabled = data.readOnly;
                        this._setRequired(element, this.data.required);
                        element.type = "radio";
                        element.name = data.fieldName;
                        if (value) element.setAttribute("checked", true);
                        element.tabIndex = DEFAULT_TAB_INDEX;
                        element.addEventListener("change", (event)=>{
                            const { name, checked } = event.target;
                            for (const radio of this._getElementsByName(name, id))storage.setValue(radio.id, {
                                value: false
                            });
                            storage.setValue(id, {
                                value: checked
                            });
                        });
                        element.addEventListener("resetform", (event)=>{
                            const defaultValue = data.defaultFieldValue;
                            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
                        });
                        if (this.enableScripting && this.hasJSActions) {
                            const pdfButtonValue = data.buttonValue;
                            element.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value: (event)=>{
                                        const checked = pdfButtonValue === event.detail.value;
                                        for (const radio of this._getElementsByName(event.target.name)){
                                            const curChecked = checked && radio.id === id;
                                            if (radio.domElement) radio.domElement.checked = curChecked;
                                            storage.setValue(radio.id, {
                                                value: curChecked
                                            });
                                        }
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            this._setEventListeners(element, null, [
                                [
                                    "change",
                                    "Validate"
                                ],
                                [
                                    "change",
                                    "Action"
                                ],
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ]
                            ], (event)=>event.target.checked);
                        }
                        this._setBackgroundColor(element);
                        this._setDefaultPropertiesFromJS(element);
                        this.container.append(element);
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                }
                class PushButtonWidgetAnnotationElement extends LinkAnnotationElement {
                    render() {
                        const container = super.render();
                        container.classList.add("buttonWidgetAnnotation", "pushButton");
                        if (this.data.alternativeText) container.title = this.data.alternativeText;
                        const linkElement = container.lastChild;
                        if (this.enableScripting && this.hasJSActions && linkElement) {
                            this._setDefaultPropertiesFromJS(linkElement);
                            linkElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                this._dispatchEventFromSandbox({}, jsEvent);
                            });
                        }
                        return container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            ignoreBorder: parameters.data.hasAppearance
                        });
                    }
                }
                class ChoiceWidgetAnnotationElement extends WidgetAnnotationElement {
                    render() {
                        this.container.classList.add("choiceWidgetAnnotation");
                        const storage = this.annotationStorage;
                        const id = this.data.id;
                        const storedData = storage.getValue(id, {
                            value: this.data.fieldValue
                        });
                        const selectElement = document.createElement("select");
                        GetElementsByNameSet.add(selectElement);
                        selectElement.setAttribute("data-element-id", id);
                        selectElement.disabled = this.data.readOnly;
                        this._setRequired(selectElement, this.data.required);
                        selectElement.name = this.data.fieldName;
                        selectElement.tabIndex = DEFAULT_TAB_INDEX;
                        let addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
                        if (!this.data.combo) {
                            selectElement.size = this.data.options.length;
                            if (this.data.multiSelect) selectElement.multiple = true;
                        }
                        selectElement.addEventListener("resetform", (event)=>{
                            const defaultValue = this.data.defaultFieldValue;
                            for (const option of selectElement.options)option.selected = option.value === defaultValue;
                        });
                        for (const option of this.data.options){
                            const optionElement = document.createElement("option");
                            optionElement.textContent = option.displayValue;
                            optionElement.value = option.exportValue;
                            if (storedData.value.includes(option.exportValue)) {
                                optionElement.setAttribute("selected", true);
                                addAnEmptyEntry = false;
                            }
                            selectElement.append(optionElement);
                        }
                        let removeEmptyEntry = null;
                        if (addAnEmptyEntry) {
                            const noneOptionElement = document.createElement("option");
                            noneOptionElement.value = " ";
                            noneOptionElement.setAttribute("hidden", true);
                            noneOptionElement.setAttribute("selected", true);
                            selectElement.prepend(noneOptionElement);
                            removeEmptyEntry = ()=>{
                                noneOptionElement.remove();
                                selectElement.removeEventListener("input", removeEmptyEntry);
                                removeEmptyEntry = null;
                            };
                            selectElement.addEventListener("input", removeEmptyEntry);
                        }
                        const getValue = (isExport)=>{
                            const name = isExport ? "value" : "textContent";
                            const { options, multiple } = selectElement;
                            if (!multiple) return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
                            return Array.prototype.filter.call(options, (option)=>option.selected).map((option)=>option[name]);
                        };
                        let selectedValues = getValue(false);
                        const getItems = (event)=>{
                            const options = event.target.options;
                            return Array.prototype.map.call(options, (option)=>{
                                return {
                                    displayValue: option.textContent,
                                    exportValue: option.value
                                };
                            });
                        };
                        if (this.enableScripting && this.hasJSActions) {
                            selectElement.addEventListener("updatefromsandbox", (jsEvent)=>{
                                const actions = {
                                    value (event) {
                                        removeEmptyEntry === null || removeEmptyEntry === void 0 ? void 0 : removeEmptyEntry();
                                        const value = event.detail.value;
                                        const values = new Set(Array.isArray(value) ? value : [
                                            value
                                        ]);
                                        for (const option of selectElement.options)option.selected = values.has(option.value);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    multipleSelection (event) {
                                        selectElement.multiple = true;
                                    },
                                    remove (event) {
                                        const options = selectElement.options;
                                        const index = event.detail.remove;
                                        options[index].selected = false;
                                        selectElement.remove(index);
                                        if (options.length > 0) {
                                            const i = Array.prototype.findIndex.call(options, (option)=>option.selected);
                                            if (i === -1) options[0].selected = true;
                                        }
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    clear (event) {
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        storage.setValue(id, {
                                            value: null,
                                            items: []
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    insert (event) {
                                        const { index, displayValue, exportValue } = event.detail.insert;
                                        const selectChild = selectElement.children[index];
                                        const optionElement = document.createElement("option");
                                        optionElement.textContent = displayValue;
                                        optionElement.value = exportValue;
                                        if (selectChild) selectChild.before(optionElement);
                                        else selectElement.append(optionElement);
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    items (event) {
                                        const { items } = event.detail;
                                        while(selectElement.length !== 0)selectElement.remove(0);
                                        for (const item of items){
                                            const { displayValue, exportValue } = item;
                                            const optionElement = document.createElement("option");
                                            optionElement.textContent = displayValue;
                                            optionElement.value = exportValue;
                                            selectElement.append(optionElement);
                                        }
                                        if (selectElement.options.length > 0) selectElement.options[0].selected = true;
                                        storage.setValue(id, {
                                            value: getValue(true),
                                            items: getItems(event)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    indices (event) {
                                        const indices = new Set(event.detail.indices);
                                        for (const option of event.target.options)option.selected = indices.has(option.index);
                                        storage.setValue(id, {
                                            value: getValue(true)
                                        });
                                        selectedValues = getValue(false);
                                    },
                                    editable (event) {
                                        event.target.disabled = !event.detail.editable;
                                    }
                                };
                                this._dispatchEventFromSandbox(actions, jsEvent);
                            });
                            selectElement.addEventListener("input", (event)=>{
                                var _this_linkService_eventBus;
                                const exportValue = getValue(true);
                                storage.setValue(id, {
                                    value: exportValue
                                });
                                event.preventDefault();
                                (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("dispatcheventinsandbox", {
                                    source: this,
                                    detail: {
                                        id: id,
                                        name: "Keystroke",
                                        value: selectedValues,
                                        changeEx: exportValue,
                                        willCommit: false,
                                        commitKey: 1,
                                        keyDown: false
                                    }
                                });
                            });
                            this._setEventListeners(selectElement, null, [
                                [
                                    "focus",
                                    "Focus"
                                ],
                                [
                                    "blur",
                                    "Blur"
                                ],
                                [
                                    "mousedown",
                                    "Mouse Down"
                                ],
                                [
                                    "mouseenter",
                                    "Mouse Enter"
                                ],
                                [
                                    "mouseleave",
                                    "Mouse Exit"
                                ],
                                [
                                    "mouseup",
                                    "Mouse Up"
                                ],
                                [
                                    "input",
                                    "Action"
                                ],
                                [
                                    "input",
                                    "Validate"
                                ]
                            ], (event)=>event.target.value);
                        } else selectElement.addEventListener("input", function(event) {
                            storage.setValue(id, {
                                value: getValue(true)
                            });
                        });
                        if (this.data.combo) this._setTextStyle(selectElement);
                        this._setBackgroundColor(selectElement);
                        this._setDefaultPropertiesFromJS(selectElement);
                        this.container.append(selectElement);
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: parameters.renderForms
                        });
                    }
                }
                class PopupAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("popupAnnotation");
                        const popup = new PopupElement({
                            container: this.container,
                            color: this.data.color,
                            titleObj: this.data.titleObj,
                            modificationDate: this.data.modificationDate,
                            contentsObj: this.data.contentsObj,
                            richText: this.data.richText,
                            rect: this.data.rect,
                            parentRect: this.data.parentRect || null,
                            parent: this.parent,
                            elements: this.elements,
                            open: this.data.open
                        });
                        const elementIds = [];
                        for (const element of this.elements){
                            element.popup = popup;
                            elementIds.push(element.data.id);
                            element.addHighlightArea();
                        }
                        this.container.setAttribute("aria-controls", elementIds.map((id)=>`${_util.AnnotationPrefix}${id}`).join(","));
                        return this.container;
                    }
                    constructor(parameters){
                        const { data, elements } = parameters;
                        super(parameters, {
                            isRenderable: AnnotationElement._hasPopupData(data)
                        });
                        this.elements = elements;
                    }
                }
                var _dateTimePromise = /*#__PURE__*/ new WeakMap(), _boundKeyDown = /*#__PURE__*/ new WeakMap(), _boundHide = /*#__PURE__*/ new WeakMap(), _boundShow = /*#__PURE__*/ new WeakMap(), _boundToggle = /*#__PURE__*/ new WeakMap(), _color = /*#__PURE__*/ new WeakMap(), _container = /*#__PURE__*/ new WeakMap(), _contentsObj = /*#__PURE__*/ new WeakMap(), _elements = /*#__PURE__*/ new WeakMap(), _parent = /*#__PURE__*/ new WeakMap(), _parentRect = /*#__PURE__*/ new WeakMap(), _pinned = /*#__PURE__*/ new WeakMap(), _popup = /*#__PURE__*/ new WeakMap(), _rect = /*#__PURE__*/ new WeakMap(), _richText = /*#__PURE__*/ new WeakMap(), _titleObj = /*#__PURE__*/ new WeakMap(), _wasVisible = /*#__PURE__*/ new WeakMap(), _keyDown = /*#__PURE__*/ new WeakSet(), _toggle = /*#__PURE__*/ new WeakSet(), _show = /*#__PURE__*/ new WeakSet(), _hide = /*#__PURE__*/ new WeakSet();
                class PopupElement {
                    render() {
                        if ((0, $f2lgg._)(this, _popup)) return;
                        const { page: { view }, viewport: { rawDims: { pageWidth, pageHeight, pageX, pageY } } } = (0, $f2lgg._)(this, _parent);
                        const popup = (0, $5grPd._)(this, _popup, document.createElement("div"));
                        popup.className = "popup";
                        if ((0, $f2lgg._)(this, _color)) {
                            const baseColor = popup.style.outlineColor = _util.Util.makeHexColor(...(0, $f2lgg._)(this, _color));
                            if (CSS.supports("background-color", "color-mix(in srgb, red 30%, white)")) popup.style.backgroundColor = `color-mix(in srgb, ${baseColor} 30%, white)`;
                            else {
                                const BACKGROUND_ENLIGHT = 0.7;
                                popup.style.backgroundColor = _util.Util.makeHexColor(...(0, $f2lgg._)(this, _color).map((c)=>Math.floor(BACKGROUND_ENLIGHT * (255 - c) + c)));
                            }
                        }
                        const header = document.createElement("span");
                        header.className = "header";
                        const title = document.createElement("h1");
                        header.append(title);
                        ({ dir: title.dir, str: title.textContent } = (0, $f2lgg._)(this, _titleObj));
                        popup.append(header);
                        if ((0, $f2lgg._)(this, _dateTimePromise)) {
                            const modificationDate = document.createElement("span");
                            modificationDate.classList.add("popupDate");
                            (0, $f2lgg._)(this, _dateTimePromise).then((localized)=>{
                                modificationDate.textContent = localized;
                            });
                            header.append(modificationDate);
                        }
                        const contentsObj = (0, $f2lgg._)(this, _contentsObj);
                        const richText = (0, $f2lgg._)(this, _richText);
                        if ((richText === null || richText === void 0 ? void 0 : richText.str) && (!(contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || contentsObj.str === richText.str)) {
                            _xfa_layer.XfaLayer.render({
                                xfaHtml: richText.html,
                                intent: "richText",
                                div: popup
                            });
                            popup.lastChild.classList.add("richText", "popupContent");
                        } else {
                            const contents = this._formatContents(contentsObj);
                            popup.append(contents);
                        }
                        let useParentRect = !!(0, $f2lgg._)(this, _parentRect);
                        let rect = useParentRect ? (0, $f2lgg._)(this, _parentRect) : (0, $f2lgg._)(this, _rect);
                        for (const element of (0, $f2lgg._)(this, _elements))if (!rect || _util.Util.intersect(element.data.rect, rect) !== null) {
                            rect = element.data.rect;
                            useParentRect = true;
                            break;
                        }
                        const normalizedRect = _util.Util.normalizeRect([
                            rect[0],
                            view[3] - rect[1] + view[1],
                            rect[2],
                            view[3] - rect[3] + view[1]
                        ]);
                        const HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
                        const parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
                        const popupLeft = normalizedRect[0] + parentWidth;
                        const popupTop = normalizedRect[1];
                        const { style } = (0, $f2lgg._)(this, _container);
                        style.left = `${100 * (popupLeft - pageX) / pageWidth}%`;
                        style.top = `${100 * (popupTop - pageY) / pageHeight}%`;
                        (0, $f2lgg._)(this, _container).append(popup);
                    }
                    _formatContents({ str, dir }) {
                        const p = document.createElement("p");
                        p.classList.add("popupContent");
                        p.dir = dir;
                        const lines = str.split(/(?:\r\n?|\n)/);
                        for(let i = 0, ii = lines.length; i < ii; ++i){
                            const line = lines[i];
                            p.append(document.createTextNode(line));
                            if (i < ii - 1) p.append(document.createElement("br"));
                        }
                        return p;
                    }
                    forceHide() {
                        (0, $5grPd._)(this, _wasVisible, this.isVisible);
                        if (!(0, $f2lgg._)(this, _wasVisible)) return;
                        (0, $f2lgg._)(this, _container).hidden = true;
                    }
                    maybeShow() {
                        if (!(0, $f2lgg._)(this, _wasVisible)) return;
                        (0, $5grPd._)(this, _wasVisible, false);
                        (0, $f2lgg._)(this, _container).hidden = false;
                    }
                    get isVisible() {
                        return (0, $f2lgg._)(this, _container).hidden === false;
                    }
                    constructor({ container, color, elements, titleObj, modificationDate, contentsObj, richText, parent, rect, parentRect, open }){
                        var _element_container;
                        (0, $2IZAT._)(this, _keyDown);
                        (0, $2IZAT._)(this, _toggle);
                        (0, $2IZAT._)(this, _show);
                        (0, $2IZAT._)(this, _hide);
                        (0, $iXPoG._)(this, _dateTimePromise, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _boundKeyDown, {
                            writable: true,
                            value: (0, $hDjZy._)(this, _keyDown, keyDown).bind(this)
                        });
                        (0, $iXPoG._)(this, _boundHide, {
                            writable: true,
                            value: (0, $hDjZy._)(this, _hide, hide).bind(this)
                        });
                        (0, $iXPoG._)(this, _boundShow, {
                            writable: true,
                            value: (0, $hDjZy._)(this, _show, show).bind(this)
                        });
                        (0, $iXPoG._)(this, _boundToggle, {
                            writable: true,
                            value: (0, $hDjZy._)(this, _toggle, toggle).bind(this)
                        });
                        (0, $iXPoG._)(this, _color, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _container, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _contentsObj, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _elements, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _parent, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _parentRect, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _pinned, {
                            writable: true,
                            value: false
                        });
                        (0, $iXPoG._)(this, _popup, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _rect, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _richText, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _titleObj, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _wasVisible, {
                            writable: true,
                            value: false
                        });
                        (0, $5grPd._)(this, _container, container);
                        (0, $5grPd._)(this, _titleObj, titleObj);
                        (0, $5grPd._)(this, _contentsObj, contentsObj);
                        (0, $5grPd._)(this, _richText, richText);
                        (0, $5grPd._)(this, _parent, parent);
                        (0, $5grPd._)(this, _color, color);
                        (0, $5grPd._)(this, _rect, rect);
                        (0, $5grPd._)(this, _parentRect, parentRect);
                        (0, $5grPd._)(this, _elements, elements);
                        const dateObject = _display_utils.PDFDateString.toDateObject(modificationDate);
                        if (dateObject) (0, $5grPd._)(this, _dateTimePromise, parent.l10n.get("annotation_date_string", {
                            date: dateObject.toLocaleDateString(),
                            time: dateObject.toLocaleTimeString()
                        }));
                        this.trigger = elements.flatMap((e)=>e.getElementsToTriggerPopup());
                        for (const element of this.trigger){
                            element.addEventListener("click", (0, $f2lgg._)(this, _boundToggle));
                            element.addEventListener("mouseenter", (0, $f2lgg._)(this, _boundShow));
                            element.addEventListener("mouseleave", (0, $f2lgg._)(this, _boundHide));
                            element.classList.add("popupTriggerArea");
                        }
                        for (const element of elements)(_element_container = element.container) === null || _element_container === void 0 ? void 0 : _element_container.addEventListener("keydown", (0, $f2lgg._)(this, _boundKeyDown));
                        (0, $f2lgg._)(this, _container).hidden = true;
                        if (open) (0, $hDjZy._)(this, _toggle, toggle).call(this);
                    }
                }
                function keyDown(event) {
                    if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) return;
                    if (event.key === "Enter" || event.key === "Escape" && (0, $f2lgg._)(this, _pinned)) (0, $hDjZy._)(this, _toggle, toggle).call(this);
                }
                function toggle() {
                    (0, $5grPd._)(this, _pinned, !(0, $f2lgg._)(this, _pinned));
                    if ((0, $f2lgg._)(this, _pinned)) {
                        (0, $hDjZy._)(this, _show, show).call(this);
                        (0, $f2lgg._)(this, _container).addEventListener("click", (0, $f2lgg._)(this, _boundToggle));
                        (0, $f2lgg._)(this, _container).addEventListener("keydown", (0, $f2lgg._)(this, _boundKeyDown));
                    } else {
                        (0, $hDjZy._)(this, _hide, hide).call(this);
                        (0, $f2lgg._)(this, _container).removeEventListener("click", (0, $f2lgg._)(this, _boundToggle));
                        (0, $f2lgg._)(this, _container).removeEventListener("keydown", (0, $f2lgg._)(this, _boundKeyDown));
                    }
                }
                function show() {
                    if (!(0, $f2lgg._)(this, _popup)) this.render();
                    if (!this.isVisible) {
                        (0, $f2lgg._)(this, _container).hidden = false;
                        (0, $f2lgg._)(this, _container).style.zIndex = parseInt((0, $f2lgg._)(this, _container).style.zIndex) + 1000;
                    } else if ((0, $f2lgg._)(this, _pinned)) (0, $f2lgg._)(this, _container).classList.add("focused");
                }
                function hide() {
                    (0, $f2lgg._)(this, _container).classList.remove("focused");
                    if ((0, $f2lgg._)(this, _pinned) || !this.isVisible) return;
                    (0, $f2lgg._)(this, _container).hidden = true;
                    (0, $f2lgg._)(this, _container).style.zIndex = parseInt((0, $f2lgg._)(this, _container).style.zIndex) - 1000;
                }
                class FreeTextAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("freeTextAnnotation");
                        if (this.textContent) {
                            const content = document.createElement("div");
                            content.classList.add("annotationTextContent");
                            content.setAttribute("role", "comment");
                            for (const line of this.textContent){
                                const lineSpan = document.createElement("span");
                                lineSpan.textContent = line;
                                content.append(lineSpan);
                            }
                            this.container.append(content);
                        }
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this._editOnDoubleClick();
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                        this.textContent = parameters.data.textContent;
                        this.textPosition = parameters.data.textPosition;
                        this.annotationEditorType = _util.AnnotationEditorType.FREETEXT;
                    }
                }
                exports.FreeTextAnnotationElement = FreeTextAnnotationElement;
                var _line = /*#__PURE__*/ new WeakMap();
                class LineAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("lineAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const line = (0, $5grPd._)(this, _line, this.svgFactory.createElement("svg:line"));
                        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
                        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
                        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
                        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
                        line.setAttribute("stroke-width", data.borderStyle.width || 1);
                        line.setAttribute("stroke", "transparent");
                        line.setAttribute("fill", "transparent");
                        svg.append(line);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _line);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        }), (0, $iXPoG._)(this, _line, {
                            writable: true,
                            value: null
                        });
                    }
                }
                var _square = /*#__PURE__*/ new WeakMap();
                class SquareAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("squareAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const square = (0, $5grPd._)(this, _square, this.svgFactory.createElement("svg:rect"));
                        square.setAttribute("x", borderWidth / 2);
                        square.setAttribute("y", borderWidth / 2);
                        square.setAttribute("width", width - borderWidth);
                        square.setAttribute("height", height - borderWidth);
                        square.setAttribute("stroke-width", borderWidth || 1);
                        square.setAttribute("stroke", "transparent");
                        square.setAttribute("fill", "transparent");
                        svg.append(square);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _square);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        }), (0, $iXPoG._)(this, _square, {
                            writable: true,
                            value: null
                        });
                    }
                }
                var _circle = /*#__PURE__*/ new WeakMap();
                class CircleAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("circleAnnotation");
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        const borderWidth = data.borderStyle.width;
                        const circle = (0, $5grPd._)(this, _circle, this.svgFactory.createElement("svg:ellipse"));
                        circle.setAttribute("cx", width / 2);
                        circle.setAttribute("cy", height / 2);
                        circle.setAttribute("rx", width / 2 - borderWidth / 2);
                        circle.setAttribute("ry", height / 2 - borderWidth / 2);
                        circle.setAttribute("stroke-width", borderWidth || 1);
                        circle.setAttribute("stroke", "transparent");
                        circle.setAttribute("fill", "transparent");
                        svg.append(circle);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _circle);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        }), (0, $iXPoG._)(this, _circle, {
                            writable: true,
                            value: null
                        });
                    }
                }
                var _polyline = /*#__PURE__*/ new WeakMap();
                class PolylineAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        let points = [];
                        for (const coordinate of data.vertices){
                            const x = coordinate.x - data.rect[0];
                            const y = data.rect[3] - coordinate.y;
                            points.push(x + "," + y);
                        }
                        points = points.join(" ");
                        const polyline = (0, $5grPd._)(this, _polyline, this.svgFactory.createElement(this.svgElementName));
                        polyline.setAttribute("points", points);
                        polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                        polyline.setAttribute("stroke", "transparent");
                        polyline.setAttribute("fill", "transparent");
                        svg.append(polyline);
                        this.container.append(svg);
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _polyline);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        }), (0, $iXPoG._)(this, _polyline, {
                            writable: true,
                            value: null
                        });
                        this.containerClassName = "polylineAnnotation";
                        this.svgElementName = "svg:polyline";
                    }
                }
                class PolygonAnnotationElement extends PolylineAnnotationElement {
                    constructor(parameters){
                        super(parameters);
                        this.containerClassName = "polygonAnnotation";
                        this.svgElementName = "svg:polygon";
                    }
                }
                class CaretAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("caretAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                }
                var _polylines = /*#__PURE__*/ new WeakMap();
                class InkAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add(this.containerClassName);
                        const data = this.data;
                        const { width, height } = getRectDims(data.rect);
                        const svg = this.svgFactory.create(width, height, true);
                        for (const inkList of data.inkLists){
                            let points = [];
                            for (const coordinate of inkList){
                                const x = coordinate.x - data.rect[0];
                                const y = data.rect[3] - coordinate.y;
                                points.push(`${x},${y}`);
                            }
                            points = points.join(" ");
                            const polyline = this.svgFactory.createElement(this.svgElementName);
                            (0, $f2lgg._)(this, _polylines).push(polyline);
                            polyline.setAttribute("points", points);
                            polyline.setAttribute("stroke-width", data.borderStyle.width || 1);
                            polyline.setAttribute("stroke", "transparent");
                            polyline.setAttribute("fill", "transparent");
                            if (!data.popupRef && this.hasPopupData) this._createPopup();
                            svg.append(polyline);
                        }
                        this.container.append(svg);
                        return this.container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _polylines);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        }), (0, $iXPoG._)(this, _polylines, {
                            writable: true,
                            value: []
                        });
                        this.containerClassName = "inkAnnotation";
                        this.svgElementName = "svg:polyline";
                        this.annotationEditorType = _util.AnnotationEditorType.INK;
                    }
                }
                exports.InkAnnotationElement = InkAnnotationElement;
                class HighlightAnnotationElement extends AnnotationElement {
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("highlightAnnotation");
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                }
                class UnderlineAnnotationElement extends AnnotationElement {
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("underlineAnnotation");
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                }
                class SquigglyAnnotationElement extends AnnotationElement {
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("squigglyAnnotation");
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                }
                class StrikeOutAnnotationElement extends AnnotationElement {
                    render() {
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        this.container.classList.add("strikeoutAnnotation");
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true,
                            createQuadrilaterals: true
                        });
                    }
                }
                class StampAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("stampAnnotation");
                        if (!this.data.popupRef && this.hasPopupData) this._createPopup();
                        return this.container;
                    }
                    constructor(parameters){
                        super(parameters, {
                            isRenderable: true,
                            ignoreBorder: true
                        });
                    }
                }
                exports.StampAnnotationElement = StampAnnotationElement;
                var _trigger = /*#__PURE__*/ new WeakMap(), _download = /*#__PURE__*/ new WeakSet();
                class FileAttachmentAnnotationElement extends AnnotationElement {
                    render() {
                        this.container.classList.add("fileAttachmentAnnotation");
                        const { container, data } = this;
                        let trigger;
                        if (data.hasAppearance || data.fillAlpha === 0) trigger = document.createElement("div");
                        else {
                            trigger = document.createElement("img");
                            trigger.src = `${this.imageResourcesPath}annotation-${/paperclip/i.test(data.name) ? "paperclip" : "pushpin"}.svg`;
                            if (data.fillAlpha && data.fillAlpha < 1) trigger.style = `filter: opacity(${Math.round(data.fillAlpha * 100)}%);`;
                        }
                        trigger.addEventListener("dblclick", (0, $hDjZy._)(this, _download, download).bind(this));
                        (0, $5grPd._)(this, _trigger, trigger);
                        const { isMac } = _util.FeatureTest.platform;
                        container.addEventListener("keydown", (evt)=>{
                            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) (0, $hDjZy._)(this, _download, download).call(this);
                        });
                        if (!data.popupRef && this.hasPopupData) this._createPopup();
                        else trigger.classList.add("popupTriggerArea");
                        container.append(trigger);
                        return container;
                    }
                    getElementsToTriggerPopup() {
                        return (0, $f2lgg._)(this, _trigger);
                    }
                    addHighlightArea() {
                        this.container.classList.add("highlightArea");
                    }
                    constructor(parameters){
                        var _this_linkService_eventBus;
                        super(parameters, {
                            isRenderable: true
                        }), (0, $2IZAT._)(this, _download), (0, $iXPoG._)(this, _trigger, {
                            writable: true,
                            value: null
                        });
                        const { filename, content } = this.data.file;
                        this.filename = (0, _display_utils.getFilenameFromUrl)(filename, true);
                        this.content = content;
                        (_this_linkService_eventBus = this.linkService.eventBus) === null || _this_linkService_eventBus === void 0 ? void 0 : _this_linkService_eventBus.dispatch("fileattachmentannotation", {
                            source: this,
                            filename: filename,
                            content: content
                        });
                    }
                }
                function download() {
                    var _this_downloadManager;
                    (_this_downloadManager = this.downloadManager) === null || _this_downloadManager === void 0 ? void 0 : _this_downloadManager.openOrDownloadData(this.container, this.content, this.filename);
                }
                var _accessibilityManager = /*#__PURE__*/ new WeakMap(), _annotationCanvasMap = /*#__PURE__*/ new WeakMap(), _editableAnnotations = /*#__PURE__*/ new WeakMap(), _appendElement = /*#__PURE__*/ new WeakSet(), _setAnnotationCanvasMap = /*#__PURE__*/ new WeakSet();
                class AnnotationLayer {
                    render(params) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            const { annotations } = params;
                            const layer = this.div;
                            (0, _display_utils.setLayerDimensions)(layer, this.viewport);
                            const popupToElements = new Map();
                            const elementParams = {
                                data: null,
                                layer: layer,
                                linkService: params.linkService,
                                downloadManager: params.downloadManager,
                                imageResourcesPath: params.imageResourcesPath || "",
                                renderForms: params.renderForms !== false,
                                svgFactory: new _display_utils.DOMSVGFactory(),
                                annotationStorage: params.annotationStorage || new _annotation_storage.AnnotationStorage(),
                                enableScripting: params.enableScripting === true,
                                hasJSActions: params.hasJSActions,
                                fieldObjects: params.fieldObjects,
                                parent: this,
                                elements: null
                            };
                            for (const data of annotations){
                                if (data.noHTML) continue;
                                const isPopupAnnotation = data.annotationType === _util.AnnotationType.POPUP;
                                if (!isPopupAnnotation) {
                                    const { width, height } = getRectDims(data.rect);
                                    if (width <= 0 || height <= 0) continue;
                                } else {
                                    const elements = popupToElements.get(data.id);
                                    if (!elements) continue;
                                    elementParams.elements = elements;
                                }
                                elementParams.data = data;
                                const element = AnnotationElementFactory.create(elementParams);
                                if (!element.isRenderable) continue;
                                if (!isPopupAnnotation && data.popupRef) {
                                    const elements = popupToElements.get(data.popupRef);
                                    if (!elements) popupToElements.set(data.popupRef, [
                                        element
                                    ]);
                                    else elements.push(element);
                                }
                                if (element.annotationEditorType > 0) (0, $f2lgg._)(this, _editableAnnotations).set(element.data.id, element);
                                const rendered = element.render();
                                if (data.hidden) rendered.style.visibility = "hidden";
                                (0, $hDjZy._)(this, _appendElement, appendElement).call(this, rendered, data.id);
                            }
                            (0, $hDjZy._)(this, _setAnnotationCanvasMap, setAnnotationCanvasMap).call(this);
                            yield this.l10n.translate(layer);
                        }).call(this);
                    }
                    update({ viewport }) {
                        const layer = this.div;
                        this.viewport = viewport;
                        (0, _display_utils.setLayerDimensions)(layer, {
                            rotation: viewport.rotation
                        });
                        (0, $hDjZy._)(this, _setAnnotationCanvasMap, setAnnotationCanvasMap).call(this);
                        layer.hidden = false;
                    }
                    getEditableAnnotations() {
                        return Array.from((0, $f2lgg._)(this, _editableAnnotations).values());
                    }
                    getEditableAnnotation(id) {
                        return (0, $f2lgg._)(this, _editableAnnotations).get(id);
                    }
                    constructor({ div, accessibilityManager, annotationCanvasMap, l10n, page, viewport }){
                        (0, $2IZAT._)(this, _appendElement);
                        (0, $2IZAT._)(this, _setAnnotationCanvasMap);
                        (0, $iXPoG._)(this, _accessibilityManager, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _annotationCanvasMap, {
                            writable: true,
                            value: null
                        });
                        (0, $iXPoG._)(this, _editableAnnotations, {
                            writable: true,
                            value: new Map()
                        });
                        this.div = div;
                        (0, $5grPd._)(this, _accessibilityManager, accessibilityManager);
                        (0, $5grPd._)(this, _annotationCanvasMap, annotationCanvasMap);
                        this.l10n = l10n;
                        this.page = page;
                        this.viewport = viewport;
                        this.zIndex = 0;
                        this.l10n || (this.l10n = _displayL10n_utils.NullL10n);
                    }
                }
                function appendElement(element, id) {
                    var _class_private_field_get1;
                    const contentElement = element.firstChild || element;
                    contentElement.id = `${_util.AnnotationPrefix}${id}`;
                    this.div.append(element);
                    (_class_private_field_get1 = (0, $f2lgg._)(this, _accessibilityManager)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.moveElementInDOM(this.div, element, contentElement, false);
                }
                function setAnnotationCanvasMap() {
                    if (!(0, $f2lgg._)(this, _annotationCanvasMap)) return;
                    const layer = this.div;
                    for (const [id, canvas] of (0, $f2lgg._)(this, _annotationCanvasMap)){
                        const element = layer.querySelector(`[data-annotation-id="${id}"]`);
                        if (!element) continue;
                        const { firstChild } = element;
                        if (!firstChild) element.append(canvas);
                        else if (firstChild.nodeName === "CANVAS") firstChild.replaceWith(canvas);
                        else firstChild.before(canvas);
                    }
                    (0, $f2lgg._)(this, _annotationCanvasMap).clear();
                }
                exports.AnnotationLayer = AnnotationLayer;
            /***/ },
            /* 30 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.ColorConverters = void 0;
                function makeColorComp(n) {
                    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
                }
                function scaleAndClamp(x) {
                    return Math.max(0, Math.min(255, 255 * x));
                }
                class ColorConverters {
                    static CMYK_G([c, y, m, k]) {
                        return [
                            "G",
                            1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)
                        ];
                    }
                    static G_CMYK([g]) {
                        return [
                            "CMYK",
                            0,
                            0,
                            0,
                            1 - g
                        ];
                    }
                    static G_RGB([g]) {
                        return [
                            "RGB",
                            g,
                            g,
                            g
                        ];
                    }
                    static G_rgb([g]) {
                        g = scaleAndClamp(g);
                        return [
                            g,
                            g,
                            g
                        ];
                    }
                    static G_HTML([g]) {
                        const G = makeColorComp(g);
                        return `#${G}${G}${G}`;
                    }
                    static RGB_G([r, g, b]) {
                        return [
                            "G",
                            0.3 * r + 0.59 * g + 0.11 * b
                        ];
                    }
                    static RGB_rgb(color) {
                        return color.map(scaleAndClamp);
                    }
                    static RGB_HTML(color) {
                        return `#${color.map(makeColorComp).join("")}`;
                    }
                    static T_HTML() {
                        return "#00000000";
                    }
                    static T_rgb() {
                        return [
                            null
                        ];
                    }
                    static CMYK_RGB([c, y, m, k]) {
                        return [
                            "RGB",
                            1 - Math.min(1, c + k),
                            1 - Math.min(1, m + k),
                            1 - Math.min(1, y + k)
                        ];
                    }
                    static CMYK_rgb([c, y, m, k]) {
                        return [
                            scaleAndClamp(1 - Math.min(1, c + k)),
                            scaleAndClamp(1 - Math.min(1, m + k)),
                            scaleAndClamp(1 - Math.min(1, y + k))
                        ];
                    }
                    static CMYK_HTML(components) {
                        const rgb = this.CMYK_RGB(components).slice(1);
                        return this.RGB_HTML(rgb);
                    }
                    static RGB_CMYK([r, g, b]) {
                        const c = 1 - r;
                        const m = 1 - g;
                        const y = 1 - b;
                        const k = Math.min(c, m, y);
                        return [
                            "CMYK",
                            c,
                            m,
                            y,
                            k
                        ];
                    }
                }
                exports.ColorConverters = ColorConverters;
            /***/ },
            /* 31 */ /***/ (__unused_webpack_module, exports)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.NullL10n = void 0;
                exports.getL10nFallback = getL10nFallback;
                const DEFAULT_L10N_STRINGS = {
                    of_pages: "of {{pagesCount}}",
                    page_of_pages: "({{pageNumber}} of {{pagesCount}})",
                    document_properties_kb: "{{size_kb}} KB ({{size_b}} bytes)",
                    document_properties_mb: "{{size_mb}} MB ({{size_b}} bytes)",
                    document_properties_date_string: "{{date}}, {{time}}",
                    document_properties_page_size_unit_inches: "in",
                    document_properties_page_size_unit_millimeters: "mm",
                    document_properties_page_size_orientation_portrait: "portrait",
                    document_properties_page_size_orientation_landscape: "landscape",
                    document_properties_page_size_name_a3: "A3",
                    document_properties_page_size_name_a4: "A4",
                    document_properties_page_size_name_letter: "Letter",
                    document_properties_page_size_name_legal: "Legal",
                    document_properties_page_size_dimension_string: "{{width}} \xd7 {{height}} {{unit}} ({{orientation}})",
                    document_properties_page_size_dimension_name_string: "{{width}} \xd7 {{height}} {{unit}} ({{name}}, {{orientation}})",
                    document_properties_linearized_yes: "Yes",
                    document_properties_linearized_no: "No",
                    additional_layers: "Additional Layers",
                    page_landmark: "Page {{page}}",
                    thumb_page_title: "Page {{page}}",
                    thumb_page_canvas: "Thumbnail of Page {{page}}",
                    find_reached_top: "Reached top of document, continued from bottom",
                    find_reached_bottom: "Reached end of document, continued from top",
                    "find_match_count[one]": "{{current}} of {{total}} match",
                    "find_match_count[other]": "{{current}} of {{total}} matches",
                    "find_match_count_limit[one]": "More than {{limit}} match",
                    "find_match_count_limit[other]": "More than {{limit}} matches",
                    find_not_found: "Phrase not found",
                    page_scale_width: "Page Width",
                    page_scale_fit: "Page Fit",
                    page_scale_auto: "Automatic Zoom",
                    page_scale_actual: "Actual Size",
                    page_scale_percent: "{{scale}}%",
                    loading_error: "An error occurred while loading the PDF.",
                    invalid_file_error: "Invalid or corrupted PDF file.",
                    missing_file_error: "Missing PDF file.",
                    unexpected_response_error: "Unexpected server response.",
                    rendering_error: "An error occurred while rendering the page.",
                    annotation_date_string: "{{date}}, {{time}}",
                    printing_not_supported: "Warning: Printing is not fully supported by this browser.",
                    printing_not_ready: "Warning: The PDF is not fully loaded for printing.",
                    web_fonts_disabled: "Web fonts are disabled: unable to use embedded PDF fonts.",
                    free_text2_default_content: "Start typing\u2026",
                    editor_free_text2_aria_label: "Text Editor",
                    editor_ink2_aria_label: "Draw Editor",
                    editor_ink_canvas_aria_label: "User-created image",
                    editor_alt_text_button_label: "Alt text",
                    editor_alt_text_edit_button_label: "Edit alt text",
                    editor_alt_text_decorative_tooltip: "Marked as decorative"
                };
                DEFAULT_L10N_STRINGS.print_progress_percent = "{{progress}}%";
                function getL10nFallback(key, args) {
                    switch(key){
                        case "find_match_count":
                            key = `find_match_count[${args.total === 1 ? "one" : "other"}]`;
                            break;
                        case "find_match_count_limit":
                            key = `find_match_count_limit[${args.limit === 1 ? "one" : "other"}]`;
                            break;
                    }
                    return DEFAULT_L10N_STRINGS[key] || "";
                }
                function formatL10nValue(text, args) {
                    if (!args) return text;
                    return text.replaceAll(/\{\{\s*(\w+)\s*\}\}/g, (all, name)=>{
                        return name in args ? args[name] : "{{" + name + "}}";
                    });
                }
                const NullL10n = {
                    getLanguage () {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            return "en-us";
                        })();
                    },
                    getDirection () {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                            return "ltr";
                        })();
                    },
                    get (_0) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*(key, args = null, fallback = getL10nFallback(key, args)) {
                            return formatL10nValue(fallback, args);
                        }).apply(this, arguments);
                    },
                    translate (element) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {})();
                    }
                };
                exports.NullL10n = NullL10n;
            /***/ },
            /* 32 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.XfaLayer = void 0;
                var _xfa_text = __w_pdfjs_require__(25);
                class XfaLayer {
                    static setupStorage(html, id, element, storage, intent) {
                        const storedData = storage.getValue(id, {
                            value: null
                        });
                        switch(element.name){
                            case "textarea":
                                if (storedData.value !== null) html.textContent = storedData.value;
                                if (intent === "print") break;
                                html.addEventListener("input", (event)=>{
                                    storage.setValue(id, {
                                        value: event.target.value
                                    });
                                });
                                break;
                            case "input":
                                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                                    if (storedData.value === element.attributes.xfaOn) html.setAttribute("checked", true);
                                    else if (storedData.value === element.attributes.xfaOff) html.removeAttribute("checked");
                                    if (intent === "print") break;
                                    html.addEventListener("change", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                                        });
                                    });
                                } else {
                                    if (storedData.value !== null) html.setAttribute("value", storedData.value);
                                    if (intent === "print") break;
                                    html.addEventListener("input", (event)=>{
                                        storage.setValue(id, {
                                            value: event.target.value
                                        });
                                    });
                                }
                                break;
                            case "select":
                                if (storedData.value !== null) {
                                    html.setAttribute("value", storedData.value);
                                    for (const option of element.children){
                                        if (option.attributes.value === storedData.value) option.attributes.selected = true;
                                        else if (option.attributes.hasOwnProperty("selected")) delete option.attributes.selected;
                                    }
                                }
                                html.addEventListener("input", (event)=>{
                                    const options = event.target.options;
                                    const value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                                    storage.setValue(id, {
                                        value: value
                                    });
                                });
                                break;
                        }
                    }
                    static setAttributes({ html, element, storage = null, intent, linkService }) {
                        const { attributes } = element;
                        const isHTMLAnchorElement = html instanceof HTMLAnchorElement;
                        if (attributes.type === "radio") attributes.name = `${attributes.name}-${intent}`;
                        for (const [key, value] of Object.entries(attributes)){
                            if (value === null || value === undefined) continue;
                            switch(key){
                                case "class":
                                    if (value.length) html.setAttribute(key, value.join(" "));
                                    break;
                                case "dataId":
                                    break;
                                case "id":
                                    html.setAttribute("data-element-id", value);
                                    break;
                                case "style":
                                    Object.assign(html.style, value);
                                    break;
                                case "textContent":
                                    html.textContent = value;
                                    break;
                                default:
                                    if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") html.setAttribute(key, value);
                            }
                        }
                        if (isHTMLAnchorElement) linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
                        if (storage && attributes.dataId) this.setupStorage(html, attributes.dataId, element, storage);
                    }
                    static render(parameters) {
                        const storage = parameters.annotationStorage;
                        const linkService = parameters.linkService;
                        const root = parameters.xfaHtml;
                        const intent = parameters.intent || "display";
                        const rootHtml = document.createElement(root.name);
                        if (root.attributes) this.setAttributes({
                            html: rootHtml,
                            element: root,
                            intent: intent,
                            linkService: linkService
                        });
                        const stack = [
                            [
                                root,
                                -1,
                                rootHtml
                            ]
                        ];
                        const rootDiv = parameters.div;
                        rootDiv.append(rootHtml);
                        if (parameters.viewport) {
                            const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                            rootDiv.style.transform = transform;
                        }
                        if (intent !== "richText") rootDiv.setAttribute("class", "xfaLayer xfaFont");
                        const textDivs = [];
                        while(stack.length > 0){
                            var _child_attributes;
                            const [parent, i, html] = stack.at(-1);
                            if (i + 1 === parent.children.length) {
                                stack.pop();
                                continue;
                            }
                            const child = parent.children[++stack.at(-1)[1]];
                            if (child === null) continue;
                            const { name } = child;
                            if (name === "#text") {
                                const node = document.createTextNode(child.value);
                                textDivs.push(node);
                                html.append(node);
                                continue;
                            }
                            const childHtml = (child === null || child === void 0 ? void 0 : (_child_attributes = child.attributes) === null || _child_attributes === void 0 ? void 0 : _child_attributes.xmlns) ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
                            html.append(childHtml);
                            if (child.attributes) this.setAttributes({
                                html: childHtml,
                                element: child,
                                storage: storage,
                                intent: intent,
                                linkService: linkService
                            });
                            if (child.children && child.children.length > 0) stack.push([
                                child,
                                -1,
                                childHtml
                            ]);
                            else if (child.value) {
                                const node = document.createTextNode(child.value);
                                if (_xfa_text.XfaText.shouldBuildText(name)) textDivs.push(node);
                                childHtml.append(node);
                            }
                        }
                        for (const el of rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea"))el.setAttribute("readOnly", true);
                        return {
                            textDivs: textDivs
                        };
                    }
                    static update(parameters) {
                        const transform = `matrix(${parameters.viewport.transform.join(",")})`;
                        parameters.div.style.transform = transform;
                        parameters.div.hidden = false;
                    }
                }
                exports.XfaLayer = XfaLayer;
            /***/ },
            /* 33 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.InkEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _display_utils = __w_pdfjs_require__(6);
                var _tools = __w_pdfjs_require__(5);
                var _baseHeight = /*#__PURE__*/ new WeakMap(), _baseWidth = /*#__PURE__*/ new WeakMap(), _boundCanvasPointermove = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerleave = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerup = /*#__PURE__*/ new WeakMap(), _boundCanvasPointerdown = /*#__PURE__*/ new WeakMap(), _currentPath2D = /*#__PURE__*/ new WeakMap(), _disableEditing = /*#__PURE__*/ new WeakMap(), _hasSomethingToDraw = /*#__PURE__*/ new WeakMap(), _isCanvasInitialized = /*#__PURE__*/ new WeakMap(), _observer = /*#__PURE__*/ new WeakMap(), _realWidth = /*#__PURE__*/ new WeakMap(), _realHeight = /*#__PURE__*/ new WeakMap(), _requestFrameCallback = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _updateThickness = /*#__PURE__*/ new WeakSet(), _updateColor = /*#__PURE__*/ new WeakSet(), _updateOpacity = /*#__PURE__*/ new WeakSet(), _getInitialBBox = /*#__PURE__*/ new WeakSet(), _setStroke = /*#__PURE__*/ new WeakSet(), _startDrawing = /*#__PURE__*/ new WeakSet(), _draw = /*#__PURE__*/ new WeakSet(), _endPath = /*#__PURE__*/ new WeakSet(), _stopDrawing = /*#__PURE__*/ new WeakSet(), _drawPoints = /*#__PURE__*/ new WeakSet(), _makeBezierCurve = /*#__PURE__*/ new WeakSet(), _generateBezierPoints = /*#__PURE__*/ new WeakSet(), _redraw = /*#__PURE__*/ new WeakSet(), _endDrawing = /*#__PURE__*/ new WeakSet(), _createCanvas = /*#__PURE__*/ new WeakSet(), _createObserver = /*#__PURE__*/ new WeakSet(), _setCanvasDims = /*#__PURE__*/ new WeakSet(), _setScaleFactor = /*#__PURE__*/ new WeakSet(), _updateTransform = /*#__PURE__*/ new WeakSet(), _serializePaths = /*#__PURE__*/ new WeakSet(), _getBbox = /*#__PURE__*/ new WeakSet(), _getPadding = /*#__PURE__*/ new WeakSet(), _fitToContent = /*#__PURE__*/ new WeakSet();
                class InkEditor extends (_editor_AnnotationEditor = _editor.AnnotationEditor) {
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n, {
                            strings: [
                                "editor_ink_canvas_aria_label",
                                "editor_ink2_aria_label"
                            ]
                        });
                    }
                    static updateDefaultParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                InkEditor._defaultThickness = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                InkEditor._defaultColor = value;
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                InkEditor._defaultOpacity = value / 100;
                                break;
                        }
                    }
                    updateParams(type, value) {
                        switch(type){
                            case _util.AnnotationEditorParamsType.INK_THICKNESS:
                                (0, $hDjZy._)(this, _updateThickness, updateThickness).call(this, value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_COLOR:
                                (0, $hDjZy._)(this, _updateColor, updateColor).call(this, value);
                                break;
                            case _util.AnnotationEditorParamsType.INK_OPACITY:
                                (0, $hDjZy._)(this, _updateOpacity, updateOpacity).call(this, value);
                                break;
                        }
                    }
                    static get defaultPropertiesToUpdate() {
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(InkEditor._defaultOpacity * 100)
                            ]
                        ];
                    }
                    get propertiesToUpdate() {
                        var _this_opacity;
                        return [
                            [
                                _util.AnnotationEditorParamsType.INK_THICKNESS,
                                this.thickness || InkEditor._defaultThickness
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_COLOR,
                                this.color || InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor
                            ],
                            [
                                _util.AnnotationEditorParamsType.INK_OPACITY,
                                Math.round(100 * ((_this_opacity = this.opacity) !== null && _this_opacity !== void 0 ? _this_opacity : InkEditor._defaultOpacity))
                            ]
                        ];
                    }
                    rebuild() {
                        if (!this.parent) return;
                        super.rebuild();
                        if (this.div === null) return;
                        if (!this.canvas) {
                            (0, $hDjZy._)(this, _createCanvas, createCanvas).call(this);
                            (0, $hDjZy._)(this, _createObserver, createObserver).call(this);
                        }
                        if (!this.isAttachedToDOM) {
                            this.parent.add(this);
                            (0, $hDjZy._)(this, _setCanvasDims, setCanvasDims).call(this);
                        }
                        (0, $hDjZy._)(this, _fitToContent, fitToContent).call(this);
                    }
                    remove() {
                        if (this.canvas === null) return;
                        if (!this.isEmpty()) this.commit();
                        this.canvas.width = this.canvas.height = 0;
                        this.canvas.remove();
                        this.canvas = null;
                        (0, $f2lgg._)(this, _observer).disconnect();
                        (0, $5grPd._)(this, _observer, null);
                        super.remove();
                    }
                    setParent(parent) {
                        if (!this.parent && parent) this._uiManager.removeShouldRescale(this);
                        else if (this.parent && parent === null) this._uiManager.addShouldRescale(this);
                        super.setParent(parent);
                    }
                    onScaleChanging() {
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        const width = this.width * parentWidth;
                        const height = this.height * parentHeight;
                        this.setDimensions(width, height);
                    }
                    enableEditMode() {
                        if ((0, $f2lgg._)(this, _disableEditing) || this.canvas === null) return;
                        super.enableEditMode();
                        this._isDraggable = false;
                        this.canvas.addEventListener("pointerdown", (0, $f2lgg._)(this, _boundCanvasPointerdown));
                    }
                    disableEditMode() {
                        if (!this.isInEditMode() || this.canvas === null) return;
                        super.disableEditMode();
                        this._isDraggable = !this.isEmpty();
                        this.div.classList.remove("editing");
                        this.canvas.removeEventListener("pointerdown", (0, $f2lgg._)(this, _boundCanvasPointerdown));
                    }
                    onceAdded() {
                        this._isDraggable = !this.isEmpty();
                    }
                    isEmpty() {
                        return this.paths.length === 0 || this.paths.length === 1 && this.paths[0].length === 0;
                    }
                    commit() {
                        if ((0, $f2lgg._)(this, _disableEditing)) return;
                        super.commit();
                        this.isEditing = false;
                        this.disableEditMode();
                        this.setInForeground();
                        (0, $5grPd._)(this, _disableEditing, true);
                        this.div.classList.add("disabled");
                        (0, $hDjZy._)(this, _fitToContent, fitToContent).call(this, true);
                        this.makeResizable();
                        this.parent.addInkEditorIfNeeded(true);
                        this.moveInDOM();
                        this.div.focus({
                            preventScroll: true
                        });
                    }
                    focusin(event) {
                        if (!this._focusEventsAllowed) return;
                        super.focusin(event);
                        this.enableEditMode();
                    }
                    canvasPointerdown(event) {
                        if (event.button !== 0 || !this.isInEditMode() || (0, $f2lgg._)(this, _disableEditing)) return;
                        this.setInForeground();
                        event.preventDefault();
                        if (event.type !== "mouse") this.div.focus();
                        (0, $hDjZy._)(this, _startDrawing, startDrawing).call(this, event.offsetX, event.offsetY);
                    }
                    canvasPointermove(event) {
                        event.preventDefault();
                        (0, $hDjZy._)(this, _draw, draw).call(this, event.offsetX, event.offsetY);
                    }
                    canvasPointerup(event) {
                        event.preventDefault();
                        (0, $hDjZy._)(this, _endDrawing, endDrawing).call(this, event);
                    }
                    canvasPointerleave(event) {
                        (0, $hDjZy._)(this, _endDrawing, endDrawing).call(this, event);
                    }
                    get isResizable() {
                        return !this.isEmpty() && (0, $f2lgg._)(this, _disableEditing);
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        _editor.AnnotationEditor._l10nPromise.get("editor_ink2_aria_label").then((msg)=>{
                            var _this_div;
                            return (_this_div = this.div) === null || _this_div === void 0 ? void 0 : _this_div.setAttribute("aria-label", msg);
                        });
                        const [x, y, w, h] = (0, $hDjZy._)(this, _getInitialBBox, getInitialBBox).call(this);
                        this.setAt(x, y, 0, 0);
                        this.setDims(w, h);
                        (0, $hDjZy._)(this, _createCanvas, createCanvas).call(this);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAspectRatio(this.width * parentWidth, this.height * parentHeight);
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                            (0, $5grPd._)(this, _isCanvasInitialized, true);
                            (0, $hDjZy._)(this, _setCanvasDims, setCanvasDims).call(this);
                            this.setDims(this.width * parentWidth, this.height * parentHeight);
                            (0, $hDjZy._)(this, _redraw, redraw).call(this);
                            this.div.classList.add("disabled");
                        } else {
                            this.div.classList.add("editing");
                            this.enableEditMode();
                        }
                        (0, $hDjZy._)(this, _createObserver, createObserver).call(this);
                        return this.div;
                    }
                    setDimensions(width, height) {
                        const roundedWidth = Math.round(width);
                        const roundedHeight = Math.round(height);
                        if ((0, $f2lgg._)(this, _realWidth) === roundedWidth && (0, $f2lgg._)(this, _realHeight) === roundedHeight) return;
                        (0, $5grPd._)(this, _realWidth, roundedWidth);
                        (0, $5grPd._)(this, _realHeight, roundedHeight);
                        this.canvas.style.visibility = "hidden";
                        const [parentWidth, parentHeight] = this.parentDimensions;
                        this.width = width / parentWidth;
                        this.height = height / parentHeight;
                        this.fixAndSetPosition();
                        if ((0, $f2lgg._)(this, _disableEditing)) (0, $hDjZy._)(this, _setScaleFactor, setScaleFactor).call(this, width, height);
                        (0, $hDjZy._)(this, _setCanvasDims, setCanvasDims).call(this);
                        (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        this.canvas.style.visibility = "visible";
                        this.fixDims();
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.InkAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        editor.thickness = data.thickness;
                        editor.color = _util.Util.makeHexColor(...data.color);
                        editor.opacity = data.opacity;
                        const [pageWidth, pageHeight] = editor.pageDimensions;
                        const width = editor.width * pageWidth;
                        const height = editor.height * pageHeight;
                        const scaleFactor = editor.parentScale;
                        const padding = data.thickness / 2;
                        (0, $5grPd._)(editor, _disableEditing, true);
                        (0, $5grPd._)(editor, _realWidth, Math.round(width));
                        (0, $5grPd._)(editor, _realHeight, Math.round(height));
                        const { paths, rect, rotation } = data;
                        for (let { bezier } of paths){
                            bezier = (0, $a36Ks._)(InkEditor, InkEditor, fromPDFCoordinates).call(InkEditor, bezier, rect, rotation);
                            const path = [];
                            editor.paths.push(path);
                            let p0 = scaleFactor * (bezier[0] - padding);
                            let p1 = scaleFactor * (bezier[1] - padding);
                            for(let i = 2, ii = bezier.length; i < ii; i += 6){
                                const p10 = scaleFactor * (bezier[i] - padding);
                                const p11 = scaleFactor * (bezier[i + 1] - padding);
                                const p20 = scaleFactor * (bezier[i + 2] - padding);
                                const p21 = scaleFactor * (bezier[i + 3] - padding);
                                const p30 = scaleFactor * (bezier[i + 4] - padding);
                                const p31 = scaleFactor * (bezier[i + 5] - padding);
                                path.push([
                                    [
                                        p0,
                                        p1
                                    ],
                                    [
                                        p10,
                                        p11
                                    ],
                                    [
                                        p20,
                                        p21
                                    ],
                                    [
                                        p30,
                                        p31
                                    ]
                                ]);
                                p0 = p30;
                                p1 = p31;
                            }
                            const path2D = (0, $a36Ks._)(this, InkEditor, buildPath2D).call(InkEditor, path);
                            editor.bezierPath2D.push(path2D);
                        }
                        const bbox = (0, $hDjZy._)(editor, _getBbox, getBbox).call(editor);
                        (0, $5grPd._)(editor, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]));
                        (0, $5grPd._)(editor, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]));
                        (0, $hDjZy._)(editor, _setScaleFactor, setScaleFactor).call(editor, width, height);
                        return editor;
                    }
                    serialize() {
                        if (this.isEmpty()) return null;
                        const rect = this.getRect(0, 0);
                        const color = _editor.AnnotationEditor._colorManager.convert(this.ctx.strokeStyle);
                        return {
                            annotationType: _util.AnnotationEditorType.INK,
                            color: color,
                            thickness: this.thickness,
                            opacity: this.opacity,
                            paths: (0, $hDjZy._)(this, _serializePaths, serializePaths).call(this, this.scaleFactor / this.parentScale, this.translationX, this.translationY, rect),
                            pageIndex: this.pageIndex,
                            rect: rect,
                            rotation: this.rotation,
                            structTreeParentId: this._structTreeParentId
                        };
                    }
                    constructor(params){
                        super((0, $7d4tS._)((0, $cTSGB._)({}, params), {
                            name: "inkEditor"
                        })), (0, $2IZAT._)(this, _updateThickness), (0, $2IZAT._)(this, _updateColor), (0, $2IZAT._)(this, _updateOpacity), (0, $2IZAT._)(this, _getInitialBBox), (0, $2IZAT._)(this, _setStroke), (0, $2IZAT._)(this, _startDrawing), (0, $2IZAT._)(this, _draw), (0, $2IZAT._)(this, _endPath), (0, $2IZAT._)(this, _stopDrawing), (0, $2IZAT._)(this, _drawPoints), (0, $2IZAT._)(this, _makeBezierCurve), (0, $2IZAT._)(this, _generateBezierPoints), (0, $2IZAT._)(this, _redraw), (0, $2IZAT._)(this, _endDrawing), (0, $2IZAT._)(this, _createCanvas), (0, $2IZAT._)(this, _createObserver), (0, $2IZAT._)(this, _setCanvasDims), (0, $2IZAT._)(this, _setScaleFactor), (0, $2IZAT._)(this, _updateTransform), (0, $2IZAT._)(this, _serializePaths), (0, $2IZAT._)(this, _getBbox), (0, $2IZAT._)(this, _getPadding), (0, $2IZAT._)(this, _fitToContent), (0, $iXPoG._)(this, _baseHeight, {
                            writable: true,
                            value: 0
                        }), (0, $iXPoG._)(this, _baseWidth, {
                            writable: true,
                            value: 0
                        }), (0, $iXPoG._)(this, _boundCanvasPointermove, {
                            writable: true,
                            value: this.canvasPointermove.bind(this)
                        }), (0, $iXPoG._)(this, _boundCanvasPointerleave, {
                            writable: true,
                            value: this.canvasPointerleave.bind(this)
                        }), (0, $iXPoG._)(this, _boundCanvasPointerup, {
                            writable: true,
                            value: this.canvasPointerup.bind(this)
                        }), (0, $iXPoG._)(this, _boundCanvasPointerdown, {
                            writable: true,
                            value: this.canvasPointerdown.bind(this)
                        }), (0, $iXPoG._)(this, _currentPath2D, {
                            writable: true,
                            value: new Path2D()
                        }), (0, $iXPoG._)(this, _disableEditing, {
                            writable: true,
                            value: false
                        }), (0, $iXPoG._)(this, _hasSomethingToDraw, {
                            writable: true,
                            value: false
                        }), (0, $iXPoG._)(this, _isCanvasInitialized, {
                            writable: true,
                            value: false
                        }), (0, $iXPoG._)(this, _observer, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _realWidth, {
                            writable: true,
                            value: 0
                        }), (0, $iXPoG._)(this, _realHeight, {
                            writable: true,
                            value: 0
                        }), (0, $iXPoG._)(this, _requestFrameCallback, {
                            writable: true,
                            value: null
                        });
                        this.color = params.color || null;
                        this.thickness = params.thickness || null;
                        this.opacity = params.opacity || null;
                        this.paths = [];
                        this.bezierPath2D = [];
                        this.allRawPaths = [];
                        this.currentPath = [];
                        this.scaleFactor = 1;
                        this.translationX = this.translationY = 0;
                        this.x = 0;
                        this.y = 0;
                        this._willKeepAspectRatio = true;
                    }
                }
                (0, $yQrT8._)(InkEditor, "_defaultColor", null);
                (0, $yQrT8._)(InkEditor, "_defaultOpacity", 1);
                (0, $yQrT8._)(InkEditor, "_defaultThickness", 1);
                (0, $yQrT8._)(InkEditor, "_type", "ink");
                function updateThickness(thickness) {
                    const savedThickness = this.thickness;
                    this.addCommands({
                        cmd: ()=>{
                            this.thickness = thickness;
                            (0, $hDjZy._)(this, _fitToContent, fitToContent).call(this);
                        },
                        undo: ()=>{
                            this.thickness = savedThickness;
                            (0, $hDjZy._)(this, _fitToContent, fitToContent).call(this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_THICKNESS,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateColor(color) {
                    const savedColor = this.color;
                    this.addCommands({
                        cmd: ()=>{
                            this.color = color;
                            (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        },
                        undo: ()=>{
                            this.color = savedColor;
                            (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_COLOR,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function updateOpacity(opacity) {
                    opacity /= 100;
                    const savedOpacity = this.opacity;
                    this.addCommands({
                        cmd: ()=>{
                            this.opacity = opacity;
                            (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        },
                        undo: ()=>{
                            this.opacity = savedOpacity;
                            (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        },
                        mustExec: true,
                        type: _util.AnnotationEditorParamsType.INK_OPACITY,
                        overwriteIfSameType: true,
                        keepUndo: true
                    });
                }
                function getInitialBBox() {
                    const { parentRotation, parentDimensions: [width, height] } = this;
                    switch(parentRotation){
                        case 90:
                            return [
                                0,
                                height,
                                height,
                                width
                            ];
                        case 180:
                            return [
                                width,
                                height,
                                width,
                                height
                            ];
                        case 270:
                            return [
                                width,
                                0,
                                height,
                                width
                            ];
                        default:
                            return [
                                0,
                                0,
                                width,
                                height
                            ];
                    }
                }
                function setStroke() {
                    const { ctx, color, opacity, thickness, parentScale, scaleFactor } = this;
                    ctx.lineWidth = thickness * parentScale / scaleFactor;
                    ctx.lineCap = "round";
                    ctx.lineJoin = "round";
                    ctx.miterLimit = 10;
                    ctx.strokeStyle = `${color}${(0, _tools.opacityToHex)(opacity)}`;
                }
                function startDrawing(x, y) {
                    this.canvas.addEventListener("contextmenu", _display_utils.noContextMenu);
                    this.canvas.addEventListener("pointerleave", (0, $f2lgg._)(this, _boundCanvasPointerleave));
                    this.canvas.addEventListener("pointermove", (0, $f2lgg._)(this, _boundCanvasPointermove));
                    this.canvas.addEventListener("pointerup", (0, $f2lgg._)(this, _boundCanvasPointerup));
                    this.canvas.removeEventListener("pointerdown", (0, $f2lgg._)(this, _boundCanvasPointerdown));
                    this.isEditing = true;
                    if (!(0, $f2lgg._)(this, _isCanvasInitialized)) {
                        (0, $5grPd._)(this, _isCanvasInitialized, true);
                        (0, $hDjZy._)(this, _setCanvasDims, setCanvasDims).call(this);
                        this.thickness || (this.thickness = InkEditor._defaultThickness);
                        this.color || (this.color = InkEditor._defaultColor || _editor.AnnotationEditor._defaultLineColor);
                        var _this_opacity;
                        (_this_opacity = this.opacity) !== null && _this_opacity !== void 0 ? _this_opacity : this.opacity = InkEditor._defaultOpacity;
                    }
                    this.currentPath.push([
                        x,
                        y
                    ]);
                    (0, $5grPd._)(this, _hasSomethingToDraw, false);
                    (0, $hDjZy._)(this, _setStroke, setStroke).call(this);
                    (0, $5grPd._)(this, _requestFrameCallback, ()=>{
                        (0, $hDjZy._)(this, _drawPoints, drawPoints).call(this);
                        if ((0, $f2lgg._)(this, _requestFrameCallback)) window.requestAnimationFrame((0, $f2lgg._)(this, _requestFrameCallback));
                    });
                    window.requestAnimationFrame((0, $f2lgg._)(this, _requestFrameCallback));
                }
                function draw(x, y) {
                    const [lastX, lastY] = this.currentPath.at(-1);
                    if (this.currentPath.length > 1 && x === lastX && y === lastY) return;
                    const currentPath = this.currentPath;
                    let path2D = (0, $f2lgg._)(this, _currentPath2D);
                    currentPath.push([
                        x,
                        y
                    ]);
                    (0, $5grPd._)(this, _hasSomethingToDraw, true);
                    if (currentPath.length <= 2) {
                        path2D.moveTo(...currentPath[0]);
                        path2D.lineTo(x, y);
                        return;
                    }
                    if (currentPath.length === 3) {
                        (0, $5grPd._)(this, _currentPath2D, path2D = new Path2D());
                        path2D.moveTo(...currentPath[0]);
                    }
                    (0, $hDjZy._)(this, _makeBezierCurve, makeBezierCurve).call(this, path2D, ...currentPath.at(-3), ...currentPath.at(-2), x, y);
                }
                function endPath() {
                    if (this.currentPath.length === 0) return;
                    const lastPoint = this.currentPath.at(-1);
                    (0, $f2lgg._)(this, _currentPath2D).lineTo(...lastPoint);
                }
                function stopDrawing(x, y) {
                    (0, $5grPd._)(this, _requestFrameCallback, null);
                    x = Math.min(Math.max(x, 0), this.canvas.width);
                    y = Math.min(Math.max(y, 0), this.canvas.height);
                    (0, $hDjZy._)(this, _draw, draw).call(this, x, y);
                    (0, $hDjZy._)(this, _endPath, endPath).call(this);
                    let bezier;
                    if (this.currentPath.length !== 1) bezier = (0, $hDjZy._)(this, _generateBezierPoints, generateBezierPoints).call(this);
                    else {
                        const xy = [
                            x,
                            y
                        ];
                        bezier = [
                            [
                                xy,
                                xy.slice(),
                                xy.slice(),
                                xy
                            ]
                        ];
                    }
                    const path2D = (0, $f2lgg._)(this, _currentPath2D);
                    const currentPath = this.currentPath;
                    this.currentPath = [];
                    (0, $5grPd._)(this, _currentPath2D, new Path2D());
                    const cmd = ()=>{
                        this.allRawPaths.push(currentPath);
                        this.paths.push(bezier);
                        this.bezierPath2D.push(path2D);
                        this.rebuild();
                    };
                    const undo = ()=>{
                        this.allRawPaths.pop();
                        this.paths.pop();
                        this.bezierPath2D.pop();
                        if (this.paths.length === 0) this.remove();
                        else {
                            if (!this.canvas) {
                                (0, $hDjZy._)(this, _createCanvas, createCanvas).call(this);
                                (0, $hDjZy._)(this, _createObserver, createObserver).call(this);
                            }
                            (0, $hDjZy._)(this, _fitToContent, fitToContent).call(this);
                        }
                    };
                    this.addCommands({
                        cmd: cmd,
                        undo: undo,
                        mustExec: true
                    });
                }
                function drawPoints() {
                    if (!(0, $f2lgg._)(this, _hasSomethingToDraw)) return;
                    (0, $5grPd._)(this, _hasSomethingToDraw, false);
                    const thickness = Math.ceil(this.thickness * this.parentScale);
                    const lastPoints = this.currentPath.slice(-3);
                    const x = lastPoints.map((xy)=>xy[0]);
                    const y = lastPoints.map((xy)=>xy[1]);
                    const xMin = Math.min(...x) - thickness;
                    const xMax = Math.max(...x) + thickness;
                    const yMin = Math.min(...y) - thickness;
                    const yMax = Math.max(...y) + thickness;
                    const { ctx } = this;
                    ctx.save();
                    ctx.clearRect(0, 0, this.canvas.width, this.canvas.height);
                    for (const path of this.bezierPath2D)ctx.stroke(path);
                    ctx.stroke((0, $f2lgg._)(this, _currentPath2D));
                    ctx.restore();
                }
                function makeBezierCurve(path2D, x0, y0, x1, y1, x2, y2) {
                    const prevX = (x0 + x1) / 2;
                    const prevY = (y0 + y1) / 2;
                    const x3 = (x1 + x2) / 2;
                    const y3 = (y1 + y2) / 2;
                    path2D.bezierCurveTo(prevX + 2 * (x1 - prevX) / 3, prevY + 2 * (y1 - prevY) / 3, x3 + 2 * (x1 - x3) / 3, y3 + 2 * (y1 - y3) / 3, x3, y3);
                }
                function generateBezierPoints() {
                    const path = this.currentPath;
                    if (path.length <= 2) return [
                        [
                            path[0],
                            path[0],
                            path.at(-1),
                            path.at(-1)
                        ]
                    ];
                    const bezierPoints = [];
                    let i;
                    let [x0, y0] = path[0];
                    for(i = 1; i < path.length - 2; i++){
                        const [x1, y1] = path[i];
                        const [x2, y2] = path[i + 1];
                        const x3 = (x1 + x2) / 2;
                        const y3 = (y1 + y2) / 2;
                        const control1 = [
                            x0 + 2 * (x1 - x0) / 3,
                            y0 + 2 * (y1 - y0) / 3
                        ];
                        const control2 = [
                            x3 + 2 * (x1 - x3) / 3,
                            y3 + 2 * (y1 - y3) / 3
                        ];
                        bezierPoints.push([
                            [
                                x0,
                                y0
                            ],
                            control1,
                            control2,
                            [
                                x3,
                                y3
                            ]
                        ]);
                        [x0, y0] = [
                            x3,
                            y3
                        ];
                    }
                    const [x1, y1] = path[i];
                    const [x2, y2] = path[i + 1];
                    const control1 = [
                        x0 + 2 * (x1 - x0) / 3,
                        y0 + 2 * (y1 - y0) / 3
                    ];
                    const control2 = [
                        x2 + 2 * (x1 - x2) / 3,
                        y2 + 2 * (y1 - y2) / 3
                    ];
                    bezierPoints.push([
                        [
                            x0,
                            y0
                        ],
                        control1,
                        control2,
                        [
                            x2,
                            y2
                        ]
                    ]);
                    return bezierPoints;
                }
                function redraw() {
                    if (this.isEmpty()) {
                        (0, $hDjZy._)(this, _updateTransform, updateTransform).call(this);
                        return;
                    }
                    (0, $hDjZy._)(this, _setStroke, setStroke).call(this);
                    const { canvas, ctx } = this;
                    ctx.setTransform(1, 0, 0, 1, 0, 0);
                    ctx.clearRect(0, 0, canvas.width, canvas.height);
                    (0, $hDjZy._)(this, _updateTransform, updateTransform).call(this);
                    for (const path of this.bezierPath2D)ctx.stroke(path);
                }
                function endDrawing(event) {
                    this.canvas.removeEventListener("pointerleave", (0, $f2lgg._)(this, _boundCanvasPointerleave));
                    this.canvas.removeEventListener("pointermove", (0, $f2lgg._)(this, _boundCanvasPointermove));
                    this.canvas.removeEventListener("pointerup", (0, $f2lgg._)(this, _boundCanvasPointerup));
                    this.canvas.addEventListener("pointerdown", (0, $f2lgg._)(this, _boundCanvasPointerdown));
                    setTimeout(()=>{
                        this.canvas.removeEventListener("contextmenu", _display_utils.noContextMenu);
                    }, 10);
                    (0, $hDjZy._)(this, _stopDrawing, stopDrawing).call(this, event.offsetX, event.offsetY);
                    this.addToAnnotationStorage();
                    this.setInBackground();
                }
                function createCanvas() {
                    this.canvas = document.createElement("canvas");
                    this.canvas.width = this.canvas.height = 0;
                    this.canvas.className = "inkEditorCanvas";
                    _editor.AnnotationEditor._l10nPromise.get("editor_ink_canvas_aria_label").then((msg)=>{
                        var _this_canvas;
                        return (_this_canvas = this.canvas) === null || _this_canvas === void 0 ? void 0 : _this_canvas.setAttribute("aria-label", msg);
                    });
                    this.div.append(this.canvas);
                    this.ctx = this.canvas.getContext("2d");
                }
                function createObserver() {
                    (0, $5grPd._)(this, _observer, new ResizeObserver((entries)=>{
                        const rect = entries[0].contentRect;
                        if (rect.width && rect.height) this.setDimensions(rect.width, rect.height);
                    }));
                    (0, $f2lgg._)(this, _observer).observe(this.div);
                }
                function setCanvasDims() {
                    if (!(0, $f2lgg._)(this, _isCanvasInitialized)) return;
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.canvas.width = Math.ceil(this.width * parentWidth);
                    this.canvas.height = Math.ceil(this.height * parentHeight);
                    (0, $hDjZy._)(this, _updateTransform, updateTransform).call(this);
                }
                function setScaleFactor(width, height) {
                    const padding = (0, $hDjZy._)(this, _getPadding, getPadding).call(this);
                    const scaleFactorW = (width - padding) / (0, $f2lgg._)(this, _baseWidth);
                    const scaleFactorH = (height - padding) / (0, $f2lgg._)(this, _baseHeight);
                    this.scaleFactor = Math.min(scaleFactorW, scaleFactorH);
                }
                function updateTransform() {
                    const padding = (0, $hDjZy._)(this, _getPadding, getPadding).call(this) / 2;
                    this.ctx.setTransform(this.scaleFactor, 0, 0, this.scaleFactor, this.translationX * this.scaleFactor + padding, this.translationY * this.scaleFactor + padding);
                }
                function buildPath2D(bezier) {
                    const path2D = new Path2D();
                    for(let i = 0, ii = bezier.length; i < ii; i++){
                        const [first, control1, control2, second] = bezier[i];
                        if (i === 0) path2D.moveTo(...first);
                        path2D.bezierCurveTo(control1[0], control1[1], control2[0], control2[1], second[0], second[1]);
                    }
                    return path2D;
                }
                function toPDFCoordinates(points, rect, rotation) {
                    const [blX, blY, trX, trY] = rect;
                    switch(rotation){
                        case 0:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                points[i] += blX;
                                points[i + 1] = trY - points[i + 1];
                            }
                            break;
                        case 90:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                const x = points[i];
                                points[i] = points[i + 1] + blX;
                                points[i + 1] = x + blY;
                            }
                            break;
                        case 180:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                points[i] = trX - points[i];
                                points[i + 1] += blY;
                            }
                            break;
                        case 270:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                const x = points[i];
                                points[i] = trX - points[i + 1];
                                points[i + 1] = trY - x;
                            }
                            break;
                        default:
                            throw new Error("Invalid rotation");
                    }
                    return points;
                }
                function fromPDFCoordinates(points, rect, rotation) {
                    const [blX, blY, trX, trY] = rect;
                    switch(rotation){
                        case 0:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                points[i] -= blX;
                                points[i + 1] = trY - points[i + 1];
                            }
                            break;
                        case 90:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                const x = points[i];
                                points[i] = points[i + 1] - blY;
                                points[i + 1] = x - blX;
                            }
                            break;
                        case 180:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                points[i] = trX - points[i];
                                points[i + 1] -= blY;
                            }
                            break;
                        case 270:
                            for(let i = 0, ii = points.length; i < ii; i += 2){
                                const x = points[i];
                                points[i] = trY - points[i + 1];
                                points[i + 1] = trX - x;
                            }
                            break;
                        default:
                            throw new Error("Invalid rotation");
                    }
                    return points;
                }
                function serializePaths(s, tx, ty, rect) {
                    const paths = [];
                    const padding = this.thickness / 2;
                    const shiftX = s * tx + padding;
                    const shiftY = s * ty + padding;
                    for (const bezier of this.paths){
                        const buffer = [];
                        const points = [];
                        for(let j = 0, jj = bezier.length; j < jj; j++){
                            const [first, control1, control2, second] = bezier[j];
                            const p10 = s * first[0] + shiftX;
                            const p11 = s * first[1] + shiftY;
                            const p20 = s * control1[0] + shiftX;
                            const p21 = s * control1[1] + shiftY;
                            const p30 = s * control2[0] + shiftX;
                            const p31 = s * control2[1] + shiftY;
                            const p40 = s * second[0] + shiftX;
                            const p41 = s * second[1] + shiftY;
                            if (j === 0) {
                                buffer.push(p10, p11);
                                points.push(p10, p11);
                            }
                            buffer.push(p20, p21, p30, p31, p40, p41);
                            points.push(p20, p21);
                            if (j === jj - 1) points.push(p40, p41);
                        }
                        paths.push({
                            bezier: (0, $a36Ks._)(InkEditor, InkEditor, toPDFCoordinates).call(InkEditor, buffer, rect, this.rotation),
                            points: (0, $a36Ks._)(InkEditor, InkEditor, toPDFCoordinates).call(InkEditor, points, rect, this.rotation)
                        });
                    }
                    return paths;
                }
                function getBbox() {
                    let xMin = Infinity;
                    let xMax = -Infinity;
                    let yMin = Infinity;
                    let yMax = -Infinity;
                    for (const path of this.paths)for (const [first, control1, control2, second] of path){
                        const bbox = _util.Util.bezierBoundingBox(...first, ...control1, ...control2, ...second);
                        xMin = Math.min(xMin, bbox[0]);
                        yMin = Math.min(yMin, bbox[1]);
                        xMax = Math.max(xMax, bbox[2]);
                        yMax = Math.max(yMax, bbox[3]);
                    }
                    return [
                        xMin,
                        yMin,
                        xMax,
                        yMax
                    ];
                }
                function getPadding() {
                    return (0, $f2lgg._)(this, _disableEditing) ? Math.ceil(this.thickness * this.parentScale) : 0;
                }
                function fitToContent(firstTime = false) {
                    if (this.isEmpty()) return;
                    if (!(0, $f2lgg._)(this, _disableEditing)) {
                        (0, $hDjZy._)(this, _redraw, redraw).call(this);
                        return;
                    }
                    const bbox = (0, $hDjZy._)(this, _getBbox, getBbox).call(this);
                    const padding = (0, $hDjZy._)(this, _getPadding, getPadding).call(this);
                    (0, $5grPd._)(this, _baseWidth, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[2] - bbox[0]));
                    (0, $5grPd._)(this, _baseHeight, Math.max(_editor.AnnotationEditor.MIN_SIZE, bbox[3] - bbox[1]));
                    const width = Math.ceil(padding + (0, $f2lgg._)(this, _baseWidth) * this.scaleFactor);
                    const height = Math.ceil(padding + (0, $f2lgg._)(this, _baseHeight) * this.scaleFactor);
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.width = width / parentWidth;
                    this.height = height / parentHeight;
                    this.setAspectRatio(width, height);
                    const prevTranslationX = this.translationX;
                    const prevTranslationY = this.translationY;
                    this.translationX = -bbox[0];
                    this.translationY = -bbox[1];
                    (0, $hDjZy._)(this, _setCanvasDims, setCanvasDims).call(this);
                    (0, $hDjZy._)(this, _redraw, redraw).call(this);
                    (0, $5grPd._)(this, _realWidth, width);
                    (0, $5grPd._)(this, _realHeight, height);
                    this.setDims(width, height);
                    const unscaledPadding = firstTime ? padding / this.scaleFactor / 2 : 0;
                    this.translate(prevTranslationX - this.translationX - unscaledPadding, prevTranslationY - this.translationY - unscaledPadding);
                }
                exports.InkEditor = InkEditor;
            /***/ },
            /* 34 */ /***/ (__unused_webpack_module, exports, __w_pdfjs_require__)=>{
                Object.defineProperty(exports, "__esModule", {
                    value: true
                });
                exports.StampEditor = void 0;
                var _util = __w_pdfjs_require__(1);
                var _editor = __w_pdfjs_require__(4);
                var _display_utils = __w_pdfjs_require__(6);
                var _annotation_layer = __w_pdfjs_require__(29);
                var _bitmap = /*#__PURE__*/ new WeakMap(), _bitmapId = /*#__PURE__*/ new WeakMap(), _bitmapPromise = /*#__PURE__*/ new WeakMap(), _bitmapUrl = /*#__PURE__*/ new WeakMap(), _bitmapFile = /*#__PURE__*/ new WeakMap(), _canvas = /*#__PURE__*/ new WeakMap(), _observer = /*#__PURE__*/ new WeakMap(), _resizeTimeoutId = /*#__PURE__*/ new WeakMap(), _isSvg = /*#__PURE__*/ new WeakMap(), _hasBeenAddedInUndoStack = /*#__PURE__*/ new WeakMap(), _editor_AnnotationEditor, _getBitmapFetched = /*#__PURE__*/ new WeakSet(), _getBitmapDone = /*#__PURE__*/ new WeakSet(), _getBitmap = /*#__PURE__*/ new WeakSet(), _createCanvas = /*#__PURE__*/ new WeakSet(), _setDimensions = /*#__PURE__*/ new WeakSet(), _scaleBitmap = /*#__PURE__*/ new WeakSet(), _drawBitmap = /*#__PURE__*/ new WeakSet(), _serializeBitmap = /*#__PURE__*/ new WeakSet(), _createObserver = /*#__PURE__*/ new WeakSet();
                class StampEditor extends (_editor_AnnotationEditor = _editor.AnnotationEditor) {
                    static initialize(l10n) {
                        _editor.AnnotationEditor.initialize(l10n);
                    }
                    static get supportedTypes() {
                        const types = [
                            "apng",
                            "avif",
                            "bmp",
                            "gif",
                            "jpeg",
                            "png",
                            "svg+xml",
                            "webp",
                            "x-icon"
                        ];
                        return (0, _util.shadow)(this, "supportedTypes", types.map((type)=>`image/${type}`));
                    }
                    static get supportedTypesStr() {
                        return (0, _util.shadow)(this, "supportedTypesStr", this.supportedTypes.join(","));
                    }
                    static isHandlingMimeForPasting(mime) {
                        return this.supportedTypes.includes(mime);
                    }
                    static paste(item, parent) {
                        parent.pasteEditor(_util.AnnotationEditorType.STAMP, {
                            bitmapFile: item.getAsFile()
                        });
                    }
                    remove() {
                        if ((0, $f2lgg._)(this, _bitmapId)) {
                            var _class_private_field_get1, _class_private_field_get2;
                            (0, $5grPd._)(this, _bitmap, null);
                            this._uiManager.imageManager.deleteId((0, $f2lgg._)(this, _bitmapId));
                            (_class_private_field_get1 = (0, $f2lgg._)(this, _canvas)) === null || _class_private_field_get1 === void 0 ? void 0 : _class_private_field_get1.remove();
                            (0, $5grPd._)(this, _canvas, null);
                            (_class_private_field_get2 = (0, $f2lgg._)(this, _observer)) === null || _class_private_field_get2 === void 0 ? void 0 : _class_private_field_get2.disconnect();
                            (0, $5grPd._)(this, _observer, null);
                        }
                        super.remove();
                    }
                    rebuild() {
                        if (!this.parent) {
                            if ((0, $f2lgg._)(this, _bitmapId)) (0, $hDjZy._)(this, _getBitmap, getBitmap).call(this);
                            return;
                        }
                        super.rebuild();
                        if (this.div === null) return;
                        if ((0, $f2lgg._)(this, _bitmapId)) (0, $hDjZy._)(this, _getBitmap, getBitmap).call(this);
                        if (!this.isAttachedToDOM) this.parent.add(this);
                    }
                    onceAdded() {
                        this._isDraggable = true;
                        this.div.focus();
                    }
                    isEmpty() {
                        return !((0, $f2lgg._)(this, _bitmapPromise) || (0, $f2lgg._)(this, _bitmap) || (0, $f2lgg._)(this, _bitmapUrl) || (0, $f2lgg._)(this, _bitmapFile));
                    }
                    get isResizable() {
                        return true;
                    }
                    render() {
                        if (this.div) return this.div;
                        let baseX, baseY;
                        if (this.width) {
                            baseX = this.x;
                            baseY = this.y;
                        }
                        super.render();
                        this.div.hidden = true;
                        if ((0, $f2lgg._)(this, _bitmap)) (0, $hDjZy._)(this, _createCanvas, createCanvas).call(this);
                        else (0, $hDjZy._)(this, _getBitmap, getBitmap).call(this);
                        if (this.width) {
                            const [parentWidth, parentHeight] = this.parentDimensions;
                            this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
                        }
                        return this.div;
                    }
                    static deserialize(data, parent, uiManager) {
                        if (data instanceof _annotation_layer.StampAnnotationElement) return null;
                        const editor = super.deserialize(data, parent, uiManager);
                        const { rect, bitmapUrl, bitmapId, isSvg, accessibilityData } = data;
                        if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) (0, $5grPd._)(editor, _bitmapId, bitmapId);
                        else (0, $5grPd._)(editor, _bitmapUrl, bitmapUrl);
                        (0, $5grPd._)(editor, _isSvg, isSvg);
                        const [parentWidth, parentHeight] = editor.pageDimensions;
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        if (accessibilityData) editor.altTextData = accessibilityData;
                        return editor;
                    }
                    serialize(isForCopying = false, context = null) {
                        var _context;
                        if (this.isEmpty()) return null;
                        const serialized = {
                            annotationType: _util.AnnotationEditorType.STAMP,
                            bitmapId: (0, $f2lgg._)(this, _bitmapId),
                            pageIndex: this.pageIndex,
                            rect: this.getRect(0, 0),
                            rotation: this.rotation,
                            isSvg: (0, $f2lgg._)(this, _isSvg),
                            structTreeParentId: this._structTreeParentId
                        };
                        if (isForCopying) {
                            serialized.bitmapUrl = (0, $hDjZy._)(this, _serializeBitmap, serializeBitmap).call(this, true);
                            serialized.accessibilityData = this.altTextData;
                            return serialized;
                        }
                        const { decorative, altText } = this.altTextData;
                        if (!decorative && altText) serialized.accessibilityData = {
                            type: "Figure",
                            alt: altText
                        };
                        if (context === null) return serialized;
                        (_context = context).stamps || (_context.stamps = new Map());
                        const area = (0, $f2lgg._)(this, _isSvg) ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
                        if (!context.stamps.has((0, $f2lgg._)(this, _bitmapId))) {
                            context.stamps.set((0, $f2lgg._)(this, _bitmapId), {
                                area: area,
                                serialized: serialized
                            });
                            serialized.bitmap = (0, $hDjZy._)(this, _serializeBitmap, serializeBitmap).call(this, false);
                        } else if ((0, $f2lgg._)(this, _isSvg)) {
                            const prevData = context.stamps.get((0, $f2lgg._)(this, _bitmapId));
                            if (area > prevData.area) {
                                prevData.area = area;
                                prevData.serialized.bitmap.close();
                                prevData.serialized.bitmap = (0, $hDjZy._)(this, _serializeBitmap, serializeBitmap).call(this, false);
                            }
                        }
                        return serialized;
                    }
                    constructor(params){
                        super((0, $7d4tS._)((0, $cTSGB._)({}, params), {
                            name: "stampEditor"
                        })), (0, $2IZAT._)(this, _getBitmapFetched), (0, $2IZAT._)(this, _getBitmapDone), (0, $2IZAT._)(this, _getBitmap), (0, $2IZAT._)(this, _createCanvas), (0, $2IZAT._)(this, _setDimensions), (0, $2IZAT._)(this, _scaleBitmap), (0, $2IZAT._)(this, _drawBitmap), (0, $2IZAT._)(this, _serializeBitmap), (0, $2IZAT._)(this, _createObserver), (0, $iXPoG._)(this, _bitmap, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _bitmapId, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _bitmapPromise, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _bitmapUrl, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _bitmapFile, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _canvas, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _observer, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _resizeTimeoutId, {
                            writable: true,
                            value: null
                        }), (0, $iXPoG._)(this, _isSvg, {
                            writable: true,
                            value: false
                        }), (0, $iXPoG._)(this, _hasBeenAddedInUndoStack, {
                            writable: true,
                            value: false
                        });
                        (0, $5grPd._)(this, _bitmapUrl, params.bitmapUrl);
                        (0, $5grPd._)(this, _bitmapFile, params.bitmapFile);
                    }
                }
                (0, $yQrT8._)(StampEditor, "_type", "stamp");
                function getBitmapFetched(data, fromId = false) {
                    if (!data) {
                        this.remove();
                        return;
                    }
                    (0, $5grPd._)(this, _bitmap, data.bitmap);
                    if (!fromId) {
                        (0, $5grPd._)(this, _bitmapId, data.id);
                        (0, $5grPd._)(this, _isSvg, data.isSvg);
                    }
                    (0, $hDjZy._)(this, _createCanvas, createCanvas).call(this);
                }
                function getBitmapDone() {
                    (0, $5grPd._)(this, _bitmapPromise, null);
                    this._uiManager.enableWaiting(false);
                    if ((0, $f2lgg._)(this, _canvas)) this.div.focus();
                }
                function getBitmap() {
                    if ((0, $f2lgg._)(this, _bitmapId)) {
                        this._uiManager.enableWaiting(true);
                        this._uiManager.imageManager.getFromId((0, $f2lgg._)(this, _bitmapId)).then((data)=>(0, $hDjZy._)(this, _getBitmapFetched, getBitmapFetched).call(this, data, true)).finally(()=>(0, $hDjZy._)(this, _getBitmapDone, getBitmapDone).call(this));
                        return;
                    }
                    if ((0, $f2lgg._)(this, _bitmapUrl)) {
                        const url = (0, $f2lgg._)(this, _bitmapUrl);
                        (0, $5grPd._)(this, _bitmapUrl, null);
                        this._uiManager.enableWaiting(true);
                        (0, $5grPd._)(this, _bitmapPromise, this._uiManager.imageManager.getFromUrl(url).then((data)=>(0, $hDjZy._)(this, _getBitmapFetched, getBitmapFetched).call(this, data)).finally(()=>(0, $hDjZy._)(this, _getBitmapDone, getBitmapDone).call(this)));
                        return;
                    }
                    if ((0, $f2lgg._)(this, _bitmapFile)) {
                        const file = (0, $f2lgg._)(this, _bitmapFile);
                        (0, $5grPd._)(this, _bitmapFile, null);
                        this._uiManager.enableWaiting(true);
                        (0, $5grPd._)(this, _bitmapPromise, this._uiManager.imageManager.getFromFile(file).then((data)=>(0, $hDjZy._)(this, _getBitmapFetched, getBitmapFetched).call(this, data)).finally(()=>(0, $hDjZy._)(this, _getBitmapDone, getBitmapDone).call(this)));
                        return;
                    }
                    const input = document.createElement("input");
                    input.type = "file";
                    input.accept = StampEditor.supportedTypesStr;
                    (0, $5grPd._)(this, _bitmapPromise, new Promise((resolve)=>{
                        input.addEventListener("change", ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                                if (!input.files || input.files.length === 0) this.remove();
                                else {
                                    this._uiManager.enableWaiting(true);
                                    const data = yield this._uiManager.imageManager.getFromFile(input.files[0]);
                                    (0, $hDjZy._)(this, _getBitmapFetched, getBitmapFetched).call(this, data);
                                }
                                resolve();
                            }).call(this));
                        input.addEventListener("cancel", ()=>{
                            this.remove();
                            resolve();
                        });
                    }).finally(()=>(0, $hDjZy._)(this, _getBitmapDone, getBitmapDone).call(this)));
                    input.click();
                }
                function createCanvas() {
                    const { div } = this;
                    let { width, height } = (0, $f2lgg._)(this, _bitmap);
                    const [pageWidth, pageHeight] = this.pageDimensions;
                    const MAX_RATIO = 0.75;
                    if (this.width) {
                        width = this.width * pageWidth;
                        height = this.height * pageHeight;
                    } else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
                        const factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
                        width *= factor;
                        height *= factor;
                    }
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
                    this._uiManager.enableWaiting(false);
                    const canvas = (0, $5grPd._)(this, _canvas, document.createElement("canvas"));
                    div.append(canvas);
                    div.hidden = false;
                    (0, $hDjZy._)(this, _drawBitmap, drawBitmap).call(this, width, height);
                    (0, $hDjZy._)(this, _createObserver, createObserver).call(this);
                    if (!(0, $f2lgg._)(this, _hasBeenAddedInUndoStack)) {
                        this.parent.addUndoableEditor(this);
                        (0, $5grPd._)(this, _hasBeenAddedInUndoStack, true);
                    }
                    this._uiManager._eventBus.dispatch("reporttelemetry", {
                        source: this,
                        details: {
                            type: "editing",
                            subtype: this.editorType,
                            data: {
                                action: "inserted_image"
                            }
                        }
                    });
                    this.addAltTextButton();
                }
                function setDimensions(width, height) {
                    var _this__initialOptions;
                    const [parentWidth, parentHeight] = this.parentDimensions;
                    this.width = width / parentWidth;
                    this.height = height / parentHeight;
                    this.setDims(width, height);
                    if ((_this__initialOptions = this._initialOptions) === null || _this__initialOptions === void 0 ? void 0 : _this__initialOptions.isCentered) this.center();
                    else this.fixAndSetPosition();
                    this._initialOptions = null;
                    if ((0, $f2lgg._)(this, _resizeTimeoutId) !== null) clearTimeout((0, $f2lgg._)(this, _resizeTimeoutId));
                    const TIME_TO_WAIT = 200;
                    (0, $5grPd._)(this, _resizeTimeoutId, setTimeout(()=>{
                        (0, $5grPd._)(this, _resizeTimeoutId, null);
                        (0, $hDjZy._)(this, _drawBitmap, drawBitmap).call(this, width, height);
                    }, TIME_TO_WAIT));
                }
                function scaleBitmap(width, height) {
                    const { width: bitmapWidth, height: bitmapHeight } = (0, $f2lgg._)(this, _bitmap);
                    let newWidth = bitmapWidth;
                    let newHeight = bitmapHeight;
                    let bitmap = (0, $f2lgg._)(this, _bitmap);
                    while(newWidth > 2 * width || newHeight > 2 * height){
                        const prevWidth = newWidth;
                        const prevHeight = newHeight;
                        if (newWidth > 2 * width) newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
                        if (newHeight > 2 * height) newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
                        const offscreen = new OffscreenCanvas(newWidth, newHeight);
                        const ctx = offscreen.getContext("2d");
                        ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                        bitmap = offscreen.transferToImageBitmap();
                    }
                    return bitmap;
                }
                function drawBitmap(width, height) {
                    width = Math.ceil(width);
                    height = Math.ceil(height);
                    const canvas = (0, $f2lgg._)(this, _canvas);
                    if (!canvas || canvas.width === width && canvas.height === height) return;
                    canvas.width = width;
                    canvas.height = height;
                    const bitmap = (0, $f2lgg._)(this, _isSvg) ? (0, $f2lgg._)(this, _bitmap) : (0, $hDjZy._)(this, _scaleBitmap, scaleBitmap).call(this, width, height);
                    const ctx = canvas.getContext("2d");
                    ctx.filter = this._uiManager.hcmFilter;
                    ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, width, height);
                }
                function serializeBitmap(toUrl) {
                    if (toUrl) {
                        if ((0, $f2lgg._)(this, _isSvg)) {
                            const url = this._uiManager.imageManager.getSvgUrl((0, $f2lgg._)(this, _bitmapId));
                            if (url) return url;
                        }
                        const canvas = document.createElement("canvas");
                        ({ width: canvas.width, height: canvas.height } = (0, $f2lgg._)(this, _bitmap));
                        const ctx = canvas.getContext("2d");
                        ctx.drawImage((0, $f2lgg._)(this, _bitmap), 0, 0);
                        return canvas.toDataURL();
                    }
                    if ((0, $f2lgg._)(this, _isSvg)) {
                        const [pageWidth, pageHeight] = this.pageDimensions;
                        const width = Math.round(this.width * pageWidth * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                        const height = Math.round(this.height * pageHeight * _display_utils.PixelsPerInch.PDF_TO_CSS_UNITS);
                        const offscreen = new OffscreenCanvas(width, height);
                        const ctx = offscreen.getContext("2d");
                        ctx.drawImage((0, $f2lgg._)(this, _bitmap), 0, 0, (0, $f2lgg._)(this, _bitmap).width, (0, $f2lgg._)(this, _bitmap).height, 0, 0, width, height);
                        return offscreen.transferToImageBitmap();
                    }
                    return structuredClone((0, $f2lgg._)(this, _bitmap));
                }
                function createObserver() {
                    (0, $5grPd._)(this, _observer, new ResizeObserver((entries)=>{
                        const rect = entries[0].contentRect;
                        if (rect.width && rect.height) (0, $hDjZy._)(this, _setDimensions, setDimensions).call(this, rect.width, rect.height);
                    }));
                    (0, $f2lgg._)(this, _observer).observe(this.div);
                }
                exports.StampEditor = StampEditor;
            /***/ }
        ];
        /************************************************************************/ /******/ // The module cache
        /******/ var __webpack_module_cache__ = {};
        /******/ /******/ // The require function
        /******/ function __w_pdfjs_require__(moduleId) {
            /******/ // Check if module is in cache
            /******/ var cachedModule = __webpack_module_cache__[moduleId];
            /******/ if (cachedModule !== undefined) /******/ return cachedModule.exports;
            /******/ // Create a new module (and put it into the cache)
            /******/ var module1 = __webpack_module_cache__[moduleId] = {
                /******/ // no module.id needed
                /******/ // no module.loaded needed
                /******/ exports: {}
            };
            /******/ /******/ // Execute the module function
            /******/ __webpack_modules__[moduleId](module1, module1.exports, __w_pdfjs_require__);
            /******/ /******/ // Return the exports of the module
            /******/ return module1.exports;
        /******/ }
        /******/ /************************************************************************/ var __webpack_exports__ = {};
        // This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
        (()=>{
            var exports = __webpack_exports__;
            Object.defineProperty(exports, "__esModule", {
                value: true
            });
            Object.defineProperty(exports, "AbortException", {
                enumerable: true,
                get: function() {
                    return _util.AbortException;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_editor_layer.AnnotationEditorLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorParamsType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorParamsType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorType", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationEditorType;
                }
            });
            Object.defineProperty(exports, "AnnotationEditorUIManager", {
                enumerable: true,
                get: function() {
                    return _tools.AnnotationEditorUIManager;
                }
            });
            Object.defineProperty(exports, "AnnotationLayer", {
                enumerable: true,
                get: function() {
                    return _annotation_layer.AnnotationLayer;
                }
            });
            Object.defineProperty(exports, "AnnotationMode", {
                enumerable: true,
                get: function() {
                    return _util.AnnotationMode;
                }
            });
            Object.defineProperty(exports, "CMapCompressionType", {
                enumerable: true,
                get: function() {
                    return _util.CMapCompressionType;
                }
            });
            Object.defineProperty(exports, "DOMSVGFactory", {
                enumerable: true,
                get: function() {
                    return _display_utils.DOMSVGFactory;
                }
            });
            Object.defineProperty(exports, "FeatureTest", {
                enumerable: true,
                get: function() {
                    return _util.FeatureTest;
                }
            });
            Object.defineProperty(exports, "GlobalWorkerOptions", {
                enumerable: true,
                get: function() {
                    return _worker_options.GlobalWorkerOptions;
                }
            });
            Object.defineProperty(exports, "ImageKind", {
                enumerable: true,
                get: function() {
                    return _util.ImageKind;
                }
            });
            Object.defineProperty(exports, "InvalidPDFException", {
                enumerable: true,
                get: function() {
                    return _util.InvalidPDFException;
                }
            });
            Object.defineProperty(exports, "MissingPDFException", {
                enumerable: true,
                get: function() {
                    return _util.MissingPDFException;
                }
            });
            Object.defineProperty(exports, "OPS", {
                enumerable: true,
                get: function() {
                    return _util.OPS;
                }
            });
            Object.defineProperty(exports, "PDFDataRangeTransport", {
                enumerable: true,
                get: function() {
                    return _api.PDFDataRangeTransport;
                }
            });
            Object.defineProperty(exports, "PDFDateString", {
                enumerable: true,
                get: function() {
                    return _display_utils.PDFDateString;
                }
            });
            Object.defineProperty(exports, "PDFWorker", {
                enumerable: true,
                get: function() {
                    return _api.PDFWorker;
                }
            });
            Object.defineProperty(exports, "PasswordResponses", {
                enumerable: true,
                get: function() {
                    return _util.PasswordResponses;
                }
            });
            Object.defineProperty(exports, "PermissionFlag", {
                enumerable: true,
                get: function() {
                    return _util.PermissionFlag;
                }
            });
            Object.defineProperty(exports, "PixelsPerInch", {
                enumerable: true,
                get: function() {
                    return _display_utils.PixelsPerInch;
                }
            });
            Object.defineProperty(exports, "PromiseCapability", {
                enumerable: true,
                get: function() {
                    return _util.PromiseCapability;
                }
            });
            Object.defineProperty(exports, "RenderingCancelledException", {
                enumerable: true,
                get: function() {
                    return _display_utils.RenderingCancelledException;
                }
            });
            Object.defineProperty(exports, "SVGGraphics", {
                enumerable: true,
                get: function() {
                    return _api.SVGGraphics;
                }
            });
            Object.defineProperty(exports, "UnexpectedResponseException", {
                enumerable: true,
                get: function() {
                    return _util.UnexpectedResponseException;
                }
            });
            Object.defineProperty(exports, "Util", {
                enumerable: true,
                get: function() {
                    return _util.Util;
                }
            });
            Object.defineProperty(exports, "VerbosityLevel", {
                enumerable: true,
                get: function() {
                    return _util.VerbosityLevel;
                }
            });
            Object.defineProperty(exports, "XfaLayer", {
                enumerable: true,
                get: function() {
                    return _xfa_layer.XfaLayer;
                }
            });
            Object.defineProperty(exports, "build", {
                enumerable: true,
                get: function() {
                    return _api.build;
                }
            });
            Object.defineProperty(exports, "createValidAbsoluteUrl", {
                enumerable: true,
                get: function() {
                    return _util.createValidAbsoluteUrl;
                }
            });
            Object.defineProperty(exports, "getDocument", {
                enumerable: true,
                get: function() {
                    return _api.getDocument;
                }
            });
            Object.defineProperty(exports, "getFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getPdfFilenameFromUrl", {
                enumerable: true,
                get: function() {
                    return _display_utils.getPdfFilenameFromUrl;
                }
            });
            Object.defineProperty(exports, "getXfaPageViewport", {
                enumerable: true,
                get: function() {
                    return _display_utils.getXfaPageViewport;
                }
            });
            Object.defineProperty(exports, "isDataScheme", {
                enumerable: true,
                get: function() {
                    return _display_utils.isDataScheme;
                }
            });
            Object.defineProperty(exports, "isPdfFile", {
                enumerable: true,
                get: function() {
                    return _display_utils.isPdfFile;
                }
            });
            Object.defineProperty(exports, "loadScript", {
                enumerable: true,
                get: function() {
                    return _display_utils.loadScript;
                }
            });
            Object.defineProperty(exports, "noContextMenu", {
                enumerable: true,
                get: function() {
                    return _display_utils.noContextMenu;
                }
            });
            Object.defineProperty(exports, "normalizeUnicode", {
                enumerable: true,
                get: function() {
                    return _util.normalizeUnicode;
                }
            });
            Object.defineProperty(exports, "renderTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.renderTextLayer;
                }
            });
            Object.defineProperty(exports, "setLayerDimensions", {
                enumerable: true,
                get: function() {
                    return _display_utils.setLayerDimensions;
                }
            });
            Object.defineProperty(exports, "shadow", {
                enumerable: true,
                get: function() {
                    return _util.shadow;
                }
            });
            Object.defineProperty(exports, "updateTextLayer", {
                enumerable: true,
                get: function() {
                    return _text_layer.updateTextLayer;
                }
            });
            Object.defineProperty(exports, "version", {
                enumerable: true,
                get: function() {
                    return _api.version;
                }
            });
            var _util = __w_pdfjs_require__(1);
            var _api = __w_pdfjs_require__(2);
            var _display_utils = __w_pdfjs_require__(6);
            var _text_layer = __w_pdfjs_require__(26);
            var _annotation_editor_layer = __w_pdfjs_require__(27);
            var _tools = __w_pdfjs_require__(5);
            var _annotation_layer = __w_pdfjs_require__(29);
            var _worker_options = __w_pdfjs_require__(14);
            var _xfa_layer = __w_pdfjs_require__(32);
            const pdfjsVersion = '3.11.174';
            const pdfjsBuild = 'ce8716743';
        })();
        /******/ return __webpack_exports__;
    /******/ })();
});

});
parcelRegister("f2lgg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $af2788feedc9c17d$export$71511d61b312f219; });

var $3C4WD = parcelRequire("3C4WD");

var $isnPw = parcelRequire("isnPw");
function $af2788feedc9c17d$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $isnPw._)(receiver, privateMap, "get");
    return (0, $3C4WD._)(receiver, descriptor);
}

});
parcelRegister("3C4WD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2a18c1a122951618$export$71511d61b312f219; });
function $2a18c1a122951618$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("isnPw", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6fd53a7bc7c9119$export$71511d61b312f219; });
function $d6fd53a7bc7c9119$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("iXPoG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $dce59b123ac81214$export$71511d61b312f219; });

var $5J8Ai = parcelRequire("5J8Ai");
function $dce59b123ac81214$export$71511d61b312f219(obj, privateMap, value) {
    (0, $5J8Ai._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("5J8Ai", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $42b7d06d9cc9d7ab$export$71511d61b312f219; });
function $42b7d06d9cc9d7ab$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("5grPd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3d5407d3ee1fef9f$export$71511d61b312f219; });

var $1rqpM = parcelRequire("1rqpM");

var $isnPw = parcelRequire("isnPw");
function $3d5407d3ee1fef9f$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $isnPw._)(receiver, privateMap, "set");
    (0, $1rqpM._)(receiver, descriptor, value);
    return value;
}

});
parcelRegister("1rqpM", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $10cccd789259af50$export$71511d61b312f219; });
function $10cccd789259af50$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}

});


parcelRegister("kmaE3", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ed1e1e9f110ec251$export$71511d61b312f219; });

var $5Rvvv = parcelRequire("5Rvvv");

var $isnPw = parcelRequire("isnPw");
function $ed1e1e9f110ec251$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $isnPw._)(receiver, privateMap, "update");
    return (0, $5Rvvv._)(receiver, descriptor);
}

});
parcelRegister("5Rvvv", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $444a57a5e9750322$export$71511d61b312f219; });
function $444a57a5e9750322$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.set) {
        if (!descriptor.get) throw new TypeError("attempted to read set only private field");
        if (!("__destrWrapper" in descriptor)) descriptor.__destrWrapper = {
            set value (v){
                descriptor.set.call(receiver, v);
            },
            get value () {
                return descriptor.get.call(receiver);
            }
        };
        return descriptor.__destrWrapper;
    } else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        return descriptor;
    }
}

});


parcelRegister("hDjZy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cd659622765565e7$export$71511d61b312f219; });
function $cd659622765565e7$export$71511d61b312f219(receiver, privateSet, fn) {
    if (!privateSet.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return fn;
}

});

parcelRegister("2IZAT", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1fbf781ca112a399$export$71511d61b312f219; });

var $5J8Ai = parcelRequire("5J8Ai");
function $1fbf781ca112a399$export$71511d61b312f219(obj, privateSet) {
    (0, $5J8Ai._)(obj, privateSet);
    privateSet.add(obj);
}

});

parcelRegister("7MsFd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5aa34025006b1ede$export$71511d61b312f219; });

var $3C4WD = parcelRequire("3C4WD");

var $01IJy = parcelRequire("01IJy");

var $70oLE = parcelRequire("70oLE");
function $5aa34025006b1ede$export$71511d61b312f219(receiver, classConstructor, descriptor) {
    (0, $01IJy._)(receiver, classConstructor);
    (0, $70oLE._)(descriptor, "get");
    return (0, $3C4WD._)(receiver, descriptor);
}

});
parcelRegister("01IJy", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $0052cb54495a8e4d$export$71511d61b312f219; });
function $0052cb54495a8e4d$export$71511d61b312f219(receiver, classConstructor) {
    if (receiver !== classConstructor) throw new TypeError("Private static access of wrong provenance");
}

});

parcelRegister("70oLE", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $519bbecf618573d6$export$71511d61b312f219; });
function $519bbecf618573d6$export$71511d61b312f219(descriptor, action) {
    if (descriptor === undefined) throw new TypeError("attempted to " + action + " private static field before its declaration");
}

});


parcelRegister("8fxDh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $6019d025796b3445$export$71511d61b312f219; });

var $1rqpM = parcelRequire("1rqpM");

var $01IJy = parcelRequire("01IJy");

var $70oLE = parcelRequire("70oLE");
function $6019d025796b3445$export$71511d61b312f219(receiver, classConstructor, descriptor, value) {
    (0, $01IJy._)(receiver, classConstructor);
    (0, $70oLE._)(descriptor, "set");
    (0, $1rqpM._)(receiver, descriptor, value);
    return value;
}

});

parcelRegister("aufOL", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7a28f9d31b619993$export$71511d61b312f219; });

var $5Rvvv = parcelRequire("5Rvvv");

var $01IJy = parcelRequire("01IJy");

var $70oLE = parcelRequire("70oLE");
function $7a28f9d31b619993$export$71511d61b312f219(receiver, classConstructor, descriptor) {
    (0, $01IJy._)(receiver, classConstructor);
    (0, $70oLE._)(descriptor, "update");
    return (0, $5Rvvv._)(receiver, descriptor);
}

});

parcelRegister("yQrT8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $068bdc55014faeb0$export$71511d61b312f219; });
function $068bdc55014faeb0$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("cTSGB", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $96450a98c3100518$export$71511d61b312f219; });

var $yQrT8 = parcelRequire("yQrT8");
function $96450a98c3100518$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $yQrT8._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("7d4tS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53fd39208340ec1f$export$71511d61b312f219; });
function $53fd39208340ec1f$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $53fd39208340ec1f$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $53fd39208340ec1f$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("a36Ks", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $750f6b3efe9b7da4$export$71511d61b312f219; });

var $01IJy = parcelRequire("01IJy");
function $750f6b3efe9b7da4$export$71511d61b312f219(receiver, classConstructor, method) {
    (0, $01IJy._)(receiver, classConstructor);
    return method;
}

});

parcelRegister("kJBqN", function(module, exports) {

$parcel$export(module.exports, "Buffer", function () { return $f1850bb0717022a4$export$a143d493d941bafc; }, function (v) { return $f1850bb0717022a4$export$a143d493d941bafc = v; });
$parcel$export(module.exports, "SlowBuffer", function () { return $f1850bb0717022a4$export$e4cf37d7f6fb9e0a; }, function (v) { return $f1850bb0717022a4$export$e4cf37d7f6fb9e0a = v; });
$parcel$export(module.exports, "INSPECT_MAX_BYTES", function () { return $f1850bb0717022a4$export$f99ded8fe4b79145; }, function (v) { return $f1850bb0717022a4$export$f99ded8fe4b79145 = v; });
$parcel$export(module.exports, "kMaxLength", function () { return $f1850bb0717022a4$export$599f31c3813fae4d; }, function (v) { return $f1850bb0717022a4$export$599f31c3813fae4d = v; });
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $f1850bb0717022a4$export$a143d493d941bafc;
var $f1850bb0717022a4$export$e4cf37d7f6fb9e0a;
var $f1850bb0717022a4$export$f99ded8fe4b79145;
var $f1850bb0717022a4$export$599f31c3813fae4d;
'use strict';

var $dZ1E5 = parcelRequire("dZ1E5");

var $chxB2 = parcelRequire("chxB2");
const $f1850bb0717022a4$var$customInspectSymbol = typeof Symbol === 'function' && typeof Symbol['for'] === 'function' // eslint-disable-line dot-notation
 ? Symbol['for']('nodejs.util.inspect.custom') // eslint-disable-line dot-notation
 : null;
$f1850bb0717022a4$export$a143d493d941bafc = $f1850bb0717022a4$var$Buffer;
$f1850bb0717022a4$export$e4cf37d7f6fb9e0a = $f1850bb0717022a4$var$SlowBuffer;
$f1850bb0717022a4$export$f99ded8fe4b79145 = 50;
const $f1850bb0717022a4$var$K_MAX_LENGTH = 0x7fffffff;
$f1850bb0717022a4$export$599f31c3813fae4d = $f1850bb0717022a4$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $f1850bb0717022a4$var$Buffer.TYPED_ARRAY_SUPPORT = $f1850bb0717022a4$var$typedArraySupport();
if (!$f1850bb0717022a4$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $f1850bb0717022a4$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($f1850bb0717022a4$var$Buffer.prototype, 'parent', {
    enumerable: true,
    get: function() {
        if (!$f1850bb0717022a4$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($f1850bb0717022a4$var$Buffer.prototype, 'offset', {
    enumerable: true,
    get: function() {
        if (!$f1850bb0717022a4$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $f1850bb0717022a4$var$createBuffer(length) {
    if (length > $f1850bb0717022a4$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $f1850bb0717022a4$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $f1850bb0717022a4$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === 'number') {
        if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
        return $f1850bb0717022a4$var$allocUnsafe(arg);
    }
    return $f1850bb0717022a4$var$from(arg, encodingOrOffset, length);
}
$f1850bb0717022a4$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $f1850bb0717022a4$var$from(value, encodingOrOffset, length) {
    if (typeof value === 'string') return $f1850bb0717022a4$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $f1850bb0717022a4$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($f1850bb0717022a4$var$isInstance(value, ArrayBuffer) || value && $f1850bb0717022a4$var$isInstance(value.buffer, ArrayBuffer)) return $f1850bb0717022a4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== 'undefined' && ($f1850bb0717022a4$var$isInstance(value, SharedArrayBuffer) || value && $f1850bb0717022a4$var$isInstance(value.buffer, SharedArrayBuffer))) return $f1850bb0717022a4$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $f1850bb0717022a4$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $f1850bb0717022a4$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return $f1850bb0717022a4$var$Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $f1850bb0717022a4$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $f1850bb0717022a4$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($f1850bb0717022a4$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($f1850bb0717022a4$var$Buffer, Uint8Array);
function $f1850bb0717022a4$var$assertSize(size) {
    if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $f1850bb0717022a4$var$alloc(size, fill, encoding) {
    $f1850bb0717022a4$var$assertSize(size);
    if (size <= 0) return $f1850bb0717022a4$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === 'string' ? $f1850bb0717022a4$var$createBuffer(size).fill(fill, encoding) : $f1850bb0717022a4$var$createBuffer(size).fill(fill);
    return $f1850bb0717022a4$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $f1850bb0717022a4$var$Buffer.alloc = function(size, fill, encoding) {
    return $f1850bb0717022a4$var$alloc(size, fill, encoding);
};
function $f1850bb0717022a4$var$allocUnsafe(size) {
    $f1850bb0717022a4$var$assertSize(size);
    return $f1850bb0717022a4$var$createBuffer(size < 0 ? 0 : $f1850bb0717022a4$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $f1850bb0717022a4$var$Buffer.allocUnsafe = function(size) {
    return $f1850bb0717022a4$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $f1850bb0717022a4$var$Buffer.allocUnsafeSlow = function(size) {
    return $f1850bb0717022a4$var$allocUnsafe(size);
};
function $f1850bb0717022a4$var$fromString(string, encoding) {
    if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
    if (!$f1850bb0717022a4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
    const length = $f1850bb0717022a4$var$byteLength(string, encoding) | 0;
    let buf = $f1850bb0717022a4$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $f1850bb0717022a4$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $f1850bb0717022a4$var$checked(array.length) | 0;
    const buf = $f1850bb0717022a4$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $f1850bb0717022a4$var$fromArrayView(arrayView) {
    if ($f1850bb0717022a4$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $f1850bb0717022a4$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $f1850bb0717022a4$var$fromArrayLike(arrayView);
}
function $f1850bb0717022a4$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $f1850bb0717022a4$var$Buffer.prototype);
    return buf;
}
function $f1850bb0717022a4$var$fromObject(obj) {
    if ($f1850bb0717022a4$var$Buffer.isBuffer(obj)) {
        const len = $f1850bb0717022a4$var$checked(obj.length) | 0;
        const buf = $f1850bb0717022a4$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== 'number' || $f1850bb0717022a4$var$numberIsNaN(obj.length)) return $f1850bb0717022a4$var$createBuffer(0);
        return $f1850bb0717022a4$var$fromArrayLike(obj);
    }
    if (obj.type === 'Buffer' && Array.isArray(obj.data)) return $f1850bb0717022a4$var$fromArrayLike(obj.data);
}
function $f1850bb0717022a4$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $f1850bb0717022a4$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $f1850bb0717022a4$var$K_MAX_LENGTH.toString(16) + ' bytes');
    return length | 0;
}
function $f1850bb0717022a4$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $f1850bb0717022a4$var$Buffer.alloc(+length);
}
$f1850bb0717022a4$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $f1850bb0717022a4$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$f1850bb0717022a4$var$Buffer.compare = function compare(a, b) {
    if ($f1850bb0717022a4$var$isInstance(a, Uint8Array)) a = $f1850bb0717022a4$var$Buffer.from(a, a.offset, a.byteLength);
    if ($f1850bb0717022a4$var$isInstance(b, Uint8Array)) b = $f1850bb0717022a4$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$f1850bb0717022a4$var$Buffer.isBuffer(a) || !$f1850bb0717022a4$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$f1850bb0717022a4$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'latin1':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return true;
        default:
            return false;
    }
};
$f1850bb0717022a4$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $f1850bb0717022a4$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $f1850bb0717022a4$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($f1850bb0717022a4$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$f1850bb0717022a4$var$Buffer.isBuffer(buf)) buf = $f1850bb0717022a4$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$f1850bb0717022a4$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $f1850bb0717022a4$var$byteLength(string, encoding) {
    if ($f1850bb0717022a4$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $f1850bb0717022a4$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'ascii':
        case 'latin1':
        case 'binary':
            return len;
        case 'utf8':
        case 'utf-8':
            return $f1850bb0717022a4$var$utf8ToBytes(string).length;
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return len * 2;
        case 'hex':
            return len >>> 1;
        case 'base64':
            return $f1850bb0717022a4$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $f1850bb0717022a4$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
}
$f1850bb0717022a4$var$Buffer.byteLength = $f1850bb0717022a4$var$byteLength;
function $f1850bb0717022a4$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return '';
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return '';
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return '';
    if (!encoding) encoding = 'utf8';
    while(true)switch(encoding){
        case 'hex':
            return $f1850bb0717022a4$var$hexSlice(this, start, end);
        case 'utf8':
        case 'utf-8':
            return $f1850bb0717022a4$var$utf8Slice(this, start, end);
        case 'ascii':
            return $f1850bb0717022a4$var$asciiSlice(this, start, end);
        case 'latin1':
        case 'binary':
            return $f1850bb0717022a4$var$latin1Slice(this, start, end);
        case 'base64':
            return $f1850bb0717022a4$var$base64Slice(this, start, end);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f1850bb0717022a4$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = (encoding + '').toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$f1850bb0717022a4$var$Buffer.prototype._isBuffer = true;
function $f1850bb0717022a4$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$f1850bb0717022a4$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
    for(let i = 0; i < len; i += 2)$f1850bb0717022a4$var$swap(this, i, i + 1);
    return this;
};
$f1850bb0717022a4$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
    for(let i = 0; i < len; i += 4){
        $f1850bb0717022a4$var$swap(this, i, i + 3);
        $f1850bb0717022a4$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$f1850bb0717022a4$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
    for(let i = 0; i < len; i += 8){
        $f1850bb0717022a4$var$swap(this, i, i + 7);
        $f1850bb0717022a4$var$swap(this, i + 1, i + 6);
        $f1850bb0717022a4$var$swap(this, i + 2, i + 5);
        $f1850bb0717022a4$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$f1850bb0717022a4$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return '';
    if (arguments.length === 0) return $f1850bb0717022a4$var$utf8Slice(this, 0, length);
    return $f1850bb0717022a4$var$slowToString.apply(this, arguments);
};
$f1850bb0717022a4$var$Buffer.prototype.toLocaleString = $f1850bb0717022a4$var$Buffer.prototype.toString;
$f1850bb0717022a4$var$Buffer.prototype.equals = function equals(b) {
    if (!$f1850bb0717022a4$var$Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
    if (this === b) return true;
    return $f1850bb0717022a4$var$Buffer.compare(this, b) === 0;
};
$f1850bb0717022a4$var$Buffer.prototype.inspect = function inspect() {
    let str = '';
    const max = $f1850bb0717022a4$export$f99ded8fe4b79145;
    str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
    if (this.length > max) str += ' ... ';
    return '<Buffer ' + str + '>';
};
if ($f1850bb0717022a4$var$customInspectSymbol) $f1850bb0717022a4$var$Buffer.prototype[$f1850bb0717022a4$var$customInspectSymbol] = $f1850bb0717022a4$var$Buffer.prototype.inspect;
$f1850bb0717022a4$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($f1850bb0717022a4$var$isInstance(target, Uint8Array)) target = $f1850bb0717022a4$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$f1850bb0717022a4$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $f1850bb0717022a4$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === 'string') {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($f1850bb0717022a4$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === 'string') val = $f1850bb0717022a4$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($f1850bb0717022a4$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $f1850bb0717022a4$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === 'number') {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === 'function') {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $f1850bb0717022a4$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError('val must be string, number or Buffer');
}
function $f1850bb0717022a4$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$f1850bb0717022a4$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$f1850bb0717022a4$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $f1850bb0717022a4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$f1850bb0717022a4$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $f1850bb0717022a4$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $f1850bb0717022a4$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($f1850bb0717022a4$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $f1850bb0717022a4$var$utf8Write(buf, string, offset, length) {
    return $f1850bb0717022a4$var$blitBuffer($f1850bb0717022a4$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $f1850bb0717022a4$var$asciiWrite(buf, string, offset, length) {
    return $f1850bb0717022a4$var$blitBuffer($f1850bb0717022a4$var$asciiToBytes(string), buf, offset, length);
}
function $f1850bb0717022a4$var$base64Write(buf, string, offset, length) {
    return $f1850bb0717022a4$var$blitBuffer($f1850bb0717022a4$var$base64ToBytes(string), buf, offset, length);
}
function $f1850bb0717022a4$var$ucs2Write(buf, string, offset, length) {
    return $f1850bb0717022a4$var$blitBuffer($f1850bb0717022a4$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$f1850bb0717022a4$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = 'utf8';
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === 'string') {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = 'utf8';
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
    if (!encoding) encoding = 'utf8';
    let loweredCase = false;
    for(;;)switch(encoding){
        case 'hex':
            return $f1850bb0717022a4$var$hexWrite(this, string, offset, length);
        case 'utf8':
        case 'utf-8':
            return $f1850bb0717022a4$var$utf8Write(this, string, offset, length);
        case 'ascii':
        case 'latin1':
        case 'binary':
            return $f1850bb0717022a4$var$asciiWrite(this, string, offset, length);
        case 'base64':
            // Warning: maxLength not taken into account in base64Write
            return $f1850bb0717022a4$var$base64Write(this, string, offset, length);
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return $f1850bb0717022a4$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
            encoding = ('' + encoding).toLowerCase();
            loweredCase = true;
    }
};
$f1850bb0717022a4$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: 'Buffer',
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $f1850bb0717022a4$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $dZ1E5.fromByteArray(buf);
    else return $dZ1E5.fromByteArray(buf.slice(start, end));
}
function $f1850bb0717022a4$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $f1850bb0717022a4$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $f1850bb0717022a4$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $f1850bb0717022a4$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $f1850bb0717022a4$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = '';
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $f1850bb0717022a4$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $f1850bb0717022a4$var$asciiSlice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $f1850bb0717022a4$var$latin1Slice(buf, start, end) {
    let ret = '';
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $f1850bb0717022a4$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = '';
    for(let i = start; i < end; ++i)out += $f1850bb0717022a4$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $f1850bb0717022a4$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = '';
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$f1850bb0717022a4$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $f1850bb0717022a4$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $f1850bb0717022a4$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
    if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
}
$f1850bb0717022a4$var$Buffer.prototype.readUintLE = $f1850bb0717022a4$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$f1850bb0717022a4$var$Buffer.prototype.readUintBE = $f1850bb0717022a4$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$f1850bb0717022a4$var$Buffer.prototype.readUint8 = $f1850bb0717022a4$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$f1850bb0717022a4$var$Buffer.prototype.readUint16LE = $f1850bb0717022a4$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$f1850bb0717022a4$var$Buffer.prototype.readUint16BE = $f1850bb0717022a4$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$f1850bb0717022a4$var$Buffer.prototype.readUint32LE = $f1850bb0717022a4$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$f1850bb0717022a4$var$Buffer.prototype.readUint32BE = $f1850bb0717022a4$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$f1850bb0717022a4$var$Buffer.prototype.readBigUInt64LE = $f1850bb0717022a4$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $f1850bb0717022a4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f1850bb0717022a4$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24);
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + last * Math.pow(2, 24);
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$f1850bb0717022a4$var$Buffer.prototype.readBigUInt64BE = $f1850bb0717022a4$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $f1850bb0717022a4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f1850bb0717022a4$var$boundsError(offset, this.length - 8);
    const hi = first * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$f1850bb0717022a4$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f1850bb0717022a4$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$f1850bb0717022a4$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$f1850bb0717022a4$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f1850bb0717022a4$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$f1850bb0717022a4$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$f1850bb0717022a4$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$f1850bb0717022a4$var$Buffer.prototype.readBigInt64LE = $f1850bb0717022a4$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $f1850bb0717022a4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f1850bb0717022a4$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * Math.pow(2, 16) + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * Math.pow(2, 16) + this[++offset] * Math.pow(2, 24));
});
$f1850bb0717022a4$var$Buffer.prototype.readBigInt64BE = $f1850bb0717022a4$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $f1850bb0717022a4$var$validateNumber(offset, 'offset');
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $f1850bb0717022a4$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * Math.pow(2, 24) + this[++offset] * Math.pow(2, 16) + this[++offset] * 256 + last);
});
$f1850bb0717022a4$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return $chxB2.read(this, offset, true, 23, 4);
};
$f1850bb0717022a4$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 4, this.length);
    return $chxB2.read(this, offset, false, 23, 4);
};
$f1850bb0717022a4$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 8, this.length);
    return $chxB2.read(this, offset, true, 52, 8);
};
$f1850bb0717022a4$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkOffset(offset, 8, this.length);
    return $chxB2.read(this, offset, false, 52, 8);
};
function $f1850bb0717022a4$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$f1850bb0717022a4$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
}
$f1850bb0717022a4$var$Buffer.prototype.writeUintLE = $f1850bb0717022a4$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f1850bb0717022a4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUintBE = $f1850bb0717022a4$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $f1850bb0717022a4$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUint8 = $f1850bb0717022a4$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUint16LE = $f1850bb0717022a4$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUint16BE = $f1850bb0717022a4$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUint32LE = $f1850bb0717022a4$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$f1850bb0717022a4$var$Buffer.prototype.writeUint32BE = $f1850bb0717022a4$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $f1850bb0717022a4$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $f1850bb0717022a4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $f1850bb0717022a4$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $f1850bb0717022a4$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$f1850bb0717022a4$var$Buffer.prototype.writeBigUInt64LE = $f1850bb0717022a4$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $f1850bb0717022a4$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f1850bb0717022a4$var$Buffer.prototype.writeBigUInt64BE = $f1850bb0717022a4$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $f1850bb0717022a4$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt('0xffffffffffffffff'));
});
$f1850bb0717022a4$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f1850bb0717022a4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f1850bb0717022a4$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $f1850bb0717022a4$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$f1850bb0717022a4$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$f1850bb0717022a4$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$f1850bb0717022a4$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$f1850bb0717022a4$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$f1850bb0717022a4$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$f1850bb0717022a4$var$Buffer.prototype.writeBigInt64LE = $f1850bb0717022a4$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $f1850bb0717022a4$var$wrtBigUInt64LE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
$f1850bb0717022a4$var$Buffer.prototype.writeBigInt64BE = $f1850bb0717022a4$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $f1850bb0717022a4$var$wrtBigUInt64BE(this, value, offset, -BigInt('0x8000000000000000'), BigInt('0x7fffffffffffffff'));
});
function $f1850bb0717022a4$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError('Index out of range');
    if (offset < 0) throw new RangeError('Index out of range');
}
function $f1850bb0717022a4$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $chxB2.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$f1850bb0717022a4$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $f1850bb0717022a4$var$writeFloat(this, value, offset, true, noAssert);
};
$f1850bb0717022a4$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $f1850bb0717022a4$var$writeFloat(this, value, offset, false, noAssert);
};
function $f1850bb0717022a4$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $f1850bb0717022a4$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $chxB2.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$f1850bb0717022a4$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $f1850bb0717022a4$var$writeDouble(this, value, offset, true, noAssert);
};
$f1850bb0717022a4$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $f1850bb0717022a4$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$f1850bb0717022a4$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$f1850bb0717022a4$var$Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError('targetStart out of bounds');
    if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
    if (end < 0) throw new RangeError('sourceEnd out of bounds');
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$f1850bb0717022a4$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === 'string') {
        if (typeof start === 'string') {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === 'string') {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
        if (typeof encoding === 'string' && !$f1850bb0717022a4$var$Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === 'number') val = val & 255;
    else if (typeof val === 'boolean') val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $f1850bb0717022a4$var$Buffer.isBuffer(val) ? val : $f1850bb0717022a4$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $f1850bb0717022a4$var$errors = {};
function $f1850bb0717022a4$var$E(sym, getMessage, Base) {
    $f1850bb0717022a4$var$errors[sym] = class NodeError extends Base {
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, 'code', {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
        constructor(){
            super();
            Object.defineProperty(this, 'message', {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
    };
}
$f1850bb0717022a4$var$E('ERR_BUFFER_OUT_OF_BOUNDS', function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return 'Attempt to access memory outside buffer bounds';
}, RangeError);
$f1850bb0717022a4$var$E('ERR_INVALID_ARG_TYPE', function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$f1850bb0717022a4$var$E('ERR_OUT_OF_RANGE', function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > Math.pow(2, 32)) received = $f1850bb0717022a4$var$addNumericalSeparator(String(input));
    else if (typeof input === 'bigint') {
        received = String(input);
        if (input > Math.pow(BigInt(2), BigInt(32)) || input < -Math.pow(BigInt(2), BigInt(32))) received = $f1850bb0717022a4$var$addNumericalSeparator(received);
        received += 'n';
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $f1850bb0717022a4$var$addNumericalSeparator(val) {
    let res = '';
    let i = val.length;
    const start = val[0] === '-' ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $f1850bb0717022a4$var$checkBounds(buf, offset, byteLength) {
    $f1850bb0717022a4$var$validateNumber(offset, 'offset');
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $f1850bb0717022a4$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $f1850bb0717022a4$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === 'bigint' ? 'n' : '';
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $f1850bb0717022a4$var$errors.ERR_OUT_OF_RANGE('value', range, value);
    }
    $f1850bb0717022a4$var$checkBounds(buf, offset, byteLength);
}
function $f1850bb0717022a4$var$validateNumber(value, name) {
    if (typeof value !== 'number') throw new $f1850bb0717022a4$var$errors.ERR_INVALID_ARG_TYPE(name, 'number', value);
}
function $f1850bb0717022a4$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $f1850bb0717022a4$var$validateNumber(value, type);
        throw new $f1850bb0717022a4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', 'an integer', value);
    }
    if (length < 0) throw new $f1850bb0717022a4$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $f1850bb0717022a4$var$errors.ERR_OUT_OF_RANGE(type || 'offset', `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $f1850bb0717022a4$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $f1850bb0717022a4$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split('=')[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($f1850bb0717022a4$var$INVALID_BASE64_RE, '');
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return '';
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + '=';
    return str;
}
function $f1850bb0717022a4$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error('Invalid code point');
    }
    return bytes;
}
function $f1850bb0717022a4$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $f1850bb0717022a4$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $f1850bb0717022a4$var$base64ToBytes(str) {
    return $dZ1E5.toByteArray($f1850bb0717022a4$var$base64clean(str));
}
function $f1850bb0717022a4$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $f1850bb0717022a4$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $f1850bb0717022a4$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $f1850bb0717022a4$var$hexSliceLookupTable = function() {
    const alphabet = '0123456789abcdef';
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $f1850bb0717022a4$var$defineBigIntMethod(fn) {
    return typeof BigInt === 'undefined' ? $f1850bb0717022a4$var$BufferBigIntNotDefined : fn;
}
function $f1850bb0717022a4$var$BufferBigIntNotDefined() {
    throw new Error('BigInt not supported');
}

});
parcelRegister("dZ1E5", function(module, exports) {

$parcel$export(module.exports, "toByteArray", function () { return $a2e23fa736cc5a9d$export$d622b2ad8d90c771; }, function (v) { return $a2e23fa736cc5a9d$export$d622b2ad8d90c771 = v; });
$parcel$export(module.exports, "fromByteArray", function () { return $a2e23fa736cc5a9d$export$6100ba28696e12de; }, function (v) { return $a2e23fa736cc5a9d$export$6100ba28696e12de = v; });
var $a2e23fa736cc5a9d$export$a48f0734ac7c2329;
var $a2e23fa736cc5a9d$export$d622b2ad8d90c771;
var $a2e23fa736cc5a9d$export$6100ba28696e12de;
'use strict';
$a2e23fa736cc5a9d$export$a48f0734ac7c2329 = $a2e23fa736cc5a9d$var$byteLength;
$a2e23fa736cc5a9d$export$d622b2ad8d90c771 = $a2e23fa736cc5a9d$var$toByteArray;
$a2e23fa736cc5a9d$export$6100ba28696e12de = $a2e23fa736cc5a9d$var$fromByteArray;
var $a2e23fa736cc5a9d$var$lookup = [];
var $a2e23fa736cc5a9d$var$revLookup = [];
var $a2e23fa736cc5a9d$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $a2e23fa736cc5a9d$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $a2e23fa736cc5a9d$var$i = 0, $a2e23fa736cc5a9d$var$len = $a2e23fa736cc5a9d$var$code.length; $a2e23fa736cc5a9d$var$i < $a2e23fa736cc5a9d$var$len; ++$a2e23fa736cc5a9d$var$i){
    $a2e23fa736cc5a9d$var$lookup[$a2e23fa736cc5a9d$var$i] = $a2e23fa736cc5a9d$var$code[$a2e23fa736cc5a9d$var$i];
    $a2e23fa736cc5a9d$var$revLookup[$a2e23fa736cc5a9d$var$code.charCodeAt($a2e23fa736cc5a9d$var$i)] = $a2e23fa736cc5a9d$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$a2e23fa736cc5a9d$var$revLookup['-'.charCodeAt(0)] = 62;
$a2e23fa736cc5a9d$var$revLookup['_'.charCodeAt(0)] = 63;
function $a2e23fa736cc5a9d$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $a2e23fa736cc5a9d$var$byteLength(b64) {
    var lens = $a2e23fa736cc5a9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a2e23fa736cc5a9d$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $a2e23fa736cc5a9d$var$toByteArray(b64) {
    var tmp;
    var lens = $a2e23fa736cc5a9d$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $a2e23fa736cc5a9d$var$Arr($a2e23fa736cc5a9d$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i)] << 18 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i)] << 2 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i)] << 10 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $a2e23fa736cc5a9d$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $a2e23fa736cc5a9d$var$tripletToBase64(num) {
    return $a2e23fa736cc5a9d$var$lookup[num >> 18 & 0x3F] + $a2e23fa736cc5a9d$var$lookup[num >> 12 & 0x3F] + $a2e23fa736cc5a9d$var$lookup[num >> 6 & 0x3F] + $a2e23fa736cc5a9d$var$lookup[num & 0x3F];
}
function $a2e23fa736cc5a9d$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($a2e23fa736cc5a9d$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $a2e23fa736cc5a9d$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($a2e23fa736cc5a9d$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($a2e23fa736cc5a9d$var$lookup[tmp >> 2] + $a2e23fa736cc5a9d$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($a2e23fa736cc5a9d$var$lookup[tmp >> 10] + $a2e23fa736cc5a9d$var$lookup[tmp >> 4 & 0x3F] + $a2e23fa736cc5a9d$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}

});

parcelRegister("chxB2", function(module, exports) {

$parcel$export(module.exports, "read", function () { return $8f11221cd1d4bc51$export$aafa59e2e03f2942; }, function (v) { return $8f11221cd1d4bc51$export$aafa59e2e03f2942 = v; });
$parcel$export(module.exports, "write", function () { return $8f11221cd1d4bc51$export$68d8715fc104d294; }, function (v) { return $8f11221cd1d4bc51$export$68d8715fc104d294 = v; });
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $8f11221cd1d4bc51$export$aafa59e2e03f2942;
var $8f11221cd1d4bc51$export$68d8715fc104d294;
$8f11221cd1d4bc51$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$8f11221cd1d4bc51$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("5XqL3", function(module, exports) {
// shim for using process in browser
var $45673803e40bd496$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $45673803e40bd496$var$cachedSetTimeout;
var $45673803e40bd496$var$cachedClearTimeout;
function $45673803e40bd496$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $45673803e40bd496$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
(function() {
    try {
        if (typeof setTimeout === 'function') $45673803e40bd496$var$cachedSetTimeout = setTimeout;
        else $45673803e40bd496$var$cachedSetTimeout = $45673803e40bd496$var$defaultSetTimout;
    } catch (e) {
        $45673803e40bd496$var$cachedSetTimeout = $45673803e40bd496$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') $45673803e40bd496$var$cachedClearTimeout = clearTimeout;
        else $45673803e40bd496$var$cachedClearTimeout = $45673803e40bd496$var$defaultClearTimeout;
    } catch (e) {
        $45673803e40bd496$var$cachedClearTimeout = $45673803e40bd496$var$defaultClearTimeout;
    }
})();
function $45673803e40bd496$var$runTimeout(fun) {
    if ($45673803e40bd496$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($45673803e40bd496$var$cachedSetTimeout === $45673803e40bd496$var$defaultSetTimout || !$45673803e40bd496$var$cachedSetTimeout) && setTimeout) {
        $45673803e40bd496$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $45673803e40bd496$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $45673803e40bd496$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $45673803e40bd496$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $45673803e40bd496$var$runClearTimeout(marker) {
    if ($45673803e40bd496$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($45673803e40bd496$var$cachedClearTimeout === $45673803e40bd496$var$defaultClearTimeout || !$45673803e40bd496$var$cachedClearTimeout) && clearTimeout) {
        $45673803e40bd496$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $45673803e40bd496$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $45673803e40bd496$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $45673803e40bd496$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $45673803e40bd496$var$queue = [];
var $45673803e40bd496$var$draining = false;
var $45673803e40bd496$var$currentQueue;
var $45673803e40bd496$var$queueIndex = -1;
function $45673803e40bd496$var$cleanUpNextTick() {
    if (!$45673803e40bd496$var$draining || !$45673803e40bd496$var$currentQueue) return;
    $45673803e40bd496$var$draining = false;
    if ($45673803e40bd496$var$currentQueue.length) $45673803e40bd496$var$queue = $45673803e40bd496$var$currentQueue.concat($45673803e40bd496$var$queue);
    else $45673803e40bd496$var$queueIndex = -1;
    if ($45673803e40bd496$var$queue.length) $45673803e40bd496$var$drainQueue();
}
function $45673803e40bd496$var$drainQueue() {
    if ($45673803e40bd496$var$draining) return;
    var timeout = $45673803e40bd496$var$runTimeout($45673803e40bd496$var$cleanUpNextTick);
    $45673803e40bd496$var$draining = true;
    var len = $45673803e40bd496$var$queue.length;
    while(len){
        $45673803e40bd496$var$currentQueue = $45673803e40bd496$var$queue;
        $45673803e40bd496$var$queue = [];
        while(++$45673803e40bd496$var$queueIndex < len)if ($45673803e40bd496$var$currentQueue) $45673803e40bd496$var$currentQueue[$45673803e40bd496$var$queueIndex].run();
        $45673803e40bd496$var$queueIndex = -1;
        len = $45673803e40bd496$var$queue.length;
    }
    $45673803e40bd496$var$currentQueue = null;
    $45673803e40bd496$var$draining = false;
    $45673803e40bd496$var$runClearTimeout(timeout);
}
$45673803e40bd496$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $45673803e40bd496$var$queue.push(new $45673803e40bd496$var$Item(fun, args));
    if ($45673803e40bd496$var$queue.length === 1 && !$45673803e40bd496$var$draining) $45673803e40bd496$var$runTimeout($45673803e40bd496$var$drainQueue);
};
// v8 likes predictible objects
function $45673803e40bd496$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$45673803e40bd496$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$45673803e40bd496$var$process.title = 'browser';
$45673803e40bd496$var$process.browser = true;
$45673803e40bd496$var$process.env = {};
$45673803e40bd496$var$process.argv = [];
$45673803e40bd496$var$process.version = ''; // empty string to avoid regexp issues
$45673803e40bd496$var$process.versions = {};
function $45673803e40bd496$var$noop() {}
$45673803e40bd496$var$process.on = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.addListener = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.once = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.off = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.removeListener = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.removeAllListeners = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.emit = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.prependListener = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.prependOnceListener = $45673803e40bd496$var$noop;
$45673803e40bd496$var$process.listeners = function(name) {
    return [];
};
$45673803e40bd496$var$process.binding = function(name) {
    throw new Error('process.binding is not supported');
};
$45673803e40bd496$var$process.cwd = function() {
    return '/';
};
$45673803e40bd496$var$process.chdir = function(dir) {
    throw new Error('process.chdir is not supported');
};
$45673803e40bd496$var$process.umask = function() {
    return 0;
};

});

parcelRegister("hDwn7", function(module, exports) {
"use strict";

});


parcelRegister("hHIjR", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $5XqL3 = parcelRequire("5XqL3");
var $ce38d4b3328bb807$var$getOwnPropertyDescriptors = Object.getOwnPropertyDescriptors || function getOwnPropertyDescriptors(obj) {
    var keys = Object.keys(obj);
    var descriptors = {};
    for(var i = 0; i < keys.length; i++)descriptors[keys[i]] = Object.getOwnPropertyDescriptor(obj, keys[i]);
    return descriptors;
};
var $ce38d4b3328bb807$var$formatRegExp = /%[sdj%]/g;
module.exports.format = function(f) {
    if (!$ce38d4b3328bb807$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($ce38d4b3328bb807$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($ce38d4b3328bb807$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($ce38d4b3328bb807$var$isNull(x) || !$ce38d4b3328bb807$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $ce38d4b3328bb807$var$inspect(x);
    return str;
};
// Mark that a method should not be used.
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
module.exports.deprecate = function(fn, msg) {
    var warned;
    return function() {
        return module.exports.deprecate(fn, msg).apply(this, arguments);
    };
    function deprecated() {
        if (!warned) {
            if ($5XqL3.throwDeprecation) throw new Error(msg);
            else if ($5XqL3.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
};
var $ce38d4b3328bb807$var$debugs = {};
var $ce38d4b3328bb807$var$debugEnvRegex = /^$/;
var $ce38d4b3328bb807$var$debugEnv;
module.exports.debuglog = function(set) {
    set = set.toUpperCase();
    if (!$ce38d4b3328bb807$var$debugs[set]) {
        if ($ce38d4b3328bb807$var$debugEnvRegex.test(set)) {
            var pid = $5XqL3.pid;
            $ce38d4b3328bb807$var$debugs[set] = function() {
                var msg = module.exports.format.apply(module.exports, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $ce38d4b3328bb807$var$debugs[set] = function() {};
    }
    return $ce38d4b3328bb807$var$debugs[set];
};
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $ce38d4b3328bb807$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $ce38d4b3328bb807$var$stylizeNoColor
    };
    // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($ce38d4b3328bb807$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    module.exports._extend(ctx, opts);
    // set default options
    if ($ce38d4b3328bb807$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($ce38d4b3328bb807$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($ce38d4b3328bb807$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($ce38d4b3328bb807$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $ce38d4b3328bb807$var$stylizeWithColor;
    return $ce38d4b3328bb807$var$formatValue(ctx, obj, ctx.depth);
}
module.exports.inspect = $ce38d4b3328bb807$var$inspect;
// http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$ce38d4b3328bb807$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
};
// Don't use 'blue' not visible on cmd.exe
$ce38d4b3328bb807$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $ce38d4b3328bb807$var$stylizeWithColor(str, styleType) {
    var style = $ce38d4b3328bb807$var$inspect.styles[styleType];
    if (style) return '\u001b[' + $ce38d4b3328bb807$var$inspect.colors[style][0] + 'm' + str + '\u001b[' + $ce38d4b3328bb807$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $ce38d4b3328bb807$var$stylizeNoColor(str, styleType) {
    return str;
}
function $ce38d4b3328bb807$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $ce38d4b3328bb807$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $ce38d4b3328bb807$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== module.exports.inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$ce38d4b3328bb807$var$isString(ret)) ret = $ce38d4b3328bb807$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    }
    // Primitive types cannot have properties
    var primitive = $ce38d4b3328bb807$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
    // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $ce38d4b3328bb807$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
    // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($ce38d4b3328bb807$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $ce38d4b3328bb807$var$formatError(value);
    // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($ce38d4b3328bb807$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($ce38d4b3328bb807$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($ce38d4b3328bb807$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($ce38d4b3328bb807$var$isError(value)) return $ce38d4b3328bb807$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ];
    // Make Array say that they are Array
    if ($ce38d4b3328bb807$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    }
    // Make functions say that they are functions
    if ($ce38d4b3328bb807$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    }
    // Make RegExps say that they are RegExps
    if ($ce38d4b3328bb807$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
    // Make dates with properties first say the date
    if ($ce38d4b3328bb807$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
    // Make error with message first say the error
    if ($ce38d4b3328bb807$var$isError(value)) base = ' ' + $ce38d4b3328bb807$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($ce38d4b3328bb807$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $ce38d4b3328bb807$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $ce38d4b3328bb807$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $ce38d4b3328bb807$var$reduceToSingleString(output, base, braces);
}
function $ce38d4b3328bb807$var$formatPrimitive(ctx, value) {
    if ($ce38d4b3328bb807$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($ce38d4b3328bb807$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($ce38d4b3328bb807$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($ce38d4b3328bb807$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean');
    // For some reason typeof null is "object", so special case here.
    if ($ce38d4b3328bb807$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $ce38d4b3328bb807$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $ce38d4b3328bb807$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($ce38d4b3328bb807$var$hasOwnProperty(value, String(i))) output.push($ce38d4b3328bb807$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($ce38d4b3328bb807$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $ce38d4b3328bb807$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$ce38d4b3328bb807$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($ce38d4b3328bb807$var$isNull(recurseTimes)) str = $ce38d4b3328bb807$var$formatValue(ctx, desc.value, null);
            else str = $ce38d4b3328bb807$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').slice(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($ce38d4b3328bb807$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.slice(1, -1);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $ce38d4b3328bb807$var$reduceToSingleString(output, base, braces) {
    var numLinesEst = 0;
    var length = output.reduce(function(prev, cur) {
        numLinesEst++;
        if (cur.indexOf('\n') >= 0) numLinesEst++;
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
}

// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
module.exports.types = (parcelRequire("1ylpO"));
function $ce38d4b3328bb807$var$isArray(ar) {
    return Array.isArray(ar);
}
module.exports.isArray = $ce38d4b3328bb807$var$isArray;
function $ce38d4b3328bb807$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
module.exports.isBoolean = $ce38d4b3328bb807$var$isBoolean;
function $ce38d4b3328bb807$var$isNull(arg) {
    return arg === null;
}
module.exports.isNull = $ce38d4b3328bb807$var$isNull;
function $ce38d4b3328bb807$var$isNullOrUndefined(arg) {
    return arg == null;
}
module.exports.isNullOrUndefined = $ce38d4b3328bb807$var$isNullOrUndefined;
function $ce38d4b3328bb807$var$isNumber(arg) {
    return typeof arg === 'number';
}
module.exports.isNumber = $ce38d4b3328bb807$var$isNumber;
function $ce38d4b3328bb807$var$isString(arg) {
    return typeof arg === 'string';
}
module.exports.isString = $ce38d4b3328bb807$var$isString;
function $ce38d4b3328bb807$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
module.exports.isSymbol = $ce38d4b3328bb807$var$isSymbol;
function $ce38d4b3328bb807$var$isUndefined(arg) {
    return arg === void 0;
}
module.exports.isUndefined = $ce38d4b3328bb807$var$isUndefined;
function $ce38d4b3328bb807$var$isRegExp(re) {
    return $ce38d4b3328bb807$var$isObject(re) && $ce38d4b3328bb807$var$objectToString(re) === '[object RegExp]';
}
module.exports.isRegExp = $ce38d4b3328bb807$var$isRegExp;
module.exports.types.isRegExp = $ce38d4b3328bb807$var$isRegExp;
function $ce38d4b3328bb807$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
module.exports.isObject = $ce38d4b3328bb807$var$isObject;
function $ce38d4b3328bb807$var$isDate(d) {
    return $ce38d4b3328bb807$var$isObject(d) && $ce38d4b3328bb807$var$objectToString(d) === '[object Date]';
}
module.exports.isDate = $ce38d4b3328bb807$var$isDate;
module.exports.types.isDate = $ce38d4b3328bb807$var$isDate;
function $ce38d4b3328bb807$var$isError(e) {
    return $ce38d4b3328bb807$var$isObject(e) && ($ce38d4b3328bb807$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
module.exports.isError = $ce38d4b3328bb807$var$isError;
module.exports.types.isNativeError = $ce38d4b3328bb807$var$isError;
function $ce38d4b3328bb807$var$isFunction(arg) {
    return typeof arg === 'function';
}
module.exports.isFunction = $ce38d4b3328bb807$var$isFunction;
function $ce38d4b3328bb807$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
module.exports.isPrimitive = $ce38d4b3328bb807$var$isPrimitive;

module.exports.isBuffer = (parcelRequire("iYklQ"));
function $ce38d4b3328bb807$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $ce38d4b3328bb807$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $ce38d4b3328bb807$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
];
// 26 Feb 16:19:34
function $ce38d4b3328bb807$var$timestamp() {
    var d = new Date();
    var time = [
        $ce38d4b3328bb807$var$pad(d.getHours()),
        $ce38d4b3328bb807$var$pad(d.getMinutes()),
        $ce38d4b3328bb807$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $ce38d4b3328bb807$var$months[d.getMonth()],
        time
    ].join(' ');
}
// log is just a thin wrapper to console.log that prepends a timestamp
module.exports.log = function() {
    console.log('%s - %s', $ce38d4b3328bb807$var$timestamp(), module.exports.format.apply(module.exports, arguments));
};

/**
 * Inherit the prototype methods from one constructor into another.
 *
 * The Function.prototype.inherits from lang.js rewritten as a standalone
 * function (not on Function.prototype). NOTE: If this file is to be loaded
 * during bootstrapping this function needs to be rewritten using some native
 * functions as prototype setup using normal JavaScript does not work as
 * expected during bootstrapping (see mirror.js in r114903).
 *
 * @param {function} ctor Constructor function which needs to inherit the
 *     prototype.
 * @param {function} superCtor Constructor function to inherit prototype from.
 */ module.exports.inherits = (parcelRequire("gdc6A"));
module.exports._extend = function(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$ce38d4b3328bb807$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
};
function $ce38d4b3328bb807$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $ce38d4b3328bb807$var$kCustomPromisifiedSymbol = typeof Symbol !== 'undefined' ? Symbol('util.promisify.custom') : undefined;
module.exports.promisify = function promisify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    if ($ce38d4b3328bb807$var$kCustomPromisifiedSymbol && original[$ce38d4b3328bb807$var$kCustomPromisifiedSymbol]) {
        var fn = original[$ce38d4b3328bb807$var$kCustomPromisifiedSymbol];
        if (typeof fn !== 'function') throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        Object.defineProperty(fn, $ce38d4b3328bb807$var$kCustomPromisifiedSymbol, {
            value: fn,
            enumerable: false,
            writable: false,
            configurable: true
        });
        return fn;
    }
    function fn() {
        var promiseResolve, promiseReject;
        var promise = new Promise(function(resolve, reject) {
            promiseResolve = resolve;
            promiseReject = reject;
        });
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        args.push(function(err, value) {
            if (err) promiseReject(err);
            else promiseResolve(value);
        });
        try {
            original.apply(this, args);
        } catch (err) {
            promiseReject(err);
        }
        return promise;
    }
    Object.setPrototypeOf(fn, Object.getPrototypeOf(original));
    if ($ce38d4b3328bb807$var$kCustomPromisifiedSymbol) Object.defineProperty(fn, $ce38d4b3328bb807$var$kCustomPromisifiedSymbol, {
        value: fn,
        enumerable: false,
        writable: false,
        configurable: true
    });
    return Object.defineProperties(fn, $ce38d4b3328bb807$var$getOwnPropertyDescriptors(original));
};
module.exports.promisify.custom = $ce38d4b3328bb807$var$kCustomPromisifiedSymbol;
function $ce38d4b3328bb807$var$callbackifyOnRejected(reason, cb) {
    // `!reason` guard inspired by bluebird (Ref: https://goo.gl/t5IS6M).
    // Because `null` is a special error value in callbacks which means "no error
    // occurred", we error-wrap so the callback consumer can distinguish between
    // "the promise rejected with null" or "the promise fulfilled with undefined".
    if (!reason) {
        var newReason = new Error('Promise was rejected with a falsy value');
        newReason.reason = reason;
        reason = newReason;
    }
    return cb(reason);
}
function $ce38d4b3328bb807$var$callbackify(original) {
    if (typeof original !== 'function') throw new TypeError('The "original" argument must be of type Function');
    // We DO NOT return the promise as it gives the user a false sense that
    // the promise is actually somehow related to the callback's execution
    // and that the callback throwing will reject the promise.
    function callbackified() {
        var args = [];
        for(var i = 0; i < arguments.length; i++)args.push(arguments[i]);
        var maybeCb = args.pop();
        if (typeof maybeCb !== 'function') throw new TypeError('The last argument must be of type Function');
        var self = this;
        var cb = function() {
            return maybeCb.apply(self, arguments);
        };
        // In true node style we process the callback on `nextTick` with all the
        // implications (stack, `uncaughtException`, `async_hooks`)
        original.apply(this, args).then(function(ret) {
            $5XqL3.nextTick(cb.bind(null, null, ret));
        }, function(rej) {
            $5XqL3.nextTick($ce38d4b3328bb807$var$callbackifyOnRejected.bind(null, rej, cb));
        });
    }
    Object.setPrototypeOf(callbackified, Object.getPrototypeOf(original));
    Object.defineProperties(callbackified, $ce38d4b3328bb807$var$getOwnPropertyDescriptors(original));
    return callbackified;
}
module.exports.callbackify = $ce38d4b3328bb807$var$callbackify;

});
parcelRegister("1ylpO", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/types.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';

var $4KueG = parcelRequire("4KueG");

var $6KKQe = parcelRequire("6KKQe");

var $8fHtM = parcelRequire("8fHtM");

var $7k9mr = parcelRequire("7k9mr");
function $1219940a41485055$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $1219940a41485055$var$BigIntSupported = typeof BigInt !== 'undefined';
var $1219940a41485055$var$SymbolSupported = typeof Symbol !== 'undefined';
var $1219940a41485055$var$ObjectToString = $1219940a41485055$var$uncurryThis(Object.prototype.toString);
var $1219940a41485055$var$numberValue = $1219940a41485055$var$uncurryThis(Number.prototype.valueOf);
var $1219940a41485055$var$stringValue = $1219940a41485055$var$uncurryThis(String.prototype.valueOf);
var $1219940a41485055$var$booleanValue = $1219940a41485055$var$uncurryThis(Boolean.prototype.valueOf);
if ($1219940a41485055$var$BigIntSupported) var $1219940a41485055$var$bigIntValue = $1219940a41485055$var$uncurryThis(BigInt.prototype.valueOf);
if ($1219940a41485055$var$SymbolSupported) var $1219940a41485055$var$symbolValue = $1219940a41485055$var$uncurryThis(Symbol.prototype.valueOf);
function $1219940a41485055$var$checkBoxedPrimitive(value, prototypeValueOf) {
    if (typeof value !== 'object') return false;
    try {
        prototypeValueOf(value);
        return true;
    } catch (e) {
        return false;
    }
}
module.exports.isArgumentsObject = $4KueG;
module.exports.isGeneratorFunction = $6KKQe;
module.exports.isTypedArray = $7k9mr;
// Taken from here and modified for better browser support
// https://github.com/sindresorhus/p-is-promise/blob/cda35a513bda03f977ad5cde3a079d237e82d7ef/index.js
function $1219940a41485055$var$isPromise(input) {
    return typeof Promise !== 'undefined' && input instanceof Promise || input !== null && typeof input === 'object' && typeof input.then === 'function' && typeof input.catch === 'function';
}
module.exports.isPromise = $1219940a41485055$var$isPromise;
function $1219940a41485055$var$isArrayBufferView(value) {
    if (typeof ArrayBuffer !== 'undefined' && ArrayBuffer.isView) return ArrayBuffer.isView(value);
    return $7k9mr(value) || $1219940a41485055$var$isDataView(value);
}
module.exports.isArrayBufferView = $1219940a41485055$var$isArrayBufferView;
function $1219940a41485055$var$isUint8Array(value) {
    return $8fHtM(value) === 'Uint8Array';
}
module.exports.isUint8Array = $1219940a41485055$var$isUint8Array;
function $1219940a41485055$var$isUint8ClampedArray(value) {
    return $8fHtM(value) === 'Uint8ClampedArray';
}
module.exports.isUint8ClampedArray = $1219940a41485055$var$isUint8ClampedArray;
function $1219940a41485055$var$isUint16Array(value) {
    return $8fHtM(value) === 'Uint16Array';
}
module.exports.isUint16Array = $1219940a41485055$var$isUint16Array;
function $1219940a41485055$var$isUint32Array(value) {
    return $8fHtM(value) === 'Uint32Array';
}
module.exports.isUint32Array = $1219940a41485055$var$isUint32Array;
function $1219940a41485055$var$isInt8Array(value) {
    return $8fHtM(value) === 'Int8Array';
}
module.exports.isInt8Array = $1219940a41485055$var$isInt8Array;
function $1219940a41485055$var$isInt16Array(value) {
    return $8fHtM(value) === 'Int16Array';
}
module.exports.isInt16Array = $1219940a41485055$var$isInt16Array;
function $1219940a41485055$var$isInt32Array(value) {
    return $8fHtM(value) === 'Int32Array';
}
module.exports.isInt32Array = $1219940a41485055$var$isInt32Array;
function $1219940a41485055$var$isFloat32Array(value) {
    return $8fHtM(value) === 'Float32Array';
}
module.exports.isFloat32Array = $1219940a41485055$var$isFloat32Array;
function $1219940a41485055$var$isFloat64Array(value) {
    return $8fHtM(value) === 'Float64Array';
}
module.exports.isFloat64Array = $1219940a41485055$var$isFloat64Array;
function $1219940a41485055$var$isBigInt64Array(value) {
    return $8fHtM(value) === 'BigInt64Array';
}
module.exports.isBigInt64Array = $1219940a41485055$var$isBigInt64Array;
function $1219940a41485055$var$isBigUint64Array(value) {
    return $8fHtM(value) === 'BigUint64Array';
}
module.exports.isBigUint64Array = $1219940a41485055$var$isBigUint64Array;
function $1219940a41485055$var$isMapToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object Map]';
}
$1219940a41485055$var$isMapToString.working = typeof Map !== 'undefined' && $1219940a41485055$var$isMapToString(new Map());
function $1219940a41485055$var$isMap(value) {
    if (typeof Map === 'undefined') return false;
    return $1219940a41485055$var$isMapToString.working ? $1219940a41485055$var$isMapToString(value) : value instanceof Map;
}
module.exports.isMap = $1219940a41485055$var$isMap;
function $1219940a41485055$var$isSetToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object Set]';
}
$1219940a41485055$var$isSetToString.working = typeof Set !== 'undefined' && $1219940a41485055$var$isSetToString(new Set());
function $1219940a41485055$var$isSet(value) {
    if (typeof Set === 'undefined') return false;
    return $1219940a41485055$var$isSetToString.working ? $1219940a41485055$var$isSetToString(value) : value instanceof Set;
}
module.exports.isSet = $1219940a41485055$var$isSet;
function $1219940a41485055$var$isWeakMapToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object WeakMap]';
}
$1219940a41485055$var$isWeakMapToString.working = typeof WeakMap !== 'undefined' && $1219940a41485055$var$isWeakMapToString(new WeakMap());
function $1219940a41485055$var$isWeakMap(value) {
    if (typeof WeakMap === 'undefined') return false;
    return $1219940a41485055$var$isWeakMapToString.working ? $1219940a41485055$var$isWeakMapToString(value) : value instanceof WeakMap;
}
module.exports.isWeakMap = $1219940a41485055$var$isWeakMap;
function $1219940a41485055$var$isWeakSetToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object WeakSet]';
}
$1219940a41485055$var$isWeakSetToString.working = typeof WeakSet !== 'undefined' && $1219940a41485055$var$isWeakSetToString(new WeakSet());
function $1219940a41485055$var$isWeakSet(value) {
    return $1219940a41485055$var$isWeakSetToString(value);
}
module.exports.isWeakSet = $1219940a41485055$var$isWeakSet;
function $1219940a41485055$var$isArrayBufferToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object ArrayBuffer]';
}
$1219940a41485055$var$isArrayBufferToString.working = typeof ArrayBuffer !== 'undefined' && $1219940a41485055$var$isArrayBufferToString(new ArrayBuffer());
function $1219940a41485055$var$isArrayBuffer(value) {
    if (typeof ArrayBuffer === 'undefined') return false;
    return $1219940a41485055$var$isArrayBufferToString.working ? $1219940a41485055$var$isArrayBufferToString(value) : value instanceof ArrayBuffer;
}
module.exports.isArrayBuffer = $1219940a41485055$var$isArrayBuffer;
function $1219940a41485055$var$isDataViewToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object DataView]';
}
$1219940a41485055$var$isDataViewToString.working = typeof ArrayBuffer !== 'undefined' && typeof DataView !== 'undefined' && $1219940a41485055$var$isDataViewToString(new DataView(new ArrayBuffer(1), 0, 1));
function $1219940a41485055$var$isDataView(value) {
    if (typeof DataView === 'undefined') return false;
    return $1219940a41485055$var$isDataViewToString.working ? $1219940a41485055$var$isDataViewToString(value) : value instanceof DataView;
}
module.exports.isDataView = $1219940a41485055$var$isDataView;
// Store a copy of SharedArrayBuffer in case it's deleted elsewhere
var $1219940a41485055$var$SharedArrayBufferCopy = typeof SharedArrayBuffer !== 'undefined' ? SharedArrayBuffer : undefined;
function $1219940a41485055$var$isSharedArrayBufferToString(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object SharedArrayBuffer]';
}
function $1219940a41485055$var$isSharedArrayBuffer(value) {
    if (typeof $1219940a41485055$var$SharedArrayBufferCopy === 'undefined') return false;
    if (typeof $1219940a41485055$var$isSharedArrayBufferToString.working === 'undefined') $1219940a41485055$var$isSharedArrayBufferToString.working = $1219940a41485055$var$isSharedArrayBufferToString(new $1219940a41485055$var$SharedArrayBufferCopy());
    return $1219940a41485055$var$isSharedArrayBufferToString.working ? $1219940a41485055$var$isSharedArrayBufferToString(value) : value instanceof $1219940a41485055$var$SharedArrayBufferCopy;
}
module.exports.isSharedArrayBuffer = $1219940a41485055$var$isSharedArrayBuffer;
function $1219940a41485055$var$isAsyncFunction(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object AsyncFunction]';
}
module.exports.isAsyncFunction = $1219940a41485055$var$isAsyncFunction;
function $1219940a41485055$var$isMapIterator(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object Map Iterator]';
}
module.exports.isMapIterator = $1219940a41485055$var$isMapIterator;
function $1219940a41485055$var$isSetIterator(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object Set Iterator]';
}
module.exports.isSetIterator = $1219940a41485055$var$isSetIterator;
function $1219940a41485055$var$isGeneratorObject(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object Generator]';
}
module.exports.isGeneratorObject = $1219940a41485055$var$isGeneratorObject;
function $1219940a41485055$var$isWebAssemblyCompiledModule(value) {
    return $1219940a41485055$var$ObjectToString(value) === '[object WebAssembly.Module]';
}
module.exports.isWebAssemblyCompiledModule = $1219940a41485055$var$isWebAssemblyCompiledModule;
function $1219940a41485055$var$isNumberObject(value) {
    return $1219940a41485055$var$checkBoxedPrimitive(value, $1219940a41485055$var$numberValue);
}
module.exports.isNumberObject = $1219940a41485055$var$isNumberObject;
function $1219940a41485055$var$isStringObject(value) {
    return $1219940a41485055$var$checkBoxedPrimitive(value, $1219940a41485055$var$stringValue);
}
module.exports.isStringObject = $1219940a41485055$var$isStringObject;
function $1219940a41485055$var$isBooleanObject(value) {
    return $1219940a41485055$var$checkBoxedPrimitive(value, $1219940a41485055$var$booleanValue);
}
module.exports.isBooleanObject = $1219940a41485055$var$isBooleanObject;
function $1219940a41485055$var$isBigIntObject(value) {
    return $1219940a41485055$var$BigIntSupported && $1219940a41485055$var$checkBoxedPrimitive(value, $1219940a41485055$var$bigIntValue);
}
module.exports.isBigIntObject = $1219940a41485055$var$isBigIntObject;
function $1219940a41485055$var$isSymbolObject(value) {
    return $1219940a41485055$var$SymbolSupported && $1219940a41485055$var$checkBoxedPrimitive(value, $1219940a41485055$var$symbolValue);
}
module.exports.isSymbolObject = $1219940a41485055$var$isSymbolObject;
function $1219940a41485055$var$isBoxedPrimitive(value) {
    return $1219940a41485055$var$isNumberObject(value) || $1219940a41485055$var$isStringObject(value) || $1219940a41485055$var$isBooleanObject(value) || $1219940a41485055$var$isBigIntObject(value) || $1219940a41485055$var$isSymbolObject(value);
}
module.exports.isBoxedPrimitive = $1219940a41485055$var$isBoxedPrimitive;
function $1219940a41485055$var$isAnyArrayBuffer(value) {
    return typeof Uint8Array !== 'undefined' && ($1219940a41485055$var$isArrayBuffer(value) || $1219940a41485055$var$isSharedArrayBuffer(value));
}
module.exports.isAnyArrayBuffer = $1219940a41485055$var$isAnyArrayBuffer;
[
    'isProxy',
    'isExternal',
    'isModuleNamespaceObject'
].forEach(function(method) {
    Object.defineProperty(module.exports, method, {
        enumerable: false,
        value: function() {
            throw new Error(method + ' is not supported in userland');
        }
    });
});

});
parcelRegister("4KueG", function(module, exports) {
'use strict';

var $3752e98270cf5c7d$var$hasToStringTag = (parcelRequire("1sJBe"))();

var $h0KKk = parcelRequire("h0KKk");
var $3752e98270cf5c7d$var$$toString = $h0KKk('Object.prototype.toString');
/** @type {import('.')} */ var $3752e98270cf5c7d$var$isStandardArguments = function isArguments(value) {
    if ($3752e98270cf5c7d$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $3752e98270cf5c7d$var$$toString(value) === '[object Arguments]';
};
/** @type {import('.')} */ var $3752e98270cf5c7d$var$isLegacyArguments = function isArguments(value) {
    if ($3752e98270cf5c7d$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && 'length' in value && typeof value.length === 'number' && value.length >= 0 && $3752e98270cf5c7d$var$$toString(value) !== '[object Array]' && 'callee' in value && $3752e98270cf5c7d$var$$toString(value.callee) === '[object Function]';
};
var $3752e98270cf5c7d$var$supportsStandardArguments = function() {
    return $3752e98270cf5c7d$var$isStandardArguments(arguments);
}();
// @ts-expect-error TODO make this not error
$3752e98270cf5c7d$var$isStandardArguments.isLegacyArguments = $3752e98270cf5c7d$var$isLegacyArguments; // for tests
/** @type {import('.')} */ module.exports = $3752e98270cf5c7d$var$supportsStandardArguments ? $3752e98270cf5c7d$var$isStandardArguments : $3752e98270cf5c7d$var$isLegacyArguments;

});
parcelRegister("1sJBe", function(module, exports) {
'use strict';

var $2l4Mc = parcelRequire("2l4Mc");
/** @type {import('.')} */ module.exports = function hasToStringTagShams() {
    return $2l4Mc() && !!Symbol.toStringTag;
};

});
parcelRegister("2l4Mc", function(module, exports) {
'use strict';
/** @type {import('./shams')} */ /* eslint complexity: [2, 18], max-statements: [2, 33] */ module.exports = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    /** @type {{ [k in symbol]?: unknown }} */ var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
    // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(var _ in obj)return false;
     // eslint-disable-line no-restricted-syntax, no-unreachable-loop
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {PropertyDescriptor} */ Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};

});


parcelRegister("h0KKk", function(module, exports) {
'use strict';

var $g7Yvk = parcelRequire("g7Yvk");

var $atInl = parcelRequire("atInl");
/** @type {(thisArg: string, searchString: string, position?: number) => number} */ var $c626b291234cc933$var$$indexOf = $atInl([
    $g7Yvk('%String.prototype.indexOf%')
]);
/** @type {import('.')} */ module.exports = function callBoundIntrinsic(name, allowMissing) {
    /* eslint no-extra-parens: 0 */ var intrinsic = /** @type {(this: unknown, ...args: unknown[]) => unknown} */ $g7Yvk(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $c626b291234cc933$var$$indexOf(name, '.prototype.') > -1) return $atInl(/** @type {const} */ [
        intrinsic
    ]);
    return intrinsic;
};

});
parcelRegister("g7Yvk", function(module, exports) {
'use strict';
var $bbdc3baf8c080197$var$undefined1;

var $lUbLd = parcelRequire("lUbLd");

var $bw8br = parcelRequire("bw8br");

var $40xYJ = parcelRequire("40xYJ");

var $34vN1 = parcelRequire("34vN1");

var $hva57 = parcelRequire("hva57");

var $5XyxM = parcelRequire("5XyxM");

var $45GSV = parcelRequire("45GSV");

var $aUKt4 = parcelRequire("aUKt4");

var $a0xs5 = parcelRequire("a0xs5");

var $1dnug = parcelRequire("1dnug");

var $1VAw8 = parcelRequire("1VAw8");

var $1vWaN = parcelRequire("1vWaN");

var $6Xnhr = parcelRequire("6Xnhr");

var $ePMVo = parcelRequire("ePMVo");

var $j1xOv = parcelRequire("j1xOv");
var $bbdc3baf8c080197$var$$Function = Function;
// eslint-disable-next-line consistent-return
var $bbdc3baf8c080197$var$getEvalledConstructor = function(expressionSyntax) {
    try {
        return $bbdc3baf8c080197$var$$Function('"use strict"; return (' + expressionSyntax + ').constructor;')();
    } catch (e) {}
};

var $l2i8c = parcelRequire("l2i8c");

var $eDaYG = parcelRequire("eDaYG");
var $bbdc3baf8c080197$var$throwTypeError = function() {
    throw new $45GSV();
};
var $bbdc3baf8c080197$var$ThrowTypeError = $l2i8c ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $bbdc3baf8c080197$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $l2i8c(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $bbdc3baf8c080197$var$throwTypeError;
        }
    }
}() : $bbdc3baf8c080197$var$throwTypeError;

var $bbdc3baf8c080197$var$hasSymbols = (parcelRequire("16s9W"))();

var $5S5RK = parcelRequire("5S5RK");

var $lKuAx = parcelRequire("lKuAx");

var $gC03P = parcelRequire("gC03P");

var $3KV1t = parcelRequire("3KV1t");

var $jlHNz = parcelRequire("jlHNz");
var $bbdc3baf8c080197$var$needsEval = {};
var $bbdc3baf8c080197$var$TypedArray = typeof Uint8Array === 'undefined' || !$5S5RK ? undefined : $5S5RK(Uint8Array);
var $bbdc3baf8c080197$var$INTRINSICS = {
    __proto__: null,
    '%AggregateError%': typeof AggregateError === 'undefined' ? undefined : AggregateError,
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? undefined : ArrayBuffer,
    '%ArrayIteratorPrototype%': $bbdc3baf8c080197$var$hasSymbols && $5S5RK ? $5S5RK([][Symbol.iterator]()) : undefined,
    '%AsyncFromSyncIteratorPrototype%': undefined,
    '%AsyncFunction%': $bbdc3baf8c080197$var$needsEval,
    '%AsyncGenerator%': $bbdc3baf8c080197$var$needsEval,
    '%AsyncGeneratorFunction%': $bbdc3baf8c080197$var$needsEval,
    '%AsyncIteratorPrototype%': $bbdc3baf8c080197$var$needsEval,
    '%Atomics%': typeof Atomics === 'undefined' ? undefined : Atomics,
    '%BigInt%': typeof BigInt === 'undefined' ? undefined : BigInt,
    '%BigInt64Array%': typeof BigInt64Array === 'undefined' ? undefined : BigInt64Array,
    '%BigUint64Array%': typeof BigUint64Array === 'undefined' ? undefined : BigUint64Array,
    '%Boolean%': Boolean,
    '%DataView%': typeof DataView === 'undefined' ? undefined : DataView,
    '%Date%': Date,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': $bw8br,
    '%eval%': eval,
    '%EvalError%': $40xYJ,
    '%Float16Array%': typeof Float16Array === 'undefined' ? undefined : Float16Array,
    '%Float32Array%': typeof Float32Array === 'undefined' ? undefined : Float32Array,
    '%Float64Array%': typeof Float64Array === 'undefined' ? undefined : Float64Array,
    '%FinalizationRegistry%': typeof FinalizationRegistry === 'undefined' ? undefined : FinalizationRegistry,
    '%Function%': $bbdc3baf8c080197$var$$Function,
    '%GeneratorFunction%': $bbdc3baf8c080197$var$needsEval,
    '%Int8Array%': typeof Int8Array === 'undefined' ? undefined : Int8Array,
    '%Int16Array%': typeof Int16Array === 'undefined' ? undefined : Int16Array,
    '%Int32Array%': typeof Int32Array === 'undefined' ? undefined : Int32Array,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $bbdc3baf8c080197$var$hasSymbols && $5S5RK ? $5S5RK($5S5RK([][Symbol.iterator]())) : undefined,
    '%JSON%': typeof JSON === 'object' ? JSON : undefined,
    '%Map%': typeof Map === 'undefined' ? undefined : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$bbdc3baf8c080197$var$hasSymbols || !$5S5RK ? undefined : $5S5RK(new Map()[Symbol.iterator]()),
    '%Math%': Math,
    '%Number%': Number,
    '%Object%': $lUbLd,
    '%Object.getOwnPropertyDescriptor%': $l2i8c,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? undefined : Promise,
    '%Proxy%': typeof Proxy === 'undefined' ? undefined : Proxy,
    '%RangeError%': $34vN1,
    '%ReferenceError%': $hva57,
    '%Reflect%': typeof Reflect === 'undefined' ? undefined : Reflect,
    '%RegExp%': RegExp,
    '%Set%': typeof Set === 'undefined' ? undefined : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$bbdc3baf8c080197$var$hasSymbols || !$5S5RK ? undefined : $5S5RK(new Set()[Symbol.iterator]()),
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? undefined : SharedArrayBuffer,
    '%String%': String,
    '%StringIteratorPrototype%': $bbdc3baf8c080197$var$hasSymbols && $5S5RK ? $5S5RK(''[Symbol.iterator]()) : undefined,
    '%Symbol%': $bbdc3baf8c080197$var$hasSymbols ? Symbol : undefined,
    '%SyntaxError%': $5XyxM,
    '%ThrowTypeError%': $bbdc3baf8c080197$var$ThrowTypeError,
    '%TypedArray%': $bbdc3baf8c080197$var$TypedArray,
    '%TypeError%': $45GSV,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? undefined : Uint8Array,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? undefined : Uint8ClampedArray,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? undefined : Uint16Array,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? undefined : Uint32Array,
    '%URIError%': $aUKt4,
    '%WeakMap%': typeof WeakMap === 'undefined' ? undefined : WeakMap,
    '%WeakRef%': typeof WeakRef === 'undefined' ? undefined : WeakRef,
    '%WeakSet%': typeof WeakSet === 'undefined' ? undefined : WeakSet,
    '%Function.prototype.call%': $jlHNz,
    '%Function.prototype.apply%': $3KV1t,
    '%Object.defineProperty%': $eDaYG,
    '%Object.getPrototypeOf%': $lKuAx,
    '%Math.abs%': $a0xs5,
    '%Math.floor%': $1dnug,
    '%Math.max%': $1VAw8,
    '%Math.min%': $1vWaN,
    '%Math.pow%': $6Xnhr,
    '%Math.round%': $ePMVo,
    '%Math.sign%': $j1xOv,
    '%Reflect.getPrototypeOf%': $gC03P
};
if ($5S5RK) try {
    null.error; // eslint-disable-line no-unused-expressions
} catch (e) {
    // https://github.com/tc39/proposal-shadowrealm/pull/384#issuecomment-1364264229
    var $bbdc3baf8c080197$var$errorProto = $5S5RK($5S5RK(e));
    $bbdc3baf8c080197$var$INTRINSICS['%Error.prototype%'] = $bbdc3baf8c080197$var$errorProto;
}
var $bbdc3baf8c080197$var$doEval = function doEval(name) {
    var value;
    if (name === '%AsyncFunction%') value = $bbdc3baf8c080197$var$getEvalledConstructor('async function () {}');
    else if (name === '%GeneratorFunction%') value = $bbdc3baf8c080197$var$getEvalledConstructor('function* () {}');
    else if (name === '%AsyncGeneratorFunction%') value = $bbdc3baf8c080197$var$getEvalledConstructor('async function* () {}');
    else if (name === '%AsyncGenerator%') {
        var fn = doEval('%AsyncGeneratorFunction%');
        if (fn) value = fn.prototype;
    } else if (name === '%AsyncIteratorPrototype%') {
        var gen = doEval('%AsyncGenerator%');
        if (gen && $5S5RK) value = $5S5RK(gen.prototype);
    }
    $bbdc3baf8c080197$var$INTRINSICS[name] = value;
    return value;
};
var $bbdc3baf8c080197$var$LEGACY_ALIASES = {
    __proto__: null,
    '%ArrayBufferPrototype%': [
        'ArrayBuffer',
        'prototype'
    ],
    '%ArrayPrototype%': [
        'Array',
        'prototype'
    ],
    '%ArrayProto_entries%': [
        'Array',
        'prototype',
        'entries'
    ],
    '%ArrayProto_forEach%': [
        'Array',
        'prototype',
        'forEach'
    ],
    '%ArrayProto_keys%': [
        'Array',
        'prototype',
        'keys'
    ],
    '%ArrayProto_values%': [
        'Array',
        'prototype',
        'values'
    ],
    '%AsyncFunctionPrototype%': [
        'AsyncFunction',
        'prototype'
    ],
    '%AsyncGenerator%': [
        'AsyncGeneratorFunction',
        'prototype'
    ],
    '%AsyncGeneratorPrototype%': [
        'AsyncGeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%BooleanPrototype%': [
        'Boolean',
        'prototype'
    ],
    '%DataViewPrototype%': [
        'DataView',
        'prototype'
    ],
    '%DatePrototype%': [
        'Date',
        'prototype'
    ],
    '%ErrorPrototype%': [
        'Error',
        'prototype'
    ],
    '%EvalErrorPrototype%': [
        'EvalError',
        'prototype'
    ],
    '%Float32ArrayPrototype%': [
        'Float32Array',
        'prototype'
    ],
    '%Float64ArrayPrototype%': [
        'Float64Array',
        'prototype'
    ],
    '%FunctionPrototype%': [
        'Function',
        'prototype'
    ],
    '%Generator%': [
        'GeneratorFunction',
        'prototype'
    ],
    '%GeneratorPrototype%': [
        'GeneratorFunction',
        'prototype',
        'prototype'
    ],
    '%Int8ArrayPrototype%': [
        'Int8Array',
        'prototype'
    ],
    '%Int16ArrayPrototype%': [
        'Int16Array',
        'prototype'
    ],
    '%Int32ArrayPrototype%': [
        'Int32Array',
        'prototype'
    ],
    '%JSONParse%': [
        'JSON',
        'parse'
    ],
    '%JSONStringify%': [
        'JSON',
        'stringify'
    ],
    '%MapPrototype%': [
        'Map',
        'prototype'
    ],
    '%NumberPrototype%': [
        'Number',
        'prototype'
    ],
    '%ObjectPrototype%': [
        'Object',
        'prototype'
    ],
    '%ObjProto_toString%': [
        'Object',
        'prototype',
        'toString'
    ],
    '%ObjProto_valueOf%': [
        'Object',
        'prototype',
        'valueOf'
    ],
    '%PromisePrototype%': [
        'Promise',
        'prototype'
    ],
    '%PromiseProto_then%': [
        'Promise',
        'prototype',
        'then'
    ],
    '%Promise_all%': [
        'Promise',
        'all'
    ],
    '%Promise_reject%': [
        'Promise',
        'reject'
    ],
    '%Promise_resolve%': [
        'Promise',
        'resolve'
    ],
    '%RangeErrorPrototype%': [
        'RangeError',
        'prototype'
    ],
    '%ReferenceErrorPrototype%': [
        'ReferenceError',
        'prototype'
    ],
    '%RegExpPrototype%': [
        'RegExp',
        'prototype'
    ],
    '%SetPrototype%': [
        'Set',
        'prototype'
    ],
    '%SharedArrayBufferPrototype%': [
        'SharedArrayBuffer',
        'prototype'
    ],
    '%StringPrototype%': [
        'String',
        'prototype'
    ],
    '%SymbolPrototype%': [
        'Symbol',
        'prototype'
    ],
    '%SyntaxErrorPrototype%': [
        'SyntaxError',
        'prototype'
    ],
    '%TypedArrayPrototype%': [
        'TypedArray',
        'prototype'
    ],
    '%TypeErrorPrototype%': [
        'TypeError',
        'prototype'
    ],
    '%Uint8ArrayPrototype%': [
        'Uint8Array',
        'prototype'
    ],
    '%Uint8ClampedArrayPrototype%': [
        'Uint8ClampedArray',
        'prototype'
    ],
    '%Uint16ArrayPrototype%': [
        'Uint16Array',
        'prototype'
    ],
    '%Uint32ArrayPrototype%': [
        'Uint32Array',
        'prototype'
    ],
    '%URIErrorPrototype%': [
        'URIError',
        'prototype'
    ],
    '%WeakMapPrototype%': [
        'WeakMap',
        'prototype'
    ],
    '%WeakSetPrototype%': [
        'WeakSet',
        'prototype'
    ]
};

var $iI0CX = parcelRequire("iI0CX");

var $3Hyd5 = parcelRequire("3Hyd5");
var $bbdc3baf8c080197$var$$concat = $iI0CX.call($jlHNz, Array.prototype.concat);
var $bbdc3baf8c080197$var$$spliceApply = $iI0CX.call($3KV1t, Array.prototype.splice);
var $bbdc3baf8c080197$var$$replace = $iI0CX.call($jlHNz, String.prototype.replace);
var $bbdc3baf8c080197$var$$strSlice = $iI0CX.call($jlHNz, String.prototype.slice);
var $bbdc3baf8c080197$var$$exec = $iI0CX.call($jlHNz, RegExp.prototype.exec);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $bbdc3baf8c080197$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $bbdc3baf8c080197$var$reEscapeChar = /\\(\\)?/g; /** Used to match backslashes in property paths. */ 
var $bbdc3baf8c080197$var$stringToPath = function stringToPath(string) {
    var first = $bbdc3baf8c080197$var$$strSlice(string, 0, 1);
    var last = $bbdc3baf8c080197$var$$strSlice(string, -1);
    if (first === '%' && last !== '%') throw new $5XyxM('invalid intrinsic syntax, expected closing `%`');
    else if (last === '%' && first !== '%') throw new $5XyxM('invalid intrinsic syntax, expected opening `%`');
    var result = [];
    $bbdc3baf8c080197$var$$replace(string, $bbdc3baf8c080197$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $bbdc3baf8c080197$var$$replace(subString, $bbdc3baf8c080197$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $bbdc3baf8c080197$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    var intrinsicName = name;
    var alias;
    if ($3Hyd5($bbdc3baf8c080197$var$LEGACY_ALIASES, intrinsicName)) {
        alias = $bbdc3baf8c080197$var$LEGACY_ALIASES[intrinsicName];
        intrinsicName = '%' + alias[0] + '%';
    }
    if ($3Hyd5($bbdc3baf8c080197$var$INTRINSICS, intrinsicName)) {
        var value = $bbdc3baf8c080197$var$INTRINSICS[intrinsicName];
        if (value === $bbdc3baf8c080197$var$needsEval) value = $bbdc3baf8c080197$var$doEval(intrinsicName);
        if (typeof value === 'undefined' && !allowMissing) throw new $45GSV('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
        return {
            alias: alias,
            name: intrinsicName,
            value: value
        };
    }
    throw new $5XyxM('intrinsic ' + name + ' does not exist!');
};
module.exports = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new $45GSV('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new $45GSV('"allowMissing" argument must be a boolean');
    if ($bbdc3baf8c080197$var$$exec(/^%?[^%]*%?$/, name) === null) throw new $5XyxM('`%` may not be present anywhere but at the beginning and end of the intrinsic name');
    var parts = $bbdc3baf8c080197$var$stringToPath(name);
    var intrinsicBaseName = parts.length > 0 ? parts[0] : '';
    var intrinsic = $bbdc3baf8c080197$var$getBaseIntrinsic('%' + intrinsicBaseName + '%', allowMissing);
    var intrinsicRealName = intrinsic.name;
    var value = intrinsic.value;
    var skipFurtherCaching = false;
    var alias = intrinsic.alias;
    if (alias) {
        intrinsicBaseName = alias[0];
        $bbdc3baf8c080197$var$$spliceApply(parts, $bbdc3baf8c080197$var$$concat([
            0,
            1
        ], alias));
    }
    for(var i = 1, isOwn = true; i < parts.length; i += 1){
        var part = parts[i];
        var first = $bbdc3baf8c080197$var$$strSlice(part, 0, 1);
        var last = $bbdc3baf8c080197$var$$strSlice(part, -1);
        if ((first === '"' || first === "'" || first === '`' || last === '"' || last === "'" || last === '`') && first !== last) throw new $5XyxM('property names with quotes must have matching quotes');
        if (part === 'constructor' || !isOwn) skipFurtherCaching = true;
        intrinsicBaseName += '.' + part;
        intrinsicRealName = '%' + intrinsicBaseName + '%';
        if ($3Hyd5($bbdc3baf8c080197$var$INTRINSICS, intrinsicRealName)) value = $bbdc3baf8c080197$var$INTRINSICS[intrinsicRealName];
        else if (value != null) {
            if (!(part in value)) {
                if (!allowMissing) throw new $45GSV('base intrinsic for ' + name + ' exists, but the property is not available.');
                return void 0;
            }
            if ($l2i8c && i + 1 >= parts.length) {
                var desc = $l2i8c(value, part);
                isOwn = !!desc;
                // By convention, when a data property is converted to an accessor
                // property to emulate a data property that does not suffer from
                // the override mistake, that accessor's getter is marked with
                // an `originalValue` property. Here, when we detect this, we
                // uphold the illusion by pretending to see that original data
                // property, i.e., returning the value rather than the getter
                // itself.
                if (isOwn && 'get' in desc && !('originalValue' in desc.get)) value = desc.get;
                else value = value[part];
            } else {
                isOwn = $3Hyd5(value, part);
                value = value[part];
            }
            if (isOwn && !skipFurtherCaching) $bbdc3baf8c080197$var$INTRINSICS[intrinsicRealName] = value;
        }
    }
    return value;
};

});
parcelRegister("lUbLd", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Object;

});

parcelRegister("bw8br", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = Error;

});

parcelRegister("40xYJ", function(module, exports) {
'use strict';
/** @type {import('./eval')} */ module.exports = EvalError;

});

parcelRegister("34vN1", function(module, exports) {
'use strict';
/** @type {import('./range')} */ module.exports = RangeError;

});

parcelRegister("hva57", function(module, exports) {
'use strict';
/** @type {import('./ref')} */ module.exports = ReferenceError;

});

parcelRegister("5XyxM", function(module, exports) {
'use strict';
/** @type {import('./syntax')} */ module.exports = SyntaxError;

});

parcelRegister("45GSV", function(module, exports) {
'use strict';
/** @type {import('./type')} */ module.exports = TypeError;

});

parcelRegister("aUKt4", function(module, exports) {
'use strict';
/** @type {import('./uri')} */ module.exports = URIError;

});

parcelRegister("a0xs5", function(module, exports) {
'use strict';
/** @type {import('./abs')} */ module.exports = Math.abs;

});

parcelRegister("1dnug", function(module, exports) {
'use strict';
/** @type {import('./floor')} */ module.exports = Math.floor;

});

parcelRegister("1VAw8", function(module, exports) {
'use strict';
/** @type {import('./max')} */ module.exports = Math.max;

});

parcelRegister("1vWaN", function(module, exports) {
'use strict';
/** @type {import('./min')} */ module.exports = Math.min;

});

parcelRegister("6Xnhr", function(module, exports) {
'use strict';
/** @type {import('./pow')} */ module.exports = Math.pow;

});

parcelRegister("ePMVo", function(module, exports) {
'use strict';
/** @type {import('./round')} */ module.exports = Math.round;

});

parcelRegister("j1xOv", function(module, exports) {
'use strict';

var $bgsek = parcelRequire("bgsek");
/** @type {import('./sign')} */ module.exports = function sign(number) {
    if ($bgsek(number) || number === 0) return number;
    return number < 0 ? -1 : 1;
};

});
parcelRegister("bgsek", function(module, exports) {
'use strict';
/** @type {import('./isNaN')} */ module.exports = Number.isNaN || function isNaN(a) {
    return a !== a;
};

});


parcelRegister("l2i8c", function(module, exports) {
'use strict';

var $9VMjV = parcelRequire("9VMjV");
var $f507d95ce8abce1b$require$$gOPD = $9VMjV;
if ($f507d95ce8abce1b$require$$gOPD) try {
    $f507d95ce8abce1b$require$$gOPD([], 'length');
} catch (e) {
    // IE 8 has a broken gOPD
    $f507d95ce8abce1b$require$$gOPD = null;
}
module.exports = $f507d95ce8abce1b$require$$gOPD;

});
parcelRegister("9VMjV", function(module, exports) {
'use strict';
/** @type {import('./gOPD')} */ module.exports = Object.getOwnPropertyDescriptor;

});


parcelRegister("eDaYG", function(module, exports) {
'use strict';
/** @type {import('.')} */ var $aa6d392ebd77c3c2$var$$defineProperty = Object.defineProperty || false;
if ($aa6d392ebd77c3c2$var$$defineProperty) try {
    $aa6d392ebd77c3c2$var$$defineProperty({}, 'a', {
        value: 1
    });
} catch (e) {
    // IE 8 has a broken defineProperty
    $aa6d392ebd77c3c2$var$$defineProperty = false;
}
module.exports = $aa6d392ebd77c3c2$var$$defineProperty;

});

parcelRegister("16s9W", function(module, exports) {
'use strict';
var $0cdc31dbc05f8b6d$var$origSymbol = typeof Symbol !== 'undefined' && Symbol;

var $2l4Mc = parcelRequire("2l4Mc");
/** @type {import('.')} */ module.exports = function hasNativeSymbols() {
    if (typeof $0cdc31dbc05f8b6d$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $0cdc31dbc05f8b6d$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $2l4Mc();
};

});

parcelRegister("5S5RK", function(module, exports) {
'use strict';

var $gC03P = parcelRequire("gC03P");

var $lKuAx = parcelRequire("lKuAx");

var $eu9rg = parcelRequire("eu9rg");
/** @type {import('.')} */ module.exports = $gC03P ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $gC03P(O);
} : $lKuAx ? function getProto(O) {
    if (!O || typeof O !== 'object' && typeof O !== 'function') throw new TypeError('getProto: not an object');
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $lKuAx(O);
} : $eu9rg ? function getProto(O) {
    // @ts-expect-error TS can't narrow inside a closure, for some reason
    return $eu9rg(O);
} : null;

});
parcelRegister("gC03P", function(module, exports) {
'use strict';
/** @type {import('./Reflect.getPrototypeOf')} */ module.exports = typeof Reflect !== 'undefined' && Reflect.getPrototypeOf || null;

});

parcelRegister("lKuAx", function(module, exports) {
'use strict';

var $lUbLd = parcelRequire("lUbLd");
/** @type {import('./Object.getPrototypeOf')} */ module.exports = $lUbLd.getPrototypeOf || null;

});

parcelRegister("eu9rg", function(module, exports) {
'use strict';

var $atInl = parcelRequire("atInl");

var $l2i8c = parcelRequire("l2i8c");
var $a8bb305d6cbe44e0$var$hasProtoAccessor;
try {
    // eslint-disable-next-line no-extra-parens, no-proto
    $a8bb305d6cbe44e0$var$hasProtoAccessor = /** @type {{ __proto__?: typeof Array.prototype }} */ [].__proto__ === Array.prototype;
} catch (e) {
    if (!e || typeof e !== 'object' || !('code' in e) || e.code !== 'ERR_PROTO_ACCESS') throw e;
}
// eslint-disable-next-line no-extra-parens
var $a8bb305d6cbe44e0$var$desc = !!$a8bb305d6cbe44e0$var$hasProtoAccessor && $l2i8c && $l2i8c(Object.prototype, /** @type {keyof typeof Object.prototype} */ '__proto__');
var $a8bb305d6cbe44e0$var$$Object = Object;
var $a8bb305d6cbe44e0$var$$getPrototypeOf = $a8bb305d6cbe44e0$var$$Object.getPrototypeOf;
/** @type {import('./get')} */ module.exports = $a8bb305d6cbe44e0$var$desc && typeof $a8bb305d6cbe44e0$var$desc.get === 'function' ? $atInl([
    $a8bb305d6cbe44e0$var$desc.get
]) : typeof $a8bb305d6cbe44e0$var$$getPrototypeOf === 'function' ? /** @type {import('./get')} */ function getDunder(value) {
    // eslint-disable-next-line eqeqeq
    return $a8bb305d6cbe44e0$var$$getPrototypeOf(value == null ? value : $a8bb305d6cbe44e0$var$$Object(value));
} : false;

});
parcelRegister("atInl", function(module, exports) {
'use strict';

var $iI0CX = parcelRequire("iI0CX");

var $45GSV = parcelRequire("45GSV");

var $jlHNz = parcelRequire("jlHNz");

var $6AR0q = parcelRequire("6AR0q");
/** @type {(args: [Function, thisArg?: unknown, ...args: unknown[]]) => Function} TODO FIXME, find a way to use import('.') */ module.exports = function callBindBasic(args) {
    if (args.length < 1 || typeof args[0] !== 'function') throw new $45GSV('a function is required');
    return $6AR0q($iI0CX, $jlHNz, args);
};

});
parcelRegister("iI0CX", function(module, exports) {
'use strict';

var $99gDf = parcelRequire("99gDf");
module.exports = Function.prototype.bind || $99gDf;

});
parcelRegister("99gDf", function(module, exports) {
'use strict';
/* eslint no-invalid-this: 1 */ var $6a91db1e09cd634b$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $6a91db1e09cd634b$var$toStr = Object.prototype.toString;
var $6a91db1e09cd634b$var$max = Math.max;
var $6a91db1e09cd634b$var$funcType = '[object Function]';
var $6a91db1e09cd634b$var$concatty = function concatty(a, b) {
    var arr = [];
    for(var i = 0; i < a.length; i += 1)arr[i] = a[i];
    for(var j = 0; j < b.length; j += 1)arr[j + a.length] = b[j];
    return arr;
};
var $6a91db1e09cd634b$var$slicy = function slicy(arrLike, offset) {
    var arr = [];
    for(var i = offset || 0, j = 0; i < arrLike.length; i += 1, j += 1)arr[j] = arrLike[i];
    return arr;
};
var $6a91db1e09cd634b$var$joiny = function(arr, joiner) {
    var str = '';
    for(var i = 0; i < arr.length; i += 1){
        str += arr[i];
        if (i + 1 < arr.length) str += joiner;
    }
    return str;
};
module.exports = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $6a91db1e09cd634b$var$toStr.apply(target) !== $6a91db1e09cd634b$var$funcType) throw new TypeError($6a91db1e09cd634b$var$ERROR_MESSAGE + target);
    var args = $6a91db1e09cd634b$var$slicy(arguments, 1);
    var bound;
    var binder = function() {
        if (this instanceof bound) {
            var result = target.apply(this, $6a91db1e09cd634b$var$concatty(args, arguments));
            if (Object(result) === result) return result;
            return this;
        }
        return target.apply(that, $6a91db1e09cd634b$var$concatty(args, arguments));
    };
    var boundLength = $6a91db1e09cd634b$var$max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs[i] = '$' + i;
    bound = Function('binder', 'return function (' + $6a91db1e09cd634b$var$joiny(boundArgs, ',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};

});


parcelRegister("jlHNz", function(module, exports) {
'use strict';
/** @type {import('./functionCall')} */ module.exports = Function.prototype.call;

});

parcelRegister("6AR0q", function(module, exports) {
'use strict';

var $iI0CX = parcelRequire("iI0CX");

var $3KV1t = parcelRequire("3KV1t");

var $jlHNz = parcelRequire("jlHNz");

var $cayzb = parcelRequire("cayzb");
/** @type {import('./actualApply')} */ module.exports = $cayzb || $iI0CX.call($jlHNz, $3KV1t);

});
parcelRegister("3KV1t", function(module, exports) {
'use strict';
/** @type {import('./functionApply')} */ module.exports = Function.prototype.apply;

});

parcelRegister("cayzb", function(module, exports) {
'use strict';
/** @type {import('./reflectApply')} */ module.exports = typeof Reflect !== 'undefined' && Reflect && Reflect.apply;

});





parcelRegister("3Hyd5", function(module, exports) {
'use strict';
var $2b1feca490292c65$var$call = Function.prototype.call;
var $2b1feca490292c65$var$$hasOwn = Object.prototype.hasOwnProperty;

var $iI0CX = parcelRequire("iI0CX");
/** @type {import('.')} */ module.exports = $iI0CX.call($2b1feca490292c65$var$call, $2b1feca490292c65$var$$hasOwn);

});




parcelRegister("6KKQe", function(module, exports) {
'use strict';

var $h0KKk = parcelRequire("h0KKk");

var $jNgmq = parcelRequire("jNgmq");
var $4eab5fb6f7eb81bf$var$isFnRegex = $jNgmq(/^\s*(?:function)?\*/);

var $4eab5fb6f7eb81bf$var$hasToStringTag = (parcelRequire("1sJBe"))();

var $5S5RK = parcelRequire("5S5RK");
var $4eab5fb6f7eb81bf$var$toStr = $h0KKk('Object.prototype.toString');
var $4eab5fb6f7eb81bf$var$fnToStr = $h0KKk('Function.prototype.toString');

var $4PqiK = parcelRequire("4PqiK");
/** @type {import('.')} */ module.exports = function isGeneratorFunction(fn) {
    if (typeof fn !== 'function') return false;
    if ($4eab5fb6f7eb81bf$var$isFnRegex($4eab5fb6f7eb81bf$var$fnToStr(fn))) return true;
    if (!$4eab5fb6f7eb81bf$var$hasToStringTag) {
        var str = $4eab5fb6f7eb81bf$var$toStr(fn);
        return str === '[object GeneratorFunction]';
    }
    if (!$5S5RK) return false;
    var GeneratorFunction = $4PqiK();
    return GeneratorFunction && $5S5RK(fn) === GeneratorFunction.prototype;
};

});
parcelRegister("jNgmq", function(module, exports) {
'use strict';

var $h0KKk = parcelRequire("h0KKk");

var $bEPCD = parcelRequire("bEPCD");
var $e68f48cb6e959158$var$$exec = $h0KKk('RegExp.prototype.exec');

var $45GSV = parcelRequire("45GSV");
/** @type {import('.')} */ module.exports = function regexTester(regex) {
    if (!$bEPCD(regex)) throw new $45GSV('`regex` must be a RegExp');
    return function test(s) {
        return $e68f48cb6e959158$var$$exec(regex, s) !== null;
    };
};

});
parcelRegister("bEPCD", function(module, exports) {
'use strict';

var $h0KKk = parcelRequire("h0KKk");

var $87cb793d69ea828f$var$hasToStringTag = (parcelRequire("1sJBe"))();

var $3Hyd5 = parcelRequire("3Hyd5");

var $l2i8c = parcelRequire("l2i8c");
/** @type {import('.')} */ var $87cb793d69ea828f$var$fn;
if ($87cb793d69ea828f$var$hasToStringTag) {
    /** @type {(receiver: ThisParameterType<typeof RegExp.prototype.exec>, ...args: Parameters<typeof RegExp.prototype.exec>) => ReturnType<typeof RegExp.prototype.exec>} */ var $87cb793d69ea828f$var$$exec = $h0KKk('RegExp.prototype.exec');
    /** @type {object} */ var $87cb793d69ea828f$var$isRegexMarker = {};
    var $87cb793d69ea828f$var$throwRegexMarker = function() {
        throw $87cb793d69ea828f$var$isRegexMarker;
    };
    /** @type {{ toString(): never, valueOf(): never, [Symbol.toPrimitive]?(): never }} */ var $87cb793d69ea828f$var$badStringifier = {
        toString: $87cb793d69ea828f$var$throwRegexMarker,
        valueOf: $87cb793d69ea828f$var$throwRegexMarker
    };
    if (typeof Symbol.toPrimitive === 'symbol') $87cb793d69ea828f$var$badStringifier[Symbol.toPrimitive] = $87cb793d69ea828f$var$throwRegexMarker;
    /** @type {import('.')} */ // @ts-expect-error TS can't figure out that the $exec call always throws
    // eslint-disable-next-line consistent-return
    $87cb793d69ea828f$var$fn = function isRegex(value) {
        if (!value || typeof value !== 'object') return false;
        // eslint-disable-next-line no-extra-parens
        var descriptor = /** @type {NonNullable<typeof gOPD>} */ $l2i8c(/** @type {{ lastIndex?: unknown }} */ value, 'lastIndex');
        var hasLastIndexDataProperty = descriptor && $3Hyd5(descriptor, 'value');
        if (!hasLastIndexDataProperty) return false;
        try {
            // eslint-disable-next-line no-extra-parens
            $87cb793d69ea828f$var$$exec(value, /** @type {unknown} */ $87cb793d69ea828f$var$badStringifier);
        } catch (e) {
            return e === $87cb793d69ea828f$var$isRegexMarker;
        }
    };
} else {
    /** @type {(receiver: ThisParameterType<typeof Object.prototype.toString>, ...args: Parameters<typeof Object.prototype.toString>) => ReturnType<typeof Object.prototype.toString>} */ var $87cb793d69ea828f$var$$toString = $h0KKk('Object.prototype.toString');
    /** @const @type {'[object RegExp]'} */ var $87cb793d69ea828f$var$regexClass = '[object RegExp]';
    /** @type {import('.')} */ $87cb793d69ea828f$var$fn = function isRegex(value) {
        // In older browsers, typeof regex incorrectly returns 'function'
        if (!value || typeof value !== 'object' && typeof value !== 'function') return false;
        return $87cb793d69ea828f$var$$toString(value) === $87cb793d69ea828f$var$regexClass;
    };
}
module.exports = $87cb793d69ea828f$var$fn;

});


parcelRegister("4PqiK", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $ae69fd37e9c5666e$export$2e2bcd8739ae039; });

var $fEC9v = parcelRequire("fEC9v");
var /** @type {import('./index.d.mts').default} */ $ae69fd37e9c5666e$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($fEC9v)));

});
parcelRegister("fEC9v", function(module, exports) {
'use strict';
// eslint-disable-next-line no-extra-parens, no-empty-function
const $b6582fac2a1da929$var$cached = /** @type {GeneratorFunctionConstructor} */ (function*() {}).constructor;
/** @type {import('.')} */ module.exports = ()=>$b6582fac2a1da929$var$cached;

});



parcelRegister("8fHtM", function(module, exports) {
'use strict';

var $h55sv = parcelRequire("h55sv");

var $2lfR4 = parcelRequire("2lfR4");

var $gPANn = parcelRequire("gPANn");

var $h0KKk = parcelRequire("h0KKk");

var $l2i8c = parcelRequire("l2i8c");

var $5S5RK = parcelRequire("5S5RK");
var $6021738205fa777d$var$$toString = $h0KKk('Object.prototype.toString');

var $6021738205fa777d$var$hasToStringTag = (parcelRequire("1sJBe"))();
var $6021738205fa777d$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
var $6021738205fa777d$var$typedArrays = $2lfR4();
var $6021738205fa777d$var$$slice = $h0KKk('String.prototype.slice');
/** @type {<T = unknown>(array: readonly T[], value: unknown) => number} */ var $6021738205fa777d$var$$indexOf = $h0KKk('Array.prototype.indexOf', true) || function indexOf(array, value) {
    for(var i = 0; i < array.length; i += 1){
        if (array[i] === value) return i;
    }
    return -1;
};
/** @typedef {import('./types').Getter} Getter */ /** @type {import('./types').Cache} */ var $6021738205fa777d$var$cache = {
    __proto__: null
};
if ($6021738205fa777d$var$hasToStringTag && $l2i8c && $5S5RK) $h55sv($6021738205fa777d$var$typedArrays, function(typedArray) {
    var arr = new $6021738205fa777d$var$g[typedArray]();
    if (Symbol.toStringTag in arr && $5S5RK) {
        var proto = $5S5RK(arr);
        // @ts-expect-error TS won't narrow inside a closure
        var descriptor = $l2i8c(proto, Symbol.toStringTag);
        if (!descriptor && proto) {
            var superProto = $5S5RK(proto);
            // @ts-expect-error TS won't narrow inside a closure
            descriptor = $l2i8c(superProto, Symbol.toStringTag);
        }
        // @ts-expect-error TODO: fix
        $6021738205fa777d$var$cache['$' + typedArray] = $gPANn(descriptor.get);
    }
});
else $h55sv($6021738205fa777d$var$typedArrays, function(typedArray) {
    var arr = new $6021738205fa777d$var$g[typedArray]();
    var fn = arr.slice || arr.set;
    if (fn) $6021738205fa777d$var$cache[/** @type {`$${import('.').TypedArrayName}`} */ '$' + typedArray] = /** @type {import('./types').BoundSlice | import('./types').BoundSet} */ // @ts-expect-error TODO FIXME
    $gPANn(fn);
});
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $6021738205fa777d$var$tryTypedArrays = function tryAllTypedArrays(value) {
    /** @type {ReturnType<typeof tryAllTypedArrays>} */ var found = false;
    $h55sv(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $6021738205fa777d$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, typedArray) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            if ('$' + getter(value) === typedArray) found = /** @type {import('.').TypedArrayName} */ $6021738205fa777d$var$$slice(typedArray, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {(value: object) => false | import('.').TypedArrayName} */ var $6021738205fa777d$var$trySlices = function tryAllSlices(value) {
    /** @type {ReturnType<typeof tryAllSlices>} */ var found = false;
    $h55sv(/** @type {Record<`\$${import('.').TypedArrayName}`, Getter>} */ $6021738205fa777d$var$cache, /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */ function(getter, name) {
        if (!found) try {
            // @ts-expect-error a throw is fine here
            getter(value);
            found = /** @type {import('.').TypedArrayName} */ $6021738205fa777d$var$$slice(name, 1);
        } catch (e) {}
    });
    return found;
};
/** @type {import('.')} */ module.exports = function whichTypedArray(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$6021738205fa777d$var$hasToStringTag) {
        /** @type {string} */ var tag = $6021738205fa777d$var$$slice($6021738205fa777d$var$$toString(value), 8, -1);
        if ($6021738205fa777d$var$$indexOf($6021738205fa777d$var$typedArrays, tag) > -1) return tag;
        if (tag !== 'Object') return false;
        // node < 0.6 hits here on real Typed Arrays
        return $6021738205fa777d$var$trySlices(value);
    }
    if (!$l2i8c) return null;
     // unknown engine
    return $6021738205fa777d$var$tryTypedArrays(value);
};

});
parcelRegister("h55sv", function(module, exports) {
'use strict';

var $46tA1 = parcelRequire("46tA1");
var $c6f72346039f2902$var$toStr = Object.prototype.toString;
var $c6f72346039f2902$var$hasOwnProperty = Object.prototype.hasOwnProperty;
/** @type {<This, A extends readonly unknown[]>(arr: A, iterator: (this: This | void, value: A[number], index: number, arr: A) => void, receiver: This | undefined) => void} */ var $c6f72346039f2902$var$forEachArray = function forEachArray(array, iterator, receiver) {
    for(var i = 0, len = array.length; i < len; i++)if ($c6f72346039f2902$var$hasOwnProperty.call(array, i)) {
        if (receiver == null) iterator(array[i], i, array);
        else iterator.call(receiver, array[i], i, array);
    }
};
/** @type {<This, S extends string>(string: S, iterator: (this: This | void, value: S[number], index: number, string: S) => void, receiver: This | undefined) => void} */ var $c6f72346039f2902$var$forEachString = function forEachString(string, iterator, receiver) {
    for(var i = 0, len = string.length; i < len; i++)// no such thing as a sparse string.
    if (receiver == null) iterator(string.charAt(i), i, string);
    else iterator.call(receiver, string.charAt(i), i, string);
};
/** @type {<This, O>(obj: O, iterator: (this: This | void, value: O[keyof O], index: keyof O, obj: O) => void, receiver: This | undefined) => void} */ var $c6f72346039f2902$var$forEachObject = function forEachObject(object, iterator, receiver) {
    for(var k in object)if ($c6f72346039f2902$var$hasOwnProperty.call(object, k)) {
        if (receiver == null) iterator(object[k], k, object);
        else iterator.call(receiver, object[k], k, object);
    }
};
/** @type {(x: unknown) => x is readonly unknown[]} */ function $c6f72346039f2902$var$isArray(x) {
    return $c6f72346039f2902$var$toStr.call(x) === '[object Array]';
}
/** @type {import('.')._internal} */ module.exports = function forEach(list, iterator, thisArg) {
    if (!$46tA1(iterator)) throw new TypeError('iterator must be a function');
    var receiver;
    if (arguments.length >= 3) receiver = thisArg;
    if ($c6f72346039f2902$var$isArray(list)) $c6f72346039f2902$var$forEachArray(list, iterator, receiver);
    else if (typeof list === 'string') $c6f72346039f2902$var$forEachString(list, iterator, receiver);
    else $c6f72346039f2902$var$forEachObject(list, iterator, receiver);
};

});
parcelRegister("46tA1", function(module, exports) {
'use strict';
var $2fceaaee11364450$var$fnToStr = Function.prototype.toString;
var $2fceaaee11364450$var$reflectApply = typeof Reflect === 'object' && Reflect !== null && Reflect.apply;
var $2fceaaee11364450$var$badArrayLike;
var $2fceaaee11364450$var$isCallableMarker;
if (typeof $2fceaaee11364450$var$reflectApply === 'function' && typeof Object.defineProperty === 'function') try {
    $2fceaaee11364450$var$badArrayLike = Object.defineProperty({}, 'length', {
        get: function() {
            throw $2fceaaee11364450$var$isCallableMarker;
        }
    });
    $2fceaaee11364450$var$isCallableMarker = {};
    // eslint-disable-next-line no-throw-literal
    $2fceaaee11364450$var$reflectApply(function() {
        throw 42;
    }, null, $2fceaaee11364450$var$badArrayLike);
} catch (_) {
    if (_ !== $2fceaaee11364450$var$isCallableMarker) $2fceaaee11364450$var$reflectApply = null;
}
else $2fceaaee11364450$var$reflectApply = null;
var $2fceaaee11364450$var$constructorRegex = /^\s*class\b/;
var $2fceaaee11364450$var$isES6ClassFn = function isES6ClassFunction(value) {
    try {
        var fnStr = $2fceaaee11364450$var$fnToStr.call(value);
        return $2fceaaee11364450$var$constructorRegex.test(fnStr);
    } catch (e) {
        return false; // not a function
    }
};
var $2fceaaee11364450$var$tryFunctionObject = function tryFunctionToStr(value) {
    try {
        if ($2fceaaee11364450$var$isES6ClassFn(value)) return false;
        $2fceaaee11364450$var$fnToStr.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $2fceaaee11364450$var$toStr = Object.prototype.toString;
var $2fceaaee11364450$var$objectClass = '[object Object]';
var $2fceaaee11364450$var$fnClass = '[object Function]';
var $2fceaaee11364450$var$genClass = '[object GeneratorFunction]';
var $2fceaaee11364450$var$ddaClass = '[object HTMLAllCollection]'; // IE 11
var $2fceaaee11364450$var$ddaClass2 = '[object HTML document.all class]';
var $2fceaaee11364450$var$ddaClass3 = '[object HTMLCollection]'; // IE 9-10
var $2fceaaee11364450$var$hasToStringTag = typeof Symbol === 'function' && !!Symbol.toStringTag; // better: use `has-tostringtag`
var $2fceaaee11364450$var$isIE68 = !(0 in [
    , 
]); // eslint-disable-line no-sparse-arrays, comma-spacing
var $2fceaaee11364450$var$isDDA = function isDocumentDotAll() {
    return false;
};
if (typeof document === 'object') {
    // Firefox 3 canonicalizes DDA to undefined when it's not accessed directly
    var $2fceaaee11364450$var$all = document.all;
    if ($2fceaaee11364450$var$toStr.call($2fceaaee11364450$var$all) === $2fceaaee11364450$var$toStr.call(document.all)) $2fceaaee11364450$var$isDDA = function isDocumentDotAll(value) {
        /* globals document: false */ // in IE 6-8, typeof document.all is "object" and it's truthy
        if (($2fceaaee11364450$var$isIE68 || !value) && (typeof value === 'undefined' || typeof value === 'object')) try {
            var str = $2fceaaee11364450$var$toStr.call(value);
            return (str === $2fceaaee11364450$var$ddaClass || str === $2fceaaee11364450$var$ddaClass2 || str === $2fceaaee11364450$var$ddaClass3 // opera 12.16
             || str === $2fceaaee11364450$var$objectClass // IE 6-8
            ) && value('') == null; // eslint-disable-line eqeqeq
        } catch (e) {}
        return false;
    };
}
module.exports = $2fceaaee11364450$var$reflectApply ? function isCallable(value) {
    if ($2fceaaee11364450$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    try {
        $2fceaaee11364450$var$reflectApply(value, null, $2fceaaee11364450$var$badArrayLike);
    } catch (e) {
        if (e !== $2fceaaee11364450$var$isCallableMarker) return false;
    }
    return !$2fceaaee11364450$var$isES6ClassFn(value) && $2fceaaee11364450$var$tryFunctionObject(value);
} : function isCallable(value) {
    if ($2fceaaee11364450$var$isDDA(value)) return true;
    if (!value) return false;
    if (typeof value !== 'function' && typeof value !== 'object') return false;
    if ($2fceaaee11364450$var$hasToStringTag) return $2fceaaee11364450$var$tryFunctionObject(value);
    if ($2fceaaee11364450$var$isES6ClassFn(value)) return false;
    var strClass = $2fceaaee11364450$var$toStr.call(value);
    if (strClass !== $2fceaaee11364450$var$fnClass && strClass !== $2fceaaee11364450$var$genClass && !/^\[object HTML/.test(strClass)) return false;
    return $2fceaaee11364450$var$tryFunctionObject(value);
};

});


parcelRegister("2lfR4", function(module, exports) {
'use strict';

var $9J5kZ = parcelRequire("9J5kZ");
var $1b49d76b59157fd0$var$g = typeof globalThis === 'undefined' ? $parcel$global : globalThis;
/** @type {import('.')} */ module.exports = function availableTypedArrays() {
    var /** @type {ReturnType<typeof availableTypedArrays>} */ out = [];
    for(var i = 0; i < $9J5kZ.length; i++)if (typeof $1b49d76b59157fd0$var$g[$9J5kZ[i]] === 'function') // @ts-expect-error
    out[out.length] = $9J5kZ[i];
    return out;
};

});
parcelRegister("9J5kZ", function(module, exports) {
'use strict';
/** @type {import('.')} */ module.exports = [
    'Float16Array',
    'Float32Array',
    'Float64Array',
    'Int8Array',
    'Int16Array',
    'Int32Array',
    'Uint8Array',
    'Uint8ClampedArray',
    'Uint16Array',
    'Uint32Array',
    'BigInt64Array',
    'BigUint64Array'
];

});


parcelRegister("gPANn", function(module, exports) {
'use strict';

var $ghXvS = parcelRequire("ghXvS");

var $eDaYG = parcelRequire("eDaYG");

var $atInl = parcelRequire("atInl");

var $5Qe5W = parcelRequire("5Qe5W");
module.exports = function callBind(originalFunction) {
    var func = $atInl(arguments);
    var adjustedLength = originalFunction.length - (arguments.length - 1);
    return $ghXvS(func, 1 + (adjustedLength > 0 ? adjustedLength : 0), true);
};
if ($eDaYG) $eDaYG(module.exports, 'apply', {
    value: $5Qe5W
});
else module.exports.apply = $5Qe5W;

});
parcelRegister("ghXvS", function(module, exports) {
'use strict';

var $g7Yvk = parcelRequire("g7Yvk");

var $hUFuu = parcelRequire("hUFuu");

var $bdbc65f20b9152fb$var$hasDescriptors = (parcelRequire("4JPOS"))();

var $l2i8c = parcelRequire("l2i8c");

var $45GSV = parcelRequire("45GSV");
var $bdbc65f20b9152fb$var$$floor = $g7Yvk('%Math.floor%');
/** @type {import('.')} */ module.exports = function setFunctionLength(fn, length) {
    if (typeof fn !== 'function') throw new $45GSV('`fn` is not a function');
    if (typeof length !== 'number' || length < 0 || length > 0xFFFFFFFF || $bdbc65f20b9152fb$var$$floor(length) !== length) throw new $45GSV('`length` must be a positive 32-bit integer');
    var loose = arguments.length > 2 && !!arguments[2];
    var functionLengthIsConfigurable = true;
    var functionLengthIsWritable = true;
    if ('length' in fn && $l2i8c) {
        var desc = $l2i8c(fn, 'length');
        if (desc && !desc.configurable) functionLengthIsConfigurable = false;
        if (desc && !desc.writable) functionLengthIsWritable = false;
    }
    if (functionLengthIsConfigurable || functionLengthIsWritable || !loose) {
        if ($bdbc65f20b9152fb$var$hasDescriptors) $hUFuu(/** @type {Parameters<define>[0]} */ fn, 'length', length, true, true);
        else $hUFuu(/** @type {Parameters<define>[0]} */ fn, 'length', length);
    }
    return fn;
};

});
parcelRegister("hUFuu", function(module, exports) {
'use strict';

var $eDaYG = parcelRequire("eDaYG");

var $5XyxM = parcelRequire("5XyxM");

var $45GSV = parcelRequire("45GSV");

var $l2i8c = parcelRequire("l2i8c");
/** @type {import('.')} */ module.exports = function defineDataProperty(obj, property, value) {
    if (!obj || typeof obj !== 'object' && typeof obj !== 'function') throw new $45GSV('`obj` must be an object or a function`');
    if (typeof property !== 'string' && typeof property !== 'symbol') throw new $45GSV('`property` must be a string or a symbol`');
    if (arguments.length > 3 && typeof arguments[3] !== 'boolean' && arguments[3] !== null) throw new $45GSV('`nonEnumerable`, if provided, must be a boolean or null');
    if (arguments.length > 4 && typeof arguments[4] !== 'boolean' && arguments[4] !== null) throw new $45GSV('`nonWritable`, if provided, must be a boolean or null');
    if (arguments.length > 5 && typeof arguments[5] !== 'boolean' && arguments[5] !== null) throw new $45GSV('`nonConfigurable`, if provided, must be a boolean or null');
    if (arguments.length > 6 && typeof arguments[6] !== 'boolean') throw new $45GSV('`loose`, if provided, must be a boolean');
    var nonEnumerable = arguments.length > 3 ? arguments[3] : null;
    var nonWritable = arguments.length > 4 ? arguments[4] : null;
    var nonConfigurable = arguments.length > 5 ? arguments[5] : null;
    var loose = arguments.length > 6 ? arguments[6] : false;
    /* @type {false | TypedPropertyDescriptor<unknown>} */ var desc = !!$l2i8c && $l2i8c(obj, property);
    if ($eDaYG) $eDaYG(obj, property, {
        configurable: nonConfigurable === null && desc ? desc.configurable : !nonConfigurable,
        enumerable: nonEnumerable === null && desc ? desc.enumerable : !nonEnumerable,
        value: value,
        writable: nonWritable === null && desc ? desc.writable : !nonWritable
    });
    else if (loose || !nonEnumerable && !nonWritable && !nonConfigurable) // must fall back to [[Set]], and was not explicitly asked to make non-enumerable, non-writable, or non-configurable
    obj[property] = value; // eslint-disable-line no-param-reassign
    else throw new $5XyxM('This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.');
};

});

parcelRegister("4JPOS", function(module, exports) {
'use strict';

var $eDaYG = parcelRequire("eDaYG");
var $37338fa9b16ba2a0$var$hasPropertyDescriptors = function hasPropertyDescriptors() {
    return !!$eDaYG;
};
$37338fa9b16ba2a0$var$hasPropertyDescriptors.hasArrayLengthDefineBug = function hasArrayLengthDefineBug() {
    // node v0.6 has a bug where array lengths can be Set but not Defined
    if (!$eDaYG) return null;
    try {
        return $eDaYG([], 'length', {
            value: 1
        }).length !== 1;
    } catch (e) {
        // In Firefox 4-22, defining length on an array throws an exception.
        return true;
    }
};
module.exports = $37338fa9b16ba2a0$var$hasPropertyDescriptors;

});


parcelRegister("5Qe5W", function(module, exports) {
'use strict';

var $iI0CX = parcelRequire("iI0CX");

var $3KV1t = parcelRequire("3KV1t");

var $6AR0q = parcelRequire("6AR0q");
/** @type {import('./applyBind')} */ module.exports = function applyBind() {
    return $6AR0q($iI0CX, $3KV1t, arguments);
};

});



parcelRegister("7k9mr", function(module, exports) {
'use strict';

var $8fHtM = parcelRequire("8fHtM");
/** @type {import('.')} */ module.exports = function isTypedArray(value) {
    return !!$8fHtM(value);
};

});


parcelRegister("iYklQ", function(module, exports) {
module.exports = function isBuffer(arg) {
    return arg && typeof arg === 'object' && typeof arg.copy === 'function' && typeof arg.fill === 'function' && typeof arg.readUInt8 === 'function';
};

});

parcelRegister("gdc6A", function(module, exports) {
if (typeof Object.create === 'function') // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});


parcelRegister("8mV0l", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $617c98b2fe5bfe1d$var$R = typeof Reflect === 'object' ? Reflect : null;
var $617c98b2fe5bfe1d$var$ReflectApply = $617c98b2fe5bfe1d$var$R && typeof $617c98b2fe5bfe1d$var$R.apply === 'function' ? $617c98b2fe5bfe1d$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $617c98b2fe5bfe1d$var$ReflectOwnKeys;
if ($617c98b2fe5bfe1d$var$R && typeof $617c98b2fe5bfe1d$var$R.ownKeys === 'function') $617c98b2fe5bfe1d$var$ReflectOwnKeys = $617c98b2fe5bfe1d$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $617c98b2fe5bfe1d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $617c98b2fe5bfe1d$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $617c98b2fe5bfe1d$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $617c98b2fe5bfe1d$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $617c98b2fe5bfe1d$var$EventEmitter() {
    $617c98b2fe5bfe1d$var$EventEmitter.init.call(this);
}
module.exports = $617c98b2fe5bfe1d$var$EventEmitter;
module.exports.once = $617c98b2fe5bfe1d$var$once;
// Backwards-compat with node 0.10.x
$617c98b2fe5bfe1d$var$EventEmitter.EventEmitter = $617c98b2fe5bfe1d$var$EventEmitter;
$617c98b2fe5bfe1d$var$EventEmitter.prototype._events = undefined;
$617c98b2fe5bfe1d$var$EventEmitter.prototype._eventsCount = 0;
$617c98b2fe5bfe1d$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $617c98b2fe5bfe1d$var$defaultMaxListeners = 10;
function $617c98b2fe5bfe1d$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($617c98b2fe5bfe1d$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $617c98b2fe5bfe1d$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $617c98b2fe5bfe1d$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $617c98b2fe5bfe1d$var$defaultMaxListeners = arg;
    }
});
$617c98b2fe5bfe1d$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$617c98b2fe5bfe1d$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $617c98b2fe5bfe1d$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $617c98b2fe5bfe1d$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $617c98b2fe5bfe1d$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$617c98b2fe5bfe1d$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $617c98b2fe5bfe1d$var$_getMaxListeners(this);
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $617c98b2fe5bfe1d$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $617c98b2fe5bfe1d$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$617c98b2fe5bfe1d$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $617c98b2fe5bfe1d$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $617c98b2fe5bfe1d$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $617c98b2fe5bfe1d$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $617c98b2fe5bfe1d$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$617c98b2fe5bfe1d$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $617c98b2fe5bfe1d$var$_addListener(this, type, listener, false);
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.on = $617c98b2fe5bfe1d$var$EventEmitter.prototype.addListener;
$617c98b2fe5bfe1d$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $617c98b2fe5bfe1d$var$_addListener(this, type, listener, true);
};
function $617c98b2fe5bfe1d$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $617c98b2fe5bfe1d$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $617c98b2fe5bfe1d$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$617c98b2fe5bfe1d$var$EventEmitter.prototype.once = function once(type, listener) {
    $617c98b2fe5bfe1d$var$checkListener(listener);
    this.on(type, $617c98b2fe5bfe1d$var$_onceWrap(this, type, listener));
    return this;
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $617c98b2fe5bfe1d$var$checkListener(listener);
    this.prependListener(type, $617c98b2fe5bfe1d$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$617c98b2fe5bfe1d$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $617c98b2fe5bfe1d$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $617c98b2fe5bfe1d$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.off = $617c98b2fe5bfe1d$var$EventEmitter.prototype.removeListener;
$617c98b2fe5bfe1d$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $617c98b2fe5bfe1d$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $617c98b2fe5bfe1d$var$unwrapListeners(evlistener) : $617c98b2fe5bfe1d$var$arrayClone(evlistener, evlistener.length);
}
$617c98b2fe5bfe1d$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $617c98b2fe5bfe1d$var$_listeners(this, type, true);
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $617c98b2fe5bfe1d$var$_listeners(this, type, false);
};
$617c98b2fe5bfe1d$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $617c98b2fe5bfe1d$var$listenerCount.call(emitter, type);
};
$617c98b2fe5bfe1d$var$EventEmitter.prototype.listenerCount = $617c98b2fe5bfe1d$var$listenerCount;
function $617c98b2fe5bfe1d$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$617c98b2fe5bfe1d$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $617c98b2fe5bfe1d$var$ReflectOwnKeys(this._events) : [];
};
function $617c98b2fe5bfe1d$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $617c98b2fe5bfe1d$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $617c98b2fe5bfe1d$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $617c98b2fe5bfe1d$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $617c98b2fe5bfe1d$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $617c98b2fe5bfe1d$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $617c98b2fe5bfe1d$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $617c98b2fe5bfe1d$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $617c98b2fe5bfe1d$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("bAlHk", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
module.exports = $86f3e33e3b26e8b9$var$Readable;
/*<replacement>*/ var $86f3e33e3b26e8b9$var$Duplex;
/*</replacement>*/ $86f3e33e3b26e8b9$var$Readable.ReadableState = $86f3e33e3b26e8b9$var$ReadableState;

var $8mV0l = parcelRequire("8mV0l");
var $86f3e33e3b26e8b9$require$EE = $8mV0l.EventEmitter;
var $86f3e33e3b26e8b9$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $f1pIN = parcelRequire("f1pIN");

var $kJBqN = parcelRequire("kJBqN");
var $86f3e33e3b26e8b9$require$Buffer = $kJBqN.Buffer;
var $86f3e33e3b26e8b9$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $86f3e33e3b26e8b9$var$_uint8ArrayToBuffer(chunk) {
    return $86f3e33e3b26e8b9$require$Buffer.from(chunk);
}
function $86f3e33e3b26e8b9$var$_isUint8Array(obj) {
    return $86f3e33e3b26e8b9$require$Buffer.isBuffer(obj) || obj instanceof $86f3e33e3b26e8b9$var$OurUint8Array;
}

var $hDwn7 = parcelRequire("hDwn7");
var $86f3e33e3b26e8b9$var$debug;
if ($hDwn7 && $hDwn7.debuglog) $86f3e33e3b26e8b9$var$debug = $hDwn7.debuglog('stream');
else $86f3e33e3b26e8b9$var$debug = function debug() {};

var $7Lxi1 = parcelRequire("7Lxi1");

var $5wAqT = parcelRequire("5wAqT");

var $8KlpT = parcelRequire("8KlpT");
var $86f3e33e3b26e8b9$var$getHighWaterMark = $8KlpT.getHighWaterMark;

var $6pCUa = parcelRequire("6pCUa");
var $86f3e33e3b26e8b9$require$_require$codes = $6pCUa.codes;
var $86f3e33e3b26e8b9$var$ERR_INVALID_ARG_TYPE = $86f3e33e3b26e8b9$require$_require$codes.ERR_INVALID_ARG_TYPE, $86f3e33e3b26e8b9$var$ERR_STREAM_PUSH_AFTER_EOF = $86f3e33e3b26e8b9$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $86f3e33e3b26e8b9$var$ERR_METHOD_NOT_IMPLEMENTED = $86f3e33e3b26e8b9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $86f3e33e3b26e8b9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $86f3e33e3b26e8b9$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $86f3e33e3b26e8b9$var$StringDecoder;
var $86f3e33e3b26e8b9$var$createReadableStreamAsyncIterator;
var $86f3e33e3b26e8b9$var$from;

(parcelRequire("gdc6A"))($86f3e33e3b26e8b9$var$Readable, $f1pIN);
var $86f3e33e3b26e8b9$var$errorOrDestroy = $5wAqT.errorOrDestroy;
var $86f3e33e3b26e8b9$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $86f3e33e3b26e8b9$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $86f3e33e3b26e8b9$var$ReadableState(options, stream, isDuplex) {
    $86f3e33e3b26e8b9$var$Duplex = $86f3e33e3b26e8b9$var$Duplex || (parcelRequire("5y1if"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $86f3e33e3b26e8b9$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $86f3e33e3b26e8b9$var$getHighWaterMark(this, options, 'readableHighWaterMark', isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $7Lxi1();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$86f3e33e3b26e8b9$var$StringDecoder) $86f3e33e3b26e8b9$var$StringDecoder = (parcelRequire("jzifX")).StringDecoder;
        this.decoder = new $86f3e33e3b26e8b9$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $86f3e33e3b26e8b9$var$Readable(options) {
    $86f3e33e3b26e8b9$var$Duplex = $86f3e33e3b26e8b9$var$Duplex || (parcelRequire("5y1if"));
    if (!(this instanceof $86f3e33e3b26e8b9$var$Readable)) return new $86f3e33e3b26e8b9$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $86f3e33e3b26e8b9$var$Duplex;
    this._readableState = new $86f3e33e3b26e8b9$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $f1pIN.call(this);
}
Object.defineProperty($86f3e33e3b26e8b9$var$Readable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$86f3e33e3b26e8b9$var$Readable.prototype.destroy = $5wAqT.destroy;
$86f3e33e3b26e8b9$var$Readable.prototype._undestroy = $5wAqT.undestroy;
$86f3e33e3b26e8b9$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$86f3e33e3b26e8b9$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $86f3e33e3b26e8b9$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $86f3e33e3b26e8b9$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$86f3e33e3b26e8b9$var$Readable.prototype.unshift = function(chunk) {
    return $86f3e33e3b26e8b9$var$readableAddChunk(this, chunk, null, true, false);
};
function $86f3e33e3b26e8b9$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $86f3e33e3b26e8b9$var$debug('readableAddChunk', chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $86f3e33e3b26e8b9$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $86f3e33e3b26e8b9$var$chunkInvalid(state, chunk);
        if (er) $86f3e33e3b26e8b9$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $86f3e33e3b26e8b9$require$Buffer.prototype) chunk = $86f3e33e3b26e8b9$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $86f3e33e3b26e8b9$var$errorOrDestroy(stream, new $86f3e33e3b26e8b9$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $86f3e33e3b26e8b9$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $86f3e33e3b26e8b9$var$errorOrDestroy(stream, new $86f3e33e3b26e8b9$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $86f3e33e3b26e8b9$var$addChunk(stream, state, chunk, false);
                    else $86f3e33e3b26e8b9$var$maybeReadMore(stream, state);
                } else $86f3e33e3b26e8b9$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $86f3e33e3b26e8b9$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $86f3e33e3b26e8b9$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit('data', chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $86f3e33e3b26e8b9$var$emitReadable(stream);
    }
    $86f3e33e3b26e8b9$var$maybeReadMore(stream, state);
}
function $86f3e33e3b26e8b9$var$chunkInvalid(state, chunk) {
    var er;
    if (!$86f3e33e3b26e8b9$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new $86f3e33e3b26e8b9$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer',
        'Uint8Array'
    ], chunk);
    return er;
}
$86f3e33e3b26e8b9$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$86f3e33e3b26e8b9$var$Readable.prototype.setEncoding = function(enc) {
    if (!$86f3e33e3b26e8b9$var$StringDecoder) $86f3e33e3b26e8b9$var$StringDecoder = (parcelRequire("jzifX")).StringDecoder;
    var decoder = new $86f3e33e3b26e8b9$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = '';
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== '') this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $86f3e33e3b26e8b9$var$MAX_HWM = 0x40000000;
function $86f3e33e3b26e8b9$var$computeNewHighWaterMark(n) {
    if (n >= $86f3e33e3b26e8b9$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $86f3e33e3b26e8b9$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $86f3e33e3b26e8b9$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $86f3e33e3b26e8b9$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$86f3e33e3b26e8b9$var$Readable.prototype.read = function(n) {
    $86f3e33e3b26e8b9$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $86f3e33e3b26e8b9$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $86f3e33e3b26e8b9$var$endReadable(this);
        else $86f3e33e3b26e8b9$var$emitReadable(this);
        return null;
    }
    n = $86f3e33e3b26e8b9$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $86f3e33e3b26e8b9$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $86f3e33e3b26e8b9$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $86f3e33e3b26e8b9$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $86f3e33e3b26e8b9$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $86f3e33e3b26e8b9$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $86f3e33e3b26e8b9$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $86f3e33e3b26e8b9$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $86f3e33e3b26e8b9$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $86f3e33e3b26e8b9$var$onEofChunk(stream, state) {
    $86f3e33e3b26e8b9$var$debug('onEofChunk');
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $86f3e33e3b26e8b9$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $86f3e33e3b26e8b9$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $86f3e33e3b26e8b9$var$emitReadable(stream) {
    var state = stream._readableState;
    $86f3e33e3b26e8b9$var$debug('emitReadable', state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $86f3e33e3b26e8b9$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        $5XqL3.nextTick($86f3e33e3b26e8b9$var$emitReadable_, stream);
    }
}
function $86f3e33e3b26e8b9$var$emitReadable_(stream) {
    var state = stream._readableState;
    $86f3e33e3b26e8b9$var$debug('emitReadable_', state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit('readable');
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $86f3e33e3b26e8b9$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $86f3e33e3b26e8b9$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $5XqL3.nextTick($86f3e33e3b26e8b9$var$maybeReadMore_, stream, state);
    }
}
function $86f3e33e3b26e8b9$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $86f3e33e3b26e8b9$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$86f3e33e3b26e8b9$var$Readable.prototype._read = function(n) {
    $86f3e33e3b26e8b9$var$errorOrDestroy(this, new $86f3e33e3b26e8b9$var$ERR_METHOD_NOT_IMPLEMENTED('_read()'));
};
$86f3e33e3b26e8b9$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $86f3e33e3b26e8b9$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $5XqL3.stdout && dest !== $5XqL3.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $5XqL3.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $86f3e33e3b26e8b9$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $86f3e33e3b26e8b9$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $86f3e33e3b26e8b9$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $86f3e33e3b26e8b9$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on('data', ondata);
    function ondata(chunk) {
        $86f3e33e3b26e8b9$var$debug('ondata');
        var ret = dest.write(chunk);
        $86f3e33e3b26e8b9$var$debug('dest.write', ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $86f3e33e3b26e8b9$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $86f3e33e3b26e8b9$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $86f3e33e3b26e8b9$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($86f3e33e3b26e8b9$var$EElistenerCount(dest, 'error') === 0) $86f3e33e3b26e8b9$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $86f3e33e3b26e8b9$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $86f3e33e3b26e8b9$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $86f3e33e3b26e8b9$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $86f3e33e3b26e8b9$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $86f3e33e3b26e8b9$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $86f3e33e3b26e8b9$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $86f3e33e3b26e8b9$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $86f3e33e3b26e8b9$var$flow(src);
        }
    };
}
$86f3e33e3b26e8b9$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $86f3e33e3b26e8b9$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$86f3e33e3b26e8b9$var$Readable.prototype.on = function(ev, fn) {
    var res = $f1pIN.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === 'data') {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount('readable') > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $86f3e33e3b26e8b9$var$debug('on readable', state.length, state.reading);
            if (state.length) $86f3e33e3b26e8b9$var$emitReadable(this);
            else if (!state.reading) $5XqL3.nextTick($86f3e33e3b26e8b9$var$nReadingNextTick, this);
        }
    }
    return res;
};
$86f3e33e3b26e8b9$var$Readable.prototype.addListener = $86f3e33e3b26e8b9$var$Readable.prototype.on;
$86f3e33e3b26e8b9$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $f1pIN.prototype.removeListener.call(this, ev, fn);
    if (ev === 'readable') // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $5XqL3.nextTick($86f3e33e3b26e8b9$var$updateReadableListening, this);
    return res;
};
$86f3e33e3b26e8b9$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $f1pIN.prototype.removeAllListeners.apply(this, arguments);
    if (ev === 'readable' || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $5XqL3.nextTick($86f3e33e3b26e8b9$var$updateReadableListening, this);
    return res;
};
function $86f3e33e3b26e8b9$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount('readable') > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount('data') > 0) self1.resume();
}
function $86f3e33e3b26e8b9$var$nReadingNextTick(self1) {
    $86f3e33e3b26e8b9$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$86f3e33e3b26e8b9$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $86f3e33e3b26e8b9$var$debug('resume');
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $86f3e33e3b26e8b9$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $86f3e33e3b26e8b9$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $5XqL3.nextTick($86f3e33e3b26e8b9$var$resume_, stream, state);
    }
}
function $86f3e33e3b26e8b9$var$resume_(stream, state) {
    $86f3e33e3b26e8b9$var$debug('resume', state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit('resume');
    $86f3e33e3b26e8b9$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$86f3e33e3b26e8b9$var$Readable.prototype.pause = function() {
    $86f3e33e3b26e8b9$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $86f3e33e3b26e8b9$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    this._readableState.paused = true;
    return this;
};
function $86f3e33e3b26e8b9$var$flow(stream) {
    var state = stream._readableState;
    $86f3e33e3b26e8b9$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$86f3e33e3b26e8b9$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $86f3e33e3b26e8b9$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $86f3e33e3b26e8b9$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $86f3e33e3b26e8b9$var$kProxyEvents.length; n++)stream.on($86f3e33e3b26e8b9$var$kProxyEvents[n], this.emit.bind(this, $86f3e33e3b26e8b9$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $86f3e33e3b26e8b9$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === 'function') $86f3e33e3b26e8b9$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($86f3e33e3b26e8b9$var$createReadableStreamAsyncIterator === undefined) $86f3e33e3b26e8b9$var$createReadableStreamAsyncIterator = (parcelRequire("2y1zD"));
    return $86f3e33e3b26e8b9$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($86f3e33e3b26e8b9$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($86f3e33e3b26e8b9$var$Readable.prototype, 'readableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($86f3e33e3b26e8b9$var$Readable.prototype, 'readableFlowing', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$86f3e33e3b26e8b9$var$Readable._fromList = $86f3e33e3b26e8b9$var$fromList;
Object.defineProperty($86f3e33e3b26e8b9$var$Readable.prototype, 'readableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $86f3e33e3b26e8b9$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $86f3e33e3b26e8b9$var$endReadable(stream) {
    var state = stream._readableState;
    $86f3e33e3b26e8b9$var$debug('endReadable', state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $5XqL3.nextTick($86f3e33e3b26e8b9$var$endReadableNT, state, stream);
    }
}
function $86f3e33e3b26e8b9$var$endReadableNT(state, stream) {
    $86f3e33e3b26e8b9$var$debug('endReadableNT', state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === 'function') $86f3e33e3b26e8b9$var$Readable.from = function(iterable, opts) {
    if ($86f3e33e3b26e8b9$var$from === undefined) $86f3e33e3b26e8b9$var$from = (parcelRequire("iKgnH"));
    return $86f3e33e3b26e8b9$var$from($86f3e33e3b26e8b9$var$Readable, iterable, opts);
};
function $86f3e33e3b26e8b9$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("f1pIN", function(module, exports) {

module.exports = (parcelRequire("8mV0l")).EventEmitter;

});

parcelRegister("7Lxi1", function(module, exports) {
'use strict';
function $5a76becda6638f5a$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $5a76becda6638f5a$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $5a76becda6638f5a$var$ownKeys(Object(source), !0).forEach(function(key) {
            $5a76becda6638f5a$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $5a76becda6638f5a$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $5a76becda6638f5a$var$_defineProperty(obj, key, value) {
    key = $5a76becda6638f5a$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $5a76becda6638f5a$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $5a76becda6638f5a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5a76becda6638f5a$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5a76becda6638f5a$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5a76becda6638f5a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a76becda6638f5a$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5a76becda6638f5a$var$_toPropertyKey(arg) {
    var key = $5a76becda6638f5a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $5a76becda6638f5a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $kJBqN = parcelRequire("kJBqN");
var $5a76becda6638f5a$var$Buffer = $kJBqN.Buffer;

var $hDwn7 = parcelRequire("hDwn7");
var $5a76becda6638f5a$var$inspect = $hDwn7.inspect;
var $5a76becda6638f5a$var$custom = $5a76becda6638f5a$var$inspect && $5a76becda6638f5a$var$inspect.custom || 'inspect';
function $5a76becda6638f5a$var$copyBuffer(src, target, offset) {
    $5a76becda6638f5a$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $5a76becda6638f5a$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $5a76becda6638f5a$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return '';
                var p = this.head;
                var ret = '' + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $5a76becda6638f5a$var$Buffer.alloc(0);
                var ret = $5a76becda6638f5a$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $5a76becda6638f5a$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $5a76becda6638f5a$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $5a76becda6638f5a$var$custom,
            value: function value(_, options) {
                return $5a76becda6638f5a$var$inspect(this, $5a76becda6638f5a$var$_objectSpread($5a76becda6638f5a$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("5wAqT", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
// undocumented cb() API, needed for core, not for public API
function $405c33b8c119f60e$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $5XqL3.nextTick($405c33b8c119f60e$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $5XqL3.nextTick($405c33b8c119f60e$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $5XqL3.nextTick($405c33b8c119f60e$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $5XqL3.nextTick($405c33b8c119f60e$var$emitErrorAndCloseNT, _this, err);
            } else $5XqL3.nextTick($405c33b8c119f60e$var$emitCloseNT, _this);
        } else if (cb) {
            $5XqL3.nextTick($405c33b8c119f60e$var$emitCloseNT, _this);
            cb(err);
        } else $5XqL3.nextTick($405c33b8c119f60e$var$emitCloseNT, _this);
    });
    return this;
}
function $405c33b8c119f60e$var$emitErrorAndCloseNT(self, err) {
    $405c33b8c119f60e$var$emitErrorNT(self, err);
    $405c33b8c119f60e$var$emitCloseNT(self);
}
function $405c33b8c119f60e$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit('close');
}
function $405c33b8c119f60e$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $405c33b8c119f60e$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
function $405c33b8c119f60e$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit('error', err);
}
module.exports = {
    destroy: $405c33b8c119f60e$var$destroy,
    undestroy: $405c33b8c119f60e$var$undestroy,
    errorOrDestroy: $405c33b8c119f60e$var$errorOrDestroy
};

});

parcelRegister("8KlpT", function(module, exports) {
'use strict';

var $65e33b844de6eb28$var$ERR_INVALID_OPT_VALUE = (parcelRequire("6pCUa")).codes.ERR_INVALID_OPT_VALUE;
function $65e33b844de6eb28$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $65e33b844de6eb28$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $65e33b844de6eb28$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : 'highWaterMark';
            throw new $65e33b844de6eb28$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $65e33b844de6eb28$var$getHighWaterMark
};

});
parcelRegister("6pCUa", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $4ab34196e6388271$export$e45cb6485273080e; }, function (v) { return $4ab34196e6388271$export$e45cb6485273080e = v; });
var $4ab34196e6388271$export$e45cb6485273080e;
'use strict';
function $4ab34196e6388271$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $4ab34196e6388271$var$codes = {};
function $4ab34196e6388271$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $4ab34196e6388271$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $4ab34196e6388271$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $4ab34196e6388271$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $4ab34196e6388271$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $4ab34196e6388271$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $4ab34196e6388271$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$4ab34196e6388271$var$createErrorType('ERR_INVALID_OPT_VALUE', function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$4ab34196e6388271$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $4ab34196e6388271$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($4ab34196e6388271$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($4ab34196e6388271$var$oneOf(expected, 'type'));
    else {
        var type = $4ab34196e6388271$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($4ab34196e6388271$var$oneOf(expected, 'type'));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$4ab34196e6388271$var$createErrorType('ERR_STREAM_PUSH_AFTER_EOF', 'stream.push() after EOF');
$4ab34196e6388271$var$createErrorType('ERR_METHOD_NOT_IMPLEMENTED', function(name) {
    return 'The ' + name + ' method is not implemented';
});
$4ab34196e6388271$var$createErrorType('ERR_STREAM_PREMATURE_CLOSE', 'Premature close');
$4ab34196e6388271$var$createErrorType('ERR_STREAM_DESTROYED', function(name) {
    return 'Cannot call ' + name + ' after a stream was destroyed';
});
$4ab34196e6388271$var$createErrorType('ERR_MULTIPLE_CALLBACK', 'Callback called multiple times');
$4ab34196e6388271$var$createErrorType('ERR_STREAM_CANNOT_PIPE', 'Cannot pipe, not readable');
$4ab34196e6388271$var$createErrorType('ERR_STREAM_WRITE_AFTER_END', 'write after end');
$4ab34196e6388271$var$createErrorType('ERR_STREAM_NULL_VALUES', 'May not write null values to stream', TypeError);
$4ab34196e6388271$var$createErrorType('ERR_UNKNOWN_ENCODING', function(arg) {
    return 'Unknown encoding: ' + arg;
}, TypeError);
$4ab34196e6388271$var$createErrorType('ERR_STREAM_UNSHIFT_AFTER_END_EVENT', 'stream.unshift() after end event');
$4ab34196e6388271$export$e45cb6485273080e = $4ab34196e6388271$var$codes;

});


parcelRegister("5y1if", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
/*<replacement>*/ var $40a1218c95689680$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $40a1218c95689680$var$Duplex;

var $bAlHk = parcelRequire("bAlHk");

var $8b39O = parcelRequire("8b39O");

(parcelRequire("gdc6A"))($40a1218c95689680$var$Duplex, $bAlHk);
// Allow the keys array to be GC'ed.
var $40a1218c95689680$var$keys = $40a1218c95689680$var$objectKeys($8b39O.prototype);
for(var $40a1218c95689680$var$v = 0; $40a1218c95689680$var$v < $40a1218c95689680$var$keys.length; $40a1218c95689680$var$v++){
    var $40a1218c95689680$var$method = $40a1218c95689680$var$keys[$40a1218c95689680$var$v];
    if (!$40a1218c95689680$var$Duplex.prototype[$40a1218c95689680$var$method]) $40a1218c95689680$var$Duplex.prototype[$40a1218c95689680$var$method] = $8b39O.prototype[$40a1218c95689680$var$method];
}
function $40a1218c95689680$var$Duplex(options) {
    if (!(this instanceof $40a1218c95689680$var$Duplex)) return new $40a1218c95689680$var$Duplex(options);
    $bAlHk.call(this, options);
    $8b39O.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once('end', $40a1218c95689680$var$onend);
        }
    }
}
Object.defineProperty($40a1218c95689680$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($40a1218c95689680$var$Duplex.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($40a1218c95689680$var$Duplex.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $40a1218c95689680$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $5XqL3.nextTick($40a1218c95689680$var$onEndNT, this);
}
function $40a1218c95689680$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($40a1218c95689680$var$Duplex.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("8b39O", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
module.exports = $5f41cccbf7409769$var$Writable;
/* <replacement> */ function $5f41cccbf7409769$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5f41cccbf7409769$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5f41cccbf7409769$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5f41cccbf7409769$var$Duplex;
/*</replacement>*/ $5f41cccbf7409769$var$Writable.WritableState = $5f41cccbf7409769$var$WritableState;

/*<replacement>*/ var $5f41cccbf7409769$var$internalUtil = {
    deprecate: (parcelRequire("ta1YL"))
};

var $f1pIN = parcelRequire("f1pIN");

var $kJBqN = parcelRequire("kJBqN");
var $5f41cccbf7409769$require$Buffer = $kJBqN.Buffer;
var $5f41cccbf7409769$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $5f41cccbf7409769$var$_uint8ArrayToBuffer(chunk) {
    return $5f41cccbf7409769$require$Buffer.from(chunk);
}
function $5f41cccbf7409769$var$_isUint8Array(obj) {
    return $5f41cccbf7409769$require$Buffer.isBuffer(obj) || obj instanceof $5f41cccbf7409769$var$OurUint8Array;
}

var $5wAqT = parcelRequire("5wAqT");

var $8KlpT = parcelRequire("8KlpT");
var $5f41cccbf7409769$var$getHighWaterMark = $8KlpT.getHighWaterMark;

var $6pCUa = parcelRequire("6pCUa");
var $5f41cccbf7409769$require$_require$codes = $6pCUa.codes;
var $5f41cccbf7409769$var$ERR_INVALID_ARG_TYPE = $5f41cccbf7409769$require$_require$codes.ERR_INVALID_ARG_TYPE, $5f41cccbf7409769$var$ERR_METHOD_NOT_IMPLEMENTED = $5f41cccbf7409769$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5f41cccbf7409769$var$ERR_MULTIPLE_CALLBACK = $5f41cccbf7409769$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5f41cccbf7409769$var$ERR_STREAM_CANNOT_PIPE = $5f41cccbf7409769$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5f41cccbf7409769$var$ERR_STREAM_DESTROYED = $5f41cccbf7409769$require$_require$codes.ERR_STREAM_DESTROYED, $5f41cccbf7409769$var$ERR_STREAM_NULL_VALUES = $5f41cccbf7409769$require$_require$codes.ERR_STREAM_NULL_VALUES, $5f41cccbf7409769$var$ERR_STREAM_WRITE_AFTER_END = $5f41cccbf7409769$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5f41cccbf7409769$var$ERR_UNKNOWN_ENCODING = $5f41cccbf7409769$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5f41cccbf7409769$var$errorOrDestroy = $5wAqT.errorOrDestroy;

(parcelRequire("gdc6A"))($5f41cccbf7409769$var$Writable, $f1pIN);
function $5f41cccbf7409769$var$nop() {}

function $5f41cccbf7409769$var$WritableState(options, stream, isDuplex) {
    $5f41cccbf7409769$var$Duplex = $5f41cccbf7409769$var$Duplex || (parcelRequire("5y1if"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== 'boolean') isDuplex = stream instanceof $5f41cccbf7409769$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5f41cccbf7409769$var$getHighWaterMark(this, options, 'writableHighWaterMark', isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5f41cccbf7409769$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5f41cccbf7409769$var$CorkedRequest(this);
}
$5f41cccbf7409769$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5f41cccbf7409769$var$WritableState.prototype, 'buffer', {
            get: $5f41cccbf7409769$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5f41cccbf7409769$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $5f41cccbf7409769$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5f41cccbf7409769$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5f41cccbf7409769$var$realHasInstance.call(this, object)) return true;
            if (this !== $5f41cccbf7409769$var$Writable) return false;
            return object && object._writableState instanceof $5f41cccbf7409769$var$WritableState;
        }
    });
} else $5f41cccbf7409769$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5f41cccbf7409769$var$Writable(options) {
    $5f41cccbf7409769$var$Duplex = $5f41cccbf7409769$var$Duplex || (parcelRequire("5y1if"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5f41cccbf7409769$var$Duplex;
    if (!isDuplex && !$5f41cccbf7409769$var$realHasInstance.call($5f41cccbf7409769$var$Writable, this)) return new $5f41cccbf7409769$var$Writable(options);
    this._writableState = new $5f41cccbf7409769$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $f1pIN.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5f41cccbf7409769$var$Writable.prototype.pipe = function() {
    $5f41cccbf7409769$var$errorOrDestroy(this, new $5f41cccbf7409769$var$ERR_STREAM_CANNOT_PIPE());
};
function $5f41cccbf7409769$var$writeAfterEnd(stream, cb) {
    var er = new $5f41cccbf7409769$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5f41cccbf7409769$var$errorOrDestroy(stream, er);
    $5XqL3.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5f41cccbf7409769$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5f41cccbf7409769$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== 'string' && !state.objectMode) er = new $5f41cccbf7409769$var$ERR_INVALID_ARG_TYPE('chunk', [
        'string',
        'Buffer'
    ], chunk);
    if (er) {
        $5f41cccbf7409769$var$errorOrDestroy(stream, er);
        $5XqL3.nextTick(cb, er);
        return false;
    }
    return true;
}
$5f41cccbf7409769$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5f41cccbf7409769$var$_isUint8Array(chunk);
    if (isBuf && !$5f41cccbf7409769$require$Buffer.isBuffer(chunk)) chunk = $5f41cccbf7409769$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $5f41cccbf7409769$var$nop;
    if (state.ending) $5f41cccbf7409769$var$writeAfterEnd(this, cb);
    else if (isBuf || $5f41cccbf7409769$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5f41cccbf7409769$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5f41cccbf7409769$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5f41cccbf7409769$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5f41cccbf7409769$var$clearBuffer(this, state);
    }
};
$5f41cccbf7409769$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new $5f41cccbf7409769$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5f41cccbf7409769$var$Writable.prototype, 'writableBuffer', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5f41cccbf7409769$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $5f41cccbf7409769$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5f41cccbf7409769$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5f41cccbf7409769$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5f41cccbf7409769$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5f41cccbf7409769$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5f41cccbf7409769$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5f41cccbf7409769$var$ERR_STREAM_DESTROYED('write'));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5f41cccbf7409769$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $5XqL3.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $5XqL3.nextTick($5f41cccbf7409769$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5f41cccbf7409769$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5f41cccbf7409769$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5f41cccbf7409769$var$finishMaybe(stream, state);
    }
}
function $5f41cccbf7409769$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5f41cccbf7409769$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== 'function') throw new $5f41cccbf7409769$var$ERR_MULTIPLE_CALLBACK();
    $5f41cccbf7409769$var$onwriteStateUpdate(state);
    if (er) $5f41cccbf7409769$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5f41cccbf7409769$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5f41cccbf7409769$var$clearBuffer(stream, state);
        if (sync) $5XqL3.nextTick($5f41cccbf7409769$var$afterWrite, stream, state, finished, cb);
        else $5f41cccbf7409769$var$afterWrite(stream, state, finished, cb);
    }
}
function $5f41cccbf7409769$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5f41cccbf7409769$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5f41cccbf7409769$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5f41cccbf7409769$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $5f41cccbf7409769$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5f41cccbf7409769$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5f41cccbf7409769$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5f41cccbf7409769$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5f41cccbf7409769$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5f41cccbf7409769$var$ERR_METHOD_NOT_IMPLEMENTED('_write()'));
};
$5f41cccbf7409769$var$Writable.prototype._writev = null;
$5f41cccbf7409769$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5f41cccbf7409769$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5f41cccbf7409769$var$Writable.prototype, 'writableLength', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5f41cccbf7409769$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5f41cccbf7409769$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5f41cccbf7409769$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit('prefinish');
        $5f41cccbf7409769$var$finishMaybe(stream, state);
    });
}
function $5f41cccbf7409769$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function' && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $5XqL3.nextTick($5f41cccbf7409769$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $5f41cccbf7409769$var$finishMaybe(stream, state) {
    var need = $5f41cccbf7409769$var$needFinish(state);
    if (need) {
        $5f41cccbf7409769$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5f41cccbf7409769$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5f41cccbf7409769$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $5XqL3.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5f41cccbf7409769$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5f41cccbf7409769$var$Writable.prototype, 'destroyed', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5f41cccbf7409769$var$Writable.prototype.destroy = $5wAqT.destroy;
$5f41cccbf7409769$var$Writable.prototype._undestroy = $5wAqT.undestroy;
$5f41cccbf7409769$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("ta1YL", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $057a7d7ad88a9f73$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $057a7d7ad88a9f73$var$deprecate(fn, msg) {
    if ($057a7d7ad88a9f73$var$config('noDeprecation')) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($057a7d7ad88a9f73$var$config('throwDeprecation')) throw new Error(msg);
            else if ($057a7d7ad88a9f73$var$config('traceDeprecation')) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $057a7d7ad88a9f73$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === 'true';
}

});



parcelRegister("jzifX", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $e3ef7288c012433b$export$63a7aa211a91ed69; }, function (v) { return $e3ef7288c012433b$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $e3ef7288c012433b$export$63a7aa211a91ed69;
'use strict';

var $6arys = parcelRequire("6arys");
var $e3ef7288c012433b$require$Buffer = $6arys.Buffer;
/*</replacement>*/ var $e3ef7288c012433b$var$isEncoding = $e3ef7288c012433b$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $e3ef7288c012433b$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $e3ef7288c012433b$var$normalizeEncoding(enc) {
    var nenc = $e3ef7288c012433b$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($e3ef7288c012433b$require$Buffer.isEncoding === $e3ef7288c012433b$var$isEncoding || !$e3ef7288c012433b$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$e3ef7288c012433b$export$63a7aa211a91ed69 = $e3ef7288c012433b$var$StringDecoder;
function $e3ef7288c012433b$var$StringDecoder(encoding) {
    this.encoding = $e3ef7288c012433b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $e3ef7288c012433b$var$utf16Text;
            this.end = $e3ef7288c012433b$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $e3ef7288c012433b$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $e3ef7288c012433b$var$base64Text;
            this.end = $e3ef7288c012433b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $e3ef7288c012433b$var$simpleWrite;
            this.end = $e3ef7288c012433b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $e3ef7288c012433b$require$Buffer.allocUnsafe(nb);
}
$e3ef7288c012433b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$e3ef7288c012433b$var$StringDecoder.prototype.end = $e3ef7288c012433b$var$utf8End;
// Returns only complete characters in a Buffer
$e3ef7288c012433b$var$StringDecoder.prototype.text = $e3ef7288c012433b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$e3ef7288c012433b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $e3ef7288c012433b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $e3ef7288c012433b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $e3ef7288c012433b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e3ef7288c012433b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $e3ef7288c012433b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $e3ef7288c012433b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $e3ef7288c012433b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $e3ef7288c012433b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $e3ef7288c012433b$var$utf8Text(buf, i) {
    var total = $e3ef7288c012433b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $e3ef7288c012433b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $e3ef7288c012433b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $e3ef7288c012433b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $e3ef7288c012433b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $e3ef7288c012433b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $e3ef7288c012433b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $e3ef7288c012433b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});
parcelRegister("6arys", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $kJBqN = parcelRequire("kJBqN");
var $47d90d10b537dade$var$Buffer = $kJBqN.Buffer;
// alternative to using Object.keys for old browsers
function $47d90d10b537dade$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($47d90d10b537dade$var$Buffer.from && $47d90d10b537dade$var$Buffer.alloc && $47d90d10b537dade$var$Buffer.allocUnsafe && $47d90d10b537dade$var$Buffer.allocUnsafeSlow) module.exports = $kJBqN;
else {
    // Copy properties from require('buffer')
    $47d90d10b537dade$var$copyProps($kJBqN, module.exports);
    module.exports.Buffer = $47d90d10b537dade$var$SafeBuffer;
}
function $47d90d10b537dade$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $47d90d10b537dade$var$Buffer(arg, encodingOrOffset, length);
}
$47d90d10b537dade$var$SafeBuffer.prototype = Object.create($47d90d10b537dade$var$Buffer.prototype);
// Copy static methods from Buffer
$47d90d10b537dade$var$copyProps($47d90d10b537dade$var$Buffer, $47d90d10b537dade$var$SafeBuffer);
$47d90d10b537dade$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $47d90d10b537dade$var$Buffer(arg, encodingOrOffset, length);
};
$47d90d10b537dade$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $47d90d10b537dade$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$47d90d10b537dade$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $47d90d10b537dade$var$Buffer(size);
};
$47d90d10b537dade$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $kJBqN.SlowBuffer(size);
};

});


parcelRegister("2y1zD", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
var $1daffa3ece514aa8$var$_Object$setPrototypeO;
function $1daffa3ece514aa8$var$_defineProperty(obj, key, value) {
    key = $1daffa3ece514aa8$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $1daffa3ece514aa8$var$_toPropertyKey(arg) {
    var key = $1daffa3ece514aa8$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $1daffa3ece514aa8$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $9DLFT = parcelRequire("9DLFT");
var $1daffa3ece514aa8$var$kLastResolve = Symbol('lastResolve');
var $1daffa3ece514aa8$var$kLastReject = Symbol('lastReject');
var $1daffa3ece514aa8$var$kError = Symbol('error');
var $1daffa3ece514aa8$var$kEnded = Symbol('ended');
var $1daffa3ece514aa8$var$kLastPromise = Symbol('lastPromise');
var $1daffa3ece514aa8$var$kHandlePromise = Symbol('handlePromise');
var $1daffa3ece514aa8$var$kStream = Symbol('stream');
function $1daffa3ece514aa8$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $1daffa3ece514aa8$var$readAndResolve(iter) {
    var resolve = iter[$1daffa3ece514aa8$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$1daffa3ece514aa8$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$1daffa3ece514aa8$var$kLastPromise] = null;
            iter[$1daffa3ece514aa8$var$kLastResolve] = null;
            iter[$1daffa3ece514aa8$var$kLastReject] = null;
            resolve($1daffa3ece514aa8$var$createIterResult(data, false));
        }
    }
}
function $1daffa3ece514aa8$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $5XqL3.nextTick($1daffa3ece514aa8$var$readAndResolve, iter);
}
function $1daffa3ece514aa8$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$1daffa3ece514aa8$var$kEnded]) {
                resolve($1daffa3ece514aa8$var$createIterResult(undefined, true));
                return;
            }
            iter[$1daffa3ece514aa8$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $1daffa3ece514aa8$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $1daffa3ece514aa8$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($1daffa3ece514aa8$var$_Object$setPrototypeO = {
    get stream () {
        return this[$1daffa3ece514aa8$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$1daffa3ece514aa8$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$1daffa3ece514aa8$var$kEnded]) return Promise.resolve($1daffa3ece514aa8$var$createIterResult(undefined, true));
        if (this[$1daffa3ece514aa8$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $5XqL3.nextTick(function() {
                if (_this[$1daffa3ece514aa8$var$kError]) reject(_this[$1daffa3ece514aa8$var$kError]);
                else resolve($1daffa3ece514aa8$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$1daffa3ece514aa8$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($1daffa3ece514aa8$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$1daffa3ece514aa8$var$kStream].read();
            if (data !== null) return Promise.resolve($1daffa3ece514aa8$var$createIterResult(data, false));
            promise = new Promise(this[$1daffa3ece514aa8$var$kHandlePromise]);
        }
        this[$1daffa3ece514aa8$var$kLastPromise] = promise;
        return promise;
    }
}, $1daffa3ece514aa8$var$_defineProperty($1daffa3ece514aa8$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $1daffa3ece514aa8$var$_defineProperty($1daffa3ece514aa8$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$1daffa3ece514aa8$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($1daffa3ece514aa8$var$createIterResult(undefined, true));
        });
    });
}), $1daffa3ece514aa8$var$_Object$setPrototypeO), $1daffa3ece514aa8$var$AsyncIteratorPrototype);
var $1daffa3ece514aa8$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($1daffa3ece514aa8$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kStream, {
        value: stream,
        writable: true
    }), $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kLastResolve, {
        value: null,
        writable: true
    }), $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kLastReject, {
        value: null,
        writable: true
    }), $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kError, {
        value: null,
        writable: true
    }), $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $1daffa3ece514aa8$var$_defineProperty(_Object$create, $1daffa3ece514aa8$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$1daffa3ece514aa8$var$kStream].read();
            if (data) {
                iterator[$1daffa3ece514aa8$var$kLastPromise] = null;
                iterator[$1daffa3ece514aa8$var$kLastResolve] = null;
                iterator[$1daffa3ece514aa8$var$kLastReject] = null;
                resolve($1daffa3ece514aa8$var$createIterResult(data, false));
            } else {
                iterator[$1daffa3ece514aa8$var$kLastResolve] = resolve;
                iterator[$1daffa3ece514aa8$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$1daffa3ece514aa8$var$kLastPromise] = null;
    $9DLFT(stream, function(err) {
        if (err && err.code !== 'ERR_STREAM_PREMATURE_CLOSE') {
            var reject = iterator[$1daffa3ece514aa8$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$1daffa3ece514aa8$var$kLastPromise] = null;
                iterator[$1daffa3ece514aa8$var$kLastResolve] = null;
                iterator[$1daffa3ece514aa8$var$kLastReject] = null;
                reject(err);
            }
            iterator[$1daffa3ece514aa8$var$kError] = err;
            return;
        }
        var resolve = iterator[$1daffa3ece514aa8$var$kLastResolve];
        if (resolve !== null) {
            iterator[$1daffa3ece514aa8$var$kLastPromise] = null;
            iterator[$1daffa3ece514aa8$var$kLastResolve] = null;
            iterator[$1daffa3ece514aa8$var$kLastReject] = null;
            resolve($1daffa3ece514aa8$var$createIterResult(undefined, true));
        }
        iterator[$1daffa3ece514aa8$var$kEnded] = true;
    });
    stream.on('readable', $1daffa3ece514aa8$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $1daffa3ece514aa8$var$createReadableStreamAsyncIterator;

});
parcelRegister("9DLFT", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';

var $704cbcc6185f1b98$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("6pCUa")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $704cbcc6185f1b98$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $704cbcc6185f1b98$var$noop() {}
function $704cbcc6185f1b98$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}
function $704cbcc6185f1b98$var$eos(stream, opts, callback) {
    if (typeof opts === 'function') return $704cbcc6185f1b98$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $704cbcc6185f1b98$var$once(callback || $704cbcc6185f1b98$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $704cbcc6185f1b98$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $704cbcc6185f1b98$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on('finish', onfinish);
    };
    if ($704cbcc6185f1b98$var$isRequest(stream)) {
        stream.on('complete', onfinish);
        stream.on('abort', onclose);
        if (stream.req) onrequest();
        else stream.on('request', onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on('end', onlegacyfinish);
        stream.on('close', onlegacyfinish);
    }
    stream.on('end', onend);
    stream.on('finish', onfinish);
    if (opts.error !== false) stream.on('error', onerror);
    stream.on('close', onclose);
    return function() {
        stream.removeListener('complete', onfinish);
        stream.removeListener('abort', onclose);
        stream.removeListener('request', onrequest);
        if (stream.req) stream.req.removeListener('finish', onfinish);
        stream.removeListener('end', onlegacyfinish);
        stream.removeListener('close', onlegacyfinish);
        stream.removeListener('finish', onfinish);
        stream.removeListener('end', onend);
        stream.removeListener('error', onerror);
        stream.removeListener('close', onclose);
    };
}
module.exports = $704cbcc6185f1b98$var$eos;

});


parcelRegister("iKgnH", function(module, exports) {
module.exports = function() {
    throw new Error('Readable.from is not available in the browser');
};

});


parcelRegister("gNFsE", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $c3b162439a9e77ea$var$Transform;

var $6pCUa = parcelRequire("6pCUa");
var $c3b162439a9e77ea$require$_require$codes = $6pCUa.codes;
var $c3b162439a9e77ea$var$ERR_METHOD_NOT_IMPLEMENTED = $c3b162439a9e77ea$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $c3b162439a9e77ea$var$ERR_MULTIPLE_CALLBACK = $c3b162439a9e77ea$require$_require$codes.ERR_MULTIPLE_CALLBACK, $c3b162439a9e77ea$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $c3b162439a9e77ea$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $c3b162439a9e77ea$var$ERR_TRANSFORM_WITH_LENGTH_0 = $c3b162439a9e77ea$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $5y1if = parcelRequire("5y1if");

(parcelRequire("gdc6A"))($c3b162439a9e77ea$var$Transform, $5y1if);
function $c3b162439a9e77ea$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit('error', new $c3b162439a9e77ea$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $c3b162439a9e77ea$var$Transform(options) {
    if (!(this instanceof $c3b162439a9e77ea$var$Transform)) return new $c3b162439a9e77ea$var$Transform(options);
    $5y1if.call(this, options);
    this._transformState = {
        afterTransform: $c3b162439a9e77ea$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $c3b162439a9e77ea$var$prefinish);
}
function $c3b162439a9e77ea$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function' && !this._readableState.destroyed) this._flush(function(er, data) {
        $c3b162439a9e77ea$var$done(_this, er, data);
    });
    else $c3b162439a9e77ea$var$done(this, null, null);
}
$c3b162439a9e77ea$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $5y1if.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$c3b162439a9e77ea$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $c3b162439a9e77ea$var$ERR_METHOD_NOT_IMPLEMENTED('_transform()'));
};
$c3b162439a9e77ea$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$c3b162439a9e77ea$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$c3b162439a9e77ea$var$Transform.prototype._destroy = function(err, cb) {
    $5y1if.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $c3b162439a9e77ea$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $c3b162439a9e77ea$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $c3b162439a9e77ea$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("9y7iY", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $6f3cf4aadde2f544$var$PassThrough;

var $gNFsE = parcelRequire("gNFsE");

(parcelRequire("gdc6A"))($6f3cf4aadde2f544$var$PassThrough, $gNFsE);
function $6f3cf4aadde2f544$var$PassThrough(options) {
    if (!(this instanceof $6f3cf4aadde2f544$var$PassThrough)) return new $6f3cf4aadde2f544$var$PassThrough(options);
    $gNFsE.call(this, options);
}
$6f3cf4aadde2f544$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("k5Htd", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
'use strict';
var $ea05fe8a21826747$var$eos;
function $ea05fe8a21826747$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $6pCUa = parcelRequire("6pCUa");
var $ea05fe8a21826747$require$_require$codes = $6pCUa.codes;
var $ea05fe8a21826747$var$ERR_MISSING_ARGS = $ea05fe8a21826747$require$_require$codes.ERR_MISSING_ARGS, $ea05fe8a21826747$var$ERR_STREAM_DESTROYED = $ea05fe8a21826747$require$_require$codes.ERR_STREAM_DESTROYED;
function $ea05fe8a21826747$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $ea05fe8a21826747$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === 'function';
}

function $ea05fe8a21826747$var$destroyer(stream, reading, writing, callback) {
    callback = $ea05fe8a21826747$var$once(callback);
    var closed = false;
    stream.on('close', function() {
        closed = true;
    });
    if ($ea05fe8a21826747$var$eos === undefined) $ea05fe8a21826747$var$eos = (parcelRequire("9DLFT"));
    $ea05fe8a21826747$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($ea05fe8a21826747$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === 'function') return stream.destroy();
        callback(err || new $ea05fe8a21826747$var$ERR_STREAM_DESTROYED('pipe'));
    };
}
function $ea05fe8a21826747$var$call(fn) {
    fn();
}
function $ea05fe8a21826747$var$pipe(from, to) {
    return from.pipe(to);
}
function $ea05fe8a21826747$var$popCallback(streams) {
    if (!streams.length) return $ea05fe8a21826747$var$noop;
    if (typeof streams[streams.length - 1] !== 'function') return $ea05fe8a21826747$var$noop;
    return streams.pop();
}
function $ea05fe8a21826747$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $ea05fe8a21826747$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $ea05fe8a21826747$var$ERR_MISSING_ARGS('streams');
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $ea05fe8a21826747$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($ea05fe8a21826747$var$call);
            if (reading) return;
            destroys.forEach($ea05fe8a21826747$var$call);
            callback(error);
        });
    });
    return streams.reduce($ea05fe8a21826747$var$pipe);
}
module.exports = $ea05fe8a21826747$var$pipeline;

});

parcelRegister("7UcXO", function(module, exports) {
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a51ae424a513ec9a6aa3466baa0cc1d55dd4f3b
// Originally from narwhal.js (http://narwhaljs.org)
// Copyright (c) 2009 Thomas Robinson <280north.com>
//
// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the 'Software'), to
// deal in the Software without restriction, including without limitation the
// rights to use, copy, modify, merge, publish, distribute, sublicense, and/or
// sell copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:
//
// The above copyright notice and this permission notice shall be included in
// all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN
// ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION
// WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
function $5c17d1ae69c0edad$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $5c17d1ae69c0edad$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $5c17d1ae69c0edad$var$_typeof(o);
}
function $5c17d1ae69c0edad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $5c17d1ae69c0edad$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $5c17d1ae69c0edad$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $5c17d1ae69c0edad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5c17d1ae69c0edad$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $5c17d1ae69c0edad$var$_toPropertyKey(arg) {
    var key = $5c17d1ae69c0edad$var$_toPrimitive(arg, "string");
    return $5c17d1ae69c0edad$var$_typeof(key) === "symbol" ? key : String(key);
}
function $5c17d1ae69c0edad$var$_toPrimitive(input, hint) {
    if ($5c17d1ae69c0edad$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($5c17d1ae69c0edad$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $5c17d1ae69c0edad$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $jUZ7b = parcelRequire("jUZ7b");
var $5c17d1ae69c0edad$var$_require$codes = $jUZ7b.codes, $5c17d1ae69c0edad$var$ERR_AMBIGUOUS_ARGUMENT = $5c17d1ae69c0edad$var$_require$codes.ERR_AMBIGUOUS_ARGUMENT, $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE = $5c17d1ae69c0edad$var$_require$codes.ERR_INVALID_ARG_TYPE, $5c17d1ae69c0edad$var$ERR_INVALID_ARG_VALUE = $5c17d1ae69c0edad$var$_require$codes.ERR_INVALID_ARG_VALUE, $5c17d1ae69c0edad$var$ERR_INVALID_RETURN_VALUE = $5c17d1ae69c0edad$var$_require$codes.ERR_INVALID_RETURN_VALUE, $5c17d1ae69c0edad$var$ERR_MISSING_ARGS = $5c17d1ae69c0edad$var$_require$codes.ERR_MISSING_ARGS;

var $EAZe6 = parcelRequire("EAZe6");

var $hHIjR = parcelRequire("hHIjR");
var $5c17d1ae69c0edad$var$inspect = $hHIjR.inspect;

var $hHIjR = parcelRequire("hHIjR");
var $5c17d1ae69c0edad$require$_require$types = $hHIjR.types;
var $5c17d1ae69c0edad$var$isPromise = $5c17d1ae69c0edad$require$_require$types.isPromise, $5c17d1ae69c0edad$var$isRegExp = $5c17d1ae69c0edad$require$_require$types.isRegExp;

var $5c17d1ae69c0edad$var$objectAssign = (parcelRequire("1muN4"))();

var $5c17d1ae69c0edad$var$objectIs = (parcelRequire("h4naa"))();

var $5c17d1ae69c0edad$var$RegExpPrototypeTest = (parcelRequire("aKCww"))('RegExp.prototype.test');
var $5c17d1ae69c0edad$var$errorCache = new Map();
var $5c17d1ae69c0edad$var$isDeepEqual;
var $5c17d1ae69c0edad$var$isDeepStrictEqual;
var $5c17d1ae69c0edad$var$parseExpressionAt;
var $5c17d1ae69c0edad$var$findNodeAround;
var $5c17d1ae69c0edad$var$decoder;

function $5c17d1ae69c0edad$var$lazyLoadComparison() {
    var comparison = (parcelRequire("iQMtp"));
    $5c17d1ae69c0edad$var$isDeepEqual = comparison.isDeepEqual;
    $5c17d1ae69c0edad$var$isDeepStrictEqual = comparison.isDeepStrictEqual;
}
// Escape control characters but not \n and \t to keep the line breaks and
// indentation intact.
// eslint-disable-next-line no-control-regex
var $5c17d1ae69c0edad$var$escapeSequencesRegExp = /[\x00-\x08\x0b\x0c\x0e-\x1f]/g;
var $5c17d1ae69c0edad$var$meta = [
    "\\u0000",
    "\\u0001",
    "\\u0002",
    "\\u0003",
    "\\u0004",
    "\\u0005",
    "\\u0006",
    "\\u0007",
    '\\b',
    '',
    '',
    "\\u000b",
    '\\f',
    '',
    "\\u000e",
    "\\u000f",
    "\\u0010",
    "\\u0011",
    "\\u0012",
    "\\u0013",
    "\\u0014",
    "\\u0015",
    "\\u0016",
    "\\u0017",
    "\\u0018",
    "\\u0019",
    "\\u001a",
    "\\u001b",
    "\\u001c",
    "\\u001d",
    "\\u001e",
    "\\u001f"
];
var $5c17d1ae69c0edad$var$escapeFn = function escapeFn(str) {
    return $5c17d1ae69c0edad$var$meta[str.charCodeAt(0)];
};
var $5c17d1ae69c0edad$var$warned = false;
// The assert module provides functions that throw
// AssertionError's when particular conditions are not met. The
// assert module must conform to the following interface.
var $5c17d1ae69c0edad$var$assert = module.exports = $5c17d1ae69c0edad$var$ok;
var $5c17d1ae69c0edad$var$NO_EXCEPTION_SENTINEL = {};
// All of the following functions must throw an AssertionError
// when a corresponding condition is not met, with a message that
// may be undefined if not provided. All assertion methods provide
// both the actual and expected values to the assertion error for
// display purposes.
function $5c17d1ae69c0edad$var$innerFail(obj) {
    if (obj.message instanceof Error) throw obj.message;
    throw new $EAZe6(obj);
}
function $5c17d1ae69c0edad$var$fail(actual, expected, message, operator, stackStartFn) {
    var argsLen = arguments.length;
    var internalMessage;
    if (argsLen === 0) internalMessage = 'Failed';
    else if (argsLen === 1) {
        message = actual;
        actual = undefined;
    } else {
        if ($5c17d1ae69c0edad$var$warned === false) {
            $5c17d1ae69c0edad$var$warned = true;
            var warn = $5XqL3.emitWarning ? $5XqL3.emitWarning : console.warn.bind(console);
            warn("assert.fail() with more than one argument is deprecated. Please use assert.strictEqual() instead or only pass a message.", 'DeprecationWarning', 'DEP0094');
        }
        if (argsLen === 2) operator = '!=';
    }
    if (message instanceof Error) throw message;
    var errArgs = {
        actual: actual,
        expected: expected,
        operator: operator === undefined ? 'fail' : operator,
        stackStartFn: stackStartFn || $5c17d1ae69c0edad$var$fail
    };
    if (message !== undefined) errArgs.message = message;
    var err = new $EAZe6(errArgs);
    if (internalMessage) {
        err.message = internalMessage;
        err.generatedMessage = true;
    }
    throw err;
}
$5c17d1ae69c0edad$var$assert.fail = $5c17d1ae69c0edad$var$fail;
// The AssertionError is defined in internal/error.
$5c17d1ae69c0edad$var$assert.AssertionError = $EAZe6;
function $5c17d1ae69c0edad$var$innerOk(fn, argLen, value, message) {
    if (!value) {
        var generatedMessage = false;
        if (argLen === 0) {
            generatedMessage = true;
            message = 'No value argument passed to `assert.ok()`';
        } else if (message instanceof Error) throw message;
        var err = new $EAZe6({
            actual: value,
            expected: true,
            message: message,
            operator: '==',
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
// Pure assertion tests whether a value is truthy, as determined
// by !!value.
function $5c17d1ae69c0edad$var$ok() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    $5c17d1ae69c0edad$var$innerOk.apply(void 0, [
        $5c17d1ae69c0edad$var$ok,
        args.length
    ].concat(args));
}
$5c17d1ae69c0edad$var$assert.ok = $5c17d1ae69c0edad$var$ok;
// The equality assertion tests shallow, coercive equality with ==.
/* eslint-disable no-restricted-properties */ $5c17d1ae69c0edad$var$assert.equal = function equal(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual != expected) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '==',
        stackStartFn: equal
    });
};
// The non-equality assertion tests for whether two objects are not
// equal with !=.
$5c17d1ae69c0edad$var$assert.notEqual = function notEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    // eslint-disable-next-line eqeqeq
    if (actual == expected) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: '!=',
        stackStartFn: notEqual
    });
};
// The equivalence assertion tests a deep equality relation.
$5c17d1ae69c0edad$var$assert.deepEqual = function deepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($5c17d1ae69c0edad$var$isDeepEqual === undefined) $5c17d1ae69c0edad$var$lazyLoadComparison();
    if (!$5c17d1ae69c0edad$var$isDeepEqual(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepEqual',
        stackStartFn: deepEqual
    });
};
// The non-equivalence assertion tests for any deep inequality.
$5c17d1ae69c0edad$var$assert.notDeepEqual = function notDeepEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($5c17d1ae69c0edad$var$isDeepEqual === undefined) $5c17d1ae69c0edad$var$lazyLoadComparison();
    if ($5c17d1ae69c0edad$var$isDeepEqual(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepEqual',
        stackStartFn: notDeepEqual
    });
};
/* eslint-enable */ $5c17d1ae69c0edad$var$assert.deepStrictEqual = function deepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($5c17d1ae69c0edad$var$isDeepEqual === undefined) $5c17d1ae69c0edad$var$lazyLoadComparison();
    if (!$5c17d1ae69c0edad$var$isDeepStrictEqual(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'deepStrictEqual',
        stackStartFn: deepStrictEqual
    });
};
$5c17d1ae69c0edad$var$assert.notDeepStrictEqual = $5c17d1ae69c0edad$var$notDeepStrictEqual;
function $5c17d1ae69c0edad$var$notDeepStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($5c17d1ae69c0edad$var$isDeepEqual === undefined) $5c17d1ae69c0edad$var$lazyLoadComparison();
    if ($5c17d1ae69c0edad$var$isDeepStrictEqual(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notDeepStrictEqual',
        stackStartFn: $5c17d1ae69c0edad$var$notDeepStrictEqual
    });
}
$5c17d1ae69c0edad$var$assert.strictEqual = function strictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if (!$5c17d1ae69c0edad$var$objectIs(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'strictEqual',
        stackStartFn: strictEqual
    });
};
$5c17d1ae69c0edad$var$assert.notStrictEqual = function notStrictEqual(actual, expected, message) {
    if (arguments.length < 2) throw new $5c17d1ae69c0edad$var$ERR_MISSING_ARGS('actual', 'expected');
    if ($5c17d1ae69c0edad$var$objectIs(actual, expected)) $5c17d1ae69c0edad$var$innerFail({
        actual: actual,
        expected: expected,
        message: message,
        operator: 'notStrictEqual',
        stackStartFn: notStrictEqual
    });
};
var $5c17d1ae69c0edad$var$Comparison = /*#__PURE__*/ $5c17d1ae69c0edad$var$_createClass(function Comparison(obj, keys, actual) {
    var _this = this;
    $5c17d1ae69c0edad$var$_classCallCheck(this, Comparison);
    keys.forEach(function(key) {
        if (key in obj) {
            if (actual !== undefined && typeof actual[key] === 'string' && $5c17d1ae69c0edad$var$isRegExp(obj[key]) && $5c17d1ae69c0edad$var$RegExpPrototypeTest(obj[key], actual[key])) _this[key] = actual[key];
            else _this[key] = obj[key];
        }
    });
});
function $5c17d1ae69c0edad$var$compareExceptionKey(actual, expected, key, message, keys, fn) {
    if (!(key in actual) || !$5c17d1ae69c0edad$var$isDeepStrictEqual(actual[key], expected[key])) {
        if (!message) {
            // Create placeholder objects to create a nice output.
            var a = new $5c17d1ae69c0edad$var$Comparison(actual, keys);
            var b = new $5c17d1ae69c0edad$var$Comparison(expected, keys, actual);
            var err = new $EAZe6({
                actual: a,
                expected: b,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.actual = actual;
            err.expected = expected;
            err.operator = fn.name;
            throw err;
        }
        $5c17d1ae69c0edad$var$innerFail({
            actual: actual,
            expected: expected,
            message: message,
            operator: fn.name,
            stackStartFn: fn
        });
    }
}
function $5c17d1ae69c0edad$var$expectedException(actual, expected, msg, fn) {
    if (typeof expected !== 'function') {
        if ($5c17d1ae69c0edad$var$isRegExp(expected)) return $5c17d1ae69c0edad$var$RegExpPrototypeTest(expected, actual);
        // assert.doesNotThrow does not accept objects.
        if (arguments.length === 2) throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('expected', [
            'Function',
            'RegExp'
        ], expected);
        // Handle primitives properly.
        if ($5c17d1ae69c0edad$var$_typeof(actual) !== 'object' || actual === null) {
            var err = new $EAZe6({
                actual: actual,
                expected: expected,
                message: msg,
                operator: 'deepStrictEqual',
                stackStartFn: fn
            });
            err.operator = fn.name;
            throw err;
        }
        var keys = Object.keys(expected);
        // Special handle errors to make sure the name and the message are compared
        // as well.
        if (expected instanceof Error) keys.push('name', 'message');
        else if (keys.length === 0) throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_VALUE('error', expected, 'may not be an empty object');
        if ($5c17d1ae69c0edad$var$isDeepEqual === undefined) $5c17d1ae69c0edad$var$lazyLoadComparison();
        keys.forEach(function(key) {
            if (typeof actual[key] === 'string' && $5c17d1ae69c0edad$var$isRegExp(expected[key]) && $5c17d1ae69c0edad$var$RegExpPrototypeTest(expected[key], actual[key])) return;
            $5c17d1ae69c0edad$var$compareExceptionKey(actual, expected, key, msg, keys, fn);
        });
        return true;
    }
    // Guard instanceof against arrow functions as they don't have a prototype.
    if (expected.prototype !== undefined && actual instanceof expected) return true;
    if (Error.isPrototypeOf(expected)) return false;
    return expected.call({}, actual) === true;
}
function $5c17d1ae69c0edad$var$getActual(fn) {
    if (typeof fn !== 'function') throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('fn', 'Function', fn);
    try {
        fn();
    } catch (e) {
        return e;
    }
    return $5c17d1ae69c0edad$var$NO_EXCEPTION_SENTINEL;
}
function $5c17d1ae69c0edad$var$checkIsPromise(obj) {
    // Accept native ES6 promises and promises that are implemented in a similar
    // way. Do not accept thenables that use a function as `obj` and that have no
    // `catch` handler.
    // TODO: thenables are checked up until they have the correct methods,
    // but according to documentation, the `then` method should receive
    // the `fulfill` and `reject` arguments as well or it may be never resolved.
    return $5c17d1ae69c0edad$var$isPromise(obj) || obj !== null && $5c17d1ae69c0edad$var$_typeof(obj) === 'object' && typeof obj.then === 'function' && typeof obj.catch === 'function';
}
function $5c17d1ae69c0edad$var$waitForActual(promiseFn) {
    return Promise.resolve().then(function() {
        var resultPromise;
        if (typeof promiseFn === 'function') {
            // Return a rejected promise if `promiseFn` throws synchronously.
            resultPromise = promiseFn();
            // Fail in case no promise is returned.
            if (!$5c17d1ae69c0edad$var$checkIsPromise(resultPromise)) throw new $5c17d1ae69c0edad$var$ERR_INVALID_RETURN_VALUE('instance of Promise', 'promiseFn', resultPromise);
        } else if ($5c17d1ae69c0edad$var$checkIsPromise(promiseFn)) resultPromise = promiseFn;
        else throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('promiseFn', [
            'Function',
            'Promise'
        ], promiseFn);
        return Promise.resolve().then(function() {
            return resultPromise;
        }).then(function() {
            return $5c17d1ae69c0edad$var$NO_EXCEPTION_SENTINEL;
        }).catch(function(e) {
            return e;
        });
    });
}
function $5c17d1ae69c0edad$var$expectsError(stackStartFn, actual, error, message) {
    if (typeof error === 'string') {
        if (arguments.length === 4) throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('error', [
            'Object',
            'Error',
            'Function',
            'RegExp'
        ], error);
        if ($5c17d1ae69c0edad$var$_typeof(actual) === 'object' && actual !== null) {
            if (actual.message === error) throw new $5c17d1ae69c0edad$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error message \"".concat(actual.message, "\" is identical to the message."));
        } else if (actual === error) throw new $5c17d1ae69c0edad$var$ERR_AMBIGUOUS_ARGUMENT('error/message', "The error \"".concat(actual, "\" is identical to the message."));
        message = error;
        error = undefined;
    } else if (error != null && $5c17d1ae69c0edad$var$_typeof(error) !== 'object' && typeof error !== 'function') throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('error', [
        'Object',
        'Error',
        'Function',
        'RegExp'
    ], error);
    if (actual === $5c17d1ae69c0edad$var$NO_EXCEPTION_SENTINEL) {
        var details = '';
        if (error && error.name) details += " (".concat(error.name, ")");
        details += message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'rejects' ? 'rejection' : 'exception';
        $5c17d1ae69c0edad$var$innerFail({
            actual: undefined,
            expected: error,
            operator: stackStartFn.name,
            message: "Missing expected ".concat(fnType).concat(details),
            stackStartFn: stackStartFn
        });
    }
    if (error && !$5c17d1ae69c0edad$var$expectedException(actual, error, message, stackStartFn)) throw actual;
}
function $5c17d1ae69c0edad$var$expectsNoError(stackStartFn, actual, error, message) {
    if (actual === $5c17d1ae69c0edad$var$NO_EXCEPTION_SENTINEL) return;
    if (typeof error === 'string') {
        message = error;
        error = undefined;
    }
    if (!error || $5c17d1ae69c0edad$var$expectedException(actual, error)) {
        var details = message ? ": ".concat(message) : '.';
        var fnType = stackStartFn.name === 'doesNotReject' ? 'rejection' : 'exception';
        $5c17d1ae69c0edad$var$innerFail({
            actual: actual,
            expected: error,
            operator: stackStartFn.name,
            message: "Got unwanted ".concat(fnType).concat(details, "\n") + "Actual message: \"".concat(actual && actual.message, "\""),
            stackStartFn: stackStartFn
        });
    }
    throw actual;
}
$5c17d1ae69c0edad$var$assert.throws = function throws(promiseFn) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    $5c17d1ae69c0edad$var$expectsError.apply(void 0, [
        throws,
        $5c17d1ae69c0edad$var$getActual(promiseFn)
    ].concat(args));
};
$5c17d1ae69c0edad$var$assert.rejects = function rejects(promiseFn) {
    for(var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)args[_key3 - 1] = arguments[_key3];
    return $5c17d1ae69c0edad$var$waitForActual(promiseFn).then(function(result) {
        return $5c17d1ae69c0edad$var$expectsError.apply(void 0, [
            rejects,
            result
        ].concat(args));
    });
};
$5c17d1ae69c0edad$var$assert.doesNotThrow = function doesNotThrow(fn) {
    for(var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++)args[_key4 - 1] = arguments[_key4];
    $5c17d1ae69c0edad$var$expectsNoError.apply(void 0, [
        doesNotThrow,
        $5c17d1ae69c0edad$var$getActual(fn)
    ].concat(args));
};
$5c17d1ae69c0edad$var$assert.doesNotReject = function doesNotReject(fn) {
    for(var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++)args[_key5 - 1] = arguments[_key5];
    return $5c17d1ae69c0edad$var$waitForActual(fn).then(function(result) {
        return $5c17d1ae69c0edad$var$expectsNoError.apply(void 0, [
            doesNotReject,
            result
        ].concat(args));
    });
};
$5c17d1ae69c0edad$var$assert.ifError = function ifError(err) {
    if (err !== null && err !== undefined) {
        var message = 'ifError got unwanted exception: ';
        if ($5c17d1ae69c0edad$var$_typeof(err) === 'object' && typeof err.message === 'string') {
            if (err.message.length === 0 && err.constructor) message += err.constructor.name;
            else message += err.message;
        } else message += $5c17d1ae69c0edad$var$inspect(err);
        var newErr = new $EAZe6({
            actual: err,
            expected: null,
            operator: 'ifError',
            message: message,
            stackStartFn: ifError
        });
        // Make sure we actually have a stack trace!
        var origStack = err.stack;
        if (typeof origStack === 'string') {
            // This will remove any duplicated frames from the error frames taken
            // from within `ifError` and add the original error frames to the newly
            // created ones.
            var tmp2 = origStack.split('\n');
            tmp2.shift();
            // Filter all frames existing in err.stack.
            var tmp1 = newErr.stack.split('\n');
            for(var i = 0; i < tmp2.length; i++){
                // Find the first occurrence of the frame.
                var pos = tmp1.indexOf(tmp2[i]);
                if (pos !== -1) {
                    // Only keep new frames.
                    tmp1 = tmp1.slice(0, pos);
                    break;
                }
            }
            newErr.stack = "".concat(tmp1.join('\n'), "\n").concat(tmp2.join('\n'));
        }
        throw newErr;
    }
};
// Currently in sync with Node.js lib/assert.js
// https://github.com/nodejs/node/commit/2a871df3dfb8ea663ef5e1f8f62701ec51384ecb
function $5c17d1ae69c0edad$var$internalMatch(string, regexp, message, fn, fnName) {
    if (!$5c17d1ae69c0edad$var$isRegExp(regexp)) throw new $5c17d1ae69c0edad$var$ERR_INVALID_ARG_TYPE('regexp', 'RegExp', regexp);
    var match = fnName === 'match';
    if (typeof string !== 'string' || $5c17d1ae69c0edad$var$RegExpPrototypeTest(regexp, string) !== match) {
        if (message instanceof Error) throw message;
        var generatedMessage = !message;
        // 'The input was expected to not match the regular expression ' +
        message = message || (typeof string !== 'string' ? 'The "string" argument must be of type string. Received type ' + "".concat($5c17d1ae69c0edad$var$_typeof(string), " (").concat($5c17d1ae69c0edad$var$inspect(string), ")") : (match ? 'The input did not match the regular expression ' : 'The input was expected to not match the regular expression ') + "".concat($5c17d1ae69c0edad$var$inspect(regexp), ". Input:\n\n").concat($5c17d1ae69c0edad$var$inspect(string), "\n"));
        var err = new $EAZe6({
            actual: string,
            expected: regexp,
            message: message,
            operator: fnName,
            stackStartFn: fn
        });
        err.generatedMessage = generatedMessage;
        throw err;
    }
}
$5c17d1ae69c0edad$var$assert.match = function match(string, regexp, message) {
    $5c17d1ae69c0edad$var$internalMatch(string, regexp, message, match, 'match');
};
$5c17d1ae69c0edad$var$assert.doesNotMatch = function doesNotMatch(string, regexp, message) {
    $5c17d1ae69c0edad$var$internalMatch(string, regexp, message, doesNotMatch, 'doesNotMatch');
};
// Expose a strict only variant of assert
function $5c17d1ae69c0edad$var$strict() {
    for(var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++)args[_key6] = arguments[_key6];
    $5c17d1ae69c0edad$var$innerOk.apply(void 0, [
        $5c17d1ae69c0edad$var$strict,
        args.length
    ].concat(args));
}
$5c17d1ae69c0edad$var$assert.strict = $5c17d1ae69c0edad$var$objectAssign($5c17d1ae69c0edad$var$strict, $5c17d1ae69c0edad$var$assert, {
    equal: $5c17d1ae69c0edad$var$assert.strictEqual,
    deepEqual: $5c17d1ae69c0edad$var$assert.deepStrictEqual,
    notEqual: $5c17d1ae69c0edad$var$assert.notStrictEqual,
    notDeepEqual: $5c17d1ae69c0edad$var$assert.notDeepStrictEqual
});
$5c17d1ae69c0edad$var$assert.strict.strict = $5c17d1ae69c0edad$var$assert.strict;

});
parcelRegister("jUZ7b", function(module, exports) {

$parcel$export(module.exports, "codes", function () { return $e802a76d61487b28$export$e45cb6485273080e; }, function (v) { return $e802a76d61487b28$export$e45cb6485273080e = v; });
// Currently in sync with Node.js lib/internal/errors.js
// https://github.com/nodejs/node/commit/3b044962c48fe313905877a96b5d0894a5404f6f
/* eslint node-core/documented-errors: "error" */ /* eslint node-core/alphabetize-errors: "error" */ /* eslint node-core/prefer-util-format-errors: "error" */ var $e802a76d61487b28$export$e45cb6485273080e;
'use strict';
// The whole point behind this internal module is to allow Node.js to no
// longer be forced to treat every error message change as a semver-major
// change. The NodeError classes here all expose a `code` property whose
// value statically and permanently identifies the error. While the error
// message may change, the code should not.
function $e802a76d61487b28$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $e802a76d61487b28$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $e802a76d61487b28$var$_typeof(o);
}
function $e802a76d61487b28$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $e802a76d61487b28$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $e802a76d61487b28$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e802a76d61487b28$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e802a76d61487b28$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $e802a76d61487b28$var$_toPropertyKey(arg) {
    var key = $e802a76d61487b28$var$_toPrimitive(arg, "string");
    return $e802a76d61487b28$var$_typeof(key) === "symbol" ? key : String(key);
}
function $e802a76d61487b28$var$_toPrimitive(input, hint) {
    if ($e802a76d61487b28$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($e802a76d61487b28$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $e802a76d61487b28$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e802a76d61487b28$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $e802a76d61487b28$var$_setPrototypeOf(subClass, superClass);
}
function $e802a76d61487b28$var$_setPrototypeOf(o, p) {
    $e802a76d61487b28$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e802a76d61487b28$var$_setPrototypeOf(o, p);
}
function $e802a76d61487b28$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $e802a76d61487b28$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $e802a76d61487b28$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $e802a76d61487b28$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $e802a76d61487b28$var$_possibleConstructorReturn(this, result);
    };
}
function $e802a76d61487b28$var$_possibleConstructorReturn(self, call) {
    if (call && ($e802a76d61487b28$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $e802a76d61487b28$var$_assertThisInitialized(self);
}
function $e802a76d61487b28$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e802a76d61487b28$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $e802a76d61487b28$var$_getPrototypeOf(o) {
    $e802a76d61487b28$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e802a76d61487b28$var$_getPrototypeOf(o);
}
var $e802a76d61487b28$var$codes = {};
// Lazy loaded
var $e802a76d61487b28$var$assert;
var $e802a76d61487b28$var$util;
function $e802a76d61487b28$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === 'string') return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $e802a76d61487b28$var$_inherits(NodeError, _Base);
        var _super = $e802a76d61487b28$var$_createSuper(NodeError);
        function NodeError(arg1, arg2, arg3) {
            var _this;
            $e802a76d61487b28$var$_classCallCheck(this, NodeError);
            _this = _super.call(this, getMessage(arg1, arg2, arg3));
            _this.code = code;
            return _this;
        }
        return $e802a76d61487b28$var$_createClass(NodeError);
    }(Base);
    $e802a76d61487b28$var$codes[code] = NodeError;
}
// https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $e802a76d61487b28$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(', '), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $e802a76d61487b28$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $e802a76d61487b28$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $e802a76d61487b28$var$includes(str, search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$e802a76d61487b28$var$createErrorType('ERR_AMBIGUOUS_ARGUMENT', 'The "%s" argument is ambiguous. %s', TypeError);

$e802a76d61487b28$var$createErrorType('ERR_INVALID_ARG_TYPE', function(name, expected, actual) {
    if ($e802a76d61487b28$var$assert === undefined) $e802a76d61487b28$var$assert = (parcelRequire("7UcXO"));
    $e802a76d61487b28$var$assert(typeof name === 'string', "'name' must be a string");
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === 'string' && $e802a76d61487b28$var$startsWith(expected, 'not ')) {
        determiner = 'must not be';
        expected = expected.replace(/^not /, '');
    } else determiner = 'must be';
    var msg;
    if ($e802a76d61487b28$var$endsWith(name, ' argument')) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($e802a76d61487b28$var$oneOf(expected, 'type'));
    else {
        var type = $e802a76d61487b28$var$includes(name, '.') ? 'property' : 'argument';
        msg = "The \"".concat(name, "\" ").concat(type, " ").concat(determiner, " ").concat($e802a76d61487b28$var$oneOf(expected, 'type'));
    }
    // TODO(BridgeAR): Improve the output by showing `null` and similar.
    msg += ". Received type ".concat($e802a76d61487b28$var$_typeof(actual));
    return msg;
}, TypeError);

$e802a76d61487b28$var$createErrorType('ERR_INVALID_ARG_VALUE', function(name, value) {
    var reason = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'is invalid';
    if ($e802a76d61487b28$var$util === undefined) $e802a76d61487b28$var$util = (parcelRequire("hHIjR"));
    var inspected = $e802a76d61487b28$var$util.inspect(value);
    if (inspected.length > 128) inspected = "".concat(inspected.slice(0, 128), "...");
    return "The argument '".concat(name, "' ").concat(reason, ". Received ").concat(inspected);
}, TypeError, RangeError);
$e802a76d61487b28$var$createErrorType('ERR_INVALID_RETURN_VALUE', function(input, name, value) {
    var type;
    if (value && value.constructor && value.constructor.name) type = "instance of ".concat(value.constructor.name);
    else type = "type ".concat($e802a76d61487b28$var$_typeof(value));
    return "Expected ".concat(input, " to be returned from the \"").concat(name, "\"") + " function but got ".concat(type, ".");
}, TypeError);

$e802a76d61487b28$var$createErrorType('ERR_MISSING_ARGS', function() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    if ($e802a76d61487b28$var$assert === undefined) $e802a76d61487b28$var$assert = (parcelRequire("7UcXO"));
    $e802a76d61487b28$var$assert(args.length > 0, 'At least one arg needs to be specified');
    var msg = 'The ';
    var len = args.length;
    args = args.map(function(a) {
        return "\"".concat(a, "\"");
    });
    switch(len){
        case 1:
            msg += "".concat(args[0], " argument");
            break;
        case 2:
            msg += "".concat(args[0], " and ").concat(args[1], " arguments");
            break;
        default:
            msg += args.slice(0, len - 1).join(', ');
            msg += ", and ".concat(args[len - 1], " arguments");
            break;
    }
    return "".concat(msg, " must be specified");
}, TypeError);
$e802a76d61487b28$export$e45cb6485273080e = $e802a76d61487b28$var$codes;

});

parcelRegister("EAZe6", function(module, exports) {
// Currently in sync with Node.js lib/internal/assert/assertion_error.js
// https://github.com/nodejs/node/commit/0817840f775032169ddd70c85ac059f18ffcc81c

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
function $07a06d4b5743fee3$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $07a06d4b5743fee3$var$_objectSpread(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $07a06d4b5743fee3$var$ownKeys(Object(t), !0).forEach(function(r) {
            $07a06d4b5743fee3$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $07a06d4b5743fee3$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $07a06d4b5743fee3$var$_defineProperty(obj, key, value) {
    key = $07a06d4b5743fee3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $07a06d4b5743fee3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $07a06d4b5743fee3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $07a06d4b5743fee3$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $07a06d4b5743fee3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $07a06d4b5743fee3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $07a06d4b5743fee3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $07a06d4b5743fee3$var$_toPropertyKey(arg) {
    var key = $07a06d4b5743fee3$var$_toPrimitive(arg, "string");
    return $07a06d4b5743fee3$var$_typeof(key) === "symbol" ? key : String(key);
}
function $07a06d4b5743fee3$var$_toPrimitive(input, hint) {
    if ($07a06d4b5743fee3$var$_typeof(input) !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if ($07a06d4b5743fee3$var$_typeof(res) !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $07a06d4b5743fee3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    Object.defineProperty(subClass, "prototype", {
        writable: false
    });
    if (superClass) $07a06d4b5743fee3$var$_setPrototypeOf(subClass, superClass);
}
function $07a06d4b5743fee3$var$_createSuper(Derived) {
    var hasNativeReflectConstruct = $07a06d4b5743fee3$var$_isNativeReflectConstruct();
    return function _createSuperInternal() {
        var Super = $07a06d4b5743fee3$var$_getPrototypeOf(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = $07a06d4b5743fee3$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $07a06d4b5743fee3$var$_possibleConstructorReturn(this, result);
    };
}
function $07a06d4b5743fee3$var$_possibleConstructorReturn(self, call) {
    if (call && ($07a06d4b5743fee3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    else if (call !== void 0) throw new TypeError("Derived constructors may only return object or undefined");
    return $07a06d4b5743fee3$var$_assertThisInitialized(self);
}
function $07a06d4b5743fee3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $07a06d4b5743fee3$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $07a06d4b5743fee3$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$07a06d4b5743fee3$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $07a06d4b5743fee3$var$_construct(Class, arguments, $07a06d4b5743fee3$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $07a06d4b5743fee3$var$_setPrototypeOf(Wrapper, Class);
    };
    return $07a06d4b5743fee3$var$_wrapNativeSuper(Class);
}
function $07a06d4b5743fee3$var$_construct(Parent, args, Class) {
    if ($07a06d4b5743fee3$var$_isNativeReflectConstruct()) $07a06d4b5743fee3$var$_construct = Reflect.construct.bind();
    else $07a06d4b5743fee3$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $07a06d4b5743fee3$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $07a06d4b5743fee3$var$_construct.apply(null, arguments);
}
function $07a06d4b5743fee3$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $07a06d4b5743fee3$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $07a06d4b5743fee3$var$_setPrototypeOf(o, p) {
    $07a06d4b5743fee3$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $07a06d4b5743fee3$var$_setPrototypeOf(o, p);
}
function $07a06d4b5743fee3$var$_getPrototypeOf(o) {
    $07a06d4b5743fee3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $07a06d4b5743fee3$var$_getPrototypeOf(o);
}
function $07a06d4b5743fee3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $07a06d4b5743fee3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $07a06d4b5743fee3$var$_typeof(o);
}

var $hHIjR = parcelRequire("hHIjR");
var $07a06d4b5743fee3$var$inspect = $hHIjR.inspect;

var $jUZ7b = parcelRequire("jUZ7b");
var $07a06d4b5743fee3$var$ERR_INVALID_ARG_TYPE = $jUZ7b.codes.ERR_INVALID_ARG_TYPE;
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $07a06d4b5743fee3$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
}
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/repeat
function $07a06d4b5743fee3$var$repeat(str, count) {
    count = Math.floor(count);
    if (str.length == 0 || count == 0) return '';
    var maxCount = str.length * count;
    count = Math.floor(Math.log(count) / Math.log(2));
    while(count){
        str += str;
        count--;
    }
    str += str.substring(0, maxCount - str.length);
    return str;
}
var $07a06d4b5743fee3$var$blue = '';
var $07a06d4b5743fee3$var$green = '';
var $07a06d4b5743fee3$var$red = '';
var $07a06d4b5743fee3$var$white = '';
var $07a06d4b5743fee3$var$kReadableOperator = {
    deepStrictEqual: 'Expected values to be strictly deep-equal:',
    strictEqual: 'Expected values to be strictly equal:',
    strictEqualObject: 'Expected "actual" to be reference-equal to "expected":',
    deepEqual: 'Expected values to be loosely deep-equal:',
    equal: 'Expected values to be loosely equal:',
    notDeepStrictEqual: 'Expected "actual" not to be strictly deep-equal to:',
    notStrictEqual: 'Expected "actual" to be strictly unequal to:',
    notStrictEqualObject: 'Expected "actual" not to be reference-equal to "expected":',
    notDeepEqual: 'Expected "actual" not to be loosely deep-equal to:',
    notEqual: 'Expected "actual" to be loosely unequal to:',
    notIdentical: 'Values identical but not reference-equal:'
};
// Comparing short primitives should just show === / !== instead of using the
// diff.
var $07a06d4b5743fee3$var$kMaxShortLength = 10;
function $07a06d4b5743fee3$var$copyError(source) {
    var keys = Object.keys(source);
    var target = Object.create(Object.getPrototypeOf(source));
    keys.forEach(function(key) {
        target[key] = source[key];
    });
    Object.defineProperty(target, 'message', {
        value: source.message
    });
    return target;
}
function $07a06d4b5743fee3$var$inspectValue(val) {
    // The util.inspect default values could be changed. This makes sure the
    // error messages contain the necessary information nevertheless.
    return $07a06d4b5743fee3$var$inspect(val, {
        compact: false,
        customInspect: false,
        depth: 1000,
        maxArrayLength: Infinity,
        // Assert compares only enumerable properties (with a few exceptions).
        showHidden: false,
        // Having a long line as error is better than wrapping the line for
        // comparison for now.
        // TODO(BridgeAR): `breakLength` should be limited as soon as soon as we
        // have meta information about the inspected properties (i.e., know where
        // in what line the property starts and ends).
        breakLength: Infinity,
        // Assert does not detect proxies currently.
        showProxy: false,
        sorted: true,
        // Inspect getters as we also check them when comparing entries.
        getters: true
    });
}
function $07a06d4b5743fee3$var$createErrDiff(actual, expected, operator) {
    var other = '';
    var res = '';
    var lastPos = 0;
    var end = '';
    var skipped = false;
    var actualInspected = $07a06d4b5743fee3$var$inspectValue(actual);
    var actualLines = actualInspected.split('\n');
    var expectedLines = $07a06d4b5743fee3$var$inspectValue(expected).split('\n');
    var i = 0;
    var indicator = '';
    // In case both values are objects explicitly mark them as not reference equal
    // for the `strictEqual` operator.
    if (operator === 'strictEqual' && $07a06d4b5743fee3$var$_typeof(actual) === 'object' && $07a06d4b5743fee3$var$_typeof(expected) === 'object' && actual !== null && expected !== null) operator = 'strictEqualObject';
    // If "actual" and "expected" fit on a single line and they are not strictly
    // equal, check further special handling.
    if (actualLines.length === 1 && expectedLines.length === 1 && actualLines[0] !== expectedLines[0]) {
        var inputLength = actualLines[0].length + expectedLines[0].length;
        // If the character length of "actual" and "expected" together is less than
        // kMaxShortLength and if neither is an object and at least one of them is
        // not `zero`, use the strict equal comparison to visualize the output.
        if (inputLength <= $07a06d4b5743fee3$var$kMaxShortLength) {
            if (($07a06d4b5743fee3$var$_typeof(actual) !== 'object' || actual === null) && ($07a06d4b5743fee3$var$_typeof(expected) !== 'object' || expected === null) && (actual !== 0 || expected !== 0)) // -0 === +0
            return "".concat($07a06d4b5743fee3$var$kReadableOperator[operator], "\n\n") + "".concat(actualLines[0], " !== ").concat(expectedLines[0], "\n");
        } else if (operator !== 'strictEqualObject') {
            // If the stderr is a tty and the input length is lower than the current
            // columns per line, add a mismatch indicator below the output. If it is
            // not a tty, use a default value of 80 characters.
            var maxLength = $5XqL3.stderr && $5XqL3.stderr.isTTY ? $5XqL3.stderr.columns : 80;
            if (inputLength < maxLength) {
                while(actualLines[0][i] === expectedLines[0][i])i++;
                // Ignore the first characters.
                if (i > 2) {
                    // Add position indicator for the first mismatch in case it is a
                    // single line and the input length is less than the column length.
                    indicator = "\n  ".concat($07a06d4b5743fee3$var$repeat(' ', i), "^");
                    i = 0;
                }
            }
        }
    }
    // Remove all ending lines that match (this optimizes the output for
    // readability by reducing the number of total changed lines).
    var a = actualLines[actualLines.length - 1];
    var b = expectedLines[expectedLines.length - 1];
    while(a === b){
        if (i++ < 2) end = "\n  ".concat(a).concat(end);
        else other = a;
        actualLines.pop();
        expectedLines.pop();
        if (actualLines.length === 0 || expectedLines.length === 0) break;
        a = actualLines[actualLines.length - 1];
        b = expectedLines[expectedLines.length - 1];
    }
    var maxLines = Math.max(actualLines.length, expectedLines.length);
    // Strict equal with identical objects that are not identical by reference.
    // E.g., assert.deepStrictEqual({ a: Symbol() }, { a: Symbol() })
    if (maxLines === 0) {
        // We have to get the result again. The lines were all removed before.
        var _actualLines = actualInspected.split('\n');
        // Only remove lines in case it makes sense to collapse those.
        // TODO: Accept env to always show the full error.
        if (_actualLines.length > 30) {
            _actualLines[26] = "".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
            while(_actualLines.length > 27)_actualLines.pop();
        }
        return "".concat($07a06d4b5743fee3$var$kReadableOperator.notIdentical, "\n\n").concat(_actualLines.join('\n'), "\n");
    }
    if (i > 3) {
        end = "\n".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white).concat(end);
        skipped = true;
    }
    if (other !== '') {
        end = "\n  ".concat(other).concat(end);
        other = '';
    }
    var printedLines = 0;
    var msg = $07a06d4b5743fee3$var$kReadableOperator[operator] + "\n".concat($07a06d4b5743fee3$var$green, "+ actual").concat($07a06d4b5743fee3$var$white, " ").concat($07a06d4b5743fee3$var$red, "- expected").concat($07a06d4b5743fee3$var$white);
    var skippedMsg = " ".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white, " Lines skipped");
    for(i = 0; i < maxLines; i++){
        // Only extra expected lines exist
        var cur = i - lastPos;
        if (actualLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(expectedLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(expectedLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the expected line to the cache.
            other += "\n".concat($07a06d4b5743fee3$var$red, "-").concat($07a06d4b5743fee3$var$white, " ").concat(expectedLines[i]);
            printedLines++;
        // Only extra actual lines exist
        } else if (expectedLines.length < i + 1) {
            // If the last diverging line is more than one line above and the
            // current line is at least line three, add some of the former lines and
            // also add dots to indicate skipped entries.
            if (cur > 1 && i > 2) {
                if (cur > 4) {
                    res += "\n".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
                    skipped = true;
                } else if (cur > 3) {
                    res += "\n  ".concat(actualLines[i - 2]);
                    printedLines++;
                }
                res += "\n  ".concat(actualLines[i - 1]);
                printedLines++;
            }
            // Mark the current line as the last diverging one.
            lastPos = i;
            // Add the actual line to the result.
            res += "\n".concat($07a06d4b5743fee3$var$green, "+").concat($07a06d4b5743fee3$var$white, " ").concat(actualLines[i]);
            printedLines++;
        // Lines diverge
        } else {
            var expectedLine = expectedLines[i];
            var actualLine = actualLines[i];
            // If the lines diverge, specifically check for lines that only diverge by
            // a trailing comma. In that case it is actually identical and we should
            // mark it as such.
            var divergingLines = actualLine !== expectedLine && (!$07a06d4b5743fee3$var$endsWith(actualLine, ',') || actualLine.slice(0, -1) !== expectedLine);
            // If the expected line has a trailing comma but is otherwise identical,
            // add a comma at the end of the actual line. Otherwise the output could
            // look weird as in:
            //
            //   [
            //     1         // No comma at the end!
            // +   2
            //   ]
            //
            if (divergingLines && $07a06d4b5743fee3$var$endsWith(expectedLine, ',') && expectedLine.slice(0, -1) === actualLine) {
                divergingLines = false;
                actualLine += ',';
            }
            if (divergingLines) {
                // If the last diverging line is more than one line above and the
                // current line is at least line three, add some of the former lines and
                // also add dots to indicate skipped entries.
                if (cur > 1 && i > 2) {
                    if (cur > 4) {
                        res += "\n".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
                        skipped = true;
                    } else if (cur > 3) {
                        res += "\n  ".concat(actualLines[i - 2]);
                        printedLines++;
                    }
                    res += "\n  ".concat(actualLines[i - 1]);
                    printedLines++;
                }
                // Mark the current line as the last diverging one.
                lastPos = i;
                // Add the actual line to the result and cache the expected diverging
                // line so consecutive diverging lines show up as +++--- and not +-+-+-.
                res += "\n".concat($07a06d4b5743fee3$var$green, "+").concat($07a06d4b5743fee3$var$white, " ").concat(actualLine);
                other += "\n".concat($07a06d4b5743fee3$var$red, "-").concat($07a06d4b5743fee3$var$white, " ").concat(expectedLine);
                printedLines += 2;
            // Lines are identical
            } else {
                // Add all cached information to the result before adding other things
                // and reset the cache.
                res += other;
                other = '';
                // If the last diverging line is exactly one line above or if it is the
                // very first line, add the line to the result.
                if (cur === 1 || i === 0) {
                    res += "\n  ".concat(actualLine);
                    printedLines++;
                }
            }
        }
        // Inspected object to big (Show ~20 rows max)
        if (printedLines > 20 && i < maxLines - 2) return "".concat(msg).concat(skippedMsg, "\n").concat(res, "\n").concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white).concat(other, "\n") + "".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
    }
    return "".concat(msg).concat(skipped ? skippedMsg : '', "\n").concat(res).concat(other).concat(end).concat(indicator);
}
var $07a06d4b5743fee3$var$AssertionError = /*#__PURE__*/ function(_Error, _inspect$custom) {
    $07a06d4b5743fee3$var$_inherits(AssertionError, _Error);
    var _super = $07a06d4b5743fee3$var$_createSuper(AssertionError);
    function AssertionError(options) {
        var _this;
        $07a06d4b5743fee3$var$_classCallCheck(this, AssertionError);
        if ($07a06d4b5743fee3$var$_typeof(options) !== 'object' || options === null) throw new $07a06d4b5743fee3$var$ERR_INVALID_ARG_TYPE('options', 'Object', options);
        var message = options.message, operator = options.operator, stackStartFn = options.stackStartFn;
        var actual = options.actual, expected = options.expected;
        var limit = Error.stackTraceLimit;
        Error.stackTraceLimit = 0;
        if (message != null) _this = _super.call(this, String(message));
        else {
            if ($5XqL3.stderr && $5XqL3.stderr.isTTY) {
                // Reset on each call to make sure we handle dynamically set environment
                // variables correct.
                if ($5XqL3.stderr && $5XqL3.stderr.getColorDepth && $5XqL3.stderr.getColorDepth() !== 1) {
                    $07a06d4b5743fee3$var$blue = "\x1B[34m";
                    $07a06d4b5743fee3$var$green = "\x1B[32m";
                    $07a06d4b5743fee3$var$white = "\x1B[39m";
                    $07a06d4b5743fee3$var$red = "\x1B[31m";
                } else {
                    $07a06d4b5743fee3$var$blue = '';
                    $07a06d4b5743fee3$var$green = '';
                    $07a06d4b5743fee3$var$white = '';
                    $07a06d4b5743fee3$var$red = '';
                }
            }
            // Prevent the error stack from being visible by duplicating the error
            // in a very close way to the original in case both sides are actually
            // instances of Error.
            if ($07a06d4b5743fee3$var$_typeof(actual) === 'object' && actual !== null && $07a06d4b5743fee3$var$_typeof(expected) === 'object' && expected !== null && 'stack' in actual && actual instanceof Error && 'stack' in expected && expected instanceof Error) {
                actual = $07a06d4b5743fee3$var$copyError(actual);
                expected = $07a06d4b5743fee3$var$copyError(expected);
            }
            if (operator === 'deepStrictEqual' || operator === 'strictEqual') _this = _super.call(this, $07a06d4b5743fee3$var$createErrDiff(actual, expected, operator));
            else if (operator === 'notDeepStrictEqual' || operator === 'notStrictEqual') {
                // In case the objects are equal but the operator requires unequal, show
                // the first object and say A equals B
                var base = $07a06d4b5743fee3$var$kReadableOperator[operator];
                var res = $07a06d4b5743fee3$var$inspectValue(actual).split('\n');
                // In case "actual" is an object, it should not be reference equal.
                if (operator === 'notStrictEqual' && $07a06d4b5743fee3$var$_typeof(actual) === 'object' && actual !== null) base = $07a06d4b5743fee3$var$kReadableOperator.notStrictEqualObject;
                // Only remove lines in case it makes sense to collapse those.
                // TODO: Accept env to always show the full error.
                if (res.length > 30) {
                    res[26] = "".concat($07a06d4b5743fee3$var$blue, "...").concat($07a06d4b5743fee3$var$white);
                    while(res.length > 27)res.pop();
                }
                // Only print a single input.
                if (res.length === 1) _this = _super.call(this, "".concat(base, " ").concat(res[0]));
                else _this = _super.call(this, "".concat(base, "\n\n").concat(res.join('\n'), "\n"));
            } else {
                var _res = $07a06d4b5743fee3$var$inspectValue(actual);
                var other = '';
                var knownOperators = $07a06d4b5743fee3$var$kReadableOperator[operator];
                if (operator === 'notDeepEqual' || operator === 'notEqual') {
                    _res = "".concat($07a06d4b5743fee3$var$kReadableOperator[operator], "\n\n").concat(_res);
                    if (_res.length > 1024) _res = "".concat(_res.slice(0, 1021), "...");
                } else {
                    other = "".concat($07a06d4b5743fee3$var$inspectValue(expected));
                    if (_res.length > 512) _res = "".concat(_res.slice(0, 509), "...");
                    if (other.length > 512) other = "".concat(other.slice(0, 509), "...");
                    if (operator === 'deepEqual' || operator === 'equal') _res = "".concat(knownOperators, "\n\n").concat(_res, "\n\nshould equal\n\n");
                    else other = " ".concat(operator, " ").concat(other);
                }
                _this = _super.call(this, "".concat(_res).concat(other));
            }
        }
        Error.stackTraceLimit = limit;
        _this.generatedMessage = !message;
        Object.defineProperty($07a06d4b5743fee3$var$_assertThisInitialized(_this), 'name', {
            value: 'AssertionError [ERR_ASSERTION]',
            enumerable: false,
            writable: true,
            configurable: true
        });
        _this.code = 'ERR_ASSERTION';
        _this.actual = actual;
        _this.expected = expected;
        _this.operator = operator;
        if (Error.captureStackTrace) // eslint-disable-next-line no-restricted-syntax
        Error.captureStackTrace($07a06d4b5743fee3$var$_assertThisInitialized(_this), stackStartFn);
        // Create error message including the error code in the name.
        _this.stack;
        // Reset the name.
        _this.name = 'AssertionError';
        return $07a06d4b5743fee3$var$_possibleConstructorReturn(_this);
    }
    $07a06d4b5743fee3$var$_createClass(AssertionError, [
        {
            key: "toString",
            value: function toString() {
                return "".concat(this.name, " [").concat(this.code, "]: ").concat(this.message);
            }
        },
        {
            key: _inspect$custom,
            value: function value(recurseTimes, ctx) {
                // This limits the `actual` and `expected` property default inspection to
                // the minimum depth. Otherwise those values would be too verbose compared
                // to the actual error message which contains a combined view of these two
                // input values.
                return $07a06d4b5743fee3$var$inspect(this, $07a06d4b5743fee3$var$_objectSpread($07a06d4b5743fee3$var$_objectSpread({}, ctx), {}, {
                    customInspect: false,
                    depth: 0
                }));
            }
        }
    ]);
    return AssertionError;
}(/*#__PURE__*/ $07a06d4b5743fee3$var$_wrapNativeSuper(Error), $07a06d4b5743fee3$var$inspect.custom);
module.exports = $07a06d4b5743fee3$var$AssertionError;

});

parcelRegister("1muN4", function(module, exports) {
'use strict';

var $aLPDY = parcelRequire("aLPDY");
var $0fdfbae24274f3f8$var$lacksProperEnumerationOrder = function() {
    if (!Object.assign) return false;
    /*
	 * v8, specifically in node 4.x, has a bug with incorrect property enumeration order
	 * note: this does not detect the bug unless there's 20 characters
	 */ var str = 'abcdefghijklmnopqrst';
    var letters = str.split('');
    var map = {};
    for(var i = 0; i < letters.length; ++i)map[letters[i]] = letters[i];
    var obj = Object.assign({}, map);
    var actual = '';
    for(var k in obj)actual += k;
    return str !== actual;
};
var $0fdfbae24274f3f8$var$assignHasPendingExceptions = function() {
    if (!Object.assign || !Object.preventExtensions) return false;
    /*
	 * Firefox 37 still has "pending exception" logic in its Object.assign implementation,
	 * which is 72% slower than our shim, and Firefox 40's native implementation.
	 */ var thrower = Object.preventExtensions({
        1: 2
    });
    try {
        Object.assign(thrower, 'xy');
    } catch (e) {
        return thrower[1] === 'y';
    }
    return false;
};
module.exports = function getPolyfill() {
    if (!Object.assign) return $aLPDY;
    if ($0fdfbae24274f3f8$var$lacksProperEnumerationOrder()) return $aLPDY;
    if ($0fdfbae24274f3f8$var$assignHasPendingExceptions()) return $aLPDY;
    return Object.assign;
};

});
parcelRegister("aLPDY", function(module, exports) {
'use strict';

var $5LkcG = parcelRequire("5LkcG");

var $7d765a8787c875f2$var$hasSymbols = (parcelRequire("2l4Mc"))();

var $h0KKk = parcelRequire("h0KKk");

var $lUbLd = parcelRequire("lUbLd");
var $7d765a8787c875f2$var$$push = $h0KKk('Array.prototype.push');
var $7d765a8787c875f2$var$$propIsEnumerable = $h0KKk('Object.prototype.propertyIsEnumerable');
var $7d765a8787c875f2$var$originalGetSymbols = $7d765a8787c875f2$var$hasSymbols ? $lUbLd.getOwnPropertySymbols : null;
// eslint-disable-next-line no-unused-vars
module.exports = function assign(target, source1) {
    if (target == null) throw new TypeError('target must be an object');
    var to = $lUbLd(target); // step 1
    if (arguments.length === 1) return to; // step 2
    for(var s = 1; s < arguments.length; ++s){
        var from = $lUbLd(arguments[s]); // step 3.a.i
        // step 3.a.ii:
        var keys = $5LkcG(from);
        var getSymbols = $7d765a8787c875f2$var$hasSymbols && ($lUbLd.getOwnPropertySymbols || $7d765a8787c875f2$var$originalGetSymbols);
        if (getSymbols) {
            var syms = getSymbols(from);
            for(var j = 0; j < syms.length; ++j){
                var key = syms[j];
                if ($7d765a8787c875f2$var$$propIsEnumerable(from, key)) $7d765a8787c875f2$var$$push(keys, key);
            }
        }
        // step 3.a.iii:
        for(var i = 0; i < keys.length; ++i){
            var nextKey = keys[i];
            if ($7d765a8787c875f2$var$$propIsEnumerable(from, nextKey)) {
                var propValue = from[nextKey]; // step 3.a.iii.2.a
                to[nextKey] = propValue; // step 3.a.iii.2.b
            }
        }
    }
    return to; // step 4
};

});
parcelRegister("5LkcG", function(module, exports) {
'use strict';
var $43210391068efb5f$var$slice = Array.prototype.slice;

var $bFo38 = parcelRequire("bFo38");
var $43210391068efb5f$var$origKeys = Object.keys;

var $43210391068efb5f$var$keysShim = $43210391068efb5f$var$origKeys ? function keys(o) {
    return $43210391068efb5f$var$origKeys(o);
} : (parcelRequire("bQZYc"));
var $43210391068efb5f$var$originalKeys = Object.keys;
$43210391068efb5f$var$keysShim.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            if ($bFo38(object)) return $43210391068efb5f$var$originalKeys($43210391068efb5f$var$slice.call(object));
            return $43210391068efb5f$var$originalKeys(object);
        };
    } else Object.keys = $43210391068efb5f$var$keysShim;
    return Object.keys || $43210391068efb5f$var$keysShim;
};
module.exports = $43210391068efb5f$var$keysShim;

});
parcelRegister("bFo38", function(module, exports) {
'use strict';
var $87e62dc8f29f5035$var$toStr = Object.prototype.toString;
module.exports = function isArguments(value) {
    var str = $87e62dc8f29f5035$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $87e62dc8f29f5035$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};

});

parcelRegister("bQZYc", function(module, exports) {
'use strict';
var $8a149ef89b8e18a7$var$keysShim;

if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $8a149ef89b8e18a7$var$has = Object.prototype.hasOwnProperty;
    var $8a149ef89b8e18a7$var$toStr = Object.prototype.toString;
    var $8a149ef89b8e18a7$var$isArgs = (parcelRequire("bFo38")); // eslint-disable-line global-require
    var $8a149ef89b8e18a7$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $8a149ef89b8e18a7$var$hasDontEnumBug = !$8a149ef89b8e18a7$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $8a149ef89b8e18a7$var$hasProtoEnumBug = $8a149ef89b8e18a7$var$isEnumerable.call(function() {}, 'prototype');
    var $8a149ef89b8e18a7$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $8a149ef89b8e18a7$var$equalsConstructorPrototype = function(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $8a149ef89b8e18a7$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $8a149ef89b8e18a7$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$8a149ef89b8e18a7$var$excludedKeys['$' + k] && $8a149ef89b8e18a7$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $8a149ef89b8e18a7$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $8a149ef89b8e18a7$var$equalsConstructorPrototypeIfNotBuggy = function(o) {
        /* global window */ if (typeof window === 'undefined' || !$8a149ef89b8e18a7$var$hasAutomationEqualityBug) return $8a149ef89b8e18a7$var$equalsConstructorPrototype(o);
        try {
            return $8a149ef89b8e18a7$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $8a149ef89b8e18a7$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $8a149ef89b8e18a7$var$toStr.call(object) === '[object Function]';
        var isArguments = $8a149ef89b8e18a7$var$isArgs(object);
        var isString = isObject && $8a149ef89b8e18a7$var$toStr.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $8a149ef89b8e18a7$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$8a149ef89b8e18a7$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $8a149ef89b8e18a7$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($8a149ef89b8e18a7$var$hasDontEnumBug) {
            var skipConstructor = $8a149ef89b8e18a7$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $8a149ef89b8e18a7$var$dontEnums.length; ++k)if (!(skipConstructor && $8a149ef89b8e18a7$var$dontEnums[k] === 'constructor') && $8a149ef89b8e18a7$var$has.call(object, $8a149ef89b8e18a7$var$dontEnums[k])) theKeys.push($8a149ef89b8e18a7$var$dontEnums[k]);
        }
        return theKeys;
    };
}
module.exports = $8a149ef89b8e18a7$var$keysShim;

});




parcelRegister("h4naa", function(module, exports) {
'use strict';

var $dfOfV = parcelRequire("dfOfV");
module.exports = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $dfOfV;
};

});
parcelRegister("dfOfV", function(module, exports) {
'use strict';
var $9a63a8d2cb2e4f3e$var$numberIsNaN = function(value) {
    return value !== value;
};
module.exports = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($9a63a8d2cb2e4f3e$var$numberIsNaN(a) && $9a63a8d2cb2e4f3e$var$numberIsNaN(b)) return true;
    return false;
};

});


parcelRegister("aKCww", function(module, exports) {
'use strict';

var $g7Yvk = parcelRequire("g7Yvk");

var $gPANn = parcelRequire("gPANn");
var $7d3c1535b7ca1cf4$var$$indexOf = $gPANn($g7Yvk('String.prototype.indexOf'));
module.exports = function callBoundIntrinsic(name, allowMissing) {
    var intrinsic = $g7Yvk(name, !!allowMissing);
    if (typeof intrinsic === 'function' && $7d3c1535b7ca1cf4$var$$indexOf(name, '.prototype.') > -1) return $gPANn(intrinsic);
    return intrinsic;
};

});

parcelRegister("iQMtp", function(module, exports) {
// Currently in sync with Node.js lib/internal/util/comparisons.js
// https://github.com/nodejs/node/commit/112cc7c27551254aa2b17098fb774867f05ed0d9
'use strict';
function $db92af1a42d5fffc$var$_slicedToArray(arr, i) {
    return $db92af1a42d5fffc$var$_arrayWithHoles(arr) || $db92af1a42d5fffc$var$_iterableToArrayLimit(arr, i) || $db92af1a42d5fffc$var$_unsupportedIterableToArray(arr, i) || $db92af1a42d5fffc$var$_nonIterableRest();
}
function $db92af1a42d5fffc$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $db92af1a42d5fffc$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $db92af1a42d5fffc$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $db92af1a42d5fffc$var$_arrayLikeToArray(o, minLen);
}
function $db92af1a42d5fffc$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $db92af1a42d5fffc$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $db92af1a42d5fffc$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $db92af1a42d5fffc$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $db92af1a42d5fffc$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $db92af1a42d5fffc$var$_typeof(o);
}
var $db92af1a42d5fffc$var$regexFlagsSupported = /a/g.flags !== undefined;
var $db92af1a42d5fffc$var$arrayFromSet = function arrayFromSet(set) {
    var array = [];
    set.forEach(function(value) {
        return array.push(value);
    });
    return array;
};
var $db92af1a42d5fffc$var$arrayFromMap = function arrayFromMap(map) {
    var array = [];
    map.forEach(function(value, key) {
        return array.push([
            key,
            value
        ]);
    });
    return array;
};

var $db92af1a42d5fffc$var$objectIs = Object.is ? Object.is : (parcelRequire("4BObi"));
var $db92af1a42d5fffc$var$objectGetOwnPropertySymbols = Object.getOwnPropertySymbols ? Object.getOwnPropertySymbols : function() {
    return [];
};

var $db92af1a42d5fffc$var$numberIsNaN = Number.isNaN ? Number.isNaN : (parcelRequire("ixKnI"));
function $db92af1a42d5fffc$var$uncurryThis(f) {
    return f.call.bind(f);
}
var $db92af1a42d5fffc$var$hasOwnProperty = $db92af1a42d5fffc$var$uncurryThis(Object.prototype.hasOwnProperty);
var $db92af1a42d5fffc$var$propertyIsEnumerable = $db92af1a42d5fffc$var$uncurryThis(Object.prototype.propertyIsEnumerable);
var $db92af1a42d5fffc$var$objectToString = $db92af1a42d5fffc$var$uncurryThis(Object.prototype.toString);

var $hHIjR = parcelRequire("hHIjR");
var $db92af1a42d5fffc$require$_require$types = $hHIjR.types;
var $db92af1a42d5fffc$var$isAnyArrayBuffer = $db92af1a42d5fffc$require$_require$types.isAnyArrayBuffer, $db92af1a42d5fffc$var$isArrayBufferView = $db92af1a42d5fffc$require$_require$types.isArrayBufferView, $db92af1a42d5fffc$var$isDate = $db92af1a42d5fffc$require$_require$types.isDate, $db92af1a42d5fffc$var$isMap = $db92af1a42d5fffc$require$_require$types.isMap, $db92af1a42d5fffc$var$isRegExp = $db92af1a42d5fffc$require$_require$types.isRegExp, $db92af1a42d5fffc$var$isSet = $db92af1a42d5fffc$require$_require$types.isSet, $db92af1a42d5fffc$var$isNativeError = $db92af1a42d5fffc$require$_require$types.isNativeError, $db92af1a42d5fffc$var$isBoxedPrimitive = $db92af1a42d5fffc$require$_require$types.isBoxedPrimitive, $db92af1a42d5fffc$var$isNumberObject = $db92af1a42d5fffc$require$_require$types.isNumberObject, $db92af1a42d5fffc$var$isStringObject = $db92af1a42d5fffc$require$_require$types.isStringObject, $db92af1a42d5fffc$var$isBooleanObject = $db92af1a42d5fffc$require$_require$types.isBooleanObject, $db92af1a42d5fffc$var$isBigIntObject = $db92af1a42d5fffc$require$_require$types.isBigIntObject, $db92af1a42d5fffc$var$isSymbolObject = $db92af1a42d5fffc$require$_require$types.isSymbolObject, $db92af1a42d5fffc$var$isFloat32Array = $db92af1a42d5fffc$require$_require$types.isFloat32Array, $db92af1a42d5fffc$var$isFloat64Array = $db92af1a42d5fffc$require$_require$types.isFloat64Array;
function $db92af1a42d5fffc$var$isNonIndex(key) {
    if (key.length === 0 || key.length > 10) return true;
    for(var i = 0; i < key.length; i++){
        var code = key.charCodeAt(i);
        if (code < 48 || code > 57) return true;
    }
    // The maximum size for an array is 2 ** 32 -1.
    return key.length === 10 && key >= Math.pow(2, 32);
}
function $db92af1a42d5fffc$var$getOwnNonIndexProperties(value) {
    return Object.keys(value).filter($db92af1a42d5fffc$var$isNonIndex).concat($db92af1a42d5fffc$var$objectGetOwnPropertySymbols(value).filter(Object.prototype.propertyIsEnumerable.bind(value)));
}
// Taken from https://github.com/feross/buffer/blob/680e9e5e488f22aac27599a57dc844a6315928dd/index.js
// original notice:
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
 * @license  MIT
 */ function $db92af1a42d5fffc$var$compare(a, b) {
    if (a === b) return 0;
    var x = a.length;
    var y = b.length;
    for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
}
var $db92af1a42d5fffc$var$ONLY_ENUMERABLE = undefined;
var $db92af1a42d5fffc$var$kStrict = true;
var $db92af1a42d5fffc$var$kLoose = false;
var $db92af1a42d5fffc$var$kNoIterator = 0;
var $db92af1a42d5fffc$var$kIsArray = 1;
var $db92af1a42d5fffc$var$kIsSet = 2;
var $db92af1a42d5fffc$var$kIsMap = 3;
// Check if they have the same source and flags
function $db92af1a42d5fffc$var$areSimilarRegExps(a, b) {
    return $db92af1a42d5fffc$var$regexFlagsSupported ? a.source === b.source && a.flags === b.flags : RegExp.prototype.toString.call(a) === RegExp.prototype.toString.call(b);
}
function $db92af1a42d5fffc$var$areSimilarFloatArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    for(var offset = 0; offset < a.byteLength; offset++){
        if (a[offset] !== b[offset]) return false;
    }
    return true;
}
function $db92af1a42d5fffc$var$areSimilarTypedArrays(a, b) {
    if (a.byteLength !== b.byteLength) return false;
    return $db92af1a42d5fffc$var$compare(new Uint8Array(a.buffer, a.byteOffset, a.byteLength), new Uint8Array(b.buffer, b.byteOffset, b.byteLength)) === 0;
}
function $db92af1a42d5fffc$var$areEqualArrayBuffers(buf1, buf2) {
    return buf1.byteLength === buf2.byteLength && $db92af1a42d5fffc$var$compare(new Uint8Array(buf1), new Uint8Array(buf2)) === 0;
}
function $db92af1a42d5fffc$var$isEqualBoxedPrimitive(val1, val2) {
    if ($db92af1a42d5fffc$var$isNumberObject(val1)) return $db92af1a42d5fffc$var$isNumberObject(val2) && $db92af1a42d5fffc$var$objectIs(Number.prototype.valueOf.call(val1), Number.prototype.valueOf.call(val2));
    if ($db92af1a42d5fffc$var$isStringObject(val1)) return $db92af1a42d5fffc$var$isStringObject(val2) && String.prototype.valueOf.call(val1) === String.prototype.valueOf.call(val2);
    if ($db92af1a42d5fffc$var$isBooleanObject(val1)) return $db92af1a42d5fffc$var$isBooleanObject(val2) && Boolean.prototype.valueOf.call(val1) === Boolean.prototype.valueOf.call(val2);
    if ($db92af1a42d5fffc$var$isBigIntObject(val1)) return $db92af1a42d5fffc$var$isBigIntObject(val2) && BigInt.prototype.valueOf.call(val1) === BigInt.prototype.valueOf.call(val2);
    return $db92af1a42d5fffc$var$isSymbolObject(val2) && Symbol.prototype.valueOf.call(val1) === Symbol.prototype.valueOf.call(val2);
}
// Notes: Type tags are historical [[Class]] properties that can be set by
// FunctionTemplate::SetClassName() in C++ or Symbol.toStringTag in JS
// and retrieved using Object.prototype.toString.call(obj) in JS
// See https://tc39.github.io/ecma262/#sec-object.prototype.tostring
// for a list of tags pre-defined in the spec.
// There are some unspecified tags in the wild too (e.g. typed array tags).
// Since tags can be altered, they only serve fast failures
//
// Typed arrays and buffers are checked by comparing the content in their
// underlying ArrayBuffer. This optimization requires that it's
// reasonable to interpret their underlying memory in the same way,
// which is checked by comparing their type tags.
// (e.g. a Uint8Array and a Uint16Array with the same memory content
// could still be different because they will be interpreted differently).
//
// For strict comparison, objects should have
// a) The same built-in type tags
// b) The same prototypes.
function $db92af1a42d5fffc$var$innerDeepEqual(val1, val2, strict, memos) {
    // All identical values are equivalent, as determined by ===.
    if (val1 === val2) {
        if (val1 !== 0) return true;
        return strict ? $db92af1a42d5fffc$var$objectIs(val1, val2) : true;
    }
    // Check more closely if val1 and val2 are equal.
    if (strict) {
        if ($db92af1a42d5fffc$var$_typeof(val1) !== 'object') return typeof val1 === 'number' && $db92af1a42d5fffc$var$numberIsNaN(val1) && $db92af1a42d5fffc$var$numberIsNaN(val2);
        if ($db92af1a42d5fffc$var$_typeof(val2) !== 'object' || val1 === null || val2 === null) return false;
        if (Object.getPrototypeOf(val1) !== Object.getPrototypeOf(val2)) return false;
    } else {
        if (val1 === null || $db92af1a42d5fffc$var$_typeof(val1) !== 'object') {
            if (val2 === null || $db92af1a42d5fffc$var$_typeof(val2) !== 'object') // eslint-disable-next-line eqeqeq
            return val1 == val2;
            return false;
        }
        if (val2 === null || $db92af1a42d5fffc$var$_typeof(val2) !== 'object') return false;
    }
    var val1Tag = $db92af1a42d5fffc$var$objectToString(val1);
    var val2Tag = $db92af1a42d5fffc$var$objectToString(val2);
    if (val1Tag !== val2Tag) return false;
    if (Array.isArray(val1)) {
        // Check for sparse arrays and general fast path
        if (val1.length !== val2.length) return false;
        var keys1 = $db92af1a42d5fffc$var$getOwnNonIndexProperties(val1, $db92af1a42d5fffc$var$ONLY_ENUMERABLE);
        var keys2 = $db92af1a42d5fffc$var$getOwnNonIndexProperties(val2, $db92af1a42d5fffc$var$ONLY_ENUMERABLE);
        if (keys1.length !== keys2.length) return false;
        return $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, $db92af1a42d5fffc$var$kIsArray, keys1);
    }
    // [browserify] This triggers on certain types in IE (Map/Set) so we don't
    // wan't to early return out of the rest of the checks. However we can check
    // if the second value is one of these values and the first isn't.
    if (val1Tag === '[object Object]') {
        // return keyCheck(val1, val2, strict, memos, kNoIterator);
        if (!$db92af1a42d5fffc$var$isMap(val1) && $db92af1a42d5fffc$var$isMap(val2) || !$db92af1a42d5fffc$var$isSet(val1) && $db92af1a42d5fffc$var$isSet(val2)) return false;
    }
    if ($db92af1a42d5fffc$var$isDate(val1)) {
        if (!$db92af1a42d5fffc$var$isDate(val2) || Date.prototype.getTime.call(val1) !== Date.prototype.getTime.call(val2)) return false;
    } else if ($db92af1a42d5fffc$var$isRegExp(val1)) {
        if (!$db92af1a42d5fffc$var$isRegExp(val2) || !$db92af1a42d5fffc$var$areSimilarRegExps(val1, val2)) return false;
    } else if ($db92af1a42d5fffc$var$isNativeError(val1) || val1 instanceof Error) {
        // Do not compare the stack as it might differ even though the error itself
        // is otherwise identical.
        if (val1.message !== val2.message || val1.name !== val2.name) return false;
    } else if ($db92af1a42d5fffc$var$isArrayBufferView(val1)) {
        if (!strict && ($db92af1a42d5fffc$var$isFloat32Array(val1) || $db92af1a42d5fffc$var$isFloat64Array(val1))) {
            if (!$db92af1a42d5fffc$var$areSimilarFloatArrays(val1, val2)) return false;
        } else if (!$db92af1a42d5fffc$var$areSimilarTypedArrays(val1, val2)) return false;
        // Buffer.compare returns true, so val1.length === val2.length. If they both
        // only contain numeric keys, we don't need to exam further than checking
        // the symbols.
        var _keys = $db92af1a42d5fffc$var$getOwnNonIndexProperties(val1, $db92af1a42d5fffc$var$ONLY_ENUMERABLE);
        var _keys2 = $db92af1a42d5fffc$var$getOwnNonIndexProperties(val2, $db92af1a42d5fffc$var$ONLY_ENUMERABLE);
        if (_keys.length !== _keys2.length) return false;
        return $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, $db92af1a42d5fffc$var$kNoIterator, _keys);
    } else if ($db92af1a42d5fffc$var$isSet(val1)) {
        if (!$db92af1a42d5fffc$var$isSet(val2) || val1.size !== val2.size) return false;
        return $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, $db92af1a42d5fffc$var$kIsSet);
    } else if ($db92af1a42d5fffc$var$isMap(val1)) {
        if (!$db92af1a42d5fffc$var$isMap(val2) || val1.size !== val2.size) return false;
        return $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, $db92af1a42d5fffc$var$kIsMap);
    } else if ($db92af1a42d5fffc$var$isAnyArrayBuffer(val1)) {
        if (!$db92af1a42d5fffc$var$areEqualArrayBuffers(val1, val2)) return false;
    } else if ($db92af1a42d5fffc$var$isBoxedPrimitive(val1) && !$db92af1a42d5fffc$var$isEqualBoxedPrimitive(val1, val2)) return false;
    return $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, $db92af1a42d5fffc$var$kNoIterator);
}
function $db92af1a42d5fffc$var$getEnumerables(val, keys) {
    return keys.filter(function(k) {
        return $db92af1a42d5fffc$var$propertyIsEnumerable(val, k);
    });
}
function $db92af1a42d5fffc$var$keyCheck(val1, val2, strict, memos, iterationType, aKeys) {
    // For all remaining Object pairs, including Array, objects and Maps,
    // equivalence is determined by having:
    // a) The same number of owned enumerable properties
    // b) The same set of keys/indexes (although not necessarily the same order)
    // c) Equivalent values for every corresponding key/index
    // d) For Sets and Maps, equal contents
    // Note: this accounts for both named and indexed properties on Arrays.
    if (arguments.length === 5) {
        aKeys = Object.keys(val1);
        var bKeys = Object.keys(val2);
        // The pair must have the same number of owned properties.
        if (aKeys.length !== bKeys.length) return false;
    }
    // Cheap key test
    var i = 0;
    for(; i < aKeys.length; i++){
        if (!$db92af1a42d5fffc$var$hasOwnProperty(val2, aKeys[i])) return false;
    }
    if (strict && arguments.length === 5) {
        var symbolKeysA = $db92af1a42d5fffc$var$objectGetOwnPropertySymbols(val1);
        if (symbolKeysA.length !== 0) {
            var count = 0;
            for(i = 0; i < symbolKeysA.length; i++){
                var key = symbolKeysA[i];
                if ($db92af1a42d5fffc$var$propertyIsEnumerable(val1, key)) {
                    if (!$db92af1a42d5fffc$var$propertyIsEnumerable(val2, key)) return false;
                    aKeys.push(key);
                    count++;
                } else if ($db92af1a42d5fffc$var$propertyIsEnumerable(val2, key)) return false;
            }
            var symbolKeysB = $db92af1a42d5fffc$var$objectGetOwnPropertySymbols(val2);
            if (symbolKeysA.length !== symbolKeysB.length && $db92af1a42d5fffc$var$getEnumerables(val2, symbolKeysB).length !== count) return false;
        } else {
            var _symbolKeysB = $db92af1a42d5fffc$var$objectGetOwnPropertySymbols(val2);
            if (_symbolKeysB.length !== 0 && $db92af1a42d5fffc$var$getEnumerables(val2, _symbolKeysB).length !== 0) return false;
        }
    }
    if (aKeys.length === 0 && (iterationType === $db92af1a42d5fffc$var$kNoIterator || iterationType === $db92af1a42d5fffc$var$kIsArray && val1.length === 0 || val1.size === 0)) return true;
    // Use memos to handle cycles.
    if (memos === undefined) memos = {
        val1: new Map(),
        val2: new Map(),
        position: 0
    };
    else {
        // We prevent up to two map.has(x) calls by directly retrieving the value
        // and checking for undefined. The map can only contain numbers, so it is
        // safe to check for undefined only.
        var val2MemoA = memos.val1.get(val1);
        if (val2MemoA !== undefined) {
            var val2MemoB = memos.val2.get(val2);
            if (val2MemoB !== undefined) return val2MemoA === val2MemoB;
        }
        memos.position++;
    }
    memos.val1.set(val1, memos.position);
    memos.val2.set(val2, memos.position);
    var areEq = $db92af1a42d5fffc$var$objEquiv(val1, val2, strict, aKeys, memos, iterationType);
    memos.val1.delete(val1);
    memos.val2.delete(val2);
    return areEq;
}
function $db92af1a42d5fffc$var$setHasEqualElement(set, val1, strict, memo) {
    // Go looking.
    var setValues = $db92af1a42d5fffc$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var val2 = setValues[i];
        if ($db92af1a42d5fffc$var$innerDeepEqual(val1, val2, strict, memo)) {
            // Remove the matching element to make sure we do not check that again.
            set.delete(val2);
            return true;
        }
    }
    return false;
}
// See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Equality_comparisons_and_sameness#Loose_equality_using
// Sadly it is not possible to detect corresponding values properly in case the
// type is a string, number, bigint or boolean. The reason is that those values
// can match lots of different string values (e.g., 1n == '+00001').
function $db92af1a42d5fffc$var$findLooseMatchingPrimitives(prim) {
    switch($db92af1a42d5fffc$var$_typeof(prim)){
        case 'undefined':
            return null;
        case 'object':
            // Only pass in null as object!
            return undefined;
        case 'symbol':
            return false;
        case 'string':
            prim = +prim;
        // Loose equal entries exist only if the string is possible to convert to
        // a regular number and not NaN.
        // Fall through
        case 'number':
            if ($db92af1a42d5fffc$var$numberIsNaN(prim)) return false;
    }
    return true;
}
function $db92af1a42d5fffc$var$setMightHaveLoosePrim(a, b, prim) {
    var altValue = $db92af1a42d5fffc$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    return b.has(altValue) && !a.has(altValue);
}
function $db92af1a42d5fffc$var$mapMightHaveLoosePrim(a, b, prim, item, memo) {
    var altValue = $db92af1a42d5fffc$var$findLooseMatchingPrimitives(prim);
    if (altValue != null) return altValue;
    var curB = b.get(altValue);
    if (curB === undefined && !b.has(altValue) || !$db92af1a42d5fffc$var$innerDeepEqual(item, curB, false, memo)) return false;
    return !a.has(altValue) && $db92af1a42d5fffc$var$innerDeepEqual(item, curB, false, memo);
}
function $db92af1a42d5fffc$var$setEquiv(a, b, strict, memo) {
    // This is a lazily initiated Set of entries which have to be compared
    // pairwise.
    var set = null;
    var aValues = $db92af1a42d5fffc$var$arrayFromSet(a);
    for(var i = 0; i < aValues.length; i++){
        var val = aValues[i];
        // Note: Checking for the objects first improves the performance for object
        // heavy sets but it is a minor slow down for primitives. As they are fast
        // to check this improves the worst case scenario instead.
        if ($db92af1a42d5fffc$var$_typeof(val) === 'object' && val !== null) {
            if (set === null) set = new Set();
            // If the specified value doesn't exist in the second set its an not null
            // object (or non strict only: a not matching primitive) we'll need to go
            // hunting for something thats deep-(strict-)equal to it. To make this
            // O(n log n) complexity we have to copy these values in a new set first.
            set.add(val);
        } else if (!b.has(val)) {
            if (strict) return false;
            // Fast path to detect missing string, symbol, undefined and null values.
            if (!$db92af1a42d5fffc$var$setMightHaveLoosePrim(a, b, val)) return false;
            if (set === null) set = new Set();
            set.add(val);
        }
    }
    if (set !== null) {
        var bValues = $db92af1a42d5fffc$var$arrayFromSet(b);
        for(var _i = 0; _i < bValues.length; _i++){
            var _val = bValues[_i];
            // We have to check if a primitive value is already
            // matching and only if it's not, go hunting for it.
            if ($db92af1a42d5fffc$var$_typeof(_val) === 'object' && _val !== null) {
                if (!$db92af1a42d5fffc$var$setHasEqualElement(set, _val, strict, memo)) return false;
            } else if (!strict && !a.has(_val) && !$db92af1a42d5fffc$var$setHasEqualElement(set, _val, strict, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $db92af1a42d5fffc$var$mapHasEqualEntry(set, map, key1, item1, strict, memo) {
    // To be able to handle cases like:
    //   Map([[{}, 'a'], [{}, 'b']]) vs Map([[{}, 'b'], [{}, 'a']])
    // ... we need to consider *all* matching keys, not just the first we find.
    var setValues = $db92af1a42d5fffc$var$arrayFromSet(set);
    for(var i = 0; i < setValues.length; i++){
        var key2 = setValues[i];
        if ($db92af1a42d5fffc$var$innerDeepEqual(key1, key2, strict, memo) && $db92af1a42d5fffc$var$innerDeepEqual(item1, map.get(key2), strict, memo)) {
            set.delete(key2);
            return true;
        }
    }
    return false;
}
function $db92af1a42d5fffc$var$mapEquiv(a, b, strict, memo) {
    var set = null;
    var aEntries = $db92af1a42d5fffc$var$arrayFromMap(a);
    for(var i = 0; i < aEntries.length; i++){
        var _aEntries$i = $db92af1a42d5fffc$var$_slicedToArray(aEntries[i], 2), key = _aEntries$i[0], item1 = _aEntries$i[1];
        if ($db92af1a42d5fffc$var$_typeof(key) === 'object' && key !== null) {
            if (set === null) set = new Set();
            set.add(key);
        } else {
            // By directly retrieving the value we prevent another b.has(key) check in
            // almost all possible cases.
            var item2 = b.get(key);
            if (item2 === undefined && !b.has(key) || !$db92af1a42d5fffc$var$innerDeepEqual(item1, item2, strict, memo)) {
                if (strict) return false;
                // Fast path to detect missing string, symbol, undefined and null
                // keys.
                if (!$db92af1a42d5fffc$var$mapMightHaveLoosePrim(a, b, key, item1, memo)) return false;
                if (set === null) set = new Set();
                set.add(key);
            }
        }
    }
    if (set !== null) {
        var bEntries = $db92af1a42d5fffc$var$arrayFromMap(b);
        for(var _i2 = 0; _i2 < bEntries.length; _i2++){
            var _bEntries$_i = $db92af1a42d5fffc$var$_slicedToArray(bEntries[_i2], 2), _key = _bEntries$_i[0], item = _bEntries$_i[1];
            if ($db92af1a42d5fffc$var$_typeof(_key) === 'object' && _key !== null) {
                if (!$db92af1a42d5fffc$var$mapHasEqualEntry(set, a, _key, item, strict, memo)) return false;
            } else if (!strict && (!a.has(_key) || !$db92af1a42d5fffc$var$innerDeepEqual(a.get(_key), item, false, memo)) && !$db92af1a42d5fffc$var$mapHasEqualEntry(set, a, _key, item, false, memo)) return false;
        }
        return set.size === 0;
    }
    return true;
}
function $db92af1a42d5fffc$var$objEquiv(a, b, strict, keys, memos, iterationType) {
    // Sets and maps don't have their entries accessible via normal object
    // properties.
    var i = 0;
    if (iterationType === $db92af1a42d5fffc$var$kIsSet) {
        if (!$db92af1a42d5fffc$var$setEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $db92af1a42d5fffc$var$kIsMap) {
        if (!$db92af1a42d5fffc$var$mapEquiv(a, b, strict, memos)) return false;
    } else if (iterationType === $db92af1a42d5fffc$var$kIsArray) for(; i < a.length; i++){
        if ($db92af1a42d5fffc$var$hasOwnProperty(a, i)) {
            if (!$db92af1a42d5fffc$var$hasOwnProperty(b, i) || !$db92af1a42d5fffc$var$innerDeepEqual(a[i], b[i], strict, memos)) return false;
        } else if ($db92af1a42d5fffc$var$hasOwnProperty(b, i)) return false;
        else {
            // Array is sparse.
            var keysA = Object.keys(a);
            for(; i < keysA.length; i++){
                var key = keysA[i];
                if (!$db92af1a42d5fffc$var$hasOwnProperty(b, key) || !$db92af1a42d5fffc$var$innerDeepEqual(a[key], b[key], strict, memos)) return false;
            }
            if (keysA.length !== Object.keys(b).length) return false;
            return true;
        }
    }
    // The pair must have equivalent values for every corresponding key.
    // Possibly expensive deep test:
    for(i = 0; i < keys.length; i++){
        var _key2 = keys[i];
        if (!$db92af1a42d5fffc$var$innerDeepEqual(a[_key2], b[_key2], strict, memos)) return false;
    }
    return true;
}
function $db92af1a42d5fffc$var$isDeepEqual(val1, val2) {
    return $db92af1a42d5fffc$var$innerDeepEqual(val1, val2, $db92af1a42d5fffc$var$kLoose);
}
function $db92af1a42d5fffc$var$isDeepStrictEqual(val1, val2) {
    return $db92af1a42d5fffc$var$innerDeepEqual(val1, val2, $db92af1a42d5fffc$var$kStrict);
}
module.exports = {
    isDeepEqual: $db92af1a42d5fffc$var$isDeepEqual,
    isDeepStrictEqual: $db92af1a42d5fffc$var$isDeepStrictEqual
};

});
parcelRegister("4BObi", function(module, exports) {
'use strict';

var $5WZV8 = parcelRequire("5WZV8");

var $gPANn = parcelRequire("gPANn");

var $dfOfV = parcelRequire("dfOfV");

var $h4naa = parcelRequire("h4naa");

var $cjmNA = parcelRequire("cjmNA");
var $35b18b0dfebb08ae$var$polyfill = $gPANn($h4naa(), Object);
$5WZV8($35b18b0dfebb08ae$var$polyfill, {
    getPolyfill: $h4naa,
    implementation: $dfOfV,
    shim: $cjmNA
});
module.exports = $35b18b0dfebb08ae$var$polyfill;

});
parcelRegister("5WZV8", function(module, exports) {
'use strict';

var $5LkcG = parcelRequire("5LkcG");
var $455266ae06ac7ae5$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $455266ae06ac7ae5$var$toStr = Object.prototype.toString;
var $455266ae06ac7ae5$var$concat = Array.prototype.concat;

var $hUFuu = parcelRequire("hUFuu");
var $455266ae06ac7ae5$var$isFunction = function(fn) {
    return typeof fn === 'function' && $455266ae06ac7ae5$var$toStr.call(fn) === '[object Function]';
};

var $455266ae06ac7ae5$var$supportsDescriptors = (parcelRequire("4JPOS"))();
var $455266ae06ac7ae5$var$defineProperty = function(object, name, value, predicate) {
    if (name in object) {
        if (predicate === true) {
            if (object[name] === value) return;
        } else if (!$455266ae06ac7ae5$var$isFunction(predicate) || !predicate()) return;
    }
    if ($455266ae06ac7ae5$var$supportsDescriptors) $hUFuu(object, name, value, true);
    else $hUFuu(object, name, value);
};
var $455266ae06ac7ae5$var$defineProperties = function(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $5LkcG(map);
    if ($455266ae06ac7ae5$var$hasSymbols) props = $455266ae06ac7ae5$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$455266ae06ac7ae5$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$455266ae06ac7ae5$var$defineProperties.supportsDescriptors = !!$455266ae06ac7ae5$var$supportsDescriptors;
module.exports = $455266ae06ac7ae5$var$defineProperties;

});

parcelRegister("cjmNA", function(module, exports) {
'use strict';

var $h4naa = parcelRequire("h4naa");

var $5WZV8 = parcelRequire("5WZV8");
module.exports = function shimObjectIs() {
    var polyfill = $h4naa();
    $5WZV8(Object, {
        is: polyfill
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill;
        }
    });
    return polyfill;
};

});


parcelRegister("ixKnI", function(module, exports) {
'use strict';

var $gPANn = parcelRequire("gPANn");

var $5WZV8 = parcelRequire("5WZV8");

var $hz8bk = parcelRequire("hz8bk");

var $bFCpv = parcelRequire("bFCpv");

var $jQCZo = parcelRequire("jQCZo");
var $d7ff4972c4e901bb$var$polyfill = $gPANn($bFCpv(), Number);
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ $5WZV8($d7ff4972c4e901bb$var$polyfill, {
    getPolyfill: $bFCpv,
    implementation: $hz8bk,
    shim: $jQCZo
});
module.exports = $d7ff4972c4e901bb$var$polyfill;

});
parcelRegister("hz8bk", function(module, exports) {
'use strict';
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function isNaN(value) {
    return value !== value;
};

});

parcelRegister("bFCpv", function(module, exports) {
'use strict';

var $hz8bk = parcelRequire("hz8bk");
module.exports = function getPolyfill() {
    if (Number.isNaN && Number.isNaN(NaN) && !Number.isNaN('a')) return Number.isNaN;
    return $hz8bk;
};

});

parcelRegister("jQCZo", function(module, exports) {
'use strict';

var $5WZV8 = parcelRequire("5WZV8");

var $bFCpv = parcelRequire("bFCpv");
/* http://www.ecma-international.org/ecma-262/6.0/#sec-number.isnan */ module.exports = function shimNumberIsNaN() {
    var polyfill = $bFCpv();
    $5WZV8(Number, {
        isNaN: polyfill
    }, {
        isNaN: function testIsNaN() {
            return Number.isNaN !== polyfill;
        }
    });
    return polyfill;
};

});




parcelRegister("iFEO0", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");

var $kJBqN = parcelRequire("kJBqN");
var $d97bb57996964529$require$Buffer = $kJBqN.Buffer;
'use strict';

var $7UcXO = parcelRequire("7UcXO");
var $d97bb57996964529$require$assert = $7UcXO.ok;

var $dy7q9 = parcelRequire("dy7q9");

var $hHIjR = parcelRequire("hHIjR");

var $kJBqN = parcelRequire("kJBqN");
var $d97bb57996964529$require$kMaxLength = $kJBqN.kMaxLength;
function Inflate(opts) {
    if (!(this instanceof Inflate)) return new Inflate(opts);
    if (opts && opts.chunkSize < $dy7q9.Z_MIN_CHUNK) opts.chunkSize = $dy7q9.Z_MIN_CHUNK;
    $dy7q9.Inflate.call(this, opts);
    // Node 8 --> 9 compatibility check
    this._offset = this._offset === undefined ? this._outOffset : this._offset;
    this._buffer = this._buffer || this._outBuffer;
    if (opts && opts.maxLength != null) this._maxLength = opts.maxLength;
}
function createInflate(opts) {
    return new Inflate(opts);
}
function _close(engine, callback) {
    if (callback) $5XqL3.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
Inflate.prototype._processChunk = function(chunk, flushFlag, asyncCb) {
    if (typeof asyncCb === 'function') return $dy7q9.Inflate._processChunk.call(this, chunk, flushFlag, asyncCb);
    var self = this;
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var leftToInflate = this._maxLength;
    var inOff = 0;
    var buffers = [];
    var nread = 0;
    var error;
    this.on('error', function(err) {
        error = err;
    });
    function handleChunk(availInAfter, availOutAfter) {
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $d97bb57996964529$require$assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            if (out.length > leftToInflate) out = out.slice(0, leftToInflate);
            buffers.push(out);
            nread += out.length;
            leftToInflate -= out.length;
            if (leftToInflate === 0) return false;
        }
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $d97bb57996964529$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            return true;
        }
        return false;
    }
    $d97bb57996964529$require$assert(this._handle, 'zlib binding closed');
    do {
        var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        // Node 8 --> 9 compatibility check
        res = res || this._writeState;
    }while (!this._hadError && handleChunk(res[0], res[1]));
    if (this._hadError) throw error;
    if (nread >= $d97bb57996964529$require$kMaxLength) {
        _close(this);
        throw new RangeError('Cannot create final Buffer. It would be larger than 0x' + $d97bb57996964529$require$kMaxLength.toString(16) + ' bytes');
    }
    var buf = $d97bb57996964529$require$Buffer.concat(buffers, nread);
    _close(this);
    return buf;
};
$hHIjR.inherits(Inflate, $dy7q9.Inflate);
function zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = $d97bb57996964529$require$Buffer.from(buffer);
    if (!(buffer instanceof $d97bb57996964529$require$Buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = engine._finishFlushFlag;
    if (flushFlag == null) flushFlag = $dy7q9.Z_FINISH;
    return engine._processChunk(buffer, flushFlag);
}
function inflateSync(buffer, opts) {
    return zlibBufferSync(new Inflate(opts), buffer);
}
module.exports = exports = inflateSync;
exports.Inflate = Inflate;
exports.createInflate = createInflate;
exports.inflateSync = inflateSync;

});
parcelRegister("dy7q9", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';

var $kJBqN = parcelRequire("kJBqN");
var $9dd434f312410d89$require$Buffer = $kJBqN.Buffer;

var $2C97X = parcelRequire("2C97X");
var $9dd434f312410d89$require$Transform = $2C97X.Transform;

var $eEvxJ = parcelRequire("eEvxJ");

var $hHIjR = parcelRequire("hHIjR");

var $7UcXO = parcelRequire("7UcXO");
var $9dd434f312410d89$require$assert = $7UcXO.ok;

var $kJBqN = parcelRequire("kJBqN");
var $9dd434f312410d89$require$kMaxLength = $kJBqN.kMaxLength;
var $9dd434f312410d89$var$kRangeErrorMessage = "Cannot create final Buffer. It would be larger than 0x" + $9dd434f312410d89$require$kMaxLength.toString(16) + ' bytes';
// zlib doesn't provide these, so kludge them in following the same
// const naming scheme zlib uses.
$eEvxJ.Z_MIN_WINDOWBITS = 8;
$eEvxJ.Z_MAX_WINDOWBITS = 15;
$eEvxJ.Z_DEFAULT_WINDOWBITS = 15;
// fewer than 64 bytes per chunk is stupid.
// technically it could work with as few as 8, but even 64 bytes
// is absurdly low.  Usually a MB or more is best.
$eEvxJ.Z_MIN_CHUNK = 64;
$eEvxJ.Z_MAX_CHUNK = Infinity;
$eEvxJ.Z_DEFAULT_CHUNK = 16384;
$eEvxJ.Z_MIN_MEMLEVEL = 1;
$eEvxJ.Z_MAX_MEMLEVEL = 9;
$eEvxJ.Z_DEFAULT_MEMLEVEL = 8;
$eEvxJ.Z_MIN_LEVEL = -1;
$eEvxJ.Z_MAX_LEVEL = 9;
$eEvxJ.Z_DEFAULT_LEVEL = $eEvxJ.Z_DEFAULT_COMPRESSION;
// expose all the zlib constants
var $9dd434f312410d89$var$bkeys = Object.keys($eEvxJ);
for(var $9dd434f312410d89$var$bk = 0; $9dd434f312410d89$var$bk < $9dd434f312410d89$var$bkeys.length; $9dd434f312410d89$var$bk++){
    var $9dd434f312410d89$var$bkey = $9dd434f312410d89$var$bkeys[$9dd434f312410d89$var$bk];
    if ($9dd434f312410d89$var$bkey.match(/^Z/)) Object.defineProperty(module.exports, $9dd434f312410d89$var$bkey, {
        enumerable: true,
        value: $eEvxJ[$9dd434f312410d89$var$bkey],
        writable: false
    });
}
// translation table for return codes.
var $9dd434f312410d89$var$codes = {
    Z_OK: $eEvxJ.Z_OK,
    Z_STREAM_END: $eEvxJ.Z_STREAM_END,
    Z_NEED_DICT: $eEvxJ.Z_NEED_DICT,
    Z_ERRNO: $eEvxJ.Z_ERRNO,
    Z_STREAM_ERROR: $eEvxJ.Z_STREAM_ERROR,
    Z_DATA_ERROR: $eEvxJ.Z_DATA_ERROR,
    Z_MEM_ERROR: $eEvxJ.Z_MEM_ERROR,
    Z_BUF_ERROR: $eEvxJ.Z_BUF_ERROR,
    Z_VERSION_ERROR: $eEvxJ.Z_VERSION_ERROR
};
var $9dd434f312410d89$var$ckeys = Object.keys($9dd434f312410d89$var$codes);
for(var $9dd434f312410d89$var$ck = 0; $9dd434f312410d89$var$ck < $9dd434f312410d89$var$ckeys.length; $9dd434f312410d89$var$ck++){
    var $9dd434f312410d89$var$ckey = $9dd434f312410d89$var$ckeys[$9dd434f312410d89$var$ck];
    $9dd434f312410d89$var$codes[$9dd434f312410d89$var$codes[$9dd434f312410d89$var$ckey]] = $9dd434f312410d89$var$ckey;
}
Object.defineProperty(module.exports, 'codes', {
    enumerable: true,
    value: Object.freeze($9dd434f312410d89$var$codes),
    writable: false
});
module.exports.Deflate = $9dd434f312410d89$var$Deflate;
module.exports.Inflate = $9dd434f312410d89$var$Inflate;
module.exports.Gzip = $9dd434f312410d89$var$Gzip;
module.exports.Gunzip = $9dd434f312410d89$var$Gunzip;
module.exports.DeflateRaw = $9dd434f312410d89$var$DeflateRaw;
module.exports.InflateRaw = $9dd434f312410d89$var$InflateRaw;
module.exports.Unzip = $9dd434f312410d89$var$Unzip;
module.exports.createDeflate = function(o) {
    return new $9dd434f312410d89$var$Deflate(o);
};
module.exports.createInflate = function(o) {
    return new $9dd434f312410d89$var$Inflate(o);
};
module.exports.createDeflateRaw = function(o) {
    return new $9dd434f312410d89$var$DeflateRaw(o);
};
module.exports.createInflateRaw = function(o) {
    return new $9dd434f312410d89$var$InflateRaw(o);
};
module.exports.createGzip = function(o) {
    return new $9dd434f312410d89$var$Gzip(o);
};
module.exports.createGunzip = function(o) {
    return new $9dd434f312410d89$var$Gunzip(o);
};
module.exports.createUnzip = function(o) {
    return new $9dd434f312410d89$var$Unzip(o);
};
// Convenience methods.
// compress/decompress a string or buffer in one step.
module.exports.deflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$Deflate(opts), buffer, callback);
};
module.exports.deflateSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$Deflate(opts), buffer);
};
module.exports.gzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$Gzip(opts), buffer, callback);
};
module.exports.gzipSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$Gzip(opts), buffer);
};
module.exports.deflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$DeflateRaw(opts), buffer, callback);
};
module.exports.deflateRawSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$DeflateRaw(opts), buffer);
};
module.exports.unzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$Unzip(opts), buffer, callback);
};
module.exports.unzipSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$Unzip(opts), buffer);
};
module.exports.inflate = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$Inflate(opts), buffer, callback);
};
module.exports.inflateSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$Inflate(opts), buffer);
};
module.exports.gunzip = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$Gunzip(opts), buffer, callback);
};
module.exports.gunzipSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$Gunzip(opts), buffer);
};
module.exports.inflateRaw = function(buffer, opts, callback) {
    if (typeof opts === 'function') {
        callback = opts;
        opts = {};
    }
    return $9dd434f312410d89$var$zlibBuffer(new $9dd434f312410d89$var$InflateRaw(opts), buffer, callback);
};
module.exports.inflateRawSync = function(buffer, opts) {
    return $9dd434f312410d89$var$zlibBufferSync(new $9dd434f312410d89$var$InflateRaw(opts), buffer);
};
function $9dd434f312410d89$var$zlibBuffer(engine, buffer, callback) {
    var buffers = [];
    var nread = 0;
    engine.on('error', onError);
    engine.on('end', onEnd);
    engine.end(buffer);
    flow();
    function flow() {
        var chunk;
        while(null !== (chunk = engine.read())){
            buffers.push(chunk);
            nread += chunk.length;
        }
        engine.once('readable', flow);
    }
    function onError(err) {
        engine.removeListener('end', onEnd);
        engine.removeListener('readable', flow);
        callback(err);
    }
    function onEnd() {
        var buf;
        var err = null;
        if (nread >= $9dd434f312410d89$require$kMaxLength) err = new RangeError($9dd434f312410d89$var$kRangeErrorMessage);
        else buf = $9dd434f312410d89$require$Buffer.concat(buffers, nread);
        buffers = [];
        engine.close();
        callback(err, buf);
    }
}
function $9dd434f312410d89$var$zlibBufferSync(engine, buffer) {
    if (typeof buffer === 'string') buffer = $9dd434f312410d89$require$Buffer.from(buffer);
    if (!$9dd434f312410d89$require$Buffer.isBuffer(buffer)) throw new TypeError('Not a string or buffer');
    var flushFlag = engine._finishFlushFlag;
    return engine._processChunk(buffer, flushFlag);
}
// generic zlib
// minimal 2-byte header
function $9dd434f312410d89$var$Deflate(opts) {
    if (!(this instanceof $9dd434f312410d89$var$Deflate)) return new $9dd434f312410d89$var$Deflate(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.DEFLATE);
}
function $9dd434f312410d89$var$Inflate(opts) {
    if (!(this instanceof $9dd434f312410d89$var$Inflate)) return new $9dd434f312410d89$var$Inflate(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.INFLATE);
}
// gzip - bigger header, same deflate compression
function $9dd434f312410d89$var$Gzip(opts) {
    if (!(this instanceof $9dd434f312410d89$var$Gzip)) return new $9dd434f312410d89$var$Gzip(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.GZIP);
}
function $9dd434f312410d89$var$Gunzip(opts) {
    if (!(this instanceof $9dd434f312410d89$var$Gunzip)) return new $9dd434f312410d89$var$Gunzip(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.GUNZIP);
}
// raw - no header
function $9dd434f312410d89$var$DeflateRaw(opts) {
    if (!(this instanceof $9dd434f312410d89$var$DeflateRaw)) return new $9dd434f312410d89$var$DeflateRaw(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.DEFLATERAW);
}
function $9dd434f312410d89$var$InflateRaw(opts) {
    if (!(this instanceof $9dd434f312410d89$var$InflateRaw)) return new $9dd434f312410d89$var$InflateRaw(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.INFLATERAW);
}
// auto-detect header.
function $9dd434f312410d89$var$Unzip(opts) {
    if (!(this instanceof $9dd434f312410d89$var$Unzip)) return new $9dd434f312410d89$var$Unzip(opts);
    $9dd434f312410d89$var$Zlib.call(this, opts, $eEvxJ.UNZIP);
}
function $9dd434f312410d89$var$isValidFlushFlag(flag) {
    return flag === $eEvxJ.Z_NO_FLUSH || flag === $eEvxJ.Z_PARTIAL_FLUSH || flag === $eEvxJ.Z_SYNC_FLUSH || flag === $eEvxJ.Z_FULL_FLUSH || flag === $eEvxJ.Z_FINISH || flag === $eEvxJ.Z_BLOCK;
}
// the Zlib class they all inherit from
// This thing manages the queue of requests, and returns
// true or false if there is anything in the queue when
// you call the .write() method.
function $9dd434f312410d89$var$Zlib(opts, mode) {
    var _this = this;
    this._opts = opts = opts || {};
    this._chunkSize = opts.chunkSize || module.exports.Z_DEFAULT_CHUNK;
    $9dd434f312410d89$require$Transform.call(this, opts);
    if (opts.flush && !$9dd434f312410d89$var$isValidFlushFlag(opts.flush)) throw new Error('Invalid flush flag: ' + opts.flush);
    if (opts.finishFlush && !$9dd434f312410d89$var$isValidFlushFlag(opts.finishFlush)) throw new Error('Invalid flush flag: ' + opts.finishFlush);
    this._flushFlag = opts.flush || $eEvxJ.Z_NO_FLUSH;
    this._finishFlushFlag = typeof opts.finishFlush !== 'undefined' ? opts.finishFlush : $eEvxJ.Z_FINISH;
    if (opts.chunkSize) {
        if (opts.chunkSize < module.exports.Z_MIN_CHUNK || opts.chunkSize > module.exports.Z_MAX_CHUNK) throw new Error('Invalid chunk size: ' + opts.chunkSize);
    }
    if (opts.windowBits) {
        if (opts.windowBits < module.exports.Z_MIN_WINDOWBITS || opts.windowBits > module.exports.Z_MAX_WINDOWBITS) throw new Error('Invalid windowBits: ' + opts.windowBits);
    }
    if (opts.level) {
        if (opts.level < module.exports.Z_MIN_LEVEL || opts.level > module.exports.Z_MAX_LEVEL) throw new Error('Invalid compression level: ' + opts.level);
    }
    if (opts.memLevel) {
        if (opts.memLevel < module.exports.Z_MIN_MEMLEVEL || opts.memLevel > module.exports.Z_MAX_MEMLEVEL) throw new Error('Invalid memLevel: ' + opts.memLevel);
    }
    if (opts.strategy) {
        if (opts.strategy != module.exports.Z_FILTERED && opts.strategy != module.exports.Z_HUFFMAN_ONLY && opts.strategy != module.exports.Z_RLE && opts.strategy != module.exports.Z_FIXED && opts.strategy != module.exports.Z_DEFAULT_STRATEGY) throw new Error('Invalid strategy: ' + opts.strategy);
    }
    if (opts.dictionary) {
        if (!$9dd434f312410d89$require$Buffer.isBuffer(opts.dictionary)) throw new Error('Invalid dictionary: it should be a Buffer instance');
    }
    this._handle = new $eEvxJ.Zlib(mode);
    var self = this;
    this._hadError = false;
    this._handle.onerror = function(message, errno) {
        // there is no way to cleanly recover.
        // continuing only obscures problems.
        $9dd434f312410d89$var$_close(self);
        self._hadError = true;
        var error = new Error(message);
        error.errno = errno;
        error.code = module.exports.codes[errno];
        self.emit('error', error);
    };
    var level = module.exports.Z_DEFAULT_COMPRESSION;
    if (typeof opts.level === 'number') level = opts.level;
    var strategy = module.exports.Z_DEFAULT_STRATEGY;
    if (typeof opts.strategy === 'number') strategy = opts.strategy;
    this._handle.init(opts.windowBits || module.exports.Z_DEFAULT_WINDOWBITS, level, opts.memLevel || module.exports.Z_DEFAULT_MEMLEVEL, strategy, opts.dictionary);
    this._buffer = $9dd434f312410d89$require$Buffer.allocUnsafe(this._chunkSize);
    this._offset = 0;
    this._level = level;
    this._strategy = strategy;
    this.once('end', this.close);
    Object.defineProperty(this, '_closed', {
        get: function() {
            return !_this._handle;
        },
        configurable: true,
        enumerable: true
    });
}
$hHIjR.inherits($9dd434f312410d89$var$Zlib, $9dd434f312410d89$require$Transform);
$9dd434f312410d89$var$Zlib.prototype.params = function(level, strategy, callback) {
    if (level < module.exports.Z_MIN_LEVEL || level > module.exports.Z_MAX_LEVEL) throw new RangeError('Invalid compression level: ' + level);
    if (strategy != module.exports.Z_FILTERED && strategy != module.exports.Z_HUFFMAN_ONLY && strategy != module.exports.Z_RLE && strategy != module.exports.Z_FIXED && strategy != module.exports.Z_DEFAULT_STRATEGY) throw new TypeError('Invalid strategy: ' + strategy);
    if (this._level !== level || this._strategy !== strategy) {
        var self = this;
        this.flush($eEvxJ.Z_SYNC_FLUSH, function() {
            $9dd434f312410d89$require$assert(self._handle, 'zlib binding closed');
            self._handle.params(level, strategy);
            if (!self._hadError) {
                self._level = level;
                self._strategy = strategy;
                if (callback) callback();
            }
        });
    } else $5XqL3.nextTick(callback);
};
$9dd434f312410d89$var$Zlib.prototype.reset = function() {
    $9dd434f312410d89$require$assert(this._handle, 'zlib binding closed');
    return this._handle.reset();
};
// This is the _flush function called by the transform class,
// internally, when the last chunk has been written.
$9dd434f312410d89$var$Zlib.prototype._flush = function(callback) {
    this._transform($9dd434f312410d89$require$Buffer.alloc(0), '', callback);
};
$9dd434f312410d89$var$Zlib.prototype.flush = function(kind, callback) {
    var _this2 = this;
    var ws = this._writableState;
    if (typeof kind === 'function' || kind === undefined && !callback) {
        callback = kind;
        kind = $eEvxJ.Z_FULL_FLUSH;
    }
    if (ws.ended) {
        if (callback) $5XqL3.nextTick(callback);
    } else if (ws.ending) {
        if (callback) this.once('end', callback);
    } else if (ws.needDrain) {
        if (callback) this.once('drain', function() {
            return _this2.flush(kind, callback);
        });
    } else {
        this._flushFlag = kind;
        this.write($9dd434f312410d89$require$Buffer.alloc(0), '', callback);
    }
};
$9dd434f312410d89$var$Zlib.prototype.close = function(callback) {
    $9dd434f312410d89$var$_close(this, callback);
    $5XqL3.nextTick($9dd434f312410d89$var$emitCloseNT, this);
};
function $9dd434f312410d89$var$_close(engine, callback) {
    if (callback) $5XqL3.nextTick(callback);
    // Caller may invoke .close after a zlib error (which will null _handle).
    if (!engine._handle) return;
    engine._handle.close();
    engine._handle = null;
}
function $9dd434f312410d89$var$emitCloseNT(self) {
    self.emit('close');
}
$9dd434f312410d89$var$Zlib.prototype._transform = function(chunk, encoding, cb) {
    var flushFlag;
    var ws = this._writableState;
    var ending = ws.ending || ws.ended;
    var last = ending && (!chunk || ws.length === chunk.length);
    if (chunk !== null && !$9dd434f312410d89$require$Buffer.isBuffer(chunk)) return cb(new Error('invalid input'));
    if (!this._handle) return cb(new Error('zlib binding closed'));
    // If it's the last chunk, or a final flush, we use the Z_FINISH flush flag
    // (or whatever flag was provided using opts.finishFlush).
    // If it's explicitly flushing at some other time, then we use
    // Z_FULL_FLUSH. Otherwise, use Z_NO_FLUSH for maximum compression
    // goodness.
    if (last) flushFlag = this._finishFlushFlag;
    else {
        flushFlag = this._flushFlag;
        // once we've flushed the last of the queue, stop flushing and
        // go back to the normal behavior.
        if (chunk.length >= ws.length) this._flushFlag = this._opts.flush || $eEvxJ.Z_NO_FLUSH;
    }
    this._processChunk(chunk, flushFlag, cb);
};
$9dd434f312410d89$var$Zlib.prototype._processChunk = function(chunk, flushFlag, cb) {
    var availInBefore = chunk && chunk.length;
    var availOutBefore = this._chunkSize - this._offset;
    var inOff = 0;
    var self = this;
    var async = typeof cb === 'function';
    if (!async) {
        var buffers = [];
        var nread = 0;
        var error;
        this.on('error', function(er) {
            error = er;
        });
        $9dd434f312410d89$require$assert(this._handle, 'zlib binding closed');
        do var res = this._handle.writeSync(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
        while (!this._hadError && callback(res[0], res[1]));
        if (this._hadError) throw error;
        if (nread >= $9dd434f312410d89$require$kMaxLength) {
            $9dd434f312410d89$var$_close(this);
            throw new RangeError($9dd434f312410d89$var$kRangeErrorMessage);
        }
        var buf = $9dd434f312410d89$require$Buffer.concat(buffers, nread);
        $9dd434f312410d89$var$_close(this);
        return buf;
    }
    $9dd434f312410d89$require$assert(this._handle, 'zlib binding closed');
    var req = this._handle.write(flushFlag, chunk, inOff, availInBefore, this._buffer, this._offset, availOutBefore); // out_len
    req.buffer = chunk;
    req.callback = callback;
    function callback(availInAfter, availOutAfter) {
        // When the callback is used in an async write, the callback's
        // context is the `req` object that was created. The req object
        // is === this._handle, and that's why it's important to null
        // out the values after they are done being used. `this._handle`
        // can stay in memory longer than the callback and buffer are needed.
        if (this) {
            this.buffer = null;
            this.callback = null;
        }
        if (self._hadError) return;
        var have = availOutBefore - availOutAfter;
        $9dd434f312410d89$require$assert(have >= 0, 'have should not go down');
        if (have > 0) {
            var out = self._buffer.slice(self._offset, self._offset + have);
            self._offset += have;
            // serve some output to the consumer.
            if (async) self.push(out);
            else {
                buffers.push(out);
                nread += out.length;
            }
        }
        // exhausted the output buffer, or used all the input create a new one.
        if (availOutAfter === 0 || self._offset >= self._chunkSize) {
            availOutBefore = self._chunkSize;
            self._offset = 0;
            self._buffer = $9dd434f312410d89$require$Buffer.allocUnsafe(self._chunkSize);
        }
        if (availOutAfter === 0) {
            // Not actually done.  Need to reprocess.
            // Also, update the availInBefore to the availInAfter value,
            // so that if we have to hit it a third (fourth, etc.) time,
            // it'll have the correct byte counts.
            inOff += availInBefore - availInAfter;
            availInBefore = availInAfter;
            if (!async) return true;
            var newReq = self._handle.write(flushFlag, chunk, inOff, availInBefore, self._buffer, self._offset, self._chunkSize);
            newReq.callback = callback; // this same function
            newReq.buffer = chunk;
            return;
        }
        if (!async) return false;
        // finished with the chunk.
        cb();
    }
};
$hHIjR.inherits($9dd434f312410d89$var$Deflate, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$Inflate, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$Gzip, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$Gunzip, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$DeflateRaw, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$InflateRaw, $9dd434f312410d89$var$Zlib);
$hHIjR.inherits($9dd434f312410d89$var$Unzip, $9dd434f312410d89$var$Zlib);

});
parcelRegister("2C97X", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $1e7635e7114800ac$var$Stream;

var $8mV0l = parcelRequire("8mV0l");
var $1e7635e7114800ac$require$EE = $8mV0l.EventEmitter;

var $gdc6A = parcelRequire("gdc6A");
$gdc6A($1e7635e7114800ac$var$Stream, $1e7635e7114800ac$require$EE);

$1e7635e7114800ac$var$Stream.Readable = (parcelRequire("bAlHk"));

$1e7635e7114800ac$var$Stream.Writable = (parcelRequire("8b39O"));

$1e7635e7114800ac$var$Stream.Duplex = (parcelRequire("5y1if"));

$1e7635e7114800ac$var$Stream.Transform = (parcelRequire("gNFsE"));

$1e7635e7114800ac$var$Stream.PassThrough = (parcelRequire("9y7iY"));

$1e7635e7114800ac$var$Stream.finished = (parcelRequire("9DLFT"));

$1e7635e7114800ac$var$Stream.pipeline = (parcelRequire("k5Htd"));
// Backwards-compat with node 0.4.x
$1e7635e7114800ac$var$Stream.Stream = $1e7635e7114800ac$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $1e7635e7114800ac$var$Stream() {
    $1e7635e7114800ac$require$EE.call(this);
}
$1e7635e7114800ac$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($1e7635e7114800ac$require$EE.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});

parcelRegister("eEvxJ", function(module, exports) {

var $kJBqN = parcelRequire("kJBqN");
var $aaad44ef9148b6e5$require$Buffer = $kJBqN.Buffer;

var $5XqL3 = parcelRequire("5XqL3");
'use strict';

var $7UcXO = parcelRequire("7UcXO");

var $hJ3h6 = parcelRequire("hJ3h6");

var $jN9NG = parcelRequire("jN9NG");

var $582gc = parcelRequire("582gc");

var $69DFd = parcelRequire("69DFd");
for(var $aaad44ef9148b6e5$var$key in $69DFd)module.exports[$aaad44ef9148b6e5$var$key] = $69DFd[$aaad44ef9148b6e5$var$key];
// zlib modes
module.exports.NONE = 0;
module.exports.DEFLATE = 1;
module.exports.INFLATE = 2;
module.exports.GZIP = 3;
module.exports.GUNZIP = 4;
module.exports.DEFLATERAW = 5;
module.exports.INFLATERAW = 6;
module.exports.UNZIP = 7;
var $aaad44ef9148b6e5$var$GZIP_HEADER_ID1 = 0x1f;
var $aaad44ef9148b6e5$var$GZIP_HEADER_ID2 = 0x8b;
/**
 * Emulate Node's zlib C++ layer for use by the JS layer in index.js
 */ function $aaad44ef9148b6e5$var$Zlib(mode) {
    if (typeof mode !== 'number' || mode < module.exports.DEFLATE || mode > module.exports.UNZIP) throw new TypeError('Bad argument');
    this.dictionary = null;
    this.err = 0;
    this.flush = 0;
    this.init_done = false;
    this.level = 0;
    this.memLevel = 0;
    this.mode = mode;
    this.strategy = 0;
    this.windowBits = 0;
    this.write_in_progress = false;
    this.pending_close = false;
    this.gzip_id_bytes_read = 0;
}
$aaad44ef9148b6e5$var$Zlib.prototype.close = function() {
    if (this.write_in_progress) {
        this.pending_close = true;
        return;
    }
    this.pending_close = false;
    $7UcXO(this.init_done, 'close before init');
    $7UcXO(this.mode <= module.exports.UNZIP);
    if (this.mode === module.exports.DEFLATE || this.mode === module.exports.GZIP || this.mode === module.exports.DEFLATERAW) $jN9NG.deflateEnd(this.strm);
    else if (this.mode === module.exports.INFLATE || this.mode === module.exports.GUNZIP || this.mode === module.exports.INFLATERAW || this.mode === module.exports.UNZIP) $582gc.inflateEnd(this.strm);
    this.mode = module.exports.NONE;
    this.dictionary = null;
};
$aaad44ef9148b6e5$var$Zlib.prototype.write = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(true, flush, input, in_off, in_len, out, out_off, out_len);
};
$aaad44ef9148b6e5$var$Zlib.prototype.writeSync = function(flush, input, in_off, in_len, out, out_off, out_len) {
    return this._write(false, flush, input, in_off, in_len, out, out_off, out_len);
};
$aaad44ef9148b6e5$var$Zlib.prototype._write = function(async, flush, input, in_off, in_len, out, out_off, out_len) {
    $7UcXO.equal(arguments.length, 8);
    $7UcXO(this.init_done, 'write before init');
    $7UcXO(this.mode !== module.exports.NONE, 'already finalized');
    $7UcXO.equal(false, this.write_in_progress, 'write already in progress');
    $7UcXO.equal(false, this.pending_close, 'close is pending');
    this.write_in_progress = true;
    $7UcXO.equal(false, flush === undefined, 'must provide flush value');
    this.write_in_progress = true;
    if (flush !== module.exports.Z_NO_FLUSH && flush !== module.exports.Z_PARTIAL_FLUSH && flush !== module.exports.Z_SYNC_FLUSH && flush !== module.exports.Z_FULL_FLUSH && flush !== module.exports.Z_FINISH && flush !== module.exports.Z_BLOCK) throw new Error('Invalid flush value');
    if (input == null) {
        input = $aaad44ef9148b6e5$require$Buffer.alloc(0);
        in_len = 0;
        in_off = 0;
    }
    this.strm.avail_in = in_len;
    this.strm.input = input;
    this.strm.next_in = in_off;
    this.strm.avail_out = out_len;
    this.strm.output = out;
    this.strm.next_out = out_off;
    this.flush = flush;
    if (!async) {
        // sync version
        this._process();
        if (this._checkError()) return this._afterSync();
        return;
    }
    // async version
    var self = this;
    $5XqL3.nextTick(function() {
        self._process();
        self._after();
    });
    return this;
};
$aaad44ef9148b6e5$var$Zlib.prototype._afterSync = function() {
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    return [
        avail_in,
        avail_out
    ];
};
$aaad44ef9148b6e5$var$Zlib.prototype._process = function() {
    var next_expected_header_byte = null;
    // If the avail_out is left at 0, then it means that it ran out
    // of room.  If there was avail_out left over, then it means
    // that all of the input was consumed.
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $jN9NG.deflate(this.strm, this.flush);
            break;
        case module.exports.UNZIP:
            if (this.strm.avail_in > 0) next_expected_header_byte = this.strm.next_in;
            switch(this.gzip_id_bytes_read){
                case 0:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $aaad44ef9148b6e5$var$GZIP_HEADER_ID1) {
                        this.gzip_id_bytes_read = 1;
                        next_expected_header_byte++;
                        if (this.strm.avail_in === 1) break;
                    } else {
                        this.mode = module.exports.INFLATE;
                        break;
                    }
                // fallthrough
                case 1:
                    if (next_expected_header_byte === null) break;
                    if (this.strm.input[next_expected_header_byte] === $aaad44ef9148b6e5$var$GZIP_HEADER_ID2) {
                        this.gzip_id_bytes_read = 2;
                        this.mode = module.exports.GUNZIP;
                    } else // There is no actual difference between INFLATE and INFLATERAW
                    // (after initialization).
                    this.mode = module.exports.INFLATE;
                    break;
                default:
                    throw new Error('invalid number of gzip magic number bytes read');
            }
        // fallthrough
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
            this.err = $582gc.inflate(this.strm, this.flush);
            if (this.err === module.exports.Z_NEED_DICT && this.dictionary) {
                // Load it
                this.err = $582gc.inflateSetDictionary(this.strm, this.dictionary);
                if (this.err === module.exports.Z_OK) // And try to decode again
                this.err = $582gc.inflate(this.strm, this.flush);
                else if (this.err === module.exports.Z_DATA_ERROR) // Both inflateSetDictionary() and inflate() return Z_DATA_ERROR.
                // Make it possible for After() to tell a bad dictionary from bad
                // input.
                this.err = module.exports.Z_NEED_DICT;
            }
            while(this.strm.avail_in > 0 && this.mode === module.exports.GUNZIP && this.err === module.exports.Z_STREAM_END && this.strm.next_in[0] !== 0x00){
                // Bytes remain in input buffer. Perhaps this is another compressed
                // member in the same archive, or just trailing garbage.
                // Trailing zero bytes are okay, though, since they are frequently
                // used for padding.
                this.reset();
                this.err = $582gc.inflate(this.strm, this.flush);
            }
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
};
$aaad44ef9148b6e5$var$Zlib.prototype._checkError = function() {
    // Acceptable error states depend on the type of zlib stream.
    switch(this.err){
        case module.exports.Z_OK:
        case module.exports.Z_BUF_ERROR:
            if (this.strm.avail_out !== 0 && this.flush === module.exports.Z_FINISH) {
                this._error('unexpected end of file');
                return false;
            }
            break;
        case module.exports.Z_STREAM_END:
            break;
        case module.exports.Z_NEED_DICT:
            if (this.dictionary == null) this._error('Missing dictionary');
            else this._error('Bad dictionary');
            return false;
        default:
            // something else.
            this._error('Zlib error');
            return false;
    }
    return true;
};
$aaad44ef9148b6e5$var$Zlib.prototype._after = function() {
    if (!this._checkError()) return;
    var avail_out = this.strm.avail_out;
    var avail_in = this.strm.avail_in;
    this.write_in_progress = false;
    // call the write() cb
    this.callback(avail_in, avail_out);
    if (this.pending_close) this.close();
};
$aaad44ef9148b6e5$var$Zlib.prototype._error = function(message) {
    if (this.strm.msg) message = this.strm.msg;
    this.onerror(message, this.err);
    this.write_in_progress = false;
    if (this.pending_close) this.close();
};
$aaad44ef9148b6e5$var$Zlib.prototype.init = function(windowBits, level, memLevel, strategy, dictionary) {
    $7UcXO(arguments.length === 4 || arguments.length === 5, 'init(windowBits, level, memLevel, strategy, [dictionary])');
    $7UcXO(windowBits >= 8 && windowBits <= 15, 'invalid windowBits');
    $7UcXO(level >= -1 && level <= 9, 'invalid compression level');
    $7UcXO(memLevel >= 1 && memLevel <= 9, 'invalid memlevel');
    $7UcXO(strategy === module.exports.Z_FILTERED || strategy === module.exports.Z_HUFFMAN_ONLY || strategy === module.exports.Z_RLE || strategy === module.exports.Z_FIXED || strategy === module.exports.Z_DEFAULT_STRATEGY, 'invalid strategy');
    this._init(level, windowBits, memLevel, strategy, dictionary);
    this._setDictionary();
};
$aaad44ef9148b6e5$var$Zlib.prototype.params = function() {
    throw new Error('deflateParams Not supported');
};
$aaad44ef9148b6e5$var$Zlib.prototype.reset = function() {
    this._reset();
    this._setDictionary();
};
$aaad44ef9148b6e5$var$Zlib.prototype._init = function(level, windowBits, memLevel, strategy, dictionary) {
    this.level = level;
    this.windowBits = windowBits;
    this.memLevel = memLevel;
    this.strategy = strategy;
    this.flush = module.exports.Z_NO_FLUSH;
    this.err = module.exports.Z_OK;
    if (this.mode === module.exports.GZIP || this.mode === module.exports.GUNZIP) this.windowBits += 16;
    if (this.mode === module.exports.UNZIP) this.windowBits += 32;
    if (this.mode === module.exports.DEFLATERAW || this.mode === module.exports.INFLATERAW) this.windowBits = -1 * this.windowBits;
    this.strm = new $hJ3h6();
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.GZIP:
        case module.exports.DEFLATERAW:
            this.err = $jN9NG.deflateInit2(this.strm, this.level, module.exports.Z_DEFLATED, this.windowBits, this.memLevel, this.strategy);
            break;
        case module.exports.INFLATE:
        case module.exports.GUNZIP:
        case module.exports.INFLATERAW:
        case module.exports.UNZIP:
            this.err = $582gc.inflateInit2(this.strm, this.windowBits);
            break;
        default:
            throw new Error('Unknown mode ' + this.mode);
    }
    if (this.err !== module.exports.Z_OK) this._error('Init error');
    this.dictionary = dictionary;
    this.write_in_progress = false;
    this.init_done = true;
};
$aaad44ef9148b6e5$var$Zlib.prototype._setDictionary = function() {
    if (this.dictionary == null) return;
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
            this.err = $jN9NG.deflateSetDictionary(this.strm, this.dictionary);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error('Failed to set dictionary');
};
$aaad44ef9148b6e5$var$Zlib.prototype._reset = function() {
    this.err = module.exports.Z_OK;
    switch(this.mode){
        case module.exports.DEFLATE:
        case module.exports.DEFLATERAW:
        case module.exports.GZIP:
            this.err = $jN9NG.deflateReset(this.strm);
            break;
        case module.exports.INFLATE:
        case module.exports.INFLATERAW:
        case module.exports.GUNZIP:
            this.err = $582gc.inflateReset(this.strm);
            break;
        default:
            break;
    }
    if (this.err !== module.exports.Z_OK) this._error('Failed to reset stream');
};
module.exports.Zlib = $aaad44ef9148b6e5$var$Zlib;

});
parcelRegister("hJ3h6", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $ce792df8c0b20f6b$var$ZStream() {
    /* next input byte */ this.input = null; // JS specific, because we have no pointers
    this.next_in = 0;
    /* number of bytes available at input */ this.avail_in = 0;
    /* total number of input bytes read so far */ this.total_in = 0;
    /* next output byte should be put there */ this.output = null; // JS specific, because we have no pointers
    this.next_out = 0;
    /* remaining free space at output */ this.avail_out = 0;
    /* total number of bytes output so far */ this.total_out = 0;
    /* last error message, NULL if no error */ this.msg = '' /*Z_NULL*/ ;
    /* not visible by applications */ this.state = null;
    /* best guess about the data type: binary or text */ this.data_type = 2 /*Z_UNKNOWN*/ ;
    /* adler32 value of the uncompressed data */ this.adler = 0;
}
module.exports = $ce792df8c0b20f6b$var$ZStream;

});

parcelRegister("jN9NG", function(module, exports) {

$parcel$export(module.exports, "deflateInit2", function () { return $e68a320d790874a8$export$a65c7b2bde87cb70; }, function (v) { return $e68a320d790874a8$export$a65c7b2bde87cb70 = v; });
$parcel$export(module.exports, "deflateReset", function () { return $e68a320d790874a8$export$8f99f0e30bc7dd53; }, function (v) { return $e68a320d790874a8$export$8f99f0e30bc7dd53 = v; });
$parcel$export(module.exports, "deflateSetHeader", function () { return $e68a320d790874a8$export$1cd50f7b2515ba19; }, function (v) { return $e68a320d790874a8$export$1cd50f7b2515ba19 = v; });
$parcel$export(module.exports, "deflate", function () { return $e68a320d790874a8$export$2316623ecd1285ab; }, function (v) { return $e68a320d790874a8$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateEnd", function () { return $e68a320d790874a8$export$599854fa319a815f; }, function (v) { return $e68a320d790874a8$export$599854fa319a815f = v; });
$parcel$export(module.exports, "deflateSetDictionary", function () { return $e68a320d790874a8$export$f55e0b3ab66b5d46; }, function (v) { return $e68a320d790874a8$export$f55e0b3ab66b5d46 = v; });
var $e68a320d790874a8$export$72b35d618fb8ad9b;
var $e68a320d790874a8$export$a65c7b2bde87cb70;
var $e68a320d790874a8$export$8f99f0e30bc7dd53;
var $e68a320d790874a8$export$e78fab288549509;
var $e68a320d790874a8$export$1cd50f7b2515ba19;
var $e68a320d790874a8$export$2316623ecd1285ab;
var $e68a320d790874a8$export$599854fa319a815f;
var $e68a320d790874a8$export$f55e0b3ab66b5d46;
var $e68a320d790874a8$export$12b6e1fcadea22f9;
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");

var $5xHTP = parcelRequire("5xHTP");

var $jnGJc = parcelRequire("jnGJc");

var $giZ5I = parcelRequire("giZ5I");

var $d1Xv2 = parcelRequire("d1Xv2");
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ var $e68a320d790874a8$var$Z_NO_FLUSH = 0;
var $e68a320d790874a8$var$Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
var $e68a320d790874a8$var$Z_FULL_FLUSH = 3;
var $e68a320d790874a8$var$Z_FINISH = 4;
var $e68a320d790874a8$var$Z_BLOCK = 5;
//var Z_TREES         = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $e68a320d790874a8$var$Z_OK = 0;
var $e68a320d790874a8$var$Z_STREAM_END = 1;
//var Z_NEED_DICT     = 2;
//var Z_ERRNO         = -1;
var $e68a320d790874a8$var$Z_STREAM_ERROR = -2;
var $e68a320d790874a8$var$Z_DATA_ERROR = -3;
//var Z_MEM_ERROR     = -4;
var $e68a320d790874a8$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* compression levels */ //var Z_NO_COMPRESSION      = 0;
//var Z_BEST_SPEED          = 1;
//var Z_BEST_COMPRESSION    = 9;
var $e68a320d790874a8$var$Z_DEFAULT_COMPRESSION = -1;
var $e68a320d790874a8$var$Z_FILTERED = 1;
var $e68a320d790874a8$var$Z_HUFFMAN_ONLY = 2;
var $e68a320d790874a8$var$Z_RLE = 3;
var $e68a320d790874a8$var$Z_FIXED = 4;
var $e68a320d790874a8$var$Z_DEFAULT_STRATEGY = 0;
/* Possible values of the data_type field (though see inflate()) */ //var Z_BINARY              = 0;
//var Z_TEXT                = 1;
//var Z_ASCII               = 1; // = Z_TEXT
var $e68a320d790874a8$var$Z_UNKNOWN = 2;
/* The deflate compression method */ var $e68a320d790874a8$var$Z_DEFLATED = 8;
/*============================================================================*/ var $e68a320d790874a8$var$MAX_MEM_LEVEL = 9;
/* Maximum value for memLevel in deflateInit2 */ var $e68a320d790874a8$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $e68a320d790874a8$var$DEF_MEM_LEVEL = 8;
var $e68a320d790874a8$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $e68a320d790874a8$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $e68a320d790874a8$var$L_CODES = $e68a320d790874a8$var$LITERALS + 1 + $e68a320d790874a8$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $e68a320d790874a8$var$D_CODES = 30;
/* number of distance codes */ var $e68a320d790874a8$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $e68a320d790874a8$var$HEAP_SIZE = 2 * $e68a320d790874a8$var$L_CODES + 1;
/* maximum heap size */ var $e68a320d790874a8$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $e68a320d790874a8$var$MIN_MATCH = 3;
var $e68a320d790874a8$var$MAX_MATCH = 258;
var $e68a320d790874a8$var$MIN_LOOKAHEAD = $e68a320d790874a8$var$MAX_MATCH + $e68a320d790874a8$var$MIN_MATCH + 1;
var $e68a320d790874a8$var$PRESET_DICT = 0x20;
var $e68a320d790874a8$var$INIT_STATE = 42;
var $e68a320d790874a8$var$EXTRA_STATE = 69;
var $e68a320d790874a8$var$NAME_STATE = 73;
var $e68a320d790874a8$var$COMMENT_STATE = 91;
var $e68a320d790874a8$var$HCRC_STATE = 103;
var $e68a320d790874a8$var$BUSY_STATE = 113;
var $e68a320d790874a8$var$FINISH_STATE = 666;
var $e68a320d790874a8$var$BS_NEED_MORE = 1; /* block not completed, need more input or more output */ 
var $e68a320d790874a8$var$BS_BLOCK_DONE = 2; /* block flush performed */ 
var $e68a320d790874a8$var$BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */ 
var $e68a320d790874a8$var$BS_FINISH_DONE = 4; /* finish done, accept no more input or output */ 
var $e68a320d790874a8$var$OS_CODE = 0x03; // Unix :) . Don't detect, use this default.
function $e68a320d790874a8$var$err(strm, errorCode) {
    strm.msg = $d1Xv2[errorCode];
    return errorCode;
}
function $e68a320d790874a8$var$rank(f) {
    return (f << 1) - (f > 4 ? 9 : 0);
}
function $e68a320d790874a8$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
/* =========================================================================
 * Flush as much pending output as possible. All deflate() output goes
 * through this function so some applications may wish to modify it
 * to avoid allocating a large strm->output buffer and copying into it.
 * (See also read_buf()).
 */ function $e68a320d790874a8$var$flush_pending(strm) {
    var s = strm.state;
    //_tr_flush_bits(s);
    var len = s.pending;
    if (len > strm.avail_out) len = strm.avail_out;
    if (len === 0) return;
    $8NmFQ.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
    strm.next_out += len;
    s.pending_out += len;
    strm.total_out += len;
    strm.avail_out -= len;
    s.pending -= len;
    if (s.pending === 0) s.pending_out = 0;
}
function $e68a320d790874a8$var$flush_block_only(s, last) {
    $5xHTP._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
    s.block_start = s.strstart;
    $e68a320d790874a8$var$flush_pending(s.strm);
}
function $e68a320d790874a8$var$put_byte(s, b) {
    s.pending_buf[s.pending++] = b;
}
/* =========================================================================
 * Put a short in the pending buffer. The 16-bit value is put in MSB order.
 * IN assertion: the stream state is correct and there is enough room in
 * pending_buf.
 */ function $e68a320d790874a8$var$putShortMSB(s, b) {
    //  put_byte(s, (Byte)(b >> 8));
    //  put_byte(s, (Byte)(b & 0xff));
    s.pending_buf[s.pending++] = b >>> 8 & 0xff;
    s.pending_buf[s.pending++] = b & 0xff;
}
/* ===========================================================================
 * Read a new buffer from the current input stream, update the adler32
 * and total number of bytes read.  All deflate() input goes through
 * this function so some applications may wish to modify it to avoid
 * allocating a large strm->input buffer and copying from it.
 * (See also flush_pending()).
 */ function $e68a320d790874a8$var$read_buf(strm, buf, start, size) {
    var len = strm.avail_in;
    if (len > size) len = size;
    if (len === 0) return 0;
    strm.avail_in -= len;
    // zmemcpy(buf, strm->next_in, len);
    $8NmFQ.arraySet(buf, strm.input, strm.next_in, len, start);
    if (strm.state.wrap === 1) strm.adler = $jnGJc(strm.adler, buf, len, start);
    else if (strm.state.wrap === 2) strm.adler = $giZ5I(strm.adler, buf, len, start);
    strm.next_in += len;
    strm.total_in += len;
    return len;
}
/* ===========================================================================
 * Set match_start to the longest match starting at the given string and
 * return its length. Matches shorter or equal to prev_length are discarded,
 * in which case the result is equal to prev_length and match_start is
 * garbage.
 * IN assertions: cur_match is the head of the hash chain for the current
 *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
 * OUT assertion: the match length is not greater than s->lookahead.
 */ function $e68a320d790874a8$var$longest_match(s, cur_match) {
    var chain_length = s.max_chain_length; /* max hash chain length */ 
    var scan = s.strstart; /* current string */ 
    var match; /* matched string */ 
    var len; /* length of current match */ 
    var best_len = s.prev_length; /* best match length so far */ 
    var nice_match = s.nice_match; /* stop if match long enough */ 
    var limit = s.strstart > s.w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD ? s.strstart - (s.w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD) : 0 /*NIL*/ ;
    var _win = s.window; // shortcut
    var wmask = s.w_mask;
    var prev = s.prev;
    /* Stop when cur_match becomes <= limit. To simplify the code,
   * we prevent matches with the string of window index 0.
   */ var strend = s.strstart + $e68a320d790874a8$var$MAX_MATCH;
    var scan_end1 = _win[scan + best_len - 1];
    var scan_end = _win[scan + best_len];
    /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
   * It is easy to get rid of this optimization if necessary.
   */ // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");
    /* Do not waste too much time if we already have a good match: */ if (s.prev_length >= s.good_match) chain_length >>= 2;
    /* Do not look for matches beyond the end of the input. This is necessary
   * to make deflate deterministic.
   */ if (nice_match > s.lookahead) nice_match = s.lookahead;
    // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");
    do {
        // Assert(cur_match < s->strstart, "no future");
        match = cur_match;
        /* Skip to next match if the match length cannot increase
     * or if the match length is less than 2.  Note that the checks below
     * for insufficient lookahead only occur occasionally for performance
     * reasons.  Therefore uninitialized memory will be accessed, and
     * conditional jumps will be made that depend on those values.
     * However the length of the match is limited to the lookahead, so
     * the output of deflate is not affected by the uninitialized values.
     */ if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) continue;
        /* The check at best_len-1 can be removed because it will be made
     * again later. (This heuristic is not always a win.)
     * It is not necessary to compare scan[2] and match[2] since they
     * are always equal when the other bytes match, given that
     * the hash keys are equal and that HASH_BITS >= 8.
     */ scan += 2;
        match++;
        // Assert(*scan == *match, "match[2]?");
        /* We check for insufficient lookahead only every 8th comparison;
     * the 256th check will be made at strstart+258.
     */ do ;
        while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);
        // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");
        len = $e68a320d790874a8$var$MAX_MATCH - (strend - scan);
        scan = strend - $e68a320d790874a8$var$MAX_MATCH;
        if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) break;
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
        }
    }while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
    if (best_len <= s.lookahead) return best_len;
    return s.lookahead;
}
/* ===========================================================================
 * Fill the window when the lookahead becomes insufficient.
 * Updates strstart and lookahead.
 *
 * IN assertion: lookahead < MIN_LOOKAHEAD
 * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
 *    At least one byte has been read, or avail_in == 0; reads are
 *    performed for at least two bytes (required for the zip translate_eol
 *    option -- not supported here).
 */ function $e68a320d790874a8$var$fill_window(s) {
    var _w_size = s.w_size;
    var p, n, m, more, str;
    //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");
    do {
        more = s.window_size - s.lookahead - s.strstart;
        // JS ints have 32 bit, block below not needed
        /* Deal with !@#$% 64K limit: */ //if (sizeof(int) <= 2) {
        //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
        //        more = wsize;
        //
        //  } else if (more == (unsigned)(-1)) {
        //        /* Very unlikely, but possible on 16 bit machine if
        //         * strstart == 0 && lookahead == 1 (input done a byte at time)
        //         */
        //        more--;
        //    }
        //}
        /* If the window is almost full and there is insufficient lookahead,
     * move the upper half to the lower one to make room in the upper half.
     */ if (s.strstart >= _w_size + (_w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD)) {
            $8NmFQ.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */ s.block_start -= _w_size;
            /* Slide the hash table (could be avoided with 32 bit values
       at the expense of memory usage). We slide even when level == 0
       to keep the hash table consistent if we switch back to level > 0
       later. (Using level 0 permanently is not an optimal usage of
       zlib, so we don't care about this pathological case.)
       */ n = s.hash_size;
            p = n;
            do {
                m = s.head[--p];
                s.head[p] = m >= _w_size ? m - _w_size : 0;
            }while (--n);
            n = _w_size;
            p = n;
            do {
                m = s.prev[--p];
                s.prev[p] = m >= _w_size ? m - _w_size : 0;
            /* If n is not on any hash chain, prev[n] is garbage but
         * its value will never be used.
         */ }while (--n);
            more += _w_size;
        }
        if (s.strm.avail_in === 0) break;
        /* If there was no sliding:
     *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
     *    more == window_size - lookahead - strstart
     * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
     * => more >= window_size - 2*WSIZE + 2
     * In the BIG_MEM or MMAP case (not yet supported),
     *   window_size == input_size + MIN_LOOKAHEAD  &&
     *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
     * Otherwise, window_size == 2*WSIZE so more >= 2.
     * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
     */ //Assert(more >= 2, "more < 2");
        n = $e68a320d790874a8$var$read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
        s.lookahead += n;
        /* Initialize the hash value now that we have some input: */ if (s.lookahead + s.insert >= $e68a320d790874a8$var$MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];
            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while(s.insert){
                /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
                s.prev[str & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = str;
                str++;
                s.insert--;
                if (s.lookahead + s.insert < $e68a320d790874a8$var$MIN_MATCH) break;
            }
        }
    /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
     * but this is not important since only literal bytes will be emitted.
     */ }while (s.lookahead < $e68a320d790874a8$var$MIN_LOOKAHEAD && s.strm.avail_in !== 0);
/* If the WIN_INIT bytes after the end of the current data have never been
   * written, then zero those bytes in order to avoid memory check reports of
   * the use of uninitialized (or uninitialised as Julian writes) bytes by
   * the longest match routines.  Update the high water mark for the next
   * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
   * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
   */ //  if (s.high_water < s.window_size) {
//    var curr = s.strstart + s.lookahead;
//    var init = 0;
//
//    if (s.high_water < curr) {
//      /* Previous high water mark below current data -- zero WIN_INIT
//       * bytes or up to end of window, whichever is less.
//       */
//      init = s.window_size - curr;
//      if (init > WIN_INIT)
//        init = WIN_INIT;
//      zmemzero(s->window + curr, (unsigned)init);
//      s->high_water = curr + init;
//    }
//    else if (s->high_water < (ulg)curr + WIN_INIT) {
//      /* High water mark at or above current data, but below current data
//       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
//       * to end of window, whichever is less.
//       */
//      init = (ulg)curr + WIN_INIT - s->high_water;
//      if (init > s->window_size - s->high_water)
//        init = s->window_size - s->high_water;
//      zmemzero(s->window + s->high_water, (unsigned)init);
//      s->high_water += init;
//    }
//  }
//
//  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
//    "not enough room for search");
}
/* ===========================================================================
 * Copy without compression as much as possible from the input stream, return
 * the current block state.
 * This function does not insert new strings in the dictionary since
 * uncompressible data is probably not useful. This function is used
 * only for the level=0 compression option.
 * NOTE: this function should be optimized to avoid extra copying from
 * window to pending_buf.
 */ function $e68a320d790874a8$var$deflate_stored(s, flush) {
    /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
   * to pending_buf_size, and each stored block has a 5 byte header:
   */ var max_block_size = 0xffff;
    if (max_block_size > s.pending_buf_size - 5) max_block_size = s.pending_buf_size - 5;
    /* Copy as much as possible from input to output: */ for(;;){
        /* Fill the window as much as possible: */ if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }
            $e68a320d790874a8$var$fill_window(s);
            if (s.lookahead === 0 && flush === $e68a320d790874a8$var$Z_NO_FLUSH) return $e68a320d790874a8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
        /* flush the current block */ }
        //Assert(s->block_start >= 0L, "block gone");
        //    if (s.block_start < 0) throw new Error("block gone");
        s.strstart += s.lookahead;
        s.lookahead = 0;
        /* Emit a stored block if pending_buf will be full: */ var max_start = s.block_start + max_block_size;
        if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */ s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        /***/ }
        /* Flush if we may have to slide, otherwise block_start may become
     * negative and the data will be gone:
     */ if (s.strstart - s.block_start >= s.w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e68a320d790874a8$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e68a320d790874a8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_FINISH_STARTED;
        /***/ return $e68a320d790874a8$var$BS_FINISH_DONE;
    }
    if (s.strstart > s.block_start) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
    /***/ }
    return $e68a320d790874a8$var$BS_NEED_MORE;
}
/* ===========================================================================
 * Compress as much as possible from the input stream, return the current
 * block state.
 * This function does not perform lazy evaluation of matches and inserts
 * new strings in the dictionary only for unmatched strings or for short
 * matches. It is used only for the fast compression options.
 */ function $e68a320d790874a8$var$deflate_fast(s, flush) {
    var hash_head; /* head of the hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $e68a320d790874a8$var$MIN_LOOKAHEAD) {
            $e68a320d790874a8$var$fill_window(s);
            if (s.lookahead < $e68a320d790874a8$var$MIN_LOOKAHEAD && flush === $e68a320d790874a8$var$Z_NO_FLUSH) return $e68a320d790874a8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break; /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $e68a320d790874a8$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     * At this point we have always match_length < MIN_MATCH
     */ if (hash_head !== 0 /*NIL*/  && s.strstart - hash_head <= s.w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD) /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $e68a320d790874a8$var$longest_match(s, hash_head);
        if (s.match_length >= $e68a320d790874a8$var$MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only
            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                     s.match_length - MIN_MATCH, bflush); ***/ bflush = $5xHTP._tr_tally(s, s.strstart - s.match_start, s.match_length - $e68a320d790874a8$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            /* Insert new strings in the hash table only if the match length
       * is not too large. This saves time but degrades compression.
       */ if (s.match_length <= s.max_lazy_match /*max_insert_length*/  && s.lookahead >= $e68a320d790874a8$var$MIN_MATCH) {
                s.match_length--; /* string at strstart already in table */ 
                do {
                    s.strstart++;
                    /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
                    hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                    s.head[s.ins_h] = s.strstart;
                /***/ /* strstart never exceeds WSIZE-MAX_MATCH, so there are
           * always MIN_MATCH bytes ahead.
           */ }while (--s.match_length !== 0);
                s.strstart++;
            } else {
                s.strstart += s.match_length;
                s.match_length = 0;
                s.ins_h = s.window[s.strstart];
                /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //                Call UPDATE_HASH() MIN_MATCH-3 more times
            //#endif
            /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
         * matter since it will be recomputed at next deflate call.
         */ }
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5xHTP._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = s.strstart < $e68a320d790874a8$var$MIN_MATCH - 1 ? s.strstart : $e68a320d790874a8$var$MIN_MATCH - 1;
    if (flush === $e68a320d790874a8$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e68a320d790874a8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_FINISH_STARTED;
        /***/ return $e68a320d790874a8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
    /***/ }
    return $e68a320d790874a8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * Same as above, but achieves better compression. We use a lazy
 * evaluation for matches: a match is finally adopted only if there is
 * no better match at the next window position.
 */ function $e68a320d790874a8$var$deflate_slow(s, flush) {
    var hash_head; /* head of hash chain */ 
    var bflush; /* set if current block must be flushed */ 
    var max_insert;
    /* Process the input block. */ for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the next match, plus MIN_MATCH bytes to insert the
     * string following the next match.
     */ if (s.lookahead < $e68a320d790874a8$var$MIN_LOOKAHEAD) {
            $e68a320d790874a8$var$fill_window(s);
            if (s.lookahead < $e68a320d790874a8$var$MIN_LOOKAHEAD && flush === $e68a320d790874a8$var$Z_NO_FLUSH) return $e68a320d790874a8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* Insert the string window[strstart .. strstart+2] in the
     * dictionary, and set hash_head to the head of the hash chain:
     */ hash_head = 0 /*NIL*/ ;
        if (s.lookahead >= $e68a320d790874a8$var$MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
        /***/ }
        /* Find the longest match, discarding those <= prev_length.
     */ s.prev_length = s.match_length;
        s.prev_match = s.match_start;
        s.match_length = $e68a320d790874a8$var$MIN_MATCH - 1;
        if (hash_head !== 0 /*NIL*/  && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - $e68a320d790874a8$var$MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
       * of window index 0 (in particular we have to avoid a match
       * of the string with itself at the start of the input file).
       */ s.match_length = $e68a320d790874a8$var$longest_match(s, hash_head);
            /* longest_match() sets match_start */ if (s.match_length <= 5 && (s.strategy === $e68a320d790874a8$var$Z_FILTERED || s.match_length === $e68a320d790874a8$var$MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/ )) /* If prev_match is also MIN_MATCH, match_start is garbage
         * but we will ignore the current match anyway.
         */ s.match_length = $e68a320d790874a8$var$MIN_MATCH - 1;
        }
        /* If there was a match at the previous step and the current
     * match is not better, output the previous match:
     */ if (s.prev_length >= $e68a320d790874a8$var$MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - $e68a320d790874a8$var$MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */ //check_match(s, s.strstart-1, s.prev_match, s.prev_length);
            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                     s.prev_length - MIN_MATCH, bflush);***/ bflush = $5xHTP._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - $e68a320d790874a8$var$MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
       * strstart-1 and strstart are already inserted. If there is not
       * enough lookahead, the last two strings are not inserted in
       * the hash table.
       */ s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
            /***/ }
            while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = $e68a320d790874a8$var$MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
                /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
                if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
            /***/ }
        } else if (s.match_available) {
            /* If there was no match at the previous position, output a
       * single literal. If there was a match but the current match
       * is longer, truncate the previous match to a single literal.
       */ //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5xHTP._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) /*** FLUSH_BLOCK_ONLY(s, 0) ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        } else {
            /* There is no previous match to compare with, wait for
       * the next step to decide.
       */ s.match_available = 1;
            s.strstart++;
            s.lookahead--;
        }
    }
    //Assert (flush != Z_NO_FLUSH, "no flush?");
    if (s.match_available) {
        //Tracevv((stderr,"%c", s->window[s->strstart-1]));
        /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/ bflush = $5xHTP._tr_tally(s, 0, s.window[s.strstart - 1]);
        s.match_available = 0;
    }
    s.insert = s.strstart < $e68a320d790874a8$var$MIN_MATCH - 1 ? s.strstart : $e68a320d790874a8$var$MIN_MATCH - 1;
    if (flush === $e68a320d790874a8$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e68a320d790874a8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_FINISH_STARTED;
        /***/ return $e68a320d790874a8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
    /***/ }
    return $e68a320d790874a8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_RLE, simply look for runs of bytes, generate matches only of distance
 * one.  Do not maintain a hash table.  (It will be regenerated if this run of
 * deflate switches away from Z_RLE.)
 */ function $e68a320d790874a8$var$deflate_rle(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    var prev; /* byte at distance one to match */ 
    var scan, strend; /* scan goes up to strend for length of run */ 
    var _win = s.window;
    for(;;){
        /* Make sure that we always have enough lookahead, except
     * at the end of the input file. We need MAX_MATCH bytes
     * for the longest run, plus one for the unrolled loop.
     */ if (s.lookahead <= $e68a320d790874a8$var$MAX_MATCH) {
            $e68a320d790874a8$var$fill_window(s);
            if (s.lookahead <= $e68a320d790874a8$var$MAX_MATCH && flush === $e68a320d790874a8$var$Z_NO_FLUSH) return $e68a320d790874a8$var$BS_NEED_MORE;
            if (s.lookahead === 0) break;
             /* flush the current block */ 
        }
        /* See how many times the previous byte repeats */ s.match_length = 0;
        if (s.lookahead >= $e68a320d790874a8$var$MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
                strend = s.strstart + $e68a320d790874a8$var$MAX_MATCH;
                do ;
                while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
                s.match_length = $e68a320d790874a8$var$MAX_MATCH - (strend - scan);
                if (s.match_length > s.lookahead) s.match_length = s.lookahead;
            }
        //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
        }
        /* Emit match if have run of MIN_MATCH or longer, else emit literal */ if (s.match_length >= $e68a320d790874a8$var$MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);
            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/ bflush = $5xHTP._tr_tally(s, 1, s.match_length - $e68a320d790874a8$var$MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
        } else {
            /* No match, output a literal byte */ //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5xHTP._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
        }
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e68a320d790874a8$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e68a320d790874a8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_FINISH_STARTED;
        /***/ return $e68a320d790874a8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
    /***/ }
    return $e68a320d790874a8$var$BS_BLOCK_DONE;
}
/* ===========================================================================
 * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
 * (It will be regenerated if this run of deflate switches away from Huffman.)
 */ function $e68a320d790874a8$var$deflate_huff(s, flush) {
    var bflush; /* set if current block must be flushed */ 
    for(;;){
        /* Make sure that we have a literal to write. */ if (s.lookahead === 0) {
            $e68a320d790874a8$var$fill_window(s);
            if (s.lookahead === 0) {
                if (flush === $e68a320d790874a8$var$Z_NO_FLUSH) return $e68a320d790874a8$var$BS_NEED_MORE;
                break; /* flush the current block */ 
            }
        }
        /* Output a literal byte */ s.match_length = 0;
        //Tracevv((stderr,"%c", s->window[s->strstart]));
        /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/ bflush = $5xHTP._tr_tally(s, 0, s.window[s.strstart]);
        s.lookahead--;
        s.strstart++;
        if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
            if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
        /***/ }
    }
    s.insert = 0;
    if (flush === $e68a320d790874a8$var$Z_FINISH) {
        /*** FLUSH_BLOCK(s, 1); ***/ $e68a320d790874a8$var$flush_block_only(s, true);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_FINISH_STARTED;
        /***/ return $e68a320d790874a8$var$BS_FINISH_DONE;
    }
    if (s.last_lit) {
        /*** FLUSH_BLOCK(s, 0); ***/ $e68a320d790874a8$var$flush_block_only(s, false);
        if (s.strm.avail_out === 0) return $e68a320d790874a8$var$BS_NEED_MORE;
    /***/ }
    return $e68a320d790874a8$var$BS_BLOCK_DONE;
}
/* Values for max_lazy_match, good_match and max_chain_length, depending on
 * the desired pack level (0..9). The values given below have been tuned to
 * exclude worst case performance for pathological files. Better values may be
 * found for specific files.
 */ function $e68a320d790874a8$var$Config(good_length, max_lazy, nice_length, max_chain, func) {
    this.good_length = good_length;
    this.max_lazy = max_lazy;
    this.nice_length = nice_length;
    this.max_chain = max_chain;
    this.func = func;
}
var $e68a320d790874a8$var$configuration_table;
$e68a320d790874a8$var$configuration_table = [
    /*      good lazy nice chain */ new $e68a320d790874a8$var$Config(0, 0, 0, 0, $e68a320d790874a8$var$deflate_stored),
    /* 0 store only */ new $e68a320d790874a8$var$Config(4, 4, 8, 4, $e68a320d790874a8$var$deflate_fast),
    /* 1 max speed, no lazy matches */ new $e68a320d790874a8$var$Config(4, 5, 16, 8, $e68a320d790874a8$var$deflate_fast),
    /* 2 */ new $e68a320d790874a8$var$Config(4, 6, 32, 32, $e68a320d790874a8$var$deflate_fast),
    /* 3 */ new $e68a320d790874a8$var$Config(4, 4, 16, 16, $e68a320d790874a8$var$deflate_slow),
    /* 4 lazy matches */ new $e68a320d790874a8$var$Config(8, 16, 32, 32, $e68a320d790874a8$var$deflate_slow),
    /* 5 */ new $e68a320d790874a8$var$Config(8, 16, 128, 128, $e68a320d790874a8$var$deflate_slow),
    /* 6 */ new $e68a320d790874a8$var$Config(8, 32, 128, 256, $e68a320d790874a8$var$deflate_slow),
    /* 7 */ new $e68a320d790874a8$var$Config(32, 128, 258, 1024, $e68a320d790874a8$var$deflate_slow),
    /* 8 */ new $e68a320d790874a8$var$Config(32, 258, 258, 4096, $e68a320d790874a8$var$deflate_slow)
];
/* ===========================================================================
 * Initialize the "longest match" routines for a new zlib stream
 */ function $e68a320d790874a8$var$lm_init(s) {
    s.window_size = 2 * s.w_size;
    /*** CLEAR_HASH(s); ***/ $e68a320d790874a8$var$zero(s.head); // Fill with NIL (= 0);
    /* Set the default configuration parameters:
   */ s.max_lazy_match = $e68a320d790874a8$var$configuration_table[s.level].max_lazy;
    s.good_match = $e68a320d790874a8$var$configuration_table[s.level].good_length;
    s.nice_match = $e68a320d790874a8$var$configuration_table[s.level].nice_length;
    s.max_chain_length = $e68a320d790874a8$var$configuration_table[s.level].max_chain;
    s.strstart = 0;
    s.block_start = 0;
    s.lookahead = 0;
    s.insert = 0;
    s.match_length = s.prev_length = $e68a320d790874a8$var$MIN_MATCH - 1;
    s.match_available = 0;
    s.ins_h = 0;
}
function $e68a320d790874a8$var$DeflateState() {
    this.strm = null; /* pointer back to this zlib stream */ 
    this.status = 0; /* as the name implies */ 
    this.pending_buf = null; /* output still pending */ 
    this.pending_buf_size = 0; /* size of pending_buf */ 
    this.pending_out = 0; /* next pending byte to output to the stream */ 
    this.pending = 0; /* nb of bytes in the pending buffer */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.gzhead = null; /* gzip header information to write */ 
    this.gzindex = 0; /* where in extra, name, or comment */ 
    this.method = $e68a320d790874a8$var$Z_DEFLATED; /* can only be DEFLATED */ 
    this.last_flush = -1; /* value of flush param for previous deflate call */ 
    this.w_size = 0; /* LZ77 window size (32K by default) */ 
    this.w_bits = 0; /* log2(w_size)  (8..16) */ 
    this.w_mask = 0; /* w_size - 1 */ 
    this.window = null;
    /* Sliding window. Input bytes are read into the second half of the window,
   * and move to the first half later to keep a dictionary of at least wSize
   * bytes. With this organization, matches are limited to a distance of
   * wSize-MAX_MATCH bytes, but this ensures that IO is always
   * performed with a length multiple of the block size.
   */ this.window_size = 0;
    /* Actual size of window: 2*wSize, except when the user input buffer
   * is directly used as sliding window.
   */ this.prev = null;
    /* Link to older string with same hash index. To limit the size of this
   * array to 64K, this link is maintained only for the last 32K strings.
   * An index in this array is thus a window index modulo 32K.
   */ this.head = null; /* Heads of the hash chains or NIL. */ 
    this.ins_h = 0; /* hash index of string to be inserted */ 
    this.hash_size = 0; /* number of elements in hash table */ 
    this.hash_bits = 0; /* log2(hash_size) */ 
    this.hash_mask = 0; /* hash_size-1 */ 
    this.hash_shift = 0;
    /* Number of bits by which ins_h must be shifted at each input
   * step. It must be such that after MIN_MATCH steps, the oldest
   * byte no longer takes part in the hash key, that is:
   *   hash_shift * MIN_MATCH >= hash_bits
   */ this.block_start = 0;
    /* Window position at the beginning of the current output block. Gets
   * negative when the window is moved backwards.
   */ this.match_length = 0; /* length of best match */ 
    this.prev_match = 0; /* previous match */ 
    this.match_available = 0; /* set if previous match exists */ 
    this.strstart = 0; /* start of string to insert */ 
    this.match_start = 0; /* start of matching string */ 
    this.lookahead = 0; /* number of valid bytes ahead in window */ 
    this.prev_length = 0;
    /* Length of the best match at previous step. Matches not greater than this
   * are discarded. This is used in the lazy match evaluation.
   */ this.max_chain_length = 0;
    /* To speed up deflation, hash chains are never searched beyond this
   * length.  A higher limit improves compression ratio but degrades the
   * speed.
   */ this.max_lazy_match = 0;
    /* Attempt to find a better match only when the current match is strictly
   * smaller than this value. This mechanism is used only for compression
   * levels >= 4.
   */ // That's alias to max_lazy_match, don't use directly
    //this.max_insert_length = 0;
    /* Insert new strings in the hash table only if the match length is not
   * greater than this length. This saves time but degrades compression.
   * max_insert_length is used only for compression levels <= 3.
   */ this.level = 0; /* compression level (1..9) */ 
    this.strategy = 0; /* favor or force Huffman coding*/ 
    this.good_match = 0;
    /* Use a faster search when the previous match is longer than this */ this.nice_match = 0; /* Stop searching when current match exceeds this */ 
    /* used by trees.c: */ /* Didn't use ct_data typedef below to suppress compiler warning */ // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
    // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
    // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */
    // Use flat array of DOUBLE size, with interleaved fata,
    // because JS does not support effective
    this.dyn_ltree = new $8NmFQ.Buf16($e68a320d790874a8$var$HEAP_SIZE * 2);
    this.dyn_dtree = new $8NmFQ.Buf16((2 * $e68a320d790874a8$var$D_CODES + 1) * 2);
    this.bl_tree = new $8NmFQ.Buf16((2 * $e68a320d790874a8$var$BL_CODES + 1) * 2);
    $e68a320d790874a8$var$zero(this.dyn_ltree);
    $e68a320d790874a8$var$zero(this.dyn_dtree);
    $e68a320d790874a8$var$zero(this.bl_tree);
    this.l_desc = null; /* desc. for literal tree */ 
    this.d_desc = null; /* desc. for distance tree */ 
    this.bl_desc = null; /* desc. for bit length tree */ 
    //ush bl_count[MAX_BITS+1];
    this.bl_count = new $8NmFQ.Buf16($e68a320d790874a8$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
    this.heap = new $8NmFQ.Buf16(2 * $e68a320d790874a8$var$L_CODES + 1); /* heap used to build the Huffman trees */ 
    $e68a320d790874a8$var$zero(this.heap);
    this.heap_len = 0; /* number of elements in the heap */ 
    this.heap_max = 0; /* element of largest frequency */ 
    /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
   * The same heap array is used to build all trees.
   */ this.depth = new $8NmFQ.Buf16(2 * $e68a320d790874a8$var$L_CODES + 1); //uch depth[2*L_CODES+1];
    $e68a320d790874a8$var$zero(this.depth);
    /* Depth of each subtree used as tie breaker for trees of equal frequency
   */ this.l_buf = 0; /* buffer index for literals or lengths */ 
    this.lit_bufsize = 0;
    /* Size of match buffer for literals/lengths.  There are 4 reasons for
   * limiting lit_bufsize to 64K:
   *   - frequencies can be kept in 16 bit counters
   *   - if compression is not successful for the first block, all input
   *     data is still in the window so we can still emit a stored block even
   *     when input comes from standard input.  (This can also be done for
   *     all blocks if lit_bufsize is not greater than 32K.)
   *   - if compression is not successful for a file smaller than 64K, we can
   *     even emit a stored file instead of a stored block (saving 5 bytes).
   *     This is applicable only for zip (not gzip or zlib).
   *   - creating new Huffman trees less frequently may not provide fast
   *     adaptation to changes in the input data statistics. (Take for
   *     example a binary file with poorly compressible code followed by
   *     a highly compressible string table.) Smaller buffer sizes give
   *     fast adaptation but have of course the overhead of transmitting
   *     trees more frequently.
   *   - I can't count above 4
   */ this.last_lit = 0; /* running index in l_buf */ 
    this.d_buf = 0;
    /* Buffer index for distances. To simplify the code, d_buf and l_buf have
   * the same number of elements. To use different lengths, an extra flag
   * array would be necessary.
   */ this.opt_len = 0; /* bit length of current block with optimal trees */ 
    this.static_len = 0; /* bit length of current block with static trees */ 
    this.matches = 0; /* number of string matches in current block */ 
    this.insert = 0; /* bytes at end of window left to insert */ 
    this.bi_buf = 0;
    /* Output buffer. bits are inserted starting at the bottom (least
   * significant bits).
   */ this.bi_valid = 0;
/* Number of valid bits in bi_buf.  All bits above the last valid bit
   * are always zero.
   */ // Used for window memory init. We safely ignore it for JS. That makes
// sense only for pointers and memory check tools.
//this.high_water = 0;
/* High water mark offset in window for initialized bytes -- bytes above
   * this are set to zero in order to avoid memory check warnings when
   * longest match routines access bytes past the input.  This is then
   * updated to the new high water mark.
   */ }
function $e68a320d790874a8$var$deflateResetKeep(strm) {
    var s;
    if (!strm || !strm.state) return $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_STREAM_ERROR);
    strm.total_in = strm.total_out = 0;
    strm.data_type = $e68a320d790874a8$var$Z_UNKNOWN;
    s = strm.state;
    s.pending = 0;
    s.pending_out = 0;
    if (s.wrap < 0) s.wrap = -s.wrap;
    s.status = s.wrap ? $e68a320d790874a8$var$INIT_STATE : $e68a320d790874a8$var$BUSY_STATE;
    strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
     : 1; // adler32(0, Z_NULL, 0)
    s.last_flush = $e68a320d790874a8$var$Z_NO_FLUSH;
    $5xHTP._tr_init(s);
    return $e68a320d790874a8$var$Z_OK;
}
function $e68a320d790874a8$var$deflateReset(strm) {
    var ret = $e68a320d790874a8$var$deflateResetKeep(strm);
    if (ret === $e68a320d790874a8$var$Z_OK) $e68a320d790874a8$var$lm_init(strm.state);
    return ret;
}
function $e68a320d790874a8$var$deflateSetHeader(strm, head) {
    if (!strm || !strm.state) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    if (strm.state.wrap !== 2) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    strm.state.gzhead = head;
    return $e68a320d790874a8$var$Z_OK;
}
function $e68a320d790874a8$var$deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
    if (!strm) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    var wrap = 1;
    if (level === $e68a320d790874a8$var$Z_DEFAULT_COMPRESSION) level = 6;
    if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else if (windowBits > 15) {
        wrap = 2; /* write gzip wrapper instead */ 
        windowBits -= 16;
    }
    if (memLevel < 1 || memLevel > $e68a320d790874a8$var$MAX_MEM_LEVEL || method !== $e68a320d790874a8$var$Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > $e68a320d790874a8$var$Z_FIXED) return $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_STREAM_ERROR);
    if (windowBits === 8) windowBits = 9;
    /* until 256-byte window bug fixed */ var s = new $e68a320d790874a8$var$DeflateState();
    strm.state = s;
    s.strm = strm;
    s.wrap = wrap;
    s.gzhead = null;
    s.w_bits = windowBits;
    s.w_size = 1 << s.w_bits;
    s.w_mask = s.w_size - 1;
    s.hash_bits = memLevel + 7;
    s.hash_size = 1 << s.hash_bits;
    s.hash_mask = s.hash_size - 1;
    s.hash_shift = ~~((s.hash_bits + $e68a320d790874a8$var$MIN_MATCH - 1) / $e68a320d790874a8$var$MIN_MATCH);
    s.window = new $8NmFQ.Buf8(s.w_size * 2);
    s.head = new $8NmFQ.Buf16(s.hash_size);
    s.prev = new $8NmFQ.Buf16(s.w_size);
    // Don't need mem init magic for JS.
    //s.high_water = 0;  /* nothing written to s->window yet */
    s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */ 
    s.pending_buf_size = s.lit_bufsize * 4;
    //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
    //s->pending_buf = (uchf *) overlay;
    s.pending_buf = new $8NmFQ.Buf8(s.pending_buf_size);
    // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
    //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
    s.d_buf = 1 * s.lit_bufsize;
    //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
    s.l_buf = 3 * s.lit_bufsize;
    s.level = level;
    s.strategy = strategy;
    s.method = method;
    return $e68a320d790874a8$var$deflateReset(strm);
}
function $e68a320d790874a8$var$deflateInit(strm, level) {
    return $e68a320d790874a8$var$deflateInit2(strm, level, $e68a320d790874a8$var$Z_DEFLATED, $e68a320d790874a8$var$MAX_WBITS, $e68a320d790874a8$var$DEF_MEM_LEVEL, $e68a320d790874a8$var$Z_DEFAULT_STRATEGY);
}
function $e68a320d790874a8$var$deflate(strm, flush) {
    var old_flush, s;
    var beg, val; // for gzip header write only
    if (!strm || !strm.state || flush > $e68a320d790874a8$var$Z_BLOCK || flush < 0) return strm ? $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_STREAM_ERROR) : $e68a320d790874a8$var$Z_STREAM_ERROR;
    s = strm.state;
    if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === $e68a320d790874a8$var$FINISH_STATE && flush !== $e68a320d790874a8$var$Z_FINISH) return $e68a320d790874a8$var$err(strm, strm.avail_out === 0 ? $e68a320d790874a8$var$Z_BUF_ERROR : $e68a320d790874a8$var$Z_STREAM_ERROR);
    s.strm = strm; /* just in case */ 
    old_flush = s.last_flush;
    s.last_flush = flush;
    /* Write the header */ if (s.status === $e68a320d790874a8$var$INIT_STATE) {
        if (s.wrap === 2) {
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            $e68a320d790874a8$var$put_byte(s, 31);
            $e68a320d790874a8$var$put_byte(s, 139);
            $e68a320d790874a8$var$put_byte(s, 8);
            if (!s.gzhead) {
                $e68a320d790874a8$var$put_byte(s, 0);
                $e68a320d790874a8$var$put_byte(s, 0);
                $e68a320d790874a8$var$put_byte(s, 0);
                $e68a320d790874a8$var$put_byte(s, 0);
                $e68a320d790874a8$var$put_byte(s, 0);
                $e68a320d790874a8$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $e68a320d790874a8$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $e68a320d790874a8$var$put_byte(s, $e68a320d790874a8$var$OS_CODE);
                s.status = $e68a320d790874a8$var$BUSY_STATE;
            } else {
                $e68a320d790874a8$var$put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
                $e68a320d790874a8$var$put_byte(s, s.gzhead.time & 0xff);
                $e68a320d790874a8$var$put_byte(s, s.gzhead.time >> 8 & 0xff);
                $e68a320d790874a8$var$put_byte(s, s.gzhead.time >> 16 & 0xff);
                $e68a320d790874a8$var$put_byte(s, s.gzhead.time >> 24 & 0xff);
                $e68a320d790874a8$var$put_byte(s, s.level === 9 ? 2 : s.strategy >= $e68a320d790874a8$var$Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
                $e68a320d790874a8$var$put_byte(s, s.gzhead.os & 0xff);
                if (s.gzhead.extra && s.gzhead.extra.length) {
                    $e68a320d790874a8$var$put_byte(s, s.gzhead.extra.length & 0xff);
                    $e68a320d790874a8$var$put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
                }
                if (s.gzhead.hcrc) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending, 0);
                s.gzindex = 0;
                s.status = $e68a320d790874a8$var$EXTRA_STATE;
            }
        } else {
            var header = $e68a320d790874a8$var$Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
            var level_flags = -1;
            if (s.strategy >= $e68a320d790874a8$var$Z_HUFFMAN_ONLY || s.level < 2) level_flags = 0;
            else if (s.level < 6) level_flags = 1;
            else if (s.level === 6) level_flags = 2;
            else level_flags = 3;
            header |= level_flags << 6;
            if (s.strstart !== 0) header |= $e68a320d790874a8$var$PRESET_DICT;
            header += 31 - header % 31;
            s.status = $e68a320d790874a8$var$BUSY_STATE;
            $e68a320d790874a8$var$putShortMSB(s, header);
            /* Save the adler32 of the preset dictionary: */ if (s.strstart !== 0) {
                $e68a320d790874a8$var$putShortMSB(s, strm.adler >>> 16);
                $e68a320d790874a8$var$putShortMSB(s, strm.adler & 0xffff);
            }
            strm.adler = 1; // adler32(0L, Z_NULL, 0);
        }
    }
    //#ifdef GZIP
    if (s.status === $e68a320d790874a8$var$EXTRA_STATE) {
        if (s.gzhead.extra /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            while(s.gzindex < (s.gzhead.extra.length & 0xffff)){
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e68a320d790874a8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) break;
                }
                $e68a320d790874a8$var$put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
                s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (s.gzindex === s.gzhead.extra.length) {
                s.gzindex = 0;
                s.status = $e68a320d790874a8$var$NAME_STATE;
            }
        } else s.status = $e68a320d790874a8$var$NAME_STATE;
    }
    if (s.status === $e68a320d790874a8$var$NAME_STATE) {
        if (s.gzhead.name /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e68a320d790874a8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.name.length) val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $e68a320d790874a8$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) {
                s.gzindex = 0;
                s.status = $e68a320d790874a8$var$COMMENT_STATE;
            }
        } else s.status = $e68a320d790874a8$var$COMMENT_STATE;
    }
    if (s.status === $e68a320d790874a8$var$COMMENT_STATE) {
        if (s.gzhead.comment /* != Z_NULL*/ ) {
            beg = s.pending; /* start of bytes to update crc */ 
            //int val;
            do {
                if (s.pending === s.pending_buf_size) {
                    if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
                    $e68a320d790874a8$var$flush_pending(strm);
                    beg = s.pending;
                    if (s.pending === s.pending_buf_size) {
                        val = 1;
                        break;
                    }
                }
                // JS specific: little magic to add zero terminator to end of string
                if (s.gzindex < s.gzhead.comment.length) val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
                else val = 0;
                $e68a320d790874a8$var$put_byte(s, val);
            }while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) strm.adler = $giZ5I(strm.adler, s.pending_buf, s.pending - beg, beg);
            if (val === 0) s.status = $e68a320d790874a8$var$HCRC_STATE;
        } else s.status = $e68a320d790874a8$var$HCRC_STATE;
    }
    if (s.status === $e68a320d790874a8$var$HCRC_STATE) {
        if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) $e68a320d790874a8$var$flush_pending(strm);
            if (s.pending + 2 <= s.pending_buf_size) {
                $e68a320d790874a8$var$put_byte(s, strm.adler & 0xff);
                $e68a320d790874a8$var$put_byte(s, strm.adler >> 8 & 0xff);
                strm.adler = 0; //crc32(0L, Z_NULL, 0);
                s.status = $e68a320d790874a8$var$BUSY_STATE;
            }
        } else s.status = $e68a320d790874a8$var$BUSY_STATE;
    }
    //#endif
    /* Flush as much pending output as possible */ if (s.pending !== 0) {
        $e68a320d790874a8$var$flush_pending(strm);
        if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
       * more output space, but possibly with both pending and
       * avail_in equal to zero. There won't be anything to do,
       * but this is not an error situation so make sure we
       * return OK instead of BUF_ERROR at next call of deflate:
       */ s.last_flush = -1;
            return $e68a320d790874a8$var$Z_OK;
        }
    /* Make sure there is something to do and avoid duplicate consecutive
     * flushes. For repeated and useless calls with Z_FINISH, we keep
     * returning Z_STREAM_END instead of Z_BUF_ERROR.
     */ } else if (strm.avail_in === 0 && $e68a320d790874a8$var$rank(flush) <= $e68a320d790874a8$var$rank(old_flush) && flush !== $e68a320d790874a8$var$Z_FINISH) return $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_BUF_ERROR);
    /* User must not provide more input after the first FINISH: */ if (s.status === $e68a320d790874a8$var$FINISH_STATE && strm.avail_in !== 0) return $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_BUF_ERROR);
    /* Start a new block or continue the current one.
   */ if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== $e68a320d790874a8$var$Z_NO_FLUSH && s.status !== $e68a320d790874a8$var$FINISH_STATE) {
        var bstate = s.strategy === $e68a320d790874a8$var$Z_HUFFMAN_ONLY ? $e68a320d790874a8$var$deflate_huff(s, flush) : s.strategy === $e68a320d790874a8$var$Z_RLE ? $e68a320d790874a8$var$deflate_rle(s, flush) : $e68a320d790874a8$var$configuration_table[s.level].func(s, flush);
        if (bstate === $e68a320d790874a8$var$BS_FINISH_STARTED || bstate === $e68a320d790874a8$var$BS_FINISH_DONE) s.status = $e68a320d790874a8$var$FINISH_STATE;
        if (bstate === $e68a320d790874a8$var$BS_NEED_MORE || bstate === $e68a320d790874a8$var$BS_FINISH_STARTED) {
            if (strm.avail_out === 0) s.last_flush = -1;
            return $e68a320d790874a8$var$Z_OK;
        /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
       * of deflate should use the same flush parameter to make sure
       * that the flush is complete. So we don't have to output an
       * empty block here, this will be done at next call. This also
       * ensures that for a very small output buffer, we emit at most
       * one empty block.
       */ }
        if (bstate === $e68a320d790874a8$var$BS_BLOCK_DONE) {
            if (flush === $e68a320d790874a8$var$Z_PARTIAL_FLUSH) $5xHTP._tr_align(s);
            else if (flush !== $e68a320d790874a8$var$Z_BLOCK) {
                $5xHTP._tr_stored_block(s, 0, 0, false);
                /* For a full flush, this empty block will be recognized
         * as a special marker by inflate_sync().
         */ if (flush === $e68a320d790874a8$var$Z_FULL_FLUSH) {
                    /*** CLEAR_HASH(s); ***/ /* forget history */ $e68a320d790874a8$var$zero(s.head); // Fill with NIL (= 0);
                    if (s.lookahead === 0) {
                        s.strstart = 0;
                        s.block_start = 0;
                        s.insert = 0;
                    }
                }
            }
            $e68a320d790874a8$var$flush_pending(strm);
            if (strm.avail_out === 0) {
                s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */ 
                return $e68a320d790874a8$var$Z_OK;
            }
        }
    }
    //Assert(strm->avail_out > 0, "bug2");
    //if (strm.avail_out <= 0) { throw new Error("bug2");}
    if (flush !== $e68a320d790874a8$var$Z_FINISH) return $e68a320d790874a8$var$Z_OK;
    if (s.wrap <= 0) return $e68a320d790874a8$var$Z_STREAM_END;
    /* Write the trailer */ if (s.wrap === 2) {
        $e68a320d790874a8$var$put_byte(s, strm.adler & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.adler >> 8 & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.adler >> 16 & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.adler >> 24 & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.total_in & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.total_in >> 8 & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.total_in >> 16 & 0xff);
        $e68a320d790874a8$var$put_byte(s, strm.total_in >> 24 & 0xff);
    } else {
        $e68a320d790874a8$var$putShortMSB(s, strm.adler >>> 16);
        $e68a320d790874a8$var$putShortMSB(s, strm.adler & 0xffff);
    }
    $e68a320d790874a8$var$flush_pending(strm);
    /* If avail_out is zero, the application will call deflate again
   * to flush the rest.
   */ if (s.wrap > 0) s.wrap = -s.wrap;
    /* write the trailer only once! */ return s.pending !== 0 ? $e68a320d790874a8$var$Z_OK : $e68a320d790874a8$var$Z_STREAM_END;
}
function $e68a320d790874a8$var$deflateEnd(strm) {
    var status;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    status = strm.state.status;
    if (status !== $e68a320d790874a8$var$INIT_STATE && status !== $e68a320d790874a8$var$EXTRA_STATE && status !== $e68a320d790874a8$var$NAME_STATE && status !== $e68a320d790874a8$var$COMMENT_STATE && status !== $e68a320d790874a8$var$HCRC_STATE && status !== $e68a320d790874a8$var$BUSY_STATE && status !== $e68a320d790874a8$var$FINISH_STATE) return $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_STREAM_ERROR);
    strm.state = null;
    return status === $e68a320d790874a8$var$BUSY_STATE ? $e68a320d790874a8$var$err(strm, $e68a320d790874a8$var$Z_DATA_ERROR) : $e68a320d790874a8$var$Z_OK;
}
/* =========================================================================
 * Initializes the compression dictionary from the given byte
 * sequence without producing any compressed output.
 */ function $e68a320d790874a8$var$deflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var s;
    var str, n;
    var wrap;
    var avail;
    var next;
    var input;
    var tmpDict;
    if (!strm /*== Z_NULL*/  || !strm.state /*== Z_NULL*/ ) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    s = strm.state;
    wrap = s.wrap;
    if (wrap === 2 || wrap === 1 && s.status !== $e68a320d790874a8$var$INIT_STATE || s.lookahead) return $e68a320d790874a8$var$Z_STREAM_ERROR;
    /* when using zlib wrappers, compute Adler-32 for provided dictionary */ if (wrap === 1) /* adler32(strm->adler, dictionary, dictLength); */ strm.adler = $jnGJc(strm.adler, dictionary, dictLength, 0);
    s.wrap = 0; /* avoid computing Adler-32 in read_buf */ 
    /* if dictionary would fill window, just replace the history */ if (dictLength >= s.w_size) {
        if (wrap === 0) {
            /*** CLEAR_HASH(s); ***/ $e68a320d790874a8$var$zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
        }
        /* use the tail */ // dictionary = dictionary.slice(dictLength - s.w_size);
        tmpDict = new $8NmFQ.Buf8(s.w_size);
        $8NmFQ.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
        dictionary = tmpDict;
        dictLength = s.w_size;
    }
    /* insert dictionary into window and hash */ avail = strm.avail_in;
    next = strm.next_in;
    input = strm.input;
    strm.avail_in = dictLength;
    strm.next_in = 0;
    strm.input = dictionary;
    $e68a320d790874a8$var$fill_window(s);
    while(s.lookahead >= $e68a320d790874a8$var$MIN_MATCH){
        str = s.strstart;
        n = s.lookahead - ($e68a320d790874a8$var$MIN_MATCH - 1);
        do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */ s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + $e68a320d790874a8$var$MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
        }while (--n);
        s.strstart = str;
        s.lookahead = $e68a320d790874a8$var$MIN_MATCH - 1;
        $e68a320d790874a8$var$fill_window(s);
    }
    s.strstart += s.lookahead;
    s.block_start = s.strstart;
    s.insert = s.lookahead;
    s.lookahead = 0;
    s.match_length = s.prev_length = $e68a320d790874a8$var$MIN_MATCH - 1;
    s.match_available = 0;
    strm.next_in = next;
    strm.input = input;
    strm.avail_in = avail;
    s.wrap = wrap;
    return $e68a320d790874a8$var$Z_OK;
}
$e68a320d790874a8$export$72b35d618fb8ad9b = $e68a320d790874a8$var$deflateInit;
$e68a320d790874a8$export$a65c7b2bde87cb70 = $e68a320d790874a8$var$deflateInit2;
$e68a320d790874a8$export$8f99f0e30bc7dd53 = $e68a320d790874a8$var$deflateReset;
$e68a320d790874a8$export$e78fab288549509 = $e68a320d790874a8$var$deflateResetKeep;
$e68a320d790874a8$export$1cd50f7b2515ba19 = $e68a320d790874a8$var$deflateSetHeader;
$e68a320d790874a8$export$2316623ecd1285ab = $e68a320d790874a8$var$deflate;
$e68a320d790874a8$export$599854fa319a815f = $e68a320d790874a8$var$deflateEnd;
$e68a320d790874a8$export$f55e0b3ab66b5d46 = $e68a320d790874a8$var$deflateSetDictionary;
$e68a320d790874a8$export$12b6e1fcadea22f9 = 'pako deflate (from Nodeca project)'; /* Not implemented
exports.deflateBound = deflateBound;
exports.deflateCopy = deflateCopy;
exports.deflateParams = deflateParams;
exports.deflatePending = deflatePending;
exports.deflatePrime = deflatePrime;
exports.deflateTune = deflateTune;
*/ 

});
parcelRegister("8NmFQ", function(module, exports) {
'use strict';
var $66747cea8cf5ac4e$var$TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
function $66747cea8cf5ac4e$var$_has(obj, key) {
    return Object.prototype.hasOwnProperty.call(obj, key);
}
module.exports.assign = function(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    while(sources.length){
        var source = sources.shift();
        if (!source) continue;
        if (typeof source !== 'object') throw new TypeError(source + 'must be non-object');
        for(var p in source)if ($66747cea8cf5ac4e$var$_has(source, p)) obj[p] = source[p];
    }
    return obj;
};
// reduce buffer size, avoiding mem copy
module.exports.shrinkBuf = function(buf, size) {
    if (buf.length === size) return buf;
    if (buf.subarray) return buf.subarray(0, size);
    buf.length = size;
    return buf;
};
var $66747cea8cf5ac4e$var$fnTyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
        }
        // Fallback to ordinary array
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        var i, l, len, pos, chunk, result;
        // calculate data length
        len = 0;
        for(i = 0, l = chunks.length; i < l; i++)len += chunks[i].length;
        // join chunks
        result = new Uint8Array(len);
        pos = 0;
        for(i = 0, l = chunks.length; i < l; i++){
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
        }
        return result;
    }
};
var $66747cea8cf5ac4e$var$fnUntyped = {
    arraySet: function(dest, src, src_offs, len, dest_offs) {
        for(var i = 0; i < len; i++)dest[dest_offs + i] = src[src_offs + i];
    },
    // Join array of chunks to single array.
    flattenChunks: function(chunks) {
        return [].concat.apply([], chunks);
    }
};
// Enable/Disable typed arrays use, for testing
//
module.exports.setTyped = function(on) {
    if (on) {
        module.exports.Buf8 = Uint8Array;
        module.exports.Buf16 = Uint16Array;
        module.exports.Buf32 = Int32Array;
        module.exports.assign(module.exports, $66747cea8cf5ac4e$var$fnTyped);
    } else {
        module.exports.Buf8 = Array;
        module.exports.Buf16 = Array;
        module.exports.Buf32 = Array;
        module.exports.assign(module.exports, $66747cea8cf5ac4e$var$fnUntyped);
    }
};
module.exports.setTyped($66747cea8cf5ac4e$var$TYPED_OK);

});

parcelRegister("5xHTP", function(module, exports) {

$parcel$export(module.exports, "_tr_init", function () { return $409216557d5023de$export$4e4fc0157c3cd14d; }, function (v) { return $409216557d5023de$export$4e4fc0157c3cd14d = v; });
$parcel$export(module.exports, "_tr_stored_block", function () { return $409216557d5023de$export$8959e34c5e020172; }, function (v) { return $409216557d5023de$export$8959e34c5e020172 = v; });
$parcel$export(module.exports, "_tr_flush_block", function () { return $409216557d5023de$export$44f15b52eef0cf41; }, function (v) { return $409216557d5023de$export$44f15b52eef0cf41 = v; });
$parcel$export(module.exports, "_tr_tally", function () { return $409216557d5023de$export$b3cbce147289408f; }, function (v) { return $409216557d5023de$export$b3cbce147289408f = v; });
$parcel$export(module.exports, "_tr_align", function () { return $409216557d5023de$export$bfb360e02ee9b403; }, function (v) { return $409216557d5023de$export$bfb360e02ee9b403 = v; });
var $409216557d5023de$export$4e4fc0157c3cd14d;
var $409216557d5023de$export$8959e34c5e020172;
var $409216557d5023de$export$44f15b52eef0cf41;
var $409216557d5023de$export$b3cbce147289408f;
var $409216557d5023de$export$bfb360e02ee9b403;
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");
/* Public constants ==========================================================*/ /* ===========================================================================*/ //var Z_FILTERED          = 1;
//var Z_HUFFMAN_ONLY      = 2;
//var Z_RLE               = 3;
var $409216557d5023de$var$Z_FIXED = 4;
//var Z_DEFAULT_STRATEGY  = 0;
/* Possible values of the data_type field (though see inflate()) */ var $409216557d5023de$var$Z_BINARY = 0;
var $409216557d5023de$var$Z_TEXT = 1;
//var Z_ASCII             = 1; // = Z_TEXT
var $409216557d5023de$var$Z_UNKNOWN = 2;
/*============================================================================*/ function $409216557d5023de$var$zero(buf) {
    var len = buf.length;
    while(--len >= 0)buf[len] = 0;
}
// From zutil.h
var $409216557d5023de$var$STORED_BLOCK = 0;
var $409216557d5023de$var$STATIC_TREES = 1;
var $409216557d5023de$var$DYN_TREES = 2;
/* The three kinds of block type */ var $409216557d5023de$var$MIN_MATCH = 3;
var $409216557d5023de$var$MAX_MATCH = 258;
/* The minimum and maximum match lengths */ // From deflate.h
/* ===========================================================================
 * Internal compression state.
 */ var $409216557d5023de$var$LENGTH_CODES = 29;
/* number of length codes, not counting the special END_BLOCK code */ var $409216557d5023de$var$LITERALS = 256;
/* number of literal bytes 0..255 */ var $409216557d5023de$var$L_CODES = $409216557d5023de$var$LITERALS + 1 + $409216557d5023de$var$LENGTH_CODES;
/* number of Literal or Length codes, including the END_BLOCK code */ var $409216557d5023de$var$D_CODES = 30;
/* number of distance codes */ var $409216557d5023de$var$BL_CODES = 19;
/* number of codes used to transfer the bit lengths */ var $409216557d5023de$var$HEAP_SIZE = 2 * $409216557d5023de$var$L_CODES + 1;
/* maximum heap size */ var $409216557d5023de$var$MAX_BITS = 15;
/* All codes must not exceed MAX_BITS bits */ var $409216557d5023de$var$Buf_size = 16;
/* size of bit buffer in bi_buf */ /* ===========================================================================
 * Constants
 */ var $409216557d5023de$var$MAX_BL_BITS = 7;
/* Bit length codes must not exceed MAX_BL_BITS bits */ var $409216557d5023de$var$END_BLOCK = 256;
/* end of block literal code */ var $409216557d5023de$var$REP_3_6 = 16;
/* repeat previous bit length 3-6 times (2 bits of repeat count) */ var $409216557d5023de$var$REPZ_3_10 = 17;
/* repeat a zero length 3-10 times  (3 bits of repeat count) */ var $409216557d5023de$var$REPZ_11_138 = 18;
/* repeat a zero length 11-138 times  (7 bits of repeat count) */ /* eslint-disable comma-spacing,array-bracket-spacing */ var $409216557d5023de$var$extra_lbits = /* extra bits for each length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    0
];
var $409216557d5023de$var$extra_dbits = /* extra bits for each distance code */ [
    0,
    0,
    0,
    0,
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
    9,
    9,
    10,
    10,
    11,
    11,
    12,
    12,
    13,
    13
];
var $409216557d5023de$var$extra_blbits = /* extra bits for each bit length code */ [
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    3,
    7
];
var $409216557d5023de$var$bl_order = [
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
];
/* eslint-enable comma-spacing,array-bracket-spacing */ /* The lengths of the bit length codes are sent in order of decreasing
 * probability, to avoid transmitting the lengths for unused bit length codes.
 */ /* ===========================================================================
 * Local data. These are initialized only once.
 */ // We pre-fill arrays with 0 to avoid uninitialized gaps
var $409216557d5023de$var$DIST_CODE_LEN = 512; /* see definition of array dist_code below */ 
// !!!! Use flat array instead of structure, Freq = i*2, Len = i*2+1
var $409216557d5023de$var$static_ltree = new Array(($409216557d5023de$var$L_CODES + 2) * 2);
$409216557d5023de$var$zero($409216557d5023de$var$static_ltree);
/* The static literal tree. Since the bit lengths are imposed, there is no
 * need for the L_CODES extra codes used during heap construction. However
 * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
 * below).
 */ var $409216557d5023de$var$static_dtree = new Array($409216557d5023de$var$D_CODES * 2);
$409216557d5023de$var$zero($409216557d5023de$var$static_dtree);
/* The static distance tree. (Actually a trivial tree since all codes use
 * 5 bits.)
 */ var $409216557d5023de$var$_dist_code = new Array($409216557d5023de$var$DIST_CODE_LEN);
$409216557d5023de$var$zero($409216557d5023de$var$_dist_code);
/* Distance codes. The first 256 values correspond to the distances
 * 3 .. 258, the last 256 values correspond to the top 8 bits of
 * the 15 bit distances.
 */ var $409216557d5023de$var$_length_code = new Array($409216557d5023de$var$MAX_MATCH - $409216557d5023de$var$MIN_MATCH + 1);
$409216557d5023de$var$zero($409216557d5023de$var$_length_code);
/* length code for each normalized match length (0 == MIN_MATCH) */ var $409216557d5023de$var$base_length = new Array($409216557d5023de$var$LENGTH_CODES);
$409216557d5023de$var$zero($409216557d5023de$var$base_length);
/* First normalized length for each code (0 = MIN_MATCH) */ var $409216557d5023de$var$base_dist = new Array($409216557d5023de$var$D_CODES);
$409216557d5023de$var$zero($409216557d5023de$var$base_dist);
/* First normalized distance for each code (0 = distance of 1) */ function $409216557d5023de$var$StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
    this.static_tree = static_tree; /* static tree or NULL */ 
    this.extra_bits = extra_bits; /* extra bits for each code or NULL */ 
    this.extra_base = extra_base; /* base index for extra_bits */ 
    this.elems = elems; /* max number of elements in the tree */ 
    this.max_length = max_length; /* max bit length for the codes */ 
    // show if `static_tree` has data or dummy - needed for monomorphic objects
    this.has_stree = static_tree && static_tree.length;
}
var $409216557d5023de$var$static_l_desc;
var $409216557d5023de$var$static_d_desc;
var $409216557d5023de$var$static_bl_desc;
function $409216557d5023de$var$TreeDesc(dyn_tree, stat_desc) {
    this.dyn_tree = dyn_tree; /* the dynamic tree */ 
    this.max_code = 0; /* largest code with non zero frequency */ 
    this.stat_desc = stat_desc; /* the corresponding static tree */ 
}
function $409216557d5023de$var$d_code(dist) {
    return dist < 256 ? $409216557d5023de$var$_dist_code[dist] : $409216557d5023de$var$_dist_code[256 + (dist >>> 7)];
}
/* ===========================================================================
 * Output a short LSB first on the stream.
 * IN assertion: there is enough room in pendingBuf.
 */ function $409216557d5023de$var$put_short(s, w) {
    //    put_byte(s, (uch)((w) & 0xff));
    //    put_byte(s, (uch)((ush)(w) >> 8));
    s.pending_buf[s.pending++] = w & 0xff;
    s.pending_buf[s.pending++] = w >>> 8 & 0xff;
}
/* ===========================================================================
 * Send a value on a given number of bits.
 * IN assertion: length <= 16 and value fits in length bits.
 */ function $409216557d5023de$var$send_bits(s, value, length) {
    if (s.bi_valid > $409216557d5023de$var$Buf_size - length) {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        $409216557d5023de$var$put_short(s, s.bi_buf);
        s.bi_buf = value >> $409216557d5023de$var$Buf_size - s.bi_valid;
        s.bi_valid += length - $409216557d5023de$var$Buf_size;
    } else {
        s.bi_buf |= value << s.bi_valid & 0xffff;
        s.bi_valid += length;
    }
}
function $409216557d5023de$var$send_code(s, c, tree) {
    $409216557d5023de$var$send_bits(s, tree[c * 2], tree[c * 2 + 1]);
}
/* ===========================================================================
 * Reverse the first len bits of a code, using straightforward code (a faster
 * method would use a table)
 * IN assertion: 1 <= len <= 15
 */ function $409216557d5023de$var$bi_reverse(code, len) {
    var res = 0;
    do {
        res |= code & 1;
        code >>>= 1;
        res <<= 1;
    }while (--len > 0);
    return res >>> 1;
}
/* ===========================================================================
 * Flush the bit buffer, keeping at most 7 bits in it.
 */ function $409216557d5023de$var$bi_flush(s) {
    if (s.bi_valid === 16) {
        $409216557d5023de$var$put_short(s, s.bi_buf);
        s.bi_buf = 0;
        s.bi_valid = 0;
    } else if (s.bi_valid >= 8) {
        s.pending_buf[s.pending++] = s.bi_buf & 0xff;
        s.bi_buf >>= 8;
        s.bi_valid -= 8;
    }
}
/* ===========================================================================
 * Compute the optimal bit lengths for a tree and update the total bit length
 * for the current block.
 * IN assertion: the fields freq and dad are set, heap[heap_max] and
 *    above are the tree nodes sorted by increasing frequency.
 * OUT assertions: the field len is set to the optimal bit length, the
 *     array bl_count contains the frequencies for each bit length.
 *     The length opt_len is updated; static_len is also updated if stree is
 *     not null.
 */ function $409216557d5023de$var$gen_bitlen(s, desc) //    deflate_state *s;
//    tree_desc *desc;    /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var max_code = desc.max_code;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var extra = desc.stat_desc.extra_bits;
    var base = desc.stat_desc.extra_base;
    var max_length = desc.stat_desc.max_length;
    var h; /* heap index */ 
    var n, m; /* iterate over the tree elements */ 
    var bits; /* bit length */ 
    var xbits; /* extra bits */ 
    var f; /* frequency */ 
    var overflow = 0; /* number of elements with bit length too large */ 
    for(bits = 0; bits <= $409216557d5023de$var$MAX_BITS; bits++)s.bl_count[bits] = 0;
    /* In a first pass, compute the optimal bit lengths (which may
   * overflow in the case of the bit length tree).
   */ tree[s.heap[s.heap_max] * 2 + 1] = 0; /* root of the heap */ 
    for(h = s.heap_max + 1; h < $409216557d5023de$var$HEAP_SIZE; h++){
        n = s.heap[h];
        bits = tree[tree[n * 2 + 1] * 2 + 1] + 1;
        if (bits > max_length) {
            bits = max_length;
            overflow++;
        }
        tree[n * 2 + 1] = bits;
        /* We overwrite tree[n].Dad which is no longer needed */ if (n > max_code) continue;
         /* not a leaf node */ 
        s.bl_count[bits]++;
        xbits = 0;
        if (n >= base) xbits = extra[n - base];
        f = tree[n * 2] /*.Freq*/ ;
        s.opt_len += f * (bits + xbits);
        if (has_stree) s.static_len += f * (stree[n * 2 + 1] + xbits);
    }
    if (overflow === 0) return;
    // Trace((stderr,"\nbit length overflow\n"));
    /* This happens for example on obj2 and pic of the Calgary corpus */ /* Find the first bit length which could increase: */ do {
        bits = max_length - 1;
        while(s.bl_count[bits] === 0)bits--;
        s.bl_count[bits]--; /* move one leaf down the tree */ 
        s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */ 
        s.bl_count[max_length]--;
        /* The brother of the overflow item also moves one step up,
     * but this does not affect bl_count[max_length]
     */ overflow -= 2;
    }while (overflow > 0);
    /* Now recompute all bit lengths, scanning in increasing frequency.
   * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
   * lengths instead of fixing only the wrong ones. This idea is taken
   * from 'ar' written by Haruhiko Okumura.)
   */ for(bits = max_length; bits !== 0; bits--){
        n = s.bl_count[bits];
        while(n !== 0){
            m = s.heap[--h];
            if (m > max_code) continue;
            if (tree[m * 2 + 1] !== bits) {
                // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
                s.opt_len += (bits - tree[m * 2 + 1]) * tree[m * 2] /*.Freq*/ ;
                tree[m * 2 + 1] = bits;
            }
            n--;
        }
    }
}
/* ===========================================================================
 * Generate the codes for a given tree and bit counts (which need not be
 * optimal).
 * IN assertion: the array bl_count contains the bit length statistics for
 * the given tree and the field len is set for all tree elements.
 * OUT assertion: the field code is set for all tree elements of non
 *     zero code length.
 */ function $409216557d5023de$var$gen_codes(tree, max_code, bl_count) //    ct_data *tree;             /* the tree to decorate */
//    int max_code;              /* largest code with non zero frequency */
//    ushf *bl_count;            /* number of codes at each bit length */
{
    var next_code = new Array($409216557d5023de$var$MAX_BITS + 1); /* next code value for each bit length */ 
    var code = 0; /* running code value */ 
    var bits; /* bit index */ 
    var n; /* code index */ 
    /* The distribution counts are first used to generate the code values
   * without bit reversal.
   */ for(bits = 1; bits <= $409216557d5023de$var$MAX_BITS; bits++)next_code[bits] = code = code + bl_count[bits - 1] << 1;
    /* Check that the bit counts in bl_count are consistent. The last code
   * must be all ones.
   */ //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
    //        "inconsistent bit counts");
    //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));
    for(n = 0; n <= max_code; n++){
        var len = tree[n * 2 + 1] /*.Len*/ ;
        if (len === 0) continue;
        /* Now reverse the bits */ tree[n * 2] = $409216557d5023de$var$bi_reverse(next_code[len]++, len);
    //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
    //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
    }
}
/* ===========================================================================
 * Initialize the various 'constant' tables.
 */ function $409216557d5023de$var$tr_static_init() {
    var n; /* iterates over tree elements */ 
    var bits; /* bit counter */ 
    var length; /* length value */ 
    var code; /* code value */ 
    var dist; /* distance index */ 
    var bl_count = new Array($409216557d5023de$var$MAX_BITS + 1);
    /* number of codes at each bit length for an optimal tree */ // do check in _tr_init()
    //if (static_init_done) return;
    /* For some embedded targets, global variables are not initialized: */ /*#ifdef NO_INIT_GLOBAL_POINTERS
  static_l_desc.static_tree = static_ltree;
  static_l_desc.extra_bits = extra_lbits;
  static_d_desc.static_tree = static_dtree;
  static_d_desc.extra_bits = extra_dbits;
  static_bl_desc.extra_bits = extra_blbits;
#endif*/ /* Initialize the mapping length (0..255) -> length code (0..28) */ length = 0;
    for(code = 0; code < $409216557d5023de$var$LENGTH_CODES - 1; code++){
        $409216557d5023de$var$base_length[code] = length;
        for(n = 0; n < 1 << $409216557d5023de$var$extra_lbits[code]; n++)$409216557d5023de$var$_length_code[length++] = code;
    }
    //Assert (length == 256, "tr_static_init: length != 256");
    /* Note that the length 255 (match length 258) can be represented
   * in two different ways: code 284 + 5 bits or code 285, so we
   * overwrite length_code[255] to use the best encoding:
   */ $409216557d5023de$var$_length_code[length - 1] = code;
    /* Initialize the mapping dist (0..32K) -> dist code (0..29) */ dist = 0;
    for(code = 0; code < 16; code++){
        $409216557d5023de$var$base_dist[code] = dist;
        for(n = 0; n < 1 << $409216557d5023de$var$extra_dbits[code]; n++)$409216557d5023de$var$_dist_code[dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: dist != 256");
    dist >>= 7; /* from now on, all distances are divided by 128 */ 
    for(; code < $409216557d5023de$var$D_CODES; code++){
        $409216557d5023de$var$base_dist[code] = dist << 7;
        for(n = 0; n < 1 << $409216557d5023de$var$extra_dbits[code] - 7; n++)$409216557d5023de$var$_dist_code[256 + dist++] = code;
    }
    //Assert (dist == 256, "tr_static_init: 256+dist != 512");
    /* Construct the codes of the static literal tree */ for(bits = 0; bits <= $409216557d5023de$var$MAX_BITS; bits++)bl_count[bits] = 0;
    n = 0;
    while(n <= 143){
        $409216557d5023de$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    while(n <= 255){
        $409216557d5023de$var$static_ltree[n * 2 + 1] = 9;
        n++;
        bl_count[9]++;
    }
    while(n <= 279){
        $409216557d5023de$var$static_ltree[n * 2 + 1] = 7;
        n++;
        bl_count[7]++;
    }
    while(n <= 287){
        $409216557d5023de$var$static_ltree[n * 2 + 1] = 8;
        n++;
        bl_count[8]++;
    }
    /* Codes 286 and 287 do not exist, but we must include them in the
   * tree construction to get a canonical Huffman tree (longest code
   * all ones)
   */ $409216557d5023de$var$gen_codes($409216557d5023de$var$static_ltree, $409216557d5023de$var$L_CODES + 1, bl_count);
    /* The static distance tree is trivial: */ for(n = 0; n < $409216557d5023de$var$D_CODES; n++){
        $409216557d5023de$var$static_dtree[n * 2 + 1] = 5;
        $409216557d5023de$var$static_dtree[n * 2] = $409216557d5023de$var$bi_reverse(n, 5);
    }
    // Now data ready and we can init static trees
    $409216557d5023de$var$static_l_desc = new $409216557d5023de$var$StaticTreeDesc($409216557d5023de$var$static_ltree, $409216557d5023de$var$extra_lbits, $409216557d5023de$var$LITERALS + 1, $409216557d5023de$var$L_CODES, $409216557d5023de$var$MAX_BITS);
    $409216557d5023de$var$static_d_desc = new $409216557d5023de$var$StaticTreeDesc($409216557d5023de$var$static_dtree, $409216557d5023de$var$extra_dbits, 0, $409216557d5023de$var$D_CODES, $409216557d5023de$var$MAX_BITS);
    $409216557d5023de$var$static_bl_desc = new $409216557d5023de$var$StaticTreeDesc(new Array(0), $409216557d5023de$var$extra_blbits, 0, $409216557d5023de$var$BL_CODES, $409216557d5023de$var$MAX_BL_BITS);
//static_init_done = true;
}
/* ===========================================================================
 * Initialize a new block.
 */ function $409216557d5023de$var$init_block(s) {
    var n; /* iterates over tree elements */ 
    /* Initialize the trees. */ for(n = 0; n < $409216557d5023de$var$L_CODES; n++)s.dyn_ltree[n * 2] = 0;
    for(n = 0; n < $409216557d5023de$var$D_CODES; n++)s.dyn_dtree[n * 2] = 0;
    for(n = 0; n < $409216557d5023de$var$BL_CODES; n++)s.bl_tree[n * 2] = 0;
    s.dyn_ltree[$409216557d5023de$var$END_BLOCK * 2] = 1;
    s.opt_len = s.static_len = 0;
    s.last_lit = s.matches = 0;
}
/* ===========================================================================
 * Flush the bit buffer and align the output on a byte boundary
 */ function $409216557d5023de$var$bi_windup(s) {
    if (s.bi_valid > 8) $409216557d5023de$var$put_short(s, s.bi_buf);
    else if (s.bi_valid > 0) //put_byte(s, (Byte)s->bi_buf);
    s.pending_buf[s.pending++] = s.bi_buf;
    s.bi_buf = 0;
    s.bi_valid = 0;
}
/* ===========================================================================
 * Copy a stored block, storing first the length and its
 * one's complement if requested.
 */ function $409216557d5023de$var$copy_block(s, buf, len, header) //DeflateState *s;
//charf    *buf;    /* the input data */
//unsigned len;     /* its length */
//int      header;  /* true if block header must be written */
{
    $409216557d5023de$var$bi_windup(s); /* align on byte boundary */ 
    if (header) {
        $409216557d5023de$var$put_short(s, len);
        $409216557d5023de$var$put_short(s, ~len);
    }
    //  while (len--) {
    //    put_byte(s, *buf++);
    //  }
    $8NmFQ.arraySet(s.pending_buf, s.window, buf, len, s.pending);
    s.pending += len;
}
/* ===========================================================================
 * Compares to subtrees, using the tree depth as tie breaker when
 * the subtrees have equal frequency. This minimizes the worst case length.
 */ function $409216557d5023de$var$smaller(tree, n, m, depth) {
    var _n2 = n * 2;
    var _m2 = m * 2;
    return tree[_n2] < tree[_m2] || tree[_n2] === tree[_m2] && depth[n] <= depth[m];
}
/* ===========================================================================
 * Restore the heap property by moving down the tree starting at node k,
 * exchanging a node with the smallest of its two sons if necessary, stopping
 * when the heap property is re-established (each father smaller than its
 * two sons).
 */ function $409216557d5023de$var$pqdownheap(s, tree, k) //    deflate_state *s;
//    ct_data *tree;  /* the tree to restore */
//    int k;               /* node to move down */
{
    var v = s.heap[k];
    var j = k << 1; /* left son of k */ 
    while(j <= s.heap_len){
        /* Set j to the smallest of the two sons: */ if (j < s.heap_len && $409216557d5023de$var$smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) j++;
        /* Exit if v is smaller than both sons */ if ($409216557d5023de$var$smaller(tree, v, s.heap[j], s.depth)) break;
        /* Exchange v with the smallest son */ s.heap[k] = s.heap[j];
        k = j;
        /* And continue down the tree, setting j to the left son of k */ j <<= 1;
    }
    s.heap[k] = v;
}
// inlined manually
// var SMALLEST = 1;
/* ===========================================================================
 * Send the block data compressed using the given Huffman trees
 */ function $409216557d5023de$var$compress_block(s, ltree, dtree) //    deflate_state *s;
//    const ct_data *ltree; /* literal tree */
//    const ct_data *dtree; /* distance tree */
{
    var dist; /* distance of matched string */ 
    var lc; /* match length or unmatched char (if dist == 0) */ 
    var lx = 0; /* running index in l_buf */ 
    var code; /* the code to send */ 
    var extra; /* number of extra bits to send */ 
    if (s.last_lit !== 0) do {
        dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
        lc = s.pending_buf[s.l_buf + lx];
        lx++;
        if (dist === 0) $409216557d5023de$var$send_code(s, lc, ltree); /* send a literal byte */ 
        else {
            /* Here, lc is the match length - MIN_MATCH */ code = $409216557d5023de$var$_length_code[lc];
            $409216557d5023de$var$send_code(s, code + $409216557d5023de$var$LITERALS + 1, ltree); /* send the length code */ 
            extra = $409216557d5023de$var$extra_lbits[code];
            if (extra !== 0) {
                lc -= $409216557d5023de$var$base_length[code];
                $409216557d5023de$var$send_bits(s, lc, extra); /* send the extra length bits */ 
            }
            dist--; /* dist is now the match distance - 1 */ 
            code = $409216557d5023de$var$d_code(dist);
            //Assert (code < D_CODES, "bad d_code");
            $409216557d5023de$var$send_code(s, code, dtree); /* send the distance code */ 
            extra = $409216557d5023de$var$extra_dbits[code];
            if (extra !== 0) {
                dist -= $409216557d5023de$var$base_dist[code];
                $409216557d5023de$var$send_bits(s, dist, extra); /* send the extra distance bits */ 
            }
        } /* literal or match pair ? */ 
    /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */ //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
    //       "pendingBuf overflow");
    }while (lx < s.last_lit);
    $409216557d5023de$var$send_code(s, $409216557d5023de$var$END_BLOCK, ltree);
}
/* ===========================================================================
 * Construct one Huffman tree and assigns the code bit strings and lengths.
 * Update the total bit length for the current block.
 * IN assertion: the field freq is set for all tree elements.
 * OUT assertions: the fields len and code are set to the optimal bit length
 *     and corresponding code. The length opt_len is updated; static_len is
 *     also updated if stree is not null. The field max_code is set.
 */ function $409216557d5023de$var$build_tree(s, desc) //    deflate_state *s;
//    tree_desc *desc; /* the tree descriptor */
{
    var tree = desc.dyn_tree;
    var stree = desc.stat_desc.static_tree;
    var has_stree = desc.stat_desc.has_stree;
    var elems = desc.stat_desc.elems;
    var n, m; /* iterate over heap elements */ 
    var max_code = -1; /* largest code with non zero frequency */ 
    var node; /* new node being created */ 
    /* Construct the initial heap, with least frequent element in
   * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
   * heap[0] is not used.
   */ s.heap_len = 0;
    s.heap_max = $409216557d5023de$var$HEAP_SIZE;
    for(n = 0; n < elems; n++)if (tree[n * 2] !== 0) {
        s.heap[++s.heap_len] = max_code = n;
        s.depth[n] = 0;
    } else tree[n * 2 + 1] = 0;
    /* The pkzip format requires that at least one distance code exists,
   * and that at least one bit should be sent even if there is only one
   * possible code. So to avoid special checks later on we force at least
   * two codes of non zero frequency.
   */ while(s.heap_len < 2){
        node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
        tree[node * 2] = 1;
        s.depth[node] = 0;
        s.opt_len--;
        if (has_stree) s.static_len -= stree[node * 2 + 1] /*.Len*/ ;
    /* node is 0 or 1 so it does not have extra bits */ }
    desc.max_code = max_code;
    /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
   * establish sub-heaps of increasing lengths:
   */ for(n = s.heap_len >> 1 /*int /2*/ ; n >= 1; n--)$409216557d5023de$var$pqdownheap(s, tree, n);
    /* Construct the Huffman tree by repeatedly combining the least two
   * frequent nodes.
   */ node = elems; /* next internal node of the tree */ 
    do {
        //pqremove(s, tree, n);  /* n = node of least frequency */
        /*** pqremove ***/ n = s.heap[1 /*SMALLEST*/ ];
        s.heap[1 /*SMALLEST*/ ] = s.heap[s.heap_len--];
        $409216557d5023de$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
        /***/ m = s.heap[1 /*SMALLEST*/ ]; /* m = node of next least frequency */ 
        s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */ 
        s.heap[--s.heap_max] = m;
        /* Create a new node father of n and m */ tree[node * 2] = tree[n * 2] + tree[m * 2] /*.Freq*/ ;
        s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
        tree[n * 2 + 1] = tree[m * 2 + 1] = node;
        /* and insert the new node in the heap */ s.heap[1 /*SMALLEST*/ ] = node++;
        $409216557d5023de$var$pqdownheap(s, tree, 1 /*SMALLEST*/ );
    }while (s.heap_len >= 2);
    s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/ ];
    /* At this point, the fields freq and dad are set. We can now
   * generate the bit lengths.
   */ $409216557d5023de$var$gen_bitlen(s, desc);
    /* The field len is now set, we can generate the bit codes */ $409216557d5023de$var$gen_codes(tree, max_code, s.bl_count);
}
/* ===========================================================================
 * Scan a literal or distance tree to determine the frequencies of the codes
 * in the bit length tree.
 */ function $409216557d5023de$var$scan_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree;   /* the tree to be scanned */
//    int max_code;    /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    tree[(max_code + 1) * 2 + 1] = 0xffff; /* guard */ 
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) s.bl_tree[curlen * 2] += count;
        else if (curlen !== 0) {
            if (curlen !== prevlen) s.bl_tree[curlen * 2]++;
            s.bl_tree[$409216557d5023de$var$REP_3_6 * 2]++;
        } else if (count <= 10) s.bl_tree[$409216557d5023de$var$REPZ_3_10 * 2]++;
        else s.bl_tree[$409216557d5023de$var$REPZ_11_138 * 2]++;
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Send a literal or distance tree in compressed form, using the codes in
 * bl_tree.
 */ function $409216557d5023de$var$send_tree(s, tree, max_code) //    deflate_state *s;
//    ct_data *tree; /* the tree to be scanned */
//    int max_code;       /* and its largest code of non zero frequency */
{
    var n; /* iterates over all tree elements */ 
    var prevlen = -1; /* last emitted length */ 
    var curlen; /* length of current code */ 
    var nextlen = tree[1] /*.Len*/ ; /* length of next code */ 
    var count = 0; /* repeat count of the current code */ 
    var max_count = 7; /* max repeat count */ 
    var min_count = 4; /* min repeat count */ 
    /* tree[max_code+1].Len = -1; */ /* guard already set */ if (nextlen === 0) {
        max_count = 138;
        min_count = 3;
    }
    for(n = 0; n <= max_code; n++){
        curlen = nextlen;
        nextlen = tree[(n + 1) * 2 + 1] /*.Len*/ ;
        if (++count < max_count && curlen === nextlen) continue;
        else if (count < min_count) do $409216557d5023de$var$send_code(s, curlen, s.bl_tree);
        while (--count !== 0);
        else if (curlen !== 0) {
            if (curlen !== prevlen) {
                $409216557d5023de$var$send_code(s, curlen, s.bl_tree);
                count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            $409216557d5023de$var$send_code(s, $409216557d5023de$var$REP_3_6, s.bl_tree);
            $409216557d5023de$var$send_bits(s, count - 3, 2);
        } else if (count <= 10) {
            $409216557d5023de$var$send_code(s, $409216557d5023de$var$REPZ_3_10, s.bl_tree);
            $409216557d5023de$var$send_bits(s, count - 3, 3);
        } else {
            $409216557d5023de$var$send_code(s, $409216557d5023de$var$REPZ_11_138, s.bl_tree);
            $409216557d5023de$var$send_bits(s, count - 11, 7);
        }
        count = 0;
        prevlen = curlen;
        if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
        } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
        } else {
            max_count = 7;
            min_count = 4;
        }
    }
}
/* ===========================================================================
 * Construct the Huffman tree for the bit lengths and return the index in
 * bl_order of the last bit length code to send.
 */ function $409216557d5023de$var$build_bl_tree(s) {
    var max_blindex; /* index of last bit length code of non zero freq */ 
    /* Determine the bit length frequencies for literal and distance trees */ $409216557d5023de$var$scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
    $409216557d5023de$var$scan_tree(s, s.dyn_dtree, s.d_desc.max_code);
    /* Build the bit length tree: */ $409216557d5023de$var$build_tree(s, s.bl_desc);
    /* opt_len now includes the length of the tree representations, except
   * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
   */ /* Determine the number of bit length codes to send. The pkzip format
   * requires that at least 4 bit length codes be sent. (appnote.txt says
   * 3 but the actual value used is 4.)
   */ for(max_blindex = $409216557d5023de$var$BL_CODES - 1; max_blindex >= 3; max_blindex--){
        if (s.bl_tree[$409216557d5023de$var$bl_order[max_blindex] * 2 + 1] !== 0) break;
    }
    /* Update opt_len to include the bit length tree and counts */ s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
    //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
    //        s->opt_len, s->static_len));
    return max_blindex;
}
/* ===========================================================================
 * Send the header for a block using dynamic Huffman trees: the counts, the
 * lengths of the bit length codes, the literal tree and the distance tree.
 * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
 */ function $409216557d5023de$var$send_all_trees(s, lcodes, dcodes, blcodes) //    deflate_state *s;
//    int lcodes, dcodes, blcodes; /* number of codes for each tree */
{
    var rank; /* index in bl_order */ 
    //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
    //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
    //        "too many codes");
    //Tracev((stderr, "\nbl counts: "));
    $409216557d5023de$var$send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */ 
    $409216557d5023de$var$send_bits(s, dcodes - 1, 5);
    $409216557d5023de$var$send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */ 
    for(rank = 0; rank < blcodes; rank++)//Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
    $409216557d5023de$var$send_bits(s, s.bl_tree[$409216557d5023de$var$bl_order[rank] * 2 + 1], 3);
    //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));
    $409216557d5023de$var$send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */ 
    //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));
    $409216557d5023de$var$send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */ 
//Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
}
/* ===========================================================================
 * Check if the data type is TEXT or BINARY, using the following algorithm:
 * - TEXT if the two conditions below are satisfied:
 *    a) There are no non-portable control characters belonging to the
 *       "black list" (0..6, 14..25, 28..31).
 *    b) There is at least one printable character belonging to the
 *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
 * - BINARY otherwise.
 * - The following partially-portable control characters form a
 *   "gray list" that is ignored in this detection algorithm:
 *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
 * IN assertion: the fields Freq of dyn_ltree are set.
 */ function $409216557d5023de$var$detect_data_type(s) {
    /* black_mask is the bit mask of black-listed bytes
   * set bits 0..6, 14..25, and 28..31
   * 0xf3ffc07f = binary 11110011111111111100000001111111
   */ var black_mask = 0xf3ffc07f;
    var n;
    /* Check for non-textual ("black-listed") bytes. */ for(n = 0; n <= 31; n++, black_mask >>>= 1){
        if (black_mask & 1 && s.dyn_ltree[n * 2] !== 0) return $409216557d5023de$var$Z_BINARY;
    }
    /* Check for textual ("white-listed") bytes. */ if (s.dyn_ltree[18] !== 0 || s.dyn_ltree[20] !== 0 || s.dyn_ltree[26] !== 0) return $409216557d5023de$var$Z_TEXT;
    for(n = 32; n < $409216557d5023de$var$LITERALS; n++){
        if (s.dyn_ltree[n * 2] !== 0) return $409216557d5023de$var$Z_TEXT;
    }
    /* There are no "black-listed" or "white-listed" bytes:
   * this stream either is empty or has tolerated ("gray-listed") bytes only.
   */ return $409216557d5023de$var$Z_BINARY;
}
var $409216557d5023de$var$static_init_done = false;
/* ===========================================================================
 * Initialize the tree data structures for a new zlib stream.
 */ function $409216557d5023de$var$_tr_init(s) {
    if (!$409216557d5023de$var$static_init_done) {
        $409216557d5023de$var$tr_static_init();
        $409216557d5023de$var$static_init_done = true;
    }
    s.l_desc = new $409216557d5023de$var$TreeDesc(s.dyn_ltree, $409216557d5023de$var$static_l_desc);
    s.d_desc = new $409216557d5023de$var$TreeDesc(s.dyn_dtree, $409216557d5023de$var$static_d_desc);
    s.bl_desc = new $409216557d5023de$var$TreeDesc(s.bl_tree, $409216557d5023de$var$static_bl_desc);
    s.bi_buf = 0;
    s.bi_valid = 0;
    /* Initialize the first block of the first file: */ $409216557d5023de$var$init_block(s);
}
/* ===========================================================================
 * Send a stored block
 */ function $409216557d5023de$var$_tr_stored_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    $409216557d5023de$var$send_bits(s, ($409216557d5023de$var$STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */ 
    $409216557d5023de$var$copy_block(s, buf, stored_len, true); /* with header */ 
}
/* ===========================================================================
 * Send one empty static block to give enough lookahead for inflate.
 * This takes 10 bits, of which 7 may remain in the bit buffer.
 */ function $409216557d5023de$var$_tr_align(s) {
    $409216557d5023de$var$send_bits(s, $409216557d5023de$var$STATIC_TREES << 1, 3);
    $409216557d5023de$var$send_code(s, $409216557d5023de$var$END_BLOCK, $409216557d5023de$var$static_ltree);
    $409216557d5023de$var$bi_flush(s);
}
/* ===========================================================================
 * Determine the best encoding for the current block: dynamic trees, static
 * trees or store, and output the encoded block to the zip file.
 */ function $409216557d5023de$var$_tr_flush_block(s, buf, stored_len, last) //DeflateState *s;
//charf *buf;       /* input block, or NULL if too old */
//ulg stored_len;   /* length of input block */
//int last;         /* one if this is the last block for a file */
{
    var opt_lenb, static_lenb; /* opt_len and static_len in bytes */ 
    var max_blindex = 0; /* index of last bit length code of non zero freq */ 
    /* Build the Huffman trees unless a stored block is forced */ if (s.level > 0) {
        /* Check if the file is binary or text */ if (s.strm.data_type === $409216557d5023de$var$Z_UNKNOWN) s.strm.data_type = $409216557d5023de$var$detect_data_type(s);
        /* Construct the literal and distance trees */ $409216557d5023de$var$build_tree(s, s.l_desc);
        // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        $409216557d5023de$var$build_tree(s, s.d_desc);
        // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
        //        s->static_len));
        /* At this point, opt_len and static_len are the total bit lengths of
     * the compressed block data, excluding the tree representations.
     */ /* Build the bit length tree for the above two trees, and get the index
     * in bl_order of the last bit length code to send.
     */ max_blindex = $409216557d5023de$var$build_bl_tree(s);
        /* Determine the best encoding. Compute the block lengths in bytes. */ opt_lenb = s.opt_len + 3 + 7 >>> 3;
        static_lenb = s.static_len + 3 + 7 >>> 3;
        // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
        //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
        //        s->last_lit));
        if (static_lenb <= opt_lenb) opt_lenb = static_lenb;
    } else // Assert(buf != (char*)0, "lost buf");
    opt_lenb = static_lenb = stored_len + 5; /* force a stored block */ 
    if (stored_len + 4 <= opt_lenb && buf !== -1) /* 4: two words for the lengths */ /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
     * Otherwise we can't have processed more than WSIZE input bytes since
     * the last block flush, because compression would have been
     * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
     * transform a block into a stored block.
     */ $409216557d5023de$var$_tr_stored_block(s, buf, stored_len, last);
    else if (s.strategy === $409216557d5023de$var$Z_FIXED || static_lenb === opt_lenb) {
        $409216557d5023de$var$send_bits(s, ($409216557d5023de$var$STATIC_TREES << 1) + (last ? 1 : 0), 3);
        $409216557d5023de$var$compress_block(s, $409216557d5023de$var$static_ltree, $409216557d5023de$var$static_dtree);
    } else {
        $409216557d5023de$var$send_bits(s, ($409216557d5023de$var$DYN_TREES << 1) + (last ? 1 : 0), 3);
        $409216557d5023de$var$send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
        $409216557d5023de$var$compress_block(s, s.dyn_ltree, s.dyn_dtree);
    }
    // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
    /* The above check is made mod 2^32, for files larger than 512 MB
   * and uLong implemented on 32 bits.
   */ $409216557d5023de$var$init_block(s);
    if (last) $409216557d5023de$var$bi_windup(s);
// Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
//       s->compressed_len-7*last));
}
/* ===========================================================================
 * Save the match info and tally the frequency counts. Return true if
 * the current block must be flushed.
 */ function $409216557d5023de$var$_tr_tally(s, dist, lc) //    deflate_state *s;
//    unsigned dist;  /* distance of matched string */
//    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
{
    //var out_length, in_length, dcode;
    s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
    s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
    s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
    s.last_lit++;
    if (dist === 0) /* lc is the unmatched char */ s.dyn_ltree[lc * 2]++;
    else {
        s.matches++;
        /* Here, lc is the match length - MIN_MATCH */ dist--; /* dist = match distance - 1 */ 
        //Assert((ush)dist < (ush)MAX_DIST(s) &&
        //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
        //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");
        s.dyn_ltree[($409216557d5023de$var$_length_code[lc] + $409216557d5023de$var$LITERALS + 1) * 2]++;
        s.dyn_dtree[$409216557d5023de$var$d_code(dist) * 2]++;
    }
    // (!) This block is disabled in zlib defaults,
    // don't enable it for binary compatibility
    //#ifdef TRUNCATE_BLOCK
    //  /* Try to guess if it is profitable to stop the current block here */
    //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
    //    /* Compute an upper bound for the compressed length */
    //    out_length = s.last_lit*8;
    //    in_length = s.strstart - s.block_start;
    //
    //    for (dcode = 0; dcode < D_CODES; dcode++) {
    //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
    //    }
    //    out_length >>>= 3;
    //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
    //    //       s->last_lit, in_length, out_length,
    //    //       100L - out_length*100L/in_length));
    //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
    //      return true;
    //    }
    //  }
    //#endif
    return s.last_lit === s.lit_bufsize - 1;
/* We avoid equality with lit_bufsize because of wraparound at 64K
   * on 16 bit machines and because stored blocks are restricted to
   * 64K-1 bytes.
   */ }
$409216557d5023de$export$4e4fc0157c3cd14d = $409216557d5023de$var$_tr_init;
$409216557d5023de$export$8959e34c5e020172 = $409216557d5023de$var$_tr_stored_block;
$409216557d5023de$export$44f15b52eef0cf41 = $409216557d5023de$var$_tr_flush_block;
$409216557d5023de$export$b3cbce147289408f = $409216557d5023de$var$_tr_tally;
$409216557d5023de$export$bfb360e02ee9b403 = $409216557d5023de$var$_tr_align;

});

parcelRegister("jnGJc", function(module, exports) {
'use strict';
// Note: adler32 takes 12% for level 0 and 2% for level 6.
// It isn't worth it to make additional optimizations as in original.
// Small size is preferable.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $e1c14f30a17913f8$var$adler32(adler, buf, len, pos) {
    var s1 = adler & 0xffff | 0, s2 = adler >>> 16 & 0xffff | 0, n = 0;
    while(len !== 0){
        // Set limit ~ twice less than 5552, to keep
        // s2 in 31-bits, because we force signed ints.
        // in other case %= will fail.
        n = len > 2000 ? 2000 : len;
        len -= n;
        do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
        }while (--n);
        s1 %= 65521;
        s2 %= 65521;
    }
    return s1 | s2 << 16 | 0;
}
module.exports = $e1c14f30a17913f8$var$adler32;

});

parcelRegister("giZ5I", function(module, exports) {
'use strict';
// Note: we can't get significant speed boost here.
// So write code to minimize size - no pregenerated tables
// and array tools dependencies.
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// Use ordinary array, since untyped makes no boost here
function $bdedb73737d4bd4c$var$makeTable() {
    var c, table = [];
    for(var n = 0; n < 256; n++){
        c = n;
        for(var k = 0; k < 8; k++)c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
        table[n] = c;
    }
    return table;
}
// Create table on load. Just 255 signed longs. Not a problem.
var $bdedb73737d4bd4c$var$crcTable = $bdedb73737d4bd4c$var$makeTable();
function $bdedb73737d4bd4c$var$crc32(crc, buf, len, pos) {
    var t = $bdedb73737d4bd4c$var$crcTable, end = pos + len;
    crc ^= -1;
    for(var i = pos; i < end; i++)crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
    return crc ^ -1; // >>> 0;
}
module.exports = $bdedb73737d4bd4c$var$crc32;

});

parcelRegister("d1Xv2", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    2: 'need dictionary',
    /* Z_NEED_DICT       2  */ 1: 'stream end',
    /* Z_STREAM_END      1  */ 0: '',
    /* Z_OK              0  */ '-1': 'file error',
    /* Z_ERRNO         (-1) */ '-2': 'stream error',
    /* Z_STREAM_ERROR  (-2) */ '-3': 'data error',
    /* Z_DATA_ERROR    (-3) */ '-4': 'insufficient memory',
    /* Z_MEM_ERROR     (-4) */ '-5': 'buffer error',
    /* Z_BUF_ERROR     (-5) */ '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */ 
};

});


parcelRegister("582gc", function(module, exports) {

$parcel$export(module.exports, "inflateReset", function () { return $3bbf73f9f33166a2$export$42de45683a92ba94; }, function (v) { return $3bbf73f9f33166a2$export$42de45683a92ba94 = v; });
$parcel$export(module.exports, "inflateInit2", function () { return $3bbf73f9f33166a2$export$6792d92addc5c8a0; }, function (v) { return $3bbf73f9f33166a2$export$6792d92addc5c8a0 = v; });
$parcel$export(module.exports, "inflate", function () { return $3bbf73f9f33166a2$export$cae1ce83fe4a1782; }, function (v) { return $3bbf73f9f33166a2$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateEnd", function () { return $3bbf73f9f33166a2$export$224e1a443c3fba76; }, function (v) { return $3bbf73f9f33166a2$export$224e1a443c3fba76 = v; });
$parcel$export(module.exports, "inflateGetHeader", function () { return $3bbf73f9f33166a2$export$6d4647cb9e1c75fc; }, function (v) { return $3bbf73f9f33166a2$export$6d4647cb9e1c75fc = v; });
$parcel$export(module.exports, "inflateSetDictionary", function () { return $3bbf73f9f33166a2$export$60da749bed98ccf8; }, function (v) { return $3bbf73f9f33166a2$export$60da749bed98ccf8 = v; });
var $3bbf73f9f33166a2$export$42de45683a92ba94;
var $3bbf73f9f33166a2$export$7633ac2cd30f9650;
var $3bbf73f9f33166a2$export$6710ea52c4ec9d6a;
var $3bbf73f9f33166a2$export$9c140b25e26874f9;
var $3bbf73f9f33166a2$export$6792d92addc5c8a0;
var $3bbf73f9f33166a2$export$cae1ce83fe4a1782;
var $3bbf73f9f33166a2$export$224e1a443c3fba76;
var $3bbf73f9f33166a2$export$6d4647cb9e1c75fc;
var $3bbf73f9f33166a2$export$60da749bed98ccf8;
var $3bbf73f9f33166a2$export$220f6291ca35fd71;
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");

var $jnGJc = parcelRequire("jnGJc");

var $giZ5I = parcelRequire("giZ5I");

var $kMD3Z = parcelRequire("kMD3Z");

var $3B1jT = parcelRequire("3B1jT");
var $3bbf73f9f33166a2$var$CODES = 0;
var $3bbf73f9f33166a2$var$LENS = 1;
var $3bbf73f9f33166a2$var$DISTS = 2;
/* Public constants ==========================================================*/ /* ===========================================================================*/ /* Allowed flush values; see deflate() and inflate() below for details */ //var Z_NO_FLUSH      = 0;
//var Z_PARTIAL_FLUSH = 1;
//var Z_SYNC_FLUSH    = 2;
//var Z_FULL_FLUSH    = 3;
var $3bbf73f9f33166a2$var$Z_FINISH = 4;
var $3bbf73f9f33166a2$var$Z_BLOCK = 5;
var $3bbf73f9f33166a2$var$Z_TREES = 6;
/* Return codes for the compression/decompression functions. Negative values
 * are errors, positive values are used for special but normal events.
 */ var $3bbf73f9f33166a2$var$Z_OK = 0;
var $3bbf73f9f33166a2$var$Z_STREAM_END = 1;
var $3bbf73f9f33166a2$var$Z_NEED_DICT = 2;
//var Z_ERRNO         = -1;
var $3bbf73f9f33166a2$var$Z_STREAM_ERROR = -2;
var $3bbf73f9f33166a2$var$Z_DATA_ERROR = -3;
var $3bbf73f9f33166a2$var$Z_MEM_ERROR = -4;
var $3bbf73f9f33166a2$var$Z_BUF_ERROR = -5;
//var Z_VERSION_ERROR = -6;
/* The deflate compression method */ var $3bbf73f9f33166a2$var$Z_DEFLATED = 8;
/* STATES ====================================================================*/ /* ===========================================================================*/ var $3bbf73f9f33166a2$var$HEAD = 1; /* i: waiting for magic header */ 
var $3bbf73f9f33166a2$var$FLAGS = 2; /* i: waiting for method and flags (gzip) */ 
var $3bbf73f9f33166a2$var$TIME = 3; /* i: waiting for modification time (gzip) */ 
var $3bbf73f9f33166a2$var$OS = 4; /* i: waiting for extra flags and operating system (gzip) */ 
var $3bbf73f9f33166a2$var$EXLEN = 5; /* i: waiting for extra length (gzip) */ 
var $3bbf73f9f33166a2$var$EXTRA = 6; /* i: waiting for extra bytes (gzip) */ 
var $3bbf73f9f33166a2$var$NAME = 7; /* i: waiting for end of file name (gzip) */ 
var $3bbf73f9f33166a2$var$COMMENT = 8; /* i: waiting for end of comment (gzip) */ 
var $3bbf73f9f33166a2$var$HCRC = 9; /* i: waiting for header crc (gzip) */ 
var $3bbf73f9f33166a2$var$DICTID = 10; /* i: waiting for dictionary check value */ 
var $3bbf73f9f33166a2$var$DICT = 11; /* waiting for inflateSetDictionary() call */ 
var $3bbf73f9f33166a2$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
var $3bbf73f9f33166a2$var$TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */ 
var $3bbf73f9f33166a2$var$STORED = 14; /* i: waiting for stored size (length and complement) */ 
var $3bbf73f9f33166a2$var$COPY_ = 15; /* i/o: same as COPY below, but only first time in */ 
var $3bbf73f9f33166a2$var$COPY = 16; /* i/o: waiting for input or output to copy stored block */ 
var $3bbf73f9f33166a2$var$TABLE = 17; /* i: waiting for dynamic block table lengths */ 
var $3bbf73f9f33166a2$var$LENLENS = 18; /* i: waiting for code length code lengths */ 
var $3bbf73f9f33166a2$var$CODELENS = 19; /* i: waiting for length/lit and distance code lengths */ 
var $3bbf73f9f33166a2$var$LEN_ = 20; /* i: same as LEN below, but only first time in */ 
var $3bbf73f9f33166a2$var$LEN = 21; /* i: waiting for length/lit/eob code */ 
var $3bbf73f9f33166a2$var$LENEXT = 22; /* i: waiting for length extra bits */ 
var $3bbf73f9f33166a2$var$DIST = 23; /* i: waiting for distance code */ 
var $3bbf73f9f33166a2$var$DISTEXT = 24; /* i: waiting for distance extra bits */ 
var $3bbf73f9f33166a2$var$MATCH = 25; /* o: waiting for output space to copy string */ 
var $3bbf73f9f33166a2$var$LIT = 26; /* o: waiting for output space to write literal */ 
var $3bbf73f9f33166a2$var$CHECK = 27; /* i: waiting for 32-bit check value */ 
var $3bbf73f9f33166a2$var$LENGTH = 28; /* i: waiting for 32-bit length (gzip) */ 
var $3bbf73f9f33166a2$var$DONE = 29; /* finished check, done -- remain here until reset */ 
var $3bbf73f9f33166a2$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $3bbf73f9f33166a2$var$MEM = 31; /* got an inflate() memory error -- remain here until reset */ 
var $3bbf73f9f33166a2$var$SYNC = 32; /* looking for synchronization bytes to restart inflate() */ 
/* ===========================================================================*/ var $3bbf73f9f33166a2$var$ENOUGH_LENS = 852;
var $3bbf73f9f33166a2$var$ENOUGH_DISTS = 592;
//var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);
var $3bbf73f9f33166a2$var$MAX_WBITS = 15;
/* 32K LZ77 window */ var $3bbf73f9f33166a2$var$DEF_WBITS = $3bbf73f9f33166a2$var$MAX_WBITS;
function $3bbf73f9f33166a2$var$zswap32(q) {
    return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
}
function $3bbf73f9f33166a2$var$InflateState() {
    this.mode = 0; /* current inflate mode */ 
    this.last = false; /* true if processing last block */ 
    this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */ 
    this.havedict = false; /* true if dictionary provided */ 
    this.flags = 0; /* gzip header method and flags (0 if zlib) */ 
    this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */ 
    this.check = 0; /* protected copy of check value */ 
    this.total = 0; /* protected copy of output count */ 
    // TODO: may be {}
    this.head = null; /* where to save gzip header information */ 
    /* sliding window */ this.wbits = 0; /* log base 2 of requested window size */ 
    this.wsize = 0; /* window size or zero if not using window */ 
    this.whave = 0; /* valid bytes in the window */ 
    this.wnext = 0; /* window write index */ 
    this.window = null; /* allocated sliding window, if needed */ 
    /* bit accumulator */ this.hold = 0; /* input bit accumulator */ 
    this.bits = 0; /* number of bits in "in" */ 
    /* for string and stored block copying */ this.length = 0; /* literal or length of data to copy */ 
    this.offset = 0; /* distance back to copy string from */ 
    /* for table and code decoding */ this.extra = 0; /* extra bits needed */ 
    /* fixed and dynamic code tables */ this.lencode = null; /* starting table for length/literal codes */ 
    this.distcode = null; /* starting table for distance codes */ 
    this.lenbits = 0; /* index bits for lencode */ 
    this.distbits = 0; /* index bits for distcode */ 
    /* dynamic table building */ this.ncode = 0; /* number of code length code lengths */ 
    this.nlen = 0; /* number of length code lengths */ 
    this.ndist = 0; /* number of distance code lengths */ 
    this.have = 0; /* number of code lengths in lens[] */ 
    this.next = null; /* next available space in codes[] */ 
    this.lens = new $8NmFQ.Buf16(320); /* temporary storage for code lengths */ 
    this.work = new $8NmFQ.Buf16(288); /* work area for code table building */ 
    /*
   because we don't have pointers in js, we use lencode and distcode directly
   as buffers so we don't need codes
  */ //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
    this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */ 
    this.distdyn = null; /* dynamic table for distance codes (JS specific) */ 
    this.sane = 0; /* if false, allow invalid distance too far */ 
    this.back = 0; /* bits back of last unprocessed length/lit */ 
    this.was = 0; /* initial length of match */ 
}
function $3bbf73f9f33166a2$var$inflateResetKeep(strm) {
    var state;
    if (!strm || !strm.state) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    strm.total_in = strm.total_out = state.total = 0;
    strm.msg = ''; /*Z_NULL*/ 
    if (state.wrap) strm.adler = state.wrap & 1;
    state.mode = $3bbf73f9f33166a2$var$HEAD;
    state.last = 0;
    state.havedict = 0;
    state.dmax = 32768;
    state.head = null /*Z_NULL*/ ;
    state.hold = 0;
    state.bits = 0;
    //state.lencode = state.distcode = state.next = state.codes;
    state.lencode = state.lendyn = new $8NmFQ.Buf32($3bbf73f9f33166a2$var$ENOUGH_LENS);
    state.distcode = state.distdyn = new $8NmFQ.Buf32($3bbf73f9f33166a2$var$ENOUGH_DISTS);
    state.sane = 1;
    state.back = -1;
    //Tracev((stderr, "inflate: reset\n"));
    return $3bbf73f9f33166a2$var$Z_OK;
}
function $3bbf73f9f33166a2$var$inflateReset(strm) {
    var state;
    if (!strm || !strm.state) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    state.wsize = 0;
    state.whave = 0;
    state.wnext = 0;
    return $3bbf73f9f33166a2$var$inflateResetKeep(strm);
}
function $3bbf73f9f33166a2$var$inflateReset2(strm, windowBits) {
    var wrap;
    var state;
    /* get the state */ if (!strm || !strm.state) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    /* extract wrap request from windowBits parameter */ if (windowBits < 0) {
        wrap = 0;
        windowBits = -windowBits;
    } else {
        wrap = (windowBits >> 4) + 1;
        if (windowBits < 48) windowBits &= 15;
    }
    /* set number of window bits, free window if different */ if (windowBits && (windowBits < 8 || windowBits > 15)) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    if (state.window !== null && state.wbits !== windowBits) state.window = null;
    /* update state and reset the rest of it */ state.wrap = wrap;
    state.wbits = windowBits;
    return $3bbf73f9f33166a2$var$inflateReset(strm);
}
function $3bbf73f9f33166a2$var$inflateInit2(strm, windowBits) {
    var ret;
    var state;
    if (!strm) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    //strm.msg = Z_NULL;                 /* in case we return an error */
    state = new $3bbf73f9f33166a2$var$InflateState();
    //if (state === Z_NULL) return Z_MEM_ERROR;
    //Tracev((stderr, "inflate: allocated\n"));
    strm.state = state;
    state.window = null /*Z_NULL*/ ;
    ret = $3bbf73f9f33166a2$var$inflateReset2(strm, windowBits);
    if (ret !== $3bbf73f9f33166a2$var$Z_OK) strm.state = null /*Z_NULL*/ ;
    return ret;
}
function $3bbf73f9f33166a2$var$inflateInit(strm) {
    return $3bbf73f9f33166a2$var$inflateInit2(strm, $3bbf73f9f33166a2$var$DEF_WBITS);
}
/*
 Return state with length and distance decoding tables and index sizes set to
 fixed code decoding.  Normally this returns fixed tables from inffixed.h.
 If BUILDFIXED is defined, then instead this routine builds the tables the
 first time it's called, and returns those tables the first time and
 thereafter.  This reduces the size of the code by about 2K bytes, in
 exchange for a little execution time.  However, BUILDFIXED should not be
 used for threaded applications, since the rewriting of the tables and virgin
 may not be thread-safe.
 */ var $3bbf73f9f33166a2$var$virgin = true;
var $3bbf73f9f33166a2$var$lenfix, $3bbf73f9f33166a2$var$distfix; // We have no pointers in JS, so keep tables separate
function $3bbf73f9f33166a2$var$fixedtables(state) {
    /* build fixed huffman tables if first call (may not be thread safe) */ if ($3bbf73f9f33166a2$var$virgin) {
        var sym;
        $3bbf73f9f33166a2$var$lenfix = new $8NmFQ.Buf32(512);
        $3bbf73f9f33166a2$var$distfix = new $8NmFQ.Buf32(32);
        /* literal/length table */ sym = 0;
        while(sym < 144)state.lens[sym++] = 8;
        while(sym < 256)state.lens[sym++] = 9;
        while(sym < 280)state.lens[sym++] = 7;
        while(sym < 288)state.lens[sym++] = 8;
        $3B1jT($3bbf73f9f33166a2$var$LENS, state.lens, 0, 288, $3bbf73f9f33166a2$var$lenfix, 0, state.work, {
            bits: 9
        });
        /* distance table */ sym = 0;
        while(sym < 32)state.lens[sym++] = 5;
        $3B1jT($3bbf73f9f33166a2$var$DISTS, state.lens, 0, 32, $3bbf73f9f33166a2$var$distfix, 0, state.work, {
            bits: 5
        });
        /* do this just once */ $3bbf73f9f33166a2$var$virgin = false;
    }
    state.lencode = $3bbf73f9f33166a2$var$lenfix;
    state.lenbits = 9;
    state.distcode = $3bbf73f9f33166a2$var$distfix;
    state.distbits = 5;
}
/*
 Update the window with the last wsize (normally 32K) bytes written before
 returning.  If window does not exist yet, create it.  This is only called
 when a window is already in use, or when output has been written during this
 inflate call, but the end of the deflate stream has not been reached yet.
 It is also called to create a window for dictionary data when a dictionary
 is loaded.

 Providing output buffers larger than 32K to inflate() should provide a speed
 advantage, since only the last 32K of output is copied to the sliding window
 upon return from inflate(), and since all distances after the first 32K of
 output will fall in the output data, making match copies simpler and faster.
 The advantage may be dependent on the size of the processor's data caches.
 */ function $3bbf73f9f33166a2$var$updatewindow(strm, src, end, copy) {
    var dist;
    var state = strm.state;
    /* if it hasn't been done already, allocate space for the window */ if (state.window === null) {
        state.wsize = 1 << state.wbits;
        state.wnext = 0;
        state.whave = 0;
        state.window = new $8NmFQ.Buf8(state.wsize);
    }
    /* copy state->wsize or less output bytes into the circular window */ if (copy >= state.wsize) {
        $8NmFQ.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
        state.wnext = 0;
        state.whave = state.wsize;
    } else {
        dist = state.wsize - state.wnext;
        if (dist > copy) dist = copy;
        //zmemcpy(state->window + state->wnext, end - copy, dist);
        $8NmFQ.arraySet(state.window, src, end - copy, dist, state.wnext);
        copy -= dist;
        if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            $8NmFQ.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
        } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) state.wnext = 0;
            if (state.whave < state.wsize) state.whave += dist;
        }
    }
    return 0;
}
function $3bbf73f9f33166a2$var$inflate(strm, flush) {
    var state;
    var input, output; // input/output buffers
    var next; /* next input INDEX */ 
    var put; /* next output INDEX */ 
    var have, left; /* available input and output */ 
    var hold; /* bit buffer */ 
    var bits; /* bits in bit buffer */ 
    var _in, _out; /* save starting available input and output */ 
    var copy; /* number of stored or match bytes to copy */ 
    var from; /* where to copy match bytes from */ 
    var from_source;
    var here = 0; /* current decoding table entry */ 
    var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
    //var last;                   /* parent table entry */
    var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
    var len; /* length to copy for repeats, bits to drop */ 
    var ret; /* return code */ 
    var hbuf = new $8NmFQ.Buf8(4); /* buffer for gzip header crc calculation */ 
    var opts;
    var n; // temporary var for NEED_BITS
    var order = /* permutation of code lengths */ [
        16,
        17,
        18,
        0,
        8,
        7,
        9,
        6,
        10,
        5,
        11,
        4,
        12,
        3,
        13,
        2,
        14,
        1,
        15
    ];
    if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.mode === $3bbf73f9f33166a2$var$TYPE) state.mode = $3bbf73f9f33166a2$var$TYPEDO;
     /* skip check */ 
    //--- LOAD() ---
    put = strm.next_out;
    output = strm.output;
    left = strm.avail_out;
    next = strm.next_in;
    input = strm.input;
    have = strm.avail_in;
    hold = state.hold;
    bits = state.bits;
    //---
    _in = have;
    _out = left;
    ret = $3bbf73f9f33166a2$var$Z_OK;
    inf_leave: for(;;)switch(state.mode){
        case $3bbf73f9f33166a2$var$HEAD:
            if (state.wrap === 0) {
                state.mode = $3bbf73f9f33166a2$var$TYPEDO;
                break;
            }
            //=== NEEDBITS(16);
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.wrap & 2 && hold === 0x8b1f) {
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/ ;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $giZ5I(state.check, hbuf, 2, 0);
                //===//
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = $3bbf73f9f33166a2$var$FLAGS;
                break;
            }
            state.flags = 0; /* expect zlib header */ 
            if (state.head) state.head.done = false;
            if (!(state.wrap & 1) || /* check if zlib header allowed */ (((hold & 0xff) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            if ((hold & 0x0f) !== $3bbf73f9f33166a2$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            len = (hold & 0x0f) + 8;
            if (state.wbits === 0) state.wbits = len;
            else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            state.dmax = 1 << len;
            //Tracev((stderr, "inflate:   zlib header ok\n"));
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = hold & 0x200 ? $3bbf73f9f33166a2$var$DICTID : $3bbf73f9f33166a2$var$TYPE;
            //=== INITBITS();
            hold = 0;
            bits = 0;
            break;
        case $3bbf73f9f33166a2$var$FLAGS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.flags = hold;
            if ((state.flags & 0xff) !== $3bbf73f9f33166a2$var$Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            if (state.head) state.head.text = hold >> 8 & 1;
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $giZ5I(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3bbf73f9f33166a2$var$TIME;
        /* falls through */ case $3bbf73f9f33166a2$var$TIME:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) state.head.time = hold;
            if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = $giZ5I(state.check, hbuf, 4, 0);
            //===
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3bbf73f9f33166a2$var$OS;
        /* falls through */ case $3bbf73f9f33166a2$var$OS:
            //=== NEEDBITS(16); */
            while(bits < 16){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
            }
            if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = $giZ5I(state.check, hbuf, 2, 0);
            //===//
            }
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3bbf73f9f33166a2$var$EXLEN;
        /* falls through */ case $3bbf73f9f33166a2$var$EXLEN:
            if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) state.head.extra_len = hold;
                if (state.flags & 0x0200) {
                    //=== CRC2(state.check, hold);
                    hbuf[0] = hold & 0xff;
                    hbuf[1] = hold >>> 8 & 0xff;
                    state.check = $giZ5I(state.check, hbuf, 2, 0);
                //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            } else if (state.head) state.head.extra = null /*Z_NULL*/ ;
            state.mode = $3bbf73f9f33166a2$var$EXTRA;
        /* falls through */ case $3bbf73f9f33166a2$var$EXTRA:
            if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) copy = have;
                if (copy) {
                    if (state.head) {
                        len = state.head.extra_len - state.length;
                        if (!state.head.extra) // Use untyped array for more convenient processing later
                        state.head.extra = new Array(state.head.extra_len);
                        $8NmFQ.arraySet(state.head.extra, input, next, // extra field is limited to 65536 bytes
                        // - no need for additional size check
                        copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/ len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                    }
                    if (state.flags & 0x0200) state.check = $giZ5I(state.check, input, copy, next);
                    have -= copy;
                    next += copy;
                    state.length -= copy;
                }
                if (state.length) break inf_leave;
            }
            state.length = 0;
            state.mode = $3bbf73f9f33166a2$var$NAME;
        /* falls through */ case $3bbf73f9f33166a2$var$NAME:
            if (state.flags & 0x0800) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    // TODO: 2 or 1 bytes?
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.name_max*/ ) state.head.name += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $giZ5I(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.name = null;
            state.length = 0;
            state.mode = $3bbf73f9f33166a2$var$COMMENT;
        /* falls through */ case $3bbf73f9f33166a2$var$COMMENT:
            if (state.flags & 0x1000) {
                if (have === 0) break inf_leave;
                copy = 0;
                do {
                    len = input[next + copy++];
                    /* use constant limit because in js we should not preallocate memory */ if (state.head && len && state.length < 65536 /*state.head.comm_max*/ ) state.head.comment += String.fromCharCode(len);
                }while (len && copy < have);
                if (state.flags & 0x0200) state.check = $giZ5I(state.check, input, copy, next);
                have -= copy;
                next += copy;
                if (len) break inf_leave;
            } else if (state.head) state.head.comment = null;
            state.mode = $3bbf73f9f33166a2$var$HCRC;
        /* falls through */ case $3bbf73f9f33166a2$var$HCRC:
            if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while(bits < 16){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                    strm.msg = 'header crc mismatch';
                    state.mode = $3bbf73f9f33166a2$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            }
            if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
            }
            strm.adler = state.check = 0;
            state.mode = $3bbf73f9f33166a2$var$TYPE;
            break;
        case $3bbf73f9f33166a2$var$DICTID:
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            strm.adler = state.check = $3bbf73f9f33166a2$var$zswap32(hold);
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3bbf73f9f33166a2$var$DICT;
        /* falls through */ case $3bbf73f9f33166a2$var$DICT:
            if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return $3bbf73f9f33166a2$var$Z_NEED_DICT;
            }
            strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/ ;
            state.mode = $3bbf73f9f33166a2$var$TYPE;
        /* falls through */ case $3bbf73f9f33166a2$var$TYPE:
            if (flush === $3bbf73f9f33166a2$var$Z_BLOCK || flush === $3bbf73f9f33166a2$var$Z_TREES) break inf_leave;
        /* falls through */ case $3bbf73f9f33166a2$var$TYPEDO:
            if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = $3bbf73f9f33166a2$var$CHECK;
                break;
            }
            //=== NEEDBITS(3); */
            while(bits < 3){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.last = hold & 0x01 /*BITS(1)*/ ;
            //--- DROPBITS(1) ---//
            hold >>>= 1;
            bits -= 1;
            //---//
            switch(hold & 0x03){
                case 0:
                    /* stored block */ //Tracev((stderr, "inflate:     stored block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3bbf73f9f33166a2$var$STORED;
                    break;
                case 1:
                    /* fixed block */ $3bbf73f9f33166a2$var$fixedtables(state);
                    //Tracev((stderr, "inflate:     fixed codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3bbf73f9f33166a2$var$LEN_; /* decode codes */ 
                    if (flush === $3bbf73f9f33166a2$var$Z_TREES) {
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                        break inf_leave;
                    }
                    break;
                case 2:
                    /* dynamic block */ //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                    //        state.last ? " (last)" : ""));
                    state.mode = $3bbf73f9f33166a2$var$TABLE;
                    break;
                case 3:
                    strm.msg = 'invalid block type';
                    state.mode = $3bbf73f9f33166a2$var$BAD;
            }
            //--- DROPBITS(2) ---//
            hold >>>= 2;
            bits -= 2;
            break;
        case $3bbf73f9f33166a2$var$STORED:
            //--- BYTEBITS() ---// /* go to byte boundary */
            hold >>>= bits & 7;
            bits -= bits & 7;
            //---//
            //=== NEEDBITS(32); */
            while(bits < 32){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            state.length = hold & 0xffff;
            //Tracev((stderr, "inflate:       stored length %u\n",
            //        state.length));
            //=== INITBITS();
            hold = 0;
            bits = 0;
            //===//
            state.mode = $3bbf73f9f33166a2$var$COPY_;
            if (flush === $3bbf73f9f33166a2$var$Z_TREES) break inf_leave;
        /* falls through */ case $3bbf73f9f33166a2$var$COPY_:
            state.mode = $3bbf73f9f33166a2$var$COPY;
        /* falls through */ case $3bbf73f9f33166a2$var$COPY:
            copy = state.length;
            if (copy) {
                if (copy > have) copy = have;
                if (copy > left) copy = left;
                if (copy === 0) break inf_leave;
                //--- zmemcpy(put, next, copy); ---
                $8NmFQ.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
            }
            //Tracev((stderr, "inflate:       stored end\n"));
            state.mode = $3bbf73f9f33166a2$var$TYPE;
            break;
        case $3bbf73f9f33166a2$var$TABLE:
            //=== NEEDBITS(14); */
            while(bits < 14){
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            }
            //===//
            state.nlen = (hold & 0x1f) + 257;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ndist = (hold & 0x1f) + 1;
            //--- DROPBITS(5) ---//
            hold >>>= 5;
            bits -= 5;
            //---//
            state.ncode = (hold & 0x0f) + 4;
            //--- DROPBITS(4) ---//
            hold >>>= 4;
            bits -= 4;
            //---//
            //#ifndef PKZIP_BUG_WORKAROUND
            if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            //#endif
            //Tracev((stderr, "inflate:       table sizes ok\n"));
            state.have = 0;
            state.mode = $3bbf73f9f33166a2$var$LENLENS;
        /* falls through */ case $3bbf73f9f33166a2$var$LENLENS:
            while(state.have < state.ncode){
                //=== NEEDBITS(3);
                while(bits < 3){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
            //---//
            }
            while(state.have < 19)state.lens[order[state.have++]] = 0;
            // We have separate tables & no pointers. 2 commented lines below not needed.
            //state.next = state.codes;
            //state.lencode = state.next;
            // Switch to use dynamic table
            state.lencode = state.lendyn;
            state.lenbits = 7;
            opts = {
                bits: state.lenbits
            };
            ret = $3B1jT($3bbf73f9f33166a2$var$CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
            state.lenbits = opts.bits;
            if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            //Tracev((stderr, "inflate:       code lengths ok\n"));
            state.have = 0;
            state.mode = $3bbf73f9f33166a2$var$CODELENS;
        /* falls through */ case $3bbf73f9f33166a2$var$CODELENS:
            while(state.have < state.nlen + state.ndist){
                for(;;){
                    here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                if (here_val < 16) {
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    state.lens[state.have++] = here_val;
                } else {
                    if (here_val === 16) {
                        //=== NEEDBITS(here.bits + 2);
                        n = here_bits + 2;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        if (state.have === 0) {
                            strm.msg = 'invalid bit length repeat';
                            state.mode = $3bbf73f9f33166a2$var$BAD;
                            break;
                        }
                        len = state.lens[state.have - 1];
                        copy = 3 + (hold & 0x03); //BITS(2);
                        //--- DROPBITS(2) ---//
                        hold >>>= 2;
                        bits -= 2;
                    //---//
                    } else if (here_val === 17) {
                        //=== NEEDBITS(here.bits + 3);
                        n = here_bits + 3;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 3 + (hold & 0x07); //BITS(3);
                        //--- DROPBITS(3) ---//
                        hold >>>= 3;
                        bits -= 3;
                    //---//
                    } else {
                        //=== NEEDBITS(here.bits + 7);
                        n = here_bits + 7;
                        while(bits < n){
                            if (have === 0) break inf_leave;
                            have--;
                            hold += input[next++] << bits;
                            bits += 8;
                        }
                        //===//
                        //--- DROPBITS(here.bits) ---//
                        hold >>>= here_bits;
                        bits -= here_bits;
                        //---//
                        len = 0;
                        copy = 11 + (hold & 0x7f); //BITS(7);
                        //--- DROPBITS(7) ---//
                        hold >>>= 7;
                        bits -= 7;
                    //---//
                    }
                    if (state.have + copy > state.nlen + state.ndist) {
                        strm.msg = 'invalid bit length repeat';
                        state.mode = $3bbf73f9f33166a2$var$BAD;
                        break;
                    }
                    while(copy--)state.lens[state.have++] = len;
                }
            }
            /* handle error breaks in while */ if (state.mode === $3bbf73f9f33166a2$var$BAD) break;
            /* check for end-of-block code (better have one) */ if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            /* build code tables -- note: do not change the lenbits or distbits
           values here (9 and 6) without reading the comments in inftrees.h
           concerning the ENOUGH constants, which depend on those values */ state.lenbits = 9;
            opts = {
                bits: state.lenbits
            };
            ret = $3B1jT($3bbf73f9f33166a2$var$LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.lenbits = opts.bits;
            // state.lencode = state.next;
            if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            state.distbits = 6;
            //state.distcode.copy(state.codes);
            // Switch to use dynamic table
            state.distcode = state.distdyn;
            opts = {
                bits: state.distbits
            };
            ret = $3B1jT($3bbf73f9f33166a2$var$DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
            // We have separate tables & no pointers. 2 commented lines below not needed.
            // state.next_index = opts.table_index;
            state.distbits = opts.bits;
            // state.distcode = state.next;
            if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            //Tracev((stderr, 'inflate:       codes ok\n'));
            state.mode = $3bbf73f9f33166a2$var$LEN_;
            if (flush === $3bbf73f9f33166a2$var$Z_TREES) break inf_leave;
        /* falls through */ case $3bbf73f9f33166a2$var$LEN_:
            state.mode = $3bbf73f9f33166a2$var$LEN;
        /* falls through */ case $3bbf73f9f33166a2$var$LEN:
            if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                $kMD3Z(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---
                if (state.mode === $3bbf73f9f33166a2$var$TYPE) state.back = -1;
                break;
            }
            state.back = 0;
            for(;;){
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            state.length = here_val;
            if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = $3bbf73f9f33166a2$var$LIT;
                break;
            }
            if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = $3bbf73f9f33166a2$var$TYPE;
                break;
            }
            if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            state.extra = here_op & 15;
            state.mode = $3bbf73f9f33166a2$var$LENEXT;
        /* falls through */ case $3bbf73f9f33166a2$var$LENEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //Tracevv((stderr, "inflate:         length %u\n", state.length));
            state.was = state.length;
            state.mode = $3bbf73f9f33166a2$var$DIST;
        /* falls through */ case $3bbf73f9f33166a2$var$DIST:
            for(;;){
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/ 
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) break;
                //--- PULLBYTE() ---//
                if (have === 0) break inf_leave;
                have--;
                hold += input[next++] << bits;
                bits += 8;
            //---//
            }
            if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for(;;){
                    here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1) >> last_bits)];
                    here_bits = here >>> 24;
                    here_op = here >>> 16 & 0xff;
                    here_val = here & 0xffff;
                    if (last_bits + here_bits <= bits) break;
                    //--- PULLBYTE() ---//
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
            }
            //--- DROPBITS(here.bits) ---//
            hold >>>= here_bits;
            bits -= here_bits;
            //---//
            state.back += here_bits;
            if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            state.offset = here_val;
            state.extra = here_op & 15;
            state.mode = $3bbf73f9f33166a2$var$DISTEXT;
        /* falls through */ case $3bbf73f9f33166a2$var$DISTEXT:
            if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while(bits < n){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/ ;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
            }
            //#ifdef INFLATE_STRICT
            if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = $3bbf73f9f33166a2$var$BAD;
                break;
            }
            //#endif
            //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
            state.mode = $3bbf73f9f33166a2$var$MATCH;
        /* falls through */ case $3bbf73f9f33166a2$var$MATCH:
            if (left === 0) break inf_leave;
            copy = _out - left;
            if (state.offset > copy) {
                copy = state.offset - copy;
                if (copy > state.whave) {
                    if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = $3bbf73f9f33166a2$var$BAD;
                        break;
                    }
                }
                if (copy > state.wnext) {
                    copy -= state.wnext;
                    from = state.wsize - copy;
                } else from = state.wnext - copy;
                if (copy > state.length) copy = state.length;
                from_source = state.window;
            } else {
                from_source = output;
                from = put - state.offset;
                copy = state.length;
            }
            if (copy > left) copy = left;
            left -= copy;
            state.length -= copy;
            do output[put++] = from_source[from++];
            while (--copy);
            if (state.length === 0) state.mode = $3bbf73f9f33166a2$var$LEN;
            break;
        case $3bbf73f9f33166a2$var$LIT:
            if (left === 0) break inf_leave;
            output[put++] = state.length;
            left--;
            state.mode = $3bbf73f9f33166a2$var$LEN;
            break;
        case $3bbf73f9f33166a2$var$CHECK:
            if (state.wrap) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    // Use '|' instead of '+' to make sure that result is signed
                    hold |= input[next++] << bits;
                    bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/ state.flags ? $giZ5I(state.check, output, _out, put - _out) : $jnGJc(state.check, output, _out, put - _out);
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : $3bbf73f9f33166a2$var$zswap32(hold)) !== state.check) {
                    strm.msg = 'incorrect data check';
                    state.mode = $3bbf73f9f33166a2$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   check matches trailer\n"));
            }
            state.mode = $3bbf73f9f33166a2$var$LENGTH;
        /* falls through */ case $3bbf73f9f33166a2$var$LENGTH:
            if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while(bits < 32){
                    if (have === 0) break inf_leave;
                    have--;
                    hold += input[next++] << bits;
                    bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                    strm.msg = 'incorrect length check';
                    state.mode = $3bbf73f9f33166a2$var$BAD;
                    break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
            //===//
            //Tracev((stderr, "inflate:   length matches trailer\n"));
            }
            state.mode = $3bbf73f9f33166a2$var$DONE;
        /* falls through */ case $3bbf73f9f33166a2$var$DONE:
            ret = $3bbf73f9f33166a2$var$Z_STREAM_END;
            break inf_leave;
        case $3bbf73f9f33166a2$var$BAD:
            ret = $3bbf73f9f33166a2$var$Z_DATA_ERROR;
            break inf_leave;
        case $3bbf73f9f33166a2$var$MEM:
            return $3bbf73f9f33166a2$var$Z_MEM_ERROR;
        case $3bbf73f9f33166a2$var$SYNC:
        /* falls through */ default:
            return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    }
    // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"
    /*
     Return from inflate(), updating the total counts and the check value.
     If there was no progress during the inflate() call, return a buffer
     error.  Call updatewindow() to create and/or update the window state.
     Note: a memory error from inflate() is non-recoverable.
   */ //--- RESTORE() ---
    strm.next_out = put;
    strm.avail_out = left;
    strm.next_in = next;
    strm.avail_in = have;
    state.hold = hold;
    state.bits = bits;
    //---
    if (state.wsize || _out !== strm.avail_out && state.mode < $3bbf73f9f33166a2$var$BAD && (state.mode < $3bbf73f9f33166a2$var$CHECK || flush !== $3bbf73f9f33166a2$var$Z_FINISH)) {
        if ($3bbf73f9f33166a2$var$updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = $3bbf73f9f33166a2$var$MEM;
            return $3bbf73f9f33166a2$var$Z_MEM_ERROR;
        }
    }
    _in -= strm.avail_in;
    _out -= strm.avail_out;
    strm.total_in += _in;
    strm.total_out += _out;
    state.total += _out;
    if (state.wrap && _out) strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/ state.flags ? $giZ5I(state.check, output, _out, strm.next_out - _out) : $jnGJc(state.check, output, _out, strm.next_out - _out);
    strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === $3bbf73f9f33166a2$var$TYPE ? 128 : 0) + (state.mode === $3bbf73f9f33166a2$var$LEN_ || state.mode === $3bbf73f9f33166a2$var$COPY_ ? 256 : 0);
    if ((_in === 0 && _out === 0 || flush === $3bbf73f9f33166a2$var$Z_FINISH) && ret === $3bbf73f9f33166a2$var$Z_OK) ret = $3bbf73f9f33166a2$var$Z_BUF_ERROR;
    return ret;
}
function $3bbf73f9f33166a2$var$inflateEnd(strm) {
    if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/ ) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    var state = strm.state;
    if (state.window) state.window = null;
    strm.state = null;
    return $3bbf73f9f33166a2$var$Z_OK;
}
function $3bbf73f9f33166a2$var$inflateGetHeader(strm, head) {
    var state;
    /* check state */ if (!strm || !strm.state) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    if ((state.wrap & 2) === 0) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    /* save header structure */ state.head = head;
    head.done = false;
    return $3bbf73f9f33166a2$var$Z_OK;
}
function $3bbf73f9f33166a2$var$inflateSetDictionary(strm, dictionary) {
    var dictLength = dictionary.length;
    var state;
    var dictid;
    var ret;
    /* check state */ if (!strm /* == Z_NULL */  || !strm.state /* == Z_NULL */ ) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    state = strm.state;
    if (state.wrap !== 0 && state.mode !== $3bbf73f9f33166a2$var$DICT) return $3bbf73f9f33166a2$var$Z_STREAM_ERROR;
    /* check for correct dictionary identifier */ if (state.mode === $3bbf73f9f33166a2$var$DICT) {
        dictid = 1; /* adler32(0, null, 0)*/ 
        /* dictid = adler32(dictid, dictionary, dictLength); */ dictid = $jnGJc(dictid, dictionary, dictLength, 0);
        if (dictid !== state.check) return $3bbf73f9f33166a2$var$Z_DATA_ERROR;
    }
    /* copy dictionary to window using updatewindow(), which will amend the
   existing dictionary if appropriate */ ret = $3bbf73f9f33166a2$var$updatewindow(strm, dictionary, dictLength, dictLength);
    if (ret) {
        state.mode = $3bbf73f9f33166a2$var$MEM;
        return $3bbf73f9f33166a2$var$Z_MEM_ERROR;
    }
    state.havedict = 1;
    // Tracev((stderr, "inflate:   dictionary set\n"));
    return $3bbf73f9f33166a2$var$Z_OK;
}
$3bbf73f9f33166a2$export$42de45683a92ba94 = $3bbf73f9f33166a2$var$inflateReset;
$3bbf73f9f33166a2$export$7633ac2cd30f9650 = $3bbf73f9f33166a2$var$inflateReset2;
$3bbf73f9f33166a2$export$6710ea52c4ec9d6a = $3bbf73f9f33166a2$var$inflateResetKeep;
$3bbf73f9f33166a2$export$9c140b25e26874f9 = $3bbf73f9f33166a2$var$inflateInit;
$3bbf73f9f33166a2$export$6792d92addc5c8a0 = $3bbf73f9f33166a2$var$inflateInit2;
$3bbf73f9f33166a2$export$cae1ce83fe4a1782 = $3bbf73f9f33166a2$var$inflate;
$3bbf73f9f33166a2$export$224e1a443c3fba76 = $3bbf73f9f33166a2$var$inflateEnd;
$3bbf73f9f33166a2$export$6d4647cb9e1c75fc = $3bbf73f9f33166a2$var$inflateGetHeader;
$3bbf73f9f33166a2$export$60da749bed98ccf8 = $3bbf73f9f33166a2$var$inflateSetDictionary;
$3bbf73f9f33166a2$export$220f6291ca35fd71 = 'pako inflate (from Nodeca project)'; /* Not implemented
exports.inflateCopy = inflateCopy;
exports.inflateGetDictionary = inflateGetDictionary;
exports.inflateMark = inflateMark;
exports.inflatePrime = inflatePrime;
exports.inflateSync = inflateSync;
exports.inflateSyncPoint = inflateSyncPoint;
exports.inflateUndermine = inflateUndermine;
*/ 

});
parcelRegister("kMD3Z", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
// See state defs from inflate.js
var $f2169785c5a0f5f5$var$BAD = 30; /* got a data error -- remain here until reset */ 
var $f2169785c5a0f5f5$var$TYPE = 12; /* i: waiting for type bits, including last-flag bit */ 
/*
   Decode literal, length, and distance codes and write out the resulting
   literal and match bytes until either not enough input or output is
   available, an end-of-block is encountered, or a data error is encountered.
   When large enough input and output buffers are supplied to inflate(), for
   example, a 16K input buffer and a 64K output buffer, more than 95% of the
   inflate execution time is spent in this routine.

   Entry assumptions:

        state.mode === LEN
        strm.avail_in >= 6
        strm.avail_out >= 258
        start >= strm.avail_out
        state.bits < 8

   On return, state.mode is one of:

        LEN -- ran out of enough output space or enough available input
        TYPE -- reached end of block code, inflate() to interpret next block
        BAD -- error in block data

   Notes:

    - The maximum input bits used by a length/distance pair is 15 bits for the
      length code, 5 bits for the length extra, 15 bits for the distance code,
      and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
      Therefore if strm.avail_in >= 6, then there is enough input to avoid
      checking for available input while decoding.

    - The maximum bytes that a single length/distance pair can output is 258
      bytes, which is the maximum length that can be coded.  inflate_fast()
      requires strm.avail_out >= 258 for each loop to avoid checking for
      output space.
 */ module.exports = function inflate_fast(strm, start) {
    var state;
    var _in; /* local strm.input */ 
    var last; /* have enough input while in < last */ 
    var _out; /* local strm.output */ 
    var beg; /* inflate()'s initial strm.output */ 
    var end; /* while out < end, enough space available */ 
    //#ifdef INFLATE_STRICT
    var dmax; /* maximum distance from zlib header */ 
    //#endif
    var wsize; /* window size or zero if not using window */ 
    var whave; /* valid bytes in the window */ 
    var wnext; /* window write index */ 
    // Use `s_window` instead `window`, avoid conflict with instrumentation tools
    var s_window; /* allocated sliding window, if wsize != 0 */ 
    var hold; /* local strm.hold */ 
    var bits; /* local strm.bits */ 
    var lcode; /* local strm.lencode */ 
    var dcode; /* local strm.distcode */ 
    var lmask; /* mask for first level of length codes */ 
    var dmask; /* mask for first level of distance codes */ 
    var here; /* retrieved table entry */ 
    var op; /* code bits, operation, extra bits, or */ 
    /*  window position, window bytes to copy */ var len; /* match length, unused bytes */ 
    var dist; /* match distance */ 
    var from; /* where to copy match from */ 
    var from_source;
    var input, output; // JS specific, because we have no pointers
    /* copy state to local variables */ state = strm.state;
    //here = state.here;
    _in = strm.next_in;
    input = strm.input;
    last = _in + (strm.avail_in - 5);
    _out = strm.next_out;
    output = strm.output;
    beg = _out - (start - strm.avail_out);
    end = _out + (strm.avail_out - 257);
    //#ifdef INFLATE_STRICT
    dmax = state.dmax;
    //#endif
    wsize = state.wsize;
    whave = state.whave;
    wnext = state.wnext;
    s_window = state.window;
    hold = state.hold;
    bits = state.bits;
    lcode = state.lencode;
    dcode = state.distcode;
    lmask = (1 << state.lenbits) - 1;
    dmask = (1 << state.distbits) - 1;
    /* decode literals and length/distances until end-of-block or not enough
     input data or output space */ top: do {
        if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
        }
        here = lcode[hold & lmask];
        dolen: for(;;){
            op = here >>> 24 /*here.bits*/ ;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/ ;
            if (op === 0) //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
            //        "inflate:         literal '%c'\n" :
            //        "inflate:         literal 0x%02x\n", here.val));
            output[_out++] = here & 0xffff /*here.val*/ ;
            else if (op & 16) {
                len = here & 0xffff /*here.val*/ ;
                op &= 15; /* number of extra bits */ 
                if (op) {
                    if (bits < op) {
                        hold += input[_in++] << bits;
                        bits += 8;
                    }
                    len += hold & (1 << op) - 1;
                    hold >>>= op;
                    bits -= op;
                }
                //Tracevv((stderr, "inflate:         length %u\n", len));
                if (bits < 15) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    hold += input[_in++] << bits;
                    bits += 8;
                }
                here = dcode[hold & dmask];
                dodist: for(;;){
                    op = here >>> 24 /*here.bits*/ ;
                    hold >>>= op;
                    bits -= op;
                    op = here >>> 16 & 0xff /*here.op*/ ;
                    if (op & 16) {
                        dist = here & 0xffff /*here.val*/ ;
                        op &= 15; /* number of extra bits */ 
                        if (bits < op) {
                            hold += input[_in++] << bits;
                            bits += 8;
                            if (bits < op) {
                                hold += input[_in++] << bits;
                                bits += 8;
                            }
                        }
                        dist += hold & (1 << op) - 1;
                        //#ifdef INFLATE_STRICT
                        if (dist > dmax) {
                            strm.msg = 'invalid distance too far back';
                            state.mode = $f2169785c5a0f5f5$var$BAD;
                            break top;
                        }
                        //#endif
                        hold >>>= op;
                        bits -= op;
                        //Tracevv((stderr, "inflate:         distance %u\n", dist));
                        op = _out - beg; /* max distance in output */ 
                        if (dist > op) {
                            op = dist - op; /* distance back in window */ 
                            if (op > whave) {
                                if (state.sane) {
                                    strm.msg = 'invalid distance too far back';
                                    state.mode = $f2169785c5a0f5f5$var$BAD;
                                    break top;
                                }
                            }
                            from = 0; // window index
                            from_source = s_window;
                            if (wnext === 0) {
                                from += wsize - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            } else if (wnext < op) {
                                from += wsize + wnext - op;
                                op -= wnext;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = 0;
                                    if (wnext < len) {
                                        op = wnext;
                                        len -= op;
                                        do output[_out++] = s_window[from++];
                                        while (--op);
                                        from = _out - dist; /* rest from output */ 
                                        from_source = output;
                                    }
                                }
                            } else {
                                from += wnext - op;
                                if (op < len) {
                                    len -= op;
                                    do output[_out++] = s_window[from++];
                                    while (--op);
                                    from = _out - dist; /* rest from output */ 
                                    from_source = output;
                                }
                            }
                            while(len > 2){
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                output[_out++] = from_source[from++];
                                len -= 3;
                            }
                            if (len) {
                                output[_out++] = from_source[from++];
                                if (len > 1) output[_out++] = from_source[from++];
                            }
                        } else {
                            from = _out - dist; /* copy direct from output */ 
                            do {
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                output[_out++] = output[from++];
                                len -= 3;
                            }while (len > 2);
                            if (len) {
                                output[_out++] = output[from++];
                                if (len > 1) output[_out++] = output[from++];
                            }
                        }
                    } else if ((op & 64) === 0) {
                        here = dcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                        continue dodist;
                    } else {
                        strm.msg = 'invalid distance code';
                        state.mode = $f2169785c5a0f5f5$var$BAD;
                        break top;
                    }
                    break; // need to emulate goto via "continue"
                }
            } else if ((op & 64) === 0) {
                here = lcode[(here & 0xffff) + (hold & (1 << op) - 1)];
                continue dolen;
            } else if (op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.mode = $f2169785c5a0f5f5$var$TYPE;
                break top;
            } else {
                strm.msg = 'invalid literal/length code';
                state.mode = $f2169785c5a0f5f5$var$BAD;
                break top;
            }
            break; // need to emulate goto via "continue"
        }
    }while (_in < last && _out < end);
    /* return unused bytes (on entry, bits < 8, so in won't go too far back) */ len = bits >> 3;
    _in -= len;
    bits -= len << 3;
    hold &= (1 << bits) - 1;
    /* update state and return */ strm.next_in = _in;
    strm.next_out = _out;
    strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
    strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
    state.hold = hold;
    state.bits = bits;
    return;
};

});

parcelRegister("3B1jT", function(module, exports) {
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");
var $29e5d9e15bb935d1$var$MAXBITS = 15;
var $29e5d9e15bb935d1$var$ENOUGH_LENS = 852;
var $29e5d9e15bb935d1$var$ENOUGH_DISTS = 592;
//var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);
var $29e5d9e15bb935d1$var$CODES = 0;
var $29e5d9e15bb935d1$var$LENS = 1;
var $29e5d9e15bb935d1$var$DISTS = 2;
var $29e5d9e15bb935d1$var$lbase = [
    /* Length codes 257..285 base */ 3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    13,
    15,
    17,
    19,
    23,
    27,
    31,
    35,
    43,
    51,
    59,
    67,
    83,
    99,
    115,
    131,
    163,
    195,
    227,
    258,
    0,
    0
];
var $29e5d9e15bb935d1$var$lext = [
    /* Length codes 257..285 extra */ 16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    16,
    72,
    78
];
var $29e5d9e15bb935d1$var$dbase = [
    /* Distance codes 0..29 base */ 1,
    2,
    3,
    4,
    5,
    7,
    9,
    13,
    17,
    25,
    33,
    49,
    65,
    97,
    129,
    193,
    257,
    385,
    513,
    769,
    1025,
    1537,
    2049,
    3073,
    4097,
    6145,
    8193,
    12289,
    16385,
    24577,
    0,
    0
];
var $29e5d9e15bb935d1$var$dext = [
    /* Distance codes 0..29 extra */ 16,
    16,
    16,
    16,
    17,
    17,
    18,
    18,
    19,
    19,
    20,
    20,
    21,
    21,
    22,
    22,
    23,
    23,
    24,
    24,
    25,
    25,
    26,
    26,
    27,
    27,
    28,
    28,
    29,
    29,
    64,
    64
];
module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
    var bits = opts.bits;
    //here = opts.here; /* table entry for duplication */
    var len = 0; /* a code's length in bits */ 
    var sym = 0; /* index of code symbols */ 
    var min = 0, max = 0; /* minimum and maximum code lengths */ 
    var root = 0; /* number of index bits for root table */ 
    var curr = 0; /* number of index bits for current table */ 
    var drop = 0; /* code bits to drop for sub-table */ 
    var left = 0; /* number of prefix codes available */ 
    var used = 0; /* code entries in table used */ 
    var huff = 0; /* Huffman code */ 
    var incr; /* for incrementing code, index */ 
    var fill; /* index for replicating entries */ 
    var low; /* low bits for current root entry */ 
    var mask; /* mask for low root bits */ 
    var next; /* next available space in table */ 
    var base = null; /* base value table to use */ 
    var base_index = 0;
    //  var shoextra;    /* extra bits table to use */
    var end; /* use base and extra for symbol > end */ 
    var count = new $8NmFQ.Buf16($29e5d9e15bb935d1$var$MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
    var offs = new $8NmFQ.Buf16($29e5d9e15bb935d1$var$MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
    var extra = null;
    var extra_index = 0;
    var here_bits, here_op, here_val;
    /*
   Process a set of code lengths to create a canonical Huffman code.  The
   code lengths are lens[0..codes-1].  Each length corresponds to the
   symbols 0..codes-1.  The Huffman code is generated by first sorting the
   symbols by length from short to long, and retaining the symbol order
   for codes with equal lengths.  Then the code starts with all zero bits
   for the first code of the shortest length, and the codes are integer
   increments for the same length, and zeros are appended as the length
   increases.  For the deflate format, these bits are stored backwards
   from their more natural integer increment ordering, and so when the
   decoding tables are built in the large loop below, the integer codes
   are incremented backwards.

   This routine assumes, but does not check, that all of the entries in
   lens[] are in the range 0..MAXBITS.  The caller must assure this.
   1..MAXBITS is interpreted as that code length.  zero means that that
   symbol does not occur in this code.

   The codes are sorted by computing a count of codes for each length,
   creating from that a table of starting indices for each length in the
   sorted table, and then entering the symbols in order in the sorted
   table.  The sorted table is work[], with that space being provided by
   the caller.

   The length counts are used for other purposes as well, i.e. finding
   the minimum and maximum length codes, determining if there are any
   codes at all, checking for a valid set of lengths, and looking ahead
   at length counts to determine sub-table sizes when building the
   decoding tables.
   */ /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */ for(len = 0; len <= $29e5d9e15bb935d1$var$MAXBITS; len++)count[len] = 0;
    for(sym = 0; sym < codes; sym++)count[lens[lens_index + sym]]++;
    /* bound code lengths, force root to be within code lengths */ root = bits;
    for(max = $29e5d9e15bb935d1$var$MAXBITS; max >= 1; max--){
        if (count[max] !== 0) break;
    }
    if (root > max) root = max;
    if (max === 0) {
        //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
        //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
        //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
        table[table_index++] = 20971520;
        //table.op[opts.table_index] = 64;
        //table.bits[opts.table_index] = 1;
        //table.val[opts.table_index++] = 0;
        table[table_index++] = 20971520;
        opts.bits = 1;
        return 0; /* no symbols, but wait for decoding to report error */ 
    }
    for(min = 1; min < max; min++){
        if (count[min] !== 0) break;
    }
    if (root < min) root = min;
    /* check for an over-subscribed or incomplete set of lengths */ left = 1;
    for(len = 1; len <= $29e5d9e15bb935d1$var$MAXBITS; len++){
        left <<= 1;
        left -= count[len];
        if (left < 0) return -1;
         /* over-subscribed */ 
    }
    if (left > 0 && (type === $29e5d9e15bb935d1$var$CODES || max !== 1)) return -1; /* incomplete set */ 
    /* generate offsets into symbol table for each length for sorting */ offs[1] = 0;
    for(len = 1; len < $29e5d9e15bb935d1$var$MAXBITS; len++)offs[len + 1] = offs[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(sym = 0; sym < codes; sym++)if (lens[lens_index + sym] !== 0) work[offs[lens[lens_index + sym]]++] = sym;
    /*
   Create and fill in decoding tables.  In this loop, the table being
   filled is at next and has curr index bits.  The code being used is huff
   with length len.  That code is converted to an index by dropping drop
   bits off of the bottom.  For codes where len is less than drop + curr,
   those top drop + curr - len bits are incremented through all values to
   fill the table with replicated entries.

   root is the number of index bits for the root table.  When len exceeds
   root, sub-tables are created pointed to by the root entry with an index
   of the low root bits of huff.  This is saved in low to check for when a
   new sub-table should be started.  drop is zero when the root table is
   being filled, and drop is root when sub-tables are being filled.

   When a new sub-table is needed, it is necessary to look ahead in the
   code lengths to determine what size sub-table is needed.  The length
   counts are used for this, and so count[] is decremented as codes are
   entered in the tables.

   used keeps track of how many table entries have been allocated from the
   provided *table space.  It is checked for LENS and DIST tables against
   the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
   the initial root table size constants.  See the comments in inftrees.h
   for more information.

   sym increments through all symbols, and the loop terminates when
   all codes of length max, i.e. all codes, have been processed.  This
   routine permits incomplete codes, so another loop after this one fills
   in the rest of the decoding tables with invalid code markers.
   */ /* set up for code type */ // poor man optimization - use if-else instead of switch,
    // to avoid deopts in old v8
    if (type === $29e5d9e15bb935d1$var$CODES) {
        base = extra = work; /* dummy value--not used */ 
        end = 19;
    } else if (type === $29e5d9e15bb935d1$var$LENS) {
        base = $29e5d9e15bb935d1$var$lbase;
        base_index -= 257;
        extra = $29e5d9e15bb935d1$var$lext;
        extra_index -= 257;
        end = 256;
    } else {
        base = $29e5d9e15bb935d1$var$dbase;
        extra = $29e5d9e15bb935d1$var$dext;
        end = -1;
    }
    /* initialize opts for loop */ huff = 0; /* starting code */ 
    sym = 0; /* starting code symbol */ 
    len = min; /* starting code length */ 
    next = table_index; /* current table to fill in */ 
    curr = root; /* current table index bits */ 
    drop = 0; /* current bits to drop from code for index */ 
    low = -1; /* trigger new sub-table when len > root */ 
    used = 1 << root; /* use root table entries */ 
    mask = used - 1; /* mask for comparing low */ 
    /* check available table space */ if (type === $29e5d9e15bb935d1$var$LENS && used > $29e5d9e15bb935d1$var$ENOUGH_LENS || type === $29e5d9e15bb935d1$var$DISTS && used > $29e5d9e15bb935d1$var$ENOUGH_DISTS) return 1;
    /* process all codes and make table entries */ for(;;){
        /* create table entry */ here_bits = len - drop;
        if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
        } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
        } else {
            here_op = 96; /* end of block */ 
            here_val = 0;
        }
        /* replicate for those indices with low len bits equal to huff */ incr = 1 << len - drop;
        fill = 1 << curr;
        min = fill; /* save offset to next table */ 
        do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
        }while (fill !== 0);
        /* backwards increment the len-bit code huff */ incr = 1 << len - 1;
        while(huff & incr)incr >>= 1;
        if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
        } else huff = 0;
        /* go to next symbol, update count, len */ sym++;
        if (--count[len] === 0) {
            if (len === max) break;
            len = lens[lens_index + work[sym]];
        }
        /* create new sub-table if needed */ if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */ if (drop === 0) drop = root;
            /* increment past last table */ next += min; /* here min is 1 << curr */ 
            /* determine length of next table */ curr = len - drop;
            left = 1 << curr;
            while(curr + drop < max){
                left -= count[curr + drop];
                if (left <= 0) break;
                curr++;
                left <<= 1;
            }
            /* check for enough space */ used += 1 << curr;
            if (type === $29e5d9e15bb935d1$var$LENS && used > $29e5d9e15bb935d1$var$ENOUGH_LENS || type === $29e5d9e15bb935d1$var$DISTS && used > $29e5d9e15bb935d1$var$ENOUGH_DISTS) return 1;
            /* point entry in root table to sub-table */ low = huff & mask;
            /*table.op[low] = curr;
      table.bits[low] = root;
      table.val[low] = next - opts.table_index;*/ table[low] = root << 24 | curr << 16 | next - table_index | 0;
        }
    }
    /* fill in remaining table entry if code is incomplete (guaranteed to have
   at most one remaining entry, since if the code is incomplete, the
   maximum code length that was allowed to get this far is one bit) */ if (huff !== 0) //table.op[next + huff] = 64;            /* invalid code marker */
    //table.bits[next + huff] = len - drop;
    //table.val[next + huff] = 0;
    table[next + huff] = len - drop << 24 | 4194304;
    /* set return parameters */ //opts.table_index += used;
    opts.bits = root;
    return 0;
};

});


parcelRegister("69DFd", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
module.exports = {
    /* Allowed flush values; see deflate() and inflate() below for details */ Z_NO_FLUSH: 0,
    Z_PARTIAL_FLUSH: 1,
    Z_SYNC_FLUSH: 2,
    Z_FULL_FLUSH: 3,
    Z_FINISH: 4,
    Z_BLOCK: 5,
    Z_TREES: 6,
    /* Return codes for the compression/decompression functions. Negative values
  * are errors, positive values are used for special but normal events.
  */ Z_OK: 0,
    Z_STREAM_END: 1,
    Z_NEED_DICT: 2,
    Z_ERRNO: -1,
    Z_STREAM_ERROR: -2,
    Z_DATA_ERROR: -3,
    //Z_MEM_ERROR:     -4,
    Z_BUF_ERROR: -5,
    //Z_VERSION_ERROR: -6,
    /* compression levels */ Z_NO_COMPRESSION: 0,
    Z_BEST_SPEED: 1,
    Z_BEST_COMPRESSION: 9,
    Z_DEFAULT_COMPRESSION: -1,
    Z_FILTERED: 1,
    Z_HUFFMAN_ONLY: 2,
    Z_RLE: 3,
    Z_FIXED: 4,
    Z_DEFAULT_STRATEGY: 0,
    /* Possible values of the data_type field (though see inflate()) */ Z_BINARY: 0,
    Z_TEXT: 1,
    //Z_ASCII:                1, // = Z_TEXT (deprecated)
    Z_UNKNOWN: 2,
    /* The deflate compression method */ Z_DEFLATED: 8
};

});




parcelRegister("e2AP9", function(module, exports) {
var $a38dd11793775bea$var$__filename = "node_modules/libheif-js/libheif/libheif.js";
var $a38dd11793775bea$var$__dirname = "node_modules/libheif-js/libheif";

var $5XqL3 = parcelRequire("5XqL3");

var $kJBqN = parcelRequire("kJBqN");
var $a38dd11793775bea$require$Buffer = $kJBqN.Buffer;



var $a38dd11793775bea$var$libheif = (()=>{
    var Ck;
    var Jr = typeof document != "undefined" ? (Ck = document.currentScript) == null ? void 0 : Ck.src : void 0;
    return typeof $a38dd11793775bea$var$__filename != "undefined" && (Jr || (Jr = $a38dd11793775bea$var$__filename)), function(wu = {}) {
        var Vk, K = wu, yk, Rr, QD = new Promise((Y, N)=>{
            yk = Y, Rr = N;
        }), vu = typeof window == "object", Li = typeof importScripts == "function", Ki = false, Ik = Object.assign({}, K), Fk = [], Nr = "./this.program", Yk = (Y, N)=>{
            throw N;
        }, x4 = "";
        function _u(Y) {
            return K.locateFile ? K.locateFile(Y, x4) : x4 + Y;
        }
        var x6, Dr, qi;
        if (Ki) {
            var Mr = (parcelRequire("hDwn7")), Ek = (parcelRequire("5Nzmz"));
            x4 = $a38dd11793775bea$var$__dirname + "/", x6 = (Y, N)=>(Y = zr(Y) ? new URL(Y) : Ek.normalize(Y), Mr.readFileSync(Y, N ? void 0 : "utf8")), qi = (Y)=>{
                var N = x6(Y, !0);
                return N.buffer || (N = new Uint8Array(N)), N;
            }, Dr = (Y, N, x, O = !0)=>{
                Y = zr(Y) ? new URL(Y) : Ek.normalize(Y), Mr.readFile(Y, O ? void 0 : "utf8", (b, a)=>{
                    b ? x(b) : N(O ? a.buffer : a);
                });
            }, !K.thisProgram && $5XqL3.argv.length > 1 && (Nr = $5XqL3.argv[1].replace(/\\/g, "/")), Fk = $5XqL3.argv.slice(2), Yk = (Y, N)=>{
                throw $5XqL3.exitCode = Y, N;
            };
        } else (vu || Li) && (Li ? x4 = self.location.href : typeof document != "undefined" && document.currentScript && (x4 = document.currentScript.src), Jr && (x4 = Jr), x4.startsWith("blob:") ? x4 = "" : x4 = x4.substr(0, x4.replace(/[?#].*/, "").lastIndexOf("/") + 1), x6 = (Y)=>{
            var N = new XMLHttpRequest;
            return N.open("GET", Y, !1), N.send(null), N.responseText;
        }, Li && (qi = (Y)=>{
            var N = new XMLHttpRequest;
            return N.open("GET", Y, !1), N.responseType = "arraybuffer", N.send(null), new Uint8Array(N.response);
        }), Dr = (Y, N, x)=>{
            if (zr(Y)) {
                var O = new XMLHttpRequest;
                O.open("GET", Y, !0), O.responseType = "arraybuffer", O.onload = ()=>{
                    if (O.status == 200 || O.status == 0 && O.response) {
                        N(O.response);
                        return;
                    }
                    x();
                }, O.onerror = x, O.send(null);
                return;
            }
            fetch(Y, {
                credentials: "same-origin"
            }).then((b)=>b.ok ? b.arrayBuffer() : Promise.reject(new Error(b.status + " : " + b.url))).then(N, x);
        });
        var Ur = K.print || console.log.bind(console), z6 = K.printErr || console.error.bind(console);
        Object.assign(K, Ik), Ik = null, K.arguments && (Fk = K.arguments), K.thisProgram && (Nr = K.thisProgram), K.quit && (Yk = K.quit);
        var $i;
        K.wasmBinary && ($i = K.wasmBinary);
        var T6 = {
            Memory: function(Y) {
                this.buffer = new ArrayBuffer(Y.initial * 65536);
            },
            Module: function(Y) {},
            Instance: function(Y, N) {
                this.exports = function(O) {
                    function b(b2) {
                        return b2.set = function(R2, o) {
                            this[R2] = o;
                        }, b2.get = function(R2) {
                            return this[R2];
                        }, b2;
                    }
                    for(var a, o0 = new Uint8Array(123), h0 = 25; h0 >= 0; --h0)o0[48 + h0] = 52 + h0, o0[65 + h0] = h0, o0[97 + h0] = 26 + h0;
                    o0[43] = 62, o0[47] = 63;
                    function u0(b2, R2, o) {
                        for(var Q, i, l = 0, I = R2, k0 = o.length, W0 = R2 + (k0 * 3 >> 2) - (o[k0 - 2] == "=") - (o[k0 - 1] == "="); l < k0; l += 4)Q = o0[o.charCodeAt(l + 1)], i = o0[o.charCodeAt(l + 2)], b2[I++] = o0[o.charCodeAt(l)] << 2 | Q >> 4, I < W0 && (b2[I++] = Q << 4 | i >> 2), I < W0 && (b2[I++] = i << 6 | o0[o.charCodeAt(l + 3)]);
                    }
                    function U0(b2) {
                        u0(a, 1024, "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"), u0(a, 39340, "PQqXPpqZGT8AAAAAAAAAAI/CNT+amRk/7FEYP+xRGD/pJjE/MQhMPwAAgD/XozA/16MwPw=="), u0(a, 39428, "SOEaP5qZGT4AAAAAAAAAAClcDz6amRk+UrgePlK4Hj7hehQ+3SQGPgAAAACamRk+mpkZPg=="), u0(a, 39516, "UrgePo/CdT0AAAAAAAAAAArXoz2PwnU9KVyPPSlcjz05tEg9f2o8PQAAAACPwnU9j8J1PQ=="), u0(a, 39604, "LbKdPQrXIz8AAAAAAAAAAB+FKz8K1yM/rkchP65HIT8EVi4/fT81PwAAgD97FC4/exQuPw=="), u0(a, 39692, "rkchP8P1qD4AAAAAAAAAAMP1qD7D9ag+exSuPnsUrj74U6M+BoGVPgAAAAAK16M+CtejPg=="), u0(a, 39780, "exSuPjcaoD4AAAAAAAAAAFK4nj43GqA+NxqgPjcaoD5SuJ4+NxqgPp+qqj6cxKA+NxqgPg=="), u0(a, 39868, "NxqgPrByqD4AAAAAAAAAAMHKoT6wcqg+sHKoPrByqD7ByqE+sHKoPjuqqj5GtrM+sHKoPg=="), u0(a, 39956, "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"), u0(a, 42208, "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"), u0(a, 46652, "AQAAAAIAAABMAAAAVAAAAFQAAABQAAAAWAAAAFgAAADAQQAAyEEAAMhB"), u0(a, 46704, "xQAAALkAAADJAAAAxQAAALkAAADJAAAAlQAAAIYAAABuAAAAmgAAAHoAAACJAAAAjAAAAMYAAACpAAAAxgAAAIsAAACNAAAAnQAAAGsAAACLAAAAfgAAAGsAAACLAAAAfg=="), u0(a, 46816, "uAAAAJoAAACLAAAAmgAAAJoAAACaAAAAiwAAAJoAAACaAAAAuAAAAJoAAAC3AAAAPwAAAJgAAACYAAAAAAAAAG8AAACNAAAAmQAAAG8AAABeAAAAigAAALYAAACaAAAAlQAAAGsAAACnAAAAmgAAAJUAAABcAAAApwAAAJoAAACZAAAAigAAAIoAAAB8AAAAigAAAF4AAADgAAAApwAAAHo="), u0(a, 46992, "bgAAAG4AAAB8AAAAfQAAAIwAAACZAAAAfQAAAH8AAACMAAAAbQAAAG8AAACPAAAAfwAAAG8AAABPAAAAbAAAAHsAAAA/AAAAfQAAAG4AAABeAAAAbgAAAF8AAABPAAAAfQAAAG8AAABuAAAATgAAAG4AAABvAAAAbwAAAF8AAABeAAAAbAAAAHsAAABsAAAAfQAAAG4AAAB8AAAAbgAAAF8AAABeAAAAfQAAAG8AAABvAAAATwAAAH0AAAB+AAAAbwAAAG8AAABPAAAAbAAAAHsAAABd"), u0(a, 47216, "WwAAAKsAAACGAAAAjQAAAHkAAACMAAAAPQAAAJoAAAB5AAAAjAAAAD0AAACaAAAAbwAAAG8AAAB9AAAAbgAAAG4AAABeAAAAfAAAAGwAAAB8AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAawAAAH0AAACNAAAAswAAAJkAAAB9AAAAjAAAAIsAAAC2AAAAtgAAAJgAAACIAAAAmAAAAIgAAACZAAAAiAAAAIsAAABvAAAAiAAAAIsAAABvAAAAmwAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAACZAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAAB7AAAAewAAAGsAAAB5AAAAawAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACMAAAAqgAAAJoAAACLAAAAmQAAAIsAAAB7AAAAewAAAD8AAAB8AAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAApgAAALcAAACMAAAAiAAAAJkAAACaAAAAqgAAAJkAAACKAAAAigAAAHoAAAB5AAAAegAAAHkAAACnAAAAlwAAALcAAACMAAAAlwAAALcAAACM"), u0(a, 47776, "jQAAAG8AAACMAAAAjAAAAIwAAACM"), u0(a, 47808, "jAAAAFwAAACJAAAAigAAAIwAAACYAAAAigAAAIsAAACZAAAASgAAAJUAAABcAAAAiwAAAGsAAAB6AAAAmAAAAIwAAACzAAAApgAAALYAAACMAAAA4wAAAHoAAADFAAAAmgAAAMQAAADEAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAiQAAAKkAAADCAAAApgAAAKcAAACaAAAApwAAAIkAAAC2AAAAmgAAAMQAAACnAAAApwAAAJoAAACYAAAApwAAALYAAAC2AAAAhgAAAJUAAACIAAAAmQAAAHkAAACIAAAAegAAAKkAAADQAAAApgAAAKcAAACaAAAAmAAAAKcAAAC2AAAAigAAAJkAAACIAAAApwAAAJgAAACYAAAAawAAAKcAAABbAAAAegAAAGsAAACnAAAAawAAAKcAAABbAAAAawAAAGsAAACnAAAAyAAAALkAAACgAAAAAAAAAIC8AACVBAAAlgQAAJcEAACYBAAAMjZ0aHJlYWRfdGFza19kZWJsb2NrX0NUQlJvdwAxMXRocmVhZF90YXNrAADcGwEAabwAAAQcAQBMvAAAeLw="), u0(a, 48288, "BgcICQoLDA0ODxAREhQWGBocHiAiJCYoKiwuMDI0Njg6PD5A"), u0(a, 48354, "AQEBAQEBAQEBAgICAgMDAwMEBAQFBQYGBwgJCgsNDhASFBYY"), u0(a, 48400, "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"), u0(a, 50512, "NFYBAOBgAQDwYAEAEGEBAJBhAQCQYwE="), u0(a, 50544, "NFYBAJBrAQCgawEAwGsBAEBsAQBAbgE="), u0(a, 50584, "QHYBAGB2AQDgdgEA4HgB"), u0(a, 50608, "4IABAACBAQCAgQEAgIMB"), u0(a, 50632, "gIsBAKCLAQAgjAEAII4BADDFAABQxQAAcMU="), u0(a, 50680, "IAAAABoAAAAVAAAAEQAAAA0AAAAJAAAABQAAAAIAAAAAAAAA/v////v////3////8////+/////r////5v///+D////m////6////+/////z////9/////v////+////AAAAAAIAAAAFAAAACQAAAA0AAAARAAAAFQAAABoAAAAgAAAAAAAAAADw//+a+f//cvz//4r9//8e/v//ev7//8X+//8A////xf7//3r+//8e/v//iv3//3L8//+a+f//APD//wAAAAAAAAAAAQAAAAAAAAACAAAAAQAAAAIAAAAAAAAAAwAAAAEAAAADAAAAAgAAAAMAAAABAAAAAAAAAAIAAAAAAAAAAgAAAAEAAAADAAAAAAAAAAMAAAABAAAAAwAAAAIAAAAAAAAAcMcAAAEFAAACBQAAMzBNb3Rpb25WZWN0b3JBY2Nlc3NfZGUyNjVfaW1hZ2UAMThNb3Rpb25WZWN0b3JBY2Nlc3MAAADcGwEAUccAAAQcAQAwxwAAaMc="), u0(a, 51076, "AwAAAAMAAAACAAAAAAAAAAMAAAAEAAAABAAAAAABBAUCAwQFBgYICAcHCGMAAAAAGgAAAAoAAAABAAAAAAECAgICAwUHCAoMDQ8REhMUFRYXFxgYGRkaGxscHB0dHh8AAAAAABjIAACVBAAAAwUAAAQFAAAFBQAAMjV0aHJlYWRfdGFza19zbGljZV9zZWdtZW50AAQcAQD8xwAAeLwAAAAAAABUyAAAlQQAAAYFAAAHBQAACAUAADE5dGhyZWFkX3Rhc2tfY3RiX3JvdwAAAAQcAQA8yAAAeLwAAAEAAAACAAAAAgAAAAEAAAABAAAAAgAAAAEAAAABAAAAoSkAAIRHAAAKRgAAAAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIQAAACIAAAAiAAAAIwAAACMAAAAkAAAAJAAAACU="), u0(a, 51408, "KAAAAC0AAAAzAAAAOQAAAEAAAABIAAAASR0AAJpHAADbJwAAghA="), u0(a, 51460, "AQABAAwACwAKAAsAEAALACgAIQAYAAsAFAALACAACwBQACEAEgALAA8ACwBAACEAoABjAAQAAwADAAIAAgABAAAAAAABDQAAHD8AANBAAACzPgAA1UAAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0loTlNfMTFjaGFyX3RyYWl0c0loRUVOU185YWxsb2NhdG9ySWhFRUVFAADcGwEAXMkAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0l3TlNfMTFjaGFyX3RyYWl0c0l3RUVOU185YWxsb2NhdG9ySXdFRUVFAADcGwEApMkAAE5TdDNfXzIxMmJhc2ljX3N0cmluZ0lEc05TXzExY2hhcl90cmFpdHNJRHNFRU5TXzlhbGxvY2F0b3JJRHNFRUVFAAAA3BsBAOzJAABOU3QzX18yMTJiYXNpY19zdHJpbmdJRGlOU18xMWNoYXJfdHJhaXRzSURpRUVOU185YWxsb2NhdG9ySURpRUVFRQAAANwbAQA4ygAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJY0VFAADcGwEAhMoAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWFFRQAA3BsBAKzKAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lzRUUAANwbAQDUygAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJdEVFAADcGwEA/MoAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWlFRQAA3BsBACTLAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lqRUUAANwbAQBMywAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJbEVFAADcGwEAdMsAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SW1FRQAA3BsBAJzLAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0l4RUUAANwbAQDEywAATjEwZW1zY3JpcHRlbjExbWVtb3J5X3ZpZXdJeUVFAADcGwEA7MsAAE4xMGVtc2NyaXB0ZW4xMW1lbW9yeV92aWV3SWZFRQAA3BsBABTMAABOMTBlbXNjcmlwdGVuMTFtZW1vcnlfdmlld0lkRUUAANwbAQA8zA=="), u0(a, 52336, "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"), u0(a, 55123, "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"), u0(a, 57122, "pQJbAPABtQWMBSUBgwYdA5QE/wDHAzEDCwa8AY8BfwPKBCsA2gavAEIDTgPcAQ4EFQChBg0BlAILAjgGZAK8Av8CXQPnBAsHzwLLBe8F2wXhAh4GRQKFAIICbANvBPEA8wMYBdkA2gNMBlQCewGdA70EAABRABUCuwCzA20A/wGFBC8F+QQ4AGUBRgGfALcGqAFzAlMB"), u0(a, 57320, "IQQAAAAAAAAAAC8C"), u0(a, 57352, "NQRHBFYE"), u0(a, 57374, "oAQ="), u0(a, 57394, "RgVgBW4FYQYAAM8BAAAAAAAAAADJBukG+QYeBzkHSQdeBw=="), u0(a, 57440, "GQALABkZGQAAAAAFAAAAAAAACQAAAAALAAAAAAAAAAAZAAoKGRkZAwoHAAEACQsYAAAJBgsAAAsABhkAAAAZGRk="), u0(a, 57521, "DgAAAAAAAAAAGQALDRkZGQANAAACAAkOAAAACQAOAAAO"), u0(a, 57579, "DA=="), u0(a, 57591, "EwAAAAATAAAAAAkMAAAAAAAMAAAM"), u0(a, 57637, "EA=="), u0(a, 57649, "DwAAAAQPAAAAAAkQAAAAAAAQAAAQ"), u0(a, 57695, "Eg=="), u0(a, 57707, "EQAAAAARAAAAAAkSAAAAAAASAAASAAAaAAAAGhoa"), u0(a, 57762, "GgAAABoaGgAAAAAAAAk="), u0(a, 57811, "FA=="), u0(a, 57823, "FwAAAAAXAAAAAAkUAAAAAAAUAAAU"), u0(a, 57869, "Fg=="), u0(a, 57881, "FQAAAAAVAAAAAAkWAAAAAAAWAAAWAAAwMTIzNDU2Nzg5QUJDREVG"), u0(a, 57956, "EQU="), u0(a, 57996, "//////////8="), u0(a, 58068, "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"), u0(a, 60784, "NO0="), u0(a, 60816, "AgAAwAMAAMAEAADABQAAwAYAAMAHAADACAAAwAkAAMAKAADACwAAwAwAAMANAADADgAAwA8AAMAQAADAEQAAwBIAAMATAADAFAAAwBUAAMAWAADAFwAAwBgAAMAZAADAGgAAwBsAAMAcAADAHQAAwB4AAMAfAADAAAAAswEAAMMCAADDAwAAwwQAAMMFAADDBgAAwwcAAMMIAADDCQAAwwoAAMMLAADDDAAAww0AANMOAADDDwAAwwAADLsBAAzDAgAMwwMADMMEAAzbAAAAALTuAAAUBQAAcAUAAHEFAAAXBQAAGAUAABkFAAAaBQAAGwUAABwFAAByBQAAcwUAAHQFAAAgBQAAIQUAAE5TdDNfXzIxMF9fc3RkaW5idWZJY0VFAAQcAQCc7gAA5OYAAAAAAAAc7wAAFAUAAHUFAAB2BQAAFwUAABgFAAAZBQAAdwUAABsFAAAcBQAAHQUAAB4FAAAfBQAAeAUAAHkFAABOU3QzX18yMTFfX3N0ZG91dGJ1ZkljRUUAAAAABBwBAADvAADk5gAAAAAAAIDvAAAwBQAAegUAAHsFAAAzBQAANAUAADUFAAA2BQAANwUAADgFAAB8BQAAfQUAAH4FAAA8BQAAPQUAAE5TdDNfXzIxMF9fc3RkaW5idWZJd0VFAAQcAQBo7wAAmOgAAAAAAADo7wAAMAUAAH8FAACABQAAMwUAADQFAAA1BQAAgQUAADcFAAA4BQAAOQUAADoFAAA7BQAAggUAAIMFAABOU3QzX18yMTFfX3N0ZG91dGJ1Zkl3RUUAAAAABBwBAMzvAACY6A=="), u0(a, 61440, "0XSeAFedvSqAcFIP//8+JwoAAABkAAAA6AMAABAnAACghgEAQEIPAICWmAAA4fUFGAAAADUAAABxAAAAa////877//+Sv///AAAAAAAAAAD/////////////////////////////////////////////////////////////////AAECAwQFBgcICf////////8KCwwNDg8QERITFBUWFxgZGhscHR4fICEiI////////woLDA0ODxAREhMUFRYXGBkaGxwdHh8gISIj/////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////wABAgQHAwYFAAAAAAAAAExDX0NUWVBFAAAAAExDX05VTUVSSUMAAExDX1RJTUUAAAAAAExDX0NPTExBVEUAAExDX01PTkVUQVJZAExDX01FU1NBR0VTALDz"), u0(a, 62388, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAEEAAABCAAAAQwAAAEQAAABFAAAARgAAAEcAAABIAAAASQAAAEoAAABLAAAATAAAAE0AAABOAAAATwAAAFAAAABRAAAAUgAAAFMAAABUAAAAVQAAAFYAAABXAAAAWAAAAFkAAABaAAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAQQAAAEIAAABDAAAARAAAAEUAAABGAAAARwAAAEgAAABJAAAASgAAAEsAAABMAAAATQAAAE4AAABPAAAAUAAAAFEAAABSAAAAUwAAAFQAAABVAAAAVgAAAFcAAABYAAAAWQAAAFoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), u0(a, 63408, "wPk="), u0(a, 63940, "AQAAAAIAAAADAAAABAAAAAUAAAAGAAAABwAAAAgAAAAJAAAACgAAAAsAAAAMAAAADQAAAA4AAAAPAAAAEAAAABEAAAASAAAAEwAAABQAAAAVAAAAFgAAABcAAAAYAAAAGQAAABoAAAAbAAAAHAAAAB0AAAAeAAAAHwAAACAAAAAhAAAAIgAAACMAAAAkAAAAJQAAACYAAAAnAAAAKAAAACkAAAAqAAAAKwAAACwAAAAtAAAALgAAAC8AAAAwAAAAMQAAADIAAAAzAAAANAAAADUAAAA2AAAANwAAADgAAAA5AAAAOgAAADsAAAA8AAAAPQAAAD4AAAA/AAAAQAAAAGEAAABiAAAAYwAAAGQAAABlAAAAZgAAAGcAAABoAAAAaQAAAGoAAABrAAAAbAAAAG0AAABuAAAAbwAAAHAAAABxAAAAcgAAAHMAAAB0AAAAdQAAAHYAAAB3AAAAeAAAAHkAAAB6AAAAWwAAAFwAAABdAAAAXgAAAF8AAABgAAAAYQAAAGIAAABjAAAAZAAAAGUAAABmAAAAZwAAAGgAAABpAAAAagAAAGsAAABsAAAAbQAAAG4AAABvAAAAcAAAAHEAAAByAAAAcwAAAHQAAAB1AAAAdgAAAHcAAAB4AAAAeQAAAHoAAAB7AAAAfAAAAH0AAAB+AAAAfw=="), u0(a, 64960, "MDEyMzQ1Njc4OWFiY2RlZkFCQ0RFRnhYKy1wUGlJbk4AJUk6JU06JVMgJXAlSDolTQ=="), u0(a, 65024, "JQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAlAAAAWQAAAC0AAAAlAAAAbQAAAC0AAAAlAAAAZAAAACUAAABJAAAAOgAAACUAAABNAAAAOgAAACUAAABTAAAAIAAAACUAAABwAAAAAAAAACUAAABIAAAAOgAAACUAAABN"), u0(a, 65168, "JQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAABAgBAJkFAACaBQAAmwUAAAAAAABkCAEAnAUAAJ0FAACbBQAAngUAAJ8FAACgBQAAoQUAAKIFAACjBQAApAUAAKUF"), u0(a, 65280, "BAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABQIAAAUAAAAFAAAABQAAAAUAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAAEAAAABAAAAAQAAAADAgAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAACCAAAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAEIBAABCAQAAQgEAAIIAAACCAAAAggAAAIIAAACCAAAAggAAAIIAAAAqAQAAKgEAACoBAAAqAQAAKgEAACoBAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAACoAAAAqAAAAKgAAAIIAAACCAAAAggAAAIIAAACCAAAAggAAADIBAAAyAQAAMgEAADIBAAAyAQAAMgEAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAMgAAADIAAAAyAAAAggAAAIIAAACCAAAAggAAAAQ="), u0(a, 66308, "zAcBAKYFAACnBQAAmwUAAKgFAACpBQAAqgUAAKsFAACsBQAArQUAAK4FAAAAAAAAnAgBAK8FAACwBQAAmwUAALEFAACyBQAAswUAALQFAAC1BQAAAAAAAMAIAQC2BQAAtwUAAJsFAAC4BQAAuQUAALoFAAC7BQAAvAUAAHQAAAByAAAAdQAAAGUAAAAAAAAAZgAAAGEAAABsAAAAcwAAAGUAAAAAAAAAJQAAAG0AAAAvAAAAJQAAAGQAAAAvAAAAJQAAAHkAAAAAAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAAAAAAJQAAAGEAAAAgAAAAJQAAAGIAAAAgAAAAJQAAAGQAAAAgAAAAJQAAAEgAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAFkAAAAAAAAAJQAAAEkAAAA6AAAAJQAAAE0AAAA6AAAAJQAAAFMAAAAgAAAAJQAAAHA="), u0(a, 66684, "pAQBAL0FAAC+BQAAmwUAAE5TdDNfXzI2bG9jYWxlNWZhY2V0RQAAAAQcAQCMBAEA0BgBAAAAAAAkBQEAvQUAAL8FAACbBQAAwAUAAMEFAADCBQAAwwUAAMQFAADFBQAAxgUAAMcFAADIBQAAyQUAAMoFAADLBQAATlN0M19fMjVjdHlwZUl3RUUATlN0M19fMjEwY3R5cGVfYmFzZUUAANwbAQAGBQEAYBwBAPQEAQAAAAAAAgAAAKQEAQACAAAAHAUBAAIAAAAAAAAAuAUBAL0FAADMBQAAmwUAAM0FAADOBQAAzwUAANAFAADRBQAA0gUAANMFAABOU3QzX18yN2NvZGVjdnRJY2MxMV9fbWJzdGF0ZV90RUUATlN0M19fMjEyY29kZWN2dF9iYXNlRQAAAADcGwEAlgUBAGAcAQB0BQEAAAAAAAIAAACkBAEAAgAAALAFAQACAAAAAAAAACwGAQC9BQAA1AUAAJsFAADVBQAA1gUAANcFAADYBQAA2QUAANoFAADbBQAATlN0M19fMjdjb2RlY3Z0SURzYzExX19tYnN0YXRlX3RFRQAAYBwBAAgGAQAAAAAAAgAAAKQEAQACAAAAsAUBAAIAAAAAAAAAoAYBAL0FAADcBQAAmwUAAN0FAADeBQAA3wUAAOAFAADhBQAA4gUAAOMFAABOU3QzX18yN2NvZGVjdnRJRHNEdTExX19tYnN0YXRlX3RFRQBgHAEAfAYBAAAAAAACAAAApAQBAAIAAACwBQEAAgAAAAAAAAAUBwEAvQUAAOQFAACbBQAA5QUAAOYFAADnBQAA6AUAAOkFAADqBQAA6wUAAE5TdDNfXzI3Y29kZWN2dElEaWMxMV9fbWJzdGF0ZV90RUUAAGAcAQDwBgEAAAAAAAIAAACkBAEAAgAAALAFAQACAAAAAAAAAIgHAQC9BQAA7AUAAJsFAADtBQAA7gUAAO8FAADwBQAA8QUAAPIFAADzBQAATlN0M19fMjdjb2RlY3Z0SURpRHUxMV9fbWJzdGF0ZV90RUUAYBwBAGQHAQAAAAAAAgAAAKQEAQACAAAAsAUBAAIAAABOU3QzX18yN2NvZGVjdnRJd2MxMV9fbWJzdGF0ZV90RUUAAABgHAEAqAcBAAAAAAACAAAApAQBAAIAAACwBQEAAgAAAE5TdDNfXzI2bG9jYWxlNV9faW1wRQAAAAQcAQDsBwEApAQBAE5TdDNfXzI3Y29sbGF0ZUljRUUABBwBABAIAQCkBAEATlN0M19fMjdjb2xsYXRlSXdFRQAEHAEAMAgBAKQEAQBOU3QzX18yNWN0eXBlSWNFRQAAAGAcAQBQCAEAAAAAAAIAAACkBAEAAgAAABwFAQACAAAATlN0M19fMjhudW1wdW5jdEljRUUAAAAABBwBAIQIAQCkBAEATlN0M19fMjhudW1wdW5jdEl3RUUAAAAABBwBAKgIAQCkBAEAAAAAACQIAQD0BQAA9QUAAJsFAAD2BQAA9wUAAPgFAAAAAAAARAgBAPkFAAD6BQAAmwUAAPsFAAD8BQAA/QUAAAAAAADgCQEAvQUAAP4FAACbBQAA/wUAAAAGAAABBgAAAgYAAAMGAAAEBgAABQYAAAYGAAAHBgAACAYAAAkGAABOU3QzX18yN251bV9nZXRJY05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzI5X19udW1fZ2V0SWNFRQBOU3QzX18yMTRfX251bV9nZXRfYmFzZUUAANwbAQCmCQEAYBwBAJAJAQAAAAAAAQAAAMAJAQAAAAAAYBwBAEwJAQAAAAAAAgAAAKQEAQACAAAAyAkB"), u0(a, 68100, "tAoBAL0FAAAKBgAAmwUAAAsGAAAMBgAADQYAAA4GAAAPBgAAEAYAABEGAAASBgAAEwYAABQGAAAVBgAATlN0M19fMjdudW1fZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX2dldEl3RUUAAABgHAEAhAoBAAAAAAABAAAAwAkBAAAAAABgHAEAQAoBAAAAAAACAAAApAQBAAIAAACcCgE="), u0(a, 68312, "nAsBAL0FAAAWBgAAmwUAABcGAAAYBgAAGQYAABoGAAAbBgAAHAYAAB0GAAAeBgAATlN0M19fMjdudW1fcHV0SWNOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEljRUUATlN0M19fMjE0X19udW1fcHV0X2Jhc2VFAADcGwEAYgsBAGAcAQBMCwEAAAAAAAEAAAB8CwEAAAAAAGAcAQAICwEAAAAAAAIAAACkBAEAAgAAAIQLAQ=="), u0(a, 68544, "ZAwBAL0FAAAfBgAAmwUAACAGAAAhBgAAIgYAACMGAAAkBgAAJQYAACYGAAAnBgAATlN0M19fMjdudW1fcHV0SXdOU18xOW9zdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yOV9fbnVtX3B1dEl3RUUAAABgHAEANAwBAAAAAAABAAAAfAsBAAAAAABgHAEA8AsBAAAAAAACAAAApAQBAAIAAABMDAE="), u0(a, 68744, "ZA0BACgGAAApBgAAmwUAACoGAAArBgAALAYAAC0GAAAuBgAALwYAADAGAAD4////ZA0BADEGAAAyBgAAMwYAADQGAAA1BgAANgYAADcGAABOU3QzX18yOHRpbWVfZ2V0SWNOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJY05TXzExY2hhcl90cmFpdHNJY0VFRUVFRQBOU3QzX18yOXRpbWVfYmFzZUUA3BsBAB0NAQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUljRUUAAADcGwEAOA0BAGAcAQDYDAEAAAAAAAMAAACkBAEAAgAAADANAQACAAAAXA0BAAAIAAAAAAAAUA4BADgGAAA5BgAAmwUAADoGAAA7BgAAPAYAAD0GAAA+BgAAPwYAAEAGAAD4////UA4BAEEGAABCBgAAQwYAAEQGAABFBgAARgYAAEcGAABOU3QzX18yOHRpbWVfZ2V0SXdOU18xOWlzdHJlYW1idWZfaXRlcmF0b3JJd05TXzExY2hhcl90cmFpdHNJd0VFRUVFRQBOU3QzX18yMjBfX3RpbWVfZ2V0X2Nfc3RvcmFnZUl3RUUAANwbAQAlDgEAYBwBAOANAQAAAAAAAwAAAKQEAQACAAAAMA0BAAIAAABIDgEAAAgAAAAAAAD0DgEASAYAAEkGAACbBQAASgYAAE5TdDNfXzI4dGltZV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMF9fdGltZV9wdXRFAAAA3BsBANUOAQBgHAEAkA4BAAAAAAACAAAApAQBAAIAAADsDgEAAAgAAAAAAAB0DwEASwYAAEwGAACbBQAATQYAAE5TdDNfXzI4dGltZV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAAAAAGAcAQAsDwEAAAAAAAIAAACkBAEAAgAAAOwOAQAACAAAAAAAAAgQAQC9BQAATgYAAJsFAABPBgAAUAYAAFEGAABSBgAAUwYAAFQGAABVBgAAVgYAAFcGAABOU3QzX18yMTBtb25leXB1bmN0SWNMYjBFRUUATlN0M19fMjEwbW9uZXlfYmFzZUUAAAAA3BsBAOgPAQBgHAEAzA8BAAAAAAACAAAApAQBAAIAAAAAEAEAAgAAAAAAAAB8EAEAvQUAAFgGAACbBQAAWQYAAFoGAABbBgAAXAYAAF0GAABeBgAAXwYAAGAGAABhBgAATlN0M19fMjEwbW9uZXlwdW5jdEljTGIxRUVFAGAcAQBgEAEAAAAAAAIAAACkBAEAAgAAAAAQAQACAAAAAAAAAPAQAQC9BQAAYgYAAJsFAABjBgAAZAYAAGUGAABmBgAAZwYAAGgGAABpBgAAagYAAGsGAABOU3QzX18yMTBtb25leXB1bmN0SXdMYjBFRUUAYBwBANQQAQAAAAAAAgAAAKQEAQACAAAAABABAAIAAAAAAAAAZBEBAL0FAABsBgAAmwUAAG0GAABuBgAAbwYAAHAGAABxBgAAcgYAAHMGAAB0BgAAdQYAAE5TdDNfXzIxMG1vbmV5cHVuY3RJd0xiMUVFRQBgHAEASBEBAAAAAAACAAAApAQBAAIAAAAAEAEAAgAAAAAAAAAIEgEAvQUAAHYGAACbBQAAdwYAAHgGAABOU3QzX18yOW1vbmV5X2dldEljTlNfMTlpc3RyZWFtYnVmX2l0ZXJhdG9ySWNOU18xMWNoYXJfdHJhaXRzSWNFRUVFRUUATlN0M19fMjExX19tb25leV9nZXRJY0VFAADcGwEA5hEBAGAcAQCgEQEAAAAAAAIAAACkBAEAAgAAAAASAQ=="), u0(a, 70188, "rBIBAL0FAAB5BgAAmwUAAHoGAAB7BgAATlN0M19fMjltb25leV9nZXRJd05TXzE5aXN0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfZ2V0SXdFRQAA3BsBAIoSAQBgHAEARBIBAAAAAAACAAAApAQBAAIAAACkEgE="), u0(a, 70352, "UBMBAL0FAAB8BgAAmwUAAH0GAAB+BgAATlN0M19fMjltb25leV9wdXRJY05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckljTlNfMTFjaGFyX3RyYWl0c0ljRUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SWNFRQAA3BsBAC4TAQBgHAEA6BIBAAAAAAACAAAApAQBAAIAAABIEwE="), u0(a, 70516, "9BMBAL0FAAB/BgAAmwUAAIAGAACBBgAATlN0M19fMjltb25leV9wdXRJd05TXzE5b3N0cmVhbWJ1Zl9pdGVyYXRvckl3TlNfMTFjaGFyX3RyYWl0c0l3RUVFRUVFAE5TdDNfXzIxMV9fbW9uZXlfcHV0SXdFRQAA3BsBANITAQBgHAEAjBMBAAAAAAACAAAApAQBAAIAAADsEwE="), u0(a, 70680, "bBQBAL0FAACCBgAAmwUAAIMGAACEBgAAhQYAAE5TdDNfXzI4bWVzc2FnZXNJY0VFAE5TdDNfXzIxM21lc3NhZ2VzX2Jhc2VFAAAAANwbAQBJFAEAYBwBADQUAQAAAAAAAgAAAKQEAQACAAAAZBQBAAIAAAAAAAAAxBQBAL0FAACGBgAAmwUAAIcGAACIBgAAiQYAAE5TdDNfXzI4bWVzc2FnZXNJd0VFAAAAAGAcAQCsFAEAAAAAAAIAAACkBAEAAgAAAGQUAQACAAAAUwAAAHUAAABuAAAAZAAAAGEAAAB5AAAAAAAAAE0AAABvAAAAbgAAAGQAAABhAAAAeQAAAAAAAABUAAAAdQAAAGUAAABzAAAAZAAAAGEAAAB5AAAAAAAAAFcAAABlAAAAZAAAAG4AAABlAAAAcwAAAGQAAABhAAAAeQAAAAAAAABUAAAAaAAAAHUAAAByAAAAcwAAAGQAAABhAAAAeQAAAAAAAABGAAAAcgAAAGkAAABkAAAAYQAAAHkAAAAAAAAAUwAAAGEAAAB0AAAAdQAAAHIAAABkAAAAYQAAAHkAAAAAAAAAUwAAAHUAAABuAAAAAAAAAE0AAABvAAAAbgAAAAAAAABUAAAAdQAAAGUAAAAAAAAAVwAAAGUAAABkAAAAAAAAAFQAAABoAAAAdQAAAAAAAABGAAAAcgAAAGkAAAAAAAAAUwAAAGEAAAB0AAAAAAAAAEoAAABhAAAAbgAAAHUAAABhAAAAcgAAAHkAAAAAAAAARgAAAGUAAABiAAAAcgAAAHUAAABhAAAAcgAAAHkAAAAAAAAATQAAAGEAAAByAAAAYwAAAGgAAAAAAAAAQQAAAHAAAAByAAAAaQAAAGwAAAAAAAAATQAAAGEAAAB5AAAAAAAAAEoAAAB1AAAAbgAAAGUAAAAAAAAASgAAAHUAAABsAAAAeQAAAAAAAABBAAAAdQAAAGcAAAB1AAAAcwAAAHQAAAAAAAAAUwAAAGUAAABwAAAAdAAAAGUAAABtAAAAYgAAAGUAAAByAAAAAAAAAE8AAABjAAAAdAAAAG8AAABiAAAAZQAAAHIAAAAAAAAATgAAAG8AAAB2AAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAARAAAAGUAAABjAAAAZQAAAG0AAABiAAAAZQAAAHIAAAAAAAAASgAAAGEAAABuAAAAAAAAAEYAAABlAAAAYgAAAAAAAABNAAAAYQAAAHIAAAAAAAAAQQAAAHAAAAByAAAAAAAAAEoAAAB1AAAAbgAAAAAAAABKAAAAdQAAAGwAAAAAAAAAQQAAAHUAAABnAAAAAAAAAFMAAABlAAAAcAAAAAAAAABPAAAAYwAAAHQAAAAAAAAATgAAAG8AAAB2AAAAAAAAAEQAAABlAAAAYwAAAAAAAABBAAAATQAAAAAAAABQAAAATQ=="), u0(a, 71772, "XA0BADEGAAAyBgAAMwYAADQGAAA1BgAANgYAADcGAAAAAAAASA4BAEEGAABCBgAAQwYAAEQGAABFBgAARgYAAEcGAAAAAAAA0BgBAIoGAACLBgAAHgAAAE5TdDNfXzIxNF9fc2hhcmVkX2NvdW50RQAAAADcGwEAtBgBAE5TdDNfXzIxOV9fc2hhcmVkX3dlYWtfY291bnRFAAAAYBwBANgYAQAAAAAAAQAAANAYAQ=="), u0(a, 71956, "PBkBANgBAACMBgAAjQYAAE5TdDNfXzIxMmJhZF93ZWFrX3B0ckUAAAQcAQAkGQEAHB0BAE4xMF9fY3h4YWJpdjExNl9fc2hpbV90eXBlX2luZm9FAAAAAAQcAQBIGQEA3B0BAE4xMF9fY3h4YWJpdjExN19fY2xhc3NfdHlwZV9pbmZvRQAAAAQcAQB4GQEAbBkBAE4xMF9fY3h4YWJpdjExN19fcGJhc2VfdHlwZV9pbmZvRQAAAAQcAQCoGQEAbBkBAE4xMF9fY3h4YWJpdjExOV9fcG9pbnRlcl90eXBlX2luZm9FAAQcAQDYGQEAzBkBAE4xMF9fY3h4YWJpdjEyMF9fZnVuY3Rpb25fdHlwZV9pbmZvRQAAAAAEHAEACBoBAGwZAQBOMTBfX2N4eGFiaXYxMjlfX3BvaW50ZXJfdG9fbWVtYmVyX3R5cGVfaW5mb0UAAAAEHAEAPBoBAMwZAQAAAAAAvBoBAI4GAACPBgAAkAYAAJEGAACSBgAATjEwX19jeHhhYml2MTIzX19mdW5kYW1lbnRhbF90eXBlX2luZm9FAAQcAQCUGgEAbBkBAHYAAACAGgEAyBoBAERuAACAGgEA1BoBAGIAAACAGgEA4BoBAGMAAACAGgEA7BoBAGgAAACAGgEA+BoBAGEAAACAGgEABBsBAHMAAACAGgEAEBsBAHQAAACAGgEAHBsBAGkAAACAGgEAKBsBAGoAAACAGgEANBsBAGwAAACAGgEAQBsBAG0AAACAGgEATBsBAHgAAACAGgEAWBsBAHkAAACAGgEAZBsBAGYAAACAGgEAcBsBAGQAAACAGgEAfBsBAAAAAADIGwEAjgYAAJMGAACQBgAAkQYAAJQGAABOMTBfX2N4eGFiaXYxMTZfX2VudW1fdHlwZV9pbmZvRQAAAAAEHAEApBsBAGwZAQAAAAAAnBkBAI4GAACVBgAAkAYAAJEGAACWBgAAlwYAAJgGAACZBgAAAAAAAEwcAQCOBgAAmgYAAJAGAACRBgAAlgYAAJsGAACcBgAAnQYAAE4xMF9fY3h4YWJpdjEyMF9fc2lfY2xhc3NfdHlwZV9pbmZvRQAAAAAEHAEAJBwBAJwZAQAAAAAAqBwBAI4GAACeBgAAkAYAAJEGAACWBgAAnwYAAKAGAAChBgAATjEwX19jeHhhYml2MTIxX192bWlfY2xhc3NfdHlwZV9pbmZvRQAAAAQcAQCAHAEAnBkBAAAAAAD8GQEAjgYAAKIGAACQBgAAkQYAAKMGAAAAAAAANB0BACAAAACkBgAApQYAAAAAAABcHQEAIAAAAKYGAACnBgAAAAAAABwdAQAgAAAAqAYAAKkGAABTdDlleGNlcHRpb24AAAAA3BsBAAwdAQBTdDliYWRfYWxsb2MAAAAABBwBACQdAQAcHQEAU3QyMGJhZF9hcnJheV9uZXdfbGVuZ3RoAAAAAAQcAQBAHQEANB0BAAAAAACMHQEAAQAAAKoGAACrBgAAU3QxMWxvZ2ljX2Vycm9yAAQcAQB8HQEAHB0BAAAAAADAHQEAAQAAAKwGAACrBgAAU3QxMmxlbmd0aF9lcnJvcgAAAAAEHAEArB0BAIwdAQBTdDl0eXBlX2luZm8AAAAA3BsBAMwdAQ=="), u0(a, 73204, "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"), u0(a, 78232, "CpYAANwbAQASlgAAAAAAAMAxAQC4AQAAuQEAALoBAADsAAAAuwEAAAQcAQAilgAA+BgBAAAAAADoMQEAvAEAAL0BAAC+AQAA7AAAAL8BAAAEHAEAZpYAAPgYAQAAAAAAEDIBAMABAADBAQAAwgEAAOwAAADDAQAABBwBAK6WAAD4GAEAAAAAADgyAQDEAQAAxQEAAMYBAADsAAAAxwEAAAQcAQDrlgAA+BgBANwbAQArlwAA3BsBAF+XAABgHAEAOJcAAAAAAAACAAAARDIBAAIAAABMMgEAAggAAAAAAACQMgEAyAEAAMkBAADKAQAA7AAAAMsBAAAEHAEAgJcAAPgYAQDcGwEAw5cAAAAAAADAMgEAzAEAAM0BAADOAQAA7AAAAM8BAAAEHAEA1JcAAPgYAQAAAAAA6DIBANABAADRAQAA0gEAAOwAAADTAQAABBwBABSYAAD4GAEAAAAAABAzAQDUAQAA1QEAANYBAADsAAAA1wEAAAQcAQBemAAA+BgBAAAAAAA4MwEA2wEAANwBAADdAQAA3gEAAN8BAAAEHAEA3JgAAJwxAQAAAAAAYDMBAOABAADhAQAA4gEAAOMBAADkAQAABBwBAPCYAACcMQEAAAAAAKgzAQDlAQAA5gEAAOcBAAAkAAAA6AEAADYAAAArAAAALAAAAC0AAAAuAAAA6QEAADkAAAA6AAAABBwBAAWZAACgHwEAAAAAANAzAQDqAQAA6wEAAOwBAADsAAAA7QEAAAQcAQAPmQAA+BgBAAAAAAAB"), u0(a, 78827, "QAAAAAAAAAABAAAAAAABAADoAwAAAABABgAAAAAAAAAgAAAAAAABAAAgAAAAQAAAAGQAAAAB"), u0(a, 78944, "BAAAAAAAAAA6MwAAAAAAAIw0AQDuAQAA7wEAAPABAADxAQAA8gEAAPMBAAAEHAEAOJwAAJwyAQAAAAAAuDQBAO4BAAD0AQAA9QEAAPYBAAD3AQAA+AEAAAQcAQBPnAAAnDIBAAAAAADkNAEA7gEAAPkBAAD6AQAA+wEAAPwBAAD9AQAABBwBAGqcAACcMgEAAAAAABA1AQD+AQAA/wEAAAACAAABAgAAAgIAAAMCAAAEHAEAg5wAAJwyAQAAAAAAPDUBAO4BAAAEAgAABQIAAAYCAAAHAgAACAIAAAQcAQCcnAAAnDIBAAAAAABoNQEACQIAAAoCAAALAgAADAIAAAcCAAANAgAABBwBALycAACcMgEAAAAAAJA1AQAOAgAADwIAABACAADsAAAAEQIAAAQcAQDYnAAA+BgBAAAAAAC4NQEAEgIAABMCAAAUAgAA7AAAABUCAAAEHAEAIp0AAPgYAQAAAAAA4DUBABYCAAAXAgAAGAIAAOwAAAAZAgAABBwBAHCdAAD4GAEAAAAAAAg2AQAaAgAAGwIAABwCAADsAAAAHQIAAAQcAQC8nQAA+BgBAAAAAAAwNgEAHgIAAB8CAAAgAgAA7AAAACECAAAEHAEACJ4AAPgYAQAAAAAAWDYBACICAAAjAgAAJAIAAOwAAAAlAgAABBwBAFueAAD4GAE="), u0(a, 79468, "CpYAAAUAAADRBwAACjUAAAUAAAAAAAAAqU4AAAUAAADTBwAAhBsAAAUAAADWBwAAhCYAAAUAAADVBwAAGhcAALA2AQDcGwEAkJ8AADgbAQDINgEA3BsBAOWfAAC8HAEA1Z8AAAAAAADANgEAzBoBAMg2AQDsNgEAyDYBALA2AQDcGwEA+J8AAPw2AQCwNgEAkBsBAAqgAAAsGwEAyDYBABQ3AQDINgEA3BsBACWgAAAUNwEAyDYBADgbAQDcGwEAVqAAALwcAQBBoAAAAAAAACg3AQAUNwEAMDcBAFA3AQBYNwEAkBsBAGqgAACQGwEAfKAAANwbAQC+oAAAvBwBALCgAAAAAAAAYDcBAJAbAQDLoAAA3BsBANqgAADMGgEAFDcBAMwaAQCYNwEAvBwBAPmgAAABAAAAKDcBACwbAQCYNwEAzBoBALg3AQC8HAEAD6EAAAEAAABgNwEAkBsBAB6hAACQGwEAMKEAAJAbAQBFoQAAkBsBAF+hAACQGwEAhKEAALwcAQCnoQAAAQAAAMA2AQAAAAAAHDgBAFgCAABZAgAAWgIAAOwAAABbAgAABBwBAMmhAAD4GAEAAAAAAEQ4AQBcAgAAXQIAAF4CAADsAAAAXwIAAAQcAQAKogAA+BgBAAQcAQBRogAAcEIBAHcwAAB3MAAAhiQAAIYkAAB3MAAAdzAAAIYkAABjMAAAeyQAAE8wAACGJAAAhiQAAIYkAACGJAAA+iEAAEgR"), u0(a, 80036, "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"), u0(a, 81920, "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"), u0(a, 85920, "LLYAAAMAAAAJAAAAtiAAADwAAAABAAAAAQAAAH4EAAB/BAAAgAQAAIEEAACCBAAAgwQAAIQEAACFBAAAhgQAAIcEAACIBAAAiQQAAIoEAACLBAAAjAQAAI0EAACOBAAAjwQAAJAEAACRBAAAkgQAAJMEAAAAAAAA/AQAAP0EAAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBEQERAREhESEhESFRMUFRQTFRgWFhgYFhYYGRkbHhsZGR0fIyMfHSQpLCkkLzY2L0FGQVhYcxAQEBAQEBAQEBARERERERISEhISEhQUFBQUFBQYGBgYGBgYGBkZGRkZGRkcHBwcHBwhISEhISkpKSk2NjZHR1sF"), u0(a, 86204, "CgU="), u0(a, 86228, "CwUAAAwFAAAUmAE="), u0(a, 86252, "Ag=="), u0(a, 86268, "//////////8="), u0(a, 86336, "sFABAAAAAAAF"), u0(a, 86356, "DQU="), u0(a, 86380, "CwUAAA4FAAAomAEAAAQ="), u0(a, 86404, "AQ=="), u0(a, 86420, "/////wo="), u0(a, 86488, "SFEBADCuAgAJ"), u0(a, 86508, "CgU="), u0(a, 86528, "EgUAAAAAAAAMBQAAKJ4BAAAE"), u0(a, 86572, "/////w=="), u0(a, 86640, "JW0vJWQvJXkAAAAIJUg6JU06JVMAAAAI");
                    }
                    var L0 = new ArrayBuffer(16), _2 = new Int32Array(L0), u2 = new Float32Array(L0), o2 = new Float64Array(L0);
                    function c0(b2) {
                        return _2[b2];
                    }
                    function J2(b2, R2) {
                        _2[b2] = R2;
                    }
                    function o1() {
                        return o2[0];
                    }
                    function I2(b2) {
                        o2[0] = b2;
                    }
                    function z() {
                        throw new Error("abort");
                    }
                    function A2(b2) {
                        u2[2] = b2;
                    }
                    function Q1() {
                        return u2[2];
                    }
                    function q2(b2) {
                        var R2 = new ArrayBuffer(16973824), o = new Int8Array(R2), Q = new Int16Array(R2), i = new Int32Array(R2), l = new Uint8Array(R2), I = new Uint16Array(R2), k0 = new Uint32Array(R2), W0 = new Float32Array(R2), n0 = new Float64Array(R2), Z = Math.imul, J = Math.fround, r2 = Math.abs, e1 = Math.clz32, tT = Math.min, oT = Math.max, Us = Math.floor, o7 = Math.ceil, uT = Math.trunc, Hs = Math.sqrt, N2 = b2.a, C0 = N2.a, y0 = N2.b, t1 = N2.c, U1 = N2.d, H1 = N2.e, t4 = N2.f, y4 = N2.g, g4 = N2.h, s8 = N2.i, h8 = N2.j, le = N2.k, k3 = N2.l, n3 = N2.m, t3 = N2.n, o3 = N2.o, u3 = N2.p, u7 = N2.q, l7 = N2.r, s7 = N2.s, h7 = N2.t, w7 = N2.u, v7 = N2.v, xs = N2.w, zs = N2.x, Ts = N2.y, Ss = N2.z, js = N2.A, Os = N2.B, Ps = N2.C, Ls = N2.D, Ks = N2.E, qs = N2.F, $s = N2.G, as = N2.H, bs = N2.I, ds = N2.J, cs = N2.K, ih = N2.L, eh = N2.M, rh = N2.N, Ah = N2.O, fh = N2.P, m = 175664, w0 = 0;
                        function l3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0;
                            if (n = m - 336 | 0, m = n, Hi(r + 16 | 0, i[r + 20 >> 2]), C = r + 20 | 0, i[r + 16 >> 2] = C, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, e = i[r + 32 >> 2], f = i[r + 28 >> 2], (e | 0) != (f | 0)) for(;;){
                                k = i[e - 4 >> 2];
                                i: {
                                    if (!k || (u = i[k + 4 >> 2], i[k + 4 >> 2] = u - 1, u)) break i;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                if (e = e - 8 | 0, (f | 0) == (e | 0)) break;
                            }
                            i[r + 32 >> 2] = f, e = i[r + 44 >> 2], i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            H3(n + 284 | 0, i[r + 48 >> 2]);
                            i: {
                                e: {
                                    r: {
                                        v = i[n + 284 >> 2], V = i[n + 288 >> 2];
                                        A: {
                                            if ((v | 0) != (V | 0)) for(R = r + 28 | 0;;){
                                                G = i[v >> 2], q1(n + 240 | 0, i[r + 48 >> 2], G);
                                                f: {
                                                    if (!i[n + 240 >> 2]) {
                                                        w = 3;
                                                        break f;
                                                    }
                                                    k = m - 192 | 0, m = k, i[k + 188 >> 2] = r, f = i[n + 240 >> 2], e = i[f + 112 >> 2], i[k + 184 >> 2] = e, u = i[f + 104 >> 2], i[k + 180 >> 2] = u;
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        if ((e | 0) <= 1785750886) {
                                                                                            if ((e | 0) <= 1752589104) {
                                                                                                if ((e | 0) == 1635135537) break l;
                                                                                                if ((e | 0) == 1635148593) break w;
                                                                                                if ((e | 0) != 1735551332) break n;
                                                                                                u = D(448), e = u, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 82988, e = L8(e + 16 | 0, i[k + 188 >> 2], i[k + 180 >> 2]), i[e + 372 >> 2] = 0, i[e + 376 >> 2] = 0, i[e >> 2] = 83148, i[e + 380 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, NA(e + 396 | 0), f = k + 36 | 0, i[f + 4 >> 2] = u, i[f >> 2] = e, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                                                                break k;
                                                                                            }
                                                                                            if ((e | 0) <= 1768912491) {
                                                                                                if ((e | 0) == 1752589105) break h;
                                                                                                if ((e | 0) != 1768187246) break n;
                                                                                                e = D(392), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 83068, u = L8(e + 16 | 0, i[k + 188 >> 2], i[k + 180 >> 2]), i[u >> 2] = 83356, f = k + 36 | 0, i[f + 4 >> 2] = e, i[f >> 2] = u, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                                                                break k;
                                                                                            }
                                                                                            if ((e | 0) == 1768912492) break t;
                                                                                            if ((e | 0) != 1781689137) break n;
                                                                                            e = D(400), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 82908, f = i[k + 180 >> 2], u = i[k + 188 >> 2], i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = u, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, o[e + 92 | 0] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, o[e + 104 | 0] = 0, i[e + 220 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = f, i[e + 16 >> 2] = 81244, f = k + 36 | 0, i[f + 4 >> 2] = e, i[f >> 2] = e + 16, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                                                            break k;
                                                                                        }
                                                                                        if ((e | 0) <= 1836280680) {
                                                                                            if ((e | 0) != 1785750887) {
                                                                                                if ((e | 0) == 1818785329) break s;
                                                                                                if ((e | 0) != 1835625829 || (t = o[f + 139 | 0], e = (t | 0) < 0, ((e ? i[f + 132 >> 2] : t) | 0) != 10) || O2(e ? i[f + 128 >> 2] : f + 128 | 0, 9263, 10)) break n;
                                                                                            }
                                                                                            e = D(400), i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82576, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = u, i[e + 16 >> 2] = 81016, i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16;
                                                                                            break k;
                                                                                        }
                                                                                        if ((e | 0) <= 1970168680) {
                                                                                            if ((e | 0) == 1836280681) break o;
                                                                                            if ((e | 0) != 1953066089) break n;
                                                                                            u = D(504), e = u, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 83108, e = L8(e + 16 | 0, i[k + 188 >> 2], i[k + 180 >> 2]), i[e + 436 >> 2] = 0, i[e + 440 >> 2] = 0, i[e + 472 >> 2] = 0, i[e + 476 >> 2] = 0, o[e + 468 | 0] = 0, i[e + 464 >> 2] = 65536, i[e + 456 >> 2] = 0, i[e + 460 >> 2] = 0, i[e >> 2] = 83460, i[e + 444 >> 2] = 0, i[e + 448 >> 2] = 0, i[e + 480 >> 2] = 0, i[e + 484 >> 2] = 0, f = k + 36 | 0, i[f + 4 >> 2] = u, i[f >> 2] = e, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                                                            break k;
                                                                                        }
                                                                                        if ((e | 0) == 1970168681) break u;
                                                                                        if ((e | 0) != 1987470129) break n;
                                                                                        e = D(400), i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82696, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = u, i[e + 16 >> 2] = 81760, i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16;
                                                                                        break k;
                                                                                    }
                                                                                    e = D(400), i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82616, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = u, i[e + 16 >> 2] = 80360, i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16;
                                                                                    break k;
                                                                                }
                                                                                e = D(400), i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82656, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = u, i[e + 16 >> 2] = 80644, i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16;
                                                                                break k;
                                                                            }
                                                                            e = D(400), i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82736, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 52 >> 2] = u, i[e + 16 >> 2] = 82048, i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16;
                                                                            break k;
                                                                        }
                                                                        h = bn(k + 36 | 0), e = U(h + 8 | 0, 21194, 20), f = k + 16 | 0, O4(f, i[k + 184 >> 2]), u = e, t = f, e = o[k + 27 | 0], f = (e | 0) < 0, U(U(u, f ? i[k + 16 >> 2] : t, f ? i[k + 20 >> 2] : e), 19906, 19), o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), e = k + 4 | 0, n9(e, h), t = i0(k + 16 | 0, 4, 3001, e), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), s = k + 4 | 0, _ = D(416), e = _, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 82776, e = e + 16 | 0, u = m - 32 | 0, m = u, F = i[k + 180 >> 2], W = i[k + 184 >> 2], w = i[t + 4 >> 2], f = i[t >> 2], i[u + 8 >> 2] = f, i[u + 12 >> 2] = w, B = u + 16 | 0;
                                                                        u: {
                                                                            if (o[t + 19 | 0] >= 0) {
                                                                                E = i[t + 12 >> 2], i[B >> 2] = i[t + 8 >> 2], i[B + 4 >> 2] = E, i[B + 8 >> 2] = i[t + 16 >> 2];
                                                                                break u;
                                                                            }
                                                                            j(B, i[t + 8 >> 2], i[t + 12 >> 2]), f = i[u + 8 >> 2], w = i[u + 12 >> 2];
                                                                        }
                                                                        i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 152 | 0] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 80 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 160 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 16 >> 2] = 4142, Q[e + 58 >> 1] = 0, Q[e + 60 >> 1] = 0, Q[e + 62 >> 1] = 0, Q[e + 64 >> 1] = 0, o[e + 76 | 0] = 0, o[e + 88 | 0] = 0, i[e + 164 >> 2] = 0, i[e + 168 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, Q[e + 42 >> 1] = 0, Q[e + 44 >> 1] = 0, Q[e + 46 >> 1] = 0, Q[e + 48 >> 1] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 288 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 208 | 0] = 1, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, o[e + 217 | 0] = 0, o[e + 218 | 0] = 0, o[e + 219 | 0] = 0, o[e + 220 | 0] = 0, o[e + 221 | 0] = 0, o[e + 222 | 0] = 0, o[e + 223 | 0] = 0, o[e + 224 | 0] = 0, i[e + 232 >> 2] = 0, i[e + 236 >> 2] = 0, i[e + 240 >> 2] = 0, i[e + 244 >> 2] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, o[e + 272 | 0] = 0, Q[e + 292 >> 1] = 1, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 308 >> 2] = 0, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 1072693248, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 376 >> 2] = f, i[e + 380 >> 2] = w, i[e + 36 >> 2] = F, i[e + 372 >> 2] = W, i[e >> 2] = 82816, f = e + 384 | 0;
                                                                        u: {
                                                                            if (o[u + 27 | 0] >= 0) {
                                                                                w = i[B + 4 >> 2], i[f >> 2] = i[B >> 2], i[f + 4 >> 2] = w, i[f + 8 >> 2] = i[B + 8 >> 2];
                                                                                break u;
                                                                            }
                                                                            if (j(f, i[u + 16 >> 2], i[u + 20 >> 2]), o[u + 27 | 0] >= 0) break u;
                                                                            X(i[u + 16 >> 2]);
                                                                        }
                                                                        m = u + 32 | 0, i[s + 4 >> 2] = _, i[s >> 2] = e, i[n + 260 >> 2] = i[k + 4 >> 2], i[n + 264 >> 2] = i[k + 8 >> 2], i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, B1(s), o[t + 19 | 0] < 0 && X(i[t + 8 >> 2]), E6(h);
                                                                        break k;
                                                                    }
                                                                    t = a1(k + 16 | 0, 3630), f = i0(k + 36 | 0, 4, 3001, t), e = D(416), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 82776, w = i[f + 12 >> 2], u = i[f + 8 >> 2], s = i[k + 184 >> 2], h = i[k + 180 >> 2], i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, B = i[f + 16 >> 2], i[f + 16 >> 2] = 0, _ = i[f >> 2], F = i[f + 4 >> 2], i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 32 >> 2] = 4142, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, o[e + 92 | 0] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, o[e + 104 | 0] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, Q[e + 58 >> 1] = 0, Q[e + 60 >> 1] = 0, Q[e + 62 >> 1] = 0, Q[e + 64 >> 1] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 392 >> 2] = _, i[e + 396 >> 2] = F, i[e + 52 >> 2] = h, i[e + 388 >> 2] = s, i[e + 16 >> 2] = 82816;
                                                                    s: {
                                                                        if ((B | 0) >= 0) {
                                                                            i[e + 408 >> 2] = B, i[e + 404 >> 2] = w, i[e + 400 >> 2] = u;
                                                                            break s;
                                                                        }
                                                                        j(e + 400 | 0, u, w), X(u);
                                                                    }
                                                                    if (i[n + 264 >> 2] = e, i[n + 260 >> 2] = e + 16, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, B1(k + 4 | 0), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), o[t + 11 | 0] >= 0) break k;
                                                                    X(i[t >> 2]);
                                                                    break k;
                                                                }
                                                                e = D(392), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 82948, f = i[k + 180 >> 2], u = i[k + 188 >> 2], i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = u, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, o[e + 92 | 0] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, o[e + 104 | 0] = 0, i[e + 220 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 52 >> 2] = f, i[e + 16 >> 2] = 82348, f = k + 36 | 0, i[f + 4 >> 2] = e, i[f >> 2] = e + 16, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                                break k;
                                                            }
                                                            u = D(432), e = u, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 83028, e = L8(e + 16 | 0, i[k + 188 >> 2], i[k + 180 >> 2]), i[e + 372 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 388 >> 2] = 0, i[e >> 2] = 83252, Q[e + 380 >> 1] = 0, i[e + 392 >> 2] = 0, i[e + 396 >> 2] = 0, i[e + 400 >> 2] = 0, i[e + 404 >> 2] = 0, i[e + 408 >> 2] = 0, i[e + 412 >> 2] = 0, f = k + 36 | 0, i[f + 4 >> 2] = u, i[f >> 2] = e, i[n + 260 >> 2] = i[k + 36 >> 2], i[n + 264 >> 2] = i[k + 40 >> 2], i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, B1(f);
                                                            break k;
                                                        }
                                                        i[n + 260 >> 2] = 0, i[n + 264 >> 2] = 0;
                                                    }
                                                    m = k + 192 | 0, f = i[n + 260 >> 2];
                                                    k: {
                                                        if (!f) {
                                                            w = 3;
                                                            break k;
                                                        }
                                                        k = i[n + 264 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                                        n: {
                                                            t: {
                                                                s = C, e = s, u = i[e >> 2];
                                                                o: {
                                                                    if (!u) break o;
                                                                    for(;;){
                                                                        if (e = u, u = i[e + 16 >> 2], u >>> 0 > G >>> 0) {
                                                                            if (s = e, u = i[e >> 2], u) continue;
                                                                            break o;
                                                                        }
                                                                        if (u >>> 0 >= G >>> 0) break t;
                                                                        if (u = i[e + 4 >> 2], !u) break;
                                                                    }
                                                                    s = e + 4 | 0;
                                                                }
                                                                u = D(28), i[u + 24 >> 2] = k, i[u + 20 >> 2] = f, i[u + 16 >> 2] = G, i[u + 8 >> 2] = e, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[s >> 2] = u, e = i[i[r + 16 >> 2] >> 2], e && (i[r + 16 >> 2] = e, u = i[s >> 2]), h4(i[r + 20 >> 2], u), i[r + 24 >> 2] = i[r + 24 >> 2] + 1;
                                                                break n;
                                                            }
                                                            if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break n;
                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        }
                                                        if (e = i[r + 48 >> 2], !l[i[n + 240 >> 2] + 164 | 0]) {
                                                            n: {
                                                                if ((G | 0) != i[i[e + 92 >> 2] + 104 >> 2] || (e = i[n + 260 >> 2], o[e + 48 | 0] = 1, k = i[n + 264 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[r + 40 >> 2] = e, e = i[r + 44 >> 2], i[r + 44 >> 2] = k, !e) || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break n;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            e = i[r + 32 >> 2];
                                                            n: {
                                                                if (e >>> 0 < k0[r + 36 >> 2]) {
                                                                    i[e >> 2] = i[n + 260 >> 2], k = i[n + 264 >> 2], i[e + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = e + 8 | 0;
                                                                    break n;
                                                                }
                                                                e = P2(R, n + 260 | 0);
                                                            }
                                                            i[r + 32 >> 2] = e, e = i[r + 48 >> 2];
                                                        }
                                                        i[n + 304 >> 2] = 0, i[n + 296 >> 2] = 0, i[n + 300 >> 2] = 0, F4(A, e, G, n + 296 | 0), w = 1;
                                                        n: {
                                                            if (i[A >> 2]) break n;
                                                            if (_ = 0, i[n + 280 >> 2] = 0, i[n + 272 >> 2] = 0, i[n + 276 >> 2] = 0, f = i[n + 260 >> 2], e = 0, k = 0, u = i[n + 296 >> 2], B = i[n + 300 >> 2], (u | 0) != (B | 0)) {
                                                                if (e = B - u | 0, (e | 0) < 0) break e;
                                                                for(k = D(e), i[n + 272 >> 2] = k, _ = e + k | 0, i[n + 280 >> 2] = _, e = k; i[e >> 2] = i[u >> 2], t = i[u + 4 >> 2], i[e + 4 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), e = e + 8 | 0, u = u + 8 | 0, (B | 0) != (u | 0););
                                                                i[n + 276 >> 2] = e;
                                                            }
                                                            if (B = i[f + 24 >> 2], B) {
                                                                if (u = i[f + 28 >> 2], t = B, (u | 0) != (t | 0)) {
                                                                    for(;;){
                                                                        e = i[u - 4 >> 2];
                                                                        t: {
                                                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break t;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        if (u = u - 8 | 0, (B | 0) == (u | 0)) break;
                                                                    }
                                                                    t = i[f + 24 >> 2], _ = i[n + 280 >> 2], k = i[n + 272 >> 2], e = i[n + 276 >> 2];
                                                                }
                                                                i[f + 28 >> 2] = B, X(t), u = i[n + 260 >> 2];
                                                            } else u = f;
                                                            if (i[f + 32 >> 2] = _, i[f + 28 >> 2] = e, i[f + 24 >> 2] = k, i[n + 280 >> 2] = 0, i[n + 272 >> 2] = 0, i[n + 276 >> 2] = 0, p[i[i[u >> 2] + 60 >> 2]](n + 96 | 0, u), k = i[n + 100 >> 2], e = i[n + 96 >> 2], i[A >> 2] = e, i[A + 4 >> 2] = k, o[A + 19 | 0] < 0 && (X(i[A + 8 >> 2]), e = i[A >> 2]), k = i[n + 108 >> 2], i[A + 8 >> 2] = i[n + 104 >> 2], i[A + 12 >> 2] = k, i[A + 16 >> 2] = i[n + 112 >> 2], e || (w = 0, o[A + 19 | 0] >= 0)) break n;
                                                            X(i[A + 8 >> 2]);
                                                        }
                                                        if (k = i[n + 296 >> 2], !k) break k;
                                                        if (e = i[n + 300 >> 2], u = k, (e | 0) != (k | 0)) {
                                                            for(;;){
                                                                f = i[e - 4 >> 2];
                                                                n: {
                                                                    if (!f || (u = i[f + 4 >> 2], i[f + 4 >> 2] = u - 1, u)) break n;
                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                }
                                                                if (e = e - 8 | 0, (k | 0) == (e | 0)) break;
                                                            }
                                                            u = i[n + 296 >> 2];
                                                        }
                                                        i[n + 300 >> 2] = k, X(u);
                                                    }
                                                    if (e = i[n + 264 >> 2], !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break f;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                e = i[n + 244 >> 2];
                                                f: {
                                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break f;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                f: switch(w | 0){
                                                    case 0:
                                                    case 3:
                                                        break f;
                                                    default:
                                                        break A;
                                                }
                                                if (v = v + 4 | 0, (V | 0) == (v | 0)) break;
                                            }
                                            if (!i[r + 40 >> 2]) {
                                                if (r = D(64), i[n + 96 >> 2] = r, i[n + 100 >> 2] = 58, i[n + 104 >> 2] = -2147483584, e = l[11638] | l[11639] << 8 | (l[11640] << 16 | l[11641] << 24), k = l[11634] | l[11635] << 8 | (l[11636] << 16 | l[11637] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 58 | 0] = 0, e = l[11690] | l[11691] << 8, o[r + 56 | 0] = e, o[r + 57 | 0] = e >>> 8, e = l[11686] | l[11687] << 8 | (l[11688] << 16 | l[11689] << 24), k = l[11682] | l[11683] << 8 | (l[11684] << 16 | l[11685] << 24), o[r + 48 | 0] = k, o[r + 49 | 0] = k >>> 8, o[r + 50 | 0] = k >>> 16, o[r + 51 | 0] = k >>> 24, o[r + 52 | 0] = e, o[r + 53 | 0] = e >>> 8, o[r + 54 | 0] = e >>> 16, o[r + 55 | 0] = e >>> 24, e = l[11678] | l[11679] << 8 | (l[11680] << 16 | l[11681] << 24), k = l[11674] | l[11675] << 8 | (l[11676] << 16 | l[11677] << 24), o[r + 40 | 0] = k, o[r + 41 | 0] = k >>> 8, o[r + 42 | 0] = k >>> 16, o[r + 43 | 0] = k >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[11670] | l[11671] << 8 | (l[11672] << 16 | l[11673] << 24), k = l[11666] | l[11667] << 8 | (l[11668] << 16 | l[11669] << 24), o[r + 32 | 0] = k, o[r + 33 | 0] = k >>> 8, o[r + 34 | 0] = k >>> 16, o[r + 35 | 0] = k >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[11662] | l[11663] << 8 | (l[11664] << 16 | l[11665] << 24), k = l[11658] | l[11659] << 8 | (l[11660] << 16 | l[11661] << 24), o[r + 24 | 0] = k, o[r + 25 | 0] = k >>> 8, o[r + 26 | 0] = k >>> 16, o[r + 27 | 0] = k >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[11654] | l[11655] << 8 | (l[11656] << 16 | l[11657] << 24), k = l[11650] | l[11651] << 8 | (l[11652] << 16 | l[11653] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[11646] | l[11647] << 8 | (l[11648] << 16 | l[11649] << 24), k = l[11642] | l[11643] << 8 | (l[11644] << 16 | l[11645] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 2e3, n + 96 | 0), o[n + 107 | 0] >= 0) break A;
                                                X(i[n + 96 >> 2]);
                                                break A;
                                            }
                                            if (u = i[r + 16 >> 2], (C | 0) != (u | 0)) for(f0 = r - -64 | 0, H = A + 8 | 0, t0 = i[14959], s0 = t0 - 12 | 0, L = i[14960], q = L - 12 | 0, m0 = i[14963], I0 = m0 - 12 | 0, Z0 = i[14961], F0 = Z0 - 12 | 0, M = n + 80 | 0, g0 = i[14968], R0 = i[14967], R = n + 116 | 0, F = n + 128 | 0, D0 = i[14965], X0 = i[14964], V0 = i[14962], c = n + 108 | 0, P = n + 104 | 0, H0 = n + 160 | 0;;){
                                                e = i[u + 20 >> 2], p[i[i[e >> 2] + 20 >> 2]](n + 96 | 0, e), e = i[n + 96 >> 2], o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]);
                                                f: {
                                                    if (e) break f;
                                                    i[n + 268 >> 2] = 0, i[n + 260 >> 2] = 0, i[n + 264 >> 2] = 0, F4(n + 240 | 0, i[r + 48 >> 2], i[u + 16 >> 2], n + 260 | 0);
                                                    k: {
                                                        n: {
                                                            if (i[n + 240 >> 2]) {
                                                                e = i[n + 244 >> 2], i[A >> 2] = i[n + 240 >> 2], i[A + 4 >> 2] = e, i[H + 8 >> 2] = i[n + 256 >> 2], e = i[n + 252 >> 2], i[H >> 2] = i[n + 248 >> 2], i[H + 4 >> 2] = e, i[n + 248 >> 2] = 0, i[n + 252 >> 2] = 0, i[n + 256 >> 2] = 0;
                                                                break n;
                                                            }
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                e = i[n + 260 >> 2], G = i[n + 264 >> 2];
                                                                                l: {
                                                                                    h: {
                                                                                        if ((e | 0) == (G | 0)) break h;
                                                                                        for(;;){
                                                                                            v: {
                                                                                                if (k = i[e >> 2], !k || !E0(k, 73632, 73788)) break v;
                                                                                                f = i[e + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), k = i[r + 48 >> 2], t = i[r + 52 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), w = i[k + 52 >> 2], B = i[k + 56 >> 2], B && (i[B + 4 >> 2] = i[B + 4 >> 2] + 1), v = i[u + 16 >> 2], i[n + 96 >> 2] = i[e >> 2], k = i[e + 4 >> 2], i[n + 100 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = i[r + 48 >> 2], s = i[r + 52 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), i[n + 296 >> 2] = i[k + 60 >> 2], k = i[k + 64 >> 2], i[n + 300 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = i[w + 36 >> 2], w = i[w + 40 >> 2] - k >> 3;
                                                                                                _: {
                                                                                                    if ((w | 0) > 0) B: for(h = i[n + 96 >> 2], _ = 0;;){
                                                                                                        if ((h | 0) == i[k + (_ << 3) >> 2]) {
                                                                                                            if (k = i[n + 296 >> 2], w = i[k + 104 >> 2], k = i[k + 108 >> 2], (w | 0) == (k | 0)) break B;
                                                                                                            for(h = _ + 1 | 0;;){
                                                                                                                m: {
                                                                                                                    Z: {
                                                                                                                        if ((v | 0) != i[w >> 2] || (_ = i[w + 4 >> 2], V = i[w + 8 >> 2], (_ | 0) == (V | 0))) break Z;
                                                                                                                        for(;;){
                                                                                                                            if ((h | 0) == I[_ + 2 >> 1]) break m;
                                                                                                                            if (_ = _ + 4 | 0, (V | 0) == (_ | 0)) break;
                                                                                                                        }
                                                                                                                    }
                                                                                                                    if (w = w + 16 | 0, (k | 0) != (w | 0)) continue;
                                                                                                                    break B;
                                                                                                                }
                                                                                                                break;
                                                                                                            }
                                                                                                            k = o[_ | 0] & 1;
                                                                                                            break _;
                                                                                                        }
                                                                                                        if (_ = _ + 1 | 0, (w | 0) == (_ | 0)) break;
                                                                                                    }
                                                                                                    k = 0;
                                                                                                }
                                                                                                w = i[n + 300 >> 2];
                                                                                                _: {
                                                                                                    if (!w || (v = i[w + 4 >> 2], i[w + 4 >> 2] = v - 1, v)) break _;
                                                                                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                                                                                }
                                                                                                _: {
                                                                                                    if (!s || (w = i[s + 4 >> 2], i[s + 4 >> 2] = w - 1, w)) break _;
                                                                                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                                                                }
                                                                                                w = i[n + 100 >> 2];
                                                                                                _: {
                                                                                                    if (!w || (s = i[w + 4 >> 2], i[w + 4 >> 2] = s - 1, s)) break _;
                                                                                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                                                                                }
                                                                                                _: {
                                                                                                    if (!B || (w = i[B + 4 >> 2], i[B + 4 >> 2] = w - 1, w)) break _;
                                                                                                    p[i[i[B >> 2] + 8 >> 2]](B), g(B);
                                                                                                }
                                                                                                _: {
                                                                                                    if (!t || (w = i[t + 4 >> 2], i[t + 4 >> 2] = w - 1, w)) break _;
                                                                                                    p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                                                                }
                                                                                                _: {
                                                                                                    if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break _;
                                                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                                }
                                                                                                if (!k) break v;
                                                                                                i[n + 96 >> 2] = Z0, i[n + 104 >> 2] = 59808, i[n + 160 >> 2] = 59828, k = n + 96 | 0, i[k + i[F0 >> 2] >> 2] = V0, f = i[n + 96 >> 2], i[n + 100 >> 2] = 0, f = k + i[f - 12 >> 2] | 0, T0(f, c), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, i[n + 104 >> 2] = m0, i[P + i[I0 >> 2] >> 2] = X0, i[n + 96 >> 2] = L, i[k + i[q >> 2] >> 2] = D0, i[n + 160 >> 2] = 59828, i[n + 96 >> 2] = 59788, i[n + 104 >> 2] = 59808, f = z0(c), i[f >> 2] = 58864, i[n + 148 >> 2] = 0, i[n + 152 >> 2] = 0, i[n + 140 >> 2] = 0, i[n + 144 >> 2] = 0, i[n + 156 >> 2] = 24, k = U(P, 21133, 31), t = n + 296 | 0, si(t, i[e >> 2]), h = k, e = o[n + 307 | 0], k = (e | 0) < 0, U(U(h, k ? i[n + 296 >> 2] : t, k ? i[n + 300 >> 2] : e), 21213, 1), o[n + 307 | 0] < 0 && X(i[n + 296 >> 2]), e = i[n + 156 >> 2];
                                                                                                _: {
                                                                                                    if (e & 16) {
                                                                                                        if (e = F, s = i[n + 152 >> 2], k = i[n + 132 >> 2], s >>> 0 >= k >>> 0) break _;
                                                                                                        i[n + 152 >> 2] = k, s = k;
                                                                                                        break _;
                                                                                                    }
                                                                                                    if (!(e & 8)) {
                                                                                                        e = 0, o[n + 307 | 0] = 0, s = n + 296 | 0;
                                                                                                        break t;
                                                                                                    }
                                                                                                    s = i[n + 124 >> 2], e = R;
                                                                                                }
                                                                                                if (k = i[e >> 2], e = s - k | 0, e >>> 0 >= 2147483640) break w;
                                                                                                if (e >>> 0 >= 11) {
                                                                                                    t = (e | 7) + 1 | 0, s = D(t), i[n + 304 >> 2] = t | -2147483648, i[n + 296 >> 2] = s, i[n + 300 >> 2] = e;
                                                                                                    break o;
                                                                                                }
                                                                                                if (o[n + 307 | 0] = e, s = n + 296 | 0, e) break o;
                                                                                                e = 0;
                                                                                                break t;
                                                                                            }
                                                                                            if (e = e + 8 | 0, (G | 0) == (e | 0)) break;
                                                                                        }
                                                                                        if (e = i[n + 260 >> 2], v = i[n + 264 >> 2], (e | 0) != (v | 0)) {
                                                                                            for(;;){
                                                                                                k = i[e >> 2];
                                                                                                v: {
                                                                                                    if (!k || (k = E0(k, 73632, 73860), !k)) break v;
                                                                                                    if (f = i[e + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), (p[i[i[k >> 2] + 28 >> 2]](k) | 0) != 2) {
                                                                                                        if (e = i[k + 108 >> 2], i[A >> 2] = i[k + 104 >> 2], i[A + 4 >> 2] = e, o[k + 123 | 0] < 0) break u;
                                                                                                        e = i[k + 116 >> 2], i[H >> 2] = i[k + 112 >> 2], i[H + 4 >> 2] = e, i[H + 8 >> 2] = i[k + 120 >> 2];
                                                                                                        break s;
                                                                                                    }
                                                                                                    t = i[u + 20 >> 2], w = i[k + 108 >> 2], i[n + 72 >> 2] = i[k + 104 >> 2], i[n + 76 >> 2] = w;
                                                                                                    _: {
                                                                                                        if (o[k + 123 | 0] >= 0) {
                                                                                                            w = i[k + 116 >> 2], i[M >> 2] = i[k + 112 >> 2], i[M + 4 >> 2] = w, i[M + 8 >> 2] = i[k + 120 >> 2];
                                                                                                            break _;
                                                                                                        }
                                                                                                        j(M, i[k + 112 >> 2], i[k + 116 >> 2]);
                                                                                                    }
                                                                                                    k = i[t + 364 >> 2];
                                                                                                    _: {
                                                                                                        if (k >>> 0 < k0[t + 368 >> 2]) {
                                                                                                            w = i[n + 76 >> 2], i[k >> 2] = i[n + 72 >> 2], i[k + 4 >> 2] = w, i[k + 16 >> 2] = i[M + 8 >> 2], w = i[M + 4 >> 2], i[k + 8 >> 2] = i[M >> 2], i[k + 12 >> 2] = w, i[M >> 2] = 0, i[M + 4 >> 2] = 0, i[M + 8 >> 2] = 0, i[t + 364 >> 2] = k + 20;
                                                                                                            break _;
                                                                                                        }
                                                                                                        if (k = D3(t + 360 | 0, n + 72 | 0), w = o[n + 91 | 0], i[t + 364 >> 2] = k, (w | 0) >= 0) break _;
                                                                                                        X(i[n + 80 >> 2]);
                                                                                                    }
                                                                                                    if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break v;
                                                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                                }
                                                                                                if (e = e + 8 | 0, (v | 0) == (e | 0)) break;
                                                                                            }
                                                                                            v = i[n + 264 >> 2], e = i[n + 260 >> 2];
                                                                                        }
                                                                                        if (k = 0, (e | 0) == (v | 0)) break h;
                                                                                        for(;;){
                                                                                            f = i[e >> 2];
                                                                                            v: {
                                                                                                if (!f || (t = E0(f, 73632, 73656), !t)) break v;
                                                                                                f = i[e + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), w = i[t + 104 >> 2], B = i[t + 108 >> 2], h6(A, f0, w, B), t = i[A >> 2];
                                                                                                _: {
                                                                                                    if (t || (k = i[u + 20 >> 2], i[k + 44 >> 2] = B, i[k + 40 >> 2] = w, k = 1, o[A + 19 | 0] >= 0)) break _;
                                                                                                    X(i[A + 8 >> 2]);
                                                                                                }
                                                                                                _: {
                                                                                                    if (!f || (w = i[f + 4 >> 2], i[f + 4 >> 2] = w - 1, w)) break _;
                                                                                                    if (p[i[i[f >> 2] + 8 >> 2]](f), g(f), !t) break v;
                                                                                                    break n;
                                                                                                }
                                                                                                if (t) break n;
                                                                                            }
                                                                                            if (e = e + 8 | 0, (v | 0) == (e | 0)) break;
                                                                                        }
                                                                                        if (V = 1, k & 1) break l;
                                                                                    }
                                                                                    k = i[u + 20 >> 2], o[n + 96 | 0] = 0, o[n + 107 | 0] = 0, f = i0(n + 48 | 0, 2, 137, n + 96 | 0), e = i[k + 364 >> 2];
                                                                                    h: {
                                                                                        if (e >>> 0 < k0[k + 368 >> 2]) {
                                                                                            t = i[f + 4 >> 2], i[e >> 2] = i[f >> 2], i[e + 4 >> 2] = t, i[e + 16 >> 2] = i[n + 64 >> 2], f = i[n + 60 >> 2], i[e + 8 >> 2] = i[n + 56 >> 2], i[e + 12 >> 2] = f, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 64 >> 2] = 0, i[k + 364 >> 2] = e + 20;
                                                                                            break h;
                                                                                        }
                                                                                        if (e = D3(k + 360 | 0, f), f = o[n + 67 | 0], i[k + 364 >> 2] = e, (f | 0) >= 0) break h;
                                                                                        X(i[n + 56 >> 2]);
                                                                                    }
                                                                                    o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), V = 0;
                                                                                }
                                                                                if (e = i[n + 260 >> 2], B = i[n + 264 >> 2], (e | 0) == (B | 0)) {
                                                                                    w = 0;
                                                                                    break k;
                                                                                }
                                                                                for(;;){
                                                                                    t = i[e >> 2];
                                                                                    l: {
                                                                                        if (!t) break l;
                                                                                        if (f = E0(t, 73632, 78760), f) {
                                                                                            k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[n + 96 >> 2] = i[f + 100 >> 2], f = i[f + 104 >> 2], i[n + 100 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), b3(i[u + 20 >> 2], n + 96 | 0), f = i[n + 100 >> 2];
                                                                                            h: {
                                                                                                if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break h;
                                                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                            }
                                                                                            if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break l;
                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                            break l;
                                                                                        }
                                                                                        w = 0, s = 0;
                                                                                        h: {
                                                                                            v: {
                                                                                                if (k = E0(t, 73632, 75960), !k) break v;
                                                                                                if (s = i[e + 4 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), !V) {
                                                                                                    o[n + 96 | 0] = 0, o[n + 107 | 0] = 0, i0(A, 2, 137, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), w = 1, f = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if (t = i[u + 20 >> 2], f = i[k + 148 >> 2], i[n + 136 >> 2] = i[k + 144 >> 2], i[n + 140 >> 2] = f, f = i[k + 140 >> 2], i[n + 128 >> 2] = i[k + 136 >> 2], i[n + 132 >> 2] = f, f = i[k + 132 >> 2], i[n + 120 >> 2] = i[k + 128 >> 2], i[n + 124 >> 2] = f, f = i[k + 124 >> 2], i[n + 112 >> 2] = i[k + 120 >> 2], i[n + 116 >> 2] = f, f = i[k + 116 >> 2], i[P >> 2] = i[k + 112 >> 2], i[P + 4 >> 2] = f, f = i[k + 108 >> 2], i[n + 96 >> 2] = i[k + 104 >> 2], i[n + 100 >> 2] = f, f = 1, o[t + 224 | 0] = 1, k = oA(t), G = uA(t), y = +(k | 0), T = n0[n + 96 >> 3] * y, n0[n + 296 >> 3] = T, e2 = +(G | 0), n0[n + 304 >> 3] = l[n + 120 | 0] ? n0[n + 128 >> 3] * e2 : T, n0[n + 312 >> 3] = n0[n + 104 >> 3] * y, n0[n + 320 >> 3] = n0[n + 112 >> 3] * e2, n0[n + 328 >> 3] = n0[n + 136 >> 3], k = i[n + 332 >> 2], i[t + 264 >> 2] = i[n + 328 >> 2], i[t + 268 >> 2] = k, k = i[n + 324 >> 2], i[t + 256 >> 2] = i[n + 320 >> 2], i[t + 260 >> 2] = k, k = i[n + 316 >> 2], i[t + 248 >> 2] = i[n + 312 >> 2], i[t + 252 >> 2] = k, k = i[n + 308 >> 2], i[t + 240 >> 2] = i[n + 304 >> 2], i[t + 244 >> 2] = k, k = i[n + 300 >> 2], i[t + 232 >> 2] = i[n + 296 >> 2], i[t + 236 >> 2] = k, t = i[e >> 2], t) break v;
                                                                                                break h;
                                                                                            }
                                                                                            if (f = E0(t, 73632, 76032), !f) {
                                                                                                f = 1;
                                                                                                break h;
                                                                                            }
                                                                                            if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), t = i[u + 20 >> 2], G = n + 96 | 0, v0(G, f + 104 | 0, 80), f = 1, o[t + 272 | 0] = 1, v0(t + 280 | 0, G, 76), !k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break h;
                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                        }
                                                                                        h: {
                                                                                            if (!s || (k = i[s + 4 >> 2], i[s + 4 >> 2] = k - 1, k)) break h;
                                                                                            p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                                                        }
                                                                                        if (!f) break k;
                                                                                    }
                                                                                    if (e = e + 8 | 0, (B | 0) == (e | 0)) break;
                                                                                }
                                                                                if (e = i[n + 260 >> 2], r0 = i[n + 264 >> 2], (e | 0) == (r0 | 0)) {
                                                                                    w = 0;
                                                                                    break k;
                                                                                }
                                                                                for(;;){
                                                                                    if (v = i[e >> 2], v) {
                                                                                        s = 0, t = 0;
                                                                                        l: {
                                                                                            h: {
                                                                                                if (E = E0(v, 73632, 74928), !E) break h;
                                                                                                if (t = i[e + 4 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), w = i[E + 100 >> 2], k = i[E + 104 >> 2], B = (k | 0) / 2 | 0, f = w + B | 0, W = (w >> 31) + (B >> 31) | 0, k = m2(f, f >>> 0 < B >>> 0 ? W + 1 | 0 : W, k, k >> 31), G = i[E + 108 >> 2], f = i[E + 112 >> 2], v = (f | 0) / 2 | 0, h = v, w = G + h | 0, v = (G >> 31) + (h >> 31) | 0, B = i[u + 20 >> 2], t2 = B, v2 = m2(w, h >>> 0 > w >>> 0 ? v + 1 | 0 : v, f, f >> 31), i[t2 + 44 >> 2] = v2, i[B + 40 >> 2] = k, S = i[u + 20 >> 2], l[S + 224 | 0] == 1) {
                                                                                                    $ = i[S + 44 >> 2], k = i[S + 40 >> 2], f = k - 1 | 0, k = k + 65535 >>> 0 < 131073, G = k ? f : (f | 0) / 2 | 0, f = i[E + 116 >> 2], B = f >> 31, _ = k ? 2 : 1, w = i[E + 120 >> 2];
                                                                                                    v: {
                                                                                                        if ((_ | 0) == (w | 0)) {
                                                                                                            if (h = (G >> 31) + B | 0, k = G, G = f + G | 0, h = k >>> 0 > G >>> 0 ? h + 1 | 0 : h, k = h, (k - (G >>> 0 < 2147483648) | 0) == -1) break v;
                                                                                                            h = k >> 31, f = G + (h | 1) | 0, v = k + h | 0, G = m2(f, f >>> 0 < G >>> 0 ? v + 1 | 0 : v, 2, 0), _ = 1;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (_ = w >> 31, G = O0(w, _, G, G >> 31), k2 = w0, v = k, i2 = G, h = f, G = k & 31, (k & 63) >>> 0 >= 32 ? (W = f << G, k = 0) : (W = (1 << G) - 1 & h >>> 32 - G | B << G, k = h << G), G = i2 + k | 0, h = W + k2 | 0, h = k >>> 0 > G >>> 0 ? h + 1 | 0 : h, k = h, W = (k - (G >>> 0 < 2147483648) | 0) == -1, B = w, f = v & 31, (v & 63) >>> 0 >= 32 ? (h = w << f, f = 0) : (h = (1 << f) - 1 & B >>> 32 - f | _ << f, f = B << f), w = h, !((h - (f >>> 0 < 2147483648) | 0) == -1 & W)) for(; h = w >> 31, B = f + (h | 1) | 0, v = h + w | 0, f = m2(B, f >>> 0 > B >>> 0 ? v + 1 | 0 : v, 2, 0), w = w0, v = w - (f >>> 0 < 2147483648) | 0, h = k >> 31, B = G + (h | 1) | 0, h = k + h | 0, G = m2(B, B >>> 0 < G >>> 0 ? h + 1 | 0 : h, 2, 0), k = w0, (k - (G >>> 0 < 2147483648) & v) != -1;);
                                                                                                        _ = f;
                                                                                                    }
                                                                                                    if (w = i[E + 100 >> 2], k = i[E + 104 >> 2], f = w - k | 0, B = k >> 31, w = (w >> 31) - (B + (k >>> 0 > w >>> 0) | 0) | 0, v = w - (f >>> 0 < 2147483648) | 0, (v | 0) == -2 | v >>> 0 < 4294967294) {
                                                                                                        for(; h = B >> 31, v = k + (h | 1) | 0, h = B + h | 0, k = m2(v, k >>> 0 > v >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, h = w >> 31, W = h, h = f + (h | 1) | 0, v = w + W | 0, f = m2(h, f >>> 0 > h >>> 0 ? v + 1 | 0 : v, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) | 0) != -1;);
                                                                                                        B = k >> 31;
                                                                                                    }
                                                                                                    if (h = B << 1 | k >>> 31, k = k << 1, B = h, v = h - (k >>> 0 < 2147483648) | 0, (v | 0) == -2 | v >>> 0 < 4294967294) for(; h = w >> 31, v = f + (h | 1) | 0, W = h + w | 0, f = m2(v, f >>> 0 > v >>> 0 ? W + 1 | 0 : W, 2, 0), w = w0, h = B >> 31, W = k + (h | 1) | 0, v = h + B | 0, k = m2(W, k >>> 0 > W >>> 0 ? v + 1 | 0 : v, 2, 0), B = w0, (B - (k >>> 0 < 2147483648) | 0) != -1;);
                                                                                                    w = G >> 31;
                                                                                                    v: {
                                                                                                        if ((k | 0) == (_ | 0)) {
                                                                                                            if (w = w - ((f >> 31) + (f >>> 0 > G >>> 0) | 0) | 0, f = G - f | 0, (w - (f >>> 0 < 2147483648) | 0) == -1) break v;
                                                                                                            for(k = _, B = k >> 31; h = B >> 31, G = k + (h | 1) | 0, v = h + B | 0, k = m2(G, k >>> 0 > G >>> 0 ? v + 1 | 0 : v, 2, 0), B = w0, h = w >> 31, G = f + (h | 1) | 0, h = h + w | 0, f = m2(G, f >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) | 0) != -1;);
                                                                                                            _ = k;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (w = O0(k, B, G, w), G = w0, v = _ >> 31, h = O0(_, v, f, f >> 31), f = w - h | 0, w = G - (w0 + (h >>> 0 > w >>> 0) | 0) | 0, k = O0(k, B, _, v), B = w0, (w - (f >>> 0 < 2147483648) & B - (k >>> 0 < 2147483648)) != -1) for(; h = B >> 31, G = k + (h | 1) | 0, h = h + B | 0, k = m2(G, k >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, h = B - (k >>> 0 < 2147483648) | 0, v = w >> 31, G = f + (v | 1) | 0, v = w + v | 0, f = m2(G, f >>> 0 > G >>> 0 ? v + 1 | 0 : v, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) & h) != -1;);
                                                                                                        _ = k;
                                                                                                    }
                                                                                                    n0[S + 248 >> 3] = n0[S + 248 >> 3] - +(f | 0) / +(_ | 0), k = $ - 1 | 0, h = k, f = (k | 0) / 2 | 0, k = $ + 65535 >>> 0 < 131073, G = k ? h : f, f = i[E + 124 >> 2], B = f >> 31, v = k ? 2 : 1, w = i[E + 128 >> 2];
                                                                                                    v: {
                                                                                                        if ((v | 0) == (w | 0)) {
                                                                                                            if (h = (G >> 31) + B | 0, k = G, G = f + G | 0, h = k >>> 0 > G >>> 0 ? h + 1 | 0 : h, k = h, (k - (G >>> 0 < 2147483648) | 0) == -1) break v;
                                                                                                            h = k >> 31, f = G + (h | 1) | 0, h = k + h | 0, G = m2(f, f >>> 0 < G >>> 0 ? h + 1 | 0 : h, 2, 0), v = 1;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (_ = w >> 31, G = O0(w, _, G, G >> 31), $ = w0, v = k, i2 = G, h = f, G = k & 31, (k & 63) >>> 0 >= 32 ? (W = f << G, k = 0) : (W = (1 << G) - 1 & h >>> 32 - G | B << G, k = h << G), G = i2 + k | 0, h = W + $ | 0, h = k >>> 0 > G >>> 0 ? h + 1 | 0 : h, k = h, W = (k - (G >>> 0 < 2147483648) | 0) == -1, B = w, f = v & 31, (v & 63) >>> 0 >= 32 ? (h = w << f, f = 0) : (h = (1 << f) - 1 & B >>> 32 - f | _ << f, f = B << f), w = h, !((h - (f >>> 0 < 2147483648) | 0) == -1 & W)) for(; h = w >> 31, B = f + (h | 1) | 0, h = w + h | 0, f = m2(B, f >>> 0 > B >>> 0 ? h + 1 | 0 : h, 2, 0), w = w0, v = w - (f >>> 0 < 2147483648) | 0, h = k >> 31, B = G + (h | 1) | 0, h = k + h | 0, G = m2(B, B >>> 0 < G >>> 0 ? h + 1 | 0 : h, 2, 0), k = w0, (k - (G >>> 0 < 2147483648) & v) != -1;);
                                                                                                        v = f;
                                                                                                    }
                                                                                                    if (w = i[E + 108 >> 2], k = i[E + 112 >> 2], f = w - k | 0, B = k >> 31, w = (w >> 31) - (B + (k >>> 0 > w >>> 0) | 0) | 0, h = w - (f >>> 0 < 2147483648) | 0, (h | 0) == -2 | h >>> 0 < 4294967294) {
                                                                                                        for(; h = B >> 31, _ = k + (h | 1) | 0, h = B + h | 0, k = m2(_, k >>> 0 > _ >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, h = w >> 31, _ = f + (h | 1) | 0, h = w + h | 0, f = m2(_, f >>> 0 > _ >>> 0 ? h + 1 | 0 : h, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) | 0) != -1;);
                                                                                                        B = k >> 31;
                                                                                                    }
                                                                                                    if (h = B << 1 | k >>> 31, k = k << 1, B = h, h = h - (k >>> 0 < 2147483648) | 0, (h | 0) == -2 | h >>> 0 < 4294967294) for(; h = w >> 31, _ = f + (h | 1) | 0, W = h + w | 0, f = m2(_, f >>> 0 > _ >>> 0 ? W + 1 | 0 : W, 2, 0), w = w0, h = B >> 31, _ = k + (h | 1) | 0, h = h + B | 0, k = m2(_, k >>> 0 > _ >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, (B - (k >>> 0 < 2147483648) | 0) != -1;);
                                                                                                    w = G >> 31;
                                                                                                    v: {
                                                                                                        if ((k | 0) == (v | 0)) {
                                                                                                            if (w = w - ((f >> 31) + (f >>> 0 > G >>> 0) | 0) | 0, f = G - f | 0, (w - (f >>> 0 < 2147483648) | 0) == -1) break v;
                                                                                                            for(k = v, B = k >> 31; h = B >> 31, G = k + (h | 1) | 0, h = h + B | 0, k = m2(G, k >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, h = w >> 31, G = f + (h | 1) | 0, h = h + w | 0, f = m2(G, f >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) | 0) != -1;);
                                                                                                            v = k;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (w = O0(k, B, G, w), G = w0, h = v >> 31, _ = O0(v, h, f, f >> 31), f = w - _ | 0, w = G - (w0 + (w >>> 0 < _ >>> 0) | 0) | 0, k = O0(k, B, v, h), B = w0, (w - (f >>> 0 < 2147483648) & B - (k >>> 0 < 2147483648)) != -1) for(; h = B >> 31, G = k + (h | 1) | 0, h = h + B | 0, k = m2(G, k >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), B = w0, v = B - (k >>> 0 < 2147483648) | 0, h = w >> 31, G = f + (h | 1) | 0, h = w + h | 0, f = m2(G, f >>> 0 > G >>> 0 ? h + 1 | 0 : h, 2, 0), w = w0, (w - (f >>> 0 < 2147483648) & v) != -1;);
                                                                                                        v = k;
                                                                                                    }
                                                                                                    n0[S + 256 >> 3] = n0[S + 256 >> 3] - +(f | 0) / +(v | 0);
                                                                                                }
                                                                                                if (v = i[e >> 2], v) break h;
                                                                                                v = 0;
                                                                                                break l;
                                                                                            }
                                                                                            B = E0(v, 73632, 74856);
                                                                                            h: {
                                                                                                v: {
                                                                                                    if (!B) break v;
                                                                                                    if (s = i[e + 4 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), !V) {
                                                                                                        o[n + 96 | 0] = 0, o[n + 107 | 0] = 0, i0(A, 2, 137, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), v = 1;
                                                                                                        break h;
                                                                                                    }
                                                                                                    f = i[u + 20 >> 2], k = i[f + 44 >> 2], _ = 24, w = 8;
                                                                                                    _: switch(i[B + 100 >> 2]){
                                                                                                        case 1:
                                                                                                            n0[f + 232 >> 3] = -n0[f + 232 >> 3], k = i[f + 40 >> 2], _ = 16, w = 32;
                                                                                                            break;
                                                                                                        case 0:
                                                                                                            break _;
                                                                                                        default:
                                                                                                            break v;
                                                                                                    }
                                                                                                    f = f + 232 | 0, w = f + w | 0, n0[w >> 3] = -n0[w >> 3], f = f + _ | 0, n0[f >> 3] = +(k - 1 | 0) - n0[f >> 3];
                                                                                                }
                                                                                                if (k = i[e >> 2], !k) {
                                                                                                    v = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if (v = 0, f = E0(k, 73632, 74784), !f) break h;
                                                                                                k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), f = i[f + 100 >> 2];
                                                                                                v: {
                                                                                                    if ((f | 0) != 270 & (f | 0) != 90) break v;
                                                                                                    if (!V) {
                                                                                                        o[n + 96 | 0] = 0, o[n + 107 | 0] = 0, i0(A, 2, 137, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), v = 1;
                                                                                                        break v;
                                                                                                    }
                                                                                                    f = i[u + 20 >> 2], w = i[f + 44 >> 2], i[f + 44 >> 2] = i[f + 40 >> 2], i[f + 40 >> 2] = w;
                                                                                                }
                                                                                                if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break h;
                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                            }
                                                                                            if (!s || (k = i[s + 4 >> 2], i[s + 4 >> 2] = k - 1, k)) break l;
                                                                                            p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                                                        }
                                                                                        l: {
                                                                                            if (!t || (k = i[t + 4 >> 2], i[t + 4 >> 2] = k - 1, k)) break l;
                                                                                            p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                                                        }
                                                                                        if (v) break n;
                                                                                    }
                                                                                    if (e = e + 8 | 0, (r0 | 0) == (e | 0)) break;
                                                                                }
                                                                                w = 0;
                                                                                break k;
                                                                            }
                                                                            Y0(), z();
                                                                        }
                                                                        j(H, i[k + 112 >> 2], i[k + 116 >> 2]);
                                                                    }
                                                                    if (w = 1, !f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break k;
                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                    break k;
                                                                }
                                                                Q0(s, k, e);
                                                            }
                                                            o[e + s | 0] = 0, i0(A, 4, 3007, n + 296 | 0), o[n + 307 | 0] < 0 && X(i[n + 296 >> 2]), i[n + 96 >> 2] = t0, i[i[s0 >> 2] + (n + 96 | 0) >> 2] = R0, i[n + 104 >> 2] = g0, i[f >> 2] = 58864, o[n + 151 | 0] < 0 && X(i[n + 140 >> 2]), x0(f), N0(H0);
                                                        }
                                                        w = 1;
                                                    }
                                                    if (o[n + 259 | 0] < 0 && X(i[n + 248 >> 2]), k = i[n + 260 >> 2], k) {
                                                        if (e = i[n + 264 >> 2], t = k, (e | 0) != (k | 0)) {
                                                            for(;;){
                                                                f = i[e - 4 >> 2];
                                                                k: {
                                                                    if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break k;
                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                }
                                                                if (e = e - 8 | 0, (k | 0) == (e | 0)) break;
                                                            }
                                                            t = i[n + 260 >> 2];
                                                        }
                                                        i[n + 264 >> 2] = k, X(t);
                                                    }
                                                    switch(w | 0){
                                                        case 0:
                                                        case 5:
                                                            break f;
                                                        default:
                                                            break A;
                                                    }
                                                }
                                                t = i[u + 4 >> 2];
                                                f: {
                                                    if (t) {
                                                        for(;;)if (e = t, t = i[e >> 2], !t) break f;
                                                    }
                                                    for(; e = i[u + 8 >> 2], k = i[e >> 2] != (u | 0), u = e, !!k;);
                                                }
                                                if (u = e, (e | 0) == (C | 0)) break;
                                            }
                                            e = i[r + 48 >> 2], E = i[e + 84 >> 2], M = i[e + 88 >> 2], M && (i[M + 4 >> 2] = i[M + 4 >> 2] + 1), u = i[r + 16 >> 2];
                                            f: {
                                                if (!(!E | (C | 0) == (u | 0))) {
                                                    for(c = i[14959], $ = c - 12 | 0, f0 = i[14960], t0 = f0 - 12 | 0, s0 = i[14963], L = s0 - 12 | 0, q = i[14961], m0 = q - 12 | 0, I0 = i[14968], Z0 = i[14967], B = n + 116 | 0, G = n + 128 | 0, F0 = i[14965], g0 = i[14964], R0 = i[14962], S = n + 108 | 0, P = n + 104 | 0, D0 = n + 160 | 0;;){
                                                        pA(n + 296 | 0, E, i[i[u + 20 >> 2] + 36 >> 2]), w = i[n + 296 >> 2], X0 = i[n + 300 >> 2];
                                                        k: {
                                                            if ((w | 0) == (X0 | 0)) {
                                                                v = 18;
                                                                break k;
                                                            }
                                                            F = u + 20 | 0;
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        for(;;){
                                                                            s: {
                                                                                if (e = i[w + 16 >> 2], (e | 0) != 1635088492) {
                                                                                    if ((e | 0) != 1953000802) break s;
                                                                                    i[n + 104 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, e = i[w + 48 >> 2], k = i[w + 44 >> 2], t = (e | 0) == (k | 0);
                                                                                    u: {
                                                                                        w: {
                                                                                            if (t) break w;
                                                                                            if (e = e - k | 0, (e | 0) < 0) break i;
                                                                                            if (f = D(e), i[n + 96 >> 2] = f, s = e + f | 0, i[n + 104 >> 2] = s, v0(f, k, e), i[n + 100 >> 2] = s, t) break w;
                                                                                            for(;;){
                                                                                                k = i[f >> 2], v = i[F >> 2], o[v + 49 | 0] = 1;
                                                                                                l: {
                                                                                                    t = C, e = i[t >> 2];
                                                                                                    h: {
                                                                                                        if (!e) break h;
                                                                                                        for(; h = k >>> 0 > k0[e + 16 >> 2], t = h ? t : e, e = i[(h << 2) + e >> 2], !!e;);
                                                                                                        if ((t | 0) == (C | 0)) break h;
                                                                                                        if (k >>> 0 >= k0[t + 16 >> 2]) break l;
                                                                                                    }
                                                                                                    e = D(48), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 41, i[n + 248 >> 2] = -2147483600, k = l[11823] | l[11824] << 8 | (l[11825] << 16 | l[11826] << 24), f = l[11819] | l[11820] << 8 | (l[11821] << 16 | l[11822] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 41 | 0] = 0, o[e + 40 | 0] = l[11859], k = l[11855] | l[11856] << 8 | (l[11857] << 16 | l[11858] << 24), f = l[11851] | l[11852] << 8 | (l[11853] << 16 | l[11854] << 24), o[e + 32 | 0] = f, o[e + 33 | 0] = f >>> 8, o[e + 34 | 0] = f >>> 16, o[e + 35 | 0] = f >>> 24, o[e + 36 | 0] = k, o[e + 37 | 0] = k >>> 8, o[e + 38 | 0] = k >>> 16, o[e + 39 | 0] = k >>> 24, k = l[11847] | l[11848] << 8 | (l[11849] << 16 | l[11850] << 24), f = l[11843] | l[11844] << 8 | (l[11845] << 16 | l[11846] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[11839] | l[11840] << 8 | (l[11841] << 16 | l[11842] << 24), f = l[11835] | l[11836] << 8 | (l[11837] << 16 | l[11838] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[11831] | l[11832] << 8 | (l[11833] << 16 | l[11834] << 24), f = l[11827] | l[11828] << 8 | (l[11829] << 16 | l[11830] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 0;
                                                                                                    break u;
                                                                                                }
                                                                                                if (e = i[t + 20 >> 2], l[e + 49 | 0] == 1) {
                                                                                                    e = D(40), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 38, i[n + 248 >> 2] = -2147483608, k = l[8059] | l[8060] << 8 | (l[8061] << 16 | l[8062] << 24), f = l[8055] | l[8056] << 8 | (l[8057] << 16 | l[8058] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 38 | 0] = 0, k = l[8089] | l[8090] << 8 | (l[8091] << 16 | l[8092] << 24), f = l[8085] | l[8086] << 8 | (l[8087] << 16 | l[8088] << 24), o[e + 30 | 0] = f, o[e + 31 | 0] = f >>> 8, o[e + 32 | 0] = f >>> 16, o[e + 33 | 0] = f >>> 24, o[e + 34 | 0] = k, o[e + 35 | 0] = k >>> 8, o[e + 36 | 0] = k >>> 16, o[e + 37 | 0] = k >>> 24, k = l[8083] | l[8084] << 8 | (l[8085] << 16 | l[8086] << 24), f = l[8079] | l[8080] << 8 | (l[8081] << 16 | l[8082] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[8075] | l[8076] << 8 | (l[8077] << 16 | l[8078] << 24), f = l[8071] | l[8072] << 8 | (l[8073] << 16 | l[8074] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[8067] | l[8068] << 8 | (l[8069] << 16 | l[8070] << 24), f = l[8063] | l[8064] << 8 | (l[8065] << 16 | l[8066] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 0;
                                                                                                    break u;
                                                                                                }
                                                                                                if ((e | 0) == (v | 0)) {
                                                                                                    e = D(40), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 34, i[n + 248 >> 2] = -2147483608, k = l[13455] | l[13456] << 8 | (l[13457] << 16 | l[13458] << 24), f = l[13451] | l[13452] << 8 | (l[13453] << 16 | l[13454] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 34 | 0] = 0, k = l[13483] | l[13484] << 8, o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, k = l[13479] | l[13480] << 8 | (l[13481] << 16 | l[13482] << 24), f = l[13475] | l[13476] << 8 | (l[13477] << 16 | l[13478] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[13471] | l[13472] << 8 | (l[13473] << 16 | l[13474] << 24), f = l[13467] | l[13468] << 8 | (l[13469] << 16 | l[13470] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[13463] | l[13464] << 8 | (l[13465] << 16 | l[13466] << 24), f = l[13459] | l[13460] << 8 | (l[13461] << 16 | l[13462] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 0;
                                                                                                    break u;
                                                                                                }
                                                                                                k = i[e + 56 >> 2];
                                                                                                l: {
                                                                                                    if (k >>> 0 < k0[e + 60 >> 2]) {
                                                                                                        i[k >> 2] = v, t = i[u + 24 >> 2], i[k + 4 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), k = k + 8 | 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    k = P2(e + 52 | 0, F);
                                                                                                }
                                                                                                if (i[e + 56 >> 2] = k, f = f + 4 | 0, (s | 0) == (f | 0)) break;
                                                                                            }
                                                                                        }
                                                                                        O3(r, F), e = 1;
                                                                                    }
                                                                                    if (k = i[n + 96 >> 2], k && (i[n + 100 >> 2] = k, X(k)), e) break s;
                                                                                    v = 1;
                                                                                    break n;
                                                                                }
                                                                                u: {
                                                                                    w: {
                                                                                        l: {
                                                                                            h: {
                                                                                                v: {
                                                                                                    _: {
                                                                                                        B: {
                                                                                                            m: {
                                                                                                                Z: {
                                                                                                                    if (k = i[F >> 2], e = i[k + 24 >> 2], k = i[k + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                                                                                                        W: {
                                                                                                                            if (f = i[e >> 2], !f || (V = E0(f, 73632, 74712), !V)) break W;
                                                                                                                            if (H = i[e + 4 >> 2], H && (i[H + 4 >> 2] = i[H + 4 >> 2] + 1), _ = 0, i[n + 104 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, k = 0, e = i[w + 48 >> 2], f = i[w + 44 >> 2], (e | 0) != (f | 0)) {
                                                                                                                                if (e = e - f | 0, (e | 0) < 0) break i;
                                                                                                                                k = D(e), i[n + 96 >> 2] = k, _ = e + k | 0, i[n + 104 >> 2] = _, v0(k, f, e), i[n + 100 >> 2] = _;
                                                                                                                            }
                                                                                                                            switch(R = V + 104 | 0, e = o[V + 115 | 0], f = (e | 0) < 0, t = i[V + 108 >> 2], s = f ? t : e, s - 25 | 0){
                                                                                                                                case 18:
                                                                                                                                    break B;
                                                                                                                                case 1:
                                                                                                                                    break m;
                                                                                                                                case 0:
                                                                                                                                    break Z;
                                                                                                                                default:
                                                                                                                                    break v;
                                                                                                                            }
                                                                                                                        }
                                                                                                                        if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                                                                                                    }
                                                                                                                    i[n + 96 >> 2] = q, i[n + 104 >> 2] = 59808, i[n + 160 >> 2] = 59828, e = n + 96 | 0, i[e + i[m0 >> 2] >> 2] = R0, i[n + 100 >> 2] = 0, k = e + i[i[n + 96 >> 2] - 12 >> 2] | 0, T0(k, S), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, i[n + 104 >> 2] = s0, i[P + i[L >> 2] >> 2] = g0, i[n + 96 >> 2] = f0, i[e + i[t0 >> 2] >> 2] = F0, i[n + 160 >> 2] = 59828, i[n + 96 >> 2] = 59788, i[n + 104 >> 2] = 59808, f = z0(S), i[f >> 2] = 58864, i[n + 148 >> 2] = 0, i[n + 152 >> 2] = 0, i[n + 140 >> 2] = 0, i[n + 144 >> 2] = 0, i[n + 156 >> 2] = 24, M0(U(P, 22321, 27), i[i[F >> 2] + 36 >> 2]), e = i[n + 156 >> 2];
                                                                                                                    W: {
                                                                                                                        if (e & 16) {
                                                                                                                            if (e = G, s = i[n + 152 >> 2], k = i[n + 132 >> 2], s >>> 0 >= k >>> 0) break W;
                                                                                                                            i[n + 152 >> 2] = k, s = k;
                                                                                                                            break W;
                                                                                                                        }
                                                                                                                        if (!(e & 8)) {
                                                                                                                            e = 0, o[n + 251 | 0] = 0, s = n + 240 | 0;
                                                                                                                            break t;
                                                                                                                        }
                                                                                                                        s = i[n + 124 >> 2], e = B;
                                                                                                                    }
                                                                                                                    if (k = i[e >> 2], e = s - k | 0, e >>> 0 >= 2147483640) break h;
                                                                                                                    if (e >>> 0 >= 11) {
                                                                                                                        t = (e | 7) + 1 | 0, s = D(t), i[n + 248 >> 2] = t | -2147483648, i[n + 240 >> 2] = s, i[n + 244 >> 2] = e;
                                                                                                                        break o;
                                                                                                                    }
                                                                                                                    if (o[n + 251 | 0] = e, s = n + 240 | 0, e) break o;
                                                                                                                    e = 0;
                                                                                                                    break t;
                                                                                                                }
                                                                                                                if (O2(f ? i[R >> 2] : R, 18164, 25)) break v;
                                                                                                                if ((k | 0) != (_ | 0)) break _;
                                                                                                                break v;
                                                                                                            }
                                                                                                            if (O2(f ? i[R >> 2] : R, 18137, s)) break v;
                                                                                                            if ((k | 0) != (_ | 0)) break _;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (O2(f ? i[R >> 2] : R, 15657, s) | (k | 0) == (_ | 0)) break v;
                                                                                                    }
                                                                                                    for(;;){
                                                                                                        f = i[k >> 2];
                                                                                                        _: {
                                                                                                            B: {
                                                                                                                t = C, e = i[t >> 2];
                                                                                                                m: {
                                                                                                                    if (!e) break m;
                                                                                                                    for(; s = f >>> 0 > k0[e + 16 >> 2], t = s ? t : e, e = i[(s << 2) + e >> 2], !!e;);
                                                                                                                    if ((t | 0) == (C | 0)) break m;
                                                                                                                    if (f >>> 0 >= k0[t + 16 >> 2]) break B;
                                                                                                                }
                                                                                                                if (ce(i[r + 48 >> 2], f)) break _;
                                                                                                                e = D(40), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 35, i[n + 248 >> 2] = -2147483608, k = l[14524] | l[14525] << 8 | (l[14526] << 16 | l[14527] << 24), f = l[14520] | l[14521] << 8 | (l[14522] << 16 | l[14523] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 35 | 0] = 0, k = l[14551] | l[14552] << 8 | (l[14553] << 16 | l[14554] << 24), o[e + 31 | 0] = k, o[e + 32 | 0] = k >>> 8, o[e + 33 | 0] = k >>> 16, o[e + 34 | 0] = k >>> 24, k = l[14548] | l[14549] << 8 | (l[14550] << 16 | l[14551] << 24), f = l[14544] | l[14545] << 8 | (l[14546] << 16 | l[14547] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[14540] | l[14541] << 8 | (l[14542] << 16 | l[14543] << 24), f = l[14536] | l[14537] << 8 | (l[14538] << 16 | l[14539] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[14532] | l[14533] << 8 | (l[14534] << 16 | l[14535] << 24), f = l[14528] | l[14529] << 8 | (l[14530] << 16 | l[14531] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                                break w;
                                                                                                            }
                                                                                                            s = i[t + 20 >> 2], f = i[t + 24 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), v = i[F >> 2];
                                                                                                            B: {
                                                                                                                if ((v | 0) == (s | 0)) {
                                                                                                                    e = D(32), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 30, i[n + 248 >> 2] = -2147483616, t = l[13521] | l[13522] << 8 | (l[13523] << 16 | l[13524] << 24), h = l[13517] | l[13518] << 8 | (l[13519] << 16 | l[13520] << 24), o[e | 0] = h, o[e + 1 | 0] = h >>> 8, o[e + 2 | 0] = h >>> 16, o[e + 3 | 0] = h >>> 24, o[e + 4 | 0] = t, o[e + 5 | 0] = t >>> 8, o[e + 6 | 0] = t >>> 16, o[e + 7 | 0] = t >>> 24, o[e + 30 | 0] = 0, t = l[13543] | l[13544] << 8 | (l[13545] << 16 | l[13546] << 24), h = l[13539] | l[13540] << 8 | (l[13541] << 16 | l[13542] << 24), o[e + 22 | 0] = h, o[e + 23 | 0] = h >>> 8, o[e + 24 | 0] = h >>> 16, o[e + 25 | 0] = h >>> 24, o[e + 26 | 0] = t, o[e + 27 | 0] = t >>> 8, o[e + 28 | 0] = t >>> 16, o[e + 29 | 0] = t >>> 24, t = l[13537] | l[13538] << 8 | (l[13539] << 16 | l[13540] << 24), h = l[13533] | l[13534] << 8 | (l[13535] << 16 | l[13536] << 24), o[e + 16 | 0] = h, o[e + 17 | 0] = h >>> 8, o[e + 18 | 0] = h >>> 16, o[e + 19 | 0] = h >>> 24, o[e + 20 | 0] = t, o[e + 21 | 0] = t >>> 8, o[e + 22 | 0] = t >>> 16, o[e + 23 | 0] = t >>> 24, t = l[13529] | l[13530] << 8 | (l[13531] << 16 | l[13532] << 24), h = l[13525] | l[13526] << 8 | (l[13527] << 16 | l[13528] << 24), o[e + 8 | 0] = h, o[e + 9 | 0] = h >>> 8, o[e + 10 | 0] = h >>> 16, o[e + 11 | 0] = h >>> 24, o[e + 12 | 0] = t, o[e + 13 | 0] = t >>> 8, o[e + 14 | 0] = t >>> 16, o[e + 15 | 0] = t >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                                    break B;
                                                                                                                }
                                                                                                                if (o[v + 64 | 0] = 1, e = i[u + 24 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[s + 68 >> 2] = v, t = i[s + 72 >> 2], i[s + 72 >> 2] = e, e = 0, !t || (h = i[t + 4 >> 2], i[t + 4 >> 2] = h - 1, h)) break B;
                                                                                                                p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                                                                            }
                                                                                                            B: {
                                                                                                                if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break B;
                                                                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                                            }
                                                                                                            if ((s | 0) == (v | 0)) break w;
                                                                                                        }
                                                                                                        if (k = k + 4 | 0, (_ | 0) == (k | 0)) break;
                                                                                                    }
                                                                                                    e = l[V + 115 | 0], t = i[V + 108 >> 2];
                                                                                                }
                                                                                                v: {
                                                                                                    _: {
                                                                                                        if (k = e, e = e << 24 >> 24 < 0, k = (e ? t : k) - 26 | 0, k) {
                                                                                                            if ((k | 0) == 17) break _;
                                                                                                            break l;
                                                                                                        }
                                                                                                        if (!O2(e ? i[R >> 2] : R, 17898, 26)) break v;
                                                                                                        break l;
                                                                                                    }
                                                                                                    if (O2(e ? i[R >> 2] : R, 8822, 43)) break l;
                                                                                                }
                                                                                                if (o[i[F >> 2] + 76 | 0] = 1, k = i[n + 96 >> 2], V0 = i[n + 100 >> 2], (k | 0) == (V0 | 0)) break l;
                                                                                                for(;;){
                                                                                                    v: {
                                                                                                        f = i[k >> 2];
                                                                                                        _: {
                                                                                                            B: {
                                                                                                                t = C, e = i[t >> 2];
                                                                                                                m: {
                                                                                                                    if (!e) break m;
                                                                                                                    for(; s = f >>> 0 > k0[e + 16 >> 2], t = s ? t : e, e = i[(s << 2) + e >> 2], !!e;);
                                                                                                                    if ((t | 0) == (C | 0)) break m;
                                                                                                                    if (f >>> 0 >= k0[t + 16 >> 2]) break B;
                                                                                                                }
                                                                                                                if (ce(i[r + 48 >> 2], f)) break _;
                                                                                                                e = D(40), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 35, i[n + 248 >> 2] = -2147483608, k = l[14454] | l[14455] << 8 | (l[14456] << 16 | l[14457] << 24), f = l[14450] | l[14451] << 8 | (l[14452] << 16 | l[14453] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 35 | 0] = 0, k = l[14481] | l[14482] << 8 | (l[14483] << 16 | l[14484] << 24), o[e + 31 | 0] = k, o[e + 32 | 0] = k >>> 8, o[e + 33 | 0] = k >>> 16, o[e + 34 | 0] = k >>> 24, k = l[14478] | l[14479] << 8 | (l[14480] << 16 | l[14481] << 24), f = l[14474] | l[14475] << 8 | (l[14476] << 16 | l[14477] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[14470] | l[14471] << 8 | (l[14472] << 16 | l[14473] << 24), f = l[14466] | l[14467] << 8 | (l[14468] << 16 | l[14469] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[14462] | l[14463] << 8 | (l[14464] << 16 | l[14465] << 24), f = l[14458] | l[14459] << 8 | (l[14460] << 16 | l[14461] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                                break w;
                                                                                                            }
                                                                                                            if (e = i[F >> 2], f = i[t + 20 >> 2], (e | 0) == (f | 0)) {
                                                                                                                e = D(32), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 30, i[n + 248 >> 2] = -2147483616, k = l[13490] | l[13491] << 8 | (l[13492] << 16 | l[13493] << 24), f = l[13486] | l[13487] << 8 | (l[13488] << 16 | l[13489] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 30 | 0] = 0, k = l[13512] | l[13513] << 8 | (l[13514] << 16 | l[13515] << 24), f = l[13508] | l[13509] << 8 | (l[13510] << 16 | l[13511] << 24), o[e + 22 | 0] = f, o[e + 23 | 0] = f >>> 8, o[e + 24 | 0] = f >>> 16, o[e + 25 | 0] = f >>> 24, o[e + 26 | 0] = k, o[e + 27 | 0] = k >>> 8, o[e + 28 | 0] = k >>> 16, o[e + 29 | 0] = k >>> 24, k = l[13506] | l[13507] << 8 | (l[13508] << 16 | l[13509] << 24), f = l[13502] | l[13503] << 8 | (l[13504] << 16 | l[13505] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[13498] | l[13499] << 8 | (l[13500] << 16 | l[13501] << 24), f = l[13494] | l[13495] << 8 | (l[13496] << 16 | l[13497] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                                break w;
                                                                                                            }
                                                                                                            t = i[u + 24 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[f + 80 >> 2] = e, e = i[f + 84 >> 2], i[f + 84 >> 2] = t;
                                                                                                            B: {
                                                                                                                if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break B;
                                                                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                                            }
                                                                                                            if (i[V + 116 >> 2] == i[V + 120 >> 2]) break _;
                                                                                                            i[n + 248 >> 2] = 0, i[n + 240 >> 2] = 0, i[n + 244 >> 2] = 0, H0 = n + 240 | 0, t = m - 96 | 0, m = t, e = i[V + 116 >> 2], f = wi(t - -64 | 0, e, i[V + 120 >> 2] - e | 0), e = i[f + 8 >> 2], v = e >> 31 << 3 | e >>> 29, s = i[f + 24 >> 2], e = s + (e << 3) | 0, h = (s >> 31) + v | 0, h = e >>> 0 < s >>> 0 ? h + 1 | 0 : h;
                                                                                                            B: {
                                                                                                                if ((h | 0) <= 0 & e >>> 0 <= 31 | (h | 0) < 0) {
                                                                                                                    if (e = D(24), i[t + 32 >> 2] = e, i[t + 36 >> 2] = 22, i[t + 40 >> 2] = -2147483624, f = l[3282] | l[3283] << 8 | (l[3284] << 16 | l[3285] << 24), s = l[3278] | l[3279] << 8 | (l[3280] << 16 | l[3281] << 24), o[e | 0] = s, o[e + 1 | 0] = s >>> 8, o[e + 2 | 0] = s >>> 16, o[e + 3 | 0] = s >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 22 | 0] = 0, f = l[3296] | l[3297] << 8 | (l[3298] << 16 | l[3299] << 24), s = l[3292] | l[3293] << 8 | (l[3294] << 16 | l[3295] << 24), o[e + 14 | 0] = s, o[e + 15 | 0] = s >>> 8, o[e + 16 | 0] = s >>> 16, o[e + 17 | 0] = s >>> 24, o[e + 18 | 0] = f, o[e + 19 | 0] = f >>> 8, o[e + 20 | 0] = f >>> 16, o[e + 21 | 0] = f >>> 24, f = l[3290] | l[3291] << 8 | (l[3292] << 16 | l[3293] << 24), s = l[3286] | l[3287] << 8 | (l[3288] << 16 | l[3289] << 24), o[e + 8 | 0] = s, o[e + 9 | 0] = s >>> 8, o[e + 10 | 0] = s >>> 16, o[e + 11 | 0] = s >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 100, t + 32 | 0), o[t + 43 | 0] >= 0) break B;
                                                                                                                    X(i[t + 32 >> 2]);
                                                                                                                    break B;
                                                                                                                }
                                                                                                                h = $0(f, 32), e = (i[f + 4 >> 2] - i[f + 8 >> 2] | 0) + (i[f + 24 >> 2] / -8 | 0) | 0;
                                                                                                                m: {
                                                                                                                    if ((h | 0) <= (e | 0)) break m;
                                                                                                                    if (e = e + i[V + 116 >> 2] | 0, s = wi(t + 32 | 0, e, i[V + 120 >> 2] - e | 0), e = i[s + 8 >> 2], h = e >> 31 << 3 | e >>> 29, f = i[s + 24 >> 2], e = f + (e << 3) | 0, W = (f >> 31) + h | 0, W = e >>> 0 < f >>> 0 ? W + 1 | 0 : W, (W | 0) <= 0 & e >>> 0 <= 39 | (W | 0) < 0) {
                                                                                                                        if (e = D(24), i[t + 4 >> 2] = e, i[t + 8 >> 2] = 22, i[t + 12 >> 2] = -2147483624, f = l[3282] | l[3283] << 8 | (l[3284] << 16 | l[3285] << 24), s = l[3278] | l[3279] << 8 | (l[3280] << 16 | l[3281] << 24), o[e | 0] = s, o[e + 1 | 0] = s >>> 8, o[e + 2 | 0] = s >>> 16, o[e + 3 | 0] = s >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 22 | 0] = 0, f = l[3296] | l[3297] << 8 | (l[3298] << 16 | l[3299] << 24), s = l[3292] | l[3293] << 8 | (l[3294] << 16 | l[3295] << 24), o[e + 14 | 0] = s, o[e + 15 | 0] = s >>> 8, o[e + 16 | 0] = s >>> 16, o[e + 17 | 0] = s >>> 24, o[e + 18 | 0] = f, o[e + 19 | 0] = f >>> 8, o[e + 20 | 0] = f >>> 16, o[e + 21 | 0] = f >>> 24, f = l[3290] | l[3291] << 8 | (l[3292] << 16 | l[3293] << 24), s = l[3286] | l[3287] << 8 | (l[3288] << 16 | l[3289] << 24), o[e + 8 | 0] = s, o[e + 9 | 0] = s >>> 8, o[e + 10 | 0] = s >>> 16, o[e + 11 | 0] = s >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 100, t + 4 | 0), o[t + 15 | 0] >= 0) break B;
                                                                                                                        X(i[t + 4 >> 2]);
                                                                                                                        break B;
                                                                                                                    }
                                                                                                                    if ($0(s, 32), e = Z1(s, 8), C2(s, 8), ((e >>> 1 | 0) - 39 & 255) >>> 0 > 1) break m;
                                                                                                                    if (e = i[s + 24 >> 2], f = e, h = e >> 31, e = i[s + 8 >> 2], v = e >> 31 << 3 | e >>> 29, W = f, f = e << 3, e = W + f | 0, v = h + v | 0, v = e >>> 0 < f >>> 0 ? v + 1 | 0 : v, (v | 0) <= 0 & e >>> 0 <= 15 | (v | 0) < 0) {
                                                                                                                        if (e = D(24), i[t + 4 >> 2] = e, i[t + 8 >> 2] = 22, i[t + 12 >> 2] = -2147483624, f = l[3282] | l[3283] << 8 | (l[3284] << 16 | l[3285] << 24), s = l[3278] | l[3279] << 8 | (l[3280] << 16 | l[3281] << 24), o[e | 0] = s, o[e + 1 | 0] = s >>> 8, o[e + 2 | 0] = s >>> 16, o[e + 3 | 0] = s >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 22 | 0] = 0, f = l[3296] | l[3297] << 8 | (l[3298] << 16 | l[3299] << 24), s = l[3292] | l[3293] << 8 | (l[3294] << 16 | l[3295] << 24), o[e + 14 | 0] = s, o[e + 15 | 0] = s >>> 8, o[e + 16 | 0] = s >>> 16, o[e + 17 | 0] = s >>> 24, o[e + 18 | 0] = f, o[e + 19 | 0] = f >>> 8, o[e + 20 | 0] = f >>> 16, o[e + 21 | 0] = f >>> 24, f = l[3290] | l[3291] << 8 | (l[3292] << 16 | l[3293] << 24), s = l[3286] | l[3287] << 8 | (l[3288] << 16 | l[3289] << 24), o[e + 8 | 0] = s, o[e + 9 | 0] = s >>> 8, o[e + 10 | 0] = s >>> 16, o[e + 11 | 0] = s >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 100, t + 4 | 0), o[t + 15 | 0] >= 0) break B;
                                                                                                                        X(i[t + 4 >> 2]);
                                                                                                                        break B;
                                                                                                                    }
                                                                                                                    if (e = Z1(s, 8), Z1(s, 8), (e | 0) != 177) break m;
                                                                                                                    v = m - 48 | 0, m = v, h = t + 4 | 0, e = h, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, e = D(80), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e >> 2] = 80536, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 76 >> 2] = 0, i[e + 16 >> 2] = 80576, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, f = e - -64 | 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, o[e + 24 | 0] = 1, f = $0(s, 1), o[e + 25 | 0] = f, t2 = e, v2 = $0(s, 1), o[t2 + 26 | 0] = v2, _ = $0(s, 1), o[e + 27 | 0] = _, W = $0(s, 1), o[e + 28 | 0] = W;
                                                                                                                    Z: {
                                                                                                                        W: {
                                                                                                                            X: {
                                                                                                                                if (!R1(s, v + 44 | 0)) {
                                                                                                                                    if (f = D(48), i[v + 12 >> 2] = f, i[v + 16 >> 2] = 42, i[v + 20 >> 2] = -2147483600, s = l[2995] | l[2996] << 8, o[f + 40 | 0] = s, o[f + 41 | 0] = s >>> 8, s = l[2991] | l[2992] << 8 | (l[2993] << 16 | l[2994] << 24), _ = l[2987] | l[2988] << 8 | (l[2989] << 16 | l[2990] << 24), o[f + 32 | 0] = _, o[f + 33 | 0] = _ >>> 8, o[f + 34 | 0] = _ >>> 16, o[f + 35 | 0] = _ >>> 24, o[f + 36 | 0] = s, o[f + 37 | 0] = s >>> 8, o[f + 38 | 0] = s >>> 16, o[f + 39 | 0] = s >>> 24, s = l[2983] | l[2984] << 8 | (l[2985] << 16 | l[2986] << 24), _ = l[2979] | l[2980] << 8 | (l[2981] << 16 | l[2982] << 24), o[f + 24 | 0] = _, o[f + 25 | 0] = _ >>> 8, o[f + 26 | 0] = _ >>> 16, o[f + 27 | 0] = _ >>> 24, o[f + 28 | 0] = s, o[f + 29 | 0] = s >>> 8, o[f + 30 | 0] = s >>> 16, o[f + 31 | 0] = s >>> 24, s = l[2975] | l[2976] << 8 | (l[2977] << 16 | l[2978] << 24), _ = l[2971] | l[2972] << 8 | (l[2973] << 16 | l[2974] << 24), o[f + 16 | 0] = _, o[f + 17 | 0] = _ >>> 8, o[f + 18 | 0] = _ >>> 16, o[f + 19 | 0] = _ >>> 24, o[f + 20 | 0] = s, o[f + 21 | 0] = s >>> 8, o[f + 22 | 0] = s >>> 16, o[f + 23 | 0] = s >>> 24, s = l[2967] | l[2968] << 8 | (l[2969] << 16 | l[2970] << 24), _ = l[2963] | l[2964] << 8 | (l[2965] << 16 | l[2966] << 24), o[f + 8 | 0] = _, o[f + 9 | 0] = _ >>> 8, o[f + 10 | 0] = _ >>> 16, o[f + 11 | 0] = _ >>> 24, o[f + 12 | 0] = s, o[f + 13 | 0] = s >>> 8, o[f + 14 | 0] = s >>> 16, o[f + 15 | 0] = s >>> 24, s = l[2959] | l[2960] << 8 | (l[2961] << 16 | l[2962] << 24), _ = l[2955] | l[2956] << 8 | (l[2957] << 16 | l[2958] << 24), o[f | 0] = _, o[f + 1 | 0] = _ >>> 8, o[f + 2 | 0] = _ >>> 16, o[f + 3 | 0] = _ >>> 24, o[f + 4 | 0] = s, o[f + 5 | 0] = s >>> 8, o[f + 6 | 0] = s >>> 16, o[f + 7 | 0] = s >>> 24, o[f + 42 | 0] = 0, f = i0(v + 24 | 0, 2, 2006, v + 12 | 0), s = i[f + 4 >> 2], i[h + 8 >> 2] = i[f >> 2], i[h + 12 >> 2] = s, o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), s = i[f + 12 >> 2], i[h + 16 >> 2] = i[f + 8 >> 2], i[h + 20 >> 2] = s, i[h + 24 >> 2] = i[f + 16 >> 2], o[f + 19 | 0] = 0, o[f + 8 | 0] = 0, o[v + 23 | 0] >= 0) break X;
                                                                                                                                    X(i[v + 12 >> 2]);
                                                                                                                                    break X;
                                                                                                                                }
                                                                                                                                if (r0 = i[v + 44 >> 2], r0 >>> 0 >= 4) {
                                                                                                                                    if (f = D(48), i[v + 12 >> 2] = f, i[v + 16 >> 2] = 44, i[v + 20 >> 2] = -2147483600, s = l[11282] | l[11283] << 8 | (l[11284] << 16 | l[11285] << 24), o[f + 40 | 0] = s, o[f + 41 | 0] = s >>> 8, o[f + 42 | 0] = s >>> 16, o[f + 43 | 0] = s >>> 24, s = l[11278] | l[11279] << 8 | (l[11280] << 16 | l[11281] << 24), _ = l[11274] | l[11275] << 8 | (l[11276] << 16 | l[11277] << 24), o[f + 32 | 0] = _, o[f + 33 | 0] = _ >>> 8, o[f + 34 | 0] = _ >>> 16, o[f + 35 | 0] = _ >>> 24, o[f + 36 | 0] = s, o[f + 37 | 0] = s >>> 8, o[f + 38 | 0] = s >>> 16, o[f + 39 | 0] = s >>> 24, s = l[11270] | l[11271] << 8 | (l[11272] << 16 | l[11273] << 24), _ = l[11266] | l[11267] << 8 | (l[11268] << 16 | l[11269] << 24), o[f + 24 | 0] = _, o[f + 25 | 0] = _ >>> 8, o[f + 26 | 0] = _ >>> 16, o[f + 27 | 0] = _ >>> 24, o[f + 28 | 0] = s, o[f + 29 | 0] = s >>> 8, o[f + 30 | 0] = s >>> 16, o[f + 31 | 0] = s >>> 24, s = l[11262] | l[11263] << 8 | (l[11264] << 16 | l[11265] << 24), _ = l[11258] | l[11259] << 8 | (l[11260] << 16 | l[11261] << 24), o[f + 16 | 0] = _, o[f + 17 | 0] = _ >>> 8, o[f + 18 | 0] = _ >>> 16, o[f + 19 | 0] = _ >>> 24, o[f + 20 | 0] = s, o[f + 21 | 0] = s >>> 8, o[f + 22 | 0] = s >>> 16, o[f + 23 | 0] = s >>> 24, s = l[11254] | l[11255] << 8 | (l[11256] << 16 | l[11257] << 24), _ = l[11250] | l[11251] << 8 | (l[11252] << 16 | l[11253] << 24), o[f + 8 | 0] = _, o[f + 9 | 0] = _ >>> 8, o[f + 10 | 0] = _ >>> 16, o[f + 11 | 0] = _ >>> 24, o[f + 12 | 0] = s, o[f + 13 | 0] = s >>> 8, o[f + 14 | 0] = s >>> 16, o[f + 15 | 0] = s >>> 24, s = l[11246] | l[11247] << 8 | (l[11248] << 16 | l[11249] << 24), _ = l[11242] | l[11243] << 8 | (l[11244] << 16 | l[11245] << 24), o[f | 0] = _, o[f + 1 | 0] = _ >>> 8, o[f + 2 | 0] = _ >>> 16, o[f + 3 | 0] = _ >>> 24, o[f + 4 | 0] = s, o[f + 5 | 0] = s >>> 8, o[f + 6 | 0] = s >>> 16, o[f + 7 | 0] = s >>> 24, o[f + 44 | 0] = 0, f = i0(v + 24 | 0, 2, 2006, v + 12 | 0), s = i[f + 4 >> 2], i[h + 8 >> 2] = i[f >> 2], i[h + 12 >> 2] = s, o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), s = i[f + 12 >> 2], i[h + 16 >> 2] = i[f + 8 >> 2], i[h + 20 >> 2] = s, i[h + 24 >> 2] = i[f + 16 >> 2], o[f + 19 | 0] = 0, o[f + 8 | 0] = 0, o[v + 23 | 0] >= 0) break X;
                                                                                                                                    X(i[v + 12 >> 2]);
                                                                                                                                    break X;
                                                                                                                                }
                                                                                                                                if (i[e + 64 >> 2] = r0, (_ | W) & 255) {
                                                                                                                                    if (!R1(s, v + 8 | 0)) {
                                                                                                                                        if (f = D(48), i[v + 12 >> 2] = f, i[v + 16 >> 2] = 41, i[v + 20 >> 2] = -2147483600, o[f + 40 | 0] = l[2953], s = l[2949] | l[2950] << 8 | (l[2951] << 16 | l[2952] << 24), _ = l[2945] | l[2946] << 8 | (l[2947] << 16 | l[2948] << 24), o[f + 32 | 0] = _, o[f + 33 | 0] = _ >>> 8, o[f + 34 | 0] = _ >>> 16, o[f + 35 | 0] = _ >>> 24, o[f + 36 | 0] = s, o[f + 37 | 0] = s >>> 8, o[f + 38 | 0] = s >>> 16, o[f + 39 | 0] = s >>> 24, s = l[2941] | l[2942] << 8 | (l[2943] << 16 | l[2944] << 24), _ = l[2937] | l[2938] << 8 | (l[2939] << 16 | l[2940] << 24), o[f + 24 | 0] = _, o[f + 25 | 0] = _ >>> 8, o[f + 26 | 0] = _ >>> 16, o[f + 27 | 0] = _ >>> 24, o[f + 28 | 0] = s, o[f + 29 | 0] = s >>> 8, o[f + 30 | 0] = s >>> 16, o[f + 31 | 0] = s >>> 24, s = l[2933] | l[2934] << 8 | (l[2935] << 16 | l[2936] << 24), _ = l[2929] | l[2930] << 8 | (l[2931] << 16 | l[2932] << 24), o[f + 16 | 0] = _, o[f + 17 | 0] = _ >>> 8, o[f + 18 | 0] = _ >>> 16, o[f + 19 | 0] = _ >>> 24, o[f + 20 | 0] = s, o[f + 21 | 0] = s >>> 8, o[f + 22 | 0] = s >>> 16, o[f + 23 | 0] = s >>> 24, s = l[2925] | l[2926] << 8 | (l[2927] << 16 | l[2928] << 24), _ = l[2921] | l[2922] << 8 | (l[2923] << 16 | l[2924] << 24), o[f + 8 | 0] = _, o[f + 9 | 0] = _ >>> 8, o[f + 10 | 0] = _ >>> 16, o[f + 11 | 0] = _ >>> 24, o[f + 12 | 0] = s, o[f + 13 | 0] = s >>> 8, o[f + 14 | 0] = s >>> 16, o[f + 15 | 0] = s >>> 24, s = l[2917] | l[2918] << 8 | (l[2919] << 16 | l[2920] << 24), _ = l[2913] | l[2914] << 8 | (l[2915] << 16 | l[2916] << 24), o[f | 0] = _, o[f + 1 | 0] = _ >>> 8, o[f + 2 | 0] = _ >>> 16, o[f + 3 | 0] = _ >>> 24, o[f + 4 | 0] = s, o[f + 5 | 0] = s >>> 8, o[f + 6 | 0] = s >>> 16, o[f + 7 | 0] = s >>> 24, o[f + 41 | 0] = 0, f = i0(v + 24 | 0, 2, 2006, v + 12 | 0), s = i[f + 4 >> 2], i[h + 8 >> 2] = i[f >> 2], i[h + 12 >> 2] = s, o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), s = i[f + 12 >> 2], i[h + 16 >> 2] = i[f + 8 >> 2], i[h + 20 >> 2] = s, i[h + 24 >> 2] = i[f + 16 >> 2], o[f + 19 | 0] = 0, o[f + 8 | 0] = 0, o[v + 23 | 0] < 0 && X(i[v + 12 >> 2]), f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, !f) break W;
                                                                                                                                        break Z;
                                                                                                                                    }
                                                                                                                                    i[e + 68 >> 2] = i[v + 8 >> 2], f = l[e + 25 | 0];
                                                                                                                                }
                                                                                                                                if (f & 255) {
                                                                                                                                    W = Z1(s, 1), f = $0(s, 7), _ = Z1(s, 5) + 1 & 255, y = +($0(s, _) >>> 0);
                                                                                                                                    p: {
                                                                                                                                        if ((f | 0) > 0) {
                                                                                                                                            T = T1(1, _), y = T1(1, f - 31 | 0) * (y / T + 1);
                                                                                                                                            break p;
                                                                                                                                        }
                                                                                                                                        y = T1(1, -30 - _ | 0) * y;
                                                                                                                                    }
                                                                                                                                    n0[e + 32 >> 3] = W ? -y : y;
                                                                                                                                }
                                                                                                                                if (l[e + 26 | 0]) {
                                                                                                                                    W = Z1(s, 1), f = $0(s, 7), _ = Z1(s, 5) + 1 & 255, y = +($0(s, _) >>> 0);
                                                                                                                                    p: {
                                                                                                                                        if ((f | 0) > 0) {
                                                                                                                                            T = T1(1, _), y = T1(1, f - 31 | 0) * (y / T + 1);
                                                                                                                                            break p;
                                                                                                                                        }
                                                                                                                                        y = T1(1, -30 - _ | 0) * y;
                                                                                                                                    }
                                                                                                                                    n0[e + 40 >> 3] = W ? -y : y;
                                                                                                                                }
                                                                                                                                if (l[e + 27 | 0]) {
                                                                                                                                    W = Z1(s, 1), f = $0(s, 7), _ = Z1(s, 5) + 1 & 255, y = +($0(s, _) >>> 0);
                                                                                                                                    p: {
                                                                                                                                        if ((f | 0) > 0) {
                                                                                                                                            T = T1(1, _), y = T1(1, f - 31 | 0) * (y / T + 1);
                                                                                                                                            break p;
                                                                                                                                        }
                                                                                                                                        y = T1(1, -30 - _ | 0) * y;
                                                                                                                                    }
                                                                                                                                    n0[e + 48 >> 3] = W ? -y : y;
                                                                                                                                }
                                                                                                                                if (l[e + 28 | 0]) {
                                                                                                                                    _ = Z1(s, 1), f = $0(s, 7), W = s, s = Z1(s, 5) + 1 & 255, y = +($0(W, s) >>> 0);
                                                                                                                                    p: {
                                                                                                                                        if ((f | 0) > 0) {
                                                                                                                                            T = T1(1, s), y = T1(1, f - 31 | 0) * (y / T + 1);
                                                                                                                                            break p;
                                                                                                                                        }
                                                                                                                                        y = T1(1, -30 - s | 0) * y;
                                                                                                                                    }
                                                                                                                                    n0[e + 56 >> 3] = _ ? -y : y;
                                                                                                                                }
                                                                                                                                if (i[e + 4 >> 2] = i[e + 4 >> 2] + 1, i[h >> 2] = e + 16, f = i[h + 4 >> 2], i[h + 4 >> 2] = e, !f || (s = i[f + 4 >> 2], i[f + 4 >> 2] = s - 1, s)) break X;
                                                                                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                                                            }
                                                                                                                            if (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f) break Z;
                                                                                                                        }
                                                                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                                                    }
                                                                                                                    if (m = v + 48 | 0, i[t + 12 >> 2]) {
                                                                                                                        e = i[t + 16 >> 2], i[A >> 2] = i[t + 12 >> 2], i[A + 4 >> 2] = e, e = A + 8 | 0;
                                                                                                                        Z: {
                                                                                                                            if (o[t + 31 | 0] >= 0) {
                                                                                                                                f = i[t + 24 >> 2], i[e >> 2] = i[t + 20 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[t + 28 >> 2];
                                                                                                                                break Z;
                                                                                                                            }
                                                                                                                            j(e, i[t + 20 >> 2], i[t + 24 >> 2]);
                                                                                                                        }
                                                                                                                        Wt(t + 4 | 0);
                                                                                                                        break B;
                                                                                                                    }
                                                                                                                    e = t + 4 | 0, ut(H0, e), Wt(e);
                                                                                                                }
                                                                                                                if (e = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = e, e = A + 8 | 0, o[86691] >= 0) {
                                                                                                                    f = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[21672];
                                                                                                                    break B;
                                                                                                                }
                                                                                                                j(e, i[21670], i[21671]);
                                                                                                            }
                                                                                                            if (m = t + 96 | 0, e = i[n + 240 >> 2], i[A >> 2]) break v;
                                                                                                            if (v = i[n + 244 >> 2], (v | 0) != (e | 0)) for(;;){
                                                                                                                f = i[e >> 2];
                                                                                                                B: {
                                                                                                                    if (!f || (f = E0(f, 78404, 78420), !f)) break B;
                                                                                                                    if (s = i[e + 4 >> 2], !s) {
                                                                                                                        t = i[F >> 2], o[t + 88 | 0] = 1, s = i[f + 12 >> 2], i[t + 96 >> 2] = i[f + 8 >> 2], i[t + 100 >> 2] = s, s = i[f + 20 >> 2], i[t + 104 >> 2] = i[f + 16 >> 2], i[t + 108 >> 2] = s, s = i[f + 28 >> 2], i[t + 112 >> 2] = i[f + 24 >> 2], i[t + 116 >> 2] = s, s = i[f + 36 >> 2], i[t + 120 >> 2] = i[f + 32 >> 2], i[t + 124 >> 2] = s, s = i[f + 44 >> 2], i[t + 128 >> 2] = i[f + 40 >> 2], i[t + 132 >> 2] = s, s = i[f + 52 >> 2], i[t + 136 >> 2] = i[f + 48 >> 2], i[t + 140 >> 2] = s, s = i[f + 60 >> 2], i[t + 144 >> 2] = i[f + 56 >> 2], i[t + 148 >> 2] = s;
                                                                                                                        break B;
                                                                                                                    }
                                                                                                                    if (i[s + 4 >> 2] = i[s + 4 >> 2] + 1, t = i[F >> 2], o[t + 88 | 0] = 1, h = i[f + 12 >> 2], i[t + 96 >> 2] = i[f + 8 >> 2], i[t + 100 >> 2] = h, h = i[f + 20 >> 2], i[t + 104 >> 2] = i[f + 16 >> 2], i[t + 108 >> 2] = h, h = i[f + 28 >> 2], i[t + 112 >> 2] = i[f + 24 >> 2], i[t + 116 >> 2] = h, h = i[f + 36 >> 2], i[t + 120 >> 2] = i[f + 32 >> 2], i[t + 124 >> 2] = h, h = i[f + 44 >> 2], i[t + 128 >> 2] = i[f + 40 >> 2], i[t + 132 >> 2] = h, h = i[f + 52 >> 2], i[t + 136 >> 2] = i[f + 48 >> 2], i[t + 140 >> 2] = h, h = i[f + 60 >> 2], i[t + 144 >> 2] = i[f + 56 >> 2], i[t + 148 >> 2] = h, f = i[s + 4 >> 2], i[s + 4 >> 2] = f - 1, f) break B;
                                                                                                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                                                                                }
                                                                                                                if (e = e + 8 | 0, (v | 0) == (e | 0)) break;
                                                                                                            }
                                                                                                            if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), f = i[n + 240 >> 2], !f) break _;
                                                                                                            if (e = i[n + 244 >> 2], t = f, (e | 0) != (f | 0)) {
                                                                                                                for(;;){
                                                                                                                    t = i[e - 4 >> 2];
                                                                                                                    B: {
                                                                                                                        if (!t || (s = i[t + 4 >> 2], i[t + 4 >> 2] = s - 1, s)) break B;
                                                                                                                        p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                                                                                    }
                                                                                                                    if (e = e - 8 | 0, (f | 0) == (e | 0)) break;
                                                                                                                }
                                                                                                                t = i[n + 240 >> 2];
                                                                                                            }
                                                                                                            i[n + 244 >> 2] = f, X(t);
                                                                                                        }
                                                                                                        if (k = k + 4 | 0, (V0 | 0) != (k | 0)) continue;
                                                                                                        break l;
                                                                                                    }
                                                                                                    break;
                                                                                                }
                                                                                                if (e) {
                                                                                                    if (s = e, t = i[n + 244 >> 2], (t | 0) != (e | 0)) {
                                                                                                        for(;;){
                                                                                                            k = i[t - 4 >> 2];
                                                                                                            v: {
                                                                                                                if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break v;
                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                            }
                                                                                                            if (t = t - 8 | 0, (t | 0) == (e | 0)) break;
                                                                                                        }
                                                                                                        s = i[n + 240 >> 2];
                                                                                                    }
                                                                                                    i[n + 244 >> 2] = e, X(s);
                                                                                                }
                                                                                                e = 1;
                                                                                                break w;
                                                                                            }
                                                                                            Y0(), z();
                                                                                        }
                                                                                        f = i[F >> 2], o[f + 152 | 0] = 1, e = f + 156 | 0;
                                                                                        l: {
                                                                                            if ((e | 0) == (R | 0)) break l;
                                                                                            if (k = o[V + 115 | 0], o[f + 167 | 0] >= 0) {
                                                                                                if ((k | 0) >= 0) {
                                                                                                    k = i[R + 4 >> 2], i[e >> 2] = i[R >> 2], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[R + 8 >> 2];
                                                                                                    break l;
                                                                                                }
                                                                                                X4(e, i[V + 104 >> 2], i[V + 108 >> 2]);
                                                                                                break l;
                                                                                            }
                                                                                            h = e, e = (k | 0) < 0, Y4(h, e ? i[V + 104 >> 2] : R, e ? i[V + 108 >> 2] : k);
                                                                                        }
                                                                                        if (f = i[n + 96 >> 2], v = i[n + 100 >> 2], (f | 0) == (v | 0)) {
                                                                                            e = 0;
                                                                                            break u;
                                                                                        }
                                                                                        for(;;){
                                                                                            k = i[f >> 2];
                                                                                            l: {
                                                                                                h: {
                                                                                                    t = C, e = i[t >> 2];
                                                                                                    v: {
                                                                                                        if (!e) break v;
                                                                                                        for(; s = k >>> 0 > k0[e + 16 >> 2], t = s ? t : e, e = i[(s << 2) + e >> 2], !!e;);
                                                                                                        if ((t | 0) == (C | 0)) break v;
                                                                                                        if (k >>> 0 >= k0[t + 16 >> 2]) break h;
                                                                                                    }
                                                                                                    if (ce(i[r + 48 >> 2], k)) break l;
                                                                                                    e = D(40), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 33, i[n + 248 >> 2] = -2147483608, k = l[14420] | l[14421] << 8 | (l[14422] << 16 | l[14423] << 24), f = l[14416] | l[14417] << 8 | (l[14418] << 16 | l[14419] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 33 | 0] = 0, o[e + 32 | 0] = l[14448], k = l[14444] | l[14445] << 8 | (l[14446] << 16 | l[14447] << 24), f = l[14440] | l[14441] << 8 | (l[14442] << 16 | l[14443] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[14436] | l[14437] << 8 | (l[14438] << 16 | l[14439] << 24), f = l[14432] | l[14433] << 8 | (l[14434] << 16 | l[14435] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[14428] | l[14429] << 8 | (l[14430] << 16 | l[14431] << 24), f = l[14424] | l[14425] << 8 | (l[14426] << 16 | l[14427] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                    break w;
                                                                                                }
                                                                                                if (s = i[F >> 2], k = i[t + 20 >> 2], (s | 0) == (k | 0)) {
                                                                                                    e = D(32), i[n + 240 >> 2] = e, i[n + 244 >> 2] = 28, i[n + 248 >> 2] = -2147483616, k = l[13426] | l[13427] << 8 | (l[13428] << 16 | l[13429] << 24), f = l[13422] | l[13423] << 8 | (l[13424] << 16 | l[13425] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 28 | 0] = 0, k = l[13446] | l[13447] << 8 | (l[13448] << 16 | l[13449] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, k = l[13442] | l[13443] << 8 | (l[13444] << 16 | l[13445] << 24), f = l[13438] | l[13439] << 8 | (l[13440] << 16 | l[13441] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[13434] | l[13435] << 8 | (l[13436] << 16 | l[13437] << 24), f = l[13430] | l[13431] << 8 | (l[13432] << 16 | l[13433] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), e = 1;
                                                                                                    break w;
                                                                                                }
                                                                                                e = i[u + 24 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[n + 244 >> 2] = e, i[n + 240 >> 2] = s, t = i[k + 172 >> 2];
                                                                                                h: {
                                                                                                    if (t >>> 0 < k0[k + 176 >> 2]) {
                                                                                                        i[t + 4 >> 2] = e, i[t >> 2] = s, i[k + 172 >> 2] = t + 8;
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (t = p2(k + 168 | 0, n + 240 | 0), e = i[n + 244 >> 2], i[k + 172 >> 2] = t, !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break h;
                                                                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                                }
                                                                                                O3(r, F);
                                                                                            }
                                                                                            if (f = f + 4 | 0, (v | 0) == (f | 0)) break;
                                                                                        }
                                                                                        e = 0;
                                                                                    }
                                                                                    f = i[n + 96 >> 2];
                                                                                }
                                                                                f && (i[n + 100 >> 2] = f, X(f));
                                                                                u: {
                                                                                    if (!H || (k = i[H + 4 >> 2], i[H + 4 >> 2] = k - 1, k)) break u;
                                                                                    p[i[i[H >> 2] + 8 >> 2]](H), g(H);
                                                                                }
                                                                                if (!e) break s;
                                                                                v = 1;
                                                                                break n;
                                                                            }
                                                                            if (w = w + 56 | 0, (X0 | 0) == (w | 0)) break;
                                                                        }
                                                                        v = 18;
                                                                        break n;
                                                                    }
                                                                    Q0(s, k, e);
                                                                }
                                                                o[e + s | 0] = 0, i0(A, 2, 123, n + 240 | 0), o[n + 251 | 0] < 0 && X(i[n + 240 >> 2]), i[n + 96 >> 2] = c, i[i[$ >> 2] + (n + 96 | 0) >> 2] = Z0, i[n + 104 >> 2] = I0, i[f >> 2] = 58864, o[n + 151 | 0] < 0 && X(i[n + 140 >> 2]), x0(f), N0(D0), v = 1;
                                                            }
                                                            w = i[n + 296 >> 2];
                                                        }
                                                        if (w) {
                                                            if (e = i[n + 300 >> 2], t = w, (e | 0) != (t | 0)) {
                                                                for(; k = i[e - 12 >> 2], k && (i[e - 8 >> 2] = k, X(k)), k = e - 56 | 0, i[k >> 2] = 73428, f = i[e - 36 >> 2], f && (i[e - 32 >> 2] = f, X(f)), e = k, (w | 0) != (e | 0););
                                                                t = i[n + 296 >> 2];
                                                            }
                                                            i[n + 300 >> 2] = w, X(t);
                                                        }
                                                        k: {
                                                            if ((v | 0) != 18) {
                                                                if ((v | 0) == 16) break k;
                                                                break f;
                                                            }
                                                            t = u, e = i[t + 4 >> 2];
                                                            n: {
                                                                if (e) {
                                                                    for(;;)if (u = e, e = i[e >> 2], !e) break n;
                                                                }
                                                                for(; u = i[t + 8 >> 2], e = i[u >> 2] != (t | 0), t = u, !!e;);
                                                            }
                                                            if ((u | 0) != (C | 0)) continue;
                                                        }
                                                        break;
                                                    }
                                                    u = i[r + 16 >> 2];
                                                }
                                                if ((u | 0) != (C | 0)) {
                                                    for(;;){
                                                        if (e = i[u + 20 >> 2], p[i[i[e >> 2] + 20 >> 2]](n + 96 | 0, e), e = i[n + 96 >> 2], o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]), !e) {
                                                            q1(n + 296 | 0, i[r + 48 >> 2], i[i[u + 20 >> 2] + 36 >> 2]), e = i[i[n + 296 >> 2] + 112 >> 2];
                                                            k: {
                                                                if ((e | 0) == 1752589105) {
                                                                    e = i[r + 48 >> 2], i[n + 240 >> 2] = i[e + 60 >> 2], k = i[e + 64 >> 2], i[n + 244 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, e = i[r + 48 >> 2]), f = i[e + 52 >> 2], k = i[e + 56 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), Rn(n + 96 | 0, f, i[i[u + 20 >> 2] + 36 >> 2], n + 240 | 0, 1752589123), f = i[n + 96 >> 2], e = i[n + 100 >> 2];
                                                                    n: {
                                                                        if (!e || (t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t)) break n;
                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                    }
                                                                    if (!f) {
                                                                        e = D(40), i[n + 96 >> 2] = e, i[n + 100 >> 2] = 35, i[n + 104 >> 2] = -2147483608, f = l[11901] | l[11902] << 8 | (l[11903] << 16 | l[11904] << 24), t = l[11897] | l[11898] << 8 | (l[11899] << 16 | l[11900] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 35 | 0] = 0, f = l[11928] | l[11929] << 8 | (l[11930] << 16 | l[11931] << 24), o[e + 31 | 0] = f, o[e + 32 | 0] = f >>> 8, o[e + 33 | 0] = f >>> 16, o[e + 34 | 0] = f >>> 24, f = l[11925] | l[11926] << 8 | (l[11927] << 16 | l[11928] << 24), t = l[11921] | l[11922] << 8 | (l[11923] << 16 | l[11924] << 24), o[e + 24 | 0] = t, o[e + 25 | 0] = t >>> 8, o[e + 26 | 0] = t >>> 16, o[e + 27 | 0] = t >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[11917] | l[11918] << 8 | (l[11919] << 16 | l[11920] << 24), t = l[11913] | l[11914] << 8 | (l[11915] << 16 | l[11916] << 24), o[e + 16 | 0] = t, o[e + 17 | 0] = t >>> 8, o[e + 18 | 0] = t >>> 16, o[e + 19 | 0] = t >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[11909] | l[11910] << 8 | (l[11911] << 16 | l[11912] << 24), t = l[11905] | l[11906] << 8 | (l[11907] << 16 | l[11908] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 106, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]);
                                                                        n: {
                                                                            if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break n;
                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                        }
                                                                        e = i[n + 244 >> 2];
                                                                        n: {
                                                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break n;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        t = 0;
                                                                        break k;
                                                                    }
                                                                    n: {
                                                                        if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break n;
                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                    }
                                                                    e = i[n + 244 >> 2];
                                                                    n: {
                                                                        if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break n;
                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                    }
                                                                    e = i[i[n + 296 >> 2] + 112 >> 2];
                                                                }
                                                                if (t = 1, (e | 0) != 1987470129) break k;
                                                                e = i[r + 48 >> 2], i[n + 240 >> 2] = i[e + 60 >> 2], k = i[e + 64 >> 2], i[n + 244 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, e = i[r + 48 >> 2]), f = i[e + 52 >> 2], k = i[e + 56 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), Rn(n + 96 | 0, f, i[i[u + 20 >> 2] + 36 >> 2], n + 240 | 0, 1987470147), f = i[n + 96 >> 2], e = i[n + 100 >> 2];
                                                                n: {
                                                                    if (!e || (w = i[e + 4 >> 2], i[e + 4 >> 2] = w - 1, w)) break n;
                                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                }
                                                                if (!f) {
                                                                    e = D(40), i[n + 96 >> 2] = e, i[n + 100 >> 2] = 35, i[n + 104 >> 2] = -2147483608, f = l[11865] | l[11866] << 8 | (l[11867] << 16 | l[11868] << 24), t = l[11861] | l[11862] << 8 | (l[11863] << 16 | l[11864] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 35 | 0] = 0, f = l[11892] | l[11893] << 8 | (l[11894] << 16 | l[11895] << 24), o[e + 31 | 0] = f, o[e + 32 | 0] = f >>> 8, o[e + 33 | 0] = f >>> 16, o[e + 34 | 0] = f >>> 24, f = l[11889] | l[11890] << 8 | (l[11891] << 16 | l[11892] << 24), t = l[11885] | l[11886] << 8 | (l[11887] << 16 | l[11888] << 24), o[e + 24 | 0] = t, o[e + 25 | 0] = t >>> 8, o[e + 26 | 0] = t >>> 16, o[e + 27 | 0] = t >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[11881] | l[11882] << 8 | (l[11883] << 16 | l[11884] << 24), t = l[11877] | l[11878] << 8 | (l[11879] << 16 | l[11880] << 24), o[e + 16 | 0] = t, o[e + 17 | 0] = t >>> 8, o[e + 18 | 0] = t >>> 16, o[e + 19 | 0] = t >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[11873] | l[11874] << 8 | (l[11875] << 16 | l[11876] << 24), t = l[11869] | l[11870] << 8 | (l[11871] << 16 | l[11872] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 141, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]);
                                                                    n: {
                                                                        if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break n;
                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                    }
                                                                    e = i[n + 244 >> 2];
                                                                    n: {
                                                                        if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break n;
                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                    }
                                                                    t = 0;
                                                                    break k;
                                                                }
                                                                n: {
                                                                    if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break n;
                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                }
                                                                if (e = i[n + 244 >> 2], !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break k;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            e = i[n + 300 >> 2];
                                                            k: {
                                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break k;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            if (!t) break f;
                                                        }
                                                        t = i[u + 4 >> 2];
                                                        k: {
                                                            if (t) {
                                                                for(;;)if (e = t, t = i[e >> 2], !t) break k;
                                                            }
                                                            for(; e = i[u + 8 >> 2], k = i[e >> 2] != (u | 0), u = e, !!k;);
                                                        }
                                                        if (u = e, (e | 0) == (C | 0)) break;
                                                    }
                                                    u = i[r + 16 >> 2];
                                                }
                                                k: {
                                                    if ((u | 0) == (C | 0)) break k;
                                                    for(;;){
                                                        e = i[u + 16 >> 2], k = i[u + 20 >> 2], p[i[i[k >> 2] + 20 >> 2]](n + 96 | 0, k), k = i[n + 96 >> 2], o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]);
                                                        n: {
                                                            if (k) break n;
                                                            q1(n + 296 | 0, i[r + 48 >> 2], e), k = i[n + 296 >> 2], v = k ? 32 : 33;
                                                            t: {
                                                                if (!E | !k) break t;
                                                                if (i[k + 112 >> 2] == 1735551332) {
                                                                    Q8(n + 96 | 0, E, e, 1684630887), t = i[n + 96 >> 2];
                                                                    o: {
                                                                        if ((t | 0) == i[n + 100 >> 2]) {
                                                                            v = 33;
                                                                            break o;
                                                                        }
                                                                        v = 33, e = i[C >> 2];
                                                                        s: {
                                                                            if (!e) break s;
                                                                            for(k = i[t >> 2], t = C; f = k >>> 0 > k0[e + 16 >> 2], t = f ? t : e, e = i[(f << 2) + e >> 2], !!e;);
                                                                            if ((t | 0) == (C | 0) | k >>> 0 < k0[t + 16 >> 2]) break s;
                                                                            k = i[t + 20 >> 2], e = i[t + 24 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), t = i[u + 20 >> 2];
                                                                            u: {
                                                                                if (i[t + 200 >> 2] || (f = i[k + 200 >> 2], !f)) break u;
                                                                                i[n + 240 >> 2] = f, f = i[k + 204 >> 2], i[n + 244 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = n + 240 | 0, b3(t, f), B1(f), t = i[u + 20 >> 2];
                                                                            }
                                                                            u: {
                                                                                if (i[t + 192 >> 2] || (f = i[k + 192 >> 2], !f)) break u;
                                                                                i[n + 240 >> 2] = f, k = i[k + 196 >> 2], i[n + 244 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = n + 240 | 0, b3(t, k), B1(k);
                                                                            }
                                                                            if (v = 0, !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break s;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        t = i[n + 96 >> 2];
                                                                    }
                                                                    if (t && (i[n + 100 >> 2] = t, X(t)), v) break t;
                                                                }
                                                                v = 0;
                                                            }
                                                            e = i[n + 300 >> 2];
                                                            t: {
                                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break t;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            if ((v | 0) == 33) break n;
                                                            if (v) break k;
                                                        }
                                                        t = i[u + 4 >> 2];
                                                        n: {
                                                            if (t) {
                                                                for(;;)if (e = t, t = i[e >> 2], !t) break n;
                                                            }
                                                            for(; e = i[u + 8 >> 2], k = i[e >> 2] != (u | 0), u = e, !!k;);
                                                        }
                                                        if (u = e, (e | 0) == (C | 0)) break;
                                                    }
                                                }
                                                v = i[n + 284 >> 2], B = i[n + 288 >> 2];
                                                k: {
                                                    if ((v | 0) == (B | 0)) break k;
                                                    for(;;){
                                                        t = i[v >> 2], e = V6(i[r + 48 >> 2], t), w = n + 296 | 0, f = 0;
                                                        n: {
                                                            t: {
                                                                k = i[r + 48 >> 2], s = i[k + 128 >> 2];
                                                                o: {
                                                                    if (!s) break o;
                                                                    for(k = k + 128 | 0, u = k; G = t >>> 0 > k0[s + 16 >> 2], u = G ? u : s, s = i[(G << 2) + s >> 2], !!s;);
                                                                    if ((k | 0) == (u | 0) | t >>> 0 < k0[u + 16 >> 2]) break o;
                                                                    if (k = i[u + 20 >> 2], f = i[u + 24 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), k) break t;
                                                                }
                                                                o[w | 0] = 0, o[w + 11 | 0] = 0;
                                                                break n;
                                                            }
                                                            if (o[k + 139 | 0] >= 0) {
                                                                u = i[k + 132 >> 2], i[w >> 2] = i[k + 128 >> 2], i[w + 4 >> 2] = u, i[w + 8 >> 2] = i[k + 136 >> 2];
                                                                break n;
                                                            }
                                                            j(w, i[k + 128 >> 2], i[k + 132 >> 2]);
                                                        }
                                                        n: {
                                                            if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break n;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        n: {
                                                            t: {
                                                                if ((e | 0) <= 1785750886) {
                                                                    if ((e | 0) <= 1752589104) {
                                                                        if (u = 35, (e | 0) == 1635135537 | (e | 0) == 1635148593) break n;
                                                                        if ((e | 0) != 1735551332) break t;
                                                                        break n;
                                                                    }
                                                                    if ((e | 0) <= 1768912491) {
                                                                        if (u = 35, (e | 0) == 1752589105) break n;
                                                                        if ((e | 0) != 1768187246) break t;
                                                                        break n;
                                                                    }
                                                                    if (u = 35, (e | 0) == 1768912492) break n;
                                                                    if ((e | 0) != 1781689137) break t;
                                                                    break n;
                                                                }
                                                                o: {
                                                                    if ((e | 0) <= 1919377773) {
                                                                        if (u = 35, (e | 0) == 1785750887) break n;
                                                                        if ((e | 0) == 1835625829) break o;
                                                                        if ((e | 0) != 1836280681) break t;
                                                                        break n;
                                                                    }
                                                                    if ((e | 0) <= 1970168680) {
                                                                        if (u = 35, (e | 0) == 1919377774) break n;
                                                                        if ((e | 0) != 1953066089) break t;
                                                                        break n;
                                                                    }
                                                                    if (u = 35, (e | 0) == 1970168681) break n;
                                                                    if ((e | 0) != 1987470129) break t;
                                                                    break n;
                                                                }
                                                                if (f = o[n + 307 | 0], k = (f | 0) < 0, ((k ? i[n + 300 >> 2] : f) | 0) != 10) break t;
                                                                if (!O2(k ? i[n + 296 >> 2] : n + 296 | 0, 9263, 10)) break n;
                                                            }
                                                            w = n + 240 | 0, f = 0;
                                                            t: {
                                                                o: {
                                                                    k = i[r + 48 >> 2], s = i[k + 128 >> 2];
                                                                    s: {
                                                                        if (!s) break s;
                                                                        for(k = k + 128 | 0, u = k; G = t >>> 0 > k0[s + 16 >> 2], u = G ? u : s, s = i[(G << 2) + s >> 2], !!s;);
                                                                        if ((k | 0) == (u | 0) | t >>> 0 < k0[u + 16 >> 2]) break s;
                                                                        if (k = i[u + 20 >> 2], f = i[u + 24 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), k) break o;
                                                                    }
                                                                    o[w | 0] = 0, o[w + 11 | 0] = 0;
                                                                    break t;
                                                                }
                                                                if (o[k + 163 | 0] >= 0) {
                                                                    u = i[k + 156 >> 2], i[w >> 2] = i[k + 152 >> 2], i[w + 4 >> 2] = u, i[w + 8 >> 2] = i[k + 160 >> 2];
                                                                    break t;
                                                                }
                                                                j(w, i[k + 152 >> 2], i[k + 156 >> 2]);
                                                            }
                                                            t: {
                                                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break t;
                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                            }
                                                            k = D(64), i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, i[k >> 2] = 78460, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = t, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, O4(n + 96 | 0, e), o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), f = i[n + 100 >> 2], i[k + 16 >> 2] = i[n + 96 >> 2], i[k + 20 >> 2] = f, i[k + 24 >> 2] = i[n + 104 >> 2], f = k + 28 | 0, u = o[n + 307 | 0];
                                                            t: {
                                                                if (o[k + 39 | 0] >= 0) {
                                                                    if ((u | 0) >= 0) {
                                                                        u = i[n + 300 >> 2], i[f >> 2] = i[n + 296 >> 2], i[f + 4 >> 2] = u, i[f + 8 >> 2] = i[n + 304 >> 2];
                                                                        break t;
                                                                    }
                                                                    X4(f, i[n + 296 >> 2], i[n + 300 >> 2]);
                                                                    break t;
                                                                }
                                                                h = f, f = (u | 0) < 0, Y4(h, f ? i[n + 296 >> 2] : n + 296 | 0, f ? i[n + 300 >> 2] : u);
                                                            }
                                                            o[k + 51 | 0] < 0 && X(i[k + 40 >> 2]), f = i[n + 244 >> 2], i[k + 40 >> 2] = i[n + 240 >> 2], i[k + 44 >> 2] = f, i[k + 48 >> 2] = i[n + 248 >> 2], o[n + 251 | 0] = 0, o[n + 240 | 0] = 0, ui(n + 96 | 0, i[r + 48 >> 2], t, k + 52 | 0);
                                                            t: {
                                                                if (i[n + 96 >> 2]) {
                                                                    if ((e | 0) != 1835625829 && (u = 35, (e | 0) != 1165519206)) break t;
                                                                    e = i[n + 100 >> 2], i[A >> 2] = i[n + 96 >> 2], i[A + 4 >> 2] = e, i[A + 16 >> 2] = i[n + 112 >> 2], e = i[n + 108 >> 2], i[A + 8 >> 2] = i[n + 104 >> 2], i[A + 12 >> 2] = e, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, u = 1;
                                                                    break t;
                                                                }
                                                                if (E) {
                                                                    Q8(n + 260 | 0, E, t, 1667527523), f = i[n + 260 >> 2], s = i[n + 264 >> 2];
                                                                    o: {
                                                                        if ((f | 0) != (s | 0)) {
                                                                            w = k + 12 | 0;
                                                                            s: {
                                                                                for(;;){
                                                                                    t = i[f >> 2];
                                                                                    u: {
                                                                                        w: {
                                                                                            u = C, e = i[u >> 2];
                                                                                            l: {
                                                                                                if (!e) break l;
                                                                                                for(; G = t >>> 0 > k0[e + 16 >> 2], u = G ? u : e, e = i[(G << 2) + e >> 2], !!e;);
                                                                                                if ((u | 0) == (C | 0)) break l;
                                                                                                if (t >>> 0 >= k0[u + 16 >> 2]) break w;
                                                                                            }
                                                                                            if (ce(i[r + 48 >> 2], t)) break u;
                                                                                            e = D(40), i[n + 32 >> 2] = e, i[n + 36 >> 2] = 39, i[n + 40 >> 2] = -2147483608, f = l[11783] | l[11784] << 8 | (l[11785] << 16 | l[11786] << 24), u = l[11779] | l[11780] << 8 | (l[11781] << 16 | l[11782] << 24), o[e | 0] = u, o[e + 1 | 0] = u >>> 8, o[e + 2 | 0] = u >>> 16, o[e + 3 | 0] = u >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 39 | 0] = 0, f = l[11814] | l[11815] << 8 | (l[11816] << 16 | l[11817] << 24), u = l[11810] | l[11811] << 8 | (l[11812] << 16 | l[11813] << 24), o[e + 31 | 0] = u, o[e + 32 | 0] = u >>> 8, o[e + 33 | 0] = u >>> 16, o[e + 34 | 0] = u >>> 24, o[e + 35 | 0] = f, o[e + 36 | 0] = f >>> 8, o[e + 37 | 0] = f >>> 16, o[e + 38 | 0] = f >>> 24, f = l[11807] | l[11808] << 8 | (l[11809] << 16 | l[11810] << 24), u = l[11803] | l[11804] << 8 | (l[11805] << 16 | l[11806] << 24), o[e + 24 | 0] = u, o[e + 25 | 0] = u >>> 8, o[e + 26 | 0] = u >>> 16, o[e + 27 | 0] = u >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[11799] | l[11800] << 8 | (l[11801] << 16 | l[11802] << 24), u = l[11795] | l[11796] << 8 | (l[11797] << 16 | l[11798] << 24), o[e + 16 | 0] = u, o[e + 17 | 0] = u >>> 8, o[e + 18 | 0] = u >>> 16, o[e + 19 | 0] = u >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[11791] | l[11792] << 8 | (l[11793] << 16 | l[11794] << 24), u = l[11787] | l[11788] << 8 | (l[11789] << 16 | l[11790] << 24), o[e + 8 | 0] = u, o[e + 9 | 0] = u >>> 8, o[e + 10 | 0] = u >>> 16, o[e + 11 | 0] = u >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 2, 2e3, n + 32 | 0), o[n + 43 | 0] < 0 && X(i[n + 32 >> 2]), e = 1;
                                                                                            break s;
                                                                                        }
                                                                                        if (u = i[u + 20 >> 2], i[k + 4 >> 2] = i[k + 4 >> 2] + 1, i[n + 36 >> 2] = k, i[n + 32 >> 2] = w, e = i[u + 184 >> 2], e >>> 0 < k0[u + 188 >> 2]) {
                                                                                            i[e + 4 >> 2] = k, i[e >> 2] = w, i[u + 184 >> 2] = e + 8;
                                                                                            break u;
                                                                                        }
                                                                                        if (t = p2(u + 180 | 0, n + 32 | 0), e = i[n + 36 >> 2], i[u + 184 >> 2] = t, !e || (u = i[e + 4 >> 2], i[e + 4 >> 2] = u - 1, u)) break u;
                                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                    }
                                                                                    if (f = f + 4 | 0, (s | 0) == (f | 0)) break;
                                                                                }
                                                                                e = 0;
                                                                            }
                                                                            f = i[n + 260 >> 2];
                                                                            break o;
                                                                        }
                                                                        e = 0;
                                                                    }
                                                                    if (f && (i[n + 264 >> 2] = f, X(f)), u = 1, e) break t;
                                                                }
                                                                u = 0;
                                                            }
                                                            if (o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]), e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), o[n + 251 | 0] >= 0) break n;
                                                            X(i[n + 240 >> 2]);
                                                        }
                                                        if (o[n + 307 | 0] < 0 && X(i[n + 296 >> 2]), u && (u | 0) != 35) break f;
                                                        if (v = v + 4 | 0, (B | 0) == (v | 0)) break;
                                                    }
                                                    if (G = i[n + 288 >> 2], B = i[n + 284 >> 2], !(!E | (G | 0) == (B | 0))) {
                                                        for(;;){
                                                            t = i[B >> 2], Q8(n + 96 | 0, E, t, 1886545261), f = i[n + 96 >> 2], w = i[n + 100 >> 2];
                                                            n: {
                                                                if ((f | 0) == (w | 0)) {
                                                                    e = 1;
                                                                    break n;
                                                                }
                                                                v = f;
                                                                t: {
                                                                    if (k = i[C >> 2], !k) break t;
                                                                    for(;;){
                                                                        for(u = C, e = k; s = t >>> 0 > k0[e + 16 >> 2], u = s ? u : e, e = i[(s << 2) + e >> 2], !!e;);
                                                                        if ((u | 0) == (C | 0) | t >>> 0 < k0[u + 16 >> 2]) break t;
                                                                        if (e = 1, o[i[u + 20 >> 2] + 65 | 0] = 1, v = v + 4 | 0, (w | 0) == (v | 0)) break;
                                                                    }
                                                                    break n;
                                                                }
                                                                e = D(48), i[n + 296 >> 2] = e, i[n + 300 >> 2] = 42, i[n + 304 >> 2] = -2147483600, k = l[11740] | l[11741] << 8 | (l[11742] << 16 | l[11743] << 24), f = l[11736] | l[11737] << 8 | (l[11738] << 16 | l[11739] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 42 | 0] = 0, k = l[11776] | l[11777] << 8, o[e + 40 | 0] = k, o[e + 41 | 0] = k >>> 8, k = l[11772] | l[11773] << 8 | (l[11774] << 16 | l[11775] << 24), f = l[11768] | l[11769] << 8 | (l[11770] << 16 | l[11771] << 24), o[e + 32 | 0] = f, o[e + 33 | 0] = f >>> 8, o[e + 34 | 0] = f >>> 16, o[e + 35 | 0] = f >>> 24, o[e + 36 | 0] = k, o[e + 37 | 0] = k >>> 8, o[e + 38 | 0] = k >>> 16, o[e + 39 | 0] = k >>> 24, k = l[11764] | l[11765] << 8 | (l[11766] << 16 | l[11767] << 24), f = l[11760] | l[11761] << 8 | (l[11762] << 16 | l[11763] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[11756] | l[11757] << 8 | (l[11758] << 16 | l[11759] << 24), f = l[11752] | l[11753] << 8 | (l[11754] << 16 | l[11755] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[11748] | l[11749] << 8 | (l[11750] << 16 | l[11751] << 24), f = l[11744] | l[11745] << 8 | (l[11746] << 16 | l[11747] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 296 | 0), o[n + 307 | 0] < 0 && X(i[n + 296 >> 2]), e = 0, f = i[n + 96 >> 2];
                                                            }
                                                            if (f && (i[n + 100 >> 2] = f, X(f)), !e) break f;
                                                            if (B = B + 4 | 0, (B | 0) == (G | 0)) break;
                                                        }
                                                        G = i[n + 288 >> 2], B = i[n + 284 >> 2];
                                                    }
                                                    if ((B | 0) == (G | 0)) break k;
                                                    for(V = r + 128 | 0;;){
                                                        h = i[B >> 2];
                                                        n: {
                                                            if ((V6(i[r + 48 >> 2], h) | 0) != 1919377774) break n;
                                                            e = D(36), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 78372, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[n + 28 >> 2] = e, i[n + 24 >> 2] = e + 12, i[e + 12 >> 2] = h, i[n + 248 >> 2] = 0, i[n + 240 >> 2] = 0, i[n + 244 >> 2] = 0, ui(n + 296 | 0, i[r + 48 >> 2], h, n + 240 | 0);
                                                            t: {
                                                                if (i[n + 296 >> 2]) {
                                                                    e = i[n + 300 >> 2], i[A >> 2] = i[n + 296 >> 2], i[A + 4 >> 2] = e, i[A + 16 >> 2] = i[n + 312 >> 2], e = i[n + 308 >> 2], i[A + 8 >> 2] = i[n + 304 >> 2], i[A + 12 >> 2] = e, i[n + 304 >> 2] = 0, i[n + 308 >> 2] = 0, i[n + 312 >> 2] = 0, s = 1;
                                                                    break t;
                                                                }
                                                                u = n + 4 | 0, k = i[n + 24 >> 2], f = m - 16 | 0, m = f, w = n + 240 | 0, e = i[w >> 2], t = i[w + 4 >> 2] - e | 0;
                                                                o: {
                                                                    if (t >>> 0 <= 7) {
                                                                        if (e = D(32), i[f + 4 >> 2] = e, i[f + 8 >> 2] = 25, i[f + 12 >> 2] = -2147483616, k = l[15566] | l[15567] << 8 | (l[15568] << 16 | l[15569] << 24), t = l[15562] | l[15563] << 8 | (l[15564] << 16 | l[15565] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 25 | 0] = 0, o[e + 24 | 0] = l[15586], k = l[15582] | l[15583] << 8 | (l[15584] << 16 | l[15585] << 24), t = l[15578] | l[15579] << 8 | (l[15580] << 16 | l[15581] << 24), o[e + 16 | 0] = t, o[e + 17 | 0] = t >>> 8, o[e + 18 | 0] = t >>> 16, o[e + 19 | 0] = t >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[15574] | l[15575] << 8 | (l[15576] << 16 | l[15577] << 24), t = l[15570] | l[15571] << 8 | (l[15572] << 16 | l[15573] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(u, 2, 136, f + 4 | 0), o[f + 15 | 0] >= 0) break o;
                                                                        X(i[f + 4 >> 2]);
                                                                        break o;
                                                                    }
                                                                    _ = o[e + 1 | 0] & 1;
                                                                    s: {
                                                                        if (_) {
                                                                            if (t >>> 0 <= 11) {
                                                                                if (e = D(24), i[f + 4 >> 2] = e, i[f + 8 >> 2] = 22, i[f + 12 >> 2] = -2147483624, k = l[9992] | l[9993] << 8 | (l[9994] << 16 | l[9995] << 24), t = l[9988] | l[9989] << 8 | (l[9990] << 16 | l[9991] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 22 | 0] = 0, k = l[10006] | l[10007] << 8 | (l[10008] << 16 | l[10009] << 24), t = l[10002] | l[10003] << 8 | (l[10004] << 16 | l[10005] << 24), o[e + 14 | 0] = t, o[e + 15 | 0] = t >>> 8, o[e + 16 | 0] = t >>> 16, o[e + 17 | 0] = t >>> 24, o[e + 18 | 0] = k, o[e + 19 | 0] = k >>> 8, o[e + 20 | 0] = k >>> 16, o[e + 21 | 0] = k >>> 24, k = l[1e4] | l[10001] << 8 | (l[10002] << 16 | l[10003] << 24), t = l[9996] | l[9997] << 8 | (l[9998] << 16 | l[9999] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(u, 2, 136, f + 4 | 0), o[f + 15 | 0] >= 0) break o;
                                                                                X(i[f + 4 >> 2]);
                                                                                break o;
                                                                            }
                                                                            t = l[e + 2 | 0] | l[e + 3 | 0] << 8 | (l[e + 4 | 0] << 16 | l[e + 5 | 0] << 24), i[k + 4 >> 2] = t << 24 | (t & 65280) << 8 | (t >>> 8 & 65280 | t >>> 24), s = l[e + 7 | 0] << 16 | l[e + 6 | 0] << 24 | l[e + 8 | 0] << 8, v = 10, t = 9;
                                                                            break s;
                                                                        }
                                                                        i[k + 4 >> 2] = l[e + 3 | 0] | l[e + 2 | 0] << 8, s = l[e + 4 | 0] << 8, v = 6, t = 5;
                                                                    }
                                                                    if (i[k + 8 >> 2] = l[e + t | 0] | s, s = l[e + v | 0], i[f >> 2] = v | 1, s) for(_ = _ ? 32 : 16, R = k + 12 | 0, v = 0;;){
                                                                        if (e = i[f >> 2], t = i[w >> 2], e >>> 0 >= i[w + 4 >> 2] - t >>> 0) {
                                                                            if (e = D(24), i[f + 4 >> 2] = e, i[f + 8 >> 2] = 22, i[f + 12 >> 2] = -2147483624, k = l[9992] | l[9993] << 8 | (l[9994] << 16 | l[9995] << 24), t = l[9988] | l[9989] << 8 | (l[9990] << 16 | l[9991] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 22 | 0] = 0, k = l[10006] | l[10007] << 8 | (l[10008] << 16 | l[10009] << 24), t = l[10002] | l[10003] << 8 | (l[10004] << 16 | l[10005] << 24), o[e + 14 | 0] = t, o[e + 15 | 0] = t >>> 8, o[e + 16 | 0] = t >>> 16, o[e + 17 | 0] = t >>> 24, o[e + 18 | 0] = k, o[e + 19 | 0] = k >>> 8, o[e + 20 | 0] = k >>> 16, o[e + 21 | 0] = k >>> 24, k = l[1e4] | l[10001] << 8 | (l[10002] << 16 | l[10003] << 24), t = l[9996] | l[9997] << 8 | (l[9998] << 16 | l[9999] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(u, 2, 136, f + 4 | 0), o[f + 15 | 0] >= 0) break o;
                                                                            X(i[f + 4 >> 2]);
                                                                            break o;
                                                                        }
                                                                        t = l[e + t | 0], i[f >> 2] = e + 1;
                                                                        s: {
                                                                            u: {
                                                                                w: switch(t | 0){
                                                                                    case 0:
                                                                                        e = D(24), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 79228, i[e + 12 >> 2] = 78964, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12;
                                                                                        break u;
                                                                                    case 1:
                                                                                        e = D(32), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 79268, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 12 >> 2] = 79008, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12;
                                                                                        break u;
                                                                                    case 2:
                                                                                        e = D(32), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 79308, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 12 >> 2] = 79052, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12;
                                                                                        break u;
                                                                                    case 3:
                                                                                        if (e = D(32), i[e + 16 >> 2] = 1, i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 1, i[e + 8 >> 2] = 0, i[e >> 2] = 79348, i[e + 12 >> 2] = 79096, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12, t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t) break u;
                                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                        break u;
                                                                                    case 4:
                                                                                        e = D(36), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 79388, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 12 >> 2] = 79140, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12;
                                                                                        break u;
                                                                                    case 5:
                                                                                        e = D(44), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e >> 2] = 79428, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 12 >> 2] = 79184, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12;
                                                                                        break u;
                                                                                    case 6:
                                                                                        break w;
                                                                                    default:
                                                                                        break s;
                                                                                }
                                                                                if (e = D(32), i[e + 16 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 1, i[e + 8 >> 2] = 0, i[e >> 2] = 79348, i[e + 12 >> 2] = 79096, i[f + 8 >> 2] = e, i[f + 4 >> 2] = e + 12, t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t) break u;
                                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                            }
                                                                            e = i[f + 4 >> 2], p[i[i[e >> 2] + 12 >> 2]](u, e, w, _, f), F = i[u >> 2];
                                                                            u: {
                                                                                if (F) break u;
                                                                                e = i[k + 16 >> 2];
                                                                                w: {
                                                                                    if (e >>> 0 < k0[k + 20 >> 2]) {
                                                                                        i[e >> 2] = i[f + 4 >> 2], t = i[f + 8 >> 2], i[e + 4 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), e = e + 8 | 0;
                                                                                        break w;
                                                                                    }
                                                                                    e = P2(R, f + 4 | 0);
                                                                                }
                                                                                if (i[k + 16 >> 2] = e, o[u + 19 | 0] >= 0) break u;
                                                                                X(i[u + 8 >> 2]);
                                                                            }
                                                                            e = i[f + 8 >> 2];
                                                                            u: {
                                                                                if (!e || (t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t)) break u;
                                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                            }
                                                                            if (F) break o;
                                                                        }
                                                                        if (v = v + 1 | 0, (s | 0) == (v | 0)) break;
                                                                    }
                                                                    if (e = i[21669], i[u >> 2] = i[21668], i[u + 4 >> 2] = e, e = u + 8 | 0, o[86691] >= 0) {
                                                                        k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                                                        break o;
                                                                    }
                                                                    j(e, i[21670], i[21671]);
                                                                }
                                                                if (m = f + 16 | 0, o[n + 23 | 0] < 0 && X(i[n + 12 >> 2]), E) {
                                                                    pA(n + 260 | 0, E, h), k = i[n + 260 >> 2], R = i[n + 264 >> 2];
                                                                    o: {
                                                                        if ((k | 0) == (R | 0)) {
                                                                            s = 44;
                                                                            break o;
                                                                        }
                                                                        s: {
                                                                            for(;;){
                                                                                if (e = i[k + 16 >> 2], (e | 0) == 1667527523) {
                                                                                    if (i[n + 104 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, t = i[k + 48 >> 2], e = i[k + 44 >> 2], (t | 0) != (e | 0)) {
                                                                                        if (u = t - e | 0, (u | 0) < 0) break i;
                                                                                        if (f = v0(D(u), e, u), (e | 0) != (t | 0)) for(w = f + u | 0, v = f;;){
                                                                                            u: {
                                                                                                e = i[C >> 2];
                                                                                                w: {
                                                                                                    if (!e) break w;
                                                                                                    for(t = i[v >> 2], u = C; s = t >>> 0 > k0[e + 16 >> 2], u = s ? u : e, e = i[(s << 2) + e >> 2], !!e;);
                                                                                                    if ((u | 0) == (C | 0)) break w;
                                                                                                    if (t >>> 0 >= k0[u + 16 >> 2]) break u;
                                                                                                }
                                                                                                e = D(48), i[n + 32 >> 2] = e, i[n + 36 >> 2] = 42, i[n + 40 >> 2] = -2147483600, k = l[11697] | l[11698] << 8 | (l[11699] << 16 | l[11700] << 24), u = l[11693] | l[11694] << 8 | (l[11695] << 16 | l[11696] << 24), o[e | 0] = u, o[e + 1 | 0] = u >>> 8, o[e + 2 | 0] = u >>> 16, o[e + 3 | 0] = u >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 42 | 0] = 0, k = l[11733] | l[11734] << 8, o[e + 40 | 0] = k, o[e + 41 | 0] = k >>> 8, k = l[11729] | l[11730] << 8 | (l[11731] << 16 | l[11732] << 24), u = l[11725] | l[11726] << 8 | (l[11727] << 16 | l[11728] << 24), o[e + 32 | 0] = u, o[e + 33 | 0] = u >>> 8, o[e + 34 | 0] = u >>> 16, o[e + 35 | 0] = u >>> 24, o[e + 36 | 0] = k, o[e + 37 | 0] = k >>> 8, o[e + 38 | 0] = k >>> 16, o[e + 39 | 0] = k >>> 24, k = l[11721] | l[11722] << 8 | (l[11723] << 16 | l[11724] << 24), u = l[11717] | l[11718] << 8 | (l[11719] << 16 | l[11720] << 24), o[e + 24 | 0] = u, o[e + 25 | 0] = u >>> 8, o[e + 26 | 0] = u >>> 16, o[e + 27 | 0] = u >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[11713] | l[11714] << 8 | (l[11715] << 16 | l[11716] << 24), u = l[11709] | l[11710] << 8 | (l[11711] << 16 | l[11712] << 24), o[e + 16 | 0] = u, o[e + 17 | 0] = u >>> 8, o[e + 18 | 0] = u >>> 16, o[e + 19 | 0] = u >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[11705] | l[11706] << 8 | (l[11707] << 16 | l[11708] << 24), u = l[11701] | l[11702] << 8 | (l[11703] << 16 | l[11704] << 24), o[e + 8 | 0] = u, o[e + 9 | 0] = u >>> 8, o[e + 10 | 0] = u >>> 16, o[e + 11 | 0] = u >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(A, 2, 2e3, n + 32 | 0), o[n + 43 | 0] < 0 && X(i[n + 32 >> 2]), X(f), s = 1;
                                                                                                break s;
                                                                                            }
                                                                                            Un(i[u + 20 >> 2], h), e = i[r + 132 >> 2];
                                                                                            u: {
                                                                                                if (e >>> 0 < k0[r + 136 >> 2]) {
                                                                                                    i[e >> 2] = i[n + 24 >> 2], u = i[n + 28 >> 2], i[e + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), e = e + 8 | 0;
                                                                                                    break u;
                                                                                                }
                                                                                                e = P2(V, n + 24 | 0);
                                                                                            }
                                                                                            if (i[r + 132 >> 2] = e, v = v + 4 | 0, (w | 0) == (v | 0)) break;
                                                                                        }
                                                                                        X(f);
                                                                                    }
                                                                                    e = i[k + 16 >> 2];
                                                                                }
                                                                                if ((e | 0) == 1835103083) {
                                                                                    if (f = 0, i[n + 40 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 36 >> 2] = 0, e = 0, u = i[k + 48 >> 2], t = i[k + 44 >> 2], (u | 0) != (t | 0)) {
                                                                                        if (u = u - t | 0, (u | 0) < 0) break r;
                                                                                        e = D(u), i[n + 32 >> 2] = e, w = e + u | 0, i[n + 40 >> 2] = w, v0(e, t, u), i[n + 36 >> 2] = w;
                                                                                    }
                                                                                    _ = 0, u = i[n + 24 >> 2], v = i[u + 16 >> 2], u = i[u + 12 >> 2], t = v - u | 0;
                                                                                    u: {
                                                                                        if ((t | 0) <= 0) {
                                                                                            s = 48;
                                                                                            break u;
                                                                                        }
                                                                                        w: {
                                                                                            for(;;){
                                                                                                if (i[n + 104 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, e = 0, s = 0, (u | 0) != (v | 0)) {
                                                                                                    if ((t | 0) < 0) break i;
                                                                                                    for(s = D(t), i[n + 96 >> 2] = s, i[n + 104 >> 2] = t + s, e = s; i[e >> 2] = i[u >> 2], t = i[u + 4 >> 2], i[e + 4 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), e = e + 8 | 0, u = u + 8 | 0, (v | 0) != (u | 0););
                                                                                                    i[n + 100 >> 2] = e;
                                                                                                }
                                                                                                if (F = f << 3, u = i[F + s >> 2], t = p[i[i[u >> 2] + 8 >> 2]](u) | 0, u = s, (u | 0) != (e | 0)) {
                                                                                                    for(;;){
                                                                                                        u = i[e - 4 >> 2];
                                                                                                        l: {
                                                                                                            if (!u || (w = i[u + 4 >> 2], i[u + 4 >> 2] = w - 1, w)) break l;
                                                                                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                                                        }
                                                                                                        if (e = e - 8 | 0, (s | 0) == (e | 0)) break;
                                                                                                    }
                                                                                                    u = i[n + 96 >> 2];
                                                                                                }
                                                                                                i[n + 100 >> 2] = s, X(u);
                                                                                                l: {
                                                                                                    if ((t | 0) != 4) break l;
                                                                                                    if (w = 0, i[n + 104 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, e = 0, s = 0, u = i[n + 24 >> 2], t = i[u + 16 >> 2], u = i[u + 12 >> 2], (t | 0) != (u | 0)) {
                                                                                                        if (e = t - u | 0, (e | 0) < 0) break i;
                                                                                                        for(s = D(e), i[n + 96 >> 2] = s, i[n + 104 >> 2] = e + s, e = s; i[e >> 2] = i[u >> 2], v = i[u + 4 >> 2], i[e + 4 >> 2] = v, v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), e = e + 8 | 0, u = u + 8 | 0, (t | 0) != (u | 0););
                                                                                                        i[n + 100 >> 2] = e;
                                                                                                    }
                                                                                                    t = 0, u = s + F | 0, v = i[u >> 2];
                                                                                                    h: {
                                                                                                        if (!v) break h;
                                                                                                        if (t = E0(v, 78492, 79164), !t) {
                                                                                                            t = 0;
                                                                                                            break h;
                                                                                                        }
                                                                                                        if (w = i[u + 4 >> 2], !w) {
                                                                                                            w = 0;
                                                                                                            break h;
                                                                                                        }
                                                                                                        i[w + 4 >> 2] = i[w + 4 >> 2] + 1;
                                                                                                    }
                                                                                                    if (u = s, (u | 0) != (e | 0)) {
                                                                                                        for(;;){
                                                                                                            u = i[e - 4 >> 2];
                                                                                                            h: {
                                                                                                                if (!u || (v = i[u + 4 >> 2], i[u + 4 >> 2] = v - 1, v)) break h;
                                                                                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                                                            }
                                                                                                            if (e = e - 8 | 0, (s | 0) == (e | 0)) break;
                                                                                                        }
                                                                                                        u = i[n + 96 >> 2];
                                                                                                    }
                                                                                                    i[n + 100 >> 2] = s, X(u), e = i[n + 32 >> 2];
                                                                                                    h: {
                                                                                                        if (i[n + 36 >> 2] - e >> 2 >>> 0 <= _ >>> 0) {
                                                                                                            e = D(64), i[n + 96 >> 2] = e, i[n + 100 >> 2] = 60, i[n + 104 >> 2] = -2147483584, u = l[12431] | l[12432] << 8 | (l[12433] << 16 | l[12434] << 24), t = l[12427] | l[12428] << 8 | (l[12429] << 16 | l[12430] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = u, o[e + 5 | 0] = u >>> 8, o[e + 6 | 0] = u >>> 16, o[e + 7 | 0] = u >>> 24, o[e + 60 | 0] = 0, u = l[12483] | l[12484] << 8 | (l[12485] << 16 | l[12486] << 24), o[e + 56 | 0] = u, o[e + 57 | 0] = u >>> 8, o[e + 58 | 0] = u >>> 16, o[e + 59 | 0] = u >>> 24, u = l[12479] | l[12480] << 8 | (l[12481] << 16 | l[12482] << 24), t = l[12475] | l[12476] << 8 | (l[12477] << 16 | l[12478] << 24), o[e + 48 | 0] = t, o[e + 49 | 0] = t >>> 8, o[e + 50 | 0] = t >>> 16, o[e + 51 | 0] = t >>> 24, o[e + 52 | 0] = u, o[e + 53 | 0] = u >>> 8, o[e + 54 | 0] = u >>> 16, o[e + 55 | 0] = u >>> 24, u = l[12471] | l[12472] << 8 | (l[12473] << 16 | l[12474] << 24), t = l[12467] | l[12468] << 8 | (l[12469] << 16 | l[12470] << 24), o[e + 40 | 0] = t, o[e + 41 | 0] = t >>> 8, o[e + 42 | 0] = t >>> 16, o[e + 43 | 0] = t >>> 24, o[e + 44 | 0] = u, o[e + 45 | 0] = u >>> 8, o[e + 46 | 0] = u >>> 16, o[e + 47 | 0] = u >>> 24, u = l[12463] | l[12464] << 8 | (l[12465] << 16 | l[12466] << 24), t = l[12459] | l[12460] << 8 | (l[12461] << 16 | l[12462] << 24), o[e + 32 | 0] = t, o[e + 33 | 0] = t >>> 8, o[e + 34 | 0] = t >>> 16, o[e + 35 | 0] = t >>> 24, o[e + 36 | 0] = u, o[e + 37 | 0] = u >>> 8, o[e + 38 | 0] = u >>> 16, o[e + 39 | 0] = u >>> 24, u = l[12455] | l[12456] << 8 | (l[12457] << 16 | l[12458] << 24), t = l[12451] | l[12452] << 8 | (l[12453] << 16 | l[12454] << 24), o[e + 24 | 0] = t, o[e + 25 | 0] = t >>> 8, o[e + 26 | 0] = t >>> 16, o[e + 27 | 0] = t >>> 24, o[e + 28 | 0] = u, o[e + 29 | 0] = u >>> 8, o[e + 30 | 0] = u >>> 16, o[e + 31 | 0] = u >>> 24, u = l[12447] | l[12448] << 8 | (l[12449] << 16 | l[12450] << 24), t = l[12443] | l[12444] << 8 | (l[12445] << 16 | l[12446] << 24), o[e + 16 | 0] = t, o[e + 17 | 0] = t >>> 8, o[e + 18 | 0] = t >>> 16, o[e + 19 | 0] = t >>> 24, o[e + 20 | 0] = u, o[e + 21 | 0] = u >>> 8, o[e + 22 | 0] = u >>> 16, o[e + 23 | 0] = u >>> 24, u = l[12439] | l[12440] << 8 | (l[12441] << 16 | l[12442] << 24), t = l[12435] | l[12436] << 8 | (l[12437] << 16 | l[12438] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = u, o[e + 13 | 0] = u >>> 8, o[e + 14 | 0] = u >>> 16, o[e + 15 | 0] = u >>> 24, i0(A, 2, 0, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), e = 1;
                                                                                                            break h;
                                                                                                        }
                                                                                                        v: {
                                                                                                            v = i[C >> 2];
                                                                                                            _: {
                                                                                                                if (!v) break _;
                                                                                                                for(s = i[e + (_ << 2) >> 2], u = C, e = v; F = s >>> 0 > k0[e + 16 >> 2], u = F ? u : e, e = i[(F << 2) + e >> 2], !!e;);
                                                                                                                if ((u | 0) == (C | 0)) break _;
                                                                                                                if (s >>> 0 >= k0[u + 16 >> 2]) break v;
                                                                                                            }
                                                                                                            e = D(48), i[n + 96 >> 2] = e, i[n + 100 >> 2] = 43, i[n + 104 >> 2] = -2147483600, u = l[11545] | l[11546] << 8 | (l[11547] << 16 | l[11548] << 24), t = l[11541] | l[11542] << 8 | (l[11543] << 16 | l[11544] << 24), o[e | 0] = t, o[e + 1 | 0] = t >>> 8, o[e + 2 | 0] = t >>> 16, o[e + 3 | 0] = t >>> 24, o[e + 4 | 0] = u, o[e + 5 | 0] = u >>> 8, o[e + 6 | 0] = u >>> 16, o[e + 7 | 0] = u >>> 24, o[e + 43 | 0] = 0, u = l[11580] | l[11581] << 8 | (l[11582] << 16 | l[11583] << 24), o[e + 39 | 0] = u, o[e + 40 | 0] = u >>> 8, o[e + 41 | 0] = u >>> 16, o[e + 42 | 0] = u >>> 24, u = l[11577] | l[11578] << 8 | (l[11579] << 16 | l[11580] << 24), t = l[11573] | l[11574] << 8 | (l[11575] << 16 | l[11576] << 24), o[e + 32 | 0] = t, o[e + 33 | 0] = t >>> 8, o[e + 34 | 0] = t >>> 16, o[e + 35 | 0] = t >>> 24, o[e + 36 | 0] = u, o[e + 37 | 0] = u >>> 8, o[e + 38 | 0] = u >>> 16, o[e + 39 | 0] = u >>> 24, u = l[11569] | l[11570] << 8 | (l[11571] << 16 | l[11572] << 24), t = l[11565] | l[11566] << 8 | (l[11567] << 16 | l[11568] << 24), o[e + 24 | 0] = t, o[e + 25 | 0] = t >>> 8, o[e + 26 | 0] = t >>> 16, o[e + 27 | 0] = t >>> 24, o[e + 28 | 0] = u, o[e + 29 | 0] = u >>> 8, o[e + 30 | 0] = u >>> 16, o[e + 31 | 0] = u >>> 24, u = l[11561] | l[11562] << 8 | (l[11563] << 16 | l[11564] << 24), t = l[11557] | l[11558] << 8 | (l[11559] << 16 | l[11560] << 24), o[e + 16 | 0] = t, o[e + 17 | 0] = t >>> 8, o[e + 18 | 0] = t >>> 16, o[e + 19 | 0] = t >>> 24, o[e + 20 | 0] = u, o[e + 21 | 0] = u >>> 8, o[e + 22 | 0] = u >>> 16, o[e + 23 | 0] = u >>> 24, u = l[11553] | l[11554] << 8 | (l[11555] << 16 | l[11556] << 24), t = l[11549] | l[11550] << 8 | (l[11551] << 16 | l[11552] << 24), o[e + 8 | 0] = t, o[e + 9 | 0] = t >>> 8, o[e + 10 | 0] = t >>> 16, o[e + 11 | 0] = t >>> 24, o[e + 12 | 0] = u, o[e + 13 | 0] = u >>> 8, o[e + 14 | 0] = u >>> 16, o[e + 15 | 0] = u >>> 24, i0(A, 2, 0, n + 96 | 0), o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), e = 1;
                                                                                                            break h;
                                                                                                        }
                                                                                                        for(e = C; u = s >>> 0 > k0[v + 16 >> 2], e = u ? e : v, v = i[(u << 2) + v >> 2], !!v;);
                                                                                                        u = i[e + 20 >> 2], p[i[i[u >> 2] + 20 >> 2]](n + 96 | 0, u), o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]), v = i[e + 20 >> 2], i[n + 96 >> 2] = v, u = i[e + 24 >> 2], i[n + 100 >> 2] = u;
                                                                                                        v: {
                                                                                                            if (!u) {
                                                                                                                u = 0;
                                                                                                                break v;
                                                                                                            }
                                                                                                            i[u + 4 >> 2] = i[u + 4 >> 2] + 1;
                                                                                                        }
                                                                                                        if (p[i[i[v >> 2] + 20 >> 2]](A, v), e = 1, i[A >> 2] || (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), i[t + 20 >> 2] = s, i[t + 12 >> 2] || (t2 = t, v2 = oA(v), i[t2 + 12 >> 2] = v2), i[t + 16 >> 2] || (t2 = t, v2 = uA(v), i[t2 + 16 >> 2] = v2), O3(r, n + 96 | 0), _ = _ + 1 | 0, e = 0), !u || (t = i[u + 4 >> 2], i[u + 4 >> 2] = t - 1, t)) break h;
                                                                                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                                                    }
                                                                                                    h: {
                                                                                                        if (!w || (u = i[w + 4 >> 2], i[w + 4 >> 2] = u - 1, u)) break h;
                                                                                                        p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                                                                                    }
                                                                                                    if (!e) break l;
                                                                                                    s = 1, f = 1;
                                                                                                    break w;
                                                                                                }
                                                                                                if (f = f + 1 | 0, e = i[n + 24 >> 2], v = i[e + 16 >> 2], u = i[e + 12 >> 2], t = v - u | 0, !((f | 0) < t >> 3)) break;
                                                                                            }
                                                                                            s = 48, f = 0;
                                                                                        }
                                                                                        e = i[n + 32 >> 2];
                                                                                    }
                                                                                    if (e && (i[n + 36 >> 2] = e, X(e)), f) break s;
                                                                                }
                                                                                if (k = k + 56 | 0, (R | 0) == (k | 0)) break;
                                                                            }
                                                                            s = 44;
                                                                        }
                                                                        k = i[n + 260 >> 2];
                                                                    }
                                                                    if (k) {
                                                                        if (u = k, e = i[n + 264 >> 2], (k | 0) != (e | 0)) {
                                                                            for(; f = i[e - 12 >> 2], f && (i[e - 8 >> 2] = f, X(f)), f = e - 56 | 0, i[f >> 2] = 73428, u = i[e - 36 >> 2], u && (i[e - 32 >> 2] = u, X(u)), e = f, (k | 0) != (e | 0););
                                                                            u = i[n + 260 >> 2];
                                                                        }
                                                                        i[n + 264 >> 2] = k, X(u);
                                                                    }
                                                                    if ((s | 0) != 44) break t;
                                                                }
                                                                s = 0;
                                                            }
                                                            o[n + 315 | 0] < 0 && X(i[n + 304 >> 2]), e = i[n + 240 >> 2], e && (i[n + 244 >> 2] = e, X(e)), e = i[n + 28 >> 2];
                                                            t: {
                                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break t;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            t: switch(s - 42 | 0){
                                                                case 0:
                                                                    break k;
                                                                case 1:
                                                                    break n;
                                                                default:
                                                                    break t;
                                                            }
                                                            if (s) break f;
                                                        }
                                                        if (B = B + 4 | 0, (B | 0) == (G | 0)) break;
                                                    }
                                                }
                                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                    break f;
                                                }
                                                j(A, i[21670], i[21671]);
                                            }
                                            if (!M || (A = i[M + 4 >> 2], i[M + 4 >> 2] = A - 1, A)) break A;
                                            p[i[i[M >> 2] + 8 >> 2]](M), g(M);
                                        }
                                        A = i[n + 284 >> 2], A && (i[n + 288 >> 2] = A, X(A)), m = n + 336 | 0;
                                        return;
                                    }
                                    p0(), z();
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function _7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0;
                            c = m - 16 | 0, m = c;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (f = i[A + 580 >> 2], f) {
                                                e = A + 549 | 0;
                                                break A;
                                            }
                                            if (k = l[A + 548 | 0], !(!(k & 1) & l[A + 549 | 0] != 1 | i[A + 3208 >> 2] != i[A + 3212 >> 2])) {
                                                if (ro(A + 2140 | 0), !r) break r;
                                                i[r >> 2] = i[A + 2192 >> 2];
                                                break r;
                                            }
                                            if (e = A + 549 | 0, o[A + 549 | 0] & 1 | (f | k & 1)) break A;
                                            if (e = 13, !r) break r;
                                            i[r >> 2] = 1;
                                            break r;
                                        }
                                        if (!Y9(A + 2140 | 0, 0)) {
                                            if (e = 9, !r) break r;
                                            i[r >> 2] = 1;
                                            break r;
                                        }
                                        o[c + 15 | 0] = 0, f = i[A + 580 >> 2];
                                        A: {
                                            f: {
                                                if (f) {
                                                    if (f && (k = i[A + 564 >> 2], e = i[A + 576 >> 2], W = i[i[k + (e >>> 8 & 16777212) >> 2] + ((e & 1023) << 2) >> 2], i[A + 580 >> 2] = f - 1, e = e + 1 | 0, i[A + 576 >> 2] = e, e >>> 0 >= 2048 && (X(i[k >> 2]), i[A + 564 >> 2] = i[A + 564 >> 2] + 4, i[A + 576 >> 2] = i[A + 576 >> 2] - 1024), i[A + 584 >> 2] = i[A + 584 >> 2] - i[W + 24 >> 2]), !W) break e;
                                                    S = m - 32 | 0, m = S, B = i[W + 20 >> 2], h = i[W + 24 >> 2], e = S + 8 | 0, i[e + 16 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 4 >> 2] = h, i[e >> 2] = B, k = -64;
                                                    k: {
                                                        if (!h || (i[e >> 2] = B + 1, f = l[B | 0], t = h - 1 | 0, i[e + 4 >> 2] = t, i[e + 8 >> 2] = 0, f = f << 24, i[e + 12 >> 2] = f, !t) || (i[e >> 2] = B + 2, t = l[B + 1 | 0], v = h - 2 | 0, i[e + 4 >> 2] = v, i[e + 8 >> 2] = w, f = t << 16 | f, i[e + 12 >> 2] = f, !v) || (i[e >> 2] = B + 3, t = l[B + 2 | 0], v = h - 3 | 0, i[e + 4 >> 2] = v, f = t << 8 | f, t = f, i[e + 8 >> 2] = w, i[e + 12 >> 2] = f, !v) || (i[e >> 2] = B + 4, f = l[B + 3 | 0], v = h - 4 | 0, i[e + 4 >> 2] = v, i[e + 8 >> 2] = s, f = f | t, i[e + 12 >> 2] = f, !v) || (i[e >> 2] = B + 5, t = l[B + 4 | 0], v = h - 5 | 0, i[e + 4 >> 2] = v, s = f, f = t, t = f >>> 8 | 0, w = f << 24 | w, i[e + 8 >> 2] = w, f = t | s, i[e + 12 >> 2] = f, !v) || (i[e >> 2] = B + 6, t = l[B + 5 | 0], v = h - 6 | 0, i[e + 4 >> 2] = v, w = t << 16 | w, i[e + 8 >> 2] = w, f = t >>> 16 | f, i[e + 12 >> 2] = f, !v) || (i[e >> 2] = B + 7, t = l[B + 6 | 0], v = h - 7 | 0, i[e + 4 >> 2] = v, s = f, f = t, t = f >>> 24 | 0, f = f << 8 | w, i[e + 8 >> 2] = f, t = t | s, i[e + 12 >> 2] = t, !v)) break k;
                                                        i[e >> 2] = B + 8, k = l[B + 7 | 0], i[e + 4 >> 2] = h - 8, i[e + 8 >> 2] = f | k, i[e + 12 >> 2] = t, k = -56;
                                                    }
                                                    i[e + 16 >> 2] = (((h >>> 0 >= 7 ? 7 : h) << 3) + k | 0) - -64, o[S + 7 | 0] = 0, o[S + 5 | 0] = 0, o[S + 6 | 0] = 0, b8(e, 1), L = S, q = l0(e, 6), o[L + 5 | 0] = q, L = S, q = l0(e, 6), o[L + 6 | 0] = q, L = S, q = l0(e, 3) - 1 | 0, o[L + 7 | 0] = q, e = l[S + 5 | 0], o[A + 3204 | 0] = e, o[A + 3206 | 0] = (e & 248) == 16, o[A + 3205 | 0] = (e - 19 & 255) >>> 0 < 2;
                                                    k: {
                                                        if (l[S + 6 | 0]) {
                                                            w4(A + 548 | 0, W);
                                                            break k;
                                                        }
                                                        if (i[A + 1904 >> 2] < l[S + 7 | 0]) {
                                                            w4(A + 548 | 0, W);
                                                            break k;
                                                        }
                                                        if (e >>> 0 <= 31) {
                                                            u = A, A = S + 8 | 0, t = W, B = m - 16 | 0, m = B, f = D(1364), i[f + 792 >> 2] = 0, i[f + 784 >> 2] = 0, i[f + 788 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, P = f + 1340 | 0, e = P, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[f + 1360 >> 2] = 0, i[f + 1352 >> 2] = 0, i[f + 1356 >> 2] = 0, e = i[f + 8 >> 2], i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0;
                                                            n: {
                                                                if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break n;
                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                            }
                                                            o[f + 40 | 0] = 0, i[f + 36 >> 2] = 0, o[f + 20 | 0] = 0, i[f + 16 >> 2] = 0, Q[f + 12 >> 1] = 0, i[f >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, Q[f + 32 >> 1] = 0, Er(f + 42 | 0), i[f + 776 >> 2] = 0, i[f + 780 >> 2] = 0, B0(f + 144 | 0, 0, 237), B0(f + 384 | 0, 0, 358), o[f + 759 | 0] = 0, o[f + 760 | 0] = 0, o[f + 761 | 0] = 0, o[f + 762 | 0] = 0, i[f + 752 >> 2] = 0, i[f + 756 >> 2] = 0, i[f + 744 >> 2] = 0, i[f + 748 >> 2] = 0, i[f + 764 >> 2] = 0, i[f + 768 >> 2] = 0, o[f + 772 | 0] = 0, i[f + 796 >> 2] = 0, i[f + 800 >> 2] = 0, i[f + 804 >> 2] = 0, i[f + 808 >> 2] = 0, i[f + 812 >> 2] = 0, i[f + 816 >> 2] = 0, i[f + 788 >> 2] = i[f + 784 >> 2], Er(f + 820 | 0), B0(f + 920 | 0, 0, 420), o[f + 1348 | 0] = 0, i[f + 1356 >> 2] = i[f + 1352 >> 2], W = A, o[B + 15 | 0] = 0, A = i[f + 8 >> 2], i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0;
                                                            n: {
                                                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break n;
                                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                            }
                                                            o[f + 40 | 0] = 0, i[f + 36 >> 2] = 0, o[f + 20 | 0] = 0, i[f + 16 >> 2] = 0, Q[f + 12 >> 1] = 0, i[f >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, Q[f + 32 >> 1] = 0, k = f + 42 | 0, Er(k), i[f + 776 >> 2] = 0, i[f + 780 >> 2] = 0, v = B0(f + 144 | 0, 0, 237), w = B0(f + 384 | 0, 0, 358), o[f + 759 | 0] = 0, o[f + 760 | 0] = 0, o[f + 761 | 0] = 0, o[f + 762 | 0] = 0, i[f + 752 >> 2] = 0, i[f + 756 >> 2] = 0, i[f + 744 >> 2] = 0, i[f + 748 >> 2] = 0, i[f + 764 >> 2] = 0, i[f + 768 >> 2] = 0, o[f + 772 | 0] = 0, i[f + 796 >> 2] = 0, i[f + 800 >> 2] = 0, i[f + 804 >> 2] = 0, i[f + 808 >> 2] = 0, i[f + 812 >> 2] = 0, i[f + 816 >> 2] = 0, i[f + 788 >> 2] = i[f + 784 >> 2], _ = f + 820 | 0, Er(_), B0(f + 920 | 0, 0, 420), o[f + 1348 | 0] = 0, o[f + 20 | 0] = 0, i[f + 1356 >> 2] = i[f + 1352 >> 2], L = f, q = l0(W, 1), o[L + 12 | 0] = q, l[u + 3206 | 0] && (L = f, q = l0(W, 1), o[L + 13 | 0] = q), A = q0(W), i[f + 16 >> 2] = A;
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        s: {
                                                                            u: {
                                                                                if (!((A | 0) != -99999 & (A | 0) <= 63) || (A = u + (A << 3) | 0, n = i[A + 856 >> 2], !n)) break u;
                                                                                e = i[A + 860 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[f + 4 >> 2] = n, A = i[f + 8 >> 2], i[f + 8 >> 2] = e;
                                                                                w: {
                                                                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break w;
                                                                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                }
                                                                                if (e = i[f + 4 >> 2], n = i[e + 4 >> 2], !l[n | 0]) {
                                                                                    W2(u + 4 | 0, 1010, 0);
                                                                                    break s;
                                                                                }
                                                                                w: {
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                if (!l[f + 12 | 0]) {
                                                                                                    for(A = 0, l[e + 14 | 0] ? e = l0(W, 1) : e = 0, o[f + 20 | 0] = e, s = i[n + 16908 >> 2]; e = A, A = e + 1 | 0, (s | 0) > 1 << e;);
                                                                                                    if (h = l0(W, e), G = l[f + 20 | 0], G) {
                                                                                                        if (!h) {
                                                                                                            o[B + 15 | 0] = 0, W2(u + 4 | 0, 1021, 0), s = 0;
                                                                                                            break n;
                                                                                                        }
                                                                                                        if (s = 16, A = i[u + 2220 >> 2], !A) break n;
                                                                                                        i[f >> 2] = i[A >> 2], e = i[A + 4 >> 2], s = i[A + 8 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), i[f + 4 >> 2] = e, e = i[f + 8 >> 2], i[f + 8 >> 2] = s;
                                                                                                        _: {
                                                                                                            if (!e || (s = i[e + 4 >> 2], i[e + 4 >> 2] = s - 1, s)) break _;
                                                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                                        }
                                                                                                        v0(f + 12 | 0, A + 12 | 0, 772);
                                                                                                        _: {
                                                                                                            if ((A | 0) != (f | 0)) {
                                                                                                                e = i[A + 784 >> 2], s = i[A + 788 >> 2], a8(f + 784 | 0, e, s, s - e >> 2), v0(f + 796 | 0, A + 796 | 0, 544), W6(f + 1340 | 0, A + 1340 | 0), o[f + 1348 | 0] = l[A + 1348 | 0], e = i[A + 1352 >> 2], A = i[A + 1356 >> 2], a8(f + 1352 | 0, e, A, A - e >> 2);
                                                                                                                break _;
                                                                                                            }
                                                                                                            v0(f + 796 | 0, A + 796 | 0, 544), W6(f + 1340 | 0, A + 1340 | 0), o[f + 1348 | 0] = l[A + 1348 | 0];
                                                                                                        }
                                                                                                        o[f + 20 | 0] = 1, o[f + 12 | 0] = 0;
                                                                                                    }
                                                                                                    if (i[f + 24 >> 2] = h, (h | 0) < 0) break w;
                                                                                                    if ((h | 0) < i[n + 16908 >> 2]) break v;
                                                                                                    break w;
                                                                                                }
                                                                                                if (i[f + 24 >> 2] = 0, o[f + 20 | 0] = 0, i[n + 16908 >> 2] <= 0) break w;
                                                                                                e = i[f + 4 >> 2];
                                                                                                break h;
                                                                                            }
                                                                                            if (e = i[f + 4 >> 2], G) break l;
                                                                                        }
                                                                                        if (A = 0, o[e + 8240 | 0] > 0) for(; b8(W, 1), A = A + 1 | 0, (A | 0) < o[i[f + 4 >> 2] + 8240 | 0];);
                                                                                        if (A = q0(W), i[f + 28 >> 2] = A, !((A | 0) != -99999 & (A | 0) <= 2)) {
                                                                                            W2(u + 4 | 0, 1007, 0);
                                                                                            break s;
                                                                                        }
                                                                                        l[i[f + 4 >> 2] + 43 | 0] ? A = l0(W, 1) : A = 1, o[f + 32 | 0] = A, l[n + 480 | 0] == 1 && (L = f, q = l0(W, 2), o[L + 33 | 0] = q), h = 0, o[f + 40 | 0] = 0, i[f + 36 >> 2] = 0;
                                                                                        h: {
                                                                                            v: {
                                                                                                _: {
                                                                                                    B: {
                                                                                                        m: {
                                                                                                            if ((l[u + 3204 | 0] - 19 & 255) >>> 0 >= 2) {
                                                                                                                L = f, q = l0(W, i[n + 520 >> 2]), i[L + 36 >> 2] = q, A = l0(W, 1), o[f + 40 | 0] = A;
                                                                                                                Z: {
                                                                                                                    if (!(A & 255)) {
                                                                                                                        $7(u + 4 | 0, n, W, k, (i[n + 8820 >> 2] - i[n + 8816 >> 2] | 0) / 100 | 0, n + 8816 | 0, 1), i[f + 816 >> 2] = (i[n + 8820 >> 2] - i[n + 8816 >> 2] | 0) / 100;
                                                                                                                        break Z;
                                                                                                                    }
                                                                                                                    for(k = i[n + 8816 >> 2], h = (i[n + 8820 >> 2] - k | 0) / 100 | 0, e = 0; A = e, e = e + 1 | 0, 1 << A < (h | 0););
                                                                                                                    W: {
                                                                                                                        if (!A) {
                                                                                                                            A = 0;
                                                                                                                            break W;
                                                                                                                        }
                                                                                                                        A = l0(W, A), k = i[n + 8816 >> 2], h = (i[n + 8820 >> 2] - k | 0) / 100 | 0;
                                                                                                                    }
                                                                                                                    if (i[v >> 2] = A, (A | 0) >= (h | 0)) break B;
                                                                                                                    i[f + 816 >> 2] = A, k = Z(A, 100) + k | 0;
                                                                                                                }
                                                                                                                v0(_, k, 100);
                                                                                                                Z: {
                                                                                                                    W: {
                                                                                                                        if (l[n + 8828 | 0]) {
                                                                                                                            X: {
                                                                                                                                if (i[n + 8832 >> 2] > 0) {
                                                                                                                                    if (A = q0(W), i[f + 148 >> 2] = A, s = 8, (A | 0) != -99999) break X;
                                                                                                                                    break n;
                                                                                                                                }
                                                                                                                                i[f + 148 >> 2] = 0;
                                                                                                                            }
                                                                                                                            if (e = q0(W), i[f + 152 >> 2] = e, s = 8, (e | 0) == -99999) break n;
                                                                                                                            if (A = i[f + 148 >> 2], e = e + A | 0, i[(n + (o[n + 2 | 0] << 2) | 0) + 524 >> 2] < (l[f + 917 | 0] + (e + l[f + 916 | 0] | 0) | 0)) break _;
                                                                                                                            if ((e | 0) <= 0) break W;
                                                                                                                            for(v = u + 2352 | 0, _ = f + 268 | 0, y = f + 252 | 0, C = n + 8964 | 0, V = n + 8836 | 0, M = f + 156 | 0, E = u + 2288 | 0, G = u + 2224 | 0, R = f + 236 | 0, F = f + 172 | 0, h = 0, k = 0;;){
                                                                                                                                X: {
                                                                                                                                    if ((A | 0) > (k | 0)) {
                                                                                                                                        for(T = i[n + 8832 >> 2], A = 0; e = A, A = e + 1 | 0, (T | 0) > 1 << e;);
                                                                                                                                        if (A = k + M | 0, e = l0(W, e), o[A | 0] = e, e = e & 255, (e | 0) < i[n + 8832 >> 2]) {
                                                                                                                                            i[G + (k << 2) >> 2] = i[V + (e << 2) >> 2], A = C + l[A | 0] | 0;
                                                                                                                                            break X;
                                                                                                                                        }
                                                                                                                                        W2(u + 4 | 0, 1023, 0);
                                                                                                                                        break s;
                                                                                                                                    }
                                                                                                                                    e = k << 2, T = e + F | 0, L = T, q = l0(W, i[n + 520 >> 2]), i[L >> 2] = q, A = k + R | 0, L = A, q = l0(W, 1), o[L | 0] = q, i[e + G >> 2] = i[T >> 2];
                                                                                                                                }
                                                                                                                                e = k << 2, T = o[A | 0], i[e + E >> 2] = T, A = l0(W, 1), o[k + y | 0] = A;
                                                                                                                                X: {
                                                                                                                                    if (A & 255) {
                                                                                                                                        if (A = q0(W), i[e + _ >> 2] = A, (A | 0) != -99999) break X;
                                                                                                                                        break n;
                                                                                                                                    }
                                                                                                                                    A = 0, i[e + _ >> 2] = 0;
                                                                                                                                }
                                                                                                                                if (h = ((T | 0) != 0) + h | 0, i[e + v >> 2] = !k | i[f + 148 >> 2] == (k | 0) ? A : i[(e + v | 0) - 4 >> 2] + A | 0, k = k + 1 | 0, A = i[f + 148 >> 2], !((k | 0) < (A + i[f + 152 >> 2] | 0))) break;
                                                                                                                            }
                                                                                                                            break Z;
                                                                                                                        }
                                                                                                                        i[f + 148 >> 2] = 0, i[f + 152 >> 2] = 0;
                                                                                                                    }
                                                                                                                    h = 0;
                                                                                                                }
                                                                                                                if (l[n + 8996 | 0]) {
                                                                                                                    L = f, q = l0(W, 1), o[L + 332 | 0] = q;
                                                                                                                    break m;
                                                                                                                }
                                                                                                                o[f + 332 | 0] = 0;
                                                                                                                break m;
                                                                                                            }
                                                                                                            i[f + 148 >> 2] = 0, i[f + 152 >> 2] = 0;
                                                                                                        }
                                                                                                        m: {
                                                                                                            if (l[n + 8799 | 0]) {
                                                                                                                if (L = f, q = l0(W, 1), o[L + 333 | 0] = q, A = 0, !i[n + 16848 >> 2]) break m;
                                                                                                                A = l0(W, 1);
                                                                                                                break m;
                                                                                                            }
                                                                                                            o[f + 333 | 0] = 0, A = 0;
                                                                                                        }
                                                                                                        if (i[f + 336 >> 2] = 0, i[f + 340 >> 2] = 0, o[f + 334 | 0] = A, k0[f + 28 >> 2] > 1) break h;
                                                                                                        A = l0(W, 1), o[f + 335 | 0] = A;
                                                                                                        m: {
                                                                                                            if (A & 255) {
                                                                                                                if (A = q0(W), i[f + 336 >> 2] = A, (A | 0) == -99999) break o;
                                                                                                                if (A = A + 1 | 0, i[f + 336 >> 2] = A, i[f + 28 >> 2]) {
                                                                                                                    e = i[f + 340 >> 2];
                                                                                                                    break m;
                                                                                                                }
                                                                                                                if (A = q0(W), i[f + 340 >> 2] = A, (A | 0) == -99999) break o;
                                                                                                                e = A + 1 | 0, i[f + 340 >> 2] = e, A = i[f + 336 >> 2];
                                                                                                                break m;
                                                                                                            }
                                                                                                            e = i[f + 4 >> 2], A = o[e + 17 | 0], i[f + 336 >> 2] = A, e = o[e + 18 | 0], i[f + 340 >> 2] = e;
                                                                                                        }
                                                                                                        if (s = 8, (A | 0) > 16 | (e | 0) > 16) break n;
                                                                                                        k = l[f + 919 | 0] + h | 0, i[f + 920 >> 2] = k;
                                                                                                        m: {
                                                                                                            Z: {
                                                                                                                if (!(!l[i[f + 4 >> 2] + 8233 | 0] | (k | 0) < 2)) {
                                                                                                                    for(e = 0; A = e, e = e + 1 | 0, (k | 0) > 1 << A;);
                                                                                                                    if (e = l0(W, 1), o[f + 344 | 0] = e, !(!(e & 255) | i[f + 336 >> 2] <= 0)) for(k = f + 346 | 0, e = 0; L = e + k | 0, q = l0(W, A), o[L | 0] = q, e = e + 1 | 0, (e | 0) < i[f + 336 >> 2];);
                                                                                                                    if (!i[f + 28 >> 2]) {
                                                                                                                        if (e = l0(W, 1), o[f + 345 | 0] = e, !(e & 255) | i[f + 340 >> 2] <= 0) break Z;
                                                                                                                        for(k = f + 362 | 0, e = 0; L = e + k | 0, q = l0(W, A), o[L | 0] = q, e = e + 1 | 0, (e | 0) < i[f + 340 >> 2];);
                                                                                                                        break Z;
                                                                                                                    }
                                                                                                                    o[f + 345 | 0] = 0;
                                                                                                                    break m;
                                                                                                                }
                                                                                                                Q[f + 344 >> 1] = 0;
                                                                                                            }
                                                                                                            if (i[f + 28 >> 2]) break m;
                                                                                                            L = f, q = l0(W, 1), o[L + 378 | 0] = q;
                                                                                                        }
                                                                                                        if (l[i[f + 4 >> 2] + 16 | 0] ? A = l0(W, 1) : A = 0, o[f + 379 | 0] = A, !l[f + 332 | 0]) break v;
                                                                                                        A = 1, i[f + 28 >> 2] || (A = l0(W, 1)), o[f + 380 | 0] = A, e = A & 255;
                                                                                                        m: {
                                                                                                            if (!(i[f + 340 >> 2] < 2 | e) || i[f + 336 >> 2] > 1 && e) {
                                                                                                                if (e = q0(W), i[w >> 2] = e, (e | 0) != -99999) {
                                                                                                                    A = l[f + 380 | 0];
                                                                                                                    break m;
                                                                                                                }
                                                                                                                break o;
                                                                                                            }
                                                                                                            e = 0, i[w >> 2] = 0;
                                                                                                        }
                                                                                                        m: {
                                                                                                            if (A & 255) {
                                                                                                                if (i[f + 336 >> 2] <= (e | 0)) break m;
                                                                                                                break v;
                                                                                                            }
                                                                                                            if (i[f + 340 >> 2] > (e | 0)) break v;
                                                                                                        }
                                                                                                        break t;
                                                                                                    }
                                                                                                    W2(u + 4 | 0, 1015, 0), s = 8;
                                                                                                    break n;
                                                                                                }
                                                                                                W2(u + 4 | 0, 1018, 0);
                                                                                                break s;
                                                                                            }
                                                                                            v: {
                                                                                                if (A = i[f + 4 >> 2], e = i[f + 28 >> 2], !(!(e | !l[A + 42 | 0]) || (e | 0) == 1 && l[A + 41 | 0])) break v;
                                                                                                _: {
                                                                                                    B: {
                                                                                                        if (A = i[(u + (i[f + 16 >> 2] << 3) | 0) + 856 >> 2], A) {
                                                                                                            if (e = i[(u + (o[A + 13 | 0] << 3) | 0) + 728 >> 2], !e) break B;
                                                                                                            A = q0(W), o[f + 388 | 0] = A, k = 0;
                                                                                                            m: {
                                                                                                                if (A >>> 0 > 7) break m;
                                                                                                                if (i[e + 476 >> 2]) {
                                                                                                                    if (A = m1(W) + l[f + 388 | 0] | 0, A >>> 0 > 7) break m;
                                                                                                                    o[f + 389 | 0] = A;
                                                                                                                }
                                                                                                                s = f + 678 | 0, v = f + 550 | 0, M = f + 518 | 0, _ = f + 454 | 0, G = f + 422 | 0, y = f + 390 | 0, A = 0, w = i[f + 336 >> 2];
                                                                                                                Z: {
                                                                                                                    if ((w | 0) <= 0) break Z;
                                                                                                                    for(; L = A + y | 0, q = l0(W, 1), o[L | 0] = q, A = A + 1 | 0, (w | 0) != (A | 0););
                                                                                                                    if (!(!i[e + 476 >> 2] | (w | 0) <= 0)) for(A = 0; L = A + G | 0, q = l0(W, 1), o[L | 0] = q, A = A + 1 | 0, (w | 0) != (A | 0););
                                                                                                                    if ((w | 0) <= 0) break Z;
                                                                                                                    for(A = 0;;){
                                                                                                                        W: {
                                                                                                                            if (l[A + y | 0]) {
                                                                                                                                if (k = 0, h = m1(W), h - 128 >>> 0 < 4294967040) break _;
                                                                                                                                if (Q[_ + (A << 1) >> 1] = h + (1 << l[f + 388 | 0]), h = m1(W), C = i[e + 16996 >> 2], (h | 0) < (0 - C | 0)) break m;
                                                                                                                                if ((h | 0) < (C | 0)) break W;
                                                                                                                                break m;
                                                                                                                            }
                                                                                                                            Q[_ + (A << 1) >> 1] = 1 << l[f + 388 | 0], h = 0;
                                                                                                                        }
                                                                                                                        o[A + M | 0] = h, r0 = s + (A << 1) | 0;
                                                                                                                        W: {
                                                                                                                            X: {
                                                                                                                                if (l[A + G | 0]) {
                                                                                                                                    if (k = m1(W), k - 128 >>> 0 >= 4294967040) break X;
                                                                                                                                    k = 0;
                                                                                                                                    break _;
                                                                                                                                }
                                                                                                                                k = v + (A << 2) | 0, h = 1 << l[f + 389 | 0], Q[k >> 1] = h, o[s + (A << 1) | 0] = 0, Q[k + 2 >> 1] = h, k = 0;
                                                                                                                                break W;
                                                                                                                            }
                                                                                                                            if (C = v + (A << 2) | 0, Q[C >> 1] = k + (1 << l[f + 389 | 0]), k = 0, V = m1(W), h = i[e + 17e3 >> 2], R = h << 2, (V | 0) < (0 - R | 0) | (V | 0) >= (R | 0) || (R = 0 - h | 0, V = (h + V | 0) - (Z(h, Q[C >> 1]) >> l[f + 389 | 0]) | 0, o[s + (A << 1) | 0] = (V | 0) < (R | 0) ? R : (h | 0) > (V | 0) ? V : h - 1 | 0, h = m1(W), h - 128 >>> 0 < 4294967040) || (Q[C + 2 >> 1] = h + (1 << l[f + 389 | 0]), V = m1(W), h = i[e + 17e3 >> 2], R = h << 2, (V | 0) < (0 - R | 0) | (V | 0) >= (R | 0))) break m;
                                                                                                                            R = 0 - h | 0, k = (h + V | 0) - (Z(h, Q[C + 2 >> 1]) >> l[f + 389 | 0]) | 0, k = (k | 0) < (R | 0) ? R : (k | 0) < (h | 0) ? k : h + 255 | 0;
                                                                                                                        }
                                                                                                                        if (o[r0 + 1 | 0] = k, A = A + 1 | 0, (w | 0) == (A | 0)) break;
                                                                                                                    }
                                                                                                                }
                                                                                                                if (k = 1, i[f + 28 >> 2] || (w = i[f + 340 >> 2], (w | 0) <= 0)) break m;
                                                                                                                for(A = 0; L = A + y | 0, q = l0(W, 1), o[L + 16 | 0] = q, A = A + 1 | 0, (w | 0) != (A | 0););
                                                                                                                if (!(!i[e + 476 >> 2] | (w | 0) <= 0)) for(A = 0; L = A + G | 0, q = l0(W, 1), o[L + 16 | 0] = q, A = A + 1 | 0, (w | 0) != (A | 0););
                                                                                                                if ((w | 0) <= 0) break m;
                                                                                                                for(A = 0;;){
                                                                                                                    Z: {
                                                                                                                        if (l[(A + y | 0) + 16 | 0]) {
                                                                                                                            if (k = 0, h = m1(W), h - 128 >>> 0 < 4294967040) break _;
                                                                                                                            if (Q[(_ + (A << 1) | 0) + 32 >> 1] = h + (1 << l[f + 388 | 0]), h = m1(W), C = i[e + 16996 >> 2], (h | 0) < (0 - C | 0)) break m;
                                                                                                                            if ((h | 0) < (C | 0)) break Z;
                                                                                                                            break m;
                                                                                                                        }
                                                                                                                        Q[(_ + (A << 1) | 0) + 32 >> 1] = 1 << l[f + 388 | 0], h = 0;
                                                                                                                    }
                                                                                                                    o[(A + M | 0) + 16 | 0] = h;
                                                                                                                    Z: {
                                                                                                                        if (l[(A + G | 0) + 16 | 0]) {
                                                                                                                            if (k = 0, h = m1(W), h - 128 >>> 0 < 4294967040) break _;
                                                                                                                            if (V = v + (A << 2) | 0, E = V - -64 | 0, Q[E >> 1] = h + (1 << l[f + 389 | 0]), C = m1(W), h = i[e + 17e3 >> 2], R = h << 2, (C | 0) < (0 - R | 0) | (C | 0) >= (R | 0) || (R = 0 - h | 0, C = (h + C | 0) - (Z(h, Q[E >> 1]) >> l[f + 389 | 0]) | 0, o[(s + (A << 1) | 0) + 32 | 0] = (C | 0) < (R | 0) ? R : (h | 0) > (C | 0) ? C : h - 1 | 0, h = m1(W), h - 128 >>> 0 < 4294967040) || (Q[V + 66 >> 1] = h + (1 << l[f + 389 | 0]), C = m1(W), h = i[e + 17e3 >> 2], E = h << 2, (C | 0) < (0 - E | 0) | (C | 0) >= (E | 0))) break m;
                                                                                                                            E = 0 - h | 0, k = (h + C | 0) - (Z(h, Q[V + 66 >> 1]) >> l[f + 389 | 0]) | 0, h = (k | 0) < (E | 0) ? E : (k | 0) < (h | 0) ? k : h + 255 | 0;
                                                                                                                            break Z;
                                                                                                                        }
                                                                                                                        k = v + (A << 2) | 0, h = 1 << l[f + 389 | 0], Q[k - -64 >> 1] = h, o[(s + (A << 1) | 0) + 32 | 0] = 0, Q[k + 66 >> 1] = h, h = 0;
                                                                                                                    }
                                                                                                                    if (k = 1, o[(s + (A << 1) | 0) + 33 | 0] = h, A = A + 1 | 0, (w | 0) == (A | 0)) break;
                                                                                                                }
                                                                                                            }
                                                                                                            break _;
                                                                                                        }
                                                                                                        y0(4222, 15050, 152, 11091), z();
                                                                                                    }
                                                                                                    y0(4218, 15050, 154, 11091), z();
                                                                                                }
                                                                                                if (k) break v;
                                                                                                break t;
                                                                                            }
                                                                                            if (A = q0(W), i[f + 744 >> 2] = A, (A | 0) == -99999) break o;
                                                                                            i[f + 812 >> 2] = 5 - A;
                                                                                        }
                                                                                        if (A = m1(W), i[f + 748 >> 2] = A, (A | 0) == -99999) break o;
                                                                                        A = i[f + 4 >> 2];
                                                                                        h: {
                                                                                            if (l[A + 40 | 0]) {
                                                                                                if (A = m1(W), i[f + 752 >> 2] = A, (A | 0) == -99999) break o;
                                                                                                if (A = m1(W), i[f + 756 >> 2] = A, (A | 0) != -99999) {
                                                                                                    A = i[f + 4 >> 2];
                                                                                                    break h;
                                                                                                }
                                                                                                break o;
                                                                                            }
                                                                                            i[f + 752 >> 2] = 0, i[f + 756 >> 2] = 0;
                                                                                        }
                                                                                        l[A + 8248 | 0] == 1 && (L = f, q = l0(W, 1), o[L + 760 | 0] = q, A = i[f + 4 >> 2]);
                                                                                        h: {
                                                                                            v: {
                                                                                                if (!l[A + 60 | 0]) {
                                                                                                    o[f + 761 | 0] = 0, i[f + 764 >> 2] = i[A + 64 >> 2], i[f + 768 >> 2] = i[A + 68 >> 2];
                                                                                                    break v;
                                                                                                }
                                                                                                if (e = l0(W, 1), o[f + 761 | 0] = e, A = i[f + 4 >> 2], i[f + 764 >> 2] = i[A + 64 >> 2], i[f + 768 >> 2] = i[A + 68 >> 2], !(e & 255)) break v;
                                                                                                if (A = l0(W, 1), o[f + 762 | 0] = A, A & 255) break h;
                                                                                                if (A = m1(W), i[f + 764 >> 2] = A, (A | 0) == -99999 || (i[f + 764 >> 2] = A << 1, A = m1(W), i[f + 768 >> 2] = A, (A | 0) == -99999)) break o;
                                                                                                i[f + 768 >> 2] = A << 1;
                                                                                                break h;
                                                                                            }
                                                                                            o[f + 762 | 0] = l[A + 61 | 0];
                                                                                        }
                                                                                        if (e = i[f + 4 >> 2], A = l[e + 58 | 0], !(!A | !(!l[f + 762 | 0] || l[f + 333 | 0] | l[f + 334 | 0]))) {
                                                                                            L = f, q = l0(W, 1), o[L + 772 | 0] = q, e = i[f + 4 >> 2];
                                                                                            break l;
                                                                                        }
                                                                                        o[f + 772 | 0] = A;
                                                                                    }
                                                                                    l: {
                                                                                        if (l[e + 46 | 0] | l[e + 45 | 0]) {
                                                                                            if (A = q0(W), i[f + 776 >> 2] = A, (A | 0) == -99999 || (e = i[f + 4 >> 2], !(!l[e + 45 | 0] | i[n + 16900 >> 2] > (A + (i[f + 24 >> 2] / i[n + 16892 >> 2] | 0) | 0)) | !(!l[e + 46 | 0] | (A | 0) <= (Z(i[e + 52 >> 2], i[e + 48 >> 2]) | 0)))) break o;
                                                                                            e = f + 784 | 0, n = i[e >> 2], k = i[e + 4 >> 2] - n >> 2;
                                                                                            h: {
                                                                                                if (k >>> 0 < A >>> 0) {
                                                                                                    d4(e, A - k | 0);
                                                                                                    break h;
                                                                                                }
                                                                                                A >>> 0 < k >>> 0 && (i[e + 4 >> 2] = n + (A << 2));
                                                                                            }
                                                                                            if (i[f + 776 >> 2] <= 0) break l;
                                                                                            if (A = q0(W), i[f + 780 >> 2] = A, (A | 0) == -99999) break o;
                                                                                            if (e = A + 1 | 0, i[f + 780 >> 2] = e, s = 8, (A | 0) > 31) break n;
                                                                                            if (i[f + 776 >> 2] <= 0 || (A = 1, e = l0(W, e), i[i[f + 784 >> 2] >> 2] = e + 1, i[f + 776 >> 2] < 2)) break l;
                                                                                            for(; e = l0(W, i[f + 780 >> 2]), n = i[f + 784 >> 2] + (A << 2) | 0, i[n >> 2] = (e + i[n - 4 >> 2] | 0) + 1, A = A + 1 | 0, (A | 0) < i[f + 776 >> 2];);
                                                                                            break l;
                                                                                        }
                                                                                        i[f + 776 >> 2] = 0;
                                                                                    }
                                                                                    l: {
                                                                                        if (!l[i[f + 4 >> 2] + 8241 | 0]) break l;
                                                                                        if (e = q0(W), i[f + 796 >> 2] = e, (e | 0) == -99999 | (e | 0) > 1e3) break o;
                                                                                        if (A = 0, (e | 0) <= 0) break l;
                                                                                        for(; l0(W, 8), A = A + 1 | 0, (A | 0) < i[f + 796 >> 2];);
                                                                                    }
                                                                                    i[f + 800 >> 2] = i[f + 748 >> 2] + i[i[f + 4 >> 2] + 20 >> 2], A = 0;
                                                                                    l: {
                                                                                        h: {
                                                                                            v: switch(i[f + 28 >> 2]){
                                                                                                case 1:
                                                                                                    A = o[f + 379 | 0] + 1 | 0;
                                                                                                    break h;
                                                                                                case 2:
                                                                                                    break h;
                                                                                                case 0:
                                                                                                    break v;
                                                                                                default:
                                                                                                    break l;
                                                                                            }
                                                                                            A = 2 - o[f + 379 | 0] | 0;
                                                                                        }
                                                                                        i[f + 804 >> 2] = A;
                                                                                    }
                                                                                    i[f + 812 >> 2] = 5 - i[f + 744 >> 2], o[B + 15 | 0] = 1, s = 0;
                                                                                    break n;
                                                                                }
                                                                                W2(u + 4 | 0, 1020, 0), s = 8;
                                                                                break n;
                                                                            }
                                                                            W2(u + 4 | 0, 1009, 0), s = 0;
                                                                            break n;
                                                                        }
                                                                        o[B + 15 | 0] = 0, s = 0;
                                                                        break n;
                                                                    }
                                                                    W2(u + 4 | 0, 1007, 0), s = 8;
                                                                    break n;
                                                                }
                                                                W2(u + 4 | 0, 8, 0), s = 8;
                                                            }
                                                            i[B + 8 >> 2] = s;
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        if (!l[B + 15 | 0]) {
                                                                            A = i[u + 2216 >> 2], A && (o[A + 312 | 0] = 2), w4(u + 548 | 0, t), A = i[f + 1352 >> 2], A && (i[f + 1356 >> 2] = A, X(A)), C8(P), A = i[f + 784 >> 2], A && (i[f + 788 >> 2] = A, X(A)), A = i[f + 8 >> 2];
                                                                            s: {
                                                                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break s;
                                                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                            }
                                                                            X(f), n = i[B + 8 >> 2];
                                                                            break o;
                                                                        }
                                                                        if (n = i[u + 528 >> 2], (n | 0) >= 0) s: {
                                                                            A = m - 864 | 0, m = A, e = 55188;
                                                                            u: {
                                                                                w: {
                                                                                    l: {
                                                                                        h: switch(n - 1 | 0){
                                                                                            case 1:
                                                                                                e = 55184;
                                                                                                break;
                                                                                            case 0:
                                                                                                break h;
                                                                                            default:
                                                                                                break l;
                                                                                        }
                                                                                        if (e = i[e >> 2], e0(e, 34548, 0), n = i[(u + (i[f + 16 >> 2] << 3) | 0) + 856 >> 2], !n) {
                                                                                            e0(e, 25835, 0);
                                                                                            break l;
                                                                                        }
                                                                                        if (!l[n | 0]) break w;
                                                                                        if (s = i[(u + (o[n + 13 | 0] << 3) | 0) + 728 >> 2], !s) {
                                                                                            e0(e, 25811, 0);
                                                                                            break l;
                                                                                        }
                                                                                        if (!l[s | 0]) break u;
                                                                                        i[A + 848 >> 2] = o[f + 12 | 0], e0(e, 31049, A + 848 | 0), (l[u + 3204 | 0] & 248) == 16 && (i[A + 832 >> 2] = o[f + 13 | 0], e0(e, 31687, A + 832 | 0)), i[A + 816 >> 2] = i[f + 16 >> 2], e0(e, 32409, A + 816 | 0), l[f + 12 | 0] || (i[A + 800 >> 2] = o[f + 20 | 0], e0(e, 31644, A + 800 | 0), i[A + 784 >> 2] = i[f + 24 >> 2], e0(e, 33185, A + 784 | 0)), k = i[f + 28 >> 2], i[A + 768 >> 2] = k ? (k | 0) == 1 ? 80 : 73 : 66, e0(e, 33893, A + 768 | 0), l[n + 43 | 0] && (i[A + 752 >> 2] = o[f + 32 | 0], e0(e, 33633, A + 752 | 0)), l[s + 480 | 0] == 1 && (i[A + 736 >> 2] = o[f + 33 | 0], e0(e, 33676, A + 736 | 0)), i[A + 720 >> 2] = i[f + 36 >> 2], e0(e, 32917, A + 720 | 0);
                                                                                        h: {
                                                                                            if ((l[u + 3204 | 0] - 19 & 255) >>> 0 < 2) break h;
                                                                                            i[A + 704 >> 2] = o[f + 40 | 0], e0(e, 30768, A + 704 | 0), k = i[s + 8820 >> 2] - i[s + 8816 >> 2] | 0;
                                                                                            v: {
                                                                                                _: {
                                                                                                    if (!l[f + 40 | 0]) {
                                                                                                        i[A + 672 >> 2] = (k | 0) / 100, e0(e, 24915, A + 672 | 0), k = f + 42 | 0;
                                                                                                        break _;
                                                                                                    }
                                                                                                    if ((k | 0) < 101) break v;
                                                                                                    i[A + 688 >> 2] = i[f + 144 >> 2], e0(e, 32140, A + 688 | 0), k = i[s + 8816 >> 2] + Z(i[f + 144 >> 2], 100) | 0;
                                                                                                }
                                                                                                mn(k, e);
                                                                                            }
                                                                                            if (l[s + 8828 | 0] && (i[s + 8832 >> 2] > 0 && (i[A + 656 >> 2] = i[f + 148 >> 2], e0(e, 33810, A + 656 | 0)), i[A + 640 >> 2] = i[f + 152 >> 2], e0(e, 33719, A + 640 | 0)), !l[s + 8996 | 0]) break h;
                                                                                            i[A + 624 >> 2] = o[f + 332 | 0], e0(e, 28353, A + 624 | 0);
                                                                                        }
                                                                                        if (l[s + 8799 | 0] && (i[A + 608 >> 2] = o[f + 333 | 0], e0(e, 32806, A + 608 | 0), i[A + 592 >> 2] = o[f + 334 | 0], e0(e, 32371, A + 592 | 0)), k0[f + 28 >> 2] <= 1) {
                                                                                            i[A + 576 >> 2] = o[f + 335 | 0], e0(e, 28060, A + 576 | 0), k = l[f + 335 | 0], i[A + 560 >> 2] = i[f + 336 >> 2], i[A + 564 >> 2] = k ? 34896 : 20353, e0(e, 25379, A + 560 | 0), i[f + 28 >> 2] || (k = l[f + 335 | 0], i[A + 544 >> 2] = i[f + 340 >> 2], i[A + 548 >> 2] = k ? 34896 : 20353, e0(e, 25339, A + 544 | 0));
                                                                                            h: {
                                                                                                if (!l[n + 8233 | 0] | i[f + 920 >> 2] < 2) break h;
                                                                                                if (i[A + 528 >> 2] = o[f + 344 | 0], e0(e, 28978, A + 528 | 0), !(!l[f + 344 | 0] | i[f + 336 >> 2] <= 0)) for(h = f + 346 | 0, k = 0; i[A + 516 >> 2] = l[k + h | 0], i[A + 512 >> 2] = k, e0(e, 27043, A + 512 | 0), k = k + 1 | 0, (k | 0) < i[f + 336 >> 2];);
                                                                                                if (i[A + 496 >> 2] = o[f + 345 | 0], e0(e, 28938, A + 496 | 0), !l[f + 345 | 0] | i[f + 340 >> 2] <= 0) break h;
                                                                                                for(h = f + 362 | 0, k = 0; i[A + 484 >> 2] = l[k + h | 0], i[A + 480 >> 2] = k, e0(e, 27043, A + 480 | 0), k = k + 1 | 0, (k | 0) < i[f + 340 >> 2];);
                                                                                            }
                                                                                            i[f + 28 >> 2] || (i[A + 464 >> 2] = o[f + 378 | 0], e0(e, 33118, A + 464 | 0)), i[A + 448 >> 2] = o[f + 379 | 0], e0(e, 33261, A + 448 | 0), l[f + 332 | 0] && (i[A + 432 >> 2] = o[f + 380 | 0], e0(e, 31464, A + 432 | 0), i[A + 416 >> 2] = i[f + 384 >> 2], e0(e, 32607, A + 416 | 0)), k = i[f + 28 >> 2];
                                                                                            h: {
                                                                                                if (!(!(k | !l[n + 42 | 0]) || (k | 0) == 1 && l[n + 41 | 0])) break h;
                                                                                                if (i[A + 400 >> 2] = l[f + 388 | 0], e0(e, 31607, A + 400 | 0), i[s + 476 >> 2] && (i[A + 384 >> 2] = l[f + 389 | 0], e0(e, 31935, A + 384 | 0)), s = f + 678 | 0, h = f + 550 | 0, w = f + 518 | 0, v = f + 454 | 0, _ = i[f + 336 >> 2], (_ | 0) > 0) for(k = 0; G = k << 1, i[A + 376 >> 2] = Q[G + v >> 1], i[A + 372 >> 2] = k, i[A + 368 >> 2] = 0, e0(e, 32844, A + 368 | 0), i[A + 360 >> 2] = o[k + w | 0], i[A + 356 >> 2] = k, i[A + 352 >> 2] = 0, e0(e, 32570, A + 352 | 0), y = h + (k << 2) | 0, i[A + 348 >> 2] = Q[y >> 1], i[A + 344 >> 2] = 0, i[A + 340 >> 2] = k, i[A + 336 >> 2] = 0, e0(e, 31501, A + 336 | 0), G = s + G | 0, i[A + 332 >> 2] = o[G | 0], i[A + 328 >> 2] = 0, i[A + 324 >> 2] = k, i[A + 320 >> 2] = 0, e0(e, 31539, A + 320 | 0), i[A + 316 >> 2] = Q[y + 2 >> 1], i[A + 312 >> 2] = 1, i[A + 308 >> 2] = k, i[A + 304 >> 2] = 0, e0(e, 31501, A + 304 | 0), i[A + 300 >> 2] = o[G + 1 | 0], i[A + 296 >> 2] = 1, i[A + 292 >> 2] = k, i[A + 288 >> 2] = 0, e0(e, 31539, A + 288 | 0), k = k + 1 | 0, (_ | 0) != (k | 0););
                                                                                                if (i[f + 28 >> 2] || (_ = i[f + 340 >> 2], (_ | 0) <= 0)) break h;
                                                                                                for(k = 0; G = k << 1, i[A + 280 >> 2] = Q[(G + v | 0) + 32 >> 1], i[A + 276 >> 2] = k, i[A + 272 >> 2] = 1, e0(e, 32844, A + 272 | 0), i[A + 264 >> 2] = o[(k + w | 0) + 16 | 0], i[A + 260 >> 2] = k, i[A + 256 >> 2] = 1, e0(e, 32570, A + 256 | 0), y = h + (k << 2) | 0, i[A + 252 >> 2] = Q[y - -64 >> 1], i[A + 248 >> 2] = 0, i[A + 244 >> 2] = k, i[A + 240 >> 2] = 1, e0(e, 31501, A + 240 | 0), G = s + G | 0, i[A + 236 >> 2] = o[G + 32 | 0], i[A + 232 >> 2] = 0, i[A + 228 >> 2] = k, i[A + 224 >> 2] = 1, e0(e, 31539, A + 224 | 0), i[A + 220 >> 2] = Q[y + 66 >> 1], i[A + 216 >> 2] = 1, i[A + 212 >> 2] = k, i[A + 208 >> 2] = 1, e0(e, 31501, A + 208 | 0), i[A + 204 >> 2] = o[G + 33 | 0], i[A + 200 >> 2] = 1, i[A + 196 >> 2] = k, i[A + 192 >> 2] = 1, e0(e, 31539, A + 192 | 0), k = k + 1 | 0, (_ | 0) != (k | 0););
                                                                                            }
                                                                                            i[A + 176 >> 2] = i[f + 744 >> 2], e0(e, 29327, A + 176 | 0);
                                                                                        }
                                                                                        if (i[A + 160 >> 2] = i[f + 748 >> 2], e0(e, 31835, A + 160 | 0), l[n + 40 | 0] && (i[A + 144 >> 2] = i[f + 752 >> 2], e0(e, 30225, A + 144 | 0), i[A + 128 >> 2] = i[f + 756 >> 2], e0(e, 30196, A + 128 | 0)), l[n + 60 | 0] && (i[A + 112 >> 2] = o[f + 761 | 0], e0(e, 28022, A + 112 | 0)), k = l[f + 761 | 0], i[A + 96 >> 2] = o[f + 762 | 0], i[A + 100 >> 2] = k ? 20319 : 20187, e0(e, 25292, A + 96 | 0), l[f + 762 | 0] | !l[f + 761 | 0] || (i[A + 80 >> 2] = i[f + 764 >> 2], e0(e, 29164, A + 80 | 0), i[A + 64 >> 2] = i[f + 768 >> 2], e0(e, 29779, A - -64 | 0)), !l[n + 58 | 0] | !(!l[f + 762 | 0] || l[f + 333 | 0] | l[f + 334 | 0]) || (i[A + 48 >> 2] = o[f + 772 | 0], e0(e, 28302, A + 48 | 0)), !(l[n + 46 | 0] | l[n + 45 | 0]) || (i[A + 32 >> 2] = i[f + 776 >> 2], e0(e, 29841, A + 32 | 0), i[f + 776 >> 2] <= 0) || (i[A + 16 >> 2] = i[f + 780 >> 2], e0(e, 33378, A + 16 | 0), i[f + 776 >> 2] <= 0)) break l;
                                                                                        for(k = 0; i[A + 4 >> 2] = i[i[f + 784 >> 2] + (k << 2) >> 2], i[A >> 2] = k, e0(e, 28876, A), k = k + 1 | 0, (k | 0) < i[f + 776 >> 2];);
                                                                                    }
                                                                                    m = A + 864 | 0;
                                                                                    break s;
                                                                                }
                                                                                y0(14606, 15050, 1287, 6192), z();
                                                                            }
                                                                            y0(14592, 15050, 1294, 6192), z();
                                                                        }
                                                                        s = i[t + 8 >> 2], V = i[t + 12 >> 2], M = i[t + 16 >> 2], v = m - 80 | 0, m = v, i[B + 8 >> 2] = 0, o[u + 3220 | 0] = 0;
                                                                        s: {
                                                                            u: {
                                                                                e = i[f + 16 >> 2], n = u + (e << 3) | 0, A = i[n + 856 >> 2];
                                                                                w: {
                                                                                    if (!(l[A | 0] && A)) {
                                                                                        if (i[v >> 2] = e, e = m - 16 | 0, m = e, l[104229] | i[26056] < -9999 || (A = i[13797], n = l[25859] == 42, n || E1(24958, 5, 1, A), i[e + 12 >> 2] = v, Se(A, n + 25859 | 0, v, 1295, 1296), R8(A)), m = e + 16 | 0, A = i[i[u + 2216 >> 2] + 112 >> 2], e = i[A + 84 >> 2], (e | 0) == 20) {
                                                                                            i[A + 80 >> 2] = 1001;
                                                                                            break w;
                                                                                        }
                                                                                        i[A + 84 >> 2] = e + 1, i[(A + (e << 2) | 0) + 4 >> 2] = 1009;
                                                                                        break w;
                                                                                    }
                                                                                    e = i[n + 860 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[u + 1384 >> 2] = A, A = i[u + 1388 >> 2], i[u + 1388 >> 2] = e;
                                                                                    l: {
                                                                                        if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                    }
                                                                                    A = u + (o[i[u + 1384 >> 2] + 13 | 0] << 3) | 0, n = i[A + 728 >> 2], e = i[A + 732 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[u + 1376 >> 2] = n, A = i[u + 1380 >> 2], i[u + 1380 >> 2] = e;
                                                                                    l: {
                                                                                        if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                    }
                                                                                    A = u + (o[i[u + 1376 >> 2] + 1 | 0] << 3) | 0, n = i[A + 600 >> 2], e = i[A + 604 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[u + 1368 >> 2] = n, A = i[u + 1372 >> 2], i[u + 1372 >> 2] = e;
                                                                                    l: {
                                                                                        if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                    }
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                _: {
                                                                                                    if (A = i[u + 1376 >> 2], !A) {
                                                                                                        if (A = i[u + 1368 >> 2], A) break _;
                                                                                                        if (A = 6, l[u + 2108 | 0] != 6) break h;
                                                                                                        break l;
                                                                                                    }
                                                                                                    if (k = o[A + 2 | 0], A = k - 1 | 0, (A | 0) != o[u + 2108 | 0]) break v;
                                                                                                    break l;
                                                                                                }
                                                                                                if (k = i[A + 8 >> 2], o[u + 2108 | 0] == (k - 1 | 0)) break l;
                                                                                                A = k - 1 | 0;
                                                                                            }
                                                                                            if ((k | 0) <= 0) break l;
                                                                                        }
                                                                                        for(E = u + 2112 | 0, _ = u + 1908 | 0, G = A + 1 | 0;;){
                                                                                            e = Z(A, 100), w = (e + 100 | 0) / (G | 0) | 0, n = (e | 0) / (G | 0) | 0;
                                                                                            h: {
                                                                                                if ((w | 0) < (n | 0)) {
                                                                                                    e = A;
                                                                                                    break h;
                                                                                                }
                                                                                                h = i[u + 1888 >> 2];
                                                                                                v: {
                                                                                                    if (n + w & 1) {
                                                                                                        e = A, k = n;
                                                                                                        break v;
                                                                                                    }
                                                                                                    e = _ + (n << 1) | 0, o[e + 1 | 0] = (A | 0) > (h | 0) ? 100 : 0, k = e, e = (A | 0) < (h | 0) ? A : h, o[k | 0] = e, k = n + 1 | 0;
                                                                                                }
                                                                                                if ((n | 0) == (w | 0)) break h;
                                                                                                for(y = w - n | 0, A = e; C = _ + (k << 1) | 0, e = (A | 0) < (h | 0) ? A : h, o[C | 0] = e, o[C + 1 | 0] = (A | 0) > (h | 0) ? 100 : (Z(k - n | 0, 100) | 0) / (y | 0) | 0, C = k + 1 | 0, A = _ + (C << 1) | 0, o[A + 1 | 0] = (Z(C - n | 0, 100) | 0) / (y | 0), o[A | 0] = e, k = k + 2 | 0, A = e, (w | 0) != (C | 0););
                                                                                            }
                                                                                            if (i[E + (e << 2) >> 2] = w, A = e - 1 | 0, !((e | 0) > 0)) break;
                                                                                        }
                                                                                    }
                                                                                    if (A = u + (i[u + 1892 >> 2] << 1) | 0, e = o[A + 1908 | 0], i[u + 1896 >> 2] = e, i[u + 1900 >> 2] = o[A + 1909 | 0], i[u + 1904 >> 2] = e, l[f + 12 | 0]) {
                                                                                        if (i[u + 2196 >> 2] = i[f + 36 >> 2], e = l[u + 533 | 0], A = i[u + 1376 >> 2], n = l[A + 8799 | 0], i[v + 72 >> 2] = A, A = i[u + 1380 >> 2], i[v + 76 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = i[v + 76 >> 2], i[v + 40 >> 2] = i[v + 72 >> 2], i[v + 44 >> 2] = A, A = Q5(u + 2140 | 0, v + 40 | 0, u, s, V, M, (e | !n) & 1), (A | 0) < 0) {
                                                                                            i[B + 8 >> 2] = 0 - A, A = 0;
                                                                                            break s;
                                                                                        }
                                                                                        e = 0, n = i[u + 2148 >> 2], A >>> 0 < i[u + 2152 >> 2] - n >> 2 >>> 0 && (e = i[n + (A << 2) >> 2]), i[u + 2216 >> 2] = e, o[e + 316 | 0] = l[S + 7 | 0], A = l[S + 5 | 0] | l[S + 6 | 0] << 8, o[e + 314 | 0] = A, o[e + 315 | 0] = A >>> 8, A = i[u + 2216 >> 2], i[v + 64 >> 2] = i[u + 1368 >> 2], e = i[u + 1372 >> 2], i[v + 68 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[v + 56 >> 2] = i[u + 1376 >> 2], e = i[u + 1380 >> 2], i[v + 60 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[v + 48 >> 2] = i[u + 1384 >> 2], e = i[u + 1388 >> 2], i[v + 52 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[v + 68 >> 2], i[v + 32 >> 2] = i[v + 64 >> 2], i[v + 36 >> 2] = e, e = i[v + 60 >> 2], i[v + 24 >> 2] = i[v + 56 >> 2], i[v + 28 >> 2] = e, e = i[v + 52 >> 2], i[v + 16 >> 2] = i[v + 48 >> 2], i[v + 20 >> 2] = e, e = i[v + 32 >> 2], n = i[v + 36 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[A + 116 >> 2] = e, e = i[A + 120 >> 2], i[A + 120 >> 2] = n;
                                                                                        l: {
                                                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break l;
                                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                        }
                                                                                        e = i[v + 24 >> 2], n = i[v + 28 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[A + 124 >> 2] = e, e = i[A + 128 >> 2], i[A + 128 >> 2] = n;
                                                                                        l: {
                                                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break l;
                                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                        }
                                                                                        e = i[v + 16 >> 2], n = i[v + 20 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[A + 132 >> 2] = e, e = i[A + 136 >> 2], i[A + 136 >> 2] = n;
                                                                                        l: {
                                                                                            if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break l;
                                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                        }
                                                                                        A = i[v + 20 >> 2];
                                                                                        l: {
                                                                                            if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                        }
                                                                                        A = i[v + 28 >> 2];
                                                                                        l: {
                                                                                            if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                        }
                                                                                        A = i[v + 36 >> 2];
                                                                                        l: {
                                                                                            if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break l;
                                                                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                                        }
                                                                                        A = i[u + 2216 >> 2], i[A + 112 >> 2] = u, k = 0, h = 0, e = i[A + 160 >> 2], e && B0(e, 0, Z(i[A + 164 >> 2], 3)), e = i[A + 140 >> 2], e && B0(e, 0, Z(i[A + 144 >> 2], 24)), e = i[A + 260 >> 2], e && B0(e, 0, i[A + 264 >> 2]), n = i[A + 144 >> 2];
                                                                                        l: {
                                                                                            if ((n | 0) <= 0) break l;
                                                                                            if (e = i[A + 320 >> 2], A = 0, n >>> 0 >= 8) for(s = n & 2147483640; i[e + Z(A, 76) >> 2] = 0, i[e + Z(A | 1, 76) >> 2] = 0, i[e + Z(A | 2, 76) >> 2] = 0, i[e + Z(A | 3, 76) >> 2] = 0, i[e + Z(A | 4, 76) >> 2] = 0, i[e + Z(A | 5, 76) >> 2] = 0, i[e + Z(A | 6, 76) >> 2] = 0, i[e + Z(A | 7, 76) >> 2] = 0, A = A + 8 | 0, h = h + 8 | 0, (s | 0) != (h | 0););
                                                                                            if (n = n & 7, !n) break l;
                                                                                            for(; i[e + Z(A, 76) >> 2] = 0, A = A + 1 | 0, k = k + 1 | 0, (n | 0) != (k | 0););
                                                                                        }
                                                                                        A = l[u + 3204 | 0];
                                                                                        l: {
                                                                                            if ((A & 248) != 16) break l;
                                                                                            h: {
                                                                                                if (!(l[u + 2200 | 0] | ((A | 0) == 18 | (A & 254) == 16 | (A - 19 & 255) >>> 0 < 2)) && l[u + 2203 | 0] != 1) break h;
                                                                                                o[u + 2203 | 0] = 0, o[u + 2201 | 0] = 1;
                                                                                                break l;
                                                                                            }
                                                                                            o[u + 2201 | 0] = 0, o[u + 2202 | 0] = 0;
                                                                                        }
                                                                                        l: {
                                                                                            if (!((l[u + 3204 | 0] & 254) != 8 | l[u + 2201 | 0] != 1)) {
                                                                                                o[i[u + 2216 >> 2] + 104 | 0] = 0;
                                                                                                break l;
                                                                                            }
                                                                                            o[i[u + 2216 >> 2] + 104 | 0] = l[f + 32 | 0] != 0;
                                                                                        }
                                                                                        n = 0;
                                                                                        l: {
                                                                                            if (!((l[u + 3204 | 0] & 248) != 16 | l[u + 2201 | 0] != 1)) {
                                                                                                o[u + 3220 | 0] = 1, i[u + 2204 >> 2] = 0, A = i[f + 36 >> 2];
                                                                                                break l;
                                                                                            }
                                                                                            A = i[f + 36 >> 2], n = i[u + 2208 >> 2], e = i[i[u + 1376 >> 2] + 16868 >> 2];
                                                                                            h: {
                                                                                                if (!((A | 0) >= (n | 0) | (n - A | 0) < ((e | 0) / 2 | 0))) {
                                                                                                    s = e + i[u + 2212 >> 2] | 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if (s = i[u + 2212 >> 2] - e | 0, !((A | 0) <= (n | 0) | (A - n | 0) <= ((e | 0) / 2 | 0))) break h;
                                                                                                s = i[u + 2212 >> 2];
                                                                                            }
                                                                                            n = s, i[u + 2204 >> 2] = n;
                                                                                        }
                                                                                        e = i[u + 2216 >> 2], i[e + 92 >> 2] = A, i[e + 96 >> 2] = A + n;
                                                                                        l: {
                                                                                            if (l[e + 316 | 0] || (A = l[u + 3204 | 0], !(A & 241)) || (A = A & 254, (A | 0) == 8 | (A | 0) == 6)) break l;
                                                                                            i[u + 2208 >> 2] = i[f + 36 >> 2], i[u + 2212 >> 2] = i[u + 2204 >> 2];
                                                                                        }
                                                                                        if (l[f + 12 | 0]) {
                                                                                            i[i[u + 2216 >> 2] + 100 >> 2] = 1, n = 0, k = 0, s = 0, G = 0, w = m - 32 | 0, m = w, i[w + 28 >> 2] = 0, i[w + 20 >> 2] = 0, i[w + 24 >> 2] = 0, A = i[u + 2216 >> 2], y = i[A >> 2];
                                                                                            l: {
                                                                                                if ((l[u + 3204 | 0] & 248) != 16 | l[u + 2201 | 0] != 1 || (h = i[u + 2148 >> 2], _ = i[u + 2152 >> 2], (h | 0) == (_ | 0))) break l;
                                                                                                for(M = i[A + 96 >> 2];;){
                                                                                                    C = i[(s << 2) + h >> 2];
                                                                                                    h: {
                                                                                                        if (!i[C + 100 >> 2] | (M | 0) <= i[C + 96 >> 2] || (V = i[C >> 2], V >>> 0 >= k0[C + 108 >> 2])) break h;
                                                                                                        v: {
                                                                                                            if (k >>> 0 < G >>> 0) {
                                                                                                                i[k >> 2] = V, k = k + 4 | 0;
                                                                                                                break v;
                                                                                                            }
                                                                                                            if (e = k - n >> 2, A = e + 1 | 0, A >>> 0 >= 1073741824) break t;
                                                                                                            if (G = G - n | 0, E = G >> 1, A = G >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < E >>> 0 ? E : A, A) {
                                                                                                                if (A >>> 0 >= 1073741824) break i;
                                                                                                                G = D(A << 2);
                                                                                                            } else G = 0;
                                                                                                            if (e = G + (e << 2) | 0, i[e >> 2] = V, G = G + (A << 2) | 0, A = e, (k | 0) != (n | 0)) for(; A = A - 4 | 0, k = k - 4 | 0, i[A >> 2] = i[k >> 2], (k | 0) != (n | 0););
                                                                                                            k = e + 4 | 0, i[w + 28 >> 2] = G, i[w + 20 >> 2] = A, n && (X(n), _ = i[u + 2152 >> 2], h = i[u + 2148 >> 2]), n = A;
                                                                                                        }
                                                                                                        i[w + 24 >> 2] = k, i[C + 108 >> 2] = i[C >> 2];
                                                                                                    }
                                                                                                    if (s = s + 1 | 0, !(s >>> 0 < _ - h >> 2 >>> 0)) break;
                                                                                                }
                                                                                            }
                                                                                            l: {
                                                                                                if ((l[u + 3204 | 0] - 19 & 255) >>> 0 < 2) {
                                                                                                    i[u + 2544 >> 2] = 0, i[u + 2548 >> 2] = 0, i[u + 2560 >> 2] = 0, A = u + 2552 | 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                                                                                    break l;
                                                                                                }
                                                                                                if (s = 0, k = 0, n = 0, h = l[f + 916 | 0], h) for(_ = f + 820 | 0, G = u + 2692 | 0, C = u + 2564 | 0, V = f + 884 | 0, M = i[u + 2216 >> 2], A = 0; e = l[A + V | 0], i[(e ? C + (n << 2) | 0 : G + (k << 2) | 0) >> 2] = i[M + 96 >> 2] + Q[_ + (A << 1) >> 1], n = ((e | 0) != 0) + n | 0, k = !e + k | 0, A = A + 1 | 0, (h | 0) != (A | 0););
                                                                                                if (i[u + 2544 >> 2] = n, n = l[f + 917 | 0], n) for(h = u + 2692 | 0, _ = u + 2628 | 0, G = f + 852 | 0, C = f + 900 | 0, V = i[u + 2216 >> 2], A = 0; e = l[A + C | 0], i[(e ? _ + (s << 2) | 0 : h + (k << 2) | 0) >> 2] = i[V + 96 >> 2] + Q[G + (A << 1) >> 1], s = ((e | 0) != 0) + s | 0, k = !e + k | 0, A = A + 1 | 0, (n | 0) != (A | 0););
                                                                                                i[u + 2552 >> 2] = k, i[u + 2548 >> 2] = s;
                                                                                                h: {
                                                                                                    if ((i[f + 152 >> 2] + i[f + 148 >> 2] | 0) <= 0) {
                                                                                                        n = 0, h = 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    for(_ = u + 2480 | 0, G = u + 2820 | 0, C = u + 2416 | 0, V = u + 2756 | 0, M = u + 2288 | 0, E = u + 2352 | 0, R = f + 252 | 0, F = u + 2224 | 0, T = i[u + 1376 >> 2], $ = i[u + 2216 >> 2], k = 0, h = 0, n = 0;;){
                                                                                                        e = k << 2, A = i[e + F >> 2], s = k + R | 0, l[s | 0] && (A = i[$ + 96 >> 2] + A - (i[f + 36 >> 2] + Z(i[T + 16868 >> 2], i[e + E >> 2])) | 0);
                                                                                                        v: {
                                                                                                            if (i[e + M >> 2]) {
                                                                                                                e = h << 2, i[e + V >> 2] = A, i[e + C >> 2] = o[s | 0], h = h + 1 | 0;
                                                                                                                break v;
                                                                                                            }
                                                                                                            e = n << 2, i[e + G >> 2] = A, i[e + _ >> 2] = o[s | 0], n = n + 1 | 0;
                                                                                                        }
                                                                                                        if (k = k + 1 | 0, !((k | 0) < (i[f + 152 >> 2] + i[f + 148 >> 2] | 0))) break;
                                                                                                    }
                                                                                                }
                                                                                                i[u + 2560 >> 2] = n, i[u + 2556 >> 2] = h;
                                                                                            }
                                                                                            if (A = i[u + 2148 >> 2], e = i[u + 2152 >> 2], i[w + 16 >> 2] = 0, i[w + 8 >> 2] = 0, i[w + 12 >> 2] = 0, (A | 0) != (e | 0)) {
                                                                                                if (A = e - A >> 2, (A | 0) < 0) break t;
                                                                                                e = D(A), i[w + 8 >> 2] = e, n = A + e | 0, i[w + 16 >> 2] = n, B0(e, 0, A), i[w + 12 >> 2] = n;
                                                                                            }
                                                                                            e = u + 2140 | 0;
                                                                                            l: {
                                                                                                h: {
                                                                                                    if (n = i[u + 2556 >> 2], (n | 0) <= 0) break h;
                                                                                                    for(_ = u + 3076 | 0, G = u + 2756 | 0, C = u + 2416 | 0, s = 0;;){
                                                                                                        A = s << 2, h = A + G | 0, n = i[h >> 2], V = A + _ | 0;
                                                                                                        v: {
                                                                                                            if (!i[A + C >> 2]) {
                                                                                                                k = cn(e, n, y);
                                                                                                                break v;
                                                                                                            }
                                                                                                            k = mi(e, n, y, 1);
                                                                                                        }
                                                                                                        i[V >> 2] = k;
                                                                                                        v: {
                                                                                                            if ((k | 0) >= 0) A = i[w + 8 >> 2] + k | 0;
                                                                                                            else {
                                                                                                                if (k = Ne(u, i[u + 1376 >> 2], i[h >> 2], 1), (k | 0) < 0) break v;
                                                                                                                A = i[u + 2148 >> 2], n = i[u + 2152 >> 2], o[w + 7 | 0] = 0, A = n - A >> 2, h = i[w + 8 >> 2], n = i[w + 12 >> 2] - h | 0;
                                                                                                                _: {
                                                                                                                    if (A >>> 0 > n >>> 0) {
                                                                                                                        ze(w + 8 | 0, A - n | 0, w + 7 | 0), h = i[w + 8 >> 2];
                                                                                                                        break _;
                                                                                                                    }
                                                                                                                    if (A >>> 0 >= n >>> 0) break _;
                                                                                                                    i[w + 12 >> 2] = A + h;
                                                                                                                }
                                                                                                                i[V >> 2] = k, A = k + h | 0;
                                                                                                            }
                                                                                                            if (o[A | 0] = 1, l[i[i[u + 2148 >> 2] + (k << 2) >> 2] + 312 | 0] && (o[i[u + 2216 >> 2] + 312 | 0] = 4), n = i[u + 2556 >> 2], s = s + 1 | 0, (n | 0) > (s | 0)) continue;
                                                                                                            break h;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                    k = 0 - k | 0;
                                                                                                    break l;
                                                                                                }
                                                                                                if (_ = i[u + 2560 >> 2], (_ | 0) > 0) {
                                                                                                    G = u + 3140 | 0, C = u + 2820 | 0, V = u + 2480 | 0, s = 0;
                                                                                                    h: {
                                                                                                        for(;;){
                                                                                                            A = s << 2, k = A + C | 0, n = i[k >> 2], _ = A + G | 0;
                                                                                                            v: {
                                                                                                                if (!i[A + V >> 2]) {
                                                                                                                    A = cn(e, n, y);
                                                                                                                    break v;
                                                                                                                }
                                                                                                                A = mi(e, n, y, 1);
                                                                                                            }
                                                                                                            i[_ >> 2] = A;
                                                                                                            v: {
                                                                                                                if ((A | 0) >= 0) A = A + i[w + 8 >> 2] | 0;
                                                                                                                else {
                                                                                                                    if (A = Ne(u, i[u + 1376 >> 2], i[k >> 2], 1), (A | 0) < 0) break v;
                                                                                                                    n = i[u + 2148 >> 2], k = i[u + 2152 >> 2], o[w + 7 | 0] = 0, n = k - n >> 2, h = i[w + 8 >> 2], k = i[w + 12 >> 2] - h | 0;
                                                                                                                    _: {
                                                                                                                        if (n >>> 0 > k >>> 0) {
                                                                                                                            ze(w + 8 | 0, n - k | 0, w + 7 | 0), h = i[w + 8 >> 2];
                                                                                                                            break _;
                                                                                                                        }
                                                                                                                        if (k >>> 0 <= n >>> 0) break _;
                                                                                                                        i[w + 12 >> 2] = n + h;
                                                                                                                    }
                                                                                                                    i[_ >> 2] = A, A = A + h | 0;
                                                                                                                }
                                                                                                                if (o[A | 0] = 1, s = s + 1 | 0, _ = i[u + 2560 >> 2], (s | 0) >= (_ | 0)) break h;
                                                                                                                continue;
                                                                                                            }
                                                                                                            break;
                                                                                                        }
                                                                                                        k = 0 - A | 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    n = i[u + 2556 >> 2];
                                                                                                }
                                                                                                h: {
                                                                                                    if ((n | 0) <= 0) break h;
                                                                                                    if (C = u + 3076 | 0, A = i[u + 2148 >> 2], h = 0, k = 0, n >>> 0 >= 4) for(V = n & 2147483644, G = 0; s = C + (k << 2) | 0, i[i[A + (i[s >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[s + 4 >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[s + 8 >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[s + 12 >> 2] << 2) >> 2] + 100 >> 2] = 2, k = k + 4 | 0, G = G + 4 | 0, (V | 0) != (G | 0););
                                                                                                    if (n = n & 3, !n) break h;
                                                                                                    for(; i[i[A + (i[C + (k << 2) >> 2] << 2) >> 2] + 100 >> 2] = 2, k = k + 1 | 0, h = h + 1 | 0, (n | 0) != (h | 0););
                                                                                                }
                                                                                                h: {
                                                                                                    if ((_ | 0) <= 0) break h;
                                                                                                    if (s = _ & 3, G = u + 3140 | 0, A = i[u + 2148 >> 2], h = 0, k = 0, _ >>> 0 >= 4) for(C = _ & 2147483644, _ = 0; n = G + (k << 2) | 0, i[i[A + (i[n >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[n + 4 >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[n + 8 >> 2] << 2) >> 2] + 100 >> 2] = 2, i[i[A + (i[n + 12 >> 2] << 2) >> 2] + 100 >> 2] = 2, k = k + 4 | 0, _ = _ + 4 | 0, (C | 0) != (_ | 0););
                                                                                                    if (!s) break h;
                                                                                                    for(; i[i[A + (i[G + (k << 2) >> 2] << 2) >> 2] + 100 >> 2] = 2, k = k + 1 | 0, h = h + 1 | 0, (s | 0) != (h | 0););
                                                                                                }
                                                                                                h: {
                                                                                                    if (i[u + 2544 >> 2] <= 0) break h;
                                                                                                    for(_ = u + 2884 | 0, G = u + 2564 | 0, s = 0;;){
                                                                                                        v: {
                                                                                                            if (A = s << 2, n = A + _ | 0, A = A + G | 0, k = mi(e, i[A >> 2], y, 0), i[n >> 2] = k, (k | 0) >= 0) A = i[w + 8 >> 2] + k | 0;
                                                                                                            else {
                                                                                                                if (k = Ne(u, i[u + 1376 >> 2], i[A >> 2], 0), (k | 0) < 0) break v;
                                                                                                                i[n >> 2] = k, A = i[u + 2148 >> 2], n = i[u + 2152 >> 2], o[w + 7 | 0] = 0, A = n - A >> 2, n = i[w + 8 >> 2], h = i[w + 12 >> 2] - n | 0;
                                                                                                                _: {
                                                                                                                    if (A >>> 0 > h >>> 0) {
                                                                                                                        ze(w + 8 | 0, A - h | 0, w + 7 | 0), n = i[w + 8 >> 2];
                                                                                                                        break _;
                                                                                                                    }
                                                                                                                    if (A >>> 0 >= h >>> 0) break _;
                                                                                                                    i[w + 12 >> 2] = A + n;
                                                                                                                }
                                                                                                                A = k + n | 0;
                                                                                                            }
                                                                                                            if (o[A | 0] = 1, l[i[i[u + 2148 >> 2] + (k << 2) >> 2] + 312 | 0] && (o[i[u + 2216 >> 2] + 312 | 0] = 4), s = s + 1 | 0, (s | 0) < i[u + 2544 >> 2]) continue;
                                                                                                            break h;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                    k = 0 - k | 0;
                                                                                                    break l;
                                                                                                }
                                                                                                h: {
                                                                                                    if (i[u + 2548 >> 2] <= 0) break h;
                                                                                                    for(_ = u + 2948 | 0, G = u + 2628 | 0, s = 0;;){
                                                                                                        v: {
                                                                                                            if (A = s << 2, n = A + _ | 0, A = A + G | 0, k = mi(e, i[A >> 2], y, 0), i[n >> 2] = k, (k | 0) >= 0) A = i[w + 8 >> 2] + k | 0;
                                                                                                            else {
                                                                                                                if (k = Ne(u, i[u + 1376 >> 2], i[A >> 2], 0), (k | 0) < 0) break v;
                                                                                                                i[n >> 2] = k, A = i[u + 2148 >> 2], n = i[u + 2152 >> 2], o[w + 7 | 0] = 0, A = n - A >> 2, n = i[w + 8 >> 2], h = i[w + 12 >> 2] - n | 0;
                                                                                                                _: {
                                                                                                                    if (A >>> 0 > h >>> 0) {
                                                                                                                        ze(w + 8 | 0, A - h | 0, w + 7 | 0), n = i[w + 8 >> 2];
                                                                                                                        break _;
                                                                                                                    }
                                                                                                                    if (A >>> 0 >= h >>> 0) break _;
                                                                                                                    i[w + 12 >> 2] = A + n;
                                                                                                                }
                                                                                                                A = k + n | 0;
                                                                                                            }
                                                                                                            if (o[A | 0] = 1, l[i[i[u + 2148 >> 2] + (k << 2) >> 2] + 312 | 0] && (o[i[u + 2216 >> 2] + 312 | 0] = 4), s = s + 1 | 0, (s | 0) < i[u + 2548 >> 2]) continue;
                                                                                                            break h;
                                                                                                        }
                                                                                                        break;
                                                                                                    }
                                                                                                    k = 0 - k | 0;
                                                                                                    break l;
                                                                                                }
                                                                                                if (i[u + 2552 >> 2] > 0) for(n = u + 3012 | 0, s = u + 2692 | 0, k = 0; h = k << 2, A = mi(e, i[h + s >> 2], y, 0), i[n + h >> 2] = A, (A | 0) >= 0 && (o[A + i[w + 8 >> 2] | 0] = 1), k = k + 1 | 0, (k | 0) < i[u + 2552 >> 2];);
                                                                                                if (e = 0, n = i[u + 2152 >> 2], s = i[u + 2148 >> 2], (n - s | 0) > 0) for(;;){
                                                                                                    A = i[w + 8 >> 2];
                                                                                                    h: {
                                                                                                        if (l[A + e | 0] && i[w + 12 >> 2] - A >>> 0 > e >>> 0 || (y = i[(e << 2) + s >> 2], A = i[u + 2216 >> 2], (y | 0) == (A | 0) | k0[y + 108 >> 2] <= k0[A >> 2] | !i[y + 100 >> 2])) break h;
                                                                                                        _ = i[y >> 2], k = i[w + 24 >> 2], h = i[w + 28 >> 2];
                                                                                                        v: {
                                                                                                            if (k >>> 0 < h >>> 0) {
                                                                                                                i[k >> 2] = _, _ = k + 4 | 0;
                                                                                                                break v;
                                                                                                            }
                                                                                                            if (G = i[w + 20 >> 2], V = k - G >> 2, A = V + 1 | 0, A >>> 0 >= 1073741824) break t;
                                                                                                            if (h = h - G | 0, C = h >> 1, C = h >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < C >>> 0 ? C : A, C) {
                                                                                                                if (C >>> 0 >= 1073741824) break i;
                                                                                                                h = D(C << 2);
                                                                                                            } else h = 0;
                                                                                                            if (A = h + (V << 2) | 0, i[A >> 2] = _, _ = A + 4 | 0, (k | 0) != (G | 0)) for(; A = A - 4 | 0, k = k - 4 | 0, i[A >> 2] = i[k >> 2], (k | 0) != (G | 0););
                                                                                                            if (i[w + 28 >> 2] = h + (C << 2), i[w + 24 >> 2] = _, i[w + 20 >> 2] = A, !G) break v;
                                                                                                            X(G), s = i[u + 2148 >> 2], n = i[u + 2152 >> 2];
                                                                                                        }
                                                                                                        i[w + 24 >> 2] = _, i[y + 108 >> 2] = i[i[u + 2216 >> 2] >> 2];
                                                                                                    }
                                                                                                    if (e = e + 1 | 0, !((e | 0) < n - s >> 2)) break;
                                                                                                }
                                                                                                if (k = 0, A = f + 1352 | 0, (A | 0) == (w + 20 | 0)) break l;
                                                                                                n = A, A = i[w + 20 >> 2], e = i[w + 24 >> 2], a8(n, A, e, e - A >> 2);
                                                                                            }
                                                                                            if (A = i[w + 8 >> 2], A && (i[w + 12 >> 2] = A, X(A)), A = i[w + 20 >> 2], A && (i[w + 24 >> 2] = A, X(A)), m = w + 32 | 0, i[B + 8 >> 2] = k, A = 0, k) break s;
                                                                                        }
                                                                                        A = i[u + 2216 >> 2], i[A + 100 >> 2] = 1, i[26056] = i[A + 96 >> 2], o[u + 2200 | 0] = 0;
                                                                                        break u;
                                                                                    }
                                                                                    if (i[u + 2216 >> 2]) break u;
                                                                                }
                                                                                A = 0;
                                                                                break s;
                                                                            }
                                                                            if (k0[f + 28 >> 2] <= 1) {
                                                                                A = 0, e = m - 480 | 0, m = e, k = i[f + 336 >> 2], s = i[f + 920 >> 2], e = B0(e, 0, 96), w = u + 3076 | 0, _ = u + 2948 | 0, G = u + 2884 | 0, n = (k | 0) > (s | 0) ? k : s, h = n - 1 | 0, M = i[u + 2556 >> 2], y = M - 1 | 0, E = i[u + 2548 >> 2], C = E - 1 | 0, R = i[u + 2544 >> 2], V = R - 1 | 0, R = (R | 0) <= 0;
                                                                                u: {
                                                                                    w: {
                                                                                        l: {
                                                                                            h: {
                                                                                                v: {
                                                                                                    for(;;){
                                                                                                        if ((A | 0) >= (n | 0)) break v;
                                                                                                        if (R || (F = h - A | 0, F = V >>> 0 > F >>> 0 ? F : V, v0((e + 288 | 0) + (A << 2) | 0, G, (F << 2) + 4 | 0), A = (A + F | 0) + 1 | 0), (E | 0) <= 0 | (A | 0) >= (n | 0) || (F = h - A | 0, F = C >>> 0 > F >>> 0 ? F : C, v0((e + 288 | 0) + (A << 2) | 0, _, (F << 2) + 4 | 0), A = (A + F | 0) + 1 | 0), (M | 0) <= 0 | (A | 0) >= (n | 0) || (F = h - A | 0, F = y >>> 0 > F >>> 0 ? F : y, T = F + 1 | 0, B0(A + e | 0, 1, T), v0((e + 288 | 0) + (A << 2) | 0, w, (F << 2) + 4 | 0), A = A + T | 0), !A) break;
                                                                                                    }
                                                                                                    if (A = i[u + 84 >> 2], (A | 0) == 20) {
                                                                                                        i[u + 80 >> 2] = 1001, n = 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    i[u + 84 >> 2] = A + 1, i[(u + (A << 2) | 0) + 4 >> 2] = 1016, n = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if ((k | 0) > 16) break l;
                                                                                                if ((k | 0) > 0) for(C = f + 1180 | 0, V = f + 1052 | 0, M = f + 1308 | 0, E = f + 924 | 0, R = f + 346 | 0, A = 0, F = l[f + 344 | 0];;){
                                                                                                    if (h = A << 2, y = h + E | 0, n = F ? l[A + R | 0] : A, i[y >> 2] = i[(e + 288 | 0) + (n << 2) >> 2], o[A + M | 0] = l[e + n | 0], n = 0, y = i[y >> 2], T = i[u + 2148 >> 2], y >>> 0 >= i[u + 2152 >> 2] - T >> 2 >>> 0 || (y = i[T + (y << 2) >> 2], !y)) break h;
                                                                                                    if (i[h + V >> 2] = i[y + 96 >> 2], i[h + C >> 2] = i[y + 100 >> 2], A = A + 1 | 0, (k | 0) == (A | 0)) break;
                                                                                                }
                                                                                                if (n = 1, i[f + 28 >> 2]) break h;
                                                                                                M = i[u + 2556 >> 2], h = M - 1 | 0, E = i[u + 2544 >> 2], y = E - 1 | 0, R = i[u + 2548 >> 2], C = R - 1 | 0, k = i[f + 340 >> 2], n = (k | 0) > (s | 0) ? k : s, s = n - 1 | 0, V = e + 48 | 0, A = 0, R = (R | 0) <= 0;
                                                                                                v: {
                                                                                                    for(;;){
                                                                                                        if ((A | 0) >= (n | 0)) break v;
                                                                                                        if (R || (F = s - A | 0, F = C >>> 0 > F >>> 0 ? F : C, v0((e + 96 | 0) + (A << 2) | 0, _, (F << 2) + 4 | 0), A = (A + F | 0) + 1 | 0), (E | 0) <= 0 | (A | 0) >= (n | 0) || (F = s - A | 0, F = y >>> 0 > F >>> 0 ? F : y, v0((e + 96 | 0) + (A << 2) | 0, G, (F << 2) + 4 | 0), A = (A + F | 0) + 1 | 0), (M | 0) <= 0 | (A | 0) >= (n | 0) || (F = s - A | 0, F = h >>> 0 > F >>> 0 ? F : h, T = F + 1 | 0, B0(A + V | 0, 1, T), v0((e + 96 | 0) + (A << 2) | 0, w, (F << 2) + 4 | 0), A = A + T | 0), !A) break;
                                                                                                    }
                                                                                                    if (A = i[u + 84 >> 2], (A | 0) == 20) {
                                                                                                        i[u + 80 >> 2] = 1001, n = 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    i[u + 84 >> 2] = A + 1, i[(u + (A << 2) | 0) + 4 >> 2] = 1016, n = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if ((k | 0) > 16) break w;
                                                                                                if (n = 1, (k | 0) <= 0) break h;
                                                                                                for(w = f + 1244 | 0, _ = f + 1116 | 0, G = f + 1324 | 0, y = f + 988 | 0, C = f + 362 | 0, A = 0, M = l[f + 345 | 0];;){
                                                                                                    if (s = A << 2, h = s + y | 0, n = M ? l[A + C | 0] : A, i[h >> 2] = i[(e + 96 | 0) + (n << 2) >> 2], o[A + G | 0] = l[n + V | 0], n = 0, h = i[h >> 2], E = i[u + 2148 >> 2], h >>> 0 >= i[u + 2152 >> 2] - E >> 2 >>> 0 || (h = i[E + (h << 2) >> 2], !h)) break h;
                                                                                                    if (i[s + _ >> 2] = i[h + 96 >> 2], i[s + w >> 2] = i[h + 100 >> 2], n = 1, A = A + 1 | 0, (k | 0) == (A | 0)) break;
                                                                                                }
                                                                                            }
                                                                                            m = e + 480 | 0;
                                                                                            break u;
                                                                                        }
                                                                                        y0(17560, 14908, 1799, 3941), z();
                                                                                    }
                                                                                    y0(17527, 14908, 1852, 3941), z();
                                                                                }
                                                                                if (A = 0, !n) break s;
                                                                            }
                                                                            i[f + 808 >> 2] = i[(l[f + 20 | 0] ? i[u + 2220 >> 2] + 808 | 0 : f + 24 | 0) >> 2], i[u + 2220 >> 2] = f, A = 1;
                                                                        }
                                                                        if (m = v + 80 | 0, s = i[u + 2216 >> 2], !A) {
                                                                            s && (o[s + 312 | 0] = 2), w4(u + 548 | 0, t), A = i[f + 1352 >> 2], A && (i[f + 1356 >> 2] = A, X(A)), C8(P), A = i[f + 784 >> 2], A && (i[f + 788 >> 2] = A, X(A)), A = i[f + 8 >> 2];
                                                                            s: {
                                                                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break s;
                                                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                            }
                                                                            X(f), n = i[B + 8 >> 2];
                                                                            break o;
                                                                        }
                                                                        n = i[s + 56 >> 2], e = i[s + 52 >> 2], k = n - e >> 2, i[f >> 2] = k;
                                                                        s: {
                                                                            if (h = i[s + 60 >> 2], h >>> 0 > n >>> 0) {
                                                                                i[n >> 2] = f, i[s + 56 >> 2] = n + 4;
                                                                                break s;
                                                                            }
                                                                            u: {
                                                                                if (A = k + 1 | 0, A >>> 0 < 1073741824) {
                                                                                    if (h = h - e | 0, w = h >> 1, h = h >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < w >>> 0 ? w : A, h) {
                                                                                        if (h >>> 0 >= 1073741824) break u;
                                                                                        A = D(h << 2);
                                                                                    } else A = 0;
                                                                                    if (k = A + (k << 2) | 0, i[k >> 2] = f, w = k + 4 | 0, (e | 0) != (n | 0)) {
                                                                                        for(; k = k - 4 | 0, n = n - 4 | 0, i[k >> 2] = i[n >> 2], (e | 0) != (n | 0););
                                                                                        e = i[s + 52 >> 2];
                                                                                    }
                                                                                    i[s + 60 >> 2] = A + (h << 2), i[s + 56 >> 2] = w, i[s + 52 >> 2] = k, e && X(e), i[s + 56 >> 2] = w;
                                                                                    break s;
                                                                                }
                                                                                break t;
                                                                            }
                                                                            break i;
                                                                        }
                                                                        if (b8(W, 1), jt(W), i[f + 776 >> 2] > 0) for(h = i[W >> 2] - i[t + 20 >> 2] | 0, n = i[f + 784 >> 2], k = 0;;){
                                                                            w = k << 2, n = i[w + n >> 2], v = i[t + 32 >> 2], A = i[t + 36 >> 2] - v >> 2;
                                                                            s: {
                                                                                for(;;){
                                                                                    if (e = A, s = 0, (e | 0) <= 0) break s;
                                                                                    if (A = e - 1 | 0, !((n | 0) < (i[v + (A << 2) >> 2] - h | 0))) break;
                                                                                }
                                                                                s = e;
                                                                            }
                                                                            if (n = i[f + 784 >> 2], A = w + n | 0, i[A >> 2] = i[A >> 2] - s, k = k + 1 | 0, !((k | 0) < i[f + 776 >> 2])) break;
                                                                        }
                                                                        s: {
                                                                            if (!l[f + 12 | 0]) {
                                                                                A = i[u + 3212 >> 2];
                                                                                break s;
                                                                            }
                                                                            h = D(480), Tn(h + 8 | 0), i[h + 472 >> 2] = 0, i[h + 476 >> 2] = 0, i[h + 464 >> 2] = 0, i[h + 468 >> 2] = 0, i[h + 456 >> 2] = 0, i[h + 460 >> 2] = 0, i[h + 448 >> 2] = 0, i[h + 452 >> 2] = 0, i[h + 440 >> 2] = 0, i[h + 444 >> 2] = 0, i[h + 432 >> 2] = 0, i[h + 436 >> 2] = 0, i[h + 424 >> 2] = 0, i[h + 428 >> 2] = 0, i[h >> 2] = i[u + 2216 >> 2], k = i[u + 3212 >> 2], n = i[u + 3216 >> 2];
                                                                            u: {
                                                                                if (k >>> 0 < n >>> 0) {
                                                                                    i[k >> 2] = h, A = k + 4 | 0;
                                                                                    break u;
                                                                                }
                                                                                if (e = i[u + 3208 >> 2], s = k - e >> 2, A = s + 1 | 0, A >>> 0 >= 1073741824) break t;
                                                                                if (_ = s << 2, n = n - e | 0, w = n >> 1, w = n >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < w >>> 0 ? w : A, w) {
                                                                                    if (w >>> 0 >= 1073741824) break i;
                                                                                    s = D(w << 2);
                                                                                } else s = 0;
                                                                                if (n = _ + s | 0, i[n >> 2] = h, A = n + 4 | 0, (e | 0) != (k | 0)) {
                                                                                    for(; n = n - 4 | 0, k = k - 4 | 0, i[n >> 2] = i[k >> 2], (e | 0) != (k | 0););
                                                                                    e = i[u + 3208 >> 2];
                                                                                }
                                                                                if (i[u + 3216 >> 2] = s + (w << 2), i[u + 3212 >> 2] = A, i[u + 3208 >> 2] = n, !e) break u;
                                                                                X(e);
                                                                            }
                                                                            i[u + 3212 >> 2] = A;
                                                                        }
                                                                        if (i[u + 3208 >> 2] != (A | 0)) {
                                                                            n = D(144), o[n + 36 | 0] = 0, i[n + 32 >> 2] = 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 44 >> 2] = 0, i[n + 140 >> 2] = u, i[n + 128 >> 2] = -1, i[n + 132 >> 2] = 0, i[n + 120 >> 2] = 0, i[n + 124 >> 2] = -1, i[n + 136 >> 2] = 0, i[n + 40 >> 2] = 0, i[n + 4 >> 2] = f, i[n >> 2] = t, A = i[W + 4 >> 2], i[n + 8 >> 2] = i[W >> 2], i[n + 12 >> 2] = A, A = i[W + 12 >> 2], i[n + 16 >> 2] = i[W + 8 >> 2], i[n + 20 >> 2] = A, A = i[W + 20 >> 2], i[n + 24 >> 2] = i[W + 16 >> 2], i[n + 28 >> 2] = A, o[n + 36 | 0] = l[u + 3220 | 0], f = i[i[u + 3212 >> 2] - 4 >> 2], t = i[f + 428 >> 2], k = i[f + 432 >> 2];
                                                                            s: {
                                                                                if (t >>> 0 < k >>> 0) {
                                                                                    i[t >> 2] = n, n = t + 4 | 0;
                                                                                    break s;
                                                                                }
                                                                                if (e = i[f + 424 >> 2], s = t - e >> 2, A = s + 1 | 0, A >>> 0 >= 1073741824) break t;
                                                                                if (k = k - e | 0, W = k >> 1, W = k >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < W >>> 0 ? W : A, W) {
                                                                                    if (W >>> 0 >= 1073741824) break i;
                                                                                    A = D(W << 2);
                                                                                } else A = 0;
                                                                                if (k = A + (s << 2) | 0, i[k >> 2] = n, n = k + 4 | 0, (e | 0) != (t | 0)) {
                                                                                    for(; k = k - 4 | 0, t = t - 4 | 0, i[k >> 2] = i[t >> 2], (e | 0) != (t | 0););
                                                                                    e = i[f + 424 >> 2];
                                                                                }
                                                                                if (i[f + 432 >> 2] = A + (W << 2), i[f + 428 >> 2] = n, i[f + 424 >> 2] = k, !e) break s;
                                                                                X(e);
                                                                            }
                                                                            i[f + 428 >> 2] = n;
                                                                        }
                                                                        B7(u, B + 7 | 0), n = 0;
                                                                    }
                                                                    m = B + 16 | 0;
                                                                    break n;
                                                                }
                                                                p0(), z();
                                                            }
                                                            break k;
                                                        }
                                                        n: switch(e - 32 | 0){
                                                            case 0:
                                                                B = D(668), i[B >> 2] = 48964, i[B + 4 >> 2] = 0, i[B + 8 >> 2] = 0, k = A, w = A + 4 | 0, f = B0(B + 12 | 0, 0, 656), s = S + 8 | 0, A = l0(s, 4), i[f >> 2] = A, n = 8;
                                                                t: {
                                                                    if ((A | 0) > 15 || (b8(s, 2), A = l0(s, 6), i[f + 4 >> 2] = A + 1, (A | 0) > 62) || (A = l0(s, 3), i[f + 8 >> 2] = A + 1, (A | 0) > 6)) break t;
                                                                    if (L = f, q = l0(s, 1), i[L + 12 >> 2] = q, b8(s, 16), f9(f + 16 | 0, s, i[f + 8 >> 2]), A = l0(s, 1), i[f + 484 >> 2] = A, u = i[f + 8 >> 2], e = A ? 0 : u - 1 | 0, (e | 0) < (u | 0)) {
                                                                        for(t = f + 488 | 0, A = e;;){
                                                                            if (u = t + Z(A, 12) | 0, L = u, q = q0(s), i[L >> 2] = q, L = u, q = q0(s), i[L + 4 >> 2] = q, h = q0(s), i[u + 8 >> 2] = h, i[u >> 2] == -99999 | (h | 0) == -99999 | i[u + 4 >> 2] == -99999) break t;
                                                                            if (A = A + 1 | 0, !((A | 0) < i[f + 8 >> 2])) break;
                                                                        }
                                                                        A = i[f + 484 >> 2];
                                                                    }
                                                                    o: {
                                                                        s: {
                                                                            u: {
                                                                                if (A) break u;
                                                                                if ((e | 0) > 7) break s;
                                                                                if ((e | 0) <= 0 || (u = (f + 488 | 0) + Z(e, 12) | 0, A = i[u >> 2], n = i[u + 4 >> 2], u = i[u + 8 >> 2], i[f + 496 >> 2] = u, i[f + 492 >> 2] = n, i[f + 488 >> 2] = A, (e | 0) == 1) || (i[f + 508 >> 2] = u, i[f + 504 >> 2] = n, i[f + 500 >> 2] = A, (e | 0) == 2) || (i[f + 520 >> 2] = u, i[f + 516 >> 2] = n, i[f + 512 >> 2] = A, (e | 0) == 3) || (i[f + 532 >> 2] = u, i[f + 528 >> 2] = n, i[f + 524 >> 2] = A, (e | 0) == 4) || (i[f + 544 >> 2] = u, i[f + 540 >> 2] = n, i[f + 536 >> 2] = A, (e | 0) == 5) || (i[f + 556 >> 2] = u, i[f + 552 >> 2] = n, i[f + 548 >> 2] = A, (e | 0) == 6)) break u;
                                                                                i[f + 568 >> 2] = u, i[f + 564 >> 2] = n, i[f + 560 >> 2] = A;
                                                                            }
                                                                            if (L = f, q = l0(s, 6), o[L + 584 | 0] = q, A = q0(s), i[f + 588 >> 2] = A, A - 1023 >>> 0 <= 4294966271) break o;
                                                                            n = A + 1 | 0, i[f + 588 >> 2] = n, A = i[f + 596 >> 2], e = A, t = i[f + 592 >> 2], u = (e - t | 0) / 12 | 0;
                                                                            u: {
                                                                                if (u >>> 0 < n >>> 0) {
                                                                                    if (e = 0, t = n - u | 0, h = i[f + 600 >> 2], t >>> 0 <= (h - A | 0) / 12 >>> 0) {
                                                                                        t && (e = A, A = Z(t, 12) - 12 | 0, A = (A - ((A >>> 0) % 12 | 0) | 0) + 12 | 0, A = B0(e, 0, A) + A | 0), i[f + 596 >> 2] = A;
                                                                                        break u;
                                                                                    }
                                                                                    w: {
                                                                                        if (u = i[f + 592 >> 2], v = (A - u | 0) / 12 | 0, n = v + t | 0, n >>> 0 < 357913942) {
                                                                                            if (h = (h - u | 0) / 12 | 0, _ = h << 1, h = h >>> 0 >= 178956970 ? 357913941 : n >>> 0 < _ >>> 0 ? _ : n, h) {
                                                                                                if (h >>> 0 >= 357913942) break w;
                                                                                                e = D(Z(h, 12));
                                                                                            }
                                                                                            n = Z(v, 12) + e | 0, t = Z(t, 12) - 12 | 0, v = (t - ((t >>> 0) % 12 | 0) | 0) + 12 | 0, t = B0(n, 0, v), v = t + v | 0, h = Z(h, 12) + e | 0;
                                                                                            l: {
                                                                                                if ((A | 0) == (u | 0)) {
                                                                                                    e = t;
                                                                                                    break l;
                                                                                                }
                                                                                                for(; _ = n - 4 | 0, i[_ >> 2] = 0, e = n - 12 | 0, t = A - 12 | 0, i[e >> 2] = i[t >> 2], i[n - 8 >> 2] = i[A - 8 >> 2], A = A - 4 | 0, i[_ >> 2] = i[A >> 2], i[A >> 2] = 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, n = e, A = t, (u | 0) != (A | 0););
                                                                                                A = i[f + 596 >> 2], u = i[f + 592 >> 2];
                                                                                            }
                                                                                            if (i[f + 600 >> 2] = h, i[f + 596 >> 2] = v, i[f + 592 >> 2] = e, (A | 0) != (u | 0)) for(; e = A - 12 | 0, n = i[e >> 2], n && (i[A - 8 >> 2] = n, X(n)), A = e, (u | 0) != (e | 0););
                                                                                            u && X(u);
                                                                                            break u;
                                                                                        }
                                                                                        p0(), z();
                                                                                    }
                                                                                    break i;
                                                                                }
                                                                                if (n >>> 0 >= u >>> 0) break u;
                                                                                if (n = t + Z(n, 12) | 0, (n | 0) != (e | 0)) for(; A = e - 12 | 0, u = i[A >> 2], u && (i[e - 8 >> 2] = u, X(u)), e = A, (e | 0) != (n | 0););
                                                                                i[f + 596 >> 2] = n;
                                                                            }
                                                                            if (i[f + 588 >> 2] >= 2) for(n = l[f + 584 | 0], A = 1;;){
                                                                                e = n + 1 | 0, h = Z(A, 12), u = h + i[f + 592 >> 2] | 0, t = i[u >> 2], _ = n, n = i[u + 4 >> 2] - t | 0;
                                                                                u: {
                                                                                    if (_ >>> 0 >= n >>> 0) {
                                                                                        r1(u, e - n | 0);
                                                                                        break u;
                                                                                    }
                                                                                    if (e >>> 0 >= n >>> 0) break u;
                                                                                    i[u + 4 >> 2] = e + t;
                                                                                }
                                                                                for(e = 0; n = l0(s, 1), o[i[h + i[f + 592 >> 2] >> 2] + e | 0] = n, n = l[f + 584 | 0], u = n >>> 0 > e >>> 0, e = e + 1 | 0, !!u;);
                                                                                if (A = A + 1 | 0, !((A | 0) < i[f + 588 >> 2])) break;
                                                                            }
                                                                            A = l0(s, 1), o[f + 604 | 0] = A;
                                                                            u: {
                                                                                w: {
                                                                                    if (!(A & 255) || (L = f, q = l0(s, 32), i[L + 608 >> 2] = q, L = f, q = l0(s, 32), i[L + 612 >> 2] = q, A = l0(s, 1), o[f + 616 | 0] = A, !(A & 255))) break w;
                                                                                    if (L = f, q = q0(s) + 1 | 0, i[L + 620 >> 2] = q, e = q0(s), i[f + 624 >> 2] = e, e >>> 0 >= 1024) break o;
                                                                                    t = 0, A = i[f + 632 >> 2], u = i[f + 628 >> 2], n = A - u >> 1;
                                                                                    l: {
                                                                                        if (n >>> 0 < e >>> 0) {
                                                                                            if (n = e - n | 0, h = i[f + 636 >> 2], n >>> 0 <= h - A >> 1 >>> 0) {
                                                                                                n && (e = A, A = n << 1, A = B0(e, 0, A) + A | 0), i[f + 632 >> 2] = A;
                                                                                                break l;
                                                                                            }
                                                                                            h: {
                                                                                                if (e = i[f + 628 >> 2], w = A - e >> 1, u = w + n | 0, (u | 0) >= 0) {
                                                                                                    if (h = h - e | 0, h = h >>> 0 >= 2147483646 ? 2147483647 : u >>> 0 < h >>> 0 ? h : u, h) {
                                                                                                        if ((h | 0) < 0) break h;
                                                                                                        t = D(h << 1);
                                                                                                    }
                                                                                                    if (u = (w << 1) + t | 0, n = n << 1, n = B0(u, 0, n) + n | 0, (A | 0) != (e | 0)) for(; u = u - 2 | 0, A = A - 2 | 0, Q[u >> 1] = I[A >> 1], (A | 0) != (e | 0););
                                                                                                    i[f + 636 >> 2] = (h << 1) + t, i[f + 632 >> 2] = n, i[f + 628 >> 2] = u, e && X(e);
                                                                                                    break l;
                                                                                                }
                                                                                                p0(), z();
                                                                                            }
                                                                                            break i;
                                                                                        }
                                                                                        e >>> 0 < n >>> 0 && (i[f + 632 >> 2] = u + (e << 1));
                                                                                    }
                                                                                    A = f + 640 | 0, n = i[A >> 2], e = i[f + 624 >> 2], u = i[A + 4 >> 2] - n | 0;
                                                                                    l: {
                                                                                        if (e >>> 0 > u >>> 0) {
                                                                                            r1(A, e - u | 0);
                                                                                            break l;
                                                                                        }
                                                                                        e >>> 0 < u >>> 0 && (i[A + 4 >> 2] = e + n);
                                                                                    }
                                                                                    if (i[f + 624 >> 2] <= 0) break w;
                                                                                    A = q0(s), Q[i[f + 628 >> 2] >> 1] = A;
                                                                                    break u;
                                                                                }
                                                                                L = f, q = l0(s, 1), o[L + 652 | 0] = q;
                                                                            }
                                                                            n = 0;
                                                                            break t;
                                                                        }
                                                                        y0(15904, 14934, 144, 14615), z();
                                                                    }
                                                                    W2(w, 8, 0), n = 8;
                                                                }
                                                                e = n;
                                                                t: {
                                                                    if (e) break t;
                                                                    if (n = i[k + 520 >> 2], (n | 0) >= 0) {
                                                                        u = m - 368 | 0, m = u, A = 55188;
                                                                        o: {
                                                                            s: switch(n - 1 | 0){
                                                                                case 1:
                                                                                    A = 55184;
                                                                                    break;
                                                                                case 0:
                                                                                    break s;
                                                                                default:
                                                                                    break o;
                                                                            }
                                                                            if (t = i[A >> 2], e0(t, 34384, 0), i[u + 352 >> 2] = i[f >> 2], e0(t, 33334, u + 352 | 0), i[u + 336 >> 2] = i[f + 4 >> 2], e0(t, 33766, u + 336 | 0), i[u + 320 >> 2] = i[f + 8 >> 2], e0(t, 33411, u + 320 | 0), i[u + 304 >> 2] = i[f + 12 >> 2], e0(t, 32018, u + 304 | 0), A = i[f + 8 >> 2], Ge(f + 16 | 0, 1, t), (A | 0) >= 2) for(n = A - 2 | 0, s = f + 68 | 0, A = 0; i[u + 288 >> 2] = A, e0(t, 33936, u + 288 | 0), Ge(s + Z(A, 52) | 0, 0, t), h = (A | 0) != (n | 0), A = A + 1 | 0, !!h;);
                                                                            i[u + 272 >> 2] = i[f + 484 >> 2], e0(t, 27459, u + 272 | 0);
                                                                            s: {
                                                                                if (i[f + 484 >> 2]) {
                                                                                    if (i[f + 8 >> 2] <= 0) break s;
                                                                                    for(s = f + 488 | 0, A = 0; n = s + Z(A, 12) | 0, i[u + 260 >> 2] = i[n >> 2], i[u + 256 >> 2] = A, e0(t, 25984, u + 256 | 0), i[u + 240 >> 2] = i[n + 4 >> 2], e0(t, 26275, u + 240 | 0), i[u + 224 >> 2] = i[n + 8 >> 2], e0(t, 26320, u + 224 | 0), A = A + 1 | 0, (A | 0) < i[f + 8 >> 2];);
                                                                                    break s;
                                                                                }
                                                                                i[u + 208 >> 2] = i[f + 488 >> 2], e0(t, 26026, u + 208 | 0), i[u + 192 >> 2] = i[f + 492 >> 2], e0(t, 26271, u + 192 | 0), i[u + 176 >> 2] = i[f + 496 >> 2], e0(t, 26316, u + 176 | 0);
                                                                            }
                                                                            if (i[u + 160 >> 2] = l[f + 584 | 0], e0(t, 26361, u + 160 | 0), i[u + 144 >> 2] = i[f + 588 >> 2], e0(t, 25931, u + 144 | 0), i[f + 588 >> 2] >= 2) for(n = 1;;){
                                                                                for(A = 0, s = Z(n, 12); i[u + 136 >> 2] = o[i[s + i[f + 592 >> 2] >> 2] + A | 0], i[u + 132 >> 2] = A, i[u + 128 >> 2] = n, e0(t, 26234, u + 128 | 0), h = l[f + 584 | 0] > A >>> 0, A = A + 1 | 0, !!h;);
                                                                                if (n = n + 1 | 0, !((n | 0) < i[f + 588 >> 2])) break;
                                                                            }
                                                                            i[u + 112 >> 2] = o[f + 604 | 0], e0(t, 26071, u + 112 | 0);
                                                                            s: {
                                                                                if (!l[f + 604 | 0] || (i[u + 96 >> 2] = i[f + 608 >> 2], e0(t, 25956, u + 96 | 0), i[u + 80 >> 2] = i[f + 612 >> 2], e0(t, 26419, u + 80 | 0), i[u + 64 >> 2] = o[f + 616 | 0], e0(t, 26131, u - -64 | 0), !l[f + 616 | 0]) || (i[u + 48 >> 2] = i[f + 620 >> 2], e0(t, 26173, u + 48 | 0), i[u + 32 >> 2] = i[f + 624 >> 2], e0(t, 26386, u + 32 | 0), i[f + 624 >> 2] <= 0)) break s;
                                                                                i[u + 20 >> 2] = I[i[f + 628 >> 2] >> 1], i[u + 16 >> 2] = 0, e0(t, 26206, u + 16 | 0);
                                                                                break o;
                                                                            }
                                                                            i[u >> 2] = o[f + 652 | 0], e0(t, 26106, u);
                                                                        }
                                                                        m = u + 368 | 0;
                                                                    }
                                                                    if (i[B + 4 >> 2] = i[B + 4 >> 2] + 1, n = k + (i[B + 12 >> 2] << 3) | 0, i[n + 600 >> 2] = f, A = i[n + 604 >> 2], i[n + 604 >> 2] = B, !A || (n = i[A + 4 >> 2], i[A + 4 >> 2] = n - 1, n)) break t;
                                                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                }
                                                                A = i[B + 4 >> 2], i[B + 4 >> 2] = A - 1, A || (p[i[i[B >> 2] + 8 >> 2]](B), g(B)), n = e, w4(k + 548 | 0, W);
                                                                break k;
                                                            case 1:
                                                                s = 0, B = D(17016), i[B >> 2] = 49080, i[B + 4 >> 2] = 0, i[B + 8 >> 2] = 0, u = A + 4 | 0, f = B + 12 | 0, i[f + 8824 >> 2] = 0, i[f + 8816 >> 2] = 0, i[f + 8820 >> 2] = 0, e = f + 9e3 | 0, Q[e + 2 >> 1] = 0, Q[e + 4 >> 1] = 0, o[e | 0] = 0, o[e + 21 | 0] = 0, o[e + 22 | 0] = 0, o[e + 23 | 0] = 0, o[e + 24 | 0] = 0, o[e + 25 | 0] = 0, o[e + 26 | 0] = 0, o[e + 27 | 0] = 0, o[e + 28 | 0] = 0, o[e + 20 | 0] = 2, i[e + 12 >> 2] = 5, i[e + 16 >> 2] = 33685504, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, Q[e + 7810 >> 1] = 258, Q[e + 7812 >> 1] = 3855, Q[e + 7808 >> 1] = 0, i[e + 7804 >> 2] = 65536, o[e + 64 | 0] = 0, i[e + 60 >> 2] = 1, o[e + 5 | 0] = 0, o[e + 6 | 0] = 0, o[e + 7 | 0] = 0, o[e + 8 | 0] = 0, o[e + 29 | 0] = 0, o[e + 30 | 0] = 0, o[e + 31 | 0] = 0, o[e + 32 | 0] = 0, o[e + 33 | 0] = 0, o[e + 34 | 0] = 0, o[e + 35 | 0] = 0, o[e + 36 | 0] = 0, o[e + 37 | 0] = 0, o[e + 38 | 0] = 0, o[e + 39 | 0] = 0, o[e + 40 | 0] = 0, o[e + 41 | 0] = 0, o[e + 42 | 0] = 0, o[e + 43 | 0] = 0, o[e + 44 | 0] = 0, o[e + 56 | 0] = 0, o[f + 16828 | 0] = 0, i[f + 16820 >> 2] = 0, i[f + 16824 >> 2] = 0, o[f | 0] = 0, k = S + 8 | 0, L = f, q = l0(k, 4), o[L + 1 | 0] = q, n = l0(k, 3) + 1 | 0, o[f + 2 | 0] = n, e = 8;
                                                                t: {
                                                                    if (n << 24 >> 24 > 7) break t;
                                                                    L = f, q = l0(k, 1), o[L + 3 | 0] = q, f9(f + 4 | 0, k, o[f + 2 | 0]);
                                                                    o: {
                                                                        s: {
                                                                            u: {
                                                                                if (n = q0(k), (n | 0) == -99999) break u;
                                                                                if (i[f + 472 >> 2] = n, (n | 0) > 15) break t;
                                                                                if (t = q0(k), (t | 0) == -99999) break u;
                                                                                if (i[f + 476 >> 2] = t, (t | 0) == 3 && (s = l0(k, 1), t = i[f + 476 >> 2]), o[f + 480 | 0] = s, t >>> 0 >= 4) {
                                                                                    W2(u, 1019, 0);
                                                                                    break t;
                                                                                }
                                                                                if (n = q0(k), (n | 0) == -99999 || (i[f + 484 >> 2] = n, n = q0(k), (n | 0) == -99999)) break u;
                                                                                if (i[f + 488 >> 2] = n, !n || (t = i[f + 484 >> 2], !t | (n | 0) > 65535 | (t | 0) > 65535)) break t;
                                                                                e = l0(k, 1), o[f + 492 | 0] = e;
                                                                                w: {
                                                                                    if (e & 255) {
                                                                                        if (e = q0(k), (e | 0) == -99999 || (i[f + 496 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[f + 500 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[f + 504 >> 2] = e, e = q0(k), (e | 0) == -99999)) break u;
                                                                                        i[f + 508 >> 2] = e;
                                                                                        break w;
                                                                                    }
                                                                                    i[f + 496 >> 2] = 0, i[f + 500 >> 2] = 0, i[f + 504 >> 2] = 0, i[f + 508 >> 2] = 0;
                                                                                }
                                                                                if (e = q0(k), (e | 0) == -99999 || (i[f + 512 >> 2] = e + 8, e = q0(k), (e | 0) == -99999)) break u;
                                                                                if (i[f + 516 >> 2] = e + 8, !(i[f + 512 >> 2] < 17 & (e | 0) <= 8)) break s;
                                                                                if (e = q0(k), (e | 0) == -99999) break u;
                                                                                if (n = e + 4 | 0, i[f + 520 >> 2] = n, e >>> 0 >= 13) break s;
                                                                                if (i[f + 16868 >> 2] = 1 << n, n = l0(k, 1), o[f + 524 | 0] = n, t = o[f + 2 | 0], e = n & 255 ? 0 : t - 1 | 0, (e | 0) < (t | 0)) {
                                                                                    for(s = f + 16964 | 0, h = f + 584 | 0, w = f + 556 | 0, v = f + 528 | 0;;){
                                                                                        if (t = q0(k), !((t | 0) != -99999 & (t | 0) < 16) || (n = e << 2, i[n + v >> 2] = t + 1, t = q0(k), (t | 0) == -99999) || (_ = n + w | 0, i[_ >> 2] = t, t = q0(k), (t | 0) == -99999)) break u;
                                                                                        if (i[n + h >> 2] = t, i[n + s >> 2] = (t + i[_ >> 2] | 0) - 1, e = e + 1 | 0, t = o[f + 2 | 0], !((e | 0) < (t | 0))) break;
                                                                                    }
                                                                                    n = l[f + 524 | 0];
                                                                                }
                                                                                w: {
                                                                                    l: {
                                                                                        if (!(n & 255)) break l;
                                                                                        if ((t | 0) > 7) break w;
                                                                                        if ((t | 0) < 2 || (e = t - 1 | 0, s = e << 2, n = s + (f + 528 | 0) | 0, i[f + 528 >> 2] = i[n >> 2], t = s + (f + 556 | 0) | 0, i[f + 556 >> 2] = i[t >> 2], s = s + (f + 584 | 0) | 0, i[f + 584 >> 2] = i[s >> 2], (e | 0) == 1) || (i[f + 532 >> 2] = i[n >> 2], i[f + 560 >> 2] = i[t >> 2], i[f + 588 >> 2] = i[s >> 2], (e | 0) == 2) || (i[f + 536 >> 2] = i[n >> 2], i[f + 564 >> 2] = i[t >> 2], i[f + 592 >> 2] = i[s >> 2], (e | 0) == 3) || (i[f + 540 >> 2] = i[n >> 2], i[f + 568 >> 2] = i[t >> 2], i[f + 596 >> 2] = i[s >> 2], (e | 0) == 4) || (i[f + 544 >> 2] = i[n >> 2], i[f + 572 >> 2] = i[t >> 2], i[f + 600 >> 2] = i[s >> 2], (e | 0) == 5)) break l;
                                                                                        i[f + 548 >> 2] = i[n >> 2], i[f + 576 >> 2] = i[t >> 2], i[f + 604 >> 2] = i[s >> 2];
                                                                                    }
                                                                                    if (e = q0(k), (e | 0) == -99999 || (i[f + 612 >> 2] = e + 3, e = q0(k), (e | 0) == -99999) || (i[f + 616 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[f + 620 >> 2] = e + 2, e = q0(k), (e | 0) == -99999) || (i[f + 624 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[f + 628 >> 2] = e, e = q0(k), (e | 0) == -99999)) break u;
                                                                                    if (i[f + 632 >> 2] = e, e = 8, n = i[f + 612 >> 2], (n | 0) > 6 | (n + i[f + 616 >> 2] | 0) > 6 || (n = i[f + 620 >> 2], (n | 0) > 5 | (n + i[f + 624 >> 2] | 0) > 5)) break t;
                                                                                    e = l0(k, 1), o[f + 636 | 0] = e;
                                                                                    l: {
                                                                                        if (!(e & 255)) break l;
                                                                                        if (e = l0(k, 1), o[f + 637 | 0] = e, n = f + 638 | 0, e & 255) {
                                                                                            if (e = T7(k, n), !e) break l;
                                                                                            break t;
                                                                                        }
                                                                                        for(e = 0, K4(n, 86048, 0), K4(n + 16 | 0, 86048, 0), K4(n + 32 | 0, 86048, 0), K4(n + 48 | 0, 86048, 0), K4(n - -64 | 0, 86048, 0), K4(n + 80 | 0, 86048, 0), s = n + 96 | 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86064 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86065 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 288 | 0, e = 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86128 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86129 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 160 | 0, e = 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86064 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86065 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 352 | 0, e = 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86128 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86129 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 224 | 0, e = 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86064 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86065 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 416 | 0, e = 0, h = i[i[12662] + 12 >> 2]; t = h + (e << 1) | 0, o[(s + (l[t + 1 | 0] << 3) | 0) + l[t | 0] | 0] = l[e + 86128 | 0], o[l[t + 2 | 0] + (s + (l[t + 3 | 0] << 3) | 0) | 0] = l[e + 86129 | 0], e = e + 2 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 481 | 0, h = n + 480 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86064 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 1249 | 0, h = n + 1248 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86128 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 737 | 0, h = n + 736 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86064 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 1505 | 0, h = n + 1504 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86128 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 993 | 0, h = n + 992 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86064 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        for(s = n + 1761 | 0, h = n + 1760 | 0, e = 0, w = i[i[12662] + 12 >> 2]; t = w + (e << 1) | 0, v = e + 86128 | 0, _ = l[v | 0], o[(h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, o[(s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0] = _, v = l[v | 0], o[((h + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, o[((s + (l[t | 0] << 1) | 0) + (l[t + 1 | 0] << 5) | 0) + 16 | 0] = v, e = e + 1 | 0, (e | 0) != 64;);
                                                                                        K4(n + 2016 | 0, 86064, 3), K4(n + 3040 | 0, 86128, 3);
                                                                                    }
                                                                                    L = f, q = l0(k, 1), o[L + 8798 | 0] = q, L = f, q = l0(k, 1), o[L + 8799 | 0] = q, e = l0(k, 1), o[f + 8800 | 0] = e;
                                                                                    l: {
                                                                                        if (e & 255) {
                                                                                            if (L = f, q = l0(k, 4) + 1 | 0, o[L + 8801 | 0] = q, L = f, q = l0(k, 4) + 1 | 0, o[L + 8802 | 0] = q, e = q0(k), (e | 0) == -99999 || (i[f + 8804 >> 2] = e + 3, e = q0(k), (e | 0) == -99999)) break u;
                                                                                            if (i[f + 8808 >> 2] = e, L = f, q = l0(k, 1), o[L + 8812 | 0] = q, i[f + 512 >> 2] < o[f + 8801 | 0]) break o;
                                                                                            if (i[f + 516 >> 2] >= o[f + 8802 | 0]) break l;
                                                                                            break o;
                                                                                        }
                                                                                        i[f + 8804 >> 2] = 0, i[f + 8808 >> 2] = 0, o[f + 8801 | 0] = 0, o[f + 8802 | 0] = 0, o[f + 8812 | 0] = 0;
                                                                                    }
                                                                                    if (n = q0(k), (n | 0) == -99999) break u;
                                                                                    if (n >>> 0 >= 65) {
                                                                                        W2(u, 1014, 0), e = 8;
                                                                                        break t;
                                                                                    }
                                                                                    s = 0, e = f + 8816 | 0, t = i[e + 4 >> 2], w = i[e >> 2], h = (t - w | 0) / 100 | 0;
                                                                                    l: {
                                                                                        if (h >>> 0 < n >>> 0) {
                                                                                            if (w = n - h | 0, _ = i[e + 8 >> 2], w >>> 0 <= (_ - t | 0) / 100 >>> 0) {
                                                                                                w && (s = t, t = Z(w, 100) - 100 | 0, t = (t - ((t >>> 0) % 100 | 0) | 0) + 100 | 0, t = B0(s, 0, t) + t | 0), i[e + 4 >> 2] = t;
                                                                                                break l;
                                                                                            }
                                                                                            h: {
                                                                                                if (h = i[e >> 2], G = (t - h | 0) / 100 | 0, v = G + w | 0, v >>> 0 < 42949673) {
                                                                                                    if (_ = (_ - h | 0) / 100 | 0, y = _ << 1, v = _ >>> 0 >= 21474836 ? 42949672 : v >>> 0 < y >>> 0 ? y : v, v) {
                                                                                                        if (v >>> 0 >= 42949673) break h;
                                                                                                        s = D(Z(v, 100));
                                                                                                    }
                                                                                                    if (_ = Z(G, 100) + s | 0, w = Z(w, 100) - 100 | 0, w = (w - ((w >>> 0) % 100 | 0) | 0) + 100 | 0, w = B0(_, 0, w) + w | 0, (t | 0) != (h | 0)) {
                                                                                                        for(; _ = _ - 100 | 0, t = t - 100 | 0, v0(_, t, 100), (t | 0) != (h | 0););
                                                                                                        h = i[e >> 2];
                                                                                                    }
                                                                                                    i[e + 8 >> 2] = Z(v, 100) + s, i[e + 4 >> 2] = w, i[e >> 2] = _, h && X(h);
                                                                                                    break l;
                                                                                                }
                                                                                                p0(), z();
                                                                                            }
                                                                                            break i;
                                                                                        }
                                                                                        n >>> 0 < h >>> 0 && (i[e + 4 >> 2] = w + Z(n, 100));
                                                                                    }
                                                                                    l: {
                                                                                        if (!n) break l;
                                                                                        for(t = 0;;){
                                                                                            if ($7(u, f, k, i[f + 8816 >> 2] + Z(t, 100) | 0, t, e, 0)) {
                                                                                                if (t = t + 1 | 0, (n | 0) != (t | 0)) continue;
                                                                                                break l;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        e = 1005;
                                                                                        break t;
                                                                                    }
                                                                                    e = l0(k, 1), o[f + 8828 | 0] = e;
                                                                                    l: {
                                                                                        if (e & 255) {
                                                                                            if (n = q0(k), (n | 0) == -99999) break u;
                                                                                            if (i[f + 8832 >> 2] = n, e = 8, (n | 0) > 32) break t;
                                                                                            if ((n | 0) <= 0) break l;
                                                                                            for(e = f + 8964 | 0, n = f + 8836 | 0, t = 0; L = n + (t << 2) | 0, q = l0(k, i[f + 520 >> 2]), i[L >> 2] = q, L = e + t | 0, q = l0(k, 1), o[L | 0] = q, t = t + 1 | 0, (t | 0) < i[f + 8832 >> 2];);
                                                                                            break l;
                                                                                        }
                                                                                        i[f + 8832 >> 2] = 0;
                                                                                    }
                                                                                    if (L = f, q = l0(k, 1), o[L + 8996 | 0] = q, L = f, q = l0(k, 1), o[L + 8997 | 0] = q, e = l0(k, 1), o[f + 8998 | 0] = e, e & 255) {
                                                                                        e = 0, n = f + 9e3 | 0, t = l0(k, 1), o[n | 0] = (t | 0) != 0;
                                                                                        l: {
                                                                                            if (t) {
                                                                                                if (e = l0(k, 8), (e | 0) <= 17) {
                                                                                                    e = e << 2, Q[n + 2 >> 1] = I[e + 51456 >> 1], e = I[e + 51458 >> 1];
                                                                                                    break l;
                                                                                                }
                                                                                                if ((e | 0) == 255) {
                                                                                                    L = n, q = l0(k, 16), Q[L + 2 >> 1] = q, e = l0(k, 16);
                                                                                                    break l;
                                                                                                }
                                                                                                e = 0;
                                                                                            }
                                                                                            Q[n + 2 >> 1] = 0;
                                                                                        }
                                                                                        Q[n + 4 >> 1] = e, e = l0(k, 1), o[n + 6 | 0] = (e | 0) != 0, e && (L = n, q = (l0(k, 1) | 0) != 0, o[L + 7 | 0] = q), o[n + 20 | 0] = 2, Q[n + 18 >> 1] = 514, o[n + 16 | 0] = 0, i[n + 12 >> 2] = 5, e = l0(k, 1), o[n + 8 | 0] = (e | 0) != 0;
                                                                                        l: {
                                                                                            if (!e || (e = l0(k, 3), i[n + 12 >> 2] = (e | 0) >= 5 ? 5 : e, L = n, q = (l0(k, 1) | 0) != 0, o[L + 16 | 0] = q, e = l0(k, 1), o[n + 17 | 0] = (e | 0) != 0, !e)) break l;
                                                                                            e = l0(k, 8), o[n + 18 | 0] = e;
                                                                                            h: {
                                                                                                v: {
                                                                                                    _: switch(e = e & 255, e | 0){
                                                                                                        case 0:
                                                                                                        case 3:
                                                                                                            break v;
                                                                                                        default:
                                                                                                            break _;
                                                                                                    }
                                                                                                    if (e >>> 0 < 11) break h;
                                                                                                }
                                                                                                o[n + 18 | 0] = 2;
                                                                                            }
                                                                                            e = l0(k, 8), o[n + 19 | 0] = e;
                                                                                            h: {
                                                                                                v: switch(e & 255){
                                                                                                    default:
                                                                                                        if ((e & 254) >>> 0 < 18) break h;
                                                                                                        break;
                                                                                                    case 0:
                                                                                                    case 3:
                                                                                                        break v;
                                                                                                }
                                                                                                o[n + 19 | 0] = 2;
                                                                                            }
                                                                                            e = l0(k, 8), o[n + 20 | 0] = (e & 255) >>> 0 > 10 ? 2 : e;
                                                                                        }
                                                                                        e = 0, t = l0(k, 1), o[n + 21 | 0] = (t | 0) != 0;
                                                                                        l: {
                                                                                            h: {
                                                                                                v: {
                                                                                                    if (t) {
                                                                                                        if (e = q0(k), (e | 0) == -99999) break h;
                                                                                                        if (o[n + 22 | 0] = e, e = q0(k), (e | 0) != -99999) break v;
                                                                                                        break h;
                                                                                                    }
                                                                                                    o[n + 22 | 0] = 0;
                                                                                                }
                                                                                                o[n + 23 | 0] = e, L = n, q = (l0(k, 1) | 0) != 0, o[L + 24 | 0] = q, L = n, q = (l0(k, 1) | 0) != 0, o[L + 25 | 0] = q, L = n, q = (l0(k, 1) | 0) != 0, o[L + 26 | 0] = q, e = l0(k, 1), o[n + 27 | 0] = (e | 0) != 0;
                                                                                                v: {
                                                                                                    if (e) {
                                                                                                        if (e = q0(k), (e | 0) == -99999 || (i[n + 28 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[n + 32 >> 2] = e, e = q0(k), (e | 0) == -99999) || (i[n + 36 >> 2] = e, e = q0(k), (e | 0) == -99999)) break h;
                                                                                                        i[n + 40 >> 2] = e;
                                                                                                        break v;
                                                                                                    }
                                                                                                    i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 36 >> 2] = 0, i[n + 40 >> 2] = 0;
                                                                                                }
                                                                                                e = l0(k, 1), o[n + 44 | 0] = (e | 0) != 0;
                                                                                                v: {
                                                                                                    _: {
                                                                                                        if (!e) break _;
                                                                                                        if (L = n, q = l0(k, 32), i[L + 48 >> 2] = q, L = n, q = l0(k, 32), i[L + 52 >> 2] = q, e = l0(k, 1), o[n + 56 | 0] = (e | 0) != 0, e) {
                                                                                                            if (e = q0(k), (e | 0) == -99999) break h;
                                                                                                            i[n + 60 >> 2] = e + 1;
                                                                                                        }
                                                                                                        if (e = l0(k, 1), o[n + 64 | 0] = (e | 0) != 0, !e) break _;
                                                                                                        s = 0, L = n, q = (l0(k, 1) | 0) != 0, o[L + 65 | 0] = q, e = l0(k, 1), o[n + 66 | 0] = (e | 0) != 0, e | o[n + 65 | 0] & 1 && (e = l0(k, 1), o[n + 67 | 0] = (e | 0) != 0, e && (L = n, q = l0(k, 8), i[L + 68 >> 2] = q, L = n, q = l0(k, 5), i[L + 72 >> 2] = q, L = n, q = (l0(k, 1) | 0) != 0, o[L + 76 | 0] = q, L = n, q = l0(k, 5), i[L + 80 >> 2] = q), L = n, q = l0(k, 4), i[L + 84 >> 2] = q, L = n, q = l0(k, 4), i[L + 88 >> 2] = q, l[n + 67 | 0] == 1 && (L = n, q = l0(k, 4), i[L + 92 >> 2] = q), L = n, q = l0(k, 5), i[L + 96 >> 2] = q, L = n, q = l0(k, 5), i[L + 100 >> 2] = q, L = n, q = l0(k, 5), i[L + 104 >> 2] = q), e = 0;
                                                                                                        B: {
                                                                                                            if (o[f + 2 | 0] <= 0) break B;
                                                                                                            v = n + 7356 | 0, _ = n + 5564 | 0, G = n + 3772 | 0, y = n + 1980 | 0, C = n + 188 | 0, E = n + 160 | 0, V = n + 132 | 0, P = n + 122 | 0, M = n + 115 | 0, R = n + 108 | 0;
                                                                                                            m: {
                                                                                                                for(;;){
                                                                                                                    Z: {
                                                                                                                        e = l0(k, 1), o[s + R | 0] = (e | 0) != 0;
                                                                                                                        W: {
                                                                                                                            X: {
                                                                                                                                p: {
                                                                                                                                    Q: {
                                                                                                                                        if (e) {
                                                                                                                                            o[s + M | 0] = 1, e = s + P | 0, o[e | 0] = 0, h = V + (s << 2) | 0, i[h >> 2] = 0;
                                                                                                                                            break Q;
                                                                                                                                        }
                                                                                                                                        if (t = l0(k, 1), o[s + M | 0] = (t | 0) != 0, e = s + P | 0, o[e | 0] = 0, h = V + (s << 2) | 0, i[h >> 2] = 0, !t) break p;
                                                                                                                                    }
                                                                                                                                    if (t = q0(k), (t | 0) == -99999) break Z;
                                                                                                                                    if (i[E + (s << 2) >> 2] = t, o[e | 0] & 1) break W;
                                                                                                                                    break X;
                                                                                                                                }
                                                                                                                                if (t = e, e = l0(k, 1), o[t | 0] = (e | 0) != 0, e) break W;
                                                                                                                            }
                                                                                                                            if (e = q0(k), (e | 0) == -99999) break Z;
                                                                                                                            if (i[h >> 2] = e, e >>> 0 <= 31) break W;
                                                                                                                            e = 8;
                                                                                                                            break B;
                                                                                                                        }
                                                                                                                        if (e = 0, l[n + 65 | 0] == 1) for(;;){
                                                                                                                            if (F = q0(k), (F | 0) == -99999 || (w = e << 3, t = s << 8, i[w + (t + C | 0) >> 2] = F, F = q0(k), (F | 0) == -99999)) break Z;
                                                                                                                            if (i[w + (t + y | 0) >> 2] = F, l[n + 67 | 0] == 1) {
                                                                                                                                if (F = q0(k), (F | 0) == -99999 || (i[w + (t + G | 0) >> 2] = F, F = q0(k), (F | 0) == -99999)) break Z;
                                                                                                                                i[w + (t + _ | 0) >> 2] = F;
                                                                                                                            }
                                                                                                                            if (L = (v + (s << 6) | 0) + (e << 1) | 0, q = (l0(k, 1) | 0) != 0, o[L | 0] = q, t = k0[h >> 2] > e >>> 0, e = e + 1 | 0, !t) break;
                                                                                                                        }
                                                                                                                        if (e = 0, l[n + 66 | 0] == 1) for(;;){
                                                                                                                            if (F = q0(k), (F | 0) == -99999 || (w = e << 3, t = s << 8, i[(w + (t + C | 0) | 0) + 4 >> 2] = F, F = q0(k), (F | 0) == -99999)) break Z;
                                                                                                                            if (i[(w + (t + y | 0) | 0) + 4 >> 2] = F, l[n + 67 | 0] == 1) {
                                                                                                                                if (F = q0(k), (F | 0) == -99999 || (i[(w + (t + G | 0) | 0) + 4 >> 2] = F, F = q0(k), (F | 0) == -99999)) break Z;
                                                                                                                                i[(w + (t + _ | 0) | 0) + 4 >> 2] = F;
                                                                                                                            }
                                                                                                                            if (L = (v + (s << 6) | 0) + (e << 1) | 0, q = (l0(k, 1) | 0) != 0, o[L + 1 | 0] = q, t = k0[h >> 2] > e >>> 0, e = e + 1 | 0, !t) break;
                                                                                                                        }
                                                                                                                        if (e = 0, s = s + 1 | 0, (s | 0) < o[f + 2 | 0]) continue;
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    break;
                                                                                                                }
                                                                                                                e = 8, W2(u, 8, 0);
                                                                                                            }
                                                                                                        }
                                                                                                        if (e) break v;
                                                                                                    }
                                                                                                    if (e = l0(k, 1), o[n + 7804 | 0] = (e | 0) != 0, e) {
                                                                                                        if (L = n, q = (l0(k, 1) | 0) != 0, o[L + 7805 | 0] = q, L = n, q = (l0(k, 1) | 0) != 0, o[L + 7806 | 0] = q, L = n, q = (l0(k, 1) | 0) != 0, o[L + 7807 | 0] = q, e = q0(k), (e | 0) == -99999 || (Q[n + 7808 >> 1] = e, e & 61440 && (W2(u, 8, 0), Q[n + 7808 >> 1] = 0), e = q0(k), (e | 0) == -99999) || (o[n + 7810 | 0] = e, (e & 255) >>> 0 >= 17 && (W2(u, 8, 0), o[n + 7810 | 0] = 2), e = q0(k), (e | 0) == -99999) || (o[n + 7811 | 0] = e, (e & 255) >>> 0 >= 17 && (W2(u, 8, 0), o[n + 7811 | 0] = 1), e = q0(k), (e | 0) == -99999) || (o[n + 7812 | 0] = e, e & 240 && (W2(u, 8, 0), o[n + 7812 | 0] = 15), t = q0(k), (t | 0) == -99999)) break h;
                                                                                                        if (o[n + 7813 | 0] = t, e = 0, !(t & 240)) break v;
                                                                                                        W2(u, 8, 0), o[n + 7813 | 0] = 15;
                                                                                                        break l;
                                                                                                    }
                                                                                                    Q[n + 7810 >> 1] = 258, Q[n + 7812 >> 1] = 3855, e = 0, Q[n + 7808 >> 1] = 0, o[n + 7807 | 0] = 0, o[n + 7805 | 0] = 0, o[n + 7806 | 0] = 1;
                                                                                                }
                                                                                                break l;
                                                                                            }
                                                                                            W2(u, 8, 0), e = 8;
                                                                                        }
                                                                                        if (e) break t;
                                                                                    }
                                                                                    e = l0(k, 1), o[f + 16816 | 0] = e;
                                                                                    l: {
                                                                                        if (!(e & 255)) {
                                                                                            o[f + 16817 | 0] = 0;
                                                                                            break l;
                                                                                        }
                                                                                        if (L = f, q = l0(k, 1), o[L + 16817 | 0] = q, L = f, q = l0(k, 1), o[L + 16818 | 0] = q, L = f, q = l0(k, 6), o[L + 16819 | 0] = q, !l[f + 16817 | 0]) break l;
                                                                                        e = f + 16820 | 0, L = e, q = l0(k, 1), o[L | 0] = q, L = e, q = l0(k, 1), o[L + 1 | 0] = q, L = e, q = l0(k, 1), o[L + 2 | 0] = q, L = e, q = l0(k, 1), o[L + 3 | 0] = q, L = e, q = l0(k, 1), o[L + 4 | 0] = q, L = e, q = l0(k, 1), o[L + 5 | 0] = q, L = e, q = l0(k, 1), o[L + 6 | 0] = q, L = e, q = l0(k, 1), o[L + 7 | 0] = q, L = e, q = l0(k, 1), o[L + 8 | 0] = q;
                                                                                    }
                                                                                    u = i[f + 476 >> 2], e = u << 2, y = i[e + 51312 >> 2], i[f + 16856 >> 2] = y, C = i[e + 51296 >> 2], i[f + 16852 >> 2] = C, M = l[f + 480 | 0];
                                                                                    l: {
                                                                                        if (M) {
                                                                                            i[f + 16848 >> 2] = 0, n = 1, e = 1;
                                                                                            break l;
                                                                                        }
                                                                                        i[f + 16848 >> 2] = u, n = u ? y : 1, e = u ? C : 1;
                                                                                    }
                                                                                    i[f + 16864 >> 2] = n, i[f + 16860 >> 2] = e, t = i[f + 512 >> 2], i[f + 16832 >> 2] = t, h = i[f + 516 >> 2], i[f + 16840 >> 2] = h, w = i[f + 612 >> 2], i[f + 16872 >> 2] = w, k = 1 << w, i[f + 16880 >> 2] = k, E = i[f + 616 >> 2], v = E + w | 0, i[f + 16876 >> 2] = v, V = i[f + 488 >> 2], P = i[f + 484 >> 2], i[f + 16912 >> 2] = Z(V, P), i[f + 16836 >> 2] = Z(t, 6) - 48, i[f + 16844 >> 2] = Z(h, 6) - 48, e = 1 << v, i[f + 16884 >> 2] = e, n = P - 1 | 0, s = (n + k | 0) / (k | 0) | 0, i[f + 16888 >> 2] = s, _ = V - 1 | 0, G = (_ + k | 0) / (k | 0) | 0, i[f + 16896 >> 2] = G, n = (e + n | 0) / (e | 0) | 0, i[f + 16892 >> 2] = n, i[f + 16904 >> 2] = Z(s, G), s = (e + _ | 0) / (e | 0) | 0, i[f + 16900 >> 2] = s, i[f + 16908 >> 2] = Z(n, s), G = 0, _ = 0;
                                                                                    l: {
                                                                                        if (!u || (_ = 0, M)) break l;
                                                                                        G = (e | 0) / (C | 0) | 0, _ = (e | 0) / (y | 0) | 0;
                                                                                    }
                                                                                    i[f + 16920 >> 2] = _, i[f + 16916 >> 2] = G, e = i[f + 620 >> 2], i[f + 16936 >> 2] = e, G = e + i[f + 624 >> 2] | 0, i[f + 16940 >> 2] = G;
                                                                                    l: {
                                                                                        h: {
                                                                                            if (u = v - e | 0, (u | 0) < i[f + 628 >> 2]) {
                                                                                                E1(25594, 70, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            if ((u | 0) < i[f + 632 >> 2]) {
                                                                                                E1(25665, 70, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            i[f + 16944 >> 2] = w - 1, _ = i[f + 8804 >> 2], i[f + 16956 >> 2] = _, y = s << u, i[f + 16928 >> 2] = y, u = n << u, i[f + 16924 >> 2] = u, r0 = s, s = E + 1 | 0, i[f + 16952 >> 2] = r0 << s, i[f + 16948 >> 2] = n << s, i[f + 16960 >> 2] = _ + i[f + 8808 >> 2], i[f + 16932 >> 2] = Z(u, y);
                                                                                            v: {
                                                                                                if (l[f + 16826 | 0]) {
                                                                                                    s = 1 << h - 1, _ = 0, u = 0, n = 1 << t - 1;
                                                                                                    break v;
                                                                                                }
                                                                                                _ = t - 8 | 0, s = 128, u = h - 8 | 0, n = 128;
                                                                                            }
                                                                                            if (i[f + 17e3 >> 2] = s, i[f + 16996 >> 2] = n, o[f + 16993 | 0] = u, o[f + 16992 | 0] = _, k - 1 & (V | P)) {
                                                                                                E1(25253, 24, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            if ((e | 0) > (w | 0)) {
                                                                                                E1(34074, 19, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            if ((G | 0) > (((v | 0) >= 5 ? 5 : v) | 0)) {
                                                                                                E1(34043, 30, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            if (t - 17 >>> 0 <= 4294967286) {
                                                                                                E1(33969, 36, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            if (h - 17 >>> 0 <= 4294967286) {
                                                                                                E1(34006, 36, 1, i[13796]);
                                                                                                break h;
                                                                                            }
                                                                                            o[f | 0] = 1, e = 0;
                                                                                            break l;
                                                                                        }
                                                                                        e = 8;
                                                                                    }
                                                                                    if (e) break t;
                                                                                    o[f | 0] = 1, e = 0;
                                                                                    break t;
                                                                                }
                                                                                y0(17521, 14941, 320, 14615), z();
                                                                            }
                                                                            W2(u, 8, 0), e = 8;
                                                                            break t;
                                                                        }
                                                                        W2(u, 1005, 0), e = 8;
                                                                        break t;
                                                                    }
                                                                    W2(u, 1027, 0), e = 8;
                                                                }
                                                                if (n = e, !e) {
                                                                    if (s = i[A + 516 >> 2], (s | 0) >= 0) {
                                                                        n = m - 928 | 0, m = n, t = 55188;
                                                                        t: {
                                                                            o: switch(s - 1 | 0){
                                                                                case 1:
                                                                                    t = 55184;
                                                                                    break;
                                                                                case 0:
                                                                                    break o;
                                                                                default:
                                                                                    break t;
                                                                            }
                                                                            if (e = i[t >> 2], e0(e, 34425, 0), i[n + 912 >> 2] = o[f + 1 | 0], e0(e, 29364, n + 912 | 0), i[n + 896 >> 2] = o[f + 2 | 0], e0(e, 30621, n + 896 | 0), i[n + 880 >> 2] = o[f + 3 | 0], e0(e, 27840, n + 880 | 0), u = o[f + 2 | 0], k = m - 16 | 0, m = k, t = f + 4 | 0, Ge(t, 1, e), (u | 0) >= 2) for(u = u - 2 | 0, h = t + 52 | 0, t = 0; i[k >> 2] = t, e0(e, 33936, k), Ge(h + Z(t, 52) | 0, 0, e), w = (t | 0) == (u | 0), t = t + 1 | 0, !w;);
                                                                            m = k + 16 | 0, i[n + 864 >> 2] = i[f + 472 >> 2], e0(e, 30166, n + 864 | 0), k = i[f + 476 >> 2];
                                                                            o: {
                                                                                if (k >>> 0 >= 3) {
                                                                                    t = (k | 0) == 3 ? 17784 : 6575;
                                                                                    break o;
                                                                                }
                                                                                t = i[(k << 2) + 51328 >> 2];
                                                                            }
                                                                            if (i[n + 852 >> 2] = t, i[n + 848 >> 2] = k, e0(e, 34673, n + 848 | 0), i[f + 476 >> 2] == 3 && (i[n + 832 >> 2] = o[f + 480 | 0], e0(e, 27917, n + 832 | 0)), i[n + 816 >> 2] = i[f + 484 >> 2], e0(e, 29189, n + 816 | 0), i[n + 800 >> 2] = i[f + 488 >> 2], e0(e, 27148, n + 800 | 0), i[n + 784 >> 2] = o[f + 492 | 0], e0(e, 29977, n + 784 | 0), l[f + 492 | 0] && (i[n + 768 >> 2] = i[f + 496 >> 2], e0(e, 29100, n + 768 | 0), i[n + 752 >> 2] = i[f + 500 >> 2], e0(e, 27053, n + 752 | 0), i[n + 736 >> 2] = i[f + 504 >> 2], e0(e, 29430, n + 736 | 0), i[n + 720 >> 2] = i[f + 508 >> 2], e0(e, 26447, n + 720 | 0)), i[n + 704 >> 2] = i[f + 512 >> 2], e0(e, 29608, n + 704 | 0), i[n + 688 >> 2] = i[f + 516 >> 2], e0(e, 28853, n + 688 | 0), i[n + 672 >> 2] = i[f + 520 >> 2], e0(e, 28778, n + 672 | 0), i[n + 656 >> 2] = o[f + 524 | 0], e0(e, 27506, n + 656 | 0), k = o[f + 2 | 0], t = l[f + 524 | 0] ? 0 : k - 1 | 0, (t | 0) < (k | 0)) for(u = f + 584 | 0, h = f + 556 | 0, w = f + 528 | 0; i[n + 640 >> 2] = t, e0(e, 25921, n + 640 | 0), k = t << 2, i[n + 624 >> 2] = i[k + w >> 2], e0(e, 30729, n + 624 | 0), i[n + 608 >> 2] = i[k + h >> 2], e0(e, 31164, n + 608 | 0), i[n + 592 >> 2] = i[k + u >> 2], e0(e, 28899, n + 592 | 0), t = t + 1 | 0, (t | 0) < o[f + 2 | 0];);
                                                                            i[n + 576 >> 2] = i[f + 612 >> 2], e0(e, 28575, n + 576 | 0), i[n + 560 >> 2] = i[f + 616 >> 2], e0(e, 28528, n + 560 | 0), i[n + 544 >> 2] = i[f + 620 >> 2], e0(e, 29527, n + 544 | 0), i[n + 528 >> 2] = i[f + 624 >> 2], e0(e, 28483, n + 528 | 0), i[n + 512 >> 2] = i[f + 628 >> 2], e0(e, 27181, n + 512 | 0), i[n + 496 >> 2] = i[f + 632 >> 2], e0(e, 28811, n + 496 | 0), i[n + 480 >> 2] = o[f + 636 | 0], e0(e, 27950, n + 480 | 0);
                                                                            o: {
                                                                                if (!l[f + 636 | 0] || (i[n + 464 >> 2] = o[f + 637 | 0], e0(e, 27679, n + 464 | 0), !l[f + 637 | 0])) break o;
                                                                                e0(e, 13378, 0);
                                                                            }
                                                                            if (i[n + 448 >> 2] = o[f + 8798 | 0], e0(e, 33455, n + 448 | 0), i[n + 432 >> 2] = o[f + 8799 | 0], e0(e, 28172, n + 432 | 0), i[n + 416 >> 2] = o[f + 8800 | 0], e0(e, 33497, n + 416 | 0), l[f + 8800 | 0] && (i[n + 400 >> 2] = o[f + 8801 | 0], e0(e, 30566, n + 400 | 0), i[n + 384 >> 2] = o[f + 8802 | 0], e0(e, 29631, n + 384 | 0), i[n + 368 >> 2] = i[f + 8804 >> 2], e0(e, 28664, n + 368 | 0), i[n + 352 >> 2] = i[f + 8808 >> 2], e0(e, 28613, n + 352 | 0), i[n + 336 >> 2] = o[f + 8812 | 0], e0(e, 29291, n + 336 | 0)), i[n + 320 >> 2] = (i[f + 8820 >> 2] - i[f + 8816 >> 2] | 0) / 100, e0(e, 27081, n + 320 | 0), i[f + 8820 >> 2] != i[f + 8816 >> 2]) for(t = 0; i[n + 304 >> 2] = t, e0(e, 24915, n + 304 | 0), mn(i[f + 8816 >> 2] + Z(t, 100) | 0, e), t = t + 1 | 0, t >>> 0 < (i[f + 8820 >> 2] - i[f + 8816 >> 2] | 0) / 100 >>> 0;);
                                                                            i[n + 288 >> 2] = o[f + 8828 | 0], e0(e, 27388, n + 288 | 0);
                                                                            o: {
                                                                                if (!l[f + 8828 | 0] || (i[n + 272 >> 2] = i[f + 8832 >> 2], e0(e, 27115, n + 272 | 0), i[f + 8832 >> 2] <= 0)) break o;
                                                                                for(k = f + 8964 | 0, u = f + 8836 | 0, t = 0; h = i[u + (t << 2) >> 2], i[n + 264 >> 2] = o[k + t | 0], i[n + 260 >> 2] = h, i[n + 256 >> 2] = t, e0(e, 34800, n + 256 | 0), t = t + 1 | 0, (t | 0) < i[f + 8832 >> 2];);
                                                                            }
                                                                            if (i[n + 240 >> 2] = o[f + 8996 | 0], e0(e, 31008, n + 240 | 0), i[n + 224 >> 2] = o[f + 8997 | 0], e0(e, 27981, n + 224 | 0), i[n + 208 >> 2] = o[f + 8998 | 0], e0(e, 31423, n + 208 | 0), i[n + 192 >> 2] = o[f + 16816 | 0], e0(e, 30043, n + 192 | 0), i[n + 176 >> 2] = o[f + 16817 | 0], e0(e, 30811, n + 176 | 0), i[n + 160 >> 2] = o[f + 16818 | 0], e0(e, 27768, n + 160 | 0), i[n + 144 >> 2] = o[f + 16819 | 0], e0(e, 32183, n + 144 | 0), i[n + 128 >> 2] = i[f + 16884 >> 2], e0(e, 30602, n + 128 | 0), i[n + 112 >> 2] = i[f + 16880 >> 2], e0(e, 29686, n + 112 | 0), i[n + 96 >> 2] = 1 << i[f + 616 >> 2] + i[f + 612 >> 2], e0(e, 29667, n + 96 | 0), i[n + 80 >> 2] = 1 << i[f + 620 >> 2], e0(e, 29724, n + 80 | 0), i[n + 64 >> 2] = 1 << i[f + 624 >> 2] + i[f + 620 >> 2], e0(e, 29705, n - -64 | 0), i[n + 48 >> 2] = i[f + 16892 >> 2], e0(e, 31864, n + 48 | 0), i[n + 32 >> 2] = i[f + 16900 >> 2], e0(e, 31577, n + 32 | 0), i[n + 16 >> 2] = i[f + 16852 >> 2], e0(e, 33155, n + 16 | 0), i[n >> 2] = i[f + 16856 >> 2], e0(e, 33006, n), l[f + 16817 | 0]) {
                                                                                u = f + 16820 | 0, k = m - 144 | 0, m = k, e = 55188;
                                                                                o: switch(s - 1 | 0){
                                                                                    case 1:
                                                                                        e = 55184;
                                                                                    case 0:
                                                                                        e = i[e >> 2], e0(e, 34327, 0), i[k + 128 >> 2] = l[u | 0], e0(e, 30120, k + 128 | 0), i[k + 112 >> 2] = l[u + 1 | 0], e0(e, 30358, k + 112 | 0), i[k + 96 >> 2] = l[u + 2 | 0], e0(e, 32760, k + 96 | 0), i[k + 80 >> 2] = l[u + 3 | 0], e0(e, 32714, k + 80 | 0), i[k + 64 >> 2] = l[u + 4 | 0], e0(e, 30883, k - -64 | 0), i[k + 48 >> 2] = l[u + 5 | 0], e0(e, 32290, k + 48 | 0), i[k + 32 >> 2] = l[u + 6 | 0], e0(e, 30450, k + 32 | 0), i[k + 16 >> 2] = l[u + 7 | 0], e0(e, 28437, k + 16 | 0), i[k >> 2] = l[u + 8 | 0], e0(e, 30404, k);
                                                                                        break;
                                                                                    default:
                                                                                        break o;
                                                                                }
                                                                                m = k + 144 | 0;
                                                                            }
                                                                            if (!l[f + 8998 | 0]) break t;
                                                                            u = f + 9e3 | 0, k = m - 576 | 0, m = k, e = 55188;
                                                                            o: {
                                                                                s: switch(s - 1 | 0){
                                                                                    case 1:
                                                                                        e = 55184;
                                                                                        break;
                                                                                    case 0:
                                                                                        break s;
                                                                                    default:
                                                                                        break o;
                                                                                }
                                                                                if (e = i[e >> 2], e0(e, 34507, 0), t = I[u + 2 >> 1], i[k + 564 >> 2] = I[u + 4 >> 1], i[k + 560 >> 2] = t, e0(e, 25885, k + 560 | 0), i[k + 544 >> 2] = l[u + 6 | 0], e0(e, 27426, k + 544 | 0), i[k + 528 >> 2] = l[u + 7 | 0], e0(e, 29258, k + 528 | 0), i[k + 512 >> 2] = l[u + 8 | 0], e0(e, 26590, k + 512 | 0), l[u + 8 | 0] == 1 && (t = i[u + 12 >> 2], t >>> 0 <= 4 ? s = i[(t << 2) + 51528 >> 2] : s = 14014, i[k + 496 >> 2] = s, e0(e, 25448, k + 496 | 0), i[k + 480 >> 2] = l[u + 16 | 0], e0(e, 31280, k + 480 | 0), i[k + 464 >> 2] = l[u + 17 | 0], e0(e, 27589, k + 464 | 0), i[k + 448 >> 2] = l[u + 18 | 0], e0(e, 32452, k + 448 | 0), i[k + 432 >> 2] = l[u + 19 | 0], e0(e, 29900, k + 432 | 0), i[k + 416 >> 2] = l[u + 20 | 0], e0(e, 33036, k + 416 | 0)), i[k + 400 >> 2] = l[u + 21 | 0], e0(e, 26475, k + 400 | 0), l[u + 21 | 0] == 1 && (i[k + 384 >> 2] = l[u + 22 | 0], e0(e, 29565, k + 384 | 0), i[k + 368 >> 2] = l[u + 23 | 0], e0(e, 27e3, k + 368 | 0)), i[k + 352 >> 2] = l[u + 24 | 0], e0(e, 26706, k + 352 | 0), i[k + 336 >> 2] = l[u + 25 | 0], e0(e, 33298, k + 336 | 0), i[k + 320 >> 2] = l[u + 26 | 0], e0(e, 27553, k + 320 | 0), i[k + 304 >> 2] = l[u + 27 | 0], e0(e, 29458, k + 304 | 0), i[k + 288 >> 2] = i[u + 28 >> 2], e0(e, 29743, k + 288 | 0), i[k + 272 >> 2] = i[u + 32 >> 2], e0(e, 29394, k + 272 | 0), i[k + 256 >> 2] = i[u + 36 >> 2], e0(e, 30254, k + 256 | 0), i[k + 240 >> 2] = i[u + 40 >> 2], e0(e, 29128, k + 240 | 0), i[k + 224 >> 2] = l[u + 44 | 0], e0(e, 29222, k + 224 | 0), l[u + 44 | 0] == 1 && (i[k + 208 >> 2] = i[u + 48 >> 2], e0(e, 31203, k + 208 | 0), i[k + 192 >> 2] = i[u + 52 >> 2], e0(e, 32881, k + 192 | 0)), i[k + 176 >> 2] = l[u + 56 | 0], e0(e, 27875, k + 176 | 0), i[k + 160 >> 2] = i[u + 60 >> 2], e0(e, 32098, k + 160 | 0), i[k + 144 >> 2] = l[u + 64 | 0], e0(e, 27350, k + 144 | 0), i[k + 128 >> 2] = l[u + 7804 | 0], e0(e, 31759, k + 128 | 0), l[u + 7804 | 0] != 1) break o;
                                                                                i[k + 112 >> 2] = l[u + 7805 | 0], e0(e, 31239, k + 112 | 0), i[k + 96 >> 2] = l[u + 7806 | 0], e0(e, 27720, k + 96 | 0), i[k + 80 >> 2] = l[u + 7807 | 0], e0(e, 30079, k + 80 | 0), i[k + 64 >> 2] = I[u + 7808 >> 1], e0(e, 30525, k - -64 | 0), i[k + 48 >> 2] = l[u + 7810 | 0], e0(e, 31894, k + 48 | 0), i[k + 32 >> 2] = l[u + 7811 | 0], e0(e, 31382, k + 32 | 0), i[k + 16 >> 2] = l[u + 7812 | 0], e0(e, 29936, k + 16 | 0), i[k >> 2] = l[u + 7813 | 0], e0(e, 30688, k);
                                                                            }
                                                                            m = k + 576 | 0;
                                                                        }
                                                                        m = n + 928 | 0;
                                                                    }
                                                                    i[B + 4 >> 2] = i[B + 4 >> 2] + 1, n = (i[B + 484 >> 2] << 3) + A | 0, i[n + 728 >> 2] = f, e = i[n + 732 >> 2], i[n + 732 >> 2] = B;
                                                                    t: {
                                                                        if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break t;
                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                    }
                                                                    for(n = 856, t = A + 856 | 0;;){
                                                                        e = i[t >> 2];
                                                                        t: {
                                                                            if (!e | i[B + 484 >> 2] != o[e + 13 | 0] || (e = i[t + 4 >> 2], i[t >> 2] = 0, i[t + 4 >> 2] = 0, !e) || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break t;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        if (n = n + 8 | 0, t = n + A | 0, (n | 0) == 1368) break;
                                                                    }
                                                                    n = 0;
                                                                }
                                                                e = i[B + 4 >> 2], i[B + 4 >> 2] = e - 1, e || (p[i[i[B >> 2] + 8 >> 2]](B), g(B)), w4(A + 548 | 0, W);
                                                                break k;
                                                            case 2:
                                                                f = A, A = S + 8 | 0, w = D(8520), i[w >> 2] = 49192, i[w + 4 >> 2] = 0, i[w + 8 >> 2] = 0, n = 1006, t = w + 12 | 0, o[t + 8263 | 0] = 0, o[t + 8264 | 0] = 0, o[t + 8246 | 0] = 2, o[t + 8247 | 0] = 0, o[t + 8248 | 0] = 0, o[t + 8249 | 0] = 0, o[t + 8250 | 0] = 0, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, o[t | 0] = 0, i[t + 8448 >> 2] = 0, i[t + 8452 >> 2] = 0, o[t + 26 | 0] = 0, Q[t + 24 >> 1] = 0, i[t + 20 >> 2] = 27, o[t + 17 | 0] = 1, o[t + 18 | 0] = 1, o[t + 9 | 0] = 0, o[t + 10 | 0] = 0, o[t + 11 | 0] = 0, o[t + 12 | 0] = 0, o[t + 13 | 0] = 0, o[t + 14 | 0] = 0, o[t + 15 | 0] = 0, o[t + 16 | 0] = 0, e = t + 8456 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, e = t + 8464 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, k = t + 8472 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, k = t + 8480 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, k = t + 8488 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, s = t + 8496 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, i[t + 8504 >> 2] = 0, o[t + 43 | 0] = 0, o[t + 44 | 0] = 0, o[t + 45 | 0] = 0, o[t + 46 | 0] = 0, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, Q[t + 56 >> 1] = 257, i[t + 48 >> 2] = 1, i[t + 52 >> 2] = 1, o[t + 58 | 0] = 1, B0(t + 8280 | 0, 0, 168), i[k >> 2] = 0, i[e >> 2] = 0, i[t + 8268 >> 2] = 0, o[t + 8233 | 0] = 0, o[t + 61 | 0] = 0, o[t + 59 | 0] = 0, o[t + 60 | 0] = 0, i[t + 64 >> 2] = 0, i[t + 68 >> 2] = 0, o[t + 72 | 0] = 0, i[t + 8236 >> 2] = 2, i[t + 8240 >> 2] = 0, Q[t + 8244 >> 1] = 0, o[t | 0] = 0, e = i[t + 8 >> 2], i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0;
                                                                t: {
                                                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break t;
                                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                }
                                                                i[t + 12 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, o[t + 26 | 0] = 0, Q[t + 24 >> 1] = 0, i[t + 20 >> 2] = 27, o[t + 18 | 0] = 1, o[t + 58 | 0] = 1, Q[t + 56 >> 1] = 257, i[t + 48 >> 2] = 1, i[t + 52 >> 2] = 1, Q[t + 16 >> 1] = 256, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, o[t + 43 | 0] = 0, o[t + 44 | 0] = 0, o[t + 45 | 0] = 0, o[t + 46 | 0] = 0, B = B0(t + 8280 | 0, 0, 168), i[t + 8268 >> 2] = 0, o[t + 8233 | 0] = 0, o[t + 61 | 0] = 0, o[t + 59 | 0] = 0, o[t + 60 | 0] = 0, i[t + 64 >> 2] = 0, i[t + 68 >> 2] = 0, o[t + 72 | 0] = 0, i[t + 8236 >> 2] = 2, i[t + 8240 >> 2] = 0, Q[t + 8244 >> 1] = 0, i[t + 8452 >> 2] = i[t + 8448 >> 2], i[t + 8464 >> 2] = i[t + 8460 >> 2], i[t + 8476 >> 2] = i[t + 8472 >> 2], i[t + 8488 >> 2] = i[t + 8484 >> 2], i[t + 8500 >> 2] = i[t + 8496 >> 2], e = q0(A), o[t + 12 | 0] = e;
                                                                t: {
                                                                    if (!((e | 0) != -99999 & (e | 0) <= 63)) {
                                                                        W2(f + 4 | 0, 1009, 0);
                                                                        break t;
                                                                    }
                                                                    e = q0(A), o[t + 13 | 0] = e;
                                                                    o: {
                                                                        s: {
                                                                            if (!((e | 0) != -99999 & (e | 0) <= 15)) break s;
                                                                            if (L = t, q = l0(A, 1), o[L + 14 | 0] = q, L = t, q = l0(A, 1), o[L + 43 | 0] = q, L = t, q = l0(A, 3), o[L + 8240 | 0] = q, L = t, q = l0(A, 1), o[L + 15 | 0] = q, L = t, q = l0(A, 1), o[L + 16 | 0] = q, e = q0(A), o[t + 17 | 0] = e, (e | 0) == -99999 || (o[t + 17 | 0] = e + 1, e = q0(A), o[t + 18 | 0] = e, (e | 0) == -99999)) break o;
                                                                            if (o[t + 18 | 0] = e + 1, e = f + (o[t + 13 | 0] << 3) | 0, s = i[e + 728 >> 2], !s) break s;
                                                                            k = i[e + 732 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[t + 4 >> 2] = s, e = i[t + 8 >> 2], i[t + 8 >> 2] = k;
                                                                            u: {
                                                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break u;
                                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                            }
                                                                            if (e = m1(A), i[t + 20 >> 2] = e, (e | 0) == -99999) break o;
                                                                            i[t + 20 >> 2] = e + 26, L = t, q = l0(A, 1), o[L + 24 | 0] = q, L = t, q = l0(A, 1), o[L + 25 | 0] = q, e = l0(A, 1), o[t + 26 | 0] = e;
                                                                            u: {
                                                                                if (e & 255) {
                                                                                    if (e = q0(A), i[t + 28 >> 2] = e, (e | 0) != -99999) break u;
                                                                                    break o;
                                                                                }
                                                                                i[t + 28 >> 2] = 0;
                                                                            }
                                                                            if (e = m1(A), i[t + 32 >> 2] = e, (e | 0) == -99999 || (e = m1(A), i[t + 36 >> 2] = e, (e | 0) == -99999)) break o;
                                                                            L = t, q = l0(A, 1), o[L + 40 | 0] = q, L = t, q = l0(A, 1), o[L + 41 | 0] = q, L = t, q = l0(A, 1), o[L + 42 | 0] = q, L = t, q = l0(A, 1), o[L + 44 | 0] = q, L = t, q = l0(A, 1), o[L + 46 | 0] = q, L = t, q = l0(A, 1), o[L + 45 | 0] = q;
                                                                            u: {
                                                                                w: {
                                                                                    if (l[t + 46 | 0]) {
                                                                                        if (e = q0(A), i[t + 48 >> 2] = e, !((e | 0) != -99999 & (e | 0) < 10) || (i[t + 48 >> 2] = e + 1, e = q0(A), i[t + 52 >> 2] = e, !((e | 0) != -99999 & (e | 0) < 10))) break o;
                                                                                        if (i[t + 52 >> 2] = e + 1, e = l0(A, 1), o[t + 56 | 0] = e, !(e & 255)) {
                                                                                            if (e = i[t + 4 >> 2], s = i[e + 16900 >> 2], k = i[e + 16892 >> 2], h = i[t + 48 >> 2], (h | 0) >= 2) for(e = 0;;){
                                                                                                if (h = B + (e << 2) | 0, u = q0(A), i[h >> 2] = u, (u | 0) == -99999) break o;
                                                                                                if (u = u + 1 | 0, i[h >> 2] = u, k = k - u | 0, e = e + 1 | 0, h = i[t + 48 >> 2], !((e | 0) < (h - 1 | 0))) break;
                                                                                            }
                                                                                            if (u = 0, (k | 0) <= 0) break u;
                                                                                            if (i[(B + (h << 2) | 0) - 4 >> 2] = k, k = i[t + 52 >> 2], (k | 0) >= 2) for(B = t + 8320 | 0, e = 0;;){
                                                                                                if (h = B + (e << 2) | 0, k = q0(A), i[h >> 2] = k, (k | 0) == -99999) break o;
                                                                                                if (k = k + 1 | 0, i[h >> 2] = k, s = s - k | 0, e = e + 1 | 0, k = i[t + 52 >> 2], !((e | 0) < (k - 1 | 0))) break;
                                                                                            }
                                                                                            if ((s | 0) <= 0) break u;
                                                                                            i[(t + (k << 2) | 0) + 8316 >> 2] = s;
                                                                                        }
                                                                                        e = l0(A, 1);
                                                                                        break w;
                                                                                    }
                                                                                    o[t + 56 | 0] = 1, i[t + 48 >> 2] = 1, i[t + 52 >> 2] = 1, e = 0;
                                                                                }
                                                                                i[t + 64 >> 2] = 0, i[t + 68 >> 2] = 0, o[t + 57 | 0] = e, L = t, q = l0(A, 1), o[L + 58 | 0] = q, e = l0(A, 1), o[t + 59 | 0] = e;
                                                                                w: {
                                                                                    if (e & 255) {
                                                                                        if (L = t, q = l0(A, 1), o[L + 60 | 0] = q, e = l0(A, 1), o[t + 61 | 0] = e, e & 255) break w;
                                                                                        if (e = m1(A), i[t - -64 >> 2] = e, (e | 0) == -99999 || (i[t + 64 >> 2] = e << 1, e = m1(A), i[t + 68 >> 2] = e, (e | 0) == -99999)) break o;
                                                                                        i[t + 68 >> 2] = e << 1;
                                                                                        break w;
                                                                                    }
                                                                                    Q[t + 60 >> 1] = 0;
                                                                                }
                                                                                if (k = l0(A, 1), o[t + 72 | 0] = k, e = i[t + 4 >> 2], s = k & 255, !(l[e + 636 | 0] | !s)) break o;
                                                                                k = t + 73 | 0;
                                                                                w: {
                                                                                    if (s) {
                                                                                        if (e = T7(A, k), !e) break w;
                                                                                        W2(f + 4 | 0, e, 0);
                                                                                        break t;
                                                                                    }
                                                                                    v0(k, e + 638 | 0, 8160);
                                                                                }
                                                                                if (L = t, q = l0(A, 1), o[L + 8233 | 0] = q, e = q0(A), i[t + 8236 >> 2] = e, (e | 0) == -99999) break o;
                                                                                if (i[t + 8236 >> 2] = e + 2, k = i[t + 4 >> 2], (e | 0) > ((i[k + 612 >> 2] + i[k + 616 >> 2] | 0) - 2 | 0)) break u;
                                                                                L = t, q = l0(A, 1), o[L + 8241 | 0] = q, e = l0(A, 1), o[t + 8242 | 0] = e;
                                                                                w: {
                                                                                    if (!(e & 255) || (L = t, q = l0(A, 1), o[L + 8243 | 0] = q, L = t, q = l0(A, 1), o[L + 8244 | 0] = q, L = t, q = l0(A, 6), o[L + 8245 | 0] = q, !l[t + 8243 | 0])) break w;
                                                                                    e = t + 8246 | 0, s = i[(f + (o[t + 13 | 0] << 3) | 0) + 728 >> 2], l[t + 25 | 0] && (L = e, q = q0(A) + 2 | 0, o[L | 0] = q), k = l0(A, 1), o[e + 1 | 0] = (k | 0) != 0, !k | i[s + 16848 >> 2] == 3 || W2(f + 4 | 0, 1006, 0), k = l0(A, 1), o[e + 2 | 0] = (k | 0) != 0;
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                _: {
                                                                                                    if (!(i[s + 16848 >> 2] | !k)) {
                                                                                                        if (W2(f + 4 | 0, 1006, 0), o[e + 2 | 0] & 1) break _;
                                                                                                        break v;
                                                                                                    }
                                                                                                    if (!k) break v;
                                                                                                }
                                                                                                if (k = q0(A), !((k | 0) != -99999 & (k | 0) <= i[s + 616 >> 2]) || (o[e + 3 | 0] = k, k = q0(A), !((k | 0) != -99999 & (k | 0) < 6))) break h;
                                                                                                if (k = (k & 255) + 1 | 0, o[e + 4 | 0] = k, (k | 0) != (k & 255)) break v;
                                                                                                for(B = e + 11 | 0, h = e + 5 | 0, k = 0;;){
                                                                                                    if (v = m1(A), v - 13 >>> 0 <= 4294967270 || (o[k + h | 0] = v, v = m1(A), v - 13 >>> 0 <= 4294967270)) break h;
                                                                                                    if (o[k + B | 0] = v, k = k + 1 | 0, !(k >>> 0 < l[e + 4 | 0])) break;
                                                                                                }
                                                                                            }
                                                                                            v: {
                                                                                                if (k = q0(A), (k | 0) != -99999 && (B = i[s + 16832 >> 2], (k | 0) <= (((B | 0) >= 10 ? B - 10 | 0 : 0) | 0))) break v;
                                                                                                break h;
                                                                                            }
                                                                                            o[e + 17 | 0] = k;
                                                                                            v: {
                                                                                                if (A = q0(A), (A | 0) != -99999 && (k = i[s + 16840 >> 2], (A | 0) <= (((k | 0) >= 10 ? k - 10 | 0 : 0) | 0))) break v;
                                                                                                break h;
                                                                                            }
                                                                                            o[e + 18 | 0] = A, A = 1;
                                                                                            break l;
                                                                                        }
                                                                                        W2(f + 4 | 0, 1006, 0), A = 0;
                                                                                    }
                                                                                    if (!A) break u;
                                                                                }
                                                                                s = 0, e = m, r0 = e, B = i[t + 4 >> 2], A = i[B + 16876 >> 2], i[t + 8276 >> 2] = l[t + 8246 | 0], i[t + 8268 >> 2] = A - i[t + 28 >> 2], i[t + 8272 >> 2] = A - l[t + 8249 | 0], k = i[t + 48 >> 2];
                                                                                w: {
                                                                                    if (!l[t + 56 | 0]) break w;
                                                                                    v = e - ((k << 2) + 19 & -16) | 0, m = v;
                                                                                    l: {
                                                                                        if ((k | 0) < 0) break l;
                                                                                        if (A = i[B + 16892 >> 2], k) for(u = k + 1 & -2, e = 0; i[v + (s << 2) >> 2] = (Z(A, s) | 0) / (k | 0), h = s | 1, i[v + (h << 2) >> 2] = (Z(A, h) | 0) / (k | 0), s = s + 2 | 0, e = e + 2 | 0, (u | 0) != (e | 0););
                                                                                        k & 1 || (i[v + (s << 2) >> 2] = (Z(A, s) | 0) / (k | 0)), G = k & 3, _ = t + 8280 | 0, e = i[v >> 2], h = 0;
                                                                                        h: {
                                                                                            if (k - 1 >>> 0 < 3) {
                                                                                                s = 0;
                                                                                                break h;
                                                                                            }
                                                                                            for(C = k & 2147483644, s = 0, u = 0; A = s << 2, V = A | 4, y = i[V + v >> 2], i[A + _ >> 2] = y - e, P = _ + V | 0, e = A | 8, V = i[e + v >> 2], i[P >> 2] = V - y, A = A | 12, y = i[A + v >> 2], i[e + _ >> 2] = y - V, s = s + 4 | 0, e = i[v + (s << 2) >> 2], i[A + _ >> 2] = e - y, u = u + 4 | 0, (C | 0) != (u | 0););
                                                                                        }
                                                                                        if (!G) break l;
                                                                                        for(; u = _ + (s << 2) | 0, s = s + 1 | 0, A = i[v + (s << 2) >> 2], i[u >> 2] = A - e, e = A, h = h + 1 | 0, (G | 0) != (h | 0););
                                                                                    }
                                                                                    if (s = 0, A = i[t + 52 >> 2], v = v - ((A << 2) + 19 & -16) | 0, m = v, (A | 0) < 0) break w;
                                                                                    if (u = i[B + 16900 >> 2], A) for(h = A + 1 & -2, e = 0; i[v + (s << 2) >> 2] = (Z(u, s) | 0) / (A | 0), _ = s | 1, i[v + (_ << 2) >> 2] = (Z(u, _) | 0) / (A | 0), s = s + 2 | 0, e = e + 2 | 0, (h | 0) != (e | 0););
                                                                                    A & 1 || (i[v + (s << 2) >> 2] = (Z(u, s) | 0) / (A | 0)), G = A & 3, _ = t + 8320 | 0, e = i[v >> 2], h = 0;
                                                                                    l: {
                                                                                        if (A - 1 >>> 0 < 3) {
                                                                                            s = 0;
                                                                                            break l;
                                                                                        }
                                                                                        for(C = A & 2147483644, s = 0, u = 0; A = s << 2, V = A | 4, y = i[V + v >> 2], i[A + _ >> 2] = y - e, P = _ + V | 0, e = A | 8, V = i[e + v >> 2], i[P >> 2] = V - y, A = A | 12, y = i[A + v >> 2], i[e + _ >> 2] = y - V, s = s + 4 | 0, e = i[v + (s << 2) >> 2], i[A + _ >> 2] = e - y, u = u + 4 | 0, (C | 0) != (u | 0););
                                                                                    }
                                                                                    if (!G) break w;
                                                                                    for(; u = _ + (s << 2) | 0, s = s + 1 | 0, A = i[v + (s << 2) >> 2], i[u >> 2] = A - e, e = A, h = h + 1 | 0, (G | 0) != (h | 0););
                                                                                }
                                                                                if (i[t + 8360 >> 2] = 0, v = t + 8360 | 0, (k | 0) > 0) for(u = t + 8280 | 0, k = 0, A = 0; e = A + 1 | 0, k = i[u + (A << 2) >> 2] + k | 0, i[v + (e << 2) >> 2] = k, A = e, (e | 0) < i[t + 48 >> 2];);
                                                                                if (i[t + 8404 >> 2] = 0, _ = t + 8404 | 0, i[t + 52 >> 2] > 0) for(u = t + 8320 | 0, k = 0, A = 0; e = A + 1 | 0, k = i[u + (A << 2) >> 2] + k | 0, i[_ + (e << 2) >> 2] = k, A = e, (e | 0) < i[t + 52 >> 2];);
                                                                                P = t + 8448 | 0, A = i[B + 16908 >> 2], k = i[t + 8448 >> 2], e = i[t + 8452 >> 2] - k >> 2;
                                                                                w: {
                                                                                    if (A >>> 0 > e >>> 0) {
                                                                                        d4(P, A - e | 0), A = i[B + 16908 >> 2];
                                                                                        break w;
                                                                                    }
                                                                                    if (A >>> 0 >= e >>> 0) break w;
                                                                                    i[t + 8452 >> 2] = k + (A << 2);
                                                                                }
                                                                                k = i[t + 8460 >> 2], e = i[t + 8464 >> 2] - k >> 2;
                                                                                w: {
                                                                                    if (e >>> 0 < A >>> 0) {
                                                                                        d4(t + 8460 | 0, A - e | 0), A = i[B + 16908 >> 2];
                                                                                        break w;
                                                                                    }
                                                                                    if (A >>> 0 >= e >>> 0) break w;
                                                                                    i[t + 8464 >> 2] = k + (A << 2);
                                                                                }
                                                                                R = t + 8472 | 0, k = i[t + 8472 >> 2], e = i[t + 8476 >> 2] - k >> 2;
                                                                                w: {
                                                                                    if (e >>> 0 < A >>> 0) {
                                                                                        d4(R, A - e | 0), A = i[B + 16908 >> 2];
                                                                                        break w;
                                                                                    }
                                                                                    if (A >>> 0 >= e >>> 0) break w;
                                                                                    i[t + 8476 >> 2] = k + (A << 2);
                                                                                }
                                                                                F = t + 8484 | 0, k = i[t + 8484 >> 2], e = i[t + 8488 >> 2] - k >> 2;
                                                                                w: {
                                                                                    if (e >>> 0 < A >>> 0) {
                                                                                        d4(F, A - e | 0);
                                                                                        break w;
                                                                                    }
                                                                                    if (A >>> 0 >= e >>> 0) break w;
                                                                                    i[t + 8488 >> 2] = k + (A << 2);
                                                                                }
                                                                                T = t + 8496 | 0, A = i[B + 16932 >> 2], k = i[t + 8496 >> 2], e = i[t + 8500 >> 2] - k >> 2;
                                                                                w: {
                                                                                    if (A >>> 0 > e >>> 0) {
                                                                                        d4(T, A - e | 0);
                                                                                        break w;
                                                                                    }
                                                                                    if (A >>> 0 >= e >>> 0) break w;
                                                                                    i[t + 8500 >> 2] = k + (A << 2);
                                                                                }
                                                                                if (i[B + 16908 >> 2] > 0) for(M = t + 8280 | 0, E = t + 8320 | 0, f0 = i[t + 8460 >> 2], s0 = i[t + 8448 >> 2], e = 0;;){
                                                                                    A = i[B + 16892 >> 2], y = (e | 0) / (A | 0) | 0, C = e - Z(A, y) | 0, h = -1, u = i[t + 48 >> 2];
                                                                                    w: {
                                                                                        if ((u | 0) <= 0) break w;
                                                                                        if (s = 0, A = 0, u >>> 0 >= 4) for(G = u & 2147483644, k = 0; V = (C | 0) < i[v + (A << 2) >> 2] ? h : A, h = A | 1, V = (C | 0) < i[v + (h << 2) >> 2] ? V : h, h = A | 2, V = (C | 0) < i[v + (h << 2) >> 2] ? V : h, h = A | 3, h = (C | 0) < i[v + (h << 2) >> 2] ? V : h, A = A + 4 | 0, k = k + 4 | 0, (G | 0) != (k | 0););
                                                                                        if (k = u & 3, !k) break w;
                                                                                        for(; h = (C | 0) < i[v + (A << 2) >> 2] ? h : A, A = A + 1 | 0, s = s + 1 | 0, (k | 0) != (s | 0););
                                                                                    }
                                                                                    G = i[t + 52 >> 2];
                                                                                    w: {
                                                                                        if ((G | 0) <= 0) {
                                                                                            u = -1;
                                                                                            break w;
                                                                                        }
                                                                                        if (u = -1, s = 0, A = 0, G >>> 0 >= 4) for(V = G & 2147483644, k = 0; H = (y | 0) < i[_ + (A << 2) >> 2] ? u : A, u = A | 1, H = (y | 0) < i[_ + (u << 2) >> 2] ? H : u, u = A | 2, H = (y | 0) < i[_ + (u << 2) >> 2] ? H : u, u = A | 3, u = (y | 0) < i[_ + (u << 2) >> 2] ? H : u, A = A + 4 | 0, k = k + 4 | 0, (V | 0) != (k | 0););
                                                                                        if (k = G & 3, !k) break w;
                                                                                        for(; u = (y | 0) < i[_ + (A << 2) >> 2] ? u : A, A = A + 1 | 0, s = s + 1 | 0, (k | 0) != (s | 0););
                                                                                    }
                                                                                    s = 0, A = (e << 2) + s0 | 0, i[A >> 2] = 0;
                                                                                    w: {
                                                                                        if ((h | 0) <= 0) break w;
                                                                                        if (V = E + (u << 2) | 0, G = 0, k = 0, h >>> 0 >= 4) for(t0 = h & 2147483644, $ = 0; H = s, s = M + (k << 2) | 0, H = H + Z(i[s >> 2], i[V >> 2]) | 0, i[A >> 2] = H, H = H + Z(i[s + 4 >> 2], i[V >> 2]) | 0, i[A >> 2] = H, H = H + Z(i[s + 8 >> 2], i[V >> 2]) | 0, i[A >> 2] = H, s = H + Z(i[s + 12 >> 2], i[V >> 2]) | 0, i[A >> 2] = s, k = k + 4 | 0, $ = $ + 4 | 0, (t0 | 0) != ($ | 0););
                                                                                        if ($ = h & 3, !$) break w;
                                                                                        for(; s = Z(i[M + (k << 2) >> 2], i[V >> 2]) + s | 0, i[A >> 2] = s, k = k + 1 | 0, G = G + 1 | 0, ($ | 0) != (G | 0););
                                                                                    }
                                                                                    w: {
                                                                                        if ((u | 0) <= 0) break w;
                                                                                        $ = u & 3, V = 0;
                                                                                        l: {
                                                                                            if (u >>> 0 < 4) {
                                                                                                k = 0;
                                                                                                break l;
                                                                                            }
                                                                                            for(t0 = u & 2147483644, k = 0, G = 0; H = s, s = E + (k << 2) | 0, H = H + Z(i[s >> 2], i[B + 16892 >> 2]) | 0, i[A >> 2] = H, H = H + Z(i[s + 4 >> 2], i[B + 16892 >> 2]) | 0, i[A >> 2] = H, H = H + Z(i[s + 8 >> 2], i[B + 16892 >> 2]) | 0, i[A >> 2] = H, s = H + Z(i[s + 12 >> 2], i[B + 16892 >> 2]) | 0, i[A >> 2] = s, k = k + 4 | 0, G = G + 4 | 0, (t0 | 0) != (G | 0););
                                                                                        }
                                                                                        if (!$) break w;
                                                                                        for(; s = Z(i[E + (k << 2) >> 2], i[B + 16892 >> 2]) + s | 0, i[A >> 2] = s, k = k + 1 | 0, V = V + 1 | 0, ($ | 0) != (V | 0););
                                                                                    }
                                                                                    if ((u | h) < 0 && (y0(18261, 14948, 620, 4467), z()), k = h << 2, u = Z(i[k + M >> 2], y - i[_ + (u << 2) >> 2] | 0) + s | 0, i[A >> 2] = u, s = A, A = u + (C - i[k + v >> 2] | 0) | 0, i[s >> 2] = A, i[(A << 2) + f0 >> 2] = e, e = e + 1 | 0, !((e | 0) < i[B + 16908 >> 2])) break;
                                                                                }
                                                                                s = i[t + 52 >> 2];
                                                                                w: {
                                                                                    if ((s | 0) <= 0 || (k = 0, A = i[t + 48 >> 2], (A | 0) <= 0)) break w;
                                                                                    for(h = 0;;){
                                                                                        l: {
                                                                                            if ((A | 0) <= 0) {
                                                                                                h = h + 1 | 0;
                                                                                                break l;
                                                                                            }
                                                                                            if (u = 0, G = _ + (h << 2) | 0, h = h + 1 | 0, C = _ + (h << 2) | 0, V = i[C >> 2], (V | 0) <= i[G >> 2]) {
                                                                                                k = ((A | 0) <= 1 ? 1 : A) + k | 0;
                                                                                                break l;
                                                                                            }
                                                                                            for(;;){
                                                                                                s = i[G >> 2];
                                                                                                h: {
                                                                                                    if ((V | 0) <= (s | 0)) {
                                                                                                        u = u + 1 | 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (y = v + (u << 2) | 0, u = u + 1 | 0, M = v + (u << 2) | 0, e = i[M >> 2], (e | 0) <= i[y >> 2]) break h;
                                                                                                    for(E = i[F >> 2], $ = i[R >> 2], f0 = i[P >> 2];;){
                                                                                                        if (A = i[y >> 2], (e | 0) > (A | 0)) {
                                                                                                            for(; e = A << 2, i[$ + (i[e + (f0 + (Z(i[B + 16892 >> 2], s) << 2) | 0) >> 2] << 2) >> 2] = k, i[e + (E + (Z(i[B + 16892 >> 2], s) << 2) | 0) >> 2] = k, A = A + 1 | 0, e = i[M >> 2], (A | 0) < (e | 0););
                                                                                                            V = i[C >> 2];
                                                                                                        }
                                                                                                        if (s = s + 1 | 0, !((V | 0) > (s | 0))) break;
                                                                                                    }
                                                                                                    A = i[t + 48 >> 2];
                                                                                                }
                                                                                                if (k = k + 1 | 0, !((A | 0) > (u | 0))) break;
                                                                                            }
                                                                                            s = i[t + 52 >> 2];
                                                                                        }
                                                                                        if (!((s | 0) > (h | 0))) break;
                                                                                    }
                                                                                }
                                                                                s = i[B + 16928 >> 2];
                                                                                w: {
                                                                                    if ((s | 0) <= 0 || (k = 0, A = i[B + 16924 >> 2], (A | 0) <= 0)) break w;
                                                                                    for(_ = i[T >> 2], G = i[P >> 2];;){
                                                                                        if (e = 0, (A | 0) > 0) {
                                                                                            for(;;){
                                                                                                y = _ + (e << 2) | 0, s = y + (Z(A, k) << 2) | 0, A = i[B + 16936 >> 2], u = i[B + 16876 >> 2], i[s >> 2] = i[(G + (Z(i[B + 16892 >> 2], k << A >> u) << 2) | 0) + (e << A >> u << 2) >> 2] << (u - A << 1), u = i[B + 16876 >> 2], h = i[B + 16936 >> 2], v = u - h | 0;
                                                                                                l: {
                                                                                                    if ((v | 0) <= 0) {
                                                                                                        s = 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    if (A = 0, s = 0, (u | 0) != (h + 1 | 0)) for(C = v & 2147483646, h = 0; V = A | 1, u = 2 << A, P = s, s = 1 << A, s = ((u & k ? 4 << A << V : 0) + ((P + (s & k ? u << A : 0) | 0) + (e & s ? s << A : 0) | 0) | 0) + (e & u ? u << V : 0) | 0, A = A + 2 | 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                                                                                    if (!(v & 1)) break l;
                                                                                                    u = 1 << A, s = ((u & k ? 2 << A << A : 0) + s | 0) + (e & u ? u << A : 0) | 0;
                                                                                                }
                                                                                                if (A = y + (Z(i[B + 16924 >> 2], k) << 2) | 0, i[A >> 2] = i[A >> 2] + s, A = i[B + 16924 >> 2], e = e + 1 | 0, !((A | 0) > (e | 0))) break;
                                                                                            }
                                                                                            s = i[B + 16928 >> 2];
                                                                                        }
                                                                                        if (k = k + 1 | 0, !((k | 0) < (s | 0))) break;
                                                                                    }
                                                                                }
                                                                                m = r0, o[t | 0] = 1, u = 1;
                                                                            }
                                                                            break t;
                                                                        }
                                                                        W2(f + 4 | 0, 1010, 0);
                                                                        break t;
                                                                    }
                                                                    W2(f + 4 | 0, 1006, 0), u = 0;
                                                                }
                                                                t: {
                                                                    if (!u) break t;
                                                                    if (n = 0, B = i[f + 524 >> 2], (B | 0) >= 0) {
                                                                        s = 0, A = m - 720 | 0, m = A, e = 55188;
                                                                        o: {
                                                                            s: switch(B - 1 | 0){
                                                                                case 1:
                                                                                    e = 55184;
                                                                                    break;
                                                                                case 0:
                                                                                    break s;
                                                                                default:
                                                                                    break o;
                                                                            }
                                                                            if (e = i[e >> 2], e0(e, 34466, 0), i[A + 704 >> 2] = o[t + 12 | 0], e0(e, 31349, A + 704 | 0), i[A + 688 >> 2] = o[t + 13 | 0], e0(e, 31316, A + 688 | 0), i[A + 672 >> 2] = o[t + 14 | 0], e0(e, 28214, A + 672 | 0), i[A + 656 >> 2] = o[t + 15 | 0], e0(e, 30929, A + 656 | 0), i[A + 640 >> 2] = o[t + 16 | 0], e0(e, 30010, A + 640 | 0), i[A + 624 >> 2] = o[t + 17 | 0], e0(e, 28742, A + 624 | 0), i[A + 608 >> 2] = o[t + 18 | 0], e0(e, 28706, A + 608 | 0), i[A + 592 >> 2] = i[t + 20 >> 2], e0(e, 33228, A + 592 | 0), i[A + 576 >> 2] = o[t + 24 | 0], e0(e, 26803, A + 576 | 0), i[A + 560 >> 2] = o[t + 25 | 0], e0(e, 26884, A + 560 | 0), i[A + 544 >> 2] = o[t + 26 | 0], e0(e, 29494, A + 544 | 0), l[t + 26 | 0] && (i[A + 528 >> 2] = i[t + 28 >> 2], e0(e, 30290, A + 528 | 0)), i[A + 512 >> 2] = i[t + 32 >> 2], e0(e, 32679, A + 512 | 0), i[A + 496 >> 2] = i[t + 36 >> 2], e0(e, 32644, A + 496 | 0), i[A + 480 >> 2] = o[t + 40 | 0], e0(e, 27303, A + 480 | 0), i[A + 464 >> 2] = o[t + 41 | 0], e0(e, 32255, A + 464 | 0), i[A + 448 >> 2] = o[t + 42 | 0], e0(e, 31800, A + 448 | 0), i[A + 432 >> 2] = o[t + 43 | 0], e0(e, 30323, A + 432 | 0), i[A + 416 >> 2] = o[t + 44 | 0], e0(e, 26768, A + 416 | 0), i[A + 400 >> 2] = o[t + 46 | 0], e0(e, 32336, A + 400 | 0), i[A + 384 >> 2] = o[t + 45 | 0], e0(e, 26962, A + 384 | 0), l[t + 46 | 0]) {
                                                                                if (i[A + 368 >> 2] = i[t + 48 >> 2], e0(e, 29874, A + 368 | 0), i[A + 352 >> 2] = i[t + 52 >> 2], e0(e, 31138, A + 352 | 0), i[A + 336 >> 2] = o[t + 56 | 0], e0(e, 26742, A + 336 | 0), e0(e, 23409, 0), i[t + 48 >> 2] >= 0) for(k = t + 8360 | 0; i[A + 320 >> 2] = i[k + (s << 2) >> 2], e0(e, 22581, A + 320 | 0), u = i[t + 48 >> 2] > (s | 0), s = s + 1 | 0, !!u;);
                                                                                if (s = 0, e0(e, 34660, 0), e0(e, 23387, 0), i[t + 52 >> 2] >= 0) for(k = t + 8404 | 0; i[A + 304 >> 2] = i[k + (s << 2) >> 2], e0(e, 22581, A + 304 | 0), u = i[t + 52 >> 2] > (s | 0), s = s + 1 | 0, !!u;);
                                                                                e0(e, 34660, 0), i[A + 288 >> 2] = o[t + 57 | 0], e0(e, 28258, A + 288 | 0);
                                                                            }
                                                                            if (i[A + 272 >> 2] = o[t + 58 | 0], e0(e, 26836, A + 272 | 0), i[A + 256 >> 2] = o[t + 59 | 0], e0(e, 26546, A + 256 | 0), l[t + 59 | 0] && (i[A + 240 >> 2] = o[t + 60 | 0], e0(e, 26917, A + 240 | 0), i[A + 224 >> 2] = o[t + 61 | 0], e0(e, 26666, A + 224 | 0), i[A + 208 >> 2] = i[t + 64 >> 2], e0(e, 33857, A + 208 | 0), i[A + 192 >> 2] = i[t + 68 >> 2], e0(e, 33875, A + 192 | 0)), i[A + 176 >> 2] = o[t + 72 | 0], e0(e, 26626, A + 176 | 0), i[A + 160 >> 2] = o[t + 8233 | 0], e0(e, 26509, A + 160 | 0), i[A + 144 >> 2] = i[t + 8236 >> 2], e0(e, 30651, A + 144 | 0), i[A + 128 >> 2] = o[t + 8240 | 0], e0(e, 29804, A + 128 | 0), i[A + 112 >> 2] = o[t + 8241 | 0], e0(e, 27629, A + 112 | 0), i[A + 96 >> 2] = o[t + 8242 | 0], e0(e, 32488, A + 96 | 0), i[A + 80 >> 2] = o[t + 8243 | 0], e0(e, 30847, A + 80 | 0), i[A + 64 >> 2] = o[t + 8244 | 0], e0(e, 27804, A - -64 | 0), i[A + 48 >> 2] = o[t + 8245 | 0], e0(e, 32219, A + 48 | 0), i[A + 32 >> 2] = i[t + 8268 >> 2], e0(e, 32062, A + 32 | 0), i[A + 16 >> 2] = i[t + 8272 >> 2], e0(e, 29018, A + 16 | 0), i[A >> 2] = i[t + 8276 >> 2], e0(e, 29059, A), !l[t + 8243 | 0]) break o;
                                                                            u = t + 8246 | 0, e = m - 144 | 0, m = e, k = 55188;
                                                                            s: switch(B - 1 | 0){
                                                                                case 1:
                                                                                    k = 55184;
                                                                                case 0:
                                                                                    s = i[k >> 2], e0(s, 34591, 0), i[e + 128 >> 2] = l[u | 0], e0(s, 31092, e + 128 | 0), i[e + 112 >> 2] = l[u + 1 | 0], e0(s, 28391, e + 112 | 0), i[e + 96 >> 2] = l[u + 2 | 0], e0(s, 30962, e + 96 | 0);
                                                                                    u: {
                                                                                        if (l[u + 2 | 0] != 1 || (i[e + 80 >> 2] = l[u + 3 | 0], e0(s, 31972, e + 80 | 0), i[e + 64 >> 2] = l[u + 4 | 0], e0(s, 33072, e - -64 | 0), !l[u + 4 | 0])) break u;
                                                                                        for(B = u + 11 | 0, h = u + 5 | 0, k = 0; i[e + 52 >> 2] = o[k + h | 0], i[e + 48 >> 2] = k, e0(s, 33586, e + 48 | 0), i[e + 36 >> 2] = o[k + B | 0], i[e + 32 >> 2] = k, e0(s, 33539, e + 32 | 0), k = k + 1 | 0, k >>> 0 < l[u + 4 | 0];);
                                                                                    }
                                                                                    i[e + 16 >> 2] = l[u + 17 | 0], e0(s, 32960, e + 16 | 0), i[e >> 2] = l[u + 18 | 0], e0(s, 32524, e);
                                                                                    break;
                                                                                default:
                                                                                    break s;
                                                                            }
                                                                            m = e + 144 | 0;
                                                                        }
                                                                        m = A + 720 | 0;
                                                                    }
                                                                    if (i[w + 4 >> 2] = i[w + 4 >> 2] + 1, e = f + (o[w + 24 | 0] << 3) | 0, i[e + 856 >> 2] = t, A = i[e + 860 >> 2], i[e + 860 >> 2] = w, !A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break t;
                                                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                                }
                                                                A = i[w + 4 >> 2], i[w + 4 >> 2] = A - 1, A || (p[i[i[w >> 2] + 8 >> 2]](w), g(w)), w4(f + 548 | 0, W);
                                                                break k;
                                                            case 7:
                                                            case 8:
                                                                k = S + 8 | 0, s = (e | 0) == 40, e = 0, t = m - 80 | 0, m = t;
                                                                t: {
                                                                    o: {
                                                                        for(u = i[A + 1376 >> 2]; f = l0(k, 8), e = f + e | 0, (f | 0) == 255;);
                                                                        for(; f = l0(k, 8), n = f + n | 0, (f | 0) == 255;);
                                                                        i[t + 4 >> 2] = n, i[t >> 2] = e;
                                                                        s: {
                                                                            u: {
                                                                                if ((e | 0) != 132) break u;
                                                                                if (L = t, q = l0(k, 8), i[L + 8 >> 2] = q, f = 1025, !u) break s;
                                                                                for(f = t + 12 | 0, B = t + 60 | 0, h = t + 68 | 0, u = i[u + 476 >> 2], n = 0;;){
                                                                                    w: {
                                                                                        l: switch(i[t + 8 >> 2]){
                                                                                            case 0:
                                                                                                e = f + (n << 4) | 0, L = e, q = l0(k, 8), o[L | 0] = q, L = e, q = l0(k, 8), o[L + 1 | 0] = q, L = e, q = l0(k, 8), o[L + 2 | 0] = q, L = e, q = l0(k, 8), o[L + 3 | 0] = q, L = e, q = l0(k, 8), o[L + 4 | 0] = q, L = e, q = l0(k, 8), o[L + 5 | 0] = q, L = e, q = l0(k, 8), o[L + 6 | 0] = q, L = e, q = l0(k, 8), o[L + 7 | 0] = q, L = e, q = l0(k, 8), o[L + 8 | 0] = q, L = e, q = l0(k, 8), o[L + 9 | 0] = q, L = e, q = l0(k, 8), o[L + 10 | 0] = q, L = e, q = l0(k, 8), o[L + 11 | 0] = q, L = e, q = l0(k, 8), o[L + 12 | 0] = q, L = e, q = l0(k, 8), o[L + 13 | 0] = q, L = e, q = l0(k, 8), o[L + 14 | 0] = q, L = e, q = l0(k, 8), o[L + 15 | 0] = q;
                                                                                                break w;
                                                                                            case 1:
                                                                                                L = B + (n << 1) | 0, q = l0(k, 16), Q[L >> 1] = q;
                                                                                                break w;
                                                                                            case 2:
                                                                                                break l;
                                                                                            default:
                                                                                                break w;
                                                                                        }
                                                                                        L = h + (n << 2) | 0, q = l0(k, 32), i[L >> 2] = q;
                                                                                    }
                                                                                    if (!u) break u;
                                                                                    if (e = n >>> 0 < 2, n = n + 1 | 0, !e) break;
                                                                                }
                                                                            }
                                                                            f = 0;
                                                                        }
                                                                        s: {
                                                                            if (!f) {
                                                                                if (e = i[A + 3212 >> 2], !s | (e | 0) == i[A + 3208 >> 2]) break s;
                                                                                if (s = i[e - 4 >> 2], e = i[s + 440 >> 2], u = i[s + 444 >> 2], e >>> 0 < u >>> 0) {
                                                                                    L = s, q = v0(e, t, 80) + 80 | 0, i[L + 440 >> 2] = q;
                                                                                    break s;
                                                                                }
                                                                                if (n = i[s + 436 >> 2], h = (e - n | 0) / 80 | 0, k = h + 1 | 0, k >>> 0 >= 53687092) break o;
                                                                                if (u = (u - n | 0) / 80 | 0, B = u << 1, B = u >>> 0 >= 26843545 ? 53687091 : k >>> 0 < B >>> 0 ? B : k, B) {
                                                                                    if (B >>> 0 >= 53687092) break i;
                                                                                    k = D(Z(B, 80));
                                                                                } else k = 0;
                                                                                if (u = k + Z(h, 80) | 0, h = v0(u, t, 80) + 80 | 0, (e | 0) != (n | 0)) {
                                                                                    for(; u = u - 80 | 0, e = e - 80 | 0, v0(u, e, 80), (e | 0) != (n | 0););
                                                                                    n = i[s + 436 >> 2];
                                                                                }
                                                                                i[s + 444 >> 2] = k + Z(B, 80), i[s + 440 >> 2] = h, i[s + 436 >> 2] = u, n && X(n), i[s + 440 >> 2] = h;
                                                                                break s;
                                                                            }
                                                                            if (e = i[A + 84 >> 2], (e | 0) == 20) {
                                                                                i[A + 80 >> 2] = 1001;
                                                                                break s;
                                                                            }
                                                                            i[A + 84 >> 2] = e + 1, i[((e << 2) + A | 0) + 4 >> 2] = f;
                                                                        }
                                                                        m = t + 80 | 0, n = f;
                                                                        break t;
                                                                    }
                                                                    p0(), z();
                                                                }
                                                                w4(A + 548 | 0, W);
                                                                break k;
                                                            case 4:
                                                                o[A + 2203 | 0] = 1, w4(A + 548 | 0, W);
                                                                break k;
                                                            default:
                                                                break n;
                                                        }
                                                        w4(A + 548 | 0, W);
                                                    }
                                                    m = S + 32 | 0, o[c + 15 | 0] = 1, e = n;
                                                    break f;
                                                }
                                                if (!(l[e | 0] != 1 | i[A + 3208 >> 2] != i[A + 3212 >> 2])) {
                                                    if (e = 13, A = 1, r) break A;
                                                    break r;
                                                }
                                                e = B7(A, c + 15 | 0);
                                            }
                                            if (!r) break r;
                                            A = e ? 0 : l[c + 15 | 0];
                                        }
                                        i[r >> 2] = A;
                                    }
                                    return m = c + 16 | 0, e;
                                }
                                y0(8353, 14908, 1328, 12287), z();
                            }
                            Z2(), z();
                        }
                        function c6(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            n = m - 320 | 0, m = n, i[n + 288 >> 2] = 0, i[n + 292 >> 2] = 0, i[n + 296 >> 2] = 0, i[n + 300 >> 2] = 0, i[n + 304 >> 2] = 0, i[n + 280 >> 2] = 0, i[n + 284 >> 2] = 0, i[n + 272 >> 2] = 73428, _e(n + 248 | 0, n + 272 | 0, r);
                            i: {
                                if (i[n + 248 >> 2]) {
                                    r = i[n + 252 >> 2], i[A >> 2] = i[n + 248 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[n + 264 >> 2], r = i[n + 260 >> 2], i[A + 8 >> 2] = i[n + 256 >> 2], i[A + 12 >> 2] = r, i[n + 264 >> 2] = 0, i[n + 256 >> 2] = 0, i[n + 260 >> 2] = 0;
                                    break i;
                                }
                                if (l[r + 20 | 0] == 1) {
                                    if (o[n + 68 | 0] = 0, o[n + 79 | 0] = 0, i0(A, 2, 100, n + 68 | 0), o[n + 79 | 0] >= 0) break i;
                                    X(i[n + 68 >> 2]);
                                    break i;
                                }
                                k = i[e + 4 >> 2], i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                e: {
                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break e;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                i[n + 240 >> 2] = 0, i[n + 244 >> 2] = 0;
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: {
                                                                            l: {
                                                                                h: {
                                                                                    v: {
                                                                                        _: {
                                                                                            B: {
                                                                                                m: {
                                                                                                    Z: {
                                                                                                        W: {
                                                                                                            X: {
                                                                                                                p: {
                                                                                                                    Q: {
                                                                                                                        C: {
                                                                                                                            I: {
                                                                                                                                V: {
                                                                                                                                    F: {
                                                                                                                                        y: {
                                                                                                                                            Y: {
                                                                                                                                                M: {
                                                                                                                                                    E: {
                                                                                                                                                        g: {
                                                                                                                                                            J: {
                                                                                                                                                                N: {
                                                                                                                                                                    R: {
                                                                                                                                                                        if (k = i[n + 288 >> 2], (k | 0) <= 1768973166) {
                                                                                                                                                                            if ((k | 0) <= 1668246641) {
                                                                                                                                                                                if ((k | 0) <= 1635148610) {
                                                                                                                                                                                    if ((k | 0) <= 1634563684) {
                                                                                                                                                                                        if ((k | 0) == 1630628984) break _;
                                                                                                                                                                                        if ((k | 0) == 1630629744) break B;
                                                                                                                                                                                        if ((k | 0) != 1634497650) break r;
                                                                                                                                                                                        k = D(136), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 77056, t = B0(k + 16 | 0, 0, 104), i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 16 >> 2] = 75164, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                                        break e;
                                                                                                                                                                                    }
                                                                                                                                                                                    if ((k | 0) == 1634563685) break l;
                                                                                                                                                                                    if ((k | 0) == 1635088451) break y;
                                                                                                                                                                                    if ((k | 0) != 1635135811) break r;
                                                                                                                                                                                    k = D(144), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 16 >> 2] = 80800, Q[k + 114 >> 1] = 0, Q[k + 116 >> 1] = 0, Q[k + 118 >> 1] = 0, Q[k + 120 >> 1] = 0, i[k + 136 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k >> 2] = 76856, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 256, o[k + 121 | 0] = 0, o[k + 122 | 0] = 0, o[k + 123 | 0] = 0, o[k + 124 | 0] = 0, i[k + 32 >> 2] = 1635135811, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                    G: {
                                                                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                    }
                                                                                                                                                                                    break e;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) <= 1668050024) {
                                                                                                                                                                                    if ((k | 0) == 1635148611) break k;
                                                                                                                                                                                    if ((k | 0) == 1667523942) break o;
                                                                                                                                                                                    if ((k | 0) != 1668047216) break r;
                                                                                                                                                                                    k = D(152), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 144 >> 2] = 1, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 1, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 1, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 1, i[k >> 2] = 76736, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 74876, i[k + 32 >> 2] = 1668047216, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                    G: {
                                                                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                    }
                                                                                                                                                                                    break e;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) <= 1668113783) {
                                                                                                                                                                                    if ((k | 0) == 1668050025) break v;
                                                                                                                                                                                    if ((k | 0) != 1668112752) break r;
                                                                                                                                                                                    k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 81472, i[k >> 2] = 77856, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1668112752, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                    G: {
                                                                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                    }
                                                                                                                                                                                    break e;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) == 1668113784) break w;
                                                                                                                                                                                if ((k | 0) != 1668114798) break r;
                                                                                                                                                                                pn(n + 68 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                G: {
                                                                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                }
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) <= 1751411825) {
                                                                                                                                                                                if ((k | 0) <= 1718773092) {
                                                                                                                                                                                    if ((k | 0) == 1668246642) break W;
                                                                                                                                                                                    if ((k | 0) == 1684631142) break p;
                                                                                                                                                                                    if ((k | 0) != 1685218662) break r;
                                                                                                                                                                                    k = D(120), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 77176, t = B0(k + 16 | 0, 0, 104), i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 75452, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                                    break e;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) == 1718773093) break N;
                                                                                                                                                                                if ((k | 0) == 1718909296) break R;
                                                                                                                                                                                if ((k | 0) != 1735553132) break r;
                                                                                                                                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76976, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 75092, i[k + 32 >> 2] = 1735553132, i[n + 244 >> 2] = k, i[n + 240 >> 2] = k + 16, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) <= 1768517221) {
                                                                                                                                                                                if ((k | 0) == 1751411826) break J;
                                                                                                                                                                                if ((k | 0) == 1752589123) break C;
                                                                                                                                                                                if ((k | 0) != 1768186228) break r;
                                                                                                                                                                                k = D(152), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 76936, t = B0(k + 16 | 0, 0, 136), i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 16 >> 2] = 75020, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 144 >> 2] = 0, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) <= 1768778097) {
                                                                                                                                                                                if ((k | 0) == 1768517222) break E;
                                                                                                                                                                                if ((k | 0) != 1768714083) break r;
                                                                                                                                                                                k = D(176), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 144 >> 2] = 0, i[k >> 2] = 76336, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 73452, o[k + 133 | 0] = 0, o[k + 134 | 0] = 0, o[k + 135 | 0] = 0, o[k + 136 | 0] = 0, o[k + 137 | 0] = 0, o[k + 138 | 0] = 0, o[k + 139 | 0] = 0, o[k + 140 | 0] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 32 >> 2] = 1768714083, o[k + 148 | 0] = 0, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                G: {
                                                                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                }
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) == 1768778098) break V;
                                                                                                                                                                            if ((k | 0) != 1768842853) break r;
                                                                                                                                                                            k = D(184), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, Q[k + 124 >> 1] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k >> 2] = 76416, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74240, o[k + 173 | 0] = 0, o[k + 174 | 0] = 0, o[k + 175 | 0] = 0, o[k + 176 | 0] = 0, o[k + 177 | 0] = 0, o[k + 178 | 0] = 0, o[k + 179 | 0] = 0, o[k + 180 | 0] = 0, i[k + 168 >> 2] = 0, i[k + 172 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 164 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 156 >> 2] = 0, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 32 >> 2] = 1768842853, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                            G: {
                                                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                            }
                                                                                                                                                                            break e;
                                                                                                                                                                        }
                                                                                                                                                                        if ((k | 0) <= 1836280642) {
                                                                                                                                                                            if ((k | 0) <= 1781689159) {
                                                                                                                                                                                if ((k | 0) <= 1769104741) {
                                                                                                                                                                                    if ((k | 0) == 1768973167) break M;
                                                                                                                                                                                    if ((k | 0) == 1768975713) break Y;
                                                                                                                                                                                    if ((k | 0) != 1768977008) break r;
                                                                                                                                                                                    k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76456, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 74384, i[k + 32 >> 2] = 1768977008, i[n + 244 >> 2] = k, i[n + 240 >> 2] = k + 16, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                                    break e;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) == 1769104742) break I;
                                                                                                                                                                                if ((k | 0) == 1769107316) break F;
                                                                                                                                                                                if ((k | 0) != 1769173093) break r;
                                                                                                                                                                                Sn(n + 68 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                G: {
                                                                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                }
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) <= 1835295091) {
                                                                                                                                                                                G: switch(k - 1781689160 | 0){
                                                                                                                                                                                    case 4:
                                                                                                                                                                                        break t;
                                                                                                                                                                                    case 0:
                                                                                                                                                                                        break s;
                                                                                                                                                                                    case 1:
                                                                                                                                                                                    case 2:
                                                                                                                                                                                    case 3:
                                                                                                                                                                                        break r;
                                                                                                                                                                                    default:
                                                                                                                                                                                        break G;
                                                                                                                                                                                }
                                                                                                                                                                                if ((k | 0) == 1785751363) break u;
                                                                                                                                                                                if ((k | 0) != 1819501932) break r;
                                                                                                                                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, Q[k + 114 >> 1] = 0, i[k >> 2] = 77376, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 75740, i[k + 32 >> 2] = 1819501932, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                G: {
                                                                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                }
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) == 1835295092) break f;
                                                                                                                                                                            if ((k | 0) == 1835295606) break h;
                                                                                                                                                                            if ((k | 0) != 1835365473) break r;
                                                                                                                                                                            k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76136, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74024, i[k + 32 >> 2] = 1835365473, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                            G: {
                                                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                            }
                                                                                                                                                                            break e;
                                                                                                                                                                        }
                                                                                                                                                                        if ((k | 0) <= 1936419183) {
                                                                                                                                                                            if ((k | 0) <= 1885959276) {
                                                                                                                                                                                if ((k | 0) == 1836280643) break n;
                                                                                                                                                                                if ((k | 0) == 1885434736) break m;
                                                                                                                                                                                if ((k | 0) != 1885564018) break r;
                                                                                                                                                                                k = D(144), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 81544, i[k >> 2] = 77896, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 32 >> 2] = 1885564018, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                                G: {
                                                                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                                }
                                                                                                                                                                                break e;
                                                                                                                                                                            }
                                                                                                                                                                            if ((k | 0) == 1885959277) break g;
                                                                                                                                                                            if ((k | 0) == 1885960297) break Z;
                                                                                                                                                                            if ((k | 0) != 1887006052) break r;
                                                                                                                                                                            k = D(152), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 77016, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 16 >> 2] = 75308, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 32 >> 2] = 1887006052, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                            G: {
                                                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                            }
                                                                                                                                                                            break e;
                                                                                                                                                                        }
                                                                                                                                                                        if ((k | 0) <= 1970433055) {
                                                                                                                                                                            if ((k | 0) == 1936419184) break N;
                                                                                                                                                                            if ((k | 0) == 1937007986) break Q;
                                                                                                                                                                            if ((k | 0) != 1969513843) break r;
                                                                                                                                                                            k = D(168), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k >> 2] = 77696, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 76052, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 156 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 164 >> 2] = 0, i[k + 32 >> 2] = 1969513843, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                            G: {
                                                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                            }
                                                                                                                                                                            break e;
                                                                                                                                                                        }
                                                                                                                                                                        if ((k | 0) == 1970433056) break X;
                                                                                                                                                                        if ((k | 0) == 1970628964) break A;
                                                                                                                                                                        if ((k | 0) != 1987470147) break r;
                                                                                                                                                                        k = D(208), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, Q[k + 120 >> 1] = 259, i[k + 16 >> 2] = 81944, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k >> 2] = 76896, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 156 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 164 >> 2] = 0, i[k + 168 >> 2] = 0, i[k + 172 >> 2] = 0, i[k + 176 >> 2] = 0, i[k + 180 >> 2] = 0, i[k + 200 >> 2] = 0, i[k + 192 >> 2] = 0, i[k + 196 >> 2] = 0, i[k + 32 >> 2] = 1987470147, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                        G: {
                                                                                                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break G;
                                                                                                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                        }
                                                                                                                                                                        break e;
                                                                                                                                                                    }
                                                                                                                                                                    k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 76176, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 73880, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 32 >> 2] = 1718909296, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                                    R: {
                                                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break R;
                                                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                                    }
                                                                                                                                                                    break e;
                                                                                                                                                                }
                                                                                                                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76216, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 73952, i[k + 32 >> 2] = 1718773093, i[n + 244 >> 2] = k, i[n + 240 >> 2] = k + 16, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                                break e;
                                                                                                                                                            }
                                                                                                                                                            k = D(152), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 1885954932, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k >> 2] = 76256, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74096, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 32 >> 2] = 1751411826, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                            J: {
                                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break J;
                                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                            }
                                                                                                                                                            break e;
                                                                                                                                                        }
                                                                                                                                                        k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 76296, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74168, i[k + 32 >> 2] = 1885959277, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                        g: {
                                                                                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break g;
                                                                                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                        }
                                                                                                                                                        break e;
                                                                                                                                                    }
                                                                                                                                                    k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76376, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74312, i[k + 32 >> 2] = 1768517222, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                                    E: {
                                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break E;
                                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                                    }
                                                                                                                                                    break e;
                                                                                                                                                }
                                                                                                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k >> 2] = 76496, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 74456, i[k + 32 >> 2] = 1768973167, i[n + 244 >> 2] = k, i[n + 240 >> 2] = k + 16, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                                                break e;
                                                                                                                                            }
                                                                                                                                            k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k >> 2] = 76536, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74588, i[k + 32 >> 2] = 1768975713, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                            Y: {
                                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break Y;
                                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                            }
                                                                                                                                            break e;
                                                                                                                                        }
                                                                                                                                        k = D(144), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k >> 2] = 76616, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74660, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 32 >> 2] = 1635088451, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                        y: {
                                                                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break y;
                                                                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                        }
                                                                                                                                        break e;
                                                                                                                                    }
                                                                                                                                    k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k >> 2] = 76656, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 74732, i[k + 32 >> 2] = 1769107316, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                    F: {
                                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break F;
                                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                    }
                                                                                                                                    break e;
                                                                                                                                }
                                                                                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k >> 2] = 76696, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 74804, i[k + 32 >> 2] = 1768778098, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                                V: {
                                                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break V;
                                                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                                }
                                                                                                                                break e;
                                                                                                                            }
                                                                                                                            k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k >> 2] = 76776, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74948, i[k + 32 >> 2] = 1769104742, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                            I: {
                                                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break I;
                                                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                            }
                                                                                                                            break e;
                                                                                                                        }
                                                                                                                        k = D(168), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 156 >> 2] = 0, o[k + 148 | 0] = 4, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 16 >> 2] = 80464, i[k >> 2] = 76816, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1752589123, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                        C: {
                                                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break C;
                                                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                        }
                                                                                                                        break e;
                                                                                                                    }
                                                                                                                    k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 77096, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 16 >> 2] = 75236, i[k + 32 >> 2] = 1937007986, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                                    Q: {
                                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break Q;
                                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                                    }
                                                                                                                    break e;
                                                                                                                }
                                                                                                                k = D(120), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 77136, t = B0(k + 16 | 0, 0, 104), i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 75380, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                                break e;
                                                                                                            }
                                                                                                            k = D(136), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 77216, t = B0(k + 16 | 0, 0, 120), i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 16 >> 2] = 75524, i[k + 128 >> 2] = 0, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                                                            break e;
                                                                                                        }
                                                                                                        k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 78708, i[k >> 2] = 77256, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1668246642, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                        W: {
                                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break W;
                                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                        }
                                                                                                        break e;
                                                                                                    }
                                                                                                    k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k >> 2] = 77296, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 75596, i[k + 32 >> 2] = 1885960297, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                    Z: {
                                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break Z;
                                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                    }
                                                                                                    break e;
                                                                                                }
                                                                                                k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 1, i[k + 120 >> 2] = 1, i[k >> 2] = 77336, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 75668, i[k + 32 >> 2] = 1885434736, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                                m: {
                                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break m;
                                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                                }
                                                                                                break e;
                                                                                            }
                                                                                            k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 16 >> 2] = 80872, i[k >> 2] = 77416, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 32 >> 2] = 1630629744, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                            B: {
                                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break B;
                                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                            }
                                                                                            break e;
                                                                                        }
                                                                                        k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 80944, i[k >> 2] = 77456, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 124 >> 2] = 0, i[k + 32 >> 2] = 1630628984, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                        _: {
                                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break _;
                                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                        }
                                                                                        break e;
                                                                                    }
                                                                                    k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, Q[k + 114 >> 1] = 0, Q[k + 116 >> 1] = 0, i[k >> 2] = 77496, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 75812, i[k + 32 >> 2] = 1668050025, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                    v: {
                                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break v;
                                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                    }
                                                                                    break e;
                                                                                }
                                                                                k = D(144), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 77536, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 73512, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 32 >> 2] = 1835295606, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                                h: {
                                                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break h;
                                                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                                }
                                                                                break e;
                                                                            }
                                                                            k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k >> 2] = 77576, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 16 >> 2] = 73572, i[k + 32 >> 2] = 1634563685, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                            l: {
                                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break l;
                                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                            }
                                                                            break e;
                                                                        }
                                                                        tn(n + 68 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                        w: {
                                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break w;
                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                        }
                                                                        break e;
                                                                    }
                                                                    k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 81120, i[k >> 2] = 77736, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1785751363, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                                    u: {
                                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break u;
                                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                    }
                                                                    break e;
                                                                }
                                                                k = D(120), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 16 >> 2] = 81688, i[k >> 2] = 77776, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1781689160, i[n + 244 >> 2] = k, i[n + 240 >> 2] = k + 16, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                                                break e;
                                                            }
                                                            k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 16 >> 2] = 81400, i[k >> 2] = 77816, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[k + 32 >> 2] = 1667523942, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                            o: {
                                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break o;
                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                            }
                                                            break e;
                                                        }
                                                        k = D(136), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 16 >> 2] = 81616, i[k >> 2] = 77936, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 32 >> 2] = 1781689164, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                        t: {
                                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break t;
                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        }
                                                        break e;
                                                    }
                                                    k = D(128), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, o[k + 120 | 0] = 0, i[k + 16 >> 2] = 82276, i[k >> 2] = 77976, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 32 >> 2] = 1836280643, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                    n: {
                                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break n;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    }
                                                    break e;
                                                }
                                                k = D(168), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 116 >> 2] = 0, i[k + 16 >> 2] = 82152, Q[k + 128 >> 1] = 2056, i[k + 124 >> 2] = 1, i[k >> 2] = 78016, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k - -64 >> 2] = 0, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, o[k + 120 | 0] = 0, i[k + 164 >> 2] = 0, i[k + 156 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 144 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 32 >> 2] = 1635148611, i[n + 72 >> 2] = k, i[n + 68 >> 2] = k + 16, t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                                k: {
                                                    if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break k;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                break e;
                                            }
                                            k = D(120), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78056, t = B0(k + 16 | 0, 0, 104), i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 16 >> 2] = 73676, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, o[k + 112 | 0] = 0, i[n + 244 >> 2] = k, i[n + 240 >> 2] = t, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0;
                                            break e;
                                        }
                                        if (GA(n + 40 | 0, n + 272 | 0), i[n + 224 >> 2] = 16, o[n + 76 | 0] = 157, o[n + 77 | 0] = 144, o[n + 78 | 0] = 78, o[n + 79 | 0] = 182, o[n + 80 | 0] = 236, o[n + 81 | 0] = 186, o[n + 82 | 0] = 243, o[n + 83 | 0] = 163, o[n + 68 | 0] = 34, o[n + 69 | 0] = 204, o[n + 70 | 0] = 4, o[n + 71 | 0] = 199, o[n + 72 | 0] = 214, o[n + 73 | 0] = 217, o[n + 74 | 0] = 78, o[n + 75 | 0] = 7, i[n + 220 >> 2] = n + 68, k = i[n + 224 >> 2], i[n + 24 >> 2] = i[n + 220 >> 2], i[n + 28 >> 2] = k, t = 0, s = b9(n + 228 | 0, n + 24 | 0), u = i[s >> 2], k = i[n + 40 >> 2], h = i[n + 44 >> 2] - k | 0, (i[s + 4 >> 2] - u | 0) == (h | 0) && (t = !O2(k, u, h)), u && (i[s + 4 >> 2] = u, X(u), k = i[n + 40 >> 2]), k && (i[n + 44 >> 2] = k, X(k)), t) {
                                            pn(n + 68 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                            A: {
                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break A;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                            }
                                            break e;
                                        }
                                        if (GA(n + 40 | 0, n + 272 | 0), i[n + 216 >> 2] = 16, o[n + 76 | 0] = 151, o[n + 77 | 0] = 174, o[n + 78 | 0] = 190, o[n + 79 | 0] = 166, o[n + 80 | 0] = 152, o[n + 81 | 0] = 3, o[n + 82 | 0] = 180, o[n + 83 | 0] = 52, o[n + 68 | 0] = 67, o[n + 69 | 0] = 99, o[n + 70 | 0] = 233, o[n + 71 | 0] = 20, o[n + 72 | 0] = 91, o[n + 73 | 0] = 125, o[n + 74 | 0] = 74, o[n + 75 | 0] = 171, i[n + 212 >> 2] = n + 68, k = i[n + 216 >> 2], i[n + 16 >> 2] = i[n + 212 >> 2], i[n + 20 >> 2] = k, t = 0, s = b9(n + 228 | 0, n + 16 | 0), u = i[s >> 2], k = i[n + 40 >> 2], h = i[n + 44 >> 2] - k | 0, (i[s + 4 >> 2] - u | 0) == (h | 0) && (t = !O2(k, u, h)), u && (i[s + 4 >> 2] = u, X(u), k = i[n + 40 >> 2]), k && (i[n + 44 >> 2] = k, X(k)), t) {
                                            tn(n + 68 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                            A: {
                                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break A;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                            }
                                            break e;
                                        }
                                        i[n + 40 >> 2] = i[n + 288 >> 2], On(n + 68 | 0, n + 40 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                        A: {
                                            if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break A;
                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        }
                                        break e;
                                    }
                                    i[n + 40 >> 2] = k, On(n + 68 | 0, n + 40 | 0), t = i[n + 68 >> 2], u = i[n + 72 >> 2], i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, k = i[n + 244 >> 2], i[n + 240 >> 2] = t, i[n + 244 >> 2] = u;
                                    r: {
                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                }
                                B1(n + 68 | 0), t = i[n + 284 >> 2], k = i[n + 240 >> 2], i[k + 8 >> 2] = i[n + 280 >> 2], i[k + 12 >> 2] = t, i[k + 16 >> 2] = i[n + 288 >> 2], (k | 0) != (n + 272 | 0) && (t = i[n + 292 >> 2], u = i[n + 296 >> 2], b4(k + 20 | 0, t, u, u - t | 0)), i[k + 32 >> 2] = i[n + 304 >> 2], si(n + 68 | 0, n + 272 | 0), k = i[n + 240 >> 2], o[k + 95 | 0] < 0 && X(i[k + 84 >> 2]), t = i[n + 72 >> 2], i[k + 84 >> 2] = i[n + 68 >> 2], i[k + 88 >> 2] = t, i[k + 92 >> 2] = i[n + 76 >> 2];
                                e: {
                                    if (i[r + 12 >> 2] >= 21) {
                                        if (r = D(64), i[n + 68 >> 2] = r, i[n + 72 >> 2] = 61, i[n + 76 >> 2] = -2147483584, e = l[14118] | l[14119] << 8 | (l[14120] << 16 | l[14121] << 24), f = l[14114] | l[14115] << 8 | (l[14116] << 16 | l[14117] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 61 | 0] = 0, e = l[14171] | l[14172] << 8 | (l[14173] << 16 | l[14174] << 24), f = l[14167] | l[14168] << 8 | (l[14169] << 16 | l[14170] << 24), o[r + 53 | 0] = f, o[r + 54 | 0] = f >>> 8, o[r + 55 | 0] = f >>> 16, o[r + 56 | 0] = f >>> 24, o[r + 57 | 0] = e, o[r + 58 | 0] = e >>> 8, o[r + 59 | 0] = e >>> 16, o[r + 60 | 0] = e >>> 24, e = l[14166] | l[14167] << 8 | (l[14168] << 16 | l[14169] << 24), f = l[14162] | l[14163] << 8 | (l[14164] << 16 | l[14165] << 24), o[r + 48 | 0] = f, o[r + 49 | 0] = f >>> 8, o[r + 50 | 0] = f >>> 16, o[r + 51 | 0] = f >>> 24, o[r + 52 | 0] = e, o[r + 53 | 0] = e >>> 8, o[r + 54 | 0] = e >>> 16, o[r + 55 | 0] = e >>> 24, e = l[14158] | l[14159] << 8 | (l[14160] << 16 | l[14161] << 24), f = l[14154] | l[14155] << 8 | (l[14156] << 16 | l[14157] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[14150] | l[14151] << 8 | (l[14152] << 16 | l[14153] << 24), f = l[14146] | l[14147] << 8 | (l[14148] << 16 | l[14149] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[14142] | l[14143] << 8 | (l[14144] << 16 | l[14145] << 24), f = l[14138] | l[14139] << 8 | (l[14140] << 16 | l[14141] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[14134] | l[14135] << 8 | (l[14136] << 16 | l[14137] << 24), f = l[14130] | l[14131] << 8 | (l[14132] << 16 | l[14133] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[14126] | l[14127] << 8 | (l[14128] << 16 | l[14129] << 24), f = l[14122] | l[14123] << 8 | (l[14124] << 16 | l[14125] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 6, 1e3, n + 68 | 0), o[n + 79 | 0] >= 0) break e;
                                        X(i[n + 68 >> 2]);
                                        break e;
                                    }
                                    t = i[n + 284 >> 2], s = t;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        if (k = i[n + 280 >> 2], t | k) {
                                                            if (t = i[n + 304 >> 2], !s & k >>> 0 < t >>> 0) {
                                                                i[n + 76 >> 2] = 59808, i[n + 132 >> 2] = 59828, r = i[14961], i[n + 68 >> 2] = r, e = i[r - 12 >> 2], r = n + 68 | 0, i[e + r >> 2] = i[14962], i[n + 72 >> 2] = 0, e = r + i[i[n + 68 >> 2] - 12 >> 2] | 0, f = n + 80 | 0, T0(e, f), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[n + 76 >> 2] = e, s = i[e - 12 >> 2], e = n + 76 | 0, i[s + e >> 2] = i[14964], k = i[14960], i[n + 68 >> 2] = k, i[r + i[k - 12 >> 2] >> 2] = i[14965], i[n + 132 >> 2] = 59828, i[n + 68 >> 2] = 59788, i[n + 76 >> 2] = 59808, f = z0(f), i[f >> 2] = 58864, i[n + 120 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 112 >> 2] = 0, i[n + 116 >> 2] = 0, i[n + 128 >> 2] = 24, U(M0(U(K1(U(e, 20946, 10), i[n + 280 >> 2], i[n + 284 >> 2]), 20957, 34), i[n + 304 >> 2]), 20229, 7), r = i[n + 128 >> 2];
                                                                t: {
                                                                    if (r & 16) {
                                                                        k = n + 100 | 0, e = i[n + 124 >> 2], r = i[n + 104 >> 2], e >>> 0 < r >>> 0 ? i[n + 124 >> 2] = r : r = e;
                                                                        break t;
                                                                    }
                                                                    if (!(r & 8)) {
                                                                        r = 0, o[n + 51 | 0] = 0, k = n + 40 | 0;
                                                                        break r;
                                                                    }
                                                                    k = n + 88 | 0, r = i[n + 96 >> 2];
                                                                }
                                                                if (e = i[k >> 2], r = r - e | 0, r >>> 0 >= 2147483640) break k;
                                                                if (r >>> 0 >= 11) {
                                                                    t = (r | 7) + 1 | 0, k = D(t), i[n + 48 >> 2] = t | -2147483648, i[n + 40 >> 2] = k, i[n + 44 >> 2] = r;
                                                                    break A;
                                                                }
                                                                if (o[n + 51 | 0] = r, k = n + 40 | 0, r) break A;
                                                                r = 0;
                                                                break r;
                                                            }
                                                            if (u = k - t | 0, k = s - (k >>> 0 < t >>> 0) | 0, (k | 0) == 1 | k >>> 0 > 1) {
                                                                if (r = A, A = a1(n + 68 | 0, 11166), i0(r, 6, 101, A), o[A + 11 | 0] >= 0) break e;
                                                                X(i[A >> 2]);
                                                                break e;
                                                            }
                                                            if ((s | 0) < 0) {
                                                                if (r = A, A = a1(n + 68 | 0, 34896), i0(r, 2, 101, A), o[A + 11 | 0] >= 0) break e;
                                                                X(i[A >> 2]);
                                                                break e;
                                                            }
                                                            if (k = i[r >> 2], t = p[i[i[k >> 2] + 8 >> 2]](k) | 0, s = i[r >> 2], k = w0, t = t + u | 0, k = t >>> 0 < u >>> 0 ? k + 1 | 0 : k, p[i[i[s >> 2] + 12 >> 2]](s, t, k) | 0) {
                                                                if (r = A, A = a1(n + 68 | 0, 34896), i0(r, 2, 100, A), o[A + 11 | 0] >= 0) break e;
                                                                X(i[A >> 2]);
                                                                break e;
                                                            }
                                                            if (k = i[n + 284 >> 2], u = k, t = i[n + 280 >> 2], k | t) break n;
                                                        }
                                                        k = i[r + 16 >> 2];
                                                        break f;
                                                    }
                                                    if (s = i[n + 304 >> 2], k = t - s | 0, t = u - (t >>> 0 < s >>> 0) | 0, (t | 0) <= 0 & k0[r + 16 >> 2] >= k >>> 0 | (t | 0) < 0) break f;
                                                    if (o[n + 68 | 0] = 0, o[n + 79 | 0] = 0, i0(A, 2, 101, n + 68 | 0), o[n + 79 | 0] >= 0) break e;
                                                    X(i[n + 68 >> 2]);
                                                    break e;
                                                }
                                                Y0(), z();
                                            }
                                            if (i[n + 60 >> 2] = i[r >> 2], t = i[r + 4 >> 2], i[n + 64 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), t = i[n + 64 >> 2], i[n + 8 >> 2] = i[n + 60 >> 2], i[n + 12 >> 2] = t, k = kr(n + 68 | 0, n + 8 | 0, k, r), r = i[n + 240 >> 2], p[i[i[r >> 2] + 40 >> 2]](n + 40 | 0, r, k, f), r = i[n + 44 >> 2], i[n + 248 >> 2] = i[n + 40 >> 2], i[n + 252 >> 2] = r, o[n + 267 | 0] < 0 && X(i[n + 256 >> 2]), r = i[n + 52 >> 2], i[n + 256 >> 2] = i[n + 48 >> 2], i[n + 260 >> 2] = r, i[n + 264 >> 2] = i[n + 56 >> 2], f = i[k + 16 >> 2], f && (r = i[k + 8 >> 2], r && (dA(r, f), f = i[k + 16 >> 2]), r = i[k >> 2], u = p[i[i[r >> 2] + 8 >> 2]](r) | 0, t = w0, s = f, f = f + u | 0, t = s >>> 0 > f >>> 0 ? t + 1 | 0 : t, p[i[i[r >> 2] + 20 >> 2]](r, f, t), i[k + 16 >> 2] = 0), i[n + 248 >> 2] != i[21668]) {
                                                r = i[n + 240 >> 2], w = n, v = p[i[i[r >> 2] + 28 >> 2]](r) | 0, i[w + 228 >> 2] = v, i[n + 36 >> 2] = i[i[n + 240 >> 2] + 16 >> 2], t = m - 32 | 0, m = t, r = D(144), i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78136, u = i[n + 36 >> 2], f = i[n + 252 >> 2], i[t + 8 >> 2] = i[n + 248 >> 2], i[t + 12 >> 2] = f, f = t + 16 | 0;
                                                f: {
                                                    if (o[n + 267 | 0] >= 0) {
                                                        s = i[n + 260 >> 2], i[f >> 2] = i[n + 256 >> 2], i[f + 4 >> 2] = s, i[f + 8 >> 2] = i[n + 264 >> 2];
                                                        break f;
                                                    }
                                                    j(f, i[n + 256 >> 2], i[n + 260 >> 2]);
                                                }
                                                s = i[n + 228 >> 2], i[r - -64 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 72 >> 2] = -1, i[r + 76 >> 2] = -1, i[r + 80 >> 2] = -1, i[r + 84 >> 2] = -1, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, o[r + 112 | 0] = 0, i[r + 16 >> 2] = 73808, i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, i[r + 136 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 132 >> 2] = 0, i[r + 116 >> 2] = u, i[r + 32 >> 2] = 1163022880, u = i[t + 12 >> 2], i[r + 120 >> 2] = i[t + 8 >> 2], i[r + 124 >> 2] = u, o[r + 139 | 0] < 0 && X(i[r + 128 >> 2]), u = i[f + 4 >> 2], i[r + 128 >> 2] = i[f >> 2], i[r + 132 >> 2] = u, i[r + 136 >> 2] = i[f + 8 >> 2], i[r + 140 >> 2] = s, i[n + 44 >> 2] = r, i[n + 40 >> 2] = r + 16, m = t + 32 | 0, f = i[n + 40 >> 2], t = i[n + 44 >> 2], i[n + 40 >> 2] = 0, i[n + 44 >> 2] = 0, r = i[n + 244 >> 2], i[n + 240 >> 2] = f, i[n + 244 >> 2] = t;
                                                f: {
                                                    if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break f;
                                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                }
                                                B1(n + 40 | 0);
                                            }
                                            if (A6(e, n + 240 | 0), r = i[n + 252 >> 2], i[A >> 2] = i[n + 248 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[n + 264 >> 2], r = i[n + 260 >> 2], i[A + 8 >> 2] = i[n + 256 >> 2], i[A + 12 >> 2] = r, i[n + 256 >> 2] = 0, i[n + 260 >> 2] = 0, i[n + 264 >> 2] = 0, A = i[k + 4 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            break e;
                                        }
                                        Q0(k, e, r);
                                    }
                                    o[r + k | 0] = 0, i0(A, 2, 101, n + 40 | 0), o[n + 51 | 0] < 0 && X(i[n + 40 >> 2]), A = i[14959], i[n + 68 >> 2] = A, i[i[A - 12 >> 2] + (n + 68 | 0) >> 2] = i[14967], i[n + 76 >> 2] = i[14968], i[f >> 2] = 58864, o[n + 123 | 0] < 0 && X(i[n + 112 >> 2]), x0(f), N0(n + 132 | 0);
                                }
                                if (A = i[n + 244 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            o[n + 267 | 0] < 0 && X(i[n + 256 >> 2]), i[n + 272 >> 2] = 73428, A = i[n + 292 >> 2], A && (i[n + 296 >> 2] = A, X(A)), m = n + 320 | 0;
                        }
                        function w8(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0;
                            i: {
                                e: {
                                    r: {
                                        if (!n) {
                                            y = i[A + 18588 >> 2], f0 = i[y + 124 >> 2];
                                            A: {
                                                if (!k) {
                                                    if (s = i[y + 208 >> 2], u = r >> s, (u | 0) < 0 || (w = i[y + 212 >> 2], (w | 0) <= (u | 0))) break e;
                                                    if (s = e >> s, (s | 0) < 0 | (s | 0) >= i[y + 216 >> 2]) break i;
                                                    u = l[(u + i[y + 200 >> 2] | 0) + Z(s, w) | 0], u = u >>> 0 <= 34 ? u : 0;
                                                    break A;
                                                }
                                                if (s = i[y + 228 >> 2], u = Z(i[f0 + 16852 >> 2], r) >> s, (u | 0) < 0 || (w = i[y + 232 >> 2], (w | 0) <= (u | 0))) break e;
                                                if (s = Z(i[f0 + 16856 >> 2], e) >> s, (s | 0) < 0 | (s | 0) >= i[y + 236 >> 2]) break i;
                                                u = l[(u + i[y + 220 >> 2] | 0) + Z(s, w) | 0] & 63;
                                            }
                                            t0 = u >>> 0 > 34 ? 1 : u, C = t0, H = i[y + (k ? 44 : 40) >> 2], u = Z(H, e), s = i[(y + (k << 2) | 0) + 4 >> 2];
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    if (i[i[y + 124 >> 2] + (k ? 16840 : 16832) >> 2] >= 9) {
                                                                        R = s + (r + u << 1) | 0, S = m - 528 | 0, m = S, W = m - 336 | 0, m = W, i[W + 24 >> 2] = k, i[W + 16 >> 2] = y, i[W + 32 >> 2] = e, i[W + 28 >> 2] = r, _ = S + 256 | 0, i[W + 12 >> 2] = _, i[W + 20 >> 2] = f;
                                                                        s: {
                                                                            if ((f | 0) < 65) {
                                                                                i[W + 316 >> 2] = 16843009, h = W + 12 | 0, p5(h);
                                                                                u: {
                                                                                    if (i[h + 8 >> 2] < 33) {
                                                                                        if (s = i[h + 4 >> 2], u = i[h + 12 >> 2], B = i[s + (u ? 44 : 40) >> 2], G = i[h + 16 >> 2], w = i[h + 24 >> 2], V = i[w + 16936 >> 2], T = i[h + 20 >> 2], V = i[(i[i[h + 28 >> 2] + 8496 >> 2] + (Z(G, i[h + 296 >> 2]) >> V << 2) | 0) + (Z(i[w + 16924 >> 2], Z(T, i[h + 300 >> 2]) >> V) << 2) >> 2], M = i[(s + (u << 2) | 0) + 4 >> 2], u = i[h + 308 >> 2], !(l[h + 304 | 0] != 1 | (u | 0) <= 0)) for(s = M - 2 | 0, w = u - 1 | 0;;){
                                                                                            u = w;
                                                                                            w: {
                                                                                                if (l[h + 304 | 0] != 1) break w;
                                                                                                E = i[h + 28 >> 2], P = Z(i[h + 296 >> 2], G - 1 | 0), F = i[h + 24 >> 2], $ = i[F + 16936 >> 2], c = u + T | 0, r0 = Z(c, i[h + 300 >> 2]), F = i[(i[E + 8496 >> 2] + (P >> $ << 2) | 0) + (Z(i[F + 16924 >> 2], r0 >> $) << 2) >> 2];
                                                                                                l: {
                                                                                                    if (l[E + 24 | 0]) {
                                                                                                        if (E = P, w = i[h + 4 >> 2], P = i[w + 168 >> 2], E = E >> P, (E | 0) < 0 || ($ = i[w + 172 >> 2], ($ | 0) <= (E | 0))) break e;
                                                                                                        if (P = r0 >> P, (P | 0) < 0 | (P | 0) >= i[w + 176 >> 2]) break i;
                                                                                                        if (l[((i[w + 160 >> 2] + Z(E, 3) | 0) + Z(Z(P, $), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                        if ((V | 0) >= (F | 0)) break l;
                                                                                                        break w;
                                                                                                    }
                                                                                                    if ((V | 0) < (F | 0)) break w;
                                                                                                }
                                                                                                i[h + 316 >> 2] || (Q[h + 320 >> 1] = I[(s + (G << 1) | 0) + (Z(B, c) << 1) >> 1]), w = u ^ -1, o[w + i[h + 292 >> 2] | 0] = 1, Q[i[h >> 2] + (w << 1) >> 1] = I[(s + (i[h + 16 >> 2] << 1) | 0) + (Z(B, u + i[h + 20 >> 2] | 0) << 1) >> 1], o[i[h + 292 >> 2] - u | 0] = 1, Q[i[h >> 2] - (u << 1) >> 1] = I[(s + (i[h + 16 >> 2] << 1) | 0) + (Z(B, (u + i[h + 20 >> 2] | 0) - 1 | 0) << 1) >> 1], w = 1 - u | 0, o[w + i[h + 292 >> 2] | 0] = 1, Q[i[h >> 2] + (w << 1) >> 1] = I[(s + (i[h + 16 >> 2] << 1) | 0) + (Z(B, (u + i[h + 20 >> 2] | 0) - 2 | 0) << 1) >> 1], w = 2 - u | 0, o[w + i[h + 292 >> 2] | 0] = 1, G = i[h + 16 >> 2], T = i[h + 20 >> 2], Q[i[h >> 2] + (w << 1) >> 1] = I[(s + (G << 1) | 0) + (Z(B, (u + T | 0) - 3 | 0) << 1) >> 1], i[h + 316 >> 2] = i[h + 316 >> 2] + 4;
                                                                                            }
                                                                                            if (w = u - 4 | 0, !((u | 0) > 3)) break;
                                                                                        }
                                                                                        w: {
                                                                                            if (!l[h + 307 | 0]) break w;
                                                                                            u = i[h + 28 >> 2], w = Z(i[h + 296 >> 2], G - 1 | 0), s = i[h + 24 >> 2], F = i[s + 16936 >> 2], E = T - 1 | 0, T = Z(E, i[h + 300 >> 2]), s = i[(i[u + 8496 >> 2] + (w >> F << 2) | 0) + (Z(i[s + 16924 >> 2], T >> F) << 2) >> 2];
                                                                                            l: {
                                                                                                if (l[u + 24 | 0]) {
                                                                                                    if (u = i[h + 4 >> 2], F = i[u + 168 >> 2], w = w >> F, (w | 0) < 0 || (P = i[u + 172 >> 2], (P | 0) <= (w | 0))) break e;
                                                                                                    if (T = T >> F, (T | 0) < 0 | (T | 0) >= i[u + 176 >> 2]) break i;
                                                                                                    if (l[((i[u + 160 >> 2] + Z(w, 3) | 0) + Z(Z(T, P), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                    if ((s | 0) <= (V | 0)) break l;
                                                                                                    break w;
                                                                                                }
                                                                                                if ((s | 0) > (V | 0)) break w;
                                                                                            }
                                                                                            u = Z(B, E), i[h + 316 >> 2] || (Q[h + 320 >> 1] = I[((M + (G << 1) | 0) + (u << 1) | 0) - 2 >> 1]), Q[i[h >> 2] >> 1] = I[((M + (G << 1) | 0) + (u << 1) | 0) - 2 >> 1], o[i[h + 292 >> 2]] = 1, i[h + 316 >> 2] = i[h + 316 >> 2] + 1;
                                                                                        }
                                                                                        if (w = i[h + 312 >> 2], (w | 0) > 0) for(s = 0;;){
                                                                                            w: {
                                                                                                if (l[h + (i[h + 8 >> 2] > (s | 0) ? 305 : 306) | 0] != 1) break w;
                                                                                                u = i[h + 28 >> 2], G = i[h + 16 >> 2], F = Z(i[h + 296 >> 2], G + s | 0), T = i[h + 24 >> 2], E = i[T + 16936 >> 2], P = i[h + 20 >> 2] - 1 | 0, $ = Z(P, i[h + 300 >> 2]), T = i[(i[u + 8496 >> 2] + (F >> E << 2) | 0) + (Z(i[T + 16924 >> 2], $ >> E) << 2) >> 2];
                                                                                                l: {
                                                                                                    if (l[u + 24 | 0]) {
                                                                                                        if (u = i[h + 4 >> 2], E = i[u + 168 >> 2], F = F >> E, (F | 0) < 0 || (c = i[u + 172 >> 2], (c | 0) <= (F | 0))) break e;
                                                                                                        if (E = $ >> E, (E | 0) < 0 | (E | 0) >= i[u + 176 >> 2]) break i;
                                                                                                        if (l[((i[u + 160 >> 2] + Z(F, 3) | 0) + Z(Z(E, c), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                        if ((V | 0) >= (T | 0)) break l;
                                                                                                        break w;
                                                                                                    }
                                                                                                    if ((V | 0) < (T | 0)) break w;
                                                                                                }
                                                                                                w = Z(B, P), i[h + 316 >> 2] || (Q[h + 320 >> 1] = I[((M + (G << 1) | 0) + (s << 1) | 0) + (w << 1) >> 1]), T = s | 1, u = M + (s << 1) | 0, Q[i[h >> 2] + (T << 1) >> 1] = I[(u + (G << 1) | 0) + (w << 1) >> 1], o[T + i[h + 292 >> 2] | 0] = 1, w = s | 2, Q[i[h >> 2] + (w << 1) >> 1] = I[((u + (i[h + 16 >> 2] << 1) | 0) + (Z(B, i[h + 20 >> 2] - 1 | 0) << 1) | 0) + 2 >> 1], o[w + i[h + 292 >> 2] | 0] = 1, w = s | 3, Q[i[h >> 2] + (w << 1) >> 1] = I[((u + (i[h + 16 >> 2] << 1) | 0) + (Z(B, i[h + 20 >> 2] - 1 | 0) << 1) | 0) + 4 >> 1], o[w + i[h + 292 >> 2] | 0] = 1, w = s + 4 | 0, Q[i[h >> 2] + (w << 1) >> 1] = I[((u + (i[h + 16 >> 2] << 1) | 0) + (Z(B, i[h + 20 >> 2] - 1 | 0) << 1) | 0) + 6 >> 1], o[w + i[h + 292 >> 2] | 0] = 1, i[h + 316 >> 2] = i[h + 316 >> 2] + 4, w = i[h + 312 >> 2];
                                                                                            }
                                                                                            if (s = s + 4 | 0, !((w | 0) > (s | 0))) break;
                                                                                        }
                                                                                        break u;
                                                                                    }
                                                                                    break o;
                                                                                }
                                                                                s = i[W + 328 >> 2], u = i[W + 20 >> 2], G = u << 2, w = G | 1;
                                                                                u: {
                                                                                    if ((s | 0) == (w | 0)) break u;
                                                                                    if (!s) {
                                                                                        if (h = 0, B = u << 1, s = 0 - B | 0, (s | 0) > (B | 0)) break u;
                                                                                        for(V = w & 5, u = 1 << i[i[i[W + 16 >> 2] + 124 >> 2] + (i[W + 24 >> 2] ? 16840 : 16832) >> 2] - 1, w = i[W + 12 >> 2]; Q[w + (s << 1) >> 1] = u, s = s + 1 | 0, h = h + 1 | 0, (V | 0) != (h | 0););
                                                                                        if (G >>> 0 < 7) break u;
                                                                                        for(G = w + 12 | 0, V = w + 10 | 0, M = w + 8 | 0, T = w + 6 | 0, F = w + 4 | 0, E = w + 2 | 0; h = s << 1, Q[h + w >> 1] = u, Q[h + E >> 1] = u, Q[h + F >> 1] = u, Q[h + T >> 1] = u, Q[h + M >> 1] = u, Q[h + V >> 1] = u, Q[h + G >> 1] = u, h = s + 7 | 0, Q[w + (h << 1) >> 1] = u, s = s + 8 | 0, (h | 0) != (B | 0););
                                                                                        break u;
                                                                                    }
                                                                                    if (u = u << 1, s = 0 - u | 0, w = i[W + 304 >> 2], l[w - u | 0] || (Q[i[W + 12 >> 2] + (s << 1) >> 1] = I[W + 332 >> 1]), (u | 0) <= (s | 0)) break u;
                                                                                    for(s = s | 1, h = i[W + 12 >> 2]; l[s + w | 0] || (B = h + (s << 1) | 0, Q[B >> 1] = I[B - 2 >> 1]), B = s + 1 | 0, l[B + w | 0] || (G = h + (B << 1) | 0, Q[G >> 1] = I[G - 2 >> 1]), s = s + 2 | 0, (u | 0) != (B | 0););
                                                                                }
                                                                                m = W + 336 | 0;
                                                                                break s;
                                                                            }
                                                                            break t;
                                                                        }
                                                                        s = i[y + 124 >> 2];
                                                                        s: {
                                                                            if (l[s + 16825 | 0] || k && (v = k, i[s + 16848 >> 2] != 3)) break s;
                                                                            w = m - 272 | 0, m = w;
                                                                            u: {
                                                                                if ((f | 0) == 4 | (C | 0) == 1) break u;
                                                                                u = (C | 0) < 26 ? 26 - C | 0 : C - 26 | 0, h = (C | 0) < 10 ? 10 - C | 0 : C - 10 | 0, u = (u | 0) < (h | 0) ? u : h;
                                                                                w: {
                                                                                    l: switch(b0(f - 8 | 0, 29) | 0){
                                                                                        case 1:
                                                                                            if ((u | 0) > 1) break w;
                                                                                            break u;
                                                                                        case 3:
                                                                                            if ((u | 0) > 0) break w;
                                                                                            break u;
                                                                                        case 7:
                                                                                            break u;
                                                                                        case 0:
                                                                                            break l;
                                                                                        default:
                                                                                            break n;
                                                                                    }
                                                                                    if ((u | 0) < 8) break u;
                                                                                }
                                                                                w: {
                                                                                    l: {
                                                                                        h: {
                                                                                            if (!(!l[s + 8997 | 0] | (v | (f | 0) != 32)) && (v = I[_ + 128 >> 1], u = I[_ >> 1], W = (v + u | 0) - (I[_ + 64 >> 1] << 1) | 0, h = W >> 31, B = 1 << i[s + 512 >> 2] - 5, (B | 0) > ((h ^ W) - h | 0))) break h;
                                                                                            s = w + 128 | 0;
                                                                                            break l;
                                                                                        }
                                                                                        if (s = w + 128 | 0, h = I[_ - 128 >> 1], G = (h + u | 0) - (I[_ + -64 >> 1] << 1) | 0, W = G >> 31, B >>> 0 <= (W ^ G) - W >>> 0) break l;
                                                                                        for(Q[w + 256 >> 1] = v, Q[w >> 1] = h, Q[w + 128 >> 1] = u, W = v - u | 0, B = h - u | 0, v = 1;;){
                                                                                            if (h = v << 1, Q[s - h >> 1] = u + (Z(v, B) + 32 >>> 6 | 0), Q[s + h >> 1] = u + (Z(v, W) + 32 >>> 6 | 0), h = v + 1 | 0, (h | 0) != 64) {
                                                                                                Q[((v ^ -1) << 1) + s >> 1] = u + (Z(h, B) + 32 >>> 6 | 0), Q[(h << 1) + s >> 1] = u + (Z(h, W) + 32 >>> 6 | 0), v = v + 2 | 0;
                                                                                                continue;
                                                                                            }
                                                                                            break;
                                                                                        }
                                                                                        G = 0 - (f << 1) | 0;
                                                                                        break w;
                                                                                    }
                                                                                    if (u = w + 128 | 0, v = f << 2, Q[u - v >> 1] = I[_ - v >> 1], Q[u + v >> 1] = I[v + _ >> 1], h = f << 1, G = 0 - h | 0, v = 1 - h | 0, (v | 0) >= (h | 0)) break w;
                                                                                    for(B = v << 1, M = _ - 2 | 0, v = 2 - h | 0, W = I[_ + (v << 1) >> 1], Q[B + u >> 1] = (I[M + B >> 1] + (W + (I[_ + B >> 1] << 1) | 0) | 0) + 2 >>> 2; B = v << 1, T = B + 2 | 0, V = I[T + _ >> 1], Q[u + B >> 1] = (I[B + M >> 1] + (V + (W << 1) | 0) | 0) + 2 >>> 2, v = v + 2 | 0, W = I[_ + (v << 1) >> 1], Q[u + T >> 1] = (I[_ + B >> 1] + (W + (V << 1) | 0) | 0) + 2 >>> 2, (h | 0) != (v | 0););
                                                                                }
                                                                                u = G << 1, v0(u + _ | 0, u + s | 0, f << 3 | 2);
                                                                            }
                                                                            m = w + 272 | 0;
                                                                        }
                                                                        s: {
                                                                            u: switch(C | 0){
                                                                                case 0:
                                                                                    if (w = 1, (f | 0) >= 2) {
                                                                                        for(s = 0, u = f; w = s, s = s + 1 | 0, v = u >>> 0 > 3, u = u >>> 1 | 0, !!v;);
                                                                                        w = w + 2 | 0;
                                                                                    }
                                                                                    if ((f | 0) <= 0) break s;
                                                                                    for(T = f & 2147483646, F = f & 1, v = f - 1 | 0, E = I[_ + ((f ^ -1) << 1) >> 1], h = I[(_ + (f << 1) | 0) + 2 >> 1], u = 0;;){
                                                                                        if (C = v - u | 0, s = u + 1 | 0, y = Z(s, E), W = R + (Z(u, H) << 1) | 0, B = I[_ + ((u ^ -1) << 1) >> 1], u = 0, G = 0, (f | 0) != 1) for(; V = u | 1, M = V << 1, Q[W + (u << 1) >> 1] = y + (((Z(B, v - u | 0) + f | 0) + Z(h, V) | 0) + Z(C, I[_ + M >> 1]) | 0) >> w, u = u + 2 | 0, Q[W + M >> 1] = y + (((Z(B, v - V | 0) + f | 0) + Z(h, u) | 0) + Z(C, I[_ + (u << 1) >> 1]) | 0) >> w, G = G + 2 | 0, (T | 0) != (G | 0););
                                                                                        if (F && (P = W + (u << 1) | 0, B = Z(B, v - u | 0) + f | 0, u = u + 1 | 0, Q[P >> 1] = y + ((B + Z(u, h) | 0) + Z(C, I[_ + (u << 1) >> 1]) | 0) >> w), u = s, (u | 0) == (f | 0)) break;
                                                                                    }
                                                                                    break s;
                                                                                case 1:
                                                                                    if (s = 0, v = 1, (f | 0) >= 2) {
                                                                                        for(u = f; w = s, s = s + 1 | 0, v = u >>> 0 > 3, u = u >>> 1 | 0, !!v;);
                                                                                        v = w + 2 | 0;
                                                                                    }
                                                                                    w: {
                                                                                        l: {
                                                                                            h: {
                                                                                                v: {
                                                                                                    if ((f | 0) > 0) {
                                                                                                        if (C = f & 1, (f | 0) != 1) break v;
                                                                                                        w = 0, s = 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (k) break w;
                                                                                                    u = f >> v;
                                                                                                    break l;
                                                                                                }
                                                                                                for(y = f & 2147483646, u = 0, s = 0, h = 0; w = u + 2 | 0, s = I[_ + ((u ^ 2147483646) << 1) >> 1] + (I[_ + (w << 1) >> 1] + (I[_ + ((u ^ -1) << 1) >> 1] + (I[(_ + (u << 1) | 0) + 2 >> 1] + s | 0) | 0) | 0) | 0, u = w, h = h + 2 | 0, (y | 0) != (h | 0););
                                                                                            }
                                                                                            if (C && (s = I[_ + ((w ^ -1) << 1) >> 1] + (I[(_ + (w << 1) | 0) + 2 >> 1] + s | 0) | 0), u = f + s >> v, !k & (f | 0) <= 31) break l;
                                                                                            if ((f | 0) <= 0) break w;
                                                                                            for(y = f & 2147483640, _ = f & 7, w = 0, W = f >>> 0 < 8;;){
                                                                                                if (C = R + (Z(w, H) << 1) | 0, s = 0, h = 0, !W) for(; v = C + (s << 1) | 0, Q[v >> 1] = u, Q[v + 2 >> 1] = u, Q[v + 4 >> 1] = u, Q[v + 6 >> 1] = u, Q[v + 8 >> 1] = u, Q[v + 10 >> 1] = u, Q[v + 12 >> 1] = u, Q[v + 14 >> 1] = u, s = s + 8 | 0, h = h + 8 | 0, (y | 0) != (h | 0););
                                                                                                if (h = 0, _) for(; Q[C + (s << 1) >> 1] = u, s = s + 1 | 0, h = h + 1 | 0, (_ | 0) != (h | 0););
                                                                                                if (w = w + 1 | 0, (w | 0) == (f | 0)) break;
                                                                                            }
                                                                                            break w;
                                                                                        }
                                                                                        if (s = 1, Q[R >> 1] = (I[_ + 2 >> 1] + (I[_ - 2 >> 1] + (u << 1) | 0) | 0) + 2 >>> 2, (f | 0) < 2) break w;
                                                                                        if (v = f - 1 | 0, y = v & 3, C = Z(u, 3) + 2 | 0, W = f - 2 | 0, W >>> 0 >= 3) for(G = v & -4, w = 0; h = s << 1, B = h + 2 | 0, Q[h + R >> 1] = C + I[_ + B >> 1] >>> 2, F = B + R | 0, B = h + 4 | 0, Q[F >> 1] = C + I[B + _ >> 1] >>> 2, h = h + 6 | 0, Q[B + R >> 1] = C + I[h + _ >> 1] >>> 2, s = s + 4 | 0, Q[h + R >> 1] = C + I[_ + (s << 1) >> 1] >>> 2, w = w + 4 | 0, (G | 0) != (w | 0););
                                                                                        if (y) for(h = 0; w = R + (s << 1) | 0, s = s + 1 | 0, Q[w >> 1] = C + I[_ + (s << 1) >> 1] >>> 2, h = h + 1 | 0, (y | 0) != (h | 0););
                                                                                        if ((f | 0) < 2) break w;
                                                                                        if (s = 1, w = Z(u, 3) + 2 | 0, W) for(C = v & -2, h = 0; Q[R + (Z(s, H) << 1) >> 1] = w + I[_ + ((s ^ -1) << 1) >> 1] >>> 2, Q[R + (Z(H, s + 1 | 0) << 1) >> 1] = w + I[_ + (-2 - s << 1) >> 1] >>> 2, s = s + 2 | 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                                                                        if (v & 1 && (Q[R + (Z(s, H) << 1) >> 1] = w + I[_ + ((s ^ -1) << 1) >> 1] >>> 2), (f | 0) < 2) break w;
                                                                                        for(y = v & -8, C = v & 7, w = 1;;){
                                                                                            if (v = R + (Z(w, H) << 1) | 0, s = 1, W >>> 0 >= 7) for(B = v + 14 | 0, G = v + 12 | 0, V = v + 10 | 0, M = v + 8 | 0, T = v + 6 | 0, F = v + 4 | 0, E = v + 2 | 0, h = 0; _ = s << 1, Q[_ + v >> 1] = u, Q[_ + E >> 1] = u, Q[_ + F >> 1] = u, Q[_ + T >> 1] = u, Q[_ + M >> 1] = u, Q[_ + V >> 1] = u, Q[_ + G >> 1] = u, Q[_ + B >> 1] = u, s = s + 8 | 0, h = h + 8 | 0, (y | 0) != (h | 0););
                                                                                            if (h = 0, C) for(; Q[v + (s << 1) >> 1] = u, s = s + 1 | 0, h = h + 1 | 0, (C | 0) != (h | 0););
                                                                                            if (w = w + 1 | 0, (w | 0) == (f | 0)) break;
                                                                                        }
                                                                                    }
                                                                                    break s;
                                                                                default:
                                                                                    break u;
                                                                            }
                                                                            if (u = i[y + 124 >> 2], T = i[u + (k ? 16840 : 16832) >> 2], l[u + 16822 | 0]) {
                                                                                if (s = i[y + 168 >> 2], u = r >> s, (u | 0) < 0 || (w = i[y + 172 >> 2], (w | 0) <= (u | 0))) break e;
                                                                                if (s = e >> s, (s | 0) < 0 | (s | 0) >= i[y + 176 >> 2]) break i;
                                                                                w = (l[((i[y + 160 >> 2] + Z(u, 3) | 0) + Z(Z(s, w), 3) | 0) + 1 | 0] & 8) >>> 3 | 0;
                                                                            } else w = 0;
                                                                            u = 0, v = 0, y = m - 528 | 0, m = y;
                                                                            u: {
                                                                                w: {
                                                                                    l: {
                                                                                        if ((C | 0) < 35) {
                                                                                            if ((C | 0) > 1) {
                                                                                                if (h = y + 256 | 0, W = i[(C << 2) + 50672 >> 2], C >>> 0 <= 17) {
                                                                                                    h: {
                                                                                                        if ((f | 0) < 0) break h;
                                                                                                        if (s = f + 1 | 0, B = s & 3, f >>> 0 >= 3) for(G = s & -4; s = u << 1, Q[s + h >> 1] = I[_ - s >> 1], V = s | 2, Q[V + h >> 1] = I[_ - V >> 1], V = s | 4, Q[V + h >> 1] = I[_ - V >> 1], s = s | 6, Q[s + h >> 1] = I[_ - s >> 1], u = u + 4 | 0, v = v + 4 | 0, (G | 0) != (v | 0););
                                                                                                        if (!B) break h;
                                                                                                        for(s = 0; v = u << 1, Q[v + h >> 1] = I[_ - v >> 1], u = u + 1 | 0, s = s + 1 | 0, (B | 0) != (s | 0););
                                                                                                    }
                                                                                                    if (s = C - 11 | 0, s >>> 0 < 15) break l;
                                                                                                    if (B = f << 1, (B | 0) <= (f | 0)) break w;
                                                                                                    if (u = f, G = u & 3, G) for(v = 0, s = u; u = s + 1 | 0, Q[h + (u << 1) >> 1] = I[_ + ((s ^ -1) << 1) >> 1], s = u, v = v + 1 | 0, (G | 0) != (v | 0););
                                                                                                    if (f - 1 >>> 0 < 3) break w;
                                                                                                    for(v = h + 6 | 0, G = h + 4 | 0, V = h + 2 | 0; s = u << 1, Q[s + V >> 1] = I[_ + ((u ^ -1) << 1) >> 1], Q[s + G >> 1] = I[_ + (-2 - u << 1) >> 1], Q[s + v >> 1] = I[_ + (-3 - u << 1) >> 1], s = u + 4 | 0, Q[h + (s << 1) >> 1] = I[_ + (-4 - u << 1) >> 1], u = s, (u | 0) != (B | 0););
                                                                                                    break w;
                                                                                                }
                                                                                                (f | 0) >= 0 && v0(h, _, (f << 1) + 2 | 0), s = C - 11 | 0;
                                                                                                h: {
                                                                                                    if (s >>> 0 >= 15) {
                                                                                                        if (u = f << 1, (u | 0) <= (f | 0)) break h;
                                                                                                        v0((u + y | 0) + 258 | 0, (u + _ | 0) + 2 | 0, u);
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (v = Z(f, W), u = v >> 5, (u | 0) > -2) break h;
                                                                                                    for(s = i[(s << 2) + 50816 >> 2], v & 32 && (Q[h + (u << 1) >> 1] = I[_ - (Z(u, s) + 128 >> 8 << 1) >> 1], u = u + 1 | 0); Q[h + (u << 1) >> 1] = I[_ - (Z(u, s) + 128 >> 8 << 1) >> 1], v = u + 1 | 0, Q[h + (v << 1) >> 1] = I[_ - (Z(s, v) + 128 >> 8 << 1) >> 1], u = u + 2 | 0, !!u;);
                                                                                                }
                                                                                                if ((f | 0) > 0) for(P = y + 258 | 0, $ = f & 2147483646, c = f & 1, r0 = f << 1, L = H << 1, s = 0;;){
                                                                                                    u = s, s = u + 1 | 0, B = Z(W, s), v = B >> 5 << 1, B = B & 31;
                                                                                                    h: {
                                                                                                        if (B) {
                                                                                                            if (G = R + (Z(u, H) << 1) | 0, V = 32 - B | 0, M = h + v | 0, u = 0, (f | 0) != 1) for(q = M + 4 | 0, v = 0; F = u << 1, s0 = F + M | 0, E = I[s0 + 4 >> 1], Q[G + F >> 1] = (Z(V, I[s0 + 2 >> 1]) + Z(B, E) | 0) + 16 >>> 5, F = F | 2, Q[F + G >> 1] = (Z(V, E) + Z(B, I[F + q >> 1]) | 0) + 16 >>> 5, u = u + 2 | 0, v = v + 2 | 0, ($ | 0) != (v | 0););
                                                                                                            if (!c) break h;
                                                                                                            v = u << 1, u = v + M | 0, Q[v + G >> 1] = (Z(V, I[u + 2 >> 1]) + Z(B, I[u + 4 >> 1]) | 0) + 16 >>> 5;
                                                                                                            break h;
                                                                                                        }
                                                                                                        v0(R + Z(u, L) | 0, v + P | 0, r0);
                                                                                                    }
                                                                                                    if ((f | 0) == (s | 0)) break;
                                                                                                }
                                                                                                if ((C | 0) != 26 | f - 32 >>> 0 < 4294967265 | (k | w)) break u;
                                                                                                for(s = -1 << T ^ -1, u = 0; w = I[_ + 2 >> 1] + (I[_ + ((u ^ -1) << 1) >> 1] - I[_ >> 1] >> 1) | 0, Q[R + (Z(u, H) << 1) >> 1] = (w | 0) >= 0 ? (s | 0) > (w | 0) ? w : s : 0, u = u + 1 | 0, (u | 0) != (f | 0););
                                                                                                break u;
                                                                                            }
                                                                                            break k;
                                                                                        }
                                                                                        break f;
                                                                                    }
                                                                                    if (v = Z(f, W), u = v >> 5, (u | 0) > -2) break w;
                                                                                    for(s = i[(s << 2) + 50816 >> 2], v & 32 && (Q[h + (u << 1) >> 1] = I[_ + (Z(u, s) + 128 >> 8 << 1) >> 1], u = u + 1 | 0); Q[h + (u << 1) >> 1] = I[_ + (Z(u, s) + 128 >> 8 << 1) >> 1], v = u + 1 | 0, Q[h + (v << 1) >> 1] = I[_ + (Z(s, v) + 128 >> 8 << 1) >> 1], u = u + 2 | 0, !!u;);
                                                                                }
                                                                                if ((f | 0) > 0) for(G = y + 258 | 0, v = 0;;){
                                                                                    for(u = v << 1, V = u + G | 0, M = u + h | 0, F = R + (Z(v, H) << 1) | 0, u = 0;;){
                                                                                        s = u + 1 | 0, E = Z(s, W), B = E >> 5, P = F + (u << 1) | 0, u = E & 31;
                                                                                        w: {
                                                                                            if (u) {
                                                                                                B = M + (B << 1) | 0, u = (Z(I[B + 2 >> 1], 32 - u | 0) + Z(u, I[B + 4 >> 1]) | 0) + 16 >>> 5 | 0;
                                                                                                break w;
                                                                                            }
                                                                                            u = I[V + (B << 1) >> 1];
                                                                                        }
                                                                                        if (Q[P >> 1] = u, u = s, (u | 0) == (f | 0)) break;
                                                                                    }
                                                                                    if (v = v + 1 | 0, (v | 0) == (f | 0)) break;
                                                                                }
                                                                                if ((C | 0) != 10 | f - 32 >>> 0 < 4294967265 | (k | w)) break u;
                                                                                if (w = _ - 2 | 0, u = -1 << T ^ -1, s = 0, (f | 0) != 1) for(C = f & 30, h = 0; H = s << 1, W = H | 2, v = I[w >> 1] + (I[W + _ >> 1] - I[_ >> 1] >> 1) | 0, Q[R + H >> 1] = (v | 0) >= 0 ? (u | 0) > (v | 0) ? v : u : 0, s = s + 2 | 0, v = I[w >> 1] + (I[_ + (s << 1) >> 1] - I[_ >> 1] >> 1) | 0, Q[W + R >> 1] = (v | 0) >= 0 ? (u | 0) > (v | 0) ? v : u : 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                                                                if (!(f & 1)) break u;
                                                                                v = I[w >> 1], w = s << 1, s = v + (I[(w + _ | 0) + 2 >> 1] - I[_ >> 1] >> 1) | 0, Q[w + R >> 1] = (s | 0) >= 0 ? (u | 0) > (s | 0) ? s : u : 0;
                                                                            }
                                                                            m = y + 528 | 0;
                                                                        }
                                                                        m = S + 528 | 0;
                                                                        break A;
                                                                    }
                                                                    R = (u + s | 0) + r | 0, T = m - 272 | 0, m = T, W = m - 336 | 0, m = W, i[W + 24 >> 2] = k, i[W + 16 >> 2] = y, i[W + 32 >> 2] = e, i[W + 28 >> 2] = r, _ = T + 128 | 0, i[W + 12 >> 2] = _, i[W + 20 >> 2] = f;
                                                                    s: {
                                                                        if ((f | 0) < 65) {
                                                                            i[W + 316 >> 2] = 16843009, h = W + 12 | 0, p5(h);
                                                                            u: {
                                                                                if (i[h + 8 >> 2] < 33) {
                                                                                    if (s = i[h + 4 >> 2], u = i[h + 12 >> 2], B = i[s + (u ? 44 : 40) >> 2], w = i[h + 24 >> 2], G = i[w + 16936 >> 2], G = i[(i[i[h + 28 >> 2] + 8496 >> 2] + (Z(i[h + 296 >> 2], i[h + 16 >> 2]) >> G << 2) | 0) + (Z(i[w + 16924 >> 2], Z(i[h + 300 >> 2], i[h + 20 >> 2]) >> G) << 2) >> 2], V = i[(s + (u << 2) | 0) + 4 >> 2], u = i[h + 308 >> 2], !(l[h + 304 | 0] != 1 | (u | 0) <= 0)) for(s = V - 1 | 0, w = u - 1 | 0;;){
                                                                                        u = w;
                                                                                        w: {
                                                                                            if (l[h + 304 | 0] != 1) break w;
                                                                                            S = i[h + 28 >> 2], E = i[h + 16 >> 2], F = Z(i[h + 296 >> 2], E - 1 | 0), M = i[h + 24 >> 2], P = i[M + 16936 >> 2], $ = u + i[h + 20 >> 2] | 0, c = Z($, i[h + 300 >> 2]), M = i[(i[S + 8496 >> 2] + (F >> P << 2) | 0) + (Z(i[M + 16924 >> 2], c >> P) << 2) >> 2];
                                                                                            l: {
                                                                                                if (l[S + 24 | 0]) {
                                                                                                    if (S = F, w = i[h + 4 >> 2], F = i[w + 168 >> 2], S = S >> F, (S | 0) < 0 || (P = i[w + 172 >> 2], (P | 0) <= (S | 0))) break e;
                                                                                                    if (F = c >> F, (F | 0) < 0 | (F | 0) >= i[w + 176 >> 2]) break i;
                                                                                                    if (l[((i[w + 160 >> 2] + Z(S, 3) | 0) + Z(Z(F, P), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                    if ((G | 0) >= (M | 0)) break l;
                                                                                                    break w;
                                                                                                }
                                                                                                if ((G | 0) < (M | 0)) break w;
                                                                                            }
                                                                                            i[h + 316 >> 2] || (o[h + 320 | 0] = l[(s + E | 0) + Z(B, $) | 0]), w = u ^ -1, o[w + i[h + 292 >> 2] | 0] = 1, o[w + i[h >> 2] | 0] = l[(s + i[h + 16 >> 2] | 0) + Z(B, u + i[h + 20 >> 2] | 0) | 0], o[i[h + 292 >> 2] - u | 0] = 1, o[i[h >> 2] - u | 0] = l[(s + i[h + 16 >> 2] | 0) + Z(B, (u + i[h + 20 >> 2] | 0) - 1 | 0) | 0], w = 1 - u | 0, o[w + i[h + 292 >> 2] | 0] = 1, o[w + i[h >> 2] | 0] = l[(s + i[h + 16 >> 2] | 0) + Z(B, (u + i[h + 20 >> 2] | 0) - 2 | 0) | 0], w = 2 - u | 0, o[w + i[h + 292 >> 2] | 0] = 1, o[w + i[h >> 2] | 0] = l[(s + i[h + 16 >> 2] | 0) + Z(B, (u + i[h + 20 >> 2] | 0) - 3 | 0) | 0], i[h + 316 >> 2] = i[h + 316 >> 2] + 4;
                                                                                        }
                                                                                        if (w = u - 4 | 0, !((u | 0) > 3)) break;
                                                                                    }
                                                                                    w: {
                                                                                        if (!l[h + 307 | 0]) break w;
                                                                                        u = i[h + 28 >> 2], s = i[h + 16 >> 2], M = Z(i[h + 296 >> 2], s - 1 | 0), w = i[h + 24 >> 2], S = i[w + 16936 >> 2], F = i[h + 20 >> 2] - 1 | 0, E = Z(F, i[h + 300 >> 2]), w = i[(i[u + 8496 >> 2] + (M >> S << 2) | 0) + (Z(i[w + 16924 >> 2], E >> S) << 2) >> 2];
                                                                                        l: {
                                                                                            if (l[u + 24 | 0]) {
                                                                                                if (u = i[h + 4 >> 2], S = i[u + 168 >> 2], M = M >> S, (M | 0) < 0 || (P = i[u + 172 >> 2], (P | 0) <= (M | 0))) break e;
                                                                                                if (S = E >> S, (S | 0) < 0 | (S | 0) >= i[u + 176 >> 2]) break i;
                                                                                                if (l[((i[u + 160 >> 2] + Z(M, 3) | 0) + Z(Z(S, P), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                if ((w | 0) <= (G | 0)) break l;
                                                                                                break w;
                                                                                            }
                                                                                            if ((w | 0) > (G | 0)) break w;
                                                                                        }
                                                                                        u = Z(B, F), i[h + 316 >> 2] || (o[h + 320 | 0] = l[(u + (s + V | 0) | 0) - 1 | 0]), o[i[h >> 2]] = l[(u + (s + V | 0) | 0) - 1 | 0], o[i[h + 292 >> 2]] = 1, i[h + 316 >> 2] = i[h + 316 >> 2] + 1;
                                                                                    }
                                                                                    if (w = i[h + 312 >> 2], (w | 0) > 0) for(s = 0;;){
                                                                                        w: {
                                                                                            if (l[h + (i[h + 8 >> 2] > (s | 0) ? 305 : 306) | 0] != 1) break w;
                                                                                            u = i[h + 28 >> 2], M = i[h + 16 >> 2], F = Z(i[h + 296 >> 2], M + s | 0), S = i[h + 24 >> 2], E = i[S + 16936 >> 2], P = i[h + 20 >> 2] - 1 | 0, $ = Z(P, i[h + 300 >> 2]), S = i[(i[u + 8496 >> 2] + (F >> E << 2) | 0) + (Z(i[S + 16924 >> 2], $ >> E) << 2) >> 2];
                                                                                            l: {
                                                                                                if (l[u + 24 | 0]) {
                                                                                                    if (u = i[h + 4 >> 2], E = i[u + 168 >> 2], F = F >> E, (F | 0) < 0 || (c = i[u + 172 >> 2], (c | 0) <= (F | 0))) break e;
                                                                                                    if (E = $ >> E, (E | 0) < 0 | (E | 0) >= i[u + 176 >> 2]) break i;
                                                                                                    if (l[((i[u + 160 >> 2] + Z(F, 3) | 0) + Z(Z(E, c), 3) | 0) + 1 | 0] & 3) break w;
                                                                                                    if ((G | 0) >= (S | 0)) break l;
                                                                                                    break w;
                                                                                                }
                                                                                                if ((G | 0) < (S | 0)) break w;
                                                                                            }
                                                                                            w = Z(B, P), i[h + 316 >> 2] || (o[h + 320 | 0] = l[w + ((V + M | 0) + s | 0) | 0]), S = s | 1, u = s + V | 0, o[S + i[h >> 2] | 0] = l[w + (u + M | 0) | 0], o[S + i[h + 292 >> 2] | 0] = 1, w = s | 2, o[w + i[h >> 2] | 0] = l[((u + i[h + 16 >> 2] | 0) + Z(B, i[h + 20 >> 2] - 1 | 0) | 0) + 1 | 0], o[w + i[h + 292 >> 2] | 0] = 1, w = s | 3, o[w + i[h >> 2] | 0] = l[((u + i[h + 16 >> 2] | 0) + Z(B, i[h + 20 >> 2] - 1 | 0) | 0) + 2 | 0], o[w + i[h + 292 >> 2] | 0] = 1, w = s + 4 | 0, o[w + i[h >> 2] | 0] = l[((u + i[h + 16 >> 2] | 0) + Z(B, i[h + 20 >> 2] - 1 | 0) | 0) + 3 | 0], o[w + i[h + 292 >> 2] | 0] = 1, i[h + 316 >> 2] = i[h + 316 >> 2] + 4, w = i[h + 312 >> 2];
                                                                                        }
                                                                                        if (s = s + 4 | 0, !((w | 0) > (s | 0))) break;
                                                                                    }
                                                                                    break u;
                                                                                }
                                                                                break o;
                                                                            }
                                                                            u = i[W + 328 >> 2], w = i[W + 20 >> 2], s = w << 2 | 1;
                                                                            u: {
                                                                                if ((u | 0) == (s | 0)) break u;
                                                                                if (!u) {
                                                                                    B0(i[W + 12 >> 2] - (w << 1) | 0, 1 << i[i[i[W + 16 >> 2] + 124 >> 2] + (i[W + 24 >> 2] ? 16840 : 16832) >> 2] - 1, s);
                                                                                    break u;
                                                                                }
                                                                                if (u = w << 1, s = 0 - u | 0, l[i[W + 304 >> 2] - u | 0] || (o[i[W + 12 >> 2] + s | 0] = l[W + 332 | 0], w = i[W + 20 >> 2], s = 0 - (w << 1) | 0), w << 1 <= (s | 0)) break u;
                                                                                for(s = s | 1; l[i[W + 304 >> 2] + s | 0] || (u = i[W + 12 >> 2] + s | 0, o[u | 0] = l[u - 1 | 0], w = i[W + 20 >> 2]), u = w << 1 > (s | 0), s = s + 1 | 0, !!u;);
                                                                            }
                                                                            m = W + 336 | 0;
                                                                            break s;
                                                                        }
                                                                        break t;
                                                                    }
                                                                    s = i[y + 124 >> 2];
                                                                    s: {
                                                                        if (l[s + 16825 | 0] || k && (v = k, i[s + 16848 >> 2] != 3)) break s;
                                                                        w = m - 144 | 0, m = w;
                                                                        u: {
                                                                            if ((f | 0) == 4 | (C | 0) == 1) break u;
                                                                            u = (C | 0) < 26 ? 26 - C | 0 : C - 26 | 0, h = (C | 0) < 10 ? 10 - C | 0 : C - 10 | 0, u = (u | 0) < (h | 0) ? u : h;
                                                                            w: {
                                                                                l: switch(b0(f - 8 | 0, 29) | 0){
                                                                                    case 1:
                                                                                        if ((u | 0) > 1) break w;
                                                                                        break u;
                                                                                    case 3:
                                                                                        if ((u | 0) > 0) break w;
                                                                                        break u;
                                                                                    case 7:
                                                                                        break u;
                                                                                    case 0:
                                                                                        break l;
                                                                                    default:
                                                                                        break n;
                                                                                }
                                                                                if ((u | 0) < 8) break u;
                                                                            }
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        if (!(!l[s + 8997 | 0] | (v | (f | 0) != 32)) && (v = l[_ + 64 | 0], u = l[_ | 0], W = (v + u | 0) - (l[_ + 32 | 0] << 1) | 0, h = W >> 31, B = 1 << i[s + 512 >> 2] - 5, (B | 0) > ((h ^ W) - h | 0))) break h;
                                                                                        s = w - -64 | 0;
                                                                                        break l;
                                                                                    }
                                                                                    if (s = w - -64 | 0, h = l[_ + -64 | 0], G = (h + u | 0) - (l[_ - 32 | 0] << 1) | 0, W = G >> 31, B >>> 0 <= (W ^ G) - W >>> 0) break l;
                                                                                    for(o[w + 128 | 0] = v, o[w | 0] = h, o[w + 64 | 0] = u, W = v - u | 0, B = h - u | 0, v = 1;;){
                                                                                        if (o[s - v | 0] = u + (Z(v, B) + 32 >>> 6 | 0), o[s + v | 0] = u + (Z(v, W) + 32 >>> 6 | 0), h = v + 1 | 0, (h | 0) != 64) {
                                                                                            o[(v ^ -1) + s | 0] = u + (Z(h, B) + 32 >>> 6 | 0), o[s + h | 0] = u + (Z(h, W) + 32 >>> 6 | 0), v = v + 2 | 0;
                                                                                            continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    h = 0 - (f << 1) | 0;
                                                                                    break w;
                                                                                }
                                                                                if (B = w - -64 | 0, u = f << 1, o[B - u | 0] = l[_ - u | 0], o[u + B | 0] = l[u + _ | 0], h = 0 - u | 0, G = 1 - u | 0, (G | 0) >= (u | 0)) break w;
                                                                                for(V = _ - 1 | 0, v = 2 - u | 0, W = l[_ + v | 0], o[B + G | 0] = (l[V + G | 0] + (W + (l[_ + G | 0] << 1) | 0) | 0) + 2 >>> 2; F = W << 1, W = v + 1 | 0, G = l[W + _ | 0], o[v + B | 0] = (l[v + V | 0] + (F + G | 0) | 0) + 2 >>> 2, F = B + W | 0, E = l[v + _ | 0], v = v + 2 | 0, W = l[_ + v | 0], o[F | 0] = (E + (W + (G << 1) | 0) | 0) + 2 >>> 2, (u | 0) != (v | 0););
                                                                            }
                                                                            v0(h + _ | 0, s + h | 0, f << 2 | 1);
                                                                        }
                                                                        m = w + 144 | 0;
                                                                    }
                                                                    s: {
                                                                        u: switch(C | 0){
                                                                            case 0:
                                                                                if (w = 1, (f | 0) >= 2) {
                                                                                    for(s = 0, u = f; w = s, s = s + 1 | 0, v = u >>> 0 > 3, u = u >>> 1 | 0, !!v;);
                                                                                    w = w + 2 | 0;
                                                                                }
                                                                                if ((f | 0) <= 0) break s;
                                                                                for(M = f & 2147483646, S = f & 1, v = f - 1 | 0, F = l[_ + (f ^ -1) | 0], C = l[(f + _ | 0) + 1 | 0], u = 0;;){
                                                                                    if (y = v - u | 0, s = u + 1 | 0, W = Z(s, F), B = R + Z(u, H) | 0, G = l[_ + (u ^ -1) | 0], u = 0, h = 0, (f | 0) != 1) for(; V = u | 1, o[u + B | 0] = W + (((Z(G, v - u | 0) + f | 0) + Z(V, C) | 0) + Z(y, l[_ + V | 0]) | 0) >> w, u = u + 2 | 0, o[B + V | 0] = W + (((Z(G, v - V | 0) + f | 0) + Z(C, u) | 0) + Z(y, l[u + _ | 0]) | 0) >> w, h = h + 2 | 0, (M | 0) != (h | 0););
                                                                                    if (S && (E = u + B | 0, P = Z(G, v - u | 0) + f | 0, u = u + 1 | 0, o[E | 0] = W + ((P + Z(u, C) | 0) + Z(y, l[u + _ | 0]) | 0) >> w), u = s, (u | 0) == (f | 0)) break;
                                                                                }
                                                                                break s;
                                                                            case 1:
                                                                                if (s = 0, h = 0, v = 1, (f | 0) >= 2) {
                                                                                    for(u = f; w = s, s = s + 1 | 0, v = u >>> 0 > 3, u = u >>> 1 | 0, !!v;);
                                                                                    v = w + 2 | 0;
                                                                                }
                                                                                w: {
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                if ((f | 0) > 0) {
                                                                                                    if (C = f & 1, (f | 0) != 1) break v;
                                                                                                    w = 0, s = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                if (k) break w;
                                                                                                s = f >> v;
                                                                                                break l;
                                                                                            }
                                                                                            for(y = f & 2147483646, u = 0, s = 0; w = u + 2 | 0, s = l[_ + (u ^ -2) | 0] + (l[_ + w | 0] + (l[_ + (u ^ -1) | 0] + (l[(u + _ | 0) + 1 | 0] + s | 0) | 0) | 0) | 0, u = w, h = h + 2 | 0, (y | 0) != (h | 0););
                                                                                        }
                                                                                        if (C && (s = l[_ + (w ^ -1) | 0] + (l[(w + _ | 0) + 1 | 0] + s | 0) | 0), s = f + s >> v, !k & (f | 0) <= 31) break l;
                                                                                        if ((f | 0) <= 0) break w;
                                                                                        if (u = 0, h = 0, f >>> 0 >= 4) for(v = f & 2147483644, w = 0; B0(R + Z(h, H) | 0, s, f), B0(R + Z(H, h | 1) | 0, s, f), B0(R + Z(H, h | 2) | 0, s, f), B0(R + Z(H, h | 3) | 0, s, f), h = h + 4 | 0, w = w + 4 | 0, (v | 0) != (w | 0););
                                                                                        if (w = f & 3, !w) break w;
                                                                                        for(; B0(R + Z(h, H) | 0, s, f), h = h + 1 | 0, u = u + 1 | 0, (w | 0) != (u | 0););
                                                                                        break w;
                                                                                    }
                                                                                    if (u = 1, o[R | 0] = (l[_ + 1 | 0] + (l[_ - 1 | 0] + (s << 1) | 0) | 0) + 2 >>> 2, (f | 0) < 2) break w;
                                                                                    if (C = f - 1 | 0, v = C & 3, w = Z(s, 3) + 2 | 0, y = f - 2 | 0, y >>> 0 >= 3) for(W = C & -4, h = 0; B = u + 1 | 0, o[u + R | 0] = w + l[B + _ | 0] >>> 2, F = B + R | 0, B = u + 2 | 0, o[F | 0] = w + l[B + _ | 0] >>> 2, F = B + R | 0, B = u + 3 | 0, o[F | 0] = w + l[B + _ | 0] >>> 2, u = u + 4 | 0, o[B + R | 0] = w + l[_ + u | 0] >>> 2, h = h + 4 | 0, (W | 0) != (h | 0););
                                                                                    if (v) for(h = 0; F = u + R | 0, u = u + 1 | 0, o[F | 0] = w + l[_ + u | 0] >>> 2, h = h + 1 | 0, (v | 0) != (h | 0););
                                                                                    if ((f | 0) < 2) break w;
                                                                                    if (u = 1, w = Z(s, 3) + 2 | 0, y) for(v = C & -2, h = 0; o[R + Z(u, H) | 0] = w + l[_ + (u ^ -1) | 0] >>> 2, o[R + Z(H, u + 1 | 0) | 0] = w + l[(_ - u | 0) - 2 | 0] >>> 2, u = u + 2 | 0, h = h + 2 | 0, (v | 0) != (h | 0););
                                                                                    if (C & 1 && (o[R + Z(u, H) | 0] = w + l[_ + (u ^ -1) | 0] >>> 2), (f | 0) < 2) break w;
                                                                                    if (u = f - 1 | 0, _ = (R + H | 0) + 1 | 0, w = 0, h = 0, y >>> 0 >= 3) for(y = C & -4, v = 0; B0(_ + Z(h, H) | 0, s, u), B0(_ + Z(H, h | 1) | 0, s, u), B0(_ + Z(H, h | 2) | 0, s, u), B0(_ + Z(H, h | 3) | 0, s, u), h = h + 4 | 0, v = v + 4 | 0, (y | 0) != (v | 0););
                                                                                    if (v = C & 3, !v) break w;
                                                                                    for(; B0(_ + Z(h, H) | 0, s, u), h = h + 1 | 0, w = w + 1 | 0, (v | 0) != (w | 0););
                                                                                }
                                                                                break s;
                                                                            default:
                                                                                break u;
                                                                        }
                                                                        if (u = i[y + 124 >> 2], S = i[u + (k ? 16840 : 16832) >> 2], l[u + 16822 | 0]) {
                                                                            if (s = i[y + 168 >> 2], u = r >> s, (u | 0) < 0 || (w = i[y + 172 >> 2], (w | 0) <= (u | 0))) break e;
                                                                            if (s = e >> s, (s | 0) < 0 | (s | 0) >= i[y + 176 >> 2]) break i;
                                                                            w = (l[((i[y + 160 >> 2] + Z(u, 3) | 0) + Z(Z(s, w), 3) | 0) + 1 | 0] & 8) >>> 3 | 0;
                                                                        } else w = 0;
                                                                        u = 0, y = m - 272 | 0, m = y;
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    if ((C | 0) < 35) {
                                                                                        if ((C | 0) > 1) {
                                                                                            if (h = y + 128 | 0, W = i[(C << 2) + 50672 >> 2], C >>> 0 <= 17) {
                                                                                                h: {
                                                                                                    if ((f | 0) < 0) break h;
                                                                                                    if (s = f + 1 | 0, v = s & 3, f >>> 0 >= 3) for(B = s & -4, s = 0; o[u + h | 0] = l[_ - u | 0], G = u | 1, o[G + h | 0] = l[_ - G | 0], G = u | 2, o[G + h | 0] = l[_ - G | 0], G = u | 3, o[G + h | 0] = l[_ - G | 0], u = u + 4 | 0, s = s + 4 | 0, (B | 0) != (s | 0););
                                                                                                    if (!v) break h;
                                                                                                    for(s = 0; o[u + h | 0] = l[_ - u | 0], u = u + 1 | 0, s = s + 1 | 0, (v | 0) != (s | 0););
                                                                                                }
                                                                                                if (s = C - 11 | 0, s >>> 0 < 15) break l;
                                                                                                if (B = f << 1, (B | 0) <= (f | 0)) break w;
                                                                                                if (u = f, G = u & 3, G) for(v = 0, s = u; u = s + 1 | 0, o[h + u | 0] = l[_ + (s ^ -1) | 0], s = u, v = v + 1 | 0, (G | 0) != (v | 0););
                                                                                                if (f - 1 >>> 0 < 3) break w;
                                                                                                for(v = h + 3 | 0, G = h + 2 | 0, V = h + 1 | 0; o[u + V | 0] = l[_ + (u ^ -1) | 0], s = _ - u | 0, o[u + G | 0] = l[s - 2 | 0], o[u + v | 0] = l[s - 3 | 0], u = u + 4 | 0, o[h + u | 0] = l[s - 4 | 0], (u | 0) != (B | 0););
                                                                                                break w;
                                                                                            }
                                                                                            (f | 0) >= 0 && v0(h, _, f + 1 | 0), s = C - 11 | 0;
                                                                                            h: {
                                                                                                if (s >>> 0 >= 15) {
                                                                                                    if (f << 1 <= (f | 0)) break h;
                                                                                                    v0((f + y | 0) + 129 | 0, (f + _ | 0) + 1 | 0, f);
                                                                                                    break h;
                                                                                                }
                                                                                                if (v = Z(f, W), u = v >> 5, (u | 0) > -2) break h;
                                                                                                for(s = i[(s << 2) + 50816 >> 2], v & 32 && (o[u + h | 0] = l[_ - (Z(u, s) + 128 >> 8) | 0], u = u + 1 | 0); o[u + h | 0] = l[_ - (Z(u, s) + 128 >> 8) | 0], v = u + 1 | 0, o[v + h | 0] = l[_ - (Z(s, v) + 128 >> 8) | 0], u = u + 2 | 0, !!u;);
                                                                                            }
                                                                                            if ((f | 0) > 0) for(E = y + 129 | 0, P = f & 2147483646, $ = f & 1, s = 0;;){
                                                                                                B = R + Z(s, H) | 0, s = s + 1 | 0, v = Z(W, s), u = v >> 5, G = v & 31;
                                                                                                h: {
                                                                                                    if (G) {
                                                                                                        if (V = u + h | 0, M = 32 - G | 0, u = 0, (f | 0) != 1) for(c = V + 2 | 0, v = 0; r0 = u + V | 0, F = l[r0 + 2 | 0], o[u + B | 0] = (Z(M, l[r0 + 1 | 0]) + Z(G, F) | 0) + 16 >>> 5, r0 = u | 1, o[r0 + B | 0] = (Z(F, M) + Z(G, l[c + r0 | 0]) | 0) + 16 >>> 5, u = u + 2 | 0, v = v + 2 | 0, (P | 0) != (v | 0););
                                                                                                        if (!$) break h;
                                                                                                        v = u + B | 0, u = u + V | 0, o[v | 0] = (Z(M, l[u + 1 | 0]) + Z(G, l[u + 2 | 0]) | 0) + 16 >>> 5;
                                                                                                        break h;
                                                                                                    }
                                                                                                    v0(B, u + E | 0, f);
                                                                                                }
                                                                                                if ((f | 0) == (s | 0)) break;
                                                                                            }
                                                                                            if ((C | 0) != 26 | f - 32 >>> 0 < 4294967265 | (k | w)) break u;
                                                                                            for(s = -1 << S ^ -1, u = 0; w = l[_ + 1 | 0] + (l[_ + (u ^ -1) | 0] - l[_ | 0] >> 1) | 0, o[R + Z(u, H) | 0] = (w | 0) >= 0 ? (s | 0) > (w | 0) ? w : s : 0, u = u + 1 | 0, (u | 0) != (f | 0););
                                                                                            break u;
                                                                                        }
                                                                                        break k;
                                                                                    }
                                                                                    break f;
                                                                                }
                                                                                if (v = Z(f, W), u = v >> 5, (u | 0) > -2) break w;
                                                                                for(s = i[(s << 2) + 50816 >> 2], v & 32 && (o[u + h | 0] = l[_ + (Z(u, s) + 128 >> 8) | 0], u = u + 1 | 0); o[u + h | 0] = l[_ + (Z(u, s) + 128 >> 8) | 0], v = u + 1 | 0, o[v + h | 0] = l[_ + (Z(s, v) + 128 >> 8) | 0], u = u + 2 | 0, !!u;);
                                                                            }
                                                                            if ((f | 0) > 0) for(G = y + 129 | 0, v = 0;;){
                                                                                for(V = v + G | 0, M = h + v | 0, F = R + Z(v, H) | 0, u = 0;;){
                                                                                    s = u + 1 | 0, E = Z(s, W), B = E >> 5, P = u + F | 0, u = E & 31;
                                                                                    w: {
                                                                                        if (u) {
                                                                                            B = B + M | 0, u = (Z(l[B + 1 | 0], 32 - u | 0) + Z(u, l[B + 2 | 0]) | 0) + 16 >>> 5 | 0;
                                                                                            break w;
                                                                                        }
                                                                                        u = l[B + V | 0];
                                                                                    }
                                                                                    if (o[P | 0] = u, u = s, (u | 0) == (f | 0)) break;
                                                                                }
                                                                                if (v = v + 1 | 0, (v | 0) == (f | 0)) break;
                                                                            }
                                                                            if ((C | 0) != 10 | f - 32 >>> 0 < 4294967265 | (k | w)) break u;
                                                                            if (w = _ - 1 | 0, s = -1 << S ^ -1, u = 0, (f | 0) != 1) for(C = f & 30, h = 0; H = u | 1, v = l[w | 0] + (l[H + _ | 0] - l[_ | 0] >> 1) | 0, o[u + R | 0] = (v | 0) >= 0 ? (s | 0) > (v | 0) ? v : s : 0, u = u + 2 | 0, v = l[w | 0] + (l[_ + u | 0] - l[_ | 0] >> 1) | 0, o[R + H | 0] = (v | 0) >= 0 ? (s | 0) > (v | 0) ? v : s : 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                                                            if (!(f & 1)) break u;
                                                                            v = u + R | 0, u = l[w | 0] + (l[(u + _ | 0) + 1 | 0] - l[_ | 0] >> 1) | 0, o[v | 0] = (u | 0) >= 0 ? (u | 0) < (s | 0) ? u : s : 0;
                                                                        }
                                                                        m = y + 272 | 0;
                                                                    }
                                                                    m = T + 272 | 0;
                                                                    break A;
                                                                }
                                                                y0(17957, 9042, 533, 11453), z();
                                                            }
                                                            y0(16253, 9042, 146, 3476), z();
                                                        }
                                                        y0(10076, 9042, 211, 9198), z();
                                                    }
                                                    y0(17865, 9042, 343, 6378), z();
                                                }
                                                y0(17694, 9042, 342, 6378), z();
                                            }
                                            u = 0, u = !l[f0 + 16822 | 0] | !(l[A + 32 | 0] | l[(A + k | 0) + 33 | 0]) ? u : (t0 & 47) == 10, u = (t0 | 0) == 26 ? u && 2 : u;
                                            break r;
                                        }
                                        if (u = 0, !l[A + 36 | 0]) break r;
                                        u = l[A + 37 | 0] ? 2 : 1;
                                    }
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (!t) {
                                                        if (!k | !i[A + 28 >> 2]) break k;
                                                        Q[((k << 1) + A | 0) + 14396 >> 1] = 0, u = 0;
                                                    }
                                                    B = l[(A + k | 0) + 33 | 0] != 0, w = !n, n = k ? 16840 : 16832;
                                                    n: {
                                                        if (i[n + i[i[A + 18588 >> 2] + 124 >> 2] >> 2] >= 9) {
                                                            t = A, W = m - 4096 | 0, m = W;
                                                            t: {
                                                                if (k >>> 0 < 3) {
                                                                    if (s = i[A + 18588 >> 2], h = i[s + 168 >> 2], v = r >> h, (v | 0) < 0 || (R = i[s + 172 >> 2], (R | 0) <= (v | 0))) break e;
                                                                    if (_ = e >> h, (_ | 0) < 0 | (_ | 0) >= i[s + 176 >> 2]) break i;
                                                                    G = k << 2, H = i[s + (k ? 44 : 40) >> 2], y = i[(G + s | 0) + 4 >> 2] + (Z(H, e) + r << 1) | 0, C = i[s + 124 >> 2], h = i[C + n >> 2], n = i[A + 2104 >> 2], r = 0, V = l[((i[s + 160 >> 2] + Z(v, 3) | 0) + Z(Z(_, R), 3) | 0) + 1 | 0] & 3, R = !V & (f | 0) == 4 & l[C + 16820 | 0] != 0;
                                                                    o: {
                                                                        if (l[A + 32 | 0]) {
                                                                            if (r = (A + (k << 1) | 0) + 14396 | 0, Q[r >> 1] > 0) for(A = 0, e = k << 11, s = e + (t + 8252 | 0) | 0, e = e + (t + 2108 | 0) | 0; w = A << 1, Q[n + (Q[w + s >> 1] << 1) >> 1] = I[e + w >> 1], A = A + 1 | 0, (A | 0) < Q[r >> 1];);
                                                                            if (R && p[i[i[t + 18584 >> 2] + 432 >> 2]](n, 4), w = t + 14404 | 0, s = k ? W : w, p[i[i[t + 18584 >> 2] + (u ? (u | 0) == 2 ? 368 : 372 : 364) >> 2]](s, n, f), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(A = i[i[t + 18588 >> 2] + 124 >> 2], u = i[A + 16832 >> 2], v = i[A + 16840 >> 2], B = f & 2147483646, G = f & 1, e = 0;;){
                                                                                if (_ = Z(e, f), A = 0, r = 0, (f | 0) != 1) for(; C = A + _ << 2, V = C + s | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[w + C >> 2] << v >> u) >> 3), C = C + 4 | 0, V = C + s | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[w + C >> 2] << v >> u) >> 3), A = A + 2 | 0, r = r + 2 | 0, (B | 0) != (r | 0););
                                                                                if (G && (A = A + _ << 2, r = A + s | 0, i[r >> 2] = i[r >> 2] + (Z(i[t + 28 >> 2], i[A + w >> 2] << v >> u) >> 3)), e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                                            }
                                                                            if (p[i[i[t + 18584 >> 2] + 460 >> 2]](y, H, s, f, h), !R) break o;
                                                                            Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, Q[n + 4 >> 1] = 0, Q[n + 6 >> 1] = 0, Q[n + 24 >> 1] = 0, Q[n + 26 >> 1] = 0, Q[n + 28 >> 1] = 0, Q[n + 30 >> 1] = 0, Q[n + 16 >> 1] = 0, Q[n + 18 >> 1] = 0, Q[n + 20 >> 1] = 0, Q[n + 22 >> 1] = 0, Q[n + 8 >> 1] = 0, Q[n + 10 >> 1] = 0, Q[n + 12 >> 1] = 0, Q[n + 14 >> 1] = 0;
                                                                            break o;
                                                                        }
                                                                        if ((f | 0) >= 2) for(A = f; r = r + 1 | 0, e = A >>> 0 > 3, A = A >>> 1 | 0, !!e;);
                                                                        _ = i[s + 132 >> 2], e = i[(t + G | 0) + 18536 >> 2], r = r + h | 0;
                                                                        s: {
                                                                            if (!l[C + 636 | 0]) {
                                                                                if (s = (t + (k << 1) | 0) + 14396 | 0, Q[s >> 1] <= 0) break s;
                                                                                for(e = i[((e | 0) % 6 << 2) + 51408 >> 2] << (e | 0) / 6, w = r - 9 | 0, v = 1 << r - 10, A = 0, r = k << 11, C = r + (t + 2108 | 0) | 0, G = r + (t + 8252 | 0) | 0; M = A << 1, r = v + Z(e, Q[M + C >> 1]) >> w, r = (r | 0) >= 32767 ? 32767 : r, Q[n + (Q[G + M >> 1] << 1) >> 1] = (r | 0) <= -32768 ? -32768 : r, A = A + 1 | 0, (A | 0) < Q[s >> 1];);
                                                                                break s;
                                                                            }
                                                                            A = k, s = A;
                                                                            u: {
                                                                                if (w || (s = A + 3 | 0, (f | 0) <= 31)) break u;
                                                                                s = A + 1 | 0;
                                                                            }
                                                                            A = s;
                                                                            u: {
                                                                                w: switch(b0(f - 4 | 0, 30) | 0){
                                                                                    case 1:
                                                                                        A = (_ + (A << 6) | 0) + 169 | 0;
                                                                                        break u;
                                                                                    case 3:
                                                                                        A = (_ + (A << 8) | 0) + 553 | 0;
                                                                                        break u;
                                                                                    case 7:
                                                                                        A = (_ + (A << 10) | 0) + 2089 | 0;
                                                                                        break u;
                                                                                    case 0:
                                                                                        break w;
                                                                                    default:
                                                                                        break f;
                                                                                }
                                                                                A = (_ + (A << 4) | 0) + 73 | 0;
                                                                            }
                                                                            if (G = (t + (k << 1) | 0) + 14396 | 0, Q[G >> 1] <= 0) break s;
                                                                            for(v = A, M = (e | 0) / 6 | 0, f0 = i[(e - Z(M, 6) << 2) + 51408 >> 2], s = r - 5 | 0, w = 1 << r - 6, T = w >> 31, A = 0, r = k << 11, t0 = r + (t + 2108 | 0) | 0, S = r + (t + 8252 | 0) | 0; r = A << 1, e = Q[r + S >> 1], F = n + (e << 1) | 0, r = Q[r + t0 >> 1], C = r, E = r >> 31, r = Z(f0, l[e + v | 0]) << M, r = O0(C, E, r, r >> 31), e = T + w0 | 0, r = r + w | 0, e = r >>> 0 < w >>> 0 ? e + 1 | 0 : e, E = r, C = s & 31, (s & 63) >>> 0 >= 32 ? (r = e >> 31, e = e >> C) : (r = e >> C, e = ((1 << C) - 1 & e) << 32 - C | E >>> C), C = (r | 0) >= 0 & e >>> 0 >= 32767 | (r | 0) > 0, e = C ? 32767 : e, r = C ? 0 : r, (r | 0) < -1 ? r = 1 : r = (r | 0) < 0 & e >>> 0 <= 4294934528, Q[F >> 1] = r ? -32768 : e, A = A + 1 | 0, (A | 0) < Q[G >> 1];);
                                                                        }
                                                                        if (B) {
                                                                            if (A = 5, (f | 0) >= 2) {
                                                                                for(r = 0, A = f; e = r, r = r + 1 | 0, s = A >>> 0 > 3, A = A >>> 1 | 0, !!s;);
                                                                                A = e + 6 | 0;
                                                                            }
                                                                            if (R && p[i[i[t + 18584 >> 2] + 432 >> 2]](n, 4), w = t + 14404 | 0, s = k ? W : w, p[i[i[t + 18584 >> 2] + (u ? (u | 0) == 2 ? 464 : 468 : 472) >> 2]](s, n, f, A, (h | 0) < 20 ? 20 - h | 0 : 0), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(A = i[i[t + 18588 >> 2] + 124 >> 2], u = i[A + 16832 >> 2], v = i[A + 16840 >> 2], B = f & 2147483646, G = f & 1, e = 0;;){
                                                                                if (_ = Z(e, f), A = 0, r = 0, (f | 0) != 1) for(; C = A + _ << 2, V = C + s | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[w + C >> 2] << v >> u) >> 3), C = C + 4 | 0, V = C + s | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[w + C >> 2] << v >> u) >> 3), A = A + 2 | 0, r = r + 2 | 0, (B | 0) != (r | 0););
                                                                                if (G && (A = A + _ << 2, r = A + s | 0, i[r >> 2] = i[r >> 2] + (Z(i[t + 28 >> 2], i[A + w >> 2] << v >> u) >> 3)), e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                                            }
                                                                            if (p[i[i[t + 18584 >> 2] + 460 >> 2]](y, H, s, f, h), !R) break o;
                                                                            Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, Q[n + 4 >> 1] = 0, Q[n + 6 >> 1] = 0, Q[n + 24 >> 1] = 0, Q[n + 26 >> 1] = 0, Q[n + 28 >> 1] = 0, Q[n + 30 >> 1] = 0, Q[n + 16 >> 1] = 0, Q[n + 18 >> 1] = 0, Q[n + 20 >> 1] = 0, Q[n + 22 >> 1] = 0, Q[n + 8 >> 1] = 0, Q[n + 10 >> 1] = 0, Q[n + 12 >> 1] = 0, Q[n + 14 >> 1] = 0;
                                                                            break o;
                                                                        }
                                                                        if (u) break t;
                                                                        if (u = !(k | V) & (f | 0) == 4, l[_ + 8247 | 0] == 1) {
                                                                            w = m - 4096 | 0, m = w, s = 20 - h | 0, e = t + 14404 | 0, A = k ? w : e, v = i[t + 18584 >> 2], r = 436;
                                                                            s: {
                                                                                if (u) break s;
                                                                                r = 440;
                                                                                u: switch(f - 4 | 0){
                                                                                    case 4:
                                                                                        r = 444;
                                                                                        break s;
                                                                                    case 12:
                                                                                        r = 448;
                                                                                        break s;
                                                                                    case 0:
                                                                                        break s;
                                                                                    default:
                                                                                        break u;
                                                                                }
                                                                                r = 452;
                                                                            }
                                                                            if (p[i[r + v >> 2]](A, n, s, 15), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(r = i[i[t + 18588 >> 2] + 124 >> 2], n = i[r + 16832 >> 2], s = i[r + 16840 >> 2], B = f & 2147483646, G = f & 1, u = 0;;){
                                                                                if (_ = Z(f, u), r = 0, C = 0, (f | 0) != 1) for(; R = r + _ << 2, V = R + A | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[e + R >> 2] << s >> n) >> 3), R = R + 4 | 0, V = R + A | 0, i[V >> 2] = i[V >> 2] + (Z(i[t + 28 >> 2], i[e + R >> 2] << s >> n) >> 3), r = r + 2 | 0, C = C + 2 | 0, (B | 0) != (C | 0););
                                                                                if (G && (r = r + _ << 2, _ = r + A | 0, i[_ >> 2] = i[_ >> 2] + (Z(i[t + 28 >> 2], i[r + e >> 2] << s >> n) >> 3)), u = u + 1 | 0, (u | 0) == (f | 0)) break;
                                                                            }
                                                                            p[i[v + 460 >> 2]](y, H, A, f, h), m = w + 4096 | 0;
                                                                            break o;
                                                                        }
                                                                        A = i[t + 18584 >> 2] + 172 | 0, r = 240;
                                                                        s: {
                                                                            if (u) break s;
                                                                            r = 244;
                                                                            u: switch(f - 4 | 0){
                                                                                case 4:
                                                                                    r = 248;
                                                                                    break s;
                                                                                case 12:
                                                                                    r = 252;
                                                                                    break s;
                                                                                case 0:
                                                                                    break s;
                                                                                default:
                                                                                    break u;
                                                                            }
                                                                            r = 256;
                                                                        }
                                                                        p[i[A + r >> 2]](y, n, H, h);
                                                                    }
                                                                    if (r = (t + (k << 1) | 0) + 14396 | 0, Q[r >> 1] > 0) for(e = i[t + 2104 >> 2], f = (t + 8252 | 0) + (k << 11) | 0, A = 0; Q[e + (Q[f + (A << 1) >> 1] << 1) >> 1] = 0, A = A + 1 | 0, (A | 0) < Q[r >> 1];);
                                                                    m = W + 4096 | 0;
                                                                    break n;
                                                                }
                                                                break A;
                                                            }
                                                            break r;
                                                        }
                                                        t = A, R = m - 4096 | 0, m = R;
                                                        t: {
                                                            if (k >>> 0 < 3) {
                                                                if (s = i[A + 18588 >> 2], n = i[s + 168 >> 2], v = r >> n, (v | 0) < 0 || (_ = i[s + 172 >> 2], (_ | 0) <= (v | 0))) break e;
                                                                if (h = e >> n, (h | 0) < 0 | (h | 0) >= i[s + 176 >> 2]) break i;
                                                                W = k << 2, C = i[s + (k ? 44 : 40) >> 2], H = (i[(W + s | 0) + 4 >> 2] + Z(C, e) | 0) + r | 0, n = i[A + 2104 >> 2], r = 0, G = l[((i[s + 160 >> 2] + Z(v, 3) | 0) + Z(Z(h, _), 3) | 0) + 1 | 0] & 3, v = i[s + 124 >> 2], y = !G & (f | 0) == 4 & l[v + 16820 | 0] != 0;
                                                                o: {
                                                                    if (l[A + 32 | 0]) {
                                                                        if (r = (A + (k << 1) | 0) + 14396 | 0, Q[r >> 1] > 0) for(A = 0, e = k << 11, s = e + (t + 8252 | 0) | 0, e = e + (t + 2108 | 0) | 0; w = A << 1, Q[n + (Q[w + s >> 1] << 1) >> 1] = I[e + w >> 1], A = A + 1 | 0, (A | 0) < Q[r >> 1];);
                                                                        if (y && p[i[i[t + 18584 >> 2] + 432 >> 2]](n, 4), w = t + 14404 | 0, s = k ? R : w, p[i[i[t + 18584 >> 2] + (u ? (u | 0) == 2 ? 368 : 372 : 364) >> 2]](s, n, f), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(A = i[i[t + 18588 >> 2] + 124 >> 2], u = i[A + 16832 >> 2], v = i[A + 16840 >> 2], W = f & 2147483646, B = f & 1, e = 0;;){
                                                                            if (h = Z(e, f), A = 0, r = 0, (f | 0) != 1) for(; _ = A + h << 2, G = _ + s | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[w + _ >> 2] << v >> u) >> 3), _ = _ + 4 | 0, G = _ + s | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[w + _ >> 2] << v >> u) >> 3), A = A + 2 | 0, r = r + 2 | 0, (W | 0) != (r | 0););
                                                                            if (B && (A = A + h << 2, r = A + s | 0, i[r >> 2] = i[r >> 2] + (Z(i[t + 28 >> 2], i[A + w >> 2] << v >> u) >> 3)), e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                                        }
                                                                        if (p[i[i[t + 18584 >> 2] + 456 >> 2]](H, C, s, f, 8), !y) break o;
                                                                        Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, Q[n + 4 >> 1] = 0, Q[n + 6 >> 1] = 0, Q[n + 24 >> 1] = 0, Q[n + 26 >> 1] = 0, Q[n + 28 >> 1] = 0, Q[n + 30 >> 1] = 0, Q[n + 16 >> 1] = 0, Q[n + 18 >> 1] = 0, Q[n + 20 >> 1] = 0, Q[n + 22 >> 1] = 0, Q[n + 8 >> 1] = 0, Q[n + 10 >> 1] = 0, Q[n + 12 >> 1] = 0, Q[n + 14 >> 1] = 0;
                                                                        break o;
                                                                    }
                                                                    if (_ = i[v + (k ? 16840 : 16832) >> 2], (f | 0) >= 2) for(A = f; r = r + 1 | 0, e = A >>> 0 > 3, A = A >>> 1 | 0, !!e;);
                                                                    h = i[s + 132 >> 2], e = i[(t + W | 0) + 18536 >> 2], r = r + _ | 0;
                                                                    s: {
                                                                        if (!l[v + 636 | 0]) {
                                                                            if (s = (t + (k << 1) | 0) + 14396 | 0, Q[s >> 1] <= 0) break s;
                                                                            for(e = i[((e | 0) % 6 << 2) + 51408 >> 2] << (e | 0) / 6, w = r - 9 | 0, v = 1 << r - 10, A = 0, r = k << 11, _ = r + (t + 2108 | 0) | 0, W = r + (t + 8252 | 0) | 0; V = A << 1, r = v + Z(e, Q[V + _ >> 1]) >> w, r = (r | 0) >= 32767 ? 32767 : r, Q[n + (Q[W + V >> 1] << 1) >> 1] = (r | 0) <= -32768 ? -32768 : r, A = A + 1 | 0, (A | 0) < Q[s >> 1];);
                                                                            break s;
                                                                        }
                                                                        A = k, s = A;
                                                                        u: {
                                                                            if (w || (s = A + 3 | 0, (f | 0) <= 31)) break u;
                                                                            s = A + 1 | 0;
                                                                        }
                                                                        A = s;
                                                                        u: {
                                                                            w: switch(b0(f - 4 | 0, 30) | 0){
                                                                                case 1:
                                                                                    A = (h + (A << 6) | 0) + 169 | 0;
                                                                                    break u;
                                                                                case 3:
                                                                                    A = (h + (A << 8) | 0) + 553 | 0;
                                                                                    break u;
                                                                                case 7:
                                                                                    A = (h + (A << 10) | 0) + 2089 | 0;
                                                                                    break u;
                                                                                case 0:
                                                                                    break w;
                                                                                default:
                                                                                    break f;
                                                                            }
                                                                            A = (h + (A << 4) | 0) + 73 | 0;
                                                                        }
                                                                        if (W = (t + (k << 1) | 0) + 14396 | 0, Q[W >> 1] <= 0) break s;
                                                                        for(v = A, V = (e | 0) / 6 | 0, M = i[(e - Z(V, 6) << 2) + 51408 >> 2], s = r - 5 | 0, w = 1 << r - 6, f0 = w >> 31, A = 0, r = k << 11, T = r + (t + 2108 | 0) | 0, t0 = r + (t + 8252 | 0) | 0; r = A << 1, e = Q[r + t0 >> 1], S = n + (e << 1) | 0, r = Q[r + T >> 1], F = r, E = r >> 31, r = Z(M, l[e + v | 0]) << V, r = O0(F, E, r, r >> 31), e = f0 + w0 | 0, r = r + w | 0, e = r >>> 0 < w >>> 0 ? e + 1 | 0 : e, F = r, _ = s & 31, (s & 63) >>> 0 >= 32 ? (r = e >> 31, e = e >> _) : (r = e >> _, e = ((1 << _) - 1 & e) << 32 - _ | F >>> _), _ = (r | 0) >= 0 & e >>> 0 >= 32767 | (r | 0) > 0, e = _ ? 32767 : e, r = _ ? 0 : r, (r | 0) < -1 ? r = 1 : r = (r | 0) < 0 & e >>> 0 <= 4294934528, Q[S >> 1] = r ? -32768 : e, A = A + 1 | 0, (A | 0) < Q[W >> 1];);
                                                                    }
                                                                    if (B) {
                                                                        if (A = 5, (f | 0) >= 2) {
                                                                            for(r = 0, A = f; e = r, r = r + 1 | 0, s = A >>> 0 > 3, A = A >>> 1 | 0, !!s;);
                                                                            A = e + 6 | 0;
                                                                        }
                                                                        if (y && p[i[i[t + 18584 >> 2] + 432 >> 2]](n, 4), w = t + 14404 | 0, s = k ? R : w, p[i[i[t + 18584 >> 2] + (u ? (u | 0) == 2 ? 464 : 468 : 472) >> 2]](s, n, f, A, 12), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(A = i[i[t + 18588 >> 2] + 124 >> 2], u = i[A + 16832 >> 2], v = i[A + 16840 >> 2], W = f & 2147483646, B = f & 1, e = 0;;){
                                                                            if (h = Z(e, f), A = 0, r = 0, (f | 0) != 1) for(; _ = A + h << 2, G = _ + s | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[w + _ >> 2] << v >> u) >> 3), _ = _ + 4 | 0, G = _ + s | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[w + _ >> 2] << v >> u) >> 3), A = A + 2 | 0, r = r + 2 | 0, (W | 0) != (r | 0););
                                                                            if (B && (A = A + h << 2, r = A + s | 0, i[r >> 2] = i[r >> 2] + (Z(i[t + 28 >> 2], i[A + w >> 2] << v >> u) >> 3)), e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                                        }
                                                                        if (p[i[i[t + 18584 >> 2] + 456 >> 2]](H, C, s, f, 8), !y) break o;
                                                                        Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, Q[n + 4 >> 1] = 0, Q[n + 6 >> 1] = 0, Q[n + 24 >> 1] = 0, Q[n + 26 >> 1] = 0, Q[n + 28 >> 1] = 0, Q[n + 30 >> 1] = 0, Q[n + 16 >> 1] = 0, Q[n + 18 >> 1] = 0, Q[n + 20 >> 1] = 0, Q[n + 22 >> 1] = 0, Q[n + 8 >> 1] = 0, Q[n + 10 >> 1] = 0, Q[n + 12 >> 1] = 0, Q[n + 14 >> 1] = 0;
                                                                        break o;
                                                                    }
                                                                    if (u) break r;
                                                                    if (s = !(k | G) & (f | 0) == 4, l[h + 8247 | 0] == 1) {
                                                                        e = 0, w = m - 4096 | 0, m = w, u = t + 14404 | 0, A = k ? w : u, v = i[t + 18584 >> 2], r = 436;
                                                                        s: {
                                                                            if (s) break s;
                                                                            r = 440;
                                                                            u: switch(f - 4 | 0){
                                                                                case 4:
                                                                                    r = 444;
                                                                                    break s;
                                                                                case 12:
                                                                                    r = 448;
                                                                                    break s;
                                                                                case 0:
                                                                                    break s;
                                                                                default:
                                                                                    break u;
                                                                            }
                                                                            r = 452;
                                                                        }
                                                                        if (p[i[r + v >> 2]](A, n, 12, 15), !(!k | !i[t + 28 >> 2] | (f | 0) <= 0)) for(r = i[i[t + 18588 >> 2] + 124 >> 2], n = i[r + 16832 >> 2], s = i[r + 16840 >> 2], W = f & 2147483646, B = f & 1;;){
                                                                            if (h = Z(e, f), r = 0, _ = 0, (f | 0) != 1) for(; y = r + h << 2, G = y + A | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[u + y >> 2] << s >> n) >> 3), y = y + 4 | 0, G = y + A | 0, i[G >> 2] = i[G >> 2] + (Z(i[t + 28 >> 2], i[u + y >> 2] << s >> n) >> 3), r = r + 2 | 0, _ = _ + 2 | 0, (W | 0) != (_ | 0););
                                                                            if (B && (r = r + h << 2, h = r + A | 0, i[h >> 2] = i[h >> 2] + (Z(i[t + 28 >> 2], i[r + u >> 2] << s >> n) >> 3)), e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                                        }
                                                                        p[i[v + 456 >> 2]](H, C, A, f, 8), m = w + 4096 | 0;
                                                                        break o;
                                                                    }
                                                                    A = i[t + 18584 >> 2] + 172 | 0, r = 216;
                                                                    s: {
                                                                        if (s) break s;
                                                                        r = 220;
                                                                        u: switch(f - 4 | 0){
                                                                            case 4:
                                                                                r = 224;
                                                                                break s;
                                                                            case 12:
                                                                                r = 228;
                                                                                break s;
                                                                            case 0:
                                                                                break s;
                                                                            default:
                                                                                break u;
                                                                        }
                                                                        r = 232;
                                                                    }
                                                                    p[i[A + r >> 2]](H, n, C);
                                                                }
                                                                if (r = (t + (k << 1) | 0) + 14396 | 0, Q[r >> 1] > 0) for(e = i[t + 2104 >> 2], f = (t + 8252 | 0) + (k << 11) | 0, A = 0; Q[e + (Q[f + (A << 1) >> 1] << 1) >> 1] = 0, A = A + 1 | 0, (A | 0) < Q[r >> 1];);
                                                                m = R + 4096 | 0;
                                                                break t;
                                                            }
                                                            break A;
                                                        }
                                                    }
                                                }
                                                return;
                                            }
                                            y0(18461, 14988, 502, 8329), z();
                                        }
                                        y0(18461, 14988, 377, 8329), z();
                                    }
                                    y0(18282, 14988, 599, 8329), z();
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function s3(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            _ = m - 48 | 0, m = _, f = i[e >> 2], k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[r + 8 >> 2] = f, f = i[r + 12 >> 2], i[r + 12 >> 2] = k;
                            i: {
                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            if (i[_ + 24 >> 2] = 0, i[_ + 28 >> 2] = 0, i[_ + 40 >> 2] = 0, i[_ + 32 >> 2] = 0, i[_ + 36 >> 2] = 0, G = i[r + 136 >> 2], t = m - 304 | 0, m = t, v = i[r >> 2], n = i[v + 20 >> 2], k = i[v + 16 >> 2], (n | 0) != (k | 0)) for(;;){
                                f = i[n - 4 >> 2];
                                i: {
                                    if (!f || (u = i[f + 4 >> 2], i[f + 4 >> 2] = u - 1, u)) break i;
                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                }
                                if (n = n - 8 | 0, (k | 0) == (n | 0)) break;
                            }
                            i[v + 20 >> 2] = k, f = i[e >> 2], k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[v + 56 >> 2] = f, f = i[v + 60 >> 2], i[v + 60 >> 2] = k;
                            i: {
                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            f = i[e >> 2], f = p[i[i[f >> 2] + 24 >> 2]](f, 0, 0, 1024, 0) | 0, i[v + 48 >> 2] = f, k = w0, i[v + 52 >> 2] = k;
                            i: {
                                if (!k & f >>> 0 <= 31) {
                                    if (e = D(24), i[t + 232 >> 2] = e, i[t + 236 >> 2] = 20, i[t + 240 >> 2] = -2147483624, f = l[19571] | l[19572] << 8 | (l[19573] << 16 | l[19574] << 24), k = l[19567] | l[19568] << 8 | (l[19569] << 16 | l[19570] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 20 | 0] = 0, f = l[19583] | l[19584] << 8 | (l[19585] << 16 | l[19586] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, f = l[19579] | l[19580] << 8 | (l[19581] << 16 | l[19582] << 24), k = l[19575] | l[19576] << 8 | (l[19577] << 16 | l[19578] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(_, 2, 0, t + 232 | 0), o[t + 243 | 0] >= 0) break i;
                                    X(i[t + 232 >> 2]);
                                    break i;
                                }
                                i[t + 272 >> 2] = i[v + 56 >> 2], k = i[v + 60 >> 2], i[t + 276 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, f = i[v + 48 >> 2]), k = i[t + 276 >> 2], i[t + 24 >> 2] = i[t + 272 >> 2], i[t + 28 >> 2] = k, W = kr(t + 280 | 0, t + 24 | 0, f, 0), B = t + 232 | 0, i[B + 8 >> 2] = 0, i[B + 12 >> 2] = 0, i[B + 16 >> 2] = 0, i[B + 20 >> 2] = 0, i[B + 24 >> 2] = 0, i[B + 28 >> 2] = 0, i[B + 32 >> 2] = 0, i[B >> 2] = 73428, i[t + 208 >> 2] = 0, i[t + 212 >> 2] = 0, i[t + 224 >> 2] = 0, i[t + 216 >> 2] = 0, i[t + 220 >> 2] = 0, _e(t + 96 | 0, B, W), k = i[t + 100 >> 2], f = i[t + 96 >> 2], i[t + 208 >> 2] = f, i[t + 212 >> 2] = k, o[t + 227 | 0] < 0 && (X(i[t + 216 >> 2]), f = i[t + 208 >> 2]), k = i[t + 108 >> 2], i[t + 216 >> 2] = i[t + 104 >> 2], i[t + 220 >> 2] = k, i[t + 224 >> 2] = i[t + 112 >> 2];
                                e: {
                                    if (f) {
                                        e = i[t + 212 >> 2], i[_ >> 2] = i[t + 208 >> 2], i[_ + 4 >> 2] = e, i[_ + 16 >> 2] = i[t + 224 >> 2], e = i[t + 220 >> 2], i[_ + 8 >> 2] = i[t + 216 >> 2], i[_ + 12 >> 2] = e, i[t + 216 >> 2] = 0, i[t + 220 >> 2] = 0, i[t + 224 >> 2] = 0;
                                        break e;
                                    }
                                    if (i[B + 16 >> 2] != 1718909296) {
                                        if (e = D(40), i[t + 96 >> 2] = e, i[t + 100 >> 2] = 36, i[t + 104 >> 2] = -2147483608, f = l[18925] | l[18926] << 8 | (l[18927] << 16 | l[18928] << 24), k = l[18921] | l[18922] << 8 | (l[18923] << 16 | l[18924] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 36 | 0] = 0, f = l[18953] | l[18954] << 8 | (l[18955] << 16 | l[18956] << 24), o[e + 32 | 0] = f, o[e + 33 | 0] = f >>> 8, o[e + 34 | 0] = f >>> 16, o[e + 35 | 0] = f >>> 24, f = l[18949] | l[18950] << 8 | (l[18951] << 16 | l[18952] << 24), k = l[18945] | l[18946] << 8 | (l[18947] << 16 | l[18948] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[18941] | l[18942] << 8 | (l[18943] << 16 | l[18944] << 24), k = l[18937] | l[18938] << 8 | (l[18939] << 16 | l[18940] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[18933] | l[18934] << 8 | (l[18935] << 16 | l[18936] << 24), k = l[18929] | l[18930] << 8 | (l[18931] << 16 | l[18932] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(_, 2, 102, t + 96 | 0), o[t + 107 | 0] >= 0) break e;
                                        X(i[t + 96 >> 2]);
                                        break e;
                                    }
                                    if (f = i[B + 12 >> 2], u = f, k = i[B + 8 >> 2], !(f | k)) {
                                        if (e = D(48), i[t + 96 >> 2] = e, i[t + 100 >> 2] = 46, i[t + 104 >> 2] = -2147483600, f = l[10892] | l[10893] << 8 | (l[10894] << 16 | l[10895] << 24), k = l[10888] | l[10889] << 8 | (l[10890] << 16 | l[10891] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 46 | 0] = 0, f = l[10930] | l[10931] << 8 | (l[10932] << 16 | l[10933] << 24), k = l[10926] | l[10927] << 8 | (l[10928] << 16 | l[10929] << 24), o[e + 38 | 0] = k, o[e + 39 | 0] = k >>> 8, o[e + 40 | 0] = k >>> 16, o[e + 41 | 0] = k >>> 24, o[e + 42 | 0] = f, o[e + 43 | 0] = f >>> 8, o[e + 44 | 0] = f >>> 16, o[e + 45 | 0] = f >>> 24, f = l[10924] | l[10925] << 8 | (l[10926] << 16 | l[10927] << 24), k = l[10920] | l[10921] << 8 | (l[10922] << 16 | l[10923] << 24), o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, o[e + 34 | 0] = k >>> 16, o[e + 35 | 0] = k >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[10916] | l[10917] << 8 | (l[10918] << 16 | l[10919] << 24), k = l[10912] | l[10913] << 8 | (l[10914] << 16 | l[10915] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[10908] | l[10909] << 8 | (l[10910] << 16 | l[10911] << 24), k = l[10904] | l[10905] << 8 | (l[10906] << 16 | l[10907] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[10900] | l[10901] << 8 | (l[10902] << 16 | l[10903] << 24), k = l[10896] | l[10897] << 8 | (l[10898] << 16 | l[10899] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(_, 2, 102, t + 96 | 0), o[t + 107 | 0] >= 0) break e;
                                        X(i[t + 96 >> 2]);
                                        break e;
                                    }
                                    if (n = i[v + 52 >> 2], (u | 0) == (n | 0) & k >>> 0 > k0[v + 48 >> 2] | n >>> 0 < u >>> 0) {
                                        if (e = D(40), i[t + 96 >> 2] = e, i[t + 100 >> 2] = 39, i[t + 104 >> 2] = -2147483608, f = l[11331] | l[11332] << 8 | (l[11333] << 16 | l[11334] << 24), k = l[11327] | l[11328] << 8 | (l[11329] << 16 | l[11330] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 39 | 0] = 0, f = l[11362] | l[11363] << 8 | (l[11364] << 16 | l[11365] << 24), k = l[11358] | l[11359] << 8 | (l[11360] << 16 | l[11361] << 24), o[e + 31 | 0] = k, o[e + 32 | 0] = k >>> 8, o[e + 33 | 0] = k >>> 16, o[e + 34 | 0] = k >>> 24, o[e + 35 | 0] = f, o[e + 36 | 0] = f >>> 8, o[e + 37 | 0] = f >>> 16, o[e + 38 | 0] = f >>> 24, f = l[11355] | l[11356] << 8 | (l[11357] << 16 | l[11358] << 24), k = l[11351] | l[11352] << 8 | (l[11353] << 16 | l[11354] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[11347] | l[11348] << 8 | (l[11349] << 16 | l[11350] << 24), k = l[11343] | l[11344] << 8 | (l[11345] << 16 | l[11346] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[11339] | l[11340] << 8 | (l[11341] << 16 | l[11342] << 24), k = l[11335] | l[11336] << 8 | (l[11337] << 16 | l[11338] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(_, 2, 102, t + 96 | 0), o[t + 107 | 0] >= 0) break e;
                                        X(i[t + 96 >> 2]);
                                        break e;
                                    }
                                    i[t + 176 >> 2] = i[v + 56 >> 2], f = i[v + 60 >> 2], i[t + 180 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = i[t + 180 >> 2], i[t + 16 >> 2] = i[t + 176 >> 2], i[t + 20 >> 2] = f, C = DA(t + 184 | 0, t + 16 | 0, 0, k), i[t + 168 >> 2] = 0, i[t + 172 >> 2] = 0, c6(t + 96 | 0, C, t + 168 | 0, G), f = i[t + 100 >> 2], i[t + 208 >> 2] = i[t + 96 >> 2], i[t + 212 >> 2] = f, o[t + 227 | 0] < 0 && X(i[t + 216 >> 2]), V = v + 16 | 0, f = i[t + 108 >> 2], i[t + 216 >> 2] = i[t + 104 >> 2], i[t + 220 >> 2] = f, i[t + 224 >> 2] = i[t + 112 >> 2], f = i[v + 20 >> 2];
                                    r: {
                                        if (f >>> 0 < k0[v + 24 >> 2]) {
                                            n = i[t + 168 >> 2], i[f >> 2] = n, s = i[t + 172 >> 2], i[f + 4 >> 2] = s, s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), w = f + 8 | 0;
                                            break r;
                                        }
                                        w = P2(V, t + 168 | 0), n = i[t + 168 >> 2];
                                    }
                                    i[v + 20 >> 2] = w;
                                    r: {
                                        A: {
                                            if (!n || (n = E0(n, 73632, 73932), !n)) break A;
                                            if (w = i[t + 172 >> 2], !w) {
                                                w = 0;
                                                break r;
                                            }
                                            i[w + 4 >> 2] = i[w + 4 >> 2] + 1;
                                            break r;
                                        }
                                        w = 0, n = 0;
                                    }
                                    i[v + 28 >> 2] = n, f = i[v + 32 >> 2], i[v + 32 >> 2] = w;
                                    r: {
                                        if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break r;
                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                    }
                                    y = v + 36 | 0;
                                    r: {
                                        for(;;){
                                            if (f = u, s = k + 32 | 0, n = s >>> 0 < 32 ? f + 1 | 0 : f, w = i[v + 52 >> 2], f = i[v + 48 >> 2], (n | 0) == (w | 0) & f >>> 0 < s >>> 0 | n >>> 0 > w >>> 0 && (f = i[e >> 2], f = p[i[i[f >> 2] + 24 >> 2]](f, k, u, s, n) | 0, h = w0, w = h, i[v + 48 >> 2] = f, i[v + 52 >> 2] = h), (n | 0) == (w | 0) & f >>> 0 < s >>> 0 | n >>> 0 > w >>> 0) {
                                                if (e = D(24), i[t + 96 >> 2] = e, i[t + 100 >> 2] = 23, i[t + 104 >> 2] = -2147483624, f = l[15500] | l[15501] << 8 | (l[15502] << 16 | l[15503] << 24), k = l[15496] | l[15497] << 8 | (l[15498] << 16 | l[15499] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 23 | 0] = 0, f = l[15515] | l[15516] << 8 | (l[15517] << 16 | l[15518] << 24), k = l[15511] | l[15512] << 8 | (l[15513] << 16 | l[15514] << 24), o[e + 15 | 0] = k, o[e + 16 | 0] = k >>> 8, o[e + 17 | 0] = k >>> 16, o[e + 18 | 0] = k >>> 24, o[e + 19 | 0] = f, o[e + 20 | 0] = f >>> 8, o[e + 21 | 0] = f >>> 16, o[e + 22 | 0] = f >>> 24, f = l[15508] | l[15509] << 8 | (l[15510] << 16 | l[15511] << 24), k = l[15504] | l[15505] << 8 | (l[15506] << 16 | l[15507] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(_, 2, 0, t + 96 | 0), o[t + 107 | 0] >= 0) break r;
                                                X(i[t + 96 >> 2]);
                                                break r;
                                            }
                                            i[t + 136 >> 2] = i[v + 56 >> 2], n = i[v + 60 >> 2], i[t + 140 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, f = i[v + 48 >> 2]), n = i[t + 140 >> 2], i[t + 8 >> 2] = i[t + 136 >> 2], i[t + 12 >> 2] = n, n = DA(t + 144 | 0, t + 8 | 0, k, f), w = t + 96 | 0, f = w, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, i[f >> 2] = 73428, _e(t + 72 | 0, f, n), n = i[t + 76 >> 2], f = i[t + 72 >> 2], i[t + 208 >> 2] = f, i[t + 212 >> 2] = n, o[t + 227 | 0] < 0 && (X(i[t + 216 >> 2]), f = i[t + 208 >> 2]), n = i[t + 84 >> 2], i[t + 216 >> 2] = i[t + 80 >> 2], i[t + 220 >> 2] = n, i[t + 224 >> 2] = i[t + 88 >> 2];
                                            A: {
                                                if (f) {
                                                    f = i[t + 212 >> 2], i[_ >> 2] = i[t + 208 >> 2], i[_ + 4 >> 2] = f, i[_ + 16 >> 2] = i[t + 224 >> 2], f = i[t + 220 >> 2], i[_ + 8 >> 2] = i[t + 216 >> 2], i[_ + 12 >> 2] = f, i[t + 216 >> 2] = 0, i[t + 220 >> 2] = 0, i[t + 224 >> 2] = 0, n = 1;
                                                    break A;
                                                }
                                                if (s = i[t + 104 >> 2], f = i[t + 108 >> 2], n = f, i[t + 112 >> 2] == 1835365473) {
                                                    if (!(f | s)) {
                                                        f = D(48), i[t + 72 >> 2] = f, i[t + 76 >> 2] = 42, i[t + 80 >> 2] = -2147483600, n = l[9690] | l[9691] << 8 | (l[9692] << 16 | l[9693] << 24), s = l[9686] | l[9687] << 8 | (l[9688] << 16 | l[9689] << 24), o[f | 0] = s, o[f + 1 | 0] = s >>> 8, o[f + 2 | 0] = s >>> 16, o[f + 3 | 0] = s >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 42 | 0] = 0, n = l[9726] | l[9727] << 8, o[f + 40 | 0] = n, o[f + 41 | 0] = n >>> 8, n = l[9722] | l[9723] << 8 | (l[9724] << 16 | l[9725] << 24), s = l[9718] | l[9719] << 8 | (l[9720] << 16 | l[9721] << 24), o[f + 32 | 0] = s, o[f + 33 | 0] = s >>> 8, o[f + 34 | 0] = s >>> 16, o[f + 35 | 0] = s >>> 24, o[f + 36 | 0] = n, o[f + 37 | 0] = n >>> 8, o[f + 38 | 0] = n >>> 16, o[f + 39 | 0] = n >>> 24, n = l[9714] | l[9715] << 8 | (l[9716] << 16 | l[9717] << 24), s = l[9710] | l[9711] << 8 | (l[9712] << 16 | l[9713] << 24), o[f + 24 | 0] = s, o[f + 25 | 0] = s >>> 8, o[f + 26 | 0] = s >>> 16, o[f + 27 | 0] = s >>> 24, o[f + 28 | 0] = n, o[f + 29 | 0] = n >>> 8, o[f + 30 | 0] = n >>> 16, o[f + 31 | 0] = n >>> 24, n = l[9706] | l[9707] << 8 | (l[9708] << 16 | l[9709] << 24), s = l[9702] | l[9703] << 8 | (l[9704] << 16 | l[9705] << 24), o[f + 16 | 0] = s, o[f + 17 | 0] = s >>> 8, o[f + 18 | 0] = s >>> 16, o[f + 19 | 0] = s >>> 24, o[f + 20 | 0] = n, o[f + 21 | 0] = n >>> 8, o[f + 22 | 0] = n >>> 16, o[f + 23 | 0] = n >>> 24, n = l[9698] | l[9699] << 8 | (l[9700] << 16 | l[9701] << 24), s = l[9694] | l[9695] << 8 | (l[9696] << 16 | l[9697] << 24), o[f + 8 | 0] = s, o[f + 9 | 0] = s >>> 8, o[f + 10 | 0] = s >>> 16, o[f + 11 | 0] = s >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, i0(_, 2, 104, t + 72 | 0), o[t + 83 | 0] < 0 && X(i[t + 72 >> 2]), n = 1;
                                                        break A;
                                                    }
                                                    if (f = i[v + 48 >> 2], n = n + u | 0, h = i[v + 52 >> 2], s = k + s | 0, n = s >>> 0 < k >>> 0 ? n + 1 | 0 : n, (h | 0) == (n | 0) & f >>> 0 < s >>> 0 | n >>> 0 > h >>> 0 && (f = i[v + 56 >> 2], f = p[i[i[f >> 2] + 24 >> 2]](f, k, u, s, n) | 0, i[v + 48 >> 2] = f, h = w0, i[v + 52 >> 2] = h), (n | 0) == (h | 0) & f >>> 0 < s >>> 0 | n >>> 0 > h >>> 0) {
                                                        f = D(32), i[t + 72 >> 2] = f, i[t + 76 >> 2] = 25, i[t + 80 >> 2] = -2147483616, n = l[2262] | l[2263] << 8 | (l[2264] << 16 | l[2265] << 24), s = l[2258] | l[2259] << 8 | (l[2260] << 16 | l[2261] << 24), o[f | 0] = s, o[f + 1 | 0] = s >>> 8, o[f + 2 | 0] = s >>> 16, o[f + 3 | 0] = s >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 25 | 0] = 0, o[f + 24 | 0] = l[2282], n = l[2278] | l[2279] << 8 | (l[2280] << 16 | l[2281] << 24), s = l[2274] | l[2275] << 8 | (l[2276] << 16 | l[2277] << 24), o[f + 16 | 0] = s, o[f + 17 | 0] = s >>> 8, o[f + 18 | 0] = s >>> 16, o[f + 19 | 0] = s >>> 24, o[f + 20 | 0] = n, o[f + 21 | 0] = n >>> 8, o[f + 22 | 0] = n >>> 16, o[f + 23 | 0] = n >>> 24, n = l[2270] | l[2271] << 8 | (l[2272] << 16 | l[2273] << 24), s = l[2266] | l[2267] << 8 | (l[2268] << 16 | l[2269] << 24), o[f + 8 | 0] = s, o[f + 9 | 0] = s >>> 8, o[f + 10 | 0] = s >>> 16, o[f + 11 | 0] = s >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, i0(_, 2, 104, t + 72 | 0), o[t + 83 | 0] < 0 && X(i[t + 72 >> 2]), n = 1;
                                                        break A;
                                                    }
                                                    i[t + 64 >> 2] = i[v + 56 >> 2], f = i[v + 60 >> 2], i[t + 68 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = i[t + 68 >> 2], i[t >> 2] = i[t + 64 >> 2], i[t + 4 >> 2] = f, f = DA(t + 72 | 0, t, k, s), i[t + 56 >> 2] = 0, i[t + 60 >> 2] = 0, c6(t + 32 | 0, f, t + 56 | 0, G), n = i[t + 36 >> 2], f = i[t + 32 >> 2], i[t + 208 >> 2] = f, i[t + 212 >> 2] = n, o[t + 227 | 0] < 0 && (X(i[t + 216 >> 2]), f = i[t + 208 >> 2]), n = i[t + 44 >> 2], i[t + 216 >> 2] = i[t + 40 >> 2], i[t + 220 >> 2] = n, i[t + 224 >> 2] = i[t + 48 >> 2];
                                                    f: {
                                                        if (f) {
                                                            f = i[t + 212 >> 2], i[_ >> 2] = i[t + 208 >> 2], i[_ + 4 >> 2] = f, i[_ + 16 >> 2] = i[t + 224 >> 2], f = i[t + 220 >> 2], i[_ + 8 >> 2] = i[t + 216 >> 2], i[_ + 12 >> 2] = f, i[t + 216 >> 2] = 0, i[t + 220 >> 2] = 0, i[t + 224 >> 2] = 0, n = 1;
                                                            break f;
                                                        }
                                                        ut(V, t + 56 | 0), f = t + 32 | 0;
                                                        k: {
                                                            n: {
                                                                if (n = i[t + 56 >> 2], !n || (n = E0(n, 73632, 74076), !n)) break n;
                                                                if (i[f >> 2] = n, n = i[t + 60 >> 2], i[f + 4 >> 2] = n, !n) break k;
                                                                i[n + 4 >> 2] = i[n + 4 >> 2] + 1;
                                                                break k;
                                                            }
                                                            i[f >> 2] = 0, i[f + 4 >> 2] = 0;
                                                        }
                                                        A6(y, f), B1(f), n = 2;
                                                    }
                                                    f = i[t + 60 >> 2];
                                                    f: {
                                                        if (!f || (s = i[f + 4 >> 2], i[f + 4 >> 2] = s - 1, s)) break f;
                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                    }
                                                    if (f = i[t + 76 >> 2], !f || (s = i[f + 4 >> 2], i[f + 4 >> 2] = s - 1, s)) break A;
                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                    break A;
                                                }
                                                if (!(n | s)) {
                                                    f = D(24), i[t + 72 >> 2] = f, i[t + 76 >> 2] = 17, i[t + 80 >> 2] = -2147483624, n = l[12798] | l[12799] << 8 | (l[12800] << 16 | l[12801] << 24), s = l[12794] | l[12795] << 8 | (l[12796] << 16 | l[12797] << 24), o[f | 0] = s, o[f + 1 | 0] = s >>> 8, o[f + 2 | 0] = s >>> 16, o[f + 3 | 0] = s >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 17 | 0] = 0, o[f + 16 | 0] = l[12810], n = l[12806] | l[12807] << 8 | (l[12808] << 16 | l[12809] << 24), s = l[12802] | l[12803] << 8 | (l[12804] << 16 | l[12805] << 24), o[f + 8 | 0] = s, o[f + 9 | 0] = s >>> 8, o[f + 10 | 0] = s >>> 16, o[f + 11 | 0] = s >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, i0(_, 2, 104, t + 72 | 0), o[t + 83 | 0] < 0 && X(i[t + 72 >> 2]), n = 1;
                                                    break A;
                                                }
                                                u = n + u | 0, f = k, k = k + s | 0, u = f >>> 0 > k >>> 0 ? u + 1 | 0 : u, n = 0;
                                            }
                                            i[w >> 2] = 73428, f = i[t + 116 >> 2], f && (i[t + 120 >> 2] = f, X(f)), f = i[t + 148 >> 2];
                                            A: {
                                                if (!f || (s = i[f + 4 >> 2], i[f + 4 >> 2] = s - 1, s)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            if (n) break;
                                        }
                                        if ((n | 0) != 2) break r;
                                        J6(_);
                                    }
                                    e = i[t + 172 >> 2];
                                    r: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (e = i[C + 4 >> 2], !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (o[t + 227 | 0] < 0 && X(i[t + 216 >> 2]), i[B >> 2] = 73428, e = i[B + 20 >> 2], e && (i[B + 24 >> 2] = e, X(e)), e = i[W + 4 >> 2], !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            m = t + 304 | 0, f = i[_ + 4 >> 2], e = i[_ >> 2], i[_ + 24 >> 2] = e, i[_ + 28 >> 2] = f, o[_ + 43 | 0] < 0 && (X(i[_ + 32 >> 2]), e = i[_ + 24 >> 2]), f = i[_ + 12 >> 2], i[_ + 32 >> 2] = i[_ + 8 >> 2], i[_ + 36 >> 2] = f, i[_ + 40 >> 2] = i[_ + 16 >> 2];
                            i: {
                                if (e) {
                                    r = i[_ + 28 >> 2], i[A >> 2] = i[_ + 24 >> 2], i[A + 4 >> 2] = r, r = i[_ + 36 >> 2], i[A + 8 >> 2] = i[_ + 32 >> 2], i[A + 12 >> 2] = r, i[A + 16 >> 2] = i[_ + 40 >> 2];
                                    break i;
                                }
                                h = m - 176 | 0, m = h, f = i[r >> 2], e = i[f + 28 >> 2], k = i[f + 32 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[r + 28 >> 2] = e, f = i[r + 32 >> 2], i[r + 32 >> 2] = k, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), e = i[r + 28 >> 2]);
                                e: {
                                    if (!e) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 102, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    i[h + 32 >> 2] = e, f = i[r + 32 >> 2], i[h + 36 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), k = r + 16 | 0, f = i[r + 20 >> 2];
                                    r: {
                                        if (f >>> 0 < k0[r + 24 >> 2]) {
                                            i[f >> 2] = e, i[f + 4 >> 2] = i[h + 36 >> 2], i[r + 20 >> 2] = f + 8;
                                            break r;
                                        }
                                        if (f = p2(k, h + 32 | 0), e = i[h + 36 >> 2], i[r + 20 >> 2] = f, !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    r: {
                                        if (k6(i[r + 28 >> 2], 1751476579) || k6(i[r + 28 >> 2], 1751476600) || k6(i[r + 28 >> 2], 1835623985) || k6(i[r + 28 >> 2], 1635150182) || k6(i[r + 28 >> 2], 829450595) || k6(i[r + 28 >> 2], 1785750887)) break r;
                                        r = bn(h + 32 | 0), U(r + 8 | 0, 34145, 44), e = h + 20 | 0, n9(e, r), i0(A, 3, 0, e), o[h + 31 | 0] < 0 && X(i[h + 20 >> 2]), E6(r);
                                        break e;
                                    }
                                    e = i[r >> 2], s = i[e + 36 >> 2], e = i[e + 40 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[r + 44 >> 2] = s, f = i[r + 48 >> 2], i[r + 48 >> 2] = e, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), s = i[r + 44 >> 2], e = i[r + 48 >> 2]), i[h + 36 >> 2] = e, i[h + 32 >> 2] = s, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 20 >> 2];
                                    r: {
                                        if (e >>> 0 < k0[r + 24 >> 2]) {
                                            i[e >> 2] = s, i[e + 4 >> 2] = i[h + 36 >> 2], i[r + 20 >> 2] = e + 8;
                                            break r;
                                        }
                                        if (f = p2(k, h + 32 | 0), e = i[h + 36 >> 2], i[r + 20 >> 2] = f, !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (f = i[r + 44 >> 2], !f) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 104, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    e = i[f + 36 >> 2], f = i[f + 40 >> 2];
                                    r: {
                                        if ((e | 0) != (f | 0)) for(;;){
                                            A: {
                                                if (k = i[e >> 2], !k || (s = E0(k, 73632, 74148), !s)) break A;
                                                if (e = i[e + 4 >> 2], !e) {
                                                    e = 0;
                                                    break r;
                                                }
                                                i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                                break r;
                                            }
                                            if (e = e + 8 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        e = 0, s = 0;
                                    }
                                    if (i[r + 36 >> 2] = s, f = i[r + 40 >> 2], i[r + 40 >> 2] = e, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), s = i[r + 36 >> 2]), !(!s | i[s + 108 >> 2] == 1885954932)) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 114, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    f = i[r + 44 >> 2], e = i[f + 36 >> 2], f = i[f + 40 >> 2];
                                    r: {
                                        if ((e | 0) != (f | 0)) for(;;){
                                            A: {
                                                if (k = i[e >> 2], !k || (s = E0(k, 73632, 74220), !s)) break A;
                                                if (e = i[e + 4 >> 2], !e) {
                                                    e = 0;
                                                    break r;
                                                }
                                                i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                                break r;
                                            }
                                            if (e = e + 8 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        e = 0, s = 0;
                                    }
                                    if (i[r + 92 >> 2] = s, f = i[r + 96 >> 2], i[r + 96 >> 2] = e, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), s = i[r + 92 >> 2]), !s) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 107, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    f = i[r + 44 >> 2], e = i[f + 36 >> 2], f = i[f + 40 >> 2];
                                    r: {
                                        if ((e | 0) != (f | 0)) for(;;){
                                            A: {
                                                if (k = i[e >> 2], !k || (s = E0(k, 73632, 74436), !s)) break A;
                                                if (e = i[e + 4 >> 2], !e) {
                                                    e = 0;
                                                    break r;
                                                }
                                                i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                                break r;
                                            }
                                            if (e = e + 8 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        e = 0, s = 0;
                                    }
                                    if (i[r + 116 >> 2] = s, f = i[r + 120 >> 2], i[r + 120 >> 2] = e, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), s = i[r + 116 >> 2]), !s) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 112, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    e = i[s + 36 >> 2], f = i[s + 40 >> 2];
                                    r: {
                                        if ((e | 0) != (f | 0)) for(;;){
                                            A: {
                                                if (k = i[e >> 2], !k || (s = E0(k, 73632, 74508), !s)) break A;
                                                if (e = i[e + 4 >> 2], !e) {
                                                    e = 0;
                                                    break r;
                                                }
                                                i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                                break r;
                                            }
                                            if (e = e + 8 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        e = 0, s = 0;
                                    }
                                    if (i[r + 52 >> 2] = s, f = i[r + 56 >> 2], i[r + 56 >> 2] = e, f && (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), s = i[r + 52 >> 2]), !s) {
                                        if (o[h + 32 | 0] = 0, o[h + 43 | 0] = 0, i0(A, 2, 108, h + 32 | 0), o[h + 43 | 0] >= 0) break e;
                                        X(i[h + 32 >> 2]);
                                        break e;
                                    }
                                    if (u = i[r + 116 >> 2], f = m - 16 | 0, m = f, e = h + 32 | 0, i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, k = i[u + 36 >> 2], s = i[u + 40 >> 2], (k | 0) != (s | 0)) for(;;){
                                        u = i[k >> 2];
                                        r: {
                                            if (!u || (n = E0(u, 73632, 74640), !n)) break r;
                                            i[f + 8 >> 2] = n, u = i[k + 4 >> 2], i[f + 12 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), u = i[e + 4 >> 2];
                                            A: {
                                                if (u >>> 0 < k0[e + 8 >> 2]) {
                                                    i[u >> 2] = n, n = i[f + 12 >> 2], i[u + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), u = u + 8 | 0;
                                                    break A;
                                                }
                                                u = P2(e, f + 8 | 0);
                                            }
                                            if (i[e + 4 >> 2] = u, u = i[f + 12 >> 2], !u || (n = i[u + 4 >> 2], i[u + 4 >> 2] = n - 1, n)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        if (k = k + 8 | 0, (s | 0) == (k | 0)) break;
                                    }
                                    m = f + 16 | 0;
                                    r: {
                                        A: {
                                            if (e = i[h + 32 >> 2], f = i[h + 36 >> 2], (e | 0) != (f | 0)) {
                                                if (f - e >>> 0 > 8) for(s = 1;;){
                                                    t = i[e >> 2], k = i[t + 108 >> 2], e = i[(s << 3) + e >> 2], f = i[e + 104 >> 2], n = f, u = i[e + 108 >> 2], w = u, e = 0, u = u - f >> 4;
                                                    f: {
                                                        if ((u | 0) <= 0) break f;
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        s: {
                                                                            if (v = i[t + 112 >> 2], (u | 0) <= v - k >> 4) {
                                                                                if ((u | 0) <= 0) {
                                                                                    v = f + (u << 4) | 0, e = k;
                                                                                    break k;
                                                                                }
                                                                                u = n;
                                                                                u: {
                                                                                    if ((w | 0) == (n | 0)) {
                                                                                        e = k;
                                                                                        break u;
                                                                                    }
                                                                                    for(e = k;;){
                                                                                        if (f = i[u >> 2], i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = f, f = i[u + 8 >> 2], n = i[u + 4 >> 2], (f | 0) != (n | 0)) {
                                                                                            if (f = f - n | 0, (f | 0) < 0) break s;
                                                                                            k = D(f), i[e + 8 >> 2] = k, i[e + 4 >> 2] = k, v = f + k | 0, i[e + 12 >> 2] = v, v0(k, n, f), i[e + 8 >> 2] = v;
                                                                                        }
                                                                                        if (e = e + 16 | 0, u = u + 16 | 0, (w | 0) == (u | 0)) break;
                                                                                    }
                                                                                }
                                                                                i[t + 108 >> 2] = e;
                                                                                break f;
                                                                            }
                                                                            if (f = i[t + 104 >> 2], w = u + (k - f >> 4) | 0, w >>> 0 >= 268435456) break o;
                                                                            if (v = v - f | 0, B = v >> 3, w = v >>> 0 >= 2147483632 ? 268435455 : w >>> 0 < B >>> 0 ? B : w, w) {
                                                                                if (w >>> 0 >= 268435456) break t;
                                                                                e = D(w << 4);
                                                                            }
                                                                            for(f = (k - f & -16) + e | 0, B = f + (u << 4) | 0, G = (w << 4) + e | 0, e = f;;){
                                                                                if (u = i[n >> 2], i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = u, u = i[n + 8 >> 2], v = i[n + 4 >> 2], (u | 0) != (v | 0)) {
                                                                                    if (u = u - v | 0, (u | 0) < 0) break n;
                                                                                    w = D(u), i[e + 8 >> 2] = w, i[e + 4 >> 2] = w, W = u + w | 0, i[e + 12 >> 2] = W, v0(w, v, u), i[e + 8 >> 2] = W;
                                                                                }
                                                                                if (n = n + 16 | 0, e = e + 16 | 0, (B | 0) == (e | 0)) break;
                                                                            }
                                                                            if (B = i[t + 104 >> 2], (B | 0) != (k | 0)) for(n = k, u = f; f = u - 16 | 0, w = n - 16 | 0, i[f >> 2] = i[w >> 2], v = n - 12 | 0, i[u - 12 >> 2] = i[v >> 2], i[u - 8 >> 2] = i[n - 8 >> 2], W = u - 4 | 0, u = n - 4 | 0, i[W >> 2] = i[u >> 2], i[u >> 2] = 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, u = f, n = w, (B | 0) != (n | 0););
                                                                            if (n = i[t + 108 >> 2], (n | 0) != (k | 0)) {
                                                                                for(; u = i[k >> 2], i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = u, i[e + 4 >> 2] = i[k + 4 >> 2], i[e + 8 >> 2] = i[k + 8 >> 2], i[e + 12 >> 2] = i[k + 12 >> 2], i[k + 12 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, e = e + 16 | 0, k = k + 16 | 0, (n | 0) != (k | 0););
                                                                                n = i[t + 108 >> 2];
                                                                            }
                                                                            if (i[t + 108 >> 2] = e, e = i[t + 104 >> 2], i[t + 104 >> 2] = f, i[t + 112 >> 2] = G, (e | 0) != (n | 0)) for(; f = i[n - 12 >> 2], f && (i[n - 8 >> 2] = f, X(f)), n = n - 16 | 0, (e | 0) != (n | 0););
                                                                            e && X(e);
                                                                            break f;
                                                                        }
                                                                        p0(), z();
                                                                    }
                                                                    p0(), z();
                                                                }
                                                                Z2(), z();
                                                            }
                                                            p0(), z();
                                                        }
                                                        if (f = u << 4, B = f + k | 0, u = e, f = e - f | 0, k >>> 0 > f >>> 0) for(w = f; G = i[w >> 2], i[u + 12 >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = G, i[u + 4 >> 2] = i[w + 4 >> 2], i[u + 8 >> 2] = i[w + 8 >> 2], i[u + 12 >> 2] = i[w + 12 >> 2], i[w + 12 >> 2] = 0, i[w + 4 >> 2] = 0, i[w + 8 >> 2] = 0, u = u + 16 | 0, w = w + 16 | 0, w >>> 0 < k >>> 0;);
                                                        if (i[t + 108 >> 2] = u, (e | 0) != (B | 0)) for(; u = e - 16 | 0, w = f - 16 | 0, i[u >> 2] = i[w >> 2], t = e - 12 | 0, B = i[t >> 2], B && (G = e - 8 | 0, i[G >> 2] = B, X(B), i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[t >> 2] = 0), B = t, t = f - 12 | 0, i[B >> 2] = i[t >> 2], i[e - 8 >> 2] = i[f - 8 >> 2], B = e - 4 | 0, e = f - 4 | 0, i[B >> 2] = i[e >> 2], i[e >> 2] = 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, e = u, f = w, (k | 0) != (f | 0););
                                                        if ((n | 0) == (v | 0)) break f;
                                                        for(e = k; i[e >> 2] = i[n >> 2], (e | 0) != (n | 0) && (f = i[n + 4 >> 2], k = i[n + 8 >> 2], a8(e + 4 | 0, f, k, k - f >> 2)), e = e + 16 | 0, n = n + 16 | 0, (v | 0) != (n | 0););
                                                    }
                                                    if (s = s + 1 | 0, e = i[h + 32 >> 2], !(s >>> 0 < i[h + 36 >> 2] - e >> 3 >>> 0)) break;
                                                }
                                                et(r + 60 | 0, e), f = h + 20 | 0;
                                                f: {
                                                    k: {
                                                        if (k = i[r + 44 >> 2], e = i[k + 36 >> 2], u = i[k + 40 >> 2], (e | 0) != (u | 0)) {
                                                            if (n = i[e >> 2], n && (k = i[f + 4 >> 2], n = E0(n, 73632, 76116), n)) break k;
                                                            if (e = e + 8 | 0, (u | 0) != (e | 0)) for(;;){
                                                                if (n = i[e >> 2], n && (k = 0, n = E0(n, 73632, 76116), n)) break k;
                                                                if (e = e + 8 | 0, (u | 0) == (e | 0)) break;
                                                            }
                                                            i[f >> 2] = 0, i[f + 4 >> 2] = 0;
                                                        }
                                                        i[f >> 2] = 0, i[f + 4 >> 2] = 0;
                                                        break f;
                                                    }
                                                    if (i[f + 4 >> 2] = k, i[f >> 2] = n, e = i[e + 4 >> 2], i[f + 4 >> 2] = e, !e) break f;
                                                    i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                                }
                                                if (A6(r + 68 | 0, f), B1(f), i[r + 68 >> 2]) break A;
                                                if (r = A, A = a1(f, 34896), i0(r, 2, 110, A), o[A + 11 | 0] >= 0) break r;
                                                X(i[A >> 2]);
                                                break r;
                                            }
                                            if (r = A, A = a1(h + 20 | 0, 34896), i0(r, 2, 109, A), o[A + 11 | 0] >= 0) break r;
                                            X(i[A >> 2]);
                                            break r;
                                        }
                                        e = h + 20 | 0;
                                        A: {
                                            f: {
                                                if (k = i[r + 44 >> 2], f = i[k + 36 >> 2], u = i[k + 40 >> 2], (f | 0) != (u | 0)) {
                                                    if (n = i[f >> 2], n && (k = i[e + 4 >> 2], n = E0(n, 73632, 75072), n)) break f;
                                                    if (f = f + 8 | 0, (u | 0) != (f | 0)) for(;;){
                                                        if (n = i[f >> 2], n && (k = 0, n = E0(n, 73632, 75072), n)) break f;
                                                        if (f = f + 8 | 0, (u | 0) == (f | 0)) break;
                                                    }
                                                    i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                }
                                                i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                break A;
                                            }
                                            if (i[e + 4 >> 2] = k, i[e >> 2] = n, f = i[f + 4 >> 2], i[e + 4 >> 2] = f, !f) break A;
                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                        }
                                        A6(r + 76 | 0, e), B1(e);
                                        A: {
                                            f: {
                                                if (k = i[r + 44 >> 2], f = i[k + 36 >> 2], u = i[k + 40 >> 2], (f | 0) != (u | 0)) {
                                                    if (n = i[f >> 2], n && (k = i[e + 4 >> 2], n = E0(n, 73632, 75e3), n)) break f;
                                                    if (f = f + 8 | 0, (u | 0) != (f | 0)) for(;;){
                                                        if (n = i[f >> 2], n && (k = 0, n = E0(n, 73632, 75e3), n)) break f;
                                                        if (f = f + 8 | 0, (u | 0) == (f | 0)) break;
                                                    }
                                                    i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                }
                                                i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                break A;
                                            }
                                            if (i[e + 4 >> 2] = k, i[e >> 2] = n, f = i[f + 4 >> 2], i[e + 4 >> 2] = f, !f) break A;
                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                        }
                                        k = r + 84 | 0, A6(k, e), B1(e);
                                        A: {
                                            if (!i[r + 84 >> 2]) break A;
                                            if (u = i[i[r + 92 >> 2] + 104 >> 2], f = m - 32 | 0, m = f, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[f + 24 >> 2] = 1065353216, R7(A, r, u, k, f + 8 | 0), e = i[f + 16 >> 2], e) for(; k = i[e >> 2], X(e), e = k, !!e;);
                                            if (e = i[f + 8 >> 2], i[f + 8 >> 2] = 0, e && X(e), m = f + 32 | 0, i[A >> 2]) break r;
                                            if (o[A + 19 | 0] >= 0) break A;
                                            X(i[A + 8 >> 2]);
                                        }
                                        f = h + 20 | 0;
                                        A: {
                                            f: {
                                                if (k = i[r + 44 >> 2], e = i[k + 36 >> 2], u = i[k + 40 >> 2], (e | 0) != (u | 0)) {
                                                    if (n = i[e >> 2], n && (k = i[f + 4 >> 2], n = E0(n, 73632, 74364), n)) break f;
                                                    if (e = e + 8 | 0, (u | 0) != (e | 0)) for(;;){
                                                        if (n = i[e >> 2], n && (k = 0, n = E0(n, 73632, 74364), n)) break f;
                                                        if (e = e + 8 | 0, (u | 0) == (e | 0)) break;
                                                    }
                                                    i[f >> 2] = 0, i[f + 4 >> 2] = 0;
                                                }
                                                i[f >> 2] = 0, i[f + 4 >> 2] = 0;
                                                break A;
                                            }
                                            if (i[f + 4 >> 2] = k, i[f >> 2] = n, e = i[e + 4 >> 2], i[f + 4 >> 2] = e, !e) break A;
                                            i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                        }
                                        if (A6(r + 100 | 0, f), B1(f), !i[r + 100 >> 2]) {
                                            if (r = A, A = a1(f, 34896), i0(r, 2, 111, A), o[A + 11 | 0] >= 0) break r;
                                            X(i[A >> 2]);
                                            break r;
                                        }
                                        e = h + 20 | 0;
                                        A: {
                                            f: {
                                                if (k = i[r + 44 >> 2], f = i[k + 36 >> 2], u = i[k + 40 >> 2], (f | 0) != (u | 0)) {
                                                    if (n = i[f >> 2], n && (k = i[e + 4 >> 2], n = E0(n, 73632, 75144), n)) break f;
                                                    if (f = f + 8 | 0, (u | 0) != (f | 0)) for(;;){
                                                        if (n = i[f >> 2], n && (k = 0, n = E0(n, 73632, 75144), n)) break f;
                                                        if (f = f + 8 | 0, (u | 0) == (f | 0)) break;
                                                    }
                                                    i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                }
                                                i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                break A;
                                            }
                                            if (i[e + 4 >> 2] = k, i[e >> 2] = n, f = i[f + 4 >> 2], i[e + 4 >> 2] = f, !f) break A;
                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                        }
                                        if (A6(r + 108 | 0, e), B1(e), u = i[r + 100 >> 2], f = m - 16 | 0, m = f, i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, k = i[u + 36 >> 2], s = i[u + 40 >> 2], (k | 0) != (s | 0)) for(;;){
                                            u = i[k >> 2];
                                            A: {
                                                if (!u || (n = E0(u, 73632, 74292), !n)) break A;
                                                i[f + 8 >> 2] = n, u = i[k + 4 >> 2], i[f + 12 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), u = i[e + 4 >> 2];
                                                f: {
                                                    if (u >>> 0 < k0[e + 8 >> 2]) {
                                                        i[u >> 2] = n, n = i[f + 12 >> 2], i[u + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), u = u + 8 | 0;
                                                        break f;
                                                    }
                                                    u = P2(e, f + 8 | 0);
                                                }
                                                if (i[e + 4 >> 2] = u, u = i[f + 12 >> 2], !u || (n = i[u + 4 >> 2], i[u + 4 >> 2] = n - 1, n)) break A;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                            }
                                            if (k = k + 8 | 0, (s | 0) == (k | 0)) break;
                                        }
                                        m = f + 16 | 0, e = i[h + 20 >> 2], s = i[h + 24 >> 2];
                                        A: {
                                            if ((e | 0) != (s | 0)) for(k = r + 124 | 0;;){
                                                if (r = i[e >> 2], !r) {
                                                    if (r = A, A = a1(h + 8 | 0, 34896), i0(r, 2, 125, A), o[A + 11 | 0] >= 0) break A;
                                                    X(i[A >> 2]);
                                                    break A;
                                                }
                                                f = i[r + 104 >> 2], i[h + 12 >> 2] = r, i[h + 8 >> 2] = f, r = i[e + 4 >> 2], i[h + 16 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), n = i[h + 8 >> 2], f = i[k + 4 >> 2];
                                                f: {
                                                    k: {
                                                        if (!f) {
                                                            u = k + 4 | 0, r = u;
                                                            break k;
                                                        }
                                                        for(;;){
                                                            if (r = f, f = i[f + 16 >> 2], f >>> 0 > n >>> 0) {
                                                                if (u = r, f = i[u >> 2], f) continue;
                                                                break k;
                                                            }
                                                            if (f >>> 0 >= n >>> 0) {
                                                                f = r, r = 0;
                                                                break f;
                                                            }
                                                            if (f = i[r + 4 >> 2], !f) break;
                                                        }
                                                        u = r + 4 | 0;
                                                    }
                                                    f = D(28), i[f + 16 >> 2] = n, i[f + 20 >> 2] = i[h + 12 >> 2], i[f + 24 >> 2] = i[h + 16 >> 2], i[h + 12 >> 2] = 0, i[h + 16 >> 2] = 0, i[f + 8 >> 2] = r, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[u >> 2] = f, r = f, n = i[i[k >> 2] >> 2], n && (i[k >> 2] = n, r = i[u >> 2]), h4(i[k + 4 >> 2], r), i[k + 8 >> 2] = i[k + 8 >> 2] + 1, r = 1;
                                                }
                                                o[h + 4 | 0] = r, i[h >> 2] = f, r = i[h + 16 >> 2];
                                                f: {
                                                    if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break f;
                                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                }
                                                if (e = e + 8 | 0, (s | 0) == (e | 0)) break;
                                            }
                                            J6(A);
                                        }
                                        H9(h + 20 | 0);
                                    }
                                    if (A = i[h + 32 >> 2], !A) break e;
                                    if (e = A, w = i[h + 36 >> 2], (e | 0) != (w | 0)) {
                                        for(;;){
                                            r = i[w - 4 >> 2];
                                            r: {
                                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            if (w = w - 8 | 0, (A | 0) == (w | 0)) break;
                                        }
                                        e = i[h + 32 >> 2];
                                    }
                                    i[h + 36 >> 2] = A, X(e);
                                }
                                if (m = h + 176 | 0, o[_ + 43 | 0] >= 0) break i;
                                X(i[_ + 32 >> 2]);
                            }
                            m = _ + 48 | 0;
                        }
                        function kh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0;
                            if (f) {
                                f = m - 32 | 0, m = f, t = f + 8 | 0, v4(t, i[r + 20 >> 2], i[(i[r + 384 >> 2] + (Z(I[r + 374 >> 1], n) << 2) | 0) + (k << 2) >> 2], 1), r = i[f + 12 >> 2], u = t, t = i[f + 8 >> 2], p[i[i[t >> 2] + 20 >> 2]](u, t);
                                i: {
                                    if (i[f + 8 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[f + 12 >> 2], i[A + 8 >> 2] = i[f + 8 >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0, o[f + 27 | 0] >= 0) {
                                            e = i[f + 20 >> 2], i[A >> 2] = i[f + 16 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[f + 24 >> 2];
                                            break i;
                                        }
                                        if (j(A, i[f + 16 >> 2], i[f + 20 >> 2]), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), p[i[i[t >> 2] + 64 >> 2]](A, t, e, 1, k, n);
                                }
                                i: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                m = f + 32 | 0;
                                return;
                            }
                            n = 0, s = m - 192 | 0, m = s, i[s + 184 >> 2] = 0, i[s + 188 >> 2] = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (f = i[r + 384 >> 2], k = i[r + 388 >> 2], (f | 0) == (k | 0)) break f;
                                                for(;;){
                                                    if (t = i[f >> 2], L9(i[r + 20 >> 2], t)) {
                                                        if (f = f + 4 | 0, (k | 0) != (f | 0)) continue;
                                                        break f;
                                                    }
                                                    break;
                                                }
                                                i[s + 48 >> 2] = 59808, i[s + 104 >> 2] = 59828, r = i[14961], i[s + 40 >> 2] = r, e = i[r - 12 >> 2], r = s + 40 | 0, i[e + r >> 2] = i[14962], i[s + 44 >> 2] = 0, e = r + i[i[s + 40 >> 2] - 12 >> 2] | 0, f = s + 52 | 0, T0(e, f), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[s + 48 >> 2] = e, k = i[e - 12 >> 2], e = s + 48 | 0, i[k + e >> 2] = i[14964], k = i[14960], i[s + 40 >> 2] = k, i[r + i[k - 12 >> 2] >> 2] = i[14965], i[s + 104 >> 2] = 59828, i[s + 40 >> 2] = 59788, i[s + 48 >> 2] = 59808, f = z0(f), i[f >> 2] = 58864, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 84 >> 2] = 0, i[s + 88 >> 2] = 0, i[s + 100 >> 2] = 24, U(M0(U(e, 17450, 14), t), 19723, 23), r = i[s + 100 >> 2];
                                                k: {
                                                    if (r & 16) {
                                                        n = s + 72 | 0, e = i[s + 96 >> 2], r = i[s + 76 >> 2], e >>> 0 < r >>> 0 ? i[s + 96 >> 2] = r : r = e;
                                                        break k;
                                                    }
                                                    if (!(r & 8)) {
                                                        r = 0, o[s + 15 | 0] = 0, n = s + 4 | 0;
                                                        break e;
                                                    }
                                                    n = s + 60 | 0, r = i[s + 68 >> 2];
                                                }
                                                if (e = i[n >> 2], r = r - e | 0, r >>> 0 >= 2147483640) break A;
                                                if (r >>> 0 >= 11) {
                                                    k = (r | 7) + 1 | 0, n = D(k), i[s + 12 >> 2] = k | -2147483648, i[s + 4 >> 2] = n, i[s + 8 >> 2] = r;
                                                    break r;
                                                }
                                                if (o[s + 15 | 0] = r, n = s + 4 | 0, r) break r;
                                                r = 0;
                                                break e;
                                            }
                                            h6(s + 40 | 0, i[r + 20 >> 2] - -64 | 0, i[r + 376 >> 2], i[r + 380 >> 2]);
                                            f: {
                                                if (i[s + 40 >> 2]) {
                                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[s + 44 >> 2], i[A + 8 >> 2] = i[s + 40 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[s + 59 | 0] >= 0) {
                                                        r = i[s + 52 >> 2], i[A >> 2] = i[s + 48 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[s + 56 >> 2];
                                                        break f;
                                                    }
                                                    j(A, i[s + 48 >> 2], i[s + 52 >> 2]);
                                                    break f;
                                                }
                                                f = i[e + 4 >> 2], f && p[f | 0](0, Z(I[r + 374 >> 1], I[r + 372 >> 1]), i[e + 16 >> 2]), f = i[e + 8 >> 2], f && p[f | 0](0, 0, i[e + 16 >> 2]), i[s >> 2] = 0, P = I[r + 372 >> 1];
                                                k: {
                                                    if (!P) break k;
                                                    for(y = A + 16 | 0, f = I[r + 374 >> 1], k = 0;;){
                                                        n: {
                                                            t: {
                                                                if (f & 65535) {
                                                                    P = 0, X0 = 0;
                                                                    break t;
                                                                }
                                                                f = 0, n = 0;
                                                                break n;
                                                            }
                                                            for(;;){
                                                                u = s + 16 | 0, t = i[i[r + 384 >> 2] + (g0 << 2) >> 2], v4(u, i[r + 20 >> 2], t, 1), c = i[s + 20 >> 2];
                                                                t: {
                                                                    o: {
                                                                        if (f = i[s + 16 >> 2], !f) {
                                                                            f = D(40), i[s + 4 >> 2] = f, i[s + 8 >> 2] = 33, i[s + 12 >> 2] = -2147483608, o[f + 32 | 0] = l[14518], n = l[14514] | l[14515] << 8 | (l[14516] << 16 | l[14517] << 24), t = l[14510] | l[14511] << 8 | (l[14512] << 16 | l[14513] << 24), o[f + 24 | 0] = t, o[f + 25 | 0] = t >>> 8, o[f + 26 | 0] = t >>> 16, o[f + 27 | 0] = t >>> 24, o[f + 28 | 0] = n, o[f + 29 | 0] = n >>> 8, o[f + 30 | 0] = n >>> 16, o[f + 31 | 0] = n >>> 24, n = l[14506] | l[14507] << 8 | (l[14508] << 16 | l[14509] << 24), t = l[14502] | l[14503] << 8 | (l[14504] << 16 | l[14505] << 24), o[f + 16 | 0] = t, o[f + 17 | 0] = t >>> 8, o[f + 18 | 0] = t >>> 16, o[f + 19 | 0] = t >>> 24, o[f + 20 | 0] = n, o[f + 21 | 0] = n >>> 8, o[f + 22 | 0] = n >>> 16, o[f + 23 | 0] = n >>> 24, n = l[14498] | l[14499] << 8 | (l[14500] << 16 | l[14501] << 24), t = l[14494] | l[14495] << 8 | (l[14496] << 16 | l[14497] << 24), o[f + 8 | 0] = t, o[f + 9 | 0] = t >>> 8, o[f + 10 | 0] = t >>> 16, o[f + 11 | 0] = t >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, n = l[14490] | l[14491] << 8 | (l[14492] << 16 | l[14493] << 24), t = l[14486] | l[14487] << 8 | (l[14488] << 16 | l[14489] << 24), o[f | 0] = t, o[f + 1 | 0] = t >>> 8, o[f + 2 | 0] = t >>> 16, o[f + 3 | 0] = t >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 33 | 0] = 0, f = i0(u, 2, 119, s + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = n;
                                                                            s: {
                                                                                if (o[s + 35 | 0] >= 0) {
                                                                                    f = i[s + 28 >> 2], i[y >> 2] = i[s + 24 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 32 >> 2];
                                                                                    break s;
                                                                                }
                                                                                if (j(y, i[s + 24 >> 2], i[s + 28 >> 2]), o[s + 35 | 0] >= 0) break s;
                                                                                X(i[s + 24 >> 2]);
                                                                            }
                                                                            if (o[s + 15 | 0] >= 0) break o;
                                                                            X(i[s + 4 >> 2]);
                                                                            break o;
                                                                        }
                                                                        if (p[i[i[f >> 2] + 20 >> 2]](s + 16 | 0, f), i[s + 16 >> 2]) {
                                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[s + 20 >> 2], i[A + 8 >> 2] = i[s + 16 >> 2], i[A + 12 >> 2] = f, o[s + 35 | 0] >= 0) {
                                                                                f = i[s + 28 >> 2], i[y >> 2] = i[s + 24 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 32 >> 2];
                                                                                break o;
                                                                            }
                                                                            if (j(y, i[s + 24 >> 2], i[s + 28 >> 2]), o[s + 35 | 0] >= 0) break o;
                                                                            X(i[s + 24 >> 2]);
                                                                            break o;
                                                                        }
                                                                        if (o[s + 35 | 0] < 0 && X(i[s + 24 >> 2]), t0 = i[f + 40 >> 2], f = i[f + 44 >> 2], h6(s + 16 | 0, i[r + 20 >> 2] - -64 | 0, t0, f), u = i[s + 20 >> 2], n = i[s + 16 >> 2], i[s + 40 >> 2] = n, i[s + 44 >> 2] = u, o[s + 59 | 0] < 0 && (X(i[s + 48 >> 2]), n = i[s + 40 >> 2]), u = i[s + 28 >> 2], i[s + 48 >> 2] = i[s + 24 >> 2], i[s + 52 >> 2] = u, i[s + 56 >> 2] = i[s + 32 >> 2], n) {
                                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[s + 44 >> 2], i[A + 8 >> 2] = i[s + 40 >> 2], i[A + 12 >> 2] = f, o[s + 59 | 0] >= 0) {
                                                                                f = i[s + 52 >> 2], i[y >> 2] = i[s + 48 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 56 >> 2];
                                                                                break o;
                                                                            }
                                                                            j(y, i[s + 48 >> 2], i[s + 52 >> 2]);
                                                                            break o;
                                                                        }
                                                                        s: {
                                                                            if (k0[r + 376 >> 2] / I[r + 374 >> 1] >>> 0 <= t0 >>> 0 && f >>> 0 >= k0[r + 380 >> 2] / I[r + 372 >> 1] >>> 0) break s;
                                                                            f = D(40), i[s + 4 >> 2] = f, i[s + 8 >> 2] = 35, i[s + 12 >> 2] = -2147483608, n = l[11964] | l[11965] << 8 | (l[11966] << 16 | l[11967] << 24), o[f + 31 | 0] = n, o[f + 32 | 0] = n >>> 8, o[f + 33 | 0] = n >>> 16, o[f + 34 | 0] = n >>> 24, n = l[11961] | l[11962] << 8 | (l[11963] << 16 | l[11964] << 24), t = l[11957] | l[11958] << 8 | (l[11959] << 16 | l[11960] << 24), o[f + 24 | 0] = t, o[f + 25 | 0] = t >>> 8, o[f + 26 | 0] = t >>> 16, o[f + 27 | 0] = t >>> 24, o[f + 28 | 0] = n, o[f + 29 | 0] = n >>> 8, o[f + 30 | 0] = n >>> 16, o[f + 31 | 0] = n >>> 24, n = l[11953] | l[11954] << 8 | (l[11955] << 16 | l[11956] << 24), t = l[11949] | l[11950] << 8 | (l[11951] << 16 | l[11952] << 24), o[f + 16 | 0] = t, o[f + 17 | 0] = t >>> 8, o[f + 18 | 0] = t >>> 16, o[f + 19 | 0] = t >>> 24, o[f + 20 | 0] = n, o[f + 21 | 0] = n >>> 8, o[f + 22 | 0] = n >>> 16, o[f + 23 | 0] = n >>> 24, n = l[11945] | l[11946] << 8 | (l[11947] << 16 | l[11948] << 24), t = l[11941] | l[11942] << 8 | (l[11943] << 16 | l[11944] << 24), o[f + 8 | 0] = t, o[f + 9 | 0] = t >>> 8, o[f + 10 | 0] = t >>> 16, o[f + 11 | 0] = t >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, n = l[11937] | l[11938] << 8 | (l[11939] << 16 | l[11940] << 24), t = l[11933] | l[11934] << 8 | (l[11935] << 16 | l[11936] << 24), o[f | 0] = t, o[f + 1 | 0] = t >>> 8, o[f + 2 | 0] = t >>> 16, o[f + 3 | 0] = t >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 35 | 0] = 0, f = i0(s + 16 | 0, 2, 118, s + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = n;
                                                                            u: {
                                                                                if (o[s + 35 | 0] >= 0) {
                                                                                    f = i[s + 28 >> 2], i[y >> 2] = i[s + 24 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 32 >> 2];
                                                                                    break u;
                                                                                }
                                                                                if (j(y, i[s + 24 >> 2], i[s + 28 >> 2]), o[s + 35 | 0] >= 0) break u;
                                                                                X(i[s + 24 >> 2]);
                                                                            }
                                                                            if (o[s + 15 | 0] >= 0) break o;
                                                                            X(i[s + 4 >> 2]);
                                                                            break o;
                                                                        }
                                                                        s: {
                                                                            if (!(P | V0)) {
                                                                                i2 = t0, k = f;
                                                                                break s;
                                                                            }
                                                                            if ((t0 | 0) == (i2 | 0) & (f | 0) == (k | 0)) break s;
                                                                            f = D(32), i[s + 4 >> 2] = f, i[s + 8 >> 2] = 31, i[s + 12 >> 2] = -2147483616, n = l[4462] | l[4463] << 8 | (l[4464] << 16 | l[4465] << 24), t = l[4458] | l[4459] << 8 | (l[4460] << 16 | l[4461] << 24), o[f + 23 | 0] = t, o[f + 24 | 0] = t >>> 8, o[f + 25 | 0] = t >>> 16, o[f + 26 | 0] = t >>> 24, o[f + 27 | 0] = n, o[f + 28 | 0] = n >>> 8, o[f + 29 | 0] = n >>> 16, o[f + 30 | 0] = n >>> 24, n = l[4455] | l[4456] << 8 | (l[4457] << 16 | l[4458] << 24), t = l[4451] | l[4452] << 8 | (l[4453] << 16 | l[4454] << 24), o[f + 16 | 0] = t, o[f + 17 | 0] = t >>> 8, o[f + 18 | 0] = t >>> 16, o[f + 19 | 0] = t >>> 24, o[f + 20 | 0] = n, o[f + 21 | 0] = n >>> 8, o[f + 22 | 0] = n >>> 16, o[f + 23 | 0] = n >>> 24, n = l[4447] | l[4448] << 8 | (l[4449] << 16 | l[4450] << 24), t = l[4443] | l[4444] << 8 | (l[4445] << 16 | l[4446] << 24), o[f + 8 | 0] = t, o[f + 9 | 0] = t >>> 8, o[f + 10 | 0] = t >>> 16, o[f + 11 | 0] = t >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, n = l[4439] | l[4440] << 8 | (l[4441] << 16 | l[4442] << 24), t = l[4435] | l[4436] << 8 | (l[4437] << 16 | l[4438] << 24), o[f | 0] = t, o[f + 1 | 0] = t >>> 8, o[f + 2 | 0] = t >>> 16, o[f + 3 | 0] = t >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 31 | 0] = 0, f = i0(s + 16 | 0, 2, 118, s + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = n;
                                                                            u: {
                                                                                if (o[s + 35 | 0] >= 0) {
                                                                                    f = i[s + 28 >> 2], i[y >> 2] = i[s + 24 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 32 >> 2];
                                                                                    break u;
                                                                                }
                                                                                if (j(y, i[s + 24 >> 2], i[s + 28 >> 2]), o[s + 35 | 0] >= 0) break u;
                                                                                X(i[s + 24 >> 2]);
                                                                            }
                                                                            if (o[s + 15 | 0] >= 0) break o;
                                                                            X(i[s + 4 >> 2]);
                                                                            break o;
                                                                        }
                                                                        f = i[e + 44 >> 2], f ? n = (p[f | 0](i[e + 16 >> 2]) | 0) != 0 : n = 0, v = m - 80 | 0, m = v, v4(v + 52 | 0, i[r + 20 >> 2], t, 1), r0 = i[v + 56 >> 2], B = s + 16 | 0, f = i[v + 52 >> 2], p[i[i[f >> 2] + 20 >> 2]](B, f), E = 0;
                                                                        s: {
                                                                            if (i[B >> 2]) break s;
                                                                            o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), ii(v + 52 | 0, f, e, 0, 0, 0);
                                                                            u: {
                                                                                if (i[v + 60 >> 2]) {
                                                                                    if (f = i[v + 64 >> 2], i[B >> 2] = i[v + 60 >> 2], i[B + 4 >> 2] = f, f = B + 8 | 0, o[v + 79 | 0] >= 0) {
                                                                                        t = i[v + 72 >> 2], i[f >> 2] = i[v + 68 >> 2], i[f + 4 >> 2] = t, i[f + 8 >> 2] = i[v + 76 >> 2];
                                                                                        break u;
                                                                                    }
                                                                                    j(f, i[v + 68 >> 2], i[v + 72 >> 2]);
                                                                                    break u;
                                                                                }
                                                                                E = i[v + 56 >> 2], E && (i[E + 4 >> 2] = i[E + 4 >> 2] + 1), R = i[v + 52 >> 2];
                                                                                w: {
                                                                                    if (f = i[s + 184 >> 2], !f) {
                                                                                        _ = i[r + 380 >> 2], W = i[r + 376 >> 2], f = D(136), i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = 78252, B0(f + 20 | 0, 0, 104), i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 44 >> 2] = 99, i[f + 48 >> 2] = 99, i[f + 32 >> 2] = 4142, t = f - -64 | 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, i[f + 132 >> 2] = 0, i[f + 124 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 84 >> 2] = 1, i[f + 88 >> 2] = 1, i[f + 72 >> 2] = f + 76, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, i[f + 112 >> 2] = 0, o[f + 113 | 0] = 0, o[f + 114 | 0] = 0, o[f + 115 | 0] = 0, o[f + 116 | 0] = 0, o[f + 117 | 0] = 0, o[f + 118 | 0] = 0, o[f + 119 | 0] = 0, o[f + 120 | 0] = 0, i[v + 36 >> 2] = f, t = f + 12 | 0, i[v + 32 >> 2] = t, i[f + 12 >> 2] = t, i[f + 8 >> 2] = i[f + 8 >> 2] + 1, i[f + 16 >> 2] = f, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), h = i[v + 32 >> 2], i[v + 48 >> 2] = E, i[v + 44 >> 2] = R, E && (i[E + 4 >> 2] = i[E + 4 >> 2] + 1), C = i[r + 20 >> 2] - -64 | 0, t = i[v + 44 >> 2], f = i[t + 32 >> 2], w = i[t + 36 >> 2], i[h + 36 >> 2] = w, i[h + 32 >> 2] = f, i[h + 28 >> 2] = _, i[h + 24 >> 2] = W;
                                                                                        l: {
                                                                                            h: {
                                                                                                v: {
                                                                                                    _: switch(f | 0){
                                                                                                        case 2:
                                                                                                            u = 255, f = i[t + 64 >> 2];
                                                                                                            B: {
                                                                                                                if (!f) break B;
                                                                                                                for(w = t - -64 | 0, t = w; G = i[f + 16 >> 2], t = (G | 0) < 0 ? t : f, f = i[(G >>> 29 & 4) + f >> 2], !!f;);
                                                                                                                if ((t | 0) == (w | 0) | i[t + 16 >> 2] > 0) break B;
                                                                                                                u = l[t + 24 | 0];
                                                                                                            }
                                                                                                            if (J0(B, h, 0, W, _, u, C), i[B >> 2]) break l;
                                                                                                            if (o[B + 19 | 0] < 0) break v;
                                                                                                            break h;
                                                                                                        case 0:
                                                                                                            f = i[t + 64 >> 2], u = 255;
                                                                                                            B: {
                                                                                                                if (!f) break B;
                                                                                                                for(G = t - -64 | 0, t = G; u = i[f + 16 >> 2], t = (u | 0) < 0 ? t : f, f = i[(u >>> 29 & 4) + f >> 2], !!f;);
                                                                                                                if (u = 255, (t | 0) == (G | 0) || (u = 255, i[t + 16 >> 2] > 0)) break B;
                                                                                                                u = l[t + 24 | 0];
                                                                                                            }
                                                                                                            if (J0(B, h, 0, W, _, u, C), i[B >> 2]) break l;
                                                                                                            o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), G = (w | 0) == 1 ? _ + 1 >>> 1 | 0 : _, w = w - 1 >>> 0 < 2 ? W + 1 >>> 1 | 0 : W, u = 255, t = i[v + 44 >> 2], f = i[t + 64 >> 2];
                                                                                                            B: {
                                                                                                                if (!f) break B;
                                                                                                                for(F = t - -64 | 0, t = F; H = i[f + 16 >> 2] <= 0, t = H ? t : f, f = i[(H << 2) + f >> 2], !!f;);
                                                                                                                if ((t | 0) == (F | 0) | i[t + 16 >> 2] > 1) break B;
                                                                                                                u = l[t + 24 | 0];
                                                                                                            }
                                                                                                            if (J0(B, h, 1, w, G, u, C), i[B >> 2]) break l;
                                                                                                            o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), u = 255, t = i[v + 44 >> 2], f = i[t + 64 >> 2];
                                                                                                            B: {
                                                                                                                if (!f) break B;
                                                                                                                for(F = t - -64 | 0, t = F; H = i[f + 16 >> 2] < 2, t = H ? t : f, f = i[(H << 2) + f >> 2], !!f;);
                                                                                                                if ((t | 0) == (F | 0) | i[t + 16 >> 2] > 2) break B;
                                                                                                                u = l[t + 24 | 0];
                                                                                                            }
                                                                                                            if (J0(B, h, 2, w, G, u, C), i[B >> 2]) break l;
                                                                                                            if (o[B + 19 | 0] < 0) break v;
                                                                                                            break h;
                                                                                                        case 1:
                                                                                                            break _;
                                                                                                        default:
                                                                                                            break h;
                                                                                                    }
                                                                                                    f = i[t + 64 >> 2], u = 255;
                                                                                                    _: {
                                                                                                        if (!f) break _;
                                                                                                        for(w = t - -64 | 0, t = w; u = i[f + 16 >> 2] < 3, t = u ? t : f, f = i[(u << 2) + f >> 2], !!f;);
                                                                                                        if (u = 255, (t | 0) == (w | 0) || (u = 255, i[t + 16 >> 2] > 3)) break _;
                                                                                                        u = l[t + 24 | 0];
                                                                                                    }
                                                                                                    if (J0(B, h, 3, W, _, u, C), i[B >> 2]) break l;
                                                                                                    o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), u = 255, t = i[v + 44 >> 2], f = i[t + 64 >> 2];
                                                                                                    _: {
                                                                                                        if (!f) break _;
                                                                                                        for(w = t - -64 | 0, t = w; G = i[f + 16 >> 2] < 4, t = G ? t : f, f = i[(G << 2) + f >> 2], !!f;);
                                                                                                        if ((t | 0) == (w | 0) | i[t + 16 >> 2] > 4) break _;
                                                                                                        u = l[t + 24 | 0];
                                                                                                    }
                                                                                                    if (J0(B, h, 4, W, _, u, C), i[B >> 2]) break l;
                                                                                                    o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), u = 255, t = i[v + 44 >> 2], f = i[t + 64 >> 2];
                                                                                                    _: {
                                                                                                        if (!f) break _;
                                                                                                        for(w = t - -64 | 0, t = w; G = i[f + 16 >> 2] < 5, t = G ? t : f, f = i[(G << 2) + f >> 2], !!f;);
                                                                                                        if ((t | 0) == (w | 0) | i[t + 16 >> 2] > 5) break _;
                                                                                                        u = l[t + 24 | 0];
                                                                                                    }
                                                                                                    if (J0(B, h, 5, W, _, u, C), i[B >> 2]) break l;
                                                                                                    if (o[B + 19 | 0] >= 0) break h;
                                                                                                }
                                                                                                X(i[B + 8 >> 2]);
                                                                                            }
                                                                                            G = i[v + 44 >> 2], u = G - -64 | 0, t = i[G + 64 >> 2];
                                                                                            h: {
                                                                                                v: {
                                                                                                    _: {
                                                                                                        if (!t) break _;
                                                                                                        for(w = u, f = t; F = i[f + 16 >> 2] < 6, w = F ? w : f, f = i[(F << 2) + f >> 2], !!f;);
                                                                                                        if ((u | 0) == (w | 0)) break _;
                                                                                                        if (i[w + 16 >> 2] < 7) break v;
                                                                                                    }
                                                                                                    if (f = i[G + 36 >> 2], f >>> 0 > 15 | !(1 << f & 43008)) break h;
                                                                                                }
                                                                                                w = 255;
                                                                                                v: {
                                                                                                    if (!t) break v;
                                                                                                    for(f = u; G = i[t + 16 >> 2] < 6, f = G ? f : t, t = i[(G << 2) + t >> 2], !!t;);
                                                                                                    if ((f | 0) == (u | 0) | i[f + 16 >> 2] > 6) break v;
                                                                                                    w = l[f + 24 | 0];
                                                                                                }
                                                                                                if (J0(B, h, 6, W, _, w, C), i[B >> 2]) break l;
                                                                                                if (o[B + 19 | 0] >= 0) break h;
                                                                                                X(i[B + 8 >> 2]);
                                                                                            }
                                                                                            if (f = i[21669], i[B >> 2] = i[21668], i[B + 4 >> 2] = f, f = B + 8 | 0, o[86691] >= 0) {
                                                                                                t = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = t, i[f + 8 >> 2] = i[21672];
                                                                                                break l;
                                                                                            }
                                                                                            j(f, i[21670], i[21671]);
                                                                                        }
                                                                                        f = i[v + 48 >> 2];
                                                                                        l: {
                                                                                            if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                        }
                                                                                        if (i[B >> 2]) break w;
                                                                                        if (_ = i[v + 32 >> 2], A1(_, 6)) {
                                                                                            G = (-1 << S0(_, 6) ^ -1) & 65535, w = 0, H = 0, C = 0, F = 0, f = 1;
                                                                                            l: {
                                                                                                h: switch(i[_ + 36 >> 2]){
                                                                                                    case 10:
                                                                                                    case 12:
                                                                                                    case 14:
                                                                                                        f = 3;
                                                                                                        break l;
                                                                                                    case 11:
                                                                                                    case 13:
                                                                                                    case 15:
                                                                                                        f = 4;
                                                                                                        break l;
                                                                                                    case 0:
                                                                                                    case 1:
                                                                                                    case 2:
                                                                                                    case 3:
                                                                                                    case 99:
                                                                                                        break l;
                                                                                                    default:
                                                                                                        break h;
                                                                                                }
                                                                                                f = 0;
                                                                                            }
                                                                                            W = f, t = i[_ + 64 >> 2];
                                                                                            l: {
                                                                                                if (!t) break l;
                                                                                                for(u = _ - -64 | 0, h = u, f = t; T = i[f + 16 >> 2] < 6, h = T ? h : f, f = i[(T << 2) + f >> 2], !!f;);
                                                                                                for(w = (u | 0) == (h | 0) | i[h + 16 >> 2] > 6 ? w : l[h + 24 | 0] < 9, h = u, f = t; T = i[f + 16 >> 2] < 6, h = T ? h : f, f = i[(T << 2) + f >> 2], !!f;);
                                                                                                for(F = (u | 0) == (h | 0) | i[h + 16 >> 2] > 6 ? F : i[h + 28 >> 2], h = u, f = t; T = i[f + 16 >> 2] < 6, h = T ? h : f, f = i[(T << 2) + f >> 2], !!f;);
                                                                                                if (C = (u | 0) == (h | 0) | i[h + 16 >> 2] > 6 ? C : i[h + 32 >> 2], w) {
                                                                                                    for(f = u; h = i[t + 16 >> 2] < 6, f = h ? f : t, t = i[(h << 2) + t >> 2], !!t;);
                                                                                                    h: {
                                                                                                        if ((f | 0) == (u | 0)) {
                                                                                                            h = 0, u = 0;
                                                                                                            break h;
                                                                                                        }
                                                                                                        if (h = 0, u = 0, i[f + 16 >> 2] > 6) break h;
                                                                                                        h = i[f + 52 >> 2], u = i[f + 44 >> 2];
                                                                                                    }
                                                                                                    if (!C) break l;
                                                                                                    if (W = Z(W, F), f = 0, t = 0, C >>> 0 >= 4) for(F = C & -4, w = 0; B0(u + Z(t, h) | 0, G, W), B0(u + Z(t | 1, h) | 0, G, W), B0(u + Z(t | 2, h) | 0, G, W), B0(u + Z(t | 3, h) | 0, G, W), t = t + 4 | 0, w = w + 4 | 0, (F | 0) != (w | 0););
                                                                                                    if (w = C & 3, !w) break l;
                                                                                                    for(; B0(u + Z(t, h) | 0, G, W), t = t + 1 | 0, f = f + 1 | 0, (w | 0) != (f | 0););
                                                                                                    break l;
                                                                                                }
                                                                                                for(f = u; h = i[t + 16 >> 2] < 6, f = h ? f : t, t = i[(h << 2) + t >> 2], !!t;);
                                                                                                t = 0;
                                                                                                h: {
                                                                                                    if ((f | 0) == (u | 0) || (t = 0, i[f + 16 >> 2] > 6)) break h;
                                                                                                    H = i[f + 44 >> 2], t = i[f + 52 >> 2] >>> 1 | 0;
                                                                                                }
                                                                                                if (!C || (u = Z(W, F), !u)) break l;
                                                                                                for(f = t, T = u & -8, W = u & 7, w = 0, f0 = u >>> 0 < 8;;){
                                                                                                    if (F = (Z(f, w) << 1) + H | 0, u = 0, h = 0, !f0) for(; t = F + (u << 1) | 0, Q[t >> 1] = G, Q[t + 2 >> 1] = G, Q[t + 4 >> 1] = G, Q[t + 6 >> 1] = G, Q[t + 8 >> 1] = G, Q[t + 10 >> 1] = G, Q[t + 12 >> 1] = G, Q[t + 14 >> 1] = G, u = u + 8 | 0, h = h + 8 | 0, (T | 0) != (h | 0););
                                                                                                    if (t = 0, W) for(; Q[F + (u << 1) >> 1] = G, u = u + 1 | 0, t = t + 1 | 0, (W | 0) != (t | 0););
                                                                                                    if (w = w + 1 | 0, (C | 0) == (w | 0)) break;
                                                                                                }
                                                                                            }
                                                                                        }
                                                                                        i[v + 48 >> 2] = E, i[v + 44 >> 2] = R, E && (i[E + 4 >> 2] = i[E + 4 >> 2] + 1), f = i[v + 44 >> 2], u = i[f + 44 >> 2], t = i[f + 48 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[_ + 44 >> 2] = u, f = i[_ + 48 >> 2], i[_ + 48 >> 2] = t;
                                                                                        l: {
                                                                                            if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                        }
                                                                                        f = i[v + 44 >> 2], u = i[f + 52 >> 2], t = i[f + 56 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[_ + 52 >> 2] = u, f = i[_ + 56 >> 2], i[_ + 56 >> 2] = t;
                                                                                        l: {
                                                                                            if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                        }
                                                                                        f = i[v + 44 >> 2], t = i[f + 72 >> 2], u = i[f + 76 >> 2], (t | 0) != (u | 0) && (i[_ + 76 >> 2] = u, i[_ + 72 >> 2] = t), I[f + 80 >> 1] | I[f + 82 >> 1] && (i[_ + 80 >> 2] = i[f + 80 >> 2], f = i[v + 44 >> 2]), l[f + 108 | 0] == 1 && (t = i[f + 92 >> 2], u = i[f + 96 >> 2], h = i[f + 84 >> 2], w = i[f + 88 >> 2], W = i[f + 104 >> 2], i[_ + 100 >> 2] = i[f + 100 >> 2], i[_ + 104 >> 2] = W, i[_ + 92 >> 2] = t, i[_ + 96 >> 2] = u, i[_ + 84 >> 2] = h, i[_ + 88 >> 2] = w, o[_ + 108 | 0] = 1, f = i[v + 44 >> 2]), o[_ + 40 | 0] = l[f + 40 | 0], f = i[v + 48 >> 2];
                                                                                        l: {
                                                                                            if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                        }
                                                                                        f = i[v + 32 >> 2], t = i[v + 36 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[s + 184 >> 2] = f, f = i[s + 188 >> 2], i[s + 188 >> 2] = t;
                                                                                        l: {
                                                                                            if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                        }
                                                                                        o[B + 19 | 0] < 0 && X(i[B + 8 >> 2]), B1(v + 32 | 0), f = i[s + 184 >> 2];
                                                                                    }
                                                                                    if (i[f + 36 >> 2] != i[R + 36 >> 2]) {
                                                                                        if (f = D(64), i[v + 32 >> 2] = f, i[v + 36 >> 2] = 58, i[v + 40 >> 2] = -2147483584, t = l[12135] | l[12136] << 8 | (l[12137] << 16 | l[12138] << 24), u = l[12131] | l[12132] << 8 | (l[12133] << 16 | l[12134] << 24), o[f | 0] = u, o[f + 1 | 0] = u >>> 8, o[f + 2 | 0] = u >>> 16, o[f + 3 | 0] = u >>> 24, o[f + 4 | 0] = t, o[f + 5 | 0] = t >>> 8, o[f + 6 | 0] = t >>> 16, o[f + 7 | 0] = t >>> 24, o[f + 58 | 0] = 0, t = l[12187] | l[12188] << 8, o[f + 56 | 0] = t, o[f + 57 | 0] = t >>> 8, t = l[12183] | l[12184] << 8 | (l[12185] << 16 | l[12186] << 24), u = l[12179] | l[12180] << 8 | (l[12181] << 16 | l[12182] << 24), o[f + 48 | 0] = u, o[f + 49 | 0] = u >>> 8, o[f + 50 | 0] = u >>> 16, o[f + 51 | 0] = u >>> 24, o[f + 52 | 0] = t, o[f + 53 | 0] = t >>> 8, o[f + 54 | 0] = t >>> 16, o[f + 55 | 0] = t >>> 24, t = l[12175] | l[12176] << 8 | (l[12177] << 16 | l[12178] << 24), u = l[12171] | l[12172] << 8 | (l[12173] << 16 | l[12174] << 24), o[f + 40 | 0] = u, o[f + 41 | 0] = u >>> 8, o[f + 42 | 0] = u >>> 16, o[f + 43 | 0] = u >>> 24, o[f + 44 | 0] = t, o[f + 45 | 0] = t >>> 8, o[f + 46 | 0] = t >>> 16, o[f + 47 | 0] = t >>> 24, t = l[12167] | l[12168] << 8 | (l[12169] << 16 | l[12170] << 24), u = l[12163] | l[12164] << 8 | (l[12165] << 16 | l[12166] << 24), o[f + 32 | 0] = u, o[f + 33 | 0] = u >>> 8, o[f + 34 | 0] = u >>> 16, o[f + 35 | 0] = u >>> 24, o[f + 36 | 0] = t, o[f + 37 | 0] = t >>> 8, o[f + 38 | 0] = t >>> 16, o[f + 39 | 0] = t >>> 24, t = l[12159] | l[12160] << 8 | (l[12161] << 16 | l[12162] << 24), u = l[12155] | l[12156] << 8 | (l[12157] << 16 | l[12158] << 24), o[f + 24 | 0] = u, o[f + 25 | 0] = u >>> 8, o[f + 26 | 0] = u >>> 16, o[f + 27 | 0] = u >>> 24, o[f + 28 | 0] = t, o[f + 29 | 0] = t >>> 8, o[f + 30 | 0] = t >>> 16, o[f + 31 | 0] = t >>> 24, t = l[12151] | l[12152] << 8 | (l[12153] << 16 | l[12154] << 24), u = l[12147] | l[12148] << 8 | (l[12149] << 16 | l[12150] << 24), o[f + 16 | 0] = u, o[f + 17 | 0] = u >>> 8, o[f + 18 | 0] = u >>> 16, o[f + 19 | 0] = u >>> 24, o[f + 20 | 0] = t, o[f + 21 | 0] = t >>> 8, o[f + 22 | 0] = t >>> 16, o[f + 23 | 0] = t >>> 24, t = l[12143] | l[12144] << 8 | (l[12145] << 16 | l[12146] << 24), u = l[12139] | l[12140] << 8 | (l[12141] << 16 | l[12142] << 24), o[f + 8 | 0] = u, o[f + 9 | 0] = u >>> 8, o[f + 10 | 0] = u >>> 16, o[f + 11 | 0] = u >>> 24, o[f + 12 | 0] = t, o[f + 13 | 0] = t >>> 8, o[f + 14 | 0] = t >>> 16, o[f + 15 | 0] = t >>> 24, i0(B, 2, 127, v + 32 | 0), o[v + 43 | 0] >= 0) break u;
                                                                                        X(i[v + 32 >> 2]);
                                                                                        break u;
                                                                                    }
                                                                                    i[v + 36 >> 2] = E, i[v + 32 >> 2] = R, E && (i[E + 4 >> 2] = i[E + 4 >> 2] + 1), s0 = v + 12 | 0, w = f, W = X0, V = m - 32 | 0, m = V, f = i[v + 32 >> 2], F = V + 24 | 0, i[V + 20 >> 2] = F, i[V + 24 >> 2] = 0, i[V + 28 >> 2] = 0;
                                                                                    l: {
                                                                                        h: {
                                                                                            t = i[f + 60 >> 2], C = f - -64 | 0;
                                                                                            v: {
                                                                                                if ((t | 0) == (C | 0)) break v;
                                                                                                for(;;){
                                                                                                    _ = i[t + 16 >> 2], h = F, f = h, u = i[V + 24 >> 2];
                                                                                                    _: {
                                                                                                        B: {
                                                                                                            if (!u) break B;
                                                                                                            for(;;){
                                                                                                                if (f = u, u = i[f + 16 >> 2], (u | 0) > (_ | 0)) {
                                                                                                                    if (h = f, u = i[f >> 2], u) continue;
                                                                                                                    break B;
                                                                                                                }
                                                                                                                if ((u | 0) >= (_ | 0)) break _;
                                                                                                                if (u = i[f + 4 >> 2], !u) break;
                                                                                                            }
                                                                                                            h = f + 4 | 0;
                                                                                                        }
                                                                                                        u = D(20), i[u + 8 >> 2] = f, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 16 >> 2] = _, i[h >> 2] = u, f = i[i[V + 20 >> 2] >> 2], f && (i[V + 20 >> 2] = f, u = i[h >> 2]), h4(i[V + 24 >> 2], u), i[V + 28 >> 2] = i[V + 28 >> 2] + 1;
                                                                                                    }
                                                                                                    u = i[t + 4 >> 2];
                                                                                                    _: {
                                                                                                        if (u) {
                                                                                                            for(;;)if (f = u, u = i[f >> 2], !u) break _;
                                                                                                        }
                                                                                                        for(; f = i[t + 8 >> 2], u = i[f >> 2] != (t | 0), t = f, !!u;);
                                                                                                    }
                                                                                                    if (t = f, (f | 0) == (C | 0)) break;
                                                                                                }
                                                                                                if (C = i[V + 20 >> 2], (F | 0) == (C | 0)) break v;
                                                                                                if (f = i[w + 24 >> 2], f >>> 0 <= W >>> 0 || (t = i[w + 28 >> 2], t >>> 0 <= S >>> 0)) break h;
                                                                                                for(u = i[w + 36 >> 2], R0 = u - 1 | 0, T = R0 >>> 0 < 2 ? W + 1 >>> 1 | 0 : W, G = w - -64 | 0, q = S + 1 >>> 1 | 0, D0 = t - S | 0, e2 = D0 + 1 >>> 1 | 0, I0 = f - W | 0, k2 = I0 + 1 >>> 1 | 0, t2 = (u | 0) == 1;;){
                                                                                                    M = i[C + 16 >> 2], m0 = 0, F0 = i[v + 32 >> 2], _ = F0 - -64 | 0, t = _;
                                                                                                    _: {
                                                                                                        B: {
                                                                                                            if (w = i[F0 + 64 >> 2], u = w, !u) break B;
                                                                                                            for(; f = (M | 0) > i[u + 16 >> 2], t = f ? t : u, u = i[(f << 2) + u >> 2], !!u;);
                                                                                                            if ((t | 0) == (_ | 0)) break B;
                                                                                                            if (L = 0, H = 0, (M | 0) < i[t + 16 >> 2]) break _;
                                                                                                            L = i[t + 52 >> 2], H = i[t + 44 >> 2];
                                                                                                            break _;
                                                                                                        }
                                                                                                        L = 0, H = 0;
                                                                                                    }
                                                                                                    h = G, u = i[h >> 2], t = u, f = 0;
                                                                                                    _: {
                                                                                                        if (!t) break _;
                                                                                                        for(; f = (M | 0) > i[t + 16 >> 2], h = f ? h : t, t = i[(f << 2) + t >> 2], !!t;);
                                                                                                        if (f = 0, (h | 0) == (G | 0) || (f = 0, (M | 0) < i[h + 16 >> 2])) break _;
                                                                                                        m0 = i[h + 52 >> 2], f = i[h + 44 >> 2];
                                                                                                    }
                                                                                                    f0 = f, R = 255, h = _, t = w, f = 255;
                                                                                                    _: {
                                                                                                        if (!t) break _;
                                                                                                        for(; f = (M | 0) > i[t + 16 >> 2], h = f ? h : t, t = i[(f << 2) + t >> 2], !!t;);
                                                                                                        if (f = 255, (h | 0) == (_ | 0) || (f = 255, (M | 0) < i[h + 16 >> 2])) break _;
                                                                                                        f = l[h + 24 | 0];
                                                                                                    }
                                                                                                    t = G;
                                                                                                    _: {
                                                                                                        if (!u) break _;
                                                                                                        for(; h = (M | 0) > i[u + 16 >> 2], t = h ? t : u, u = i[(h << 2) + u >> 2], !!u;);
                                                                                                        if ((t | 0) == (G | 0) | (M | 0) < i[t + 16 >> 2]) break _;
                                                                                                        R = l[t + 24 | 0];
                                                                                                    }
                                                                                                    _: {
                                                                                                        B: {
                                                                                                            if ((f & 255) == (R | 0)) {
                                                                                                                t = _, u = w;
                                                                                                                m: {
                                                                                                                    if (!u) {
                                                                                                                        h = 0, u = 0;
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    for(; f = (M | 0) > i[u + 16 >> 2], t = f ? t : u, u = i[(f << 2) + u >> 2], !!u;);
                                                                                                                    for(h = 0, h = (t | 0) == (_ | 0) | (M | 0) < i[t + 16 >> 2] ? h : i[t + 28 >> 2], t = _, u = w; f = (M | 0) > i[u + 16 >> 2], t = f ? t : u, u = i[(f << 2) + u >> 2], !!u;);
                                                                                                                    if (u = 0, (t | 0) == (_ | 0) | (M | 0) < i[t + 16 >> 2]) break m;
                                                                                                                    u = i[t + 32 >> 2];
                                                                                                                }
                                                                                                                H0 = M - 1 | 0, R = H0 >>> 0 < 2, f = R && R0 >>> 0 < 2 ? k2 : I0, h = f >>> 0 < h >>> 0 ? f : h, $ = R & t2, f = $ ? e2 : D0, Z0 = f >>> 0 < u >>> 0 ? f : u;
                                                                                                                m: {
                                                                                                                    if ((M | 0) != 10) {
                                                                                                                        t = _, u = w;
                                                                                                                        Z: {
                                                                                                                            W: {
                                                                                                                                if (u) {
                                                                                                                                    for(; f = (M | 0) > i[u + 16 >> 2], t = f ? t : u, u = i[(f << 2) + u >> 2], !!u;);
                                                                                                                                    if (u = 0, t = Z(h, (((t | 0) == (_ | 0) | (M | 0) < i[t + 16 >> 2] ? u : l[t + 24 | 0] + 7 & -8) & 248) >>> 3 | 0), u = S, f = W, R) break W;
                                                                                                                                    break Z;
                                                                                                                                }
                                                                                                                                if (t = 0, u = S, f = W, R = 0, H0 >>> 0 > 1) break m;
                                                                                                                            }
                                                                                                                            u = $ ? q : S, f = T;
                                                                                                                        }
                                                                                                                        if (R = 0, h = _, !w) break m;
                                                                                                                        for(; $ = (M | 0) > i[w + 16 >> 2], h = $ ? h : w, w = i[($ << 2) + w >> 2], !!w;);
                                                                                                                        if ((h | 0) == (_ | 0) | (M | 0) < i[h + 16 >> 2]) break m;
                                                                                                                        R = l[h + 24 | 0] + 7 | 0;
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    f = 8;
                                                                                                                    Z: {
                                                                                                                        W: {
                                                                                                                            X: {
                                                                                                                                p: {
                                                                                                                                    Q: {
                                                                                                                                        C: switch(w = i[F0 + 36 >> 2], w - 10 | 0){
                                                                                                                                            case 3:
                                                                                                                                            case 5:
                                                                                                                                                break W;
                                                                                                                                            case 1:
                                                                                                                                                break p;
                                                                                                                                            case 2:
                                                                                                                                            case 4:
                                                                                                                                                break Q;
                                                                                                                                            case 0:
                                                                                                                                                break C;
                                                                                                                                            default:
                                                                                                                                                break X;
                                                                                                                                        }
                                                                                                                                        u = $ ? q : S, t = Z(h, 3), R = 24;
                                                                                                                                        break Z;
                                                                                                                                    }
                                                                                                                                    f = 6;
                                                                                                                                    break W;
                                                                                                                                }
                                                                                                                                u = $ ? q : S, t = h << 2, R = 32;
                                                                                                                                break Z;
                                                                                                                            }
                                                                                                                            f = 31;
                                                                                                                        }
                                                                                                                        u = $ ? q : S, t = Z(f, h), R = 64, f = W;
                                                                                                                        W: switch(w - 12 | 0){
                                                                                                                            case 0:
                                                                                                                            case 2:
                                                                                                                                R = 48;
                                                                                                                                break Z;
                                                                                                                            case 1:
                                                                                                                            case 3:
                                                                                                                                break m;
                                                                                                                            default:
                                                                                                                                break W;
                                                                                                                        }
                                                                                                                        R = 255;
                                                                                                                    }
                                                                                                                    f = W;
                                                                                                                }
                                                                                                                if (!Z0) break _;
                                                                                                                if (_ = Z0 & 1, w = Z((R & 248) >>> 3 | 0, f) + f0 | 0, f = 0, (Z0 | 0) == 1) break B;
                                                                                                                for(R = Z0 & -2, h = 0; v0(w + Z(f + u | 0, m0) | 0, Z(f, L) + H | 0, t), f0 = f | 1, v0(w + Z(f0 + u | 0, m0) | 0, Z(f0, L) + H | 0, t), f = f + 2 | 0, h = h + 2 | 0, (R | 0) != (h | 0););
                                                                                                                break B;
                                                                                                            }
                                                                                                            if (o[V + 8 | 0] = 0, o[V + 19 | 0] = 0, i0(s0, 2, 132, V + 8 | 0), o[V + 19 | 0] >= 0) break l;
                                                                                                            X(i[V + 8 >> 2]);
                                                                                                            break l;
                                                                                                        }
                                                                                                        if (!_) break _;
                                                                                                        v0(w + Z(f + u | 0, m0) | 0, Z(f, L) + H | 0, t);
                                                                                                    }
                                                                                                    u = i[C + 4 >> 2];
                                                                                                    _: {
                                                                                                        if (u) {
                                                                                                            for(;;)if (f = u, u = i[f >> 2], !u) break _;
                                                                                                        }
                                                                                                        for(; f = i[C + 8 >> 2], t = i[f >> 2] != (C | 0), C = f, !!t;);
                                                                                                    }
                                                                                                    if (C = f, (f | 0) == (F | 0)) break;
                                                                                                }
                                                                                            }
                                                                                            if (f = i[21669], i[s0 >> 2] = i[21668], i[s0 + 4 >> 2] = f, f = s0 + 8 | 0, o[86691] >= 0) {
                                                                                                t = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = t, i[f + 8 >> 2] = i[21672];
                                                                                                break l;
                                                                                            }
                                                                                            j(f, i[21670], i[21671]);
                                                                                            break l;
                                                                                        }
                                                                                        if (o[V + 8 | 0] = 0, o[V + 19 | 0] = 0, i0(s0, 2, 118, V + 8 | 0), o[V + 19 | 0] >= 0) break l;
                                                                                        X(i[V + 8 >> 2]);
                                                                                    }
                                                                                    Si(V + 20 | 0, i[V + 24 >> 2]), m = V + 32 | 0, o[v + 31 | 0] < 0 && X(i[v + 20 >> 2]), f = i[v + 36 >> 2];
                                                                                    l: {
                                                                                        if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break l;
                                                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                    }
                                                                                    if (f = i[e + 8 >> 2], f && (t = i[s >> 2] + 1 | 0, i[s >> 2] = t, p[f | 0](0, t, i[e + 16 >> 2])), f = i[21669], i[B >> 2] = i[21668], i[B + 4 >> 2] = f, f = B + 8 | 0, o[86691] >= 0) {
                                                                                        t = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = t, i[f + 8 >> 2] = i[21672];
                                                                                        break u;
                                                                                    }
                                                                                    j(f, i[21670], i[21671]);
                                                                                    break u;
                                                                                }
                                                                                if (f = i[v + 36 >> 2], !f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break u;
                                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                            }
                                                                            if (o[v + 79 | 0] < 0 && X(i[v + 68 >> 2]), f = i[v + 56 >> 2], !f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break s;
                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                        }
                                                                        s: {
                                                                            if (!r0 || (f = i[r0 + 4 >> 2], i[r0 + 4 >> 2] = f - 1, f)) break s;
                                                                            p[i[i[r0 >> 2] + 8 >> 2]](r0), g(r0);
                                                                        }
                                                                        s: {
                                                                            if (!E || (f = i[E + 4 >> 2], i[E + 4 >> 2] = f - 1, f)) break s;
                                                                            p[i[i[E >> 2] + 8 >> 2]](E), g(E);
                                                                        }
                                                                        if (m = v + 80 | 0, t = i[s + 20 >> 2], f = i[s + 16 >> 2], i[s + 40 >> 2] = f, i[s + 44 >> 2] = t, o[s + 59 | 0] < 0 && (X(i[s + 48 >> 2]), f = i[s + 40 >> 2]), t = i[s + 28 >> 2], i[s + 48 >> 2] = i[s + 24 >> 2], i[s + 52 >> 2] = t, i[s + 56 >> 2] = i[s + 32 >> 2], f) {
                                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[s + 44 >> 2], i[A + 8 >> 2] = i[s + 40 >> 2], i[A + 12 >> 2] = f, o[s + 59 | 0] >= 0) {
                                                                                f = i[s + 52 >> 2], i[y >> 2] = i[s + 48 >> 2], i[y + 4 >> 2] = f, i[y + 8 >> 2] = i[s + 56 >> 2], f = 0;
                                                                                break t;
                                                                            }
                                                                            j(y, i[s + 48 >> 2], i[s + 52 >> 2]), f = 0;
                                                                            break t;
                                                                        }
                                                                        g0 = g0 + 1 | 0, X0 = t0 + X0 | 0, f = 1;
                                                                        break t;
                                                                    }
                                                                    n = 0, f = 0;
                                                                }
                                                                t: {
                                                                    if (!c || (t = i[c + 4 >> 2], i[c + 4 >> 2] = t - 1, t)) break t;
                                                                    p[i[i[c >> 2] + 8 >> 2]](c), g(c);
                                                                }
                                                                if (!f) break f;
                                                                if (f = I[r + 374 >> 1], P = P + 1 | 0, !!(f >>> 0 <= P >>> 0 | n)) break;
                                                            }
                                                            P = I[r + 372 >> 1];
                                                        }
                                                        if (V0 = V0 + 1 | 0, V0 >>> 0 >= (P & 65535) >>> 0) break k;
                                                        if (S = k + S | 0, !!n) break;
                                                    }
                                                }
                                                if (r = i[e + 12 >> 2], r && p[r | 0](0, i[e + 16 >> 2]), n) {
                                                    r = D(32), i[s + 4 >> 2] = r, i[s + 8 >> 2] = 31, i[s + 12 >> 2] = -2147483616, e = l[13918] | l[13919] << 8 | (l[13920] << 16 | l[13921] << 24), f = l[13914] | l[13915] << 8 | (l[13916] << 16 | l[13917] << 24), o[r + 23 | 0] = f, o[r + 24 | 0] = f >>> 8, o[r + 25 | 0] = f >>> 16, o[r + 26 | 0] = f >>> 24, o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, e = l[13911] | l[13912] << 8 | (l[13913] << 16 | l[13914] << 24), f = l[13907] | l[13908] << 8 | (l[13909] << 16 | l[13910] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13903] | l[13904] << 8 | (l[13905] << 16 | l[13906] << 24), f = l[13899] | l[13900] << 8 | (l[13901] << 16 | l[13902] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[13895] | l[13896] << 8 | (l[13897] << 16 | l[13898] << 24), f = l[13891] | l[13892] << 8 | (l[13893] << 16 | l[13894] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 31 | 0] = 0, r = i0(s + 16 | 0, 12, 0, s + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                                    k: {
                                                        if (o[r + 19 | 0] >= 0) {
                                                            e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                            break k;
                                                        }
                                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break k;
                                                        X(i[r + 8 >> 2]);
                                                    }
                                                    if (o[s + 15 | 0] >= 0) break f;
                                                    X(i[s + 4 >> 2]);
                                                    break f;
                                                }
                                                if (i[A >> 2] = i[s + 184 >> 2], r = i[s + 188 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                    break f;
                                                }
                                                j(A, i[21670], i[21671]);
                                            }
                                            if (o[s + 59 | 0] >= 0) break i;
                                            X(i[s + 48 >> 2]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(n, e, r);
                                }
                                o[r + n | 0] = 0, r = i0(s + 16 | 0, 2, 119, s + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                e: {
                                    if (o[r + 19 | 0] >= 0) {
                                        e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                        break e;
                                    }
                                    if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break e;
                                    X(i[r + 8 >> 2]);
                                }
                                o[s + 15 | 0] < 0 && X(i[s + 4 >> 2]), A = i[14959], i[s + 40 >> 2] = A, i[i[A - 12 >> 2] + (s + 40 | 0) >> 2] = i[14967], i[s + 48 >> 2] = i[14968], i[f >> 2] = 58864, o[s + 95 | 0] < 0 && X(i[s + 84 >> 2]), x0(f), N0(s + 104 | 0);
                            }
                            A = i[s + 188 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = s + 192 | 0;
                        }
                        function s6(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            v = m - 144 | 0, m = v, h = i[r >> 2], w = i[h + 28 >> 2], s = i[h + 24 >> 2];
                            i: {
                                e: {
                                    if (!A1(h, 6) || (T4(i[r >> 2], 6) | 0) == (s | 0) && (S4(i[r >> 2], 6) | 0) == (w | 0)) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!(f - 4 >>> 0 > 4294967292 | e)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (o[v + 142 | 0] = 1, Q[v + 140 >> 1] = 2, i[v + 136 >> 2] = 131074, o[v + 124 | 0] = 0, i[v + 116 >> 2] = 99, i[v + 120 >> 2] = 99, i[v + 128 >> 2] = 8, i[v + 132 >> 2] = 78668, w = v + 132 | 0, o[w + 10 | 0] = 1, Q[w + 8 >> 1] = 6, i[w + 4 >> 2] = 851969, h = i[r >> 2], i[v + 116 >> 2] = i[h + 32 >> 2], i[v + 120 >> 2] = i[h + 36 >> 2], A1(h, 6) ? h = 1 : (h = i[i[r >> 2] + 36 >> 2], h = 43008 >>> h & h >>> 0 < 16), o[v + 124 | 0] = h, h = i[i[r >> 2] + 44 >> 2], h && (i[v + 136 >> 2] = i[h + 4 >> 2], h = l[h + 7 | 0] | l[h + 8 | 0] << 8 | (l[h + 9 | 0] << 16 | l[h + 10 | 0] << 24), o[v + 139 | 0] = h, o[v + 140 | 0] = h >>> 8, o[v + 141 | 0] = h >>> 16, o[v + 142 | 0] = h >>> 24), eo(w), w = i[r >> 2], W = v + 104 | 0, h = W, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, _ = h + 4 | 0, i[h >> 2] = _, h = i[w + 60 >> 2], C = w - -64 | 0, (h | 0) != (C | 0)) for(;;){
                                    B = i[h + 16 >> 2], w = _, s = w, G = i[s >> 2];
                                    e: {
                                        r: {
                                            if (!G) break r;
                                            for(;;){
                                                if (s = G, w = i[s + 16 >> 2], (w | 0) > (B | 0)) {
                                                    if (w = s, G = i[s >> 2], G) continue;
                                                    break r;
                                                }
                                                if ((w | 0) >= (B | 0)) break e;
                                                if (G = i[s + 4 >> 2], !G) break;
                                            }
                                            w = s + 4 | 0;
                                        }
                                        G = D(20), i[G + 8 >> 2] = s, i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[G + 16 >> 2] = B, i[w >> 2] = G, s = i[i[W >> 2] >> 2], s && (i[W >> 2] = s, G = i[w >> 2]), h4(i[W + 4 >> 2], G), i[W + 8 >> 2] = i[W + 8 >> 2] + 1;
                                    }
                                    G = i[h + 4 >> 2];
                                    e: {
                                        if (G) {
                                            for(;;)if (s = G, G = i[s >> 2], !G) break e;
                                        }
                                        for(; s = i[h + 8 >> 2], w = i[s >> 2] != (h | 0), h = s, !!w;);
                                    }
                                    if (h = s, (C | 0) == (s | 0)) break;
                                }
                                T = v, S = S0(i[r >> 2], i[i[v + 104 >> 2] + 16 >> 2]), i[T + 128 >> 2] = S, h = i[v + 128 >> 2], i[v + 80 >> 2] = i[v + 124 >> 2], i[v + 84 >> 2] = h, h = i[v + 120 >> 2], i[v + 72 >> 2] = i[v + 116 >> 2], i[v + 76 >> 2] = h, i[v + 88 >> 2] = 78668, h = l[v + 139 | 0] | l[v + 140 | 0] << 8 | (l[v + 141 | 0] << 16 | l[v + 142 | 0] << 24), o[v + 95 | 0] = h, o[v + 96 | 0] = h >>> 8, o[v + 97 | 0] = h >>> 16, o[v + 98 | 0] = h >>> 24, h = i[v + 136 >> 2], i[v + 72 >> 2] = e, i[v + 76 >> 2] = f, i[v + 92 >> 2] = h, e = i[k >> 2], e && (i[v + 92 >> 2] = i[e + 4 >> 2], e = l[e + 7 | 0] | l[e + 8 | 0] << 8 | (l[e + 9 | 0] << 16 | l[e + 10 | 0] << 24), o[v + 95 | 0] = e, o[v + 96 | 0] = e >>> 8, o[v + 97 | 0] = e >>> 16, o[v + 98 | 0] = e >>> 24), I[v + 96 >> 1] == 2 && (Q[v + 96 >> 1] = I[v + 140 >> 1]), I[v + 92 >> 1] == 2 && (Q[v + 92 >> 1] = I[v + 136 >> 1]), I[v + 94 >> 1] == 2 && (Q[v + 94 >> 1] = I[v + 138 >> 1]), e = 1;
                                e: {
                                    r: switch(f | 0){
                                        case 10:
                                        case 12:
                                        case 14:
                                            e = 3;
                                            break e;
                                        case 11:
                                        case 13:
                                        case 15:
                                            e = 4;
                                            break e;
                                        case 0:
                                        case 1:
                                        case 2:
                                        case 3:
                                        case 99:
                                            break e;
                                        default:
                                            break r;
                                    }
                                    e = 0;
                                }
                                if (o[v + 80 | 0] = (e | 0) >= 2 ? 43008 >>> f & f >>> 0 < 16 : l[v + 124 | 0], n && (i[v + 84 >> 2] = n), (f & -2) != 10 ? e = i[v + 84 >> 2] < 9 : (i[v + 84 >> 2] = 8, e = 1), !e | (f & -4) != 12 || (i[v + 84 >> 2] = 10), i[v + 52 >> 2] = 0, i[v + 44 >> 2] = 0, i[v + 48 >> 2] = 0, G = v + 116 | 0, W = v + 72 | 0, s = m - 96 | 0, m = s, f = i[v + 48 >> 2], k = i[v + 44 >> 2], (f | 0) != (k | 0)) for(;;){
                                    e = i[f - 60 >> 2];
                                    e: {
                                        if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (f = f + -64 | 0, (k | 0) == (f | 0)) break;
                                }
                                i[v + 48 >> 2] = k, e = i[t + 12 >> 2], i[v + 64 >> 2] = i[t + 8 >> 2], i[v + 68 >> 2] = e, e = i[t + 4 >> 2], i[v + 56 >> 2] = i[t >> 2], i[v + 60 >> 2] = e, e = i[G >> 2];
                                e: {
                                    r: {
                                        if ((e | 0) != i[W >> 2] | i[G + 4 >> 2] != i[W + 4 >> 2] | (l[G + 8 | 0] != l[W + 8 | 0] | i[G + 12 >> 2] != i[W + 12 >> 2])) break r;
                                        if (w = 1, e) break e;
                                        if (l[G + 26 | 0] != l[W + 26 | 0] | I[G + 24 >> 1] != I[W + 24 >> 1]) break r;
                                        if (I[G + 20 >> 1] == I[W + 20 >> 1]) break e;
                                    }
                                    w3(), i[s + 92 >> 2] = 0, i[s + 84 >> 2] = 0, i[s + 88 >> 2] = 0, i[s + 80 >> 2] = 0, i[s + 72 >> 2] = 0, i[s + 76 >> 2] = 0, i[s + 8 >> 2] = -1, i[s + 56 >> 2] = 0, i[s + 68 >> 2] = 0, w = 0;
                                    r: {
                                        A: {
                                            if (f = i[s + 72 >> 2], n = (i[s + 76 >> 2] - f | 0) / 44 | 0, e = n + 1 | 0, e >>> 0 < 97612894) {
                                                if (f = (i[s + 80 >> 2] - f | 0) / 44 | 0, k = f << 1, k = f >>> 0 >= 48806446 ? 97612893 : e >>> 0 < k >>> 0 ? k : e, k) {
                                                    if (k >>> 0 >= 97612894) break A;
                                                    w = D(Z(k, 44));
                                                }
                                                h = i[s + 68 >> 2], f = i[s + 8 >> 2], e = Z(n, 44) + w | 0, o[e + 38 | 0] = 1, Q[e + 36 >> 1] = 2, i[e + 32 >> 2] = 131074, i[e + 28 >> 2] = 78668, i[e + 24 >> 2] = 8, o[e + 20 | 0] = 0, i[e + 16 >> 2] = 99, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 99, i[e >> 2] = -1, i[e + 4 >> 2] = 0, o[e + 38 | 0] = 1, Q[e + 36 >> 1] = 6, i[e + 32 >> 2] = 851969, i[e >> 2] = f, f = i[e + 8 >> 2], i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, k = Z(k, 44);
                                                f: {
                                                    if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break f;
                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                }
                                                C = k + w | 0, f = i[G + 4 >> 2], i[e + 12 >> 2] = i[G >> 2], i[e + 16 >> 2] = f, f = i[G + 12 >> 2], i[e + 20 >> 2] = i[G + 8 >> 2], i[e + 24 >> 2] = f, f = l[G + 23 | 0] | l[G + 24 | 0] << 8 | (l[G + 25 | 0] << 16 | l[G + 26 | 0] << 24), o[e + 35 | 0] = f, o[e + 36 | 0] = f >>> 8, o[e + 37 | 0] = f >>> 16, o[e + 38 | 0] = f >>> 24, i[e + 32 >> 2] = i[G + 20 >> 2], i[e + 40 >> 2] = h, n = e + 44 | 0, k = i[s + 76 >> 2], w = i[s + 72 >> 2];
                                                f: {
                                                    if ((k | 0) == (w | 0)) {
                                                        f = e;
                                                        break f;
                                                    }
                                                    for(; f = e - 44 | 0, h = k - 44 | 0, i[f >> 2] = i[h >> 2], _ = k - 40 | 0, i[e - 40 >> 2] = i[_ >> 2], i[e - 36 >> 2] = i[k - 36 >> 2], i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, _ = k - 32 | 0, V = i[_ + 12 >> 2], B = e - 32 | 0, i[B + 8 >> 2] = i[_ + 8 >> 2], i[B + 12 >> 2] = V, V = i[_ + 4 >> 2], i[B >> 2] = i[_ >> 2], i[B + 4 >> 2] = V, i[e - 16 >> 2] = 78668, _ = e - 12 | 0, B = k - 12 | 0, i[_ >> 2] = i[B >> 2], B = l[B + 3 | 0] | l[B + 4 | 0] << 8 | (l[B + 5 | 0] << 16 | l[B + 6 | 0] << 24), o[_ + 3 | 0] = B, o[_ + 4 | 0] = B >>> 8, o[_ + 5 | 0] = B >>> 16, o[_ + 6 | 0] = B >>> 24, i[e - 4 >> 2] = i[k - 4 >> 2], e = f, k = h, (w | 0) != (k | 0););
                                                    k = i[s + 76 >> 2], w = i[s + 72 >> 2];
                                                }
                                                if (i[s + 76 >> 2] = n, i[s + 72 >> 2] = f, i[s + 80 >> 2] = C, (k | 0) != (w | 0)) for(;;){
                                                    e = i[k - 36 >> 2];
                                                    f: {
                                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break f;
                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                    }
                                                    if (k = k - 44 | 0, (w | 0) == (k | 0)) break;
                                                }
                                                w && X(w), f = n;
                                                break r;
                                            }
                                            p0(), z();
                                        }
                                        Z2(), z();
                                    }
                                    i[s + 76 >> 2] = f, e = i[s + 72 >> 2], w = 0;
                                    r: {
                                        if ((f | 0) == (e | 0)) break r;
                                        for(;;){
                                            f = f - e | 0;
                                            A: {
                                                if ((f | 0) <= 0) {
                                                    _ = -1;
                                                    break A;
                                                }
                                                k = (f >>> 0) / 44 | 0, k = k >>> 0 <= 1 ? 1 : k, n = k & 3, w = 0;
                                                f: {
                                                    if (f >>> 0 < 176) {
                                                        k = 2147483647, _ = -1, f = 0;
                                                        break f;
                                                    }
                                                    for(R = k & 67108860, f = 0, k = 2147483647, _ = -1, B = 0; C = i[(Z(f, 44) + e | 0) + 40 >> 2], h = (C | 0) < (k | 0), E = f | 1, V = i[(Z(E, 44) + e | 0) + 40 >> 2], k = h ? C : k, C = (V | 0) < (k | 0), F = f | 2, y = i[(Z(F, 44) + e | 0) + 40 >> 2], k = C ? V : k, V = (y | 0) < (k | 0), H = f | 3, M = i[(Z(H, 44) + e | 0) + 40 >> 2], k = V ? y : k, y = (M | 0) < (k | 0), k = y ? M : k, _ = y ? H : V ? F : C ? E : h ? f : _, f = f + 4 | 0, B = B + 4 | 0, (R | 0) != (B | 0););
                                                }
                                                if (!n) break A;
                                                for(; B = i[(Z(f, 44) + e | 0) + 40 >> 2], h = (B | 0) < (k | 0), k = h ? B : k, _ = h ? f : _, f = f + 1 | 0, w = w + 1 | 0, (n | 0) != (w | 0););
                                            }
                                            C = Z(_, 44), f = C + e | 0, k = i[s + 88 >> 2];
                                            A: {
                                                if (k >>> 0 < k0[s + 92 >> 2]) {
                                                    i[k >> 2] = i[f >> 2], i[k + 4 >> 2] = i[f + 4 >> 2], n = i[f + 8 >> 2], i[k + 8 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = i[f + 16 >> 2], i[k + 12 >> 2] = i[f + 12 >> 2], i[k + 16 >> 2] = n, n = i[f + 24 >> 2], i[k + 20 >> 2] = i[f + 20 >> 2], i[k + 24 >> 2] = n, i[k + 28 >> 2] = 78668, i[k + 32 >> 2] = i[f + 32 >> 2], n = l[f + 35 | 0] | l[f + 36 | 0] << 8 | (l[f + 37 | 0] << 16 | l[f + 38 | 0] << 24), o[k + 35 | 0] = n, o[k + 36 | 0] = n >>> 8, o[k + 37 | 0] = n >>> 16, o[k + 38 | 0] = n >>> 24, i[k + 40 >> 2] = i[f + 40 >> 2], f = k + 44 | 0;
                                                    break A;
                                                }
                                                f: {
                                                    k: {
                                                        if (k = i[s + 88 >> 2], w = i[s + 84 >> 2], n = (k - w | 0) / 44 | 0, e = n + 1 | 0, e >>> 0 < 97612894) {
                                                            if (B = Z(n, 44), h = (i[s + 92 >> 2] - w | 0) / 44 | 0, _ = h << 1, h = h >>> 0 >= 48806446 ? 97612893 : e >>> 0 < _ >>> 0 ? _ : e, h) {
                                                                if (h >>> 0 >= 97612894) break k;
                                                                n = D(Z(h, 44));
                                                            } else n = 0;
                                                            e = B + n | 0, i[e >> 2] = i[f >> 2], i[e + 4 >> 2] = i[f + 4 >> 2], _ = i[f + 8 >> 2], i[e + 8 >> 2] = _, _ && (i[_ + 4 >> 2] = i[_ + 4 >> 2] + 1, w = i[s + 84 >> 2], k = i[s + 88 >> 2]), V = n + Z(h, 44) | 0, n = i[f + 16 >> 2], i[e + 12 >> 2] = i[f + 12 >> 2], i[e + 16 >> 2] = n, n = i[f + 24 >> 2], i[e + 20 >> 2] = i[f + 20 >> 2], i[e + 24 >> 2] = n, i[e + 28 >> 2] = 78668, i[e + 32 >> 2] = i[f + 32 >> 2], n = l[f + 35 | 0] | l[f + 36 | 0] << 8 | (l[f + 37 | 0] << 16 | l[f + 38 | 0] << 24), o[e + 35 | 0] = n, o[e + 36 | 0] = n >>> 8, o[e + 37 | 0] = n >>> 16, o[e + 38 | 0] = n >>> 24, i[e + 40 >> 2] = i[f + 40 >> 2], n = e + 44 | 0;
                                                            n: {
                                                                if ((k | 0) == (w | 0)) {
                                                                    f = e;
                                                                    break n;
                                                                }
                                                                for(; f = e - 44 | 0, h = k - 44 | 0, i[f >> 2] = i[h >> 2], _ = k - 40 | 0, i[e - 40 >> 2] = i[_ >> 2], i[e - 36 >> 2] = i[k - 36 >> 2], i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, _ = k - 32 | 0, y = i[_ + 12 >> 2], B = e - 32 | 0, i[B + 8 >> 2] = i[_ + 8 >> 2], i[B + 12 >> 2] = y, y = i[_ + 4 >> 2], i[B >> 2] = i[_ >> 2], i[B + 4 >> 2] = y, i[e - 16 >> 2] = 78668, _ = e - 12 | 0, B = k - 12 | 0, i[_ >> 2] = i[B >> 2], B = l[B + 3 | 0] | l[B + 4 | 0] << 8 | (l[B + 5 | 0] << 16 | l[B + 6 | 0] << 24), o[_ + 3 | 0] = B, o[_ + 4 | 0] = B >>> 8, o[_ + 5 | 0] = B >>> 16, o[_ + 6 | 0] = B >>> 24, i[e - 4 >> 2] = i[k - 4 >> 2], e = f, k = h, (w | 0) != (k | 0););
                                                                k = i[s + 88 >> 2], w = i[s + 84 >> 2];
                                                            }
                                                            if (i[s + 88 >> 2] = n, i[s + 84 >> 2] = f, i[s + 92 >> 2] = V, (k | 0) != (w | 0)) for(;;){
                                                                e = i[k - 36 >> 2];
                                                                n: {
                                                                    if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break n;
                                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                }
                                                                if (k = k - 44 | 0, (w | 0) == (k | 0)) break;
                                                            }
                                                            w && X(w), f = n;
                                                            break f;
                                                        }
                                                        p0(), z();
                                                    }
                                                    Z2(), z();
                                                }
                                                e = i[s + 72 >> 2];
                                            }
                                            i[s + 88 >> 2] = f, e = e + C | 0, k = i[s + 76 >> 2], i[e >> 2] = i[k - 44 >> 2], f = i[k - 40 >> 2], n = i[k - 36 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[e + 4 >> 2] = f, f = i[e + 8 >> 2], i[e + 8 >> 2] = n;
                                            A: {
                                                if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            f = k - 32 | 0, n = i[f + 4 >> 2], i[e + 12 >> 2] = i[f >> 2], i[e + 16 >> 2] = n, n = i[f + 12 >> 2], i[e + 20 >> 2] = i[f + 8 >> 2], i[e + 24 >> 2] = n, f = k - 12 | 0, i[e + 32 >> 2] = i[f >> 2], f = l[f + 3 | 0] | l[f + 4 | 0] << 8 | (l[f + 5 | 0] << 16 | l[f + 6 | 0] << 24), o[e + 35 | 0] = f, o[e + 36 | 0] = f >>> 8, o[e + 37 | 0] = f >>> 16, o[e + 38 | 0] = f >>> 24, i[e + 40 >> 2] = i[k - 4 >> 2], f = i[s + 76 >> 2], e = i[f - 36 >> 2];
                                            A: {
                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            f = f - 44 | 0, i[s + 76 >> 2] = f;
                                            A: {
                                                if (e = i[s + 88 >> 2], k = i[e - 32 >> 2], (k | 0) != i[W >> 2] | i[e - 28 >> 2] != i[W + 4 >> 2] | (l[e - 24 | 0] != l[W + 8 | 0] | i[e - 20 >> 2] != i[W + 12 >> 2]) || !k && l[e - 6 | 0] != l[W + 26 | 0] | I[e - 8 >> 1] != I[W + 24 >> 1] | I[e - 12 >> 1] != I[W + 20 >> 1]) break A;
                                                f = e, e = i[s + 84 >> 2], k = ((f - e | 0) / 44 | 0) - 1 | 0;
                                                f: {
                                                    k: {
                                                        if (k) {
                                                            for(f = 0; n = f, f = f + 1 | 0, k = i[e + Z(k, 44) >> 2], !!k;);
                                                            if (h = i[v + 48 >> 2], k = h, w = i[v + 44 >> 2], e = k - w >> 6, n >>> 0 < e >>> 0) break k;
                                                            n = 0;
                                                            n: {
                                                                if (k = f - e | 0, t = i[v + 52 >> 2], k >>> 0 <= t - h >> 6 >>> 0) {
                                                                    if (k) for(e = (k << 6) + h | 0; i[h + 32 >> 2] = 0, i[h + 36 >> 2] = 0, i[h + 24 >> 2] = 0, i[h + 28 >> 2] = 0, i[h + 16 >> 2] = 0, i[h + 20 >> 2] = 0, i[h >> 2] = 0, i[h + 4 >> 2] = 0, i[h + 56 >> 2] = 0, i[h + 60 >> 2] = 0, i[h + 48 >> 2] = 0, i[h + 52 >> 2] = 0, i[h + 40 >> 2] = 0, i[h + 44 >> 2] = 0, i[h + 8 >> 2] = 99, i[h + 12 >> 2] = 99, o[h + 34 | 0] = 1, Q[h + 32 >> 1] = 2, i[h + 28 >> 2] = 131074, i[h + 24 >> 2] = 78668, i[h + 20 >> 2] = 8, o[h + 34 | 0] = 1, Q[h + 32 >> 1] = 6, i[h + 28 >> 2] = 851969, o[h + 62 | 0] = 1, Q[h + 60 >> 1] = 2, i[h + 56 >> 2] = 131074, i[h + 52 >> 2] = 78668, i[h + 48 >> 2] = 8, o[h + 44 | 0] = 0, i[h + 36 >> 2] = 99, i[h + 40 >> 2] = 99, o[h + 62 | 0] = 1, Q[h + 60 >> 1] = 6, i[h + 56 >> 2] = 851969, h = h - -64 | 0, (e | 0) != (h | 0););
                                                                    i[v + 48 >> 2] = h;
                                                                    break n;
                                                                }
                                                                t: {
                                                                    if (e = h, h = i[v + 44 >> 2], w = e - h >> 6, e = w + k | 0, e >>> 0 < 67108864) {
                                                                        if (t = t - h | 0, h = t >> 5, t = t >>> 0 >= 2147483584 ? 67108863 : e >>> 0 < h >>> 0 ? h : e, t) {
                                                                            if (t >>> 0 >= 67108864) break t;
                                                                            n = D(t << 6);
                                                                        }
                                                                        for(e = (w << 6) + n | 0, k = e + (k << 6) | 0, h = e; i[h + 32 >> 2] = 0, i[h + 36 >> 2] = 0, i[h + 24 >> 2] = 0, i[h + 28 >> 2] = 0, i[h + 16 >> 2] = 0, i[h + 20 >> 2] = 0, i[h >> 2] = 0, i[h + 4 >> 2] = 0, i[h + 56 >> 2] = 0, i[h + 60 >> 2] = 0, i[h + 48 >> 2] = 0, i[h + 52 >> 2] = 0, i[h + 40 >> 2] = 0, i[h + 44 >> 2] = 0, i[h + 8 >> 2] = 99, i[h + 12 >> 2] = 99, o[h + 34 | 0] = 1, Q[h + 32 >> 1] = 2, i[h + 28 >> 2] = 131074, i[h + 24 >> 2] = 78668, i[h + 20 >> 2] = 8, o[h + 34 | 0] = 1, Q[h + 32 >> 1] = 6, i[h + 28 >> 2] = 851969, o[h + 62 | 0] = 1, Q[h + 60 >> 1] = 2, i[h + 56 >> 2] = 131074, i[h + 52 >> 2] = 78668, i[h + 48 >> 2] = 8, o[h + 44 | 0] = 0, i[h + 36 >> 2] = 99, i[h + 40 >> 2] = 99, o[h + 62 | 0] = 1, Q[h + 60 >> 1] = 6, i[h + 56 >> 2] = 851969, h = h - -64 | 0, (k | 0) != (h | 0););
                                                                        B = (t << 6) + n | 0, k = i[v + 48 >> 2], w = i[v + 44 >> 2];
                                                                        o: {
                                                                            if ((k | 0) == (w | 0)) {
                                                                                n = e;
                                                                                break o;
                                                                            }
                                                                            for(; n = e + -64 | 0, t = k + -64 | 0, i[n >> 2] = i[t >> 2], i[e - 60 >> 2] = i[k - 60 >> 2], i[t >> 2] = 0, i[t + 4 >> 2] = 0, _ = k - 56 | 0, C = i[_ + 12 >> 2], W = e - 56 | 0, i[W + 8 >> 2] = i[_ + 8 >> 2], i[W + 12 >> 2] = C, C = i[_ + 4 >> 2], i[W >> 2] = i[_ >> 2], i[W + 4 >> 2] = C, i[e - 40 >> 2] = 78668, _ = e - 36 | 0, W = k - 36 | 0, i[_ >> 2] = i[W >> 2], W = l[W + 3 | 0] | l[W + 4 | 0] << 8 | (l[W + 5 | 0] << 16 | l[W + 6 | 0] << 24), o[_ + 3 | 0] = W, o[_ + 4 | 0] = W >>> 8, o[_ + 5 | 0] = W >>> 16, o[_ + 6 | 0] = W >>> 24, _ = k - 28 | 0, C = i[_ + 4 >> 2], W = e - 28 | 0, i[W >> 2] = i[_ >> 2], i[W + 4 >> 2] = C, C = i[_ + 12 >> 2], i[W + 8 >> 2] = i[_ + 8 >> 2], i[W + 12 >> 2] = C, i[e - 12 >> 2] = 78668, e = e - 8 | 0, k = k - 8 | 0, i[e >> 2] = i[k >> 2], k = l[k + 3 | 0] | l[k + 4 | 0] << 8 | (l[k + 5 | 0] << 16 | l[k + 6 | 0] << 24), o[e + 3 | 0] = k, o[e + 4 | 0] = k >>> 8, o[e + 5 | 0] = k >>> 16, o[e + 6 | 0] = k >>> 24, e = n, k = t, (w | 0) != (k | 0););
                                                                            k = i[v + 48 >> 2], w = i[v + 44 >> 2];
                                                                        }
                                                                        if (i[v + 48 >> 2] = h, i[v + 44 >> 2] = n, i[v + 52 >> 2] = B, (k | 0) != (w | 0)) for(;;){
                                                                            e = i[k - 60 >> 2];
                                                                            o: {
                                                                                if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break o;
                                                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                            }
                                                                            if (k = k + -64 | 0, (w | 0) == (k | 0)) break;
                                                                        }
                                                                        w && X(w);
                                                                        break n;
                                                                    }
                                                                    p0(), z();
                                                                }
                                                                Z2(), z();
                                                            }
                                                            break f;
                                                        }
                                                        k = i[v + 48 >> 2], w = i[v + 44 >> 2], e = k - w >> 6, f = 0;
                                                    }
                                                    if (e >>> 0 <= f >>> 0) break f;
                                                    if (n = (f << 6) + w | 0, (n | 0) != (k | 0)) for(;;){
                                                        e = i[k - 60 >> 2];
                                                        k: {
                                                            if (!e || (t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t)) break k;
                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                        }
                                                        if (k = k + -64 | 0, (n | 0) == (k | 0)) break;
                                                    }
                                                    i[v + 48 >> 2] = n;
                                                }
                                                if (k = i[v + 44 >> 2], e = i[s + 84 >> 2], t = ((i[s + 88 >> 2] - e | 0) / 44 | 0) - 1 | 0, t) {
                                                    h = f - 1 | 0, k = (h << 6) + k | 0, e = e + Z(t, 44) | 0, w = i[e + 4 >> 2], n = i[e + 8 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[k >> 2] = w, e = i[k + 4 >> 2], i[k + 4 >> 2] = n;
                                                    f: {
                                                        if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break f;
                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                    }
                                                    if (t = Z(t, 44), k = t + i[s + 84 >> 2] | 0, n = i[k + 16 >> 2], e = i[v + 44 >> 2] + (h << 6) | 0, i[e + 36 >> 2] = i[k + 12 >> 2], i[e + 40 >> 2] = n, n = i[k + 24 >> 2], i[e + 44 >> 2] = i[k + 20 >> 2], i[e + 48 >> 2] = n, n = l[k + 35 | 0] | l[k + 36 | 0] << 8 | (l[k + 37 | 0] << 16 | l[k + 38 | 0] << 24), o[e + 59 | 0] = n, o[e + 60 | 0] = n >>> 8, o[e + 61 | 0] = n >>> 16, o[e + 62 | 0] = n >>> 24, i[e + 56 >> 2] = i[k + 32 >> 2], _ = i[s + 84 >> 2], w = i[t + _ >> 2], w) for(k = 1;;){
                                                        h = (k ^ -1) + f << 6, n = h + i[v + 44 >> 2] | 0, w = Z(w, 44), e = w + _ | 0, _ = i[e + 4 >> 2], t = i[e + 8 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[n >> 2] = _, e = i[n + 4 >> 2], i[n + 4 >> 2] = t;
                                                        f: {
                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break f;
                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                        }
                                                        if (n = w + i[s + 84 >> 2] | 0, t = i[n + 16 >> 2], e = h + i[v + 44 >> 2] | 0, i[e + 36 >> 2] = i[n + 12 >> 2], i[e + 40 >> 2] = t, t = i[n + 24 >> 2], i[e + 44 >> 2] = i[n + 20 >> 2], i[e + 48 >> 2] = t, t = l[n + 35 | 0] | l[n + 36 | 0] << 8 | (l[n + 37 | 0] << 16 | l[n + 38 | 0] << 24), o[e + 59 | 0] = t, o[e + 60 | 0] = t >>> 8, o[e + 61 | 0] = t >>> 16, o[e + 62 | 0] = t >>> 24, i[e + 56 >> 2] = i[n + 32 >> 2], n = i[v + 44 >> 2], e = n + (f - k << 6) | 0, n = n + h | 0, t = i[n + 40 >> 2], i[e + 8 >> 2] = i[n + 36 >> 2], i[e + 12 >> 2] = t, t = i[n + 48 >> 2], i[e + 16 >> 2] = i[n + 44 >> 2], i[e + 20 >> 2] = t, t = l[n + 59 | 0] | l[n + 60 | 0] << 8 | (l[n + 61 | 0] << 16 | l[n + 62 | 0] << 24), o[e + 31 | 0] = t, o[e + 32 | 0] = t >>> 8, o[e + 33 | 0] = t >>> 16, o[e + 34 | 0] = t >>> 24, i[e + 28 >> 2] = i[n + 56 >> 2], k = k + 1 | 0, _ = i[s + 84 >> 2], w = i[w + _ >> 2], !w) break;
                                                    }
                                                    k = i[v + 44 >> 2];
                                                }
                                                e = i[G + 4 >> 2], i[k + 8 >> 2] = i[G >> 2], i[k + 12 >> 2] = e, e = i[G + 12 >> 2], i[k + 16 >> 2] = i[G + 8 >> 2], i[k + 20 >> 2] = e, e = l[G + 23 | 0] | l[G + 24 | 0] << 8 | (l[G + 25 | 0] << 16 | l[G + 26 | 0] << 24), o[k + 31 | 0] = e, o[k + 32 | 0] = e >>> 8, o[k + 33 | 0] = e >>> 16, o[k + 34 | 0] = e >>> 24, i[k + 28 >> 2] = i[G + 20 >> 2], e = i[s + 72 >> 2], w = 1;
                                                break r;
                                            }
                                            if (_ = i[21712], y = i[21713], (_ | 0) != (y | 0)) {
                                                for(;;){
                                                    if (e = i[_ >> 2], p[i[i[e >> 2] + 8 >> 2]](s + 56 | 0, e, i[s + 88 >> 2] - 32 | 0, W, t), k = i[s + 56 >> 2], R = i[s + 60 >> 2], (k | 0) != (R | 0)) {
                                                        for(;;){
                                                            h = i[s + 88 >> 2], V = h - 4 | 0, B = i[V >> 2], w = i[k + 28 >> 2], e = i[s + 84 >> 2];
                                                            A: {
                                                                if ((e | 0) != (h | 0)) for(n = i[k >> 2], f = e;;){
                                                                    f: {
                                                                        if ((n | 0) != i[f + 12 >> 2] | i[f + 16 >> 2] != i[k + 4 >> 2] | (l[f + 20 | 0] != l[k + 8 | 0] | i[f + 24 >> 2] != i[k + 12 >> 2])) break f;
                                                                        if (n) break A;
                                                                        if (l[f + 38 | 0] != l[k + 26 | 0] | I[f + 36 >> 1] != I[k + 24 >> 1]) break f;
                                                                        if (I[f + 32 >> 1] == I[k + 20 >> 1]) break A;
                                                                    }
                                                                    if (f = f + 44 | 0, (h | 0) == (f | 0)) break;
                                                                }
                                                                if (f = i[s + 72 >> 2], n = i[s + 76 >> 2], (f | 0) != (n | 0)) for(B = w + B | 0, C = i[k >> 2];;){
                                                                    f: {
                                                                        if ((C | 0) != i[f + 12 >> 2] | i[f + 16 >> 2] != i[k + 4 >> 2] | (l[f + 20 | 0] != l[k + 8 | 0] | i[f + 24 >> 2] != i[k + 12 >> 2]) || !C && l[f + 38 | 0] != l[k + 26 | 0] | I[f + 36 >> 1] != I[k + 24 >> 1] | I[f + 32 >> 1] != I[k + 20 >> 1]) break f;
                                                                        if ((B | 0) >= i[f + 40 >> 2]) break A;
                                                                        o[s + 46 | 0] = 1, Q[s + 44 >> 1] = 2, i[s + 40 >> 2] = 131074, o[s + 28 | 0] = 0, i[s + 24 >> 2] = 99, i[s + 16 >> 2] = 0, i[s + 20 >> 2] = 99, i[s + 8 >> 2] = -1, i[s + 12 >> 2] = 0, i[s + 32 >> 2] = 8, i[s + 36 >> 2] = 78668, o[s + 46 | 0] = 1, Q[s + 44 >> 1] = 6, i[s + 40 >> 2] = 851969, i[s + 8 >> 2] = ((h - e | 0) / 44 | 0) - 1, e = i[_ >> 2], n = i[_ + 4 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[s + 12 >> 2] = e, e = i[s + 16 >> 2], i[s + 16 >> 2] = n;
                                                                        k: {
                                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break k;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        e = i[k + 4 >> 2], i[s + 20 >> 2] = i[k >> 2], i[s + 24 >> 2] = e, e = i[k + 12 >> 2], i[s + 28 >> 2] = i[k + 8 >> 2], i[s + 32 >> 2] = e, e = l[k + 23 | 0] | l[k + 24 | 0] << 8 | (l[k + 25 | 0] << 16 | l[k + 26 | 0] << 24), o[s + 43 | 0] = e, o[s + 44 | 0] = e >>> 8, o[s + 45 | 0] = e >>> 16, o[s + 46 | 0] = e >>> 24, i[s + 40 >> 2] = i[k + 20 >> 2], i[s + 48 >> 2] = w, i[f >> 2] = i[s + 8 >> 2], n = i[s + 12 >> 2], h = i[s + 16 >> 2], i[s + 12 >> 2] = 0, i[s + 16 >> 2] = 0, e = i[f + 8 >> 2], i[f + 4 >> 2] = n, i[f + 8 >> 2] = h;
                                                                        k: {
                                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break k;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        e = i[s + 24 >> 2], i[f + 12 >> 2] = i[s + 20 >> 2], i[f + 16 >> 2] = e, e = i[s + 32 >> 2], i[f + 20 >> 2] = i[s + 28 >> 2], i[f + 24 >> 2] = e, e = l[s + 43 | 0] | l[s + 44 | 0] << 8 | (l[s + 45 | 0] << 16 | l[s + 46 | 0] << 24), o[f + 35 | 0] = e, o[f + 36 | 0] = e >>> 8, o[f + 37 | 0] = e >>> 16, o[f + 38 | 0] = e >>> 24, i[f + 32 >> 2] = i[s + 40 >> 2], i[f + 40 >> 2] = i[s + 48 >> 2], e = i[s + 16 >> 2];
                                                                        k: {
                                                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break k;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        i[f + 40 >> 2] = B;
                                                                        break A;
                                                                    }
                                                                    if (f = f + 44 | 0, (n | 0) == (f | 0)) break;
                                                                }
                                                                f = i[k + 12 >> 2], i[s + 16 >> 2] = i[k + 8 >> 2], i[s + 20 >> 2] = f, f = i[k + 4 >> 2], i[s + 8 >> 2] = i[k >> 2], i[s + 12 >> 2] = f, i[s + 24 >> 2] = 78668, f = l[k + 23 | 0] | l[k + 24 | 0] << 8 | (l[k + 25 | 0] << 16 | l[k + 26 | 0] << 24), o[s + 31 | 0] = f, o[s + 32 | 0] = f >>> 8, o[s + 33 | 0] = f >>> 16, o[s + 34 | 0] = f >>> 24, i[s + 28 >> 2] = i[k + 20 >> 2], w = w + i[V >> 2] | 0, i[s + 36 >> 2] = w, e = ((h - e | 0) / 44 | 0) - 1 | 0, i[s + 68 >> 2] = e;
                                                                f: {
                                                                    if (n >>> 0 < k0[s + 80 >> 2]) {
                                                                        o[n + 38 | 0] = 1, Q[n + 36 >> 1] = 2, i[n + 32 >> 2] = 131074, i[n + 24 >> 2] = 8, o[n + 20 | 0] = 0, i[n + 16 >> 2] = 99, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 99, i[n >> 2] = -1, i[n + 4 >> 2] = 0, i[n + 28 >> 2] = 78668, o[n + 38 | 0] = 1, Q[n + 36 >> 1] = 6, i[n + 32 >> 2] = 851969, i[n >> 2] = e, e = i[_ >> 2], f = i[_ + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[n + 4 >> 2] = e, e = i[n + 8 >> 2], i[n + 8 >> 2] = f;
                                                                        k: {
                                                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break k;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        e = i[s + 12 >> 2], i[n + 12 >> 2] = i[s + 8 >> 2], i[n + 16 >> 2] = e, e = i[s + 20 >> 2], i[n + 20 >> 2] = i[s + 16 >> 2], i[n + 24 >> 2] = e, e = l[s + 31 | 0] | l[s + 32 | 0] << 8 | (l[s + 33 | 0] << 16 | l[s + 34 | 0] << 24), o[n + 35 | 0] = e, o[n + 36 | 0] = e >>> 8, o[n + 37 | 0] = e >>> 16, o[n + 38 | 0] = e >>> 24, i[n + 32 >> 2] = i[s + 28 >> 2], i[n + 40 >> 2] = w, e = n + 44 | 0;
                                                                        break f;
                                                                    }
                                                                    B = 0;
                                                                    k: {
                                                                        n: {
                                                                            if (f = i[s + 72 >> 2], n = (i[s + 76 >> 2] - f | 0) / 44 | 0, e = n + 1 | 0, e >>> 0 < 97612894) {
                                                                                if (f = (i[s + 80 >> 2] - f | 0) / 44 | 0, h = f << 1, f = f >>> 0 >= 48806446 ? 97612893 : e >>> 0 < h >>> 0 ? h : e, f) {
                                                                                    if (f >>> 0 >= 97612894) break n;
                                                                                    B = D(Z(f, 44));
                                                                                }
                                                                                h = i[s + 36 >> 2], w = i[s + 68 >> 2], e = Z(n, 44) + B | 0, o[e + 38 | 0] = 1, Q[e + 36 >> 1] = 2, i[e + 32 >> 2] = 131074, i[e + 28 >> 2] = 78668, i[e + 24 >> 2] = 8, o[e + 20 | 0] = 0, i[e + 16 >> 2] = 99, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 99, i[e >> 2] = -1, i[e + 4 >> 2] = 0, o[e + 38 | 0] = 1, Q[e + 36 >> 1] = 6, i[e + 32 >> 2] = 851969, i[e >> 2] = w, w = i[_ >> 2], n = i[_ + 4 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), C = Z(f, 44), i[e + 4 >> 2] = w, f = i[e + 8 >> 2], i[e + 8 >> 2] = n;
                                                                                t: {
                                                                                    if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break t;
                                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                                }
                                                                                E = B + C | 0, f = i[s + 12 >> 2], i[e + 12 >> 2] = i[s + 8 >> 2], i[e + 16 >> 2] = f, f = i[s + 20 >> 2], i[e + 20 >> 2] = i[s + 16 >> 2], i[e + 24 >> 2] = f, f = l[s + 31 | 0] | l[s + 32 | 0] << 8 | (l[s + 33 | 0] << 16 | l[s + 34 | 0] << 24), o[e + 35 | 0] = f, o[e + 36 | 0] = f >>> 8, o[e + 37 | 0] = f >>> 16, o[e + 38 | 0] = f >>> 24, i[e + 32 >> 2] = i[s + 28 >> 2], i[e + 40 >> 2] = h, n = e + 44 | 0, w = i[s + 76 >> 2], B = i[s + 72 >> 2];
                                                                                t: {
                                                                                    if ((w | 0) == (B | 0)) {
                                                                                        f = e;
                                                                                        break t;
                                                                                    }
                                                                                    for(; f = e - 44 | 0, h = w - 44 | 0, i[f >> 2] = i[h >> 2], C = w - 40 | 0, i[e - 40 >> 2] = i[C >> 2], i[e - 36 >> 2] = i[w - 36 >> 2], i[C >> 2] = 0, i[C + 4 >> 2] = 0, C = w - 32 | 0, F = i[C + 12 >> 2], V = e - 32 | 0, i[V + 8 >> 2] = i[C + 8 >> 2], i[V + 12 >> 2] = F, F = i[C + 4 >> 2], i[V >> 2] = i[C >> 2], i[V + 4 >> 2] = F, i[e - 16 >> 2] = 78668, C = e - 12 | 0, V = w - 12 | 0, i[C >> 2] = i[V >> 2], V = l[V + 3 | 0] | l[V + 4 | 0] << 8 | (l[V + 5 | 0] << 16 | l[V + 6 | 0] << 24), o[C + 3 | 0] = V, o[C + 4 | 0] = V >>> 8, o[C + 5 | 0] = V >>> 16, o[C + 6 | 0] = V >>> 24, i[e - 4 >> 2] = i[w - 4 >> 2], e = f, w = h, (h | 0) != (B | 0););
                                                                                    w = i[s + 76 >> 2], B = i[s + 72 >> 2];
                                                                                }
                                                                                if (i[s + 76 >> 2] = n, i[s + 72 >> 2] = f, i[s + 80 >> 2] = E, (w | 0) != (B | 0)) for(;;){
                                                                                    e = i[w - 36 >> 2];
                                                                                    t: {
                                                                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break t;
                                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                                    }
                                                                                    if (w = w - 44 | 0, (B | 0) == (w | 0)) break;
                                                                                }
                                                                                B && X(B), e = n;
                                                                                break k;
                                                                            }
                                                                            p0(), z();
                                                                        }
                                                                        Z2(), z();
                                                                    }
                                                                }
                                                                i[s + 76 >> 2] = e;
                                                            }
                                                            if (k = k + 32 | 0, (R | 0) == (k | 0)) break;
                                                        }
                                                        k = i[s + 56 >> 2];
                                                    }
                                                    if (k && (i[s + 60 >> 2] = k, X(k)), _ = _ + 8 | 0, (y | 0) == (_ | 0)) break;
                                                }
                                                f = i[s + 76 >> 2];
                                            }
                                            if (e = i[s + 72 >> 2], (f | 0) == (e | 0)) break;
                                        }
                                        w = 0;
                                    }
                                    if (e) {
                                        if (k = e, f = i[s + 76 >> 2], (f | 0) != (e | 0)) {
                                            for(;;){
                                                k = i[f - 36 >> 2];
                                                r: {
                                                    if (!k || (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n)) break r;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                if (f = f - 44 | 0, (f | 0) == (e | 0)) break;
                                            }
                                            k = i[s + 72 >> 2];
                                        }
                                        i[s + 76 >> 2] = e, X(k);
                                    }
                                    if (e = i[s + 84 >> 2], !e) break e;
                                    if (f = i[s + 88 >> 2], k = e, (f | 0) != (e | 0)) {
                                        for(;;){
                                            k = i[f - 36 >> 2];
                                            r: {
                                                if (!k || (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n)) break r;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                            }
                                            if (f = f - 44 | 0, (e | 0) == (f | 0)) break;
                                        }
                                        k = i[s + 84 >> 2];
                                    }
                                    i[s + 88 >> 2] = e, X(k);
                                }
                                m = s + 96 | 0;
                                e: {
                                    if (!w) {
                                        o[v + 12 | 0] = 0, o[v + 23 | 0] = 0, r = i0(v + 24 | 0, 4, 3003, v + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[v + 23 | 0] >= 0) break e;
                                        X(i[v + 12 >> 2]);
                                        break e;
                                    }
                                    if (i[v + 44 >> 2] == i[v + 48 >> 2]) {
                                        if (i[A >> 2] = i[r >> 2], r = i[r + 4 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break e;
                                        }
                                        j(A, i[21670], i[21671]);
                                        break e;
                                    }
                                    n = A, s = m + -64 | 0, m = s, A = i[r >> 2], k = i[r + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 2), r = v + 44 | 0, _ = i[r >> 2], y = i[r + 4 >> 2];
                                    r: {
                                        A: {
                                            if ((_ | 0) == (y | 0)) {
                                                r = A;
                                                break A;
                                            }
                                            for(C = n + 16 | 0, R = r + 12 | 0, G = s + 16 | 0, r = A;;){
                                                e = i[_ >> 2], i[s + 32 >> 2] = k, i[s + 28 >> 2] = A, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), p[i[i[e >> 2] + 12 >> 2]](s + 36 | 0, e, s + 28 | 0, _ + 8 | 0, _ + 36 | 0, R, u), e = i[s + 32 >> 2];
                                                f: {
                                                    if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break f;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                f: {
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        if (E = i[s + 44 >> 2], E) {
                                                                            if (i[n >> 2] = 0, i[n + 4 >> 2] = 0, e = i[s + 48 >> 2], i[n + 8 >> 2] = i[s + 44 >> 2], i[n + 12 >> 2] = e, o[s + 63 | 0] < 0) break s;
                                                                            e = i[s + 56 >> 2], i[C >> 2] = i[s + 52 >> 2], i[C + 4 >> 2] = e, i[C + 8 >> 2] = i[s + 60 >> 2];
                                                                            break f;
                                                                        }
                                                                        t = i[s + 40 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), r = i[s + 36 >> 2];
                                                                        u: {
                                                                            if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break u;
                                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                                        }
                                                                        W = D(24), e = W, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 78668, i[e >> 2] = 78292, i[e + 16 >> 2] = i[_ + 56 >> 2], f = l[_ + 59 | 0] | l[_ + 60 | 0] << 8 | (l[_ + 61 | 0] << 16 | l[_ + 62 | 0] << 24), o[e + 19 | 0] = f, o[e + 20 | 0] = f >>> 8, o[e + 21 | 0] = f >>> 16, o[e + 22 | 0] = f >>> 24, i[e + 4 >> 2] = 2, i[r + 44 >> 2] = e + 12, f = i[r + 48 >> 2], i[r + 48 >> 2] = e;
                                                                        u: {
                                                                            if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break u;
                                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                        }
                                                                        e = i[W + 4 >> 2], i[W + 4 >> 2] = e - 1, e || (p[i[i[W >> 2] + 8 >> 2]](W), g(W)), e = i[A + 52 >> 2], f = i[A + 56 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[r + 52 >> 2] = e, e = i[r + 56 >> 2], i[r + 56 >> 2] = f;
                                                                        u: {
                                                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break u;
                                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                        }
                                                                        if (o[r + 40 | 0] = l[A + 40 | 0], I[A + 80 >> 1] | I[A + 82 >> 1] && (i[r + 80 >> 2] = i[A + 80 >> 2]), l[A + 108 | 0] == 1 && (e = i[A + 92 >> 2], f = i[A + 96 >> 2], h = i[A + 84 >> 2], w = i[A + 88 >> 2], B = i[A + 104 >> 2], i[r + 100 >> 2] = i[A + 100 >> 2], i[r + 104 >> 2] = B, i[r + 92 >> 2] = e, i[r + 96 >> 2] = f, i[r + 84 >> 2] = h, i[r + 88 >> 2] = w, o[r + 108 | 0] = 1), e = i[A + 72 >> 2], f = i[A + 76 >> 2], (e | 0) != (f | 0) && (i[r + 76 >> 2] = f, i[r + 72 >> 2] = e), h = i[A + 112 >> 2], F = i[A + 116 >> 2], (h | 0) == (F | 0)) break n;
                                                                        for(;;){
                                                                            A = i[h + 4 >> 2], i[s + 8 >> 2] = i[h >> 2], i[s + 12 >> 2] = A;
                                                                            u: {
                                                                                if (o[h + 19 | 0] >= 0) {
                                                                                    A = i[h + 12 >> 2], i[G >> 2] = i[h + 8 >> 2], i[G + 4 >> 2] = A, i[G + 8 >> 2] = i[h + 16 >> 2];
                                                                                    break u;
                                                                                }
                                                                                j(G, i[h + 8 >> 2], i[h + 12 >> 2]);
                                                                            }
                                                                            A = i[r + 116 >> 2], e = i[r + 120 >> 2];
                                                                            u: {
                                                                                if (A >>> 0 < e >>> 0) {
                                                                                    e = i[s + 12 >> 2], i[A >> 2] = i[s + 8 >> 2], i[A + 4 >> 2] = e, i[A + 16 >> 2] = i[G + 8 >> 2], e = i[G + 4 >> 2], i[A + 8 >> 2] = i[G >> 2], i[A + 12 >> 2] = e, i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 0, V = A + 20 | 0;
                                                                                    break u;
                                                                                }
                                                                                if (f = i[r + 112 >> 2], w = (A - f | 0) / 20 | 0, A = w + 1 | 0, A >>> 0 >= 214748365) break o;
                                                                                if (e = (e - f | 0) / 20 | 0, f = e << 1, A = e >>> 0 >= 107374182 ? 214748364 : A >>> 0 < f >>> 0 ? f : A, A) {
                                                                                    if (A >>> 0 >= 214748365) break t;
                                                                                    f = D(Z(A, 20));
                                                                                } else f = 0;
                                                                                e = f + Z(w, 20) | 0, w = i[s + 12 >> 2], i[e >> 2] = i[s + 8 >> 2], i[e + 4 >> 2] = w, i[e + 16 >> 2] = i[G + 8 >> 2], w = i[G + 4 >> 2], i[e + 8 >> 2] = i[G >> 2], i[e + 12 >> 2] = w, i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 0, H = f + Z(A, 20) | 0, V = e + 20 | 0, A = i[r + 116 >> 2], B = i[r + 112 >> 2];
                                                                                w: {
                                                                                    if ((A | 0) == (B | 0)) {
                                                                                        f = e;
                                                                                        break w;
                                                                                    }
                                                                                    for(; w = A - 20 | 0, M = i[w + 4 >> 2], f = e - 20 | 0, i[f >> 2] = i[w >> 2], i[f + 4 >> 2] = M, e = e - 12 | 0, A = A - 12 | 0, i[e + 8 >> 2] = i[A + 8 >> 2], M = i[A + 4 >> 2], i[e >> 2] = i[A >> 2], i[e + 4 >> 2] = M, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, e = f, A = w, (A | 0) != (B | 0););
                                                                                    A = i[r + 116 >> 2], B = i[r + 112 >> 2];
                                                                                }
                                                                                if (i[r + 116 >> 2] = V, i[r + 112 >> 2] = f, i[r + 120 >> 2] = H, (A | 0) != (B | 0)) for(; o[A - 1 | 0] < 0 && X(i[A - 12 >> 2]), A = A - 20 | 0, (B | 0) != (A | 0););
                                                                                if (!B) break u;
                                                                                X(B);
                                                                            }
                                                                            if (i[r + 116 >> 2] = V, o[s + 27 | 0] < 0 && X(i[s + 16 >> 2]), h = h + 20 | 0, (F | 0) == (h | 0)) break;
                                                                        }
                                                                        break n;
                                                                    }
                                                                    j(C, i[s + 52 >> 2], i[s + 56 >> 2]);
                                                                    break k;
                                                                }
                                                                p0(), z();
                                                            }
                                                            Z2(), z();
                                                        }
                                                        t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1);
                                                        n: {
                                                            if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break n;
                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        }
                                                        A = i[W + 4 >> 2], i[W + 4 >> 2] = A - 1, A || (p[i[i[W >> 2] + 8 >> 2]](W), g(W)), k = t, A = r;
                                                    }
                                                    if (o[s + 63 | 0] >= 0) break f;
                                                    X(i[s + 52 >> 2]);
                                                }
                                                e = i[s + 40 >> 2];
                                                f: {
                                                    if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break f;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                if (E) break r;
                                                if (_ = _ - -64 | 0, (y | 0) == (_ | 0)) break;
                                            }
                                        }
                                        if (i[n + 4 >> 2] = k, i[n >> 2] = r, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), A = i[21669], i[n + 8 >> 2] = i[21668], i[n + 12 >> 2] = A, A = n + 16 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    r: {
                                        if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    r: {
                                        if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    m = s - -64 | 0;
                                }
                                if (e = i[v + 44 >> 2], e) {
                                    if (r = i[v + 48 >> 2], A = e, (r | 0) != (e | 0)) {
                                        for(;;){
                                            A = i[r - 60 >> 2];
                                            e: {
                                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break e;
                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            }
                                            if (r = r + -64 | 0, (e | 0) == (r | 0)) break;
                                        }
                                        A = i[v + 44 >> 2];
                                    }
                                    i[v + 48 >> 2] = e, X(A);
                                }
                                Si(v + 104 | 0, i[v + 108 >> 2]);
                            }
                            m = v + 144 | 0;
                        }
                        function nh(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            k = m - 144 | 0, m = k, e = i[r + 20 >> 2], i[k + 136 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[k + 140 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 24 >> 2], f = i[r + 28 >> 2];
                            i: {
                                if ((e | 0) != (f | 0)) for(n = e;;){
                                    e: {
                                        if (t = i[n >> 2], !t || (t = E0(t, 73632, 83544), !t)) break e;
                                        C = i[n + 4 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1, f = i[r + 28 >> 2], e = i[r + 24 >> 2]);
                                        r: {
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            if ((e | 0) != (f | 0)) for(;;){
                                                                t: {
                                                                    if (n = i[e >> 2], !n || (n = E0(n, 73632, 73656), !n)) break t;
                                                                    if (V = i[e + 4 >> 2], V && (i[V + 4 >> 2] = i[V + 4 >> 2] + 1), e = i[t + 164 >> 2], i[k + 128 >> 2] = i[t + 160 >> 2], i[k + 132 >> 2] = e, e = i[t + 156 >> 2], i[k + 120 >> 2] = i[t + 152 >> 2], i[k + 124 >> 2] = e, e = i[t + 148 >> 2], i[k + 112 >> 2] = i[t + 144 >> 2], i[k + 116 >> 2] = e, e = i[t + 140 >> 2], i[k + 104 >> 2] = i[t + 136 >> 2], i[k + 108 >> 2] = e, e = i[t + 132 >> 2], i[k + 96 >> 2] = i[t + 128 >> 2], i[k + 100 >> 2] = e, e = i[t + 124 >> 2], i[k + 88 >> 2] = i[t + 120 >> 2], i[k + 92 >> 2] = e, e = i[t + 116 >> 2], i[k + 80 >> 2] = i[t + 112 >> 2], i[k + 84 >> 2] = e, e = i[t + 108 >> 2], i[k + 72 >> 2] = i[t + 104 >> 2], i[k + 76 >> 2] = e, f = i[n + 104 >> 2], i[k + 76 >> 2] = f, e = i[n + 108 >> 2], i[k + 80 >> 2] = e, e && f) break n;
                                                                    if (r = D(40), i[k + 40 >> 2] = r, i[k + 44 >> 2] = 39, i[k + 48 >> 2] = -2147483608, f = l[19097] | l[19098] << 8 | (l[19099] << 16 | l[19100] << 24), e = l[19093] | l[19094] << 8 | (l[19095] << 16 | l[19096] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 39 | 0] = 0, f = l[19128] | l[19129] << 8 | (l[19130] << 16 | l[19131] << 24), e = l[19124] | l[19125] << 8 | (l[19126] << 16 | l[19127] << 24), o[r + 31 | 0] = e, o[r + 32 | 0] = e >>> 8, o[r + 33 | 0] = e >>> 16, o[r + 34 | 0] = e >>> 24, o[r + 35 | 0] = f, o[r + 36 | 0] = f >>> 8, o[r + 37 | 0] = f >>> 16, o[r + 38 | 0] = f >>> 24, f = l[19121] | l[19122] << 8 | (l[19123] << 16 | l[19124] << 24), e = l[19117] | l[19118] << 8 | (l[19119] << 16 | l[19120] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[19113] | l[19114] << 8 | (l[19115] << 16 | l[19116] << 24), e = l[19109] | l[19110] << 8 | (l[19111] << 16 | l[19112] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[19105] | l[19106] << 8 | (l[19107] << 16 | l[19108] << 24), e = l[19101] | l[19102] << 8 | (l[19103] << 16 | l[19104] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, k + 40 | 0), o[k + 51 | 0] >= 0) break k;
                                                                    X(i[k + 40 >> 2]);
                                                                    break k;
                                                                }
                                                                if (e = e + 8 | 0, (f | 0) == (e | 0)) break;
                                                            }
                                                            if (r = D(48), i[k + 72 >> 2] = r, i[k + 76 >> 2] = 40, i[k + 80 >> 2] = -2147483600, f = l[18469] | l[18470] << 8 | (l[18471] << 16 | l[18472] << 24), e = l[18465] | l[18466] << 8 | (l[18467] << 16 | l[18468] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 40 | 0] = 0, f = l[18501] | l[18502] << 8 | (l[18503] << 16 | l[18504] << 24), e = l[18497] | l[18498] << 8 | (l[18499] << 16 | l[18500] << 24), o[r + 32 | 0] = e, o[r + 33 | 0] = e >>> 8, o[r + 34 | 0] = e >>> 16, o[r + 35 | 0] = e >>> 24, o[r + 36 | 0] = f, o[r + 37 | 0] = f >>> 8, o[r + 38 | 0] = f >>> 16, o[r + 39 | 0] = f >>> 24, f = l[18493] | l[18494] << 8 | (l[18495] << 16 | l[18496] << 24), e = l[18489] | l[18490] << 8 | (l[18491] << 16 | l[18492] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[18485] | l[18486] << 8 | (l[18487] << 16 | l[18488] << 24), e = l[18481] | l[18482] << 8 | (l[18483] << 16 | l[18484] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[18477] | l[18478] << 8 | (l[18479] << 16 | l[18480] << 24), e = l[18473] | l[18474] << 8 | (l[18475] << 16 | l[18476] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, k + 72 | 0), o[k + 83 | 0] >= 0) break f;
                                                            X(i[k + 72 >> 2]);
                                                            break f;
                                                        }
                                                        v = A, y = m - 16 | 0, m = y, A = i[k + 76 >> 2], h = r + 372 | 0, e = h, i[e >> 2] = i[k + 72 >> 2], i[e + 4 >> 2] = A, A = i[k + 132 >> 2], i[e + 56 >> 2] = i[k + 128 >> 2], i[e + 60 >> 2] = A, A = i[k + 124 >> 2], i[e + 48 >> 2] = i[k + 120 >> 2], i[e + 52 >> 2] = A, A = i[k + 116 >> 2], i[e + 40 >> 2] = i[k + 112 >> 2], i[e + 44 >> 2] = A, A = i[k + 108 >> 2], i[e + 32 >> 2] = i[k + 104 >> 2], i[e + 36 >> 2] = A, A = i[k + 100 >> 2], i[e + 24 >> 2] = i[k + 96 >> 2], i[e + 28 >> 2] = A, A = i[k + 92 >> 2], i[e + 16 >> 2] = i[k + 88 >> 2], i[e + 20 >> 2] = A, A = i[k + 84 >> 2], i[e + 8 >> 2] = i[k + 80 >> 2], i[e + 12 >> 2] = A, _ = i[k + 84 >> 2], e = i[k + 76 >> 2], A = i[19709], w = A;
                                                        n: {
                                                            t: {
                                                                if (f = i[19708], !(A | f)) {
                                                                    B = ((e + _ | 0) - 1 >>> 0) / (_ >>> 0) | 0, A = i[k + 88 >> 2], n = ((A + i[k + 80 >> 2] | 0) - 1 >>> 0) / (A >>> 0) | 0, e = l[k + 98 | 0];
                                                                    break t;
                                                                }
                                                                A = i[k + 88 >> 2], n = ((A + i[k + 80 >> 2] | 0) - 1 >>> 0) / (A >>> 0) | 0, B = ((e + _ | 0) - 1 >>> 0) / (_ >>> 0) | 0, A = O0(n, 0, B, 0), u = w0, e = l[k + 98 | 0];
                                                                o: {
                                                                    if (!e || (A = O0(A, u, i[k + 100 >> 2], 0), u = w0, _ = e - 1 | 0, !_) || (A = O0(A, u, i[k + 104 >> 2], 0), u = w0, (_ | 0) == 1) || (A = O0(A, u, i[k + 108 >> 2], 0), u = w0, (_ | 0) == 2) || (A = O0(A, u, i[k + 112 >> 2], 0), u = w0, (_ | 0) == 3) || (A = O0(A, u, i[k + 116 >> 2], 0), u = w0, (_ | 0) == 4) || (A = O0(A, u, i[k + 120 >> 2], 0), u = w0, (_ | 0) == 5) || (A = O0(A, u, i[k + 124 >> 2], 0), u = w0, (_ | 0) == 6)) break o;
                                                                    A = O0(A, u, i[k + 128 >> 2], 0), u = w0;
                                                                }
                                                                if ((u | 0) == (w | 0) & A >>> 0 <= f >>> 0 | u >>> 0 < w >>> 0) break t;
                                                                if (A = D(40), i[y + 4 >> 2] = A, i[y + 8 >> 2] = 38, i[y + 12 >> 2] = -2147483608, f = l[3485] | l[3486] << 8 | (l[3487] << 16 | l[3488] << 24), e = l[3481] | l[3482] << 8 | (l[3483] << 16 | l[3484] << 24), o[A | 0] = e, o[A + 1 | 0] = e >>> 8, o[A + 2 | 0] = e >>> 16, o[A + 3 | 0] = e >>> 24, o[A + 4 | 0] = f, o[A + 5 | 0] = f >>> 8, o[A + 6 | 0] = f >>> 16, o[A + 7 | 0] = f >>> 24, o[A + 38 | 0] = 0, f = l[3515] | l[3516] << 8 | (l[3517] << 16 | l[3518] << 24), e = l[3511] | l[3512] << 8 | (l[3513] << 16 | l[3514] << 24), o[A + 30 | 0] = e, o[A + 31 | 0] = e >>> 8, o[A + 32 | 0] = e >>> 16, o[A + 33 | 0] = e >>> 24, o[A + 34 | 0] = f, o[A + 35 | 0] = f >>> 8, o[A + 36 | 0] = f >>> 16, o[A + 37 | 0] = f >>> 24, f = l[3509] | l[3510] << 8 | (l[3511] << 16 | l[3512] << 24), e = l[3505] | l[3506] << 8 | (l[3507] << 16 | l[3508] << 24), o[A + 24 | 0] = e, o[A + 25 | 0] = e >>> 8, o[A + 26 | 0] = e >>> 16, o[A + 27 | 0] = e >>> 24, o[A + 28 | 0] = f, o[A + 29 | 0] = f >>> 8, o[A + 30 | 0] = f >>> 16, o[A + 31 | 0] = f >>> 24, f = l[3501] | l[3502] << 8 | (l[3503] << 16 | l[3504] << 24), e = l[3497] | l[3498] << 8 | (l[3499] << 16 | l[3500] << 24), o[A + 16 | 0] = e, o[A + 17 | 0] = e >>> 8, o[A + 18 | 0] = e >>> 16, o[A + 19 | 0] = e >>> 24, o[A + 20 | 0] = f, o[A + 21 | 0] = f >>> 8, o[A + 22 | 0] = f >>> 16, o[A + 23 | 0] = f >>> 24, f = l[3493] | l[3494] << 8 | (l[3495] << 16 | l[3496] << 24), e = l[3489] | l[3490] << 8 | (l[3491] << 16 | l[3492] << 24), o[A + 8 | 0] = e, o[A + 9 | 0] = e >>> 8, o[A + 10 | 0] = e >>> 16, o[A + 11 | 0] = e >>> 24, o[A + 12 | 0] = f, o[A + 13 | 0] = f >>> 8, o[A + 14 | 0] = f >>> 16, o[A + 15 | 0] = f >>> 24, i0(v, 3, 1e3, y + 4 | 0), o[y + 15 | 0] >= 0) break n;
                                                                X(i[y + 4 >> 2]);
                                                                break n;
                                                            }
                                                            A = Z(n, B), e = e & 255;
                                                            t: {
                                                                if (!e || (A = Z(A, i[k + 100 >> 2]), e = e - 1 | 0, !e) || (A = Z(A, i[k + 104 >> 2]), (e | 0) == 1) || (A = Z(A, i[k + 108 >> 2]), (e | 0) == 2) || (A = Z(A, i[k + 112 >> 2]), (e | 0) == 3) || (A = Z(A, i[k + 116 >> 2]), (e | 0) == 4) || (A = Z(A, i[k + 120 >> 2]), (e | 0) == 5) || (A = Z(A, i[k + 124 >> 2]), (e | 0) == 6)) break t;
                                                                A = Z(A, i[k + 128 >> 2]);
                                                            }
                                                            f = A, e = i[h + 68 >> 2], A = i[h + 64 >> 2], n = e - A >> 4;
                                                            t: {
                                                                if (f >>> 0 > n >>> 0) {
                                                                    B = 0;
                                                                    o: {
                                                                        if (u = f - n | 0, G = h - -64 | 0, n = i[G + 8 >> 2], e = i[G + 4 >> 2], u >>> 0 <= n - e >> 4 >>> 0) {
                                                                            if (!u) {
                                                                                i[G + 4 >> 2] = e;
                                                                                break o;
                                                                            }
                                                                            n = u - 1 & 268435455, f = u & 7;
                                                                            s: {
                                                                                if (!f) {
                                                                                    A = e;
                                                                                    break s;
                                                                                }
                                                                                for(A = e; i[A >> 2] = 10, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, A = A + 16 | 0, B = B + 1 | 0, (f | 0) != (B | 0););
                                                                            }
                                                                            if (n >>> 0 >= 7) for(e = e + (u << 4) | 0; i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A >> 2] = 10, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 16 >> 2] = 10, i[A + 20 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 60 >> 2] = 0, i[A + 32 >> 2] = 10, i[A + 36 >> 2] = 0, i[A + 72 >> 2] = 0, i[A + 76 >> 2] = 0, i[A + 48 >> 2] = 10, i[A + 52 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 64 >> 2] = 10, i[A + 68 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, i[A + 80 >> 2] = 10, i[A + 84 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 96 >> 2] = 10, i[A + 100 >> 2] = 0, i[A + 112 >> 2] = 10, i[A + 116 >> 2] = 0, A = A + 128 | 0, (e | 0) != (A | 0););
                                                                            i[G + 4 >> 2] = A;
                                                                            break o;
                                                                        }
                                                                        s: {
                                                                            if (A = i[G >> 2], f = e - A >> 4, w = f + u | 0, w >>> 0 < 268435456) {
                                                                                if (e = n - A | 0, A = e >> 3, _ = e >>> 0 >= 2147483632 ? 268435455 : A >>> 0 > w >>> 0 ? A : w, _) {
                                                                                    if (_ >>> 0 >= 268435456) break s;
                                                                                    s = D(_ << 4);
                                                                                }
                                                                                e = (f << 4) + s | 0, n = u - 1 & 268435455, f = u & 7;
                                                                                u: {
                                                                                    if (!f) {
                                                                                        A = e;
                                                                                        break u;
                                                                                    }
                                                                                    for(A = e; i[A >> 2] = 10, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, A = A + 16 | 0, B = B + 1 | 0, (f | 0) != (B | 0););
                                                                                }
                                                                                if (n >>> 0 >= 7) for(f = (u << 4) + e | 0; i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A >> 2] = 10, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 16 >> 2] = 10, i[A + 20 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 60 >> 2] = 0, i[A + 32 >> 2] = 10, i[A + 36 >> 2] = 0, i[A + 72 >> 2] = 0, i[A + 76 >> 2] = 0, i[A + 48 >> 2] = 10, i[A + 52 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 64 >> 2] = 10, i[A + 68 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, i[A + 80 >> 2] = 10, i[A + 84 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 96 >> 2] = 10, i[A + 100 >> 2] = 0, i[A + 112 >> 2] = 10, i[A + 116 >> 2] = 0, A = A + 128 | 0, (f | 0) != (A | 0););
                                                                                if (n = i[G >> 2], B = i[G + 4 >> 2], (n | 0) != (B | 0)) {
                                                                                    for(; B = B - 16 | 0, w = B, f = i[w + 4 >> 2], e = e - 16 | 0, i[e >> 2] = i[w >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[w + 8 >> 2], (n | 0) != (w | 0););
                                                                                    n = i[G >> 2];
                                                                                }
                                                                                i[G + 4 >> 2] = A, i[G >> 2] = e, i[G + 8 >> 2] = (_ << 4) + s, n && X(n);
                                                                                break o;
                                                                            }
                                                                            p0(), z();
                                                                        }
                                                                        Z2(), z();
                                                                    }
                                                                    e = i[h + 68 >> 2], A = i[h + 64 >> 2];
                                                                    break t;
                                                                }
                                                                if (f >>> 0 >= n >>> 0) break t;
                                                                e = (f << 4) + A | 0, i[h + 68 >> 2] = e;
                                                            }
                                                            if ((A | 0) != (e | 0)) for(; i[A >> 2] = 10, i[A + 4 >> 2] = 0, A = A + 16 | 0, (e | 0) != (A | 0););
                                                            if (A = i[21669], i[v >> 2] = i[21668], i[v + 4 >> 2] = A, e = v + 8 | 0, o[86691] >= 0) {
                                                                A = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[21672];
                                                                break n;
                                                            }
                                                            j(e, i[21670], i[21671]);
                                                        }
                                                        if (m = y + 16 | 0, i[v >> 2]) break k;
                                                        o[v + 19 | 0] < 0 && X(i[v + 8 >> 2]), A = _9(i[r + 392 >> 2]), v3(k + 40 | 0, i[r + 20 >> 2], A), e = i[k + 40 >> 2], A = i[k + 44 >> 2], i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, f = i[r + 476 >> 2], i[r + 472 >> 2] = e, i[r + 476 >> 2] = A;
                                                        n: {
                                                            if (!f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break n;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        e = i[k + 44 >> 2];
                                                        n: {
                                                            if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break n;
                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                        }
                                                        n: {
                                                            if (l[t + 97 | 0] == 1) {
                                                                ye(k + 40 | 0, r), W = i[k + 52 >> 2];
                                                                t: {
                                                                    if (W) {
                                                                        if (A = i[k + 56 >> 2], i[v >> 2] = i[k + 52 >> 2], i[v + 4 >> 2] = A, e = v + 8 | 0, o[k + 71 | 0] >= 0) {
                                                                            A = i[k + 64 >> 2], i[e >> 2] = i[k + 60 >> 2], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[k + 68 >> 2];
                                                                            break t;
                                                                        }
                                                                        j(e, i[k + 60 >> 2], i[k + 64 >> 2]);
                                                                        break t;
                                                                    }
                                                                    s = i[r + 472 >> 2], e = k + 28 | 0, i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0;
                                                                    o: {
                                                                        s: {
                                                                            if (A = i[k + 40 >> 2], t = i[k + 44 >> 2], (A | 0) != (t | 0)) {
                                                                                if (n = t - A | 0, (n | 0) < 0) break s;
                                                                                for(f = D(n), i[e + 4 >> 2] = f, i[e >> 2] = f, i[e + 8 >> 2] = f + n; i[f >> 2] = i[A >> 2], n = i[A + 4 >> 2], i[f + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), f = f + 8 | 0, A = A + 8 | 0, (t | 0) != (A | 0););
                                                                                i[e + 4 >> 2] = f;
                                                                            }
                                                                            A = e;
                                                                            break o;
                                                                        }
                                                                        p0(), z();
                                                                    }
                                                                    if (f = A, A = i[s + 24 >> 2], A) {
                                                                        if (e = A, t = i[s + 28 >> 2], (e | 0) != (t | 0)) {
                                                                            for(;;){
                                                                                n = i[t - 4 >> 2];
                                                                                o: {
                                                                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break o;
                                                                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                                                }
                                                                                if (t = t - 8 | 0, (A | 0) == (t | 0)) break;
                                                                            }
                                                                            e = i[s + 24 >> 2];
                                                                        }
                                                                        i[s + 28 >> 2] = A, X(e), i[s + 32 >> 2] = 0, i[s + 24 >> 2] = 0, i[s + 28 >> 2] = 0;
                                                                    }
                                                                    i[s + 24 >> 2] = i[f >> 2], i[s + 28 >> 2] = i[f + 4 >> 2], i[s + 32 >> 2] = i[f + 8 >> 2], i[f + 8 >> 2] = 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, H9(f);
                                                                }
                                                                if (o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), A = i[k + 40 >> 2], A) {
                                                                    if (e = A, n = i[k + 44 >> 2], (e | 0) != (n | 0)) {
                                                                        for(;;){
                                                                            f = i[n - 4 >> 2];
                                                                            t: {
                                                                                if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break t;
                                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                            }
                                                                            if (n = n - 8 | 0, (A | 0) == (n | 0)) break;
                                                                        }
                                                                        e = i[k + 40 >> 2];
                                                                    }
                                                                    i[k + 44 >> 2] = A, X(e);
                                                                }
                                                                if (!W) break n;
                                                                break k;
                                                            }
                                                            i[k + 48 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, n = i[t + 36 >> 2], t = i[t + 40 >> 2];
                                                            t: {
                                                                if ((n | 0) != (t | 0)) {
                                                                    if (A = t - n | 0, (A | 0) < 0) break A;
                                                                    for(f = D(A), i[k + 44 >> 2] = f, i[k + 40 >> 2] = f, i[k + 48 >> 2] = A + f, A = f; e = A, i[e >> 2] = i[n >> 2], A = i[n + 4 >> 2], i[e + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = e + 8 | 0, n = n + 8 | 0, (t | 0) != (n | 0););
                                                                    for(i[k + 44 >> 2] = A, n = f;;){
                                                                        if (i[i[n >> 2] + 16 >> 2] == 1769173093) break t;
                                                                        if (t = (e | 0) == (n | 0), n = n + 8 | 0, !!t) break;
                                                                    }
                                                                }
                                                                f = k + 20 | 0, Sn(f), A = i[k + 88 >> 2], e = i[k + 20 >> 2], i[e + 104 >> 2] = i[k + 84 >> 2], i[e + 108 >> 2] = A, A = k + 40 | 0, e = i[A + 4 >> 2];
                                                                o: {
                                                                    if (k0[A + 8 >> 2] > e >>> 0) {
                                                                        i[e >> 2] = i[f >> 2], i[e + 4 >> 2] = i[f + 4 >> 2], i[f >> 2] = 0, i[f + 4 >> 2] = 0, e = e + 8 | 0;
                                                                        break o;
                                                                    }
                                                                    e = p2(A, f);
                                                                }
                                                                i[A + 4 >> 2] = e, B1(f), A = i[k + 44 >> 2], f = i[k + 40 >> 2];
                                                            }
                                                            if (w = i[r + 472 >> 2], i[k + 16 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, n = 0, t = 0, (A | 0) != (f | 0)) {
                                                                if (e = A - f | 0, (e | 0) < 0) break r;
                                                                for(t = D(e), i[k + 8 >> 2] = t, W = e + t | 0, i[k + 16 >> 2] = W, e = f, n = t; i[n >> 2] = i[e >> 2], s = i[e + 4 >> 2], i[n + 4 >> 2] = s, s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), n = n + 8 | 0, e = e + 8 | 0, (e | 0) != (A | 0););
                                                                i[k + 12 >> 2] = n;
                                                            }
                                                            if (A = i[w + 24 >> 2], A) {
                                                                if (e = i[w + 28 >> 2], f = A, (e | 0) != (A | 0)) {
                                                                    for(;;){
                                                                        n = i[e - 4 >> 2];
                                                                        t: {
                                                                            if (!n || (f = i[n + 4 >> 2], i[n + 4 >> 2] = f - 1, f)) break t;
                                                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                                        }
                                                                        if (e = e - 8 | 0, (A | 0) == (e | 0)) break;
                                                                    }
                                                                    W = i[k + 16 >> 2], n = i[k + 12 >> 2], t = i[k + 8 >> 2], f = i[w + 24 >> 2];
                                                                }
                                                                i[w + 28 >> 2] = A, X(f), f = i[k + 40 >> 2];
                                                            }
                                                            if (i[w + 32 >> 2] = W, i[w + 28 >> 2] = n, i[w + 24 >> 2] = t, i[k + 16 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, !f) break n;
                                                            if (e = f, n = i[k + 44 >> 2], (e | 0) != (n | 0)) {
                                                                for(;;){
                                                                    e = i[n - 4 >> 2];
                                                                    t: {
                                                                        if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break t;
                                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                                    }
                                                                    if (n = n - 8 | 0, (n | 0) == (f | 0)) break;
                                                                }
                                                                e = i[k + 40 >> 2];
                                                            }
                                                            i[k + 44 >> 2] = f, X(e);
                                                        }
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        u: {
                                                                            if (e = i[r + 472 >> 2], A = p[i[i[e >> 2] + 8 >> 2]](e) | 0, (A | 0) <= 1781689136) {
                                                                                w: {
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                if ((A | 0) != 1635135537) {
                                                                                                    if ((A | 0) == 1635148593) break v;
                                                                                                    if ((A | 0) != 1752589105) break u;
                                                                                                    f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                                    _: {
                                                                                                        B: {
                                                                                                            if ((f | 0) != (e | 0)) for(;;){
                                                                                                                m: {
                                                                                                                    if (A = i[f >> 2], !A || (n = E0(A, 73632, 80516), !n)) break m;
                                                                                                                    if (f = i[f + 4 >> 2], !f) break B;
                                                                                                                    i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                                                    break _;
                                                                                                                }
                                                                                                                if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                                            }
                                                                                                            n = 0;
                                                                                                        }
                                                                                                        f = 0;
                                                                                                    }
                                                                                                    if (e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80120, A = e + 12 | 0, !f) break h;
                                                                                                    i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 80592, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                                    break o;
                                                                                                }
                                                                                                f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                                _: {
                                                                                                    B: {
                                                                                                        if ((f | 0) != (e | 0)) for(;;){
                                                                                                            m: {
                                                                                                                if (A = i[f >> 2], !A || (n = E0(A, 73632, 80852), !n)) break m;
                                                                                                                if (f = i[f + 4 >> 2], !f) break B;
                                                                                                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                                                break _;
                                                                                                            }
                                                                                                            if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                                        }
                                                                                                        n = 0;
                                                                                                    }
                                                                                                    f = 0;
                                                                                                }
                                                                                                if (e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80160, A = e + 12 | 0, !f) break l;
                                                                                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 80748, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                                break o;
                                                                                            }
                                                                                            f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                            v: {
                                                                                                _: {
                                                                                                    if ((f | 0) != (e | 0)) for(;;){
                                                                                                        B: {
                                                                                                            if (A = i[f >> 2], !A || (n = E0(A, 73632, 82204), !n)) break B;
                                                                                                            if (f = i[f + 4 >> 2], !f) break _;
                                                                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                                    }
                                                                                                    n = 0;
                                                                                                }
                                                                                                f = 0;
                                                                                            }
                                                                                            if (e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80200, A = e + 12 | 0, !f) break w;
                                                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 82224, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                            break o;
                                                                                        }
                                                                                        i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 80592;
                                                                                        break t;
                                                                                    }
                                                                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 80748;
                                                                                    break t;
                                                                                }
                                                                                i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 82224;
                                                                                break t;
                                                                            }
                                                                            if ((A | 0) <= 1836280680) {
                                                                                if ((A | 0) != 1781689137) {
                                                                                    if ((A | 0) != 1785750887) break u;
                                                                                    f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                    w: {
                                                                                        if ((f | 0) != (e | 0)) for(;;){
                                                                                            l: {
                                                                                                if (A = i[f >> 2], !A || (n = E0(A, 73632, 81172), !n)) break l;
                                                                                                if (f = i[f + 4 >> 2], !f) {
                                                                                                    f = 0;
                                                                                                    break w;
                                                                                                }
                                                                                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                                break w;
                                                                                            }
                                                                                            if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                        }
                                                                                        f = 0, n = 0;
                                                                                    }
                                                                                    if (e = D(72), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80320, A = e + 12 | 0, f) {
                                                                                        i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81192, i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 68 | 0] = 0, o[e + 52 | 0] = 0, n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n || (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                        break o;
                                                                                    }
                                                                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, o[e + 68 | 0] = 0, o[e + 52 | 0] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81192;
                                                                                    break t;
                                                                                }
                                                                                f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                w: {
                                                                                    if ((f | 0) != (e | 0)) for(;;){
                                                                                        l: {
                                                                                            if (A = i[f >> 2], !A || (n = E0(A, 73632, 81740), !n)) break l;
                                                                                            if (f = i[f + 4 >> 2], !f) {
                                                                                                f = 0;
                                                                                                break w;
                                                                                            }
                                                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                            break w;
                                                                                        }
                                                                                        if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                    }
                                                                                    f = 0, n = 0;
                                                                                }
                                                                                if (e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80240, A = e + 12 | 0, f) {
                                                                                    i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81348, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                    break o;
                                                                                }
                                                                                i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81348;
                                                                                break t;
                                                                            }
                                                                            if ((A | 0) != 1836280681) {
                                                                                if ((A | 0) != 1987470129) break u;
                                                                                f = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                                                                w: {
                                                                                    if ((f | 0) != (e | 0)) for(;;){
                                                                                        l: {
                                                                                            if (A = i[f >> 2], !A || (n = E0(A, 73632, 81996), !n)) break l;
                                                                                            if (f = i[f + 4 >> 2], !f) {
                                                                                                f = 0;
                                                                                                break w;
                                                                                            }
                                                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                                            break w;
                                                                                        }
                                                                                        if (f = f + 8 | 0, (e | 0) == (f | 0)) break;
                                                                                    }
                                                                                    f = 0, n = 0;
                                                                                }
                                                                                if (e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80280, A = e + 12 | 0, !f) break s;
                                                                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = f, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81864, i[f + 4 >> 2] == -1 && (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                                                                                break o;
                                                                            }
                                                                            i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0;
                                                                            break n;
                                                                        }
                                                                        i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0;
                                                                        break n;
                                                                    }
                                                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81864, i[k + 44 >> 2] = e, i[k + 40 >> 2] = A;
                                                                    break n;
                                                                }
                                                                if (i[k + 44 >> 2] = e, i[k + 40 >> 2] = A, A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A) break n;
                                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                break n;
                                                            }
                                                            i[k + 44 >> 2] = e, i[k + 40 >> 2] = A;
                                                        }
                                                        e = i[k + 40 >> 2], A = i[k + 44 >> 2], i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, f = i[r + 484 >> 2], i[r + 480 >> 2] = e, i[r + 484 >> 2] = A;
                                                        n: {
                                                            if (!f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break n;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        e = i[k + 44 >> 2];
                                                        n: {
                                                            if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break n;
                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                        }
                                                        if (!i[r + 480 >> 2]) {
                                                            if (A = D(56), i[k + 40 >> 2] = A, i[k + 44 >> 2] = 49, i[k + 48 >> 2] = -2147483592, e = l[19137] | l[19138] << 8 | (l[19139] << 16 | l[19140] << 24), r = l[19133] | l[19134] << 8 | (l[19135] << 16 | l[19136] << 24), o[A | 0] = r, o[A + 1 | 0] = r >>> 8, o[A + 2 | 0] = r >>> 16, o[A + 3 | 0] = r >>> 24, o[A + 4 | 0] = e, o[A + 5 | 0] = e >>> 8, o[A + 6 | 0] = e >>> 16, o[A + 7 | 0] = e >>> 24, o[A + 49 | 0] = 0, o[A + 48 | 0] = l[19181], e = l[19177] | l[19178] << 8 | (l[19179] << 16 | l[19180] << 24), r = l[19173] | l[19174] << 8 | (l[19175] << 16 | l[19176] << 24), o[A + 40 | 0] = r, o[A + 41 | 0] = r >>> 8, o[A + 42 | 0] = r >>> 16, o[A + 43 | 0] = r >>> 24, o[A + 44 | 0] = e, o[A + 45 | 0] = e >>> 8, o[A + 46 | 0] = e >>> 16, o[A + 47 | 0] = e >>> 24, e = l[19169] | l[19170] << 8 | (l[19171] << 16 | l[19172] << 24), r = l[19165] | l[19166] << 8 | (l[19167] << 16 | l[19168] << 24), o[A + 32 | 0] = r, o[A + 33 | 0] = r >>> 8, o[A + 34 | 0] = r >>> 16, o[A + 35 | 0] = r >>> 24, o[A + 36 | 0] = e, o[A + 37 | 0] = e >>> 8, o[A + 38 | 0] = e >>> 16, o[A + 39 | 0] = e >>> 24, e = l[19161] | l[19162] << 8 | (l[19163] << 16 | l[19164] << 24), r = l[19157] | l[19158] << 8 | (l[19159] << 16 | l[19160] << 24), o[A + 24 | 0] = r, o[A + 25 | 0] = r >>> 8, o[A + 26 | 0] = r >>> 16, o[A + 27 | 0] = r >>> 24, o[A + 28 | 0] = e, o[A + 29 | 0] = e >>> 8, o[A + 30 | 0] = e >>> 16, o[A + 31 | 0] = e >>> 24, e = l[19153] | l[19154] << 8 | (l[19155] << 16 | l[19156] << 24), r = l[19149] | l[19150] << 8 | (l[19151] << 16 | l[19152] << 24), o[A + 16 | 0] = r, o[A + 17 | 0] = r >>> 8, o[A + 18 | 0] = r >>> 16, o[A + 19 | 0] = r >>> 24, o[A + 20 | 0] = e, o[A + 21 | 0] = e >>> 8, o[A + 22 | 0] = e >>> 16, o[A + 23 | 0] = e >>> 24, e = l[19145] | l[19146] << 8 | (l[19147] << 16 | l[19148] << 24), r = l[19141] | l[19142] << 8 | (l[19143] << 16 | l[19144] << 24), o[A + 8 | 0] = r, o[A + 9 | 0] = r >>> 8, o[A + 10 | 0] = r >>> 16, o[A + 11 | 0] = r >>> 24, o[A + 12 | 0] = e, o[A + 13 | 0] = e >>> 8, o[A + 14 | 0] = e >>> 16, o[A + 15 | 0] = e >>> 24, i0(v, 4, 3e3, k + 40 | 0), o[k + 51 | 0] >= 0) break k;
                                                            X(i[k + 40 >> 2]);
                                                            break k;
                                                        }
                                                        n: {
                                                            if (l[r + 468 | 0] != 1) break n;
                                                            t = k + 136 | 0, n = i[r + 36 >> 2], s = m - 16 | 0, m = s, e = i[19708], W = i[19709], u = !(e | W), A = i[h + 16 >> 2], r = ((A + i[h + 8 >> 2] | 0) - 1 >>> 0) / (A >>> 0) | 0, A = i[h + 12 >> 2], A = O0(r, 0, ((A + i[h + 4 >> 2] | 0) - 1 >>> 0) / (A >>> 0) | 0, 0), r = w0, f = l[h + 26 | 0];
                                                            t: {
                                                                if (!f || (A = O0(A, r, i[h + 28 >> 2], 0), r = w0, f = f - 1 | 0, !f) || (A = O0(A, r, i[h + 32 >> 2], 0), r = w0, (f | 0) == 1) || (A = O0(A, r, i[h + 36 >> 2], 0), r = w0, (f | 0) == 2) || (A = O0(A, r, i[h + 40 >> 2], 0), r = w0, (f | 0) == 3) || (A = O0(A, r, i[h + 44 >> 2], 0), r = w0, (f | 0) == 4) || (A = O0(A, r, i[h + 48 >> 2], 0), r = w0, (f | 0) == 5) || (A = O0(A, r, i[h + 52 >> 2], 0), r = w0, (f | 0) == 6)) break t;
                                                                A = O0(A, r, i[h + 56 >> 2], 0), r = w0;
                                                            }
                                                            t: {
                                                                if (!(u | ((W | 0) == (r | 0) & A >>> 0 <= e >>> 0 | r >>> 0 < W >>> 0))) {
                                                                    if (e = D(40), i[s + 4 >> 2] = e, i[s + 8 >> 2] = 39, i[s + 12 >> 2] = -2147483608, r = l[19016] | l[19017] << 8 | (l[19018] << 16 | l[19019] << 24), A = l[19012] | l[19013] << 8 | (l[19014] << 16 | l[19015] << 24), o[e | 0] = A, o[e + 1 | 0] = A >>> 8, o[e + 2 | 0] = A >>> 16, o[e + 3 | 0] = A >>> 24, o[e + 4 | 0] = r, o[e + 5 | 0] = r >>> 8, o[e + 6 | 0] = r >>> 16, o[e + 7 | 0] = r >>> 24, o[e + 39 | 0] = 0, r = l[19047] | l[19048] << 8 | (l[19049] << 16 | l[19050] << 24), A = l[19043] | l[19044] << 8 | (l[19045] << 16 | l[19046] << 24), o[e + 31 | 0] = A, o[e + 32 | 0] = A >>> 8, o[e + 33 | 0] = A >>> 16, o[e + 34 | 0] = A >>> 24, o[e + 35 | 0] = r, o[e + 36 | 0] = r >>> 8, o[e + 37 | 0] = r >>> 16, o[e + 38 | 0] = r >>> 24, r = l[19040] | l[19041] << 8 | (l[19042] << 16 | l[19043] << 24), A = l[19036] | l[19037] << 8 | (l[19038] << 16 | l[19039] << 24), o[e + 24 | 0] = A, o[e + 25 | 0] = A >>> 8, o[e + 26 | 0] = A >>> 16, o[e + 27 | 0] = A >>> 24, o[e + 28 | 0] = r, o[e + 29 | 0] = r >>> 8, o[e + 30 | 0] = r >>> 16, o[e + 31 | 0] = r >>> 24, r = l[19032] | l[19033] << 8 | (l[19034] << 16 | l[19035] << 24), A = l[19028] | l[19029] << 8 | (l[19030] << 16 | l[19031] << 24), o[e + 16 | 0] = A, o[e + 17 | 0] = A >>> 8, o[e + 18 | 0] = A >>> 16, o[e + 19 | 0] = A >>> 24, o[e + 20 | 0] = r, o[e + 21 | 0] = r >>> 8, o[e + 22 | 0] = r >>> 16, o[e + 23 | 0] = r >>> 24, r = l[19024] | l[19025] << 8 | (l[19026] << 16 | l[19027] << 24), A = l[19020] | l[19021] << 8 | (l[19022] << 16 | l[19023] << 24), o[e + 8 | 0] = A, o[e + 9 | 0] = A >>> 8, o[e + 10 | 0] = A >>> 16, o[e + 11 | 0] = A >>> 24, o[e + 12 | 0] = r, o[e + 13 | 0] = r >>> 8, o[e + 14 | 0] = r >>> 16, o[e + 15 | 0] = r >>> 24, i0(v, 2, 1e3, s + 4 | 0), o[s + 15 | 0] >= 0) break t;
                                                                    X(i[s + 4 >> 2]);
                                                                    break t;
                                                                }
                                                                D7(v, h, t, n, 0, A, r);
                                                            }
                                                            if (m = s + 16 | 0, i[v >> 2]) break k;
                                                            if (o[v + 19 | 0] >= 0) break n;
                                                            X(i[v + 8 >> 2]);
                                                        }
                                                        J6(v);
                                                    }
                                                    if (!V || (A = i[V + 4 >> 2], i[V + 4 >> 2] = A - 1, A)) break f;
                                                    p[i[i[V >> 2] + 8 >> 2]](V), g(V);
                                                }
                                                if (!C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break i;
                                                p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                                                break i;
                                            }
                                            p0(), z();
                                        }
                                        p0(), z();
                                    }
                                    if (n = n + 8 | 0, (n | 0) == (f | 0)) break;
                                }
                                if (r = D(48), i[k + 72 >> 2] = r, i[k + 76 >> 2] = 40, i[k + 80 >> 2] = -2147483600, f = l[18510] | l[18511] << 8 | (l[18512] << 16 | l[18513] << 24), e = l[18506] | l[18507] << 8 | (l[18508] << 16 | l[18509] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 40 | 0] = 0, f = l[18542] | l[18543] << 8 | (l[18544] << 16 | l[18545] << 24), e = l[18538] | l[18539] << 8 | (l[18540] << 16 | l[18541] << 24), o[r + 32 | 0] = e, o[r + 33 | 0] = e >>> 8, o[r + 34 | 0] = e >>> 16, o[r + 35 | 0] = e >>> 24, o[r + 36 | 0] = f, o[r + 37 | 0] = f >>> 8, o[r + 38 | 0] = f >>> 16, o[r + 39 | 0] = f >>> 24, f = l[18534] | l[18535] << 8 | (l[18536] << 16 | l[18537] << 24), e = l[18530] | l[18531] << 8 | (l[18532] << 16 | l[18533] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[18526] | l[18527] << 8 | (l[18528] << 16 | l[18529] << 24), e = l[18522] | l[18523] << 8 | (l[18524] << 16 | l[18525] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[18518] | l[18519] << 8 | (l[18520] << 16 | l[18521] << 24), e = l[18514] | l[18515] << 8 | (l[18516] << 16 | l[18517] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, k + 72 | 0), o[k + 83 | 0] >= 0) break i;
                                X(i[k + 72 >> 2]);
                            }
                            r = i[k + 140 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = k + 144 | 0;
                        }
                        function B7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0;
                            if (o[r | 0] = 0, e = i[A + 3208 >> 2], u = i[A + 3212 >> 2], (e | 0) == (u | 0)) return 0;
                            i: {
                                e: {
                                    s = i[e >> 2], f = i[s + 428 >> 2], k = i[s + 424 >> 2];
                                    r: {
                                        A: {
                                            if ((f | 0) == (k | 0)) break A;
                                            for(f = f - k >> 2, f = f >>> 0 <= 1 ? 1 : f;;){
                                                if (n = i[k + (G << 2) >> 2], i[n + 40 >> 2]) {
                                                    if (G = G + 1 | 0, (f | 0) != (G | 0)) continue;
                                                    break A;
                                                }
                                                break;
                                            }
                                            if (l[n + 36 | 0] == 1 && ro(A + 2140 | 0), o[r | 0] = 1, u = 0, t = i[n + 4 >> 2], f = i[t + 1352 >> 2], (f | 0) != i[t + 1356 >> 2]) for(k = A + 2140 | 0; e = d9(k, i[(u << 2) + f >> 2]), (e | 0) >= 0 && (i[i[i[A + 2148 >> 2] + (e << 2) >> 2] + 100 >> 2] = 0), u = u + 1 | 0, f = i[t + 1352 >> 2], u >>> 0 < i[t + 1356 >> 2] - f >> 2 >>> 0;);
                                            v = i[s >> 2], e = i[v + 132 >> 2], i[n + 40 >> 2] = 1, w = l[e + 46 | 0], W = l[e + 45 | 0], k = i[v + 112 >> 2], t = i[k + 1884 >> 2];
                                            f: {
                                                if (w | (W | (t | 0) <= 0)) break f;
                                                f = i[k + 168 >> 2];
                                                k: {
                                                    if ((f | 0) > 0) {
                                                        for(e = k + 88 | 0, u = 0;;){
                                                            if (i[e + (u << 2) >> 2] == 1e3) break f;
                                                            if (u = u + 1 | 0, (f | 0) == (u | 0)) break;
                                                        }
                                                        if ((f | 0) > 19) break k;
                                                    }
                                                    i[k + 168 >> 2] = f + 1, i[(k + (f << 2) | 0) + 88 >> 2] = 1e3;
                                                }
                                                if (e = i[k + 84 >> 2], (e | 0) == 20) {
                                                    i[k + 80 >> 2] = 1001;
                                                    break f;
                                                }
                                                i[k + 84 >> 2] = e + 1, i[(k + 4 | 0) + (e << 2) >> 2] = 1e3;
                                            }
                                            f = i[s + 424 >> 2], u = i[s + 428 >> 2];
                                            f: {
                                                if ((f | 0) == (u | 0) | (n | 0) != i[f >> 2] || (k = i[i[n + 4 >> 2] + 24 >> 2], (k | 0) <= 0)) break f;
                                                for(u = 0; e = i[v + 320 >> 2] + Z(u, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), u = u + 1 | 0, (k | 0) != (u | 0););
                                                f = i[s + 424 >> 2], u = i[s + 428 >> 2];
                                            }
                                            k = u - f >> 2;
                                            f: {
                                                if (k >>> 0 < 2) break f;
                                                for(u = 1;;){
                                                    if (e = (u << 2) + f | 0, (n | 0) != i[e >> 2]) {
                                                        if (u = u + 1 | 0, (k | 0) != (u | 0)) continue;
                                                        break f;
                                                    }
                                                    break;
                                                }
                                                if (v = i[e - 4 >> 2], !v | i[v + 40 >> 2] != 2 || (k = k - 1 | 0, !k)) break f;
                                                for(u = 0;;){
                                                    if (e = (u << 2) + f | 0, (v | 0) != i[e >> 2]) {
                                                        if (u = u + 1 | 0, (k | 0) != (u | 0)) continue;
                                                        break f;
                                                    }
                                                    break;
                                                }
                                                if (f = i[e + 4 >> 2], !f || (u = i[i[v + 4 >> 2] + 24 >> 2], (u | 0) >= i[i[f + 4 >> 2] + 24 >> 2])) break f;
                                                for(;;){
                                                    if (e = i[s >> 2], i[e + 144 >> 2] <= (u | 0)) break f;
                                                    if (e = i[e + 320 >> 2] + Z(u, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), u = u + 1 | 0, !((u | 0) < i[i[f + 4 >> 2] + 24 >> 2])) break;
                                                }
                                            }
                                            u = 0;
                                            f: {
                                                k: {
                                                    n: {
                                                        if (!(w | W && (t | 0) > 0)) {
                                                            if (k = 0, w = m - 18608 | 0, m = w, G = i[n + 4 >> 2], t = i[G + 1352 >> 2], (t | 0) != i[G + 1356 >> 2]) {
                                                                for(f = A + 2140 | 0; e = d9(f, i[(k << 2) + t >> 2]), (e | 0) >= 0 && (i[i[i[A + 2148 >> 2] + (e << 2) >> 2] + 100 >> 2] = 0), k = k + 1 | 0, t = i[G + 1352 >> 2], k >>> 0 < i[G + 1356 >> 2] - t >> 2 >>> 0;);
                                                                G = i[n + 4 >> 2];
                                                            }
                                                            if (k = 6, e = i[i[s >> 2] + 132 >> 2], k0[G + 24 >> 2] < i[e + 8452 >> 2] - i[e + 8448 >> 2] >> 2 >>> 0) {
                                                                W = w + 18572 | 0, i[W >> 2] = 0, i[W + 4 >> 2] = 0, i[w + 18516 >> 2] = 0, e = w + 18508 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[w + 18500 >> 2] = 0, i[w + 18504 >> 2] = 0, e = (w + 38 & -16) + 16 | 0, i[w + 2104 >> 2] = e, B0(e, 0, 2048), e = i[n + 4 >> 2], i[w + 18592 >> 2] = e, f = i[s >> 2], i[w + 18600 >> 2] = n, i[w + 18596 >> 2] = s, i[w + 18584 >> 2] = A, i[w + 18588 >> 2] = f, e = i[i[i[f + 132 >> 2] + 8448 >> 2] + (i[e + 24 >> 2] << 2) >> 2], i[w + 18604 >> 2] = 0, i[w + 4 >> 2] = e, vi(w), e = i[n + 12 >> 2];
                                                                t: {
                                                                    if ((e | 0) <= 0) {
                                                                        k = 17;
                                                                        break t;
                                                                    }
                                                                    zi(w + 18548 | 0, i[n + 8 >> 2], e);
                                                                    o: {
                                                                        if (!l[i[i[s >> 2] + 132 >> 2] + 45 | 0] | !l[i[n + 4 >> 2] + 12 | 0]) break o;
                                                                        if (t = i[i[i[A + 2216 >> 2] + 124 >> 2] + 16900 >> 2] - 1 | 0, k = i[s + 472 >> 2], e = i[s + 468 >> 2], f = k - e >> 3, t >>> 0 > f >>> 0) {
                                                                            a5(s + 468 | 0, t - f | 0);
                                                                            break o;
                                                                        }
                                                                        if (f >>> 0 <= t >>> 0) break o;
                                                                        if (e = e + (t << 3) | 0, (e | 0) != (k | 0)) for(; k = C8(k - 8 | 0), (e | 0) != (k | 0););
                                                                        i[s + 472 >> 2] = e;
                                                                    }
                                                                    i[n + 120 >> 2] = 1, k = 0, G = 0, v = i[w + 18588 >> 2], f = i[v + 124 >> 2], h = i[f + 16908 >> 2], e = i[w + 4 >> 2];
                                                                    o: {
                                                                        if ((h | 0) > (e | 0)) {
                                                                            h = i[i[i[v + 132 >> 2] + 8460 >> 2] + (e << 2) >> 2], e = i[f + 16892 >> 2], t = (h | 0) / (e | 0) | 0, e = h - Z(e, t) | 0;
                                                                            break o;
                                                                        }
                                                                        e = i[f + 16892 >> 2], t = (h | 0) / (e | 0) | 0, e = h - Z(t, e) | 0;
                                                                    }
                                                                    i[w + 12 >> 2] = t, i[w + 8 >> 2] = e, i[w >> 2] = h, e = i[w + 18592 >> 2], v = i[v + 132 >> 2], t = 18;
                                                                    o: {
                                                                        s: {
                                                                            u: {
                                                                                if (!N3(w) || (Fi(w + 18548 | 0), t = 0, !(he(w, 0, !l[e + 20 | 0]) & -3))) break u;
                                                                                f = w + 18572 | 0, h = 1;
                                                                                w: {
                                                                                    if (l[v + 46 | 0]) {
                                                                                        if (k = i[w + 18592 >> 2], G = i[k + 804 >> 2], G >>> 0 > 2) break s;
                                                                                        t = 0;
                                                                                        break w;
                                                                                    }
                                                                                    t = 1;
                                                                                }
                                                                                for(;;){
                                                                                    if (!t) {
                                                                                        Ai(f, G, i[k + 800 >> 2]), o[w + 18580 | 0] = 0, o[w + 18581 | 0] = 0, o[w + 18582 | 0] = 0, o[w + 18583 | 0] = 0, t = 1;
                                                                                        continue;
                                                                                    }
                                                                                    for(;;){
                                                                                        e = i[w + 18592 >> 2], k = i[e + 784 >> 2], t = i[e + 788 >> 2] - k >> 2, e = h - 1 | 0;
                                                                                        w: {
                                                                                            if (t >>> 0 > e >>> 0 && i[k + (e << 2) >> 2] == ((i[w + 18552 >> 2] - i[w + 18548 >> 2] | 0) - 2 | 0)) break w;
                                                                                            W2(i[w + 18584 >> 2] + 4 | 0, 1003, 1);
                                                                                        }
                                                                                        if (t = 0, !(he(w, 0, 0) & -3)) break u;
                                                                                        if (h = h + 1 | 0, !!l[v + 46 | 0]) break;
                                                                                    }
                                                                                    if (k = i[w + 18592 >> 2], G = i[k + 804 >> 2], !(G >>> 0 < 3)) break;
                                                                                }
                                                                                break s;
                                                                            }
                                                                            e = t;
                                                                            break o;
                                                                        }
                                                                        y0(18036, 15050, 1520, 4390), z();
                                                                    }
                                                                    k = e, i[n + 44 >> 2] <= 0 && (i[n + 44 >> 2] = 1);
                                                                }
                                                                C8(W);
                                                            }
                                                            if (m = w + 18608 | 0, f = k, i[n + 40 >> 2] = 2, t = i[s + 424 >> 2], k = (i[s + 428 >> 2] - t >> 2) - 1 | 0, !k) break n;
                                                            for(;;){
                                                                if (e = t + (u << 2) | 0, (n | 0) != i[e >> 2]) {
                                                                    if (u = u + 1 | 0, (k | 0) != (u | 0)) continue;
                                                                    break n;
                                                                }
                                                                break;
                                                            }
                                                            if (k = i[e + 4 >> 2], !k || (u = i[i[n + 4 >> 2] + 24 >> 2], (u | 0) >= i[i[k + 4 >> 2] + 24 >> 2])) break n;
                                                            for(;;){
                                                                if (e = i[s >> 2], i[e + 144 >> 2] <= (u | 0)) break n;
                                                                if (e = i[e + 320 >> 2] + Z(u, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), u = u + 1 | 0, !((u | 0) < i[i[k + 4 >> 2] + 24 >> 2])) break;
                                                            }
                                                            break n;
                                                        }
                                                        if (W && (f = 1006, w)) break n;
                                                        if (W) {
                                                            t: {
                                                                if (C = i[s >> 2], i[C + 332 >> 2] == (0 - i[C + 328 >> 2] | 0)) {
                                                                    w = i[n + 4 >> 2], E = i[w + 776 >> 2], h = i[C + 132 >> 2], e = i[C + 124 >> 2], W = i[e + 16892 >> 2];
                                                                    o: {
                                                                        if (!l[w + 12 | 0]) break o;
                                                                        if (t = i[e + 16900 >> 2] - 1 | 0, e = i[s + 472 >> 2], f = i[s + 468 >> 2], k = e - f >> 3, t >>> 0 > k >>> 0) {
                                                                            a5(s + 468 | 0, t - k | 0);
                                                                            break o;
                                                                        }
                                                                        if (k >>> 0 <= t >>> 0) break o;
                                                                        if (f = f + (t << 3) | 0, (f | 0) != (e | 0)) for(; e = C8(e - 8 | 0), (f | 0) != (e | 0););
                                                                        i[s + 472 >> 2] = f;
                                                                    }
                                                                    if (i[n + 132 >> 2]) break e;
                                                                    v = E + 1 | 0, y = D((t0 = -1, s0 = O0(v, 0, 18608, 0) | 4, L = w0, L ? t0 : s0)), i[y >> 2] = v, f = y + 4 | 0;
                                                                    o: {
                                                                        if (!v) {
                                                                            i[n + 136 >> 2] = v, i[n + 132 >> 2] = f;
                                                                            break o;
                                                                        }
                                                                        for(t = f + Z(v, 18608) | 0, e = f; k = e + 18572 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[e + 18516 >> 2] = 0, k = e + 18508 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[e + 18500 >> 2] = 0, i[e + 18504 >> 2] = 0, i[e + 18584 >> 2] = 0, i[e + 18588 >> 2] = 0, k = e + 18592 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[e + 18600 >> 2] = 0, k = (e + 38 & -15) + 16 | 0, i[e + 2104 >> 2] = k, B0(k, 0, 2048), e = e + 18608 | 0, (t | 0) != (e | 0););
                                                                        if (i[n + 136 >> 2] = v, i[n + 132 >> 2] = f, (E | 0) < 0) break o;
                                                                        if (k = i[w + 24 >> 2], V = (k | 0) / (W | 0) | 0, E) {
                                                                            if (k - Z(W, V) | 0) break o;
                                                                            if ((E | 0) == 2147483647) break i;
                                                                        }
                                                                        if (i[y + 18596 >> 2] = w, e = i[C + 112 >> 2], i[y + 18604 >> 2] = n, i[y + 18600 >> 2] = s, i[y + 18592 >> 2] = C, i[y + 18588 >> 2] = e, i[y + 8 >> 2] = i[i[h + 8448 >> 2] + (k << 2) >> 2], vi(f), v = n + 12 | 0, e = v, E && (e = i[w + 784 >> 2]), e = i[e >> 2], (e | 0) > i[v >> 2] || (k = 1, (e | 0) <= 0) || (zi(y + 18552 | 0, i[n + 8 >> 2], e), i[C + 324 >> 2] = i[C + 324 >> 2] + 1, i[C + 340 >> 2] = i[C + 340 >> 2] + 1, i[n + 120 >> 2] = i[n + 120 >> 2] + 1, Gn(A, f, 1, V), !E)) break o;
                                                                        for(;;){
                                                                            if (i[n + 136 >> 2] <= (k | 0)) break i;
                                                                            if (y = i[n + 132 >> 2] + Z(k, 18608) | 0, i[y + 18592 >> 2] = w, e = i[C + 112 >> 2], i[y + 18600 >> 2] = n, i[y + 18596 >> 2] = s, i[y + 18588 >> 2] = C, i[y + 18584 >> 2] = e, V = V + 1 | 0, i[y + 4 >> 2] = i[i[h + 8448 >> 2] + (Z(W, V) << 2) >> 2], vi(y), f = k << 2, e = i[w + 784 >> 2], t = i[(f + e | 0) - 4 >> 2], (t | 0) < 0 || (f = e + f | 0, e = (k | 0) != (E | 0), f = i[(e ? f : v) >> 2], (f | 0) > i[v >> 2] | (f | 0) <= (t | 0))) break o;
                                                                            if (zi(y + 18548 | 0, t + i[n + 8 >> 2] | 0, f - t | 0), i[C + 324 >> 2] = i[C + 324 >> 2] + 1, i[C + 340 >> 2] = i[C + 340 >> 2] + 1, i[n + 120 >> 2] = i[n + 120 >> 2] + 1, Gn(A, y, 0, V), k = k + 1 | 0, !e) break;
                                                                        }
                                                                    }
                                                                    if (sr(C), f = i[s + 460 >> 2], k = i[s + 456 >> 2], (f | 0) != (k | 0)) for(e = 0; t = i[(e << 2) + k >> 2], t && (p[i[i[t >> 2] + 4 >> 2]](t), k = i[s + 456 >> 2], f = i[s + 460 >> 2]), e = e + 1 | 0, e >>> 0 < f - k >> 2 >>> 0;);
                                                                    i[s + 460 >> 2] = k;
                                                                    break t;
                                                                }
                                                                y0(18432, 14908, 1003, 16022), z();
                                                            }
                                                            if (i[n + 40 >> 2] = 2, f = 0, t = i[s + 424 >> 2], k = (i[s + 428 >> 2] - t >> 2) - 1 | 0, !k) break n;
                                                            for(;;){
                                                                if (e = t + (u << 2) | 0, (n | 0) != i[e >> 2]) {
                                                                    if (u = u + 1 | 0, (k | 0) != (u | 0)) continue;
                                                                    break n;
                                                                }
                                                                break;
                                                            }
                                                            if (k = i[e + 4 >> 2], !k || (u = i[i[n + 4 >> 2] + 24 >> 2], (u | 0) >= i[i[k + 4 >> 2] + 24 >> 2])) break n;
                                                            for(;;){
                                                                if (e = i[s >> 2], i[e + 144 >> 2] <= (u | 0)) break n;
                                                                if (e = i[e + 320 >> 2] + Z(u, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), u = u + 1 | 0, !((u | 0) < i[i[k + 4 >> 2] + 24 >> 2])) break;
                                                            }
                                                            break n;
                                                        }
                                                        if (!w) break k;
                                                        t = s;
                                                        t: {
                                                            if (R = i[t >> 2], i[R + 332 >> 2] == (0 - i[R + 328 >> 2] | 0)) {
                                                                if (i[n + 132 >> 2]) break e;
                                                                V = i[R + 132 >> 2], B = i[i[R + 124 >> 2] + 16892 >> 2], C = i[n + 4 >> 2], _ = i[C + 776 >> 2], v = _ + 1 | 0, W = D((t0 = -1, s0 = O0(v, 0, 18608, 0) | 4, L = w0, L ? t0 : s0)), i[W >> 2] = v, f = W + 4 | 0;
                                                                o: {
                                                                    if (!v) {
                                                                        i[n + 136 >> 2] = v, i[n + 132 >> 2] = f;
                                                                        break o;
                                                                    }
                                                                    for(k = f + Z(v, 18608) | 0, s = f; e = s + 18572 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[s + 18516 >> 2] = 0, e = s + 18508 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[s + 18500 >> 2] = 0, i[s + 18504 >> 2] = 0, i[s + 18584 >> 2] = 0, i[s + 18588 >> 2] = 0, e = s + 18592 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[s + 18600 >> 2] = 0, e = (s + 38 & -15) + 16 | 0, i[s + 2104 >> 2] = e, B0(e, 0, 2048), s = s + 18608 | 0, (k | 0) != (s | 0););
                                                                    if (i[n + 136 >> 2] = v, i[n + 132 >> 2] = f, (_ | 0) < 0) break o;
                                                                    if ((_ | 0) == 2147483647) break i;
                                                                    if (v = i[C + 24 >> 2], k = v << 2, s = i[k + i[V + 8484 >> 2] >> 2], i[W + 18596 >> 2] = C, e = i[R + 112 >> 2], i[W + 18604 >> 2] = n, i[W + 18600 >> 2] = t, i[W + 18592 >> 2] = R, i[W + 18588 >> 2] = e, i[W + 8 >> 2] = i[k + i[V + 8448 >> 2] >> 2], vi(f), y = n + 12 | 0, e = y, _ && (e = i[C + 784 >> 2]), e = i[e >> 2], (e | 0) > i[y >> 2]) {
                                                                        h = 17;
                                                                        break o;
                                                                    }
                                                                    if (k = 1, (e | 0) <= 0) {
                                                                        h = 17;
                                                                        break o;
                                                                    }
                                                                    if (zi(W + 18552 | 0, i[n + 8 >> 2], e), i[R + 324 >> 2] = i[R + 324 >> 2] + 1, i[R + 340 >> 2] = i[R + 340 >> 2] + 1, i[n + 120 >> 2] = i[n + 120 >> 2] + 1, e = (v | 0) / (B | 0) | 0, Bn(A, f, 1, v - Z(e, B) | 0, e), !_) break o;
                                                                    for(w = V + 8404 | 0, W = V + 8360 | 0;;){
                                                                        if (s = s + 1 | 0, f = i[V + 48 >> 2], (s | 0) >= (Z(f, i[V + 52 >> 2]) | 0)) {
                                                                            h = 1007;
                                                                            break o;
                                                                        }
                                                                        if (i[n + 136 >> 2] <= (k | 0)) break i;
                                                                        if (e = (s | 0) / (f | 0) | 0, v = i[w + (e << 2) >> 2], f = i[W + (s - Z(e, f) << 2) >> 2], H = i[n + 132 >> 2] + Z(k, 18608) | 0, i[H + 18592 >> 2] = C, e = i[R + 112 >> 2], i[H + 18600 >> 2] = n, i[H + 18596 >> 2] = t, i[H + 18588 >> 2] = R, i[H + 18584 >> 2] = e, v = f + Z(v, B) | 0, i[H + 4 >> 2] = i[i[V + 8448 >> 2] + (v << 2) >> 2], vi(H), f = k << 2, e = i[C + 784 >> 2], E = i[(f + e | 0) - 4 >> 2], (E | 0) < 0) {
                                                                            h = 17;
                                                                            break o;
                                                                        }
                                                                        if (e = i[((k | 0) != (_ | 0) ? e + f | 0 : y) >> 2], (e | 0) > i[y >> 2]) {
                                                                            h = 17;
                                                                            break o;
                                                                        }
                                                                        if ((e | 0) <= (E | 0)) {
                                                                            h = 17;
                                                                            break o;
                                                                        }
                                                                        if (zi(H + 18548 | 0, E + i[n + 8 >> 2] | 0, e - E | 0), i[R + 324 >> 2] = i[R + 324 >> 2] + 1, i[R + 340 >> 2] = i[R + 340 >> 2] + 1, i[n + 120 >> 2] = i[n + 120 >> 2] + 1, e = (v | 0) / (B | 0) | 0, Bn(A, H, 0, v - Z(e, B) | 0, e), e = (k | 0) != (_ | 0), k = k + 1 | 0, !e) break;
                                                                    }
                                                                }
                                                                if (sr(R), f = i[t + 460 >> 2], k = i[t + 456 >> 2], (f | 0) != (k | 0)) for(s = 0; e = i[(s << 2) + k >> 2], e && (p[i[i[e >> 2] + 4 >> 2]](e), k = i[t + 456 >> 2], f = i[t + 460 >> 2]), s = s + 1 | 0, s >>> 0 < f - k >> 2 >>> 0;);
                                                                i[t + 460 >> 2] = k, f = h;
                                                                break t;
                                                            }
                                                            y0(18432, 14908, 1117, 4642), z();
                                                        }
                                                        if (i[n + 40 >> 2] = 2, s = i[t + 424 >> 2], k = (i[t + 428 >> 2] - s >> 2) - 1 | 0, !k) break n;
                                                        for(;;){
                                                            if (e = s + (u << 2) | 0, (n | 0) != i[e >> 2]) {
                                                                if (u = u + 1 | 0, (k | 0) != (u | 0)) continue;
                                                                break n;
                                                            }
                                                            break;
                                                        }
                                                        if (k = i[e + 4 >> 2], !k || (u = i[i[n + 4 >> 2] + 24 >> 2], (u | 0) >= i[i[k + 4 >> 2] + 24 >> 2])) break n;
                                                        for(;;){
                                                            if (e = i[t >> 2], i[e + 144 >> 2] <= (u | 0)) break n;
                                                            if (e = i[e + 320 >> 2] + Z(u, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), u = u + 1 | 0, !((u | 0) < i[i[k + 4 >> 2] + 24 >> 2])) break;
                                                        }
                                                    }
                                                    e = f;
                                                    break f;
                                                }
                                                y0(10076, 14908, 985, 8268), z();
                                            }
                                            if (e) break r;
                                            e = i[A + 3208 >> 2], u = i[A + 3212 >> 2];
                                        }
                                        A: {
                                            if (u - e >>> 0 >= 5 && (h = i[e >> 2], f = i[h + 428 >> 2], i[i[f - 4 >> 2] + 40 >> 2] | (f | 0) == i[h + 424 >> 2])) break A;
                                            if ((e | 0) == (u | 0)) return 0;
                                            if (h = i[e >> 2], f = i[h + 428 >> 2], (f | 0) != i[h + 424 >> 2] && (e = 0, !i[i[f - 4 >> 2] + 40 >> 2]) || (e = 0, i[A + 580 >> 2] != ((i[A + 556 >> 2] ? -1 : 0) | 0))) break r;
                                            if (l[A + 548 | 0]) break A;
                                            if (l[A + 549 | 0] != 1) break r;
                                        }
                                        if (o[r | 0] = 1, e = i[h >> 2], i[e + 144 >> 2] > 0) for(G = 0; r = i[e + 320 >> 2] + Z(G, 76) | 0, i[r >> 2] <= 0 && (i[r >> 2] = 1), G = G + 1 | 0, (G | 0) < i[e + 144 >> 2];);
                                        _ = i[h >> 2], r = i[_ + 112 >> 2], f = l[r + 532 | 0];
                                        A: {
                                            if (i[i[i[A + 2216 >> 2] + 112 >> 2] + 1884 >> 2]) {
                                                if (e = 1, !(f & 1)) {
                                                    G = 0, w = i[h >> 2], e = i[w + 112 >> 2], r = i[i[w + 124 >> 2] + 16900 >> 2] << 1, i[w + 324 >> 2] = r + i[w + 324 >> 2], i[w + 340 >> 2] = r + i[w + 340 >> 2];
                                                    f: {
                                                        if (i[i[w + 124 >> 2] + 16900 >> 2] <= 0) break f;
                                                        v = e + 1392 | 0;
                                                        k: {
                                                            n: {
                                                                for(;;){
                                                                    W = D(20), o[W + 16 | 0] = 1, i[W + 12 >> 2] = G, i[W + 8 >> 2] = w, i[W >> 2] = 48188, i[W + 4 >> 2] = 0, r = i[h + 460 >> 2], f = i[h + 464 >> 2];
                                                                    t: {
                                                                        if (r >>> 0 < f >>> 0) {
                                                                            i[r >> 2] = W, t = r + 4 | 0;
                                                                            break t;
                                                                        }
                                                                        if (e = i[h + 456 >> 2], k = r - e >> 2, t = k + 1 | 0, t >>> 0 >= 1073741824) break n;
                                                                        if (n = f - e | 0, f = n >> 1, n = n >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 > t >>> 0 ? f : t, n) {
                                                                            if (n >>> 0 >= 1073741824) break k;
                                                                            f = D(n << 2);
                                                                        } else f = 0;
                                                                        if (s = f + (k << 2) | 0, i[s >> 2] = W, t = s + 4 | 0, (r | 0) != (e | 0)) {
                                                                            for(; s = s - 4 | 0, r = r - 4 | 0, i[s >> 2] = i[r >> 2], (r | 0) != (e | 0););
                                                                            e = i[h + 456 >> 2];
                                                                        }
                                                                        if (i[h + 464 >> 2] = f + (n << 2), i[h + 460 >> 2] = t, i[h + 456 >> 2] = s, !e) break t;
                                                                        X(e);
                                                                    }
                                                                    if (i[h + 460 >> 2] = t, Ii(v, W), G = G + 1 | 0, r = i[i[w + 124 >> 2] + 16900 >> 2], !((G | 0) < (r | 0))) break;
                                                                }
                                                                if ((r | 0) <= 0) break f;
                                                                for(G = 0;;){
                                                                    W = D(20), o[W + 16 | 0] = 0, i[W + 12 >> 2] = G, i[W + 8 >> 2] = w, i[W >> 2] = 48188, i[W + 4 >> 2] = 0, r = i[h + 460 >> 2], f = i[h + 464 >> 2];
                                                                    t: {
                                                                        if (r >>> 0 >= f >>> 0) {
                                                                            if (e = i[h + 456 >> 2], k = r - e >> 2, t = k + 1 | 0, t >>> 0 > 1073741823) break n;
                                                                            if (n = f - e | 0, f = n >> 1, n = n >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 > t >>> 0 ? f : t, n) {
                                                                                if (n >>> 0 > 1073741823) break k;
                                                                                f = D(n << 2);
                                                                            } else f = 0;
                                                                            if (s = f + (k << 2) | 0, i[s >> 2] = W, t = s + 4 | 0, (r | 0) != (e | 0)) {
                                                                                for(; s = s - 4 | 0, r = r - 4 | 0, i[s >> 2] = i[r >> 2], (r | 0) != (e | 0););
                                                                                e = i[h + 456 >> 2];
                                                                            }
                                                                            if (i[h + 464 >> 2] = f + (n << 2), i[h + 460 >> 2] = t, i[h + 456 >> 2] = s, !e) break t;
                                                                            X(e);
                                                                            break t;
                                                                        }
                                                                        i[r >> 2] = W, t = r + 4 | 0;
                                                                    }
                                                                    if (i[h + 460 >> 2] = t, Ii(v, W), G = G + 1 | 0, !((G | 0) < i[i[w + 124 >> 2] + 16900 >> 2])) break;
                                                                }
                                                                break f;
                                                            }
                                                            p0(), z();
                                                        }
                                                        Z2(), z();
                                                    }
                                                    e = 3, r = i[_ + 112 >> 2];
                                                }
                                                if (!l[r + 533 | 0]) f: {
                                                    f = e, C = m - 16 | 0, m = C;
                                                    k: {
                                                        n: {
                                                            B = i[h >> 2], y = i[B + 124 >> 2];
                                                            t: {
                                                                if (!l[y + 8799 | 0]) break t;
                                                                if (E = i[B + 20 >> 2], w = i[B + 28 >> 2], v = i[B + 24 >> 2], r = i[B + 112 >> 2], i[C + 8 >> 2] = y, n = i[B + 128 >> 2], i[C + 12 >> 2] = n, e = r, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = i[B + 112 >> 2]), s = i[B + 288 >> 2], t = i[B + 280 >> 2], k = i[B + 284 >> 2], n = i[C + 12 >> 2], i[C >> 2] = i[C + 8 >> 2], i[C + 4 >> 2] = n, W = h + 8 | 0, z7(W, v, w, E, C, 0, e, t, k, s, 1)) {
                                                                    W2(i[B + 112 >> 2] + 4 | 0, 1024, 0);
                                                                    break t;
                                                                }
                                                                if (v = i[y + 16900 >> 2], e = v, i[B + 324 >> 2] = e + i[B + 324 >> 2], i[B + 340 >> 2] = e + i[B + 340 >> 2], (e | 0) > 0) for(s = r + 1392 | 0, w = 0;;){
                                                                    E = D(28), i[E + 20 >> 2] = W, i[E + 16 >> 2] = B, i[E >> 2] = 50360, i[E + 4 >> 2] = 0, i[E + 12 >> 2] = B, i[E + 24 >> 2] = f, i[E + 8 >> 2] = w, G = i[h + 460 >> 2], r = i[h + 464 >> 2];
                                                                    o: {
                                                                        if (G >>> 0 < r >>> 0) {
                                                                            i[G >> 2] = E, V = G + 4 | 0;
                                                                            break o;
                                                                        }
                                                                        if (e = i[h + 456 >> 2], k = G - e >> 2, t = k + 1 | 0, t >>> 0 >= 1073741824) break n;
                                                                        if (n = r - e | 0, r = n >> 1, n = n >>> 0 >= 2147483644 ? 1073741823 : r >>> 0 > t >>> 0 ? r : t, n) {
                                                                            if (n >>> 0 >= 1073741824) break k;
                                                                            r = D(n << 2);
                                                                        } else r = 0;
                                                                        if (t = r + (k << 2) | 0, i[t >> 2] = E, V = t + 4 | 0, (e | 0) != (G | 0)) {
                                                                            for(; t = t - 4 | 0, G = G - 4 | 0, i[t >> 2] = i[G >> 2], (e | 0) != (G | 0););
                                                                            e = i[h + 456 >> 2];
                                                                        }
                                                                        if (i[h + 464 >> 2] = r + (n << 2), i[h + 460 >> 2] = V, i[h + 456 >> 2] = t, !e) break o;
                                                                        X(e);
                                                                    }
                                                                    if (i[h + 460 >> 2] = V, Ii(s, E), w = w + 1 | 0, (v | 0) == (w | 0)) break;
                                                                }
                                                                sr(B), r = i[B + 4 >> 2], i[B + 4 >> 2] = i[h + 12 >> 2], i[h + 12 >> 2] = r, r = i[B + 64 >> 2], i[B + 64 >> 2] = i[h + 72 >> 2], i[h + 72 >> 2] = r, r = i[B + 292 >> 2], i[B + 292 >> 2] = i[h + 300 >> 2], i[h + 300 >> 2] = r, r = i[B + 8 >> 2], i[B + 8 >> 2] = i[h + 16 >> 2], i[h + 16 >> 2] = r, r = i[B + 68 >> 2], i[B + 68 >> 2] = i[h + 76 >> 2], i[h + 76 >> 2] = r, r = i[B + 296 >> 2], i[B + 296 >> 2] = i[h + 304 >> 2], i[h + 304 >> 2] = r, r = i[B + 12 >> 2], i[B + 12 >> 2] = i[h + 20 >> 2], i[h + 20 >> 2] = r, r = i[B + 72 >> 2], i[B + 72 >> 2] = i[h + 80 >> 2], i[h + 80 >> 2] = r, r = i[B + 300 >> 2], i[B + 300 >> 2] = i[h + 308 >> 2], i[h + 308 >> 2] = r, r = i[B + 40 >> 2], i[B + 40 >> 2] = i[h + 48 >> 2], i[h + 48 >> 2] = r, r = i[B + 44 >> 2], i[B + 44 >> 2] = i[h + 52 >> 2], i[h + 52 >> 2] = r, f = i[B + 304 >> 2], e = i[B + 308 >> 2], r = i[h + 316 >> 2], i[B + 304 >> 2] = i[h + 312 >> 2], i[B + 308 >> 2] = r, i[h + 312 >> 2] = f, i[h + 316 >> 2] = e;
                                                            }
                                                            m = C + 16 | 0;
                                                            break f;
                                                        }
                                                        p0(), z();
                                                    }
                                                    Z2(), z();
                                                }
                                                sr(_);
                                                break A;
                                            }
                                            if (!(f & 1)) {
                                                e = 0, f = 0;
                                                f: {
                                                    if (i[i[_ + 124 >> 2] + 16900 >> 2] <= 0) break f;
                                                    for(; f = O7(_, e) | f, e = e + 1 | 0, (e | 0) < i[i[_ + 124 >> 2] + 16900 >> 2];);
                                                    if (!(f & 1)) break f;
                                                    X3(_, 1, 0, i[_ + 276 >> 2], i[_ + 272 >> 2]), e = i[_ + 272 >> 2], r = i[_ + 276 >> 2];
                                                    k: {
                                                        if (i[i[_ + 124 >> 2] + 16832 >> 2] >= 9) {
                                                            _3(_, 1, 0, r, e);
                                                            break k;
                                                        }
                                                        m3(_, 1, 0, r, e);
                                                    }
                                                    r = i[_ + 124 >> 2];
                                                    k: {
                                                        if (!i[r + 16848 >> 2]) break k;
                                                        if (f = i[_ + 272 >> 2], e = i[_ + 276 >> 2], i[r + 16840 >> 2] >= 9) {
                                                            G3(_, 1, 0, e, f);
                                                            break k;
                                                        }
                                                        W3(_, 1, 0, e, f);
                                                    }
                                                    X3(_, 0, 0, i[_ + 276 >> 2], i[_ + 272 >> 2]), e = i[_ + 272 >> 2], r = i[_ + 276 >> 2];
                                                    k: {
                                                        if (i[i[_ + 124 >> 2] + 16832 >> 2] >= 9) {
                                                            _3(_, 0, 0, r, e);
                                                            break k;
                                                        }
                                                        m3(_, 0, 0, r, e);
                                                    }
                                                    if (r = i[_ + 124 >> 2], !i[r + 16848 >> 2]) break f;
                                                    if (f = i[_ + 272 >> 2], e = i[_ + 276 >> 2], i[r + 16840 >> 2] >= 9) {
                                                        G3(_, 0, 0, e, f);
                                                        break f;
                                                    }
                                                    W3(_, 0, 0, e, f);
                                                }
                                                r = i[_ + 112 >> 2];
                                            }
                                            if (l[r + 533 | 0]) break A;
                                            if (B = i[_ + 124 >> 2], l[B + 8799 | 0]) {
                                                for(e = Z(Z(i[_ + 28 >> 2], i[_ + 40 >> 2]), (i[B + 16832 >> 2] + 7 | 0) / 8 | 0), r = Z(Z(i[_ + 36 >> 2], i[_ + 44 >> 2]), (i[B + 16840 >> 2] + 7 | 0) / 8 | 0), w = D((r | 0) < (e | 0) ? e : r), W = i[B + 16848 >> 2] ? 3 : 1, v = _ + 4 | 0, e = i[B + 16900 >> 2], u = 0;;){
                                                    f: {
                                                        s = v + (u << 2) | 0, k = _ + (u ? 44 : 40) | 0, y = i[k >> 2], C = v0(w, i[s >> 2], Z(Z(y, i[_ + (u ? 36 : 28) >> 2]), (i[i[_ + 124 >> 2] + (u ? 16840 : 16832) >> 2] + 7 | 0) / 8 | 0));
                                                        k: {
                                                            if ((e | 0) <= 0 || (r = 0, t = i[B + 16892 >> 2], (t | 0) <= 0)) break k;
                                                            for(;;){
                                                                n: {
                                                                    if ((t | 0) <= 0) break n;
                                                                    if (e = 0, !u) for(;;){
                                                                        if (f = I[((i[_ + 140 >> 2] + Z(Z(i[_ + 152 >> 2], r), 24) | 0) + Z(e, 24) | 0) + 2 >> 1], n = i[_ + 52 >> 2], f >>> 0 >= i[_ + 56 >> 2] - n >> 2 >>> 0 || (f = i[n + (f << 2) >> 2], !f)) break f;
                                                                        t: {
                                                                            if (!l[f + 333 | 0]) break t;
                                                                            if (t = 1 << i[B + 16876 >> 2], n = i[_ + 40 >> 2], f = i[_ + 4 >> 2], i[i[_ + 124 >> 2] + 16832 >> 2] <= 8) {
                                                                                ni(_, e, r, 0, t, t, C, y, f, n);
                                                                                break t;
                                                                            }
                                                                            ki(_, e, r, 0, t, t, C, y, f, n);
                                                                        }
                                                                        if (e = e + 1 | 0, t = i[B + 16892 >> 2], !((e | 0) < (t | 0))) break n;
                                                                    }
                                                                    for(;;){
                                                                        if (f = I[((i[_ + 140 >> 2] + Z(Z(i[_ + 152 >> 2], r), 24) | 0) + Z(e, 24) | 0) + 2 >> 1], n = i[_ + 52 >> 2], f >>> 0 >= i[_ + 56 >> 2] - n >> 2 >>> 0 || (f = i[n + (f << 2) >> 2], !f)) break f;
                                                                        t: {
                                                                            if (!l[f + 334 | 0]) break t;
                                                                            if (f = 1 << i[B + 16876 >> 2], E = (f | 0) / i[B + 16856 >> 2] | 0, t = (f | 0) / i[B + 16852 >> 2] | 0, n = i[k >> 2], f = i[s >> 2], i[i[_ + 124 >> 2] + 16840 >> 2] >= 9) {
                                                                                ki(_, e, r, u, t, E, C, y, f, n);
                                                                                break t;
                                                                            }
                                                                            ni(_, e, r, u, t, E, C, y, f, n);
                                                                        }
                                                                        if (e = e + 1 | 0, t = i[B + 16892 >> 2], !((e | 0) < (t | 0))) break;
                                                                    }
                                                                }
                                                                if (r = r + 1 | 0, e = i[B + 16900 >> 2], !((r | 0) < (e | 0))) break;
                                                            }
                                                        }
                                                        if (u = u + 1 | 0, (W | 0) != (u | 0)) continue;
                                                    }
                                                    break;
                                                }
                                                X(C);
                                            }
                                        }
                                        r = i[h + 436 >> 2];
                                        A: {
                                            if ((r | 0) == i[h + 440 >> 2]) {
                                                e = 0;
                                                break A;
                                            }
                                            for(G = 0;;){
                                                e = 0, t = 0, F = m - 176 | 0, m = F, c = Z(G, 80) + r | 0, S = i[h >> 2];
                                                f: {
                                                    if (i[c >> 2] != 132 | l[i[S + 112 >> 2] + 512 | 0] != 1 | !l[S + 104 | 0]) break f;
                                                    for(_ = c + 12 | 0, B = c + 60 | 0, C = c + 68 | 0, y = S + 4 | 0, E = i[i[S + 124 >> 2] + 476 >> 2];;){
                                                        P = i[S + (t ? 44 : 40) >> 2], T = i[S + (t ? 36 : 28) >> 2], M = i[S + (t ? 32 : 24) >> 2], W = t << 2, $ = i[W + y >> 2];
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    o: switch(i[c + 8 >> 2]){
                                                                        case 0:
                                                                            r = i[i[S + 124 >> 2] + (t ? 16840 : 16832) >> 2], i[F + 40 >> 2] = -1732584194, i[F + 44 >> 2] = 271733878, i[F + 32 >> 2] = 1732584193, i[F + 36 >> 2] = -271733879, i[F + 24 >> 2] = 0, i[F + 28 >> 2] = 0;
                                                                            s: {
                                                                                if ((T | 0) > 0) {
                                                                                    if ((r | 0) >= 9) {
                                                                                        w = M << 1;
                                                                                        u: {
                                                                                            if ((M | 0) <= 0) {
                                                                                                for(r = 0; r || (r = D(w)), XA(F + 24 | 0, r, w), e = e + 1 | 0, (T | 0) != (e | 0););
                                                                                                break u;
                                                                                            }
                                                                                            for(s = M & 2147483646, k = M & 1, V = 0, r = 0;;){
                                                                                                if (r || (r = D(w)), W = $ + (Z(V, P) << 1) | 0, e = 0, u = 0, (M | 0) != 1) for(; v = e << 1, n = v + r | 0, f = v + W | 0, o[n | 0] = l[f | 0], o[n + 1 | 0] = l[f + 1 | 0], f = v | 2, n = f + r | 0, f = f + W | 0, o[n | 0] = l[f | 0], o[n + 1 | 0] = l[f + 1 | 0], e = e + 2 | 0, u = u + 2 | 0, (s | 0) != (u | 0););
                                                                                                if (k && (e = e << 1, f = e + r | 0, e = e + W | 0, o[f | 0] = l[e | 0], o[f + 1 | 0] = l[e + 1 | 0]), XA(F + 24 | 0, r, w), V = V + 1 | 0, (T | 0) == (V | 0)) break;
                                                                                            }
                                                                                        }
                                                                                        Cn(F, F + 24 | 0), X(r);
                                                                                        break s;
                                                                                    }
                                                                                    for(; XA(F + 24 | 0, $ + Z(e, P) | 0, M), e = e + 1 | 0, (T | 0) != (e | 0););
                                                                                }
                                                                                Cn(F, F + 24 | 0);
                                                                            }
                                                                            r = _ + (t << 4) | 0;
                                                                            s: {
                                                                                if (l[F | 0] != l[r | 0] | l[F + 1 | 0] != l[r + 1 | 0] | (l[F + 2 | 0] != l[r + 2 | 0] | l[F + 3 | 0] != l[r + 3 | 0]) || l[F + 4 | 0] != l[r + 4 | 0] | l[F + 5 | 0] != l[r + 5 | 0] | (l[F + 6 | 0] != l[r + 6 | 0] | l[F + 7 | 0] != l[r + 7 | 0]) || l[F + 8 | 0] != l[r + 8 | 0] | l[F + 9 | 0] != l[r + 9 | 0] | (l[F + 10 | 0] != l[r + 10 | 0] | l[F + 11 | 0] != l[r + 11 | 0]) || l[F + 12 | 0] != l[r + 12 | 0] | l[F + 13 | 0] != l[r + 13 | 0] | l[F + 14 | 0] != l[r + 14 | 0]) break s;
                                                                                if (l[F + 15 | 0] == l[r + 15 | 0]) break k;
                                                                            }
                                                                            e = 5;
                                                                            break f;
                                                                        case 1:
                                                                            if (e = 7439, (T | 0) <= 0) break n;
                                                                            if (i[i[S + 124 >> 2] + (t ? 16840 : 16832) >> 2] < 9) break t;
                                                                            if (r0 = M << 1, (M | 0) <= 0) {
                                                                                for(e = 0, f = 0; f || (f = D(r0)), e = e + 1 | 0, (T | 0) != (e | 0););
                                                                                e = 7439, X(f);
                                                                                break n;
                                                                            }
                                                                            for(w = M & 2147483646, W = M & 1, R = (r0 | 0) <= 1 ? 1 : r0, v = R & 2147483646, s = R & 1, f0 = 0, f = 0;;){
                                                                                if (f || (f = D(r0)), u = $ + (Z(P, f0) << 1) | 0, r = 0, H = 0, (M | 0) != 1) for(; V = r << 1, k = V + f | 0, n = u + V | 0, o[k | 0] = l[n | 0], o[k + 1 | 0] = l[n + 1 | 0], n = V | 2, k = n + f | 0, n = n + u | 0, o[k | 0] = l[n | 0], o[k + 1 | 0] = l[n + 1 | 0], r = r + 2 | 0, H = H + 2 | 0, (w | 0) != (H | 0););
                                                                                if (W && (r = r << 1, n = r + f | 0, r = r + u | 0, o[n | 0] = l[r | 0], o[n + 1 | 0] = l[r + 1 | 0]), r = 0, u = 0, (R | 0) != 1) for(; V = e << 8, n = r + f | 0, e = l[n | 0] ^ (e & 65280) >>> 8, k = e >>> 4 ^ e, e = (V | k) ^ k << 5, V = e << 8, e = l[n + 1 | 0] ^ ((e ^ k << 12) & 65280) >>> 8, e = e >>> 4 ^ e, e = (V | e) ^ e << 5 ^ e << 12, r = r + 2 | 0, u = u + 2 | 0, (v | 0) != (u | 0););
                                                                                if (s && (r = l[r + f | 0] ^ (e & 65280) >>> 8, r = r >>> 4 ^ r, e = (r | e << 8) ^ r << 5 ^ r << 12), f0 = f0 + 1 | 0, (T | 0) == (f0 | 0)) break;
                                                                            }
                                                                            X(f);
                                                                            break n;
                                                                        case 2:
                                                                            break o;
                                                                        default:
                                                                            break k;
                                                                    }
                                                                    r = (M | 0) > 0 & (T | 0) > 0;
                                                                    o: {
                                                                        if (i[i[S + 124 >> 2] + (t ? 16840 : 16832) >> 2] >= 9) {
                                                                            if (f = 0, !r) break o;
                                                                            for(v = M & 2147483646, s = M & 1, r = 0;;){
                                                                                if (V = $ + Z(r, P) | 0, e = 0, u = 0, (M | 0) != 1) for(; k = (r ^ e) >>> 8 ^ r, n = e | 1, w = (k ^ n) & 255, R = f, f = (e ^ k) & 255, f = (w + ((R + f | 0) + (f ^ l[e + V | 0]) | 0) | 0) + (w ^ l[n + V | 0]) | 0, e = e + 2 | 0, u = u + 2 | 0, (v | 0) != (u | 0););
                                                                                if (s && (k = f, f = ((r ^ e) >>> 8 ^ r ^ e) & 255, f = (k + f | 0) + (f ^ l[e + V | 0]) | 0), r = r + 1 | 0, (T | 0) == (r | 0)) break;
                                                                            }
                                                                            break o;
                                                                        }
                                                                        if (f = 0, !r) break o;
                                                                        for(v = M & 2147483646, s = M & 1, r = 0;;){
                                                                            if (w = $ + Z(r, P) | 0, e = 0, u = 0, (M | 0) != 1) for(; k = (r ^ e) >>> 8 ^ r, n = e | 1, f = ((k ^ n) & 255 ^ l[n + w | 0]) + ((l[e + w | 0] ^ (e ^ k) & 255) + f | 0) | 0, e = e + 2 | 0, u = u + 2 | 0, (v | 0) != (u | 0););
                                                                            if (s && (f = (l[e + w | 0] ^ ((r ^ e) >>> 8 ^ r ^ e) & 255) + f | 0), r = r + 1 | 0, (T | 0) == (r | 0)) break;
                                                                        }
                                                                    }
                                                                    if (i[W + C >> 2] == (f | 0)) break k;
                                                                    e = 5;
                                                                    break f;
                                                                }
                                                                if ((M | 0) <= 0) break n;
                                                                for(s = M & 2147483646, k = M & 1, V = 0;;){
                                                                    if (v = $ + Z(V, P) | 0, f = 0, u = 0, (M | 0) != 1) for(; R = e << 8, n = f + v | 0, r = l[n | 0] ^ (e & 65280) >>> 8, e = r >>> 4 ^ r, r = (R | e) ^ e << 5, R = r << 8, r = l[n + 1 | 0] ^ ((r ^ e << 12) & 65280) >>> 8, r = r >>> 4 ^ r, e = (R | r) ^ r << 5 ^ r << 12, f = f + 2 | 0, u = u + 2 | 0, (s | 0) != (u | 0););
                                                                    if (k && (r = l[f + v | 0] ^ (e & 65280) >>> 8, r = r >>> 4 ^ r, e = (r | e << 8) ^ r << 5 ^ r << 12), V = V + 1 | 0, (T | 0) == (V | 0)) break;
                                                                }
                                                            }
                                                            if (I[(t << 1) + B >> 1] == (e & 65535)) break k;
                                                            e = 5;
                                                            break f;
                                                        }
                                                        if (e = 0, !E) break f;
                                                        if (r = t >>> 0 < 2, t = t + 1 | 0, !r) break;
                                                    }
                                                }
                                                if (m = F + 176 | 0, e) break A;
                                                if (G = G + 1 | 0, r = i[h + 436 >> 2], !(G >>> 0 < (i[h + 440 >> 2] - r | 0) / 80 >>> 0)) break;
                                            }
                                            e = 0;
                                        }
                                        if (s = i[h >> 2], s) {
                                            if (!(l[s + 104 | 0] != 1 | (l[A + 514 | 0] ? l[s + 312 | 0] : 0))) A: {
                                                if (v = A + 2140 | 0, u = i[v + 24 >> 2], f = i[v + 28 >> 2], u >>> 0 < f >>> 0) {
                                                    i[u >> 2] = s, i[v + 24 >> 2] = u + 4;
                                                    break A;
                                                }
                                                f: {
                                                    if (r = i[v + 20 >> 2], k = u - r >> 2, t = k + 1 | 0, t >>> 0 < 1073741824) {
                                                        if (n = f - r | 0, f = n >> 1, t = n >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 > t >>> 0 ? f : t, t) {
                                                            if (t >>> 0 >= 1073741824) break f;
                                                            f = D(t << 2);
                                                        } else f = 0;
                                                        if (G = f + (k << 2) | 0, i[G >> 2] = s, n = G + 4 | 0, (r | 0) != (u | 0)) {
                                                            for(; G = G - 4 | 0, u = u - 4 | 0, i[G >> 2] = i[u >> 2], (r | 0) != (u | 0););
                                                            r = i[v + 20 >> 2];
                                                        }
                                                        i[v + 28 >> 2] = f + (t << 2), i[v + 24 >> 2] = n, i[v + 20 >> 2] = G, r && X(r), i[v + 24 >> 2] = n;
                                                        break A;
                                                    }
                                                    p0(), z();
                                                }
                                                Z2(), z();
                                            }
                                            r = i[s + 116 >> 2], r ? r = i[(r + Z(i[r + 8 >> 2], 12) | 0) + 480 >> 2] : r = 0, (r | 0) < i[A + 2164 >> 2] - i[A + 2160 >> 2] >> 2 && fn(A + 2140 | 0);
                                        }
                                        if (X(rn(h)), h = i[A + 3212 >> 2], r = i[A + 3208 >> 2], h - r >>> 0 >= 5) for(G = 1; r = (G << 2) + r | 0, i[r - 4 >> 2] = i[r >> 2], G = G + 1 | 0, h = i[A + 3212 >> 2], r = i[A + 3208 >> 2], G >>> 0 < h - r >> 2 >>> 0;);
                                        i[A + 3212 >> 2] = h - 4;
                                    }
                                    return e;
                                }
                                y0(16057, 14908, 172, 3896), z();
                            }
                            y0(3921, 9001, 174, 2821), z();
                        }
                        function m7(A, r, e, f, k, n, t, u, s, h, w, v) {
                            var _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0, D1 = 0, e4 = 0, r4 = 0, A4 = 0, U4 = 0, H4 = 0;
                            D1 = m - 16 | 0, m = D1, F = D1 + 4 | 0, r0 = m - 80 | 0, m = r0;
                            i: {
                                e: {
                                    if (_ = i[e + 168 >> 2], H = k >> _, (H | 0) < 0 || (M = i[e + 172 >> 2], (M | 0) <= (H | 0))) break e;
                                    if (P = n >> _, (P | 0) < 0 | (P | 0) >= i[e + 176 >> 2]) break i;
                                    _ = n + u | 0, C = k + t | 0, y = l[f + 10 | 0];
                                    r: {
                                        A: {
                                            f: switch((l[((i[e + 160 >> 2] + Z(H, 3) | 0) + Z(Z(M, P), 3) | 0) + 1 | 0] & 3) - 1 | 0){
                                                case 0:
                                                    if (!(y & 16)) break A;
                                                    break;
                                                case 1:
                                                    break f;
                                                default:
                                                    break A;
                                            }
                                            i[r0 + 12 >> 2] = e, i[r0 + 8 >> 2] = 50984, B = r0 + 8 | 0, f = _, H = h, P = w, M = v, X0 = y >>> 5 | 0, G = r0 + 16 | 0, y = m - 16 | 0, m = y, V = i[i[e + 132 >> 2] + 8236 >> 2], (s | 0) != 8 | i[i[e + 132 >> 2] + 8236 >> 2] < 3 || (P = 8, M = 0, H = 8, C = k, f = n), Z0 = f + P | 0, R = Z0 - 1 | 0, _ = p[i[i[B >> 2] >> 2]](B, k, n) | 0;
                                            f: {
                                                S = X0 + 1 | 0, c = C >> V, t0 = C - 1 | 0, $ = (c | 0) != t0 >> V;
                                                k: {
                                                    if (!$ && (v = 0, f >> V == R >> V) || !((M | 0) != 1 | _ >>> 0 > 7) && (v = 0, 1 << _ & 196) || (v = 0, !q4(e, k, n, s, C, f, H, P, M, t0, R))) break k;
                                                    v = p[i[i[B >> 2] + 4 >> 2]](B, t0, R) | 0, B = I[v + 4 >> 1] | I[v + 6 >> 1] << 16, R = I[v >> 1] | I[v + 2 >> 1] << 16, Q[G >> 1] = R, Q[G + 2 >> 1] = R >>> 16, Q[G + 4 >> 1] = B, Q[G + 6 >> 1] = B >>> 16, v = I[v + 8 >> 1] | I[v + 10 >> 1] << 16, Q[G + 8 >> 1] = v, Q[G + 10 >> 1] = v >>> 16, v = 1;
                                                }
                                                if ((S | 0) <= (v | 0)) break f;
                                                k: {
                                                    n: {
                                                        t: {
                                                            if (W = C + H | 0, B = W - 1 | 0, R = f - 1 | 0, !(!(1 << _ & 50) || (M | 0) != 1 | _ >>> 0 > 5) | (c | 0) == B >> V & f >> V == R >> V || !q4(e, k, n, s, C, f, H, P, M, B, R)) break t;
                                                            if (E = i[e + 188 >> 2], _ = B >> E, (_ | 0) < 0 || (B = i[e + 192 >> 2], (B | 0) <= (_ | 0))) break e;
                                                            if (E = R >> E, !((E | 0) < 0 | (E | 0) >= i[e + 196 >> 2])) {
                                                                B = (i[e + 180 >> 2] + Z(_, 12) | 0) + Z(Z(B, E), 12) | 0;
                                                                o: {
                                                                    if (!v || (_ = l[G | 0], (_ | 0) != l[B | 0]) || _ && I[G + 4 >> 1] != I[B + 4 >> 1] | I[G + 6 >> 1] != I[B + 6 >> 1] | l[G + 2 | 0] != l[B + 2 | 0] || (g0 = l[G + 1 | 0], (g0 | 0) != l[B + 1 | 0])) break o;
                                                                    if (E = 0, V0 = 1, _ = v, !g0) break n;
                                                                    if (I[G + 8 >> 1] != I[B + 8 >> 1] | I[G + 10 >> 1] != I[B + 10 >> 1] | l[G + 3 | 0] != l[B + 3 | 0]) break o;
                                                                    _ = v;
                                                                    break n;
                                                                }
                                                                E = I[B + 4 >> 1] | I[B + 6 >> 1] << 16, _ = G + Z(v, 12) | 0, V0 = I[B >> 1] | I[B + 2 >> 1] << 16, Q[_ >> 1] = V0, Q[_ + 2 >> 1] = V0 >>> 16, Q[_ + 4 >> 1] = E, Q[_ + 6 >> 1] = E >>> 16, E = I[B + 8 >> 1] | I[B + 10 >> 1] << 16, Q[_ + 8 >> 1] = E, Q[_ + 10 >> 1] = E >>> 16, V0 = 1, E = v, _ = v + 1 | 0;
                                                                break n;
                                                            }
                                                            break k;
                                                        }
                                                        _ = v;
                                                    }
                                                    n: {
                                                        if (S >>> 0 <= _ >>> 0) break n;
                                                        t: {
                                                            if ((c | 0) == W >> V & f >> V == R >> V || !q4(e, k, n, s, C, f, H, P, M, W, R)) break t;
                                                            if (B = W, W = i[e + 188 >> 2], B = B >> W, (B | 0) < 0 || (c = i[e + 192 >> 2], (c | 0) <= (B | 0))) break e;
                                                            if (W = R >> W, (W | 0) < 0 | (W | 0) >= i[e + 196 >> 2]) break k;
                                                            B = (i[e + 180 >> 2] + Z(B, 12) | 0) + Z(Z(W, c), 12) | 0;
                                                            o: {
                                                                if (!V0 || (W = G + Z(E, 12) | 0, c = l[W | 0], (c | 0) != l[B | 0]) || c && I[W + 4 >> 1] != I[B + 4 >> 1] | I[W + 6 >> 1] != I[B + 6 >> 1] | l[W + 2 | 0] != l[B + 2 | 0] || (c = l[W + 1 | 0], (c | 0) != l[B + 1 | 0])) break o;
                                                                if (!c) break t;
                                                                if (I[W + 8 >> 1] != I[B + 8 >> 1] | I[W + 10 >> 1] != I[B + 10 >> 1]) break o;
                                                                if (l[W + 3 | 0] == l[B + 3 | 0]) break t;
                                                            }
                                                            c = I[B + 4 >> 1] | I[B + 6 >> 1] << 16, W = G + Z(_, 12) | 0, g0 = I[B >> 1] | I[B + 2 >> 1] << 16, Q[W >> 1] = g0, Q[W + 2 >> 1] = g0 >>> 16, Q[W + 4 >> 1] = c, Q[W + 6 >> 1] = c >>> 16, B = I[B + 8 >> 1] | I[B + 10 >> 1] << 16, Q[W + 8 >> 1] = B, Q[W + 10 >> 1] = B >>> 16, _ = _ + 1 | 0;
                                                        }
                                                        if (_ >>> 0 >= S >>> 0) break n;
                                                        t: {
                                                            o: {
                                                                if (!$ && (B = f >> V, (B | 0) == Z0 >> V)) break o;
                                                                s: {
                                                                    if (!q4(e, k, n, s, C, f, H, P, M, t0, Z0)) break s;
                                                                    if (W = i[e + 188 >> 2], B = t0 >> W, (B | 0) < 0 || (c = i[e + 192 >> 2], (c | 0) <= (B | 0))) break e;
                                                                    if (W = Z0 >> W, (W | 0) < 0 | (W | 0) >= i[e + 196 >> 2]) break k;
                                                                    B = (i[e + 180 >> 2] + Z(B, 12) | 0) + Z(Z(W, c), 12) | 0;
                                                                    u: {
                                                                        if (!v || (W = l[G | 0], (W | 0) != l[B | 0]) || W && I[G + 4 >> 1] != I[B + 4 >> 1] | I[G + 6 >> 1] != I[B + 6 >> 1] | l[G + 2 | 0] != l[B + 2 | 0] || (W = l[G + 1 | 0], (W | 0) != l[B + 1 | 0])) break u;
                                                                        if (!W) break s;
                                                                        if (I[G + 8 >> 1] != I[B + 8 >> 1] | I[G + 10 >> 1] != I[B + 10 >> 1]) break u;
                                                                        if (l[G + 3 | 0] == l[B + 3 | 0]) break s;
                                                                    }
                                                                    Z0 = I[B + 4 >> 1] | I[B + 6 >> 1] << 16, W = G + Z(_, 12) | 0, c = I[B >> 1] | I[B + 2 >> 1] << 16, Q[W >> 1] = c, Q[W + 2 >> 1] = c >>> 16, Q[W + 4 >> 1] = Z0, Q[W + 6 >> 1] = Z0 >>> 16, B = I[B + 8 >> 1] | I[B + 10 >> 1] << 16, Q[W + 8 >> 1] = B, Q[W + 10 >> 1] = B >>> 16, _ = _ + 1 | 0;
                                                                }
                                                                if ((_ | 0) == 4 | _ >>> 0 >= S >>> 0) break n;
                                                                if ($) break t;
                                                                B = f >> V;
                                                            }
                                                            if (R >> V == (B | 0)) break n;
                                                        }
                                                        if (!q4(e, k, n, s, C, f, H, P, M, t0, R)) break n;
                                                        if (V = i[e + 188 >> 2], M = t0 >> V, (M | 0) < 0 || (B = i[e + 192 >> 2], (B | 0) <= (M | 0))) break e;
                                                        if (V = R >> V, (V | 0) < 0 | (V | 0) >= i[e + 196 >> 2]) break k;
                                                        if (M = (i[e + 180 >> 2] + Z(M, 12) | 0) + Z(Z(B, V), 12) | 0, V0 && g9(G + Z(E, 12) | 0, M) || v && g9(G, M)) break n;
                                                        E = I[M + 4 >> 1] | I[M + 6 >> 1] << 16, v = G + Z(_, 12) | 0, V = I[M >> 1] | I[M + 2 >> 1] << 16, Q[v >> 1] = V, Q[v + 2 >> 1] = V >>> 16, Q[v + 4 >> 1] = E, Q[v + 6 >> 1] = E >>> 16, M = I[M + 8 >> 1] | I[M + 10 >> 1] << 16, Q[v + 8 >> 1] = M, Q[v + 10 >> 1] = M >>> 16, _ = _ + 1 | 0;
                                                    }
                                                    v = _;
                                                    break f;
                                                }
                                                break i;
                                            }
                                            i[y + 12 >> 2] = v;
                                            f: {
                                                if ((v | 0) > (X0 | 0) || (je(A, e, r, C, f, H, P, 0, 0, y + 4 | 0, y + 2 | 0), o[y + 3 | 0] = 0, _ = l[y + 2 | 0], i[r + 28 >> 2] || (je(A, e, r, C, f, H, P, 0, 1, y + 8 | 0, y + 3 | 0), f0 = l[y + 3 | 0], _ = _ | f0), !(_ & 255))) break f;
                                                i[y + 12 >> 2] = v + 1, f = G + Z(v, 12) | 0, v = i[y + 4 >> 2], Q[f + 4 >> 1] = v, Q[f + 6 >> 1] = v >>> 16, v = i[y + 8 >> 2], Q[f + 8 >> 1] = v, Q[f + 10 >> 1] = v >>> 16, v = l[y + 2 | 0], Q[f + 2 >> 1] = 0, o[f + 1 | 0] = f0, o[f | 0] = v;
                                            }
                                            if (v = i[r + 28 >> 2], !v) {
                                                C = 0;
                                                f: {
                                                    if (H = i[y + 12 >> 2], (H | 0) < 2 | (H | 0) >= (S | 0)) break f;
                                                    V = r + 988 | 0, B = r + 924 | 0, R = Z(H, H - 1 | 0);
                                                    k: {
                                                        for(;;){
                                                            if (f = C << 2, v = i[f + 50880 >> 2], (v | 0) >= (H | 0) || (_ = i[f + 50928 >> 2], (_ | 0) >= (H | 0))) break k;
                                                            if (M = 0, f = 0, v = G + Z(v, 12) | 0, l[v | 0] && (f = p[i[i[A >> 2] + 8 >> 2]](A, i[B + (o[v + 2 | 0] << 2) >> 2]) | 0), _ = G + Z(_, 12) | 0, l[_ + 1 | 0] && (M = p[i[i[A >> 2] + 8 >> 2]](A, i[V + (o[_ + 3 | 0] << 2) >> 2]) | 0), P = l[v | 0], !(!P || f) || (E = l[_ + 1 | 0], !(!E || M)) || (!(i[f + 96 >> 2] != i[M + 96 >> 2] | I[v + 4 >> 1] != I[_ + 8 >> 1]) & I[v + 6 >> 1] == I[_ + 10 >> 1] | (!P | !E) || (f = G + Z(i[y + 12 >> 2], 12) | 0, o[f + 2 | 0] = l[v + 2 | 0], M = l[_ + 3 | 0], o[f + 1 | 0] = E, o[f | 0] = P, o[f + 3 | 0] = M, v = I[v + 4 >> 1] | I[v + 6 >> 1] << 16, Q[f + 4 >> 1] = v, Q[f + 6 >> 1] = v >>> 16, v = I[_ + 8 >> 1] | I[_ + 10 >> 1] << 16, Q[f + 8 >> 1] = v, Q[f + 10 >> 1] = v >>> 16, i[y + 12 >> 2] = i[y + 12 >> 2] + 1), C = C + 1 | 0, (R | 0) == (C | 0))) break f;
                                                            if ((S | 0) == i[y + 12 >> 2]) break;
                                                        }
                                                        break f;
                                                    }
                                                    y0(10076, 14978, 1432, 4493), z();
                                                }
                                                v = i[r + 28 >> 2];
                                            }
                                            H = i[r + 336 >> 2], (v | 0) != 1 && (f = i[r + 340 >> 2], H = (f | 0) > (H | 0) ? H : f), P = i[y + 12 >> 2];
                                            f: {
                                                if ((X0 | 0) < (P | 0)) break f;
                                                if (f = S - P | 0, C = f & 1, v = 0, (P | 0) != (X0 | 0)) for(M = f & -2, f = 0; S = i[r + 28 >> 2], _ = G + Z(P, 12) | 0, E = (v | 0) < (H | 0) ? v : 0, o[_ + 2 | 0] = E, Q[_ + 4 >> 1] = 0, Q[_ + 6 >> 1] = 0, Q[_ + 8 >> 1] = 0, Q[_ + 10 >> 1] = 0, S = (S | 0) != 1, o[_ + 1 | 0] = S, o[_ | 0] = 1, o[_ + 3 | 0] = S ? E : -1, S = i[r + 28 >> 2], E = v | 1, E = (E | 0) < (H | 0) ? E : 0, o[_ + 14 | 0] = E, Q[_ + 16 >> 1] = 0, Q[_ + 18 >> 1] = 0, Q[_ + 20 >> 1] = 0, Q[_ + 22 >> 1] = 0, o[_ + 12 | 0] = 1, S = (S | 0) != 1, o[_ + 13 | 0] = S, o[_ + 15 | 0] = S ? E : -1, v = v + 2 | 0, P = P + 2 | 0, f = f + 2 | 0, (M | 0) != (f | 0););
                                                if (!C) break f;
                                                _ = i[r + 28 >> 2], f = G + Z(P, 12) | 0, v = (v | 0) < (H | 0) ? v : 0, o[f + 2 | 0] = v, Q[f + 4 >> 1] = 0, Q[f + 6 >> 1] = 0, Q[f + 8 >> 1] = 0, Q[f + 10 >> 1] = 0, _ = (_ | 0) != 1, o[f + 1 | 0] = _, o[f | 0] = 1, o[f + 3 | 0] = _ ? v : -1;
                                            }
                                            if (m = y + 16 | 0, f = G + Z(X0, 12) | 0, v = I[f >> 1] | I[f + 2 >> 1] << 16, _ = I[f + 4 >> 1] | I[f + 6 >> 1] << 16, Q[F >> 1] = v, Q[F + 2 >> 1] = v >>> 16, Q[F + 4 >> 1] = _, Q[F + 6 >> 1] = _ >>> 16, f = I[f + 8 >> 1] | I[f + 10 >> 1] << 16, Q[F + 8 >> 1] = f, Q[F + 10 >> 1] = f >>> 16, !(v & 255) | !l[F + 1 | 0] | (h + w | 0) != 12) break r;
                                            o[F + 1 | 0] = 0, o[F + 3 | 0] = 255;
                                            break r;
                                        }
                                        A: {
                                            f: {
                                                k: {
                                                    n: switch((y & 3) - 1 | 0){
                                                        case 0:
                                                        case 2:
                                                            if (y = o[f | 0], o[F | 0] = 1, o[F + 2 | 0] = y, o[f | 0] < 16) break k;
                                                            f = F + 2 | 0;
                                                            break A;
                                                        default:
                                                            break n;
                                                    }
                                                    o[F | 0] = 0, o[F + 2 | 0] = 255;
                                                    break f;
                                                }
                                                H = I[f + 4 >> 1], P = I[f + 2 >> 1], S = y, y = r0 + 16 | 0, I7(A, r, e, k, n, s, C, _, h, w, 0, S, v, y), y = y + (l[f + 10 | 0] & 4) | 0, y = I[y >> 1] | I[y + 2 >> 1] << 16, Q[F + 4 >> 1] = y + P, Q[F + 6 >> 1] = H + (y >>> 16 | 0);
                                            }
                                            if (!(l[f + 10 | 0] & 2)) {
                                                o[F + 1 | 0] = 0, o[F + 3 | 0] = 255;
                                                break r;
                                            }
                                            if (y = o[f + 1 | 0], o[F + 1 | 0] = 1, o[F + 3 | 0] = y, o[f + 1 | 0] > 15) {
                                                f = F + 3 | 0;
                                                break A;
                                            }
                                            H = I[f + 8 >> 1], P = I[f + 6 >> 1], S = v, v = r0 + 16 | 0, I7(A, r, e, k, n, s, C, _, h, w, 1, y, S, v), f = v + (l[f + 10 | 0] >>> 1 & 4) | 0, f = I[f >> 1] | I[f + 2 >> 1] << 16, Q[F + 8 >> 1] = f + P, Q[F + 10 >> 1] = H + (f >>> 16 | 0);
                                            break r;
                                        }
                                        o[f | 0] = 0, o[e + 312 | 0] = 3, W2(A + 4 | 0, 1012, 0);
                                    }
                                    m = r0 + 80 | 0, v = A, y = k, H = n, P = t, M = u, f = F, k = m - 49152 | 0, m = k;
                                    r: {
                                        A: {
                                            if (n = r, K2 = i[r + 4 >> 2], r0 = i[K2 + 4 >> 2], R = i[r0 + 16832 >> 2], A = i[e + 124 >> 2], (R | 0) == i[A + 16832 >> 2] && (B = i[r0 + 16840 >> 2], (B | 0) == i[A + 16840 >> 2])) break A;
                                            o[e + 312 | 0] = 3, W2(v + 4 | 0, 1031, 0);
                                            break r;
                                        }
                                        if (i[r0 + 476 >> 2] != i[e + 20 >> 2]) {
                                            o[e + 312 | 0] = 3, W2(v + 4 | 0, 1030, 0);
                                            break r;
                                        }
                                        V = i[e + 44 >> 2], k2 = M + H | 0, t2 = i[r0 + 16856 >> 2], v2 = y + P | 0, y2 = i[r0 + 16852 >> 2], A = Z(V, (k2 | 0) / (t2 | 0) | 0) + ((v2 | 0) / (y2 | 0) | 0) | 0, r = A << l[e + 18 | 0], t = i[e + 12 >> 2], A = A << l[e + 17 | 0], _ = i[e + 8 >> 2], X0 = i[e + 40 >> 2], F = Z(X0, k2) + v2 << l[e + 16 | 0], G = i[e + 4 >> 2], C = l[f + 1 | 0], u = l[f | 0];
                                        A: {
                                            if (l[K2 + 41 | 0] | !u | (!C | I[f + 4 >> 1] != I[f + 8 >> 1]) || I[f + 6 >> 1] != I[f + 10 >> 1]) break A;
                                            C = i[(n + (o[f + 2 | 0] << 2) | 0) + 924 >> 2] != i[(n + (o[f + 3 | 0] << 2) | 0) + 988 >> 2] ? C : 0;
                                        }
                                        for(S = k + 40960 | 0, E = k - -8192 | 0, Z0 = r + t | 0, V0 = A + _ | 0, c = G + F | 0, U4 = f + 4 | 0, j2 = v + 4 | 0, H4 = n + 924 | 0, e4 = f + 2 | 0, g0 = k + 16384 | 0, t = k + 32768 | 0, r = k, F = 1, A = u;;){
                                            A: {
                                                if (!A) break A;
                                                if (A = o[V1 + e4 | 0], (A | 0) >= 16) {
                                                    o[e + 312 | 0] = 3, W2(j2, 1012, 0);
                                                    break r;
                                                }
                                                if (t0 = p[i[i[v >> 2] + 8 >> 2]](v, i[((V1 << 6) + H4 | 0) + (A << 2) >> 2]) | 0, !(i[t0 + 100 >> 2] && t0)) {
                                                    o[e + 312 | 0] = 3, W2(j2, 1012, 0);
                                                    break A;
                                                }
                                                if (!(!(i[t0 + 24 >> 2] != i[r0 + 484 >> 2] | i[t0 + 28 >> 2] != i[r0 + 488 >> 2]) & i[e + 20 >> 2] == i[t0 + 20 >> 2])) {
                                                    o[e + 312 | 0] = 3, W2(j2, 1029, 0);
                                                    break A;
                                                }
                                                if (_ = i[e + 124 >> 2], G = i[_ + 16832 >> 2], A = i[t0 + 124 >> 2], !((G | 0) == i[A + 16832 >> 2] & i[_ + 16840 >> 2] == i[A + 16840 >> 2])) {
                                                    o[e + 312 | 0] = 3, W2(j2, 1028, 0);
                                                    break A;
                                                }
                                                U2 = (V1 << 2) + U4 | 0, A = Q[U2 + 2 >> 1], _ = Q[U2 >> 1], W = i[t0 + 40 >> 2], H2 = i[t0 + 4 >> 2];
                                                f: {
                                                    if ((G | 0) >= 9) {
                                                        s0 = m - 20448 | 0, m = s0, I0 = (A >> 2) + k2 | 0, $ = (_ >> 2) + v2 | 0, R0 = i[r0 + 488 >> 2], f0 = i[r0 + 484 >> 2];
                                                        k: {
                                                            if (!((A | _) & 3)) {
                                                                A = i[r0 + 16832 >> 2];
                                                                n: {
                                                                    if (!(($ | I0) < 0 | (f0 | 0) < (h + $ | 0)) && (R0 | 0) >= (w + I0 | 0)) break n;
                                                                    if ((w | 0) <= 0 | (h | 0) <= 0) break k;
                                                                    for(L = 14 - A | 0, D0 = R0 - 1 | 0, m0 = f0 - 1 | 0, H0 = h & 2147483646, i2 = h & 1, G = 0;;){
                                                                        if (A = G + I0 | 0, F0 = (Z((A | 0) >= 0 ? (A | 0) < (R0 | 0) ? A : D0 : 0, W) << 1) + H2 | 0, q = (Z(s, G) << 1) + t | 0, A = 0, _ = 0, (h | 0) != 1) for(; T = A + $ | 0, Q[q + (A << 1) >> 1] = I[F0 + (((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : m0 : 0) << 1) >> 1] << L, e2 = A | 1, T = e2 + $ | 0, Q[q + (e2 << 1) >> 1] = I[F0 + (((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : m0 : 0) << 1) >> 1] << L, A = A + 2 | 0, _ = _ + 2 | 0, (H0 | 0) != (_ | 0););
                                                                        if (i2 && (_ = q + (A << 1) | 0, A = A + $ | 0, Q[_ >> 1] = I[F0 + (((A | 0) >= 0 ? (A | 0) < (f0 | 0) ? A : m0 : 0) << 1) >> 1] << L), G = G + 1 | 0, (G | 0) == (w | 0)) break;
                                                                    }
                                                                    break k;
                                                                }
                                                                if (A = ((Z(W, I0) << 1) + H2 | 0) + ($ << 1) | 0, (R | 0) <= 8) {
                                                                    p[i[v + 220 >> 2]](t, s, A, W, h, w, s0 + 11360 | 0);
                                                                    break k;
                                                                }
                                                                p[i[v + 300 >> 2]](t, s, A, W, h, w, s0 + 11360 | 0, R);
                                                                break k;
                                                            }
                                                            D0 = A & 3, A = D0 << 2, F0 = i[A + 51072 >> 2], G = i[A + 51088 >> 2], H0 = _ & 3, _ = H0 << 2, A = i[_ + 51088 >> 2], m0 = i[_ + 51072 >> 2], q = $ - m0 | 0;
                                                            n: {
                                                                if (!((f0 | 0) <= (A + (h + $ | 0) | 0) | (R0 | 0) <= (G + (w + I0 | 0) | 0) | (q | I0 - F0) < 0)) {
                                                                    A = (($ << 1) + H2 | 0) + (Z(W, I0) << 1) | 0;
                                                                    break n;
                                                                }
                                                                L = 0 - F0 | 0, i1 = w + G | 0;
                                                                t: {
                                                                    if ((L | 0) >= (i1 | 0) || (v1 = A + h | 0, _ = 0 - m0 | 0, (v1 | 0) <= (_ | 0))) break t;
                                                                    for(r4 = R0 - 1 | 0, G = 1 - m0 | 0, y1 = (A + m0 | 0) + h | 0, I1 = y1 & 1, i2 = f0 - 1 | 0, A4 = ((q | 0) >= 0 ? (f0 | 0) > (q | 0) ? q : i2 : 0) << 1;;){
                                                                        if (A = L + I0 | 0, q = (Z((A | 0) >= 0 ? (A | 0) < (R0 | 0) ? A : r4 : 0, W) << 1) + H2 | 0, T = Z(L + F0 | 0, 80), A = _, I1 && (Q[s0 + (T << 1) >> 1] = I[q + A4 >> 1], A = G), (y1 | 0) != 1) for(e2 = T + m0 | 0; T = A + $ | 0, Q[s0 + (A + e2 << 1) >> 1] = I[q + (((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : i2 : 0) << 1) >> 1], p1 = A + 1 | 0, T = p1 + $ | 0, Q[s0 + (e2 + p1 << 1) >> 1] = I[q + (((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : i2 : 0) << 1) >> 1], A = A + 2 | 0, (v1 | 0) != (A | 0););
                                                                        if (L = L + 1 | 0, (i1 | 0) == (L | 0)) break;
                                                                    }
                                                                }
                                                                W = 80, A = s0 + (m0 + Z(F0, 80) << 1) | 0;
                                                            }
                                                            if ((R | 0) <= 8) {
                                                                p[i[((v + (H0 << 4) | 0) + (D0 << 2) | 0) + 220 >> 2]](t, s, A, W, h, w, s0 + 11360 | 0);
                                                                break k;
                                                            }
                                                            p[i[((v + (H0 << 4) | 0) + (D0 << 2) | 0) + 300 >> 2]](t, s, A, W, h, w, s0 + 11360 | 0, R);
                                                        }
                                                        m = s0 + 20448 | 0;
                                                        break f;
                                                    }
                                                    s0 = m - 14768 | 0, m = s0, I0 = (A >> 2) + k2 | 0, $ = (_ >> 2) + v2 | 0, R0 = i[r0 + 488 >> 2], f0 = i[r0 + 484 >> 2];
                                                    k: {
                                                        if (!((A | _) & 3)) {
                                                            A = i[r0 + 16832 >> 2];
                                                            n: {
                                                                if (!(($ | I0) < 0 | (f0 | 0) < (h + $ | 0)) && (R0 | 0) >= (w + I0 | 0)) break n;
                                                                if ((w | 0) <= 0 | (h | 0) <= 0) break k;
                                                                for(L = 14 - A | 0, D0 = R0 - 1 | 0, m0 = f0 - 1 | 0, H0 = h & 2147483646, i2 = h & 1, G = 0;;){
                                                                    if (A = G + I0 | 0, F0 = Z((A | 0) >= 0 ? (A | 0) < (R0 | 0) ? A : D0 : 0, W) + H2 | 0, q = (Z(s, G) << 1) + t | 0, A = 0, _ = 0, (h | 0) != 1) for(; T = A + $ | 0, Q[q + (A << 1) >> 1] = l[F0 + ((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : m0 : 0) | 0] << L, e2 = A | 1, T = e2 + $ | 0, Q[q + (e2 << 1) >> 1] = l[F0 + ((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : m0 : 0) | 0] << L, A = A + 2 | 0, _ = _ + 2 | 0, (H0 | 0) != (_ | 0););
                                                                    if (i2 && (_ = q + (A << 1) | 0, A = A + $ | 0, Q[_ >> 1] = l[F0 + ((A | 0) >= 0 ? (A | 0) < (f0 | 0) ? A : m0 : 0) | 0] << L), G = G + 1 | 0, (G | 0) == (w | 0)) break;
                                                                }
                                                                break k;
                                                            }
                                                            if (A = $ + (Z(W, I0) + H2 | 0) | 0, (R | 0) <= 8) {
                                                                p[i[v + 220 >> 2]](t, s, A, W, h, w, s0 + 5680 | 0);
                                                                break k;
                                                            }
                                                            p[i[v + 300 >> 2]](t, s, A, W, h, w, s0 + 5680 | 0, R);
                                                            break k;
                                                        }
                                                        D0 = A & 3, A = D0 << 2, F0 = i[A + 51072 >> 2], q = i[A + 51088 >> 2], H0 = _ & 3, _ = H0 << 2, A = i[_ + 51088 >> 2], m0 = i[_ + 51072 >> 2], G = $ - m0 | 0;
                                                        n: {
                                                            if (!((f0 | 0) <= (A + (h + $ | 0) | 0) | (R0 | 0) <= (q + (w + I0 | 0) | 0) | (G | I0 - F0) < 0)) {
                                                                A = ($ + H2 | 0) + Z(W, I0) | 0;
                                                                break n;
                                                            }
                                                            L = 0 - F0 | 0, i1 = w + q | 0;
                                                            t: {
                                                                if ((L | 0) >= (i1 | 0) || (v1 = A + h | 0, _ = 0 - m0 | 0, (v1 | 0) <= (_ | 0))) break t;
                                                                for(r4 = R0 - 1 | 0, i2 = f0 - 1 | 0, y1 = (G | 0) >= 0 ? (G | 0) < (f0 | 0) ? G : i2 : 0, G = 1 - m0 | 0, I1 = (A + m0 | 0) + h | 0, A4 = I1 & 1;;){
                                                                    if (A = L + I0 | 0, q = Z((A | 0) >= 0 ? (A | 0) < (R0 | 0) ? A : r4 : 0, W) + H2 | 0, T = Z(L + F0 | 0, 80), A = _, A4 && (o[T + s0 | 0] = l[q + y1 | 0], A = G), (I1 | 0) != 1) for(e2 = T + m0 | 0; T = A + $ | 0, o[s0 + (A + e2 | 0) | 0] = l[q + ((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : i2 : 0) | 0], p1 = A + 1 | 0, T = p1 + $ | 0, o[s0 + (e2 + p1 | 0) | 0] = l[q + ((T | 0) >= 0 ? (T | 0) < (f0 | 0) ? T : i2 : 0) | 0], A = A + 2 | 0, (v1 | 0) != (A | 0););
                                                                    if (L = L + 1 | 0, (i1 | 0) == (L | 0)) break;
                                                                }
                                                            }
                                                            W = 80, A = s0 + (m0 + Z(F0, 80) | 0) | 0;
                                                        }
                                                        if ((R | 0) <= 8) {
                                                            p[i[((v + (H0 << 4) | 0) + (D0 << 2) | 0) + 220 >> 2]](t, s, A, W, h, w, s0 + 5680 | 0);
                                                            break k;
                                                        }
                                                        p[i[((v + (H0 << 4) | 0) + (D0 << 2) | 0) + 300 >> 2]](t, s, A, W, h, w, s0 + 5680 | 0, R);
                                                    }
                                                    m = s0 + 14768 | 0;
                                                }
                                                if (!i[e + 20 >> 2]) break A;
                                                if (A = (w | 0) / (t2 | 0) | 0, t = (h | 0) / (y2 | 0) | 0, _ = g0 + (V1 << 13) | 0, G = Q[U2 + 2 >> 1], W = Q[U2 >> 1], $ = i[t0 + 44 >> 2], f0 = i[t0 + 8 >> 2], i[i[e + 124 >> 2] + 16840 >> 2] >= 9) {
                                                    o5(v, r0, W, G, v2, k2, r, s, f0, $, t, A, B), o5(v, r0, Q[U2 >> 1], Q[U2 + 2 >> 1], v2, k2, _, s, i[t0 + 12 >> 2], i[t0 + 44 >> 2], t, A, B);
                                                    break A;
                                                }
                                                v5(v, r0, W, G, v2, k2, r, s, f0, $, t, A, B), v5(v, r0, Q[U2 >> 1], Q[U2 + 2 >> 1], v2, k2, _, s, i[t0 + 12 >> 2], i[t0 + 44 >> 2], t, A, B);
                                            }
                                            if (V1 = 1, _ = F, F = 0, A = C, r = E, t = S, !_) break;
                                        }
                                        A = i[r0 + 16840 >> 2], _ = (A | 0) > 12 ? 2 : 14 - A | 0, A = i[r0 + 16832 >> 2], F = (A | 0) > 12 ? 2 : 14 - A | 0, r = i[e + 124 >> 2], A = l[r + 16993 | 0], t = l[r + 16992 | 0];
                                        A: switch(i[n + 28 >> 2]){
                                            case 1:
                                                if (r = !C & (u | 0) == 1, !l[K2 + 41 | 0]) {
                                                    if (r) {
                                                        f: {
                                                            if ((R | 0) <= 8) {
                                                                p[i[v + 176 >> 2]](c, X0, k + 32768 | 0, s, h, w);
                                                                break f;
                                                            }
                                                            p[i[v + 192 >> 2]](c, X0, k + 32768 | 0, s, h, w, R);
                                                        }
                                                        if (!i[e + 20 >> 2]) break r;
                                                        if (A = (w | 0) / (t2 | 0) | 0, r = (h | 0) / (y2 | 0) | 0, (B | 0) <= 8) {
                                                            p[i[v + 176 >> 2]](V0, V, k, s, r, A), p[i[v + 176 >> 2]](Z0, V, g0, s, r, A);
                                                            break r;
                                                        }
                                                        p[i[v + 192 >> 2]](V0, V, k, s, r, A, B), p[i[v + 192 >> 2]](Z0, V, g0, s, r, A, B);
                                                        break r;
                                                    }
                                                    W2(j2, 1011, 0), o[e + 312 | 0] = 3;
                                                    break r;
                                                }
                                                if (r) {
                                                    r = F + l[n + 388 | 0] | 0, u = o[e4 | 0], t = o[(u + n | 0) + 518 | 0] << t, C = n + (u << 1) | 0, S = o[C + 679 | 0], F = n + (u << 2) | 0, u = Q[F + 552 >> 1], E = o[C + 678 | 0], F = Q[F + 550 >> 1], C = Q[C + 454 >> 1], G = l[n + 389 | 0];
                                                    f: {
                                                        if ((R | 0) <= 8) {
                                                            p[i[v + 180 >> 2]](c, X0, k + 32768 | 0, s, h, w, C, t, r);
                                                            break f;
                                                        }
                                                        p[i[v + 196 >> 2]](c, X0, k + 32768 | 0, s, h, w, C, t, r, R);
                                                    }
                                                    if (!i[e + 20 >> 2]) break r;
                                                    if (r = (w | 0) / (t2 | 0) | 0, n = (h | 0) / (y2 | 0) | 0, t = _ + G | 0, _ = E << A, A = S << A, (B | 0) <= 8) {
                                                        p[i[v + 180 >> 2]](V0, V, k, s, n, r, F, _, t), p[i[v + 180 >> 2]](Z0, V, g0, s, n, r, u, A, t);
                                                        break r;
                                                    }
                                                    p[i[v + 196 >> 2]](V0, V, k, s, n, r, F, _, t, B), p[i[v + 196 >> 2]](Z0, V, g0, s, n, r, u, A, t, B);
                                                    break r;
                                                }
                                                W2(j2, 1011, 0), o[e + 312 | 0] = 3;
                                                break r;
                                            default:
                                                y0(16616, 14978, 528, 4608), z();
                                            case 0:
                                                break A;
                                        }
                                        if (!((u | 0) != 1 | (C | 0) != 1)) {
                                            if (!l[K2 + 42 | 0]) {
                                                A = k + 40960 | 0;
                                                A: {
                                                    if ((R | 0) <= 8) {
                                                        p[i[v + 172 >> 2]](c, X0, k + 32768 | 0, A, s, h, w);
                                                        break A;
                                                    }
                                                    p[i[v + 188 >> 2]](c, X0, k + 32768 | 0, A, s, h, w, R);
                                                }
                                                if (!i[e + 20 >> 2]) break r;
                                                if (A = (w | 0) / (t2 | 0) | 0, r = (h | 0) / (y2 | 0) | 0, n = k - -8192 | 0, t = k + 24576 | 0, (B | 0) <= 8) {
                                                    p[i[v + 172 >> 2]](V0, V, k, n, s, r, A), p[i[v + 172 >> 2]](Z0, V, g0, t, s, r, A);
                                                    break r;
                                                }
                                                p[i[v + 188 >> 2]](V0, V, k, n, s, r, A, B), p[i[v + 188 >> 2]](Z0, V, g0, t, s, r, A, B);
                                                break r;
                                            }
                                            if (r = o[f + 3 | 0], u = n + (r << 1) | 0, E = o[u + 711 | 0], C = n + (r << 2) | 0, G = Q[C + 616 >> 1], r0 = o[u + 710 | 0], W = Q[C + 614 >> 1], C = o[f + 2 | 0], S = n + (C << 1) | 0, t0 = o[S + 679 | 0], $ = n + (C << 2) | 0, f0 = Q[$ + 552 >> 1], s0 = o[S + 678 | 0], $ = Q[$ + 550 >> 1], L = l[n + 389 | 0], v = v + 172 | 0, UA(v, c, X0, k + 32768 | 0, k + 40960 | 0, s, h, w, Q[S + 454 >> 1], o[(n + C | 0) + 518 | 0] << t, Q[u + 486 >> 1], o[(r + n | 0) + 534 | 0] << t, F + l[n + 388 | 0] | 0, R), !i[e + 20 >> 2]) break r;
                                            r = (h | 0) / (y2 | 0) | 0, n = (w | 0) / (t2 | 0) | 0, t = _ + L | 0, UA(v, V0, V, k, k - -8192 | 0, s, r, n, $, s0 << A, W, r0 << A, t, B), UA(v, Z0, V, g0, k + 24576 | 0, s, r, n, f0, t0 << A, G, E << A, t, B);
                                            break r;
                                        }
                                        if (!((u | 0) != 1 & (C | 0) != 1)) {
                                            if (!l[K2 + 42 | 0]) {
                                                t = !u, A = (k + 32768 | 0) + (t << 13) | 0;
                                                A: {
                                                    if ((R | 0) <= 8) {
                                                        p[i[v + 176 >> 2]](c, X0, A, s, h, w);
                                                        break A;
                                                    }
                                                    p[i[v + 192 >> 2]](c, X0, A, s, h, w, R);
                                                }
                                                if (!i[e + 20 >> 2]) break r;
                                                if (n = u ? g0 : k + 24576 | 0, A = (w | 0) / (t2 | 0) | 0, r = (h | 0) / (y2 | 0) | 0, t = k + (t << 13) | 0, (B | 0) <= 8) {
                                                    p[i[v + 176 >> 2]](V0, V, t, s, r, A), p[i[v + 176 >> 2]](Z0, V, n, s, r, A);
                                                    break r;
                                                }
                                                p[i[v + 192 >> 2]](V0, V, t, s, r, A, B), p[i[v + 192 >> 2]](Z0, V, n, s, r, A, B);
                                                break r;
                                            }
                                            r = !u, C = o[r + e4 | 0], t = o[(C + (n + (r << 4) | 0) | 0) + 518 | 0] << t, S = (n + (r << 5) | 0) + (C << 1) | 0, r0 = o[S + 679 | 0], E = (n + (r << 6) | 0) + (C << 2) | 0, C = Q[E + 552 >> 1], W = o[S + 678 | 0], E = Q[E + 550 >> 1], S = Q[S + 454 >> 1], F = F + l[n + 388 | 0] | 0, G = (k + 32768 | 0) + (r << 13) | 0, t0 = l[n + 389 | 0];
                                            A: {
                                                if ((R | 0) <= 8) {
                                                    p[i[v + 180 >> 2]](c, X0, G, s, h, w, S, t, F);
                                                    break A;
                                                }
                                                p[i[v + 196 >> 2]](c, X0, G, s, h, w, S, t, F, R);
                                            }
                                            if (!i[e + 20 >> 2]) break r;
                                            if (F = u ? g0 : k + 24576 | 0, n = (w | 0) / (t2 | 0) | 0, t = (h | 0) / (y2 | 0) | 0, u = _ + t0 | 0, _ = W << A, A = r0 << A, r = k + (r << 13) | 0, (B | 0) <= 8) {
                                                p[i[v + 180 >> 2]](V0, V, r, s, t, n, E, _, u), p[i[v + 180 >> 2]](Z0, V, F, s, t, n, C, A, u);
                                                break r;
                                            }
                                            p[i[v + 196 >> 2]](V0, V, r, s, t, n, E, _, u, B), p[i[v + 196 >> 2]](Z0, V, F, s, t, n, C, A, u, B);
                                            break r;
                                        }
                                        W2(j2, 1011, 0), o[e + 312 | 0] = 3;
                                    }
                                    m = k + 49152 | 0, k = y + P | 0, n = M + H | 0, A = f, w = w >> 2;
                                    r: {
                                        if ((w | 0) <= 0 || (r = h >> 2, (r | 0) <= 0)) break r;
                                        for(v = n >> 2, n = k >> 2, _ = i[e + 192 >> 2], h = h & 4, C = r & 2147483646, f = 0, F = (r | 0) == 1;;){
                                            if (u = Z(_, f + v | 0), r = 0, t = 0, !F) for(; s = I[A + 4 >> 1] | I[A + 6 >> 1] << 16, H = Z(u, 12), y = Z(n, 12), k = H + ((y + i[e + 180 >> 2] | 0) + Z(r, 12) | 0) | 0, P = I[A >> 1] | I[A + 2 >> 1] << 16, Q[k >> 1] = P, Q[k + 2 >> 1] = P >>> 16, Q[k + 4 >> 1] = s, Q[k + 6 >> 1] = s >>> 16, s = I[A + 8 >> 1] | I[A + 10 >> 1] << 16, Q[k + 8 >> 1] = s, Q[k + 10 >> 1] = s >>> 16, s = I[A + 4 >> 1] | I[A + 6 >> 1] << 16, k = H + ((y + i[e + 180 >> 2] | 0) + Z(r | 1, 12) | 0) | 0, y = I[A >> 1] | I[A + 2 >> 1] << 16, Q[k >> 1] = y, Q[k + 2 >> 1] = y >>> 16, Q[k + 4 >> 1] = s, Q[k + 6 >> 1] = s >>> 16, s = I[A + 8 >> 1] | I[A + 10 >> 1] << 16, Q[k + 8 >> 1] = s, Q[k + 10 >> 1] = s >>> 16, r = r + 2 | 0, t = t + 2 | 0, (C | 0) != (t | 0););
                                            if (h && (k = I[A + 4 >> 1] | I[A + 6 >> 1] << 16, r = ((i[e + 180 >> 2] + Z(n, 12) | 0) + Z(r, 12) | 0) + Z(u, 12) | 0, t = I[A >> 1] | I[A + 2 >> 1] << 16, Q[r >> 1] = t, Q[r + 2 >> 1] = t >>> 16, Q[r + 4 >> 1] = k, Q[r + 6 >> 1] = k >>> 16, k = I[A + 8 >> 1] | I[A + 10 >> 1] << 16, Q[r + 8 >> 1] = k, Q[r + 10 >> 1] = k >>> 16), f = f + 1 | 0, (w | 0) == (f | 0)) break;
                                        }
                                    }
                                    m = D1 + 16 | 0;
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function Z7(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            C = m - 48 | 0, m = C;
                            i: {
                                e: {
                                    if (e >>> 0 > 2) break e;
                                    for(e = e << 2, S = i[e + 61500 >> 2], P = i[e + 61488 >> 2];;){
                                        e = i[r + 4 >> 2];
                                        r: {
                                            if ((e | 0) != i[r + 104 >> 2]) {
                                                i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                break r;
                                            }
                                            e = M2(r);
                                        }
                                        if (!((e | 0) == 32 | e - 9 >>> 0 < 5)) break;
                                    }
                                    y = 1;
                                    r: {
                                        A: switch(e - 43 | 0){
                                            case 0:
                                            case 2:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        if (y = (e | 0) == 45 ? -1 : 1, e = i[r + 4 >> 2], (e | 0) != i[r + 104 >> 2]) {
                                            i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                            break r;
                                        }
                                        e = M2(r);
                                    }
                                    r: {
                                        A: {
                                            if ((e & -33) == 73) for(;;){
                                                if ((n | 0) == 7) break A;
                                                e = i[r + 4 >> 2];
                                                f: {
                                                    if ((e | 0) != i[r + 104 >> 2]) {
                                                        i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                        break f;
                                                    }
                                                    e = M2(r);
                                                }
                                                if (k = n + 1418 | 0, n = n + 1 | 0, o[k | 0] != (e | 32)) break;
                                            }
                                            if ((n | 0) != 3) {
                                                if (k = (n | 0) == 8, k) break A;
                                                if (!f | n >>> 0 < 4) break r;
                                                if (k) break A;
                                            }
                                            if (e = i[r + 116 >> 2], (e | 0) >= 0 | (e | 0) > 0 && (i[r + 4 >> 2] = i[r + 4 >> 2] - 1), !f | n >>> 0 < 4) break A;
                                            for(e = (e | 0) < 0; e || (i[r + 4 >> 2] = i[r + 4 >> 2] - 1), n = n - 1 | 0, n >>> 0 > 3;);
                                        }
                                        u = m - 16 | 0, m = u, G = (A2(J(J(y | 0) * J(1 / 0))), c0(2)), r = G & 8388607, f = G >>> 23 | 0, e = f & 255;
                                        A: {
                                            if (e) {
                                                if ((e | 0) != 255) {
                                                    e = r, r = r >>> 7 | 0, t = e << 25, s = r, f = (f & 255) + 16256 | 0;
                                                    break A;
                                                }
                                                e = r, r = r >>> 7 | 0, t = e << 25, s = r, f = 32767;
                                                break A;
                                            }
                                            if (f = 0, !r) break A;
                                            e = r, r = e1(r), P1(u, e, 0, 0, 0, r + 81 | 0), t = i[u + 8 >> 2], s = i[u + 12 >> 2] ^ 65536, h = i[u >> 2], w = i[u + 4 >> 2], f = 16265 - r | 0;
                                        }
                                        i[C >> 2] = h, i[C + 4 >> 2] = w, e = C, i[e + 8 >> 2] = t, i[e + 12 >> 2] = s | (G & -2147483648 | f << 16), m = u + 16 | 0, t = i[e + 8 >> 2], s = i[e + 12 >> 2], h = i[e >> 2], w = i[e + 4 >> 2];
                                        break i;
                                    }
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        if (n || (n = 0, (e & -33) != 78)) break n;
                                                        for(;;){
                                                            if ((n | 0) == 2) break k;
                                                            e = i[r + 4 >> 2];
                                                            t: {
                                                                if ((e | 0) != i[r + 104 >> 2]) {
                                                                    i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                                    break t;
                                                                }
                                                                e = M2(r);
                                                            }
                                                            if (k = n + 7585 | 0, n = n + 1 | 0, o[k | 0] != (e | 32)) break;
                                                        }
                                                    }
                                                    switch(n | 0){
                                                        case 0:
                                                            break r;
                                                        case 3:
                                                            break k;
                                                        default:
                                                            break f;
                                                    }
                                                }
                                                k: {
                                                    e = i[r + 4 >> 2];
                                                    n: {
                                                        if ((e | 0) != i[r + 104 >> 2]) {
                                                            i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                            break n;
                                                        }
                                                        e = M2(r);
                                                    }
                                                    if ((e | 0) == 40) {
                                                        n = 1;
                                                        break k;
                                                    }
                                                    if (s = 2147450880, i[r + 116 >> 2] < 0) break i;
                                                    i[r + 4 >> 2] = i[r + 4 >> 2] - 1;
                                                    break i;
                                                }
                                                for(;;){
                                                    k: {
                                                        e = i[r + 4 >> 2];
                                                        n: {
                                                            if ((e | 0) != i[r + 104 >> 2]) {
                                                                i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                                break n;
                                                            }
                                                            e = M2(r);
                                                        }
                                                        if (!(e - 48 >>> 0 < 10 | e - 65 >>> 0 < 26 | (e | 0) == 95) && e - 97 >>> 0 >= 26) break k;
                                                        n = n + 1 | 0;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                if (s = 2147450880, (e | 0) == 41) break i;
                                                e = i[r + 116 >> 2], (e | 0) >= 0 | (e | 0) > 0 && (i[r + 4 >> 2] = i[r + 4 >> 2] - 1);
                                                k: {
                                                    if (f) {
                                                        if (n) break k;
                                                        break i;
                                                    }
                                                    break A;
                                                }
                                                for(; (e | 0) > 0 | (e | 0) >= 0 && (i[r + 4 >> 2] = i[r + 4 >> 2] - 1), n = n - 1 | 0, !!n;);
                                                break i;
                                            }
                                            e = i[r + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (i[r + 4 >> 2] = i[r + 4 >> 2] - 1);
                                        }
                                        i[26064] = 28, z4(r, 0, 0);
                                        break e;
                                    }
                                    r: {
                                        if ((e | 0) != 48) break r;
                                        n = i[r + 4 >> 2];
                                        A: {
                                            if ((n | 0) != i[r + 104 >> 2]) {
                                                i[r + 4 >> 2] = n + 1, n = l[n | 0];
                                                break A;
                                            }
                                            n = M2(r);
                                        }
                                        if ((n & -33) == 88) {
                                            k = m - 432 | 0, m = k, e = i[r + 4 >> 2];
                                            A: {
                                                if ((e | 0) != i[r + 104 >> 2]) {
                                                    i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                    break A;
                                                }
                                                e = M2(r);
                                            }
                                            A: {
                                                f: {
                                                    for(;;){
                                                        if ((e | 0) != 48) k: {
                                                            if ((e | 0) != 46) break A;
                                                            if (e = i[r + 4 >> 2], (e | 0) == i[r + 104 >> 2]) break k;
                                                            i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                            break f;
                                                        }
                                                        else {
                                                            e = i[r + 4 >> 2], (e | 0) != i[r + 104 >> 2] ? (T = 1, i[r + 4 >> 2] = e + 1, e = l[e | 0]) : (T = 1, e = M2(r));
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    e = M2(r);
                                                }
                                                if (V = 1, (e | 0) != 48) break A;
                                                for(;;){
                                                    e = G, G = e - 1 | 0, W = W - !e | 0, e = i[r + 4 >> 2];
                                                    f: {
                                                        if ((e | 0) != i[r + 104 >> 2]) {
                                                            i[r + 4 >> 2] = e + 1, e = l[e | 0];
                                                            break f;
                                                        }
                                                        e = M2(r);
                                                    }
                                                    if ((e | 0) != 48) break;
                                                }
                                                T = 1;
                                            }
                                            for(w = 1073676288;;){
                                                A: {
                                                    n = e;
                                                    f: {
                                                        k: {
                                                            if ($ = e - 48 | 0, $ >>> 0 < 10) break k;
                                                            if (r0 = (e | 0) != 46, n = e | 32, r0 & n - 97 >>> 0 > 5) break A;
                                                            if (r0) break k;
                                                            if (V) break A;
                                                            V = 1, G = t, W = s;
                                                            break f;
                                                        }
                                                        e = (e | 0) > 57 ? n - 87 | 0 : $;
                                                        k: {
                                                            if ((s | 0) <= 0 & t >>> 0 <= 7 | (s | 0) < 0) {
                                                                v = e + (v << 4) | 0;
                                                                break k;
                                                            }
                                                            if (!s & t >>> 0 <= 28) {
                                                                Z4(k + 48 | 0, e), f1(k + 32 | 0, M, H, h, w, 0, 0, 0, 1073414144), M = i[k + 32 >> 2], H = i[k + 36 >> 2], h = i[k + 40 >> 2], w = i[k + 44 >> 2], f1(k + 16 | 0, i[k + 48 >> 2], i[k + 52 >> 2], i[k + 56 >> 2], i[k + 60 >> 2], M, H, h, w), l4(k, i[k + 16 >> 2], i[k + 20 >> 2], i[k + 24 >> 2], i[k + 28 >> 2], u, _, E, R), E = i[k + 8 >> 2], R = i[k + 12 >> 2], u = i[k >> 2], _ = i[k + 4 >> 2];
                                                                break k;
                                                            }
                                                            if (B | !e) break k;
                                                            f1(k + 80 | 0, M, H, h, w, 0, 0, 0, 1073610752), l4(k - -64 | 0, i[k + 80 >> 2], i[k + 84 >> 2], i[k + 88 >> 2], i[k + 92 >> 2], u, _, E, R), E = i[k + 72 >> 2], R = i[k + 76 >> 2], B = 1, u = i[k + 64 >> 2], _ = i[k + 68 >> 2];
                                                        }
                                                        t = t + 1 | 0, s = t ? s : s + 1 | 0, T = 1;
                                                    }
                                                    e = i[r + 4 >> 2], (e | 0) != i[r + 104 >> 2] ? (i[r + 4 >> 2] = e + 1, e = l[e | 0]) : e = M2(r);
                                                    continue;
                                                }
                                                break;
                                            }
                                            A: {
                                                if (!T) {
                                                    e = i[r + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0;
                                                    f: {
                                                        k: {
                                                            if (e) {
                                                                if (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, !f) break k;
                                                                if (i[r + 4 >> 2] = e - 2, !V) break f;
                                                                i[r + 4 >> 2] = e - 3;
                                                                break f;
                                                            }
                                                            if (f) break f;
                                                        }
                                                        z4(r, 0, 0);
                                                    }
                                                    I2(0), r = c0(1) | 0, f = c0(0) | 0, I2(+(y | 0)), e = c0(1) | 0, c0(0), J2(0, f | 0), J2(1, r & 2147483647 | e & -2147483648), c4(k + 96 | 0, +o1()), u = i[k + 96 >> 2], _ = i[k + 100 >> 2], e = i[k + 108 >> 2], r = i[k + 104 >> 2];
                                                    break A;
                                                }
                                                if ((s | 0) <= 0 & t >>> 0 <= 7 | (s | 0) < 0) for(h = t, w = s; v = v << 4, h = h + 1 | 0, w = h ? w : w + 1 | 0, !!((h | 0) != 8 | w););
                                                f: {
                                                    k: {
                                                        n: {
                                                            if ((e & -33) == 80) {
                                                                if (h = F5(r, f), e = w0, w = e, h | (e | 0) != -2147483648) break f;
                                                                if (f) {
                                                                    if (e = i[r + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e) break n;
                                                                    break k;
                                                                }
                                                                u = 0, _ = 0, z4(r, 0, 0), e = 0, r = 0;
                                                                break A;
                                                            }
                                                            if (h = 0, w = 0, i[r + 116 >> 2] < 0) break f;
                                                        }
                                                        i[r + 4 >> 2] = i[r + 4 >> 2] - 1;
                                                    }
                                                    h = 0, w = 0;
                                                }
                                                if (!v) {
                                                    I2(0), r = c0(1) | 0, f = c0(0) | 0, I2(+(y | 0)), e = c0(1) | 0, c0(0), J2(0, f | 0), J2(1, r & 2147483647 | e & -2147483648), c4(k + 112 | 0, +o1()), u = i[k + 112 >> 2], _ = i[k + 116 >> 2], e = i[k + 124 >> 2], r = i[k + 120 >> 2];
                                                    break A;
                                                }
                                                if (r = V ? G : t, f = h + (r << 2) | 0, r = w + ((V ? W : s) << 2 | r >>> 30) | 0, t = f - 32 | 0, e = 0 - S | 0, s = (f >>> 0 < h >>> 0 ? r + 1 | 0 : r) - (f >>> 0 < 32) | 0, r = s, (r | 0) > 0 ? r = 1 : r = e >>> 0 < t >>> 0 & (r | 0) >= 0, r) {
                                                    i[26064] = 68, Z4(k + 160 | 0, y), f1(k + 144 | 0, i[k + 160 >> 2], i[k + 164 >> 2], i[k + 168 >> 2], i[k + 172 >> 2], -1, -1, -1, 2147418111), f1(k + 128 | 0, i[k + 144 >> 2], i[k + 148 >> 2], i[k + 152 >> 2], i[k + 156 >> 2], -1, -1, -1, 2147418111), u = i[k + 128 >> 2], _ = i[k + 132 >> 2], e = i[k + 140 >> 2], r = i[k + 136 >> 2];
                                                    break A;
                                                }
                                                if (r = S - 226 | 0, e = r >> 31, (s | 0) >= (e | 0) & r >>> 0 <= t >>> 0 | (e | 0) < (s | 0)) {
                                                    if ((v | 0) >= 0) for(; l4(k + 416 | 0, u, _, E, R, 0, 0, 0, -1073807360), r = an(u, _, E, R, 1073610752), e = (r | 0) >= 0, r = e, l4(k + 400 | 0, u, _, E, R, r ? i[k + 416 >> 2] : u, r ? i[k + 420 >> 2] : _, r ? i[k + 424 >> 2] : E, r ? i[k + 428 >> 2] : R), r = t, t = r - 1 | 0, s = s - !r | 0, E = i[k + 408 >> 2], R = i[k + 412 >> 2], u = i[k + 400 >> 2], _ = i[k + 404 >> 2], v = e | v << 1, (v | 0) >= 0;);
                                                    r = s - ((S >> 31) + (t >>> 0 < S >>> 0) | 0) | 0, e = (t - S | 0) + 32 | 0, r = e >>> 0 < 32 ? r + 1 | 0 : r, e = e >>> 0 < P >>> 0 & (r | 0) <= 0 | (r | 0) < 0 ? (e | 0) > 0 ? e : 0 : P;
                                                    f: {
                                                        if ((e | 0) >= 113) {
                                                            Z4(k + 384 | 0, y), G = i[k + 392 >> 2], W = i[k + 396 >> 2], M = i[k + 384 >> 2], H = i[k + 388 >> 2], h = 0, r = 0;
                                                            break f;
                                                        }
                                                        c4(k + 352 | 0, T1(1, 144 - e | 0)), Z4(k + 336 | 0, y), M = i[k + 336 >> 2], H = i[k + 340 >> 2], G = i[k + 344 >> 2], W = i[k + 348 >> 2], Kt(k + 368 | 0, i[k + 352 >> 2], i[k + 356 >> 2], i[k + 360 >> 2], i[k + 364 >> 2], W), F = i[k + 376 >> 2], c = i[k + 380 >> 2], h = i[k + 372 >> 2], r = i[k + 368 >> 2];
                                                    }
                                                    f = !(v & 1) & (($8(u, _, E, R, 0, 0, 0, 0) | 0) != 0 & (e | 0) < 32), I6(k + 320 | 0, f | v), f1(k + 304 | 0, M, H, G, W, i[k + 320 >> 2], i[k + 324 >> 2], i[k + 328 >> 2], i[k + 332 >> 2]), e = r, l4(k + 272 | 0, i[k + 304 >> 2], i[k + 308 >> 2], i[k + 312 >> 2], i[k + 316 >> 2], r, h, F, c), r = f, f1(k + 288 | 0, M, H, G, W, r ? 0 : u, r ? 0 : _, r ? 0 : E, r ? 0 : R), l4(k + 256 | 0, i[k + 288 >> 2], i[k + 292 >> 2], i[k + 296 >> 2], i[k + 300 >> 2], i[k + 272 >> 2], i[k + 276 >> 2], i[k + 280 >> 2], i[k + 284 >> 2]), JA(k + 240 | 0, i[k + 256 >> 2], i[k + 260 >> 2], i[k + 264 >> 2], i[k + 268 >> 2], e, h, F, c), r = i[k + 240 >> 2], f = i[k + 244 >> 2], e = i[k + 248 >> 2], h = i[k + 252 >> 2], $8(r, f, e, h, 0, 0, 0, 0) || (i[26064] = 68), un(k + 224 | 0, r, f, e, h, t), u = i[k + 224 >> 2], _ = i[k + 228 >> 2], e = i[k + 236 >> 2], r = i[k + 232 >> 2];
                                                    break A;
                                                }
                                                i[26064] = 68, Z4(k + 208 | 0, y), f1(k + 192 | 0, i[k + 208 >> 2], i[k + 212 >> 2], i[k + 216 >> 2], i[k + 220 >> 2], 0, 0, 0, 65536), f1(k + 176 | 0, i[k + 192 >> 2], i[k + 196 >> 2], i[k + 200 >> 2], i[k + 204 >> 2], 0, 0, 0, 65536), u = i[k + 176 >> 2], _ = i[k + 180 >> 2], e = i[k + 188 >> 2], r = i[k + 184 >> 2];
                                            }
                                            i[C + 16 >> 2] = u, i[C + 20 >> 2] = _, i[C + 24 >> 2] = r, i[C + 28 >> 2] = e, m = k + 432 | 0, t = i[C + 24 >> 2], s = i[C + 28 >> 2], h = i[C + 16 >> 2], w = i[C + 20 >> 2];
                                            break i;
                                        }
                                        if (i[r + 116 >> 2] < 0) break r;
                                        i[r + 4 >> 2] = i[r + 4 >> 2] - 1;
                                    }
                                    n = r, u = e, F = f, f = 0, k = m - 8976 | 0, m = k, $ = 0 - S | 0, c = $ - P | 0;
                                    r: {
                                        A: {
                                            for(;;){
                                                if ((u | 0) != 48) f: {
                                                    if ((u | 0) != 46) break r;
                                                    if (r = i[n + 4 >> 2], (r | 0) == i[n + 104 >> 2]) break f;
                                                    i[n + 4 >> 2] = r + 1, u = l[r | 0];
                                                    break A;
                                                }
                                                else {
                                                    r = i[n + 4 >> 2], (r | 0) != i[n + 104 >> 2] ? (i[n + 4 >> 2] = r + 1, u = l[r | 0]) : u = M2(n), f = 1;
                                                    continue;
                                                }
                                                break;
                                            }
                                            u = M2(n);
                                        }
                                        if (T = 1, (u | 0) != 48) break r;
                                        for(;;){
                                            r = t, t = r - 1 | 0, s = s - !r | 0, r = i[n + 4 >> 2];
                                            A: {
                                                if ((r | 0) != i[n + 104 >> 2]) {
                                                    i[n + 4 >> 2] = r + 1, u = l[r | 0];
                                                    break A;
                                                }
                                                u = M2(n);
                                            }
                                            if ((u | 0) != 48) break;
                                        }
                                        f = 1;
                                    }
                                    i[k + 784 >> 2] = 0;
                                    r: {
                                        A: {
                                            r = (u | 0) == 46, e = u - 48 | 0;
                                            f: {
                                                k: {
                                                    n: {
                                                        if (r | e >>> 0 <= 9) for(;;){
                                                            t: {
                                                                if (r & 1) {
                                                                    if (!T) {
                                                                        t = h, s = w, T = 1;
                                                                        break t;
                                                                    }
                                                                    r = !f;
                                                                    break n;
                                                                }
                                                                if (r = w, h = h + 1 | 0, w = h ? r : r + 1 | 0, (v | 0) <= 2044) {
                                                                    V = (u | 0) == 48 ? V : h, r = (k + 784 | 0) + (v << 2) | 0, B && (e = (Z(i[r >> 2], 10) + u | 0) - 48 | 0), i[r >> 2] = e, f = 1, e = B + 1 | 0, r = (e | 0) == 9, B = r ? 0 : e, v = r + v | 0;
                                                                    break t;
                                                                }
                                                                if ((u | 0) == 48) break t;
                                                                i[k + 8960 >> 2] = i[k + 8960 >> 2] | 1, V = 18396;
                                                            }
                                                            r = i[n + 4 >> 2];
                                                            t: {
                                                                if ((r | 0) != i[n + 104 >> 2]) {
                                                                    i[n + 4 >> 2] = r + 1, u = l[r | 0];
                                                                    break t;
                                                                }
                                                                u = M2(n);
                                                            }
                                                            if (r = (u | 0) == 46, e = u - 48 | 0, !(r | e >>> 0 < 10)) break;
                                                        }
                                                        if (t = T ? t : h, s = T ? s : w, !(!f | (u & -33) != 69)) {
                                                            u = F5(n, F), r = w0, _ = r;
                                                            t: {
                                                                if (u | (r | 0) != -2147483648) break t;
                                                                if (!F) break f;
                                                                if (u = 0, _ = 0, i[n + 116 >> 2] < 0) break t;
                                                                i[n + 4 >> 2] = i[n + 4 >> 2] - 1;
                                                            }
                                                            r = s + _ | 0, t = t + u | 0, s = t >>> 0 < u >>> 0 ? r + 1 | 0 : r;
                                                            break A;
                                                        }
                                                        if (r = !f, (u | 0) < 0) break k;
                                                    }
                                                    if (i[n + 116 >> 2] < 0) break k;
                                                    i[n + 4 >> 2] = i[n + 4 >> 2] - 1;
                                                }
                                                if (!r) break A;
                                                i[26064] = 28;
                                            }
                                            z4(n, 0, 0), t = 0, s = 0, e = 0, r = 0;
                                            break r;
                                        }
                                        if (r = i[k + 784 >> 2], !r) {
                                            I2(0), r = c0(1) | 0, f = c0(0) | 0, I2(+(y | 0)), e = c0(1) | 0, c0(0), J2(0, f | 0), J2(1, r & 2147483647 | e & -2147483648), c4(k, +o1()), t = i[k + 8 >> 2], s = i[k + 12 >> 2], e = i[k + 4 >> 2], r = i[k >> 2];
                                            break r;
                                        }
                                        if (!(h >>> 0 > 9 & (w | 0) >= 0 | (w | 0) > 0 | ((t | 0) != (h | 0) | (s | 0) != (w | 0)) | (r >>> P | 0 ? (P | 0) <= 30 : 0))) {
                                            Z4(k + 48 | 0, y), I6(k + 32 | 0, r), f1(k + 16 | 0, i[k + 48 >> 2], i[k + 52 >> 2], i[k + 56 >> 2], i[k + 60 >> 2], i[k + 32 >> 2], i[k + 36 >> 2], i[k + 40 >> 2], i[k + 44 >> 2]), t = i[k + 24 >> 2], s = i[k + 28 >> 2], e = i[k + 20 >> 2], r = i[k + 16 >> 2];
                                            break r;
                                        }
                                        if (r = $ >>> 1 | 0, r >>> 0 < t >>> 0 & (s | 0) >= 0 | (s | 0) > 0) {
                                            i[26064] = 68, Z4(k + 96 | 0, y), f1(k + 80 | 0, i[k + 96 >> 2], i[k + 100 >> 2], i[k + 104 >> 2], i[k + 108 >> 2], -1, -1, -1, 2147418111), f1(k - -64 | 0, i[k + 80 >> 2], i[k + 84 >> 2], i[k + 88 >> 2], i[k + 92 >> 2], -1, -1, -1, 2147418111), t = i[k + 72 >> 2], s = i[k + 76 >> 2], e = i[k + 68 >> 2], r = i[k + 64 >> 2];
                                            break r;
                                        }
                                        if (r = S - 226 | 0, e = t >>> 0 < r >>> 0, r = r >> 31, e & (s | 0) <= (r | 0) | (r | 0) > (s | 0)) {
                                            i[26064] = 68, Z4(k + 144 | 0, y), f1(k + 128 | 0, i[k + 144 >> 2], i[k + 148 >> 2], i[k + 152 >> 2], i[k + 156 >> 2], 0, 0, 0, 65536), f1(k + 112 | 0, i[k + 128 >> 2], i[k + 132 >> 2], i[k + 136 >> 2], i[k + 140 >> 2], 0, 0, 0, 65536), t = i[k + 120 >> 2], s = i[k + 124 >> 2], e = i[k + 116 >> 2], r = i[k + 112 >> 2];
                                            break r;
                                        }
                                        if (B) {
                                            if ((B | 0) <= 8) {
                                                for(r = (k + 784 | 0) + (v << 2) | 0, n = i[r >> 2]; n = Z(n, 10), B = B + 1 | 0, (B | 0) != 9;);
                                                i[r >> 2] = n;
                                            }
                                            v = v + 1 | 0;
                                        }
                                        B = t;
                                        A: {
                                            if (t >>> 0 > 17 & (s | 0) >= 0 | (s | 0) > 0 | (V | 0) >= 9 | (t | 0) < (V | 0)) break A;
                                            if (!s & (t | 0) == 9) {
                                                Z4(k + 192 | 0, y), I6(k + 176 | 0, i[k + 784 >> 2]), f1(k + 160 | 0, i[k + 192 >> 2], i[k + 196 >> 2], i[k + 200 >> 2], i[k + 204 >> 2], i[k + 176 >> 2], i[k + 180 >> 2], i[k + 184 >> 2], i[k + 188 >> 2]), t = i[k + 168 >> 2], s = i[k + 172 >> 2], e = i[k + 164 >> 2], r = i[k + 160 >> 2];
                                                break r;
                                            }
                                            if ((s | 0) <= 0 & t >>> 0 <= 8 | (s | 0) < 0) {
                                                Z4(k + 272 | 0, y), I6(k + 256 | 0, i[k + 784 >> 2]), f1(k + 240 | 0, i[k + 272 >> 2], i[k + 276 >> 2], i[k + 280 >> 2], i[k + 284 >> 2], i[k + 256 >> 2], i[k + 260 >> 2], i[k + 264 >> 2], i[k + 268 >> 2]), Z4(k + 224 | 0, i[(0 - B << 2) + 61488 >> 2]), Y7(k + 208 | 0, i[k + 240 >> 2], i[k + 244 >> 2], i[k + 248 >> 2], i[k + 252 >> 2], i[k + 224 >> 2], i[k + 228 >> 2], i[k + 232 >> 2], i[k + 236 >> 2]), t = i[k + 216 >> 2], s = i[k + 220 >> 2], e = i[k + 212 >> 2], r = i[k + 208 >> 2];
                                                break r;
                                            }
                                            if (r = (Z(B, -3) + P | 0) + 27 | 0, e = i[k + 784 >> 2], e >>> r | 0 && (r | 0) <= 30) break A;
                                            Z4(k + 352 | 0, y), I6(k + 336 | 0, e), f1(k + 320 | 0, i[k + 352 >> 2], i[k + 356 >> 2], i[k + 360 >> 2], i[k + 364 >> 2], i[k + 336 >> 2], i[k + 340 >> 2], i[k + 344 >> 2], i[k + 348 >> 2]), Z4(k + 304 | 0, i[(B << 2) + 61416 >> 2]), f1(k + 288 | 0, i[k + 320 >> 2], i[k + 324 >> 2], i[k + 328 >> 2], i[k + 332 >> 2], i[k + 304 >> 2], i[k + 308 >> 2], i[k + 312 >> 2], i[k + 316 >> 2]), t = i[k + 296 >> 2], s = i[k + 300 >> 2], e = i[k + 292 >> 2], r = i[k + 288 >> 2];
                                            break r;
                                        }
                                        for(; r = v, v = r - 1 | 0, !i[(k + 784 | 0) + (v << 2) >> 2];);
                                        V = 0, e = (B | 0) % 9 | 0;
                                        A: {
                                            if (!e) {
                                                e = 0;
                                                break A;
                                            }
                                            f = (s | 0) < 0 ? e + 9 | 0 : e;
                                            f: {
                                                if (!r) {
                                                    e = 0, r = 0;
                                                    break f;
                                                }
                                                for(t = i[(0 - f << 2) + 61488 >> 2], s = 1e9 / (t | 0) | 0, u = 0, n = 0, e = 0; h = u, w = k + 784 | 0, u = w + (n << 2) | 0, v = i[u >> 2], F = (v >>> 0) / (t >>> 0) | 0, h = h + F | 0, i[u >> 2] = h, h = !h & (e | 0) == (n | 0), e = h ? e + 1 & 2047 : e, B = h ? B - 9 | 0 : B, u = Z(s, v - Z(t, F) | 0), n = n + 1 | 0, (n | 0) != (r | 0););
                                                if (!u) break f;
                                                i[w + (r << 2) >> 2] = u, r = r + 1 | 0;
                                            }
                                            B = (B - f | 0) + 9 | 0;
                                        }
                                        for(;;){
                                            n = (k + 784 | 0) + (e << 2) | 0, F = (B | 0) < 36;
                                            A: {
                                                for(;;){
                                                    if (!F & ((B | 0) != 36 | k0[n >> 2] >= 10384593)) break A;
                                                    for(v = r + 2047 | 0, f = 0; h = r, t = f, u = v & 2047, v = (k + 784 | 0) + (u << 2) | 0, f = i[v >> 2], r = f >>> 3 | 0, f = f << 29, t = t + f | 0, s = f >>> 0 > t >>> 0 ? r + 1 | 0 : r, !s & t >>> 0 < 1000000001 ? f = 0 : (r = t, f = _6(r, s, 1e9, 0), w = O0(f, w0, 1e9, 0), t = r - w | 0, s = s - (w0 + (r >>> 0 < w >>> 0) | 0) | 0), i[v >> 2] = t, r = (e | 0) == (u | 0) || t | s ? h : u, t = h - 1 & 2047, r = (t | 0) != (u | 0) ? h : r, v = u - 1 | 0, (e | 0) != (u | 0););
                                                    if (V = V - 29 | 0, r = h, !!f) break;
                                                }
                                                e = e - 1 & 2047, (e | 0) == (r | 0) && (u = (r + 2046 & 2047) << 2, r = k + 784 | 0, h = u + r | 0, i[h >> 2] = i[h >> 2] | i[r + (t << 2) >> 2], r = t), B = B + 9 | 0, i[(k + 784 | 0) + (e << 2) >> 2] = f;
                                                continue;
                                            }
                                            break;
                                        }
                                        A: {
                                            f: for(;;){
                                                for(t = r + 1 & 2047, s = (k + 784 | 0) + ((r - 1 & 2047) << 2) | 0;;){
                                                    h = (B | 0) > 45 ? 9 : 1;
                                                    k: {
                                                        for(;;){
                                                            f = e, n = 0;
                                                            n: {
                                                                for(;;){
                                                                    t: {
                                                                        if (e = f + n & 2047, (e | 0) == (r | 0) || (e = i[(k + 784 | 0) + (e << 2) >> 2], u = i[(n << 2) + 61440 >> 2], e >>> 0 < u >>> 0)) break t;
                                                                        if (e >>> 0 > u >>> 0) break n;
                                                                        if (n = n + 1 | 0, (n | 0) != 4) continue;
                                                                    }
                                                                    break;
                                                                }
                                                                if ((B | 0) != 36) break n;
                                                                for(t = 0, s = 0, n = 0, h = 0, w = 0; e = f + n & 2047, (e | 0) == (r | 0) && (r = r + 1 & 2047, i[((r << 2) + k | 0) + 780 >> 2] = 0), I6(k + 768 | 0, i[(k + 784 | 0) + (e << 2) >> 2]), f1(k + 752 | 0, t, s, h, w, 0, 0, 1342177280, 1075633366), l4(k + 736 | 0, i[k + 752 >> 2], i[k + 756 >> 2], i[k + 760 >> 2], i[k + 764 >> 2], i[k + 768 >> 2], i[k + 772 >> 2], i[k + 776 >> 2], i[k + 780 >> 2]), h = i[k + 744 >> 2], w = i[k + 748 >> 2], t = i[k + 736 >> 2], s = i[k + 740 >> 2], n = n + 1 | 0, (n | 0) != 4;);
                                                                if (Z4(k + 720 | 0, y), f1(k + 704 | 0, t, s, h, w, i[k + 720 >> 2], i[k + 724 >> 2], i[k + 728 >> 2], i[k + 732 >> 2]), h = i[k + 712 >> 2], w = i[k + 716 >> 2], t = 0, s = 0, u = i[k + 704 >> 2], _ = i[k + 708 >> 2], F = V + 113 | 0, n = F - S | 0, B = (n | 0) < (P | 0), e = B ? (n | 0) > 0 ? n : 0 : P, (e | 0) <= 112) break k;
                                                                break A;
                                                            }
                                                            if (V = h + V | 0, e = r, (r | 0) != (f | 0)) break;
                                                        }
                                                        for(w = 1e9 >>> h | 0, v = -1 << h ^ -1, n = 0, e = f; u = n, F = k + 784 | 0, n = F + (f << 2) | 0, _ = i[n >> 2], u = u + (_ >>> h | 0) | 0, i[n >> 2] = u, u = !u & (e | 0) == (f | 0), e = u ? e + 1 & 2047 : e, B = u ? B - 9 | 0 : B, n = Z(w, v & _), f = f + 1 & 2047, (f | 0) != (r | 0););
                                                        if (!n) continue;
                                                        if ((e | 0) != (t | 0)) {
                                                            i[F + (r << 2) >> 2] = n, r = t;
                                                            continue f;
                                                        }
                                                        i[s >> 2] = i[s >> 2] | 1;
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break;
                                            }
                                            c4(k + 656 | 0, T1(1, 225 - e | 0)), Kt(k + 688 | 0, i[k + 656 >> 2], i[k + 660 >> 2], i[k + 664 >> 2], i[k + 668 >> 2], w), M = i[k + 696 >> 2], H = i[k + 700 >> 2], E = i[k + 688 >> 2], R = i[k + 692 >> 2], c4(k + 640 | 0, T1(1, 113 - e | 0)), k5(k + 672 | 0, u, _, h, w, i[k + 640 >> 2], i[k + 644 >> 2], i[k + 648 >> 2], i[k + 652 >> 2]), t = i[k + 672 >> 2], s = i[k + 676 >> 2], G = i[k + 680 >> 2], W = i[k + 684 >> 2], JA(k + 624 | 0, u, _, h, w, t, s, G, W), l4(k + 608 | 0, E, R, M, H, i[k + 624 >> 2], i[k + 628 >> 2], i[k + 632 >> 2], i[k + 636 >> 2]), h = i[k + 616 >> 2], w = i[k + 620 >> 2], u = i[k + 608 >> 2], _ = i[k + 612 >> 2];
                                        }
                                        v = f + 4 & 2047;
                                        A: {
                                            if ((v | 0) == (r | 0)) break A;
                                            v = i[(k + 784 | 0) + (v << 2) >> 2];
                                            f: {
                                                if (v >>> 0 <= 499999999) {
                                                    if (!v & (f + 5 & 2047) == (r | 0)) break f;
                                                    c4(k + 496 | 0, +(y | 0) * .25), l4(k + 480 | 0, t, s, G, W, i[k + 496 >> 2], i[k + 500 >> 2], i[k + 504 >> 2], i[k + 508 >> 2]), G = i[k + 488 >> 2], W = i[k + 492 >> 2], t = i[k + 480 >> 2], s = i[k + 484 >> 2];
                                                    break f;
                                                }
                                                if ((v | 0) != 5e8) {
                                                    c4(k + 592 | 0, +(y | 0) * .75), l4(k + 576 | 0, t, s, G, W, i[k + 592 >> 2], i[k + 596 >> 2], i[k + 600 >> 2], i[k + 604 >> 2]), G = i[k + 584 >> 2], W = i[k + 588 >> 2], t = i[k + 576 >> 2], s = i[k + 580 >> 2];
                                                    break f;
                                                }
                                                if (f0 = +(y | 0), (f + 5 & 2047) == (r | 0)) {
                                                    c4(k + 528 | 0, f0 * .5), l4(k + 512 | 0, t, s, G, W, i[k + 528 >> 2], i[k + 532 >> 2], i[k + 536 >> 2], i[k + 540 >> 2]), G = i[k + 520 >> 2], W = i[k + 524 >> 2], t = i[k + 512 >> 2], s = i[k + 516 >> 2];
                                                    break f;
                                                }
                                                c4(k + 560 | 0, f0 * .75), l4(k + 544 | 0, t, s, G, W, i[k + 560 >> 2], i[k + 564 >> 2], i[k + 568 >> 2], i[k + 572 >> 2]), G = i[k + 552 >> 2], W = i[k + 556 >> 2], t = i[k + 544 >> 2], s = i[k + 548 >> 2];
                                            }
                                            if ((e | 0) > 111 || (k5(k + 464 | 0, t, s, G, W, 0, 0, 0, 1073676288), $8(i[k + 464 >> 2], i[k + 468 >> 2], i[k + 472 >> 2], i[k + 476 >> 2], 0, 0, 0, 0))) break A;
                                            l4(k + 448 | 0, t, s, G, W, 0, 0, 0, 1073676288), G = i[k + 456 >> 2], W = i[k + 460 >> 2], t = i[k + 448 >> 2], s = i[k + 452 >> 2];
                                        }
                                        l4(k + 432 | 0, u, _, h, w, t, s, G, W), JA(k + 416 | 0, i[k + 432 >> 2], i[k + 436 >> 2], i[k + 440 >> 2], i[k + 444 >> 2], E, R, M, H), h = i[k + 424 >> 2], w = i[k + 428 >> 2], u = i[k + 416 >> 2], _ = i[k + 420 >> 2];
                                        A: {
                                            if ((c - 2 | 0) >= (F & 2147483647) || (i[k + 408 >> 2] = h, i[k + 412 >> 2] = w & 2147483647, i[k + 400 >> 2] = u, i[k + 404 >> 2] = _, f1(k + 384 | 0, u, _, h, w, 0, 0, 0, 1073610752), f = an(i[k + 400 >> 2], i[k + 404 >> 2], i[k + 408 >> 2], i[k + 412 >> 2], 1081081856), r = (f | 0) >= 0, h = r ? i[k + 392 >> 2] : h, w = r ? i[k + 396 >> 2] : w, u = r ? i[k + 384 >> 2] : u, _ = r ? i[k + 388 >> 2] : _, t = $8(t, s, G, W, 0, 0, 0, 0), V = r + V | 0, (V + 110 | 0) <= (c | 0) && !(B & ((e | 0) != (n | 0) | (f | 0) < 0) & (t | 0) != 0))) break A;
                                            i[26064] = 68;
                                        }
                                        un(k + 368 | 0, u, _, h, w, V), t = i[k + 376 >> 2], s = i[k + 380 >> 2], e = i[k + 372 >> 2], r = i[k + 368 >> 2];
                                    }
                                    i[C + 40 >> 2] = t, i[C + 44 >> 2] = s, i[C + 32 >> 2] = r, i[C + 36 >> 2] = e, m = k + 8976 | 0, t = i[C + 40 >> 2], s = i[C + 44 >> 2], h = i[C + 32 >> 2], w = i[C + 36 >> 2];
                                    break i;
                                }
                                s = 0;
                            }
                            i[A >> 2] = h, i[A + 4 >> 2] = w, i[A + 8 >> 2] = t, i[A + 12 >> 2] = s, m = C + 48 | 0;
                        }
                        function ii(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            t = m - 144 | 0, m = t, i[t + 136 >> 2] = n, i[t + 140 >> 2] = k;
                            i: {
                                e: {
                                    if (!f) {
                                        if (n = i[r + 24 >> 2], u = i[r + 28 >> 2], (n | 0) == (u | 0)) break e;
                                        for(;;){
                                            r: {
                                                if (k = i[n >> 2], !k || (k = E0(k, 73632, 73656), !k)) break r;
                                                s = i[n + 4 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), h6(t + 56 | 0, i[r + 20 >> 2] - -64 | 0, i[k + 104 >> 2], i[k + 108 >> 2]), n = i[t + 56 >> 2];
                                                A: {
                                                    if (n) {
                                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 60 >> 2], i[A + 8 >> 2] = i[t + 56 >> 2], i[A + 12 >> 2] = k, h = A + 16 | 0, o[t + 75 | 0] >= 0) {
                                                            u = t - -64 | 0, k = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[u + 8 >> 2];
                                                            break A;
                                                        }
                                                        if (j(h, i[t + 64 >> 2], i[t + 68 >> 2]), o[t + 75 | 0] >= 0) break A;
                                                        X(i[t + 64 >> 2]);
                                                        break A;
                                                    }
                                                    if (o[t + 75 | 0] >= 0) break A;
                                                    X(i[t + 64 >> 2]);
                                                }
                                                A: {
                                                    if (!s || (k = i[s + 4 >> 2], i[s + 4 >> 2] = k - 1, k)) break A;
                                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                }
                                                if (!n) break e;
                                                break i;
                                            }
                                            if (n = n + 8 | 0, (u | 0) == (n | 0)) break;
                                        }
                                        break e;
                                    }
                                    if (l[e + 1 | 0]) break e;
                                    G5(t + 56 | 0, r, t + 140 | 0, t + 136 | 0), n = i[t + 56 >> 2];
                                    r: {
                                        if (!n) break r;
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 60 >> 2], i[A + 8 >> 2] = i[t + 56 >> 2], i[A + 12 >> 2] = k, h = A + 16 | 0, o[t + 75 | 0] >= 0) {
                                            u = t - -64 | 0, k = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[u + 8 >> 2];
                                            break r;
                                        }
                                        j(h, i[t + 64 >> 2], i[t + 68 >> 2]);
                                    }
                                    if (o[t + 75 | 0] < 0 && X(i[t + 64 >> 2]), n) break i;
                                }
                                p[i[i[r >> 2] + 64 >> 2]](t + 108 | 0, r, e, f, i[t + 140 >> 2], i[t + 136 >> 2]);
                                e: {
                                    if (i[t + 116 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 120 >> 2], i[A + 8 >> 2] = i[t + 116 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[t + 135 | 0] >= 0) {
                                            A = i[t + 128 >> 2], i[r >> 2] = i[t + 124 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 132 >> 2];
                                            break e;
                                        }
                                        j(r, i[t + 124 >> 2], i[t + 128 >> 2]);
                                        break e;
                                    }
                                    h = i[t + 112 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), k = i[r + 20 >> 2], V = i[k + 48 >> 2], C = i[k + 52 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1), v = i[t + 108 >> 2], i[t + 88 >> 2] = 0, i[t + 92 >> 2] = 0, i[t + 104 >> 2] = 0, i[t + 96 >> 2] = 0, i[t + 100 >> 2] = 0;
                                    r: {
                                        if (!l[e + 1 | 0]) {
                                            ye(t + 56 | 0, r);
                                            A: {
                                                if (i[t + 68 >> 2]) {
                                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 72 >> 2], i[A + 8 >> 2] = i[t + 68 >> 2], i[A + 12 >> 2] = k, n = A + 16 | 0, o[t + 87 | 0] >= 0) {
                                                        k = i[t + 80 >> 2], i[n >> 2] = i[t + 76 >> 2], i[n + 4 >> 2] = k, i[n + 8 >> 2] = i[t + 84 >> 2];
                                                        break A;
                                                    }
                                                    j(n, i[t + 76 >> 2], i[t + 80 >> 2]);
                                                    break A;
                                                }
                                                f: {
                                                    k: {
                                                        n: {
                                                            if (n = i[t + 56 >> 2], G = i[t + 60 >> 2], (n | 0) != (G | 0)) for(B = A + 16 | 0;;){
                                                                k = i[n >> 2];
                                                                t: {
                                                                    if (!k || (k = E0(k, 73632, 74784), !k)) break t;
                                                                    i[t + 4 >> 2] = k, u = i[n + 4 >> 2], i[t + 8 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), W7(t + 24 | 0, v, i[k + 100 >> 2], i[r + 20 >> 2] - -64 | 0), s = i[t + 32 >> 2];
                                                                    o: {
                                                                        if (s) {
                                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 92 >> 2], i[A + 8 >> 2] = i[t + 88 >> 2], i[A + 12 >> 2] = k, o[t + 107 | 0] >= 0) {
                                                                                k = i[t + 100 >> 2], i[B >> 2] = i[t + 96 >> 2], i[B + 4 >> 2] = k, i[B + 8 >> 2] = i[t + 104 >> 2];
                                                                                break o;
                                                                            }
                                                                            j(B, i[t + 96 >> 2], i[t + 100 >> 2]);
                                                                            break o;
                                                                        }
                                                                        k = i[t + 28 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), v = i[t + 24 >> 2];
                                                                        s: {
                                                                            if (!h || (u = i[h + 4 >> 2], i[h + 4 >> 2] = u - 1, u)) break s;
                                                                            p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                                                        }
                                                                        h = k;
                                                                    }
                                                                    o[t + 51 | 0] < 0 && X(i[t + 40 >> 2]), u = i[t + 28 >> 2];
                                                                    o: {
                                                                        if (!u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break o;
                                                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                    }
                                                                    if (s) break n;
                                                                    if (u = i[t + 8 >> 2], !u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break t;
                                                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                }
                                                                k = i[n >> 2];
                                                                t: {
                                                                    if (!k || (k = E0(k, 73632, 74856), !k)) break t;
                                                                    i[t + 4 >> 2] = k, u = i[n + 4 >> 2], i[t + 8 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), V7(t + 24 | 0, v, i[k + 100 >> 2], i[r + 20 >> 2] - -64 | 0), s = i[t + 32 >> 2];
                                                                    o: {
                                                                        if (s) {
                                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 92 >> 2], i[A + 8 >> 2] = i[t + 88 >> 2], i[A + 12 >> 2] = k, o[t + 107 | 0] >= 0) {
                                                                                k = i[t + 100 >> 2], i[B >> 2] = i[t + 96 >> 2], i[B + 4 >> 2] = k, i[B + 8 >> 2] = i[t + 104 >> 2];
                                                                                break o;
                                                                            }
                                                                            j(B, i[t + 96 >> 2], i[t + 100 >> 2]);
                                                                            break o;
                                                                        }
                                                                        k = i[t + 28 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), v = i[t + 24 >> 2];
                                                                        s: {
                                                                            if (!h || (u = i[h + 4 >> 2], i[h + 4 >> 2] = u - 1, u)) break s;
                                                                            p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                                                        }
                                                                        h = k;
                                                                    }
                                                                    o[t + 51 | 0] < 0 && X(i[t + 40 >> 2]), u = i[t + 28 >> 2];
                                                                    o: {
                                                                        if (!u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break o;
                                                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                    }
                                                                    if (s) break k;
                                                                    if (u = i[t + 8 >> 2], !u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break t;
                                                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                }
                                                                t: {
                                                                    if (f || (k = i[n >> 2], !k) || (k = E0(k, 73632, 74928), !k)) break t;
                                                                    i[t + 16 >> 2] = k, u = i[n + 4 >> 2], i[t + 20 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), _ = i[v + 28 >> 2], W = i[v + 24 >> 2], w = oi(k, W), s = x3(i[t + 16 >> 2], W), u = ti(i[t + 16 >> 2], _), k = z3(i[t + 16 >> 2], _);
                                                                    o: {
                                                                        if (w = (w | 0) > 0 ? w : 0, s = s >>> 0 < W >>> 0 ? s : W - 1 | 0, (w | 0) <= (s | 0) && (u = (u | 0) > 0 ? u : 0, k = k >>> 0 < _ >>> 0 ? k : _ - 1 | 0, (u | 0) <= (k | 0))) break o;
                                                                        o[t + 4 | 0] = 0, o[t + 15 | 0] = 0, n = i0(t + 24 | 0, 2, 120, t + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[n + 4 >> 2], i[A + 8 >> 2] = i[n >> 2], i[A + 12 >> 2] = k;
                                                                        s: {
                                                                            if (o[n + 19 | 0] >= 0) {
                                                                                k = i[n + 12 >> 2], i[B >> 2] = i[n + 8 >> 2], i[B + 4 >> 2] = k, i[B + 8 >> 2] = i[n + 16 >> 2];
                                                                                break s;
                                                                            }
                                                                            if (j(B, i[n + 8 >> 2], i[n + 12 >> 2]), o[n + 19 | 0] >= 0) break s;
                                                                            X(i[n + 8 >> 2]);
                                                                        }
                                                                        if (o[t + 15 | 0] >= 0) break f;
                                                                        X(i[t + 4 >> 2]);
                                                                        break f;
                                                                    }
                                                                    Z3(t + 24 | 0, v, w, s, u, k, i[r + 20 >> 2] - -64 | 0), s = i[t + 32 >> 2];
                                                                    o: {
                                                                        s: {
                                                                            if (s) {
                                                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[t + 36 >> 2], i[A + 8 >> 2] = i[t + 32 >> 2], i[A + 12 >> 2] = k, o[t + 51 | 0] >= 0) {
                                                                                    k = i[t + 44 >> 2], i[B >> 2] = i[t + 40 >> 2], i[B + 4 >> 2] = k, i[B + 8 >> 2] = i[t + 48 >> 2];
                                                                                    break o;
                                                                                }
                                                                                j(B, i[t + 40 >> 2], i[t + 44 >> 2]);
                                                                                break s;
                                                                            }
                                                                            k = i[t + 28 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), v = i[t + 24 >> 2];
                                                                            u: {
                                                                                if (!h || (u = i[h + 4 >> 2], i[h + 4 >> 2] = u - 1, u)) break u;
                                                                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                                                            }
                                                                            h = k;
                                                                        }
                                                                        if (o[t + 51 | 0] >= 0) break o;
                                                                        X(i[t + 40 >> 2]);
                                                                    }
                                                                    u = i[t + 28 >> 2];
                                                                    o: {
                                                                        if (!u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break o;
                                                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                    }
                                                                    if (s) break f;
                                                                    if (u = i[t + 20 >> 2], !u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break t;
                                                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                                }
                                                                if (n = n + 8 | 0, (G | 0) == (n | 0)) break;
                                                            }
                                                            w = 1;
                                                            break A;
                                                        }
                                                        B1(t + 4 | 0), w = 0;
                                                        break A;
                                                    }
                                                    B1(t + 4 | 0), w = 0;
                                                    break A;
                                                }
                                                B1(t + 16 | 0), w = 0;
                                            }
                                            if (o[t + 87 | 0] < 0 && X(i[t + 76 >> 2]), u = i[t + 56 >> 2], u) {
                                                if (k = u, n = i[t + 60 >> 2], (k | 0) != (n | 0)) {
                                                    for(;;){
                                                        s = i[n - 4 >> 2];
                                                        A: {
                                                            if (!s || (k = i[s + 4 >> 2], i[s + 4 >> 2] = k - 1, k)) break A;
                                                            p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                        }
                                                        if (n = n - 8 | 0, (u | 0) == (n | 0)) break;
                                                    }
                                                    k = i[t + 56 >> 2];
                                                }
                                                i[t + 60 >> 2] = u, X(k);
                                            }
                                            if (!w) break r;
                                        }
                                        k = i[r + 68 >> 2], W = i[r + 72 >> 2], W && (i[W + 4 >> 2] = i[W + 4 >> 2] + 1);
                                        A: {
                                            f: {
                                                k: {
                                                    if (!k) break k;
                                                    if (ii(t + 56 | 0, k, e, f, i[t + 140 >> 2], i[t + 136 >> 2]), i[t + 64 >> 2]) {
                                                        i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 68 >> 2], i[A + 8 >> 2] = i[t + 64 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                        n: {
                                                            if (o[t + 83 | 0] >= 0) {
                                                                A = i[t + 76 >> 2], i[r >> 2] = i[t + 72 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 80 >> 2];
                                                                break n;
                                                            }
                                                            if (j(r, i[t + 72 >> 2], i[t + 76 >> 2]), o[t + 83 | 0] >= 0) break n;
                                                            X(i[t + 72 >> 2]);
                                                        }
                                                        if (r = i[t + 60 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break A;
                                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                        break A;
                                                    }
                                                    if (f = i[t + 56 >> 2], i[t + 16 >> 2] = f, e = i[t + 60 >> 2], i[t + 20 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[f + 32 >> 2], e >>> 0 >= 3) {
                                                        e = a1(t + 4 | 0, 34896), f = i0(t + 24 | 0, 2, 3003, e), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                        n: {
                                                            if (o[f + 19 | 0] >= 0) {
                                                                A = i[f + 12 >> 2], i[r >> 2] = i[f + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 16 >> 2];
                                                                break n;
                                                            }
                                                            if (j(r, i[f + 8 >> 2], i[f + 12 >> 2]), o[f + 19 | 0] >= 0) break n;
                                                            X(i[f + 8 >> 2]);
                                                        }
                                                        if (o[e + 11 | 0] >= 0) break f;
                                                        X(i[e >> 2]);
                                                        break f;
                                                    }
                                                    G = i[(e << 2) + 43284 >> 2], e = i[v + 24 >> 2];
                                                    n: {
                                                        t: {
                                                            if ((e | 0) != i[k + 40 >> 2]) {
                                                                n = i[v + 28 >> 2];
                                                                break t;
                                                            }
                                                            if (n = i[v + 28 >> 2], (n | 0) == i[k + 44 >> 2]) break n;
                                                        }
                                                        i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, h3(t + 24 | 0, f, t + 4 | 0, e, n, i[r + 20 >> 2] - -64 | 0), k = i[t + 24 >> 2];
                                                        t: {
                                                            if (k) {
                                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[t + 28 >> 2], i[A + 8 >> 2] = i[t + 24 >> 2], i[A + 12 >> 2] = e, f = A + 16 | 0, o[t + 43 | 0] >= 0) {
                                                                    e = i[t + 36 >> 2], i[f >> 2] = i[t + 32 >> 2], i[f + 4 >> 2] = e, i[f + 8 >> 2] = i[t + 40 >> 2];
                                                                    break t;
                                                                }
                                                                j(f, i[t + 32 >> 2], i[t + 36 >> 2]);
                                                                break t;
                                                            }
                                                            if (f = i[t + 4 >> 2], e = i[t + 8 >> 2], i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, n = i[t + 20 >> 2], i[t + 16 >> 2] = f, i[t + 20 >> 2] = e, !n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break t;
                                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                        }
                                                        o[t + 43 | 0] < 0 && X(i[t + 32 >> 2]), f = i[t + 8 >> 2];
                                                        t: {
                                                            if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break t;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        if (k) break f;
                                                    }
                                                    _ = m - 48 | 0, m = _, n = i[t + 16 >> 2], u = i[n + 64 >> 2];
                                                    n: {
                                                        t: {
                                                            if (!u) {
                                                                w = n - -64 | 0, e = w;
                                                                break t;
                                                            }
                                                            for(k = u;;){
                                                                if (e = k, f = i[k + 16 >> 2], (f | 0) > (G | 0)) {
                                                                    if (w = k, k = i[k >> 2], k) continue;
                                                                    break t;
                                                                }
                                                                if ((f | 0) >= (G | 0)) break n;
                                                                if (k = i[e + 4 >> 2], !k) break;
                                                            }
                                                            w = e + 4 | 0;
                                                        }
                                                        k = D(56), i[k + 16 >> 2] = G, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 20 >> 2] = 1, i[k + 24 >> 2] = 256, i[k + 8 >> 2] = e, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[w >> 2] = k, e = k, f = i[i[n + 60 >> 2] >> 2], f && (i[n + 60 >> 2] = f, e = i[w >> 2]), h4(i[n + 64 >> 2], e), i[n + 68 >> 2] = i[n + 68 >> 2] + 1, n = i[t + 16 >> 2], u = i[n + 64 >> 2];
                                                    }
                                                    i[_ + 40 >> 2] = i[k + 52 >> 2], e = i[k + 48 >> 2], i[_ + 32 >> 2] = i[k + 44 >> 2], i[_ + 36 >> 2] = e, e = i[k + 40 >> 2], i[_ + 24 >> 2] = i[k + 36 >> 2], i[_ + 28 >> 2] = e, e = i[k + 32 >> 2], i[_ + 16 >> 2] = i[k + 28 >> 2], i[_ + 20 >> 2] = e, e = i[k + 24 >> 2], i[_ + 8 >> 2] = i[k + 20 >> 2], i[_ + 12 >> 2] = e;
                                                    n: {
                                                        if (!u) break n;
                                                        for(s = n - -64 | 0, k = s, e = u; f = (G | 0) > i[e + 16 >> 2], k = f ? k : e, e = i[(f << 2) + e >> 2], !!e;);
                                                        if ((k | 0) == (s | 0) | (G | 0) < i[k + 16 >> 2]) break n;
                                                        f = i[k + 4 >> 2];
                                                        t: {
                                                            if (!f) {
                                                                for(f = k; e = i[f + 8 >> 2], s = i[e >> 2] != (f | 0), f = e, !!s;);
                                                                break t;
                                                            }
                                                            for(; e = f, f = i[f >> 2], !!f;);
                                                        }
                                                        i[n + 60 >> 2] == (k | 0) && (i[n + 60 >> 2] = e), i[n + 68 >> 2] = i[n + 68 >> 2] - 1;
                                                        t: {
                                                            o: {
                                                                if (f = k, e = i[f >> 2], e) {
                                                                    if (n = i[f + 4 >> 2], !n) break o;
                                                                    for(; f = n, n = i[f >> 2], !!n;);
                                                                }
                                                                if (e = i[f + 4 >> 2], e) break o;
                                                                w = i[f + 8 >> 2], e = 0, s = 1;
                                                                break t;
                                                            }
                                                            w = i[f + 8 >> 2], i[e + 8 >> 2] = w, s = 0;
                                                        }
                                                        n = i[w >> 2];
                                                        t: {
                                                            if ((n | 0) == (f | 0)) {
                                                                if (i[w >> 2] = e, (f | 0) == (u | 0)) {
                                                                    n = 0, u = e;
                                                                    break t;
                                                                }
                                                                n = i[w + 4 >> 2];
                                                                break t;
                                                            }
                                                            i[w + 4 >> 2] = e;
                                                        }
                                                        G = l[f + 12 | 0], (f | 0) != (k | 0) && (w = i[k + 8 >> 2], i[f + 8 >> 2] = w, i[w + ((i[w >> 2] != (k | 0)) << 2) >> 2] = f, w = i[k >> 2], i[f >> 2] = w, i[w + 8 >> 2] = f, w = i[k + 4 >> 2], i[f + 4 >> 2] = w, w && (i[w + 8 >> 2] = f), o[f + 12 | 0] = l[k + 12 | 0], u = (k | 0) == (u | 0) ? f : u);
                                                        t: {
                                                            if (!u | !(G & 1)) break t;
                                                            if (s) for(;;){
                                                                e = l[n + 12 | 0];
                                                                o: {
                                                                    if (s = i[n + 8 >> 2], f = i[s >> 2], (f | 0) != (n | 0)) {
                                                                        e & 1 || (o[n + 12 | 0] = 1, o[s + 12 | 0] = 0, f = i[s + 4 >> 2], e = i[f >> 2], i[s + 4 >> 2] = e, e && (i[e + 8 >> 2] = s), e = i[s + 8 >> 2], i[f + 8 >> 2] = e, i[e + (((s | 0) != i[e >> 2]) << 2) >> 2] = f, i[f >> 2] = s, i[s + 8 >> 2] = f, e = i[n >> 2], u = (e | 0) == (u | 0) ? n : u, n = i[e + 4 >> 2]);
                                                                        s: {
                                                                            u: {
                                                                                f = i[n >> 2];
                                                                                w: {
                                                                                    if (!(l[f + 12 | 0] != 1 && f)) {
                                                                                        if (e = i[n + 4 >> 2], l[e + 12 | 0] != 1 && e) break w;
                                                                                        if (o[n + 12 | 0] = 0, n = i[n + 8 >> 2], l[n + 12 | 0] && (u | 0) != (n | 0)) break o;
                                                                                        o[n + 12 | 0] = 1;
                                                                                        break t;
                                                                                    }
                                                                                    if (e = i[n + 4 >> 2], !e) break u;
                                                                                }
                                                                                if (l[e + 12 | 0] == 1) break u;
                                                                                f = n;
                                                                                break s;
                                                                            }
                                                                            o[f + 12 | 0] = 1, o[n + 12 | 0] = 0, e = i[f + 4 >> 2], i[n >> 2] = e, e && (i[e + 8 >> 2] = n), e = i[n + 8 >> 2], i[f + 8 >> 2] = e, i[e + ((i[e >> 2] != (n | 0)) << 2) >> 2] = f, i[f + 4 >> 2] = n, i[n + 8 >> 2] = f, e = n;
                                                                        }
                                                                        n = i[f + 8 >> 2], o[f + 12 | 0] = l[n + 12 | 0], o[n + 12 | 0] = 1, o[e + 12 | 0] = 1, f = i[n + 4 >> 2], e = i[f >> 2], i[n + 4 >> 2] = e, e && (i[e + 8 >> 2] = n), e = i[n + 8 >> 2], i[f + 8 >> 2] = e, i[e + (((n | 0) != i[e >> 2]) << 2) >> 2] = f, i[f >> 2] = n, i[n + 8 >> 2] = f;
                                                                        break t;
                                                                    }
                                                                    e & 1 || (o[n + 12 | 0] = 1, o[s + 12 | 0] = 0, e = i[f + 4 >> 2], i[s >> 2] = e, e && (i[e + 8 >> 2] = s), e = i[s + 8 >> 2], i[f + 8 >> 2] = e, i[e + (((s | 0) != i[e >> 2]) << 2) >> 2] = f, i[f + 4 >> 2] = s, i[s + 8 >> 2] = f, e = i[n + 4 >> 2], u = (e | 0) == (u | 0) ? n : u, n = i[e >> 2]);
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    if (e = i[n >> 2], e && (f = l[e + 12 | 0], (f | 0) != 1)) break l;
                                                                                    if (f = i[n + 4 >> 2], !(l[f + 12 | 0] != 1 && f)) {
                                                                                        if (o[n + 12 | 0] = 0, n = i[n + 8 >> 2], l[n + 12 | 0] == 1 & (n | 0) != (u | 0)) break o;
                                                                                        o[n + 12 | 0] = 1;
                                                                                        break t;
                                                                                    }
                                                                                    if (!e) break u;
                                                                                    if (o[e + 12 | 0] & 1) break w;
                                                                                    f = n;
                                                                                    break s;
                                                                                }
                                                                                if (f) break w;
                                                                                f = n;
                                                                                break s;
                                                                            }
                                                                            f = i[n + 4 >> 2];
                                                                        }
                                                                        o[f + 12 | 0] = 1, o[n + 12 | 0] = 0, e = i[f >> 2], i[n + 4 >> 2] = e, e && (i[e + 8 >> 2] = n), e = i[n + 8 >> 2], i[f + 8 >> 2] = e, i[e + ((i[e >> 2] != (n | 0)) << 2) >> 2] = f, i[f >> 2] = n, i[n + 8 >> 2] = f, e = n;
                                                                    }
                                                                    n = i[f + 8 >> 2], o[f + 12 | 0] = l[n + 12 | 0], o[n + 12 | 0] = 1, o[e + 12 | 0] = 1, f = i[n >> 2], e = i[f + 4 >> 2], i[n >> 2] = e, e && (i[e + 8 >> 2] = n), e = i[n + 8 >> 2], i[f + 8 >> 2] = e, i[e + (((n | 0) != i[e >> 2]) << 2) >> 2] = f, i[f + 4 >> 2] = n, i[n + 8 >> 2] = f;
                                                                    break t;
                                                                }
                                                                e = i[n + 8 >> 2], n = i[((i[e >> 2] == (n | 0)) << 2) + e >> 2];
                                                            }
                                                            o[e + 12 | 0] = 1;
                                                        }
                                                        X(k);
                                                    }
                                                    k = i[v + 64 >> 2];
                                                    n: {
                                                        t: {
                                                            if (!k) {
                                                                f = v - -64 | 0, e = f;
                                                                break t;
                                                            }
                                                            for(;;){
                                                                if (e = k, f = i[k + 16 >> 2], (f | 0) > 6) {
                                                                    if (f = k, k = i[f >> 2], k) continue;
                                                                    break t;
                                                                }
                                                                if ((f | 0) >= 6) break n;
                                                                if (k = i[e + 4 >> 2], !k) break;
                                                            }
                                                            f = e + 4 | 0;
                                                        }
                                                        k = D(56), i[k + 16 >> 2] = 6, n = i[_ + 12 >> 2], i[k + 20 >> 2] = i[_ + 8 >> 2], i[k + 24 >> 2] = n, n = i[_ + 20 >> 2], i[k + 28 >> 2] = i[_ + 16 >> 2], i[k + 32 >> 2] = n, n = i[_ + 28 >> 2], i[k + 36 >> 2] = i[_ + 24 >> 2], i[k + 40 >> 2] = n, n = i[_ + 36 >> 2], i[k + 44 >> 2] = i[_ + 32 >> 2], i[k + 48 >> 2] = n, i[k + 52 >> 2] = i[_ + 40 >> 2], i[k + 8 >> 2] = e, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[f >> 2] = k, e = i[i[v + 60 >> 2] >> 2], e && (i[v + 60 >> 2] = e, k = i[f >> 2]), h4(i[v + 64 >> 2], k), i[v + 68 >> 2] = i[v + 68 >> 2] + 1;
                                                    }
                                                    m = _ + 48 | 0, l[r + 65 | 0] == 1 && (o[v + 40 | 0] = 1), f = i[t + 20 >> 2];
                                                    n: {
                                                        if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break n;
                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                    }
                                                    if (o[t + 83 | 0] < 0 && X(i[t + 72 >> 2]), f = i[t + 60 >> 2], !f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break k;
                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                }
                                                e = i[r + 192 >> 2], B = i[r + 196 >> 2];
                                                k: {
                                                    n: {
                                                        if (!B) {
                                                            if (e) break n;
                                                            break k;
                                                        }
                                                        if (i[B + 4 >> 2] = i[B + 4 >> 2] + 1, !e) break k;
                                                        i[B + 4 >> 2] = i[B + 4 >> 2] + 1;
                                                    }
                                                    if (i[v + 44 >> 2] = e, f = i[v + 48 >> 2], i[v + 48 >> 2] = B, !f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break k;
                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                }
                                                e = i[r + 200 >> 2], _ = i[r + 204 >> 2];
                                                k: {
                                                    n: {
                                                        if (!_) {
                                                            if (e) break n;
                                                            break k;
                                                        }
                                                        if (i[_ + 4 >> 2] = i[_ + 4 >> 2] + 1, !e) break k;
                                                        i[_ + 4 >> 2] = i[_ + 4 >> 2] + 1;
                                                    }
                                                    if (i[v + 52 >> 2] = e, f = i[v + 56 >> 2], i[v + 56 >> 2] = _, !f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break k;
                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                }
                                                w = i[V + 56 >> 2], w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1), s = i[V + 64 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), f = i[r + 24 >> 2], k = i[r + 28 >> 2];
                                                k: {
                                                    if ((f | 0) == (k | 0)) break k;
                                                    n = f;
                                                    n: {
                                                        for(;;){
                                                            t: {
                                                                if (e = i[n >> 2], !e || (e = E0(e, 73632, 75864), !e)) break t;
                                                                G = i[n + 4 >> 2], G && (i[G + 4 >> 2] = i[G + 4 >> 2] + 1), i[v + 80 >> 2] = I[e + 98 >> 1] | I[e + 100 >> 1] << 16, k = i[r + 28 >> 2], f = i[r + 24 >> 2];
                                                                break n;
                                                            }
                                                            if (n = n + 8 | 0, (n | 0) == (k | 0)) break;
                                                        }
                                                        G = 0;
                                                    }
                                                    n: {
                                                        if ((f | 0) != (k | 0)) for(n = f;;){
                                                            t: {
                                                                if (e = i[n >> 2], !e || (u = E0(e, 73632, 75876), !u)) break t;
                                                                e = i[n + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), f = i[u + 104 >> 2], i[v + 84 >> 2] = i[u + 100 >> 2], i[v + 88 >> 2] = f, f = i[u + 120 >> 2], i[v + 100 >> 2] = i[u + 116 >> 2], i[v + 104 >> 2] = f, f = i[u + 112 >> 2], i[v + 92 >> 2] = i[u + 108 >> 2], i[v + 96 >> 2] = f, o[v + 108 | 0] = 1, k = i[r + 28 >> 2], f = i[r + 24 >> 2];
                                                                break n;
                                                            }
                                                            if (n = n + 8 | 0, (n | 0) == (k | 0)) break;
                                                        }
                                                        e = 0;
                                                    }
                                                    n: {
                                                        if ((f | 0) == (k | 0)) break n;
                                                        for(;;){
                                                            t: {
                                                                o: {
                                                                    if (r = i[f >> 2], !r || (n = E0(r, 73632, 75720), !n)) break o;
                                                                    if (f = i[f + 4 >> 2], f) break t;
                                                                    r = i[n + 104 >> 2], i[v + 72 >> 2] = i[n + 100 >> 2], i[v + 76 >> 2] = r;
                                                                    break n;
                                                                }
                                                                if (f = f + 8 | 0, (k | 0) != (f | 0)) continue;
                                                                break n;
                                                            }
                                                            break;
                                                        }
                                                        if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, r = i[n + 104 >> 2], i[v + 72 >> 2] = i[n + 100 >> 2], i[v + 76 >> 2] = r, r = i[f + 4 >> 2], i[f + 4 >> 2] = r - 1, r) break n;
                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                    }
                                                    n: {
                                                        if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break n;
                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                    }
                                                    if (!G || (r = i[G + 4 >> 2], i[G + 4 >> 2] = r - 1, r)) break k;
                                                    p[i[i[G >> 2] + 8 >> 2]](G), g(G);
                                                }
                                                k: {
                                                    if (!s || (r = i[s + 4 >> 2], i[s + 4 >> 2] = r - 1, r)) break k;
                                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                                }
                                                k: {
                                                    if (!w || (r = i[w + 4 >> 2], i[w + 4 >> 2] = r - 1, r)) break k;
                                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                                }
                                                i[A + 4 >> 2] = h, i[A >> 2] = v, h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                k: {
                                                    if (o[86691] >= 0) {
                                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                        break k;
                                                    }
                                                    j(r, i[21670], i[21671]);
                                                }
                                                k: {
                                                    if (!_ || (A = i[_ + 4 >> 2], i[_ + 4 >> 2] = A - 1, A)) break k;
                                                    p[i[i[_ >> 2] + 8 >> 2]](_), g(_);
                                                }
                                                if (!B || (A = i[B + 4 >> 2], i[B + 4 >> 2] = A - 1, A)) break A;
                                                p[i[i[B >> 2] + 8 >> 2]](B), g(B);
                                                break A;
                                            }
                                            r = i[t + 20 >> 2];
                                            f: {
                                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break f;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            if (o[t + 83 | 0] < 0 && X(i[t + 72 >> 2]), r = i[t + 60 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (!W || (A = i[W + 4 >> 2], i[W + 4 >> 2] = A - 1, A)) break r;
                                        p[i[i[W >> 2] + 8 >> 2]](W), g(W);
                                    }
                                    o[t + 107 | 0] < 0 && X(i[t + 96 >> 2]);
                                    r: {
                                        if (!C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break r;
                                        p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                                    }
                                    if (!h || (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                }
                                if (o[t + 135 | 0] < 0 && X(i[t + 124 >> 2]), r = i[t + 112 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = t + 144 | 0;
                        }
                        function ei(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            v = m - 176 | 0, m = v;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (_ = i[r + 104 >> 2], r = i[r + 108 >> 2], (_ | 0) != (r | 0)) for(;;){
                                                    if (i[_ >> 2] == (e | 0)) break f;
                                                    if (_ = _ + 32 | 0, (r | 0) == (_ | 0)) break;
                                                }
                                                i[v + 40 >> 2] = 59808, i[v + 96 >> 2] = 59828, r = i[14961], i[v + 32 >> 2] = r, f = i[r - 12 >> 2], r = v + 32 | 0, i[f + r >> 2] = i[14962], i[v + 36 >> 2] = 0, f = r + i[i[v + 32 >> 2] - 12 >> 2] | 0, k = v + 44 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[v + 40 >> 2] = f, n = v + 40 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[v + 32 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[v + 96 >> 2] = 59828, i[v + 32 >> 2] = 59788, i[v + 40 >> 2] = 59808, f = z0(k), i[f >> 2] = 58864, i[v + 84 >> 2] = 0, i[v + 88 >> 2] = 0, i[v + 76 >> 2] = 0, i[v + 80 >> 2] = 0, i[v + 92 >> 2] = 24, U(M0(U(n, 22593, 13), e), 15606, 23), r = i[v + 92 >> 2];
                                                k: {
                                                    if (r & 16) {
                                                        _ = i[v + 88 >> 2], r = i[v + 68 >> 2], _ >>> 0 < r >>> 0 && (i[v + 88 >> 2] = r, _ = r), r = v - -64 | 0;
                                                        break k;
                                                    }
                                                    if (!(r & 8)) {
                                                        _ = 0, o[v + 31 | 0] = 0, e = v + 20 | 0;
                                                        break r;
                                                    }
                                                    _ = i[v + 60 >> 2], r = v + 52 | 0;
                                                }
                                                if (r = i[r >> 2], _ = _ - r | 0, _ >>> 0 >= 2147483640) break i;
                                                if (_ >>> 0 >= 11) {
                                                    k = (_ | 7) + 1 | 0, e = D(k), i[v + 28 >> 2] = k | -2147483648, i[v + 20 >> 2] = e, i[v + 24 >> 2] = _;
                                                    break A;
                                                }
                                                if (o[v + 31 | 0] = _, e = v + 20 | 0, _) break A;
                                                _ = 0;
                                                break r;
                                            }
                                            M = s, E = h;
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    if (e = i[_ + 16 >> 2], $ = i[_ + 20 >> 2], (e | 0) != ($ | 0)) for(;;){
                                                                        u: {
                                                                            w: {
                                                                                l: switch(l[_ + 4 | 0]){
                                                                                    case 0:
                                                                                        C = i[e + 8 >> 2];
                                                                                        h: {
                                                                                            r = i[e + 12 >> 2];
                                                                                            v: {
                                                                                                if (r >>> 0 > 8388607 || (W = i[_ + 8 >> 2], B = i[_ + 12 >> 2], V = B, B >>> 0 > 8388607)) break v;
                                                                                                if (B = i[e + 16 >> 2], F = i[e + 20 >> 2], F >>> 0 < 8388608) break h;
                                                                                            }
                                                                                            if (r = D(40), i[v + 32 >> 2] = r, i[v + 36 >> 2] = 39, i[v + 40 >> 2] = -2147483608, e = l[11291] | l[11292] << 8 | (l[11293] << 16 | l[11294] << 24), f = l[11287] | l[11288] << 8 | (l[11289] << 16 | l[11290] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 39 | 0] = 0, e = l[11322] | l[11323] << 8 | (l[11324] << 16 | l[11325] << 24), f = l[11318] | l[11319] << 8 | (l[11320] << 16 | l[11321] << 24), o[r + 31 | 0] = f, o[r + 32 | 0] = f >>> 8, o[r + 33 | 0] = f >>> 16, o[r + 34 | 0] = f >>> 24, o[r + 35 | 0] = e, o[r + 36 | 0] = e >>> 8, o[r + 37 | 0] = e >>> 16, o[r + 38 | 0] = e >>> 24, e = l[11315] | l[11316] << 8 | (l[11317] << 16 | l[11318] << 24), f = l[11311] | l[11312] << 8 | (l[11313] << 16 | l[11314] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[11307] | l[11308] << 8 | (l[11309] << 16 | l[11310] << 24), f = l[11303] | l[11304] << 8 | (l[11305] << 16 | l[11306] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[11299] | l[11300] << 8 | (l[11301] << 16 | l[11302] << 24), f = l[11295] | l[11296] << 8 | (l[11297] << 16 | l[11298] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 1e3, v + 32 | 0), o[v + 43 | 0] >= 0) break e;
                                                                                            X(i[v + 32 >> 2]);
                                                                                            break e;
                                                                                        }
                                                                                        y = i[f >> 2], r = r + V | 0, V = W, W = W + C | 0, C = F + (V >>> 0 > W >>> 0 ? r + 1 | 0 : r) | 0, r = B + W | 0, C = r >>> 0 < B >>> 0 ? C + 1 | 0 : C;
                                                                                        h: switch((p[i[i[y >> 2] + 12 >> 2]](y, r, C) | 0) - 1 | 0){
                                                                                            case 1:
                                                                                                i[n + 4 >> 2] = i[n >> 2], i[v + 40 >> 2] = 59808, i[v + 96 >> 2] = 59828, r = i[14961], i[v + 32 >> 2] = r, f = i[r - 12 >> 2], r = v + 32 | 0, i[f + r >> 2] = i[14962], i[v + 36 >> 2] = 0, f = r + i[i[v + 32 >> 2] - 12 >> 2] | 0, k = v + 44 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[v + 40 >> 2] = f, n = v + 40 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[v + 32 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[v + 96 >> 2] = 59828, i[v + 32 >> 2] = 59788, i[v + 40 >> 2] = 59808, f = z0(k), i[f >> 2] = 58864, i[v + 84 >> 2] = 0, i[v + 88 >> 2] = 0, i[v + 76 >> 2] = 0, i[v + 80 >> 2] = 0, i[v + 92 >> 2] = 24, n = U(U(n, 21406, 58), 21731, 25), r = i[_ + 12 >> 2] + i[e + 12 >> 2] | 0, t = i[e + 8 >> 2], k = t + i[_ + 8 >> 2] | 0, U(K1(n, k, k >>> 0 < t >>> 0 ? r + 1 | 0 : r), 34894, 2), r = i[v + 92 >> 2];
                                                                                                v: {
                                                                                                    if (r & 16) {
                                                                                                        _ = i[v + 88 >> 2], r = i[v + 68 >> 2], _ >>> 0 < r >>> 0 && (i[v + 88 >> 2] = r, _ = r), r = v - -64 | 0;
                                                                                                        break v;
                                                                                                    }
                                                                                                    if (!(r & 8)) {
                                                                                                        _ = 0, o[v + 31 | 0] = 0, e = v + 20 | 0;
                                                                                                        break f;
                                                                                                    }
                                                                                                    _ = i[v + 60 >> 2], r = v + 52 | 0;
                                                                                                }
                                                                                                if (r = i[r >> 2], _ = _ - r | 0, _ >>> 0 >= 2147483640) break i;
                                                                                                if (_ >>> 0 >= 11) {
                                                                                                    k = (_ | 7) + 1 | 0, e = D(k), i[v + 28 >> 2] = k | -2147483648, i[v + 20 >> 2] = e, i[v + 24 >> 2] = _;
                                                                                                    break k;
                                                                                                }
                                                                                                if (o[v + 31 | 0] = _, e = v + 20 | 0, _) break k;
                                                                                                _ = 0;
                                                                                                break f;
                                                                                            case 0:
                                                                                                if (o[v + 32 | 0] = 0, o[v + 43 | 0] = 0, i0(A, 2, 100, v + 32 | 0), o[v + 43 | 0] >= 0) break e;
                                                                                                X(i[v + 32 >> 2]);
                                                                                                break e;
                                                                                            default:
                                                                                                break h;
                                                                                        }
                                                                                        if (B = i[e + 16 >> 2], C = i[e + 20 >> 2], V = (C | 0) == (u | 0) & t >>> 0 > B >>> 0 | u >>> 0 > C >>> 0, r = V ? B : t, W = t - r | 0, V = V ? C : u, u = u - (V + (r >>> 0 > t >>> 0) | 0) | 0, t = W, u | W || (W = B - r | 0, B = C - ((r >>> 0 > B >>> 0) + V | 0) | 0, C = (E | 0) == (B | 0) & W >>> 0 > M >>> 0 | B >>> 0 > E >>> 0, W = C ? M : W, B = C ? E : B, C = B, !(B | W))) break u;
                                                                                        B = i[n + 4 >> 2] - i[n >> 2] | 0;
                                                                                        h: {
                                                                                            if (t = i[w + 40 >> 2], u = i[w + 44 >> 2], !(t | u) || (y = u - (t >>> 0 < B >>> 0) | 0, (C | 0) == (y | 0) & W >>> 0 <= t - B >>> 0 | C >>> 0 < y >>> 0)) break h;
                                                                                            i[v + 40 >> 2] = 59808, i[v + 96 >> 2] = 59828, r = i[14961], i[v + 32 >> 2] = r, f = i[r - 12 >> 2], r = v + 32 | 0, i[f + r >> 2] = i[14962], i[v + 36 >> 2] = 0, f = r + i[i[v + 32 >> 2] - 12 >> 2] | 0, k = v + 44 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[v + 40 >> 2] = f, n = v + 40 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[v + 32 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[v + 96 >> 2] = 59828, i[v + 32 >> 2] = 59788, i[v + 40 >> 2] = 59808, f = z0(k), i[f >> 2] = 58864, i[v + 84 >> 2] = 0, i[v + 88 >> 2] = 0, i[v + 76 >> 2] = 0, i[v + 80 >> 2] = 0, i[v + 92 >> 2] = 24, k = U(K1(U(n, 22431, 19), i[e + 16 >> 2], i[e + 20 >> 2]), 22349, 35), r = i[e + 20 >> 2], e = B + i[e + 16 >> 2] | 0, r = e >>> 0 < B >>> 0 ? r + 1 | 0 : r, U(K1(U(K1(k, e, r), 22121, 40), t, u), 4486, 6), r = i[v + 92 >> 2];
                                                                                            v: {
                                                                                                if (r & 16) {
                                                                                                    _ = i[v + 88 >> 2], r = i[v + 68 >> 2], _ >>> 0 < r >>> 0 && (i[v + 88 >> 2] = r, _ = r), r = v - -64 | 0;
                                                                                                    break v;
                                                                                                }
                                                                                                if (!(r & 8)) {
                                                                                                    _ = 0, o[v + 31 | 0] = 0, e = v + 20 | 0;
                                                                                                    break n;
                                                                                                }
                                                                                                _ = i[v + 60 >> 2], r = v + 52 | 0;
                                                                                            }
                                                                                            if (r = i[r >> 2], _ = _ - r | 0, _ >>> 0 >= 2147483640) break i;
                                                                                            if (_ >>> 0 >= 11) {
                                                                                                k = (_ | 7) + 1 | 0, e = D(k), i[v + 28 >> 2] = k | -2147483648, i[v + 20 >> 2] = e, i[v + 24 >> 2] = _;
                                                                                                break t;
                                                                                            }
                                                                                            if (o[v + 31 | 0] = _, e = v + 20 | 0, _) break t;
                                                                                            _ = 0;
                                                                                            break n;
                                                                                        }
                                                                                        if (F = i[f >> 2], y = i[_ + 8 >> 2], t = V + i[e + 12 >> 2] | 0, u = r + i[e + 8 >> 2] | 0, r = i[_ + 12 >> 2] + (u >>> 0 < r >>> 0 ? t + 1 | 0 : t) | 0, t = u + y | 0, u = t >>> 0 < u >>> 0 ? r + 1 | 0 : r, r = C + u | 0, V = t + W | 0, r = V >>> 0 < W >>> 0 ? r + 1 | 0 : r, V = p[i[i[F >> 2] + 24 >> 2]](F, t, u, V, r) | 0, r = i[f >> 2], !(w0 | V)) {
                                                                                            if (e = i[r + 8 >> 2], i[A >> 2] = i[r + 4 >> 2], i[A + 4 >> 2] = e, A = A + 8 | 0, o[r + 23 | 0] >= 0) {
                                                                                                e = i[r + 16 >> 2], i[A >> 2] = i[r + 12 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 20 >> 2];
                                                                                                break e;
                                                                                            }
                                                                                            j(A, i[r + 12 >> 2], i[r + 16 >> 2]);
                                                                                            break e;
                                                                                        }
                                                                                        if (!(p[i[i[r >> 2] + 20 >> 2]](r, t, u) | 0)) {
                                                                                            if (r = A, A = a1(v + 32 | 0, 6614), i0(r, 2, 0, A), o[A + 11 | 0] >= 0) break e;
                                                                                            X(i[A >> 2]);
                                                                                            break e;
                                                                                        }
                                                                                        r = B + W | 0, u = i[n >> 2], t = i[n + 4 >> 2] - u | 0;
                                                                                        h: {
                                                                                            if (r >>> 0 > t >>> 0) {
                                                                                                r1(n, r - t | 0);
                                                                                                break h;
                                                                                            }
                                                                                            r >>> 0 < t >>> 0 && (i[n + 4 >> 2] = r + u);
                                                                                        }
                                                                                        if (r = i[f >> 2], p[i[i[r >> 2] + 16 >> 2]](r, B + i[n >> 2] | 0, W) | 0) break w;
                                                                                        if (r = A, A = a1(v + 32 | 0, 10764), i0(r, 2, 0, A), o[A + 11 | 0] >= 0) break e;
                                                                                        X(i[A >> 2]);
                                                                                        break e;
                                                                                    case 1:
                                                                                        if (H = i[k >> 2], !H) {
                                                                                            if (r = D(56), i[v + 32 >> 2] = r, i[v + 36 >> 2] = 54, i[v + 40 >> 2] = -2147483592, e = l[10793] | l[10794] << 8 | (l[10795] << 16 | l[10796] << 24), f = l[10789] | l[10790] << 8 | (l[10791] << 16 | l[10792] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 54 | 0] = 0, e = l[10839] | l[10840] << 8 | (l[10841] << 16 | l[10842] << 24), f = l[10835] | l[10836] << 8 | (l[10837] << 16 | l[10838] << 24), o[r + 46 | 0] = f, o[r + 47 | 0] = f >>> 8, o[r + 48 | 0] = f >>> 16, o[r + 49 | 0] = f >>> 24, o[r + 50 | 0] = e, o[r + 51 | 0] = e >>> 8, o[r + 52 | 0] = e >>> 16, o[r + 53 | 0] = e >>> 24, e = l[10833] | l[10834] << 8 | (l[10835] << 16 | l[10836] << 24), f = l[10829] | l[10830] << 8 | (l[10831] << 16 | l[10832] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[10825] | l[10826] << 8 | (l[10827] << 16 | l[10828] << 24), f = l[10821] | l[10822] << 8 | (l[10823] << 16 | l[10824] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[10817] | l[10818] << 8 | (l[10819] << 16 | l[10820] << 24), f = l[10813] | l[10814] << 8 | (l[10815] << 16 | l[10816] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[10809] | l[10810] << 8 | (l[10811] << 16 | l[10812] << 24), f = l[10805] | l[10806] << 8 | (l[10807] << 16 | l[10808] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[10801] | l[10802] << 8 | (l[10803] << 16 | l[10804] << 24), f = l[10797] | l[10798] << 8 | (l[10799] << 16 | l[10800] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 103, v + 32 | 0), o[v + 43 | 0] >= 0) break e;
                                                                                            X(i[v + 32 >> 2]);
                                                                                            break e;
                                                                                        }
                                                                                        r = i[e + 8 >> 2], B = r + i[_ + 8 >> 2] | 0, C = i[_ + 12 >> 2] + i[e + 12 >> 2] | 0, C = r >>> 0 > B >>> 0 ? C + 1 | 0 : C, W = i[e + 16 >> 2], F = i[e + 20 >> 2], G = m - 160 | 0, m = G, S = i[n + 4 >> 2] - i[n >> 2] | 0, r = i[w + 40 >> 2], V = r;
                                                                                        h: {
                                                                                            v: {
                                                                                                _: {
                                                                                                    B: {
                                                                                                        m: {
                                                                                                            if (y = i[w + 44 >> 2], !(y | r) || (R = r - S | 0, r = y - (r >>> 0 < S >>> 0) | 0, (F | 0) == (r | 0) & W >>> 0 <= R >>> 0 | r >>> 0 > F >>> 0)) break m;
                                                                                                            i[G + 24 >> 2] = 59808, i[G + 80 >> 2] = 59828, r = i[14961], i[G + 16 >> 2] = r, B = i[r - 12 >> 2], r = G + 16 | 0, i[B + r >> 2] = i[14962], i[G + 20 >> 2] = 0, B = r + i[i[G + 16 >> 2] - 12 >> 2] | 0, C = G + 28 | 0, T0(B, C), i[B + 72 >> 2] = 0, i[B + 76 >> 2] = -1, B = i[14963], i[G + 24 >> 2] = B, T = i[B - 12 >> 2], B = G + 24 | 0, i[T + B >> 2] = i[14964], R = i[14960], i[G + 16 >> 2] = R, i[r + i[R - 12 >> 2] >> 2] = i[14965], i[G + 80 >> 2] = 59828, i[G + 16 >> 2] = 59788, i[G + 24 >> 2] = 59808, C = z0(C), i[C >> 2] = 58864, i[G + 68 >> 2] = 0, i[G + 72 >> 2] = 0, i[G + 60 >> 2] = 0, i[G + 64 >> 2] = 0, i[G + 76 >> 2] = 24, B = U(K1(U(B, 22411, 19), W, F), 22349, 35), r = F, W = W + S | 0, r = W >>> 0 < S >>> 0 ? r + 1 | 0 : r, U(K1(U(K1(B, W, r), 22121, 40), V, y), 4486, 6), r = i[G + 76 >> 2];
                                                                                                            Z: {
                                                                                                                if (r & 16) {
                                                                                                                    B = G + 48 | 0, W = i[G + 72 >> 2], r = i[G + 52 >> 2], W >>> 0 < r >>> 0 ? i[G + 72 >> 2] = r : r = W;
                                                                                                                    break Z;
                                                                                                                }
                                                                                                                if (!(r & 8)) {
                                                                                                                    r = 0, o[G + 15 | 0] = 0, B = G + 4 | 0;
                                                                                                                    break v;
                                                                                                                }
                                                                                                                B = G + 36 | 0, r = i[G + 44 >> 2];
                                                                                                            }
                                                                                                            if (W = i[B >> 2], r = r - W | 0, r >>> 0 >= 2147483640) break B;
                                                                                                            if (r >>> 0 >= 11) {
                                                                                                                V = (r | 7) + 1 | 0, B = D(V), i[G + 12 >> 2] = V | -2147483648, i[G + 4 >> 2] = B, i[G + 8 >> 2] = r;
                                                                                                                break _;
                                                                                                            }
                                                                                                            if (o[G + 15 | 0] = r, B = G + 4 | 0, r) break _;
                                                                                                            r = 0;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (V = i[H + 8 >> 2], R = i[H + 112 >> 2], P = V + R | 0, y = i[H + 12 >> 2], c = i[H + 116 >> 2], r = y + c | 0, r = R >>> 0 > P >>> 0 ? r + 1 | 0 : r, (r | 0) == (C | 0) & B >>> 0 > P >>> 0 | r >>> 0 < C >>> 0) {
                                                                                                            if (o[G + 16 | 0] = 0, o[G + 27 | 0] = 0, i0(v, 2, 100, G + 16 | 0), o[G + 27 | 0] >= 0) break h;
                                                                                                            X(i[G + 16 >> 2]);
                                                                                                            break h;
                                                                                                        }
                                                                                                        m: {
                                                                                                            if ((y | 0) == (F | 0) & W >>> 0 <= V >>> 0 | y >>> 0 > F >>> 0 && (r = C + F | 0, P = B + W | 0, r = P >>> 0 < B >>> 0 ? r + 1 | 0 : r, T = V, V = P, (r | 0) == (y | 0) & T >>> 0 >= V >>> 0 | r >>> 0 < y >>> 0)) break m;
                                                                                                            if (o[G + 16 | 0] = 0, o[G + 27 | 0] = 0, i0(v, 2, 100, G + 16 | 0), o[G + 27 | 0] >= 0) break h;
                                                                                                            X(i[G + 16 >> 2]);
                                                                                                            break h;
                                                                                                        }
                                                                                                        if (y = i[f >> 2], r = r + c | 0, T = V, V = V + R | 0, r = T >>> 0 > V >>> 0 ? r + 1 | 0 : r, ((p[i[i[y >> 2] + 12 >> 2]](y, V, r) | 0) - 1 & 255) >>> 0 <= 1) {
                                                                                                            if (o[G + 16 | 0] = 0, o[G + 27 | 0] = 0, i0(v, 2, 100, G + 16 | 0), o[G + 27 | 0] >= 0) break h;
                                                                                                            X(i[G + 16 >> 2]);
                                                                                                            break h;
                                                                                                        }
                                                                                                        if (V = i[f >> 2], r = C + i[H + 116 >> 2] | 0, T = B, B = B + i[H + 112 >> 2] | 0, r = T >>> 0 > B >>> 0 ? r + 1 | 0 : r, p[i[i[V >> 2] + 20 >> 2]](V, B, r), W | F) {
                                                                                                            r = W + S | 0, B = i[n >> 2], C = i[n + 4 >> 2] - B | 0;
                                                                                                            m: {
                                                                                                                if (r >>> 0 > C >>> 0) {
                                                                                                                    r1(n, r - C | 0), B = i[n >> 2];
                                                                                                                    break m;
                                                                                                                }
                                                                                                                if (r >>> 0 >= C >>> 0) break m;
                                                                                                                i[n + 4 >> 2] = r + B;
                                                                                                            }
                                                                                                            r = i[f >> 2], p[i[i[r >> 2] + 16 >> 2]](r, B + S | 0, W);
                                                                                                        }
                                                                                                        if (r = i[21669], i[v >> 2] = i[21668], i[v + 4 >> 2] = r, r = v + 8 | 0, o[86691] >= 0) {
                                                                                                            W = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = W, i[r + 8 >> 2] = i[21672];
                                                                                                            break h;
                                                                                                        }
                                                                                                        j(r, i[21670], i[21671]);
                                                                                                        break h;
                                                                                                    }
                                                                                                    Y0(), z();
                                                                                                }
                                                                                                Q0(B, W, r);
                                                                                            }
                                                                                            o[r + B | 0] = 0, i0(v, 6, 1e3, G + 4 | 0), o[G + 15 | 0] < 0 && X(i[G + 4 >> 2]), r = i[14959], i[G + 16 >> 2] = r, i[i[r - 12 >> 2] + (G + 16 | 0) >> 2] = i[14967], i[G + 24 >> 2] = i[14968], i[C >> 2] = 58864, o[G + 71 | 0] < 0 && X(i[G + 60 >> 2]), x0(C), N0(G + 80 | 0);
                                                                                        }
                                                                                        m = G + 160 | 0, o[v + 19 | 0] < 0 && X(i[v + 8 >> 2]), r = M, W = i[e + 16 >> 2], M = r - W | 0, E = E - (i[e + 20 >> 2] + (r >>> 0 < W >>> 0) | 0) | 0;
                                                                                        break u;
                                                                                    default:
                                                                                        break l;
                                                                                }
                                                                                i[v + 40 >> 2] = 59808, i[v + 96 >> 2] = 59828, r = i[14961], i[v + 32 >> 2] = r, e = i[r - 12 >> 2], r = v + 32 | 0, i[e + r >> 2] = i[14962], i[v + 36 >> 2] = 0, e = r + i[i[v + 32 >> 2] - 12 >> 2] | 0, f = v + 44 | 0, T0(e, f), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[v + 40 >> 2] = e, k = v + 40 | 0, i[k + i[e - 12 >> 2] >> 2] = i[14964], e = i[14960], i[v + 32 >> 2] = e, i[r + i[e - 12 >> 2] >> 2] = i[14965], i[v + 96 >> 2] = 59828, i[v + 32 >> 2] = 59788, i[v + 40 >> 2] = 59808, e = z0(f), i[e >> 2] = 58864, i[v + 84 >> 2] = 0, i[v + 88 >> 2] = 0, i[v + 76 >> 2] = 0, i[v + 80 >> 2] = 0, i[v + 92 >> 2] = 24, U(P0(U(k, 22385, 25), l[_ + 4 | 0]), 13405, 16), r = i[v + 92 >> 2];
                                                                                l: {
                                                                                    if (r & 16) {
                                                                                        _ = i[v + 88 >> 2], r = i[v + 68 >> 2], _ >>> 0 < r >>> 0 && (i[v + 88 >> 2] = r, _ = r), r = v - -64 | 0;
                                                                                        break l;
                                                                                    }
                                                                                    if (!(r & 8)) {
                                                                                        _ = 0, o[v + 31 | 0] = 0, r = v + 20 | 0;
                                                                                        break o;
                                                                                    }
                                                                                    _ = i[v + 60 >> 2], r = v + 52 | 0;
                                                                                }
                                                                                if (f = i[r >> 2], _ = _ - f | 0, _ >>> 0 >= 2147483640) break i;
                                                                                if (_ >>> 0 >= 11) {
                                                                                    k = (_ | 7) + 1 | 0, r = D(k), i[v + 28 >> 2] = k | -2147483648, i[v + 20 >> 2] = r, i[v + 24 >> 2] = _;
                                                                                    break s;
                                                                                }
                                                                                if (o[v + 31 | 0] = _, r = v + 20 | 0, _) break s;
                                                                                _ = 0;
                                                                                break o;
                                                                            }
                                                                            r = M, M = r - W | 0, E = E - ((r >>> 0 < W >>> 0) + C | 0) | 0, t = 0, u = 0;
                                                                        }
                                                                        if (e = e + 40 | 0, ($ | 0) == (e | 0)) break;
                                                                    }
                                                                    if (!(!(E | M) | (s & h) == -1)) {
                                                                        if (r = D(56), i[v + 32 >> 2] = r, i[v + 36 >> 2] = 53, i[v + 40 >> 2] = -2147483592, e = l[18962] | l[18963] << 8 | (l[18964] << 16 | l[18965] << 24), f = l[18958] | l[18959] << 8 | (l[18960] << 16 | l[18961] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 53 | 0] = 0, e = l[19007] | l[19008] << 8 | (l[19009] << 16 | l[19010] << 24), f = l[19003] | l[19004] << 8 | (l[19005] << 16 | l[19006] << 24), o[r + 45 | 0] = f, o[r + 46 | 0] = f >>> 8, o[r + 47 | 0] = f >>> 16, o[r + 48 | 0] = f >>> 24, o[r + 49 | 0] = e, o[r + 50 | 0] = e >>> 8, o[r + 51 | 0] = e >>> 16, o[r + 52 | 0] = e >>> 24, e = l[19002] | l[19003] << 8 | (l[19004] << 16 | l[19005] << 24), f = l[18998] | l[18999] << 8 | (l[19e3] << 16 | l[19001] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[18994] | l[18995] << 8 | (l[18996] << 16 | l[18997] << 24), f = l[18990] | l[18991] << 8 | (l[18992] << 16 | l[18993] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18986] | l[18987] << 8 | (l[18988] << 16 | l[18989] << 24), f = l[18982] | l[18983] << 8 | (l[18984] << 16 | l[18985] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18978] | l[18979] << 8 | (l[18980] << 16 | l[18981] << 24), f = l[18974] | l[18975] << 8 | (l[18976] << 16 | l[18977] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18970] | l[18971] << 8 | (l[18972] << 16 | l[18973] << 24), f = l[18966] | l[18967] << 8 | (l[18968] << 16 | l[18969] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 100, v + 32 | 0), o[v + 43 | 0] >= 0) break e;
                                                                        X(i[v + 32 >> 2]);
                                                                        break e;
                                                                    }
                                                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                                        break e;
                                                                    }
                                                                    j(A, i[21670], i[21671]);
                                                                    break e;
                                                                }
                                                                Q0(r, f, _);
                                                            }
                                                            o[r + _ | 0] = 0, i0(A, 4, 3004, v + 20 | 0), o[v + 31 | 0] < 0 && X(i[v + 20 >> 2]), A = i[14959], i[v + 32 >> 2] = A, i[i[A - 12 >> 2] + (v + 32 | 0) >> 2] = i[14967], i[v + 40 >> 2] = i[14968], i[e >> 2] = 58864, o[v + 87 | 0] < 0 && X(i[v + 76 >> 2]), x0(e), N0(v + 96 | 0);
                                                            break e;
                                                        }
                                                        Q0(e, r, _);
                                                    }
                                                    o[e + _ | 0] = 0, i0(A, 6, 1e3, v + 20 | 0), o[v + 31 | 0] < 0 && X(i[v + 20 >> 2]), A = i[14959], i[v + 32 >> 2] = A, i[i[A - 12 >> 2] + (v + 32 | 0) >> 2] = i[14967], i[v + 40 >> 2] = i[14968], i[f >> 2] = 58864, o[v + 87 | 0] < 0 && X(i[v + 76 >> 2]), x0(f), N0(v + 96 | 0);
                                                    break e;
                                                }
                                                Q0(e, r, _);
                                            }
                                            o[e + _ | 0] = 0, i0(A, 2, 100, v + 20 | 0), o[v + 31 | 0] < 0 && X(i[v + 20 >> 2]), A = i[14959], i[v + 32 >> 2] = A, i[i[A - 12 >> 2] + (v + 32 | 0) >> 2] = i[14967], i[v + 40 >> 2] = i[14968], i[f >> 2] = 58864, o[v + 87 | 0] < 0 && X(i[v + 76 >> 2]), x0(f), N0(v + 96 | 0);
                                            break e;
                                        }
                                        Q0(e, r, _);
                                    }
                                    o[e + _ | 0] = 0, i0(A, 2, 117, v + 20 | 0), o[v + 31 | 0] < 0 && X(i[v + 20 >> 2]), A = i[14959], i[v + 32 >> 2] = A, i[i[A - 12 >> 2] + (v + 32 | 0) >> 2] = i[14967], i[v + 40 >> 2] = i[14968], i[f >> 2] = 58864, o[v + 87 | 0] < 0 && X(i[v + 76 >> 2]), x0(f), N0(v + 96 | 0);
                                }
                                m = v + 176 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function se(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0;
                            h = A + 18548 | 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                for(;;){
                                                    _ = i[A + 18588 >> 2], u = i[_ + 132 >> 2];
                                                    k: {
                                                        n: {
                                                            if (v = i[_ + 124 >> 2], B = i[v + 484 >> 2], n = 1 << f, (B | 0) < (n + r | 0)) {
                                                                t = i[v + 16872 >> 2];
                                                                break n;
                                                            }
                                                            if (s = i[v + 488 >> 2], t = i[v + 16872 >> 2], (s | 0) < (e + n | 0) | (t | 0) >= (f | 0)) break n;
                                                            t = 1, G = r - 1 | 0, n = 1;
                                                            t: {
                                                                if ((G | e) < 0 || (n = 1, (r | 0) > (B | 0)) || (n = 1, (e | 0) >= (s | 0)) || (w = i[v + 16876 >> 2], W = Z(i[v + 16892 >> 2], e >> w), C = i[_ + 140 >> 2], V = W + (r >> w) | 0, w = W + (G >> w) | 0, n = 1, I[C + Z(V, 24) >> 1] != I[C + Z(w, 24) >> 1])) break t;
                                                                n = i[u + 8484 >> 2], n = i[n + (V << 2) >> 2] != i[n + (w << 2) >> 2];
                                                            }
                                                            w = e - 1 | 0;
                                                            t: {
                                                                if ((w | r) < 0 | (r | 0) >= (B | 0) | (e | 0) > (s | 0) || (B = i[v + 16876 >> 2], s = r >> B, C = i[_ + 140 >> 2], W = i[v + 16892 >> 2], V = s + Z(W, e >> B) | 0, B = s + Z(W, w >> B) | 0, I[C + Z(V, 24) >> 1] != I[C + Z(B, 24) >> 1])) break t;
                                                                t = i[u + 8484 >> 2], t = i[t + (V << 2) >> 2] != i[t + (B << 2) >> 2];
                                                            }
                                                            if (B = 0, !n) {
                                                                if (B = i[_ + 168 >> 2], n = G >> B, (n | 0) < 0 || (s = i[_ + 172 >> 2], (s | 0) <= (n | 0))) break e;
                                                                if (B = e >> B, (B | 0) < 0 | (B | 0) >= i[_ + 176 >> 2]) break i;
                                                                n = (i[_ + 160 >> 2] + Z(n, 3) | 0) + Z(Z(s, B), 3) | 0, B = ((l[n | 0] | l[n + 1 | 0] << 8) >>> 6 & 3) > (k | 0);
                                                            }
                                                            t: {
                                                                if (t) n = 0;
                                                                else {
                                                                    if (t = i[_ + 168 >> 2], n = r >> t, (n | 0) < 0 || (s = i[_ + 172 >> 2], (s | 0) <= (n | 0))) break e;
                                                                    if (t = w >> t, (t | 0) < 0 | (t | 0) >= i[_ + 176 >> 2]) break t;
                                                                    n = (i[_ + 160 >> 2] + Z(n, 3) | 0) + Z(Z(t, s), 3) | 0, n = ((l[n | 0] | l[n + 1 | 0] << 8) >>> 6 & 3) > (k | 0);
                                                                }
                                                                n = !s2(h, (n + (i[A + 18572 >> 2] + B | 0) | 0) + 2 | 0);
                                                                break k;
                                                            }
                                                            break i;
                                                        }
                                                        n = (f | 0) <= (t | 0);
                                                    }
                                                    if (!l[u + 26 | 0] | i[u + 8268 >> 2] > (f | 0) || (i[A + 18500 >> 2] = 0, i[A + 18504 >> 2] = 0), !l[i[A + 18592 >> 2] + 760 | 0] | i[u + 8272 >> 2] > (f | 0) || (i[A + 18508 >> 2] = 0), !n) {
                                                        if (f = f - 1 | 0, k = k + 1 | 0, se(A, r, e, f, k), u = 1 << f, n = u + e | 0, u = r + u | 0, (u | 0) < i[v + 484 >> 2] && se(A, u, e, f, k), t = i[v + 488 >> 2], (n | 0) < (t | 0) && (se(A, r, n, f, k), t = i[v + 488 >> 2]), (u | 0) >= i[v + 484 >> 2]) break f;
                                                        if (r = u, e = n, (t | 0) > (e | 0)) continue;
                                                        break f;
                                                    }
                                                    break;
                                                }
                                                if (n = i[_ + 168 >> 2], u = f - n | 0, (u | 0) != 31) for(t = e >> n, u = 1 << u, B = t + u | 0, h = u, u = r >> n, s = h + u | 0, G = k << 6 & 192;;){
                                                    for(n = u; h = (i[_ + 160 >> 2] + Z(n, 3) | 0) + Z(Z(i[_ + 172 >> 2], t), 3) | 0, v = G | (l[h | 0] | l[h + 1 | 0] << 8) & 65343, o[h | 0] = v, o[h + 1 | 0] = v >>> 8, n = n + 1 | 0, (s | 0) > (n | 0););
                                                    if (t = t + 1 | 0, !((B | 0) > (t | 0))) break;
                                                }
                                                if (G = m - 80 | 0, m = G, t = A, B = i[A + 18592 >> 2], n = i[A + 18588 >> 2], w = i[n + 132 >> 2], V = i[n + 124 >> 2], u = r, h = e, _ = f, A = i[n + 168 >> 2], r = f - A | 0, (r | 0) != 31) for(e = e >> A, r = 1 << r, W = e + r | 0, v = r, r = u >> A, C = v + r | 0;;){
                                                    for(A = r; v = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(i[n + 172 >> 2], e), 3) | 0, s = (l[v | 0] | l[v + 1 | 0] << 8) & 65528, o[v | 0] = s, o[v + 1 | 0] = s >>> 8, A = A + 1 | 0, (C | 0) > (A | 0););
                                                    if (e = e + 1 | 0, !((W | 0) > (e | 0))) break;
                                                }
                                                if (r = i[n + 168 >> 2], A = u >> r, (A | 0) < 0 || (e = i[n + 172 >> 2], (e | 0) <= (A | 0))) break A;
                                                if (r = h >> r, (r | 0) < 0 | (r | 0) >= i[n + 176 >> 2]) break r;
                                                if (A = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(r, e), 3) | 0, r = (l[A | 0] | l[A + 1 | 0] << 8) & 65528 | f & 7, o[A | 0] = r, o[A + 1 | 0] = r >>> 8, r = i[n + 248 >> 2], e = _ - r | 0, (e | 0) != 31) for(A = h >> r, e = 1 << e, f = A + e | 0, v = e, e = u >> r, v = v + e | 0;;){
                                                    for(r = e; o[(i[n + 240 >> 2] + r | 0) + Z(i[n + 252 >> 2], A) | 0] = 0, r = r + 1 | 0, (v | 0) > (r | 0););
                                                    if (A = A + 1 | 0, !((f | 0) > (A | 0))) break;
                                                }
                                                c7(t, u, h);
                                                k: {
                                                    if (l[w + 44 | 0]) {
                                                        if (A = s2(t + 18548 | 0, i[t + 18572 >> 2] + 161 | 0), o[t + 32 | 0] = A, !A) break k;
                                                        if (A = i[n + 168 >> 2], r = _ - A | 0, (r | 0) != 31) for(e = h >> A, r = 1 << r, s = e + r | 0, f = r, r = u >> A, w = f + r | 0;;){
                                                            for(A = r; f = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(i[n + 172 >> 2], e), 3) | 0, v = (l[f | 0] | l[f + 1 | 0] << 8) & 63487 | 2048, o[f | 0] = v, o[f + 1 | 0] = v >>> 8, A = A + 1 | 0, (w | 0) > (A | 0););
                                                            if (e = e + 1 | 0, !((s | 0) > (e | 0))) break;
                                                        }
                                                        if (r = i[n + 148 >> 2], A = u >> r, (A | 0) < 0 || (e = i[n + 152 >> 2], (e | 0) <= (A | 0))) break A;
                                                        if (r = h >> r, (r | 0) < 0 | (r | 0) >= i[n + 156 >> 2]) break r;
                                                        o[((i[n + 140 >> 2] + Z(A, 24) | 0) + Z(Z(r, e), 24) | 0) + 22 | 0] = 1;
                                                        break k;
                                                    }
                                                    o[t + 32 | 0] = 0;
                                                }
                                                s = 1 << _, f = 0;
                                                k: {
                                                    n: {
                                                        if (i[B + 28 >> 2] == 2) break n;
                                                        r = i[t + 18588 >> 2], v = 1, f = u - 1 | 0, A = 1;
                                                        t: {
                                                            if ((f | h) < 0 || (e = i[r + 124 >> 2], A = 1, (u | 0) > i[e + 484 >> 2]) || (A = 1, (h | 0) >= i[e + 488 >> 2]) || (A = i[e + 16892 >> 2], e = i[e + 16876 >> 2], w = Z(A, h >> e), C = i[r + 140 >> 2], W = w + (u >> e) | 0, e = w + (f >> e) | 0, A = 1, I[C + Z(W, 24) >> 1] != I[C + Z(e, 24) >> 1])) break t;
                                                            A = i[i[r + 132 >> 2] + 8484 >> 2], A = i[A + (W << 2) >> 2] != i[A + (e << 2) >> 2];
                                                        }
                                                        W = h - 1 | 0;
                                                        t: {
                                                            if ((W | u) < 0 || (e = i[r + 124 >> 2], (u | 0) >= i[e + 484 >> 2] | (h | 0) > i[e + 488 >> 2]) || (w = i[e + 16876 >> 2], C = u >> w, E = i[r + 140 >> 2], e = i[e + 16892 >> 2], y = C + Z(e, h >> w) | 0, e = C + Z(e, W >> w) | 0, I[E + Z(y, 24) >> 1] != I[E + Z(e, 24) >> 1])) break t;
                                                            v = i[i[r + 132 >> 2] + 8484 >> 2], v = i[v + (y << 2) >> 2] != i[v + (e << 2) >> 2];
                                                        }
                                                        if (w = 0, e = 0, !A) {
                                                            if (e = i[r + 168 >> 2], A = f >> e, (A | 0) < 0 || (f = i[r + 172 >> 2], (f | 0) <= (A | 0))) break e;
                                                            if (e = h >> e, (e | 0) < 0 | (e | 0) >= i[r + 176 >> 2]) break i;
                                                            A = (i[r + 160 >> 2] + Z(A, 3) | 0) + Z(Z(e, f), 3) | 0, e = ((l[A | 0] | l[A + 1 | 0] << 8) & 768) == 512;
                                                        }
                                                        if (!v) {
                                                            if (f = i[r + 168 >> 2], A = u >> f, (A | 0) < 0 || (v = i[r + 172 >> 2], (v | 0) <= (A | 0))) break e;
                                                            if (f = W >> f, (f | 0) < 0 | (f | 0) >= i[r + 176 >> 2]) break i;
                                                            A = (i[r + 160 >> 2] + Z(A, 3) | 0) + Z(Z(f, v), 3) | 0, w = ((l[A | 0] | l[A + 1 | 0] << 8) & 768) == 512;
                                                        }
                                                        if (A = t + 18548 | 0, s2(A, ((i[t + 18572 >> 2] + e | 0) + w | 0) + 5 | 0) & 255) {
                                                            r = 16;
                                                            t: {
                                                                if (i[i[t + 18592 >> 2] + 812 >> 2] < 2 || !s2(A, i[t + 18572 >> 2] + 148 | 0) || (r = 48, i[i[t + 18592 >> 2] + 812 >> 2] < 3)) break t;
                                                                for(r = 1; S1(A) && (r = r + 1 | 0, (r | 0) < (i[i[t + 18592 >> 2] + 812 >> 2] - 1 | 0)););
                                                                r = r << 5 | 16;
                                                            }
                                                            if (o[t + 26 | 0] = l[t + 26 | 0] & 15 | r, r = i[n + 168 >> 2], A = u >> r, (A | 0) < 0 || (e = i[n + 172 >> 2], (e | 0) <= (A | 0))) break A;
                                                            if (r = h >> r, (r | 0) < 0 | (r | 0) >= i[n + 176 >> 2]) break r;
                                                            if (A = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(r, e), 3) | 0, r = (l[A | 0] | l[A + 1 | 0] << 8) & 65479, o[A | 0] = r, o[A + 1 | 0] = r >>> 8, A = i[n + 168 >> 2], r = _ - A | 0, (r | 0) != 31) for(e = h >> A, r = 1 << r, _ = e + r | 0, A = u >> A, v = A + r | 0;;){
                                                                for(r = A; f = (i[n + 160 >> 2] + Z(r, 3) | 0) + Z(Z(i[n + 172 >> 2], e), 3) | 0, k = (l[f | 0] | l[f + 1 | 0] << 8) & 64767 | 512, o[f | 0] = k, o[f + 1 | 0] = k >>> 8, r = r + 1 | 0, (v | 0) > (r | 0););
                                                                if (e = e + 1 | 0, !((_ | 0) > (e | 0))) break;
                                                            }
                                                            m7(i[t + 18584 >> 2], i[t + 18592 >> 2], i[t + 18588 >> 2], t + 16 | 0, u, h, 0, 0, s, s, s, 0);
                                                            break k;
                                                        }
                                                        if (f = 0, i[B + 28 >> 2] == 2) break n;
                                                        f = !s2(A, i[t + 18572 >> 2] + 149 | 0);
                                                    }
                                                    if (A = i[n + 168 >> 2], r = _ - A | 0, (r | 0) != 31) for(e = h >> A, r = 1 << r, w = e + r | 0, W = f << 8, A = u >> A, C = A + r | 0;;){
                                                        for(r = A; v = (i[n + 160 >> 2] + Z(r, 3) | 0) + Z(Z(i[n + 172 >> 2], e), 3) | 0, B = W | (l[v | 0] | l[v + 1 | 0] << 8) & 64767, o[v | 0] = B, o[v + 1 | 0] = B >>> 8, r = r + 1 | 0, (C | 0) > (r | 0););
                                                        if (e = e + 1 | 0, !((w | 0) > (e | 0))) break;
                                                    }
                                                    B = !f;
                                                    n: {
                                                        t: {
                                                            if (f) {
                                                                A = 0, v = i[i[t + 18588 >> 2] + 124 >> 2];
                                                                o: {
                                                                    if (e = t + 18548 | 0, s2(e, i[t + 18572 >> 2] + 8 | 0)) break o;
                                                                    r = s2(e, i[t + 18572 >> 2] + 9 | 0);
                                                                    s: {
                                                                        if ((_ | 0) > i[v + 16872 >> 2]) {
                                                                            if (A = r ? 1 : 2, !l[v + 8798 | 0] || s2(e, i[t + 18572 >> 2] + 11 | 0) || (e = S1(e), r && (A = 5, e)) || r && (A = 4, !e)) break o;
                                                                            if (r | e) break s;
                                                                            A = 6;
                                                                            break o;
                                                                        }
                                                                        if (A = 1, r || (A = 2, (_ | 0) == 3)) break o;
                                                                        A = 3 - s2(e, i[t + 18572 >> 2] + 10 | 0) | 0;
                                                                        break o;
                                                                    }
                                                                    if (!r && (A = 7, e)) break o;
                                                                    y0(10076, 15050, 1774, 12270), z();
                                                                }
                                                                break t;
                                                            }
                                                            if (r = 0, v = 0, (_ | 0) != i[V + 16872 >> 2]) break n;
                                                            A = s2(t + 18548 | 0, i[t + 18572 >> 2] + 8 | 0) ? 0 : 3;
                                                        }
                                                        r = A, v = (A | 0) == 3 & B;
                                                    }
                                                    if (e = i[n + 168 >> 2], A = u >> e, (A | 0) < 0 || (B = i[n + 172 >> 2], (B | 0) <= (A | 0))) break A;
                                                    if (e = h >> e, (e | 0) < 0 | (e | 0) >= i[n + 176 >> 2]) break r;
                                                    A = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(e, B), 3) | 0, e = (l[A | 0] | l[A + 1 | 0] << 8) & 65479 | r << 3 & 56, o[A | 0] = e, o[A + 1 | 0] = e >>> 8;
                                                    n: {
                                                        if (!f) {
                                                            t: {
                                                                if (!l[V + 8800 | 0] | r | ((_ | 0) < i[V + 16956 >> 2] | (_ | 0) > i[V + 16960 >> 2]) || (C = t + 18548 | 0, !wA(C))) break t;
                                                                if (A = i[n + 168 >> 2], r = _ - A | 0, (r | 0) != 31) for(e = h >> A, r = 1 << r, v = e + r | 0, f = r, r = u >> A, B = f + r | 0;;){
                                                                    for(A = r; f = (i[n + 160 >> 2] + Z(A, 3) | 0) + Z(Z(i[n + 172 >> 2], e), 3) | 0, k = (l[f | 0] | l[f + 1 | 0] << 8) & 64511 | 1024, o[f | 0] = k, o[f + 1 | 0] = k >>> 8, A = A + 1 | 0, (B | 0) > (A | 0););
                                                                    if (e = e + 1 | 0, !((v | 0) > (e | 0))) break;
                                                                }
                                                                if (r = i[n + 148 >> 2], A = u >> r, (A | 0) < 0 || (e = i[n + 152 >> 2], (e | 0) <= (A | 0))) break A;
                                                                if (r = h >> r, (r | 0) < 0 | (r | 0) >= i[n + 156 >> 2]) break r;
                                                                o[((i[n + 140 >> 2] + Z(A, 24) | 0) + Z(Z(r, e), 24) | 0) + 22 | 0] = 1, A = i[t + 18552 >> 2], i[G + 48 >> 2] = A, r = i[t + 18556 >> 2], w = 0, i[G + 64 >> 2] = 0, i[G + 56 >> 2] = 0, i[G + 60 >> 2] = 0, i[G + 52 >> 2] = r - A, A = i[t + 18588 >> 2], r = i[A + 40 >> 2], e = Z(r, h), f = i[A + 4 >> 2], k = i[A + 124 >> 2], A = o[k + 8801 | 0], k = i[k + 16832 >> 2];
                                                                o: {
                                                                    if ((k | 0) >= 9) {
                                                                        if ((_ | 0) == 31) break o;
                                                                        for(k = k - A | 0, n = (k | 0) > 0 ? k : 0, e = f + (e + u << 1) | 0;;){
                                                                            for(f = e + (Z(r, w) << 1) | 0, k = 0; f0 = f + (k << 1) | 0, t0 = l0(G + 48 | 0, A) << n, Q[f0 >> 1] = t0, k = k + 1 | 0, (s | 0) != (k | 0););
                                                                            if (w = w + 1 | 0, (s | 0) == (w | 0)) break;
                                                                        }
                                                                        break o;
                                                                    }
                                                                    if ((_ | 0) == 31) break o;
                                                                    for(k = k - A | 0, n = (k | 0) > 0 ? k : 0, e = u + (e + f | 0) | 0;;){
                                                                        for(f = e + Z(r, w) | 0, k = 0; f0 = f + k | 0, t0 = l0(G + 48 | 0, A) << n, o[f0 | 0] = t0, k = k + 1 | 0, (s | 0) != (k | 0););
                                                                        if (w = w + 1 | 0, (s | 0) == (w | 0)) break;
                                                                    }
                                                                }
                                                                w = i[t + 18588 >> 2], A = i[w + 124 >> 2];
                                                                o: {
                                                                    if (!i[A + 16848 >> 2]) break o;
                                                                    if (r = i[A + 16852 >> 2], _ = (u | 0) / (r | 0) | 0, e = i[A + 16856 >> 2], v = (s | 0) / (e | 0) | 0, k = (s | 0) / (r | 0) | 0, f = i[w + 44 >> 2], W = Z(f, (h | 0) / (e | 0) | 0), B = i[w + 8 >> 2], r = o[A + 8802 | 0], A = i[A + 16840 >> 2], (A | 0) >= 9) {
                                                                        if (n = 0, A = A - r | 0, e = (A | 0) > 0 ? A : 0, A = _ + W << 1, !((k | 0) <= 0 | (v | 0) <= 0)) {
                                                                            for(_ = A + B | 0;;){
                                                                                for(B = _ + (Z(f, n) << 1) | 0, A = 0; f0 = B + (A << 1) | 0, t0 = l0(G + 48 | 0, r) << e, Q[f0 >> 1] = t0, A = A + 1 | 0, (k | 0) != (A | 0););
                                                                                if (n = n + 1 | 0, (v | 0) == (n | 0)) break;
                                                                            }
                                                                            w = i[t + 18588 >> 2], A = i[w + 124 >> 2], r = o[A + 8802 | 0], e = i[A + 16840 >> 2] - r | 0, e = (e | 0) > 0 ? e : 0, f = i[w + 44 >> 2], k = i[A + 16856 >> 2], n = i[A + 16852 >> 2], A = Z(f, (h | 0) / (k | 0) | 0) + ((u | 0) / (n | 0) | 0) << 1, v = (s | 0) / (k | 0) | 0, k = (s | 0) / (n | 0) | 0;
                                                                        }
                                                                        if ((v | 0) <= 0 | (k | 0) <= 0) break o;
                                                                        for(u = i[w + 12 >> 2] + A | 0, n = 0;;){
                                                                            for(h = u + (Z(f, n) << 1) | 0, A = 0; f0 = h + (A << 1) | 0, t0 = l0(G + 48 | 0, r) << e, Q[f0 >> 1] = t0, A = A + 1 | 0, (k | 0) != (A | 0););
                                                                            if (n = n + 1 | 0, (v | 0) == (n | 0)) break;
                                                                        }
                                                                        break o;
                                                                    }
                                                                    if (n = 0, A = A - r | 0, e = (A | 0) > 0 ? A : 0, !((k | 0) <= 0 | (v | 0) <= 0)) {
                                                                        for(_ = (B + W | 0) + _ | 0;;){
                                                                            for(B = _ + Z(f, n) | 0, A = 0; f0 = A + B | 0, t0 = l0(G + 48 | 0, r) << e, o[f0 | 0] = t0, A = A + 1 | 0, (k | 0) != (A | 0););
                                                                            if (n = n + 1 | 0, (v | 0) == (n | 0)) break;
                                                                        }
                                                                        w = i[t + 18588 >> 2], A = i[w + 124 >> 2], r = o[A + 8802 | 0], e = i[A + 16840 >> 2] - r | 0, e = (e | 0) > 0 ? e : 0, f = i[A + 16852 >> 2], _ = (u | 0) / (f | 0) | 0, A = i[A + 16856 >> 2], v = (s | 0) / (A | 0) | 0, k = (s | 0) / (f | 0) | 0, f = i[w + 44 >> 2], W = Z(f, (h | 0) / (A | 0) | 0);
                                                                    }
                                                                    if ((v | 0) <= 0 | (k | 0) <= 0) break o;
                                                                    for(u = (i[w + 12 >> 2] + W | 0) + _ | 0, n = 0;;){
                                                                        for(h = u + Z(f, n) | 0, A = 0; f0 = A + h | 0, t0 = l0(G + 48 | 0, r) << e, o[f0 | 0] = t0, A = A + 1 | 0, (k | 0) != (A | 0););
                                                                        if (n = n + 1 | 0, (v | 0) == (n | 0)) break;
                                                                    }
                                                                }
                                                                jt(G + 48 | 0), i[t + 18552 >> 2] = i[G + 48 >> 2], Fi(C);
                                                                break k;
                                                            }
                                                            if (f = (r | 0) == 3, C = f ? (s | 0) / 2 | 0 : s, (_ | 0) != 31) for(e = t + 18548 | 0, r = 0, w = 0;;){
                                                                for(A = 0; f0 = (G + 48 | 0) + (r << 2) | 0, t0 = s2(e, i[t + 18572 >> 2] + 12 | 0), i[f0 >> 2] = t0, r = r + 1 | 0, A = A + C | 0, (s | 0) > (A | 0););
                                                                if (w = w + C | 0, !((s | 0) > (w | 0))) break;
                                                            }
                                                            k = u - 1 | 0, A = 0;
                                                            t: {
                                                                if ((k | h) < 0 || (r = i[n + 124 >> 2], A = 0, (u | 0) > i[r + 484 >> 2]) || (A = 0, (h | 0) >= i[r + 488 >> 2]) || (A = i[r + 16892 >> 2], r = i[r + 16876 >> 2], e = Z(A, h >> r), w = i[n + 140 >> 2], B = e + (u >> r) | 0, r = e + (k >> r) | 0, A = 0, I[w + Z(B, 24) >> 1] != I[w + Z(r, 24) >> 1])) break t;
                                                                A = i[i[n + 132 >> 2] + 8484 >> 2], A = i[A + (B << 2) >> 2] == i[A + (r << 2) >> 2];
                                                            }
                                                            B = A, k = h - 1 | 0;
                                                            t: {
                                                                if ((k | u) < 0 || (A = i[n + 124 >> 2], (u | 0) >= i[A + 484 >> 2] | (h | 0) > i[A + 488 >> 2]) || (r = i[A + 16876 >> 2], e = u >> r, W = i[n + 140 >> 2], A = i[A + 16892 >> 2], w = e + Z(A, h >> r) | 0, A = e + Z(A, k >> r) | 0, I[W + Z(w, 24) >> 1] != I[W + Z(A, 24) >> 1])) break t;
                                                                r = i[i[n + 132 >> 2] + 8484 >> 2], c = i[r + (w << 2) >> 2] == i[r + (A << 2) >> 2];
                                                            }
                                                            if (k = _ - f | 0, (_ | 0) != 31) for(T = t + 18548 | 0, E = 0;;){
                                                                for(y = h + E | 0, r0 = (E | 0) > 0 | c, W = 0;;){
                                                                    R = S << 2, P = i[R + (G + 48 | 0) >> 2];
                                                                    t: {
                                                                        if (P) {
                                                                            w = Qi(T, 2), A = G + 32 | 0;
                                                                            break t;
                                                                        }
                                                                        w = i8(T, 5), A = G + 16 | 0;
                                                                    }
                                                                    i[A + R >> 2] = w, e = u + W | 0, H = e, A = i[V + 16944 >> 2], w = Z(i[V + 16948 >> 2], y >> A) + (e >> A) | 0, f = w, M = i[n + 124 >> 2], r = 1, A = 1;
                                                                    t: {
                                                                        if (!((W | 0) > 0 | B)) break t;
                                                                        if (A = i[n + 168 >> 2], e = e - 1 >> A, (e | 0) < 0 || ($ = i[n + 172 >> 2], ($ | 0) <= (e | 0))) break e;
                                                                        if (F = y >> A, (F | 0) < 0 | (F | 0) >= i[n + 176 >> 2]) break i;
                                                                        if (A = 1, l[((i[n + 160 >> 2] + Z(e, 3) | 0) + Z(Z(F, $), 3) | 0) + 1 | 0] & 7) break t;
                                                                        A = l[(f + i[n + 200 >> 2] | 0) - 1 | 0];
                                                                    }
                                                                    t: {
                                                                        if (!r0) break t;
                                                                        if (F = i[n + 168 >> 2], e = H >> F, (e | 0) < 0 || (H = i[n + 172 >> 2], (H | 0) <= (e | 0))) break e;
                                                                        if (F = y - 1 >> F, (F | 0) < 0 | (F | 0) >= i[n + 176 >> 2]) break i;
                                                                        if (l[((i[n + 160 >> 2] + Z(e, 3) | 0) + Z(Z(F, H), 3) | 0) + 1 | 0] & 7 | (y | 0) <= (y & -1 << i[M + 16876 >> 2])) break t;
                                                                        r = l[i[n + 200 >> 2] + (f - i[M + 16948 >> 2] | 0) | 0];
                                                                    }
                                                                    t: {
                                                                        if ((A | 0) == (r | 0)) {
                                                                            if (A >>> 0 <= 1) {
                                                                                i[G + 12 >> 2] = 26, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 1;
                                                                                break t;
                                                                            }
                                                                            i[G + 4 >> 2] = A, i[G + 12 >> 2] = (A - 1 & 31) + 2, i[G + 8 >> 2] = (A + 29 & 31) + 2;
                                                                            break t;
                                                                        }
                                                                        if (i[G + 8 >> 2] = r, i[G + 4 >> 2] = A, !(!A | !r)) {
                                                                            i[G + 12 >> 2] = 0;
                                                                            break t;
                                                                        }
                                                                        if (!((A | 0) == 1 | (r | 0) == 1)) {
                                                                            i[G + 12 >> 2] = 1;
                                                                            break t;
                                                                        }
                                                                        i[G + 12 >> 2] = 26;
                                                                    }
                                                                    t: {
                                                                        if ((P | 0) != 1) {
                                                                            A = i[G + 4 >> 2], e = i[G + 8 >> 2], r = (A | 0) > (e | 0) ? A : e, A = (A | 0) < (e | 0) ? A : e, e = i[G + 12 >> 2];
                                                                            o: {
                                                                                if ((A | 0) <= (e | 0)) {
                                                                                    f = A, A = e;
                                                                                    break o;
                                                                                }
                                                                                i[G + 12 >> 2] = A, i[G + 4 >> 2] = e, f = e;
                                                                            }
                                                                            o: {
                                                                                if ((A | 0) >= (r | 0)) {
                                                                                    e = A, A = r;
                                                                                    break o;
                                                                                }
                                                                                i[G + 8 >> 2] = A, e = r;
                                                                            }
                                                                            r = A, A = i[R + (G + 16 | 0) >> 2], A = ((A | 0) >= (f | 0)) + A | 0, A = ((r | 0) <= (A | 0)) + A | 0, f = ((A | 0) >= (e | 0)) + A | 0;
                                                                            break t;
                                                                        }
                                                                        f = i[(G + 4 | 0) + (i[R + (G + 32 | 0) >> 2] << 2) >> 2];
                                                                    }
                                                                    if (R = i[n + 208 >> 2], A = k - R | 0, (A | 0) != 31) for(M = 1 << A, F = M & 2147483646, A = 0;;){
                                                                        if (r = 0, e = 0, (k | 0) != (R | 0)) for(; o[(w + (i[n + 200 >> 2] + r | 0) | 0) + Z(i[n + 212 >> 2], A) | 0] = f, o[((w + (i[n + 200 >> 2] + r | 0) | 0) + Z(i[n + 212 >> 2], A) | 0) + 1 | 0] = f, r = r + 2 | 0, e = e + 2 | 0, (F | 0) != (e | 0););
                                                                        if ((k | 0) == (R | 0) && (o[(w + (i[n + 200 >> 2] + r | 0) | 0) + Z(i[n + 212 >> 2], A) | 0] = f), A = A + 1 | 0, (M | 0) == (A | 0)) break;
                                                                    }
                                                                    if (S = S + 1 | 0, W = W + C | 0, !((s | 0) > (W | 0))) break;
                                                                }
                                                                if (E = C + E | 0, !((s | 0) > (E | 0))) break;
                                                            }
                                                            t: switch(i[V + 16848 >> 2]){
                                                                case 3:
                                                                    if ((_ | 0) == 31) break n;
                                                                    w = t + 18548 | 0, W = 0;
                                                                    o: {
                                                                        for(;;){
                                                                            A = h + W | 0, r = 0;
                                                                            s: {
                                                                                for(;;){
                                                                                    if (s2(w, i[t + 18572 >> 2] + 13 | 0) ? e = i8(w, 2) : e = 4, B = r + u | 0, y = i[n + 208 >> 2], f = B >> y, (f | 0) < 0 || (E = i[n + 212 >> 2], (E | 0) <= (f | 0))) break s;
                                                                                    if (y = A >> y, (y | 0) < 0 | (y | 0) >= i[n + 216 >> 2]) break o;
                                                                                    if (f = l[(f + i[n + 200 >> 2] | 0) + Z(y, E) | 0], f = f >>> 0 <= 34 ? f : 0, y = (e | 0) == 4, y || (e = i[(e << 2) + 51120 >> 2], f = (e | 0) == (f | 0) ? 34 : e), Mn(n, B, A, k, f, y), r = r + C | 0, !((s | 0) > (r | 0))) break;
                                                                                }
                                                                                if (W = W + C | 0, (s | 0) > (W | 0)) continue;
                                                                                break n;
                                                                            }
                                                                            break;
                                                                        }
                                                                        break e;
                                                                    }
                                                                    break i;
                                                                case 0:
                                                                    break n;
                                                                default:
                                                                    break t;
                                                            }
                                                            if (A = t + 18548 | 0, s2(A, i[t + 18572 >> 2] + 13 | 0) ? A = i8(A, 2) : A = 4, e = i[n + 208 >> 2], r = u >> e, (r | 0) < 0 || (f = i[n + 212 >> 2], (f | 0) <= (r | 0))) break e;
                                                            if (e = h >> e, (e | 0) < 0 | (e | 0) >= i[n + 216 >> 2]) break i;
                                                            r = l[(r + i[n + 200 >> 2] | 0) + Z(e, f) | 0], r = r >>> 0 <= 34 ? r : 0, (A | 0) != 4 && (e = i[(A << 2) + 51120 >> 2], r = (r | 0) == (e | 0) ? 34 : e), i[V + 16848 >> 2] == 2 && (r = l[r + 51136 | 0]), Mn(n, u, h, _, r, (A | 0) == 4);
                                                            break n;
                                                        }
                                                        t: {
                                                            o: {
                                                                s: switch(r | 0){
                                                                    case 1:
                                                                        A = (s | 0) / 2 | 0, i4(t, u, h, 0, 0, s, A, k, s, 0), i4(t, u, h, 0, A, s, A, k, s, 1);
                                                                        break o;
                                                                    case 2:
                                                                        A = (s | 0) / 2 | 0, i4(t, u, h, 0, 0, A, s, k, s, 0), i4(t, u, h, A, 0, A, s, k, s, 1);
                                                                        break o;
                                                                    case 4:
                                                                        A = (s | 0) / 4 | 0, i4(t, u, h, 0, 0, s, A, k, s, 0), i4(t, u, h, 0, A, s, (3 << _) / 4 | 0, k, s, 1);
                                                                        break o;
                                                                    case 5:
                                                                        A = (3 << _) / 4 | 0, i4(t, u, h, 0, 0, s, A, k, s, 0), i4(t, u, h, 0, A, s, (s | 0) / 4 | 0, k, s, 1);
                                                                        break o;
                                                                    case 6:
                                                                        A = (s | 0) / 4 | 0, i4(t, u, h, 0, 0, A, s, k, s, 0), i4(t, u, h, A, 0, (3 << _) / 4 | 0, s, k, s, 1);
                                                                        break o;
                                                                    case 7:
                                                                        A = (3 << _) / 4 | 0, i4(t, u, h, 0, 0, A, s, k, s, 0), i4(t, u, h, A, 0, (s | 0) / 4 | 0, s, k, s, 1);
                                                                        break o;
                                                                    case 3:
                                                                        A = (s | 0) / 2 | 0, i4(t, u, h, 0, 0, A, A, k, s, 0), i4(t, u, h, A, 0, A, A, k, s, 1), i4(t, u, h, 0, A, A, A, k, s, 2), i4(t, u, h, A, A, A, A, k, s, 3);
                                                                        break o;
                                                                    default:
                                                                        y0(18461, 15050, 4544, 3459), z();
                                                                    case 0:
                                                                        break s;
                                                                }
                                                                if (i4(t, u, h, 0, 0, s, s, k, s, 0), l[t + 26 | 0] & 16) break t;
                                                            }
                                                            if (!s2(t + 18548 | 0, i[t + 18572 >> 2] + 153 | 0)) break k;
                                                        }
                                                        A = i[V + 16848 >> 2] != 0, fi(t, u, h, u, h, u, h, _, 0, 0, i[V + 628 >> 2], v, 1, A, A);
                                                        break k;
                                                    }
                                                    A = i[V + 16848 >> 2] != 0, fi(t, u, h, u, h, u, h, _, 0, 0, v + i[V + 632 >> 2] | 0, v, 0, A, A);
                                                }
                                                m = G + 80 | 0;
                                            }
                                            return;
                                        }
                                        y0(4105, 9012, 128, 3731), z();
                                    }
                                    y0(4067, 9012, 129, 3731), z();
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function th(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0;
                            k = 0, f = m - 112 | 0, m = f, _ = i[r + 384 >> 2], s = i[r + 388 >> 2], h6(f + 88 | 0, i[r + 20 >> 2] - -64 | 0, _, s);
                            i: {
                                if (i[f + 88 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 92 >> 2], i[A + 8 >> 2] = i[f + 88 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 107 | 0] >= 0) {
                                        A = i[f + 100 >> 2], i[r >> 2] = i[f + 96 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 104 >> 2];
                                        break i;
                                    }
                                    j(r, i[f + 96 >> 2], i[f + 100 >> 2]);
                                    break i;
                                }
                                if (k = D(136), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78252, B0(k + 20 | 0, 0, 104), u = i[k + 4 >> 2], t = u + 1 | 0, i[k + 4 >> 2] = t, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 44 >> 2] = 99, i[k + 48 >> 2] = 99, i[k + 32 >> 2] = 4142, n = k - -64 | 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 84 >> 2] = 1, i[k + 88 >> 2] = 1, i[k + 72 >> 2] = k + 76, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, i[k + 112 >> 2] = 0, o[k + 113 | 0] = 0, o[k + 114 | 0] = 0, o[k + 115 | 0] = 0, o[k + 116 | 0] = 0, o[k + 117 | 0] = 0, o[k + 118 | 0] = 0, o[k + 119 | 0] = 0, o[k + 120 | 0] = 0, y = k + 12 | 0, i[k + 12 >> 2] = y, i[k + 8 >> 2] = i[k + 8 >> 2] + 1, i[k + 4 >> 2] = u, i[k + 16 >> 2] = k, t || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), i[y + 36 >> 2] = 3, i[y + 32 >> 2] = 1, i[y + 28 >> 2] = s, i[y + 24 >> 2] = _, J0(f + 56 | 0, y, 3, _, s, 8, i[r + 20 >> 2] - -64 | 0), i[f + 56 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 60 >> 2], i[A + 8 >> 2] = i[f + 56 >> 2], i[A + 12 >> 2] = r, e = A + 16 | 0, o[f + 75 | 0] >= 0) {
                                        r = f - -64 | 0, A = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[r + 8 >> 2];
                                        break i;
                                    }
                                    if (j(e, i[f + 64 >> 2], i[f + 68 >> 2]), o[f + 75 | 0] >= 0) break i;
                                    X(i[f + 64 >> 2]);
                                    break i;
                                }
                                if (o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), J0(f + 56 | 0, y, 4, _, s, 8, i[r + 20 >> 2] - -64 | 0), i[f + 56 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 60 >> 2], i[A + 8 >> 2] = i[f + 56 >> 2], i[A + 12 >> 2] = r, e = A + 16 | 0, o[f + 75 | 0] >= 0) {
                                        r = f - -64 | 0, A = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[r + 8 >> 2];
                                        break i;
                                    }
                                    if (j(e, i[f + 64 >> 2], i[f + 68 >> 2]), o[f + 75 | 0] >= 0) break i;
                                    X(i[f + 64 >> 2]);
                                    break i;
                                }
                                if (o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), J0(f + 56 | 0, y, 5, _, s, 8, i[r + 20 >> 2] - -64 | 0), i[f + 56 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 60 >> 2], i[A + 8 >> 2] = i[f + 56 >> 2], i[A + 12 >> 2] = r, e = A + 16 | 0, o[f + 75 | 0] >= 0) {
                                        r = f - -64 | 0, A = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[r + 8 >> 2];
                                        break i;
                                    }
                                    if (j(e, i[f + 64 >> 2], i[f + 68 >> 2]), o[f + 75 | 0] >= 0) break i;
                                    X(i[f + 64 >> 2]);
                                    break i;
                                }
                                o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), R = f + 56 | 0, F = I[r + 374 >> 1], w = I[r + 376 >> 1], _ = I[r + 378 >> 1], h = I[r + 380 >> 1], G = m - 16 | 0, m = G;
                                e: {
                                    r: {
                                        if (u = i[y + 64 >> 2], !u) break r;
                                        for(t = y - -64 | 0, n = t; s = i[u + 16 >> 2] < 3, n = s ? n : u, u = i[(s << 2) + u >> 2], !!u;);
                                        if ((n | 0) == (t | 0) | i[n + 16 >> 2] >= 4) break r;
                                        w = w >>> 8 | 0, _ = _ >>> 8 | 0, h = h >>> 8 | 0, s = F >>> 8 | 0;
                                        A: {
                                            if (l[n + 24 | 0] != 8) break A;
                                            if (B0(i[n + 44 >> 2], s, Z(i[n + 32 >> 2], i[n + 52 >> 2])), u = i[t >> 2], !u) break r;
                                            for(n = t; s = i[u + 16 >> 2] < 4, n = s ? n : u, u = i[(s << 2) + u >> 2], !!u;);
                                            if ((n | 0) == (t | 0) | i[n + 16 >> 2] > 4) break r;
                                            if (l[n + 24 | 0] != 8) break A;
                                            if (B0(i[n + 44 >> 2], w, Z(i[n + 32 >> 2], i[n + 52 >> 2])), u = i[t >> 2], !u) break r;
                                            for(n = t; s = i[u + 16 >> 2] < 5, n = s ? n : u, u = i[(s << 2) + u >> 2], !!u;);
                                            if ((n | 0) == (t | 0) | i[n + 16 >> 2] > 5) break r;
                                            if (l[n + 24 | 0] != 8) break A;
                                            B0(i[n + 44 >> 2], _, Z(i[n + 32 >> 2], i[n + 52 >> 2])), u = i[t >> 2];
                                            f: {
                                                if (!u) break f;
                                                for(n = t; s = i[u + 16 >> 2] < 6, n = s ? n : u, u = i[(s << 2) + u >> 2], !!u;);
                                                if ((n | 0) == (t | 0) | i[n + 16 >> 2] > 6) break f;
                                                if (l[n + 24 | 0] != 8) break A;
                                                if (u = i[n + 52 >> 2], t = i[n + 32 >> 2], s = Z(u, t), n = i[n + 44 >> 2], t >>> 0 >= 4294967295 / (u >>> 0) >>> 0) {
                                                    B0(n, h, s);
                                                    break f;
                                                }
                                                B0(n, h, s);
                                            }
                                            if (n = i[21669], i[R >> 2] = i[21668], i[R + 4 >> 2] = n, t = R + 8 | 0, o[86691] >= 0) {
                                                n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                break e;
                                            }
                                            j(t, i[21670], i[21671]);
                                            break e;
                                        }
                                        if (n = D(56), i[G + 4 >> 2] = n, i[G + 8 >> 2] = 52, i[G + 12 >> 2] = -2147483592, u = l[8166] | l[8167] << 8 | (l[8168] << 16 | l[8169] << 24), t = l[8162] | l[8163] << 8 | (l[8164] << 16 | l[8165] << 24), o[n | 0] = t, o[n + 1 | 0] = t >>> 8, o[n + 2 | 0] = t >>> 16, o[n + 3 | 0] = t >>> 24, o[n + 4 | 0] = u, o[n + 5 | 0] = u >>> 8, o[n + 6 | 0] = u >>> 16, o[n + 7 | 0] = u >>> 24, o[n + 52 | 0] = 0, t = l[8210] | l[8211] << 8 | (l[8212] << 16 | l[8213] << 24), o[n + 48 | 0] = t, o[n + 49 | 0] = t >>> 8, o[n + 50 | 0] = t >>> 16, o[n + 51 | 0] = t >>> 24, u = l[8206] | l[8207] << 8 | (l[8208] << 16 | l[8209] << 24), t = l[8202] | l[8203] << 8 | (l[8204] << 16 | l[8205] << 24), o[n + 40 | 0] = t, o[n + 41 | 0] = t >>> 8, o[n + 42 | 0] = t >>> 16, o[n + 43 | 0] = t >>> 24, o[n + 44 | 0] = u, o[n + 45 | 0] = u >>> 8, o[n + 46 | 0] = u >>> 16, o[n + 47 | 0] = u >>> 24, u = l[8198] | l[8199] << 8 | (l[8200] << 16 | l[8201] << 24), t = l[8194] | l[8195] << 8 | (l[8196] << 16 | l[8197] << 24), o[n + 32 | 0] = t, o[n + 33 | 0] = t >>> 8, o[n + 34 | 0] = t >>> 16, o[n + 35 | 0] = t >>> 24, o[n + 36 | 0] = u, o[n + 37 | 0] = u >>> 8, o[n + 38 | 0] = u >>> 16, o[n + 39 | 0] = u >>> 24, u = l[8190] | l[8191] << 8 | (l[8192] << 16 | l[8193] << 24), t = l[8186] | l[8187] << 8 | (l[8188] << 16 | l[8189] << 24), o[n + 24 | 0] = t, o[n + 25 | 0] = t >>> 8, o[n + 26 | 0] = t >>> 16, o[n + 27 | 0] = t >>> 24, o[n + 28 | 0] = u, o[n + 29 | 0] = u >>> 8, o[n + 30 | 0] = u >>> 16, o[n + 31 | 0] = u >>> 24, u = l[8182] | l[8183] << 8 | (l[8184] << 16 | l[8185] << 24), t = l[8178] | l[8179] << 8 | (l[8180] << 16 | l[8181] << 24), o[n + 16 | 0] = t, o[n + 17 | 0] = t >>> 8, o[n + 18 | 0] = t >>> 16, o[n + 19 | 0] = t >>> 24, o[n + 20 | 0] = u, o[n + 21 | 0] = u >>> 8, o[n + 22 | 0] = u >>> 16, o[n + 23 | 0] = u >>> 24, u = l[8174] | l[8175] << 8 | (l[8176] << 16 | l[8177] << 24), t = l[8170] | l[8171] << 8 | (l[8172] << 16 | l[8173] << 24), o[n + 8 | 0] = t, o[n + 9 | 0] = t >>> 8, o[n + 10 | 0] = t >>> 16, o[n + 11 | 0] = t >>> 24, o[n + 12 | 0] = u, o[n + 13 | 0] = u >>> 8, o[n + 14 | 0] = u >>> 16, o[n + 15 | 0] = u >>> 24, i0(R, 4, 0, G + 4 | 0), o[G + 15 | 0] >= 0) break e;
                                        X(i[G + 4 >> 2]);
                                        break e;
                                    }
                                    if (o[G + 4 | 0] = 0, o[G + 15 | 0] = 0, i0(R, 5, 2002, G + 4 | 0), o[G + 15 | 0] >= 0) break e;
                                    X(i[G + 4 >> 2]);
                                }
                                m = G + 16 | 0, t = i[f + 60 >> 2], n = i[f + 56 >> 2], i[f + 88 >> 2] = n, i[f + 92 >> 2] = t, o[f + 107 | 0] < 0 && (X(i[f + 96 >> 2]), n = i[f + 88 >> 2]), t = i[f + 68 >> 2], i[f + 96 >> 2] = i[f + 64 >> 2], i[f + 100 >> 2] = t, i[f + 104 >> 2] = i[f + 72 >> 2];
                                e: {
                                    r: {
                                        if (!n) {
                                            if (n = i[r + 404 >> 2], (n | 0) == i[r + 408 >> 2]) break e;
                                            q = e + 28 | 0, v = A + 16 | 0, S = f - -64 | 0;
                                            break r;
                                        }
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 92 >> 2], i[A + 8 >> 2] = i[f + 88 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 107 | 0] >= 0) {
                                            A = i[f + 100 >> 2], i[r >> 2] = i[f + 96 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 104 >> 2];
                                            break i;
                                        }
                                        j(r, i[f + 96 >> 2], i[f + 100 >> 2]);
                                        break i;
                                    }
                                    for(;;){
                                        if (t = i[(c << 2) + n >> 2], (t | 0) == i[r + 36 >> 2]) {
                                            e = a1(f + 16 | 0, 19487), n = i0(f + 56 | 0, 2, 0, e), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 4 >> 2], i[A + 8 >> 2] = i[n >> 2], i[A + 12 >> 2] = r;
                                            r: {
                                                if (o[n + 19 | 0] >= 0) {
                                                    A = i[n + 12 >> 2], i[v >> 2] = i[n + 8 >> 2], i[v + 4 >> 2] = A, i[v + 8 >> 2] = i[n + 16 >> 2];
                                                    break r;
                                                }
                                                if (j(v, i[n + 8 >> 2], i[n + 12 >> 2]), o[n + 19 | 0] >= 0) break r;
                                                X(i[n + 8 >> 2]);
                                            }
                                            if (o[e + 11 | 0] >= 0) break i;
                                            X(i[e >> 2]);
                                            break i;
                                        }
                                        n = f + 56 | 0, v4(n, i[r + 20 >> 2], t, 1), P = i[f + 60 >> 2], t = i[f + 56 >> 2];
                                        r: {
                                            if (!t) {
                                                s = D(48), i[f + 16 >> 2] = s, i[f + 20 >> 2] = 44, i[f + 24 >> 2] = -2147483600, t = l[19482] | l[19483] << 8 | (l[19484] << 16 | l[19485] << 24), o[s + 40 | 0] = t, o[s + 41 | 0] = t >>> 8, o[s + 42 | 0] = t >>> 16, o[s + 43 | 0] = t >>> 24, u = l[19478] | l[19479] << 8 | (l[19480] << 16 | l[19481] << 24), t = l[19474] | l[19475] << 8 | (l[19476] << 16 | l[19477] << 24), o[s + 32 | 0] = t, o[s + 33 | 0] = t >>> 8, o[s + 34 | 0] = t >>> 16, o[s + 35 | 0] = t >>> 24, o[s + 36 | 0] = u, o[s + 37 | 0] = u >>> 8, o[s + 38 | 0] = u >>> 16, o[s + 39 | 0] = u >>> 24, u = l[19470] | l[19471] << 8 | (l[19472] << 16 | l[19473] << 24), t = l[19466] | l[19467] << 8 | (l[19468] << 16 | l[19469] << 24), o[s + 24 | 0] = t, o[s + 25 | 0] = t >>> 8, o[s + 26 | 0] = t >>> 16, o[s + 27 | 0] = t >>> 24, o[s + 28 | 0] = u, o[s + 29 | 0] = u >>> 8, o[s + 30 | 0] = u >>> 16, o[s + 31 | 0] = u >>> 24, u = l[19462] | l[19463] << 8 | (l[19464] << 16 | l[19465] << 24), t = l[19458] | l[19459] << 8 | (l[19460] << 16 | l[19461] << 24), o[s + 16 | 0] = t, o[s + 17 | 0] = t >>> 8, o[s + 18 | 0] = t >>> 16, o[s + 19 | 0] = t >>> 24, o[s + 20 | 0] = u, o[s + 21 | 0] = u >>> 8, o[s + 22 | 0] = u >>> 16, o[s + 23 | 0] = u >>> 24, u = l[19454] | l[19455] << 8 | (l[19456] << 16 | l[19457] << 24), t = l[19450] | l[19451] << 8 | (l[19452] << 16 | l[19453] << 24), o[s + 8 | 0] = t, o[s + 9 | 0] = t >>> 8, o[s + 10 | 0] = t >>> 16, o[s + 11 | 0] = t >>> 24, o[s + 12 | 0] = u, o[s + 13 | 0] = u >>> 8, o[s + 14 | 0] = u >>> 16, o[s + 15 | 0] = u >>> 24, u = l[19446] | l[19447] << 8 | (l[19448] << 16 | l[19449] << 24), t = l[19442] | l[19443] << 8 | (l[19444] << 16 | l[19445] << 24), o[s | 0] = t, o[s + 1 | 0] = t >>> 8, o[s + 2 | 0] = t >>> 16, o[s + 3 | 0] = t >>> 24, o[s + 4 | 0] = u, o[s + 5 | 0] = u >>> 8, o[s + 6 | 0] = u >>> 16, o[s + 7 | 0] = u >>> 24, o[s + 44 | 0] = 0, t = i0(n, 2, 2e3, f + 16 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[t + 4 >> 2], i[A + 8 >> 2] = i[t >> 2], i[A + 12 >> 2] = n;
                                                A: {
                                                    if (o[f + 75 | 0] >= 0) {
                                                        n = i[S + 4 >> 2], i[v >> 2] = i[S >> 2], i[v + 4 >> 2] = n, i[v + 8 >> 2] = i[S + 8 >> 2];
                                                        break A;
                                                    }
                                                    if (j(v, i[f + 64 >> 2], i[f + 68 >> 2]), o[f + 75 | 0] >= 0) break A;
                                                    X(i[f + 64 >> 2]);
                                                }
                                                o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), n = 1;
                                                break r;
                                            }
                                            if (p[i[i[t >> 2] + 20 >> 2]](f + 56 | 0, t), i[f + 56 >> 2]) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 60 >> 2], i[A + 8 >> 2] = i[f + 56 >> 2], i[A + 12 >> 2] = n, o[f + 75 | 0] >= 0) {
                                                    n = i[S + 4 >> 2], i[v >> 2] = i[S >> 2], i[v + 4 >> 2] = n, i[v + 8 >> 2] = i[S + 8 >> 2], n = 1;
                                                    break r;
                                                }
                                                j(v, i[f + 64 >> 2], i[f + 68 >> 2]), o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), n = 1;
                                                break r;
                                            }
                                            o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), ii(f + 56 | 0, t, e, 0, 0, 0);
                                            A: {
                                                f: {
                                                    if (i[f + 64 >> 2]) {
                                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 68 >> 2], i[A + 8 >> 2] = i[f + 64 >> 2], i[A + 12 >> 2] = n, o[f + 83 | 0] >= 0) {
                                                            n = i[f + 76 >> 2], i[v >> 2] = i[f + 72 >> 2], i[v + 4 >> 2] = n, i[v + 8 >> 2] = i[f + 80 >> 2], n = 1;
                                                            break A;
                                                        }
                                                        j(v, i[f + 72 >> 2], i[f + 76 >> 2]), n = 1;
                                                        break f;
                                                    }
                                                    n = i[f + 56 >> 2], i[f + 48 >> 2] = n, t = i[f + 60 >> 2], i[f + 52 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1);
                                                    k: {
                                                        if (!(i[n + 32 >> 2] == 1 & i[n + 36 >> 2] == 3)) {
                                                            i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, s6(f + 16 | 0, f + 48 | 0, 1, 3, f + 8 | 0, 0, q, i[r + 20 >> 2] - -64 | 0), t = i[f + 12 >> 2];
                                                            n: {
                                                                if (!t || (n = i[t + 4 >> 2], i[t + 4 >> 2] = n - 1, n)) break n;
                                                                p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                            }
                                                            t = i[f + 24 >> 2];
                                                            n: {
                                                                t: {
                                                                    if (t) {
                                                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 28 >> 2], i[A + 8 >> 2] = i[f + 24 >> 2], i[A + 12 >> 2] = n, o[f + 43 | 0] >= 0) {
                                                                            n = i[f + 36 >> 2], i[v >> 2] = i[f + 32 >> 2], i[v + 4 >> 2] = n, i[v + 8 >> 2] = i[f + 40 >> 2];
                                                                            break n;
                                                                        }
                                                                        j(v, i[f + 32 >> 2], i[f + 36 >> 2]);
                                                                        break t;
                                                                    }
                                                                    et(f + 48 | 0, f + 16 | 0);
                                                                }
                                                                if (o[f + 43 | 0] >= 0) break n;
                                                                X(i[f + 32 >> 2]);
                                                            }
                                                            u = i[f + 20 >> 2];
                                                            n: {
                                                                if (!u || (n = i[u + 4 >> 2], i[u + 4 >> 2] = n - 1, n)) break n;
                                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                            }
                                                            if (n = 1, t) break k;
                                                        }
                                                        if (n = i[r + 392 >> 2] + Z(c, 12) | 0, H = i[n + 4 >> 2], T = i[n + 8 >> 2], s0 = 0, C = m - 16 | 0, m = C, n = i[f + 48 >> 2], r0 = C + 8 | 0, i[C + 4 >> 2] = r0, i[C + 8 >> 2] = 0, i[C + 12 >> 2] = 0, V = f + 16 | 0, u = i[n + 60 >> 2], _ = n - -64 | 0, (u | 0) != (_ | 0)) {
                                                            for(;;){
                                                                w = i[u + 16 >> 2], s = r0, n = s, t = i[C + 8 >> 2];
                                                                n: {
                                                                    t: {
                                                                        if (!t) break t;
                                                                        for(;;){
                                                                            if (n = t, t = i[n + 16 >> 2], (t | 0) > (w | 0)) {
                                                                                if (s = n, t = i[n >> 2], t) continue;
                                                                                break t;
                                                                            }
                                                                            if ((t | 0) >= (w | 0)) break n;
                                                                            if (t = i[n + 4 >> 2], !t) break;
                                                                        }
                                                                        s = n + 4 | 0;
                                                                    }
                                                                    t = D(20), i[t + 8 >> 2] = n, i[t >> 2] = 0, i[t + 4 >> 2] = 0, i[t + 16 >> 2] = w, i[s >> 2] = t, n = i[i[C + 4 >> 2] >> 2], n && (i[C + 4 >> 2] = n, t = i[s >> 2]), h4(i[C + 8 >> 2], t), i[C + 12 >> 2] = i[C + 12 >> 2] + 1;
                                                                }
                                                                t = i[u + 4 >> 2];
                                                                n: {
                                                                    if (t) {
                                                                        for(;;)if (n = t, t = i[n >> 2], !t) break n;
                                                                    }
                                                                    for(; n = i[u + 8 >> 2], t = i[n >> 2] != (u | 0), u = n, !!t;);
                                                                }
                                                                if (u = n, (n | 0) == (_ | 0)) break;
                                                            }
                                                            n = i[f + 48 >> 2];
                                                        }
                                                        w = n - -64 | 0, n = i[n + 64 >> 2];
                                                        n: {
                                                            t: {
                                                                if (!n) break t;
                                                                for(u = w, t = n; s = i[t + 16 >> 2] < 6, u = s ? u : t, t = i[(s << 2) + t >> 2], !!t;);
                                                                if ((u | 0) == (w | 0)) break t;
                                                                if (i[u + 16 >> 2] < 7) break n;
                                                            }
                                                            u = w;
                                                        }
                                                        n: {
                                                            if (!n) break n;
                                                            for(t = w; s = i[n + 16 >> 2] < 6, t = s ? t : n, n = i[(s << 2) + n >> 2], !!n;);
                                                            if ((t | 0) == (w | 0) | i[t + 16 >> 2] > 6) break n;
                                                            s0 = i[t + 44 >> 2];
                                                        }
                                                        n: {
                                                            t: {
                                                                if (s = i[C + 4 >> 2], (r0 | 0) == (s | 0) || (t = i[y + 64 >> 2], !t)) break t;
                                                                for(L = 0 - T | 0, G = 0 - H | 0, _ = y - -64 | 0, m0 = (H | 0) <= 0, Z0 = (H | 0) >= 0, X0 = (u | 0) != (w | 0);;){
                                                                    o: {
                                                                        if (!t) break o;
                                                                        for(B = i[s + 16 >> 2], u = _, n = t; w = (B | 0) > i[n + 16 >> 2], u = w ? u : n, n = i[(w << 2) + n >> 2], !!n;);
                                                                        if ((u | 0) == (_ | 0) | (B | 0) < i[u + 16 >> 2]) break o;
                                                                        n = i[f + 48 >> 2], w = n - -64 | 0, h = w;
                                                                        s: {
                                                                            u: {
                                                                                if (u = i[n + 64 >> 2], n = u, !n) break u;
                                                                                for(; F = (B | 0) > i[n + 16 >> 2], h = F ? h : n, n = i[(F << 2) + n >> 2], !!n;);
                                                                                if ((h | 0) == (w | 0)) break u;
                                                                                if (f0 = 0, R = 0, (B | 0) < i[h + 16 >> 2]) break s;
                                                                                f0 = i[h + 52 >> 2], R = i[h + 44 >> 2];
                                                                                break s;
                                                                            }
                                                                            f0 = 0, R = 0;
                                                                        }
                                                                        for(h = _, n = t; F = (B | 0) > i[n + 16 >> 2], h = F ? h : n, n = i[(F << 2) + n >> 2], !!n;);
                                                                        E = 0;
                                                                        s: {
                                                                            if ((h | 0) == (_ | 0)) {
                                                                                $ = 0, F = 0;
                                                                                break s;
                                                                            }
                                                                            if ($ = 0, F = 0, (B | 0) < i[h + 16 >> 2]) break s;
                                                                            $ = i[h + 44 >> 2], F = i[h + 52 >> 2];
                                                                        }
                                                                        h = w, M = 0, n = u;
                                                                        s: {
                                                                            if (!n) break s;
                                                                            for(; W = (B | 0) > i[n + 16 >> 2], h = W ? h : n, n = i[(W << 2) + n >> 2], !!n;);
                                                                            for(E = (h | 0) == (w | 0) | (B | 0) < i[h + 16 >> 2] ? E : i[h + 28 >> 2], n = w; h = (B | 0) > i[u + 16 >> 2], n = h ? n : u, u = i[(h << 2) + u >> 2], !!u;);
                                                                            if ((n | 0) == (w | 0) | (B | 0) < i[n + 16 >> 2]) break s;
                                                                            M = i[n + 32 >> 2];
                                                                        }
                                                                        for(u = _, n = t; w = (B | 0) > i[n + 16 >> 2], u = w ? u : n, n = i[(w << 2) + n >> 2], !!n;);
                                                                        for(h = 0, h = (u | 0) == (_ | 0) | (B | 0) < i[u + 16 >> 2] ? h : i[u + 28 >> 2], n = _; u = (B | 0) > i[t + 16 >> 2], n = u ? n : t, t = i[(u << 2) + t >> 2], !!t;);
                                                                        if (u = 0, u = (n | 0) == (_ | 0) | (B | 0) < i[n + 16 >> 2] ? u : i[n + 32 >> 2], !(h >>> 0 > H >>> 0 | m0)) {
                                                                            if (n = i[21669], i[V >> 2] = i[21668], i[V + 4 >> 2] = n, t = V + 8 | 0, o[86691] >= 0) {
                                                                                n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                                                break n;
                                                                            }
                                                                            j(t, i[21670], i[21671]);
                                                                            break n;
                                                                        }
                                                                        if (t = 0, Z0) n = H;
                                                                        else {
                                                                            if (G >>> 0 >= E >>> 0) {
                                                                                if (n = i[21669], i[V >> 2] = i[21668], i[V + 4 >> 2] = n, t = V + 8 | 0, o[86691] >= 0) {
                                                                                    n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                                                    break n;
                                                                                }
                                                                                j(t, i[21670], i[21671]);
                                                                                break n;
                                                                            }
                                                                            E = E + H | 0, t = G, n = 0;
                                                                        }
                                                                        if (!((T | 0) <= 0 | u >>> 0 > T >>> 0)) {
                                                                            if (n = i[21669], i[V >> 2] = i[21668], i[V + 4 >> 2] = n, t = V + 8 | 0, o[86691] >= 0) {
                                                                                n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                                                break n;
                                                                            }
                                                                            j(t, i[21670], i[21671]);
                                                                            break n;
                                                                        }
                                                                        if (W = 0, (T | 0) >= 0) w = T;
                                                                        else {
                                                                            if (M >>> 0 <= L >>> 0) {
                                                                                if (n = i[21669], i[V >> 2] = i[21668], i[V + 4 >> 2] = n, t = V + 8 | 0, o[86691] >= 0) {
                                                                                    n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                                                    break n;
                                                                                }
                                                                                j(t, i[21670], i[21671]);
                                                                                break n;
                                                                            }
                                                                            M = M + T | 0, W = L, w = 0;
                                                                        }
                                                                        if (B = u - T | 0, t0 = T >>> 0 > (M ^ -1) >>> 0 || M + T >>> 0 > u >>> 0 ? B : M, t0 >>> 0 <= W >>> 0) break o;
                                                                        if (u = h - H | 0, E = H >>> 0 > (E ^ -1) >>> 0 || E + H >>> 0 > h >>> 0 ? u : E, M = n + $ | 0, $ = w - W | 0, !X0) {
                                                                            for(u = E - t | 0, n = t + R | 0; v0(M + Z(W + $ | 0, F) | 0, n + Z(W, f0) | 0, u), W = W + 1 | 0, (t0 | 0) != (W | 0););
                                                                            break o;
                                                                        }
                                                                        if (t >>> 0 >= E >>> 0) break o;
                                                                        for(;;){
                                                                            for(B = Z(W, f0) + t | 0, h = M + Z(W + $ | 0, F) | 0, n = t; u = n + h | 0, V0 = u, I0 = l[u | 0], w = n + B | 0, u = l[w + s0 | 0], o[V0 | 0] = (Z(I0, u ^ 255) + Z(l[w + R | 0], u) >>> 0) / 255, n = n + 1 | 0, (E | 0) != (n | 0););
                                                                            if (W = W + 1 | 0, (t0 | 0) == (W | 0)) break;
                                                                        }
                                                                    }
                                                                    t = i[s + 4 >> 2];
                                                                    o: {
                                                                        if (t) {
                                                                            for(;;)if (n = t, t = i[n >> 2], !t) break o;
                                                                        }
                                                                        for(; n = i[s + 8 >> 2], t = i[n >> 2] != (s | 0), s = n, !!t;);
                                                                    }
                                                                    if ((n | 0) == (r0 | 0)) break t;
                                                                    t = i[_ >> 2], s = n;
                                                                }
                                                            }
                                                            if (n = i[21669], i[V >> 2] = i[21668], i[V + 4 >> 2] = n, t = V + 8 | 0, o[86691] >= 0) {
                                                                n = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = n, i[t + 8 >> 2] = i[21672];
                                                                break n;
                                                            }
                                                            j(t, i[21670], i[21671]);
                                                        }
                                                        if (Si(C + 4 | 0, i[C + 8 >> 2]), m = C + 16 | 0, t = i[f + 20 >> 2], n = i[f + 16 >> 2], i[f + 88 >> 2] = n, i[f + 92 >> 2] = t, o[f + 107 | 0] >= 0 || (X(i[f + 96 >> 2]), n = i[f + 88 >> 2]), t = n, n = i[f + 28 >> 2], i[f + 96 >> 2] = i[f + 24 >> 2], i[f + 100 >> 2] = n, i[f + 104 >> 2] = i[f + 32 >> 2], n = 0, !t | (t | 0) == 2 & i[f + 92 >> 2] == 122) break k;
                                                        i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[f + 92 >> 2], i[A + 8 >> 2] = i[f + 88 >> 2], i[A + 12 >> 2] = n;
                                                        n: {
                                                            if (o[f + 107 | 0] >= 0) {
                                                                n = i[f + 100 >> 2], i[v >> 2] = i[f + 96 >> 2], i[v + 4 >> 2] = n, i[v + 8 >> 2] = i[f + 104 >> 2];
                                                                break n;
                                                            }
                                                            j(v, i[f + 96 >> 2], i[f + 100 >> 2]);
                                                        }
                                                        n = 1;
                                                    }
                                                    if (u = i[f + 52 >> 2], !u || (t = i[u + 4 >> 2], i[u + 4 >> 2] = t - 1, t)) break f;
                                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                }
                                                if (o[f + 83 | 0] >= 0) break A;
                                                X(i[f + 72 >> 2]);
                                            }
                                            if (u = i[f + 60 >> 2], !u || (t = i[u + 4 >> 2], i[u + 4 >> 2] = t - 1, t)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        r: {
                                            if (!P || (t = i[P + 4 >> 2], i[P + 4 >> 2] = t - 1, t)) break r;
                                            p[i[i[P >> 2] + 8 >> 2]](P), g(P);
                                        }
                                        if (n) break i;
                                        if (c = c + 1 | 0, n = i[r + 404 >> 2], !(c >>> 0 < i[r + 408 >> 2] - n >> 2 >>> 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = k, i[A >> 2] = y, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            o[f + 107 | 0] < 0 && X(i[f + 96 >> 2]);
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 112 | 0;
                        }
                        function G7(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            h = m - 16 | 0, m = h, p[i[i[r >> 2] + 80 >> 2]](A, r, e, f, k, n);
                            i: {
                                e: {
                                    if (i[A + 32 >> 2]) break e;
                                    v = e, u = i[k + 4 >> 2], s = A, _ = m - 16 | 0, m = _;
                                    r: {
                                        A: switch(n - 1 | 0){
                                            case 0:
                                            case 3:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        A = i[v >> 2], t = i[A + 52 >> 2], n = i[A + 56 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1);
                                        A: {
                                            f: {
                                                if (t) {
                                                    if (A = D(128), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 77256, e = A + 16 | 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[e >> 2] = 78708, i[A + 32 >> 2] = 1668246642, i[A + 120 >> 2] = 0, n) {
                                                        i[n + 4 >> 2] = i[n + 4 >> 2] + 2, i[A + 116 >> 2] = t, t = i[A + 120 >> 2], i[A + 120 >> 2] = n;
                                                        k: {
                                                            if (!t || (w = i[t + 4 >> 2], i[t + 4 >> 2] = w - 1, w)) break k;
                                                            p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                        }
                                                        if (t = i[n + 4 >> 2], i[n + 4 >> 2] = t - 1, t) break f;
                                                        p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                        break f;
                                                    }
                                                    i[A + 120 >> 2] = n, i[A + 116 >> 2] = t;
                                                    break f;
                                                }
                                                A = l[k | 0], e = i[k + 4 >> 2] != 0;
                                                break A;
                                            }
                                            i[_ + 12 >> 2] = A, i[_ + 8 >> 2] = e, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, t = i[s + 4 >> 2];
                                            f: {
                                                if (t >>> 0 < k0[s + 8 >> 2]) {
                                                    i[t + 4 >> 2] = A, i[t >> 2] = e, i[s + 4 >> 2] = t + 8;
                                                    break f;
                                                }
                                                if (t = p2(s, _ + 8 | 0), e = i[_ + 12 >> 2], i[s + 4 >> 2] = t, !e || (t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t)) break f;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), A = l[k | 0], e = l[k + 3 | 0] != 0 & i[k + 4 >> 2] != 0 & A >>> 0 > 2;
                                        }
                                        A: {
                                            if (!(!l[k + 8 | 0] | A >>> 0 < 4) | !e) break A;
                                            k = D(24), o[k + 22 | 0] = 1, Q[k + 20 >> 1] = 2, i[k + 16 >> 2] = 131074, i[k + 12 >> 2] = 78668, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78292, t = k + 12 | 0, o[t + 10 | 0] = 1, Q[t + 8 >> 1] = 6, i[t + 4 >> 2] = 851969, dt(t, u), A = D(128), i[A >> 2] = 77256, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, e = A + 16 | 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[e >> 2] = 78708, i[A + 32 >> 2] = 1668246642, i[k + 4 >> 2] = i[k + 4 >> 2] + 2, i[A + 120 >> 2] = k, i[A + 116 >> 2] = t, t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), i[_ + 12 >> 2] = A, i[_ + 8 >> 2] = e, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, t = i[s + 4 >> 2];
                                            f: {
                                                if (t >>> 0 < k0[s + 8 >> 2]) {
                                                    i[t + 4 >> 2] = A, i[t >> 2] = e, i[s + 4 >> 2] = t + 8;
                                                    break f;
                                                }
                                                if (t = p2(s, _ + 8 | 0), e = i[_ + 12 >> 2], i[s + 4 >> 2] = t, !e || (t = i[e + 4 >> 2], i[e + 4 >> 2] = t - 1, t)) break f;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            if (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A) break A;
                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        }
                                        if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break r;
                                        p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                    }
                                    m = _ + 16 | 0, A = i[v >> 2], e = i[A + 28 >> 2], k = i[A + 24 >> 2], A = i[s + 24 >> 2], i[h + 12 >> 2] = A, i[h + 8 >> 2] = i[s + 28 >> 2];
                                    r: {
                                        if (A) break r;
                                        A: {
                                            if (A = i[f >> 2], i[A >> 2] < 3 || (A = i[A + 112 >> 2], !A)) break A;
                                            p[A | 0](i[f + 4 >> 2], k, e, h + 12 | 0, h + 8 | 0);
                                            break r;
                                        }
                                        i[h + 8 >> 2] = e, i[h + 12 >> 2] = k;
                                    }
                                    _ = D(128), A = _, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76576, f = A + 16 | 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 16 >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[A + 16 >> 2] = 74528, i[A + 32 >> 2] = 1769173093, n = i[h + 12 >> 2], i[A + 124 >> 2] = i[h + 8 >> 2], i[A + 120 >> 2] = n, C = A, V = p[i[i[r >> 2] + 16 >> 2]](r) | 0, o[C + 112 | 0] = V, i[h + 4 >> 2] = A, i[h >> 2] = f, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, r = i[s + 4 >> 2];
                                    r: {
                                        if (r >>> 0 < k0[s + 8 >> 2]) {
                                            i[r + 4 >> 2] = A, i[r >> 2] = f, i[s + 4 >> 2] = r + 8;
                                            break r;
                                        }
                                        if (r = p2(s, h), A = i[h + 4 >> 2], i[s + 4 >> 2] = r, !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    r: {
                                        if ((k | 0) == i[h + 12 >> 2] & (e | 0) == i[h + 8 >> 2]) break r;
                                        A = D(152), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76736, f = A + 16 | 0, r = f, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 16 >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[A + 16 >> 2] = 74876, i[A + 140 >> 2] = 0, i[A + 144 >> 2] = 1, i[A + 132 >> 2] = 0, i[A + 136 >> 2] = 1, i[A + 124 >> 2] = 0, i[A + 128 >> 2] = 1, i[A + 116 >> 2] = 0, i[A + 120 >> 2] = 1, i[A + 32 >> 2] = 1668047216, n = i[h + 12 >> 2], r = i[h + 8 >> 2], i[A + 124 >> 2] = e, i[A + 128 >> 2] = 1, i[A + 116 >> 2] = k, i[A + 120 >> 2] = 1, r = e - r | 0, e = r - 65537 >>> 0 < 4294836223, i[A + 140 >> 2] = e & 0 | (e ? (r | 0) / 2 | 0 : r), i[A + 144 >> 2] = e ? 1 : 2, r = k - n | 0, e = r - 65537 >>> 0 < 4294836223, i[A + 132 >> 2] = e & 0 | (e ? (r | 0) / 2 | 0 : r), i[A + 136 >> 2] = e ? 1 : 2, i[h + 4 >> 2] = A, i[h >> 2] = f, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, r = i[s + 4 >> 2];
                                        A: {
                                            if (r >>> 0 < k0[s + 8 >> 2]) {
                                                i[r + 4 >> 2] = A, i[r >> 2] = f, i[s + 4 >> 2] = r + 8;
                                                break A;
                                            }
                                            if (e = p2(s, h), r = i[h + 4 >> 2], i[s + 4 >> 2] = e, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    A = i[v >> 2], r = i[A + 36 >> 2], e = i[A + 32 >> 2], t = D(136), i[t >> 2] = 77296, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, G = t + 16 | 0, A = G, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 32 >> 2] = 0, i[A >> 2] = 73428, i[t + 60 >> 2] = 0, i[t + 64 >> 2] = 0, i[t + 52 >> 2] = 0, i[t + 56 >> 2] = 0, i[t + 72 >> 2] = -1, i[t + 76 >> 2] = -1, i[t + 80 >> 2] = -1, i[t + 84 >> 2] = -1, i[t + 116 >> 2] = 0, i[t + 88 >> 2] = 0, i[t + 92 >> 2] = 0, i[t + 96 >> 2] = 0, i[t + 100 >> 2] = 0, i[t + 104 >> 2] = 0, i[t + 108 >> 2] = 0, Q[t + 112 >> 1] = 0, i[A >> 2] = 75596, i[t + 128 >> 2] = 0, i[t + 120 >> 2] = 0, i[t + 124 >> 2] = 0, i[t + 32 >> 2] = 1885960297;
                                    r: {
                                        A: switch(e | 0){
                                            case 2:
                                                if (k = S0(i[v >> 2], 0), A = i[t + 124 >> 2], f = i[t + 128 >> 2], A >>> 0 < f >>> 0) {
                                                    o[A | 0] = k, i[t + 124 >> 2] = A + 1;
                                                    break r;
                                                }
                                                if (u = i[t + 120 >> 2], e = A - u | 0, r = e + 1 | 0, (r | 0) < 0) break i;
                                                f = f - u | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? r = D(n) : r = 0, f = e + r | 0, o[f | 0] = k, B = r + n | 0, k = f + 1 | 0;
                                                f: {
                                                    if ((A | 0) == (u | 0)) {
                                                        r = f;
                                                        break f;
                                                    }
                                                    e = e & 3;
                                                    k: {
                                                        if (!e) {
                                                            n = A;
                                                            break k;
                                                        }
                                                        for(w = 0, n = A; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                    }
                                                    if (u - A >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                    u = i[t + 120 >> 2];
                                                }
                                                i[t + 128 >> 2] = B, i[t + 124 >> 2] = k, i[t + 120 >> 2] = r, u && X(u), i[t + 124 >> 2] = k;
                                                break r;
                                            case 0:
                                                k = S0(i[v >> 2], 0), A = i[t + 124 >> 2], f = i[t + 128 >> 2];
                                                f: {
                                                    if (A >>> 0 < f >>> 0) {
                                                        o[A | 0] = k, k = A + 1 | 0;
                                                        break f;
                                                    }
                                                    if (u = i[t + 120 >> 2], e = A - u | 0, r = e + 1 | 0, (r | 0) < 0) break i;
                                                    f = f - u | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? r = D(n) : r = 0, f = e + r | 0, o[f | 0] = k, B = r + n | 0, k = f + 1 | 0;
                                                    k: {
                                                        if ((A | 0) == (u | 0)) {
                                                            r = f;
                                                            break k;
                                                        }
                                                        e = e & 3;
                                                        n: {
                                                            if (!e) {
                                                                n = A;
                                                                break n;
                                                            }
                                                            for(w = 0, n = A; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                        }
                                                        if (u - A >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                        u = i[t + 120 >> 2];
                                                    }
                                                    if (i[t + 128 >> 2] = B, i[t + 124 >> 2] = k, i[t + 120 >> 2] = r, !u) break f;
                                                    X(u);
                                                }
                                                i[t + 124 >> 2] = k, k = S0(i[v >> 2], 1), A = i[t + 124 >> 2], f = i[t + 128 >> 2];
                                                f: {
                                                    if (A >>> 0 < f >>> 0) {
                                                        o[A | 0] = k, k = A + 1 | 0;
                                                        break f;
                                                    }
                                                    if (u = i[t + 120 >> 2], e = A - u | 0, r = e + 1 | 0, (r | 0) < 0) break i;
                                                    f = f - u | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? r = D(n) : r = 0, f = e + r | 0, o[f | 0] = k, B = r + n | 0, k = f + 1 | 0;
                                                    k: {
                                                        if ((A | 0) == (u | 0)) {
                                                            r = f;
                                                            break k;
                                                        }
                                                        e = e & 3;
                                                        n: {
                                                            if (!e) {
                                                                n = A;
                                                                break n;
                                                            }
                                                            for(w = 0, n = A; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                        }
                                                        if (u - A >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                        u = i[t + 120 >> 2];
                                                    }
                                                    if (i[t + 128 >> 2] = B, i[t + 124 >> 2] = k, i[t + 120 >> 2] = r, !u) break f;
                                                    X(u);
                                                }
                                                if (i[t + 124 >> 2] = k, k = S0(i[v >> 2], 2), A = i[t + 124 >> 2], f = i[t + 128 >> 2], A >>> 0 < f >>> 0) {
                                                    o[A | 0] = k, i[t + 124 >> 2] = A + 1;
                                                    break r;
                                                }
                                                if (u = i[t + 120 >> 2], e = A - u | 0, r = e + 1 | 0, (r | 0) < 0) break i;
                                                f = f - u | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? r = D(n) : r = 0, f = e + r | 0, o[f | 0] = k, B = r + n | 0, k = f + 1 | 0;
                                                f: {
                                                    if ((A | 0) == (u | 0)) {
                                                        r = f;
                                                        break f;
                                                    }
                                                    e = e & 3;
                                                    k: {
                                                        if (!e) {
                                                            n = A;
                                                            break k;
                                                        }
                                                        for(w = 0, n = A; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                    }
                                                    if (u - A >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                    u = i[t + 120 >> 2];
                                                }
                                                i[t + 128 >> 2] = B, i[t + 124 >> 2] = k, i[t + 120 >> 2] = r, u && X(u), i[t + 124 >> 2] = k;
                                                break r;
                                            case 1:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        if (r - 10 >>> 0 >= 6) {
                                            if ((r | 0) != 3) break r;
                                            j3(G, S0(i[v >> 2], 3)), j3(G, S0(i[v >> 2], 4)), j3(G, S0(i[v >> 2], 5));
                                            break r;
                                        }
                                        B = S0(i[v >> 2], 10), e = i[t + 124 >> 2], r = i[t + 128 >> 2];
                                        A: {
                                            if (e >>> 0 < r >>> 0) {
                                                o[e | 0] = B, r = e + 1 | 0;
                                                break A;
                                            }
                                            if (u = i[t + 120 >> 2], k = e - u | 0, A = k + 1 | 0, (A | 0) < 0) break i;
                                            r = r - u | 0, f = r << 1, r = r >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < f >>> 0 ? f : A, r ? A = D(r) : A = 0, f = k + A | 0, o[f | 0] = B, W = A + r | 0, r = f + 1 | 0;
                                            f: {
                                                if ((e | 0) == (u | 0)) {
                                                    A = f;
                                                    break f;
                                                }
                                                k = k & 3;
                                                k: {
                                                    if (!k) {
                                                        n = e;
                                                        break k;
                                                    }
                                                    for(w = 0, n = e; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (k | 0) != (w | 0););
                                                }
                                                if (u - e >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                u = i[t + 120 >> 2];
                                            }
                                            if (i[t + 128 >> 2] = W, i[t + 124 >> 2] = r, i[t + 120 >> 2] = A, !u) break A;
                                            X(u);
                                        }
                                        i[t + 124 >> 2] = r, f = i[t + 128 >> 2];
                                        A: {
                                            if (f >>> 0 > r >>> 0) {
                                                o[r | 0] = B, k = r + 1 | 0;
                                                break A;
                                            }
                                            if (u = i[t + 120 >> 2], e = r - u | 0, A = e + 1 | 0, (A | 0) < 0) break i;
                                            f = f - u | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < k >>> 0 ? k : A, k ? A = D(k) : A = 0, f = e + A | 0, o[f | 0] = B, W = A + k | 0, k = f + 1 | 0;
                                            f: {
                                                if ((r | 0) == (u | 0)) {
                                                    A = f;
                                                    break f;
                                                }
                                                e = e & 3;
                                                k: {
                                                    if (!e) {
                                                        n = r;
                                                        break k;
                                                    }
                                                    for(w = 0, n = r; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                }
                                                if (u - r >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                u = i[t + 120 >> 2];
                                            }
                                            if (i[t + 128 >> 2] = W, i[t + 124 >> 2] = k, i[t + 120 >> 2] = A, !u) break A;
                                            X(u);
                                        }
                                        i[t + 124 >> 2] = k, r = i[t + 128 >> 2];
                                        A: {
                                            if (r >>> 0 > k >>> 0) {
                                                o[k | 0] = B, A = k + 1 | 0;
                                                break A;
                                            }
                                            if (u = i[t + 120 >> 2], e = k - u | 0, A = e + 1 | 0, (A | 0) < 0) break i;
                                            r = r - u | 0, f = r << 1, A = r >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < f >>> 0 ? f : A, A ? r = D(A) : r = 0, f = e + r | 0, o[f | 0] = B, B = A + r | 0, A = f + 1 | 0;
                                            f: {
                                                if ((k | 0) == (u | 0)) {
                                                    r = f;
                                                    break f;
                                                }
                                                e = e & 3;
                                                k: {
                                                    if (!e) {
                                                        n = k;
                                                        break k;
                                                    }
                                                    for(w = 0, n = k; f = f - 1 | 0, n = n - 1 | 0, o[f | 0] = l[n | 0], w = w + 1 | 0, (e | 0) != (w | 0););
                                                }
                                                if (u - k >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[n - 1 | 0], o[f - 2 | 0] = l[n - 2 | 0], o[f - 3 | 0] = l[n - 3 | 0], f = f - 4 | 0, n = n - 4 | 0, o[f | 0] = l[n | 0], (n | 0) != (u | 0););
                                                u = i[t + 120 >> 2];
                                            }
                                            if (i[t + 128 >> 2] = B, i[t + 124 >> 2] = A, i[t + 120 >> 2] = r, !u) break A;
                                            X(u);
                                        }
                                        i[t + 124 >> 2] = A;
                                    }
                                    i[h + 4 >> 2] = t, i[h >> 2] = G, i[t + 4 >> 2] = i[t + 4 >> 2] + 1, A = i[s + 4 >> 2];
                                    r: {
                                        if (A >>> 0 < k0[s + 8 >> 2]) {
                                            i[A + 4 >> 2] = t, i[A >> 2] = G, i[s + 4 >> 2] = A + 8;
                                            break r;
                                        }
                                        if (r = p2(s, h), A = i[h + 4 >> 2], i[s + 4 >> 2] = r, !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    A = i[v >> 2];
                                    r: {
                                        if (i[A + 72 >> 2] == i[A + 76 >> 2]) break r;
                                        A = D(128), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 77336, e = A + 16 | 0, r = e, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 16 >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[A + 16 >> 2] = 75668, i[A + 32 >> 2] = 1885434736, i[A + 120 >> 2] = 1, r = i[v >> 2], i[A + 116 >> 2] = i[r + 72 >> 2], i[A + 120 >> 2] = i[r + 76 >> 2], i[h + 4 >> 2] = A, i[h >> 2] = e, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, r = i[s + 4 >> 2];
                                        A: {
                                            if (r >>> 0 < k0[s + 8 >> 2]) {
                                                i[r + 4 >> 2] = A, i[r >> 2] = e, i[s + 4 >> 2] = r + 8;
                                                break A;
                                            }
                                            if (e = p2(s, h), r = i[h + 4 >> 2], i[s + 4 >> 2] = e, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    A = i[v >> 2];
                                    r: {
                                        if (!(I[A + 80 >> 1] | I[A + 82 >> 1])) break r;
                                        A = D(120), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 77496, e = A + 16 | 0, r = e, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 16 >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[A + 16 >> 2] = 75812, Q[A + 114 >> 1] = 0, Q[A + 116 >> 1] = 0, i[A + 32 >> 2] = 1668050025, r = i[i[v >> 2] + 80 >> 2], Q[A + 114 >> 1] = r, Q[A + 116 >> 1] = r >>> 16, i[h + 4 >> 2] = A, i[h >> 2] = e, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, r = i[s + 4 >> 2];
                                        A: {
                                            if (r >>> 0 < k0[s + 8 >> 2]) {
                                                i[r + 4 >> 2] = A, i[r >> 2] = e, i[s + 4 >> 2] = r + 8;
                                                break A;
                                            }
                                            if (e = p2(s, h), r = i[h + 4 >> 2], i[s + 4 >> 2] = e, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    r: {
                                        if (l[i[v >> 2] + 108 | 0] != 1) break r;
                                        r = D(144), A = r, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 77536, A = A + 16 | 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 56 >> 2] = -1, i[A + 60 >> 2] = -1, i[A + 72 >> 2] = 0, i[A + 76 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, e = A - -64 | 0, i[e >> 2] = -1, i[e + 4 >> 2] = -1, i[A + 80 >> 2] = 0, i[A + 84 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, o[A + 96 | 0] = 0, i[A + 108 >> 2] = 0, i[A + 112 >> 2] = 0, i[A + 116 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 16 >> 2] = 1835295606, i[A >> 2] = 73512, e = i[v >> 2], f = i[e + 92 >> 2], k = i[e + 96 >> 2], n = i[e + 84 >> 2], v = i[e + 88 >> 2], u = i[e + 104 >> 2], i[r + 132 >> 2] = i[e + 100 >> 2], i[r + 136 >> 2] = u, i[r + 124 >> 2] = f, i[r + 128 >> 2] = k, i[r + 116 >> 2] = n, i[r + 120 >> 2] = v, i[h + 4 >> 2] = r, i[h >> 2] = A, i[r + 4 >> 2] = i[r + 4 >> 2] + 1, e = i[s + 4 >> 2];
                                        A: {
                                            if (e >>> 0 < k0[s + 8 >> 2]) {
                                                i[e + 4 >> 2] = r, i[e >> 2] = A, i[s + 4 >> 2] = e + 8;
                                                break A;
                                            }
                                            if (e = p2(s, h), A = i[h + 4 >> 2], i[s + 4 >> 2] = e, !A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    if (A = i[t + 4 >> 2], i[t + 4 >> 2] = A - 1, A || (p[i[i[t >> 2] + 8 >> 2]](t), g(t)), A = i[_ + 4 >> 2], i[_ + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[_ >> 2] + 8 >> 2]](_), g(_);
                                }
                                m = h + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function W7(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            C = m + -64 | 0, m = C;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: switch(i[r + 36 >> 2] - 1 | 0){
                                                            case 1:
                                                                if ((e | 0) <= 179) {
                                                                    if (!e) break f;
                                                                    if ((e | 0) == 90) break n;
                                                                    break r;
                                                                }
                                                                if ((e | 0) == 270) break n;
                                                                if ((e | 0) != 180) break r;
                                                                if (n = i[r + 28 >> 2], n & 1) break n;
                                                                B = i[r + 24 >> 2];
                                                                break e;
                                                            case 0:
                                                                break t;
                                                            default:
                                                                break k;
                                                        }
                                                        if ((e | 0) <= 179) {
                                                            if (!e) break f;
                                                            if ((e | 0) != 90) break r;
                                                            if (n = i[r + 24 >> 2], n & 1) break n;
                                                            B = i[r + 28 >> 2];
                                                            break e;
                                                        }
                                                        if ((e | 0) != 180) {
                                                            if ((e | 0) != 270) break r;
                                                            if (B = i[r + 28 >> 2], B & 1) break n;
                                                            n = i[r + 24 >> 2];
                                                            break e;
                                                        }
                                                        if (B = i[r + 24 >> 2], B & 1) break n;
                                                        if (n = i[r + 28 >> 2], !(n & 1)) break e;
                                                    }
                                                    if (i[C + 56 >> 2] = 0, i[C + 60 >> 2] = 0, i[C + 48 >> 2] = 0, i[C + 52 >> 2] = 0, o[C + 60 | 0] = 1, i[C + 52 >> 2] = 2, i[C + 56 >> 2] = 2, o[C + 48 | 0] = 1, i[C + 8 >> 2] = i[r >> 2], k = i[r + 4 >> 2], !k || (k = gi(k), i[C + 12 >> 2] = k, !k)) break A;
                                                    i[C >> 2] = 0, i[C + 4 >> 2] = 0, k = 255, B = i[r + 64 >> 2];
                                                    n: {
                                                        if (!B) break n;
                                                        for(t = r - -64 | 0, n = t; r = i[B + 16 >> 2], n = (r | 0) < 0 ? n : B, B = i[(r >>> 29 & 4) + B >> 2], !!B;);
                                                        if ((n | 0) == (t | 0) | i[n + 16 >> 2] > 0) break n;
                                                        k = l[n + 24 | 0];
                                                    }
                                                    s6(C + 16 | 0, C + 8 | 0, 0, 3, C, k, C + 48 | 0, f), k = i[C + 4 >> 2];
                                                    n: {
                                                        if (!k || (r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r)) break n;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    }
                                                    k = i[C + 12 >> 2];
                                                    n: {
                                                        if (!k || (r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r)) break n;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    }
                                                    n: {
                                                        if (i[C + 24 >> 2]) {
                                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[C + 28 >> 2], i[A + 8 >> 2] = i[C + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[C + 43 | 0] >= 0) {
                                                                A = i[C + 36 >> 2], i[r >> 2] = i[C + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[C + 40 >> 2];
                                                                break n;
                                                            }
                                                            j(r, i[C + 32 >> 2], i[C + 36 >> 2]);
                                                            break n;
                                                        }
                                                        W7(A, i[C + 16 >> 2], e, f);
                                                    }
                                                    if (o[C + 43 | 0] < 0 && X(i[C + 32 >> 2]), r = i[C + 20 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                    break i;
                                                }
                                                if (e) break r;
                                            }
                                            if (e = i[r + 4 >> 2], !e || (r = i[r >> 2], e = gi(e), !e)) break A;
                                            i[A + 4 >> 2] = e, i[A >> 2] = r, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                            f: {
                                                if (o[86691] >= 0) {
                                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                    break f;
                                                }
                                                j(r, i[21670], i[21671]);
                                            }
                                            if (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            break i;
                                        }
                                        rf(), z();
                                    }
                                    if (B = i[r + 28 >> 2], k = i[r + 24 >> 2], !((e | 0) == 270 | (e | 0) == 90)) {
                                        n = B, B = k;
                                        break e;
                                    }
                                    n = k;
                                }
                                G = D(136), k = G, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78252, B0(k + 20 | 0, 0, 104), s = i[k + 4 >> 2], t = s + 1 | 0, i[k + 4 >> 2] = t, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 44 >> 2] = 99, i[k + 48 >> 2] = 99, i[k + 32 >> 2] = 4142, k = k - -64 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[G + 132 >> 2] = 0, i[G + 124 >> 2] = 0, i[G + 128 >> 2] = 0, i[G + 84 >> 2] = 1, i[G + 88 >> 2] = 1, T = G + 76 | 0, i[G + 72 >> 2] = T, i[G + 92 >> 2] = 0, i[G + 96 >> 2] = 0, i[G + 100 >> 2] = 0, i[G + 104 >> 2] = 0, i[G + 108 >> 2] = 0, i[G + 112 >> 2] = 0, o[G + 113 | 0] = 0, o[G + 114 | 0] = 0, o[G + 115 | 0] = 0, o[G + 116 | 0] = 0, o[G + 117 | 0] = 0, o[G + 118 | 0] = 0, o[G + 119 | 0] = 0, o[G + 120 | 0] = 0, P = G + 12 | 0, i[G + 12 >> 2] = P, i[G + 8 >> 2] = i[G + 8 >> 2] + 1, i[G + 4 >> 2] = s, i[G + 16 >> 2] = G, t || (p[i[i[G >> 2] + 8 >> 2]](G), g(G)), t = i[r + 36 >> 2], k = i[r + 32 >> 2], i[G + 40 >> 2] = n, i[G + 44 >> 2] = k, i[G + 48 >> 2] = t, i[G + 36 >> 2] = B, B = i[r + 60 >> 2], $ = r - -64 | 0;
                                e: {
                                    if ((B | 0) != ($ | 0)) for(S = A + 16 | 0, r0 = (e | 0) == 270, f0 = (e | 0) != 90;;){
                                        t = i[B + 32 >> 2], n = i[B + 28 >> 2];
                                        r: {
                                            if (!(!f0 | r0)) {
                                                k = n, n = t;
                                                break r;
                                            }
                                            k = t;
                                        }
                                        s = i[B + 16 >> 2], F3(C + 16 | 0, P, s, k, n, i[B + 20 >> 2], l[B + 24 | 0], f), c = i[C + 16 >> 2];
                                        r: {
                                            if (c) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[C + 20 >> 2], i[A + 8 >> 2] = i[C + 16 >> 2], i[A + 12 >> 2] = k, o[C + 35 | 0] >= 0) {
                                                    A = i[C + 28 >> 2], i[S >> 2] = i[C + 24 >> 2], i[S + 4 >> 2] = A, i[S + 8 >> 2] = i[C + 32 >> 2];
                                                    break e;
                                                }
                                                j(S, i[C + 24 >> 2], i[C + 28 >> 2]);
                                                break r;
                                            }
                                            k = T, n = i[k >> 2];
                                            A: {
                                                f: {
                                                    if (!n) break f;
                                                    for(; t = (s | 0) > i[n + 16 >> 2], k = t ? k : n, n = i[(t << 2) + n >> 2], !!n;);
                                                    if ((k | 0) == (T | 0)) break f;
                                                    if ((s | 0) >= i[k + 16 >> 2]) break A;
                                                }
                                                k = T;
                                            }
                                            if (n = l[B + 24 | 0], n >>> 0 <= 8) {
                                                u = 0, E = i[k + 44 >> 2], v = i[k + 52 >> 2], _ = i[B + 44 >> 2], F = i[B + 52 >> 2], y = i[B + 32 >> 2], k = i[B + 28 >> 2];
                                                A: {
                                                    if ((e | 0) != 270) {
                                                        if ((e | 0) != 180) {
                                                            if (!k | (!y | (e | 0) != 90)) break A;
                                                            for(w = k + _ | 0, s = k & -4, W = k & 3, t = k >>> 0 < 4;;){
                                                                if (h = u + E | 0, _ = w + Z(u, F) | 0, k = 0, n = 0, !t) for(; o[h + Z(k, v) | 0] = l[_ + (k ^ -1) | 0], o[h + Z(v, k | 1) | 0] = l[_ + (k ^ -2) | 0], o[h + Z(v, k | 2) | 0] = l[_ + (k ^ -3) | 0], o[h + Z(v, k | 3) | 0] = l[_ + (k ^ -4) | 0], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                                if (n = 0, W) for(; o[h + Z(k, v) | 0] = l[_ + (k ^ -1) | 0], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                                if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                            }
                                                            break A;
                                                        }
                                                        if (!y | !k) break A;
                                                        for(w = k + _ | 0, s = k & -4, _ = k & 3, t = k >>> 0 < 4;;){
                                                            if (W = E + Z(u, v) | 0, V = w + Z(F, y + (u ^ -1) | 0) | 0, k = 0, n = 0, !t) for(; h = k + W | 0, o[h | 0] = l[V + (k ^ -1) | 0], o[h + 1 | 0] = l[V + (k ^ -2) | 0], o[h + 2 | 0] = l[V + (k ^ -3) | 0], o[h + 3 | 0] = l[V + (k ^ -4) | 0], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                            if (n = 0, _) for(; o[k + W | 0] = l[V + (k ^ -1) | 0], k = k + 1 | 0, n = n + 1 | 0, (_ | 0) != (n | 0););
                                                            if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    if (!y | !k) break A;
                                                    for(w = k & -4, W = k & 3, s = k - 1 >>> 0 < 3;;){
                                                        if (V = u + E | 0, h = _ + Z(F, y + (u ^ -1) | 0) | 0, k = 0, n = 0, !s) for(; o[V + Z(k, v) | 0] = l[k + h | 0], t = k | 1, o[V + Z(t, v) | 0] = l[t + h | 0], t = k | 2, o[V + Z(t, v) | 0] = l[t + h | 0], t = k | 3, o[V + Z(t, v) | 0] = l[t + h | 0], k = k + 4 | 0, n = n + 4 | 0, (w | 0) != (n | 0););
                                                        if (n = 0, W) for(; o[V + Z(k, v) | 0] = l[k + h | 0], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                        if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                    }
                                                }
                                                break r;
                                            }
                                            if (n >>> 0 <= 16) {
                                                u = 0, v = i[k + 52 >> 2] >>> 1 | 0, E = i[B + 52 >> 2] >>> 1 | 0, F = i[k + 44 >> 2], _ = i[B + 44 >> 2], y = i[B + 32 >> 2], k = i[B + 28 >> 2];
                                                A: {
                                                    if ((e | 0) != 270) {
                                                        if ((e | 0) != 180) {
                                                            if (!k | (!y | (e | 0) != 90)) break A;
                                                            for(w = _ + (k << 1) | 0, s = k & -4, W = k & 3, t = k >>> 0 < 4;;){
                                                                if (h = F + (u << 1) | 0, _ = w + (Z(u, E) << 1) | 0, k = 0, n = 0, !t) for(; Q[h + (Z(k, v) << 1) >> 1] = I[_ + ((k ^ -1) << 1) >> 1], Q[h + (Z(v, k | 1) << 1) >> 1] = I[_ + ((k ^ 2147483646) << 1) >> 1], Q[h + (Z(v, k | 2) << 1) >> 1] = I[_ + ((k ^ 2147483645) << 1) >> 1], Q[h + (Z(v, k | 3) << 1) >> 1] = I[_ + ((k ^ 2147483644) << 1) >> 1], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                                if (n = 0, W) for(; Q[h + (Z(k, v) << 1) >> 1] = I[_ + ((k ^ -1) << 1) >> 1], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                                if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                            }
                                                            break A;
                                                        }
                                                        if (!y | !k) break A;
                                                        for(w = _ + (k << 1) | 0, s = k & -4, _ = k & 3, t = k >>> 0 < 4;;){
                                                            if (W = F + (Z(u, v) << 1) | 0, V = w + (Z(E, y + (u ^ -1) | 0) << 1) | 0, k = 0, n = 0, !t) for(; h = W + (k << 1) | 0, Q[h >> 1] = I[V + ((k ^ -1) << 1) >> 1], Q[h + 2 >> 1] = I[V + ((k ^ 2147483646) << 1) >> 1], Q[h + 4 >> 1] = I[V + ((k ^ 2147483645) << 1) >> 1], Q[h + 6 >> 1] = I[V + ((k ^ 2147483644) << 1) >> 1], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                            if (n = 0, _) for(; Q[W + (k << 1) >> 1] = I[V + ((k ^ -1) << 1) >> 1], k = k + 1 | 0, n = n + 1 | 0, (_ | 0) != (n | 0););
                                                            if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    if (!y | !k) break A;
                                                    for(w = k & -4, W = k & 3, s = k - 1 >>> 0 < 3;;){
                                                        if (V = F + (u << 1) | 0, h = _ + (Z(E, y + (u ^ -1) | 0) << 1) | 0, k = 0, n = 0, !s) for(; Q[V + (Z(k, v) << 1) >> 1] = I[h + (k << 1) >> 1], t = k | 1, Q[V + (Z(t, v) << 1) >> 1] = I[h + (t << 1) >> 1], t = k | 2, Q[V + (Z(t, v) << 1) >> 1] = I[h + (t << 1) >> 1], t = k | 3, Q[V + (Z(t, v) << 1) >> 1] = I[h + (t << 1) >> 1], k = k + 4 | 0, n = n + 4 | 0, (w | 0) != (n | 0););
                                                        if (n = 0, W) for(; Q[V + (Z(k, v) << 1) >> 1] = I[h + (k << 1) >> 1], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                        if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                    }
                                                }
                                                break r;
                                            }
                                            if (n >>> 0 <= 32) {
                                                u = 0, v = i[k + 52 >> 2] >>> 2 | 0, E = i[B + 52 >> 2] >>> 2 | 0, F = i[k + 44 >> 2], _ = i[B + 44 >> 2], y = i[B + 32 >> 2], k = i[B + 28 >> 2];
                                                A: {
                                                    if ((e | 0) != 270) {
                                                        if ((e | 0) != 180) {
                                                            if (!k | (!y | (e | 0) != 90)) break A;
                                                            for(w = _ + (k << 2) | 0, s = k & -4, W = k & 3, t = k >>> 0 < 4;;){
                                                                if (h = F + (u << 2) | 0, _ = w + (Z(u, E) << 2) | 0, k = 0, n = 0, !t) for(; i[h + (Z(k, v) << 2) >> 2] = i[_ + ((k ^ -1) << 2) >> 2], i[h + (Z(v, k | 1) << 2) >> 2] = i[_ + ((k ^ 1073741822) << 2) >> 2], i[h + (Z(v, k | 2) << 2) >> 2] = i[_ + ((k ^ 1073741821) << 2) >> 2], i[h + (Z(v, k | 3) << 2) >> 2] = i[_ + ((k ^ 1073741820) << 2) >> 2], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                                if (n = 0, W) for(; i[h + (Z(k, v) << 2) >> 2] = i[_ + ((k ^ -1) << 2) >> 2], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                                if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                            }
                                                            break A;
                                                        }
                                                        if (!y | !k) break A;
                                                        for(w = _ + (k << 2) | 0, s = k & -4, _ = k & 3, t = k >>> 0 < 4;;){
                                                            if (W = F + (Z(u, v) << 2) | 0, V = w + (Z(E, y + (u ^ -1) | 0) << 2) | 0, k = 0, n = 0, !t) for(; h = W + (k << 2) | 0, i[h >> 2] = i[V + ((k ^ -1) << 2) >> 2], i[h + 4 >> 2] = i[V + ((k ^ 1073741822) << 2) >> 2], i[h + 8 >> 2] = i[V + ((k ^ 1073741821) << 2) >> 2], i[h + 12 >> 2] = i[V + ((k ^ 1073741820) << 2) >> 2], k = k + 4 | 0, n = n + 4 | 0, (s | 0) != (n | 0););
                                                            if (n = 0, _) for(; i[W + (k << 2) >> 2] = i[V + ((k ^ -1) << 2) >> 2], k = k + 1 | 0, n = n + 1 | 0, (_ | 0) != (n | 0););
                                                            if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    if (!y | !k) break A;
                                                    for(w = k & -4, W = k & 3, s = k - 1 >>> 0 < 3;;){
                                                        if (V = F + (u << 2) | 0, h = _ + (Z(E, y + (u ^ -1) | 0) << 2) | 0, k = 0, n = 0, !s) for(; i[V + (Z(k, v) << 2) >> 2] = i[h + (k << 2) >> 2], t = k | 1, i[V + (Z(t, v) << 2) >> 2] = i[h + (t << 2) >> 2], t = k | 2, i[V + (Z(t, v) << 2) >> 2] = i[h + (t << 2) >> 2], t = k | 3, i[V + (Z(t, v) << 2) >> 2] = i[h + (t << 2) >> 2], k = k + 4 | 0, n = n + 4 | 0, (w | 0) != (n | 0););
                                                        if (n = 0, W) for(; i[V + (Z(k, v) << 2) >> 2] = i[h + (k << 2) >> 2], k = k + 1 | 0, n = n + 1 | 0, (W | 0) != (n | 0););
                                                        if (u = u + 1 | 0, (y | 0) == (u | 0)) break;
                                                    }
                                                }
                                                break r;
                                            }
                                            if (n >>> 0 <= 64) {
                                                u = 0, R = i[k + 52 >> 2] >>> 3 | 0, y = i[B + 52 >> 2] >>> 3 | 0, V = i[k + 44 >> 2], F = i[B + 44 >> 2], M = i[B + 32 >> 2], k = i[B + 28 >> 2];
                                                A: {
                                                    if ((e | 0) != 270) {
                                                        if ((e | 0) != 180) {
                                                            if (!k | (!M | (e | 0) != 90)) break A;
                                                            for(h = F + (k << 3) | 0, _ = k & -4, F = k & 3, W = k >>> 0 < 4;;){
                                                                if (v = V + (u << 3) | 0, E = h + (Z(u, y) << 3) | 0, k = 0, n = 0, !W) for(; s = E + ((k ^ -1) << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(k, R) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, s = E + ((k ^ 536870910) << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(R, k | 1) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, s = E + ((k ^ 536870909) << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(R, k | 2) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, s = E + ((k ^ 536870908) << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(R, k | 3) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, k = k + 4 | 0, n = n + 4 | 0, (_ | 0) != (n | 0););
                                                                if (n = 0, F) for(; s = E + ((k ^ -1) << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(k, R) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, k = k + 1 | 0, n = n + 1 | 0, (F | 0) != (n | 0););
                                                                if (u = u + 1 | 0, (M | 0) == (u | 0)) break;
                                                            }
                                                            break A;
                                                        }
                                                        if (!M | !k) break A;
                                                        for(h = F + (k << 3) | 0, _ = k & -4, E = k & 3, W = k >>> 0 < 4;;){
                                                            if (F = V + (Z(u, R) << 3) | 0, v = h + (Z(y, M + (u ^ -1) | 0) << 3) | 0, k = 0, n = 0, !W) for(; s = v + ((k ^ -1) << 3) | 0, t = i[s + 4 >> 2], w = F + (k << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, s = v + ((k ^ 536870910) << 3) | 0, t = i[s + 4 >> 2], i[w + 8 >> 2] = i[s >> 2], i[w + 12 >> 2] = t, s = v + ((k ^ 536870909) << 3) | 0, t = i[s + 4 >> 2], i[w + 16 >> 2] = i[s >> 2], i[w + 20 >> 2] = t, s = v + ((k ^ 536870908) << 3) | 0, t = i[s + 4 >> 2], i[w + 24 >> 2] = i[s >> 2], i[w + 28 >> 2] = t, k = k + 4 | 0, n = n + 4 | 0, (_ | 0) != (n | 0););
                                                            if (n = 0, E) for(; s = v + ((k ^ -1) << 3) | 0, t = i[s + 4 >> 2], w = F + (k << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, k = k + 1 | 0, n = n + 1 | 0, (E | 0) != (n | 0););
                                                            if (u = u + 1 | 0, (M | 0) == (u | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    if (!M | !k) break A;
                                                    for(_ = k & -4, h = k & 3, W = k - 1 >>> 0 < 3;;){
                                                        if (v = V + (u << 3) | 0, E = F + (Z(y, M + (u ^ -1) | 0) << 3) | 0, k = 0, n = 0, !W) for(; s = E + (k << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(k, R) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, t = k | 1, w = v + (Z(t, R) << 3) | 0, s = E + (t << 3) | 0, t = i[s + 4 >> 2], i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, t = k | 2, w = v + (Z(t, R) << 3) | 0, s = E + (t << 3) | 0, t = i[s + 4 >> 2], i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, t = k | 3, w = v + (Z(t, R) << 3) | 0, s = E + (t << 3) | 0, t = i[s + 4 >> 2], i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, k = k + 4 | 0, n = n + 4 | 0, (_ | 0) != (n | 0););
                                                        if (n = 0, h) for(; s = E + (k << 3) | 0, t = i[s + 4 >> 2], w = v + (Z(k, R) << 3) | 0, i[w >> 2] = i[s >> 2], i[w + 4 >> 2] = t, k = k + 1 | 0, n = n + 1 | 0, (h | 0) != (n | 0););
                                                        if (u = u + 1 | 0, (M | 0) == (u | 0)) break;
                                                    }
                                                }
                                                break r;
                                            }
                                            if (n >>> 0 > 128) break r;
                                            v = i[k + 52 >> 2] >>> 4 | 0, V = i[B + 52 >> 2] >>> 4 | 0, E = i[k + 44 >> 2], F = i[B + 44 >> 2], R = i[B + 32 >> 2], H = i[B + 28 >> 2];
                                            A: {
                                                if ((e | 0) != 270) {
                                                    if ((e | 0) != 180) {
                                                        if (!H | (!R | (e | 0) != 90)) break A;
                                                        for(W = F + (H << 4) | 0, w = H & -2, s = H & 1, u = 0;;){
                                                            if (F = E + (u << 4) | 0, h = W + (Z(u, V) << 4) | 0, k = 0, M = 0, (H | 0) != 1) for(; _ = h + ((k ^ -1) << 4) | 0, n = i[_ + 4 >> 2], t = F + (Z(k, v) << 4) | 0, i[t >> 2] = i[_ >> 2], i[t + 4 >> 2] = n, n = i[_ + 12 >> 2], i[t + 8 >> 2] = i[_ + 8 >> 2], i[t + 12 >> 2] = n, _ = h + ((k ^ 268435454) << 4) | 0, n = i[_ + 12 >> 2], t = F + (Z(v, k | 1) << 4) | 0, i[t + 8 >> 2] = i[_ + 8 >> 2], i[t + 12 >> 2] = n, n = i[_ + 4 >> 2], i[t >> 2] = i[_ >> 2], i[t + 4 >> 2] = n, k = k + 2 | 0, M = M + 2 | 0, (w | 0) != (M | 0););
                                                            if (s && (n = F + (Z(k, v) << 4) | 0, t = h + ((k ^ -1) << 4) | 0, k = i[t + 4 >> 2], i[n >> 2] = i[t >> 2], i[n + 4 >> 2] = k, k = i[t + 12 >> 2], i[n + 8 >> 2] = i[t + 8 >> 2], i[n + 12 >> 2] = k), u = u + 1 | 0, (R | 0) == (u | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    if (!R | !H) break A;
                                                    for(W = F + (H << 4) | 0, w = H & -2, s = H & 1, u = 0;;){
                                                        if (_ = E + (Z(u, v) << 4) | 0, F = W + (Z(V, R + (u ^ -1) | 0) << 4) | 0, k = 0, M = 0, (H | 0) != 1) for(; h = F + ((k ^ -1) << 4) | 0, n = i[h + 4 >> 2], y = _ + (k << 4) | 0, t = y, i[t >> 2] = i[h >> 2], i[t + 4 >> 2] = n, n = i[h + 12 >> 2], i[t + 8 >> 2] = i[h + 8 >> 2], i[t + 12 >> 2] = n, t = F + ((k ^ 268435454) << 4) | 0, n = i[t + 4 >> 2], i[y + 16 >> 2] = i[t >> 2], i[y + 20 >> 2] = n, n = i[t + 12 >> 2], i[y + 24 >> 2] = i[t + 8 >> 2], i[y + 28 >> 2] = n, k = k + 2 | 0, M = M + 2 | 0, (w | 0) != (M | 0););
                                                        if (s && (n = _ + (k << 4) | 0, t = F + ((k ^ -1) << 4) | 0, k = i[t + 4 >> 2], i[n >> 2] = i[t >> 2], i[n + 4 >> 2] = k, k = i[t + 12 >> 2], i[n + 8 >> 2] = i[t + 8 >> 2], i[n + 12 >> 2] = k), u = u + 1 | 0, (R | 0) == (u | 0)) break;
                                                    }
                                                    break A;
                                                }
                                                if (!R | !H) break A;
                                                for(w = H & -2, s = H & 1, u = 0;;){
                                                    if (h = E + (u << 4) | 0, _ = F + (Z(V, R + (u ^ -1) | 0) << 4) | 0, k = 0, M = 0, (H | 0) != 1) for(; W = _ + (k << 4) | 0, n = i[W + 4 >> 2], t = h + (Z(k, v) << 4) | 0, i[t >> 2] = i[W >> 2], i[t + 4 >> 2] = n, n = i[W + 12 >> 2], i[t + 8 >> 2] = i[W + 8 >> 2], i[t + 12 >> 2] = n, n = k | 1, t = h + (Z(n, v) << 4) | 0, W = _ + (n << 4) | 0, n = i[W + 12 >> 2], i[t + 8 >> 2] = i[W + 8 >> 2], i[t + 12 >> 2] = n, n = i[W + 4 >> 2], i[t >> 2] = i[W >> 2], i[t + 4 >> 2] = n, k = k + 2 | 0, M = M + 2 | 0, (w | 0) != (M | 0););
                                                    if (s && (n = h + (Z(k, v) << 4) | 0, t = _ + (k << 4) | 0, k = i[t + 4 >> 2], i[n >> 2] = i[t >> 2], i[n + 4 >> 2] = k, k = i[t + 12 >> 2], i[n + 8 >> 2] = i[t + 8 >> 2], i[n + 12 >> 2] = k), u = u + 1 | 0, (R | 0) == (u | 0)) break;
                                                }
                                            }
                                        }
                                        if (o[C + 35 | 0] < 0 && X(i[C + 24 >> 2]), c) break e;
                                        k = B, n = i[k + 4 >> 2];
                                        r: {
                                            if (n) {
                                                for(;;)if (B = n, n = i[n >> 2], !n) break r;
                                            }
                                            for(; B = i[k + 8 >> 2], n = i[B >> 2] != (k | 0), k = B, !!n;);
                                        }
                                        if ((B | 0) == ($ | 0)) break;
                                    }
                                    e = i[r + 44 >> 2], f = i[r + 48 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[G + 56 >> 2] = e, k = i[G + 60 >> 2], i[G + 60 >> 2] = f;
                                    r: {
                                        if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    e = i[r + 52 >> 2], r = i[r + 56 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[G + 64 >> 2] = e, e = i[G + 68 >> 2], i[G + 68 >> 2] = r;
                                    r: {
                                        if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (i[A + 4 >> 2] = G, i[A >> 2] = P, i[G + 4 >> 2] = i[G + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[G + 4 >> 2], i[G + 4 >> 2] = A - 1, A) break i;
                                p[i[i[G >> 2] + 8 >> 2]](G), g(G);
                            }
                            m = C - -64 | 0;
                        }
                        function ri(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            t = m - 256 | 0, m = t, v3(t + 248 | 0, r, i[i[f >> 2] + 4 >> 2]), i[t + 240 >> 2] = i[k + 32 >> 2], u = i[k + 28 >> 2], i[t + 232 >> 2] = i[k + 24 >> 2], i[t + 236 >> 2] = u, u = i[k + 20 >> 2], i[t + 224 >> 2] = i[k + 16 >> 2], i[t + 228 >> 2] = u, u = i[k + 12 >> 2], i[t + 216 >> 2] = i[k + 8 >> 2], i[t + 220 >> 2] = u, u = i[k + 4 >> 2], i[t + 208 >> 2] = i[k >> 2], i[t + 212 >> 2] = u, k = i[t + 248 >> 2], k = p[i[i[k >> 2] + 24 >> 2]](k) | 0, k && (i[t + 212 >> 2] = k), d7(t + 180 | 0, i[t + 248 >> 2], e, f, t + 208 | 0);
                            i: {
                                e: {
                                    if (i[t + 188 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 192 >> 2], i[A + 8 >> 2] = i[t + 188 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[t + 207 | 0] >= 0) {
                                            A = i[t + 200 >> 2], i[r >> 2] = i[t + 196 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 204 >> 2];
                                            break e;
                                        }
                                        j(r, i[t + 196 >> 2], i[t + 200 >> 2]);
                                        break e;
                                    }
                                    i[t + 172 >> 2] = i[t + 180 >> 2], k = i[t + 184 >> 2], i[t + 176 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), G = t + 152 | 0, w = m - 80 | 0, m = w, _ = t + 172 | 0, u = i[_ >> 2], k = i[u + 28 >> 2], W = i[t + 248 >> 2], i[W + 40 >> 2] = i[u + 24 >> 2], i[W + 44 >> 2] = k, R = f, G7(w + 28 | 0, W, _, f, t + 208 | 0, n);
                                    r: {
                                        if (i[w + 60 >> 2]) {
                                            if (f = i[w + 64 >> 2], i[G >> 2] = i[w + 60 >> 2], i[G + 4 >> 2] = f, k = G + 8 | 0, o[w + 79 | 0] >= 0) {
                                                f = i[w + 72 >> 2], i[k >> 2] = i[w + 68 >> 2], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[w + 76 >> 2];
                                                break r;
                                            }
                                            j(k, i[w + 68 >> 2], i[w + 72 >> 2]);
                                            break r;
                                        }
                                        f = i[r + 48 >> 2], k = i[r + 52 >> 2];
                                        A: {
                                            if (k) {
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, m8(w + 20 | 0, f, p[i[i[W >> 2] + 8 >> 2]](W) | 0), f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f) break A;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break A;
                                            }
                                            m8(w + 20 | 0, f, p[i[i[W >> 2] + 8 >> 2]](W) | 0);
                                        }
                                        B = i[i[w + 20 >> 2] + 104 >> 2], i[W + 36 >> 2] = B, f = i[r + 48 >> 2], k = i[r + 52 >> 2];
                                        A: {
                                            if (!k) {
                                                x8(f, B, w + 40 | 0, 0);
                                                break A;
                                            }
                                            if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, x8(f, B, w + 40 | 0, 0), f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f) break A;
                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        }
                                        if (f = i[w + 28 >> 2], u = i[w + 32 >> 2], (f | 0) != (u | 0)) for(;;){
                                            n = i[r + 48 >> 2], v = i[r + 52 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), k = i[n + 52 >> 2], n = i[n + 56 >> 2];
                                            A: {
                                                if (!n) {
                                                    V = c8(k, f);
                                                    break A;
                                                }
                                                if (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, V = c8(k, f), k = i[n + 4 >> 2], i[n + 4 >> 2] = k - 1, k) break A;
                                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                            }
                                            A: {
                                                if (!v || (k = i[v + 4 >> 2], i[v + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                            }
                                            k = i[r + 48 >> 2], h = i[r + 52 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), n = i[k + 60 >> 2], v = i[k + 64 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), k = i[f >> 2], k = p[i[i[k >> 2] + 32 >> 2]](k) | 0, Q[w + 18 >> 1] = V + 1, o[w + 16 | 0] = k, i[w + 12 >> 2] = I[w + 16 >> 1] | I[w + 18 >> 1] << 16, v6(n, B, w + 12 | 0);
                                            A: {
                                                if (!v || (k = i[v + 4 >> 2], i[v + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                            }
                                            A: {
                                                if (!h || (k = i[h + 4 >> 2], i[h + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                            }
                                            if (f = f + 8 | 0, (u | 0) == (f | 0)) break;
                                        }
                                        A: {
                                            if (i[i[R >> 2] + 4 >> 2] == 4 || (u = i[_ >> 2], i[u + 32 >> 2])) break A;
                                            n = i[u + 24 >> 2], k = i[u + 28 >> 2], f = 1;
                                            f: {
                                                k: switch(i[u + 36 >> 2]){
                                                    case 2:
                                                        f = !(n & 1);
                                                        break f;
                                                    case 1:
                                                        f = !((k | n) & 1);
                                                        break f;
                                                    case 0:
                                                    case 3:
                                                        break f;
                                                    default:
                                                        break k;
                                                }
                                                f = 0;
                                            }
                                            if (f) break A;
                                            o[W + 208 | 0] = 0;
                                        }
                                        f = i[r + 48 >> 2], k = i[r + 52 >> 2];
                                        A: {
                                            if (!k) {
                                                B5(f, B, i[t + 220 >> 2]);
                                                break A;
                                            }
                                            if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, B5(f, B, i[t + 220 >> 2]), f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f) break A;
                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        }
                                        f = i[21669], i[G >> 2] = i[21668], i[G + 4 >> 2] = f, k = G + 8 | 0;
                                        A: {
                                            if (o[86691] >= 0) {
                                                f = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(k, i[21670], i[21671]);
                                        }
                                        if (k = i[w + 24 >> 2], !k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    if (o[w + 79 | 0] < 0 && X(i[w + 68 >> 2]), f = i[w + 40 >> 2], f && (i[w + 44 >> 2] = f, X(f)), f = i[w + 28 >> 2], f) {
                                        if (n = i[w + 32 >> 2], k = f, (n | 0) != (k | 0)) {
                                            for(;;){
                                                u = i[n - 4 >> 2];
                                                r: {
                                                    if (!u || (k = i[u + 4 >> 2], i[u + 4 >> 2] = k - 1, k)) break r;
                                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                }
                                                if (n = n - 8 | 0, (f | 0) == (n | 0)) break;
                                            }
                                            k = i[w + 28 >> 2];
                                        }
                                        i[w + 32 >> 2] = f, X(k);
                                    }
                                    m = w + 80 | 0;
                                    r: {
                                        if (i[t + 152 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 156 >> 2], i[A + 8 >> 2] = i[t + 152 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[t + 171 | 0] >= 0) {
                                                A = i[t + 164 >> 2], i[r >> 2] = i[t + 160 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 168 >> 2];
                                                break r;
                                            }
                                            j(r, i[t + 160 >> 2], i[t + 164 >> 2]);
                                            break r;
                                        }
                                        Oe(r, i[i[t + 248 >> 2] + 36 >> 2], t + 248 | 0);
                                        A: {
                                            if (!l[t + 209 | 0]) break A;
                                            _ = i[t + 172 >> 2], f = i[_ + 64 >> 2];
                                            f: {
                                                k: {
                                                    if (!f) break k;
                                                    for(u = _ - -64 | 0, k = u; n = i[f + 16 >> 2] < 6, k = n ? k : f, f = i[(n << 2) + f >> 2], !!f;);
                                                    if ((k | 0) == (u | 0)) break k;
                                                    if (n = 1, i[k + 16 >> 2] < 7) break f;
                                                }
                                                if (f = i[_ + 36 >> 2], n = 0, f >>> 0 > 15) break f;
                                                n = 43008 >>> f | 0;
                                            }
                                            if (!(n & 1) || (f = i[t + 248 >> 2], !(p[i[i[f >> 2] + 12 >> 2]](f) | 0))) break A;
                                            i[t + 144 >> 2] = 0, i[t + 148 >> 2] = 0, s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), n = i[s + 4 >> 2], k = n + 1 | 0, i[s + 4 >> 2] = k, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, f = s - -64 | 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, i[s + 72 >> 2] = s + 76, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, C = s + 12 | 0, i[s + 12 >> 2] = C, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, k || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), _ = r - -64 | 0, f = i[t + 172 >> 2], k = i[f + 24 >> 2], f = i[f + 28 >> 2], i[C + 36 >> 2] = 0, i[C + 32 >> 2] = 2, i[C + 28 >> 2] = f, i[C + 24 >> 2] = k;
                                            f: {
                                                k: {
                                                    if (A1(i[t + 172 >> 2], 6)) {
                                                        if (i[t + 60 >> 2] = i[t + 172 >> 2], f = i[t + 176 >> 2], i[t + 64 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), J8(t + 80 | 0, C, t + 60 | 0, 6, 0, _), o[t + 99 | 0] < 0 && X(i[t + 88 >> 2]), k = i[t + 64 >> 2], !k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break k;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        break k;
                                                    }
                                                    if (f = i[t + 172 >> 2], i[f + 36 >> 2] != 11) break k;
                                                    i[t + 60 >> 2] = f, f = i[t + 176 >> 2], i[t + 64 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), y = t + 80 | 0, k = i[t + 60 >> 2], W = i[k + 28 >> 2], w = i[k + 24 >> 2], F = 255, f = i[k + 64 >> 2];
                                                    n: {
                                                        if (!f) break n;
                                                        for(u = k - -64 | 0, n = u; k = i[f + 16 >> 2] < 10, n = k ? n : f, f = i[(k << 2) + f >> 2], !!f;);
                                                        if ((n | 0) == (u | 0) | i[n + 16 >> 2] > 10) break n;
                                                        F = l[n + 24 | 0];
                                                    }
                                                    if (J0(y, C, 0, w, W, F, _), !i[y >> 2]) n: {
                                                        o[y + 19 | 0] < 0 && X(i[y + 8 >> 2]), F = 0;
                                                        t: {
                                                            o: {
                                                                if (k = i[t + 60 >> 2], f = i[k + 64 >> 2], !f) break o;
                                                                for(u = k - -64 | 0, n = u; k = i[f + 16 >> 2] < 10, n = k ? n : f, f = i[(k << 2) + f >> 2], !!f;);
                                                                if ((n | 0) == (u | 0)) break o;
                                                                if (h = 0, u = 0, i[n + 16 >> 2] > 10) break t;
                                                                h = i[n + 52 >> 2], u = i[n + 44 >> 2];
                                                                break t;
                                                            }
                                                            h = 0, u = 0;
                                                        }
                                                        f = i[C + 64 >> 2], k = 0;
                                                        t: {
                                                            if (!f) break t;
                                                            for(_ = C - -64 | 0, n = _; k = i[f + 16 >> 2], n = (k | 0) < 0 ? n : f, f = i[(k >>> 29 & 4) + f >> 2], !!f;);
                                                            if (k = 0, (n | 0) == (_ | 0) || (k = 0, i[n + 16 >> 2] > 0)) break t;
                                                            F = i[n + 52 >> 2], k = i[n + 44 >> 2];
                                                        }
                                                        if (!(!W | !w)) for(G = u + 3 | 0, B = w & -4, v = w & 3, V = 0, _ = w - 1 >>> 0 < 3;;){
                                                            if (E = Z(V, F) + k | 0, w = Z(h, V) + G | 0, f = 0, n = 0, !_) for(; o[f + E | 0] = l[w + (f << 2) | 0], u = f | 1, o[u + E | 0] = l[w + (u << 2) | 0], u = f | 2, o[u + E | 0] = l[w + (u << 2) | 0], u = f | 3, o[u + E | 0] = l[w + (u << 2) | 0], f = f + 4 | 0, n = n + 4 | 0, (B | 0) != (n | 0););
                                                            if (n = 0, v) for(; o[f + E | 0] = l[w + (f << 2) | 0], f = f + 1 | 0, n = n + 1 | 0, (v | 0) != (n | 0););
                                                            if (V = V + 1 | 0, (W | 0) == (V | 0)) break;
                                                        }
                                                        if (f = i[21669], i[y >> 2] = i[21668], i[y + 4 >> 2] = f, k = y + 8 | 0, o[86691] >= 0) {
                                                            f = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[21672];
                                                            break n;
                                                        }
                                                        j(k, i[21670], i[21671]);
                                                    }
                                                    k = i[t + 64 >> 2];
                                                    n: {
                                                        if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break n;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    }
                                                    if (i[t + 80 >> 2]) {
                                                        if (i[t + 112 >> 2] = 0, i[t + 116 >> 2] = 0, f = i[t + 84 >> 2], i[t + 120 >> 2] = i[t + 80 >> 2], i[t + 124 >> 2] = f, k = t + 128 | 0, o[t + 99 | 0] >= 0) {
                                                            f = i[t + 92 >> 2], i[k >> 2] = i[t + 88 >> 2], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[t + 96 >> 2];
                                                            break f;
                                                        }
                                                        if (j(k, i[t + 88 >> 2], i[t + 92 >> 2]), o[t + 99 | 0] >= 0) break f;
                                                        X(i[t + 88 >> 2]);
                                                        break f;
                                                    }
                                                    if (o[t + 99 | 0] >= 0) break k;
                                                    X(i[t + 88 >> 2]);
                                                }
                                                n = D(24), o[n + 22 | 0] = 1, Q[n + 20 >> 1] = 2, i[n + 16 >> 2] = 131074, i[n + 12 >> 2] = 78668, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = 78292, f = n + 12 | 0, o[f + 10 | 0] = 1, Q[n + 20 >> 1] = 6, i[n + 16 >> 2] = 851969, o[n + 22 | 0] = 1, Q[n + 20 >> 1] = 2, i[n + 16 >> 2] = 131074, o[n + 22 | 0] = 1, i[n + 4 >> 2] = i[n + 4 >> 2] + 2, i[s + 56 >> 2] = f, k = i[s + 60 >> 2], i[s + 60 >> 2] = n;
                                                k: {
                                                    if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break k;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                f = i[n + 4 >> 2], i[n + 4 >> 2] = f - 1, f || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), i[t + 116 >> 2] = s, i[t + 112 >> 2] = C, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, f = i[21669], i[t + 120 >> 2] = i[21668], i[t + 124 >> 2] = f, k = t + 128 | 0;
                                                k: {
                                                    if (o[86691] >= 0) {
                                                        f = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[21672];
                                                        break k;
                                                    }
                                                    j(k, i[21670], i[21671]);
                                                }
                                                if (f = i[n + 4 >> 2], i[n + 4 >> 2] = f - 1, f) break f;
                                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                            }
                                            if (f = i[s + 4 >> 2], i[s + 4 >> 2] = f - 1, f || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), i[t + 120 >> 2]) {
                                                i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 124 >> 2], i[A + 8 >> 2] = i[t + 120 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                f: {
                                                    if (o[t + 139 | 0] >= 0) {
                                                        A = i[t + 132 >> 2], i[r >> 2] = i[t + 128 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 136 >> 2];
                                                        break f;
                                                    }
                                                    if (j(r, i[t + 128 >> 2], i[t + 132 >> 2]), o[t + 139 | 0] >= 0) break f;
                                                    X(i[t + 128 >> 2]);
                                                }
                                                r = i[t + 116 >> 2];
                                                f: {
                                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break f;
                                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                }
                                                if (r = i[t + 148 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break r;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                break r;
                                            }
                                            f = i[t + 112 >> 2], k = i[t + 116 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[t + 144 >> 2] = f, n = i[t + 148 >> 2], i[t + 148 >> 2] = k;
                                            f: {
                                                if (!n || (f = i[n + 4 >> 2], i[n + 4 >> 2] = f - 1, f)) break f;
                                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                            }
                                            ri(t + 80 | 0, r, t + 144 | 0, R, t + 208 | 0, 2), u = i[t + 88 >> 2];
                                            f: {
                                                if (u) {
                                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[t + 92 >> 2], i[A + 8 >> 2] = i[t + 88 >> 2], i[A + 12 >> 2] = e, f = A + 16 | 0, o[t + 107 | 0] >= 0) {
                                                        e = i[t + 100 >> 2], i[f >> 2] = i[t + 96 >> 2], i[f + 4 >> 2] = e, i[f + 8 >> 2] = i[t + 104 >> 2];
                                                        break f;
                                                    }
                                                    j(f, i[t + 96 >> 2], i[t + 100 >> 2]);
                                                    break f;
                                                }
                                                f = i[t + 80 >> 2], i[t + 72 >> 2] = f, k = i[t + 84 >> 2], i[t + 76 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), n = i[f + 36 >> 2], k = i[r + 48 >> 2], f = i[i[t + 248 >> 2] + 36 >> 2], i[t + 56 >> 2] = 1, i[t + 48 >> 2] = f, i[t + 52 >> 2] = t + 48, f = i[t + 56 >> 2], i[t + 16 >> 2] = i[t + 52 >> 2], i[t + 20 >> 2] = f, f = k, k = $9(t + 60 | 0, t + 16 | 0), J4(f, n, 1635088492, k), f = i[k >> 2], f && (i[k + 4 >> 2] = f, X(f)), _ = i[r + 48 >> 2], n = i[i[t + 72 >> 2] + 36 >> 2], f = i[t + 248 >> 2], G = a1(t + 60 | 0, p[i[i[f >> 2] + 12 >> 2]](f) | 0), v = m - 16 | 0, m = v, h = D(144), i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, i[h >> 2] = 76616, B = h + 16 | 0, i[B + 8 >> 2] = 0, i[B + 12 >> 2] = 0, i[B + 16 >> 2] = 0, i[B + 20 >> 2] = 0, i[B + 24 >> 2] = 0, i[B + 28 >> 2] = 0, i[B + 32 >> 2] = 0, i[B >> 2] = 73428, i[h + 60 >> 2] = 0, i[h + 64 >> 2] = 0, i[h + 52 >> 2] = 0, i[h + 56 >> 2] = 0, i[h + 72 >> 2] = -1, i[h + 76 >> 2] = -1, i[h + 80 >> 2] = -1, i[h + 84 >> 2] = -1, i[h + 116 >> 2] = 0, i[h + 88 >> 2] = 0, i[h + 92 >> 2] = 0, i[h + 96 >> 2] = 0, i[h + 100 >> 2] = 0, i[h + 104 >> 2] = 0, i[h + 108 >> 2] = 0, Q[h + 112 >> 1] = 0, i[B >> 2] = 74660, i[h + 136 >> 2] = 0, i[h + 140 >> 2] = 0, i[h + 128 >> 2] = 0, i[h + 132 >> 2] = 0, i[h + 120 >> 2] = 0, i[h + 124 >> 2] = 0, i[h + 32 >> 2] = 1635088451, k = h + 120 | 0;
                                                k: {
                                                    if ((k | 0) == (G | 0)) break k;
                                                    if (o[G + 11 | 0] >= 0) {
                                                        f = i[G + 4 >> 2], i[k >> 2] = i[G >> 2], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[G + 8 >> 2];
                                                        break k;
                                                    }
                                                    X4(k, i[G >> 2], i[G + 4 >> 2]);
                                                }
                                                f = i[_ + 52 >> 2], i[v + 12 >> 2] = h, i[v + 8 >> 2] = B, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, k = c8(f, v + 8 | 0), B = i[v + 12 >> 2];
                                                k: {
                                                    if (!B || (f = i[B + 4 >> 2], i[B + 4 >> 2] = f - 1, f)) break k;
                                                    p[i[i[B >> 2] + 8 >> 2]](B), g(B);
                                                }
                                                f = i[_ + 60 >> 2], o[v + 4 | 0] = 1, Q[v + 6 >> 1] = k + 1, i[v >> 2] = I[v + 4 >> 1] | I[v + 6 >> 1] << 16, v6(f, n, v), f = i[h + 4 >> 2], i[h + 4 >> 2] = f - 1, f || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), m = v + 16 | 0, o[G + 11 | 0] < 0 && X(i[G >> 2]);
                                                k: {
                                                    if (l[i[e >> 2] + 40 | 0] != 1 || (k = i[i[t + 248 >> 2] + 36 >> 2], f = i[r + 48 >> 2], e = i[i[t + 72 >> 2] + 36 >> 2], i[t + 44 >> 2] = 1, i[t + 48 >> 2] = e, i[t + 40 >> 2] = t + 48, e = i[t + 44 >> 2], i[t + 8 >> 2] = i[t + 40 >> 2], i[t + 12 >> 2] = e, e = f, f = $9(t + 60 | 0, t + 8 | 0), J4(e, k, 1886545261, f), e = i[f >> 2], !e)) break k;
                                                    i[f + 4 >> 2] = e, X(e);
                                                }
                                                B1(t + 72 | 0);
                                            }
                                            o[t + 107 | 0] < 0 && X(i[t + 96 >> 2]), f = i[t + 84 >> 2];
                                            f: {
                                                if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            o[t + 139 | 0] < 0 && X(i[t + 128 >> 2]), f = i[t + 116 >> 2];
                                            f: {
                                                if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            f = i[t + 148 >> 2];
                                            f: {
                                                if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            if (u) break r;
                                        }
                                        i[t + 88 >> 2] = 0, i[t + 80 >> 2] = 0, i[t + 84 >> 2] = 0, F4(t + 112 | 0, i[r + 48 >> 2], i[i[t + 248 >> 2] + 36 >> 2], t + 80 | 0), f = i[t + 116 >> 2], e = i[t + 112 >> 2], i[t + 152 >> 2] = e, i[t + 156 >> 2] = f, o[t + 171 | 0] < 0 && (X(i[t + 160 >> 2]), e = i[t + 152 >> 2]), f = i[t + 124 >> 2], i[t + 160 >> 2] = i[t + 120 >> 2], i[t + 164 >> 2] = f, i[t + 168 >> 2] = i[t + 128 >> 2];
                                        A: {
                                            if (e) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 156 >> 2], i[A + 8 >> 2] = i[t + 152 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[t + 171 | 0] >= 0) {
                                                    A = i[t + 164 >> 2], i[r >> 2] = i[t + 160 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[t + 168 >> 2];
                                                    break A;
                                                }
                                                j(r, i[t + 160 >> 2], i[t + 164 >> 2]);
                                                break A;
                                            }
                                            if (i[t + 36 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, _ = i[t + 248 >> 2], k = 0, f = 0, e = i[t + 80 >> 2], n = i[t + 84 >> 2], (e | 0) != (n | 0)) {
                                                if (k = n - e | 0, (k | 0) < 0) break i;
                                                for(f = D(k), i[t + 28 >> 2] = f, M = f + k | 0, i[t + 36 >> 2] = M, k = f; i[k >> 2] = i[e >> 2], u = i[e + 4 >> 2], i[k + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), k = k + 8 | 0, e = e + 8 | 0, (n | 0) != (e | 0););
                                                i[t + 32 >> 2] = k;
                                            }
                                            if (u = i[_ + 24 >> 2], u) {
                                                if (e = i[_ + 28 >> 2], n = u, (e | 0) != (n | 0)) {
                                                    for(;;){
                                                        k = i[e - 4 >> 2];
                                                        f: {
                                                            if (!k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break f;
                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        }
                                                        if (e = e - 8 | 0, (u | 0) == (e | 0)) break;
                                                    }
                                                    n = i[_ + 24 >> 2], M = i[t + 36 >> 2], k = i[t + 32 >> 2], f = i[t + 28 >> 2];
                                                }
                                                i[_ + 28 >> 2] = u, X(n), e = i[t + 248 >> 2];
                                            } else e = _;
                                            if (i[_ + 32 >> 2] = M, i[_ + 28 >> 2] = k, i[_ + 24 >> 2] = f, i[t + 36 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, S3(i[r + 48 >> 2], i[i[R >> 2] + 4 >> 2], l[e + 208 | 0]), i[A >> 2] = i[t + 248 >> 2], r = i[t + 252 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                                A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(r, i[21670], i[21671]);
                                        }
                                        if (r = i[t + 80 >> 2], !r) break r;
                                        if (A = r, k = i[t + 84 >> 2], (r | 0) != (k | 0)) {
                                            for(;;){
                                                e = i[k - 4 >> 2];
                                                A: {
                                                    if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break A;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                if (k = k - 8 | 0, (r | 0) == (k | 0)) break;
                                            }
                                            A = i[t + 80 >> 2];
                                        }
                                        i[t + 84 >> 2] = r, X(A);
                                    }
                                    if (o[t + 171 | 0] < 0 && X(i[t + 160 >> 2]), r = i[t + 176 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                o[t + 207 | 0] < 0 && X(i[t + 196 >> 2]), r = i[t + 184 >> 2];
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = i[t + 252 >> 2];
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                m = t + 256 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function h3(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0;
                            h = m - 16 | 0, m = h, u = D(136), i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 78252, B0(u + 20 | 0, 0, 104), s = i[u + 4 >> 2], v = s + 1 | 0, i[u + 4 >> 2] = v, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 44 >> 2] = 99, i[u + 48 >> 2] = 99, i[u + 32 >> 2] = 4142, t = u - -64 | 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, i[u + 132 >> 2] = 0, i[u + 124 >> 2] = 0, i[u + 128 >> 2] = 0, i[u + 84 >> 2] = 1, i[u + 88 >> 2] = 1, i[u + 72 >> 2] = u + 76, i[u + 92 >> 2] = 0, i[u + 96 >> 2] = 0, i[u + 100 >> 2] = 0, i[u + 104 >> 2] = 0, i[u + 108 >> 2] = 0, i[u + 112 >> 2] = 0, o[u + 113 | 0] = 0, o[u + 114 | 0] = 0, o[u + 115 | 0] = 0, o[u + 116 | 0] = 0, o[u + 117 | 0] = 0, o[u + 118 | 0] = 0, o[u + 119 | 0] = 0, o[u + 120 | 0] = 0, t = u + 12 | 0, i[u + 12 >> 2] = t, i[u + 8 >> 2] = i[u + 8 >> 2] + 1, i[u + 4 >> 2] = s, i[u + 16 >> 2] = u, v || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), i[e >> 2] = t, v = i[e + 4 >> 2], i[e + 4 >> 2] = u;
                            i: {
                                if (!v || (t = i[v + 4 >> 2], i[v + 4 >> 2] = t - 1, t)) break i;
                                p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                            }
                            B = i[r + 32 >> 2], _ = i[e >> 2], G = i[r + 36 >> 2], i[_ + 36 >> 2] = G, i[_ + 32 >> 2] = B, i[_ + 28 >> 2] = k, i[_ + 24 >> 2] = f;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: {
                                                                            if (u = i[r + 64 >> 2], u) {
                                                                                for(v = r - -64 | 0, s = v, t = u; w = i[t + 16 >> 2] < 10, s = w ? s : t, t = i[(w << 2) + t >> 2], !!t;);
                                                                                if (!((s | 0) == (v | 0) | i[s + 16 >> 2] > 10)) {
                                                                                    for(t = v; s = i[u + 16 >> 2] < 10, t = s ? t : u, u = i[(s << 2) + u >> 2], !!u;);
                                                                                    if (s = 255, J0(A, _, 10, f, k, (t | 0) == (v | 0) | i[t + 16 >> 2] > 10 ? s : l[t + 24 | 0], n), i[A >> 2]) break i;
                                                                                    if (o[A + 19 | 0] >= 0) break e;
                                                                                    X(i[A + 8 >> 2]);
                                                                                    break e;
                                                                                }
                                                                                switch(w = v, t = u, s = t, B | 0){
                                                                                    case 0:
                                                                                        break t;
                                                                                    case 2:
                                                                                        break s;
                                                                                    case 1:
                                                                                        break w;
                                                                                    default:
                                                                                        break f;
                                                                                }
                                                                            }
                                                                            switch(B | 0){
                                                                                case 2:
                                                                                    break o;
                                                                                case 1:
                                                                                    break u;
                                                                                case 0:
                                                                                    break n;
                                                                                default:
                                                                                    break f;
                                                                            }
                                                                        }
                                                                        for(; s = i[t + 16 >> 2] < 3, w = s ? w : t, t = i[(s << 2) + t >> 2], !!t;);
                                                                        if ((v | 0) == (w | 0) | i[w + 16 >> 2] > 3) break u;
                                                                        for(s = v, t = u; w = i[t + 16 >> 2] < 4, s = w ? s : t, t = i[(w << 2) + t >> 2], !!t;);
                                                                        if ((s | 0) == (v | 0) | i[s + 16 >> 2] > 4) break u;
                                                                        for(s = v, t = u; w = i[t + 16 >> 2] < 5, s = w ? s : t, t = i[(w << 2) + t >> 2], !!t;);
                                                                        if ((s | 0) == (v | 0) | i[s + 16 >> 2] >= 6) break u;
                                                                        for(t = v; s = i[u + 16 >> 2] < 3, t = s ? t : u, u = i[(s << 2) + u >> 2], !!u;);
                                                                        if (s = 255, J0(A, _, 3, f, k, (t | 0) == (v | 0) | i[t + 16 >> 2] > 3 ? s : l[t + 24 | 0], n), i[A >> 2] || (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), J0(A, i[e >> 2], 4, f, k, S0(r, 4), n), i[A >> 2]) || (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), J0(A, i[e >> 2], 5, f, k, S0(r, 5), n), i[A >> 2])) break i;
                                                                        if (o[A + 19 | 0] >= 0) break r;
                                                                        X(i[A + 8 >> 2]);
                                                                        break r;
                                                                    }
                                                                    if (r = D(32), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 31, i[h + 12 >> 2] = -2147483616, f = l[4580] | l[4581] << 8 | (l[4582] << 16 | l[4583] << 24), e = l[4576] | l[4577] << 8 | (l[4578] << 16 | l[4579] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 31 | 0] = 0, f = l[4603] | l[4604] << 8 | (l[4605] << 16 | l[4606] << 24), e = l[4599] | l[4600] << 8 | (l[4601] << 16 | l[4602] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, o[r + 27 | 0] = f, o[r + 28 | 0] = f >>> 8, o[r + 29 | 0] = f >>> 16, o[r + 30 | 0] = f >>> 24, f = l[4596] | l[4597] << 8 | (l[4598] << 16 | l[4599] << 24), e = l[4592] | l[4593] << 8 | (l[4594] << 16 | l[4595] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[4588] | l[4589] << 8 | (l[4590] << 16 | l[4591] << 24), e = l[4584] | l[4585] << 8 | (l[4586] << 16 | l[4587] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                                                    X(i[h + 4 >> 2]);
                                                                    break i;
                                                                }
                                                                for(; t = i[s + 16 >> 2], w = (t | 0) < 0 ? w : s, s = i[(t >>> 29 & 4) + s >> 2], !!s;);
                                                                if ((v | 0) == (w | 0) | i[w + 16 >> 2] > 0) break o;
                                                                for(t = v; s = i[u + 16 >> 2], t = (s | 0) < 0 ? t : u, u = i[(s >>> 29 & 4) + u >> 2], !!u;);
                                                                if (s = 255, J0(A, _, 0, f, k, (t | 0) == (v | 0) | i[t + 16 >> 2] > 0 ? s : l[t + 24 | 0], n), i[A >> 2]) break i;
                                                                if (o[A + 19 | 0] >= 0) break r;
                                                                X(i[A + 8 >> 2]);
                                                                break r;
                                                            }
                                                            if (r = D(40), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 32, i[h + 12 >> 2] = -2147483608, f = l[10589] | l[10590] << 8 | (l[10591] << 16 | l[10592] << 24), e = l[10585] | l[10586] << 8 | (l[10587] << 16 | l[10588] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 32 | 0] = 0, f = l[10613] | l[10614] << 8 | (l[10615] << 16 | l[10616] << 24), e = l[10609] | l[10610] << 8 | (l[10611] << 16 | l[10612] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[10605] | l[10606] << 8 | (l[10607] << 16 | l[10608] << 24), e = l[10601] | l[10602] << 8 | (l[10603] << 16 | l[10604] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[10597] | l[10598] << 8 | (l[10599] << 16 | l[10600] << 24), e = l[10593] | l[10594] << 8 | (l[10595] << 16 | l[10596] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                                            X(i[h + 4 >> 2]);
                                                            break i;
                                                        }
                                                        for(; s = i[t + 16 >> 2], w = (s | 0) < 0 ? w : t, t = i[(s >>> 29 & 4) + t >> 2], !!t;);
                                                        if ((v | 0) == (w | 0) | i[w + 16 >> 2] > 0) break n;
                                                        for(t = v; s = i[u + 16 >> 2] <= 0, t = s ? t : u, u = i[(s << 2) + u >> 2], !!u;);
                                                        if ((t | 0) == (v | 0) | i[t + 16 >> 2] > 1) break n;
                                                        if (A1(r, 2)) break k;
                                                    }
                                                    if (r = D(40), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 34, i[h + 12 >> 2] = -2147483608, f = l[4545] | l[4546] << 8 | (l[4547] << 16 | l[4548] << 24), e = l[4541] | l[4542] << 8 | (l[4543] << 16 | l[4544] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 34 | 0] = 0, e = l[4573] | l[4574] << 8, o[r + 32 | 0] = e, o[r + 33 | 0] = e >>> 8, f = l[4569] | l[4570] << 8 | (l[4571] << 16 | l[4572] << 24), e = l[4565] | l[4566] << 8 | (l[4567] << 16 | l[4568] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[4561] | l[4562] << 8 | (l[4563] << 16 | l[4564] << 24), e = l[4557] | l[4558] << 8 | (l[4559] << 16 | l[4560] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[4553] | l[4554] << 8 | (l[4555] << 16 | l[4556] << 24), e = l[4549] | l[4550] << 8 | (l[4551] << 16 | l[4552] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                                    X(i[h + 4 >> 2]);
                                                    break i;
                                                }
                                                if (IA(f, k, 1, G, h + 4 | 0, h), J0(A, i[e >> 2], 0, f, k, S0(r, 0), n), i[A >> 2] || (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), J0(A, i[e >> 2], 1, i[h + 4 >> 2], i[h >> 2], S0(r, 1), n), i[A >> 2])) break i;
                                                if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), J0(A, i[e >> 2], 2, i[h + 4 >> 2], i[h >> 2], S0(r, 2), n), t = i[A >> 2], t | o[A + 19 | 0] >= 0) break A;
                                                X(i[A + 8 >> 2]);
                                                break r;
                                            }
                                            if (r = D(32), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 27, i[h + 12 >> 2] = -2147483616, f = l[6727] | l[6728] << 8 | (l[6729] << 16 | l[6730] << 24), e = l[6723] | l[6724] << 8 | (l[6725] << 16 | l[6726] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 27 | 0] = 0, e = l[6746] | l[6747] << 8 | (l[6748] << 16 | l[6749] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, f = l[6743] | l[6744] << 8 | (l[6745] << 16 | l[6746] << 24), e = l[6739] | l[6740] << 8 | (l[6741] << 16 | l[6742] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[6735] | l[6736] << 8 | (l[6737] << 16 | l[6738] << 24), e = l[6731] | l[6732] << 8 | (l[6733] << 16 | l[6734] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                            X(i[h + 4 >> 2]);
                                            break i;
                                        }
                                        if (t) break i;
                                    }
                                    if (t = i[v >> 2], !t) break e;
                                    for(s = v; u = i[t + 16 >> 2] < 6, s = u ? s : t, t = i[(u << 2) + t >> 2], !!t;);
                                    if ((s | 0) == (v | 0) | i[s + 16 >> 2] > 6) break e;
                                    if (J0(A, i[e >> 2], 6, f, k, S0(r, 6), n), i[A >> 2]) break i;
                                    if (o[A + 19 | 0] >= 0) break e;
                                    X(i[A + 8 >> 2]);
                                }
                                if (G = i[r + 60 >> 2], (v | 0) != (G | 0)) for(;;){
                                    _ = i[G + 16 >> 2];
                                    e: {
                                        if ((_ | 0) == 10) {
                                            if (W = 255, n = i[r + 36 >> 2] - 10 | 0, n >>> 0 >= 6) break e;
                                            n = n << 3, t = n & 31, (n & 63) >>> 0 >= 32 ? W = 16432 >>> t | 0 : W = ((1 << t) - 1 & 16432) << 32 - t | 1076895768 >>> t;
                                            break e;
                                        }
                                        if (W = 0, t = v, s = i[t >> 2], !s) break e;
                                        for(; n = (_ | 0) > i[s + 16 >> 2], t = n ? t : s, s = i[(n << 2) + s >> 2], !!s;);
                                        if ((t | 0) == (v | 0) | (_ | 0) < i[t + 16 >> 2]) break e;
                                        W = l[t + 24 | 0] + 7 & -8;
                                    }
                                    e: {
                                        n = i[e >> 2], t = i[n + 64 >> 2];
                                        r: {
                                            if (!t) break r;
                                            for(C = W >>> 3 & 31, w = n - -64 | 0, u = w, s = t; n = (_ | 0) > i[s + 16 >> 2], u = n ? u : s, s = i[(n << 2) + s >> 2], !!s;);
                                            if ((u | 0) == (w | 0)) break r;
                                            if ((_ | 0) >= i[u + 16 >> 2]) break e;
                                        }
                                        if (r = D(40), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 35, i[h + 12 >> 2] = -2147483608, f = l[10553] | l[10554] << 8 | (l[10555] << 16 | l[10556] << 24), e = l[10549] | l[10550] << 8 | (l[10551] << 16 | l[10552] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 35 | 0] = 0, e = l[10580] | l[10581] << 8 | (l[10582] << 16 | l[10583] << 24), o[r + 31 | 0] = e, o[r + 32 | 0] = e >>> 8, o[r + 33 | 0] = e >>> 16, o[r + 34 | 0] = e >>> 24, f = l[10577] | l[10578] << 8 | (l[10579] << 16 | l[10580] << 24), e = l[10573] | l[10574] << 8 | (l[10575] << 16 | l[10576] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[10569] | l[10570] << 8 | (l[10571] << 16 | l[10572] << 24), e = l[10565] | l[10566] << 8 | (l[10567] << 16 | l[10568] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[10561] | l[10562] << 8 | (l[10563] << 16 | l[10564] << 24), e = l[10557] | l[10558] << 8 | (l[10559] << 16 | l[10560] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 2, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                        X(i[h + 4 >> 2]);
                                        break i;
                                    }
                                    if (u = w, s = t, l[G + 24 | 0] != 8) {
                                        if (r = D(56), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 52, i[h + 12 >> 2] = -2147483592, f = l[8113] | l[8114] << 8 | (l[8115] << 16 | l[8116] << 24), e = l[8109] | l[8110] << 8 | (l[8111] << 16 | l[8112] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 52 | 0] = 0, e = l[8157] | l[8158] << 8 | (l[8159] << 16 | l[8160] << 24), o[r + 48 | 0] = e, o[r + 49 | 0] = e >>> 8, o[r + 50 | 0] = e >>> 16, o[r + 51 | 0] = e >>> 24, f = l[8153] | l[8154] << 8 | (l[8155] << 16 | l[8156] << 24), e = l[8149] | l[8150] << 8 | (l[8151] << 16 | l[8152] << 24), o[r + 40 | 0] = e, o[r + 41 | 0] = e >>> 8, o[r + 42 | 0] = e >>> 16, o[r + 43 | 0] = e >>> 24, o[r + 44 | 0] = f, o[r + 45 | 0] = f >>> 8, o[r + 46 | 0] = f >>> 16, o[r + 47 | 0] = f >>> 24, f = l[8145] | l[8146] << 8 | (l[8147] << 16 | l[8148] << 24), e = l[8141] | l[8142] << 8 | (l[8143] << 16 | l[8144] << 24), o[r + 32 | 0] = e, o[r + 33 | 0] = e >>> 8, o[r + 34 | 0] = e >>> 16, o[r + 35 | 0] = e >>> 24, o[r + 36 | 0] = f, o[r + 37 | 0] = f >>> 8, o[r + 38 | 0] = f >>> 16, o[r + 39 | 0] = f >>> 24, f = l[8137] | l[8138] << 8 | (l[8139] << 16 | l[8140] << 24), e = l[8133] | l[8134] << 8 | (l[8135] << 16 | l[8136] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[8129] | l[8130] << 8 | (l[8131] << 16 | l[8132] << 24), e = l[8125] | l[8126] << 8 | (l[8127] << 16 | l[8128] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[8121] | l[8122] << 8 | (l[8123] << 16 | l[8124] << 24), e = l[8117] | l[8118] << 8 | (l[8119] << 16 | l[8120] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 4, 0, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                        X(i[h + 4 >> 2]);
                                        break i;
                                    }
                                    for(; n = (_ | 0) > i[s + 16 >> 2], u = n ? u : s, s = i[(n << 2) + s >> 2], !!s;);
                                    for(n = 0, n = (u | 0) == (w | 0) | (_ | 0) < i[u + 16 >> 2] ? n : i[u + 28 >> 2], u = w, s = t; B = (_ | 0) > i[s + 16 >> 2], u = B ? u : s, s = i[(B << 2) + s >> 2], !!s;);
                                    for(E = 0, E = (u | 0) == (w | 0) | (_ | 0) < i[u + 16 >> 2] ? E : i[u + 32 >> 2], M = i[G + 44 >> 2], H = i[G + 52 >> 2], s = w; u = (_ | 0) > i[t + 16 >> 2], s = u ? s : t, t = i[(u << 2) + t >> 2], !!t;);
                                    e: {
                                        if ((s | 0) == (w | 0)) {
                                            R = 0, w = 0;
                                            break e;
                                        }
                                        if (R = 0, w = 0, (_ | 0) < i[s + 16 >> 2]) break e;
                                        R = i[s + 44 >> 2], w = i[s + 52 >> 2];
                                    }
                                    if (E) for(S = n & -2, P = n & 1, $ = C & 28, T = C & 3, s = 0, c = (W & 255) >>> 0 < 8, r0 = C - 1 >>> 0 < 3;;){
                                        t = (Z(i[r + 28 >> 2], s) >>> 0) / (k >>> 0) | 0;
                                        e: {
                                            if ((C | 0) != 1) {
                                                if (c | !n) break e;
                                                for(V = Z(s, w) + R | 0, _ = Z(t, H) + M | 0, W = 0;;){
                                                    if (y = Z(W, C) + V | 0, F = Z((Z(i[r + 24 >> 2], W) >>> 0) / (f >>> 0) | 0, C) + _ | 0, t = 0, u = 0, !r0) for(; o[t + y | 0] = l[t + F | 0], B = t | 1, o[B + y | 0] = l[B + F | 0], B = t | 2, o[B + y | 0] = l[B + F | 0], B = t | 3, o[B + y | 0] = l[B + F | 0], t = t + 4 | 0, u = u + 4 | 0, ($ | 0) != (u | 0););
                                                    if (u = 0, T) for(; o[t + y | 0] = l[t + F | 0], t = t + 1 | 0, u = u + 1 | 0, (T | 0) != (u | 0););
                                                    if (W = W + 1 | 0, (W | 0) == (n | 0)) break;
                                                }
                                                break e;
                                            }
                                            if (!n) break e;
                                            if (V = Z(s, w) + R | 0, _ = Z(t, H) + M | 0, t = 0, u = 0, (n | 0) != 1) for(; o[t + V | 0] = l[_ + ((Z(i[r + 24 >> 2], t) >>> 0) / (f >>> 0) | 0) | 0], B = t | 1, o[B + V | 0] = l[_ + ((Z(B, i[r + 24 >> 2]) >>> 0) / (f >>> 0) | 0) | 0], t = t + 2 | 0, u = u + 2 | 0, (S | 0) != (u | 0););
                                            if (!P) break e;
                                            o[t + V | 0] = l[_ + ((Z(i[r + 24 >> 2], t) >>> 0) / (f >>> 0) | 0) | 0];
                                        }
                                        if (s = s + 1 | 0, (E | 0) == (s | 0)) break;
                                    }
                                    s = i[G + 4 >> 2];
                                    e: {
                                        if (s) {
                                            for(;;)if (t = s, s = i[t >> 2], !s) break e;
                                        }
                                        for(; t = i[G + 8 >> 2], n = i[t >> 2] != (G | 0), G = t, !!n;);
                                    }
                                    if (G = t, (t | 0) == (v | 0)) break;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            m = h + 16 | 0;
                        }
                        function oh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            r = m - 176 | 0, m = r, i[r + 168 >> 2] = 0, i[r + 172 >> 2] = 0, i[r + 160 >> 2] = 0, i[r + 164 >> 2] = 0, i[r + 152 >> 2] = 0, i[r + 156 >> 2] = 0, i[r + 144 >> 2] = 0, i[r + 148 >> 2] = 0, C = D(208), i[C >> 2] = 76896, i[C + 4 >> 2] = 0, i[C + 8 >> 2] = 0, _ = C + 16 | 0, k = _, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k >> 2] = 73428, k = C, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[_ >> 2] = 81944, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, Q[k + 120 >> 1] = 259, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 152 >> 2] = 0, i[k + 156 >> 2] = 0, i[k + 160 >> 2] = 0, i[k + 164 >> 2] = 0, i[k + 168 >> 2] = 0, i[k + 172 >> 2] = 0, i[k + 176 >> 2] = 0, i[k + 180 >> 2] = 0, i[k + 200 >> 2] = 0, i[k + 192 >> 2] = 0, i[k + 196 >> 2] = 0, i[k + 32 >> 2] = 1987470147, i[r + 28 >> 2] = k, i[r + 24 >> 2] = _, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, R = r, M = p2(r + 144 | 0, r + 24 | 0), i[R + 148 >> 2] = M, k = i[r + 28 >> 2];
                            i: {
                                if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            i[r + 140 >> 2] = 0, t = i[e >> 2], k = i[e + 4 >> 2];
                            i: {
                                if (!k) {
                                    i[r + 140 >> 2] = 0, i[r + 136 >> 2] = t;
                                    break i;
                                }
                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, i[r + 136 >> 2] = t, e = i[r + 140 >> 2], i[r + 140 >> 2] = k, !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            p[i[i[f >> 2] + 100 >> 2]](r + 124 | 0, i[f + 4 >> 2], r + 136 | 0, n);
                            i: {
                                k = i[r + 124 >> 2];
                                e: {
                                    if (k) {
                                        if (n = i[r + 128 >> 2], t = i[r + 132 >> 2], e = E2(t), e >>> 0 >= 2147483640) break i;
                                        r: {
                                            A: {
                                                if (e >>> 0 >= 11) {
                                                    u = (e | 7) + 1 | 0, f = D(u), i[r + 120 >> 2] = u | -2147483648, i[r + 112 >> 2] = f, i[r + 116 >> 2] = e;
                                                    break A;
                                                }
                                                if (o[r + 123 | 0] = e, f = r + 112 | 0, !e) break r;
                                            }
                                            Q0(f, t, e);
                                        }
                                        o[e + f | 0] = 0, e = i0(r + 24 | 0, k, n, r + 112 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                                        r: {
                                            if (o[e + 19 | 0] >= 0) {
                                                f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break r;
                                            X(i[e + 8 >> 2]);
                                        }
                                        if (o[r + 123 | 0] >= 0) break e;
                                        X(i[r + 112 >> 2]);
                                        break e;
                                    }
                                    if (i[r + 112 >> 2] = 0, i[r + 108 >> 2] = 0, p[i[i[f >> 2] + 104 >> 2]](r + 24 | 0, i[f + 4 >> 2], r + 104 | 0, r + 100 | 0, 0), e = i[r + 104 >> 2], e) for(;;){
                                        r: {
                                            A: {
                                                if (n = i[r + 100 >> 2], (n | 0) < 2) break A;
                                                f: switch((l[e + 1 | 0] >>> 3 | 0) - 14 | 0){
                                                    case 1:
                                                        Q[r + 24 >> 1] = 259, i[r + 80 >> 2] = 0, i[r + 84 >> 2] = 0, i[r + 72 >> 2] = 0, i[r + 76 >> 2] = 0, i[r + 64 >> 2] = 0, i[r + 68 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, F = r + 4 | 0, y = e, w = r + 24 | 0, u = 0, k = 0, s = 0, v = 0, h = m - 80 | 0, m = h, i[h + 76 >> 2] = 0, i[h + 68 >> 2] = 0, i[h + 72 >> 2] = 0;
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        s: {
                                                                            u: {
                                                                                w: {
                                                                                    if (n) {
                                                                                        for(E = n;;){
                                                                                            l: {
                                                                                                h: {
                                                                                                    if (e = v + 2 | 0, E >>> 0 <= e >>> 0 || (n = v + y | 0, l[n | 0] | l[n + 1 | 0] | l[e + y | 0] != 3)) break h;
                                                                                                    v: {
                                                                                                        if (u >>> 0 > s >>> 0) {
                                                                                                            o[s | 0] = 0, v = s + 1 | 0;
                                                                                                            break v;
                                                                                                        }
                                                                                                        if (W = s - k | 0, n = W + 1 | 0, (n | 0) < 0) break t;
                                                                                                        t = u - k | 0, u = t << 1, V = t >>> 0 >= 1073741823 ? 2147483647 : n >>> 0 < u >>> 0 ? u : n, V ? v = D(V) : v = 0, G = v + W | 0, o[G | 0] = 0, t = G;
                                                                                                        _: {
                                                                                                            if ((k | 0) == (s | 0)) break _;
                                                                                                            if (B = 0, n = t, u = s, t = W & 3, t) for(; n = n - 1 | 0, u = u - 1 | 0, o[n | 0] = l[u | 0], B = B + 1 | 0, (t | 0) != (B | 0););
                                                                                                            if (t = v, k - s >>> 0 > 4294967292) break _;
                                                                                                            for(; o[n - 1 | 0] = l[u - 1 | 0], o[n - 2 | 0] = l[u - 2 | 0], o[n - 3 | 0] = l[u - 3 | 0], n = n - 4 | 0, u = u - 4 | 0, o[n | 0] = l[u | 0], (k | 0) != (u | 0););
                                                                                                            t = v;
                                                                                                        }
                                                                                                        u = v + V | 0, v = G + 1 | 0, k && X(k), k = t;
                                                                                                    }
                                                                                                    if (u >>> 0 > v >>> 0) {
                                                                                                        o[v | 0] = 0, s = v + 1 | 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    if (W = v - k | 0, n = W + 1 | 0, (n | 0) < 0) break w;
                                                                                                    t = u - k | 0, u = t << 1, V = t >>> 0 >= 1073741823 ? 2147483647 : n >>> 0 < u >>> 0 ? u : n, V ? s = D(V) : s = 0, G = s + W | 0, o[G | 0] = 0, t = G;
                                                                                                    v: {
                                                                                                        if ((k | 0) == (v | 0)) break v;
                                                                                                        if (B = 0, n = t, u = v, t = W & 3, t) for(; n = n - 1 | 0, u = u - 1 | 0, o[n | 0] = l[u | 0], B = B + 1 | 0, (t | 0) != (B | 0););
                                                                                                        if (t = s, k - v >>> 0 > 4294967292) break v;
                                                                                                        for(; o[n - 1 | 0] = l[u - 1 | 0], o[n - 2 | 0] = l[u - 2 | 0], o[n - 3 | 0] = l[u - 3 | 0], n = n - 4 | 0, u = u - 4 | 0, o[n | 0] = l[u | 0], (k | 0) != (u | 0););
                                                                                                        t = s;
                                                                                                    }
                                                                                                    if (u = s + V | 0, s = G + 1 | 0, !k) {
                                                                                                        k = t;
                                                                                                        break l;
                                                                                                    }
                                                                                                    X(k), k = t;
                                                                                                    break l;
                                                                                                }
                                                                                                e = v + y | 0;
                                                                                                h: {
                                                                                                    if (u >>> 0 > s >>> 0) {
                                                                                                        o[s | 0] = l[e | 0], s = s + 1 | 0;
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (W = s - k | 0, n = W + 1 | 0, (n | 0) < 0) break t;
                                                                                                    t = u - k | 0, u = t << 1, B = t >>> 0 >= 1073741823 ? 2147483647 : n >>> 0 < u >>> 0 ? u : n, B ? t = D(B) : t = 0, G = t + W | 0, o[G | 0] = l[e | 0], n = G;
                                                                                                    v: {
                                                                                                        if ((k | 0) == (s | 0)) break v;
                                                                                                        if (n = 0, u = G, e = s, W = W & 3, W) for(; u = u - 1 | 0, e = e - 1 | 0, o[u | 0] = l[e | 0], n = n + 1 | 0, (W | 0) != (n | 0););
                                                                                                        if (n = t, k - s >>> 0 > 4294967292) break v;
                                                                                                        for(; o[u - 1 | 0] = l[e - 1 | 0], o[u - 2 | 0] = l[e - 2 | 0], o[u - 3 | 0] = l[e - 3 | 0], u = u - 4 | 0, e = e - 4 | 0, o[u | 0] = l[e | 0], (e | 0) != (k | 0););
                                                                                                        n = t;
                                                                                                    }
                                                                                                    u = t + B | 0, s = G + 1 | 0, k && X(k), k = n;
                                                                                                }
                                                                                                e = v;
                                                                                            }
                                                                                            if (v = e + 1 | 0, !(E >>> 0 > v >>> 0)) break;
                                                                                        }
                                                                                        i[h + 72 >> 2] = s, i[h + 68 >> 2] = k, i[h + 76 >> 2] = u;
                                                                                    }
                                                                                    if (t = wi(h + 32 | 0, k, s - k | 0), C2(t, 16), C2(t, 4), C2(t, 4), Q[w + 2 >> 1] = 0, R = w, M = Z1(t, 3) + 1 | 0, o[R + 4 | 0] = M, R = w, M = Z1(t, 2), o[R + 6 | 0] = M, C2(t, 2), !$0(t, 1)) break o;
                                                                                    if (R = w, M = Z1(t, 7), o[R + 9 | 0] = M, R = w, M = Z1(t, 1), o[R + 10 | 0] = M, R = w, M = Z1(t, 8), o[R + 11 | 0] = M, R = w, M = Z1(t, 1), o[R + 12 | 0] = M, R = w, M = Z1(t, 1), o[R + 13 | 0] = M, !$0(t, 1)) {
                                                                                        o[w + 8 | 0] = 1, u = i[w + 20 >> 2], n = i[w + 24 >> 2];
                                                                                        l: {
                                                                                            if (u >>> 0 < n >>> 0) {
                                                                                                o[u | 0] = 0, v = u + 1 | 0;
                                                                                                break l;
                                                                                            }
                                                                                            if (B = i[w + 16 >> 2], e = u - B | 0, k = e + 1 | 0, (k | 0) < 0) break u;
                                                                                            s = 0, n = n - B | 0, v = n << 1, k = n >>> 0 >= 1073741823 ? 2147483647 : k >>> 0 < v >>> 0 ? v : k, k && (s = D(k)), n = e + s | 0, o[n | 0] = 0, G = k + s | 0, v = n + 1 | 0;
                                                                                            h: {
                                                                                                if ((u | 0) == (B | 0)) {
                                                                                                    s = n;
                                                                                                    break h;
                                                                                                }
                                                                                                y = e & 3;
                                                                                                v: {
                                                                                                    if (!y) {
                                                                                                        e = u;
                                                                                                        break v;
                                                                                                    }
                                                                                                    for(k = 0, e = u; n = n - 1 | 0, e = e - 1 | 0, o[n | 0] = l[e | 0], k = k + 1 | 0, (y | 0) != (k | 0););
                                                                                                }
                                                                                                if (B - u >>> 0 <= 4294967292) for(; o[n - 1 | 0] = l[e - 1 | 0], o[n - 2 | 0] = l[e - 2 | 0], o[n - 3 | 0] = l[e - 3 | 0], n = n - 4 | 0, e = e - 4 | 0, o[n | 0] = l[e | 0], (e | 0) != (B | 0););
                                                                                                B = i[w + 16 >> 2];
                                                                                            }
                                                                                            if (i[w + 24 >> 2] = G, i[w + 20 >> 2] = v, i[w + 16 >> 2] = s, !B) break l;
                                                                                            X(B);
                                                                                        }
                                                                                        i[w + 20 >> 2] = v;
                                                                                    }
                                                                                    if (e = i[t + 24 >> 2], i[t + 24 >> 2] = e & -8, u = i[t + 20 >> 2], n = i[t + 16 >> 2], k = e & 7, e = k, (e & 63) >>> 0 >= 32 ? (k = n << e, e = 0) : (k = (1 << e) - 1 & n >>> 32 - e | u << e, e = n << e), i[t + 16 >> 2] = e, i[t + 20 >> 2] = k, C5(w + 28 | 0, l[w + 4 | 0]), e = l[w + 4 | 0], e >>> 0 < 2) break s;
                                                                                    for(e = e - 2 | 0; k = 1 << e, u = $0(t, 1), n = i[w + 28 >> 2] + (e >>> 3 & 536870908) | 0, u ? k = k | i[n >> 2] : k = i[n >> 2] & (k ^ -1), i[n >> 2] = k, k = (e | 0) > 0, e = e - 1 | 0, !!k;);
                                                                                    break s;
                                                                                }
                                                                                i[h + 72 >> 2] = v;
                                                                                break n;
                                                                            }
                                                                            p0(), z();
                                                                        }
                                                                        e = i[t + 24 >> 2], i[t + 24 >> 2] = e & -8, u = i[t + 20 >> 2], n = i[t + 16 >> 2], k = e & 7, e = k, (e & 63) >>> 0 >= 32 ? (k = n << e, e = 0) : (k = (1 << e) - 1 & n >>> 32 - e | u << e, e = n << e), i[t + 16 >> 2] = e, i[t + 20 >> 2] = k, k = w + 40 | 0, e = l[w + 4 | 0], u = i[w + 40 >> 2], n = i[w + 44 >> 2] - u | 0;
                                                                        s: {
                                                                            if (e >>> 0 > n >>> 0) {
                                                                                r1(k, e - n | 0), e = l[w + 4 | 0];
                                                                                break s;
                                                                            }
                                                                            if (e >>> 0 >= n >>> 0) break s;
                                                                            i[w + 44 >> 2] = e + u;
                                                                        }
                                                                        if (e >>> 0 >= 2) for(e = e - 2 | 0; i[i[w + 28 >> 2] + (e >>> 3 & 536870908) >> 2] >>> e & 1 && (n = Z1(t, 8), o[i[k >> 2] + e | 0] = n), n = (e | 0) > 0, e = e - 1 | 0, !!n;);
                                                                        n = w + 52 | 0, k = $0(t, 8), u = i[w + 52 >> 2], e = i[w + 56 >> 2] - u >> 2;
                                                                        s: {
                                                                            if (k >>> 0 > e >>> 0) {
                                                                                d4(n, k - e | 0);
                                                                                break s;
                                                                            }
                                                                            if (e >>> 0 <= k >>> 0) break s;
                                                                            i[w + 56 >> 2] = u + (k << 2);
                                                                        }
                                                                        if (e = 0, (k | 0) <= 0) break o;
                                                                        for(; u = $0(t, 32), i[i[n >> 2] + (e << 2) >> 2] = u, e = e + 1 | 0, (k | 0) != (e | 0););
                                                                    }
                                                                    C2(t, 1), $0(t, 1) && C2(t, 1), R1(t, h + 28 | 0), R1(t, h + 24 | 0), e = i[h + 28 >> 2], i[r + 112 >> 2] = e, k = i[h + 24 >> 2], i[r + 108 >> 2] = k;
                                                                    o: {
                                                                        if (!((k | 0) < 65536 & (e | 0) <= 65535)) {
                                                                            if (e = D(56), i[h + 12 >> 2] = e, i[h + 16 >> 2] = 55, i[h + 20 >> 2] = -2147483592, k = l[20412] | l[20413] << 8 | (l[20414] << 16 | l[20415] << 24), n = l[20408] | l[20409] << 8 | (l[20410] << 16 | l[20411] << 24), o[e | 0] = n, o[e + 1 | 0] = n >>> 8, o[e + 2 | 0] = n >>> 16, o[e + 3 | 0] = n >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 55 | 0] = 0, k = l[20459] | l[20460] << 8 | (l[20461] << 16 | l[20462] << 24), n = l[20455] | l[20456] << 8 | (l[20457] << 16 | l[20458] << 24), o[e + 47 | 0] = n, o[e + 48 | 0] = n >>> 8, o[e + 49 | 0] = n >>> 16, o[e + 50 | 0] = n >>> 24, o[e + 51 | 0] = k, o[e + 52 | 0] = k >>> 8, o[e + 53 | 0] = k >>> 16, o[e + 54 | 0] = k >>> 24, k = l[20452] | l[20453] << 8 | (l[20454] << 16 | l[20455] << 24), n = l[20448] | l[20449] << 8 | (l[20450] << 16 | l[20451] << 24), o[e + 40 | 0] = n, o[e + 41 | 0] = n >>> 8, o[e + 42 | 0] = n >>> 16, o[e + 43 | 0] = n >>> 24, o[e + 44 | 0] = k, o[e + 45 | 0] = k >>> 8, o[e + 46 | 0] = k >>> 16, o[e + 47 | 0] = k >>> 24, k = l[20444] | l[20445] << 8 | (l[20446] << 16 | l[20447] << 24), n = l[20440] | l[20441] << 8 | (l[20442] << 16 | l[20443] << 24), o[e + 32 | 0] = n, o[e + 33 | 0] = n >>> 8, o[e + 34 | 0] = n >>> 16, o[e + 35 | 0] = n >>> 24, o[e + 36 | 0] = k, o[e + 37 | 0] = k >>> 8, o[e + 38 | 0] = k >>> 16, o[e + 39 | 0] = k >>> 24, k = l[20436] | l[20437] << 8 | (l[20438] << 16 | l[20439] << 24), n = l[20432] | l[20433] << 8 | (l[20434] << 16 | l[20435] << 24), o[e + 24 | 0] = n, o[e + 25 | 0] = n >>> 8, o[e + 26 | 0] = n >>> 16, o[e + 27 | 0] = n >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[20428] | l[20429] << 8 | (l[20430] << 16 | l[20431] << 24), n = l[20424] | l[20425] << 8 | (l[20426] << 16 | l[20427] << 24), o[e + 16 | 0] = n, o[e + 17 | 0] = n >>> 8, o[e + 18 | 0] = n >>> 16, o[e + 19 | 0] = n >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[20420] | l[20421] << 8 | (l[20422] << 16 | l[20423] << 24), n = l[20416] | l[20417] << 8 | (l[20418] << 16 | l[20419] << 24), o[e + 8 | 0] = n, o[e + 9 | 0] = n >>> 8, o[e + 10 | 0] = n >>> 16, o[e + 11 | 0] = n >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(F, 9, 2006, h + 12 | 0), o[h + 23 | 0] >= 0) break o;
                                                                            X(i[h + 12 >> 2]);
                                                                            break o;
                                                                        }
                                                                        if (Q[w + 66 >> 1] = k, Q[w + 64 >> 1] = e, $0(t, 1) && (R1(t, h + 12 | 0), R1(t, h + 8 | 0), R1(t, h + 4 | 0), R1(t, h)), $0(t, 1), R1(t, h + 8 | 0), e = i[h + 8 >> 2], (e | 0) >= 248) {
                                                                            if (e = D(32), i[h + 12 >> 2] = e, i[h + 16 >> 2] = 27, i[h + 20 >> 2] = -2147483616, k = l[19667] | l[19668] << 8 | (l[19669] << 16 | l[19670] << 24), n = l[19663] | l[19664] << 8 | (l[19665] << 16 | l[19666] << 24), o[e | 0] = n, o[e + 1 | 0] = n >>> 8, o[e + 2 | 0] = n >>> 16, o[e + 3 | 0] = n >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 27 | 0] = 0, k = l[19686] | l[19687] << 8 | (l[19688] << 16 | l[19689] << 24), o[e + 23 | 0] = k, o[e + 24 | 0] = k >>> 8, o[e + 25 | 0] = k >>> 16, o[e + 26 | 0] = k >>> 24, k = l[19683] | l[19684] << 8 | (l[19685] << 16 | l[19686] << 24), n = l[19679] | l[19680] << 8 | (l[19681] << 16 | l[19682] << 24), o[e + 16 | 0] = n, o[e + 17 | 0] = n >>> 8, o[e + 18 | 0] = n >>> 16, o[e + 19 | 0] = n >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[19675] | l[19676] << 8 | (l[19677] << 16 | l[19678] << 24), n = l[19671] | l[19672] << 8 | (l[19673] << 16 | l[19674] << 24), o[e + 8 | 0] = n, o[e + 9 | 0] = n >>> 8, o[e + 10 | 0] = n >>> 16, o[e + 11 | 0] = n >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, i0(F, 9, 0, h + 12 | 0), o[h + 23 | 0] >= 0) break o;
                                                                            X(i[h + 12 >> 2]);
                                                                            break o;
                                                                        }
                                                                        if (o[w + 5 | 0] = 1, o[w + 7 | 0] = e, e = i[21669], i[F >> 2] = i[21668], i[F + 4 >> 2] = e, e = F + 8 | 0, o[86691] >= 0) {
                                                                            k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                                                            break o;
                                                                        }
                                                                        j(e, i[21670], i[21671]);
                                                                    }
                                                                    e = i[h + 68 >> 2], e && (i[h + 72 >> 2] = e, X(e)), m = h + 80 | 0;
                                                                    break k;
                                                                }
                                                                i[h + 72 >> 2] = s;
                                                            }
                                                            i[h + 68 >> 2] = k, i[h + 76 >> 2] = u, p0(), z();
                                                        }
                                                        o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), e = r + 24 | 0, k = i[e + 4 >> 2], i[_ + 104 >> 2] = i[e >> 2], i[_ + 108 >> 2] = k, i[_ + 112 >> 2] = i[e + 8 >> 2], Q[_ + 116 >> 1] = I[e + 12 >> 1];
                                                        k: {
                                                            if ((e | 0) == (_ + 104 | 0)) {
                                                                r9(_ + 132 | 0, e + 28 | 0);
                                                                break k;
                                                            }
                                                            k = i[e + 16 >> 2], n = i[e + 20 >> 2], b4(_ + 120 | 0, k, n, n - k | 0), r9(_ + 132 | 0, e + 28 | 0), k = i[e + 40 >> 2], n = i[e + 44 >> 2], b4(_ + 144 | 0, k, n, n - k | 0), k = i[e + 52 >> 2], n = i[e + 56 >> 2], a8(_ + 156 | 0, k, n, n - k >> 2);
                                                        }
                                                        i[_ + 168 >> 2] = i[e + 64 >> 2], Q[_ + 172 >> 1] = I[e + 68 >> 1], e = i[r + 76 >> 2], e && (i[r + 80 >> 2] = e, X(e)), e = i[r + 64 >> 2], e && (i[r + 68 >> 2] = e, X(e)), e = i[r + 52 >> 2], e && X(e), e = i[r + 40 >> 2], e && (i[r + 44 >> 2] = e, X(e)), n = i[r + 100 >> 2], e = i[r + 104 >> 2];
                                                        break;
                                                    case 0:
                                                    case 2:
                                                        break f;
                                                    default:
                                                        break A;
                                                }
                                                u = m - 16 | 0, m = u, i[u + 12 >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, n ? (r1(u + 4 | 0, n), k = i[u + 4 >> 2]) : k = 0, v0(k, e, n), t = m - 16 | 0, m = t, n = u + 4 | 0, k = l[i[n >> 2] + 1 | 0] >>> 3 | 0;
                                                f: {
                                                    k: {
                                                        e = i[_ + 176 >> 2], s = i[_ + 180 >> 2];
                                                        n: {
                                                            if ((e | 0) != (s | 0)) for(;;){
                                                                if ((k | 0) == l[e + 1 | 0]) {
                                                                    if (k = i[e + 8 >> 2], k >>> 0 < k0[e + 12 >> 2]) {
                                                                        if (i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, s = i[n + 4 >> 2], v = i[n >> 2], (s | 0) != (v | 0)) {
                                                                            if (n = s - v | 0, (n | 0) < 0) break k;
                                                                            s = D(n), i[k + 4 >> 2] = s, i[k >> 2] = s, G = n + s | 0, i[k + 8 >> 2] = G, v0(s, v, n), i[k + 4 >> 2] = G;
                                                                        }
                                                                        i[e + 8 >> 2] = k + 12;
                                                                        break n;
                                                                    }
                                                                    R = e, M = B6(e + 4 | 0, n), i[R + 8 >> 2] = M;
                                                                    break n;
                                                                }
                                                                if (e = e + 16 | 0, (s | 0) == (e | 0)) break;
                                                            }
                                                            i[t + 12 >> 2] = 0, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, o[t + 1 | 0] = k, o[t | 0] = 1, k = B6(t + 4 | 0, n), e = i[_ + 180 >> 2], i[t + 8 >> 2] = k;
                                                            t: {
                                                                if (e >>> 0 < k0[_ + 184 >> 2]) {
                                                                    k = I[t >> 1], i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, Q[e >> 1] = k, k = i[t + 4 >> 2], n = i[t + 8 >> 2], eA(e + 4 | 0, k, n, (n - k | 0) / 12 | 0), e = e + 16 | 0;
                                                                    break t;
                                                                }
                                                                e = T5(_ + 176 | 0, t);
                                                            }
                                                            if (i[_ + 180 >> 2] = e, k = i[t + 4 >> 2], !k) break n;
                                                            if (e = i[t + 8 >> 2], n = k, (e | 0) != (k | 0)) {
                                                                for(; n = e - 12 | 0, s = i[n >> 2], s && (i[e - 8 >> 2] = s, X(s)), e = n, (k | 0) != (e | 0););
                                                                n = i[t + 4 >> 2];
                                                            }
                                                            i[t + 8 >> 2] = k, X(n);
                                                        }
                                                        m = t + 16 | 0;
                                                        break f;
                                                    }
                                                    p0(), z();
                                                }
                                                e = i[u + 4 >> 2], e && (i[u + 8 >> 2] = e, X(e)), m = u + 16 | 0;
                                                break r;
                                            }
                                            P9(r + 144 | 0, e, n);
                                        }
                                        if (p[i[i[f >> 2] + 104 >> 2]](r + 24 | 0, i[f + 4 >> 2], r + 104 | 0, r + 100 | 0, 0), e = i[r + 104 >> 2], !e) break;
                                    }
                                    G6(A, r + 144 | 0);
                                }
                                A = i[r + 140 >> 2];
                                e: {
                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A || (p[i[i[C >> 2] + 8 >> 2]](C), g(C)), A = i[r + 156 >> 2], A && (i[r + 160 >> 2] = A, X(A)), A = i[r + 144 >> 2], A) {
                                    if (e = A, f = i[r + 148 >> 2], (e | 0) != (f | 0)) {
                                        for(;;){
                                            e = i[f - 4 >> 2];
                                            e: {
                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break e;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            if (f = f - 8 | 0, (A | 0) == (f | 0)) break;
                                        }
                                        e = i[r + 144 >> 2];
                                    }
                                    i[r + 148 >> 2] = A, X(e);
                                }
                                m = r + 176 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function X7(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            f = r + 60 | 0, (f | 0) != (e | 0) && (k = f, f = i[e >> 2], e = i[e + 4 >> 2], b4(k, f, e, e - f | 0)), u = m - 48 | 0, m = u, i[r + 72 >> 2] = 0, k = u + 24 | 0, f = m - 16 | 0, m = f;
                            i: {
                                e: {
                                    if (n = i[r + 60 >> 2], e = i[r + 64 >> 2] - n | 0, e >>> 0 >= 2 && (t = e - 2 | 0, e = i[r + 72 >> 2], t >>> 0 >= e >>> 0)) break e;
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(k, 2, 140, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (n = e + n | 0, n = l[n | 0] | l[n + 1 | 0] << 8, i[r + 72 >> 2] = e + 2, ((n << 8 | n >>> 8) & 65535) == 65359) {
                                    if (e = i[21669], i[k >> 2] = i[21668], i[k + 4 >> 2] = e, e = k + 8 | 0, o[86691] >= 0) {
                                        k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(e, i[21670], i[21671]);
                                    break i;
                                }
                                if (e = D(32), i[f + 4 >> 2] = e, i[f + 8 >> 2] = 27, i[f + 12 >> 2] = -2147483616, n = l[6066] | l[6067] << 8 | (l[6068] << 16 | l[6069] << 24), s = l[6062] | l[6063] << 8 | (l[6064] << 16 | l[6065] << 24), o[e | 0] = s, o[e + 1 | 0] = s >>> 8, o[e + 2 | 0] = s >>> 16, o[e + 3 | 0] = s >>> 24, o[e + 4 | 0] = n, o[e + 5 | 0] = n >>> 8, o[e + 6 | 0] = n >>> 16, o[e + 7 | 0] = n >>> 24, o[e + 27 | 0] = 0, n = l[6085] | l[6086] << 8 | (l[6087] << 16 | l[6088] << 24), o[e + 23 | 0] = n, o[e + 24 | 0] = n >>> 8, o[e + 25 | 0] = n >>> 16, o[e + 26 | 0] = n >>> 24, n = l[6082] | l[6083] << 8 | (l[6084] << 16 | l[6085] << 24), s = l[6078] | l[6079] << 8 | (l[6080] << 16 | l[6081] << 24), o[e + 16 | 0] = s, o[e + 17 | 0] = s >>> 8, o[e + 18 | 0] = s >>> 16, o[e + 19 | 0] = s >>> 24, o[e + 20 | 0] = n, o[e + 21 | 0] = n >>> 8, o[e + 22 | 0] = n >>> 16, o[e + 23 | 0] = n >>> 24, n = l[6074] | l[6075] << 8 | (l[6076] << 16 | l[6077] << 24), s = l[6070] | l[6071] << 8 | (l[6072] << 16 | l[6073] << 24), o[e + 8 | 0] = s, o[e + 9 | 0] = s >>> 8, o[e + 10 | 0] = s >>> 16, o[e + 11 | 0] = s >>> 24, o[e + 12 | 0] = n, o[e + 13 | 0] = n >>> 8, o[e + 14 | 0] = n >>> 16, o[e + 15 | 0] = n >>> 24, i0(k, 2, 140, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                X(i[f + 4 >> 2]);
                            }
                            m = f + 16 | 0;
                            i: {
                                if (i[u + 24 >> 2]) {
                                    r = i[u + 28 >> 2], i[A >> 2] = i[u + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[u + 40 >> 2], r = i[u + 36 >> 2], i[A + 8 >> 2] = i[u + 32 >> 2], i[A + 12 >> 2] = r, i[u + 40 >> 2] = 0, i[u + 32 >> 2] = 0, i[u + 36 >> 2] = 0;
                                    break i;
                                }
                                n = m - 16 | 0, m = n;
                                e: {
                                    r: {
                                        if (f = i[r + 60 >> 2], s = i[r + 64 >> 2] - f | 0, s >>> 0 >= 43 && (e = i[r + 72 >> 2], e >>> 0 <= s - 43 >>> 0)) break r;
                                        if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(u, 2, 140, n + 4 | 0), o[n + 15 | 0] >= 0) break e;
                                        X(i[n + 4 >> 2]);
                                        break e;
                                    }
                                    if (k = e + f | 0, k = l[k | 0] | l[k + 1 | 0] << 8, t = e + 2 | 0, i[r + 72 >> 2] = t, ((k << 8 | k >>> 8) & 65535) != 65361) {
                                        if (e = D(32), i[n + 4 >> 2] = e, i[n + 8 >> 2] = 27, i[n + 12 >> 2] = -2147483616, f = l[6038] | l[6039] << 8 | (l[6040] << 16 | l[6041] << 24), k = l[6034] | l[6035] << 8 | (l[6036] << 16 | l[6037] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 27 | 0] = 0, f = l[6057] | l[6058] << 8 | (l[6059] << 16 | l[6060] << 24), o[e + 23 | 0] = f, o[e + 24 | 0] = f >>> 8, o[e + 25 | 0] = f >>> 16, o[e + 26 | 0] = f >>> 24, f = l[6054] | l[6055] << 8 | (l[6056] << 16 | l[6057] << 24), k = l[6050] | l[6051] << 8 | (l[6052] << 16 | l[6053] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[6046] | l[6047] << 8 | (l[6048] << 16 | l[6049] << 24), k = l[6042] | l[6043] << 8 | (l[6044] << 16 | l[6045] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(u, 2, 140, n + 4 | 0), o[n + 15 | 0] >= 0) break e;
                                        X(i[n + 4 >> 2]);
                                        break e;
                                    }
                                    if (k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8, t = e + 4 | 0, i[r + 72 >> 2] = t, ((k << 8 | k >>> 8) + 16345 & 65535) >>> 0 <= 16385) {
                                        if (e = D(24), i[n + 4 >> 2] = e, i[n + 8 >> 2] = 23, i[n + 12 >> 2] = -2147483624, f = l[9816] | l[9817] << 8 | (l[9818] << 16 | l[9819] << 24), k = l[9812] | l[9813] << 8 | (l[9814] << 16 | l[9815] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 23 | 0] = 0, f = l[9831] | l[9832] << 8 | (l[9833] << 16 | l[9834] << 24), k = l[9827] | l[9828] << 8 | (l[9829] << 16 | l[9830] << 24), o[e + 15 | 0] = k, o[e + 16 | 0] = k >>> 8, o[e + 17 | 0] = k >>> 16, o[e + 18 | 0] = k >>> 24, o[e + 19 | 0] = f, o[e + 20 | 0] = f >>> 8, o[e + 21 | 0] = f >>> 16, o[e + 22 | 0] = f >>> 24, f = l[9824] | l[9825] << 8 | (l[9826] << 16 | l[9827] << 24), k = l[9820] | l[9821] << 8 | (l[9822] << 16 | l[9823] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(u, 2, 140, n + 4 | 0), o[n + 15 | 0] >= 0) break e;
                                        X(i[n + 4 >> 2]);
                                        break e;
                                    }
                                    if (k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8, t = e + 6 | 0, i[r + 72 >> 2] = t, Q[r >> 1] = k << 8 | k >>> 8, k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 10 | 0, i[r + 72 >> 2] = t, i[r + 4 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 14 | 0, i[r + 72 >> 2] = t, i[r + 8 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 18 | 0, i[r + 72 >> 2] = t, i[r + 12 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 22 | 0, i[r + 72 >> 2] = t, i[r + 16 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 26 | 0, i[r + 72 >> 2] = t, i[r + 20 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 30 | 0, i[r + 72 >> 2] = t, i[r + 24 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 34 | 0, i[r + 72 >> 2] = t, i[r + 28 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = f + t | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), t = e + 38 | 0, i[r + 72 >> 2] = t, i[r + 32 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), f = f + t | 0, f = l[f | 0] | l[f + 1 | 0] << 8, e = e + 40 | 0, i[r + 72 >> 2] = e, v = f << 8 | f >>> 8, (v - 16385 & 65535) >>> 0 <= 49151) {
                                        if (e = D(24), i[n + 4 >> 2] = e, i[n + 8 >> 2] = 23, i[n + 12 >> 2] = -2147483624, f = l[9840] | l[9841] << 8 | (l[9842] << 16 | l[9843] << 24), k = l[9836] | l[9837] << 8 | (l[9838] << 16 | l[9839] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 23 | 0] = 0, f = l[9855] | l[9856] << 8 | (l[9857] << 16 | l[9858] << 24), k = l[9851] | l[9852] << 8 | (l[9853] << 16 | l[9854] << 24), o[e + 15 | 0] = k, o[e + 16 | 0] = k >>> 8, o[e + 17 | 0] = k >>> 16, o[e + 18 | 0] = k >>> 24, o[e + 19 | 0] = f, o[e + 20 | 0] = f >>> 8, o[e + 21 | 0] = f >>> 16, o[e + 22 | 0] = f >>> 24, f = l[9848] | l[9849] << 8 | (l[9850] << 16 | l[9851] << 24), k = l[9844] | l[9845] << 8 | (l[9846] << 16 | l[9847] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(u, 2, 140, n + 4 | 0), o[n + 15 | 0] >= 0) break e;
                                        X(i[n + 4 >> 2]);
                                        break e;
                                    }
                                    if (e >>> 0 <= s + Z(v & 65535, -3) >>> 0) {
                                        e = i[r + 40 >> 2];
                                        r: {
                                            A: {
                                                for(;;){
                                                    k = i[r + 60 >> 2], f = i[r + 72 >> 2], s = l[k + f | 0], t = f + 1 | 0, i[r + 72 >> 2] = t, h = l[k + t | 0], t = f + 2 | 0, i[r + 72 >> 2] = t, _ = l[k + t | 0], i[r + 72 >> 2] = f + 3, B = s >>> 7 | 0, G = (s & 127) + 1 | 0, k = i[r + 44 >> 2];
                                                    f: {
                                                        if (k >>> 0 > e >>> 0) {
                                                            f = h | (G << 16 | B << 24 | _ << 8), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, e = e + 4 | 0;
                                                            break f;
                                                        }
                                                        if (t = i[r + 36 >> 2], s = e - t >> 2, f = s + 1 | 0, f >>> 0 >= 1073741824) break A;
                                                        if (k = k - t | 0, w = k >> 1, w = k >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < w >>> 0 ? w : f, w) {
                                                            if (w >>> 0 >= 1073741824) break r;
                                                            k = D(w << 2);
                                                        } else k = 0;
                                                        if (s = k + (s << 2) | 0, f = h | (G << 16 | B << 24 | _ << 8), o[s | 0] = f, o[s + 1 | 0] = f >>> 8, o[s + 2 | 0] = f >>> 16, o[s + 3 | 0] = f >>> 24, f = s + 4 | 0, (e | 0) != (t | 0)) {
                                                            for(; s = s - 4 | 0, e = e - 4 | 0, h = l[e | 0] | l[e + 1 | 0] << 8 | (l[e + 2 | 0] << 16 | l[e + 3 | 0] << 24), o[s | 0] = h, o[s + 1 | 0] = h >>> 8, o[s + 2 | 0] = h >>> 16, o[s + 3 | 0] = h >>> 24, (e | 0) != (t | 0););
                                                            t = i[r + 36 >> 2];
                                                        }
                                                        i[r + 44 >> 2] = k + (w << 2), i[r + 40 >> 2] = f, i[r + 36 >> 2] = s, t && X(t), e = f;
                                                    }
                                                    if (i[r + 40 >> 2] = e, W = W + 1 | 0, !((W & 65535) >>> 0 < (v & 65535) >>> 0)) break;
                                                }
                                                J6(u);
                                                break e;
                                            }
                                            p0(), z();
                                        }
                                        Z2(), z();
                                    }
                                    if (e = a1(n + 4 | 0, 34896), i0(u, 2, 140, e), o[e + 11 | 0] >= 0) break e;
                                    X(i[e >> 2]);
                                }
                                if (m = n + 16 | 0, f = i[u + 4 >> 2], e = i[u >> 2], i[u + 24 >> 2] = e, i[u + 28 >> 2] = f, o[u + 43 | 0] < 0 && (X(i[u + 32 >> 2]), e = i[u + 24 >> 2]), f = i[u + 12 >> 2], i[u + 32 >> 2] = i[u + 8 >> 2], i[u + 36 >> 2] = f, i[u + 40 >> 2] = i[u + 16 >> 2], e) {
                                    r = i[u + 28 >> 2], i[A >> 2] = i[u + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[u + 40 >> 2], r = i[u + 36 >> 2], i[A + 8 >> 2] = i[u + 32 >> 2], i[A + 12 >> 2] = r, i[u + 32 >> 2] = 0, i[u + 36 >> 2] = 0, i[u + 40 >> 2] = 0;
                                    break i;
                                }
                                if (e = i[r + 72 >> 2], f = i[r + 60 >> 2], e >>> 0 < (i[r + 64 >> 2] - f | 0) - 2 >>> 0) {
                                    if (f = e + f | 0, f = l[f | 0] | l[f + 1 | 0] << 8, i[r + 72 >> 2] = e + 2, ((f << 8 | f >>> 8) & 65535) == 65360) {
                                        k = m - 16 | 0, m = k, f = i[r + 72 >> 2], e = i[r + 60 >> 2];
                                        e: {
                                            if (f >>> 0 > (i[r + 64 >> 2] - e | 0) - 8 >>> 0) {
                                                if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, i0(A, 2, 140, k + 4 | 0), o[k + 15 | 0] >= 0) break e;
                                                X(i[k + 4 >> 2]);
                                                break e;
                                            }
                                            if (n = e + f | 0, n = l[n | 0] | l[n + 1 | 0] << 8, s = f + 2 | 0, i[r + 72 >> 2] = s, ((n << 8 | n >>> 8) - 71 & 65535) >>> 0 <= 65472) {
                                                if (r = D(24), i[k + 4 >> 2] = r, i[k + 8 >> 2] = 23, i[k + 12 >> 2] = -2147483624, e = l[9888] | l[9889] << 8 | (l[9890] << 16 | l[9891] << 24), f = l[9884] | l[9885] << 8 | (l[9886] << 16 | l[9887] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 23 | 0] = 0, e = l[9903] | l[9904] << 8 | (l[9905] << 16 | l[9906] << 24), f = l[9899] | l[9900] << 8 | (l[9901] << 16 | l[9902] << 24), o[r + 15 | 0] = f, o[r + 16 | 0] = f >>> 8, o[r + 17 | 0] = f >>> 16, o[r + 18 | 0] = f >>> 24, o[r + 19 | 0] = e, o[r + 20 | 0] = e >>> 8, o[r + 21 | 0] = e >>> 16, o[r + 22 | 0] = e >>> 24, e = l[9896] | l[9897] << 8 | (l[9898] << 16 | l[9899] << 24), f = l[9892] | l[9893] << 8 | (l[9894] << 16 | l[9895] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 140, k + 4 | 0), o[k + 15 | 0] >= 0) break e;
                                                X(i[k + 4 >> 2]);
                                                break e;
                                            }
                                            for(e = e + s | 0, e = l[e | 0] | l[e + 1 | 0] << 8 | (l[e + 2 | 0] << 16 | l[e + 3 | 0] << 24), i[r + 72 >> 2] = f + 6, v = e << 24 | (e & 65280) << 8 | (e >>> 8 & 65280 | e >>> 24), s = 2;;){
                                                r: {
                                                    if (!(v >>> 32 - s & 1)) break r;
                                                    if ((s | 0) == 15) {
                                                        e = i[r + 72 >> 2], f = e + i[r + 60 >> 2] | 0, n = l[f + 1 | 0], f = l[f | 0], i[r + 72 >> 2] = e + 2, e = f << 24 | n << 16 | 15, i[k >> 2] = e, i[k + 4 >> 2] = e;
                                                        A: {
                                                            if (e = i[r + 52 >> 2], n = i[r + 56 >> 2], e >>> 0 < n >>> 0) {
                                                                f = I[k >> 1] | I[k + 2 >> 1] << 16, Q[e >> 1] = f, Q[e + 2 >> 1] = f >>> 16, i[r + 52 >> 2] = e + 4;
                                                                break A;
                                                            }
                                                            f: {
                                                                if (t = i[r + 48 >> 2], h = e - t >> 2, f = h + 1 | 0, f >>> 0 < 1073741824) {
                                                                    if (n = n - t | 0, w = n >> 1, w = n >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < w >>> 0 ? w : f, w) {
                                                                        if (w >>> 0 >= 1073741824) break f;
                                                                        f = D(w << 2);
                                                                    } else f = 0;
                                                                    if (n = f + (h << 2) | 0, h = I[k >> 1] | I[k + 2 >> 1] << 16, Q[n >> 1] = h, Q[n + 2 >> 1] = h >>> 16, h = n + 4 | 0, (e | 0) != (t | 0)) {
                                                                        for(; n = n - 4 | 0, e = e - 4 | 0, _ = I[e >> 1] | I[e + 2 >> 1] << 16, Q[n >> 1] = _, Q[n + 2 >> 1] = _ >>> 16, (e | 0) != (t | 0););
                                                                        t = i[r + 48 >> 2];
                                                                    }
                                                                    i[r + 56 >> 2] = f + (w << 2), i[r + 52 >> 2] = h, i[r + 48 >> 2] = n, t && X(t), i[r + 52 >> 2] = h;
                                                                    break A;
                                                                }
                                                                p0(), z();
                                                            }
                                                            Z2(), z();
                                                        }
                                                        break r;
                                                    }
                                                    n = k + 4 | 0, e = P0(U(107228, 24188, 39), s), f = i[(i[i[e >> 2] - 12 >> 2] + e | 0) + 28 >> 2], i[n >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(n, 108580), t = p[i[i[f >> 2] + 28 >> 2]](f, 10) | 0, d0(n), f = m - 16 | 0, m = f, C1(f + 8 | 0, e);
                                                    A: {
                                                        if (!l[f + 8 | 0] || (n = f + 4 | 0, i[n >> 2] = i[(e + i[i[e >> 2] - 12 >> 2] | 0) + 24 >> 2], bA(n, t), i[n >> 2])) break A;
                                                        Gf(e + i[i[e >> 2] - 12 >> 2] | 0, 1);
                                                    }
                                                    G1(f + 8 | 0), m = f + 16 | 0, Ni(e), i[r + 72 >> 2] = i[r + 72 >> 2] + 2;
                                                }
                                                if (s = s + 1 | 0, (s | 0) == 33) break;
                                            }
                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break e;
                                            }
                                            j(A, i[21670], i[21671]);
                                        }
                                        m = k + 16 | 0;
                                        break i;
                                    }
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                if (r = D(40), i[u >> 2] = r, i[u + 4 >> 2] = 33, i[u + 8 >> 2] = -2147483608, e = l[20241] | l[20242] << 8 | (l[20243] << 16 | l[20244] << 24), f = l[20237] | l[20238] << 8 | (l[20239] << 16 | l[20240] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 33 | 0] = 0, o[r + 32 | 0] = l[20269], e = l[20265] | l[20266] << 8 | (l[20267] << 16 | l[20268] << 24), f = l[20261] | l[20262] << 8 | (l[20263] << 16 | l[20264] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[20257] | l[20258] << 8 | (l[20259] << 16 | l[20260] << 24), f = l[20253] | l[20254] << 8 | (l[20255] << 16 | l[20256] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[20249] | l[20250] << 8 | (l[20251] << 16 | l[20252] << 24), f = l[20245] | l[20246] << 8 | (l[20247] << 16 | l[20248] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 140, u), o[u + 11 | 0] >= 0) break i;
                                X(i[u >> 2]);
                            }
                            o[u + 43 | 0] < 0 && X(i[u + 32 >> 2]), m = u + 48 | 0;
                        }
                        function uh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = J(0), s = J(0), h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = J(0), V = 0, y = 0, F = J(0), E = 0, R = 0, M = 0, H = J(0), T = J(0), S = J(0), P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0;
                            n = m - 160 | 0, m = n, r = i[e >> 2], y = i[r + 28 >> 2], W = i[r + 24 >> 2], G = D(136), i[G >> 2] = 78252, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 0, B0(G + 20 | 0, 0, 104), h = i[G + 4 >> 2], v = h + 1 | 0, i[G + 4 >> 2] = v, i[G + 56 >> 2] = 0, i[G + 60 >> 2] = 0, i[G + 44 >> 2] = 99, i[G + 48 >> 2] = 99, i[G + 32 >> 2] = 4142, r = G - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[G + 132 >> 2] = 0, f = G, i[f + 124 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 84 >> 2] = 1, i[f + 88 >> 2] = 1, r = f + 76 | 0, i[f + 72 >> 2] = r, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, i[f + 112 >> 2] = 0, o[f + 113 | 0] = 0, o[f + 114 | 0] = 0, o[f + 115 | 0] = 0, o[f + 116 | 0] = 0, o[f + 117 | 0] = 0, o[f + 118 | 0] = 0, o[f + 119 | 0] = 0, o[f + 120 | 0] = 0, P = f + 12 | 0, i[f + 12 >> 2] = P, i[f + 8 >> 2] = i[f + 8 >> 2] + 1, i[f + 4 >> 2] = h, i[f + 16 >> 2] = f, v || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), f = i[k + 4 >> 2], h = f >>> 0 < 4, i[P + 36 >> 2] = f, i[P + 32 >> 2] = 0, i[P + 28 >> 2] = y, i[P + 24 >> 2] = W, q = l[k + 8 | 0], Z0 = i[i[e >> 2] + 36 >> 2], J0(n + 136 | 0, P, 0, W, y, 8, t), L = W - 1 | 0, f = f << 3, R = (h ? 16908801 >>> f | 0 : 0) & 3, v = (L + R >>> 0) / (R >>> 0) | 0, m0 = y - 1 | 0, _ = (h ? 16843265 >>> f | 0 : 0) & 3, h = (m0 + _ >>> 0) / (_ >>> 0) | 0, J0(n + 112 | 0, P, 1, v, h, 8, t), f = n + 16 | 0;
                            i: {
                                if (i[n + 136 >> 2]) {
                                    if (B = i[n + 140 >> 2], i[n + 8 >> 2] = i[n + 136 >> 2], i[n + 12 >> 2] = B, o[n + 155 | 0] >= 0) {
                                        B = i[n + 148 >> 2], i[f >> 2] = i[n + 144 >> 2], i[f + 4 >> 2] = B, i[f + 8 >> 2] = i[n + 152 >> 2];
                                        break i;
                                    }
                                    j(f, i[n + 144 >> 2], i[n + 148 >> 2]);
                                    break i;
                                }
                                if (B = i[n + 116 >> 2], i[n + 8 >> 2] = i[n + 112 >> 2], i[n + 12 >> 2] = B, o[n + 131 | 0] >= 0) {
                                    B = i[n + 124 >> 2], i[f >> 2] = i[n + 120 >> 2], i[f + 4 >> 2] = B, i[f + 8 >> 2] = i[n + 128 >> 2];
                                    break i;
                                }
                                j(f, i[n + 120 >> 2], i[n + 124 >> 2]);
                            }
                            J0(n + 88 | 0, P, 2, v, h, 8, t), h = n + 56 | 0;
                            i: {
                                if (i[n + 8 >> 2]) {
                                    if (v = i[n + 12 >> 2], i[n + 48 >> 2] = i[n + 8 >> 2], i[n + 52 >> 2] = v, o[n + 27 | 0] >= 0) {
                                        v = i[f + 4 >> 2], i[h >> 2] = i[f >> 2], i[h + 4 >> 2] = v, i[h + 8 >> 2] = i[f + 8 >> 2];
                                        break i;
                                    }
                                    j(h, i[n + 16 >> 2], i[n + 20 >> 2]);
                                    break i;
                                }
                                if (f = i[n + 92 >> 2], i[n + 48 >> 2] = i[n + 88 >> 2], i[n + 52 >> 2] = f, o[n + 107 | 0] >= 0) {
                                    f = i[n + 100 >> 2], i[h >> 2] = i[n + 96 >> 2], i[h + 4 >> 2] = f, i[h + 8 >> 2] = i[n + 104 >> 2];
                                    break i;
                                }
                                j(h, i[n + 96 >> 2], i[n + 100 >> 2]);
                            }
                            o[n + 107 | 0] < 0 && X(i[n + 96 >> 2]), o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), o[n + 131 | 0] < 0 && X(i[n + 120 >> 2]), o[n + 155 | 0] < 0 && X(i[n + 144 >> 2]);
                            i: {
                                if (i[n + 48 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 52 >> 2], i[A + 8 >> 2] = i[n + 48 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 67 | 0] >= 0) {
                                        r = i[h + 4 >> 2], i[A >> 2] = i[h >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[h + 8 >> 2];
                                        break i;
                                    }
                                    if (j(A, i[n + 56 >> 2], i[n + 60 >> 2]), o[n + 67 | 0] >= 0) break i;
                                    X(i[n + 56 >> 2]);
                                    break i;
                                }
                                o[n + 67 | 0] < 0 && X(i[n + 56 >> 2]);
                                e: {
                                    if (!(q & 1)) break e;
                                    if (J0(n + 48 | 0, P, 6, W, y, 8, t), i[n + 48 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 52 >> 2], i[A + 8 >> 2] = i[n + 48 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 67 | 0] >= 0) {
                                            r = i[n + 60 >> 2], i[A >> 2] = i[n + 56 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 64 >> 2];
                                            break i;
                                        }
                                        if (j(A, i[n + 56 >> 2], i[n + 60 >> 2]), o[n + 67 | 0] >= 0) break i;
                                        X(i[n + 56 >> 2]);
                                        break i;
                                    }
                                    if (o[n + 67 | 0] >= 0) break e;
                                    X(i[n + 56 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (e = i[e >> 2], t = i[e + 64 >> 2], !t) break r;
                                        for(e = e - -64 | 0, f = e; h = i[t + 16 >> 2] < 10, f = h ? f : t, t = i[(h << 2) + t >> 2], !!t;);
                                        if ((e | 0) == (f | 0)) break r;
                                        if (h = 0, i[f + 16 >> 2] > 10) break e;
                                        $ = i[f + 44 >> 2], h = i[f + 52 >> 2];
                                        break e;
                                    }
                                    h = 0;
                                }
                                e: {
                                    r: {
                                        if (f = i[r >> 2], f) {
                                            for(e = r, t = f; w = i[t + 16 >> 2], e = (w | 0) < 0 ? e : t, t = i[(w >>> 29 & 4) + t >> 2], !!t;);
                                            w = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (w = 0, i[e + 16 >> 2] > 0)) break A;
                                                r0 = i[e + 52 >> 2], w = i[e + 44 >> 2];
                                            }
                                            for(e = r, t = f; v = i[t + 16 >> 2] <= 0, e = v ? e : t, t = i[(v << 2) + t >> 2], !!t;);
                                            E = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (E = 0, i[e + 16 >> 2] > 1)) break A;
                                                f0 = i[e + 44 >> 2], E = i[e + 52 >> 2];
                                            }
                                            for(e = r, t = f; v = i[t + 16 >> 2] < 2, e = v ? e : t, t = i[(v << 2) + t >> 2], !!t;);
                                            M = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (M = 0, i[e + 16 >> 2] > 2)) break A;
                                                t0 = i[e + 52 >> 2], M = i[e + 44 >> 2];
                                            }
                                            if (v = 0, !f || (v = 0, !(q & 1))) break e;
                                            for(t = r; e = i[f + 16 >> 2] < 6, t = e ? t : f, f = i[(e << 2) + f >> 2], !!f;);
                                            if ((r | 0) != (t | 0)) break r;
                                        }
                                        v = 0;
                                        break e;
                                    }
                                    if (v = 0, i[t + 16 >> 2] > 6) break e;
                                    X0 = i[t + 52 >> 2], v = i[t + 44 >> 2];
                                }
                                i[n + 84 >> 2] = -1113159960, i[n + 76 >> 2] = 1056964608, i[n + 80 >> 2] = -1093247418, i[n + 68 >> 2] = -1096180881, i[n + 72 >> 2] = 1056964608, i[n + 60 >> 2] = 1038710997, i[n + 64 >> 2] = -1104361250, i[n + 52 >> 2] = 1050220167, i[n + 56 >> 2] = 1058424226, o[n + 48 | 0] = 1, c = l[k + 26 | 0], Te(n + 8 | 0, I[k + 24 >> 1], I[k + 20 >> 1]), r = i[n + 44 >> 2], i[n + 80 >> 2] = i[n + 40 >> 2], i[n + 84 >> 2] = r, r = i[n + 36 >> 2], i[n + 72 >> 2] = i[n + 32 >> 2], i[n + 76 >> 2] = r, e = i[n + 28 >> 2], r = n - -64 | 0, i[r >> 2] = i[n + 24 >> 2], i[r + 4 >> 2] = e, r = i[n + 20 >> 2], i[n + 56 >> 2] = i[n + 16 >> 2], i[n + 60 >> 2] = r, r = i[n + 12 >> 2], i[n + 48 >> 2] = i[n + 8 >> 2], i[n + 52 >> 2] = r, B = (Z0 | 0) == 11 ? 4 : 3;
                                e: {
                                    r: {
                                        A: {
                                            if (y) {
                                                if (W) {
                                                    for(r = 0, s0 = c & 1;;){
                                                        k = Z(r, r0) + w | 0, t = Z(r, h) + $ | 0, e = 0, f = 0;
                                                        f: {
                                                            if (!s0) for(;;){
                                                                V = e + k | 0, u = J(J(J(J(J(l[t + 2 | 0]) * W0[n + 60 >> 2]) + J(J(J(l[t | 0]) * W0[n + 52 >> 2]) + J(W0[n + 56 >> 2] * J(l[t + 1 | 0])))) * J(.8554700016975403)) + J(.5));
                                                                k: {
                                                                    if (J(r2(u)) < J(2147483648)) {
                                                                        f = ~~u;
                                                                        break k;
                                                                    }
                                                                    f = -2147483648;
                                                                }
                                                                if (o[V | 0] = (f | 0) < 0 ? 16 : (f >>> 0 >= 219 ? 219 : f) + 16 | 0, t = t + B | 0, e = e + 1 | 0, (W | 0) == (e | 0)) break f;
                                                            }
                                                            for(;;){
                                                                V = f + k | 0, u = J(J(J(J(l[t + 2 | 0]) * W0[n + 60 >> 2]) + J(J(J(l[t | 0]) * W0[n + 52 >> 2]) + J(W0[n + 56 >> 2] * J(l[t + 1 | 0])))) + J(.5));
                                                                k: {
                                                                    if (J(r2(u)) < J(2147483648)) {
                                                                        e = ~~u;
                                                                        break k;
                                                                    }
                                                                    e = -2147483648;
                                                                }
                                                                if (e = (e | 0) >= 255 ? 255 : e, o[V | 0] = (e | 0) > 0 ? e : 0, t = t + B | 0, f = f + 1 | 0, (W | 0) == (f | 0)) break;
                                                            }
                                                        }
                                                        if (r = r + 1 | 0, (y | 0) == (r | 0)) break;
                                                    }
                                                    if (t = (_ | 0) == 1, (R | 0) != 1 | (_ | 0) != 1) break A;
                                                    if (!y) break r;
                                                    for(_ = c & 1, r = 0;;){
                                                        k = Z(r, t0) + M | 0, w = Z(r, E) + f0 | 0, t = Z(r, h) + $ | 0, f = 0, e = 0;
                                                        f: {
                                                            if (!_) for(;;){
                                                                u = W0[n + 84 >> 2], s = W0[n + 76 >> 2], F = W0[n + 80 >> 2], V = f + w | 0, C = J(l[t + 2 | 0]), H = J(l[t | 0]), T = J(l[t + 1 | 0]), S = J(J(J(J(J(C * W0[n + 72 >> 2]) + J(J(H * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * T))) * J(.875)) + J(128)) + J(.5));
                                                                k: {
                                                                    if (J(r2(S)) < J(2147483648)) {
                                                                        e = ~~S;
                                                                        break k;
                                                                    }
                                                                    e = -2147483648;
                                                                }
                                                                e = (e | 0) >= 255 ? 255 : e, o[V | 0] = (e | 0) > 0 ? e : 0, V = f + k | 0, u = J(J(J(J(J(C * u) + J(J(H * s) + J(F * T))) * J(.875)) + J(128)) + J(.5));
                                                                k: {
                                                                    if (J(r2(u)) < J(2147483648)) {
                                                                        e = ~~u;
                                                                        break k;
                                                                    }
                                                                    e = -2147483648;
                                                                }
                                                                if (e = (e | 0) >= 255 ? 255 : e, o[V | 0] = (e | 0) > 0 ? e : 0, t = t + B | 0, f = f + 1 | 0, (W | 0) == (f | 0)) break f;
                                                            }
                                                            for(;;){
                                                                u = W0[n + 84 >> 2], s = W0[n + 76 >> 2], F = W0[n + 80 >> 2], V = e + w | 0, C = J(l[t + 2 | 0]), H = J(l[t | 0]), T = J(l[t + 1 | 0]), S = J(J(J(J(C * W0[n + 72 >> 2]) + J(J(H * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * T))) + J(128)) + J(.5));
                                                                k: {
                                                                    if (J(r2(S)) < J(2147483648)) {
                                                                        f = ~~S;
                                                                        break k;
                                                                    }
                                                                    f = -2147483648;
                                                                }
                                                                f = (f | 0) >= 255 ? 255 : f, o[V | 0] = (f | 0) > 0 ? f : 0, V = e + k | 0, u = J(J(J(J(C * u) + J(J(H * s) + J(F * T))) + J(128)) + J(.5));
                                                                k: {
                                                                    if (J(r2(u)) < J(2147483648)) {
                                                                        f = ~~u;
                                                                        break k;
                                                                    }
                                                                    f = -2147483648;
                                                                }
                                                                if (f = (f | 0) >= 255 ? 255 : f, o[V | 0] = (f | 0) > 0 ? f : 0, t = t + B | 0, e = e + 1 | 0, (W | 0) == (e | 0)) break;
                                                            }
                                                        }
                                                        if (r = r + 1 | 0, (y | 0) == (r | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (t = (_ | 0) == 1, (R | 0) != 1) break A;
                                                if (t) break e;
                                                break A;
                                            }
                                            if (t = (_ | 0) == 1, (R | 0) != 1) break A;
                                            if (t) break r;
                                        }
                                        if (r = (R | 0) != 2, !(r | (_ | 0) != 2)) {
                                            _ = y & -2;
                                            A: {
                                                if (!_ || (R = W & -2, !R)) break A;
                                                for(r0 = B << 1, s0 = h + 2 | 0, V0 = B + 2 | 0, I0 = h + 1 | 0, F0 = B + 1 | 0, w = h + B | 0, g0 = w + 2 | 0, R0 = w + 1 | 0, k = 0;;){
                                                    for(t = Z(k, h) + $ | 0, r = k >>> 1 | 0, D0 = Z(r, t0) + M | 0, H0 = Z(r, E) + f0 | 0, f = 0;;){
                                                        s = J((l[t + g0 | 0] + (l[t + s0 | 0] + (l[t + V0 | 0] + l[t + 2 | 0] | 0) | 0) >>> 2 & 255) >>> 0), F = J((l[t + w | 0] + (l[t + h | 0] + (l[t + B | 0] + l[t | 0] | 0) | 0) >>> 2 & 255) >>> 0), C = J((l[t + R0 | 0] + (l[t + I0 | 0] + (l[t + F0 | 0] + l[t + 1 | 0] | 0) | 0) >>> 2 & 255) >>> 0), u = J(J(s * W0[n + 84 >> 2]) + J(J(F * W0[n + 76 >> 2]) + J(W0[n + 80 >> 2] * C))), s = J(J(s * W0[n + 72 >> 2]) + J(J(F * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * C))), e = f >>> 1 | 0, r = e + D0 | 0, V = e + H0 | 0;
                                                        f: {
                                                            if (!(c & 1)) {
                                                                u = J(J(u * J(.875)) + J(128)), s = J(J(J(s * J(.875)) + J(128)) + J(.5));
                                                                k: {
                                                                    if (J(r2(s)) < J(2147483648)) {
                                                                        e = ~~s;
                                                                        break k;
                                                                    }
                                                                    e = -2147483648;
                                                                }
                                                                e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                                break f;
                                                            }
                                                            u = J(u + J(128)), s = J(J(s + J(128)) + J(.5));
                                                            k: {
                                                                if (J(r2(s)) < J(2147483648)) {
                                                                    e = ~~s;
                                                                    break k;
                                                                }
                                                                e = -2147483648;
                                                            }
                                                            e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                        }
                                                        o[V | 0] = e, t = t + r0 | 0, V = r, u = J(u + J(.5));
                                                        f: {
                                                            if (J(r2(u)) < J(2147483648)) {
                                                                e = ~~u;
                                                                break f;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        if (r = (e | 0) >= 255 ? 255 : e, o[V | 0] = (r | 0) > 0 ? r : 0, f = f + 2 | 0, !(R >>> 0 > f >>> 0)) break;
                                                    }
                                                    if (k = k + 2 | 0, !(_ >>> 0 > k >>> 0)) break;
                                                }
                                            }
                                            if (W & 1) {
                                                if (!y) break r;
                                                for(w = h << 1, _ = h + 2 | 0, R = h + 1 | 0, r = L >>> 1 | 0, r0 = r + M | 0, s0 = r + f0 | 0, t = Z(B, L) + $ | 0, f = 0;;){
                                                    e = l[t | 0];
                                                    A: {
                                                        if ((f | 1) >>> 0 < y >>> 0) {
                                                            e = l[t + h | 0] + (e & 255) >>> 1 | 0, k = l[t + _ | 0] + l[t + 2 | 0] >>> 1 | 0, r = l[t + R | 0] + l[t + 1 | 0] >>> 1 | 0;
                                                            break A;
                                                        }
                                                        k = l[t + 2 | 0], r = l[t + 1 | 0];
                                                    }
                                                    s = J((k & 255) >>> 0), F = J((e & 255) >>> 0), C = J((r & 255) >>> 0), u = J(J(s * W0[n + 84 >> 2]) + J(J(F * W0[n + 76 >> 2]) + J(W0[n + 80 >> 2] * C))), s = J(J(s * W0[n + 72 >> 2]) + J(J(F * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * C))), e = f >>> 1 | 0, r = r0 + Z(e, t0) | 0, k = s0 + Z(e, E) | 0;
                                                    A: {
                                                        if (c & 1) {
                                                            u = J(u + J(128)), s = J(J(s + J(128)) + J(.5));
                                                            f: {
                                                                if (J(r2(s)) < J(2147483648)) {
                                                                    e = ~~s;
                                                                    break f;
                                                                }
                                                                e = -2147483648;
                                                            }
                                                            e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                            break A;
                                                        }
                                                        u = J(J(u * J(.875)) + J(128)), s = J(J(J(s * J(.875)) + J(128)) + J(.5));
                                                        f: {
                                                            if (J(r2(s)) < J(2147483648)) {
                                                                e = ~~s;
                                                                break f;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                    }
                                                    o[k | 0] = e, k = r, u = J(u + J(.5));
                                                    A: {
                                                        if (J(r2(u)) < J(2147483648)) {
                                                            e = ~~u;
                                                            break A;
                                                        }
                                                        e = -2147483648;
                                                    }
                                                    if (r = (e | 0) >= 255 ? 255 : e, o[k | 0] = (r | 0) > 0 ? r : 0, t = t + w | 0, f = f + 2 | 0, !(y >>> 0 > f >>> 0)) break;
                                                }
                                            }
                                            if (!(y & 1) | !W) break r;
                                            for(w = B << 1, _ = B + 2 | 0, R = B + 1 | 0, t = Z(h, m0) + $ | 0, r = m0 >>> 1 | 0, M = Z(r, t0) + M | 0, E = Z(r, E) + f0 | 0, f = 0;;){
                                                e = l[t | 0];
                                                A: {
                                                    if ((f | 1) >>> 0 < W >>> 0) {
                                                        e = l[t + B | 0] + (e & 255) >>> 1 | 0, k = l[t + _ | 0] + l[t + 2 | 0] >>> 1 | 0, r = l[t + R | 0] + l[t + 1 | 0] >>> 1 | 0;
                                                        break A;
                                                    }
                                                    k = l[t + 2 | 0], r = l[t + 1 | 0];
                                                }
                                                s = J((k & 255) >>> 0), F = J((e & 255) >>> 0), C = J((r & 255) >>> 0), u = J(J(s * W0[n + 84 >> 2]) + J(J(F * W0[n + 76 >> 2]) + J(W0[n + 80 >> 2] * C))), s = J(J(s * W0[n + 72 >> 2]) + J(J(F * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * C))), e = f >>> 1 | 0, r = e + M | 0, k = e + E | 0;
                                                A: {
                                                    if (c & 1) {
                                                        u = J(u + J(128)), s = J(J(s + J(128)) + J(.5));
                                                        f: {
                                                            if (J(r2(s)) < J(2147483648)) {
                                                                e = ~~s;
                                                                break f;
                                                            }
                                                            e = -2147483648;
                                                        }
                                                        e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                        break A;
                                                    }
                                                    u = J(J(u * J(.875)) + J(128)), s = J(J(J(s * J(.875)) + J(128)) + J(.5));
                                                    f: {
                                                        if (J(r2(s)) < J(2147483648)) {
                                                            e = ~~s;
                                                            break f;
                                                        }
                                                        e = -2147483648;
                                                    }
                                                    e = (e | 0) >= 255 ? 255 : e, e = (e | 0) > 0 ? e : 0;
                                                }
                                                o[k | 0] = e, k = r, u = J(u + J(.5));
                                                A: {
                                                    if (J(r2(u)) < J(2147483648)) {
                                                        e = ~~u;
                                                        break A;
                                                    }
                                                    e = -2147483648;
                                                }
                                                if (r = (e | 0) >= 255 ? 255 : e, o[k | 0] = (r | 0) > 0 ? r : 0, t = t + w | 0, f = f + 2 | 0, !(W >>> 0 > f >>> 0)) break;
                                            }
                                            break r;
                                        }
                                        if (!W | (!y | (r | t ^ 1))) break r;
                                        for(k = B << 1, w = 0, c = c & 1;;){
                                            B = Z(w, t0) + M | 0, _ = Z(w, E) + f0 | 0, t = Z(h, w) + $ | 0, f = 0, e = 0;
                                            A: {
                                                if (!c) for(;;){
                                                    u = W0[n + 84 >> 2], s = W0[n + 76 >> 2], F = W0[n + 80 >> 2], e = f >>> 1 | 0, V = e + _ | 0, C = J(l[t + 2 | 0]), H = J(l[t | 0]), T = J(l[t + 1 | 0]), S = J(J(J(J(J(C * W0[n + 72 >> 2]) + J(J(H * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * T))) * J(.875)) + J(128)) + J(.5));
                                                    f: {
                                                        if (J(r2(S)) < J(2147483648)) {
                                                            r = ~~S;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    r = (r | 0) >= 255 ? 255 : r, o[V | 0] = (r | 0) > 0 ? r : 0, e = e + B | 0, u = J(J(J(J(J(C * u) + J(J(H * s) + J(F * T))) * J(.875)) + J(128)) + J(.5));
                                                    f: {
                                                        if (J(r2(u)) < J(2147483648)) {
                                                            r = ~~u;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    if (r = (r | 0) >= 255 ? 255 : r, o[e | 0] = (r | 0) > 0 ? r : 0, t = k + t | 0, f = f + 2 | 0, !(W >>> 0 > f >>> 0)) break A;
                                                }
                                                for(;;){
                                                    u = W0[n + 84 >> 2], s = W0[n + 76 >> 2], F = W0[n + 80 >> 2], f = e >>> 1 | 0, V = f + _ | 0, C = J(l[t + 2 | 0]), H = J(l[t | 0]), T = J(l[t + 1 | 0]), S = J(J(J(J(C * W0[n + 72 >> 2]) + J(J(H * W0[n + 64 >> 2]) + J(W0[n + 68 >> 2] * T))) + J(128)) + J(.5));
                                                    f: {
                                                        if (J(r2(S)) < J(2147483648)) {
                                                            r = ~~S;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    r = (r | 0) >= 255 ? 255 : r, o[V | 0] = (r | 0) > 0 ? r : 0, f = f + B | 0, u = J(J(J(J(C * u) + J(J(H * s) + J(F * T))) + J(128)) + J(.5));
                                                    f: {
                                                        if (J(r2(u)) < J(2147483648)) {
                                                            r = ~~u;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    if (r = (r | 0) >= 255 ? 255 : r, o[f | 0] = (r | 0) > 0 ? r : 0, t = k + t | 0, e = e + 2 | 0, !(W >>> 0 > e >>> 0)) break;
                                                }
                                            }
                                            if (w = w + 1 | 0, (y | 0) == (w | 0)) break;
                                        }
                                    }
                                    if (!W | (!(q & 1) | !y)) break e;
                                    for(M = $ + 3 | 0, B = W & -4, E = W & 3, w = 0, $ = (Z0 | 0) != 11;;){
                                        r = Z(w, X0);
                                        r: {
                                            A: {
                                                f: {
                                                    if (!$) {
                                                        if (f = M + Z(h, w) | 0, e = 0, t = 0, k = 0, L >>> 0 >= 3) break f;
                                                        break A;
                                                    }
                                                    B0(r + v | 0, 255, W);
                                                    break r;
                                                }
                                                for(; o[(r + t | 0) + v | 0] = l[f + (t << 2) | 0], _ = t | 1, o[(_ + r | 0) + v | 0] = l[f + (_ << 2) | 0], _ = t | 2, o[(_ + r | 0) + v | 0] = l[f + (_ << 2) | 0], _ = t | 3, o[(_ + r | 0) + v | 0] = l[f + (_ << 2) | 0], t = t + 4 | 0, k = k + 4 | 0, (B | 0) != (k | 0););
                                            }
                                            if (!E) break r;
                                            for(; o[(r + t | 0) + v | 0] = l[f + (t << 2) | 0], t = t + 1 | 0, e = e + 1 | 0, (E | 0) != (e | 0););
                                        }
                                        if (w = w + 1 | 0, (y | 0) == (w | 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = G, i[A >> 2] = P, i[G + 4 >> 2] = i[G + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[G + 4 >> 2], i[G + 4 >> 2] = A - 1, A || (p[i[i[G >> 2] + 8 >> 2]](G), g(G)), m = n + 160 | 0;
                        }
                        function p7() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            _r(), h = D(8), s = D(160), i[s >> 2] = 79880, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, f = s + 16 | 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, i[f + 136 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 132 >> 2] = 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 4142, i[f + 16 >> 2] = f + 20, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 4;
                            i: {
                                e: {
                                    if (e = Pe(15880), !e || d1(e, 9361) && d1(e, 16249)) break e;
                                    e = i[19721], i[f + 64 >> 2] = i[19720], i[f + 68 >> 2] = e, e = i[19735], i[f + 120 >> 2] = i[19734], i[f + 124 >> 2] = e, e = i[19733], i[f + 112 >> 2] = i[19732], i[f + 116 >> 2] = e, e = i[19731], i[f + 104 >> 2] = i[19730], i[f + 108 >> 2] = e, e = i[19729], i[f + 96 >> 2] = i[19728], i[f + 100 >> 2] = e, e = i[19727], i[f + 88 >> 2] = i[19726], i[f + 92 >> 2] = e, e = i[19725], i[f + 80 >> 2] = i[19724], i[f + 84 >> 2] = e, e = i[19723], i[f + 72 >> 2] = i[19722];
                                    break i;
                                }
                                e = i[19705], i[f + 64 >> 2] = i[19704], i[f + 68 >> 2] = e, e = i[19719], i[f + 120 >> 2] = i[19718], i[f + 124 >> 2] = e, e = i[19717], i[f + 112 >> 2] = i[19716], i[f + 116 >> 2] = e, e = i[19715], i[f + 104 >> 2] = i[19714], i[f + 108 >> 2] = e, e = i[19713], i[f + 96 >> 2] = i[19712], i[f + 100 >> 2] = e, e = i[19711], i[f + 88 >> 2] = i[19710], i[f + 92 >> 2] = e, e = i[19709], i[f + 80 >> 2] = i[19708], i[f + 84 >> 2] = e, e = i[19707], i[f + 72 >> 2] = i[19706];
                            }
                            i[f + 76 >> 2] = e, k = D(152), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78332, w = f, v = Ye(k + 12 | 0), i[w + 48 >> 2] = v, e = i[f + 52 >> 2], i[f + 52 >> 2] = k;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            if (e = i[f + 48 >> 2], i[e + 136 >> 2] = f - -64, k = m - 16 | 0, m = k, A = i[e + 20 >> 2], n = i[e + 16 >> 2], (A | 0) != (n | 0)) for(;;){
                                r = i[A - 4 >> 2];
                                i: {
                                    if (!r || (t = i[r + 4 >> 2], i[r + 4 >> 2] = t - 1, t)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                if (A = A - 8 | 0, (n | 0) == (A | 0)) break;
                            }
                            i[e + 20 >> 2] = n, A = D(136), i[A >> 2] = 76176, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[r >> 2] = 73880, i[A + 132 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 128 >> 2] = 0, i[A + 116 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 32 >> 2] = 1718909296, i[e + 28 >> 2] = r, r = i[e + 32 >> 2], i[e + 32 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(152), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76256, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74096, i[A + 128 >> 2] = 0, i[A + 132 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 124 >> 2] = 1885954932, i[A + 136 >> 2] = 0, i[A + 140 >> 2] = 0, i[A + 144 >> 2] = 0, i[A + 148 >> 2] = 0, i[A + 32 >> 2] = 1751411826, i[e + 36 >> 2] = r, r = i[e + 40 >> 2], i[e + 40 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(120), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76136, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74024, i[A + 32 >> 2] = 1835365473, i[e + 44 >> 2] = r, r = i[e + 48 >> 2], i[e + 48 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(120), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76496, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[r >> 2] = 74456, i[A + 32 >> 2] = 1768973167, i[e + 52 >> 2] = r, r = i[e + 56 >> 2], i[e + 56 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(136), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76536, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74588, i[A + 128 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 32 >> 2] = 1768975713, i[e + 60 >> 2] = r, r = i[e + 64 >> 2], i[e + 64 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = D(176), i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 76336, A = r + 16 | 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 56 >> 2] = -1, i[A + 60 >> 2] = -1, i[A + 72 >> 2] = 0, i[A + 76 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 136 >> 2] = 0, i[A + 128 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, n = A - -64 | 0, i[n >> 2] = -1, i[n + 4 >> 2] = -1, i[A + 80 >> 2] = 0, i[A + 84 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, Q[A + 96 >> 1] = 0, i[A + 112 >> 2] = 0, i[A + 116 >> 2] = 0, o[A + 117 | 0] = 0, o[A + 118 | 0] = 0, o[A + 119 | 0] = 0, o[A + 120 | 0] = 0, o[A + 121 | 0] = 0, o[A + 122 | 0] = 0, o[A + 123 | 0] = 0, o[A + 124 | 0] = 0, i[A >> 2] = 73452, o[A + 132 | 0] = 0, i[A + 16 >> 2] = 1768714083, i[e + 68 >> 2] = A, A = i[e + 72 >> 2], i[e + 72 >> 2] = r;
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = D(120), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76376, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74312, i[A + 32 >> 2] = 1768517222, i[e + 100 >> 2] = r, r = i[e + 104 >> 2], i[e + 104 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(120), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76456, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[r >> 2] = 74384, i[A + 32 >> 2] = 1768977008, i[e + 116 >> 2] = r, r = i[e + 120 >> 2], i[e + 120 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = D(128), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76296, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74168, i[A + 32 >> 2] = 1885959277, i[A + 120 >> 2] = 0, i[e + 92 >> 2] = r, r = i[e + 96 >> 2], i[e + 96 >> 2] = A;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = i[e + 44 >> 2], n = i[e + 36 >> 2], i[k + 8 >> 2] = n, r = i[e + 40 >> 2], i[k + 12 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = A, r = i[A + 40 >> 2];
                            i: {
                                if (r >>> 0 < k0[A + 44 >> 2]) {
                                    i[r >> 2] = n, A = i[k + 12 >> 2], i[r + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = r + 8 | 0;
                                    break i;
                                }
                                A = P2(A + 36 | 0, k + 8 | 0);
                            }
                            i[t + 40 >> 2] = A, A = i[k + 12 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 44 >> 2], n = i[e + 92 >> 2], i[k + 8 >> 2] = n, r = i[e + 96 >> 2], i[k + 12 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = A, r = i[A + 40 >> 2];
                            i: {
                                if (r >>> 0 < k0[A + 44 >> 2]) {
                                    i[r >> 2] = n, A = i[k + 12 >> 2], i[r + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = r + 8 | 0;
                                    break i;
                                }
                                A = P2(A + 36 | 0, k + 8 | 0);
                            }
                            i[t + 40 >> 2] = A, A = i[k + 12 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 44 >> 2], n = i[e + 68 >> 2], i[k + 8 >> 2] = n, r = i[e + 72 >> 2], i[k + 12 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = A, r = i[A + 40 >> 2];
                            i: {
                                if (r >>> 0 < k0[A + 44 >> 2]) {
                                    i[r >> 2] = n, A = i[k + 12 >> 2], i[r + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = r + 8 | 0;
                                    break i;
                                }
                                A = P2(A + 36 | 0, k + 8 | 0);
                            }
                            i[t + 40 >> 2] = A, A = i[k + 12 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 44 >> 2], n = i[e + 100 >> 2], i[k + 8 >> 2] = n, r = i[e + 104 >> 2], i[k + 12 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = A, r = i[A + 40 >> 2];
                            i: {
                                if (r >>> 0 < k0[A + 44 >> 2]) {
                                    i[r >> 2] = n, A = i[k + 12 >> 2], i[r + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = r + 8 | 0;
                                    break i;
                                }
                                A = P2(A + 36 | 0, k + 8 | 0);
                            }
                            i[t + 40 >> 2] = A, A = i[k + 12 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 44 >> 2], n = i[e + 116 >> 2], i[k + 8 >> 2] = n, r = i[e + 120 >> 2], i[k + 12 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = A, r = i[A + 40 >> 2];
                            i: {
                                if (r >>> 0 < k0[A + 44 >> 2]) {
                                    i[r >> 2] = n, A = i[k + 12 >> 2], i[r + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = r + 8 | 0;
                                    break i;
                                }
                                A = P2(A + 36 | 0, k + 8 | 0);
                            }
                            i[t + 40 >> 2] = A, A = i[k + 12 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            t = i[e + 116 >> 2], u = i[e + 52 >> 2], i[k + 8 >> 2] = u, A = i[e + 56 >> 2], i[k + 12 >> 2] = A;
                            i: {
                                e: {
                                    r: {
                                        if (!A) {
                                            if (n = t + 40 | 0, r = i[t + 40 >> 2], r >>> 0 >= k0[t + 44 >> 2]) break e;
                                            i[r + 4 >> 2] = A, i[r >> 2] = u;
                                            break r;
                                        }
                                        if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, n = t + 40 | 0, r = i[t + 40 >> 2], r >>> 0 >= k0[t + 44 >> 2]) break e;
                                        i[r + 4 >> 2] = A, i[r >> 2] = u, i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                                    }
                                    r = r + 8 | 0;
                                    break i;
                                }
                                r = P2(t + 36 | 0, k + 8 | 0), A = i[k + 12 >> 2];
                            }
                            i[n >> 2] = r;
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            t = i[e + 116 >> 2], u = i[e + 60 >> 2], i[k + 8 >> 2] = u, A = i[e + 64 >> 2], i[k + 12 >> 2] = A;
                            i: {
                                e: {
                                    r: {
                                        if (!A) {
                                            if (n = t + 40 | 0, r = i[t + 40 >> 2], r >>> 0 >= k0[t + 44 >> 2]) break e;
                                            i[r + 4 >> 2] = A, i[r >> 2] = u;
                                            break r;
                                        }
                                        if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, n = t + 40 | 0, r = i[t + 40 >> 2], r >>> 0 >= k0[t + 44 >> 2]) break e;
                                        i[r + 4 >> 2] = A, i[r >> 2] = u, i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                                    }
                                    r = r + 8 | 0;
                                    break i;
                                }
                                r = P2(t + 36 | 0, k + 8 | 0), A = i[k + 12 >> 2];
                            }
                            i[n >> 2] = r;
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            Ar(e + 124 | 0, i[e + 128 >> 2]), i[e + 124 >> 2] = e + 128, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, t = i[e + 28 >> 2], i[k + 8 >> 2] = t, A = i[e + 32 >> 2], i[k + 12 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), n = e + 16 | 0, r = i[e + 20 >> 2];
                            i: {
                                if (r >>> 0 < k0[e + 24 >> 2]) {
                                    i[r + 4 >> 2] = A, i[r >> 2] = t, i[e + 20 >> 2] = r + 8;
                                    break i;
                                }
                                if (r = p2(n, k + 8 | 0), A = i[k + 12 >> 2], i[e + 20 >> 2] = r, !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            t = i[e + 44 >> 2], i[k + 8 >> 2] = t, A = i[e + 48 >> 2], i[k + 12 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), r = i[e + 20 >> 2];
                            i: {
                                if (r >>> 0 < k0[e + 24 >> 2]) {
                                    i[r + 4 >> 2] = A, i[r >> 2] = t, i[e + 20 >> 2] = r + 8;
                                    break i;
                                }
                                if (r = p2(n, k + 8 | 0), A = i[k + 12 >> 2], i[e + 20 >> 2] = r, !A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            if (m = k + 16 | 0, Hi(f + 16 | 0, i[f + 20 >> 2]), i[f + 16 >> 2] = f + 20, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, n = i[f + 32 >> 2], k = i[f + 28 >> 2], (n | 0) != (k | 0)) for(;;){
                                e = i[n - 4 >> 2];
                                i: {
                                    if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (n = n - 8 | 0, (k | 0) == (n | 0)) break;
                            }
                            i[f + 32 >> 2] = k, e = i[f + 44 >> 2], i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            return i[h + 4 >> 2] = s, i[h >> 2] = f, h | 0;
                        }
                        function lh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], k = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, u = f + 16 | 0, T0(k, u), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, B = z0(u), i[B >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), t = n, u = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(t, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(f + 12 | 0, 23710, 23), l[r + 100 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), s = U(P0(U(n, 23687, 22), l[r + 101 | 0]), 21010, 2);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: switch(n = l[r + 101 | 0], n - 66 | 0){
                                                                            case 56:
                                                                                break n;
                                                                            case 44:
                                                                                break t;
                                                                            case 34:
                                                                                break o;
                                                                            case 22:
                                                                                break s;
                                                                            case 11:
                                                                                break u;
                                                                            case 0:
                                                                                break r;
                                                                            case 1:
                                                                            case 2:
                                                                            case 3:
                                                                            case 4:
                                                                            case 5:
                                                                            case 6:
                                                                            case 7:
                                                                            case 8:
                                                                            case 9:
                                                                            case 10:
                                                                            case 12:
                                                                            case 13:
                                                                            case 14:
                                                                            case 15:
                                                                            case 16:
                                                                            case 17:
                                                                            case 18:
                                                                            case 19:
                                                                            case 20:
                                                                            case 21:
                                                                            case 23:
                                                                            case 24:
                                                                            case 25:
                                                                            case 26:
                                                                            case 27:
                                                                            case 28:
                                                                            case 29:
                                                                            case 30:
                                                                            case 31:
                                                                            case 32:
                                                                            case 33:
                                                                            case 35:
                                                                            case 36:
                                                                            case 37:
                                                                            case 38:
                                                                            case 39:
                                                                            case 40:
                                                                            case 41:
                                                                            case 42:
                                                                            case 43:
                                                                            case 45:
                                                                            case 46:
                                                                            case 47:
                                                                            case 48:
                                                                            case 49:
                                                                            case 50:
                                                                            case 51:
                                                                            case 52:
                                                                            case 53:
                                                                            case 54:
                                                                            case 55:
                                                                                break f;
                                                                            default:
                                                                                break w;
                                                                        }
                                                                        if ((n | 0) == 244) break k;
                                                                        if ((n | 0) != 44) break f;
                                                                        n = D(16), i[f >> 2] = n, i[f + 4 >> 2] = 11, i[f + 8 >> 2] = -2147483632, k = l[17782] | l[17783] << 8 | (l[17784] << 16 | l[17785] << 24), u = l[17778] | l[17779] << 8 | (l[17780] << 16 | l[17781] << 24), o[n | 0] = u, o[n + 1 | 0] = u >>> 8, o[n + 2 | 0] = u >>> 16, o[n + 3 | 0] = u >>> 24, o[n + 4 | 0] = k, o[n + 5 | 0] = k >>> 8, o[n + 6 | 0] = k >>> 16, o[n + 7 | 0] = k >>> 24, k = l[17785] | l[17786] << 8 | (l[17787] << 16 | l[17788] << 24), o[n + 7 | 0] = k, o[n + 8 | 0] = k >>> 8, o[n + 9 | 0] = k >>> 16, o[n + 10 | 0] = k >>> 24, k = n + 11 | 0;
                                                                        break e;
                                                                    }
                                                                    i[f >> 2] = 1852399949, o[f + 11 | 0] = 4, k = 4;
                                                                    break A;
                                                                }
                                                                i[f >> 2] = 1702131781, i[f + 4 >> 2] = 1684366446, o[f + 11 | 0] = 8, k = 8;
                                                                break A;
                                                            }
                                                            n = D(16), i[f >> 2] = n, i[f + 4 >> 2] = 12, i[f + 8 >> 2] = -2147483632, k = l[3409] | l[3410] << 8 | (l[3411] << 16 | l[3412] << 24), u = l[3405] | l[3406] << 8 | (l[3407] << 16 | l[3408] << 24), o[n | 0] = u, o[n + 1 | 0] = u >>> 8, o[n + 2 | 0] = u >>> 16, o[n + 3 | 0] = u >>> 24, o[n + 4 | 0] = k, o[n + 5 | 0] = k >>> 8, o[n + 6 | 0] = k >>> 16, o[n + 7 | 0] = k >>> 24, k = l[3413] | l[3414] << 8 | (l[3415] << 16 | l[3416] << 24), o[n + 8 | 0] = k, o[n + 9 | 0] = k >>> 8, o[n + 10 | 0] = k >>> 16, o[n + 11 | 0] = k >>> 24, k = n + 12 | 0;
                                                            break e;
                                                        }
                                                        o[f + 11 | 0] = 7, i[f >> 2] = l[18337] | l[18338] << 8 | (l[18339] << 16 | l[18340] << 24), n = l[18340] | l[18341] << 8 | (l[18342] << 16 | l[18343] << 24), o[f + 3 | 0] = n, o[f + 4 | 0] = n >>> 8, o[f + 5 | 0] = n >>> 16, o[f + 6 | 0] = n >>> 24, k = 7;
                                                        break A;
                                                    }
                                                    Q[f + 8 >> 1] = l[17933] | l[17934] << 8, o[f + 11 | 0] = 10, n = l[17929] | l[17930] << 8 | (l[17931] << 16 | l[17932] << 24), i[f >> 2] = l[17925] | l[17926] << 8 | (l[17927] << 16 | l[17928] << 24), i[f + 4 >> 2] = n, k = 10;
                                                    break A;
                                                }
                                                Q[f + 8 >> 1] = l[17775] | l[17776] << 8, o[f + 11 | 0] = 10, n = l[17771] | l[17772] << 8 | (l[17773] << 16 | l[17774] << 24), i[f >> 2] = l[17767] | l[17768] << 8 | (l[17769] << 16 | l[17770] << 24), i[f + 4 >> 2] = n, k = 10;
                                                break A;
                                            }
                                            o[f + 11 | 0] = 7, i[f >> 2] = l[6583] | l[6584] << 8 | (l[6585] << 16 | l[6586] << 24), n = l[6586] | l[6587] << 8 | (l[6588] << 16 | l[6589] << 24), o[f + 3 | 0] = n, o[f + 4 | 0] = n >>> 8, o[f + 5 | 0] = n >>> 16, o[f + 6 | 0] = n >>> 24, k = 7;
                                        }
                                        o[k + f | 0] = 0, n = f;
                                        break i;
                                    }
                                    n = D(24), i[f >> 2] = n, i[f + 4 >> 2] = 20, i[f + 8 >> 2] = -2147483624, k = l[10510] | l[10511] << 8 | (l[10512] << 16 | l[10513] << 24), u = l[10506] | l[10507] << 8 | (l[10508] << 16 | l[10509] << 24), o[n | 0] = u, o[n + 1 | 0] = u >>> 8, o[n + 2 | 0] = u >>> 16, o[n + 3 | 0] = u >>> 24, o[n + 4 | 0] = k, o[n + 5 | 0] = k >>> 8, o[n + 6 | 0] = k >>> 16, o[n + 7 | 0] = k >>> 24, k = l[10522] | l[10523] << 8 | (l[10524] << 16 | l[10525] << 24), o[n + 16 | 0] = k, o[n + 17 | 0] = k >>> 8, o[n + 18 | 0] = k >>> 16, o[n + 19 | 0] = k >>> 24, k = l[10518] | l[10519] << 8 | (l[10520] << 16 | l[10521] << 24), u = l[10514] | l[10515] << 8 | (l[10516] << 16 | l[10517] << 24), o[n + 8 | 0] = u, o[n + 9 | 0] = u >>> 8, o[n + 10 | 0] = u >>> 16, o[n + 11 | 0] = u >>> 24, o[n + 12 | 0] = k, o[n + 13 | 0] = k >>> 8, o[n + 14 | 0] = k >>> 16, o[n + 15 | 0] = k >>> 24, k = n + 20 | 0;
                                }
                                o[k | 0] = 0, k = i[f + 4 >> 2];
                            }
                            n = U(U(s, n, k), 34894, 2), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 22611, 23), l[r + 102 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 23666, 20), l[r + 103 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(n, 23008, 15), o[f + 11 | 0] < 0 && X(i[f >> 2]);
                            i: {
                                e: switch(i[r + 108 >> 2]){
                                    case 0:
                                        U(f + 12 | 0, 34138, 6);
                                        break i;
                                    case 1:
                                        U(f + 12 | 0, 34131, 6);
                                        break i;
                                    case 2:
                                        U(f + 12 | 0, 34124, 6);
                                        break i;
                                    case 3:
                                        U(f + 12 | 0, 34117, 6);
                                        break i;
                                    default:
                                        break e;
                                }
                                U(f + 12 | 0, 25798, 12);
                            }
                            n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(f + 12 | 0, 24860, 16), l[r + 112 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(n, 24896, 18), l[r + 113 | 0]), 34895, 1);
                            i: {
                                if (u = i[r + 116 >> 2], C = i[r + 120 >> 2], (u | 0) != (C | 0)) for(V = f + 24 | 0;;){
                                    n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 24946, 5);
                                    e: {
                                        if (n = i[u >> 2], G = i[u + 4 >> 2], (n | 0) == (G | 0)) break e;
                                        for(;;){
                                            h = l[n | 0], k = i[f + 12 >> 2], s = i[k - 12 >> 2] + (f + 12 | 0) | 0, i[s + 76 >> 2] == -1 && (t = f + 148 | 0, k = i[s + 28 >> 2], i[t >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(t, 108580), p[i[i[k >> 2] + 28 >> 2]](k, 32), d0(t), k = i[f + 12 >> 2]), i[s + 76 >> 2] = 48, k = k - 12 | 0, i[V + i[k >> 2] >> 2] = 2, k = i[k >> 2] + B | 0, i[k >> 2] = i[k >> 2] & -75 | 8;
                                            r: {
                                                v = P0(f + 12 | 0, h), W = C1(f, v);
                                                A: {
                                                    if (l[W | 0] != 1) break A;
                                                    w = v + i[i[v >> 2] - 12 >> 2] | 0, t = i[w + 4 >> 2], h = i[w + 24 >> 2], k = i[w + 76 >> 2], (k | 0) == -1 && (s = f + 148 | 0, k = i[w + 28 >> 2], i[s >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(s, 108580), k = p[i[i[k >> 2] + 28 >> 2]](k, 32) | 0, d0(s), i[w + 76 >> 2] = k);
                                                    f: {
                                                        if (!h || (s = i[w + 12 >> 2], _ = (t & 176) == 32 ? 25194 : 25193, t = _ - 25193 | 0, (t | 0) > 0 && (p[i[i[h >> 2] + 48 >> 2]](h, 25193, t) | 0) != (t | 0))) break f;
                                                        if (t = (s | 0) > 1 ? s - 1 | 0 : 0, (t | 0) > 0) {
                                                            if (t >>> 0 >= 2147483640) break r;
                                                            k: {
                                                                if (t >>> 0 >= 11) {
                                                                    y = (t | 7) + 1 | 0, s = D(y), i[f + 156 >> 2] = y | -2147483648, i[f + 148 >> 2] = s, i[f + 152 >> 2] = t;
                                                                    break k;
                                                                }
                                                                o[f + 159 | 0] = t, s = f + 148 | 0;
                                                            }
                                                            if (F = B0(s, k, t) + t | 0, E = 0, o[F | 0] = E, k = p[i[i[h >> 2] + 48 >> 2]](h, o[f + 159 | 0] < 0 ? i[f + 148 >> 2] : f + 148 | 0, t) | 0, o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), (k | 0) != (t | 0)) break f;
                                                        }
                                                        if (k = 25194 - _ | 0, (k | 0) > 0 && (p[i[i[h >> 2] + 48 >> 2]](h, _, k) | 0) != (k | 0)) break f;
                                                        i[w + 12 >> 2] = 0;
                                                        break A;
                                                    }
                                                    k = v + i[i[v >> 2] - 12 >> 2] | 0, N1(k, i[k + 16 >> 2] | 5);
                                                }
                                                if (G1(W), n = n + 1 | 0, (G | 0) == (n | 0)) break e;
                                                continue;
                                            }
                                            break;
                                        }
                                        break i;
                                    }
                                    if (U(f + 12 | 0, 34895, 1), n = i[i[f + 12 >> 2] - 12 >> 2] + B | 0, i[n >> 2] = i[n >> 2] & -75 | 2, u = u + 12 | 0, (C | 0) == (u | 0)) break;
                                }
                                if (u = i[r + 140 >> 2], C = i[r + 144 >> 2], (u | 0) != (C | 0)) for(V = f + 24 | 0;;){
                                    n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 24936, 9);
                                    e: {
                                        if (n = i[u >> 2], G = i[u + 4 >> 2], (n | 0) == (G | 0)) break e;
                                        for(;;){
                                            h = l[n | 0], k = i[f + 12 >> 2], s = i[k - 12 >> 2] + (f + 12 | 0) | 0, i[s + 76 >> 2] == -1 && (t = f + 148 | 0, k = i[s + 28 >> 2], i[t >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(t, 108580), p[i[i[k >> 2] + 28 >> 2]](k, 32), d0(t), k = i[f + 12 >> 2]), i[s + 76 >> 2] = 48, k = k - 12 | 0, i[V + i[k >> 2] >> 2] = 2, k = i[k >> 2] + B | 0, i[k >> 2] = i[k >> 2] & -75 | 8;
                                            r: {
                                                v = P0(f + 12 | 0, h), W = C1(f, v);
                                                A: {
                                                    if (l[W | 0] != 1) break A;
                                                    w = v + i[i[v >> 2] - 12 >> 2] | 0, t = i[w + 4 >> 2], h = i[w + 24 >> 2], k = i[w + 76 >> 2], (k | 0) == -1 && (s = f + 148 | 0, k = i[w + 28 >> 2], i[s >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(s, 108580), k = p[i[i[k >> 2] + 28 >> 2]](k, 32) | 0, d0(s), i[w + 76 >> 2] = k);
                                                    f: {
                                                        if (!h || (s = i[w + 12 >> 2], _ = (t & 176) == 32 ? 25194 : 25193, t = _ - 25193 | 0, (t | 0) > 0 && (p[i[i[h >> 2] + 48 >> 2]](h, 25193, t) | 0) != (t | 0))) break f;
                                                        if (t = (s | 0) > 1 ? s - 1 | 0 : 0, (t | 0) > 0) {
                                                            if (t >>> 0 >= 2147483640) break r;
                                                            k: {
                                                                if (t >>> 0 >= 11) {
                                                                    y = (t | 7) + 1 | 0, s = D(y), i[f + 156 >> 2] = y | -2147483648, i[f + 148 >> 2] = s, i[f + 152 >> 2] = t;
                                                                    break k;
                                                                }
                                                                o[f + 159 | 0] = t, s = f + 148 | 0;
                                                            }
                                                            if (F = B0(s, k, t) + t | 0, E = 0, o[F | 0] = E, k = p[i[i[h >> 2] + 48 >> 2]](h, o[f + 159 | 0] < 0 ? i[f + 148 >> 2] : f + 148 | 0, t) | 0, o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), (k | 0) != (t | 0)) break f;
                                                        }
                                                        if (k = 25194 - _ | 0, (k | 0) > 0 && (p[i[i[h >> 2] + 48 >> 2]](h, _, k) | 0) != (k | 0)) break f;
                                                        i[w + 12 >> 2] = 0;
                                                        break A;
                                                    }
                                                    k = v + i[i[v >> 2] - 12 >> 2] | 0, N1(k, i[k + 16 >> 2] | 5);
                                                }
                                                if (G1(W), n = n + 1 | 0, (G | 0) == (n | 0)) break e;
                                                continue;
                                            }
                                            break;
                                        }
                                        break i;
                                    }
                                    if (U(f + 12 | 0, 34895, 1), n = i[i[f + 12 >> 2] - 12 >> 2] + B | 0, i[n >> 2] = i[n >> 2] & -75 | 2, u = u + 12 | 0, (C | 0) == (u | 0)) break;
                                }
                                if (u = i[r + 128 >> 2], _ = i[r + 132 >> 2], (u | 0) != (_ | 0)) for(C = f + 24 | 0;;){
                                    r = f + 148 | 0, G0(r, e), k = r, r = o[f + 159 | 0], n = (r | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : k, n ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 24952, 5);
                                    e: {
                                        if (n = i[u >> 2], V = i[u + 4 >> 2], (n | 0) == (V | 0)) break e;
                                        for(;;){
                                            t = l[n | 0], k = i[f + 12 >> 2], s = i[k - 12 >> 2] + (f + 12 | 0) | 0, i[s + 76 >> 2] == -1 && (k = f + 148 | 0, r = i[s + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108580), p[i[i[r >> 2] + 28 >> 2]](r, 32), d0(k), k = i[f + 12 >> 2]), i[s + 76 >> 2] = 48, r = k - 12 | 0, i[C + i[r >> 2] >> 2] = 2, r = i[r >> 2] + B | 0, i[r >> 2] = i[r >> 2] & -75 | 8;
                                            r: {
                                                w = P0(f + 12 | 0, t), G = C1(f, w);
                                                A: {
                                                    if (l[G | 0] != 1) break A;
                                                    h = w + i[i[w >> 2] - 12 >> 2] | 0, v = i[h + 4 >> 2], t = i[h + 24 >> 2], k = i[h + 76 >> 2], (k | 0) == -1 && (s = f + 148 | 0, r = i[h + 28 >> 2], i[s >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(s, 108580), k = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(s), i[h + 76 >> 2] = k);
                                                    f: {
                                                        if (!t || (r = i[h + 12 >> 2], v = (v & 176) == 32 ? 25194 : 25193, s = v - 25193 | 0, (s | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, 25193, s) | 0) != (s | 0))) break f;
                                                        if (r = (r | 0) > 1 ? r - 1 | 0 : 0, (r | 0) > 0) {
                                                            if (r >>> 0 >= 2147483640) break r;
                                                            k: {
                                                                if (r >>> 0 >= 11) {
                                                                    W = (r | 7) + 1 | 0, s = D(W), i[f + 156 >> 2] = W | -2147483648, i[f + 148 >> 2] = s, i[f + 152 >> 2] = r;
                                                                    break k;
                                                                }
                                                                o[f + 159 | 0] = r, s = f + 148 | 0;
                                                            }
                                                            if (F = B0(s, k, r) + r | 0, E = 0, o[F | 0] = E, k = p[i[i[t >> 2] + 48 >> 2]](t, o[f + 159 | 0] < 0 ? i[f + 148 >> 2] : f + 148 | 0, r) | 0, o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), (r | 0) != (k | 0)) break f;
                                                        }
                                                        if (r = 25194 - v | 0, (r | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, v, r) | 0) != (r | 0)) break f;
                                                        i[h + 12 >> 2] = 0;
                                                        break A;
                                                    }
                                                    r = w + i[i[w >> 2] - 12 >> 2] | 0, N1(r, i[r + 16 >> 2] | 5);
                                                }
                                                if (G1(G), n = n + 1 | 0, (V | 0) == (n | 0)) break e;
                                                continue;
                                            }
                                            break;
                                        }
                                        break i;
                                    }
                                    if (U(f + 12 | 0, 34895, 1), r = i[i[f + 12 >> 2] - 12 >> 2] + B | 0, i[r >> 2] = i[r >> 2] & -75 | 2, u = u + 12 | 0, (_ | 0) == (u | 0)) break;
                                }
                                r = i[f + 64 >> 2];
                                e: {
                                    r: {
                                        if (r & 16) {
                                            k = f + 36 | 0, e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 ? i[f + 60 >> 2] = r : r = e;
                                            break r;
                                        }
                                        if (!(r & 8)) {
                                            n = 0, o[A + 11 | 0] = 0;
                                            break e;
                                        }
                                        k = f + 24 | 0, r = i[f + 32 >> 2];
                                    }
                                    r: {
                                        if (e = i[k >> 2], n = r - e | 0, n >>> 0 < 2147483640) {
                                            if (n >>> 0 >= 11) {
                                                k = (n | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = n, A = r;
                                                break r;
                                            }
                                            if (o[A + 11 | 0] = n, n) break r;
                                            n = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(A, e, n);
                                }
                                o[A + n | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[B >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(B), N0(f + 68 | 0), m = f + 160 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Ai(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            w = m - 32 | 0, m = w, l[87597] == 1 && (i[w + 16 >> 2] = A, n8(25278, w + 16 | 0));
                            i: {
                                k = i[A + 4 >> 2];
                                e: {
                                    if (k) {
                                        if (n = i[k >> 2], (n | 0) == 1) {
                                            k = i[A >> 2];
                                            break e;
                                        }
                                        if ((n | 0) <= 1) break i;
                                        i[k >> 2] = n - 1;
                                    }
                                    l[87597] == 1 && (i[w >> 2] = A, n8(34869, w)), k = D(172), i[A >> 2] = k, B0(k, 0, 172), s = A, A = D(4), i[s + 4 >> 2] = A, i[A >> 2] = 1;
                                }
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: {
                                                                            l: {
                                                                                h: {
                                                                                    v: {
                                                                                        _: {
                                                                                            if ((r | 0) <= 0) {
                                                                                                A = (e | 0) >= 51 ? 51 : e, n = (A | 0) > 0 ? A : 0;
                                                                                                break _;
                                                                                            }
                                                                                            if (t = r - 1 | 0, f = Z(t, 12) + 46704 | 0, A = i[f >> 2], e = (e | 0) >= 51 ? 51 : e, n = (e | 0) > 0 ? e : 0, A = ((A << 3 & 120) + (Z(n, Z(A >> 4, 5) - 45 | 0) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 5 | 0, (s & 127) >>> 0 >= 63 || (o[k + 5 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 6 | 0, (s & 127) >>> 0 > 62) || (o[k + 6 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 7 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                            if (o[k + 7 | 0] = A, A = t << 2, e = i[A + 46728 >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, f = e ? f ^ 64 : 63 - f | 0, e = f << 1 | e, (f & 127) >>> 0 >= 63) break v;
                                                                                            if (o[k + 149 | 0] = e, e = i[A + 46736 >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, f = e ? f ^ 64 : 63 - f | 0, e = f << 1 | e, (f & 127) >>> 0 >= 63) break h;
                                                                                            if (o[k + 147 | 0] = e, A = i[A + 46744 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, e = A ? e ^ 64 : 63 - e | 0, A = e << 1 | A, (e & 127) >>> 0 >= 63) break l;
                                                                                            if (o[k + 148 | 0] = A, A = Z(n, -20) >> 4, e = (A | 0) > -41, f = e ? A + 104 ^ 64 : -41 - A | 0, A = e | f << 1, e = k + 156 | 0, (f & 127) >>> 0 >= 63 || (o[k + 156 | 0] = A, f = Z(n, -25) >> 4, t = -41 - f | 0, v = f + 104 ^ 64, s = (f | 0) > -41, A = s, u = A ? v : t, A = u << 1 | A, e = k + 157 | 0, (u & 127) >>> 0 > 62) || (o[k + 157 | 0] = A, A = Z(n, -30) >> 4, e = (A | 0) > -41, u = e ? A + 104 ^ 64 : -41 - A | 0, A = e | u << 1, e = k + 158 | 0, (u & 127) >>> 0 > 62) || (o[k + 158 | 0] = A, A = Z(n, -40) >> 4, e = (A | 0) <= -103 ? -103 : A, A = (A | 0) > -41, u = A ? e + 104 ^ 64 : -41 - e | 0, A = u << 1 | A, e = k + 159 | 0, (u & 127) >>> 0 > 62) || (A = Z(A & 255, 257), o[k + 159 | 0] = A, o[k + 160 | 0] = A >>> 8, o[k + 154 | 0] = 14, o[k + 155 | 0] = 14, u = (((r | 0) != 1) << 3) + 46752 | 0, A = i[u >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, h = A ? e ^ 64 : 63 - e | 0, A = h << 1 | A, e = k + 150 | 0, (h & 127) >>> 0 >= 63) || (o[k + 150 | 0] = A, A = i[u + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, u = A ? e ^ 64 : 63 - e | 0, A = u << 1 | A, e = k + 151 | 0, (u & 127) >>> 0 > 62)) break k;
                                                                                            if (o[k + 151 | 0] = A, o[k + 152 | 0] = 30 - (Z(n, 5) >>> 3 & 254), e = s ? v : t, A = s | e << 1, (e & 127) >>> 0 > 62) break w;
                                                                                            if (o[k + 153 | 0] = A, A = Z(n, -5) >> 4, e = (A | 0) > -9, f = e ? A + 72 ^ 64 : -9 - A | 0, A = e | f << 1, (f & 127) >>> 0 >= 63) break u;
                                                                                            A = Z(A & 255, 16843009), o[k + 143 | 0] = A, o[k + 144 | 0] = A >>> 8, o[k + 145 | 0] = A >>> 16, o[k + 146 | 0] = A >>> 24;
                                                                                        }
                                                                                        if (t = Z(r, 12), f = t + 46768 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 2 | 0, (s & 127) >>> 0 >= 63 || (o[k + 2 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 3 | 0, (s & 127) >>> 0 > 62) || (o[k + 3 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 4 | 0, (f & 127) >>> 0 > 62) || (o[k + 4 | 0] = A, f = (((r | 0) == 2 ? 5 : r) << 2) + 46816 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 8 | 0, (s & 127) >>> 0 >= 63) || (o[k + 8 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 9 | 0, (s & 127) >>> 0 > 62) || (o[k + 9 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, s = A ? e ^ 64 : 63 - e | 0, A = s << 1 | A, e = k + 10 | 0, (s & 127) >>> 0 > 62) || (o[k + 10 | 0] = A, A = i[f + 12 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 11 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                        if (o[k + 11 | 0] = A, s = r << 2, e = s, A = i[e + 46852 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (A | 0) >= 126 ? 126 : A, f = (f | 0) <= 1 ? 1 : f, A = (A | 0) > 63, f = A ? f ^ 64 : 63 - f | 0, A = f << 1 | A, (f & 127) >>> 0 >= 63) break s;
                                                                                        if (o[k + 12 | 0] = A, A = i[e + 46864 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, e = A ? e ^ 64 : 63 - e | 0, A = e << 1 | A, (e & 127) >>> 0 >= 63) break o;
                                                                                        if (o[k + 13 | 0] = A, f = (((r | 0) != 0) << 3) + 46880 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, u = A ? e ^ 64 : 63 - e | 0, A = u << 1 | A, e = k + 14 | 0, (u & 127) >>> 0 >= 63 || (o[k + 14 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 15 | 0, (f & 127) >>> 0 > 62) || (o[k + 15 | 0] = A, f = (r << 4) + 46896 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, u = A ? e ^ 64 : 63 - e | 0, A = u << 1 | A, e = k + 16 | 0, (u & 127) >>> 0 >= 63) || (o[k + 16 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, u = A ? e ^ 64 : 63 - e | 0, A = u << 1 | A, e = k + 17 | 0, (u & 127) >>> 0 > 62) || (o[k + 17 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, u = A ? e ^ 64 : 63 - e | 0, A = u << 1 | A, e = k + 18 | 0, (u & 127) >>> 0 > 62) || (o[k + 18 | 0] = A, A = i[f + 12 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 19 | 0, (f & 127) >>> 0 > 62) || (o[k + 19 | 0] = A, f = t + 46944 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 20 | 0, (t & 127) >>> 0 >= 63) || (o[k + 20 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 21 | 0, (t & 127) >>> 0 > 62) || (o[k + 21 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 22 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                        for(o[k + 22 | 0] = A, u = k + 25 | 0, t = Z(r, 72) + 46992 | 0, A = 0;;){
                                                                                            if (e = i[t + (A << 2) >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, h = e ? f ^ 64 : 63 - f | 0, f = h << 1 | e, e = A + u | 0, (h & 127) >>> 0 >= 63) break f;
                                                                                            if (o[e | 0] = f, A = A + 1 | 0, (A | 0) == 18) break;
                                                                                        }
                                                                                        for(u = k + 43 | 0, A = 0;;){
                                                                                            if (e = i[t + (A << 2) >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, h = e ? f ^ 64 : 63 - f | 0, f = h << 1 | e, e = A + u | 0, (h & 127) >>> 0 >= 63) break f;
                                                                                            if (o[e | 0] = f, A = A + 1 | 0, (A | 0) == 18) break;
                                                                                        }
                                                                                        if (f = (s << 2) + 47216 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 61 | 0, (t & 127) >>> 0 >= 63 || (o[k + 61 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 62 | 0, (t & 127) >>> 0 > 62) || (o[k + 62 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 63 | 0, (t & 127) >>> 0 > 62) || (o[k + 63 | 0] = A, A = i[f + 12 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k - -64 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                        for(o[e | 0] = A, t = k + 65 | 0, s = Z(r, 168) + 47264 | 0, A = 0;;){
                                                                                            if (e = i[s + (A << 2) >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, u = e ? f ^ 64 : 63 - f | 0, e = u << 1 | e, f = A + t | 0, (u & 127) >>> 0 >= 63) break A;
                                                                                            if (o[f | 0] = e, A = A + 1 | 0, (A | 0) == 42) break;
                                                                                        }
                                                                                        if (f = (r << 3) + 47776 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 107 | 0, (t & 127) >>> 0 >= 63 || (o[k + 107 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 108 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                        for(o[k + 108 | 0] = A, t = k + 109 | 0, s = Z(r, 96) + 47808 | 0, A = 0;;){
                                                                                            if (e = i[s + (A << 2) >> 2], e = ((e << 3 & 120) + (Z(Z(e >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, f = (e | 0) >= 126 ? 126 : e, f = (f | 0) <= 1 ? 1 : f, e = (e | 0) > 63, u = e ? f ^ 64 : 63 - f | 0, e = u << 1 | e, f = A + t | 0, (u & 127) >>> 0 >= 63) break A;
                                                                                            if (o[f | 0] = e, A = A + 1 | 0, (A | 0) == 24) break;
                                                                                        }
                                                                                        if (f = Z(r, 24) + 48096 | 0, A = i[f >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 133 | 0, (t & 127) >>> 0 >= 63 || (o[k + 133 | 0] = A, A = i[f + 4 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 134 | 0, (t & 127) >>> 0 > 62) || (o[k + 134 | 0] = A, A = i[f + 8 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 135 | 0, (t & 127) >>> 0 > 62) || (o[k + 135 | 0] = A, A = i[f + 12 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 136 | 0, (t & 127) >>> 0 > 62) || (o[k + 136 | 0] = A, A = i[f + 16 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, t = A ? e ^ 64 : 63 - e | 0, A = t << 1 | A, e = k + 137 | 0, (t & 127) >>> 0 > 62) || (o[k + 137 | 0] = A, A = i[f + 20 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, e = (A | 0) >= 126 ? 126 : A, e = (e | 0) <= 1 ? 1 : e, A = (A | 0) > 63, f = A ? e ^ 64 : 63 - e | 0, A = f << 1 | A, e = k + 138 | 0, (f & 127) >>> 0 > 62)) break k;
                                                                                        if (o[k + 138 | 0] = A, o[k | 0] = 14, A = i[(r << 2) + 48168 >> 2], A = ((A << 3 & 120) + (Z(Z(A >> 4, 5) - 45 | 0, n) >> 4) | 0) - 16 | 0, r = (A | 0) >= 126 ? 126 : A, r = (r | 0) <= 1 ? 1 : r, A = (A | 0) > 63, r = A ? r ^ 64 : 63 - r | 0, A = r << 1 | A, (r & 127) >>> 0 >= 63) break t;
                                                                                        if (o[k + 1 | 0] = A, o[k + 139 | 0] = 1, o[k + 140 | 0] = 1, A = Z(n, -5) >> 4, r = (A | 0) >= 54 ? 54 : A, r = (r | 0) <= -71 ? -71 : r, A = (A | 0) > -9, r = A ? r + 72 ^ 64 : -9 - r | 0, A = r << 1 | A, (r & 127) >>> 0 <= 62) break n;
                                                                                        o[k + 141 | 0] = A;
                                                                                        break r;
                                                                                    }
                                                                                    o[k + 149 | 0] = e;
                                                                                    break r;
                                                                                }
                                                                                o[k + 147 | 0] = e;
                                                                                break r;
                                                                            }
                                                                            o[k + 148 | 0] = A;
                                                                            break r;
                                                                        }
                                                                        o[k + 153 | 0] = A;
                                                                        break r;
                                                                    }
                                                                    o[k + 143 | 0] = A;
                                                                    break r;
                                                                }
                                                                o[k + 12 | 0] = A;
                                                                break r;
                                                            }
                                                            o[k + 13 | 0] = A;
                                                            break r;
                                                        }
                                                        o[k + 1 | 0] = A;
                                                        break r;
                                                    }
                                                    A = Z(A & 255, 257), o[k + 141 | 0] = A, o[k + 142 | 0] = A >>> 8, o[k + 170 | 0] = 1, o[k + 171 | 0] = 1, o[k + 162 | 0] = 1, o[k + 163 | 0] = 1, o[k + 164 | 0] = 1, o[k + 165 | 0] = 1, o[k + 166 | 0] = 1, o[k + 167 | 0] = 1, o[k + 168 | 0] = 1, o[k + 169 | 0] = 1, o[k + 161 | 0] = 1, o[k + 23 | 0] = 1, o[k + 24 | 0] = 1;
                                                    break e;
                                                }
                                                o[e | 0] = A;
                                                break r;
                                            }
                                            o[e | 0] = f;
                                            break r;
                                        }
                                        o[f | 0] = e;
                                    }
                                    y0(17936, 15014, 212, 9942), z();
                                }
                                m = w + 32 | 0;
                                return;
                            }
                            y0(18117, 15014, 177, 15158), z();
                        }
                        function sh(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            h = m - 80 | 0, m = h;
                            i: {
                                if (!n) {
                                    if (o[h + 4 | 0] = 0, o[h + 15 | 0] = 0, e = A, A = i0(h + 32 | 0, 5, 2001, h + 4 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[h + 15 | 0] >= 0) break i;
                                    X(i[h + 4 >> 2]);
                                    break i;
                                }
                                if (!k) {
                                    if (o[h + 4 | 0] = 0, o[h + 15 | 0] = 0, e = A, A = i0(h + 32 | 0, 5, 2006, h + 4 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[h + 15 | 0] >= 0) break i;
                                    X(i[h + 4 >> 2]);
                                    break i;
                                }
                                i[h + 76 >> 2] = 0, i[h + 68 >> 2] = 0, i[h + 72 >> 2] = 0, w = n, n = k << 2, y = w + n | 0, _ = k;
                                e: {
                                    if ((k | 0) <= 0) break e;
                                    if (C = i[h + 76 >> 2], V = i[h + 72 >> 2], C - V >> 2 >= (k | 0)) {
                                        C = V >> 2;
                                        r: {
                                            if ((C | 0) >= (k | 0)) {
                                                W = n + w | 0, k = V;
                                                break r;
                                            }
                                            if (W = w + V | 0, k = y - W | 0, (W | 0) != (y | 0) && Q0(V, W, k), k = k + V | 0, i[h + 72 >> 2] = k, (C | 0) <= 0) break e;
                                        }
                                        if (n = k, C = _ << 2, G = k - C | 0, V >>> 0 > G >>> 0) for(; i[n >> 2] = i[G >> 2], n = n + 4 | 0, G = G + 4 | 0, V >>> 0 > G >>> 0;);
                                        if (i[h + 72 >> 2] = n, (k | 0) != (C | 0) && (n = k, k = k - C | 0, Q0(n - k | 0, 0, k)), (w | 0) == (W | 0)) break e;
                                        Q0(0, w, W - w | 0);
                                        break e;
                                    }
                                    r: {
                                        if (W = i[h + 68 >> 2], y = _ + (V - W >> 2) | 0, y >>> 0 < 1073741824) {
                                            if (n = C - W | 0, k = n >> 1, E = n >>> 0 >= 2147483644 ? 1073741823 : k >>> 0 > y >>> 0 ? k : y, E) {
                                                if (E >>> 0 >= 1073741824) break r;
                                                k = D(E << 2);
                                            } else k = 0;
                                            if (y = 0 - W | 0, n = _ << 2, C = y + n | 0, G = v0(k + (y & -4) | 0, w, n), W) for(n = 0; G = G - 4 | 0, n = n - 4 | 0, i[G >> 2] = i[n >> 2], (n | 0) != (W | 0););
                                            n = k + C | 0, V && Q0(n, 0, V), i[h + 76 >> 2] = k + (E << 2), i[h + 68 >> 2] = G, i[h + 72 >> 2] = n + V, W && X(W);
                                            break e;
                                        }
                                        p0(), z();
                                    }
                                    Z2(), z();
                                }
                                Q[h + 40 >> 1] = 0, i[h + 60 >> 2] = 0, i[h + 32 >> 2] = 0, i[h + 36 >> 2] = 0, i[h + 52 >> 2] = 0, i[h + 56 >> 2] = 0, i[h + 48 >> 2] = f, i[h + 44 >> 2] = e, u && (Q[h + 34 >> 1] = I[u >> 1], Q[h + 36 >> 1] = I[u + 2 >> 1], Q[h + 38 >> 1] = I[u + 4 >> 1], Q[h + 40 >> 1] = I[u + 6 >> 1]);
                                e: {
                                    if (!t) {
                                        for(;;)if (Wn(h + 32 | 0, i[w + (B << 2) >> 2], 0, 0), B = B + 1 | 0, (_ | 0) == (B | 0)) break e;
                                    }
                                    for(; e = (B << 3) + t | 0, Wn(h + 32 | 0, i[w + (B << 2) >> 2], i[e >> 2], i[e + 4 >> 2]), B = B + 1 | 0, (_ | 0) != (B | 0););
                                }
                                F = h + 4 | 0, E = i[r >> 2], v = m - 80 | 0, m = v, B = i[h + 56 >> 2], f = i[h + 52 >> 2];
                                e: {
                                    if ((B - f | 0) / 12 >>> 0 >= 65536) {
                                        k = D(48), i[v + 44 >> 2] = k, i[v + 48 >> 2] = 40, i[v + 52 >> 2] = -2147483600, f = l[20532] | l[20533] << 8 | (l[20534] << 16 | l[20535] << 24), e = l[20528] | l[20529] << 8 | (l[20530] << 16 | l[20531] << 24), o[k + 32 | 0] = e, o[k + 33 | 0] = e >>> 8, o[k + 34 | 0] = e >>> 16, o[k + 35 | 0] = e >>> 24, o[k + 36 | 0] = f, o[k + 37 | 0] = f >>> 8, o[k + 38 | 0] = f >>> 16, o[k + 39 | 0] = f >>> 24, f = l[20524] | l[20525] << 8 | (l[20526] << 16 | l[20527] << 24), e = l[20520] | l[20521] << 8 | (l[20522] << 16 | l[20523] << 24), o[k + 24 | 0] = e, o[k + 25 | 0] = e >>> 8, o[k + 26 | 0] = e >>> 16, o[k + 27 | 0] = e >>> 24, o[k + 28 | 0] = f, o[k + 29 | 0] = f >>> 8, o[k + 30 | 0] = f >>> 16, o[k + 31 | 0] = f >>> 24, f = l[20516] | l[20517] << 8 | (l[20518] << 16 | l[20519] << 24), e = l[20512] | l[20513] << 8 | (l[20514] << 16 | l[20515] << 24), o[k + 16 | 0] = e, o[k + 17 | 0] = e >>> 8, o[k + 18 | 0] = e >>> 16, o[k + 19 | 0] = e >>> 24, o[k + 20 | 0] = f, o[k + 21 | 0] = f >>> 8, o[k + 22 | 0] = f >>> 16, o[k + 23 | 0] = f >>> 24, f = l[20508] | l[20509] << 8 | (l[20510] << 16 | l[20511] << 24), e = l[20504] | l[20505] << 8 | (l[20506] << 16 | l[20507] << 24), o[k + 8 | 0] = e, o[k + 9 | 0] = e >>> 8, o[k + 10 | 0] = e >>> 16, o[k + 11 | 0] = e >>> 24, o[k + 12 | 0] = f, o[k + 13 | 0] = f >>> 8, o[k + 14 | 0] = f >>> 16, o[k + 15 | 0] = f >>> 24, f = l[20500] | l[20501] << 8 | (l[20502] << 16 | l[20503] << 24), e = l[20496] | l[20497] << 8 | (l[20498] << 16 | l[20499] << 24), o[k | 0] = e, o[k + 1 | 0] = e >>> 8, o[k + 2 | 0] = e >>> 16, o[k + 3 | 0] = e >>> 24, o[k + 4 | 0] = f, o[k + 5 | 0] = f >>> 8, o[k + 6 | 0] = f >>> 16, o[k + 7 | 0] = f >>> 24, o[k + 40 | 0] = 0, k = i0(v + 56 | 0, 5, 0, v + 44 | 0), i[F >> 2] = 0, i[F + 4 >> 2] = 0, e = i[k + 4 >> 2], i[F + 8 >> 2] = i[k >> 2], i[F + 12 >> 2] = e, f = F + 16 | 0;
                                        r: {
                                            if (o[k + 19 | 0] >= 0) {
                                                e = i[k + 12 >> 2], i[f >> 2] = i[k + 8 >> 2], i[f + 4 >> 2] = e, i[f + 8 >> 2] = i[k + 16 >> 2];
                                                break r;
                                            }
                                            if (j(f, i[k + 8 >> 2], i[k + 12 >> 2]), o[k + 19 | 0] >= 0) break r;
                                            X(i[k + 8 >> 2]);
                                        }
                                        if (o[v + 55 | 0] >= 0) break e;
                                        X(i[v + 44 >> 2]);
                                        break e;
                                    }
                                    i[v + 64 >> 2] = 0, i[v + 56 >> 2] = 0, i[v + 60 >> 2] = 0, M = i[E + 48 >> 2], R = i[E + 52 >> 2], R && (i[R + 4 >> 2] = i[R + 4 >> 2] + 1, B = i[h + 56 >> 2], f = i[h + 52 >> 2]);
                                    r: {
                                        if ((f | 0) == (B | 0)) break r;
                                        A: {
                                            for(;;){
                                                q1(v + 44 | 0, M, i[f >> 2]), e = i[v + 44 >> 2], o[e + 164 | 0] = 1, i[e + 100 >> 2] = i[e + 100 >> 2] & -2 | 1, k = i[v + 48 >> 2];
                                                f: {
                                                    if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break f;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                f: {
                                                    k = i[v + 60 >> 2], e = i[v + 64 >> 2];
                                                    k: {
                                                        if (k >>> 0 < e >>> 0) {
                                                            i[k >> 2] = i[f >> 2], W = k + 4 | 0;
                                                            break k;
                                                        }
                                                        if (_ = i[v + 56 >> 2], t = k - _ >> 2, u = t + 1 | 0, u >>> 0 >= 1073741824) break f;
                                                        if (n = e - _ | 0, e = n >> 1, n = n >>> 0 >= 2147483644 ? 1073741823 : e >>> 0 > u >>> 0 ? e : u, n) {
                                                            if (n >>> 0 >= 1073741824) break A;
                                                            e = D(n << 2);
                                                        } else e = 0;
                                                        if (G = e + (t << 2) | 0, i[G >> 2] = i[f >> 2], W = G + 4 | 0, (k | 0) != (_ | 0)) for(; G = G - 4 | 0, k = k - 4 | 0, i[G >> 2] = i[k >> 2], (k | 0) != (_ | 0););
                                                        if (i[v + 64 >> 2] = e + (n << 2), i[v + 60 >> 2] = W, i[v + 56 >> 2] = G, !_) break k;
                                                        X(_);
                                                    }
                                                    if (i[v + 60 >> 2] = W, f = f + 12 | 0, (B | 0) != (f | 0)) continue;
                                                    break r;
                                                }
                                                break;
                                            }
                                            p0(), z();
                                        }
                                        Z2(), z();
                                    }
                                    B = v + 44 | 0, f = k0[h + 44 >> 2] > 65535 | k0[h + 48 >> 2] > 65535, t = i[h + 52 >> 2], u = i[h + 56 >> 2], e = f;
                                    r: {
                                        A: {
                                            if ((t | 0) == (u | 0)) break A;
                                            for(k = t;;){
                                                if (n = i[k + 4 >> 2], (n | 0) >= 32768) {
                                                    i[B + 8 >> 2] = 0, i[B >> 2] = 0, i[B + 4 >> 2] = 0, k = u - t | 0, n = 2, e = 1, f = 4;
                                                    break r;
                                                }
                                                if (e = 1, (n | 0) < -32768 | i[k + 8 >> 2] - 32768 >>> 0 <= 4294901759) break A;
                                                if (k = k + 12 | 0, (u | 0) == (k | 0)) break;
                                            }
                                            e = f;
                                        }
                                        i[B + 8 >> 2] = 0, i[B >> 2] = 0, i[B + 4 >> 2] = 0, f = e & 1, n = f ? 2 : 1, k = u - t | 0, f = f ? 4 : 2;
                                    }
                                    if (r1(B, (((k | 0) / 12 << 1) + 2 << n) + 10 | 0), o[i[B >> 2]] = l[h + 32 | 0], o[i[B >> 2] + 1 | 0] = e & 1, k = i[B >> 2], e = I[h + 34 >> 1], e = e << 8 | e >>> 8, o[k + 2 | 0] = e, o[k + 3 | 0] = e >>> 8, k = i[B >> 2], e = I[h + 36 >> 1], e = e << 8 | e >>> 8, o[k + 4 | 0] = e, o[k + 5 | 0] = e >>> 8, k = i[B >> 2], e = I[h + 38 >> 1], e = e << 8 | e >>> 8, o[k + 6 | 0] = e, o[k + 7 | 0] = e >>> 8, k = i[B >> 2], e = I[h + 40 >> 1], e = e << 8 | e >>> 8, o[k + 8 | 0] = e, o[k + 9 | 0] = e >>> 8, u = i[B >> 2] + 10 | 0, w = i[h + 44 >> 2], n = 0, k = 0, f >>> 0 >= 4) for(t = f & 4, e = 0; _ = k + u | 0, o[_ + 1 | 0] = w >>> (f + (k ^ 536870910) << 3), o[_ | 0] = w >>> (f + (k ^ -1) << 3), o[_ + 2 | 0] = w >>> (f + (k ^ 536870909) << 3), o[_ + 3 | 0] = w >>> (f + (k ^ 536870908) << 3), k = k + 4 | 0, e = e + 4 | 0, (t | 0) != (e | 0););
                                    if (e = f & 2, e) for(; o[k + u | 0] = w >>> (f + (k ^ -1) << 3), k = k + 1 | 0, n = n + 1 | 0, (e | 0) != (n | 0););
                                    if (w = f + 10 | 0, u = w + i[B >> 2] | 0, V = i[h + 48 >> 2], n = 0, k = 0, f >>> 0 >= 4) for(t = f & 4, e = 0; _ = k + u | 0, o[_ + 1 | 0] = V >>> (f + (k ^ 536870910) << 3), o[_ | 0] = V >>> (f + (k ^ -1) << 3), o[_ + 2 | 0] = V >>> (f + (k ^ 536870909) << 3), o[_ + 3 | 0] = V >>> (f + (k ^ 536870908) << 3), k = k + 4 | 0, e = e + 4 | 0, (t | 0) != (e | 0););
                                    if (e = f & 2, e) for(; o[k + u | 0] = V >>> (f + (k ^ -1) << 3), k = k + 1 | 0, n = n + 1 | 0, (e | 0) != (n | 0););
                                    if (n = i[h + 52 >> 2], _ = i[h + 56 >> 2], (n | 0) != (_ | 0)) for(V = f & 4, y = f & 2;;){
                                        if (u = f + w | 0, w = u + i[B >> 2] | 0, W = i[n + 4 >> 2], e = 0, k = 0, G = 0, t = f >>> 0 < 4, !t) for(; C = k + w | 0, o[C + 1 | 0] = W >> (f + (k ^ 536870910) << 3), o[C | 0] = W >> (f + (k ^ -1) << 3), o[C + 2 | 0] = W >> (f + (k ^ 536870909) << 3), o[C + 3 | 0] = W >> (f + (k ^ 536870908) << 3), k = k + 4 | 0, G = G + 4 | 0, (V | 0) != (G | 0););
                                        if (y) for(; o[k + w | 0] = W >> (f + (k ^ -1) << 3), k = k + 1 | 0, e = e + 1 | 0, (y | 0) != (e | 0););
                                        if (w = f + u | 0, u = w + i[B >> 2] | 0, C = i[n + 8 >> 2], e = 0, k = 0, G = 0, !t) for(; t = k + u | 0, o[t + 1 | 0] = C >> (f + (k ^ 536870910) << 3), o[t | 0] = C >> (f + (k ^ -1) << 3), o[t + 2 | 0] = C >> (f + (k ^ 536870909) << 3), o[t + 3 | 0] = C >> (f + (k ^ 536870908) << 3), k = k + 4 | 0, G = G + 4 | 0, (V | 0) != (G | 0););
                                        if (y) for(; o[k + u | 0] = C >> (f + (k ^ -1) << 3), k = k + 1 | 0, e = e + 1 | 0, (y | 0) != (e | 0););
                                        if (n = n + 12 | 0, (_ | 0) == (n | 0)) break;
                                    }
                                    f = YA(M, 1768912492), k = D(432), i[k >> 2] = 83028, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, n = L8(k + 16 | 0, E, f), i[n >> 2] = 83252, Q[k + 396 >> 1] = 0, i[k + 388 >> 2] = 0, i[k + 392 >> 2] = 0, i[k + 400 >> 2] = 0, i[k + 404 >> 2] = 0, i[k + 408 >> 2] = 0, i[k + 412 >> 2] = 0, i[k + 416 >> 2] = 0, i[k + 420 >> 2] = 0, i[k + 424 >> 2] = 0, i[k + 428 >> 2] = 0, i[v + 40 >> 2] = k, i[v + 36 >> 2] = n, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, Oe(E, f, v + 36 | 0), t = i[v + 40 >> 2];
                                    r: {
                                        if (!t || (e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                    }
                                    x8(M, f, v + 44 | 0, 1), J4(M, f, 1684630887, v + 56 | 0), w = D(128), i[w >> 2] = 76576, i[w + 4 >> 2] = 0, i[w + 8 >> 2] = 0, f = w + 16 | 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[w + 32 >> 2] = 0, i[w + 36 >> 2] = 0, i[w + 40 >> 2] = 0, i[w + 44 >> 2] = 0, i[w + 48 >> 2] = 0, i[w + 16 >> 2] = 73428, i[w + 60 >> 2] = 0, i[w + 64 >> 2] = 0, i[w + 52 >> 2] = 0, i[w + 56 >> 2] = 0, i[w + 72 >> 2] = -1, i[w + 76 >> 2] = -1, i[w + 80 >> 2] = -1, i[w + 84 >> 2] = -1, i[w + 116 >> 2] = 0, i[w + 88 >> 2] = 0, i[w + 92 >> 2] = 0, i[w + 96 >> 2] = 0, i[w + 100 >> 2] = 0, i[w + 104 >> 2] = 0, i[w + 108 >> 2] = 0, Q[w + 112 >> 1] = 0, i[w + 16 >> 2] = 74528, i[w + 32 >> 2] = 1769173093, e = i[h + 48 >> 2], i[w + 120 >> 2] = i[h + 44 >> 2], i[w + 124 >> 2] = e, i[v + 32 >> 2] = w, i[v + 28 >> 2] = f, i[w + 4 >> 2] = i[w + 4 >> 2] + 1, e = i[v + 32 >> 2], i[v + 8 >> 2] = i[v + 28 >> 2], i[v + 12 >> 2] = e, Zi(n, v + 8 | 0, 0), e = i[i[v + 56 >> 2] >> 2], _ = m - 32 | 0, m = _, i[_ + 28 >> 2] = 0, i[_ + 20 >> 2] = 0, i[_ + 24 >> 2] = 0, F4(_, M, e, _ + 20 | 0);
                                    r: {
                                        if (i[_ >> 2]) {
                                            i[v + 36 >> 2] = 0, i[v + 40 >> 2] = 0;
                                            break r;
                                        }
                                        A: {
                                            if (u = i[_ + 20 >> 2], f = i[_ + 24 >> 2], (u | 0) != (f | 0)) {
                                                if (e = i[u >> 2], e && (G = i[v + 40 >> 2], e = E0(e, 73632, 75648), e)) break A;
                                                if (u = u + 8 | 0, (f | 0) != (u | 0)) for(;;){
                                                    if (e = i[u >> 2], e && (G = 0, e = E0(e, 73632, 75648), e)) break A;
                                                    if (u = u + 8 | 0, (f | 0) == (u | 0)) break;
                                                }
                                                i[v + 36 >> 2] = 0, i[v + 40 >> 2] = 0;
                                            }
                                            i[v + 36 >> 2] = 0, i[v + 40 >> 2] = 0;
                                            break r;
                                        }
                                        if (i[v + 40 >> 2] = G, i[v + 36 >> 2] = e, e = i[u + 4 >> 2], i[v + 40 >> 2] = e, !e) break r;
                                        i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                    }
                                    if (o[_ + 19 | 0] < 0 && X(i[_ + 8 >> 2]), f = i[_ + 20 >> 2], f) {
                                        if (e = f, u = i[_ + 24 >> 2], (e | 0) != (u | 0)) {
                                            for(;;){
                                                t = i[u - 4 >> 2];
                                                r: {
                                                    if (!t || (e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e)) break r;
                                                    p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                }
                                                if (u = u - 8 | 0, (f | 0) == (u | 0)) break;
                                            }
                                            e = i[_ + 20 >> 2];
                                        }
                                        i[_ + 24 >> 2] = f, X(e);
                                    }
                                    m = _ + 32 | 0, i[v + 20 >> 2] = i[v + 36 >> 2], e = i[v + 40 >> 2], i[v + 24 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[v + 24 >> 2], i[v >> 2] = i[v + 20 >> 2], i[v + 4 >> 2] = e, Zi(n, v, 1), i[F + 4 >> 2] = k, i[F >> 2] = n, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, e = i[21669], i[F + 8 >> 2] = i[21668], i[F + 12 >> 2] = e, f = F + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            e = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = e, i[f + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(f, i[21670], i[21671]);
                                    }
                                    f = i[v + 40 >> 2];
                                    r: {
                                        if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                    }
                                    e = i[w + 4 >> 2], i[w + 4 >> 2] = e - 1, e || (p[i[i[w >> 2] + 8 >> 2]](w), g(w)), e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), e = i[v + 44 >> 2], e && (i[v + 48 >> 2] = e, X(e));
                                    r: {
                                        if (!R || (e = i[R + 4 >> 2], i[R + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[R >> 2] + 8 >> 2]](R), g(R);
                                    }
                                    if (e = i[v + 56 >> 2], !e) break e;
                                    i[v + 60 >> 2] = e, X(e);
                                }
                                m = v + 80 | 0;
                                e: {
                                    if (i[h + 12 >> 2] != i[21668]) {
                                        j0(A, h + 12 | 0, i[r >> 2]);
                                        break e;
                                    }
                                    e = i[h + 4 >> 2];
                                    r: {
                                        k = i[h + 8 >> 2];
                                        A: {
                                            if (!k) {
                                                if (s) break A;
                                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                                break e;
                                            }
                                            if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, !s) break r;
                                        }
                                        f = D(16), i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[s >> 2] = f, i[f + 4 >> 2] = k, i[f >> 2] = e, e = i[r >> 2], r = i[r + 4 >> 2];
                                        A: {
                                            if (!r) {
                                                i[f + 12 >> 2] = r, i[f + 8 >> 2] = e;
                                                break A;
                                            }
                                            if (i[r + 4 >> 2] = i[r + 4 >> 2] + 1, i[f + 8 >> 2] = e, e = i[f + 12 >> 2], i[f + 12 >> 2] = r, !e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break A;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                        break e;
                                    }
                                    if (r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                o[h + 31 | 0] < 0 && X(i[h + 20 >> 2]), r = i[h + 8 >> 2];
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                if (A = i[h + 52 >> 2], A && (i[h + 56 >> 2] = A, X(A)), A = i[h + 68 >> 2], !A) break i;
                                i[h + 72 >> 2] = A, X(A);
                            }
                            m = h + 80 | 0;
                        }
                        function hh(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            W = m - 32 | 0, m = W, n = m + -64 | 0, m = n, k = i[r + 20 >> 2], e = i[k + 48 >> 2], y = i[k + 52 >> 2], y && (i[y + 4 >> 2] = i[y + 4 >> 2] + 1), k = i[e + 84 >> 2], F = i[e + 88 >> 2], F && (i[F + 4 >> 2] = i[F + 4 >> 2] + 1), B = W + 8 | 0;
                            i: {
                                if (!k) {
                                    if (r = D(56), i[n + 32 >> 2] = r, i[n + 36 >> 2] = 48, i[n + 40 >> 2] = -2147483592, e = l[11589] | l[11590] << 8 | (l[11591] << 16 | l[11592] << 24), k = l[11585] | l[11586] << 8 | (l[11587] << 16 | l[11588] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 48 | 0] = 0, e = l[11629] | l[11630] << 8 | (l[11631] << 16 | l[11632] << 24), k = l[11625] | l[11626] << 8 | (l[11627] << 16 | l[11628] << 24), o[r + 40 | 0] = k, o[r + 41 | 0] = k >>> 8, o[r + 42 | 0] = k >>> 16, o[r + 43 | 0] = k >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[11621] | l[11622] << 8 | (l[11623] << 16 | l[11624] << 24), k = l[11617] | l[11618] << 8 | (l[11619] << 16 | l[11620] << 24), o[r + 32 | 0] = k, o[r + 33 | 0] = k >>> 8, o[r + 34 | 0] = k >>> 16, o[r + 35 | 0] = k >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[11613] | l[11614] << 8 | (l[11615] << 16 | l[11616] << 24), k = l[11609] | l[11610] << 8 | (l[11611] << 16 | l[11612] << 24), o[r + 24 | 0] = k, o[r + 25 | 0] = k >>> 8, o[r + 26 | 0] = k >>> 16, o[r + 27 | 0] = k >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[11605] | l[11606] << 8 | (l[11607] << 16 | l[11608] << 24), k = l[11601] | l[11602] << 8 | (l[11603] << 16 | l[11604] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[11597] | l[11598] << 8 | (l[11599] << 16 | l[11600] << 24), k = l[11593] | l[11594] << 8 | (l[11595] << 16 | l[11596] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(B, 2, 113, n + 32 | 0), o[n + 43 | 0] >= 0) break i;
                                    X(i[n + 32 >> 2]);
                                    break i;
                                }
                                Q8(n + 32 | 0, k, i[r + 36 >> 2], 1684630887), k = i[r + 404 >> 2], k && (i[r + 408 >> 2] = k, X(k)), i[r + 404 >> 2] = i[n + 32 >> 2], i[r + 408 >> 2] = i[n + 36 >> 2], i[r + 412 >> 2] = i[n + 40 >> 2], i[n + 60 >> 2] = 0, i[n + 52 >> 2] = 0, i[n + 56 >> 2] = 0, ui(n + 32 | 0, e, i[r + 36 >> 2], n + 52 | 0);
                                e: {
                                    if (i[n + 32 >> 2]) {
                                        r = i[n + 36 >> 2], i[B >> 2] = i[n + 32 >> 2], i[B + 4 >> 2] = r, i[B + 16 >> 2] = i[n + 48 >> 2], r = i[n + 44 >> 2], i[B + 8 >> 2] = i[n + 40 >> 2], i[B + 12 >> 2] = r, i[n + 48 >> 2] = 0, i[n + 40 >> 2] = 0, i[n + 44 >> 2] = 0;
                                        break e;
                                    }
                                    G = n + 8 | 0, u = r + 372 | 0, E = i[r + 408 >> 2] - i[r + 404 >> 2] >> 2, s = m - 192 | 0, m = s, e = D(32), i[s + 24 >> 2] = e, i[s + 28 >> 2] = 29, i[s + 32 >> 2] = -2147483616, k = l[10036] | l[10037] << 8 | (l[10038] << 16 | l[10039] << 24), w = l[10032] | l[10033] << 8 | (l[10034] << 16 | l[10035] << 24), o[e + 21 | 0] = w, o[e + 22 | 0] = w >>> 8, o[e + 23 | 0] = w >>> 16, o[e + 24 | 0] = w >>> 24, o[e + 25 | 0] = k, o[e + 26 | 0] = k >>> 8, o[e + 27 | 0] = k >>> 16, o[e + 28 | 0] = k >>> 24, k = l[10031] | l[10032] << 8 | (l[10033] << 16 | l[10034] << 24), w = l[10027] | l[10028] << 8 | (l[10029] << 16 | l[10030] << 24), o[e + 16 | 0] = w, o[e + 17 | 0] = w >>> 8, o[e + 18 | 0] = w >>> 16, o[e + 19 | 0] = w >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[10023] | l[10024] << 8 | (l[10025] << 16 | l[10026] << 24), w = l[10019] | l[10020] << 8 | (l[10021] << 16 | l[10022] << 24), o[e + 8 | 0] = w, o[e + 9 | 0] = w >>> 8, o[e + 10 | 0] = w >>> 16, o[e + 11 | 0] = w >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, k = l[10015] | l[10016] << 8 | (l[10017] << 16 | l[10018] << 24), w = l[10011] | l[10012] << 8 | (l[10013] << 16 | l[10014] << 24), o[e | 0] = w, o[e + 1 | 0] = w >>> 8, o[e + 2 | 0] = w >>> 16, o[e + 3 | 0] = w >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 29 | 0] = 0, k = i0(s + 168 | 0, 2, 121, s + 24 | 0), o[s + 35 | 0] < 0 && X(i[s + 24 >> 2]), e = i[n + 52 >> 2], t = i[n + 56 >> 2] - e | 0;
                                    r: {
                                        if (t >>> 0 <= 9) {
                                            e = i[k + 4 >> 2], i[G >> 2] = i[k >> 2], i[G + 4 >> 2] = e, i[G + 16 >> 2] = i[k + 16 >> 2], e = i[k + 12 >> 2], i[G + 8 >> 2] = i[k + 8 >> 2], i[G + 12 >> 2] = e, i[k + 16 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0;
                                            break r;
                                        }
                                        w = l[e | 0], o[u | 0] = w;
                                        A: {
                                            f: {
                                                k: {
                                                    if (w) {
                                                        i[s + 32 >> 2] = 59808, i[s + 88 >> 2] = 59828, e = i[14961], i[s + 24 >> 2] = e, f = i[e - 12 >> 2], e = s + 24 | 0, i[f + e >> 2] = i[14962], i[s + 28 >> 2] = 0, f = e + i[i[s + 24 >> 2] - 12 >> 2] | 0, w = s + 36 | 0, T0(f, w), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[s + 32 >> 2] = f, t = i[f - 12 >> 2], f = s + 32 | 0, i[t + f >> 2] = i[14964], t = i[14960], i[s + 24 >> 2] = t, i[e + i[t - 12 >> 2] >> 2] = i[14965], i[s + 88 >> 2] = 59828, i[s + 24 >> 2] = 59788, i[s + 32 >> 2] = 59808, w = z0(w), i[w >> 2] = 58864, i[s + 76 >> 2] = 0, i[s + 80 >> 2] = 0, i[s + 68 >> 2] = 0, i[s + 72 >> 2] = 0, i[s + 84 >> 2] = 24, U(P0(U(f, 21809, 27), l[u | 0]), 3679, 23), e = i[s + 84 >> 2];
                                                        n: {
                                                            if (e & 16) {
                                                                f = s + 56 | 0, u = i[s + 80 >> 2], e = i[s + 60 >> 2], u >>> 0 < e >>> 0 ? i[s + 80 >> 2] = e : e = u;
                                                                break n;
                                                            }
                                                            if (!(e & 8)) {
                                                                e = 0, o[s + 23 | 0] = 0, f = s + 12 | 0;
                                                                break A;
                                                            }
                                                            f = s + 44 | 0, e = i[s + 52 >> 2];
                                                        }
                                                        if (u = i[f >> 2], e = e - u | 0, e >>> 0 >= 2147483640) break k;
                                                        if (e >>> 0 >= 11) {
                                                            t = (e | 7) + 1 | 0, f = D(t), i[s + 20 >> 2] = t | -2147483648, i[s + 12 >> 2] = f, i[s + 16 >> 2] = e;
                                                            break f;
                                                        }
                                                        if (o[s + 23 | 0] = e, f = s + 12 | 0, e) break f;
                                                        e = 0;
                                                        break A;
                                                    }
                                                    if (w = l[e + 1 | 0], o[u + 1 | 0] = w, e = 10, M = w & 1, V = M ? 4 : 2, H = V << 1, w = H + 10 | 0, t >>> 0 >= w + (E << 1 << (M ? 2 : 1)) >>> 0) {
                                                        if (t = i[n + 52 >> 2], t = l[t + 2 | 0] | l[t + 3 | 0] << 8, Q[u + 2 >> 1] = t << 8 | t >>> 8, t = i[n + 52 >> 2], t = l[t + 4 | 0] | l[t + 5 | 0] << 8, Q[u + 4 >> 1] = t << 8 | t >>> 8, t = i[n + 52 >> 2], t = l[t + 6 | 0] | l[t + 7 | 0] << 8, Q[u + 6 >> 1] = t << 8 | t >>> 8, t = i[n + 52 >> 2], t = l[t + 8 | 0] | l[t + 9 | 0] << 8, Q[u + 8 >> 1] = t << 8 | t >>> 8, _ = i[n + 52 >> 2], M) {
                                                            for(C = V & 4; t = e, e = e + 4 | 0, h = h + 4 | 0, (C | 0) != (h | 0););
                                                            t = t + _ | 0, h = (l[t | 0] << 16 | l[t + 1 | 0] << 8 | l[t + 2 | 0]) << 8 | l[t + 3 | 0];
                                                        }
                                                        if (t = V & 2, t) for(; h = l[e + _ | 0] | h << 8, e = e + 1 | 0, f = f + 1 | 0, (t | 0) != (f | 0););
                                                        if (i[u + 12 >> 2] = h, _ = V & 2, e = V + 10 | 0, C = i[n + 52 >> 2], M) {
                                                            for(R = V & 4, f = 0; t = e, e = e + 4 | 0, f = f + 4 | 0, (R | 0) != (f | 0););
                                                            f = t + C | 0, f = (l[f | 0] << 16 | l[f + 1 | 0] << 8 | l[f + 2 | 0]) << 8 | l[f + 3 | 0];
                                                        } else f = 0;
                                                        if (_) for(; f = l[e + C | 0] | f << 8, e = e + 1 | 0, v = v + 1 | 0, (_ | 0) != (v | 0););
                                                        if (i[u + 16 >> 2] = f, !(f && h)) {
                                                            if (e = D(48), i[s + 24 >> 2] = e, i[s + 28 >> 2] = 40, i[s + 32 >> 2] = -2147483600, f = l[19056] | l[19057] << 8 | (l[19058] << 16 | l[19059] << 24), u = l[19052] | l[19053] << 8 | (l[19054] << 16 | l[19055] << 24), o[e | 0] = u, o[e + 1 | 0] = u >>> 8, o[e + 2 | 0] = u >>> 16, o[e + 3 | 0] = u >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 40 | 0] = 0, f = l[19088] | l[19089] << 8 | (l[19090] << 16 | l[19091] << 24), u = l[19084] | l[19085] << 8 | (l[19086] << 16 | l[19087] << 24), o[e + 32 | 0] = u, o[e + 33 | 0] = u >>> 8, o[e + 34 | 0] = u >>> 16, o[e + 35 | 0] = u >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[19080] | l[19081] << 8 | (l[19082] << 16 | l[19083] << 24), u = l[19076] | l[19077] << 8 | (l[19078] << 16 | l[19079] << 24), o[e + 24 | 0] = u, o[e + 25 | 0] = u >>> 8, o[e + 26 | 0] = u >>> 16, o[e + 27 | 0] = u >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[19072] | l[19073] << 8 | (l[19074] << 16 | l[19075] << 24), u = l[19068] | l[19069] << 8 | (l[19070] << 16 | l[19071] << 24), o[e + 16 | 0] = u, o[e + 17 | 0] = u >>> 8, o[e + 18 | 0] = u >>> 16, o[e + 19 | 0] = u >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[19064] | l[19065] << 8 | (l[19066] << 16 | l[19067] << 24), u = l[19060] | l[19061] << 8 | (l[19062] << 16 | l[19063] << 24), o[e + 8 | 0] = u, o[e + 9 | 0] = u >>> 8, o[e + 10 | 0] = u >>> 16, o[e + 11 | 0] = u >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(G, 2, 121, s + 24 | 0), o[s + 35 | 0] >= 0) break r;
                                                            X(i[s + 24 >> 2]);
                                                            break r;
                                                        }
                                                        e = i[u + 24 >> 2], f = i[u + 20 >> 2], t = (e - f | 0) / 12 | 0;
                                                        n: {
                                                            t: {
                                                                if (t >>> 0 < E >>> 0) {
                                                                    if (f = 0, v = E - t | 0, _ = i[u + 28 >> 2], v >>> 0 <= (_ - e | 0) / 12 >>> 0) {
                                                                        v && (f = e, e = Z(v, 12) - 12 | 0, e = (e - ((e >>> 0) % 12 | 0) | 0) + 12 | 0, e = B0(f, 0, e) + e | 0), i[u + 24 >> 2] = e;
                                                                        break t;
                                                                    }
                                                                    o: {
                                                                        if (t = i[u + 20 >> 2], C = (e - t | 0) / 12 | 0, h = C + v | 0, h >>> 0 < 357913942) {
                                                                            if (_ = (_ - t | 0) / 12 | 0, R = _ << 1, _ = _ >>> 0 >= 178956970 ? 357913941 : h >>> 0 < R >>> 0 ? R : h, _) {
                                                                                if (_ >>> 0 >= 357913942) break o;
                                                                                f = D(Z(_, 12));
                                                                            }
                                                                            if (h = Z(C, 12) + f | 0, v = Z(v, 12) - 12 | 0, v = (v - ((v >>> 0) % 12 | 0) | 0) + 12 | 0, v = B0(h, 0, v) + v | 0, (e | 0) != (t | 0)) {
                                                                                for(; e = e - 12 | 0, C = i[e + 4 >> 2], h = h - 12 | 0, i[h >> 2] = i[e >> 2], i[h + 4 >> 2] = C, i[h + 8 >> 2] = i[e + 8 >> 2], (e | 0) != (t | 0););
                                                                                t = i[u + 20 >> 2];
                                                                            }
                                                                            i[u + 28 >> 2] = Z(_, 12) + f, i[u + 24 >> 2] = v, i[u + 20 >> 2] = h, t && X(t);
                                                                            break t;
                                                                        }
                                                                        p0(), z();
                                                                    }
                                                                    Z2(), z();
                                                                }
                                                                if (t >>> 0 > E >>> 0 && (i[u + 24 >> 2] = f + Z(E, 12)), !E) break n;
                                                            }
                                                            for(C = V & 4, _ = V & 2, R = 128 << (V << 3) - 8, P = i[u + 20 >> 2], t = 0;;){
                                                                if (f = i[n + 52 >> 2], e = w, v = 0, h = 0, M) {
                                                                    for(; u = e, e = e + 4 | 0, v = v + 4 | 0, (C | 0) != (v | 0););
                                                                    h = f + u | 0, u = (l[h | 0] << 16 | l[h + 1 | 0] << 8 | l[h + 2 | 0]) << 8, h = u | l[h + 3 | 0];
                                                                }
                                                                if (v = 0, _) for(; u = h << 8, h = u | l[e + f | 0], e = e + 1 | 0, v = v + 1 | 0, (_ | 0) != (v | 0););
                                                                if (T = Z(t, 12) + P | 0, i[T + 4 >> 2] = u & R ? h | -2147483648 : h, e = w + V | 0, S = i[n + 52 >> 2], v = 0, u = 0, h = 0, M) {
                                                                    for(; f = e, e = e + 4 | 0, u = u + 4 | 0, (C | 0) != (u | 0););
                                                                    h = f + S | 0, f = (l[h | 0] << 16 | l[h + 1 | 0] << 8 | l[h + 2 | 0]) << 8, h = f | l[h + 3 | 0];
                                                                }
                                                                if (_) for(; f = h << 8, h = f | l[e + S | 0], e = e + 1 | 0, v = v + 1 | 0, (_ | 0) != (v | 0););
                                                                if (i[T + 8 >> 2] = f & R ? h | -2147483648 : h, w = w + H | 0, t = t + 1 | 0, (E | 0) == (t | 0)) break;
                                                            }
                                                        }
                                                        if (e = i[21669], i[G >> 2] = i[21668], i[G + 4 >> 2] = e, e = G + 8 | 0, o[86691] >= 0) {
                                                            f = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[21672];
                                                            break r;
                                                        }
                                                        j(e, i[21670], i[21671]);
                                                        break r;
                                                    }
                                                    e = i[k + 4 >> 2], i[G >> 2] = i[k >> 2], i[G + 4 >> 2] = e, i[G + 16 >> 2] = i[k + 16 >> 2], e = i[k + 12 >> 2], i[G + 8 >> 2] = i[k + 8 >> 2], i[G + 12 >> 2] = e, i[k + 16 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0;
                                                    break r;
                                                }
                                                Y0(), z();
                                            }
                                            Q0(f, u, e);
                                        }
                                        o[e + f | 0] = 0, i0(G, 4, 3002, s + 12 | 0), o[s + 23 | 0] < 0 && X(i[s + 12 >> 2]), e = i[14959], i[s + 24 >> 2] = e, i[i[e - 12 >> 2] + (s + 24 | 0) >> 2] = i[14967], i[s + 32 >> 2] = i[14968], i[w >> 2] = 58864, o[s + 79 | 0] < 0 && X(i[s + 68 >> 2]), x0(w), N0(s + 88 | 0);
                                    }
                                    if (o[k + 19 | 0] < 0 && X(i[k + 8 >> 2]), m = s + 192 | 0, k = i[n + 12 >> 2], e = i[n + 8 >> 2], i[n + 32 >> 2] = e, i[n + 36 >> 2] = k, o[n + 51 | 0] < 0 && (X(i[n + 40 >> 2]), e = i[n + 32 >> 2]), k = i[n + 20 >> 2], i[n + 40 >> 2] = i[n + 16 >> 2], i[n + 44 >> 2] = k, i[n + 48 >> 2] = i[n + 24 >> 2], e) {
                                        r = i[n + 36 >> 2], i[B >> 2] = i[n + 32 >> 2], i[B + 4 >> 2] = r, i[B + 16 >> 2] = i[n + 48 >> 2], r = i[n + 44 >> 2], i[B + 8 >> 2] = i[n + 40 >> 2], i[B + 12 >> 2] = r, i[n + 40 >> 2] = 0, i[n + 44 >> 2] = 0, i[n + 48 >> 2] = 0;
                                        break e;
                                    }
                                    if (((i[r + 396 >> 2] - i[r + 392 >> 2] | 0) / 12 | 0) != i[r + 408 >> 2] - i[r + 404 >> 2] >> 2) {
                                        if (r = D(72), i[n + 8 >> 2] = r, i[n + 12 >> 2] = 69, i[n + 16 >> 2] = -2147483576, $ = v0(r, 4960, 69), c = 0, o[$ + 69 | 0] = c, i0(B, 2, 121, n + 8 | 0), o[n + 19 | 0] >= 0) break e;
                                        X(i[n + 8 >> 2]);
                                        break e;
                                    }
                                    if (r = i[21669], i[B >> 2] = i[21668], i[B + 4 >> 2] = r, r = B + 8 | 0, o[86691] >= 0) {
                                        e = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = e, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (o[n + 51 | 0] < 0 && X(i[n + 40 >> 2]), r = i[n + 52 >> 2], !r) break i;
                                i[n + 56 >> 2] = r, X(r);
                            }
                            i: {
                                if (!F || (r = i[F + 4 >> 2], i[F + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[F >> 2] + 8 >> 2]](F), g(F);
                            }
                            i: {
                                if (!y || (r = i[y + 4 >> 2], i[y + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[y >> 2] + 8 >> 2]](y), g(y);
                            }
                            m = n - -64 | 0, r = A + 8 | 0;
                            i: {
                                if (i[W + 8 >> 2]) {
                                    e = i[W + 12 >> 2], i[A >> 2] = i[W + 8 >> 2], i[A + 4 >> 2] = e, i[r + 8 >> 2] = i[W + 24 >> 2], A = i[W + 20 >> 2], i[r >> 2] = i[W + 16 >> 2], i[r + 4 >> 2] = A, i[W + 24 >> 2] = 0, i[W + 16 >> 2] = 0, i[W + 20 >> 2] = 0;
                                    break i;
                                }
                                if (e = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = e, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            o[W + 27 | 0] < 0 && X(i[W + 16 >> 2]), m = W + 32 | 0;
                        }
                        function wh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            k = m - 32 | 0, m = k, u = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 100 | 0]), f2(e, l[r + 101 | 0]), f2(e, l[r + 102 | 0]), f2(e, l[r + 103 | 0]), f2(e, (l[r + 104 | 0] - 1 | 252) & 255), f = (i[r + 120 >> 2] - i[r + 116 >> 2] | 0) / 12 | 0;
                            i: {
                                if (f >>> 0 >= 32) {
                                    if (r = D(48), i[k + 20 >> 2] = r, i[k + 24 >> 2] = 44, i[k + 28 >> 2] = -2147483600, e = l[18880] | l[18881] << 8 | (l[18882] << 16 | l[18883] << 24), f = l[18876] | l[18877] << 8 | (l[18878] << 16 | l[18879] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 44 | 0] = 0, e = l[18916] | l[18917] << 8 | (l[18918] << 16 | l[18919] << 24), o[r + 40 | 0] = e, o[r + 41 | 0] = e >>> 8, o[r + 42 | 0] = e >>> 16, o[r + 43 | 0] = e >>> 24, e = l[18912] | l[18913] << 8 | (l[18914] << 16 | l[18915] << 24), f = l[18908] | l[18909] << 8 | (l[18910] << 16 | l[18911] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18904] | l[18905] << 8 | (l[18906] << 16 | l[18907] << 24), f = l[18900] | l[18901] << 8 | (l[18902] << 16 | l[18903] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18896] | l[18897] << 8 | (l[18898] << 16 | l[18899] << 24), f = l[18892] | l[18893] << 8 | (l[18894] << 16 | l[18895] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18888] | l[18889] << 8 | (l[18890] << 16 | l[18891] << 24), f = l[18884] | l[18885] << 8 | (l[18886] << 16 | l[18887] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, k + 20 | 0), o[k + 31 | 0] >= 0) break i;
                                    X(i[k + 20 >> 2]);
                                    break i;
                                }
                                if (f2(e, (f | 224) & 255), f = i[r + 116 >> 2], n = i[r + 120 >> 2], (f | 0) != (n | 0)) for(;;){
                                    if (t = i[f + 4 >> 2] - i[f >> 2] | 0, t >>> 0 >= 65536) {
                                        if (r = D(56), i[k + 20 >> 2] = r, i[k + 24 >> 2] = 55, i[k + 28 >> 2] = -2147483592, e = l[18722] | l[18723] << 8 | (l[18724] << 16 | l[18725] << 24), f = l[18718] | l[18719] << 8 | (l[18720] << 16 | l[18721] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 55 | 0] = 0, e = l[18769] | l[18770] << 8 | (l[18771] << 16 | l[18772] << 24), f = l[18765] | l[18766] << 8 | (l[18767] << 16 | l[18768] << 24), o[r + 47 | 0] = f, o[r + 48 | 0] = f >>> 8, o[r + 49 | 0] = f >>> 16, o[r + 50 | 0] = f >>> 24, o[r + 51 | 0] = e, o[r + 52 | 0] = e >>> 8, o[r + 53 | 0] = e >>> 16, o[r + 54 | 0] = e >>> 24, e = l[18762] | l[18763] << 8 | (l[18764] << 16 | l[18765] << 24), f = l[18758] | l[18759] << 8 | (l[18760] << 16 | l[18761] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[18754] | l[18755] << 8 | (l[18756] << 16 | l[18757] << 24), f = l[18750] | l[18751] << 8 | (l[18752] << 16 | l[18753] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18746] | l[18747] << 8 | (l[18748] << 16 | l[18749] << 24), f = l[18742] | l[18743] << 8 | (l[18744] << 16 | l[18745] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18738] | l[18739] << 8 | (l[18740] << 16 | l[18741] << 24), f = l[18734] | l[18735] << 8 | (l[18736] << 16 | l[18737] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18730] | l[18731] << 8 | (l[18732] << 16 | l[18733] << 24), f = l[18726] | l[18727] << 8 | (l[18728] << 16 | l[18729] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, k + 20 | 0), o[k + 31 | 0] >= 0) break i;
                                        X(i[k + 20 >> 2]);
                                        break i;
                                    }
                                    if (w2(e, t & 65535), G4(e, f), f = f + 12 | 0, (n | 0) == (f | 0)) break;
                                }
                                if (f = (i[r + 132 >> 2] - i[r + 128 >> 2] | 0) / 12 | 0, f >>> 0 >= 256) {
                                    if (r = D(48), i[k + 20 >> 2] = r, i[k + 24 >> 2] = 45, i[k + 28 >> 2] = -2147483600, e = l[18834] | l[18835] << 8 | (l[18836] << 16 | l[18837] << 24), f = l[18830] | l[18831] << 8 | (l[18832] << 16 | l[18833] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 45 | 0] = 0, e = l[18871] | l[18872] << 8 | (l[18873] << 16 | l[18874] << 24), f = l[18867] | l[18868] << 8 | (l[18869] << 16 | l[18870] << 24), o[r + 37 | 0] = f, o[r + 38 | 0] = f >>> 8, o[r + 39 | 0] = f >>> 16, o[r + 40 | 0] = f >>> 24, o[r + 41 | 0] = e, o[r + 42 | 0] = e >>> 8, o[r + 43 | 0] = e >>> 16, o[r + 44 | 0] = e >>> 24, e = l[18866] | l[18867] << 8 | (l[18868] << 16 | l[18869] << 24), f = l[18862] | l[18863] << 8 | (l[18864] << 16 | l[18865] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18858] | l[18859] << 8 | (l[18860] << 16 | l[18861] << 24), f = l[18854] | l[18855] << 8 | (l[18856] << 16 | l[18857] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18850] | l[18851] << 8 | (l[18852] << 16 | l[18853] << 24), f = l[18846] | l[18847] << 8 | (l[18848] << 16 | l[18849] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18842] | l[18843] << 8 | (l[18844] << 16 | l[18845] << 24), f = l[18838] | l[18839] << 8 | (l[18840] << 16 | l[18841] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, k + 20 | 0), o[k + 31 | 0] >= 0) break i;
                                    X(i[k + 20 >> 2]);
                                    break i;
                                }
                                if (f2(e, f & 255), f = i[r + 128 >> 2], n = i[r + 132 >> 2], (f | 0) != (n | 0)) for(;;){
                                    if (t = i[f + 4 >> 2] - i[f >> 2] | 0, t >>> 0 >= 65536) {
                                        if (r = D(56), i[k + 20 >> 2] = r, i[k + 24 >> 2] = 55, i[k + 28 >> 2] = -2147483592, e = l[18778] | l[18779] << 8 | (l[18780] << 16 | l[18781] << 24), f = l[18774] | l[18775] << 8 | (l[18776] << 16 | l[18777] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 55 | 0] = 0, e = l[18825] | l[18826] << 8 | (l[18827] << 16 | l[18828] << 24), f = l[18821] | l[18822] << 8 | (l[18823] << 16 | l[18824] << 24), o[r + 47 | 0] = f, o[r + 48 | 0] = f >>> 8, o[r + 49 | 0] = f >>> 16, o[r + 50 | 0] = f >>> 24, o[r + 51 | 0] = e, o[r + 52 | 0] = e >>> 8, o[r + 53 | 0] = e >>> 16, o[r + 54 | 0] = e >>> 24, e = l[18818] | l[18819] << 8 | (l[18820] << 16 | l[18821] << 24), f = l[18814] | l[18815] << 8 | (l[18816] << 16 | l[18817] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[18810] | l[18811] << 8 | (l[18812] << 16 | l[18813] << 24), f = l[18806] | l[18807] << 8 | (l[18808] << 16 | l[18809] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18802] | l[18803] << 8 | (l[18804] << 16 | l[18805] << 24), f = l[18798] | l[18799] << 8 | (l[18800] << 16 | l[18801] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18794] | l[18795] << 8 | (l[18796] << 16 | l[18797] << 24), f = l[18790] | l[18791] << 8 | (l[18792] << 16 | l[18793] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18786] | l[18787] << 8 | (l[18788] << 16 | l[18789] << 24), f = l[18782] | l[18783] << 8 | (l[18784] << 16 | l[18785] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, k + 20 | 0), o[k + 31 | 0] >= 0) break i;
                                        X(i[k + 20 >> 2]);
                                        break i;
                                    }
                                    if (w2(e, t & 65535), G4(e, f), f = f + 12 | 0, (n | 0) == (f | 0)) break;
                                }
                                f = l[r + 101 | 0] - 66 | 0;
                                e: {
                                    if (1 << f & 4196353 && f >>> 0 <= 22) break e;
                                    if (f2(e, l[r + 108 | 0]), f2(e, l[r + 112 | 0] - 8 & 255), f2(e, l[r + 113 | 0] - 8 & 255), f = (i[r + 144 >> 2] - i[r + 140 >> 2] | 0) / 12 | 0, f >>> 0 >= 256) {
                                        if (r = A, A = a1(k + 20 | 0, 18608), i0(r, 9, 0, A), o[A + 11 | 0] >= 0) break i;
                                        X(i[A >> 2]);
                                        break i;
                                    }
                                    if (f2(e, f & 255), f = i[r + 140 >> 2], n = i[r + 144 >> 2], (f | 0) == (n | 0)) break e;
                                    for(;;){
                                        if (t = i[f + 4 >> 2] - i[f >> 2] | 0, t >>> 0 >= 65536) {
                                            if (r = D(64), i[k + 20 >> 2] = r, i[k + 24 >> 2] = 59, i[k + 28 >> 2] = -2147483584, e = l[18662] | l[18663] << 8 | (l[18664] << 16 | l[18665] << 24), f = l[18658] | l[18659] << 8 | (l[18660] << 16 | l[18661] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 59 | 0] = 0, e = l[18713] | l[18714] << 8 | (l[18715] << 16 | l[18716] << 24), o[r + 55 | 0] = e, o[r + 56 | 0] = e >>> 8, o[r + 57 | 0] = e >>> 16, o[r + 58 | 0] = e >>> 24, e = l[18710] | l[18711] << 8 | (l[18712] << 16 | l[18713] << 24), f = l[18706] | l[18707] << 8 | (l[18708] << 16 | l[18709] << 24), o[r + 48 | 0] = f, o[r + 49 | 0] = f >>> 8, o[r + 50 | 0] = f >>> 16, o[r + 51 | 0] = f >>> 24, o[r + 52 | 0] = e, o[r + 53 | 0] = e >>> 8, o[r + 54 | 0] = e >>> 16, o[r + 55 | 0] = e >>> 24, e = l[18702] | l[18703] << 8 | (l[18704] << 16 | l[18705] << 24), f = l[18698] | l[18699] << 8 | (l[18700] << 16 | l[18701] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[18694] | l[18695] << 8 | (l[18696] << 16 | l[18697] << 24), f = l[18690] | l[18691] << 8 | (l[18692] << 16 | l[18693] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[18686] | l[18687] << 8 | (l[18688] << 16 | l[18689] << 24), f = l[18682] | l[18683] << 8 | (l[18684] << 16 | l[18685] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[18678] | l[18679] << 8 | (l[18680] << 16 | l[18681] << 24), f = l[18674] | l[18675] << 8 | (l[18676] << 16 | l[18677] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18670] | l[18671] << 8 | (l[18672] << 16 | l[18673] << 24), f = l[18666] | l[18667] << 8 | (l[18668] << 16 | l[18669] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, k + 20 | 0), o[k + 31 | 0] >= 0) break i;
                                            X(i[k + 20 >> 2]);
                                            break i;
                                        }
                                        if (w2(e, t & 65535), G4(e, f), f = f + 12 | 0, (n | 0) == (f | 0)) break;
                                    }
                                }
                                if (E4(k, r, e, u), o[k + 19 | 0] < 0 && X(i[k + 8 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 32 | 0;
                        }
                        function Q2(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            w = m - 16 | 0, m = w;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    if (A >>> 0 <= 244) {
                                                                        if (k = i[26378], t = A >>> 0 < 11 ? 16 : A + 11 & 504, A = t >>> 3 | 0, r = k >>> A | 0, r & 3) {
                                                                            e = A + ((r ^ -1) & 1) | 0, r = e << 3, A = r + 105552 | 0, r = i[r + 105560 >> 2], f = i[r + 8 >> 2];
                                                                            u: {
                                                                                if ((A | 0) == (f | 0)) {
                                                                                    _ = 105512, B = b0(-2, e) & k, i[_ >> 2] = B;
                                                                                    break u;
                                                                                }
                                                                                i[f + 12 >> 2] = A, i[A + 8 >> 2] = f;
                                                                            }
                                                                            A = r + 8 | 0, e = e << 3, i[r + 4 >> 2] = e | 3, r = r + e | 0, i[r + 4 >> 2] = i[r + 4 >> 2] | 1;
                                                                            break i;
                                                                        }
                                                                        if (s = i[26380], s >>> 0 >= t >>> 0) break s;
                                                                        if (r) {
                                                                            e = 2 << A, A = Oi((0 - e | e) & r << A), e = A << 3, r = e + 105552 | 0, e = i[e + 105560 >> 2], f = i[e + 8 >> 2];
                                                                            u: {
                                                                                if ((r | 0) == (f | 0)) {
                                                                                    k = b0(-2, A) & k, i[26378] = k;
                                                                                    break u;
                                                                                }
                                                                                i[f + 12 >> 2] = r, i[r + 8 >> 2] = f;
                                                                            }
                                                                            if (i[e + 4 >> 2] = t | 3, u = e + t | 0, A = A << 3, n = A - t | 0, i[u + 4 >> 2] = n | 1, i[A + e >> 2] = n, s) {
                                                                                A = (s & -8) + 105552 | 0, f = i[26383], r = 1 << (s >>> 3);
                                                                                u: {
                                                                                    if (!(r & k)) {
                                                                                        i[26378] = r | k, r = A;
                                                                                        break u;
                                                                                    }
                                                                                    r = i[A + 8 >> 2];
                                                                                }
                                                                                i[A + 8 >> 2] = f, i[r + 12 >> 2] = f, i[f + 12 >> 2] = A, i[f + 8 >> 2] = r;
                                                                            }
                                                                            A = e + 8 | 0, i[26383] = u, i[26380] = n;
                                                                            break i;
                                                                        }
                                                                        if (v = i[26379], !v) break s;
                                                                        for(e = i[(Oi(v) << 2) + 105816 >> 2], n = (i[e + 4 >> 2] & -8) - t | 0, r = e;;){
                                                                            u: {
                                                                                if (A = i[r + 16 >> 2], !A && (A = i[r + 20 >> 2], !A)) break u;
                                                                                f = (i[A + 4 >> 2] & -8) - t | 0, r = f >>> 0 < n >>> 0, n = r ? f : n, e = r ? A : e, r = A;
                                                                                continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        if (h = i[e + 24 >> 2], A = i[e + 12 >> 2], (e | 0) != (A | 0)) {
                                                                            r = i[e + 8 >> 2], i[r + 12 >> 2] = A, i[A + 8 >> 2] = r;
                                                                            break e;
                                                                        }
                                                                        if (r = i[e + 20 >> 2], r) f = e + 20 | 0;
                                                                        else {
                                                                            if (r = i[e + 16 >> 2], !r) break o;
                                                                            f = e + 16 | 0;
                                                                        }
                                                                        for(; u = f, A = r, f = A + 20 | 0, r = i[A + 20 >> 2], !(!r && (f = A + 16 | 0, r = i[A + 16 >> 2], !r)););
                                                                        i[u >> 2] = 0;
                                                                        break e;
                                                                    }
                                                                    if (t = -1, A >>> 0 > 4294967231 || (r = A + 11 | 0, t = r & -8, s = i[26379], !s)) break s;
                                                                    n = 0 - t | 0, k = 0;
                                                                    u: {
                                                                        if (t >>> 0 < 256 || (k = 31, t >>> 0 > 16777215)) break u;
                                                                        A = e1(r >>> 8 | 0), k = ((t >>> 38 - A & 1) - (A << 1) | 0) + 62 | 0;
                                                                    }
                                                                    r = i[(k << 2) + 105816 >> 2];
                                                                    u: {
                                                                        w: {
                                                                            l: {
                                                                                if (!r) {
                                                                                    A = 0;
                                                                                    break l;
                                                                                }
                                                                                for(A = 0, e = t << ((k | 0) != 31 ? 25 - (k >>> 1 | 0) | 0 : 0);;){
                                                                                    h: {
                                                                                        if (u = (i[r + 4 >> 2] & -8) - t | 0, u >>> 0 >= n >>> 0 || (f = r, n = u, n)) break h;
                                                                                        n = 0, A = r;
                                                                                        break w;
                                                                                    }
                                                                                    if (u = i[r + 20 >> 2], r = i[((e >>> 29 & 4) + r | 0) + 16 >> 2], A = u ? (u | 0) == (r | 0) ? A : u : A, e = e << 1, !r) break;
                                                                                }
                                                                            }
                                                                            if (!(A | f)) {
                                                                                if (f = 0, A = 2 << k, A = (0 - A | A) & s, !A) break s;
                                                                                A = i[(Oi(A) << 2) + 105816 >> 2];
                                                                            }
                                                                            if (!A) break u;
                                                                        }
                                                                        for(; e = (i[A + 4 >> 2] & -8) - t | 0, r = e >>> 0 < n >>> 0, n = r ? e : n, f = r ? A : f, r = i[A + 16 >> 2], r ? A = r : A = i[A + 20 >> 2], !!A;);
                                                                    }
                                                                    if (!f | i[26380] - t >>> 0 <= n >>> 0) break s;
                                                                    if (u = i[f + 24 >> 2], A = i[f + 12 >> 2], (f | 0) != (A | 0)) {
                                                                        r = i[f + 8 >> 2], i[r + 12 >> 2] = A, i[A + 8 >> 2] = r;
                                                                        break r;
                                                                    }
                                                                    if (r = i[f + 20 >> 2], r) e = f + 20 | 0;
                                                                    else {
                                                                        if (r = i[f + 16 >> 2], !r) break t;
                                                                        e = f + 16 | 0;
                                                                    }
                                                                    for(; k = e, A = r, e = A + 20 | 0, r = i[A + 20 >> 2], !(!r && (e = A + 16 | 0, r = i[A + 16 >> 2], !r)););
                                                                    i[k >> 2] = 0;
                                                                    break r;
                                                                }
                                                                if (f = i[26380], f >>> 0 >= t >>> 0) {
                                                                    A = i[26383], r = f - t | 0;
                                                                    s: {
                                                                        if (r >>> 0 >= 16) {
                                                                            e = A + t | 0, i[e + 4 >> 2] = r | 1, i[A + f >> 2] = r, i[A + 4 >> 2] = t | 3;
                                                                            break s;
                                                                        }
                                                                        i[A + 4 >> 2] = f | 3, r = A + f | 0, i[r + 4 >> 2] = i[r + 4 >> 2] | 1, e = 0, r = 0;
                                                                    }
                                                                    i[26380] = r, i[26383] = e, A = A + 8 | 0;
                                                                    break i;
                                                                }
                                                                if (e = i[26381], e >>> 0 > t >>> 0) {
                                                                    r = e - t | 0, i[26381] = r, A = i[26384], e = A + t | 0, i[26384] = e, i[e + 4 >> 2] = r | 1, i[A + 4 >> 2] = t | 3, A = A + 8 | 0;
                                                                    break i;
                                                                }
                                                                if (A = 0, n = t + 47 | 0, i[26496] ? r = i[26498] : (i[26499] = -1, i[26500] = -1, i[26497] = 4096, i[26498] = 4096, i[26496] = w + 12 & -16 ^ 1431655768, i[26501] = 0, i[26489] = 0, r = 4096), k = n + r | 0, u = 0 - r | 0, r = k & u, r >>> 0 <= t >>> 0 || (s = i[26488], s && (h = i[26486], f = h + r | 0, f >>> 0 <= h >>> 0 | f >>> 0 > s >>> 0))) break i;
                                                                s: {
                                                                    if (!(l[105956] & 4)) {
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        if (f = i[26384], f) for(A = 105960;;){
                                                                                            if (s = i[A >> 2], s >>> 0 <= f >>> 0 & f >>> 0 < s + i[A + 4 >> 2] >>> 0) break h;
                                                                                            if (A = i[A + 8 >> 2], !A) break;
                                                                                        }
                                                                                        if (e = g6(0), (e | 0) == -1 || (k = r, A = i[26497], f = A - 1 | 0, f & e && (k = (r - e | 0) + (e + f & 0 - A) | 0), k >>> 0 <= t >>> 0) || (f = i[26488], f && (u = i[26486], A = u + k | 0, A >>> 0 <= u >>> 0 | A >>> 0 > f >>> 0))) break u;
                                                                                        if (A = g6(k), (e | 0) != (A | 0)) break l;
                                                                                        break s;
                                                                                    }
                                                                                    if (k = u & k - e, e = g6(k), (e | 0) == (i[A >> 2] + i[A + 4 >> 2] | 0)) break w;
                                                                                    A = e;
                                                                                }
                                                                                if ((A | 0) == -1) break u;
                                                                                if (t + 48 >>> 0 <= k >>> 0) {
                                                                                    e = A;
                                                                                    break s;
                                                                                }
                                                                                if (e = i[26498], e = e + (n - k | 0) & 0 - e, (g6(e) | 0) == -1) break u;
                                                                                k = e + k | 0, e = A;
                                                                                break s;
                                                                            }
                                                                            if ((e | 0) != -1) break s;
                                                                        }
                                                                        i[26489] = i[26489] | 4;
                                                                    }
                                                                    if (e = g6(r), A = g6(0), (e | 0) == -1 | (A | 0) == -1 | A >>> 0 <= e >>> 0 || (k = A - e | 0, k >>> 0 <= t + 40 >>> 0)) break f;
                                                                }
                                                                A = i[26486] + k | 0, i[26486] = A, A >>> 0 > k0[26487] && (i[26487] = A);
                                                                s: {
                                                                    if (n = i[26384], n) {
                                                                        for(A = 105960;;){
                                                                            if (r = i[A >> 2], f = i[A + 4 >> 2], (r + f | 0) == (e | 0)) break s;
                                                                            if (A = i[A + 8 >> 2], !A) break;
                                                                        }
                                                                        break n;
                                                                    }
                                                                    for(A = i[26382], A >>> 0 <= e >>> 0 && A || (i[26382] = e), A = 0, i[26491] = k, i[26490] = e, i[26386] = -1, i[26387] = i[26496], i[26493] = 0; r = A << 3, f = r + 105552 | 0, i[r + 105560 >> 2] = f, i[r + 105564 >> 2] = f, A = A + 1 | 0, (A | 0) != 32;);
                                                                    A = k - 40 | 0, r = -8 - e & 7, f = A - r | 0, i[26381] = f, r = r + e | 0, i[26384] = r, i[r + 4 >> 2] = f | 1, i[(A + e | 0) + 4 >> 2] = 40, i[26385] = i[26500];
                                                                    break k;
                                                                }
                                                                if (i[A + 12 >> 2] & 8 | (e >>> 0 <= n >>> 0 | r >>> 0 > n >>> 0)) break n;
                                                                i[A + 4 >> 2] = f + k, A = -8 - n & 7, r = A + n | 0, i[26384] = r, e = i[26381] + k | 0, A = e - A | 0, i[26381] = A, i[r + 4 >> 2] = A | 1, i[(e + n | 0) + 4 >> 2] = 40, i[26385] = i[26500];
                                                                break k;
                                                            }
                                                            A = 0;
                                                            break e;
                                                        }
                                                        A = 0;
                                                        break r;
                                                    }
                                                    k0[26382] > e >>> 0 && (i[26382] = e), f = e + k | 0, A = 105960;
                                                    n: {
                                                        for(;;){
                                                            if (r = i[A >> 2], (r | 0) != (f | 0)) {
                                                                if (A = i[A + 8 >> 2], A) continue;
                                                                break n;
                                                            }
                                                            break;
                                                        }
                                                        if (!(l[A + 12 | 0] & 8)) break A;
                                                    }
                                                    for(A = 105960;;){
                                                        n: {
                                                            if (r = i[A >> 2], r >>> 0 <= n >>> 0 && (f = r + i[A + 4 >> 2] | 0, f >>> 0 > n >>> 0)) break n;
                                                            A = i[A + 8 >> 2];
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    for(A = k - 40 | 0, r = -8 - e & 7, u = A - r | 0, i[26381] = u, r = r + e | 0, i[26384] = r, i[r + 4 >> 2] = u | 1, i[(A + e | 0) + 4 >> 2] = 40, i[26385] = i[26500], A = (f + (39 - f & 7) | 0) - 47 | 0, r = A >>> 0 < n + 16 >>> 0 ? n : A, i[r + 4 >> 2] = 27, A = i[26493], i[r + 16 >> 2] = i[26492], i[r + 20 >> 2] = A, A = i[26491], i[r + 8 >> 2] = i[26490], i[r + 12 >> 2] = A, i[26492] = r + 8, i[26491] = k, i[26490] = e, i[26493] = 0, A = r + 24 | 0; i[A + 4 >> 2] = 7, e = A + 8 | 0, A = A + 4 | 0, e >>> 0 < f >>> 0;);
                                                    if ((r | 0) == (n | 0)) break k;
                                                    i[r + 4 >> 2] = i[r + 4 >> 2] & -2, e = r - n | 0, i[n + 4 >> 2] = e | 1, i[r >> 2] = e;
                                                    n: {
                                                        if (e >>> 0 <= 255) {
                                                            A = (e & -8) + 105552 | 0, r = i[26378], e = 1 << (e >>> 3);
                                                            t: {
                                                                if (!(r & e)) {
                                                                    i[26378] = r | e, r = A;
                                                                    break t;
                                                                }
                                                                r = i[A + 8 >> 2];
                                                            }
                                                            i[A + 8 >> 2] = n, i[r + 12 >> 2] = n, f = 8, e = 12;
                                                            break n;
                                                        }
                                                        A = 31, e >>> 0 <= 16777215 && (A = e1(e >>> 8 | 0), A = ((e >>> 38 - A & 1) - (A << 1) | 0) + 62 | 0), i[n + 28 >> 2] = A, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, r = (A << 2) + 105816 | 0;
                                                        t: {
                                                            f = i[26379], k = 1 << A;
                                                            o: {
                                                                if (!(f & k)) {
                                                                    i[26379] = f | k, i[r >> 2] = n;
                                                                    break o;
                                                                }
                                                                for(A = e << ((A | 0) != 31 ? 25 - (A >>> 1 | 0) | 0 : 0), f = i[r >> 2];;){
                                                                    if (r = f, (e | 0) == (i[r + 4 >> 2] & -8)) break t;
                                                                    if (f = A >>> 29 | 0, A = A << 1, k = (f & 4) + r | 0, f = i[k + 16 >> 2], !f) break;
                                                                }
                                                                i[k + 16 >> 2] = n;
                                                            }
                                                            i[n + 24 >> 2] = r, r = n, A = r, f = 12, e = 8;
                                                            break n;
                                                        }
                                                        A = i[r + 8 >> 2], i[A + 12 >> 2] = n, i[r + 8 >> 2] = n, i[n + 8 >> 2] = A, A = 0, f = 12, e = 24;
                                                    }
                                                    i[f + n >> 2] = r, i[e + n >> 2] = A;
                                                }
                                                if (A = i[26381], A >>> 0 <= t >>> 0) break f;
                                                r = A - t | 0, i[26381] = r, A = i[26384], e = A + t | 0, i[26384] = e, i[e + 4 >> 2] = r | 1, i[A + 4 >> 2] = t | 3, A = A + 8 | 0;
                                                break i;
                                            }
                                            i[26064] = 48, A = 0;
                                            break i;
                                        }
                                        i[A >> 2] = e, i[A + 4 >> 2] = i[A + 4 >> 2] + k, h = (-8 - e & 7) + e | 0, i[h + 4 >> 2] = t | 3, k = r + (-8 - r & 7) | 0, n = t + h | 0, s = k - n | 0;
                                        A: {
                                            if (i[26384] == (k | 0)) {
                                                i[26384] = n, A = i[26381] + s | 0, i[26381] = A, i[n + 4 >> 2] = A | 1;
                                                break A;
                                            }
                                            if (i[26383] == (k | 0)) {
                                                i[26383] = n, A = i[26380] + s | 0, i[26380] = A, i[n + 4 >> 2] = A | 1, i[A + n >> 2] = A;
                                                break A;
                                            }
                                            if (A = i[k + 4 >> 2], (A & 3) == 1) {
                                                t = A & -8, e = i[k + 12 >> 2];
                                                f: {
                                                    if (A >>> 0 <= 255) {
                                                        if (r = i[k + 8 >> 2], (r | 0) == (e | 0)) {
                                                            _ = 105512, B = i[26378] & b0(-2, A >>> 3 | 0), i[_ >> 2] = B;
                                                            break f;
                                                        }
                                                        i[r + 12 >> 2] = e, i[e + 8 >> 2] = r;
                                                        break f;
                                                    }
                                                    u = i[k + 24 >> 2];
                                                    k: {
                                                        if ((e | 0) != (k | 0)) {
                                                            A = i[k + 8 >> 2], i[A + 12 >> 2] = e, i[e + 8 >> 2] = A;
                                                            break k;
                                                        }
                                                        n: {
                                                            if (A = i[k + 20 >> 2], A) r = k + 20 | 0;
                                                            else {
                                                                if (A = i[k + 16 >> 2], !A) break n;
                                                                r = k + 16 | 0;
                                                            }
                                                            for(; f = r, e = A, r = A + 20 | 0, A = i[A + 20 >> 2], !(!A && (r = e + 16 | 0, A = i[e + 16 >> 2], !A)););
                                                            i[f >> 2] = 0;
                                                            break k;
                                                        }
                                                        e = 0;
                                                    }
                                                    if (!u) break f;
                                                    A = i[k + 28 >> 2], r = (A << 2) + 105816 | 0;
                                                    k: {
                                                        if (i[r >> 2] == (k | 0)) {
                                                            if (i[r >> 2] = e, e) break k;
                                                            _ = 105516, B = i[26379] & b0(-2, A), i[_ >> 2] = B;
                                                            break f;
                                                        }
                                                        if (i[u + (i[u + 16 >> 2] == (k | 0) ? 16 : 20) >> 2] = e, !e) break f;
                                                    }
                                                    if (i[e + 24 >> 2] = u, A = i[k + 16 >> 2], A && (i[e + 16 >> 2] = A, i[A + 24 >> 2] = e), A = i[k + 20 >> 2], !A) break f;
                                                    i[e + 20 >> 2] = A, i[A + 24 >> 2] = e;
                                                }
                                                s = t + s | 0, k = k + t | 0, A = i[k + 4 >> 2];
                                            }
                                            if (i[k + 4 >> 2] = A & -2, i[n + 4 >> 2] = s | 1, i[n + s >> 2] = s, s >>> 0 <= 255) {
                                                A = (s & -8) + 105552 | 0, r = i[26378], e = 1 << (s >>> 3);
                                                f: {
                                                    if (!(r & e)) {
                                                        i[26378] = r | e, r = A;
                                                        break f;
                                                    }
                                                    r = i[A + 8 >> 2];
                                                }
                                                i[A + 8 >> 2] = n, i[r + 12 >> 2] = n, i[n + 12 >> 2] = A, i[n + 8 >> 2] = r;
                                                break A;
                                            }
                                            e = 31, s >>> 0 <= 16777215 && (A = e1(s >>> 8 | 0), e = ((s >>> 38 - A & 1) - (A << 1) | 0) + 62 | 0), i[n + 28 >> 2] = e, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, A = (e << 2) + 105816 | 0;
                                            f: {
                                                r = i[26379], f = 1 << e;
                                                k: {
                                                    if (!(r & f)) {
                                                        i[26379] = r | f, i[A >> 2] = n;
                                                        break k;
                                                    }
                                                    for(e = s << ((e | 0) != 31 ? 25 - (e >>> 1 | 0) | 0 : 0), r = i[A >> 2];;){
                                                        if (A = r, (i[A + 4 >> 2] & -8) == (s | 0)) break f;
                                                        if (r = e >>> 29 | 0, e = e << 1, f = (r & 4) + A | 0, r = i[f + 16 >> 2], !r) break;
                                                    }
                                                    i[f + 16 >> 2] = n;
                                                }
                                                i[n + 24 >> 2] = A, i[n + 12 >> 2] = n, i[n + 8 >> 2] = n;
                                                break A;
                                            }
                                            r = i[A + 8 >> 2], i[r + 12 >> 2] = n, i[A + 8 >> 2] = n, i[n + 24 >> 2] = 0, i[n + 12 >> 2] = A, i[n + 8 >> 2] = r;
                                        }
                                        A = h + 8 | 0;
                                        break i;
                                    }
                                    r: {
                                        if (!u) break r;
                                        r = i[f + 28 >> 2], e = (r << 2) + 105816 | 0;
                                        A: {
                                            if (i[e >> 2] == (f | 0)) {
                                                if (i[e >> 2] = A, A) break A;
                                                s = b0(-2, r) & s, i[26379] = s;
                                                break r;
                                            }
                                            if (i[u + (i[u + 16 >> 2] == (f | 0) ? 16 : 20) >> 2] = A, !A) break r;
                                        }
                                        if (i[A + 24 >> 2] = u, r = i[f + 16 >> 2], r && (i[A + 16 >> 2] = r, i[r + 24 >> 2] = A), r = i[f + 20 >> 2], !r) break r;
                                        i[A + 20 >> 2] = r, i[r + 24 >> 2] = A;
                                    }
                                    r: {
                                        if (n >>> 0 <= 15) {
                                            A = n + t | 0, i[f + 4 >> 2] = A | 3, A = A + f | 0, i[A + 4 >> 2] = i[A + 4 >> 2] | 1;
                                            break r;
                                        }
                                        if (i[f + 4 >> 2] = t | 3, k = f + t | 0, i[k + 4 >> 2] = n | 1, i[n + k >> 2] = n, n >>> 0 <= 255) {
                                            A = (n & -8) + 105552 | 0, r = i[26378], e = 1 << (n >>> 3);
                                            A: {
                                                if (!(r & e)) {
                                                    i[26378] = r | e, r = A;
                                                    break A;
                                                }
                                                r = i[A + 8 >> 2];
                                            }
                                            i[A + 8 >> 2] = k, i[r + 12 >> 2] = k, i[k + 12 >> 2] = A, i[k + 8 >> 2] = r;
                                            break r;
                                        }
                                        A = 31, n >>> 0 <= 16777215 && (A = e1(n >>> 8 | 0), A = ((n >>> 38 - A & 1) - (A << 1) | 0) + 62 | 0), i[k + 28 >> 2] = A, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, r = (A << 2) + 105816 | 0;
                                        A: {
                                            e = 1 << A;
                                            f: {
                                                if (!(e & s)) {
                                                    i[26379] = e | s, i[r >> 2] = k, i[k + 24 >> 2] = r;
                                                    break f;
                                                }
                                                for(A = n << ((A | 0) != 31 ? 25 - (A >>> 1 | 0) | 0 : 0), r = i[r >> 2];;){
                                                    if (e = r, (i[r + 4 >> 2] & -8) == (n | 0)) break A;
                                                    if (u = A >>> 29 | 0, A = A << 1, u = r + (u & 4) | 0, r = i[u + 16 >> 2], !r) break;
                                                }
                                                i[u + 16 >> 2] = k, i[k + 24 >> 2] = e;
                                            }
                                            i[k + 12 >> 2] = k, i[k + 8 >> 2] = k;
                                            break r;
                                        }
                                        A = i[e + 8 >> 2], i[A + 12 >> 2] = k, i[e + 8 >> 2] = k, i[k + 24 >> 2] = 0, i[k + 12 >> 2] = e, i[k + 8 >> 2] = A;
                                    }
                                    A = f + 8 | 0;
                                    break i;
                                }
                                e: {
                                    if (!h) break e;
                                    r = i[e + 28 >> 2], f = (r << 2) + 105816 | 0;
                                    r: {
                                        if (i[f >> 2] == (e | 0)) {
                                            if (i[f >> 2] = A, A) break r;
                                            _ = 105516, B = b0(-2, r) & v, i[_ >> 2] = B;
                                            break e;
                                        }
                                        if (i[h + (i[h + 16 >> 2] == (e | 0) ? 16 : 20) >> 2] = A, !A) break e;
                                    }
                                    if (i[A + 24 >> 2] = h, r = i[e + 16 >> 2], r && (i[A + 16 >> 2] = r, i[r + 24 >> 2] = A), r = i[e + 20 >> 2], !r) break e;
                                    i[A + 20 >> 2] = r, i[r + 24 >> 2] = A;
                                }
                                e: {
                                    if (n >>> 0 <= 15) {
                                        A = n + t | 0, i[e + 4 >> 2] = A | 3, A = A + e | 0, i[A + 4 >> 2] = i[A + 4 >> 2] | 1;
                                        break e;
                                    }
                                    if (i[e + 4 >> 2] = t | 3, u = e + t | 0, i[u + 4 >> 2] = n | 1, i[n + u >> 2] = n, s) {
                                        A = (s & -8) + 105552 | 0, f = i[26383], r = 1 << (s >>> 3);
                                        r: {
                                            if (!(r & k)) {
                                                i[26378] = r | k, r = A;
                                                break r;
                                            }
                                            r = i[A + 8 >> 2];
                                        }
                                        i[A + 8 >> 2] = f, i[r + 12 >> 2] = f, i[f + 12 >> 2] = A, i[f + 8 >> 2] = r;
                                    }
                                    i[26383] = u, i[26380] = n;
                                }
                                A = e + 8 | 0;
                            }
                            return m = w + 16 | 0, A | 0;
                        }
                        function w3() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = m - 16 | 0, m = e, f = i[21712], r = i[21713];
                            i: {
                                if ((f | 0) != (r | 0)) break i;
                                A = D(16), i[A + 12 >> 2] = 85468, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 83576, i[e + 12 >> 2] = A, k = A + 12 | 0, i[e + 8 >> 2] = k;
                                e: {
                                    if (f >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = k, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85612, i[A >> 2] = 83624, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 83704, i[A >> 2] = 83664, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 83780, i[A >> 2] = 83740, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85360, i[A >> 2] = 83816, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85396, i[A >> 2] = 83856, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85432, i[A >> 2] = 83896, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85504, i[A >> 2] = 83936, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85540, i[A >> 2] = 83976, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85684, i[A >> 2] = 84016, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85720, i[A >> 2] = 84056, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85648, i[A >> 2] = 84096, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85576, i[A >> 2] = 84136, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85252, i[A >> 2] = 84176, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84256, i[A >> 2] = 84216, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84332, i[A >> 2] = 84292, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85216, i[A >> 2] = 84368, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85288, i[A >> 2] = 84408, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85828, i[A >> 2] = 84448, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85756, i[A >> 2] = 84488, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85792, i[A >> 2] = 84528, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84608, i[A >> 2] = 84568, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84684, i[A >> 2] = 84644, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84760, i[A >> 2] = 84720, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84836, i[A >> 2] = 84796, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84912, i[A >> 2] = 84872, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 84988, i[A >> 2] = 84948, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85064, i[A >> 2] = 85024, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = D(16), i[A + 12 >> 2] = 85140, i[A >> 2] = 85100, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713];
                                e: {
                                    if (r >>> 0 < k0[21714]) {
                                        i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                        break e;
                                    }
                                    if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = D(16), i[A + 12 >> 2] = 85324, i[A >> 2] = 85176, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[e + 12 >> 2] = A, f = A + 12 | 0, i[e + 8 >> 2] = f, r = i[21713], r >>> 0 < k0[21714]) {
                                    i[r + 4 >> 2] = A, i[r >> 2] = f, i[21713] = r + 8;
                                    break i;
                                }
                                if (n = 86852, t = p2(86848, e + 8 | 0), i[n >> 2] = t, A = i[e + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = e + 16 | 0;
                        }
                        function Q7(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            v = m - 48 | 0, m = v;
                            i: {
                                e: {
                                    if (!e) {
                                        if (o[v + 12 | 0] = 0, o[v + 23 | 0] = 0, e = A, A = i0(v + 24 | 0, 5, 2001, v + 12 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[v + 23 | 0] >= 0) break e;
                                        X(i[v + 12 >> 2]);
                                        break e;
                                    }
                                    if (i[e >> 2] != 1) {
                                        if (o[v + 12 | 0] = 0, o[v + 23 | 0] = 0, e = i0(v + 24 | 0, 5, 2004, v + 12 | 0), o[v + 23 | 0] < 0 && X(i[v + 12 >> 2]), j0(A, e, i[r >> 2]), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    if (i[v + 32 >> 2] = 0, i[v + 36 >> 2] = 0, i[v + 24 >> 2] = 0, i[v + 28 >> 2] = 0, _ = v + 24 | 0, W = m - 32 | 0, m = W, s = i[r >> 2], n = i[s + 16 >> 2], B = s + 20 | 0, (n | 0) != (B | 0)) for(;;){
                                        if (t = i[n + 20 >> 2], k = i[t + 212 >> 2], u = i[t + 216 >> 2], (k | 0) != (u | 0)) for(; w = i[s + 48 >> 2], h = i[k >> 2], G = i[n + 16 >> 2], t = D(4), i[W >> 2] = t, C = t + 4 | 0, i[W + 8 >> 2] = C, i[t >> 2] = G, i[W + 4 >> 2] = C, J4(w, h, 1667527523, W), t = i[W >> 2], t && (i[W + 4 >> 2] = t, X(t)), k = k + 4 | 0, (u | 0) != (k | 0););
                                        t = i[n + 4 >> 2];
                                        r: {
                                            if (t) {
                                                for(;;)if (k = t, t = i[k >> 2], !t) break r;
                                            }
                                            for(; k = i[n + 8 >> 2], t = i[k >> 2] != (n | 0), n = k, !!t;);
                                        }
                                        if (n = k, (k | 0) == (B | 0)) break;
                                    }
                                    if (k = i[s + 128 >> 2], C = i[s + 132 >> 2], (k | 0) != (C | 0)) for(;;){
                                        i[W + 28 >> 2] = 0, i[W + 20 >> 2] = 0, i[W + 24 >> 2] = 0, u = i[k >> 2], G = W + 20 | 0, w = 0, n = m - 32 | 0, m = n, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, f2(n + 16 | 0, 0);
                                        r: {
                                            A: {
                                                if (!(k0[u + 4 >> 2] > 65535 | k0[u + 8 >> 2] >= 65536)) {
                                                    w = 1;
                                                    break A;
                                                }
                                                if (h = 2, t = i[u + 12 >> 2], V = i[u + 16 >> 2], (t | 0) == (V | 0)) break r;
                                                for(;;){
                                                    if (w = i[t >> 2], w = p[i[i[w >> 2] + 16 >> 2]](w) | 0, w) break A;
                                                    if (t = t + 8 | 0, (V | 0) == (t | 0)) break;
                                                }
                                                break r;
                                            }
                                            h = 4;
                                        }
                                        t = n + 16 | 0, f2(t, w), l1(t, h, i[u + 4 >> 2], 0), l1(t, h, i[u + 8 >> 2], 0);
                                        r: {
                                            A: {
                                                t = i[u + 16 >> 2] - i[u + 12 >> 2] >> 3;
                                                f: {
                                                    if (t >>> 0 >= 256) {
                                                        if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(W, 9, 5004, n + 4 | 0), o[n + 15 | 0] >= 0) break f;
                                                        X(i[n + 4 >> 2]);
                                                        break f;
                                                    }
                                                    if (f2(n + 16 | 0, t & 255), t = i[u + 12 >> 2], u = i[u + 16 >> 2], (t | 0) != (u | 0)) for(; w = i[t >> 2], p[i[i[w >> 2] + 20 >> 2]](w, n + 16 | 0, h), t = t + 8 | 0, (u | 0) != (t | 0););
                                                    if (w = 0, i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, t = 0, u = i[n + 20 >> 2], h = i[n + 16 >> 2], (u | 0) != (h | 0)) {
                                                        if (u = u - h | 0, (u | 0) < 0) break A;
                                                        t = D(u), i[n + 4 >> 2] = t, w = t + u | 0, i[n + 12 >> 2] = w, v0(t, h, u), i[n + 8 >> 2] = w;
                                                    }
                                                    if ((G | 0) != (n + 4 | 0) && (b4(G, t, w, w - t | 0), t = i[n + 4 >> 2]), t && (i[n + 8 >> 2] = t, X(t)), t = i[21669], i[W >> 2] = i[21668], i[W + 4 >> 2] = t, t = W + 8 | 0, o[86691] >= 0) {
                                                        u = i[21671], i[t >> 2] = i[21670], i[t + 4 >> 2] = u, i[t + 8 >> 2] = i[21672];
                                                        break f;
                                                    }
                                                    j(t, i[21670], i[21671]);
                                                }
                                                t = i[n + 16 >> 2], t && (i[n + 20 >> 2] = t, X(t)), m = n + 32 | 0;
                                                break r;
                                            }
                                            p0(), z();
                                        }
                                        if (x8(i[s + 48 >> 2], i[i[k >> 2] >> 2], G, 0), o[W + 19 | 0] < 0 && X(i[W + 8 >> 2]), n = i[W + 20 >> 2], n && (i[W + 24 >> 2] = n, X(n)), k = k + 8 | 0, (C | 0) == (k | 0)) break;
                                    }
                                    if (n = i[s + 16 >> 2], (B | 0) != (n | 0)) for(;;){
                                        k = i[n + 20 >> 2], p[i[i[k >> 2] + 52 >> 2]](k), t = i[n + 4 >> 2];
                                        r: {
                                            if (t) {
                                                for(;;)if (k = t, t = i[k >> 2], !t) break r;
                                            }
                                            for(; k = i[n + 8 >> 2], t = i[k >> 2] != (n | 0), n = k, !!t;);
                                        }
                                        if (n = k, (k | 0) == (B | 0)) break;
                                    }
                                    t = i[s + 48 >> 2], G = i[t + 60 >> 2], w = i[t + 64 >> 2], w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1, t = i[s + 48 >> 2]), i[W >> 2] = i[t + 52 >> 2], k = i[t + 56 >> 2], i[W + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = 0, t = 0, h = m - 16 | 0, m = h, u = i[W >> 2], i[h + 12 >> 2] = 0, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0;
                                    r: {
                                        A: {
                                            if (n = i[u + 36 >> 2], B = i[u + 40 >> 2], (n | 0) != (B | 0)) {
                                                if (k = B - n | 0, (k | 0) < 0) break A;
                                                for(t = D(k), i[h + 4 >> 2] = t, i[h + 12 >> 2] = k + t, k = t; i[k >> 2] = i[n >> 2], u = i[n + 4 >> 2], i[k + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), k = k + 8 | 0, n = n + 8 | 0, (B | 0) != (n | 0););
                                                i[h + 8 >> 2] = k;
                                            }
                                            if (B = i[G + 104 >> 2], R = i[G + 108 >> 2], (B | 0) != (R | 0)) for(V = t - 8 | 0;;){
                                                if (y = 0, M = (i[B + 8 >> 2] - i[B + 4 >> 2] >> 2) - 1 | 0, G = M, G) for(;;){
                                                    for(H = G >>> 0 <= 1 ? 1 : G, n = 0;;){
                                                        u = n, n = n + 1 | 0, u = u << 2, C = i[V + (I[(u + i[B + 4 >> 2] | 0) + 2 >> 1] << 3) >> 2];
                                                        f: {
                                                            if (!(p[i[i[C >> 2] + 36 >> 2]](C) | 0) || (C = n << 2, F = i[V + (I[(C + i[B + 4 >> 2] | 0) + 2 >> 1] << 3) >> 2], p[i[i[F >> 2] + 36 >> 2]](F) | 0)) break f;
                                                            E = i[B + 4 >> 2], u = E + u | 0, F = I[u >> 1] | I[u + 2 >> 1] << 16, C = C + E | 0, E = I[C >> 1] | I[C + 2 >> 1] << 16, Q[u >> 1] = E, Q[u + 2 >> 1] = E >>> 16, Q[C >> 1] = F, Q[C + 2 >> 1] = F >>> 16;
                                                        }
                                                        if ((n | 0) == (H | 0)) break;
                                                    }
                                                    if (G = G - 1 | 0, y = y + 1 | 0, (M | 0) == (y | 0)) break;
                                                }
                                                if (B = B + 16 | 0, (R | 0) == (B | 0)) break;
                                            }
                                            if (t) {
                                                if ((k | 0) != (t | 0)) {
                                                    for(;;){
                                                        n = i[k - 4 >> 2];
                                                        f: {
                                                            if (!n || (u = i[n + 4 >> 2], i[n + 4 >> 2] = u - 1, u)) break f;
                                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                        }
                                                        if (k = k - 8 | 0, (k | 0) == (t | 0)) break;
                                                    }
                                                    t = i[h + 4 >> 2];
                                                }
                                                X(t);
                                            }
                                            m = h + 16 | 0;
                                            break r;
                                        }
                                        p0(), z();
                                    }
                                    k = i[W + 4 >> 2];
                                    r: {
                                        if (!k || (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    r: {
                                        if (!w || (k = i[w + 4 >> 2], i[w + 4 >> 2] = k - 1, k)) break r;
                                        p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                    }
                                    if (w = m - 48 | 0, m = w, t = i[s + 48 >> 2], k = i[t + 16 >> 2], n = i[t + 20 >> 2], (k | 0) != (n | 0)) for(; pt(i[k >> 2]), u = i[k >> 2], p[i[i[u >> 2] + 16 >> 2]](w + 28 | 0, u, _), o[w + 47 | 0] < 0 && X(i[w + 36 >> 2]), k = k + 8 | 0, (n | 0) != (k | 0););
                                    if (n = 0, u = m - 176 | 0, m = u, t = i[t + 68 >> 2], s = i[t + 104 >> 2], h = i[t + 108 >> 2], (s | 0) != (h | 0)) for(;;){
                                        r: {
                                            if (l[s + 4 | 0] || (k = i[s + 16 >> 2], B = i[s + 20 >> 2], (k | 0) == (B | 0))) break r;
                                            for(; n = i[k + 16 >> 2] + n | 0, k = k + 40 | 0, (B | 0) != (k | 0););
                                        }
                                        if (s = s + 32 | 0, (h | 0) == (s | 0)) break;
                                    }
                                    l2(_, n + 8 | 0), l2(_, 1835295092), l[t + 132 | 0] && _t(i[t + 136 >> 2], 0, 0, 0), B = w + 8 | 0;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            if (n = i[t + 104 >> 2], C = i[t + 108 >> 2], (n | 0) != (C | 0)) for(;;){
                                                                o: {
                                                                    if (l[n + 4 | 0] || (i[n + 8 >> 2] = i[_ + 12 >> 2], i[n + 12 >> 2] = 0, k = i[n + 16 >> 2], V = i[n + 20 >> 2], (k | 0) == (V | 0))) break o;
                                                                    for(;;){
                                                                        s = i[_ + 12 >> 2], h = i[n + 8 >> 2], G = s - h | 0, s = 0 - (i[n + 12 >> 2] + (s >>> 0 < h >>> 0) | 0) | 0, i[k + 8 >> 2] = G, i[k + 12 >> 2] = s;
                                                                        s: {
                                                                            if (l[t + 132 | 0] == 1) {
                                                                                h = i[k + 16 >> 2], G = 0, i[u + 172 >> 2] = 0, i[u + 164 >> 2] = 0, i[u + 168 >> 2] = 0;
                                                                                u: {
                                                                                    if (!h) {
                                                                                        s = 0;
                                                                                        break u;
                                                                                    }
                                                                                    if ((h | 0) < 0) break t;
                                                                                    s = D(h), i[u + 164 >> 2] = s, G = s + h | 0, i[u + 172 >> 2] = G, B0(s, 0, h), i[u + 168 >> 2] = G, G = i[k + 16 >> 2];
                                                                                }
                                                                                if (y = i[t + 136 >> 2], h = m - 16 | 0, m = h, i[h + 12 >> 2] = G, i[h + 8 >> 2] = s, s = h7(y | 0, h + 8 | 0, 1, h + 4 | 0) | 0, s ? (i[26064] = s, s = -1) : s = 0, m = h + 16 | 0, s = s ? -1 : i[h + 4 >> 2], (s | 0) < 0) {
                                                                                    i[u + 28 >> 2] = 59808, i[u + 84 >> 2] = 59828, k = i[14961], i[u + 20 >> 2] = k, n = i[k - 12 >> 2], k = u + 20 | 0, i[n + k >> 2] = i[14962], i[u + 24 >> 2] = 0, n = k + i[i[u + 20 >> 2] - 12 >> 2] | 0, t = u + 32 | 0, T0(n, t), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, n = i[14963], i[u + 28 >> 2] = n, s = i[n - 12 >> 2], n = u + 28 | 0, i[s + n >> 2] = i[14964], _ = i[14960], i[u + 20 >> 2] = _, i[k + i[_ - 12 >> 2] >> 2] = i[14965], i[u + 84 >> 2] = 59828, i[u + 20 >> 2] = 59788, i[u + 28 >> 2] = 59808, _ = z0(t), i[_ >> 2] = 58864, i[u + 72 >> 2] = 0, i[u + 76 >> 2] = 0, i[u + 64 >> 2] = 0, i[u + 68 >> 2] = 0, i[u + 80 >> 2] = 24, P0(U(n, 21501, 33), i[26064]), k = i[u + 80 >> 2];
                                                                                    u: {
                                                                                        if (k & 16) {
                                                                                            n = u + 52 | 0, t = i[u + 76 >> 2], k = i[u + 56 >> 2], t >>> 0 < k >>> 0 ? i[u + 76 >> 2] = k : k = t;
                                                                                            break u;
                                                                                        }
                                                                                        if (!(k & 8)) {
                                                                                            k = 0, o[u + 19 | 0] = 0, n = u + 8 | 0;
                                                                                            break f;
                                                                                        }
                                                                                        n = u + 40 | 0, k = i[u + 48 >> 2];
                                                                                    }
                                                                                    if (t = i[n >> 2], k = k - t | 0, k >>> 0 >= 2147483640) break n;
                                                                                    if (k >>> 0 >= 11) {
                                                                                        s = (k | 7) + 1 | 0, n = D(s), i[u + 16 >> 2] = s | -2147483648, i[u + 8 >> 2] = n, i[u + 12 >> 2] = k;
                                                                                        break k;
                                                                                    }
                                                                                    if (o[u + 19 | 0] = k, n = u + 8 | 0, k) break k;
                                                                                    k = 0;
                                                                                    break f;
                                                                                }
                                                                                if (i[k + 16 >> 2] != (s | 0) | i[k + 20 >> 2]) {
                                                                                    if (k = D(40), i[u + 20 >> 2] = k, i[u + 24 >> 2] = 37, i[u + 28 >> 2] = -2147483608, n = l[1525] | l[1526] << 8 | (l[1527] << 16 | l[1528] << 24), t = l[1521] | l[1522] << 8 | (l[1523] << 16 | l[1524] << 24), o[k | 0] = t, o[k + 1 | 0] = t >>> 8, o[k + 2 | 0] = t >>> 16, o[k + 3 | 0] = t >>> 24, o[k + 4 | 0] = n, o[k + 5 | 0] = n >>> 8, o[k + 6 | 0] = n >>> 16, o[k + 7 | 0] = n >>> 24, o[k + 37 | 0] = 0, n = l[1554] | l[1555] << 8 | (l[1556] << 16 | l[1557] << 24), t = l[1550] | l[1551] << 8 | (l[1552] << 16 | l[1553] << 24), o[k + 29 | 0] = t, o[k + 30 | 0] = t >>> 8, o[k + 31 | 0] = t >>> 16, o[k + 32 | 0] = t >>> 24, o[k + 33 | 0] = n, o[k + 34 | 0] = n >>> 8, o[k + 35 | 0] = n >>> 16, o[k + 36 | 0] = n >>> 24, n = l[1549] | l[1550] << 8 | (l[1551] << 16 | l[1552] << 24), t = l[1545] | l[1546] << 8 | (l[1547] << 16 | l[1548] << 24), o[k + 24 | 0] = t, o[k + 25 | 0] = t >>> 8, o[k + 26 | 0] = t >>> 16, o[k + 27 | 0] = t >>> 24, o[k + 28 | 0] = n, o[k + 29 | 0] = n >>> 8, o[k + 30 | 0] = n >>> 16, o[k + 31 | 0] = n >>> 24, n = l[1541] | l[1542] << 8 | (l[1543] << 16 | l[1544] << 24), t = l[1537] | l[1538] << 8 | (l[1539] << 16 | l[1540] << 24), o[k + 16 | 0] = t, o[k + 17 | 0] = t >>> 8, o[k + 18 | 0] = t >>> 16, o[k + 19 | 0] = t >>> 24, o[k + 20 | 0] = n, o[k + 21 | 0] = n >>> 8, o[k + 22 | 0] = n >>> 16, o[k + 23 | 0] = n >>> 24, n = l[1533] | l[1534] << 8 | (l[1535] << 16 | l[1536] << 24), t = l[1529] | l[1530] << 8 | (l[1531] << 16 | l[1532] << 24), o[k + 8 | 0] = t, o[k + 9 | 0] = t >>> 8, o[k + 10 | 0] = t >>> 16, o[k + 11 | 0] = t >>> 24, o[k + 12 | 0] = n, o[k + 13 | 0] = n >>> 8, o[k + 14 | 0] = n >>> 16, o[k + 15 | 0] = n >>> 24, i0(B, 9, 0, u + 20 | 0), o[u + 31 | 0] >= 0) break A;
                                                                                    X(i[u + 20 >> 2]);
                                                                                    break A;
                                                                                }
                                                                                if (G4(_, u + 164 | 0), s = i[u + 164 >> 2], !s) break s;
                                                                                i[u + 168 >> 2] = s, X(s);
                                                                                break s;
                                                                            }
                                                                            G4(_, k + 24 | 0);
                                                                        }
                                                                        if (k = k + 40 | 0, (V | 0) == (k | 0)) break;
                                                                    }
                                                                }
                                                                if (n = n + 32 | 0, (C | 0) == (n | 0)) break;
                                                            }
                                                            s = i[_ + 12 >> 2], i[_ + 12 >> 2] = i[t + 116 >> 2], f2(_, l[t + 122 | 0] | l[t + 121 | 0] << 4 & 240), f2(_, l[t + 124 | 0] | l[t + 123 | 0] << 4 & 240), k = i[t + 108 >> 2] - i[t + 104 >> 2] | 0;
                                                            o: {
                                                                if (l[t + 97 | 0] <= 1) {
                                                                    w2(_, k >>> 5 & 65535);
                                                                    break o;
                                                                }
                                                                l2(_, k >> 5);
                                                            }
                                                            if (k = i[t + 104 >> 2], h = i[t + 108 >> 2], (k | 0) != (h | 0)) for(;;){
                                                                n = i[k >> 2];
                                                                o: {
                                                                    if (l[t + 97 | 0] <= 1) {
                                                                        w2(_, n & 65535);
                                                                        break o;
                                                                    }
                                                                    l2(_, n);
                                                                }
                                                                if (l[t + 97 | 0] && w2(_, l[k + 4 | 0]), w2(_, I[k + 6 >> 1]), n = l[t + 123 | 0], n && l1(_, n, i[k + 8 >> 2], i[k + 12 >> 2]), w2(_, (i[k + 20 >> 2] - i[k + 16 >> 2] | 0) / 40 & 65535), n = i[k + 16 >> 2], G = i[k + 20 >> 2], (n | 0) != (G | 0)) for(;;){
                                                                    o: {
                                                                        if (!l[t + 97 | 0] || (C = l[t + 124 | 0], !C)) break o;
                                                                        l1(_, C, i[n >> 2], i[n + 4 >> 2]);
                                                                    }
                                                                    if (l1(_, l[t + 121 | 0], i[n + 8 >> 2], i[n + 12 >> 2]), l1(_, l[t + 122 | 0], i[n + 16 >> 2], i[n + 20 >> 2]), n = n + 40 | 0, (G | 0) == (n | 0)) break;
                                                                }
                                                                if (k = k + 32 | 0, (h | 0) == (k | 0)) break;
                                                            }
                                                            if (i[_ + 12 >> 2] = s, k = i[21669], i[B >> 2] = i[21668], i[B + 4 >> 2] = k, k = B + 8 | 0, o[86691] >= 0) {
                                                                n = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[21672];
                                                                break r;
                                                            }
                                                            j(k, i[21670], i[21671]);
                                                            break r;
                                                        }
                                                        p0(), z();
                                                    }
                                                    Y0(), z();
                                                }
                                                Q0(n, t, k);
                                            }
                                            o[k + n | 0] = 0, i0(B, 9, 0, u + 8 | 0), o[u + 19 | 0] < 0 && X(i[u + 8 >> 2]), k = i[14959], i[u + 20 >> 2] = k, i[i[k - 12 >> 2] + (u + 20 | 0) >> 2] = i[14967], i[u + 28 >> 2] = i[14968], i[_ >> 2] = 58864, o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]), x0(_), N0(u + 84 | 0);
                                        }
                                        if (k = i[u + 164 >> 2], !k) break r;
                                        i[u + 168 >> 2] = k, X(k);
                                    }
                                    m = u + 176 | 0, o[w + 27 | 0] < 0 && X(i[w + 16 >> 2]), m = w + 48 | 0, m = W + 32 | 0, i[v + 20 >> 2] = 0, i[v + 12 >> 2] = 0, i[v + 16 >> 2] = 0, k = i[v + 28 >> 2], t = i[v + 24 >> 2];
                                    r: {
                                        if ((k | 0) == (t | 0)) {
                                            k = 0;
                                            break r;
                                        }
                                        if (n = k - t | 0, (n | 0) < 0) break i;
                                        k = D(n), T = v0(k, t, n) + n | 0;
                                    }
                                    p[i[e + 4 >> 2]](v, r, k, T - k | 0, f);
                                    r: {
                                        if (!i[v + 8 >> 2]) {
                                            if (!i[v >> 2]) {
                                                i[v + 8 >> 2] = 38410, i[A + 8 >> 2] = 38410, r = i[v + 4 >> 2], i[A >> 2] = i[v >> 2], i[A + 4 >> 2] = r;
                                                break r;
                                            }
                                            i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 2840;
                                            break r;
                                        }
                                        r = i[v + 4 >> 2], i[A >> 2] = i[v >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[v + 8 >> 2];
                                    }
                                    if (k && X(k), A = i[v + 24 >> 2], !A) break e;
                                    i[v + 28 >> 2] = A, X(A);
                                }
                                m = v + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function C7(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = J(0), P = 0;
                            k = m - 144 | 0, m = k, f = B0(k, 0, 144), i[f + 76 >> 2] = -1, i[f + 44 >> 2] = A, i[f + 32 >> 2] = 1412, i[f + 84 >> 2] = A, k = r, E = e, A = 0, h = m - 304 | 0, m = h;
                            i: {
                                e: {
                                    if (!i[f + 4 >> 2] && (Ei(f), !i[f + 4 >> 2])) break e;
                                    if (r = l[k | 0], !r) break i;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        for(;;){
                                                            t: {
                                                                r = r & 255;
                                                                o: {
                                                                    if ((r | 0) == 32 | r - 9 >>> 0 < 5) {
                                                                        for(; r = k, k = k + 1 | 0, e = l[r + 1 | 0], !!((e | 0) == 32 | e - 9 >>> 0 < 5););
                                                                        for(z4(f, 0, 0);;){
                                                                            e = i[f + 4 >> 2];
                                                                            s: {
                                                                                if ((e | 0) != i[f + 104 >> 2]) {
                                                                                    i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                    break s;
                                                                                }
                                                                                e = M2(f);
                                                                            }
                                                                            if (!((e | 0) == 32 | e - 9 >>> 0 < 5)) break;
                                                                        }
                                                                        k = i[f + 4 >> 2], e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (k = k - 1 | 0, i[f + 4 >> 2] = k), e = k - i[f + 44 >> 2] | 0, k = e, t = G + i[f + 124 >> 2] | 0, n = e >> 31, e = v + i[f + 120 >> 2] | 0, t = n + (e >>> 0 < v >>> 0 ? t + 1 | 0 : t) | 0, v = e + k | 0, G = v >>> 0 < e >>> 0 ? t + 1 | 0 : t;
                                                                        break o;
                                                                    }
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                if ((r | 0) == 37) {
                                                                                    if (r = l[k + 1 | 0], (r | 0) == 42) break w;
                                                                                    if ((r | 0) != 37) break u;
                                                                                }
                                                                                z4(f, 0, 0);
                                                                                l: {
                                                                                    if (l[k | 0] == 37) {
                                                                                        for(;;){
                                                                                            r = i[f + 4 >> 2];
                                                                                            h: {
                                                                                                if ((r | 0) != i[f + 104 >> 2]) {
                                                                                                    i[f + 4 >> 2] = r + 1, r = l[r | 0];
                                                                                                    break h;
                                                                                                }
                                                                                                r = M2(f);
                                                                                            }
                                                                                            if (!((r | 0) == 32 | r - 9 >>> 0 < 5)) break;
                                                                                        }
                                                                                        k = k + 1 | 0;
                                                                                        break l;
                                                                                    }
                                                                                    if (r = i[f + 4 >> 2], (r | 0) != i[f + 104 >> 2]) {
                                                                                        i[f + 4 >> 2] = r + 1, r = l[r | 0];
                                                                                        break l;
                                                                                    }
                                                                                    r = M2(f);
                                                                                }
                                                                                if (l[k | 0] != (r | 0)) {
                                                                                    if (A = i[f + 116 >> 2], (A | 0) > 0 ? A = 1 : A = (A | 0) >= 0, A && (i[f + 4 >> 2] = i[f + 4 >> 2] - 1), F | (r | 0) >= 0) break i;
                                                                                    break e;
                                                                                }
                                                                                r = i[f + 4 >> 2] - i[f + 44 >> 2] | 0, n = r, e = G + i[f + 124 >> 2] | 0, u = r >> 31, r = v + i[f + 120 >> 2] | 0, s = u + (r >>> 0 < v >>> 0 ? e + 1 | 0 : e) | 0, v = r + n | 0, G = v >>> 0 < r >>> 0 ? s + 1 | 0 : s, r = k;
                                                                                break o;
                                                                            }
                                                                            w = 0, r = k + 2 | 0;
                                                                            break s;
                                                                        }
                                                                        if (r = r - 48 | 0, !(l[k + 2 | 0] != 36 | r >>> 0 > 9)) {
                                                                            e = m - 16 | 0, i[e + 12 >> 2] = E, r = r >>> 0 > 1 ? ((r << 2) + E | 0) - 4 | 0 : E, i[e + 8 >> 2] = r + 4, w = i[r >> 2], r = k + 3 | 0;
                                                                            break s;
                                                                        }
                                                                        w = i[E >> 2], E = E + 4 | 0, r = k + 1 | 0;
                                                                    }
                                                                    if (V = 0, n = 0, k = l[r | 0], k - 48 >>> 0 <= 9) for(; n = (Z(n, 10) + k | 0) - 48 | 0, k = l[r + 1 | 0], r = r + 1 | 0, k - 48 >>> 0 < 10;);
                                                                    (k | 0) == 109 && (B = 0, V = (w | 0) != 0, k = l[r + 1 | 0], A = 0, r = r + 1 | 0), u = r, r = r + 1 | 0, e = 3, t = V;
                                                                    s: {
                                                                        u: switch((k & 255) - 65 | 0){
                                                                            case 39:
                                                                                e = l[u + 1 | 0] == 104, r = e ? u + 2 | 0 : r, e = e ? -2 : -1;
                                                                                break s;
                                                                            case 43:
                                                                                e = l[u + 1 | 0] == 108, r = e ? u + 2 | 0 : r, e = e ? 3 : 1;
                                                                                break s;
                                                                            case 51:
                                                                            case 57:
                                                                                e = 1;
                                                                                break s;
                                                                            case 11:
                                                                                e = 2;
                                                                                break s;
                                                                            case 41:
                                                                                break s;
                                                                            case 0:
                                                                            case 2:
                                                                            case 4:
                                                                            case 5:
                                                                            case 6:
                                                                            case 18:
                                                                            case 23:
                                                                            case 26:
                                                                            case 32:
                                                                            case 34:
                                                                            case 35:
                                                                            case 36:
                                                                            case 37:
                                                                            case 38:
                                                                            case 40:
                                                                            case 45:
                                                                            case 46:
                                                                            case 47:
                                                                            case 50:
                                                                            case 52:
                                                                            case 55:
                                                                                break u;
                                                                            default:
                                                                                break A;
                                                                        }
                                                                        e = 0, r = u;
                                                                    }
                                                                    u = e, e = l[r | 0], k = (e & 47) == 3, R = k ? 1 : u, W = k ? e | 32 : e;
                                                                    s: {
                                                                        if ((W | 0) == 91) break s;
                                                                        u: {
                                                                            if ((W | 0) != 110) {
                                                                                if ((W | 0) != 99) break u;
                                                                                n = (n | 0) <= 1 ? 1 : n;
                                                                                break s;
                                                                            }
                                                                            nt(w, R, v, G);
                                                                            break o;
                                                                        }
                                                                        for(z4(f, 0, 0);;){
                                                                            e = i[f + 4 >> 2];
                                                                            u: {
                                                                                if ((e | 0) != i[f + 104 >> 2]) {
                                                                                    i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                    break u;
                                                                                }
                                                                                e = M2(f);
                                                                            }
                                                                            if (!((e | 0) == 32 | e - 9 >>> 0 < 5)) break;
                                                                        }
                                                                        k = i[f + 4 >> 2], e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (k = k - 1 | 0, i[f + 4 >> 2] = k), e = k - i[f + 44 >> 2] | 0, k = e, t = G + i[f + 124 >> 2] | 0, u = e >> 31, e = v + i[f + 120 >> 2] | 0, G = u + (e >>> 0 < v >>> 0 ? t + 1 | 0 : t) | 0, v = e + k | 0, G = v >>> 0 < e >>> 0 ? G + 1 | 0 : G;
                                                                    }
                                                                    _ = n, C = n >> 31, z4(f, n, C), e = i[f + 4 >> 2];
                                                                    s: {
                                                                        if ((e | 0) != i[f + 104 >> 2]) {
                                                                            i[f + 4 >> 2] = e + 1;
                                                                            break s;
                                                                        }
                                                                        if ((M2(f) | 0) < 0) break f;
                                                                    }
                                                                    e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (i[f + 4 >> 2] = i[f + 4 >> 2] - 1), k = 16;
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    h: switch(W - 88 | 0){
                                                                                        default:
                                                                                            if (e = W - 65 | 0, e >>> 0 > 6 | !(1 << e & 113)) break s;
                                                                                        case 9:
                                                                                        case 13:
                                                                                        case 14:
                                                                                        case 15:
                                                                                            if (Z7(h + 8 | 0, f, R, 0), e = i[f + 4 >> 2] - i[f + 44 >> 2] | 0, i[f + 120 >> 2] != (0 - e | 0) | i[f + 124 >> 2] != (0 - ((e >> 31) + ((e | 0) != 0) | 0) | 0)) break w;
                                                                                            break k;
                                                                                        case 3:
                                                                                        case 11:
                                                                                        case 27:
                                                                                            if ((W | 16) == 115) {
                                                                                                if (B0(h + 32 | 0, -1, 257), o[h + 32 | 0] = 0, (W | 0) != 115) break u;
                                                                                                o[h + 65 | 0] = 0, o[h + 46 | 0] = 0, Q[h + 42 >> 1] = 0, Q[h + 44 >> 1] = 0;
                                                                                                break u;
                                                                                            }
                                                                                            k = l[r + 1 | 0], t = (k | 0) == 94, B0(h + 32 | 0, t, 257), o[h + 32 | 0] = 0, e = t ? r + 2 | 0 : r + 1 | 0;
                                                                                            v: {
                                                                                                _: {
                                                                                                    B: {
                                                                                                        if (r = l[(t ? 2 : 1) + r | 0], (r | 0) != 45) {
                                                                                                            if ((r | 0) == 93) break B;
                                                                                                            s = (k | 0) != 94, r = e;
                                                                                                            break v;
                                                                                                        }
                                                                                                        s = (k | 0) != 94, o[h + 78 | 0] = s;
                                                                                                        break _;
                                                                                                    }
                                                                                                    s = (k | 0) != 94, o[h + 126 | 0] = s;
                                                                                                }
                                                                                                r = e + 1 | 0;
                                                                                            }
                                                                                            for(;;){
                                                                                                e = l[r | 0];
                                                                                                v: {
                                                                                                    if ((e | 0) != 45) {
                                                                                                        if (!e) break f;
                                                                                                        if ((e | 0) == 93) break u;
                                                                                                        break v;
                                                                                                    }
                                                                                                    if (e = 45, t = l[r + 1 | 0], !t | (t | 0) == 93) break v;
                                                                                                    u = r + 1 | 0, k = l[r - 1 | 0];
                                                                                                    _: {
                                                                                                        if (t >>> 0 <= k >>> 0) {
                                                                                                            e = t;
                                                                                                            break _;
                                                                                                        }
                                                                                                        for(; k = k + 1 | 0, o[k + (h + 32 | 0) | 0] = s, e = l[u | 0], k >>> 0 < e >>> 0;);
                                                                                                    }
                                                                                                    r = u;
                                                                                                }
                                                                                                o[(e + h | 0) + 33 | 0] = s, r = r + 1 | 0;
                                                                                            }
                                                                                        case 23:
                                                                                            k = 8;
                                                                                            break l;
                                                                                        case 12:
                                                                                        case 29:
                                                                                            k = 10;
                                                                                            break l;
                                                                                        case 1:
                                                                                        case 2:
                                                                                        case 4:
                                                                                        case 5:
                                                                                        case 6:
                                                                                        case 7:
                                                                                        case 8:
                                                                                        case 10:
                                                                                        case 16:
                                                                                        case 18:
                                                                                        case 19:
                                                                                        case 20:
                                                                                        case 21:
                                                                                        case 22:
                                                                                        case 25:
                                                                                        case 26:
                                                                                        case 28:
                                                                                        case 30:
                                                                                        case 31:
                                                                                            break s;
                                                                                        case 0:
                                                                                        case 24:
                                                                                        case 32:
                                                                                            break l;
                                                                                        case 17:
                                                                                            break h;
                                                                                    }
                                                                                    k = 0;
                                                                                }
                                                                                n = 0, t = 0, u = 0, s = 0, C = 0, M = m - 16 | 0, m = M;
                                                                                l: {
                                                                                    if (!((k | 0) != 1 & k >>> 0 <= 36)) {
                                                                                        i[26064] = 28;
                                                                                        break l;
                                                                                    }
                                                                                    for(;;){
                                                                                        e = i[f + 4 >> 2];
                                                                                        h: {
                                                                                            if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                break h;
                                                                                            }
                                                                                            e = M2(f);
                                                                                        }
                                                                                        if (!((e | 0) == 32 | e - 9 >>> 0 < 5)) break;
                                                                                    }
                                                                                    h: {
                                                                                        v: switch(e - 43 | 0){
                                                                                            case 0:
                                                                                            case 2:
                                                                                                break v;
                                                                                            default:
                                                                                                break h;
                                                                                        }
                                                                                        if (C = (e | 0) == 45 ? -1 : 0, e = i[f + 4 >> 2], (e | 0) != i[f + 104 >> 2]) {
                                                                                            i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                            break h;
                                                                                        }
                                                                                        e = M2(f);
                                                                                    }
                                                                                    h: {
                                                                                        v: {
                                                                                            _: {
                                                                                                B: {
                                                                                                    if (!((k | 0) != 0 & (k | 0) != 16 | (e | 0) != 48)) {
                                                                                                        e = i[f + 4 >> 2];
                                                                                                        m: {
                                                                                                            if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                                i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                                break m;
                                                                                                            }
                                                                                                            e = M2(f);
                                                                                                        }
                                                                                                        if ((e & -33) == 88) {
                                                                                                            k = 16, e = i[f + 4 >> 2];
                                                                                                            m: {
                                                                                                                if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                                    i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                                    break m;
                                                                                                                }
                                                                                                                e = M2(f);
                                                                                                            }
                                                                                                            if (l[e + 61521 | 0] < 16) break _;
                                                                                                            e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (i[f + 4 >> 2] = i[f + 4 >> 2] - 1), z4(f, 0, 0);
                                                                                                            break l;
                                                                                                        }
                                                                                                        if (k) break B;
                                                                                                        k = 8;
                                                                                                        break _;
                                                                                                    }
                                                                                                    if (k = k || 10, k >>> 0 > l[e + 61521 | 0]) break B;
                                                                                                    e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (i[f + 4 >> 2] = i[f + 4 >> 2] - 1), z4(f, 0, 0), i[26064] = 28;
                                                                                                    break l;
                                                                                                }
                                                                                                if ((k | 0) != 10) break _;
                                                                                                if (u = e - 48 | 0, u >>> 0 <= 9) {
                                                                                                    for(e = 0;;){
                                                                                                        e = Z(e, 10) + u | 0, n = e >>> 0 < 429496729, k = i[f + 4 >> 2];
                                                                                                        B: {
                                                                                                            if ((k | 0) != i[f + 104 >> 2]) {
                                                                                                                i[f + 4 >> 2] = k + 1, k = l[k | 0];
                                                                                                                break B;
                                                                                                            }
                                                                                                            k = M2(f);
                                                                                                        }
                                                                                                        if (u = k - 48 | 0, !(n & u >>> 0 <= 9)) break;
                                                                                                    }
                                                                                                    n = e;
                                                                                                }
                                                                                                if (u >>> 0 > 9) break h;
                                                                                                for(k = O0(n, 0, 10, 0), _ = w0;;){
                                                                                                    t = _, n = k + u | 0, t = n >>> 0 < k >>> 0 ? t + 1 | 0 : t, k = (t | 0) == 429496729 & n >>> 0 < 2576980378 | t >>> 0 < 429496729, e = i[f + 4 >> 2];
                                                                                                    B: {
                                                                                                        if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                            i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                            break B;
                                                                                                        }
                                                                                                        e = M2(f);
                                                                                                    }
                                                                                                    if (s = e - 48 | 0, !(k & s >>> 0 <= 9)) {
                                                                                                        if (k = 10, s >>> 0 <= 9) break v;
                                                                                                        break h;
                                                                                                    }
                                                                                                    if (k = O0(n, t, 10, 0), _ = w0, u = s, !((_ | 0) == -1 & (u ^ -1) >>> 0 >= k >>> 0 | (_ | 0) != -1)) break;
                                                                                                }
                                                                                                k = 10;
                                                                                                break v;
                                                                                            }
                                                                                            if (k - 1 & k) {
                                                                                                if (s = l[e + 61521 | 0], s >>> 0 < k >>> 0) {
                                                                                                    for(;;){
                                                                                                        u = Z(k, u) + s | 0, n = u >>> 0 < 119304647, e = i[f + 4 >> 2];
                                                                                                        _: {
                                                                                                            if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                                i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                                break _;
                                                                                                            }
                                                                                                            e = M2(f);
                                                                                                        }
                                                                                                        if (s = l[e + 61521 | 0], !(n & s >>> 0 < k >>> 0)) break;
                                                                                                    }
                                                                                                    n = u;
                                                                                                }
                                                                                                if (k >>> 0 <= s >>> 0) break v;
                                                                                                for(;;){
                                                                                                    if (u = O0(n, t, k, 0), _ = w0, s = s & 255, (_ | 0) == -1 & (s ^ -1) >>> 0 < u >>> 0) break v;
                                                                                                    t = _, n = u + s | 0, t = n >>> 0 < u >>> 0 ? t + 1 | 0 : t, e = i[f + 4 >> 2];
                                                                                                    _: {
                                                                                                        if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                            i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                            break _;
                                                                                                        }
                                                                                                        e = M2(f);
                                                                                                    }
                                                                                                    if (s = l[e + 61521 | 0], k >>> 0 <= s >>> 0) break v;
                                                                                                    if (x1(M, k, 0, 0, 0, n, t, 0, 0), !!(i[M + 8 >> 2] | i[M + 12 >> 2])) break;
                                                                                                }
                                                                                                break v;
                                                                                            }
                                                                                            if (_ = o[(Z(k, 23) >>> 5 & 7) + 61777 | 0], u = l[e + 61521 | 0], u >>> 0 < k >>> 0) {
                                                                                                for(;;){
                                                                                                    s = s << _ | u, n = s >>> 0 < 134217728, e = i[f + 4 >> 2];
                                                                                                    _: {
                                                                                                        if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                            i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                            break _;
                                                                                                        }
                                                                                                        e = M2(f);
                                                                                                    }
                                                                                                    if (u = l[e + 61521 | 0], !(n & u >>> 0 < k >>> 0)) break;
                                                                                                }
                                                                                                n = s;
                                                                                            }
                                                                                            if (k >>> 0 <= u >>> 0 || (y = _ & 31, (_ & 63) >>> 0 >= 32 ? (s = 0, y = -1 >>> y | 0) : (s = -1 >>> y | 0, y = s | (1 << y) - 1 << 32 - y), !s & n >>> 0 > y >>> 0)) break v;
                                                                                            for(;;){
                                                                                                H = u & 255, u = n, e = _ & 31, (_ & 63) >>> 0 >= 32 ? (t = n << e, e = 0) : (t = (1 << e) - 1 & u >>> 32 - e | t << e, e = u << e), n = H | e, e = i[f + 4 >> 2];
                                                                                                _: {
                                                                                                    if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                        i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                        break _;
                                                                                                    }
                                                                                                    e = M2(f);
                                                                                                }
                                                                                                if (u = l[e + 61521 | 0], k >>> 0 <= u >>> 0) break v;
                                                                                                if (!((t | 0) == (s | 0) & n >>> 0 <= y >>> 0 | t >>> 0 < s >>> 0)) break;
                                                                                            }
                                                                                        }
                                                                                        if (l[e + 61521 | 0] >= k >>> 0) break h;
                                                                                        for(;;){
                                                                                            e = i[f + 4 >> 2];
                                                                                            v: {
                                                                                                if ((e | 0) != i[f + 104 >> 2]) {
                                                                                                    i[f + 4 >> 2] = e + 1, e = l[e | 0];
                                                                                                    break v;
                                                                                                }
                                                                                                e = M2(f);
                                                                                            }
                                                                                            if (!(l[e + 61521 | 0] < k >>> 0)) break;
                                                                                        }
                                                                                        i[26064] = 68, C = 0, n = -1, t = -1;
                                                                                    }
                                                                                    e = i[f + 116 >> 2], (e | 0) > 0 ? e = 1 : e = (e | 0) >= 0, e && (i[f + 4 >> 2] = i[f + 4 >> 2] - 1);
                                                                                    h: if ((n & t) != -1) break h;
                                                                                    e = n ^ C, n = e - C | 0, k = C >> 31, t = (k ^ t) - ((e >>> 0 < C >>> 0) + k | 0) | 0;
                                                                                }
                                                                                if (m = M + 16 | 0, e = i[f + 4 >> 2] - i[f + 44 >> 2] | 0, i[f + 120 >> 2] == (0 - e | 0) & i[f + 124 >> 2] == (0 - ((e >> 31) + ((e | 0) != 0) | 0) | 0)) break k;
                                                                                if (!(!w | (W | 0) != 112)) {
                                                                                    i[w >> 2] = n;
                                                                                    break s;
                                                                                }
                                                                                nt(w, R, n, t);
                                                                                break s;
                                                                            }
                                                                            if (!w) break s;
                                                                            e = i[h + 16 >> 2], n = i[h + 20 >> 2], k = i[h + 8 >> 2], t = i[h + 12 >> 2];
                                                                            w: switch(R | 0){
                                                                                case 0:
                                                                                    T = w, S = K5(k, t, e, n), W0[T >> 2] = S;
                                                                                    break s;
                                                                                case 1:
                                                                                    T = w, P = J3(k, t, e, n), n0[T >> 3] = P;
                                                                                    break s;
                                                                                case 2:
                                                                                    break w;
                                                                                default:
                                                                                    break s;
                                                                            }
                                                                            i[w >> 2] = k, i[w + 4 >> 2] = t, i[w + 8 >> 2] = e, i[w + 12 >> 2] = n;
                                                                            break s;
                                                                        }
                                                                        u = (W | 0) != 99, e = u ? 31 : n + 1 | 0;
                                                                        u: {
                                                                            if ((R | 0) == 1) {
                                                                                if (n = w, V && (n = Q2(e << 2), !n)) break n;
                                                                                for(i[h + 296 >> 2] = 0, i[h + 300 >> 2] = 0, k = 0;;){
                                                                                    A = n;
                                                                                    w: {
                                                                                        for(;;){
                                                                                            n = i[f + 4 >> 2];
                                                                                            l: {
                                                                                                if ((n | 0) != i[f + 104 >> 2]) {
                                                                                                    i[f + 4 >> 2] = n + 1, n = l[n | 0];
                                                                                                    break l;
                                                                                                }
                                                                                                n = M2(f);
                                                                                            }
                                                                                            if (!l[(n + h | 0) + 33 | 0]) break w;
                                                                                            if (o[h + 27 | 0] = n, n = _i(h + 28 | 0, h + 27 | 0, 1, h + 296 | 0), (n | 0) != -2) {
                                                                                                if ((n | 0) == -1) {
                                                                                                    B = 0;
                                                                                                    break f;
                                                                                                }
                                                                                                if (A && (i[(k << 2) + A >> 2] = i[h + 28 >> 2], k = k + 1 | 0), !(!V | (e | 0) != (k | 0))) break;
                                                                                            }
                                                                                        }
                                                                                        if (t = 1, B = 0, e = e << 1 | 1, n = Ce(A, e << 2), n) continue;
                                                                                        break A;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                if (B = 0, e = A, h + 296 | 0 && i[h + 296 >> 2]) break f;
                                                                                break u;
                                                                            }
                                                                            if (V) {
                                                                                if (k = 0, n = Q2(e), !n) break n;
                                                                                for(;;){
                                                                                    for(A = n;;){
                                                                                        n = i[f + 4 >> 2];
                                                                                        w: {
                                                                                            if ((n | 0) != i[f + 104 >> 2]) {
                                                                                                i[f + 4 >> 2] = n + 1, n = l[n | 0];
                                                                                                break w;
                                                                                            }
                                                                                            n = M2(f);
                                                                                        }
                                                                                        if (!l[(n + h | 0) + 33 | 0]) {
                                                                                            e = 0, B = A;
                                                                                            break u;
                                                                                        }
                                                                                        if (o[A + k | 0] = n, k = k + 1 | 0, (k | 0) == (e | 0)) break;
                                                                                    }
                                                                                    if (t = 1, e = e << 1 | 1, n = Ce(A, e), !n) break;
                                                                                }
                                                                                B = A, A = 0;
                                                                                break A;
                                                                            }
                                                                            if (k = 0, w) for(;;){
                                                                                A = i[f + 4 >> 2];
                                                                                w: {
                                                                                    if ((A | 0) != i[f + 104 >> 2]) {
                                                                                        i[f + 4 >> 2] = A + 1, A = l[A | 0];
                                                                                        break w;
                                                                                    }
                                                                                    A = M2(f);
                                                                                }
                                                                                if (l[(A + h | 0) + 33 | 0]) {
                                                                                    o[k + w | 0] = A, k = k + 1 | 0;
                                                                                    continue;
                                                                                } else {
                                                                                    e = 0, A = w, B = A;
                                                                                    break u;
                                                                                }
                                                                            }
                                                                            for(;;){
                                                                                A = i[f + 4 >> 2];
                                                                                w: {
                                                                                    if ((A | 0) != i[f + 104 >> 2]) {
                                                                                        i[f + 4 >> 2] = A + 1, A = l[A | 0];
                                                                                        break w;
                                                                                    }
                                                                                    A = M2(f);
                                                                                }
                                                                                if (!l[(A + h | 0) + 33 | 0]) break;
                                                                            }
                                                                            A = 0, B = 0, e = 0;
                                                                        }
                                                                        if (n = i[f + 4 >> 2], t = i[f + 116 >> 2], (t | 0) > 0 ? t = 1 : t = (t | 0) >= 0, t && (n = n - 1 | 0, i[f + 4 >> 2] = n), t = n - i[f + 44 >> 2] | 0, s = t, n = t + i[f + 120 >> 2] | 0, t = i[f + 124 >> 2] + (t >> 31) | 0, t = n >>> 0 < s >>> 0 ? t + 1 | 0 : t, !(t | n) | !(u | (n | 0) == (_ | 0) & (t | 0) == (C | 0))) break t;
                                                                        V && (i[w >> 2] = A);
                                                                        u: {
                                                                            if ((W | 0) == 99) break u;
                                                                            if (e && (i[(k << 2) + e >> 2] = 0), !B) {
                                                                                B = 0;
                                                                                break u;
                                                                            }
                                                                            o[k + B | 0] = 0;
                                                                        }
                                                                        A = e;
                                                                    }
                                                                    e = i[f + 4 >> 2] - i[f + 44 >> 2] | 0, n = e, t = e >> 31, e = G + i[f + 124 >> 2] | 0, k = v + i[f + 120 >> 2] | 0, t = (k >>> 0 < v >>> 0 ? e + 1 | 0 : e) + t | 0, v = k + n | 0, G = v >>> 0 < k >>> 0 ? t + 1 | 0 : t, F = ((w | 0) != 0) + F | 0;
                                                                }
                                                                if (k = r + 1 | 0, r = l[r + 1 | 0], r) continue;
                                                                break i;
                                                            }
                                                            break;
                                                        }
                                                        A = e;
                                                        break k;
                                                    }
                                                    t = 1, B = 0, A = 0;
                                                    break A;
                                                }
                                                t = V;
                                                break r;
                                            }
                                            t = V;
                                        }
                                        F = F || -1;
                                    }
                                    if (!t) break i;
                                    X(B), X(A);
                                    break i;
                                }
                                F = -1;
                            }
                            return m = h + 304 | 0, m = f + 144 | 0, F;
                        }
                        function V7(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0;
                            n = m - 192 | 0, m = n;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: switch(i[r + 36 >> 2] - 1 | 0){
                                                case 1:
                                                    if ((e | 0) != 1) break r;
                                                    if (o[r + 24 | 0] & 1) break A;
                                                    break r;
                                                case 0:
                                                    break f;
                                                default:
                                                    break r;
                                            }
                                            if (o[r + 24 | 0] & 1) break A;
                                            if (!(o[r + 28 | 0] & 1)) break r;
                                        }
                                        if (i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, o[n + 28 | 0] = 1, i[n + 20 >> 2] = 2, i[n + 24 >> 2] = 2, o[n + 16 | 0] = 1, i[n + 4 >> 2] = i[r >> 2], k = i[r + 4 >> 2], !k || (k = gi(k), i[n + 8 >> 2] = k, !k)) break i;
                                        i[n + 184 >> 2] = 0, i[n + 188 >> 2] = 0, t = 255, w = i[r + 64 >> 2];
                                        A: {
                                            if (!w) break A;
                                            for(r = r - -64 | 0, k = r; s = i[w + 16 >> 2], k = (s | 0) < 0 ? k : w, w = i[(s >>> 29 & 4) + w >> 2], !!w;);
                                            if ((r | 0) == (k | 0) | i[k + 16 >> 2] > 0) break A;
                                            t = l[k + 24 | 0];
                                        }
                                        s6(n + 40 | 0, n + 4 | 0, 0, 3, n + 184 | 0, t, n + 16 | 0, f), r = i[n + 188 >> 2];
                                        A: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        r = i[n + 8 >> 2];
                                        A: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        A: {
                                            if (i[n + 48 >> 2]) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 52 >> 2], i[A + 8 >> 2] = i[n + 48 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 67 | 0] >= 0) {
                                                    r = i[n + 60 >> 2], i[A >> 2] = i[n + 56 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 64 >> 2];
                                                    break A;
                                                }
                                                j(A, i[n + 56 >> 2], i[n + 60 >> 2]);
                                                break A;
                                            }
                                            V7(A, i[n + 40 >> 2], e, f);
                                        }
                                        if (o[n + 67 | 0] < 0 && X(i[n + 56 >> 2]), A = i[n + 44 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        break e;
                                    }
                                    if (w = i[r + 60 >> 2], H = r - -64 | 0, (w | 0) != (H | 0)) for(R = (e | 0) == 1;;){
                                        r: {
                                            if (e = l[w + 24 | 0], e >>> 0 <= 8) {
                                                if (v = i[w + 44 >> 2], G = i[w + 32 >> 2], f = i[w + 28 >> 2], !R) {
                                                    if (!f | G >>> 0 < 2) break r;
                                                    for(_ = G >>> 1 | 0, C = f & -2, u = f & 1, e = 0;;){
                                                        if (t = G + (e ^ -1) | 0, k = 0, s = 0, (f | 0) != 1) for(; h = i[w + 52 >> 2], B = (v + Z(h, e) | 0) + k | 0, V = l[B | 0], h = (v + Z(t, h) | 0) + k | 0, o[B | 0] = l[h | 0], o[h | 0] = V, B = k | 1, h = i[w + 52 >> 2], V = B + (v + Z(h, e) | 0) | 0, W = l[V | 0], h = B + (v + Z(t, h) | 0) | 0, o[V | 0] = l[h | 0], o[h | 0] = W, k = k + 2 | 0, s = s + 2 | 0, (C | 0) != (s | 0););
                                                        if (u && (s = i[w + 52 >> 2], h = (v + Z(s, e) | 0) + k | 0, B = l[h | 0], k = (v + Z(t, s) | 0) + k | 0, o[h | 0] = l[k | 0], o[k | 0] = B), e = e + 1 | 0, (_ | 0) == (e | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!G | f >>> 0 < 2) break r;
                                                for(s = f & 2, _ = f >>> 1 | 0, C = _ & 2147483646, e = 0;;){
                                                    if (k = 0, t = 0, (_ | 0) != 1) for(; u = v + Z(i[w + 52 >> 2], e) | 0, h = u + k | 0, B = l[h | 0], u = (f + u | 0) + (k ^ -1) | 0, o[h | 0] = l[u | 0], o[u | 0] = B, u = v + Z(i[w + 52 >> 2], e) | 0, h = u + k | 0, B = l[h + 1 | 0], u = (f + u | 0) + (k ^ -2) | 0, o[h + 1 | 0] = l[u | 0], o[u | 0] = B, k = k + 2 | 0, t = t + 2 | 0, (C | 0) != (t | 0););
                                                    if (s && (t = v + Z(i[w + 52 >> 2], e) | 0, u = t + k | 0, h = l[u | 0], k = (f + t | 0) + (k ^ -1) | 0, o[u | 0] = l[k | 0], o[k | 0] = h), e = e + 1 | 0, (G | 0) == (e | 0)) break;
                                                }
                                                break r;
                                            }
                                            if (e >>> 0 <= 16) {
                                                if (_ = i[w + 44 >> 2], v = i[w + 32 >> 2], t = i[w + 28 >> 2], !R) {
                                                    if (!t | v >>> 0 < 2) break r;
                                                    for(h = v >>> 1 | 0, C = i[w + 52 >> 2], B = t & -4, u = t & 3, s = 0, V = t >>> 0 < 4;;){
                                                        if (e = _ + (Z(s, C) & -2) | 0, G = _ + (Z(C, v + (s ^ -1) | 0) & -2) | 0, k = 0, t = 0, !V) for(; f = k << 1, W = f + e | 0, F = I[W >> 1], y = W, W = f + G | 0, Q[y >> 1] = I[W >> 1], Q[W >> 1] = F, W = f | 2, F = W + e | 0, y = I[F >> 1], W = G + W | 0, Q[F >> 1] = I[W >> 1], Q[W >> 1] = y, W = f | 4, F = W + e | 0, y = I[F >> 1], W = G + W | 0, Q[F >> 1] = I[W >> 1], Q[W >> 1] = y, f = f | 6, W = f + e | 0, F = I[W >> 1], f = f + G | 0, Q[W >> 1] = I[f >> 1], Q[f >> 1] = F, k = k + 4 | 0, t = t + 4 | 0, (B | 0) != (t | 0););
                                                        if (f = 0, u) for(; t = k << 1, W = t + e | 0, F = I[W >> 1], t = t + G | 0, Q[W >> 1] = I[t >> 1], Q[t >> 1] = F, k = k + 1 | 0, f = f + 1 | 0, (u | 0) != (f | 0););
                                                        if (s = s + 1 | 0, (h | 0) == (s | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!v | t >>> 0 < 2) break r;
                                                for(u = i[w + 52 >> 2], h = t & 2, B = t >>> 1 | 0, V = B & 2147483646, e = 0;;){
                                                    if (C = _ + (Z(e, u) & -2) | 0, s = C + (t << 1) | 0, k = 0, f = 0, (B | 0) != 1) for(; G = C + (k << 1) | 0, W = I[G >> 1], F = s + ((k ^ -1) << 1) | 0, Q[G >> 1] = I[F >> 1], Q[F >> 1] = W, W = I[G + 2 >> 1], y = G, G = s + ((k ^ 2147483646) << 1) | 0, Q[y + 2 >> 1] = I[G >> 1], Q[G >> 1] = W, k = k + 2 | 0, f = f + 2 | 0, (V | 0) != (f | 0););
                                                    if (h && (f = C + (k << 1) | 0, G = I[f >> 1], W = f, f = s + ((k ^ -1) << 1) | 0, Q[W >> 1] = I[f >> 1], Q[f >> 1] = G), e = e + 1 | 0, (v | 0) == (e | 0)) break;
                                                }
                                                break r;
                                            }
                                            if (e >>> 0 <= 32) {
                                                if (k = i[w + 44 >> 2], G = i[w + 32 >> 2], v = i[w + 28 >> 2], !R) {
                                                    if (!v | G >>> 0 < 2) break r;
                                                    for(C = G >>> 1 | 0, u = v & -2, h = v & 1, f = 0;;){
                                                        if (e = G + (f ^ -1) | 0, t = 0, s = 0, (v | 0) != 1) for(; _ = t << 2, B = i[w + 52 >> 2], V = _ + (k + (Z(B, f) & -4) | 0) | 0, W = i[V >> 2], B = _ + (k + (Z(e, B) & -4) | 0) | 0, i[V >> 2] = i[B >> 2], i[B >> 2] = W, _ = _ | 4, B = i[w + 52 >> 2], V = _ + (k + (Z(B, f) & -4) | 0) | 0, W = i[V >> 2], _ = _ + (k + (Z(e, B) & -4) | 0) | 0, i[V >> 2] = i[_ >> 2], i[_ >> 2] = W, t = t + 2 | 0, s = s + 2 | 0, (u | 0) != (s | 0););
                                                        if (h && (t = t << 2, s = i[w + 52 >> 2], _ = t + (k + (Z(s, f) & -4) | 0) | 0, B = i[_ >> 2], e = t + (k + (Z(e, s) & -4) | 0) | 0, i[_ >> 2] = i[e >> 2], i[e >> 2] = B), f = f + 1 | 0, (C | 0) == (f | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!G | v >>> 0 < 2) break r;
                                                for(s = v & 2, _ = v >>> 1 | 0, C = _ & 2147483646, e = 0;;){
                                                    if (t = 0, f = 0, (_ | 0) != 1) for(; u = k + (Z(i[w + 52 >> 2], e) & -4) | 0, h = t << 2, B = u + h | 0, V = i[B >> 2], W = B, B = u, u = v << 2, B = (B + u | 0) + ((t ^ -1) << 2) | 0, i[W >> 2] = i[B >> 2], i[B >> 2] = V, B = h, h = k + (Z(i[w + 52 >> 2], e) & -4) | 0, B = B + h | 0, V = i[B + 4 >> 2], u = (u + h | 0) + ((t ^ 1073741822) << 2) | 0, i[B + 4 >> 2] = i[u >> 2], i[u >> 2] = V, t = t + 2 | 0, f = f + 2 | 0, (C | 0) != (f | 0););
                                                    if (s && (f = k + (Z(i[w + 52 >> 2], e) & -4) | 0, u = f + (t << 2) | 0, h = i[u >> 2], f = (f + (v << 2) | 0) + ((t ^ -1) << 2) | 0, i[u >> 2] = i[f >> 2], i[f >> 2] = h), e = e + 1 | 0, (G | 0) == (e | 0)) break;
                                                }
                                                break r;
                                            }
                                            if (e >>> 0 <= 64) {
                                                if (C = i[w + 44 >> 2], v = i[w + 32 >> 2], e = i[w + 28 >> 2], !R) {
                                                    if (!e | v >>> 0 < 2) break r;
                                                    for(W = v >>> 1 | 0, B = i[w + 52 >> 2], F = e & -4, V = e & 3, _ = 0;;){
                                                        if (s = C + (Z(_, B) & -8) | 0, G = C + (Z(B, v + (_ ^ -1) | 0) & -8) | 0, k = 0, t = 0, e >>> 0 >= 4) for(; f = k << 3, u = f + s | 0, y = i[u >> 2], E = i[u + 4 >> 2], h = f + G | 0, M = i[h + 4 >> 2], i[u >> 2] = i[h >> 2], i[u + 4 >> 2] = M, i[h >> 2] = y, i[h + 4 >> 2] = E, u = f | 8, h = u + s | 0, y = i[h >> 2], E = i[h + 4 >> 2], u = u + G | 0, M = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = M, i[u >> 2] = y, i[u + 4 >> 2] = E, u = f | 16, h = u + s | 0, y = i[h >> 2], E = i[h + 4 >> 2], u = u + G | 0, M = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = M, i[u >> 2] = y, i[u + 4 >> 2] = E, f = f | 24, u = f + s | 0, h = i[u >> 2], y = i[u + 4 >> 2], f = f + G | 0, E = i[f + 4 >> 2], i[u >> 2] = i[f >> 2], i[u + 4 >> 2] = E, i[f >> 2] = h, i[f + 4 >> 2] = y, k = k + 4 | 0, t = t + 4 | 0, (F | 0) != (t | 0););
                                                        if (f = 0, V) for(; t = k << 3, u = t + s | 0, h = i[u >> 2], y = i[u + 4 >> 2], t = t + G | 0, E = i[t + 4 >> 2], i[u >> 2] = i[t >> 2], i[u + 4 >> 2] = E, i[t >> 2] = h, i[t + 4 >> 2] = y, k = k + 1 | 0, f = f + 1 | 0, (V | 0) != (f | 0););
                                                        if (_ = _ + 1 | 0, (W | 0) == (_ | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!v | e >>> 0 < 2) break r;
                                                for(h = i[w + 52 >> 2], B = e & 2, V = e >>> 1 | 0, W = V & 2147483646, t = 0;;){
                                                    if (u = C + (Z(t, h) & -8) | 0, G = u + (e << 3) | 0, k = 0, f = 0, (V | 0) != 1) for(; s = u + (k << 3) | 0, F = i[s >> 2], y = i[s + 4 >> 2], _ = G + ((k ^ -1) << 3) | 0, E = i[_ + 4 >> 2], i[s >> 2] = i[_ >> 2], i[s + 4 >> 2] = E, i[_ >> 2] = F, i[_ + 4 >> 2] = y, F = i[s + 8 >> 2], y = i[s + 12 >> 2], _ = G + ((k ^ 536870910) << 3) | 0, E = i[_ + 4 >> 2], i[s + 8 >> 2] = i[_ >> 2], i[s + 12 >> 2] = E, i[_ >> 2] = F, i[_ + 4 >> 2] = y, k = k + 2 | 0, f = f + 2 | 0, (W | 0) != (f | 0););
                                                    if (B && (f = u + (k << 3) | 0, s = i[f >> 2], _ = i[f + 4 >> 2], k = G + ((k ^ -1) << 3) | 0, G = i[k + 4 >> 2], i[f >> 2] = i[k >> 2], i[f + 4 >> 2] = G, i[k >> 2] = s, i[k + 4 >> 2] = _), t = t + 1 | 0, (v | 0) == (t | 0)) break;
                                                }
                                                break r;
                                            }
                                            if (e >>> 0 <= 128) {
                                                if (G = i[w + 44 >> 2], f = i[w + 32 >> 2], t = i[w + 28 >> 2], !R) {
                                                    if (!t | f >>> 0 < 2) break r;
                                                    for(_ = f >>> 1 | 0, e = 0;;){
                                                        for(C = f + (e ^ -1) | 0, k = 0; u = k << 4, v = i[w + 52 >> 2], s = u + (G + (Z(v, e) & -16) | 0) | 0, h = i[s + 12 >> 2], i[n + 48 >> 2] = i[s + 8 >> 2], i[n + 52 >> 2] = h, h = i[s + 4 >> 2], i[n + 40 >> 2] = i[s >> 2], i[n + 44 >> 2] = h, v = u + (G + (Z(v, C) & -16) | 0) | 0, u = i[v + 12 >> 2], i[s + 8 >> 2] = i[v + 8 >> 2], i[s + 12 >> 2] = u, u = i[v + 4 >> 2], i[s >> 2] = i[v >> 2], i[s + 4 >> 2] = u, s = i[n + 52 >> 2], i[v + 8 >> 2] = i[n + 48 >> 2], i[v + 12 >> 2] = s, s = i[n + 44 >> 2], i[v >> 2] = i[n + 40 >> 2], i[v + 4 >> 2] = s, k = k + 1 | 0, (t | 0) != (k | 0););
                                                        if (e = e + 1 | 0, (_ | 0) == (e | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!f | t >>> 0 < 2) break r;
                                                for(_ = t >>> 1 | 0, e = 0;;){
                                                    for(k = 0; v = G + (Z(i[w + 52 >> 2], e) & -16) | 0, s = v + (k << 4) | 0, C = i[s + 12 >> 2], i[n + 48 >> 2] = i[s + 8 >> 2], i[n + 52 >> 2] = C, C = i[s + 4 >> 2], i[n + 40 >> 2] = i[s >> 2], i[n + 44 >> 2] = C, v = (v + (t << 4) | 0) + ((k ^ -1) << 4) | 0, C = i[v + 12 >> 2], i[s + 8 >> 2] = i[v + 8 >> 2], i[s + 12 >> 2] = C, C = i[v + 4 >> 2], i[s >> 2] = i[v >> 2], i[s + 4 >> 2] = C, s = i[n + 52 >> 2], i[v + 8 >> 2] = i[n + 48 >> 2], i[v + 12 >> 2] = s, s = i[n + 44 >> 2], i[v >> 2] = i[n + 40 >> 2], i[v + 4 >> 2] = s, k = k + 1 | 0, (_ | 0) != (k | 0););
                                                    if (e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                                }
                                                break r;
                                            }
                                            i[n + 48 >> 2] = 59808, i[n + 104 >> 2] = 59828, r = i[14961], i[n + 40 >> 2] = r, e = i[r - 12 >> 2], r = n + 40 | 0, i[e + r >> 2] = i[14962], i[n + 44 >> 2] = 0, e = r + i[i[n + 40 >> 2] - 12 >> 2] | 0, f = n + 52 | 0, T0(e, f), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[n + 48 >> 2] = e, k = i[e - 12 >> 2], e = n + 48 | 0, i[k + e >> 2] = i[14964], k = i[14960], i[n + 40 >> 2] = k, i[r + i[k - 12 >> 2] >> 2] = i[14965], i[n + 104 >> 2] = 59828, i[n + 40 >> 2] = 59788, i[n + 48 >> 2] = 59808, f = z0(f), i[f >> 2] = 58864, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 84 >> 2] = 0, i[n + 88 >> 2] = 0, i[n + 100 >> 2] = 24, r = U(e, 21981, 26), o[n + 16 | 0] = l[w + 24 | 0], U(U(r, n + 16 | 0, 1), 8199, 15), r = i[n + 100 >> 2];
                                            A: {
                                                f: {
                                                    if (r & 16) {
                                                        t = n + 72 | 0, e = i[n + 96 >> 2], r = i[n + 76 >> 2], e >>> 0 < r >>> 0 ? i[n + 96 >> 2] = r : r = e;
                                                        break f;
                                                    }
                                                    if (!(r & 8)) {
                                                        w = 0, o[n + 15 | 0] = 0, t = n + 4 | 0;
                                                        break A;
                                                    }
                                                    t = n + 60 | 0, r = i[n + 68 >> 2];
                                                }
                                                f: {
                                                    if (e = r, r = i[t >> 2], w = e - r | 0, w >>> 0 < 2147483640) {
                                                        if (w >>> 0 >= 11) {
                                                            e = (w | 7) + 1 | 0, t = D(e), i[n + 12 >> 2] = e | -2147483648, i[n + 4 >> 2] = t, i[n + 8 >> 2] = w;
                                                            break f;
                                                        }
                                                        if (o[n + 15 | 0] = w, t = n + 4 | 0, w) break f;
                                                        w = 0;
                                                        break A;
                                                    }
                                                    Y0(), z();
                                                }
                                                Q0(t, r, w);
                                            }
                                            o[t + w | 0] = 0, r = i0(n + 16 | 0, 4, 0, n + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                            A: {
                                                if (o[r + 19 | 0] >= 0) {
                                                    e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                    break A;
                                                }
                                                if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break A;
                                                X(i[r + 8 >> 2]);
                                            }
                                            o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), A = i[14959], i[n + 40 >> 2] = A, i[i[A - 12 >> 2] + (n + 40 | 0) >> 2] = i[14967], i[n + 48 >> 2] = i[14968], i[f >> 2] = 58864, o[n + 95 | 0] < 0 && X(i[n + 84 >> 2]), x0(f), N0(n + 104 | 0);
                                            break e;
                                        }
                                        t = i[w + 4 >> 2];
                                        r: {
                                            if (t) {
                                                for(;;)if (k = t, t = i[k >> 2], !t) break r;
                                            }
                                            for(; k = i[w + 8 >> 2], e = i[k >> 2] != (w | 0), w = k, !!e;);
                                        }
                                        if (w = k, (H | 0) == (k | 0)) break;
                                    }
                                    if (e = i[r + 4 >> 2], !e || (f = i[r >> 2], r = gi(e), !r)) break i;
                                    i[A + 4 >> 2] = r, i[A >> 2] = f, i[r + 4 >> 2] = i[r + 4 >> 2] + 1, e = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    if (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                m = n + 192 | 0;
                                return;
                            }
                            rf(), z();
                        }
                        function v3(A, r, e) {
                            var f = 0, k = 0;
                            i: {
                                e: switch(e - 1 | 0){
                                    case 2:
                                        f = D(400), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82576, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 16 >> 2] = 81016, k = e + 16 | 0;
                                        break i;
                                    case 0:
                                        f = D(400), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82616, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 16 >> 2] = 80360, k = e + 16 | 0;
                                        break i;
                                    case 3:
                                        f = D(400), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82656, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 16 >> 2] = 80644, k = e + 16 | 0;
                                        break i;
                                    case 4:
                                        f = D(400), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82696, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 16 >> 2] = 81760, k = e + 16 | 0;
                                        break i;
                                    case 6:
                                    case 9:
                                        f = D(400), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82908, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 388 >> 2] = 0, i[e + 392 >> 2] = 0, i[e + 16 >> 2] = 81244, k = e + 16 | 0;
                                        break i;
                                    case 8:
                                        break e;
                                    default:
                                        break i;
                                }
                                f = D(392), e = f, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, o[e + 168 | 0] = 0, i[e + 36 >> 2] = r, i[e + 32 >> 2] = 4142, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0, i[e >> 2] = 82948, i[e + 28 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, Q[e - -64 >> 1] = 0, Q[e + 74 >> 1] = 0, Q[e + 76 >> 1] = 0, Q[e + 78 >> 1] = 0, Q[e + 80 >> 1] = 0, o[e + 92 | 0] = 0, o[e + 104 | 0] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, i[e + 188 >> 2] = 0, i[e + 192 >> 2] = 0, i[e + 196 >> 2] = 0, i[e + 200 >> 2] = 0, i[e + 204 >> 2] = 0, i[e + 208 >> 2] = 0, i[e + 212 >> 2] = 0, i[e + 216 >> 2] = 0, i[e + 220 >> 2] = 0, i[e + 304 >> 2] = 0, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, o[e + 224 | 0] = 1, i[e + 228 >> 2] = 0, i[e + 232 >> 2] = 0, o[e + 233 | 0] = 0, o[e + 234 | 0] = 0, o[e + 235 | 0] = 0, o[e + 236 | 0] = 0, o[e + 237 | 0] = 0, o[e + 238 | 0] = 0, o[e + 239 | 0] = 0, o[e + 240 | 0] = 0, i[e + 248 >> 2] = 0, i[e + 252 >> 2] = 0, i[e + 256 >> 2] = 0, i[e + 260 >> 2] = 0, i[e + 264 >> 2] = 0, i[e + 268 >> 2] = 0, i[e + 272 >> 2] = 0, i[e + 276 >> 2] = 0, i[e + 280 >> 2] = 0, i[e + 284 >> 2] = 0, o[e + 288 | 0] = 0, Q[e + 308 >> 1] = 1, i[e + 312 >> 2] = 0, i[e + 316 >> 2] = 0, i[e + 320 >> 2] = 0, i[e + 324 >> 2] = 0, i[e + 328 >> 2] = 0, i[e + 332 >> 2] = 0, i[e + 384 >> 2] = 0, i[e + 376 >> 2] = 0, i[e + 380 >> 2] = 0, i[e + 336 >> 2] = 0, i[e + 340 >> 2] = 1072693248, i[e + 160 >> 2] = 0, i[e + 164 >> 2] = 0, i[e + 152 >> 2] = 0, i[e + 156 >> 2] = 0, i[e + 144 >> 2] = 0, i[e + 148 >> 2] = 0, i[e + 136 >> 2] = 0, i[e + 140 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 124 >> 2] = 0, i[e + 112 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 368 >> 2] = 0, i[e + 360 >> 2] = 0, i[e + 364 >> 2] = 0, i[e + 352 >> 2] = 0, i[e + 356 >> 2] = 0, i[e + 344 >> 2] = 0, i[e + 348 >> 2] = 0, i[e + 16 >> 2] = 82348, k = e + 16 | 0;
                            }
                            i[A + 4 >> 2] = f, i[A >> 2] = k;
                        }
                        function vh(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0;
                            k = m - 256 | 0, m = k, z1(k + 236 | 0, r, e), o[k + 255 | 0] < 0 && X(i[k + 244 >> 2]);
                            i: {
                                F = l[r + 97 | 0];
                                e: {
                                    if (F >>> 0 >= 3) {
                                        s4(A, r, 14712);
                                        break e;
                                    }
                                    u = B2(e);
                                    r: {
                                        if ((F | 0) != 2) {
                                            n = B2(e);
                                            break r;
                                        }
                                        n = n2(e);
                                    }
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (_ = i[f + 28 >> 2], H = n, !(_ >>> 0 < n >>> 0 && _)) {
                                                        if (!n) break f;
                                                        Z0 = u & 15, V0 = (Z0 | 0) != 0 & (F - 1 & 255) >>> 0 < 2, I0 = r + 104 | 0, R = i[14959], T = R - 12 | 0, S = i[14960] - 12 | 0, P = i[14963] - 12 | 0, M = i[14961], $ = M - 12 | 0, c = k + 112 | 0, _ = k + 124 | 0, V = k + 104 | 0, y = k + 100 | 0, r0 = k + 156 | 0, f0 = i[14968], t0 = i[14967], s0 = i[14965], L = i[14964], q = i[14962], B = k + 56 | 6, F0 = (u >>> 4 & 15) - 4 | 0, g0 = (u >>> 12 | 0) - 4 | 0, R0 = (u >>> 8 & 15) - 4 | 0;
                                                        break k;
                                                    }
                                                    i[k + 100 >> 2] = 59808, i[k + 156 >> 2] = 59828, r = i[14961], i[k + 92 >> 2] = r, e = i[r - 12 >> 2], _ = k + 92 | 0, r = _, i[e + r >> 2] = i[14962], i[k + 96 >> 2] = 0, r = r + i[i[k + 92 >> 2] - 12 >> 2] | 0, n = k + 104 | 0, T0(r, n), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[k + 100 >> 2] = r, e = k + 100 | 0, i[e + i[r - 12 >> 2] >> 2] = i[14964], r = i[14960], i[k + 92 >> 2] = r, i[_ + i[r - 12 >> 2] >> 2] = i[14965], i[k + 156 >> 2] = 59828, i[k + 92 >> 2] = 59788, i[k + 100 >> 2] = 59808, _ = z0(n), i[_ >> 2] = 58864, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 152 >> 2] = 24, U(M0(U(M0(U(e, 21387, 18), H), 22076, 44), i[f + 28 >> 2]), 19286, 7), r = i[k + 152 >> 2];
                                                    n: {
                                                        if (r & 16) {
                                                            u = k + 124 | 0, r = i[k + 148 >> 2], e = i[k + 128 >> 2], r >>> 0 < e >>> 0 && (i[k + 148 >> 2] = e, r = e);
                                                            break n;
                                                        }
                                                        if (!(r & 8)) {
                                                            n = 0, o[k + 27 | 0] = 0, u = k + 16 | 0;
                                                            break r;
                                                        }
                                                        u = k + 112 | 0, r = i[k + 120 >> 2];
                                                    }
                                                    if (e = i[u >> 2], n = r - e | 0, n >>> 0 >= 2147483640) break i;
                                                    if (n >>> 0 >= 11) {
                                                        r = (n | 7) + 1 | 0, u = D(r), i[k + 24 >> 2] = r | -2147483648, i[k + 16 >> 2] = u, i[k + 20 >> 2] = n;
                                                        break A;
                                                    }
                                                    if (o[k + 27 | 0] = n, u = k + 16 | 0, n) break A;
                                                    n = 0;
                                                    break r;
                                                }
                                                for(;;){
                                                    o[k + 60 | 0] = 0, i[k + 56 >> 2] = 0, Q[B + 14 >> 1] = 0, Q[B + 16 >> 1] = 0, Q[B + 18 >> 1] = 0, Q[B + 20 >> 1] = 0, Q[B + 8 >> 1] = 0, Q[B + 10 >> 1] = 0, Q[B + 12 >> 1] = 0, Q[B + 14 >> 1] = 0, Q[B >> 1] = 0, Q[B + 2 >> 1] = 0, Q[B + 4 >> 1] = 0, Q[B + 6 >> 1] = 0;
                                                    k: {
                                                        n: {
                                                            t: {
                                                                if (!i[e + 16 >> 2]) {
                                                                    i[k + 92 >> 2] = M, i[k + 100 >> 2] = 59808, i[k + 156 >> 2] = 59828, u = k + 92 | 0, i[u + i[$ >> 2] >> 2] = q, i[k + 96 >> 2] = 0, n = u + i[i[k + 92 >> 2] - 12 >> 2] | 0, T0(n, V), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[i[P >> 2] + y >> 2] = L, i[u + i[S >> 2] >> 2] = s0, i[k + 156 >> 2] = 59828, i[k + 92 >> 2] = 59788, i[k + 100 >> 2] = 59808, h = z0(V), i[h >> 2] = 58864, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 152 >> 2] = 24, U(M0(U(M0(U(y, 21906, 24), H), 22483, 29), m0), 19286, 7), n = i[k + 152 >> 2];
                                                                    o: {
                                                                        if (n & 16) {
                                                                            if (n = _, u = i[k + 148 >> 2], t = i[k + 128 >> 2], u >>> 0 >= t >>> 0) break o;
                                                                            i[k + 148 >> 2] = t, u = t;
                                                                            break o;
                                                                        }
                                                                        if (!(n & 8)) {
                                                                            n = 0, o[k + 27 | 0] = 0, u = k + 16 | 0;
                                                                            break n;
                                                                        }
                                                                        u = i[k + 120 >> 2], n = c;
                                                                    }
                                                                    if (s = i[n >> 2], n = u - s | 0, n >>> 0 >= 2147483640) break i;
                                                                    if (n >>> 0 >= 11) {
                                                                        t = (n | 7) + 1 | 0, u = D(t), i[k + 24 >> 2] = t | -2147483648, i[k + 16 >> 2] = u, i[k + 20 >> 2] = n;
                                                                        break t;
                                                                    }
                                                                    if (o[k + 27 | 0] = n, u = k + 16 | 0, n) break t;
                                                                    n = 0;
                                                                    break n;
                                                                }
                                                                o: {
                                                                    s: {
                                                                        if ((F | 0) == 2) {
                                                                            D0 = k, H0 = n2(e), i[D0 + 56 >> 2] = H0;
                                                                            break s;
                                                                        }
                                                                        if (D0 = k, H0 = B2(e), i[D0 + 56 >> 2] = H0, !F) break o;
                                                                    }
                                                                    D0 = k, H0 = B2(e) & 15, o[D0 + 60 | 0] = H0;
                                                                }
                                                                n = B2(e), i[k + 64 >> 2] = 0, i[k + 68 >> 2] = 0, Q[k + 62 >> 1] = n, u = k;
                                                                o: {
                                                                    s: {
                                                                        u: switch(F0 | 0){
                                                                            case 0:
                                                                                n = n2(e), t = 0;
                                                                                break s;
                                                                            case 4:
                                                                                break u;
                                                                            default:
                                                                                break o;
                                                                        }
                                                                        n = n2(e), i[k + 64 >> 2] = 0, i[k + 68 >> 2] = n, n = n2(e) | i[k + 64 >> 2], t = i[k + 68 >> 2];
                                                                    }
                                                                    i[u + 64 >> 2] = n, i[u + 68 >> 2] = t;
                                                                }
                                                                E = B2(e);
                                                                o: {
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                if (t = i[f + 52 >> 2], !(t >>> 0 < E >>> 0 && t)) {
                                                                                    if (u = 0, E) break w;
                                                                                    break o;
                                                                                }
                                                                                i[k + 92 >> 2] = M, i[k + 100 >> 2] = 59808, i[k + 156 >> 2] = 59828, u = k + 92 | 0, i[u + i[$ >> 2] >> 2] = q, i[k + 96 >> 2] = 0, n = u + i[i[k + 92 >> 2] - 12 >> 2] | 0, T0(n, V), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[i[P >> 2] + y >> 2] = L, i[u + i[S >> 2] >> 2] = s0, i[k + 156 >> 2] = 59828, i[k + 92 >> 2] = 59788, i[k + 100 >> 2] = 59808, h = z0(V), i[h >> 2] = 58864, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 152 >> 2] = 24, U(M0(U(M0(U(y, 20841, 31), E), 20873, 26), t), 34894, 2), n = i[k + 152 >> 2];
                                                                                l: {
                                                                                    if (n & 16) {
                                                                                        if (n = _, u = i[k + 148 >> 2], t = i[k + 128 >> 2], u >>> 0 >= t >>> 0) break l;
                                                                                        i[k + 148 >> 2] = t, u = t;
                                                                                        break l;
                                                                                    }
                                                                                    if (!(n & 8)) {
                                                                                        n = 0, o[k + 27 | 0] = 0, u = k + 16 | 0;
                                                                                        break s;
                                                                                    }
                                                                                    u = i[k + 120 >> 2], n = c;
                                                                                }
                                                                                if (s = i[n >> 2], n = u - s | 0, n >>> 0 >= 2147483640) break i;
                                                                                if (n >>> 0 >= 11) {
                                                                                    t = (n | 7) + 1 | 0, u = D(t), i[k + 24 >> 2] = t | -2147483648, i[k + 16 >> 2] = u, i[k + 20 >> 2] = n;
                                                                                    break u;
                                                                                }
                                                                                if (o[k + 27 | 0] = n, u = k + 16 | 0, n) break u;
                                                                                n = 0;
                                                                                break s;
                                                                            }
                                                                            for(;;){
                                                                                i[k + 48 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0;
                                                                                w: {
                                                                                    l: {
                                                                                        h: {
                                                                                            v: {
                                                                                                _: {
                                                                                                    if (X0 = i[e + 16 >> 2], !X0) {
                                                                                                        i[k + 92 >> 2] = M, i[k + 100 >> 2] = 59808, i[k + 156 >> 2] = 59828, t = k + 92 | 0, i[t + i[$ >> 2] >> 2] = q, i[k + 96 >> 2] = 0, n = t + i[i[k + 92 >> 2] - 12 >> 2] | 0, T0(n, V), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[i[P >> 2] + y >> 2] = L, i[t + i[S >> 2] >> 2] = s0, i[k + 156 >> 2] = 59828, i[k + 92 >> 2] = 59788, i[k + 100 >> 2] = 59808, w = z0(V), i[w >> 2] = 58864, i[k + 144 >> 2] = 0, i[k + 148 >> 2] = 0, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 152 >> 2] = 24, U(P0(U(M0(U(y, 21931, 25), E), 22451, 31), u), 19208, 9), n = i[k + 152 >> 2];
                                                                                                        B: {
                                                                                                            if (n & 16) {
                                                                                                                if (n = _, s = i[k + 148 >> 2], t = i[k + 128 >> 2], s >>> 0 >= t >>> 0) break B;
                                                                                                                i[k + 148 >> 2] = t, s = t;
                                                                                                                break B;
                                                                                                            }
                                                                                                            if (!(n & 8)) {
                                                                                                                n = 0, o[k + 15 | 0] = 0, s = k + 4 | 0;
                                                                                                                break l;
                                                                                                            }
                                                                                                            s = i[k + 120 >> 2], n = c;
                                                                                                        }
                                                                                                        if (h = i[n >> 2], n = s - h | 0, n >>> 0 >= 2147483640) break _;
                                                                                                        if (n >>> 0 >= 11) {
                                                                                                            t = (n | 7) + 1 | 0, s = D(t), i[k + 12 >> 2] = t | -2147483648, i[k + 4 >> 2] = s, i[k + 8 >> 2] = n;
                                                                                                            break h;
                                                                                                        }
                                                                                                        if (o[k + 15 | 0] = n, s = k + 4 | 0, n) break h;
                                                                                                        n = 0;
                                                                                                        break l;
                                                                                                    }
                                                                                                    B: {
                                                                                                        if (!V0) break B;
                                                                                                        m: switch(Z0 - 4 | 0){
                                                                                                            case 0:
                                                                                                                D0 = k, H0 = n2(e), i[D0 + 16 >> 2] = H0, i[k + 20 >> 2] = 0;
                                                                                                                break B;
                                                                                                            case 4:
                                                                                                                break m;
                                                                                                            default:
                                                                                                                break B;
                                                                                                        }
                                                                                                        n = n2(e), i[k + 16 >> 2] = 0, i[k + 20 >> 2] = n, s = n2(e), n = i[k + 20 >> 2], i[k + 16 >> 2] = i[k + 16 >> 2] | s, i[k + 20 >> 2] = n;
                                                                                                    }
                                                                                                    i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, t = k;
                                                                                                    B: {
                                                                                                        m: {
                                                                                                            Z: switch(g0 | 0){
                                                                                                                case 0:
                                                                                                                    n = n2(e), s = 0;
                                                                                                                    break m;
                                                                                                                case 4:
                                                                                                                    break Z;
                                                                                                                default:
                                                                                                                    break B;
                                                                                                            }
                                                                                                            n = n2(e), i[k + 24 >> 2] = 0, i[k + 28 >> 2] = n, n = n2(e) | i[k + 24 >> 2], s = i[k + 28 >> 2];
                                                                                                        }
                                                                                                        i[t + 24 >> 2] = n, i[t + 28 >> 2] = s;
                                                                                                    }
                                                                                                    i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0;
                                                                                                    B: {
                                                                                                        m: {
                                                                                                            Z: switch(R0 | 0){
                                                                                                                case 0:
                                                                                                                    n = n2(e), s = 0;
                                                                                                                    break m;
                                                                                                                case 4:
                                                                                                                    break Z;
                                                                                                                default:
                                                                                                                    break B;
                                                                                                            }
                                                                                                            n = n2(e), i[k + 32 >> 2] = 0, i[k + 36 >> 2] = n, n = n2(e) | i[k + 32 >> 2], s = i[k + 36 >> 2];
                                                                                                        }
                                                                                                        i[t + 32 >> 2] = n, i[t + 36 >> 2] = s;
                                                                                                    }
                                                                                                    n = i[k + 76 >> 2];
                                                                                                    B: {
                                                                                                        if (n >>> 0 < k0[k + 80 >> 2]) {
                                                                                                            if (t = i[k + 20 >> 2], i[n >> 2] = i[k + 16 >> 2], i[n + 4 >> 2] = t, t = i[k + 36 >> 2], i[n + 16 >> 2] = i[k + 32 >> 2], i[n + 20 >> 2] = t, t = i[k + 28 >> 2], i[n + 8 >> 2] = i[k + 24 >> 2], i[n + 12 >> 2] = t, i[n + 32 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, t = i[k + 44 >> 2], s = i[k + 40 >> 2], (t | 0) != (s | 0)) {
                                                                                                                if (w = t - s | 0, (w | 0) < 0) break v;
                                                                                                                h = D(w), i[n + 28 >> 2] = h, i[n + 24 >> 2] = h, t = h + w | 0, i[n + 32 >> 2] = t, v0(h, s, w), i[n + 28 >> 2] = t;
                                                                                                            }
                                                                                                            n = n + 40 | 0;
                                                                                                            break B;
                                                                                                        }
                                                                                                        n = 0;
                                                                                                        m: {
                                                                                                            Z: {
                                                                                                                W: {
                                                                                                                    if (w = i[k + 76 >> 2], G = i[k + 72 >> 2], h = (w - G | 0) / 40 | 0, v = h + 1 | 0, v >>> 0 < 107374183) {
                                                                                                                        if (s = (i[k + 80 >> 2] - G | 0) / 40 | 0, t = s << 1, W = s >>> 0 >= 53687091 ? 107374182 : t >>> 0 > v >>> 0 ? t : v, W) {
                                                                                                                            if (W >>> 0 >= 107374183) break W;
                                                                                                                            n = D(Z(W, 40));
                                                                                                                        }
                                                                                                                        if (s = i[k + 20 >> 2], t = Z(h, 40) + n | 0, i[t >> 2] = i[k + 16 >> 2], i[t + 4 >> 2] = s, C = i[k + 24 >> 2], v = i[k + 28 >> 2], h = i[k + 32 >> 2], s = i[k + 36 >> 2], i[t + 32 >> 2] = 0, i[t + 24 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 16 >> 2] = h, i[t + 20 >> 2] = s, i[t + 8 >> 2] = C, i[t + 12 >> 2] = v, s = i[k + 44 >> 2], v = i[k + 40 >> 2], (s | 0) != (v | 0)) {
                                                                                                                            if (C = s - v | 0, (C | 0) < 0) break Z;
                                                                                                                            h = D(C), i[t + 24 >> 2] = h, s = h + C | 0, i[t + 32 >> 2] = s, v0(h, v, C), i[t + 28 >> 2] = s;
                                                                                                                        }
                                                                                                                        C = Z(W, 40) + n | 0, s = t + 40 | 0;
                                                                                                                        X: {
                                                                                                                            if ((w | 0) == (G | 0)) {
                                                                                                                                n = t;
                                                                                                                                break X;
                                                                                                                            }
                                                                                                                            for(; h = w - 40 | 0, v = i[h + 4 >> 2], n = t - 40 | 0, i[n >> 2] = i[h >> 2], i[n + 4 >> 2] = v, v = i[h + 20 >> 2], i[n + 16 >> 2] = i[h + 16 >> 2], i[n + 20 >> 2] = v, v = i[h + 12 >> 2], i[n + 8 >> 2] = i[h + 8 >> 2], i[n + 12 >> 2] = v, v = t - 8 | 0, i[v >> 2] = 0, W = w - 16 | 0, i[t - 16 >> 2] = i[W >> 2], i[t - 12 >> 2] = i[w - 12 >> 2], t = w - 8 | 0, i[v >> 2] = i[t >> 2], i[t >> 2] = 0, i[W >> 2] = 0, i[W + 4 >> 2] = 0, t = n, w = h, (h | 0) != (G | 0););
                                                                                                                            w = i[k + 76 >> 2], G = i[k + 72 >> 2];
                                                                                                                        }
                                                                                                                        if (i[k + 80 >> 2] = C, i[k + 76 >> 2] = s, i[k + 72 >> 2] = n, (w | 0) != (G | 0)) for(; n = i[w - 16 >> 2], n && (i[w - 12 >> 2] = n, X(n)), w = w - 40 | 0, (G | 0) != (w | 0););
                                                                                                                        G && X(G), n = s;
                                                                                                                        break m;
                                                                                                                    }
                                                                                                                    p0(), z();
                                                                                                                }
                                                                                                                Z2(), z();
                                                                                                            }
                                                                                                            p0(), z();
                                                                                                        }
                                                                                                    }
                                                                                                    i[k + 76 >> 2] = n;
                                                                                                    break w;
                                                                                                }
                                                                                                Y0(), z();
                                                                                            }
                                                                                            p0(), z();
                                                                                        }
                                                                                        Q0(s, h, n);
                                                                                    }
                                                                                    o[n + s | 0] = 0, i0(A, 2, 100, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), i[k + 92 >> 2] = R, i[i[T >> 2] + (k + 92 | 0) >> 2] = t0, i[k + 100 >> 2] = f0, i[w >> 2] = 58864, o[k + 147 | 0] < 0 && X(i[k + 136 >> 2]), x0(w), N0(r0);
                                                                                }
                                                                                if (n = i[k + 40 >> 2], n && (i[k + 44 >> 2] = n, X(n)), X0) {
                                                                                    if (u = u + 1 | 0, (E | 0) == (u | 0)) break o;
                                                                                    continue;
                                                                                }
                                                                                break;
                                                                            }
                                                                            s = 0;
                                                                            break k;
                                                                        }
                                                                        Q0(u, s, n);
                                                                    }
                                                                    o[n + u | 0] = 0, i0(A, 6, 1e3, k + 16 | 0), o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), i[k + 92 >> 2] = R, i[i[T >> 2] + (k + 92 | 0) >> 2] = t0, i[k + 100 >> 2] = f0, i[h >> 2] = 58864, o[k + 147 | 0] < 0 && X(i[k + 136 >> 2]), x0(h), N0(r0), s = 0;
                                                                    break k;
                                                                }
                                                                if (s = 1, l[e + 20 | 0]) break k;
                                                                n = i[r + 108 >> 2];
                                                                o: {
                                                                    if (n >>> 0 < k0[r + 112 >> 2]) {
                                                                        u = i[k + 60 >> 2], i[n >> 2] = i[k + 56 >> 2], i[n + 4 >> 2] = u, t = k - -64 | 0, u = i[t + 4 >> 2], i[n + 8 >> 2] = i[t >> 2], i[n + 12 >> 2] = u, i[n + 24 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, t = i[k + 72 >> 2], u = i[k + 76 >> 2], $3(n + 16 | 0, t, u, (u - t | 0) / 40 | 0), n = n + 32 | 0;
                                                                        break o;
                                                                    }
                                                                    n = J5(I0, k + 56 | 0);
                                                                }
                                                                i[r + 108 >> 2] = n;
                                                                break k;
                                                            }
                                                            Q0(u, s, n);
                                                        }
                                                        o[n + u | 0] = 0, i0(A, 2, 100, k + 16 | 0), o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), i[k + 92 >> 2] = R, i[i[T >> 2] + (k + 92 | 0) >> 2] = t0, i[k + 100 >> 2] = f0, i[h >> 2] = 58864, o[k + 147 | 0] < 0 && X(i[k + 136 >> 2]), x0(h), N0(r0), s = 0;
                                                    }
                                                    if (t = i[k + 72 >> 2], t) {
                                                        if (n = i[k + 76 >> 2], u = t, (n | 0) != (t | 0)) {
                                                            for(; u = i[n - 16 >> 2], u && (i[n - 12 >> 2] = u, X(u)), n = n - 40 | 0, (t | 0) != (n | 0););
                                                            u = i[k + 72 >> 2];
                                                        }
                                                        i[k + 76 >> 2] = t, X(u);
                                                    }
                                                    if (!s) break e;
                                                    if (m0 = m0 + 1 | 0, (m0 | 0) == (H | 0)) break;
                                                }
                                            }
                                            if (l[e + 20 | 0] == 1) {
                                                if (o[k + 92 | 0] = 0, o[k + 103 | 0] = 0, i0(A, 2, 100, k + 92 | 0), o[k + 103 | 0] >= 0) break e;
                                                X(i[k + 92 >> 2]);
                                                break e;
                                            }
                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                                A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                break e;
                                            }
                                            j(r, i[21670], i[21671]);
                                            break e;
                                        }
                                        Q0(u, e, n);
                                    }
                                    o[n + u | 0] = 0, i0(A, 6, 1e3, k + 16 | 0), o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), A = i[14959], i[k + 92 >> 2] = A, i[i[A - 12 >> 2] + (k + 92 | 0) >> 2] = i[14967], i[k + 100 >> 2] = i[14968], i[_ >> 2] = 58864, o[k + 147 | 0] < 0 && X(i[k + 136 >> 2]), x0(_), N0(k + 156 | 0);
                                }
                                m = k + 256 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function _h(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = J(0), v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = J(0), s0 = 0, L = J(0), q = J(0), m0 = J(0), Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = J(0), e2 = J(0), k2 = J(0), t2 = 0, v2 = J(0), y2 = 0, U2 = 0, H2 = J(0), j2 = J(0), K2 = J(0);
                            u = m - 160 | 0, m = u, f = i[e >> 2], W = i[f + 28 >> 2], _ = i[f + 24 >> 2], s = i[k + 4 >> 2], r = s >>> 0 < 4, n = s << 3, E = (r ? 16908801 >>> n | 0 : 0) & 3, P = (r ? 16843265 >>> n | 0 : 0) & 3, C = S0(f, 3);
                            i: {
                                if (C >>> 0 <= 8) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                e: {
                                    if ($ = A1(i[e >> 2], 6), !$ || (S0(i[e >> 2], 6) | 0) == (C | 0)) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                h = D(136), r = h, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), n = i[r + 4 >> 2], f = n + 1 | 0, i[r + 4 >> 2] = f, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[h + 132 >> 2] = 0, i[h + 124 >> 2] = 0, i[h + 128 >> 2] = 0, i[h + 84 >> 2] = 1, i[h + 88 >> 2] = 1, v = h + 76 | 0, i[h + 72 >> 2] = v, i[h + 92 >> 2] = 0, i[h + 96 >> 2] = 0, i[h + 100 >> 2] = 0, i[h + 104 >> 2] = 0, i[h + 108 >> 2] = 0, i[h + 112 >> 2] = 0, o[h + 113 | 0] = 0, o[h + 114 | 0] = 0, o[h + 115 | 0] = 0, o[h + 116 | 0] = 0, o[h + 117 | 0] = 0, o[h + 118 | 0] = 0, o[h + 119 | 0] = 0, o[h + 120 | 0] = 0, R = h + 12 | 0, i[h + 12 >> 2] = R, i[h + 8 >> 2] = i[h + 8 >> 2] + 1, i[h + 4 >> 2] = n, i[h + 16 >> 2] = h, f || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), i[R + 36 >> 2] = s, i[R + 32 >> 2] = 0, i[R + 28 >> 2] = W, i[R + 24 >> 2] = _, J0(u + 136 | 0, R, 0, _, W, C, t), n = ((_ + E | 0) - 1 >>> 0) / (E >>> 0) | 0, f = ((W + P | 0) - 1 >>> 0) / (P >>> 0) | 0, J0(u + 112 | 0, R, 1, n, f, C, t), s = u + 16 | 0;
                                e: {
                                    if (i[u + 136 >> 2]) {
                                        if (r = i[u + 140 >> 2], i[u + 8 >> 2] = i[u + 136 >> 2], i[u + 12 >> 2] = r, o[u + 155 | 0] >= 0) {
                                            r = i[u + 148 >> 2], i[s >> 2] = i[u + 144 >> 2], i[s + 4 >> 2] = r, i[s + 8 >> 2] = i[u + 152 >> 2];
                                            break e;
                                        }
                                        j(s, i[u + 144 >> 2], i[u + 148 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 116 >> 2], i[u + 8 >> 2] = i[u + 112 >> 2], i[u + 12 >> 2] = r, o[u + 131 | 0] >= 0) {
                                        r = i[u + 124 >> 2], i[s >> 2] = i[u + 120 >> 2], i[s + 4 >> 2] = r, i[s + 8 >> 2] = i[u + 128 >> 2];
                                        break e;
                                    }
                                    j(s, i[u + 120 >> 2], i[u + 124 >> 2]);
                                }
                                J0(u + 88 | 0, R, 2, n, f, C, t), f = u + 56 | 0;
                                e: {
                                    if (i[u + 8 >> 2]) {
                                        if (r = i[u + 12 >> 2], i[u + 48 >> 2] = i[u + 8 >> 2], i[u + 52 >> 2] = r, o[u + 27 | 0] >= 0) {
                                            r = i[s + 4 >> 2], i[f >> 2] = i[s >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[s + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 16 >> 2], i[u + 20 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 92 >> 2], i[u + 48 >> 2] = i[u + 88 >> 2], i[u + 52 >> 2] = r, o[u + 107 | 0] >= 0) {
                                        r = i[u + 100 >> 2], i[f >> 2] = i[u + 96 >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[u + 104 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 96 >> 2], i[u + 100 >> 2]);
                                }
                                o[u + 107 | 0] < 0 && X(i[u + 96 >> 2]), o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 131 | 0] < 0 && X(i[u + 120 >> 2]), o[u + 155 | 0] < 0 && X(i[u + 144 >> 2]);
                                e: {
                                    if (i[u + 48 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 52 >> 2], i[A + 8 >> 2] = i[u + 48 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 67 | 0] >= 0) {
                                            A = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 56 >> 2], i[u + 60 >> 2]), o[u + 67 | 0] >= 0) break e;
                                        X(i[u + 56 >> 2]);
                                        break e;
                                    }
                                    o[u + 67 | 0] < 0 && X(i[u + 56 >> 2]);
                                    r: {
                                        if (!$) break r;
                                        if (J0(u + 48 | 0, R, 6, _, W, C, t), i[u + 48 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 52 >> 2], i[A + 8 >> 2] = i[u + 48 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 67 | 0] >= 0) {
                                                A = i[u + 60 >> 2], i[r >> 2] = i[u + 56 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 64 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 56 >> 2], i[u + 60 >> 2]), o[u + 67 | 0] >= 0) break e;
                                            X(i[u + 56 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 67 | 0] >= 0) break r;
                                        X(i[u + 56 >> 2]);
                                    }
                                    r = i[e >> 2], n = r - -64 | 0;
                                    r: {
                                        A: {
                                            if (t = i[r + 64 >> 2], t) {
                                                for(f = n, r = t; s = i[r + 16 >> 2] < 3, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                G = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (G = 0, i[f + 16 >> 2] > 3)) break f;
                                                    c = i[f + 44 >> 2], G = i[f + 52 >> 2];
                                                }
                                                for(f = n, r = t; s = i[r + 16 >> 2] < 4, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                r = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (r = 0, i[f + 16 >> 2] > 4)) break f;
                                                    S = i[f + 52 >> 2], r = i[f + 44 >> 2];
                                                }
                                                for(Z0 = r, f = n, r = t; s = i[r + 16 >> 2] < 5, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            r = 0;
                                            break r;
                                        }
                                        if (r = 0, i[f + 16 >> 2] > 5) break r;
                                        T = i[f + 52 >> 2], r = i[f + 44 >> 2];
                                    }
                                    X0 = r;
                                    r: {
                                        A: {
                                            if (f = i[v >> 2], f) {
                                                for(s = v, r = f; V = i[r + 16 >> 2], s = (V | 0) < 0 ? s : r, r = i[(V >>> 29 & 4) + r >> 2], !!r;);
                                                V = 0;
                                                f: {
                                                    if ((s | 0) == (v | 0) || (V = 0, i[s + 16 >> 2] > 0)) break f;
                                                    r0 = i[s + 44 >> 2], V = i[s + 52 >> 2];
                                                }
                                                for(s = v, r = f; F = i[r + 16 >> 2] <= 0, s = F ? s : r, r = i[(F << 2) + r >> 2], !!r;);
                                                B = 0;
                                                f: {
                                                    if ((s | 0) == (v | 0) || (B = 0, i[s + 16 >> 2] > 1)) break f;
                                                    y2 = i[s + 44 >> 2], B = i[s + 52 >> 2];
                                                }
                                                for(s = v, r = f; F = i[r + 16 >> 2] < 2, s = F ? s : r, r = i[(F << 2) + r >> 2], !!r;);
                                                if ((s | 0) != (v | 0)) break A;
                                            }
                                            F = 0;
                                            break r;
                                        }
                                        if (F = 0, i[s + 16 >> 2] > 2) break r;
                                        U2 = i[s + 52 >> 2] >>> 1 | 0, F = i[s + 44 >> 2];
                                    }
                                    s = 0;
                                    r: {
                                        if (!$) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(r = n; s = i[t + 16 >> 2] < 6, r = s ? r : t, t = i[(s << 2) + t >> 2], !!t;);
                                                if ((r | 0) == (n | 0)) break f;
                                                if (n = 0, i[r + 16 >> 2] > 6) break A;
                                                V0 = i[r + 44 >> 2], n = i[r + 52 >> 2];
                                                break A;
                                            }
                                            n = 0;
                                        }
                                        if (I0 = n, s = 0, !f) break r;
                                        for(r = v; n = i[f + 16 >> 2] < 6, r = n ? r : f, f = i[(n << 2) + f >> 2], !!f;);
                                        if (s = 0, (r | 0) == (v | 0) || (s = 0, i[r + 16 >> 2] > 6)) break r;
                                        F0 = i[r + 52 >> 2], s = i[r + 44 >> 2];
                                    }
                                    n = s, i[u + 84 >> 2] = -1113159960, i[u + 76 >> 2] = 1056964608, i[u + 80 >> 2] = -1093247418, i[u + 68 >> 2] = -1096180881, i[u + 72 >> 2] = 1056964608, i[u + 60 >> 2] = 1038710997, i[u + 64 >> 2] = -1104361250, i[u + 52 >> 2] = 1050220167, i[u + 56 >> 2] = 1058424226, o[u + 48 | 0] = 1, f0 = l[k + 26 | 0], g0 = I[k + 24 >> 1], Te(u + 8 | 0, g0, I[k + 20 >> 1]), r = i[u + 44 >> 2], i[u + 80 >> 2] = i[u + 40 >> 2], i[u + 84 >> 2] = r, r = i[u + 36 >> 2], i[u + 72 >> 2] = i[u + 32 >> 2], i[u + 76 >> 2] = r, r = i[u + 28 >> 2], f = u - -64 | 0, i[f >> 2] = i[u + 24 >> 2], i[f + 4 >> 2] = r, r = i[u + 20 >> 2], i[u + 56 >> 2] = i[u + 16 >> 2], i[u + 60 >> 2] = r, r = i[u + 12 >> 2], i[u + 48 >> 2] = i[u + 8 >> 2], i[u + 52 >> 2] = r;
                                    r: {
                                        if (!W) break r;
                                        if (R0 = T >>> 1 | 0, D0 = S >>> 1 | 0, H0 = G >>> 1 | 0, y = -1 << C ^ -1, t0 = J(16 << C - 8), _) for(T = V >>> 1 | 0, V = _ & -4, S = _ & 3, v = _ >>> 0 < 4, G = 0;;){
                                            M = (Z(G, T) << 1) + r0 | 0, H = (Z(G, D0) << 1) + Z0 | 0;
                                            A: {
                                                if (g0) {
                                                    for(k = (Z(G, R0) << 1) + X0 | 0, f = (Z(G, H0) << 1) + c | 0, i2 = W0[u + 60 >> 2], e2 = W0[u + 56 >> 2], k2 = W0[u + 52 >> 2], s = 0;;){
                                                        t = s << 1, w = J(J(J(I[t + k >> 1]) * i2) + J(J(J(I[f + t >> 1]) * k2) + J(e2 * J(I[t + H >> 1])))), w = J((f0 & 1 ? w : J(J(J(w * J(219)) * J(.00390625)) + t0)) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                r = ~~w;
                                                                break f;
                                                            }
                                                            r = -2147483648;
                                                        }
                                                        if (Q[t + M >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, s = s + 1 | 0, (_ | 0) == (s | 0)) break;
                                                    }
                                                    break A;
                                                }
                                                f = 0;
                                                f: {
                                                    if (f0 & 1) {
                                                        if (s = 0, t = 0, v) break f;
                                                        for(; k = t << 1, Q[k + M >> 1] = I[k + H >> 1], r = k | 2, Q[r + M >> 1] = I[r + H >> 1], r = k | 4, Q[r + M >> 1] = I[r + H >> 1], r = k | 6, Q[r + M >> 1] = I[r + H >> 1], t = t + 4 | 0, f = f + 4 | 0, (V | 0) != (f | 0););
                                                        break f;
                                                    }
                                                    for(;;){
                                                        k = f << 1, w = J(J(J(J(J(I[k + H >> 1]) * J(219)) * J(.00390625)) + t0) + J(.5));
                                                        k: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                r = ~~w;
                                                                break k;
                                                            }
                                                            r = -2147483648;
                                                        }
                                                        if (Q[k + M >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, f = f + 1 | 0, (_ | 0) == (f | 0)) break;
                                                    }
                                                    break A;
                                                }
                                                if (!S) break A;
                                                for(; r = t << 1, Q[r + M >> 1] = I[r + H >> 1], t = t + 1 | 0, s = s + 1 | 0, (S | 0) != (s | 0););
                                            }
                                            if (G = G + 1 | 0, (W | 0) == (G | 0)) break;
                                        }
                                        if (!_) break r;
                                        for(G = B >>> 1 | 0, v2 = J((1 << C - 1 & 65535) >>> 0), B = 0, C = (P | 0) == 2, V = (E | P) >>> 0 < 2;;){
                                            k = Z(B, R0) << 1, s0 = k + X0 | 0, f = (B >>> 0) / (P >>> 0) | 0, r = Z(f, G) << 1, t2 = r + y2 | 0;
                                            A: {
                                                if (g0) {
                                                    for(r = B + 1 | 0, r = C && r >>> 0 < W >>> 0 ? r : B, M = (Z(r, R0) << 1) + X0 | 0, H = (Z(r, D0) << 1) + Z0 | 0, S = (Z(r, H0) << 1) + c | 0, r0 = (Z(B, D0) << 1) + Z0 | 0, T = (Z(B, H0) << 1) + c | 0, H2 = W0[u + 84 >> 2], j2 = W0[u + 80 >> 2], K2 = W0[u + 76 >> 2], i2 = W0[u + 72 >> 2], e2 = W0[u + 68 >> 2], k2 = W0[u + 64 >> 2], s = (Z(f, U2) << 1) + F | 0, t = 0;;){
                                                        f = t << 1, L = J(I[f + s0 >> 1]), q = J(I[f + r0 >> 1]), m0 = J(I[f + T >> 1]), V || (r = t + 1 | 0, r = (C && (E | 0) == 2 && r >>> 0 < _ >>> 0 ? r : t) << 1, L = J(J(J(J(L + J(I[r + s0 >> 1])) + J(I[f + M >> 1])) + J(I[r + M >> 1])) * J(.25)), q = J(J(J(J(q + J(I[r + r0 >> 1])) + J(I[f + H >> 1])) + J(I[r + H >> 1])) * J(.25)), m0 = J(J(J(J(m0 + J(I[r + T >> 1])) + J(I[f + S >> 1])) + J(I[r + S >> 1])) * J(.25))), v = (t >>> 0) / (E >>> 0) << 1, f = v + t2 | 0, w = J(J(L * i2) + J(J(m0 * k2) + J(q * e2))), k = f0 & 1, w = J(J((k ? w : J(J(w * J(224)) * J(.00390625))) + v2) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                r = ~~w;
                                                                break f;
                                                            }
                                                            r = -2147483648;
                                                        }
                                                        Q[f >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, f = s + v | 0, w = J(J(L * H2) + J(J(m0 * K2) + J(q * j2))), w = J(J((k ? w : J(J(w * J(224)) * J(.00390625))) + v2) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                r = ~~w;
                                                                break f;
                                                            }
                                                            r = -2147483648;
                                                        }
                                                        if (Q[f >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, t = t + E | 0, !(_ >>> 0 > t >>> 0)) break;
                                                    }
                                                    break A;
                                                }
                                                if (T = k + c | 0, s = r + F | 0, t = 0, !(f0 & 1)) for(;;){
                                                    v = (t >>> 0) / (E >>> 0) << 1, f = v + t2 | 0, k = t << 1, w = J(J(J(J(J(I[k + s0 >> 1]) * J(224)) * J(.00390625)) + t0) + J(.5));
                                                    f: {
                                                        if (J(r2(w)) < J(2147483648)) {
                                                            r = ~~w;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    Q[f >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, f = s + v | 0, w = J(J(J(J(J(I[k + T >> 1]) * J(224)) * J(.00390625)) + t0) + J(.5));
                                                    f: {
                                                        if (J(r2(w)) < J(2147483648)) {
                                                            r = ~~w;
                                                            break f;
                                                        }
                                                        r = -2147483648;
                                                    }
                                                    if (Q[f >> 1] = (r | 0) >= 0 ? (r | 0) < (y | 0) ? r : y : 0, t = t + E | 0, !(_ >>> 0 > t >>> 0)) break A;
                                                }
                                                for(; f = (t >>> 0) / (E >>> 0) << 1, r = t << 1, Q[f + t2 >> 1] = I[r + s0 >> 1], Q[f + s >> 1] = I[r + T >> 1], t = t + E | 0, _ >>> 0 > t >>> 0;);
                                            }
                                            if (B = B + P | 0, !(W >>> 0 > B >>> 0)) break;
                                        }
                                    }
                                    r: {
                                        if (!$ || (r = S0(i[e >> 2], 6), !W)) break r;
                                        if (t = _ << (r >>> 0 > 8), r = 0, (W | 0) != 1) for(k = W & -2, f = 0; v0(Z(r, F0) + n | 0, Z(r, I0) + V0 | 0, t), e = r | 1, v0(Z(e, F0) + n | 0, Z(e, I0) + V0 | 0, t), r = r + 2 | 0, f = f + 2 | 0, (k | 0) != (f | 0););
                                        if (!(W & 1)) break r;
                                        v0(Z(r, F0) + n | 0, Z(r, I0) + V0 | 0, t);
                                    }
                                    if (i[A + 4 >> 2] = h, i[A >> 2] = R, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            m = u + 160 | 0;
                        }
                        function Bh(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            B = m - 16 | 0, m = B, i[B + 12 >> 2] = 0, i[B + 4 >> 2] = 0, i[B + 8 >> 2] = 0, u = B + 4 | 0;
                            i: {
                                e: {
                                    if (G = i[r + 32 >> 2], w = i[G + 116 >> 2], _ = i[G + 120 >> 2], (w | 0) != (_ | 0)) for(;;){
                                        e = i[w + 4 >> 2] - i[w >> 2] >>> 24 | 0, k = i[u + 4 >> 2], f = i[u + 8 >> 2];
                                        r: {
                                            if (k >>> 0 < f >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] >>> 16 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = k, e = i[w + 4 >> 2] - i[w >> 2] >>> 8 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > k >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        if (i[u + 4 >> 2] = k, r = i[w >> 2], f = i[w + 4 >> 2], G8(u, k, r, f, f - r | 0), w = w + 12 | 0, (_ | 0) == (w | 0)) break;
                                    }
                                    if (w = i[G + 140 >> 2], _ = i[G + 144 >> 2], (w | 0) != (_ | 0)) for(;;){
                                        e = i[w + 4 >> 2] - i[w >> 2] >>> 24 | 0, k = i[u + 4 >> 2], f = i[u + 8 >> 2];
                                        r: {
                                            if (k >>> 0 < f >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] >>> 16 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = k, e = i[w + 4 >> 2] - i[w >> 2] >>> 8 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > k >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, v = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = v, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        if (i[u + 4 >> 2] = k, r = i[w >> 2], f = i[w + 4 >> 2], G8(u, k, r, f, f - r | 0), w = w + 12 | 0, (_ | 0) == (w | 0)) break;
                                    }
                                    if (w = i[G + 128 >> 2], G = i[G + 132 >> 2], (w | 0) != (G | 0)) for(;;){
                                        e = i[w + 4 >> 2] - i[w >> 2] >>> 24 | 0, k = i[u + 4 >> 2], f = i[u + 8 >> 2];
                                        r: {
                                            if (k >>> 0 < f >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, _ = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = _, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] >>> 16 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, _ = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = _, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = k, e = i[w + 4 >> 2] - i[w >> 2] >>> 8 | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > k >>> 0) {
                                                o[k | 0] = e, n = k + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = k - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, n = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < n >>> 0 ? n : r, n ? f = D(n) : f = 0, r = s + f | 0, o[r | 0] = e, _ = f + n | 0, n = r + 1 | 0;
                                            A: {
                                                if ((k | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = k, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - k >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = _, i[u + 4 >> 2] = n, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[u + 4 >> 2] = n, e = i[w + 4 >> 2] - i[w >> 2] | 0, f = i[u + 8 >> 2];
                                        r: {
                                            if (f >>> 0 > n >>> 0) {
                                                o[n | 0] = e, k = n + 1 | 0;
                                                break r;
                                            }
                                            if (t = i[u >> 2], s = n - t | 0, r = s + 1 | 0, (r | 0) < 0) break e;
                                            f = f - t | 0, k = f << 1, k = f >>> 0 >= 1073741823 ? 2147483647 : r >>> 0 < k >>> 0 ? k : r, k ? f = D(k) : f = 0, r = s + f | 0, o[r | 0] = e, _ = f + k | 0, k = r + 1 | 0;
                                            A: {
                                                if ((n | 0) == (t | 0)) {
                                                    f = r;
                                                    break A;
                                                }
                                                if (h = 0, e = n, s = s & 3, s) for(; r = r - 1 | 0, e = e - 1 | 0, o[r | 0] = l[e | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                if (t - n >>> 0 <= 4294967292) for(; o[r - 1 | 0] = l[e - 1 | 0], o[r - 2 | 0] = l[e - 2 | 0], o[r - 3 | 0] = l[e - 3 | 0], r = r - 4 | 0, e = e - 4 | 0, o[r | 0] = l[e | 0], (e | 0) != (t | 0););
                                                t = i[u >> 2];
                                            }
                                            if (i[u + 8 >> 2] = _, i[u + 4 >> 2] = k, i[u >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        if (i[u + 4 >> 2] = k, r = i[w >> 2], f = i[w + 4 >> 2], G8(u, k, r, f, f - r | 0), w = w + 12 | 0, (G | 0) == (w | 0)) break;
                                    }
                                    break i;
                                }
                                p0(), z();
                            }
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                if (r = i[B + 4 >> 2], f = i[B + 8 >> 2], (r | 0) != (f | 0)) {
                                    if (f = f - r | 0, (f | 0) < 0) break i;
                                    e = D(f), i[A >> 2] = e, n = e + f | 0, i[A + 8 >> 2] = n, v0(e, r, f), i[A + 4 >> 2] = n;
                                }
                                f = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = f, A = A + 20 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        f = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]), r = i[B + 4 >> 2];
                                }
                                r && (i[B + 8 >> 2] = r, X(r)), m = B + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function mh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0;
                            for(f = m - 176 | 0, m = f, i[f + 64 >> 2] = 60132, n = i[15036], i[f + 8 >> 2] = n, k = i[n - 12 >> 2], n = f + 8 | 0, i[k + n >> 2] = i[15037], k = n + i[i[f + 8 >> 2] - 12 >> 2] | 0, t = f + 12 | 0, T0(k, t), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, i[f + 64 >> 2] = 60132, i[f + 8 >> 2] = 60112, G = z0(t), i[G >> 2] = 58864, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 60 >> 2] = 16, k = f + 164 | 0, D2(k, r, e), _ = n, u = k, n = o[f + 175 | 0], k = (n | 0) < 0, U(_, k ? i[f + 164 >> 2] : u, k ? i[f + 168 >> 2] : n), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = f + 164 | 0, G0(n, e), u = n, n = o[f + 175 | 0], k = (n | 0) < 0, U(f + 8 | 0, k ? i[f + 164 >> 2] : u, k ? i[f + 168 >> 2] : n), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(f + 8 | 0, 23710, 23), l[r + 100 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24615, 23), l[r + 101 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(qe(U(n, 23997, 19), l[r + 102 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(P0(U(n, 24814, 21), l[r + 103 | 0]), 34895, 1), n = f + 164 | 0, G0(n, e), u = n, n = o[f + 175 | 0], k = (n | 0) < 0, U(f + 8 | 0, k ? i[f + 164 >> 2] : u, k ? i[f + 168 >> 2] : n), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(f + 8 | 0, 23233, 37), n = 0;;){
                                k = f + 8 | 0, M0(k, i[r + 104 >> 2] >>> 31 - n & 1);
                                i: {
                                    if ((n & 7) == 7) {
                                        o[f + 164 | 0] = 32, U(k, f + 164 | 0, 1);
                                        break i;
                                    }
                                    if ((n & 3) != 3) break i;
                                    o[f + 164 | 0] = 46, U(f + 8 | 0, f + 164 | 0, 1);
                                }
                                if (n = n + 1 | 0, (n | 0) == 32) break;
                            }
                            for(k = f + 8 | 0, U(k, 34895, 1), t = f + 164 | 0, G0(t, e), n = 0, _ = k, u = t, k = o[f + 175 | 0], t = (k | 0) < 0, U(_, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(f + 8 | 0, 23271, 36), k = r + 108 | 0; t = f + 8 | 0, P0(t, i[k + (n >>> 3 & 536870908) >> 2] >>> n & 1), n = n + 1 | 0, n & 7 || (o[f + 164 | 0] = 32, U(t, f + 164 | 0, 1)), (n | 0) != 48;);
                            n = f + 8 | 0, U(n, 34895, 1), k = f + 164 | 0, G0(k, e), _ = n, u = k, n = o[f + 175 | 0], k = (n | 0) < 0, U(_, k ? i[f + 164 >> 2] : u, k ? i[f + 168 >> 2] : n), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(f + 8 | 0, 24794, 19), l[r + 116 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(M0(U(n, 24763, 30), I[r + 118 >> 1]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24366, 18), l[r + 120 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(n, 22976, 15);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: switch(n = l[r + 121 | 0], n - 1 | 0){
                                                case 2:
                                                    break r;
                                                case 1:
                                                    break A;
                                                case 0:
                                                    break f;
                                                default:
                                                    break e;
                                            }
                                            U(f + 8 | 0, 18308, 5);
                                            break i;
                                        }
                                        U(f + 8 | 0, 17930, 5);
                                        break i;
                                    }
                                    U(f + 8 | 0, 17784, 5);
                                    break i;
                                }
                                P0(f + 8 | 0, n);
                            }
                            n = U(f + 8 | 0, 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24843, 16), l[r + 122 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24877, 18), l[r + 123 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(M0(U(n, 24250, 16), I[r + 124 >> 1]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24228, 21), l[r + 126 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 23132, 21), l[r + 127 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), n = U(P0(U(n, 24728, 20), l[r + 128 | 0]), 34895, 1), k = f + 164 | 0, G0(k, e), u = k, k = o[f + 175 | 0], t = (k | 0) < 0, U(n, t ? i[f + 164 >> 2] : u, t ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(P0(U(n, 24111, 13), l[r + 132 | 0]), 34895, 1);
                            i: {
                                if (v = i[r + 136 >> 2], y = i[r + 140 >> 2], (v | 0) != (y | 0)) for(_ = f + 20 | 0;;){
                                    r = f + 164 | 0, G0(r, e), k = r, r = o[f + 175 | 0], n = (r | 0) < 0, U(f + 8 | 0, n ? i[f + 164 >> 2] : k, n ? i[f + 168 >> 2] : r), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), r = f + 8 | 0, U(r, 34094, 8), i[e >> 2] = i[e >> 2] + 1, n = f + 164 | 0, G0(n, e), u = r, k = n, r = o[f + 175 | 0], n = (r | 0) < 0, U(u, n ? i[f + 164 >> 2] : k, n ? i[f + 168 >> 2] : r), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), r = U(P0(U(f + 8 | 0, 23074, 20), l[v | 0]), 34895, 1), n = f + 164 | 0, G0(n, e), u = n, n = o[f + 175 | 0], k = (n | 0) < 0, U(r, k ? i[f + 164 >> 2] : u, k ? i[f + 168 >> 2] : n), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(P0(U(r, 24321, 15), l[v + 1 | 0]), 34895, 1);
                                    e: {
                                        if (B = i[v + 4 >> 2], F = i[v + 8 >> 2], (B | 0) == (F | 0)) break e;
                                        for(;;){
                                            G0(f + 144 | 0, e), t = o[f + 155 | 0], u = i[f + 144 >> 2], w = i[f + 148 >> 2], r = f + 8 | 0, W = C1(f + 156 | 0, r);
                                            r: {
                                                if (l[W | 0] != 1) break r;
                                                s = r + i[i[f + 8 >> 2] - 12 >> 2] | 0, V = i[s + 4 >> 2], n = i[s + 24 >> 2], k = i[s + 76 >> 2], (k | 0) == -1 && (h = f + 164 | 0, r = i[s + 28 >> 2], i[h >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(h, 108580), k = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(h), i[s + 76 >> 2] = k);
                                                A: {
                                                    if (!n || (h = i[s + 12 >> 2], r = u, u = (t | 0) < 0, r = u ? r : f + 144 | 0, t = u ? w : t, C = r + t | 0, u = (V & 176) == 32 ? C : r, w = u - r | 0, (w | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, r, w) | 0) != (w | 0))) break A;
                                                    if (r = (t | 0) < (h | 0) ? h - t | 0 : 0, (r | 0) > 0) {
                                                        if (r >>> 0 >= 2147483640) break i;
                                                        f: {
                                                            if (r >>> 0 >= 11) {
                                                                h = (r | 7) + 1 | 0, t = D(h), i[f + 172 >> 2] = h | -2147483648, i[f + 164 >> 2] = t, i[f + 168 >> 2] = r;
                                                                break f;
                                                            }
                                                            o[f + 175 | 0] = r, t = f + 164 | 0;
                                                        }
                                                        if (E = B0(t, k, r) + r | 0, R = 0, o[E | 0] = R, k = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, r) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break A;
                                                    }
                                                    if (r = C - u | 0, (r | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, u, r) | 0) != (r | 0)) break A;
                                                    i[s + 12 >> 2] = 0;
                                                    break r;
                                                }
                                                r = i[i[f + 8 >> 2] - 12 >> 2] + (f + 8 | 0) | 0, N1(r, i[r + 16 >> 2] | 5);
                                            }
                                            if (G1(W), o[f + 155 | 0] < 0 && X(i[f + 144 >> 2]), n = i[B >> 2], W = i[B + 4 >> 2], (n | 0) != (W | 0)) for(;;){
                                                s = l[n | 0], r = i[f + 8 >> 2], k = i[r - 12 >> 2] + (f + 8 | 0) | 0, i[k + 76 >> 2] == -1 && (t = f + 164 | 0, r = i[k + 28 >> 2], i[t >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(t, 108580), p[i[i[r >> 2] + 28 >> 2]](r, 32), d0(t), r = i[f + 8 >> 2]), i[k + 76 >> 2] = 48, r = r - 12 | 0, i[i[r >> 2] + _ >> 2] = 2, r = i[r >> 2] + G | 0, i[r >> 2] = i[r >> 2] & -75 | 8, s = P0(f + 8 | 0, s), V = C1(f + 144 | 0, s);
                                                r: {
                                                    if (l[V | 0] != 1) break r;
                                                    t = s + i[i[s >> 2] - 12 >> 2] | 0, w = i[t + 4 >> 2], k = i[t + 24 >> 2], h = i[t + 76 >> 2], (h | 0) == -1 && (u = f + 164 | 0, r = i[t + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108580), h = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(u), i[t + 76 >> 2] = h);
                                                    A: {
                                                        if (!k || (r = i[t + 12 >> 2], w = (w & 176) == 32 ? 25194 : 25193, u = w - 25193 | 0, (u | 0) > 0 && (p[i[i[k >> 2] + 48 >> 2]](k, 25193, u) | 0) != (u | 0))) break A;
                                                        if (r = (r | 0) > 1 ? r - 1 | 0 : 0, (r | 0) > 0) {
                                                            if (r >>> 0 >= 2147483640) break i;
                                                            f: {
                                                                if (r >>> 0 >= 11) {
                                                                    C = (r | 7) + 1 | 0, u = D(C), i[f + 172 >> 2] = C | -2147483648, i[f + 164 >> 2] = u, i[f + 168 >> 2] = r;
                                                                    break f;
                                                                }
                                                                o[f + 175 | 0] = r, u = f + 164 | 0;
                                                            }
                                                            if (E = B0(u, h, r) + r | 0, R = 0, o[E | 0] = R, h = p[i[i[k >> 2] + 48 >> 2]](k, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, r) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (h | 0)) break A;
                                                        }
                                                        if (r = 25194 - w | 0, (r | 0) > 0 && (p[i[i[k >> 2] + 48 >> 2]](k, w, r) | 0) != (r | 0)) break A;
                                                        i[t + 12 >> 2] = 0;
                                                        break r;
                                                    }
                                                    r = s + i[i[s >> 2] - 12 >> 2] | 0, N1(r, i[r + 16 >> 2] | 5);
                                                }
                                                if (G1(V), n = n + 1 | 0, (W | 0) == (n | 0)) break;
                                            }
                                            r: {
                                                r = f + 8 | 0, u = C1(f + 144 | 0, r);
                                                A: {
                                                    if (l[u | 0] != 1) break A;
                                                    s = r + i[i[f + 8 >> 2] - 12 >> 2] | 0, h = i[s + 4 >> 2], n = i[s + 24 >> 2], t = i[s + 76 >> 2], (t | 0) == -1 && (k = f + 164 | 0, r = i[s + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108580), t = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(k), i[s + 76 >> 2] = t);
                                                    f: {
                                                        if (!n || (r = i[s + 12 >> 2], h = (h & 176) == 32 ? 34896 : 34895, k = h - 34895 | 0, (k | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, 34895, k) | 0) != (k | 0))) break f;
                                                        if (r = (r | 0) > 1 ? r - 1 | 0 : 0, (r | 0) > 0) {
                                                            if (r >>> 0 >= 2147483640) break r;
                                                            k: {
                                                                if (r >>> 0 >= 11) {
                                                                    w = (r | 7) + 1 | 0, k = D(w), i[f + 172 >> 2] = w | -2147483648, i[f + 164 >> 2] = k, i[f + 168 >> 2] = r;
                                                                    break k;
                                                                }
                                                                o[f + 175 | 0] = r, k = f + 164 | 0;
                                                            }
                                                            if (E = B0(k, t, r) + r | 0, R = 0, o[E | 0] = R, k = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, r) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break f;
                                                        }
                                                        if (r = 34896 - h | 0, (r | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, h, r) | 0) != (r | 0)) break f;
                                                        i[s + 12 >> 2] = 0;
                                                        break A;
                                                    }
                                                    r = i[i[f + 8 >> 2] - 12 >> 2] + (f + 8 | 0) | 0, N1(r, i[r + 16 >> 2] | 5);
                                                }
                                                if (G1(u), r = i[i[f + 8 >> 2] - 12 >> 2] + G | 0, i[r >> 2] = i[r >> 2] & -75 | 2, B = B + 12 | 0, (F | 0) == (B | 0)) break e;
                                                continue;
                                            }
                                            break;
                                        }
                                        break i;
                                    }
                                    if (r = i[e >> 2], i[e >> 2] = (r | 0) > 0 ? r - 1 | 0 : 0, v = v + 16 | 0, (y | 0) == (v | 0)) break;
                                }
                                r = i[f + 60 >> 2];
                                e: {
                                    r: {
                                        if (r & 16) {
                                            n = i[f + 56 >> 2], r = i[f + 36 >> 2], n >>> 0 < r >>> 0 && (i[f + 56 >> 2] = r, n = r), r = f + 32 | 0;
                                            break r;
                                        }
                                        if (!(r & 8)) {
                                            n = 0, o[A + 11 | 0] = 0;
                                            break e;
                                        }
                                        n = i[f + 28 >> 2], r = f + 20 | 0;
                                    }
                                    r: {
                                        if (e = i[r >> 2], n = n - e | 0, n >>> 0 < 2147483640) {
                                            if (n >>> 0 >= 11) {
                                                k = (n | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = n, A = r;
                                                break r;
                                            }
                                            if (o[A + 11 | 0] = n, n) break r;
                                            n = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(A, e, n);
                                }
                                o[A + n | 0] = 0, A = i[15035], i[f + 8 >> 2] = A, i[i[A - 12 >> 2] + (f + 8 | 0) >> 2] = i[15038], i[G >> 2] = 58864, o[f + 55 | 0] < 0 && X(i[f + 44 >> 2]), x0(G), N0(f - -64 | 0), m = f + 176 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Zh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = J(0), v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = J(0), s0 = J(0), L = J(0), q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = J(0), k2 = J(0), t2 = J(0);
                            u = m - 160 | 0, m = u, r = i[e >> 2], G = i[r + 28 >> 2], _ = i[r + 24 >> 2], s = i[k + 4 >> 2], f = s >>> 0 < 4, n = s << 3, V = (f ? 16908801 >>> n | 0 : 0) & 3, M = (f ? 16843265 >>> n | 0 : 0) & 3;
                            i: {
                                if ((S0(r, 3) | 0) != 8) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                e: {
                                    if (P = A1(i[e >> 2], 6), !P || (S0(i[e >> 2], 6) | 0) == 8) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                h = D(136), r = h, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), n = i[r + 4 >> 2], f = n + 1 | 0, i[r + 4 >> 2] = f, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[h + 132 >> 2] = 0, i[h + 124 >> 2] = 0, i[h + 128 >> 2] = 0, i[h + 84 >> 2] = 1, i[h + 88 >> 2] = 1, B = h + 76 | 0, i[h + 72 >> 2] = B, i[h + 92 >> 2] = 0, i[h + 96 >> 2] = 0, i[h + 100 >> 2] = 0, i[h + 104 >> 2] = 0, i[h + 108 >> 2] = 0, i[h + 112 >> 2] = 0, o[h + 113 | 0] = 0, o[h + 114 | 0] = 0, o[h + 115 | 0] = 0, o[h + 116 | 0] = 0, o[h + 117 | 0] = 0, o[h + 118 | 0] = 0, o[h + 119 | 0] = 0, o[h + 120 | 0] = 0, y = h + 12 | 0, i[h + 12 >> 2] = y, i[h + 8 >> 2] = i[h + 8 >> 2] + 1, i[h + 4 >> 2] = n, i[h + 16 >> 2] = h, f || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), i[y + 36 >> 2] = s, i[y + 32 >> 2] = 0, i[y + 28 >> 2] = G, i[y + 24 >> 2] = _, J0(u + 136 | 0, y, 0, _, G, 8, t), n = ((_ + V | 0) - 1 >>> 0) / (V >>> 0) | 0, f = ((G + M | 0) - 1 >>> 0) / (M >>> 0) | 0, J0(u + 112 | 0, y, 1, n, f, 8, t), s = u + 16 | 0;
                                e: {
                                    if (i[u + 136 >> 2]) {
                                        if (r = i[u + 140 >> 2], i[u + 8 >> 2] = i[u + 136 >> 2], i[u + 12 >> 2] = r, o[u + 155 | 0] >= 0) {
                                            r = i[u + 148 >> 2], i[s >> 2] = i[u + 144 >> 2], i[s + 4 >> 2] = r, i[s + 8 >> 2] = i[u + 152 >> 2];
                                            break e;
                                        }
                                        j(s, i[u + 144 >> 2], i[u + 148 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 116 >> 2], i[u + 8 >> 2] = i[u + 112 >> 2], i[u + 12 >> 2] = r, o[u + 131 | 0] >= 0) {
                                        r = i[u + 124 >> 2], i[s >> 2] = i[u + 120 >> 2], i[s + 4 >> 2] = r, i[s + 8 >> 2] = i[u + 128 >> 2];
                                        break e;
                                    }
                                    j(s, i[u + 120 >> 2], i[u + 124 >> 2]);
                                }
                                J0(u + 88 | 0, y, 2, n, f, 8, t), f = u + 56 | 0;
                                e: {
                                    if (i[u + 8 >> 2]) {
                                        if (r = i[u + 12 >> 2], i[u + 48 >> 2] = i[u + 8 >> 2], i[u + 52 >> 2] = r, o[u + 27 | 0] >= 0) {
                                            r = i[s + 4 >> 2], i[f >> 2] = i[s >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[s + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 16 >> 2], i[u + 20 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 92 >> 2], i[u + 48 >> 2] = i[u + 88 >> 2], i[u + 52 >> 2] = r, o[u + 107 | 0] >= 0) {
                                        r = i[u + 100 >> 2], i[f >> 2] = i[u + 96 >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[u + 104 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 96 >> 2], i[u + 100 >> 2]);
                                }
                                o[u + 107 | 0] < 0 && X(i[u + 96 >> 2]), o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 131 | 0] < 0 && X(i[u + 120 >> 2]), o[u + 155 | 0] < 0 && X(i[u + 144 >> 2]);
                                e: {
                                    if (i[u + 48 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 52 >> 2], i[A + 8 >> 2] = i[u + 48 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 67 | 0] >= 0) {
                                            A = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 56 >> 2], i[u + 60 >> 2]), o[u + 67 | 0] >= 0) break e;
                                        X(i[u + 56 >> 2]);
                                        break e;
                                    }
                                    o[u + 67 | 0] < 0 && X(i[u + 56 >> 2]);
                                    r: {
                                        if (!P) break r;
                                        if (J0(u + 48 | 0, y, 6, _, G, 8, t), i[u + 48 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 52 >> 2], i[A + 8 >> 2] = i[u + 48 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 67 | 0] >= 0) {
                                                A = i[u + 60 >> 2], i[r >> 2] = i[u + 56 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 64 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 56 >> 2], i[u + 60 >> 2]), o[u + 67 | 0] >= 0) break e;
                                            X(i[u + 56 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 67 | 0] >= 0) break r;
                                        X(i[u + 56 >> 2]);
                                    }
                                    r = i[e >> 2], n = r - -64 | 0;
                                    r: {
                                        A: {
                                            if (t = i[r + 64 >> 2], t) {
                                                for(f = n, r = t; s = i[r + 16 >> 2] < 3, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                r = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (r = 0, i[f + 16 >> 2] > 3)) break f;
                                                    q = i[f + 52 >> 2], r = i[f + 44 >> 2];
                                                }
                                                for($ = r, f = n, r = t; s = i[r + 16 >> 2] < 4, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                r = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (r = 0, i[f + 16 >> 2] > 4)) break f;
                                                    m0 = i[f + 52 >> 2], r = i[f + 44 >> 2];
                                                }
                                                for(Z0 = r, f = n, r = t; s = i[r + 16 >> 2] < 5, f = s ? f : r, r = i[(s << 2) + r >> 2], !!r;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            r = 0;
                                            break r;
                                        }
                                        if (r = 0, i[f + 16 >> 2] > 5) break r;
                                        X0 = i[f + 52 >> 2], r = i[f + 44 >> 2];
                                    }
                                    V0 = r;
                                    r: {
                                        A: {
                                            if (f = i[B >> 2], f) {
                                                for(s = B, r = f; W = i[r + 16 >> 2], s = (W | 0) < 0 ? s : r, r = i[(W >>> 29 & 4) + r >> 2], !!r;);
                                                C = 0;
                                                f: {
                                                    if ((s | 0) == (B | 0) || (C = 0, i[s + 16 >> 2] > 0)) break f;
                                                    c = i[s + 44 >> 2], C = i[s + 52 >> 2];
                                                }
                                                for(s = B, r = f; W = i[r + 16 >> 2] <= 0, s = W ? s : r, r = i[(W << 2) + r >> 2], !!r;);
                                                W = 0;
                                                f: {
                                                    if ((s | 0) == (B | 0) || (W = 0, i[s + 16 >> 2] > 1)) break f;
                                                    H0 = i[s + 52 >> 2], W = i[s + 44 >> 2];
                                                }
                                                for(s = B, r = f; R = i[r + 16 >> 2] < 2, s = R ? s : r, r = i[(R << 2) + r >> 2], !!r;);
                                                if ((s | 0) != (B | 0)) break A;
                                            }
                                            R = 0;
                                            break r;
                                        }
                                        if (R = 0, i[s + 16 >> 2] > 2) break r;
                                        i2 = i[s + 52 >> 2], R = i[s + 44 >> 2];
                                    }
                                    s = 0, v = 0;
                                    r: {
                                        if (!P) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(r = n; E = i[t + 16 >> 2] < 6, r = E ? r : t, t = i[(E << 2) + t >> 2], !!t;);
                                                if ((r | 0) == (n | 0)) break f;
                                                if (E = 0, i[r + 16 >> 2] > 6) break A;
                                                I0 = i[r + 44 >> 2], E = i[r + 52 >> 2];
                                                break A;
                                            }
                                            E = 0;
                                        }
                                        if (v = 0, !f) break r;
                                        for(r = B; n = i[f + 16 >> 2] < 6, r = n ? r : f, f = i[(n << 2) + f >> 2], !!f;);
                                        if (v = 0, (r | 0) == (B | 0) || (v = 0, i[r + 16 >> 2] > 6)) break r;
                                        s = i[r + 52 >> 2], v = i[r + 44 >> 2];
                                    }
                                    if (B = v, i[u + 84 >> 2] = -1113159960, i[u + 76 >> 2] = 1056964608, i[u + 80 >> 2] = -1093247418, i[u + 68 >> 2] = -1096180881, i[u + 72 >> 2] = 1056964608, i[u + 60 >> 2] = 1038710997, i[u + 64 >> 2] = -1104361250, i[u + 52 >> 2] = 1050220167, i[u + 56 >> 2] = 1058424226, o[u + 48 | 0] = 1, F0 = l[k + 26 | 0], g0 = I[k + 24 >> 1], Te(u + 8 | 0, g0, I[k + 20 >> 1]), r = i[u + 44 >> 2], i[u + 80 >> 2] = i[u + 40 >> 2], i[u + 84 >> 2] = r, r = i[u + 36 >> 2], i[u + 72 >> 2] = i[u + 32 >> 2], i[u + 76 >> 2] = r, r = i[u + 28 >> 2], f = u - -64 | 0, i[f >> 2] = i[u + 24 >> 2], i[f + 4 >> 2] = r, r = i[u + 20 >> 2], i[u + 56 >> 2] = i[u + 16 >> 2], i[u + 60 >> 2] = r, r = i[u + 12 >> 2], i[u + 48 >> 2] = i[u + 8 >> 2], i[u + 52 >> 2] = r, !(!G | !_)) {
                                        for(r0 = _ & -4, T = _ & 3, S = F0 & 1, R0 = _ >>> 0 < 4, n = 0;;){
                                            v = Z(n, C) + c | 0, F = Z(n, m0) + Z0 | 0;
                                            r: {
                                                if (g0) {
                                                    for(H = Z(n, X0) + V0 | 0, t = Z(n, q) + $ | 0, r = 0;;){
                                                        k = r + v | 0, w = J(J(J(l[r + H | 0]) * W0[u + 60 >> 2]) + J(J(J(l[r + t | 0]) * W0[u + 52 >> 2]) + J(W0[u + 56 >> 2] * J(l[r + F | 0])))), w = J((S ? w : J(J(J(w * J(219)) * J(.00390625)) + J(16))) + J(.5));
                                                        A: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                f = ~~w;
                                                                break A;
                                                            }
                                                            f = -2147483648;
                                                        }
                                                        if (o[k | 0] = (f | 0) >= 0 ? f >>> 0 >= 255 ? 255 : f : 0, r = r + 1 | 0, (_ | 0) == (r | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                r = 0;
                                                A: {
                                                    if (S) {
                                                        if (t = 0, k = 0, R0) break A;
                                                        for(; o[r + v | 0] = l[r + F | 0], f = r | 1, o[f + v | 0] = l[f + F | 0], f = r | 2, o[f + v | 0] = l[f + F | 0], f = r | 3, o[f + v | 0] = l[f + F | 0], r = r + 4 | 0, k = k + 4 | 0, (r0 | 0) != (k | 0););
                                                        break A;
                                                    }
                                                    for(;;){
                                                        k = r + v | 0, w = J(J(J(J(J(l[r + F | 0]) * J(219)) * J(.00390625)) + J(16)) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                f = ~~w;
                                                                break f;
                                                            }
                                                            f = -2147483648;
                                                        }
                                                        if (o[k | 0] = (f | 0) >= 0 ? f >>> 0 >= 255 ? 255 : f : 0, r = r + 1 | 0, (_ | 0) == (r | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (!T) break r;
                                                for(; o[r + v | 0] = l[r + F | 0], r = r + 1 | 0, t = t + 1 | 0, (T | 0) != (t | 0););
                                            }
                                            if (n = n + 1 | 0, (G | 0) == (n | 0)) break;
                                        }
                                        for(v = (M | 0) == 2, R0 = (V | M) >>> 0 < 2, f = 0;;){
                                            n = Z(f, X0), f0 = n + V0 | 0, k = (f >>> 0) / (M >>> 0) | 0, r = Z(k, H0), D0 = r + W | 0;
                                            r: {
                                                if (g0) {
                                                    for(r = f + 1 | 0, r = v && r >>> 0 < G >>> 0 ? r : f, F = Z(r, X0) + V0 | 0, T = Z(r, m0) + Z0 | 0, S = Z(r, q) + $ | 0, c = Z(f, m0) + Z0 | 0, r0 = Z(f, q) + $ | 0, H = Z(k, i2) + R | 0, r = 0;;){
                                                        t0 = J(l[r + f0 | 0]), s0 = J(l[r + c | 0]), L = J(l[r + r0 | 0]), R0 || (k = r + 1 | 0, k = v && (V | 0) == 2 && k >>> 0 < _ >>> 0 ? k : r, t0 = J(J(J(J(t0 + J(l[k + f0 | 0])) + J(l[r + F | 0])) + J(l[k + F | 0])) * J(.25)), s0 = J(J(J(J(s0 + J(l[k + c | 0])) + J(l[r + T | 0])) + J(l[k + T | 0])) * J(.25)), L = J(J(J(J(L + J(l[k + r0 | 0])) + J(l[r + S | 0])) + J(l[k + S | 0])) * J(.25))), e2 = W0[u + 84 >> 2], k2 = W0[u + 76 >> 2], t2 = W0[u + 80 >> 2], C = (r >>> 0) / (V >>> 0) | 0, n = D0 + C | 0, w = J(J(t0 * W0[u + 72 >> 2]) + J(J(L * W0[u + 64 >> 2]) + J(s0 * W0[u + 68 >> 2]))), t = F0 & 1, w = J(J((t ? w : J(J(w * J(224)) * J(.00390625))) + J(128)) + J(.5));
                                                        A: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                k = ~~w;
                                                                break A;
                                                            }
                                                            k = -2147483648;
                                                        }
                                                        o[n | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, n = C + H | 0, w = J(J(t0 * e2) + J(J(L * k2) + J(s0 * t2))), w = J(J((t ? w : J(J(w * J(224)) * J(.00390625))) + J(128)) + J(.5));
                                                        A: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                k = ~~w;
                                                                break A;
                                                            }
                                                            k = -2147483648;
                                                        }
                                                        if (o[n | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, r = r + V | 0, !(_ >>> 0 > r >>> 0)) break;
                                                    }
                                                    break r;
                                                }
                                                if (H = n + $ | 0, C = r + R | 0, r = 0, !(F0 & 1)) for(;;){
                                                    t = (r >>> 0) / (V >>> 0) | 0, n = t + D0 | 0, w = J(J(J(J(J(l[r + f0 | 0]) * J(224)) * J(.00390625)) + J(16)) + J(.5));
                                                    A: {
                                                        if (J(r2(w)) < J(2147483648)) {
                                                            k = ~~w;
                                                            break A;
                                                        }
                                                        k = -2147483648;
                                                    }
                                                    o[n | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, n = t + C | 0, w = J(J(J(J(J(l[r + H | 0]) * J(224)) * J(.00390625)) + J(16)) + J(.5));
                                                    A: {
                                                        if (J(r2(w)) < J(2147483648)) {
                                                            k = ~~w;
                                                            break A;
                                                        }
                                                        k = -2147483648;
                                                    }
                                                    if (o[n | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, r = r + V | 0, !(_ >>> 0 > r >>> 0)) break r;
                                                }
                                                for(; k = (r >>> 0) / (V >>> 0) | 0, o[k + D0 | 0] = l[r + f0 | 0], o[k + C | 0] = l[r + H | 0], r = r + V | 0, _ >>> 0 > r >>> 0;);
                                            }
                                            if (f = f + M | 0, !(G >>> 0 > f >>> 0)) break;
                                        }
                                    }
                                    r: {
                                        if (!P || (r = S0(i[e >> 2], 6), !G)) break r;
                                        if (n = _ << (r >>> 0 > 8), r = 0, (G | 0) != 1) for(k = G & -2, f = 0; v0(B + Z(r, s) | 0, Z(r, E) + I0 | 0, n), e = r | 1, v0(B + Z(e, s) | 0, Z(e, E) + I0 | 0, n), r = r + 2 | 0, f = f + 2 | 0, (k | 0) != (f | 0););
                                        if (!(G & 1)) break r;
                                        v0(B + Z(r, s) | 0, Z(r, E) + I0 | 0, n);
                                    }
                                    if (i[A + 4 >> 2] = h, i[A >> 2] = y, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            m = u + 160 | 0;
                        }
                        function y7() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            for(o[93072] = 0, o[93073] = 0, o[93074] = 0, o[93075] = 1, o[93076] = 1, o[93077] = 0, o[93078] = 1, o[93079] = 1, o[90336] = 0, o[90337] = 0, o[90338] = 1, o[90339] = 0, o[90340] = 0, o[90341] = 1, o[90342] = 1, o[90343] = 1;;){
                                if ((f | 0) < 0) f = 0;
                                else {
                                    i: {
                                        e: {
                                            if (f >>> 0 <= 1) {
                                                if (A = r << 1, o[A + 87607 | 0] = f, o[A + 87606 | 0] = 0, k = r + 1 | 0, !f) {
                                                    r = k;
                                                    break i;
                                                }
                                                o[(k << 1) + 87606 | 0] = 1, n = 2, A = f - 1 | 0;
                                                break e;
                                            }
                                            if ((f | 0) != 2) break i;
                                            o[(r << 1) + 87606 | 0] = 1, k = r, n = 1, A = 1;
                                        }
                                        o[(k << 1) + 87607 | 0] = A, r = r + n | 0;
                                    }
                                    f = f + 1 | 0;
                                }
                                if (!((r | 0) < 4)) break;
                            }
                            for(i[22594] = 50397952, i[22595] = 50529026, i[22592] = 33620480, i[22593] = 33751554, i[22590] = 16843008, i[22591] = 16974082, i[22588] = 65536, i[22589] = 196610, i[23272] = 16777216, i[23273] = 50332160, i[23274] = 16842753, i[23275] = 50397697, i[23276] = 16908290, i[23277] = 50463234, i[23278] = 16973827, i[23279] = 50528771, r = 0, f = 0;;){
                                if ((f | 0) < 0) f = 0;
                                else {
                                    i: {
                                        e: {
                                            r: {
                                                A: {
                                                    f: {
                                                        k: {
                                                            if (f >>> 0 <= 3) {
                                                                if (A = r << 1, o[A + 87617 | 0] = f, o[A + 87616 | 0] = 0, A = r + 1 | 0, f) break k;
                                                                r = A;
                                                                break i;
                                                            }
                                                            if ((f | 0) != 4) break f;
                                                            Q[(r << 1) + 87616 >> 1] = 769, r = r + 1 | 0;
                                                            break r;
                                                        }
                                                        if (A = A << 1, o[A + 87617 | 0] = f - 1, o[A + 87616 | 0] = 1, A = r + 2 | 0, (f | 0) != 1) break A;
                                                        r = A;
                                                        break i;
                                                    }
                                                    if (f >>> 0 < 6) break r;
                                                    if ((f | 0) != 6) break i;
                                                    break e;
                                                }
                                                if (A = A << 1, o[A + 87617 | 0] = f - 2, o[A + 87616 | 0] = 2, A = r + 3 | 0, (f | 0) == 2) {
                                                    r = A;
                                                    break i;
                                                }
                                                A = A << 1, o[A + 87617 | 0] = f - 3, o[A + 87616 | 0] = 3, r = r + 4 | 0;
                                                break i;
                                            }
                                            A = r << 1, o[A + 87617 | 0] = f - 2, o[A + 87616 | 0] = 2, r = r + 1 | 0;
                                        }
                                        A = r << 1, o[A + 87617 | 0] = f - 3, o[A + 87616 | 0] = 3, r = r + 1 | 0;
                                    }
                                    f = f + 1 | 0;
                                }
                                if (!((r | 0) < 16)) break;
                            }
                            for(i[22626] = 117769988, i[22627] = 117901062, i[22624] = 117507840, i[22625] = 117638914, i[22622] = 100992516, i[22623] = 101123590, i[22620] = 100730368, i[22621] = 100861442, i[22618] = 84215044, i[22619] = 84346118, i[22616] = 83952896, i[22617] = 84083970, i[22614] = 67437572, i[22615] = 67568646, i[22612] = 67175424, i[22613] = 67306498, i[22610] = 50660100, i[22611] = 50791174, i[22608] = 50397952, i[22609] = 50529026, i[22606] = 33882628, i[22607] = 34013702, i[22604] = 33620480, i[22605] = 33751554, i[22602] = 17105156, i[22603] = 17236230, i[22600] = 16843008, i[22601] = 16974082, i[22598] = 327684, i[22599] = 458758, i[22596] = 65536, i[22597] = 196610, i[23280] = 16777216, i[23281] = 50332160, i[23282] = 83887104, i[23283] = 117442048, i[23284] = 16842753, i[23285] = 50397697, i[23286] = 83952641, i[23287] = 117507585, i[23288] = 16908290, i[23289] = 50463234, i[23290] = 84018178, i[23291] = 117573122, i[23292] = 16973827, i[23293] = 50528771, i[23294] = 84083715, i[23295] = 117638659, i[23296] = 17039364, i[23297] = 50594308, i[23298] = 84149252, i[23299] = 117704196, i[23300] = 17104901, i[23301] = 50659845, i[23302] = 84214789, i[23303] = 117769733, i[23304] = 17170438, i[23305] = 50725382, i[23306] = 84280326, i[23307] = 117835270, i[23308] = 17235975, i[23309] = 50790919, i[23310] = 84345863, i[23311] = 117900807, k = 0, A = 0;;){
                                if ((A | 0) < 0) A = 0;
                                else {
                                    i: {
                                        if (!A) {
                                            r = 0, f = A;
                                            break i;
                                        }
                                        for(n = A + 1 & -2, r = 0, f = A, e = 0;;){
                                            (f | 0) > 7 | r >>> 0 > 7 || (t = k << 1, o[t + 87649 | 0] = f, o[t + 87648 | 0] = r, k = k + 1 | 0);
                                            e: {
                                                if ((f | 0) > 8 || (t = r | 1, t >>> 0 > 7)) break e;
                                                u = k << 1, o[u + 87649 | 0] = f - 1, o[u + 87648 | 0] = t, k = k + 1 | 0;
                                            }
                                            if (r = r + 2 | 0, f = f - 2 | 0, e = e + 2 | 0, (n | 0) == (e | 0)) break;
                                        }
                                    }
                                    A & 1 | (f | 0) > 7 | r >>> 0 > 7 || (e = k << 1, o[e + 87649 | 0] = f, o[e + 87648 | 0] = r, k = k + 1 | 0), A = A + 1 | 0;
                                }
                                if (!((k | 0) < 64)) break;
                            }
                            for(k = 0, e = 0; A = e << 1, o[A + 90513 | 0] = k, r = 0, o[A + 90512 | 0] = 0, o[A + 90515 | 0] = k, o[A + 90514 | 0] = 1, o[A + 90517 | 0] = k, o[A + 90516 | 0] = 2, o[A + 90519 | 0] = k, o[A + 90518 | 0] = 3, o[A + 90521 | 0] = k, o[A + 90520 | 0] = 4, o[A + 90523 | 0] = k, o[A + 90522 | 0] = 5, o[A + 90525 | 0] = k, o[A + 90524 | 0] = 6, o[A + 90527 | 0] = k, o[A + 90526 | 0] = 7, o[A + 90529 | 0] = k, o[A + 90528 | 0] = 8, o[A + 90531 | 0] = k, o[A + 90530 | 0] = 9, o[A + 90533 | 0] = k, o[A + 90532 | 0] = 10, o[A + 90535 | 0] = k, o[A + 90534 | 0] = 11, o[A + 90537 | 0] = k, o[A + 90536 | 0] = 12, o[A + 90539 | 0] = k, o[A + 90538 | 0] = 13, o[A + 90541 | 0] = k, o[A + 90540 | 0] = 14, o[A + 90543 | 0] = k, o[A + 90542 | 0] = 15, e = e + 16 | 0, k = k + 1 | 0, (k | 0) != 16;);
                            for(e = 0; k = 0, A = e << 1, o[A + 93249 | 0] = 0, o[A + 93248 | 0] = r, o[A + 93251 | 0] = 1, o[A + 93250 | 0] = r, o[A + 93253 | 0] = 2, o[A + 93252 | 0] = r, o[A + 93255 | 0] = 3, o[A + 93254 | 0] = r, o[A + 93257 | 0] = 4, o[A + 93256 | 0] = r, o[A + 93259 | 0] = 5, o[A + 93258 | 0] = r, o[A + 93261 | 0] = 6, o[A + 93260 | 0] = r, o[A + 93263 | 0] = 7, o[A + 93262 | 0] = r, o[A + 93265 | 0] = 8, o[A + 93264 | 0] = r, o[A + 93267 | 0] = 9, o[A + 93266 | 0] = r, o[A + 93269 | 0] = 10, o[A + 93268 | 0] = r, o[A + 93271 | 0] = 11, o[A + 93270 | 0] = r, o[A + 93273 | 0] = 12, o[A + 93272 | 0] = r, o[A + 93275 | 0] = 13, o[A + 93274 | 0] = r, o[A + 93277 | 0] = 14, o[A + 93276 | 0] = r, o[A + 93279 | 0] = 15, o[A + 93278 | 0] = r, e = e + 16 | 0, r = r + 1 | 0, (r | 0) != 16;);
                            for(A = 0;;){
                                if (e = 0, (A | 0) < 0) A = 0;
                                else {
                                    i: {
                                        if (!A) {
                                            r = 0, f = A;
                                            break i;
                                        }
                                        for(t = A + 1 & -2, r = 0, f = A, n = 0;;){
                                            (f | 0) > 15 | r >>> 0 > 15 || (u = k << 1, o[u + 87777 | 0] = f, o[u + 87776 | 0] = r, k = k + 1 | 0);
                                            e: {
                                                if ((f | 0) > 16 || (u = r | 1, u >>> 0 > 15)) break e;
                                                s = k << 1, o[s + 87777 | 0] = f - 1, o[s + 87776 | 0] = u, k = k + 1 | 0;
                                            }
                                            if (r = r + 2 | 0, f = f - 2 | 0, n = n + 2 | 0, (t | 0) == (n | 0)) break;
                                        }
                                    }
                                    A & 1 | (f | 0) > 15 | r >>> 0 > 15 || (n = k << 1, o[n + 87777 | 0] = f, o[n + 87776 | 0] = r, k = k + 1 | 0), A = A + 1 | 0;
                                }
                                if (!((k | 0) < 256)) break;
                            }
                            for(k = 0; A = k << 1, o[A + 91025 | 0] = e, r = 0, o[A + 91024 | 0] = 0, o[A + 91027 | 0] = e, o[A + 91026 | 0] = 1, o[A + 91029 | 0] = e, o[A + 91028 | 0] = 2, o[A + 91031 | 0] = e, o[A + 91030 | 0] = 3, o[A + 91033 | 0] = e, o[A + 91032 | 0] = 4, o[A + 91035 | 0] = e, o[A + 91034 | 0] = 5, o[A + 91037 | 0] = e, o[A + 91036 | 0] = 6, o[A + 91039 | 0] = e, o[A + 91038 | 0] = 7, o[A + 91041 | 0] = e, o[A + 91040 | 0] = 8, o[A + 91043 | 0] = e, o[A + 91042 | 0] = 9, o[A + 91045 | 0] = e, o[A + 91044 | 0] = 10, o[A + 91047 | 0] = e, o[A + 91046 | 0] = 11, o[A + 91049 | 0] = e, o[A + 91048 | 0] = 12, o[A + 91051 | 0] = e, o[A + 91050 | 0] = 13, o[A + 91053 | 0] = e, o[A + 91052 | 0] = 14, o[A + 91055 | 0] = e, o[A + 91054 | 0] = 15, o[A + 91057 | 0] = e, o[A + 91056 | 0] = 16, o[A + 91059 | 0] = e, o[A + 91058 | 0] = 17, o[A + 91061 | 0] = e, o[A + 91060 | 0] = 18, o[A + 91063 | 0] = e, o[A + 91062 | 0] = 19, o[A + 91065 | 0] = e, o[A + 91064 | 0] = 20, o[A + 91067 | 0] = e, o[A + 91066 | 0] = 21, o[A + 91069 | 0] = e, o[A + 91068 | 0] = 22, o[A + 91071 | 0] = e, o[A + 91070 | 0] = 23, o[A + 91073 | 0] = e, o[A + 91072 | 0] = 24, o[A + 91075 | 0] = e, o[A + 91074 | 0] = 25, o[A + 91077 | 0] = e, o[A + 91076 | 0] = 26, o[A + 91079 | 0] = e, o[A + 91078 | 0] = 27, o[A + 91081 | 0] = e, o[A + 91080 | 0] = 28, o[A + 91083 | 0] = e, o[A + 91082 | 0] = 29, o[A + 91085 | 0] = e, o[A + 91084 | 0] = 30, o[A + 91087 | 0] = e, o[A + 91086 | 0] = 31, k = k + 32 | 0, e = e + 1 | 0, (e | 0) != 32;);
                            for(e = 0; k = 0, A = e << 1, o[A + 93761 | 0] = 0, o[A + 93760 | 0] = r, o[A + 93763 | 0] = 1, o[A + 93762 | 0] = r, o[A + 93765 | 0] = 2, o[A + 93764 | 0] = r, o[A + 93767 | 0] = 3, o[A + 93766 | 0] = r, o[A + 93769 | 0] = 4, o[A + 93768 | 0] = r, o[A + 93771 | 0] = 5, o[A + 93770 | 0] = r, o[A + 93773 | 0] = 6, o[A + 93772 | 0] = r, o[A + 93775 | 0] = 7, o[A + 93774 | 0] = r, o[A + 93777 | 0] = 8, o[A + 93776 | 0] = r, o[A + 93779 | 0] = 9, o[A + 93778 | 0] = r, o[A + 93781 | 0] = 10, o[A + 93780 | 0] = r, o[A + 93783 | 0] = 11, o[A + 93782 | 0] = r, o[A + 93785 | 0] = 12, o[A + 93784 | 0] = r, o[A + 93787 | 0] = 13, o[A + 93786 | 0] = r, o[A + 93789 | 0] = 14, o[A + 93788 | 0] = r, o[A + 93791 | 0] = 15, o[A + 93790 | 0] = r, o[A + 93793 | 0] = 16, o[A + 93792 | 0] = r, o[A + 93795 | 0] = 17, o[A + 93794 | 0] = r, o[A + 93797 | 0] = 18, o[A + 93796 | 0] = r, o[A + 93799 | 0] = 19, o[A + 93798 | 0] = r, o[A + 93801 | 0] = 20, o[A + 93800 | 0] = r, o[A + 93803 | 0] = 21, o[A + 93802 | 0] = r, o[A + 93805 | 0] = 22, o[A + 93804 | 0] = r, o[A + 93807 | 0] = 23, o[A + 93806 | 0] = r, o[A + 93809 | 0] = 24, o[A + 93808 | 0] = r, o[A + 93811 | 0] = 25, o[A + 93810 | 0] = r, o[A + 93813 | 0] = 26, o[A + 93812 | 0] = r, o[A + 93815 | 0] = 27, o[A + 93814 | 0] = r, o[A + 93817 | 0] = 28, o[A + 93816 | 0] = r, o[A + 93819 | 0] = 29, o[A + 93818 | 0] = r, o[A + 93821 | 0] = 30, o[A + 93820 | 0] = r, o[A + 93823 | 0] = 31, o[A + 93822 | 0] = r, e = e + 32 | 0, r = r + 1 | 0, (r | 0) != 32;);
                            for(A = 0;;){
                                if ((A | 0) < 0) A = 0;
                                else {
                                    i: {
                                        if (!A) {
                                            r = 0, f = A;
                                            break i;
                                        }
                                        for(n = A + 1 & -2, r = 0, f = A, e = 0;;){
                                            (f | 0) > 31 | r >>> 0 > 31 || (t = k << 1, o[t + 88289 | 0] = f, o[t + 88288 | 0] = r, k = k + 1 | 0);
                                            e: {
                                                if ((f | 0) > 32 || (t = r | 1, t >>> 0 > 31)) break e;
                                                u = k << 1, o[u + 88289 | 0] = f - 1, o[u + 88288 | 0] = t, k = k + 1 | 0;
                                            }
                                            if (r = r + 2 | 0, f = f - 2 | 0, e = e + 2 | 0, (n | 0) == (e | 0)) break;
                                        }
                                    }
                                    A & 1 | (f | 0) > 31 | r >>> 0 > 31 || (e = k << 1, o[e + 88289 | 0] = f, o[e + 88288 | 0] = r, k = k + 1 | 0), A = A + 1 | 0;
                                }
                                if (!((k | 0) < 1024)) break;
                            }
                            for(n = 2;;){
                                for(A = n - 2 | 0, k = (1 << A << A) - 1 | 0, t = 1 << n, u = n << 2, _ = i[u + 50576 >> 2], s = A << 2, v = i[s + 50480 >> 2], A = 0;;){
                                    for(G = _ + (A << n << 1) | 0, e = 0;;){
                                        for(h = G + (e << 1) | 0, f = 16, r = k; r = r - !f | 0, w = v + (r << 1) | 0, f = f ? f - 1 | 0 : 15, B = f << 1, !!((l[B + 87616 | 0] + (l[w | 0] << 2) | 0) != (e | 0) | (l[B + 87617 | 0] + (l[w + 1 | 0] << 2) | 0) != (A | 0)););
                                        if (o[h + 1 | 0] = f, o[h | 0] = r, e = e + 1 | 0, (t | 0) == (e | 0)) break;
                                    }
                                    if (A = A + 1 | 0, (t | 0) == (A | 0)) break;
                                }
                                for(_ = i[s + 50512 >> 2], v = i[u + 50600 >> 2], A = 0;;){
                                    for(G = v + (A << n << 1) | 0, e = 0;;){
                                        for(h = G + (e << 1) | 0, f = 16, r = k; r = r - !f | 0, w = _ + (r << 1) | 0, f = f ? f - 1 | 0 : 15, B = f << 1, !!((l[B + 90352 | 0] + (l[w | 0] << 2) | 0) != (e | 0) | (l[B + 90353 | 0] + (l[w + 1 | 0] << 2) | 0) != (A | 0)););
                                        if (o[h + 1 | 0] = f, o[h | 0] = r, e = e + 1 | 0, (t | 0) == (e | 0)) break;
                                    }
                                    if (A = A + 1 | 0, (t | 0) == (A | 0)) break;
                                }
                                for(h = i[s + 50544 >> 2], w = i[u + 50624 >> 2], A = 0;;){
                                    for(_ = w + (A << n << 1) | 0, e = 0;;){
                                        for(u = _ + (e << 1) | 0, f = 16, r = k; r = r - !f | 0, s = h + (r << 1) | 0, f = f ? f - 1 | 0 : 15, v = f << 1, !!((l[v + 93088 | 0] + (l[s | 0] << 2) | 0) != (e | 0) | (l[v + 93089 | 0] + (l[s + 1 | 0] << 2) | 0) != (A | 0)););
                                        if (o[u + 1 | 0] = f, o[u | 0] = r, e = e + 1 | 0, (t | 0) == (e | 0)) break;
                                    }
                                    if (A = A + 1 | 0, (t | 0) == (A | 0)) break;
                                }
                                if (n = n + 1 | 0, (n | 0) == 6) break;
                            }
                        }
                        function Gh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0;
                            u = m - 128 | 0, m = u, k = S0(i[e >> 2], 0), n = S0(i[e >> 2], 1), h = S0(i[e >> 2], 2), q = A1(i[e >> 2], 6), q && (I0 = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(k >>> 0 < 9 | n >>> 0 < 9) & h >>> 0 > 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((k | 0) == (n | 0) & (k | 0) == (h | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], c = i[f + 48 >> 2], c && (i[c + 4 >> 2] = i[c + 4 >> 2] + 1, f = i[e >> 2]), M = i[f + 28 >> 2], y = i[f + 24 >> 2], w = D(136), i[w >> 2] = 78252, i[w + 4 >> 2] = 0, i[w + 8 >> 2] = 0, B0(w + 20 | 0, 0, 104), F = i[w + 4 >> 2], E = F + 1 | 0, i[w + 4 >> 2] = E, i[w + 56 >> 2] = 0, i[w + 60 >> 2] = 0, i[w + 44 >> 2] = 99, i[w + 48 >> 2] = 99, i[w + 32 >> 2] = 4142, r = w - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[w + 132 >> 2] = 0, r = w, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, f = r + 76 | 0, i[r + 72 >> 2] = f, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, P = r + 12 | 0, i[r + 12 >> 2] = P, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = F, i[r + 16 >> 2] = r, E || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), i[P + 36 >> 2] = 3, i[P + 32 >> 2] = 0, i[P + 28 >> 2] = M, i[P + 24 >> 2] = y, J0(u + 56 | 0, P, 0, y, M, k, t), J0(u + 32 | 0, P, 1, y, M, n, t), r = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = n, i[r + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(r, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[r >> 2] = i[u + 40 >> 2], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(r, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, P, 2, y, M, h, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[r + 4 >> 2], i[k >> 2] = i[r >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[r + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!q) break r;
                                        if (J0(u + 104 | 0, P, 6, y, M, I0, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], k = r - -64 | 0, h = 0;
                                    r: {
                                        A: {
                                            t = i[r + 64 >> 2];
                                            f: {
                                                if (!t) {
                                                    F = 0;
                                                    break f;
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                t0 = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (t0 = 0, i[r + 16 >> 2] > 0)) break k;
                                                    D0 = i[r + 44 >> 2], t0 = i[r + 52 >> 2];
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                e = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (e = 0, i[r + 16 >> 2] > 1)) break k;
                                                    s = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                                }
                                                for(F = e, r = k, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[r + 16 >> 2] > 2) break r;
                                        S = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                    }
                                    E = e;
                                    r: {
                                        A: {
                                            if (r = i[f >> 2], r) {
                                                for(n = f, e = r; h = i[e + 16 >> 2], n = (h | 0) < 0 ? n : e, e = i[(h >>> 29 & 4) + e >> 2], !!e;);
                                                s0 = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (s0 = 0, i[n + 16 >> 2] > 0)) break f;
                                                    H0 = i[n + 44 >> 2], s0 = i[n + 52 >> 2];
                                                }
                                                for(n = f, e = r; h = i[e + 16 >> 2] <= 0, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 1)) break f;
                                                    B = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                                }
                                                for(h = e, n = f, e = r; R = i[e + 16 >> 2] < 2, n = R ? n : e, e = i[(R << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[n + 16 >> 2] > 2) break r;
                                        H = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                    }
                                    n = e, R = 0;
                                    r: {
                                        if (!q) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = k; R = i[t + 16 >> 2] < 6, e = R ? e : t, t = i[(R << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (k | 0)) break f;
                                                if (m0 = 0, i[e + 16 >> 2] > 6) break A;
                                                i2 = i[e + 44 >> 2], m0 = i[e + 52 >> 2];
                                                break A;
                                            }
                                            m0 = 0;
                                        }
                                        if (R = 0, !r) break r;
                                        for(e = f; k = i[r + 16 >> 2] < 6, e = k ? e : r, r = i[(k << 2) + r >> 2], !!r;);
                                        if (R = 0, (e | 0) == (f | 0) || (R = 0, i[e + 16 >> 2] > 6)) break r;
                                        e2 = i[e + 52 >> 2], R = i[e + 44 >> 2];
                                    }
                                    if (Q[h >> 1] = I[F >> 1], Q[n >> 1] = I[E >> 1], f0 = y - 1 | 0, v = f0 >>> 1 | 0, f0 >>> 0 >= 2) for(f = v >>> 0 <= 1 ? 1 : v, e = 0; k = e << 2, t = k | 2, r = e & -2, $ = r + 2 | 0, G = $ + F | 0, W = r + F | 0, Q[t + h >> 1] = (I[G >> 1] + Z(I[W >> 1], 3) | 0) + 2 >>> 2, k = k + 4 | 0, Q[k + h >> 1] = (I[W >> 1] + Z(I[G >> 1], 3) | 0) + 2 >>> 2, T = n + t | 0, t = E + $ | 0, r = r + E | 0, Q[T >> 1] = (I[t >> 1] + Z(I[r >> 1], 3) | 0) + 2 >>> 2, Q[k + n >> 1] = (I[r >> 1] + Z(I[t >> 1], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (f | 0) != (e | 0););
                                    if ($ = y & 1, $ || (r = f0 << 1, e = y - 2 | 0, Q[r + h >> 1] = I[e + F >> 1], Q[r + n >> 1] = I[e + E >> 1]), f = H >>> 1 | 0, k = B >>> 1 | 0, t = S >>> 1 | 0, S = s >>> 1 | 0, r = M - 1 | 0, s = r >>> 1 | 0, r >>> 0 >= 2) for(H = s >>> 0 <= 1 ? 1 : s, e = 0; G = e << 1, W = G | 1, B = e >>> 1 | 0, C = B + 1 | 0, V = (Z(C, S) << 1) + F | 0, _ = (Z(B, S) << 1) + F | 0, Q[(Z(W, k) << 1) + h >> 1] = (I[V >> 1] + Z(I[_ >> 1], 3) | 0) + 2 >>> 2, G = G + 2 | 0, Q[(Z(G, k) << 1) + h >> 1] = (I[_ >> 1] + Z(I[V >> 1], 3) | 0) + 2 >>> 2, T = n + (Z(f, W) << 1) | 0, W = (Z(t, C) << 1) + E | 0, B = (Z(t, B) << 1) + E | 0, Q[T >> 1] = (I[W >> 1] + Z(I[B >> 1], 3) | 0) + 2 >>> 2, Q[n + (Z(f, G) << 1) >> 1] = (I[B >> 1] + Z(I[W >> 1], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (H | 0) != (e | 0););
                                    if (C = M & 1, C || (e = (M >>> 1 | 0) - 1 | 0, Q[(Z(r, k) << 1) + h >> 1] = I[(Z(e, S) << 1) + F >> 1], Q[n + (Z(r, f) << 1) >> 1] = I[(Z(e, t) << 1) + E >> 1]), !(r >>> 0 < 2 | $)) for(B = (y + E | 0) - 2 | 0, H = (y + F | 0) - 2 | 0, e = y << 1, G = (e + n | 0) - 2 | 0, W = (e + h | 0) - 2 | 0, V = s >>> 0 <= 1 ? 1 : s, e = 0; _ = e << 1, r0 = _ | 1, s = e >>> 1 | 0, Z0 = s + 1 | 0, X0 = H + (Z(Z0, S) << 1) | 0, V0 = H + (Z(s, S) << 1) | 0, Q[W + (Z(r0, k) << 1) >> 1] = (I[X0 >> 1] + Z(I[V0 >> 1], 3) | 0) + 2 >>> 2, _ = _ + 2 | 0, Q[W + (Z(_, k) << 1) >> 1] = (I[V0 >> 1] + Z(I[X0 >> 1], 3) | 0) + 2 >>> 2, T = G + (Z(f, r0) << 1) | 0, r0 = B + (Z(t, Z0) << 1) | 0, s = B + (Z(t, s) << 1) | 0, Q[T >> 1] = (I[r0 >> 1] + Z(I[s >> 1], 3) | 0) + 2 >>> 2, Q[G + (Z(f, _) << 1) >> 1] = (I[s >> 1] + Z(I[r0 >> 1], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (V | 0) != (e | 0););
                                    r: {
                                        if (C) break r;
                                        if (f0 >>> 0 >= 2) for(v = v >>> 0 <= 1 ? 1 : v, B = n + (Z(r, f) << 1) | 0, e = (M >>> 1 | 0) - 1 | 0, H = Z(e, t), G = (Z(r, k) << 1) + h | 0, W = Z(e, S), e = 0; C = e << 2, V = C + G | 0, _ = e >>> 1 | 0, s = (_ + W << 1) + F | 0, Q[V + 2 >> 1] = (I[s + 2 >> 1] + Z(I[s >> 1], 3) | 0) + 2 >>> 2, Q[V + 4 >> 1] = (I[s >> 1] + Z(I[s + 2 >> 1], 3) | 0) + 2 >>> 2, C = B + C | 0, s = (_ + H << 1) + E | 0, Q[C + 2 >> 1] = (I[s + 2 >> 1] + Z(I[s >> 1], 3) | 0) + 2 >>> 2, Q[C + 4 >> 1] = (I[s >> 1] + Z(I[s + 2 >> 1], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (v | 0) != (e | 0););
                                        if ($) break r;
                                        e = y << 1, s = (M >>> 1 | 0) - 1 | 0, Q[(e + ((Z(r, k) << 1) + h | 0) | 0) - 2 >> 1] = I[(((Z(s, S) << 1) + F | 0) + y | 0) - 2 >> 1], Q[(e + (n + (Z(r, f) << 1) | 0) | 0) - 2 >> 1] = I[(((Z(t, s) << 1) + E | 0) + y | 0) - 2 >> 1];
                                    }
                                    r: {
                                        if (r >>> 0 >= 2) {
                                            if (f0 >>> 0 >= 2) for(s = 1;;){
                                                for(e = s >>> 1 | 0, r0 = Z(e, t), Z0 = Z(e, S), X0 = n + (Z(f, s) << 1) | 0, V0 = (Z(k, s) << 1) + h | 0, e = e + 1 | 0, k2 = Z(e, t), t2 = Z(e, S), e = s + 1 | 0, v2 = n + (Z(e, f) << 1) | 0, y2 = (Z(e, k) << 1) + h | 0, e = 1; v = e >>> 1 | 0, B = (v + k2 << 1) + E | 0, $ = I[B + 2 >> 1], B = I[B >> 1], G = (v + r0 << 1) + E | 0, H = I[G >> 1], G = I[G + 2 >> 1], V = (v + t2 << 1) + F | 0, W = I[V >> 1], C = e << 1, L = C + V0 | 0, V = I[V + 2 >> 1], F0 = Z(V, 3), _ = (v + Z0 << 1) + F | 0, v = I[_ >> 1], g0 = Z(v, 3) + 8 | 0, _ = I[_ + 2 >> 1], Q[L + 2 >> 1] = F0 + (W + (g0 + Z(_, 9) | 0) | 0) >>> 4, T = L, R0 = Z(W, 3), L = Z(_, 3) + 8 | 0, Q[T >> 1] = V + (R0 + (L + Z(v, 9) | 0) | 0) >>> 4, T = C + y2 | 0, Q[T + 2 >> 1] = (R0 + (v + L | 0) | 0) + Z(V, 9) >>> 4, Q[T >> 1] = ((_ + g0 | 0) + Z(W, 9) | 0) + F0 >>> 4, v = C + X0 | 0, V = Z($, 3), W = Z(H, 3) + 8 | 0, Q[v + 2 >> 1] = V + (B + (W + Z(G, 9) | 0) | 0) >>> 4, T = v, _ = Z(B, 3), v = Z(G, 3) + 8 | 0, Q[T >> 1] = $ + (_ + (v + Z(H, 9) | 0) | 0) >>> 4, C = C + v2 | 0, Q[C + 2 >> 1] = (_ + (v + H | 0) | 0) + Z($, 9) >>> 4, Q[C >> 1] = V + ((G + W | 0) + Z(B, 9) | 0) >>> 4, e = e + 2 | 0, f0 >>> 0 > e >>> 0;);
                                                if (s = s + 2 | 0, !(r >>> 0 > s >>> 0)) break;
                                            }
                                            if (!M) break r;
                                        }
                                        for(r = s0 >>> 1 | 0, f = t0 >>> 1 | 0, k = y << 1, n = I0 >>> 0 > 8 ? k : y, e = 0; v0((Z(r, e) << 1) + H0 | 0, (Z(e, f) << 1) + D0 | 0, k), q && v0(Z(e, e2) + R | 0, Z(e, m0) + i2 | 0, n), e = e + 1 | 0, (M | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = w, i[A >> 2] = P, i[w + 4 >> 2] = i[w + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[w + 4 >> 2], i[w + 4 >> 2] = A - 1, A || (p[i[i[w >> 2] + 8 >> 2]](w), g(w)), !c || (A = i[c + 4 >> 2], i[c + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[c >> 2] + 8 >> 2]](c), g(c);
                            }
                            m = u + 128 | 0;
                        }
                        function I7(A, r, e, f, k, n, t, u, s, h, w, v, _, B) {
                            var G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0;
                            W = m - 32 | 0, m = W, y = A, G = e, s0 = r, f0 = f, F = W + 20 | 0, V = m + -64 | 0, m = V;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if ((v | 0) >= 16) {
                                                        W2(y + 4 | 0, 1008, 0), o[e + 312 | 0] = 3, o[W + 30 | 0] = 0, o[W + 31 | 0] = 0, Q[F >> 1] = 0, Q[F + 2 >> 1] = 0, Q[F + 4 >> 1] = 0, Q[F + 6 >> 1] = 0;
                                                        break k;
                                                    }
                                                    if (o[W + 31 | 0] = 0, R = -1, E = t - 1 | 0, i[V + 60 >> 2] = E, i[V + 56 >> 2] = E, r = u + h | 0, i[V + 52 >> 2] = r, C = r - 1 | 0, i[V + 48 >> 2] = C, o[W + 30 | 0] = 0, Q[F >> 1] = 0, Q[F + 2 >> 1] = 0, P = q4(G, f0, k, n, t, u, s, h, _, E, r), o[V + 47 | 0] = P, $ = q4(G, f0, k, n, t, u, s, h, _, E, C), o[V + 46 | 0] = $, H = s0 + 924 | 0, c = w << 6, L = (H + c | 0) + (v << 2) | 0, e = p[i[i[y >> 2] + 8 >> 2]](y, i[L >> 2]) | 0, !e) break k;
                                                    A = 1 - w | 0, T = i[e + 96 >> 2];
                                                    n: {
                                                        if (l[W + 30 | 0] | !P) break n;
                                                        if (f = i[G + 168 >> 2], e = E >> f, (e | 0) < 0 || (r0 = i[G + 172 >> 2], (r0 | 0) <= (e | 0))) break r;
                                                        if (f = r >> f, (f | 0) < 0 | (f | 0) >= i[G + 176 >> 2]) break e;
                                                        if (!(l[((i[G + 160 >> 2] + Z(e, 3) | 0) + Z(Z(f, r0), 3) | 0) + 1 | 0] & 3)) break n;
                                                        if (e = i[G + 188 >> 2], f = E >> e, (f | 0) < 0 || (r0 = i[G + 192 >> 2], (r0 | 0) <= (f | 0))) break r;
                                                        if (r = r >> e, (r | 0) < 0 | (r | 0) >= i[G + 196 >> 2]) break e;
                                                        if (e = 0, r = (i[G + 180 >> 2] + Z(f, 12) | 0) + Z(Z(r, r0), 12) | 0, f = r + w | 0, l[f | 0]) {
                                                            if (S = l[f + 2 | 0], S >>> 0 > 15) break k;
                                                            S = p[i[i[y >> 2] + 8 >> 2]](y, i[(H + c | 0) + (S << 2) >> 2]) | 0;
                                                        }
                                                        if (c = A + r | 0, l[c | 0]) {
                                                            if (e = l[c + 2 | 0], e >>> 0 > 15) break k;
                                                            e = p[i[i[y >> 2] + 8 >> 2]](y, i[((A << 6) + H | 0) + (e << 2) >> 2]) | 0;
                                                        }
                                                        t: {
                                                            if (!(!S | !l[f | 0]) && (f = w, i[S + 96 >> 2] == (T | 0))) break t;
                                                            if (!e | !l[c | 0] || (f = A, i[e + 96 >> 2] != (T | 0))) break n;
                                                        }
                                                        o[W + 30 | 0] = 1, e = r + (f << 2) | 0, e = I[e + 4 >> 1] | I[e + 6 >> 1] << 16, Q[F >> 1] = e, Q[F + 2 >> 1] = e >>> 16, R = o[(r + f | 0) + 2 | 0];
                                                    }
                                                    n: {
                                                        if (l[W + 30 | 0] | !$) break n;
                                                        if (e = i[G + 168 >> 2], r = E >> e, (r | 0) < 0 || (f = i[G + 172 >> 2], (f | 0) <= (r | 0))) break r;
                                                        if (e = C >> e, (e | 0) < 0 | (e | 0) >= i[G + 176 >> 2]) break e;
                                                        if (!(l[((i[G + 160 >> 2] + Z(r, 3) | 0) + Z(Z(e, f), 3) | 0) + 1 | 0] & 3)) break n;
                                                        if (e = i[G + 188 >> 2], r = E >> e, (r | 0) < 0 || (S = i[G + 192 >> 2], (S | 0) <= (r | 0))) break r;
                                                        if (e = C >> e, (e | 0) < 0 | (e | 0) >= i[G + 196 >> 2]) break e;
                                                        if (f = 0, r = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(e, S), 12) | 0, e = r + w | 0, l[e | 0]) {
                                                            if (f = l[e + 2 | 0], f >>> 0 > 15) break k;
                                                            f = p[i[i[y >> 2] + 8 >> 2]](y, i[((w << 6) + H | 0) + (f << 2) >> 2]) | 0;
                                                        }
                                                        if (C = A + r | 0, l[C | 0]) {
                                                            if (M = l[C + 2 | 0], M >>> 0 > 15) break k;
                                                            M = p[i[i[y >> 2] + 8 >> 2]](y, i[((A << 6) + H | 0) + (M << 2) >> 2]) | 0;
                                                        }
                                                        t: {
                                                            if (!(!f | !l[e | 0]) && (e = w, i[f + 96 >> 2] == (T | 0))) break t;
                                                            if (!M | !l[C | 0] || (e = A, i[M + 96 >> 2] != (T | 0))) break n;
                                                        }
                                                        o[W + 30 | 0] = 1, f = r + (e << 2) | 0, f = I[f + 4 >> 1] | I[f + 6 >> 1] << 16, Q[F >> 1] = f, Q[F + 2 >> 1] = f >>> 16, R = o[(r + e | 0) + 2 | 0];
                                                    }
                                                    for(c = P | $, $ = s0 + 1308 | 0, r0 = $ + (w << 4) | 0, P = r0 + v | 0, S = y + 4 | 0, e = V + 60 | 0, f = V + 52 | 0, r = V + 47 | 0, M = 1;;){
                                                        if (!l[W + 30 | 0]) {
                                                            C = -1;
                                                            n: {
                                                                if (l[r | 0] != 1) break n;
                                                                if (t0 = i[e >> 2], e = i[G + 168 >> 2], r = t0 >> e, (r | 0) < 0 || (q = i[G + 172 >> 2], (q | 0) <= (r | 0))) break r;
                                                                if (f = i[f >> 2], e = f >> e, (e | 0) < 0 | (e | 0) >= i[G + 176 >> 2]) break e;
                                                                if (!(l[((i[G + 160 >> 2] + Z(r, 3) | 0) + Z(Z(e, q), 3) | 0) + 1 | 0] & 3)) break n;
                                                                if (e = i[G + 188 >> 2], r = t0 >> e, (r | 0) < 0 || (t0 = i[G + 192 >> 2], (t0 | 0) <= (r | 0))) break r;
                                                                if (e = f >> e, (e | 0) < 0 | (e | 0) >= i[G + 196 >> 2]) break e;
                                                                r = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(e, t0), 12) | 0, f = r + w | 0;
                                                                t: {
                                                                    if (l[f | 0] == 1 && (e = w, f = f + 2 | 0, l[P | 0] == l[r0 + o[f | 0] | 0])) break t;
                                                                    if (e = A + r | 0, l[e | 0] != 1 || (f = e + 2 | 0, e = A, l[P | 0] != l[o[f | 0] + ($ + (e << 4) | 0) | 0])) break n;
                                                                }
                                                                o[W + 30 | 0] = 1, r = r + (e << 2) | 0, r = I[r + 4 >> 1] | I[r + 6 >> 1] << 16, Q[F >> 1] = r, Q[F + 2 >> 1] = r >>> 16, R = o[f | 0], C = e;
                                                            }
                                                            n: {
                                                                if (l[W + 30 | 0] != 1) break n;
                                                                if ((R | 0) < 0) {
                                                                    o[W + 30 | 0] = 0, o[W + 31 | 0] = 0;
                                                                    break k;
                                                                }
                                                                if ((C | 0) < 0) break f;
                                                                if (e = p[i[i[y >> 2] + 8 >> 2]](y, i[((C << 6) + H | 0) + (R << 2) >> 2]) | 0, p[i[i[y >> 2] + 8 >> 2]](y, i[L >> 2]), l[($ + (C << 4) | 0) + R | 0] | l[P | 0]) break n;
                                                                if (r = i[G + 96 >> 2], e = i[e + 96 >> 2], (r | 0) != (e | 0)) {
                                                                    e = r - e | 0, e = (e | 0) >= 127 ? 127 : e, e = (e | 0) <= -128 ? -128 : e, f = e >> 31, r = r - T | 0, r = (r | 0) >= 127 ? 127 : r, r = Z((((e ^ f) - f >>> 1 | 0) + 16384 << 16 >> 16) / (e | 0) << 16 >> 16, (r | 0) <= -128 ? -128 : r) + 32 >> 6, r = (r | 0) >= 4095 ? 4095 : r, f = (r | 0) <= -4096 ? -4096 : r, C = I[F >> 1] | I[F + 2 >> 1] << 16, r = Z(f, C >> 16), e = r >> 31, r = Z(((r ^ e) - e | 0) + 127 >>> 8 | 0, (r | 0) < 0 ? -1 : (r | 0) != 0), r = (r | 0) >= 32767 ? 32767 : r, Q[F + 2 >> 1] = (r | 0) <= -32768 ? -32768 : r, r = Z(f, C << 16 >> 16), e = r >> 31, r = Z(((r ^ e) - e | 0) + 127 >>> 8 | 0, (r | 0) < 0 ? -1 : (r | 0) != 0), r = (r | 0) >= 32767 ? 32767 : r, Q[F >> 1] = (r | 0) <= -32768 ? -32768 : r;
                                                                    break n;
                                                                }
                                                                W2(S, 1008, 0), o[G + 312 | 0] = 3;
                                                            }
                                                            if (C = M & 1, e = V + 56 | 0, f = V + 48 | 0, r = V + 46 | 0, M = 0, C) continue;
                                                        }
                                                        break;
                                                    }
                                                    i[V + 40 >> 2] = E, M = -1, r = u - 1 | 0, i[V + 20 >> 2] = r, i[V + 24 >> 2] = r, i[V + 28 >> 2] = r, r = t + s | 0, i[V + 32 >> 2] = r, i[V + 36 >> 2] = r - 1, o[W + 31 | 0] = 0, Q[F + 4 >> 1] = 0, Q[F + 6 >> 1] = 0, r = i[V + 32 >> 2], e = i[V + 20 >> 2], f = q4(G, f0, k, n, t, u, s, h, _, r, e), o[V + 17 | 0] = f, E = F + 4 | 0;
                                                    n: {
                                                        if (l[W + 31 | 0] | !f) break n;
                                                        if (f = i[G + 188 >> 2], r = r >> f, (r | 0) < 0 || (C = i[G + 192 >> 2], (C | 0) <= (r | 0))) break r;
                                                        if (f = e >> f, (f | 0) < 0 | (f | 0) >= i[G + 196 >> 2]) break e;
                                                        if (e = 0, R = 0, f = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(f, C), 12) | 0, r = f + w | 0, l[r | 0]) {
                                                            if (C = l[r + 2 | 0], C >>> 0 > 15) break k;
                                                            R = p[i[i[y >> 2] + 8 >> 2]](y, i[((w << 6) + H | 0) + (C << 2) >> 2]) | 0;
                                                        }
                                                        if (C = A + f | 0, l[C | 0]) {
                                                            if (e = l[C + 2 | 0], e >>> 0 > 15) break k;
                                                            e = p[i[i[y >> 2] + 8 >> 2]](y, i[((A << 6) + H | 0) + (e << 2) >> 2]) | 0;
                                                        }
                                                        t: {
                                                            if (!(!R | !l[r | 0]) && (r = w, i[R + 96 >> 2] == (T | 0))) break t;
                                                            if (!e | !l[C | 0] || (r = A, i[e + 96 >> 2] != (T | 0))) break n;
                                                        }
                                                        o[W + 31 | 0] = 1, e = f + (r << 2) | 0, e = I[e + 4 >> 1] | I[e + 6 >> 1] << 16, Q[E >> 1] = e, Q[E + 2 >> 1] = e >>> 16, M = o[(r + f | 0) + 2 | 0];
                                                    }
                                                    r = i[V + 36 >> 2], e = i[V + 24 >> 2], f = q4(G, f0, k, n, t, u, s, h, _, r, e), o[V + 18 | 0] = f;
                                                    n: {
                                                        if (l[W + 31 | 0] | !f) break n;
                                                        if (f = i[G + 188 >> 2], r = r >> f, (r | 0) < 0 || (C = i[G + 192 >> 2], (C | 0) <= (r | 0))) break r;
                                                        if (f = e >> f, (f | 0) < 0 | (f | 0) >= i[G + 196 >> 2]) break e;
                                                        if (e = 0, R = 0, f = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(f, C), 12) | 0, r = f + w | 0, l[r | 0]) {
                                                            if (C = l[r + 2 | 0], C >>> 0 > 15) break k;
                                                            R = p[i[i[y >> 2] + 8 >> 2]](y, i[((w << 6) + H | 0) + (C << 2) >> 2]) | 0;
                                                        }
                                                        if (C = A + f | 0, l[C | 0]) {
                                                            if (e = l[C + 2 | 0], e >>> 0 > 15) break k;
                                                            e = p[i[i[y >> 2] + 8 >> 2]](y, i[((A << 6) + H | 0) + (e << 2) >> 2]) | 0;
                                                        }
                                                        t: {
                                                            if (!(!R | !l[r | 0]) && (r = w, i[R + 96 >> 2] == (T | 0))) break t;
                                                            if (!e | !l[C | 0] || (r = A, i[e + 96 >> 2] != (T | 0))) break n;
                                                        }
                                                        o[W + 31 | 0] = 1, e = f + (r << 2) | 0, e = I[e + 4 >> 1] | I[e + 6 >> 1] << 16, Q[E >> 1] = e, Q[E + 2 >> 1] = e >>> 16, M = o[(r + f | 0) + 2 | 0];
                                                    }
                                                    r = i[V + 40 >> 2], e = i[V + 28 >> 2], f = q4(G, f0, k, n, t, u, s, h, _, r, e), o[V + 19 | 0] = f;
                                                    n: {
                                                        if (l[W + 31 | 0] | !f) break n;
                                                        if (f = i[G + 188 >> 2], r = r >> f, (r | 0) < 0 || (k = i[G + 192 >> 2], (k | 0) <= (r | 0))) break r;
                                                        if (f = e >> f, (f | 0) < 0 | (f | 0) >= i[G + 196 >> 2]) break e;
                                                        if (e = 0, R = 0, f = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(f, k), 12) | 0, r = f + w | 0, l[r | 0]) {
                                                            if (k = l[r + 2 | 0], k >>> 0 > 15) break k;
                                                            R = p[i[i[y >> 2] + 8 >> 2]](y, i[((w << 6) + H | 0) + (k << 2) >> 2]) | 0;
                                                        }
                                                        if (k = A + f | 0, l[k | 0]) {
                                                            if (e = l[k + 2 | 0], e >>> 0 > 15) break k;
                                                            e = p[i[i[y >> 2] + 8 >> 2]](y, i[((A << 6) + H | 0) + (e << 2) >> 2]) | 0;
                                                        }
                                                        t: {
                                                            if (!(!R | !l[r | 0]) && (r = w, i[R + 96 >> 2] == (T | 0))) break t;
                                                            if (!e | !l[k | 0] || (r = A, i[e + 96 >> 2] != (T | 0))) break n;
                                                        }
                                                        o[W + 31 | 0] = 1, e = f + (r << 2) | 0, e = I[e + 4 >> 1] | I[e + 6 >> 1] << 16, Q[E >> 1] = e, Q[E + 2 >> 1] = e >>> 16, M = o[(r + f | 0) + 2 | 0];
                                                    }
                                                    if (c) break k;
                                                    for(l[W + 31 | 0] && (o[W + 30 | 0] = 1, r = I[F + 4 >> 1] | I[F + 6 >> 1] << 16, Q[F >> 1] = r, Q[F + 2 >> 1] = r >>> 16), o[W + 31 | 0] = 0, n = $ + (w << 4) | 0, C = 0;;){
                                                        r = -1;
                                                        n: {
                                                            if (l[(V + 17 | 0) + C | 0] != 1) break n;
                                                            if (e = C << 2, f = i[G + 188 >> 2], r = i[e + (V + 32 | 0) >> 2] >> f, (r | 0) < 0 || (k = i[G + 192 >> 2], (k | 0) <= (r | 0))) break r;
                                                            if (e = i[e + (V + 20 | 0) >> 2] >> f, (e | 0) < 0 | (e | 0) >= i[G + 196 >> 2]) break e;
                                                            t: {
                                                                o: {
                                                                    if (k = (i[G + 180 >> 2] + Z(r, 12) | 0) + Z(Z(e, k), 12) | 0, _ = k + 2 | 0, e = _ + w | 0, r = o[e | 0], (r | 0) <= 15) {
                                                                        if (l[k + w | 0] == 1 && (f = w, l[P | 0] == l[r + n | 0])) break t;
                                                                        if (l[A + k | 0] == 1) break o;
                                                                        r = -1;
                                                                        break n;
                                                                    }
                                                                    o[G + 312 | 0] = 3, W2(S, 1012, 0);
                                                                    break k;
                                                                }
                                                                if (f = A, e = _ + f | 0, r = -1, l[P | 0] != l[o[e | 0] + ($ + (f << 4) | 0) | 0]) break n;
                                                            }
                                                            o[W + 31 | 0] = 1, r = k + (f << 2) | 0, r = I[r + 4 >> 1] | I[r + 6 >> 1] << 16, Q[E >> 1] = r, Q[E + 2 >> 1] = r >>> 16, M = o[e | 0], r = f;
                                                        }
                                                        n: {
                                                            if (l[W + 31 | 0] != 1) break n;
                                                            if ((M | 0) < 0) {
                                                                o[W + 30 | 0] = 0, o[W + 31 | 0] = 0;
                                                                break k;
                                                            }
                                                            if ((r | 0) < 0) break A;
                                                            e = p[i[i[y >> 2] + 8 >> 2]](y, i[((r << 6) + H | 0) + (M << 2) >> 2]) | 0, f = p[i[i[y >> 2] + 8 >> 2]](y, i[L >> 2]) | 0;
                                                            t: {
                                                                if (!(f && e)) {
                                                                    W2(i[G + 112 >> 2] + 4 | 0, 1012, 0);
                                                                    break t;
                                                                }
                                                                if (e = i[e + 96 >> 2], l[P | 0] | (l[($ + (r << 4) | 0) + M | 0] | (e | 0) == i[f + 96 >> 2]) || (r = i[G + 96 >> 2], f = I[E >> 1] | I[E + 2 >> 1] << 16, i[V + 8 >> 2] = f, i[V + 12 >> 2] = f, En(E, V + 8 | 0, r - e | 0, r - T | 0))) break n;
                                                                W2(S, 1008, 0);
                                                            }
                                                            o[G + 312 | 0] = 3;
                                                        }
                                                        if (C = C + 1 | 0, (C | 0) == 3) break k;
                                                        if (l[W + 31 | 0]) break;
                                                    }
                                                }
                                                m = V - -64 | 0;
                                                break i;
                                            }
                                            y0(18247, 14978, 1801, 6648), z();
                                        }
                                        y0(18247, 14978, 1959, 6648), z();
                                    }
                                    y0(4105, 9012, 118, 3731), z();
                                }
                                y0(4067, 9012, 119, 3731), z();
                            }
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (A = l[W + 30 | 0], r = l[W + 31 | 0], !(!A | !r)) {
                                                        if (I[W + 20 >> 1] != I[W + 24 >> 1] | I[W + 22 >> 1] != I[W + 26 >> 1]) break k;
                                                        je(y, G, s0, t, u, s, h, v, w, W + 12 | 0, W + 19 | 0);
                                                        break f;
                                                    }
                                                    if (je(y, G, s0, t, u, s, h, v, w, W + 12 | 0, W + 19 | 0), A) break A;
                                                    if (v = 0, A = 0, !r) break i;
                                                    break e;
                                                }
                                                o[W + 19 | 0] = 0;
                                            }
                                            A = i[W + 20 >> 2], Q[B >> 1] = A, Q[B + 2 >> 1] = A >>> 16;
                                            break r;
                                        }
                                        if (A = i[W + 20 >> 2], Q[B >> 1] = A, Q[B + 2 >> 1] = A >>> 16, r) break r;
                                        A = 1;
                                        break i;
                                    }
                                    if (v = 1, I[W + 20 >> 1] != I[W + 24 >> 1]) break e;
                                    if (A = 1, I[W + 22 >> 1] == I[W + 26 >> 1]) break i;
                                }
                                A = (v << 2) + B | 0, r = i[W + 24 >> 2], Q[A >> 1] = r, Q[A + 2 >> 1] = r >>> 16, A = v + 1 | 0;
                            }
                            v = A, l[W + 19 | 0] && (A = (v << 2) + B | 0, r = i[W + 12 >> 2], Q[A >> 1] = r, Q[A + 2 >> 1] = r >>> 16, v = v + 1 | 0);
                            i: {
                                if (v >>> 0 <= 1) {
                                    A = v << 2, B0(A + B | 0, 0, 8 - A | 0);
                                    break i;
                                }
                                if ((v | 0) == 2) break i;
                                y0(17882, 14978, 2063, 4150), z();
                            }
                            m = W + 32 | 0;
                        }
                        function Wh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            k = m - 144 | 0, m = k, i[k + 136 >> 2] = 0, i[k + 140 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 112 >> 2] = 0, i[k + 116 >> 2] = 0, s = D(168), i[s >> 2] = 76816, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, y = s + 16 | 0, r = y, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[s + 60 >> 2] = 0, i[s + 64 >> 2] = 0, i[s + 52 >> 2] = 0, i[s + 56 >> 2] = 0, i[s + 72 >> 2] = -1, i[s + 76 >> 2] = -1, i[s + 80 >> 2] = -1, i[s + 84 >> 2] = -1, i[s + 88 >> 2] = 0, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, o[s + 112 | 0] = 0, i[r >> 2] = 80464, i[s + 160 >> 2] = 0, i[s + 152 >> 2] = 0, i[s + 156 >> 2] = 0, o[s + 148 | 0] = 4, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 32 >> 2] = 1752589123, t = i[e >> 2], r = i[e + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[k + 108 >> 2] = r, i[k + 104 >> 2] = t, p[i[i[f >> 2] + 100 >> 2]](k + 92 | 0, i[f + 4 >> 2], k + 104 | 0, n);
                            i: {
                                n = i[k + 92 >> 2];
                                e: {
                                    if (n) {
                                        if (e = i[k + 96 >> 2], t = i[k + 100 >> 2], r = E2(t), r >>> 0 >= 2147483640) break i;
                                        r: {
                                            A: {
                                                if (r >>> 0 >= 11) {
                                                    u = (r | 7) + 1 | 0, f = D(u), i[k + 88 >> 2] = u | -2147483648, i[k + 80 >> 2] = f, i[k + 84 >> 2] = r;
                                                    break A;
                                                }
                                                if (o[k + 91 | 0] = r, f = k + 80 | 0, !r) break r;
                                            }
                                            Q0(f, t, r);
                                        }
                                        o[r + f | 0] = 0, r = i0(k + 32 | 0, n, e, k + 80 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 32 >> 2] = i[r >> 2], i[A + 36 >> 2] = e, A = A + 40 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[k + 91 | 0] >= 0) break e;
                                        X(i[k + 80 >> 2]);
                                        break e;
                                    }
                                    if (i[k + 76 >> 2] = 0, i[k + 72 >> 2] = 0, p[i[i[f >> 2] + 104 >> 2]](k + 32 | 0, i[f + 4 >> 2], k + 80 | 0, k + 68 | 0, 0), t = i[k + 80 >> 2], t) for(;;){
                                        if (n = l[t | 0], (n & 254) == 66) {
                                            i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, H = k + 12 | 0, F = t, E = i[k + 68 >> 2], R = k + 76 | 0, M = k + 72 | 0, r = 0, n = 0, t = 0, _ = 0, V = 0, v = m - 80 | 0, m = v, i[v + 76 >> 2] = 0, i[v + 68 >> 2] = 0, i[v + 72 >> 2] = 0;
                                            r: {
                                                A: {
                                                    f: {
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    if (E) {
                                                                        for(;;){
                                                                            o: {
                                                                                s: {
                                                                                    if (B = _ + 2 | 0, E >>> 0 <= B >>> 0 || (u = _ + F | 0, l[u | 0] | l[u + 1 | 0] | l[B + F | 0] != 3)) break s;
                                                                                    u: {
                                                                                        if (r >>> 0 > t >>> 0) {
                                                                                            o[t | 0] = 0, _ = t + 1 | 0;
                                                                                            break u;
                                                                                        }
                                                                                        if (G = t - n | 0, u = G + 1 | 0, (u | 0) < 0) break f;
                                                                                        r = r - n | 0, h = r << 1, W = r >>> 0 >= 1073741823 ? 2147483647 : u >>> 0 < h >>> 0 ? h : u, W ? h = D(W) : h = 0, _ = h + G | 0, o[_ | 0] = 0, u = _;
                                                                                        w: {
                                                                                            if ((n | 0) == (t | 0)) break w;
                                                                                            if (C = 0, w = u, r = t, u = G & 3, u) for(; w = w - 1 | 0, r = r - 1 | 0, o[w | 0] = l[r | 0], C = C + 1 | 0, (u | 0) != (C | 0););
                                                                                            if (u = h, n - t >>> 0 > 4294967292) break w;
                                                                                            for(; o[w - 1 | 0] = l[r - 1 | 0], o[w - 2 | 0] = l[r - 2 | 0], o[w - 3 | 0] = l[r - 3 | 0], w = w - 4 | 0, r = r - 4 | 0, o[w | 0] = l[r | 0], (r | 0) != (n | 0););
                                                                                            u = h;
                                                                                        }
                                                                                        r = h + W | 0, _ = _ + 1 | 0, n && X(n), n = u;
                                                                                    }
                                                                                    if (r >>> 0 > _ >>> 0) {
                                                                                        o[_ | 0] = 0, t = _ + 1 | 0;
                                                                                        break o;
                                                                                    }
                                                                                    if (h = _ - n | 0, t = h + 1 | 0, (t | 0) < 0) break t;
                                                                                    r = r - n | 0, u = r << 1, W = r >>> 0 >= 1073741823 ? 2147483647 : t >>> 0 < u >>> 0 ? u : t, W ? u = D(W) : u = 0, G = u + h | 0, o[G | 0] = 0, t = G;
                                                                                    u: {
                                                                                        if ((n | 0) == (_ | 0)) break u;
                                                                                        if (C = 0, w = t, r = _, t = h & 3, t) for(; w = w - 1 | 0, r = r - 1 | 0, o[w | 0] = l[r | 0], C = C + 1 | 0, (t | 0) != (C | 0););
                                                                                        if (t = u, n - _ >>> 0 > 4294967292) break u;
                                                                                        for(; o[w - 1 | 0] = l[r - 1 | 0], o[w - 2 | 0] = l[r - 2 | 0], o[w - 3 | 0] = l[r - 3 | 0], w = w - 4 | 0, r = r - 4 | 0, o[w | 0] = l[r | 0], (r | 0) != (n | 0););
                                                                                        t = u;
                                                                                    }
                                                                                    if (h = t, r = u + W | 0, t = G + 1 | 0, !n) {
                                                                                        n = h;
                                                                                        break o;
                                                                                    }
                                                                                    X(n), n = h;
                                                                                    break o;
                                                                                }
                                                                                u = _ + F | 0;
                                                                                s: {
                                                                                    if (r >>> 0 > t >>> 0) {
                                                                                        o[t | 0] = l[u | 0], t = t + 1 | 0;
                                                                                        break s;
                                                                                    }
                                                                                    if (C = t - n | 0, h = C + 1 | 0, (h | 0) < 0) break f;
                                                                                    r = r - n | 0, w = r << 1, W = r >>> 0 >= 1073741823 ? 2147483647 : h >>> 0 < w >>> 0 ? w : h, W ? h = D(W) : h = 0, G = h + C | 0, o[G | 0] = l[u | 0], u = G;
                                                                                    u: {
                                                                                        if ((n | 0) == (t | 0)) break u;
                                                                                        if (w = 0, r = u, B = t, u = C & 3, u) for(; r = r - 1 | 0, B = B - 1 | 0, o[r | 0] = l[B | 0], w = w + 1 | 0, (u | 0) != (w | 0););
                                                                                        if (u = h, n - t >>> 0 > 4294967292) break u;
                                                                                        for(; o[r - 1 | 0] = l[B - 1 | 0], o[r - 2 | 0] = l[B - 2 | 0], o[r - 3 | 0] = l[B - 3 | 0], r = r - 4 | 0, B = B - 4 | 0, o[r | 0] = l[B | 0], (n | 0) != (B | 0););
                                                                                        u = h;
                                                                                    }
                                                                                    r = h + W | 0, t = G + 1 | 0, n && X(n), n = u;
                                                                                }
                                                                                B = _;
                                                                            }
                                                                            if (_ = B + 1 | 0, !(E >>> 0 > _ >>> 0)) break;
                                                                        }
                                                                        i[v + 72 >> 2] = t, i[v + 68 >> 2] = n, i[v + 76 >> 2] = r;
                                                                    }
                                                                    if (t = wi(v + 32 | 0, n, t - n | 0), C2(t, 16), C2(t, 4), n = Z1(t, 3), T = k, S = Z1(t, 1), o[T + 60 | 0] = S, T = k, S = Z1(t, 2), o[T + 33 | 0] = S, T = k, S = (Z1(t, 1) | 0) != 0, o[T + 34 | 0] = S, T = k, S = Z1(t, 5), o[T + 35 | 0] = S, T = k, S = $0(t, 32), i[T + 36 >> 2] = S, C2(t, 16), C2(t, 16), C2(t, 16), T = k, S = Z1(t, 8), o[T + 48 | 0] = S, !n) {
                                                                        w = 0;
                                                                        break k;
                                                                    }
                                                                    for(r = n - 1 >>> 5 | 0, h = r + 1 << 2, w = D(h), _ = n >>> 0 >= 33 ? r : 0, i[w + (_ << 2) >> 2] = 0, r = n >>> 5 | 0, n >>> 0 >= 32 && B0(w, 0, r << 2), u = n & 31, u && (B = (r << 2) + w | 0, i[B >> 2] = i[B >> 2] & (-1 >>> 32 - u ^ -1)), V = D(h), i[V + (_ << 2) >> 2] = 0, n >>> 0 >= 32 && B0(V, 0, r << 2), u && (r = (r << 2) + V | 0, i[r >> 2] = i[r >> 2] & (-1 >>> 32 - u ^ -1)), r = 0;;){
                                                                        u = 1 << r, _ = r >>> 5 << 2, h = _ + w | 0;
                                                                        o: {
                                                                            if ($0(t, 1)) {
                                                                                G = u | i[h >> 2];
                                                                                break o;
                                                                            }
                                                                            G = i[h >> 2] & (u ^ -1);
                                                                        }
                                                                        i[h >> 2] = G, h = _ + V | 0;
                                                                        o: {
                                                                            if ($0(t, 1)) {
                                                                                u = u | i[h >> 2];
                                                                                break o;
                                                                            }
                                                                            u = i[h >> 2] & (u ^ -1);
                                                                        }
                                                                        if (i[h >> 2] = u, r = r + 1 | 0, (n | 0) == (r | 0)) break;
                                                                    }
                                                                    break n;
                                                                }
                                                                i[v + 72 >> 2] = _;
                                                                break A;
                                                            }
                                                            if (n >>> 0 < 8) for(r = n; C2(t, 2), r = r + 1 | 0, (r | 0) != 8;);
                                                            if (!n) break k;
                                                            for(r = 0; h = 1 << r, u = r >>> 5 << 2, h & i[u + w >> 2] && (C2(t, 8), C2(t, 32), C2(t, 16)), h & i[u + V >> 2] && C2(t, 8), r = r + 1 | 0, (n | 0) != (r | 0););
                                                        }
                                                        R1(t, v + 28 | 0), R1(t, v + 24 | 0), r = i[v + 24 >> 2], o[k + 53 | 0] = r, (r & 255) == 3 && C2(t, 1), R1(t, R), R1(t, M), $0(t, 1) && (R1(t, v + 20 | 0), R1(t, v + 16 | 0), R1(t, v + 12 | 0), R1(t, v + 8 | 0), r = l[k + 53 | 0], i[R >> 2] = i[R >> 2] - (i[v + 16 >> 2] + i[v + 20 >> 2] << ((r - 1 & 255) >>> 0 < 2)), i[M >> 2] = i[M >> 2] - (i[v + 8 >> 2] + i[v + 12 >> 2] << ((r | 0) == 1))), r = v + 24 | 0, R1(t, r), o[k + 54 | 0] = l[v + 24 | 0] + 8, R1(t, r), r = l[v + 24 | 0], i[k + 56 >> 2] = 16777216, o[k + 52 | 0] = 0, Q[k + 50 >> 1] = 0, o[k + 32 | 0] = 1, o[k + 55 | 0] = r + 8, n = i[21669], r = H, i[r >> 2] = i[21668], i[r + 4 >> 2] = n, r = r + 8 | 0;
                                                        k: {
                                                            if (o[86691] >= 0) {
                                                                n = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = n, i[r + 8 >> 2] = i[21672];
                                                                break k;
                                                            }
                                                            j(r, i[21670], i[21671]);
                                                        }
                                                        V && X(V), w && X(w), r = i[v + 68 >> 2], r && (i[v + 72 >> 2] = r, X(r)), m = v + 80 | 0;
                                                        break r;
                                                    }
                                                    i[v + 72 >> 2] = t;
                                                }
                                                i[v + 68 >> 2] = n, i[v + 76 >> 2] = r, p0(), z();
                                            }
                                            o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), r = i[k + 36 >> 2], i[s + 116 >> 2] = i[k + 32 >> 2], i[s + 120 >> 2] = r, r = l[k + 57 | 0] | l[k + 58 | 0] << 8 | (l[k + 59 | 0] << 16 | l[k + 60 | 0] << 24), n = l[k + 53 | 0] | l[k + 54 | 0] << 8 | (l[k + 55 | 0] << 16 | l[k + 56 | 0] << 24), o[s + 137 | 0] = n, o[s + 138 | 0] = n >>> 8, o[s + 139 | 0] = n >>> 16, o[s + 140 | 0] = n >>> 24, o[s + 141 | 0] = r, o[s + 142 | 0] = r >>> 8, o[s + 143 | 0] = r >>> 16, o[s + 144 | 0] = r >>> 24, r = i[k + 52 >> 2], i[s + 132 >> 2] = i[k + 48 >> 2], i[s + 136 >> 2] = r, r = i[k + 44 >> 2], i[s + 124 >> 2] = i[k + 40 >> 2], i[s + 128 >> 2] = r, i[k + 136 >> 2] = i[k + 76 >> 2], i[k + 140 >> 2] = i[k + 72 >> 2], t = i[k + 80 >> 2], n = l[t | 0];
                                        }
                                        r = i[k + 68 >> 2];
                                        r: {
                                            if ((((n & 254) >>> 1 | 0) - 32 & 255) >>> 0 <= 2) {
                                                u = m - 32 | 0, m = u, i[u + 28 >> 2] = 0, i[u + 20 >> 2] = 0, i[u + 24 >> 2] = 0, r ? (r1(u + 20 | 0, r), n = i[u + 20 >> 2]) : n = 0, v0(n, t, r), i[u + 16 >> 2] = 0, i[u + 8 >> 2] = 0, i[u + 12 >> 2] = 0, o[u + 4 | 0] = 0, o[u + 5 | 0] = l[i[u + 20 >> 2]] >>> 1, T = u, S = U3(u + 8 | 0, u + 20 | 0), i[T + 12 >> 2] = S, r = i[y + 140 >> 2];
                                                A: {
                                                    if (r >>> 0 < k0[y + 144 >> 2]) {
                                                        n = I[u + 4 >> 1], i[r + 12 >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, Q[r >> 1] = n, n = i[u + 8 >> 2], t = i[u + 12 >> 2], eA(r + 4 | 0, n, t, (t - n | 0) / 12 | 0), r = r + 16 | 0;
                                                        break A;
                                                    }
                                                    r = T5(y + 136 | 0, u + 4 | 0);
                                                }
                                                if (i[y + 140 >> 2] = r, n = i[u + 8 >> 2], n) {
                                                    if (r = i[u + 12 >> 2], t = n, (r | 0) != (t | 0)) {
                                                        for(; t = r - 12 | 0, h = i[t >> 2], h && (i[r - 8 >> 2] = h, X(h)), r = t, (n | 0) != (r | 0););
                                                        t = i[u + 8 >> 2];
                                                    }
                                                    i[u + 12 >> 2] = n, X(t);
                                                }
                                                r = i[u + 20 >> 2], r && (i[u + 24 >> 2] = r, X(r)), m = u + 32 | 0;
                                                break r;
                                            }
                                            P9(k + 112 | 0, t, r);
                                        }
                                        if (p[i[i[f >> 2] + 104 >> 2]](k + 32 | 0, i[f + 4 >> 2], k + 80 | 0, k + 68 | 0, 0), t = i[k + 80 >> 2], !t) break;
                                    }
                                    if (!(i[k + 72 >> 2] && i[k + 76 >> 2])) {
                                        o[k + 80 | 0] = 0, o[k + 91 | 0] = 0, r = i0(k + 32 | 0, 8, 129, k + 80 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 32 >> 2] = i[r >> 2], i[A + 36 >> 2] = e, A = A + 40 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[k + 91 | 0] >= 0) break e;
                                        X(i[k + 80 >> 2]);
                                        break e;
                                    }
                                    i[k + 36 >> 2] = s, i[k + 32 >> 2] = y, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[k + 116 >> 2];
                                    r: {
                                        if (r >>> 0 < k0[k + 120 >> 2]) {
                                            i[r + 4 >> 2] = s, i[r >> 2] = y, i[k + 116 >> 2] = r + 8;
                                            break r;
                                        }
                                        if (T = k, S = p2(k + 112 | 0, k + 32 | 0), i[T + 116 >> 2] = S, r = i[k + 36 >> 2], !r || (n = i[r + 4 >> 2], i[r + 4 >> 2] = n - 1, n)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    r = i[f >> 2];
                                    r: {
                                        if (i[r >> 2] < 3 || (r = i[r + 112 >> 2], !r)) break r;
                                        e = i[e >> 2], n = i[e + 24 >> 2], i[k + 32 >> 2] = n, e = i[e + 28 >> 2], i[k + 80 >> 2] = e, p[r | 0](i[f + 4 >> 2], n, e, k + 32 | 0, k + 80 | 0);
                                    }
                                    G6(A, k + 112 | 0);
                                }
                                A = i[k + 108 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), A = i[k + 124 >> 2], A && (i[k + 128 >> 2] = A, X(A)), A = i[k + 112 >> 2], A) {
                                    if (r = A, t = i[k + 116 >> 2], (r | 0) != (t | 0)) {
                                        for(;;){
                                            r = i[t - 4 >> 2];
                                            e: {
                                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break e;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            if (t = t - 8 | 0, (A | 0) == (t | 0)) break;
                                        }
                                        r = i[k + 112 >> 2];
                                    }
                                    i[k + 116 >> 2] = A, X(r);
                                }
                                m = k + 144 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Xh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0;
                            u = m - 128 | 0, m = u, k = S0(i[e >> 2], 0), n = S0(i[e >> 2], 1), s = S0(i[e >> 2], 2), t0 = A1(i[e >> 2], 6), t0 && (X0 = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(k >>> 0 > 8 | n >>> 0 > 8) & s >>> 0 < 9)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((k | 0) == (n | 0) & (k | 0) == (s | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], S = i[f + 48 >> 2], S && (i[S + 4 >> 2] = i[S + 4 >> 2] + 1, f = i[e >> 2]), H = i[f + 28 >> 2], F = i[f + 24 >> 2], _ = D(136), i[_ >> 2] = 78252, i[_ + 4 >> 2] = 0, i[_ + 8 >> 2] = 0, B0(_ + 20 | 0, 0, 104), G = i[_ + 4 >> 2], C = G + 1 | 0, i[_ + 4 >> 2] = C, i[_ + 56 >> 2] = 0, i[_ + 60 >> 2] = 0, i[_ + 44 >> 2] = 99, i[_ + 48 >> 2] = 99, i[_ + 32 >> 2] = 4142, r = _ - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[_ + 132 >> 2] = 0, r = _, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, f = r + 76 | 0, i[r + 72 >> 2] = f, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, T = r + 12 | 0, i[r + 12 >> 2] = T, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = G, i[r + 16 >> 2] = r, C || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), i[T + 36 >> 2] = 3, i[T + 32 >> 2] = 0, i[T + 28 >> 2] = H, i[T + 24 >> 2] = F, J0(u + 56 | 0, T, 0, F, H, k, t), J0(u + 32 | 0, T, 1, F, H, n, t), r = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = n, i[r + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(r, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[r >> 2] = i[u + 40 >> 2], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(r, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, T, 2, F, H, s, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[r + 4 >> 2], i[k >> 2] = i[r >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[r + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!t0) break r;
                                        if (J0(u + 104 | 0, T, 6, F, H, X0, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], k = r - -64 | 0, s = 0;
                                    r: {
                                        A: {
                                            t = i[r + 64 >> 2];
                                            f: {
                                                if (!t) {
                                                    G = 0;
                                                    break f;
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (e = 0, i[r + 16 >> 2] > 0)) break k;
                                                    g0 = i[r + 44 >> 2], e = i[r + 52 >> 2];
                                                }
                                                for(R0 = e, r = k, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                G = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (G = 0, i[r + 16 >> 2] > 1)) break k;
                                                    P = i[r + 52 >> 2], G = i[r + 44 >> 2];
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            C = 0;
                                            break r;
                                        }
                                        if (C = 0, i[r + 16 >> 2] > 2) break r;
                                        $ = i[r + 52 >> 2], C = i[r + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (r = i[f >> 2], r) {
                                                for(n = f, e = r; s = i[e + 16 >> 2], n = (s | 0) < 0 ? n : e, e = i[(s >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 0)) break f;
                                                    D0 = i[n + 44 >> 2], e = i[n + 52 >> 2];
                                                }
                                                for(H0 = e, n = f, e = r; s = i[e + 16 >> 2] <= 0, n = s ? n : e, e = i[(s << 2) + e >> 2], !!e;);
                                                s = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (s = 0, i[n + 16 >> 2] > 1)) break f;
                                                    c = i[n + 52 >> 2], s = i[n + 44 >> 2];
                                                }
                                                for(n = f, e = r; V = i[e + 16 >> 2] < 2, n = V ? n : e, e = i[(V << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            V = 0;
                                            break r;
                                        }
                                        if (V = 0, i[n + 16 >> 2] > 2) break r;
                                        r0 = i[n + 52 >> 2], V = i[n + 44 >> 2];
                                    }
                                    n = 0, h = 0;
                                    r: {
                                        if (!t0) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = k; s0 = i[t + 16 >> 2] < 6, e = s0 ? e : t, t = i[(s0 << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (k | 0)) break f;
                                                if (k = 0, i[e + 16 >> 2] > 6) break A;
                                                i2 = i[e + 44 >> 2], k = i[e + 52 >> 2];
                                                break A;
                                            }
                                            k = 0;
                                        }
                                        if (e2 = k, h = 0, !r) break r;
                                        for(e = f; k = i[r + 16 >> 2] < 6, e = k ? e : r, r = i[(k << 2) + r >> 2], !!r;);
                                        if (h = 0, (e | 0) == (f | 0) || (h = 0, i[e + 16 >> 2] > 6)) break r;
                                        n = i[e + 52 >> 2], h = i[e + 44 >> 2];
                                    }
                                    if (s0 = h, o[s | 0] = l[G | 0], o[V | 0] = l[C | 0], f = F - 1 | 0, k = f >>> 1 | 0, f >>> 0 >= 2) for(t = k >>> 0 <= 1 ? 1 : k, e = 0; E = e << 1, w = E | 1, r = e >>> 1 | 0, R = r + 1 | 0, W = R + G | 0, v = r + G | 0, o[w + s | 0] = (l[W | 0] + Z(l[v | 0], 3) | 0) + 2 >>> 2, E = E + 2 | 0, o[E + s | 0] = (l[v | 0] + Z(l[W | 0], 3) | 0) + 2 >>> 2, h = w + V | 0, w = C + R | 0, r = r + C | 0, o[h | 0] = (l[w | 0] + Z(l[r | 0], 3) | 0) + 2 >>> 2, o[V + E | 0] = (l[r | 0] + Z(l[w | 0], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (t | 0) != (e | 0););
                                    if (E = F & 1, E || (r = (F >>> 1 | 0) - 1 | 0, o[f + s | 0] = l[r + G | 0], o[f + V | 0] = l[r + C | 0]), r = H - 1 | 0, t = r >>> 1 | 0, r >>> 0 >= 2) for(R = t >>> 0 <= 1 ? 1 : t, e = 0; W = e << 1, v = W | 1, w = e >>> 1 | 0, B = w + 1 | 0, y = Z(B, P) + G | 0, M = Z(w, P) + G | 0, o[Z(v, c) + s | 0] = (l[y | 0] + Z(l[M | 0], 3) | 0) + 2 >>> 2, W = W + 2 | 0, o[Z(W, c) + s | 0] = (l[M | 0] + Z(l[y | 0], 3) | 0) + 2 >>> 2, h = V + Z(v, r0) | 0, v = Z(B, $) + C | 0, w = Z(w, $) + C | 0, o[h | 0] = (l[v | 0] + Z(l[w | 0], 3) | 0) + 2 >>> 2, o[V + Z(W, r0) | 0] = (l[w | 0] + Z(l[v | 0], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (R | 0) != (e | 0););
                                    if (B = H & 1, B || (e = (H >>> 1 | 0) - 1 | 0, o[Z(r, c) + s | 0] = l[Z(e, P) + G | 0], o[V + Z(r, r0) | 0] = l[Z(e, $) + C | 0]), !(r >>> 0 < 2 | E)) for(w = (F + V | 0) - 1 | 0, R = (s + F | 0) - 1 | 0, y = t >>> 0 <= 1 ? 1 : t, e = F >>> 1 | 0, t = (e + C | 0) - 1 | 0, W = (e + G | 0) - 1 | 0, e = 0; M = e << 1, f0 = M | 1, v = e >>> 1 | 0, L = v + 1 | 0, q = W + Z(L, P) | 0, m0 = W + Z(v, P) | 0, o[R + Z(f0, c) | 0] = (l[q | 0] + Z(l[m0 | 0], 3) | 0) + 2 >>> 2, M = M + 2 | 0, o[R + Z(M, c) | 0] = (l[m0 | 0] + Z(l[q | 0], 3) | 0) + 2 >>> 2, h = w + Z(r0, f0) | 0, f0 = t + Z($, L) | 0, v = t + Z(v, $) | 0, o[h | 0] = (l[f0 | 0] + Z(l[v | 0], 3) | 0) + 2 >>> 2, o[w + Z(r0, M) | 0] = (l[v | 0] + Z(l[f0 | 0], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (y | 0) != (e | 0););
                                    r: {
                                        if (B) break r;
                                        if (f >>> 0 >= 2) for(t = k >>> 0 <= 1 ? 1 : k, w = V + Z(r, r0) | 0, R = Z(r, c) + s | 0, e = (H >>> 1 | 0) - 1 | 0, W = Z(e, $), v = Z(e, P), e = 0; B = e << 1, y = B + R | 0, M = e >>> 1 | 0, k = (M + v | 0) + G | 0, o[y + 1 | 0] = (l[k + 1 | 0] + Z(l[k | 0], 3) | 0) + 2 >>> 2, o[y + 2 | 0] = (l[k | 0] + Z(l[k + 1 | 0], 3) | 0) + 2 >>> 2, B = w + B | 0, k = (W + M | 0) + C | 0, o[B + 1 | 0] = (l[k + 1 | 0] + Z(l[k | 0], 3) | 0) + 2 >>> 2, o[B + 2 | 0] = (l[k | 0] + Z(l[k + 1 | 0], 3) | 0) + 2 >>> 2, e = e + 1 | 0, (t | 0) != (e | 0););
                                        if (E) break r;
                                        k = F >>> 1 | 0, e = (H >>> 1 | 0) - 1 | 0, o[((Z(r, c) + s | 0) + F | 0) - 1 | 0] = l[(k + (Z(e, P) + G | 0) | 0) - 1 | 0], o[((V + Z(r, r0) | 0) + F | 0) - 1 | 0] = l[(k + (Z(e, $) + C | 0) | 0) - 1 | 0];
                                    }
                                    r: {
                                        if (r >>> 0 >= 2) {
                                            if (f >>> 0 >= 2) for(k = 1;;){
                                                for(M = V + Z(k, r0) | 0, f0 = Z(k, c) + s | 0, e = k >>> 1 | 0, L = Z(e, $), q = Z(e, P), t = k + 1 | 0, m0 = V + Z(t, r0) | 0, k2 = Z(t, c) + s | 0, e = e + 1 | 0, t2 = Z(e, $), v2 = Z(e, P), e = 1; t = e >>> 1 | 0, w = (t + t2 | 0) + C | 0, E = l[w + 1 | 0], w = l[w | 0], W = (t + L | 0) + C | 0, R = l[W | 0], W = l[W + 1 | 0], B = (t + v2 | 0) + G | 0, v = l[B | 0], h = e + f0 | 0, B = l[B + 1 | 0], V0 = Z(B, 3), y = (t + q | 0) + G | 0, t = l[y | 0], I0 = Z(t, 3) + 8 | 0, y = l[y + 1 | 0], o[h + 1 | 0] = V0 + (v + (I0 + Z(y, 9) | 0) | 0) >>> 4, Z0 = h, F0 = Z(v, 3), h = Z(y, 3) + 8 | 0, o[Z0 | 0] = B + (F0 + (h + Z(t, 9) | 0) | 0) >>> 4, Z0 = e + k2 | 0, o[Z0 + 1 | 0] = (F0 + (t + h | 0) | 0) + Z(B, 9) >>> 4, o[Z0 | 0] = ((y + I0 | 0) + Z(v, 9) | 0) + V0 >>> 4, t = e + M | 0, B = Z(E, 3), v = Z(R, 3) + 8 | 0, o[t + 1 | 0] = B + (w + (v + Z(W, 9) | 0) | 0) >>> 4, h = t, y = Z(w, 3), t = Z(W, 3) + 8 | 0, o[h | 0] = E + (y + (t + Z(R, 9) | 0) | 0) >>> 4, h = e + m0 | 0, o[h + 1 | 0] = (y + (t + R | 0) | 0) + Z(E, 9) >>> 4, o[h | 0] = B + ((v + W | 0) + Z(w, 9) | 0) >>> 4, e = e + 2 | 0, f >>> 0 > e >>> 0;);
                                                if (k = k + 2 | 0, !(r >>> 0 > k >>> 0)) break;
                                            }
                                            if (!H) break r;
                                        }
                                        for(r = F << (X0 >>> 0 > 8), e = 0; v0(Z(e, H0) + D0 | 0, Z(e, R0) + g0 | 0, F), t0 && v0(Z(e, n) + s0 | 0, Z(e, e2) + i2 | 0, r), e = e + 1 | 0, (H | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = _, i[A >> 2] = T, i[_ + 4 >> 2] = i[_ + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[_ + 4 >> 2], i[_ + 4 >> 2] = A - 1, A || (p[i[i[_ >> 2] + 8 >> 2]](_), g(_)), !S || (A = i[S + 4 >> 2], i[S + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[S >> 2] + 8 >> 2]](S), g(S);
                            }
                            m = u + 128 | 0;
                        }
                        function ph(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = J(0), w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = J(0), t0 = 0, s0 = 0, L = 0, q = 0, m0 = J(0), Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = J(0), R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = J(0), H2 = J(0), j2 = J(0), K2 = J(0), i1 = J(0);
                            u = m - 128 | 0, m = u, r = i[e >> 2], t0 = i[r + 36 >> 2], w = S0(r, 0), f = S0(i[e >> 2], 1), r = S0(i[e >> 2], 2), s0 = A1(i[e >> 2], 6), s0 && (v = S0(i[e >> 2], 6));
                            i: {
                                if (!(!((w | 0) == 8 | (f | 0) == 8) & (r | 0) != 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((f | 0) == (w | 0) & (r | 0) == (w | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = i[e >> 2], M = i[n + 44 >> 2], C = i[n + 48 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1, n = i[e >> 2]), V = i[n + 28 >> 2], _ = i[n + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), n = i[s + 4 >> 2], f = n + 1 | 0, i[s + 4 >> 2] = f, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, k = s + 76 | 0, i[s + 72 >> 2] = k, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, G = s + 12 | 0, i[s + 12 >> 2] = G, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, f || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), i[G + 36 >> 2] = 3, i[G + 32 >> 2] = 1, i[G + 28 >> 2] = V, i[G + 24 >> 2] = _, J0(u + 56 | 0, G, 3, _, V, w, t), J0(u + 32 | 0, G, 4, _, V, w, t), n = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (r = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = r, o[u + 75 | 0] >= 0) {
                                            f = u - -64 | 0, r = i[f + 4 >> 2], i[n >> 2] = i[f >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        j(n, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = r, o[u + 51 | 0] >= 0) {
                                        r = i[u + 44 >> 2], i[n >> 2] = i[u + 40 >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(n, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, G, 5, _, V, w, t), f = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (r = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = r, o[u + 99 | 0] >= 0) {
                                            r = i[n + 4 >> 2], i[f >> 2] = i[n >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[n + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[f >> 2] = i[u + 16 >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            A = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!s0) break r;
                                        if (J0(u + 104 | 0, G, 6, _, V, v, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                A = i[u + 116 >> 2], i[r >> 2] = i[u + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], f = r - -64 | 0;
                                    r: {
                                        A: {
                                            if (n = i[r + 64 >> 2], n) {
                                                for(r = f, e = n; t = i[e + 16 >> 2], r = (t | 0) < 0 ? r : e, e = i[(t >>> 29 & 4) + e >> 2], !!e;);
                                                y = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (y = 0, i[r + 16 >> 2] > 0)) break f;
                                                    R0 = i[r + 44 >> 2], y = i[r + 52 >> 2];
                                                }
                                                for(r = f, e = n; t = i[e + 16 >> 2] <= 0, r = t ? r : e, e = i[(t << 2) + e >> 2], !!e;);
                                                F = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (F = 0, i[r + 16 >> 2] > 1)) break f;
                                                    D0 = i[r + 44 >> 2], F = i[r + 52 >> 2];
                                                }
                                                for(r = f, e = n; t = i[e + 16 >> 2] < 2, r = t ? r : e, e = i[(t << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (f | 0)) break A;
                                            }
                                            L = 0;
                                            break r;
                                        }
                                        if (L = 0, i[r + 16 >> 2] > 2) break r;
                                        V0 = i[r + 52 >> 2], L = i[r + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (r = i[k >> 2], r) {
                                                for(t = k, e = r; W = i[e + 16 >> 2] < 3, t = W ? t : e, e = i[(W << 2) + e >> 2], !!e;);
                                                E = 0;
                                                f: {
                                                    if ((k | 0) == (t | 0) || (E = 0, i[t + 16 >> 2] > 3)) break f;
                                                    H0 = i[t + 44 >> 2], E = i[t + 52 >> 2];
                                                }
                                                for(t = k, e = r; W = i[e + 16 >> 2] < 4, t = W ? t : e, e = i[(W << 2) + e >> 2], !!e;);
                                                R = 0;
                                                f: {
                                                    if ((k | 0) == (t | 0) || (R = 0, i[t + 16 >> 2] > 4)) break f;
                                                    i2 = i[t + 44 >> 2], R = i[t + 52 >> 2];
                                                }
                                                for(t = k, e = r; W = i[e + 16 >> 2] < 5, t = W ? t : e, e = i[(W << 2) + e >> 2], !!e;);
                                                if ((k | 0) != (t | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[t + 16 >> 2] > 5) break r;
                                        e2 = i[t + 52 >> 2] >>> 1 | 0, e = i[t + 44 >> 2];
                                    }
                                    W = e, t = 0;
                                    r: {
                                        if (!s0) break r;
                                        A: {
                                            f: {
                                                if (!n) break f;
                                                for(e = f; t = i[n + 16 >> 2] < 6, e = t ? e : n, n = i[(t << 2) + n >> 2], !!n;);
                                                if ((e | 0) == (f | 0)) break f;
                                                if (q = 0, i[e + 16 >> 2] > 6) break A;
                                                k2 = i[e + 44 >> 2], q = i[e + 52 >> 2];
                                                break A;
                                            }
                                            q = 0;
                                        }
                                        if (t = 0, !r) break r;
                                        for(e = k; f = i[r + 16 >> 2] < 6, e = f ? e : r, r = i[(f << 2) + r >> 2], !!r;);
                                        if (t = 0, (e | 0) == (k | 0) || (t = 0, i[e + 16 >> 2] > 6)) break r;
                                        t2 = i[e + 52 >> 2], t = i[e + 44 >> 2];
                                    }
                                    r = t, n = t0 << 3, k = t0 >>> 0 < 4, f = (k ? 16908801 >>> n | 0 : 0) & 3, i[u + 116 >> 2] = -1086926434, i[u + 120 >> 2] = 1071829221, i[u + 108 >> 2] = 1068725436, i[u + 112 >> 2] = -1095748968, o[u + 104 | 0] = 1;
                                    r: {
                                        if (!M) {
                                            I0 = 2, F0 = 1;
                                            break r;
                                        }
                                        F0 = l[M + 10 | 0], I0 = I[M + 8 >> 1], Xi(u + 80 | 0, I0, I[M + 4 >> 1]), i[u + 120 >> 2] = i[u + 96 >> 2], e = i[u + 92 >> 2], i[u + 112 >> 2] = i[u + 88 >> 2], i[u + 116 >> 2] = e, e = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = e;
                                    }
                                    if (V) for(v2 = R >>> 1 | 0, y2 = E >>> 1 | 0, M = V0 >>> 1 | 0, t0 = F >>> 1 | 0, V0 = y >>> 1 | 0, H = f - 1 | 0, B = -1 << w ^ -1, y = ((k ? 16843265 >>> n | 0 : 0) & 3) - 1 | 0, m0 = J(16 << w - 8), F = _ & -2, E = _ & 1, Z0 = 1 << w - 1 & 65535, R = _ << (v >>> 0 > 8), k = 0;;){
                                        r: {
                                            if (!_) break r;
                                            T = (Z(k, e2) << 1) + W | 0, S = (Z(k, v2) << 1) + i2 | 0, P = (Z(k, y2) << 1) + H0 | 0, $ = (Z(k, V0) << 1) + R0 | 0, e = k >>> y | 0, c = (Z(e, M) << 1) + L | 0, r0 = (Z(e, t0) << 1) + D0 | 0, e = 0, U2 = W0[u + 120 >> 2], H2 = W0[u + 116 >> 2], j2 = W0[u + 112 >> 2], K2 = W0[u + 108 >> 2];
                                            A: switch(I0 | 0){
                                                case 0:
                                                    if (F0 & 1) {
                                                        if (t = 0, (_ | 0) != 1) for(; n = e << 1, f = e >>> H << 1, Q[n + P >> 1] = I[f + c >> 1], Q[n + S >> 1] = I[n + $ >> 1], Q[n + T >> 1] = I[f + r0 >> 1], f = e | 1, n = f << 1, f = f >>> H << 1, Q[n + P >> 1] = I[f + c >> 1], Q[n + S >> 1] = I[n + $ >> 1], Q[n + T >> 1] = I[f + r0 >> 1], e = e + 2 | 0, t = t + 2 | 0, (F | 0) != (t | 0););
                                                        if (!E) break r;
                                                        f = e << 1, e = e >>> H << 1, Q[f + P >> 1] = I[e + c >> 1], Q[f + S >> 1] = I[f + $ >> 1], Q[f + T >> 1] = I[e + r0 >> 1];
                                                        break r;
                                                    }
                                                    for(;;){
                                                        v = e << 1, n = v + P | 0, t = e >>> H << 1, h = J(J(J(J(I[t + c >> 1]) - m0) * J(1.142899990081787)) + J(.5));
                                                        f: {
                                                            if (J(r2(h)) < J(2147483648)) {
                                                                f = ~~h;
                                                                break f;
                                                            }
                                                            f = -2147483648;
                                                        }
                                                        Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, n = v + S | 0, h = J(J(J(J(I[v + $ >> 1]) - m0) * J(1.1689000129699707)) + J(.5));
                                                        f: {
                                                            if (J(r2(h)) < J(2147483648)) {
                                                                f = ~~h;
                                                                break f;
                                                            }
                                                            f = -2147483648;
                                                        }
                                                        Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, n = v + T | 0, h = J(J(J(J(I[t + r0 >> 1]) - m0) * J(1.142899990081787)) + J(.5));
                                                        f: {
                                                            if (J(r2(h)) < J(2147483648)) {
                                                                f = ~~h;
                                                                break f;
                                                            }
                                                            f = -2147483648;
                                                        }
                                                        if (Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, e = e + 1 | 0, (_ | 0) == (e | 0)) break;
                                                    }
                                                    break r;
                                                case 8:
                                                    for(; X0 = e << 1, t = I[X0 + $ >> 1], f = e >>> H << 1, n = I[f + r0 >> 1] - Z0 | 0, w = t - n | 0, f = I[f + c >> 1] - Z0 | 0, v = f + w | 0, Q[P + X0 >> 1] = (v | 0) >= 0 ? v >>> 0 >= 255 ? 255 : v : 0, n = n + t | 0, Q[S + X0 >> 1] = (n | 0) >= 0 ? n >>> 0 >= 255 ? 255 : n : 0, f = w - f | 0, Q[T + X0 >> 1] = (f | 0) >= 0 ? f >>> 0 >= 255 ? 255 : f : 0, e = e + 1 | 0, (_ | 0) != (e | 0););
                                                    break r;
                                                default:
                                                    break A;
                                            }
                                            for(;;){
                                                n = e >>> H << 1, h = J(I[n + c >> 1] - Z0 | 0), v = F0 & 1, f0 = v ? h : J(h * J(1.142899990081787)), w = e << 1, h = J(I[w + $ >> 1]), g0 = v ? h : J(J(h - m0) * J(1.1689000129699707)), h = J(J(J(K2 * f0) + g0) + J(.5));
                                                A: {
                                                    if (J(r2(h)) < J(2147483648)) {
                                                        f = ~~h;
                                                        break A;
                                                    }
                                                    f = -2147483648;
                                                }
                                                t = I[n + r0 >> 1], Q[w + P >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, n = w + S | 0, i1 = J(H2 * f0), h = J(t - Z0 | 0), f0 = v ? h : J(h * J(1.142899990081787)), h = J(J(i1 + J(J(j2 * f0) + g0)) + J(.5));
                                                A: {
                                                    if (J(r2(h)) < J(2147483648)) {
                                                        f = ~~h;
                                                        break A;
                                                    }
                                                    f = -2147483648;
                                                }
                                                Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, n = w + T | 0, h = J(J(J(U2 * f0) + g0) + J(.5));
                                                A: {
                                                    if (J(r2(h)) < J(2147483648)) {
                                                        f = ~~h;
                                                        break A;
                                                    }
                                                    f = -2147483648;
                                                }
                                                if (Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (B | 0) ? f : B : 0, e = e + 1 | 0, (_ | 0) == (e | 0)) break;
                                            }
                                        }
                                        if (s0 && v0(Z(k, t2) + r | 0, Z(k, q) + k2 | 0, R), k = k + 1 | 0, (V | 0) == (k | 0)) break;
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = G, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                            }
                            m = u + 128 | 0;
                        }
                        function F7(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            i: {
                                e: {
                                    r: for(;;){
                                        for(C = r - 4 | 0, V = r - 20 | 0, G = r - 24 | 0, y = r - 12 | 0, W = r - 16 | 0, _ = r - 8 | 0;;){
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: switch(k = A, t = r - k >> 3, t | 0){
                                                                        case 3:
                                                                            break o;
                                                                        case 2:
                                                                            break s;
                                                                        case 0:
                                                                        case 1:
                                                                            break A;
                                                                        case 4:
                                                                            break k;
                                                                        case 5:
                                                                            break t;
                                                                        default:
                                                                            break n;
                                                                    }
                                                                    if (i[r - 4 >> 2] <= i[k + 4 >> 2]) break A;
                                                                    n = i[k >> 2], v = i[k + 4 >> 2], A = r - 8 | 0, r = i[A + 4 >> 2], i[k >> 2] = i[A >> 2], i[k + 4 >> 2] = r;
                                                                    break e;
                                                                }
                                                                if (A = r - 8 | 0, f = r - 4 | 0, e = i[f >> 2], r = i[k + 12 >> 2], (r | 0) <= i[k + 4 >> 2]) {
                                                                    if ((r | 0) >= (e | 0) || (f = i[k + 8 >> 2], e = i[k + 12 >> 2], r = i[A + 4 >> 2], i[k + 8 >> 2] = i[A >> 2], i[k + 12 >> 2] = r, i[A >> 2] = f, i[A + 4 >> 2] = e, i[k + 12 >> 2] <= i[k + 4 >> 2])) break A;
                                                                    n = i[k + 8 >> 2], v = i[k + 12 >> 2];
                                                                    break i;
                                                                }
                                                                if (n = i[k >> 2], v = i[k + 4 >> 2], (r | 0) < (e | 0)) {
                                                                    r = i[A + 4 >> 2], i[k >> 2] = i[A >> 2], i[k + 4 >> 2] = r;
                                                                    break e;
                                                                }
                                                                if (e = i[k + 8 >> 2], r = i[k + 12 >> 2], i[k + 8 >> 2] = n, i[k + 12 >> 2] = v, i[k >> 2] = e, i[k + 4 >> 2] = r, (v | 0) >= i[f >> 2]) break A;
                                                                r = i[A + 4 >> 2], i[k + 8 >> 2] = i[A >> 2], i[k + 12 >> 2] = r;
                                                                break e;
                                                            }
                                                            if (De(k, k + 8 | 0, k + 16 | 0, k + 24 | 0), i[r - 4 >> 2] <= i[k + 28 >> 2] || (f = i[k + 24 >> 2], e = i[k + 28 >> 2], r = r - 8 | 0, A = i[r + 4 >> 2], i[k + 24 >> 2] = i[r >> 2], i[k + 28 >> 2] = A, i[r >> 2] = f, i[r + 4 >> 2] = e, i[k + 28 >> 2] <= i[k + 20 >> 2]) || (n = i[k + 24 >> 2], v = i[k + 28 >> 2], A = i[k + 20 >> 2], i[k + 24 >> 2] = i[k + 16 >> 2], i[k + 28 >> 2] = A, i[k + 16 >> 2] = n, i[k + 20 >> 2] = v, (v | 0) <= i[k + 12 >> 2]) || (A = i[k + 12 >> 2], i[k + 16 >> 2] = i[k + 8 >> 2], i[k + 20 >> 2] = A, i[k + 8 >> 2] = n, i[k + 12 >> 2] = v, (v | 0) <= i[k + 4 >> 2])) break A;
                                                            break i;
                                                        }
                                                        if ((t | 0) <= 23) {
                                                            if (A = k + 8 | 0, e = (r | 0) == (k | 0) | (r | 0) == (A | 0), f & 1) {
                                                                if (e) break A;
                                                                for(h = k;;){
                                                                    if (e = A, i[h + 12 >> 2] > i[h + 4 >> 2]) {
                                                                        for(n = i[A >> 2], f = i[A + 4 >> 2], t = A;;){
                                                                            n: {
                                                                                if (A = h, s = i[A + 4 >> 2], i[t >> 2] = i[A >> 2], i[t + 4 >> 2] = s, (A | 0) == (k | 0)) {
                                                                                    A = k;
                                                                                    break n;
                                                                                }
                                                                                if (h = A - 8 | 0, t = A, (f | 0) > i[A - 4 >> 2]) continue;
                                                                            }
                                                                            break;
                                                                        }
                                                                        i[A >> 2] = n, i[A + 4 >> 2] = f;
                                                                    }
                                                                    if (h = e, A = h + 8 | 0, (r | 0) == (A | 0)) break;
                                                                }
                                                                break A;
                                                            }
                                                            if (e) break A;
                                                            for(;;){
                                                                if (i[k + 12 >> 2] > i[k + 4 >> 2]) {
                                                                    for(f = i[A >> 2], e = i[A + 4 >> 2], h = A; n = h, h = k, t = i[k + 4 >> 2], i[n >> 2] = i[k >> 2], i[n + 4 >> 2] = t, k = k - 8 | 0, (e | 0) > i[h - 4 >> 2];);
                                                                    i[h >> 2] = f, i[h + 4 >> 2] = e;
                                                                }
                                                                if (k = A, A = k + 8 | 0, (r | 0) == (A | 0)) break;
                                                            }
                                                            break A;
                                                        }
                                                        if (!e) {
                                                            if ((r | 0) == (k | 0)) break A;
                                                            for(w = t - 2 >>> 1 | 0, A = w;;){
                                                                v = A;
                                                                n: {
                                                                    if ((A | 0) > (w | 0) || (s = (A << 3) + k | 0, e = A << 1 & 1073741822, h = e | 1, A = (h << 3) + k | 0, e = e + 2 | 0, (e | 0) < (t | 0) && (f = e, e = i[A + 4 >> 2] > i[A + 12 >> 2], h = e ? f : h, A = (e << 3) + A | 0), i[A + 4 >> 2] > i[s + 4 >> 2])) break n;
                                                                    for(f = i[s >> 2], e = i[s + 4 >> 2];;){
                                                                        t: {
                                                                            if (n = s, s = A, B = i[A + 4 >> 2], i[n >> 2] = i[A >> 2], i[n + 4 >> 2] = B, (h | 0) > (w | 0)) break t;
                                                                            if (n = h << 1, h = n | 1, A = (h << 3) + k | 0, n = n + 2 | 0, (n | 0) < (t | 0) && (B = n, n = i[A + 4 >> 2] > i[A + 12 >> 2], h = n ? B : h, A = (n << 3) + A | 0), (e | 0) >= i[A + 4 >> 2]) continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    i[s >> 2] = f, i[s + 4 >> 2] = e;
                                                                }
                                                                if (A = v - 1 | 0, !((v | 0) > 0)) break;
                                                            }
                                                            for(;;){
                                                                for(s = t, v = t - 2 >>> 1 | 0, f = i[k >> 2], B = i[k + 4 >> 2], h = 0, t = k;;){
                                                                    n = h << 1, e = n | 1, w = (h << 3) + t | 0, A = w + 8 | 0, n = n + 2 | 0;
                                                                    n: {
                                                                        if ((n | 0) >= (s | 0)) {
                                                                            h = e;
                                                                            break n;
                                                                        }
                                                                        h = e, e = i[w + 12 >> 2] > i[w + 20 >> 2], h = e ? n : h, A = e ? w + 16 | 0 : A;
                                                                    }
                                                                    if (e = i[A + 4 >> 2], i[t >> 2] = i[A >> 2], i[t + 4 >> 2] = e, t = A, !((h | 0) <= (v | 0))) break;
                                                                }
                                                                r = r - 8 | 0;
                                                                n: {
                                                                    if ((A | 0) == (r | 0)) {
                                                                        i[A >> 2] = f, i[A + 4 >> 2] = B;
                                                                        break n;
                                                                    }
                                                                    if (e = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = e, i[r >> 2] = f, i[r + 4 >> 2] = B, e = (A - k | 0) + 8 >> 3, (e | 0) < 2 || (h = e - 2 >>> 1 | 0, t = (h << 3) + k | 0, i[t + 4 >> 2] <= i[A + 4 >> 2])) break n;
                                                                    for(n = i[A >> 2], f = i[A + 4 >> 2];;){
                                                                        t: {
                                                                            if (e = A, A = t, t = i[A + 4 >> 2], i[e >> 2] = i[A >> 2], i[e + 4 >> 2] = t, !h) break t;
                                                                            if (h = h - 1 >>> 1 | 0, t = (h << 3) + k | 0, (f | 0) < i[t + 4 >> 2]) continue;
                                                                        }
                                                                        break;
                                                                    }
                                                                    i[A >> 2] = n, i[A + 4 >> 2] = f;
                                                                }
                                                                if (t = s - 1 | 0, !((s | 0) > 2)) break;
                                                            }
                                                            break A;
                                                        }
                                                        u = (t >>> 1 << 3) + k | 0, s = i[C >> 2];
                                                        n: {
                                                            if (t >>> 0 >= 129) {
                                                                n = i[u + 4 >> 2];
                                                                t: {
                                                                    if ((n | 0) <= i[k + 4 >> 2]) {
                                                                        if ((n | 0) >= (s | 0) || (t = i[u >> 2], n = i[u + 4 >> 2], A = i[_ + 4 >> 2], i[u >> 2] = i[_ >> 2], i[u + 4 >> 2] = A, i[_ >> 2] = t, i[_ + 4 >> 2] = n, i[u + 4 >> 2] <= i[k + 4 >> 2])) break t;
                                                                        t = i[k >> 2], n = i[k + 4 >> 2], A = i[u + 4 >> 2], i[k >> 2] = i[u >> 2], i[k + 4 >> 2] = A, i[u >> 2] = t, i[u + 4 >> 2] = n;
                                                                        break t;
                                                                    }
                                                                    A = i[k >> 2], t = i[k + 4 >> 2];
                                                                    o: {
                                                                        if ((n | 0) < (s | 0)) {
                                                                            n = i[_ + 4 >> 2], i[k >> 2] = i[_ >> 2], i[k + 4 >> 2] = n;
                                                                            break o;
                                                                        }
                                                                        if (n = i[u + 4 >> 2], i[k >> 2] = i[u >> 2], i[k + 4 >> 2] = n, i[u >> 2] = A, i[u + 4 >> 2] = t, (t | 0) >= i[C >> 2]) break t;
                                                                        n = i[_ + 4 >> 2], i[u >> 2] = i[_ >> 2], i[u + 4 >> 2] = n;
                                                                    }
                                                                    i[_ >> 2] = A, i[_ + 4 >> 2] = t;
                                                                }
                                                                t = i[y >> 2], w = u - 8 | 0, n = i[w + 4 >> 2];
                                                                t: {
                                                                    if ((n | 0) <= i[k + 12 >> 2]) {
                                                                        if ((n | 0) >= (t | 0) || (t = i[w >> 2], n = i[w + 4 >> 2], A = i[W + 4 >> 2], i[w >> 2] = i[W >> 2], i[w + 4 >> 2] = A, i[W >> 2] = t, i[W + 4 >> 2] = n, i[w + 4 >> 2] <= i[k + 12 >> 2])) break t;
                                                                        t = i[k + 8 >> 2], n = i[k + 12 >> 2], A = i[w + 4 >> 2], i[k + 8 >> 2] = i[w >> 2], i[k + 12 >> 2] = A, i[w >> 2] = t, i[w + 4 >> 2] = n;
                                                                        break t;
                                                                    }
                                                                    A = i[k + 8 >> 2], s = i[k + 12 >> 2];
                                                                    o: {
                                                                        if ((n | 0) < (t | 0)) {
                                                                            n = i[W + 4 >> 2], i[k + 8 >> 2] = i[W >> 2], i[k + 12 >> 2] = n;
                                                                            break o;
                                                                        }
                                                                        if (n = i[w + 4 >> 2], i[k + 8 >> 2] = i[w >> 2], i[k + 12 >> 2] = n, i[w >> 2] = A, i[w + 4 >> 2] = s, (s | 0) >= i[y >> 2]) break t;
                                                                        n = i[W + 4 >> 2], i[w >> 2] = i[W >> 2], i[w + 4 >> 2] = n;
                                                                    }
                                                                    i[W >> 2] = A, i[W + 4 >> 2] = s;
                                                                }
                                                                t = i[V >> 2], n = i[u + 12 >> 2];
                                                                t: {
                                                                    if ((n | 0) <= i[k + 20 >> 2]) {
                                                                        if ((n | 0) >= (t | 0) || (t = i[u + 8 >> 2], n = i[u + 12 >> 2], A = i[G + 4 >> 2], i[u + 8 >> 2] = i[G >> 2], i[u + 12 >> 2] = A, i[G >> 2] = t, i[G + 4 >> 2] = n, i[u + 12 >> 2] <= i[k + 20 >> 2])) break t;
                                                                        t = i[k + 16 >> 2], n = i[k + 20 >> 2], A = i[u + 12 >> 2], i[k + 16 >> 2] = i[u + 8 >> 2], i[k + 20 >> 2] = A, i[u + 8 >> 2] = t, i[u + 12 >> 2] = n;
                                                                        break t;
                                                                    }
                                                                    A = i[k + 16 >> 2], s = i[k + 20 >> 2];
                                                                    o: {
                                                                        if ((n | 0) < (t | 0)) {
                                                                            n = i[G + 4 >> 2], i[k + 16 >> 2] = i[G >> 2], i[k + 20 >> 2] = n;
                                                                            break o;
                                                                        }
                                                                        if (n = i[u + 12 >> 2], i[k + 16 >> 2] = i[u + 8 >> 2], i[k + 20 >> 2] = n, i[u + 8 >> 2] = A, i[u + 12 >> 2] = s, (s | 0) >= i[V >> 2]) break t;
                                                                        n = i[G + 4 >> 2], i[u + 8 >> 2] = i[G >> 2], i[u + 12 >> 2] = n;
                                                                    }
                                                                    i[G >> 2] = A, i[G + 4 >> 2] = s;
                                                                }
                                                                B = i[u + 12 >> 2], h = i[u + 4 >> 2], s = i[w + 4 >> 2];
                                                                t: {
                                                                    if ((h | 0) <= (s | 0)) {
                                                                        if (n = i[u >> 2], v = i[u + 4 >> 2], (h | 0) >= (B | 0)) break t;
                                                                        if (t = i[u + 12 >> 2], A = i[u + 8 >> 2], i[u >> 2] = A, i[u + 4 >> 2] = t, i[u + 8 >> 2] = n, i[u + 12 >> 2] = v, (t | 0) <= (s | 0)) {
                                                                            n = A, v = t;
                                                                            break t;
                                                                        }
                                                                        n = i[w >> 2], v = i[w + 4 >> 2], i[w >> 2] = A, i[w + 4 >> 2] = t, i[u >> 2] = n, i[u + 4 >> 2] = v;
                                                                        break t;
                                                                    }
                                                                    if (A = i[w >> 2], t = i[w + 4 >> 2], (h | 0) < (B | 0)) {
                                                                        n = i[u + 12 >> 2], i[w >> 2] = i[u + 8 >> 2], i[w + 4 >> 2] = n, i[u + 8 >> 2] = A, i[u + 12 >> 2] = t, n = i[u >> 2], v = i[u + 4 >> 2];
                                                                        break t;
                                                                    }
                                                                    if (n = i[u + 4 >> 2], i[w >> 2] = i[u >> 2], i[w + 4 >> 2] = n, i[u >> 2] = A, i[u + 4 >> 2] = t, (t | 0) >= (B | 0)) {
                                                                        n = A, v = t;
                                                                        break t;
                                                                    }
                                                                    s = i[u + 12 >> 2], v = s, n = i[u + 8 >> 2], i[u >> 2] = n, i[u + 4 >> 2] = s, i[u + 8 >> 2] = A, i[u + 12 >> 2] = t;
                                                                }
                                                                t = i[k >> 2], A = i[k + 4 >> 2], i[k >> 2] = n, i[k + 4 >> 2] = v, i[u >> 2] = t, i[u + 4 >> 2] = A;
                                                                break n;
                                                            }
                                                            if (n = i[k + 4 >> 2], (n | 0) <= i[u + 4 >> 2]) {
                                                                if ((n | 0) >= (s | 0) || (t = i[k >> 2], n = i[k + 4 >> 2], A = i[_ + 4 >> 2], i[k >> 2] = i[_ >> 2], i[k + 4 >> 2] = A, i[_ >> 2] = t, i[_ + 4 >> 2] = n, i[k + 4 >> 2] <= i[u + 4 >> 2])) break n;
                                                                t = i[u >> 2], n = i[u + 4 >> 2], A = i[k + 4 >> 2], i[u >> 2] = i[k >> 2], i[u + 4 >> 2] = A, i[k >> 2] = t, i[k + 4 >> 2] = n;
                                                                break n;
                                                            }
                                                            A = i[u >> 2], t = i[u + 4 >> 2];
                                                            t: {
                                                                if ((n | 0) < (s | 0)) {
                                                                    n = i[_ + 4 >> 2], i[u >> 2] = i[_ >> 2], i[u + 4 >> 2] = n;
                                                                    break t;
                                                                }
                                                                if (n = i[k + 4 >> 2], i[u >> 2] = i[k >> 2], i[u + 4 >> 2] = n, i[k >> 2] = A, i[k + 4 >> 2] = t, (t | 0) >= i[C >> 2]) break n;
                                                                n = i[_ + 4 >> 2], i[k >> 2] = i[_ >> 2], i[k + 4 >> 2] = n;
                                                            }
                                                            i[_ >> 2] = A, i[_ + 4 >> 2] = t;
                                                        }
                                                        if (e = e - 1 | 0, F = f & 1, F) {
                                                            n = i[k >> 2], v = i[k + 4 >> 2];
                                                            break f;
                                                        }
                                                        if (n = i[k >> 2], A = i[k + 4 >> 2], v = A, i[k - 4 >> 2] > i[k + 4 >> 2]) break f;
                                                        t = k, s = k, h = A;
                                                        n: {
                                                            if ((A | 0) > i[C >> 2]) {
                                                                for(;;)if (f = t, A = t + 8 | 0, t = A, !((h | 0) <= i[f + 12 >> 2])) break n;
                                                            }
                                                            for(;;){
                                                                if (A = s + 8 | 0, r >>> 0 <= A >>> 0) break n;
                                                                if (f = s, s = A, !((h | 0) <= i[f + 12 >> 2])) break;
                                                            }
                                                        }
                                                        if (s = r, s >>> 0 > A >>> 0) for(; f = s - 4 | 0, s = s - 8 | 0, (h | 0) > i[f >> 2];);
                                                        if (A >>> 0 < s >>> 0) for(;;){
                                                            for(B = i[A >> 2], t = i[A + 4 >> 2], f = i[s + 4 >> 2], i[A >> 2] = i[s >> 2], i[A + 4 >> 2] = f, i[s >> 2] = B, i[s + 4 >> 2] = t; t = A, f = A + 8 | 0, A = f, (h | 0) <= i[t + 12 >> 2];);
                                                            for(A = s; t = A - 4 | 0, s = A - 8 | 0, A = s, (h | 0) > i[t >> 2];);
                                                            if (A = f, !(s >>> 0 > A >>> 0)) break;
                                                        }
                                                        t = A - 8 | 0, (t | 0) != (k | 0) && (f = i[t + 4 >> 2], i[k >> 2] = i[t >> 2], i[k + 4 >> 2] = f), i[t >> 2] = n, i[t + 4 >> 2] = v, f = 0;
                                                        continue;
                                                    }
                                                    De(k, k + 8 | 0, k + 16 | 0, r - 8 | 0);
                                                    break A;
                                                }
                                                for(t = k; h = t, t = t + 8 | 0, i[h + 12 >> 2] > (v | 0););
                                                s = r, A = s;
                                                f: {
                                                    if ((k | 0) == (h | 0)) for(;;){
                                                        if (t >>> 0 >= s >>> 0) {
                                                            B = s;
                                                            break f;
                                                        }
                                                        if (A = s - 4 | 0, B = s - 8 | 0, s = B, !(i[A >> 2] <= (v | 0))) break f;
                                                    }
                                                    for(; s = A - 4 | 0, B = A - 8 | 0, A = B, i[s >> 2] <= (v | 0););
                                                }
                                                if (A = B, s = t, A >>> 0 > t >>> 0) for(;;){
                                                    for(u = i[s >> 2], w = i[s + 4 >> 2], h = i[A + 4 >> 2], i[s >> 2] = i[A >> 2], i[s + 4 >> 2] = h, i[A >> 2] = u, i[A + 4 >> 2] = w; h = s, s = s + 8 | 0, i[h + 12 >> 2] > (v | 0););
                                                    for(; w = A - 4 | 0, A = A - 8 | 0, i[w >> 2] <= (v | 0););
                                                    if (!(A >>> 0 > s >>> 0)) break;
                                                }
                                                if ((k | 0) != (h | 0) && (A = i[h + 4 >> 2], i[k >> 2] = i[h >> 2], i[k + 4 >> 2] = A), i[h >> 2] = n, i[h + 4 >> 2] = v, t >>> 0 >= B >>> 0) {
                                                    if (n = e5(k, h), A = h + 8 | 0, e5(A, r)) {
                                                        if (r = h, A = k, !n) continue r;
                                                        break A;
                                                    }
                                                    if (n) continue;
                                                }
                                                F7(k, h, e, F), A = h + 8 | 0, f = 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        break;
                                    }
                                    return;
                                }
                                i[A >> 2] = n, i[A + 4 >> 2] = v;
                                return;
                            }
                            A = i[k + 4 >> 2], i[k + 8 >> 2] = i[k >> 2], i[k + 12 >> 2] = A, i[k >> 2] = n, i[k + 4 >> 2] = v;
                        }
                        function Qh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            _ = m - 32 | 0, m = _;
                            i: {
                                e: {
                                    if (u = i[e >> 2], !u) break e;
                                    if (s = E0(u, 82544, 83556), s) {
                                        v = i[e + 4 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), w = _ + 12 | 0, u = m - 112 | 0, m = u, v3(u + 104 | 0, i[s + 20 >> 2], i[i[t >> 2] + 4 >> 2]), e = it(), d7(u + 76 | 0, i[u + 104 >> 2], n, t, e);
                                        r: {
                                            if (i[u + 84 >> 2]) {
                                                if (I8(e), e = i[u + 88 >> 2], i[w >> 2] = i[u + 84 >> 2], i[w + 4 >> 2] = e, e = w + 8 | 0, o[u + 103 | 0] >= 0) {
                                                    f = i[u + 96 >> 2], i[e >> 2] = i[u + 92 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[u + 100 >> 2];
                                                    break r;
                                                }
                                                j(e, i[u + 92 >> 2], i[u + 96 >> 2]);
                                                break r;
                                            }
                                            i[u + 68 >> 2] = i[u + 76 >> 2], h = i[u + 80 >> 2], i[u + 72 >> 2] = h, h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), G7(u + 16 | 0, i[u + 104 >> 2], u + 68 | 0, t, e, 1), I8(e);
                                            A: {
                                                f: {
                                                    k: {
                                                        if (i[u + 48 >> 2]) {
                                                            if (e = i[u + 52 >> 2], i[w >> 2] = i[u + 48 >> 2], i[w + 4 >> 2] = e, e = w + 8 | 0, o[u + 67 | 0] < 0) break k;
                                                            f = i[u + 60 >> 2], i[e >> 2] = i[u + 56 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[u + 64 >> 2];
                                                            break A;
                                                        }
                                                        e = i[s + 20 >> 2], i[u + 4 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[u + 8 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), x8(i[u + 4 >> 2], i[s + 36 >> 2], u + 28 | 0, 0), e = i[u + 8 >> 2];
                                                        n: {
                                                            if (!e || (h = i[e + 4 >> 2], i[e + 4 >> 2] = h - 1, h)) break n;
                                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                        }
                                                        if (e = i[n >> 2], n = i[e + 24 >> 2], !((n | 0) == i[s + 384 >> 2] & i[e + 28 >> 2] == i[s + 388 >> 2])) {
                                                            if (e = D(56), i[u + 4 >> 2] = e, i[u + 8 >> 2] = 55, i[u + 12 >> 2] = -2147483592, f = l[19592] | l[19593] << 8 | (l[19594] << 16 | l[19595] << 24), k = l[19588] | l[19589] << 8 | (l[19590] << 16 | l[19591] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 55 | 0] = 0, f = l[19639] | l[19640] << 8 | (l[19641] << 16 | l[19642] << 24), k = l[19635] | l[19636] << 8 | (l[19637] << 16 | l[19638] << 24), o[e + 47 | 0] = k, o[e + 48 | 0] = k >>> 8, o[e + 49 | 0] = k >>> 16, o[e + 50 | 0] = k >>> 24, o[e + 51 | 0] = f, o[e + 52 | 0] = f >>> 8, o[e + 53 | 0] = f >>> 16, o[e + 54 | 0] = f >>> 24, f = l[19632] | l[19633] << 8 | (l[19634] << 16 | l[19635] << 24), k = l[19628] | l[19629] << 8 | (l[19630] << 16 | l[19631] << 24), o[e + 40 | 0] = k, o[e + 41 | 0] = k >>> 8, o[e + 42 | 0] = k >>> 16, o[e + 43 | 0] = k >>> 24, o[e + 44 | 0] = f, o[e + 45 | 0] = f >>> 8, o[e + 46 | 0] = f >>> 16, o[e + 47 | 0] = f >>> 24, f = l[19624] | l[19625] << 8 | (l[19626] << 16 | l[19627] << 24), k = l[19620] | l[19621] << 8 | (l[19622] << 16 | l[19623] << 24), o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, o[e + 34 | 0] = k >>> 16, o[e + 35 | 0] = k >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[19616] | l[19617] << 8 | (l[19618] << 16 | l[19619] << 24), k = l[19612] | l[19613] << 8 | (l[19614] << 16 | l[19615] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[19608] | l[19609] << 8 | (l[19610] << 16 | l[19611] << 24), k = l[19604] | l[19605] << 8 | (l[19606] << 16 | l[19607] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[19600] | l[19601] << 8 | (l[19602] << 16 | l[19603] << 24), k = l[19596] | l[19597] << 8 | (l[19598] << 16 | l[19599] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(w, 5, 0, u + 4 | 0), o[u + 15 | 0] >= 0) break A;
                                                            X(i[u + 4 >> 2]);
                                                            break A;
                                                        }
                                                        e = i[s + 460 >> 2], h = i[s + 456 >> 2], f = (i[s + 436 >> 2] + (Z(((n + i[s + 376 >> 2] | 0) - 1 >>> 0) / (n >>> 0) | 0, k) << 4) | 0) + (f << 4) | 0, k = i[u + 32 >> 2] - i[u + 28 >> 2] | 0, i[f + 8 >> 2] = k, i[f >> 2] = h, i[f + 4 >> 2] = e, f = k + h | 0, e = k >>> 0 > f >>> 0 ? e + 1 | 0 : e, i[s + 456 >> 2] = f, i[s + 460 >> 2] = e, k = i[s + 24 >> 2], e = i[s + 28 >> 2];
                                                        n: {
                                                            t: {
                                                                if ((k | 0) != (e | 0)) for(;;){
                                                                    o: {
                                                                        if (f = i[k >> 2], !f || (n = E0(f, 73632, 83544), !n)) break o;
                                                                        if (f = i[k + 4 >> 2], !f) break t;
                                                                        i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                        break n;
                                                                    }
                                                                    if (k = k + 8 | 0, (e | 0) == (k | 0)) break;
                                                                }
                                                                n = 0;
                                                            }
                                                            f = 0;
                                                        }
                                                        if (e = i[u + 16 >> 2], G = i[u + 20 >> 2], (e | 0) == (G | 0)) break f;
                                                        for(W = n + 36 | 0;;){
                                                            B = i[e >> 2], C = i[B + 16 >> 2];
                                                            n: {
                                                                if ((C | 0) == 1769173093) break n;
                                                                if (k = i[n + 36 >> 2], h = i[n + 40 >> 2], (k | 0) != (h | 0)) for(;;){
                                                                    if (i[i[k >> 2] + 16 >> 2] == (C | 0)) break n;
                                                                    if (k = k + 8 | 0, (h | 0) == (k | 0)) break;
                                                                }
                                                                t: {
                                                                    if (h >>> 0 < k0[n + 44 >> 2]) {
                                                                        i[h >> 2] = B, k = i[e + 4 >> 2], i[h + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = h + 8 | 0;
                                                                        break t;
                                                                    }
                                                                    k = P2(W, e);
                                                                }
                                                                if (i[n + 40 >> 2] = k, i[i[e >> 2] + 16 >> 2] != 1885960297 || (k = i[s + 20 >> 2], i[u + 4 >> 2] = i[k + 48 >> 2], k = i[k + 52 >> 2], i[u + 8 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = i[e >> 2], rr(i[u + 4 >> 2], i[s + 36 >> 2], e, p[i[i[k >> 2] + 32 >> 2]](k) | 0), k = i[u + 8 >> 2], !k) || (h = i[k + 4 >> 2], i[k + 4 >> 2] = h - 1, h)) break n;
                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                            }
                                                            if (e = e + 8 | 0, (G | 0) == (e | 0)) break;
                                                        }
                                                        break f;
                                                    }
                                                    j(e, i[u + 56 >> 2], i[u + 60 >> 2]);
                                                    break A;
                                                }
                                                e = i[s + 20 >> 2], i[u + 4 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[u + 8 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), S3(i[u + 4 >> 2], i[i[t >> 2] + 4 >> 2], 1), e = i[u + 8 >> 2];
                                                f: {
                                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break f;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                e = i[21669], i[w >> 2] = i[21668], i[w + 4 >> 2] = e, e = w + 8 | 0;
                                                f: {
                                                    if (o[86691] >= 0) {
                                                        k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                                        break f;
                                                    }
                                                    j(e, i[21670], i[21671]);
                                                }
                                                if (!f || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            if (o[u + 67 | 0] < 0 && X(i[u + 56 >> 2]), e = i[u + 28 >> 2], e && (i[u + 32 >> 2] = e, X(e)), e = i[u + 16 >> 2], e) {
                                                if (k = i[u + 20 >> 2], f = e, (k | 0) != (e | 0)) {
                                                    for(;;){
                                                        f = i[k - 4 >> 2];
                                                        A: {
                                                            if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break A;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        if (k = k - 8 | 0, (e | 0) == (k | 0)) break;
                                                    }
                                                    f = i[u + 16 >> 2];
                                                }
                                                i[u + 20 >> 2] = e, X(f);
                                            }
                                            if (e = i[u + 72 >> 2], !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        o[u + 103 | 0] < 0 && X(i[u + 92 >> 2]), e = i[u + 80 >> 2];
                                        r: {
                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        e = i[u + 108 >> 2];
                                        r: {
                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (m = u + 112 | 0, j0(A, w, i[r >> 2]), o[_ + 31 | 0] < 0 && X(i[_ + 20 >> 2]), !v || (A = i[v + 4 >> 2], i[v + 4 >> 2] = A - 1, A)) break i;
                                        p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                        break i;
                                    }
                                    if (u = E0(u, 82544, 83232), !u) break e;
                                    w = i[e + 4 >> 2], w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1), h = _ + 12 | 0, s = m - 128 | 0, m = s, ri(s + 100 | 0, i[u + 20 >> 2], n, t, u + 396 | 0, 1);
                                    r: {
                                        if (i[s + 108 >> 2] != i[21668]) {
                                            if (e = i[s + 112 >> 2], i[h >> 2] = i[s + 108 >> 2], i[h + 4 >> 2] = e, e = h + 8 | 0, o[s + 127 | 0] >= 0) {
                                                f = i[s + 120 >> 2], i[e >> 2] = i[s + 116 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[s + 124 >> 2];
                                                break r;
                                            }
                                            j(e, i[s + 116 >> 2], i[s + 120 >> 2]);
                                            break r;
                                        }
                                        e = i[s + 100 >> 2], v = i[s + 104 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), n = i[u + 20 >> 2], i[s + 92 >> 2] = i[n + 48 >> 2], n = i[n + 52 >> 2], i[s + 96 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), q1(s + 20 | 0, i[s + 92 >> 2], i[e + 36 >> 2]), n = i[s + 20 >> 2], o[n + 164 | 0] = 1, i[n + 100 >> 2] = i[n + 100 >> 2] & -2 | 1, n = i[s + 24 >> 2];
                                        A: {
                                            if (!n || (t = i[n + 4 >> 2], i[n + 4 >> 2] = t - 1, t)) break A;
                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                        }
                                        if (p[i[i[u >> 2] + 72 >> 2]](s + 20 | 0, u), t = i[u + 36 >> 2], G = Z(i[s + 24 >> 2], k) + f | 0, W = i[e + 36 >> 2], B = i[i[s + 92 >> 2] + 84 >> 2], n = i[B + 104 >> 2], B = i[B + 108 >> 2], (n | 0) != (B | 0)) for(;;){
                                            A: {
                                                if (!((t | 0) != i[n + 40 >> 2] | i[n + 16 >> 2] != 1684630887)) {
                                                    i[i[n + 44 >> 2] + (G << 2) >> 2] = W;
                                                    break A;
                                                }
                                                if (n = n + 56 | 0, (B | 0) != (n | 0)) continue;
                                            }
                                            break;
                                        }
                                        i[(i[u + 384 >> 2] + (Z(I[u + 374 >> 1], k) << 2) | 0) + (f << 2) >> 2] = i[e + 36 >> 2], f = 0, t = 0, n = i[e + 24 >> 2], e = i[e + 28 >> 2];
                                        A: {
                                            f: {
                                                if ((n | 0) == (e | 0)) break f;
                                                for(;;){
                                                    k: {
                                                        if (k = i[n >> 2], !k || (t = E0(k, 73632, 75648), !t)) break k;
                                                        if (e = i[n + 4 >> 2], !e) break f;
                                                        i[e + 4 >> 2] = i[e + 4 >> 2] + 1, i[s + 16 >> 2] = e, i[s + 12 >> 2] = t, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, f = e, e = 0;
                                                        break A;
                                                    }
                                                    if (n = n + 8 | 0, (e | 0) == (n | 0)) break;
                                                }
                                                t = 0;
                                            }
                                            i[s + 16 >> 2] = 0, i[s + 12 >> 2] = t, e = 1;
                                        }
                                        k = i[s + 16 >> 2], i[s >> 2] = i[s + 12 >> 2], i[s + 4 >> 2] = k, Zi(u, s, 1), k = i[21669], i[h >> 2] = i[21668], i[h + 4 >> 2] = k, k = h + 8 | 0;
                                        A: {
                                            if (o[86691] >= 0) {
                                                n = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(k, i[21670], i[21671]);
                                        }
                                        A: {
                                            if (e || (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                        }
                                        e = i[s + 96 >> 2];
                                        A: {
                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break A;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (!v || (e = i[v + 4 >> 2], i[v + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                    }
                                    o[s + 127 | 0] < 0 && X(i[s + 116 >> 2]), e = i[s + 104 >> 2];
                                    r: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (m = s + 128 | 0, j0(A, h, i[r >> 2]), o[_ + 31 | 0] < 0 && X(i[_ + 20 >> 2]), !w || (A = i[w + 4 >> 2], i[w + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                    break i;
                                }
                                i[A >> 2] = 5, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 12190;
                            }
                            m = _ + 32 | 0;
                        }
                        function Ch(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            t = m - 48 | 0, m = t, u = i[r + 20 >> 2], i[t + 24 >> 2] = i[u + 48 >> 2], u = i[u + 52 >> 2], i[t + 28 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), u = i[t + 24 >> 2], h = i[u + 84 >> 2], u = i[u + 88 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), s = i[t + 28 >> 2];
                            i: {
                                if (!s || (w = i[s + 4 >> 2], i[s + 4 >> 2] = w - 1, w)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            i: {
                                if (!h) {
                                    r = D(56), i[t + 12 >> 2] = r, i[t + 16 >> 2] = 48, i[t + 20 >> 2] = -2147483592, e = l[11536] | l[11537] << 8 | (l[11538] << 16 | l[11539] << 24), f = l[11532] | l[11533] << 8 | (l[11534] << 16 | l[11535] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[11528] | l[11529] << 8 | (l[11530] << 16 | l[11531] << 24), f = l[11524] | l[11525] << 8 | (l[11526] << 16 | l[11527] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[11520] | l[11521] << 8 | (l[11522] << 16 | l[11523] << 24), f = l[11516] | l[11517] << 8 | (l[11518] << 16 | l[11519] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[11512] | l[11513] << 8 | (l[11514] << 16 | l[11515] << 24), f = l[11508] | l[11509] << 8 | (l[11510] << 16 | l[11511] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[11504] | l[11505] << 8 | (l[11506] << 16 | l[11507] << 24), f = l[11500] | l[11501] << 8 | (l[11502] << 16 | l[11503] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[11496] | l[11497] << 8 | (l[11498] << 16 | l[11499] << 24), f = l[11492] | l[11493] << 8 | (l[11494] << 16 | l[11495] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 48 | 0] = 0, r = i0(t + 24 | 0, 2, 113, t + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                    e: {
                                        if (o[r + 19 | 0] >= 0) {
                                            e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break e;
                                        X(i[r + 8 >> 2]);
                                    }
                                    if (o[t + 23 | 0] >= 0) break i;
                                    X(i[t + 12 >> 2]);
                                    break i;
                                }
                                Q8(t + 12 | 0, h, i[r + 36 >> 2], 1684630887), s = i[t + 12 >> 2];
                                e: {
                                    if ((i[t + 16 >> 2] - s | 0) != 4) {
                                        r = D(48), i[t >> 2] = r, i[t + 4 >> 2] = 47, i[t + 8 >> 2] = -2147483600, e = l[12054] | l[12055] << 8 | (l[12056] << 16 | l[12057] << 24), f = l[12050] | l[12051] << 8 | (l[12052] << 16 | l[12053] << 24), o[r + 39 | 0] = f, o[r + 40 | 0] = f >>> 8, o[r + 41 | 0] = f >>> 16, o[r + 42 | 0] = f >>> 24, o[r + 43 | 0] = e, o[r + 44 | 0] = e >>> 8, o[r + 45 | 0] = e >>> 16, o[r + 46 | 0] = e >>> 24, e = l[12047] | l[12048] << 8 | (l[12049] << 16 | l[12050] << 24), f = l[12043] | l[12044] << 8 | (l[12045] << 16 | l[12046] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[12039] | l[12040] << 8 | (l[12041] << 16 | l[12042] << 24), f = l[12035] | l[12036] << 8 | (l[12037] << 16 | l[12038] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[12031] | l[12032] << 8 | (l[12033] << 16 | l[12034] << 24), f = l[12027] | l[12028] << 8 | (l[12029] << 16 | l[12030] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[12023] | l[12024] << 8 | (l[12025] << 16 | l[12026] << 24), f = l[12019] | l[12020] << 8 | (l[12021] << 16 | l[12022] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[12015] | l[12016] << 8 | (l[12017] << 16 | l[12018] << 24), f = l[12011] | l[12012] << 8 | (l[12013] << 16 | l[12014] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 47 | 0] = 0, r = i0(t + 24 | 0, 2, 0, t), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[t + 11 | 0] >= 0) break e;
                                        X(i[t >> 2]);
                                        break e;
                                    }
                                    if (s = i[s >> 2], (s | 0) == i[r + 36 >> 2]) {
                                        r = D(40), i[t >> 2] = r, i[t + 4 >> 2] = 32, i[t + 8 >> 2] = -2147483608, e = l[9334] | l[9335] << 8 | (l[9336] << 16 | l[9337] << 24), f = l[9330] | l[9331] << 8 | (l[9332] << 16 | l[9333] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[9326] | l[9327] << 8 | (l[9328] << 16 | l[9329] << 24), f = l[9322] | l[9323] << 8 | (l[9324] << 16 | l[9325] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[9318] | l[9319] << 8 | (l[9320] << 16 | l[9321] << 24), f = l[9314] | l[9315] << 8 | (l[9316] << 16 | l[9317] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[9310] | l[9311] << 8 | (l[9312] << 16 | l[9313] << 24), f = l[9306] | l[9307] << 8 | (l[9308] << 16 | l[9309] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 32 | 0] = 0, r = i0(t + 24 | 0, 2, 0, t), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[t + 11 | 0] >= 0) break e;
                                        X(i[t >> 2]);
                                        break e;
                                    }
                                    h = t + 24 | 0, v4(h, i[r + 20 >> 2], s, 1), s = i[t + 28 >> 2], r = i[t + 24 >> 2];
                                    r: {
                                        if (!r) {
                                            r = D(48), i[t >> 2] = r, i[t + 4 >> 2] = 41, i[t + 8 >> 2] = -2147483600, o[r + 40 | 0] = l[12009], e = l[12005] | l[12006] << 8 | (l[12007] << 16 | l[12008] << 24), f = l[12001] | l[12002] << 8 | (l[12003] << 16 | l[12004] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[11997] | l[11998] << 8 | (l[11999] << 16 | l[12e3] << 24), f = l[11993] | l[11994] << 8 | (l[11995] << 16 | l[11996] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[11989] | l[11990] << 8 | (l[11991] << 16 | l[11992] << 24), f = l[11985] | l[11986] << 8 | (l[11987] << 16 | l[11988] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[11981] | l[11982] << 8 | (l[11983] << 16 | l[11984] << 24), f = l[11977] | l[11978] << 8 | (l[11979] << 16 | l[11980] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[11973] | l[11974] << 8 | (l[11975] << 16 | l[11976] << 24), f = l[11969] | l[11970] << 8 | (l[11971] << 16 | l[11972] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 41 | 0] = 0, r = i0(h, 2, 0, t), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                            A: {
                                                if (o[r + 19 | 0] >= 0) {
                                                    e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                    break A;
                                                }
                                                if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break A;
                                                X(i[r + 8 >> 2]);
                                            }
                                            if (o[t + 11 | 0] >= 0) break r;
                                            X(i[t >> 2]);
                                            break r;
                                        }
                                        if (p[i[i[r >> 2] + 20 >> 2]](t + 24 | 0, r), i[t + 24 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 28 >> 2], i[A + 8 >> 2] = i[t + 24 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[t + 43 | 0] >= 0) {
                                                r = i[t + 36 >> 2], i[A >> 2] = i[t + 32 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[t + 40 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[t + 32 >> 2], i[t + 36 >> 2]), o[t + 43 | 0] >= 0) break r;
                                            X(i[t + 32 >> 2]);
                                            break r;
                                        }
                                        o[t + 43 | 0] < 0 && X(i[t + 32 >> 2]), ii(A, r, e, f, k, n);
                                    }
                                    if (!s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                }
                                if (A = i[t + 12 >> 2], !A) break i;
                                i[t + 16 >> 2] = A, X(A);
                            }
                            i: {
                                if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            m = t + 48 | 0;
                        }
                        function Vh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = J(0), v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = J(0), c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = J(0), q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = J(0);
                            u = m - 128 | 0, m = u, r = i[e >> 2], c = i[r + 36 >> 2], G = S0(r, 0), f = S0(i[e >> 2], 1), r = S0(i[e >> 2], 2), r0 = A1(i[e >> 2], 6), r0 && (W = S0(i[e >> 2], 6));
                            i: {
                                if (!(!((G | 0) != 8 | (f | 0) != 8) & (r | 0) == 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = i[e >> 2], F = i[n + 44 >> 2], C = i[n + 48 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1, n = i[e >> 2]), V = i[n + 28 >> 2], v = i[n + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), n = i[s + 4 >> 2], k = n + 1 | 0, i[s + 4 >> 2] = k, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, f = s + 76 | 0, i[s + 72 >> 2] = f, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, B = s + 12 | 0, i[s + 12 >> 2] = B, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, k || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), i[B + 36 >> 2] = 3, i[B + 32 >> 2] = 1, i[B + 28 >> 2] = V, i[B + 24 >> 2] = v, J0(u + 56 | 0, B, 3, v, V, G, t), J0(u + 32 | 0, B, 4, v, V, G, t), n = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (r = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = r, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, r = i[k + 4 >> 2], i[n >> 2] = i[k >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(n, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = r, o[u + 51 | 0] >= 0) {
                                        r = i[u + 44 >> 2], i[n >> 2] = i[u + 40 >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(n, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, B, 5, v, V, G, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (r = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = r, o[u + 99 | 0] >= 0) {
                                            r = i[n + 4 >> 2], i[k >> 2] = i[n >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[n + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            A = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!r0) break r;
                                        if (J0(u + 104 | 0, B, 6, v, V, W, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                A = i[u + 116 >> 2], i[r >> 2] = i[u + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    e = i[e >> 2], r = e - -64 | 0;
                                    r: {
                                        A: {
                                            if (k = i[e + 64 >> 2], k) {
                                                for(t = r, e = k; n = i[e + 16 >> 2], t = (n | 0) < 0 ? t : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (e = 0, i[t + 16 >> 2] > 0)) break f;
                                                    q = i[t + 44 >> 2], e = i[t + 52 >> 2];
                                                }
                                                for(m0 = e, t = r, e = k; n = i[e + 16 >> 2] <= 0, t = n ? t : e, e = i[(n << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (e = 0, i[t + 16 >> 2] > 1)) break f;
                                                    Z0 = i[t + 52 >> 2], e = i[t + 44 >> 2];
                                                }
                                                for(X0 = e, t = r, e = k; n = i[e + 16 >> 2] < 2, t = n ? t : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (t | 0)) break A;
                                            }
                                            G = 0;
                                            break r;
                                        }
                                        if (G = 0, i[t + 16 >> 2] > 2) break r;
                                        V0 = i[t + 52 >> 2], G = i[t + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (t = i[f >> 2], t) {
                                                for(n = f, e = t; _ = i[e + 16 >> 2] < 3, n = _ ? n : e, e = i[(_ << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 3)) break f;
                                                    I0 = i[n + 44 >> 2], e = i[n + 52 >> 2];
                                                }
                                                for(F0 = e, n = f, e = t; _ = i[e + 16 >> 2] < 4, n = _ ? n : e, e = i[(_ << 2) + e >> 2], !!e;);
                                                _ = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (_ = 0, i[n + 16 >> 2] > 4)) break f;
                                                    g0 = i[n + 52 >> 2], _ = i[n + 44 >> 2];
                                                }
                                                for(n = f, e = t; h = i[e + 16 >> 2] < 5, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[n + 16 >> 2] > 5) break r;
                                        R0 = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                    }
                                    n = e, h = 0;
                                    r: {
                                        if (!r0) break r;
                                        A: {
                                            f: {
                                                if (!k) break f;
                                                for(e = r; y = i[k + 16 >> 2] < 6, e = y ? e : k, k = i[(y << 2) + k >> 2], !!k;);
                                                if ((r | 0) == (e | 0)) break f;
                                                if (y = 0, i[e + 16 >> 2] > 6) break A;
                                                D0 = i[e + 44 >> 2], y = i[e + 52 >> 2];
                                                break A;
                                            }
                                            y = 0;
                                        }
                                        if (h = 0, !t) break r;
                                        for(e = f; r = i[t + 16 >> 2] < 6, e = r ? e : t, t = i[(r << 2) + t >> 2], !!t;);
                                        if (h = 0, (e | 0) == (f | 0) || (h = 0, i[e + 16 >> 2] > 6)) break r;
                                        H0 = i[e + 52 >> 2], h = i[e + 44 >> 2];
                                    }
                                    f = h, t = c << 3, k = c >>> 0 < 4, e = (k ? 16908801 >>> t | 0 : 0) & 3, i[u + 116 >> 2] = -1086926434, i[u + 120 >> 2] = 1071829221, i[u + 108 >> 2] = 1068725436, i[u + 112 >> 2] = -1095748968, o[u + 104 | 0] = 1;
                                    r: {
                                        if (!F) {
                                            f0 = 2, t0 = 1;
                                            break r;
                                        }
                                        t0 = l[F + 10 | 0], f0 = I[F + 8 >> 1], Xi(u + 80 | 0, f0, I[F + 4 >> 1]), i[u + 120 >> 2] = i[u + 96 >> 2], r = i[u + 92 >> 2], i[u + 112 >> 2] = i[u + 88 >> 2], i[u + 116 >> 2] = r, r = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = r;
                                    }
                                    if (V) for(E = e - 1 | 0, i2 = ((k ? 16843265 >>> t | 0 : 0) & 3) - 1 | 0, e2 = v & -2, F = v & 1, c = v << (W >>> 0 > 8), r = 0;;){
                                        r: {
                                            if (!v) break r;
                                            R = Z(r, R0) + n | 0, M = Z(r, g0) + _ | 0, H = Z(r, F0) + I0 | 0, T = Z(r, m0) + q | 0, e = r >>> i2 | 0, S = Z(e, V0) + G | 0, P = Z(e, Z0) + X0 | 0, e = 0;
                                            A: switch(f0 | 0){
                                                case 0:
                                                    if (t0 & 1) {
                                                        if (t = 0, (v | 0) != 1) for(; k = e >>> E | 0, o[e + H | 0] = l[k + S | 0], o[e + M | 0] = l[e + T | 0], o[e + R | 0] = l[k + P | 0], h = e | 1, k = h >>> E | 0, o[h + H | 0] = l[k + S | 0], o[h + M | 0] = l[h + T | 0], o[h + R | 0] = l[k + P | 0], e = e + 2 | 0, t = t + 2 | 0, (e2 | 0) != (t | 0););
                                                        if (!F) break r;
                                                        k = e >>> E | 0, o[e + H | 0] = l[k + S | 0], o[e + M | 0] = l[e + T | 0], o[e + R | 0] = l[k + P | 0];
                                                        break r;
                                                    }
                                                    for(;;){
                                                        t = e + H | 0, h = e >>> E | 0, w = J(J(J(J(l[h + S | 0]) + J(-16)) * J(1.142899990081787)) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                k = ~~w;
                                                                break f;
                                                            }
                                                            k = -2147483648;
                                                        }
                                                        o[t | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, t = e + M | 0, w = J(J(J(J(l[e + T | 0]) + J(-16)) * J(1.1689000129699707)) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                k = ~~w;
                                                                break f;
                                                            }
                                                            k = -2147483648;
                                                        }
                                                        o[t | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, t = e + R | 0, w = J(J(J(J(l[h + P | 0]) + J(-16)) * J(1.142899990081787)) + J(.5));
                                                        f: {
                                                            if (J(r2(w)) < J(2147483648)) {
                                                                k = ~~w;
                                                                break f;
                                                            }
                                                            k = -2147483648;
                                                        }
                                                        if (o[t | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, e = e + 1 | 0, (v | 0) == (e | 0)) break;
                                                    }
                                                    break r;
                                                case 8:
                                                    for(; W = l[e + T | 0], k = e >>> E | 0, h = l[k + P | 0] - 128 | 0, t = W - h | 0, k = l[k + S | 0] - 128 | 0, s0 = t + k | 0, o[e + H | 0] = (s0 | 0) >= 0 ? s0 >>> 0 >= 255 ? 255 : s0 : 0, h = h + W | 0, o[e + M | 0] = (h | 0) >= 0 ? h >>> 0 >= 255 ? 255 : h : 0, k = t - k | 0, o[e + R | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, e = e + 1 | 0, (v | 0) != (e | 0););
                                                    break r;
                                                default:
                                                    break A;
                                            }
                                            for(;;){
                                                t = e >>> E | 0, w = J(l[t + S | 0] - 128 | 0), W = t0 & 1, $ = W ? w : J(w * J(1.142899990081787)), w = J(l[e + T | 0]), L = W ? w : J(J(w + J(-16)) * J(1.1689000129699707)), w = J(J(J(W0[u + 108 >> 2] * $) + L) + J(.5));
                                                A: {
                                                    if (J(r2(w)) < J(2147483648)) {
                                                        k = ~~w;
                                                        break A;
                                                    }
                                                    k = -2147483648;
                                                }
                                                h = l[t + P | 0], o[e + H | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, t = e + M | 0, k2 = J(W0[u + 116 >> 2] * $), w = J(h - 128 | 0), $ = W ? w : J(w * J(1.142899990081787)), w = J(J(k2 + J(J(W0[u + 112 >> 2] * $) + L)) + J(.5));
                                                A: {
                                                    if (J(r2(w)) < J(2147483648)) {
                                                        k = ~~w;
                                                        break A;
                                                    }
                                                    k = -2147483648;
                                                }
                                                o[t | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, t = e + R | 0, w = J(J(J(W0[u + 120 >> 2] * $) + L) + J(.5));
                                                A: {
                                                    if (J(r2(w)) < J(2147483648)) {
                                                        k = ~~w;
                                                        break A;
                                                    }
                                                    k = -2147483648;
                                                }
                                                if (o[t | 0] = (k | 0) >= 0 ? k >>> 0 >= 255 ? 255 : k : 0, e = e + 1 | 0, (v | 0) == (e | 0)) break;
                                            }
                                        }
                                        if (r0 && v0(Z(r, H0) + f | 0, Z(r, y) + D0 | 0, c), r = r + 1 | 0, (V | 0) == (r | 0)) break;
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = B, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                            }
                            m = u + 128 | 0;
                        }
                        function Y7(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0;
                            w = m - 336 | 0, m = w, _ = u, B = s & 65535, G = f, W = k & 65535, y = (k ^ s) & -2147483648, H = s >>> 16 & 32767, E = k >>> 16 & 32767;
                            i: {
                                e: {
                                    if (H - 32767 >>> 0 > 4294934529 & E - 32767 >>> 0 >= 4294934530) break e;
                                    if (h = k & 2147483647, !(!f & (h | 0) == 2147418112 ? !(r | e) : h >>> 0 < 2147418112)) {
                                        V = f, y = k | 32768;
                                        break i;
                                    }
                                    if (k = s & 2147483647, !(!u & (k | 0) == 2147418112 ? !(n | t) : k >>> 0 < 2147418112)) {
                                        V = u, y = s | 32768, r = n, e = t;
                                        break i;
                                    }
                                    if (!(r | f | (h ^ 2147418112 | e))) {
                                        if (!(n | u | (k ^ 2147418112 | t))) {
                                            r = 0, e = 0, y = 2147450880;
                                            break i;
                                        }
                                        y = y | 2147418112, r = 0, e = 0;
                                        break i;
                                    }
                                    if (!(n | u | (k ^ 2147418112 | t))) {
                                        r = 0, e = 0;
                                        break i;
                                    }
                                    if (!(r | f | (e | h))) {
                                        r = !(n | u | (k | t)), V = r ? 0 : V, y = r ? 2147450880 : y, r = 0, e = 0;
                                        break i;
                                    }
                                    if (!(n | u | (k | t))) {
                                        y = y | 2147418112, r = 0, e = 0;
                                        break i;
                                    }
                                    if ((h | 0) == 65535 | h >>> 0 < 65535 && (f = !(G | W), s = f, h = f ? r : G, f = f << 6, s = e1(s ? e : W), f = f + ((s | 0) == 32 ? e1(h) + 32 | 0 : s) | 0, P1(w + 320 | 0, r, e, G, W, f - 15 | 0), C = 16 - f | 0, G = i[w + 328 >> 2], W = i[w + 332 >> 2], e = i[w + 324 >> 2], r = i[w + 320 >> 2]), k >>> 0 > 65535) break e;
                                    f = !(B | _), u = f, s = f ? n : _, f = f << 6, u = e1(u ? t : B), f = f + ((u | 0) == 32 ? e1(s) + 32 | 0 : u) | 0, P1(w + 304 | 0, n, t, _, B, f - 15 | 0), C = (f + C | 0) - 16 | 0, _ = i[w + 312 >> 2], B = i[w + 316 >> 2], n = i[w + 304 >> 2], t = i[w + 308 >> 2];
                                }
                                k = B | 65536, T = k, S = _, f = _, h = k << 15 | f >>> 17, k = f << 15 | t >>> 17, f = k, s = 0 - f | 0, u = h, h = 1963258675 - (h + ((f | 0) != 0) | 0) | 0, x1(w + 288 | 0, f, u, 0, 0, s, h, 0, 0), f = i[w + 296 >> 2], x1(w + 272 | 0, 0 - f | 0, 0 - (i[w + 300 >> 2] + ((f | 0) != 0) | 0) | 0, 0, 0, s, h, 0, 0), f = i[w + 280 >> 2], s = f << 1 | i[w + 276 >> 2] >>> 31, f = i[w + 284 >> 2] << 1 | f >>> 31, x1(w + 256 | 0, s, f, 0, 0, k, u, 0, 0), h = i[w + 264 >> 2], x1(w + 240 | 0, s, f, 0, 0, 0 - h | 0, 0 - (i[w + 268 >> 2] + ((h | 0) != 0) | 0) | 0, 0, 0), s = i[w + 248 >> 2], h = s << 1 | i[w + 244 >> 2] >>> 31, f = i[w + 252 >> 2] << 1 | s >>> 31, x1(w + 224 | 0, h, f, 0, 0, k, u, 0, 0), s = i[w + 232 >> 2], x1(w + 208 | 0, h, f, 0, 0, 0 - s | 0, 0 - (i[w + 236 >> 2] + ((s | 0) != 0) | 0) | 0, 0, 0), f = i[w + 216 >> 2], s = f << 1 | i[w + 212 >> 2] >>> 31, f = i[w + 220 >> 2] << 1 | f >>> 31, x1(w + 192 | 0, s, f, 0, 0, k, u, 0, 0), h = i[w + 200 >> 2], x1(w + 176 | 0, s, f, 0, 0, 0 - h | 0, 0 - (i[w + 204 >> 2] + ((h | 0) != 0) | 0) | 0, 0, 0), s = k, k = i[w + 184 >> 2], f = u, _ = k << 1 | i[w + 180 >> 2] >>> 31, u = _ - 1 | 0, k = (i[w + 188 >> 2] << 1 | k >>> 31) - !_ | 0, x1(w + 160 | 0, s, f, 0, 0, u, k, 0, 0), f = u, x1(w + 144 | 0, n << 15, t << 15 | n >>> 17, 0, 0, f, k, 0, 0), R = w + 112 | 0, P = i[w + 168 >> 2], u = i[w + 172 >> 2], _ = i[w + 160 >> 2], s = i[w + 152 >> 2], v = _ + s | 0, B = i[w + 164 >> 2], h = B + i[w + 156 >> 2] | 0, h = s >>> 0 > v >>> 0 ? h + 1 | 0 : h, s = h, h = (B | 0) == (h | 0) & v >>> 0 < _ >>> 0 | h >>> 0 < B >>> 0, B = h + P | 0, h = h >>> 0 > B >>> 0 ? u + 1 | 0 : u, _ = !s & v >>> 0 > 1 | (s | 0) != 0, u = B + _ | 0, h = _ >>> 0 > u >>> 0 ? h + 1 | 0 : h, x1(R, f, k, 0, 0, 0 - u | 0, 0 - (((u | 0) != 0) + h | 0) | 0, 0, 0), x1(w + 128 | 0, 1 - v | 0, 0 - ((v >>> 0 > 1) + s | 0) | 0, 0, 0, f, k, 0, 0), m0 = (E - H | 0) + C | 0, k = i[w + 116 >> 2], E = k, f = i[w + 112 >> 2], h = k << 1 | f >>> 31, s = f << 1, B = h, f = h, u = i[w + 140 >> 2], M = u, k = i[w + 136 >> 2], h = u << 1 | k >>> 31, v = k << 1 | i[w + 132 >> 2] >>> 31, u = v + s | 0, f = f + h | 0, f = u >>> 0 < v >>> 0 ? f + 1 | 0 : f, k = f, f = f - (u >>> 0 < 13927) | 0, F = f, R = f, v = 0, h = W | 65536, Z0 = h, X0 = G, f = G, h = h << 1 | f >>> 31, I0 = f << 1, F0 = h, f0 = h, f = O0(F, v, h, 0), h = w0, $ = f, c = h, s0 = r << 1, f = e << 1 | r >>> 31, H = f, P = f, h = 0, C = h, _ = u - 13927 | 0, F = (k | 0) == (F | 0) & _ >>> 0 < u >>> 0 | k >>> 0 > F >>> 0, k = (k | 0) == (B | 0) & u >>> 0 < s >>> 0 | k >>> 0 < B >>> 0, f = i[w + 120 >> 2], u = i[w + 124 >> 2] << 1 | f >>> 31, f = f << 1 | E >>> 31, v = M >>> 31 | 0, f = v + f | 0, h = u, h = f >>> 0 < v >>> 0 ? h + 1 | 0 : h, u = f, f = f + k | 0, h = u >>> 0 > f >>> 0 ? h + 1 | 0 : h, k = f, f = f + F | 0, v = k >>> 0 > f >>> 0 ? h + 1 | 0 : h, k = f - 1 | 0, r0 = v - !f | 0, M = 0, s = O0(P, C, r0, M), f = s + $ | 0, u = w0 + c | 0, u = f >>> 0 < s >>> 0 ? u + 1 | 0 : u, B = (c | 0) == (u | 0) & f >>> 0 < $ >>> 0 | u >>> 0 < c >>> 0, $ = k, V0 = e >>> 31 | 0, t0 = V0 | G << 1, F = 0, k = O0(k, 0, t0, F), G = k + f | 0, h = w0 + u | 0, v = 0, h = k >>> 0 > G >>> 0 ? h + 1 | 0 : h, W = h, f = (h | 0) == (u | 0) & f >>> 0 > G >>> 0 | u >>> 0 > h >>> 0, k = f, f = f + B | 0, v = k >>> 0 > f >>> 0 ? 1 : v, k = O0(f0, C, r0, M), f = k + f | 0, h = w0 + v | 0, B = f, f = f >>> 0 < k >>> 0 ? h + 1 | 0 : h, k = O0(f0, C, $, F), v = w0, u = k, k = O0(t0, F, r0, M), s = u + k | 0, h = w0 + v | 0, h = k >>> 0 > s >>> 0 ? h + 1 | 0 : h, k = h, h = (v | 0) == (h | 0) & u >>> 0 > s >>> 0 | h >>> 0 < v >>> 0, v = B + k | 0, f = f + h | 0, f = v >>> 0 < k >>> 0 ? f + 1 | 0 : f, B = v, v = f, k = 0, f = k + G | 0, h = s + W | 0, h = f >>> 0 < k >>> 0 ? h + 1 | 0 : h, k = h, u = (h | 0) == (W | 0) & f >>> 0 < G >>> 0 | h >>> 0 < W >>> 0, h = v, s = u, u = u + B | 0, h = s >>> 0 > u >>> 0 ? h + 1 | 0 : h, E = u, v = h, G = f, c = _, f = O0(_, 0, t0, F), s = w0, u = f, _ = O0(R, V, P, V), f = f + _ | 0, h = w0 + s | 0, h = f >>> 0 < _ >>> 0 ? h + 1 | 0 : h, _ = (s | 0) == (h | 0) & f >>> 0 < u >>> 0 | s >>> 0 > h >>> 0, u = h, L = s0 & -2, s = O0($, F, L, 0), W = s + f | 0, h = w0 + h | 0, h = s >>> 0 > W >>> 0 ? h + 1 | 0 : h, s = h, f = (h | 0) == (u | 0) & f >>> 0 > W >>> 0 | u >>> 0 > h >>> 0, u = 0, h = f + _ | 0, f = (h >>> 0 < f >>> 0 ? 1 : u) + k | 0, B = h + G | 0, f = B >>> 0 < h >>> 0 ? f + 1 | 0 : f, h = v, _ = f, f = (f | 0) == (k | 0) & B >>> 0 < G >>> 0 | f >>> 0 < k >>> 0, k = f, f = f + E | 0, h = k >>> 0 > f >>> 0 ? h + 1 | 0 : h, g0 = f, E = h, f = O0(f0, C, c, V), q = w0, f0 = f, k = O0(r0, M, L, V), f = f + k | 0, h = w0 + q | 0, h = f >>> 0 < k >>> 0 ? h + 1 | 0 : h, G = f, v = O0(R, V, t0, F), k = f + v | 0, u = h, f = h + w0 | 0, f = k >>> 0 < v >>> 0 ? f + 1 | 0 : f, C = k, h = O0(P, V, $, F), k = k + h | 0, v = w0 + f | 0, v = k >>> 0 < h >>> 0 ? v + 1 | 0 : v, r0 = (f | 0) == (v | 0) & k >>> 0 < C >>> 0 | f >>> 0 > v >>> 0, h = (u | 0) == (q | 0) & G >>> 0 < f0 >>> 0 | u >>> 0 < q >>> 0, f = (f | 0) == (u | 0) & G >>> 0 > C >>> 0 | f >>> 0 < u >>> 0, f = f + h | 0, f = f + r0 | 0, u = v, C = u + B | 0, h = (f | M) + _ | 0, h = u >>> 0 > C >>> 0 ? h + 1 | 0 : h, G = h, f = (_ | 0) == (h | 0) & B >>> 0 > C >>> 0 | h >>> 0 < _ >>> 0, h = E, u = f, f = f + g0 | 0, h = u >>> 0 > f >>> 0 ? h + 1 | 0 : h, M = f, _ = h, f = O0(R, V, L, V), R = w0, B = f, u = O0(P, V, c, V), f = f + u | 0, h = w0 + R | 0, h = f >>> 0 < u >>> 0 ? h + 1 | 0 : h, E = 0, u = (h | 0) == (R | 0) & f >>> 0 < B >>> 0 | h >>> 0 < R >>> 0, B = h, f = h + W | 0, h = (u | E) + s | 0, h = f >>> 0 < B >>> 0 ? h + 1 | 0 : h, s = (s | 0) == (h | 0) & f >>> 0 < W >>> 0 | s >>> 0 > h >>> 0, u = h, h = k, W = 0, k = W + f | 0, v = u + h | 0, h = 0, v = k >>> 0 < W >>> 0 ? v + 1 | 0 : v, f = (u | 0) == (v | 0) & f >>> 0 > k >>> 0 | u >>> 0 > v >>> 0, k = f, f = f + s | 0, h = (k >>> 0 > f >>> 0 ? 1 : h) + G | 0, v = _, k = f, f = f + C | 0, h = k >>> 0 > f >>> 0 ? h + 1 | 0 : h, k = h, u = (G | 0) == (h | 0) & f >>> 0 < C >>> 0 | h >>> 0 < G >>> 0, s = u, u = u + M | 0, v = s >>> 0 > u >>> 0 ? v + 1 | 0 : v, s = v;
                                e: {
                                    if ((v | 0) == 131071 | v >>> 0 < 131071) {
                                        X0 = I0 | V0, Z0 = F | F0, x1(w + 80 | 0, f, h, u, v, n, t, S, T), v = i[w + 84 >> 2], C = v, h = r << 17, G = 0, W = i[w + 88 >> 2], e = G - W | 0, r = i[w + 80 >> 2], v = (v | r) != 0, _ = e - v | 0, B = (h - (i[w + 92 >> 2] + (G >>> 0 < W >>> 0) | 0) | 0) - (e >>> 0 < v >>> 0) | 0, W = 0 - (((r | 0) != 0) + C | 0) | 0, C = m0 + 16382 | 0, G = 0 - r | 0;
                                        break e;
                                    }
                                    f = (k & 1) << 31 | f >>> 1, k = u << 31 | k >>> 1, u = (s & 1) << 31 | u >>> 1, s = s >>> 1 | 0, x1(w + 96 | 0, f, k, u, s, n, t, S, T), _ = i[w + 100 >> 2], H = _, B = 0, C = i[w + 104 >> 2], G = B - C | 0, v = i[w + 96 >> 2], W = (_ | v) != 0, _ = G - W | 0, B = ((r << 16) - (i[w + 108 >> 2] + (B >>> 0 < C >>> 0) | 0) | 0) - (G >>> 0 < W >>> 0) | 0, W = 0 - (((v | 0) != 0) + H | 0) | 0, s0 = r, H = e, C = m0 + 16383 | 0, G = 0 - v | 0;
                                }
                                if ((C | 0) >= 32767) {
                                    y = y | 2147418112, r = 0, e = 0;
                                    break i;
                                }
                                e: {
                                    if ((C | 0) > 0) {
                                        r = _ << 1 | W >>> 31, e = B << 1 | _ >>> 31, _ = u, B = s & 65535 | C << 16, v = W << 1 | G >>> 31, u = G << 1;
                                        break e;
                                    }
                                    if ((C | 0) <= -113) {
                                        r = 0, e = 0;
                                        break i;
                                    }
                                    d8(w - -64 | 0, f, k, u, s, 1 - C | 0), P1(w + 48 | 0, s0, H, X0, Z0, C + 112 | 0), f = i[w + 64 >> 2], k = i[w + 68 >> 2], _ = i[w + 72 >> 2], B = i[w + 76 >> 2], x1(w + 32 | 0, n, t, S, T, f, k, _, B), r = i[w + 40 >> 2], e = i[w + 56 >> 2], s = i[w + 36 >> 2], W = r << 1 | s >>> 31, v = e - W | 0, W = i[w + 60 >> 2] - ((i[w + 44 >> 2] << 1 | r >>> 31) + (e >>> 0 < W >>> 0) | 0) | 0, e = i[w + 52 >> 2], C = e, r = i[w + 32 >> 2], u = s << 1 | r >>> 31, G = r << 1, r = G, h = i[w + 48 >> 2], e = (e | 0) == (u | 0) & r >>> 0 > h >>> 0 | e >>> 0 < u >>> 0, r = v - e | 0, e = W - (e >>> 0 > v >>> 0) | 0, v = C - ((h >>> 0 < G >>> 0) + u | 0) | 0, u = h - G | 0;
                                }
                                x1(w + 16 | 0, n, t, S, T, 3, 0, 0, 0), x1(w, n, t, S, T, 5, 0, 0, 0), G = f, W = f & 1, s = W, f = u + s | 0, h = 0, u = h + v | 0, u = f >>> 0 < s >>> 0 ? u + 1 | 0 : u, s = f, t = (t | 0) == (u | 0) & f >>> 0 > n >>> 0 | t >>> 0 < u >>> 0, v = e, f = (u | 0) == (h | 0) & f >>> 0 < W >>> 0 | u >>> 0 < h >>> 0, n = r + f | 0, v = f >>> 0 > n >>> 0 ? v + 1 | 0 : v, h = k, r = (v | 0) == (T | 0), r = r & (n | 0) == (S | 0) ? t : r & n >>> 0 > S >>> 0 | v >>> 0 > T >>> 0, e = r, r = r + G | 0, h = e >>> 0 > r >>> 0 ? h + 1 | 0 : h, e = h, f = (k | 0) == (h | 0) & r >>> 0 < G >>> 0 | k >>> 0 > h >>> 0, h = B, k = f, f = f + _ | 0, h = k >>> 0 > f >>> 0 ? h + 1 | 0 : h, t = f, k = i[w + 20 >> 2], _ = (k | 0) == (u | 0) & k0[w + 16 >> 2] < s >>> 0 | k >>> 0 < u >>> 0, k = i[w + 28 >> 2], f = i[w + 24 >> 2], k = h >>> 0 < 2147418112 & ((f | 0) == (n | 0) & (k | 0) == (v | 0) ? _ : (k | 0) == (v | 0) & f >>> 0 < n >>> 0 | k >>> 0 < v >>> 0), f = e, _ = k, k = r + k | 0, f = _ >>> 0 > k >>> 0 ? f + 1 | 0 : f, r = (e | 0) == (f | 0) & r >>> 0 > k >>> 0 | e >>> 0 > f >>> 0, e = r, r = r + t | 0, h = e >>> 0 > r >>> 0 ? h + 1 | 0 : h, t = r, e = i[w + 4 >> 2], u = (e | 0) == (u | 0) & k0[w >> 2] < s >>> 0 | e >>> 0 < u >>> 0, e = i[w + 12 >> 2], r = i[w + 8 >> 2], r = h >>> 0 < 2147418112 & ((r | 0) == (n | 0) & (e | 0) == (v | 0) ? u : (e | 0) == (v | 0) & r >>> 0 < n >>> 0 | e >>> 0 < v >>> 0), e = r, r = r + k | 0, v = e >>> 0 > r >>> 0 ? f + 1 | 0 : f, e = v, k = (f | 0) == (v | 0) & r >>> 0 < k >>> 0 | f >>> 0 > v >>> 0, f = h, n = k, k = k + t | 0, f = n >>> 0 > k >>> 0 ? f + 1 | 0 : f, V = k | V, y = f | y;
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = V, i[A + 12 >> 2] = y, m = w + 336 | 0;
                        }
                        function yh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            e = m + -64 | 0, m = e, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, f = i[r + 20 >> 2], i[e >> 2] = i[f + 48 >> 2], f = i[f + 52 >> 2], i[e + 4 >> 2] = f, f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), w6(e + 24 | 0, i[e >> 2], i[r + 36 >> 2], e + 44 | 0, 0, 0, -1, -1), f = i[e + 4 >> 2];
                            i: {
                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            i: {
                                if (i[e + 24 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 28 >> 2], i[A + 8 >> 2] = i[e + 24 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[e + 43 | 0] >= 0) {
                                        r = i[e + 36 >> 2], i[A >> 2] = i[e + 32 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 40 >> 2];
                                        break i;
                                    }
                                    j(A, i[e + 32 >> 2], i[e + 36 >> 2]);
                                    break i;
                                }
                                n = 0, k = m - 32 | 0, m = k, f = k + 8 | 0, w = i[r + 20 >> 2], v4(f, w, i[r + 36 >> 2], 0), v = i[k + 12 >> 2], t = i[k + 8 >> 2];
                                e: {
                                    if (!t) {
                                        if (o[k + 8 | 0] = 0, o[k + 19 | 0] = 0, i0(e, 2, 2e3, f), o[k + 19 | 0] >= 0) break e;
                                        X(i[k + 8 >> 2]);
                                        break e;
                                    }
                                    r: {
                                        A: {
                                            f = i[t + 24 >> 2], s = i[t + 28 >> 2];
                                            f: {
                                                if ((f | 0) == (s | 0)) break f;
                                                r = f;
                                                k: {
                                                    for(;;){
                                                        n: {
                                                            if (n = i[r >> 2], !n || (u = E0(n, 73632, 73656), !u)) break n;
                                                            if (h = i[r + 4 >> 2], !h) {
                                                                h = 0;
                                                                break k;
                                                            }
                                                            i[h + 4 >> 2] = i[h + 4 >> 2] + 1, s = i[t + 28 >> 2], f = i[t + 24 >> 2];
                                                            break k;
                                                        }
                                                        if (r = r + 8 | 0, (s | 0) == (r | 0)) break;
                                                    }
                                                    u = 0;
                                                }
                                                k: {
                                                    if ((f | 0) != (s | 0)) for(;;){
                                                        n: {
                                                            if (r = i[f >> 2], !r || (r = E0(r, 73632, 82328), !r)) break n;
                                                            if (n = i[f + 4 >> 2], !n) {
                                                                n = 0;
                                                                break k;
                                                            }
                                                            i[n + 4 >> 2] = i[n + 4 >> 2] + 1;
                                                            break k;
                                                        }
                                                        if (f = f + 8 | 0, (s | 0) == (f | 0)) break;
                                                    }
                                                    n = 0, r = 0;
                                                }
                                                if (!u) break f;
                                                if (w = w - -64 | 0, t = i[u + 104 >> 2], s = i[u + 108 >> 2], h6(e, w, t, s), i[e >> 2]) break r;
                                                if (o[e + 19 | 0] < 0 && X(i[e + 8 >> 2]), r) break A;
                                            }
                                            if (r = D(40), i[k + 8 >> 2] = r, i[k + 12 >> 2] = 35, i[k + 16 >> 2] = -2147483608, f = l[14854] | l[14855] << 8 | (l[14856] << 16 | l[14857] << 24), t = l[14850] | l[14851] << 8 | (l[14852] << 16 | l[14853] << 24), o[r | 0] = t, o[r + 1 | 0] = t >>> 8, o[r + 2 | 0] = t >>> 16, o[r + 3 | 0] = t >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 35 | 0] = 0, f = l[14881] | l[14882] << 8 | (l[14883] << 16 | l[14884] << 24), o[r + 31 | 0] = f, o[r + 32 | 0] = f >>> 8, o[r + 33 | 0] = f >>> 16, o[r + 34 | 0] = f >>> 24, f = l[14878] | l[14879] << 8 | (l[14880] << 16 | l[14881] << 24), t = l[14874] | l[14875] << 8 | (l[14876] << 16 | l[14877] << 24), o[r + 24 | 0] = t, o[r + 25 | 0] = t >>> 8, o[r + 26 | 0] = t >>> 16, o[r + 27 | 0] = t >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[14870] | l[14871] << 8 | (l[14872] << 16 | l[14873] << 24), t = l[14866] | l[14867] << 8 | (l[14868] << 16 | l[14869] << 24), o[r + 16 | 0] = t, o[r + 17 | 0] = t >>> 8, o[r + 18 | 0] = t >>> 16, o[r + 19 | 0] = t >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[14862] | l[14863] << 8 | (l[14864] << 16 | l[14865] << 24), t = l[14858] | l[14859] << 8 | (l[14860] << 16 | l[14861] << 24), o[r + 8 | 0] = t, o[r + 9 | 0] = t >>> 8, o[r + 10 | 0] = t >>> 16, o[r + 11 | 0] = t >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(e, 4, 3002, k + 8 | 0), o[k + 19 | 0] >= 0) break r;
                                            X(i[k + 8 >> 2]);
                                            break r;
                                        }
                                        A: switch(l[r + 104 | 0] - 8 | 0){
                                            default:
                                                if (r = D(40), i[k + 8 >> 2] = r, i[k + 12 >> 2] = 35, i[k + 16 >> 2] = -2147483608, f = l[7839] | l[7840] << 8 | (l[7841] << 16 | l[7842] << 24), t = l[7835] | l[7836] << 8 | (l[7837] << 16 | l[7838] << 24), o[r | 0] = t, o[r + 1 | 0] = t >>> 8, o[r + 2 | 0] = t >>> 16, o[r + 3 | 0] = t >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 35 | 0] = 0, f = l[7866] | l[7867] << 8 | (l[7868] << 16 | l[7869] << 24), o[r + 31 | 0] = f, o[r + 32 | 0] = f >>> 8, o[r + 33 | 0] = f >>> 16, o[r + 34 | 0] = f >>> 24, f = l[7863] | l[7864] << 8 | (l[7865] << 16 | l[7866] << 24), t = l[7859] | l[7860] << 8 | (l[7861] << 16 | l[7862] << 24), o[r + 24 | 0] = t, o[r + 25 | 0] = t >>> 8, o[r + 26 | 0] = t >>> 16, o[r + 27 | 0] = t >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[7855] | l[7856] << 8 | (l[7857] << 16 | l[7858] << 24), t = l[7851] | l[7852] << 8 | (l[7853] << 16 | l[7854] << 24), o[r + 16 | 0] = t, o[r + 17 | 0] = t >>> 8, o[r + 18 | 0] = t >>> 16, o[r + 19 | 0] = t >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[7847] | l[7848] << 8 | (l[7849] << 16 | l[7850] << 24), t = l[7843] | l[7844] << 8 | (l[7845] << 16 | l[7846] << 24), o[r + 8 | 0] = t, o[r + 9 | 0] = t >>> 8, o[r + 10 | 0] = t >>> 16, o[r + 11 | 0] = t >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(e, 4, 3002, k + 8 | 0), o[k + 19 | 0] >= 0) break r;
                                                X(i[k + 8 >> 2]);
                                                break r;
                                            case 0:
                                            case 8:
                                                break A;
                                        }
                                        if (i[e + 48 >> 2] - i[e + 44 >> 2] >>> 0 < Z(t, s) >>> 0) {
                                            if (r = D(32), i[k + 8 >> 2] = r, i[k + 12 >> 2] = 28, i[k + 16 >> 2] = -2147483616, f = l[3253] | l[3254] << 8 | (l[3255] << 16 | l[3256] << 24), t = l[3249] | l[3250] << 8 | (l[3251] << 16 | l[3252] << 24), o[r | 0] = t, o[r + 1 | 0] = t >>> 8, o[r + 2 | 0] = t >>> 16, o[r + 3 | 0] = t >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 28 | 0] = 0, f = l[3273] | l[3274] << 8 | (l[3275] << 16 | l[3276] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, f = l[3269] | l[3270] << 8 | (l[3271] << 16 | l[3272] << 24), t = l[3265] | l[3266] << 8 | (l[3267] << 16 | l[3268] << 24), o[r + 16 | 0] = t, o[r + 17 | 0] = t >>> 8, o[r + 18 | 0] = t >>> 16, o[r + 19 | 0] = t >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[3261] | l[3262] << 8 | (l[3263] << 16 | l[3264] << 24), t = l[3257] | l[3258] << 8 | (l[3259] << 16 | l[3260] << 24), o[r + 8 | 0] = t, o[r + 9 | 0] = t >>> 8, o[r + 10 | 0] = t >>> 16, o[r + 11 | 0] = t >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(e, 2, 0, k + 8 | 0), o[k + 19 | 0] >= 0) break r;
                                            X(i[k + 8 >> 2]);
                                            break r;
                                        }
                                        f = D(136), i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = 78252, B0(f + 20 | 0, 0, 104), u = i[f + 4 >> 2], _ = u + 1 | 0, i[f + 4 >> 2] = _, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 44 >> 2] = 99, i[f + 48 >> 2] = 99, i[f + 32 >> 2] = 4142, B = f - -64 | 0, i[B >> 2] = 0, i[B + 4 >> 2] = 0, i[f + 132 >> 2] = 0, i[f + 124 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 84 >> 2] = 1, i[f + 88 >> 2] = 1, i[f + 72 >> 2] = f + 76, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, i[f + 112 >> 2] = 0, o[f + 113 | 0] = 0, o[f + 114 | 0] = 0, o[f + 115 | 0] = 0, o[f + 116 | 0] = 0, o[f + 117 | 0] = 0, o[f + 118 | 0] = 0, o[f + 119 | 0] = 0, o[f + 120 | 0] = 0, B = f + 12 | 0, i[f + 12 >> 2] = B, i[f + 8 >> 2] = i[f + 8 >> 2] + 1, i[f + 4 >> 2] = u, i[f + 16 >> 2] = f, _ || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), i[e + 56 >> 2] = B, u = i[e + 60 >> 2], i[e + 60 >> 2] = f;
                                        A: {
                                            if (!u || (f = i[u + 4 >> 2], i[u + 4 >> 2] = f - 1, f)) break A;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        if (f = i[e + 56 >> 2], i[f + 36 >> 2] = 0, i[f + 32 >> 2] = 2, i[f + 28 >> 2] = s, i[f + 24 >> 2] = t, J0(k + 8 | 0, i[e + 56 >> 2], 0, t, s, l[r + 104 | 0], w), i[k + 8 >> 2]) {
                                            r = i[k + 12 >> 2], i[e >> 2] = i[k + 8 >> 2], i[e + 4 >> 2] = r, r = i[k + 20 >> 2], i[e + 8 >> 2] = i[k + 16 >> 2], i[e + 12 >> 2] = r, i[e + 16 >> 2] = i[k + 24 >> 2];
                                            break r;
                                        }
                                        f = V9(i[e + 56 >> 2], 0, k + 4 | 0);
                                        A: {
                                            if ((t | 0) != i[k + 4 >> 2]) {
                                                if (!s) break A;
                                                if (r = 0, (s | 0) != 1) for(w = s & -2, u = 0; v0(f + Z(i[k + 4 >> 2], r) | 0, i[e + 44 >> 2] + Z(r, t) | 0, t), _ = r | 1, v0(f + Z(_, i[k + 4 >> 2]) | 0, i[e + 44 >> 2] + Z(t, _) | 0, t), r = r + 2 | 0, u = u + 2 | 0, (w | 0) != (u | 0););
                                                if (!(s & 1)) break A;
                                                v0(f + Z(i[k + 4 >> 2], r) | 0, i[e + 44 >> 2] + Z(r, t) | 0, t);
                                                break A;
                                            }
                                            r = i[e + 44 >> 2], v0(f, r, i[e + 48 >> 2] - r | 0);
                                        }
                                        if (J6(e), o[k + 27 | 0] >= 0) break r;
                                        X(i[k + 16 >> 2]);
                                    }
                                    r: {
                                        if (!n || (r = i[n + 4 >> 2], i[n + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                    }
                                    if (!h || (r = i[h + 4 >> 2], i[h + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                }
                                e: {
                                    if (!v || (r = i[v + 4 >> 2], i[v + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                }
                                m = k + 32 | 0;
                                e: {
                                    if (i[e >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 4 >> 2], i[A + 8 >> 2] = i[e >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[e + 19 | 0] >= 0) {
                                            r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                            break e;
                                        }
                                        j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                        break e;
                                    }
                                    if (i[A >> 2] = i[e + 56 >> 2], r = i[e + 60 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            o[e + 43 | 0] < 0 && X(i[e + 32 >> 2]), A = i[e + 44 >> 2], A && (i[e + 48 >> 2] = A, X(A)), A = i[e + 60 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = e - -64 | 0;
                        }
                        function Ih(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            n = m + -64 | 0, m = n, z1(n + 44 | 0, r, e), o[n + 63 | 0] < 0 && X(i[n + 52 >> 2]), f = X2(e), u = f & 1, o[r + 105 | 0] = u, o[r + 104 | 0] = f >>> 1 & 3;
                            i: {
                                e: {
                                    r: {
                                        if (u) {
                                            if (f = B2(e), o[r + 110 | 0] = f & 3, Q[r + 106 >> 1] = f >>> 7, o[r + 109 | 0] = f >>> 2 & 3, o[r + 108 | 0] = f >>> 4 & 7, G = r, W = X2(e) >>> 5 | 0, o[G + 111 | 0] = W, f = X2(e) & 63, o[r + 112 | 0] = f, !f) {
                                                if (r = D(56), i[n + 28 >> 2] = r, i[n + 32 >> 2] = 54, i[n + 36 >> 2] = -2147483592, e = l[19855] | l[19856] << 8 | (l[19857] << 16 | l[19858] << 24), f = l[19851] | l[19852] << 8 | (l[19853] << 16 | l[19854] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 54 | 0] = 0, e = l[19901] | l[19902] << 8 | (l[19903] << 16 | l[19904] << 24), f = l[19897] | l[19898] << 8 | (l[19899] << 16 | l[19900] << 24), o[r + 46 | 0] = f, o[r + 47 | 0] = f >>> 8, o[r + 48 | 0] = f >>> 16, o[r + 49 | 0] = f >>> 24, o[r + 50 | 0] = e, o[r + 51 | 0] = e >>> 8, o[r + 52 | 0] = e >>> 16, o[r + 53 | 0] = e >>> 24, e = l[19895] | l[19896] << 8 | (l[19897] << 16 | l[19898] << 24), f = l[19891] | l[19892] << 8 | (l[19893] << 16 | l[19894] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[19887] | l[19888] << 8 | (l[19889] << 16 | l[19890] << 24), f = l[19883] | l[19884] << 8 | (l[19885] << 16 | l[19886] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[19879] | l[19880] << 8 | (l[19881] << 16 | l[19882] << 24), f = l[19875] | l[19876] << 8 | (l[19877] << 16 | l[19878] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[19871] | l[19872] << 8 | (l[19873] << 16 | l[19874] << 24), f = l[19867] | l[19868] << 8 | (l[19869] << 16 | l[19870] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[19863] | l[19864] << 8 | (l[19865] << 16 | l[19866] << 24), f = l[19859] | l[19860] << 8 | (l[19861] << 16 | l[19862] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 2006, n + 28 | 0), o[n + 39 | 0] >= 0) break r;
                                                X(i[n + 28 >> 2]);
                                                break r;
                                            }
                                            f = X2(e), o[r + 114 | 0] = f & 1, o[r + 113 | 0] = f >>> 1, G = r, W = X2(e), o[G + 115 | 0] = W;
                                            A: {
                                                if (!l[r + 112 | 0]) break A;
                                                for(;;){
                                                    f = X2(e), h || (o[r + 116 | 0] = f >>> 7, o[r + 117 | 0] = f >>> 6 & 1, f = f & 63);
                                                    f: {
                                                        s = i[r + 124 >> 2], k = i[r + 128 >> 2];
                                                        k: {
                                                            if (s >>> 0 < k >>> 0) {
                                                                o[s | 0] = f, v = s + 1 | 0;
                                                                break k;
                                                            }
                                                            if (t = i[r + 120 >> 2], w = s - t | 0, u = w + 1 | 0, (u | 0) < 0) break f;
                                                            k = k - t | 0, v = k << 1, v = k >>> 0 >= 1073741823 ? 2147483647 : u >>> 0 < v >>> 0 ? v : u, v ? k = D(v) : k = 0, u = w + k | 0, o[u | 0] = f, B = k + v | 0, v = u + 1 | 0;
                                                            n: {
                                                                if ((t | 0) == (s | 0)) {
                                                                    k = u;
                                                                    break n;
                                                                }
                                                                if (_ = 0, f = s, w = w & 3, w) for(; u = u - 1 | 0, f = f - 1 | 0, o[u | 0] = l[f | 0], _ = _ + 1 | 0, (w | 0) != (_ | 0););
                                                                if (t - s >>> 0 <= 4294967292) for(; o[u - 1 | 0] = l[f - 1 | 0], o[u - 2 | 0] = l[f - 2 | 0], o[u - 3 | 0] = l[f - 3 | 0], u = u - 4 | 0, f = f - 4 | 0, o[u | 0] = l[f | 0], (f | 0) != (t | 0););
                                                                t = i[r + 120 >> 2];
                                                            }
                                                            if (i[r + 128 >> 2] = B, i[r + 124 >> 2] = v, i[r + 120 >> 2] = k, !t) break k;
                                                            X(t);
                                                        }
                                                        if (i[r + 124 >> 2] = v, h = h + 1 | 0, h >>> 0 < l[r + 112 | 0]) continue;
                                                        break A;
                                                    }
                                                    break;
                                                }
                                                p0(), z();
                                            }
                                            h = l[r + 108 | 0];
                                            A: {
                                                if (h >>> 0 <= 1 || (C5(r + 132 | 0, h - 1 | 0), s = X2(e), h = l[r + 108 | 0], h >>> 0 < 2)) break A;
                                                for(f = h - 2 | 0, w = i[r + 132 >> 2], u = 128; k = 1 << f, t = w + (f >>> 3 & 536870908) | 0, u & s ? k = k | i[t >> 2] : k = i[t >> 2] & (k ^ -1), i[t >> 2] = k, u = u >>> 1 | 0, k = (f | 0) > 0, f = f - 1 | 0, !!k;);
                                            }
                                            u = r + 144 | 0, k = i[r + 144 >> 2], f = i[r + 148 >> 2] - k | 0;
                                            A: {
                                                if (f >>> 0 < h >>> 0) {
                                                    r1(u, h - f | 0), h = l[r + 108 | 0];
                                                    break A;
                                                }
                                                if (f >>> 0 <= h >>> 0) break A;
                                                i[r + 148 >> 2] = k + h;
                                            }
                                            f = h & 255;
                                            A: {
                                                if (!f || (o[(f + i[r + 144 >> 2] | 0) - 1 | 0] = l[r + 115 | 0], f = l[r + 108 | 0], f >>> 0 < 2)) break A;
                                                for(f = f - 2 | 0;;){
                                                    f: {
                                                        if (i[i[r + 132 >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1) {
                                                            k = X2(e), o[i[u >> 2] + f | 0] = k;
                                                            break f;
                                                        }
                                                        k = i[u >> 2] + f | 0, o[k | 0] = l[k + 1 | 0];
                                                    }
                                                    if (k = (f | 0) > 0, f = f - 1 | 0, !k) break;
                                                }
                                            }
                                            if (h = X2(e), h) for(v = 0;;){
                                                t = n2(e), f = i[r + 160 >> 2], k = i[r + 164 >> 2];
                                                A: {
                                                    if (f >>> 0 < k >>> 0) {
                                                        i[f >> 2] = t, t = f + 4 | 0;
                                                        break A;
                                                    }
                                                    if (s = i[r + 156 >> 2], _ = f - s >> 2, u = _ + 1 | 0, u >>> 0 >= 1073741824) break e;
                                                    if (k = k - s | 0, w = k >> 1, w = k >>> 0 >= 2147483644 ? 1073741823 : u >>> 0 < w >>> 0 ? w : u, w) {
                                                        if (w >>> 0 >= 1073741824) break i;
                                                        k = D(w << 2);
                                                    } else k = 0;
                                                    if (u = k + (_ << 2) | 0, i[u >> 2] = t, t = u + 4 | 0, (f | 0) != (s | 0)) for(; u = u - 4 | 0, f = f - 4 | 0, i[u >> 2] = i[f >> 2], (f | 0) != (s | 0););
                                                    if (i[r + 164 >> 2] = k + (w << 2), i[r + 160 >> 2] = t, i[r + 156 >> 2] = u, !s) break A;
                                                    X(s);
                                                }
                                                if (i[r + 160 >> 2] = t, v = v + 1 | 0, (h | 0) == (v | 0)) break;
                                            }
                                            G = r, W = B2(e), Q[G + 168 >> 1] = W, G = r, W = B2(e), Q[G + 170 >> 1] = W, G = r, W = B2(e), Q[G + 172 >> 1] = W;
                                        }
                                        w = X2(e);
                                        A: {
                                            if (!w) break A;
                                            for(v = r + 176 | 0, _ = n + 32 | 0, h = 0;;){
                                                if (l[e + 20 | 0]) break A;
                                                f = X2(e), u = 0, i[n + 40 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 36 >> 2] = 0, o[n + 29 | 0] = f & 63, o[n + 28 | 0] = f >>> 7, s = B2(e);
                                                f: {
                                                    k: {
                                                        if (!s) break k;
                                                        for(;;){
                                                            if (l[e + 20 | 0]) break k;
                                                            i[n + 24 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, k = B2(e), t = 19;
                                                            n: {
                                                                if (!k) break n;
                                                                t: {
                                                                    if (!o4(e, k)) break t;
                                                                    t = i[n + 16 >> 2], f = i[n + 20 >> 2] - t | 0;
                                                                    o: {
                                                                        if (f >>> 0 < k >>> 0) {
                                                                            r1(n + 16 | 0, k - f | 0);
                                                                            break o;
                                                                        }
                                                                        if (f >>> 0 <= k >>> 0) break o;
                                                                        i[n + 20 >> 2] = k + t;
                                                                    }
                                                                    t = i[e >> 2], f = i[e + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), k = p[i[i[t >> 2] + 16 >> 2]](t, i[n + 16 >> 2], k) | 0;
                                                                    o: {
                                                                        if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break o;
                                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                    }
                                                                    if (k) break t;
                                                                    f = D(32), i[n + 4 >> 2] = f, i[n + 8 >> 2] = 28, i[n + 12 >> 2] = -2147483616, k = l[2359] | l[2360] << 8 | (l[2361] << 16 | l[2362] << 24), t = l[2355] | l[2356] << 8 | (l[2357] << 16 | l[2358] << 24), o[f | 0] = t, o[f + 1 | 0] = t >>> 8, o[f + 2 | 0] = t >>> 16, o[f + 3 | 0] = t >>> 24, o[f + 4 | 0] = k, o[f + 5 | 0] = k >>> 8, o[f + 6 | 0] = k >>> 16, o[f + 7 | 0] = k >>> 24, o[f + 28 | 0] = 0, k = l[2379] | l[2380] << 8 | (l[2381] << 16 | l[2382] << 24), o[f + 24 | 0] = k, o[f + 25 | 0] = k >>> 8, o[f + 26 | 0] = k >>> 16, o[f + 27 | 0] = k >>> 24, k = l[2375] | l[2376] << 8 | (l[2377] << 16 | l[2378] << 24), t = l[2371] | l[2372] << 8 | (l[2373] << 16 | l[2374] << 24), o[f + 16 | 0] = t, o[f + 17 | 0] = t >>> 8, o[f + 18 | 0] = t >>> 16, o[f + 19 | 0] = t >>> 24, o[f + 20 | 0] = k, o[f + 21 | 0] = k >>> 8, o[f + 22 | 0] = k >>> 16, o[f + 23 | 0] = k >>> 24, k = l[2367] | l[2368] << 8 | (l[2369] << 16 | l[2370] << 24), t = l[2363] | l[2364] << 8 | (l[2365] << 16 | l[2366] << 24), o[f + 8 | 0] = t, o[f + 9 | 0] = t >>> 8, o[f + 10 | 0] = t >>> 16, o[f + 11 | 0] = t >>> 24, o[f + 12 | 0] = k, o[f + 13 | 0] = k >>> 8, o[f + 14 | 0] = k >>> 16, o[f + 15 | 0] = k >>> 24, i0(A, 2, 100, n + 4 | 0), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), t = 1;
                                                                    break n;
                                                                }
                                                                f = i[n + 36 >> 2];
                                                                t: {
                                                                    if (f >>> 0 < k0[n + 40 >> 2]) {
                                                                        i[f + 8 >> 2] = 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[f >> 2] = i[n + 16 >> 2], i[f + 4 >> 2] = i[n + 20 >> 2], i[f + 8 >> 2] = i[n + 24 >> 2], i[n + 24 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, f = f + 12 | 0;
                                                                        break t;
                                                                    }
                                                                    f = U3(_, n + 16 | 0);
                                                                }
                                                                i[n + 36 >> 2] = f, t = 0;
                                                            }
                                                            if (f = i[n + 16 >> 2], f && (i[n + 20 >> 2] = f, X(f)), (t | 0) != 19 && t) break f;
                                                            if (u = u + 1 | 0, (s | 0) == (u | 0)) break;
                                                        }
                                                    }
                                                    f = i[r + 180 >> 2];
                                                    k: {
                                                        if (f >>> 0 < k0[r + 184 >> 2]) {
                                                            u = I[n + 28 >> 1], i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, Q[f >> 1] = u, i[f + 4 >> 2] = i[n + 32 >> 2], i[f + 8 >> 2] = i[n + 36 >> 2], i[f + 12 >> 2] = i[n + 40 >> 2], i[n + 40 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 36 >> 2] = 0, f = f + 16 | 0;
                                                            break k;
                                                        }
                                                        f = S5(v, n + 28 | 0);
                                                    }
                                                    i[r + 180 >> 2] = f, t = 0;
                                                }
                                                if (k = i[n + 32 >> 2], k) {
                                                    if (f = i[n + 36 >> 2], u = k, (f | 0) != (k | 0)) {
                                                        for(; u = f - 12 | 0, s = i[u >> 2], s && (i[f - 8 >> 2] = s, X(s)), f = u, (k | 0) != (f | 0););
                                                        u = i[n + 32 >> 2];
                                                    }
                                                    i[n + 36 >> 2] = k, X(u);
                                                }
                                                if (t) break r;
                                                if (h = h + 1 | 0, (w | 0) == (h | 0)) break;
                                            }
                                        }
                                        if (l[e + 20 | 0] == 1) {
                                            if (o[n + 28 | 0] = 0, o[n + 39 | 0] = 0, i0(A, 2, 100, n + 28 | 0), o[n + 39 | 0] >= 0) break r;
                                            X(i[n + 28 >> 2]);
                                            break r;
                                        }
                                        if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    m = n - -64 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function Fh(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0;
                            s = m - 144 | 0, m = s;
                            i: {
                                if (!(n && e)) {
                                    if (o[s + 108 | 0] = 0, o[s + 119 | 0] = 0, e = A, A = i0(s + 56 | 0, 5, 2001, s + 108 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[s + 119 | 0] >= 0) break i;
                                    X(i[s + 108 >> 2]);
                                    break i;
                                }
                                if (!(k && f)) {
                                    if (o[s + 108 | 0] = 0, o[s + 119 | 0] = 0, e = A, A = i0(s + 56 | 0, 5, 2006, s + 108 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[s + 119 | 0] >= 0) break i;
                                    X(i[s + 108 >> 2]);
                                    break i;
                                }
                                o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, Q[s + 110 >> 1] = 0, Q[s + 112 >> 1] = 0, Q[s + 108 >> 1] = 263, o[s + 140 | 0] = 1, o[s + 136 | 0] = 0, i[s + 128 >> 2] = 2, i[s + 132 >> 2] = 2, o[s + 124 | 0] = 1, i[s + 120 >> 2] = 1;
                                e: {
                                    if (!t) break e;
                                    r: {
                                        A: switch(l[t | 0] - 1 | 0){
                                            case 1:
                                                o[s + 110 | 0] = l[t + 2 | 0], o[s + 109 | 0] = l[t + 1 | 0];
                                                break r;
                                            case 0:
                                                o[s + 109 | 0] = l[t + 1 | 0];
                                                break r;
                                            case 6:
                                                o[s + 140 | 0] = l[t + 32 | 0];
                                            case 5:
                                                w = i[t + 20 >> 2], i[s + 124 >> 2] = i[t + 16 >> 2], i[s + 128 >> 2] = w, w = i[t + 28 >> 2], i[s + 132 >> 2] = i[t + 24 >> 2], i[s + 136 >> 2] = w;
                                            case 4:
                                                i[s + 120 >> 2] = i[t + 12 >> 2];
                                            case 3:
                                                w = i[t + 4 >> 2], i[s + 112 >> 2] = w, o[s + 116 | 0] = l[t + 8 | 0];
                                                break;
                                            case 2:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        if (o[s + 111 | 0] = l[t + 3 | 0], o[s + 110 | 0] = l[t + 2 | 0], o[s + 109 | 0] = l[t + 1 | 0], w) break e;
                                    }
                                    if (t = i[i[e >> 2] >> 2], w = i[t + 44 >> 2], t = i[t + 48 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), w && (o[s + 56 | 0] = 1, i[s + 112 >> 2] = s + 56, i[s + 60 >> 2] = I[w + 4 >> 1], i[s + 64 >> 2] = I[w + 6 >> 1], i[s + 68 >> 2] = I[w + 8 >> 1], o[s + 72 | 0] = l[w + 10 | 0]), !t || (w = i[t + 4 >> 2], i[t + 4 >> 2] = w - 1, w)) break e;
                                    p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                }
                                if (t = 0, i[s + 52 >> 2] = 0, i[s + 44 >> 2] = 0, i[s + 48 >> 2] = 0, W = Z(f, k), W) for(w = 0;;){
                                    v = i[(w << 2) + e >> 2];
                                    e: {
                                        if (k0[s + 52 >> 2] > t >>> 0) {
                                            i[t >> 2] = i[v >> 2], v = i[v + 4 >> 2], i[t + 4 >> 2] = v, v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), t = t + 8 | 0;
                                            break e;
                                        }
                                        t = P2(s + 44 | 0, v);
                                    }
                                    if (i[s + 48 >> 2] = t, w = w + 1 | 0, (W | 0) == (w | 0)) break;
                                }
                                i[s + 36 >> 2] = 0, i[s + 40 >> 2] = 0, F = i[r >> 2], h = m - 96 | 0, m = h, e = T4(i[i[s + 44 >> 2] >> 2], 10), W = Z(S4(i[i[s + 44 >> 2] >> 2], 10), k), t = Z(e, f), _ = W | t, B = _ >>> 0 > 65535, e = B ? 12 : 8, w = D(e), i[h + 84 >> 2] = w, G = e + w | 0, i[h + 92 >> 2] = G, v = B0(w, 0, e), i[h + 88 >> 2] = G, o[v + 3 | 0] = f - 1, o[v + 2 | 0] = k - 1, o[v + 1 | 0] = B, o[v | 0] = 0;
                                e: {
                                    if (_ >>> 0 >= 65536) {
                                        e = W << 24 | (W & 65280) << 8 | (W >>> 8 & 65280 | W >>> 24), o[v + 8 | 0] = e, o[v + 9 | 0] = e >>> 8, o[v + 10 | 0] = e >>> 16, o[v + 11 | 0] = e >>> 24, _ = t >>> 24 | 0, w = t, e = t >>> 16 | 0;
                                        break e;
                                    }
                                    _ = t >>> 8 | 0, w = W, e = t;
                                }
                                o[v + 7 | 0] = w, o[v + 5 | 0] = e, o[v + 4 | 0] = _, o[v + 6 | 0] = w >>> 8, E = i[F + 48 >> 2], G = i[F + 52 >> 2], G && (i[G + 4 >> 2] = i[G + 4 >> 2] + 1), B = s + 8 | 0, P = s + 108 | 0, w = 0, i[h + 80 >> 2] = 0, i[h + 72 >> 2] = 0, i[h + 76 >> 2] = 0;
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (T = Z(f, k), !T) break k;
                                                    for(R = B + 16 | 0, e = 0;;){
                                                        ri(h + 44 | 0, F, i[s + 44 >> 2] + (e << 3) | 0, n, P, 1), S = i[h + 52 >> 2];
                                                        n: {
                                                            t: {
                                                                if (S) {
                                                                    if (i[B >> 2] = 0, i[B + 4 >> 2] = 0, f = i[h + 56 >> 2], i[B + 8 >> 2] = i[h + 52 >> 2], i[B + 12 >> 2] = f, o[h + 71 | 0] >= 0) {
                                                                        f = i[h + 64 >> 2], i[R >> 2] = i[h + 60 >> 2], i[R + 4 >> 2] = f, i[R + 8 >> 2] = i[h + 68 >> 2], _ = 0;
                                                                        break n;
                                                                    }
                                                                    j(R, i[h + 60 >> 2], i[h + 64 >> 2]), _ = 0;
                                                                    break t;
                                                                }
                                                                _ = i[h + 48 >> 2], _ && (i[_ + 4 >> 2] = i[_ + 4 >> 2] + 1), M = i[h + 44 >> 2], q1(h + 36 | 0, E, i[M + 36 >> 2]), f = i[h + 36 >> 2], o[f + 164 | 0] = 1, i[f + 100 >> 2] = i[f + 100 >> 2] & -2 | 1, f = i[h + 40 >> 2];
                                                                o: {
                                                                    if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break o;
                                                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                                }
                                                                V = i[M + 36 >> 2], f = i[h + 76 >> 2], v = i[h + 80 >> 2];
                                                                o: {
                                                                    if (f >>> 0 < v >>> 0) {
                                                                        i[f >> 2] = V, V = f + 4 | 0;
                                                                        break o;
                                                                    }
                                                                    if (y = i[h + 72 >> 2], C = f - y >> 2, k = C + 1 | 0, k >>> 0 >= 1073741824) break A;
                                                                    if ($ = C << 2, v = v - y | 0, C = v >> 1, C = v >>> 0 >= 2147483644 ? 1073741823 : k >>> 0 < C >>> 0 ? C : k, C) {
                                                                        if (C >>> 0 >= 1073741824) break r;
                                                                        v = D(C << 2);
                                                                    } else v = 0;
                                                                    if (k = $ + v | 0, i[k >> 2] = V, V = k + 4 | 0, (f | 0) != (y | 0)) for(; k = k - 4 | 0, f = f - 4 | 0, i[k >> 2] = i[f >> 2], (f | 0) != (y | 0););
                                                                    if (i[h + 80 >> 2] = v + (C << 2), i[h + 76 >> 2] = V, i[h + 72 >> 2] = k, !y) break o;
                                                                    X(y);
                                                                }
                                                                if (i[h + 76 >> 2] = V, H) break t;
                                                                f = i[M + 24 >> 2], k = i[M + 28 >> 2];
                                                                o: {
                                                                    if ((f | 0) != (k | 0)) for(;;){
                                                                        s: {
                                                                            if (v = i[f >> 2], !v || (H = E0(v, 73632, 75648), !H)) break s;
                                                                            if (f = i[f + 4 >> 2], !f) {
                                                                                f = 0;
                                                                                break o;
                                                                            }
                                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                                                            break o;
                                                                        }
                                                                        if (f = f + 8 | 0, (k | 0) == (f | 0)) break;
                                                                    }
                                                                    f = 0, H = 0;
                                                                }
                                                                o: {
                                                                    if (!w || (k = i[w + 4 >> 2], i[w + 4 >> 2] = k - 1, k)) break o;
                                                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                                                }
                                                                w = f;
                                                            }
                                                            if (o[h + 71 | 0] >= 0) break n;
                                                            X(i[h + 60 >> 2]);
                                                        }
                                                        f = i[h + 48 >> 2];
                                                        n: {
                                                            if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break n;
                                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        }
                                                        n: {
                                                            if (!_ || (f = i[_ + 4 >> 2], i[_ + 4 >> 2] = f - 1, f)) break n;
                                                            p[i[i[_ >> 2] + 8 >> 2]](_), g(_);
                                                        }
                                                        if (!S) {
                                                            if (e = e + 1 | 0, (T | 0) == (e | 0)) break k;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    k = 0;
                                                    break f;
                                                }
                                                f = YA(E, 1735551332), k = D(448), i[k >> 2] = 82988, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, v = L8(k + 16 | 0, F, f), i[v >> 2] = 83148, i[k + 404 >> 2] = 0, i[k + 408 >> 2] = 0, i[k + 396 >> 2] = 0, i[k + 400 >> 2] = 0, i[k + 388 >> 2] = 0, i[k + 392 >> 2] = 0, NA(k + 412 | 0), i[h + 48 >> 2] = k, i[h + 44 >> 2] = v, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, Oe(F, f, h + 44 | 0), e = i[h + 48 >> 2];
                                                k: {
                                                    if (!e || (_ = i[e + 4 >> 2], i[e + 4 >> 2] = _ - 1, _)) break k;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                x8(E, f, h + 84 | 0, 1), J4(E, f, 1684630887, h + 72 | 0), e = D(128), i[e >> 2] = 76576, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, f = e + 16 | 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 16 >> 2] = 73428, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 72 >> 2] = -1, i[e + 76 >> 2] = -1, i[e + 80 >> 2] = -1, i[e + 84 >> 2] = -1, i[e + 116 >> 2] = 0, i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, Q[e + 112 >> 1] = 0, i[e + 16 >> 2] = 74528, i[e + 124 >> 2] = W, i[e + 120 >> 2] = t, i[e + 32 >> 2] = 1769173093, i[h + 32 >> 2] = e, i[h + 28 >> 2] = f, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, f = i[h + 32 >> 2], i[h + 8 >> 2] = i[h + 28 >> 2], i[h + 12 >> 2] = f, Zi(v, h + 8 | 0, 0), i[h + 24 >> 2] = w, i[h + 20 >> 2] = H, w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1), f = i[h + 24 >> 2], i[h >> 2] = i[h + 20 >> 2], i[h + 4 >> 2] = f, Zi(v, h, 1), S3(E, i[i[n >> 2] + 4 >> 2], l[k + 224 | 0]), i[B + 4 >> 2] = k, i[B >> 2] = v, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, f = i[21669], i[B + 8 >> 2] = i[21668], i[B + 12 >> 2] = f, f = B + 16 | 0;
                                                k: {
                                                    if (o[86691] >= 0) {
                                                        n = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = n, i[f + 8 >> 2] = i[21672];
                                                        break k;
                                                    }
                                                    j(f, i[21670], i[21671]);
                                                }
                                                if (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f) break f;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            f: {
                                                if (!w || (e = i[w + 4 >> 2], i[w + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                            }
                                            e = i[h + 72 >> 2], e && (i[h + 76 >> 2] = e, X(e));
                                            f: {
                                                if (!G || (e = i[G + 4 >> 2], i[G + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[G >> 2] + 8 >> 2]](G), g(G);
                                            }
                                            e = i[h + 84 >> 2], e && (i[h + 88 >> 2] = e, X(e));
                                            f: {
                                                if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                            }
                                            m = h + 96 | 0;
                                            break e;
                                        }
                                        p0(), z();
                                    }
                                    Z2(), z();
                                }
                                e: {
                                    if (i[s + 16 >> 2]) {
                                        j0(A, s + 16 | 0, i[r >> 2]);
                                        break e;
                                    }
                                    f = i[s + 8 >> 2], e = i[s + 12 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[s + 40 >> 2] = e, i[s + 36 >> 2] = f, e = i[r >> 2], i[e + 40 >> 2] || V3(e, s + 36 | 0);
                                    r: {
                                        if (!u) break r;
                                        if (e = D(16), i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[u >> 2] = e, f = i[s + 36 >> 2], k = i[s + 40 >> 2], i[s + 36 >> 2] = 0, i[s + 40 >> 2] = 0, i[e >> 2] = f, i[e + 4 >> 2] = k, k = i[r >> 2], f = i[r + 4 >> 2], !f) {
                                            i[e + 12 >> 2] = f, i[e + 8 >> 2] = k;
                                            break r;
                                        }
                                        if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, i[e + 8 >> 2] = k, r = i[e + 12 >> 2], i[e + 12 >> 2] = f, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                o[s + 35 | 0] < 0 && X(i[s + 24 >> 2]), A = i[s + 12 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = i[s + 40 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[s + 44 >> 2], !A) break i;
                                if (t = i[s + 48 >> 2], w = A, (t | 0) != (w | 0)) {
                                    for(;;){
                                        r = i[t - 4 >> 2];
                                        e: {
                                            if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break e;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (t = t - 8 | 0, (A | 0) == (t | 0)) break;
                                    }
                                    w = i[s + 44 >> 2];
                                }
                                i[s + 48 >> 2] = A, X(w);
                            }
                            m = s + 144 | 0;
                        }
                        function E7() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            i: {
                                if (M = Q2(11296), M) for(r = B0(M, 255, 11296), A = r + 1056 | 0, i[26028] = A, i[26024] = A, i[26023] = r + 992, i[26022] = r + 928, i[26021] = r + 864, i[26020] = r + 800, i[26019] = r + 736, i[26018] = r + 672, i[26017] = r + 608, i[26016] = r + 544, i[26015] = r + 480, i[26014] = r + 416, i[26013] = r + 352, i[26012] = r + 288, i[26011] = r + 224, i[26010] = r + 160, i[26009] = r + 96, i[26008] = r + 32, A = r + 16 | 0, i[26007] = A, i[26006] = A, i[26005] = A, i[26004] = A, i[26003] = A, i[26002] = A, i[26001] = A, i[26e3] = A, i[25999] = r, i[25998] = r, i[25997] = r, i[25996] = r, i[25995] = r, i[25994] = r, i[25993] = r, i[25992] = r, A = r + 1312 | 0, i[26029] = A, i[26025] = A, A = r + 1568 | 0, i[26030] = A, i[26026] = A, A = r + 2080 | 0, i[26036] = A, i[26032] = A, A = r + 1824 | 0, i[26031] = A, i[26027] = A, A = r + 2336 | 0, i[26037] = A, i[26033] = A, A = r + 2592 | 0, i[26038] = A, i[26034] = A, A = r + 3104 | 0, i[26044] = A, i[26040] = A, A = r + 2848 | 0, i[26039] = A, i[26035] = A, A = r + 4128 | 0, i[26045] = A, i[26041] = A, A = r + 5152 | 0, i[26046] = A, i[26042] = A, A = r + 7200 | 0, i[26052] = A, i[26048] = A, A = r + 6176 | 0, i[26047] = A, i[26043] = A, A = r + 8224 | 0, i[26053] = A, i[26049] = A, A = r + 9248 | 0, i[26054] = A, i[26050] = A, r = r + 10272 | 0, i[26055] = r, i[26051] = r, v = 2;;){
                                    E = v - 2 | 0, u = 1 << v;
                                    e: {
                                        if ((v | 0) != 2) {
                                            for(C = (v | 0) == 3, w = C ? 11 : 14, R = 0, r = 1;;){
                                                for(W = 1, A = 0;;){
                                                    for(V = ((E << 6) + (R << 5) | 0) + (A << 4) | 0, B = V + 103968 | 0, y = W & 1 ? 9 : 15, s = 0;;){
                                                        for(F = s & 3, n = s << v, A = 0;;){
                                                            f = A | s, e = 0;
                                                            r: {
                                                                if (!f) break r;
                                                                if (e = F + (A & 3) | 0, h = e >>> 0 <= 2 ? e ? 1 : 2 : 0, r) {
                                                                    if (h = f >>> 0 < 4 ? h : h + 3 | 0, e = h + y | 0, (v | 0) == 3) break r;
                                                                    e = h + 21 | 0;
                                                                    break r;
                                                                }
                                                                if (e = h + 9 | 0, (v | 0) == 3) break r;
                                                                e = h | 12;
                                                            }
                                                            if (h = n + (i[B >> 2] + A | 0) | 0, f = l[h | 0], e = r ? e : e + 27 | 0, (f | 0) != 255 & (e | 0) != (f | 0)) break i;
                                                            if (o[h | 0] = e, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (s = s + 1 | 0, (s | 0) == (u | 0)) break;
                                                    }
                                                    for(n = V + 103972 | 0, s = 0;;){
                                                        for(A = s & 3, h = A ? (A | 0) == 1 : 2, f = C ? h + 9 | 0 : h | 12, t = h + 3 | 0, k = s << v, A = 0;;){
                                                            B = A | s, e = B ? f : 0, F = !r;
                                                            r: {
                                                                if (F | !B) break r;
                                                                if (e = B >>> 0 < 4 ? h : t, !C) {
                                                                    e = e + 21 | 0;
                                                                    break r;
                                                                }
                                                                e = e + y | 0;
                                                            }
                                                            if (B = k + (i[n >> 2] + A | 0) | 0, _ = l[B | 0], e = r ? e : e + 27 | 0, (_ | 0) != 255 & (e | 0) != (_ | 0)) break i;
                                                            if (o[B | 0] = e, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (s = s + 1 | 0, (s | 0) == (u | 0)) break;
                                                    }
                                                    for(B = V + 103976 | 0, s = 0;;){
                                                        for(n = s << v, A = 0;;){
                                                            f = A | s, e = 0;
                                                            r: {
                                                                if (!f) break r;
                                                                if (e = A & 3, h = e ? (e | 0) == 1 : 2, !r) {
                                                                    if (e = h | 12, !C) break r;
                                                                    e = h + 9 | 0;
                                                                    break r;
                                                                }
                                                                if (h = f >>> 0 < 4 ? h : h + 3 | 0, e = h + 21 | 0, !C) break r;
                                                                e = h + y | 0;
                                                            }
                                                            if (h = n + (i[B >> 2] + A | 0) | 0, f = l[h | 0], e = r ? e : e + 27 | 0, (f | 0) != 255 & (e | 0) != (f | 0)) break i;
                                                            if (o[h | 0] = e, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (s = s + 1 | 0, (s | 0) == (u | 0)) break;
                                                    }
                                                    for(V = V + 103980 | 0, s = 0;;){
                                                        for(B = s << v, A = 0;;){
                                                            h = A | s, e = h ? w : 0;
                                                            r: {
                                                                if (F | !h) break r;
                                                                if (e = h >>> 0 < 4 ? 2 : 5, !C) {
                                                                    e = e + 21 | 0;
                                                                    break r;
                                                                }
                                                                e = e + y | 0;
                                                            }
                                                            if (h = B + (i[V >> 2] + A | 0) | 0, n = l[h | 0], e = r ? e : e + 27 | 0, (n | 0) != 255 & (e | 0) != (n | 0)) break i;
                                                            if (o[h | 0] = e, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (s = s + 1 | 0, (s | 0) == (u | 0)) break;
                                                    }
                                                    if (A = 1, e = W & 1, W = 0, !e) break;
                                                }
                                                if (R = 1, A = r, r = 0, !A) break;
                                            }
                                            break e;
                                        }
                                        for(s = E << 6, C = s + 103996 | 0, y = s + 103992 | 0, h = s + 103988 | 0, V = s + 103984 | 0, E = s + 103980 | 0, R = s + 103976 | 0, B = s + 103972 | 0, F = s + 103968 | 0, W = 0;;){
                                            r = 0;
                                            r: {
                                                if (W) {
                                                    for(e = s + (W << 5) | 0, w = e + 103968 | 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103972 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103976 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103980 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103984 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103988 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(w = e + 103992 | 0, r = 0;;){
                                                        for(n = r << 2, f = r << v, A = 0;;){
                                                            if (t = f + (i[w >> 2] + A | 0) | 0, k = l[t | 0], G = (k | 0) != 255, _ = k, k = l[(A + n | 0) + 51104 | 0] + 27 | 0, G & (_ | 0) != (k | 0)) break i;
                                                            if (o[t | 0] = k, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    for(e = e + 103996 | 0, r = 0;;){
                                                        for(w = r << 2, n = r << v, A = 0;;){
                                                            if (f = n + (i[e >> 2] + A | 0) | 0, t = l[f | 0], _ = (t | 0) != 255, k = t, t = l[(A + w | 0) + 51104 | 0] + 27 | 0, _ & (k | 0) != (t | 0)) break i;
                                                            if (o[f | 0] = t, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                        }
                                                        if (r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                    }
                                                    break r;
                                                }
                                                for(;;){
                                                    for(e = r << 2, w = r << v, A = 0;;){
                                                        if (n = w + (i[F >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + e | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (e = 0, r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                }
                                                for(;;){
                                                    for(r = e << 2, w = e << v, A = 0;;){
                                                        if (n = w + (i[B >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + r | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (r = 0, e = e + 1 | 0, (u | 0) == (e | 0)) break;
                                                }
                                                for(;;){
                                                    for(e = r << 2, w = r << v, A = 0;;){
                                                        if (n = w + (i[R >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + e | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (e = 0, r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                }
                                                for(;;){
                                                    for(r = e << 2, w = e << v, A = 0;;){
                                                        if (n = w + (i[E >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + r | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (r = 0, e = e + 1 | 0, (u | 0) == (e | 0)) break;
                                                }
                                                for(;;){
                                                    for(e = r << 2, w = r << v, A = 0;;){
                                                        if (n = w + (i[V >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + e | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (e = 0, r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                }
                                                for(;;){
                                                    for(r = e << 2, w = e << v, A = 0;;){
                                                        if (n = w + (i[h >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + r | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (r = 0, e = e + 1 | 0, (u | 0) == (e | 0)) break;
                                                }
                                                for(;;){
                                                    for(e = r << 2, w = r << v, A = 0;;){
                                                        if (n = w + (i[y >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + e | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (e = 0, r = r + 1 | 0, (u | 0) == (r | 0)) break;
                                                }
                                                for(;;){
                                                    for(r = e << 2, w = e << v, A = 0;;){
                                                        if (n = w + (i[C >> 2] + A | 0) | 0, f = l[n | 0], t = (f | 0) != 255, k = f, f = l[(A + r | 0) + 51104 | 0], t & (k | 0) != (f | 0)) break i;
                                                        if (o[n | 0] = f, A = A + 1 | 0, (u | 0) == (A | 0)) break;
                                                    }
                                                    if (e = e + 1 | 0, (u | 0) == (e | 0)) break;
                                                }
                                            }
                                            if (W = W + 1 | 0, (W | 0) == 2) break;
                                        }
                                    }
                                    if (v = v + 1 | 0, (v | 0) == 6) break;
                                }
                                return (M | 0) != 0;
                            }
                            y0(14717, 15050, 2114, 11114), z();
                        }
                        function Yh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            f = m - 192 | 0, m = f, i[f + 92 >> 2] = 60132, n = i[15036], i[f + 36 >> 2] = n, _ = f + 36 | 0, i[_ + i[n - 12 >> 2] >> 2] = i[15037], n = _ + i[i[f + 36 >> 2] - 12 >> 2] | 0, k = f + 40 | 0, T0(n, k), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[f + 92 >> 2] = 60132, i[f + 36 >> 2] = 60112, B = z0(k), i[B >> 2] = 58864, i[f + 80 >> 2] = 0, i[f + 84 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 76 >> 2] = 0, i[f + 88 >> 2] = 16, w = f + 180 | 0, k = w, u = m - 160 | 0, m = u, i[u + 68 >> 2] = 60132, n = i[15036], i[u + 12 >> 2] = n, t = u + 12 | 0, i[t + i[n - 12 >> 2] >> 2] = i[15037], n = t + i[i[u + 12 >> 2] - 12 >> 2] | 0, h = u + 16 | 0, T0(n, h), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[u + 68 >> 2] = 60132, i[u + 12 >> 2] = 60112, h = z0(h), i[h >> 2] = 58864, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 48 >> 2] = 0, i[u + 52 >> 2] = 0, i[u + 64 >> 2] = 16, s = u + 148 | 0, n = r, D2(s, r, e), v = t, r = o[u + 159 | 0], t = (r | 0) < 0, U(v, t ? i[u + 148 >> 2] : s, t ? i[u + 152 >> 2] : r), o[u + 159 | 0] < 0 && X(i[u + 148 >> 2]), r = u + 148 | 0, G0(r, e), s = r, r = o[u + 159 | 0], t = (r | 0) < 0, U(u + 12 | 0, t ? i[u + 148 >> 2] : s, t ? i[u + 152 >> 2] : r), o[u + 159 | 0] < 0 && X(i[u + 148 >> 2]), r = U(P0(U(u + 12 | 0, 23740, 9), l[n + 97 | 0]), 34895, 1), t = u + 148 | 0, G0(t, e), v = t, t = o[u + 159 | 0], s = (t | 0) < 0, U(r, s ? i[u + 148 >> 2] : v, s ? i[u + 152 >> 2] : t), o[u + 159 | 0] < 0 && X(i[u + 148 >> 2]), r = U(r, 23300, 7), t = i[i[r >> 2] - 12 >> 2] + r | 0, i[t + 4 >> 2] = i[t + 4 >> 2] & -75 | 8, U(M0(r, i[n + 100 >> 2]), 34895, 1), r = i[u + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[u + 60 >> 2], t = i[u + 40 >> 2], r >>> 0 < t >>> 0 && (i[u + 60 >> 2] = t, r = t), t = u + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[k + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[u + 32 >> 2], t = u + 24 | 0;
                                }
                                e: {
                                    if (s = i[t >> 2], r = r - s | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            v = (r | 7) + 1 | 0, t = D(v), i[k + 8 >> 2] = v | -2147483648, i[k >> 2] = t, i[k + 4 >> 2] = r, k = t;
                                            break e;
                                        }
                                        if (o[k + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(k, s, r);
                            }
                            if (o[r + k | 0] = 0, r = i[15035], i[u + 12 >> 2] = r, i[i[r - 12 >> 2] + (u + 12 | 0) >> 2] = i[15038], i[h >> 2] = 58864, o[u + 59 | 0] < 0 && X(i[u + 48 >> 2]), x0(h), N0(u + 68 | 0), m = u + 160 | 0, r = o[f + 191 | 0], k = (r | 0) < 0, U(_, k ? i[f + 180 >> 2] : w, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = f + 180 | 0, G0(r, e), t = r, r = o[f + 191 | 0], k = (r | 0) < 0, U(f + 36 | 0, k ? i[f + 180 >> 2] : t, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = f + 36 | 0, U(P0(U(r, 24143, 17), l[n + 104 | 0] + 1 | 0), 34895, 1), l[n + 105 | 0] == 1 && (k = f + 180 | 0, G0(k, e), t = r, s = k, r = o[f + 191 | 0], k = (r | 0) < 0, U(t, k ? i[f + 180 >> 2] : s, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(M0(U(f + 36 | 0, 22805, 11), I[n + 106 >> 1]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(r, 23116, 15), l[n + 108 | 0]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), k = U(r, 24267, 21), r = l[n + 109 | 0], r = (r | 0) == 1 ? 3396 : (r | 0) == 2 ? 5866 : 6575, r = U(U(k, r, E2(r)), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), k = U(r, 22992, 15), r = i[(l[n + 110 | 0] << 2) + 81920 >> 2], r = U(U(k, r, E2(r)), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(r, 23886, 11), l[n + 111 | 0] + 8 | 0), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(M0(U(r, 25157, 20), I[n + 168 >> 1]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), U(M0(U(r, 22924, 20), I[n + 170 >> 1]), 34895, 1), r = f + 180 | 0, G0(r, e), t = r, r = o[f + 191 | 0], k = (r | 0) < 0, U(f + 36 | 0, k ? i[f + 180 >> 2] : t, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(f + 36 | 0, 24508, 17), l[n + 113 | 0]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(r, 24068, 11), l[n + 114 | 0]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(r, 17480, 14), l[n + 115 | 0]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = U(P0(U(r, 24035, 32), l[n + 116 | 0]), 34895, 1), k = f + 180 | 0, G0(k, e), s = k, k = o[f + 191 | 0], t = (k | 0) < 0, U(r, t ? i[f + 180 >> 2] : s, t ? i[f + 184 >> 2] : k), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), U(P0(U(r, 24080, 30), l[n + 117 | 0]), 34895, 1)), r = f + 180 | 0, G0(r, e), t = r, r = o[f + 191 | 0], k = (r | 0) < 0, U(f + 36 | 0, k ? i[f + 180 >> 2] : t, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), r = f + 36 | 0, U(M0(U(r, 23024, 15), i[n + 180 >> 2] - i[n + 176 >> 2] >> 4), 34895, 1), k = f + 180 | 0, G0(k, e), t = r, s = k, r = o[f + 191 | 0], k = (r | 0) < 0, U(t, k ? i[f + 180 >> 2] : s, k ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), U(f + 36 | 0, 34103, 13), k = i[n + 176 >> 2], G = i[n + 180 >> 2], (k | 0) != (G | 0)) for(r = i[e >> 2];;){
                                i[e >> 2] = r + 1, r = f + 180 | 0, G0(r, e), t = r, r = o[f + 191 | 0], n = (r | 0) < 0, U(f + 36 | 0, n ? i[f + 180 >> 2] : t, n ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), t = U(P0(U(f + 36 | 0, 24458, 10), l[k + 1 | 0]), 21010, 2), r = l[k + 1 | 0] - 12 & 255, r >>> 0 > 7 ? r = 16726 : r = i[(r << 2) + 82008 >> 2], U(U(t, r, E2(r)), 34894, 2), r = f + 180 | 0, G0(r, e), t = r, r = o[f + 191 | 0], n = (r | 0) < 0, U(f + 36 | 0, n ? i[f + 180 >> 2] : t, n ? i[f + 184 >> 2] : r), o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), U(P0(U(f + 36 | 0, 23095, 20), l[k | 0]), 34895, 1);
                                i: {
                                    if (r = i[k + 4 >> 2], W = i[k + 8 >> 2], (r | 0) == (W | 0)) break i;
                                    for(;;){
                                        e: {
                                            i[e >> 2] = i[e >> 2] + 1, n = f + 24 | 0, G0(n, e), t = i[r >> 2], w5(f + 12 | 0, t, i[r + 4 >> 2] - t | 0, n, n), h = o[f + 23 | 0], s = i[f + 12 >> 2], v = i[f + 16 >> 2], n = f + 36 | 0, C = C1(f + 172 | 0, n);
                                            r: {
                                                if (l[C | 0] != 1) break r;
                                                u = n + i[i[f + 36 >> 2] - 12 >> 2] | 0, y = i[u + 4 >> 2], t = i[u + 24 >> 2], _ = i[u + 76 >> 2], (_ | 0) == -1 && (w = f + 180 | 0, n = i[u + 28 >> 2], i[w >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = K0(w, 108580), _ = p[i[i[n >> 2] + 28 >> 2]](n, 32) | 0, d0(w), i[u + 76 >> 2] = _);
                                                A: {
                                                    if (!t || (w = i[u + 12 >> 2], n = s, s = (h | 0) < 0, n = s ? n : f + 12 | 0, h = s ? v : h, V = n + h | 0, s = (y & 176) == 32 ? V : n, v = s - n | 0, (v | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, n, v) | 0) != (v | 0))) break A;
                                                    if (n = (h | 0) < (w | 0) ? w - h | 0 : 0, (n | 0) > 0) {
                                                        if (n >>> 0 >= 2147483640) break e;
                                                        f: {
                                                            if (n >>> 0 >= 11) {
                                                                w = (n | 7) + 1 | 0, h = D(w), i[f + 188 >> 2] = w | -2147483648, i[f + 180 >> 2] = h, i[f + 184 >> 2] = n;
                                                                break f;
                                                            }
                                                            o[f + 191 | 0] = n, h = f + 180 | 0;
                                                        }
                                                        if (F = B0(h, _, n) + n | 0, E = 0, o[F | 0] = E, _ = p[i[i[t >> 2] + 48 >> 2]](t, o[f + 191 | 0] < 0 ? i[f + 180 >> 2] : f + 180 | 0, n) | 0, o[f + 191 | 0] < 0 && X(i[f + 180 >> 2]), (n | 0) != (_ | 0)) break A;
                                                    }
                                                    if (n = V - s | 0, (n | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, s, n) | 0) != (n | 0)) break A;
                                                    i[u + 12 >> 2] = 0;
                                                    break r;
                                                }
                                                n = i[i[f + 36 >> 2] - 12 >> 2] + (f + 36 | 0) | 0, N1(n, i[n + 16 >> 2] | 5);
                                            }
                                            if (G1(C), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), n = i[e >> 2], i[e >> 2] = (n | 0) > 0 ? n - 1 | 0 : 0, o[f + 35 | 0] < 0 && X(i[f + 24 >> 2]), r = r + 12 | 0, (W | 0) != (r | 0)) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    Y0(), z();
                                }
                                if (r = i[e >> 2], r = (r | 0) > 0 ? r - 1 | 0 : 0, i[e >> 2] = r, k = k + 16 | 0, (G | 0) == (k | 0)) break;
                            }
                            r = i[f + 88 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 84 >> 2], r = i[f + 64 >> 2], e >>> 0 < r >>> 0 && (i[f + 84 >> 2] = r, e = r), r = f + 60 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 56 >> 2], r = f + 48 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 36 >> 2] = A, i[i[A - 12 >> 2] + (f + 36 | 0) >> 2] = i[15038], i[B >> 2] = 58864, o[f + 83 | 0] < 0 && X(i[f + 72 >> 2]), x0(B), N0(f + 92 | 0), m = f + 192 | 0;
                        }
                        function Eh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            r = m - 128 | 0, m = r, i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, i[r + 112 >> 2] = 0, i[r + 116 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, o[r + 92 | 0] = 0, o[r + 93 | 0] = 0, o[r + 94 | 0] = 0, o[r + 95 | 0] = 0, o[r + 85 | 0] = 0, o[r + 86 | 0] = 0, o[r + 87 | 0] = 0, o[r + 88 | 0] = 0, o[r + 89 | 0] = 0, o[r + 90 | 0] = 0, o[r + 91 | 0] = 0, o[r + 92 | 0] = 0, o[r + 84 | 0] = 1, k = r - -64 | 0, t = S0(i[e >> 2], 0), u = i[i[e >> 2] + 36 >> 2], s = (t | 0) < 11, h = s && (u | 0) == 3 ? 1 : 2, _ = s ? u >>> 0 >= 2 ? h : 0 : h, s = T4(i[e >> 2], 0), h = S4(i[e >> 2], 0), v = Z(s, h);
                            i: {
                                if (!((s | 0) > 8192 | (h | 0) > 4352) && (w = 13, (v | 0) < 8912897)) break i;
                                w = (s | 0) >= 16385 || (h | 0) >= 8705 ? 31 : (v | 0) < 35651585 ? 17 : 31;
                            }
                            o[r + 86 | 0] = w, o[r + 85 | 0] = _, o[r + 90 | 0] = !u, o[r + 89 | 0] = t >>> 0 > 11, o[r + 88 | 0] = t >>> 0 > 8, t = u << 3, s = u >>> 0 < 4, o[r + 91 | 0] = ((s ? 16908801 >>> t | 0 : 0) & 3) >>> 1, o[r + 93 | 0] = ((u | 0) != 1) << 1, o[r + 92 | 0] = ((s ? 16843265 >>> t | 0 : 0) & 3) >>> 1, u = i[21669], i[k >> 2] = i[21668], i[k + 4 >> 2] = u, k = k + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    u = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = u, i[k + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(k, i[21670], i[21671]);
                            }
                            o[r + 83 | 0] < 0 && X(i[r + 72 >> 2]), i[r + 60 >> 2] = 0, u = i[e >> 2], k = i[e + 4 >> 2];
                            i: {
                                if (!k) {
                                    i[r + 60 >> 2] = 0, i[r + 56 >> 2] = u;
                                    break i;
                                }
                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, i[r + 56 >> 2] = u, e = i[r + 60 >> 2], i[r + 60 >> 2] = k, !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            p[i[i[f >> 2] + 100 >> 2]](r + 44 | 0, i[f + 4 >> 2], r + 56 | 0, n);
                            i: {
                                e: {
                                    r: {
                                        if (k = i[r + 44 >> 2], !k) for(;;){
                                            p[i[i[f >> 2] + 104 >> 2]](r + 24 | 0, i[f + 4 >> 2], r + 12 | 0, r + 8 | 0, 0), n = r + 84 | 0, k = 0, v = m - 48 | 0, m = v, t = wi(v + 16 | 0, i[r + 12 >> 2], i[r + 8 >> 2]), e = i[t + 8 >> 2], u = e >> 31 << 3 | e >>> 29, s = i[t + 24 >> 2], e = s + (e << 3) | 0, h = (s >> 31) + u | 0, h = e >>> 0 < s >>> 0 ? h + 1 | 0 : h;
                                            A: {
                                                if (!e & (h | 0) <= 0 | (h | 0) < 0) break A;
                                                f: {
                                                    for(;;){
                                                        if (C2(t, 1), w = $0(t, 4), e = $0(t, 1), u = $0(t, 1), C2(t, 1), e && C2(t, 8), u) {
                                                            e = $0(t, 8), u = e & 127, s = 0;
                                                            k: {
                                                                if (!(e & 128) || (e = $0(t, 8), u = u | e << 7 & 16256, !(e & 128)) || (e = $0(t, 8), u = u | e << 14 & 2080768, !(e & 128)) || (e = $0(t, 8), u = u | e << 21 & 266338304, !(e & 128)) || (e = $0(t, 8), h = e >>> 4 | 0, u = u | e << 28 & -268435456, s = s | h & 7, !(e & 128)) || (e = $0(t, 8), s = s | e << 3 & 1016, !(e & 128)) || (e = $0(t, 8), s = s | e << 10 & 130048, !(e & 128))) break k;
                                                                s = s | $0(t, 8) << 17 & 16646144;
                                                            }
                                                            if ((w | 0) == 1) break f;
                                                            if (!s & u >>> 0 > 2147483647 | s) break A;
                                                            if (Jn(t, u), e = i[t + 24 >> 2], u = e, s = e >> 31, e = i[t + 8 >> 2], h = e >> 31 << 3 | e >>> 29, w = e << 3, u = w + u | 0, e = s + h | 0, e = u >>> 0 < w >>> 0 ? e + 1 | 0 : e, !!u & (e | 0) >= 0 | (e | 0) > 0) continue;
                                                            break A;
                                                        }
                                                        break;
                                                    }
                                                    if ((w | 0) != 1) break A;
                                                }
                                                B = n, G = $0(t, 3), o[B + 1 | 0] = G, $0(t, 1), w = $0(t, 1);
                                                f: {
                                                    if (w) {
                                                        e = $0(t, 5), o[n + 3 | 0] = 0, o[n + 2 | 0] = e;
                                                        break f;
                                                    }
                                                    k: {
                                                        n: {
                                                            if (!$0(t, 1) || (Jn(t, 8), $0(t, 1) && R1(t, v + 12 | 0), !$0(t, 1))) break n;
                                                            k = $0(t, 5), C2(t, 32), C2(t, 10), u = 1;
                                                            break k;
                                                        }
                                                        u = 0;
                                                    }
                                                    if (_ = $0(t, 1), h = $0(t, 5), (h | 0) < 0) break f;
                                                    if (C2(t, 12), e = $0(t, 5), o[n + 2 | 0] = e, s = k + 1 | 0, e = e & 248, !_) {
                                                        e && (B = n, G = $0(t, 1), o[B + 3 | 0] = G);
                                                        k: {
                                                            if (!u || !$0(t, 1)) break k;
                                                            C2(t, s), C2(t, s), C2(t, 1);
                                                        }
                                                        if (!h) break f;
                                                        for(e = 1;;){
                                                            C2(t, 12), $0(t, 5) & 248 && $0(t, 1), k = e;
                                                            k: {
                                                                if (!u || !$0(t, 1)) break k;
                                                                C2(t, s), C2(t, s), C2(t, 1);
                                                            }
                                                            if (e = k + 1 | 0, (k | 0) == (h | 0)) break;
                                                        }
                                                        break f;
                                                    }
                                                    if (!u) {
                                                        if (e && (B = n, G = $0(t, 1), o[B + 3 | 0] = G), k = 1, e = $0(t, 1), o[n + 10 | 0] = (e | 0) != 0, e && (B = n, G = $0(t, 4), o[B + 11 | 0] = G), !h) break f;
                                                        for(; C2(t, 12), $0(t, 5) & 248 && $0(t, 1), $0(t, 1) && $0(t, 4), e = (k | 0) != (h | 0), k = k + 1 | 0, !!e;);
                                                        break f;
                                                    }
                                                    if (e && (B = n, G = $0(t, 1), o[B + 3 | 0] = G), $0(t, 1) && (C2(t, s), C2(t, s), C2(t, 1)), e = $0(t, 1), o[n + 10 | 0] = (e | 0) != 0, e && (B = n, G = $0(t, 4), o[B + 11 | 0] = G), !h) break f;
                                                    for(k = 1; C2(t, 12), $0(t, 5) & 248 && $0(t, 1), $0(t, 1) && (C2(t, s), C2(t, s), C2(t, 1)), $0(t, 1) && $0(t, 4), e = (k | 0) == (h | 0), k = k + 1 | 0, !e;);
                                                }
                                                e = $0(t, 4), k = $0(t, 4), $0(t, e + 1 | 0), $0(t, k + 1 | 0);
                                                f: {
                                                    if (!w) {
                                                        $0(t, 1) && C2(t, 7), C2(t, 3), C2(t, 4), e = $0(t, 1), e && C2(t, 2);
                                                        k: {
                                                            if (!$0(t, 1) && ($0(t, 1) | 0) <= 0 || $0(t, 1)) break k;
                                                            C2(t, 1);
                                                        }
                                                        if (!e) break f;
                                                    }
                                                    C2(t, 3);
                                                }
                                                C2(t, 3), e = $0(t, 1), o[n + 4 | 0] = e, u = l[n + 1 | 0], k = 0;
                                                f: {
                                                    if (!(e & 255)) {
                                                        e = 0;
                                                        break f;
                                                    }
                                                    if (e = 0, (u | 0) != 2) break f;
                                                    e = $0(t, 1), u = l[n + 1 | 0];
                                                }
                                                o[n + 5 | 0] = e, (u | 0) != 1 ? e = $0(t, 1) : e = 0, o[n + 6 | 0] = e;
                                                f: {
                                                    if (!$0(t, 1)) {
                                                        u = 0, e = 0;
                                                        break f;
                                                    }
                                                    u = ($0(t, 8) | 0) == 1, k = ($0(t, 8) | 0) == 13, e = !$0(t, 8);
                                                }
                                                f: {
                                                    k: {
                                                        if (l[n + 6 | 0]) {
                                                            C2(t, 1), o[n + 7 | 0] = 1, o[n + 8 | 0] = 1, k = 9, e = 0;
                                                            break k;
                                                        }
                                                        n: {
                                                            if ((e & (k & u)) == 1) break n;
                                                            C2(t, 1);
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        u: switch(l[n + 1 | 0]){
                                                                            default:
                                                                                if (l[n + 5 | 0]) {
                                                                                    if (e = $0(t, 1), o[n + 7 | 0] = e, e & 255) break s;
                                                                                    break t;
                                                                                }
                                                                                o[n + 7 | 0] = 1;
                                                                                break t;
                                                                            case 1:
                                                                                break n;
                                                                            case 0:
                                                                                break u;
                                                                        }
                                                                        o[n + 7 | 0] = 1, o[n + 8 | 0] = 1;
                                                                        break o;
                                                                    }
                                                                    if (e = $0(t, 1), o[n + 8 | 0] = e, !l[n + 7 | 0] | !(e & 255)) break f;
                                                                }
                                                                k = 9, e = $0(t, 2);
                                                                break k;
                                                            }
                                                            k = 8, e = 0;
                                                            break k;
                                                        }
                                                        o[n + 7 | 0] = 0, k = 8, e = 0;
                                                    }
                                                    o[k + n | 0] = e;
                                                }
                                                C2(t, 1);
                                            }
                                            if (m = v + 48 | 0, e = i[r + 12 >> 2], !e) break r;
                                            Gr(r + 96 | 0, e, i[r + 8 >> 2]);
                                        }
                                        if (n = i[r + 48 >> 2], u = i[r + 52 >> 2], f = E2(u), f >>> 0 >= 2147483640) break i;
                                        A: {
                                            f: {
                                                if (f >>> 0 >= 11) {
                                                    t = (f | 7) + 1 | 0, e = D(t), i[r + 20 >> 2] = t | -2147483648, i[r + 12 >> 2] = e, i[r + 16 >> 2] = f;
                                                    break f;
                                                }
                                                if (o[r + 23 | 0] = f, e = r + 12 | 0, !f) break A;
                                            }
                                            Q0(e, u, f);
                                        }
                                        o[e + f | 0] = 0, e = i0(r + 24 | 0, k, n, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                                        A: {
                                            if (o[e + 19 | 0] >= 0) {
                                                f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                break A;
                                            }
                                            if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break A;
                                            X(i[e + 8 >> 2]);
                                        }
                                        if (o[r + 23 | 0] >= 0) break e;
                                        X(i[r + 12 >> 2]);
                                        break e;
                                    }
                                    e = D(144), i[e >> 2] = 76856, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, n = e + 16 | 0, f = n, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 16 >> 2] = 73428, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 72 >> 2] = -1, i[e + 76 >> 2] = -1, i[e + 80 >> 2] = -1, i[e + 84 >> 2] = -1, i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, o[e + 112 | 0] = 0, i[e + 16 >> 2] = 80800, i[e + 136 >> 2] = 0, i[e + 128 >> 2] = 0, i[e + 132 >> 2] = 0, i[e + 32 >> 2] = 1635135811, f = l[r + 88 | 0] | l[r + 89 | 0] << 8 | (l[r + 90 | 0] << 16 | l[r + 91 | 0] << 24), k = l[r + 84 | 0] | l[r + 85 | 0] << 8 | (l[r + 86 | 0] << 16 | l[r + 87 | 0] << 24), o[e + 113 | 0] = k, o[e + 114 | 0] = k >>> 8, o[e + 115 | 0] = k >>> 16, o[e + 116 | 0] = k >>> 24, o[e + 117 | 0] = f, o[e + 118 | 0] = f >>> 8, o[e + 119 | 0] = f >>> 16, o[e + 120 | 0] = f >>> 24, f = l[r + 92 | 0] | l[r + 93 | 0] << 8 | (l[r + 94 | 0] << 16 | l[r + 95 | 0] << 24), o[e + 121 | 0] = f, o[e + 122 | 0] = f >>> 8, o[e + 123 | 0] = f >>> 16, o[e + 124 | 0] = f >>> 24, i[r + 28 >> 2] = e, i[r + 24 >> 2] = n, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, f = i[r + 100 >> 2];
                                    r: {
                                        if (f >>> 0 < k0[r + 104 >> 2]) {
                                            i[f + 4 >> 2] = e, i[f >> 2] = n, i[r + 100 >> 2] = f + 8;
                                            break r;
                                        }
                                        if (B = r, G = p2(r + 96 | 0, r + 24 | 0), i[B + 100 >> 2] = G, f = i[r + 28 >> 2], !f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break r;
                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                    }
                                    if (G6(A, r + 96 | 0), A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                A = i[r + 60 >> 2];
                                e: {
                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[r + 108 >> 2], A && (i[r + 112 >> 2] = A, X(A)), A = i[r + 96 >> 2], A) {
                                    if (e = A, f = i[r + 100 >> 2], (e | 0) != (f | 0)) {
                                        for(;;){
                                            e = i[f - 4 >> 2];
                                            e: {
                                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break e;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            if (f = f - 8 | 0, (A | 0) == (f | 0)) break;
                                        }
                                        e = i[r + 96 >> 2];
                                    }
                                    i[r + 100 >> 2] = A, X(e);
                                }
                                m = r + 128 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function gh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0;
                            u = m - 128 | 0, m = u, n = S0(i[e >> 2], 0), h = S0(i[e >> 2], 1), _ = S0(i[e >> 2], 2), P = A1(i[e >> 2], 6), P && (f0 = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(n >>> 0 < 9 | h >>> 0 < 9) & _ >>> 0 > 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((n | 0) == (h | 0) & (n | 0) == (_ | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                k = i[e >> 2], V = i[k + 48 >> 2], V && (i[V + 4 >> 2] = i[V + 4 >> 2] + 1, k = i[e >> 2]), G = i[k + 28 >> 2], W = i[k + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), k = i[s + 4 >> 2], v = k + 1 | 0, i[s + 4 >> 2] = v, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, f = s, i[f + 124 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 84 >> 2] = 1, i[f + 88 >> 2] = 1, r = f + 76 | 0, i[f + 72 >> 2] = r, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, i[f + 112 >> 2] = 0, o[f + 113 | 0] = 0, o[f + 114 | 0] = 0, o[f + 115 | 0] = 0, o[f + 116 | 0] = 0, o[f + 117 | 0] = 0, o[f + 118 | 0] = 0, o[f + 119 | 0] = 0, o[f + 120 | 0] = 0, C = f + 12 | 0, i[f + 12 >> 2] = C, i[f + 8 >> 2] = i[f + 8 >> 2] + 1, i[f + 4 >> 2] = k, i[f + 16 >> 2] = f, v || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), i[C + 36 >> 2] = 1, i[C + 32 >> 2] = 0, i[C + 28 >> 2] = G, i[C + 24 >> 2] = W, J0(u + 56 | 0, C, 0, W, G, n, t), B = W + 1 >>> 1 | 0, M = G + 1 >>> 1 | 0, J0(u + 32 | 0, C, 1, B, M, h, t), f = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[f >> 2] = i[k >> 2], i[f + 4 >> 2] = n, i[f + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[f >> 2] = i[u + 40 >> 2], i[f + 4 >> 2] = k, i[f + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, C, 2, B, M, _, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[f + 4 >> 2], i[k >> 2] = i[f >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (f = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = f, o[u + 27 | 0] >= 0) {
                                        f = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!P) break r;
                                        if (J0(u + 104 | 0, C, 6, W, G, f0, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    e = i[e >> 2], f = e - -64 | 0;
                                    r: {
                                        A: {
                                            n = i[e + 64 >> 2];
                                            f: {
                                                if (!n) {
                                                    h = 0;
                                                    break f;
                                                }
                                                for(h = f, e = n; k = i[e + 16 >> 2], h = (k | 0) < 0 ? h : e, e = i[(k >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                k: {
                                                    if ((f | 0) == (h | 0) || (e = 0, i[h + 16 >> 2] > 0)) break k;
                                                    L = i[h + 44 >> 2], e = i[h + 52 >> 2];
                                                }
                                                for(q = e, k = f, e = n; t = i[e + 16 >> 2] <= 0, k = t ? k : e, e = i[(t << 2) + e >> 2], !!e;);
                                                h = 0;
                                                k: {
                                                    if ((f | 0) == (k | 0) || (h = 0, i[k + 16 >> 2] > 1)) break k;
                                                    F = i[k + 52 >> 2], h = i[k + 44 >> 2];
                                                }
                                                for(t = f, e = n; k = i[e + 16 >> 2] < 2, t = k ? t : e, e = i[(k << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (t | 0)) break A;
                                            }
                                            _ = 0;
                                            break r;
                                        }
                                        if (_ = 0, i[t + 16 >> 2] > 2) break r;
                                        E = i[t + 52 >> 2], _ = i[t + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (t = i[r >> 2], t) {
                                                for(k = r, e = t; w = i[e + 16 >> 2], k = (w | 0) < 0 ? k : e, e = i[(w >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (e = 0, i[k + 16 >> 2] > 0)) break f;
                                                    m0 = i[k + 44 >> 2], e = i[k + 52 >> 2];
                                                }
                                                for(Z0 = e, k = r, e = t; w = i[e + 16 >> 2] <= 0, k = w ? k : e, e = i[(w << 2) + e >> 2], !!e;);
                                                w = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (w = 0, i[k + 16 >> 2] > 1)) break f;
                                                    H = i[k + 52 >> 2], w = i[k + 44 >> 2];
                                                }
                                                for(k = r, e = t; v = i[e + 16 >> 2] < 2, k = v ? k : e, e = i[(v << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            v = 0;
                                            break r;
                                        }
                                        if (v = 0, i[k + 16 >> 2] > 2) break r;
                                        T = i[k + 52 >> 2], v = i[k + 44 >> 2];
                                    }
                                    k = 0;
                                    r: {
                                        if (!P) break r;
                                        A: {
                                            f: {
                                                if (!n) break f;
                                                for(e = f; k = i[n + 16 >> 2] < 6, e = k ? e : n, n = i[(k << 2) + n >> 2], !!n;);
                                                if ((e | 0) == (f | 0)) break f;
                                                if (f = 0, i[e + 16 >> 2] > 6) break A;
                                                X0 = i[e + 44 >> 2], f = i[e + 52 >> 2];
                                                break A;
                                            }
                                            f = 0;
                                        }
                                        if (V0 = f, k = 0, !t) break r;
                                        for(e = r; f = i[t + 16 >> 2] < 6, e = f ? e : t, t = i[(f << 2) + t >> 2], !!t;);
                                        if (k = 0, (r | 0) == (e | 0) || (k = 0, i[e + 16 >> 2] > 6)) break r;
                                        I0 = i[e + 52 >> 2], k = i[e + 44 >> 2];
                                    }
                                    r = k, T = T >>> 1 | 0, H = H >>> 1 | 0, f = E >>> 1 | 0, t = F >>> 1 | 0;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if ($ = G & 1, $) {
                                                        if (k = W - 1 | 0, !k) break k;
                                                        for(e = G - 1 | 0, n = Z(e, f), F = Z(e, t), e = M - 1 | 0, E = v + (Z(e, T) << 1) | 0, S = (Z(e, H) << 1) + w | 0, e = 0; y = (e + F << 1) + h | 0, Q[e + S >> 1] = (I[y >> 1] + I[y + 2 >> 1] | 0) + 1 >>> 1, y = _ + (e + n << 1) | 0, Q[e + E >> 1] = (I[y >> 1] + I[y + 2 >> 1] | 0) + 1 >>> 1, e = e + 2 | 0, k >>> 0 > e >>> 0;);
                                                    }
                                                    if (W & 1) break k;
                                                    k = G - 1 | 0;
                                                    break f;
                                                }
                                                if (n = B << 1, B = W << 1, k = G - 1 | 0, k) {
                                                    for(S = (n + v | 0) - 2 | 0, F = (_ + B | 0) - 2 | 0, y = (n + w | 0) - 2 | 0, E = (h + B | 0) - 2 | 0, e = 0; R = e >>> 1 | 0, c = e | 1, Q[y + (Z(R, H) << 1) >> 1] = (I[E + (Z(e, t) << 1) >> 1] + I[E + (Z(c, t) << 1) >> 1] | 0) + 1 >>> 1, Q[S + (Z(T, R) << 1) >> 1] = (I[F + (Z(e, f) << 1) >> 1] + I[F + (Z(f, c) << 1) >> 1] | 0) + 1 >>> 1, e = e + 2 | 0, k >>> 0 > e >>> 0;);
                                                    if (!$) break A;
                                                }
                                                e = M - 1 | 0, Q[(n + ((Z(e, H) << 1) + w | 0) | 0) - 2 >> 1] = I[(B + ((Z(k, t) << 1) + h | 0) | 0) - 2 >> 1], Q[(n + (v + (Z(e, T) << 1) | 0) | 0) - 2 >> 1] = I[(B + (_ + (Z(f, k) << 1) | 0) | 0) - 2 >> 1];
                                            }
                                            if (!k) break r;
                                        }
                                        if (B = W - 1 | 0, !B) break r;
                                        for(n = 0;;){
                                            for(M = Z(f, n), F = Z(n, t), e = n | 1, E = Z(e, f), $ = Z(e, t), e = n >>> 1 | 0, S = v + (Z(e, T) << 1) | 0, y = (Z(e, H) << 1) + w | 0, e = 0; R = _ + (e + E << 1) | 0, c = I[R + 2 >> 1], R = I[R >> 1], r0 = _ + (e + M << 1) | 0, F0 = I[r0 >> 1], r0 = I[r0 + 2 >> 1], t0 = (e + $ << 1) + h | 0, s0 = (e + F << 1) + h | 0, Q[e + y >> 1] = ((I[t0 >> 1] + (I[s0 >> 1] + I[s0 + 2 >> 1] | 0) | 0) + I[t0 + 2 >> 1] | 0) + 2 >>> 2, Q[e + S >> 1] = (c + (R + (r0 + F0 | 0) | 0) | 0) + 2 >>> 2, e = e + 2 | 0, B >>> 0 > e >>> 0;);
                                            if (n = n + 2 | 0, !(n >>> 0 < k >>> 0)) break;
                                        }
                                    }
                                    if (G) for(f = Z0 >>> 1 | 0, k = q >>> 1 | 0, n = W << 1, t = f0 >>> 0 > 8 ? n : W, e = 0; v0((Z(e, f) << 1) + m0 | 0, (Z(e, k) << 1) + L | 0, n), P && v0(Z(e, I0) + r | 0, Z(e, V0) + X0 | 0, t), e = e + 1 | 0, (G | 0) != (e | 0););
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = C, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !V || (A = i[V + 4 >> 2], i[V + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[V >> 2] + 8 >> 2]](V), g(V);
                            }
                            m = u + 128 | 0;
                        }
                        function Jh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0;
                            u = m - 128 | 0, m = u, k = S0(i[e >> 2], 0), n = S0(i[e >> 2], 1), w = S0(i[e >> 2], 2), S = A1(i[e >> 2], 6), S && (r0 = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(k >>> 0 < 9 | n >>> 0 < 9) & w >>> 0 > 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((k | 0) == (n | 0) & (k | 0) == (w | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], V = i[f + 48 >> 2], V && (i[V + 4 >> 2] = i[V + 4 >> 2] + 1, f = i[e >> 2]), v = i[f + 28 >> 2], _ = i[f + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), F = i[s + 4 >> 2], h = F + 1 | 0, i[s + 4 >> 2] = h, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, r = s, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, f = r + 76 | 0, i[r + 72 >> 2] = f, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, C = r + 12 | 0, i[r + 12 >> 2] = C, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = F, i[r + 16 >> 2] = r, h || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), i[C + 36 >> 2] = 3, i[C + 32 >> 2] = 0, i[C + 28 >> 2] = v, i[C + 24 >> 2] = _, J0(u + 56 | 0, C, 0, _, v, k, t), J0(u + 32 | 0, C, 1, _, v, n, t), r = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = n, i[r + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(r, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[r >> 2] = i[u + 40 >> 2], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(r, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, C, 2, _, v, w, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[r + 4 >> 2], i[k >> 2] = i[r >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[r + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!S) break r;
                                        if (J0(u + 104 | 0, C, 6, _, v, r0, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], k = r - -64 | 0, w = 0;
                                    r: {
                                        A: {
                                            if (t = i[r + 64 >> 2], t) {
                                                for(r = k, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                H = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (H = 0, i[r + 16 >> 2] > 0)) break f;
                                                    L = i[r + 44 >> 2], H = i[r + 52 >> 2];
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                y = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (y = 0, i[r + 16 >> 2] > 1)) break f;
                                                    B = i[r + 52 >> 2], y = i[r + 44 >> 2];
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[r + 16 >> 2] > 2) break r;
                                        G = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                    }
                                    F = e;
                                    r: {
                                        A: {
                                            if (r = i[f >> 2], r) {
                                                for(n = f, e = r; w = i[e + 16 >> 2], n = (w | 0) < 0 ? n : e, e = i[(w >>> 29 & 4) + e >> 2], !!e;);
                                                T = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (T = 0, i[n + 16 >> 2] > 0)) break f;
                                                    q = i[n + 44 >> 2], T = i[n + 52 >> 2];
                                                }
                                                for(n = f, e = r; w = i[e + 16 >> 2] <= 0, n = w ? n : e, e = i[(w << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 1)) break f;
                                                    E = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                                }
                                                for(w = e, n = f, e = r; h = i[e + 16 >> 2] < 2, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[n + 16 >> 2] > 2) break r;
                                        R = i[n + 52 >> 2] >>> 1 | 0, e = i[n + 44 >> 2];
                                    }
                                    n = e, h = 0;
                                    r: {
                                        if (!S) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = k; h = i[t + 16 >> 2] < 6, e = h ? e : t, t = i[(h << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (k | 0)) break f;
                                                if (P = 0, i[e + 16 >> 2] > 6) break A;
                                                m0 = i[e + 44 >> 2], P = i[e + 52 >> 2];
                                                break A;
                                            }
                                            P = 0;
                                        }
                                        if (h = 0, !r) break r;
                                        for(e = f; k = i[r + 16 >> 2] < 6, e = k ? e : r, r = i[(k << 2) + r >> 2], !!r;);
                                        if (h = 0, (e | 0) == (f | 0) || (h = 0, i[e + 16 >> 2] > 6)) break r;
                                        Z0 = i[e + 52 >> 2], h = i[e + 44 >> 2];
                                    }
                                    f = E >>> 1 | 0, k = G >>> 1 | 0, t = B >>> 1 | 0;
                                    r: {
                                        A: {
                                            f: {
                                                if (v) {
                                                    if (e = 0, (v | 0) != 1) for(G = v & -2, r = 0; Q[(Z(e, f) << 1) + w >> 1] = I[(Z(e, t) << 1) + y >> 1], Q[(Z(e, R) << 1) + n >> 1] = I[(Z(e, k) << 1) + F >> 1], B = e | 1, Q[(Z(B, f) << 1) + w >> 1] = I[(Z(t, B) << 1) + y >> 1], Q[(Z(B, R) << 1) + n >> 1] = I[(Z(k, B) << 1) + F >> 1], e = e + 2 | 0, r = r + 2 | 0, (G | 0) != (r | 0););
                                                    if (v & 1 && (Q[(Z(e, f) << 1) + w >> 1] = I[(Z(e, t) << 1) + y >> 1], Q[(Z(e, R) << 1) + n >> 1] = I[(Z(e, k) << 1) + F >> 1]), !(_ & 1)) break f;
                                                    if (v) break A;
                                                    break r;
                                                }
                                                if (_ & 1) break r;
                                            }
                                            if (!v) break r;
                                            if (r = (_ + F | 0) - 2 | 0, B = (_ + y | 0) - 2 | 0, e = _ << 1, G = (e + n | 0) - 2 | 0, E = (e + w | 0) - 2 | 0, e = 0, (v | 0) != 1) for(c = v & -2; Q[E + (Z(e, f) << 1) >> 1] = I[B + (Z(e, t) << 1) >> 1], Q[G + (Z(e, R) << 1) >> 1] = I[r + (Z(e, k) << 1) >> 1], M = e | 1, Q[E + (Z(M, f) << 1) >> 1] = I[B + (Z(t, M) << 1) >> 1], Q[G + (Z(R, M) << 1) >> 1] = I[r + (Z(k, M) << 1) >> 1], e = e + 2 | 0, $ = $ + 2 | 0, (c | 0) != ($ | 0););
                                            if (!(v & 1)) break A;
                                            Q[E + (Z(e, f) << 1) >> 1] = I[B + (Z(e, t) << 1) >> 1], Q[G + (Z(e, R) << 1) >> 1] = I[r + (Z(e, k) << 1) >> 1];
                                        }
                                        if (E = _ - 1 | 0, E >>> 0 >= 2) for(r = 0;;){
                                            for(M = Z(r, k), c = Z(r, t), $ = (Z(r, R) << 1) + n | 0, X0 = (Z(r, f) << 1) + w | 0, e = 1; W = e >>> 1 | 0, G = (W + M << 1) + F | 0, B = I[G >> 1], G = I[G + 2 >> 1], f0 = e << 1, t0 = f0 + X0 | 0, W = (W + c << 1) + y | 0, s0 = I[W >> 1], W = I[W + 2 >> 1], Q[t0 >> 1] = (Z(s0, 3) + W | 0) + 2 >>> 2, Q[t0 + 2 >> 1] = (Z(W, 3) + s0 | 0) + 2 >>> 2, W = $ + f0 | 0, Q[W + 2 >> 1] = (B + Z(G, 3) | 0) + 2 >>> 2, Q[W >> 1] = (G + Z(B, 3) | 0) + 2 >>> 2, e = e + 2 | 0, E >>> 0 > e >>> 0;);
                                            if (r = r + 1 | 0, (v | 0) == (r | 0)) break;
                                        }
                                        for(r = T >>> 1 | 0, f = H >>> 1 | 0, k = _ << 1, n = r0 >>> 0 > 8 ? k : _, e = 0; v0((Z(r, e) << 1) + q | 0, (Z(e, f) << 1) + L | 0, k), S && v0(Z(e, Z0) + h | 0, Z(e, P) + m0 | 0, n), e = e + 1 | 0, (v | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = C, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !V || (A = i[V + 4 >> 2], i[V + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[V >> 2] + 8 >> 2]](V), g(V);
                            }
                            m = u + 128 | 0;
                        }
                        function Rh(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            for(k = m + -64 | 0, m = k, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, r = i[e >> 2], t = i[e + 4 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[k + 28 >> 2] = t, i[k + 24 >> 2] = r, r = k + 12 | 0, p[i[i[f >> 2] + 100 >> 2]](r, i[f + 4 >> 2], k + 24 | 0, n), p[i[i[f >> 2] + 104 >> 2]](r, i[f + 4 >> 2], k + 8 | 0, k + 4 | 0, 0);;){
                                if (r = i[k + 8 >> 2], r) {
                                    Gr(k + 32 | 0, r, i[k + 4 >> 2]), p[i[i[f >> 2] + 104 >> 2]](k + 12 | 0, i[f + 4 >> 2], k + 8 | 0, k + 4 | 0, 0);
                                    continue;
                                }
                                break;
                            }
                            f = D(120), i[f >> 2] = 77776, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, v = f + 16 | 0, r = v, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[f + 32 >> 2] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 16 >> 2] = 73428, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 72 >> 2] = -1, i[f + 76 >> 2] = -1, i[f + 80 >> 2] = -1, i[f + 84 >> 2] = -1, i[f + 88 >> 2] = 0, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, o[f + 112 | 0] = 0, i[f + 16 >> 2] = 81688, i[f + 32 >> 2] = 1781689160, t = D(128), i[t >> 2] = 77816, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, _ = t + 16 | 0, r = _, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[t + 32 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, i[t + 44 >> 2] = 0, i[t + 48 >> 2] = 0, i[t + 16 >> 2] = 73428, i[t + 60 >> 2] = 0, i[t + 64 >> 2] = 0, i[t + 52 >> 2] = 0, i[t + 56 >> 2] = 0, i[t + 72 >> 2] = -1, i[t + 76 >> 2] = -1, i[t + 80 >> 2] = -1, i[t + 84 >> 2] = -1, i[t + 88 >> 2] = 0, i[t + 92 >> 2] = 0, i[t + 96 >> 2] = 0, i[t + 100 >> 2] = 0, i[t + 104 >> 2] = 0, i[t + 108 >> 2] = 0, o[t + 112 | 0] = 0, i[t + 16 >> 2] = 81400, i[t + 124 >> 2] = 0, i[t + 116 >> 2] = 0, i[t + 120 >> 2] = 0, i[t + 32 >> 2] = 1667523942;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: switch(i[i[e >> 2] + 32 >> 2]){
                                                            case 1:
                                                                r = i[t + 124 >> 2], n = i[t + 120 >> 2];
                                                                o: {
                                                                    if (r >>> 0 > n >>> 0) {
                                                                        Q[n + 4 >> 1] = 1, Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, e = n + 6 | 0;
                                                                        break o;
                                                                    }
                                                                    if (s = i[t + 116 >> 2], h = (n - s | 0) / 6 | 0, u = h + 1 | 0, u >>> 0 >= 715827883) break n;
                                                                    if (e = 0, w = (r - s | 0) / 6 | 0, r = w << 1, r = w >>> 0 >= 357913941 ? 715827882 : r >>> 0 > u >>> 0 ? r : u, r) {
                                                                        if (r >>> 0 >= 715827883) break k;
                                                                        e = D(Z(r, 6));
                                                                    }
                                                                    if (u = Z(h, 6) + e | 0, Q[u + 4 >> 1] = 1, Q[u >> 1] = 0, Q[u + 2 >> 1] = 0, r = Z(r, 6) + e | 0, e = u + 6 | 0, (n | 0) != (s | 0)) {
                                                                        for(; u = u - 6 | 0, n = n - 6 | 0, w = I[n >> 1] | I[n + 2 >> 1] << 16, Q[u >> 1] = w, Q[u + 2 >> 1] = w >>> 16, Q[u + 4 >> 1] = I[n + 4 >> 1], (n | 0) != (s | 0););
                                                                        s = i[t + 116 >> 2];
                                                                    }
                                                                    if (i[t + 124 >> 2] = r, i[t + 120 >> 2] = e, i[t + 116 >> 2] = u, !s) break o;
                                                                    X(s), r = i[t + 124 >> 2];
                                                                }
                                                                i[t + 120 >> 2] = e;
                                                                o: {
                                                                    if (r >>> 0 > e >>> 0) {
                                                                        Q[e + 4 >> 1] = 2, Q[e >> 1] = 1, Q[e + 2 >> 1] = 0, n = e + 6 | 0;
                                                                        break o;
                                                                    }
                                                                    if (s = i[t + 116 >> 2], w = (e - s | 0) / 6 | 0, h = w + 1 | 0, h >>> 0 >= 715827883) break n;
                                                                    if (n = (r - s | 0) / 6 | 0, r = n << 1, h = n >>> 0 >= 357913941 ? 715827882 : r >>> 0 > h >>> 0 ? r : h, h) {
                                                                        if (h >>> 0 >= 715827883) break k;
                                                                        r = D(Z(h, 6));
                                                                    } else r = 0;
                                                                    if (u = r + Z(w, 6) | 0, Q[u + 4 >> 1] = 2, Q[u >> 1] = 1, Q[u + 2 >> 1] = 0, n = u + 6 | 0, (e | 0) != (s | 0)) {
                                                                        for(; u = u - 6 | 0, e = e - 6 | 0, w = I[e >> 1] | I[e + 2 >> 1] << 16, Q[u >> 1] = w, Q[u + 2 >> 1] = w >>> 16, Q[u + 4 >> 1] = I[e + 4 >> 1], (e | 0) != (s | 0););
                                                                        s = i[t + 116 >> 2];
                                                                    }
                                                                    if (r = r + Z(h, 6) | 0, i[t + 124 >> 2] = r, i[t + 120 >> 2] = n, i[t + 116 >> 2] = u, !s) break o;
                                                                    X(s), r = i[t + 124 >> 2];
                                                                }
                                                                if (i[t + 120 >> 2] = n, r >>> 0 > n >>> 0) break r;
                                                                if (u = i[t + 116 >> 2], w = (n - u | 0) / 6 | 0, h = w + 1 | 0, h >>> 0 >= 715827883) break n;
                                                                if (e = (r - u | 0) / 6 | 0, r = e << 1, s = e >>> 0 >= 357913941 ? 715827882 : r >>> 0 > h >>> 0 ? r : h, s) {
                                                                    if (s >>> 0 >= 715827883) break k;
                                                                    r = D(Z(s, 6));
                                                                } else r = 0;
                                                                e = r + Z(w, 6) | 0, Q[e + 4 >> 1] = 3;
                                                                break e;
                                                            case 0:
                                                                r = i[t + 124 >> 2], n = i[t + 120 >> 2];
                                                                o: {
                                                                    if (r >>> 0 > n >>> 0) {
                                                                        Q[n + 4 >> 1] = 1, Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, e = n + 6 | 0;
                                                                        break o;
                                                                    }
                                                                    if (s = i[t + 116 >> 2], h = (n - s | 0) / 6 | 0, u = h + 1 | 0, u >>> 0 >= 715827883) break f;
                                                                    if (e = 0, w = (r - s | 0) / 6 | 0, r = w << 1, r = w >>> 0 >= 357913941 ? 715827882 : r >>> 0 > u >>> 0 ? r : u, r) {
                                                                        if (r >>> 0 >= 715827883) break k;
                                                                        e = D(Z(r, 6));
                                                                    }
                                                                    if (u = Z(h, 6) + e | 0, Q[u + 4 >> 1] = 1, Q[u >> 1] = 0, Q[u + 2 >> 1] = 0, r = Z(r, 6) + e | 0, e = u + 6 | 0, (n | 0) != (s | 0)) {
                                                                        for(; u = u - 6 | 0, n = n - 6 | 0, w = I[n >> 1] | I[n + 2 >> 1] << 16, Q[u >> 1] = w, Q[u + 2 >> 1] = w >>> 16, Q[u + 4 >> 1] = I[n + 4 >> 1], (n | 0) != (s | 0););
                                                                        s = i[t + 116 >> 2];
                                                                    }
                                                                    if (i[t + 124 >> 2] = r, i[t + 120 >> 2] = e, i[t + 116 >> 2] = u, !s) break o;
                                                                    X(s), r = i[t + 124 >> 2];
                                                                }
                                                                i[t + 120 >> 2] = e;
                                                                o: {
                                                                    if (r >>> 0 > e >>> 0) {
                                                                        Q[e + 4 >> 1] = 2, Q[e >> 1] = 1, Q[e + 2 >> 1] = 0, n = e + 6 | 0;
                                                                        break o;
                                                                    }
                                                                    if (s = i[t + 116 >> 2], w = (e - s | 0) / 6 | 0, h = w + 1 | 0, h >>> 0 >= 715827883) break f;
                                                                    if (n = (r - s | 0) / 6 | 0, r = n << 1, h = n >>> 0 >= 357913941 ? 715827882 : r >>> 0 > h >>> 0 ? r : h, h) {
                                                                        if (h >>> 0 >= 715827883) break k;
                                                                        r = D(Z(h, 6));
                                                                    } else r = 0;
                                                                    if (u = r + Z(w, 6) | 0, Q[u + 4 >> 1] = 2, Q[u >> 1] = 1, Q[u + 2 >> 1] = 0, n = u + 6 | 0, (e | 0) != (s | 0)) {
                                                                        for(; u = u - 6 | 0, e = e - 6 | 0, w = I[e >> 1] | I[e + 2 >> 1] << 16, Q[u >> 1] = w, Q[u + 2 >> 1] = w >>> 16, Q[u + 4 >> 1] = I[e + 4 >> 1], (e | 0) != (s | 0););
                                                                        s = i[t + 116 >> 2];
                                                                    }
                                                                    if (r = r + Z(h, 6) | 0, i[t + 124 >> 2] = r, i[t + 120 >> 2] = n, i[t + 116 >> 2] = u, !s) break o;
                                                                    X(s), r = i[t + 124 >> 2];
                                                                }
                                                                if (i[t + 120 >> 2] = n, r >>> 0 > n >>> 0) break r;
                                                                if (u = i[t + 116 >> 2], w = (n - u | 0) / 6 | 0, h = w + 1 | 0, h >>> 0 >= 715827883) break f;
                                                                if (e = (r - u | 0) / 6 | 0, r = e << 1, s = e >>> 0 >= 357913941 ? 715827882 : r >>> 0 > h >>> 0 ? r : h, s) {
                                                                    if (s >>> 0 >= 715827883) break k;
                                                                    r = D(Z(s, 6));
                                                                } else r = 0;
                                                                e = r + Z(w, 6) | 0, Q[e + 4 >> 1] = 3;
                                                                break e;
                                                            case 2:
                                                                break t;
                                                            default:
                                                                break i;
                                                        }
                                                        e = i[t + 120 >> 2], r = i[t + 124 >> 2];
                                                        t: {
                                                            if (e >>> 0 < r >>> 0) {
                                                                Q[e + 4 >> 1] = 1, Q[e >> 1] = 0, Q[e + 2 >> 1] = 0, s = e + 6 | 0;
                                                                break t;
                                                            }
                                                            if (u = i[t + 116 >> 2], w = (e - u | 0) / 6 | 0, h = w + 1 | 0, h >>> 0 >= 715827883) break A;
                                                            if (n = (r - u | 0) / 6 | 0, r = n << 1, r = n >>> 0 >= 357913941 ? 715827882 : r >>> 0 > h >>> 0 ? r : h, r) {
                                                                if (r >>> 0 >= 715827883) break k;
                                                                s = D(Z(r, 6));
                                                            }
                                                            if (n = Z(w, 6) + s | 0, Q[n + 4 >> 1] = 1, Q[n >> 1] = 0, Q[n + 2 >> 1] = 0, w = Z(r, 6) + s | 0, s = n + 6 | 0, (e | 0) != (u | 0)) {
                                                                for(; n = n - 6 | 0, e = e - 6 | 0, r = I[e >> 1] | I[e + 2 >> 1] << 16, Q[n >> 1] = r, Q[n + 2 >> 1] = r >>> 16, Q[n + 4 >> 1] = I[e + 4 >> 1], (e | 0) != (u | 0););
                                                                u = i[t + 116 >> 2];
                                                            }
                                                            if (i[t + 124 >> 2] = w, i[t + 120 >> 2] = s, i[t + 116 >> 2] = n, !u) break t;
                                                            X(u);
                                                        }
                                                        i[t + 120 >> 2] = s;
                                                        break i;
                                                    }
                                                    p0(), z();
                                                }
                                                Z2(), z();
                                            }
                                            p0(), z();
                                        }
                                        p0(), z();
                                    }
                                    Q[n + 4 >> 1] = 3, Q[n >> 1] = 2, Q[n + 2 >> 1] = 0, i[t + 120 >> 2] = n + 6;
                                    break i;
                                }
                                if (Q[e >> 1] = 2, Q[e + 2 >> 1] = 0, h = e + 6 | 0, (n | 0) != (u | 0)) {
                                    for(; e = e - 6 | 0, n = n - 6 | 0, w = I[n >> 1] | I[n + 2 >> 1] << 16, Q[e >> 1] = w, Q[e + 2 >> 1] = w >>> 16, Q[e + 4 >> 1] = I[n + 4 >> 1], (n | 0) != (u | 0););
                                    u = i[t + 116 >> 2];
                                }
                                i[t + 124 >> 2] = Z(s, 6) + r, i[t + 120 >> 2] = h, i[t + 116 >> 2] = e, u && X(u), i[t + 120 >> 2] = h;
                            }
                            i[k + 16 >> 2] = t, i[k + 12 >> 2] = _, i[t + 4 >> 2] = i[t + 4 >> 2] + 1, r = i[f + 56 >> 2];
                            i: {
                                e: {
                                    if (r >>> 0 < k0[f + 60 >> 2]) {
                                        i[r + 4 >> 2] = t, i[r >> 2] = _, i[t + 4 >> 2] = i[t + 4 >> 2] + 1, i[f + 56 >> 2] = r + 8, n = t;
                                        break e;
                                    }
                                    if (r = P2(f + 52 | 0, k + 12 | 0), n = i[k + 16 >> 2], i[f + 56 >> 2] = r, !n) break i;
                                }
                                if (r = i[n + 4 >> 2], i[n + 4 >> 2] = r - 1, r) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            i[k + 16 >> 2] = f, i[k + 12 >> 2] = v, i[f + 4 >> 2] = i[f + 4 >> 2] + 1, r = i[k + 36 >> 2];
                            i: {
                                if (r >>> 0 < k0[k + 40 >> 2]) {
                                    i[r + 4 >> 2] = f, i[r >> 2] = v, i[k + 36 >> 2] = r + 8;
                                    break i;
                                }
                                if (B = k, G = p2(k + 32 | 0, k + 12 | 0), i[B + 36 >> 2] = G, e = i[k + 16 >> 2], !e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            G6(A, k + 32 | 0), A = i[t + 4 >> 2], i[t + 4 >> 2] = A - 1, A || (p[i[i[t >> 2] + 8 >> 2]](t), g(t)), A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), r = i[k + 28 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (A = i[k + 44 >> 2], A && (i[k + 48 >> 2] = A, X(A)), A = i[k + 32 >> 2], A) {
                                if (r = A, f = i[k + 36 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        e = i[f - 4 >> 2];
                                        i: {
                                            if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (f = f - 8 | 0, (A | 0) == (f | 0)) break;
                                    }
                                    r = i[k + 32 >> 2];
                                }
                                i[k + 36 >> 2] = A, X(r);
                            }
                            m = k - -64 | 0;
                        }
                        function g7(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0;
                            v = m - 528 | 0, m = v, i[v + 520 >> 2] = w, i[v + 524 >> 2] = r;
                            i: {
                                if (T2(A, v + 524 | 0)) {
                                    i[n >> 2] = i[n >> 2] | 4, A = 0;
                                    break i;
                                }
                                i[v + 76 >> 2] = 1414, W = v + 76 | 0, V = s1(v + 104 | 0, v + 112 | 0, W), r = i[V >> 2], i[v + 100 >> 2] = r, i[v + 96 >> 2] = r + 400, r = m - 16 | 0, m = r, i[W >> 2] = 0, i[W + 4 >> 2] = 0, i[W + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, G = v - -64 | 0, i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, B = v + 52 | 0, i[B >> 2] = 0, i[B + 4 >> 2] = 0, i[B + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, _ = v + 40 | 0, i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, i[_ + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, C = v + 28 | 0, i[C >> 2] = 0, i[C + 4 >> 2] = 0, i[C + 8 >> 2] = 0, m = r + 16 | 0, w = m - 16 | 0, m = w;
                                e: {
                                    if (e) {
                                        e = w + 4 | 0, r = K0(f, 108316), p[i[i[r >> 2] + 44 >> 2]](e, r), f = i[w + 4 >> 2], o[v + 92 | 0] = f, o[v + 93 | 0] = f >>> 8, o[v + 94 | 0] = f >>> 16, o[v + 95 | 0] = f >>> 24, p[i[i[r >> 2] + 32 >> 2]](e, r), $1(_, e), a0(e), p[i[i[r >> 2] + 28 >> 2]](e, r), $1(B, e), a0(e), E = v, R = p[i[i[r >> 2] + 12 >> 2]](r) | 0, o[E + 91 | 0] = R, E = v, R = p[i[i[r >> 2] + 16 >> 2]](r) | 0, o[E + 90 | 0] = R, p[i[i[r >> 2] + 20 >> 2]](e, r), $1(W, e), a0(e), p[i[i[r >> 2] + 24 >> 2]](e, r), $1(G, e), a0(e), r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                        break e;
                                    }
                                    e = w + 4 | 0, r = K0(f, 108308), p[i[i[r >> 2] + 44 >> 2]](e, r), f = i[w + 4 >> 2], o[v + 92 | 0] = f, o[v + 93 | 0] = f >>> 8, o[v + 94 | 0] = f >>> 16, o[v + 95 | 0] = f >>> 24, p[i[i[r >> 2] + 32 >> 2]](e, r), $1(_, e), a0(e), p[i[i[r >> 2] + 28 >> 2]](e, r), $1(B, e), a0(e), E = v, R = p[i[i[r >> 2] + 12 >> 2]](r) | 0, o[E + 91 | 0] = R, E = v, R = p[i[i[r >> 2] + 16 >> 2]](r) | 0, o[E + 90 | 0] = R, p[i[i[r >> 2] + 20 >> 2]](e, r), $1(W, e), a0(e), p[i[i[r >> 2] + 24 >> 2]](e, r), $1(G, e), a0(e), r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                }
                                for(i[v + 24 >> 2] = r, m = w + 16 | 0, i[h >> 2] = i[s >> 2], y = k & 512, f = 0, r = 0;;){
                                    e = r;
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    if ((f | 0) == 4 || T2(A, v + 524 | 0)) break f;
                                                    w = 0;
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: switch(l[(v + 92 | 0) + f | 0]){
                                                                        case 1:
                                                                            if ((f | 0) == 3) break r;
                                                                            r = i[A >> 2], k = i[r + 12 >> 2];
                                                                            u: {
                                                                                if ((k | 0) == i[r + 16 >> 2]) {
                                                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                                    break u;
                                                                                }
                                                                                r = l[k | 0];
                                                                            }
                                                                            if (r = r << 24 >> 24, (r | 0) >= 0 ? r = i[i[u + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, r) {
                                                                                Zo(v + 16 | 0, A), Wi(C, o[v + 16 | 0]);
                                                                                break o;
                                                                            }
                                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                            break A;
                                                                        case 4:
                                                                            break k;
                                                                        case 2:
                                                                            break n;
                                                                        case 3:
                                                                            break t;
                                                                        case 0:
                                                                            break s;
                                                                        default:
                                                                            break e;
                                                                    }
                                                                    if ((f | 0) == 3) break r;
                                                                }
                                                                for(;;){
                                                                    if (T2(A, v + 524 | 0)) break r;
                                                                    r = i[A >> 2], k = i[r + 12 >> 2];
                                                                    o: {
                                                                        if ((k | 0) == i[r + 16 >> 2]) {
                                                                            r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                            break o;
                                                                        }
                                                                        r = l[k | 0];
                                                                    }
                                                                    if (r = r << 24 >> 24, (r | 0) >= 0 ? r = i[i[u + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, !r) break r;
                                                                    Zo(v + 16 | 0, A), Wi(C, o[v + 16 | 0]);
                                                                }
                                                            }
                                                            t: {
                                                                if (l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, !r) break t;
                                                                r = i[A >> 2], k = i[r + 12 >> 2];
                                                                o: {
                                                                    if ((k | 0) == i[r + 16 >> 2]) {
                                                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                        break o;
                                                                    }
                                                                    r = l[k | 0];
                                                                }
                                                                if (k = r << 24 >> 24 & 255, l[B + 11 | 0] >>> 7 | 0 ? r = i[B >> 2] : r = B, (k | 0) != l[r | 0]) break t;
                                                                g1(A), o[t | 0] = 0, l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, r = r >>> 0 > 1 ? B : e;
                                                                break e;
                                                            }
                                                            t: {
                                                                if (l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ + 4 >> 2] : r = l[_ + 11 | 0] & 127, !r) break t;
                                                                r = i[A >> 2], k = i[r + 12 >> 2];
                                                                o: {
                                                                    if ((k | 0) == i[r + 16 >> 2]) {
                                                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                        break o;
                                                                    }
                                                                    r = l[k | 0];
                                                                }
                                                                if (k = r << 24 >> 24 & 255, l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ >> 2] : r = _, (k | 0) != l[r | 0]) break t;
                                                                g1(A), o[t | 0] = 1, l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ + 4 >> 2] : r = l[_ + 11 | 0] & 127, r = r >>> 0 > 1 ? _ : e;
                                                                break e;
                                                            }
                                                            if (l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, k = !r, l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ + 4 >> 2] : r = l[_ + 11 | 0] & 127, !(k | !r)) {
                                                                i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                break A;
                                                            }
                                                            if (l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, !r && (l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ + 4 >> 2] : r = l[_ + 11 | 0] & 127, !r)) break r;
                                                            l[_ + 11 | 0] >>> 7 | 0 ? r = i[_ + 4 >> 2] : r = l[_ + 11 | 0] & 127, o[t | 0] = !r;
                                                            break r;
                                                        }
                                                        if (!(y | (e | f >>> 0 < 2)) && (r = 0, !((f | 0) == 2 & l[v + 95 | 0] != 0))) break e;
                                                        E = v, R = Q4(G), i[E + 12 >> 2] = R, i[v + 16 >> 2] = i[v + 12 >> 2];
                                                        n: {
                                                            if (!f | l[(f + v | 0) + 91 | 0] > 1) break n;
                                                            for(;;){
                                                                t: {
                                                                    if (E = v, R = U8(G), i[E + 12 >> 2] = R, r = i[v + 16 >> 2], (r | 0) == i[v + 12 >> 2] || (r = o[r | 0], (r | 0) >= 0 ? r = i[i[u + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, !r)) break t;
                                                                    i[v + 16 >> 2] = i[v + 16 >> 2] + 1;
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            if (E = v, R = Q4(G), i[E + 12 >> 2] = R, l[C + 11 | 0] >>> 7 | 0 ? w = i[C + 4 >> 2] : w = l[C + 11 | 0] & 127, r = v + 12 | 0, k = i[v + 16 >> 2] - i[r >> 2] | 0, w >>> 0 >= k >>> 0 && (E = v, R = U8(C), i[E + 12 >> 2] = R, r = SA(r, 0 - k | 0), k = U8(C), w = Q4(G), F = m - 16 | 0, m = F, r = H8(r), k = H8(k), r = O2(r, H8(w), k - r | 0), m = F + 16 | 0, !r)) break n;
                                                            E = v, R = Q4(G), i[E + 8 >> 2] = R, i[v + 12 >> 2] = i[v + 8 >> 2], i[v + 16 >> 2] = i[v + 12 >> 2];
                                                        }
                                                        for(i[v + 12 >> 2] = i[v + 16 >> 2];;){
                                                            n: {
                                                                if (E = v, R = U8(G), i[E + 8 >> 2] = R, i[v + 12 >> 2] == i[v + 8 >> 2] || T2(A, v + 524 | 0)) break n;
                                                                r = i[A >> 2], k = i[r + 12 >> 2];
                                                                t: {
                                                                    if ((k | 0) == i[r + 16 >> 2]) {
                                                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                        break t;
                                                                    }
                                                                    r = l[k | 0];
                                                                }
                                                                if ((r << 24 >> 24 & 255) != l[i[v + 12 >> 2]]) break n;
                                                                g1(A), i[v + 12 >> 2] = i[v + 12 >> 2] + 1;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        if (!y || (E = v, R = U8(G), i[E + 8 >> 2] = R, i[v + 12 >> 2] == i[v + 8 >> 2])) break r;
                                                        i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                        break A;
                                                    }
                                                    for(;;){
                                                        k: {
                                                            if (T2(A, v + 524 | 0)) break k;
                                                            r = i[A >> 2], k = i[r + 12 >> 2];
                                                            n: {
                                                                if ((k | 0) == i[r + 16 >> 2]) {
                                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                    break n;
                                                                }
                                                                r = l[k | 0];
                                                            }
                                                            r = r << 24 >> 24, (r | 0) >= 0 ? k = i[i[u + 8 >> 2] + (r << 2) >> 2] & 64 : k = 0;
                                                            n: {
                                                                if (k) {
                                                                    k = i[h >> 2], (k | 0) == i[v + 520 >> 2] && (u9(s, h, v + 520 | 0), k = i[h >> 2]), i[h >> 2] = k + 1, o[k | 0] = r, w = w + 1 | 0;
                                                                    break n;
                                                                }
                                                                if (l[W + 11 | 0] >>> 7 | 0 ? k = i[W + 4 >> 2] : k = l[W + 11 | 0] & 127, !k | !w | l[v + 90 | 0] != (r & 255)) break k;
                                                                r = i[v + 100 >> 2], (r | 0) == i[v + 96 >> 2] && (C6(V, v + 100 | 0, v + 96 | 0), r = i[v + 100 >> 2]), i[v + 100 >> 2] = r + 4, i[r >> 2] = w, w = 0;
                                                            }
                                                            g1(A);
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    r = i[v + 100 >> 2], !w | (r | 0) == i[V >> 2] || (i[v + 96 >> 2] == (r | 0) && (C6(V, v + 100 | 0, v + 96 | 0), r = i[v + 100 >> 2]), i[v + 100 >> 2] = r + 4, i[r >> 2] = w);
                                                    k: {
                                                        if (i[v + 24 >> 2] <= 0) break k;
                                                        n: {
                                                            if (!T2(A, v + 524 | 0)) {
                                                                r = i[A >> 2], k = i[r + 12 >> 2];
                                                                t: {
                                                                    if ((k | 0) == i[r + 16 >> 2]) {
                                                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                        break t;
                                                                    }
                                                                    r = l[k | 0];
                                                                }
                                                                if ((r << 24 >> 24 & 255) == l[v + 91 | 0]) break n;
                                                            }
                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                            break A;
                                                        }
                                                        for(;;){
                                                            if (g1(A), i[v + 24 >> 2] <= 0) break k;
                                                            n: {
                                                                if (!T2(A, v + 524 | 0)) {
                                                                    r = i[A >> 2], k = i[r + 12 >> 2];
                                                                    t: {
                                                                        if ((k | 0) == i[r + 16 >> 2]) {
                                                                            r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                            break t;
                                                                        }
                                                                        r = l[k | 0];
                                                                    }
                                                                    if (r = r << 24 >> 24, (r | 0) >= 0 ? r = i[i[u + 8 >> 2] + (r << 2) >> 2] & 64 : r = 0, r) break n;
                                                                }
                                                                i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                break A;
                                                            }
                                                            i[h >> 2] == i[v + 520 >> 2] && u9(s, h, v + 520 | 0), r = i[A >> 2], k = i[r + 12 >> 2];
                                                            n: {
                                                                if ((k | 0) == i[r + 16 >> 2]) {
                                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                    break n;
                                                                }
                                                                r = l[k | 0];
                                                            }
                                                            k = i[h >> 2], i[h >> 2] = k + 1, o[k | 0] = r << 24 >> 24, i[v + 24 >> 2] = i[v + 24 >> 2] - 1;
                                                        }
                                                    }
                                                    if (r = e, i[s >> 2] != i[h >> 2]) break e;
                                                    i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                    break A;
                                                }
                                                f: {
                                                    if (!e) break f;
                                                    for(w = 1;;){
                                                        if (l[e + 11 | 0] >>> 7 | 0 ? r = i[e + 4 >> 2] : r = l[e + 11 | 0] & 127, r >>> 0 <= w >>> 0) break f;
                                                        k: {
                                                            if (!T2(A, v + 524 | 0)) {
                                                                r = i[A >> 2], f = i[r + 12 >> 2];
                                                                n: {
                                                                    if ((f | 0) == i[r + 16 >> 2]) {
                                                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                                        break n;
                                                                    }
                                                                    r = l[f | 0];
                                                                }
                                                                if (f = r << 24 >> 24 & 255, l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, (f | 0) == l[r + w | 0]) break k;
                                                            }
                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                            break A;
                                                        }
                                                        g1(A), w = w + 1 | 0;
                                                    }
                                                }
                                                if (A = 1, i[V >> 2] == i[v + 100 >> 2]) break A;
                                                if (A = 0, i[v + 16 >> 2] = 0, L1(W, i[V >> 2], i[v + 100 >> 2], v + 16 | 0), i[v + 16 >> 2]) {
                                                    i[n >> 2] = i[n >> 2] | 4;
                                                    break A;
                                                }
                                                A = 1;
                                            }
                                            a0(C), a0(_), a0(B), a0(G), a0(W), r = i[V >> 2], i[V >> 2] = 0, r && p[i[V + 4 >> 2]](r);
                                            break i;
                                        }
                                        r = e;
                                    }
                                    f = f + 1 | 0;
                                }
                            }
                            return m = v + 528 | 0, A;
                        }
                        function Nh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = J(0), w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = J(0), S = J(0), P = J(0), $ = 0, c = 0, r0 = 0, f0 = J(0), t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = J(0), F0 = 0, g0 = 0, R0 = 0, D0 = J(0), H0 = J(0), i2 = J(0), e2 = J(0), k2 = J(0);
                            n = m - 144 | 0, m = n, r = i[e >> 2], W = i[r + 28 >> 2], C = i[r + 24 >> 2], F = S0(r, 10), E = i[i[e >> 2] + 36 >> 2], u = D(136), i[u >> 2] = 78252, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, B0(u + 20 | 0, 0, 104), s = i[u + 4 >> 2], f = s + 1 | 0, i[u + 4 >> 2] = f, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 44 >> 2] = 99, i[u + 48 >> 2] = 99, i[u + 32 >> 2] = 4142, r = u - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[u + 132 >> 2] = 0, i[u + 124 >> 2] = 0, i[u + 128 >> 2] = 0, i[u + 84 >> 2] = 1, i[u + 88 >> 2] = 1, r = u + 76 | 0, i[u + 72 >> 2] = r, i[u + 92 >> 2] = 0, i[u + 96 >> 2] = 0, i[u + 100 >> 2] = 0, i[u + 104 >> 2] = 0, i[u + 108 >> 2] = 0, i[u + 112 >> 2] = 0, o[u + 113 | 0] = 0, o[u + 114 | 0] = 0, o[u + 115 | 0] = 0, o[u + 116 | 0] = 0, o[u + 117 | 0] = 0, o[u + 118 | 0] = 0, o[u + 119 | 0] = 0, o[u + 120 | 0] = 0, V = u + 12 | 0, i[u + 12 >> 2] = V, i[u + 8 >> 2] = i[u + 8 >> 2] + 1, i[u + 4 >> 2] = s, i[u + 16 >> 2] = u, f || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), i[V + 36 >> 2] = 1, i[V + 32 >> 2] = 0, i[V + 28 >> 2] = W, i[V + 24 >> 2] = C, J0(n + 96 | 0, V, 0, C, W, F, t), y = C + 1 >>> 1 | 0, s = W + 1 >>> 1 | 0, J0(n + 72 | 0, V, 1, y, s, F, t), w = n + 128 | 0;
                            i: {
                                if (i[n + 96 >> 2]) {
                                    if (f = i[n + 100 >> 2], i[n + 120 >> 2] = i[n + 96 >> 2], i[n + 124 >> 2] = f, o[n + 115 | 0] >= 0) {
                                        f = i[n + 108 >> 2], i[w >> 2] = i[n + 104 >> 2], i[w + 4 >> 2] = f, i[w + 8 >> 2] = i[n + 112 >> 2];
                                        break i;
                                    }
                                    j(w, i[n + 104 >> 2], i[n + 108 >> 2]);
                                    break i;
                                }
                                if (f = i[n + 76 >> 2], i[n + 120 >> 2] = i[n + 72 >> 2], i[n + 124 >> 2] = f, o[n + 91 | 0] >= 0) {
                                    f = i[n + 84 >> 2], i[w >> 2] = i[n + 80 >> 2], i[w + 4 >> 2] = f, i[w + 8 >> 2] = i[n + 88 >> 2];
                                    break i;
                                }
                                j(w, i[n + 80 >> 2], i[n + 84 >> 2]);
                            }
                            J0(n + 48 | 0, V, 2, y, s, F, t), s = n + 16 | 0;
                            i: {
                                if (i[n + 120 >> 2]) {
                                    if (f = i[n + 124 >> 2], i[n + 8 >> 2] = i[n + 120 >> 2], i[n + 12 >> 2] = f, o[n + 139 | 0] >= 0) {
                                        f = i[w + 4 >> 2], i[s >> 2] = i[w >> 2], i[s + 4 >> 2] = f, i[s + 8 >> 2] = i[w + 8 >> 2];
                                        break i;
                                    }
                                    j(s, i[n + 128 >> 2], i[n + 132 >> 2]);
                                    break i;
                                }
                                if (f = i[n + 52 >> 2], i[n + 8 >> 2] = i[n + 48 >> 2], i[n + 12 >> 2] = f, o[n + 67 | 0] >= 0) {
                                    f = i[n + 60 >> 2], i[s >> 2] = i[n + 56 >> 2], i[s + 4 >> 2] = f, i[s + 8 >> 2] = i[n + 64 >> 2];
                                    break i;
                                }
                                j(s, i[n + 56 >> 2], i[n + 60 >> 2]);
                            }
                            o[n + 67 | 0] < 0 && X(i[n + 56 >> 2]), o[n + 139 | 0] < 0 && X(i[n + 128 >> 2]), o[n + 91 | 0] < 0 && X(i[n + 80 >> 2]), o[n + 115 | 0] < 0 && X(i[n + 104 >> 2]);
                            i: {
                                if (i[n + 8 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 12 >> 2], i[A + 8 >> 2] = i[n + 8 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[n + 27 | 0] >= 0) {
                                        A = i[s + 4 >> 2], i[r >> 2] = i[s >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[s + 8 >> 2];
                                        break i;
                                    }
                                    if (j(r, i[n + 16 >> 2], i[n + 20 >> 2]), o[n + 27 | 0] >= 0) break i;
                                    X(i[n + 16 >> 2]);
                                    break i;
                                }
                                o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]);
                                e: {
                                    r: switch(E - 13 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    if (J0(n + 8 | 0, V, 6, C, W, F, t), i[n + 8 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 12 >> 2], i[A + 8 >> 2] = i[n + 8 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[n + 27 | 0] >= 0) {
                                            A = i[n + 20 >> 2], i[r >> 2] = i[n + 16 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[n + 24 >> 2];
                                            break i;
                                        }
                                        if (j(r, i[n + 16 >> 2], i[n + 20 >> 2]), o[n + 27 | 0] >= 0) break i;
                                        X(i[n + 16 >> 2]);
                                        break i;
                                    }
                                    if (o[n + 27 | 0] >= 0) break e;
                                    X(i[n + 16 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (w = i[e >> 2], t = i[w + 64 >> 2], !t) break r;
                                        for(s = w - -64 | 0, f = s; e = i[t + 16 >> 2] < 10, f = e ? f : t, t = i[(e << 2) + t >> 2], !!t;);
                                        if ((f | 0) == (s | 0)) break r;
                                        if (y = 0, i[f + 16 >> 2] > 10) break e;
                                        t0 = i[f + 44 >> 2], y = i[f + 52 >> 2];
                                        break e;
                                    }
                                    y = 0;
                                }
                                e: {
                                    r: {
                                        if (f = i[r >> 2], f) {
                                            for(e = r, t = f; s = i[t + 16 >> 2], e = (s | 0) < 0 ? e : t, t = i[(s >>> 29 & 4) + t >> 2], !!t;);
                                            v = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (v = 0, i[e + 16 >> 2] > 0)) break A;
                                                H = i[e + 52 >> 2], v = i[e + 44 >> 2];
                                            }
                                            for(e = r, t = f; s = i[t + 16 >> 2] <= 0, e = s ? e : t, t = i[(s << 2) + t >> 2], !!t;);
                                            t = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (t = 0, i[e + 16 >> 2] > 1)) break A;
                                                R = i[e + 52 >> 2], t = i[e + 44 >> 2];
                                            }
                                            for(F0 = t, e = r, t = f; s = i[t + 16 >> 2] < 2, e = s ? e : t, t = i[(s << 2) + t >> 2], !!t;);
                                            if ((r | 0) != (e | 0)) break r;
                                        }
                                        s = 0;
                                        break e;
                                    }
                                    if (s = 0, i[e + 16 >> 2] > 2) break e;
                                    g0 = i[e + 52 >> 2] >>> 1 | 0, s = i[e + 44 >> 2];
                                }
                                e: {
                                    r: switch(E - 13 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    r: {
                                        if (!f) break r;
                                        for(t = r; e = i[f + 16 >> 2] < 6, t = e ? t : f, f = i[(e << 2) + f >> 2], !!f;);
                                        if ((r | 0) == (t | 0)) break r;
                                        if (i[t + 16 >> 2] > 6) break e;
                                        $ = i[t + 52 >> 2] >>> 1 | 0, s0 = i[t + 44 >> 2];
                                    }
                                }
                                L = l[k + 26 | 0], r = i[w + 36 >> 2], Te(n + 8 | 0, I[k + 24 >> 1], I[k + 20 >> 1]);
                                e: {
                                    if (!W) break e;
                                    c = (E & -3) == 13 ? 8 : 6, M = -1 << F ^ -1, r0 = r & -2, B = (r0 | 0) == 14, q = B | 4, m0 = B ^ 3, Z0 = B | 2;
                                    r: {
                                        if (!C) break r;
                                        V0 = H >>> 1 | 0, f0 = J(16 << F - 8), _ = B ? 4 : 5, G = !B, T = W0[n + 20 >> 2], S = W0[n + 16 >> 2], P = W0[n + 12 >> 2], e = 0;
                                        A: switch(E - 13 | 0){
                                            case 0:
                                            case 2:
                                                for(X0 = B ^ 7, E = B | 6, t = 0;;){
                                                    for(w = Z(t, $), H = Z(t, y) + t0 | 0, k = (Z(t, V0) << 1) + v | 0, f = 0;;){
                                                        R0 = (f << 1) + k | 0, e = Z(f, c) + H | 0, h = J(J(J((l[e + q | 0] << 8 | l[e + _ | 0]) >>> 0) * T) + J(J(J((l[e + G | 0] | l[e + B | 0] << 8) >>> 0) * P) + J(S * J((l[e + m0 | 0] | l[e + Z0 | 0] << 8) >>> 0)))), h = J((L & 1 ? h : J(J(h * J(.8554700016975403)) + f0)) + J(.5));
                                                        f: {
                                                            if (J(r2(h)) < J(2147483648)) {
                                                                r = ~~h;
                                                                break f;
                                                            }
                                                            r = -2147483648;
                                                        }
                                                        if (Q[R0 >> 1] = (r | 0) >= 0 ? (r | 0) < (M | 0) ? r : M : 0, Q[(f + w << 1) + s0 >> 1] = l[e + X0 | 0] | l[e + E | 0] << 8, f = f + 1 | 0, (C | 0) == (f | 0)) break;
                                                    }
                                                    if (t = t + 1 | 0, (W | 0) == (t | 0)) break;
                                                }
                                                if (W) break r;
                                                break e;
                                            default:
                                                break A;
                                        }
                                        for(;;){
                                            for(H = Z(e, y) + t0 | 0, t = (Z(e, V0) << 1) + v | 0, f = 0;;){
                                                k = t + (f << 1) | 0, r = H + Z(f, c) | 0, h = J(J(J((l[r + q | 0] << 8 | l[r + _ | 0]) >>> 0) * T) + J(J(J((l[r + G | 0] | l[r + B | 0] << 8) >>> 0) * P) + J(S * J((l[r + m0 | 0] | l[r + Z0 | 0] << 8) >>> 0)))), h = J((L & 1 ? h : J(J(h * J(.8554700016975403)) + f0)) + J(.5));
                                                A: {
                                                    if (J(r2(h)) < J(2147483648)) {
                                                        r = ~~h;
                                                        break A;
                                                    }
                                                    r = -2147483648;
                                                }
                                                if (Q[k >> 1] = (r | 0) >= 0 ? (r | 0) < (M | 0) ? r : M : 0, f = f + 1 | 0, (C | 0) == (f | 0)) break;
                                            }
                                            if (e = e + 1 | 0, (W | 0) == (e | 0)) break;
                                        }
                                    }
                                    if (!C) break e;
                                    for(s0 = R >>> 1 | 0, r0 = (r0 | 0) == 14 ? 4 : 5, $ = !B, I0 = J((1 << F - 1 & 65535) >>> 0), t = 0, D0 = W0[n + 44 >> 2], H0 = W0[n + 40 >> 2], i2 = W0[n + 36 >> 2], e2 = W0[n + 32 >> 2], k2 = W0[n + 28 >> 2], f0 = W0[n + 24 >> 2];;){
                                        for(_ = (t | 1) >>> 0 < W >>> 0 ? y : 0, X0 = Z(t, y) + t0 | 0, r = t >>> 1 | 0, E = (Z(r, g0) << 1) + s | 0, w = (Z(r, s0) << 1) + F0 | 0, e = 0;;){
                                            F = e + w | 0, G = X0 + Z(e, c) | 0, v = G + q | 0, R = (e | 1) >>> 0 < C >>> 0 ? c : 0, f = v + R | 0, k = G + r0 | 0, r = k + R | 0, T = J(J((((l[f | 0] << 8 | l[r | 0]) + (l[k | 0] | l[v | 0] << 8) | 0) + (l[k + _ | 0] | l[_ + v | 0] << 8) | 0) + (l[r + _ | 0] | l[f + _ | 0] << 8) >>> 0) * J(.25)), v = G + (R | $) | 0, k = G + (B | R) | 0, f = G + $ | 0, r = B + G | 0, S = J(J((((l[v | 0] | l[k | 0] << 8) + (l[f | 0] | l[r | 0] << 8) | 0) + (l[f + _ | 0] | l[r + _ | 0] << 8) | 0) + (l[_ + v | 0] | l[k + _ | 0] << 8) >>> 0) * J(.25)), v = G + m0 | 0, f = v + R | 0, k = G + Z0 | 0, r = k + R | 0, P = J(J((((l[f | 0] | l[r | 0] << 8) + (l[v | 0] | l[k | 0] << 8) | 0) + (l[_ + v | 0] | l[k + _ | 0] << 8) | 0) + (l[f + _ | 0] | l[r + _ | 0] << 8) >>> 0) * J(.25)), h = J(J(T * e2) + J(J(S * f0) + J(k2 * P))), k = L & 1, h = J(J((k ? h : J(h * J(.875))) + I0) + J(.5));
                                            r: {
                                                if (J(r2(h)) < J(2147483648)) {
                                                    r = ~~h;
                                                    break r;
                                                }
                                                r = -2147483648;
                                            }
                                            Q[F >> 1] = (r | 0) >= 0 ? (r | 0) < (M | 0) ? r : M : 0, f = e + E | 0, h = J(J(T * D0) + J(J(S * i2) + J(P * H0))), h = J(J((k ? h : J(h * J(.875))) + I0) + J(.5));
                                            r: {
                                                if (J(r2(h)) < J(2147483648)) {
                                                    r = ~~h;
                                                    break r;
                                                }
                                                r = -2147483648;
                                            }
                                            if (Q[f >> 1] = (r | 0) >= 0 ? (r | 0) < (M | 0) ? r : M : 0, e = e + 2 | 0, !(C >>> 0 > e >>> 0)) break;
                                        }
                                        if (t = t + 2 | 0, !(W >>> 0 > t >>> 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = u, i[A >> 2] = V, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = n + 144 | 0;
                        }
                        function Dh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0;
                            u = m - 128 | 0, m = u, n = S0(i[e >> 2], 0), w = S0(i[e >> 2], 1), C = S0(i[e >> 2], 2), c = A1(i[e >> 2], 6), c && (q = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(n >>> 0 > 8 | w >>> 0 > 8) & C >>> 0 < 9)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((n | 0) == (w | 0) & (n | 0) == (C | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                k = i[e >> 2], V = i[k + 48 >> 2], V && (i[V + 4 >> 2] = i[V + 4 >> 2] + 1, k = i[e >> 2]), _ = i[k + 28 >> 2], v = i[k + 24 >> 2], h = D(136), i[h >> 2] = 78252, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, B0(h + 20 | 0, 0, 104), k = i[h + 4 >> 2], s = k + 1 | 0, i[h + 4 >> 2] = s, i[h + 56 >> 2] = 0, i[h + 60 >> 2] = 0, i[h + 44 >> 2] = 99, i[h + 48 >> 2] = 99, i[h + 32 >> 2] = 4142, r = h - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[h + 132 >> 2] = 0, f = h, i[f + 124 >> 2] = 0, i[f + 128 >> 2] = 0, i[f + 84 >> 2] = 1, i[f + 88 >> 2] = 1, r = f + 76 | 0, i[f + 72 >> 2] = r, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, i[f + 112 >> 2] = 0, o[f + 113 | 0] = 0, o[f + 114 | 0] = 0, o[f + 115 | 0] = 0, o[f + 116 | 0] = 0, o[f + 117 | 0] = 0, o[f + 118 | 0] = 0, o[f + 119 | 0] = 0, o[f + 120 | 0] = 0, B = f + 12 | 0, i[f + 12 >> 2] = B, i[f + 8 >> 2] = i[f + 8 >> 2] + 1, i[f + 4 >> 2] = k, i[f + 16 >> 2] = f, s || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), i[B + 36 >> 2] = 1, i[B + 32 >> 2] = 0, i[B + 28 >> 2] = _, i[B + 24 >> 2] = v, J0(u + 56 | 0, B, 0, v, _, n, t), y = v + 1 >>> 1 | 0, R = _ + 1 >>> 1 | 0, J0(u + 32 | 0, B, 1, y, R, w, t), f = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[f >> 2] = i[k >> 2], i[f + 4 >> 2] = n, i[f + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[f >> 2] = i[u + 40 >> 2], i[f + 4 >> 2] = k, i[f + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, B, 2, y, R, C, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[f + 4 >> 2], i[k >> 2] = i[f >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (f = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = f, o[u + 27 | 0] >= 0) {
                                        f = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = f, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!c) break r;
                                        if (J0(u + 104 | 0, B, 6, v, _, q, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    e = i[e >> 2], f = e - -64 | 0;
                                    r: {
                                        A: {
                                            n = i[e + 64 >> 2];
                                            f: {
                                                if (!n) {
                                                    w = 0;
                                                    break f;
                                                }
                                                for(w = f, e = n; k = i[e + 16 >> 2], w = (k | 0) < 0 ? w : e, e = i[(k >>> 29 & 4) + e >> 2], !!e;);
                                                T = 0;
                                                k: {
                                                    if ((f | 0) == (w | 0) || (T = 0, i[w + 16 >> 2] > 0)) break k;
                                                    V0 = i[w + 44 >> 2], T = i[w + 52 >> 2];
                                                }
                                                for(k = f, e = n; t = i[e + 16 >> 2] <= 0, k = t ? k : e, e = i[(t << 2) + e >> 2], !!e;);
                                                w = 0;
                                                k: {
                                                    if ((f | 0) == (k | 0) || (w = 0, i[k + 16 >> 2] > 1)) break k;
                                                    M = i[k + 52 >> 2], w = i[k + 44 >> 2];
                                                }
                                                for(t = f, e = n; k = i[e + 16 >> 2] < 2, t = k ? t : e, e = i[(k << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (t | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[t + 16 >> 2] > 2) break r;
                                        H = i[t + 52 >> 2], e = i[t + 44 >> 2];
                                    }
                                    C = e;
                                    r: {
                                        A: {
                                            if (t = i[r >> 2], t) {
                                                for(k = r, e = t; s = i[e + 16 >> 2], k = (s | 0) < 0 ? k : e, e = i[(s >>> 29 & 4) + e >> 2], !!e;);
                                                S = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (S = 0, i[k + 16 >> 2] > 0)) break f;
                                                    I0 = i[k + 44 >> 2], S = i[k + 52 >> 2];
                                                }
                                                for(k = r, e = t; s = i[e + 16 >> 2] <= 0, k = s ? k : e, e = i[(s << 2) + e >> 2], !!e;);
                                                F = 0;
                                                f: {
                                                    if ((r | 0) == (k | 0) || (F = 0, i[k + 16 >> 2] > 1)) break f;
                                                    r0 = i[k + 52 >> 2], F = i[k + 44 >> 2];
                                                }
                                                for(k = r, e = t; s = i[e + 16 >> 2] < 2, k = s ? k : e, e = i[(s << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            E = 0;
                                            break r;
                                        }
                                        if (E = 0, i[k + 16 >> 2] > 2) break r;
                                        f0 = i[k + 52 >> 2], E = i[k + 44 >> 2];
                                    }
                                    k = 0, s = 0;
                                    r: {
                                        if (!c) break r;
                                        A: {
                                            f: {
                                                if (!n) break f;
                                                for(e = f; s = i[n + 16 >> 2] < 6, e = s ? e : n, n = i[(s << 2) + n >> 2], !!n;);
                                                if ((e | 0) == (f | 0)) break f;
                                                if (t0 = 0, i[e + 16 >> 2] > 6) break A;
                                                F0 = i[e + 44 >> 2], t0 = i[e + 52 >> 2];
                                                break A;
                                            }
                                            t0 = 0;
                                        }
                                        if (s = 0, !t) break r;
                                        for(e = r; f = i[t + 16 >> 2] < 6, e = f ? e : t, t = i[(f << 2) + t >> 2], !!t;);
                                        if (s = 0, (r | 0) == (e | 0) || (s = 0, i[e + 16 >> 2] > 6)) break r;
                                        k = i[e + 52 >> 2], s = i[e + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (t = _ & 1, t) {
                                                        if (r = v - 1 | 0, !r) break k;
                                                        for(e = _ - 1 | 0, f = Z(e, H), n = Z(e, M), e = R - 1 | 0, P = Z(e, f0) + E | 0, $ = Z(e, r0) + F | 0, e = 0; G = e >>> 1 | 0, W = (e + n | 0) + w | 0, o[G + $ | 0] = (l[W | 0] + l[W + 1 | 0] | 0) + 1 >>> 1, L = G + P | 0, G = (e + f | 0) + C | 0, o[L | 0] = (l[G | 0] + l[G + 1 | 0] | 0) + 1 >>> 1, e = e + 2 | 0, r >>> 0 > e >>> 0;);
                                                    }
                                                    if (v & 1) break k;
                                                    r = _ - 1 | 0;
                                                    break f;
                                                }
                                                if (r = _ - 1 | 0, r) {
                                                    for(P = (y + E | 0) - 1 | 0, f = (v + C | 0) - 1 | 0, $ = (y + F | 0) - 1 | 0, n = (w + v | 0) - 1 | 0, e = 0; G = e >>> 1 | 0, W = e | 1, o[$ + Z(G, r0) | 0] = (l[n + Z(e, M) | 0] + l[n + Z(W, M) | 0] | 0) + 1 >>> 1, o[P + Z(G, f0) | 0] = (l[f + Z(e, H) | 0] + l[f + Z(W, H) | 0] | 0) + 1 >>> 1, e = e + 2 | 0, e >>> 0 < r >>> 0;);
                                                    if (!t) break A;
                                                }
                                                e = R - 1 | 0, o[(y + (Z(e, r0) + F | 0) | 0) - 1 | 0] = l[((Z(r, M) + w | 0) + v | 0) - 1 | 0], o[(y + (Z(e, f0) + E | 0) | 0) - 1 | 0] = l[((Z(r, H) + C | 0) + v | 0) - 1 | 0];
                                            }
                                            if (!r) break r;
                                        }
                                        if (n = v - 1 | 0, !n) break r;
                                        for(f = 0;;){
                                            for(t = Z(f, H), y = Z(f, M), e = f | 1, R = Z(e, H), P = Z(e, M), e = f >>> 1 | 0, $ = Z(e, f0) + E | 0, G = Z(e, r0) + F | 0, e = 0; W = (e + R | 0) + C | 0, g0 = l[W + 1 | 0], W = l[W | 0], s0 = (e + t | 0) + C | 0, L = l[s0 | 0], s0 = l[s0 + 1 | 0], m0 = e >>> 1 | 0, Z0 = (e + P | 0) + w | 0, X0 = (e + y | 0) + w | 0, o[G + m0 | 0] = ((l[Z0 | 0] + (l[X0 | 0] + l[X0 + 1 | 0] | 0) | 0) + l[Z0 + 1 | 0] | 0) + 2 >>> 2, o[$ + m0 | 0] = ((W + (s0 + L | 0) | 0) + g0 | 0) + 2 >>> 2, e = e + 2 | 0, n >>> 0 > e >>> 0;);
                                            if (f = f + 2 | 0, !(f >>> 0 < r >>> 0)) break;
                                        }
                                    }
                                    if (_) for(r = v << (q >>> 0 > 8), e = 0; v0(Z(e, S) + I0 | 0, Z(e, T) + V0 | 0, v), c && v0(s + Z(e, k) | 0, Z(e, t0) + F0 | 0, r), e = e + 1 | 0, (_ | 0) != (e | 0););
                                    if (i[A + 4 >> 2] = h, i[A >> 2] = B, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), !V || (A = i[V + 4 >> 2], i[V + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[V >> 2] + 8 >> 2]](V), g(V);
                            }
                            m = u + 128 | 0;
                        }
                        function Mh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0;
                            u = m - 128 | 0, m = u, k = S0(i[e >> 2], 0), n = S0(i[e >> 2], 1), w = S0(i[e >> 2], 2), T = A1(i[e >> 2], 6), T && (c = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(k >>> 0 > 8 | n >>> 0 > 8) & w >>> 0 < 9)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((k | 0) == (n | 0) & (k | 0) == (w | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], y = i[f + 48 >> 2], y && (i[y + 4 >> 2] = i[y + 4 >> 2] + 1, f = i[e >> 2]), v = i[f + 28 >> 2], B = i[f + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), W = i[s + 4 >> 2], _ = W + 1 | 0, i[s + 4 >> 2] = _, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, r = s, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, f = r + 76 | 0, i[r + 72 >> 2] = f, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, V = r + 12 | 0, i[r + 12 >> 2] = V, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = W, i[r + 16 >> 2] = r, _ || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), i[V + 36 >> 2] = 3, i[V + 32 >> 2] = 0, i[V + 28 >> 2] = v, i[V + 24 >> 2] = B, J0(u + 56 | 0, V, 0, B, v, k, t), J0(u + 32 | 0, V, 1, B, v, n, t), r = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (k = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = k, o[u + 75 | 0] >= 0) {
                                            k = u - -64 | 0, n = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = n, i[r + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        j(r, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (k = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = k, o[u + 51 | 0] >= 0) {
                                        k = i[u + 44 >> 2], i[r >> 2] = i[u + 40 >> 2], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(r, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, V, 2, B, v, w, t), k = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (n = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = n, o[u + 99 | 0] >= 0) {
                                            n = i[r + 4 >> 2], i[k >> 2] = i[r >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[r + 8 >> 2];
                                            break e;
                                        }
                                        j(k, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[k >> 2] = i[u + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(k, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!T) break r;
                                        if (J0(u + 104 | 0, V, 6, B, v, c, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                r = i[u + 116 >> 2], i[A >> 2] = i[u + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(A, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], k = r - -64 | 0;
                                    r: {
                                        A: {
                                            t = i[r + 64 >> 2];
                                            f: {
                                                if (!t) {
                                                    w = 0;
                                                    break f;
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (e = 0, i[r + 16 >> 2] > 0)) break k;
                                                    t0 = i[r + 44 >> 2], e = i[r + 52 >> 2];
                                                }
                                                for(s0 = e, r = k, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                w = 0;
                                                k: {
                                                    if ((r | 0) == (k | 0) || (w = 0, i[r + 16 >> 2] > 1)) break k;
                                                    M = i[r + 44 >> 2], w = i[r + 52 >> 2];
                                                }
                                                for(r = k, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            W = 0;
                                            break r;
                                        }
                                        if (W = 0, i[r + 16 >> 2] > 2) break r;
                                        E = i[r + 52 >> 2], W = i[r + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (r = i[f >> 2], r) {
                                                for(n = f, e = r; h = i[e + 16 >> 2], n = (h | 0) < 0 ? n : e, e = i[(h >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 0)) break f;
                                                    L = i[n + 44 >> 2], e = i[n + 52 >> 2];
                                                }
                                                for(q = e, n = f, e = r; h = i[e + 16 >> 2] <= 0, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                h = 0;
                                                f: {
                                                    if ((f | 0) == (n | 0) || (h = 0, i[n + 16 >> 2] > 1)) break f;
                                                    H = i[n + 44 >> 2], h = i[n + 52 >> 2];
                                                }
                                                for(n = f, e = r; _ = i[e + 16 >> 2] < 2, n = _ ? n : e, e = i[(_ << 2) + e >> 2], !!e;);
                                                if ((f | 0) != (n | 0)) break A;
                                            }
                                            _ = 0;
                                            break r;
                                        }
                                        if (_ = 0, i[n + 16 >> 2] > 2) break r;
                                        R = i[n + 52 >> 2], _ = i[n + 44 >> 2];
                                    }
                                    n = 0, G = 0;
                                    r: {
                                        if (!T) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = k; G = i[t + 16 >> 2] < 6, e = G ? e : t, t = i[(G << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (k | 0)) break f;
                                                if (k = 0, i[e + 16 >> 2] > 6) break A;
                                                m0 = i[e + 44 >> 2], k = i[e + 52 >> 2];
                                                break A;
                                            }
                                            k = 0;
                                        }
                                        if (Z0 = k, G = 0, !r) break r;
                                        for(e = f; k = i[r + 16 >> 2] < 6, e = k ? e : r, r = i[(k << 2) + r >> 2], !!r;);
                                        if (G = 0, (e | 0) == (f | 0) || (G = 0, i[e + 16 >> 2] > 6)) break r;
                                        n = i[e + 52 >> 2], G = i[e + 44 >> 2];
                                    }
                                    r: {
                                        if (!v) break r;
                                        k = v & 1, F = v - 1 | 0;
                                        A: {
                                            if (!F) {
                                                e = 0;
                                                break A;
                                            }
                                            for(t = v & -2, e = 0, r = 0; o[Z(e, h) + H | 0] = l[Z(e, w) + M | 0], o[Z(e, R) + _ | 0] = l[Z(e, E) + W | 0], f = e | 1, o[Z(f, h) + H | 0] = l[Z(f, w) + M | 0], o[Z(f, R) + _ | 0] = l[Z(f, E) + W | 0], e = e + 2 | 0, r = r + 2 | 0, (t | 0) != (r | 0););
                                        }
                                        k && (o[Z(e, h) + H | 0] = l[Z(e, w) + M | 0], o[Z(e, R) + _ | 0] = l[Z(e, E) + W | 0]);
                                        A: {
                                            if (!(B & 1)) {
                                                if (!v) break r;
                                                r = (B + _ | 0) - 1 | 0, f = (B + H | 0) - 1 | 0, P = v & 1, e = B >>> 1 | 0, k = (e + W | 0) - 1 | 0, t = (e + M | 0) - 1 | 0;
                                                f: {
                                                    if (!F) {
                                                        e = 0;
                                                        break f;
                                                    }
                                                    for($ = v & -2, e = 0; o[f + Z(e, h) | 0] = l[t + Z(e, w) | 0], o[r + Z(e, R) | 0] = l[k + Z(e, E) | 0], F = e | 1, o[f + Z(F, h) | 0] = l[t + Z(w, F) | 0], o[r + Z(R, F) | 0] = l[k + Z(E, F) | 0], e = e + 2 | 0, S = S + 2 | 0, ($ | 0) != (S | 0););
                                                }
                                                if (!P) break A;
                                                o[f + Z(e, h) | 0] = l[t + Z(e, w) | 0], o[r + Z(e, R) | 0] = l[k + Z(e, E) | 0];
                                                break A;
                                            }
                                            if (!v) break r;
                                        }
                                        if (t = B - 1 | 0, t >>> 0 >= 2) for(r = 0;;){
                                            for(F = Z(r, E), P = Z(r, w), $ = Z(r, R) + _ | 0, S = Z(r, h) + H | 0, e = 1; C = e >>> 1 | 0, k = (C + F | 0) + W | 0, f = l[k | 0], k = l[k + 1 | 0], r0 = e + S | 0, C = (C + P | 0) + M | 0, f0 = l[C | 0], C = l[C + 1 | 0], o[r0 | 0] = (Z(f0, 3) + C | 0) + 2 >>> 2, o[r0 + 1 | 0] = (Z(C, 3) + f0 | 0) + 2 >>> 2, C = e + $ | 0, o[C + 1 | 0] = (f + Z(k, 3) | 0) + 2 >>> 2, o[C | 0] = (k + Z(f, 3) | 0) + 2 >>> 2, e = e + 2 | 0, t >>> 0 > e >>> 0;);
                                            if (r = r + 1 | 0, (v | 0) == (r | 0)) break;
                                        }
                                        for(r = B << (c >>> 0 > 8), e = 0; v0(Z(e, q) + L | 0, Z(e, s0) + t0 | 0, B), T && v0(Z(e, n) + G | 0, Z(e, Z0) + m0 | 0, r), e = e + 1 | 0, (v | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = V, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !y || (A = i[y + 4 >> 2], i[y + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[y >> 2] + 8 >> 2]](y), g(y);
                            }
                            m = u + 128 | 0;
                        }
                        function J7(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0;
                            v = m - 528 | 0, m = v, i[v + 520 >> 2] = w, i[v + 524 >> 2] = r;
                            i: {
                                if (S2(A, v + 524 | 0)) {
                                    i[n >> 2] = i[n >> 2] | 4, A = 0;
                                    break i;
                                }
                                i[v + 72 >> 2] = 1414, C = v + 72 | 0, y = s1(v + 104 | 0, v + 112 | 0, C), r = i[y >> 2], i[v + 100 >> 2] = r, i[v + 96 >> 2] = r + 400, r = m - 16 | 0, m = r, i[C >> 2] = 0, i[C + 4 >> 2] = 0, i[C + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, W = v + 60 | 0, i[W >> 2] = 0, i[W + 4 >> 2] = 0, i[W + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, G = v + 48 | 0, i[G >> 2] = 0, i[G + 4 >> 2] = 0, i[G + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, B = v + 36 | 0, i[B >> 2] = 0, i[B + 4 >> 2] = 0, i[B + 8 >> 2] = 0, m = r + 16 | 0, r = m - 16 | 0, m = r, V = v + 24 | 0, i[V >> 2] = 0, i[V + 4 >> 2] = 0, i[V + 8 >> 2] = 0, m = r + 16 | 0, w = m - 16 | 0, m = w, r = v;
                                e: {
                                    if (e) {
                                        _ = w + 4 | 0, f = K0(f, 108332), p[i[i[f >> 2] + 44 >> 2]](_, f), e = i[w + 4 >> 2], o[v + 92 | 0] = e, o[v + 93 | 0] = e >>> 8, o[v + 94 | 0] = e >>> 16, o[v + 95 | 0] = e >>> 24, p[i[i[f >> 2] + 32 >> 2]](_, f), A8(B, _), h1(_), p[i[i[f >> 2] + 28 >> 2]](_, f), A8(G, _), h1(_), E = v, R = p[i[i[f >> 2] + 12 >> 2]](f) | 0, i[E + 88 >> 2] = R, E = v, R = p[i[i[f >> 2] + 16 >> 2]](f) | 0, i[E + 84 >> 2] = R, p[i[i[f >> 2] + 20 >> 2]](_, f), $1(C, _), a0(_), p[i[i[f >> 2] + 24 >> 2]](_, f), A8(W, _), h1(_), e = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                        break e;
                                    }
                                    _ = w + 4 | 0, f = K0(f, 108324), p[i[i[f >> 2] + 44 >> 2]](_, f), e = i[w + 4 >> 2], o[v + 92 | 0] = e, o[v + 93 | 0] = e >>> 8, o[v + 94 | 0] = e >>> 16, o[v + 95 | 0] = e >>> 24, p[i[i[f >> 2] + 32 >> 2]](_, f), A8(B, _), h1(_), p[i[i[f >> 2] + 28 >> 2]](_, f), A8(G, _), h1(_), E = v, R = p[i[i[f >> 2] + 12 >> 2]](f) | 0, i[E + 88 >> 2] = R, E = v, R = p[i[i[f >> 2] + 16 >> 2]](f) | 0, i[E + 84 >> 2] = R, p[i[i[f >> 2] + 20 >> 2]](_, f), $1(C, _), a0(_), p[i[i[f >> 2] + 24 >> 2]](_, f), A8(W, _), h1(_), e = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                }
                                for(i[r + 20 >> 2] = e, m = w + 16 | 0, i[h >> 2] = i[s >> 2], F = k & 512, f = 0, r = 0;;){
                                    e = r;
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    if ((f | 0) == 4 || S2(A, v + 524 | 0)) break f;
                                                    w = 0;
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: switch(l[(v + 92 | 0) + f | 0]){
                                                                        case 1:
                                                                            if ((f | 0) == 3) break r;
                                                                            k = i[A >> 2], r = i[k + 12 >> 2];
                                                                            u: {
                                                                                if ((r | 0) == i[k + 16 >> 2]) {
                                                                                    r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                                    break u;
                                                                                }
                                                                                r = i[r >> 2];
                                                                            }
                                                                            if (p[i[i[u >> 2] + 12 >> 2]](u, 1, r) | 0) {
                                                                                Xo(v + 12 | 0, A), iA(V, i[v + 12 >> 2]);
                                                                                break o;
                                                                            }
                                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                            break A;
                                                                        case 4:
                                                                            break k;
                                                                        case 2:
                                                                            break n;
                                                                        case 3:
                                                                            break t;
                                                                        case 0:
                                                                            break s;
                                                                        default:
                                                                            break e;
                                                                    }
                                                                    if ((f | 0) == 3) break r;
                                                                }
                                                                for(;;){
                                                                    if (S2(A, v + 524 | 0)) break r;
                                                                    k = i[A >> 2], r = i[k + 12 >> 2];
                                                                    o: {
                                                                        if ((r | 0) == i[k + 16 >> 2]) {
                                                                            r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                            break o;
                                                                        }
                                                                        r = i[r >> 2];
                                                                    }
                                                                    if (!(p[i[i[u >> 2] + 12 >> 2]](u, 1, r) | 0)) break r;
                                                                    Xo(v + 12 | 0, A), iA(V, i[v + 12 >> 2]);
                                                                }
                                                            }
                                                            t: {
                                                                if (l[G + 11 | 0] >>> 7 | 0 ? r = i[G + 4 >> 2] : r = l[G + 11 | 0] & 127, !r) break t;
                                                                k = i[A >> 2], r = i[k + 12 >> 2];
                                                                o: {
                                                                    if ((r | 0) == i[k + 16 >> 2]) {
                                                                        r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                        break o;
                                                                    }
                                                                    r = i[r >> 2];
                                                                }
                                                                if (l[G + 11 | 0] >>> 7 | 0 ? k = i[G >> 2] : k = G, (r | 0) != i[k >> 2]) break t;
                                                                J1(A), o[t | 0] = 0, l[G + 11 | 0] >>> 7 | 0 ? r = i[G + 4 >> 2] : r = l[G + 11 | 0] & 127, r = r >>> 0 > 1 ? G : e;
                                                                break e;
                                                            }
                                                            t: {
                                                                if (l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, !r) break t;
                                                                k = i[A >> 2], r = i[k + 12 >> 2];
                                                                o: {
                                                                    if ((r | 0) == i[k + 16 >> 2]) {
                                                                        r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                        break o;
                                                                    }
                                                                    r = i[r >> 2];
                                                                }
                                                                if (l[B + 11 | 0] >>> 7 | 0 ? k = i[B >> 2] : k = B, (r | 0) != i[k >> 2]) break t;
                                                                J1(A), o[t | 0] = 1, l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, r = r >>> 0 > 1 ? B : e;
                                                                break e;
                                                            }
                                                            if (l[G + 11 | 0] >>> 7 | 0 ? r = i[G + 4 >> 2] : r = l[G + 11 | 0] & 127, r = !r, l[B + 11 | 0] >>> 7 | 0 ? k = i[B + 4 >> 2] : k = l[B + 11 | 0] & 127, !(r | !k)) {
                                                                i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                break A;
                                                            }
                                                            if (l[G + 11 | 0] >>> 7 | 0 ? r = i[G + 4 >> 2] : r = l[G + 11 | 0] & 127, !r && (l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, !r)) break r;
                                                            l[B + 11 | 0] >>> 7 | 0 ? r = i[B + 4 >> 2] : r = l[B + 11 | 0] & 127, o[t | 0] = !r;
                                                            break r;
                                                        }
                                                        if (!(F | (e | f >>> 0 < 2)) && (r = 0, !((f | 0) == 2 & l[v + 95 | 0] != 0))) break e;
                                                        E = v, R = Q4(W), i[E + 8 >> 2] = R, i[v + 12 >> 2] = i[v + 8 >> 2];
                                                        n: {
                                                            if (!f | l[(f + v | 0) + 91 | 0] > 1) break n;
                                                            for(;;){
                                                                t: {
                                                                    if (E = v, R = M8(W), i[E + 8 >> 2] = R, r = i[v + 12 >> 2], (r | 0) == i[v + 8 >> 2] || !(p[i[i[u >> 2] + 12 >> 2]](u, 1, i[r >> 2]) | 0)) break t;
                                                                    i[v + 12 >> 2] = i[v + 12 >> 2] + 4;
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            if (E = v, R = Q4(W), i[E + 8 >> 2] = R, l[V + 11 | 0] >>> 7 | 0 ? w = i[V + 4 >> 2] : w = l[V + 11 | 0] & 127, k = v + 8 | 0, r = i[v + 12 >> 2] - i[k >> 2] >> 2, w >>> 0 >= r >>> 0 && (E = v, R = M8(V), i[E + 8 >> 2] = R, _ = xA(k, 0 - r | 0), r = M8(V), w = Q4(W), k = m - 16 | 0, m = k, _ = H8(_), r = H8(r), r = O2(_, H8(w), r - _ & -4), m = k + 16 | 0, !r)) break n;
                                                            E = v, R = Q4(W), i[E + 4 >> 2] = R, i[v + 8 >> 2] = i[v + 4 >> 2], i[v + 12 >> 2] = i[v + 8 >> 2];
                                                        }
                                                        for(i[v + 8 >> 2] = i[v + 12 >> 2];;){
                                                            n: {
                                                                if (E = v, R = M8(W), i[E + 4 >> 2] = R, i[v + 8 >> 2] == i[v + 4 >> 2] || S2(A, v + 524 | 0)) break n;
                                                                k = i[A >> 2], r = i[k + 12 >> 2];
                                                                t: {
                                                                    if ((r | 0) == i[k + 16 >> 2]) {
                                                                        r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                        break t;
                                                                    }
                                                                    r = i[r >> 2];
                                                                }
                                                                if ((r | 0) != i[i[v + 8 >> 2] >> 2]) break n;
                                                                J1(A), i[v + 8 >> 2] = i[v + 8 >> 2] + 4;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        if (!F || (E = v, R = M8(W), i[E + 4 >> 2] = R, i[v + 8 >> 2] == i[v + 4 >> 2])) break r;
                                                        i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                        break A;
                                                    }
                                                    for(;;){
                                                        k: {
                                                            if (S2(A, v + 524 | 0)) break k;
                                                            k = i[A >> 2], r = i[k + 12 >> 2];
                                                            n: {
                                                                if ((r | 0) == i[k + 16 >> 2]) {
                                                                    r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                    break n;
                                                                }
                                                                r = i[r >> 2];
                                                            }
                                                            n: {
                                                                if (p[i[i[u >> 2] + 12 >> 2]](u, 64, r) | 0) {
                                                                    k = i[h >> 2], (k | 0) == i[v + 520 >> 2] && (C6(s, h, v + 520 | 0), k = i[h >> 2]), i[h >> 2] = k + 4, i[k >> 2] = r, w = w + 1 | 0;
                                                                    break n;
                                                                }
                                                                if (l[C + 11 | 0] >>> 7 | 0 ? k = i[C + 4 >> 2] : k = l[C + 11 | 0] & 127, !k | !w | (r | 0) != i[v + 84 >> 2]) break k;
                                                                r = i[v + 100 >> 2], (r | 0) == i[v + 96 >> 2] && (C6(y, v + 100 | 0, v + 96 | 0), r = i[v + 100 >> 2]), i[v + 100 >> 2] = r + 4, i[r >> 2] = w, w = 0;
                                                            }
                                                            J1(A);
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    r = i[v + 100 >> 2], !w | (r | 0) == i[y >> 2] || (i[v + 96 >> 2] == (r | 0) && (C6(y, v + 100 | 0, v + 96 | 0), r = i[v + 100 >> 2]), i[v + 100 >> 2] = r + 4, i[r >> 2] = w);
                                                    k: {
                                                        if (i[v + 20 >> 2] <= 0) break k;
                                                        n: {
                                                            if (!S2(A, v + 524 | 0)) {
                                                                k = i[A >> 2], r = i[k + 12 >> 2];
                                                                t: {
                                                                    if ((r | 0) == i[k + 16 >> 2]) {
                                                                        r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                        break t;
                                                                    }
                                                                    r = i[r >> 2];
                                                                }
                                                                if ((r | 0) == i[v + 88 >> 2]) break n;
                                                            }
                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                            break A;
                                                        }
                                                        for(;;){
                                                            if (J1(A), i[v + 20 >> 2] <= 0) break k;
                                                            n: {
                                                                if (!S2(A, v + 524 | 0)) {
                                                                    k = i[A >> 2], r = i[k + 12 >> 2];
                                                                    t: {
                                                                        if ((r | 0) == i[k + 16 >> 2]) {
                                                                            r = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                            break t;
                                                                        }
                                                                        r = i[r >> 2];
                                                                    }
                                                                    if (p[i[i[u >> 2] + 12 >> 2]](u, 64, r) | 0) break n;
                                                                }
                                                                i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                                break A;
                                                            }
                                                            i[h >> 2] == i[v + 520 >> 2] && C6(s, h, v + 520 | 0), k = i[A >> 2], r = i[k + 12 >> 2];
                                                            n: {
                                                                if ((r | 0) == i[k + 16 >> 2]) {
                                                                    k = p[i[i[k >> 2] + 36 >> 2]](k) | 0;
                                                                    break n;
                                                                }
                                                                k = i[r >> 2];
                                                            }
                                                            r = i[h >> 2], i[h >> 2] = r + 4, i[r >> 2] = k, i[v + 20 >> 2] = i[v + 20 >> 2] - 1;
                                                        }
                                                    }
                                                    if (r = e, i[s >> 2] != i[h >> 2]) break e;
                                                    i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                    break A;
                                                }
                                                f: {
                                                    if (!e) break f;
                                                    for(w = 1;;){
                                                        if (l[e + 11 | 0] >>> 7 | 0 ? r = i[e + 4 >> 2] : r = l[e + 11 | 0] & 127, r >>> 0 <= w >>> 0) break f;
                                                        k: {
                                                            if (!S2(A, v + 524 | 0)) {
                                                                f = i[A >> 2], r = i[f + 12 >> 2];
                                                                n: {
                                                                    if ((r | 0) == i[f + 16 >> 2]) {
                                                                        r = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                                                        break n;
                                                                    }
                                                                    r = i[r >> 2];
                                                                }
                                                                if (l[e + 11 | 0] >>> 7 | 0 ? f = i[e >> 2] : f = e, (r | 0) == i[f + (w << 2) >> 2]) break k;
                                                            }
                                                            i[n >> 2] = i[n >> 2] | 4, A = 0;
                                                            break A;
                                                        }
                                                        J1(A), w = w + 1 | 0;
                                                    }
                                                }
                                                if (A = 1, i[y >> 2] == i[v + 100 >> 2]) break A;
                                                if (A = 0, i[v + 12 >> 2] = 0, L1(C, i[y >> 2], i[v + 100 >> 2], v + 12 | 0), i[v + 12 >> 2]) {
                                                    i[n >> 2] = i[n >> 2] | 4;
                                                    break A;
                                                }
                                                A = 1;
                                            }
                                            h1(V), h1(B), h1(G), h1(W), a0(C), r = i[y >> 2], i[y >> 2] = 0, r && p[i[y + 4 >> 2]](r);
                                            break i;
                                        }
                                        r = e;
                                    }
                                    f = f + 1 | 0;
                                }
                            }
                            return m = v + 528 | 0, A;
                        }
                        function Uh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0;
                            n = m - 128 | 0, m = n, W = D(136), r = W, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), k = i[r + 4 >> 2], u = k + 1 | 0, i[r + 4 >> 2] = u, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[W + 132 >> 2] = 0, r = W, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, f = r + 76 | 0, i[r + 72 >> 2] = f, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, C = r + 12 | 0, i[r + 12 >> 2] = C, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = k, i[r + 16 >> 2] = r, u || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), k = i[e >> 2], V = i[k + 24 >> 2], r = V, B = i[k + 28 >> 2], k = B, i[C + 36 >> 2] = 1, i[C + 32 >> 2] = 0, i[C + 28 >> 2] = k, i[C + 24 >> 2] = r, G = S0(i[e >> 2], 0), J0(n + 56 | 0, C, 0, r, k, G, t), w = r + 1 | 0, u = w >>> 1 | 0, _ = k + 1 | 0, F = _ >>> 1 | 0, J0(n + 32 | 0, C, 1, u, F, G, t), r = n + 88 | 0;
                            i: {
                                if (i[n + 56 >> 2]) {
                                    if (k = i[n + 60 >> 2], i[n + 80 >> 2] = i[n + 56 >> 2], i[n + 84 >> 2] = k, o[n + 75 | 0] >= 0) {
                                        k = n - -64 | 0, s = i[k + 4 >> 2], i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = s, i[r + 8 >> 2] = i[k + 8 >> 2];
                                        break i;
                                    }
                                    j(r, i[n + 64 >> 2], i[n + 68 >> 2]);
                                    break i;
                                }
                                if (k = i[n + 36 >> 2], i[n + 80 >> 2] = i[n + 32 >> 2], i[n + 84 >> 2] = k, o[n + 51 | 0] >= 0) {
                                    k = i[n + 44 >> 2], i[r >> 2] = i[n + 40 >> 2], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[n + 48 >> 2];
                                    break i;
                                }
                                j(r, i[n + 40 >> 2], i[n + 44 >> 2]);
                            }
                            J0(n + 8 | 0, C, 2, u, F, G, t), k = n + 112 | 0;
                            i: {
                                if (i[n + 80 >> 2]) {
                                    if (s = i[n + 84 >> 2], i[n + 104 >> 2] = i[n + 80 >> 2], i[n + 108 >> 2] = s, o[n + 99 | 0] >= 0) {
                                        s = i[r + 4 >> 2], i[k >> 2] = i[r >> 2], i[k + 4 >> 2] = s, i[k + 8 >> 2] = i[r + 8 >> 2];
                                        break i;
                                    }
                                    j(k, i[n + 88 >> 2], i[n + 92 >> 2]);
                                    break i;
                                }
                                if (r = i[n + 12 >> 2], i[n + 104 >> 2] = i[n + 8 >> 2], i[n + 108 >> 2] = r, o[n + 27 | 0] >= 0) {
                                    r = i[n + 20 >> 2], i[k >> 2] = i[n + 16 >> 2], i[k + 4 >> 2] = r, i[k + 8 >> 2] = i[n + 24 >> 2];
                                    break i;
                                }
                                j(k, i[n + 16 >> 2], i[n + 20 >> 2]);
                            }
                            o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), o[n + 99 | 0] < 0 && X(i[n + 88 >> 2]), o[n + 51 | 0] < 0 && X(i[n + 40 >> 2]), o[n + 75 | 0] < 0 && X(i[n + 64 >> 2]);
                            i: {
                                if (i[n + 104 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 108 >> 2], i[A + 8 >> 2] = i[n + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 123 | 0] >= 0) {
                                        r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 8 >> 2];
                                        break i;
                                    }
                                    if (j(A, i[n + 112 >> 2], i[n + 116 >> 2]), o[n + 123 | 0] >= 0) break i;
                                    X(i[n + 112 >> 2]);
                                    break i;
                                }
                                o[n + 123 | 0] < 0 && X(i[n + 112 >> 2]), R = A1(i[e >> 2], 6);
                                e: {
                                    if (!R) break e;
                                    if (M = S0(i[e >> 2], 6), J0(n + 104 | 0, C, 6, V, B, M, t), i[n + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 108 >> 2], i[A + 8 >> 2] = i[n + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 123 | 0] >= 0) {
                                            r = i[n + 116 >> 2], i[A >> 2] = i[n + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 120 >> 2];
                                            break i;
                                        }
                                        if (j(A, i[n + 112 >> 2], i[n + 116 >> 2]), o[n + 123 | 0] >= 0) break i;
                                        X(i[n + 112 >> 2]);
                                        break i;
                                    }
                                    if (o[n + 123 | 0] >= 0) break e;
                                    X(i[n + 112 >> 2]);
                                }
                                r = i[e >> 2], k = r - -64 | 0, t = i[r + 64 >> 2];
                                e: {
                                    r: {
                                        A: {
                                            if (G >>> 0 <= 8) {
                                                if (w = 0, !t) break A;
                                                for(r = k; u = i[t + 16 >> 2], r = (u | 0) < 0 ? r : t, t = i[(u >>> 29 & 4) + t >> 2], !!t;);
                                                if ((r | 0) == (k | 0)) break A;
                                                if (s = 0, i[r + 16 >> 2] > 0) break r;
                                                h = i[r + 44 >> 2], s = i[r + 52 >> 2];
                                                break r;
                                            }
                                            f: {
                                                k: {
                                                    if (!t) break k;
                                                    for(r = k; s = i[t + 16 >> 2], r = (s | 0) < 0 ? r : t, t = i[(s >>> 29 & 4) + t >> 2], !!t;);
                                                    if ((r | 0) == (k | 0)) break k;
                                                    if (s = 0, i[r + 16 >> 2] > 0) break f;
                                                    H = i[r + 52 >> 2], s = i[r + 44 >> 2];
                                                    break f;
                                                }
                                                s = 0;
                                            }
                                            f: {
                                                k: {
                                                    t = i[f >> 2];
                                                    n: {
                                                        if (!t) {
                                                            k = 0;
                                                            break n;
                                                        }
                                                        for(k = f, r = t; h = i[r + 16 >> 2], k = (h | 0) < 0 ? k : r, r = i[(h >>> 29 & 4) + r >> 2], !!r;);
                                                        h = 0;
                                                        t: {
                                                            if ((f | 0) == (k | 0) || (h = 0, i[k + 16 >> 2] > 0)) break t;
                                                            T = i[k + 52 >> 2], h = i[k + 44 >> 2];
                                                        }
                                                        for(k = f, r = t; v = i[r + 16 >> 2] <= 0, k = v ? k : r, r = i[(v << 2) + r >> 2], !!r;);
                                                        r = 0;
                                                        t: {
                                                            if ((f | 0) == (k | 0) || (r = 0, i[k + 16 >> 2] > 1)) break t;
                                                            S = i[k + 44 >> 2], r = i[k + 52 >> 2];
                                                        }
                                                        for(k = r, r = f; v = i[t + 16 >> 2] < 2, r = v ? r : t, t = i[(v << 2) + t >> 2], !!t;);
                                                        if ((r | 0) != (f | 0)) break k;
                                                    }
                                                    t = 0;
                                                    break f;
                                                }
                                                if (t = 0, i[r + 16 >> 2] > 2) break f;
                                                P = i[r + 52 >> 2] >>> 1 | 0, t = i[r + 44 >> 2];
                                            }
                                            f: {
                                                if (_ >>> 0 >= 2) {
                                                    if (w >>> 0 < 2) break f;
                                                    for($ = k >>> 1 | 0, k = 128 << G - 8, c = u & 2147483644, _ = u & 3, w = 0, r0 = u - 1 >>> 0 < 3;;){
                                                        if (G = (Z(w, P) << 1) + t | 0, v = (Z(w, $) << 1) + S | 0, r = 0, y = 0, !r0) for(; u = r << 1, Q[u + v >> 1] = k, Q[u + G >> 1] = k, E = u | 2, Q[E + v >> 1] = k, Q[G + E >> 1] = k, E = u | 4, Q[E + v >> 1] = k, Q[G + E >> 1] = k, u = u | 6, Q[u + v >> 1] = k, Q[u + G >> 1] = k, r = r + 4 | 0, y = y + 4 | 0, (c | 0) != (y | 0););
                                                        if (u = 0, _) for(; y = r << 1, Q[y + v >> 1] = k, Q[G + y >> 1] = k, r = r + 1 | 0, u = u + 1 | 0, (_ | 0) != (u | 0););
                                                        if (w = w + 1 | 0, (F | 0) == (w | 0)) break;
                                                    }
                                                }
                                                if (!B) break e;
                                            }
                                            if (r = T >>> 1 | 0, k = H >>> 1 | 0, w = V << 1, t = 0, (B | 0) != 1) for(G = B & -2, u = 0; v0((Z(r, t) << 1) + h | 0, s + (Z(k, t) << 1) | 0, w), v = t | 1, v0((Z(v, r) << 1) + h | 0, s + (Z(k, v) << 1) | 0, w), t = t + 2 | 0, u = u + 2 | 0, (G | 0) != (u | 0););
                                            if (!(B & 1)) break e;
                                            v0((Z(r, t) << 1) + h | 0, s + (Z(k, t) << 1) | 0, w);
                                            break e;
                                        }
                                        s = 0;
                                    }
                                    r: {
                                        A: {
                                            t = i[f >> 2];
                                            f: {
                                                if (!t) {
                                                    k = 0, u = 0;
                                                    break f;
                                                }
                                                for(k = f, r = t; u = i[r + 16 >> 2], k = (u | 0) < 0 ? k : r, r = i[(u >>> 29 & 4) + r >> 2], !!r;);
                                                u = 0;
                                                k: {
                                                    if ((f | 0) == (k | 0) || (u = 0, i[k + 16 >> 2] > 0)) break k;
                                                    v = i[k + 44 >> 2], u = i[k + 52 >> 2];
                                                }
                                                for(k = f, r = t; _ = i[r + 16 >> 2] <= 0, k = _ ? k : r, r = i[(_ << 2) + r >> 2], !!r;);
                                                r = 0;
                                                k: {
                                                    if ((f | 0) == (k | 0) || (r = 0, i[k + 16 >> 2] > 1)) break k;
                                                    w = i[k + 44 >> 2], r = i[k + 52 >> 2];
                                                }
                                                for(k = r, r = f; _ = i[t + 16 >> 2] < 2, r = _ ? r : t, t = i[(_ << 2) + t >> 2], !!t;);
                                                if ((r | 0) != (f | 0)) break A;
                                            }
                                            _ = 0, t = 0;
                                            break r;
                                        }
                                        if (_ = 0, t = 0, i[r + 16 >> 2] > 2) break r;
                                        _ = i[r + 44 >> 2], t = i[r + 52 >> 2];
                                    }
                                    if (r = 1 << G - 1, B0(w, r, Z(k, F)), B0(_, r, Z(t, F)), !B) break e;
                                    if (t = 0, (B | 0) != 1) for(k = B & -2, r = 0; v0(Z(t, u) + v | 0, Z(t, s) + h | 0, V), w = t | 1, v0(Z(w, u) + v | 0, Z(w, s) + h | 0, V), t = t + 2 | 0, r = r + 2 | 0, (k | 0) != (r | 0););
                                    if (!(B & 1)) break e;
                                    v0(Z(t, u) + v | 0, Z(t, s) + h | 0, V);
                                }
                                e: {
                                    if (!R) break e;
                                    k = 0;
                                    r: {
                                        A: {
                                            if (r = i[e >> 2], t = i[r + 64 >> 2], !t) break A;
                                            for(e = r - -64 | 0, r = e; u = i[t + 16 >> 2] < 6, r = u ? r : t, t = i[(u << 2) + t >> 2], !!t;);
                                            if ((r | 0) == (e | 0)) break A;
                                            if (h = 0, u = 0, i[r + 16 >> 2] > 6) break r;
                                            h = i[r + 44 >> 2], u = i[r + 52 >> 2];
                                            break r;
                                        }
                                        h = 0, u = 0;
                                    }
                                    t = i[f >> 2], e = 0;
                                    r: {
                                        if (!t) break r;
                                        for(r = f; e = i[t + 16 >> 2] < 6, r = e ? r : t, t = i[(e << 2) + t >> 2], !!t;);
                                        if (e = 0, (r | 0) == (f | 0) || (e = 0, i[r + 16 >> 2] > 6)) break r;
                                        k = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                    }
                                    if (!B) break e;
                                    if (r = h, f = V << (M >>> 0 > 8), t = 0, (B | 0) != 1) for(s = B & -2, h = 0; v0(e + Z(k, t) | 0, r + Z(t, u) | 0, f), w = t | 1, v0(e + Z(w, k) | 0, r + Z(u, w) | 0, f), t = t + 2 | 0, h = h + 2 | 0, (s | 0) != (h | 0););
                                    if (!(B & 1)) break e;
                                    v0(e + Z(k, t) | 0, r + Z(t, u) | 0, f);
                                }
                                if (i[A + 4 >> 2] = W, i[A >> 2] = C, i[W + 4 >> 2] = i[W + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[W + 4 >> 2], i[W + 4 >> 2] = A - 1, A || (p[i[i[W >> 2] + 8 >> 2]](W), g(W)), m = n + 128 | 0;
                        }
                        function Hh(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            u = m - 16 | 0, m = u, n = i[k >> 2], t = n + i[e >> 2] | 0;
                            i: {
                                if (i[e + 4 >> 2] - t >>> 0 <= (f | 0) / 8 << 2 >>> 0) {
                                    if (r = D(56), i[u + 4 >> 2] = r, i[u + 8 >> 2] = 50, i[u + 12 >> 2] = -2147483592, e = l[7223] | l[7224] << 8 | (l[7225] << 16 | l[7226] << 24), f = l[7219] | l[7220] << 8 | (l[7221] << 16 | l[7222] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 50 | 0] = 0, e = l[7267] | l[7268] << 8, o[r + 48 | 0] = e, o[r + 49 | 0] = e >>> 8, e = l[7263] | l[7264] << 8 | (l[7265] << 16 | l[7266] << 24), f = l[7259] | l[7260] << 8 | (l[7261] << 16 | l[7262] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[7255] | l[7256] << 8 | (l[7257] << 16 | l[7258] << 24), f = l[7251] | l[7252] << 8 | (l[7253] << 16 | l[7254] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[7247] | l[7248] << 8 | (l[7249] << 16 | l[7250] << 24), f = l[7243] | l[7244] << 8 | (l[7245] << 16 | l[7246] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7239] | l[7240] << 8 | (l[7241] << 16 | l[7242] << 24), f = l[7235] | l[7236] << 8 | (l[7237] << 16 | l[7238] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7231] | l[7232] << 8 | (l[7233] << 16 | l[7234] << 24), f = l[7227] | l[7228] << 8 | (l[7229] << 16 | l[7230] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, u + 4 | 0), o[u + 15 | 0] >= 0) break i;
                                    X(i[u + 4 >> 2]);
                                    break i;
                                }
                                s = l[t | 0], h = l[t + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = n + 4 | 0, t = l[t + 3 | 0] | (h << 16 | s << 24 | l[t + 2 | 0] << 8);
                                        break e;
                                    }
                                    n = n + 2 | 0, t = (h << 16 | s << 24) >> 16;
                                }
                                i[k >> 2] = n, i[r + 4 >> 2] = t, n = i[k >> 2], t = n + i[e >> 2] | 0, s = l[t | 0], h = l[t + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = n + 4 | 0, t = l[t + 3 | 0] | (h << 16 | s << 24 | l[t + 2 | 0] << 8);
                                        break e;
                                    }
                                    n = n + 2 | 0, t = (h << 16 | s << 24) >> 16;
                                }
                                i[k >> 2] = n, i[r + 8 >> 2] = t, t = i[e >> 2], w = i[k >> 2], n = t + w | 0, s = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | s << 24 | l[n + 2 | 0] << 8), s = 4;
                                        break e;
                                    }
                                    n = h | s << 8, s = 2;
                                }
                                i[k >> 2] = s + w, i[r + 12 >> 2] = n, w = i[k >> 2], n = w + t | 0, s = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        f = l[n + 3 | 0] | (h << 16 | s << 24 | l[n + 2 | 0] << 8), n = 4;
                                        break e;
                                    }
                                    f = h | s << 8, n = 2;
                                }
                                if (i[k >> 2] = n + w, i[r + 16 >> 2] = f, f = i[k >> 2], n = l[f + t | 0], i[k >> 2] = f + 1, n) {
                                    if (r = D(56), i[u + 4 >> 2] = r, i[u + 8 >> 2] = 51, i[u + 12 >> 2] = -2147483592, e = l[13330] | l[13331] << 8 | (l[13332] << 16 | l[13333] << 24), f = l[13326] | l[13327] << 8 | (l[13328] << 16 | l[13329] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 51 | 0] = 0, e = l[13373] | l[13374] << 8 | (l[13375] << 16 | l[13376] << 24), o[r + 47 | 0] = e, o[r + 48 | 0] = e >>> 8, o[r + 49 | 0] = e >>> 16, o[r + 50 | 0] = e >>> 24, e = l[13370] | l[13371] << 8 | (l[13372] << 16 | l[13373] << 24), f = l[13366] | l[13367] << 8 | (l[13368] << 16 | l[13369] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[13362] | l[13363] << 8 | (l[13364] << 16 | l[13365] << 24), f = l[13358] | l[13359] << 8 | (l[13360] << 16 | l[13361] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[13354] | l[13355] << 8 | (l[13356] << 16 | l[13357] << 24), f = l[13350] | l[13351] << 8 | (l[13352] << 16 | l[13353] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[13346] | l[13347] << 8 | (l[13348] << 16 | l[13349] << 24), f = l[13342] | l[13343] << 8 | (l[13344] << 16 | l[13345] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13338] | l[13339] << 8 | (l[13340] << 16 | l[13341] << 24), f = l[13334] | l[13335] << 8 | (l[13336] << 16 | l[13337] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, u + 4 | 0), o[u + 15 | 0] >= 0) break i;
                                    X(i[u + 4 >> 2]);
                                    break i;
                                }
                                if (t = i[e + 4 >> 2] + ((f ^ -1) - t | 0) | 0, s = Z(i[r + 16 >> 2], i[r + 12 >> 2]), f = s >>> 3 | 0, t >>> 0 < f >>> 0) {
                                    if (r = D(64), i[u + 4 >> 2] = r, i[u + 8 >> 2] = 57, i[u + 12 >> 2] = -2147483584, e = l[15761] | l[15762] << 8 | (l[15763] << 16 | l[15764] << 24), f = l[15757] | l[15758] << 8 | (l[15759] << 16 | l[15760] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 57 | 0] = 0, o[r + 56 | 0] = l[15813], e = l[15809] | l[15810] << 8 | (l[15811] << 16 | l[15812] << 24), f = l[15805] | l[15806] << 8 | (l[15807] << 16 | l[15808] << 24), o[r + 48 | 0] = f, o[r + 49 | 0] = f >>> 8, o[r + 50 | 0] = f >>> 16, o[r + 51 | 0] = f >>> 24, o[r + 52 | 0] = e, o[r + 53 | 0] = e >>> 8, o[r + 54 | 0] = e >>> 16, o[r + 55 | 0] = e >>> 24, e = l[15801] | l[15802] << 8 | (l[15803] << 16 | l[15804] << 24), f = l[15797] | l[15798] << 8 | (l[15799] << 16 | l[15800] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[15793] | l[15794] << 8 | (l[15795] << 16 | l[15796] << 24), f = l[15789] | l[15790] << 8 | (l[15791] << 16 | l[15792] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[15785] | l[15786] << 8 | (l[15787] << 16 | l[15788] << 24), f = l[15781] | l[15782] << 8 | (l[15783] << 16 | l[15784] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[15777] | l[15778] << 8 | (l[15779] << 16 | l[15780] << 24), f = l[15773] | l[15774] << 8 | (l[15775] << 16 | l[15776] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[15769] | l[15770] << 8 | (l[15771] << 16 | l[15772] << 24), f = l[15765] | l[15766] << 8 | (l[15767] << 16 | l[15768] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, u + 4 | 0), o[u + 15 | 0] >= 0) break i;
                                    X(i[u + 4 >> 2]);
                                    break i;
                                }
                                t = r + 20 | 0, h = i[r + 20 >> 2], n = i[r + 24 >> 2] - h | 0;
                                e: {
                                    if (n >>> 0 < f >>> 0) {
                                        r1(t, f - n | 0);
                                        break e;
                                    }
                                    if (f >>> 0 >= n >>> 0) break e;
                                    i[r + 24 >> 2] = f + h;
                                }
                                if (s >>> 0 >= 8 && Q0(i[t >> 2], i[e >> 2] + i[k >> 2] | 0, f), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = u + 16 | 0;
                        }
                        function _3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0, D1 = 0, e4 = 0, r4 = 0, A4 = 0;
                            n = m + -64 | 0, m = n;
                            i: {
                                e: {
                                    u = i[A + 276 >> 2], t2 = (f | 0) > (u | 0) ? u : f;
                                    r: {
                                        if ((t2 | 0) <= (e | 0) || (e2 = i[A + 272 >> 2], v2 = (k | 0) > (e2 | 0) ? e2 : k, (v2 | 0) <= 0)) break r;
                                        for(v1 = r ? 1 : 2, p1 = r ? 2 : 1, y = i[A + 40 >> 2], y2 = y << 1, U2 = i[A + 124 >> 2], f = i[U2 + 16832 >> 2], H2 = f - 8 | 0, M = -1 << f ^ -1, V1 = r ? 4 : 3, Z0 = Z(y, 6), y1 = y << (r ^ 1) << 3, I1 = Z(e, y) << 3, D1 = i[A + 260 >> 2], P = y << 1, f0 = P << 1, X0 = 0 - P << 1, V0 = 0 - y << 1, I0 = Z(y, -6), j2 = y << 2, D0 = 0 - j2 << 1;;){
                                            for(g0 = e << 2, K2 = g0 - 1 | 0, e4 = Z(y, g0), r4 = Z(i1, y1) + I1 | 0, A4 = Z(g0 >> 2, e2) + D1 | 0, k2 = 0, H0 = 0;;){
                                                B = H0 << 2, t0 = l[(B >> 2) + A4 | 0] & 3;
                                                A: {
                                                    if (!t0) break A;
                                                    f = i[A + 4 >> 2], u = f + (B + e4 << 1) | 0;
                                                    f: {
                                                        if (!r) {
                                                            Q[n + 32 >> 1] = I[u >> 1], Q[n >> 1] = I[u + V0 >> 1], Q[n + 34 >> 1] = I[u + P >> 1], Q[n + 2 >> 1] = I[u + X0 >> 1], Q[n + 36 >> 1] = I[u + f0 >> 1], t = I[u + I0 >> 1], Q[n + 4 >> 1] = t, Q[n + 38 >> 1] = I[u + Z0 >> 1], s = I[u + D0 >> 1], Q[n + 6 >> 1] = s, f = u + 2 | 0, Q[n + 40 >> 1] = I[f >> 1], Q[n + 8 >> 1] = I[f + V0 >> 1], Q[n + 42 >> 1] = I[f + P >> 1], Q[n + 10 >> 1] = I[f + X0 >> 1], Q[n + 44 >> 1] = I[f + f0 >> 1], Q[n + 12 >> 1] = I[f + I0 >> 1], Q[n + 46 >> 1] = I[f + Z0 >> 1], Q[n + 14 >> 1] = I[f + D0 >> 1], f = u + 4 | 0, Q[n + 48 >> 1] = I[f >> 1], Q[n + 16 >> 1] = I[f + V0 >> 1], Q[n + 50 >> 1] = I[f + P >> 1], Q[n + 18 >> 1] = I[f + X0 >> 1], Q[n + 52 >> 1] = I[f + f0 >> 1], Q[n + 20 >> 1] = I[f + I0 >> 1], Q[n + 54 >> 1] = I[f + Z0 >> 1], Q[n + 22 >> 1] = I[f + D0 >> 1], k = u + 6 | 0, Q[n + 56 >> 1] = I[k >> 1], f = I[k + V0 >> 1], Q[n + 24 >> 1] = f, Q[n + 58 >> 1] = I[k + P >> 1], v = I[k + X0 >> 1], Q[n + 26 >> 1] = v, Q[n + 60 >> 1] = I[k + f0 >> 1], w = I[k + I0 >> 1], Q[n + 28 >> 1] = w, Q[n + 62 >> 1] = I[k + Z0 >> 1], k = k + D0 | 0;
                                                            break f;
                                                        }
                                                        f = f + ((k2 << V1) + r4 | 0) | 0, k = I[f + 4 >> 1] | I[f + 6 >> 1] << 16, i[n + 32 >> 2] = I[f >> 1] | I[f + 2 >> 1] << 16, i[n + 36 >> 2] = k, Q[n >> 1] = I[u - 2 >> 1], Q[n + 2 >> 1] = I[u - 4 >> 1], t = I[u - 6 >> 1], Q[n + 4 >> 1] = t, s = I[u - 8 >> 1], Q[n + 6 >> 1] = s, k = f + y2 | 0, v = I[k + 4 >> 1] | I[k + 6 >> 1] << 16, i[n + 40 >> 2] = I[k >> 1] | I[k + 2 >> 1] << 16, i[n + 44 >> 2] = v, k = u + P | 0, Q[n + 8 >> 1] = I[k - 2 >> 1], Q[n + 10 >> 1] = I[k - 4 >> 1], Q[n + 12 >> 1] = I[k - 6 >> 1], Q[n + 14 >> 1] = I[k - 8 >> 1], k = f + j2 | 0, v = I[k + 4 >> 1] | I[k + 6 >> 1] << 16, i[n + 48 >> 2] = I[k >> 1] | I[k + 2 >> 1] << 16, i[n + 52 >> 2] = v, k = u + f0 | 0, Q[n + 16 >> 1] = I[k - 2 >> 1], Q[n + 18 >> 1] = I[k - 4 >> 1], Q[n + 20 >> 1] = I[k - 6 >> 1], Q[n + 22 >> 1] = I[k - 8 >> 1], f = f + Z0 | 0, k = I[f + 4 >> 1] | I[f + 6 >> 1] << 16, i[n + 56 >> 2] = I[f >> 1] | I[f + 2 >> 1] << 16, i[n + 60 >> 2] = k, k = u + Z0 | 0, f = I[k - 2 >> 1], Q[n + 24 >> 1] = f, v = I[k - 4 >> 1], Q[n + 26 >> 1] = v, w = I[k - 6 >> 1], Q[n + 28 >> 1] = w, k = k - 8 | 0;
                                                    }
                                                    if (i2 = I[k >> 1], Q[n + 30 >> 1] = i2, F = i[A + 168 >> 2], k = B >> F, (k | 0) < 0 || (G = i[A + 172 >> 2], (G | 0) <= (k | 0))) break i;
                                                    if (_ = g0 >> F, (_ | 0) < 0 || (H = i[A + 176 >> 2], (H | 0) <= (_ | 0))) break e;
                                                    E = i[A + 160 >> 2], T = E + Z(k, 3) | 0, h = Z(Z(_, G), 3), $ = T + h | 0, F0 = o[$ + 2 | 0];
                                                    f: {
                                                        if (!r) {
                                                            if (k = K2 >> F, (k | 0) < 0 | (k | 0) >= (H | 0)) break e;
                                                            k = (T + Z(Z(k, G), 3) | 0) + 2 | 0;
                                                            break f;
                                                        }
                                                        if (k = B - 1 >> F, (k | 0) < 0 | k >>> 0 >= G >>> 0) break i;
                                                        k = (h + (E + Z(k, 3) | 0) | 0) + 2 | 0;
                                                    }
                                                    if (C = i[A + 148 >> 2], _ = B >> C, (_ | 0) < 0 || (s0 = i[A + 152 >> 2], (s0 | 0) <= (_ | 0))) break i;
                                                    if (C = g0 >> C, (C | 0) < 0 | (C | 0) >= i[A + 156 >> 2]) break e;
                                                    if (R = I[n + 56 >> 1], L = R + (I[n + 60 >> 1] - (I[n + 58 >> 1] << 1) | 0) | 0, W = L >> 31, q = ((w & 65535) - (v << 1) | 0) + f | 0, v = q >> 31, w = I[n + 32 >> 1], m0 = w + (I[n + 36 >> 1] - (I[n + 34 >> 1] << 1) | 0) | 0, c = m0 >> 31, r0 = I[n >> 1], V = r0 + (t - (I[n + 2 >> 1] << 1) | 0) | 0, t = V >> 31, W = (W ^ L) - W | 0, L = (v ^ q) - v | 0, q = W + L | 0, c = (c ^ m0) - c | 0, m0 = (t ^ V) - t | 0, V = c + m0 | 0, k = (F0 + o[k | 0] | 0) + 1 >> 1, v = i[i[A + 52 >> 2] + (I[((i[A + 140 >> 2] + Z(_, 24) | 0) + Z(Z(C, s0), 24) | 0) + 2 >> 1] << 2) >> 2], t = k + i[v + 764 >> 2] | 0, t = (t | 0) >= 51 ? 51 : t, _ = l[((t | 0) > 0 ? t : 0) + 48272 | 0] << H2, (q + V | 0) >= (_ | 0)) break A;
                                                    t = f, f = (i[v + 768 >> 2] + (k + (t0 << 1) | 0) | 0) - 2 | 0, f = (f | 0) >= 53 ? 53 : f, v = l[((f | 0) > 0 ? f : 0) + 48336 | 0] << H2, f = 0, t0 = _ >>> 2 | 0, k = 0;
                                                    f: {
                                                        if (t0 >>> 0 <= V << 1 >>> 0 || (F0 = w - I[n + 38 >> 1] | 0, C = F0 >> 31, s0 = s - r0 | 0, s = s0 >> 31, k = 0, (C ^ F0) - C + ((s ^ s0) - s) >>> 0 >= _ >>> 3 >>> 0)) break f;
                                                        s = r0 - w | 0, k = s >> 31, k = ((k ^ s) - k | 0) < Z(v, 5) + 1 >> 1;
                                                    }
                                                    s = k;
                                                    f: {
                                                        if (t0 >>> 0 <= q << 1 >>> 0 || (C = R - I[n + 62 >> 1] | 0, k = C >> 31, r0 = i2 - t | 0, w = r0 >> 31, (k ^ C) - k + ((w ^ r0) - w) >>> 0 >= _ >>> 3 >>> 0)) break f;
                                                        k = t - R | 0, f = k >> 31, f = ((f ^ k) - f | 0) < Z(v, 5) + 1 >> 1;
                                                    }
                                                    w = l[U2 + 8812 | 0];
                                                    f: {
                                                        if (!r) {
                                                            if (t = K2 >> F, w) {
                                                                if ((t | 0) < 0 | (t | 0) >= (H | 0)) break e;
                                                                k = !(l[(T + Z(Z(t, G), 3) | 0) + 1 | 0] & 4);
                                                            } else k = 1;
                                                            if ((t | 0) < 0 | (t | 0) >= (H | 0)) break e;
                                                            t = T + Z(Z(t, G), 3) | 0;
                                                            break f;
                                                        }
                                                        if (t = B - 1 >> F, w) {
                                                            if ((t | 0) < 0 | t >>> 0 >= G >>> 0) break i;
                                                            k = !(l[(h + (E + Z(t, 3) | 0) | 0) + 1 | 0] & 4);
                                                        } else k = 1;
                                                        if ((t | 0) < 0 | t >>> 0 >= G >>> 0) break i;
                                                        t = h + (E + Z(t, 3) | 0) | 0;
                                                    }
                                                    for(r0 = f & s, H = !(l[t + 1 | 0] & 8) & k, f = _ + (_ >>> 1 | 0) >>> 3 | 0, t0 = H & f >>> 0 > L + m0 >>> 0, k = f >>> 0 > W + c >>> 0, f = l[$ | 0] | l[$ + 1 | 0] << 8, _ = !(f & 2048) & (!w | !(f & 1024)), i2 = k & _, t = v << 1, f = 0, c = 0 - v | 0, F0 = Z(v, 10), s0 = u + 2 | 0, L = u - 4 | 0, q = u - 2 | 0, $ = v >> 1, C = 0 - $ | 0, m0 = u + P | 0;;){
                                                        G = f << 3, k = G + n | 0, s = I[k + 2 >> 1], h = G + (n + 32 | 0) | 0, E = I[h + 4 >> 1], G = I[h + 2 >> 1], B = I[h >> 1], T = I[k + 4 >> 1], F = I[k >> 1];
                                                        f: {
                                                            if (!r0) {
                                                                if (k = (Z(B - F | 0, 9) + Z(G - s | 0, -3) | 0) + 8 >> 4, h = k >> 31, (F0 | 0) <= ((k ^ h) - h | 0)) break f;
                                                                h = (k | 0) < (c | 0) ? c : (k | 0) < (v | 0) ? k : v;
                                                                k: {
                                                                    n: {
                                                                        if (!r) {
                                                                            if (H && (k = h + F | 0, Q[u + (f - y << 1) >> 1] = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0), !_) break k;
                                                                            k = B - h | 0, w = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0, k = f;
                                                                            break n;
                                                                        }
                                                                        if (H && (k = h + F | 0, Q[q + (Z(f, y) << 1) >> 1] = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0), !_) break k;
                                                                        k = B - h | 0, w = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0, k = Z(f, y);
                                                                    }
                                                                    Q[(k << 1) + u >> 1] = w;
                                                                }
                                                                if (t0 && (k = h + (((F + T | 0) + 1 >>> 1 | 0) - s | 0) >> 1, k = ((k | 0) < (C | 0) ? C : (k | 0) < ($ | 0) ? k : $) + s | 0, Q[(r ? L + (Z(f, y) << 1) | 0 : u + (f - y2 << 1) | 0) >> 1] = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0), !i2) break f;
                                                                if (k = ((B + E | 0) + 1 >>> 1) - (h + G) >> 1, k = G + ((k | 0) < (C | 0) ? C : (k | 0) < ($ | 0) ? k : $) | 0, k = (k | 0) >= 0 ? (k | 0) < (M | 0) ? k : M : 0, !r) {
                                                                    Q[m0 + (f << 1) >> 1] = k;
                                                                    break f;
                                                                }
                                                                Q[s0 + (Z(f, y) << 1) >> 1] = k;
                                                                break f;
                                                            }
                                                            if (R = G - t | 0, W = B + F | 0, V = W + G | 0, w = (V + E | 0) + 2 >>> 2 | 0, S = t + G | 0, w = (w | 0) < (R | 0) ? R : (w | 0) < (S | 0) ? w : S, S = s - t | 0, W = s + W | 0, R = (W + T | 0) + 2 >>> 2 | 0, R0 = t + s | 0, R = (R | 0) < (S | 0) ? S : (R | 0) < (R0 | 0) ? R : R0, S = E - t | 0, h = ((V + Z(E, 3) | 0) + (I[h + 6 >> 1] << 1) | 0) + 4 >>> 3 | 0, V = t + E | 0, h = (h | 0) < (S | 0) ? S : (h | 0) < (V | 0) ? h : V, V = T - t | 0, k = ((W + Z(T, 3) | 0) + (I[k + 6 >> 1] << 1) | 0) + 4 >>> 3 | 0, W = t + T | 0, W = (k | 0) < (V | 0) ? V : (k | 0) < (W | 0) ? k : W, V = B - t | 0, R0 = B << 1, S = (F << 1) + 4 | 0, k = E + ((R0 + (S + s | 0) | 0) + (G << 1) | 0) >>> 3 | 0, B = t + B | 0, B = (k | 0) < (V | 0) ? V : (k | 0) < (B | 0) ? k : B, E = F - t | 0, k = G + (R0 + ((T + S | 0) + (s << 1) | 0) | 0) >>> 3 | 0, s = t + F | 0, s = (k | 0) < (E | 0) ? E : (k | 0) < (s | 0) ? k : s, !r) {
                                                                if (k = u + (f << 1) | 0, !H) {
                                                                    if (!_) break f;
                                                                    Q[k >> 1] = B, Q[k + P >> 1] = w, Q[k + f0 >> 1] = h;
                                                                    break f;
                                                                }
                                                                if (!_) {
                                                                    Q[k + V0 >> 1] = s, Q[k + X0 >> 1] = R, Q[k + I0 >> 1] = W;
                                                                    break f;
                                                                }
                                                                Q[k + V0 >> 1] = s, Q[k >> 1] = B, Q[k + X0 >> 1] = R, Q[k + P >> 1] = w, Q[k + I0 >> 1] = W, Q[k + f0 >> 1] = h;
                                                                break f;
                                                            }
                                                            if (k = u + (Z(f, y) << 1) | 0, H && (Q[k - 2 >> 1] = s), _ && (Q[k >> 1] = B), H && (Q[k - 4 >> 1] = R), _ && (Q[k + 2 >> 1] = w), H && (Q[k - 6 >> 1] = W), !_) break f;
                                                            Q[k + 4 >> 1] = h;
                                                        }
                                                        if (f = f + 1 | 0, (f | 0) == 4) break;
                                                    }
                                                }
                                                if (k2 = k2 + 1 | 0, H0 = H0 + p1 | 0, !((v2 | 0) > (H0 | 0))) break;
                                            }
                                            if (i1 = i1 + 1 | 0, e = e + v1 | 0, !((t2 | 0) > (e | 0))) break;
                                        }
                                    }
                                    m = n - -64 | 0;
                                    return;
                                }
                                y0(4067, 9012, 119, 3731), z();
                            }
                            y0(4105, 9012, 118, 3731), z();
                        }
                        function R7(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = J(0), W = J(0);
                            v = m - 16 | 0, m = v, i[v + 12 >> 2] = e;
                            i: {
                                e: {
                                    if (s = i[k + 4 >> 2], !s) break e;
                                    n = i[k >> 2], u = R6(s), t = s - 1 & e;
                                    r: {
                                        if (u >>> 0 <= 1 || (t = e, e >>> 0 < s >>> 0)) break r;
                                        t = (e >>> 0) % (s >>> 0) | 0;
                                    }
                                    if (n = i[n + (t << 2) >> 2], !n || (n = i[n >> 2], !n)) break e;
                                    r: {
                                        if (u >>> 0 <= 1) {
                                            for(s = s - 1 | 0;;){
                                                u = i[n + 4 >> 2];
                                                A: {
                                                    if ((u | 0) != (e | 0)) {
                                                        if ((t | 0) == (s & u)) break A;
                                                        break e;
                                                    }
                                                    if (i[n + 8 >> 2] == (e | 0)) break r;
                                                }
                                                if (n = i[n >> 2], !n) break;
                                            }
                                            break e;
                                        }
                                        for(;;){
                                            u = i[n + 4 >> 2];
                                            A: {
                                                if ((u | 0) != (e | 0)) {
                                                    if (s >>> 0 <= u >>> 0 && (u = (u >>> 0) % (s >>> 0) | 0), (t | 0) == (u | 0)) break A;
                                                    break e;
                                                }
                                                if (i[n + 8 >> 2] == (e | 0)) break r;
                                            }
                                            if (n = i[n >> 2], !n) break;
                                        }
                                        break e;
                                    }
                                    if (f = D(24), i[v >> 2] = f, i[v + 4 >> 2] = 21, i[v + 8 >> 2] = -2147483624, e = l[11066] | l[11067] << 8 | (l[11068] << 16 | l[11069] << 24), r = l[11062] | l[11063] << 8 | (l[11064] << 16 | l[11065] << 24), o[f | 0] = r, o[f + 1 | 0] = r >>> 8, o[f + 2 | 0] = r >>> 16, o[f + 3 | 0] = r >>> 24, o[f + 4 | 0] = e, o[f + 5 | 0] = e >>> 8, o[f + 6 | 0] = e >>> 16, o[f + 7 | 0] = e >>> 24, o[f + 21 | 0] = 0, e = l[11079] | l[11080] << 8 | (l[11081] << 16 | l[11082] << 24), r = l[11075] | l[11076] << 8 | (l[11077] << 16 | l[11078] << 24), o[f + 13 | 0] = r, o[f + 14 | 0] = r >>> 8, o[f + 15 | 0] = r >>> 16, o[f + 16 | 0] = r >>> 24, o[f + 17 | 0] = e, o[f + 18 | 0] = e >>> 8, o[f + 19 | 0] = e >>> 16, o[f + 20 | 0] = e >>> 24, e = l[11074] | l[11075] << 8 | (l[11076] << 16 | l[11077] << 24), r = l[11070] | l[11071] << 8 | (l[11072] << 16 | l[11073] << 24), o[f + 8 | 0] = r, o[f + 9 | 0] = r >>> 8, o[f + 10 | 0] = r >>> 16, o[f + 11 | 0] = r >>> 24, o[f + 12 | 0] = e, o[f + 13 | 0] = e >>> 8, o[f + 14 | 0] = e >>> 16, o[f + 15 | 0] = e >>> 24, i0(A, 2, 2008, v), o[v + 11 | 0] >= 0) break i;
                                    X(i[v >> 2]);
                                    break i;
                                }
                                e = 0, u = i[v + 12 >> 2], t = i[k + 4 >> 2];
                                e: {
                                    r: {
                                        if (!t) break r;
                                        n = i[k >> 2], s = R6(t), e = u & t - 1;
                                        A: {
                                            if (s >>> 0 <= 1 || (e = u, e >>> 0 < t >>> 0)) break A;
                                            e = (e >>> 0) % (t >>> 0) | 0;
                                        }
                                        if (n = i[n + (e << 2) >> 2], !n || (h = i[n >> 2], !h)) break r;
                                        if (s >>> 0 <= 1) {
                                            for(s = t - 1 | 0;;){
                                                A: {
                                                    if (n = i[h + 4 >> 2], (n | 0) != (u | 0)) {
                                                        if ((n & s) != (e | 0)) break r;
                                                        break A;
                                                    }
                                                    if ((u | 0) != i[h + 8 >> 2]) break A;
                                                    e = 0;
                                                    break e;
                                                }
                                                if (h = i[h >> 2], !h) break;
                                            }
                                            break r;
                                        }
                                        for(;;){
                                            A: {
                                                if (n = i[h + 4 >> 2], (n | 0) != (u | 0)) {
                                                    if (n >>> 0 >= t >>> 0 && (n = (n >>> 0) % (t >>> 0) | 0), (e | 0) != (n | 0)) break r;
                                                    break A;
                                                }
                                                if ((u | 0) != i[h + 8 >> 2]) break A;
                                                e = 0;
                                                break e;
                                            }
                                            if (h = i[h >> 2], !h) break;
                                        }
                                    }
                                    h = D(12), i[h + 4 >> 2] = u, i[h >> 2] = 0, i[h + 8 >> 2] = i[v + 12 >> 2], G = J(i[k + 12 >> 2] + 1 >>> 0), W = W0[k + 16 >> 2];
                                    r: {
                                        if (!(G > J(W * J(t >>> 0))) && t) break r;
                                        e = 2, n = (t - 1 & t) != 0 | t >>> 0 < 3 | t << 1, G = J(o7(J(G / W)));
                                        A: {
                                            if (G < J(4294967296) & G >= J(0)) {
                                                s = ~~G >>> 0;
                                                break A;
                                            }
                                            s = 0;
                                        }
                                        n = n >>> 0 > s >>> 0 ? n : s;
                                        A: {
                                            if ((n | 0) == 1) break A;
                                            if (!(n & n - 1)) {
                                                e = n;
                                                break A;
                                            }
                                            e = x7(n), t = i[k + 4 >> 2];
                                        }
                                        A: {
                                            if (e >>> 0 <= t >>> 0) {
                                                if (e >>> 0 >= t >>> 0) break A;
                                                s = t >>> 0 < 3, G = J(o7(J(J(k0[k + 12 >> 2]) / W0[k + 16 >> 2])));
                                                f: {
                                                    if (G < J(4294967296) & G >= J(0)) {
                                                        n = ~~G >>> 0;
                                                        break f;
                                                    }
                                                    n = 0;
                                                }
                                                f: {
                                                    k: {
                                                        if (s || R6(t) >>> 0 > 1) break k;
                                                        n = n >>> 0 < 2 ? n : 1 << 32 - e1(n - 1 | 0);
                                                        break f;
                                                    }
                                                    n = x7(n);
                                                }
                                                if (e = e >>> 0 > n >>> 0 ? e : n, t >>> 0 <= e >>> 0) break A;
                                            }
                                            t = 0, s = e;
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            if (e) {
                                                                if (e >>> 0 >= 1073741824) break t;
                                                                if (e = D(e << 2), n = i[k >> 2], i[k >> 2] = e, n && X(n), i[k + 4 >> 2] = s, n = 0, s >>> 0 >= 4) for(e = s & 1073741820; B = n << 2, i[B + i[k >> 2] >> 2] = 0, i[(B + i[k >> 2] | 0) + 4 >> 2] = 0, i[(B + i[k >> 2] | 0) + 8 >> 2] = 0, i[(B + i[k >> 2] | 0) + 12 >> 2] = 0, n = n + 4 | 0, _ = _ + 4 | 0, (e | 0) != (_ | 0););
                                                                if (e = s & 3, e) for(; i[i[k >> 2] + (n << 2) >> 2] = 0, n = n + 1 | 0, t = t + 1 | 0, (e | 0) != (t | 0););
                                                                if (e = i[k + 8 >> 2], !e) break f;
                                                                if (n = k + 8 | 0, t = i[e + 4 >> 2], _ = R6(s), _ >>> 0 < 2) break n;
                                                                if (t = t >>> 0 >= s >>> 0 ? (t >>> 0) % (s >>> 0) | 0 : t, i[i[k >> 2] + (t << 2) >> 2] = n, n = i[e >> 2], !n) break f;
                                                                if (_ >>> 0 <= 1) break k;
                                                                for(;;){
                                                                    _ = i[n + 4 >> 2], s >>> 0 <= _ >>> 0 && (_ = (_ >>> 0) % (s >>> 0) | 0);
                                                                    o: {
                                                                        if ((t | 0) == (_ | 0)) {
                                                                            e = n;
                                                                            break o;
                                                                        }
                                                                        if (w = _ << 2, B = w + i[k >> 2] | 0, !i[B >> 2]) {
                                                                            i[B >> 2] = e, e = n, t = _;
                                                                            break o;
                                                                        }
                                                                        i[e >> 2] = i[n >> 2], i[n >> 2] = i[i[w + i[k >> 2] >> 2] >> 2], i[i[w + i[k >> 2] >> 2] >> 2] = n;
                                                                    }
                                                                    if (n = i[e >> 2], !n) break;
                                                                }
                                                                break f;
                                                            }
                                                            e = i[k >> 2], i[k >> 2] = 0, e && X(e), i[k + 4 >> 2] = 0;
                                                            break f;
                                                        }
                                                        Z2(), z();
                                                    }
                                                    if (t = s - 1 & t, i[i[k >> 2] + (t << 2) >> 2] = n, n = i[e >> 2], !n) break f;
                                                }
                                                for(B = s - 1 | 0;;){
                                                    _ = B & i[n + 4 >> 2];
                                                    k: {
                                                        if ((_ | 0) == (t | 0)) {
                                                            e = n;
                                                            break k;
                                                        }
                                                        if (w = _ << 2, s = w + i[k >> 2] | 0, i[s >> 2]) {
                                                            i[e >> 2] = i[n >> 2], i[n >> 2] = i[i[w + i[k >> 2] >> 2] >> 2], i[i[w + i[k >> 2] >> 2] >> 2] = n;
                                                            break k;
                                                        }
                                                        i[s >> 2] = e, e = n, t = _;
                                                    }
                                                    if (n = i[e >> 2], !n) break;
                                                }
                                            }
                                        }
                                        if (t = i[k + 4 >> 2], e = t - 1 | 0, !(e & t)) {
                                            e = e & u;
                                            break r;
                                        }
                                        if (t >>> 0 > u >>> 0) {
                                            e = u;
                                            break r;
                                        }
                                        e = (u >>> 0) % (t >>> 0) | 0;
                                    }
                                    n = i[k >> 2] + (e << 2) | 0, e = i[n >> 2];
                                    r: {
                                        A: {
                                            if (!e) {
                                                if (e = k + 8 | 0, i[h >> 2] = i[e >> 2], i[k + 8 >> 2] = h, i[n >> 2] = e, e = i[h >> 2], !e) break r;
                                                e = i[e + 4 >> 2], n = t - 1 | 0;
                                                f: {
                                                    if (!(n & t)) {
                                                        e = e & n;
                                                        break f;
                                                    }
                                                    if (e >>> 0 < t >>> 0) break f;
                                                    e = (e >>> 0) % (t >>> 0) | 0;
                                                }
                                                e = i[k >> 2] + (e << 2) | 0;
                                                break A;
                                            }
                                            i[h >> 2] = i[e >> 2];
                                        }
                                        i[e >> 2] = h;
                                    }
                                    i[k + 12 >> 2] = i[k + 12 >> 2] + 1, e = 1;
                                }
                                o[v + 4 | 0] = e, i[v >> 2] = h, Q8(v, i[f >> 2], i[v + 12 >> 2], 1684630887), n = i[v >> 2], e = i[v + 4 >> 2];
                                e: {
                                    if ((n | 0) != (e | 0)) for(;;){
                                        if (R7(A, r, i[n >> 2], f, k), i[A >> 2]) break e;
                                        if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), n = n + 4 | 0, (e | 0) == (n | 0)) break;
                                    }
                                    B = m - 16 | 0, m = B, u = i[k + 4 >> 2];
                                    r: {
                                        if (!u) break r;
                                        f = i[k >> 2], n = i[v + 12 >> 2], r = n & u - 1, e = R6(u);
                                        A: {
                                            if (e >>> 0 <= 1 || (r = n, n >>> 0 < u >>> 0)) break A;
                                            r = (n >>> 0) % (u >>> 0) | 0;
                                        }
                                        if (t = f, f = r, r = i[t + (f << 2) >> 2], !r || (r = i[r >> 2], !r)) break r;
                                        A: {
                                            if (e >>> 0 <= 1) {
                                                for(u = u - 1 | 0;;){
                                                    e = i[r + 4 >> 2];
                                                    f: {
                                                        if ((e | 0) != (n | 0)) {
                                                            if ((f | 0) == (e & u)) break f;
                                                            break r;
                                                        }
                                                        if ((n | 0) == i[r + 8 >> 2]) break A;
                                                    }
                                                    if (r = i[r >> 2], !r) break;
                                                }
                                                break r;
                                            }
                                            for(;;){
                                                e = i[r + 4 >> 2];
                                                f: {
                                                    if ((e | 0) != (n | 0)) {
                                                        if (e >>> 0 >= u >>> 0 && (e = (e >>> 0) % (u >>> 0) | 0), (e | 0) == (f | 0)) break f;
                                                        break r;
                                                    }
                                                    if ((n | 0) == i[r + 8 >> 2]) break A;
                                                }
                                                if (r = i[r >> 2], !r) break;
                                            }
                                            break r;
                                        }
                                        n = i[r + 4 >> 2], w = i[k + 4 >> 2], s = R6(w);
                                        A: {
                                            if (s >>> 0 <= 1) {
                                                n = w - 1 & n;
                                                break A;
                                            }
                                            if (n >>> 0 < w >>> 0) break A;
                                            n = (n >>> 0) % (w >>> 0) | 0;
                                        }
                                        for(u = i[k >> 2] + (n << 2) | 0, f = i[u >> 2]; e = f, f = i[e >> 2], (f | 0) != (r | 0););
                                        _ = k + 8 | 0;
                                        A: {
                                            if ((_ | 0) != (e | 0)) {
                                                f = i[e + 4 >> 2];
                                                f: {
                                                    if (s >>> 0 <= 1) {
                                                        f = w - 1 & f;
                                                        break f;
                                                    }
                                                    if (f >>> 0 < w >>> 0) break f;
                                                    f = (f >>> 0) % (w >>> 0) | 0;
                                                }
                                                if ((f | 0) == (n | 0)) break A;
                                            }
                                            if (f = i[r >> 2], f) {
                                                f = i[f + 4 >> 2];
                                                f: {
                                                    if (s >>> 0 <= 1) {
                                                        f = w - 1 & f;
                                                        break f;
                                                    }
                                                    if (f >>> 0 < w >>> 0) break f;
                                                    f = (f >>> 0) % (w >>> 0) | 0;
                                                }
                                                if ((f | 0) == (n | 0)) break A;
                                            }
                                            i[u >> 2] = 0;
                                        }
                                        u = i[r >> 2], t = 0;
                                        A: {
                                            if (!u) break A;
                                            f = i[u + 4 >> 2];
                                            f: {
                                                if (s >>> 0 <= 1) {
                                                    f = w - 1 & f;
                                                    break f;
                                                }
                                                if (f >>> 0 < w >>> 0) break f;
                                                f = (f >>> 0) % (w >>> 0) | 0;
                                            }
                                            if (t = u, (f | 0) == (n | 0)) break A;
                                            i[i[k >> 2] + (f << 2) >> 2] = e, t = i[r >> 2];
                                        }
                                        i[e >> 2] = t, i[r >> 2] = 0, i[k + 12 >> 2] = i[k + 12 >> 2] - 1, o[B + 12 | 0] = 1, i[B + 8 >> 2] = _, i[B + 4 >> 2] = r, r = i[B + 4 >> 2], i[B + 4 >> 2] = 0, r && X(r);
                                    }
                                    if (m = B + 16 | 0, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[v >> 2], !A) break i;
                                i[v + 4 >> 2] = A, X(A);
                            }
                            m = v + 16 | 0;
                        }
                        function xh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0;
                            u = m - 128 | 0, m = u, h = S0(i[e >> 2], 0), W = S0(i[e >> 2], 1), w = S0(i[e >> 2], 2), M = A1(i[e >> 2], 6), M && (c = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(h >>> 0 < 9 | W >>> 0 < 9) & w >>> 0 > 8)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((h | 0) == (W | 0) & (h | 0) == (w | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], C = i[f + 48 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1, f = i[e >> 2]), v = i[f + 28 >> 2], V = i[f + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), n = i[s + 4 >> 2], f = n + 1 | 0, i[s + 4 >> 2] = f, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, k = s + 76 | 0, i[s + 72 >> 2] = k, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, _ = s + 12 | 0, i[s + 12 >> 2] = _, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, f || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), i[_ + 36 >> 2] = 2, i[_ + 32 >> 2] = 0, i[_ + 28 >> 2] = v, i[_ + 24 >> 2] = V, J0(u + 56 | 0, _, 0, V, v, h, t), B = V + 1 >>> 1 | 0, J0(u + 32 | 0, _, 1, B, v, W, t), n = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (r = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = r, o[u + 75 | 0] >= 0) {
                                            f = u - -64 | 0, r = i[f + 4 >> 2], i[n >> 2] = i[f >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        j(n, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = r, o[u + 51 | 0] >= 0) {
                                        r = i[u + 44 >> 2], i[n >> 2] = i[u + 40 >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(n, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, _, 2, B, v, w, t), f = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (r = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = r, o[u + 99 | 0] >= 0) {
                                            r = i[n + 4 >> 2], i[f >> 2] = i[n >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[n + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[f >> 2] = i[u + 16 >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            A = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!M) break r;
                                        if (J0(u + 104 | 0, _, 6, V, v, c, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                A = i[u + 116 >> 2], i[r >> 2] = i[u + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], f = r - -64 | 0;
                                    r: {
                                        A: {
                                            if (t = i[r + 64 >> 2], t) {
                                                for(r = f, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (e = 0, i[r + 16 >> 2] > 0)) break f;
                                                    t0 = i[r + 44 >> 2], e = i[r + 52 >> 2];
                                                }
                                                for(s0 = e, r = f, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (e = 0, i[r + 16 >> 2] > 1)) break f;
                                                    F = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                                }
                                                for(r0 = e, r = f, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (f | 0)) break A;
                                            }
                                            W = 0;
                                            break r;
                                        }
                                        if (W = 0, i[r + 16 >> 2] > 2) break r;
                                        y = i[r + 52 >> 2], W = i[r + 44 >> 2];
                                    }
                                    r: {
                                        A: {
                                            if (r = i[k >> 2], r) {
                                                for(n = k, e = r; G = i[e + 16 >> 2], n = (G | 0) < 0 ? n : e, e = i[(G >>> 29 & 4) + e >> 2], !!e;);
                                                G = 0;
                                                f: {
                                                    if ((k | 0) == (n | 0) || (G = 0, i[n + 16 >> 2] > 0)) break f;
                                                    L = i[n + 44 >> 2], G = i[n + 52 >> 2];
                                                }
                                                for(n = k, e = r; w = i[e + 16 >> 2] <= 0, n = w ? n : e, e = i[(w << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((k | 0) == (n | 0) || (e = 0, i[n + 16 >> 2] > 1)) break f;
                                                    E = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                                }
                                                for(f0 = e, n = k, e = r; w = i[e + 16 >> 2] < 2, n = w ? n : e, e = i[(w << 2) + e >> 2], !!e;);
                                                if ((k | 0) != (n | 0)) break A;
                                            }
                                            w = 0;
                                            break r;
                                        }
                                        if (w = 0, i[n + 16 >> 2] > 2) break r;
                                        H = i[n + 52 >> 2] >>> 1 | 0, w = i[n + 44 >> 2];
                                    }
                                    n = 0, h = 0;
                                    r: {
                                        if (!M) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = f; R = i[t + 16 >> 2] < 6, e = R ? e : t, t = i[(R << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (f | 0)) break f;
                                                if (R = 0, i[e + 16 >> 2] > 6) break A;
                                                q = i[e + 44 >> 2], R = i[e + 52 >> 2];
                                                break A;
                                            }
                                            R = 0;
                                        }
                                        if (h = 0, !r) break r;
                                        for(e = k; f = i[r + 16 >> 2] < 6, e = f ? e : r, r = i[(f << 2) + r >> 2], !!r;);
                                        if (h = 0, (e | 0) == (k | 0) || (h = 0, i[e + 16 >> 2] > 6)) break r;
                                        n = i[e + 52 >> 2], h = i[e + 44 >> 2];
                                    }
                                    r = h, T = E >>> 1 | 0, S = y >>> 1 | 0, P = F >>> 1 | 0;
                                    r: {
                                        A: {
                                            f: {
                                                if (!(V & 1)) break f;
                                                if (k = v - 1 | 0, !k) break A;
                                                if (f = B << 1, B = (f + w | 0) - 2 | 0, e = V << 1, F = (e + W | 0) - 2 | 0, E = (f + f0 | 0) - 2 | 0, h = (e + r0 | 0) - 2 | 0, e = 0, (v | 0) != 2) for(f = k & -2; Q[E + (Z(e, T) << 1) >> 1] = I[h + (Z(e, P) << 1) >> 1], Q[B + (Z(e, H) << 1) >> 1] = I[F + (Z(e, S) << 1) >> 1], t = e | 1, Q[E + (Z(t, T) << 1) >> 1] = I[h + (Z(t, P) << 1) >> 1], Q[B + (Z(t, H) << 1) >> 1] = I[F + (Z(t, S) << 1) >> 1], e = e + 2 | 0, $ = $ + 2 | 0, (f | 0) != ($ | 0););
                                                if (!(k & 1)) break f;
                                                Q[E + (Z(e, T) << 1) >> 1] = I[h + (Z(e, P) << 1) >> 1], Q[B + (Z(e, H) << 1) >> 1] = I[F + (Z(e, S) << 1) >> 1];
                                            }
                                            if (!v) break r;
                                        }
                                        if (B = V - 1 | 0, B) for(y = 0;;){
                                            for(F = Z(y, S), E = Z(y, P), $ = (Z(y, H) << 1) + w | 0, h = (Z(y, T) << 1) + f0 | 0, e = 0; f = (e + F << 1) + W | 0, t = I[f >> 1], k = I[f + 2 >> 1], f = (e + E << 1) + r0 | 0, Q[e + h >> 1] = (I[f >> 1] + I[f + 2 >> 1] | 0) + 1 >>> 1, Q[e + $ >> 1] = (k + t | 0) + 1 >>> 1, e = e + 2 | 0, B >>> 0 > e >>> 0;);
                                            if (y = y + 1 | 0, (v | 0) == (y | 0)) break;
                                        }
                                        for(G = G >>> 1 | 0, t = s0 >>> 1 | 0, k = V << 1, f = c >>> 0 > 8 ? k : V, e = 0; v0((Z(e, G) << 1) + L | 0, (Z(e, t) << 1) + t0 | 0, k), M && v0(Z(e, n) + r | 0, Z(e, R) + q | 0, f), e = e + 1 | 0, (v | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = _, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                            }
                            m = u + 128 | 0;
                        }
                        function v8(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0;
                            h = m - 160 | 0, m = h;
                            i: {
                                e: {
                                    if (_ = i[A + 18588 >> 2], u = i[_ + 168 >> 2], s = r >> u, (s | 0) < 0 || (n = i[_ + 172 >> 2], (n | 0) <= (s | 0))) break e;
                                    if (u = e >> u, (u | 0) < 0 | (u | 0) >= i[_ + 176 >> 2]) break i;
                                    S = i[_ + 132 >> 2], R = i[_ + 124 >> 2], w = l[((i[_ + 160 >> 2] + Z(s, 3) | 0) + Z(Z(n, u), 3) | 0) + 1 | 0];
                                    r: {
                                        if (k || (s = i[_ + 248 >> 2], n = f - s | 0, (n | 0) == 31)) break r;
                                        for(u = e >> s, n = 1 << n, W = u + n | 0, s = r >> s, B = s + n | 0;;){
                                            for(n = s; t = (i[_ + 240 >> 2] + n | 0) + Z(i[_ + 252 >> 2], u) | 0, o[t | 0] = l[t | 0] | 128, n = n + 1 | 0, (B | 0) > (n | 0););
                                            if (u = u + 1 | 0, !((W | 0) > (u | 0))) break;
                                        }
                                    }
                                    t0 = w & 3, n = A + k | 0, P = n, u = 0;
                                    r: {
                                        if (!l[S + 25 | 0] || (u = 0, l[A + 32 | 0]) || (u = 0, i[S + 8276 >> 2] < (f | 0))) break r;
                                        u = s2(A + 18548 | 0, i[A + 18572 >> 2] + (k ? 142 : 141) | 0);
                                    }
                                    o[n + 33 | 0] = u, o[A + 36 | 0] = 0;
                                    r: {
                                        if (!(l[n + 33 | 0] | l[A + 32 | 0]) | (!l[R + 16823 | 0] | (t0 | 0) != 1) || (s = A + 18548 | 0, u = (k | 0) != 0, n = s2(s, (u + i[A + 18572 >> 2] | 0) + 143 | 0), o[A + 36 | 0] = n, !(n & 255))) break r;
                                        D0 = A, H0 = s2(s, (u + i[A + 18572 >> 2] | 0) + 145 | 0), o[D0 + 37 | 0] = H0;
                                    }
                                    B = !k << 1, B = l[P + 33 | 0] | l[A + 32 | 0] ? B | 1 : B, w = f << 1;
                                    r: {
                                        if (!k) {
                                            t = f + 1 >> 2, n = (Z(f, 3) + (f - 1 >> 2) | 0) - 6 | 0;
                                            break r;
                                        }
                                        t = f - 2 | 0, n = 15;
                                    }
                                    v = i[A + 18572 >> 2], u = w - 1 | 0;
                                    r: {
                                        if ((w | 0) < 2) {
                                            n = u;
                                            break r;
                                        }
                                        W = n + (v + 25 | 0) | 0, s = A + 18548 | 0, n = 0;
                                        A: {
                                            for(;;){
                                                if (!s2(s, W + (n >>> t | 0) | 0)) break A;
                                                if (n = n + 1 | 0, (u | 0) == (n | 0)) break;
                                            }
                                            n = u;
                                        }
                                        v = i[A + 18572 >> 2];
                                    }
                                    r: {
                                        if (!k) {
                                            t = (Z(f, 3) + (f - 1 >> 2) | 0) - 6 | 0, s = f + 1 >> 2;
                                            break r;
                                        }
                                        t = 15, s = f - 2 | 0;
                                    }
                                    r: {
                                        if ((w | 0) < 2) break r;
                                        for(w = t + (v + 43 | 0) | 0, W = A + 18548 | 0, t = 0;;){
                                            if (!s2(W, w + (t >>> s | 0) | 0)) {
                                                u = t;
                                                break r;
                                            }
                                            if (t = t + 1 | 0, (u | 0) == (t | 0)) break;
                                        }
                                    }
                                    (n | 0) >= 4 && (s = (n >>> 1 | 0) - 1 | 0, n = i8(A + 18548 | 0, s) + ((n & 1 | 2) << s) | 0), (u | 0) >= 4 && (s = (u >>> 1 | 0) - 1 | 0, u = i8(A + 18548 | 0, s) + ((u & 1 | 2) << s) | 0);
                                    r: {
                                        A: {
                                            if (t0) {
                                                t = 0;
                                                break A;
                                            }
                                            f: {
                                                if (!k) {
                                                    if (t = i[_ + 208 >> 2], W = r >> t, (W | 0) < 0 || (s = i[_ + 212 >> 2], (s | 0) <= (W | 0))) break e;
                                                    if (t = e >> t, (t | 0) < 0 | (t | 0) >= i[_ + 216 >> 2]) break i;
                                                    s = l[(W + i[_ + 200 >> 2] | 0) + Z(t, s) | 0], v = s >>> 0 <= 34 ? s : 0, s = 0;
                                                    break f;
                                                }
                                                if (t = i[_ + 228 >> 2], W = r >> t, (W | 0) < 0 || (s = i[_ + 232 >> 2], (s | 0) <= (W | 0))) break e;
                                                if (t = e >> t, (t | 0) < 0 | (t | 0) >= i[_ + 236 >> 2]) break i;
                                                v = l[(W + i[_ + 220 >> 2] | 0) + Z(t, s) | 0] & 63, s = k;
                                            }
                                            t = 2, W = s, s = 0;
                                            f: {
                                                k: {
                                                    n: switch(f - 2 | 0){
                                                        case 0:
                                                            break k;
                                                        case 1:
                                                            break n;
                                                        default:
                                                            break f;
                                                    }
                                                    if (!W) break k;
                                                    if (i[R + 16848 >> 2] != 3) break f;
                                                }
                                                if (s = 2, v - 6 >>> 0 < 9) break f;
                                                s = v - 22 >>> 0 < 9;
                                            }
                                            if ((s | 0) != 2) {
                                                t = s;
                                                break A;
                                            }
                                            s = u;
                                            break r;
                                        }
                                        s = n, n = u;
                                    }
                                    for(E = f - 2 | 0, u = E, t >>> 0 <= 2 ? W = i[i[(t << 2) + 50648 >> 2] + (u << 2) >> 2] : W = 0, m0 = t >>> 0 <= 2 ? i[i[(t << 2) + 50648 >> 2] + 8 >> 2] : 0, n = (i[(Z(t, 24) + (f << 2) | 0) + 50576 >> 2] + (n << f << 1) | 0) + (s << 1) | 0, n = l[n | 0] | l[n + 1 | 0] << 8, o[h + 158 | 0] = n, o[h + 159 | 0] = n >>> 8, H = l[h + 158 | 0], Z0 = l[h + 159 | 0], B0(h + 80 | 0, 0, 1 << E << E), T = ((k << 1) + A | 0) + 14396 | 0, Q[T >> 1] = 0, s = k ? 43 : 42, $ = (k | 0) > 0, V0 = $ ? 17 : 1, y = A + 18548 | 0, c = (A + B | 0) + 18580 | 0, I0 = Z0 - 1 | 0, F0 = E << 6 | ((k | 0) != 0) << 5 | ((t | 0) != 0) << 4, n = k << 11, g0 = n + (A + 2108 | 0) | 0, R0 = n + (A + 8252 | 0) | 0, M = 1, n = H;;){
                                        u = (n << 1) + W | 0, t = l[u + 1 | 0], w = l[u | 0], r0 = n, G = (n | 0) != 0;
                                        r: {
                                            A: {
                                                if (!(G & n >>> 0 < H >>> 0)) {
                                                    if ((n | 0) != (H | 0) && n) break r;
                                                    B = 0;
                                                    break A;
                                                }
                                                if (B = 1, n = l[h + 80 + (w + (t << E)) | 0], n = n & 1 | n >>> 1, !s2(y, (i[A + 18572 >> 2] + (k ? n + 2 | 0 : n) | 0) + 61 | 0)) break r;
                                            }
                                            if (w && (n = (w + (t << E) | 0) + h | 0, o[n + 79 | 0] = l[n + 79 | 0] | 1), v = 0, u = 0, t && (n = h + 80 + (w + (t - 1 << E)) | 0, o[n | 0] = l[n | 0] | 2, u = t), n = ((l[h + 80 + (w + (u << E)) | 0] << 2) + F0 | 0) + 103968 | 0, (H | 0) == (r0 | 0) && (o[h | 0] = 1, Q[h + 48 >> 1] = 1, o[h + 32 | 0] = Z0, v = 1), f0 = i[n >> 2], s0 = u << 2, L = w << 2, u = (H | 0) != (r0 | 0) ? 15 : I0, (u | 0) > 0) for(V = f0 + L | 0, n = u;;){
                                                t = (n << 1) + m0 | 0, F = l[t + 1 | 0], w = l[t | 0], C = i[A + 18572 >> 2];
                                                A: {
                                                    if (l[R + 16821 | 0] && (t = s, l[A + 32 | 0] | l[P + 33 | 0])) break A;
                                                    t = l[(w + V | 0) + (F + s0 << f) | 0];
                                                }
                                                if (s2(y, (C + (t & 255) | 0) + 65 | 0) && (o[h + v | 0] = 1, o[(h + 32 | 0) + v | 0] = n, Q[(h + 48 | 0) + (v << 1) >> 1] = 1, v = v + 1 | 0, B = 0), t = (n | 0) > 1, n = n - 1 | 0, !t) break;
                                            }
                                            A: {
                                                if ((u | 0) < 0) break A;
                                                if (!B) {
                                                    u = i[A + 18572 >> 2];
                                                    f: {
                                                        if (l[R + 16821 | 0] && (n = s, l[A + 32 | 0] | l[P + 33 | 0])) break f;
                                                        n = l[(f0 + L | 0) + (s0 << f) | 0];
                                                    }
                                                    if (!s2(y, (u + (n & 255) | 0) + 65 | 0)) break A;
                                                }
                                                o[h + v | 0] = 1, o[(h + 32 | 0) + v | 0] = 0, Q[(h + 48 | 0) + (v << 1) >> 1] = 1, v = v + 1 | 0;
                                            }
                                            if (!v) break r;
                                            B = 1;
                                            A: {
                                                if ((v | 0) <= 0) break A;
                                                G = !M | ($ ? 0 : G << 1), V = G << 2, C = s2(y, (i[A + 18572 >> 2] + (V | V0) | 0) + 109 | 0);
                                                f: {
                                                    if (C) {
                                                        Q[h + 48 >> 1] = I[h + 48 >> 1] + 1, B = 0, u = 0;
                                                        break f;
                                                    }
                                                    o[h | 0] = 0, B = 2, u = -1;
                                                }
                                                if (t = 1, (v | 0) != 1) for(F = (v | 0) >= 8 ? 8 : v, n = 1;;){
                                                    n = (n | 0) > 0 ? (C | 0) != 1 ? n + 1 | 0 : 0 : n, w = V + ((n | 0) >= 3 ? 3 : n) | 0, C = s2(y, (i[A + 18572 >> 2] + ($ ? w + 16 | 0 : w) | 0) + 109 | 0);
                                                    f: {
                                                        if (C) {
                                                            B = (h + 48 | 0) + (t << 1) | 0, Q[B >> 1] = I[B >> 1] + 1, u = (u | 0) == -1 ? t : u, B = 0;
                                                            break f;
                                                        }
                                                        o[t + h | 0] = 0, B = (B - 1 >>> 0 < 2) + B | 0;
                                                    }
                                                    if (t = t + 1 | 0, (F | 0) == (t | 0)) break;
                                                }
                                                if ((u | 0) == -1) break A;
                                                t = s2(y, (i[A + 18572 >> 2] + ($ ? G | 4 : G) | 0) + 133 | 0), o[u + h | 0] = t, n = (h + 48 | 0) + (u << 1) | 0, Q[n >> 1] = t + I[n >> 1];
                                            }
                                            A: {
                                                if (!k) {
                                                    if (u = i[_ + 208 >> 2], t = r >> u, (t | 0) < 0 || (n = i[_ + 212 >> 2], (n | 0) <= (t | 0))) break e;
                                                    if (u = e >> u, (u | 0) < 0 | (u | 0) >= i[_ + 216 >> 2]) break i;
                                                    n = l[(t + i[_ + 200 >> 2] | 0) + Z(n, u) | 0], u = n >>> 0 <= 34 ? n : 0;
                                                    break A;
                                                }
                                                if (u = i[_ + 228 >> 2], t = r >> u, (t | 0) < 0 || (n = i[_ + 232 >> 2], (n | 0) <= (t | 0))) break e;
                                                if (u = e >> u, (u | 0) < 0 | (u | 0) >= i[_ + 236 >> 2]) break i;
                                                u = l[(t + i[_ + 220 >> 2] | 0) + Z(n, u) | 0] & 63;
                                            }
                                            n = 0, V = 0;
                                            A: {
                                                if (l[A + 32 | 0] || !(!l[R + 16822 | 0] | t0 | (u & 239) != 10) && (V = 0, l[P + 33 | 0]) || (V = 0, l[A + 36 | 0])) break A;
                                                V = (o[h + 32 | 0] - o[(h + v | 0) + 31 | 0] | 0) > 3;
                                            }
                                            if (q = v - 1 | 0, (v | 0) > 1) for(; D0 = (h + 16 | 0) + n | 0, H0 = S1(y), o[D0 | 0] = H0, n = n + 1 | 0, (q | 0) != (n | 0););
                                            if (G = 0, u = q + (h + 16 | 0) | 0, V & l[S + 15 | 0] != 0 ? n = 0 : n = S1(y), o[u | 0] = n, G = l[R + 16827 | 0] ? l[c | 0] >>> 2 | 0 : G, u = 1, C = 0, M = 0, (v | 0) > 0) for(;;){
                                                F = Q[(h + 48 | 0) + (C << 1) >> 1], n = -1;
                                                A: {
                                                    if (!l[h + C | 0]) {
                                                        n = 0;
                                                        break A;
                                                    }
                                                    X0 = 3 << G, t = F, F = t;
                                                    f: {
                                                        for(;;){
                                                            if (f0 = S1(y), w = n, t = 0, (n | 0) == 64) break f;
                                                            if (n = n + 1 | 0, !f0) break;
                                                        }
                                                        if ((w | 0) <= 2) {
                                                            t = i8(y, G) + (n << G) | 0;
                                                            break f;
                                                        }
                                                        n = w - 2 | 0, t = i8(y, n + G | 0) + ((1 << n) + 2 << G) | 0;
                                                    }
                                                    if (n = t, t = F + n | 0, !l[R + 16827 | 0]) {
                                                        if (u = 0, (t | 0) <= (X0 | 0)) break A;
                                                        G = ((G | 0) >= 3 ? 3 : G) + 1 | 0;
                                                        break A;
                                                    }
                                                    if (G = ((t | 0) > (X0 | 0)) + G | 0, t = u, u = 0, !t) break A;
                                                    if (w = l[c | 0], t = w >>> 2 | 0, 3 << t <= (n | 0)) {
                                                        o[c | 0] = w + 1;
                                                        break A;
                                                    }
                                                    if (!w | n << 1 >= 1 << t) break A;
                                                    o[c | 0] = w - 1;
                                                }
                                                if (n = n + F | 0, n = l[(h + 16 | 0) + C | 0] ? 0 - n | 0 : n, t = (o[(h + 32 | 0) + C | 0] << 1) + m0 | 0, F = l[t + 1 | 0], w = l[t | 0], t = (Q[T >> 1] << 1) + g0 | 0, V & l[S + 15 | 0] != 0 && (M = (n & 65535) + M | 0, n = (C | 0) != (q | 0) ? n : M & 1 ? 0 - n | 0 : n), Q[t >> 1] = n, Q[(Q[T >> 1] << 1) + R0 >> 1] = (w + L | 0) + (F + s0 << f), Q[T >> 1] = I[T >> 1] + 1, C = C + 1 | 0, (C | 0) == (v | 0)) break;
                                            }
                                            M = B;
                                        }
                                        if (n = r0 - 1 | 0, !((r0 | 0) > 0)) break;
                                    }
                                    m = h + 160 | 0;
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function B3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            n = m - 208 | 0, m = n, s = i[r + 108 >> 2], h = i[r + 104 >> 2], w = s - h >> 5;
                            i: {
                                if ((s | 0) == (h | 0)) break i;
                                for(u = w >>> 0 <= 1 ? 1 : w;;){
                                    if (i[(t << 5) + h >> 2] == (e | 0)) break i;
                                    if (t = t + 1 | 0, (u | 0) == (t | 0)) break;
                                }
                                t = u;
                            }
                            if (_ = r + 104 | 0, (t | 0) == (w | 0)) {
                                Q[n + 44 >> 1] = 0, Q[n + 46 >> 1] = 0, Q[n + 48 >> 1] = 0, Q[n + 50 >> 1] = 0, Q[n + 38 >> 1] = 0, Q[n + 40 >> 1] = 0, Q[n + 42 >> 1] = 0, Q[n + 44 >> 1] = 0, Q[n + 30 >> 1] = 0, Q[n + 32 >> 1] = 0, Q[n + 34 >> 1] = 0, Q[n + 36 >> 1] = 0, o[n + 28 | 0] = k, i[n + 24 >> 2] = e;
                                i: {
                                    if (s >>> 0 < k0[r + 112 >> 2]) {
                                        e = i[n + 28 >> 2], i[s >> 2] = i[n + 24 >> 2], i[s + 4 >> 2] = e, e = i[n + 36 >> 2], i[s + 8 >> 2] = i[n + 32 >> 2], i[s + 12 >> 2] = e, i[s + 24 >> 2] = 0, i[s + 16 >> 2] = 0, i[s + 20 >> 2] = 0, $3(s + 16 | 0, 0, 0, 0), i[r + 108 >> 2] = s + 32;
                                        break i;
                                    }
                                    if (e = J5(_, n + 24 | 0), u = i[n + 40 >> 2], i[r + 108 >> 2] = e, !u) break i;
                                    if (e = u, h = i[n + 44 >> 2], (e | 0) != (h | 0)) {
                                        for(; e = i[h - 16 >> 2], e && (i[h - 12 >> 2] = e, X(e)), h = h - 40 | 0, (u | 0) != (h | 0););
                                        e = i[n + 40 >> 2];
                                    }
                                    i[n + 44 >> 2] = u, X(e);
                                }
                                h = i[_ >> 2];
                            }
                            i[n + 200 >> 2] = 0, i[n + 192 >> 2] = 0, i[n + 196 >> 2] = 0, i[n + 184 >> 2] = 0, i[n + 188 >> 2] = 0, i[n + 176 >> 2] = 0, i[n + 180 >> 2] = 0, i[n + 168 >> 2] = 0, i[n + 172 >> 2] = 0, u = i[f + 4 >> 2], s = i[f >> 2], v = u - s | 0, i[n + 184 >> 2] = v, i[n + 188 >> 2] = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (!(!(o[r + 132 | 0] & 1) | k)) {
                                                    if (r = Zt(i[r + 136 >> 2], s, v), (r | 0) < 0) {
                                                        i[n + 32 >> 2] = 59808, i[n + 88 >> 2] = 59828, r = i[14961], i[n + 24 >> 2] = r, e = i[r - 12 >> 2], k = n + 24 | 0, r = k, i[e + r >> 2] = i[14962], i[n + 28 >> 2] = 0, r = r + i[i[n + 24 >> 2] - 12 >> 2] | 0, f = n + 36 | 0, T0(r, f), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[n + 32 >> 2] = r, e = n + 32 | 0, i[e + i[r - 12 >> 2] >> 2] = i[14964], r = i[14960], i[n + 24 >> 2] = r, i[k + i[r - 12 >> 2] >> 2] = i[14965], i[n + 88 >> 2] = 59828, i[n + 24 >> 2] = 59788, i[n + 32 >> 2] = 59808, k = z0(f), i[k >> 2] = 58864, i[n + 76 >> 2] = 0, i[n + 80 >> 2] = 0, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, i[n + 84 >> 2] = 24, P0(U(e, 21465, 35), i[26064]), r = i[n + 84 >> 2];
                                                        k: {
                                                            if (r & 16) {
                                                                t = i[n + 80 >> 2], r = i[n + 60 >> 2], t >>> 0 < r >>> 0 && (i[n + 80 >> 2] = r, t = r), r = n + 56 | 0;
                                                                break k;
                                                            }
                                                            if (!(r & 8)) {
                                                                t = 0, o[n + 23 | 0] = 0, e = n + 12 | 0;
                                                                break e;
                                                            }
                                                            t = i[n + 52 >> 2], r = n + 44 | 0;
                                                        }
                                                        if (f = i[r >> 2], t = t - f | 0, t >>> 0 >= 2147483640) break A;
                                                        if (t >>> 0 >= 11) {
                                                            r = (t | 7) + 1 | 0, e = D(r), i[n + 20 >> 2] = r | -2147483648, i[n + 12 >> 2] = e, i[n + 16 >> 2] = t;
                                                            break r;
                                                        }
                                                        if (o[n + 23 | 0] = t, e = n + 12 | 0, t) break r;
                                                        t = 0;
                                                        break e;
                                                    }
                                                    if ((r | 0) == (i[f + 4 >> 2] - i[f >> 2] | 0)) break f;
                                                    if (r = D(48), i[n + 24 >> 2] = r, i[n + 28 >> 2] = 43, i[n + 32 >> 2] = -2147483600, f = l[20368] | l[20369] << 8 | (l[20370] << 16 | l[20371] << 24), e = l[20364] | l[20365] << 8 | (l[20366] << 16 | l[20367] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = f, o[r + 5 | 0] = f >>> 8, o[r + 6 | 0] = f >>> 16, o[r + 7 | 0] = f >>> 24, o[r + 43 | 0] = 0, e = l[20403] | l[20404] << 8 | (l[20405] << 16 | l[20406] << 24), o[r + 39 | 0] = e, o[r + 40 | 0] = e >>> 8, o[r + 41 | 0] = e >>> 16, o[r + 42 | 0] = e >>> 24, f = l[20400] | l[20401] << 8 | (l[20402] << 16 | l[20403] << 24), e = l[20396] | l[20397] << 8 | (l[20398] << 16 | l[20399] << 24), o[r + 32 | 0] = e, o[r + 33 | 0] = e >>> 8, o[r + 34 | 0] = e >>> 16, o[r + 35 | 0] = e >>> 24, o[r + 36 | 0] = f, o[r + 37 | 0] = f >>> 8, o[r + 38 | 0] = f >>> 16, o[r + 39 | 0] = f >>> 24, f = l[20392] | l[20393] << 8 | (l[20394] << 16 | l[20395] << 24), e = l[20388] | l[20389] << 8 | (l[20390] << 16 | l[20391] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = f, o[r + 29 | 0] = f >>> 8, o[r + 30 | 0] = f >>> 16, o[r + 31 | 0] = f >>> 24, f = l[20384] | l[20385] << 8 | (l[20386] << 16 | l[20387] << 24), e = l[20380] | l[20381] << 8 | (l[20382] << 16 | l[20383] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = f, o[r + 21 | 0] = f >>> 8, o[r + 22 | 0] = f >>> 16, o[r + 23 | 0] = f >>> 24, f = l[20376] | l[20377] << 8 | (l[20378] << 16 | l[20379] << 24), e = l[20372] | l[20373] << 8 | (l[20374] << 16 | l[20375] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = f, o[r + 13 | 0] = f >>> 8, o[r + 14 | 0] = f >>> 16, o[r + 15 | 0] = f >>> 24, i0(A, 9, 0, n + 24 | 0), o[n + 35 | 0] >= 0) break i;
                                                    X(i[n + 24 >> 2]);
                                                    break i;
                                                }
                                                if (e = (t << 5) + h | 0, w = i[e + 20 >> 2], (w | 0) != i[e + 16 >> 2]) {
                                                    if (e = w - 16 | 0, r = w - 12 | 0, G8(e, i[r >> 2], s, u, v), e = i[r >> 2] - i[e >> 2] | 0, r = w - 24 | 0, i[r >> 2] = e, i[r + 4 >> 2] = 0, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                        break i;
                                                    }
                                                    j(r, i[21670], i[21671]);
                                                    break i;
                                                }
                                                if (e = n + 192 | 0, (e | 0) != (f | 0) && b4(e, s, u, v), (k | 0) != 1) break f;
                                                k = i[r + 128 >> 2], e = k, i[n + 176 >> 2] = e, i[n + 180 >> 2] = e >> 31, e = i[f + 4 >> 2] - i[f >> 2] | 0, i[n + 184 >> 2] = e, i[n + 188 >> 2] = 0, i[r + 128 >> 2] = e + k;
                                            }
                                            k = i[_ >> 2] + (t << 5) | 0, r = i[k + 20 >> 2];
                                            f: {
                                                if (k0[k + 24 >> 2] > r >>> 0) {
                                                    e = i[n + 172 >> 2], i[r >> 2] = i[n + 168 >> 2], i[r + 4 >> 2] = e, e = i[n + 188 >> 2], i[r + 16 >> 2] = i[n + 184 >> 2], i[r + 20 >> 2] = e, e = i[n + 180 >> 2], i[r + 8 >> 2] = i[n + 176 >> 2], i[r + 12 >> 2] = e, i[r + 32 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 24 >> 2] = i[n + 192 >> 2], i[r + 28 >> 2] = i[n + 196 >> 2], i[r + 32 >> 2] = i[n + 200 >> 2], i[n + 200 >> 2] = 0, i[n + 192 >> 2] = 0, i[n + 196 >> 2] = 0, r = r + 40 | 0;
                                                    break f;
                                                }
                                                e = 0;
                                                k: {
                                                    n: {
                                                        if (r = i[k + 16 >> 2], t = (i[k + 20 >> 2] - r | 0) / 40 | 0, u = t + 1 | 0, u >>> 0 < 107374183) {
                                                            if (f = (i[k + 24 >> 2] - r | 0) / 40 | 0, r = f << 1, u = f >>> 0 >= 53687091 ? 107374182 : r >>> 0 > u >>> 0 ? r : u, u) {
                                                                if (u >>> 0 >= 107374183) break n;
                                                                e = D(Z(u, 40));
                                                            }
                                                            f = i[n + 172 >> 2], r = Z(t, 40) + e | 0, i[r >> 2] = i[n + 168 >> 2], i[r + 4 >> 2] = f, f = i[n + 188 >> 2], i[r + 16 >> 2] = i[n + 184 >> 2], i[r + 20 >> 2] = f, f = i[n + 180 >> 2], i[r + 8 >> 2] = i[n + 176 >> 2], i[r + 12 >> 2] = f, i[r + 24 >> 2] = i[n + 192 >> 2], i[r + 28 >> 2] = i[n + 196 >> 2], i[r + 32 >> 2] = i[n + 200 >> 2], i[n + 200 >> 2] = 0, i[n + 192 >> 2] = 0, i[n + 196 >> 2] = 0, _ = Z(u, 40) + e | 0, t = r + 40 | 0, f = i[k + 20 >> 2], v = i[k + 16 >> 2];
                                                            t: {
                                                                if ((f | 0) == (v | 0)) {
                                                                    e = r;
                                                                    break t;
                                                                }
                                                                for(; u = f - 40 | 0, s = i[u + 4 >> 2], e = r - 40 | 0, i[e >> 2] = i[u >> 2], i[e + 4 >> 2] = s, s = i[u + 20 >> 2], i[e + 16 >> 2] = i[u + 16 >> 2], i[e + 20 >> 2] = s, s = i[u + 12 >> 2], i[e + 8 >> 2] = i[u + 8 >> 2], i[e + 12 >> 2] = s, s = r - 8 | 0, i[s >> 2] = 0, w = f - 16 | 0, i[r - 16 >> 2] = i[w >> 2], i[r - 12 >> 2] = i[f - 12 >> 2], r = f - 8 | 0, i[s >> 2] = i[r >> 2], i[r >> 2] = 0, i[w >> 2] = 0, i[w + 4 >> 2] = 0, r = e, f = u, (f | 0) != (v | 0););
                                                                f = i[k + 20 >> 2], v = i[k + 16 >> 2];
                                                            }
                                                            if (i[k + 20 >> 2] = t, i[k + 16 >> 2] = e, i[k + 24 >> 2] = _, (f | 0) != (v | 0)) for(; r = i[f - 16 >> 2], r && (i[f - 12 >> 2] = r, X(r)), f = f - 40 | 0, (v | 0) != (f | 0););
                                                            v && X(v), r = t;
                                                            break k;
                                                        }
                                                        p0(), z();
                                                    }
                                                    Z2(), z();
                                                }
                                            }
                                            if (i[k + 20 >> 2] = r, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                                A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(r, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(e, f, t);
                                }
                                o[e + t | 0] = 0, i0(A, 9, 0, n + 12 | 0), o[n + 23 | 0] < 0 && X(i[n + 12 >> 2]), A = i[14959], i[n + 24 >> 2] = A, i[i[A - 12 >> 2] + (n + 24 | 0) >> 2] = i[14967], i[n + 32 >> 2] = i[14968], i[k >> 2] = 58864, o[n + 79 | 0] < 0 && X(i[n + 68 >> 2]), x0(k), N0(n + 88 | 0);
                            }
                            A = i[n + 192 >> 2], A && (i[n + 196 >> 2] = A, X(A)), m = n + 208 | 0;
                        }
                        function zh(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0;
                            u = m - 128 | 0, m = u, v = S0(i[e >> 2], 0), E = S0(i[e >> 2], 1), h = S0(i[e >> 2], 2), T = A1(i[e >> 2], 6), T && (r0 = S0(i[e >> 2], 6));
                            i: {
                                if (!(!(v >>> 0 > 8 | E >>> 0 > 8) & h >>> 0 < 9)) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                if (!((v | 0) == (E | 0) & (v | 0) == (h | 0))) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                f = i[e >> 2], C = i[f + 48 >> 2], C && (i[C + 4 >> 2] = i[C + 4 >> 2] + 1, f = i[e >> 2]), _ = i[f + 28 >> 2], B = i[f + 24 >> 2], s = D(136), i[s >> 2] = 78252, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, B0(s + 20 | 0, 0, 104), n = i[s + 4 >> 2], f = n + 1 | 0, i[s + 4 >> 2] = f, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 44 >> 2] = 99, i[s + 48 >> 2] = 99, i[s + 32 >> 2] = 4142, r = s - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, k = s + 76 | 0, i[s + 72 >> 2] = k, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, G = s + 12 | 0, i[s + 12 >> 2] = G, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, f || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), i[G + 36 >> 2] = 2, i[G + 32 >> 2] = 0, i[G + 28 >> 2] = _, i[G + 24 >> 2] = B, J0(u + 56 | 0, G, 0, B, _, v, t), W = B + 1 >>> 1 | 0, J0(u + 32 | 0, G, 1, W, _, E, t), n = u + 88 | 0;
                                e: {
                                    if (i[u + 56 >> 2]) {
                                        if (r = i[u + 60 >> 2], i[u + 80 >> 2] = i[u + 56 >> 2], i[u + 84 >> 2] = r, o[u + 75 | 0] >= 0) {
                                            f = u - -64 | 0, r = i[f + 4 >> 2], i[n >> 2] = i[f >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        j(n, i[u + 64 >> 2], i[u + 68 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 36 >> 2], i[u + 80 >> 2] = i[u + 32 >> 2], i[u + 84 >> 2] = r, o[u + 51 | 0] >= 0) {
                                        r = i[u + 44 >> 2], i[n >> 2] = i[u + 40 >> 2], i[n + 4 >> 2] = r, i[n + 8 >> 2] = i[u + 48 >> 2];
                                        break e;
                                    }
                                    j(n, i[u + 40 >> 2], i[u + 44 >> 2]);
                                }
                                J0(u + 8 | 0, G, 2, W, _, h, t), f = u + 112 | 0;
                                e: {
                                    if (i[u + 80 >> 2]) {
                                        if (r = i[u + 84 >> 2], i[u + 104 >> 2] = i[u + 80 >> 2], i[u + 108 >> 2] = r, o[u + 99 | 0] >= 0) {
                                            r = i[n + 4 >> 2], i[f >> 2] = i[n >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[n + 8 >> 2];
                                            break e;
                                        }
                                        j(f, i[u + 88 >> 2], i[u + 92 >> 2]);
                                        break e;
                                    }
                                    if (r = i[u + 12 >> 2], i[u + 104 >> 2] = i[u + 8 >> 2], i[u + 108 >> 2] = r, o[u + 27 | 0] >= 0) {
                                        r = i[u + 20 >> 2], i[f >> 2] = i[u + 16 >> 2], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[u + 24 >> 2];
                                        break e;
                                    }
                                    j(f, i[u + 16 >> 2], i[u + 20 >> 2]);
                                }
                                o[u + 27 | 0] < 0 && X(i[u + 16 >> 2]), o[u + 99 | 0] < 0 && X(i[u + 88 >> 2]), o[u + 51 | 0] < 0 && X(i[u + 40 >> 2]), o[u + 75 | 0] < 0 && X(i[u + 64 >> 2]);
                                e: {
                                    if (i[u + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                            A = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 8 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                        X(i[u + 112 >> 2]);
                                        break e;
                                    }
                                    o[u + 123 | 0] < 0 && X(i[u + 112 >> 2]);
                                    r: {
                                        if (!T) break r;
                                        if (J0(u + 104 | 0, G, 6, B, _, r0, t), i[u + 104 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 108 >> 2], i[A + 8 >> 2] = i[u + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 123 | 0] >= 0) {
                                                A = i[u + 116 >> 2], i[r >> 2] = i[u + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 120 >> 2];
                                                break e;
                                            }
                                            if (j(r, i[u + 112 >> 2], i[u + 116 >> 2]), o[u + 123 | 0] >= 0) break e;
                                            X(i[u + 112 >> 2]);
                                            break e;
                                        }
                                        if (o[u + 123 | 0] >= 0) break r;
                                        X(i[u + 112 >> 2]);
                                    }
                                    r = i[e >> 2], f = r - -64 | 0;
                                    r: {
                                        A: {
                                            t = i[r + 64 >> 2];
                                            f: {
                                                if (!t) break f;
                                                for(r = f, e = t; n = i[e + 16 >> 2], r = (n | 0) < 0 ? r : e, e = i[(n >>> 29 & 4) + e >> 2], !!e;);
                                                R = 0;
                                                k: {
                                                    if ((r | 0) == (f | 0) || (R = 0, i[r + 16 >> 2] > 0)) break k;
                                                    L = i[r + 44 >> 2], R = i[r + 52 >> 2];
                                                }
                                                for(r = f, e = t; n = i[e + 16 >> 2] <= 0, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                V = 0;
                                                k: {
                                                    if ((r | 0) == (f | 0) || (V = 0, i[r + 16 >> 2] > 1)) break k;
                                                    f0 = i[r + 44 >> 2], V = i[r + 52 >> 2];
                                                }
                                                for(r = f, e = t; n = i[e + 16 >> 2] < 2, r = n ? r : e, e = i[(n << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (f | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[r + 16 >> 2] > 2) break r;
                                        S = i[r + 52 >> 2], e = i[r + 44 >> 2];
                                    }
                                    E = e;
                                    r: {
                                        A: {
                                            if (r = i[k >> 2], r) {
                                                for(n = k, e = r; y = i[e + 16 >> 2], n = (y | 0) < 0 ? n : e, e = i[(y >>> 29 & 4) + e >> 2], !!e;);
                                                y = 0;
                                                f: {
                                                    if ((k | 0) == (n | 0) || (y = 0, i[n + 16 >> 2] > 0)) break f;
                                                    q = i[n + 44 >> 2], y = i[n + 52 >> 2];
                                                }
                                                for(n = k, e = r; h = i[e + 16 >> 2] <= 0, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                F = 0;
                                                f: {
                                                    if ((k | 0) == (n | 0) || (F = 0, i[n + 16 >> 2] > 1)) break f;
                                                    t0 = i[n + 44 >> 2], F = i[n + 52 >> 2];
                                                }
                                                for(n = k, e = r; h = i[e + 16 >> 2] < 2, n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                                if ((k | 0) != (n | 0)) break A;
                                            }
                                            e = 0;
                                            break r;
                                        }
                                        if (e = 0, i[n + 16 >> 2] > 2) break r;
                                        P = i[n + 52 >> 2], e = i[n + 44 >> 2];
                                    }
                                    h = e, n = 0, w = 0;
                                    r: {
                                        if (!T) break r;
                                        A: {
                                            f: {
                                                if (!t) break f;
                                                for(e = f; $ = i[t + 16 >> 2] < 6, e = $ ? e : t, t = i[($ << 2) + t >> 2], !!t;);
                                                if ((e | 0) == (f | 0)) break f;
                                                if (f = 0, i[e + 16 >> 2] > 6) break A;
                                                m0 = i[e + 44 >> 2], f = i[e + 52 >> 2];
                                                break A;
                                            }
                                            f = 0;
                                        }
                                        if ($ = f, w = 0, !r) break r;
                                        for(e = k; f = i[r + 16 >> 2] < 6, e = f ? e : r, r = i[(f << 2) + r >> 2], !!r;);
                                        if (w = 0, (e | 0) == (k | 0) || (w = 0, i[e + 16 >> 2] > 6)) break r;
                                        n = i[e + 52 >> 2], w = i[e + 44 >> 2];
                                    }
                                    f = w;
                                    r: {
                                        A: {
                                            f: {
                                                if (!(B & 1)) break f;
                                                if (k = _ - 1 | 0, !k) break A;
                                                if (M = (h + W | 0) - 1 | 0, H = (B + E | 0) - 1 | 0, W = (W + t0 | 0) - 1 | 0, v = (B + f0 | 0) - 1 | 0, e = 0, (_ | 0) != 2) for(r = k & -2; o[W + Z(e, F) | 0] = l[v + Z(e, V) | 0], o[M + Z(e, P) | 0] = l[H + Z(e, S) | 0], t = e | 1, o[W + Z(t, F) | 0] = l[v + Z(t, V) | 0], o[M + Z(t, P) | 0] = l[H + Z(t, S) | 0], e = e + 2 | 0, c = c + 2 | 0, (r | 0) != (c | 0););
                                                if (!(k & 1)) break f;
                                                o[W + Z(e, F) | 0] = l[v + Z(e, V) | 0], o[M + Z(e, P) | 0] = l[H + Z(e, S) | 0];
                                            }
                                            if (!_) break r;
                                        }
                                        if (s0 = B - 1 | 0, s0) for(r = 0;;){
                                            for(w = Z(r, S), M = Z(r, V), H = Z(r, P) + h | 0, W = Z(r, F) + t0 | 0, e = 0; k = (e + w | 0) + E | 0, c = l[k | 0], v = l[k + 1 | 0], t = e >>> 1 | 0, k = (e + M | 0) + f0 | 0, o[W + t | 0] = (l[k | 0] + l[k + 1 | 0] | 0) + 1 >>> 1, o[t + H | 0] = (v + c | 0) + 1 >>> 1, e = e + 2 | 0, s0 >>> 0 > e >>> 0;);
                                            if (r = r + 1 | 0, (_ | 0) == (r | 0)) break;
                                        }
                                        for(r = B << (r0 >>> 0 > 8), e = 0; v0(Z(e, y) + q | 0, Z(e, R) + L | 0, B), T && v0(Z(e, n) + f | 0, Z(e, $) + m0 | 0, r), e = e + 1 | 0, (_ | 0) != (e | 0););
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = G, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), !C || (A = i[C + 4 >> 2], i[C + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[C >> 2] + 8 >> 2]](C), g(C);
                            }
                            m = u + 128 | 0;
                        }
                        function he(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0;
                            f = i[A + 18588 >> 2], V = i[f + 132 >> 2], R = i[f + 124 >> 2], P = i[R + 16892 >> 2];
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (!l[V + 45 | 0] | e || (e = i[A + 12 >> 2], i[A + 8 >> 2] | (e | 0) <= 0)) break A;
                                            if (M = 2, (P | 0) >= 2) {
                                                if (e = e - 1 | 0, k = i[A + 18596 >> 2], e >>> 0 >= i[k + 472 >> 2] - i[k + 468 >> 2] >> 3 >>> 0) break r;
                                                r8(f, i[A + 18604 >> 2], 1, e, 1), W6(A + 18572 | 0, (i[i[A + 18596 >> 2] + 468 >> 2] + (i[A + 12 >> 2] << 3) | 0) - 8 | 0), x9((i[i[A + 18596 >> 2] + 468 >> 2] + (i[A + 12 >> 2] << 3) | 0) - 8 | 0);
                                                break A;
                                            }
                                            if (r8(f, i[A + 18604 >> 2], 0, e - 1 | 0, 1), e = i[A + 18592 >> 2], f = i[e + 804 >> 2], f >>> 0 >= 3) break e;
                                            Ai(A + 18572 | 0, f, i[e + 800 >> 2]), o[A + 18580 | 0] = 0, o[A + 18581 | 0] = 0, o[A + 18582 | 0] = 0, o[A + 18583 | 0] = 0;
                                        }
                                        for($ = A + 18548 | 0, s0 = A + 18572 | 0, m0 = P - 1 | 0, W = i[A + 12 >> 2], e = i[A + 8 >> 2], M = 2;;){
                                            if (L = Z(W, P) + e | 0, i[R + 16892 >> 2] <= (e | 0) | L >>> 0 >= i[V + 8452 >> 2] - i[V + 8448 >> 2] >> 2 >>> 0 | i[R + 16900 >> 2] <= (W | 0) || (!r | (W | 0) <= 0 | (e | 0) >= (m0 | 0) || r8(i[A + 18588 >> 2], i[A + 18604 >> 2], e + 1 | 0, W - 1 | 0, 1), !i[A + 18576 >> 2])) break r;
                                            c = 0, q = 0, k = i[A >> 2], f = i[A + 18588 >> 2], r0 = i[f + 124 >> 2], n = i[r0 + 16892 >> 2], v = (k | 0) / (n | 0) | 0, C = k - Z(n, v) | 0, n = i[r0 + 16876 >> 2], h = C << n, k = i[A + 18592 >> 2], t = i[f + 152 >> 2], (t | 0) <= (C | 0) | (v | 0) >= i[f + 156 >> 2] || (Q[(i[f + 140 >> 2] + Z(Z(t, v), 24) | 0) + Z(C, 24) >> 1] = i[k + 808 >> 2]);
                                            A: {
                                                f: {
                                                    if (u = i[f + 148 >> 2], s = h >> u, !((s | 0) < 0 | (t | 0) <= (s | 0))) {
                                                        if (E = v << n, u = E >> u, (u | 0) < 0 | (u | 0) >= i[f + 156 >> 2]) break f;
                                                        if (Q[((i[f + 140 >> 2] + Z(s, 24) | 0) + Z(Z(t, u), 24) | 0) + 2 >> 1] = i[k >> 2], Z0 = h, X0 = E, l[k + 333 | 0] | l[k + 334 | 0]) {
                                                            w = 0, s = m - 32 | 0, m = s, H = i[A + 18592 >> 2], _ = i[A + 18588 >> 2], f0 = i[_ + 132 >> 2], n = i[_ + 124 >> 2], o[s + 24 | 0] = 0, i[s + 16 >> 2] = 0, i[s + 20 >> 2] = 0, i[s + 8 >> 2] = 0, i[s + 12 >> 2] = 0, f = 0;
                                                            k: {
                                                                if ((C | 0) <= 0 || (f = 0, i[A >> 2] <= i[H + 808 >> 2]) || (u = C << 2, k = i[f0 + 8484 >> 2], t = Z(v, i[n + 16892 >> 2]) << 2, f = 0, i[u + (k + t | 0) >> 2] != i[(t + (k + u | 0) | 0) - 4 >> 2])) break k;
                                                                f = s2(A + 18548 | 0, i[A + 18572 >> 2]);
                                                            }
                                                            k = f;
                                                            k: {
                                                                if (k & 255 | (v | 0) <= 0 || (f = i[n + 16892 >> 2], i[H + 808 >> 2] > (i[A >> 2] - f | 0)) || (u = C << 2, t = i[f0 + 8484 >> 2], i[u + (t + (Z(f, v) << 2) | 0) >> 2] != i[u + (t + (Z(f, v - 1 | 0) << 2) | 0) >> 2])) break k;
                                                                c = s2(A + 18548 | 0, i[A + 18572 >> 2]);
                                                            }
                                                            if (!((k | c) & 255)) {
                                                                for(u = A + 18548 | 0, f = s + 8 | 0, V0 = f | 2, I0 = f | 5, F0 = i[n + 16848 >> 2], t = l[s + 9 | 0], n = l[s + 8 | 0], T = 0;;){
                                                                    k: {
                                                                        n: {
                                                                            t: {
                                                                                o: {
                                                                                    s: {
                                                                                        if (!l[H + 333 | 0] || w) {
                                                                                            if (!w | !l[H + 334 | 0]) break k;
                                                                                            if ((w | 0) != 1) break t;
                                                                                            if (s2(u, i[A + 18572 >> 2] + 1 | 0)) break s;
                                                                                            f = 0;
                                                                                            break o;
                                                                                        }
                                                                                        s2(u, i[A + 18572 >> 2] + 1 | 0) ? n = S1(u) ? 2 : 1 : n = 0, T = n, f = n;
                                                                                        break n;
                                                                                    }
                                                                                    f = S1(u) ? 2 : 1;
                                                                                }
                                                                                n = f << 2 | f << 4 | T, T = n;
                                                                                break n;
                                                                            }
                                                                            f = (T & 255) >>> (w << 1) & 3;
                                                                        }
                                                                        if (!f) break k;
                                                                        B = (w << 2) + I0 | 0, h = w ? 16840 : 16832, G = i[h + i[_ + 124 >> 2] >> 2], G = Qi(u, -1 << ((G | 0) >= 10 ? 10 : G) - 5 ^ -1), o[B | 0] = G, y = i[h + i[_ + 124 >> 2] >> 2], y = Qi(u, -1 << ((y | 0) >= 10 ? 10 : y) - 5 ^ -1), o[B + 1 | 0] = y, F = i[h + i[_ + 124 >> 2] >> 2], F = Qi(u, -1 << ((F | 0) >= 10 ? 10 : F) - 5 ^ -1), o[B + 2 | 0] = F, h = i[h + i[_ + 124 >> 2] >> 2], S = Qi(u, -1 << ((h | 0) >= 10 ? 10 : h) - 5 ^ -1), o[B + 3 | 0] = S;
                                                                        n: {
                                                                            if ((f | 0) == 1) {
                                                                                f = 0, E = 0, G & 255 && (E = S1(u) ? -1 : 1), y & 255 && (f = S1(u) ? -1 : 1), h = 0, t0 = 0, F & 255 && (t0 = S1(u) ? -1 : 1), S & 255 && (h = S1(u) ? -1 : 1), R0 = w + V0 | 0, D0 = i8(u, 5), o[R0 | 0] = D0, S = l[B + 3 | 0], F = l[B + 2 | 0], y = l[B + 1 | 0], G = l[B | 0];
                                                                                break n;
                                                                            }
                                                                            t: {
                                                                                o: {
                                                                                    if (!w) {
                                                                                        f = 1, h = -1, t = i8(u, 2);
                                                                                        break o;
                                                                                    }
                                                                                    if (f = 1, h = -1, (w | 0) != 1) break t;
                                                                                    t = i8(u, 2), t = t << 2 | t << 4 | q;
                                                                                }
                                                                                q = t;
                                                                            }
                                                                            t0 = -1, E = 1;
                                                                        }
                                                                        g0 = G, G = l[(w ? 8264 : 8263) + f0 | 0], o[B | 0] = Z(g0 << G, E), o[B + 1 | 0] = Z(y << G, f), o[B + 2 | 0] = Z(F << G, t0), o[B + 3 | 0] = Z(S << G, h);
                                                                    }
                                                                    if (!(F0 && (f = w >>> 0 < 2, w = w + 1 | 0, f))) break;
                                                                }
                                                                o[s + 9 | 0] = t, o[s + 8 | 0] = n, f = (i[_ + 140 >> 2] + Z(Z(v, i[_ + 152 >> 2]), 24) | 0) + Z(C, 24) | 0, o[f + 20 | 0] = l[s + 24 | 0], n = i[s + 20 >> 2], t = i[s + 16 >> 2], o[f + 12 | 0] = t, o[f + 13 | 0] = t >>> 8, o[f + 14 | 0] = t >>> 16, o[f + 15 | 0] = t >>> 24, o[f + 16 | 0] = n, o[f + 17 | 0] = n >>> 8, o[f + 18 | 0] = n >>> 16, o[f + 19 | 0] = n >>> 24, n = i[s + 12 >> 2], t = i[s + 8 >> 2], o[f + 4 | 0] = t, o[f + 5 | 0] = t >>> 8, o[f + 6 | 0] = t >>> 16, o[f + 7 | 0] = t >>> 24, o[f + 8 | 0] = n, o[f + 9 | 0] = n >>> 8, o[f + 10 | 0] = n >>> 16, o[f + 11 | 0] = n >>> 24;
                                                            }
                                                            k & 255 && (f = (i[_ + 140 >> 2] + Z(Z(v, i[_ + 152 >> 2]), 24) | 0) + Z(C, 24) | 0, k = f - 24 | 0, o[f + 20 | 0] = l[k + 20 | 0], n = l[k + 16 | 0] | l[k + 17 | 0] << 8 | (l[k + 18 | 0] << 16 | l[k + 19 | 0] << 24), t = l[k + 12 | 0] | l[k + 13 | 0] << 8 | (l[k + 14 | 0] << 16 | l[k + 15 | 0] << 24), o[f + 12 | 0] = t, o[f + 13 | 0] = t >>> 8, o[f + 14 | 0] = t >>> 16, o[f + 15 | 0] = t >>> 24, o[f + 16 | 0] = n, o[f + 17 | 0] = n >>> 8, o[f + 18 | 0] = n >>> 16, o[f + 19 | 0] = n >>> 24, n = l[k + 8 | 0] | l[k + 9 | 0] << 8 | (l[k + 10 | 0] << 16 | l[k + 11 | 0] << 24), k = l[k + 4 | 0] | l[k + 5 | 0] << 8 | (l[k + 6 | 0] << 16 | l[k + 7 | 0] << 24), o[f + 4 | 0] = k, o[f + 5 | 0] = k >>> 8, o[f + 6 | 0] = k >>> 16, o[f + 7 | 0] = k >>> 24, o[f + 8 | 0] = n, o[f + 9 | 0] = n >>> 8, o[f + 10 | 0] = n >>> 16, o[f + 11 | 0] = n >>> 24), c & 255 && (t = Z(C, 24), n = i[_ + 140 >> 2], k = i[_ + 152 >> 2], f = t + (n + Z(Z(k, v), 24) | 0) | 0, k = t + (n + Z(Z(k, v - 1 | 0), 24) | 0) | 0, o[f + 20 | 0] = l[k + 20 | 0], n = l[k + 16 | 0] | l[k + 17 | 0] << 8 | (l[k + 18 | 0] << 16 | l[k + 19 | 0] << 24), t = l[k + 12 | 0] | l[k + 13 | 0] << 8 | (l[k + 14 | 0] << 16 | l[k + 15 | 0] << 24), o[f + 12 | 0] = t, o[f + 13 | 0] = t >>> 8, o[f + 14 | 0] = t >>> 16, o[f + 15 | 0] = t >>> 24, o[f + 16 | 0] = n, o[f + 17 | 0] = n >>> 8, o[f + 18 | 0] = n >>> 16, o[f + 19 | 0] = n >>> 24, n = l[k + 8 | 0] | l[k + 9 | 0] << 8 | (l[k + 10 | 0] << 16 | l[k + 11 | 0] << 24), k = l[k + 4 | 0] | l[k + 5 | 0] << 8 | (l[k + 6 | 0] << 16 | l[k + 7 | 0] << 24), o[f + 4 | 0] = k, o[f + 5 | 0] = k >>> 8, o[f + 6 | 0] = k >>> 16, o[f + 7 | 0] = k >>> 24, o[f + 8 | 0] = n, o[f + 9 | 0] = n >>> 8, o[f + 10 | 0] = n >>> 16, o[f + 11 | 0] = n >>> 24), m = s + 32 | 0, n = i[r0 + 16876 >> 2];
                                                        }
                                                        se(A, Z0, X0, n, 0);
                                                        break A;
                                                    }
                                                    y0(4105, 9012, 128, 3731), z();
                                                }
                                                y0(4067, 9012, 129, 3731), z();
                                            }
                                            if (!(!l[V + 45 | 0] | (e | 0) != 1 | (i[R + 16900 >> 2] - 1 | 0) <= (W | 0))) {
                                                if (f = i[A + 18596 >> 2], e = i[f + 468 >> 2], i[f + 472 >> 2] - e >> 3 >>> 0 <= W >>> 0) break r;
                                                n = e, e = W << 3, W6(n + e | 0, s0), J9(e + i[i[A + 18596 >> 2] + 468 >> 2] | 0);
                                            }
                                            if (f = wA($), !f | !l[V + 14 | 0] || (W6(i[A + 18592 >> 2] + 1340 | 0, s0), J9(i[A + 18592 >> 2] + 1340 | 0), o[i[A + 18592 >> 2] + 1348 | 0] = 1), e = i[i[A + 18588 >> 2] + 320 >> 2] + Z(L, 76) | 0, i[e >> 2] <= 0 && (i[e >> 2] = 1), t = i[A + 4 >> 2], k = t + 1 | 0, i[A + 4 >> 2] = k, s = i[A + 18588 >> 2], n = i[s + 124 >> 2], e = i[n + 16908 >> 2], (e | 0) <= (k | 0)) {
                                                if (r = i[n + 16892 >> 2], i[A >> 2] = e, k = (e | 0) / (r | 0) | 0, i[A + 12 >> 2] = k, i[A + 8 >> 2] = e - Z(r, k), M = 0, f) break r;
                                                W2(i[A + 18584 >> 2] + 4 | 0, 1004, 0);
                                                break i;
                                            }
                                            if (u = i[A + 12 >> 2], e = i[n + 16892 >> 2], n = k << 2, k = i[n + i[i[s + 132 >> 2] + 8460 >> 2] >> 2], i[A >> 2] = k, W = (k | 0) / (e | 0) | 0, i[A + 12 >> 2] = W, e = k - Z(e, W) | 0, i[A + 8 >> 2] = e, f) return 0;
                                            if (l[V + 46 | 0] ? (f = i[V + 8472 >> 2], n = i[f + n >> 2] != i[f + (t << 2) >> 2]) : n = 0, !!(n | l[V + 45 | 0] != 0 & (u | 0) != (W | 0))) break;
                                        }
                                        if (!wA($)) {
                                            W2(i[A + 18584 >> 2] + 4 | 0, 1017, 0);
                                            break i;
                                        }
                                        Fi($), M = 1;
                                    }
                                    return M;
                                }
                                y0(18036, 15050, 1520, 4390), z();
                            }
                            return o[i[A + 18588 >> 2] + 312 | 0] = 3, 2;
                        }
                        function m3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                e: {
                                    t = i[A + 276 >> 2], e2 = (f | 0) > (t | 0) ? t : f;
                                    r: {
                                        if ((e2 | 0) <= (e | 0) || (f = i[A + 272 >> 2], k2 = (f | 0) < (k | 0) ? f : k, (k2 | 0) <= 0)) break r;
                                        for(U2 = r ? 1 : 2, H2 = r ? 2 : 1, W = i[A + 40 >> 2], j2 = W << 1, t2 = i[A + 124 >> 2], f = i[t2 + 16832 >> 2], v2 = f - 8 | 0, H = -1 << f ^ -1, K2 = r ? 3 : 2, q = Z(W, -3), m0 = 0 - W | 0, Z0 = Z(W, 3), P = W << 1, X0 = 0 - P | 0, g0 = 0 - (W << 2) | 0;;){
                                            for(I0 = e << 2, y2 = I0 - 1 | 0, i1 = I0 >> 2, i2 = 0, R0 = 0;;){
                                                _ = R0 << 2, r0 = l[(i[A + 260 >> 2] + (_ >> 2) | 0) + Z(i[A + 272 >> 2], i1) | 0] & 3;
                                                A: {
                                                    if (!r0) break A;
                                                    f = i[A + 4 >> 2], k = Z(i[A + 40 >> 2], I0), h = _ + (f + k | 0) | 0;
                                                    f: {
                                                        if (!r) {
                                                            o[n + 16 | 0] = l[h | 0], o[n | 0] = l[h + m0 | 0], o[n + 17 | 0] = l[h + W | 0], o[n + 1 | 0] = l[h + X0 | 0], o[n + 18 | 0] = l[h + P | 0], u = l[h + q | 0], o[n + 2 | 0] = u, o[n + 19 | 0] = l[h + Z0 | 0], V = l[h + g0 | 0], o[n + 3 | 0] = V, f = h + 1 | 0, o[n + 20 | 0] = l[f | 0], o[n + 4 | 0] = l[f + m0 | 0], o[n + 21 | 0] = l[f + W | 0], o[n + 5 | 0] = l[f + X0 | 0], o[n + 22 | 0] = l[f + P | 0], o[n + 6 | 0] = l[f + q | 0], o[n + 23 | 0] = l[f + Z0 | 0], o[n + 7 | 0] = l[f + g0 | 0], f = h + 2 | 0, o[n + 24 | 0] = l[f | 0], o[n + 8 | 0] = l[f + m0 | 0], o[n + 25 | 0] = l[f + W | 0], o[n + 9 | 0] = l[f + X0 | 0], o[n + 26 | 0] = l[f + P | 0], o[n + 10 | 0] = l[f + q | 0], o[n + 27 | 0] = l[f + Z0 | 0], o[n + 11 | 0] = l[f + g0 | 0], k = h + 3 | 0, o[n + 28 | 0] = l[k | 0], f = l[k + m0 | 0], o[n + 12 | 0] = f, o[n + 29 | 0] = l[k + W | 0], t = l[k + X0 | 0], o[n + 13 | 0] = t, o[n + 30 | 0] = l[k + P | 0], s = l[k + q | 0], o[n + 14 | 0] = s, o[n + 31 | 0] = l[k + Z0 | 0], k = k + g0 | 0;
                                                            break f;
                                                        }
                                                        f = f + (k + (i2 << K2) | 0) | 0, i[n + 16 >> 2] = l[f | 0] | l[f + 1 | 0] << 8 | (l[f + 2 | 0] << 16 | l[f + 3 | 0] << 24), o[n | 0] = l[h - 1 | 0], o[n + 1 | 0] = l[h - 2 | 0], u = l[h - 3 | 0], o[n + 2 | 0] = u, V = l[h - 4 | 0], o[n + 3 | 0] = V, k = f + W | 0, i[n + 20 >> 2] = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), k = h + W | 0, o[n + 4 | 0] = l[k - 1 | 0], o[n + 5 | 0] = l[k - 2 | 0], o[n + 6 | 0] = l[k - 3 | 0], o[n + 7 | 0] = l[k - 4 | 0], k = f + P | 0, i[n + 24 >> 2] = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), k = h + P | 0, o[n + 8 | 0] = l[k - 1 | 0], o[n + 9 | 0] = l[k - 2 | 0], o[n + 10 | 0] = l[k - 3 | 0], o[n + 11 | 0] = l[k - 4 | 0], f = f + Z0 | 0, i[n + 28 >> 2] = l[f | 0] | l[f + 1 | 0] << 8 | (l[f + 2 | 0] << 16 | l[f + 3 | 0] << 24), k = h + Z0 | 0, f = l[k - 1 | 0], o[n + 12 | 0] = f, t = l[k - 2 | 0], o[n + 13 | 0] = t, s = l[k - 3 | 0], o[n + 14 | 0] = s, k = k - 4 | 0;
                                                    }
                                                    if (D0 = l[k | 0], o[n + 15 | 0] = D0, F = i[A + 168 >> 2], k = _ >> F, (k | 0) < 0 || (C = i[A + 172 >> 2], (C | 0) <= (k | 0))) break i;
                                                    if (B = I0 >> F, (B | 0) < 0 || (T = i[A + 176 >> 2], (T | 0) <= (B | 0))) break e;
                                                    E = i[A + 160 >> 2], S = E + Z(k, 3) | 0, w = Z(Z(C, B), 3), $ = S + w | 0, V0 = o[$ + 2 | 0];
                                                    f: {
                                                        if (!r) {
                                                            if (k = y2 >> F, (k | 0) < 0 | (k | 0) >= (T | 0)) break e;
                                                            k = (S + Z(Z(k, C), 3) | 0) + 2 | 0;
                                                            break f;
                                                        }
                                                        if (k = _ - 1 >> F, (k | 0) < 0 | k >>> 0 >= C >>> 0) break i;
                                                        k = (w + (E + Z(k, 3) | 0) | 0) + 2 | 0;
                                                    }
                                                    if (G = i[A + 148 >> 2], B = _ >> G, (B | 0) < 0 || (f0 = i[A + 152 >> 2], (f0 | 0) <= (B | 0))) break i;
                                                    if (G = I0 >> G, (G | 0) < 0 | (G | 0) >= i[A + 156 >> 2]) break e;
                                                    if (R = l[n + 28 | 0], t0 = R + (l[n + 30 | 0] - (l[n + 29 | 0] << 1) | 0) | 0, v = t0 >> 31, s = (s & 255) - (t << 1) | 0, t = f, s0 = s + f | 0, f = s0 >> 31, s = l[n + 16 | 0], H0 = s + (l[n + 18 | 0] - (l[n + 17 | 0] << 1) | 0) | 0, c = H0 >> 31, y = u - (l[n + 1 | 0] << 1) | 0, u = l[n | 0], y = y + u | 0, L = y >> 31, t0 = (v ^ t0) - v | 0, s0 = (f ^ s0) - f | 0, M = t0 + s0 | 0, c = (c ^ H0) - c | 0, L = (y ^ L) - L | 0, v = c + L | 0, k = (V0 + o[k | 0] | 0) + 1 >> 1, f = i[i[A + 52 >> 2] + (I[((i[A + 140 >> 2] + Z(B, 24) | 0) + Z(Z(G, f0), 24) | 0) + 2 >> 1] << 2) >> 2], B = k + i[f + 764 >> 2] | 0, B = (B | 0) >= 51 ? 51 : B, G = l[((B | 0) > 0 ? B : 0) + 48272 | 0] << v2, (M + v | 0) >= (G | 0)) break A;
                                                    f = (i[f + 768 >> 2] + (k + (r0 << 1) | 0) | 0) - 2 | 0, f = (f | 0) >= 53 ? 53 : f, B = l[((f | 0) > 0 ? f : 0) + 48336 | 0] << v2, f = 0, r0 = G >>> 2 | 0, k = 0;
                                                    f: {
                                                        if (r0 >>> 0 <= v << 1 >>> 0 || (V0 = s - l[n + 19 | 0] | 0, v = V0 >> 31, f0 = V - u | 0, V = f0 >> 31, k = 0, (v ^ V0) - v + ((V ^ f0) - V) >>> 0 >= G >>> 3 >>> 0)) break f;
                                                        u = u - s | 0, k = u >> 31, k = ((k ^ u) - k | 0) < Z(B, 5) + 1 >> 1;
                                                    }
                                                    u = k;
                                                    f: {
                                                        if (r0 >>> 0 <= M << 1 >>> 0 || (V = R - l[n + 31 | 0] | 0, k = V >> 31, v = D0 - t | 0, s = v >> 31, (k ^ V) - k + ((s ^ v) - s) >>> 0 >= G >>> 3 >>> 0)) break f;
                                                        k = t - R | 0, f = k >> 31, f = ((f ^ k) - f | 0) < Z(B, 5) + 1 >> 1;
                                                    }
                                                    s = l[t2 + 8812 | 0];
                                                    f: {
                                                        if (!r) {
                                                            if (t = y2 >> F, s) {
                                                                if ((t | 0) < 0 | (t | 0) >= (T | 0)) break e;
                                                                k = !(l[(S + Z(Z(t, C), 3) | 0) + 1 | 0] & 4);
                                                            } else k = 1;
                                                            if ((t | 0) < 0 | (t | 0) >= (T | 0)) break e;
                                                            t = S + Z(Z(t, C), 3) | 0;
                                                            break f;
                                                        }
                                                        if (t = _ - 1 >> F, s) {
                                                            if ((t | 0) < 0 | t >>> 0 >= C >>> 0) break i;
                                                            k = !(l[(w + (E + Z(t, 3) | 0) | 0) + 1 | 0] & 4);
                                                        } else k = 1;
                                                        if ((t | 0) < 0 | t >>> 0 >= C >>> 0) break i;
                                                        t = w + (E + Z(t, 3) | 0) | 0;
                                                    }
                                                    for(r0 = f & u, T = !(l[t + 1 | 0] & 8) & k, f = G + (G >>> 1 | 0) >>> 3 | 0, L = T & f >>> 0 > L + s0 >>> 0, k = f >>> 0 > c + t0 >>> 0, f = l[$ | 0] | l[$ + 1 | 0] << 8, G = !(f & 2048) & (!s | !(f & 1024)), D0 = k & G, t = B << 1, f = 0, c = 0 - B | 0, V0 = Z(B, 10), f0 = h + 1 | 0, t0 = h + W | 0, s0 = h - 2 | 0, H0 = h - 1 | 0, V = B >> 1, $ = 0 - V | 0;;){
                                                        C = f << 2, k = C + n | 0, u = l[k + 1 | 0], w = C + (n + 16 | 0) | 0, E = l[w + 2 | 0], C = l[w + 1 | 0], _ = l[w | 0], S = l[k + 2 | 0], F = l[k | 0];
                                                        f: {
                                                            if (!r0) {
                                                                if (k = (Z(_ - F | 0, 9) + Z(C - u | 0, -3) | 0) + 8 >> 4, w = k >> 31, (V0 | 0) <= ((k ^ w) - w | 0)) break f;
                                                                w = (k | 0) < (c | 0) ? c : (k | 0) < (B | 0) ? k : B;
                                                                k: {
                                                                    n: {
                                                                        if (!r) {
                                                                            if (T && (k = w + F | 0, o[h + (f - W | 0) | 0] = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0), !G) break k;
                                                                            k = _ - w | 0, s = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0, k = f;
                                                                            break n;
                                                                        }
                                                                        if (T && (k = w + F | 0, o[H0 + Z(f, W) | 0] = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0), !G) break k;
                                                                        k = _ - w | 0, s = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0, k = Z(f, W);
                                                                    }
                                                                    o[k + h | 0] = s;
                                                                }
                                                                if (L && (k = w + (((F + S | 0) + 1 >>> 1 | 0) - u | 0) >> 1, k = ((k | 0) < ($ | 0) ? $ : (k | 0) < (V | 0) ? k : V) + u | 0, o[(r ? s0 + Z(f, W) | 0 : h + (f - j2 | 0) | 0) | 0] = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0), !D0) break f;
                                                                if (k = ((_ + E | 0) + 1 >>> 1) - (w + C) >> 1, k = C + ((k | 0) < ($ | 0) ? $ : (k | 0) < (V | 0) ? k : V) | 0, k = (k | 0) >= 0 ? (k | 0) < (H | 0) ? k : H : 0, !r) {
                                                                    o[f + t0 | 0] = k;
                                                                    break f;
                                                                }
                                                                o[f0 + Z(f, W) | 0] = k;
                                                                break f;
                                                            }
                                                            if (R = C - t | 0, v = _ + F | 0, y = v + C | 0, s = (y + E | 0) + 2 >>> 2 | 0, M = t + C | 0, s = (s | 0) < (R | 0) ? R : (s | 0) < (M | 0) ? s : M, M = u - t | 0, v = u + v | 0, R = (v + S | 0) + 2 >>> 2 | 0, F0 = t + u | 0, R = (R | 0) < (M | 0) ? M : (R | 0) < (F0 | 0) ? R : F0, M = E - t | 0, w = ((y + Z(E, 3) | 0) + (l[w + 3 | 0] << 1) | 0) + 4 >>> 3 | 0, y = t + E | 0, w = (w | 0) < (M | 0) ? M : (w | 0) < (y | 0) ? w : y, y = S - t | 0, k = ((v + Z(S, 3) | 0) + (l[k + 3 | 0] << 1) | 0) + 4 >>> 3 | 0, v = t + S | 0, v = (k | 0) < (y | 0) ? y : (k | 0) < (v | 0) ? k : v, y = _ - t | 0, F0 = _ << 1, M = (F << 1) + 4 | 0, k = E + ((F0 + (M + u | 0) | 0) + (C << 1) | 0) >>> 3 | 0, _ = t + _ | 0, _ = (k | 0) < (y | 0) ? y : (k | 0) < (_ | 0) ? k : _, E = F - t | 0, k = C + (F0 + ((S + M | 0) + (u << 1) | 0) | 0) >>> 3 | 0, u = t + F | 0, u = (k | 0) < (E | 0) ? E : (k | 0) < (u | 0) ? k : u, !r) {
                                                                if (k = f + h | 0, !T) {
                                                                    if (!G) break f;
                                                                    o[k | 0] = _, o[k + W | 0] = s, o[k + P | 0] = w;
                                                                    break f;
                                                                }
                                                                if (!G) {
                                                                    o[k + m0 | 0] = u, o[k + X0 | 0] = R, o[k + q | 0] = v;
                                                                    break f;
                                                                }
                                                                o[k + m0 | 0] = u, o[k | 0] = _, o[k + X0 | 0] = R, o[k + W | 0] = s, o[k + q | 0] = v, o[k + P | 0] = w;
                                                                break f;
                                                            }
                                                            if (k = h + Z(f, W) | 0, T && (o[k - 1 | 0] = u), G && (o[k | 0] = _), T && (o[k - 2 | 0] = R), G && (o[k + 1 | 0] = s), T && (o[k - 3 | 0] = v), !G) break f;
                                                            o[k + 2 | 0] = w;
                                                        }
                                                        if (f = f + 1 | 0, (f | 0) == 4) break;
                                                    }
                                                }
                                                if (i2 = i2 + 1 | 0, R0 = R0 + H2 | 0, !((k2 | 0) > (R0 | 0))) break;
                                            }
                                            if (e = e + U2 | 0, !((e2 | 0) > (e | 0))) break;
                                        }
                                    }
                                    m = n + 32 | 0;
                                    return;
                                }
                                y0(4067, 9012, 119, 3731), z();
                            }
                            y0(4105, 9012, 118, 3731), z();
                        }
                        function j0(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 160 | 0, m = k, f = i[r >> 2];
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (e) {
                                                    if (!f) {
                                                        f = 38410, i[e + 12 >> 2] = 38410, e = 0;
                                                        break e;
                                                    }
                                                    i[k + 24 >> 2] = 59808, i[k + 80 >> 2] = 59828, f = i[14961], i[k + 16 >> 2] = f, n = i[f - 12 >> 2], t = k + 16 | 0, f = t, i[n + f >> 2] = i[14962], i[k + 20 >> 2] = 0, f = f + i[i[k + 16 >> 2] - 12 >> 2] | 0, u = k + 28 | 0, T0(f, u), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[k + 24 >> 2] = f, n = k + 24 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[k + 16 >> 2] = f, i[t + i[f - 12 >> 2] >> 2] = i[14965], i[k + 80 >> 2] = 59828, i[k + 16 >> 2] = 59788, i[k + 24 >> 2] = 59808, u = z0(u), i[u >> 2] = 58864, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 76 >> 2] = 24, f = i[r >> 2], f >>> 0 > 12 ? f = 5596 : f = i[(f << 2) + 78172 >> 2], s = U(U(n, f, E2(f)), 25140, 2);
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    s: {
                                                                        u: {
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        v: {
                                                                                            _: {
                                                                                                B: {
                                                                                                    m: {
                                                                                                        Z: {
                                                                                                            W: {
                                                                                                                X: {
                                                                                                                    p: {
                                                                                                                        Q: {
                                                                                                                            C: {
                                                                                                                                I: {
                                                                                                                                    V: {
                                                                                                                                        F: {
                                                                                                                                            y: {
                                                                                                                                                Y: {
                                                                                                                                                    M: {
                                                                                                                                                        E: {
                                                                                                                                                            g: {
                                                                                                                                                                J: {
                                                                                                                                                                    N: {
                                                                                                                                                                        R: {
                                                                                                                                                                            G: {
                                                                                                                                                                                U: {
                                                                                                                                                                                    H: {
                                                                                                                                                                                        x: {
                                                                                                                                                                                            z: {
                                                                                                                                                                                                T: {
                                                                                                                                                                                                    S: {
                                                                                                                                                                                                        j: {
                                                                                                                                                                                                            O: {
                                                                                                                                                                                                                P: {
                                                                                                                                                                                                                    L: {
                                                                                                                                                                                                                        K: {
                                                                                                                                                                                                                            q: {
                                                                                                                                                                                                                                $: {
                                                                                                                                                                                                                                    a: {
                                                                                                                                                                                                                                        b: {
                                                                                                                                                                                                                                            d: {
                                                                                                                                                                                                                                                c: {
                                                                                                                                                                                                                                                    i0: {
                                                                                                                                                                                                                                                        e0: {
                                                                                                                                                                                                                                                            r0: {
                                                                                                                                                                                                                                                                A0: {
                                                                                                                                                                                                                                                                    f0: {
                                                                                                                                                                                                                                                                        k0: {
                                                                                                                                                                                                                                                                            n0: {
                                                                                                                                                                                                                                                                                t0: {
                                                                                                                                                                                                                                                                                    o0: {
                                                                                                                                                                                                                                                                                        u0: {
                                                                                                                                                                                                                                                                                            l0: {
                                                                                                                                                                                                                                                                                                s0: {
                                                                                                                                                                                                                                                                                                    h0: {
                                                                                                                                                                                                                                                                                                        w0: {
                                                                                                                                                                                                                                                                                                            v0: {
                                                                                                                                                                                                                                                                                                                _0: {
                                                                                                                                                                                                                                                                                                                    B0: {
                                                                                                                                                                                                                                                                                                                        m0: {
                                                                                                                                                                                                                                                                                                                            Z0: {
                                                                                                                                                                                                                                                                                                                                G0: {
                                                                                                                                                                                                                                                                                                                                    W0: {
                                                                                                                                                                                                                                                                                                                                        X0: {
                                                                                                                                                                                                                                                                                                                                            p0: {
                                                                                                                                                                                                                                                                                                                                                Q0: {
                                                                                                                                                                                                                                                                                                                                                    C0: {
                                                                                                                                                                                                                                                                                                                                                        V0: {
                                                                                                                                                                                                                                                                                                                                                            y0: {
                                                                                                                                                                                                                                                                                                                                                                I0: {
                                                                                                                                                                                                                                                                                                                                                                    F0: {
                                                                                                                                                                                                                                                                                                                                                                        Y0: {
                                                                                                                                                                                                                                                                                                                                                                            if (t = i[r + 4 >> 2], (t | 0) <= 1999) {
                                                                                                                                                                                                                                                                                                                                                                                f = 14040;
                                                                                                                                                                                                                                                                                                                                                                                D: switch(t | 0){
                                                                                                                                                                                                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                                                                                                                                                                                                    case 2:
                                                                                                                                                                                                                                                                                                                                                                                    case 3:
                                                                                                                                                                                                                                                                                                                                                                                    case 4:
                                                                                                                                                                                                                                                                                                                                                                                    case 5:
                                                                                                                                                                                                                                                                                                                                                                                    case 6:
                                                                                                                                                                                                                                                                                                                                                                                    case 7:
                                                                                                                                                                                                                                                                                                                                                                                    case 8:
                                                                                                                                                                                                                                                                                                                                                                                    case 9:
                                                                                                                                                                                                                                                                                                                                                                                    case 10:
                                                                                                                                                                                                                                                                                                                                                                                    case 11:
                                                                                                                                                                                                                                                                                                                                                                                    case 12:
                                                                                                                                                                                                                                                                                                                                                                                    case 13:
                                                                                                                                                                                                                                                                                                                                                                                    case 14:
                                                                                                                                                                                                                                                                                                                                                                                    case 15:
                                                                                                                                                                                                                                                                                                                                                                                    case 16:
                                                                                                                                                                                                                                                                                                                                                                                    case 17:
                                                                                                                                                                                                                                                                                                                                                                                    case 18:
                                                                                                                                                                                                                                                                                                                                                                                    case 19:
                                                                                                                                                                                                                                                                                                                                                                                    case 20:
                                                                                                                                                                                                                                                                                                                                                                                    case 21:
                                                                                                                                                                                                                                                                                                                                                                                    case 22:
                                                                                                                                                                                                                                                                                                                                                                                    case 23:
                                                                                                                                                                                                                                                                                                                                                                                    case 24:
                                                                                                                                                                                                                                                                                                                                                                                    case 25:
                                                                                                                                                                                                                                                                                                                                                                                    case 26:
                                                                                                                                                                                                                                                                                                                                                                                    case 27:
                                                                                                                                                                                                                                                                                                                                                                                    case 28:
                                                                                                                                                                                                                                                                                                                                                                                    case 29:
                                                                                                                                                                                                                                                                                                                                                                                    case 30:
                                                                                                                                                                                                                                                                                                                                                                                    case 31:
                                                                                                                                                                                                                                                                                                                                                                                    case 32:
                                                                                                                                                                                                                                                                                                                                                                                    case 33:
                                                                                                                                                                                                                                                                                                                                                                                    case 34:
                                                                                                                                                                                                                                                                                                                                                                                    case 35:
                                                                                                                                                                                                                                                                                                                                                                                    case 36:
                                                                                                                                                                                                                                                                                                                                                                                    case 37:
                                                                                                                                                                                                                                                                                                                                                                                    case 38:
                                                                                                                                                                                                                                                                                                                                                                                    case 39:
                                                                                                                                                                                                                                                                                                                                                                                    case 40:
                                                                                                                                                                                                                                                                                                                                                                                    case 41:
                                                                                                                                                                                                                                                                                                                                                                                    case 42:
                                                                                                                                                                                                                                                                                                                                                                                    case 43:
                                                                                                                                                                                                                                                                                                                                                                                    case 44:
                                                                                                                                                                                                                                                                                                                                                                                    case 45:
                                                                                                                                                                                                                                                                                                                                                                                    case 46:
                                                                                                                                                                                                                                                                                                                                                                                    case 47:
                                                                                                                                                                                                                                                                                                                                                                                    case 48:
                                                                                                                                                                                                                                                                                                                                                                                    case 49:
                                                                                                                                                                                                                                                                                                                                                                                    case 50:
                                                                                                                                                                                                                                                                                                                                                                                    case 51:
                                                                                                                                                                                                                                                                                                                                                                                    case 52:
                                                                                                                                                                                                                                                                                                                                                                                    case 53:
                                                                                                                                                                                                                                                                                                                                                                                    case 54:
                                                                                                                                                                                                                                                                                                                                                                                    case 55:
                                                                                                                                                                                                                                                                                                                                                                                    case 56:
                                                                                                                                                                                                                                                                                                                                                                                    case 57:
                                                                                                                                                                                                                                                                                                                                                                                    case 58:
                                                                                                                                                                                                                                                                                                                                                                                    case 59:
                                                                                                                                                                                                                                                                                                                                                                                    case 60:
                                                                                                                                                                                                                                                                                                                                                                                    case 61:
                                                                                                                                                                                                                                                                                                                                                                                    case 62:
                                                                                                                                                                                                                                                                                                                                                                                    case 63:
                                                                                                                                                                                                                                                                                                                                                                                    case 64:
                                                                                                                                                                                                                                                                                                                                                                                    case 65:
                                                                                                                                                                                                                                                                                                                                                                                    case 66:
                                                                                                                                                                                                                                                                                                                                                                                    case 67:
                                                                                                                                                                                                                                                                                                                                                                                    case 68:
                                                                                                                                                                                                                                                                                                                                                                                    case 69:
                                                                                                                                                                                                                                                                                                                                                                                    case 70:
                                                                                                                                                                                                                                                                                                                                                                                    case 71:
                                                                                                                                                                                                                                                                                                                                                                                    case 72:
                                                                                                                                                                                                                                                                                                                                                                                    case 73:
                                                                                                                                                                                                                                                                                                                                                                                    case 74:
                                                                                                                                                                                                                                                                                                                                                                                    case 75:
                                                                                                                                                                                                                                                                                                                                                                                    case 76:
                                                                                                                                                                                                                                                                                                                                                                                    case 77:
                                                                                                                                                                                                                                                                                                                                                                                    case 78:
                                                                                                                                                                                                                                                                                                                                                                                    case 79:
                                                                                                                                                                                                                                                                                                                                                                                    case 80:
                                                                                                                                                                                                                                                                                                                                                                                    case 81:
                                                                                                                                                                                                                                                                                                                                                                                    case 82:
                                                                                                                                                                                                                                                                                                                                                                                    case 83:
                                                                                                                                                                                                                                                                                                                                                                                    case 84:
                                                                                                                                                                                                                                                                                                                                                                                    case 85:
                                                                                                                                                                                                                                                                                                                                                                                    case 86:
                                                                                                                                                                                                                                                                                                                                                                                    case 87:
                                                                                                                                                                                                                                                                                                                                                                                    case 88:
                                                                                                                                                                                                                                                                                                                                                                                    case 89:
                                                                                                                                                                                                                                                                                                                                                                                    case 90:
                                                                                                                                                                                                                                                                                                                                                                                    case 91:
                                                                                                                                                                                                                                                                                                                                                                                    case 92:
                                                                                                                                                                                                                                                                                                                                                                                    case 93:
                                                                                                                                                                                                                                                                                                                                                                                    case 94:
                                                                                                                                                                                                                                                                                                                                                                                    case 95:
                                                                                                                                                                                                                                                                                                                                                                                    case 96:
                                                                                                                                                                                                                                                                                                                                                                                    case 97:
                                                                                                                                                                                                                                                                                                                                                                                    case 98:
                                                                                                                                                                                                                                                                                                                                                                                    case 99:
                                                                                                                                                                                                                                                                                                                                                                                    case 144:
                                                                                                                                                                                                                                                                                                                                                                                    case 145:
                                                                                                                                                                                                                                                                                                                                                                                    case 146:
                                                                                                                                                                                                                                                                                                                                                                                    case 147:
                                                                                                                                                                                                                                                                                                                                                                                    case 148:
                                                                                                                                                                                                                                                                                                                                                                                        break t;
                                                                                                                                                                                                                                                                                                                                                                                    case 149:
                                                                                                                                                                                                                                                                                                                                                                                        break H;
                                                                                                                                                                                                                                                                                                                                                                                    case 142:
                                                                                                                                                                                                                                                                                                                                                                                        break x;
                                                                                                                                                                                                                                                                                                                                                                                    case 150:
                                                                                                                                                                                                                                                                                                                                                                                        break z;
                                                                                                                                                                                                                                                                                                                                                                                    case 140:
                                                                                                                                                                                                                                                                                                                                                                                        break T;
                                                                                                                                                                                                                                                                                                                                                                                    case 139:
                                                                                                                                                                                                                                                                                                                                                                                        break S;
                                                                                                                                                                                                                                                                                                                                                                                    case 138:
                                                                                                                                                                                                                                                                                                                                                                                        break j;
                                                                                                                                                                                                                                                                                                                                                                                    case 137:
                                                                                                                                                                                                                                                                                                                                                                                        break O;
                                                                                                                                                                                                                                                                                                                                                                                    case 136:
                                                                                                                                                                                                                                                                                                                                                                                        break P;
                                                                                                                                                                                                                                                                                                                                                                                    case 135:
                                                                                                                                                                                                                                                                                                                                                                                        break L;
                                                                                                                                                                                                                                                                                                                                                                                    case 134:
                                                                                                                                                                                                                                                                                                                                                                                        break K;
                                                                                                                                                                                                                                                                                                                                                                                    case 133:
                                                                                                                                                                                                                                                                                                                                                                                        break q;
                                                                                                                                                                                                                                                                                                                                                                                    case 132:
                                                                                                                                                                                                                                                                                                                                                                                        break $;
                                                                                                                                                                                                                                                                                                                                                                                    case 130:
                                                                                                                                                                                                                                                                                                                                                                                        break a;
                                                                                                                                                                                                                                                                                                                                                                                    case 129:
                                                                                                                                                                                                                                                                                                                                                                                        break b;
                                                                                                                                                                                                                                                                                                                                                                                    case 128:
                                                                                                                                                                                                                                                                                                                                                                                        break d;
                                                                                                                                                                                                                                                                                                                                                                                    case 127:
                                                                                                                                                                                                                                                                                                                                                                                        break c;
                                                                                                                                                                                                                                                                                                                                                                                    case 126:
                                                                                                                                                                                                                                                                                                                                                                                        break i0;
                                                                                                                                                                                                                                                                                                                                                                                    case 124:
                                                                                                                                                                                                                                                                                                                                                                                        break e0;
                                                                                                                                                                                                                                                                                                                                                                                    case 123:
                                                                                                                                                                                                                                                                                                                                                                                        break r0;
                                                                                                                                                                                                                                                                                                                                                                                    case 122:
                                                                                                                                                                                                                                                                                                                                                                                        break A0;
                                                                                                                                                                                                                                                                                                                                                                                    case 121:
                                                                                                                                                                                                                                                                                                                                                                                        break f0;
                                                                                                                                                                                                                                                                                                                                                                                    case 120:
                                                                                                                                                                                                                                                                                                                                                                                        break k0;
                                                                                                                                                                                                                                                                                                                                                                                    case 117:
                                                                                                                                                                                                                                                                                                                                                                                        break n0;
                                                                                                                                                                                                                                                                                                                                                                                    case 116:
                                                                                                                                                                                                                                                                                                                                                                                        break t0;
                                                                                                                                                                                                                                                                                                                                                                                    case 115:
                                                                                                                                                                                                                                                                                                                                                                                        break o0;
                                                                                                                                                                                                                                                                                                                                                                                    case 114:
                                                                                                                                                                                                                                                                                                                                                                                        break u0;
                                                                                                                                                                                                                                                                                                                                                                                    case 125:
                                                                                                                                                                                                                                                                                                                                                                                        break l0;
                                                                                                                                                                                                                                                                                                                                                                                    case 113:
                                                                                                                                                                                                                                                                                                                                                                                        break s0;
                                                                                                                                                                                                                                                                                                                                                                                    case 112:
                                                                                                                                                                                                                                                                                                                                                                                        break h0;
                                                                                                                                                                                                                                                                                                                                                                                    case 111:
                                                                                                                                                                                                                                                                                                                                                                                        break w0;
                                                                                                                                                                                                                                                                                                                                                                                    case 110:
                                                                                                                                                                                                                                                                                                                                                                                        break v0;
                                                                                                                                                                                                                                                                                                                                                                                    case 109:
                                                                                                                                                                                                                                                                                                                                                                                        break _0;
                                                                                                                                                                                                                                                                                                                                                                                    case 108:
                                                                                                                                                                                                                                                                                                                                                                                        break B0;
                                                                                                                                                                                                                                                                                                                                                                                    case 107:
                                                                                                                                                                                                                                                                                                                                                                                        break m0;
                                                                                                                                                                                                                                                                                                                                                                                    case 143:
                                                                                                                                                                                                                                                                                                                                                                                        break Z0;
                                                                                                                                                                                                                                                                                                                                                                                    case 131:
                                                                                                                                                                                                                                                                                                                                                                                        break G0;
                                                                                                                                                                                                                                                                                                                                                                                    case 141:
                                                                                                                                                                                                                                                                                                                                                                                        break W0;
                                                                                                                                                                                                                                                                                                                                                                                    case 106:
                                                                                                                                                                                                                                                                                                                                                                                        break X0;
                                                                                                                                                                                                                                                                                                                                                                                    case 105:
                                                                                                                                                                                                                                                                                                                                                                                        break p0;
                                                                                                                                                                                                                                                                                                                                                                                    case 104:
                                                                                                                                                                                                                                                                                                                                                                                        break Q0;
                                                                                                                                                                                                                                                                                                                                                                                    case 103:
                                                                                                                                                                                                                                                                                                                                                                                        break C0;
                                                                                                                                                                                                                                                                                                                                                                                    case 102:
                                                                                                                                                                                                                                                                                                                                                                                        break V0;
                                                                                                                                                                                                                                                                                                                                                                                    case 119:
                                                                                                                                                                                                                                                                                                                                                                                        break y0;
                                                                                                                                                                                                                                                                                                                                                                                    case 118:
                                                                                                                                                                                                                                                                                                                                                                                        break I0;
                                                                                                                                                                                                                                                                                                                                                                                    case 101:
                                                                                                                                                                                                                                                                                                                                                                                        break F0;
                                                                                                                                                                                                                                                                                                                                                                                    case 100:
                                                                                                                                                                                                                                                                                                                                                                                        break Y0;
                                                                                                                                                                                                                                                                                                                                                                                    default:
                                                                                                                                                                                                                                                                                                                                                                                        break D;
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                switch(t - 1e3 | 0){
                                                                                                                                                                                                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                                                                                                                                                                                                        break G;
                                                                                                                                                                                                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                                                                                                                                                                                                        break U;
                                                                                                                                                                                                                                                                                                                                                                                    default:
                                                                                                                                                                                                                                                                                                                                                                                        break t;
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                            if ((t | 0) <= 3999) {
                                                                                                                                                                                                                                                                                                                                                                                D: switch(t - 2e3 | 0){
                                                                                                                                                                                                                                                                                                                                                                                    case 8:
                                                                                                                                                                                                                                                                                                                                                                                        break F;
                                                                                                                                                                                                                                                                                                                                                                                    case 7:
                                                                                                                                                                                                                                                                                                                                                                                        break y;
                                                                                                                                                                                                                                                                                                                                                                                    case 6:
                                                                                                                                                                                                                                                                                                                                                                                        break Y;
                                                                                                                                                                                                                                                                                                                                                                                    case 5:
                                                                                                                                                                                                                                                                                                                                                                                        break M;
                                                                                                                                                                                                                                                                                                                                                                                    case 4:
                                                                                                                                                                                                                                                                                                                                                                                        break E;
                                                                                                                                                                                                                                                                                                                                                                                    case 3:
                                                                                                                                                                                                                                                                                                                                                                                        break g;
                                                                                                                                                                                                                                                                                                                                                                                    case 2:
                                                                                                                                                                                                                                                                                                                                                                                        break J;
                                                                                                                                                                                                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                                                                                                                                                                                                        break N;
                                                                                                                                                                                                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                                                                                                                                                                                                        break R;
                                                                                                                                                                                                                                                                                                                                                                                    default:
                                                                                                                                                                                                                                                                                                                                                                                        break D;
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                                switch(t - 3e3 | 0){
                                                                                                                                                                                                                                                                                                                                                                                    case 7:
                                                                                                                                                                                                                                                                                                                                                                                        break Z;
                                                                                                                                                                                                                                                                                                                                                                                    case 6:
                                                                                                                                                                                                                                                                                                                                                                                        break W;
                                                                                                                                                                                                                                                                                                                                                                                    case 5:
                                                                                                                                                                                                                                                                                                                                                                                        break X;
                                                                                                                                                                                                                                                                                                                                                                                    case 4:
                                                                                                                                                                                                                                                                                                                                                                                        break p;
                                                                                                                                                                                                                                                                                                                                                                                    case 3:
                                                                                                                                                                                                                                                                                                                                                                                        break Q;
                                                                                                                                                                                                                                                                                                                                                                                    case 2:
                                                                                                                                                                                                                                                                                                                                                                                        break C;
                                                                                                                                                                                                                                                                                                                                                                                    case 1:
                                                                                                                                                                                                                                                                                                                                                                                        break I;
                                                                                                                                                                                                                                                                                                                                                                                    case 0:
                                                                                                                                                                                                                                                                                                                                                                                        break V;
                                                                                                                                                                                                                                                                                                                                                                                    default:
                                                                                                                                                                                                                                                                                                                                                                                        break t;
                                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                            D: switch(t - 5e3 | 0){
                                                                                                                                                                                                                                                                                                                                                                                case 4:
                                                                                                                                                                                                                                                                                                                                                                                    break h;
                                                                                                                                                                                                                                                                                                                                                                                case 3:
                                                                                                                                                                                                                                                                                                                                                                                    break v;
                                                                                                                                                                                                                                                                                                                                                                                case 2:
                                                                                                                                                                                                                                                                                                                                                                                    break _;
                                                                                                                                                                                                                                                                                                                                                                                case 1:
                                                                                                                                                                                                                                                                                                                                                                                    break B;
                                                                                                                                                                                                                                                                                                                                                                                case 0:
                                                                                                                                                                                                                                                                                                                                                                                    break m;
                                                                                                                                                                                                                                                                                                                                                                                default:
                                                                                                                                                                                                                                                                                                                                                                                    break D;
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                            switch(t - 6e3 | 0){
                                                                                                                                                                                                                                                                                                                                                                                case 3:
                                                                                                                                                                                                                                                                                                                                                                                    break s;
                                                                                                                                                                                                                                                                                                                                                                                case 2:
                                                                                                                                                                                                                                                                                                                                                                                    break u;
                                                                                                                                                                                                                                                                                                                                                                                case 1:
                                                                                                                                                                                                                                                                                                                                                                                    break w;
                                                                                                                                                                                                                                                                                                                                                                                case 0:
                                                                                                                                                                                                                                                                                                                                                                                    break l;
                                                                                                                                                                                                                                                                                                                                                                                default:
                                                                                                                                                                                                                                                                                                                                                                                    break o;
                                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                                        f = 10865;
                                                                                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                                    f = 9478;
                                                                                                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                                f = 15588;
                                                                                                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                                            f = 4906;
                                                                                                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                                        f = 2426;
                                                                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                                    f = 2384;
                                                                                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                                f = 2572;
                                                                                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                                            f = 2398;
                                                                                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                                        f = 2614;
                                                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                                    f = 2600;
                                                                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                                f = 2642;
                                                                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                                            f = 2628;
                                                                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                                        f = 2468;
                                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                                    f = 2454;
                                                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                                f = 2586;
                                                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                                            f = 2558;
                                                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                                        f = 2516;
                                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                                    f = 2440;
                                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                                f = 2530;
                                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                                            f = 2544;
                                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                                        f = 6013;
                                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                                    f = 1302;
                                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                                f = 7804;
                                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                                            f = 15520;
                                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                                        f = 6797;
                                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                                    f = 15426;
                                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                                f = 15720;
                                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                                            f = 13990;
                                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                                        f = 7777;
                                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                                    f = 10446;
                                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                                f = 3847;
                                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                                            }
                                                                                                                                                                                                                                            f = 6314;
                                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                                        }
                                                                                                                                                                                                                                        f = 9580;
                                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                                    }
                                                                                                                                                                                                                                    f = 2241;
                                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                                }
                                                                                                                                                                                                                                f = 8888;
                                                                                                                                                                                                                                break k;
                                                                                                                                                                                                                            }
                                                                                                                                                                                                                            f = 4725;
                                                                                                                                                                                                                            break k;
                                                                                                                                                                                                                        }
                                                                                                                                                                                                                        f = 5082;
                                                                                                                                                                                                                        break k;
                                                                                                                                                                                                                    }
                                                                                                                                                                                                                    f = 4034;
                                                                                                                                                                                                                    break k;
                                                                                                                                                                                                                }
                                                                                                                                                                                                                f = 15537;
                                                                                                                                                                                                                break k;
                                                                                                                                                                                                            }
                                                                                                                                                                                                            f = 1365;
                                                                                                                                                                                                            break k;
                                                                                                                                                                                                        }
                                                                                                                                                                                                        f = 13795;
                                                                                                                                                                                                        break k;
                                                                                                                                                                                                    }
                                                                                                                                                                                                    f = 13761;
                                                                                                                                                                                                    break k;
                                                                                                                                                                                                }
                                                                                                                                                                                                f = 7964;
                                                                                                                                                                                                break k;
                                                                                                                                                                                            }
                                                                                                                                                                                            f = 6751;
                                                                                                                                                                                            break k;
                                                                                                                                                                                        }
                                                                                                                                                                                        f = 2412;
                                                                                                                                                                                        break k;
                                                                                                                                                                                    }
                                                                                                                                                                                    f = 2482;
                                                                                                                                                                                    break k;
                                                                                                                                                                                }
                                                                                                                                                                                f = 14090;
                                                                                                                                                                                break k;
                                                                                                                                                                            }
                                                                                                                                                                            f = 5729;
                                                                                                                                                                            break k;
                                                                                                                                                                        }
                                                                                                                                                                        f = 14556;
                                                                                                                                                                        break k;
                                                                                                                                                                    }
                                                                                                                                                                    f = 12817;
                                                                                                                                                                    break k;
                                                                                                                                                                }
                                                                                                                                                                f = 14378;
                                                                                                                                                                break k;
                                                                                                                                                            }
                                                                                                                                                            f = 12973;
                                                                                                                                                            break k;
                                                                                                                                                        }
                                                                                                                                                        f = 12923;
                                                                                                                                                        break k;
                                                                                                                                                    }
                                                                                                                                                    f = 5944;
                                                                                                                                                    break k;
                                                                                                                                                }
                                                                                                                                                f = 9860;
                                                                                                                                                break k;
                                                                                                                                            }
                                                                                                                                            f = 1348;
                                                                                                                                            break k;
                                                                                                                                        }
                                                                                                                                        f = 11062;
                                                                                                                                        break k;
                                                                                                                                    }
                                                                                                                                    f = 14886;
                                                                                                                                    break k;
                                                                                                                                }
                                                                                                                                f = 10473;
                                                                                                                                break k;
                                                                                                                            }
                                                                                                                            f = 7071;
                                                                                                                            break k;
                                                                                                                        }
                                                                                                                        f = 6877;
                                                                                                                        break k;
                                                                                                                    }
                                                                                                                    f = 12680;
                                                                                                                    break k;
                                                                                                                }
                                                                                                                f = 12717;
                                                                                                                break k;
                                                                                                            }
                                                                                                            f = 12755;
                                                                                                            break k;
                                                                                                        }
                                                                                                        f = 1266;
                                                                                                        break k;
                                                                                                    }
                                                                                                    f = 15447;
                                                                                                    break k;
                                                                                                }
                                                                                                f = 7887;
                                                                                                break k;
                                                                                            }
                                                                                            f = 7910;
                                                                                            break k;
                                                                                        }
                                                                                        f = 7871;
                                                                                        break k;
                                                                                    }
                                                                                    f = 19524;
                                                                                    break k;
                                                                                }
                                                                                f = 14256;
                                                                                break k;
                                                                            }
                                                                            f = 14211;
                                                                            break k;
                                                                        }
                                                                        f = 4279;
                                                                        break k;
                                                                    }
                                                                    f = 7502;
                                                                    break k;
                                                                }
                                                                if ((t | 0) == 4e3) break n;
                                                            }
                                                            f = i[19542];
                                                            break k;
                                                        }
                                                        f = 8866;
                                                    }
                                                    U(s, f, E2(f)), f = o[r + 19 | 0], ((f | 0) < 0 ? i[r + 12 >> 2] : f) && (t = U(n, 25140, 2), f = o[r + 19 | 0], n = (f | 0) < 0, U(t, n ? i[r + 8 >> 2] : r + 8 | 0, n ? i[r + 12 >> 2] : f)), f = i[k + 76 >> 2];
                                                    k: {
                                                        if (f & 16) {
                                                            f = i[k + 72 >> 2], n = i[k + 52 >> 2], f >>> 0 < n >>> 0 && (i[k + 72 >> 2] = n, f = n), n = k + 48 | 0;
                                                            break k;
                                                        }
                                                        if (!(f & 8)) {
                                                            f = 0, o[k + 15 | 0] = 0, n = k + 4 | 0;
                                                            break r;
                                                        }
                                                        f = i[k + 44 >> 2], n = k + 36 | 0;
                                                    }
                                                    if (t = i[n >> 2], f = f - t | 0, f >>> 0 >= 2147483640) break f;
                                                    if (f >>> 0 >= 11) {
                                                        s = (f | 7) + 1 | 0, n = D(s), i[k + 12 >> 2] = s | -2147483648, i[k + 4 >> 2] = n, i[k + 8 >> 2] = f;
                                                        break A;
                                                    }
                                                    if (o[k + 15 | 0] = f, n = k + 4 | 0, f) break A;
                                                    f = 0;
                                                    break r;
                                                }
                                                i[A >> 2] = f, i[A + 4 >> 2] = i[r + 4 >> 2], f = i[19542];
                                                break i;
                                            }
                                            Y0(), z();
                                        }
                                        Q0(n, t, f);
                                    }
                                    o[f + n | 0] = 0;
                                    r: {
                                        if ((k + 4 | 0) == (e | 0)) break r;
                                        if (f = o[k + 15 | 0], o[e + 11 | 0] >= 0) {
                                            if ((f | 0) >= 0) {
                                                f = i[k + 8 >> 2], i[e >> 2] = i[k + 4 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[k + 12 >> 2];
                                                break r;
                                            }
                                            X4(e, i[k + 4 >> 2], i[k + 8 >> 2]);
                                            break r;
                                        }
                                        n = (f | 0) < 0, Y4(e, n ? i[k + 4 >> 2] : k + 4 | 0, n ? i[k + 8 >> 2] : f);
                                    }
                                    i[e + 12 >> 2] = o[e + 11 | 0] < 0 ? i[e >> 2] : e, o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), f = i[14959], i[k + 16 >> 2] = f, i[i[f - 12 >> 2] + (k + 16 | 0) >> 2] = i[14967], i[k + 24 >> 2] = i[14968], i[u >> 2] = 58864, o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), x0(u), N0(k + 80 | 0), f = i[e + 12 >> 2], e = i[r >> 2];
                                }
                                i[A >> 2] = e, i[A + 4 >> 2] = i[r + 4 >> 2];
                            }
                            i[A + 8 >> 2] = f, m = k + 160 | 0;
                        }
                        function Th(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            if (n = m - 224 | 0, m = n, t = -1, u = -1, s = i[A + 24 >> 2], i[s >> 2] >= 2) {
                                p[i[s + 20 >> 2]](n + 200 | 0, r, e, f, k, i[A + 28 >> 2]), i[n + 192 >> 2] = 0, i[n + 184 >> 2] = 0, i[n + 188 >> 2] = 0;
                                i: {
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            t: {
                                                                o: {
                                                                    e = i[n + 220 >> 2];
                                                                    s: {
                                                                        if (!e) break s;
                                                                        if (r = E2(e), r >>> 0 >= 2147483640) break o;
                                                                        u: {
                                                                            w: {
                                                                                if (r >>> 0 >= 11) {
                                                                                    u = (r | 7) + 1 | 0, t = D(u), i[n + 48 >> 2] = u | -2147483648, i[n + 40 >> 2] = t, i[n + 44 >> 2] = r;
                                                                                    break w;
                                                                                }
                                                                                if (o[n + 51 | 0] = r, t = n + 40 | 0, !r) break u;
                                                                            }
                                                                            Q0(t, e, r);
                                                                        }
                                                                        if (o[r + t | 0] = 0, o[n + 195 | 0] < 0 && X(i[n + 184 >> 2]), i[n + 192 >> 2] = i[n + 48 >> 2], r = i[n + 44 >> 2], i[n + 184 >> 2] = i[n + 40 >> 2], i[n + 188 >> 2] = r, r = i[i[A + 24 >> 2] + 32 >> 2], !r) break s;
                                                                        p[r | 0](i[n + 220 >> 2]);
                                                                    }
                                                                    s: switch(i[n + 200 >> 2]){
                                                                        case 2:
                                                                            r = D(24), i[n + 16 >> 2] = r, i[n + 20 >> 2] = 21, i[n + 24 >> 2] = -2147483624, e = l[9575] | l[9576] << 8 | (l[9577] << 16 | l[9578] << 24), f = l[9571] | l[9572] << 8 | (l[9573] << 16 | l[9574] << 24), o[r + 13 | 0] = f, o[r + 14 | 0] = f >>> 8, o[r + 15 | 0] = f >>> 16, o[r + 16 | 0] = f >>> 24, o[r + 17 | 0] = e, o[r + 18 | 0] = e >>> 8, o[r + 19 | 0] = e >>> 16, o[r + 20 | 0] = e >>> 24, e = l[9570] | l[9571] << 8 | (l[9572] << 16 | l[9573] << 24), f = l[9566] | l[9567] << 8 | (l[9568] << 16 | l[9569] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[9562] | l[9563] << 8 | (l[9564] << 16 | l[9565] << 24), f = l[9558] | l[9559] << 8 | (l[9560] << 16 | l[9561] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 21 | 0] = 0, r = i0(n + 40 | 0, 2, 100, n + 16 | 0), e = i[r + 4 >> 2], i[A + 4 >> 2] = i[r >> 2], i[A + 8 >> 2] = e, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), e = i[r + 12 >> 2], i[A + 12 >> 2] = i[r + 8 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = i[r + 16 >> 2], o[r + 19 | 0] = 0, o[r + 8 | 0] = 0, o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), f = i[n + 208 >> 2], k = i[n + 212 >> 2];
                                                                            break i;
                                                                        case 3:
                                                                            if (i[n + 220 >> 2]) {
                                                                                i[n + 48 >> 2] = 59808, i[n + 104 >> 2] = 59828, r = i[14961], i[n + 40 >> 2] = r, k = n + 40 | 0, i[k + i[r - 12 >> 2] >> 2] = i[14962], r = i[n + 40 >> 2], i[n + 44 >> 2] = 0, r = i[r - 12 >> 2] + (n + 40 | 0) | 0, e = n + 52 | 0, T0(r, e), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[n + 48 >> 2] = r, f = i[r - 12 >> 2], r = n + 48 | 0, i[f + r >> 2] = i[14964], f = i[14960], i[n + 40 >> 2] = f, i[k + i[f - 12 >> 2] >> 2] = i[14965], i[n + 104 >> 2] = 59828, i[n + 40 >> 2] = 59788, i[n + 48 >> 2] = 59808, f = z0(e), i[f >> 2] = 58864, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 84 >> 2] = 0, i[n + 88 >> 2] = 0, i[n + 100 >> 2] = 24, k = U(P0(U(r, 20932, 13), i[n + 216 >> 2]), 25138, 4), r = o[n + 195 | 0], e = (r | 0) < 0, U(k, e ? i[n + 184 >> 2] : n + 184 | 0, e ? i[n + 188 >> 2] : r), r = i[n + 100 >> 2];
                                                                                u: {
                                                                                    if (r & 16) {
                                                                                        t = n + 72 | 0, e = i[n + 96 >> 2], r = i[n + 76 >> 2], e >>> 0 < r >>> 0 ? i[n + 96 >> 2] = r : r = e;
                                                                                        break u;
                                                                                    }
                                                                                    if (!(r & 8)) {
                                                                                        r = 0, o[n + 15 | 0] = 0, t = n + 4 | 0;
                                                                                        break r;
                                                                                    }
                                                                                    t = n + 60 | 0, r = i[n + 68 >> 2];
                                                                                }
                                                                                if (e = i[t >> 2], r = r - e | 0, r >>> 0 >= 2147483640) break t;
                                                                                if (r >>> 0 >= 11) {
                                                                                    k = (r | 7) + 1 | 0, t = D(k), i[n + 12 >> 2] = k | -2147483648, i[n + 4 >> 2] = t, i[n + 8 >> 2] = r;
                                                                                    break A;
                                                                                }
                                                                                if (o[n + 15 | 0] = r, t = n + 4 | 0, r) break A;
                                                                                r = 0;
                                                                                break r;
                                                                            }
                                                                            i[n + 48 >> 2] = 59808, i[n + 104 >> 2] = 59828, r = i[14961], i[n + 40 >> 2] = r, e = i[r - 12 >> 2], r = n + 40 | 0, i[e + r >> 2] = i[14962], i[n + 44 >> 2] = 0, e = r + i[i[n + 40 >> 2] - 12 >> 2] | 0, f = n + 52 | 0, T0(e, f), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[n + 48 >> 2] = e, k = i[e - 12 >> 2], e = n + 48 | 0, i[k + e >> 2] = i[14964], k = i[14960], i[n + 40 >> 2] = k, i[r + i[k - 12 >> 2] >> 2] = i[14965], i[n + 104 >> 2] = 59828, i[n + 40 >> 2] = 59788, i[n + 48 >> 2] = 59808, f = z0(f), i[f >> 2] = 58864, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 84 >> 2] = 0, i[n + 88 >> 2] = 0, i[n + 100 >> 2] = 24, U(P0(U(e, 20932, 13), i[n + 216 >> 2]), 20804, 1), r = i[n + 100 >> 2];
                                                                            u: {
                                                                                if (r & 16) {
                                                                                    t = n + 72 | 0, e = i[n + 96 >> 2], r = i[n + 76 >> 2], e >>> 0 < r >>> 0 ? i[n + 96 >> 2] = r : r = e;
                                                                                    break u;
                                                                                }
                                                                                if (!(r & 8)) {
                                                                                    r = 0, o[n + 15 | 0] = 0, t = n + 4 | 0;
                                                                                    break f;
                                                                                }
                                                                                t = n + 60 | 0, r = i[n + 68 >> 2];
                                                                            }
                                                                            if (e = i[t >> 2], r = r - e | 0, r >>> 0 >= 2147483640) break n;
                                                                            if (r >>> 0 >= 11) {
                                                                                k = (r | 7) + 1 | 0, t = D(k), i[n + 12 >> 2] = k | -2147483648, i[n + 4 >> 2] = t, i[n + 8 >> 2] = r;
                                                                                break k;
                                                                            }
                                                                            if (o[n + 15 | 0] = r, t = n + 4 | 0, r) break k;
                                                                            r = 0;
                                                                            break f;
                                                                        case 0:
                                                                            break i;
                                                                        case 1:
                                                                            break e;
                                                                        default:
                                                                            break s;
                                                                    }
                                                                    if (r = D(40), i[n + 16 >> 2] = r, i[n + 20 >> 2] = 33, i[n + 24 >> 2] = -2147483608, o[r + 32 | 0] = l[9940], e = l[9936] | l[9937] << 8 | (l[9938] << 16 | l[9939] << 24), f = l[9932] | l[9933] << 8 | (l[9934] << 16 | l[9935] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[9928] | l[9929] << 8 | (l[9930] << 16 | l[9931] << 24), f = l[9924] | l[9925] << 8 | (l[9926] << 16 | l[9927] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[9920] | l[9921] << 8 | (l[9922] << 16 | l[9923] << 24), f = l[9916] | l[9917] << 8 | (l[9918] << 16 | l[9919] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[9912] | l[9913] << 8 | (l[9914] << 16 | l[9915] << 24), f = l[9908] | l[9909] << 8 | (l[9910] << 16 | l[9911] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 33 | 0] = 0, r = i0(n + 40 | 0, 2, 0, n + 16 | 0), e = i[r + 4 >> 2], i[A + 4 >> 2] = i[r >> 2], i[A + 8 >> 2] = e, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), e = i[r + 12 >> 2], i[A + 12 >> 2] = i[r + 8 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = i[r + 16 >> 2], o[r + 19 | 0] = 0, o[r + 8 | 0] = 0, o[n + 27 | 0] >= 0) break e;
                                                                    X(i[n + 16 >> 2]);
                                                                    break e;
                                                                }
                                                                Y0(), z();
                                                            }
                                                            Y0(), z();
                                                        }
                                                        Y0(), z();
                                                    }
                                                    Q0(t, e, r);
                                                }
                                                o[r + t | 0] = 0, r = i0(n + 16 | 0, 2, 0, n + 4 | 0), e = i[r + 4 >> 2], i[A + 4 >> 2] = i[r >> 2], i[A + 8 >> 2] = e, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), e = i[r + 12 >> 2], i[A + 12 >> 2] = i[r + 8 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = i[r + 16 >> 2], o[r + 19 | 0] = 0, o[r + 8 | 0] = 0, o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), A = i[14959], i[n + 40 >> 2] = A, i[i[A - 12 >> 2] + (n + 40 | 0) >> 2] = i[14967], i[n + 48 >> 2] = i[14968], i[f >> 2] = 58864, o[n + 95 | 0] < 0 && X(i[n + 84 >> 2]), x0(f), N0(n + 104 | 0);
                                                break e;
                                            }
                                            Q0(t, e, r);
                                        }
                                        o[r + t | 0] = 0, r = i0(n + 16 | 0, 2, 0, n + 4 | 0), e = i[r + 4 >> 2], i[A + 4 >> 2] = i[r >> 2], i[A + 8 >> 2] = e, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), e = i[r + 12 >> 2], i[A + 12 >> 2] = i[r + 8 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = i[r + 16 >> 2], o[r + 19 | 0] = 0, o[r + 8 | 0] = 0, o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), A = i[14959], i[n + 40 >> 2] = A, i[i[A - 12 >> 2] + (n + 40 | 0) >> 2] = i[14967], i[n + 48 >> 2] = i[14968], i[f >> 2] = 58864, o[n + 95 | 0] < 0 && X(i[n + 84 >> 2]), x0(f), N0(n + 104 | 0);
                                    }
                                    f = 0, k = 0;
                                }
                                o[n + 195 | 0] < 0 && X(i[n + 184 >> 2]), u = k, t = f;
                            }
                            return m = n + 224 | 0, w0 = u, t | 0;
                        }
                        function N7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            G = m - 48 | 0, m = G, I2(+A), v = c0(1) | 0, e = c0(0) | 0;
                            i: {
                                e: {
                                    s = v & 2147483647;
                                    r: {
                                        if (s >>> 0 <= 1074752122) {
                                            if ((v & 1048575) == 598523) break r;
                                            if (s >>> 0 <= 1073928572) {
                                                if ((v | 0) > 0 | (v | 0) >= 0) {
                                                    A = A + -1.5707963267341256, k = A + -0.00000000006077100506506192, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + -0.00000000006077100506506192, f = 1;
                                                    break i;
                                                }
                                                A = A + 1.5707963267341256, k = A + 6077100506506192e-26, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + 6077100506506192e-26, f = -1;
                                                break i;
                                            }
                                            if ((v | 0) > 0 | (v | 0) >= 0) {
                                                A = A + -3.1415926534682512, k = A + -0.00000000012154201013012384, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + -0.00000000012154201013012384, f = 2;
                                                break i;
                                            }
                                            A = A + 3.1415926534682512, k = A + 12154201013012384e-26, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + 12154201013012384e-26, f = -2;
                                            break i;
                                        }
                                        if (s >>> 0 <= 1075594811) {
                                            if (s >>> 0 <= 1075183036) {
                                                if ((s | 0) == 1074977148) break r;
                                                if ((v | 0) > 0 | (v | 0) >= 0) {
                                                    A = A + -4.712388980202377, k = A + -0.00000000018231301519518578, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + -0.00000000018231301519518578, f = 3;
                                                    break i;
                                                }
                                                A = A + 4.712388980202377, k = A + 18231301519518578e-26, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + 18231301519518578e-26, f = -3;
                                                break i;
                                            }
                                            if ((s | 0) == 1075388923) break r;
                                            if ((v | 0) > 0 | (v | 0) >= 0) {
                                                A = A + -6.2831853069365025, k = A + -0.0000000002430840202602477, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + -0.0000000002430840202602477, f = 4;
                                                break i;
                                            }
                                            A = A + 6.2831853069365025, k = A + 2430840202602477e-25, n0[r >> 3] = k, n0[r + 8 >> 3] = A - k + 2430840202602477e-25, f = -4;
                                            break i;
                                        }
                                        if (s >>> 0 > 1094263290) break e;
                                    }
                                    w = A * .6366197723675814 + 6755399441055744 + -6755399441055744, k = A + w * -1.5707963267341256, _ = w * 6077100506506192e-26, M = k - _, e = M < -0.7853981633974483, r2(w) < 2147483648 ? f = ~~w : f = -2147483648;
                                    r: {
                                        if (e) {
                                            f = f - 1 | 0, w = w + -1, _ = w * 6077100506506192e-26, k = A + w * -1.5707963267341256;
                                            break r;
                                        }
                                        if (!(M > .7853981633974483)) break r;
                                        f = f + 1 | 0, w = w + 1, _ = w * 6077100506506192e-26, k = A + w * -1.5707963267341256;
                                    }
                                    A = k - _, n0[r >> 3] = A, I2(+A), e = c0(1) | 0, c0(0), v = s >>> 20 | 0;
                                    r: {
                                        if ((v - (e >>> 20 & 2047) | 0) < 17 || (_ = k, A = w * 6077100506303966e-26, k = k - A, _ = w * 20222662487959506e-37 - (_ - k - A), A = k - _, n0[r >> 3] = A, I2(+A), e = c0(1) | 0, c0(0), (v - (e >>> 20 & 2047) | 0) < 50)) break r;
                                        _ = k, A = w * 20222662487111665e-37, k = k - A, _ = w * 84784276603689e-45 - (_ - k - A), A = k - _, n0[r >> 3] = A;
                                    }
                                    n0[r + 8 >> 3] = k - A - _;
                                    break i;
                                }
                                if (s >>> 0 >= 2146435072) {
                                    A = A - A, n0[r >> 3] = A, n0[r + 8 >> 3] = A;
                                    break i;
                                }
                                for(f = G + 16 | 0, n = f | 8, J2(0, e | 0), J2(1, v & 1048575 | 1096810496), A = +o1(), e = 1; r2(A) < 2147483648 ? h = ~~A : h = -2147483648, k = +(h | 0), n0[f >> 3] = k, A = (A - k) * 16777216, h = e, e = 0, f = n, !!h;);
                                for(n0[G + 32 >> 3] = A, f = 2; e = f, f = e - 1 | 0, E = G + 16 | 0, n0[E + (e << 3) >> 3] == 0;);
                                if (n = 0, t = m - 560 | 0, m = t, f = (s >>> 20 | 0) - 1046 | 0, h = (f - 3 | 0) / 24 | 0, R = (h | 0) > 0 ? h : 0, h = Z(R, -24) + f | 0, W = i[13085], C = e + 1 | 0, u = C - 1 | 0, (W + u | 0) >= 0) for(f = W + C | 0, e = R - u | 0; n0[(t + 320 | 0) + (n << 3) >> 3] = (e | 0) < 0 ? 0 : +i[(e << 2) + 52352 >> 2], e = e + 1 | 0, n = n + 1 | 0, (f | 0) != (n | 0););
                                for(s = h - 24 | 0, f = 0, n = (W | 0) > 0 ? W : 0, B = (C | 0) <= 0;;){
                                    e: {
                                        if (B) {
                                            A = 0;
                                            break e;
                                        }
                                        for(y = f + u | 0, e = 0, A = 0; A = n0[(e << 3) + E >> 3] * n0[(t + 320 | 0) + (y - e << 3) >> 3] + A, e = e + 1 | 0, (C | 0) != (e | 0););
                                    }
                                    if (n0[(f << 3) + t >> 3] = A, e = (f | 0) == (n | 0), f = f + 1 | 0, !!e) break;
                                }
                                S = 47 - h | 0, y = 48 - h | 0, P = h - 25 | 0, f = W;
                                e: {
                                    for(;;){
                                        if (A = n0[(f << 3) + t >> 3], e = 0, n = f, V = (f | 0) <= 0, !V) for(;;){
                                            B = (t + 480 | 0) + (e << 2) | 0, k = A * 5960464477539063e-23;
                                            r: {
                                                if (r2(k) < 2147483648) {
                                                    u = ~~k;
                                                    break r;
                                                }
                                                u = -2147483648;
                                            }
                                            k = +(u | 0), A = k * -16777216 + A;
                                            r: {
                                                if (r2(A) < 2147483648) {
                                                    u = ~~A;
                                                    break r;
                                                }
                                                u = -2147483648;
                                            }
                                            if (i[B >> 2] = u, n = n - 1 | 0, A = n0[(n << 3) + t >> 3] + k, e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        A = T1(A, s), A = A + Us(A * .125) * -8;
                                        r: {
                                            if (r2(A) < 2147483648) {
                                                B = ~~A;
                                                break r;
                                            }
                                            B = -2147483648;
                                        }
                                        A = A - +(B | 0);
                                        r: {
                                            A: {
                                                f: {
                                                    H = (s | 0) <= 0;
                                                    k: {
                                                        if (!H) {
                                                            n = (f << 2) + t | 0, u = i[n + 476 >> 2], e = u >> y, F = n, n = u - (e << y) | 0, i[F + 476 >> 2] = n, B = e + B | 0, u = n >> S;
                                                            break k;
                                                        }
                                                        if (s) break f;
                                                        u = i[((f << 2) + t | 0) + 476 >> 2] >> 23;
                                                    }
                                                    if ((u | 0) <= 0) break r;
                                                    break A;
                                                }
                                                if (u = 2, A >= .5) break A;
                                                u = 0;
                                                break r;
                                            }
                                            if (e = 0, n = 0, !V) for(;;){
                                                F = (t + 480 | 0) + (e << 2) | 0, V = i[F >> 2], T = 16777215;
                                                A: {
                                                    f: {
                                                        if (n || (T = 16777216, V)) break f;
                                                        n = 0;
                                                        break A;
                                                    }
                                                    i[F >> 2] = T - V, n = 1;
                                                }
                                                if (e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                            }
                                            A: {
                                                if (H) break A;
                                                e = 8388607;
                                                f: switch(P | 0){
                                                    case 1:
                                                        e = 4194303;
                                                        break;
                                                    case 0:
                                                        break f;
                                                    default:
                                                        break A;
                                                }
                                                V = (f << 2) + t | 0, i[V + 476 >> 2] = i[V + 476 >> 2] & e;
                                            }
                                            if (B = B + 1 | 0, (u | 0) != 2 || (A = 1 - A, u = 2, !n)) break r;
                                            A = A - T1(1, s);
                                        }
                                        if (A == 0) {
                                            n = 0;
                                            r: {
                                                if (e = f, (W | 0) >= (e | 0)) break r;
                                                for(; e = e - 1 | 0, n = i[(t + 480 | 0) + (e << 2) >> 2] | n, (e | 0) > (W | 0););
                                                if (!n) break r;
                                                for(h = s; h = h - 24 | 0, f = f - 1 | 0, !i[(t + 480 | 0) + (f << 2) >> 2];);
                                                break e;
                                            }
                                            for(e = 1; n = e, e = e + 1 | 0, !i[(t + 480 | 0) + (W - n << 2) >> 2];);
                                            for(n = f + n | 0;;){
                                                if (u = f + C | 0, f = f + 1 | 0, n0[(t + 320 | 0) + (u << 3) >> 3] = i[(R + f << 2) + 52352 >> 2], e = 0, A = 0, (C | 0) > 0) for(; A = n0[(e << 3) + E >> 3] * n0[(t + 320 | 0) + (u - e << 3) >> 3] + A, e = e + 1 | 0, (C | 0) != (e | 0););
                                                if (n0[(f << 3) + t >> 3] = A, !((f | 0) < (n | 0))) break;
                                            }
                                            f = n;
                                            continue;
                                        }
                                        break;
                                    }
                                    A = T1(A, 24 - h | 0);
                                    r: {
                                        if (A >= 16777216) {
                                            s = (t + 480 | 0) + (f << 2) | 0, k = A * 5960464477539063e-23;
                                            A: {
                                                if (r2(k) < 2147483648) {
                                                    e = ~~k;
                                                    break A;
                                                }
                                                e = -2147483648;
                                            }
                                            A = +(e | 0) * -16777216 + A;
                                            A: {
                                                if (r2(A) < 2147483648) {
                                                    n = ~~A;
                                                    break A;
                                                }
                                                n = -2147483648;
                                            }
                                            i[s >> 2] = n, f = f + 1 | 0;
                                            break r;
                                        }
                                        r2(A) < 2147483648 ? e = ~~A : e = -2147483648, h = s;
                                    }
                                    i[(t + 480 | 0) + (f << 2) >> 2] = e;
                                }
                                A = T1(1, h);
                                e: {
                                    if ((f | 0) < 0) break e;
                                    for(e = f; n = e, n0[(e << 3) + t >> 3] = A * +i[(t + 480 | 0) + (e << 2) >> 2], e = e - 1 | 0, A = A * 5960464477539063e-23, !!n;);
                                    if ((f | 0) < 0) break e;
                                    for(n = f;;){
                                        if (A = 0, e = 0, h = f - n | 0, s = (h | 0) > (W | 0) ? W : h, (s | 0) >= 0) for(; A = n0[(e << 3) + 55120 >> 3] * n0[(e + n << 3) + t >> 3] + A, C = (e | 0) != (s | 0), e = e + 1 | 0, !!C;);
                                        if (n0[(t + 160 | 0) + (h << 3) >> 3] = A, e = (n | 0) > 0, n = n - 1 | 0, !e) break;
                                    }
                                }
                                if (A = 0, (f | 0) >= 0) for(e = f; n = e, e = e - 1 | 0, A = A + n0[(t + 160 | 0) + (n << 3) >> 3], !!n;);
                                if (n0[G >> 3] = u ? -A : A, A = n0[t + 160 >> 3] - A, e = 1, (f | 0) > 0) for(; A = A + n0[(t + 160 | 0) + (e << 3) >> 3], n = (e | 0) != (f | 0), e = e + 1 | 0, !!n;);
                                if (n0[G + 8 >> 3] = u ? -A : A, m = t + 560 | 0, f = B & 7, A = n0[G >> 3], (v | 0) < 0) {
                                    n0[r >> 3] = -A, n0[r + 8 >> 3] = -n0[G + 8 >> 3], f = 0 - f | 0;
                                    break i;
                                }
                                n0[r >> 3] = A, n0[r + 8 >> 3] = n0[G + 8 >> 3];
                            }
                            return m = G + 48 | 0, f;
                        }
                        function Sh(A, r, e, f, k, n) {
                            A = A | 0, r = +r, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            B = m - 560 | 0, m = B, i[B + 44 >> 2] = 0, I2(+r), u = c0(1) | 0, c0(0);
                            i: {
                                if ((u | 0) < 0) {
                                    F = 1, T = 2724, r = -r, I2(+r), u = c0(1) | 0, c0(0);
                                    break i;
                                }
                                if (k & 2048) {
                                    F = 1, T = 2727;
                                    break i;
                                }
                                F = k & 1, T = F ? 2730 : 2725, V = !F;
                            }
                            i: {
                                if ((u & 2146435072) == 2146435072) {
                                    u = F + 3 | 0, b1(A, 32, e, u, k & -65537), j1(A, T, F), f = n & 32, j1(A, r != r ? f ? 7584 : 16044 : f ? 9302 : 16245, 3), b1(A, 32, e, u, k ^ 8192), _ = (e | 0) < (u | 0) ? u : e;
                                    break i;
                                }
                                R = B + 16 | 0;
                                e: {
                                    r: {
                                        A: {
                                            if (r = T9(r, B + 44 | 0), r = r + r, r != 0) {
                                                if (u = i[B + 44 >> 2], i[B + 44 >> 2] = u - 1, H = n | 32, (H | 0) != 97) break A;
                                                break e;
                                            }
                                            if (H = n | 32, (H | 0) == 97) break e;
                                            w = i[B + 44 >> 2], v = (f | 0) < 0 ? 6 : f;
                                            break r;
                                        }
                                        w = u - 29 | 0, i[B + 44 >> 2] = w, r = r * 268435456, v = (f | 0) < 0 ? 6 : f;
                                    }
                                    for(W = (B + 48 | 0) + ((w | 0) >= 0 ? 288 : 0) | 0, u = W; r < 4294967296 & r >= 0 ? f = ~~r >>> 0 : f = 0, i[u >> 2] = f, u = u + 4 | 0, r = (r - +(f >>> 0)) * 1e9, r != 0;);
                                    r: {
                                        if ((w | 0) <= 0) {
                                            f = w, t = u, s = W;
                                            break r;
                                        }
                                        for(s = W, f = w;;){
                                            h = f >>> 0 >= 29 ? 29 : f, t = u - 4 | 0;
                                            A: {
                                                if (s >>> 0 > t >>> 0) break A;
                                                for(G = 0; f = i[t >> 2], _ = h & 31, M = G, (h & 63) >>> 0 >= 32 ? (G = f << _, f = 0) : (G = (1 << _) - 1 & f >>> 32 - _, f = f << _), M = M + f | 0, _ = G + y | 0, _ = f >>> 0 > M >>> 0 ? _ + 1 | 0 : _, G = _6(M, _, 1e9, 0), S = t, P = M - O0(G, w0, 1e9, 0) | 0, i[S >> 2] = P, t = t - 4 | 0, s >>> 0 <= t >>> 0;);
                                                if (!_ & M >>> 0 < 1e9) break A;
                                                s = s - 4 | 0, i[s >> 2] = G;
                                            }
                                            for(; t = u, s >>> 0 < t >>> 0 && (u = t - 4 | 0, !i[u >> 2]););
                                            if (f = i[B + 44 >> 2] - h | 0, i[B + 44 >> 2] = f, u = t, !((f | 0) > 0)) break;
                                        }
                                    }
                                    if ((f | 0) < 0) for(E = ((v + 25 >>> 0) / 9 | 0) + 1 | 0, y = (H | 0) == 102;;){
                                        f = 0 - f | 0, _ = f >>> 0 >= 9 ? 9 : f;
                                        r: {
                                            if (t >>> 0 <= s >>> 0) {
                                                u = !i[s >> 2] << 2;
                                                break r;
                                            }
                                            for(G = 1e9 >>> _ | 0, h = -1 << _ ^ -1, f = 0, u = s; M = f, f = i[u >> 2], i[u >> 2] = M + (f >>> _ | 0), f = Z(G, f & h), u = u + 4 | 0, u >>> 0 < t >>> 0;);
                                            if (u = !i[s >> 2] << 2, !f) break r;
                                            i[t >> 2] = f, t = t + 4 | 0;
                                        }
                                        if (f = _ + i[B + 44 >> 2] | 0, i[B + 44 >> 2] = f, s = u + s | 0, u = y ? W : s, t = t - u >> 2 > (E | 0) ? u + (E << 2) | 0 : t, !((f | 0) < 0)) break;
                                    }
                                    f = 0;
                                    r: {
                                        if (t >>> 0 <= s >>> 0 || (f = Z(W - s >> 2, 9), u = 10, h = i[s >> 2], h >>> 0 < 10)) break r;
                                        for(; f = f + 1 | 0, u = Z(u, 10), h >>> 0 >= u >>> 0;);
                                    }
                                    if (u = (v - ((H | 0) != 102 ? f : 0) | 0) - ((H | 0) == 103 & (v | 0) != 0) | 0, (u | 0) < (Z(t - W >> 2, 9) - 9 | 0)) {
                                        if (G = u + 9216 | 0, h = (G | 0) / 9 | 0, w = ((B + 48 | 0) + ((w | 0) < 0 ? -4092 : -3804) | 0) + (h << 2) | 0, u = 10, _ = G - Z(h, 9) | 0, (_ | 0) <= 7) for(; u = Z(u, 10), _ = _ + 1 | 0, (_ | 0) != 8;);
                                        G = i[w >> 2], E = (G >>> 0) / (u >>> 0) | 0, y = G - Z(u, E) | 0, h = w + 4 | 0;
                                        r: {
                                            if (!y & (h | 0) == (t | 0)) break r;
                                            A: {
                                                if (!(E & 1) && (r = 9007199254740992, !(o[w - 4 | 0] & 1) | ((u | 0) != 1e9 | s >>> 0 >= w >>> 0))) break A;
                                                r = 9007199254740994;
                                            }
                                            if (C = (t | 0) == (h | 0) ? 1 : 1.5, h = u >>> 1 | 0, C = h >>> 0 > y >>> 0 ? .5 : (h | 0) == (y | 0) ? C : 1.5, l[T | 0] != 45 | V || (C = -C, r = -r), h = G - y | 0, i[w >> 2] = h, r + C == r) break r;
                                            if (f = u + h | 0, i[w >> 2] = f, f >>> 0 >= 1e9) for(; i[w >> 2] = 0, w = w - 4 | 0, w >>> 0 < s >>> 0 && (s = s - 4 | 0, i[s >> 2] = 0), f = i[w >> 2] + 1 | 0, i[w >> 2] = f, f >>> 0 > 999999999;);
                                            if (f = Z(W - s >> 2, 9), u = 10, h = i[s >> 2], h >>> 0 < 10) break r;
                                            for(; f = f + 1 | 0, u = Z(u, 10), h >>> 0 >= u >>> 0;);
                                        }
                                        u = w + 4 | 0, t = t >>> 0 > u >>> 0 ? u : t;
                                    }
                                    for(; h = t, G = t >>> 0 <= s >>> 0, !G && (t = t - 4 | 0, !i[t >> 2]););
                                    r: {
                                        if ((H | 0) != 103) {
                                            w = k & 8;
                                            break r;
                                        }
                                        if (t = v || 1, u = (t | 0) > (f | 0) & (f | 0) > -5, v = (u ? f ^ -1 : -1) + t | 0, n = (u ? -1 : -2) + n | 0, w = k & 8, w) break r;
                                        t = -9;
                                        A: {
                                            if (G || (w = i[h - 4 >> 2], !w) || (_ = 10, t = 0, (w >>> 0) % 10 | 0)) break A;
                                            for(; u = t, t = t + 1 | 0, _ = Z(_, 10), !((w >>> 0) % (_ >>> 0) | 0););
                                            t = u ^ -1;
                                        }
                                        if (u = Z(h - W >> 2, 9), (n & -33) == 70) {
                                            w = 0, u = (t + u | 0) - 9 | 0, u = (u | 0) > 0 ? u : 0, v = (u | 0) > (v | 0) ? v : u;
                                            break r;
                                        }
                                        w = 0, u = ((f + u | 0) + t | 0) - 9 | 0, u = (u | 0) > 0 ? u : 0, v = (u | 0) > (v | 0) ? v : u;
                                    }
                                    if (_ = -1, y = v | w, ((y ? 2147483645 : 2147483646) | 0) < (v | 0)) break i;
                                    V = (((y | 0) != 0) + v | 0) + 1 | 0, G = n & -33;
                                    r: {
                                        if ((G | 0) == 70) {
                                            if ((V ^ 2147483647) < (f | 0)) break i;
                                            t = (f | 0) > 0 ? f : 0;
                                            break r;
                                        }
                                        if (u = f >> 31, t = y6((u ^ f) - u | 0, 0, R), (R - t | 0) <= 1) for(; t = t - 1 | 0, o[t | 0] = 48, (R - t | 0) < 2;);
                                        if (E = t - 2 | 0, o[E | 0] = n, o[t - 1 | 0] = (f | 0) < 0 ? 45 : 43, t = R - E | 0, (t | 0) > (V ^ 2147483647)) break i;
                                    }
                                    if (f = t + V | 0, (f | 0) > (F ^ 2147483647)) break i;
                                    V = f + F | 0, b1(A, 32, e, V, k), j1(A, T, F), b1(A, 48, e, V, k ^ 65536);
                                    r: {
                                        A: {
                                            f: {
                                                if ((G | 0) == 70) {
                                                    for(u = B + 16 | 9, n = s >>> 0 > W >>> 0 ? W : s, s = n;;){
                                                        t = y6(i[s >> 2], 0, u);
                                                        k: {
                                                            if ((n | 0) != (s | 0)) {
                                                                if (B + 16 >>> 0 >= t >>> 0) break k;
                                                                for(; t = t - 1 | 0, o[t | 0] = 48, B + 16 >>> 0 < t >>> 0;);
                                                                break k;
                                                            }
                                                            if ((t | 0) != (u | 0)) break k;
                                                            t = t - 1 | 0, o[t | 0] = 48;
                                                        }
                                                        if (j1(A, t, u - t | 0), s = s + 4 | 0, !(W >>> 0 >= s >>> 0)) break;
                                                    }
                                                    if (y && j1(A, 20123, 1), (v | 0) <= 0 | s >>> 0 >= h >>> 0) break f;
                                                    for(;;){
                                                        if (t = y6(i[s >> 2], 0, u), t >>> 0 > B + 16 >>> 0) for(; t = t - 1 | 0, o[t | 0] = 48, B + 16 >>> 0 < t >>> 0;);
                                                        if (j1(A, t, (v | 0) >= 9 ? 9 : v), t = v - 9 | 0, s = s + 4 | 0, h >>> 0 <= s >>> 0) break A;
                                                        if (f = (v | 0) > 9, v = t, !f) break;
                                                    }
                                                    break A;
                                                }
                                                k: {
                                                    if ((v | 0) < 0) break k;
                                                    for(n = s >>> 0 < h >>> 0 ? h : s + 4 | 0, W = B + 16 | 9, u = s;;){
                                                        t = y6(i[u >> 2], 0, W), (W | 0) == (t | 0) && (t = t - 1 | 0, o[t | 0] = 48);
                                                        n: {
                                                            if ((u | 0) != (s | 0)) {
                                                                if (B + 16 >>> 0 >= t >>> 0) break n;
                                                                for(; t = t - 1 | 0, o[t | 0] = 48, B + 16 >>> 0 < t >>> 0;);
                                                                break n;
                                                            }
                                                            if (j1(A, t, 1), t = t + 1 | 0, !(v | w)) break n;
                                                            j1(A, 20123, 1);
                                                        }
                                                        if (f = W - t | 0, j1(A, t, (f | 0) < (v | 0) ? f : v), v = v - f | 0, u = u + 4 | 0, n >>> 0 <= u >>> 0) break k;
                                                        if (!((v | 0) >= 0)) break;
                                                    }
                                                }
                                                b1(A, 48, v + 18 | 0, 18, 0), j1(A, E, R - E | 0);
                                                break r;
                                            }
                                            t = v;
                                        }
                                        b1(A, 48, t + 9 | 0, 9, 0);
                                    }
                                    b1(A, 32, e, V, k ^ 8192), _ = (e | 0) < (V | 0) ? V : e;
                                    break i;
                                }
                                w = (n << 26 >> 31 & 9) + T | 0;
                                e: {
                                    if (f >>> 0 > 11) break e;
                                    for(t = 12 - f | 0, C = 16; C = C * 16, t = t - 1 | 0, !!t;);
                                    if (l[w | 0] == 45) {
                                        r = -(C + (-r - C));
                                        break e;
                                    }
                                    r = r + C - C;
                                }
                                for(u = i[B + 44 >> 2], t = u >> 31, t = y6((t ^ u) - t | 0, 0, R), (R | 0) == (t | 0) && (t = t - 1 | 0, o[t | 0] = 48), W = F | 2, s = n & 32, u = i[B + 44 >> 2], v = t - 2 | 0, o[v | 0] = n + 15, o[t - 1 | 0] = (u | 0) < 0 ? 45 : 43, t = k & 8, u = B + 16 | 0; n = u, r2(r) < 2147483648 ? h = ~~r : h = -2147483648, o[u | 0] = s | l[h + 57904 | 0], r = (r - +(h | 0)) * 16, u = n + 1 | 0, !((f | 0) > 0 | t) & r == 0 | (u - (B + 16 | 0) | 0) != 1 || (o[n + 1 | 0] = 46, u = n + 2 | 0), r != 0;);
                                if (_ = -1, t = R - v | 0, n = t + W | 0, (2147483645 - n | 0) < (f | 0)) break i;
                                h = n, n = B + 16 | 0, s = u - n | 0, f = f && (s - 2 | 0) < (f | 0) ? f + 2 | 0 : s, u = h + f | 0, b1(A, 32, e, u, k), j1(A, w, W), b1(A, 48, e, u, k ^ 65536), j1(A, n, s), b1(A, 48, f - s | 0, 0, 0), j1(A, v, t), b1(A, 32, e, u, k ^ 8192), _ = (e | 0) < (u | 0) ? u : e;
                            }
                            return m = B + 560 | 0, _ | 0;
                        }
                        function jh(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0;
                            k = m - 272 | 0, m = k, z1(k + 252 | 0, r, e), o[k + 271 | 0] < 0 && X(i[k + 260 >> 2]);
                            i: {
                                if (l[r + 97 | 0] <= 1) {
                                    for(s0 = r + 104 | 0, v = A + 8 | 0, V = i[14959], F = V - 12 | 0, E = i[14960] - 12 | 0, R = i[14963] - 12 | 0, y = i[14961], M = y - 12 | 0, H = k + 44 | 0, T = k + 56 | 0, G = k + 36 | 0, W = k + 32 | 0, S = k + 88 | 0, P = i[14968], $ = i[14967], c = i[14965], r0 = i[14964], f0 = i[14962];;){
                                        e: {
                                            r: {
                                                A: {
                                                    f: {
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        s: {
                                                                            if (i[e + 16 >> 2]) {
                                                                                if (i[k + 192 >> 2] = 73428, i[k + 224 >> 2] = 0, i[k + 216 >> 2] = 0, i[k + 220 >> 2] = 0, i[k + 208 >> 2] = 0, i[k + 212 >> 2] = 0, i[k + 200 >> 2] = 0, i[k + 204 >> 2] = 0, i[k + 244 >> 2] = 0, i[k + 236 >> 2] = 0, i[k + 240 >> 2] = 0, _e(k + 168 | 0, k + 192 | 0, e), i[k + 168 >> 2] != i[21668]) {
                                                                                    n = i[k + 172 >> 2], i[A >> 2] = i[k + 168 >> 2], i[A + 4 >> 2] = n, i[v + 8 >> 2] = i[k + 184 >> 2], n = i[k + 180 >> 2], i[v >> 2] = i[k + 176 >> 2], i[v + 4 >> 2] = n, i[k + 176 >> 2] = 0, i[k + 180 >> 2] = 0, i[k + 184 >> 2] = 0, n = 0;
                                                                                    break e;
                                                                                }
                                                                                if (t0 = l[r + 97 | 0] ? 32 : 16, L = k, q = l5(e, t0), i[L + 232 >> 2] = q, B = B2(e), !B) {
                                                                                    u = D(56), i[k + 24 >> 2] = u, i[k + 28 >> 2] = 48, i[k + 32 >> 2] = -2147483592, t = l[19309] | l[19310] << 8 | (l[19311] << 16 | l[19312] << 24), n = l[19305] | l[19306] << 8 | (l[19307] << 16 | l[19308] << 24), o[u | 0] = n, o[u + 1 | 0] = n >>> 8, o[u + 2 | 0] = n >>> 16, o[u + 3 | 0] = n >>> 24, o[u + 4 | 0] = t, o[u + 5 | 0] = t >>> 8, o[u + 6 | 0] = t >>> 16, o[u + 7 | 0] = t >>> 24, o[u + 48 | 0] = 0, t = l[19349] | l[19350] << 8 | (l[19351] << 16 | l[19352] << 24), n = l[19345] | l[19346] << 8 | (l[19347] << 16 | l[19348] << 24), o[u + 40 | 0] = n, o[u + 41 | 0] = n >>> 8, o[u + 42 | 0] = n >>> 16, o[u + 43 | 0] = n >>> 24, o[u + 44 | 0] = t, o[u + 45 | 0] = t >>> 8, o[u + 46 | 0] = t >>> 16, o[u + 47 | 0] = t >>> 24, t = l[19341] | l[19342] << 8 | (l[19343] << 16 | l[19344] << 24), n = l[19337] | l[19338] << 8 | (l[19339] << 16 | l[19340] << 24), o[u + 32 | 0] = n, o[u + 33 | 0] = n >>> 8, o[u + 34 | 0] = n >>> 16, o[u + 35 | 0] = n >>> 24, o[u + 36 | 0] = t, o[u + 37 | 0] = t >>> 8, o[u + 38 | 0] = t >>> 16, o[u + 39 | 0] = t >>> 24, t = l[19333] | l[19334] << 8 | (l[19335] << 16 | l[19336] << 24), n = l[19329] | l[19330] << 8 | (l[19331] << 16 | l[19332] << 24), o[u + 24 | 0] = n, o[u + 25 | 0] = n >>> 8, o[u + 26 | 0] = n >>> 16, o[u + 27 | 0] = n >>> 24, o[u + 28 | 0] = t, o[u + 29 | 0] = t >>> 8, o[u + 30 | 0] = t >>> 16, o[u + 31 | 0] = t >>> 24, t = l[19325] | l[19326] << 8 | (l[19327] << 16 | l[19328] << 24), n = l[19321] | l[19322] << 8 | (l[19323] << 16 | l[19324] << 24), o[u + 16 | 0] = n, o[u + 17 | 0] = n >>> 8, o[u + 18 | 0] = n >>> 16, o[u + 19 | 0] = n >>> 24, o[u + 20 | 0] = t, o[u + 21 | 0] = t >>> 8, o[u + 22 | 0] = t >>> 16, o[u + 23 | 0] = t >>> 24, t = l[19317] | l[19318] << 8 | (l[19319] << 16 | l[19320] << 24), n = l[19313] | l[19314] << 8 | (l[19315] << 16 | l[19316] << 24), o[u + 8 | 0] = n, o[u + 9 | 0] = n >>> 8, o[u + 10 | 0] = n >>> 16, o[u + 11 | 0] = n >>> 24, o[u + 12 | 0] = t, o[u + 13 | 0] = t >>> 8, o[u + 14 | 0] = t >>> 16, o[u + 15 | 0] = t >>> 24, i0(A, 2, 0, k + 24 | 0), o[k + 35 | 0] < 0 && X(i[k + 24 >> 2]), n = 0;
                                                                                    break e;
                                                                                }
                                                                                if (C = 0, n = i[f + 28 >> 2], !(!n | n >>> 0 >= B >>> 0)) {
                                                                                    i[k + 24 >> 2] = y, i[k + 32 >> 2] = 59808, i[k + 88 >> 2] = 59828, t = k + 24 | 0, i[t + i[M >> 2] >> 2] = f0, i[k + 28 >> 2] = 0, n = t + i[i[k + 24 >> 2] - 12 >> 2] | 0, T0(n, G), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[i[R >> 2] + W >> 2] = r0, i[t + i[E >> 2] >> 2] = c, i[k + 88 >> 2] = 59828, i[k + 24 >> 2] = 59788, i[k + 32 >> 2] = 59808, h = z0(G), i[h >> 2] = 58864, i[k + 76 >> 2] = 0, i[k + 80 >> 2] = 0, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 84 >> 2] = 24, U(M0(U(M0(U(W, 20806, 34), B), 22162, 33), i[f + 28 >> 2]), 19341, 12), n = i[k + 84 >> 2];
                                                                                    u: {
                                                                                        if (n & 16) {
                                                                                            if (n = T, t = i[k + 80 >> 2], u = i[k + 60 >> 2], t >>> 0 >= u >>> 0) break u;
                                                                                            i[k + 80 >> 2] = u, t = u;
                                                                                            break u;
                                                                                        }
                                                                                        if (!(n & 8)) {
                                                                                            n = 0, o[k + 23 | 0] = 0, t = k + 12 | 0;
                                                                                            break r;
                                                                                        }
                                                                                        t = i[k + 52 >> 2], n = H;
                                                                                    }
                                                                                    if (s = i[n >> 2], n = t - s | 0, n >>> 0 >= 2147483640) break s;
                                                                                    if (n >>> 0 >= 11) {
                                                                                        u = (n | 7) + 1 | 0, t = D(u), i[k + 20 >> 2] = u | -2147483648, i[k + 12 >> 2] = t, i[k + 16 >> 2] = n;
                                                                                        break A;
                                                                                    }
                                                                                    if (o[k + 23 | 0] = n, t = k + 12 | 0, n) break A;
                                                                                    n = 0;
                                                                                    break r;
                                                                                }
                                                                                for(;;){
                                                                                    if (!i[e + 16 >> 2]) {
                                                                                        i[k + 24 >> 2] = y, i[k + 32 >> 2] = 59808, i[k + 88 >> 2] = 59828, t = k + 24 | 0, i[t + i[M >> 2] >> 2] = f0, i[k + 28 >> 2] = 0, n = t + i[i[k + 24 >> 2] - 12 >> 2] | 0, T0(n, G), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[i[R >> 2] + W >> 2] = r0, i[t + i[E >> 2] >> 2] = c, i[k + 88 >> 2] = 59828, i[k + 24 >> 2] = 59788, i[k + 32 >> 2] = 59808, h = z0(G), i[h >> 2] = 58864, i[k + 76 >> 2] = 0, i[k + 80 >> 2] = 0, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 84 >> 2] = 24, U(P0(U(M0(U(W, 21881, 24), B), 22546, 34), C), 19341, 12), n = i[k + 84 >> 2];
                                                                                        u: {
                                                                                            if (n & 16) {
                                                                                                if (n = T, t = i[k + 80 >> 2], u = i[k + 60 >> 2], t >>> 0 >= u >>> 0) break u;
                                                                                                i[k + 80 >> 2] = u, t = u;
                                                                                                break u;
                                                                                            }
                                                                                            if (!(n & 8)) {
                                                                                                n = 0, o[k + 23 | 0] = 0, t = k + 12 | 0;
                                                                                                break f;
                                                                                            }
                                                                                            t = i[k + 52 >> 2], n = H;
                                                                                        }
                                                                                        if (s = i[n >> 2], n = t - s | 0, n >>> 0 >= 2147483640) break o;
                                                                                        if (n >>> 0 >= 11) {
                                                                                            u = (n | 7) + 1 | 0, t = D(u), i[k + 20 >> 2] = u | -2147483648, i[k + 12 >> 2] = t, i[k + 16 >> 2] = n;
                                                                                            break k;
                                                                                        }
                                                                                        if (o[k + 23 | 0] = n, t = k + 12 | 0, n) break k;
                                                                                        n = 0;
                                                                                        break f;
                                                                                    }
                                                                                    s = l5(e, t0), n = i[k + 240 >> 2], t = i[k + 244 >> 2];
                                                                                    u: {
                                                                                        if (n >>> 0 < t >>> 0) {
                                                                                            i[n >> 2] = s, s = n + 4 | 0;
                                                                                            break u;
                                                                                        }
                                                                                        if (_ = i[k + 236 >> 2], h = n - _ >> 2, w = h + 1 | 0, w >>> 0 >= 1073741824) break t;
                                                                                        if (u = t - _ | 0, t = u >> 1, w = u >>> 0 >= 2147483644 ? 1073741823 : t >>> 0 > w >>> 0 ? t : w, w) {
                                                                                            if (w >>> 0 >= 1073741824) break n;
                                                                                            u = D(w << 2);
                                                                                        } else u = 0;
                                                                                        if (t = u + (h << 2) | 0, i[t >> 2] = s, s = t + 4 | 0, (n | 0) != (_ | 0)) for(; t = t - 4 | 0, n = n - 4 | 0, i[t >> 2] = i[n >> 2], (n | 0) != (_ | 0););
                                                                                        if (i[k + 244 >> 2] = u + (w << 2), i[k + 240 >> 2] = s, i[k + 236 >> 2] = t, !_) break u;
                                                                                        X(_);
                                                                                    }
                                                                                    if (i[k + 240 >> 2] = s, C = C + 1 | 0, (C | 0) == (B | 0)) break;
                                                                                }
                                                                                n = i[r + 108 >> 2];
                                                                                u: {
                                                                                    if (n >>> 0 < k0[r + 112 >> 2]) {
                                                                                        Bi(n, k + 192 | 0), n = n + 56 | 0;
                                                                                        break u;
                                                                                    }
                                                                                    n = L3(s0, k + 192 | 0);
                                                                                }
                                                                                i[r + 108 >> 2] = n, n = 1;
                                                                                break e;
                                                                            }
                                                                            if (a7(A, r), i[A >> 2]) break i;
                                                                            if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), l[e + 20 | 0] == 1) {
                                                                                if (o[k + 24 | 0] = 0, o[k + 35 | 0] = 0, i0(A, 2, 100, k + 24 | 0), o[k + 35 | 0] >= 0) break i;
                                                                                X(i[k + 24 >> 2]);
                                                                                break i;
                                                                            }
                                                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, o[86691] >= 0) {
                                                                                A = i[21671], i[v >> 2] = i[21670], i[v + 4 >> 2] = A, i[v + 8 >> 2] = i[21672];
                                                                                break i;
                                                                            }
                                                                            j(v, i[21670], i[21671]);
                                                                            break i;
                                                                        }
                                                                        Y0(), z();
                                                                    }
                                                                    Y0(), z();
                                                                }
                                                                p0(), z();
                                                            }
                                                            Z2(), z();
                                                        }
                                                        Q0(t, s, n);
                                                    }
                                                    o[n + t | 0] = 0, i0(A, 2, 100, k + 12 | 0), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), i[k + 24 >> 2] = V, i[i[F >> 2] + (k + 24 | 0) >> 2] = $, i[k + 32 >> 2] = P, i[h >> 2] = 58864, o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), x0(h), N0(S), n = 0;
                                                    break e;
                                                }
                                                Q0(t, s, n);
                                            }
                                            o[n + t | 0] = 0, i0(A, 2, 1e3, k + 12 | 0), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), i[k + 24 >> 2] = V, i[i[F >> 2] + (k + 24 | 0) >> 2] = $, i[k + 32 >> 2] = P, i[h >> 2] = 58864, o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), x0(h), N0(S), n = 0;
                                        }
                                        if (o[k + 187 | 0] < 0 && X(i[k + 176 >> 2]), t = i[k + 236 >> 2], t && (i[k + 240 >> 2] = t, X(t)), i[k + 192 >> 2] = 73428, t = i[k + 212 >> 2], t && (i[k + 216 >> 2] = t, X(t)), !n) break;
                                    }
                                    break i;
                                }
                                s4(A, r, 9365);
                            }
                            m = k + 272 | 0;
                        }
                        function Oh(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (s = n2(e), !((s | 0) == 1917403971 | (s | 0) == 1886547814)) {
                                                        if ((s | 0) != 1852009592) break k;
                                                        f = D(24), o[f + 22 | 0] = 1, Q[f + 20 >> 1] = 6, i[f + 16 >> 2] = 851969, i[f + 4 >> 2] = 1, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 78668, i[f >> 2] = 78292, t = f + 12 | 0, i[r + 100 >> 2] = t, k = i[r + 104 >> 2], i[r + 104 >> 2] = f;
                                                        n: {
                                                            if (!k || (r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r)) break n;
                                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        }
                                                        r = m - 16 | 0, m = r, k = i[e >> 2], u = p[i[i[k >> 2] + 8 >> 2]](k) | 0, s = i[e >> 2], k = w0, u = u + 7 | 0, k = u >>> 0 < 7 ? k + 1 | 0 : k;
                                                        n: {
                                                            if (p[i[i[s >> 2] + 12 >> 2]](s, u, k) | 0) {
                                                                if (o[r + 4 | 0] = 0, o[r + 15 | 0] = 0, i0(A, 2, 100, r + 4 | 0), o[r + 15 | 0] >= 0) break n;
                                                                X(i[r + 4 >> 2]);
                                                                break n;
                                                            }
                                                            if (B = t, G = B2(e), Q[B + 4 >> 1] = G, B = t, G = B2(e), Q[B + 6 >> 1] = G, B = t, G = B2(e), Q[B + 8 >> 1] = G, B = t, G = X2(e) >>> 7 | 0, o[B + 10 | 0] = G, k = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = k, k = A + 8 | 0, o[86691] >= 0) {
                                                                t = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = t, i[k + 8 >> 2] = i[21672];
                                                                break n;
                                                            }
                                                            j(k, i[21670], i[21671]);
                                                        }
                                                        if (m = r + 16 | 0, i[A >> 2]) break f;
                                                        if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), r = i[f + 4 >> 2], i[f + 4 >> 2] = r - 1, r) break e;
                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                        break e;
                                                    }
                                                    if (k = i[r + 12 >> 2], _ = k, t = i[r + 8 >> 2], !(k | t)) {
                                                        if (r = D(56), i[n + 4 >> 2] = r, i[n + 8 >> 2] = 52, i[n + 12 >> 2] = -2147483592, e = l[13211] | l[13212] << 8 | (l[13213] << 16 | l[13214] << 24), f = l[13207] | l[13208] << 8 | (l[13209] << 16 | l[13210] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 52 | 0] = 0, e = l[13255] | l[13256] << 8 | (l[13257] << 16 | l[13258] << 24), o[r + 48 | 0] = e, o[r + 49 | 0] = e >>> 8, o[r + 50 | 0] = e >>> 16, o[r + 51 | 0] = e >>> 24, e = l[13251] | l[13252] << 8 | (l[13253] << 16 | l[13254] << 24), f = l[13247] | l[13248] << 8 | (l[13249] << 16 | l[13250] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[13243] | l[13244] << 8 | (l[13245] << 16 | l[13246] << 24), f = l[13239] | l[13240] << 8 | (l[13241] << 16 | l[13242] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[13235] | l[13236] << 8 | (l[13237] << 16 | l[13238] << 24), f = l[13231] | l[13232] << 8 | (l[13233] << 16 | l[13234] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[13227] | l[13228] << 8 | (l[13229] << 16 | l[13230] << 24), f = l[13223] | l[13224] << 8 | (l[13225] << 16 | l[13226] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13219] | l[13220] << 8 | (l[13221] << 16 | l[13222] << 24), f = l[13215] | l[13216] << 8 | (l[13217] << 16 | l[13218] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 4, 0, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                                        X(i[n + 4 >> 2]);
                                                        break i;
                                                    }
                                                    if (v = i[r + 32 >> 2], h = t - v | 0, k = h - 4 | 0, f = i[f + 32 >> 2], !(!f | (_ - (t >>> 0 < v >>> 0) | 0) == (h >>> 0 < 4 | 0) & f >>> 0 >= k >>> 0)) {
                                                        if (r = D(48), i[n + 4 >> 2] = r, i[n + 8 >> 2] = 44, i[n + 12 >> 2] = -2147483600, e = l[9645] | l[9646] << 8 | (l[9647] << 16 | l[9648] << 24), f = l[9641] | l[9642] << 8 | (l[9643] << 16 | l[9644] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 44 | 0] = 0, e = l[9681] | l[9682] << 8 | (l[9683] << 16 | l[9684] << 24), o[r + 40 | 0] = e, o[r + 41 | 0] = e >>> 8, o[r + 42 | 0] = e >>> 16, o[r + 43 | 0] = e >>> 24, e = l[9677] | l[9678] << 8 | (l[9679] << 16 | l[9680] << 24), f = l[9673] | l[9674] << 8 | (l[9675] << 16 | l[9676] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[9669] | l[9670] << 8 | (l[9671] << 16 | l[9672] << 24), f = l[9665] | l[9666] << 8 | (l[9667] << 16 | l[9668] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[9661] | l[9662] << 8 | (l[9663] << 16 | l[9664] << 24), f = l[9657] | l[9658] << 8 | (l[9659] << 16 | l[9660] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[9653] | l[9654] << 8 | (l[9655] << 16 | l[9656] << 24), f = l[9649] | l[9650] << 8 | (l[9651] << 16 | l[9652] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 1e3, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                                        X(i[n + 4 >> 2]);
                                                        break i;
                                                    }
                                                    if (f = i[e >> 2], t = p[i[i[f >> 2] + 8 >> 2]](f) | 0, h = i[e >> 2], f = w0, t = k + t | 0, f = t >>> 0 < k >>> 0 ? f + 1 | 0 : f, p[i[i[h >> 2] + 12 >> 2]](h, t, f) | 0) {
                                                        if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(A, 2, 100, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                                        X(i[n + 4 >> 2]);
                                                        break i;
                                                    }
                                                    if (i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, k) {
                                                        if ((k | 0) < 0) break A;
                                                        for(u = D(k), i[n + 4 >> 2] = u, w = k + u | 0, i[n + 12 >> 2] = w, f = 0, t = B0(u, 0, k), i[n + 8 >> 2] = w; B = f + t | 0, G = X2(e), o[B | 0] = G, f = f + 1 | 0, (k | 0) != (f | 0););
                                                    }
                                                    if (f = D(32), i[f + 28 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 16 >> 2] = s, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 78628, i[f >> 2] = 78780, (u | 0) != (w | 0)) {
                                                        if (k = w - u | 0, (k | 0) < 0) break r;
                                                        t = D(k), i[f + 20 >> 2] = t, s = k + t | 0, i[f + 28 >> 2] = s, v0(t, u, k), i[f + 24 >> 2] = s;
                                                    }
                                                    i[r + 100 >> 2] = f + 12, k = i[r + 104 >> 2], i[r + 104 >> 2] = f;
                                                    n: {
                                                        if (!k || (r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r)) break n;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    }
                                                    if (r = i[n + 4 >> 2], !r) break e;
                                                    X(r);
                                                    break e;
                                                }
                                                if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(A, 2, 126, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                                X(i[n + 4 >> 2]);
                                                break i;
                                            }
                                            if (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A) break i;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            break i;
                                        }
                                        p0(), z();
                                    }
                                    p0(), z();
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(A, 2, 100, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                    X(i[n + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 16 | 0;
                        }
                        function Ph(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            if (f = Q[r + 22 >> 1], _ = Q[r + 6 >> 1], w = Q[r + 30 >> 1], u = ((Z(f, -74) + Z(_, 74) | 0) + Z(w, 74) | 0) - -64 >> 7, u = (u | 0) >= 32767 ? 32767 : u, u = (u | 0) <= -32768 ? -32768 : u, n = Q[r + 20 >> 1], s = Q[r + 4 >> 1], t = Q[r + 28 >> 1], G = ((Z(n, -74) + Z(s, 74) | 0) + Z(t, 74) | 0) - -64 >> 7, G = (G | 0) >= 32767 ? 32767 : G, G = (G | 0) <= -32768 ? -32768 : G, V = Q[r + 18 >> 1], h = Q[r + 2 >> 1], B = Q[r + 26 >> 1], v = ((Z(V, -74) + Z(h, 74) | 0) + Z(B, 74) | 0) - -64 >> 7, v = (v | 0) >= 32767 ? 32767 : v, y = (v | 0) <= -32768 ? -32768 : v, F = Q[r + 16 >> 1], E = Q[r >> 1], R = Q[r + 24 >> 1], v = ((Z(F, -74) + Z(E, 74) | 0) + Z(R, 74) | 0) - -64 >> 7, v = (v | 0) >= 32767 ? 32767 : v, v = (v | 0) <= -32768 ? -32768 : v, k = Q[r + 14 >> 1], W = (((Z(k, -74) + Z(_, 84) | 0) + Z(f, 55) | 0) + Z(w, -29) | 0) - -64 >> 7, W = (W | 0) >= 32767 ? 32767 : W, W = (W | 0) <= -32768 ? -32768 : W, C = Z(k, 74), k = (((C + Z(_, 55) | 0) + Z(f, -29) | 0) + Z(w, -84) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, k = (k | 0) <= -32768 ? -32768 : k, f = (((C + Z(_, 29) | 0) + Z(f, 84) | 0) + Z(w, 55) | 0) - -64 >> 7, f = (f | 0) >= 32767 ? 32767 : f, f = (f | 0) <= -32768 ? -32768 : f, w = Q[r + 12 >> 1], _ = (((Z(w, -74) + Z(s, 84) | 0) + Z(n, 55) | 0) + Z(t, -29) | 0) - -64 >> 7, _ = (_ | 0) >= 32767 ? 32767 : _, _ = (_ | 0) <= -32768 ? -32768 : _, C = Z(w, 74), w = (((C + Z(s, 55) | 0) + Z(n, -29) | 0) + Z(t, -84) | 0) - -64 >> 7, w = (w | 0) >= 32767 ? 32767 : w, w = (w | 0) <= -32768 ? -32768 : w, n = (((C + Z(s, 29) | 0) + Z(n, 84) | 0) + Z(t, 55) | 0) - -64 >> 7, n = (n | 0) >= 32767 ? 32767 : n, n = (n | 0) <= -32768 ? -32768 : n, s = Q[r + 10 >> 1], t = (((Z(s, -74) + Z(h, 84) | 0) + Z(V, 55) | 0) + Z(B, -29) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, C = (t | 0) <= -32768 ? -32768 : t, s = Z(s, 74), t = (((s + Z(h, 55) | 0) + Z(V, -29) | 0) + Z(B, -84) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, M = (t | 0) <= -32768 ? -32768 : t, s = (((s + Z(h, 29) | 0) + Z(V, 84) | 0) + Z(B, 55) | 0) - -64 >> 7, s = (s | 0) >= 32767 ? 32767 : s, V = (s | 0) <= -32768 ? -32768 : s, s = Q[r + 8 >> 1], r = (((Z(s, -74) + Z(E, 84) | 0) + Z(F, 55) | 0) + Z(R, -29) | 0) - -64 >> 7, r = (r | 0) >= 32767 ? 32767 : r, r = (r | 0) <= -32768 ? -32768 : r, t = Z(s, 74), s = (((t + Z(E, 55) | 0) + Z(F, -29) | 0) + Z(R, -84) | 0) - -64 >> 7, s = (s | 0) >= 32767 ? 32767 : s, s = (s | 0) <= -32768 ? -32768 : s, t = (((t + Z(E, 29) | 0) + Z(F, 84) | 0) + Z(R, 55) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, t = (t | 0) <= -32768 ? -32768 : t, (e | 0) != 1) {
                                h = l[A + 2 | 0] + (((Z(n, -74) + Z(t, 74) | 0) + Z(f, 74) | 0) + 2048 >> 12) | 0, h = (h | 0) >= 255 ? 255 : h, o[A + 2 | 0] = (h | 0) > 0 ? h : 0, h = Z(V, 74), B = l[A | 0] + ((((h + Z(t, 29) | 0) + Z(n, 84) | 0) + Z(f, 55) | 0) + 2048 >> 12) | 0, B = (B | 0) >= 255 ? 255 : B, o[A | 0] = (B | 0) > 0 ? B : 0, h = l[A + 1 | 0] + ((((h + Z(t, 55) | 0) + Z(n, -29) | 0) + Z(f, -84) | 0) + 2048 >> 12) | 0, h = (h | 0) >= 255 ? 255 : h, o[A + 1 | 0] = (h | 0) > 0 ? h : 0, f = l[A + 3 | 0] + ((((Z(V, -74) + Z(t, 84) | 0) + Z(n, 55) | 0) + Z(f, -29) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, o[A + 3 | 0] = (f | 0) > 0 ? f : 0, f = A + e | 0, t = Z(M, 74), n = l[f | 0] + ((((t + Z(s, 29) | 0) + Z(w, 84) | 0) + Z(k, 55) | 0) + 2048 >> 12) | 0, n = (n | 0) >= 255 ? 255 : n, o[f | 0] = (n | 0) > 0 ? n : 0, n = l[f + 1 | 0] + ((((t + Z(s, 55) | 0) + Z(w, -29) | 0) + Z(k, -84) | 0) + 2048 >> 12) | 0, n = (n | 0) >= 255 ? 255 : n, o[f + 1 | 0] = (n | 0) > 0 ? n : 0, n = l[f + 2 | 0] + (((Z(w, -74) + Z(s, 74) | 0) + Z(k, 74) | 0) + 2048 >> 12) | 0, n = (n | 0) >= 255 ? 255 : n, o[f + 2 | 0] = (n | 0) > 0 ? n : 0, k = l[f + 3 | 0] + ((((Z(M, -74) + Z(s, 84) | 0) + Z(w, 55) | 0) + Z(k, -29) | 0) + 2048 >> 12) | 0, k = (k | 0) >= 255 ? 255 : k, o[f + 3 | 0] = (k | 0) > 0 ? k : 0, k = (e << 1) + A | 0, w = Z(y, 74), f = l[k | 0] + ((((w + Z(v, 29) | 0) + Z(G, 84) | 0) + Z(u, 55) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, o[k | 0] = (f | 0) > 0 ? f : 0, f = l[k + 1 | 0] + ((((w + Z(v, 55) | 0) + Z(G, -29) | 0) + Z(u, -84) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, o[k + 1 | 0] = (f | 0) > 0 ? f : 0, f = l[k + 2 | 0] + (((Z(G, -74) + Z(v, 74) | 0) + Z(u, 74) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, o[k + 2 | 0] = (f | 0) > 0 ? f : 0, u = l[k + 3 | 0] + ((((Z(y, -74) + Z(v, 84) | 0) + Z(G, 55) | 0) + Z(u, -29) | 0) + 2048 >> 12) | 0, u = (u | 0) >= 255 ? 255 : u, o[k + 3 | 0] = (u | 0) > 0 ? u : 0, A = Z(e, 3) + A | 0, u = Z(C, 74), e = l[A | 0] + ((((u + Z(r, 29) | 0) + Z(_, 84) | 0) + Z(W, 55) | 0) + 2048 >> 12) | 0, e = (e | 0) >= 255 ? 255 : e, o[A | 0] = (e | 0) > 0 ? e : 0, e = l[A + 1 | 0] + ((((u + Z(r, 55) | 0) + Z(_, -29) | 0) + Z(W, -84) | 0) + 2048 >> 12) | 0, e = (e | 0) >= 255 ? 255 : e, o[A + 1 | 0] = (e | 0) > 0 ? e : 0, e = l[A + 2 | 0] + (((Z(_, -74) + Z(r, 74) | 0) + Z(W, 74) | 0) + 2048 >> 12) | 0, e = (e | 0) >= 255 ? 255 : e, o[A + 2 | 0] = (e | 0) > 0 ? e : 0, e = A, A = l[A + 3 | 0] + ((((Z(C, -74) + Z(r, 84) | 0) + Z(_, 55) | 0) + Z(W, -29) | 0) + 2048 >> 12) | 0, A = (A | 0) >= 255 ? 255 : A, o[e + 3 | 0] = (A | 0) > 0 ? A : 0;
                                return;
                            }
                            h = l[A + 2 | 0] + (((Z(n, -74) + Z(t, 74) | 0) + Z(f, 74) | 0) + 2048 >> 12) | 0, h = (h | 0) >= 255 ? 255 : h, o[A + 2 | 0] = (h | 0) > 0 ? h : 0, h = Z(V, 74), B = l[A | 0] + ((((h + Z(t, 29) | 0) + Z(n, 84) | 0) + Z(f, 55) | 0) + 2048 >> 12) | 0, B = (B | 0) >= 255 ? 255 : B, o[A | 0] = (B | 0) > 0 ? B : 0, h = l[A + 1 | 0] + ((((h + Z(t, 55) | 0) + Z(n, -29) | 0) + Z(f, -84) | 0) + 2048 >> 12) | 0, h = (h | 0) >= 255 ? 255 : h, o[A + 1 | 0] = (h | 0) > 0 ? h : 0, f = l[A + 3 | 0] + ((((Z(V, -74) + Z(t, 84) | 0) + Z(n, 55) | 0) + Z(f, -29) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, n = (f | 0) > 0 ? f : 0, o[A + 3 | 0] = n, f = A + e | 0, n = n + (((Z(w, -74) + Z(s, 74) | 0) + Z(k, 74) | 0) + 2048 >> 12) | 0, n = (n | 0) >= 255 ? 255 : n, o[f + 2 | 0] = (n | 0) > 0 ? n : 0, n = Z(M, 74), t = l[f | 0] + ((((n + Z(s, 29) | 0) + Z(w, 84) | 0) + Z(k, 55) | 0) + 2048 >> 12) | 0, t = (t | 0) >= 255 ? 255 : t, o[f | 0] = (t | 0) > 0 ? t : 0, n = l[f + 1 | 0] + ((((n + Z(s, 55) | 0) + Z(w, -29) | 0) + Z(k, -84) | 0) + 2048 >> 12) | 0, n = (n | 0) >= 255 ? 255 : n, o[f + 1 | 0] = (n | 0) > 0 ? n : 0, k = l[f + 3 | 0] + ((((Z(M, -74) + Z(s, 84) | 0) + Z(w, 55) | 0) + Z(k, -29) | 0) + 2048 >> 12) | 0, k = (k | 0) >= 255 ? 255 : k, k = (k | 0) > 0 ? k : 0, o[f + 3 | 0] = k, k = k + (((Z(G, -74) + Z(v, 74) | 0) + Z(u, 74) | 0) + 2048 >> 12) | 0, k = (k | 0) >= 255 ? 255 : k, o[A + 4 | 0] = (k | 0) > 0 ? k : 0, k = Z(y, 74), f = l[A + 2 | 0] + ((((k + Z(v, 29) | 0) + Z(G, 84) | 0) + Z(u, 55) | 0) + 2048 >> 12) | 0, f = (f | 0) >= 255 ? 255 : f, o[A + 2 | 0] = (f | 0) > 0 ? f : 0, k = l[A + 3 | 0] + ((((k + Z(v, 55) | 0) + Z(G, -29) | 0) + Z(u, -84) | 0) + 2048 >> 12) | 0, k = (k | 0) >= 255 ? 255 : k, o[A + 3 | 0] = (k | 0) > 0 ? k : 0, u = l[A + 5 | 0] + ((((Z(y, -74) + Z(v, 84) | 0) + Z(G, 55) | 0) + Z(u, -29) | 0) + 2048 >> 12) | 0, u = (u | 0) >= 255 ? 255 : u, u = (u | 0) > 0 ? u : 0, o[A + 5 | 0] = u, A = Z(e, 3) + A | 0, e = u + (((Z(_, -74) + Z(r, 74) | 0) + Z(W, 74) | 0) + 2048 >> 12) | 0, e = (e | 0) >= 255 ? 255 : e, o[A + 2 | 0] = (e | 0) > 0 ? e : 0, e = Z(C, 74), u = l[A | 0] + ((((e + Z(r, 29) | 0) + Z(_, 84) | 0) + Z(W, 55) | 0) + 2048 >> 12) | 0, u = (u | 0) >= 255 ? 255 : u, o[A | 0] = (u | 0) > 0 ? u : 0, e = l[A + 1 | 0] + ((((e + Z(r, 55) | 0) + Z(_, -29) | 0) + Z(W, -84) | 0) + 2048 >> 12) | 0, e = (e | 0) >= 255 ? 255 : e, o[A + 1 | 0] = (e | 0) > 0 ? e : 0, e = A, A = l[A + 3 | 0] + ((((Z(C, -74) + Z(r, 84) | 0) + Z(_, 55) | 0) + Z(W, -29) | 0) + 2048 >> 12) | 0, A = (A | 0) >= 255 ? 255 : A, o[e + 3 | 0] = (A | 0) > 0 ? A : 0;
                        }
                        function Lh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0, D1 = 0, e4 = 0, r4 = 0, A4 = 0, U4 = 0, H4 = 0, U6 = 0, H6 = 0, Wf = 0, Xf = 0, pf = 0, Qf = 0, Cf = 0, Vf = 0, yf = 0, If = 0, Ff = 0, Yf = 0, Ef = 0, gf = 0, Jf = 0, Rf = 0, Nf = 0, Df = 0, Mf = 0, Uf = 0, Hf = 0, xf = 0, zf = 0, Tf = 0, Sf = 0, jf = 0, Of = 0, Pf = 0, Lf = 0, Kf = 0, qf = 0, $f = 0, af = 0, bf = 0, df = 0, cf = 0, ik = 0, ek = 0, rk = 0, Ak = 0, fk = 0, kk = 0, nk = 0, tk = 0, ok = 0, uk = 0, lk = 0, sk = 0, hk = 0, wk = 0, vk = 0, _k = 0, Bk = 0, mk = 0, Zk = 0, Gk = 0, Wk = 0, Xk = 0, pk = 0, Qk = 0;
                            G = Z(e, 14) + r | 0, F = I[G + 14 >> 1], E = I[r + 14 >> 1], R = I[r + 6 >> 1], s = E + R | 0, S = I[r + 10 >> 1], P = I[r + 2 >> 1], h = S + P | 0, f = s + h | 0, $ = I[r + 12 >> 1], c = I[r + 4 >> 1], v = $ + c | 0, L = I[r + 8 >> 1], q = I[r >> 1], _ = L + q | 0, n = v + _ | 0, t = f + n | 0, k = (e << 3) + r | 0, m0 = I[k + 14 >> 1], Z0 = I[k + 6 >> 1], W = m0 + Z0 | 0, X0 = I[k + 10 >> 1], V0 = I[k + 2 >> 1], C = X0 + V0 | 0, w = W + C | 0, I0 = I[k + 12 >> 1], F0 = I[k + 4 >> 1], V = I0 + F0 | 0, v2 = I[k + 8 >> 1], y2 = I[k >> 1], M = v2 + y2 | 0, B = V + M | 0, u = w + B | 0, y = t - u | 0, k = (e << 2) + r | 0, U2 = I[k + 14 >> 1], H2 = I[k + 6 >> 1], g0 = U2 + H2 | 0, j2 = I[k + 10 >> 1], K2 = I[k + 2 >> 1], R0 = j2 + K2 | 0, r0 = g0 + R0 | 0, i1 = I[k + 12 >> 1], v1 = I[k + 4 >> 1], D0 = i1 + v1 | 0, p1 = I[k + 8 >> 1], V1 = I[k >> 1], H0 = p1 + V1 | 0, f0 = D0 + H0 | 0, H = r0 + f0 | 0, k = Z(e, 12) + r | 0, y1 = I[k + 14 >> 1], I1 = I[k + 6 >> 1], i2 = y1 + I1 | 0, D1 = I[k + 10 >> 1], e4 = I[k + 2 >> 1], e2 = D1 + e4 | 0, t0 = i2 + e2 | 0, r4 = I[k + 12 >> 1], A4 = I[k + 4 >> 1], k2 = r4 + A4 | 0, U4 = I[k + 8 >> 1], U6 = I[k >> 1], H4 = U4 + U6 | 0, t2 = k2 + H4 | 0, s0 = t0 + t2 | 0, T = H - s0 | 0, H6 = y - T | 0, k = (e << 1) + r | 0, Wf = I[k + 14 >> 1], Xf = I[k + 6 >> 1], pf = Wf + Xf | 0, Qf = I[k + 10 >> 1], Cf = I[k + 2 >> 1], Vf = Qf + Cf | 0, yf = pf + Vf | 0, If = I[k + 12 >> 1], Ff = I[k + 4 >> 1], Yf = If + Ff | 0, Ef = I[k + 8 >> 1], gf = I[k >> 1], Jf = Ef + gf | 0, Rf = Yf + Jf | 0, Nf = yf + Rf | 0, k = Z(e, 10) + r | 0, Df = I[k + 14 >> 1], Mf = I[k + 6 >> 1], Uf = Df + Mf | 0, Hf = I[k + 10 >> 1], xf = I[k + 2 >> 1], zf = Hf + xf | 0, Tf = Uf + zf | 0, Sf = I[k + 12 >> 1], jf = I[k + 4 >> 1], Of = Sf + jf | 0, Pf = I[k + 8 >> 1], k = I[k >> 1], Lf = Pf + k | 0, Kf = Of + Lf | 0, qf = Tf + Kf | 0, $f = Nf - qf | 0, r = Z(e, 6) + r | 0, e = I[r + 14 >> 1], af = I[r + 6 >> 1], bf = e + af | 0, df = I[r + 10 >> 1], cf = I[r + 2 >> 1], ik = df + cf | 0, ek = bf + ik | 0, rk = I[r + 12 >> 1], Ak = I[r + 4 >> 1], fk = rk + Ak | 0, kk = I[r + 8 >> 1], r = I[r >> 1], nk = kk + r | 0, tk = fk + nk | 0, ok = ek + tk | 0, uk = I[G + 6 >> 1], lk = F + uk | 0, sk = I[G + 10 >> 1], hk = I[G + 2 >> 1], wk = sk + hk | 0, vk = lk + wk | 0, _k = I[G + 12 >> 1], Bk = I[G + 4 >> 1], mk = _k + Bk | 0, Zk = I[G + 8 >> 1], G = I[G >> 1], Gk = Zk + G | 0, Wk = mk + Gk | 0, Xk = vk + Wk | 0, pk = ok - Xk | 0, Qk = $f - pk | 0, Q[A + 112 >> 1] = H6 - Qk, Q[A + 96 >> 1] = H6 + Qk, y = y + T | 0, T = $f + pk | 0, Q[A + 80 >> 1] = y - T, Q[A + 64 >> 1] = y + T, t = t + u | 0, u = H + s0 | 0, y = t - u | 0, H = Nf + qf | 0, s0 = ok + Xk | 0, T = H - s0 | 0, Q[A + 48 >> 1] = y - T, Q[A + 32 >> 1] = y + T, t = t + u | 0, u = H + s0 | 0, Q[A + 16 >> 1] = t - u, Q[A >> 1] = t + u, f = n - f | 0, n = B - w | 0, t = f - n | 0, w = f0 - r0 | 0, B = t2 - t0 | 0, u = w - B | 0, y = t - u | 0, r0 = Rf - yf | 0, f0 = Kf - Tf | 0, H = r0 - f0 | 0, t0 = tk - ek | 0, t2 = Wk - vk | 0, s0 = t0 - t2 | 0, T = H - s0 | 0, Q[A + 114 >> 1] = y - T, Q[A + 98 >> 1] = y + T, t = t + u | 0, u = H + s0 | 0, Q[A + 82 >> 1] = t - u, Q[A + 66 >> 1] = t + u, f = f + n | 0, n = w + B | 0, t = f - n | 0, w = r0 + f0 | 0, B = t0 + t2 | 0, u = w - B | 0, Q[A + 50 >> 1] = t - u, Q[A + 34 >> 1] = t + u, f = f + n | 0, n = w + B | 0, Q[A + 18 >> 1] = f - n, Q[A + 2 >> 1] = f + n, s = h - s | 0, h = _ - v | 0, f = s + h | 0, v = C - W | 0, _ = M - V | 0, n = v + _ | 0, t = f - n | 0, W = R0 - g0 | 0, C = H0 - D0 | 0, w = W + C | 0, V = e2 - i2 | 0, M = H4 - k2 | 0, B = V + M | 0, u = w - B | 0, y = t - u | 0, g0 = Vf - pf | 0, R0 = Jf - Yf | 0, r0 = g0 + R0 | 0, D0 = zf - Uf | 0, H0 = Lf - Of | 0, f0 = D0 + H0 | 0, H = r0 - f0 | 0, i2 = ik - bf | 0, e2 = nk - fk | 0, t0 = i2 + e2 | 0, k2 = wk - lk | 0, H4 = Gk - mk | 0, t2 = k2 + H4 | 0, s0 = t0 - t2 | 0, T = H - s0 | 0, Q[A + 116 >> 1] = y - T, Q[A + 100 >> 1] = y + T, t = t + u | 0, u = H + s0 | 0, Q[A + 84 >> 1] = t - u, Q[A + 68 >> 1] = t + u, f = f + n | 0, n = w + B | 0, t = f - n | 0, w = r0 + f0 | 0, B = t0 + t2 | 0, u = w - B | 0, Q[A + 52 >> 1] = t - u, Q[A + 36 >> 1] = t + u, f = f + n | 0, n = w + B | 0, Q[A + 20 >> 1] = f - n, Q[A + 4 >> 1] = f + n, s = h - s | 0, h = _ - v | 0, f = s - h | 0, v = C - W | 0, _ = M - V | 0, n = v - _ | 0, t = f - n | 0, W = R0 - g0 | 0, C = H0 - D0 | 0, w = W - C | 0, V = e2 - i2 | 0, M = H4 - k2 | 0, B = V - M | 0, u = w - B | 0, Q[A + 118 >> 1] = t - u, Q[A + 102 >> 1] = t + u, f = f + n | 0, n = w + B | 0, Q[A + 86 >> 1] = f - n, Q[A + 70 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, f = s - h | 0, v = W + C | 0, _ = V + M | 0, n = v - _ | 0, Q[A + 54 >> 1] = f - n, Q[A + 38 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, Q[A + 22 >> 1] = s - h, Q[A + 6 >> 1] = s + h, E = R - E | 0, R = P - S | 0, s = E + R | 0, S = c - $ | 0, P = q - L | 0, h = S + P | 0, f = s + h | 0, $ = Z0 - m0 | 0, c = V0 - X0 | 0, v = $ + c | 0, L = F0 - I0 | 0, q = y2 - v2 | 0, _ = L + q | 0, n = v + _ | 0, t = f - n | 0, m0 = H2 - U2 | 0, Z0 = K2 - j2 | 0, W = m0 + Z0 | 0, X0 = v1 - i1 | 0, V0 = V1 - p1 | 0, C = X0 + V0 | 0, w = W + C | 0, I0 = I1 - y1 | 0, F0 = e4 - D1 | 0, V = I0 + F0 | 0, v2 = A4 - r4 | 0, y2 = U6 - U4 | 0, M = v2 + y2 | 0, B = V + M | 0, u = w - B | 0, y = t - u | 0, U2 = Xf - Wf | 0, H2 = Cf - Qf | 0, g0 = U2 + H2 | 0, j2 = Ff - If | 0, K2 = gf - Ef | 0, R0 = j2 + K2 | 0, r0 = g0 + R0 | 0, i1 = Mf - Df | 0, v1 = xf - Hf | 0, D0 = i1 + v1 | 0, p1 = jf - Sf | 0, k = k - Pf | 0, V1 = p1 + k | 0, H0 = D0 + V1 | 0, f0 = r0 - H0 | 0, e = af - e | 0, H = cf - df | 0, y1 = e + H | 0, I1 = Ak - rk | 0, r = r - kk | 0, i2 = I1 + r | 0, D1 = y1 + i2 | 0, F = uk - F | 0, e4 = hk - sk | 0, e2 = F + e4 | 0, t0 = Bk - _k | 0, G = G - Zk | 0, r4 = t0 + G | 0, A4 = e2 + r4 | 0, k2 = D1 - A4 | 0, U4 = f0 - k2 | 0, Q[A + 120 >> 1] = y - U4, Q[A + 104 >> 1] = y + U4, t = t + u | 0, u = f0 + k2 | 0, Q[A + 88 >> 1] = t - u, Q[A + 72 >> 1] = t + u, f = f + n | 0, n = w + B | 0, t = f - n | 0, w = r0 + H0 | 0, B = D1 + A4 | 0, u = w - B | 0, Q[A + 56 >> 1] = t - u, Q[A + 40 >> 1] = t + u, f = f + n | 0, n = w + B | 0, Q[A + 24 >> 1] = f - n, Q[A + 8 >> 1] = f + n, s = h - s | 0, h = _ - v | 0, f = s - h | 0, v = C - W | 0, _ = M - V | 0, n = v - _ | 0, t = f - n | 0, W = R0 - g0 | 0, C = V1 - D0 | 0, w = W - C | 0, V = i2 - y1 | 0, M = r4 - e2 | 0, B = V - M | 0, u = w - B | 0, Q[A + 122 >> 1] = t - u, Q[A + 106 >> 1] = t + u, f = f + n | 0, n = w + B | 0, Q[A + 90 >> 1] = f - n, Q[A + 74 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, f = s - h | 0, v = W + C | 0, _ = V + M | 0, n = v - _ | 0, Q[A + 58 >> 1] = f - n, Q[A + 42 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, Q[A + 26 >> 1] = s - h, Q[A + 10 >> 1] = s + h, E = R - E | 0, R = P - S | 0, s = E + R | 0, S = c - $ | 0, P = q - L | 0, h = S + P | 0, f = s - h | 0, $ = Z0 - m0 | 0, c = V0 - X0 | 0, v = $ + c | 0, L = F0 - I0 | 0, q = y2 - v2 | 0, _ = L + q | 0, n = v - _ | 0, t = f - n | 0, m0 = H2 - U2 | 0, Z0 = K2 - j2 | 0, W = m0 + Z0 | 0, X0 = v1 - i1 | 0, k = k - p1 | 0, V0 = X0 + k | 0, C = W - V0 | 0, e = H - e | 0, r = r - I1 | 0, w = e + r | 0, F = e4 - F | 0, G = G - t0 | 0, I0 = F + G | 0, F0 = w - I0 | 0, V = C - F0 | 0, Q[A + 124 >> 1] = t - V, Q[A + 108 >> 1] = t + V, f = f + n | 0, n = C + F0 | 0, Q[A + 92 >> 1] = f - n, Q[A + 76 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, f = s - h | 0, v = W + V0 | 0, _ = w + I0 | 0, n = v - _ | 0, Q[A + 60 >> 1] = f - n, Q[A + 44 >> 1] = f + n, s = s + h | 0, h = v + _ | 0, Q[A + 28 >> 1] = s - h, Q[A + 12 >> 1] = s + h, G = G - F | 0, r = r - e | 0, e = G + r | 0, k = k - X0 | 0, F = Z0 - m0 | 0, s = k + F | 0, h = e + s | 0, f = q - L | 0, $ = c - $ | 0, c = f + $ | 0, S = P - S | 0, E = R - E | 0, R = S + E | 0, P = c + R | 0, Q[A + 14 >> 1] = h + P, Q[A + 30 >> 1] = P - h, e = s - e | 0, R = R - c | 0, Q[A + 46 >> 1] = e + R, Q[A + 62 >> 1] = R - e, r = r - G | 0, e = F - k | 0, G = r + e | 0, k = $ - f | 0, F = E - S | 0, E = k + F | 0, Q[A + 78 >> 1] = G + E, Q[A + 94 >> 1] = E - G, r = e - r | 0, e = F - k | 0, Q[A + 110 >> 1] = r + e, Q[A + 126 >> 1] = e - r;
                        }
                        function P8(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 160 | 0, m = k, n = V6(i[r + 48 >> 2], e);
                            i: {
                                if (!(!((n | 0) == 1735551332 | (n | 0) == 1768912492) & (n | 0) != 1768187246)) {
                                    n = i[r + 48 >> 2], t = i[n + 84 >> 2], n = i[n + 88 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1);
                                    e: {
                                        if (!t) {
                                            if (r = D(56), i[k + 4 >> 2] = r, i[k + 8 >> 2] = 54, i[k + 12 >> 2] = -2147483592, e = l[4330] | l[4331] << 8 | (l[4332] << 16 | l[4333] << 24), f = l[4326] | l[4327] << 8 | (l[4328] << 16 | l[4329] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 54 | 0] = 0, e = l[4376] | l[4377] << 8 | (l[4378] << 16 | l[4379] << 24), f = l[4372] | l[4373] << 8 | (l[4374] << 16 | l[4375] << 24), o[r + 46 | 0] = f, o[r + 47 | 0] = f >>> 8, o[r + 48 | 0] = f >>> 16, o[r + 49 | 0] = f >>> 24, o[r + 50 | 0] = e, o[r + 51 | 0] = e >>> 8, o[r + 52 | 0] = e >>> 16, o[r + 53 | 0] = e >>> 24, e = l[4370] | l[4371] << 8 | (l[4372] << 16 | l[4373] << 24), f = l[4366] | l[4367] << 8 | (l[4368] << 16 | l[4369] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[4362] | l[4363] << 8 | (l[4364] << 16 | l[4365] << 24), f = l[4358] | l[4359] << 8 | (l[4360] << 16 | l[4361] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[4354] | l[4355] << 8 | (l[4356] << 16 | l[4357] << 24), f = l[4350] | l[4351] << 8 | (l[4352] << 16 | l[4353] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[4346] | l[4347] << 8 | (l[4348] << 16 | l[4349] << 24), f = l[4342] | l[4343] << 8 | (l[4344] << 16 | l[4345] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[4338] | l[4339] << 8 | (l[4340] << 16 | l[4341] << 24), f = l[4334] | l[4335] << 8 | (l[4336] << 16 | l[4337] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 117, k + 4 | 0), o[k + 15 | 0] >= 0) break e;
                                            X(i[k + 4 >> 2]);
                                            break e;
                                        }
                                        Q8(k + 4 | 0, t, e, 1684630887);
                                        r: {
                                            A: {
                                                if (t = i[k + 4 >> 2], (t | 0) != i[k + 8 >> 2] && (u = e, e = i[t >> 2], (u | 0) != (e | 0))) break A;
                                                if (r = D(56), i[k + 148 >> 2] = r, i[k + 152 >> 2] = 54, i[k + 156 >> 2] = -2147483592, e = l[4330] | l[4331] << 8 | (l[4332] << 16 | l[4333] << 24), f = l[4326] | l[4327] << 8 | (l[4328] << 16 | l[4329] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 54 | 0] = 0, e = l[4376] | l[4377] << 8 | (l[4378] << 16 | l[4379] << 24), f = l[4372] | l[4373] << 8 | (l[4374] << 16 | l[4375] << 24), o[r + 46 | 0] = f, o[r + 47 | 0] = f >>> 8, o[r + 48 | 0] = f >>> 16, o[r + 49 | 0] = f >>> 24, o[r + 50 | 0] = e, o[r + 51 | 0] = e >>> 8, o[r + 52 | 0] = e >>> 16, o[r + 53 | 0] = e >>> 24, e = l[4370] | l[4371] << 8 | (l[4372] << 16 | l[4373] << 24), f = l[4366] | l[4367] << 8 | (l[4368] << 16 | l[4369] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[4362] | l[4363] << 8 | (l[4364] << 16 | l[4365] << 24), f = l[4358] | l[4359] << 8 | (l[4360] << 16 | l[4361] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[4354] | l[4355] << 8 | (l[4356] << 16 | l[4357] << 24), f = l[4350] | l[4351] << 8 | (l[4352] << 16 | l[4353] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[4346] | l[4347] << 8 | (l[4348] << 16 | l[4349] << 24), f = l[4342] | l[4343] << 8 | (l[4344] << 16 | l[4345] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[4338] | l[4339] << 8 | (l[4340] << 16 | l[4341] << 24), f = l[4334] | l[4335] << 8 | (l[4336] << 16 | l[4337] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 117, k + 148 | 0), o[k + 159 | 0] >= 0) break r;
                                                X(i[k + 148 >> 2]);
                                                break r;
                                            }
                                            P8(A, r, e, f);
                                        }
                                        if (A = i[k + 4 >> 2], !A) break e;
                                        i[k + 8 >> 2] = A, X(A);
                                    }
                                    if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                    break i;
                                }
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (n = i[r + 20 >> 2], !n) break k;
                                                    for(t = r + 20 | 0, r = t; u = k0[n + 16 >> 2] < e >>> 0, r = u ? r : n, n = i[(u << 2) + n >> 2], !!n;);
                                                    if ((r | 0) == (t | 0) | k0[r + 16 >> 2] > e >>> 0) break k;
                                                    if (i[f >> 2] = e, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] < 0) break f;
                                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                    break i;
                                                }
                                                i[k + 12 >> 2] = 59808, i[k + 68 >> 2] = 59828, r = i[14961], i[k + 4 >> 2] = r, f = i[r - 12 >> 2], r = k + 4 | 0, i[f + r >> 2] = i[14962], i[k + 8 >> 2] = 0, f = r + i[i[k + 4 >> 2] - 12 >> 2] | 0, n = k + 16 | 0, T0(f, n), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[k + 12 >> 2] = f, t = k + 12 | 0, i[t + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[k + 4 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[k + 68 >> 2] = 59828, i[k + 4 >> 2] = 59788, i[k + 12 >> 2] = 59808, f = z0(n), i[f >> 2] = 58864, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 64 >> 2] = 24, U(M0(U(t, 21969, 11), e), 25204, 35), r = i[k + 64 >> 2];
                                                k: {
                                                    if (r & 16) {
                                                        n = i[k + 60 >> 2], r = i[k + 40 >> 2], n >>> 0 < r >>> 0 && (i[k + 60 >> 2] = r, n = r), r = k + 36 | 0;
                                                        break k;
                                                    }
                                                    if (!(r & 8)) {
                                                        n = 0, o[k + 159 | 0] = 0, r = k + 148 | 0;
                                                        break e;
                                                    }
                                                    n = i[k + 32 >> 2], r = k + 24 | 0;
                                                }
                                                if (e = i[r >> 2], n = n - e | 0, n >>> 0 >= 2147483640) break A;
                                                if (n >>> 0 >= 11) {
                                                    t = (n | 7) + 1 | 0, r = D(t), i[k + 156 >> 2] = t | -2147483648, i[k + 148 >> 2] = r, i[k + 152 >> 2] = n;
                                                    break r;
                                                }
                                                if (o[k + 159 | 0] = n, r = k + 148 | 0, n) break r;
                                                n = 0;
                                                break e;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(r, e, n);
                                }
                                o[r + n | 0] = 0, i0(A, 2, 2e3, k + 148 | 0), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), A = i[14959], i[k + 4 >> 2] = A, i[i[A - 12 >> 2] + (k + 4 | 0) >> 2] = i[14967], i[k + 12 >> 2] = i[14968], i[f >> 2] = 58864, o[k + 59 | 0] < 0 && X(i[k + 48 >> 2]), x0(f), N0(k + 68 | 0);
                            }
                            m = k + 160 | 0;
                        }
                        function D7(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0;
                            w = m + -64 | 0, m = w, u = D(32), i[w + 8 >> 2] = u, i[w + 12 >> 2] = 27, i[w + 16 >> 2] = -2147483616, s = l[9983] | l[9984] << 8 | (l[9985] << 16 | l[9986] << 24), o[u + 23 | 0] = s, o[u + 24 | 0] = s >>> 8, o[u + 25 | 0] = s >>> 16, o[u + 26 | 0] = s >>> 24, s = l[9980] | l[9981] << 8 | (l[9982] << 16 | l[9983] << 24), h = l[9976] | l[9977] << 8 | (l[9978] << 16 | l[9979] << 24), o[u + 16 | 0] = h, o[u + 17 | 0] = h >>> 8, o[u + 18 | 0] = h >>> 16, o[u + 19 | 0] = h >>> 24, o[u + 20 | 0] = s, o[u + 21 | 0] = s >>> 8, o[u + 22 | 0] = s >>> 16, o[u + 23 | 0] = s >>> 24, s = l[9972] | l[9973] << 8 | (l[9974] << 16 | l[9975] << 24), h = l[9968] | l[9969] << 8 | (l[9970] << 16 | l[9971] << 24), o[u + 8 | 0] = h, o[u + 9 | 0] = h >>> 8, o[u + 10 | 0] = h >>> 16, o[u + 11 | 0] = h >>> 24, o[u + 12 | 0] = s, o[u + 13 | 0] = s >>> 8, o[u + 14 | 0] = s >>> 16, o[u + 15 | 0] = s >>> 24, s = l[9964] | l[9965] << 8 | (l[9966] << 16 | l[9967] << 24), h = l[9960] | l[9961] << 8 | (l[9962] << 16 | l[9963] << 24), o[u | 0] = h, o[u + 1 | 0] = h >>> 8, o[u + 2 | 0] = h >>> 16, o[u + 3 | 0] = h >>> 24, o[u + 4 | 0] = s, o[u + 5 | 0] = s >>> 8, o[u + 6 | 0] = s >>> 16, o[u + 7 | 0] = s >>> 24, o[u + 27 | 0] = 0, T = i0(w + 44 | 0, 2, 0, w + 8 | 0), o[w + 19 | 0] < 0 && X(i[w + 8 >> 2]), i[w + 40 >> 2] = 0, i[w + 32 >> 2] = 0, i[w + 36 >> 2] = 0, u = i[e >> 2], s = l[r + 24 | 0], e = s + l[r + 25 | 0] | 0, s = e >>> 0 < s >>> 0, h = O0(e, s, k, 0), W = w0, V = e, e = n - k | 0, s = O0(V, s, e, t - (k >>> 0 > n >>> 0) | 0), w6(w + 8 | 0, u, f, w + 32 | 0, (W & 7) << 29 | h >>> 3, 0, (w0 & 7) << 29 | s >>> 3, 0);
                            i: {
                                e: {
                                    if (!i[w + 8 >> 2]) {
                                        if (!t & k >>> 0 >= n >>> 0) break e;
                                        if (f = l[r + 24 | 0], G = f >>> 3 | 0, W = i[r + 64 >> 2], r = l[r + 25 | 0], !r) {
                                            if (f >>> 0 >= 8) {
                                                for(v = G & 28, B = G & 3, r = 0, F = G - 1 >>> 0 < 3;;){
                                                    if (u = 0, f = 0, s = i[w + 32 >> 2], e = r, !F) for(V = s + 3 | 0, R = s + 2 | 0, M = s + 1 | 0, h = 0; y = f << 16 | u >>> 16, f = l[e + s | 0], y = (y | f >>> 24) << 16, f = l[e + M | 0] | (u << 16 | f << 8), C = y | f >>> 16, u = l[e + R | 0], H = u >>> 24 | 0, u = l[e + V | 0] | (f << 16 | u << 8), f = C | H, e = e + 4 | 0, h = h + 4 | 0, (v | 0) != (h | 0););
                                                    if (h = 0, B) for(; f = f << 8 | u >>> 24, u = l[e + s | 0] | u << 8, e = e + 1 | 0, h = h + 1 | 0, (B | 0) != (h | 0););
                                                    if (e = (k << 4) + W | 0, i[e >> 2] = u, i[e + 4 >> 2] = f, r = r + G | 0, k = k + 1 | 0, _ = k ? _ : _ + 1 | 0, !((k | 0) != (n | 0) | (t | 0) != (_ | 0))) break;
                                                }
                                                break e;
                                            }
                                            if (u = k, f = 0, r = 0, _ = e & 7, _) for(e = 0; s = (u << 4) + W | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, u = u + 1 | 0, f = u ? f : f + 1 | 0, r = r + 1 | 0, e = r ? e : e + 1 | 0, !!(e | (r | 0) != (_ | 0)););
                                            if ((0 - ((k >>> 0 < n >>> 0) + t | 0) | 0) == -1 & k - n >>> 0 > 4294967288) break e;
                                            for(e = W + 112 | 0, k = W + 96 | 0, _ = W + 80 | 0, s = W - -64 | 0, h = W + 48 | 0, G = W + 32 | 0, B = W + 16 | 0; r = u << 4, v = r + W | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + B | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + G | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + h | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + s | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + _ | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, v = r + k | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, r = r + e | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, u = u + 8 | 0, f = u >>> 0 < 8 ? f + 1 | 0 : f, !!((n | 0) != (u | 0) | (f | 0) != (t | 0)););
                                            break e;
                                        }
                                        if (B = r >>> 3 | 0, f >>> 0 <= 7) {
                                            if (r >>> 0 >= 8) {
                                                for(v = B & 28, s = B & 3, f = 0, F = B - 1 >>> 0 < 3;;){
                                                    if (V = (k << 4) + W | 0, r = V, i[r >> 2] = 0, i[r + 4 >> 2] = 0, G = i[w + 32 >> 2], e = f, r = 0, h = 0, !F) {
                                                        for(; u = e, e = u + 4 | 0, r = r + 4 | 0, (v | 0) != (r | 0););
                                                        r = u + G | 0, r = l[r | 0] | l[r + 1 | 0] << 8 | (l[r + 2 | 0] << 16 | l[r + 3 | 0] << 24), h = r << 24 | (r & 65280) << 8 | (r >>> 8 & 65280 | r >>> 24);
                                                    }
                                                    if (r = 0, s) for(; h = l[e + G | 0] | h << 8, e = e + 1 | 0, r = r + 1 | 0, (s | 0) != (r | 0););
                                                    if (i[V + 8 >> 2] = h, f = f + B | 0, k = k + 1 | 0, _ = k ? _ : _ + 1 | 0, !((k | 0) != (n | 0) | (t | 0) != (_ | 0))) break;
                                                }
                                                break e;
                                            }
                                            if (u = k, f = 0, r = 0, s = e & 3, s) for(e = 0; _ = (u << 4) + W | 0, i[_ + 8 >> 2] = 0, i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, u = u + 1 | 0, f = u ? f : f + 1 | 0, r = r + 1 | 0, e = r ? e : e + 1 | 0, !!(e | (r | 0) != (s | 0)););
                                            if ((0 - ((k >>> 0 < n >>> 0) + t | 0) | 0) == -1 & k - n >>> 0 > 4294967292) break e;
                                            for(; r = (u << 4) + W | 0, i[r + 8 >> 2] = 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, u = u + 4 | 0, f = u >>> 0 < 4 ? f + 1 | 0 : f, !!((n | 0) != (u | 0) | (f | 0) != (t | 0)););
                                            break e;
                                        }
                                        if (r >>> 0 <= 7) {
                                            for(v = G & 28, B = G & 3, F = G - 1 >>> 0 < 3, r = 0;;){
                                                if (u = 0, f = 0, s = i[w + 32 >> 2], e = r, !F) for(V = s + 3 | 0, R = s + 2 | 0, M = s + 1 | 0, h = 0; C = l[e + s | 0], H = C >>> 24 | 0, C = l[e + M | 0] | (C << 8 | u << 16), y = C << 16, f = (H | (f << 16 | u >>> 16)) << 16 | C >>> 16, u = l[e + R | 0], C = u >>> 24 | 0, u = l[e + V | 0] | (u << 8 | y), f = f | C, e = e + 4 | 0, h = h + 4 | 0, (v | 0) != (h | 0););
                                                if (h = 0, B) for(; f = f << 8 | u >>> 24, u = l[e + s | 0] | u << 8, e = e + 1 | 0, h = h + 1 | 0, (B | 0) != (h | 0););
                                                if (e = (k << 4) + W | 0, i[e + 8 >> 2] = 0, i[e >> 2] = u, i[e + 4 >> 2] = f, r = r + G | 0, k = k + 1 | 0, _ = k ? _ : _ + 1 | 0, !((k | 0) != (n | 0) | (t | 0) != (_ | 0))) break;
                                            }
                                            break e;
                                        }
                                        for(V = B & 28, v = B & 3, R = G & 28, F = G & 3, M = B + G | 0, s = 0, C = G - 1 >>> 0 < 3, H = B - 1 >>> 0 < 3;;){
                                            if (u = 0, f = 0, r = i[w + 32 >> 2], e = s, !C) for(B = r + 3 | 0, y = r + 2 | 0, S = r + 1 | 0, h = 0; E = l[r + e | 0], P = E >>> 24 | 0, E = l[e + S | 0] | (u << 16 | E << 8), $ = E << 16, f = (P | (f << 16 | u >>> 16)) << 16 | E >>> 16, u = l[e + y | 0], E = u >>> 24 | 0, u = l[e + B | 0] | (u << 8 | $), f = f | E, e = e + 4 | 0, h = h + 4 | 0, (R | 0) != (h | 0););
                                            if (h = 0, F) for(; f = f << 8 | u >>> 24, u = l[r + e | 0] | u << 8, e = e + 1 | 0, h = h + 1 | 0, (F | 0) != (h | 0););
                                            if (y = (k << 4) + W | 0, r = y, i[r >> 2] = u, i[r + 4 >> 2] = f, e = s + G | 0, r = 0, B = i[w + 32 >> 2], f = 0, h = 0, !H) {
                                                for(; u = e, e = u + 4 | 0, f = f + 4 | 0, (V | 0) != (f | 0););
                                                f = u + B | 0, f = l[f | 0] | l[f + 1 | 0] << 8 | (l[f + 2 | 0] << 16 | l[f + 3 | 0] << 24), h = f << 24 | (f & 65280) << 8 | (f >>> 8 & 65280 | f >>> 24);
                                            }
                                            if (v) for(; h = l[e + B | 0] | h << 8, e = e + 1 | 0, r = r + 1 | 0, (v | 0) != (r | 0););
                                            if (i[y + 8 >> 2] = h, s = s + M | 0, k = k + 1 | 0, _ = k ? _ : _ + 1 | 0, !((k | 0) != (n | 0) | (t | 0) != (_ | 0))) break;
                                        }
                                        break e;
                                    }
                                    r = i[w + 12 >> 2], i[A >> 2] = i[w + 8 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[w + 24 >> 2], r = i[w + 20 >> 2], i[A + 8 >> 2] = i[w + 16 >> 2], i[A + 12 >> 2] = r, i[w + 24 >> 2] = 0, i[w + 16 >> 2] = 0, i[w + 20 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[w + 27 | 0] < 0 && X(i[w + 16 >> 2]), A = i[w + 32 >> 2], A && (i[w + 36 >> 2] = A, X(A)), o[T + 19 | 0] < 0 && X(i[T + 8 >> 2]), m = w - -64 | 0;
                        }
                        function M7(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            h = m + -64 | 0, m = h, i[h + 60 >> 2] = r, T = h + 39 | 0, V = h + 40 | 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: for(;;){
                                                u = 0;
                                                k: for(;;){
                                                    if (w = r, (G ^ 2147483647) < (u | 0)) break A;
                                                    G = u + G | 0;
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    if (u = r, s = l[u | 0], s) for(;;){
                                                                        u: {
                                                                            r = s & 255;
                                                                            w: {
                                                                                if (!r) {
                                                                                    r = u;
                                                                                    break w;
                                                                                }
                                                                                if ((r | 0) != 37) break u;
                                                                                for(s = u;;){
                                                                                    if (l[s + 1 | 0] != 37) {
                                                                                        r = s;
                                                                                        break w;
                                                                                    }
                                                                                    if (u = u + 1 | 0, _ = l[s + 2 | 0], r = s + 2 | 0, s = r, (_ | 0) != 37) break;
                                                                                }
                                                                            }
                                                                            if (u = u - w | 0, H = G ^ 2147483647, (u | 0) > (H | 0)) break A;
                                                                            if (A && j1(A, w, u), u) continue k;
                                                                            i[h + 60 >> 2] = r, u = r + 1 | 0, C = -1, _ = o[r + 1 | 0] - 48 | 0, l[r + 2 | 0] != 36 | _ >>> 0 > 9 || (R = 1, C = _, u = r + 3 | 0), i[h + 60 >> 2] = u, B = 0, s = o[u | 0], r = s - 32 | 0;
                                                                            w: {
                                                                                if (r >>> 0 > 31) {
                                                                                    _ = u;
                                                                                    break w;
                                                                                }
                                                                                if (_ = u, r = 1 << r, !(r & 75913)) break w;
                                                                                for(;;){
                                                                                    if (_ = u + 1 | 0, i[h + 60 >> 2] = _, B = r | B, s = o[u + 1 | 0], r = s - 32 | 0, r >>> 0 >= 32) break w;
                                                                                    if (u = _, r = 1 << r, !(r & 75913)) break;
                                                                                }
                                                                            }
                                                                            w: {
                                                                                if ((s | 0) == 42) {
                                                                                    r = o[_ + 1 | 0] - 48 | 0;
                                                                                    l: {
                                                                                        if (!(l[_ + 2 | 0] != 36 | r >>> 0 > 9)) {
                                                                                            h: {
                                                                                                if (!A) {
                                                                                                    i[(r << 2) + k >> 2] = 10, r = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                r = i[(r << 3) + f >> 2];
                                                                                            }
                                                                                            W = r, r = _ + 3 | 0, s = 1;
                                                                                            break l;
                                                                                        }
                                                                                        if (R) break s;
                                                                                        if (r = _ + 1 | 0, !A) {
                                                                                            i[h + 60 >> 2] = r, R = 0, W = 0;
                                                                                            break w;
                                                                                        }
                                                                                        u = i[e >> 2], i[e >> 2] = u + 4, W = i[u >> 2], s = 0;
                                                                                    }
                                                                                    if (R = s, i[h + 60 >> 2] = r, (W | 0) >= 0) break w;
                                                                                    W = 0 - W | 0, B = B | 8192;
                                                                                    break w;
                                                                                }
                                                                                if (W = z9(h + 60 | 0), (W | 0) < 0) break A;
                                                                                r = i[h + 60 >> 2];
                                                                            }
                                                                            u = 0, v = -1, y = 0;
                                                                            w: {
                                                                                if (l[r | 0] != 46) break w;
                                                                                if (l[r + 1 | 0] == 42) {
                                                                                    _ = o[r + 2 | 0] - 48 | 0;
                                                                                    l: {
                                                                                        if (!(l[r + 3 | 0] != 36 | _ >>> 0 > 9)) {
                                                                                            r = r + 4 | 0;
                                                                                            h: {
                                                                                                if (!A) {
                                                                                                    i[(_ << 2) + k >> 2] = 10, v = 0;
                                                                                                    break h;
                                                                                                }
                                                                                                v = i[(_ << 3) + f >> 2];
                                                                                            }
                                                                                            break l;
                                                                                        }
                                                                                        if (R) break s;
                                                                                        if (r = r + 2 | 0, v = 0, !A) break l;
                                                                                        _ = i[e >> 2], i[e >> 2] = _ + 4, v = i[_ >> 2];
                                                                                    }
                                                                                    i[h + 60 >> 2] = r, y = (v | 0) >= 0;
                                                                                    break w;
                                                                                }
                                                                                i[h + 60 >> 2] = r + 1, v = z9(h + 60 | 0), r = i[h + 60 >> 2], y = 1;
                                                                            }
                                                                            for(;;){
                                                                                if (F = u, _ = 28, M = r, s = o[r | 0], s - 123 >>> 0 < 4294967238) break r;
                                                                                if (r = r + 1 | 0, u = l[(s + Z(u, 58) | 0) + 57375 | 0], !(u - 1 >>> 0 < 8)) break;
                                                                            }
                                                                            i[h + 60 >> 2] = r;
                                                                            w: {
                                                                                if ((u | 0) != 27) {
                                                                                    if (!u) break r;
                                                                                    if ((C | 0) >= 0) {
                                                                                        if (!A) {
                                                                                            i[(C << 2) + k >> 2] = u;
                                                                                            continue f;
                                                                                        }
                                                                                        u = (C << 3) + f | 0, _ = i[u + 4 >> 2], i[h + 48 >> 2] = i[u >> 2], i[h + 52 >> 2] = _;
                                                                                        break w;
                                                                                    }
                                                                                    if (!A) break n;
                                                                                    on(h + 48 | 0, u, e, t);
                                                                                    break w;
                                                                                }
                                                                                if ((C | 0) >= 0) break r;
                                                                                if (u = 0, !A) continue k;
                                                                            }
                                                                            if (l[A | 0] & 32) break e;
                                                                            s = B & -65537, B = B & 8192 ? s : B, C = 0, E = 2714, _ = V;
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        v: {
                                                                                            _: {
                                                                                                B: {
                                                                                                    m: {
                                                                                                        Z: {
                                                                                                            W: {
                                                                                                                X: {
                                                                                                                    p: {
                                                                                                                        Q: {
                                                                                                                            C: {
                                                                                                                                I: {
                                                                                                                                    V: {
                                                                                                                                        F: {
                                                                                                                                            y: switch(u = o[M | 0], u = F && (u & 15) == 3 ? u & -45 : u, u - 88 | 0){
                                                                                                                                                case 9:
                                                                                                                                                case 13:
                                                                                                                                                case 14:
                                                                                                                                                case 15:
                                                                                                                                                    break w;
                                                                                                                                                case 27:
                                                                                                                                                    break m;
                                                                                                                                                case 11:
                                                                                                                                                    break Z;
                                                                                                                                                case 12:
                                                                                                                                                case 17:
                                                                                                                                                    break p;
                                                                                                                                                case 23:
                                                                                                                                                    break Q;
                                                                                                                                                case 0:
                                                                                                                                                case 32:
                                                                                                                                                    break C;
                                                                                                                                                case 24:
                                                                                                                                                    break I;
                                                                                                                                                case 22:
                                                                                                                                                    break V;
                                                                                                                                                case 29:
                                                                                                                                                    break F;
                                                                                                                                                case 1:
                                                                                                                                                case 2:
                                                                                                                                                case 3:
                                                                                                                                                case 4:
                                                                                                                                                case 5:
                                                                                                                                                case 6:
                                                                                                                                                case 7:
                                                                                                                                                case 8:
                                                                                                                                                case 10:
                                                                                                                                                case 16:
                                                                                                                                                case 18:
                                                                                                                                                case 19:
                                                                                                                                                case 20:
                                                                                                                                                case 21:
                                                                                                                                                case 25:
                                                                                                                                                case 26:
                                                                                                                                                case 28:
                                                                                                                                                case 30:
                                                                                                                                                case 31:
                                                                                                                                                    break t;
                                                                                                                                                default:
                                                                                                                                                    break y;
                                                                                                                                            }
                                                                                                                                            y: switch(u - 65 | 0){
                                                                                                                                                case 0:
                                                                                                                                                case 4:
                                                                                                                                                case 5:
                                                                                                                                                case 6:
                                                                                                                                                    break w;
                                                                                                                                                case 2:
                                                                                                                                                    break B;
                                                                                                                                                case 1:
                                                                                                                                                case 3:
                                                                                                                                                    break t;
                                                                                                                                                default:
                                                                                                                                                    break y;
                                                                                                                                            }
                                                                                                                                            if ((u | 0) == 83) break _;
                                                                                                                                            break t;
                                                                                                                                        }
                                                                                                                                        w = i[h + 48 >> 2], s = i[h + 52 >> 2], E = 2714;
                                                                                                                                        break X;
                                                                                                                                    }
                                                                                                                                    u = 0;
                                                                                                                                    V: switch(F & 255){
                                                                                                                                        case 0:
                                                                                                                                            i[i[h + 48 >> 2] >> 2] = G;
                                                                                                                                            continue k;
                                                                                                                                        case 1:
                                                                                                                                            i[i[h + 48 >> 2] >> 2] = G;
                                                                                                                                            continue k;
                                                                                                                                        case 2:
                                                                                                                                            w = i[h + 48 >> 2], i[w >> 2] = G, i[w + 4 >> 2] = G >> 31;
                                                                                                                                            continue k;
                                                                                                                                        case 3:
                                                                                                                                            Q[i[h + 48 >> 2] >> 1] = G;
                                                                                                                                            continue k;
                                                                                                                                        case 4:
                                                                                                                                            o[i[h + 48 >> 2]] = G;
                                                                                                                                            continue k;
                                                                                                                                        case 6:
                                                                                                                                            i[i[h + 48 >> 2] >> 2] = G;
                                                                                                                                            continue k;
                                                                                                                                        case 7:
                                                                                                                                            break V;
                                                                                                                                        default:
                                                                                                                                            continue k;
                                                                                                                                    }
                                                                                                                                    w = i[h + 48 >> 2], i[w >> 2] = G, i[w + 4 >> 2] = G >> 31;
                                                                                                                                    continue k;
                                                                                                                                }
                                                                                                                                v = v >>> 0 <= 8 ? 8 : v, B = B | 8, u = 120;
                                                                                                                            }
                                                                                                                            if (r = V, M = u & 32, w = i[h + 48 >> 2], s = i[h + 52 >> 2], w | s) for(; r = r - 1 | 0, o[r | 0] = M | l[(w & 15) + 57904 | 0], F = !s & w >>> 0 > 15 | (s | 0) != 0, w = (s & 15) << 28 | w >>> 4, s = s >>> 4 | 0, !!F;);
                                                                                                                            if (w = r, !(i[h + 48 >> 2] | i[h + 52 >> 2]) | !(B & 8)) break W;
                                                                                                                            E = (u >>> 4 | 0) + 2714 | 0, C = 2;
                                                                                                                            break W;
                                                                                                                        }
                                                                                                                        if (r = V, u = i[h + 52 >> 2], s = u, w = i[h + 48 >> 2], u | w) for(; r = r - 1 | 0, o[r | 0] = w & 7 | 48, F = !s & w >>> 0 > 7 | (s | 0) != 0, w = (s & 7) << 29 | w >>> 3, s = s >>> 3 | 0, !!F;);
                                                                                                                        if (w = r, !(B & 8)) break W;
                                                                                                                        r = V - r | 0, v = (r | 0) < (v | 0) ? v : r + 1 | 0;
                                                                                                                        break W;
                                                                                                                    }
                                                                                                                    if (w = i[h + 48 >> 2], r = i[h + 52 >> 2], s = r, (r | 0) < 0) {
                                                                                                                        s = 0 - (r + ((w | 0) != 0) | 0) | 0, w = 0 - w | 0, i[h + 48 >> 2] = w, i[h + 52 >> 2] = s, C = 1, E = 2714;
                                                                                                                        break X;
                                                                                                                    }
                                                                                                                    if (B & 2048) {
                                                                                                                        C = 1, E = 2715;
                                                                                                                        break X;
                                                                                                                    }
                                                                                                                    C = B & 1, E = C ? 2716 : 2714;
                                                                                                                }
                                                                                                                w = y6(w, s, V);
                                                                                                            }
                                                                                                            if ((v | 0) < 0 & y) break A;
                                                                                                            if (B = y ? B & -65537 : B, r = i[h + 48 >> 2], u = i[h + 52 >> 2], !(v | (r | u) != 0)) {
                                                                                                                w = V, v = 0;
                                                                                                                break t;
                                                                                                            }
                                                                                                            r = !(r | u) + (V - w | 0) | 0, v = (r | 0) < (v | 0) ? v : r;
                                                                                                            break t;
                                                                                                        }
                                                                                                        w = i[h + 48 >> 2];
                                                                                                        break o;
                                                                                                    }
                                                                                                    if (r = i[h + 48 >> 2], w = r || 20281, r = v >>> 0 >= 2147483647 ? 2147483647 : v, u = d3(w, 0, r), r = u ? u - w | 0 : r, _ = r + w | 0, (v | 0) >= 0) {
                                                                                                        B = s, v = r;
                                                                                                        break t;
                                                                                                    }
                                                                                                    if (B = s, v = r, l[_ | 0]) break A;
                                                                                                    break t;
                                                                                                }
                                                                                                if (u = i[h + 48 >> 2], u | i[h + 52 >> 2]) break v;
                                                                                                w = 0;
                                                                                                break o;
                                                                                            }
                                                                                            if (v) {
                                                                                                s = i[h + 48 >> 2];
                                                                                                break h;
                                                                                            }
                                                                                            u = 0, b1(A, 32, W, 0, B);
                                                                                            break l;
                                                                                        }
                                                                                        i[h + 12 >> 2] = 0, i[h + 8 >> 2] = u, s = h + 8 | 0, i[h + 48 >> 2] = s, v = -1;
                                                                                    }
                                                                                    for(u = 0;;){
                                                                                        h: {
                                                                                            if (w = i[s >> 2], !w) break h;
                                                                                            if (w = Wr(h + 4 | 0, w), (w | 0) < 0) break e;
                                                                                            if (w >>> 0 > v - u >>> 0) break h;
                                                                                            if (s = s + 4 | 0, u = u + w | 0, v >>> 0 > u >>> 0) continue;
                                                                                        }
                                                                                        break;
                                                                                    }
                                                                                    if (_ = 61, (u | 0) < 0) break r;
                                                                                    if (b1(A, 32, W, u, B), !u) {
                                                                                        u = 0;
                                                                                        break l;
                                                                                    }
                                                                                    for(_ = 0, s = i[h + 48 >> 2];;){
                                                                                        if (w = i[s >> 2], !w || (v = h + 4 | 0, w = Wr(v, w), _ = w + _ | 0, _ >>> 0 > u >>> 0)) break l;
                                                                                        if (j1(A, v, w), s = s + 4 | 0, !(u >>> 0 > _ >>> 0)) break;
                                                                                    }
                                                                                }
                                                                                b1(A, 32, W, u, B ^ 8192), u = (u | 0) < (W | 0) ? W : u;
                                                                                continue k;
                                                                            }
                                                                            if ((v | 0) < 0 & y) break A;
                                                                            if (_ = 61, u = p[n | 0](A, n0[h + 48 >> 3], W, v, B, u) | 0, (u | 0) >= 0) continue k;
                                                                            break r;
                                                                        }
                                                                        s = l[u + 1 | 0], u = u + 1 | 0;
                                                                    }
                                                                    if (A) break i;
                                                                    if (!R) break n;
                                                                    for(u = 1;;){
                                                                        if (A = i[(u << 2) + k >> 2], A) {
                                                                            if (on((u << 3) + f | 0, A, e, t), G = 1, u = u + 1 | 0, (u | 0) != 10) continue;
                                                                            break i;
                                                                        }
                                                                        break;
                                                                    }
                                                                    if (G = 1, u >>> 0 >= 10) break i;
                                                                    for(;;){
                                                                        if (i[(u << 2) + k >> 2]) break s;
                                                                        if (u = u + 1 | 0, (u | 0) == 10) break;
                                                                    }
                                                                    break i;
                                                                }
                                                                _ = 28;
                                                                break r;
                                                            }
                                                            o[h + 39 | 0] = w, v = 1, w = T, B = s;
                                                        }
                                                        if (s = _ - w | 0, v = (s | 0) < (v | 0) ? v : s, (v | 0) > (C ^ 2147483647)) break A;
                                                        if (_ = 61, r = v + C | 0, u = (r | 0) < (W | 0) ? W : r, (H | 0) < (u | 0)) break r;
                                                        b1(A, 32, u, r, B), j1(A, E, C), b1(A, 48, u, r, B ^ 65536), b1(A, 48, v, s, 0), j1(A, w, s), b1(A, 32, u, r, B ^ 8192), r = i[h + 60 >> 2];
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                break;
                                            }
                                            G = 0;
                                            break i;
                                        }
                                        _ = 61;
                                    }
                                    i[26064] = _;
                                }
                                G = -1;
                            }
                            return m = h - -64 | 0, G;
                        }
                        function Kh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            if (f = m - 176 | 0, m = f, i[f + 64 >> 2] = 60132, k = i[15036], i[f + 8 >> 2] = k, h = i[k - 12 >> 2], k = f + 8 | 0, i[h + k >> 2] = i[15037], w = k + i[i[f + 8 >> 2] - 12 >> 2] | 0, n = f + 12 | 0, T0(w, n), i[w + 72 >> 2] = 0, i[w + 76 >> 2] = -1, i[f + 64 >> 2] = 60132, i[f + 8 >> 2] = 60112, G = z0(n), i[G >> 2] = 58864, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 60 >> 2] = 16, w = f + 164 | 0, D2(w, r, e), W = k, h = w, k = o[f + 175 | 0], w = (k | 0) < 0, U(W, w ? i[f + 164 >> 2] : h, w ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), B = i[r + 104 >> 2], C = i[r + 108 >> 2], (B | 0) != (C | 0)) for(;;){
                                if (r = f + 164 | 0, G0(r, e), h = r, r = o[f + 175 | 0], k = (r | 0) < 0, U(f + 8 | 0, k ? i[f + 164 >> 2] : h, k ? i[f + 168 >> 2] : r), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(M0(U(f + 8 | 0, 24997, 26), i[B >> 2]), 34895, 1), r = i[e >> 2] + 1 | 0, i[e >> 2] = r, w = i[B + 4 >> 2], V = i[B + 8 >> 2], (w | 0) != (V | 0)) {
                                    i: {
                                        e: {
                                            for(;;){
                                                r: {
                                                    G0(f + 144 | 0, e), k = o[f + 155 | 0], h = i[f + 144 >> 2], v = i[f + 148 >> 2], r = f + 8 | 0, _ = C1(f + 156 | 0, r);
                                                    A: {
                                                        if (l[_ | 0] != 1) break A;
                                                        t = r + i[i[f + 8 >> 2] - 12 >> 2] | 0, W = i[t + 4 >> 2], n = i[t + 24 >> 2], u = i[t + 76 >> 2], (u | 0) == -1 && (s = f + 164 | 0, r = i[t + 28 >> 2], i[s >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(s, 108580), u = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(s), i[t + 76 >> 2] = u);
                                                        f: {
                                                            if (!n || (s = i[t + 12 >> 2], r = h, h = (k | 0) < 0, r = h ? r : f + 144 | 0, k = h ? v : k, y = r + k | 0, h = (W & 176) == 32 ? y : r, v = h - r | 0, (v | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, r, v) | 0) != (v | 0))) break f;
                                                            if (k = (k | 0) < (s | 0) ? s - k | 0 : 0, (k | 0) > 0) {
                                                                if (k >>> 0 >= 2147483640) break r;
                                                                k: {
                                                                    if (k >>> 0 >= 11) {
                                                                        s = (k | 7) + 1 | 0, r = D(s), i[f + 172 >> 2] = s | -2147483648, i[f + 164 >> 2] = r, i[f + 168 >> 2] = k;
                                                                        break k;
                                                                    }
                                                                    o[f + 175 | 0] = k, r = f + 164 | 0;
                                                                }
                                                                if (F = B0(r, u, k) + k | 0, E = 0, o[F | 0] = E, r = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, k) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break f;
                                                            }
                                                            if (r = y - h | 0, (r | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, h, r) | 0) != (r | 0)) break f;
                                                            i[t + 12 >> 2] = 0;
                                                            break A;
                                                        }
                                                        r = i[i[f + 8 >> 2] - 12 >> 2] + (f + 8 | 0) | 0, N1(r, i[r + 16 >> 2] | 5);
                                                    }
                                                    G1(_), o[f + 155 | 0] < 0 && X(i[f + 144 >> 2]), r = f + 8 | 0, h = C1(f + 144 | 0, r);
                                                    A: {
                                                        if (l[h | 0] != 1) break A;
                                                        t = r + i[i[f + 8 >> 2] - 12 >> 2] | 0, u = i[t + 4 >> 2], n = i[t + 24 >> 2], r = i[t + 76 >> 2], (r | 0) == -1 && (k = f + 164 | 0, r = i[t + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108580), r = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(k), i[t + 76 >> 2] = r);
                                                        f: {
                                                            if (!n || (k = i[t + 12 >> 2], s = (u & 176) == 32 ? 22844 : 22828, u = s - 22828 | 0, (u | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, 22828, u) | 0) != (u | 0))) break f;
                                                            if (k = (k | 0) > 16 ? k - 16 | 0 : 0, (k | 0) > 0) {
                                                                k: {
                                                                    if (k >>> 0 >= 11) {
                                                                        v = (k | 7) + 1 | 0, u = D(v), i[f + 172 >> 2] = v | -2147483648, i[f + 164 >> 2] = u, i[f + 168 >> 2] = k;
                                                                        break k;
                                                                    }
                                                                    o[f + 175 | 0] = k, u = f + 164 | 0;
                                                                }
                                                                if (F = B0(u, r, k) + k | 0, E = 0, o[F | 0] = E, r = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, k) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break f;
                                                            }
                                                            if (r = 22844 - s | 0, (r | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, s, r) | 0) != (r | 0)) break f;
                                                            i[t + 12 >> 2] = 0;
                                                            break A;
                                                        }
                                                        r = i[i[f + 8 >> 2] - 12 >> 2] + (f + 8 | 0) | 0, N1(r, i[r + 16 >> 2] | 5);
                                                    }
                                                    G1(h), n = M0(f + 8 | 0, I[w + 2 >> 1]), v = C1(f + 144 | 0, n);
                                                    A: {
                                                        if (l[v | 0] != 1) break A;
                                                        s = n + i[i[n >> 2] - 12 >> 2] | 0, t = i[s + 4 >> 2], u = i[s + 24 >> 2], r = i[s + 76 >> 2], (r | 0) == -1 && (k = f + 164 | 0, r = i[s + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108580), r = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(k), i[s + 76 >> 2] = r);
                                                        f: {
                                                            if (!u || (k = i[s + 12 >> 2], h = (t & 176) == 32 ? 23869 : 23856, t = h - 23856 | 0, (t | 0) > 0 && (p[i[i[u >> 2] + 48 >> 2]](u, 23856, t) | 0) != (t | 0))) break f;
                                                            if (k = (k | 0) > 13 ? k - 13 | 0 : 0, (k | 0) > 0) {
                                                                k: {
                                                                    if (k >>> 0 >= 11) {
                                                                        _ = (k | 7) + 1 | 0, t = D(_), i[f + 172 >> 2] = _ | -2147483648, i[f + 164 >> 2] = t, i[f + 168 >> 2] = k;
                                                                        break k;
                                                                    }
                                                                    o[f + 175 | 0] = k, t = f + 164 | 0;
                                                                }
                                                                if (F = B0(t, r, k) + k | 0, E = 0, o[F | 0] = E, r = p[i[i[u >> 2] + 48 >> 2]](u, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, k) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break f;
                                                            }
                                                            if (r = 23869 - h | 0, (r | 0) > 0 && (p[i[i[u >> 2] + 48 >> 2]](u, h, r) | 0) != (r | 0)) break f;
                                                            i[s + 12 >> 2] = 0;
                                                            break A;
                                                        }
                                                        r = n + i[i[n >> 2] - 12 >> 2] | 0, N1(r, i[r + 16 >> 2] | 5);
                                                    }
                                                    G1(v), r = n + i[i[n >> 2] - 12 >> 2] | 0, i[r + 4 >> 2] = i[r + 4 >> 2] | 1, s = qe(n, l[w | 0]), v = C1(f + 144 | 0, s);
                                                    A: {
                                                        if (l[v | 0] != 1) break A;
                                                        u = s + i[i[s >> 2] - 12 >> 2] | 0, t = i[u + 4 >> 2], n = i[u + 24 >> 2], r = i[u + 76 >> 2], (r | 0) == -1 && (k = f + 164 | 0, r = i[u + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108580), r = p[i[i[r >> 2] + 28 >> 2]](r, 32) | 0, d0(k), i[u + 76 >> 2] = r);
                                                        f: {
                                                            if (!n || (k = i[u + 12 >> 2], h = (t & 176) == 32 ? 34896 : 34894, t = h - 34894 | 0, (t | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, 34894, t) | 0) != (t | 0))) break f;
                                                            if (k = (k | 0) > 2 ? k - 2 | 0 : 0, (k | 0) > 0) {
                                                                if (k >>> 0 >= 2147483640) break e;
                                                                k: {
                                                                    if (k >>> 0 >= 11) {
                                                                        _ = (k | 7) + 1 | 0, t = D(_), i[f + 172 >> 2] = _ | -2147483648, i[f + 164 >> 2] = t, i[f + 168 >> 2] = k;
                                                                        break k;
                                                                    }
                                                                    o[f + 175 | 0] = k, t = f + 164 | 0;
                                                                }
                                                                if (F = B0(t, r, k) + k | 0, E = 0, o[F | 0] = E, r = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 175 | 0] < 0 ? i[f + 164 >> 2] : f + 164 | 0, k) | 0, o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), (r | 0) != (k | 0)) break f;
                                                            }
                                                            if (r = 34896 - h | 0, (r | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, h, r) | 0) != (r | 0)) break f;
                                                            i[u + 12 >> 2] = 0;
                                                            break A;
                                                        }
                                                        r = s + i[i[s >> 2] - 12 >> 2] | 0, N1(r, i[r + 16 >> 2] | 5);
                                                    }
                                                    if (G1(v), w = w + 4 | 0, (V | 0) != (w | 0)) continue;
                                                    break i;
                                                }
                                                break;
                                            }
                                            Y0(), z();
                                        }
                                        Y0(), z();
                                    }
                                    r = i[e >> 2];
                                }
                                if (i[e >> 2] = (r | 0) > 0 ? r - 1 | 0 : 0, B = B + 16 | 0, (C | 0) == (B | 0)) break;
                            }
                            r = i[f + 60 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        w = f + 32 | 0, e = i[f + 56 >> 2], r = i[f + 36 >> 2], e >>> 0 < r >>> 0 ? i[f + 56 >> 2] = r : r = e;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    w = f + 20 | 0, r = i[f + 28 >> 2];
                                }
                                e: {
                                    if (k = i[w >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            w = (r | 7) + 1 | 0, e = D(w), i[A + 8 >> 2] = w | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 8 >> 2] = A, i[i[A - 12 >> 2] + (f + 8 | 0) >> 2] = i[15038], i[G >> 2] = 58864, o[f + 55 | 0] < 0 && X(i[f + 44 >> 2]), x0(G), N0(f - -64 | 0), m = f + 176 | 0;
                        }
                        function U7(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            h = m - 80 | 0, m = h;
                            i: {
                                e: {
                                    B = i[r + 20 >> 2];
                                    r: {
                                        if (!B) break r;
                                        for(w = r + 20 | 0, _ = w, v = B; G = k0[v + 16 >> 2] < e >>> 0, _ = G ? _ : v, v = i[(G << 2) + v >> 2], !!v;);
                                        if (v = 0, (w | 0) == (_ | 0) | k0[_ + 16 >> 2] > e >>> 0) break r;
                                        for(v = w; _ = k0[B + 16 >> 2] < e >>> 0, v = _ ? v : B, B = i[(_ << 2) + B >> 2], !!B;);
                                        if (v = (w | 0) != (v | 0) & k0[v + 16 >> 2] <= e >>> 0 ? v : w, _ = i[v + 20 >> 2], v = i[v + 24 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), _) break e;
                                    }
                                    o[h + 12 | 0] = 0, o[h + 23 | 0] = 0, r = i0(h + 48 | 0, 2, 2e3, h + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                    r: {
                                        if (o[r + 19 | 0] >= 0) {
                                            e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                            break r;
                                        }
                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                        X(i[r + 8 >> 2]);
                                    }
                                    if (o[h + 23 | 0] >= 0) break i;
                                    X(i[h + 12 >> 2]);
                                    break i;
                                }
                                ii(h + 48 | 0, _, n, t, u, s);
                                e: {
                                    if (i[h + 56 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[h + 60 >> 2], i[A + 8 >> 2] = i[h + 56 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[h + 75 | 0] >= 0) {
                                            r = h - -64 | 0, e = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 8 >> 2];
                                            break e;
                                        }
                                        j(A, i[h + 64 >> 2], i[h + 68 >> 2]);
                                        break e;
                                    }
                                    e = i[h + 48 >> 2], i[h + 40 >> 2] = e, t = i[h + 52 >> 2], i[h + 44 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), f = (f | 0) == 99 ? i[e + 32 >> 2] : f, t = i[e + 32 >> 2], W = t, G = i[e + 36 >> 2], w = 0;
                                    r: {
                                        A: switch(t | 0){
                                            case 2:
                                                if (w = 255, t = i[e + 64 >> 2], !t) break r;
                                                for(u = e - -64 | 0, e = u; s = i[t + 16 >> 2], e = (s | 0) < 0 ? e : t, t = i[(s >>> 29 & 4) + t >> 2], !!t;);
                                                if ((e | 0) == (u | 0) | i[e + 16 >> 2] > 0) break r;
                                                w = l[e + 24 | 0];
                                                break r;
                                            case 0:
                                                w = 255, B = 255, t = i[e + 64 >> 2], s = 255;
                                                f: {
                                                    if (!t) break f;
                                                    for(u = e - -64 | 0, s = u, e = t; w = i[e + 16 >> 2], s = (w | 0) < 0 ? s : e, e = i[(w >>> 29 & 4) + e >> 2], !!e;);
                                                    for(B = (u | 0) == (s | 0) | i[s + 16 >> 2] > 0 ? B : l[s + 24 | 0], s = u, e = t; w = i[e + 16 >> 2] <= 0, s = w ? s : e, e = i[(w << 2) + e >> 2], !!e;);
                                                    for(w = 255, w = (u | 0) == (s | 0) | i[s + 16 >> 2] > 1 ? w : l[s + 24 | 0], e = u; s = i[t + 16 >> 2] < 2, e = s ? e : t, t = i[(s << 2) + t >> 2], !!t;);
                                                    if (s = 255, (e | 0) == (u | 0) | i[e + 16 >> 2] > 2) break f;
                                                    s = l[e + 24 | 0];
                                                }
                                                e = w & 255, t = s & 255, e = e >>> 0 > t >>> 0 ? e : t, w = e >>> 0 < B >>> 0 ? B : e;
                                                break r;
                                            case 1:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        w = 255, B = 255, t = i[e + 64 >> 2], s = 255;
                                        A: {
                                            if (!t) break A;
                                            for(u = e - -64 | 0, s = u, e = t; w = i[e + 16 >> 2] < 3, s = w ? s : e, e = i[(w << 2) + e >> 2], !!e;);
                                            for(B = (u | 0) == (s | 0) | i[s + 16 >> 2] > 3 ? B : l[s + 24 | 0], s = u, e = t; w = i[e + 16 >> 2] < 4, s = w ? s : e, e = i[(w << 2) + e >> 2], !!e;);
                                            for(w = 255, w = (u | 0) == (s | 0) | i[s + 16 >> 2] > 4 ? w : l[s + 24 | 0], e = u; s = i[t + 16 >> 2] < 5, e = s ? e : t, t = i[(s << 2) + t >> 2], !!t;);
                                            if (s = 255, (e | 0) == (u | 0) | i[e + 16 >> 2] > 5) break A;
                                            s = l[e + 24 | 0];
                                        }
                                        e = w & 255, t = s & 255, e = e >>> 0 > t >>> 0 ? e : t, w = e >>> 0 < B >>> 0 ? B : e;
                                    }
                                    e = l[n + 20 | 0] != 0 & (w & 255) >>> 0 > 8, k = (k | 0) == 99 ? G : k;
                                    r: {
                                        if ((k | 0) != (G | 0) | (f | 0) != (W | 0) | e) {
                                            i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, s6(h + 12 | 0, h + 40 | 0, f, k, h + 4 | 0, e ? 8 : 0, n + 28 | 0, r - -64 | 0), r = i[h + 8 >> 2];
                                            A: {
                                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            f = i[h + 20 >> 2];
                                            A: {
                                                if (f) {
                                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[h + 24 >> 2], i[A + 8 >> 2] = i[h + 20 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[h + 39 | 0] >= 0) {
                                                        e = i[h + 32 >> 2], i[r >> 2] = i[h + 28 >> 2], i[r + 4 >> 2] = e, i[r + 8 >> 2] = i[h + 36 >> 2];
                                                        break A;
                                                    }
                                                    j(r, i[h + 28 >> 2], i[h + 32 >> 2]);
                                                    break A;
                                                }
                                                if (r = i[h + 12 >> 2], e = i[h + 16 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[h + 40 >> 2] = r, r = i[h + 44 >> 2], i[h + 44 >> 2] = e, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            o[h + 39 | 0] < 0 && X(i[h + 28 >> 2]), r = i[h + 16 >> 2];
                                            A: {
                                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            if (f) break r;
                                        }
                                        if (k = i[h + 40 >> 2], r = i[_ + 360 >> 2], B = i[_ + 364 >> 2], (r | 0) != (B | 0)) {
                                            for(_ = i[k + 116 >> 2];;){
                                                A: {
                                                    if (k0[k + 120 >> 2] > _ >>> 0) {
                                                        if (e = i[r + 4 >> 2], i[_ >> 2] = i[r >> 2], i[_ + 4 >> 2] = e, e = _ + 8 | 0, o[r + 19 | 0] >= 0) {
                                                            f = i[r + 12 >> 2], i[e >> 2] = i[r + 8 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[r + 16 >> 2], e = _ + 20 | 0;
                                                            break A;
                                                        }
                                                        j(e, i[r + 8 >> 2], i[r + 12 >> 2]), e = _ + 20 | 0;
                                                        break A;
                                                    }
                                                    f = 0;
                                                    f: {
                                                        k: {
                                                            if (t = i[k + 116 >> 2], u = i[k + 112 >> 2], s = (t - u | 0) / 20 | 0, e = s + 1 | 0, e >>> 0 < 214748365) {
                                                                if (n = (i[k + 120 >> 2] - u | 0) / 20 | 0, w = n << 1, n = n >>> 0 >= 107374182 ? 214748364 : e >>> 0 < w >>> 0 ? w : e, n) {
                                                                    if (n >>> 0 >= 214748365) break k;
                                                                    f = D(Z(n, 20));
                                                                }
                                                                e = Z(s, 20) + f | 0, s = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = s, s = Z(n, 20), n = e + 8 | 0;
                                                                n: {
                                                                    if (o[r + 19 | 0] >= 0) {
                                                                        w = i[r + 12 >> 2], i[n >> 2] = i[r + 8 >> 2], i[n + 4 >> 2] = w, i[n + 8 >> 2] = i[r + 16 >> 2];
                                                                        break n;
                                                                    }
                                                                    j(n, i[r + 8 >> 2], i[r + 12 >> 2]), u = i[k + 112 >> 2], t = i[k + 116 >> 2];
                                                                }
                                                                _ = f + s | 0, n = e + 20 | 0;
                                                                n: {
                                                                    if ((t | 0) == (u | 0)) {
                                                                        f = e;
                                                                        break n;
                                                                    }
                                                                    for(; s = t - 20 | 0, w = i[s + 4 >> 2], f = e - 20 | 0, i[f >> 2] = i[s >> 2], i[f + 4 >> 2] = w, w = e - 12 | 0, e = t - 12 | 0, i[w + 8 >> 2] = i[e + 8 >> 2], t = i[e + 4 >> 2], i[w >> 2] = i[e >> 2], i[w + 4 >> 2] = t, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, e = f, t = s, (u | 0) != (t | 0););
                                                                    t = i[k + 116 >> 2], u = i[k + 112 >> 2];
                                                                }
                                                                if (i[k + 116 >> 2] = n, i[k + 112 >> 2] = f, i[k + 120 >> 2] = _, (t | 0) != (u | 0)) for(; o[t - 1 | 0] < 0 && X(i[t - 12 >> 2]), t = t - 20 | 0, (u | 0) != (t | 0););
                                                                u && X(u), e = n;
                                                                break f;
                                                            }
                                                            p0(), z();
                                                        }
                                                        Z2(), z();
                                                    }
                                                }
                                                if (_ = e, i[k + 116 >> 2] = e, r = r + 20 | 0, (B | 0) == (r | 0)) break;
                                            }
                                            k = i[h + 40 >> 2];
                                        }
                                        if (i[A >> 2] = k, r = i[h + 44 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    if (A = i[h + 44 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (o[h + 75 | 0] < 0 && X(i[h + 64 >> 2]), A = i[h + 52 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            i: {
                                if (!v || (A = i[v + 4 >> 2], i[v + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                            }
                            m = h + 80 | 0;
                        }
                        function qh(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            w = m - 48 | 0, m = w;
                            i: {
                                if (!(n && k)) {
                                    if (o[w + 36 | 0] = 0, o[w + 47 | 0] = 0, e = A, A = i0(w + 8 | 0, 5, 2006, w + 36 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[w + 47 | 0] >= 0) break i;
                                    X(i[w + 36 >> 2]);
                                    break i;
                                }
                                if ((k | n) >>> 0 >= 65536) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 129, i[A + 8 >> 2] = 17711;
                                    break i;
                                }
                                B = w + 8 | 0, C = i[r >> 2], s = m - 48 | 0, m = s, V = n & 65535, y = k & 65535, v = Z(V, y);
                                e: {
                                    if (v >>> 16 | 0) {
                                        e = D(32), i[s + 12 >> 2] = e, i[s + 16 >> 2] = 31, i[s + 20 >> 2] = -2147483616, f = l[20491] | l[20492] << 8 | (l[20493] << 16 | l[20494] << 24), k = l[20487] | l[20488] << 8 | (l[20489] << 16 | l[20490] << 24), o[e + 23 | 0] = k, o[e + 24 | 0] = k >>> 8, o[e + 25 | 0] = k >>> 16, o[e + 26 | 0] = k >>> 24, o[e + 27 | 0] = f, o[e + 28 | 0] = f >>> 8, o[e + 29 | 0] = f >>> 16, o[e + 30 | 0] = f >>> 24, f = l[20484] | l[20485] << 8 | (l[20486] << 16 | l[20487] << 24), k = l[20480] | l[20481] << 8 | (l[20482] << 16 | l[20483] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[20476] | l[20477] << 8 | (l[20478] << 16 | l[20479] << 24), k = l[20472] | l[20473] << 8 | (l[20474] << 16 | l[20475] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[20468] | l[20469] << 8 | (l[20470] << 16 | l[20471] << 24), k = l[20464] | l[20465] << 8 | (l[20466] << 16 | l[20467] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 31 | 0] = 0, e = i0(s + 24 | 0, 5, 0, s + 12 | 0), i[B >> 2] = 0, i[B + 4 >> 2] = 0, f = i[e + 4 >> 2], i[B + 8 >> 2] = i[e >> 2], i[B + 12 >> 2] = f, f = B + 16 | 0;
                                        r: {
                                            if (o[e + 19 | 0] >= 0) {
                                                k = i[e + 12 >> 2], i[f >> 2] = i[e + 8 >> 2], i[f + 4 >> 2] = k, i[f + 8 >> 2] = i[e + 16 >> 2];
                                                break r;
                                            }
                                            if (j(f, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break r;
                                            X(i[e + 8 >> 2]);
                                        }
                                        if (o[s + 23 | 0] >= 0) break e;
                                        X(i[s + 12 >> 2]);
                                        break e;
                                    }
                                    _ = e | f, G = _ >>> 0 > 65535, k = G ? 12 : 8, n = D(k), i[s + 24 >> 2] = n, W = k + n | 0, i[s + 32 >> 2] = W, h = B0(n, 0, k), i[s + 28 >> 2] = W, o[h + 3 | 0] = y - 1, o[h + 2 | 0] = V - 1, o[h + 1 | 0] = G, o[h | 0] = 0;
                                    r: {
                                        if (_ >>> 0 >= 65536) {
                                            k = f << 24 | (f & 65280) << 8 | (f >>> 8 & 65280 | f >>> 24), o[h + 8 | 0] = k, o[h + 9 | 0] = k >>> 8, o[h + 10 | 0] = k >>> 16, o[h + 11 | 0] = k >>> 24, _ = e >>> 24 | 0, n = e, k = e >>> 16 | 0;
                                            break r;
                                        }
                                        _ = e >>> 8 | 0, n = f, k = e;
                                    }
                                    o[h + 7 | 0] = n, o[h + 5 | 0] = k, o[h + 4 | 0] = _, o[h + 6 | 0] = n >>> 8, _ = i[C + 48 >> 2], h = i[C + 52 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), G = YA(_, 1735551332), n = D(448), i[n >> 2] = 82988, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, W = L8(n + 16 | 0, C, G), i[W >> 2] = 83148, i[n + 404 >> 2] = 0, i[n + 408 >> 2] = 0, i[n + 396 >> 2] = 0, i[n + 400 >> 2] = 0, i[n + 388 >> 2] = 0, i[n + 392 >> 2] = 0, NA(n + 412 | 0), i[n + 444 >> 2] = i[t + 32 >> 2], k = i[t + 28 >> 2], i[n + 436 >> 2] = i[t + 24 >> 2], i[n + 440 >> 2] = k, k = i[t + 20 >> 2], i[n + 428 >> 2] = i[t + 16 >> 2], i[n + 432 >> 2] = k, k = i[t + 12 >> 2], i[n + 420 >> 2] = i[t + 8 >> 2], i[n + 424 >> 2] = k, k = i[t + 4 >> 2], i[n + 412 >> 2] = i[t >> 2], i[n + 416 >> 2] = k, i[n + 396 >> 2] = f, i[n + 392 >> 2] = e, Q[n + 390 >> 1] = y, Q[n + 388 >> 1] = V, t = i[n + 400 >> 2], k = i[n + 404 >> 2] - t >> 2;
                                    r: {
                                        if (k >>> 0 < v >>> 0) {
                                            d4(n + 400 | 0, v - k | 0);
                                            break r;
                                        }
                                        if (k >>> 0 <= v >>> 0) break r;
                                        i[n + 404 >> 2] = t + (v << 2);
                                    }
                                    i[n + 60 >> 2] = f, i[n + 56 >> 2] = e, i[s + 16 >> 2] = n, i[s + 12 >> 2] = W, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, Oe(C, G, s + 12 | 0), k = i[s + 16 >> 2];
                                    r: {
                                        if (!k || (t = i[k + 4 >> 2], i[k + 4 >> 2] = t - 1, t)) break r;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    }
                                    x8(_, G, s + 24 | 0, 1), i[s + 20 >> 2] = 0, i[s + 12 >> 2] = 0, i[s + 16 >> 2] = 0, v && d4(s + 12 | 0, v), J4(_, G, 1684630887, s + 12 | 0), t = m - 16 | 0, m = t, k = D(128), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 76576, v = k + 16 | 0, i[v + 8 >> 2] = 0, i[v + 12 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 16 >> 2] = 73428, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[k + 16 >> 2] = 74528, i[k + 124 >> 2] = f, i[k + 120 >> 2] = e, i[k + 32 >> 2] = 1769173093, e = i[_ + 52 >> 2], i[t + 12 >> 2] = k, i[t + 8 >> 2] = v, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, f = c8(e, t + 8 | 0), e = i[t + 12 >> 2];
                                    r: {
                                        if (!e || (v = i[e + 4 >> 2], i[e + 4 >> 2] = v - 1, v)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    e = i[_ + 60 >> 2], Q[t + 6 >> 1] = f + 1, o[t + 4 | 0] = 0, i[t >> 2] = I[t + 4 >> 1] | I[t + 6 >> 1] << 16, v6(e, G, t), e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), m = t + 16 | 0, i[B + 4 >> 2] = n, i[B >> 2] = W, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = i[21669], i[B + 8 >> 2] = i[21668], i[B + 12 >> 2] = e, e = B + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            f = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(e, i[21670], i[21671]);
                                    }
                                    e = i[s + 12 >> 2], e && (i[s + 16 >> 2] = e, X(e));
                                    r: {
                                        if (!h || (e = i[h + 4 >> 2], i[h + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                    }
                                    if (e = i[s + 24 >> 2], e && (i[s + 28 >> 2] = e, X(e)), e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                m = s + 48 | 0;
                                e: {
                                    if (i[w + 16 >> 2]) {
                                        j0(A, w + 16 | 0, i[r >> 2]);
                                        break e;
                                    }
                                    r: {
                                        if (!u) break r;
                                        k = D(16), e = k, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[u >> 2] = e, n = i[w + 8 >> 2], f = i[w + 12 >> 2];
                                        A: {
                                            if (!f) {
                                                i[e + 4 >> 2] = f, i[e >> 2] = n;
                                                break A;
                                            }
                                            if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, i[k >> 2] = n, e = i[k + 4 >> 2], i[k + 4 >> 2] = f, !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break A;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (k = i[r >> 2], e = i[u >> 2], f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 8 >> 2] = k, r = i[e + 12 >> 2], i[e + 12 >> 2] = f, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (o[w + 35 | 0] < 0 && X(i[w + 24 >> 2]), A = i[w + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = w + 48 | 0;
                        }
                        function $h(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            f = m - 128 | 0, m = f, w = l[k + 8 | 0], v = i[i[e >> 2] + 36 >> 2], n = D(136), i[n >> 2] = 78252, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, B0(n + 20 | 0, 0, 104), k = i[n + 4 >> 2], u = k + 1 | 0, i[n + 4 >> 2] = u, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 44 >> 2] = 99, i[n + 48 >> 2] = 99, i[n + 32 >> 2] = 4142, r = n - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, r = n + 76 | 0, i[n + 72 >> 2] = r, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, _ = n + 12 | 0, i[n + 12 >> 2] = _, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = k, i[n + 16 >> 2] = n, u || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), k = i[e >> 2], G = i[k + 28 >> 2], W = i[k + 24 >> 2], s = S0(k, 10), i[_ + 36 >> 2] = 3, i[_ + 32 >> 2] = 1, i[_ + 28 >> 2] = G, i[_ + 24 >> 2] = W, J0(f + 56 | 0, _, 3, W, G, s, t), J0(f + 32 | 0, _, 4, W, G, s, t), k = f + 88 | 0;
                            i: {
                                if (i[f + 56 >> 2]) {
                                    if (u = i[f + 60 >> 2], i[f + 80 >> 2] = i[f + 56 >> 2], i[f + 84 >> 2] = u, o[f + 75 | 0] >= 0) {
                                        u = f - -64 | 0, h = i[u + 4 >> 2], i[k >> 2] = i[u >> 2], i[k + 4 >> 2] = h, i[k + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    j(k, i[f + 64 >> 2], i[f + 68 >> 2]);
                                    break i;
                                }
                                if (u = i[f + 36 >> 2], i[f + 80 >> 2] = i[f + 32 >> 2], i[f + 84 >> 2] = u, o[f + 51 | 0] >= 0) {
                                    u = i[f + 44 >> 2], i[k >> 2] = i[f + 40 >> 2], i[k + 4 >> 2] = u, i[k + 8 >> 2] = i[f + 48 >> 2];
                                    break i;
                                }
                                j(k, i[f + 40 >> 2], i[f + 44 >> 2]);
                            }
                            J0(f + 8 | 0, _, 5, W, G, s, t), u = f + 112 | 0;
                            i: {
                                if (i[f + 80 >> 2]) {
                                    if (h = i[f + 84 >> 2], i[f + 104 >> 2] = i[f + 80 >> 2], i[f + 108 >> 2] = h, o[f + 99 | 0] >= 0) {
                                        h = i[k + 4 >> 2], i[u >> 2] = i[k >> 2], i[u + 4 >> 2] = h, i[u + 8 >> 2] = i[k + 8 >> 2];
                                        break i;
                                    }
                                    j(u, i[f + 88 >> 2], i[f + 92 >> 2]);
                                    break i;
                                }
                                if (k = i[f + 12 >> 2], i[f + 104 >> 2] = i[f + 8 >> 2], i[f + 108 >> 2] = k, o[f + 27 | 0] >= 0) {
                                    k = i[f + 20 >> 2], i[u >> 2] = i[f + 16 >> 2], i[u + 4 >> 2] = k, i[u + 8 >> 2] = i[f + 24 >> 2];
                                    break i;
                                }
                                j(u, i[f + 16 >> 2], i[f + 20 >> 2]);
                            }
                            o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), o[f + 99 | 0] < 0 && X(i[f + 88 >> 2]), o[f + 51 | 0] < 0 && X(i[f + 40 >> 2]), o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]);
                            i: {
                                if (i[f + 104 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                        r = i[u + 4 >> 2], i[A >> 2] = i[u >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    if (j(A, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                    X(i[f + 112 >> 2]);
                                    break i;
                                }
                                o[f + 123 | 0] < 0 && X(i[f + 112 >> 2]);
                                e: {
                                    if (!(w & 1)) break e;
                                    if (J0(f + 104 | 0, _, 6, W, G, s, t), i[f + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                            r = i[f + 116 >> 2], i[A >> 2] = i[f + 112 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[f + 120 >> 2];
                                            break i;
                                        }
                                        if (j(A, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                        X(i[f + 112 >> 2]);
                                        break i;
                                    }
                                    if (o[f + 123 | 0] >= 0) break e;
                                    X(i[f + 112 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (e = i[e >> 2], t = i[e + 64 >> 2], !t) break r;
                                        for(k = e - -64 | 0, e = k; u = i[t + 16 >> 2] < 10, e = u ? e : t, t = i[(u << 2) + t >> 2], !!t;);
                                        if ((e | 0) == (k | 0)) break r;
                                        if (h = 0, i[e + 16 >> 2] > 10) break e;
                                        F = i[e + 52 >> 2], h = i[e + 44 >> 2];
                                        break e;
                                    }
                                    h = 0;
                                }
                                e: {
                                    r: {
                                        e = i[r >> 2];
                                        A: {
                                            if (!e) {
                                                u = 0;
                                                break A;
                                            }
                                            for(k = r, t = e; u = i[t + 16 >> 2] < 3, k = u ? k : t, t = i[(u << 2) + t >> 2], !!t;);
                                            t = 0;
                                            f: {
                                                if ((r | 0) == (k | 0) || (t = 0, i[k + 16 >> 2] > 3)) break f;
                                                C = i[k + 52 >> 2], t = i[k + 44 >> 2];
                                            }
                                            for(E = t, k = r, t = e; u = i[t + 16 >> 2] < 4, k = u ? k : t, t = i[(u << 2) + t >> 2], !!t;);
                                            u = 0;
                                            f: {
                                                if ((r | 0) == (k | 0) || (u = 0, i[k + 16 >> 2] > 4)) break f;
                                                R = i[k + 44 >> 2], u = i[k + 52 >> 2];
                                            }
                                            for(k = r, t = e; B = i[t + 16 >> 2] < 5, k = B ? k : t, t = i[(B << 2) + t >> 2], !!t;);
                                            B = 0;
                                            f: {
                                                if ((r | 0) == (k | 0) || (B = 0, i[k + 16 >> 2] > 5)) break f;
                                                M = i[k + 52 >> 2] >>> 1 | 0, B = i[k + 44 >> 2];
                                            }
                                            if (k = 0, !e || (k = 0, !(w & 1))) break e;
                                            for(t = r; k = i[e + 16 >> 2] < 6, t = k ? t : e, e = i[(k << 2) + e >> 2], !!e;);
                                            if ((r | 0) != (t | 0)) break r;
                                        }
                                        k = 0;
                                        break e;
                                    }
                                    if (k = 0, i[t + 16 >> 2] > 6) break e;
                                    y = i[t + 52 >> 2] >>> 1 | 0, k = i[t + 44 >> 2];
                                }
                                e: {
                                    if (!G | !W) break e;
                                    if (H = (v & -3) == 13 ? 8 : 6, T = u >>> 1 | 0, C = C >>> 1 | 0, !(w & 1)) {
                                        for(u = 0;;){
                                            for(w = Z(u, F), v = (Z(u, M) << 1) + B | 0, y = (Z(u, T) << 1) + R | 0, V = (Z(u, C) << 1) + E | 0, t = 0; r = (w + Z(t, H) | 0) + h | 0, e = l[r + 4 | 0] | l[r + 5 | 0] << 8, k = l[r + 2 | 0] | l[r + 3 | 0] << 8, s = t << 1, r = l[r | 0] | l[r + 1 | 0] << 8, Q[s + V >> 1] = r << 8 | r >>> 8, Q[s + y >> 1] = k << 8 | k >>> 8, Q[s + v >> 1] = e << 8 | e >>> 8, t = t + 1 | 0, (W | 0) != (t | 0););
                                            if (u = u + 1 | 0, (G | 0) == (u | 0)) break;
                                        }
                                        break e;
                                    }
                                    V = -1 << s ^ -1, r = 0;
                                    r: switch(v - 13 | 0){
                                        case 0:
                                        case 2:
                                            for(;;){
                                                for(V = Z(r, y), u = Z(r, F), S = (Z(r, M) << 1) + B | 0, P = (Z(r, T) << 1) + R | 0, $ = (Z(r, C) << 1) + E | 0, t = 0; e = (u + Z(t, H) | 0) + h | 0, s = l[e + 4 | 0] | l[e + 5 | 0] << 8, w = l[e + 2 | 0] | l[e + 3 | 0] << 8, v = t << 1, e = l[e | 0] | l[e + 1 | 0] << 8, Q[v + $ >> 1] = e << 8 | e >>> 8, Q[v + P >> 1] = w << 8 | w >>> 8, Q[v + S >> 1] = s << 8 | s >>> 8, e = (u + (t << 3) | 0) + h | 0, e = l[e + 6 | 0] | l[e + 7 | 0] << 8, Q[k + (t + V << 1) >> 1] = e << 8 | e >>> 8, t = t + 1 | 0, (W | 0) != (t | 0););
                                                if (r = r + 1 | 0, (G | 0) == (r | 0)) break;
                                            }
                                            break e;
                                        default:
                                            break r;
                                    }
                                    for(;;){
                                        for(v = Z(r, y), S = Z(r, F), P = (Z(r, M) << 1) + B | 0, $ = (Z(r, T) << 1) + R | 0, c = (Z(r, C) << 1) + E | 0, t = 0; e = (S + Z(t, H) | 0) + h | 0, u = l[e + 4 | 0] | l[e + 5 | 0] << 8, s = l[e + 2 | 0] | l[e + 3 | 0] << 8, w = t << 1, e = l[e | 0] | l[e + 1 | 0] << 8, Q[w + c >> 1] = e << 8 | e >>> 8, Q[w + $ >> 1] = s << 8 | s >>> 8, Q[w + P >> 1] = u << 8 | u >>> 8, Q[k + (t + v << 1) >> 1] = V, t = t + 1 | 0, (W | 0) != (t | 0););
                                        if (r = r + 1 | 0, (G | 0) == (r | 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = n, i[A >> 2] = _, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = f + 128 | 0;
                        }
                        function ah(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0;
                            f = m - 80 | 0, m = f, i[f + 72 >> 2] = 0, i[f + 76 >> 2] = 0, r = f - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, r = i[e >> 2];
                            i: {
                                if (i[r + 32 >> 2] != 2) {
                                    r = D(40), i[f + 12 >> 2] = r, i[f + 16 >> 2] = 39, i[f + 20 >> 2] = -2147483608, e = l[7214] | l[7215] << 8 | (l[7216] << 16 | l[7217] << 24), k = l[7210] | l[7211] << 8 | (l[7212] << 16 | l[7213] << 24), o[r + 31 | 0] = k, o[r + 32 | 0] = k >>> 8, o[r + 33 | 0] = k >>> 16, o[r + 34 | 0] = k >>> 24, o[r + 35 | 0] = e, o[r + 36 | 0] = e >>> 8, o[r + 37 | 0] = e >>> 16, o[r + 38 | 0] = e >>> 24, e = l[7207] | l[7208] << 8 | (l[7209] << 16 | l[7210] << 24), k = l[7203] | l[7204] << 8 | (l[7205] << 16 | l[7206] << 24), o[r + 24 | 0] = k, o[r + 25 | 0] = k >>> 8, o[r + 26 | 0] = k >>> 16, o[r + 27 | 0] = k >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7199] | l[7200] << 8 | (l[7201] << 16 | l[7202] << 24), k = l[7195] | l[7196] << 8 | (l[7197] << 16 | l[7198] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7191] | l[7192] << 8 | (l[7193] << 16 | l[7194] << 24), k = l[7187] | l[7188] << 8 | (l[7189] << 16 | l[7190] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[7183] | l[7184] << 8 | (l[7185] << 16 | l[7186] << 24), k = l[7179] | l[7180] << 8 | (l[7181] << 16 | l[7182] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 39 | 0] = 0, r = i0(f + 24 | 0, 4, 3002, f + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 32 >> 2] = i[r >> 2], i[A + 36 >> 2] = e, A = A + 40 | 0;
                                    e: {
                                        if (o[r + 19 | 0] >= 0) {
                                            e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break e;
                                        X(i[r + 8 >> 2]);
                                    }
                                    if (o[f + 23 | 0] >= 0) break i;
                                    X(i[f + 12 >> 2]);
                                    break i;
                                }
                                if (n = 0, (S0(r, 0) | 0) != 8) {
                                    r = D(40), i[f + 12 >> 2] = r, i[f + 16 >> 2] = 37, i[f + 20 >> 2] = -2147483608, e = l[7174] | l[7175] << 8 | (l[7176] << 16 | l[7177] << 24), k = l[7170] | l[7171] << 8 | (l[7172] << 16 | l[7173] << 24), o[r + 29 | 0] = k, o[r + 30 | 0] = k >>> 8, o[r + 31 | 0] = k >>> 16, o[r + 32 | 0] = k >>> 24, o[r + 33 | 0] = e, o[r + 34 | 0] = e >>> 8, o[r + 35 | 0] = e >>> 16, o[r + 36 | 0] = e >>> 24, e = l[7169] | l[7170] << 8 | (l[7171] << 16 | l[7172] << 24), k = l[7165] | l[7166] << 8 | (l[7167] << 16 | l[7168] << 24), o[r + 24 | 0] = k, o[r + 25 | 0] = k >>> 8, o[r + 26 | 0] = k >>> 16, o[r + 27 | 0] = k >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7161] | l[7162] << 8 | (l[7163] << 16 | l[7164] << 24), k = l[7157] | l[7158] << 8 | (l[7159] << 16 | l[7160] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7153] | l[7154] << 8 | (l[7155] << 16 | l[7156] << 24), k = l[7149] | l[7150] << 8 | (l[7151] << 16 | l[7152] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[7145] | l[7146] << 8 | (l[7147] << 16 | l[7148] << 24), k = l[7141] | l[7142] << 8 | (l[7143] << 16 | l[7144] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 37 | 0] = 0, r = i0(f + 24 | 0, 4, 3002, f + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 32 >> 2] = i[r >> 2], i[A + 36 >> 2] = e, A = A + 40 | 0;
                                    e: {
                                        if (o[r + 19 | 0] >= 0) {
                                            e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break e;
                                        X(i[r + 8 >> 2]);
                                    }
                                    if (o[f + 23 | 0] >= 0) break i;
                                    X(i[f + 12 >> 2]);
                                    break i;
                                }
                                i[f + 32 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, u = i[e >> 2], k = i[u + 64 >> 2], t = 0;
                                e: {
                                    if (!k) break e;
                                    for(n = u - -64 | 0, r = n; t = i[k + 16 >> 2], r = (t | 0) < 0 ? r : k, k = i[(t >>> 29 & 4) + k >> 2], !!k;);
                                    if ((r | 0) == (n | 0)) {
                                        n = 0, t = 0;
                                        break e;
                                    }
                                    if (n = 0, t = 0, i[r + 16 >> 2] > 0) break e;
                                    n = i[r + 52 >> 2], t = i[r + 44 >> 2];
                                }
                                r = i[u + 28 >> 2], u = i[u + 24 >> 2], k = Z(r, u), k && r1(f + 24 | 0, k);
                                e: {
                                    if ((n | 0) != (u | 0)) {
                                        if (!r) break e;
                                        for(k = 0; Gr(f + 48 | 0, t + Z(k, n) | 0, u), k = k + 1 | 0, (r | 0) != (k | 0););
                                        break e;
                                    }
                                    Gr(f + 48 | 0, t, k);
                                }
                                r = D(128), i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 77976, k = r + 16 | 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 16 >> 2] = 73428, i[r + 60 >> 2] = 0, i[r + 64 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 72 >> 2] = -1, i[r + 76 >> 2] = -1, i[r + 80 >> 2] = -1, i[r + 84 >> 2] = -1, i[r + 116 >> 2] = 0, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, Q[r + 112 >> 1] = 0, i[r + 16 >> 2] = 82276, i[r + 32 >> 2] = 1836280643, o[r + 120 | 0] = 0, s = r, h = S0(i[e >> 2], 0), o[s + 120 | 0] = h, i[f + 16 >> 2] = r, i[f + 12 >> 2] = k, i[r + 4 >> 2] = i[r + 4 >> 2] + 1, e = i[f + 52 >> 2];
                                e: {
                                    if (e >>> 0 < k0[f + 56 >> 2]) {
                                        i[e + 4 >> 2] = r, i[e >> 2] = k, i[f + 52 >> 2] = e + 8;
                                        break e;
                                    }
                                    if (s = f, h = p2(f + 48 | 0, f + 12 | 0), i[s + 52 >> 2] = h, e = i[f + 16 >> 2], !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (G6(A, f + 48 | 0), A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), A = i[f + 24 >> 2], A && (i[f + 28 >> 2] = A, X(A)), A = i[f + 60 >> 2], !A) break i;
                                i[f + 64 >> 2] = A, X(A);
                            }
                            if (A = i[f + 48 >> 2], A) {
                                if (r = A, k = i[f + 52 >> 2], (r | 0) != (k | 0)) {
                                    for(;;){
                                        r = i[k - 4 >> 2];
                                        i: {
                                            if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (k = k - 8 | 0, (A | 0) == (k | 0)) break;
                                    }
                                    r = i[f + 48 >> 2];
                                }
                                i[f + 52 >> 2] = A, X(r);
                            }
                            m = f + 80 | 0;
                        }
                        function bh(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            k = m - 160 | 0, m = k, i[k + 60 >> 2] = 60132, u = i[15036], i[k + 4 >> 2] = u, f = i[u - 12 >> 2], u = k + 4 | 0, i[f + u >> 2] = i[15037], f = u + i[i[k + 4 >> 2] - 12 >> 2] | 0, t = k + 8 | 0, T0(f, t), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, i[k + 60 >> 2] = 60132, i[k + 4 >> 2] = 60112, B = z0(t), i[B >> 2] = 58864, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 56 >> 2] = 16, f = k + 148 | 0, D2(f, r, e), n = u, t = f, u = o[k + 159 | 0], f = (u | 0) < 0, U(n, f ? i[k + 148 >> 2] : t, f ? i[k + 152 >> 2] : u), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]);
                            i: {
                                if (u = i[r + 104 >> 2], G = i[r + 108 >> 2], (u | 0) != (G | 0)) for(;;){
                                    r = k + 148 | 0, G0(r, e), n = r, r = o[k + 159 | 0], f = (r | 0) < 0, U(k + 4 | 0, f ? i[k + 148 >> 2] : n, f ? i[k + 152 >> 2] : r), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), r = U(M0(U(k + 4 | 0, 25014, 9), i[u >> 2]), 34895, 1), f = k + 148 | 0, G0(f, e), n = f, f = o[k + 159 | 0], t = (f | 0) < 0, U(r, t ? i[k + 148 >> 2] : n, t ? i[k + 152 >> 2] : f), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), r = U(P0(U(r, 24639, 23), l[u + 4 | 0]), 34895, 1), f = k + 148 | 0, G0(f, e), n = f, f = o[k + 159 | 0], t = (f | 0) < 0, U(r, t ? i[k + 148 >> 2] : n, t ? i[k + 152 >> 2] : f), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), r = U(r, 22780, 24), f = i[i[r >> 2] - 12 >> 2] + r | 0, i[f + 4 >> 2] = i[f + 4 >> 2] & -75 | 8, r = M0(r, I[u + 6 >> 1]), f = i[i[r >> 2] - 12 >> 2] + r | 0, i[f + 4 >> 2] = i[f + 4 >> 2] & -75 | 2, r = U(r, 34895, 1), f = k + 148 | 0, G0(f, e), n = f, f = o[k + 159 | 0], t = (f | 0) < 0, U(r, t ? i[k + 148 >> 2] : n, t ? i[k + 152 >> 2] : f), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), U(K1(U(r, 22960, 15), i[u + 8 >> 2], i[u + 12 >> 2]), 34895, 1), r = k + 148 | 0, G0(r, e), n = r, r = o[k + 159 | 0], f = (r | 0) < 0, U(k + 4 | 0, f ? i[k + 148 >> 2] : n, f ? i[k + 152 >> 2] : r), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), U(k + 4 | 0, 23040, 11);
                                    e: {
                                        if (r = i[u + 16 >> 2], W = i[u + 20 >> 2], (r | 0) == (W | 0)) break e;
                                        r: {
                                            for(;;){
                                                A: {
                                                    n = K1(k + 4 | 0, i[r + 8 >> 2], i[r + 12 >> 2]), _ = C1(k + 140 | 0, n);
                                                    f: {
                                                        if (l[_ | 0] != 1) break f;
                                                        w = n + i[i[n >> 2] - 12 >> 2] | 0, v = i[w + 4 >> 2], t = i[w + 24 >> 2], h = i[w + 76 >> 2], (h | 0) == -1 && (s = k + 148 | 0, f = i[w + 28 >> 2], i[s >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(s, 108580), h = p[i[i[f >> 2] + 28 >> 2]](f, 32) | 0, d0(s), i[w + 76 >> 2] = h);
                                                        k: {
                                                            if (!t || (f = i[w + 12 >> 2], v = (v & 176) == 32 ? 20127 : 20126, s = v - 20126 | 0, (s | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, 20126, s) | 0) != (s | 0))) break k;
                                                            if (f = (f | 0) > 1 ? f - 1 | 0 : 0, (f | 0) > 0) {
                                                                if (f >>> 0 >= 2147483640) break A;
                                                                n: {
                                                                    if (f >>> 0 >= 11) {
                                                                        C = (f | 7) + 1 | 0, s = D(C), i[k + 156 >> 2] = C | -2147483648, i[k + 148 >> 2] = s, i[k + 152 >> 2] = f;
                                                                        break n;
                                                                    }
                                                                    o[k + 159 | 0] = f, s = k + 148 | 0;
                                                                }
                                                                if (V = B0(s, h, f) + f | 0, y = 0, o[V | 0] = y, h = p[i[i[t >> 2] + 48 >> 2]](t, o[k + 159 | 0] < 0 ? i[k + 148 >> 2] : k + 148 | 0, f) | 0, o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), (f | 0) != (h | 0)) break k;
                                                            }
                                                            if (f = 20127 - v | 0, (f | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, v, f) | 0) != (f | 0)) break k;
                                                            i[w + 12 >> 2] = 0;
                                                            break f;
                                                        }
                                                        f = n + i[i[n >> 2] - 12 >> 2] | 0, N1(f, i[f + 16 >> 2] | 5);
                                                    }
                                                    if (G1(_), K1(n, i[r + 16 >> 2], i[r + 20 >> 2]), i[r >> 2] | i[r + 4 >> 2]) {
                                                        f = k + 4 | 0, v = C1(k + 140 | 0, f);
                                                        f: {
                                                            if (l[v | 0] != 1) break f;
                                                            h = f + i[i[k + 4 >> 2] - 12 >> 2] | 0, s = i[h + 4 >> 2], t = i[h + 24 >> 2], w = i[h + 76 >> 2], (w | 0) == -1 && (n = k + 148 | 0, f = i[h + 28 >> 2], i[n >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(n, 108580), w = p[i[i[f >> 2] + 28 >> 2]](f, 32) | 0, d0(n), i[h + 76 >> 2] = w);
                                                            k: {
                                                                if (!t || (f = i[h + 12 >> 2], s = (s & 176) == 32 ? 17410 : 17403, n = s - 17403 | 0, (n | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, 17403, n) | 0) != (n | 0))) break k;
                                                                if (f = (f | 0) > 7 ? f - 7 | 0 : 0, (f | 0) > 0) {
                                                                    if (f >>> 0 >= 2147483640) break i;
                                                                    n: {
                                                                        if (f >>> 0 >= 11) {
                                                                            _ = (f | 7) + 1 | 0, n = D(_), i[k + 156 >> 2] = _ | -2147483648, i[k + 148 >> 2] = n, i[k + 152 >> 2] = f;
                                                                            break n;
                                                                        }
                                                                        o[k + 159 | 0] = f, n = k + 148 | 0;
                                                                    }
                                                                    if (V = B0(n, w, f) + f | 0, y = 0, o[V | 0] = y, w = p[i[i[t >> 2] + 48 >> 2]](t, o[k + 159 | 0] < 0 ? i[k + 148 >> 2] : k + 148 | 0, f) | 0, o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), (f | 0) != (w | 0)) break k;
                                                                }
                                                                if (f = 17410 - s | 0, (f | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, s, f) | 0) != (f | 0)) break k;
                                                                i[h + 12 >> 2] = 0;
                                                                break f;
                                                            }
                                                            f = i[i[k + 4 >> 2] - 12 >> 2] + (k + 4 | 0) | 0, N1(f, i[f + 16 >> 2] | 5);
                                                        }
                                                        G1(v), K1(k + 4 | 0, i[r >> 2], i[r + 4 >> 2]);
                                                    }
                                                    f = k + 4 | 0, v = C1(k + 140 | 0, f);
                                                    f: {
                                                        if (l[v | 0] != 1) break f;
                                                        h = f + i[i[k + 4 >> 2] - 12 >> 2] | 0, s = i[h + 4 >> 2], t = i[h + 24 >> 2], w = i[h + 76 >> 2], (w | 0) == -1 && (n = k + 148 | 0, f = i[h + 28 >> 2], i[n >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(n, 108580), w = p[i[i[f >> 2] + 28 >> 2]](f, 32) | 0, d0(n), i[h + 76 >> 2] = w);
                                                        k: {
                                                            if (!t || (f = i[h + 12 >> 2], s = (s & 176) == 32 ? 25194 : 25193, n = s - 25193 | 0, (n | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, 25193, n) | 0) != (n | 0))) break k;
                                                            if (f = (f | 0) > 1 ? f - 1 | 0 : 0, (f | 0) > 0) {
                                                                if (f >>> 0 >= 2147483640) break r;
                                                                n: {
                                                                    if (f >>> 0 >= 11) {
                                                                        _ = (f | 7) + 1 | 0, n = D(_), i[k + 156 >> 2] = _ | -2147483648, i[k + 148 >> 2] = n, i[k + 152 >> 2] = f;
                                                                        break n;
                                                                    }
                                                                    o[k + 159 | 0] = f, n = k + 148 | 0;
                                                                }
                                                                if (V = B0(n, w, f) + f | 0, y = 0, o[V | 0] = y, w = p[i[i[t >> 2] + 48 >> 2]](t, o[k + 159 | 0] < 0 ? i[k + 148 >> 2] : k + 148 | 0, f) | 0, o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), (f | 0) != (w | 0)) break k;
                                                            }
                                                            if (f = 25194 - s | 0, (f | 0) > 0 && (p[i[i[t >> 2] + 48 >> 2]](t, s, f) | 0) != (f | 0)) break k;
                                                            i[h + 12 >> 2] = 0;
                                                            break f;
                                                        }
                                                        f = i[i[k + 4 >> 2] - 12 >> 2] + (k + 4 | 0) | 0, N1(f, i[f + 16 >> 2] | 5);
                                                    }
                                                    if (G1(v), r = r + 40 | 0, (W | 0) != (r | 0)) continue;
                                                    break e;
                                                }
                                                break;
                                            }
                                            break i;
                                        }
                                        break i;
                                    }
                                    if (U(k + 4 | 0, 34895, 1), u = u + 32 | 0, (G | 0) == (u | 0)) break;
                                }
                                r = i[k + 56 >> 2];
                                e: {
                                    r: {
                                        if (r & 16) {
                                            r = i[k + 52 >> 2], e = i[k + 32 >> 2], r >>> 0 < e >>> 0 && (i[k + 52 >> 2] = e, r = e), e = k + 28 | 0;
                                            break r;
                                        }
                                        if (!(r & 8)) {
                                            r = 0, o[A + 11 | 0] = 0;
                                            break e;
                                        }
                                        r = i[k + 24 >> 2], e = k + 16 | 0;
                                    }
                                    r: {
                                        if (u = i[e >> 2], r = r - u | 0, r >>> 0 < 2147483640) {
                                            if (r >>> 0 >= 11) {
                                                f = (r | 7) + 1 | 0, e = D(f), i[A + 8 >> 2] = f | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                                break r;
                                            }
                                            if (o[A + 11 | 0] = r, r) break r;
                                            r = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(A, u, r);
                                }
                                o[A + r | 0] = 0, A = i[15035], i[k + 4 >> 2] = A, i[i[A - 12 >> 2] + (k + 4 | 0) >> 2] = i[15038], i[B >> 2] = 58864, o[k + 51 | 0] < 0 && X(i[k + 40 >> 2]), x0(B), N0(k + 60 | 0), m = k + 160 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function dh(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            s = m - 112 | 0, m = s, o[s + 81 | 0] = 0, o[s + 82 | 0] = 0, o[s + 83 | 0] = 0, o[s + 84 | 0] = 0, Q[s + 78 >> 1] = 0, Q[s + 80 >> 1] = 0, Q[s + 76 >> 1] = 263, o[s + 108 | 0] = 1, o[s + 104 | 0] = 0, i[s + 96 >> 2] = 2, i[s + 100 >> 2] = 2, o[s + 92 | 0] = 1, i[s + 88 >> 2] = 1;
                            i: {
                                if (!n) break i;
                                e: switch(l[n | 0] - 1 | 0){
                                    case 6:
                                        o[s + 108 | 0] = l[n + 32 | 0];
                                    case 5:
                                        h = i[n + 20 >> 2], i[s + 92 >> 2] = i[n + 16 >> 2], i[s + 96 >> 2] = h, h = i[n + 28 >> 2], i[s + 100 >> 2] = i[n + 24 >> 2], i[s + 104 >> 2] = h;
                                    case 4:
                                        i[s + 88 >> 2] = i[n + 12 >> 2];
                                    case 3:
                                        i[s + 80 >> 2] = i[n + 4 >> 2], o[s + 84 | 0] = l[n + 8 | 0];
                                    case 2:
                                        o[s + 79 | 0] = l[n + 3 | 0];
                                    case 1:
                                        o[s + 78 | 0] = l[n + 2 | 0];
                                        break;
                                    case 0:
                                        break e;
                                    default:
                                        break i;
                                }
                                o[s + 77 | 0] = l[n + 1 | 0];
                            }
                            w = s + 48 | 0, _ = i[r >> 2], B = s + 76 | 0, h = m + -64 | 0, m = h, v = i[e >> 2], e = i[v + 28 >> 2], n = i[v + 24 >> 2];
                            i: {
                                if (!((n | 0) > (t | 0) | (e | 0) > (t | 0))) {
                                    if (i[w >> 2] = 0, i[w + 4 >> 2] = 0, e = i[21669], i[w + 8 >> 2] = i[21668], i[w + 12 >> 2] = e, e = w + 16 | 0, o[86691] >= 0) {
                                        k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(e, i[21670], i[21671]);
                                    break i;
                                }
                                e: {
                                    if ((e | 0) < (n | 0)) {
                                        n = (Z(e, t) | 0) / (n | 0) | 0, e = t;
                                        break e;
                                    }
                                    e = (Z(n, t) | 0) / (e | 0) | 0, n = t;
                                }
                                i[h + 56 >> 2] = 0, i[h + 60 >> 2] = 0, h3(h + 32 | 0, v, h + 56 | 0, e & -2, n & -2, _ - -64 | 0);
                                e: {
                                    if (i[h + 32 >> 2]) {
                                        if (i[w >> 2] = 0, i[w + 4 >> 2] = 0, e = i[h + 36 >> 2], i[w + 8 >> 2] = i[h + 32 >> 2], i[w + 12 >> 2] = e, e = w + 16 | 0, o[h + 51 | 0] >= 0) {
                                            k = i[h + 44 >> 2], i[e >> 2] = i[h + 40 >> 2], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[h + 48 >> 2];
                                            break e;
                                        }
                                        j(e, i[h + 40 >> 2], i[h + 44 >> 2]);
                                        break e;
                                    }
                                    ri(h + 4 | 0, _, h + 56 | 0, k, B, 4);
                                    r: {
                                        if (i[h + 12 >> 2]) {
                                            if (i[w >> 2] = 0, i[w + 4 >> 2] = 0, e = i[h + 16 >> 2], i[w + 8 >> 2] = i[h + 12 >> 2], i[w + 12 >> 2] = e, e = w + 16 | 0, o[h + 31 | 0] >= 0) {
                                                k = i[h + 24 >> 2], i[e >> 2] = i[h + 20 >> 2], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[h + 28 >> 2];
                                                break r;
                                            }
                                            j(e, i[h + 20 >> 2], i[h + 24 >> 2]);
                                            break r;
                                        }
                                        if (i[w >> 2] = i[h + 4 >> 2], e = i[h + 8 >> 2], i[w + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[21669], i[w + 8 >> 2] = i[21668], i[w + 12 >> 2] = e, e = w + 16 | 0, o[86691] >= 0) {
                                            k = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = k, i[e + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(e, i[21670], i[21671]);
                                    }
                                    if (o[h + 31 | 0] < 0 && X(i[h + 20 >> 2]), e = i[h + 8 >> 2], !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (o[h + 51 | 0] < 0 && X(i[h + 40 >> 2]), e = i[h + 60 >> 2], !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            m = h - -64 | 0;
                            i: {
                                if (i[s + 56 >> 2] != i[21668]) {
                                    j0(A, s + 56 | 0, i[r >> 2]);
                                    break i;
                                }
                                e = i[s + 48 >> 2], i[s + 40 >> 2] = e, n = i[s + 52 >> 2], i[s + 44 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1);
                                e: {
                                    if (!e) {
                                        if (e = D(64), i[s + 8 >> 2] = e, i[s + 12 >> 2] = 57, i[s + 16 >> 2] = -2147483584, o[e + 56 | 0] = l[19803], f = l[19799] | l[19800] << 8 | (l[19801] << 16 | l[19802] << 24), k = l[19795] | l[19796] << 8 | (l[19797] << 16 | l[19798] << 24), o[e + 48 | 0] = k, o[e + 49 | 0] = k >>> 8, o[e + 50 | 0] = k >>> 16, o[e + 51 | 0] = k >>> 24, o[e + 52 | 0] = f, o[e + 53 | 0] = f >>> 8, o[e + 54 | 0] = f >>> 16, o[e + 55 | 0] = f >>> 24, f = l[19791] | l[19792] << 8 | (l[19793] << 16 | l[19794] << 24), k = l[19787] | l[19788] << 8 | (l[19789] << 16 | l[19790] << 24), o[e + 40 | 0] = k, o[e + 41 | 0] = k >>> 8, o[e + 42 | 0] = k >>> 16, o[e + 43 | 0] = k >>> 24, o[e + 44 | 0] = f, o[e + 45 | 0] = f >>> 8, o[e + 46 | 0] = f >>> 16, o[e + 47 | 0] = f >>> 24, f = l[19783] | l[19784] << 8 | (l[19785] << 16 | l[19786] << 24), k = l[19779] | l[19780] << 8 | (l[19781] << 16 | l[19782] << 24), o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, o[e + 34 | 0] = k >>> 16, o[e + 35 | 0] = k >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[19775] | l[19776] << 8 | (l[19777] << 16 | l[19778] << 24), k = l[19771] | l[19772] << 8 | (l[19773] << 16 | l[19774] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[19767] | l[19768] << 8 | (l[19769] << 16 | l[19770] << 24), k = l[19763] | l[19764] << 8 | (l[19765] << 16 | l[19766] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[19759] | l[19760] << 8 | (l[19761] << 16 | l[19762] << 24), k = l[19755] | l[19756] << 8 | (l[19757] << 16 | l[19758] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[19751] | l[19752] << 8 | (l[19753] << 16 | l[19754] << 24), k = l[19747] | l[19748] << 8 | (l[19749] << 16 | l[19750] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 57 | 0] = 0, e = i0(s + 20 | 0, 5, 2006, s + 8 | 0), o[s + 19 | 0] < 0 && X(i[s + 8 >> 2]), j0(A, e, i[r >> 2]), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    e = s + 20 | 0, t9(e, i[r >> 2], f, s + 40 | 0);
                                    r: {
                                        if (i[s + 20 >> 2] != i[21668]) {
                                            j0(A, e, i[r >> 2]);
                                            break r;
                                        }
                                        A: {
                                            if (!u) break A;
                                            k = D(16), e = k, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[u >> 2] = e, n = i[s + 40 >> 2], f = i[s + 44 >> 2];
                                            f: {
                                                if (!f) {
                                                    i[e + 4 >> 2] = f, i[e >> 2] = n;
                                                    break f;
                                                }
                                                if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, i[k >> 2] = n, e = i[k + 4 >> 2], i[k + 4 >> 2] = f, !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break f;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            if (k = i[r >> 2], e = i[u >> 2], f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 8 >> 2] = k, r = i[e + 12 >> 2], i[e + 12 >> 2] = f, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                    }
                                    o[s + 39 | 0] < 0 && X(i[s + 28 >> 2]), n = i[s + 44 >> 2];
                                }
                                if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            o[s + 75 | 0] < 0 && X(i[s + 64 >> 2]), A = i[s + 52 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = s + 112 | 0;
                        }
                        function H7(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (i[A >> 2] = 48848, r = i[A + 3212 >> 2], e = i[A + 3208 >> 2], (r | 0) != (e | 0)) for(; f = i[r - 4 >> 2], f && (X(rn(f)), e = i[A + 3208 >> 2], r = i[A + 3212 >> 2]), r = r - 4 | 0, i[A + 3212 >> 2] = r, (r | 0) != (e | 0););
                            if (e && (i[A + 3212 >> 2] = e, X(e)), e = 0, r = A + 2140 | 0, f = i[r + 12 >> 2], k = i[r + 8 >> 2], (f | 0) != (k | 0)) for(; n = i[(e << 2) + k >> 2], n && (X(K3(n)), k = i[r + 8 >> 2], f = i[r + 12 >> 2]), e = e + 1 | 0, e >>> 0 < f - k >> 2 >>> 0;);
                            c3(r + 32 | 0), e = i[r + 20 >> 2], e && (i[r + 24 >> 2] = e, X(e)), e = i[r + 8 >> 2], e && (i[r + 12 >> 2] = e, X(e)), c3(A + 1396 | 0), r = i[A + 1388 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 1380 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 1372 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            for(f = A + 4 | 0, r = 1368;;){
                                r = r - 8 | 0, e = i[f + r >> 2];
                                i: {
                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if ((r | 0) == 856) break;
                            }
                            r = i[A + 852 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 844 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 836 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 828 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 820 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 812 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 804 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 796 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 788 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 780 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 772 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 764 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 756 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 748 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 740 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 732 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 724 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 716 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 708 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 700 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 692 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 684 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 676 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 668 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 660 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 652 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 644 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 636 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 628 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 620 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 612 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 604 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (r = A + 548 | 0, e = i[r + 32 >> 2], e) for(; n = i[r + 16 >> 2], f = i[r + 28 >> 2], k = i[i[n + (f >>> 8 & 16777212) >> 2] + ((f & 1023) << 2) >> 2], i[r + 32 >> 2] = e - 1, e = f + 1 | 0, i[r + 28 >> 2] = e, e >>> 0 >= 2048 && (X(i[n >> 2]), i[r + 16 >> 2] = i[r + 16 >> 2] + 4, i[r + 28 >> 2] = i[r + 28 >> 2] - 1024), i[r + 36 >> 2] = i[r + 36 >> 2] - i[k + 24 >> 2], w4(r, k), e = i[r + 32 >> 2], !!e;);
                            if (e = i[r + 8 >> 2], e && w4(r, e), e = i[r + 40 >> 2], n = i[r + 44 >> 2], (e | 0) != (n | 0)) for(f = 0; k = i[(f << 2) + e >> 2], k && (X(i[k + 20 >> 2]), e = i[k + 32 >> 2], e && (i[k + 36 >> 2] = e, X(e)), X(k), n = i[r + 44 >> 2], e = i[r + 40 >> 2]), f = f + 1 | 0, f >>> 0 < n - e >> 2 >>> 0;);
                            return e && (i[r + 44 >> 2] = e, X(e)), c3(r + 12 | 0), A | 0;
                        }
                        function fi(A, r, e, f, k, n, t, u, s, h, w, v, _, B, G) {
                            var W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            i: {
                                e: {
                                    if (y = i[A + 18588 >> 2], W = i[y + 168 >> 2], V = r >> W, (V | 0) < 0) break e;
                                    R = A + 18548 | 0, E = e >> W;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            for(;;){
                                                                if (W = i[y + 172 >> 2], (W | 0) <= (V | 0)) break e;
                                                                if ((E | 0) < 0 | i[y + 176 >> 2] <= (E | 0)) break i;
                                                                if (V = (i[y + 160 >> 2] + Z(V, 3) | 0) + Z(Z(W, E), 3) | 0, C = l[V | 0] | l[V + 1 | 0] << 8, E = C >>> 8 & 3, (E | 0) != (_ | 0)) break n;
                                                                V = !s;
                                                                o: {
                                                                    s: {
                                                                        F = i[y + 124 >> 2], W = i[F + 16940 >> 2];
                                                                        u: {
                                                                            if (!((W | 0) < (u | 0) | (s | 0) >= (w | 0) | (V & (v | 0) != 0 | i[F + 16936 >> 2] >= (u | 0)))) {
                                                                                if (u - 3 >>> 0 >= 3) break k;
                                                                                C = s2(R, (i[A + 18572 >> 2] - u | 0) + 25 | 0);
                                                                                break u;
                                                                            }
                                                                            if (V & (v | 0) == 1 | (u | 0) > (W | 0)) break s;
                                                                            C = !(i[F + 628 >> 2] | s) & (E | 0) == 1 & (C & 56) != 0;
                                                                        }
                                                                        if (C) break s;
                                                                        C = 1;
                                                                        break o;
                                                                    }
                                                                    if (W = i[y + 248 >> 2], V = r >> W, (V | 0) < 0 || (C = i[y + 252 >> 2], (C | 0) <= (V | 0))) break f;
                                                                    if (W = e >> W, (W | 0) < 0 | (W | 0) >= i[y + 256 >> 2]) break A;
                                                                    V = (V + i[y + 240 >> 2] | 0) + Z(W, C) | 0, o[V | 0] = l[V | 0] | 1 << s, C = 0;
                                                                }
                                                                W = i[F + 16848 >> 2];
                                                                o: {
                                                                    s: {
                                                                        if (!((W | 0) != 0 & (u | 0) > 2) && (V = -1, (W | 0) != 3)) break s;
                                                                        V = -1, W = -1;
                                                                        u: {
                                                                            if (!(B & 255) || (W = s2(R, (i[A + 18572 >> 2] + s | 0) + 16 | 0), (C ^ 1) & (u | 0) != 3 | i[F + 16848 >> 2] != 2)) break u;
                                                                            W = s2(R, (i[A + 18572 >> 2] + s | 0) + 16 | 0) << 1 | W;
                                                                        }
                                                                        u: {
                                                                            if (!(G & 255) || (V = s2(R, (i[A + 18572 >> 2] + s | 0) + 16 | 0), (C ^ 1) & (u | 0) != 3 | i[F + 16848 >> 2] != 2)) break u;
                                                                            V = s2(R, (i[A + 18572 >> 2] + s | 0) + 16 | 0) << 1 | V;
                                                                        }
                                                                        if ((W | 0) >= 0) break o;
                                                                    }
                                                                    if (W = (u | 0) == 2, W & !s) break r;
                                                                    W = W && (s | 0) > 0 ? B & 255 : 0;
                                                                }
                                                                if ((V | 0) < 0 && (V = (u | 0) == 2 && (s | 0) > 0 ? G & 255 : 0), C) break t;
                                                                if (u = u - 1 | 0, s = s + 1 | 0, f = W & 255, k = V & 255, fi(A, r, e, r, e, n, t, u, s, 0, w, v, _, f, k), h = 1 << u, F = h + r | 0, fi(A, F, e, r, e, n, t, u, s, 1, w, v, _, f, k), C = e + h | 0, fi(A, r, C, r, e, n, t, u, s, 2, w, v, _, f, k), y = i[A + 18588 >> 2], M = i[y + 168 >> 2], E = C >> M, h = 3, G = V, B = W, k = e, f = r, e = C, r = F, V = r >> M, !((V | 0) >= 0)) break;
                                                            }
                                                            break e;
                                                        }
                                                        t: {
                                                            if (E && (w = 1, !(s | W | V))) break t;
                                                            w = s2(R, i[A + 18572 >> 2] + (s ? 14 : 15) | 0);
                                                        }
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    if ((W | 0) != -1) {
                                                                        if ((V | 0) == -1) break s;
                                                                        if ((w | 0) == -1) break o;
                                                                        if (v = i[A + 18588 >> 2], B = i[v + 124 >> 2], G = i[B + 16848 >> 2], o[A + 33 | 0] = 0, o[A + 34 | 0] = 0, o[A + 35 | 0] = 0, o[A + 36 | 0] = 0, _ = i[v + 168 >> 2], s = r >> _, (s | 0) < 0 || (C = i[v + 172 >> 2], (C | 0) <= (s | 0))) break e;
                                                                        if (_ = e >> _, (_ | 0) < 0 | (_ | 0) >= i[v + 176 >> 2]) break i;
                                                                        F = u - ((G | 0) != 3) | 0, y = (F | 0) > 2, R = l[((i[v + 160 >> 2] + Z(s, 3) | 0) + Z(Z(_, C), 3) | 0) + 1 | 0], E = V | W;
                                                                        u: {
                                                                            if (!(E | w)) break u;
                                                                            if (s = 0, !(i[A + 18500 >> 2] | !l[i[v + 132 >> 2] + 26 | 0])) {
                                                                                C = A + 18548 | 0;
                                                                                w: {
                                                                                    if (!s2(C, i[A + 18572 >> 2] + 139 | 0)) {
                                                                                        _ = 0, v = 0;
                                                                                        break w;
                                                                                    }
                                                                                    l: {
                                                                                        if (!s2(C, i[A + 18572 >> 2] + 140 | 0)) {
                                                                                            s = 1;
                                                                                            break l;
                                                                                        }
                                                                                        if (!s2(C, i[A + 18572 >> 2] + 140 | 0)) {
                                                                                            s = 2;
                                                                                            break l;
                                                                                        }
                                                                                        if (!s2(C, i[A + 18572 >> 2] + 140 | 0)) {
                                                                                            s = 3;
                                                                                            break l;
                                                                                        }
                                                                                        if (!s2(C, i[A + 18572 >> 2] + 140 | 0)) {
                                                                                            s = 4;
                                                                                            break l;
                                                                                        }
                                                                                        if (_ = 0, s = T3(C, 0) + 5 | 0, v = 0, !s) break w;
                                                                                    }
                                                                                    _ = s, v = S1(C);
                                                                                }
                                                                                i[A + 18500 >> 2] = 1, i[A + 18504 >> 2] = Z(_, 1 - (v << 1) | 0), s = 1;
                                                                            }
                                                                            w: {
                                                                                l: {
                                                                                    h: {
                                                                                        if (!(!E | !l[i[A + 18592 >> 2] + 760 | 0] | (l[A + 32 | 0] | i[A + 18508 >> 2]))) {
                                                                                            s = A + 18548 | 0, v = s2(s, i[A + 18572 >> 2] + 23 | 0), _ = i[i[A + 18588 >> 2] + 132 >> 2];
                                                                                            v: {
                                                                                                if (!(!v | l[_ + 8250 | 0] < 2)) {
                                                                                                    s = s2(s, i[A + 18572 >> 2] + 24 | 0), i[A + 18508 >> 2] = 1;
                                                                                                    break v;
                                                                                                }
                                                                                                if (i[A + 18508 >> 2] = 1, s = 0, !v) break h;
                                                                                            }
                                                                                            s = s + _ | 0, i[A + 18512 >> 2] = o[s + 8251 | 0], s = o[s + 8257 | 0];
                                                                                            break l;
                                                                                        }
                                                                                        if (s) break w;
                                                                                        break u;
                                                                                    }
                                                                                    i[A + 18512 >> 2] = 0, s = 0;
                                                                                }
                                                                                i[A + 18516 >> 2] = s;
                                                                            }
                                                                            c7(A, n, t);
                                                                        }
                                                                        n = i[B + 16856 >> 2], s = i[B + 16852 >> 2], i[A + 28 >> 2] = 0, w && v8(A, r, e, u, 0), C = y ? F : 2, v = 1 << C, _ = 1 << u, t = R & 3, w8(A, r, e, _, 0, t, (w | 0) != 0);
                                                                        u: {
                                                                            if (!((G | 0) != 3 & (u | 0) <= 2)) {
                                                                                f = 0, k = 0;
                                                                                w: {
                                                                                    if (!w || (u = i[A + 18588 >> 2], k = 0, !(o[i[u + 132 >> 2] + 8247 | 0] & 1))) break w;
                                                                                    if ((t | 0) != 1) {
                                                                                        if (f = i[u + 228 >> 2], h = r >> f, (h | 0) < 0 || (_ = i[u + 232 >> 2], (_ | 0) <= (h | 0))) break e;
                                                                                        if (w = e >> f, (w | 0) < 0 | (w | 0) >= i[u + 236 >> 2]) break i;
                                                                                        if (f = 0, k = 0, o[(h + i[u + 220 >> 2] | 0) + Z(w, _) | 0] >= 0) break w;
                                                                                    }
                                                                                    if (u = A + 18548 | 0, k = 1, !s2(u, i[A + 18572 >> 2] + 162 | 0)) break w;
                                                                                    f = 0;
                                                                                    l: {
                                                                                        if (!s2(u, i[A + 18572 >> 2] + 163 | 0) || (f = 1, !s2(u, i[A + 18572 >> 2] + 164 | 0))) break l;
                                                                                        f = s2(u, i[A + 18572 >> 2] + 165 | 0) ? 3 : 2;
                                                                                    }
                                                                                    f = 1 - (s2(u, i[A + 18572 >> 2] + 170 | 0) << 1) << f, k = 1;
                                                                                }
                                                                                i[A + 28 >> 2] = f, f = W & 1, f && v8(A, r, e, C, 1), i[B + 16848 >> 2] && w8(A, (r | 0) / (s | 0) | 0, (e | 0) / (n | 0) | 0, v, 1, t, f), (G | 0) == 2 && (f = W & 2, f && v8(A, r, (n << C) + e | 0, C, 1), w8(A, (r | 0) / (s | 0) | 0, v + ((e | 0) / (n | 0) | 0) | 0, v, 1, t, (f | 0) != 0)), f = 0;
                                                                                w: {
                                                                                    if (!k || (k = A + 18548 | 0, !s2(k, i[A + 18572 >> 2] + 166 | 0))) break w;
                                                                                    f = 0;
                                                                                    l: {
                                                                                        if (!s2(k, i[A + 18572 >> 2] + 167 | 0) || (f = 1, !s2(k, i[A + 18572 >> 2] + 168 | 0))) break l;
                                                                                        f = s2(k, i[A + 18572 >> 2] + 169 | 0) ? 3 : 2;
                                                                                    }
                                                                                    f = 1 - (s2(k, i[A + 18572 >> 2] + 171 | 0) << 1) << f;
                                                                                }
                                                                                if (i[A + 28 >> 2] = f, f = V & 1, f && v8(A, r, e, C, 2), i[B + 16848 >> 2] && w8(A, (r | 0) / (s | 0) | 0, (e | 0) / (n | 0) | 0, v, 2, t, f), (G | 0) != 2) break u;
                                                                                f = V & 2, f && v8(A, r, (n << C) + e | 0, C, 2), w8(A, (r | 0) / (s | 0) | 0, v + ((e | 0) / (n | 0) | 0) | 0, v, 2, t, (f | 0) != 0);
                                                                                break t;
                                                                            }
                                                                            if ((h | 0) != 3 || (r = W & 1, r && v8(A, f, k, u, 1), i[B + 16848 >> 2] && w8(A, (f | 0) / (s | 0) | 0, (k | 0) / (n | 0) | 0, _, 1, t, r), r = W & 2, r && v8(A, f, k + _ | 0, u, 1), (G | 0) == 2 && w8(A, (f | 0) / (s | 0) | 0, _ + ((k | 0) / (n | 0) | 0) | 0, _, 1, t, (r | 0) != 0), r = V & 1, r && v8(A, f, k, u, 2), i[B + 16848 >> 2] && w8(A, (f | 0) / (s | 0) | 0, (k | 0) / (n | 0) | 0, _, 2, t, r), r = V & 2, r && v8(A, f, k + v | 0, u, 2), (G | 0) != 2)) break u;
                                                                            w8(A, (f | 0) / (s | 0) | 0, _ + ((k | 0) / (n | 0) | 0) | 0, _, 2, t, (r | 0) != 0);
                                                                        }
                                                                        break t;
                                                                    }
                                                                    y0(18203, 15050, 3575, 3439), z();
                                                                }
                                                                y0(18190, 15050, 3576, 3439), z();
                                                            }
                                                            y0(18216, 15050, 3577, 3439), z();
                                                        }
                                                        return;
                                                    }
                                                    y0(12337, 15050, 3857, 12232), z();
                                                }
                                                y0(17980, 15050, 1834, 9274), z();
                                            }
                                            y0(4105, 9012, 128, 3731), z();
                                        }
                                        y0(4067, 9012, 129, 3731), z();
                                    }
                                    y0(20537, 15050, 3924, 12232), z();
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function ch(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            f = m - 96 | 0, m = f;
                            i: {
                                e: {
                                    n = _n(p[i[i[r >> 2] + 8 >> 2]](r) | 0, i[e + 24 >> 2]);
                                    r: {
                                        if (!n) {
                                            o[f + 24 | 0] = 0, o[f + 35 | 0] = 0, e = i0(f + 48 | 0, 11, 6003, f + 24 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 4 >> 2], i[A + 8 >> 2] = i[e >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                            A: {
                                                if (o[e + 19 | 0] >= 0) {
                                                    A = i[e + 12 >> 2], i[r >> 2] = i[e + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[e + 16 >> 2];
                                                    break A;
                                                }
                                                if (j(r, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break A;
                                                X(i[e + 8 >> 2]);
                                            }
                                            if (o[f + 35 | 0] >= 0) break r;
                                            X(i[f + 24 >> 2]);
                                            break r;
                                        }
                                        if (k = i[n + 20 >> 2], !k) {
                                            k = D(48), i[f + 24 >> 2] = k, i[f + 28 >> 2] = 43, i[f + 32 >> 2] = -2147483600, r = l[19281] | l[19282] << 8 | (l[19283] << 16 | l[19284] << 24), o[k + 39 | 0] = r, o[k + 40 | 0] = r >>> 8, o[k + 41 | 0] = r >>> 16, o[k + 42 | 0] = r >>> 24, e = l[19278] | l[19279] << 8 | (l[19280] << 16 | l[19281] << 24), r = l[19274] | l[19275] << 8 | (l[19276] << 16 | l[19277] << 24), o[k + 32 | 0] = r, o[k + 33 | 0] = r >>> 8, o[k + 34 | 0] = r >>> 16, o[k + 35 | 0] = r >>> 24, o[k + 36 | 0] = e, o[k + 37 | 0] = e >>> 8, o[k + 38 | 0] = e >>> 16, o[k + 39 | 0] = e >>> 24, e = l[19270] | l[19271] << 8 | (l[19272] << 16 | l[19273] << 24), r = l[19266] | l[19267] << 8 | (l[19268] << 16 | l[19269] << 24), o[k + 24 | 0] = r, o[k + 25 | 0] = r >>> 8, o[k + 26 | 0] = r >>> 16, o[k + 27 | 0] = r >>> 24, o[k + 28 | 0] = e, o[k + 29 | 0] = e >>> 8, o[k + 30 | 0] = e >>> 16, o[k + 31 | 0] = e >>> 24, e = l[19262] | l[19263] << 8 | (l[19264] << 16 | l[19265] << 24), r = l[19258] | l[19259] << 8 | (l[19260] << 16 | l[19261] << 24), o[k + 16 | 0] = r, o[k + 17 | 0] = r >>> 8, o[k + 18 | 0] = r >>> 16, o[k + 19 | 0] = r >>> 24, o[k + 20 | 0] = e, o[k + 21 | 0] = e >>> 8, o[k + 22 | 0] = e >>> 16, o[k + 23 | 0] = e >>> 24, e = l[19254] | l[19255] << 8 | (l[19256] << 16 | l[19257] << 24), r = l[19250] | l[19251] << 8 | (l[19252] << 16 | l[19253] << 24), o[k + 8 | 0] = r, o[k + 9 | 0] = r >>> 8, o[k + 10 | 0] = r >>> 16, o[k + 11 | 0] = r >>> 24, o[k + 12 | 0] = e, o[k + 13 | 0] = e >>> 8, o[k + 14 | 0] = e >>> 16, o[k + 15 | 0] = e >>> 24, e = l[19246] | l[19247] << 8 | (l[19248] << 16 | l[19249] << 24), r = l[19242] | l[19243] << 8 | (l[19244] << 16 | l[19245] << 24), o[k | 0] = r, o[k + 1 | 0] = r >>> 8, o[k + 2 | 0] = r >>> 16, o[k + 3 | 0] = r >>> 24, o[k + 4 | 0] = e, o[k + 5 | 0] = e >>> 8, o[k + 6 | 0] = e >>> 16, o[k + 7 | 0] = e >>> 24, o[k + 43 | 0] = 0, e = i0(f + 48 | 0, 11, 6003, f + 24 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 4 >> 2], i[A + 8 >> 2] = i[e >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                            A: {
                                                if (o[e + 19 | 0] >= 0) {
                                                    A = i[e + 12 >> 2], i[r >> 2] = i[e + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[e + 16 >> 2];
                                                    break A;
                                                }
                                                if (j(r, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break A;
                                                X(i[e + 8 >> 2]);
                                            }
                                            if (o[f + 35 | 0] >= 0) break r;
                                            X(i[f + 24 >> 2]);
                                            break r;
                                        }
                                        if (p[k | 0](f + 80 | 0, f + 92 | 0), s = i[f + 80 >> 2], s) {
                                            if (n = i[f + 84 >> 2], k = i[f + 88 >> 2], t = E2(k), t >>> 0 >= 2147483640) break e;
                                            A: {
                                                f: {
                                                    if (t >>> 0 >= 11) {
                                                        e = (t | 7) + 1 | 0, r = D(e), i[f + 32 >> 2] = e | -2147483648, i[f + 24 >> 2] = r, i[f + 28 >> 2] = t;
                                                        break f;
                                                    }
                                                    if (o[f + 35 | 0] = t, r = f + 24 | 0, !t) break A;
                                                }
                                                Q0(r, k, t);
                                            }
                                            o[r + t | 0] = 0, e = i0(f + 48 | 0, s, n, f + 24 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 4 >> 2], i[A + 8 >> 2] = i[e >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                            A: {
                                                if (o[e + 19 | 0] >= 0) {
                                                    A = i[e + 12 >> 2], i[r >> 2] = i[e + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[e + 16 >> 2];
                                                    break A;
                                                }
                                                if (j(r, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break A;
                                                X(i[e + 8 >> 2]);
                                            }
                                            if (o[f + 35 | 0] >= 0) break r;
                                            X(i[f + 24 >> 2]);
                                            break r;
                                        }
                                        t = i[n + 24 >> 2], h = i[f + 92 >> 2];
                                        A: {
                                            if (i[n >> 2] < 2 || (k = i[n + 36 >> 2], !k)) break A;
                                            p[k | 0](h, l[e + 21 | 0]);
                                        }
                                        Xe(f + 48 | 0, r);
                                        A: {
                                            if (i[f + 60 >> 2]) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 64 >> 2], i[A + 8 >> 2] = i[f + 60 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 79 | 0] >= 0) {
                                                    A = i[f + 72 >> 2], i[r >> 2] = i[f + 68 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 76 >> 2];
                                                    break A;
                                                }
                                                j(r, i[f + 68 >> 2], i[f + 72 >> 2]);
                                                break A;
                                            }
                                            if (r = i[f + 48 >> 2], p[i[n + 28 >> 2]](f + 24 | 0, i[f + 92 >> 2], r, i[f + 52 >> 2] - r | 0), i[f + 88 >> 2] = i[f + 32 >> 2], r = i[f + 28 >> 2], e = i[f + 24 >> 2], i[f + 80 >> 2] = e, i[f + 84 >> 2] = r, e) {
                                                if (s = i[f + 84 >> 2], n = i[f + 88 >> 2], u = E2(n), u >>> 0 >= 2147483640) break i;
                                                f: {
                                                    k: {
                                                        if (u >>> 0 >= 11) {
                                                            k = (u | 7) + 1 | 0, r = D(k), i[f + 20 >> 2] = k | -2147483648, i[f + 12 >> 2] = r, i[f + 16 >> 2] = u;
                                                            break k;
                                                        }
                                                        if (o[f + 23 | 0] = u, r = f + 12 | 0, !u) break f;
                                                    }
                                                    Q0(r, n, u);
                                                }
                                                o[r + u | 0] = 0, e = i0(f + 24 | 0, e, s, f + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 4 >> 2], i[A + 8 >> 2] = i[e >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                f: {
                                                    if (o[e + 19 | 0] >= 0) {
                                                        A = i[e + 12 >> 2], i[r >> 2] = i[e + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[e + 16 >> 2];
                                                        break f;
                                                    }
                                                    if (j(r, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break f;
                                                    X(i[e + 8 >> 2]);
                                                }
                                                if (o[f + 23 | 0] >= 0) break A;
                                                X(i[f + 12 >> 2]);
                                                break A;
                                            }
                                            if (i[f + 8 >> 2] = 0, k = f + 24 | 0, p[i[n + 32 >> 2]](k, i[f + 92 >> 2], f + 8 | 0), i[f + 88 >> 2] = i[f + 32 >> 2], e = i[f + 28 >> 2], r = i[f + 24 >> 2], i[f + 80 >> 2] = r, i[f + 84 >> 2] = e, r) {
                                                n = i[f + 84 >> 2], e = a1(f + 12 | 0, i[f + 88 >> 2]), k = i0(k, r, n, e), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[k + 4 >> 2], i[A + 8 >> 2] = i[k >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                f: {
                                                    if (o[k + 19 | 0] >= 0) {
                                                        A = i[k + 12 >> 2], i[r >> 2] = i[k + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[k + 16 >> 2];
                                                        break f;
                                                    }
                                                    if (j(r, i[k + 8 >> 2], i[k + 12 >> 2]), o[k + 19 | 0] >= 0) break f;
                                                    X(i[k + 8 >> 2]);
                                                }
                                                if (o[e + 11 | 0] >= 0) break A;
                                                X(i[e >> 2]);
                                                break A;
                                            }
                                            if (r = i[f + 8 >> 2], !r) {
                                                e = a1(f + 12 | 0, 34896), k = i0(f + 24 | 0, 7, 0, e), i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[k + 4 >> 2], i[A + 8 >> 2] = i[k >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                                f: {
                                                    if (o[k + 19 | 0] >= 0) {
                                                        A = i[k + 12 >> 2], i[r >> 2] = i[k + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[k + 16 >> 2];
                                                        break f;
                                                    }
                                                    if (j(r, i[k + 8 >> 2], i[k + 12 >> 2]), o[k + 19 | 0] >= 0) break f;
                                                    X(i[k + 8 >> 2]);
                                                }
                                                if (o[e + 11 | 0] >= 0) break A;
                                                X(i[e >> 2]);
                                                break A;
                                            }
                                            i[f + 24 >> 2] = i[r >> 2], i[f + 28 >> 2] = i[r + 4 >> 2], i[r >> 2] = 0, i[r + 4 >> 2] = 0, p4(i[f + 8 >> 2]), r = A, A = f + 24 | 0, S9(r, A), B1(A);
                                        }
                                        if (o[f + 79 | 0] < 0 && X(i[f + 68 >> 2]), A = i[f + 48 >> 2], A && (i[f + 52 >> 2] = A, X(A)), !h) break r;
                                        p[t | 0](h);
                                    }
                                    m = f + 96 | 0;
                                    return;
                                }
                                Y0(), z();
                            }
                            Y0(), z();
                        }
                        function iw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            f = m - 128 | 0, m = f, r = i[e >> 2], W = i[r + 28 >> 2], v = i[r + 24 >> 2], n = D(136), i[n >> 2] = 78252, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, B0(n + 20 | 0, 0, 104), s = i[n + 4 >> 2], u = s + 1 | 0, i[n + 4 >> 2] = u, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 44 >> 2] = 99, i[n + 48 >> 2] = 99, i[n + 32 >> 2] = 4142, r = n - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, r = n + 76 | 0, i[n + 72 >> 2] = r, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, B = n + 12 | 0, i[n + 12 >> 2] = B, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = s, i[n + 16 >> 2] = n, u || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), i[B + 36 >> 2] = 3, i[B + 32 >> 2] = 0, i[B + 28 >> 2] = W, i[B + 24 >> 2] = v, w = l[k + 8 | 0], s = i[i[e >> 2] + 36 >> 2], J0(f + 56 | 0, B, 0, v, W, 8, t), J0(f + 32 | 0, B, 1, v, W, 8, t), h = f + 88 | 0;
                            i: {
                                if (i[f + 56 >> 2]) {
                                    if (k = i[f + 60 >> 2], i[f + 80 >> 2] = i[f + 56 >> 2], i[f + 84 >> 2] = k, o[f + 75 | 0] >= 0) {
                                        u = f - -64 | 0, k = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    j(h, i[f + 64 >> 2], i[f + 68 >> 2]);
                                    break i;
                                }
                                if (k = i[f + 36 >> 2], i[f + 80 >> 2] = i[f + 32 >> 2], i[f + 84 >> 2] = k, o[f + 51 | 0] >= 0) {
                                    k = i[f + 44 >> 2], i[h >> 2] = i[f + 40 >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[f + 48 >> 2];
                                    break i;
                                }
                                j(h, i[f + 40 >> 2], i[f + 44 >> 2]);
                            }
                            J0(f + 8 | 0, B, 2, v, W, 8, t), u = f + 112 | 0;
                            i: {
                                if (i[f + 80 >> 2]) {
                                    if (k = i[f + 84 >> 2], i[f + 104 >> 2] = i[f + 80 >> 2], i[f + 108 >> 2] = k, o[f + 99 | 0] >= 0) {
                                        k = i[h + 4 >> 2], i[u >> 2] = i[h >> 2], i[u + 4 >> 2] = k, i[u + 8 >> 2] = i[h + 8 >> 2];
                                        break i;
                                    }
                                    j(u, i[f + 88 >> 2], i[f + 92 >> 2]);
                                    break i;
                                }
                                if (k = i[f + 12 >> 2], i[f + 104 >> 2] = i[f + 8 >> 2], i[f + 108 >> 2] = k, o[f + 27 | 0] >= 0) {
                                    k = i[f + 20 >> 2], i[u >> 2] = i[f + 16 >> 2], i[u + 4 >> 2] = k, i[u + 8 >> 2] = i[f + 24 >> 2];
                                    break i;
                                }
                                j(u, i[f + 16 >> 2], i[f + 20 >> 2]);
                            }
                            o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), o[f + 99 | 0] < 0 && X(i[f + 88 >> 2]), o[f + 51 | 0] < 0 && X(i[f + 40 >> 2]), o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]);
                            i: {
                                if (i[f + 104 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                        A = i[u + 4 >> 2], i[r >> 2] = i[u >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    if (j(r, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                    X(i[f + 112 >> 2]);
                                    break i;
                                }
                                o[f + 123 | 0] < 0 && X(i[f + 112 >> 2]);
                                e: {
                                    if (!(w & 1)) break e;
                                    if (J0(f + 104 | 0, B, 6, v, W, 8, t), i[f + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                            A = i[f + 116 >> 2], i[r >> 2] = i[f + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 120 >> 2];
                                            break i;
                                        }
                                        if (j(r, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                        X(i[f + 112 >> 2]);
                                        break i;
                                    }
                                    if (o[f + 123 | 0] >= 0) break e;
                                    X(i[f + 112 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (e = i[e >> 2], t = i[e + 64 >> 2], !t) break r;
                                        for(u = e - -64 | 0, k = u; e = i[t + 16 >> 2] < 10, k = e ? k : t, t = i[(e << 2) + t >> 2], !!t;);
                                        if ((k | 0) == (u | 0)) break r;
                                        if (u = 0, i[k + 16 >> 2] > 10) break e;
                                        S = i[k + 52 >> 2], u = i[k + 44 >> 2];
                                        break e;
                                    }
                                    u = 0;
                                }
                                e: {
                                    r: {
                                        if (k = i[r >> 2], k) {
                                            for(e = r, t = k; _ = i[t + 16 >> 2], e = (_ | 0) < 0 ? e : t, t = i[(_ >>> 29 & 4) + t >> 2], !!t;);
                                            y = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (y = 0, i[e + 16 >> 2] > 0)) break A;
                                                P = i[e + 52 >> 2], y = i[e + 44 >> 2];
                                            }
                                            for(e = r, t = k; _ = i[t + 16 >> 2] <= 0, e = _ ? e : t, t = i[(_ << 2) + t >> 2], !!t;);
                                            F = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (F = 0, i[e + 16 >> 2] > 1)) break A;
                                                $ = i[e + 44 >> 2], F = i[e + 52 >> 2];
                                            }
                                            for(e = r, t = k; _ = i[t + 16 >> 2] < 2, e = _ ? e : t, t = i[(_ << 2) + t >> 2], !!t;);
                                            t = 0;
                                            A: {
                                                if ((r | 0) == (e | 0) || (t = 0, i[e + 16 >> 2] > 2)) break A;
                                                c = i[e + 52 >> 2], t = i[e + 44 >> 2];
                                            }
                                            if (_ = t, e = 0, !k || (e = 0, !(w & 1))) break e;
                                            for(t = r; e = i[k + 16 >> 2] < 6, t = e ? t : k, k = i[(e << 2) + k >> 2], !!k;);
                                            if ((r | 0) != (t | 0)) break r;
                                        }
                                        e = 0;
                                        break e;
                                    }
                                    if (e = 0, i[t + 16 >> 2] > 6) break e;
                                    M = i[t + 52 >> 2], e = i[t + 44 >> 2];
                                }
                                r = e;
                                e: {
                                    if (!W | !v) break e;
                                    if (C = (s | 0) == 11, H = C ? 4 : 3, w & 1) {
                                        for(G = u + 3 | 0, e = 0;;){
                                            r0 = Z(e, M), T = Z(e, S), f0 = Z(e, c) + _ | 0, E = Z(e, F) + $ | 0, R = Z(e, P) + y | 0, t = 0;
                                            r: {
                                                if (C) {
                                                    for(h = G + T | 0; w = Z(t, H), V = u + (w + T | 0) | 0, s = l[V | 0], k = l[V + 2 | 0], o[t + R | 0] = l[V + 1 | 0], o[t + E | 0] = k, o[t + f0 | 0] = s, o[r + (t + r0 | 0) | 0] = l[h + w | 0], t = t + 1 | 0, (v | 0) != (t | 0););
                                                    break r;
                                                }
                                                for(; w = u + (T + Z(t, H) | 0) | 0, s = l[w | 0], k = l[w + 2 | 0], o[t + R | 0] = l[w + 1 | 0], o[t + E | 0] = k, o[t + f0 | 0] = s, o[r + (t + r0 | 0) | 0] = 255, t = t + 1 | 0, (v | 0) != (t | 0););
                                            }
                                            if (e = e + 1 | 0, (W | 0) == (e | 0)) break;
                                        }
                                        break e;
                                    }
                                    for(h = v & -2, w = v & 1, e = 0;;){
                                        if (E = Z(e, S), R = Z(e, c) + _ | 0, V = Z(e, F) + $ | 0, M = Z(e, P) + y | 0, t = 0, r = 0, (v | 0) != 1) for(; G = u + (E + Z(t, H) | 0) | 0, s = l[G | 0], k = l[G + 2 | 0], o[t + M | 0] = l[G + 1 | 0], o[t + V | 0] = k, o[t + R | 0] = s, C = t | 1, G = u + (E + Z(C, H) | 0) | 0, s = l[G | 0], k = l[G + 2 | 0], o[M + C | 0] = l[G + 1 | 0], o[V + C | 0] = k, o[R + C | 0] = s, t = t + 2 | 0, r = r + 2 | 0, (h | 0) != (r | 0););
                                        if (w && (s = u + (E + Z(t, H) | 0) | 0, k = l[s | 0], r = l[s + 2 | 0], o[t + M | 0] = l[s + 1 | 0], o[t + V | 0] = r, o[t + R | 0] = k), e = e + 1 | 0, (W | 0) == (e | 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = n, i[A >> 2] = B, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = f + 128 | 0;
                        }
                        function ki(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0;
                            E = m - 128 | 0, m = E;
                            i: {
                                e: {
                                    r: {
                                        if (H = i[A + 140 >> 2], G = i[A + 152 >> 2], T = H + Z(Z(G, e), 24) | 0, _ = Z(r, 24), B = (T + _ | 0) + 4 | 0, w = f << 1, L = l[B | 0] >>> w & 3, !L) break r;
                                        if (R = Z(r, k), r = i[A + 148 >> 2], F = R >> r, (F | 0) < 0 | (G | 0) <= (F | 0)) break e;
                                        if (S = Z(e, n), y = S >> r, (y | 0) < 0 | (y | 0) >= i[A + 156 >> 2]) break i;
                                        if (V = i[A + 124 >> 2], W = i[V + (f ? 16840 : 16832) >> 2], e = -1 << W ^ -1, t0 = i[(f ? 36 : 28) + A >> 2], P = (t0 | 0) < (n + S | 0) ? t0 - S | 0 : n, s0 = i[(f ? 32 : 24) + A >> 2], $ = (s0 | 0) < (k + R | 0) ? s0 - R | 0 : k, c = f ? i[V + 16856 >> 2] - 1 | 0 : 0, r0 = f ? i[V + 16852 >> 2] - 1 | 0 : 0, V0 = l[(_ + T | 0) + 22 | 0], (L | 0) == 2) {
                                            if (T = i[A + 132 >> 2], W = i[A + 52 >> 2], F = i[i[W + (I[((H + Z(F, 24) | 0) + Z(Z(G, y), 24) | 0) + 2 >> 1] << 2) >> 2] + 808 >> 2], n = i[A + 56 >> 2], k = i[V + 16876 >> 2], y = i[V + 16892 >> 2], _ = l[B + 1 | 0], f = B + (f << 2) | 0, o[E | 0] = l[f + 5 | 0], B = l[f + 6 | 0], o[E + 2 | 0] = 0, o[E + 1 | 0] = B, o[E + 3 | 0] = l[f + 7 | 0], o[E + 4 | 0] = l[f + 8 | 0], (P | 0) <= 0 | ($ | 0) <= 0) break r;
                                            for(L = n - W >> 2, f = (_ >>> w & 3) << 2, I0 = i[f + 50424 >> 2], F0 = i[f + 50408 >> 2], q = k - r0 | 0, g0 = R >> q, k2 = P - 1 | 0, t2 = $ - 1 | 0, m0 = k - c | 0, R0 = Z(y, S >> m0), k = R << 1, v2 = k + s | 0, y2 = k + t | 0, D0 = i[A + 168 >> 2], H0 = i[f + 50440 >> 2], U2 = Z(H0, u) << 1, i2 = i[f + 50456 >> 2], H2 = Z(i2, u) << 1, f = 0;;){
                                                for(k = f + S | 0, t = k << c, n = t >> D0, j2 = (Z(k, h) << 1) + v2 | 0, K2 = (Z(k, u) << 1) + y2 | 0, s = t >> r, i1 = (H + Z(Z(s, G), 24) | 0) + 2 | 0, B = k + H0 | 0, Z0 = B << c >> r, v1 = (H + Z(Z(G, Z0), 24) | 0) + 2 | 0, _ = k + i2 | 0, X0 = _ << c >> r, p1 = (H + Z(Z(G, X0), 24) | 0) + 2 | 0, V1 = Z(y, _ >>> m0 | 0) << 2, y1 = Z(y, B >>> m0 | 0) << 2, I1 = (f | 0) == (k2 | 0), k = 0;;){
                                                    v = k + R | 0, M = v << r0, t = M >> D0;
                                                    A: {
                                                        f: {
                                                            if (!(!(V0 & 1) | !l[V + 8812 | 0])) {
                                                                if ((t | 0) < 0 || (w = i[A + 172 >> 2], (w | 0) <= (t | 0))) break e;
                                                                if ((n | 0) < 0 | (n | 0) >= i[A + 176 >> 2]) break i;
                                                                if (!(l[((i[A + 160 >> 2] + Z(t, 3) | 0) + Z(Z(n, w), 3) | 0) + 1 | 0] & 4)) break f;
                                                                break A;
                                                            }
                                                            if ((t | 0) < 0) break e;
                                                        }
                                                        if (w = i[A + 172 >> 2], (w | 0) <= (t | 0)) break e;
                                                        if ((n | 0) < 0 | (n | 0) >= i[A + 176 >> 2]) break i;
                                                        if (l[((i[A + 160 >> 2] + Z(t, 3) | 0) + Z(Z(n, w), 3) | 0) + 1 | 0] & 8) break A;
                                                        f: {
                                                            if (!(!f | !k | (k | 0) == (t2 | 0)) && !I1) break f;
                                                            if (t = v + I0 | 0, (t | 0) >= (s0 | 0) | (t | 0) < 0 | ((_ | 0) < 0 | (_ | 0) >= (t0 | 0))) break A;
                                                            if (C = t << r0 >> r, (C | 0) < 0 | (G | 0) <= (C | 0)) break e;
                                                            if ((X0 | 0) < 0 || (w = i[A + 156 >> 2], (w | 0) <= (X0 | 0))) break i;
                                                            if (C = I[Z(C, 24) + p1 >> 1], C >>> 0 >= L >>> 0 || (C = i[W + (C << 2) >> 2], !C)) break r;
                                                            M = M >> r, e2 = (M | 0) >= 0 & G >>> 0 > M >>> 0, M = Z(M, 24) + i1 | 0;
                                                            k: {
                                                                if (f0 = i[C + 808 >> 2], (f0 | 0) < (F | 0)) {
                                                                    if (!e2) break e;
                                                                    if ((s | 0) < 0 | (s | 0) >= (w | 0)) break k;
                                                                    if (!l[i[W + (I[M >> 1] << 2) >> 2] + 772 | 0]) break A;
                                                                }
                                                                if (!l[C + 772 | 0] & (F | 0) < (f0 | 0) || (C = l[T + 57 | 0], !C && (f0 = t >>> q << 2, t = i[T + 8484 >> 2], i[(f0 + t | 0) + V1 >> 2] != i[(t + (g0 << 2) | 0) + (R0 << 2) >> 2])) || (t = v + F0 | 0, (t | 0) >= (s0 | 0) | (t | 0) < 0 | ((B | 0) < 0 | (B | 0) >= (t0 | 0)))) break A;
                                                                if (v = t << r0 >> r, (v | 0) < 0 | (G | 0) <= (v | 0)) break e;
                                                                if ((Z0 | 0) < 0 | (w | 0) <= (Z0 | 0)) break i;
                                                                if (v = I[Z(v, 24) + v1 >> 1], v >>> 0 >= L >>> 0 || (v = i[W + (v << 2) >> 2], !v)) break r;
                                                                if (f0 = i[v + 808 >> 2], (f0 | 0) < (F | 0)) {
                                                                    if (!e2) break e;
                                                                    if ((s | 0) < 0 | (s | 0) >= (w | 0)) break k;
                                                                    if (!l[i[W + (I[M >> 1] << 2) >> 2] + 772 | 0]) break A;
                                                                }
                                                                if (!l[v + 772 | 0] & (F | 0) < (f0 | 0)) break A;
                                                                if (C || (w = t >>> q << 2, t = i[T + 8484 >> 2], i[(w + t | 0) + y1 >> 2] == i[(t + (g0 << 2) | 0) + (R0 << 2) >> 2])) break f;
                                                                break A;
                                                            }
                                                            break i;
                                                        }
                                                        v = k << 1, w = v + K2 | 0, t = I[w >> 1], C = v + j2 | 0, v = I[(w + (I0 << 1) | 0) + H2 >> 1], w = I[(w + (F0 << 1) | 0) + U2 >> 1], t = t + o[((t >>> 0 < v >>> 0 ? 1 : (v | 0) == (t | 0) ? 2 : 3) + (t >>> 0 < w >>> 0 ? -1 : (w | 0) != (t | 0)) | 0) + E | 0] | 0, Q[C >> 1] = (t | 0) >= 0 ? (e | 0) > (t | 0) ? t : e : 0;
                                                    }
                                                    if (k = k + 1 | 0, ($ | 0) == (k | 0)) break;
                                                }
                                                if (f = f + 1 | 0, (P | 0) == (f | 0)) break;
                                            }
                                            break r;
                                        }
                                        if (r = l[(f + B | 0) + 2 | 0], G = B0(E, 0, 128), i[((r & 31) << 2) + G >> 2] = 1, i[G + ((r + 1 & 31) << 2) >> 2] = 2, i[G + ((r + 2 & 31) << 2) >> 2] = 3, i[G + ((r + 3 & 31) << 2) >> 2] = 4, H = W - 5 | 0, !(V0 & 1)) {
                                            if ((P | 0) <= 0 | ($ | 0) <= 0 | (W | 0) > 12) break r;
                                            for(n = B + 5 | 0, V = (R << 1) + t | 0, r = 0;;){
                                                for(A = r + S | 0, B = (Z(A, h) << 1) + s | 0, A = Z(A, u) << 1, c = A + t | 0, r0 = A + V | 0, A = 0; k = I[r0 + (A << 1) >> 1], k = i[G + ((e >>> 0 > k >>> 0 ? k : e) >>> H << 2) >> 2], (k | 0) > 0 && (W = A + R << 1, k = I[W + c >> 1] + o[(k + (n + (f << 2) | 0) | 0) - 1 | 0] | 0, Q[B + W >> 1] = (k | 0) >= 0 ? (e | 0) > (k | 0) ? k : e : 0), A = A + 1 | 0, ($ | 0) > (A | 0););
                                                if (r = r + 1 | 0, !((P | 0) > (r | 0))) break;
                                            }
                                            break r;
                                        }
                                        if ((P | 0) <= 0 | ($ | 0) <= 0) break r;
                                        F = B + 5 | 0, B = i[A + 168 >> 2], t0 = l[V + 8812 | 0], W = (W | 0) > 12, V = 0;
                                        A: {
                                            for(;;){
                                                k = V + S | 0, r = k << c >> B, s0 = (Z(k, h) << 1) + s | 0, T = (Z(k, u) << 1) + t | 0, n = 0;
                                                f: {
                                                    for(;;){
                                                        y = n + R | 0, k = y << r0 >> B;
                                                        k: {
                                                            n: {
                                                                if (t0) {
                                                                    if ((k | 0) < 0 || (_ = i[A + 172 >> 2], (_ | 0) <= (k | 0))) break f;
                                                                    if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break i;
                                                                    if (!(l[((i[A + 160 >> 2] + Z(k, 3) | 0) + Z(Z(r, _), 3) | 0) + 1 | 0] & 4)) break n;
                                                                    break k;
                                                                }
                                                                if ((k | 0) < 0) break e;
                                                            }
                                                            if (_ = i[A + 172 >> 2], (_ | 0) <= (k | 0)) break e;
                                                            if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break A;
                                                            if (W | l[((i[A + 160 >> 2] + Z(k, 3) | 0) + Z(Z(r, _), 3) | 0) + 1 | 0] & 8 || (y = y << 1, k = I[y + T >> 1], _ = i[G + ((e >>> 0 > k >>> 0 ? k : e) >>> H << 2) >> 2], (_ | 0) <= 0)) break k;
                                                            k = k + o[(_ + (F + (f << 2) | 0) | 0) - 1 | 0] | 0, Q[y + s0 >> 1] = (k | 0) >= 0 ? (e | 0) > (k | 0) ? k : e : 0;
                                                        }
                                                        if (n = n + 1 | 0, !(($ | 0) > (n | 0))) break;
                                                    }
                                                    if (V = V + 1 | 0, (P | 0) <= (V | 0)) break r;
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        break i;
                                    }
                                    m = E + 128 | 0;
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function Z3(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            w = m + -64 | 0, m = w;
                            i: {
                                u = i[r + 36 >> 2];
                                e: {
                                    if (!(!(e & 1 & (u | 0) == 2) & (!((e | k) & 1) | (u | 0) != 1))) {
                                        if (i[w + 56 >> 2] = 0, i[w + 60 >> 2] = 0, i[w + 48 >> 2] = 0, i[w + 52 >> 2] = 0, o[w + 60 | 0] = 1, i[w + 52 >> 2] = 2, i[w + 56 >> 2] = 2, o[w + 48 | 0] = 1, i[w + 8 >> 2] = i[r >> 2], u = i[r + 4 >> 2], !u || (u = gi(u), i[w + 12 >> 2] = u, !u)) break i;
                                        i[w >> 2] = 0, i[w + 4 >> 2] = 0, u = 255, v = i[r + 64 >> 2];
                                        r: {
                                            if (!v) break r;
                                            for(_ = r - -64 | 0, s = _; r = i[v + 16 >> 2], s = (r | 0) < 0 ? s : v, v = i[(r >>> 29 & 4) + v >> 2], !!v;);
                                            if ((s | 0) == (_ | 0) | i[s + 16 >> 2] > 0) break r;
                                            u = l[s + 24 | 0];
                                        }
                                        s = m - 48 | 0, m = s, i[s + 40 >> 2] = i[w + 8 >> 2], r = i[w + 12 >> 2], i[s + 44 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), _ = w + 16 | 0, s6(s + 12 | 0, s + 40 | 0, 0, 3, w, u, w + 48 | 0, t);
                                        r: {
                                            if (i[s + 20 >> 2]) {
                                                if (i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, r = i[s + 24 >> 2], i[_ + 8 >> 2] = i[s + 20 >> 2], i[_ + 12 >> 2] = r, u = _ + 16 | 0, o[s + 39 | 0] >= 0) {
                                                    r = i[s + 32 >> 2], i[u >> 2] = i[s + 28 >> 2], i[u + 4 >> 2] = r, i[u + 8 >> 2] = i[s + 36 >> 2];
                                                    break r;
                                                }
                                                j(u, i[s + 28 >> 2], i[s + 32 >> 2]);
                                                break r;
                                            }
                                            r = i[s + 12 >> 2], v = i[s + 16 >> 2];
                                            A: {
                                                if (!v) {
                                                    i[_ + 4 >> 2] = 0, i[_ >> 2] = r;
                                                    break A;
                                                }
                                                i[v + 4 >> 2] = i[v + 4 >> 2] + 1, i[_ + 4 >> 2] = v, i[_ >> 2] = r, i[v + 4 >> 2] = i[v + 4 >> 2] + 1;
                                            }
                                            r = i[21669], i[_ + 8 >> 2] = i[21668], i[_ + 12 >> 2] = r, u = _ + 16 | 0;
                                            A: {
                                                if (o[86691] >= 0) {
                                                    r = i[21671], i[u >> 2] = i[21670], i[u + 4 >> 2] = r, i[u + 8 >> 2] = i[21672];
                                                    break A;
                                                }
                                                j(u, i[21670], i[21671]);
                                            }
                                            if (!v || (r = i[v + 4 >> 2], i[v + 4 >> 2] = r - 1, r)) break r;
                                            p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                        }
                                        o[s + 39 | 0] < 0 && X(i[s + 28 >> 2]), u = i[s + 16 >> 2];
                                        r: {
                                            if (!u || (r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        u = i[s + 44 >> 2];
                                        r: {
                                            if (!u || (r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        m = s + 48 | 0, u = i[w + 4 >> 2];
                                        r: {
                                            if (!u || (r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        u = i[w + 12 >> 2];
                                        r: {
                                            if (!u || (r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break r;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        r: {
                                            if (i[w + 24 >> 2]) {
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[w + 28 >> 2], i[A + 8 >> 2] = i[w + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[w + 43 | 0] >= 0) {
                                                    A = i[w + 36 >> 2], i[r >> 2] = i[w + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[w + 40 >> 2];
                                                    break r;
                                                }
                                                j(r, i[w + 32 >> 2], i[w + 36 >> 2]);
                                                break r;
                                            }
                                            Z3(A, i[w + 16 >> 2], e, f, k, n, t);
                                        }
                                        if (o[w + 43 | 0] < 0 && X(i[w + 32 >> 2]), r = i[w + 20 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        break e;
                                    }
                                    h = D(136), u = h, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 78252, B0(u + 20 | 0, 0, 104), s = i[u + 4 >> 2], v = s + 1 | 0, i[u + 4 >> 2] = v, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 44 >> 2] = 99, i[u + 48 >> 2] = 99, i[u + 32 >> 2] = 4142, u = u - -64 | 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[h + 132 >> 2] = 0, i[h + 124 >> 2] = 0, i[h + 128 >> 2] = 0, i[h + 84 >> 2] = 1, i[h + 88 >> 2] = 1, _ = h + 76 | 0, i[h + 72 >> 2] = _, i[h + 92 >> 2] = 0, i[h + 96 >> 2] = 0, i[h + 100 >> 2] = 0, i[h + 104 >> 2] = 0, i[h + 108 >> 2] = 0, i[h + 112 >> 2] = 0, o[h + 113 | 0] = 0, o[h + 114 | 0] = 0, o[h + 115 | 0] = 0, o[h + 116 | 0] = 0, o[h + 117 | 0] = 0, o[h + 118 | 0] = 0, o[h + 119 | 0] = 0, o[h + 120 | 0] = 0, V = h + 12 | 0, i[h + 12 >> 2] = V, i[h + 8 >> 2] = i[h + 8 >> 2] + 1, i[h + 4 >> 2] = s, i[h + 16 >> 2] = h, v || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), u = i[r + 36 >> 2], i[h + 44 >> 2] = i[r + 32 >> 2], i[h + 48 >> 2] = u, i[h + 40 >> 2] = (n - k | 0) + 1, i[h + 36 >> 2] = (f - e | 0) + 1, v = i[r + 60 >> 2], F = r - -64 | 0;
                                    r: {
                                        if ((v | 0) != (F | 0)) for(G = A + 16 | 0;;){
                                            B = i[v + 16 >> 2], E = ft(e, B, i[r + 36 >> 2], 2), u = ft(f, B, i[r + 36 >> 2], 1), W = kt(k, B, i[r + 36 >> 2], 2), R = (u - E | 0) + 1 | 0, y = kt(n, B, i[r + 36 >> 2], 1), F3(w + 16 | 0, V, B, R, (y - W | 0) + 1 | 0, i[v + 20 >> 2], l[v + 24 | 0], t), M = i[w + 16 >> 2];
                                            A: {
                                                if (M) {
                                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, u = i[w + 20 >> 2], i[A + 8 >> 2] = i[w + 16 >> 2], i[A + 12 >> 2] = u, o[w + 35 | 0] >= 0) {
                                                        A = i[w + 28 >> 2], i[G >> 2] = i[w + 24 >> 2], i[G + 4 >> 2] = A, i[G + 8 >> 2] = i[w + 32 >> 2];
                                                        break r;
                                                    }
                                                    j(G, i[w + 24 >> 2], i[w + 28 >> 2]);
                                                    break A;
                                                }
                                                u = _, s = i[u >> 2];
                                                f: {
                                                    k: {
                                                        if (!s) break k;
                                                        for(; C = (B | 0) > i[s + 16 >> 2], u = C ? u : s, s = i[(C << 2) + s >> 2], !!s;);
                                                        if ((u | 0) == (_ | 0)) break k;
                                                        if ((B | 0) >= i[u + 16 >> 2]) break f;
                                                    }
                                                    u = _;
                                                }
                                                s = l[v + 24 | 0], B = 1;
                                                f: {
                                                    if (s >>> 0 < 9 || (B = 2, s >>> 0 < 17) || (B = 4, s >>> 0 < 33)) break f;
                                                    B = s >>> 0 < 65 ? 8 : 16;
                                                }
                                                if (s = B, W >>> 0 > y >>> 0) break A;
                                                for(H = i[u + 44 >> 2], T = i[u + 52 >> 2], B = i[v + 52 >> 2], C = Z(s, R), u = i[v + 44 >> 2] + Z(s, E) | 0, s = W; v0(H + Z(T, s - W | 0) | 0, u + Z(s, B) | 0, C), s = s + 1 | 0, y >>> 0 >= s >>> 0;);
                                            }
                                            if (o[w + 35 | 0] < 0 && X(i[w + 24 >> 2]), M) break r;
                                            u = v, s = i[u + 4 >> 2];
                                            A: {
                                                if (s) {
                                                    for(;;)if (v = s, s = i[s >> 2], !s) break A;
                                                }
                                                for(; v = i[u + 8 >> 2], s = i[v >> 2] != (u | 0), u = v, !!s;);
                                            }
                                            if ((v | 0) == (F | 0)) break;
                                        }
                                        e = i[r + 44 >> 2], f = i[r + 48 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[h + 56 >> 2] = e, k = i[h + 60 >> 2], i[h + 60 >> 2] = f;
                                        A: {
                                            if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break A;
                                            p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        }
                                        e = i[r + 52 >> 2], r = i[r + 56 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[h + 64 >> 2] = e, e = i[h + 68 >> 2], i[h + 68 >> 2] = r;
                                        A: {
                                            if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break A;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (i[A + 4 >> 2] = h, i[A >> 2] = V, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                            A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(r, i[21670], i[21671]);
                                    }
                                    if (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                }
                                m = w - -64 | 0;
                                return;
                            }
                            rf(), z();
                        }
                        function ni(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0;
                            R = m - 128 | 0, m = R;
                            i: {
                                e: {
                                    r: {
                                        if (_ = i[A + 140 >> 2], G = i[A + 152 >> 2], C = _ + Z(Z(G, e), 24) | 0, V = Z(r, 24), w = (C + V | 0) + 4 | 0, M = f << 1, B = l[w | 0] >>> M & 3, !B) break r;
                                        if (E = Z(r, k), r = i[A + 148 >> 2], H = E >> r, (H | 0) < 0 | (G | 0) <= (H | 0)) break e;
                                        if (P = Z(e, n), y = P >> r, (y | 0) < 0 | (y | 0) >= i[A + 156 >> 2]) break i;
                                        if (T = i[A + 124 >> 2], r = i[T + (f ? 16840 : 16832) >> 2], e = -1 << r ^ -1, F = i[(f ? 36 : 28) + A >> 2], $ = (F | 0) < (n + P | 0) ? F - P | 0 : n, c = i[(f ? 32 : 24) + A >> 2], k = (c | 0) < (k + E | 0) ? c - E | 0 : k, r0 = f ? i[T + 16856 >> 2] - 1 | 0 : 0, f0 = f ? i[T + 16852 >> 2] - 1 | 0 : 0, V = l[(C + V | 0) + 22 | 0], (B | 0) == 2) {
                                            if (C = i[A + 132 >> 2], G = i[i[i[A + 52 >> 2] + (I[((_ + Z(H, 24) | 0) + Z(Z(G, y), 24) | 0) + 2 >> 1] << 2) >> 2] + 808 >> 2], n = i[T + 16876 >> 2], H = i[T + 16892 >> 2], y = l[w + 1 | 0], r = w + (f << 2) | 0, o[R | 0] = l[r + 5 | 0], f = l[r + 6 | 0], o[R + 2 | 0] = 0, o[R + 1 | 0] = f, o[R + 3 | 0] = l[r + 7 | 0], o[R + 4 | 0] = l[r + 8 | 0], ($ | 0) <= 0 | (k | 0) <= 0) break r;
                                            for(r = (y >>> M & 3) << 2, m0 = i[r + 50440 >> 2], D0 = Z(m0, u), Z0 = i[r + 50456 >> 2], H0 = Z(Z0, u), X0 = i[r + 50424 >> 2], V0 = i[r + 50408 >> 2], s0 = n - f0 | 0, I0 = E >> s0, i2 = $ - 1 | 0, e2 = k - 1 | 0, k2 = s + E | 0, t2 = t + E | 0, L = n - r0 | 0, F0 = Z(H, P >> L), f = 0, v2 = V & 1;;){
                                                for(r = f + P | 0, w = r << r0, y = r + m0 | 0, y2 = y << r0, V = r + Z0 | 0, U2 = V << r0, H2 = Z(r, h) + k2 | 0, j2 = Z(r, u) + t2 | 0, K2 = Z(H, V >>> L | 0) << 2, i1 = Z(H, y >>> L | 0) << 2, v1 = (f | 0) != (i2 | 0), n = 0;;){
                                                    t = i[A + 168 >> 2], r = w >> t, W = n + E | 0, t0 = W << f0, t = t0 >> t;
                                                    A: {
                                                        f: {
                                                            if (!(!v2 | !l[T + 8812 | 0])) {
                                                                if ((t | 0) < 0 || (s = i[A + 172 >> 2], (s | 0) <= (t | 0))) break e;
                                                                if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break i;
                                                                if (!(l[((i[A + 160 >> 2] + Z(t, 3) | 0) + Z(Z(r, s), 3) | 0) + 1 | 0] & 4)) break f;
                                                                break A;
                                                            }
                                                            if ((t | 0) < 0) break e;
                                                        }
                                                        if (s = i[A + 172 >> 2], (s | 0) <= (t | 0)) break e;
                                                        if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break i;
                                                        if (l[((i[A + 160 >> 2] + Z(t, 3) | 0) + Z(Z(r, s), 3) | 0) + 1 | 0] & 8) break A;
                                                        f: {
                                                            if (!(!f | !n | (n | 0) == (e2 | 0)) && v1) break f;
                                                            if (_ = W + X0 | 0, (_ | 0) >= (c | 0) | (_ | 0) < 0 | ((V | 0) < 0 | (V | 0) >= (F | 0))) break A;
                                                            if (r = i[A + 148 >> 2], B = _ << f0 >> r, (B | 0) < 0 || (t = i[A + 152 >> 2], (t | 0) <= (B | 0))) break e;
                                                            if (v = U2 >> r, (v | 0) < 0 || (M = i[A + 156 >> 2], (M | 0) <= (v | 0))) break i;
                                                            if (s = i[A + 52 >> 2], g0 = i[A + 56 >> 2] - s >> 2, S = Z(B, 24), B = i[A + 140 >> 2], v = I[((S + B | 0) + Z(Z(t, v), 24) | 0) + 2 >> 1], g0 >>> 0 <= v >>> 0 || (v = i[s + (v << 2) >> 2], !v)) break r;
                                                            if (R0 = i[v + 808 >> 2], (G | 0) > (R0 | 0)) {
                                                                if (S = t0 >> r, (S | 0) < 0 | t >>> 0 <= S >>> 0) break e;
                                                                if (q = w >> r, (q | 0) < 0 | (M | 0) <= (q | 0)) break i;
                                                                if (!l[i[s + (I[((B + Z(S, 24) | 0) + Z(Z(t, q), 24) | 0) + 2 >> 1] << 2) >> 2] + 772 | 0]) break A;
                                                            }
                                                            if (!l[v + 772 | 0] & (G | 0) < (R0 | 0) || (S = l[C + 57 | 0], !S && (v = _ >>> s0 << 2, _ = i[C + 8484 >> 2], i[(v + _ | 0) + K2 >> 2] != i[(_ + (I0 << 2) | 0) + (F0 << 2) >> 2])) || (_ = W + V0 | 0, (_ | 0) >= (c | 0) | (_ | 0) < 0 | ((y | 0) < 0 | (y | 0) >= (F | 0)))) break A;
                                                            if (W = _ << f0 >> r, (W | 0) < 0 | t >>> 0 <= W >>> 0) break e;
                                                            if (v = y2 >> r, (v | 0) < 0 | (v | 0) >= (M | 0)) break i;
                                                            if (W = I[((B + Z(W, 24) | 0) + Z(Z(t, v), 24) | 0) + 2 >> 1], W >>> 0 >= g0 >>> 0 || (W = i[s + (W << 2) >> 2], !W)) break r;
                                                            if (v = i[W + 808 >> 2], (v | 0) < (G | 0)) {
                                                                if (t0 = t0 >> r, (t0 | 0) < 0 | t >>> 0 <= t0 >>> 0) break e;
                                                                if (r = w >> r, (r | 0) < 0 | (r | 0) >= (M | 0)) break i;
                                                                if (!l[i[s + (I[((B + Z(t0, 24) | 0) + Z(Z(r, t), 24) | 0) + 2 >> 1] << 2) >> 2] + 772 | 0]) break A;
                                                            }
                                                            if (!l[W + 772 | 0] & (G | 0) < (v | 0)) break A;
                                                            if (S || (r = i[C + 8484 >> 2], i[(r + (_ >>> s0 << 2) | 0) + i1 >> 2] == i[(r + (I0 << 2) | 0) + (F0 << 2) >> 2])) break f;
                                                            break A;
                                                        }
                                                        t = n + j2 | 0, r = l[t | 0], s = l[(t + X0 | 0) + H0 | 0], t = l[(t + V0 | 0) + D0 | 0], r = o[((r >>> 0 < s >>> 0 ? 1 : (r | 0) == (s | 0) ? 2 : 3) + (r >>> 0 < t >>> 0 ? -1 : (t | 0) != (r | 0)) | 0) + R | 0] + r | 0, o[n + H2 | 0] = (r | 0) >= 0 ? (r | 0) < (e | 0) ? r : e : 0;
                                                    }
                                                    if (n = n + 1 | 0, (k | 0) == (n | 0)) break;
                                                }
                                                if (f = f + 1 | 0, ($ | 0) == (f | 0)) break;
                                            }
                                            break r;
                                        }
                                        if (n = l[(f + w | 0) + 2 | 0], G = B0(R, 0, 128), i[((n & 31) << 2) + G >> 2] = 1, i[G + ((n + 1 & 31) << 2) >> 2] = 2, i[G + ((n + 2 & 31) << 2) >> 2] = 3, i[G + ((n + 3 & 31) << 2) >> 2] = 4, c = r - 5 | 0, !(V & 1)) {
                                            if (($ | 0) <= 0 | (k | 0) <= 0 | (r | 0) > 12) break r;
                                            for(T = w + 5 | 0, w = t + E | 0, r = 0;;){
                                                for(A = r + P | 0, r0 = Z(A, h) + s | 0, A = Z(A, u), f0 = A + t | 0, F = A + w | 0, A = 0; n = l[A + F | 0], n = i[G + ((e >>> 0 > n >>> 0 ? n : e) >>> c << 2) >> 2], (n | 0) > 0 && (C = A + E | 0, n = l[C + f0 | 0] + o[(n + (T + (f << 2) | 0) | 0) - 1 | 0] | 0, o[C + r0 | 0] = (n | 0) >= 0 ? (e | 0) > (n | 0) ? n : e : 0), A = A + 1 | 0, (k | 0) > (A | 0););
                                                if (r = r + 1 | 0, !(($ | 0) > (r | 0))) break;
                                            }
                                            break r;
                                        }
                                        if (($ | 0) <= 0 | (k | 0) <= 0) break r;
                                        H = w + 5 | 0, F = 0, y = (r | 0) > 12;
                                        A: {
                                            for(;;){
                                                r = F + P | 0, V = r << r0, _ = Z(r, h) + s | 0, M = Z(r, u) + t | 0, n = 0;
                                                f: {
                                                    for(;;){
                                                        w = i[A + 168 >> 2], r = V >> w, C = n + E | 0, w = C << f0 >> w;
                                                        k: {
                                                            n: {
                                                                if (l[T + 8812 | 0]) {
                                                                    if ((w | 0) < 0 || (B = i[A + 172 >> 2], (B | 0) <= (w | 0))) break f;
                                                                    if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break i;
                                                                    if (!(l[((i[A + 160 >> 2] + Z(w, 3) | 0) + Z(Z(r, B), 3) | 0) + 1 | 0] & 4)) break n;
                                                                    break k;
                                                                }
                                                                if ((w | 0) < 0) break e;
                                                            }
                                                            if (B = i[A + 172 >> 2], (B | 0) <= (w | 0)) break e;
                                                            if ((r | 0) < 0 | (r | 0) >= i[A + 176 >> 2]) break A;
                                                            if (y | l[((i[A + 160 >> 2] + Z(w, 3) | 0) + Z(Z(r, B), 3) | 0) + 1 | 0] & 8 || (r = l[C + M | 0], w = i[G + ((r >>> 0 < e >>> 0 ? r : e) >>> c << 2) >> 2], (w | 0) <= 0)) break k;
                                                            r = r + o[(w + (H + (f << 2) | 0) | 0) - 1 | 0] | 0, o[_ + C | 0] = (r | 0) >= 0 ? (r | 0) < (e | 0) ? r : e : 0;
                                                        }
                                                        if (n = n + 1 | 0, !((k | 0) > (n | 0))) break;
                                                    }
                                                    if (F = F + 1 | 0, ($ | 0) <= (F | 0)) break r;
                                                    continue;
                                                }
                                                break;
                                            }
                                            break e;
                                        }
                                        break i;
                                    }
                                    m = R + 128 | 0;
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function x7(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k, i[k + 12 >> 2] = A;
                            i: {
                                if (A >>> 0 <= 211) {
                                    A = i[R9(58064, 58256, k + 12 | 0) >> 2];
                                    break i;
                                }
                                for(A >>> 0 >= 4294967292 && (w1(), z()), n = (A >>> 0) / 210 | 0, f = Z(n, 210), i[k + 8 >> 2] = A - f, t = R9(58256, 58448, k + 8 | 0) - 58256 >> 2;;){
                                    A = i[(t << 2) + 58256 >> 2] + f | 0, f = 5;
                                    e: {
                                        r: {
                                            for(;;){
                                                if (e = f, (e | 0) == 47) break r;
                                                if (u = i[(e << 2) + 58064 >> 2], r = (A >>> 0) / (u >>> 0) | 0, r >>> 0 < u >>> 0) break i;
                                                if (f = e + 1 | 0, (Z(r, u) | 0) == (A | 0)) break;
                                            }
                                            if (e >>> 0 < 47) break e;
                                        }
                                        for(f = 211;;){
                                            if (e = (A >>> 0) / (f >>> 0) | 0, e >>> 0 < f >>> 0) break i;
                                            if ((Z(e, f) | 0) == (A | 0)) break e;
                                            if (r = f + 10 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 12 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 16 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 18 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 22 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 28 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 30 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 36 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 40 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 42 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 46 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 52 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 58 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 60 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 66 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 70 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 72 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 78 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 82 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 88 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 96 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 100 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 102 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 106 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 108 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 112 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 120 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 126 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 130 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 136 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 138 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 142 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 148 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 150 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 156 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 162 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 166 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 168 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 172 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 178 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 180 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 186 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 190 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 192 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 196 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 198 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if ((Z(e, r) | 0) == (A | 0)) break e;
                                            if (r = f + 208 | 0, e = (A >>> 0) / (r >>> 0) | 0, e >>> 0 < r >>> 0) break i;
                                            if (f = f + 210 | 0, (Z(e, r) | 0) == (A | 0)) break;
                                        }
                                    }
                                    A = t + 1 | 0, e = (A | 0) == 48, t = e ? 0 : A, n = e + n | 0, f = Z(n, 210);
                                }
                            }
                            return m = k + 16 | 0, A;
                        }
                        function ew(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            f = m - 128 | 0, m = f, w = l[k + 8 | 0], s = i[i[e >> 2] + 36 >> 2], n = D(136), i[n >> 2] = 78252, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, B0(n + 20 | 0, 0, 104), u = i[n + 4 >> 2], k = u + 1 | 0, i[n + 4 >> 2] = k, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 44 >> 2] = 99, i[n + 48 >> 2] = 99, i[n + 32 >> 2] = 4142, r = n - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, r = n + 76 | 0, i[n + 72 >> 2] = r, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, B = n + 12 | 0, i[n + 12 >> 2] = B, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = u, i[n + 16 >> 2] = n, k || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), k = i[e >> 2], v = i[k + 24 >> 2], W = i[k + 28 >> 2], k = W, i[B + 36 >> 2] = 3, i[B + 32 >> 2] = 1, i[B + 28 >> 2] = k, i[B + 24 >> 2] = v, J0(f + 56 | 0, B, 3, v, k, 8, t), J0(f + 32 | 0, B, 4, v, k, 8, t), h = f + 88 | 0;
                            i: {
                                if (i[f + 56 >> 2]) {
                                    if (k = i[f + 60 >> 2], i[f + 80 >> 2] = i[f + 56 >> 2], i[f + 84 >> 2] = k, o[f + 75 | 0] >= 0) {
                                        u = f - -64 | 0, k = i[u + 4 >> 2], i[h >> 2] = i[u >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    j(h, i[f + 64 >> 2], i[f + 68 >> 2]);
                                    break i;
                                }
                                if (k = i[f + 36 >> 2], i[f + 80 >> 2] = i[f + 32 >> 2], i[f + 84 >> 2] = k, o[f + 51 | 0] >= 0) {
                                    k = i[f + 44 >> 2], i[h >> 2] = i[f + 40 >> 2], i[h + 4 >> 2] = k, i[h + 8 >> 2] = i[f + 48 >> 2];
                                    break i;
                                }
                                j(h, i[f + 40 >> 2], i[f + 44 >> 2]);
                            }
                            J0(f + 8 | 0, B, 5, v, W, 8, t), u = f + 112 | 0;
                            i: {
                                if (i[f + 80 >> 2]) {
                                    if (k = i[f + 84 >> 2], i[f + 104 >> 2] = i[f + 80 >> 2], i[f + 108 >> 2] = k, o[f + 99 | 0] >= 0) {
                                        k = i[h + 4 >> 2], i[u >> 2] = i[h >> 2], i[u + 4 >> 2] = k, i[u + 8 >> 2] = i[h + 8 >> 2];
                                        break i;
                                    }
                                    j(u, i[f + 88 >> 2], i[f + 92 >> 2]);
                                    break i;
                                }
                                if (k = i[f + 12 >> 2], i[f + 104 >> 2] = i[f + 8 >> 2], i[f + 108 >> 2] = k, o[f + 27 | 0] >= 0) {
                                    k = i[f + 20 >> 2], i[u >> 2] = i[f + 16 >> 2], i[u + 4 >> 2] = k, i[u + 8 >> 2] = i[f + 24 >> 2];
                                    break i;
                                }
                                j(u, i[f + 16 >> 2], i[f + 20 >> 2]);
                            }
                            o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), o[f + 99 | 0] < 0 && X(i[f + 88 >> 2]), o[f + 51 | 0] < 0 && X(i[f + 40 >> 2]), o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]);
                            i: {
                                if (i[f + 104 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                        A = i[u + 4 >> 2], i[r >> 2] = i[u >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 8 >> 2];
                                        break i;
                                    }
                                    if (j(r, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                    X(i[f + 112 >> 2]);
                                    break i;
                                }
                                o[f + 123 | 0] < 0 && X(i[f + 112 >> 2]);
                                e: {
                                    if (!(w & 1)) break e;
                                    if (J0(f + 104 | 0, B, 6, v, W, 8, t), i[f + 104 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 108 >> 2], i[A + 8 >> 2] = i[f + 104 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 123 | 0] >= 0) {
                                            A = i[f + 116 >> 2], i[r >> 2] = i[f + 112 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 120 >> 2];
                                            break i;
                                        }
                                        if (j(r, i[f + 112 >> 2], i[f + 116 >> 2]), o[f + 123 | 0] >= 0) break i;
                                        X(i[f + 112 >> 2]);
                                        break i;
                                    }
                                    if (o[f + 123 | 0] >= 0) break e;
                                    X(i[f + 112 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (e = i[e >> 2], t = i[e + 64 >> 2], !t) break r;
                                        for(u = e - -64 | 0, e = u; k = i[t + 16 >> 2] < 10, e = k ? e : t, t = i[(k << 2) + t >> 2], !!t;);
                                        if ((e | 0) == (u | 0)) break r;
                                        if (u = 0, i[e + 16 >> 2] > 10) break e;
                                        M = i[e + 44 >> 2], u = i[e + 52 >> 2];
                                        break e;
                                    }
                                    u = 0;
                                }
                                e: {
                                    r: {
                                        if (e = i[r >> 2], e) {
                                            for(k = r, t = e; _ = i[t + 16 >> 2] < 3, k = _ ? k : t, t = i[(_ << 2) + t >> 2], !!t;);
                                            C = 0;
                                            A: {
                                                if ((r | 0) == (k | 0) || (C = 0, i[k + 16 >> 2] > 3)) break A;
                                                H = i[k + 52 >> 2], C = i[k + 44 >> 2];
                                            }
                                            for(k = r, t = e; _ = i[t + 16 >> 2] < 4, k = _ ? k : t, t = i[(_ << 2) + t >> 2], !!t;);
                                            V = 0;
                                            A: {
                                                if ((r | 0) == (k | 0) || (V = 0, i[k + 16 >> 2] > 4)) break A;
                                                T = i[k + 44 >> 2], V = i[k + 52 >> 2];
                                            }
                                            for(k = r, t = e; _ = i[t + 16 >> 2] < 5, k = _ ? k : t, t = i[(_ << 2) + t >> 2], !!t;);
                                            t = 0;
                                            A: {
                                                if ((r | 0) == (k | 0) || (t = 0, i[k + 16 >> 2] > 5)) break A;
                                                S = i[k + 52 >> 2], t = i[k + 44 >> 2];
                                            }
                                            if (_ = t, k = 0, !e || (k = 0, !(w & 1))) break e;
                                            for(t = r; k = i[e + 16 >> 2] < 6, t = k ? t : e, e = i[(k << 2) + e >> 2], !!e;);
                                            if ((r | 0) != (t | 0)) break r;
                                        }
                                        k = 0;
                                        break e;
                                    }
                                    if (k = 0, i[t + 16 >> 2] > 6) break e;
                                    G = i[t + 52 >> 2], k = i[t + 44 >> 2];
                                }
                                r = k;
                                e: {
                                    if (!W | !v) break e;
                                    if (k = (s | 0) == 11, R = k ? 4 : 3, w & 1) {
                                        for(e = 0;;){
                                            y = Z(e, G), F = Z(e, S) + _ | 0, E = Z(e, V) + T | 0, h = Z(e, H) + C | 0, w = Z(e, u) + M | 0, t = 0;
                                            r: {
                                                if (!k) {
                                                    for(;;)if (s = w + Z(t, R) | 0, o[t + h | 0] = l[s | 0], o[t + E | 0] = l[s + 1 | 0], o[t + F | 0] = l[s + 2 | 0], o[r + (t + y | 0) | 0] = 255, t = t + 1 | 0, (v | 0) == (t | 0)) break r;
                                                }
                                                for(; s = w + Z(t, R) | 0, o[t + h | 0] = l[s | 0], o[t + E | 0] = l[s + 1 | 0], o[t + F | 0] = l[s + 2 | 0], o[r + (t + y | 0) | 0] = l[s + 3 | 0], t = t + 1 | 0, (v | 0) != (t | 0););
                                            }
                                            if (e = e + 1 | 0, (W | 0) == (e | 0)) break;
                                        }
                                        break e;
                                    }
                                    for(k = v & -2, e = v & 1, G = 0;;){
                                        if (y = Z(G, S) + _ | 0, F = Z(G, V) + T | 0, E = Z(G, H) + C | 0, h = Z(u, G) + M | 0, t = 0, r = 0, (v | 0) != 1) for(; s = h + Z(t, R) | 0, o[t + E | 0] = l[s | 0], o[t + F | 0] = l[s + 1 | 0], o[t + y | 0] = l[s + 2 | 0], w = t | 1, s = h + Z(w, R) | 0, o[w + E | 0] = l[s | 0], o[w + F | 0] = l[s + 1 | 0], o[w + y | 0] = l[s + 2 | 0], t = t + 2 | 0, r = r + 2 | 0, (k | 0) != (r | 0););
                                        if (e && (r = h + Z(t, R) | 0, o[t + E | 0] = l[r | 0], o[t + F | 0] = l[r + 1 | 0], o[t + y | 0] = l[r + 2 | 0]), G = G + 1 | 0, (W | 0) == (G | 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = n, i[A >> 2] = B, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = f + 128 | 0;
                        }
                        function rw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = J(0), w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = J(0), $ = 0, c = 0, r0 = 0, f0 = 0, t0 = J(0), s0 = J(0), L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = J(0), F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0;
                            s = m - 48 | 0, m = s, r = i[e >> 2], V = i[r + 28 >> 2], y = i[r + 24 >> 2], B = S0(r, 0), H = A1(i[e >> 2], 6), G = i[k + 4 >> 2], u = D(136), i[u >> 2] = 78252, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, B0(u + 20 | 0, 0, 104), w = i[u + 4 >> 2], n = w + 1 | 0, i[u + 4 >> 2] = n, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 44 >> 2] = 99, i[u + 48 >> 2] = 99, i[u + 32 >> 2] = 4142, r = u - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[u + 132 >> 2] = 0, i[u + 124 >> 2] = 0, i[u + 128 >> 2] = 0, i[u + 84 >> 2] = 1, i[u + 88 >> 2] = 1, f = u + 76 | 0, i[u + 72 >> 2] = f, i[u + 92 >> 2] = 0, i[u + 96 >> 2] = 0, i[u + 100 >> 2] = 0, i[u + 104 >> 2] = 0, i[u + 108 >> 2] = 0, i[u + 112 >> 2] = 0, o[u + 113 | 0] = 0, o[u + 114 | 0] = 0, o[u + 115 | 0] = 0, o[u + 116 | 0] = 0, o[u + 117 | 0] = 0, o[u + 118 | 0] = 0, o[u + 119 | 0] = 0, o[u + 120 | 0] = 0, _ = u + 12 | 0, i[u + 12 >> 2] = _, i[u + 8 >> 2] = i[u + 8 >> 2] + 1, i[u + 4 >> 2] = w, i[u + 16 >> 2] = u, n || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), i[_ + 36 >> 2] = i[k + 4 >> 2], i[_ + 32 >> 2] = 1, i[_ + 28 >> 2] = V, i[_ + 24 >> 2] = y, J0(s + 24 | 0, _, 10, y, V, B, t);
                            i: {
                                if (i[s + 24 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[s + 28 >> 2], i[A + 8 >> 2] = i[s + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[s + 43 | 0] >= 0) {
                                        A = i[s + 36 >> 2], i[r >> 2] = i[s + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[s + 40 >> 2];
                                        break i;
                                    }
                                    if (j(r, i[s + 32 >> 2], i[s + 36 >> 2]), o[s + 43 | 0] >= 0) break i;
                                    X(i[s + 32 >> 2]);
                                    break i;
                                }
                                o[s + 43 | 0] < 0 && X(i[s + 32 >> 2]);
                                e: {
                                    if (!H) break e;
                                    if (J0(s + 24 | 0, _, 6, y, V, B, t), i[s + 24 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[s + 28 >> 2], i[A + 8 >> 2] = i[s + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[s + 43 | 0] >= 0) {
                                            A = i[s + 36 >> 2], i[r >> 2] = i[s + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[s + 40 >> 2];
                                            break i;
                                        }
                                        if (j(r, i[s + 32 >> 2], i[s + 36 >> 2]), o[s + 43 | 0] >= 0) break i;
                                        X(i[s + 32 >> 2]);
                                        break i;
                                    }
                                    if (o[s + 43 | 0] >= 0) break e;
                                    X(i[s + 32 >> 2]);
                                }
                                e: {
                                    r: {
                                        if (k = i[f >> 2], !k) break r;
                                        for(r = f; n = i[k + 16 >> 2] < 10, r = n ? r : k, k = i[(n << 2) + k >> 2], !!k;);
                                        if ((r | 0) == (f | 0)) break r;
                                        if (f = 0, i[r + 16 >> 2] > 10) break e;
                                        L = i[r + 52 >> 2], f = i[r + 44 >> 2];
                                        break e;
                                    }
                                    f = 0;
                                }
                                F = f;
                                e: {
                                    r: {
                                        if (f = i[e >> 2], r = i[f + 64 >> 2], r) {
                                            for(f = f - -64 | 0, t = f, k = r; n = i[k + 16 >> 2], t = (n | 0) < 0 ? t : k, k = i[(n >>> 29 & 4) + k >> 2], !!k;);
                                            E = 0;
                                            A: {
                                                if ((f | 0) == (t | 0) || (E = 0, i[t + 16 >> 2] > 0)) break A;
                                                q = i[t + 52 >> 2], E = i[t + 44 >> 2];
                                            }
                                            for(t = f, k = r; n = i[k + 16 >> 2] <= 0, t = n ? t : k, k = i[(n << 2) + k >> 2], !!k;);
                                            R = 0;
                                            A: {
                                                if ((f | 0) == (t | 0) || (R = 0, i[t + 16 >> 2] > 1)) break A;
                                                m0 = i[t + 44 >> 2], R = i[t + 52 >> 2];
                                            }
                                            for(t = f, k = r; n = i[k + 16 >> 2] < 2, t = n ? t : k, k = i[(n << 2) + k >> 2], !!k;);
                                            M = 0;
                                            A: {
                                                if ((f | 0) == (t | 0) || (M = 0, i[t + 16 >> 2] > 2)) break A;
                                                Z0 = i[t + 52 >> 2], M = i[t + 44 >> 2];
                                            }
                                            if (W = 0, !r | H ^ 1) break e;
                                            for(k = f; n = i[r + 16 >> 2] < 6, k = n ? k : r, r = i[(n << 2) + r >> 2], !!r;);
                                            if ((f | 0) != (k | 0)) break r;
                                        }
                                        W = 0;
                                        break e;
                                    }
                                    if (W = 0, i[k + 16 >> 2] > 6) break e;
                                    X0 = i[k + 52 >> 2], W = i[k + 44 >> 2];
                                }
                                i[s + 36 >> 2] = -1086926434, i[s + 40 >> 2] = 1071829221, i[s + 28 >> 2] = 1068725436, i[s + 32 >> 2] = -1095748968, o[s + 24 | 0] = 1, r = i[e >> 2], e = i[r + 44 >> 2], v = i[r + 48 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1);
                                e: {
                                    if (!e) {
                                        r = 1;
                                        break e;
                                    }
                                    r = l[e + 10 | 0], Xi(s + 4 | 0, I[e + 8 >> 1], I[e + 4 >> 1]), i[s + 40 >> 2] = i[s + 20 >> 2], e = i[s + 16 >> 2], i[s + 32 >> 2] = i[s + 12 >> 2], i[s + 36 >> 2] = e, e = i[s + 8 >> 2], i[s + 24 >> 2] = i[s + 4 >> 2], i[s + 28 >> 2] = e;
                                }
                                if (!(!V | !y)) for(f = G & -2, c = (f | 0) == 14, V0 = H ? 8 : 6, I0 = J(16 << B - 8), e = (f | 0) == 14, F0 = e ? 6 : 7, g0 = e ? 4 : 5, R0 = e ? 2 : 3, D0 = (f | 0) != 14, w = -1 << B ^ -1, t = w >>> 8 | 0, r0 = 1 << B - 1, T = r & 1;;){
                                    for(S = Z(C, L), H0 = F0 + S | 0, i2 = Z(C, X0) >>> 1 | 0, e2 = (Z(C, q) & -2) + E | 0, f0 = F + S | 0, k2 = (f0 + c | 0) + 6 | 0, r = C >>> 1 | 0, t2 = (Z(r, Z0) & -2) + M | 0, v2 = (Z(r, R) & -2) + m0 | 0, k = 0;;){
                                        r = k & -2, h = J(I[r + t2 >> 1] - r0 | 0), t0 = T ? h : J(h * J(1.142899990081787)), h = J(I[(k << 1) + e2 >> 1]), P = T ? h : J(J(h - I0) * J(1.1689000129699707)), h = J(J(J(W0[s + 28 >> 2] * t0) + P) + J(.5));
                                        e: {
                                            if (J(r2(h)) < J(2147483648)) {
                                                f = ~~h;
                                                break e;
                                            }
                                            f = -2147483648;
                                        }
                                        h = J(I[r + v2 >> 1] - r0 | 0), s0 = T ? h : J(h * J(1.142899990081787)), e = 0, r = 0;
                                        e: {
                                            if ((f | 0) < 0) break e;
                                            if ((f | 0) > (w | 0)) {
                                                e = w, r = t;
                                                break e;
                                            }
                                            e = f, r = e >>> 8 | 0;
                                        }
                                        y2 = e, f = 0, h = J(J(J(W0[s + 36 >> 2] * t0) + J(J(W0[s + 32 >> 2] * s0) + P)) + J(.5));
                                        e: {
                                            if (J(r2(h)) < J(2147483648)) {
                                                n = ~~h;
                                                break e;
                                            }
                                            n = -2147483648;
                                        }
                                        e = 0;
                                        e: {
                                            if ((n | 0) < 0) break e;
                                            if ((n | 0) > (w | 0)) {
                                                f = t, e = w;
                                                break e;
                                            }
                                            f = n >>> 8 | 0, e = n;
                                        }
                                        B = e, n = 0, h = J(J(J(W0[s + 40 >> 2] * s0) + P) + J(.5));
                                        e: {
                                            if (J(r2(h)) < J(2147483648)) {
                                                e = ~~h;
                                                break e;
                                            }
                                            e = -2147483648;
                                        }
                                        G = 0;
                                        e: {
                                            if ((e | 0) < 0) break e;
                                            if ((e | 0) > (w | 0)) {
                                                n = t, G = w;
                                                break e;
                                            }
                                            n = e >>> 8 | 0, G = e;
                                        }
                                        if (e = Z(k, V0), $ = (e + f0 | 0) + c | 0, o[$ | 0] = r, o[$ + 2 | 0] = f, o[$ + 4 | 0] = n, r = e + S | 0, o[F + (r + D0 | 0) | 0] = y2, o[F + (r + R0 | 0) | 0] = B, o[F + (r + g0 | 0) | 0] = G, H && (e = k << 3, r = (k + i2 << 1) + W | 0, o[e + k2 | 0] = l[r + 1 | 0], o[F + (e + H0 | 0) | 0] = l[r | 0]), k = k + 1 | 0, (y | 0) == (k | 0)) break;
                                    }
                                    if (C = C + 1 | 0, (C | 0) == (V | 0)) break;
                                }
                                i[A + 4 >> 2] = u, i[A >> 2] = _, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (!v || (A = i[v + 4 >> 2], i[v + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                            }
                            A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = s + 48 | 0;
                        }
                        function we(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            for(v = i[A + 20 >> 2], w = i[A + 16 >> 2], h = i[A + 12 >> 2], $ = i[A + 8 >> 2]; s = l[r | 0] | l[r + 1 | 0] << 8 | (l[r + 2 | 0] << 16 | l[r + 3 | 0] << 24), i[A + 88 >> 2] = s, _ = l[r + 4 | 0] | l[r + 5 | 0] << 8 | (l[r + 6 | 0] << 16 | l[r + 7 | 0] << 24), i[A + 92 >> 2] = _, B = l[r + 8 | 0] | l[r + 9 | 0] << 8 | (l[r + 10 | 0] << 16 | l[r + 11 | 0] << 24), i[A + 96 >> 2] = B, G = l[r + 12 | 0] | l[r + 13 | 0] << 8 | (l[r + 14 | 0] << 16 | l[r + 15 | 0] << 24), i[A + 100 >> 2] = G, W = l[r + 16 | 0] | l[r + 17 | 0] << 8 | (l[r + 18 | 0] << 16 | l[r + 19 | 0] << 24), i[A + 104 >> 2] = W, C = l[r + 20 | 0] | l[r + 21 | 0] << 8 | (l[r + 22 | 0] << 16 | l[r + 23 | 0] << 24), i[A + 108 >> 2] = C, V = l[r + 24 | 0] | l[r + 25 | 0] << 8 | (l[r + 26 | 0] << 16 | l[r + 27 | 0] << 24), i[A + 112 >> 2] = V, y = l[r + 28 | 0] | l[r + 29 | 0] << 8 | (l[r + 30 | 0] << 16 | l[r + 31 | 0] << 24), i[A + 116 >> 2] = y, F = l[r + 32 | 0] | l[r + 33 | 0] << 8 | (l[r + 34 | 0] << 16 | l[r + 35 | 0] << 24), i[A + 120 >> 2] = F, E = l[r + 36 | 0] | l[r + 37 | 0] << 8 | (l[r + 38 | 0] << 16 | l[r + 39 | 0] << 24), i[A + 124 >> 2] = E, R = l[r + 40 | 0] | l[r + 41 | 0] << 8 | (l[r + 42 | 0] << 16 | l[r + 43 | 0] << 24), i[A + 128 >> 2] = R, M = l[r + 44 | 0] | l[r + 45 | 0] << 8 | (l[r + 46 | 0] << 16 | l[r + 47 | 0] << 24), i[A + 132 >> 2] = M, H = l[r + 48 | 0] | l[r + 49 | 0] << 8 | (l[r + 50 | 0] << 16 | l[r + 51 | 0] << 24), i[A + 136 >> 2] = H, T = l[r + 52 | 0] | l[r + 53 | 0] << 8 | (l[r + 54 | 0] << 16 | l[r + 55 | 0] << 24), i[A + 140 >> 2] = T, S = l[r + 56 | 0] | l[r + 57 | 0] << 8 | (l[r + 58 | 0] << 16 | l[r + 59 | 0] << 24), i[A + 144 >> 2] = S, P = l[r + 60 | 0] | l[r + 61 | 0] << 8 | (l[r + 62 | 0] << 16 | l[r + 63 | 0] << 24), i[A + 148 >> 2] = P, f = b0(((((w ^ v) & h ^ v) + $ | 0) + s | 0) - 680876936 | 0, 7) + h | 0, k = b0(((v + _ | 0) + (f & (h ^ w) ^ w) | 0) - 389564586 | 0, 12) + f | 0, n = b0(((w + B | 0) + (k & (f ^ h) ^ h) | 0) + 606105819 | 0, 17) + k | 0, t = b0(((h + G | 0) + (f ^ n & (f ^ k)) | 0) - 1044525330 | 0, 22) + n | 0, f = b0(((f + W | 0) + (k ^ t & (k ^ n)) | 0) - 176418897 | 0, 7) + t | 0, k = b0(((k + C | 0) + (n ^ f & (t ^ n)) | 0) + 1200080426 | 0, 12) + f | 0, n = b0(((n + V | 0) + (t ^ k & (f ^ t)) | 0) - 1473231341 | 0, 17) + k | 0, t = b0(((t + y | 0) + (f ^ n & (f ^ k)) | 0) - 45705983 | 0, 22) + n | 0, f = b0(((f + F | 0) + (k ^ t & (k ^ n)) | 0) + 1770035416 | 0, 7) + t | 0, k = b0(((k + E | 0) + (n ^ f & (t ^ n)) | 0) - 1958414417 | 0, 12) + f | 0, n = b0(((n + R | 0) + (t ^ k & (f ^ t)) | 0) - 42063 | 0, 17) + k | 0, t = b0(((t + M | 0) + (f ^ n & (f ^ k)) | 0) - 1990404162 | 0, 22) + n | 0, u = k + T | 0, k = b0(((f + H | 0) + (k ^ t & (k ^ n)) | 0) + 1804603682 | 0, 7) + t | 0, u = b0((u + (n ^ k & (t ^ n)) | 0) - 40341101 | 0, 12) + k | 0, f = t + P | 0, t = b0(((n + S | 0) + (t ^ u & (k ^ t)) | 0) - 1502002290 | 0, 17) + u | 0, f = b0((f + (k ^ t & (k ^ u)) | 0) + 1236535329 | 0, 22) + t | 0, k = b0(((k + _ | 0) + (t ^ u & (f ^ t)) | 0) - 165796510 | 0, 5) + f | 0, n = b0(((u + V | 0) + ((f ^ k) & t ^ f) | 0) - 1069501632 | 0, 9) + k | 0, t = b0(((t + M | 0) + (k ^ f & (k ^ n)) | 0) + 643717713 | 0, 14) + n | 0, f = b0(((f + s | 0) + (n ^ k & (t ^ n)) | 0) - 373897302 | 0, 20) + t | 0, k = b0(((k + C | 0) + (t ^ n & (f ^ t)) | 0) - 701558691 | 0, 5) + f | 0, n = b0(((n + R | 0) + ((f ^ k) & t ^ f) | 0) + 38016083 | 0, 9) + k | 0, t = b0(((t + P | 0) + (k ^ f & (k ^ n)) | 0) - 660478335 | 0, 14) + n | 0, f = b0(((f + W | 0) + (n ^ k & (t ^ n)) | 0) - 405537848 | 0, 20) + t | 0, k = b0(((k + E | 0) + (t ^ n & (f ^ t)) | 0) + 568446438 | 0, 5) + f | 0, n = b0(((n + S | 0) + ((f ^ k) & t ^ f) | 0) - 1019803690 | 0, 9) + k | 0, t = b0(((t + G | 0) + (k ^ f & (k ^ n)) | 0) - 187363961 | 0, 14) + n | 0, f = b0(((f + F | 0) + (n ^ k & (t ^ n)) | 0) + 1163531501 | 0, 20) + t | 0, k = b0(((k + T | 0) + (t ^ n & (f ^ t)) | 0) - 1444681467 | 0, 5) + f | 0, n = b0(((n + B | 0) + ((f ^ k) & t ^ f) | 0) - 51403784 | 0, 9) + k | 0, c = f + H | 0, u = b0(((t + y | 0) + (k ^ f & (k ^ n)) | 0) + 1735328473 | 0, 14) + n | 0, f = u ^ n, t = b0((c + (n ^ k & f) | 0) - 1926607734 | 0, 20) + u | 0, f = b0(((k + C | 0) + (f ^ t) | 0) - 378558 | 0, 4) + t | 0, k = b0(((n + F | 0) + (f ^ (t ^ u)) | 0) - 2022574463 | 0, 11) + f | 0, n = b0(((u + M | 0) + (k ^ (f ^ t)) | 0) + 1839030562 | 0, 16) + k | 0, t = b0(((t + S | 0) + (n ^ (f ^ k)) | 0) - 35309556 | 0, 23) + n | 0, f = b0(((f + _ | 0) + (t ^ (k ^ n)) | 0) - 1530992060 | 0, 4) + t | 0, k = b0(((k + W | 0) + (f ^ (t ^ n)) | 0) + 1272893353 | 0, 11) + f | 0, n = b0(((n + y | 0) + (k ^ (f ^ t)) | 0) - 155497632 | 0, 16) + k | 0, t = b0(((t + R | 0) + (n ^ (f ^ k)) | 0) - 1094730640 | 0, 23) + n | 0, f = b0(((f + T | 0) + (t ^ (k ^ n)) | 0) + 681279174 | 0, 4) + t | 0, k = b0(((k + s | 0) + (f ^ (t ^ n)) | 0) - 358537222 | 0, 11) + f | 0, n = b0(((n + G | 0) + (k ^ (f ^ t)) | 0) - 722521979 | 0, 16) + k | 0, t = b0(((t + V | 0) + (n ^ (f ^ k)) | 0) + 76029189 | 0, 23) + n | 0, f = b0(((f + E | 0) + (t ^ (k ^ n)) | 0) - 640364487 | 0, 4) + t | 0, k = b0(((k + H | 0) + (f ^ (t ^ n)) | 0) - 421815835 | 0, 11) + f | 0, u = f + s | 0, s = f ^ k, f = b0(((n + P | 0) + (k ^ (f ^ t)) | 0) + 530742520 | 0, 16) + k | 0, n = b0(((t + B | 0) + (s ^ f) | 0) - 995338651 | 0, 23) + f | 0, t = b0((u + ((n | k ^ -1) ^ f) | 0) - 198630844 | 0, 6) + n | 0, u = n + C | 0, s = f + S | 0, f = b0(((k + y | 0) + (n ^ (t | f ^ -1)) | 0) + 1126891415 | 0, 10) + t | 0, n = b0((s + (t ^ (f | n ^ -1)) | 0) - 1416354905 | 0, 15) + f | 0, k = b0((u + ((n | t ^ -1) ^ f) | 0) - 57434055 | 0, 21) + n | 0, u = n + R | 0, s = f + G | 0, f = b0(((t + H | 0) + (n ^ (k | f ^ -1)) | 0) + 1700485571 | 0, 6) + k | 0, n = b0((s + (k ^ (f | n ^ -1)) | 0) - 1894986606 | 0, 10) + f | 0, t = b0((u + ((n | k ^ -1) ^ f) | 0) - 1051523 | 0, 15) + n | 0, u = n + P | 0, s = f + F | 0, f = b0(((k + _ | 0) + (n ^ (t | f ^ -1)) | 0) - 2054922799 | 0, 21) + t | 0, n = b0((s + (t ^ (f | n ^ -1)) | 0) + 1873313359 | 0, 6) + f | 0, k = b0((u + ((n | t ^ -1) ^ f) | 0) - 30611744 | 0, 10) + n | 0, u = n + W | 0, s = f + T | 0, f = b0(((t + V | 0) + (n ^ (k | f ^ -1)) | 0) - 1560198380 | 0, 15) + k | 0, n = b0((s + (k ^ (f | n ^ -1)) | 0) + 1309151649 | 0, 21) + f | 0, t = b0((u + ((n | k ^ -1) ^ f) | 0) - 145523070 | 0, 6) + n | 0, k = b0(((k + M | 0) + (n ^ (t | f ^ -1)) | 0) - 1120210379 | 0, 10) + t | 0, f = b0(((f + B | 0) + (t ^ (k | n ^ -1)) | 0) + 718787259 | 0, 15) + k | 0, h = (f + h | 0) + b0(((n + E | 0) + (k ^ (f | t ^ -1)) | 0) - 343485551 | 0, 21) | 0, w = f + w | 0, v = k + v | 0, $ = t + $ | 0, r = r - -64 | 0, e = e + -64 | 0, !!e;);
                            return i[A + 20 >> 2] = v, i[A + 16 >> 2] = w, i[A + 12 >> 2] = h, i[A + 8 >> 2] = $, r;
                        }
                        function Aw(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            t = m - 32 | 0, m = t, e = m - 192 | 0, m = e, f = i[r + 20 >> 2], u = i[f + 48 >> 2], s = i[f + 52 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), n = t + 8 | 0, i[e + 188 >> 2] = 0, i[e + 180 >> 2] = 0, i[e + 184 >> 2] = 0, ui(e + 160 | 0, u, i[r + 36 >> 2], e + 180 | 0);
                            i: {
                                if (i[e + 160 >> 2]) {
                                    r = i[e + 164 >> 2], i[n >> 2] = i[e + 160 >> 2], i[n + 4 >> 2] = r, i[n + 16 >> 2] = i[e + 176 >> 2], r = i[e + 172 >> 2], i[n + 8 >> 2] = i[e + 168 >> 2], i[n + 12 >> 2] = r, i[e + 176 >> 2] = 0, i[e + 168 >> 2] = 0, i[e + 172 >> 2] = 0;
                                    break i;
                                }
                                if (K7(e + 16 | 0, r + 372 | 0, e + 180 | 0), k = i[e + 20 >> 2], f = i[e + 16 >> 2], i[e + 160 >> 2] = f, i[e + 164 >> 2] = k, o[e + 179 | 0] < 0 && (X(i[e + 168 >> 2]), f = i[e + 160 >> 2]), k = i[e + 28 >> 2], i[e + 168 >> 2] = i[e + 24 >> 2], i[e + 172 >> 2] = k, i[e + 176 >> 2] = i[e + 32 >> 2], f) {
                                    r = i[e + 164 >> 2], i[n >> 2] = i[e + 160 >> 2], i[n + 4 >> 2] = r, i[n + 16 >> 2] = i[e + 176 >> 2], r = i[e + 172 >> 2], i[n + 8 >> 2] = i[e + 168 >> 2], i[n + 12 >> 2] = r, i[e + 168 >> 2] = 0, i[e + 172 >> 2] = 0, i[e + 176 >> 2] = 0;
                                    break i;
                                }
                                f = i[u + 84 >> 2], h = i[u + 88 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1);
                                e: {
                                    if (!f) {
                                        if (k = D(56), i[e + 16 >> 2] = k, i[e + 20 >> 2] = 48, i[e + 24 >> 2] = -2147483592, f = l[12063] | l[12064] << 8 | (l[12065] << 16 | l[12066] << 24), r = l[12059] | l[12060] << 8 | (l[12061] << 16 | l[12062] << 24), o[k | 0] = r, o[k + 1 | 0] = r >>> 8, o[k + 2 | 0] = r >>> 16, o[k + 3 | 0] = r >>> 24, o[k + 4 | 0] = f, o[k + 5 | 0] = f >>> 8, o[k + 6 | 0] = f >>> 16, o[k + 7 | 0] = f >>> 24, o[k + 48 | 0] = 0, f = l[12103] | l[12104] << 8 | (l[12105] << 16 | l[12106] << 24), r = l[12099] | l[12100] << 8 | (l[12101] << 16 | l[12102] << 24), o[k + 40 | 0] = r, o[k + 41 | 0] = r >>> 8, o[k + 42 | 0] = r >>> 16, o[k + 43 | 0] = r >>> 24, o[k + 44 | 0] = f, o[k + 45 | 0] = f >>> 8, o[k + 46 | 0] = f >>> 16, o[k + 47 | 0] = f >>> 24, f = l[12095] | l[12096] << 8 | (l[12097] << 16 | l[12098] << 24), r = l[12091] | l[12092] << 8 | (l[12093] << 16 | l[12094] << 24), o[k + 32 | 0] = r, o[k + 33 | 0] = r >>> 8, o[k + 34 | 0] = r >>> 16, o[k + 35 | 0] = r >>> 24, o[k + 36 | 0] = f, o[k + 37 | 0] = f >>> 8, o[k + 38 | 0] = f >>> 16, o[k + 39 | 0] = f >>> 24, f = l[12087] | l[12088] << 8 | (l[12089] << 16 | l[12090] << 24), r = l[12083] | l[12084] << 8 | (l[12085] << 16 | l[12086] << 24), o[k + 24 | 0] = r, o[k + 25 | 0] = r >>> 8, o[k + 26 | 0] = r >>> 16, o[k + 27 | 0] = r >>> 24, o[k + 28 | 0] = f, o[k + 29 | 0] = f >>> 8, o[k + 30 | 0] = f >>> 16, o[k + 31 | 0] = f >>> 24, f = l[12079] | l[12080] << 8 | (l[12081] << 16 | l[12082] << 24), r = l[12075] | l[12076] << 8 | (l[12077] << 16 | l[12078] << 24), o[k + 16 | 0] = r, o[k + 17 | 0] = r >>> 8, o[k + 18 | 0] = r >>> 16, o[k + 19 | 0] = r >>> 24, o[k + 20 | 0] = f, o[k + 21 | 0] = f >>> 8, o[k + 22 | 0] = f >>> 16, o[k + 23 | 0] = f >>> 24, f = l[12071] | l[12072] << 8 | (l[12073] << 16 | l[12074] << 24), r = l[12067] | l[12068] << 8 | (l[12069] << 16 | l[12070] << 24), o[k + 8 | 0] = r, o[k + 9 | 0] = r >>> 8, o[k + 10 | 0] = r >>> 16, o[k + 11 | 0] = r >>> 24, o[k + 12 | 0] = f, o[k + 13 | 0] = f >>> 8, o[k + 14 | 0] = f >>> 16, o[k + 15 | 0] = f >>> 24, i0(n, 2, 113, e + 16 | 0), o[e + 27 | 0] >= 0) break e;
                                        X(i[e + 16 >> 2]);
                                        break e;
                                    }
                                    Q8(e + 16 | 0, f, i[r + 36 >> 2], 1684630887), f = i[r + 384 >> 2], f && (i[r + 388 >> 2] = f, X(f)), k = i[e + 16 >> 2], i[r + 384 >> 2] = k, f = i[e + 20 >> 2], i[r + 388 >> 2] = f, i[r + 392 >> 2] = i[e + 24 >> 2];
                                    r: {
                                        A: {
                                            f: {
                                                if ((Z(I[r + 374 >> 1], I[r + 372 >> 1]) | 0) != f - k >> 2) {
                                                    i[e + 24 >> 2] = 59808, i[e + 80 >> 2] = 59828, f = i[14961], i[e + 16 >> 2] = f, w = e + 16 | 0, i[w + i[f - 12 >> 2] >> 2] = i[14962], i[e + 20 >> 2] = 0, f = w + i[i[e + 16 >> 2] - 12 >> 2] | 0, u = e + 28 | 0, T0(f, u), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[e + 24 >> 2] = f, k = e + 24 | 0, i[k + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[e + 16 >> 2] = f, i[w + i[f - 12 >> 2] >> 2] = i[14965], i[e + 80 >> 2] = 59828, i[e + 16 >> 2] = 59788, i[e + 24 >> 2] = 59808, u = z0(u), i[u >> 2] = 58864, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 76 >> 2] = 24, U(M0(U(P0(U(M0(U(M0(U(k, 22008, 17), I[r + 372 >> 1]), 2741, 1), I[r + 374 >> 1]), 17463, 1), Z(I[r + 374 >> 1], I[r + 372 >> 1])), 21248, 17), i[r + 388 >> 2] - i[r + 384 >> 2] >> 2), 10844, 20), r = i[e + 76 >> 2];
                                                    k: {
                                                        if (r & 16) {
                                                            r = i[e + 72 >> 2], f = i[e + 52 >> 2], r >>> 0 < f >>> 0 && (i[e + 72 >> 2] = f, r = f), f = e + 48 | 0;
                                                            break k;
                                                        }
                                                        if (!(r & 8)) {
                                                            r = 0, o[e + 15 | 0] = 0, w = e + 4 | 0;
                                                            break r;
                                                        }
                                                        r = i[e + 44 >> 2], f = e + 36 | 0;
                                                    }
                                                    if (k = i[f >> 2], r = r - k | 0, r >>> 0 >= 2147483640) break f;
                                                    if (r >>> 0 >= 11) {
                                                        f = (r | 7) + 1 | 0, w = D(f), i[e + 12 >> 2] = f | -2147483648, i[e + 4 >> 2] = w, i[e + 8 >> 2] = r;
                                                        break A;
                                                    }
                                                    if (o[e + 15 | 0] = r, w = e + 4 | 0, r) break A;
                                                    r = 0;
                                                    break r;
                                                }
                                                if (r = i[21669], i[n >> 2] = i[21668], i[n + 4 >> 2] = r, f = n + 8 | 0, o[86691] >= 0) {
                                                    r = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = r, i[f + 8 >> 2] = i[21672];
                                                    break e;
                                                }
                                                j(f, i[21670], i[21671]);
                                                break e;
                                            }
                                            Y0(), z();
                                        }
                                        Q0(w, k, r);
                                    }
                                    o[r + w | 0] = 0, i0(n, 2, 119, e + 4 | 0), o[e + 15 | 0] < 0 && X(i[e + 4 >> 2]), r = i[14959], i[e + 16 >> 2] = r, i[i[r - 12 >> 2] + (e + 16 | 0) >> 2] = i[14967], i[e + 24 >> 2] = i[14968], i[u >> 2] = 58864, o[e + 71 | 0] < 0 && X(i[e + 60 >> 2]), x0(u), N0(e + 80 | 0);
                                }
                                if (!h || (r = i[h + 4 >> 2], i[h + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            o[e + 179 | 0] < 0 && X(i[e + 168 >> 2]), r = i[e + 180 >> 2], r && (i[e + 184 >> 2] = r, X(r));
                            i: {
                                if (!s || (r = i[s + 4 >> 2], i[s + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            m = e + 192 | 0, f = A + 8 | 0;
                            i: {
                                if (i[t + 8 >> 2]) {
                                    r = i[t + 12 >> 2], i[A >> 2] = i[t + 8 >> 2], i[A + 4 >> 2] = r, i[f + 8 >> 2] = i[t + 24 >> 2], A = i[t + 20 >> 2], i[f >> 2] = i[t + 16 >> 2], i[f + 4 >> 2] = A, i[t + 24 >> 2] = 0, i[t + 16 >> 2] = 0, i[t + 20 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, o[86691] >= 0) {
                                    A = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = A, i[f + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(f, i[21670], i[21671]);
                            }
                            o[t + 27 | 0] < 0 && X(i[t + 16 >> 2]), m = t + 32 | 0;
                        }
                        function fw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (S0(i[e >> 2], 3) >>> 0 < 9 || S0(i[e >> 2], 4) >>> 0 < 9) break r;
                                        if (S0(i[e >> 2], 5) >>> 0 > 8) break e;
                                    }
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                u = A1(i[e >> 2], 6), n = l[k + 8 | 0];
                                e: {
                                    if (!u) break e;
                                    if (S0(i[e >> 2], 6) >>> 0 <= 8) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                            A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                            break i;
                                        }
                                        j(r, i[21675], i[21676]);
                                        break i;
                                    }
                                    if ((T4(i[e >> 2], 6) | 0) == (T4(i[e >> 2], 4) | 0) && (S4(i[e >> 2], 6) | 0) == (S4(i[e >> 2], 4) | 0)) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                if (w = S0(i[e >> 2], 3), !w) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                r = D(136), i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, k = r - -64 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[r + 132 >> 2] = 0, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, i[r + 72 >> 2] = r + 76, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, i[f + 28 >> 2] = r, k = r + 12 | 0, i[f + 24 >> 2] = k, i[r + 12 >> 2] = k, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 16 >> 2] = r, i[r + 4 >> 2] == -1 && (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), r = i[e >> 2], y = i[r + 24 >> 2], k = y, V = i[r + 28 >> 2], s = i[f + 24 >> 2], r = s, G = n | u, i[r + 36 >> 2] = G & 1 ? 13 : 12, i[r + 32 >> 2] = 1, i[r + 28 >> 2] = V, i[r + 24 >> 2] = k, J0(f, r, 10, k, V, w, t);
                                e: {
                                    if (i[f >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[f + 19 | 0] >= 0) {
                                            A = i[f + 12 >> 2], i[r >> 2] = i[f + 8 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[f + 16 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[f + 8 >> 2], i[f + 12 >> 2]), o[f + 19 | 0] >= 0) break e;
                                        X(i[f + 8 >> 2]);
                                        break e;
                                    }
                                    o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), i[f >> 2] = 0;
                                    r: {
                                        A: {
                                            B = i[e >> 2], e = i[B + 64 >> 2];
                                            f: {
                                                if (!e) {
                                                    n = 0;
                                                    break f;
                                                }
                                                for(r = B - -64 | 0, t = r, k = e; n = i[k + 16 >> 2] < 3, t = n ? t : k, k = i[(n << 2) + k >> 2], !!k;);
                                                n = 0;
                                                k: {
                                                    if ((r | 0) == (t | 0) || (n = 0, i[t + 16 >> 2] > 3)) break k;
                                                    E = i[t + 44 >> 2], n = i[t + 52 >> 2];
                                                }
                                                for(t = r, k = e; _ = i[k + 16 >> 2] < 4, t = _ ? t : k, k = i[(_ << 2) + k >> 2], !!k;);
                                                _ = 0;
                                                k: {
                                                    if ((r | 0) == (t | 0) || (_ = 0, i[t + 16 >> 2] > 4)) break k;
                                                    C = i[t + 52 >> 2], _ = i[t + 44 >> 2];
                                                }
                                                for(k = r; t = i[e + 16 >> 2] < 5, k = t ? k : e, e = i[(t << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (k | 0)) break A;
                                            }
                                            t = 0;
                                            break r;
                                        }
                                        if (t = 0, i[k + 16 >> 2] > 5) break r;
                                        R = i[k + 52 >> 2] >>> 1 | 0, t = i[k + 44 >> 2];
                                    }
                                    e = i[s + 64 >> 2], r = 0;
                                    r: {
                                        if (!e) break r;
                                        for(s = s - -64 | 0, k = s; r = i[e + 16 >> 2] < 10, k = r ? k : e, e = i[(r << 2) + e >> 2], !!e;);
                                        if (r = 0, (k | 0) == (s | 0) || (r = 0, i[k + 16 >> 2] > 10)) break r;
                                        M = i[k + 52 >> 2], r = i[k + 44 >> 2];
                                    }
                                    e = r;
                                    r: {
                                        if (u) {
                                            if (h = V9(B, 6, f), !h) break r;
                                            v = i[f >> 2] >>> 1 | 0;
                                        }
                                        i[f >> 2] = v;
                                        A: {
                                            if (!V | !y) break A;
                                            if (r = G & 1, H = r ? 8 : 6, T = C >>> 1 | 0, S = n >>> 1 | 0, !r) {
                                                for(n = 0;;){
                                                    for(B = e + Z(n, M) | 0, G = t + (Z(n, R) << 1) | 0, C = (Z(n, T) << 1) + _ | 0, s = (Z(n, S) << 1) + E | 0, k = 0; r = k << 1, h = I[r + s >> 1], w = I[r + C >> 1], u = B + Z(k, H) | 0, r = I[r + G >> 1], o[u + 5 | 0] = r, o[u + 3 | 0] = w, o[u + 1 | 0] = h, o[u + 4 | 0] = r >>> 8, o[u + 2 | 0] = w >>> 8, o[u | 0] = h >>> 8, k = k + 1 | 0, (y | 0) != (k | 0););
                                                    if (n = n + 1 | 0, (V | 0) == (n | 0)) break;
                                                }
                                                break A;
                                            }
                                            if (r = 0, u) for(;;){
                                                for(w = Z(r, v), B = e + Z(r, M) | 0, G = t + (Z(r, R) << 1) | 0, C = (Z(r, T) << 1) + _ | 0, s = (Z(r, S) << 1) + E | 0, k = 0; n = k << 1, F = I[n + s >> 1], u = I[n + C >> 1], W = B + Z(k, H) | 0, n = I[n + G >> 1], o[W + 5 | 0] = n, o[W + 3 | 0] = u, o[W + 1 | 0] = F, o[W + 4 | 0] = n >>> 8, o[W + 2 | 0] = u >>> 8, o[W | 0] = F >>> 8, n = I[(k + w << 1) + h >> 1], n = n << 8 | n >>> 8, o[W + 6 | 0] = n, o[W + 7 | 0] = n >>> 8, k = k + 1 | 0, (y | 0) != (k | 0););
                                                if (r = r + 1 | 0, (V | 0) == (r | 0)) break A;
                                            }
                                            for(w = -1 << w ^ -1, B = (w & 65280) >>> 8 | 0;;){
                                                for(G = e + Z(r, M) | 0, C = t + (Z(r, R) << 1) | 0, s = (Z(r, T) << 1) + _ | 0, n = (Z(r, S) << 1) + E | 0, k = 0; h = k << 1, F = I[h + n >> 1], u = I[s + h >> 1], h = I[h + C >> 1], v = G + Z(k, H) | 0, o[v + 7 | 0] = w, o[v + 6 | 0] = B, o[v + 5 | 0] = h, o[v + 3 | 0] = u, o[v + 1 | 0] = F, o[v + 4 | 0] = h >>> 8, o[v + 2 | 0] = u >>> 8, o[v | 0] = F >>> 8, k = k + 1 | 0, (y | 0) != (k | 0););
                                                if (r = r + 1 | 0, (V | 0) == (r | 0)) break;
                                            }
                                        }
                                        S9(A, f + 24 | 0);
                                        break e;
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                    r: {
                                        if (o[86711] >= 0) {
                                            A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                            break r;
                                        }
                                        j(r, i[21675], i[21676]);
                                    }
                                }
                                if (r = i[f + 28 >> 2], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = f + 32 | 0;
                        }
                        function kw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            n = m - 16 | 0, m = n, _ = B2(e);
                            i: {
                                e: {
                                    if (B = X2(e), !B) break e;
                                    for(;;){
                                        if (t = X2(e), t << 24 >> 24 < 0) {
                                            if (r = D(40), i[n + 4 >> 2] = r, i[n + 8 >> 2] = 38, i[n + 12 >> 2] = -2147483608, e = l[13079] | l[13080] << 8 | (l[13081] << 16 | l[13082] << 24), f = l[13075] | l[13076] << 8 | (l[13077] << 16 | l[13078] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 38 | 0] = 0, e = l[13109] | l[13110] << 8 | (l[13111] << 16 | l[13112] << 24), f = l[13105] | l[13106] << 8 | (l[13107] << 16 | l[13108] << 24), o[r + 30 | 0] = f, o[r + 31 | 0] = f >>> 8, o[r + 32 | 0] = f >>> 16, o[r + 33 | 0] = f >>> 24, o[r + 34 | 0] = e, o[r + 35 | 0] = e >>> 8, o[r + 36 | 0] = e >>> 16, o[r + 37 | 0] = e >>> 24, e = l[13103] | l[13104] << 8 | (l[13105] << 16 | l[13106] << 24), f = l[13099] | l[13100] << 8 | (l[13101] << 16 | l[13102] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[13095] | l[13096] << 8 | (l[13097] << 16 | l[13098] << 24), f = l[13091] | l[13092] << 8 | (l[13093] << 16 | l[13094] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13087] | l[13088] << 8 | (l[13089] << 16 | l[13090] << 24), f = l[13083] | l[13084] << 8 | (l[13085] << 16 | l[13086] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 4, 3002, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                            X(i[n + 4 >> 2]);
                                            break i;
                                        }
                                        if (t >>> 0 >= 17) {
                                            if (r = D(56), i[n + 4 >> 2] = r, i[n + 8 >> 2] = 51, i[n + 12 >> 2] = -2147483592, e = l[13027] | l[13028] << 8 | (l[13029] << 16 | l[13030] << 24), f = l[13023] | l[13024] << 8 | (l[13025] << 16 | l[13026] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 51 | 0] = 0, e = l[13070] | l[13071] << 8 | (l[13072] << 16 | l[13073] << 24), o[r + 47 | 0] = e, o[r + 48 | 0] = e >>> 8, o[r + 49 | 0] = e >>> 16, o[r + 50 | 0] = e >>> 24, e = l[13067] | l[13068] << 8 | (l[13069] << 16 | l[13070] << 24), f = l[13063] | l[13064] << 8 | (l[13065] << 16 | l[13066] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[13059] | l[13060] << 8 | (l[13061] << 16 | l[13062] << 24), f = l[13055] | l[13056] << 8 | (l[13057] << 16 | l[13058] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[13051] | l[13052] << 8 | (l[13053] << 16 | l[13054] << 24), f = l[13047] | l[13048] << 8 | (l[13049] << 16 | l[13050] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[13043] | l[13044] << 8 | (l[13045] << 16 | l[13046] << 24), f = l[13039] | l[13040] << 8 | (l[13041] << 16 | l[13042] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13035] | l[13036] << 8 | (l[13037] << 16 | l[13038] << 24), f = l[13031] | l[13032] << 8 | (l[13033] << 16 | l[13034] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 4, 3002, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                            X(i[n + 4 >> 2]);
                                            break i;
                                        }
                                        r: {
                                            s = i[r + 104 >> 2], k = i[r + 108 >> 2];
                                            A: {
                                                if (s >>> 0 < k >>> 0) {
                                                    o[s | 0] = t, u = s + 1 | 0;
                                                    break A;
                                                }
                                                if (h = i[r + 100 >> 2], w = s - h | 0, f = w + 1 | 0, (f | 0) < 0) break r;
                                                k = k - h | 0, u = k << 1, u = k >>> 0 >= 1073741823 ? 2147483647 : f >>> 0 < u >>> 0 ? u : f, u ? k = D(u) : k = 0, f = w + k | 0, o[f | 0] = t, W = k + u | 0, u = f + 1 | 0;
                                                f: {
                                                    if ((s | 0) == (h | 0)) {
                                                        k = f;
                                                        break f;
                                                    }
                                                    if (v = 0, t = s, w = w & 3, w) for(; f = f - 1 | 0, t = t - 1 | 0, o[f | 0] = l[t | 0], v = v + 1 | 0, (w | 0) != (v | 0););
                                                    if (h - s >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[t - 1 | 0], o[f - 2 | 0] = l[t - 2 | 0], o[f - 3 | 0] = l[t - 3 | 0], f = f - 4 | 0, t = t - 4 | 0, o[f | 0] = l[t | 0], (t | 0) != (h | 0););
                                                    h = i[r + 100 >> 2];
                                                }
                                                if (i[r + 108 >> 2] = W, i[r + 104 >> 2] = u, i[r + 100 >> 2] = k, !h) break A;
                                                X(h);
                                            }
                                            if (i[r + 104 >> 2] = u, G = G + 1 | 0, (G & 255) >>> 0 < B >>> 0) continue;
                                            break e;
                                        }
                                        break;
                                    }
                                    p0(), z();
                                }
                                e: {
                                    if (!_) break e;
                                    for(h = r + 112 | 0, f = 0;;){
                                        r: {
                                            i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, k = i[r + 116 >> 2];
                                            A: {
                                                if (k >>> 0 < k0[r + 120 >> 2]) {
                                                    if (i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, t = i[n + 8 >> 2], w = i[n + 4 >> 2], (t | 0) != (w | 0)) {
                                                        if (t = t - w | 0, (t | 0) < 0) break r;
                                                        s = D(t), i[k + 4 >> 2] = s, i[k >> 2] = s, u = t + s | 0, i[k + 8 >> 2] = u, v0(s, w, t), i[k + 4 >> 2] = u;
                                                    }
                                                    k = k + 12 | 0;
                                                    break A;
                                                }
                                                k = B6(h, n + 4 | 0);
                                            }
                                            if (i[r + 116 >> 2] = k, k = i[n + 4 >> 2], k && (i[n + 8 >> 2] = k, X(k)), f = f + 1 | 0, (f & 65535) >>> 0 < _ >>> 0) continue;
                                            break e;
                                        }
                                        break;
                                    }
                                    p0(), z();
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(A, 2, 100, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                    X(i[n + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 16 | 0;
                        }
                        function f1(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0;
                            w = m - 96 | 0, m = w, E = s & 65535, G = (k ^ s) & -2147483648, V = k & 65535, T = V, g0 = s >>> 16 & 32767, R0 = k >>> 16 & 32767;
                            i: {
                                e: {
                                    if (g0 - 32767 >>> 0 > 4294934529 & R0 - 32767 >>> 0 >= 4294934530) break e;
                                    if (y = k & 2147483647, C = y, h = f, !(!f & (C | 0) == 2147418112 ? !(r | e) : C >>> 0 < 2147418112)) {
                                        _ = f, G = k | 32768;
                                        break i;
                                    }
                                    if (y = s & 2147483647, W = y, k = u, !(!k & (W | 0) == 2147418112 ? !(n | t) : W >>> 0 < 2147418112)) {
                                        _ = k, G = s | 32768, r = n, e = t;
                                        break i;
                                    }
                                    if (!(r | h | (C ^ 2147418112 | e))) {
                                        if (!(k | n | (t | W))) {
                                            G = 2147450880, r = 0, e = 0;
                                            break i;
                                        }
                                        G = G | 2147418112, r = 0, e = 0;
                                        break i;
                                    }
                                    if (!(k | n | (W ^ 2147418112 | t))) {
                                        if (k = r | h, f = e | C, r = 0, e = 0, !(f | k)) {
                                            G = 2147450880;
                                            break i;
                                        }
                                        G = G | 2147418112;
                                        break i;
                                    }
                                    if (!(r | h | (e | C))) {
                                        r = 0, e = 0;
                                        break i;
                                    }
                                    if (!(k | n | (t | W))) {
                                        r = 0, e = 0;
                                        break i;
                                    }
                                    if ((C | 0) == 65535 | C >>> 0 < 65535 && (h = !(f | V), s = h ? r : f, y = h << 6, k = e1(s) + 32 | 0, s = e1(h ? e : V), s = y + ((s | 0) == 32 ? k : s) | 0, P1(w + 80 | 0, r, e, f, V, s - 15 | 0), F = 16 - s | 0, f = i[w + 88 >> 2], T = i[w + 92 >> 2], e = i[w + 84 >> 2], r = i[w + 80 >> 2]), W >>> 0 > 65535) break e;
                                    s = !(u | E), k = s ? n : u, V = s << 6, h = e1(k) + 32 | 0, k = e1(s ? t : E), k = V + ((k | 0) == 32 ? h : k) | 0, P1(w - -64 | 0, n, t, u, E, k - 15 | 0), F = (F - k | 0) + 16 | 0, u = i[w + 72 >> 2], E = i[w + 76 >> 2], n = i[w + 64 >> 2], t = i[w + 68 >> 2];
                                }
                                k = n, n = t << 15 | n >>> 17, s = k << 15, k = 0, R = s & -32768, m0 = e, y = O0(R, k, e, 0), k = w0, S = k, Z0 = n, C = r, e = O0(n, 0, r, 0), r = e + y | 0, n = w0 + k | 0, s = r, e = r >>> 0 < e >>> 0 ? n + 1 | 0 : n, n = r, h = 0, r = O0(C, v, R, v), W = h + r | 0, k = w0 + n | 0, k = r >>> 0 > W >>> 0 ? k + 1 | 0 : k, V = k, X0 = (n | 0) == (k | 0) & h >>> 0 > W >>> 0 | k >>> 0 < n >>> 0, V0 = f, M = O0(R, v, f, 0), I0 = w0, r = O0(m0, v, Z0, v), H = r + M | 0, h = w0 + I0 | 0, h = r >>> 0 > H >>> 0 ? h + 1 | 0 : h, r = E << 15 | u >>> 17, P = u << 15 | t >>> 17, f = O0(P, 0, C, v), $ = f + H | 0, n = w0 + h | 0, n = f >>> 0 > $ >>> 0 ? n + 1 | 0 : n, c = n, f = (e | 0) == (S | 0) & s >>> 0 < y >>> 0 | e >>> 0 < S >>> 0, r0 = e + $ | 0, n = f + n | 0, n = e >>> 0 > r0 >>> 0 ? n + 1 | 0 : n, E = n, t = r0, e = n, f0 = T | 65536, T = O0(R, v, f0, B), F0 = w0, f = O0(V0, _, Z0, v), t0 = f + T | 0, k = w0 + F0 | 0, k = f >>> 0 > t0 >>> 0 ? k + 1 | 0 : k, s = k, s0 = r | -2147483648, r = O0(s0, 0, C, v), L = r + t0 | 0, n = w0 + k | 0, n = r >>> 0 > L >>> 0 ? n + 1 | 0 : n, f = O0(P, _, m0, v), r = f + L | 0, q = n, n = n + w0 | 0, S = r, y = r >>> 0 < f >>> 0 ? n + 1 | 0 : n, n = r, r = 0, C = r + t | 0, k = e + n | 0, k = r >>> 0 > C >>> 0 ? k + 1 | 0 : k, R = k, n = k, r = C + X0 | 0, e = r >>> 0 < C >>> 0 ? n + 1 | 0 : n, F = ((R0 + g0 | 0) + F | 0) - 16383 | 0, f = O0(s0, _, m0, v), u = w0, k = O0(f0, _, Z0, v), t = k + f | 0, n = w0 + u | 0, n = k >>> 0 > t >>> 0 ? n + 1 | 0 : n, B = (u | 0) == (n | 0) & f >>> 0 > t >>> 0 | n >>> 0 < u >>> 0, u = n, k = O0(P, _, V0, _), f = k + t | 0, n = w0 + n | 0, n = f >>> 0 < k >>> 0 ? n + 1 | 0 : n, k = n, t = (n | 0) == (u | 0) & f >>> 0 < t >>> 0 | n >>> 0 < u >>> 0, n = 0, u = t, t = t + B | 0, n = u >>> 0 > t >>> 0 ? 1 : n, u = t, t = O0(s0, _, f0, _), u = u + t | 0, n = w0 + n | 0, X0 = u, t = t >>> 0 > u >>> 0 ? n + 1 | 0 : n, u = f, v = k, k = (h | 0) == (I0 | 0) & M >>> 0 > H >>> 0 | h >>> 0 < I0 >>> 0, n = 0, h = (h | 0) == (c | 0) & H >>> 0 > $ >>> 0 | h >>> 0 > c >>> 0, B = h, h = k + h | 0, k = (B >>> 0 > h >>> 0 ? 1 : n) + v | 0, n = t, f = f + h | 0, k = f >>> 0 < h >>> 0 ? k + 1 | 0 : k, B = k, M = f, f = (k | 0) == (v | 0) & f >>> 0 < u >>> 0 | k >>> 0 < v >>> 0, k = f, f = f + X0 | 0, n = k >>> 0 > f >>> 0 ? n + 1 | 0 : n, h = f, u = n, k = O0(P, _, f0, _), v = w0, t = O0(s0, _, V0, _), f = t + k | 0, n = w0 + v | 0, n = f >>> 0 < t >>> 0 ? n + 1 | 0 : n, t = n, n = (v | 0) == (n | 0) & f >>> 0 < k >>> 0 | n >>> 0 < v >>> 0, H = t + h | 0, k = n + u | 0, k = t >>> 0 > H >>> 0 ? k + 1 | 0 : k, v = H, u = k, h = f, k = 0, f = k + M | 0, n = h + B | 0, n = f >>> 0 < k >>> 0 ? n + 1 | 0 : n, k = n, t = (B | 0) == (n | 0) & f >>> 0 < M >>> 0 | n >>> 0 < B >>> 0, n = u, u = t, t = t + v | 0, n = u >>> 0 > t >>> 0 ? n + 1 | 0 : n, M = t, t = n, u = f, h = k, k = (y | 0) == (q | 0) & S >>> 0 < L >>> 0 | y >>> 0 < q >>> 0, f = (s | 0) == (F0 | 0) & T >>> 0 > t0 >>> 0 | s >>> 0 < F0 >>> 0, s = (s | 0) == (q | 0) & t0 >>> 0 > L >>> 0 | s >>> 0 > q >>> 0, f = f + s | 0, f = f + k | 0, B = y, s = B + u | 0, k = f + h | 0, n = t, f = s, k = f >>> 0 < B >>> 0 ? k + 1 | 0 : k, u = (k | 0) == (h | 0) & u >>> 0 > f >>> 0 | k >>> 0 < h >>> 0, t = u + M | 0, n = u >>> 0 > t >>> 0 ? n + 1 | 0 : n, h = t, t = n, u = f, n = 0, s = k, B = (E | 0) == (R | 0) & C >>> 0 < r0 >>> 0 | E >>> 0 > R >>> 0, v = B, B = B + ((E | 0) == (c | 0) & $ >>> 0 > r0 >>> 0 | E >>> 0 < c >>> 0) | 0, k = k + (v >>> 0 > B >>> 0 ? 1 : n) | 0, n = t, f = f + B | 0, k = f >>> 0 < B >>> 0 ? k + 1 | 0 : k, u = (k | 0) == (s | 0) & f >>> 0 < u >>> 0 | k >>> 0 < s >>> 0, t = u, u = u + h | 0, n = t >>> 0 > u >>> 0 ? n + 1 | 0 : n, s = n;
                                e: {
                                    if (n & 65536) {
                                        F = F + 1 | 0;
                                        break e;
                                    }
                                    h = V >>> 31 | 0, t = 0, n = s << 1 | u >>> 31, u = u << 1 | k >>> 31, s = n, n = k << 1 | f >>> 31, f = f << 1 | e >>> 31, k = n, n = V << 1 | W >>> 31, W = W << 1, V = n, n = e << 1 | r >>> 31, r = r << 1 | h, e = n | t;
                                }
                                if ((F | 0) >= 32767) {
                                    G = G | 2147418112, r = 0, e = 0;
                                    break i;
                                }
                                e: {
                                    if ((F | 0) <= 0) {
                                        if (t = 1 - F | 0, t >>> 0 <= 127) {
                                            n = F + 127 | 0, P1(w + 48 | 0, W, V, r, e, n), P1(w + 32 | 0, f, k, u, s, n), d8(w + 16 | 0, W, V, r, e, t), d8(w, f, k, u, s, t), W = i[w + 32 >> 2] | i[w + 16 >> 2] | (i[w + 48 >> 2] | i[w + 56 >> 2] | (i[w + 52 >> 2] | i[w + 60 >> 2])) != 0, V = i[w + 36 >> 2] | i[w + 20 >> 2], r = i[w + 40 >> 2] | i[w + 24 >> 2], e = i[w + 44 >> 2] | i[w + 28 >> 2], f = i[w >> 2], k = i[w + 4 >> 2], t = i[w + 8 >> 2], n = i[w + 12 >> 2];
                                            break e;
                                        }
                                        r = 0, e = 0;
                                        break i;
                                    }
                                    t = u, n = s & 65535 | F << 16;
                                }
                                if (_ = t | _, G = n | G, !(!r & (e | 0) == -2147483648 ? !(W | V) : (e | 0) > 0 | (e | 0) >= 0)) {
                                    r = f + 1 | 0, h = r ? k : k + 1 | 0, k = G, e = h, f = !(h | r), _ = f + _ | 0, G = f >>> 0 > _ >>> 0 ? k + 1 | 0 : k;
                                    break i;
                                }
                                if (r | W | (e ^ -2147483648 | V)) {
                                    r = f, e = k;
                                    break i;
                                }
                                n = k, r = f & 1, e = r, r = r + f | 0, e = e >>> 0 > r >>> 0 ? n + 1 | 0 : n, f = (n | 0) == (e | 0) & r >>> 0 < f >>> 0 | e >>> 0 < n >>> 0, n = G, _ = f + _ | 0, G = _ >>> 0 < f >>> 0 ? n + 1 | 0 : n;
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = _, i[A + 12 >> 2] = G, m = w + 96 | 0;
                        }
                        function z7(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            v = m - 48 | 0, m = v, _ = i[k >> 2];
                            i: {
                                e: {
                                    if (n) {
                                        if (_) break e;
                                        y0(4218, 15041, 242, 11480), z();
                                    }
                                    if (!_) break i;
                                }
                                if (B = i[k + 4 >> 2], B && (i[B + 4 >> 2] = i[B + 4 >> 2] + 1), i[A + 124 >> 2] = _, _ = i[A + 128 >> 2], i[A + 128 >> 2] = B, !_ || (B = i[_ + 4 >> 2], i[_ + 4 >> 2] = B - 1, B)) break i;
                                p[i[i[_ >> 2] + 8 >> 2]](_), g(_);
                            }
                            a3(A), G = 1, B = i[21900], i[21900] = B + 1, i[A + 112 >> 2] = t, i[A + 108 >> 2] = 2147483647, i[A >> 2] = B, i[A + 288 >> 2] = h, i[A + 36 >> 2] = e, i[A + 32 >> 2] = r, i[A + 28 >> 2] = e, i[A + 24 >> 2] = r, i[A + 20 >> 2] = f, i[A + 280 >> 2] = u, i[A + 284 >> 2] = s;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: switch(f | 0){
                                                            default:
                                                                y0(18461, 15041, 278, 11480), z();
                                                            case 1:
                                                                G = 2, i[v + 8 >> 2] = 2, V = (e + 1 | 0) / 2 | 0, i[A + 36 >> 2] = V, W = (r + 1 | 0) / 2 | 0, i[A + 32 >> 2] = W, h = 2, f = 2;
                                                                break k;
                                                            case 2:
                                                                i[v + 8 >> 2] = 3, G = 2, W = (r + 1 | 0) / 2 | 0, i[A + 32 >> 2] = W, h = 1;
                                                                break n;
                                                            case 3:
                                                                break t;
                                                            case 0:
                                                                break f;
                                                        }
                                                        i[v + 8 >> 2] = 4, W = r, h = 1;
                                                    }
                                                    V = e, f = 1;
                                                }
                                                if (o[A + 51 | 0] = h, o[A + 50 | 0] = G, h = i[k >> 2], !h) {
                                                    i[v + 20 >> 2] = 16, i[v + 16 >> 2] = e, i[v + 12 >> 2] = r, y = 1;
                                                    break A;
                                                }
                                                if (i[h + 16852 >> 2] != (G | 0)) break r;
                                                if (i[h + 16856 >> 2] == (f | 0)) {
                                                    i[v + 20 >> 2] = 16, i[v + 16 >> 2] = e, i[v + 12 >> 2] = r;
                                                    break e;
                                                }
                                                y0(16430, 15041, 318, 11480), z();
                                            }
                                            if (y = 1, i[v + 8 >> 2] = 1, Q[A + 50 >> 1] = 257, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, h = i[k >> 2], i[v + 20 >> 2] = 16, i[v + 16 >> 2] = e, i[v + 12 >> 2] = r, h) {
                                                f = 1;
                                                break e;
                                            }
                                            f = 1;
                                        }
                                        h = 0, u = 0;
                                        break i;
                                    }
                                    y0(16460, 15041, 317, 11480), z();
                                }
                                E = i[h + 508 >> 2], F = i[h + 504 >> 2], R = i[h + 500 >> 2], y = 0, u = i[h + 496 >> 2];
                            }
                            C = 8, M = u + R | 0, _ = Z(M, G);
                            i: {
                                if ((_ | 0) >= (r | 0) || (B = F + E | 0, s = Z(B, f), (s | 0) >= (e | 0))) break i;
                                i[A + 88 >> 2] = V - B, i[A + 84 >> 2] = W - M, e = e - s | 0, i[A + 80 >> 2] = e, r = r - _ | 0, i[A + 76 >> 2] = r, i[v + 44 >> 2] = e, i[v + 40 >> 2] = r, i[v + 36 >> 2] = Z(f, E), s = Z(f, F), i[v + 32 >> 2] = s, i[v + 28 >> 2] = Z(G, R), f = Z(u, G), i[v + 24 >> 2] = f, r = 8, e = 8, y || (e = i[h + 16840 >> 2], r = i[h + 16832 >> 2]), o[A + 49 | 0] = e, o[A + 48 | 0] = r, e = (e & 255) >>> 0 > 8, o[A + 18 | 0] = e, o[A + 17 | 0] = e, o[A + 16 | 0] = (r & 255) >>> 0 > 8, r = 0;
                                e: {
                                    r: {
                                        if (!t || (r = i[t + 544 >> 2], !w)) break r;
                                        w = i[t + 540 >> 2], e = i[t + 536 >> 2];
                                        break e;
                                    }
                                    w = i[21511], e = i[21510];
                                }
                                i[A + 304 >> 2] = e, i[A + 308 >> 2] = w;
                                e: {
                                    if (!e) break e;
                                    e = p[e | 0](t, v + 8 | 0, A, r) | 0, i[A + 64 >> 2] = (f + i[A + 4 >> 2] | 0) + Z(s, i[A + 40 >> 2]);
                                    r: {
                                        if (!i[A + 20 >> 2]) {
                                            G = 0, r = 0;
                                            break r;
                                        }
                                        r = Z(i[A + 44 >> 2], F), G = r + (i[A + 12 >> 2] + u | 0) | 0, r = r + (i[A + 8 >> 2] + u | 0) | 0;
                                    }
                                    if (i[A + 72 >> 2] = G, i[A + 68 >> 2] = r, e) break e;
                                    C = 7;
                                    break i;
                                }
                                e: {
                                    if (!n) break e;
                                    r = i[A + 200 >> 2], n = i[h + 16944 >> 2], f = i[h + 16952 >> 2], e = i[h + 16948 >> 2], t = Z(f, e);
                                    r: {
                                        if ((t | 0) != i[A + 204 >> 2]) {
                                            if (X(r), r = Q2(t), i[A + 200 >> 2] = r, !r) {
                                                i[A + 204 >> 2] = 0, e = 0;
                                                break r;
                                            }
                                            i[A + 204 >> 2] = t;
                                        }
                                        i[A + 216 >> 2] = f, i[A + 212 >> 2] = e, i[A + 208 >> 2] = n, e = (r | 0) != 0;
                                    }
                                    r = i[A + 220 >> 2], t = i[h + 16944 >> 2], n = i[h + 16952 >> 2], f = i[h + 16948 >> 2], u = Z(n, f);
                                    r: {
                                        if ((u | 0) != i[A + 224 >> 2]) {
                                            if (X(r), r = Q2(u), i[A + 220 >> 2] = r, !r) {
                                                i[A + 224 >> 2] = 0, r = 0;
                                                break r;
                                            }
                                            i[A + 224 >> 2] = u;
                                        }
                                        i[A + 236 >> 2] = n, i[A + 232 >> 2] = f, i[A + 228 >> 2] = t, r = (r | 0) != 0;
                                    }
                                    t = r & e, r = i[A + 160 >> 2], n = i[h + 16872 >> 2], f = i[h + 16896 >> 2], e = i[h + 16888 >> 2], u = Z(f, e);
                                    r: {
                                        if ((u | 0) != i[A + 164 >> 2]) {
                                            if (X(r), r = Q2(Z(u, 3)), i[A + 160 >> 2] = r, !r) {
                                                i[A + 164 >> 2] = 0, r = 0;
                                                break r;
                                            }
                                            i[A + 164 >> 2] = u;
                                        }
                                        i[A + 176 >> 2] = f, i[A + 172 >> 2] = e, i[A + 168 >> 2] = n, r = (r | 0) != 0;
                                    }
                                    n = r & t, r = i[A + 180 >> 2], e = i[h + 16872 >> 2] - 2 | 0, f = i[h + 16896 >> 2] << e, e = i[h + 16888 >> 2] << e, t = Z(f, e);
                                    r: {
                                        if ((t | 0) != i[A + 184 >> 2]) {
                                            if (X(r), r = Q2(Z(t, 12)), i[A + 180 >> 2] = r, !r) {
                                                i[A + 184 >> 2] = 0, r = 0;
                                                break r;
                                            }
                                            i[A + 184 >> 2] = t;
                                        }
                                        i[A + 196 >> 2] = f, i[A + 192 >> 2] = e, i[A + 188 >> 2] = 2, r = (r | 0) != 0;
                                    }
                                    t = r & n, r = i[A + 240 >> 2], n = i[h + 16936 >> 2], f = i[h + 16928 >> 2], e = i[h + 16924 >> 2], u = Z(f, e);
                                    r: {
                                        if ((u | 0) != i[A + 244 >> 2]) {
                                            if (X(r), r = Q2(u), i[A + 240 >> 2] = r, !r) {
                                                i[A + 244 >> 2] = 0, r = 0;
                                                break r;
                                            }
                                            i[A + 244 >> 2] = u;
                                        }
                                        i[A + 256 >> 2] = f, i[A + 252 >> 2] = e, i[A + 248 >> 2] = n, r = (r | 0) != 0;
                                    }
                                    n = r & t, r = i[A + 260 >> 2], f = (i[h + 488 >> 2] + 3 | 0) / 4 | 0, e = (i[h + 484 >> 2] + 3 | 0) / 4 | 0, t = Z(f, e);
                                    r: {
                                        if ((t | 0) != i[A + 264 >> 2]) {
                                            if (X(r), r = Q2(t), i[A + 260 >> 2] = r, !r) {
                                                i[A + 264 >> 2] = 0, r = 0;
                                                break r;
                                            }
                                            i[A + 264 >> 2] = t;
                                        }
                                        i[A + 276 >> 2] = f, i[A + 272 >> 2] = e, i[A + 268 >> 2] = 2, r = (r | 0) != 0;
                                    }
                                    if (t = r & n, h = i[k >> 2], e = i[h + 16892 >> 2], !((e | 0) == i[A + 152 >> 2] & i[A + 156 >> 2] == i[h + 16900 >> 2])) {
                                        if (f = i[A + 320 >> 2], f) {
                                            if (e = f - 4 | 0, r = i[e >> 2], r) {
                                                for(h = f + Z(r, 76) | 0; h = h - 76 | 0, (f | 0) != (h | 0););
                                                h = i[k >> 2];
                                            }
                                            X(e), e = i[h + 16892 >> 2];
                                        }
                                        r = i[A + 140 >> 2], n = i[h + 16876 >> 2], f = i[h + 16900 >> 2], h = Z(f, e);
                                        r: {
                                            if ((h | 0) != i[A + 144 >> 2]) {
                                                if (X(r), r = Q2(Z(h, 24)), i[A + 140 >> 2] = r, !r) {
                                                    h = 0, i[A + 144 >> 2] = 0, r = 0;
                                                    break r;
                                                }
                                                i[A + 144 >> 2] = h;
                                            }
                                            i[A + 156 >> 2] = f, i[A + 152 >> 2] = e, i[A + 148 >> 2] = n, r = (r | 0) != 0;
                                        }
                                        if (e = O0(h, 0, 76, 0), f = e + 4 | 0, e = D(w0 || e >>> 0 > f >>> 0 ? -1 : f), i[e >> 2] = h, e = e + 4 | 0, h) for(f = e + Z(h, 76) | 0, h = e; i[h >> 2] = 0, h = h + 76 | 0, (f | 0) != (h | 0););
                                        if (i[A + 320 >> 2] = e, C = 7, r & t) break e;
                                        break i;
                                    }
                                    if (C = 7, !t) break i;
                                }
                                C = 0;
                            }
                            r = i[k + 4 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = v + 48 | 0, C;
                        }
                        function nw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = J(0), q = J(0), m0 = J(0), Z0 = J(0);
                            u = m - 48 | 0, m = u;
                            i: {
                                e: {
                                    r: {
                                        if ((S0(i[e >> 2], 0) | 0) != 8 || (S0(i[e >> 2], 1) | 0) != 8) break r;
                                        if ((S0(i[e >> 2], 2) | 0) == 8) break e;
                                    }
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = D(136), r = n, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), s = i[r + 4 >> 2], f = s + 1 | 0, i[r + 4 >> 2] = f, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, k = n + 76 | 0, i[n + 72 >> 2] = k, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, v = n + 12 | 0, i[n + 12 >> 2] = v, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = s, i[n + 16 >> 2] = n, f || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), r = i[e >> 2], V = i[r + 24 >> 2], f = V, y = i[r + 28 >> 2], r = y, i[v + 36 >> 2] = 11, i[v + 32 >> 2] = 1, i[v + 28 >> 2] = r, i[v + 24 >> 2] = f, J0(u + 24 | 0, v, 10, f, r, 8, t);
                                e: {
                                    if (i[u + 24 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 28 >> 2], i[A + 8 >> 2] = i[u + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 43 | 0] >= 0) {
                                            A = i[u + 36 >> 2], i[r >> 2] = i[u + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 40 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 32 >> 2], i[u + 36 >> 2]), o[u + 43 | 0] >= 0) break e;
                                        X(i[u + 32 >> 2]);
                                        break e;
                                    }
                                    o[u + 43 | 0] < 0 && X(i[u + 32 >> 2]), r = i[e >> 2], f = i[r + 44 >> 2], w = i[r + 48 >> 2], w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1), i[u + 36 >> 2] = -1086926434, i[u + 40 >> 2] = 1071829221, i[u + 28 >> 2] = 1068725436, i[u + 32 >> 2] = -1095748968, o[u + 24 | 0] = 1, f && (Xi(u + 4 | 0, I[f + 8 >> 1], I[f + 4 >> 1]), i[u + 40 >> 2] = i[u + 20 >> 2], r = i[u + 16 >> 2], i[u + 32 >> 2] = i[u + 12 >> 2], i[u + 36 >> 2] = r, r = i[u + 8 >> 2], i[u + 24 >> 2] = i[u + 4 >> 2], i[u + 28 >> 2] = r), L = W0[u + 40 >> 2], q = W0[u + 32 >> 2], m0 = W0[u + 36 >> 2], Z0 = W0[u + 28 >> 2], s = A1(i[e >> 2], 6), r = i[e >> 2], t = i[r + 64 >> 2], S = N8(J(L * J(256))), P = N8(J(q * J(256))), $ = N8(J(m0 * J(256))), c = N8(J(Z0 * J(256)));
                                    r: {
                                        A: {
                                            if (t) {
                                                for(r = r - -64 | 0, f = r, e = t; h = i[e + 16 >> 2], f = (h | 0) < 0 ? f : e, e = i[(h >>> 29 & 4) + e >> 2], !!e;);
                                                B = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (B = 0, i[f + 16 >> 2] > 0)) break f;
                                                    r0 = i[f + 52 >> 2], B = i[f + 44 >> 2];
                                                }
                                                for(f = r, e = t; h = i[e + 16 >> 2] <= 0, f = h ? f : e, e = i[(h << 2) + e >> 2], !!e;);
                                                G = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (G = 0, i[f + 16 >> 2] > 1)) break f;
                                                    f0 = i[f + 44 >> 2], G = i[f + 52 >> 2];
                                                }
                                                for(f = r, e = t; h = i[e + 16 >> 2] < 2, f = h ? f : e, e = i[(h << 2) + e >> 2], !!e;);
                                                e = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (e = 0, i[f + 16 >> 2] > 2)) break f;
                                                    t0 = i[f + 52 >> 2], e = i[f + 44 >> 2];
                                                }
                                                if (h = e, f = 0, !t | s ^ 1) break r;
                                                for(e = r; f = i[t + 16 >> 2] < 6, e = f ? e : t, t = i[(f << 2) + t >> 2], !!t;);
                                                if ((r | 0) != (e | 0)) break A;
                                            }
                                            f = 0;
                                            break r;
                                        }
                                        if (f = 0, i[e + 16 >> 2] > 6) break r;
                                        C = i[e + 52 >> 2], f = i[e + 44 >> 2];
                                    }
                                    e = i[k >> 2], r = 0;
                                    r: {
                                        if (!e) break r;
                                        for(t = k; r = i[e + 16 >> 2] < 10, t = r ? t : e, e = i[(r << 2) + e >> 2], !!e;);
                                        if (r = 0, (k | 0) == (t | 0) || (r = 0, i[t + 16 >> 2] > 10)) break r;
                                        s0 = i[t + 52 >> 2], r = i[t + 44 >> 2];
                                    }
                                    k = r;
                                    r: {
                                        if (!y | !V) break r;
                                        if (r = 0, s) for(;;){
                                            for(W = Z(r, C), E = k + Z(r, s0) | 0, R = Z(r, r0) + B | 0, e = r >>> 1 | 0, M = Z(e, t0) + h | 0, H = Z(e, G) + f0 | 0, e = 0; s = e >>> 1 | 0, t = l[s + M | 0], F = E + (e << 2) | 0, T = l[e + R | 0], s = l[s + H | 0] - 128 | 0, _ = T + (Z(s, S) + 128 >> 8) | 0, o[F + 2 | 0] = (_ | 0) >= 0 ? _ >>> 0 >= 255 ? 255 : _ : 0, t = t - 128 | 0, _ = T + (Z(t, c) + 128 >> 8) | 0, o[F | 0] = (_ | 0) >= 0 ? _ >>> 0 >= 255 ? 255 : _ : 0, t = T + ((Z(s, P) + Z(t, $) | 0) + 128 >> 8) | 0, o[F + 1 | 0] = (t | 0) >= 0 ? t >>> 0 >= 255 ? 255 : t : 0, o[F + 3 | 0] = l[f + (e + W | 0) | 0], e = e + 1 | 0, (V | 0) != (e | 0););
                                            if (r = r + 1 | 0, (y | 0) == (r | 0)) break r;
                                        }
                                        for(;;){
                                            for(E = k + Z(r, s0) | 0, R = Z(r, r0) + B | 0, e = r >>> 1 | 0, M = Z(e, t0) + h | 0, H = Z(e, G) + f0 | 0, e = 0; f = e >>> 1 | 0, s = l[f + M | 0], C = l[e + R | 0], f = l[f + H | 0], W = E + (e << 2) | 0, o[W + 3 | 0] = 255, t = f - 128 | 0, f = C + (Z(t, S) + 128 >> 8) | 0, o[W + 2 | 0] = (f | 0) >= 0 ? f >>> 0 >= 255 ? 255 : f : 0, f = s - 128 | 0, s = C + (Z(f, c) + 128 >> 8) | 0, o[W | 0] = (s | 0) >= 0 ? s >>> 0 >= 255 ? 255 : s : 0, f = C + ((Z(t, P) + Z(f, $) | 0) + 128 >> 8) | 0, o[W + 1 | 0] = (f | 0) >= 0 ? f >>> 0 >= 255 ? 255 : f : 0, e = e + 1 | 0, (V | 0) != (e | 0););
                                            if (r = r + 1 | 0, (y | 0) == (r | 0)) break;
                                        }
                                    }
                                    i[A + 4 >> 2] = n, i[A >> 2] = v, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(r, i[21670], i[21671]);
                                    }
                                    if (!w || (A = i[w + 4 >> 2], i[w + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                                }
                                if (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            m = u + 48 | 0;
                        }
                        function tw(A, r, e, f, k, n, t, u, s, h) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0;
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            B = h - 8 | 0, _ = n + 3 | 0, R = m - ((Z(_, k) << 1) + 15 & -16) | 0;
                            i: {
                                if ((n | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(C = e - 2 | 0, E = R + 2 | 0, e = n + 2 | 0, V = (e | 0) > 0 ? e : 0, T = k & 2147483646, S = k & 1, y = k - t & 3, G = -1, F = k - 1 | 0, P = F - t >>> 0 < 3;;){
                                        v = E + (G << 1) | 0, h = C + (Z(f, G) << 1) | 0;
                                        e: {
                                            r: {
                                                A: switch(t | 0){
                                                    case 0:
                                                        if (s = 0, e = t, y) for(; Q[v + (Z(e, _) << 1) >> 1] = I[h + 2 >> 1], e = e + 1 | 0, h = h + 2 | 0, s = s + 1 | 0, (y | 0) != (s | 0););
                                                        if (P) break e;
                                                        for(; Q[v + (Z(e, _) << 1) >> 1] = I[h + 2 >> 1], Q[v + (Z(e + 1 | 0, _) << 1) >> 1] = I[h + 4 >> 1], Q[v + (Z(e + 2 | 0, _) << 1) >> 1] = I[h + 6 >> 1], Q[v + (Z(e + 3 | 0, _) << 1) >> 1] = I[h + 8 >> 1], h = h + 8 | 0, e = e + 4 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    default:
                                                        for(s = I[h >> 1], e = 0; w = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = (Z(I[h + 4 >> 1], 58) + Z(w, 10) | 0) - (I[h + 6 >> 1] + (s & 65535) << 1) >> B, h = h + 2 | 0, s = w, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 1:
                                                        for(s = I[h >> 1], e = 0; w = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = (Z(I[h + 4 >> 1], 10) + Z(w, 58) | 0) - (I[h + 6 >> 1] + (s & 65535) << 1) >> B, h = h + 2 | 0, s = w, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 2:
                                                        for(s = I[h >> 1], e = 0; w = s & 65535, s = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = Z(s, 54) + (I[h + 4 >> 1] << 4) - ((w << 2) + (I[h + 6 >> 1] << 1)) >> B, h = h + 2 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 3:
                                                        for(s = I[h >> 1], e = 0; w = s & 65535, s = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = ((Z(s, 46) + Z(w, -6) | 0) + Z(I[h + 4 >> 1], 28) | 0) - (I[h + 6 >> 1] << 2) >> B, h = h + 2 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 4:
                                                        if (s = I[h >> 1], e = 0, W = 0, !F) break r;
                                                        for(; w = s & 65535, s = I[h + 4 >> 1], M = I[h + 2 >> 1], H = I[h + 6 >> 1], Q[v + (Z(e, _) << 1) >> 1] = Z(s + M | 0, 36) - (w + H << 2) >> B, Q[v + (Z(e | 1, _) << 1) >> 1] = Z(s + H | 0, 36) - (I[h + 8 >> 1] + M << 2) >> B, e = e + 2 | 0, h = h + 4 | 0, W = W + 2 | 0, (T | 0) != (W | 0););
                                                        break r;
                                                    case 5:
                                                        for(s = I[h >> 1], e = 0; w = s & 65535, s = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = ((Z(s, 28) - (w << 2) | 0) + Z(I[h + 4 >> 1], 46) | 0) + Z(I[h + 6 >> 1], -6) >> B, h = h + 2 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 6:
                                                        break A;
                                                }
                                                for(s = I[h >> 1], e = 0; w = s & 65535, s = I[h + 2 >> 1], Q[v + (Z(e, _) << 1) >> 1] = Z(I[h + 4 >> 1], 54) + (s << 4) - ((w << 1) + (I[h + 6 >> 1] << 2)) >> B, h = h + 2 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                break e;
                                            }
                                            if (!S) break e;
                                            Q[v + (Z(e, _) << 1) >> 1] = Z(I[h + 4 >> 1] + I[h + 2 >> 1] | 0, 36) - (I[h + 6 >> 1] + (s & 65535) << 2) >> B;
                                        }
                                        if (G = G + 1 | 0, (V | 0) == (G | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(w = t ? 6 : B, B = n & 2147483646, y = n & 1, v = n - u & 3, G = 0, C = n - 1 | 0, E = C - u >>> 0 < 3;;){
                                    t = (G << 1) + A | 0, h = (Z(_, G) << 1) + R | 0;
                                    e: {
                                        r: {
                                            A: switch(u | 0){
                                                case 0:
                                                    if (s = 0, e = u, v) for(; Q[t + (Z(r, e) << 1) >> 1] = I[h + 2 >> 1], e = e + 1 | 0, h = h + 2 | 0, s = s + 1 | 0, (v | 0) != (s | 0););
                                                    if (E) break e;
                                                    for(; Q[t + (Z(r, e) << 1) >> 1] = I[h + 2 >> 1], Q[t + (Z(e + 1 | 0, r) << 1) >> 1] = I[h + 4 >> 1], Q[t + (Z(e + 2 | 0, r) << 1) >> 1] = I[h + 6 >> 1], Q[t + (Z(e + 3 | 0, r) << 1) >> 1] = I[h + 8 >> 1], h = h + 8 | 0, e = e + 4 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                default:
                                                    for(s = I[h >> 1], e = 0; f = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = (Z(Q[h + 4 >> 1], 58) + Z(f, 10) | 0) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 1) >> w, h = h + 2 | 0, s = f, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 1:
                                                    for(s = I[h >> 1], e = 0; f = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = (Z(Q[h + 4 >> 1], 10) + Z(f, 58) | 0) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 1) >> w, h = h + 2 | 0, s = f, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 2:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(s, 54) + (Q[h + 4 >> 1] << 4) - ((f << 2) + (Q[h + 6 >> 1] << 1)) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 3:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = ((Z(s, 46) + Z(f, -6) | 0) + Z(Q[h + 4 >> 1], 28) | 0) - (Q[h + 6 >> 1] << 2) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 4:
                                                    if (s = I[h >> 1], e = 0, W = 0, !C) break r;
                                                    for(; f = s << 16 >> 16, s = Q[h + 4 >> 1], V = Q[h + 2 >> 1], F = f, f = Q[h + 6 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(s + V | 0, 36) - (F + f << 2) >> w, Q[t + (Z(e | 1, r) << 1) >> 1] = Z(f + s | 0, 36) - (V + Q[h + 8 >> 1] << 2) >> w, e = e + 2 | 0, h = h + 4 | 0, W = W + 2 | 0, (B | 0) != (W | 0););
                                                    break r;
                                                case 5:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = ((Z(s, 28) - (f << 2) | 0) + Z(Q[h + 4 >> 1], 46) | 0) + Z(Q[h + 6 >> 1], -6) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 6:
                                                    break A;
                                            }
                                            for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(Q[h + 4 >> 1], 54) + (s << 4) - ((f << 1) + (Q[h + 6 >> 1] << 2)) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            break e;
                                        }
                                        if (!y) break e;
                                        Q[t + (Z(r, e) << 1) >> 1] = Z(Q[h + 4 >> 1] + Q[h + 2 >> 1] | 0, 36) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 2) >> w;
                                    }
                                    if (G = G + 1 | 0, (G | 0) == (k | 0)) break;
                                }
                            }
                        }
                        function ow(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            h = m - 32 | 0, m = h, s = A1(i[e >> 2], 6), w = l[k + 8 | 0];
                            i: {
                                e: {
                                    r: {
                                        if ((S0(i[e >> 2], 3) | 0) != 8 || (S0(i[e >> 2], 4) | 0) != 8) break r;
                                        if ((S0(i[e >> 2], 5) | 0) == 8) break e;
                                    }
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                e: {
                                    if (!s || (S0(i[e >> 2], 6) | 0) == 8) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = D(136), r = n, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), u = i[r + 4 >> 2], k = u + 1 | 0, i[r + 4 >> 2] = k, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, f = n + 76 | 0, i[n + 72 >> 2] = f, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, W = n + 12 | 0, i[n + 12 >> 2] = W, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = u, i[n + 16 >> 2] = n, k || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), r = i[e >> 2], _ = i[r + 24 >> 2], k = _, E = i[r + 28 >> 2], r = E, i[W + 36 >> 2] = w & 1 ? 11 : 10, i[W + 32 >> 2] = 1, i[W + 28 >> 2] = r, i[W + 24 >> 2] = k, J0(h + 8 | 0, W, 10, k, r, 8, t);
                                e: {
                                    if (i[h + 8 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[h + 12 >> 2], i[A + 8 >> 2] = i[h + 8 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[h + 27 | 0] >= 0) {
                                            A = i[h + 20 >> 2], i[r >> 2] = i[h + 16 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[h + 24 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[h + 16 >> 2], i[h + 20 >> 2]), o[h + 27 | 0] >= 0) break e;
                                        X(i[h + 16 >> 2]);
                                        break e;
                                    }
                                    o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), e = i[e >> 2], r = e - -64 | 0;
                                    r: {
                                        A: {
                                            if (k = i[e + 64 >> 2], k) {
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 3, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                C = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (C = 0, i[t + 16 >> 2] > 3)) break f;
                                                    R = i[t + 44 >> 2], C = i[t + 52 >> 2];
                                                }
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 4, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                V = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (V = 0, i[t + 16 >> 2] > 4)) break f;
                                                    M = i[t + 52 >> 2], V = i[t + 44 >> 2];
                                                }
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 5, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (t | 0)) break A;
                                            }
                                            F = 0;
                                            break r;
                                        }
                                        if (F = 0, i[t + 16 >> 2] > 5) break r;
                                        H = i[t + 52 >> 2], F = i[t + 44 >> 2];
                                    }
                                    e = i[f >> 2], u = 0;
                                    r: {
                                        if (!e) break r;
                                        for(t = f; u = i[e + 16 >> 2] < 10, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                        if ((f | 0) == (t | 0)) {
                                            u = 0;
                                            break r;
                                        }
                                        if (u = 0, i[t + 16 >> 2] > 10) break r;
                                        T = i[t + 52 >> 2], u = i[t + 44 >> 2];
                                    }
                                    t = 0, f = 0;
                                    r: {
                                        if (!k | s ^ 1) break r;
                                        for(e = r; f = i[k + 16 >> 2] < 6, e = f ? e : k, k = i[(f << 2) + k >> 2], !!k;);
                                        if (f = 0, (r | 0) == (e | 0) || (f = 0, i[e + 16 >> 2] > 6)) break r;
                                        t = i[e + 44 >> 2], f = i[e + 52 >> 2];
                                    }
                                    r: {
                                        if (!E) break r;
                                        if ((s & w) == 1) {
                                            if (!_) break r;
                                            for(r = 0;;){
                                                for(B = Z(r, f), G = F + Z(r, H) | 0, s = Z(r, M) + V | 0, w = Z(r, T) + u | 0, k = Z(r, C) + R | 0, e = 0; v = w + (e << 2) | 0, o[v | 0] = l[e + k | 0], o[v + 1 | 0] = l[e + s | 0], o[v + 2 | 0] = l[e + G | 0], o[v + 3 | 0] = l[(e + B | 0) + t | 0], e = e + 1 | 0, (_ | 0) != (e | 0););
                                                if (r = r + 1 | 0, (E | 0) == (r | 0)) break;
                                            }
                                            break r;
                                        }
                                        if (w & 1) {
                                            if (!_) break r;
                                            for(w = _ & -2, k = _ & 1, f = 0;;){
                                                if (y = F + Z(f, H) | 0, v = Z(f, M) + V | 0, B = Z(f, T) + u | 0, G = Z(f, C) + R | 0, e = 0, t = 0, (_ | 0) != 1) for(; s = B + (e << 2) | 0, o[s | 0] = l[e + G | 0], o[s + 1 | 0] = l[e + v | 0], r = l[e + y | 0], o[s + 3 | 0] = 255, o[s + 2 | 0] = r, r = e | 1, s = B + (r << 2) | 0, o[s | 0] = l[r + G | 0], o[s + 1 | 0] = l[r + v | 0], r = l[r + y | 0], o[s + 3 | 0] = 255, o[s + 2 | 0] = r, e = e + 2 | 0, t = t + 2 | 0, (w | 0) != (t | 0););
                                                if (k && (t = B + (e << 2) | 0, o[t | 0] = l[e + G | 0], o[t + 1 | 0] = l[e + v | 0], r = l[e + y | 0], o[t + 3 | 0] = 255, o[t + 2 | 0] = r), f = f + 1 | 0, (E | 0) == (f | 0)) break;
                                            }
                                            break r;
                                        }
                                        if (!_) break r;
                                        for(k = _ & -2, r = _ & 1, f = 0;;){
                                            if (y = F + Z(f, H) | 0, v = Z(f, M) + V | 0, B = Z(f, T) + u | 0, G = Z(f, C) + R | 0, e = 0, t = 0, (_ | 0) != 1) for(; w = B + Z(e, 3) | 0, o[w | 0] = l[e + G | 0], o[w + 1 | 0] = l[e + v | 0], o[w + 2 | 0] = l[e + y | 0], s = e | 1, w = B + Z(s, 3) | 0, o[w | 0] = l[s + G | 0], o[w + 1 | 0] = l[s + v | 0], o[w + 2 | 0] = l[s + y | 0], e = e + 2 | 0, t = t + 2 | 0, (k | 0) != (t | 0););
                                            if (r && (t = B + Z(e, 3) | 0, o[t | 0] = l[e + G | 0], o[t + 1 | 0] = l[e + v | 0], o[t + 2 | 0] = l[e + y | 0]), f = f + 1 | 0, (E | 0) == (f | 0)) break;
                                        }
                                    }
                                    if (i[A + 4 >> 2] = n, i[A >> 2] = W, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            m = h + 32 | 0;
                        }
                        function uw(A, r, e, f, k, n, t, u, s, h) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0;
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            B = h - 8 | 0, _ = n + 3 | 0, R = m - ((Z(_, k) << 1) + 15 & -16) | 0;
                            i: {
                                if ((n | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(C = e - 1 | 0, E = R + 2 | 0, e = n + 2 | 0, V = (e | 0) > 0 ? e : 0, T = k & 2147483646, S = k & 1, y = k - t & 3, G = -1, F = k - 1 | 0, P = F - t >>> 0 < 3;;){
                                        v = E + (G << 1) | 0, h = C + Z(f, G) | 0;
                                        e: {
                                            r: {
                                                A: switch(t | 0){
                                                    case 0:
                                                        if (s = 0, e = t, y) for(; Q[v + (Z(e, _) << 1) >> 1] = l[h + 1 | 0], e = e + 1 | 0, h = h + 1 | 0, s = s + 1 | 0, (y | 0) != (s | 0););
                                                        if (P) break e;
                                                        for(; Q[v + (Z(e, _) << 1) >> 1] = l[h + 1 | 0], Q[v + (Z(e + 1 | 0, _) << 1) >> 1] = l[h + 2 | 0], Q[v + (Z(e + 2 | 0, _) << 1) >> 1] = l[h + 3 | 0], Q[v + (Z(e + 3 | 0, _) << 1) >> 1] = l[h + 4 | 0], h = h + 4 | 0, e = e + 4 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    default:
                                                        for(s = l[h | 0], e = 0; w = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = (Z(l[h + 2 | 0], 58) + Z(w, 10) | 0) - (l[h + 3 | 0] + (s & 255) << 1) >> B, h = h + 1 | 0, s = w, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 1:
                                                        for(s = l[h | 0], e = 0; w = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = (Z(l[h + 2 | 0], 10) + Z(w, 58) | 0) - (l[h + 3 | 0] + (s & 255) << 1) >> B, h = h + 1 | 0, s = w, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 2:
                                                        for(s = l[h | 0], e = 0; w = s & 255, s = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = Z(s, 54) + (l[h + 2 | 0] << 4) - ((w << 2) + (l[h + 3 | 0] << 1)) >> B, h = h + 1 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 3:
                                                        for(s = l[h | 0], e = 0; w = s & 255, s = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = ((Z(s, 46) + Z(w, -6) | 0) + Z(l[h + 2 | 0], 28) | 0) - (l[h + 3 | 0] << 2) >> B, h = h + 1 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 4:
                                                        if (s = l[h | 0], e = 0, W = 0, !F) break r;
                                                        for(; w = s & 255, s = l[h + 2 | 0], M = l[h + 1 | 0], H = l[h + 3 | 0], Q[v + (Z(e, _) << 1) >> 1] = Z(s + M | 0, 36) - (w + H << 2) >> B, Q[v + (Z(e | 1, _) << 1) >> 1] = Z(s + H | 0, 36) - (l[h + 4 | 0] + M << 2) >> B, e = e + 2 | 0, h = h + 2 | 0, W = W + 2 | 0, (T | 0) != (W | 0););
                                                        break r;
                                                    case 5:
                                                        for(s = l[h | 0], e = 0; w = s & 255, s = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = ((Z(s, 28) - (w << 2) | 0) + Z(l[h + 2 | 0], 46) | 0) + Z(l[h + 3 | 0], -6) >> B, h = h + 1 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break e;
                                                    case 6:
                                                        break A;
                                                }
                                                for(s = l[h | 0], e = 0; w = s & 255, s = l[h + 1 | 0], Q[v + (Z(e, _) << 1) >> 1] = Z(l[h + 2 | 0], 54) + (s << 4) - ((w << 1) + (l[h + 3 | 0] << 2)) >> B, h = h + 1 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                                break e;
                                            }
                                            if (!S) break e;
                                            Q[v + (Z(e, _) << 1) >> 1] = Z(l[h + 2 | 0] + l[h + 1 | 0] | 0, 36) - (l[h + 3 | 0] + (s & 255) << 2) >> B;
                                        }
                                        if (G = G + 1 | 0, (V | 0) == (G | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(w = t ? 6 : B, B = n & 2147483646, y = n & 1, v = n - u & 3, G = 0, C = n - 1 | 0, E = C - u >>> 0 < 3;;){
                                    t = (G << 1) + A | 0, h = (Z(_, G) << 1) + R | 0;
                                    e: {
                                        r: {
                                            A: switch(u | 0){
                                                case 0:
                                                    if (s = 0, e = u, v) for(; Q[t + (Z(r, e) << 1) >> 1] = I[h + 2 >> 1], e = e + 1 | 0, h = h + 2 | 0, s = s + 1 | 0, (v | 0) != (s | 0););
                                                    if (E) break e;
                                                    for(; Q[t + (Z(r, e) << 1) >> 1] = I[h + 2 >> 1], Q[t + (Z(e + 1 | 0, r) << 1) >> 1] = I[h + 4 >> 1], Q[t + (Z(e + 2 | 0, r) << 1) >> 1] = I[h + 6 >> 1], Q[t + (Z(e + 3 | 0, r) << 1) >> 1] = I[h + 8 >> 1], h = h + 8 | 0, e = e + 4 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                default:
                                                    for(s = I[h >> 1], e = 0; f = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = (Z(Q[h + 4 >> 1], 58) + Z(f, 10) | 0) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 1) >> w, h = h + 2 | 0, s = f, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 1:
                                                    for(s = I[h >> 1], e = 0; f = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = (Z(Q[h + 4 >> 1], 10) + Z(f, 58) | 0) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 1) >> w, h = h + 2 | 0, s = f, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 2:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(s, 54) + (Q[h + 4 >> 1] << 4) - ((f << 2) + (Q[h + 6 >> 1] << 1)) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 3:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = ((Z(s, 46) + Z(f, -6) | 0) + Z(Q[h + 4 >> 1], 28) | 0) - (Q[h + 6 >> 1] << 2) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 4:
                                                    if (s = I[h >> 1], e = 0, W = 0, !C) break r;
                                                    for(; f = s << 16 >> 16, s = Q[h + 4 >> 1], V = Q[h + 2 >> 1], F = f, f = Q[h + 6 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(s + V | 0, 36) - (F + f << 2) >> w, Q[t + (Z(e | 1, r) << 1) >> 1] = Z(f + s | 0, 36) - (V + Q[h + 8 >> 1] << 2) >> w, e = e + 2 | 0, h = h + 4 | 0, W = W + 2 | 0, (B | 0) != (W | 0););
                                                    break r;
                                                case 5:
                                                    for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = ((Z(s, 28) - (f << 2) | 0) + Z(Q[h + 4 >> 1], 46) | 0) + Z(Q[h + 6 >> 1], -6) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                                    break e;
                                                case 6:
                                                    break A;
                                            }
                                            for(s = I[h >> 1], e = 0; f = s << 16 >> 16, s = Q[h + 2 >> 1], Q[t + (Z(r, e) << 1) >> 1] = Z(Q[h + 4 >> 1], 54) + (s << 4) - ((f << 1) + (Q[h + 6 >> 1] << 2)) >> w, h = h + 2 | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            break e;
                                        }
                                        if (!y) break e;
                                        Q[t + (Z(r, e) << 1) >> 1] = Z(Q[h + 4 >> 1] + Q[h + 2 >> 1] | 0, 36) - (Q[h + 6 >> 1] + (s << 16 >> 16) << 2) >> w;
                                    }
                                    if (G = G + 1 | 0, (G | 0) == (k | 0)) break;
                                }
                            }
                        }
                        function lw(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if (n = m - 32 | 0, m = n, v = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 105 | 0] | l[r + 104 | 0] << 1 & 6 | 248), l[r + 105 | 0] == 1) {
                                w2(e, (l[r + 110 | 0] | (l[r + 108 | 0] << 4 | I[r + 106 >> 1] << 7 | l[r + 109 | 0] << 2)) & 65535), f2(e, (l[r + 111 | 0] << 5 | 31) & 255), f2(e, l[r + 112 | 0] & 63), f2(e, l[r + 114 | 0] | l[r + 113 | 0] << 1 & 254), f2(e, l[r + 115 | 0]);
                                i: {
                                    if (!l[r + 112 | 0] || (f2(e, (l[i[r + 120 >> 2]] | (l[r + 117 | 0] << 6 | l[r + 116 | 0] << 7)) & 255), f = 1, l[r + 112 | 0] <= 1)) break i;
                                    for(; f2(e, l[i[r + 120 >> 2] + f | 0]), f = f + 1 | 0, f >>> 0 < l[r + 112 | 0];);
                                }
                                f = l[r + 108 | 0];
                                i: {
                                    if (f >>> 0 <= 1) break i;
                                    k = f - 1 | 0, h = k & 1, u = i[r + 132 >> 2], f = f - 2 | 0;
                                    e: {
                                        if (!f) {
                                            t = 128, k = 0;
                                            break e;
                                        }
                                        for(_ = k & -2, t = 128, k = 0; s = f - 1 | 0, B = 0 - (i[u + (s >>> 3 & 536870908) >> 2] >>> s & 1) | 0, s = t & 255, k = B & s >>> 1 | (0 - (i[u + (f >>> 3 & 536870908) >> 2] >>> f & 1) & t | k), f = f - 2 | 0, t = s >>> 2 | 0, w = w + 2 | 0, (w | 0) != (_ | 0););
                                    }
                                    if (!h) break i;
                                    k = 0 - (i[u + (f >>> 3 & 536870908) >> 2] >>> f & 1) & t | k;
                                }
                                if (f2(e, k & 255), f = l[r + 108 | 0], f >>> 0 >= 2) for(f = f - 2 | 0; i[i[r + 132 >> 2] + (f >>> 3 & 536870908) >> 2] >>> f & 1 && f2(e, l[i[r + 144 >> 2] + f | 0]), k = (f | 0) > 0, f = f - 1 | 0, !!k;);
                                if (k = i[r + 160 >> 2] - i[r + 156 >> 2] >>> 2 & 255, f2(e, k), k) for(f = 0; l2(e, i[i[r + 156 >> 2] + (f << 2) >> 2]), f = f + 1 | 0, (k | 0) != (f | 0););
                                w2(e, I[r + 168 >> 1]), w2(e, I[r + 170 >> 1]), w2(e, I[r + 172 >> 1]);
                            }
                            f = i[r + 180 >> 2] - i[r + 176 >> 2] >> 4;
                            i: {
                                if (f >>> 0 >= 256) {
                                    if (r = D(32), i[n + 20 >> 2] = r, i[n + 24 >> 2] = 24, i[n + 28 >> 2] = -2147483616, e = l[19187] | l[19188] << 8 | (l[19189] << 16 | l[19190] << 24), f = l[19183] | l[19184] << 8 | (l[19185] << 16 | l[19186] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 24 | 0] = 0, e = l[19203] | l[19204] << 8 | (l[19205] << 16 | l[19206] << 24), f = l[19199] | l[19200] << 8 | (l[19201] << 16 | l[19202] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[19195] | l[19196] << 8 | (l[19197] << 16 | l[19198] << 24), f = l[19191] | l[19192] << 8 | (l[19193] << 16 | l[19194] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, n + 20 | 0), o[n + 31 | 0] >= 0) break i;
                                    X(i[n + 20 >> 2]);
                                    break i;
                                }
                                if (f2(e, f & 255), k = i[r + 176 >> 2], t = i[r + 180 >> 2], (k | 0) != (t | 0)) for(;;){
                                    if (f2(e, l[k + 1 | 0] | (l[k | 0] ? 128 : 0)), f = (i[k + 8 >> 2] - i[k + 4 >> 2] | 0) / 12 | 0, f >>> 0 >= 65536) {
                                        if (r = D(24), i[n + 20 >> 2] = r, i[n + 24 >> 2] = 23, i[n + 28 >> 2] = -2147483624, e = l[19222] | l[19223] << 8 | (l[19224] << 16 | l[19225] << 24), f = l[19218] | l[19219] << 8 | (l[19220] << 16 | l[19221] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 23 | 0] = 0, e = l[19237] | l[19238] << 8 | (l[19239] << 16 | l[19240] << 24), f = l[19233] | l[19234] << 8 | (l[19235] << 16 | l[19236] << 24), o[r + 15 | 0] = f, o[r + 16 | 0] = f >>> 8, o[r + 17 | 0] = f >>> 16, o[r + 18 | 0] = f >>> 24, o[r + 19 | 0] = e, o[r + 20 | 0] = e >>> 8, o[r + 21 | 0] = e >>> 16, o[r + 22 | 0] = e >>> 24, e = l[19230] | l[19231] << 8 | (l[19232] << 16 | l[19233] << 24), f = l[19226] | l[19227] << 8 | (l[19228] << 16 | l[19229] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, n + 20 | 0), o[n + 31 | 0] >= 0) break i;
                                        X(i[n + 20 >> 2]);
                                        break i;
                                    }
                                    if (w2(e, f & 65535), f = i[k + 4 >> 2], u = i[k + 8 >> 2], (f | 0) != (u | 0)) for(;;){
                                        if (h = i[f + 4 >> 2] - i[f >> 2] | 0, h >>> 0 >= 65536) {
                                            if (r = D(24), i[n + 20 >> 2] = r, i[n + 24 >> 2] = 18, i[n + 28 >> 2] = -2147483624, e = l[19648] | l[19649] << 8 | (l[19650] << 16 | l[19651] << 24), f = l[19644] | l[19645] << 8 | (l[19646] << 16 | l[19647] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 18 | 0] = 0, e = l[19660] | l[19661] << 8, o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, e = l[19656] | l[19657] << 8 | (l[19658] << 16 | l[19659] << 24), f = l[19652] | l[19653] << 8 | (l[19654] << 16 | l[19655] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 9, 0, n + 20 | 0), o[n + 31 | 0] >= 0) break i;
                                            X(i[n + 20 >> 2]);
                                            break i;
                                        }
                                        if (w2(e, h & 65535), G4(e, f), f = f + 12 | 0, (u | 0) == (f | 0)) break;
                                    }
                                    if (k = k + 16 | 0, (t | 0) == (k | 0)) break;
                                }
                                if (E4(n, r, e, v), o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function sw(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0;
                            u = m - 48 | 0, m = u, i[u + 44 >> 2] = r, i[k >> 2] = 0, s = i[f + 28 >> 2], i[u >> 2] = s, (s | 0) != 108396 && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), s = K0(u, 108572), d0(u);
                            i: {
                                e: {
                                    r: {
                                        A: switch(t - 65 | 0){
                                            case 0:
                                            case 32:
                                                Ht(A, n + 24 | 0, u + 44 | 0, e, k, s);
                                                break e;
                                            case 1:
                                            case 33:
                                            case 39:
                                                Rt(A, n + 16 | 0, u + 44 | 0, e, k, s);
                                                break e;
                                            case 34:
                                                r = p[i[i[A + 8 >> 2] + 12 >> 2]](A + 8 | 0) | 0, t = A, h = i[u + 44 >> 2], l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, s = A, l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, l[r + 11 | 0] >>> 7 | 0 ? r = i[r + 4 >> 2] : r = l[r + 11 | 0] & 127, w = u, v = W8(t, h, e, f, k, n, s, A + (r << 2) | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 35:
                                            case 36:
                                                A = a4(u + 44 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!(A - 1 >>> 0 > 30 | r & 4)) {
                                                        i[n + 12 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 3:
                                                t = i[16263], i[u + 24 >> 2] = i[16262], i[u + 28 >> 2] = t, t = i[16261], i[u + 16 >> 2] = i[16260], i[u + 20 >> 2] = t, t = i[16259], i[u + 8 >> 2] = i[16258], i[u + 12 >> 2] = t, t = i[16257], i[u >> 2] = i[16256], i[u + 4 >> 2] = t, w = u, v = W8(A, r, e, f, k, n, u, u + 32 | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 5:
                                                t = i[16271], i[u + 24 >> 2] = i[16270], i[u + 28 >> 2] = t, t = i[16269], i[u + 16 >> 2] = i[16268], i[u + 20 >> 2] = t, t = i[16267], i[u + 8 >> 2] = i[16266], i[u + 12 >> 2] = t, t = i[16265], i[u >> 2] = i[16264], i[u + 4 >> 2] = t, w = u, v = W8(A, r, e, f, k, n, u, u + 32 | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 7:
                                                A = a4(u + 44 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 23 | r & 4)) {
                                                        i[n + 8 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 8:
                                                A = a4(u + 44 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!(A - 1 >>> 0 > 11 | r & 4)) {
                                                        i[n + 8 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 41:
                                                A = a4(u + 44 | 0, e, k, s, 3), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 365 | r & 4)) {
                                                        i[n + 28 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 44:
                                                r = a4(u + 44 | 0, e, k, s, 2) - 1 | 0, A = i[k >> 2];
                                                f: {
                                                    if (!(r >>> 0 > 11 | A & 4)) {
                                                        i[n + 16 >> 2] = r;
                                                        break f;
                                                    }
                                                    i[k >> 2] = A | 4;
                                                }
                                                break e;
                                            case 12:
                                                A = a4(u + 44 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 59 | r & 4)) {
                                                        i[n + 4 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 45:
                                            case 51:
                                                for(A = u + 44 | 0, r = m - 16 | 0, m = r, i[r + 12 >> 2] = e;;){
                                                    f: {
                                                        if (S2(A, r + 12 | 0)) break f;
                                                        e = i[A >> 2], f = i[e + 12 >> 2];
                                                        k: {
                                                            if ((f | 0) == i[e + 16 >> 2]) {
                                                                e = p[i[i[e >> 2] + 36 >> 2]](e) | 0;
                                                                break k;
                                                            }
                                                            e = i[f >> 2];
                                                        }
                                                        if (!(p[i[i[s >> 2] + 12 >> 2]](s, 1, e) | 0)) break f;
                                                        J1(A);
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                S2(A, r + 12 | 0) && (i[k >> 2] = i[k >> 2] | 2), m = r + 16 | 0;
                                                break e;
                                            case 47:
                                                t = u + 44 | 0, r = p[i[i[A + 8 >> 2] + 8 >> 2]](A + 8 | 0) | 0;
                                                f: {
                                                    if (l[r + 11 | 0] >>> 7 | 0) {
                                                        A = i[r + 4 >> 2];
                                                        break f;
                                                    }
                                                    A = l[r + 11 | 0] & 127;
                                                }
                                                l[r + 23 | 0] >>> 7 | 0 ? f = i[r + 16 >> 2] : f = l[r + 23 | 0] & 127;
                                                f: {
                                                    if ((A | 0) == (0 - f | 0)) {
                                                        i[k >> 2] = i[k >> 2] | 4;
                                                        break f;
                                                    }
                                                    if (e = Fe(t, e, r, r + 24 | 0, s, k, 0), A = i[n + 8 >> 2], !((e | 0) != (r | 0) | (A | 0) != 12)) {
                                                        i[n + 8 >> 2] = 0;
                                                        break f;
                                                    }
                                                    (e - r | 0) != 12 | (A | 0) > 11 || (i[n + 8 >> 2] = A + 12);
                                                }
                                                break e;
                                            case 49:
                                                t = v0(u, 65088, 44), w = t, v = W8(A, r, e, f, k, n, t, t + 44 | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 17:
                                                i[u + 16 >> 2] = i[16288], t = i[16287], i[u + 8 >> 2] = i[16286], i[u + 12 >> 2] = t, t = i[16285], i[u >> 2] = i[16284], i[u + 4 >> 2] = t, w = u, v = W8(A, r, e, f, k, n, u, u + 20 | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 18:
                                                A = a4(u + 44 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 60 | r & 4)) {
                                                        i[n >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 19:
                                                t = i[16299], i[u + 24 >> 2] = i[16298], i[u + 28 >> 2] = t, t = i[16297], i[u + 16 >> 2] = i[16296], i[u + 20 >> 2] = t, t = i[16295], i[u + 8 >> 2] = i[16294], i[u + 12 >> 2] = t, t = i[16293], i[u >> 2] = i[16292], i[u + 4 >> 2] = t, w = u, v = W8(A, r, e, f, k, n, u, u + 32 | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 54:
                                                A = a4(u + 44 | 0, e, k, s, 1), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 6 | r & 4)) {
                                                        i[n + 24 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 55:
                                                A = p[i[i[A >> 2] + 20 >> 2]](A, r, e, f, k, n) | 0;
                                                break i;
                                            case 23:
                                                r = p[i[i[A + 8 >> 2] + 24 >> 2]](A + 8 | 0) | 0, t = A, h = i[u + 44 >> 2], l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, s = A, l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, l[r + 11 | 0] >>> 7 | 0 ? r = i[r + 4 >> 2] : r = l[r + 11 | 0] & 127, w = u, v = W8(t, h, e, f, k, n, s, A + (r << 2) | 0), i[w + 44 >> 2] = v;
                                                break e;
                                            case 56:
                                                bt(n + 20 | 0, u + 44 | 0, e, k, s);
                                                break e;
                                            case 24:
                                                A = a4(u + 44 | 0, e, k, s, 4), l[k | 0] & 4 || (i[n + 20 >> 2] = A - 1900);
                                                break e;
                                            default:
                                                if ((t | 0) == 37) break r;
                                                break;
                                            case 2:
                                            case 4:
                                            case 6:
                                            case 9:
                                            case 10:
                                            case 11:
                                            case 13:
                                            case 14:
                                            case 15:
                                            case 16:
                                            case 20:
                                            case 21:
                                            case 22:
                                            case 25:
                                            case 26:
                                            case 27:
                                            case 28:
                                            case 29:
                                            case 30:
                                            case 31:
                                            case 37:
                                            case 38:
                                            case 40:
                                            case 42:
                                            case 43:
                                            case 46:
                                            case 48:
                                            case 50:
                                            case 52:
                                            case 53:
                                                break A;
                                        }
                                        i[k >> 2] = i[k >> 2] | 4;
                                        break e;
                                    }
                                    A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, r = 6, f = u + 44 | 0, t = A + 12 | 0;
                                    r: {
                                        A: {
                                            if (S2(f, t)) break A;
                                            r = 4, e = i[f >> 2], n = i[e + 12 >> 2];
                                            f: {
                                                if ((n | 0) == i[e + 16 >> 2]) {
                                                    e = p[i[i[e >> 2] + 36 >> 2]](e) | 0;
                                                    break f;
                                                }
                                                e = i[n >> 2];
                                            }
                                            if ((p[i[i[s >> 2] + 52 >> 2]](s, e, 0) | 0) != 37) break A;
                                            if (r = 2, !S2(J1(f), t)) break r;
                                        }
                                        i[k >> 2] = i[k >> 2] | r;
                                    }
                                    m = A + 16 | 0;
                                }
                                A = i[u + 44 >> 2];
                            }
                            return m = u + 48 | 0, A | 0;
                        }
                        function G3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0, D1 = 0, e4 = 0, r4 = 0, A4 = 0, U4 = 0, H4 = 0, U6 = 0, H6 = 0;
                            i: {
                                e: {
                                    v = i[A + 276 >> 2], I0 = (f | 0) > (v | 0) ? v : f;
                                    r: {
                                        if ((I0 | 0) <= (e | 0) || (q = i[A + 272 >> 2], F0 = (k | 0) > (q | 0) ? q : k, (F0 | 0) <= 0)) break r;
                                        for(r0 = i[A + 124 >> 2], m0 = i[r0 + 16856 >> 2], U2 = m0 << (r ^ 1), Z0 = i[r0 + 16852 >> 2], H2 = Z0 << r, j2 = A + 4 | 0, K2 = 3 - m0 | 0, i1 = 3 - Z0 | 0, f = i[r0 + 16840 >> 2], v1 = f - 8 | 0, t = -1 << f ^ -1, R = i[A + 44 >> 2], M = R << 1, g0 = 0 - M | 0, p1 = i[A + 260 >> 2], $ = Z(R, 6), c = M << 1, V1 = 0 - R << 1, y1 = 1 - R << 1, I1 = 2 - R << 1, D1 = 3 - R << 1;;){
                                            for(f = e << K2, e4 = Z(f, R), t0 = Z(f, m0), r4 = t0 - 1 | 0, A4 = Z((t0 | 0) / 4 | 0, q) + p1 | 0, s0 = 0;;){
                                                if (k = s0 << i1, L = Z(k, Z0), f = l[((L | 0) / 4 | 0) + A4 | 0] & 3, f >>> 0 > 1) for(v = 1, U4 = (f << 1) - 2 | 0, f = i[A + 168 >> 2], F = L - 1 >> f, E = r4 >> f, X0 = t0 >> f, V0 = L >> f, f = k + e4 | 0, H4 = f + R << 1, R0 = f << 1, U6 = R0 + g0 | 0, H6 = i[A + 132 >> 2], f = 1;;){
                                                    k = i[(f << 2) + j2 >> 2], w = k + R0 | 0;
                                                    A: {
                                                        if (!r) {
                                                            H = w + 6 | 0, T = w + 4 | 0, S = w + 2 | 0, f = k + H4 | 0, _ = f + 6 | 0, B = f + 4 | 0, W = f + 2 | 0, k = k + U6 | 0, P = k + 6 | 0, C = k + g0 | 0, u = C + 6 | 0, s = C + 4 | 0, V = C + 2 | 0, y = k + 4 | 0, n = k + 2 | 0;
                                                            break A;
                                                        }
                                                        C = w - 4 | 0, u = $ + C | 0, f = w + 2 | 0, _ = $ + f | 0, s = C + c | 0, B = f + c | 0, V = C + M | 0, W = f + M | 0, k = w - 2 | 0, P = $ + k | 0, H = w + $ | 0, T = w + c | 0, S = w + M | 0, y = k + c | 0, n = k + M | 0;
                                                    }
                                                    if ((V0 | 0) < 0 || (h = i[A + 172 >> 2], (h | 0) <= (V0 | 0))) break e;
                                                    if ((X0 | 0) < 0 || (G = i[A + 176 >> 2], (G | 0) <= (X0 | 0))) break i;
                                                    D0 = I[u >> 1], H0 = I[s >> 1], i2 = I[V >> 1], f0 = I[C >> 1], P = I[P >> 1], u = I[y >> 1], n = I[n >> 1], s = I[k >> 1], e2 = I[_ >> 1], k2 = I[B >> 1], t2 = I[W >> 1], v2 = I[f >> 1], H = I[H >> 1], T = I[T >> 1], S = I[S >> 1], _ = I[w >> 1], C = v, k = i[(v ? 32 : 36) + H6 >> 2], W = i[A + 160 >> 2], V = W + Z(V0, 3) | 0, y = Z(Z(h, X0), 3), v = V + y | 0, B = o[v + 2 | 0];
                                                    A: {
                                                        if (!r) {
                                                            if ((E | 0) < 0 | (G | 0) <= (E | 0)) break i;
                                                            f = (V + Z(Z(h, E), 3) | 0) + 2 | 0;
                                                            break A;
                                                        }
                                                        if ((F | 0) < 0 | h >>> 0 <= F >>> 0) break e;
                                                        f = (y + (W + Z(F, 3) | 0) | 0) + 2 | 0;
                                                    }
                                                    k = k + ((B + o[f | 0] | 0) + 1 >> 1) | 0;
                                                    A: {
                                                        if (i[r0 + 16848 >> 2] != 1) {
                                                            k = (k | 0) >= 51 ? 51 : k;
                                                            break A;
                                                        }
                                                        if ((k | 0) < 30) break A;
                                                        if (k >>> 0 <= 42) {
                                                            k = i[(k << 2) + 51224 >> 2];
                                                            break A;
                                                        }
                                                        k = k - 6 | 0;
                                                    }
                                                    if (B = i[A + 148 >> 2], f = L >> B, (f | 0) < 0 || (y2 = i[A + 152 >> 2], (f | 0) >= (y2 | 0))) break e;
                                                    if (B = t0 >> B, (B | 0) < 0 | (B | 0) >= i[A + 156 >> 2]) break i;
                                                    f = i[i[i[A + 52 >> 2] + (I[((i[A + 140 >> 2] + Z(f, 24) | 0) + Z(Z(B, y2), 24) | 0) + 2 >> 1] << 2) >> 2] + 768 >> 2] + (k + U4 | 0) | 0, f = (f | 0) >= 53 ? 53 : f, f = l[((f | 0) > 0 ? f : 0) + 48336 | 0] << v1, B = l[r0 + 8812 | 0];
                                                    A: {
                                                        if (!r) {
                                                            if (B) {
                                                                if ((E | 0) < 0 | (G | 0) <= (E | 0)) break i;
                                                                W = !(l[(V + Z(Z(h, E), 3) | 0) + 1 | 0] & 4);
                                                            } else W = 1;
                                                            if ((E | 0) < 0 | (G | 0) <= (E | 0)) break i;
                                                            if (k = 0 - f | 0, G = ((f0 + (_ - s << 2) | 0) - v2 | 0) + 4 >> 3, G = (k | 0) > (G | 0) ? k : (f | 0) > (G | 0) ? G : f, y = l[v | 0] | l[v + 1 | 0] << 8, v = W & !(l[(V + Z(Z(h, E), 3) | 0) + 1 | 0] & 8), v && (h = s + G | 0, Q[w + V1 >> 1] = (h | 0) >= 0 ? (t | 0) > (h | 0) ? h : t : 0), h = !(y & 2048) & (!B | !(y & 1024)), h && (s = _ - G | 0, Q[w >> 1] = (s | 0) >= 0 ? (t | 0) > (s | 0) ? s : t : 0), s = (((S - n << 2) + i2 | 0) - t2 | 0) + 4 >> 3, s = (k | 0) > (s | 0) ? k : (f | 0) > (s | 0) ? s : f, v && (n = n + s | 0, Q[w + y1 >> 1] = (n | 0) >= 0 ? (t | 0) > (n | 0) ? n : t : 0), h && (n = S - s | 0, Q[w + 2 >> 1] = (n | 0) >= 0 ? (t | 0) > (n | 0) ? n : t : 0), n = (((T - u << 2) + H0 | 0) - k2 | 0) + 4 >> 3, n = (k | 0) > (n | 0) ? k : (f | 0) > (n | 0) ? n : f, v && (u = n + u | 0, Q[w + I1 >> 1] = (u | 0) >= 0 ? (t | 0) > (u | 0) ? u : t : 0), h && (u = T - n | 0, Q[w + 4 >> 1] = (u | 0) >= 0 ? (t | 0) > (u | 0) ? u : t : 0), u = (((H - P << 2) + D0 | 0) - e2 | 0) + 4 >> 3, f = (k | 0) > (u | 0) ? k : (f | 0) > (u | 0) ? u : f, v && (k = f + P | 0, Q[w + D1 >> 1] = (k | 0) >= 0 ? (k | 0) < (t | 0) ? k : t : 0), !h) break A;
                                                            f = H - f | 0, Q[w + 6 >> 1] = (f | 0) >= 0 ? (f | 0) < (t | 0) ? f : t : 0;
                                                            break A;
                                                        }
                                                        if (B) {
                                                            if ((F | 0) < 0 | h >>> 0 <= F >>> 0) break e;
                                                            G = !(l[(y + (W + Z(F, 3) | 0) | 0) + 1 | 0] & 4);
                                                        } else G = 1;
                                                        if ((F | 0) < 0 | h >>> 0 <= F >>> 0) break e;
                                                        if (k = 0 - f | 0, h = ((f0 + (_ - s << 2) | 0) - v2 | 0) + 4 >> 3, V = (k | 0) > (h | 0) ? k : (f | 0) > (h | 0) ? h : f, f0 = l[v | 0] | l[v + 1 | 0] << 8, v = w - 2 | 0, h = G & !(l[(y + (W + Z(F, 3) | 0) | 0) + 1 | 0] & 8), h && (s = s + V | 0, Q[v >> 1] = (s | 0) >= 0 ? (t | 0) > (s | 0) ? s : t : 0), s = !(f0 & 2048) & (!B | !(f0 & 1024)), s && (_ = _ - V | 0, Q[w >> 1] = (_ | 0) >= 0 ? (t | 0) > (_ | 0) ? _ : t : 0), _ = (((S - n << 2) + i2 | 0) - t2 | 0) + 4 >> 3, _ = (k | 0) > (_ | 0) ? k : (f | 0) > (_ | 0) ? _ : f, h && (n = n + _ | 0, Q[v + M >> 1] = (n | 0) >= 0 ? (t | 0) > (n | 0) ? n : t : 0), s && (n = S - _ | 0, Q[w + M >> 1] = (n | 0) >= 0 ? (t | 0) > (n | 0) ? n : t : 0), n = (((T - u << 2) + H0 | 0) - k2 | 0) + 4 >> 3, n = (k | 0) > (n | 0) ? k : (f | 0) > (n | 0) ? n : f, h && (u = n + u | 0, Q[v + c >> 1] = (u | 0) >= 0 ? (t | 0) > (u | 0) ? u : t : 0), s && (u = T - n | 0, Q[w + c >> 1] = (u | 0) >= 0 ? (t | 0) > (u | 0) ? u : t : 0), u = (((H - P << 2) + D0 | 0) - e2 | 0) + 4 >> 3, f = (k | 0) > (u | 0) ? k : (f | 0) > (u | 0) ? u : f, h && (k = f + P | 0, Q[v + $ >> 1] = (k | 0) >= 0 ? (k | 0) < (t | 0) ? k : t : 0), !s) break A;
                                                        f = H - f | 0, Q[w + $ >> 1] = (f | 0) >= 0 ? (f | 0) < (t | 0) ? f : t : 0;
                                                    }
                                                    if (f = 2, v = 0, !C) break;
                                                }
                                                if (s0 = s0 + H2 | 0, !((F0 | 0) > (s0 | 0))) break;
                                            }
                                            if (e = e + U2 | 0, !((I0 | 0) > (e | 0))) break;
                                        }
                                    }
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function T7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            _ = m - 6240 | 0, m = _, B = r + 96 | 0, C = r + 480 | 0, V = r + 2016 | 0;
                            i: {
                                for(;;){
                                    for(h = w ? 64 : 16, G = (w | 0) == 3, y = G ? 3 : 1, v = (_ + 6144 | 0) + Z(w, 24) | 0, k = 0;;){
                                        n = k << 10, f = n + _ | 0;
                                        e: {
                                            r: {
                                                A: {
                                                    f: {
                                                        k: {
                                                            if (!(l0(A, 1) & 255)) {
                                                                if (e = q0(A), (e | 0) == -99999 || (e = G ? Z(e, 3) : e, (e | 0) > (k | 0))) break A;
                                                                if (t = v + (k << 2) | 0, i[t >> 2] = 16, !e) {
                                                                    if (!w) {
                                                                        e = i[21515], i[f + 8 >> 2] = i[21514], i[f + 12 >> 2] = e, e = i[21513], i[f >> 2] = i[21512], i[f + 4 >> 2] = e;
                                                                        break r;
                                                                    }
                                                                    if (k >>> 0 <= 2) {
                                                                        e = i[21531], i[f + 56 >> 2] = i[21530], i[f + 60 >> 2] = e, e = i[21529], i[f + 48 >> 2] = i[21528], i[f + 52 >> 2] = e, e = i[21527], i[f + 40 >> 2] = i[21526], i[f + 44 >> 2] = e, e = i[21525], i[f + 32 >> 2] = i[21524], i[f + 36 >> 2] = e, e = i[21523], i[f + 24 >> 2] = i[21522], i[f + 28 >> 2] = e, e = 16, t = i[21521], i[f + 16 >> 2] = i[21520], i[f + 20 >> 2] = t, t = i[21519], i[f + 8 >> 2] = i[21518], i[f + 12 >> 2] = t, t = i[21517], i[f >> 2] = i[21516], i[f + 4 >> 2] = t;
                                                                        break k;
                                                                    }
                                                                    e = i[21547], i[f + 56 >> 2] = i[21546], i[f + 60 >> 2] = e, e = i[21545], i[f + 48 >> 2] = i[21544], i[f + 52 >> 2] = e, e = i[21543], i[f + 40 >> 2] = i[21542], i[f + 44 >> 2] = e, e = i[21541], i[f + 32 >> 2] = i[21540], i[f + 36 >> 2] = e, e = i[21539], i[f + 24 >> 2] = i[21538], i[f + 28 >> 2] = e, e = 16, t = i[21537], i[f + 16 >> 2] = i[21536], i[f + 20 >> 2] = t, t = i[21535], i[f + 8 >> 2] = i[21534], i[f + 12 >> 2] = t, t = i[21533], i[f >> 2] = i[21532], i[f + 4 >> 2] = t;
                                                                    break k;
                                                                }
                                                                if ((w | 0) == 3 & (e | 0) != 3) break f;
                                                                e = k - e | 0, v0(f, (e << 10) + _ | 0, h), e = i[v + (e << 2) >> 2], i[t >> 2] = e;
                                                                break k;
                                                            }
                                                            n: {
                                                                if (w >>> 0 < 2) {
                                                                    t = 8, e = 16;
                                                                    break n;
                                                                }
                                                                if (e = m1(A), e - 248 >>> 0 < 4294967041) break A;
                                                                t = e + 8 | 0, i[v + (k << 2) >> 2] = t, e = t;
                                                            }
                                                            for(s = 0;;){
                                                                if (u = m1(A), u + 128 >>> 0 > 255) break A;
                                                                if (t = t + u | 0, o[f + s | 0] = t, s = s + 1 | 0, (h | 0) == (s | 0)) break;
                                                            }
                                                        }
                                                        k: switch(w | 0){
                                                            case 1:
                                                                for(e = (k << 6) + B | 0, s = 0, t = i[i[12662] + 12 >> 2]; n = t + (s << 1) | 0, o[(e + (l[n + 1 | 0] << 3) | 0) + l[n | 0] | 0] = l[f + s | 0], n = s | 1, u = t + (n << 1) | 0, o[(e + (l[u + 1 | 0] << 3) | 0) + l[u | 0] | 0] = l[f + n | 0], s = s + 2 | 0, (s | 0) != 64;);
                                                                break e;
                                                            case 2:
                                                                for(n = (k << 8) + C | 0, W = n + 1 | 0, t = 0, F = i[i[12662] + 12 >> 2]; s = (t << 1) + F | 0, u = l[f + t | 0], o[(n + (l[s | 0] << 1) | 0) + (l[s + 1 | 0] << 5) | 0] = u, o[((l[s | 0] << 1) + W | 0) + (l[s + 1 | 0] << 5) | 0] = u, o[((n + (l[s | 0] << 1) | 0) + (l[s + 1 | 0] << 5) | 0) + 16 | 0] = u, o[(((l[s | 0] << 1) + W | 0) + (l[s + 1 | 0] << 5) | 0) + 16 | 0] = u, t = t + 1 | 0, (t | 0) != 64;);
                                                                o[n | 0] = e;
                                                                break e;
                                                            case 3:
                                                                break k;
                                                            case 0:
                                                                break r;
                                                            default:
                                                                break e;
                                                        }
                                                        t = n + V | 0, K4(t, f, 3), o[t | 0] = e;
                                                        break e;
                                                    }
                                                    y0(17806, 14941, 934, 3231), z();
                                                }
                                                A = 8;
                                                break i;
                                            }
                                            K4((k << 4) + r | 0, f, 0);
                                        }
                                        if (k = k + y | 0, !(k >>> 0 < 6)) break;
                                    }
                                    if (w = w + 1 | 0, (w | 0) == 4) break;
                                }
                                for(s = r + 96 | 0, w = r - -64 | 0, v = r + 32 | 0, A = 0, t = i[i[12662] + 12 >> 2]; e = t + (A << 1) | 0, n = l[e + 1 | 0], e = l[e | 0], f = ((n << 7) + (e << 2) | 0) + 3040 | 0, k = f + r | 0, e = Z(l[(e + ((n << 3) + B | 0) | 0) - -64 | 0], 16843009), o[k | 0] = e, n = e >>> 8 | 0, o[k + 1 | 0] = n, u = e >>> 16 | 0, o[k + 2 | 0] = u, h = e >>> 24 | 0, o[k + 3 | 0] = h, k = f + v | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, k = f + w | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, f = f + s | 0, o[f | 0] = e, o[f + 1 | 0] = n, o[f + 2 | 0] = u, o[f + 3 | 0] = h, A = A + 1 | 0, (A | 0) != 64;);
                                for(o[r + 3040 | 0] = l[r + 160 | 0], s = r + 96 | 0, w = r - -64 | 0, v = r + 32 | 0, A = 0; e = t + (A << 1) | 0, n = l[e + 1 | 0], e = l[e | 0], f = ((n << 7) + (e << 2) | 0) + 4064 | 0, k = f + r | 0, e = Z(l[(e + ((n << 3) + B | 0) | 0) + 128 | 0], 16843009), o[k | 0] = e, n = e >>> 8 | 0, o[k + 1 | 0] = n, u = e >>> 16 | 0, o[k + 2 | 0] = u, h = e >>> 24 | 0, o[k + 3 | 0] = h, k = f + v | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, k = f + w | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, f = f + s | 0, o[f | 0] = e, o[f + 1 | 0] = n, o[f + 2 | 0] = u, o[f + 3 | 0] = h, A = A + 1 | 0, (A | 0) != 64;);
                                for(o[r + 4064 | 0] = l[r + 224 | 0], s = r + 96 | 0, w = r - -64 | 0, v = r + 32 | 0, A = 0; e = t + (A << 1) | 0, n = l[e + 1 | 0], e = l[e | 0], f = ((n << 7) + (e << 2) | 0) + 6112 | 0, k = f + r | 0, e = Z(l[(e + ((n << 3) + B | 0) | 0) + 256 | 0], 16843009), o[k | 0] = e, n = e >>> 8 | 0, o[k + 1 | 0] = n, u = e >>> 16 | 0, o[k + 2 | 0] = u, h = e >>> 24 | 0, o[k + 3 | 0] = h, k = f + v | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, k = f + w | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, f = f + s | 0, o[f | 0] = e, o[f + 1 | 0] = n, o[f + 2 | 0] = u, o[f + 3 | 0] = h, A = A + 1 | 0, (A | 0) != 64;);
                                for(o[r + 6112 | 0] = l[r + 352 | 0], s = r + 96 | 0, w = r - -64 | 0, v = r + 32 | 0, A = 0; e = t + (A << 1) | 0, n = l[e + 1 | 0], e = l[e | 0], f = ((n << 7) + (e << 2) | 0) + 7136 | 0, k = f + r | 0, e = Z(l[(e + ((n << 3) + B | 0) | 0) + 320 | 0], 16843009), o[k | 0] = e, n = e >>> 8 | 0, o[k + 1 | 0] = n, u = e >>> 16 | 0, o[k + 2 | 0] = u, h = e >>> 24 | 0, o[k + 3 | 0] = h, k = f + v | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, k = f + w | 0, o[k | 0] = e, o[k + 1 | 0] = n, o[k + 2 | 0] = u, o[k + 3 | 0] = h, f = f + s | 0, o[f | 0] = e, o[f + 1 | 0] = n, o[f + 2 | 0] = u, o[f + 3 | 0] = h, A = A + 1 | 0, (A | 0) != 64;);
                                o[r + 7136 | 0] = l[r + 416 | 0], A = 0;
                            }
                            return m = _ + 6240 | 0, A;
                        }
                        function hw(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            if (k = m - 48 | 0, m = k, i[k + 44 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, r = i[r + 32 >> 2], _ = i[r + 136 >> 2], G = i[r + 140 >> 2], (_ | 0) != (G | 0)) for(;;){
                                i: {
                                    if (v = i[_ + 4 >> 2], W = i[_ + 8 >> 2], (v | 0) == (W | 0)) break i;
                                    for(;;){
                                        e: {
                                            r = i[v + 4 >> 2] - i[v >> 2] >>> 24 | 0, n = i[k + 40 >> 2], e = i[k + 44 >> 2];
                                            r: {
                                                if (n >>> 0 < e >>> 0) {
                                                    o[n | 0] = r, t = n + 1 | 0;
                                                    break r;
                                                }
                                                if (u = i[k + 36 >> 2], s = n - u | 0, f = s + 1 | 0, (f | 0) < 0) break e;
                                                e = e - u | 0, t = e << 1, t = e >>> 0 >= 1073741823 ? 2147483647 : t >>> 0 > f >>> 0 ? t : f, t ? f = D(t) : f = 0, e = s + f | 0, o[e | 0] = r, w = t + f | 0, t = e + 1 | 0;
                                                A: {
                                                    if ((n | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (h = 0, r = n, s = s & 3, s) for(; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                    if (u - n >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (u | 0););
                                                    u = i[k + 36 >> 2];
                                                }
                                                if (i[k + 44 >> 2] = w, i[k + 40 >> 2] = t, i[k + 36 >> 2] = f, !u) break r;
                                                X(u);
                                            }
                                            i[k + 40 >> 2] = t, r = i[v + 4 >> 2] - i[v >> 2] >>> 16 | 0, e = i[k + 44 >> 2];
                                            r: {
                                                if (e >>> 0 > t >>> 0) {
                                                    o[t | 0] = r, n = t + 1 | 0;
                                                    break r;
                                                }
                                                if (u = i[k + 36 >> 2], s = t - u | 0, f = s + 1 | 0, (f | 0) < 0) break e;
                                                e = e - u | 0, n = e << 1, n = e >>> 0 >= 1073741823 ? 2147483647 : n >>> 0 > f >>> 0 ? n : f, n ? f = D(n) : f = 0, e = s + f | 0, o[e | 0] = r, w = n + f | 0, n = e + 1 | 0;
                                                A: {
                                                    if ((t | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (h = 0, r = t, s = s & 3, s) for(; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                    if (u - t >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (u | 0););
                                                    u = i[k + 36 >> 2];
                                                }
                                                if (i[k + 44 >> 2] = w, i[k + 40 >> 2] = n, i[k + 36 >> 2] = f, !u) break r;
                                                X(u);
                                            }
                                            i[k + 40 >> 2] = n, r = i[v + 4 >> 2] - i[v >> 2] >>> 8 | 0, e = i[k + 44 >> 2];
                                            r: {
                                                if (e >>> 0 > n >>> 0) {
                                                    o[n | 0] = r, t = n + 1 | 0;
                                                    break r;
                                                }
                                                if (u = i[k + 36 >> 2], s = n - u | 0, f = s + 1 | 0, (f | 0) < 0) break e;
                                                e = e - u | 0, t = e << 1, t = e >>> 0 >= 1073741823 ? 2147483647 : t >>> 0 > f >>> 0 ? t : f, t ? f = D(t) : f = 0, e = s + f | 0, o[e | 0] = r, w = t + f | 0, t = e + 1 | 0;
                                                A: {
                                                    if ((n | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (h = 0, r = n, s = s & 3, s) for(; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                    if (u - n >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (u | 0););
                                                    u = i[k + 36 >> 2];
                                                }
                                                if (i[k + 44 >> 2] = w, i[k + 40 >> 2] = t, i[k + 36 >> 2] = f, !u) break r;
                                                X(u);
                                            }
                                            i[k + 40 >> 2] = t, r = i[v + 4 >> 2] - i[v >> 2] | 0, e = i[k + 44 >> 2];
                                            r: {
                                                if (e >>> 0 > t >>> 0) {
                                                    o[t | 0] = r, n = t + 1 | 0;
                                                    break r;
                                                }
                                                if (u = i[k + 36 >> 2], s = t - u | 0, f = s + 1 | 0, (f | 0) < 0) break e;
                                                e = e - u | 0, n = e << 1, n = e >>> 0 >= 1073741823 ? 2147483647 : n >>> 0 > f >>> 0 ? n : f, n ? f = D(n) : f = 0, e = s + f | 0, o[e | 0] = r, w = n + f | 0, n = e + 1 | 0;
                                                A: {
                                                    if ((t | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (h = 0, r = t, s = s & 3, s) for(; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], h = h + 1 | 0, (s | 0) != (h | 0););
                                                    if (u - t >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (u | 0););
                                                    u = i[k + 36 >> 2];
                                                }
                                                if (i[k + 44 >> 2] = w, i[k + 40 >> 2] = n, i[k + 36 >> 2] = f, !u) break r;
                                                X(u);
                                            }
                                            i[k + 40 >> 2] = n, f = i[v + 4 >> 2], s = i[v >> 2], r = f - s | 0;
                                            r: {
                                                if ((r | 0) <= 0) break r;
                                                if (w = i[k + 44 >> 2], (r | 0) <= (w - n | 0)) {
                                                    (f | 0) != (s | 0) && Q0(n, s, r), i[k + 40 >> 2] = r + n;
                                                    break r;
                                                }
                                                if (f = i[k + 36 >> 2], u = n - f | 0, e = u + r | 0, (e | 0) < 0) break e;
                                                h = 0, t = 0, w = w - f | 0, B = w << 1, e = w >>> 0 >= 1073741823 ? 2147483647 : e >>> 0 < B >>> 0 ? B : e, e && (t = D(e)), w = e + t | 0, B = r, e = t + u | 0, r = v0(e, s, r), s = B + r | 0;
                                                A: {
                                                    if ((n | 0) == (f | 0)) {
                                                        t = r;
                                                        break A;
                                                    }
                                                    if (r = n, u = u & 3, u) for(; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], h = h + 1 | 0, (u | 0) != (h | 0););
                                                    if (f - n >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (f | 0););
                                                    if (r = i[k + 40 >> 2], h = r - n | 0, (r | 0) == (n | 0)) break A;
                                                    Q0(s, n, h);
                                                }
                                                if (i[k + 40 >> 2] = s + h, r = i[k + 36 >> 2], i[k + 36 >> 2] = t, i[k + 44 >> 2] = w, !r) break r;
                                                X(r);
                                            }
                                            if (v = v + 12 | 0, (W | 0) != (v | 0)) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    p0(), z();
                                }
                                if (_ = _ + 16 | 0, (G | 0) == (_ | 0)) break;
                            }
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                if (r = i[k + 40 >> 2], e = i[k + 36 >> 2], (r | 0) != (e | 0)) {
                                    if (r = r - e | 0, (r | 0) < 0) break i;
                                    f = D(r), i[A + 4 >> 2] = f, i[A >> 2] = f, t = r + f | 0, i[A + 8 >> 2] = t, v0(f, e, r), i[A + 4 >> 2] = t;
                                }
                                r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[k + 36 >> 2], A && (i[k + 40 >> 2] = A, X(A)), m = k + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function W3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0, L = 0, q = 0, m0 = 0, Z0 = 0, X0 = 0, V0 = 0, I0 = 0, F0 = 0, g0 = 0, R0 = 0, D0 = 0, H0 = 0, i2 = 0, e2 = 0, k2 = 0, t2 = 0, v2 = 0, y2 = 0, U2 = 0, H2 = 0, j2 = 0, K2 = 0, i1 = 0, v1 = 0, p1 = 0, V1 = 0, y1 = 0, I1 = 0, D1 = 0;
                            i: {
                                e: {
                                    v = i[A + 276 >> 2], X0 = (f | 0) > (v | 0) ? v : f;
                                    r: {
                                        if ((X0 | 0) <= (e | 0) || (f = i[A + 272 >> 2], V0 = (f | 0) < (k | 0) ? f : k, (V0 | 0) <= 0)) break r;
                                        for(P = i[A + 124 >> 2], L = i[P + 16856 >> 2], y2 = L << (r ^ 1), q = i[P + 16852 >> 2], U2 = q << r, H2 = A + 4 | 0, j2 = 3 - L | 0, K2 = 3 - q | 0, u = -1 << i[P + 16840 >> 2] ^ -1, B = i[A + 44 >> 2], $ = Z(B, 3), c = B << 1, i1 = 3 - B | 0, v1 = 2 - B | 0, p1 = 1 - B | 0, V1 = 0 - B | 0;;){
                                            for(I0 = e << j2, r0 = Z(I0, L), F0 = r0 - 1 | 0, y1 = (r0 | 0) / 4 | 0, f0 = 0;;){
                                                if (t0 = f0 << K2, s0 = Z(q, t0), f = l[(i[A + 260 >> 2] + ((s0 | 0) / 4 | 0) | 0) + Z(i[A + 272 >> 2], y1) | 0] & 3, f >>> 0 > 1) for(I1 = t0 - B | 0, g0 = s0 - 1 | 0, t = 1, D1 = (f << 1) - 2 | 0, f = 1;;){
                                                    G = i[(f << 2) + H2 >> 2], k = Z(i[A + 44 >> 2], I0), v = (G + k | 0) + t0 | 0;
                                                    A: {
                                                        if (!r) {
                                                            s = k + I1 | 0, f = s + G | 0, F = f + 3 | 0, k = G + (k + t0 | 0) | 0, E = k + 3 | 0, R = k + 2 | 0, M = k + 1 | 0, G = G + (s - B | 0) | 0, w = G + 3 | 0, _ = G + 2 | 0, W = G + 1 | 0, V = k + B | 0, y = V + 3 | 0, H = V + 2 | 0, T = V + 1 | 0, S = f + 2 | 0, h = f + 1 | 0;
                                                            break A;
                                                        }
                                                        E = v + $ | 0, R = v + c | 0, M = v + B | 0, G = v - 2 | 0, w = $ + G | 0, V = v + 1 | 0, y = $ + V | 0, _ = G + c | 0, H = V + c | 0, W = B + G | 0, T = B + V | 0, f = v - 1 | 0, F = $ + f | 0, k = v, S = f + c | 0, h = f + B | 0;
                                                    }
                                                    if (n = i[A + 168 >> 2], m0 = s0 >> n, (m0 | 0) < 0 || (s = i[A + 172 >> 2], (s | 0) <= (m0 | 0))) break e;
                                                    if (Z0 = r0 >> n, (Z0 | 0) < 0 || (C = i[A + 176 >> 2], (C | 0) <= (Z0 | 0))) break i;
                                                    R0 = l[w | 0], D0 = l[_ | 0], H0 = l[W | 0], i2 = l[G | 0], F = l[F | 0], w = l[S | 0], h = l[h | 0], _ = l[f | 0], e2 = l[y | 0], k2 = l[H | 0], t2 = l[T | 0], v2 = l[V | 0], V = l[E | 0], E = l[R | 0], R = l[M | 0], M = l[k | 0], G = t, k = i[i[A + 132 >> 2] + (t ? 32 : 36) >> 2], H = i[A + 160 >> 2], T = H + Z(m0, 3) | 0, S = Z(Z(s, Z0), 3), W = T + S | 0, t = o[W + 2 | 0];
                                                    A: {
                                                        if (!r) {
                                                            if (f = F0 >> n, (f | 0) < 0 | (f | 0) >= (C | 0)) break i;
                                                            f = (T + Z(Z(f, s), 3) | 0) + 2 | 0;
                                                            break A;
                                                        }
                                                        if (f = g0 >> n, (f | 0) < 0 | f >>> 0 >= s >>> 0) break e;
                                                        f = (S + (H + Z(f, 3) | 0) | 0) + 2 | 0;
                                                    }
                                                    f = k + ((t + o[f | 0] | 0) + 1 >> 1) | 0;
                                                    A: {
                                                        if (i[P + 16848 >> 2] != 1) {
                                                            f = (f | 0) >= 51 ? 51 : f;
                                                            break A;
                                                        }
                                                        if ((f | 0) < 30) break A;
                                                        if (f >>> 0 <= 42) {
                                                            f = i[(f << 2) + 51224 >> 2];
                                                            break A;
                                                        }
                                                        f = f - 6 | 0;
                                                    }
                                                    if (t = i[A + 148 >> 2], k = s0 >> t, (k | 0) < 0 || (y = i[A + 152 >> 2], (y | 0) <= (k | 0))) break e;
                                                    if (t = r0 >> t, (t | 0) < 0 | (t | 0) >= i[A + 156 >> 2]) break i;
                                                    f = i[i[i[A + 52 >> 2] + (I[((i[A + 140 >> 2] + Z(k, 24) | 0) + Z(Z(t, y), 24) | 0) + 2 >> 1] << 2) >> 2] + 768 >> 2] + (f + D1 | 0) | 0, f = (f | 0) >= 53 ? 53 : f, f = l[((f | 0) > 0 ? f : 0) + 48336 | 0] << i[P + 16840 >> 2] - 8, y = l[P + 8812 | 0];
                                                    A: {
                                                        f: {
                                                            if (!r) {
                                                                if (t = F0 >> n, y) {
                                                                    if ((t | 0) < 0 | (t | 0) >= (C | 0)) break i;
                                                                    n = !(l[(T + Z(Z(t, s), 3) | 0) + 1 | 0] & 4);
                                                                } else n = 1;
                                                                if ((t | 0) < 0 | (t | 0) >= (C | 0)) break i;
                                                                if (k = 0 - f | 0, C = (((M - _ << 2) + i2 | 0) - v2 | 0) + 4 >> 3, C = (k | 0) > (C | 0) ? k : (f | 0) > (C | 0) ? C : f, W = l[W | 0] | l[W + 1 | 0] << 8, t = n & !(l[(T + Z(Z(t, s), 3) | 0) + 1 | 0] & 8), t && (s = _ + C | 0, o[v + V1 | 0] = (s | 0) >= 0 ? (u | 0) > (s | 0) ? s : u : 0), s = !(W & 2048) & (!y | !(W & 1024)), s && (n = M - C | 0, o[v | 0] = (n | 0) >= 0 ? (n | 0) < (u | 0) ? n : u : 0), n = (((R - h << 2) + H0 | 0) - t2 | 0) + 4 >> 3, n = (k | 0) > (n | 0) ? k : (f | 0) > (n | 0) ? n : f, t && (h = n + h | 0, o[v + p1 | 0] = (h | 0) >= 0 ? (u | 0) > (h | 0) ? h : u : 0), s && (n = R - n | 0, o[v + 1 | 0] = (n | 0) >= 0 ? (n | 0) < (u | 0) ? n : u : 0), n = (((E - w << 2) + D0 | 0) - k2 | 0) + 4 >> 3, n = (k | 0) > (n | 0) ? k : (f | 0) > (n | 0) ? n : f, t && (w = n + w | 0, o[v + v1 | 0] = (w | 0) >= 0 ? (u | 0) > (w | 0) ? w : u : 0), s && (n = E - n | 0, o[v + 2 | 0] = (n | 0) >= 0 ? (n | 0) < (u | 0) ? n : u : 0), n = (((V - F << 2) + R0 | 0) - e2 | 0) + 4 >> 3, f = (k | 0) > (n | 0) ? k : (f | 0) > (n | 0) ? n : f, t && (k = f + F | 0, o[v + i1 | 0] = (k | 0) >= 0 ? (k | 0) < (u | 0) ? k : u : 0), !s) break A;
                                                                k = 3, f = V - f | 0;
                                                                break f;
                                                            }
                                                            if (t = g0 >> n, y) {
                                                                if ((t | 0) < 0 | t >>> 0 >= s >>> 0) break e;
                                                                n = !(l[(S + (H + Z(t, 3) | 0) | 0) + 1 | 0] & 4);
                                                            } else n = 1;
                                                            if ((t | 0) < 0 | t >>> 0 >= s >>> 0) break e;
                                                            if (k = 0 - f | 0, s = (((M - _ << 2) + i2 | 0) - v2 | 0) + 4 >> 3, C = (k | 0) > (s | 0) ? k : (f | 0) > (s | 0) ? s : f, W = l[W | 0] | l[W + 1 | 0] << 8, s = v - 1 | 0, t = n & !(l[(S + (H + Z(t, 3) | 0) | 0) + 1 | 0] & 8), t && (n = _ + C | 0, o[s | 0] = (n | 0) >= 0 ? (n | 0) < (u | 0) ? n : u : 0), n = !(W & 2048) & (!y | !(W & 1024)), n && (_ = M - C | 0, o[v | 0] = (_ | 0) >= 0 ? (u | 0) > (_ | 0) ? _ : u : 0), _ = (((R - h << 2) + H0 | 0) - t2 | 0) + 4 >> 3, _ = (k | 0) > (_ | 0) ? k : (f | 0) > (_ | 0) ? _ : f, t && (h = h + _ | 0, o[s + B | 0] = (h | 0) >= 0 ? (u | 0) > (h | 0) ? h : u : 0), n && (h = R - _ | 0, o[v + B | 0] = (h | 0) >= 0 ? (u | 0) > (h | 0) ? h : u : 0), h = (((E - w << 2) + D0 | 0) - k2 | 0) + 4 >> 3, h = (k | 0) > (h | 0) ? k : (f | 0) > (h | 0) ? h : f, t && (w = h + w | 0, o[s + c | 0] = (w | 0) >= 0 ? (u | 0) > (w | 0) ? w : u : 0), n && (w = E - h | 0, o[v + c | 0] = (w | 0) >= 0 ? (u | 0) > (w | 0) ? w : u : 0), w = (((V - F << 2) + R0 | 0) - e2 | 0) + 4 >> 3, f = (k | 0) > (w | 0) ? k : (f | 0) > (w | 0) ? w : f, t && (k = f + F | 0, o[s + $ | 0] = (k | 0) >= 0 ? (k | 0) < (u | 0) ? k : u : 0), !n) break A;
                                                            k = $, f = V - f | 0;
                                                        }
                                                        o[k + v | 0] = (f | 0) >= 0 ? (f | 0) < (u | 0) ? f : u : 0;
                                                    }
                                                    if (f = 2, t = 0, !G) break;
                                                }
                                                if (f0 = f0 + U2 | 0, !((V0 | 0) > (f0 | 0))) break;
                                            }
                                            if (e = e + y2 | 0, !((X0 | 0) > (e | 0))) break;
                                        }
                                    }
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function ww(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            h = m - 16 | 0, m = h, n = (f | 0) / 8 | 0, t = i[e >> 2], u = i[e + 4 >> 2] - t | 0, s = i[k >> 2];
                            i: {
                                if (n >>> 0 > u - s >>> 0) {
                                    if (r = D(40), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 39, i[h + 12 >> 2] = -2147483608, e = l[7425] | l[7426] << 8 | (l[7427] << 16 | l[7428] << 24), f = l[7421] | l[7422] << 8 | (l[7423] << 16 | l[7424] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 39 | 0] = 0, e = l[7456] | l[7457] << 8 | (l[7458] << 16 | l[7459] << 24), f = l[7452] | l[7453] << 8 | (l[7454] << 16 | l[7455] << 24), o[r + 31 | 0] = f, o[r + 32 | 0] = f >>> 8, o[r + 33 | 0] = f >>> 16, o[r + 34 | 0] = f >>> 24, o[r + 35 | 0] = e, o[r + 36 | 0] = e >>> 8, o[r + 37 | 0] = e >>> 16, o[r + 38 | 0] = e >>> 24, e = l[7449] | l[7450] << 8 | (l[7451] << 16 | l[7452] << 24), f = l[7445] | l[7446] << 8 | (l[7447] << 16 | l[7448] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7441] | l[7442] << 8 | (l[7443] << 16 | l[7444] << 24), f = l[7437] | l[7438] << 8 | (l[7439] << 16 | l[7440] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7433] | l[7434] << 8 | (l[7435] << 16 | l[7436] << 24), f = l[7429] | l[7430] << 8 | (l[7431] << 16 | l[7432] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                    X(i[h + 4 >> 2]);
                                    break i;
                                }
                                t = t + s | 0, w = l[t | 0], v = l[t + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        v = l[t + 3 | 0] | (v << 16 | w << 24 | l[t + 2 | 0] << 8), t = 4;
                                        break e;
                                    }
                                    v = v | w << 8, t = 2;
                                }
                                if (t = t + s | 0, i[k >> 2] = t, s = u - t | 0, t = O0(n, n >> 31, v, 0), n = w0 << 1 | t >>> 31, t = t << 1, !n & t >>> 0 <= s >>> 0) {
                                    e: {
                                        if (!v) break e;
                                        W = (f | 0) != 32;
                                        r: {
                                            for(;;){
                                                f = i[k >> 2], n = f + i[e >> 2] | 0, t = l[n | 0], s = l[n + 1 | 0];
                                                A: {
                                                    if (!W) {
                                                        w = l[n + 3 | 0], u = l[n + 2 | 0], n = f + 4 | 0, i[k >> 2] = n, n = n + i[e >> 2] | 0, n = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), n = n << 24 | (n & 65280) << 8 | (n >>> 8 & 65280 | n >>> 24), s = s << 16 | t << 24 | u << 8 | w, f = f + 8 | 0;
                                                        break A;
                                                    }
                                                    n = f + 2 | 0, i[k >> 2] = n, s = (s << 16 | t << 24) >> 16, n = n + i[e >> 2] | 0, n = (l[n + 1 | 0] << 16 | l[n | 0] << 24) >> 16, f = f + 4 | 0;
                                                }
                                                i[k >> 2] = f;
                                                A: {
                                                    f = i[r + 12 >> 2], u = i[r + 16 >> 2];
                                                    f: {
                                                        if (f >>> 0 < u >>> 0) {
                                                            i[f >> 2] = s, i[f + 4 >> 2] = n, s = f + 8 | 0;
                                                            break f;
                                                        }
                                                        if (w = i[r + 8 >> 2], B = f - w >> 3, t = B + 1 | 0, t >>> 0 >= 536870912) break A;
                                                        if (u = u - w | 0, _ = u >> 2, _ = u >>> 0 >= 2147483640 ? 536870911 : t >>> 0 < _ >>> 0 ? _ : t, _) {
                                                            if (_ >>> 0 >= 536870912) break r;
                                                            t = D(_ << 3);
                                                        } else t = 0;
                                                        if (u = t + (B << 3) | 0, i[u >> 2] = s, i[u + 4 >> 2] = n, s = u + 8 | 0, (f | 0) != (w | 0)) {
                                                            for(; f = f - 8 | 0, B = i[f + 4 >> 2], u = u - 8 | 0, n = u, i[n >> 2] = i[f >> 2], i[n + 4 >> 2] = B, (f | 0) != (w | 0););
                                                            w = i[r + 8 >> 2];
                                                        }
                                                        if (i[r + 16 >> 2] = t + (_ << 3), i[r + 12 >> 2] = s, i[r + 8 >> 2] = u, !w) break f;
                                                        X(w);
                                                    }
                                                    if (i[r + 12 >> 2] = s, G = G + 1 | 0, (G | 0) != (v | 0)) continue;
                                                    break e;
                                                }
                                                break;
                                            }
                                            p0(), z();
                                        }
                                        Z2(), z();
                                    }
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                if (r = D(40), i[h + 4 >> 2] = r, i[h + 8 >> 2] = 39, i[h + 12 >> 2] = -2147483608, e = l[7425] | l[7426] << 8 | (l[7427] << 16 | l[7428] << 24), f = l[7421] | l[7422] << 8 | (l[7423] << 16 | l[7424] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 39 | 0] = 0, e = l[7456] | l[7457] << 8 | (l[7458] << 16 | l[7459] << 24), f = l[7452] | l[7453] << 8 | (l[7454] << 16 | l[7455] << 24), o[r + 31 | 0] = f, o[r + 32 | 0] = f >>> 8, o[r + 33 | 0] = f >>> 16, o[r + 34 | 0] = f >>> 24, o[r + 35 | 0] = e, o[r + 36 | 0] = e >>> 8, o[r + 37 | 0] = e >>> 16, o[r + 38 | 0] = e >>> 24, e = l[7449] | l[7450] << 8 | (l[7451] << 16 | l[7452] << 24), f = l[7445] | l[7446] << 8 | (l[7447] << 16 | l[7448] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7441] | l[7442] << 8 | (l[7443] << 16 | l[7444] << 24), f = l[7437] | l[7438] << 8 | (l[7439] << 16 | l[7440] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7433] | l[7434] << 8 | (l[7435] << 16 | l[7436] << 24), f = l[7429] | l[7430] << 8 | (l[7431] << 16 | l[7432] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, h + 4 | 0), o[h + 15 | 0] >= 0) break i;
                                X(i[h + 4 >> 2]);
                            }
                            m = h + 16 | 0;
                        }
                        function vw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            h = m - 32 | 0, m = h;
                            i: {
                                e: {
                                    r: {
                                        if ((S0(i[e >> 2], 3) | 0) != 8 || (S0(i[e >> 2], 4) | 0) != 8) break r;
                                        if ((S0(i[e >> 2], 5) | 0) == 8) break e;
                                    }
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                w = A1(i[e >> 2], 6), v = l[k + 8 | 0];
                                e: {
                                    if (!w || (S0(i[e >> 2], 6) | 0) == 8) break e;
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = D(136), r = n, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), u = i[r + 4 >> 2], k = u + 1 | 0, i[r + 4 >> 2] = k, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, f = n + 76 | 0, i[n + 72 >> 2] = f, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, G = n + 12 | 0, i[n + 12 >> 2] = G, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = u, i[n + 16 >> 2] = n, k || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), r = i[e >> 2], V = i[r + 24 >> 2], k = V, F = i[r + 28 >> 2], r = F, _ = w | v, i[G + 36 >> 2] = _ & 1 ? 13 : 12, i[G + 32 >> 2] = 1, i[G + 28 >> 2] = r, i[G + 24 >> 2] = k, J0(h + 8 | 0, G, 10, k, r, S0(i[e >> 2], 3), t);
                                e: {
                                    if (i[h + 8 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[h + 12 >> 2], i[A + 8 >> 2] = i[h + 8 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[h + 27 | 0] >= 0) {
                                            A = i[h + 20 >> 2], i[r >> 2] = i[h + 16 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[h + 24 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[h + 16 >> 2], i[h + 20 >> 2]), o[h + 27 | 0] >= 0) break e;
                                        X(i[h + 16 >> 2]);
                                        break e;
                                    }
                                    o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), e = i[e >> 2], r = e - -64 | 0;
                                    r: {
                                        A: {
                                            if (k = i[e + 64 >> 2], k) {
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 3, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                W = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (W = 0, i[t + 16 >> 2] > 3)) break f;
                                                    E = i[t + 44 >> 2], W = i[t + 52 >> 2];
                                                }
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 4, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                C = 0;
                                                f: {
                                                    if ((r | 0) == (t | 0) || (C = 0, i[t + 16 >> 2] > 4)) break f;
                                                    R = i[t + 52 >> 2], C = i[t + 44 >> 2];
                                                }
                                                for(t = r, e = k; u = i[e + 16 >> 2] < 5, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (t | 0)) break A;
                                            }
                                            y = 0;
                                            break r;
                                        }
                                        if (y = 0, i[t + 16 >> 2] > 5) break r;
                                        M = i[t + 52 >> 2], y = i[t + 44 >> 2];
                                    }
                                    e = i[f >> 2], u = 0;
                                    r: {
                                        if (!e) break r;
                                        for(t = f; u = i[e + 16 >> 2] < 10, t = u ? t : e, e = i[(u << 2) + e >> 2], !!e;);
                                        if ((f | 0) == (t | 0)) {
                                            u = 0;
                                            break r;
                                        }
                                        if (u = 0, i[t + 16 >> 2] > 10) break r;
                                        H = i[t + 52 >> 2], u = i[t + 44 >> 2];
                                    }
                                    t = 0, f = 0;
                                    r: {
                                        if (!k | w ^ 1) break r;
                                        for(e = r; f = i[k + 16 >> 2] < 6, e = f ? e : k, k = i[(f << 2) + k >> 2], !!k;);
                                        if (f = 0, (r | 0) == (e | 0) || (f = 0, i[e + 16 >> 2] > 6)) break r;
                                        t = i[e + 52 >> 2], f = i[e + 44 >> 2];
                                    }
                                    e = f;
                                    r: {
                                        if (!F) break r;
                                        if (w) {
                                            if (!V) break r;
                                            for(r = 0;;){
                                                for(T = Z(r, t), s = y + Z(r, M) | 0, w = Z(r, R) + C | 0, v = Z(r, W) + E | 0, _ = Z(r, H) + u | 0, k = 0; B = (k << 3) + _ | 0, o[B | 0] = 0, f = l[k + v | 0], o[B + 2 | 0] = 0, o[B + 1 | 0] = f, f = l[k + w | 0], o[B + 4 | 0] = 0, o[B + 3 | 0] = f, f = l[k + s | 0], o[B + 6 | 0] = 0, o[B + 5 | 0] = f, o[B + 7 | 0] = l[e + (k + T | 0) | 0], k = k + 1 | 0, (V | 0) != (k | 0););
                                                if (r = r + 1 | 0, (F | 0) == (r | 0)) break;
                                            }
                                            break r;
                                        }
                                        if (!V) break r;
                                        if (w = _ & 1 ? 8 : 6, f = 0, v & 1) for(;;){
                                            for(v = y + Z(f, M) | 0, _ = Z(f, R) + C | 0, t = Z(f, W) + E | 0, e = Z(f, H) + u | 0, k = 0; s = e + Z(k, w) | 0, o[s | 0] = 0, r = l[k + t | 0], o[s + 2 | 0] = 0, o[s + 1 | 0] = r, r = l[k + _ | 0], o[s + 4 | 0] = 0, o[s + 3 | 0] = r, r = l[k + v | 0], o[s + 6 | 0] = 0, o[s + 7 | 0] = 255, o[s + 5 | 0] = r, k = k + 1 | 0, (V | 0) != (k | 0););
                                            if (f = f + 1 | 0, (F | 0) == (f | 0)) break r;
                                        }
                                        for(;;){
                                            for(v = y + Z(f, M) | 0, _ = Z(f, R) + C | 0, t = Z(f, W) + E | 0, k = Z(f, H) + u | 0, e = 0; s = k + Z(e, w) | 0, o[s | 0] = 0, r = l[e + t | 0], o[s + 2 | 0] = 0, o[s + 1 | 0] = r, r = l[e + _ | 0], o[s + 4 | 0] = 0, o[s + 3 | 0] = r, o[s + 5 | 0] = l[e + v | 0], e = e + 1 | 0, (V | 0) != (e | 0););
                                            if (f = f + 1 | 0, (F | 0) == (f | 0)) break;
                                        }
                                    }
                                    if (i[A + 4 >> 2] = n, i[A >> 2] = G, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            m = h + 32 | 0;
                        }
                        function X3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0;
                            i: {
                                e: {
                                    n = i[A + 276 >> 2], M = (f | 0) > (n | 0) ? n : f;
                                    r: {
                                        if ((M | 0) <= (e | 0) || (f = i[A + 272 >> 2], H = (f | 0) < (k | 0) ? f : k, (H | 0) <= 0)) break r;
                                        for(P = r ? 16 : 32, $ = r ? 80 : 160, c = r ? 1 : 2, r0 = r ? 2 : 1, f0 = r - 1 | 0, t0 = 0 - r | 0;;){
                                            for(V = e << 2, y = f0 + V | 0, T = V >> 2, f = 0;;){
                                                A: {
                                                    f: {
                                                        k: {
                                                            if (k = f << 2, S = k >> 2, v = (S + i[A + 260 >> 2] | 0) + Z(i[A + 272 >> 2], T) | 0, t = l[v | 0], t & $) {
                                                                if (n = k + t0 | 0, r = i[A + 168 >> 2], s = n >> r, (s | 0) < 0 || (u = i[A + 172 >> 2], (u | 0) <= (s | 0))) break e;
                                                                if (h = y >> r, (h | 0) < 0 || (w = i[A + 176 >> 2], (w | 0) <= (h | 0))) break i;
                                                                if (_ = k >> r, (_ | 0) < 0 | u >>> 0 <= _ >>> 0) break e;
                                                                if (B = V >> r, (B | 0) < 0 | (w | 0) <= (B | 0)) break i;
                                                                r = 2, w = Z(s, 3), s = i[A + 160 >> 2], h = (w + s | 0) + Z(Z(u, h), 3) | 0;
                                                                n: {
                                                                    if (!((l[h | 0] | l[h + 1 | 0] << 8) & 768) || (u = (s + Z(_, 3) | 0) + Z(Z(u, B), 3) | 0, !((l[u | 0] | l[u + 1 | 0] << 8) & 768))) break n;
                                                                    if (t & P) {
                                                                        if (u = i[A + 248 >> 2], h = k >> u, (h | 0) < 0 || (s = i[A + 252 >> 2], (s | 0) <= (h | 0))) break e;
                                                                        if (_ = V >> u, (_ | 0) < 0 || (B = i[A + 256 >> 2], (B | 0) <= (_ | 0))) break i;
                                                                        if (r = 1, w = i[A + 240 >> 2], o[(w + h | 0) + Z(s, _) | 0] < 0) break n;
                                                                        if (h = n >> u, (h | 0) < 0 | s >>> 0 <= h >>> 0) break e;
                                                                        if (u = y >> u, (u | 0) < 0 | (u | 0) >= (B | 0)) break i;
                                                                        if (o[(h + w | 0) + Z(u, s) | 0] < 0) break n;
                                                                    }
                                                                    if (r = i[A + 188 >> 2], h = n >> r, (h | 0) < 0 || (u = i[A + 192 >> 2], (u | 0) <= (h | 0))) break e;
                                                                    if (_ = y >> r, (_ | 0) < 0 || (s = i[A + 196 >> 2], (s | 0) <= (_ | 0))) break i;
                                                                    if (B = k >> r, (B | 0) < 0 | u >>> 0 <= B >>> 0) break e;
                                                                    if (w = V >> r, (w | 0) < 0 | (s | 0) <= (w | 0)) break i;
                                                                    if (r = n, n = i[A + 148 >> 2], G = r >> n, (G | 0) < 0 || (s = i[A + 152 >> 2], (s | 0) <= (G | 0))) break e;
                                                                    if (W = y >> n, (W | 0) < 0 || (F = i[A + 156 >> 2], (F | 0) <= (W | 0))) break i;
                                                                    if (r = 0, C = i[A + 52 >> 2], E = i[A + 56 >> 2] - C >> 2, R = Z(G, 24), G = i[A + 140 >> 2], W = I[((R + G | 0) + Z(Z(s, W), 24) | 0) + 2 >> 1], E >>> 0 > W >>> 0 && (r = i[C + (W << 2) >> 2]), k = k >> n, (k | 0) < 0 | k >>> 0 >= s >>> 0) break e;
                                                                    if (n = V >> n, (n | 0) < 0 | (n | 0) >= (F | 0)) break i;
                                                                    if (k = I[((G + Z(k, 24) | 0) + Z(Z(n, s), 24) | 0) + 2 >> 1], k >>> 0 >= E >>> 0) {
                                                                        r = 0;
                                                                        break n;
                                                                    }
                                                                    if (!r) {
                                                                        r = 0;
                                                                        break n;
                                                                    }
                                                                    if (G = i[C + (k << 2) >> 2], !G) {
                                                                        r = 0;
                                                                        break n;
                                                                    }
                                                                    if (n = i[A + 180 >> 2], k = (n + Z(h, 12) | 0) + Z(Z(u, _), 12) | 0, h = o[k + 2 | 0], (h | 0) > 16 || (W = o[k + 3 | 0], (W | 0) > 16) || (n = (n + Z(B, 12) | 0) + Z(Z(u, w), 12) | 0, w = o[n + 2 | 0], (w | 0) > 16) || (C = o[n + 3 | 0], (C | 0) > 16)) break f;
                                                                    if (s = -1, t = -1, B = l[k | 0], t = B ? i[((h << 2) + r | 0) + 924 >> 2] : t, _ = l[k + 1 | 0], s = _ ? i[((W << 2) + r | 0) + 988 >> 2] : s, v = -1, u = -1, h = l[n | 0], u = h ? i[(G + (w << 2) | 0) + 924 >> 2] : u, w = l[n + 1 | 0], v = w ? i[(G + (C << 2) | 0) + 988 >> 2] : v, !((t | 0) == (u | 0) & (v | 0) == (s | 0)) && (r = 1, (t | 0) != (v | 0) | (u | 0) != (s | 0))) break n;
                                                                    r = I[n + 8 >> 1], G = I[n + 10 >> 1], W = I[n + 4 >> 1], n = I[n + 6 >> 1], C = I[k + 8 >> 1], F = I[k + 10 >> 1], E = I[k + 4 >> 1], R = I[k + 6 >> 1], (_ + B | 0) != (h + w | 0) && (W2(i[A + 112 >> 2] + 4 | 0, 1013, 0), o[A + 312 | 0] = 3), r = w ? r : 0, k = w ? G : 0, w = h ? W : 0, n = h ? n : 0, h = _ ? C : 0, _ = _ ? F : 0, G = B ? E : 0, B = B ? R : 0;
                                                                    t: {
                                                                        if ((t | 0) != (s | 0)) {
                                                                            if (s = G << 16 >> 16, (t | 0) != (u | 0)) {
                                                                                if (t = s - (r << 16 >> 16) | 0, r = t >> 31, (r ^ t) - r >>> 0 > 3 || (k = (B << 16 >> 16) - (k << 16 >> 16) | 0, r = k >> 31, (r ^ k) - r >>> 0 > 3) || (k = (h << 16 >> 16) - (w << 16 >> 16) | 0, r = k >> 31, (r ^ k) - r >>> 0 > 3) || (r = 0, n = (_ << 16 >> 16) - (n << 16 >> 16) | 0, k = n >> 31, (k ^ n) - k >>> 0 >= 4)) break t;
                                                                                break n;
                                                                            }
                                                                            if (u = s - (w << 16 >> 16) | 0, t = u >> 31, (t ^ u) - t >>> 0 > 3 || (t = (B << 16 >> 16) - (n << 16 >> 16) | 0, n = t >> 31, (n ^ t) - n >>> 0 > 3) || (n = (h << 16 >> 16) - (r << 16 >> 16) | 0, r = n >> 31, (r ^ n) - r >>> 0 > 3) || (r = 0, n = (_ << 16 >> 16) - (k << 16 >> 16) | 0, k = n >> 31, (k ^ n) - k >>> 0 >= 4)) break t;
                                                                            break n;
                                                                        }
                                                                        if ((u | 0) != (v | 0)) break k;
                                                                        u = G << 16 >> 16, s = w << 16 >> 16, v = u - s | 0, t = v >> 31;
                                                                        o: {
                                                                            if ((t ^ v) - t >>> 0 > 3 || (v = (B << 16 >> 16) - (n << 16 >> 16) | 0, t = v >> 31, (t ^ v) - t >>> 0 > 3) || (v = (h << 16 >> 16) - (r << 16 >> 16) | 0, t = v >> 31, (t ^ v) - t >>> 0 > 3) || (v = (_ << 16 >> 16) - (k << 16 >> 16) | 0, t = v >> 31, (t ^ v) - t >>> 0 >= 4)) break o;
                                                                            r = 0;
                                                                            break n;
                                                                        }
                                                                        if (t = u - (r << 16 >> 16) | 0, r = t >> 31, (r ^ t) - r >>> 0 > 3 || (k = (B << 16 >> 16) - (k << 16 >> 16) | 0, r = k >> 31, (r ^ k) - r >>> 0 > 3) || (k = (h << 16 >> 16) - s | 0, r = k >> 31, (r ^ k) - r >>> 0 > 3)) break t;
                                                                        if (r = 0, n = (_ << 16 >> 16) - (n << 16 >> 16) | 0, k = n >> 31, (k ^ n) - k >>> 0 < 4) break n;
                                                                    }
                                                                    r = 1;
                                                                }
                                                                k = (i[A + 260 >> 2] + S | 0) + Z(i[A + 272 >> 2], T) | 0, o[k | 0] = l[k | 0] & 252 | r;
                                                                break A;
                                                            }
                                                            o[v | 0] = t & 252;
                                                            break A;
                                                        }
                                                        y0(18098, 15030, 355, 8917), z();
                                                    }
                                                    o[v | 0] = t & 252;
                                                }
                                                if (f = f + r0 | 0, !((H | 0) > (f | 0))) break;
                                            }
                                            if (e = e + c | 0, !((M | 0) > (e | 0))) break;
                                        }
                                    }
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function _w(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0;
                            u = m - 16 | 0, m = u, i[u + 12 >> 2] = r, i[k >> 2] = 0, s = i[f + 28 >> 2], i[u >> 2] = s, (s | 0) != 108396 && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), s = K0(u, 108580), d0(u);
                            i: {
                                e: {
                                    r: {
                                        A: switch(t - 65 | 0){
                                            case 0:
                                            case 32:
                                                Ut(A, n + 24 | 0, u + 12 | 0, e, k, s);
                                                break e;
                                            case 1:
                                            case 33:
                                            case 39:
                                                Jt(A, n + 16 | 0, u + 12 | 0, e, k, s);
                                                break e;
                                            case 34:
                                                r = p[i[i[A + 8 >> 2] + 12 >> 2]](A + 8 | 0) | 0, t = A, h = i[u + 12 >> 2], l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, s = A, l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, l[r + 11 | 0] >>> 7 | 0 ? r = i[r + 4 >> 2] : r = l[r + 11 | 0] & 127, w = u, v = Z8(t, h, e, f, k, n, s, A + r | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 35:
                                            case 36:
                                                A = $4(u + 12 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!(A - 1 >>> 0 > 30 | r & 4)) {
                                                        i[n + 12 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 3:
                                                i[u >> 2] = 623865125, i[u + 4 >> 2] = 2032480100, w = u, v = Z8(A, r, e, f, k, n, u, u + 8 | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 5:
                                                i[u >> 2] = 623728933, i[u + 4 >> 2] = 1680158061, w = u, v = Z8(A, r, e, f, k, n, u, u + 8 | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 7:
                                                A = $4(u + 12 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 23 | r & 4)) {
                                                        i[n + 8 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 8:
                                                A = $4(u + 12 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!(A - 1 >>> 0 > 11 | r & 4)) {
                                                        i[n + 8 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 41:
                                                A = $4(u + 12 | 0, e, k, s, 3), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 365 | r & 4)) {
                                                        i[n + 28 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 44:
                                                r = $4(u + 12 | 0, e, k, s, 2) - 1 | 0, A = i[k >> 2];
                                                f: {
                                                    if (!(r >>> 0 > 11 | A & 4)) {
                                                        i[n + 16 >> 2] = r;
                                                        break f;
                                                    }
                                                    i[k >> 2] = A | 4;
                                                }
                                                break e;
                                            case 12:
                                                A = $4(u + 12 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 59 | r & 4)) {
                                                        i[n + 4 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 45:
                                            case 51:
                                                for(A = u + 12 | 0, r = m - 16 | 0, m = r, i[r + 12 >> 2] = e;;){
                                                    f: {
                                                        if (T2(A, r + 12 | 0)) break f;
                                                        e = i[A >> 2], f = i[e + 12 >> 2];
                                                        k: {
                                                            if ((f | 0) == i[e + 16 >> 2]) {
                                                                e = p[i[i[e >> 2] + 36 >> 2]](e) | 0;
                                                                break k;
                                                            }
                                                            e = l[f | 0];
                                                        }
                                                        if (e = e << 24 >> 24, (e | 0) >= 0 ? e = i[i[s + 8 >> 2] + (e << 2) >> 2] & 1 : e = 0, !e) break f;
                                                        g1(A);
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                T2(A, r + 12 | 0) && (i[k >> 2] = i[k >> 2] | 2), m = r + 16 | 0;
                                                break e;
                                            case 47:
                                                t = u + 12 | 0, r = p[i[i[A + 8 >> 2] + 8 >> 2]](A + 8 | 0) | 0;
                                                f: {
                                                    if (l[r + 11 | 0] >>> 7 | 0) {
                                                        A = i[r + 4 >> 2];
                                                        break f;
                                                    }
                                                    A = l[r + 11 | 0] & 127;
                                                }
                                                l[r + 23 | 0] >>> 7 | 0 ? f = i[r + 16 >> 2] : f = l[r + 23 | 0] & 127;
                                                f: {
                                                    if ((A | 0) == (0 - f | 0)) {
                                                        i[k >> 2] = i[k >> 2] | 4;
                                                        break f;
                                                    }
                                                    if (e = Ie(t, e, r, r + 24 | 0, s, k, 0), A = i[n + 8 >> 2], !((e | 0) != (r | 0) | (A | 0) != 12)) {
                                                        i[n + 8 >> 2] = 0;
                                                        break f;
                                                    }
                                                    (e - r | 0) != 12 | (A | 0) > 11 || (i[n + 8 >> 2] = A + 12);
                                                }
                                                break e;
                                            case 49:
                                                t = l[65e3] | l[65001] << 8 | (l[65002] << 16 | l[65003] << 24), o[u + 7 | 0] = t, o[u + 8 | 0] = t >>> 8, o[u + 9 | 0] = t >>> 16, o[u + 10 | 0] = t >>> 24, t = l[64997] | l[64998] << 8 | (l[64999] << 16 | l[65e3] << 24), i[u >> 2] = l[64993] | l[64994] << 8 | (l[64995] << 16 | l[64996] << 24), i[u + 4 >> 2] = t, w = u, v = Z8(A, r, e, f, k, n, u, u + 11 | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 17:
                                                o[u + 4 | 0] = l[65008], i[u >> 2] = l[65004] | l[65005] << 8 | (l[65006] << 16 | l[65007] << 24), w = u, v = Z8(A, r, e, f, k, n, u, u + 5 | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 18:
                                                A = $4(u + 12 | 0, e, k, s, 2), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 60 | r & 4)) {
                                                        i[n >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 19:
                                                i[u >> 2] = 624576549, i[u + 4 >> 2] = 1394948685, w = u, v = Z8(A, r, e, f, k, n, u, u + 8 | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 54:
                                                A = $4(u + 12 | 0, e, k, s, 1), r = i[k >> 2];
                                                f: {
                                                    if (!((A | 0) > 6 | r & 4)) {
                                                        i[n + 24 >> 2] = A;
                                                        break f;
                                                    }
                                                    i[k >> 2] = r | 4;
                                                }
                                                break e;
                                            case 55:
                                                A = p[i[i[A >> 2] + 20 >> 2]](A, r, e, f, k, n) | 0;
                                                break i;
                                            case 23:
                                                r = p[i[i[A + 8 >> 2] + 24 >> 2]](A + 8 | 0) | 0, t = A, h = i[u + 12 >> 2], l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, s = A, l[r + 11 | 0] >>> 7 | 0 ? A = i[r >> 2] : A = r, l[r + 11 | 0] >>> 7 | 0 ? r = i[r + 4 >> 2] : r = l[r + 11 | 0] & 127, w = u, v = Z8(t, h, e, f, k, n, s, A + r | 0), i[w + 12 >> 2] = v;
                                                break e;
                                            case 56:
                                                at(n + 20 | 0, u + 12 | 0, e, k, s);
                                                break e;
                                            case 24:
                                                A = $4(u + 12 | 0, e, k, s, 4), l[k | 0] & 4 || (i[n + 20 >> 2] = A - 1900);
                                                break e;
                                            default:
                                                if ((t | 0) == 37) break r;
                                                break;
                                            case 2:
                                            case 4:
                                            case 6:
                                            case 9:
                                            case 10:
                                            case 11:
                                            case 13:
                                            case 14:
                                            case 15:
                                            case 16:
                                            case 20:
                                            case 21:
                                            case 22:
                                            case 25:
                                            case 26:
                                            case 27:
                                            case 28:
                                            case 29:
                                            case 30:
                                            case 31:
                                            case 37:
                                            case 38:
                                            case 40:
                                            case 42:
                                            case 43:
                                            case 46:
                                            case 48:
                                            case 50:
                                            case 52:
                                            case 53:
                                                break A;
                                        }
                                        i[k >> 2] = i[k >> 2] | 4;
                                        break e;
                                    }
                                    A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, r = 6, f = u + 12 | 0, t = A + 12 | 0;
                                    r: {
                                        A: {
                                            if (T2(f, t)) break A;
                                            r = 4, e = i[f >> 2], n = i[e + 12 >> 2];
                                            f: {
                                                if ((n | 0) == i[e + 16 >> 2]) {
                                                    e = p[i[i[e >> 2] + 36 >> 2]](e) | 0;
                                                    break f;
                                                }
                                                e = l[n | 0];
                                            }
                                            if ((p[i[i[s >> 2] + 36 >> 2]](s, e << 24 >> 24, 0) | 0) != 37) break A;
                                            if (r = 2, !T2(g1(f), t)) break r;
                                        }
                                        i[k >> 2] = i[k >> 2] | r;
                                    }
                                    m = A + 16 | 0;
                                }
                                A = i[u + 12 >> 2];
                            }
                            return m = u + 16 | 0, A | 0;
                        }
                        function Bw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            s = m - 48 | 0, m = s, u = D(136), i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 78252, B0(u + 20 | 0, 0, 104), k = i[u + 4 >> 2], f = k + 1 | 0, i[u + 4 >> 2] = f, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 44 >> 2] = 99, i[u + 48 >> 2] = 99, i[u + 32 >> 2] = 4142, r = u - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[u + 132 >> 2] = 0, i[u + 124 >> 2] = 0, i[u + 128 >> 2] = 0, i[u + 84 >> 2] = 1, i[u + 88 >> 2] = 1, r = u + 76 | 0, i[u + 72 >> 2] = r, i[u + 92 >> 2] = 0, i[u + 96 >> 2] = 0, i[u + 100 >> 2] = 0, i[u + 104 >> 2] = 0, i[u + 108 >> 2] = 0, i[u + 112 >> 2] = 0, o[u + 113 | 0] = 0, o[u + 114 | 0] = 0, o[u + 115 | 0] = 0, o[u + 116 | 0] = 0, o[u + 117 | 0] = 0, o[u + 118 | 0] = 0, o[u + 119 | 0] = 0, o[u + 120 | 0] = 0, V = u + 12 | 0, i[u + 12 >> 2] = V, i[u + 8 >> 2] = i[u + 8 >> 2] + 1, i[u + 4 >> 2] = k, i[u + 16 >> 2] = u, f || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), h = i[e >> 2], n = i[h + 24 >> 2], k = i[h + 28 >> 2], f = i[h + 32 >> 2], i[V + 36 >> 2] = i[h + 36 >> 2], i[V + 32 >> 2] = f, i[V + 28 >> 2] = k, i[V + 24 >> 2] = n;
                            i: {
                                for(;;){
                                    w = i[M + 46548 >> 2];
                                    e: {
                                        if (!A1(i[e >> 2], w)) break e;
                                        r: {
                                            A: {
                                                if (C = S0(i[e >> 2], w), C >>> 0 >= 9) {
                                                    if (v = T4(i[e >> 2], w), F = S4(i[e >> 2], w), J0(s + 24 | 0, V, w, v, F, 8, t), i[s + 24 >> 2]) {
                                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[s + 28 >> 2], i[A + 8 >> 2] = i[s + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[s + 43 | 0] >= 0) {
                                                            A = i[s + 36 >> 2], i[r >> 2] = i[s + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[s + 40 >> 2];
                                                            break i;
                                                        }
                                                        if (j(r, i[s + 32 >> 2], i[s + 36 >> 2]), o[s + 43 | 0] >= 0) break i;
                                                        X(i[s + 32 >> 2]);
                                                        break i;
                                                    }
                                                    if (o[s + 43 | 0] < 0 && X(i[s + 32 >> 2]), E = 0, k = i[e >> 2], h = k - -64 | 0, f = h, n = i[k + 64 >> 2], !n) break A;
                                                    for(; k = (w | 0) > i[n + 16 >> 2], f = k ? f : n, n = i[(k << 2) + n >> 2], !!n;);
                                                    if ((f | 0) == (h | 0)) break A;
                                                    if (_ = 0, h = 0, (w | 0) < i[f + 16 >> 2]) break r;
                                                    _ = i[f + 52 >> 2], h = i[f + 44 >> 2];
                                                    break r;
                                                }
                                                f: {
                                                    k: {
                                                        if ((C | 0) != 8) {
                                                            if (v = T4(i[e >> 2], w), F = S4(i[e >> 2], w), J0(s + 24 | 0, V, w, v, F, 8, t), i[s + 24 >> 2]) {
                                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[s + 28 >> 2], i[A + 8 >> 2] = i[s + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[s + 43 | 0] >= 0) {
                                                                    A = i[s + 36 >> 2], i[r >> 2] = i[s + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[s + 40 >> 2];
                                                                    break i;
                                                                }
                                                                if (j(r, i[s + 32 >> 2], i[s + 36 >> 2]), o[s + 43 | 0] >= 0) break i;
                                                                X(i[s + 32 >> 2]);
                                                                break i;
                                                            }
                                                            if (o[s + 43 | 0] < 0 && X(i[s + 32 >> 2]), f = 1 << 16 - C, n = (f & 65534) >>> C | 0, n) for(; f = f | n, n = n >>> C | 0, !!n;);
                                                            if (E = 0, n = i[e >> 2], _ = n - -64 | 0, k = _, n = i[n + 64 >> 2], !n) break k;
                                                            for(; h = (w | 0) > i[n + 16 >> 2], k = h ? k : n, n = i[(h << 2) + n >> 2], !!n;);
                                                            if ((k | 0) == (_ | 0)) break k;
                                                            if (y = 0, _ = 0, (w | 0) < i[k + 16 >> 2]) break f;
                                                            y = i[k + 52 >> 2], _ = i[k + 44 >> 2];
                                                            break f;
                                                        }
                                                        if (J8(s + 4 | 0, V, e, w, w, t), o[s + 23 | 0] >= 0) break e;
                                                        X(i[s + 12 >> 2]);
                                                        break e;
                                                    }
                                                    y = 0, _ = 0;
                                                }
                                                k = r, n = i[k >> 2], h = 0;
                                                f: {
                                                    if (!n) break f;
                                                    for(; h = (w | 0) > i[n + 16 >> 2], k = h ? k : n, n = i[(h << 2) + n >> 2], !!n;);
                                                    if ((r | 0) == (k | 0)) {
                                                        h = 0;
                                                        break f;
                                                    }
                                                    if (h = 0, (w | 0) < i[k + 16 >> 2]) break f;
                                                    E = i[k + 52 >> 2], h = i[k + 44 >> 2];
                                                }
                                                if (!F | !v) break e;
                                                for(w = v & -4, R = v & 3, B = 0, C = v - 1 >>> 0 < 3;;){
                                                    if (G = h + Z(E, B) | 0, W = _ + Z(y, B) | 0, n = 0, k = 0, !C) for(; o[n + G | 0] = Z(l[n + W | 0], f) >>> 8, v = n | 1, o[v + G | 0] = Z(l[v + W | 0], f) >>> 8, v = n | 2, o[v + G | 0] = Z(l[v + W | 0], f) >>> 8, v = n | 3, o[v + G | 0] = Z(l[v + W | 0], f) >>> 8, n = n + 4 | 0, k = k + 4 | 0, (w | 0) != (k | 0););
                                                    if (k = 0, R) for(; o[n + G | 0] = Z(l[n + W | 0], f) >>> 8, n = n + 1 | 0, k = k + 1 | 0, (R | 0) != (k | 0););
                                                    if (B = B + 1 | 0, (F | 0) == (B | 0)) break;
                                                }
                                                break e;
                                            }
                                            _ = 0, h = 0;
                                        }
                                        f = r, n = i[r >> 2], k = 0;
                                        r: {
                                            if (!n) break r;
                                            for(; k = (w | 0) > i[n + 16 >> 2], f = k ? f : n, n = i[(k << 2) + n >> 2], !!n;);
                                            if ((r | 0) == (f | 0)) {
                                                k = 0;
                                                break r;
                                            }
                                            if (k = 0, (w | 0) < i[f + 16 >> 2]) break r;
                                            E = i[f + 52 >> 2], k = i[f + 44 >> 2];
                                        }
                                        if (!F | !v) break e;
                                        for(f = k, G = C - 8 | 0, w = _ >>> 1 | 0, C = v & -4, R = v & 3, B = 0, v = v - 1 >>> 0 < 3;;){
                                            if (W = f + Z(E, B) | 0, y = h + (Z(w, B) << 1) | 0, n = 0, k = 0, !v) for(; o[n + W | 0] = I[y + (n << 1) >> 1] >>> G, _ = n | 1, o[_ + W | 0] = I[y + (_ << 1) >> 1] >>> G, _ = n | 2, o[_ + W | 0] = I[y + (_ << 1) >> 1] >>> G, _ = n | 3, o[_ + W | 0] = I[y + (_ << 1) >> 1] >>> G, n = n + 4 | 0, k = k + 4 | 0, (C | 0) != (k | 0););
                                            if (k = 0, R) for(; o[n + W | 0] = I[y + (n << 1) >> 1] >>> G, n = n + 1 | 0, k = k + 1 | 0, (R | 0) != (k | 0););
                                            if (B = B + 1 | 0, (F | 0) == (B | 0)) break;
                                        }
                                    }
                                    if (M = M + 4 | 0, (M | 0) == 28) break;
                                }
                                if (i[A + 4 >> 2] = u, i[A >> 2] = V, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = s + 48 | 0;
                        }
                        function S7() {
                            var A = 0, r = 0;
                            t4(6906, 1, 79532, 40911, 551, 552, 0), t4(6250, 1, 79544, 40914, 553, 554, 0), t4(14678, 1, 79548, 40911, 555, 556, 0), t4(12252, 2, 79576, 40948, 557, 558, 0), t4(1469, 3, 79584, 40965, 559, 560, 0), t4(10271, 2, 79604, 40993, 561, 562, 0), t4(4770, 2, 79620, 40993, 563, 564, 0), t4(5215, 2, 79628, 41016, 565, 566, 0), t4(10976, 3, 79644, 41020, 567, 568, 0), t4(10935, 2, 79628, 41016, 565, 569, 0), t4(17843, 4, 79680, 41098, 570, 571, 0), t4(10082, 2, 79760, 40948, 572, 573, 0), t4(8962, 2, 79784, 40993, 574, 575, 0), t4(3580, 2, 79784, 40993, 574, 576, 0), t4(11408, 2, 79784, 40993, 574, 577, 0), t4(10108, 2, 79792, 40948, 578, 579, 0), h8(79816, 12321, 4, 0), C0(79816, 8684, 0), C0(79816, 3057, 1), C0(79816, 2888, 2), C0(79816, 5514, 11), C0(79816, 10294, 3), C0(79816, 10220, 4), C0(79816, 5557, 5), C0(79816, 5354, 6), C0(79816, 5421, 7), C0(79816, 5389, 8), C0(79816, 5453, 9), C0(79816, 3089, 10), C0(79816, 13923, 12), h8(79824, 12302, 4, 0), C0(79824, 14026, 0), C0(79824, 15227, 5e3), C0(79824, 5307, 1001), C0(79824, 15385, 150), C0(79824, 6686, 5001), C0(79824, 9232, 5002), C0(79824, 6507, 5003), C0(79824, 4248, 5004), C0(79824, 15327, 100), C0(79824, 9385, 101), C0(79824, 1729, 102), C0(79824, 1651, 103), C0(79824, 1999, 104), C0(79824, 1677, 105), C0(79824, 2077, 106), C0(79824, 2051, 141), C0(79824, 1807, 107), C0(79824, 1781, 108), C0(79824, 2025, 109), C0(79824, 1973, 110), C0(79824, 1895, 111), C0(79824, 1755, 112), C0(79824, 1921, 113), C0(79824, 5983, 114), C0(79824, 1149, 115), C0(79824, 7732, 116), C0(79824, 15300, 117), C0(79824, 15353, 118), C0(79824, 4814, 119), C0(79824, 2129, 131), C0(79824, 2103, 143), C0(79824, 1864, 149), C0(79824, 10127, 120), C0(79824, 15192, 121), C0(79824, 5120, 122), C0(79824, 14176, 6001), C0(79824, 5479, 6e3), C0(79824, 13943, 123), C0(79824, 1426, 6002), C0(79824, 13829, 6003), C0(79824, 7691, 124), C0(79824, 1947, 125), C0(79824, 14052, 1e3), C0(79824, 10326, 126), C0(79824, 3769, 127), C0(79824, 6274, 128), C0(79824, 9416, 129), C0(79824, 14285, 2e3), C0(79824, 3339, 2001), C0(79824, 14327, 2002), C0(79824, 6964, 2003), C0(79824, 6923, 2004), C0(79824, 5878, 2005), C0(79824, 9774, 2006), C0(79824, 1235, 2007), C0(79824, 11027, 2008), C0(79824, 1833, 130), C0(79824, 15266, 136), C0(79824, 14818, 3e3), C0(79824, 10367, 3001), C0(79824, 7005, 3002), C0(79824, 12627, 3006), C0(79824, 1104, 3007), C0(79824, 6834, 3003), C0(79824, 12524, 3004), C0(79824, 12575, 3005), C0(79824, 8724, 4e3), C0(79824, 8760, 132), C0(79824, 4682, 133), C0(79824, 5030, 134), C0(79824, 3987, 135), C0(79824, 1204, 137), C0(79824, 13638, 138), C0(79824, 13590, 139), C0(79824, 7927, 140), C0(79824, 1703, 142), h8(79832, 3745, 4, 0), C0(79832, 13686, 0), C0(79832, 16549, 1), C0(79832, 16571, 2), C0(79832, 16223, 3), C0(79832, 18077, 4), C0(79832, 16507, 5), C0(79832, 16528, 6), C0(79832, 18345, 7), C0(79832, 13548, 8), C0(79832, 8357, 9), C0(79832, 16169, 10), h8(79704, 15635, 4, 0), C0(79704, 13739, 99), C0(79704, 10645, 0), C0(79704, 18314, 1), C0(79704, 17964, 2), C0(79704, 17790, 3), C0(79704, 16669, 10), C0(79704, 16697, 11), C0(79704, 16355, 12), C0(79704, 16389, 13), C0(79704, 16285, 14), C0(79704, 16319, 15), C0(79704, 3520, 10), C0(79704, 3550, 11), h8(79840, 7656, 4, 0), C0(79840, 11375, 2), C0(79840, 5809, 1), C0(79840, 2765, 3), h8(79848, 7623, 4, 0), C0(79848, 6417, 2), C0(79848, 5769, 1), h8(79696, 12488, 4, 0), C0(79696, 13713, 99), C0(79696, 6469, 0), C0(79696, 16649, 1), C0(79696, 10618, 2), C0(79696, 8295, 3), h8(79736, 8215, 4, 0), C0(79736, 15838, 0), C0(79736, 6491, 2), C0(79736, 15121, 1), C0(79736, 16007, 3), C0(79736, 16203, 4), C0(79736, 16601, 5), C0(79736, 15701, 6), C0(79736, 12840, 10), C0(79736, 1559, 11), C0(79736, 8803, 12), C0(79736, 1394, 13), h8(79612, 3418, 4, 0), C0(79612, 6558, 0), C0(79612, 12895, 1), C0(79612, 12865, 2), C0(79612, 12504, 3), n3(79552, 79560, 79856, 0, 40911, 580, 41400, 0, 41400, 0, 2808, 41402, 581), n3(79656, 79664, 79768, 0, 40911, 582, 41400, 0, 41400, 0, 11009, 41402, 583), n3(79712, 79720, 79800, 0, 40911, 584, 41400, 0, 41400, 0, 11469, 41402, 585), zs(79596, 5546, 41405, 586, 41402, 587), A = D(4), i[A >> 2] = 0, r = D(4), i[r >> 2] = 0, k3(79596, 12332, 79816, 40993, 588, A | 0, 79816, 41407, 589, r | 0), A = D(4), i[A >> 2] = 4, r = D(4), i[r >> 2] = 4, k3(79596, 12294, 79824, 40993, 590, A | 0, 79824, 41407, 591, r | 0), A = D(4), i[A >> 2] = 592, r = D(4), i[r >> 2] = 593, k3(79596, 11367, 79536, 41016, 594, A | 0, 79536, 41412, 595, r | 0), xs(79596);
                        }
                        function j7() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            l[87596] || (o[87596] = 1), r = i[21892], i[21892] = r + 1;
                            i: {
                                if ((r | 0) > 0 || (y7(), E7())) break i;
                                return i[21892] = i[21892] - 1, 0;
                            }
                            A = D(3224), i[A + 168 >> 2] = 0, i[A + 84 >> 2] = 0, i[A >> 2] = 48824, i[A + 384 >> 2] = 1195, i[A + 376 >> 2] = 1196, i[A + 360 >> 2] = 1197, i[A + 356 >> 2] = 1198, i[A + 352 >> 2] = 1199, i[A + 348 >> 2] = 1200, i[A + 344 >> 2] = 1201, i[A + 340 >> 2] = 1202, i[A + 336 >> 2] = 1203, i[A + 332 >> 2] = 1204, i[A + 328 >> 2] = 1205, i[A + 324 >> 2] = 1206, i[A + 320 >> 2] = 1207, i[A + 316 >> 2] = 1208, i[A + 312 >> 2] = 1209, i[A + 308 >> 2] = 1210, i[A + 304 >> 2] = 1211, i[A + 300 >> 2] = 1212, i[A + 296 >> 2] = 1213, i[A + 292 >> 2] = 1213, i[A + 288 >> 2] = 1213, i[A + 284 >> 2] = 1214, i[A + 280 >> 2] = 1215, i[A + 276 >> 2] = 1216, i[A + 272 >> 2] = 1217, i[A + 268 >> 2] = 1218, i[A + 264 >> 2] = 1219, i[A + 260 >> 2] = 1220, i[A + 256 >> 2] = 1221, i[A + 252 >> 2] = 1222, i[A + 248 >> 2] = 1223, i[A + 244 >> 2] = 1224, i[A + 240 >> 2] = 1225, i[A + 236 >> 2] = 1226, i[A + 232 >> 2] = 1227, i[A + 228 >> 2] = 1228, i[A + 224 >> 2] = 1229, i[A + 220 >> 2] = 1230, i[A + 216 >> 2] = 1231, i[A + 212 >> 2] = 1231, i[A + 208 >> 2] = 1231, i[A + 204 >> 2] = 1232, i[A + 200 >> 2] = 1233, i[A + 196 >> 2] = 1234, i[A + 192 >> 2] = 1235, i[A + 188 >> 2] = 1236, i[A + 184 >> 2] = 1237, i[A + 180 >> 2] = 1238, i[A + 176 >> 2] = 1239, i[A + 172 >> 2] = 1240, i[A + 372 >> 2] = 1241, i[A + 380 >> 2] = 1242, i[A + 364 >> 2] = 1243, i[A + 368 >> 2] = 1244, i[A + 388 >> 2] = 1245, i[A + 392 >> 2] = 1246, i[A + 396 >> 2] = 1247, i[A + 400 >> 2] = 1248, i[A + 404 >> 2] = 1249, i[A + 408 >> 2] = 1250, i[A + 412 >> 2] = 1251, i[A + 416 >> 2] = 1252, i[A + 420 >> 2] = 1253, i[A + 424 >> 2] = 1254, i[A + 428 >> 2] = 1255, i[A + 432 >> 2] = 1256, i[A + 456 >> 2] = 1257, i[A + 460 >> 2] = 1258, i[A + 468 >> 2] = 1259, i[A + 472 >> 2] = 1260, i[A + 464 >> 2] = 1261, i[A + 508 >> 2] = 1262, i[A + 504 >> 2] = 1263, i[A + 500 >> 2] = 1264, i[A + 496 >> 2] = 1265, i[A + 492 >> 2] = 1266, i[A + 488 >> 2] = 1267, i[A + 484 >> 2] = 1268, i[A + 480 >> 2] = 1269, i[A + 476 >> 2] = 1270, i[A + 452 >> 2] = 1271, i[A + 448 >> 2] = 1272, i[A + 444 >> 2] = 1273, i[A + 440 >> 2] = 1274, i[A + 436 >> 2] = 1275, i[A >> 2] = 48848, i[A + 552 >> 2] = 0, i[A + 556 >> 2] = 0, Q[A + 548 >> 1] = 0, i[A + 560 >> 2] = 0, i[A + 564 >> 2] = 0, i[A + 568 >> 2] = 0, i[A + 572 >> 2] = 0, i[A + 576 >> 2] = 0, i[A + 580 >> 2] = 0, i[A + 584 >> 2] = 0, i[A + 588 >> 2] = 0, i[A + 592 >> 2] = 0, i[A + 596 >> 2] = 0, r = A + 1412 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, r = A + 1404 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[A + 1396 >> 2] = 0, i[A + 1400 >> 2] = 0, B0(A + 600 | 0, 0, 792), r = A + 2140 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r >> 2] = 30, i[r + 4 >> 2] = 30, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[A + 3216 >> 2] = 0, i[A + 3208 >> 2] = 0, i[A + 3212 >> 2] = 0, Q[A + 532 >> 1] = 0, o[A + 514 | 0] = 0, Q[A + 512 >> 1] = 256, i[A + 516 >> 2] = -1, i[A + 520 >> 2] = -1, i[A + 524 >> 2] = -1, i[A + 528 >> 2] = -1, r = i[21511], e = i[21510], i[A + 1368 >> 2] = 0, i[A + 544 >> 2] = 0, i[A + 536 >> 2] = e, i[A + 540 >> 2] = r, r = i[A + 1372 >> 2], i[A + 1372 >> 2] = 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 1380 >> 2], i[A + 1376 >> 2] = 0, i[A + 1380 >> 2] = 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 1388 >> 2], i[A + 1384 >> 2] = 0, i[A + 1388 >> 2] = 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A + 1892 >> 2] = 100, i[A + 1896 >> 2] = 6, i[A + 1884 >> 2] = 0, i[A + 1888 >> 2] = 6, i[A + 1900 >> 2] = 100, i[A + 1904 >> 2] = 6, r = i[A + 1376 >> 2];
                            i: {
                                e: {
                                    r: {
                                        if (r) {
                                            r = o[r + 2 | 0];
                                            break r;
                                        }
                                        if (e = i[A + 1368 >> 2], r = 6, !e) break e;
                                        r = i[e + 8 >> 2];
                                    }
                                    if ((r | 0) <= 0) break i;
                                    r = r - 1 | 0;
                                }
                                for(v = A + 2112 | 0, s = A + 1908 | 0, h = r + 1 | 0;;){
                                    e = Z(r, 100), n = (e + 100 | 0) / (h | 0) | 0, f = (e | 0) / (h | 0) | 0;
                                    e: {
                                        if ((n | 0) < (f | 0)) {
                                            e = r;
                                            break e;
                                        }
                                        t = i[A + 1888 >> 2];
                                        r: {
                                            if (f + n & 1) {
                                                e = r, r = f;
                                                break r;
                                            }
                                            e = (f << 1) + s | 0, o[e + 1 | 0] = (r | 0) > (t | 0) ? 100 : 0, k = e, e = (r | 0) < (t | 0) ? r : t, o[k | 0] = e, r = f + 1 | 0;
                                        }
                                        if (k = r, (f | 0) == (n | 0)) break e;
                                        for(w = n - f | 0, r = e; u = (k << 1) + s | 0, e = (r | 0) < (t | 0) ? r : t, o[u | 0] = e, o[u + 1 | 0] = (r | 0) > (t | 0) ? 100 : (Z(k - f | 0, 100) | 0) / (w | 0) | 0, u = k + 1 | 0, r = (u << 1) + s | 0, o[r + 1 | 0] = (Z(u - f | 0, 100) | 0) / (w | 0), o[r | 0] = e, k = k + 2 | 0, r = e, (n | 0) != (u | 0););
                                    }
                                    if (i[(e << 2) + v >> 2] = n, r = e - 1 | 0, !((e | 0) > 0)) break;
                                }
                            }
                            return i[A + 2200 >> 2] = 0, i[A + 2204 >> 2] = 0, i[A + 2196 >> 2] = -1, r = A + 2216 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, r = A + 2208 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, o[A + 2200 | 0] = 1, A | 0;
                        }
                        function O7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            i: {
                                e: {
                                    if (k = i[A + 124 >> 2], v = i[k + 16876 >> 2], e = i[k + 16872 >> 2], B = r << v >> e, _ = i[k + 16896 >> 2], r = r + 1 << v >> e, y = (r | 0) > (_ | 0) ? _ : r, !((B | 0) >= (y | 0) | i[k + 16888 >> 2] <= 0)) for(F = -1 << v ^ -1, E = i[k + 16892 >> 2], R = i[k + 16880 >> 2], W = i[A + 132 >> 2];;){
                                        if (i[k + 16888 >> 2] > 0) for(r = 0, h = Z(B, R), e = (h | 0) != 0, c = e & !(h & F), M = Z(h >> v, E), _ = e << 5, H = h - 1 | 0, r0 = Z(H >> v, E) << 2;;){
                                            e = (i[A + 160 >> 2] + Z(Z(i[A + 172 >> 2], B), 3) | 0) + Z(r, 3) | 0, u = (l[e | 0] | l[e + 1 | 0] << 8) & 7;
                                            r: {
                                                if (!u) break r;
                                                if (n = Z(r, R), s = i[A + 148 >> 2], e = n >> s, (e | 0) < 0 || (w = i[A + 152 >> 2], (w | 0) <= (e | 0))) break e;
                                                if (f = h >> s, (f | 0) < 0 || (T = i[A + 156 >> 2], (f | 0) >= (T | 0))) break i;
                                                if (C = i[A + 52 >> 2], V = i[A + 56 >> 2] - C >> 2, G = i[A + 140 >> 2], S = G + Z(e, 24) | 0, P = Z(Z(f, w), 24), e = I[(S + P | 0) + 2 >> 1], V >>> 0 <= e >>> 0) return 0;
                                                $ = n >> v, t = i[C + (e << 2) >> 2], f = ((n | 0) != 0) << 4, e = f;
                                                A: {
                                                    if (!n || (e = f, n & F)) break A;
                                                    f: {
                                                        if (l[t + 772 | 0]) break f;
                                                        if (e = n - 1 >> s, (e | 0) < 0 | e >>> 0 >= w >>> 0) break e;
                                                        if (G = I[((Z(e, 24) + G | 0) + P | 0) + 2 >> 1], G >>> 0 >= V >>> 0) break f;
                                                        if (e = 0, i[t + 808 >> 2] != i[i[C + (G << 2) >> 2] + 808 >> 2]) break A;
                                                    }
                                                    if (e = f, l[W + 57 | 0]) break A;
                                                    f = M << 2, e = i[W + 8484 >> 2], e = (i[f + (e + ($ << 2) | 0) >> 2] == i[f + (e + (n - 1 >> v << 2) | 0) >> 2]) << 4;
                                                }
                                                f = e, e = _;
                                                A: {
                                                    if (!c) break A;
                                                    f: {
                                                        if (l[t + 772 | 0]) break f;
                                                        if (e = H >> s, (e | 0) < 0 | (e | 0) >= (T | 0)) break i;
                                                        if (s = I[(Z(Z(e, w), 24) + S | 0) + 2 >> 1], s >>> 0 >= V >>> 0) break f;
                                                        if (e = 0, i[t + 808 >> 2] != i[i[C + (s << 2) >> 2] + 808 >> 2]) break A;
                                                    }
                                                    if (e = _, l[W + 57 | 0]) break A;
                                                    e = i[W + 8484 >> 2] + ($ << 2) | 0, e = (i[e + (M << 2) >> 2] == i[e + r0 >> 2]) << 5;
                                                }
                                                if (l[t + 762 | 0]) break r;
                                                if (K8(A, n, h, u, 0, f, e), e = i[A + 168 >> 2], t = n >> e, (t | 0) < 0 || (w = i[A + 172 >> 2], (w | 0) <= (t | 0))) break e;
                                                if (s = h >> e, (s | 0) < 0 | (s | 0) >= i[A + 176 >> 2]) break i;
                                                e = 1 << u, k = 1 << u - 2, f = 1 << u - 1;
                                                A: {
                                                    f: {
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    o: {
                                                                        s: {
                                                                            u: switch(t = (i[A + 160 >> 2] + Z(t, 3) | 0) + Z(Z(s, w), 3) | 0, ((l[t | 0] | l[t + 1 | 0] << 8) >>> 3 & 7) - 1 | 0){
                                                                                case 2:
                                                                                    break f;
                                                                                case 1:
                                                                                    break k;
                                                                                case 0:
                                                                                    break n;
                                                                                case 5:
                                                                                    break t;
                                                                                case 6:
                                                                                    break o;
                                                                                case 3:
                                                                                    break s;
                                                                                case 4:
                                                                                    break u;
                                                                                default:
                                                                                    break A;
                                                                            }
                                                                            for(t = (e | 0) <= 1 ? 1 : e, f = (k + (f + h | 0) | 0) / 4 | 0, e = 0; k = (e + n | 0) / 4 | 0, u = i[A + 272 >> 2], (k | 0) >= (u | 0) | (f | 0) >= i[A + 276 >> 2] || (k = (k + i[A + 260 >> 2] | 0) + Z(f, u) | 0, o[k | 0] = l[k | 0] | 128), e = e + 1 | 0, (t | 0) != (e | 0););
                                                                            break A;
                                                                        }
                                                                        for(t = (e | 0) <= 1 ? 1 : e, f = (k + h | 0) / 4 | 0, e = 0; k = (e + n | 0) / 4 | 0, u = i[A + 272 >> 2], (k | 0) >= (u | 0) | (f | 0) >= i[A + 276 >> 2] || (k = (k + i[A + 260 >> 2] | 0) + Z(f, u) | 0, o[k | 0] = l[k | 0] | 128), e = e + 1 | 0, (t | 0) != (e | 0););
                                                                        break A;
                                                                    }
                                                                    for(t = (e | 0) <= 1 ? 1 : e, f = (k + (f + n | 0) | 0) / 4 | 0, e = 0; k = i[A + 272 >> 2], n = (e + h | 0) / 4 | 0, (k | 0) <= (f | 0) | (n | 0) >= i[A + 276 >> 2] || (n = (f + i[A + 260 >> 2] | 0) + Z(k, n) | 0, o[n | 0] = l[n | 0] | 64), e = e + 1 | 0, (t | 0) != (e | 0););
                                                                    break A;
                                                                }
                                                                for(t = (e | 0) <= 1 ? 1 : e, f = (k + n | 0) / 4 | 0, e = 0; k = i[A + 272 >> 2], n = (e + h | 0) / 4 | 0, (k | 0) <= (f | 0) | (n | 0) >= i[A + 276 >> 2] || (n = (f + i[A + 260 >> 2] | 0) + Z(k, n) | 0, o[n | 0] = l[n | 0] | 64), e = e + 1 | 0, (t | 0) != (e | 0););
                                                                break A;
                                                            }
                                                            for(k = (e | 0) <= 1 ? 1 : e, f = (f + h | 0) / 4 | 0, e = 0; t = (e + n | 0) / 4 | 0, u = i[A + 272 >> 2], (t | 0) >= (u | 0) | (f | 0) >= i[A + 276 >> 2] || (t = (t + i[A + 260 >> 2] | 0) + Z(f, u) | 0, o[t | 0] = l[t | 0] | 128), e = e + 1 | 0, (k | 0) != (e | 0););
                                                            break A;
                                                        }
                                                        for(k = (e | 0) <= 1 ? 1 : e, f = (f + n | 0) / 4 | 0, e = 0; t = i[A + 272 >> 2], n = (e + h | 0) / 4 | 0, (t | 0) <= (f | 0) | (n | 0) >= i[A + 276 >> 2] || (n = (f + i[A + 260 >> 2] | 0) + Z(n, t) | 0, o[n | 0] = l[n | 0] | 64), e = e + 1 | 0, (k | 0) != (e | 0););
                                                        break A;
                                                    }
                                                    for(w = (e | 0) <= 1 ? 1 : e, t = (f + h | 0) / 4 | 0, u = (f + n | 0) / 4 | 0, e = 0; f = i[A + 276 >> 2], s = (e + h | 0) / 4 | 0, k = i[A + 272 >> 2], (f | 0) <= (s | 0) | (u | 0) >= (k | 0) || (f = (u + i[A + 260 >> 2] | 0) + Z(k, s) | 0, o[f | 0] = l[f | 0] | 64, k = i[A + 272 >> 2], f = i[A + 276 >> 2]), s = (e + n | 0) / 4 | 0, (f | 0) <= (t | 0) | (s | 0) >= (k | 0) || (f = (s + i[A + 260 >> 2] | 0) + Z(k, t) | 0, o[f | 0] = l[f | 0] | 128), e = e + 1 | 0, (w | 0) != (e | 0););
                                                }
                                                k = i[A + 124 >> 2], f0 = 1;
                                            }
                                            if (r = r + 1 | 0, !((r | 0) < i[k + 16888 >> 2])) break;
                                        }
                                        if (B = B + 1 | 0, (y | 0) == (B | 0)) break;
                                    }
                                    return f0;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function mw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            for(t = m - 48 | 0, m = t, B = r, G = X2(e), o[B + 100 | 0] = G, f = X2(e), o[r + 103 | 0] = f & 31, o[r + 101 | 0] = f >>> 6, o[r + 102 | 0] = f >>> 5 & 1, B = r, G = n2(e), i[B + 104 >> 2] = G, h = r + 108 | 0; f = X2(e), s = h + (u & -4) | 0, n = i[s >> 2], k = u << 3, n = (B = n | 1 << k, G = b0(-2, k) & n, W = f << 24 >> 24 < 0, W ? B : G), w = s, s = 2 << k, n = f & 64 ? s | n : n & (s ^ -1), s = 4 << k, n = f & 32 ? n | s : n & (s ^ -1), s = 8 << k, n = f & 16 ? n | s : n & (s ^ -1), s = 16 << k, n = f & 8 ? n | s : n & (s ^ -1), s = 32 << k, n = f & 4 ? n | s : n & (s ^ -1), s = 64 << k, n = f & 2 ? n | s : n & (s ^ -1), k = 128 << k, i[w >> 2] = f & 1 ? n | k : n & (k ^ -1), u = u + 1 | 0, (u | 0) != 6;);
                            B = r, G = X2(e), o[B + 116 | 0] = G, B = r, G = B2(e) & 4095, Q[B + 118 >> 1] = G, B = r, G = X2(e) & 3, o[B + 120 | 0] = G, B = r, G = X2(e) & 3, o[B + 121 | 0] = G, B = r, G = X2(e) & 7 | 8, o[B + 122 | 0] = G, B = r, G = X2(e) & 7 | 8, o[B + 123 | 0] = G, B = r, G = B2(e), Q[B + 124 >> 1] = G, f = X2(e), o[r + 126 | 0] = f >>> 6, o[r + 132 | 0] = (f & 3) + 1, o[r + 128 | 0] = f >>> 2 & 1, o[r + 127 | 0] = f >>> 3 & 7, w = X2(e);
                            i: {
                                e: {
                                    if (!w) break e;
                                    for(v = r + 136 | 0, _ = t + 36 | 0, h = 0;;){
                                        if (l[e + 20 | 0]) break e;
                                        k = X2(e), f = 0, i[t + 44 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, o[t + 33 | 0] = k & 63, o[t + 32 | 0] = k >>> 6 & 1, s = B2(e);
                                        r: {
                                            A: {
                                                if (!s) break A;
                                                for(;;){
                                                    if (l[e + 20 | 0]) break A;
                                                    i[t + 28 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, u = B2(e), k = 13;
                                                    f: {
                                                        if (!u) break f;
                                                        k: {
                                                            if (!o4(e, u)) break k;
                                                            n = i[t + 20 >> 2], k = i[t + 24 >> 2] - n | 0;
                                                            n: {
                                                                if (k >>> 0 < u >>> 0) {
                                                                    r1(t + 20 | 0, u - k | 0);
                                                                    break n;
                                                                }
                                                                if (k >>> 0 <= u >>> 0) break n;
                                                                i[t + 24 >> 2] = u + n;
                                                            }
                                                            n = i[e >> 2], k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), u = p[i[i[n >> 2] + 16 >> 2]](n, i[t + 20 >> 2], u) | 0;
                                                            n: {
                                                                if (!k || (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n)) break n;
                                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                            }
                                                            if (u) break k;
                                                            k = D(32), i[t + 8 >> 2] = k, i[t + 12 >> 2] = 28, i[t + 16 >> 2] = -2147483616, u = l[2359] | l[2360] << 8 | (l[2361] << 16 | l[2362] << 24), n = l[2355] | l[2356] << 8 | (l[2357] << 16 | l[2358] << 24), o[k | 0] = n, o[k + 1 | 0] = n >>> 8, o[k + 2 | 0] = n >>> 16, o[k + 3 | 0] = n >>> 24, o[k + 4 | 0] = u, o[k + 5 | 0] = u >>> 8, o[k + 6 | 0] = u >>> 16, o[k + 7 | 0] = u >>> 24, o[k + 28 | 0] = 0, u = l[2379] | l[2380] << 8 | (l[2381] << 16 | l[2382] << 24), o[k + 24 | 0] = u, o[k + 25 | 0] = u >>> 8, o[k + 26 | 0] = u >>> 16, o[k + 27 | 0] = u >>> 24, u = l[2375] | l[2376] << 8 | (l[2377] << 16 | l[2378] << 24), n = l[2371] | l[2372] << 8 | (l[2373] << 16 | l[2374] << 24), o[k + 16 | 0] = n, o[k + 17 | 0] = n >>> 8, o[k + 18 | 0] = n >>> 16, o[k + 19 | 0] = n >>> 24, o[k + 20 | 0] = u, o[k + 21 | 0] = u >>> 8, o[k + 22 | 0] = u >>> 16, o[k + 23 | 0] = u >>> 24, u = l[2367] | l[2368] << 8 | (l[2369] << 16 | l[2370] << 24), n = l[2363] | l[2364] << 8 | (l[2365] << 16 | l[2366] << 24), o[k + 8 | 0] = n, o[k + 9 | 0] = n >>> 8, o[k + 10 | 0] = n >>> 16, o[k + 11 | 0] = n >>> 24, o[k + 12 | 0] = u, o[k + 13 | 0] = u >>> 8, o[k + 14 | 0] = u >>> 16, o[k + 15 | 0] = u >>> 24, i0(A, 2, 100, t + 8 | 0), o[t + 19 | 0] < 0 && X(i[t + 8 >> 2]), k = 1;
                                                            break f;
                                                        }
                                                        k = i[t + 40 >> 2];
                                                        k: {
                                                            if (k >>> 0 < k0[t + 44 >> 2]) {
                                                                i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[k >> 2] = i[t + 20 >> 2], i[k + 4 >> 2] = i[t + 24 >> 2], i[k + 8 >> 2] = i[t + 28 >> 2], i[t + 28 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, k = k + 12 | 0;
                                                                break k;
                                                            }
                                                            k = U3(_, t + 20 | 0);
                                                        }
                                                        i[t + 40 >> 2] = k, k = 0;
                                                    }
                                                    if (u = i[t + 20 >> 2], u && (i[t + 24 >> 2] = u, X(u)), (k | 0) != 13 && k) break r;
                                                    if (f = f + 1 | 0, (s | 0) == (f | 0)) break;
                                                }
                                            }
                                            f = i[r + 140 >> 2];
                                            A: {
                                                if (f >>> 0 < k0[r + 144 >> 2]) {
                                                    k = I[t + 32 >> 1], i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, Q[f >> 1] = k, i[f + 4 >> 2] = i[t + 36 >> 2], i[f + 8 >> 2] = i[t + 40 >> 2], i[f + 12 >> 2] = i[t + 44 >> 2], i[t + 44 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, f = f + 16 | 0;
                                                    break A;
                                                }
                                                f = S5(v, t + 32 | 0);
                                            }
                                            i[r + 140 >> 2] = f, k = 0;
                                        }
                                        if (u = i[t + 36 >> 2], u) {
                                            if (f = u, n = i[t + 40 >> 2], (u | 0) != (n | 0)) {
                                                for(; f = n - 12 | 0, s = i[f >> 2], s && (i[n - 8 >> 2] = s, X(s)), n = f, (u | 0) != (n | 0););
                                                f = i[t + 36 >> 2];
                                            }
                                            i[t + 40 >> 2] = u, X(f);
                                        }
                                        if (k) break i;
                                        if (h = h + 1 | 0, (w | 0) == (h | 0)) break;
                                    }
                                }
                                if (f = i[e + 16 >> 2], f && (r = i[e + 8 >> 2], r && (dA(r, f), f = i[e + 16 >> 2]), r = i[e >> 2], u = p[i[i[r >> 2] + 8 >> 2]](r) | 0, k = w0, n = f, f = f + u | 0, k = n >>> 0 > f >>> 0 ? k + 1 | 0 : k, p[i[i[r >> 2] + 20 >> 2]](r, f, k), i[e + 16 >> 2] = 0), l[e + 20 | 0] == 1) {
                                    if (o[t + 32 | 0] = 0, o[t + 43 | 0] = 0, i0(A, 2, 100, t + 32 | 0), o[t + 43 | 0] >= 0) break i;
                                    X(i[t + 32 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = t + 48 | 0;
                        }
                        function Zw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            t = Q[r + 8 >> 1], v = m - 32 | 0, u = Q[r + 16 >> 1], w = Q[r >> 1], n = Q[r + 24 >> 1], k = ((Z(u, -74) + Z(w, 74) | 0) + Z(n, 74) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 16 >> 1] = (k | 0) <= -32768 ? -32768 : k, k = (((Z(t, -74) + Z(w, 84) | 0) + Z(u, 55) | 0) + Z(n, -29) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 24 >> 1] = (k | 0) <= -32768 ? -32768 : k, t = Z(t, 74), k = (((t + Z(w, 55) | 0) + Z(u, -29) | 0) + Z(n, -84) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 8 >> 1] = (k | 0) <= -32768 ? -32768 : k, u = (((t + Z(w, 29) | 0) + Z(u, 84) | 0) + Z(n, 55) | 0) - -64 >> 7, u = (u | 0) >= 32767 ? 32767 : u, Q[v >> 1] = (u | 0) <= -32768 ? -32768 : u, t = Q[r + 10 >> 1], u = Q[r + 18 >> 1], w = Q[r + 2 >> 1], n = Q[r + 26 >> 1], k = ((Z(u, -74) + Z(w, 74) | 0) + Z(n, 74) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 18 >> 1] = (k | 0) <= -32768 ? -32768 : k, k = (((Z(t, -74) + Z(w, 84) | 0) + Z(u, 55) | 0) + Z(n, -29) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 26 >> 1] = (k | 0) <= -32768 ? -32768 : k, t = Z(t, 74), k = (((t + Z(w, 55) | 0) + Z(u, -29) | 0) + Z(n, -84) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 10 >> 1] = (k | 0) <= -32768 ? -32768 : k, u = (((t + Z(w, 29) | 0) + Z(u, 84) | 0) + Z(n, 55) | 0) - -64 >> 7, u = (u | 0) >= 32767 ? 32767 : u, Q[v + 2 >> 1] = (u | 0) <= -32768 ? -32768 : u, t = Q[r + 12 >> 1], u = Q[r + 20 >> 1], w = Q[r + 4 >> 1], n = Q[r + 28 >> 1], k = ((Z(u, -74) + Z(w, 74) | 0) + Z(n, 74) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 20 >> 1] = (k | 0) <= -32768 ? -32768 : k, k = (((Z(t, -74) + Z(w, 84) | 0) + Z(u, 55) | 0) + Z(n, -29) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 28 >> 1] = (k | 0) <= -32768 ? -32768 : k, t = Z(t, 74), k = (((t + Z(w, 55) | 0) + Z(u, -29) | 0) + Z(n, -84) | 0) - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[v + 12 >> 1] = (k | 0) <= -32768 ? -32768 : k, u = (((t + Z(w, 29) | 0) + Z(u, 84) | 0) + Z(n, 55) | 0) - -64 >> 7, u = (u | 0) >= 32767 ? 32767 : u, Q[v + 4 >> 1] = (u | 0) <= -32768 ? -32768 : u, n = Q[r + 14 >> 1], u = Q[r + 22 >> 1], w = Q[r + 6 >> 1], r = Q[r + 30 >> 1], t = ((Z(u, -74) + Z(w, 74) | 0) + Z(r, 74) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, Q[v + 22 >> 1] = (t | 0) <= -32768 ? -32768 : t, t = (((Z(n, -74) + Z(w, 84) | 0) + Z(u, 55) | 0) + Z(r, -29) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, Q[v + 30 >> 1] = (t | 0) <= -32768 ? -32768 : t, n = Z(n, 74), t = (((n + Z(w, 55) | 0) + Z(u, -29) | 0) + Z(r, -84) | 0) - -64 >> 7, t = (t | 0) >= 32767 ? 32767 : t, Q[v + 14 >> 1] = (t | 0) <= -32768 ? -32768 : t, r = (((n + Z(w, 29) | 0) + Z(u, 84) | 0) + Z(r, 55) | 0) - -64 >> 7, r = (r | 0) >= 32767 ? 32767 : r, Q[v + 6 >> 1] = (r | 0) <= -32768 ? -32768 : r, u = 20 - f | 0, r = -1 << f ^ -1, w = 1 << 19 - f;
                            i: {
                                if ((e | 0) != 1) {
                                    for(f = 0; t = (f << 3) + v | 0, s = Q[t + 2 >> 1], n = (Z(e, f) << 1) + A | 0, k = Q[t + 4 >> 1], B = Q[t >> 1], t = Q[t + 6 >> 1], h = w + ((Z(k, -74) + Z(B, 74) | 0) + Z(t, 74) | 0) >> u, h = (h | 0) >= 32767 ? 32767 : h, h = I[n + 4 >> 1] + ((h | 0) <= -32768 ? -32768 : h) | 0, Q[n + 4 >> 1] = (h | 0) >= 0 ? (r | 0) > (h | 0) ? h : r : 0, _ = Z(s, 74), h = w + (((_ + Z(B, 29) | 0) + Z(k, 84) | 0) + Z(t, 55) | 0) >> u, h = (h | 0) >= 32767 ? 32767 : h, h = I[n >> 1] + ((h | 0) <= -32768 ? -32768 : h) | 0, Q[n >> 1] = (h | 0) >= 0 ? (r | 0) > (h | 0) ? h : r : 0, h = w + (((_ + Z(B, 55) | 0) + Z(k, -29) | 0) + Z(t, -84) | 0) >> u, h = (h | 0) >= 32767 ? 32767 : h, h = I[n + 2 >> 1] + ((h | 0) <= -32768 ? -32768 : h) | 0, Q[n + 2 >> 1] = (h | 0) >= 0 ? (r | 0) > (h | 0) ? h : r : 0, _ = n, h = I[n + 6 >> 1], n = w + (((Z(s, -74) + Z(B, 84) | 0) + Z(k, 55) | 0) + Z(t, -29) | 0) >> u, n = (n | 0) >= 32767 ? 32767 : n, n = h + ((n | 0) <= -32768 ? -32768 : n) | 0, Q[_ + 6 >> 1] = (n | 0) >= 0 ? (r | 0) > (n | 0) ? n : r : 0, f = f + 1 | 0, (f | 0) != 4;);
                                    break i;
                                }
                                for(k = I[A + 4 >> 1], f = 0; t = (f << 3) + v | 0, h = Q[t + 2 >> 1], n = (Z(e, f) << 1) + A | 0, _ = k & 65535, k = Q[t + 4 >> 1], B = Q[t >> 1], t = Q[t + 6 >> 1], s = w + ((Z(k, -74) + Z(B, 74) | 0) + Z(t, 74) | 0) >> u, s = (s | 0) >= 32767 ? 32767 : s, s = _ + ((s | 0) <= -32768 ? -32768 : s) | 0, Q[n + 4 >> 1] = (s | 0) >= 0 ? (r | 0) > (s | 0) ? s : r : 0, _ = Z(h, 74), s = w + (((_ + Z(B, 29) | 0) + Z(k, 84) | 0) + Z(t, 55) | 0) >> u, s = (s | 0) >= 32767 ? 32767 : s, s = I[n >> 1] + ((s | 0) <= -32768 ? -32768 : s) | 0, Q[n >> 1] = (s | 0) >= 0 ? (r | 0) > (s | 0) ? s : r : 0, s = w + (((_ + Z(B, 55) | 0) + Z(k, -29) | 0) + Z(t, -84) | 0) >> u, s = (s | 0) >= 32767 ? 32767 : s, s = I[n + 2 >> 1] + ((s | 0) <= -32768 ? -32768 : s) | 0, Q[n + 2 >> 1] = (s | 0) >= 0 ? (r | 0) > (s | 0) ? s : r : 0, _ = n, s = I[n + 6 >> 1], n = w + (((Z(h, -74) + Z(B, 84) | 0) + Z(k, 55) | 0) + Z(t, -29) | 0) >> u, n = (n | 0) >= 32767 ? 32767 : n, n = s + ((n | 0) <= -32768 ? -32768 : n) | 0, k = (n | 0) >= 0 ? (r | 0) > (n | 0) ? n : r : 0, Q[_ + 6 >> 1] = k, f = f + 1 | 0, (f | 0) != 4;);
                            }
                        }
                        function Gw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = J(0), F = J(0), E = J(0), R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0, t0 = 0, s0 = 0;
                            u = m - 48 | 0, m = u;
                            i: {
                                e: {
                                    r: {
                                        if ((S0(i[e >> 2], 0) | 0) != 8 || (S0(i[e >> 2], 1) | 0) != 8) break r;
                                        if ((S0(i[e >> 2], 2) | 0) == 8) break e;
                                    }
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                n = D(136), r = n, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), k = i[r + 4 >> 2], f = k + 1 | 0, i[r + 4 >> 2] = f, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, s = n + 76 | 0, i[n + 72 >> 2] = s, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, w = n + 12 | 0, i[n + 12 >> 2] = w, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = k, i[n + 16 >> 2] = n, f || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), r = i[e >> 2], G = i[r + 24 >> 2], f = G, W = i[r + 28 >> 2], r = W, i[w + 36 >> 2] = 10, i[w + 32 >> 2] = 1, i[w + 28 >> 2] = r, i[w + 24 >> 2] = f, J0(u + 24 | 0, w, 10, f, r, 8, t);
                                e: {
                                    if (i[u + 24 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[u + 28 >> 2], i[A + 8 >> 2] = i[u + 24 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[u + 43 | 0] >= 0) {
                                            A = i[u + 36 >> 2], i[r >> 2] = i[u + 32 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[u + 40 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[u + 32 >> 2], i[u + 36 >> 2]), o[u + 43 | 0] >= 0) break e;
                                        X(i[u + 32 >> 2]);
                                        break e;
                                    }
                                    o[u + 43 | 0] < 0 && X(i[u + 32 >> 2]), r = i[e >> 2], f = i[r + 44 >> 2], h = i[r + 48 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), i[u + 36 >> 2] = -1086926434, i[u + 40 >> 2] = 1071829221, i[u + 28 >> 2] = 1068725436, i[u + 32 >> 2] = -1095748968, o[u + 24 | 0] = 1, f && (Xi(u + 4 | 0, I[f + 8 >> 1], I[f + 4 >> 1]), i[u + 40 >> 2] = i[u + 20 >> 2], r = i[u + 16 >> 2], i[u + 32 >> 2] = i[u + 12 >> 2], i[u + 36 >> 2] = r, r = i[u + 8 >> 2], i[u + 24 >> 2] = i[u + 4 >> 2], i[u + 28 >> 2] = r), y = W0[u + 28 >> 2], F = W0[u + 36 >> 2], E = W0[u + 32 >> 2], r = i[e >> 2], e = i[r + 64 >> 2], R = N8(J(W0[u + 40 >> 2] * J(256))), M = N8(J(E * J(256))), H = N8(J(F * J(256))), T = N8(J(y * J(256)));
                                    r: {
                                        A: {
                                            if (e) {
                                                for(r = r - -64 | 0, f = r, t = e; k = i[t + 16 >> 2], f = (k | 0) < 0 ? f : t, t = i[(k >>> 29 & 4) + t >> 2], !!t;);
                                                _ = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (_ = 0, i[f + 16 >> 2] > 0)) break f;
                                                    S = i[f + 44 >> 2], _ = i[f + 52 >> 2];
                                                }
                                                for(f = r, t = e; k = i[t + 16 >> 2] <= 0, f = k ? f : t, t = i[(k << 2) + t >> 2], !!t;);
                                                B = 0;
                                                f: {
                                                    if ((r | 0) == (f | 0) || (B = 0, i[f + 16 >> 2] > 1)) break f;
                                                    P = i[f + 52 >> 2], B = i[f + 44 >> 2];
                                                }
                                                for(t = r; f = i[e + 16 >> 2] < 2, t = f ? t : e, e = i[(f << 2) + e >> 2], !!e;);
                                                if ((r | 0) != (t | 0)) break A;
                                            }
                                            k = 0;
                                            break r;
                                        }
                                        if (k = 0, i[t + 16 >> 2] > 2) break r;
                                        $ = i[t + 52 >> 2], k = i[t + 44 >> 2];
                                    }
                                    e = i[s >> 2], f = 0;
                                    r: {
                                        if (!e) break r;
                                        for(t = s; r = i[e + 16 >> 2] < 10, t = r ? t : e, e = i[(r << 2) + e >> 2], !!e;);
                                        if (f = 0, (t | 0) == (s | 0) || (f = 0, i[t + 16 >> 2] > 10)) break r;
                                        c = i[t + 52 >> 2], f = i[t + 44 >> 2];
                                    }
                                    if (!(!W | !G)) for(r = 0;;){
                                        for(r0 = Z(r, c) + f | 0, f0 = Z(r, _) + S | 0, e = r >>> 1 | 0, t0 = Z(e, $) + k | 0, s0 = Z(e, P) + B | 0, e = 0; s = e >>> 1 | 0, t = l[s + t0 | 0], C = Z(e, 3) + r0 | 0, V = l[e + f0 | 0], s = l[s + s0 | 0] - 128 | 0, v = V + (Z(s, R) + 128 >> 8) | 0, o[C + 2 | 0] = (v | 0) >= 0 ? v >>> 0 >= 255 ? 255 : v : 0, t = t - 128 | 0, v = V + (Z(t, T) + 128 >> 8) | 0, o[C | 0] = (v | 0) >= 0 ? v >>> 0 >= 255 ? 255 : v : 0, t = V + ((Z(s, M) + Z(t, H) | 0) + 128 >> 8) | 0, o[C + 1 | 0] = (t | 0) >= 0 ? t >>> 0 >= 255 ? 255 : t : 0, e = e + 1 | 0, (G | 0) != (e | 0););
                                        if (r = r + 1 | 0, (W | 0) == (r | 0)) break;
                                    }
                                    i[A + 4 >> 2] = n, i[A >> 2] = w, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(r, i[21670], i[21671]);
                                    }
                                    if (!h || (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                }
                                if (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            m = u + 48 | 0;
                        }
                        function P7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            k = m - 80 | 0, m = k;
                            i: {
                                if (l[r + 56 | 0] == 1) {
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                Xe(k + 48 | 0, r);
                                e: {
                                    if (i[k + 60 >> 2]) {
                                        if (r = i[k + 64 >> 2], i[A >> 2] = i[k + 60 >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[k + 79 | 0] >= 0) {
                                            r = i[k + 72 >> 2], i[A >> 2] = i[k + 68 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 76 >> 2];
                                            break e;
                                        }
                                        j(A, i[k + 68 >> 2], i[k + 72 >> 2]);
                                        break e;
                                    }
                                    f = D(24), i[k + 12 >> 2] = f, i[k + 16 >> 2] = 23, i[k + 20 >> 2] = -2147483624, n = l[6237] | l[6238] << 8 | (l[6239] << 16 | l[6240] << 24), e = l[6233] | l[6234] << 8 | (l[6235] << 16 | l[6236] << 24), o[f + 15 | 0] = e, o[f + 16 | 0] = e >>> 8, o[f + 17 | 0] = e >>> 16, o[f + 18 | 0] = e >>> 24, o[f + 19 | 0] = n, o[f + 20 | 0] = n >>> 8, o[f + 21 | 0] = n >>> 16, o[f + 22 | 0] = n >>> 24, n = l[6230] | l[6231] << 8 | (l[6232] << 16 | l[6233] << 24), e = l[6226] | l[6227] << 8 | (l[6228] << 16 | l[6229] << 24), o[f + 8 | 0] = e, o[f + 9 | 0] = e >>> 8, o[f + 10 | 0] = e >>> 16, o[f + 11 | 0] = e >>> 24, o[f + 12 | 0] = n, o[f + 13 | 0] = n >>> 8, o[f + 14 | 0] = n >>> 16, o[f + 15 | 0] = n >>> 24, n = l[6222] | l[6223] << 8 | (l[6224] << 16 | l[6225] << 24), e = l[6218] | l[6219] << 8 | (l[6220] << 16 | l[6221] << 24), o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, o[f + 4 | 0] = n, o[f + 5 | 0] = n >>> 8, o[f + 6 | 0] = n >>> 16, o[f + 7 | 0] = n >>> 24, o[f + 23 | 0] = 0, e = i0(k + 24 | 0, 2, 0, k + 12 | 0), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]);
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        if (u = i[k + 48 >> 2], s = i[k + 52 >> 2] - u | 0, s >>> 0 >= 2) for(f = 1;;){
                                                            n = t, t = f;
                                                            t: {
                                                                if (h = n + u | 0, l[h | 0] != 255 || (f = l[f + u | 0], (f & 240) != 192 | l[(f & 15) + 42208 | 0] != 1)) break t;
                                                                if (t = n + 9 | 0, t >>> 0 >= s >>> 0) {
                                                                    if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                                        r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                                        break r;
                                                                    }
                                                                    j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                                    break r;
                                                                }
                                                                o: {
                                                                    if (w = l[t + u | 0], t = n + 11 | 0, s >>> 0 > Z(w, 3) + t >>> 0) {
                                                                        if (!w) break k;
                                                                        if (u = t + u | 0, s = l[u | 0], n = 0, f = 0, t = 0, (w | 0) != 1) break o;
                                                                        break n;
                                                                    }
                                                                    if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                                        r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                                        break r;
                                                                    }
                                                                    j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                                    break r;
                                                                }
                                                                if (t = l[u + 3 | 0], f = t & 15, t = t >>> 4 | 0, (w | 0) == 2) break n;
                                                                u = l[u + 6 | 0], v = u & 15, _ = u >>> 4 | 0;
                                                                break n;
                                                            }
                                                            if (f = t + 1 | 0, (s | 0) == (f | 0)) break;
                                                        }
                                                        if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                            r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                            break r;
                                                        }
                                                        j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                        break r;
                                                    }
                                                    switch(h = l[h + 4 | 0], u = s & 15, s = s >>> 4 | 0, w - 1 | 0){
                                                        case 2:
                                                            break f;
                                                        case 0:
                                                            break A;
                                                        default:
                                                            break k;
                                                    }
                                                }
                                                if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                    r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                    break r;
                                                }
                                                j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                break r;
                                            }
                                            if (!((t | 0) == (_ | 0) & (f | 0) == (v | 0))) {
                                                if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                    r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                    break r;
                                                }
                                                j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                break r;
                                            }
                                            if (n = 1, !((f | 0) != 1 | (t | 0) != 1 | (s | 0) != 2) && (u | 0) == 2 || (B = (f | 0) != 1, !(B | (t | 0) != 1 | (s | 0) != 2) && (n = 2, (u | 0) == 1)) || !((t | 0) != 1 | B | (s | 0) != 1) && (n = 3, (u | 0) == 1)) break A;
                                            if (r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[e + 19 | 0] >= 0) {
                                                r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                break r;
                                            }
                                            j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                            break r;
                                        }
                                        A: {
                                            if (l[r + 56 | 0] == 1) {
                                                o[r + 40 | 0] = h, h = l[k + 12 | 0] | l[k + 13 | 0] << 8, o[r + 41 | 0] = h, o[r + 42 | 0] = h >>> 8, o[r + 43 | 0] = l[k + 14 | 0];
                                                break A;
                                            }
                                            o[r + 40 | 0] = h, h = l[k + 12 | 0] | l[k + 13 | 0] << 8, o[r + 41 | 0] = h, o[r + 42 | 0] = h >>> 8, o[r + 43 | 0] = l[k + 14 | 0], o[r + 56 | 0] = 1;
                                        }
                                        o[r + 54 | 0] = v, o[r + 53 | 0] = f, o[r + 52 | 0] = u, o[r + 51 | 0] = _, o[r + 50 | 0] = t, o[r + 49 | 0] = s, o[r + 48 | 0] = w, i[r + 44 >> 2] = n, J6(A);
                                    }
                                    if (o[e + 19 | 0] >= 0) break e;
                                    X(i[e + 8 >> 2]);
                                }
                                if (o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), A = i[k + 48 >> 2], !A) break i;
                                i[k + 52 >> 2] = A, X(A);
                            }
                            m = k + 80 | 0;
                        }
                        function Ww(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            w = m - 32 | 0, m = w, r = i[e >> 2], C = i[r + 28 >> 2], B = i[r + 24 >> 2];
                            i: {
                                if ((S0(r, 0) | 0) != 8) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86711] >= 0) {
                                        A = i[21676], i[r >> 2] = i[21675], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(r, i[21675], i[21676]);
                                    break i;
                                }
                                s = D(136), r = s, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), n = i[r + 4 >> 2], f = n + 1 | 0, i[r + 4 >> 2] = f, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[s + 132 >> 2] = 0, i[s + 124 >> 2] = 0, i[s + 128 >> 2] = 0, i[s + 84 >> 2] = 1, i[s + 88 >> 2] = 1, u = s + 76 | 0, i[s + 72 >> 2] = u, i[s + 92 >> 2] = 0, i[s + 96 >> 2] = 0, i[s + 100 >> 2] = 0, i[s + 104 >> 2] = 0, i[s + 108 >> 2] = 0, i[s + 112 >> 2] = 0, o[s + 113 | 0] = 0, o[s + 114 | 0] = 0, o[s + 115 | 0] = 0, o[s + 116 | 0] = 0, o[s + 117 | 0] = 0, o[s + 118 | 0] = 0, o[s + 119 | 0] = 0, o[s + 120 | 0] = 0, G = s + 12 | 0, i[s + 12 >> 2] = G, i[s + 8 >> 2] = i[s + 8 >> 2] + 1, i[s + 4 >> 2] = n, i[s + 16 >> 2] = s, f || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), T = A1(i[e >> 2], 6), i[G + 36 >> 2] = l[k + 8 | 0] ? 11 : 10, i[G + 32 >> 2] = 1, i[G + 28 >> 2] = C, i[G + 24 >> 2] = B, J0(w + 8 | 0, G, 10, B, C, 8, t);
                                e: {
                                    if (i[w + 8 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[w + 12 >> 2], i[A + 8 >> 2] = i[w + 8 >> 2], i[A + 12 >> 2] = r, r = A + 16 | 0, o[w + 27 | 0] >= 0) {
                                            A = i[w + 20 >> 2], i[r >> 2] = i[w + 16 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[w + 24 >> 2];
                                            break e;
                                        }
                                        if (j(r, i[w + 16 >> 2], i[w + 20 >> 2]), o[w + 27 | 0] >= 0) break e;
                                        X(i[w + 16 >> 2]);
                                        break e;
                                    }
                                    o[w + 27 | 0] < 0 && X(i[w + 16 >> 2]);
                                    r: {
                                        A: {
                                            if (r = i[e >> 2], t = i[r + 64 >> 2], t) {
                                                for(f = r - -64 | 0, e = f, r = t; n = i[r + 16 >> 2], e = (n | 0) < 0 ? e : r, r = i[(n >>> 29 & 4) + r >> 2], !!r;);
                                                W = 0;
                                                f: {
                                                    if ((e | 0) == (f | 0) || (W = 0, i[e + 16 >> 2] > 0)) break f;
                                                    V = i[e + 52 >> 2], W = i[e + 44 >> 2];
                                                }
                                                if (n = 0, !T) break r;
                                                for(r = f; e = i[t + 16 >> 2] < 6, r = e ? r : t, t = i[(e << 2) + t >> 2], !!t;);
                                                if ((r | 0) != (f | 0)) break A;
                                            }
                                            n = 0;
                                            break r;
                                        }
                                        if (n = 0, i[r + 16 >> 2] > 6) break r;
                                        S = i[r + 52 >> 2], n = i[r + 44 >> 2];
                                    }
                                    r = i[u >> 2], f = 0;
                                    r: {
                                        if (!r) break r;
                                        for(e = u; f = i[r + 16 >> 2] < 10, e = f ? e : r, r = i[(f << 2) + r >> 2], !!r;);
                                        if (f = 0, (e | 0) == (u | 0) || (f = 0, i[e + 16 >> 2] > 10)) break r;
                                        y = i[e + 52 >> 2], f = i[e + 44 >> 2];
                                    }
                                    if (C) for(F = B & -2, E = B & 1, R = B - 1 | 0, e = 0;;){
                                        r: {
                                            if (!l[k + 8 | 0]) {
                                                if (!B) break r;
                                                if (_ = f + Z(e, y) | 0, v = Z(e, V) + W | 0, r = 0, t = 0, R) for(; h = _ + Z(r, 3) | 0, u = l[r + v | 0], o[h | 0] = u, o[h + 2 | 0] = u, o[h + 1 | 0] = u, u = r | 1, h = _ + Z(u, 3) | 0, u = l[u + v | 0], o[h + 2 | 0] = u, o[h + 1 | 0] = u, o[h | 0] = u, r = r + 2 | 0, t = t + 2 | 0, (F | 0) != (t | 0););
                                                if (!E) break r;
                                                t = _ + Z(r, 3) | 0, r = l[r + v | 0], o[t | 0] = r, o[t + 2 | 0] = r, o[t + 1 | 0] = r;
                                                break r;
                                            }
                                            if (!T) {
                                                if (!B) break r;
                                                if (_ = f + Z(e, y) | 0, v = Z(e, V) + W | 0, r = 0, t = 0, R) for(; h = _ + (r << 2) | 0, u = l[r + v | 0], o[h | 0] = u, o[h + 3 | 0] = 255, o[h + 2 | 0] = u, o[h + 1 | 0] = u, u = r | 1, h = l[u + v | 0], u = _ + (u << 2) | 0, o[u + 3 | 0] = 255, o[u + 2 | 0] = h, o[u + 1 | 0] = h, o[u | 0] = h, r = r + 2 | 0, t = t + 2 | 0, (F | 0) != (t | 0););
                                                if (!E) break r;
                                                t = _ + (r << 2) | 0, r = l[r + v | 0], o[t | 0] = r, o[t + 3 | 0] = 255, o[t + 2 | 0] = r, o[t + 1 | 0] = r;
                                                break r;
                                            }
                                            if (!B) break r;
                                            if (M = Z(e, S), H = f + Z(e, y) | 0, _ = Z(e, V) + W | 0, r = 0, h = 0, R) for(; u = H + (r << 2) | 0, t = l[r + _ | 0], o[u | 0] = t, o[u + 2 | 0] = t, o[u + 1 | 0] = t, o[u + 3 | 0] = l[n + (r + M | 0) | 0], u = r | 1, v = H + (u << 2) | 0, t = l[u + _ | 0], o[v + 2 | 0] = t, o[v + 1 | 0] = t, o[v | 0] = t, o[v + 3 | 0] = l[n + (u + M | 0) | 0], r = r + 2 | 0, h = h + 2 | 0, (F | 0) != (h | 0););
                                            if (!E) break r;
                                            u = H + (r << 2) | 0, t = l[r + _ | 0], o[u | 0] = t, o[u + 2 | 0] = t, o[u + 1 | 0] = t, o[u + 3 | 0] = l[n + (r + M | 0) | 0];
                                        }
                                        if (e = e + 1 | 0, (C | 0) == (e | 0)) break;
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = G, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, r = A + 16 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            m = w + 32 | 0;
                        }
                        function L7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            if (_ = i[A + 176 >> 2], G = i[A + 180 >> 2], (_ | 0) != (G | 0)) for(;;){
                                i: {
                                    if (w = i[_ + 4 >> 2], W = i[_ + 8 >> 2], (w | 0) == (W | 0)) break i;
                                    for(;;){
                                        e: {
                                            h = i[w >> 2], v = i[w + 4 >> 2], u = i[r + 4 >> 2], f = i[r + 8 >> 2];
                                            r: {
                                                if (u >>> 0 < f >>> 0) {
                                                    o[u | 0] = 0, t = u + 1 | 0;
                                                    break r;
                                                }
                                                if (k = i[r >> 2], n = u - k | 0, A = n + 1 | 0, (A | 0) < 0) break e;
                                                f = f - k | 0, e = f << 1, A = f >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < e >>> 0 ? e : A, A ? f = D(A) : f = 0, e = n + f | 0, o[e | 0] = 0, B = A + f | 0, t = e + 1 | 0;
                                                A: {
                                                    if ((k | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (s = 0, A = u, n = n & 3, n) for(; e = e - 1 | 0, A = A - 1 | 0, o[e | 0] = l[A | 0], s = s + 1 | 0, (n | 0) != (s | 0););
                                                    if (k - u >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[A - 1 | 0], o[e - 2 | 0] = l[A - 2 | 0], o[e - 3 | 0] = l[A - 3 | 0], e = e - 4 | 0, A = A - 4 | 0, o[e | 0] = l[A | 0], (A | 0) != (k | 0););
                                                    k = i[r >> 2];
                                                }
                                                if (i[r + 8 >> 2] = B, i[r + 4 >> 2] = t, i[r >> 2] = f, !k) break r;
                                                X(k);
                                            }
                                            i[r + 4 >> 2] = t, f = i[r + 8 >> 2];
                                            r: {
                                                if (f >>> 0 > t >>> 0) {
                                                    o[t | 0] = 0, u = t + 1 | 0;
                                                    break r;
                                                }
                                                if (k = i[r >> 2], n = t - k | 0, A = n + 1 | 0, (A | 0) < 0) break e;
                                                f = f - k | 0, e = f << 1, A = f >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < e >>> 0 ? e : A, A ? f = D(A) : f = 0, e = n + f | 0, o[e | 0] = 0, B = A + f | 0, u = e + 1 | 0;
                                                A: {
                                                    if ((k | 0) == (t | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (s = 0, A = t, n = n & 3, n) for(; e = e - 1 | 0, A = A - 1 | 0, o[e | 0] = l[A | 0], s = s + 1 | 0, (n | 0) != (s | 0););
                                                    if (k - t >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[A - 1 | 0], o[e - 2 | 0] = l[A - 2 | 0], o[e - 3 | 0] = l[A - 3 | 0], e = e - 4 | 0, A = A - 4 | 0, o[e | 0] = l[A | 0], (A | 0) != (k | 0););
                                                    k = i[r >> 2];
                                                }
                                                if (i[r + 8 >> 2] = B, i[r + 4 >> 2] = u, i[r >> 2] = f, !k) break r;
                                                X(k);
                                            }
                                            i[r + 4 >> 2] = u, h = v - h | 0, A = h >>> 8 | 0, e = i[r + 8 >> 2];
                                            r: {
                                                if (e >>> 0 > u >>> 0) {
                                                    o[u | 0] = A, t = u + 1 | 0;
                                                    break r;
                                                }
                                                if (k = i[r >> 2], n = u - k | 0, f = n + 1 | 0, (f | 0) < 0) break e;
                                                e = e - k | 0, t = e << 1, t = e >>> 0 >= 1073741823 ? 2147483647 : f >>> 0 < t >>> 0 ? t : f, t ? f = D(t) : f = 0, e = n + f | 0, o[e | 0] = A, v = f + t | 0, t = e + 1 | 0;
                                                A: {
                                                    if ((k | 0) == (u | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (s = 0, A = u, n = n & 3, n) for(; e = e - 1 | 0, A = A - 1 | 0, o[e | 0] = l[A | 0], s = s + 1 | 0, (n | 0) != (s | 0););
                                                    if (k - u >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[A - 1 | 0], o[e - 2 | 0] = l[A - 2 | 0], o[e - 3 | 0] = l[A - 3 | 0], e = e - 4 | 0, A = A - 4 | 0, o[e | 0] = l[A | 0], (A | 0) != (k | 0););
                                                    k = i[r >> 2];
                                                }
                                                if (i[r + 8 >> 2] = v, i[r + 4 >> 2] = t, i[r >> 2] = f, !k) break r;
                                                X(k);
                                            }
                                            i[r + 4 >> 2] = t, f = i[r + 8 >> 2];
                                            r: {
                                                if (f >>> 0 > t >>> 0) {
                                                    o[t | 0] = h, u = t + 1 | 0;
                                                    break r;
                                                }
                                                if (k = i[r >> 2], n = t - k | 0, A = n + 1 | 0, (A | 0) < 0) break e;
                                                f = f - k | 0, e = f << 1, A = f >>> 0 >= 1073741823 ? 2147483647 : A >>> 0 < e >>> 0 ? e : A, A ? f = D(A) : f = 0, e = n + f | 0, o[e | 0] = h, h = A + f | 0, u = e + 1 | 0;
                                                A: {
                                                    if ((k | 0) == (t | 0)) {
                                                        f = e;
                                                        break A;
                                                    }
                                                    if (s = 0, A = t, n = n & 3, n) for(; e = e - 1 | 0, A = A - 1 | 0, o[e | 0] = l[A | 0], s = s + 1 | 0, (n | 0) != (s | 0););
                                                    if (k - t >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[A - 1 | 0], o[e - 2 | 0] = l[A - 2 | 0], o[e - 3 | 0] = l[A - 3 | 0], e = e - 4 | 0, A = A - 4 | 0, o[e | 0] = l[A | 0], (A | 0) != (k | 0););
                                                    k = i[r >> 2];
                                                }
                                                if (i[r + 8 >> 2] = h, i[r + 4 >> 2] = u, i[r >> 2] = f, !k) break r;
                                                X(k);
                                            }
                                            i[r + 4 >> 2] = u, f = i[w + 4 >> 2], n = i[w >> 2], A = f - n | 0;
                                            r: {
                                                if ((A | 0) <= 0) break r;
                                                if (s = i[r + 8 >> 2], (A | 0) <= (s - u | 0)) {
                                                    (f | 0) != (n | 0) && Q0(u, n, A), i[r + 4 >> 2] = A + u;
                                                    break r;
                                                }
                                                if (f = i[r >> 2], h = u - f | 0, e = h + A | 0, (e | 0) < 0) break e;
                                                k = 0, t = 0, s = s - f | 0, v = s << 1, e = s >>> 0 >= 1073741823 ? 2147483647 : e >>> 0 < v >>> 0 ? v : e, e && (t = D(e)), v = e + t | 0, s = A, e = t + h | 0, A = v0(e, n, A), n = s + A | 0;
                                                A: {
                                                    if ((f | 0) == (u | 0)) {
                                                        t = A;
                                                        break A;
                                                    }
                                                    if (s = 0, A = u, k = h & 3, k) for(; e = e - 1 | 0, A = A - 1 | 0, o[e | 0] = l[A | 0], s = s + 1 | 0, (k | 0) != (s | 0););
                                                    if (f - u >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[A - 1 | 0], o[e - 2 | 0] = l[A - 2 | 0], o[e - 3 | 0] = l[A - 3 | 0], e = e - 4 | 0, A = A - 4 | 0, o[e | 0] = l[A | 0], (A | 0) != (f | 0););
                                                    if (A = i[r + 4 >> 2], k = A - u | 0, (A | 0) == (u | 0)) break A;
                                                    Q0(n, u, k);
                                                }
                                                if (i[r + 4 >> 2] = k + n, A = i[r >> 2], i[r >> 2] = t, i[r + 8 >> 2] = v, !A) break r;
                                                X(A);
                                            }
                                            if (w = w + 12 | 0, (W | 0) != (w | 0)) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    p0(), z();
                                }
                                if (_ = _ + 16 | 0, (G | 0) == (_ | 0)) break;
                            }
                            return 1;
                        }
                        function Xw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0;
                            f = m - 32 | 0, m = f, _ = f + 12 | 0, G = i[r >> 2], w = m - 32 | 0, m = w, k = D(152), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78332, H = G, T = Ye(k + 12 | 0), i[H + 48 >> 2] = T, n = i[G + 52 >> 2], i[G + 52 >> 2] = k;
                            i: {
                                if (!n || (k = i[n + 4 >> 2], i[n + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            h = i[G + 48 >> 2], i[h + 136 >> 2] = G - -64, k = m - 160 | 0, m = k, s = D(188), n = i[15081], i[s >> 2] = n, i[s + 108 >> 2] = 60312, i[s + i[n - 12 >> 2] >> 2] = i[15082], i[s + 4 >> 2] = 0, t = s + i[i[s >> 2] - 12 >> 2] | 0, n = s + 8 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[s + 108 >> 2] = 60312, i[s >> 2] = 60292, n5($n(n), e, 12) || (e = s + i[i[s >> 2] - 12 >> 2] | 0, N1(e, i[e + 16 >> 2] | 4)), E = w + 8 | 0, i[k + 156 >> 2] = s;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (i[(s + i[i[s >> 2] - 12 >> 2] | 0) + 16 >> 2]) {
                                                if (i[k + 20 >> 2] = 59808, i[k + 76 >> 2] = 59828, e = i[14961], i[k + 12 >> 2] = e, t = k + 12 | 0, i[t + i[e - 12 >> 2] >> 2] = i[14962], i[k + 16 >> 2] = 0, e = t + i[i[k + 12 >> 2] - 12 >> 2] | 0, h = k + 24 | 0, T0(e, h), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[k + 20 >> 2] = e, n = k + 20 | 0, i[n + i[e - 12 >> 2] >> 2] = i[14964], e = i[14960], i[k + 12 >> 2] = e, i[t + i[e - 12 >> 2] >> 2] = i[14965], i[k + 76 >> 2] = 59828, i[k + 12 >> 2] = 59788, i[k + 20 >> 2] = 59808, V = z0(h), i[V >> 2] = 58864, e = k - -64 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 72 >> 2] = 24, e = U(n, 24526, 20), n = i[26064], R = I[((n >>> 0 <= 153 ? n : 0) << 1) + 57120 >> 1] + 55192 | 0, n = i[i[26106] + 20 >> 2], n) {
                                                    W = i[n + 4 >> 2], v = i[n >> 2], B = i[v >> 2] + 1794895138 | 0, C = n6(i[v + 8 >> 2], B), s = n6(i[v + 12 >> 2], B), h = n6(i[v + 16 >> 2], B);
                                                    f: {
                                                        if (W >>> 2 >>> 0 <= C >>> 0 || (n = W - (C << 2) | 0, (s | h) & 3 | (n >>> 0 <= s >>> 0 | n >>> 0 <= h >>> 0))) break f;
                                                        for(t = h >>> 2 | 0, h = v + (s & -4) | 0;;){
                                                            if (y = C >>> 1 | 0, F = y + M | 0, n = (F << 3) + h | 0, s = n6(i[n >> 2], B), n = n6(i[n + 4 >> 2], B), n >>> 0 >= W >>> 0 | s >>> 0 >= W - n >>> 0 || (n = n + v | 0, l[n + s | 0])) break f;
                                                            if (n = d1(R, n), !n) {
                                                                if (n = (v + (t << 2) | 0) + (F << 3) | 0, h = n6(i[n >> 2], B), n = n6(i[n + 4 >> 2], B), n >>> 0 >= W >>> 0 | h >>> 0 >= W - n >>> 0) break f;
                                                                u = n + v | 0, u = l[u + h | 0] ? 0 : u;
                                                                break f;
                                                            }
                                                            if ((C | 0) == 1) break f;
                                                            n = (n | 0) < 0, C = n ? y : C - y | 0, M = n ? M : F;
                                                        }
                                                    }
                                                }
                                                n = e, e = u || R, U(P0(U(U(n, e, E2(e)), 21010, 2), i[26064]), 34894, 2), e = i[k + 72 >> 2];
                                                f: {
                                                    if (e & 16) {
                                                        u = i[k + 68 >> 2], e = i[k + 48 >> 2], u >>> 0 < e >>> 0 && (i[k + 68 >> 2] = e, u = e), e = k + 44 | 0;
                                                        break f;
                                                    }
                                                    if (!(e & 8)) {
                                                        u = 0, o[k + 11 | 0] = 0, e = k;
                                                        break e;
                                                    }
                                                    u = i[k + 40 >> 2], e = k + 32 | 0;
                                                }
                                                if (h = i[e >> 2], u = u - h | 0, u >>> 0 >= 2147483640) break A;
                                                if (u >>> 0 >= 11) {
                                                    n = (u | 7) + 1 | 0, e = D(n), i[k + 8 >> 2] = n | -2147483648, i[k >> 2] = e, i[k + 4 >> 2] = u;
                                                    break r;
                                                }
                                                if (o[k + 11 | 0] = u, e = k, u) break r;
                                                u = 0;
                                                break e;
                                            }
                                            t = D(56), i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, i[t >> 2] = 78548, n = m - 16 | 0, m = n, u = t + 16 | 0, i[u >> 2] = 73384, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, i[t + 16 >> 2] = 73208, e = i[k + 156 >> 2], i[k + 156 >> 2] = 0, i[t + 40 >> 2] = e, lA(e, 0, 0, 2), Q9(n, i[t + 40 >> 2]), e = i[n + 12 >> 2], i[t + 48 >> 2] = i[n + 8 >> 2], i[t + 52 >> 2] = e, lA(i[t + 40 >> 2], 0, 0, 0), m = n + 16 | 0, i[k + 16 >> 2] = t, i[k + 12 >> 2] = u, i[t + 4 >> 2] = i[t + 4 >> 2] + 1, s3(E, h, k + 12 | 0), u = i[k + 16 >> 2];
                                            f: {
                                                if (!u || (e = i[u + 4 >> 2], i[u + 4 >> 2] = e - 1, e)) break f;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                            }
                                            if (e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e) break i;
                                            p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(e, h, u);
                                }
                                o[e + u | 0] = 0, i0(E, 1, 0, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), e = i[14959], i[k + 12 >> 2] = e, i[i[e - 12 >> 2] + (k + 12 | 0) >> 2] = i[14967], i[k + 20 >> 2] = i[14968], i[V >> 2] = 58864, o[k + 67 | 0] < 0 && X(i[k + 56 >> 2]), x0(V), N0(k + 76 | 0);
                            }
                            e = i[k + 156 >> 2], i[k + 156 >> 2] = 0, e && p[i[i[e >> 2] + 4 >> 2]](e), m = k + 160 | 0;
                            i: {
                                if (i[w + 8 >> 2]) {
                                    e = i[w + 12 >> 2], i[_ >> 2] = i[w + 8 >> 2], i[_ + 4 >> 2] = e, e = i[w + 20 >> 2], i[_ + 8 >> 2] = i[w + 16 >> 2], i[_ + 12 >> 2] = e, i[_ + 16 >> 2] = i[w + 24 >> 2];
                                    break i;
                                }
                                if (l3(_, G), o[w + 27 | 0] >= 0) break i;
                                X(i[w + 16 >> 2]);
                            }
                            m = w + 32 | 0, j0(A, _, i[r >> 2]), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), m = f + 32 | 0;
                        }
                        function K7(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 160 | 0, m = f, k = i[e + 4 >> 2], e = i[e >> 2], k = k - e | 0;
                            i: {
                                if (k >>> 0 <= 7) {
                                    if (r = D(32), i[f + 16 >> 2] = r, i[f + 20 >> 2] = 25, i[f + 24 >> 2] = -2147483616, e = l[15566] | l[15567] << 8 | (l[15568] << 16 | l[15569] << 24), k = l[15562] | l[15563] << 8 | (l[15564] << 16 | l[15565] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 25 | 0] = 0, o[r + 24 | 0] = l[15586], e = l[15582] | l[15583] << 8 | (l[15584] << 16 | l[15585] << 24), k = l[15578] | l[15579] << 8 | (l[15580] << 16 | l[15581] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[15574] | l[15575] << 8 | (l[15576] << 16 | l[15577] << 24), k = l[15570] | l[15571] << 8 | (l[15572] << 16 | l[15573] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 118, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                    X(i[f + 16 >> 2]);
                                    break i;
                                }
                                e: {
                                    r: {
                                        A: {
                                            if (t = l[e | 0], t) {
                                                i[f + 24 >> 2] = 59808, i[f + 80 >> 2] = 59828, r = i[14961], i[f + 16 >> 2] = r, e = i[r - 12 >> 2], r = f + 16 | 0, i[e + r >> 2] = i[14962], i[f + 20 >> 2] = 0, e = r + i[i[f + 16 >> 2] - 12 >> 2] | 0, k = f + 28 | 0, T0(e, k), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[f + 24 >> 2] = e, n = i[e - 12 >> 2], e = f + 24 | 0, i[n + e >> 2] = i[14964], n = i[14960], i[f + 16 >> 2] = n, i[r + i[n - 12 >> 2] >> 2] = i[14965], i[f + 80 >> 2] = 59828, i[f + 16 >> 2] = 59788, i[f + 24 >> 2] = 59808, n = z0(k), i[n >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 24, U(P0(U(e, 21770, 19), t), 13096, 17), r = i[f + 76 >> 2];
                                                f: {
                                                    if (r & 16) {
                                                        r = f + 48 | 0, k = i[f + 72 >> 2], e = i[f + 52 >> 2], k >>> 0 < e >>> 0 ? i[f + 72 >> 2] = e : e = k;
                                                        break f;
                                                    }
                                                    if (!(r & 8)) {
                                                        e = 0, o[f + 15 | 0] = 0, r = f + 4 | 0;
                                                        break e;
                                                    }
                                                    r = f + 36 | 0, e = i[f + 44 >> 2];
                                                }
                                                if (k = i[r >> 2], e = e - k | 0, e >>> 0 >= 2147483640) break A;
                                                if (e >>> 0 >= 11) {
                                                    t = (e | 7) + 1 | 0, r = D(t), i[f + 12 >> 2] = t | -2147483648, i[f + 4 >> 2] = r, i[f + 8 >> 2] = e;
                                                    break r;
                                                }
                                                if (o[f + 15 | 0] = e, r = f + 4 | 0, e) break r;
                                                e = 0;
                                                break e;
                                            }
                                            n = l[e + 1 | 0], Q[r >> 1] = l[e + 2 | 0] + 1, Q[r + 2 >> 1] = l[e + 3 | 0] + 1;
                                            f: {
                                                if (n & 1) {
                                                    if (n = 11, k >>> 0 <= 11) {
                                                        if (r = D(32), i[f + 16 >> 2] = r, i[f + 20 >> 2] = 26, i[f + 24 >> 2] = -2147483616, e = l[10045] | l[10046] << 8 | (l[10047] << 16 | l[10048] << 24), k = l[10041] | l[10042] << 8 | (l[10043] << 16 | l[10044] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 26 | 0] = 0, e = l[10065] | l[10066] << 8, o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, e = l[10061] | l[10062] << 8 | (l[10063] << 16 | l[10064] << 24), k = l[10057] | l[10058] << 8 | (l[10059] << 16 | l[10060] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[10053] | l[10054] << 8 | (l[10055] << 16 | l[10056] << 24), k = l[10049] | l[10050] << 8 | (l[10051] << 16 | l[10052] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 118, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                                        X(i[f + 16 >> 2]);
                                                        break i;
                                                    }
                                                    k = l[e + 4 | 0] | l[e + 5 | 0] << 8 | (l[e + 6 | 0] << 16 | l[e + 7 | 0] << 24), i[r + 4 >> 2] = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), k = l[e + 9 | 0] << 16 | l[e + 8 | 0] << 24 | l[e + 10 | 0] << 8;
                                                    break f;
                                                }
                                                i[r + 4 >> 2] = l[e + 5 | 0] | l[e + 4 | 0] << 8, n = 7, k = l[e + 6 | 0] << 8;
                                            }
                                            if (i[r + 8 >> 2] = k | l[e + n | 0], r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(r, k, e);
                                }
                                o[r + e | 0] = 0, i0(A, 4, 3002, f + 4 | 0), o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), A = i[14959], i[f + 16 >> 2] = A, i[i[A - 12 >> 2] + (f + 16 | 0) >> 2] = i[14967], i[f + 24 >> 2] = i[14968], i[n >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(n), N0(f + 80 | 0);
                            }
                            m = f + 160 | 0;
                        }
                        function p3(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            l[108564] || (f = m - 16 | 0, m = f, l[108556] || (k = m - 16 | 0, m = k, i[k + 12 >> 2] = 1, i[27100] = i[k + 12 >> 2] - 1, i[27099] = 71848, i[27099] = 66688, i[27099] = 65208, r = m - 16 | 0, m = r, i[27101] = 0, i[27102] = 0, i[r + 12 >> 2] = 0, i[27103] = 0, o[108536] = 0, i[r + 4 >> 2] = 108404, o[r + 10 | 0] = 0, e = m - 16 | 0, m = e, wt() >>> 0 < 30 && (u4(), z()), Et(e + 8 | 0, 108416, 30), n = i[e + 8 >> 2], i[27102] = n, i[27101] = n, i[27103] = (i[e + 12 >> 2] << 2) + n, m = e + 16 | 0, O9(30), o[r + 10 | 0] = 1, m = r + 16 | 0, Gi(108540, 16599), su(108404), i[27456] = 0, i[27455] = 71848, i[27455] = 66688, i[27455] = 67796, u1(109820, n1(108228)), i[27458] = 0, i[27457] = 71848, i[27457] = 66688, i[27457] = 67828, u1(109828, n1(108236)), i[27460] = 0, i[27459] = 71848, i[27459] = 66688, o[109848] = 0, i[27461] = 0, i[27459] = 65228, i[27461] = 65280, u1(109836, n1(108580)), i[27464] = 0, i[27463] = 71848, i[27463] = 66688, i[27463] = 66744, u1(109852, n1(108572)), i[27466] = 0, i[27465] = 71848, i[27465] = 66688, i[27465] = 66892, u1(109860, n1(108588)), i[27468] = 0, i[27467] = 71848, i[27467] = 66688, i[27467] = 66312, t = 109876, u = L2(), i[t >> 2] = u, u1(109868, n1(108596)), i[27471] = 0, i[27470] = 71848, i[27470] = 66688, i[27470] = 67040, u1(109880, n1(108604)), i[27473] = 0, i[27472] = 71848, i[27472] = 66688, i[27472] = 67272, u1(109888, n1(108620)), i[27475] = 0, i[27474] = 71848, i[27474] = 66688, i[27474] = 67156, u1(109896, n1(108612)), i[27477] = 0, i[27476] = 71848, i[27476] = 66688, i[27476] = 67388, u1(109904, n1(108628)), i[27479] = 0, i[27478] = 71848, i[27478] = 66688, Q[54960] = 11310, i[27478] = 66360, r = m - 16 | 0, m = r, i[27481] = 0, i[27482] = 0, i[27483] = 0, m = r + 16 | 0, u1(109912, n1(108636)), i[27485] = 0, i[27484] = 71848, i[27484] = 66688, i[27486] = 46, i[27487] = 44, i[27484] = 66400, r = m - 16 | 0, m = r, i[27488] = 0, i[27489] = 0, i[27490] = 0, m = r + 16 | 0, u1(109936, n1(108644)), i[27492] = 0, i[27491] = 71848, i[27491] = 66688, i[27491] = 67860, u1(109964, n1(108244)), i[27494] = 0, i[27493] = 71848, i[27493] = 66688, i[27493] = 68104, u1(109972, n1(108252)), i[27496] = 0, i[27495] = 71848, i[27495] = 66688, i[27495] = 68316, u1(109980, n1(108260)), i[27498] = 0, i[27497] = 71848, i[27497] = 66688, i[27497] = 68548, u1(109988, n1(108268)), i[27500] = 0, i[27499] = 71848, i[27499] = 66688, i[27499] = 69532, u1(109996, n1(108308)), i[27502] = 0, i[27501] = 71848, i[27501] = 66688, i[27501] = 69680, u1(110004, n1(108316)), i[27504] = 0, i[27503] = 71848, i[27503] = 66688, i[27503] = 69796, u1(110012, n1(108324)), i[27506] = 0, i[27505] = 71848, i[27505] = 66688, i[27505] = 69912, u1(110020, n1(108332)), i[27508] = 0, i[27507] = 71848, i[27507] = 66688, i[27507] = 70028, u1(110028, n1(108340)), i[27510] = 0, i[27509] = 71848, i[27509] = 66688, i[27509] = 70192, u1(110036, n1(108348)), i[27512] = 0, i[27511] = 71848, i[27511] = 66688, i[27511] = 70356, u1(110044, n1(108356)), i[27514] = 0, i[27513] = 71848, i[27513] = 66688, i[27513] = 70520, u1(110052, n1(108364)), i[27516] = 0, i[27515] = 71848, i[27515] = 66688, i[27517] = 71776, i[27515] = 68748, i[27517] = 68796, u1(110060, n1(108276)), i[27519] = 0, i[27518] = 71848, i[27518] = 66688, i[27520] = 71812, i[27518] = 69012, i[27520] = 69060, u1(110072, n1(108284)), i[27522] = 0, i[27521] = 71848, i[27521] = 66688, Jo(110092), i[27521] = 69248, u1(110084, n1(108292)), i[27525] = 0, i[27524] = 71848, i[27524] = 66688, Jo(110104), i[27524] = 69404, u1(110096, n1(108300)), i[27528] = 0, i[27527] = 71848, i[27527] = 66688, i[27527] = 70684, u1(110108, n1(108372)), i[27530] = 0, i[27529] = 71848, i[27529] = 66688, i[27529] = 70804, u1(110116, n1(108380)), m = k + 16 | 0, i[f + 8 >> 2] = 108396, i[27138] = i[f + 8 >> 2], o[108556] = 1), m = f + 16 | 0, r = i[27138], i[27140] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), o[108564] = 1), r = A, A = i[27140], i[r >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1);
                        }
                        function _8(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            w = s << 2, B = i[w + 50336 >> 2] + n | 0, w = i[w + 50320 >> 2], G = B + w | 0, C = h - 8 | 0, h = i[(u << 2) + 50320 >> 2];
                            i: {
                                e: switch(u | 0){
                                    case 0:
                                        if (_ = 0 - w | 0, (B | 0) <= (_ | 0) | (k | 0) <= 0) break i;
                                        for(V = (w << 1) + t | 0, y = e - (h << 1) | 0, F = k & 2147483644, W = k & 3, E = k >>> 0 < 4;;){
                                            if (h = (_ << 1) + V | 0, w = (Z(f, _) << 1) + y | 0, v = 0, !E) for(; Q[h >> 1] = I[w >> 1], e = G << 1, h = e + h | 0, Q[h >> 1] = I[w + 2 >> 1], h = e + h | 0, Q[h >> 1] = I[w + 4 >> 1], h = e + h | 0, Q[h >> 1] = I[w + 6 >> 1], h = e + h | 0, w = w + 8 | 0, v = v + 4 | 0, (F | 0) != (v | 0););
                                            if (e = 0, W) for(; Q[h >> 1] = I[w >> 1], w = w + 2 | 0, h = (G << 1) + h | 0, e = e + 1 | 0, (W | 0) != (e | 0););
                                            if (_ = _ + 1 | 0, (B | 0) == (_ | 0)) break;
                                        }
                                        break i;
                                    case 1:
                                        if (v = 0 - w | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                        for(_ = (w << 1) + t | 0, W = e - (h << 1) | 0;;){
                                            for(h = _ + (v << 1) | 0, w = W + (Z(f, v) << 1) | 0, e = 0; Q[h >> 1] = I[w + 12 >> 1] + ((((((I[w + 2 >> 1] << 2) - I[w >> 1] | 0) + Z(I[w + 4 >> 1], -10) | 0) + Z(I[w + 6 >> 1], 58) | 0) + Z(I[w + 8 >> 1], 17) | 0) + Z(I[w + 10 >> 1], -5) | 0) >> C, w = w + 2 | 0, h = (G << 1) + h | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                            if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                        }
                                        break i;
                                    case 2:
                                        if (v = 0 - w | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                        for(_ = (w << 1) + t | 0, W = e - (h << 1) | 0;;){
                                            for(h = _ + (v << 1) | 0, w = W + (Z(f, v) << 1) | 0, e = 0; Q[h >> 1] = (((((I[w + 2 >> 1] << 2) - I[w >> 1] | 0) + Z(I[w + 8 >> 1] + I[w + 6 >> 1] | 0, 40) | 0) + (I[w + 12 >> 1] << 2) | 0) - I[w + 14 >> 1] | 0) + Z(I[w + 10 >> 1] + I[w + 4 >> 1] | 0, -11) >> C, w = w + 2 | 0, h = (G << 1) + h | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                            if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                        }
                                        break i;
                                    case 3:
                                        break e;
                                    default:
                                        break i;
                                }
                                if (v = 0 - w | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                for(_ = (w << 1) + t | 0, W = e - (h << 1) | 0;;){
                                    for(h = _ + (v << 1) | 0, w = W + (Z(f, v) << 1) | 0, e = 0; Q[h >> 1] = (((((I[w >> 1] + Z(I[w + 2 >> 1], -5) | 0) + Z(I[w + 4 >> 1], 17) | 0) + Z(I[w + 6 >> 1], 58) | 0) + Z(I[w + 8 >> 1], -10) | 0) + (I[w + 10 >> 1] << 2) | 0) - I[w + 12 >> 1] >> C, w = w + 2 | 0, h = (G << 1) + h | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                    if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                }
                            }
                            f = u ? 6 : C;
                            i: {
                                e: switch(s | 0){
                                    case 3:
                                        if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                        for(v = 0;;){
                                            for(h = (v << 1) + A | 0, w = (Z(v, G) << 1) + t | 0, e = 0; Q[h >> 1] = (((((Q[w >> 1] + Z(Q[w + 2 >> 1], -5) | 0) + Z(Q[w + 4 >> 1], 17) | 0) + Z(Q[w + 6 >> 1], 58) | 0) + Z(Q[w + 8 >> 1], -10) | 0) + (Q[w + 10 >> 1] << 2) | 0) - Q[w + 12 >> 1] >> f, w = w + 2 | 0, h = (r << 1) + h | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 2:
                                        if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                        for(v = 0;;){
                                            for(h = (v << 1) + A | 0, w = (Z(v, G) << 1) + t | 0, e = 0; Q[h >> 1] = (((((Q[w + 2 >> 1] << 2) - Q[w >> 1] | 0) + Z(Q[w + 8 >> 1] + Q[w + 6 >> 1] | 0, 40) | 0) + (Q[w + 12 >> 1] << 2) | 0) - Q[w + 14 >> 1] | 0) + Z(Q[w + 10 >> 1] + Q[w + 4 >> 1] | 0, -11) >> f, w = w + 2 | 0, h = (r << 1) + h | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 1:
                                        if ((k | 0) <= 0) break i;
                                        for(v = 0, u = (n | 0) <= 0;;){
                                            if (!u) for(h = (v << 1) + A | 0, w = (Z(v, G) << 1) + t | 0, e = 0; Q[h >> 1] = Q[w + 12 >> 1] + ((((((Q[w + 2 >> 1] << 2) - Q[w >> 1] | 0) + Z(Q[w + 4 >> 1], -10) | 0) + Z(Q[w + 6 >> 1], 58) | 0) + Z(Q[w + 8 >> 1], 17) | 0) + Z(Q[w + 10 >> 1], -5) | 0) >> f, w = w + 2 | 0, h = (r << 1) + h | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 0:
                                        break e;
                                    default:
                                        break i;
                                }
                                if ((k | 0) <= 0) break i;
                                for(v = n & 2147483644, s = n & 3, f = 0, B = (n | 0) <= 0;;){
                                    e: {
                                        if (B) break e;
                                        if (h = (f << 1) + A | 0, w = (Z(f, G) << 1) + t | 0, e = 0, n >>> 0 > 3) for(; Q[h >> 1] = I[w >> 1], u = r << 1, h = u + h | 0, Q[h >> 1] = I[w + 2 >> 1], h = u + h | 0, Q[h >> 1] = I[w + 4 >> 1], h = u + h | 0, Q[h >> 1] = I[w + 6 >> 1], h = u + h | 0, w = w + 8 | 0, e = e + 4 | 0, (v | 0) != (e | 0););
                                        if (e = 0, !s) break e;
                                        for(; Q[h >> 1] = I[w >> 1], w = w + 2 | 0, h = (r << 1) + h | 0, e = e + 1 | 0, (s | 0) != (e | 0););
                                    }
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function pw(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], k = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, s = f + 16 | 0, T0(k, s), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, s = z0(s), i[s >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), u = n, t = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(u, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), u = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(f + 12 | 0, 23740, 9), l[r + 97 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 24494, 13), l[r + 98 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 25071, 17), l[r + 99 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 23870, 15), l[r + 101 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 22911, 12), l[r + 102 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 24469, 12), l[r + 103 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 22863, 22), l[r + 104 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 22693, 22), l[r + 105 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(n, 23553, 24), l[r + 106 | 0]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(n, 22646, 28);
                            i: {
                                if (l[r + 107 | 0]) {
                                    U(P0(f + 12 | 0, l[r + 108 | 0] + 1 | 0), 34895, 1);
                                    break i;
                                }
                                U(f + 12 | 0, 25240, 12);
                            }
                            if (k = f + 148 | 0, G0(k, e), n = 0, u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 17467, 12), i[r + 116 >> 2] != i[r + 112 >> 2]) for(; e = U(f + 12 | 0, 25193, 1), k = i[e >> 2], t = k - 12 | 0, u = i[t >> 2] + e | 0, i[u + 4 >> 2] = i[u + 4 >> 2] & -75 | 8, t = e + i[t >> 2] | 0, i[t + 76 >> 2] == -1 && (u = f + 148 | 0, k = i[t + 28 >> 2], i[u >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(u, 108580), p[i[i[k >> 2] + 28 >> 2]](k, 32), d0(u), k = i[e >> 2]), i[t + 76 >> 2] = 48, i[(e + i[k - 12 >> 2] | 0) + 12 >> 2] = 2, P0(e, l[i[r + 112 >> 2] + n | 0]), n = n + 1 | 0, n >>> 0 < i[r + 116 >> 2] - i[r + 112 >> 2] >>> 0;);
                            r = f + 12 | 0, e = r + i[i[f + 12 >> 2] - 12 >> 2] | 0, i[e + 4 >> 2] = i[e + 4 >> 2] & -75 | 2, U(r, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[s >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(s), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function B8(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            h = s << 2, B = i[h + 50336 >> 2] + n | 0, h = i[h + 50320 >> 2], G = B + h | 0, w = i[(u << 2) + 50320 >> 2];
                            i: {
                                e: switch(u | 0){
                                    case 0:
                                        if (_ = 0 - h | 0, (B | 0) <= (_ | 0) | (k | 0) <= 0) break i;
                                        for(C = (h << 1) + t | 0, V = e - w | 0, y = k & 2147483644, W = k & 3, F = k >>> 0 < 4;;){
                                            if (w = (_ << 1) + C | 0, h = Z(f, _) + V | 0, v = 0, !F) for(; Q[w >> 1] = l[h | 0], e = G << 1, w = e + w | 0, Q[w >> 1] = l[h + 1 | 0], w = e + w | 0, Q[w >> 1] = l[h + 2 | 0], w = e + w | 0, Q[w >> 1] = l[h + 3 | 0], w = e + w | 0, h = h + 4 | 0, v = v + 4 | 0, (y | 0) != (v | 0););
                                            if (e = 0, W) for(; Q[w >> 1] = l[h | 0], h = h + 1 | 0, w = (G << 1) + w | 0, e = e + 1 | 0, (W | 0) != (e | 0););
                                            if (_ = _ + 1 | 0, (B | 0) == (_ | 0)) break;
                                        }
                                        break i;
                                    case 1:
                                        if (v = 0 - h | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                        for(_ = (h << 1) + t | 0, W = e - w | 0;;){
                                            for(w = _ + (v << 1) | 0, h = W + Z(f, v) | 0, e = 0; Q[w >> 1] = l[h + 6 | 0] + ((((((l[h + 1 | 0] << 2) - l[h | 0] | 0) + Z(l[h + 2 | 0], -10) | 0) + Z(l[h + 3 | 0], 58) | 0) + Z(l[h + 4 | 0], 17) | 0) + Z(l[h + 5 | 0], -5) | 0), h = h + 1 | 0, w = (G << 1) + w | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                            if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                        }
                                        break i;
                                    case 2:
                                        if (v = 0 - h | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                        for(_ = (h << 1) + t | 0, W = e - w | 0;;){
                                            for(w = _ + (v << 1) | 0, h = W + Z(f, v) | 0, e = 0; Q[w >> 1] = (((((l[h + 1 | 0] << 2) - l[h | 0] | 0) + Z(l[h + 4 | 0] + l[h + 3 | 0] | 0, 40) | 0) + (l[h + 6 | 0] << 2) | 0) - l[h + 7 | 0] | 0) + Z(l[h + 5 | 0] + l[h + 2 | 0] | 0, -11), h = h + 1 | 0, w = (G << 1) + w | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                            if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                        }
                                        break i;
                                    case 3:
                                        break e;
                                    default:
                                        break i;
                                }
                                if (v = 0 - h | 0, (B | 0) <= (v | 0) | (k | 0) <= 0) break i;
                                for(_ = (h << 1) + t | 0, W = e - w | 0;;){
                                    for(w = _ + (v << 1) | 0, h = W + Z(f, v) | 0, e = 0; Q[w >> 1] = (((((l[h | 0] + Z(l[h + 1 | 0], -5) | 0) + Z(l[h + 2 | 0], 17) | 0) + Z(l[h + 3 | 0], 58) | 0) + Z(l[h + 4 | 0], -10) | 0) + (l[h + 5 | 0] << 2) | 0) - l[h + 6 | 0], h = h + 1 | 0, w = (G << 1) + w | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                                    if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                }
                            }
                            f = u ? 6 : 0;
                            i: {
                                e: switch(s | 0){
                                    case 3:
                                        if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                        for(v = 0;;){
                                            for(w = (v << 1) + A | 0, h = (Z(v, G) << 1) + t | 0, e = 0; Q[w >> 1] = (((((Q[h >> 1] + Z(Q[h + 2 >> 1], -5) | 0) + Z(Q[h + 4 >> 1], 17) | 0) + Z(Q[h + 6 >> 1], 58) | 0) + Z(Q[h + 8 >> 1], -10) | 0) + (Q[h + 10 >> 1] << 2) | 0) - Q[h + 12 >> 1] >> f, h = h + 2 | 0, w = (r << 1) + w | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 2:
                                        if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                        for(v = 0;;){
                                            for(w = (v << 1) + A | 0, h = (Z(v, G) << 1) + t | 0, e = 0; Q[w >> 1] = (((((Q[h + 2 >> 1] << 2) - Q[h >> 1] | 0) + Z(Q[h + 8 >> 1] + Q[h + 6 >> 1] | 0, 40) | 0) + (Q[h + 12 >> 1] << 2) | 0) - Q[h + 14 >> 1] | 0) + Z(Q[h + 10 >> 1] + Q[h + 4 >> 1] | 0, -11) >> f, h = h + 2 | 0, w = (r << 1) + w | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 1:
                                        if ((k | 0) <= 0) break i;
                                        for(v = 0, u = (n | 0) <= 0;;){
                                            if (!u) for(w = (v << 1) + A | 0, h = (Z(v, G) << 1) + t | 0, e = 0; Q[w >> 1] = Q[h + 12 >> 1] + ((((((Q[h + 2 >> 1] << 2) - Q[h >> 1] | 0) + Z(Q[h + 4 >> 1], -10) | 0) + Z(Q[h + 6 >> 1], 58) | 0) + Z(Q[h + 8 >> 1], 17) | 0) + Z(Q[h + 10 >> 1], -5) | 0) >> f, h = h + 2 | 0, w = (r << 1) + w | 0, e = e + 1 | 0, (n | 0) != (e | 0););
                                            if (v = v + 1 | 0, (v | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    case 0:
                                        break e;
                                    default:
                                        break i;
                                }
                                if ((k | 0) <= 0) break i;
                                for(v = n & 2147483644, s = n & 3, f = 0, B = (n | 0) <= 0;;){
                                    e: {
                                        if (B) break e;
                                        if (w = (f << 1) + A | 0, h = (Z(f, G) << 1) + t | 0, e = 0, n >>> 0 > 3) for(; Q[w >> 1] = I[h >> 1], u = r << 1, w = u + w | 0, Q[w >> 1] = I[h + 2 >> 1], w = u + w | 0, Q[w >> 1] = I[h + 4 >> 1], w = u + w | 0, Q[w >> 1] = I[h + 6 >> 1], w = u + w | 0, h = h + 8 | 0, e = e + 4 | 0, (v | 0) != (e | 0););
                                        if (e = 0, !s) break e;
                                        for(; Q[w >> 1] = I[h >> 1], h = h + 2 | 0, w = (r << 1) + w | 0, e = e + 1 | 0, (s | 0) != (e | 0););
                                    }
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function q7(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0;
                            C = m - 2176 | 0, m = C;
                            i: {
                                if ((r | 0) <= 0) break i;
                                G = r >>> 1 | 0;
                                e: {
                                    if (r >>> 0 >= 8) {
                                        for(h = r >>> 2 | 0, H = r & 2, M = G & 1073741822, t = C - -64 | 0, k = C;;){
                                            r: {
                                                if ((r | 0) == 1) break r;
                                                if (w = (Z(f, E) << 1) + e | 0, n = 0, u = 0, (G | 0) != 1) for(; v = n << 1, s = v + w | 0, B = t + v | 0, v = n + G << 1, _ = v + w | 0, Q[B >> 1] = I[_ >> 1] + I[s >> 1], Q[t + v >> 1] = I[s >> 1] - I[_ >> 1], s = n | 1, v = s << 1, B = v + t | 0, s = s + G << 1, _ = s + w | 0, v = w + v | 0, Q[B >> 1] = I[_ >> 1] + I[v >> 1], Q[t + s >> 1] = I[v >> 1] - I[_ >> 1], n = n + 2 | 0, u = u + 2 | 0, (M | 0) != (u | 0););
                                                if (!H) break r;
                                                s = n << 1, u = s + w | 0, n = n + G << 1, w = n + w | 0, Q[t + s >> 1] = I[w >> 1] + I[u >> 1], Q[n + t >> 1] = I[u >> 1] - I[w >> 1];
                                            }
                                            for(u = h, w = G;;){
                                                r: {
                                                    if (n = t, t = k, !u) break r;
                                                    for(V = u & 536870910, F = u & 1, s = 0;;){
                                                        if (k = 0, v = 0, (u | 0) != 1) for(; _ = k + s | 0, W = _ << 1, B = W + t | 0, R = u + _ << 1, y = I[R + n >> 1], W = I[n + W >> 1], Q[B >> 1] = y + W, Q[t + R >> 1] = W - y, _ = _ + 1 | 0, W = _ << 1, B = W + t | 0, _ = u + _ << 1, R = I[_ + n >> 1], W = I[n + W >> 1], Q[B >> 1] = R + W, Q[t + _ >> 1] = W - R, k = k + 2 | 0, v = v + 2 | 0, (V | 0) != (v | 0););
                                                        if (F && (k = k + s | 0, v = k << 1, B = v + t | 0, k = k + u << 1, _ = I[k + n >> 1], v = I[n + v >> 1], Q[B >> 1] = _ + v, Q[k + t >> 1] = v - _), s = s + w | 0, !((s | 0) < (r | 0))) break;
                                                    }
                                                    if (w = w >>> 1 | 0, s = u >>> 0 > 3, u = u >>> 1 | 0, k = n, s) continue;
                                                }
                                                break;
                                            }
                                            for(u = Z(r, E), k = 0; w = C + 128 | 0, s = k | 1, v = (s << 1) + t | 0, _ = (k << 1) + t | 0, Q[w + (k + u << 1) >> 1] = I[v >> 1] + I[_ >> 1], Q[w + (u + s << 1) >> 1] = I[_ >> 1] - I[v >> 1], k = k + 2 | 0, (k | 0) < (r | 0););
                                            if (k = n, E = E + 1 | 0, (E | 0) == (r | 0)) break;
                                        }
                                        break e;
                                    }
                                    for(k = r - 1 | 0, v = k & 2, E = (k >>> 1 | 0) + 1 & -2, _ = G << 1, k = C - -64 | 0, H = _ + k | 0, M = G + 2 << 1, V = M + k | 0, F = G + 1 << 1, W = F + k | 0, R = r >>> 0 < 3;;){
                                        r: {
                                            if ((r | 0) == 1 || (k = (Z(f, u) << 1) + e | 0, n = I[k + _ >> 1], t = I[k >> 1], Q[C + 64 >> 1] = n + t, Q[H >> 1] = t - n, r >>> 0 < 4) || (n = I[k + F >> 1], t = I[k + 2 >> 1], Q[C + 66 >> 1] = n + t, Q[W >> 1] = t - n, (G | 0) == 2)) break r;
                                            n = I[k + M >> 1], k = I[k + 4 >> 1], Q[C + 68 >> 1] = n + k, Q[V >> 1] = k - n;
                                        }
                                        if (n = Z(r, u), t = 0, k = 0, !R) for(; w = C + 128 | 0, h = C - -64 | 0, s = t | 1, y = I[h + (s << 1) >> 1], B = I[h + (t << 1) >> 1], Q[w + (n + t << 1) >> 1] = y + B, Q[w + (n + s << 1) >> 1] = B - y, y = t | 2, s = I[h + (y << 1) >> 1], B = w + (n + y << 1) | 0, y = t | 3, h = I[h + (y << 1) >> 1], Q[B >> 1] = s + h, Q[w + (n + y << 1) >> 1] = s - h, t = t + 4 | 0, k = k + 2 | 0, (E | 0) != (k | 0););
                                        if (v || (k = C + 128 | 0, B = k + (n + t << 1) | 0, h = C - -64 | 0, w = t | 1, s = I[h + (w << 1) >> 1], t = I[h + (t << 1) >> 1], Q[B >> 1] = s + t, Q[k + (n + w << 1) >> 1] = t - s), u = u + 1 | 0, (u | 0) == (r | 0)) break;
                                    }
                                    n = C, t = n - -64 | 0;
                                }
                                if ((r | 0) <= 0) break i;
                                for(e = r >>> 1 | 0, E = e >>> 0 <= 1 ? 1 : e, f = r >>> 2 | 0, G = 0, _ = r >>> 0 < 8;;){
                                    k = 0;
                                    e: {
                                        if ((r | 0) == 1) {
                                            k = n;
                                            break e;
                                        }
                                        for(; h = C + 128 | 0, w = e + k | 0, u = I[h + (Z(w, r) + G << 1) >> 1], h = h + (Z(r, k) + G << 1) | 0, Q[(k << 1) + t >> 1] = u + I[h >> 1], Q[(w << 1) + t >> 1] = I[h >> 1] - u, k = k + 1 | 0, (E | 0) != (k | 0););
                                        if (u = f, w = e, k = n, _) break e;
                                        for(;;){
                                            if (k = t, t = n, !u) break e;
                                            for(H = u & 536870910, M = u & 1, s = 0;;){
                                                if (n = 0, v = 0, (u | 0) != 1) for(; h = n + s | 0, V = h << 1, B = V + t | 0, F = u + h << 1, W = I[F + k >> 1], V = I[k + V >> 1], Q[B >> 1] = W + V, Q[t + F >> 1] = V - W, h = h + 1 | 0, V = h << 1, B = V + t | 0, h = u + h << 1, F = I[h + k >> 1], V = I[k + V >> 1], Q[B >> 1] = F + V, Q[t + h >> 1] = V - F, n = n + 2 | 0, v = v + 2 | 0, (H | 0) != (v | 0););
                                                if (M && (n = n + s | 0, h = n << 1, B = h + t | 0, n = n + u << 1, v = I[n + k >> 1], h = I[k + h >> 1], Q[B >> 1] = v + h, Q[n + t >> 1] = h - v), s = s + w | 0, !((s | 0) < (r | 0))) break;
                                            }
                                            if (w = w >>> 1 | 0, h = u >>> 0 > 3, u = u >>> 1 | 0, n = k, !h) break;
                                        }
                                    }
                                    for(u = (G << 1) + A | 0, n = 0; w = n | 1, h = (w << 1) + t | 0, s = (n << 1) + t | 0, Q[u + (Z(r, n) << 1) >> 1] = I[h >> 1] + I[s >> 1], Q[u + (Z(r, w) << 1) >> 1] = I[s >> 1] - I[h >> 1], n = n + 2 | 0, (n | 0) < (r | 0););
                                    if (n = k, G = G + 1 | 0, (G | 0) == (r | 0)) break;
                                }
                            }
                            m = C + 2176 | 0;
                        }
                        function $7(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            C = m;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    if (!k || !(l0(e, 1) & 255)) break s;
                                                                    if (t) {
                                                                        if (A = q0(e), (A | 0) == -99999 | (A | 0) >= (k | 0)) break r;
                                                                        A = A ^ -1;
                                                                    } else A = -1;
                                                                    if (v = A + k | 0, (v | 0) < 0) break t;
                                                                    if (r = l0(e, 1), A = q0(e), (A | 0) == -99999) break r;
                                                                    for(B = l[(i[n >> 2] + Z(v, 100) | 0) + 98 | 0], k = B + 16 & 496, s = C - k | 0, t = s, m = t, u = A ^ -1, h = A + 1 | 0, w = t - k | 0, m = w, k = 0; A = l0(e, 1), o[k + s | 0] = A, t = k + w | 0, A & 255 ? A = 1 : A = l0(e, 1), o[t | 0] = A, A = (k | 0) != (B | 0), k = k + 1 | 0, !!A;);
                                                                    u = r ? u : h, e = Z(v, 100), r = e + i[n >> 2] | 0, A = l[r + 96 | 0], r = l[r + 97 | 0];
                                                                    u: {
                                                                        if (!r) {
                                                                            t = 0;
                                                                            break u;
                                                                        }
                                                                        for(h = f - -64 | 0, t = 0, _ = r >>> 0 < 17, k = r;;){
                                                                            if (G = i[n >> 2], v >>> 0 >= (i[n + 4 >> 2] - G | 0) / 100 >>> 0) break n;
                                                                            if (!_) break k;
                                                                            k = k - 1 | 0, G = u + Q[((e + G | 0) + (k << 1) | 0) + 32 >> 1] | 0;
                                                                            w: {
                                                                                if ((G | 0) >= 0 || (W = A + k | 0, !l[W + w | 0])) break w;
                                                                                if ((t | 0) > 15) break i;
                                                                                Q[(t << 1) + f >> 1] = G, o[t + h | 0] = l[s + W | 0], t = t + 1 | 0;
                                                                            }
                                                                            if (!k) break;
                                                                        }
                                                                    }
                                                                    if (!(!l[w + B | 0] | (u | 0) >= 0)) {
                                                                        if (h = 0, (t | 0) > 15) break r;
                                                                        Q[(t << 1) + f >> 1] = u, o[(f + t | 0) - -64 | 0] = l[s + B | 0], t = t + 1 | 0;
                                                                    }
                                                                    u: {
                                                                        if (!A) {
                                                                            o[f + 96 | 0] = t, k = 0;
                                                                            break u;
                                                                        }
                                                                        for(e = f - -64 | 0, k = 0, h = Z(v, 100);;){
                                                                            if (_ = u + Q[(h + i[n >> 2] | 0) + (k << 1) >> 1] | 0, !(!l[k + w | 0] | (_ | 0) >= 0)) {
                                                                                if ((t | 0) > 15) break i;
                                                                                Q[(t << 1) + f >> 1] = _, o[e + t | 0] = l[k + s | 0], t = t + 1 | 0;
                                                                            }
                                                                            if (k = k + 1 | 0, (A | 0) == (k | 0)) break;
                                                                        }
                                                                        if (o[f + 96 | 0] = t, !A) {
                                                                            k = 0;
                                                                            break u;
                                                                        }
                                                                        for(h = f + 80 | 0, _ = f + 32 | 0, k = 0, G = Z(v, 100), t = A;;){
                                                                            if (e = t, t = t - 1 | 0, W = u + Q[(G + i[n >> 2] | 0) + (t << 1) >> 1] | 0, !((W | 0) <= 0 | !l[t + w | 0])) {
                                                                                if ((k | 0) > 15) break i;
                                                                                Q[_ + (k << 1) >> 1] = W, o[k + h | 0] = l[t + s | 0], k = k + 1 | 0;
                                                                            }
                                                                            if (!((e | 0) > 1)) break;
                                                                        }
                                                                    }
                                                                    if (!(!l[w + B | 0] | (u | 0) <= 0)) {
                                                                        if (h = 0, (k | 0) > 15) break r;
                                                                        Q[((k << 1) + f | 0) + 32 >> 1] = u, o[(f + k | 0) + 80 | 0] = l[s + B | 0], k = k + 1 | 0;
                                                                    }
                                                                    if (r) for(e = f + 80 | 0, B = f + 32 | 0, t = 0, v = Z(v, 100);;){
                                                                        h = u + Q[((v + i[n >> 2] | 0) + (t << 1) | 0) + 32 >> 1] | 0;
                                                                        u: {
                                                                            if ((h | 0) <= 0 || (_ = A + t | 0, !l[_ + w | 0])) break u;
                                                                            if ((k | 0) > 15) break i;
                                                                            Q[B + (k << 1) >> 1] = h, o[e + k | 0] = l[s + _ | 0], k = k + 1 | 0;
                                                                        }
                                                                        if (t = t + 1 | 0, (r | 0) == (t | 0)) break;
                                                                    }
                                                                    o[f + 97 | 0] = k;
                                                                    break o;
                                                                }
                                                                if (n = q0(e), u = q0(e), !((n | 0) != -99999 & (u | 0) != -99999)) break e;
                                                                if (i[((o[r + 2 | 0] << 2) + r | 0) + 524 >> 2] < (n + u | 0)) {
                                                                    Q[f + 96 >> 1] = 0, Q[f + 98 >> 1] = 0;
                                                                    break e;
                                                                }
                                                                if (!((u | 0) < 17 & (n | 0) <= 16)) break e;
                                                                if (o[f + 97 | 0] = u, o[f + 96 | 0] = n, (n | 0) > 0) for(A = f - -64 | 0, k = 0, r = 0;;){
                                                                    if (t = q0(e), (t | 0) == -99999) break r;
                                                                    if (s = l0(e, 1), w = (k << 1) + f | 0, Q[w >> 1] = (t ^ -1) + r, o[A + k | 0] = s, r = I[w >> 1], k = k + 1 | 0, (n | 0) == (k | 0)) break;
                                                                }
                                                                if ((u | 0) <= 0) break o;
                                                                for(A = f + 80 | 0, r = f + 32 | 0, k = 0, t = 0;;){
                                                                    if (n = q0(e), (n | 0) == -99999) break r;
                                                                    if (s = l0(e, 1), w = r + (k << 1) | 0, Q[w >> 1] = (n + t | 0) + 1, o[A + k | 0] = s, t = I[w >> 1], k = k + 1 | 0, (u | 0) == (k | 0)) break;
                                                                }
                                                            }
                                                            if (k = 0, o[f + 99 | 0] = 0, A = l[f + 96 | 0], !A) break A;
                                                            if (n = A & 1, r = f - -64 | 0, (A | 0) == 1) {
                                                                e = 0;
                                                                break f;
                                                            }
                                                            for(u = A & 254, e = 0, t = 0; s = r + e | 0, l[s | 0] && (k = k + 1 | 0, o[f + 99 | 0] = k), l[s + 1 | 0] && (k = k + 1 | 0, o[f + 99 | 0] = k), e = e + 2 | 0, t = t + 2 | 0, (u | 0) != (t | 0););
                                                            break f;
                                                        }
                                                        y0(18239, 15059, 129, 3703), z();
                                                    }
                                                    y0(20656, 15059, 174, 3703), z();
                                                }
                                                y0(15978, 15059, 175, 3703), z();
                                            }
                                            if (!n | !l[r + e | 0]) break A;
                                            k = k + 1 | 0, o[f + 99 | 0] = k;
                                        }
                                        r = l[f + 97 | 0];
                                        A: {
                                            if (!r) break A;
                                            if (n = f + 80 | 0, e = 0, (r | 0) != 1) for(u = r & 254, t = 0; s = e + n | 0, l[s | 0] && (k = k + 1 | 0, o[f + 99 | 0] = k), l[s + 1 | 0] && (k = k + 1 | 0, o[f + 99 | 0] = k), e = e + 2 | 0, t = t + 2 | 0, (u | 0) != (t | 0););
                                            if (!(r & 1) | !l[e + n | 0]) break A;
                                            o[f + 99 | 0] = k + 1;
                                        }
                                        o[f + 98 | 0] = A + r, h = 1;
                                    }
                                    return m = C, h;
                                }
                                W2(A, 1018, 0);
                            }
                            return m = C, 0;
                        }
                        function Qw() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0;
                            A = m - 16 | 0, m = A;
                            i: {
                                if (as(A + 12 | 0, A + 8 | 0) | 0 || (r = Q2((i[A + 12 >> 2] << 2) + 4 | 0), i[26065] = r, !r) || (r = Q2(i[A + 8 >> 2]), r && (i[i[26065] + (i[A + 12 >> 2] << 2) >> 2] = 0, !($s(i[26065], r | 0) | 0)))) break i;
                                i[26065] = 0;
                            }
                            m = A + 16 | 0, l[108089] || (e = i[15174], f = m - 16 | 0, m = f, A = z0(107736), i[A + 40 >> 2] = 107792, i[A + 32 >> 2] = e, i[A >> 2] = 61028, o[A + 52 | 0] = 0, i[A + 48 >> 2] = -1, k = f + 12 | 0, r = i[A + 4 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), p[i[i[A >> 2] + 8 >> 2]](A, k), d0(k), m = f + 16 | 0, i[26765] = 60660, i[26765] = 58992, i[26763] = 58524, i[26765] = 58544, i[26764] = 0, Zr(i[14628] + 107052 | 0, 107736), k = i[13797], M9(107800, k, 107848), PA(107228, 107800), n = i[13796], M9(107856, n, 107904), PA(107396, 107856), PA(107564, i[(i[i[26849] - 12 >> 2] + 107396 | 0) + 24 >> 2]), i[(i[i[26763] - 12 >> 2] + 107052 | 0) + 72 >> 2] = 107228, A = i[i[26849] - 12 >> 2] + 107396 | 0, i[A + 4 >> 2] = i[A + 4 >> 2] | 8192, i[(i[i[26849] - 12 >> 2] + 107396 | 0) + 72 >> 2] = 107228, f = m - 16 | 0, m = f, A = Mt(107912), i[A + 40 >> 2] = 107968, i[A + 32 >> 2] = e, i[A >> 2] = 61232, o[A + 52 | 0] = 0, i[A + 48 >> 2] = -1, e = f + 12 | 0, r = i[A + 4 >> 2], i[e >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), p[i[i[A >> 2] + 8 >> 2]](A, e), d0(e), m = f + 16 | 0, i[26787] = 60660, i[26787] = 59428, i[26785] = 58772, i[26787] = 58792, i[26786] = 0, Zr(i[14690] + 107140 | 0, 107912), U9(107976, k, 108024), LA(107312, 107976), U9(108032, n, 108080), LA(107480, 108032), LA(107648, i[(i[i[26870] - 12 >> 2] + 107480 | 0) + 24 >> 2]), i[(i[i[26785] - 12 >> 2] + 107140 | 0) + 72 >> 2] = 107312, A = i[i[26870] - 12 >> 2] + 107480 | 0, i[A + 4 >> 2] = i[A + 4 >> 2] | 8192, i[(i[i[26870] - 12 >> 2] + 107480 | 0) + 72 >> 2] = 107312, o[108089] = 1), i[21668] = 0, i[21669] = 0, o[86691] = 0, o[86680] = 0, A = D(16), o[A + 14 | 0] = 0, r = l[5712] | l[5713] << 8 | (l[5714] << 16 | l[5715] << 24), e = l[5708] | l[5709] << 8 | (l[5710] << 16 | l[5711] << 24), o[A + 6 | 0] = e, o[A + 7 | 0] = e >>> 8, o[A + 8 | 0] = e >>> 16, o[A + 9 | 0] = e >>> 24, o[A + 10 | 0] = r, o[A + 11 | 0] = r >>> 8, o[A + 12 | 0] = r >>> 16, o[A + 13 | 0] = r >>> 24, r = l[5706] | l[5707] << 8 | (l[5708] << 16 | l[5709] << 24), e = l[5702] | l[5703] << 8 | (l[5704] << 16 | l[5705] << 24), o[A | 0] = e, o[A + 1 | 0] = e >>> 8, o[A + 2 | 0] = e >>> 16, o[A + 3 | 0] = e >>> 24, o[A + 4 | 0] = r, o[A + 5 | 0] = r >>> 8, o[A + 6 | 0] = r >>> 16, o[A + 7 | 0] = r >>> 24, i[21673] = 4, i[21674] = 0, j(86700, A, 14), X(A), i[21679] = 0, i[21680] = 0, i[21678] = 86716, i[21681] = 86728, i[21682] = 0, i[21683] = 0, AA(), A = m - 80 | 0, m = A, i[21687] = 0, i[21686] = 596, S7(), i[21687] = i[26061], i[26061] = 86744, i[21689] = 0, i[21690] = 0, i[21688] = 86756, r = i[10174], i[A + 48 >> 2] = i[10173], i[A + 52 >> 2] = r, r = i[10172], i[A + 40 >> 2] = i[10171], i[A + 44 >> 2] = r, r = i[10170], i[A + 32 >> 2] = i[10169], i[A + 36 >> 2] = r, r = i[10168], i[A + 24 >> 2] = i[10167], i[A + 28 >> 2] = r, r = i[10166], i[A + 16 >> 2] = i[10165], i[A + 20 >> 2] = r, r = i[10164], i[A + 8 >> 2] = i[10163], i[A + 12 >> 2] = r, r = A + 8 | 0, He(86752, r, A + 56 | 0), v0(r, 40700, 68), i[21691] = 86768, i[21692] = 0, i[21693] = 0, He(86764, r, A + 76 | 0), i[21695] = 0, i[21696] = 0, i[21694] = 86780, e = i[10205], i[A + 56 >> 2] = i[10204], i[A + 60 >> 2] = e, e = i[10203], i[A + 48 >> 2] = i[10202], i[A + 52 >> 2] = e, e = i[10201], i[A + 40 >> 2] = i[10200], i[A + 44 >> 2] = e, e = i[10199], i[A + 32 >> 2] = i[10198], i[A + 36 >> 2] = e, e = i[10197], i[A + 24 >> 2] = i[10196], i[A + 28 >> 2] = e, e = i[10195], i[A + 16 >> 2] = i[10194], i[A + 20 >> 2] = e, e = i[10193], i[A + 8 >> 2] = i[10192], i[A + 12 >> 2] = e, He(86776, r, A - -64 | 0), m = A + 80 | 0, i[26062] = 1289, i[26063] = 0, d5(), i[26063] = i[26061], i[26061] = 104248, i[26106] = 104304, i[26088] = 42;
                        }
                        function Q3(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 192 | 0, m = k, z1(k + 168 | 0, r, e);
                            i: {
                                if (i[k + 168 >> 2] != i[21668]) {
                                    r = i[k + 172 >> 2], i[A >> 2] = i[k + 168 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 184 >> 2], r = i[k + 180 >> 2], i[A + 8 >> 2] = i[k + 176 >> 2], i[A + 12 >> 2] = r, i[k + 184 >> 2] = 0, i[k + 176 >> 2] = 0, i[k + 180 >> 2] = 0;
                                    break i;
                                }
                                s = r, h = n2(e), i[s + 104 >> 2] = h, t = n2(e);
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        if (t >>> 0 > i[e + 16 >> 2] >>> 2 >>> 0) {
                                                            i[k + 32 >> 2] = 59808, i[k + 88 >> 2] = 59828, r = i[14961], i[k + 24 >> 2] = r, f = i[r - 12 >> 2], r = k + 24 | 0, i[f + r >> 2] = i[14962], i[k + 28 >> 2] = 0, f = r + i[i[k + 24 >> 2] - 12 >> 2] | 0, n = k + 36 | 0, T0(f, n), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[k + 32 >> 2] = f, u = k + 32 | 0, i[u + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[k + 24 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[k + 88 >> 2] = 59828, i[k + 24 >> 2] = 59788, i[k + 32 >> 2] = 59808, f = z0(n), i[f >> 2] = 58864, i[k + 76 >> 2] = 0, i[k + 80 >> 2] = 0, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 84 >> 2] = 24, r = i[e + 16 >> 2], U(M0(U(M0(U(u, 21848, 32), t), 22513, 32), r >>> 2 | 0), 19294, 10), r = i[k + 84 >> 2];
                                                            t: {
                                                                if (r & 16) {
                                                                    r = i[k + 80 >> 2], e = i[k + 60 >> 2], r >>> 0 < e >>> 0 && (i[k + 80 >> 2] = e, r = e), e = k + 56 | 0;
                                                                    break t;
                                                                }
                                                                if (!(r & 8)) {
                                                                    r = 0, o[k + 23 | 0] = 0, e = k + 12 | 0;
                                                                    break e;
                                                                }
                                                                r = i[k + 52 >> 2], e = k + 44 | 0;
                                                            }
                                                            if (t = i[e >> 2], r = r - t | 0, r >>> 0 >= 2147483640) break n;
                                                            if (r >>> 0 >= 11) {
                                                                n = (r | 7) + 1 | 0, e = D(n), i[k + 20 >> 2] = n | -2147483648, i[k + 12 >> 2] = e, i[k + 16 >> 2] = r;
                                                                break r;
                                                            }
                                                            if (o[k + 23 | 0] = r, e = k + 12 | 0, r) break r;
                                                            r = 0;
                                                            break e;
                                                        }
                                                        if (n = i[f + 56 >> 2], !(!n | n >>> 0 >= t >>> 0)) {
                                                            i[k + 32 >> 2] = 59808, i[k + 88 >> 2] = 59828, r = i[14961], i[k + 24 >> 2] = r, e = i[r - 12 >> 2], r = k + 24 | 0, i[e + r >> 2] = i[14962], i[k + 28 >> 2] = 0, e = r + i[i[k + 24 >> 2] - 12 >> 2] | 0, n = k + 36 | 0, T0(e, n), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[k + 32 >> 2] = e, u = i[e - 12 >> 2], e = k + 32 | 0, i[u + e >> 2] = i[14964], u = i[14960], i[k + 24 >> 2] = u, i[r + i[u - 12 >> 2] >> 2] = i[14965], i[k + 88 >> 2] = 59828, i[k + 24 >> 2] = 59788, i[k + 32 >> 2] = 59808, n = z0(n), i[n >> 2] = 58864, i[k + 76 >> 2] = 0, i[k + 80 >> 2] = 0, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 84 >> 2] = 24, U(M0(U(M0(U(e, 21360, 26), t), 21638, 44), i[f + 56 >> 2]), 19294, 10), r = i[k + 84 >> 2];
                                                            t: {
                                                                if (r & 16) {
                                                                    r = i[k + 80 >> 2], e = i[k + 60 >> 2], r >>> 0 < e >>> 0 && (i[k + 80 >> 2] = e, r = e), e = k + 56 | 0;
                                                                    break t;
                                                                }
                                                                if (!(r & 8)) {
                                                                    r = 0, o[k + 23 | 0] = 0, e = k + 12 | 0;
                                                                    break A;
                                                                }
                                                                r = i[k + 52 >> 2], e = k + 44 | 0;
                                                            }
                                                            if (f = i[e >> 2], r = r - f | 0, r >>> 0 >= 2147483640) break k;
                                                            if (r >>> 0 >= 11) {
                                                                t = (r | 7) + 1 | 0, e = D(t), i[k + 20 >> 2] = t | -2147483648, i[k + 12 >> 2] = e, i[k + 16 >> 2] = r;
                                                                break f;
                                                            }
                                                            if (o[k + 23 | 0] = r, e = k + 12 | 0, r) break f;
                                                            r = 0;
                                                            break A;
                                                        }
                                                        f = r + 108 | 0, u = i[r + 108 >> 2], n = i[r + 112 >> 2] - u >> 2;
                                                        t: {
                                                            o: {
                                                                if (n >>> 0 < t >>> 0) {
                                                                    d4(f, t - n | 0);
                                                                    break o;
                                                                }
                                                                if (n >>> 0 > t >>> 0 && (i[r + 112 >> 2] = u + (t << 2)), !t) break t;
                                                            }
                                                            for(r = 0; n = n2(e), i[i[f >> 2] + (r << 2) >> 2] = n, r = r + 1 | 0, (t | 0) != (r | 0););
                                                        }
                                                        if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                            break i;
                                                        }
                                                        j(A, i[21670], i[21671]);
                                                        break i;
                                                    }
                                                    Y0(), z();
                                                }
                                                Y0(), z();
                                            }
                                            Q0(e, f, r);
                                        }
                                        o[r + e | 0] = 0, i0(A, 2, 1e3, k + 12 | 0), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), A = i[14959], i[k + 24 >> 2] = A, i[i[A - 12 >> 2] + (k + 24 | 0) >> 2] = i[14967], i[k + 32 >> 2] = i[14968], i[n >> 2] = 58864, o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), x0(n), N0(k + 88 | 0);
                                        break i;
                                    }
                                    Q0(e, t, r);
                                }
                                o[r + e | 0] = 0, i0(A, 2, 100, k + 12 | 0), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), A = i[14959], i[k + 24 >> 2] = A, i[i[A - 12 >> 2] + (k + 24 | 0) >> 2] = i[14967], i[k + 32 >> 2] = i[14968], i[f >> 2] = 58864, o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), x0(f), N0(k + 88 | 0);
                            }
                            o[k + 187 | 0] < 0 && X(i[k + 176 >> 2]), m = k + 192 | 0;
                        }
                        function Cw(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            n = m + -64 | 0, m = n;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (!(f && r)) {
                                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 13578;
                                                    break f;
                                                }
                                                if (u = D(168), i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 77696, v = u + 16 | 0, t = v, i[t + 8 >> 2] = 0, i[t + 12 >> 2] = 0, i[t + 16 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 32 >> 2] = 0, i[t >> 2] = 73428, i[u + 60 >> 2] = 0, i[u + 64 >> 2] = 0, i[u + 52 >> 2] = 0, i[u + 56 >> 2] = 0, i[u + 72 >> 2] = -1, i[u + 76 >> 2] = -1, i[u + 80 >> 2] = -1, i[u + 84 >> 2] = -1, i[u + 116 >> 2] = 0, i[u + 88 >> 2] = 0, i[u + 92 >> 2] = 0, i[u + 96 >> 2] = 0, i[u + 100 >> 2] = 0, i[u + 104 >> 2] = 0, i[u + 108 >> 2] = 0, Q[u + 112 >> 1] = 0, i[t >> 2] = 76052, i[u + 160 >> 2] = 0, i[u + 164 >> 2] = 0, i[u + 152 >> 2] = 0, i[u + 156 >> 2] = 0, i[u + 144 >> 2] = 0, i[u + 148 >> 2] = 0, i[u + 136 >> 2] = 0, i[u + 140 >> 2] = 0, i[u + 128 >> 2] = 0, i[u + 132 >> 2] = 0, i[u + 120 >> 2] = 0, i[u + 124 >> 2] = 0, i[u + 32 >> 2] = 1969513843, t = i[f + 4 >> 2], h = t || 34896, s = E2(h), s >>> 0 >= 2147483640) break A;
                                                k: {
                                                    n: {
                                                        if (s >>> 0 >= 11) {
                                                            w = (s | 7) + 1 | 0, t = D(w), i[n + 60 >> 2] = w | -2147483648, i[n + 52 >> 2] = t, i[n + 56 >> 2] = s;
                                                            break n;
                                                        }
                                                        if (o[n + 63 | 0] = s, t = n + 52 | 0, !s) break k;
                                                    }
                                                    Q0(t, h, s);
                                                }
                                                h = u + 120 | 0, o[t + s | 0] = 0, t = o[n + 63 | 0];
                                                k: {
                                                    n: {
                                                        if (o[u + 131 | 0] >= 0) {
                                                            if ((t | 0) >= 0) {
                                                                t = i[n + 56 >> 2], i[h >> 2] = i[n + 52 >> 2], i[h + 4 >> 2] = t, i[h + 8 >> 2] = i[n + 60 >> 2];
                                                                break k;
                                                            }
                                                            X4(h, i[n + 52 >> 2], i[n + 56 >> 2]);
                                                            break n;
                                                        }
                                                        if (s = (t | 0) < 0, Y4(h, s ? i[n + 52 >> 2] : n + 52 | 0, s ? i[n + 56 >> 2] : t), o[n + 63 | 0] >= 0) break k;
                                                    }
                                                    X(i[n + 52 >> 2]);
                                                }
                                                if (t = i[f + 8 >> 2], h = t || 34896, s = E2(h), s >>> 0 >= 2147483640) break r;
                                                k: {
                                                    n: {
                                                        if (s >>> 0 >= 11) {
                                                            w = (s | 7) + 1 | 0, t = D(w), i[n + 48 >> 2] = w | -2147483648, i[n + 40 >> 2] = t, i[n + 44 >> 2] = s;
                                                            break n;
                                                        }
                                                        if (o[n + 51 | 0] = s, t = n + 40 | 0, !s) break k;
                                                    }
                                                    Q0(t, h, s);
                                                }
                                                o[t + s | 0] = 0, t = u + 132 | 0, s = o[n + 51 | 0];
                                                k: {
                                                    n: {
                                                        if (o[u + 143 | 0] >= 0) {
                                                            if ((s | 0) >= 0) {
                                                                s = i[n + 44 >> 2], i[t >> 2] = i[n + 40 >> 2], i[t + 4 >> 2] = s, i[t + 8 >> 2] = i[n + 48 >> 2];
                                                                break k;
                                                            }
                                                            X4(t, i[n + 40 >> 2], i[n + 44 >> 2]);
                                                            break n;
                                                        }
                                                        h = t, t = (s | 0) < 0, Y4(h, t ? i[n + 40 >> 2] : n + 40 | 0, t ? i[n + 44 >> 2] : s);
                                                    }
                                                    if (o[n + 51 | 0] >= 0) break k;
                                                    X(i[n + 40 >> 2]);
                                                }
                                                if (t = i[f + 12 >> 2], h = t || 34896, s = E2(h), s >>> 0 >= 2147483640) break e;
                                                k: {
                                                    n: {
                                                        if (s >>> 0 >= 11) {
                                                            w = (s | 7) + 1 | 0, t = D(w), i[n + 36 >> 2] = w | -2147483648, i[n + 28 >> 2] = t, i[n + 32 >> 2] = s;
                                                            break n;
                                                        }
                                                        if (o[n + 39 | 0] = s, t = n + 28 | 0, !s) break k;
                                                    }
                                                    Q0(t, h, s);
                                                }
                                                o[t + s | 0] = 0, t = u + 144 | 0, s = o[n + 39 | 0];
                                                k: {
                                                    n: {
                                                        if (o[u + 155 | 0] >= 0) {
                                                            if ((s | 0) >= 0) {
                                                                s = i[n + 32 >> 2], i[t >> 2] = i[n + 28 >> 2], i[t + 4 >> 2] = s, i[t + 8 >> 2] = i[n + 36 >> 2];
                                                                break k;
                                                            }
                                                            X4(t, i[n + 28 >> 2], i[n + 32 >> 2]);
                                                            break n;
                                                        }
                                                        h = t, t = (s | 0) < 0, Y4(h, t ? i[n + 28 >> 2] : n + 28 | 0, t ? i[n + 32 >> 2] : s);
                                                    }
                                                    if (o[n + 39 | 0] >= 0) break k;
                                                    X(i[n + 28 >> 2]);
                                                }
                                                if (f = i[f + 16 >> 2], s = f || 34896, f = E2(s), f >>> 0 >= 2147483640) break i;
                                                k: {
                                                    n: {
                                                        if (f >>> 0 >= 11) {
                                                            h = (f | 7) + 1 | 0, t = D(h), i[n + 24 >> 2] = h | -2147483648, i[n + 16 >> 2] = t, i[n + 20 >> 2] = f;
                                                            break n;
                                                        }
                                                        if (o[n + 27 | 0] = f, t = n + 16 | 0, !f) break k;
                                                    }
                                                    Q0(t, s, f);
                                                }
                                                o[f + t | 0] = 0, f = u + 156 | 0, t = o[n + 27 | 0];
                                                k: {
                                                    n: {
                                                        if (o[u + 167 | 0] >= 0) {
                                                            if ((t | 0) >= 0) {
                                                                t = i[n + 20 >> 2], i[f >> 2] = i[n + 16 >> 2], i[f + 4 >> 2] = t, i[f + 8 >> 2] = i[n + 24 >> 2];
                                                                break k;
                                                            }
                                                            X4(f, i[n + 16 >> 2], i[n + 20 >> 2]);
                                                            break n;
                                                        }
                                                        h = f, f = (t | 0) < 0, Y4(h, f ? i[n + 16 >> 2] : n + 16 | 0, f ? i[n + 20 >> 2] : t);
                                                    }
                                                    if (o[n + 27 | 0] >= 0) break k;
                                                    X(i[n + 16 >> 2]);
                                                }
                                                if (r = i[r >> 2], i[n + 12 >> 2] = u, i[n + 8 >> 2] = v, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, f = i[n + 12 >> 2], i[n >> 2] = i[n + 8 >> 2], i[n + 4 >> 2] = f, r = Qt(r, e, n, 0), k && (i[k >> 2] = r), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A) break f;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                            }
                                            m = n - -64 | 0;
                                            return;
                                        }
                                        Y0(), z();
                                    }
                                    Y0(), z();
                                }
                                Y0(), z();
                            }
                            Y0(), z();
                        }
                        function Vw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 160 | 0, m = k, t = B2(e);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            if (n = i[f + 48 >> 2], !(!n | t >>> 0 <= n >>> 0)) {
                                                                i[k + 24 >> 2] = 59808, i[k + 80 >> 2] = 59828, r = i[14961], i[k + 16 >> 2] = r, e = i[r - 12 >> 2], r = k + 16 | 0, i[e + r >> 2] = i[14962], i[k + 20 >> 2] = 0, e = r + i[i[k + 16 >> 2] - 12 >> 2] | 0, n = k + 28 | 0, T0(e, n), i[e + 72 >> 2] = 0, i[e + 76 >> 2] = -1, e = i[14963], i[k + 24 >> 2] = e, u = i[e - 12 >> 2], e = k + 24 | 0, i[u + e >> 2] = i[14964], u = i[14960], i[k + 16 >> 2] = u, i[r + i[u - 12 >> 2] >> 2] = i[14965], i[k + 80 >> 2] = 59828, i[k + 16 >> 2] = 59788, i[k + 24 >> 2] = 59808, n = z0(n), i[n >> 2] = 58864, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 76 >> 2] = 24, U(M0(U(M0(U(e, 22269, 25), t), 21583, 54), i[f + 48 >> 2]), 3975, 11), r = i[k + 76 >> 2];
                                                                o: {
                                                                    if (r & 16) {
                                                                        f = k + 48 | 0, e = i[k + 72 >> 2], r = i[k + 52 >> 2], e >>> 0 < r >>> 0 ? i[k + 72 >> 2] = r : r = e;
                                                                        break o;
                                                                    }
                                                                    if (!(r & 8)) {
                                                                        e = 0, o[k + 15 | 0] = 0, f = k + 4 | 0;
                                                                        break e;
                                                                    }
                                                                    f = k + 36 | 0, r = i[k + 44 >> 2];
                                                                }
                                                                if (e = r, r = i[f >> 2], e = e - r | 0, e >>> 0 >= 2147483640) break t;
                                                                if (e >>> 0 >= 11) {
                                                                    t = (e | 7) + 1 | 0, f = D(t), i[k + 12 >> 2] = t | -2147483648, i[k + 4 >> 2] = f, i[k + 8 >> 2] = e;
                                                                    break r;
                                                                }
                                                                if (o[k + 15 | 0] = e, f = k + 4 | 0, e) break r;
                                                                e = 0;
                                                                break e;
                                                            }
                                                            if (t >>> 0 > k0[e + 16 >> 2] / 6 >>> 0) {
                                                                i[k + 24 >> 2] = 59808, i[k + 80 >> 2] = 59828, r = i[14961], i[k + 16 >> 2] = r, f = i[r - 12 >> 2], r = k + 16 | 0, i[f + r >> 2] = i[14962], i[k + 20 >> 2] = 0, f = r + i[i[k + 16 >> 2] - 12 >> 2] | 0, n = k + 28 | 0, T0(f, n), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[k + 24 >> 2] = f, u = i[f - 12 >> 2], f = k + 24 | 0, i[u + f >> 2] = i[14964], u = i[14960], i[k + 16 >> 2] = u, i[r + i[u - 12 >> 2] >> 2] = i[14965], i[k + 80 >> 2] = 59828, i[k + 16 >> 2] = 59788, i[k + 24 >> 2] = 59808, n = z0(n), i[n >> 2] = 58864, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 76 >> 2] = 24, U(M0(U(M0(U(f, 22269, 25), t), 21315, 44), k0[e + 16 >> 2] / 6 | 0), 3975, 11), r = i[k + 76 >> 2];
                                                                o: {
                                                                    if (r & 16) {
                                                                        f = k + 48 | 0, e = i[k + 72 >> 2], r = i[k + 52 >> 2], e >>> 0 < r >>> 0 ? i[k + 72 >> 2] = r : r = e;
                                                                        break o;
                                                                    }
                                                                    if (!(r & 8)) {
                                                                        e = 0, o[k + 15 | 0] = 0, f = k + 4 | 0;
                                                                        break A;
                                                                    }
                                                                    f = k + 36 | 0, r = i[k + 44 >> 2];
                                                                }
                                                                if (e = r, r = i[f >> 2], e = e - r | 0, e >>> 0 >= 2147483640) break n;
                                                                if (e >>> 0 >= 11) {
                                                                    t = (e | 7) + 1 | 0, f = D(t), i[k + 12 >> 2] = t | -2147483648, i[k + 4 >> 2] = f, i[k + 8 >> 2] = e;
                                                                    break f;
                                                                }
                                                                if (o[k + 15 | 0] = e, f = k + 4 | 0, e) break f;
                                                                e = 0;
                                                                break A;
                                                            }
                                                            n = r + 100 | 0, u = i[r + 100 >> 2], f = (i[r + 104 >> 2] - u | 0) / 6 | 0;
                                                            o: {
                                                                if (f >>> 0 < t >>> 0) {
                                                                    Zn(n, t - f | 0);
                                                                    break o;
                                                                }
                                                                if (f >>> 0 <= t >>> 0) break o;
                                                                i[r + 104 >> 2] = u + Z(t, 6);
                                                            }
                                                            if (!t) break k;
                                                            for(f = 0;;){
                                                                if (l[e + 20 | 0] | !i[e + 16 >> 2]) break k;
                                                                if (u = B2(e), s = B2(e), h = B2(e), r = i[n >> 2] + Z(f, 6) | 0, Q[r + 4 >> 1] = h, Q[r + 2 >> 1] = s, Q[r >> 1] = u, f = f + 1 | 0, (t | 0) == (f | 0)) break;
                                                            }
                                                            break k;
                                                        }
                                                        Y0(), z();
                                                    }
                                                    Y0(), z();
                                                }
                                                if (l[e + 20 | 0] == 1) {
                                                    if (o[k + 16 | 0] = 0, o[k + 27 | 0] = 0, i0(A, 2, 100, k + 16 | 0), o[k + 27 | 0] >= 0) break i;
                                                    X(i[k + 16 >> 2]);
                                                    break i;
                                                }
                                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                    break i;
                                                }
                                                j(A, i[21670], i[21671]);
                                                break i;
                                            }
                                            Q0(f, r, e);
                                        }
                                        o[e + f | 0] = 0, i0(A, 2, 100, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), A = i[14959], i[k + 16 >> 2] = A, i[i[A - 12 >> 2] + (k + 16 | 0) >> 2] = i[14967], i[k + 24 >> 2] = i[14968], i[n >> 2] = 58864, o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), x0(n), N0(k + 80 | 0);
                                        break i;
                                    }
                                    Q0(f, r, e);
                                }
                                o[e + f | 0] = 0, i0(A, 2, 1e3, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), A = i[14959], i[k + 16 >> 2] = A, i[i[A - 12 >> 2] + (k + 16 | 0) >> 2] = i[14967], i[k + 24 >> 2] = i[14968], i[n >> 2] = 58864, o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), x0(n), N0(k + 80 | 0);
                            }
                            m = k + 160 | 0;
                        }
                        function yw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                if (!(i[r + 8 >> 2] | i[r + 12 >> 2])) {
                                    if (r = D(48), i[k + 4 >> 2] = r, i[k + 8 >> 2] = 44, i[k + 12 >> 2] = -2147483600, e = l[13264] | l[13265] << 8 | (l[13266] << 16 | l[13267] << 24), f = l[13260] | l[13261] << 8 | (l[13262] << 16 | l[13263] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 44 | 0] = 0, e = l[13300] | l[13301] << 8 | (l[13302] << 16 | l[13303] << 24), o[r + 40 | 0] = e, o[r + 41 | 0] = e >>> 8, o[r + 42 | 0] = e >>> 16, o[r + 43 | 0] = e >>> 24, e = l[13296] | l[13297] << 8 | (l[13298] << 16 | l[13299] << 24), f = l[13292] | l[13293] << 8 | (l[13294] << 16 | l[13295] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[13288] | l[13289] << 8 | (l[13290] << 16 | l[13291] << 24), f = l[13284] | l[13285] << 8 | (l[13286] << 16 | l[13287] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[13280] | l[13281] << 8 | (l[13282] << 16 | l[13283] << 24), f = l[13276] | l[13277] << 8 | (l[13278] << 16 | l[13279] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[13272] | l[13273] << 8 | (l[13274] << 16 | l[13275] << 24), f = l[13268] | l[13269] << 8 | (l[13270] << 16 | l[13271] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 4, 0, k + 4 | 0), o[k + 15 | 0] >= 0) break i;
                                    X(i[k + 4 >> 2]);
                                    break i;
                                }
                                if (n = i[f + 40 >> 2], f = i[f + 44 >> 2], t = i[e + 16 >> 2], !(!(n | f) | (!f & t >>> 0 <= n >>> 0 | (f | 0) != 0))) {
                                    if (r = D(32), i[k + 4 >> 2] = r, i[k + 8 >> 2] = 31, i[k + 12 >> 2] = -2147483616, e = l[9530] | l[9531] << 8 | (l[9532] << 16 | l[9533] << 24), f = l[9526] | l[9527] << 8 | (l[9528] << 16 | l[9529] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 31 | 0] = 0, e = l[9553] | l[9554] << 8 | (l[9555] << 16 | l[9556] << 24), f = l[9549] | l[9550] << 8 | (l[9551] << 16 | l[9552] << 24), o[r + 23 | 0] = f, o[r + 24 | 0] = f >>> 8, o[r + 25 | 0] = f >>> 16, o[r + 26 | 0] = f >>> 24, o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, e = l[9546] | l[9547] << 8 | (l[9548] << 16 | l[9549] << 24), f = l[9542] | l[9543] << 8 | (l[9544] << 16 | l[9545] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[9538] | l[9539] << 8 | (l[9540] << 16 | l[9541] << 24), f = l[9534] | l[9535] << 8 | (l[9536] << 16 | l[9537] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 0, k + 4 | 0), o[k + 15 | 0] >= 0) break i;
                                    X(i[k + 4 >> 2]);
                                    break i;
                                }
                                f = i[r + 100 >> 2], n = i[r + 104 >> 2] - f | 0;
                                e: {
                                    if (n >>> 0 < t >>> 0) {
                                        r1(r + 100 | 0, t - n | 0), f = i[r + 100 >> 2];
                                        break e;
                                    }
                                    if (t >>> 0 >= n >>> 0) break e;
                                    i[r + 104 >> 2] = f + t;
                                }
                                if (Y6(e, f, t), l[e + 20 | 0] == 1) {
                                    if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, i0(A, 2, 100, k + 4 | 0), o[k + 15 | 0] >= 0) break i;
                                    X(i[k + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 16 | 0;
                        }
                        function l4(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            w = m - 112 | 0, m = w, h = s & 2147483647;
                            i: {
                                e: {
                                    if (_ = k & 2147483647, v = 2147418112, B = !(r | e), !(f | _ ? _ - v >>> 0 < 2147549184 : B) && (V = h - v | 0, !u & (V | 0) == -2147418112 ? n | t : (V | 0) == -2147418112 & (u | 0) != 0 | V >>> 0 > 2147549184)) break e;
                                    if (!(!f & (_ | 0) == 2147418112 ? B : _ >>> 0 < 2147418112)) {
                                        u = f, s = k | 32768, n = r, t = e;
                                        break i;
                                    }
                                    if (!(!u & (h | 0) == 2147418112 ? !(n | t) : h >>> 0 < 2147418112)) {
                                        s = s | 32768;
                                        break i;
                                    }
                                    if (!(r | f | (_ ^ 2147418112 | e))) {
                                        h = f, f = !(r ^ n | f ^ u | (e ^ t | k ^ s ^ -2147483648)), u = f ? 0 : h, s = f ? 2147450880 : k, n = f ? 0 : r, t = f ? 0 : e;
                                        break i;
                                    }
                                    if (v = n | u, !(v | (h ^ 2147418112 | t))) break i;
                                    if (!(r | f | (e | _))) {
                                        if (t | h | v) break i;
                                        n = r & n, t = e & t, u = f & u, s = k & s;
                                        break i;
                                    }
                                    if (n | u | (t | h)) break e;
                                    n = r, t = e, u = f, s = k;
                                    break i;
                                }
                                v = (h | 0) == (_ | 0), W = v & (f | 0) == (u | 0) ? (e | 0) == (t | 0) & r >>> 0 < n >>> 0 | e >>> 0 < t >>> 0 : v & f >>> 0 < u >>> 0 | h >>> 0 > _ >>> 0, B = W, _ = B ? n : r, V = B ? t : e, v = B ? s : k, y = v, B = B ? u : f, C = v & 65535, h = W ? f : u, v = W ? k : s, f = v, v = f >>> 16 & 32767, G = y >>> 16 & 32767, G || (G = !(B | C), u = G, G = u << 6, F = e1(u ? _ : B) + 32 | 0, u = e1(u ? V : C), G = G + ((u | 0) == 32 ? F : u) | 0, P1(w + 96 | 0, _, V, B, C, G - 15 | 0), B = i[w + 104 >> 2], C = i[w + 108 >> 2], V = i[w + 100 >> 2], G = 16 - G | 0, _ = i[w + 96 >> 2]), n = W ? r : n, t = W ? e : t, r = h, e = f & 65535, v || (h = !(r | e), W = h, f = h ? n : r, h = h << 6, W = e1(W ? t : e), h = h + ((W | 0) == 32 ? e1(f) + 32 | 0 : W) | 0, P1(w + 80 | 0, n, t, r, e, h - 15 | 0), v = 16 - h | 0, n = i[w + 80 >> 2], t = i[w + 84 >> 2], r = i[w + 88 >> 2], e = i[w + 92 >> 2]), f = e << 3, e = r, r = f | r >>> 29, h = e << 3, e = r, r = t >>> 29 | h, e = e | 524288, h = C << 3 | B >>> 29, C = B << 3 | V >>> 29, W = h, u = k ^ s, h = t << 3 | n >>> 29, f = n << 3;
                                e: {
                                    if ((v | 0) == (G | 0)) break e;
                                    if (k = G - v | 0, k >>> 0 > 127) {
                                        r = 0, e = 0, h = 0, f = 1;
                                        break e;
                                    }
                                    P1(w - -64 | 0, f, h, r, e, 128 - k | 0), d8(w + 48 | 0, f, h, r, e, k), r = i[w + 56 >> 2], e = i[w + 60 >> 2], h = i[w + 52 >> 2], f = i[w + 48 >> 2] | (i[w + 64 >> 2] | i[w + 72 >> 2] | (i[w + 68 >> 2] | i[w + 76 >> 2])) != 0;
                                }
                                B = f, v = h, W = W | 524288, h = V << 3 | _ >>> 29, _ = _ << 3;
                                e: {
                                    if ((u | 0) < 0) {
                                        if (n = 0, t = 0, u = 0, s = 0, !(_ ^ B | r ^ C | (h ^ v | e ^ W))) break i;
                                        if (f = _ - B | 0, k = h - ((_ >>> 0 < B >>> 0) + v | 0) | 0, n = C - r | 0, t = (h | 0) == (v | 0) & _ >>> 0 < B >>> 0 | h >>> 0 < v >>> 0, u = n - t | 0, r = (W - ((r >>> 0 > C >>> 0) + e | 0) | 0) - (n >>> 0 < t >>> 0) | 0, s = r, r >>> 0 > 524287) break e;
                                        e = !(r | u), t = e, s = e ? f : u, e = e << 6, t = e1(t ? k : r), e = e + ((t | 0) == 32 ? e1(s) + 32 | 0 : t) | 0, n = r, r = e - 12 | 0, P1(w + 32 | 0, f, k, u, n, r), G = G - r | 0, u = i[w + 40 >> 2], s = i[w + 44 >> 2], f = i[w + 32 >> 2], k = i[w + 36 >> 2];
                                        break e;
                                    }
                                    if (h = h + v | 0, f = _ + B | 0, k = f >>> 0 < _ >>> 0 ? h + 1 | 0 : h, n = (v | 0) == (k | 0) & f >>> 0 < B >>> 0 | k >>> 0 < v >>> 0, h = e + W | 0, r = r + C | 0, h = r >>> 0 < C >>> 0 ? h + 1 | 0 : h, u = r + n | 0, s = u >>> 0 < r >>> 0 ? h + 1 | 0 : h, !(s & 1048576)) break e;
                                    f = B & 1 | ((k & 1) << 31 | f >>> 1), k = u << 31 | k >>> 1, G = G + 1 | 0, u = (s & 1) << 31 | u >>> 1, s = s >>> 1 | 0;
                                }
                                if (n = 0, r = y & -2147483648, _ = r, (G | 0) >= 32767) {
                                    u = n, s = r | 2147418112, t = 0;
                                    break i;
                                }
                                v = 0;
                                e: {
                                    if ((G | 0) > 0) {
                                        v = G;
                                        break e;
                                    }
                                    P1(w + 16 | 0, f, k, u, s, G + 127 | 0), d8(w, f, k, u, s, 1 - G | 0), f = i[w >> 2] | (i[w + 16 >> 2] | i[w + 24 >> 2] | (i[w + 20 >> 2] | i[w + 28 >> 2])) != 0, k = i[w + 4 >> 2], u = i[w + 8 >> 2], s = i[w + 12 >> 2];
                                }
                                e = (k & 7) << 29 | f >>> 3, r = u << 29 | k >>> 3, k = n | ((s & 7) << 29 | u >>> 3), n = _ | (s >>> 3 & 65535 | v << 16);
                                e: {
                                    r: {
                                        if (f = f & 7, (f | 0) != 4) {
                                            s = n, n = f >>> 0 > 4, t = n, n = e + n | 0, t = t >>> 0 > n >>> 0 ? r + 1 | 0 : r, r = (t | 0) == (r | 0) & e >>> 0 > n >>> 0 | r >>> 0 > t >>> 0, u = r + k | 0, s = r >>> 0 > u >>> 0 ? s + 1 | 0 : s;
                                            break r;
                                        }
                                        h = n, f = e & 1, n = e + f | 0, t = f >>> 0 > n >>> 0 ? r + 1 | 0 : r, r = (t | 0) == (r | 0) & e >>> 0 > n >>> 0 | r >>> 0 > t >>> 0, u = r + k | 0, s = r >>> 0 > u >>> 0 ? h + 1 | 0 : h;
                                        break e;
                                    }
                                    if (!f) break i;
                                }
                            }
                            i[A >> 2] = n, i[A + 4 >> 2] = t, i[A + 8 >> 2] = u, i[A + 12 >> 2] = s, m = w + 112 | 0;
                        }
                        function Iw(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            B = m - 32 | 0, m = B, _ = B + 20 | 0, r = i[A + 388 >> 2], s = ((r + i[A + 380 >> 2] | 0) - 1 >>> 0) / (r >>> 0) | 0, r = i[A + 384 >> 2], r = Z(s, ((r + i[A + 376 >> 2] | 0) - 1 >>> 0) / (r >>> 0) | 0), e = l[A + 398 | 0];
                            i: {
                                if (!e || (r = Z(r, i[A + 400 >> 2]), e = e - 1 | 0, !e) || (r = Z(r, i[A + 404 >> 2]), (e | 0) == 1) || (r = Z(r, i[A + 408 >> 2]), (e | 0) == 2) || (r = Z(r, i[A + 412 >> 2]), (e | 0) == 3) || (r = Z(r, i[A + 416 >> 2]), (e | 0) == 4) || (r = Z(r, i[A + 420 >> 2]), (e | 0) == 5) || (r = Z(r, i[A + 424 >> 2]), (e | 0) == 6)) break i;
                                r = Z(r, i[A + 428 >> 2]);
                            }
                            if (e = l[A + 397 | 0], f = l[A + 396 | 0], i[_ + 8 >> 2] = 0, i[_ >> 2] = 0, i[_ + 4 >> 2] = 0, r = Z(r, e + f >>> 3 | 0), r && r1(_, r), h = i[A + 436 >> 2], W = i[A + 440 >> 2], (h | 0) != (W | 0)) for(;;){
                                r = l[A + 396 | 0], w = r >>> 3 | 0;
                                i: {
                                    if (r >>> 0 < 8) break i;
                                    if (t = i[h >> 2], f = i[h + 4 >> 2], y = w & 1, C = i[_ >> 2] + v | 0, r = 0, e = 0, (w | 0) != 1) for(F = w & 30, n = 0, k = 0; G = w + (r ^ 536870910) << 3, u = G & 31, s = r + C | 0, (G & 63) >>> 0 >= 32 ? V = f >>> u | 0 : V = ((1 << u) - 1 & f) << 32 - u | t >>> u, o[s + 1 | 0] = V, V = s, s = t, G = w + (r ^ -1) << 3, u = G & 31, (G & 63) >>> 0 >= 32 ? s = f >>> u | 0 : s = ((1 << u) - 1 & f) << 32 - u | s >>> u, o[V | 0] = s, r = r + 2 | 0, e = r >>> 0 < 2 ? e + 1 | 0 : e, n = n + 2 | 0, k = n >>> 0 < 2 ? k + 1 | 0 : k, !!((n | 0) != (F | 0) | k););
                                    if (!y) break i;
                                    s = r + C | 0, k = t, e = w + (r ^ -1) << 3, r = e & 31, (e & 63) >>> 0 >= 32 ? r = f >>> r | 0 : r = ((1 << r) - 1 & f) << 32 - r | k >>> r, o[s | 0] = r;
                                }
                                if (v = w + v | 0, r = l[A + 397 | 0], r) {
                                    e = r >>> 3 | 0;
                                    i: {
                                        if (r >>> 0 < 8) break i;
                                        if (f = i[h + 8 >> 2], t = i[_ >> 2] + v | 0, n = 0, r = 0, e - 1 >>> 0 >= 3) for(u = e & 28, w = 0; k = r + t | 0, o[k + 1 | 0] = f >>> (e + (r ^ 536870910) << 3), o[k | 0] = f >>> (e + (r ^ -1) << 3), o[k + 2 | 0] = f >>> (e + (r ^ 536870909) << 3), o[k + 3 | 0] = f >>> (e + (r ^ 536870908) << 3), r = r + 4 | 0, w = w + 4 | 0, (u | 0) != (w | 0););
                                        if (k = e & 3, !k) break i;
                                        for(; o[r + t | 0] = f >>> (e + (r ^ -1) << 3), r = r + 1 | 0, n = n + 1 | 0, (k | 0) != (n | 0););
                                    }
                                    v = e + v | 0;
                                }
                                if (h = h + 16 | 0, (W | 0) == (h | 0)) break;
                            }
                            i[A + 448 >> 2] = i[_ + 4 >> 2] - i[_ >> 2], r = i[A + 20 >> 2], i[B + 12 >> 2] = i[r + 48 >> 2], r = i[r + 52 >> 2], i[B + 16 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), v = i[A + 36 >> 2], r = 0, e = 0, k = 0, t = 0, h = m - 32 | 0, m = h, w = h + 12 | 0, A = i[i[B + 12 >> 2] + 68 >> 2], f = i[A + 108 >> 2], n = i[A + 104 >> 2];
                            i: {
                                if ((f | 0) == (n | 0)) {
                                    A = 0;
                                    break i;
                                }
                                for(A = f - n >> 5, f = A >>> 0 <= 1 ? 1 : A, A = 0;;){
                                    if ((v | 0) == i[n + (A << 5) >> 2]) break i;
                                    if (A = A + 1 | 0, (f | 0) == (A | 0)) break;
                                }
                                A = f;
                            }
                            f = n + (A << 5) | 0, A = i[f + 16 >> 2], C = i[f + 20 >> 2];
                            i: {
                                if ((A | 0) == (C | 0)) break i;
                                for(;;){
                                    G = i[A + 24 >> 2], n = i[A + 28 >> 2] - G | 0;
                                    e: {
                                        if (!e & r >>> 0 >= n >>> 0 | e) {
                                            f = r - n | 0, e = e - (r >>> 0 < n >>> 0) | 0;
                                            break e;
                                        }
                                        W = i[_ >> 2], f = i[_ + 4 >> 2] - W | 0, v = f - k | 0, s = v, u = n - r | 0, e = 0 - ((r >>> 0 > n >>> 0) + e | 0) | 0, f = 0 - ((f >>> 0 < k >>> 0) + t | 0) | 0, v = (e | 0) == (f | 0) & u >>> 0 > v >>> 0 | e >>> 0 > f >>> 0, n = v ? s : u, v0(r + G | 0, k + W | 0, n), t = t + (v ? f : e) | 0, r = k, k = k + n | 0, t = r >>> 0 > k >>> 0 ? t + 1 | 0 : t, f = 0, e = 0;
                                    }
                                    if (r = f, !t & (i[_ + 4 >> 2] - i[_ >> 2] | 0) == (k | 0)) break i;
                                    if (A = A + 40 | 0, (C | 0) == (A | 0)) break;
                                }
                            }
                            r = i[21669], A = w, i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[h + 31 | 0] < 0 && X(i[h + 20 >> 2]), m = h + 32 | 0, A = i[B + 16 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[B + 20 >> 2], A && (i[B + 24 >> 2] = A, X(A)), m = B + 32 | 0;
                        }
                        function a7(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                e: {
                                    if (s = i[r + 104 >> 2], B = i[r + 108 >> 2], (s | 0) != (B | 0)) for(v = n + 24 | 0;;){
                                        if (i[n + 20 >> 2] = v, i[n + 24 >> 2] = 0, w = 0, h = i[s + 44 >> 2], G = i[s + 48 >> 2], (h | 0) == (G | 0)) r = 0;
                                        else {
                                            for(;;){
                                                u = i[h >> 2], f = i[n + 24 >> 2], k = f, e = v, t = e, r = e;
                                                r: {
                                                    A: {
                                                        if (!f) break A;
                                                        for(; t = e, r = k, _ = u >>> 0 > k0[r + 16 >> 2], e = _ ? e : r, k = i[(_ << 2) + r >> 2], !!k;);
                                                        if ((e | 0) != (v | 0) & u >>> 0 >= k0[(_ ? t : r) + 16 >> 2]) break e;
                                                        for(;;){
                                                            if (r = f, e = i[r + 16 >> 2], e >>> 0 > u >>> 0) {
                                                                if (t = r, f = i[r >> 2], f) continue;
                                                                break A;
                                                            }
                                                            if (e >>> 0 >= u >>> 0) break r;
                                                            if (f = i[r + 4 >> 2], !f) break;
                                                        }
                                                        t = r + 4 | 0;
                                                    }
                                                    e = D(20), i[e + 8 >> 2] = r, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 16 >> 2] = u, i[t >> 2] = e, r = i[i[n + 20 >> 2] >> 2], r && (i[n + 20 >> 2] = r, e = i[t >> 2]), t = i[n + 24 >> 2], r = (t | 0) == (e | 0), o[e + 12 | 0] = r;
                                                    A: {
                                                        if (r) break A;
                                                        for(;;){
                                                            if (f = i[e + 8 >> 2], l[f + 12 | 0]) break A;
                                                            f: {
                                                                if (r = i[f + 8 >> 2], k = i[r >> 2], (f | 0) == (k | 0)) {
                                                                    if (u = i[r + 4 >> 2], !(!u | l[u + 12 | 0] == 1)) {
                                                                        e = u + 12 | 0;
                                                                        break f;
                                                                    }
                                                                    k: {
                                                                        if (i[f >> 2] == (e | 0)) {
                                                                            e = f;
                                                                            break k;
                                                                        }
                                                                        e = i[f + 4 >> 2], k = i[e >> 2], i[f + 4 >> 2] = k, t = f, k && (i[k + 8 >> 2] = f, r = i[f + 8 >> 2], t = i[r >> 2]), i[e + 8 >> 2] = r, i[(((f | 0) != (t | 0)) << 2) + r >> 2] = e, i[e >> 2] = f, i[f + 8 >> 2] = e, r = i[e + 8 >> 2], k = i[r >> 2];
                                                                    }
                                                                    o[e + 12 | 0] = 1, o[r + 12 | 0] = 0, e = i[k + 4 >> 2], i[r >> 2] = e, e && (i[e + 8 >> 2] = r), e = i[r + 8 >> 2], i[k + 8 >> 2] = e, i[e + ((i[e >> 2] != (r | 0)) << 2) >> 2] = k, i[k + 4 >> 2] = r, i[r + 8 >> 2] = k;
                                                                    break A;
                                                                }
                                                                if (!(!k | l[k + 12 | 0] == 1)) {
                                                                    e = k + 12 | 0;
                                                                    break f;
                                                                }
                                                                k = i[f >> 2];
                                                                k: {
                                                                    if ((k | 0) != (e | 0)) {
                                                                        k = f;
                                                                        break k;
                                                                    }
                                                                    e = i[k + 4 >> 2], i[f >> 2] = e, e && (i[e + 8 >> 2] = f, r = i[f + 8 >> 2]), i[k + 8 >> 2] = r, i[(((f | 0) != i[r >> 2]) << 2) + r >> 2] = k, i[k + 4 >> 2] = f, i[f + 8 >> 2] = k, r = i[k + 8 >> 2];
                                                                }
                                                                o[k + 12 | 0] = 1, o[r + 12 | 0] = 0, e = i[r + 4 >> 2], f = i[e >> 2], i[r + 4 >> 2] = f, f && (i[f + 8 >> 2] = r), f = i[r + 8 >> 2], i[e + 8 >> 2] = f, i[f + ((i[f >> 2] != (r | 0)) << 2) >> 2] = e, i[e >> 2] = r, i[r + 8 >> 2] = e;
                                                                break A;
                                                            }
                                                            if (o[f + 12 | 0] = 1, o[r + 12 | 0] = (r | 0) == (t | 0), o[e | 0] = 1, e = r, (r | 0) == (t | 0)) break;
                                                        }
                                                    }
                                                    w = w + 1 | 0;
                                                }
                                                if (h = h + 4 | 0, (G | 0) == (h | 0)) break;
                                            }
                                            r = i[n + 24 >> 2];
                                        }
                                        if (i[n + 28 >> 2] = w, T8(n + 20 | 0, r), s = s + 56 | 0, (B | 0) == (s | 0)) break;
                                    }
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                i[n + 28 >> 2] = w, r = D(32), i[n + 8 >> 2] = r, i[n + 12 >> 2] = 28, i[n + 16 >> 2] = -2147483616, e = l[4955] | l[4956] << 8 | (l[4957] << 16 | l[4958] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, e = l[4951] | l[4952] << 8 | (l[4953] << 16 | l[4954] << 24), f = l[4947] | l[4948] << 8 | (l[4949] << 16 | l[4950] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[4943] | l[4944] << 8 | (l[4945] << 16 | l[4946] << 24), f = l[4939] | l[4940] << 8 | (l[4941] << 16 | l[4942] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[4935] | l[4936] << 8 | (l[4937] << 16 | l[4938] << 24), f = l[4931] | l[4932] << 8 | (l[4933] << 16 | l[4934] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 28 | 0] = 0, i0(A, 2, 0, n + 8 | 0), o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]), T8(n + 20 | 0, i[n + 24 >> 2]);
                            }
                            m = n + 32 | 0;
                        }
                        function ve(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            s = m - 32 | 0, m = s, i[s + 28 >> 2] = 0, i[s + 20 >> 2] = 0, i[s + 24 >> 2] = 0, F4(s, i[r >> 2], e, s + 20 | 0);
                            i: {
                                e: {
                                    if (i[s >> 2] || (e = i[s + 20 >> 2], t = i[s + 24 >> 2], (e | 0) == (t | 0))) break e;
                                    for(;;){
                                        r: {
                                            if (u = i[e >> 2], !u || (u = E0(u, 73632, 73656), !u)) break r;
                                            e = i[e + 4 >> 2];
                                            A: {
                                                if (!e) {
                                                    t = i[u + 108 >> 2], u = i[u + 104 >> 2];
                                                    break A;
                                                }
                                                if (n = i[e + 4 >> 2], v = n + 1 | 0, i[e + 4 >> 2] = v, t = i[u + 108 >> 2], u = i[u + 104 >> 2], i[e + 4 >> 2] = n, v) break A;
                                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            }
                                            if (!u | !t) break e;
                                            if (i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, n0[A + 24 >> 3] = +(t >>> 0) / +(k | 0), n0[A >> 3] = +(u >>> 0) / +(f | 0), e = i[s + 20 >> 2], v = i[s + 24 >> 2], (e | 0) == (v | 0)) break i;
                                            for(;;){
                                                f = i[e >> 2], k = i[f + 16 >> 2];
                                                A: {
                                                    f: {
                                                        if ((k | 0) != 1668047216) {
                                                            if ((k | 0) != 1769107316) {
                                                                if ((k | 0) != 1768778098) break A;
                                                                k = 0, n = E0(f, 73632, 74856);
                                                                k: {
                                                                    if (!n || (f = i[e + 4 >> 2], !f)) break k;
                                                                    i[f + 4 >> 2] = i[f + 4 >> 2] + 1, k = f;
                                                                }
                                                                if (f = i[n + 100 >> 2], n = (((f | 0) != 1) << 4) + A | 0, n0[n >> 3] = -n0[n >> 3], f = (f | 0) == 1, n = (f ? 8 : 24) + A | 0, n0[n >> 3] = -n0[n >> 3], n = (f ? 32 : 40) + A | 0, n0[n >> 3] = +((f ? u : t) - 1 >>> 0) - n0[n >> 3], !k) break A;
                                                                if (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, !f) break f;
                                                                break A;
                                                            }
                                                            k = 0, n = E0(f, 73632, 74784);
                                                            k: {
                                                                if (!n || (f = i[e + 4 >> 2], !f)) break k;
                                                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1, k = f;
                                                            }
                                                            f = i[n + 100 >> 2];
                                                            k: {
                                                                n: {
                                                                    t: {
                                                                        if ((f | 0) != 270) {
                                                                            if ((f | 0) != 180) {
                                                                                if ((f | 0) != 90) {
                                                                                    f = t;
                                                                                    break k;
                                                                                }
                                                                                h = n0[A + 32 >> 3], n0[A + 32 >> 3] = n0[A + 40 >> 3], _ = n0[A + 8 >> 3], n0[A + 8 >> 3] = n0[A + 24 >> 3], B = n0[A >> 3], n0[A >> 3] = n0[A + 16 >> 3], n0[A + 24 >> 3] = -_, n0[A + 16 >> 3] = -B, h = +(u >>> 0) - h + -1;
                                                                                break t;
                                                                            }
                                                                            n0[A >> 3] = -n0[A >> 3], n0[A + 8 >> 3] = -n0[A + 8 >> 3], n0[A + 16 >> 3] = -n0[A + 16 >> 3], n0[A + 24 >> 3] = -n0[A + 24 >> 3], n0[A + 32 >> 3] = +(u - 1 >>> 0) - n0[A + 32 >> 3], h = +(t - 1 >>> 0) - n0[A + 40 >> 3], f = t;
                                                                            break n;
                                                                        }
                                                                        h = n0[A + 24 >> 3], n0[A + 24 >> 3] = n0[A + 8 >> 3], _ = n0[A + 16 >> 3], n0[A + 16 >> 3] = n0[A >> 3], n0[A + 8 >> 3] = -h, n0[A >> 3] = -_, h = n0[A + 32 >> 3], n0[A + 32 >> 3] = +(t >>> 0) - n0[A + 40 >> 3] + -1;
                                                                    }
                                                                    f = u, u = t;
                                                                }
                                                                n0[A + 40 >> 3] = h;
                                                            }
                                                            if (!k) {
                                                                t = f;
                                                                break A;
                                                            }
                                                            if (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, t = f, !n) break f;
                                                            break A;
                                                        }
                                                        k = 0, n = E0(f, 73632, 74928);
                                                        k: {
                                                            if (!n || (f = i[e + 4 >> 2], !f)) break k;
                                                            i[f + 4 >> 2] = i[f + 4 >> 2] + 1, k = f;
                                                        }
                                                        if (f = oi(n, u), t = ti(n, t), n0[A + 32 >> 3] = n0[A + 32 >> 3] - +(f | 0), n0[A + 40 >> 3] = n0[A + 40 >> 3] - +(t | 0), f = i[n + 100 >> 2], t = i[n + 104 >> 2], w = (t | 0) / 2 | 0, u = f + w | 0, f = (f >> 31) + (w >> 31) | 0, u = m2(u, u >>> 0 < w >>> 0 ? f + 1 | 0 : f, t, t >> 31), f = i[n + 108 >> 2], t = i[n + 112 >> 2], w = (t | 0) / 2 | 0, n = f + w | 0, f = (f >> 31) + (w >> 31) | 0, t = m2(n, n >>> 0 < w >>> 0 ? f + 1 | 0 : f, t, t >> 31), !k || (f = i[k + 4 >> 2], i[k + 4 >> 2] = f - 1, f)) break A;
                                                    }
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                if (e = e + 8 | 0, (v | 0) == (e | 0)) break;
                                            }
                                            break i;
                                        }
                                        if (e = e + 8 | 0, (t | 0) == (e | 0)) break;
                                    }
                                }
                                i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 1072693248, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 1072693248, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0;
                            }
                            if (o[s + 19 | 0] < 0 && X(i[s + 8 >> 2]), f = i[s + 20 >> 2], f) {
                                if (A = f, e = i[s + 24 >> 2], (A | 0) != (e | 0)) {
                                    for(;;){
                                        A = i[e - 4 >> 2];
                                        i: {
                                            if (!A || (k = i[A + 4 >> 2], i[A + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (e = e - 8 | 0, (f | 0) == (e | 0)) break;
                                    }
                                    A = i[s + 20 >> 2];
                                }
                                i[s + 24 >> 2] = f, X(A);
                            }
                            A = i[r + 4 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = s + 32 | 0;
                        }
                        function Fw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 2709);
                                    break i;
                                }
                                i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, Q[r + 116 >> 1] = 1, i[r + 112 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 152 >> 2] = 0, i[r + 156 >> 2] = 0, i[r + 144 >> 2] = 0, i[r + 148 >> 2] = 1072693248, i[r + 128 >> 2] = 0, i[r + 132 >> 2] = 0, i[r + 136 >> 2] = 0, i[r + 140 >> 2] = 0, i[r + 160 >> 2] = 0, i[r + 164 >> 2] = 0, i[r + 168 >> 2] = 0, i[r + 172 >> 2] = 0, i[r + 176 >> 2] = 0, k = i[r + 100 >> 2], k & 1 && (o[r + 184 | 0] = 1, v = r, _ = n2(e), i[v + 104 >> 2] = _, k = i[r + 100 >> 2]), k & 2 && (o[r + 185 | 0] = 1, v = r, _ = n2(e), i[v + 108 >> 2] = _, k = i[r + 100 >> 2]), k & 4 && (o[r + 186 | 0] = 1, v = r, _ = n2(e), i[v + 112 >> 2] = _, k = i[r + 100 >> 2]);
                                e: {
                                    if (!(k & 8)) break e;
                                    o[r + 187 | 0] = 1;
                                    r: {
                                        A: switch(l[r + 97 | 0]){
                                            case 0:
                                                s = k & 16;
                                                f: {
                                                    if (s) {
                                                        k = n2(e), h = n2(e), w = n2(e);
                                                        break f;
                                                    }
                                                    k = vA(e), h = vA(e), w = vA(e);
                                                }
                                                if (o[r + 116 | 0] = 1, n = +(16384 << s >>> 0), t = +(w | 0) / n, n0[r + 136 >> 3] = t, u = +(h | 0) / n, n0[r + 128 >> 3] = u, n = +(k | 0) / n, n0[r + 120 >> 3] = n, n = t * t + (n * n + u * u), !(n > 1)) break r;
                                                if (r = D(48), i[f + 20 >> 2] = r, i[f + 24 >> 2] = 47, i[f + 28 >> 2] = -2147483600, e = l[2660] | l[2661] << 8 | (l[2662] << 16 | l[2663] << 24), k = l[2656] | l[2657] << 8 | (l[2658] << 16 | l[2659] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 47 | 0] = 0, e = l[2699] | l[2700] << 8 | (l[2701] << 16 | l[2702] << 24), k = l[2695] | l[2696] << 8 | (l[2697] << 16 | l[2698] << 24), o[r + 39 | 0] = k, o[r + 40 | 0] = k >>> 8, o[r + 41 | 0] = k >>> 16, o[r + 42 | 0] = k >>> 24, o[r + 43 | 0] = e, o[r + 44 | 0] = e >>> 8, o[r + 45 | 0] = e >>> 16, o[r + 46 | 0] = e >>> 24, e = l[2692] | l[2693] << 8 | (l[2694] << 16 | l[2695] << 24), k = l[2688] | l[2689] << 8 | (l[2690] << 16 | l[2691] << 24), o[r + 32 | 0] = k, o[r + 33 | 0] = k >>> 8, o[r + 34 | 0] = k >>> 16, o[r + 35 | 0] = k >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[2684] | l[2685] << 8 | (l[2686] << 16 | l[2687] << 24), k = l[2680] | l[2681] << 8 | (l[2682] << 16 | l[2683] << 24), o[r + 24 | 0] = k, o[r + 25 | 0] = k >>> 8, o[r + 26 | 0] = k >>> 16, o[r + 27 | 0] = k >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[2676] | l[2677] << 8 | (l[2678] << 16 | l[2679] << 24), k = l[2672] | l[2673] << 8 | (l[2674] << 16 | l[2675] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[2668] | l[2669] << 8 | (l[2670] << 16 | l[2671] << 24), k = l[2664] | l[2665] << 8 | (l[2666] << 16 | l[2667] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 0, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                                X(i[f + 20 >> 2]);
                                                break i;
                                            case 1:
                                                break A;
                                            default:
                                                break e;
                                        }
                                        v = r, B = +(n2(e) | 0) * 152587890625e-16, n0[v + 152 >> 3] = B, v = r, B = +(n2(e) | 0) * 152587890625e-16, n0[v + 160 >> 3] = B, v = r, B = +(n2(e) | 0) * 152587890625e-16, n0[v + 168 >> 3] = B;
                                        break e;
                                    }
                                    n0[r + 144 >> 3] = Hs(1 - n);
                                }
                                if (l[r + 100 | 0] & 32 && (o[r + 188 | 0] = 1, v = r, _ = n2(e), i[v + 176 >> 2] = _), l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function Yw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            k = m - 176 | 0, m = k, z1(k + 156 | 0, r, e), o[k + 175 | 0] < 0 && X(i[k + 164 >> 2]);
                            i: {
                                if (l[r + 97 | 0] >= 2) {
                                    s4(A, r, 15630);
                                    break i;
                                }
                                _ = n2(e);
                                e: {
                                    if (n = i[f + 28 >> 2], !(n >>> 0 < _ >>> 0 && n)) {
                                        if (!_) break e;
                                        for(C = r + 104 | 0;;){
                                            if (l[e + 20 | 0] | !i[e + 16 >> 2]) break e;
                                            i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0;
                                            r: {
                                                if (!l[r + 97 | 0]) {
                                                    f = B2(e);
                                                    break r;
                                                }
                                                f = n2(e);
                                            }
                                            i[k + 12 >> 2] = f, B = 0;
                                            r: {
                                                if (G = X2(e), !G) break r;
                                                A: {
                                                    for(;;){
                                                        f: {
                                                            if (o[r + 100 | 0] & 1) {
                                                                f = B2(e), h = f & 32767, u = f >>> 15 | 0;
                                                                break f;
                                                            }
                                                            f = X2(e), h = f & 127, u = f >>> 7 | 0;
                                                        }
                                                        f: {
                                                            f = i[k + 20 >> 2], n = i[k + 24 >> 2];
                                                            k: {
                                                                if (f >>> 0 < n >>> 0) {
                                                                    n = h << 16 | u, Q[f >> 1] = n, Q[f + 2 >> 1] = n >>> 16, h = f + 4 | 0;
                                                                    break k;
                                                                }
                                                                if (w = i[k + 16 >> 2], v = f - w >> 2, s = v + 1 | 0, s >>> 0 >= 1073741824) break f;
                                                                if (t = n - w | 0, n = t >> 1, s = t >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 > s >>> 0 ? n : s, s) {
                                                                    if (s >>> 0 >= 1073741824) break A;
                                                                    t = D(s << 2);
                                                                } else t = 0;
                                                                if (n = t + (v << 2) | 0, u = h << 16 | u, Q[n >> 1] = u, Q[n + 2 >> 1] = u >>> 16, h = n + 4 | 0, (f | 0) != (w | 0)) {
                                                                    for(; n = n - 4 | 0, f = f - 4 | 0, u = I[f >> 1] | I[f + 2 >> 1] << 16, Q[n >> 1] = u, Q[n + 2 >> 1] = u >>> 16, (f | 0) != (w | 0););
                                                                    w = i[k + 16 >> 2];
                                                                }
                                                                if (i[k + 24 >> 2] = t + (s << 2), i[k + 20 >> 2] = h, i[k + 16 >> 2] = n, !w) break k;
                                                                X(w);
                                                            }
                                                            if (i[k + 20 >> 2] = h, B = B + 1 | 0, (G | 0) == (B | 0)) break r;
                                                            continue;
                                                        }
                                                        break;
                                                    }
                                                    p0(), z();
                                                }
                                                Z2(), z();
                                            }
                                            r: {
                                                f = i[r + 108 >> 2];
                                                A: {
                                                    if (f >>> 0 < k0[r + 112 >> 2]) {
                                                        if (n = i[k + 12 >> 2], i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = n, n = i[k + 20 >> 2], t = i[k + 16 >> 2], (n | 0) != (t | 0)) {
                                                            if (v = n - t | 0, (v | 0) < 0) break r;
                                                            u = D(v), i[f + 8 >> 2] = u, i[f + 4 >> 2] = u, n = u + v | 0, i[f + 12 >> 2] = n, v0(u, t, v), i[f + 8 >> 2] = n;
                                                        }
                                                        f = f + 16 | 0;
                                                        break A;
                                                    }
                                                    f = L5(C, k + 12 | 0);
                                                }
                                                if (i[r + 108 >> 2] = f, f = i[k + 16 >> 2], f && (i[k + 20 >> 2] = f, X(f)), W = W + 1 | 0, (_ | 0) != (W | 0)) continue;
                                                break e;
                                            }
                                            break;
                                        }
                                        p0(), z();
                                    }
                                    i[k + 20 >> 2] = 59808, i[k + 76 >> 2] = 59828, r = i[14961], i[k + 12 >> 2] = r, e = i[r - 12 >> 2], t = k + 12 | 0, r = t, i[e + r >> 2] = i[14962], i[k + 16 >> 2] = 0, r = r + i[i[k + 12 >> 2] - 12 >> 2] | 0, n = k + 24 | 0, T0(r, n), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[k + 20 >> 2] = r, e = k + 20 | 0, i[e + i[r - 12 >> 2] >> 2] = i[14964], r = i[14960], i[k + 12 >> 2] = r, i[t + i[r - 12 >> 2] >> 2] = i[14965], i[k + 76 >> 2] = 59828, i[k + 12 >> 2] = 59788, i[k + 20 >> 2] = 59808, t = z0(n), i[t >> 2] = 58864, r = k - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 72 >> 2] = 24, U(M0(U(M0(U(e, 21535, 40), _), 21683, 47), i[f + 28 >> 2]), 4374, 6), r = i[k + 72 >> 2];
                                    r: {
                                        A: {
                                            if (r & 16) {
                                                n = k + 44 | 0, r = i[k + 68 >> 2], e = i[k + 48 >> 2], r >>> 0 < e >>> 0 && (i[k + 68 >> 2] = e, r = e);
                                                break A;
                                            }
                                            if (!(r & 8)) {
                                                f = 0, o[k + 11 | 0] = 0, n = k;
                                                break r;
                                            }
                                            n = k + 32 | 0, r = i[k + 40 >> 2];
                                        }
                                        A: {
                                            if (e = i[n >> 2], f = r - e | 0, f >>> 0 < 2147483640) {
                                                if (f >>> 0 >= 11) {
                                                    r = (f | 7) + 1 | 0, n = D(r), i[k + 8 >> 2] = r | -2147483648, i[k >> 2] = n, i[k + 4 >> 2] = f;
                                                    break A;
                                                }
                                                if (o[k + 11 | 0] = f, n = k, f) break A;
                                                f = 0;
                                                break r;
                                            }
                                            Y0(), z();
                                        }
                                        Q0(n, e, f);
                                    }
                                    o[f + n | 0] = 0, i0(A, 2, 1e3, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), A = i[14959], i[k + 12 >> 2] = A, i[i[A - 12 >> 2] + (k + 12 | 0) >> 2] = i[14967], i[k + 20 >> 2] = i[14968], i[t >> 2] = 58864, o[k + 67 | 0] < 0 && X(i[k + 56 >> 2]), x0(t), N0(k + 76 | 0);
                                    break i;
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[k + 12 | 0] = 0, o[k + 23 | 0] = 0, i0(A, 2, 100, k + 12 | 0), o[k + 23 | 0] >= 0) break i;
                                    X(i[k + 12 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            m = k + 176 | 0;
                        }
                        function X(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                if (!A) break i;
                                f = A - 8 | 0, r = i[A - 4 >> 2], A = r & -8, n = f + A | 0;
                                e: {
                                    if (r & 1) break e;
                                    if (!(r & 2) || (r = i[f >> 2], f = f - r | 0, f >>> 0 < k0[26382])) break i;
                                    A = A + r | 0;
                                    r: {
                                        A: {
                                            f: {
                                                if (i[26383] != (f | 0)) {
                                                    if (e = i[f + 12 >> 2], r >>> 0 <= 255) {
                                                        if (k = i[f + 8 >> 2], (k | 0) != (e | 0)) break f;
                                                        s = 105512, h = i[26378] & b0(-2, r >>> 3 | 0), i[s >> 2] = h;
                                                        break e;
                                                    }
                                                    if (u = i[f + 24 >> 2], (e | 0) != (f | 0)) {
                                                        r = i[f + 8 >> 2], i[r + 12 >> 2] = e, i[e + 8 >> 2] = r;
                                                        break r;
                                                    }
                                                    if (k = i[f + 20 >> 2], k) r = f + 20 | 0;
                                                    else {
                                                        if (k = i[f + 16 >> 2], !k) break A;
                                                        r = f + 16 | 0;
                                                    }
                                                    for(; t = r, e = k, r = e + 20 | 0, k = i[e + 20 >> 2], !(!k && (r = e + 16 | 0, k = i[e + 16 >> 2], !k)););
                                                    i[t >> 2] = 0;
                                                    break r;
                                                }
                                                if (r = i[n + 4 >> 2], (r & 3) != 3) break e;
                                                i[26380] = A, i[n + 4 >> 2] = r & -2, i[f + 4 >> 2] = A | 1, i[n >> 2] = A;
                                                return;
                                            }
                                            i[k + 12 >> 2] = e, i[e + 8 >> 2] = k;
                                            break e;
                                        }
                                        e = 0;
                                    }
                                    if (!u) break e;
                                    r = i[f + 28 >> 2], k = (r << 2) + 105816 | 0;
                                    r: {
                                        if (i[k >> 2] == (f | 0)) {
                                            if (i[k >> 2] = e, e) break r;
                                            s = 105516, h = i[26379] & b0(-2, r), i[s >> 2] = h;
                                            break e;
                                        }
                                        if (i[u + (i[u + 16 >> 2] == (f | 0) ? 16 : 20) >> 2] = e, !e) break e;
                                    }
                                    if (i[e + 24 >> 2] = u, r = i[f + 16 >> 2], r && (i[e + 16 >> 2] = r, i[r + 24 >> 2] = e), r = i[f + 20 >> 2], !r) break e;
                                    i[e + 20 >> 2] = r, i[r + 24 >> 2] = e;
                                }
                                if (f >>> 0 >= n >>> 0 || (r = i[n + 4 >> 2], !(r & 1))) break i;
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (!(r & 2)) {
                                                    if ((n | 0) == i[26384]) {
                                                        if (i[26384] = f, A = i[26381] + A | 0, i[26381] = A, i[f + 4 >> 2] = A | 1, i[26383] != (f | 0)) break i;
                                                        i[26380] = 0, i[26383] = 0;
                                                        return;
                                                    }
                                                    if ((n | 0) == i[26383]) {
                                                        i[26383] = f, A = i[26380] + A | 0, i[26380] = A, i[f + 4 >> 2] = A | 1, i[A + f >> 2] = A;
                                                        return;
                                                    }
                                                    if (A = (r & -8) + A | 0, e = i[n + 12 >> 2], r >>> 0 <= 255) {
                                                        if (k = i[n + 8 >> 2], (k | 0) == (e | 0)) {
                                                            s = 105512, h = i[26378] & b0(-2, r >>> 3 | 0), i[s >> 2] = h;
                                                            break r;
                                                        }
                                                        i[k + 12 >> 2] = e, i[e + 8 >> 2] = k;
                                                        break r;
                                                    }
                                                    if (u = i[n + 24 >> 2], (e | 0) != (n | 0)) {
                                                        r = i[n + 8 >> 2], i[r + 12 >> 2] = e, i[e + 8 >> 2] = r;
                                                        break A;
                                                    }
                                                    if (k = i[n + 20 >> 2], k) r = n + 20 | 0;
                                                    else {
                                                        if (k = i[n + 16 >> 2], !k) break f;
                                                        r = n + 16 | 0;
                                                    }
                                                    for(; t = r, e = k, r = e + 20 | 0, k = i[e + 20 >> 2], !(!k && (r = e + 16 | 0, k = i[e + 16 >> 2], !k)););
                                                    i[t >> 2] = 0;
                                                    break A;
                                                }
                                                i[n + 4 >> 2] = r & -2, i[f + 4 >> 2] = A | 1, i[A + f >> 2] = A;
                                                break e;
                                            }
                                            e = 0;
                                        }
                                        if (!u) break r;
                                        r = i[n + 28 >> 2], k = (r << 2) + 105816 | 0;
                                        A: {
                                            if ((n | 0) == i[k >> 2]) {
                                                if (i[k >> 2] = e, e) break A;
                                                s = 105516, h = i[26379] & b0(-2, r), i[s >> 2] = h;
                                                break r;
                                            }
                                            if (i[u + ((n | 0) == i[u + 16 >> 2] ? 16 : 20) >> 2] = e, !e) break r;
                                        }
                                        if (i[e + 24 >> 2] = u, r = i[n + 16 >> 2], r && (i[e + 16 >> 2] = r, i[r + 24 >> 2] = e), r = i[n + 20 >> 2], !r) break r;
                                        i[e + 20 >> 2] = r, i[r + 24 >> 2] = e;
                                    }
                                    if (i[f + 4 >> 2] = A | 1, i[A + f >> 2] = A, i[26383] != (f | 0)) break e;
                                    i[26380] = A;
                                    return;
                                }
                                if (A >>> 0 <= 255) {
                                    r = (A & -8) + 105552 | 0, k = i[26378], A = 1 << (A >>> 3);
                                    e: {
                                        if (!(k & A)) {
                                            i[26378] = A | k, A = r;
                                            break e;
                                        }
                                        A = i[r + 8 >> 2];
                                    }
                                    i[r + 8 >> 2] = f, i[A + 12 >> 2] = f, i[f + 12 >> 2] = r, i[f + 8 >> 2] = A;
                                    return;
                                }
                                e = 31, A >>> 0 <= 16777215 && (r = e1(A >>> 8 | 0), e = ((A >>> 38 - r & 1) - (r << 1) | 0) + 62 | 0), i[f + 28 >> 2] = e, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, t = (e << 2) + 105816 | 0;
                                e: {
                                    r: {
                                        r = i[26379], k = 1 << e;
                                        A: {
                                            if (!(r & k)) {
                                                i[26379] = r | k, e = 24, r = t;
                                                break A;
                                            }
                                            for(e = A << ((e | 0) != 31 ? 25 - (e >>> 1 | 0) | 0 : 0), r = i[t >> 2];;){
                                                if (k = r, (i[r + 4 >> 2] & -8) == (A | 0)) break r;
                                                if (r = e >>> 29 | 0, e = e << 1, t = ((r & 4) + k | 0) + 16 | 0, r = i[t >> 2], !r) break;
                                            }
                                            e = 24, r = k;
                                        }
                                        k = f, n = f, A = 8;
                                        break e;
                                    }
                                    r = i[k + 8 >> 2], i[r + 12 >> 2] = f, e = 8, t = k + 8 | 0, n = 0, A = 24;
                                }
                                i[t >> 2] = f, i[e + f >> 2] = r, i[f + 12 >> 2] = k, i[A + f >> 2] = n, A = i[26386] - 1 | 0, i[26386] = A || -1;
                            }
                        }
                        function Ew(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            W = r + 4 | 0, u = e << 2, R = Q[W + u >> 1], s = r + 2 | 0, w = Q[s + u >> 1], B = r + 6 | 0, v = Q[B + u >> 1], f = e << 1, C = Q[f + W >> 1], h = Z(e, 6), e = Q[h + W >> 1], _ = Q[r + u >> 1], W = Q[W >> 1], u = Q[h + B >> 1], y = Q[f + B >> 1], B = Q[B >> 1], k = Z(u, -74) + Z(y + B | 0, 74) >> 1, k = (k | 0) >= 32767 ? 32767 : k, k = (k | 0) <= -32768 ? -32768 : k, F = Q[s + h >> 1], E = Q[f + s >> 1], s = Q[s >> 1], n = Z(F, -74) + Z(E + s | 0, 74) >> 1, n = (n | 0) >= 32767 ? 32767 : n, n = (n | 0) <= -32768 ? -32768 : n, h = Q[r + h >> 1], f = Q[r + f >> 1], r = Q[r >> 1], t = Z(h, -74) + Z(f + r | 0, 74) >> 1, t = (t | 0) >= 32767 ? 32767 : t, t = (t | 0) <= -32768 ? -32768 : t, Q[A + 10 >> 1] = (Z(k, 16777142) + Z(n + t | 0, 74) | 0) + 128 >>> 8, G = Z(e, -74) + Z(W + C | 0, 74) >> 1, G = (G | 0) >= 32767 ? 32767 : G, G = (G | 0) <= -32768 ? -32768 : G, V = Z(G, 74), Q[A + 14 >> 1] = ((V + (Z(n, -84) + Z(t, 55) | 0) | 0) + Z(k, 16777187) | 0) + 128 >>> 8, Q[A + 12 >> 1] = (((Z(n, -29) + Z(t, 84) | 0) + Z(G, 16777142) | 0) + Z(k, 55) | 0) + 128 >>> 8, Q[A + 8 >> 1] = ((V + (Z(n, 55) + Z(t, 29) | 0) | 0) + Z(k, 84) | 0) + 128 >>> 8, G = Z(v, 74), k = ((G + (Z(y, -84) + Z(B, 55) | 0) | 0) + Z(u, -29) | 0) + 1 >> 1, k = (k | 0) >= 32767 ? 32767 : k, k = (k | 0) <= -32768 ? -32768 : k, V = Z(w, 74), n = ((V + (Z(E, -84) + Z(s, 55) | 0) | 0) + Z(F, -29) | 0) + 1 >> 1, n = (n | 0) >= 32767 ? 32767 : n, n = (n | 0) <= -32768 ? -32768 : n, M = Z(_, 74), t = ((M + (Z(f, -84) + Z(r, 55) | 0) | 0) + Z(h, -29) | 0) + 1 >> 1, t = (t | 0) >= 32767 ? 32767 : t, t = (t | 0) <= -32768 ? -32768 : t, Q[A + 26 >> 1] = (Z(k, 16777142) + Z(n + t | 0, 74) | 0) + 128 >>> 8, v = (((Z(y, -29) + Z(B, 84) | 0) + Z(v, -74) | 0) + Z(u, 55) | 0) + 1 >> 1, v = (v | 0) >= 32767 ? 32767 : v, v = (v | 0) <= -32768 ? -32768 : v, w = (((Z(E, -29) + Z(s, 84) | 0) + Z(w, -74) | 0) + Z(F, 55) | 0) + 1 >> 1, w = (w | 0) >= 32767 ? 32767 : w, w = (w | 0) <= -32768 ? -32768 : w, _ = (((Z(f, -29) + Z(r, 84) | 0) + Z(_, -74) | 0) + Z(h, 55) | 0) + 1 >> 1, _ = (_ | 0) >= 32767 ? 32767 : _, _ = (_ | 0) <= -32768 ? -32768 : _, Q[A + 18 >> 1] = (Z(v, 16777142) + Z(w + _ | 0, 74) | 0) + 128 >>> 8, u = ((G + (Z(y, 55) + Z(B, 29) | 0) | 0) + Z(u, 84) | 0) + 1 >> 1, u = (u | 0) >= 32767 ? 32767 : u, u = (u | 0) <= -32768 ? -32768 : u, s = ((V + (Z(E, 55) + Z(s, 29) | 0) | 0) + Z(F, 84) | 0) + 1 >> 1, s = (s | 0) >= 32767 ? 32767 : s, s = (s | 0) <= -32768 ? -32768 : s, r = (((Z(f, 55) + Z(r, 29) | 0) + M | 0) + Z(h, 84) | 0) + 1 >> 1, r = (r | 0) >= 32767 ? 32767 : r, r = (r | 0) <= -32768 ? -32768 : r, Q[A + 2 >> 1] = (Z(u, 16777142) + Z(s + r | 0, 74) | 0) + 128 >>> 8, B = Z(R, 74), f = ((B + (Z(C, -84) + Z(W, 55) | 0) | 0) + Z(e, -29) | 0) + 1 >> 1, f = (f | 0) >= 32767 ? 32767 : f, f = (f | 0) <= -32768 ? -32768 : f, h = Z(f, 74), Q[A + 30 >> 1] = ((h + (Z(n, -84) + Z(t, 55) | 0) | 0) + Z(k, 16777187) | 0) + 128 >>> 8, Q[A + 28 >> 1] = (((Z(n, -29) + Z(t, 84) | 0) + Z(f, 16777142) | 0) + Z(k, 55) | 0) + 128 >>> 8, Q[A + 24 >> 1] = ((h + (Z(n, 55) + Z(t, 29) | 0) | 0) + Z(k, 84) | 0) + 128 >>> 8, f = (((Z(C, -29) + Z(W, 84) | 0) + Z(R, -74) | 0) + Z(e, 55) | 0) + 1 >> 1, f = (f | 0) >= 32767 ? 32767 : f, f = (f | 0) <= -32768 ? -32768 : f, h = Z(f, 74), Q[A + 22 >> 1] = ((h + (Z(w, -84) + Z(_, 55) | 0) | 0) + Z(v, 16777187) | 0) + 128 >>> 8, Q[A + 20 >> 1] = (((Z(w, -29) + Z(_, 84) | 0) + Z(f, 16777142) | 0) + Z(v, 55) | 0) + 128 >>> 8, Q[A + 16 >> 1] = ((h + (Z(w, 55) + Z(_, 29) | 0) | 0) + Z(v, 84) | 0) + 128 >>> 8, e = ((B + (Z(C, 55) + Z(W, 29) | 0) | 0) + Z(e, 84) | 0) + 1 >> 1, e = (e | 0) >= 32767 ? 32767 : e, e = (e | 0) <= -32768 ? -32768 : e, C = Z(e, 74), Q[A + 6 >> 1] = ((C + (Z(s, -84) + Z(r, 55) | 0) | 0) + Z(u, 16777187) | 0) + 128 >>> 8, Q[A + 4 >> 1] = (((Z(s, -29) + Z(r, 84) | 0) + Z(e, 16777142) | 0) + Z(u, 55) | 0) + 128 >>> 8, Q[A >> 1] = ((C + (Z(s, 55) + Z(r, 29) | 0) | 0) + Z(u, 84) | 0) + 128 >>> 8;
                        }
                        function b7(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 160 | 0, m = n;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            if (t = i[f >> 2], f = i[t + 104 >> 2], t = i[t + 108 >> 2], (f | 0) != (t | 0)) for(;;){
                                                                if (i[f >> 2] == (e | 0)) break t;
                                                                if (f = f + 16 | 0, (t | 0) == (f | 0)) break;
                                                            }
                                                            i[n + 24 >> 2] = 59808, i[n + 80 >> 2] = 59828, r = i[14961], i[n + 16 >> 2] = r, f = i[r - 12 >> 2], r = n + 16 | 0, i[f + r >> 2] = i[14962], i[n + 20 >> 2] = 0, f = r + i[i[n + 16 >> 2] - 12 >> 2] | 0, k = n + 28 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[n + 24 >> 2] = f, t = i[f - 12 >> 2], f = n + 24 | 0, i[t + f >> 2] = i[14964], t = i[14960], i[n + 16 >> 2] = t, i[r + i[t - 12 >> 2] >> 2] = i[14965], i[n + 80 >> 2] = 59828, i[n + 16 >> 2] = 59788, i[n + 24 >> 2] = 59808, k = z0(k), i[k >> 2] = 58864, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 64 >> 2] = 0, i[n + 76 >> 2] = 24, U(M0(U(f, 17440, 9), e), 2284, 46), r = i[n + 76 >> 2];
                                                            o: {
                                                                if (r & 16) {
                                                                    f = i[n + 72 >> 2], r = i[n + 52 >> 2], f >>> 0 < r >>> 0 && (i[n + 72 >> 2] = r, f = r), r = n + 48 | 0;
                                                                    break o;
                                                                }
                                                                if (!(r & 8)) {
                                                                    f = 0, o[n + 15 | 0] = 0, e = n + 4 | 0;
                                                                    break e;
                                                                }
                                                                f = i[n + 44 >> 2], r = n + 36 | 0;
                                                            }
                                                            if (r = i[r >> 2], f = f - r | 0, f >>> 0 >= 2147483640) break n;
                                                            if (f >>> 0 >= 11) {
                                                                t = (f | 7) + 1 | 0, e = D(t), i[n + 12 >> 2] = t | -2147483648, i[n + 4 >> 2] = e, i[n + 8 >> 2] = f;
                                                                break r;
                                                            }
                                                            if (o[n + 15 | 0] = f, e = n + 4 | 0, f) break r;
                                                            f = 0;
                                                            break e;
                                                        }
                                                        if (t = i[f + 4 >> 2], s = i[f + 8 >> 2], (t | 0) != (s | 0)) for(;;){
                                                            if (f = I[t + 2 >> 1], u = i[r + 36 >> 2], f >>> 0 > i[r + 40 >> 2] - u >> 3 >>> 0) {
                                                                i[n + 24 >> 2] = 59808, i[n + 80 >> 2] = 59828, r = i[14961], i[n + 16 >> 2] = r, f = i[r - 12 >> 2], r = n + 16 | 0, i[f + r >> 2] = i[14962], i[n + 20 >> 2] = 0, f = r + i[i[n + 16 >> 2] - 12 >> 2] | 0, k = n + 28 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[n + 24 >> 2] = f, u = i[f - 12 >> 2], f = n + 24 | 0, i[u + f >> 2] = i[14964], u = i[14960], i[n + 16 >> 2] = u, i[r + i[u - 12 >> 2] >> 2] = i[14965], i[n + 80 >> 2] = 59828, i[n + 16 >> 2] = 59788, i[n + 24 >> 2] = 59808, k = z0(k), i[k >> 2] = 58864, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 64 >> 2] = 0, i[n + 76 >> 2] = 24, U(M0(U(U(M0(U(f, 17411, 28), I[t + 2 >> 1]), 21957, 11), 17460, 4), e), 2331, 23), r = i[n + 76 >> 2];
                                                                t: {
                                                                    if (r & 16) {
                                                                        f = i[n + 72 >> 2], r = i[n + 52 >> 2], f >>> 0 < r >>> 0 && (i[n + 72 >> 2] = r, f = r), r = n + 48 | 0;
                                                                        break t;
                                                                    }
                                                                    if (!(r & 8)) {
                                                                        f = 0, o[n + 15 | 0] = 0, e = n + 4 | 0;
                                                                        break A;
                                                                    }
                                                                    f = i[n + 44 >> 2], r = n + 36 | 0;
                                                                }
                                                                if (r = i[r >> 2], f = f - r | 0, f >>> 0 >= 2147483640) break k;
                                                                if (f >>> 0 >= 11) {
                                                                    t = (f | 7) + 1 | 0, e = D(t), i[n + 12 >> 2] = t | -2147483648, i[n + 4 >> 2] = e, i[n + 8 >> 2] = f;
                                                                    break f;
                                                                }
                                                                if (o[n + 15 | 0] = f, e = n + 4 | 0, f) break f;
                                                                f = 0;
                                                                break A;
                                                            }
                                                            if (f) {
                                                                h = u + (f << 3) | 0, u = h - 8 | 0, f = i[k + 4 >> 2];
                                                                t: {
                                                                    if (f >>> 0 < k0[k + 8 >> 2]) {
                                                                        i[f >> 2] = i[u >> 2], u = i[h - 4 >> 2], i[f + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), f = f + 8 | 0;
                                                                        break t;
                                                                    }
                                                                    f = P2(k, u);
                                                                }
                                                                i[k + 4 >> 2] = f;
                                                            }
                                                            if (t = t + 4 | 0, (s | 0) == (t | 0)) break;
                                                        }
                                                        if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                            break i;
                                                        }
                                                        j(A, i[21670], i[21671]);
                                                        break i;
                                                    }
                                                    Y0(), z();
                                                }
                                                Y0(), z();
                                            }
                                            Q0(e, r, f);
                                        }
                                        o[e + f | 0] = 0, i0(A, 2, 115, n + 4 | 0), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), A = i[14959], i[n + 16 >> 2] = A, i[i[A - 12 >> 2] + (n + 16 | 0) >> 2] = i[14967], i[n + 24 >> 2] = i[14968], i[k >> 2] = 58864, o[n + 71 | 0] < 0 && X(i[n + 60 >> 2]), x0(k), N0(n + 80 | 0);
                                        break i;
                                    }
                                    Q0(e, r, f);
                                }
                                o[e + f | 0] = 0, i0(A, 2, 116, n + 4 | 0), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), A = i[14959], i[n + 16 >> 2] = A, i[i[A - 12 >> 2] + (n + 16 | 0) >> 2] = i[14967], i[n + 24 >> 2] = i[14968], i[k >> 2] = 58864, o[n + 71 | 0] < 0 && X(i[n + 60 >> 2]), x0(k), N0(n + 80 | 0);
                            }
                            m = n + 160 | 0;
                        }
                        function gw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            W = m - 80 | 0, m = W;
                            i: {
                                if (!(f && r)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 20604;
                                    break i;
                                }
                                if (v = W + 8 | 0, s = i[r >> 2], p[i[i[s >> 2] + 72 >> 2]](v, s), t = v0(f, v, 72), e) {
                                    e = 0, n = m - 48 | 0, m = n, ye(n + 16 | 0, i[r >> 2]);
                                    e: {
                                        if (i[n + 28 >> 2]) {
                                            if (e = i[n + 32 >> 2], i[v >> 2] = i[n + 28 >> 2], i[v + 4 >> 2] = e, e = v + 8 | 0, o[n + 47 | 0] >= 0) {
                                                f = i[n + 40 >> 2], i[e >> 2] = i[n + 36 >> 2], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[n + 44 >> 2];
                                                break e;
                                            }
                                            j(e, i[n + 36 >> 2], i[n + 40 >> 2]);
                                            break e;
                                        }
                                        s = i[t + 12 >> 2], f = 0;
                                        r: {
                                            if (!s || (h = i[t + 16 >> 2], f = 0, !h)) break r;
                                            e = k0[t + 20 >> 2] % (s >>> 0) | 0, f = k0[t + 24 >> 2] % (h >>> 0) | 0;
                                        }
                                        if (s = 0, w = i[n + 16 >> 2], C = i[n + 20 >> 2], (w | 0) != (C | 0)) for(;;){
                                            h = f, _ = e, k = B, u = i[w >> 2];
                                            r: {
                                                if (!u) break r;
                                                if (G = E0(u, 73632, 74784), G) {
                                                    u = i[w + 4 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1);
                                                    A: {
                                                        f: {
                                                            k: {
                                                                e = i[G + 100 >> 2], f = (e | 0) == 270;
                                                                n: {
                                                                    if (!f) {
                                                                        if ((e | 0) == 180) break n;
                                                                        if ((e | 0) != 90) break f;
                                                                    }
                                                                    if (y = t, F = sf(i[t + 12 >> 2], i[t + 16 >> 2]), i[y + 12 >> 2] = F, i[t + 16 >> 2] = w0, y = t, F = sf(i[t + 20 >> 2], i[t + 24 >> 2]), i[y + 20 >> 2] = F, i[t + 24 >> 2] = w0, y = t, F = sf(i[t + 4 >> 2], i[t + 8 >> 2]), i[y + 4 >> 2] = F, i[t + 8 >> 2] = w0, (e | 0) == 90) {
                                                                        f = s, e = h, B = _, s = k;
                                                                        break A;
                                                                    }
                                                                    if (f) break k;
                                                                    if ((e | 0) != 180) break f;
                                                                }
                                                                f = k, e = s, B = h, s = _;
                                                                break A;
                                                            }
                                                            f = _, e = k, B = s, s = h;
                                                            break A;
                                                        }
                                                        f = h, e = _, B = k;
                                                    }
                                                    A: {
                                                        if (!u || (h = i[u + 4 >> 2], i[u + 4 >> 2] = h - 1, h)) break A;
                                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                    }
                                                    if (u = i[w >> 2], !u) break r;
                                                }
                                                u = E0(u, 73632, 74856);
                                                A: {
                                                    if (!u) {
                                                        h = e, _ = f;
                                                        break A;
                                                    }
                                                    k = i[w + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), _ = f, h = e;
                                                    f: {
                                                        k: switch(i[u + 100 >> 2]){
                                                            case 1:
                                                                h = s, s = e;
                                                                break f;
                                                            case 0:
                                                                break k;
                                                            default:
                                                                break f;
                                                        }
                                                        _ = B, B = f;
                                                    }
                                                    if (!k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break A;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                }
                                                A: {
                                                    if (e = i[w >> 2], !e || (e = E0(e, 73632, 74928), !e)) break A;
                                                    k = i[w + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), f = oi(e, i[t + 20 >> 2]), u = x3(e, i[t + 20 >> 2]), G = ti(e, i[t + 24 >> 2]), e = z3(e, i[t + 24 >> 2]);
                                                    f: {
                                                        if (V = (f | 0) > 0 ? f : 0, f = i[t + 20 >> 2], u = f >>> 0 > u >>> 0 ? u : f - 1 | 0, (V | 0) <= (u | 0) && (G = (G | 0) > 0 ? G : 0, f = i[t + 24 >> 2], e = e >>> 0 < f >>> 0 ? e : f - 1 | 0, (G | 0) <= (e | 0))) break f;
                                                        if (o[n + 4 | 0] = 0, o[n + 15 | 0] = 0, i0(v, 2, 120, n + 4 | 0), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), !k || (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e)) break e;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        break e;
                                                    }
                                                    if (f = e + _ | 0, B = B + G | 0, e = u + h | 0, s = s + V | 0, !k || (h = i[k + 4 >> 2], i[k + 4 >> 2] = h - 1, h)) break r;
                                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                    break r;
                                                }
                                                e = h, f = _;
                                            }
                                            if (w = w + 8 | 0, (C | 0) == (w | 0)) break;
                                        }
                                        if (i[t + 28 >> 2] = B, i[t + 32 >> 2] = s, e = i[21669], i[v >> 2] = i[21668], i[v + 4 >> 2] = e, e = v + 8 | 0, o[86691] >= 0) {
                                            f = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[21672];
                                            break e;
                                        }
                                        j(e, i[21670], i[21671]);
                                    }
                                    if (o[n + 47 | 0] < 0 && X(i[n + 36 >> 2]), f = i[n + 16 >> 2], f) {
                                        if (e = f, w = i[n + 20 >> 2], (e | 0) != (w | 0)) {
                                            for(;;){
                                                e = i[w - 4 >> 2];
                                                e: {
                                                    if (!e || (s = i[e + 4 >> 2], i[e + 4 >> 2] = s - 1, s)) break e;
                                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                }
                                                if (w = w - 8 | 0, (f | 0) == (w | 0)) break;
                                            }
                                            e = i[n + 16 >> 2];
                                        }
                                        i[n + 20 >> 2] = f, X(e);
                                    }
                                    if (m = n + 48 | 0, e = i[W + 8 >> 2], e && j0(A, v, i[r + 8 >> 2]), o[W + 27 | 0] < 0 && X(i[W + 16 >> 2]), e) break i;
                                }
                                r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                            }
                            m = W + 80 | 0;
                        }
                        function Jw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            c = Q[r + 10 >> 1], G = Q[r + 26 >> 1], M = Q[r + 18 >> 1], H = Q[r + 2 >> 1], F = Q[r + 14 >> 1], E = Q[r + 12 >> 1], R = Q[r + 8 >> 1], h = 1 << e - 1, n = 1 << f, f = 0 - n | 0, v = Q[r + 22 >> 1], k = Q[r + 6 >> 1], y = Q[r + 30 >> 1], t = ((Z(v, -74) + Z(k, 74) | 0) + Z(y, 74) | 0) - -64 >> 7, w = n + 65535 | 0, t = ((f | 0) > (t | 0) ? f : (n | 0) > (t | 0) ? t : w) << 16 >> 16, _ = Q[r + 20 >> 1], T = Q[r + 4 >> 1], S = Q[r + 28 >> 1], u = ((Z(_, -74) + Z(T, 74) | 0) + Z(S, 74) | 0) - -64 >> 7, u = ((f | 0) > (u | 0) ? f : (n | 0) > (u | 0) ? u : w) << 16 >> 16, P = Q[r + 16 >> 1], $ = Q[r >> 1], r = Q[r + 24 >> 1], s = ((Z(P, -74) + Z($, 74) | 0) + Z(r, 74) | 0) - -64 >> 7, s = ((f | 0) > (s | 0) ? f : (n | 0) > (s | 0) ? s : w) << 16 >> 16, i[A + 40 >> 2] = h + (Z(t, 74) + (Z(u, -74) + Z(s, 74) | 0) | 0) >> e, W = (((Z(E, -74) + Z(T, 84) | 0) + Z(_, 55) | 0) + Z(S, -29) | 0) - -64 >> 7, W = ((f | 0) > (W | 0) ? f : (n | 0) > (W | 0) ? W : w) << 16 >> 16, C = (((Z(R, -74) + Z($, 84) | 0) + Z(P, 55) | 0) + Z(r, -29) | 0) - -64 >> 7, C = ((f | 0) > (C | 0) ? f : (n | 0) > (C | 0) ? C : w) << 16 >> 16, V = (((Z(F, -74) + Z(k, 84) | 0) + Z(v, 55) | 0) + Z(y, -29) | 0) - -64 >> 7, V = ((f | 0) > (V | 0) ? f : (n | 0) > (V | 0) ? V : w) << 16 >> 16, i[A + 56 >> 2] = ((Z(W, -74) + Z(C, 74) | 0) + Z(V, 74) | 0) + h >> e, B = ((Z(M, -74) + Z(H, 74) | 0) + Z(G, 74) | 0) - -64 >> 7, B = ((f | 0) > (B | 0) ? f : (n | 0) > (B | 0) ? B : w) << 16 >> 16, i[A + 44 >> 2] = (((Z(B, -74) + Z(s, 84) | 0) + Z(u, 55) | 0) + Z(t, -29) | 0) + h >> e, B = Z(B, 74), i[A + 36 >> 2] = (((B + Z(s, 55) | 0) + Z(u, -29) | 0) + Z(t, -84) | 0) + h >> e, i[A + 32 >> 2] = (((B + Z(s, 29) | 0) + Z(u, 84) | 0) + Z(t, 55) | 0) + h >> e, E = Z(E, 74), t = (((E + Z(T, 55) | 0) + Z(_, -29) | 0) + Z(S, -84) | 0) - -64 >> 7, t = ((f | 0) > (t | 0) ? f : (n | 0) > (t | 0) ? t : w) << 16 >> 16, R = Z(R, 74), u = (((R + Z($, 55) | 0) + Z(P, -29) | 0) + Z(r, -84) | 0) - -64 >> 7, u = ((f | 0) > (u | 0) ? f : (n | 0) > (u | 0) ? u : w) << 16 >> 16, F = Z(F, 74), s = (((F + Z(k, 55) | 0) + Z(v, -29) | 0) + Z(y, -84) | 0) - -64 >> 7, s = ((f | 0) > (s | 0) ? f : (n | 0) > (s | 0) ? s : w) << 16 >> 16, i[A + 24 >> 2] = ((Z(t, -74) + Z(u, 74) | 0) + Z(s, 74) | 0) + h >> e, _ = (((E + Z(T, 29) | 0) + Z(_, 84) | 0) + Z(S, 55) | 0) - -64 >> 7, _ = ((f | 0) > (_ | 0) ? f : (n | 0) > (_ | 0) ? _ : w) << 16 >> 16, r = (((R + Z($, 29) | 0) + Z(P, 84) | 0) + Z(r, 55) | 0) - -64 >> 7, r = ((r | 0) < (f | 0) ? f : (r | 0) < (n | 0) ? r : w) << 16 >> 16, v = (((F + Z(k, 29) | 0) + Z(v, 84) | 0) + Z(y, 55) | 0) - -64 >> 7, v = ((f | 0) > (v | 0) ? f : (n | 0) > (v | 0) ? v : w) << 16 >> 16, i[A + 8 >> 2] = ((Z(_, -74) + Z(r, 74) | 0) + Z(v, 74) | 0) + h >> e, k = (((Z(c, -74) + Z(H, 84) | 0) + Z(M, 55) | 0) + Z(G, -29) | 0) - -64 >> 7, k = ((f | 0) > (k | 0) ? f : (n | 0) > (k | 0) ? k : w) << 16 >> 16, i[A + 60 >> 2] = (((Z(k, -74) + Z(C, 84) | 0) + Z(W, 55) | 0) + Z(V, -29) | 0) + h >> e, k = Z(k, 74), i[A + 52 >> 2] = (((k + Z(C, 55) | 0) + Z(W, -29) | 0) + Z(V, -84) | 0) + h >> e, i[A + 48 >> 2] = (((k + Z(C, 29) | 0) + Z(W, 84) | 0) + Z(V, 55) | 0) + h >> e, y = Z(c, 74), k = (((y + Z(H, 55) | 0) + Z(M, -29) | 0) + Z(G, -84) | 0) - -64 >> 7, k = ((f | 0) > (k | 0) ? f : (n | 0) > (k | 0) ? k : w) << 16 >> 16, i[A + 28 >> 2] = (((Z(k, -74) + Z(u, 84) | 0) + Z(t, 55) | 0) + Z(s, -29) | 0) + h >> e, k = Z(k, 74), i[A + 20 >> 2] = (((k + Z(u, 55) | 0) + Z(t, -29) | 0) + Z(s, -84) | 0) + h >> e, i[A + 16 >> 2] = (((k + Z(u, 29) | 0) + Z(t, 84) | 0) + Z(s, 55) | 0) + h >> e, G = (((y + Z(H, 29) | 0) + Z(M, 84) | 0) + Z(G, 55) | 0) - -64 >> 7, f = ((f | 0) > (G | 0) ? f : (n | 0) > (G | 0) ? G : w) << 16 >> 16, i[A + 12 >> 2] = (((Z(f, -74) + Z(r, 84) | 0) + Z(_, 55) | 0) + Z(v, -29) | 0) + h >> e, f = Z(f, 74), i[A + 4 >> 2] = (((f + Z(r, 55) | 0) + Z(_, -29) | 0) + Z(v, -84) | 0) + h >> e, i[A >> 2] = (((f + Z(r, 29) | 0) + Z(_, 84) | 0) + Z(v, 55) | 0) + h >> e;
                        }
                        function _e(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            f = m - 160 | 0, m = f, k = i[e >> 2], n = p[i[i[k >> 2] + 8 >> 2]](k) | 0, t = i[e >> 2], k = w0, n = n + 8 | 0, k = n >>> 0 < 8 ? k + 1 | 0 : k;
                            i: {
                                if (p[i[i[t >> 2] + 12 >> 2]](t, n, k) | 0) {
                                    if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 100, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                    X(i[f + 16 >> 2]);
                                    break i;
                                }
                                s = r, h = n2(e), i[s + 8 >> 2] = h, i[r + 12 >> 2] = 0, k = n2(e), i[r + 32 >> 2] = 8, i[r + 16 >> 2] = k;
                                e: {
                                    r: {
                                        A: {
                                            if (!i[r + 12 >> 2] & i[r + 8 >> 2] == 1) {
                                                if (k = i[e >> 2], n = p[i[i[k >> 2] + 8 >> 2]](k) | 0, t = i[e >> 2], k = w0, n = n + 8 | 0, k = n >>> 0 < 8 ? k + 1 | 0 : k, p[i[i[t >> 2] + 12 >> 2]](t, n, k) | 0) {
                                                    if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 100, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                                    X(i[f + 16 >> 2]);
                                                    break i;
                                                }
                                                if (k = n2(e), s = r, h = n2(e), i[s + 8 >> 2] = h, i[r + 12 >> 2] = k, i[r + 32 >> 2] = i[r + 32 >> 2] + 8, i[f + 24 >> 2] = 59808, i[f + 80 >> 2] = 59828, k = i[14961], i[f + 16 >> 2] = k, n = i[k - 12 >> 2], k = f + 16 | 0, i[n + k >> 2] = i[14962], i[f + 20 >> 2] = 0, n = k + i[i[f + 16 >> 2] - 12 >> 2] | 0, t = f + 28 | 0, T0(n, t), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, n = i[14963], i[f + 24 >> 2] = n, u = i[n - 12 >> 2], n = f + 24 | 0, i[u + n >> 2] = i[14964], u = i[14960], i[f + 16 >> 2] = u, i[k + i[u - 12 >> 2] >> 2] = i[14965], i[f + 80 >> 2] = 59828, i[f + 16 >> 2] = 59788, i[f + 24 >> 2] = 59808, k = z0(t), i[k >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 24, U(K1(U(n, 22214, 9), i[r + 8 >> 2], i[r + 12 >> 2]), 19027, 24), n = f + 80 | 0, t = i[r + 12 >> 2], (t | 0) == 268435456 | t >>> 0 > 268435456) {
                                                    r = i[f + 76 >> 2];
                                                    f: {
                                                        if (r & 16) {
                                                            e = i[f + 72 >> 2], r = i[f + 52 >> 2], e >>> 0 < r >>> 0 && (i[f + 72 >> 2] = r, e = r), r = f + 48 | 0;
                                                            break f;
                                                        }
                                                        if (!(r & 8)) {
                                                            e = 0, o[f + 15 | 0] = 0, r = f + 4 | 0;
                                                            break e;
                                                        }
                                                        e = i[f + 44 >> 2], r = f + 36 | 0;
                                                    }
                                                    if (t = i[r >> 2], e = e - t | 0, e >>> 0 >= 2147483640) break A;
                                                    if (e >>> 0 >= 11) {
                                                        u = (e | 7) + 1 | 0, r = D(u), i[f + 12 >> 2] = u | -2147483648, i[f + 4 >> 2] = r, i[f + 8 >> 2] = e;
                                                        break r;
                                                    }
                                                    if (o[f + 15 | 0] = e, r = f + 4 | 0, e) break r;
                                                    e = 0;
                                                    break e;
                                                }
                                                t = i[14959], i[f + 16 >> 2] = t, i[i[t - 12 >> 2] + (f + 16 | 0) >> 2] = i[14967], i[f + 24 >> 2] = i[14968], i[k >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(k), N0(n), k = i[r + 16 >> 2];
                                            }
                                            if ((k | 0) == 1970628964) {
                                                if (k = i[e >> 2], n = p[i[i[k >> 2] + 8 >> 2]](k) | 0, t = i[e >> 2], k = w0, n = n + 16 | 0, k = n >>> 0 < 16 ? k + 1 | 0 : k, p[i[i[t >> 2] + 12 >> 2]](t, n, k) | 0) {
                                                    if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 100, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                                    X(i[f + 16 >> 2]);
                                                    break i;
                                                }
                                                f: {
                                                    if (!o4(e, 16)) break f;
                                                    t = r + 20 | 0, n = i[r + 20 >> 2], k = i[r + 24 >> 2] - n | 0;
                                                    k: {
                                                        if (k >>> 0 <= 15) {
                                                            r1(t, 16 - k | 0);
                                                            break k;
                                                        }
                                                        if ((k | 0) == 16) break k;
                                                        i[r + 24 >> 2] = n + 16;
                                                    }
                                                    if (n = i[e >> 2], k = i[e + 4 >> 2], k) {
                                                        if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, p[i[i[n >> 2] + 16 >> 2]](n, i[t >> 2], 16), n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n) break f;
                                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                        break f;
                                                    }
                                                    p[i[i[n >> 2] + 16 >> 2]](n, i[t >> 2], 16);
                                                }
                                                i[r + 32 >> 2] = i[r + 32 >> 2] + 16;
                                            }
                                            if (l[e + 20 | 0] == 1) {
                                                if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 100, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                                X(i[f + 16 >> 2]);
                                                break i;
                                            }
                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(r, t, e);
                                }
                                o[r + e | 0] = 0, i0(A, 6, 1e3, f + 4 | 0), o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), A = i[14959], i[f + 16 >> 2] = A, i[i[A - 12 >> 2] + (f + 16 | 0) >> 2] = i[14967], i[f + 24 >> 2] = i[14968], i[k >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(k), N0(n);
                            }
                            m = f + 160 | 0;
                        }
                        function Rw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            _ = m - 32 | 0, m = _, s = _ + 12 | 0, V = e, y = f, k = m - 48 | 0, m = k, w = i[r >> 2], f = i[w + 60 >> 2], W = w - -64 | 0;
                            i: {
                                if ((f | 0) != (W | 0)) for(C = s + 8 | 0;;){
                                    IA(V, y, i[f + 16 >> 2], i[w + 36 >> 2], k + 44 | 0, k + 40 | 0), t = i[f + 16 >> 2];
                                    e: {
                                        if ((t | 0) == 10) {
                                            if (u = 255, e = i[w + 36 >> 2] - 10 | 0, e >>> 0 >= 6) break e;
                                            e = e << 3, n = e & 31, (e & 63) >>> 0 >= 32 ? u = 16432 >>> n | 0 : u = ((1 << n) - 1 & 16432) << 32 - n | 1076895768 >>> n;
                                            break e;
                                        }
                                        if (u = 0, n = W, e = i[n >> 2], !e) break e;
                                        for(; h = i[e + 16 >> 2] < (t | 0), n = h ? n : e, e = i[(h << 2) + e >> 2], !!e;);
                                        if ((n | 0) == (W | 0) | i[n + 16 >> 2] > (t | 0)) break e;
                                        u = l[n + 24 | 0] + 7 | 0;
                                    }
                                    n = i[f + 32 >> 2], G = i[f + 28 >> 2], v = u >>> 3 & 31;
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    if (u = i[k + 44 >> 2], h = i[k + 40 >> 2], !(u >>> 0 <= k0[f + 36 >> 2] & h >>> 0 <= k0[f + 40 >> 2])) {
                                                        Q[k + 8 >> 1] = 256, i[k + 4 >> 2] = 1, i[k + 36 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 12 >> 2] = 0, i[k + 16 >> 2] = 0, F = k + 4 | 0, t = i[f + 20 >> 2], B = l[f + 24 | 0], e = 1;
                                                        k: {
                                                            n: switch(i[w + 36 >> 2]){
                                                                case 10:
                                                                case 12:
                                                                case 14:
                                                                    e = 3;
                                                                    break k;
                                                                case 11:
                                                                case 13:
                                                                case 15:
                                                                    e = 4;
                                                                    break k;
                                                                case 0:
                                                                case 1:
                                                                case 2:
                                                                case 3:
                                                                case 99:
                                                                    break k;
                                                                default:
                                                                    break n;
                                                            }
                                                            e = 0;
                                                        }
                                                        if (Ve(s, F, u, h, t, B, e, 0), i[s >> 2]) break i;
                                                        if (o[s + 19 | 0] < 0 && X(i[s + 8 >> 2]), u = i[k + 28 >> 2], !u) break f;
                                                        if (i[f + 32 >> 2]) for(e = 0, h = i[k + 36 >> 2]; v0(u + Z(e, h) | 0, i[f + 44 >> 2] + Z(i[f + 52 >> 2], e) | 0, Z(v, i[f + 28 >> 2])), e = e + 1 | 0, e >>> 0 < k0[f + 32 >> 2];);
                                                        e = i[k + 8 >> 2], i[f + 20 >> 2] = i[k + 4 >> 2], i[f + 24 >> 2] = e, i[f + 52 >> 2] = i[k + 36 >> 2], e = i[k + 32 >> 2], i[f + 44 >> 2] = i[k + 28 >> 2], i[f + 48 >> 2] = e, e = i[k + 24 >> 2], i[f + 36 >> 2] = i[k + 20 >> 2], i[f + 40 >> 2] = e, e = i[k + 16 >> 2], i[f + 28 >> 2] = i[k + 12 >> 2], i[f + 32 >> 2] = e, t = i[f + 16 >> 2], u = i[k + 44 >> 2];
                                                    }
                                                    B = (v | 0) == 1 && t - 1 >>> 0 < 2 ? -128 : 0;
                                                    k: {
                                                        if (!n | (u | 0) == (G | 0)) break k;
                                                        if (u = Z(v, G), t = 0, (n | 0) != 1) for(e = n & -2, h = 0; B0(u + (i[f + 44 >> 2] + Z(i[f + 52 >> 2], t) | 0) | 0, B, Z(v, i[k + 44 >> 2] - G | 0)), B0(u + (i[f + 44 >> 2] + Z(i[f + 52 >> 2], t | 1) | 0) | 0, B, Z(v, i[k + 44 >> 2] - G | 0)), t = t + 2 | 0, h = h + 2 | 0, (e | 0) != (h | 0););
                                                        if (!(n & 1)) break k;
                                                        B0(u + (i[f + 44 >> 2] + Z(i[f + 52 >> 2], t) | 0) | 0, B, Z(v, i[k + 44 >> 2] - G | 0));
                                                    }
                                                    if (t = i[k + 40 >> 2], t >>> 0 > n >>> 0) break A;
                                                    break e;
                                                }
                                                if (e = i[21674], i[s >> 2] = i[21673], i[s + 4 >> 2] = e, o[86711] < 0) break r;
                                                e = i[21676], i[C >> 2] = i[21675], i[C + 4 >> 2] = e, i[C + 8 >> 2] = i[21677];
                                                break i;
                                            }
                                            for(; B0(i[f + 44 >> 2] + Z(i[f + 52 >> 2], n) | 0, B, Z(v, i[k + 44 >> 2])), n = n + 1 | 0, t = i[k + 40 >> 2], n >>> 0 < t >>> 0;);
                                            break e;
                                        }
                                        j(C, i[21675], i[21676]);
                                        break i;
                                    }
                                    e = i[k + 44 >> 2], i[f + 32 >> 2] = t, i[f + 28 >> 2] = e, n = i[f + 4 >> 2];
                                    e: {
                                        if (n) {
                                            for(;;)if (e = n, n = i[e >> 2], !n) break e;
                                        }
                                        for(; e = i[f + 8 >> 2], n = i[e >> 2] != (f | 0), f = e, !!n;);
                                    }
                                    if (f = e, (W | 0) == (f | 0)) break;
                                }
                                if (i[w + 28 >> 2] = y, i[w + 24 >> 2] = V, e = i[21669], i[s >> 2] = i[21668], i[s + 4 >> 2] = e, f = s + 8 | 0, o[86691] >= 0) {
                                    e = i[21671], i[f >> 2] = i[21670], i[f + 4 >> 2] = e, i[f + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(f, i[21670], i[21671]);
                            }
                            m = k + 48 | 0;
                            i: {
                                if (i[_ + 12 >> 2]) {
                                    e = A, A = i[r >> 2], j0(e, s, A ? A + 8 | 0 : 0);
                                    break i;
                                }
                                r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                            }
                            o[_ + 31 | 0] < 0 && X(i[_ + 20 >> 2]), m = _ + 32 | 0;
                        }
                        function Nw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            n = m - 32 | 0, m = n, A = i[A >> 2], k = i[A + 48 >> 2], A = i[A + 52 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), u = i[k + 108 >> 2], h = i[k + 112 >> 2], h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1);
                            i: {
                                if (!A || (k = i[A + 4 >> 2], i[A + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            i: {
                                if (!u) {
                                    u = 0, i[f >> 2] = 0;
                                    break i;
                                }
                                k = 0, i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0;
                                e: {
                                    r: {
                                        A: {
                                            if (A = i[u + 36 >> 2], t = i[u + 40 >> 2], (A | 0) != (t | 0)) {
                                                if (k = t - A | 0, (k | 0) < 0) break A;
                                                for(u = D(k), i[n + 20 >> 2] = u, i[n + 28 >> 2] = k + u, k = u; i[k >> 2] = i[A >> 2], w = k, k = i[A + 4 >> 2], i[w + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = w + 8 | 0, A = A + 8 | 0, (t | 0) != (A | 0););
                                                for(i[n + 24 >> 2] = k, i[n + 16 >> 2] = 0, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 0;;){
                                                    A = i[u >> 2];
                                                    f: {
                                                        k: {
                                                            n: {
                                                                t: {
                                                                    if (r) {
                                                                        if (i[A + 16 >> 2] == (r | 0)) break t;
                                                                        break f;
                                                                    }
                                                                    if (!A) break n;
                                                                }
                                                                if (t = E0(A, 73632, 75216), !t) break n;
                                                                if (i[n >> 2] = t, A = i[u + 4 >> 2], i[n + 4 >> 2] = A, !A) break k;
                                                                i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                                                                break k;
                                                            }
                                                            i[n >> 2] = 0, i[n + 4 >> 2] = 0, t = 0;
                                                        }
                                                        k: {
                                                            n: {
                                                                if (!e) break n;
                                                                if (A = i[t + 108 >> 2], k = i[t + 112 >> 2], (A | 0) == (k | 0)) break k;
                                                                for(;;){
                                                                    if (i[A >> 2] == (e | 0)) break n;
                                                                    if (A = A + 4 | 0, (k | 0) == (A | 0)) break;
                                                                }
                                                                break k;
                                                            }
                                                            A = i[n + 12 >> 2];
                                                            n: {
                                                                if (A >>> 0 < k0[n + 16 >> 2]) {
                                                                    i[A >> 2] = t, k = i[n + 4 >> 2], i[A + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), A = A + 8 | 0;
                                                                    break n;
                                                                }
                                                                A = P2(n + 8 | 0, n);
                                                            }
                                                            i[n + 12 >> 2] = A;
                                                        }
                                                        if (A = i[n + 4 >> 2], !A || (k = i[A + 4 >> 2], i[A + 4 >> 2] = k - 1, k)) break f;
                                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                    }
                                                    if (A = (u | 0) == (w | 0), u = u + 8 | 0, !!A) break;
                                                }
                                                break r;
                                            }
                                            i[f >> 2] = 0, u = 0;
                                            break e;
                                        }
                                        p0(), z();
                                    }
                                    v = i[n + 12 >> 2], r = i[n + 8 >> 2], A = v - r | 0, w = A >> 3, u = D(w >>> 0 > 268435455 ? -1 : A << 1), W = (r | 0) == (v | 0);
                                    r: {
                                        A: {
                                            if (!W) {
                                                for(V = w >>> 0 <= 1 ? 1 : w;;){
                                                    t = (B << 4) + u | 0, A = i[r + (B << 3) >> 2], i[t >> 2] = i[A + 104 >> 2], i[t + 4 >> 2] = i[A + 16 >> 2], e = i[A + 108 >> 2], k = i[A + 112 >> 2];
                                                    f: {
                                                        if ((e | 0) == (k | 0)) {
                                                            k = 0, A = e;
                                                            break f;
                                                        }
                                                        e = k - e | 0, k = D((e | 0) < 0 ? -1 : e), e = i[A + 108 >> 2], A = i[A + 112 >> 2];
                                                    }
                                                    i[t + 8 >> 2] = k, s = t, t = A - e >> 2, i[s + 12 >> 2] = t;
                                                    f: {
                                                        if (!k | (A | 0) == (e | 0)) break f;
                                                        if (s = t >>> 0 <= 1 ? 1 : t, C = s & 3, G = 0, A = 0, t >>> 0 >= 4) for(y = s & -4, t = 0; s = A << 2, i[s + k >> 2] = i[e + s >> 2], _ = s | 4, i[_ + k >> 2] = i[e + _ >> 2], _ = s | 8, i[_ + k >> 2] = i[e + _ >> 2], s = s | 12, i[s + k >> 2] = i[e + s >> 2], A = A + 4 | 0, t = t + 4 | 0, (y | 0) != (t | 0););
                                                        if (!C) break f;
                                                        for(; t = A << 2, i[t + k >> 2] = i[e + t >> 2], A = A + 1 | 0, G = G + 1 | 0, (G | 0) != (C | 0););
                                                    }
                                                    if (B = B + 1 | 0, (V | 0) == (B | 0)) break;
                                                }
                                                if (i[f >> 2] = w, !r) break r;
                                                if (W) {
                                                    A = r;
                                                    break A;
                                                }
                                                for(;;){
                                                    A = i[v - 4 >> 2];
                                                    f: {
                                                        if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break f;
                                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                                    }
                                                    if (v = v - 8 | 0, (r | 0) == (v | 0)) break;
                                                }
                                                A = i[n + 8 >> 2];
                                                break A;
                                            }
                                            if (i[f >> 2] = w, A = r, !A) break r;
                                        }
                                        i[n + 12 >> 2] = r, X(A);
                                    }
                                    k = i[n + 20 >> 2];
                                }
                                if (!k) break i;
                                if (e = k, A = i[n + 24 >> 2], (k | 0) != (A | 0)) {
                                    for(;;){
                                        r = i[A - 4 >> 2];
                                        e: {
                                            if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break e;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (A = A - 8 | 0, (k | 0) == (A | 0)) break;
                                    }
                                    e = i[n + 20 >> 2];
                                }
                                i[n + 24 >> 2] = k, X(e);
                            }
                            i: {
                                if (!h || (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            return m = n + 32 | 0, u | 0;
                        }
                        function Be(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = A + r | 0, e = i[A + 4 >> 2];
                            i: {
                                e: {
                                    if (e & 1) break e;
                                    if (!(e & 2)) break i;
                                    e = i[A >> 2], r = e + r | 0;
                                    r: {
                                        A: {
                                            f: {
                                                if (A = A - e | 0, (A | 0) != i[26383]) {
                                                    if (f = i[A + 12 >> 2], e >>> 0 <= 255) {
                                                        if (k = i[A + 8 >> 2], (k | 0) != (f | 0)) break f;
                                                        s = 105512, h = i[26378] & b0(-2, e >>> 3 | 0), i[s >> 2] = h;
                                                        break e;
                                                    }
                                                    if (t = i[A + 24 >> 2], (A | 0) != (f | 0)) {
                                                        e = i[A + 8 >> 2], i[e + 12 >> 2] = f, i[f + 8 >> 2] = e;
                                                        break r;
                                                    }
                                                    if (k = i[A + 20 >> 2], k) e = A + 20 | 0;
                                                    else {
                                                        if (k = i[A + 16 >> 2], !k) break A;
                                                        e = A + 16 | 0;
                                                    }
                                                    for(; u = e, f = k, e = f + 20 | 0, k = i[f + 20 >> 2], !(!k && (e = f + 16 | 0, k = i[f + 16 >> 2], !k)););
                                                    i[u >> 2] = 0;
                                                    break r;
                                                }
                                                if (e = i[n + 4 >> 2], (e & 3) != 3) break e;
                                                i[26380] = r, i[n + 4 >> 2] = e & -2, i[A + 4 >> 2] = r | 1, i[n >> 2] = r;
                                                return;
                                            }
                                            i[k + 12 >> 2] = f, i[f + 8 >> 2] = k;
                                            break e;
                                        }
                                        f = 0;
                                    }
                                    if (!t) break e;
                                    e = i[A + 28 >> 2], k = (e << 2) + 105816 | 0;
                                    r: {
                                        if (i[k >> 2] == (A | 0)) {
                                            if (i[k >> 2] = f, f) break r;
                                            s = 105516, h = i[26379] & b0(-2, e), i[s >> 2] = h;
                                            break e;
                                        }
                                        if (i[t + (i[t + 16 >> 2] == (A | 0) ? 16 : 20) >> 2] = f, !f) break e;
                                    }
                                    if (i[f + 24 >> 2] = t, e = i[A + 16 >> 2], e && (i[f + 16 >> 2] = e, i[e + 24 >> 2] = f), e = i[A + 20 >> 2], !e) break e;
                                    i[f + 20 >> 2] = e, i[e + 24 >> 2] = f;
                                }
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (e = i[n + 4 >> 2], !(e & 2)) {
                                                    if (i[26384] == (n | 0)) {
                                                        if (i[26384] = A, r = i[26381] + r | 0, i[26381] = r, i[A + 4 >> 2] = r | 1, i[26383] != (A | 0)) break i;
                                                        i[26380] = 0, i[26383] = 0;
                                                        return;
                                                    }
                                                    if (i[26383] == (n | 0)) {
                                                        i[26383] = A, r = i[26380] + r | 0, i[26380] = r, i[A + 4 >> 2] = r | 1, i[A + r >> 2] = r;
                                                        return;
                                                    }
                                                    if (r = (e & -8) + r | 0, f = i[n + 12 >> 2], e >>> 0 <= 255) {
                                                        if (k = i[n + 8 >> 2], (k | 0) == (f | 0)) {
                                                            s = 105512, h = i[26378] & b0(-2, e >>> 3 | 0), i[s >> 2] = h;
                                                            break r;
                                                        }
                                                        i[k + 12 >> 2] = f, i[f + 8 >> 2] = k;
                                                        break r;
                                                    }
                                                    if (t = i[n + 24 >> 2], (f | 0) != (n | 0)) {
                                                        e = i[n + 8 >> 2], i[e + 12 >> 2] = f, i[f + 8 >> 2] = e;
                                                        break A;
                                                    }
                                                    if (k = i[n + 20 >> 2], k) e = n + 20 | 0;
                                                    else {
                                                        if (k = i[n + 16 >> 2], !k) break f;
                                                        e = n + 16 | 0;
                                                    }
                                                    for(; u = e, f = k, e = f + 20 | 0, k = i[f + 20 >> 2], !(!k && (e = f + 16 | 0, k = i[f + 16 >> 2], !k)););
                                                    i[u >> 2] = 0;
                                                    break A;
                                                }
                                                i[n + 4 >> 2] = e & -2, i[A + 4 >> 2] = r | 1, i[A + r >> 2] = r;
                                                break e;
                                            }
                                            f = 0;
                                        }
                                        if (!t) break r;
                                        e = i[n + 28 >> 2], k = (e << 2) + 105816 | 0;
                                        A: {
                                            if (i[k >> 2] == (n | 0)) {
                                                if (i[k >> 2] = f, f) break A;
                                                s = 105516, h = i[26379] & b0(-2, e), i[s >> 2] = h;
                                                break r;
                                            }
                                            if (i[t + (i[t + 16 >> 2] == (n | 0) ? 16 : 20) >> 2] = f, !f) break r;
                                        }
                                        if (i[f + 24 >> 2] = t, e = i[n + 16 >> 2], e && (i[f + 16 >> 2] = e, i[e + 24 >> 2] = f), e = i[n + 20 >> 2], !e) break r;
                                        i[f + 20 >> 2] = e, i[e + 24 >> 2] = f;
                                    }
                                    if (i[A + 4 >> 2] = r | 1, i[A + r >> 2] = r, i[26383] != (A | 0)) break e;
                                    i[26380] = r;
                                    return;
                                }
                                if (r >>> 0 <= 255) {
                                    e = (r & -8) + 105552 | 0, f = i[26378], r = 1 << (r >>> 3);
                                    e: {
                                        if (!(f & r)) {
                                            i[26378] = r | f, r = e;
                                            break e;
                                        }
                                        r = i[e + 8 >> 2];
                                    }
                                    i[e + 8 >> 2] = A, i[r + 12 >> 2] = A, i[A + 12 >> 2] = e, i[A + 8 >> 2] = r;
                                    return;
                                }
                                f = 31, r >>> 0 <= 16777215 && (e = e1(r >>> 8 | 0), f = ((r >>> 38 - e & 1) - (e << 1) | 0) + 62 | 0), i[A + 28 >> 2] = f, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, e = (f << 2) + 105816 | 0;
                                e: {
                                    k = i[26379], u = 1 << f;
                                    r: {
                                        if (!(k & u)) {
                                            i[26379] = k | u, i[e >> 2] = A, i[A + 24 >> 2] = e;
                                            break r;
                                        }
                                        for(f = r << ((f | 0) != 31 ? 25 - (f >>> 1 | 0) | 0 : 0), e = i[e >> 2];;){
                                            if (k = e, (i[e + 4 >> 2] & -8) == (r | 0)) break e;
                                            if (e = f >>> 29 | 0, f = f << 1, u = k + (e & 4) | 0, e = i[u + 16 >> 2], !e) break;
                                        }
                                        i[u + 16 >> 2] = A, i[A + 24 >> 2] = k;
                                    }
                                    i[A + 12 >> 2] = A, i[A + 8 >> 2] = A;
                                    return;
                                }
                                r = i[k + 8 >> 2], i[r + 12 >> 2] = A, i[k + 8 >> 2] = A, i[A + 24 >> 2] = 0, i[A + 12 >> 2] = k, i[A + 8 >> 2] = r;
                            }
                        }
                        function me(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            t = m - 32 | 0, m = t;
                            i: {
                                r = i[A + 16 >> 2];
                                e: {
                                    if (r >>> 0 >= 1024) {
                                        i[A + 16 >> 2] = r - 1024, r = i[A + 4 >> 2], s = i[r >> 2], e = r + 4 | 0, i[A + 4 >> 2] = e, f = i[A + 8 >> 2];
                                        r: {
                                            if ((f | 0) != i[A + 12 >> 2]) break r;
                                            if (r = i[A >> 2], r >>> 0 < e >>> 0) {
                                                n = f - e | 0, k = ((e - r >> 2) + 1 | 0) / -2 << 2, r = k + e | 0, (e | 0) != (f | 0) && (Q0(r, e, n), e = i[A + 4 >> 2]), f = r + n | 0, i[A + 8 >> 2] = f, i[A + 4 >> 2] = e + k;
                                                break r;
                                            }
                                            if (k = (r | 0) == (f | 0) ? 1 : f - r >> 1, k >>> 0 >= 1073741824) break i;
                                            if (u = k << 2, n = D(u), h = n + u | 0, u = n + (k & -4) | 0, k = u, (e | 0) != (f | 0)) for(f = k + (f - e | 0) | 0; i[k >> 2] = i[e >> 2], e = e + 4 | 0, k = k + 4 | 0, (f | 0) != (k | 0););
                                            i[A + 12 >> 2] = h, i[A + 8 >> 2] = k, i[A + 4 >> 2] = u, i[A >> 2] = n, X(r), f = i[A + 8 >> 2];
                                        }
                                        i[f >> 2] = s, i[A + 8 >> 2] = i[A + 8 >> 2] + 4;
                                        break e;
                                    }
                                    if (e = i[A + 8 >> 2], k = i[A + 4 >> 2], n = e - k | 0, r = i[A + 12 >> 2], f = i[A >> 2], u = r - f | 0, n >>> 0 < u >>> 0) {
                                        if ((e | 0) != (r | 0)) {
                                            w = t, v = D(4096), i[w + 12 >> 2] = v;
                                            r: {
                                                A: {
                                                    n = i[A + 8 >> 2];
                                                    f: {
                                                        if ((n | 0) != i[A + 12 >> 2]) {
                                                            r = n;
                                                            break f;
                                                        }
                                                        if (e = i[A + 4 >> 2], f = i[A >> 2], e >>> 0 > f >>> 0) {
                                                            r = n - e | 0, k = ((e - f >> 2) + 1 | 0) / -2 << 2, f = k + e | 0, (e | 0) != (n | 0) && (Q0(f, e, r), e = i[A + 4 >> 2]), r = r + f | 0, i[A + 8 >> 2] = r, i[A + 4 >> 2] = e + k;
                                                            break f;
                                                        }
                                                        if (r = (f | 0) == (n | 0) ? 1 : n - f >> 1, r >>> 0 >= 1073741824) break A;
                                                        if (u = r << 2, k = D(u), u = k + u | 0, s = k + (r & -4) | 0, r = s, (e | 0) != (n | 0)) for(n = (n - e | 0) + r | 0; i[r >> 2] = i[e >> 2], e = e + 4 | 0, r = r + 4 | 0, (n | 0) != (r | 0););
                                                        if (i[A + 12 >> 2] = u, i[A + 8 >> 2] = r, i[A + 4 >> 2] = s, i[A >> 2] = k, !f) break f;
                                                        X(f), r = i[A + 8 >> 2];
                                                    }
                                                    i[r >> 2] = i[t + 12 >> 2], i[A + 8 >> 2] = i[A + 8 >> 2] + 4;
                                                    break r;
                                                }
                                                Z2(), z();
                                            }
                                            break e;
                                        }
                                        w = t, v = D(4096), i[w + 12 >> 2] = v, Vn(A, t + 12 | 0), r = i[A + 4 >> 2], s = i[r >> 2], e = r + 4 | 0, i[A + 4 >> 2] = e, f = i[A + 8 >> 2];
                                        r: {
                                            if ((f | 0) != i[A + 12 >> 2]) break r;
                                            if (r = i[A >> 2], r >>> 0 < e >>> 0) {
                                                n = f - e | 0, k = ((e - r >> 2) + 1 | 0) / -2 << 2, r = k + e | 0, (e | 0) != (f | 0) && (Q0(r, e, n), e = i[A + 4 >> 2]), f = r + n | 0, i[A + 8 >> 2] = f, i[A + 4 >> 2] = e + k;
                                                break r;
                                            }
                                            if (k = (r | 0) == (f | 0) ? 1 : f - r >> 1, k >>> 0 >= 1073741824) break i;
                                            if (u = k << 2, n = D(u), h = n + u | 0, u = n + (k & -4) | 0, k = u, (e | 0) != (f | 0)) for(f = k + (f - e | 0) | 0; i[k >> 2] = i[e >> 2], e = e + 4 | 0, k = k + 4 | 0, (f | 0) != (k | 0););
                                            i[A + 12 >> 2] = h, i[A + 8 >> 2] = k, i[A + 4 >> 2] = u, i[A >> 2] = n, X(r), f = i[A + 8 >> 2];
                                        }
                                        i[f >> 2] = s, i[A + 8 >> 2] = i[A + 8 >> 2] + 4;
                                        break e;
                                    }
                                    if (i[t + 28 >> 2] = A + 12, r = (r | 0) == (f | 0) ? 1 : u >> 1, r >>> 0 >= 1073741824) break i;
                                    s = r << 2, r = D(s), i[t + 12 >> 2] = r, u = r + s | 0, i[t + 24 >> 2] = u, f = r + n | 0, i[t + 16 >> 2] = f, h = D(4096);
                                    r: {
                                        if ((n | 0) != (s | 0)) break r;
                                        if ((n | 0) > 0) {
                                            f = f - ((n >>> 1 | 0) + 2 & -4) | 0, i[t + 16 >> 2] = f;
                                            break r;
                                        }
                                        if (e = (e | 0) == (k | 0) ? 1 : n >> 1, e >>> 0 >= 1073741824) break i;
                                        f = e << 2, n = D(f), i[t + 12 >> 2] = n, u = f + n | 0, i[t + 24 >> 2] = u, f = n + (e & -4) | 0, i[t + 16 >> 2] = f, X(r), k = i[A + 4 >> 2], e = i[A + 8 >> 2], r = n;
                                    }
                                    if (i[f >> 2] = h, s = f + 4 | 0, i[t + 20 >> 2] = s, (e | 0) != (k | 0)) {
                                        for(; e = e - 4 | 0, Vn(t + 12 | 0, e), k = i[A + 4 >> 2], (k | 0) != (e | 0););
                                        e = i[A + 8 >> 2], u = i[t + 24 >> 2], s = i[t + 20 >> 2], f = i[t + 16 >> 2], r = i[t + 12 >> 2];
                                    }
                                    if (n = i[A >> 2], i[A >> 2] = r, i[t + 12 >> 2] = n, i[A + 4 >> 2] = f, i[t + 16 >> 2] = k, i[A + 8 >> 2] = s, i[t + 20 >> 2] = e, r = i[A + 12 >> 2], i[A + 12 >> 2] = u, i[t + 24 >> 2] = r, (e | 0) != (k | 0) && (i[t + 20 >> 2] = ((k - e | 0) + 3 & -4) + e), !n) break e;
                                    X(n);
                                }
                                m = t + 32 | 0;
                                return;
                            }
                            Z2(), z();
                        }
                        function Dw(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], s = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(s, n), i[s + 72 >> 2] = 0, i[s + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, s = z0(n), i[s >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), t = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(M0(U(f + 12 | 0, 24976, 9), i[r + 104 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(k, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(M0(U(k, 22740, 23), I[r + 108 >> 1]), 34895, 1), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(k, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(k, 24385, 11), O4(f, i[r + 112 >> 2]), t = k, k = o[f + 11 | 0], n = (k | 0) < 0, k = U(U(t, n ? i[f >> 2] : f, n ? i[f + 4 >> 2] : k), 34895, 1), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(k, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = U(k, 24482, 11), k = o[r + 127 | 0], n = (k | 0) < 0, U(U(t, n ? i[r + 116 >> 2] : r + 116 | 0, n ? i[r + 120 >> 2] : k), 34895, 1), o[f + 11 | 0] < 0 && X(i[f >> 2]), k = i[r + 112 >> 2], (k | 0) == 1835625829 && (k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = U(f + 12 | 0, 24306, 14), k = o[r + 139 | 0], n = (k | 0) < 0, k = U(U(t, n ? i[r + 128 >> 2] : r + 128 | 0, n ? i[r + 132 >> 2] : k), 34895, 1), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(k, u ? i[f + 148 >> 2] : t, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = U(k, 23949, 18), k = o[r + 151 | 0], n = (k | 0) < 0, U(U(t, n ? i[r + 140 >> 2] : r + 140 | 0, n ? i[r + 144 >> 2] : k), 34895, 1), k = i[r + 112 >> 2]), (k | 0) == 1970432288 && (k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = U(f + 12 | 0, 24442, 15), k = o[r + 163 | 0], n = (k | 0) < 0, U(U(t, n ? i[r + 152 >> 2] : r + 152 | 0, n ? i[r + 156 >> 2] : k), 34895, 1)), k = f + 148 | 0, G0(k, e), n = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), e = U(f + 12 | 0, 23750, 13), k = i[i[e >> 2] - 12 >> 2] + e | 0, i[k + 4 >> 2] = i[k + 4 >> 2] | 1, U(qe(e, l[r + 164 | 0]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[s >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(s), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Mw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            k = m - 32 | 0, m = k, t = le() | 0;
                            i: {
                                if (!r) {
                                    i[A + 4 >> 2] = t, i[A >> 2] = 104328;
                                    break i;
                                }
                                I3(k + 4 | 0, r, k + 16 | 0, e, f, 0);
                                e: {
                                    if (!i[k + 4 >> 2]) {
                                        for(f = g4(12221) | 0, i[k + 24 >> 2] = i[k + 16 >> 2], e = U1(79720, k + 24 | 0) | 0, y4(t | 0, f | 0, e | 0), e >>> 0 >= 9 && t1(e | 0), f >>> 0 >= 9 && t1(f | 0), e = i[r >> 2], e ? e = i[e + 40 >> 2] : e = 0, f = g4(8984) | 0, i[k + 24 >> 2] = e, e = U1(72492, k + 24 | 0) | 0, y4(t | 0, f | 0, e | 0), e >>> 0 >= 9 && t1(e | 0), f >>> 0 >= 9 && t1(f | 0), r = i[r >> 2], r ? e = i[r + 44 >> 2] : e = 0, f = g4(3623) | 0, i[k + 24 >> 2] = e, r = U1(72492, k + 24 | 0) | 0, y4(t | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), r = i[i[i[k + 16 >> 2] >> 2] + 36 >> 2], f = g4(15650) | 0, i[k + 24 >> 2] = r, r = U1(79704, k + 24 | 0) | 0, y4(t | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), r = i[i[i[k + 16 >> 2] >> 2] + 32 >> 2], f = g4(12493) | 0, i[k + 24 >> 2] = r, r = U1(79696, k + 24 | 0) | 0, y4(t | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), v = D(32), f = v, r = i[10277], i[f >> 2] = i[10276], i[f + 4 >> 2] = r, r = i[10283], i[f + 24 >> 2] = i[10282], i[f + 28 >> 2] = r, r = i[10281], i[f + 16 >> 2] = i[10280], i[f + 20 >> 2] = r, r = i[10279], i[f + 8 >> 2] = i[10278], i[f + 12 >> 2] = r, w = u7() | 0;;){
                                            if (s = i[v + _ >> 2], A1(i[i[k + 16 >> 2] >> 2], s)) {
                                                u = le() | 0, f = g4(12814) | 0, i[k + 24 >> 2] = s, r = U1(79736, k + 24 | 0) | 0, y4(u | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0);
                                                r: {
                                                    A: {
                                                        if (r = i[k + 16 >> 2], !r || (r = i[r >> 2], !r) || (h = r - -64 | 0, f = h, r = i[r + 64 >> 2], !r)) break A;
                                                        for(; n = i[r + 16 >> 2] < (s | 0), f = n ? f : r, r = i[(n << 2) + r >> 2], !!r;);
                                                        if ((f | 0) == (h | 0)) break A;
                                                        if (r = 0, n = 0, i[f + 16 >> 2] > (s | 0)) break r;
                                                        r = i[f + 44 >> 2], n = i[f + 52 >> 2], f = (n | 0) < 0, r = f ? 0 : r, n = f ? B : n;
                                                        break r;
                                                    }
                                                    r = 0, n = 0;
                                                }
                                                h = g4(12360) | 0, B = n, i[k + 24 >> 2] = n, f = U1(72492, k + 24 | 0) | 0, y4(u | 0, h | 0, f | 0), f >>> 0 >= 9 && t1(f | 0), h >>> 0 >= 9 && t1(h | 0), i[k + 28 >> 2] = r, i[k + 24 >> 2] = Z(e, B), f = U1(79744, k + 24 | 0) | 0, r = g4(15625) | 0, y4(u | 0, r | 0, f | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), r = T4(i[i[k + 16 >> 2] >> 2], s), f = g4(8984) | 0, i[k + 24 >> 2] = r ? (r | 0) < 0 ? -1 : r : -1, r = U1(72492, k + 24 | 0) | 0, y4(u | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), r = S4(i[i[k + 16 >> 2] >> 2], s), f = g4(3623) | 0, i[k + 24 >> 2] = r ? (r | 0) < 0 ? -1 : r : -1, r = U1(72492, k + 24 | 0) | 0, y4(u | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), r = S0(i[i[k + 16 >> 2] >> 2], s), f = g4(8094) | 0, i[k + 24 >> 2] = r, r = U1(72492, k + 24 | 0) | 0, y4(u | 0, f | 0, r | 0), r >>> 0 >= 9 && t1(r | 0), f >>> 0 >= 9 && t1(f | 0), n = u >>> 0 < 9, n || fh(u | 0), i[k + 24 >> 2] = u, i[k + 20 >> 2] = 0;
                                                r: {
                                                    if (o[86792] & 1) {
                                                        f = i[21697];
                                                        break r;
                                                    }
                                                    f = Ah(2, 79752, 0) | 0, o[86792] = 1, i[21697] = f;
                                                }
                                                rh(f | 0, w | 0, 8990, k + 20 | 0, k + 24 | 0), r = i[k + 20 >> 2], r && eh(r | 0), n || t1(u | 0);
                                            }
                                            if (_ = _ + 4 | 0, (_ | 0) == 32) break;
                                        }
                                        break e;
                                    }
                                    if (e = D(12), i[e + 8 >> 2] = i[k + 12 >> 2], r = i[k + 8 >> 2], i[e >> 2] = i[k + 4 >> 2], i[e + 4 >> 2] = r, i[k + 24 >> 2] = e, G = A, W = U1(79596, k + 24 | 0) | 0, i[G + 4 >> 2] = W, i[A >> 2] = 104328, t >>> 0 < 9) break i;
                                    t1(t | 0);
                                    break i;
                                }
                                r = g4(4381) | 0, y4(t | 0, r | 0, w | 0), r >>> 0 >= 9 && t1(r | 0), i[A + 4 >> 2] = t, i[A >> 2] = 104328, w >>> 0 >= 9 && t1(w | 0), X(v);
                            }
                            m = k + 32 | 0;
                        }
                        function Uw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            n = m - 32 | 0, m = n, k = D(136), r = k, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r >> 2] = 78252, B0(r + 20 | 0, 0, 104), f = i[r + 4 >> 2], s = f + 1 | 0, i[r + 4 >> 2] = s, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, r = r - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[k + 132 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 128 >> 2] = 0, i[k + 84 >> 2] = 1, i[k + 88 >> 2] = 1, w = k + 76 | 0, i[k + 72 >> 2] = w, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, i[k + 112 >> 2] = 0, o[k + 113 | 0] = 0, o[k + 114 | 0] = 0, o[k + 115 | 0] = 0, o[k + 116 | 0] = 0, o[k + 117 | 0] = 0, o[k + 118 | 0] = 0, o[k + 119 | 0] = 0, o[k + 120 | 0] = 0, v = k + 12 | 0, i[k + 12 >> 2] = v, i[k + 8 >> 2] = i[k + 8 >> 2] + 1, i[k + 4 >> 2] = f, i[k + 16 >> 2] = k, s || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), r = i[e >> 2], s = i[r + 36 >> 2] - 12 | 0;
                            i: {
                                if (s >>> 0 >= 4) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                        r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                        break i;
                                    }
                                    j(A, i[21675], i[21676]);
                                    break i;
                                }
                                if (f = i[r + 24 >> 2], G = i[r + 28 >> 2], r = G, i[v + 36 >> 2] = i[(s << 2) + 46488 >> 2], i[v + 32 >> 2] = 1, i[v + 28 >> 2] = r, i[v + 24 >> 2] = f, J0(n + 8 | 0, v, 10, f, r, S0(i[e >> 2], 10), t), i[n + 8 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[n + 12 >> 2], i[A + 8 >> 2] = i[n + 8 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[n + 27 | 0] >= 0) {
                                        r = i[n + 20 >> 2], i[A >> 2] = i[n + 16 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 24 >> 2];
                                        break i;
                                    }
                                    if (j(A, i[n + 16 >> 2], i[n + 20 >> 2]), o[n + 27 | 0] >= 0) break i;
                                    X(i[n + 16 >> 2]);
                                    break i;
                                }
                                o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), t = 0;
                                e: {
                                    r: {
                                        if (r = i[e >> 2], e = i[r + 64 >> 2], !e) break r;
                                        for(f = r - -64 | 0, r = f; s = i[e + 16 >> 2] < 10, r = s ? r : e, e = i[(s << 2) + e >> 2], !!e;);
                                        if ((r | 0) == (f | 0)) break r;
                                        if (s = 0, i[r + 16 >> 2] > 10) break e;
                                        C = i[r + 44 >> 2], s = i[r + 52 >> 2];
                                        break e;
                                    }
                                    s = 0;
                                }
                                e = i[w >> 2], f = 0;
                                e: {
                                    if (!e) break e;
                                    for(r = w; f = i[e + 16 >> 2] < 10, r = f ? r : e, e = i[(f << 2) + e >> 2], !!e;);
                                    if ((r | 0) == (w | 0)) {
                                        f = 0;
                                        break e;
                                    }
                                    if (f = 0, i[r + 16 >> 2] > 10) break e;
                                    t = i[r + 52 >> 2], f = i[r + 44 >> 2];
                                }
                                e: {
                                    if (!G || (r = t >>> 0 < s >>> 0 ? t : s, !r)) break e;
                                    for(r = r - 1 | 0, e = (r >>> 1 | 0) + 1 | 0, V = e & -4, W = e & 3, y = r >>> 0 < 6;;){
                                        if (r = Z(t, B) + f | 0, w = Z(s, B) + C | 0, e = 0, _ = 0, !y) for(; u = r + e | 0, h = e + w | 0, o[u | 0] = l[h + 1 | 0], o[u + 1 | 0] = l[h | 0], u = e | 2, h = u + r | 0, u = u + w | 0, o[h | 0] = l[u + 1 | 0], o[h + 1 | 0] = l[u | 0], u = e | 4, h = u + r | 0, u = u + w | 0, o[h | 0] = l[u + 1 | 0], o[h + 1 | 0] = l[u | 0], u = e | 6, h = u + r | 0, u = u + w | 0, o[h | 0] = l[u + 1 | 0], o[h + 1 | 0] = l[u | 0], e = e + 8 | 0, _ = _ + 4 | 0, (V | 0) != (_ | 0););
                                        if (_ = 0, W) for(; u = r + e | 0, h = e + w | 0, o[u | 0] = l[h + 1 | 0], o[u + 1 | 0] = l[h | 0], e = e + 2 | 0, _ = _ + 1 | 0, (W | 0) != (_ | 0););
                                        if (B = B + 1 | 0, (B | 0) == (G | 0)) break;
                                    }
                                }
                                if (i[A + 4 >> 2] = k, i[A >> 2] = v, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A || (p[i[i[k >> 2] + 8 >> 2]](k), g(k)), m = n + 32 | 0;
                        }
                        function d7(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            t = m - 48 | 0, m = t, n = p[i[i[r >> 2] + 24 >> 2]](r) | 0, u = i[k + 4 >> 2], s = i[e >> 2], i[t + 44 >> 2] = i[s + 32 >> 2], i[t + 40 >> 2] = i[s + 36 >> 2], s = n || u, n = i[f >> 2];
                            i: {
                                if (i[n >> 2] >= 2) {
                                    p[i[n + 108 >> 2]](i[f + 4 >> 2], t + 44 | 0, t + 40 | 0);
                                    break i;
                                }
                                p[i[n + 96 >> 2]](t + 44 | 0, t + 40 | 0);
                            }
                            u = D(24), o[u + 22 | 0] = 1, Q[u + 20 >> 1] = 2, i[u + 16 >> 2] = 131074, i[u + 12 >> 2] = 78668, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 78292, w = u + 12 | 0, f = w, o[f + 10 | 0] = 1, Q[f + 8 >> 1] = 6, i[f + 4 >> 2] = 851969;
                            i: {
                                if (s) {
                                    dt(f, s);
                                    break i;
                                }
                                f = i[e >> 2], n = i[f + 44 >> 2], f = i[f + 48 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1);
                                e: {
                                    if (n) {
                                        i[u + 16 >> 2] = i[n + 4 >> 2], n = l[n + 7 | 0] | l[n + 8 | 0] << 8 | (l[n + 9 | 0] << 16 | l[n + 10 | 0] << 24), o[u + 19 | 0] = n, o[u + 20 | 0] = n >>> 8, o[u + 21 | 0] = n >>> 16, o[u + 22 | 0] = n >>> 24;
                                        break e;
                                    }
                                    o[w + 10 | 0] = 1, Q[w + 8 >> 1] = 2, i[w + 4 >> 2] = 131074;
                                }
                                if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            eo(w);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (h = i[t + 44 >> 2], n = i[e >> 2], f = i[t + 40 >> 2], !((h | 0) != i[n + 32 >> 2] | (f | 0) != i[n + 36 >> 2])) {
                                                    v = i[n + 44 >> 2], n = i[n + 48 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), _ = 1;
                                                    k: {
                                                        if (!s) {
                                                            f = n;
                                                            break k;
                                                        }
                                                        if (h) {
                                                            f = n;
                                                            break k;
                                                        }
                                                        n: {
                                                            if (v) {
                                                                f = n;
                                                                break n;
                                                            }
                                                            if (f = D(24), o[f + 22 | 0] = 1, Q[f + 20 >> 1] = 2, i[f + 16 >> 2] = 131074, i[f + 12 >> 2] = 78668, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = 78292, v = f + 12 | 0, o[v + 10 | 0] = 1, Q[f + 20 >> 1] = 6, i[f + 16 >> 2] = 851969, !n || (h = i[n + 4 >> 2], i[n + 4 >> 2] = h - 1, h)) break n;
                                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                        }
                                                        if (_ = 0, l[v + 10 | 0] == (!l[s + 16 | 0] | 0) | i[s + 12 >> 2] != I[v + 8 >> 1]) break k;
                                                        _ = i[s + 4 >> 2] == I[v + 4 >> 1];
                                                    }
                                                    k: {
                                                        if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break k;
                                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                                    }
                                                    if (_) break f;
                                                    h = i[t + 44 >> 2], f = i[t + 40 >> 2];
                                                }
                                                i[t + 8 >> 2] = u, i[t + 4 >> 2] = w, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, s6(t + 12 | 0, e, h, f, t + 4 | 0, 0, k + 16 | 0, i[r + 20 >> 2] - -64 | 0), r = i[t + 8 >> 2];
                                                k: {
                                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break k;
                                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                                }
                                                if (!i[t + 20 >> 2]) break r;
                                                if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[t + 24 >> 2], i[A + 8 >> 2] = i[t + 20 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[t + 39 | 0] < 0) break A;
                                                r = i[t + 32 >> 2], i[A >> 2] = i[t + 28 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[t + 36 >> 2];
                                                break e;
                                            }
                                            if (i[A >> 2] = i[e >> 2], r = i[e + 4 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        j(A, i[t + 28 >> 2], i[t + 32 >> 2]);
                                        break e;
                                    }
                                    if (i[A >> 2] = i[t + 12 >> 2], r = i[t + 16 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (o[t + 39 | 0] < 0 && X(i[t + 28 >> 2]), A = i[t + 16 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = t + 48 | 0;
                        }
                        function Hw(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            s = m - 16 | 0, m = s, u = i[k >> 2], n = u + i[e >> 2] | 0;
                            i: {
                                if (i[e + 4 >> 2] - n >>> 0 < (f | 0) / 8 << 2 >>> 0) {
                                    if (r = D(56), i[s + 4 >> 2] = r, i[s + 8 >> 2] = 54, i[s + 12 >> 2] = -2147483592, e = l[7274] | l[7275] << 8 | (l[7276] << 16 | l[7277] << 24), f = l[7270] | l[7271] << 8 | (l[7272] << 16 | l[7273] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 54 | 0] = 0, e = l[7320] | l[7321] << 8 | (l[7322] << 16 | l[7323] << 24), f = l[7316] | l[7317] << 8 | (l[7318] << 16 | l[7319] << 24), o[r + 46 | 0] = f, o[r + 47 | 0] = f >>> 8, o[r + 48 | 0] = f >>> 16, o[r + 49 | 0] = f >>> 24, o[r + 50 | 0] = e, o[r + 51 | 0] = e >>> 8, o[r + 52 | 0] = e >>> 16, o[r + 53 | 0] = e >>> 24, e = l[7314] | l[7315] << 8 | (l[7316] << 16 | l[7317] << 24), f = l[7310] | l[7311] << 8 | (l[7312] << 16 | l[7313] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[7306] | l[7307] << 8 | (l[7308] << 16 | l[7309] << 24), f = l[7302] | l[7303] << 8 | (l[7304] << 16 | l[7305] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[7298] | l[7299] << 8 | (l[7300] << 16 | l[7301] << 24), f = l[7294] | l[7295] << 8 | (l[7296] << 16 | l[7297] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7290] | l[7291] << 8 | (l[7292] << 16 | l[7293] << 24), f = l[7286] | l[7287] << 8 | (l[7288] << 16 | l[7289] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7282] | l[7283] << 8 | (l[7284] << 16 | l[7285] << 24), f = l[7278] | l[7279] << 8 | (l[7280] << 16 | l[7281] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, s + 4 | 0), o[s + 15 | 0] >= 0) break i;
                                    X(i[s + 4 >> 2]);
                                    break i;
                                }
                                t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 4 >> 2] = n, u = i[k >> 2], n = u + i[e >> 2] | 0, t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 8 >> 2] = n, t = i[e >> 2], h = i[k >> 2], e = t + h | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        e = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), n = 4;
                                        break e;
                                    }
                                    e = n | u << 8, n = 2;
                                }
                                i[k >> 2] = n + h, i[r + 12 >> 2] = e, e = t, t = i[k >> 2], e = e + t | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        f = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), e = 4;
                                        break e;
                                    }
                                    f = n | u << 8, e = 2;
                                }
                                if (i[k >> 2] = e + t, i[r + 16 >> 2] = f, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = s + 16 | 0;
                        }
                        function xw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            w = m - 32 | 0, m = w, u = w + 12 | 0, C = e, V = f, n = m - 48 | 0, m = n;
                            i: {
                                e: {
                                    if (v = i[r >> 2], f = i[v + 60 >> 2], B = v - -64 | 0, (f | 0) != (B | 0)) for(G = u + 8 | 0;;){
                                        IA(C, V, i[f + 16 >> 2], i[v + 36 >> 2], n + 44 | 0, n + 40 | 0), s = i[f + 16 >> 2];
                                        r: {
                                            if ((s | 0) == 10) {
                                                if (t = 255, e = i[v + 36 >> 2] - 10 | 0, e >>> 0 >= 6) break r;
                                                k = e << 3, e = k & 31, (k & 63) >>> 0 >= 32 ? t = 16432 >>> e | 0 : t = ((1 << e) - 1 & 16432) << 32 - e | 1076895768 >>> e;
                                                break r;
                                            }
                                            if (t = 0, k = B, e = i[k >> 2], !e) break r;
                                            for(; h = (s | 0) > i[e + 16 >> 2], k = h ? k : e, e = i[(h << 2) + e >> 2], !!e;);
                                            if ((k | 0) == (B | 0) | (s | 0) < i[k + 16 >> 2]) break r;
                                            t = l[k + 24 | 0] + 7 | 0;
                                        }
                                        if (h = i[f + 32 >> 2], s = i[f + 28 >> 2], _ = (t & 248) >>> 3 | 0, k = i[n + 44 >> 2], e = i[n + 40 >> 2], !(k >>> 0 <= k0[f + 36 >> 2] & e >>> 0 <= k0[f + 40 >> 2])) {
                                            Q[n + 8 >> 1] = 256, i[n + 4 >> 2] = 1, i[n + 36 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 12 >> 2] = 0, i[n + 16 >> 2] = 0, W = n + 4 | 0, t = e, y = i[f + 20 >> 2], F = l[f + 24 | 0], e = 1;
                                            r: {
                                                A: switch(i[v + 36 >> 2]){
                                                    case 10:
                                                    case 12:
                                                    case 14:
                                                        e = 3;
                                                        break r;
                                                    case 11:
                                                    case 13:
                                                    case 15:
                                                        e = 4;
                                                        break r;
                                                    case 0:
                                                    case 1:
                                                    case 2:
                                                    case 3:
                                                    case 99:
                                                        break r;
                                                    default:
                                                        break A;
                                                }
                                                e = 0;
                                            }
                                            if (Ve(u, W, k, t, y, F, e, 0), i[u >> 2]) break i;
                                            if (o[u + 19 | 0] < 0 && X(i[u + 8 >> 2]), k = i[n + 28 >> 2], !k) break e;
                                            if (i[f + 32 >> 2]) for(e = 0, t = i[n + 36 >> 2]; v0(k + Z(e, t) | 0, i[f + 44 >> 2] + Z(i[f + 52 >> 2], e) | 0, Z(i[f + 28 >> 2], _)), e = e + 1 | 0, e >>> 0 < k0[f + 32 >> 2];);
                                            e = i[n + 8 >> 2], i[f + 20 >> 2] = i[n + 4 >> 2], i[f + 24 >> 2] = e, i[f + 52 >> 2] = i[n + 36 >> 2], e = i[n + 32 >> 2], i[f + 44 >> 2] = i[n + 28 >> 2], i[f + 48 >> 2] = e, e = i[n + 24 >> 2], i[f + 36 >> 2] = i[n + 20 >> 2], i[f + 40 >> 2] = e, e = i[n + 16 >> 2], i[f + 28 >> 2] = i[n + 12 >> 2], i[f + 32 >> 2] = e, k = i[n + 44 >> 2];
                                        }
                                        if (!(!h | (k | 0) == (s | 0) | k >>> 0 <= s >>> 0)) for(W = Z(s - 1 | 0, _), t = 0;;){
                                            if (e = s, k >>> 0 > e >>> 0) for(; k = i[f + 44 >> 2] + Z(i[f + 52 >> 2], t) | 0, v0(k + Z(e, _) | 0, k + W | 0, _), e = e + 1 | 0, k = i[n + 44 >> 2], e >>> 0 < k >>> 0;);
                                            if (t = t + 1 | 0, (h | 0) == (t | 0)) break;
                                        }
                                        if (k0[n + 40 >> 2] > h >>> 0) for(e = h - 1 | 0; s = i[f + 44 >> 2], k = i[f + 52 >> 2], v0(s + Z(k, h) | 0, s + Z(e, k) | 0, Z(i[n + 44 >> 2], _)), h = h + 1 | 0, h >>> 0 < k0[n + 40 >> 2];);
                                        k = i[f + 4 >> 2];
                                        r: {
                                            if (k) {
                                                for(;;)if (e = k, k = i[e >> 2], !k) break r;
                                            }
                                            for(; e = i[f + 8 >> 2], k = i[e >> 2] != (f | 0), f = e, !!k;);
                                        }
                                        if (f = e, (B | 0) == (e | 0)) break;
                                    }
                                    if (e = i[21669], i[u >> 2] = i[21668], i[u + 4 >> 2] = e, e = u + 8 | 0, o[86691] >= 0) {
                                        f = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = f, i[e + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(e, i[21670], i[21671]);
                                    break i;
                                }
                                if (e = i[21674], i[u >> 2] = i[21673], i[u + 4 >> 2] = e, o[86711] >= 0) {
                                    e = i[21676], i[G >> 2] = i[21675], i[G + 4 >> 2] = e, i[G + 8 >> 2] = i[21677];
                                    break i;
                                }
                                j(G, i[21675], i[21676]);
                            }
                            m = n + 48 | 0;
                            i: {
                                if (i[w + 12 >> 2]) {
                                    e = A, A = i[r >> 2], j0(e, u, A ? A + 8 | 0 : 0);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[w + 31 | 0] < 0 && X(i[w + 20 >> 2]), m = w + 32 | 0;
                        }
                        function Ze(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            n = m - 192 | 0, m = n, _ = r + 36 | 0, h = A + 8 | 0, B = i[14959], y = B - 12 | 0, F = i[14960] - 12 | 0, E = i[14963] - 12 | 0, G = i[14961], R = G - 12 | 0, M = i[14968], H = i[14967], T = n + 36 | 0, S = n + 48 | 0, P = i[14965], $ = i[14964], c = i[14962], W = n + 28 | 0, C = n + 24 | 0, r0 = n + 80 | 0, f0 = (f | 0) == -1;
                            i: {
                                e: {
                                    r: {
                                        for(;;){
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            t: {
                                                                if (t = l[e + 20 | 0], !(!i[e + 16 >> 2] | t & 1)) {
                                                                    i[n + 184 >> 2] = 0, i[n + 188 >> 2] = 0, c6(n + 160 | 0, e, n + 184 | 0, k);
                                                                    o: {
                                                                        if (i[n + 160 >> 2] == i[21668] || (t = i[n + 184 >> 2], t && p[i[i[t >> 2] + 28 >> 2]](t) | 0)) break o;
                                                                        t = i[n + 164 >> 2], i[A >> 2] = i[n + 160 >> 2], i[A + 4 >> 2] = t, i[h + 8 >> 2] = i[n + 176 >> 2], t = i[n + 172 >> 2], i[h >> 2] = i[n + 168 >> 2], i[h + 4 >> 2] = t, i[n + 168 >> 2] = 0, i[n + 172 >> 2] = 0, i[n + 176 >> 2] = 0, t = 1;
                                                                        break A;
                                                                    }
                                                                    if (!f0) {
                                                                        t = i[r + 40 >> 2];
                                                                        break f;
                                                                    }
                                                                    if (u = i[(i[r + 16 >> 2] == 1768517222 ? 28 : 60) + k >> 2], t = i[r + 40 >> 2], !u | u >>> 0 >= t - i[_ >> 2] >> 3 >>> 0) break f;
                                                                    i[n + 16 >> 2] = G, i[n + 24 >> 2] = 59808, i[n + 80 >> 2] = 59828, t = n + 16 | 0, i[t + i[R >> 2] >> 2] = c, s = i[n + 16 >> 2], i[n + 20 >> 2] = 0, s = t + i[s - 12 >> 2] | 0, T0(s, W), i[s + 72 >> 2] = 0, i[s + 76 >> 2] = -1, i[i[E >> 2] + C >> 2] = $, i[t + i[F >> 2] >> 2] = P, i[n + 80 >> 2] = 59828, i[n + 16 >> 2] = 59788, i[n + 24 >> 2] = 59808, v = z0(W), i[v >> 2] = 58864, i[n + 68 >> 2] = 0, i[n + 72 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 64 >> 2] = 0, i[n + 76 >> 2] = 24, t = U(M0(U(C, 20900, 31), u), 21165, 6), u = n + 4 | 0, si(u, r), s = t, w = u, t = o[n + 15 | 0], u = (t | 0) < 0, U(U(s, u ? i[n + 4 >> 2] : w, u ? i[n + 8 >> 2] : t), 19926, 15), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), t = i[n + 76 >> 2];
                                                                    o: {
                                                                        if (t & 16) {
                                                                            if (t = S, u = i[n + 72 >> 2], s = i[n + 52 >> 2], u >>> 0 >= s >>> 0) break o;
                                                                            i[n + 72 >> 2] = s, u = s;
                                                                            break o;
                                                                        }
                                                                        if (!(t & 8)) {
                                                                            t = 0, o[n + 15 | 0] = 0, u = n + 4 | 0;
                                                                            break k;
                                                                        }
                                                                        u = i[n + 44 >> 2], t = T;
                                                                    }
                                                                    if (s = i[t >> 2], t = u - s | 0, t >>> 0 >= 2147483640) break t;
                                                                    if (t >>> 0 >= 11) {
                                                                        w = (t | 7) + 1 | 0, u = D(w), i[n + 12 >> 2] = w | -2147483648, i[n + 4 >> 2] = u, i[n + 8 >> 2] = t;
                                                                        break n;
                                                                    }
                                                                    if (o[n + 15 | 0] = t, u = n + 4 | 0, t) break n;
                                                                    t = 0;
                                                                    break k;
                                                                }
                                                                if (t & 1) break r;
                                                                break e;
                                                            }
                                                            Y0(), z();
                                                        }
                                                        Q0(u, s, t);
                                                    }
                                                    o[t + u | 0] = 0, i0(A, 6, 1e3, n + 4 | 0), o[n + 15 | 0] < 0 && X(i[n + 4 >> 2]), i[n + 16 >> 2] = B, i[i[y >> 2] + (n + 16 | 0) >> 2] = H, i[n + 24 >> 2] = M, i[v >> 2] = 58864, o[n + 71 | 0] < 0 && X(i[n + 60 >> 2]), x0(v), N0(r0), t = 1;
                                                    break A;
                                                }
                                                f: {
                                                    if (k0[r + 44 >> 2] > t >>> 0) {
                                                        i[t >> 2] = i[n + 184 >> 2], i[t + 4 >> 2] = i[n + 188 >> 2], i[n + 184 >> 2] = 0, i[n + 188 >> 2] = 0, t = t + 8 | 0;
                                                        break f;
                                                    }
                                                    t = p2(_, n + 184 | 0);
                                                }
                                                i[r + 40 >> 2] = t, V = V + 1 | 0, t = (f | 0) != -1 && (V | 0) == (f | 0) ? 3 : 0;
                                            }
                                            o[n + 179 | 0] < 0 && X(i[n + 168 >> 2]), u = i[n + 188 >> 2];
                                            A: {
                                                if (!u || (s = i[u + 4 >> 2], i[u + 4 >> 2] = s - 1, s)) break A;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                            }
                                            if (t) break;
                                        }
                                        if ((t | 0) != 3) break i;
                                        if (!(o[e + 20 | 0] & 1)) break e;
                                    }
                                    if (o[n + 16 | 0] = 0, o[n + 27 | 0] = 0, i0(A, 2, 100, n + 16 | 0), o[n + 27 | 0] >= 0) break i;
                                    X(i[n + 16 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, o[86691] >= 0) {
                                    A = i[21671], i[h >> 2] = i[21670], i[h + 4 >> 2] = A, i[h + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(h, i[21670], i[21671]);
                            }
                            m = n + 192 | 0;
                        }
                        function zw(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i[A + 4 >> 2] = 1, r = i[A + 12 >> 2], i[r + 324 >> 2] = i[r + 324 >> 2] - 1, i[r + 328 >> 2] = i[r + 328 >> 2] + 1, r = i[A + 12 >> 2], w = i[r + 124 >> 2], h = i[w + 16876 >> 2], _ = i[w + 16892 >> 2], f = _ - 1 | 0, r8(r, A, f, i[A + 8 >> 2], i[A + 24 >> 2]), e = i[A + 8 >> 2], (e | 0) > 0 && (r8(i[A + 12 >> 2], A, f, e - 1 | 0, i[A + 24 >> 2]), e = i[A + 8 >> 2]), r = e + 1 | 0, (r | 0) < i[w + 16900 >> 2] && (r8(i[A + 12 >> 2], A, f, r, i[A + 24 >> 2]), e = i[A + 8 >> 2], r = e + 1 | 0), n = i[A + 20 >> 2], f = i[A + 16 >> 2], r = r << h;
                            i: {
                                e: {
                                    r: {
                                        if (e = e << h, !(e & 1)) {
                                            if (s = i[f + 28 >> 2], k = (r | 0) > (s | 0) ? s : r, k & 1) break r;
                                            if (r = i[n + 124 >> 2], s = (i[r + 16840 >> 2] + 7 | 0) / 8 | 0, u = (i[r + 16832 >> 2] + 7 | 0) / 8 | 0, r = i[f + 40 >> 2], (r | 0) == i[n + 40 >> 2]) break e;
                                            if ((e | 0) >= (k | 0)) break i;
                                            for(r = e; t = Z(r, u), v0(i[n + 4 >> 2] + Z(t, i[n + 40 >> 2]) | 0, i[f + 4 >> 2] + Z(t, i[f + 40 >> 2]) | 0, Z(u, i[f + 24 >> 2])), r = r + 1 | 0, (k | 0) != (r | 0););
                                            break i;
                                        }
                                        y0(18404, 15041, 570, 7602), z();
                                    }
                                    y0(18419, 15041, 571, 7602), z();
                                }
                                t = Z(r, Z(e, u)), v0(t + i[n + 4 >> 2] | 0, t + i[f + 4 >> 2] | 0, Z(k - e | 0, Z(r, u)));
                            }
                            r = k, k = l[f + 51 | 0], r = (r | 0) / (k | 0) | 0, e = (e | 0) / (k | 0) | 0;
                            i: {
                                if (!i[f + 20 >> 2]) break i;
                                if (k = i[f + 44 >> 2], (k | 0) != i[n + 44 >> 2]) {
                                    if ((r | 0) <= (e | 0)) break i;
                                    for(; k = Z(e, s), v0(i[n + 8 >> 2] + Z(k, i[n + 44 >> 2]) | 0, i[f + 8 >> 2] + Z(k, i[f + 44 >> 2]) | 0, Z(s, i[f + 32 >> 2])), v0(i[n + 12 >> 2] + Z(k, i[n + 44 >> 2]) | 0, i[f + 12 >> 2] + Z(k, i[f + 44 >> 2]) | 0, Z(s, i[f + 32 >> 2])), e = e + 1 | 0, (r | 0) != (e | 0););
                                    break i;
                                }
                                u = Z(e, s), t = Z(u, k), r = Z(s, r - e | 0), v0(t + i[n + 8 >> 2] | 0, t + i[f + 8 >> 2] | 0, Z(r, k)), k = i[n + 12 >> 2], e = i[n + 44 >> 2], n = Z(e, u), v0(k + n | 0, n + i[f + 12 >> 2] | 0, Z(r, e));
                            }
                            i: {
                                if (i[w + 16892 >> 2] <= 0) break i;
                                for(r = 1 << h, e = 0;;){
                                    if (f = i[A + 12 >> 2], n = i[f + 52 >> 2], s = i[A + 8 >> 2], k = I[((i[f + 140 >> 2] + Z(Z(s, i[f + 152 >> 2]), 24) | 0) + Z(e, 24) | 0) + 2 >> 1], k >>> 0 >= i[f + 56 >> 2] - n >> 2 >>> 0 || (n = i[n + (k << 2) >> 2], !n)) break i;
                                    e: {
                                        if (!l[n + 333 | 0]) break e;
                                        if (u = i[A + 20 >> 2], k = i[u + 40 >> 2], u = i[u + 4 >> 2], t = i[A + 16 >> 2], h = i[t + 40 >> 2], t = i[t + 4 >> 2], i[i[f + 124 >> 2] + 16832 >> 2] >= 9) {
                                            ki(f, e, s, 0, r, r, t, h, u, k);
                                            break e;
                                        }
                                        ni(f, e, s, 0, r, r, t, h, u, k);
                                    }
                                    e: {
                                        if (!l[n + 334 | 0]) break e;
                                        f = (r | 0) / i[w + 16856 >> 2] | 0, n = (r | 0) / i[w + 16852 >> 2] | 0, s = i[A + 8 >> 2], u = i[A + 20 >> 2], k = i[u + 44 >> 2], u = i[u + 8 >> 2], t = i[A + 16 >> 2], h = i[t + 44 >> 2], t = i[t + 8 >> 2], v = i[A + 12 >> 2];
                                        r: {
                                            if (i[i[v + 124 >> 2] + 16840 >> 2] >= 9) {
                                                ki(v, e, s, 1, n, f, t, h, u, k);
                                                break r;
                                            }
                                            ni(v, e, s, 1, n, f, t, h, u, k);
                                        }
                                        if (s = i[A + 8 >> 2], u = i[A + 20 >> 2], k = i[u + 44 >> 2], u = i[u + 12 >> 2], t = i[A + 16 >> 2], h = i[t + 44 >> 2], t = i[t + 12 >> 2], v = i[A + 12 >> 2], i[i[v + 124 >> 2] + 16840 >> 2] >= 9) {
                                            ki(v, e, s, 2, n, f, t, h, u, k);
                                            break e;
                                        }
                                        ni(v, e, s, 2, n, f, t, h, u, k);
                                    }
                                    if (e = e + 1 | 0, !((e | 0) < i[w + 16892 >> 2])) break;
                                }
                            }
                            if (e = 0, (_ | 0) > 0) for(; r = (i[i[A + 12 >> 2] + 320 >> 2] + Z(e, 76) | 0) + Z(Z(i[A + 8 >> 2], i[w + 16892 >> 2]), 76) | 0, i[r >> 2] < 4 && (i[r >> 2] = 4), e = e + 1 | 0, (_ | 0) != (e | 0););
                            i[A + 4 >> 2] = 3, ur(i[A + 12 >> 2]);
                        }
                        function Tw(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (e = i[r + 24 >> 2], k = i[r + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                            A: {
                                                if (n = i[e >> 2], !n || (n = E0(n, 73632, 81740), !n)) break A;
                                                if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80240, t = e + 12 | 0, !k) break r;
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81348, i[k + 4 >> 2] != -1) break e;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break e;
                                            }
                                            if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                        }
                                        if (r = D(24), i[f + 16 >> 2] = r, i[f + 20 >> 2] = 18, i[f + 24 >> 2] = -2147483624, e = l[19809] | l[19810] << 8 | (l[19811] << 16 | l[19812] << 24), k = l[19805] | l[19806] << 8 | (l[19807] << 16 | l[19808] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 18 | 0] = 0, e = l[19821] | l[19822] << 8, o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, e = l[19817] | l[19818] << 8 | (l[19819] << 16 | l[19820] << 24), k = l[19813] | l[19814] << 8 | (l[19815] << 16 | l[19816] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 0, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81348;
                                }
                                i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                                e: {
                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                                e: {
                                    if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function Sw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            f = m - 16 | 0, m = f, W = r, C = n2(e), i[W + 100 >> 2] = C, W = r, C = n2(e), i[W + 104 >> 2] = C;
                            i: {
                                e: {
                                    if (u = i[r + 12 >> 2], s = i[r + 8 >> 2], !u & s >>> 0 >= 8 | u && (n = s - 8 | 0, s = u - (s >>> 0 < 8) | 0, k = i[r + 32 >> 2], !s & k >>> 0 <= n >>> 0 | s)) break e;
                                    if (r = D(40), i[f + 4 >> 2] = r, i[f + 8 >> 2] = 38, i[f + 12 >> 2] = -2147483608, k = l[20202] | l[20203] << 8 | (l[20204] << 16 | l[20205] << 24), e = l[20198] | l[20199] << 8 | (l[20200] << 16 | l[20201] << 24), o[r | 0] = e, o[r + 1 | 0] = e >>> 8, o[r + 2 | 0] = e >>> 16, o[r + 3 | 0] = e >>> 24, o[r + 4 | 0] = k, o[r + 5 | 0] = k >>> 8, o[r + 6 | 0] = k >>> 16, o[r + 7 | 0] = k >>> 24, o[r + 38 | 0] = 0, k = l[20232] | l[20233] << 8 | (l[20234] << 16 | l[20235] << 24), e = l[20228] | l[20229] << 8 | (l[20230] << 16 | l[20231] << 24), o[r + 30 | 0] = e, o[r + 31 | 0] = e >>> 8, o[r + 32 | 0] = e >>> 16, o[r + 33 | 0] = e >>> 24, o[r + 34 | 0] = k, o[r + 35 | 0] = k >>> 8, o[r + 36 | 0] = k >>> 16, o[r + 37 | 0] = k >>> 24, k = l[20226] | l[20227] << 8 | (l[20228] << 16 | l[20229] << 24), e = l[20222] | l[20223] << 8 | (l[20224] << 16 | l[20225] << 24), o[r + 24 | 0] = e, o[r + 25 | 0] = e >>> 8, o[r + 26 | 0] = e >>> 16, o[r + 27 | 0] = e >>> 24, o[r + 28 | 0] = k, o[r + 29 | 0] = k >>> 8, o[r + 30 | 0] = k >>> 16, o[r + 31 | 0] = k >>> 24, k = l[20218] | l[20219] << 8 | (l[20220] << 16 | l[20221] << 24), e = l[20214] | l[20215] << 8 | (l[20216] << 16 | l[20217] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, o[r + 20 | 0] = k, o[r + 21 | 0] = k >>> 8, o[r + 22 | 0] = k >>> 16, o[r + 23 | 0] = k >>> 24, k = l[20210] | l[20211] << 8 | (l[20212] << 16 | l[20213] << 24), e = l[20206] | l[20207] << 8 | (l[20208] << 16 | l[20209] << 24), o[r + 8 | 0] = e, o[r + 9 | 0] = e >>> 8, o[r + 10 | 0] = e >>> 16, o[r + 11 | 0] = e >>> 24, o[r + 12 | 0] = k, o[r + 13 | 0] = k >>> 8, o[r + 14 | 0] = k >>> 16, o[r + 15 | 0] = k >>> 24, i0(A, 2, 101, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                u = n - k | 0;
                                e: {
                                    if (k = s - (k >>> 0 > n >>> 0) | 0, !k & u >>> 0 < 4) break e;
                                    s = k >>> 2 | 0, G = (k & 3) << 30 | u >>> 2, u = 0, k = 0;
                                    r: {
                                        for(;;){
                                            if (l[e + 20 | 0] == 1) break e;
                                            B = n2(e);
                                            A: {
                                                h = i[r + 112 >> 2], n = i[r + 116 >> 2];
                                                f: {
                                                    if (h >>> 0 < n >>> 0) {
                                                        i[h >> 2] = B, v = h + 4 | 0;
                                                        break f;
                                                    }
                                                    if (_ = i[r + 108 >> 2], v = h - _ >> 2, t = v + 1 | 0, t >>> 0 >= 1073741824) break A;
                                                    if (w = n - _ | 0, n = w >> 1, w = w >>> 0 >= 2147483644 ? 1073741823 : n >>> 0 > t >>> 0 ? n : t, w) {
                                                        if (w >>> 0 >= 1073741824) break r;
                                                        n = D(w << 2);
                                                    } else n = 0;
                                                    if (t = n + (v << 2) | 0, i[t >> 2] = B, v = t + 4 | 0, (h | 0) != (_ | 0)) for(; t = t - 4 | 0, h = h - 4 | 0, i[t >> 2] = i[h >> 2], (h | 0) != (_ | 0););
                                                    if (i[r + 116 >> 2] = n + (w << 2), i[r + 112 >> 2] = v, i[r + 108 >> 2] = t, !_) break f;
                                                    X(_);
                                                }
                                                if (i[r + 112 >> 2] = v, n = u + 1 | 0, k = n ? k : k + 1 | 0, u = n, (n | 0) != (G | 0) | (k | 0) != (s | 0)) continue;
                                                break e;
                                            }
                                            break;
                                        }
                                        p0(), z();
                                    }
                                    Z2(), z();
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function jw(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            t = m - 48 | 0, m = t;
                            i: {
                                if (f) {
                                    f = m - 48 | 0, m = f, f5(f, r, k, n);
                                    e: {
                                        if (i[f + 28 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 32 >> 2], i[A + 8 >> 2] = i[f + 28 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[f + 47 | 0] >= 0) {
                                                r = i[f + 40 >> 2], i[A >> 2] = i[f + 36 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[f + 44 >> 2];
                                                break e;
                                            }
                                            j(A, i[f + 36 >> 2], i[f + 40 >> 2]);
                                            break e;
                                        }
                                        k = i[r + 480 >> 2], s = i[f + 20 >> 2], i[f + 20 >> 2] = 0, u = i[f + 4 >> 2], i[f + 4 >> 2] = 0, n = i[f >> 2], i[f >> 2] = 0, h = i[f + 12 >> 2], w = i[f + 16 >> 2], i[f + 12 >> 2] = 0, i[f + 16 >> 2] = 0, v = i[f + 24 >> 2], _ = l[f + 8 | 0], i[k + 4 >> 2] = n, n = i[k + 8 >> 2], i[k + 8 >> 2] = u;
                                        r: {
                                            if (!n || (u = i[n + 4 >> 2], i[n + 4 >> 2] = u - 1, u)) break r;
                                            p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                        }
                                        o[k + 12 | 0] = _, n = i[k + 16 >> 2], n && (i[k + 20 >> 2] = n, X(n)), i[k + 28 >> 2] = v, i[k + 24 >> 2] = s, i[k + 20 >> 2] = w, i[k + 16 >> 2] = h, k = A, A = i[r + 480 >> 2], p[i[i[A >> 2] + 28 >> 2]](k, A, e);
                                    }
                                    o[f + 47 | 0] < 0 && X(i[f + 36 >> 2]), A = i[f + 12 >> 2], A && (i[f + 16 >> 2] = A, X(A)), A = i[f + 4 >> 2];
                                    e: {
                                        if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    m = f + 48 | 0;
                                    break i;
                                }
                                r = D(48), i[t + 12 >> 2] = r, i[t + 16 >> 2] = 41, i[t + 20 >> 2] = -2147483600, o[r + 40 | 0] = l[10717], e = l[10713] | l[10714] << 8 | (l[10715] << 16 | l[10716] << 24), f = l[10709] | l[10710] << 8 | (l[10711] << 16 | l[10712] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[10705] | l[10706] << 8 | (l[10707] << 16 | l[10708] << 24), f = l[10701] | l[10702] << 8 | (l[10703] << 16 | l[10704] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[10697] | l[10698] << 8 | (l[10699] << 16 | l[10700] << 24), f = l[10693] | l[10694] << 8 | (l[10695] << 16 | l[10696] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[10689] | l[10690] << 8 | (l[10691] << 16 | l[10692] << 24), f = l[10685] | l[10686] << 8 | (l[10687] << 16 | l[10688] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, e = l[10681] | l[10682] << 8 | (l[10683] << 16 | l[10684] << 24), f = l[10677] | l[10678] << 8 | (l[10679] << 16 | l[10680] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 41 | 0] = 0, r = i0(t + 24 | 0, 4, 0, t + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = e, A = A + 16 | 0;
                                e: {
                                    if (o[r + 19 | 0] >= 0) {
                                        e = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 16 >> 2];
                                        break e;
                                    }
                                    if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break e;
                                    X(i[r + 8 >> 2]);
                                }
                                if (o[t + 23 | 0] >= 0) break i;
                                X(i[t + 12 >> 2]);
                            }
                            m = t + 48 | 0;
                        }
                        function Ow(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            t = m - 32 | 0, m = t, s = t + 12 | 0, _ = i[r >> 2], B = e, e = 0, n = m - 16 | 0, m = n;
                            i: {
                                if (k >>> 0 < 5) break i;
                                for(h = k - 4 | 0;;){
                                    if (u = e + f | 0, w = l[u + 1 | 0] << 8, v = l[u + 2 | 0] << 16 | l[u + 3 | 0] << 24, (l[u | 0] | w | v) == 704662861 | (v | (w | l[u | 0])) == 2771273) break i;
                                    if (e = e + 1 | 0, (h | 0) == (e | 0)) break;
                                }
                                e = h;
                            }
                            i: {
                                if (e >>> 0 >= k >>> 0) {
                                    if (e = D(64), i[n + 4 >> 2] = e, i[n + 8 >> 2] = 56, i[n + 12 >> 2] = -2147483584, f = l[19946] | l[19947] << 8 | (l[19948] << 16 | l[19949] << 24), k = l[19942] | l[19943] << 8 | (l[19944] << 16 | l[19945] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 56 | 0] = 0, f = l[19994] | l[19995] << 8 | (l[19996] << 16 | l[19997] << 24), k = l[19990] | l[19991] << 8 | (l[19992] << 16 | l[19993] << 24), o[e + 48 | 0] = k, o[e + 49 | 0] = k >>> 8, o[e + 50 | 0] = k >>> 16, o[e + 51 | 0] = k >>> 24, o[e + 52 | 0] = f, o[e + 53 | 0] = f >>> 8, o[e + 54 | 0] = f >>> 16, o[e + 55 | 0] = f >>> 24, f = l[19986] | l[19987] << 8 | (l[19988] << 16 | l[19989] << 24), k = l[19982] | l[19983] << 8 | (l[19984] << 16 | l[19985] << 24), o[e + 40 | 0] = k, o[e + 41 | 0] = k >>> 8, o[e + 42 | 0] = k >>> 16, o[e + 43 | 0] = k >>> 24, o[e + 44 | 0] = f, o[e + 45 | 0] = f >>> 8, o[e + 46 | 0] = f >>> 16, o[e + 47 | 0] = f >>> 24, f = l[19978] | l[19979] << 8 | (l[19980] << 16 | l[19981] << 24), k = l[19974] | l[19975] << 8 | (l[19976] << 16 | l[19977] << 24), o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, o[e + 34 | 0] = k >>> 16, o[e + 35 | 0] = k >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[19970] | l[19971] << 8 | (l[19972] << 16 | l[19973] << 24), k = l[19966] | l[19967] << 8 | (l[19968] << 16 | l[19969] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[19962] | l[19963] << 8 | (l[19964] << 16 | l[19965] << 24), k = l[19958] | l[19959] << 8 | (l[19960] << 16 | l[19961] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[19954] | l[19955] << 8 | (l[19956] << 16 | l[19957] << 24), k = l[19950] | l[19951] << 8 | (l[19952] << 16 | l[19953] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(s, 5, 2006, n + 4 | 0), o[n + 15 | 0] >= 0) break i;
                                    X(i[n + 4 >> 2]);
                                    break i;
                                }
                                if (i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, r1(n + 4 | 0, k + 4 | 0), o[i[n + 4 >> 2]] = e >>> 24, o[i[n + 4 >> 2] + 1 | 0] = e >>> 16, o[i[n + 4 >> 2] + 2 | 0] = e >>> 8, o[i[n + 4 >> 2] + 3 | 0] = e, e = i[n + 4 >> 2], v0(e + 4 | 0, f, k), li(s, _, B, e, i[n + 8 >> 2] - e | 0, 1165519206, 0, 0, 0), e = i[n + 4 >> 2], !e) break i;
                                i[n + 8 >> 2] = e, X(e);
                            }
                            m = n + 16 | 0;
                            i: {
                                if (i[t + 12 >> 2] != i[21668]) {
                                    j0(A, s, i[r >> 2]);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), m = t + 32 | 0;
                        }
                        function Pw(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            if (f = m - 160 | 0, m = f, i[f + 60 >> 2] = 60132, k = i[15036], i[f + 4 >> 2] = k, s = i[k - 12 >> 2], k = f + 4 | 0, i[s + k >> 2] = i[15037], n = k + i[i[f + 4 >> 2] - 12 >> 2] | 0, t = f + 8 | 0, T0(n, t), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, i[f + 60 >> 2] = 60132, i[f + 4 >> 2] = 60112, G = z0(t), i[G >> 2] = 58864, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 56 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), w = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(w, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = i[r + 104 >> 2], W = i[r + 108 >> 2], (t | 0) != (W | 0)) for(;;){
                                r = f + 148 | 0, G0(r, e), s = r, r = o[f + 159 | 0], k = (r | 0) < 0, U(f + 4 | 0, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), r = U(f + 4 | 0, 21172, 21), k = f + 148 | 0, si(k, t), w = r, s = k, r = o[f + 159 | 0], k = (r | 0) < 0, U(M0(U(U(U(w, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : r), 21213, 1), 24986, 10), i[t + 40 >> 2]), 23494, 9), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]);
                                i: {
                                    if (r = i[t + 44 >> 2], C = i[t + 48 >> 2], (r | 0) == (C | 0)) break i;
                                    for(;;){
                                        e: {
                                            _ = M0(f + 4 | 0, i[r >> 2]), w = C1(f + 140 | 0, _);
                                            r: {
                                                if (l[w | 0] != 1) break r;
                                                h = i[i[_ >> 2] - 12 >> 2] + _ | 0, B = i[h + 4 >> 2], n = i[h + 24 >> 2], v = i[h + 76 >> 2], (v | 0) == -1 && (u = f + 148 | 0, k = i[h + 28 >> 2], i[u >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(u, 108580), v = p[i[i[k >> 2] + 28 >> 2]](k, 32) | 0, d0(u), i[h + 76 >> 2] = v);
                                                A: {
                                                    if (!n || (k = i[h + 12 >> 2], B = (B & 176) == 32 ? 25194 : 25193, u = B - 25193 | 0, (u | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, 25193, u) | 0) != (u | 0))) break A;
                                                    if (k = (k | 0) > 1 ? k - 1 | 0 : 0, (k | 0) > 0) {
                                                        if (k >>> 0 >= 2147483640) break e;
                                                        f: {
                                                            if (k >>> 0 >= 11) {
                                                                s = (k | 7) + 1 | 0, u = D(s), i[f + 156 >> 2] = s | -2147483648, i[f + 148 >> 2] = u, i[f + 152 >> 2] = k;
                                                                break f;
                                                            }
                                                            o[f + 159 | 0] = k, u = f + 148 | 0;
                                                        }
                                                        if (V = B0(u, v, k) + k | 0, y = 0, o[V | 0] = y, v = p[i[i[n >> 2] + 48 >> 2]](n, o[f + 159 | 0] < 0 ? i[f + 148 >> 2] : f + 148 | 0, k) | 0, o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), (k | 0) != (v | 0)) break A;
                                                    }
                                                    if (k = 25194 - B | 0, (k | 0) > 0 && (p[i[i[n >> 2] + 48 >> 2]](n, B, k) | 0) != (k | 0)) break A;
                                                    i[h + 12 >> 2] = 0;
                                                    break r;
                                                }
                                                k = i[i[_ >> 2] - 12 >> 2] + _ | 0, N1(k, i[k + 16 >> 2] | 5);
                                            }
                                            if (G1(w), r = r + 4 | 0, (C | 0) != (r | 0)) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    Y0(), z();
                                }
                                if (U(f + 4 | 0, 34895, 1), t = t + 56 | 0, (W | 0) == (t | 0)) break;
                            }
                            r = i[f + 56 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 52 >> 2], e = i[f + 32 >> 2], r >>> 0 < e >>> 0 && (i[f + 52 >> 2] = e, r = e), e = f + 28 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 24 >> 2], e = f + 16 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 4 >> 2] = A, i[i[A - 12 >> 2] + (f + 4 | 0) >> 2] = i[15038], i[G >> 2] = 58864, o[f + 51 | 0] < 0 && X(i[f + 40 >> 2]), x0(G), N0(f + 60 | 0), m = f + 160 | 0;
                        }
                        function Ge(A, r, e) {
                            var f = 0, k = 0;
                            f = m - 656 | 0, m = f, r = r ? 8321 : 5856, l[A | 0] && (i[f + 644 >> 2] = o[A + 1 | 0], i[f + 640 >> 2] = r, e0(e, 30496, f + 640 | 0), i[f + 628 >> 2] = o[A + 2 | 0], i[f + 624 >> 2] = r, e0(e, 31730, f + 624 | 0), k = i[A + 4 >> 2] - 1 | 0, k >>> 0 <= 3 ? k = i[(k << 2) + 51432 >> 2] : k = 20271, i[f + 612 >> 2] = k, i[f + 608 >> 2] = r, e0(e, 25419, f + 608 | 0), i[f + 592 >> 2] = r, e0(e, 23198, f + 592 | 0), i[f + 576 >> 2] = o[A + 8 | 0], e0(e, 14669, f + 576 | 0), e0(e, 20125, 0), i[f + 560 >> 2] = o[A + 9 | 0], e0(e, 14669, f + 560 | 0), e0(e, 20125, 0), i[f + 544 >> 2] = o[A + 10 | 0], e0(e, 14669, f + 544 | 0), e0(e, 20125, 0), i[f + 528 >> 2] = o[A + 11 | 0], e0(e, 14669, f + 528 | 0), e0(e, 20125, 0), i[f + 512 >> 2] = o[A + 12 | 0], e0(e, 14669, f + 512 | 0), e0(e, 20125, 0), i[f + 496 >> 2] = o[A + 13 | 0], e0(e, 14669, f + 496 | 0), e0(e, 20125, 0), i[f + 480 >> 2] = o[A + 14 | 0], e0(e, 14669, f + 480 | 0), e0(e, 20125, 0), i[f + 464 >> 2] = o[A + 15 | 0], e0(e, 14669, f + 464 | 0), e0(e, 20125, 0), i[f + 448 >> 2] = o[A + 16 | 0], e0(e, 14669, f + 448 | 0), e0(e, 20125, 0), i[f + 432 >> 2] = o[A + 17 | 0], e0(e, 14669, f + 432 | 0), e0(e, 20125, 0), i[f + 416 >> 2] = o[A + 18 | 0], e0(e, 14669, f + 416 | 0), e0(e, 20125, 0), i[f + 400 >> 2] = o[A + 19 | 0], e0(e, 14669, f + 400 | 0), e0(e, 20125, 0), i[f + 384 >> 2] = o[A + 20 | 0], e0(e, 14669, f + 384 | 0), e0(e, 20125, 0), i[f + 368 >> 2] = o[A + 21 | 0], e0(e, 14669, f + 368 | 0), e0(e, 20125, 0), i[f + 352 >> 2] = o[A + 22 | 0], e0(e, 14669, f + 352 | 0), e0(e, 20125, 0), i[f + 336 >> 2] = o[A + 23 | 0], e0(e, 14669, f + 336 | 0), e0(e, 20125, 0), i[f + 320 >> 2] = o[A + 24 | 0], e0(e, 14669, f + 320 | 0), e0(e, 20125, 0), i[f + 304 >> 2] = o[A + 25 | 0], e0(e, 14669, f + 304 | 0), e0(e, 20125, 0), i[f + 288 >> 2] = o[A + 26 | 0], e0(e, 14669, f + 288 | 0), e0(e, 20125, 0), i[f + 272 >> 2] = o[A + 27 | 0], e0(e, 14669, f + 272 | 0), e0(e, 20125, 0), i[f + 256 >> 2] = o[A + 28 | 0], e0(e, 14669, f + 256 | 0), e0(e, 20125, 0), i[f + 240 >> 2] = o[A + 29 | 0], e0(e, 14669, f + 240 | 0), e0(e, 20125, 0), i[f + 224 >> 2] = o[A + 30 | 0], e0(e, 14669, f + 224 | 0), e0(e, 20125, 0), i[f + 208 >> 2] = o[A + 31 | 0], e0(e, 14669, f + 208 | 0), e0(e, 20125, 0), i[f + 192 >> 2] = o[A + 32 | 0], e0(e, 14669, f + 192 | 0), e0(e, 20125, 0), i[f + 176 >> 2] = o[A + 33 | 0], e0(e, 14669, f + 176 | 0), e0(e, 20125, 0), i[f + 160 >> 2] = o[A + 34 | 0], e0(e, 14669, f + 160 | 0), e0(e, 20125, 0), i[f + 144 >> 2] = o[A + 35 | 0], e0(e, 14669, f + 144 | 0), e0(e, 20125, 0), i[f + 128 >> 2] = o[A + 36 | 0], e0(e, 14669, f + 128 | 0), e0(e, 20125, 0), i[f + 112 >> 2] = o[A + 37 | 0], e0(e, 14669, f + 112 | 0), e0(e, 20125, 0), i[f + 96 >> 2] = o[A + 38 | 0], e0(e, 14669, f + 96 | 0), e0(e, 20125, 0), i[f + 80 >> 2] = o[A + 39 | 0], e0(e, 14669, f + 80 | 0), e0(e, 34660, 0), i[f + 68 >> 2] = o[A + 40 | 0], i[f + 64 >> 2] = r, e0(e, 28099, f - -64 | 0), i[f + 52 >> 2] = o[A + 41 | 0], i[f + 48 >> 2] = r, e0(e, 28136, f + 48 | 0), i[f + 36 >> 2] = o[A + 42 | 0], i[f + 32 >> 2] = r, e0(e, 27263, f + 32 | 0), i[f + 20 >> 2] = o[A + 43 | 0], i[f + 16 >> 2] = r, e0(e, 27223, f + 16 | 0)), l[A + 44 | 0] && (A = i[A + 48 >> 2], i[f + 4 >> 2] = A, i[f >> 2] = r, n0[f + 8 >> 3] = J(J(A | 0) / J(30)), e0(e, 34763, f)), m = f + 656 | 0;
                        }
                        function Lw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            h = m - 32 | 0, m = h, n = D(136), i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = 78252, B0(n + 20 | 0, 0, 104), r = i[n + 4 >> 2], s = r + 1 | 0, i[n + 4 >> 2] = s, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 44 >> 2] = 99, i[n + 48 >> 2] = 99, i[n + 32 >> 2] = 4142, f = n - -64 | 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[n + 132 >> 2] = 0, i[n + 124 >> 2] = 0, i[n + 128 >> 2] = 0, i[n + 84 >> 2] = 1, i[n + 88 >> 2] = 1, f = n + 76 | 0, i[n + 72 >> 2] = f, i[n + 92 >> 2] = 0, i[n + 96 >> 2] = 0, i[n + 100 >> 2] = 0, i[n + 104 >> 2] = 0, i[n + 108 >> 2] = 0, i[n + 112 >> 2] = 0, o[n + 113 | 0] = 0, o[n + 114 | 0] = 0, o[n + 115 | 0] = 0, o[n + 116 | 0] = 0, o[n + 117 | 0] = 0, o[n + 118 | 0] = 0, o[n + 119 | 0] = 0, o[n + 120 | 0] = 0, _ = n + 12 | 0, i[n + 12 >> 2] = _, i[n + 8 >> 2] = i[n + 8 >> 2] + 1, i[n + 4 >> 2] = r, i[n + 16 >> 2] = n, s || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), r = i[e >> 2], s = i[r + 24 >> 2], v = i[r + 28 >> 2], u = i[r + 32 >> 2], i[_ + 36 >> 2] = i[r + 36 >> 2], i[_ + 32 >> 2] = u, i[_ + 28 >> 2] = v, i[_ + 24 >> 2] = s;
                            i: {
                                for(;;){
                                    w = i[V + 46548 >> 2];
                                    e: {
                                        if (!A1(i[e >> 2], w)) break e;
                                        if (C = T4(i[e >> 2], w), y = S4(i[e >> 2], w), J0(h + 8 | 0, _, w, C, y, i[k + 12 >> 2], t), i[h + 8 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[h + 12 >> 2], i[A + 8 >> 2] = i[h + 8 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[h + 27 | 0] >= 0) {
                                                r = i[h + 20 >> 2], i[A >> 2] = i[h + 16 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[h + 24 >> 2];
                                                break i;
                                            }
                                            if (j(A, i[h + 16 >> 2], i[h + 20 >> 2]), o[h + 27 | 0] >= 0) break i;
                                            X(i[h + 16 >> 2]);
                                            break i;
                                        }
                                        o[h + 27 | 0] < 0 && X(i[h + 16 >> 2]), G = S0(i[e >> 2], w), W = 0, s = i[e >> 2], v = s - -64 | 0, r = v;
                                        r: {
                                            A: {
                                                if (u = i[s + 64 >> 2], !u) break A;
                                                for(; s = (w | 0) > i[u + 16 >> 2], r = s ? r : u, u = i[(s << 2) + u >> 2], !!u;);
                                                if ((r | 0) == (v | 0)) break A;
                                                if (F = 0, v = 0, (w | 0) < i[r + 16 >> 2]) break r;
                                                F = i[r + 44 >> 2], v = i[r + 52 >> 2];
                                                break r;
                                            }
                                            F = 0, v = 0;
                                        }
                                        r = f, u = i[r >> 2], s = 0;
                                        r: {
                                            if (!u) break r;
                                            for(; s = (w | 0) > i[u + 16 >> 2], r = s ? r : u, u = i[(s << 2) + u >> 2], !!u;);
                                            if ((r | 0) == (f | 0)) {
                                                s = 0;
                                                break r;
                                            }
                                            if (s = 0, (w | 0) < i[r + 16 >> 2]) break r;
                                            W = i[r + 52 >> 2], s = i[r + 44 >> 2];
                                        }
                                        if (!y | !C) break e;
                                        for(r = i[k + 12 >> 2], w = (G << 1) - r | 0, G = r - G | 0, H = W >>> 1 | 0, T = C & -2, S = C & 1, r = 0;;){
                                            if (W = Z(r, v) + F | 0, E = (Z(r, H) << 1) + s | 0, u = 0, R = 0, (C | 0) != 1) for(; B = l[u + W | 0], Q[E + (u << 1) >> 1] = B << G | B >>> w, M = u | 1, B = l[M + W | 0], Q[E + (M << 1) >> 1] = B << G | B >>> w, u = u + 2 | 0, R = R + 2 | 0, (T | 0) != (R | 0););
                                            if (S && (B = E + (u << 1) | 0, u = l[u + W | 0], Q[B >> 1] = u << G | u >>> w), r = r + 1 | 0, (y | 0) == (r | 0)) break;
                                        }
                                    }
                                    if (V = V + 4 | 0, (V | 0) == 28) break;
                                }
                                if (i[A + 4 >> 2] = n, i[A >> 2] = _, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = h + 32 | 0;
                        }
                        function Kw(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            s = m - 16 | 0, m = s, u = i[k >> 2], n = u + i[e >> 2] | 0;
                            i: {
                                if (i[e + 4 >> 2] - n >>> 0 < (f | 0) / 8 << 2 >>> 0) {
                                    if (r = D(56), i[s + 4 >> 2] = r, i[s + 8 >> 2] = 48, i[s + 12 >> 2] = -2147483592, e = l[7376] | l[7377] << 8 | (l[7378] << 16 | l[7379] << 24), f = l[7372] | l[7373] << 8 | (l[7374] << 16 | l[7375] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 48 | 0] = 0, e = l[7416] | l[7417] << 8 | (l[7418] << 16 | l[7419] << 24), f = l[7412] | l[7413] << 8 | (l[7414] << 16 | l[7415] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[7408] | l[7409] << 8 | (l[7410] << 16 | l[7411] << 24), f = l[7404] | l[7405] << 8 | (l[7406] << 16 | l[7407] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[7400] | l[7401] << 8 | (l[7402] << 16 | l[7403] << 24), f = l[7396] | l[7397] << 8 | (l[7398] << 16 | l[7399] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7392] | l[7393] << 8 | (l[7394] << 16 | l[7395] << 24), f = l[7388] | l[7389] << 8 | (l[7390] << 16 | l[7391] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7384] | l[7385] << 8 | (l[7386] << 16 | l[7387] << 24), f = l[7380] | l[7381] << 8 | (l[7382] << 16 | l[7383] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, s + 4 | 0), o[s + 15 | 0] >= 0) break i;
                                    X(i[s + 4 >> 2]);
                                    break i;
                                }
                                t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 4 >> 2] = n, u = i[k >> 2], n = u + i[e >> 2] | 0, t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 8 >> 2] = n, t = i[e >> 2], h = i[k >> 2], e = t + h | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        e = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), n = 4;
                                        break e;
                                    }
                                    e = n | u << 8, n = 2;
                                }
                                i[k >> 2] = n + h, i[r + 12 >> 2] = e, e = t, t = i[k >> 2], e = e + t | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        f = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), e = 4;
                                        break e;
                                    }
                                    f = n | u << 8, e = 2;
                                }
                                if (i[k >> 2] = e + t, i[r + 16 >> 2] = f, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = s + 16 | 0;
                        }
                        function qw(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            s = m - 16 | 0, m = s, u = i[k >> 2], n = u + i[e >> 2] | 0;
                            i: {
                                if (i[e + 4 >> 2] - n >>> 0 < (f | 0) / 8 << 2 >>> 0) {
                                    if (r = D(48), i[s + 4 >> 2] = r, i[s + 8 >> 2] = 46, i[s + 12 >> 2] = -2147483600, e = l[7329] | l[7330] << 8 | (l[7331] << 16 | l[7332] << 24), f = l[7325] | l[7326] << 8 | (l[7327] << 16 | l[7328] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 46 | 0] = 0, e = l[7367] | l[7368] << 8 | (l[7369] << 16 | l[7370] << 24), f = l[7363] | l[7364] << 8 | (l[7365] << 16 | l[7366] << 24), o[r + 38 | 0] = f, o[r + 39 | 0] = f >>> 8, o[r + 40 | 0] = f >>> 16, o[r + 41 | 0] = f >>> 24, o[r + 42 | 0] = e, o[r + 43 | 0] = e >>> 8, o[r + 44 | 0] = e >>> 16, o[r + 45 | 0] = e >>> 24, e = l[7361] | l[7362] << 8 | (l[7363] << 16 | l[7364] << 24), f = l[7357] | l[7358] << 8 | (l[7359] << 16 | l[7360] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[7353] | l[7354] << 8 | (l[7355] << 16 | l[7356] << 24), f = l[7349] | l[7350] << 8 | (l[7351] << 16 | l[7352] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7345] | l[7346] << 8 | (l[7347] << 16 | l[7348] << 24), f = l[7341] | l[7342] << 8 | (l[7343] << 16 | l[7344] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7337] | l[7338] << 8 | (l[7339] << 16 | l[7340] << 24), f = l[7333] | l[7334] << 8 | (l[7335] << 16 | l[7336] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, s + 4 | 0), o[s + 15 | 0] >= 0) break i;
                                    X(i[s + 4 >> 2]);
                                    break i;
                                }
                                t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 4 >> 2] = n, u = i[k >> 2], n = u + i[e >> 2] | 0, t = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        n = l[n + 3 | 0] | (h << 16 | t << 24 | l[n + 2 | 0] << 8), t = u + 4 | 0;
                                        break e;
                                    }
                                    n = (h << 16 | t << 24) >> 16, t = u + 2 | 0;
                                }
                                i[k >> 2] = t, i[r + 8 >> 2] = n, t = i[e >> 2], h = i[k >> 2], e = t + h | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        e = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), n = 4;
                                        break e;
                                    }
                                    e = n | u << 8, n = 2;
                                }
                                i[k >> 2] = n + h, i[r + 12 >> 2] = e, e = t, t = i[k >> 2], e = e + t | 0, u = l[e | 0], n = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        f = l[e + 3 | 0] | (n << 16 | u << 24 | l[e + 2 | 0] << 8), e = 4;
                                        break e;
                                    }
                                    f = n | u << 8, e = 2;
                                }
                                if (i[k >> 2] = e + t, i[r + 16 >> 2] = f, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = s + 16 | 0;
                        }
                        function $w(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], s = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(s, n), i[s + 72 >> 2] = 0, i[s + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, s = z0(n), i[s >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(k, 25115, 22), U(P0(k, i[r + 104 >> 2]), 22607, 3), U(P0(k, i[r + 108 >> 2]), 22607, 3), U(P0(k, i[r + 112 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(k, 21757, 12);
                            i: {
                                if (l[r + 116 | 0] == 1) {
                                    U(k, 34750, 12), n = f + 148 | 0, G0(n, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(I4(U(I4(U(I4(U(I4(U(f + 12 | 0, 15815, 7), n0[r + 120 >> 3]), 17465, 1), n0[r + 128 >> 3]), 17465, 1), n0[r + 136 >> 3]), 17465, 1), n0[r + 144 >> 3]), 34040, 2);
                                    break i;
                                }
                                k = f + 12 | 0, U(k, 34663, 9), n = f + 148 | 0, G0(n, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(I4(U(k, 25178, 9), n0[r + 152 >> 3]), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(I4(U(k, 23927, 9), n0[r + 160 >> 3]), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(I4(U(f + 12 | 0, 25147, 9), n0[r + 168 >> 3]), 34895, 1);
                            }
                            k = f + 148 | 0, G0(k, e), n = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 24699, 28), i[r + 176 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[s >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(s), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function c7(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            k = i[A + 18588 >> 2], v = i[k + 132 >> 2], f = -1 << i[v + 8268 >> 2], t = f & e, _ = i[A + 18592 >> 2], h = i[k + 124 >> 2], s = r & f, (s | 0) == i[A + 18524 >> 2] & (t | 0) == i[A + 18528 >> 2] || (i[A + 18528 >> 2] = t, i[A + 18524 >> 2] = s, i[A + 18532 >> 2] = i[A + 18520 >> 2]), f = i[h + 16876 >> 2], n = -1 << f ^ -1, u = i[_ + 808 >> 2], w = i[h + 16892 >> 2], k = (u | 0) / (w | 0) | 0, w = u - Z(k, w) | 0, u = i[h + 16884 >> 2], u = (s | 0) == (Z(w, u) | 0) & (t | 0) == (Z(k, u) | 0), k = 0;
                            i: {
                                if (!l[v + 46 | 0] || (k = 0, n & (t | s))) break i;
                                k = s9(v, s >> f, t >> f);
                            }
                            i: {
                                if (!(!l[v + 45 | 0] | (s | n & t)) || k | u) {
                                    k = i[A + 18592 >> 2] + 800 | 0;
                                    break i;
                                }
                                k = A + 18532 | 0;
                            }
                            f = i[k >> 2];
                            i: {
                                e: {
                                    u = s - 1 | 0;
                                    r: {
                                        if (!Fn(i[A + 18588 >> 2], s, t, u, t)) {
                                            n = i[A + 18588 >> 2], k = f;
                                            break r;
                                        }
                                        if (n = i[A + 18588 >> 2], w = i[h + 16936 >> 2], k = f, i[A + 4 >> 2] != i[(i[v + 8496 >> 2] + (u >> w << 2) | 0) + (Z(i[h + 16924 >> 2], t >> w) << 2) >> 2] >> (i[h + 16876 >> 2] - w << 1)) break r;
                                        if (k = u, u = i[n + 168 >> 2], k = k >> u, (k | 0) < 0 || (w = i[n + 172 >> 2], (w | 0) <= (k | 0))) break e;
                                        if (u = t >> u, (u | 0) < 0 | (u | 0) >= i[n + 176 >> 2]) break i;
                                        k = o[((i[n + 160 >> 2] + Z(k, 3) | 0) + Z(Z(u, w), 3) | 0) + 2 | 0];
                                    }
                                    u = n, n = t - 1 | 0;
                                    r: {
                                        if (!Fn(u, s, t, s, n) || (t = i[h + 16936 >> 2], i[A + 4 >> 2] != i[(i[v + 8496 >> 2] + (s >> t << 2) | 0) + (Z(i[h + 16924 >> 2], n >> t) << 2) >> 2] >> (i[h + 16876 >> 2] - t << 1))) break r;
                                        if (u = s, f = i[A + 18588 >> 2], s = i[f + 168 >> 2], t = u >> s, (t | 0) < 0 || (u = i[f + 172 >> 2], (u | 0) <= (t | 0))) break e;
                                        if (n = n >> s, (n | 0) < 0 | (n | 0) >= i[f + 176 >> 2]) break i;
                                        f = o[((i[f + 160 >> 2] + Z(t, 3) | 0) + Z(Z(n, u), 3) | 0) + 2 | 0];
                                    }
                                    k = i[A + 18504 >> 2] + ((f + k | 0) + 1 >> 1) | 0, f = i[h + 16836 >> 2], n = ((k + (f << 1) | 0) + 52 | 0) % (f + 52 | 0) | 0, i[A + 18536 >> 2] = (n | 0) > 0 ? n : 0, s = i[h + 16844 >> 2], k = 0 - s | 0, t = n - f | 0, f = i[A + 18516 >> 2] + (i[_ + 756 >> 2] + (t + i[v + 36 >> 2] | 0) | 0) | 0, n = (f | 0) < (k | 0) ? k : (f | 0) >= 57 ? 57 : f, f = i[A + 18512 >> 2] + (i[_ + 752 >> 2] + (t + i[v + 32 >> 2] | 0) | 0) | 0, f = (f | 0) < (k | 0) ? k : (f | 0) >= 57 ? 57 : f;
                                    r: {
                                        if (i[h + 16848 >> 2] != 1) break r;
                                        A: {
                                            if ((f | 0) < 30) break A;
                                            if (f >>> 0 >= 43) {
                                                f = f - 6 | 0;
                                                break A;
                                            }
                                            f = i[(f << 2) + 51224 >> 2];
                                        }
                                        if ((n | 0) < 30) break r;
                                        if (n >>> 0 >= 43) {
                                            n = n - 6 | 0;
                                            break r;
                                        }
                                        n = i[(n << 2) + 51224 >> 2];
                                    }
                                    if (k = n + s | 0, i[A + 18544 >> 2] = (k | 0) > 0 ? k : 0, k = f + s | 0, i[A + 18540 >> 2] = (k | 0) > 0 ? k : 0, f = i[A + 18588 >> 2], n = i[f + 168 >> 2], k = r >> n, (k | 0) < 0 || (h = i[f + 172 >> 2], (h | 0) <= (k | 0))) break e;
                                    if (r = e >> n, (r | 0) < 0 | i[f + 176 >> 2] <= (r | 0)) break i;
                                    if (f = i[f + 160 >> 2], e = (f + Z(k, 3) | 0) + Z(Z(r, h), 3) | 0, e = (l[e | 0] | l[e + 1 | 0] << 8) & 7, e = (e >>> 0 <= 3 ? 3 : e) - n | 0, (e | 0) != 31) for(e = 1 << e, n = e + r | 0, s = e + k | 0;;){
                                        for(v = (f + Z(Z(r, h), 3) | 0) + 2 | 0, e = k; o[v + Z(e, 3) | 0] = t, e = e + 1 | 0, (s | 0) > (e | 0););
                                        if (r = r + 1 | 0, !((n | 0) > (r | 0))) break;
                                    }
                                    i[A + 18520 >> 2] = t;
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function i5(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 96 | 0, m = n, i[n + 72 >> 2] = 0, i[n + 76 >> 2] = 0, i[n + 88 >> 2] = 0, i[n + 80 >> 2] = 0, i[n + 84 >> 2] = 0;
                            i: {
                                e: {
                                    t = i[r + 128 >> 2];
                                    r: {
                                        if (!t) break r;
                                        for(h = r + 128 | 0, u = h; s = k0[t + 16 >> 2] < e >>> 0, u = s ? u : t, t = i[(s << 2) + t >> 2], !!t;);
                                        if (s = 0, (u | 0) == (h | 0) | k0[u + 16 >> 2] > e >>> 0) break r;
                                        if (t = i[u + 20 >> 2], s = i[u + 24 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), t) break e;
                                    }
                                    if (o[n + 8 | 0] = 0, o[n + 19 | 0] = 0, i0(A, 5, 2e3, n + 8 | 0), o[n + 19 | 0] >= 0) break i;
                                    X(i[n + 8 >> 2]);
                                    break i;
                                }
                                u = i[t + 112 >> 2];
                                e: {
                                    if (o[t + 139 | 0] >= 0) {
                                        i[n - -64 >> 2] = i[t + 136 >> 2], h = i[t + 132 >> 2], i[n + 56 >> 2] = i[t + 128 >> 2], i[n + 60 >> 2] = h;
                                        break e;
                                    }
                                    j(n + 56 | 0, i[t + 128 >> 2], i[t + 132 >> 2]);
                                }
                                e: {
                                    if ((u | 0) != 1835625829) {
                                        k && (i[k >> 2] = 0), ei(A, i[r + 68 >> 2], e, r + 8 | 0, r + 76 | 0, f, 0, 0, -1, -1, i[r + 136 >> 2]);
                                        break e;
                                    }
                                    r: {
                                        if (o[t + 151 | 0] >= 0) {
                                            i[n + 48 >> 2] = i[t + 148 >> 2], u = i[t + 144 >> 2], i[n + 40 >> 2] = i[t + 140 >> 2], i[n + 44 >> 2] = u;
                                            break r;
                                        }
                                        j(n + 40 | 0, i[t + 140 >> 2], i[t + 144 >> 2]);
                                    }
                                    u = 2, h = o[n + 51 | 0], t = (h | 0) < 0;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: switch(h = t ? i[n + 44 >> 2] : h, h | 0){
                                                            case 2:
                                                                break f;
                                                            case 7:
                                                                break k;
                                                            case 13:
                                                                break n;
                                                            case 0:
                                                                break t;
                                                            default:
                                                                break A;
                                                        }
                                                        k && (i[k >> 2] = 0), ei(A, i[r + 68 >> 2], e, r + 8 | 0, r + 76 | 0, f, 0, 0, -1, -1, i[r + 136 >> 2]);
                                                        break r;
                                                    }
                                                    u = O2(t ? i[n + 40 >> 2] : n + 40 | 0, 15100, 13) ? 2 : 4;
                                                    break A;
                                                }
                                                u = O2(t ? i[n + 40 >> 2] : n + 40 | 0, 10068, h) ? 2 : 3;
                                                break A;
                                            }
                                            u = O2(t ? i[n + 40 >> 2] : n + 40 | 0, 6368, h) ? 2 : 5;
                                        }
                                        i[n + 36 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, ei(n + 8 | 0, i[r + 68 >> 2], e, r + 8 | 0, r + 76 | 0, n + 28 | 0, 0, 0, -1, -1, i[r + 136 >> 2]), e = i[n + 12 >> 2], r = i[n + 8 >> 2], i[n + 72 >> 2] = r, i[n + 76 >> 2] = e, o[n + 91 | 0] < 0 && (X(i[n + 80 >> 2]), r = i[n + 72 >> 2]), e = i[n + 20 >> 2], i[n + 80 >> 2] = i[n + 16 >> 2], i[n + 84 >> 2] = e, i[n + 88 >> 2] = i[n + 24 >> 2];
                                        A: {
                                            if (r) {
                                                r = i[n + 76 >> 2], i[A >> 2] = i[n + 72 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[n + 88 >> 2], r = i[n + 84 >> 2], i[A + 8 >> 2] = i[n + 80 >> 2], i[A + 12 >> 2] = r, i[n + 80 >> 2] = 0, i[n + 84 >> 2] = 0, i[n + 88 >> 2] = 0;
                                                break A;
                                            }
                                            if (k) {
                                                if (i[k >> 2] = u, r = i[f >> 2], r && (i[f + 4 >> 2] = r, X(r)), i[f >> 2] = i[n + 28 >> 2], i[f + 4 >> 2] = i[n + 32 >> 2], i[f + 8 >> 2] = i[n + 36 >> 2], i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 36 >> 2] = 0, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                    break A;
                                                }
                                                j(A, i[21670], i[21671]);
                                                break A;
                                            }
                                            if (o[n + 8 | 0] = 0, o[n + 19 | 0] = 0, i0(A, 3, 3005, n + 8 | 0), o[n + 19 | 0] >= 0) break A;
                                            X(i[n + 8 >> 2]);
                                        }
                                        if (A = i[n + 28 >> 2], !A) break r;
                                        i[n + 32 >> 2] = A, X(A);
                                    }
                                    if (o[n + 51 | 0] >= 0) break e;
                                    X(i[n + 40 >> 2]);
                                }
                                if (o[n + 67 | 0] >= 0) break i;
                                X(i[n + 56 >> 2]);
                            }
                            i: {
                                if (!s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            o[n + 91 | 0] < 0 && X(i[n + 80 >> 2]), m = n + 96 | 0;
                        }
                        function aw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if (s = m - 48 | 0, m = s, u = i[r >> 2], _ = i[u + 48 >> 2], v = i[u + 52 >> 2], v && (i[v + 4 >> 2] = i[v + 4 >> 2] + 1), h = E2(f), h >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (h >>> 0 >= 11) {
                                            w = (h | 7) + 1 | 0, u = D(w), i[s + 20 >> 2] = w | -2147483648, i[s + 12 >> 2] = u, i[s + 16 >> 2] = h;
                                            break e;
                                        }
                                        if (o[s + 23 | 0] = h, u = s + 12 | 0, !h) break i;
                                    }
                                    v0(u, f, h);
                                }
                                o[u + h | 0] = 0, f = m + -64 | 0, m = f, i[s + 24 >> 2] = 0, i[s + 28 >> 2] = 0, i[s + 32 >> 2] = 0, i[s + 44 >> 2] = 0, i[s + 36 >> 2] = 0, i[s + 40 >> 2] = 0, m8(f + 56 | 0, _, 1835625829), w = i[f + 56 >> 2], u = w, o[u + 164 | 0] = 1, i[u + 100 >> 2] = i[u + 100 >> 2] & -2 | 1;
                                i: {
                                    if (h = E2(e), h >>> 0 < 2147483640) {
                                        e: {
                                            r: {
                                                if (h >>> 0 >= 11) {
                                                    B = (h | 7) + 1 | 0, u = D(B), i[f + 52 >> 2] = B | -2147483648, i[f + 44 >> 2] = u, i[f + 48 >> 2] = h;
                                                    break r;
                                                }
                                                if (o[f + 55 | 0] = h, u = f + 44 | 0, !h) break e;
                                            }
                                            v0(u, e, h);
                                        }
                                        o[u + h | 0] = 0, e = w + 128 | 0;
                                        e: {
                                            if ((e | 0) == (f + 44 | 0)) break e;
                                            if (u = o[f + 55 | 0], o[w + 139 | 0] >= 0) {
                                                if ((u | 0) >= 0) {
                                                    u = i[f + 48 >> 2], i[e >> 2] = i[f + 44 >> 2], i[e + 4 >> 2] = u, i[e + 8 >> 2] = i[f + 52 >> 2];
                                                    break e;
                                                }
                                                X4(e, i[f + 44 >> 2], i[f + 48 >> 2]);
                                                break e;
                                            }
                                            w = e, e = (u | 0) < 0, Y4(w, e ? i[f + 44 >> 2] : f + 44 | 0, e ? i[f + 48 >> 2] : u);
                                        }
                                        o[f + 55 | 0] < 0 && X(i[f + 44 >> 2]), i[s + 24 >> 2] = i[i[f + 56 >> 2] + 104 >> 2], i[f + 16 >> 2] = i[s + 20 >> 2], e = i[s + 16 >> 2], i[f + 8 >> 2] = i[s + 12 >> 2], i[f + 12 >> 2] = e, i[s + 12 >> 2] = 0, i[s + 16 >> 2] = 0, i[s + 20 >> 2] = 0, u = f + 8 | 0, e = m - 32 | 0, m = e, i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, n ? (r1(e, n), w = i[e >> 2]) : w = 0, v0(w, k, n), h = i[f + 56 >> 2], k = h + 140 | 0;
                                        e: {
                                            if ((k | 0) == (u | 0)) break e;
                                            if (n = o[u + 11 | 0], o[h + 151 | 0] >= 0) {
                                                if ((n | 0) >= 0) {
                                                    n = i[u + 4 >> 2], i[k >> 2] = i[u >> 2], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[u + 8 >> 2];
                                                    break e;
                                                }
                                                X4(k, i[u >> 2], i[u + 4 >> 2]);
                                                break e;
                                            }
                                            w = k, k = (n | 0) < 0, Y4(w, k ? i[u >> 2] : u, k ? i[u + 4 >> 2] : n);
                                        }
                                        B3(e + 12 | 0, i[_ + 68 >> 2], i[i[f + 56 >> 2] + 104 >> 2], e, 0), o[e + 31 | 0] < 0 && X(i[e + 20 >> 2]), n = i[21669], k = f + 24 | 0, i[k >> 2] = i[21668], i[k + 4 >> 2] = n, k = k + 8 | 0;
                                        e: {
                                            if (o[86691] >= 0) {
                                                n = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[21672];
                                                break e;
                                            }
                                            j(k, i[21670], i[21671]);
                                        }
                                        k = i[e >> 2], k && (i[e + 4 >> 2] = k, X(k)), m = e + 32 | 0, o[f + 43 | 0] < 0 && X(i[f + 32 >> 2]), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), e = i[f + 60 >> 2];
                                        e: {
                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break e;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        m = f - -64 | 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                o[s + 23 | 0] < 0 && X(i[s + 12 >> 2]);
                                i: {
                                    if (!v || (e = i[v + 4 >> 2], i[v + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[v >> 2] + 8 >> 2]](v), g(v);
                                }
                                i: {
                                    if (!(i[s + 28 >> 2] | !t)) {
                                        i[t >> 2] = i[s + 24 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                        break i;
                                    }
                                    j0(A, s + 28 | 0, i[r >> 2]);
                                }
                                o[s + 47 | 0] < 0 && X(i[s + 36 >> 2]), m = s + 48 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function e5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            i: {
                                e: {
                                    r: {
                                        A: switch(r - A >> 3){
                                            case 2:
                                                if (i[r - 4 >> 2] <= i[A + 4 >> 2]) break r;
                                                return f = i[A >> 2], e = i[A + 4 >> 2], k = r - 8 | 0, r = i[k + 4 >> 2], i[A >> 2] = i[k >> 2], i[A + 4 >> 2] = r, i[k >> 2] = f, i[k + 4 >> 2] = e, 1;
                                            case 3:
                                                if (n = r - 8 | 0, k = r - 4 | 0, f = i[k >> 2], e = i[A + 12 >> 2], (e | 0) <= i[A + 4 >> 2]) {
                                                    if ((e | 0) >= (f | 0) || (f = i[A + 8 >> 2], e = i[A + 12 >> 2], r = i[n + 4 >> 2], i[A + 8 >> 2] = i[n >> 2], i[A + 12 >> 2] = r, i[n >> 2] = f, i[n + 4 >> 2] = e, i[A + 12 >> 2] <= i[A + 4 >> 2])) break r;
                                                    r = i[A + 8 >> 2], e = i[A + 12 >> 2];
                                                    break e;
                                                }
                                                if (r = i[A >> 2], t = i[A + 4 >> 2], (e | 0) < (f | 0)) {
                                                    e = i[n + 4 >> 2], i[A >> 2] = i[n >> 2], i[A + 4 >> 2] = e;
                                                    break i;
                                                }
                                                if (f = i[A + 8 >> 2], e = i[A + 12 >> 2], i[A + 8 >> 2] = r, i[A + 12 >> 2] = t, i[A >> 2] = f, i[A + 4 >> 2] = e, (t | 0) >= i[k >> 2]) break r;
                                                e = i[n + 4 >> 2], i[A + 8 >> 2] = i[n >> 2], i[A + 12 >> 2] = e;
                                                break i;
                                            case 4:
                                                return De(A, A + 8 | 0, A + 16 | 0, r - 8 | 0), 1;
                                            case 5:
                                                if (De(A, A + 8 | 0, A + 16 | 0, A + 24 | 0), i[r - 4 >> 2] <= i[A + 28 >> 2] || (f = i[A + 24 >> 2], e = i[A + 28 >> 2], k = r - 8 | 0, r = i[k + 4 >> 2], i[A + 24 >> 2] = i[k >> 2], i[A + 28 >> 2] = r, i[k >> 2] = f, i[k + 4 >> 2] = e, i[A + 28 >> 2] <= i[A + 20 >> 2]) || (r = i[A + 24 >> 2], e = i[A + 28 >> 2], f = i[A + 20 >> 2], i[A + 24 >> 2] = i[A + 16 >> 2], i[A + 28 >> 2] = f, i[A + 16 >> 2] = r, i[A + 20 >> 2] = e, (e | 0) <= i[A + 12 >> 2]) || (f = i[A + 12 >> 2], i[A + 16 >> 2] = i[A + 8 >> 2], i[A + 20 >> 2] = f, i[A + 8 >> 2] = r, i[A + 12 >> 2] = e, (e | 0) <= i[A + 4 >> 2])) break r;
                                                break e;
                                            case 0:
                                            case 1:
                                                break r;
                                            default:
                                                break A;
                                        }
                                        t = i[A + 20 >> 2], f = i[A + 12 >> 2], k = i[A + 4 >> 2];
                                        A: {
                                            if ((f | 0) <= (k | 0)) {
                                                if ((f | 0) >= (t | 0) || (e = i[A + 16 >> 2], t = i[A + 20 >> 2], f = i[A + 12 >> 2], i[A + 16 >> 2] = i[A + 8 >> 2], i[A + 20 >> 2] = f, i[A + 8 >> 2] = e, i[A + 12 >> 2] = t, (k | 0) >= (t | 0))) break A;
                                                f = i[A + 4 >> 2], i[A + 8 >> 2] = i[A >> 2], i[A + 12 >> 2] = f, i[A >> 2] = e, i[A + 4 >> 2] = t;
                                                break A;
                                            }
                                            if (e = i[A >> 2], n = i[A + 4 >> 2], (f | 0) < (t | 0)) {
                                                k = i[A + 16 >> 2], f = i[A + 20 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = n, i[A >> 2] = k, i[A + 4 >> 2] = f;
                                                break A;
                                            }
                                            if (k = i[A + 8 >> 2], f = i[A + 12 >> 2], i[A + 8 >> 2] = e, i[A + 12 >> 2] = n, i[A >> 2] = k, i[A + 4 >> 2] = f, (n | 0) >= (t | 0)) break A;
                                            k = i[A + 16 >> 2], f = i[A + 20 >> 2], i[A + 16 >> 2] = e, i[A + 20 >> 2] = n, i[A + 8 >> 2] = k, i[A + 12 >> 2] = f;
                                        }
                                        if (k = A + 24 | 0, (k | 0) == (r | 0)) break r;
                                        for(f = A + 16 | 0;;){
                                            A: {
                                                if (i[k + 4 >> 2] <= i[f + 4 >> 2]) break A;
                                                for(s = i[k >> 2], n = i[k + 4 >> 2], e = k;;){
                                                    f: {
                                                        if (t = e, e = f, f = i[e + 4 >> 2], i[t >> 2] = i[e >> 2], i[t + 4 >> 2] = f, (A | 0) == (e | 0)) break f;
                                                        if (f = e - 8 | 0, i[e - 4 >> 2] < (n | 0)) continue;
                                                    }
                                                    break;
                                                }
                                                if (i[e >> 2] = s, i[e + 4 >> 2] = n, u = u + 1 | 0, (u | 0) != 8) break A;
                                                return (k + 8 | 0) == (r | 0);
                                            }
                                            if (f = k, k = k + 8 | 0, (k | 0) == (r | 0)) break;
                                        }
                                    }
                                    return 1;
                                }
                                return f = i[A + 4 >> 2], i[A + 8 >> 2] = i[A >> 2], i[A + 12 >> 2] = f, i[A >> 2] = r, i[A + 4 >> 2] = e, 1;
                            }
                            return i[n >> 2] = r, i[n + 4 >> 2] = t, 1;
                        }
                        function bw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            f = m - 16 | 0, m = f, _ = r, B = X2(e), o[_ + 100 | 0] = B, _ = r, B = X2(e), o[_ + 101 | 0] = B, _ = r, B = X2(e), o[_ + 102 | 0] = B, _ = r, B = X2(e), o[_ + 103 | 0] = B, _ = r, B = (X2(e) & 3) + 1 | 0, o[_ + 104 | 0] = B;
                            i: {
                                if (h = X2(e) & 31, !h) break i;
                                for(v = r + 116 | 0;;){
                                    t = B2(e), i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, n = 0, k = 0, t && (k = D(t), i[f + 4 >> 2] = k, n = k + t | 0, i[f + 12 >> 2] = n, B0(k, 0, t), i[f + 8 >> 2] = n), Y6(e, k, n - k | 0);
                                    e: {
                                        k = i[r + 120 >> 2];
                                        r: {
                                            if (k >>> 0 < k0[r + 124 >> 2]) {
                                                if (i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, n = i[f + 8 >> 2], u = i[f + 4 >> 2], (n | 0) != (u | 0)) {
                                                    if (n = n - u | 0, (n | 0) < 0) break e;
                                                    t = D(n), i[k + 4 >> 2] = t, i[k >> 2] = t, w = n + t | 0, i[k + 8 >> 2] = w, v0(t, u, n), i[k + 4 >> 2] = w;
                                                }
                                                k = k + 12 | 0;
                                                break r;
                                            }
                                            k = B6(v, f + 4 | 0);
                                        }
                                        if (i[r + 120 >> 2] = k, k = i[f + 4 >> 2], k && (i[f + 8 >> 2] = k, X(k)), s = s + 1 | 0, (h | 0) != (s | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                p0(), z();
                            }
                            i: {
                                if (h = X2(e), !h) break i;
                                for(v = r + 128 | 0, s = 0;;){
                                    t = B2(e), i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, n = 0, k = 0, t && (k = D(t), i[f + 4 >> 2] = k, n = k + t | 0, i[f + 12 >> 2] = n, B0(k, 0, t), i[f + 8 >> 2] = n), Y6(e, k, n - k | 0);
                                    e: {
                                        k = i[r + 132 >> 2];
                                        r: {
                                            if (k >>> 0 < k0[r + 136 >> 2]) {
                                                if (i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, n = i[f + 8 >> 2], u = i[f + 4 >> 2], (n | 0) != (u | 0)) {
                                                    if (n = n - u | 0, (n | 0) < 0) break e;
                                                    t = D(n), i[k + 4 >> 2] = t, i[k >> 2] = t, w = n + t | 0, i[k + 8 >> 2] = w, v0(t, u, n), i[k + 4 >> 2] = w;
                                                }
                                                k = k + 12 | 0;
                                                break r;
                                            }
                                            k = B6(v, f + 4 | 0);
                                        }
                                        if (i[r + 132 >> 2] = k, k = i[f + 4 >> 2], k && (i[f + 8 >> 2] = k, X(k)), s = s + 1 | 0, (h | 0) != (s | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                p0(), z();
                            }
                            i: {
                                k = l[r + 101 | 0] - 66 | 0;
                                e: {
                                    if (1 << k & 4196353 && k >>> 0 <= 22 || (_ = r, B = X2(e) & 3, i[_ + 108 >> 2] = B, _ = r, B = X2(e) & 7 | 8, o[_ + 112 | 0] = B, _ = r, B = X2(e) & 7 | 8, o[_ + 113 | 0] = B, h = X2(e), !h)) break e;
                                    for(v = r + 140 | 0, s = 0;;){
                                        t = B2(e), i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, n = 0, k = 0, t && (k = D(t), i[f + 4 >> 2] = k, n = k + t | 0, i[f + 12 >> 2] = n, B0(k, 0, t), i[f + 8 >> 2] = n), Y6(e, k, n - k | 0), k = i[r + 144 >> 2];
                                        r: {
                                            if (k >>> 0 < k0[r + 148 >> 2]) {
                                                if (i[k + 8 >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, n = i[f + 8 >> 2], u = i[f + 4 >> 2], (n | 0) != (u | 0)) {
                                                    if (n = n - u | 0, (n | 0) < 0) break i;
                                                    t = D(n), i[k + 4 >> 2] = t, i[k >> 2] = t, w = n + t | 0, i[k + 8 >> 2] = w, v0(t, u, n), i[k + 4 >> 2] = w;
                                                }
                                                k = k + 12 | 0;
                                                break r;
                                            }
                                            k = B6(v, f + 4 | 0);
                                        }
                                        if (i[r + 144 >> 2] = k, k = i[f + 4 >> 2], k && (i[f + 8 >> 2] = k, X(k)), s = s + 1 | 0, (h | 0) == (s | 0)) break;
                                    }
                                }
                                e: {
                                    if (l[e + 20 | 0] == 1) {
                                        if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break e;
                                        X(i[f + 4 >> 2]);
                                        break e;
                                    }
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                m = f + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function ti(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = r - 1 | 0, e = f, u = (f | 0) / 2 | 0, f = r + 65535 >>> 0 < 131073, u = f ? e : u, k = i[A + 124 >> 2], t = k >> 31, r = f ? 2 : 1, n = i[A + 128 >> 2];
                            i: {
                                if ((r | 0) == (n | 0)) {
                                    if (e = (u >> 31) + t | 0, n = k + u | 0, e = n >>> 0 < u >>> 0 ? e + 1 | 0 : e, (e - (n >>> 0 < 2147483648) | 0) == -1) break i;
                                    r = e >> 31, u = r, r = n + (r | 1) | 0, e = e + u | 0, n = m2(r, r >>> 0 < n >>> 0 ? e + 1 | 0 : e, 2, 0), r = 1;
                                    break i;
                                }
                                if (r = n, s = r >> 31, n = O0(r, s, u, u >> 31), h = w0, w = n, e = k, n = f & 31, (f & 63) >>> 0 >= 32 ? (u = e << n, k = 0) : (u = (1 << n) - 1 & e >>> 32 - n | t << n, k = e << n), n = w + k | 0, e = u + h | 0, e = k >>> 0 > n >>> 0 ? e + 1 | 0 : e, t = e, h = (e - (n >>> 0 < 2147483648) | 0) == -1, u = r, k = f & 31, (f & 63) >>> 0 >= 32 ? (e = r << k, f = 0) : (e = (1 << k) - 1 & u >>> 32 - k | s << k, f = u << k), k = e, !((e - (f >>> 0 < 2147483648) | 0) == -1 & h)) for(; r = k >> 31, e = r, r = f + (e | 1) | 0, e = e + k | 0, f = m2(r, r >>> 0 < f >>> 0 ? e + 1 | 0 : e, 2, 0), k = w0, s = k - (f >>> 0 < 2147483648) | 0, r = t >> 31, u = r, r = n + (r | 1) | 0, e = t + u | 0, n = m2(r, r >>> 0 < n >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, t = r, (r - (n >>> 0 < 2147483648) & s) != -1;);
                                r = f;
                            }
                            if (k = i[A + 108 >> 2], A = i[A + 112 >> 2], f = k - A | 0, t = A >> 31, k = (k >> 31) - (t + (A >>> 0 > k >>> 0) | 0) | 0, e = k - (f >>> 0 < 2147483648) | 0, (e | 0) == -2 | e >>> 0 < 4294967294) {
                                for(; e = t >> 31, s = A + (e | 1) | 0, e = t + e | 0, A = m2(s, A >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, e = k >> 31, s = f + (e | 1) | 0, e = k + e | 0, f = m2(s, f >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), k = w0, (k - (f >>> 0 < 2147483648) | 0) != -1;);
                                t = A >> 31;
                            }
                            if (e = t << 1 | A >>> 31, A = A << 1, t = e, e = e - (A >>> 0 < 2147483648) | 0, (e | 0) == -2 | e >>> 0 < 4294967294) for(; e = k >> 31, s = f + (e | 1) | 0, u = e + k | 0, f = m2(s, f >>> 0 > s >>> 0 ? u + 1 | 0 : u, 2, 0), k = w0, e = t >> 31, s = A + (e | 1) | 0, e = e + t | 0, A = m2(s, A >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, (t - (A >>> 0 < 2147483648) | 0) != -1;);
                            k = n >> 31;
                            i: {
                                if ((A | 0) == (r | 0)) {
                                    if (k = k - ((f >> 31) + (f >>> 0 > n >>> 0) | 0) | 0, f = n - f | 0, (k - (f >>> 0 < 2147483648) | 0) == -1) break i;
                                    for(A = r, t = r >> 31; r = t >> 31, e = r, r = A + (e | 1) | 0, e = e + t | 0, A = m2(r, A >>> 0 > r >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, r = k >> 31, e = r, r = f + (e | 1) | 0, e = e + k | 0, f = m2(r, r >>> 0 < f >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, k = r, (r - (f >>> 0 < 2147483648) | 0) != -1;);
                                    r = A;
                                    break i;
                                }
                                if (k = O0(A, t, n, k), n = w0, e = r >> 31, s = O0(r, e, f, f >> 31), f = k - s | 0, k = n - (w0 + (k >>> 0 < s >>> 0) | 0) | 0, A = O0(A, t, r, e), r = w0, t = r, (k - (f >>> 0 < 2147483648) & r - (A >>> 0 < 2147483648)) != -1) for(; r = t >> 31, n = r, r = A + (r | 1) | 0, e = n + t | 0, A = m2(r, A >>> 0 > r >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, n = t - (A >>> 0 < 2147483648) | 0, r = k >> 31, u = r, r = f + (r | 1) | 0, e = k + u | 0, f = m2(r, r >>> 0 < f >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, k = r, (r - (f >>> 0 < 2147483648) & n) != -1;);
                                r = A;
                            }
                            return A = f, f = (r | 0) / 2 | 0, A = A + f | 0, e = (f >> 31) + k | 0, m2(A, A >>> 0 < f >>> 0 ? e + 1 | 0 : e, r, r >> 31);
                        }
                        function K4(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                e: switch(e | 0){
                                    case 1:
                                        for(e = 0, k = i[i[12662] + 12 >> 2]; n = k + (e << 1) | 0, o[((l[n + 1 | 0] << 3) + A | 0) + l[n | 0] | 0] = l[r + e | 0], n = e | 1, u = k + (n << 1) | 0, o[((l[u + 1 | 0] << 3) + A | 0) + l[u | 0] | 0] = l[r + n | 0], e = e + 2 | 0, (e | 0) != 64;);
                                        break i;
                                    case 2:
                                        for(n = A + 1 | 0, u = i[i[12662] + 12 >> 2]; e = u + (k << 1) | 0, t = r + k | 0, s = l[t | 0], o[((l[e | 0] << 1) + A | 0) + (l[e + 1 | 0] << 5) | 0] = s, o[(n + (l[e | 0] << 1) | 0) + (l[e + 1 | 0] << 5) | 0] = s, t = l[t | 0], o[(((l[e | 0] << 1) + A | 0) + (l[e + 1 | 0] << 5) | 0) + 16 | 0] = t, o[((n + (l[e | 0] << 1) | 0) + (l[e + 1 | 0] << 5) | 0) + 16 | 0] = t, k = k + 1 | 0, (k | 0) != 64;);
                                        break i;
                                    case 3:
                                        for(n = A + 3 | 0, u = A + 2 | 0, t = A + 1 | 0, h = i[i[12662] + 12 >> 2]; e = (s << 1) + h | 0, k = r + s | 0, f = l[k | 0], o[((l[e | 0] << 2) + A | 0) + (l[e + 1 | 0] << 7) | 0] = f, o[(t + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0] = f, f = l[k | 0], o[(u + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0] = f, o[(n + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0] = f, f = l[k | 0], o[(((l[e | 0] << 2) + A | 0) + (l[e + 1 | 0] << 7) | 0) + 32 | 0] = f, o[((t + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 32 | 0] = f, f = l[k | 0], o[((u + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 32 | 0] = f, o[((n + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 32 | 0] = f, f = l[k | 0], o[(((l[e | 0] << 2) + A | 0) + (l[e + 1 | 0] << 7) | 0) + 64 | 0] = f, o[((t + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 64 | 0] = f, f = l[k | 0], o[((u + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 64 | 0] = f, o[((n + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 64 | 0] = f, f = l[k | 0], o[(((l[e | 0] << 2) + A | 0) + (l[e + 1 | 0] << 7) | 0) + 96 | 0] = f, o[((t + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 96 | 0] = f, k = l[k | 0], o[((u + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 96 | 0] = k, o[((n + (l[e | 0] << 2) | 0) + (l[e + 1 | 0] << 7) | 0) + 96 | 0] = k, s = s + 1 | 0, (s | 0) != 64;);
                                        break i;
                                    default:
                                        y0(18461, 14941, 865, 5287), z();
                                    case 0:
                                        break e;
                                }
                                e = i[i[12662] + 8 >> 2], o[((l[e + 1 | 0] << 2) + A | 0) + l[e | 0] | 0] = l[r | 0], o[l[e + 2 | 0] + ((l[e + 3 | 0] << 2) + A | 0) | 0] = l[r + 1 | 0], o[l[e + 4 | 0] + ((l[e + 5 | 0] << 2) + A | 0) | 0] = l[r + 2 | 0], o[l[e + 6 | 0] + ((l[e + 7 | 0] << 2) + A | 0) | 0] = l[r + 3 | 0], o[l[e + 8 | 0] + ((l[e + 9 | 0] << 2) + A | 0) | 0] = l[r + 4 | 0], o[l[e + 10 | 0] + ((l[e + 11 | 0] << 2) + A | 0) | 0] = l[r + 5 | 0], o[l[e + 12 | 0] + ((l[e + 13 | 0] << 2) + A | 0) | 0] = l[r + 6 | 0], o[l[e + 14 | 0] + ((l[e + 15 | 0] << 2) + A | 0) | 0] = l[r + 7 | 0], o[l[e + 16 | 0] + ((l[e + 17 | 0] << 2) + A | 0) | 0] = l[r + 8 | 0], o[l[e + 18 | 0] + ((l[e + 19 | 0] << 2) + A | 0) | 0] = l[r + 9 | 0], o[l[e + 20 | 0] + ((l[e + 21 | 0] << 2) + A | 0) | 0] = l[r + 10 | 0], o[l[e + 22 | 0] + ((l[e + 23 | 0] << 2) + A | 0) | 0] = l[r + 11 | 0], o[l[e + 24 | 0] + ((l[e + 25 | 0] << 2) + A | 0) | 0] = l[r + 12 | 0], o[l[e + 26 | 0] + ((l[e + 27 | 0] << 2) + A | 0) | 0] = l[r + 13 | 0], o[l[e + 28 | 0] + ((l[e + 29 | 0] << 2) + A | 0) | 0] = l[r + 14 | 0], o[l[e + 30 | 0] + ((l[e + 31 | 0] << 2) + A | 0) | 0] = l[r + 15 | 0];
                            }
                        }
                        function dw(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            n = m - 16 | 0, m = n, u = n2(e), s = n2(e), h = n2(e), v = n2(e), k = n2(e), f = n2(e), w = n2(e), t = n2(e);
                            i: {
                                if ((t | (u | s | h | v | f)) < 0) {
                                    if (r = D(32), i[n >> 2] = r, i[n + 4 >> 2] = 31, i[n + 8 >> 2] = -2147483616, e = l[19695] | l[19696] << 8 | (l[19697] << 16 | l[19698] << 24), f = l[19691] | l[19692] << 8 | (l[19693] << 16 | l[19694] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 31 | 0] = 0, e = l[19718] | l[19719] << 8 | (l[19720] << 16 | l[19721] << 24), f = l[19714] | l[19715] << 8 | (l[19716] << 16 | l[19717] << 24), o[r + 23 | 0] = f, o[r + 24 | 0] = f >>> 8, o[r + 25 | 0] = f >>> 16, o[r + 26 | 0] = f >>> 24, o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, e = l[19711] | l[19712] << 8 | (l[19713] << 16 | l[19714] << 24), f = l[19707] | l[19708] << 8 | (l[19709] << 16 | l[19710] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[19703] | l[19704] << 8 | (l[19705] << 16 | l[19706] << 24), f = l[19699] | l[19700] << 8 | (l[19701] << 16 | l[19702] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 128, n), o[n + 11 | 0] >= 0) break i;
                                    X(i[n >> 2]);
                                    break i;
                                }
                                if (s = E9(n, u, s), u = i[s >> 2], s = i[s + 4 >> 2], i[r + 100 >> 2] = u, i[r + 104 >> 2] = s, h = E9(n, h, v), u = i[h >> 2], h = i[h + 4 >> 2], i[r + 108 >> 2] = u, i[r + 112 >> 2] = h, f - 65537 >>> 0 < 4294836223) for(; k = (k | 0) / 2 | 0, f = (f | 0) / 2 | 0, f - 65537 >>> 0 < 4294836223;);
                                e: {
                                    if ((f | 0) <= 1) break e;
                                    for(;;){
                                        if (k - 65537 >>> 0 > 4294836222) break e;
                                        if (k = (k | 0) / 2 | 0, u = f >>> 0 > 3, f = f >>> 1 | 0, !u) break;
                                    }
                                }
                                if (i[r + 116 >> 2] = k, i[r + 120 >> 2] = f, t - 65537 >>> 0 < 4294836223) for(; w = (w | 0) / 2 | 0, t = (t | 0) / 2 | 0, t - 65537 >>> 0 < 4294836223;);
                                e: {
                                    if ((t | 0) <= 1) {
                                        k = t;
                                        break e;
                                    }
                                    for(;;){
                                        if (w - 65537 >>> 0 > 4294836222) {
                                            k = t;
                                            break e;
                                        }
                                        if (w = (w | 0) / 2 | 0, u = t >>> 0 > 3, k = t >>> 1 | 0, t = k, !u) break;
                                    }
                                }
                                i[r + 124 >> 2] = w, i[r + 128 >> 2] = k;
                                e: {
                                    if (!(!f | (!s | !h)) && k) break e;
                                    if (r = A, A = a1(n, 34896), i0(r, 2, 128, A), o[A + 11 | 0] >= 0) break i;
                                    X(i[A >> 2]);
                                    break i;
                                }
                                r = m - 16 | 0, m = r;
                                e: {
                                    if (l[e + 20 | 0] == 1) {
                                        if (o[r + 4 | 0] = 0, o[r + 15 | 0] = 0, i0(A, 2, 100, r + 4 | 0), o[r + 15 | 0] >= 0) break e;
                                        X(i[r + 4 >> 2]);
                                        break e;
                                    }
                                    if (e = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = e, A = A + 8 | 0, o[86691] >= 0) {
                                        e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                m = r + 16 | 0;
                            }
                            m = n + 16 | 0;
                        }
                        function u1(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (u = m - 16 | 0, m = u, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, e = m - 16 | 0, m = e, i[e + 12 >> 2] = A, i[u + 12 >> 2] = i[e + 12 >> 2], m = e + 16 | 0, e = i[27101], i[27102] - e >> 2 >>> 0 <= r >>> 0) i: {
                                if (A = r + 1 | 0, f = i[27102], e = f - e >> 2, A >>> 0 > e >>> 0) {
                                    s = m - 32 | 0, m = s, t = A - e | 0;
                                    e: {
                                        if (t >>> 0 <= i[27103] - f >> 2 >>> 0) {
                                            O9(t);
                                            break e;
                                        }
                                        f = s + 12 | 0, e = m - 16 | 0, m = e, k = t + (i[27102] - i[27101] >> 2) | 0, i[e + 12 >> 2] = k;
                                        r: {
                                            if (A = wt(), k >>> 0 <= A >>> 0) {
                                                k = i[27103] - i[27101] >> 2, k >>> 0 < A >>> 1 >>> 0 && (i[e + 8 >> 2] = k << 1, A = m - 16 | 0, m = A, m = A + 16 | 0, A = e + 12 | 0, k = e + 8 | 0, A = i[(k0[k >> 2] < k0[A >> 2] ? A : k) >> 2]), m = e + 16 | 0, e = A;
                                                break r;
                                            }
                                            u4(), z();
                                        }
                                        for(n = i[27102] - i[27101] >> 2, A = 0, k = m - 16 | 0, m = k, i[k + 12 >> 2] = 0, i[f + 12 >> 2] = 0, i[f + 16 >> 2] = 108416, e ? (Et(k + 4 | 0, i[f + 16 >> 2], e), A = i[k + 4 >> 2], e = i[k + 8 >> 2]) : e = 0, i[f >> 2] = A, n = (n << 2) + A | 0, i[f + 8 >> 2] = n, i[f + 4 >> 2] = n, i[f + 12 >> 2] = (e << 2) + A, m = k + 16 | 0, e = m - 16 | 0, m = e, A = i[f + 8 >> 2], i[e + 12 >> 2] = f + 8, i[e + 4 >> 2] = A, i[e + 8 >> 2] = A + (t << 2), A = i[e + 4 >> 2];;){
                                            if (i[e + 8 >> 2] != (A | 0)) {
                                                i[i[e + 4 >> 2] >> 2] = 0, A = i[e + 4 >> 2] + 4 | 0, i[e + 4 >> 2] = A;
                                                continue;
                                            }
                                            break;
                                        }
                                        for(i[i[e + 12 >> 2] >> 2] = i[e + 4 >> 2], m = e + 16 | 0, k = m - 16 | 0, m = k, i[k + 8 >> 2] = i[27102], i[k + 4 >> 2] = i[27101], i[k >> 2] = i[f + 4 >> 2], n = i[k + 4 >> 2], h = i[k >> 2], t = m - 16 | 0, m = t, A = m - 32 | 0, m = A, e = m - 16 | 0, m = e, i[e + 12 >> 2] = i[k + 8 >> 2], i[e + 8 >> 2] = n, i[A + 24 >> 2] = i[e + 12 >> 2], i[A + 28 >> 2] = i[e + 8 >> 2], m = e + 16 | 0, n = i[A + 24 >> 2], e = m - 16 | 0, m = e, i[e + 8 >> 2] = i[A + 28 >> 2], i[e + 12 >> 2] = n, i[e + 4 >> 2] = h;;){
                                            if (n = i[e + 12 >> 2], (n | 0) != i[e + 8 >> 2]) {
                                                i[i[e + 4 >> 2] - 4 >> 2] = i[n - 4 >> 2], i[e + 12 >> 2] = i[e + 12 >> 2] - 4, i[e + 4 >> 2] = i[e + 4 >> 2] - 4;
                                                continue;
                                            }
                                            break;
                                        }
                                        for(i[A + 16 >> 2] = i[e + 12 >> 2], i[A + 20 >> 2] = i[e + 4 >> 2], m = e + 16 | 0, i[A + 12 >> 2] = i[A + 16 >> 2], i[A + 8 >> 2] = i[A + 20 >> 2], i[t + 8 >> 2] = i[A + 12 >> 2], i[t + 12 >> 2] = i[A + 8 >> 2], m = A + 32 | 0, m = t + 16 | 0, i[k + 12 >> 2] = i[t + 12 >> 2], i[f + 4 >> 2] = i[k + 12 >> 2], A = i[27101], i[27101] = i[f + 4 >> 2], i[f + 4 >> 2] = A, A = i[27102], i[27102] = i[f + 8 >> 2], i[f + 8 >> 2] = A, A = i[27103], i[27103] = i[f + 12 >> 2], i[f + 12 >> 2] = A, i[f >> 2] = i[f + 4 >> 2], m = k + 16 | 0, A = i[f + 4 >> 2];;){
                                            if (e = i[f + 8 >> 2], (e | 0) != (A | 0)) {
                                                i[f + 8 >> 2] = e - 4;
                                                continue;
                                            }
                                            break;
                                        }
                                        A = i[f >> 2], A && Ao(i[f + 16 >> 2], A);
                                    }
                                    m = s + 32 | 0;
                                    break i;
                                }
                                A >>> 0 < e >>> 0 && fo(108404, i[27101] + (A << 2) | 0);
                            }
                            A = i[i[27101] + (r << 2) >> 2], A && (e = i[A + 4 >> 2] - 1 | 0, i[A + 4 >> 2] = e, (e | 0) == -1 && p[i[i[A >> 2] + 8 >> 2]](A)), A = i[u + 12 >> 2], i[u + 12 >> 2] = 0, i[i[27101] + (r << 2) >> 2] = A, A = i[u + 12 >> 2], i[u + 12 >> 2] = 0, A && (r = i[A + 4 >> 2] - 1 | 0, i[A + 4 >> 2] = r, (r | 0) == -1 && p[i[i[A >> 2] + 8 >> 2]](A)), m = u + 16 | 0;
                        }
                        function oi(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            k = r - 1 | 0, e = k, u = (k | 0) / 2 | 0, k = r + 65535 >>> 0 < 131073, u = k ? e : u, f = i[A + 116 >> 2], t = f >> 31, r = k ? 2 : 1, n = i[A + 120 >> 2];
                            i: {
                                if ((r | 0) == (n | 0)) {
                                    if (e = (u >> 31) + t | 0, n = f + u | 0, e = n >>> 0 < u >>> 0 ? e + 1 | 0 : e, (e - (n >>> 0 < 2147483648) | 0) == -1) break i;
                                    r = e >> 31, u = r, r = n + (r | 1) | 0, e = e + u | 0, n = m2(r, r >>> 0 < n >>> 0 ? e + 1 | 0 : e, 2, 0), r = 1;
                                    break i;
                                }
                                if (r = n, s = r >> 31, n = O0(r, s, u, u >> 31), h = w0, w = n, e = f, n = k & 31, (k & 63) >>> 0 >= 32 ? (u = e << n, f = 0) : (u = (1 << n) - 1 & e >>> 32 - n | t << n, f = e << n), n = w + f | 0, e = u + h | 0, e = f >>> 0 > n >>> 0 ? e + 1 | 0 : e, t = e, h = (e - (n >>> 0 < 2147483648) | 0) == -1, u = r, f = k & 31, (k & 63) >>> 0 >= 32 ? (e = r << f, k = 0) : (e = (1 << f) - 1 & u >>> 32 - f | s << f, k = u << f), f = e, !((e - (k >>> 0 < 2147483648) | 0) == -1 & h)) for(; r = f >> 31, e = r, r = k + (e | 1) | 0, e = e + f | 0, k = m2(r, r >>> 0 < k >>> 0 ? e + 1 | 0 : e, 2, 0), f = w0, s = f - (k >>> 0 < 2147483648) | 0, r = t >> 31, u = r, r = n + (r | 1) | 0, e = t + u | 0, n = m2(r, r >>> 0 < n >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, t = r, (r - (n >>> 0 < 2147483648) & s) != -1;);
                                r = k;
                            }
                            if (f = i[A + 100 >> 2], A = i[A + 104 >> 2], k = f - A | 0, t = A >> 31, f = (f >> 31) - (t + (A >>> 0 > f >>> 0) | 0) | 0, e = f - (k >>> 0 < 2147483648) | 0, (e | 0) == -2 | e >>> 0 < 4294967294) {
                                for(; e = t >> 31, s = A + (e | 1) | 0, e = t + e | 0, A = m2(s, A >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, e = f >> 31, s = k + (e | 1) | 0, e = f + e | 0, k = m2(s, k >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), f = w0, (f - (k >>> 0 < 2147483648) | 0) != -1;);
                                t = A >> 31;
                            }
                            if (e = t << 1 | A >>> 31, A = A << 1, t = e, e = e - (A >>> 0 < 2147483648) | 0, (e | 0) == -2 | e >>> 0 < 4294967294) for(; e = f >> 31, s = k + (e | 1) | 0, u = e + f | 0, k = m2(s, k >>> 0 > s >>> 0 ? u + 1 | 0 : u, 2, 0), f = w0, e = t >> 31, s = A + (e | 1) | 0, e = e + t | 0, A = m2(s, A >>> 0 > s >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, (t - (A >>> 0 < 2147483648) | 0) != -1;);
                            f = n >> 31;
                            i: {
                                if ((A | 0) == (r | 0)) {
                                    if (f = f - ((k >> 31) + (k >>> 0 > n >>> 0) | 0) | 0, k = n - k | 0, (f - (k >>> 0 < 2147483648) | 0) == -1) break i;
                                    for(A = r, t = r >> 31; r = t >> 31, e = r, r = A + (e | 1) | 0, e = e + t | 0, A = m2(r, A >>> 0 > r >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, r = f >> 31, e = r, r = k + (e | 1) | 0, e = e + f | 0, k = m2(r, r >>> 0 < k >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, f = r, (r - (k >>> 0 < 2147483648) | 0) != -1;);
                                    r = A;
                                    break i;
                                }
                                if (f = O0(A, t, n, f), n = w0, e = r >> 31, s = O0(r, e, k, k >> 31), k = f - s | 0, f = n - (w0 + (f >>> 0 < s >>> 0) | 0) | 0, A = O0(A, t, r, e), r = w0, t = r, (f - (k >>> 0 < 2147483648) & r - (A >>> 0 < 2147483648)) != -1) for(; r = t >> 31, n = r, r = A + (r | 1) | 0, e = n + t | 0, A = m2(r, A >>> 0 > r >>> 0 ? e + 1 | 0 : e, 2, 0), t = w0, n = t - (A >>> 0 < 2147483648) | 0, r = f >> 31, u = r, r = k + (r | 1) | 0, e = f + u | 0, k = m2(r, r >>> 0 < k >>> 0 ? e + 1 | 0 : e, 2, 0), r = w0, f = r, (r - (k >>> 0 < 2147483648) & n) != -1;);
                                r = A;
                            }
                            return (k | 0) / (r | 0) | 0;
                        }
                        function cw(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0;
                            s = m - 32 | 0, m = s;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (u = i[r + 16 >> 2], (p[i[i[u >> 2] + 8 >> 2]](u) | 0) == 5) {
                                                f: {
                                                    if (!(!k | (!e | !f)) && n) break f;
                                                    r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                                    break i;
                                                }
                                                if (u = i[r + 16 >> 2], !u || (h = E0(u, 78492, 79208), !h)) break A;
                                                u = i[r + 20 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), i[e >> 2] = i[h + 4 >> 2], i[f >> 2] = i[h + 8 >> 2], w = i[h + 12 >> 2], i[k >> 2] = w, r = n, n = i[h + 16 >> 2], i[r >> 2] = n, h = i[h + 20 >> 2], C3(s + 16 | 0, w, n, 2, 0, t);
                                                f: {
                                                    if (i[s + 16 >> 2]) {
                                                        r = i[s + 20 >> 2], i[A >> 2] = i[s + 16 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[s + 24 >> 2];
                                                        break f;
                                                    }
                                                    if (WA(s + 4 | 0, i[t >> 2], 0, w, n, 8), i[s + 24 >> 2] = i[s + 12 >> 2], e = i[s + 8 >> 2], r = i[s + 4 >> 2], i[s + 16 >> 2] = r, i[s + 20 >> 2] = e, r) {
                                                        p4(i[t >> 2]), i[A + 8 >> 2] = i[s + 24 >> 2], r = i[s + 20 >> 2], i[A >> 2] = i[s + 16 >> 2], i[A + 4 >> 2] = r;
                                                        break f;
                                                    }
                                                    if (e = 0, t = Ci(i[t >> 2], 0, s + 4 | 0), !(!w | !n)) for(k = 0, f = 0;;){
                                                        for(r = 0; o[(t + Z(i[s + 4 >> 2], e) | 0) + r | 0] = (l[((f & 7) << 29 | k >>> 3) + h | 0] << (k & 7) & 128) >>> 7 | 0 ? -1 : 0, k = k + 1 | 0, f = k ? f : f + 1 | 0, r = r + 1 | 0, (w | 0) != (r | 0););
                                                        if (e = e + 1 | 0, (n | 0) == (e | 0)) break;
                                                    }
                                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                                }
                                                if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break i;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                break i;
                                            }
                                            if (u = i[r + 16 >> 2], (p[i[i[u >> 2] + 8 >> 2]](u) | 0) == 4) {
                                                f: {
                                                    if (!(!k | (!e | !f)) && n) break f;
                                                    e = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[20015], e = 0;
                                                    break e;
                                                }
                                                if (u = i[r + 16 >> 2], !u || (h = E0(u, 78492, 79164), !h)) break r;
                                                if (u = i[r + 20 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), i[e >> 2] = i[h + 4 >> 2], i[f >> 2] = i[h + 8 >> 2], i[k >> 2] = i[h + 12 >> 2], i[n >> 2] = i[h + 16 >> 2], e = i[h + 20 >> 2], i[A + 8 >> 2] = i[19867], f = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = f, !u || (f = i[u + 4 >> 2], i[u + 4 >> 2] = f - 1, f)) break e;
                                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                                break e;
                                            }
                                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                            break i;
                                        }
                                        r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                        break i;
                                    }
                                    e = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[20015], e = 0;
                                }
                                if (i[A >> 2] || (f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[s + 8 >> 2] = r, i[s + 4 >> 2] = f, R3(A, s + 4 | 0, e, s), i[A >> 2] || (I3(s + 16 | 0, i[s >> 2], t, 2, 0, 0), i[A + 8 >> 2] = i[s + 24 >> 2], r = i[s + 20 >> 2], i[A >> 2] = i[s + 16 >> 2], i[A + 4 >> 2] = r, Ji(i[s >> 2])), A = i[s + 8 >> 2], !A) || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = s + 32 | 0;
                        }
                        function iv(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            n = m - 96 | 0, m = n;
                            i: {
                                if (!(k && r)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2006, i[A + 8 >> 2] = 13578;
                                    break i;
                                }
                                s = i[r >> 2], t = i[s + 48 >> 2], s = i[s + 52 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), i[n + 92 >> 2] = 0, i[n + 84 >> 2] = 0, i[n + 88 >> 2] = 0, u = n - -64 | 0, F4(u, t, e, n + 84 | 0);
                                e: {
                                    if (i[n + 64 >> 2]) {
                                        j0(A, u, i[r >> 2]);
                                        break e;
                                    }
                                    r: {
                                        if (f && (e = f - 1 | 0, r = i[n + 84 >> 2], e >>> 0 < i[n + 88 >> 2] - r >> 3 >>> 0)) break r;
                                        i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 11185;
                                        break e;
                                    }
                                    r: {
                                        if (e = r + (e << 3) | 0, r = i[e >> 2], !r || (r = E0(r, 73632, 76104), !r)) break r;
                                        e = i[e + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), f = D(20), i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[f >> 2] = 1;
                                        A: {
                                            if (o[r + 115 | 0] >= 0) {
                                                i[n + 56 >> 2] = i[r + 112 >> 2], t = i[r + 108 >> 2], i[n + 48 >> 2] = i[r + 104 >> 2], i[n + 52 >> 2] = t;
                                                break A;
                                            }
                                            j(n + 48 | 0, i[r + 104 >> 2], i[r + 108 >> 2]);
                                        }
                                        u = o[n + 59 | 0], t = (u | 0) < 0, h = D((t ? i[n + 52 >> 2] : u) + 1 | 0), u = i[n + 48 >> 2], w = f, v = p6(h, t ? u : n + 48 | 0), i[w + 4 >> 2] = v, t && X(u);
                                        A: {
                                            if (o[r + 127 | 0] >= 0) {
                                                i[n + 40 >> 2] = i[r + 124 >> 2], t = i[r + 120 >> 2], i[n + 32 >> 2] = i[r + 116 >> 2], i[n + 36 >> 2] = t;
                                                break A;
                                            }
                                            j(n + 32 | 0, i[r + 116 >> 2], i[r + 120 >> 2]);
                                        }
                                        u = o[n + 43 | 0], t = (u | 0) < 0, h = D((t ? i[n + 36 >> 2] : u) + 1 | 0), u = i[n + 32 >> 2], w = f, v = p6(h, t ? u : n + 32 | 0), i[w + 8 >> 2] = v, t && X(u);
                                        A: {
                                            if (o[r + 139 | 0] >= 0) {
                                                i[n + 24 >> 2] = i[r + 136 >> 2], t = i[r + 132 >> 2], i[n + 16 >> 2] = i[r + 128 >> 2], i[n + 20 >> 2] = t;
                                                break A;
                                            }
                                            j(n + 16 | 0, i[r + 128 >> 2], i[r + 132 >> 2]);
                                        }
                                        u = o[n + 27 | 0], t = (u | 0) < 0, h = D((t ? i[n + 20 >> 2] : u) + 1 | 0), u = i[n + 16 >> 2], w = f, v = p6(h, t ? u : n + 16 | 0), i[w + 12 >> 2] = v, t && X(u);
                                        A: {
                                            if (o[r + 151 | 0] >= 0) {
                                                i[n + 8 >> 2] = i[r + 148 >> 2], t = i[r + 144 >> 2], i[n >> 2] = i[r + 140 >> 2], i[n + 4 >> 2] = t;
                                                break A;
                                            }
                                            j(n, i[r + 140 >> 2], i[r + 144 >> 2]);
                                        }
                                        if (t = o[n + 11 | 0], r = (t | 0) < 0, u = D((r ? i[n + 4 >> 2] : t) + 1 | 0), t = i[n >> 2], w = f, v = p6(u, r ? t : n), i[w + 16 >> 2] = v, r && X(t), i[k >> 2] = f, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, !e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break e;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        break e;
                                    }
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 10426;
                                }
                                if (o[n + 83 | 0] < 0 && X(i[n + 72 >> 2]), e = i[n + 84 >> 2], e) {
                                    if (A = e, r = i[n + 88 >> 2], (A | 0) != (r | 0)) {
                                        for(;;){
                                            A = i[r - 4 >> 2];
                                            e: {
                                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break e;
                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            }
                                            if (r = r - 8 | 0, (e | 0) == (r | 0)) break;
                                        }
                                        A = i[n + 84 >> 2];
                                    }
                                    i[n + 88 >> 2] = e, X(A);
                                }
                                if (!s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            m = n + 96 | 0;
                        }
                        function ev(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            k = m - 48 | 0, m = k, Q3(k + 24 | 0, r, e, f);
                            i: {
                                if (i[k + 24 >> 2]) {
                                    r = i[k + 28 >> 2], i[A >> 2] = i[k + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 40 >> 2], r = i[k + 36 >> 2], i[A + 8 >> 2] = i[k + 32 >> 2], i[A + 12 >> 2] = r, i[k + 40 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0;
                                    break i;
                                }
                                if ((i[r + 112 >> 2] - i[r + 108 >> 2] | 0) != 8) {
                                    if (r = D(64), i[k + 12 >> 2] = r, i[k + 16 >> 2] = 57, i[k + 20 >> 2] = -2147483584, e = l[4852] | l[4853] << 8 | (l[4854] << 16 | l[4855] << 24), f = l[4848] | l[4849] << 8 | (l[4850] << 16 | l[4851] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 57 | 0] = 0, o[r + 56 | 0] = l[4904], e = l[4900] | l[4901] << 8 | (l[4902] << 16 | l[4903] << 24), f = l[4896] | l[4897] << 8 | (l[4898] << 16 | l[4899] << 24), o[r + 48 | 0] = f, o[r + 49 | 0] = f >>> 8, o[r + 50 | 0] = f >>> 16, o[r + 51 | 0] = f >>> 24, o[r + 52 | 0] = e, o[r + 53 | 0] = e >>> 8, o[r + 54 | 0] = e >>> 16, o[r + 55 | 0] = e >>> 24, e = l[4892] | l[4893] << 8 | (l[4894] << 16 | l[4895] << 24), f = l[4888] | l[4889] << 8 | (l[4890] << 16 | l[4891] << 24), o[r + 40 | 0] = f, o[r + 41 | 0] = f >>> 8, o[r + 42 | 0] = f >>> 16, o[r + 43 | 0] = f >>> 24, o[r + 44 | 0] = e, o[r + 45 | 0] = e >>> 8, o[r + 46 | 0] = e >>> 16, o[r + 47 | 0] = e >>> 24, e = l[4884] | l[4885] << 8 | (l[4886] << 16 | l[4887] << 24), f = l[4880] | l[4881] << 8 | (l[4882] << 16 | l[4883] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[4876] | l[4877] << 8 | (l[4878] << 16 | l[4879] << 24), f = l[4872] | l[4873] << 8 | (l[4874] << 16 | l[4875] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[4868] | l[4869] << 8 | (l[4870] << 16 | l[4871] << 24), f = l[4864] | l[4865] << 8 | (l[4866] << 16 | l[4867] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[4860] | l[4861] << 8 | (l[4862] << 16 | l[4863] << 24), f = l[4856] | l[4857] << 8 | (l[4858] << 16 | l[4859] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 101, k + 12 | 0), o[k + 23 | 0] >= 0) break i;
                                    X(i[k + 12 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[k + 43 | 0] < 0 && X(i[k + 32 >> 2]), m = k + 48 | 0;
                        }
                        function r5(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            i: {
                                e: {
                                    if (s = A + 548 | 0, !i[s + 8 >> 2]) {
                                        o[s + 1 | 0] = 0, A = 7, t = i[s + 44 >> 2];
                                        r: {
                                            if ((t | 0) != i[s + 40 >> 2]) {
                                                u = t - 4 | 0, t = i[u >> 2], i[s + 44 >> 2] = u, u = i[t + 32 >> 2];
                                                break r;
                                            }
                                            t = D(48), i[t + 40 >> 2] = 0, i[t + 32 >> 2] = 0, i[t + 36 >> 2] = 0, o[t + 2 | 0] = 0, o[t | 0] = 0, o[t + 1 | 0] = 0, u = D(64), i[t + 32 >> 2] = u, h = u - -64 | 0, i[t + 40 >> 2] = h, i[u + 56 >> 2] = 0, i[u + 60 >> 2] = 0, i[u + 48 >> 2] = 0, i[u + 52 >> 2] = 0, i[u + 40 >> 2] = 0, i[u + 44 >> 2] = 0, i[u + 32 >> 2] = 0, i[u + 36 >> 2] = 0, i[u + 24 >> 2] = 0, i[u + 28 >> 2] = 0, i[u + 16 >> 2] = 0, i[u + 20 >> 2] = 0, i[u + 8 >> 2] = 0, i[u + 12 >> 2] = 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[t + 8 >> 2] = 0, i[t + 12 >> 2] = 0, i[t + 36 >> 2] = h, i[t + 16 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, i[t + 28 >> 2] = 0;
                                        }
                                        if (i[t + 36 >> 2] = u, i[t + 24 >> 2] = 0, i[t + 16 >> 2] = 0, i[t + 8 >> 2] = 0, i[t + 12 >> 2] = 0, o[t + 2 | 0] = 0, Q[t >> 1] = 0, i[t + 28 >> 2] < (e | 0)) r: {
                                            if (u = Q2(e), u) {
                                                h = i[t + 20 >> 2], h && X(h), i[t + 28 >> 2] = e, i[t + 20 >> 2] = u;
                                                break r;
                                            }
                                            w4(s, t), t = 0;
                                        }
                                        if (t) {
                                            r: {
                                                if (i[t + 28 >> 2] >= (e | 0)) {
                                                    A = i[t + 20 >> 2];
                                                    break r;
                                                }
                                                if (A = Q2(e), !A) break e;
                                                u = i[t + 20 >> 2], u && (v0(A, u, i[t + 24 >> 2]), X(u)), i[t + 28 >> 2] = e, i[t + 20 >> 2] = A;
                                            }
                                            if (v0(A, r, e), i[t + 16 >> 2] = n, i[t + 8 >> 2] = f, i[t + 12 >> 2] = k, i[t + 24 >> 2] = e, (e | 0) >= 3) for(A = i[t + 20 >> 2], n = 0;;){
                                                r = A + 2 | 0;
                                                r: {
                                                    A: {
                                                        f: switch(f = l[A + 2 | 0], f | 0){
                                                            case 0:
                                                            case 3:
                                                                break A;
                                                            default:
                                                                break f;
                                                        }
                                                        n = n + 2 | 0;
                                                        break r;
                                                    }
                                                    if (l[A | 0]) {
                                                        r = A;
                                                        break r;
                                                    }
                                                    if ((f | 0) != 3) {
                                                        r = A;
                                                        break r;
                                                    }
                                                    if (l[A + 1 | 0]) {
                                                        r = A;
                                                        break r;
                                                    }
                                                    e = i[t + 36 >> 2], w = ((e - i[t + 32 >> 2] >> 2) + n | 0) + 2 | 0;
                                                    A: {
                                                        if (u = i[t + 40 >> 2], u >>> 0 > e >>> 0) {
                                                            i[e >> 2] = w, i[t + 36 >> 2] = e + 4;
                                                            break A;
                                                        }
                                                        f: {
                                                            if (k = i[t + 32 >> 2], h = e - k >> 2, f = h + 1 | 0, f >>> 0 < 1073741824) {
                                                                if (v = h << 2, u = u - k | 0, h = u >> 1, h = u >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < h >>> 0 ? h : f, h) {
                                                                    if (h >>> 0 >= 1073741824) break f;
                                                                    f = D(h << 2);
                                                                } else f = 0;
                                                                if (u = v + f | 0, i[u >> 2] = w, w = u + 4 | 0, (e | 0) != (k | 0)) for(; u = u - 4 | 0, e = e - 4 | 0, i[u >> 2] = i[e >> 2], (e | 0) != (k | 0););
                                                                i[t + 40 >> 2] = f + (h << 2), i[t + 36 >> 2] = w, i[t + 32 >> 2] = u, k && X(k), i[t + 36 >> 2] = w;
                                                                break A;
                                                            }
                                                            p0(), z();
                                                        }
                                                        Z2(), z();
                                                    }
                                                    Q0(r, A + 3 | 0, (i[t + 24 >> 2] - n | 0) - 3 | 0), e = i[t + 24 >> 2] - 1 | 0, i[t + 24 >> 2] = e, n = n + 1 | 0, r = A + 1 | 0;
                                                }
                                                if (A = r + 1 | 0, n = n + 1 | 0, !((n | 0) < (e - 2 | 0))) break;
                                            }
                                            A = 0, u = i[s + 32 >> 2], r = u + i[s + 28 >> 2] | 0, f = i[s + 20 >> 2], n = i[s + 16 >> 2], (r | 0) == (((f | 0) != (n | 0) ? (f - n << 8) - 1 | 0 : 0) | 0) && (me(s + 12 | 0), e = i[t + 24 >> 2], n = i[s + 16 >> 2], u = i[s + 32 >> 2], r = u + i[s + 28 >> 2] | 0), i[i[(r >>> 8 & 16777212) + n >> 2] + ((r & 1023) << 2) >> 2] = t, i[s + 32 >> 2] = u + 1, i[s + 36 >> 2] = i[s + 36 >> 2] + e;
                                        }
                                        break i;
                                    }
                                    y0(16123, 14955, 375, 16160), z();
                                }
                                w4(s, t), A = 7;
                            }
                            return A;
                        }
                        function h6(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 160 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        if (u = i[r + 8 >> 2], r = i[r + 12 >> 2], !(u | r)) break n;
                                                        if ((e | f) >= 0) {
                                                            if (!f) break k;
                                                            if (t = _6(u, r, f, 0), n = w0, !n & e >>> 0 <= t >>> 0 | n) break n;
                                                        }
                                                        i[k + 24 >> 2] = 59808, i[k + 80 >> 2] = 59828, t = i[14961], i[k + 16 >> 2] = t, n = i[t - 12 >> 2], t = k + 16 | 0, i[n + t >> 2] = i[14962], i[k + 20 >> 2] = 0, n = t + i[i[k + 16 >> 2] - 12 >> 2] | 0, s = k + 28 | 0, T0(n, s), i[n + 72 >> 2] = 0, i[n + 76 >> 2] = -1, n = i[14963], i[k + 24 >> 2] = n, h = k + 24 | 0, i[h + i[n - 12 >> 2] >> 2] = i[14964], n = i[14960], i[k + 16 >> 2] = n, i[t + i[n - 12 >> 2] >> 2] = i[14965], i[k + 80 >> 2] = 59828, i[k + 16 >> 2] = 59788, i[k + 24 >> 2] = 59808, t = z0(s), i[t >> 2] = 58864, i[k + 68 >> 2] = 0, i[k + 72 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 76 >> 2] = 24, U(K1(U(M0(U(M0(U(h, 22257, 11), e), 2741, 1), f), 22224, 32), u, r), 34895, 1), r = i[k + 76 >> 2];
                                                        t: {
                                                            if (r & 16) {
                                                                f = i[k + 72 >> 2], r = i[k + 52 >> 2], f >>> 0 < r >>> 0 && (i[k + 72 >> 2] = r, f = r), r = k + 48 | 0;
                                                                break t;
                                                            }
                                                            if (!(r & 8)) {
                                                                f = 0, o[k + 15 | 0] = 0, e = k + 4 | 0;
                                                                break e;
                                                            }
                                                            f = i[k + 44 >> 2], r = k + 36 | 0;
                                                        }
                                                        if (r = i[r >> 2], f = f - r | 0, f >>> 0 >= 2147483640) break A;
                                                        if (f >>> 0 >= 11) {
                                                            u = (f | 7) + 1 | 0, e = D(u), i[k + 12 >> 2] = u | -2147483648, i[k + 4 >> 2] = e, i[k + 8 >> 2] = f;
                                                            break r;
                                                        }
                                                        if (o[k + 15 | 0] = f, e = k + 4 | 0, f) break r;
                                                        f = 0;
                                                        break e;
                                                    }
                                                    if (!e) break k;
                                                    if (f) break f;
                                                }
                                                if (r = D(24), i[k + 16 >> 2] = r, i[k + 20 >> 2] = 20, i[k + 24 >> 2] = -2147483624, e = l[3613] | l[3614] << 8 | (l[3615] << 16 | l[3616] << 24), f = l[3609] | l[3610] << 8 | (l[3611] << 16 | l[3612] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 20 | 0] = 0, e = l[3625] | l[3626] << 8 | (l[3627] << 16 | l[3628] << 24), o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, o[r + 18 | 0] = e >>> 16, o[r + 19 | 0] = e >>> 24, e = l[3621] | l[3622] << 8 | (l[3623] << 16 | l[3624] << 24), f = l[3617] | l[3618] << 8 | (l[3619] << 16 | l[3620] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 6, 129, k + 16 | 0), o[k + 27 | 0] >= 0) break i;
                                                X(i[k + 16 >> 2]);
                                                break i;
                                            }
                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(e, r, f);
                                }
                                o[e + f | 0] = 0, i0(A, 6, 1e3, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), A = i[14959], i[k + 16 >> 2] = A, i[i[A - 12 >> 2] + (k + 16 | 0) >> 2] = i[14967], i[k + 24 >> 2] = i[14968], i[t >> 2] = 58864, o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), x0(t), N0(k + 80 | 0);
                            }
                            m = k + 160 | 0;
                        }
                        function rv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], u = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(u, k), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(k), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, Ee(k, r, e), t = n, s = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(t, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(f + 12 | 0, 24663, 13), O4(f, i[r + 100 >> 2]), t = n, n = o[f + 11 | 0], k = (n | 0) < 0, n = U(U(t, k ? i[f >> 2] : f, k ? i[f + 4 >> 2] : n), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], s = (k | 0) < 0, U(n, s ? i[f + 148 >> 2] : t, s ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(n, 23734, 15), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = i[r + 104 >> 2];
                            i: {
                                if (n >>> 0 <= 1090519039) {
                                    M0(f + 12 | 0, n);
                                    break i;
                                }
                                if (k = f + 148 | 0, O4(k, n), t = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] >= 0) break i;
                                X(i[f + 148 >> 2]);
                            }
                            n = U(f + 12 | 0, 34895, 1), k = f + 148 | 0, G0(k, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(n, 23434, 19), e = i[r + 108 >> 2], n = i[r + 112 >> 2];
                            i: {
                                if ((e | 0) == (n | 0) || (r = f + 148 | 0, O4(r, i[e >> 2]), t = r, r = o[f + 159 | 0], k = (r | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), r = e + 4 | 0, (n | 0) == (r | 0))) break i;
                                for(; k = i[r >> 2], o[f + 148 | 0] = 44, s = f + 12 | 0, e = f + 148 | 0, U(s, e, 1), O4(e, k), t = e, e = o[f + 159 | 0], k = (e | 0) < 0, U(s, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), r = r + 4 | 0, (n | 0) != (r | 0););
                            }
                            U(f + 12 | 0, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[e >> 2], r = r - n | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            k = (r | 7) + 1 | 0, e = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function m8(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (s = m - 16 | 0, m = s, f = i[r + 124 >> 2], u = r + 128 | 0, (f | 0) == (u | 0)) t = 1;
                            else {
                                for(;;){
                                    h = i[i[f + 20 >> 2] + 104 >> 2], w = h >>> 0 < t >>> 0, n = i[f + 4 >> 2];
                                    i: {
                                        if (n) {
                                            for(;;)if (k = n, n = i[k >> 2], !n) break i;
                                        }
                                        for(; k = i[f + 8 >> 2], n = i[k >> 2] != (f | 0), f = k, !!n;);
                                    }
                                    if (t = w ? t : h, f = k, (u | 0) == (f | 0)) break;
                                }
                                t = t + 1 | 0;
                            }
                            f = D(184), i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = 76416, k = f + 16 | 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k >> 2] = 73428, h = k, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 72 >> 2] = -1, i[f + 76 >> 2] = -1, i[f + 80 >> 2] = -1, i[f + 84 >> 2] = -1, i[f + 116 >> 2] = 0, i[f + 88 >> 2] = 0, i[f + 92 >> 2] = 0, i[f + 96 >> 2] = 0, i[f + 100 >> 2] = 0, i[f + 104 >> 2] = 0, i[f + 108 >> 2] = 0, Q[f + 112 >> 1] = 0, i[k >> 2] = 74240, i[f + 128 >> 2] = 0, i[f + 132 >> 2] = 0, Q[f + 124 >> 1] = 0, i[f + 136 >> 2] = 0, i[f + 140 >> 2] = 0, i[f + 144 >> 2] = 0, i[f + 148 >> 2] = 0, i[f + 152 >> 2] = 0, i[f + 156 >> 2] = 0, i[f + 160 >> 2] = 0, i[f + 164 >> 2] = 0, i[f + 168 >> 2] = 0, i[f + 172 >> 2] = 0, o[f + 173 | 0] = 0, o[f + 174 | 0] = 0, o[f + 175 | 0] = 0, o[f + 176 | 0] = 0, o[f + 177 | 0] = 0, o[f + 178 | 0] = 0, o[f + 179 | 0] = 0, o[f + 180 | 0] = 0, i[f + 32 >> 2] = 1768842853, i[A + 4 >> 2] = f, i[A >> 2] = k, i[f + 120 >> 2] = t, o[k + 164 | 0] = 0, i[k + 100 >> 2] = i[k + 100 >> 2] & -2, i[f + 128 >> 2] = e;
                            i: {
                                e: {
                                    k = u, n = i[k >> 2];
                                    r: {
                                        if (!n) break r;
                                        for(;;){
                                            if (k = n, e = i[k + 16 >> 2], e >>> 0 > t >>> 0) {
                                                if (u = k, n = i[k >> 2], n) continue;
                                                break r;
                                            }
                                            if (e >>> 0 >= t >>> 0) break e;
                                            if (n = i[k + 4 >> 2], !n) break;
                                        }
                                        u = k + 4 | 0;
                                    }
                                    if (n = D(28), i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 16 >> 2] = t, i[n + 8 >> 2] = k, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[u >> 2] = n, k = n, e = i[i[r + 124 >> 2] >> 2], e && (i[r + 124 >> 2] = e, k = i[u >> 2]), h4(i[r + 128 >> 2], k), i[r + 132 >> 2] = i[r + 132 >> 2] + 1, h = i[A >> 2], f = i[A + 4 >> 2], f) break e;
                                    f = 0;
                                    break i;
                                }
                                i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                            }
                            i[n + 20 >> 2] = h, e = i[n + 24 >> 2], i[n + 24 >> 2] = f;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            r = i[r + 100 >> 2], e = i[A >> 2], i[s + 8 >> 2] = e, k = i[A + 4 >> 2], i[s + 12 >> 2] = k;
                            i: {
                                e: {
                                    r: {
                                        if (!k) {
                                            if (t = r + 40 | 0, f = i[r + 40 >> 2], f >>> 0 >= k0[r + 44 >> 2]) break e;
                                            i[f + 4 >> 2] = k, i[f >> 2] = e;
                                            break r;
                                        }
                                        if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, t = r + 40 | 0, f = i[r + 40 >> 2], f >>> 0 >= k0[r + 44 >> 2]) break e;
                                        i[f + 4 >> 2] = k, i[f >> 2] = e, i[k + 4 >> 2] = i[k + 4 >> 2] + 1;
                                    }
                                    n = f + 8 | 0;
                                    break i;
                                }
                                n = P2(r + 36 | 0, s + 8 | 0), k = i[s + 12 >> 2];
                            }
                            i[t >> 2] = n;
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = s + 16 | 0;
                        }
                        function Av(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 160 | 0, m = f, n = B2(e);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (n >>> 0 > k0[e + 16 >> 2] / 5 >>> 0) {
                                                    i[f + 8 >> 2] = 59808, i[f + 64 >> 2] = 59828, r = i[14961], i[f >> 2] = r, i[i[r - 12 >> 2] + f >> 2] = i[14962], i[f + 4 >> 2] = 0, r = i[i[f >> 2] - 12 >> 2] + f | 0, k = f + 12 | 0, T0(r, k), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[f + 8 >> 2] = r, t = i[r - 12 >> 2], r = f + 8 | 0, i[t + r >> 2] = i[14964], t = i[14960], i[f >> 2] = t, i[i[t - 12 >> 2] + f >> 2] = i[14965], i[f + 64 >> 2] = 59828, i[f >> 2] = 59788, i[f + 8 >> 2] = 59808, t = z0(k), i[t >> 2] = 58864, i[f + 52 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 60 >> 2] = 24, U(M0(U(M0(U(r, 22295, 25), n), 21270, 44), k0[e + 16 >> 2] / 5 | 0), 4666, 15), r = i[f + 60 >> 2];
                                                    k: {
                                                        if (r & 16) {
                                                            k = f + 32 | 0, e = i[f + 56 >> 2], r = i[f + 36 >> 2], e >>> 0 < r >>> 0 ? i[f + 56 >> 2] = r : r = e;
                                                            break k;
                                                        }
                                                        if (!(r & 8)) {
                                                            e = 0, o[f + 159 | 0] = 0, k = f + 148 | 0;
                                                            break e;
                                                        }
                                                        k = f + 20 | 0, r = i[f + 28 >> 2];
                                                    }
                                                    if (e = r, r = i[k >> 2], e = e - r | 0, e >>> 0 >= 2147483640) break f;
                                                    if (e >>> 0 >= 11) {
                                                        n = (e | 7) + 1 | 0, k = D(n), i[f + 156 >> 2] = n | -2147483648, i[f + 148 >> 2] = k, i[f + 152 >> 2] = e;
                                                        break r;
                                                    }
                                                    if (o[f + 159 | 0] = e, k = f + 148 | 0, e) break r;
                                                    e = 0;
                                                    break e;
                                                }
                                                t = r + 104 | 0, u = i[r + 104 >> 2], k = (i[r + 108 >> 2] - u | 0) / 6 | 0;
                                                k: {
                                                    if (k >>> 0 < n >>> 0) {
                                                        Zn(t, n - k | 0);
                                                        break k;
                                                    }
                                                    if (k >>> 0 <= n >>> 0) break k;
                                                    i[r + 108 >> 2] = u + Z(n, 6);
                                                }
                                                if (!n) break A;
                                                for(k = 0;;){
                                                    if (l[e + 20 | 0] | !i[e + 16 >> 2]) break A;
                                                    if (s = B2(e), h = X2(e), w = B2(e), u = i[t >> 2] + Z(k, 6) | 0, Q[u + 4 >> 1] = w, o[u + 2 | 0] = h, Q[u >> 1] = s, k = k + 1 | 0, (n | 0) == (k | 0)) break;
                                                }
                                                break A;
                                            }
                                            Y0(), z();
                                        }
                                        A: {
                                            if (l[e + 20 | 0] == 1) {
                                                if (o[f + 148 | 0] = 0, o[f + 159 | 0] = 0, i0(f, 2, 100, f + 148 | 0), o[f + 159 | 0] >= 0) break A;
                                                X(i[f + 148 >> 2]);
                                                break A;
                                            }
                                            if (k = i[21669], i[f >> 2] = i[21668], i[f + 4 >> 2] = k, k = f + 8 | 0, o[86691] >= 0) {
                                                n = i[21671], i[k >> 2] = i[21670], i[k + 4 >> 2] = n, i[k + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(k, i[21670], i[21671]);
                                        }
                                        if (k = i[f >> 2], o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), k && (i[r + 108 >> 2] = i[r + 104 >> 2]), l[e + 20 | 0] == 1) {
                                            if (o[f | 0] = 0, o[f + 11 | 0] = 0, i0(A, 2, 100, f), o[f + 11 | 0] >= 0) break i;
                                            X(i[f >> 2]);
                                            break i;
                                        }
                                        if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break i;
                                        }
                                        j(A, i[21670], i[21671]);
                                        break i;
                                    }
                                    Q0(k, r, e);
                                }
                                o[e + k | 0] = 0, i0(A, 2, 100, f + 148 | 0), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), A = i[14959], i[f >> 2] = A, i[i[A - 12 >> 2] + f >> 2] = i[14967], i[f + 8 >> 2] = i[14968], i[t >> 2] = 58864, o[f + 55 | 0] < 0 && X(i[f + 44 >> 2]), x0(t), N0(f - -64 | 0);
                            }
                            m = f + 160 | 0;
                        }
                        function We(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            if (h = m - 2048 | 0, m = h, v = 5, (e | 0) >= 2) {
                                for(v = 0, n = e; t = v, v = t + 1 | 0, u = n >>> 0 > 3, n = n >>> 1 | 0, !!u;);
                                v = 4 - t | 0;
                            }
                            i: {
                                if ((e | 0) <= 0) break i;
                                for(y = e & 2147483644, G = e & 3, W = e - 1 | 0;;){
                                    _ = (s << 1) + f | 0, n = 0, t = e;
                                    e: {
                                        for(;;){
                                            if (B = n, u = t, (t | 0) <= 0) {
                                                if (t = 0, n = 0, u = 0, W >>> 0 >= 3) for(; Q[(Z(e, n) + s << 1) + h >> 1] = 0, Q[(Z(n | 1, e) + s << 1) + h >> 1] = 0, Q[(Z(n | 2, e) + s << 1) + h >> 1] = 0, Q[(Z(n | 3, e) + s << 1) + h >> 1] = 0, n = n + 4 | 0, u = u + 4 | 0, (y | 0) != (u | 0););
                                                if (!G) break e;
                                                for(; Q[(Z(e, n) + s << 1) + h >> 1] = 0, n = n + 1 | 0, t = t + 1 | 0, (G | 0) != (t | 0););
                                                break e;
                                            }
                                            if (n = B + 1 | 0, t = u - 1 | 0, !!I[_ + (Z(t, e) << 1) >> 1]) break;
                                        }
                                        for(F = u & 2147483646, C = u & 1, t = 0;;){
                                            if (n = 0, u = 0, w = 0, (B | 0) != (W | 0)) for(; V = Z(Q[_ + (Z(e, n) << 1) >> 1], o[((n << v << 5) + t | 0) + 49296 | 0]) + u | 0, u = n | 1, u = V + Z(Q[_ + (Z(u, e) << 1) >> 1], o[((u << v << 5) + t | 0) + 49296 | 0]) | 0, n = n + 2 | 0, w = w + 2 | 0, (F | 0) != (w | 0););
                                            if (w = (Z(e, t) + s << 1) + h | 0, C && (u = Z(Q[_ + (Z(e, n) << 1) >> 1], o[((n << v << 5) + t | 0) + 49296 | 0]) + u | 0), n = u - -64 >> 7, n = (n | 0) >= 32767 ? 32767 : n, Q[w >> 1] = (n | 0) <= -32768 ? -32768 : n, t = t + 1 | 0, (t | 0) == (e | 0)) break;
                                        }
                                    }
                                    if (s = s + 1 | 0, (s | 0) == (e | 0)) break;
                                }
                                if ((e | 0) <= 0) break i;
                                for(y = e & 2147483646, F = e & 1, C = 1 << 19 - k, V = 20 - k | 0, G = C >> V, s = -1 << k ^ -1, k = 0;;){
                                    _ = Z(e, k), n = 0, t = e;
                                    e: {
                                        r: {
                                            for(;;){
                                                if (B = n, f = t, (t | 0) <= 0) break r;
                                                if (n = n + 1 | 0, t = t - 1 | 0, !!I[(_ + t << 1) + h >> 1]) break;
                                            }
                                            for(E = f & 2147483646, R = f & 1, M = (Z(r, k) << 1) + A | 0, t = 0;;){
                                                if (n = 0, u = 0, w = 0, (B | 0) != (W | 0)) for(; f = n | 1, u = (Z(Q[(n + _ << 1) + h >> 1], o[((n << v << 5) + t | 0) + 49296 | 0]) + u | 0) + Z(Q[(f + _ << 1) + h >> 1], o[((f << v << 5) + t | 0) + 49296 | 0]) | 0, n = n + 2 | 0, w = w + 2 | 0, (E | 0) != (w | 0););
                                                if (f = (t << 1) + M | 0, w = I[f >> 1], R && (u = Z(Q[(n + _ << 1) + h >> 1], o[((n << v << 5) + t | 0) + 49296 | 0]) + u | 0), n = f, f = (u + C >> V) + w | 0, Q[n >> 1] = (f | 0) >= 0 ? (f | 0) < (s | 0) ? f : s : 0, t = t + 1 | 0, (t | 0) == (e | 0)) break;
                                            }
                                            break e;
                                        }
                                        if (u = (Z(r, k) << 1) + A | 0, n = 0, B = 0, W) for(; f = u + (n << 1) | 0, t = G + I[f >> 1] | 0, Q[f >> 1] = (t | 0) >= 0 ? (t | 0) < (s | 0) ? t : s : 0, t = f, f = G + I[f + 2 >> 1] | 0, Q[t + 2 >> 1] = (f | 0) >= 0 ? (f | 0) < (s | 0) ? f : s : 0, n = n + 2 | 0, B = B + 2 | 0, (y | 0) != (B | 0););
                                        if (!F) break e;
                                        t = u + (n << 1) | 0, f = G + I[t >> 1] | 0, Q[t >> 1] = (f | 0) >= 0 ? (f | 0) < (s | 0) ? f : s : 0;
                                    }
                                    if (k = k + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                            m = h + 2048 | 0;
                        }
                        function A5(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            W = m - 16 | 0, m = W;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (p[i[i[A >> 2] + 12 >> 2]](A, f) | 0) {
                                                    if (v = p[i[i[A >> 2] + 8 >> 2]](A, f) | 0, !(i[v + 24 >> 2] > (k | 0) & i[v + 28 >> 2] > (n | 0))) {
                                                        W2(A + 4 | 0, 1026, 0), o[h | 0] = 0;
                                                        break r;
                                                    }
                                                    k: {
                                                        if (w = i[v + 168 >> 2], f = k >> w, (f | 0) < 0 || (_ = i[v + 172 >> 2], (_ | 0) <= (f | 0))) break k;
                                                        if (w = n >> w, !((w | 0) < 0 | (w | 0) >= i[v + 176 >> 2])) {
                                                            if (!(l[((i[v + 160 >> 2] + Z(f, 3) | 0) + Z(Z(w, _), 3) | 0) + 1 | 0] & 3)) {
                                                                Q[s >> 1] = 0, Q[s + 2 >> 1] = 0, o[h | 0] = 0;
                                                                break r;
                                                            }
                                                            if (l[v + 312 | 0] == 1) {
                                                                Q[s >> 1] = 0, Q[s + 2 >> 1] = 0, o[h | 0] = 0;
                                                                break r;
                                                            }
                                                            n: {
                                                                if (w = i[v + 188 >> 2], f = k >> w, (f | 0) < 0 || (_ = i[v + 192 >> 2], (_ | 0) <= (f | 0))) break n;
                                                                if (w = n >> w, !((w | 0) < 0 | (w | 0) >= i[v + 196 >> 2])) {
                                                                    if (w = (i[v + 180 >> 2] + Z(f, 12) | 0) + Z(Z(w, _), 12) | 0, !l[w | 0]) {
                                                                        _ = w + 3 | 0, f = 1, w = w + 8 | 0;
                                                                        break A;
                                                                    }
                                                                    if (!l[w + 1 | 0]) {
                                                                        _ = w + 2 | 0, f = 0, w = w + 4 | 0;
                                                                        break A;
                                                                    }
                                                                    if (B = i[r + 96 >> 2], _ = 1, i[e + 340 >> 2] <= 0) break f;
                                                                    for(G = e + 988 | 0, f = 0;;){
                                                                        if (C = i[(p[i[i[A >> 2] + 8 >> 2]](A, i[G + (f << 2) >> 2]) | 0) + 96 >> 2], _ = (C | 0) <= (B | 0), f = f + 1 | 0, (f | 0) >= i[e + 340 >> 2]) break f;
                                                                        if (!((B | 0) >= (C | 0))) break;
                                                                    }
                                                                    break f;
                                                                }
                                                                break e;
                                                            }
                                                            break i;
                                                        }
                                                        break e;
                                                    }
                                                    break i;
                                                }
                                                y0(20330, 14978, 1136, 4185), z();
                                            }
                                            f: {
                                                if (!_ | i[e + 336 >> 2] <= 0) break f;
                                                for(G = e + 924 | 0, f = 0;;){
                                                    if (C = i[(p[i[i[A >> 2] + 8 >> 2]](A, i[G + (f << 2) >> 2]) | 0) + 96 >> 2], _ = (C | 0) <= (B | 0), f = f + 1 | 0, (f | 0) >= i[e + 336 >> 2]) break f;
                                                    if (!((B | 0) >= (C | 0))) break;
                                                }
                                            }
                                            if (_) {
                                                _ = (u + w | 0) + 2 | 0, f = u, w = (w + (f << 2) | 0) + 4 | 0;
                                                break A;
                                            }
                                            f = o[e + 380 | 0], _ = (w + f | 0) + 2 | 0, w = (w + (f << 2) | 0) + 4 | 0;
                                        }
                                        if (B = i[v + 148 >> 2], k = k >> B, (k | 0) < 0 || (G = i[v + 152 >> 2], (G | 0) <= (k | 0))) break i;
                                        if (n = n >> B, (n | 0) < 0 | (n | 0) >= i[v + 156 >> 2]) break e;
                                        if (k = I[((i[v + 140 >> 2] + Z(k, 24) | 0) + Z(Z(n, G), 24) | 0) + 2 >> 1], B = i[v + 52 >> 2], k >>> 0 >= i[v + 56 >> 2] - B >> 2 >>> 0) {
                                            W2(A + 4 | 0, 1033, 0), o[h | 0] = 0, Q[s >> 1] = 0, Q[s + 2 >> 1] = 0;
                                            break r;
                                        }
                                        if (n = (((u << 4) + e | 0) + t | 0) + 1308 | 0, _ = o[_ | 0], B = i[B + (k << 2) >> 2], l[n | 0] != l[(_ + (B + (f << 4) | 0) | 0) + 1308 | 0]) {
                                            o[h | 0] = 0, Q[s >> 1] = 0, Q[s + 2 >> 1] = 0;
                                            break r;
                                        }
                                        k = I[w >> 1] | I[w + 2 >> 1] << 16, o[h | 0] = 1;
                                        A: {
                                            if (!l[n | 0] && (f = i[v + 96 >> 2] - i[((B + (f << 6) | 0) + (_ << 2) | 0) + 1052 >> 2] | 0, e = i[r + 96 >> 2] - i[(((u << 6) + e | 0) + (t << 2) | 0) + 1052 >> 2] | 0, (f | 0) != (e | 0))) break A;
                                            Q[s >> 1] = k, Q[s + 2 >> 1] = k >>> 16;
                                            break r;
                                        }
                                        if (i[W + 8 >> 2] = k, i[W + 12 >> 2] = k, En(s, W + 8 | 0, f, e)) break r;
                                        W2(A + 4 | 0, 1008, 0), o[r + 312 | 0] = 3;
                                    }
                                    m = W + 16 | 0;
                                    return;
                                }
                                y0(4067, 9012, 119, 3731), z();
                            }
                            y0(4105, 9012, 118, 3731), z();
                        }
                        function Xe(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            e = m - 80 | 0, m = e, p[i[i[r >> 2] + 24 >> 2]](e + 48 | 0, r);
                            i: {
                                e: {
                                    r: {
                                        if (i[e + 60 >> 2]) {
                                            if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 64 >> 2], i[A + 12 >> 2] = i[e + 60 >> 2], i[A + 16 >> 2] = r, A = A + 20 | 0, o[e + 79 | 0] >= 0) {
                                                r = i[e + 72 >> 2], i[A >> 2] = i[e + 68 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 76 >> 2];
                                                break r;
                                            }
                                            j(A, i[e + 68 >> 2], i[e + 72 >> 2]);
                                            break r;
                                        }
                                        if (i[e + 44 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, f = i[e + 52 >> 2], k = i[e + 48 >> 2], (f | 0) != (k | 0)) {
                                            if (f = f - k | 0, (f | 0) < 0) break e;
                                            n = D(f), i[e + 36 >> 2] = n, t = f + n | 0, i[e + 44 >> 2] = t, v0(n, k, f), i[e + 40 >> 2] = t;
                                        }
                                        k = e + 12 | 0, f = m - 32 | 0, m = f, r = r + 4 | 0, n = r + 12 | 0;
                                        A: {
                                            if (i[r + 12 >> 2] != i[r + 16 >> 2]) {
                                                if (i[k >> 2] = n, r = i[21669], i[k + 4 >> 2] = i[21668], i[k + 8 >> 2] = r, r = k + 12 | 0, o[86691] >= 0) {
                                                    k = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[21672];
                                                    break A;
                                                }
                                                j(r, i[21670], i[21671]);
                                                break A;
                                            }
                                            if (l[r + 8 | 0] == 1) {
                                                w6(f + 8 | 0, i[r >> 2], i[r + 24 >> 2], n, 0, 0, -1, -1), t = i[f + 8 >> 2];
                                                f: {
                                                    if (!t) break f;
                                                    if (i[k >> 2] = 0, r = i[f + 12 >> 2], i[k + 4 >> 2] = i[f + 8 >> 2], i[k + 8 >> 2] = r, r = k + 12 | 0, o[f + 27 | 0] >= 0) {
                                                        u = i[f + 20 >> 2], i[r >> 2] = i[f + 16 >> 2], i[r + 4 >> 2] = u, i[r + 8 >> 2] = i[f + 24 >> 2];
                                                        break f;
                                                    }
                                                    j(r, i[f + 16 >> 2], i[f + 20 >> 2]);
                                                }
                                                if (o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), t) break A;
                                            }
                                            if (i[k >> 2] = n, r = i[21669], i[k + 4 >> 2] = i[21668], i[k + 8 >> 2] = r, r = k + 12 | 0, o[86691] >= 0) {
                                                k = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = k, i[r + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(r, i[21670], i[21671]);
                                        }
                                        m = f + 32 | 0;
                                        A: {
                                            if (i[e + 16 >> 2]) {
                                                if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 20 >> 2], i[A + 12 >> 2] = i[e + 16 >> 2], i[A + 16 >> 2] = r, A = A + 20 | 0, o[e + 35 | 0] >= 0) {
                                                    r = i[e + 28 >> 2], i[A >> 2] = i[e + 24 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 32 >> 2];
                                                    break A;
                                                }
                                                j(A, i[e + 24 >> 2], i[e + 28 >> 2]);
                                                break A;
                                            }
                                            if (r = i[e + 12 >> 2], f = i[r >> 2], r = i[r + 4 >> 2], G8(e + 36 | 0, i[e + 40 >> 2], f, r, r - f | 0), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 40 >> 2], k = i[e + 36 >> 2], (r | 0) != (k | 0)) {
                                                if (r = r - k | 0, (r | 0) < 0) break i;
                                                f = D(r), i[A + 4 >> 2] = f, i[A >> 2] = f, n = r + f | 0, i[A + 8 >> 2] = n, v0(f, k, r), i[A + 4 >> 2] = n;
                                            }
                                            if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(A, i[21670], i[21671]);
                                        }
                                        if (o[e + 35 | 0] < 0 && X(i[e + 24 >> 2]), A = i[e + 36 >> 2], !A) break r;
                                        i[e + 40 >> 2] = A, X(A);
                                    }
                                    o[e + 79 | 0] < 0 && X(i[e + 68 >> 2]), A = i[e + 48 >> 2], A && (i[e + 52 >> 2] = A, X(A)), m = e + 80 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function J8(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            w = m - 32 | 0, m = w;
                            i: {
                                e: {
                                    if (B = i[e >> 2], v = i[B + 64 >> 2], !v) break e;
                                    for(h = B - -64 | 0, u = h, t = v; s = i[t + 16 >> 2] < (f | 0), u = s ? u : t, t = i[(s << 2) + t >> 2], !!t;);
                                    for(W = (u | 0) == (h | 0) | i[u + 16 >> 2] > (f | 0) ? W : i[u + 28 >> 2], u = h, t = v; s = i[t + 16 >> 2] < (f | 0), u = s ? u : t, t = i[(s << 2) + t >> 2], !!t;);
                                    if (G = (u | 0) == (h | 0) | i[u + 16 >> 2] > (f | 0) ? G : i[u + 32 >> 2], !v) break e;
                                    for(u = h, t = v; s = i[t + 16 >> 2] < (f | 0), u = s ? u : t, t = i[(s << 2) + t >> 2], !!t;);
                                    if (t = h, (u | 0) != (t | 0) ? u = i[u + 16 >> 2] > (f | 0) ? t : u : u = t, _ = i[u + 20 >> 2], s = 255, !v) break i;
                                    for(; u = i[v + 16 >> 2] < (f | 0), t = u ? t : v, v = i[(u << 2) + v >> 2], !!v;);
                                    if ((t | 0) == (h | 0) | i[t + 16 >> 2] > (f | 0)) break i;
                                    s = l[t + 24 | 0];
                                    break i;
                                }
                                _ = i[B + 84 >> 2], s = 255;
                            }
                            F3(w + 8 | 0, r, k, W, G, _, s, n);
                            i: {
                                if (i[w + 8 >> 2]) {
                                    r = i[w + 12 >> 2], i[A >> 2] = i[w + 8 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[w + 24 >> 2], r = i[w + 20 >> 2], i[A + 8 >> 2] = i[w + 16 >> 2], i[A + 12 >> 2] = r, i[w + 24 >> 2] = 0, i[w + 16 >> 2] = 0, i[w + 20 >> 2] = 0;
                                    break i;
                                }
                                B = i[e >> 2], e = B - -64 | 0;
                                e: {
                                    r: {
                                        if (u = i[B + 64 >> 2], !u) break r;
                                        for(s = e, t = u; n = i[t + 16 >> 2] < (f | 0), s = n ? s : t, t = i[(n << 2) + t >> 2], !!t;);
                                        if ((e | 0) == (s | 0)) break r;
                                        if (_ = 0, n = 0, i[s + 16 >> 2] > (f | 0)) break e;
                                        _ = i[s + 44 >> 2], n = i[s + 52 >> 2];
                                        break e;
                                    }
                                    _ = 0, n = 0;
                                }
                                t = i[r + 64 >> 2], h = 0;
                                e: {
                                    if (!t) break e;
                                    for(v = r - -64 | 0, s = v; r = i[t + 16 >> 2] < (k | 0), s = r ? s : t, t = i[(r << 2) + t >> 2], !!t;);
                                    if (h = 0, (s | 0) == (v | 0) || (h = 0, i[s + 16 >> 2] > (k | 0))) break e;
                                    C = i[s + 52 >> 2], h = i[s + 44 >> 2];
                                }
                                r = h;
                                e: {
                                    if ((f | 0) == 10) {
                                        if (k = 31, e = i[B + 36 >> 2] - 10 | 0, e >>> 0 >= 6) break e;
                                        k = i[(e << 2) + 39108 >> 2];
                                        break e;
                                    }
                                    if (k = 0, !u) break e;
                                    for(t = e; h = i[u + 16 >> 2] < (f | 0), t = h ? t : u, u = i[(h << 2) + u >> 2], !!u;);
                                    if ((e | 0) == (t | 0) | i[t + 16 >> 2] > (f | 0)) break e;
                                    k = (l[t + 24 | 0] + 7 & 248) >>> 3 | 0;
                                }
                                e: {
                                    if (!G) break e;
                                    if (k = Z(k, W), t = 0, (G | 0) != 1) for(f = G & -2, u = 0; v0(r + Z(t, C) | 0, Z(n, t) + _ | 0, k), e = t | 1, v0(r + Z(e, C) | 0, Z(e, n) + _ | 0, k), t = t + 2 | 0, u = u + 2 | 0, (f | 0) != (u | 0););
                                    if (!(G & 1)) break e;
                                    v0(r + Z(t, C) | 0, Z(n, t) + _ | 0, k);
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            o[w + 27 | 0] < 0 && X(i[w + 16 >> 2]), m = w + 32 | 0;
                        }
                        function pe(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0;
                            if (h = m - 2048 | 0, m = h, v = 5, (r | 0) >= 2) {
                                for(v = 0, n = r; t = v, v = t + 1 | 0, B = n >>> 0 > 3, n = n >>> 1 | 0, !!B;);
                                v = 4 - t | 0;
                            }
                            i: {
                                if ((r | 0) <= 0) break i;
                                for(G = 1 << k, B = 0 - G | 0, W = G + 65535 | 0, y = r & 2147483644, C = r & 3, V = r - 1 | 0;;){
                                    _ = (u << 1) + e | 0, n = 0, k = r;
                                    e: {
                                        for(;;){
                                            if (w = n, t = k, (k | 0) <= 0) {
                                                if (k = 0, n = 0, t = 0, V >>> 0 >= 3) for(; Q[(Z(r, n) + u << 1) + h >> 1] = 0, Q[(Z(n | 1, r) + u << 1) + h >> 1] = 0, Q[(Z(n | 2, r) + u << 1) + h >> 1] = 0, Q[(Z(n | 3, r) + u << 1) + h >> 1] = 0, n = n + 4 | 0, t = t + 4 | 0, (y | 0) != (t | 0););
                                                if (!C) break e;
                                                for(; Q[(Z(r, n) + u << 1) + h >> 1] = 0, n = n + 1 | 0, k = k + 1 | 0, (C | 0) != (k | 0););
                                                break e;
                                            }
                                            if (n = w + 1 | 0, k = t - 1 | 0, !!I[_ + (Z(k, r) << 1) >> 1]) break;
                                        }
                                        for(F = t & 2147483646, E = t & 1, k = 0;;){
                                            if (n = 0, t = 0, s = 0, (w | 0) != (V | 0)) for(; R = Z(Q[_ + (Z(r, n) << 1) >> 1], o[((n << v << 5) + k | 0) + 49296 | 0]) + t | 0, t = n | 1, t = R + Z(Q[_ + (Z(t, r) << 1) >> 1], o[((t << v << 5) + k | 0) + 49296 | 0]) | 0, n = n + 2 | 0, s = s + 2 | 0, (F | 0) != (s | 0););
                                            if (s = (Z(r, k) + u << 1) + h | 0, E && (t = Z(Q[_ + (Z(r, n) << 1) >> 1], o[((n << v << 5) + k | 0) + 49296 | 0]) + t | 0), n = t - -64 >> 7, Q[s >> 1] = (n | 0) < (B | 0) ? B : (n | 0) < (G | 0) ? n : W, k = k + 1 | 0, (k | 0) == (r | 0)) break;
                                        }
                                    }
                                    if (u = u + 1 | 0, (u | 0) == (r | 0)) break;
                                }
                                if ((r | 0) <= 0) break i;
                                for(C = r & 2147483640, G = r & 7, W = 1 << f - 1, w = W >> f, _ = 0;;){
                                    u = Z(r, _), n = 0, k = r;
                                    e: {
                                        r: {
                                            for(;;){
                                                if (B = n, e = k, (k | 0) <= 0) break r;
                                                if (n = n + 1 | 0, k = k - 1 | 0, !!I[(u + k << 1) + h >> 1]) break;
                                            }
                                            for(y = e & 2147483646, e = e & 1, F = (u << 2) + A | 0, k = 0;;){
                                                if (n = 0, t = 0, s = 0, (B | 0) != (V | 0)) for(; E = Z(Q[(n + u << 1) + h >> 1], o[((n << v << 5) + k | 0) + 49296 | 0]) + t | 0, t = n | 1, t = E + Z(Q[(t + u << 1) + h >> 1], o[((t << v << 5) + k | 0) + 49296 | 0]) | 0, n = n + 2 | 0, s = s + 2 | 0, (y | 0) != (s | 0););
                                                if (s = F + (k << 2) | 0, e && (t = Z(Q[(n + u << 1) + h >> 1], o[((n << v << 5) + k | 0) + 49296 | 0]) + t | 0), i[s >> 2] = t + W >> f, k = k + 1 | 0, (k | 0) == (r | 0)) break;
                                            }
                                            break e;
                                        }
                                        if (n = (u << 2) + A | 0, t = 0, k = 0, s = 0, V >>> 0 >= 7) for(; e = n + (k << 2) | 0, i[e >> 2] = w, i[e + 4 >> 2] = w, i[e + 8 >> 2] = w, i[e + 12 >> 2] = w, i[e + 16 >> 2] = w, i[e + 20 >> 2] = w, i[e + 24 >> 2] = w, i[e + 28 >> 2] = w, k = k + 8 | 0, s = s + 8 | 0, (C | 0) != (s | 0););
                                        if (!G) break e;
                                        for(; i[n + (k << 2) >> 2] = w, k = k + 1 | 0, t = t + 1 | 0, (G | 0) != (t | 0););
                                    }
                                    if (_ = _ + 1 | 0, (_ | 0) == (r | 0)) break;
                                }
                            }
                            m = h + 2048 | 0;
                        }
                        function f5(A, r, e, f) {
                            var k = 0, n = 0;
                            k = m - 96 | 0, m = k, n = i[r + 472 >> 2], i[n + 36 >> 2] = 0, p[i[i[n >> 2] + 60 >> 2]](k + 72 | 0, n);
                            i: {
                                e: {
                                    if (i[k + 72 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, o[A + 8 | 0] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0, r = i[k + 76 >> 2], i[A + 28 >> 2] = i[k + 72 >> 2], i[A + 32 >> 2] = r, A = A + 36 | 0, o[k + 91 | 0] >= 0) {
                                            r = i[k + 84 >> 2], i[A >> 2] = i[k + 80 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 88 >> 2];
                                            break e;
                                        }
                                        j(A, i[k + 80 >> 2], i[k + 84 >> 2]);
                                        break e;
                                    }
                                    n = i[r + 472 >> 2], p[i[i[n >> 2] + 32 >> 2]](k + 40 | 0, n);
                                    r: {
                                        if (i[k + 52 >> 2]) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, o[A + 8 | 0] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0, r = i[k + 56 >> 2], i[A + 28 >> 2] = i[k + 52 >> 2], i[A + 32 >> 2] = r, A = A + 36 | 0, o[k + 71 | 0] >= 0) {
                                                r = i[k + 64 >> 2], i[A >> 2] = i[k + 60 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 68 >> 2];
                                                break r;
                                            }
                                            j(A, i[k + 60 >> 2], i[k + 64 >> 2]);
                                            break r;
                                        }
                                        if (y3(k + 8 | 0, r, k + 40 | 0, e, f), e = i[k + 12 >> 2], r = i[k + 8 >> 2], i[k + 72 >> 2] = r, i[k + 76 >> 2] = e, o[k + 91 | 0] < 0 && (X(i[k + 80 >> 2]), r = i[k + 72 >> 2]), e = i[k + 20 >> 2], i[k + 80 >> 2] = i[k + 16 >> 2], i[k + 84 >> 2] = e, i[k + 88 >> 2] = i[k + 24 >> 2], r) {
                                            if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, o[A + 8 | 0] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0, r = i[k + 76 >> 2], i[A + 28 >> 2] = i[k + 72 >> 2], i[A + 32 >> 2] = r, A = A + 36 | 0, o[k + 91 | 0] >= 0) {
                                                r = i[k + 84 >> 2], i[A >> 2] = i[k + 80 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 88 >> 2];
                                                break r;
                                            }
                                            j(A, i[k + 80 >> 2], i[k + 84 >> 2]);
                                            break r;
                                        }
                                        if (o[k + 16 | 0] = 0, i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, r = i[k + 40 >> 2], e = i[k + 44 >> 2], b4(k + 20 | 0, r, e, e - r | 0), i[A >> 2] = i[k + 8 >> 2], r = i[k + 12 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = l[k + 16 | 0], i[A + 20 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, o[A + 8 | 0] = r, r = i[k + 20 >> 2], e = i[k + 24 >> 2], (r | 0) != (e | 0)) {
                                            if (e = e - r | 0, (e | 0) < 0) break i;
                                            f = D(e), i[A + 16 >> 2] = f, i[A + 12 >> 2] = f, n = e + f | 0, i[A + 20 >> 2] = n, v0(f, r, e), i[A + 16 >> 2] = n;
                                        }
                                        i[A + 24 >> 2] = i[k + 32 >> 2], e = i[21669], i[A + 28 >> 2] = i[21668], i[A + 32 >> 2] = e, A = A + 36 | 0;
                                        A: {
                                            if (o[86691] >= 0) {
                                                e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(A, i[21670], i[21671]), r = i[k + 20 >> 2];
                                        }
                                        if (r && (i[k + 24 >> 2] = r, X(r)), A = i[k + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                    }
                                    if (o[k + 71 | 0] < 0 && X(i[k + 60 >> 2]), A = i[k + 40 >> 2], !A) break e;
                                    i[k + 44 >> 2] = A, X(A);
                                }
                                o[k + 91 | 0] < 0 && X(i[k + 80 >> 2]), m = k + 96 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function k5(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            h = m - 128 | 0, m = h;
                            i: {
                                e: {
                                    r: {
                                        if (!$8(n, t, u, s, 0, 0, 0, 0)) break r;
                                        w = s & 65535, _ = s >>> 16 & 32767;
                                        A: f: {
                                            if ((_ | 0) != 32767) {
                                                if (B = 4, _) break f;
                                                B = n | u | (t | w) ? 3 : 2;
                                                break A;
                                            }
                                            B = !(n | u | (t | w));
                                        }
                                        if (!B) break r;
                                        if (y = k >>> 16 | 0, W = y & 32767, (W | 0) != 32767) break e;
                                    }
                                    f1(h + 16 | 0, r, e, f, k, n, t, u, s), r = i[h + 16 >> 2], f = i[h + 20 >> 2], k = i[h + 24 >> 2], e = i[h + 28 >> 2], Y7(h, r, f, k, e, r, f, k, e), f = i[h + 8 >> 2], k = i[h + 12 >> 2], u = i[h >> 2], s = i[h + 4 >> 2];
                                    break i;
                                }
                                if (G = f, B = k & 2147483647, w = B, _ = u, v = s & 2147483647, ($8(r, e, G, w, n, t, u, v) | 0) <= 0) {
                                    if ($8(r, e, G, w, n, t, u, v)) {
                                        u = r, s = e;
                                        break i;
                                    }
                                    f1(h + 112 | 0, r, e, f, k, 0, 0, 0, 0), f = i[h + 120 >> 2], k = i[h + 124 >> 2], u = i[h + 112 >> 2], s = i[h + 116 >> 2];
                                    break i;
                                }
                                if (C = s >>> 16 & 32767, W ? (s = e, u = r) : (f1(h + 96 | 0, r, e, G, B, 0, 0, 0, 1081540608), G = i[h + 104 >> 2], u = i[h + 108 >> 2], B = u, W = (u >>> 16 | 0) - 120 | 0, s = i[h + 100 >> 2], u = i[h + 96 >> 2]), C || (f1(h + 80 | 0, n, t, _, v, 0, 0, 0, 1081540608), _ = i[h + 88 >> 2], n = i[h + 92 >> 2], v = n, C = (n >>> 16 | 0) - 120 | 0, t = i[h + 84 >> 2], n = i[h + 80 >> 2]), V = _, F = v & 65535 | 65536, B = B & 65535 | 65536, (W | 0) > (C | 0)) {
                                    for(;;){
                                        v = G - V | 0, w = (t | 0) == (s | 0) & n >>> 0 > u >>> 0 | t >>> 0 > s >>> 0, _ = v - w | 0, w = (B - ((G >>> 0 < V >>> 0) + F | 0) | 0) - (w >>> 0 > v >>> 0) | 0;
                                        e: {
                                            if ((w | 0) >= 0 | (w | 0) > 0) {
                                                if (G = u, u = u - n | 0, s = s - ((n >>> 0 > G >>> 0) + t | 0) | 0, !(u | _ | (s | w))) {
                                                    f1(h + 32 | 0, r, e, f, k, 0, 0, 0, 0), f = i[h + 40 >> 2], k = i[h + 44 >> 2], u = i[h + 32 >> 2], s = i[h + 36 >> 2];
                                                    break i;
                                                }
                                                w = w << 1 | _ >>> 31, G = _ << 1 | s >>> 31;
                                                break e;
                                            }
                                            w = B << 1 | G >>> 31, G = G << 1 | s >>> 31;
                                        }
                                        if (B = w, w = s << 1 | u >>> 31, u = u << 1, s = w, W = W - 1 | 0, !((C | 0) < (W | 0))) break;
                                    }
                                    W = C;
                                }
                                v = G - V | 0, w = (t | 0) == (s | 0) & n >>> 0 > u >>> 0 | t >>> 0 > s >>> 0, _ = v - w | 0, w = (B - ((G >>> 0 < V >>> 0) + F | 0) | 0) - (w >>> 0 > v >>> 0) | 0, v = w;
                                e: {
                                    if ((w | 0) < 0) {
                                        _ = G, v = B;
                                        break e;
                                    }
                                    if (G = u, u = u - n | 0, s = s - ((n >>> 0 > G >>> 0) + t | 0) | 0, u | _ | (s | v)) break e;
                                    f1(h + 48 | 0, r, e, f, k, 0, 0, 0, 0), f = i[h + 56 >> 2], k = i[h + 60 >> 2], u = i[h + 48 >> 2], s = i[h + 52 >> 2];
                                    break i;
                                }
                                if ((v | 0) == 65535 | v >>> 0 < 65535) for(; r = s >>> 31 | 0, W = W - 1 | 0, B = s << 1 | u >>> 31, u = u << 1, s = B, e = r, r = v << 1 | _ >>> 31, _ = e | _ << 1, v = r, r >>> 0 < 65536;);
                                if (r = y & 32768, (W | 0) <= 0) {
                                    f1(h - -64 | 0, u, s, _, v & 65535 | (r | W + 120) << 16, 0, 0, 0, 1065811968), f = i[h + 72 >> 2], k = i[h + 76 >> 2], u = i[h + 64 >> 2], s = i[h + 68 >> 2];
                                    break i;
                                }
                                f = _, k = v & 65535 | (r | W) << 16;
                            }
                            i[A >> 2] = u, i[A + 4 >> 2] = s, i[A + 8 >> 2] = f, i[A + 12 >> 2] = k, m = h + 128 | 0;
                        }
                        function fv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 176 | 0, m = f, i[f + 84 >> 2] = 60132, k = i[15036], i[f + 28 >> 2] = k, t = i[k - 12 >> 2], k = f + 28 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 28 >> 2] - 12 >> 2] | 0, n = f + 32 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 84 >> 2] = 60132, i[f + 28 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 72 >> 2] = 0, i[f + 76 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 68 >> 2] = 0, i[f + 80 >> 2] = 16, n = f + 164 | 0, Ee(n, r, e), s = k, t = n, k = o[f + 175 | 0], n = (k | 0) < 0, U(s, n ? i[f + 164 >> 2] : t, n ? i[f + 168 >> 2] : k), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]);
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (t = i[r + 12 >> 2], n = i[r + 32 >> 2], k = i[r + 8 >> 2], !t & n >>> 0 <= k >>> 0 | t) {
                                                    r = i[r + 100 >> 2], Q[f + 20 >> 1] = l[24840] | l[24841] << 8, o[f + 27 | 0] = 6, i[f + 16 >> 2] = l[24836] | l[24837] << 8 | (l[24838] << 16 | l[24839] << 24), o[f + 22 | 0] = 0, Q[f + 8 >> 1] = l[25192] | l[25193] << 8, o[f + 15 | 0] = 6, i[f + 4 >> 2] = l[25188] | l[25189] << 8 | (l[25190] << 16 | l[25191] << 24), o[f + 10 | 0] = 0, e = f + 164 | 0, w5(e, r, k - n | 0, f + 16 | 0, f + 4 | 0), k = e, r = o[f + 175 | 0], e = (r | 0) < 0, U(f + 28 | 0, e ? i[f + 164 >> 2] : k, e ? i[f + 168 >> 2] : r), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), r = i[f + 80 >> 2];
                                                    k: {
                                                        if (r & 16) {
                                                            r = i[f + 76 >> 2], e = i[f + 56 >> 2], r >>> 0 < e >>> 0 && (i[f + 76 >> 2] = e, r = e), e = f + 52 | 0;
                                                            break k;
                                                        }
                                                        if (!(r & 8)) {
                                                            o[A + 11 | 0] = 0;
                                                            break i;
                                                        }
                                                        r = i[f + 48 >> 2], e = f + 40 | 0;
                                                    }
                                                    if (k = i[e >> 2], e = r - k | 0, e >>> 0 >= 2147483640) break f;
                                                    if (e >>> 0 >= 11) {
                                                        n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                                        break e;
                                                    }
                                                    if (o[A + 11 | 0] = e, e) break e;
                                                    break i;
                                                }
                                                k = f + 164 | 0, G0(k, e), t = k, e = o[f + 175 | 0], k = (e | 0) < 0, U(f + 28 | 0, k ? i[f + 164 >> 2] : t, k ? i[f + 168 >> 2] : e), o[f + 175 | 0] < 0 && X(i[f + 164 >> 2]), U(K1(U(f + 28 | 0, 22196, 17), i[r + 8 >> 2], i[r + 12 >> 2]), 34708, 23), r = i[f + 80 >> 2];
                                                k: {
                                                    if (r & 16) {
                                                        r = i[f + 76 >> 2], e = i[f + 56 >> 2], r >>> 0 < e >>> 0 && (i[f + 76 >> 2] = e, r = e), e = f + 52 | 0;
                                                        break k;
                                                    }
                                                    if (!(r & 8)) {
                                                        r = 0, o[A + 11 | 0] = 0;
                                                        break r;
                                                    }
                                                    r = i[f + 48 >> 2], e = f + 40 | 0;
                                                }
                                                if (k = i[e >> 2], r = r - k | 0, r >>> 0 >= 2147483640) break f;
                                                if (r >>> 0 >= 11) {
                                                    n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                                    break A;
                                                }
                                                if (o[A + 11 | 0] = r, r) break A;
                                                r = 0;
                                                break r;
                                            }
                                            Y0(), z();
                                        }
                                        Q0(A, k, r);
                                    }
                                    A = A + r | 0;
                                    break i;
                                }
                                A = Q0(A, k, e) + e | 0;
                            }
                            o[A | 0] = 0, A = i[15035], i[f + 28 >> 2] = A, i[i[A - 12 >> 2] + (f + 28 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 75 | 0] < 0 && X(i[f + 64 >> 2]), x0(u), N0(f + 84 | 0), m = f + 176 | 0;
                        }
                        function kv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            t = m - 128 | 0, m = t;
                            i: {
                                if (!f) {
                                    if (o[t + 92 | 0] = 0, o[t + 103 | 0] = 0, e = A, A = i0(t + 40 | 0, 5, 2001, t + 92 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[t + 103 | 0] >= 0) break i;
                                    X(i[t + 92 >> 2]);
                                    break i;
                                }
                                n && (i[n >> 2] = 0), o[t + 97 | 0] = 0, o[t + 98 | 0] = 0, o[t + 99 | 0] = 0, o[t + 100 | 0] = 0, Q[t + 94 >> 1] = 0, Q[t + 96 >> 1] = 0, Q[t + 92 >> 1] = 263, u = 1, o[t + 124 | 0] = 1, o[t + 120 | 0] = 0, i[t + 112 >> 2] = 2, i[t + 116 >> 2] = 2, o[t + 108 | 0] = 1, i[t + 104 >> 2] = 1;
                                e: {
                                    if (!k) break e;
                                    r: {
                                        A: switch(l[k | 0] - 1 | 0){
                                            case 1:
                                                o[t + 94 | 0] = l[k + 2 | 0], o[t + 93 | 0] = l[k + 1 | 0];
                                                break r;
                                            case 0:
                                                o[t + 93 | 0] = l[k + 1 | 0];
                                                break r;
                                            case 6:
                                                o[t + 124 | 0] = l[k + 32 | 0];
                                            case 5:
                                                u = i[k + 20 >> 2], i[t + 108 >> 2] = i[k + 16 >> 2], i[t + 112 >> 2] = u, u = i[k + 28 >> 2], i[t + 116 >> 2] = i[k + 24 >> 2], i[t + 120 >> 2] = u;
                                            case 4:
                                                i[t + 104 >> 2] = i[k + 12 >> 2];
                                            case 3:
                                                u = i[k + 4 >> 2], i[t + 96 >> 2] = u, o[t + 100 | 0] = l[k + 8 | 0], u = !u;
                                                break;
                                            case 2:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        if (o[t + 95 | 0] = l[k + 3 | 0], o[t + 94 | 0] = l[k + 2 | 0], o[t + 93 | 0] = l[k + 1 | 0], !u) break e;
                                    }
                                    if (k = i[e >> 2], u = i[k + 44 >> 2], k = i[k + 48 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), u && (o[t + 40 | 0] = 1, i[t + 96 >> 2] = t + 40, i[t + 44 >> 2] = I[u + 4 >> 1], i[t + 48 >> 2] = I[u + 6 >> 1], i[t + 52 >> 2] = I[u + 8 >> 1], o[t + 56 | 0] = l[u + 10 | 0]), !k || (u = i[k + 4 >> 2], i[k + 4 >> 2] = u - 1, u)) break e;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                ri(t + 12 | 0, i[r >> 2], e, f, t + 92 | 0, 1);
                                e: {
                                    if (i[t + 20 >> 2] != i[21668]) {
                                        j0(A, t + 20 | 0, i[r >> 2]);
                                        break e;
                                    }
                                    i[t + 4 >> 2] = i[t + 12 >> 2], e = i[t + 16 >> 2], i[t + 8 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r >> 2], i[e + 40 >> 2] || V3(e, t + 4 | 0);
                                    r: {
                                        if (!n) break r;
                                        if (e = D(16), i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[n >> 2] = e, f = i[t + 4 >> 2], k = i[t + 8 >> 2], i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, i[e >> 2] = f, i[e + 4 >> 2] = k, k = i[r >> 2], f = i[r + 4 >> 2], !f) {
                                            i[e + 12 >> 2] = f, i[e + 8 >> 2] = k;
                                            break r;
                                        }
                                        if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, i[e + 8 >> 2] = k, r = i[e + 12 >> 2], i[e + 12 >> 2] = f, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    if (r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[t + 8 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (o[t + 39 | 0] < 0 && X(i[t + 28 >> 2]), A = i[t + 16 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = t + 128 | 0;
                        }
                        function Qe(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            if (s = m - 2048 | 0, m = s, w = 5, (e | 0) >= 2) {
                                for(w = 0, k = e; n = w, w = n + 1 | 0, t = k >>> 0 > 3, k = k >>> 1 | 0, !!t;);
                                w = 4 - n | 0;
                            }
                            i: {
                                if ((e | 0) <= 0) break i;
                                for(W = e & 2147483644, B = e & 3, G = e - 1 | 0;;){
                                    v = (u << 1) + f | 0, k = 0, n = e;
                                    e: {
                                        for(;;){
                                            if (_ = k, t = n, (n | 0) <= 0) {
                                                if (n = 0, k = 0, t = 0, G >>> 0 >= 3) for(; Q[(Z(e, k) + u << 1) + s >> 1] = 0, Q[(Z(k | 1, e) + u << 1) + s >> 1] = 0, Q[(Z(k | 2, e) + u << 1) + s >> 1] = 0, Q[(Z(k | 3, e) + u << 1) + s >> 1] = 0, k = k + 4 | 0, t = t + 4 | 0, (W | 0) != (t | 0););
                                                if (!B) break e;
                                                for(; Q[(Z(e, k) + u << 1) + s >> 1] = 0, k = k + 1 | 0, n = n + 1 | 0, (B | 0) != (n | 0););
                                                break e;
                                            }
                                            if (k = _ + 1 | 0, n = t - 1 | 0, !!I[v + (Z(n, e) << 1) >> 1]) break;
                                        }
                                        for(C = t & 2147483646, V = t & 1, n = 0;;){
                                            if (k = 0, t = 0, h = 0, (_ | 0) != (G | 0)) for(; y = Z(Q[v + (Z(e, k) << 1) >> 1], o[((k << w << 5) + n | 0) + 49296 | 0]) + t | 0, t = k | 1, t = y + Z(Q[v + (Z(t, e) << 1) >> 1], o[((t << w << 5) + n | 0) + 49296 | 0]) | 0, k = k + 2 | 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                            if (h = (Z(e, n) + u << 1) + s | 0, V && (t = Z(Q[v + (Z(e, k) << 1) >> 1], o[((k << w << 5) + n | 0) + 49296 | 0]) + t | 0), k = t - -64 >> 7, k = (k | 0) >= 32767 ? 32767 : k, Q[h >> 1] = (k | 0) <= -32768 ? -32768 : k, n = n + 1 | 0, (n | 0) == (e | 0)) break;
                                        }
                                    }
                                    if (u = u + 1 | 0, (u | 0) == (e | 0)) break;
                                }
                                if ((e | 0) <= 0) break i;
                                for(B = e & 2147483646, W = e & 1, u = 0;;){
                                    v = Z(e, u), k = 0, n = e;
                                    e: {
                                        r: {
                                            for(;;){
                                                if (_ = k, f = n, (n | 0) <= 0) break r;
                                                if (k = k + 1 | 0, n = n - 1 | 0, !!I[(v + n << 1) + s >> 1]) break;
                                            }
                                            for(C = f & 2147483646, V = f & 1, y = Z(r, u) + A | 0, n = 0;;){
                                                if (k = 0, t = 0, h = 0, (_ | 0) != (G | 0)) for(; f = k | 1, t = (Z(Q[(k + v << 1) + s >> 1], o[((k << w << 5) + n | 0) + 49296 | 0]) + t | 0) + Z(Q[(f + v << 1) + s >> 1], o[((f << w << 5) + n | 0) + 49296 | 0]) | 0, k = k + 2 | 0, h = h + 2 | 0, (C | 0) != (h | 0););
                                                if (f = n + y | 0, h = l[f | 0], V && (t = Z(Q[(k + v << 1) + s >> 1], o[((k << w << 5) + n | 0) + 49296 | 0]) + t | 0), k = f, f = (t + 2048 >> 12) + h | 0, o[k | 0] = (f | 0) >= 0 ? (f | 0) >= 255 ? 255 : f : 0, n = n + 1 | 0, (n | 0) == (e | 0)) break;
                                            }
                                            break e;
                                        }
                                        if (n = Z(r, u) + A | 0, k = 0, t = 0, G) for(; f = k + n | 0, _ = l[f | 0], o[f | 0] = _ >>> 0 >= 255 ? 255 : _, _ = f, f = l[f + 1 | 0], o[_ + 1 | 0] = f >>> 0 >= 255 ? 255 : f, k = k + 2 | 0, t = t + 2 | 0, (B | 0) != (t | 0););
                                        if (!W) break e;
                                        n = k + n | 0, f = l[n | 0], o[n | 0] = f >>> 0 >= 255 ? 255 : f;
                                    }
                                    if (u = u + 1 | 0, (u | 0) == (e | 0)) break;
                                }
                            }
                            m = s + 2048 | 0;
                        }
                        function nv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f, e = i[r + 24 >> 2], k = i[r + 28 >> 2];
                            i: {
                                e: {
                                    if ((e | 0) != (k | 0)) for(;;){
                                        r: {
                                            if (n = i[e >> 2], !n || (n = E0(n, 73632, 81172), !n)) break r;
                                            if (k = i[e + 4 >> 2], !k) break e;
                                            i[k + 4 >> 2] = i[k + 4 >> 2] + 1;
                                            break i;
                                        }
                                        if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                    }
                                    n = 0;
                                }
                                k = 0;
                            }
                            e = D(72), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80320, t = e + 12 | 0;
                            i: {
                                if (k) {
                                    if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81192, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 68 | 0] = 0, o[e + 52 | 0] = 0, n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n) break i;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    break i;
                                }
                                i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, o[e + 68 | 0] = 0, o[e + 52 | 0] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81192;
                            }
                            i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                            i: {
                                if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                            i: {
                                if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function tv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (e = i[r + 24 >> 2], k = i[r + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                            A: {
                                                if (n = i[e >> 2], !n || (n = E0(n, 73632, 80852), !n)) break A;
                                                if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80160, t = e + 12 | 0, !k) break r;
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 80748, i[k + 4 >> 2] != -1) break e;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break e;
                                            }
                                            if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                        }
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 131, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 80748;
                                }
                                i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                                e: {
                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                                e: {
                                    if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function ov(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (e = i[r + 24 >> 2], k = i[r + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                            A: {
                                                if (n = i[e >> 2], !n || (n = E0(n, 73632, 81996), !n)) break A;
                                                if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80280, t = e + 12 | 0, !k) break r;
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 81864, i[k + 4 >> 2] != -1) break e;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break e;
                                            }
                                            if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                        }
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 131, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 81864;
                                }
                                i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                                e: {
                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                                e: {
                                    if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function uv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (e = i[r + 24 >> 2], k = i[r + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                            A: {
                                                if (n = i[e >> 2], !n || (n = E0(n, 73632, 80516), !n)) break A;
                                                if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80120, t = e + 12 | 0, !k) break r;
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 80592, i[k + 4 >> 2] != -1) break e;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break e;
                                            }
                                            if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                        }
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 106, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 80592;
                                }
                                i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                                e: {
                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                                e: {
                                    if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function lv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (e = i[r + 24 >> 2], k = i[r + 28 >> 2], (e | 0) != (k | 0)) for(;;){
                                            A: {
                                                if (n = i[e >> 2], !n || (n = E0(n, 73632, 82204), !n)) break A;
                                                if (k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(52), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 80200, t = e + 12 | 0, !k) break r;
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, o[e + 24 | 0] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 48 >> 2] = k, i[e + 44 >> 2] = n, i[e + 12 >> 2] = 82224, i[k + 4 >> 2] != -1) break e;
                                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                                break e;
                                            }
                                            if (e = e + 8 | 0, (k | 0) == (e | 0)) break;
                                        }
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, i0(A, 2, 131, f + 16 | 0), o[f + 27 | 0] >= 0) break i;
                                        X(i[f + 16 >> 2]);
                                        break i;
                                    }
                                    i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 32 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 44 >> 2] = n, o[e + 24 | 0] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 12 >> 2] = 82224;
                                }
                                i[r + 372 >> 2] = t, n = i[r + 376 >> 2], i[r + 376 >> 2] = e;
                                e: {
                                    if (!n || (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                o[f + 24 | 0] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, e = i[r + 20 >> 2], i[f + 8 >> 2] = i[e + 48 >> 2], e = i[e + 52 >> 2], i[f + 12 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = i[r + 36 >> 2], n = i[f + 12 >> 2], i[f >> 2] = i[f + 8 >> 2], i[f + 4 >> 2] = n, i6(f + 16 | 0, f, e), r = i[r + 372 >> 2], n = i[f + 20 >> 2], i[f + 20 >> 2] = 0, e = i[f + 16 >> 2], i[f + 16 >> 2] = 0, t = i[f + 36 >> 2], i[f + 36 >> 2] = 0, u = i[f + 32 >> 2], i[f + 32 >> 2] = 0, s = i[f + 28 >> 2], i[f + 28 >> 2] = 0, h = l[f + 24 | 0], w = i[f + 40 >> 2], i[r + 4 >> 2] = e, e = i[r + 8 >> 2], i[r + 8 >> 2] = n;
                                e: {
                                    if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                o[r + 12 | 0] = h, e = i[r + 16 >> 2], e && (i[r + 20 >> 2] = e, X(e)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = t, i[r + 20 >> 2] = u, i[r + 16 >> 2] = s, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[f + 28 >> 2], A && (i[f + 32 >> 2] = A, X(A)), A = i[f + 20 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 48 | 0;
                        }
                        function sv(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            u = m - 16 | 0, m = u, t = i[k >> 2], n = t + i[e >> 2] | 0;
                            i: {
                                if (i[e + 4 >> 2] - n >>> 0 < (f | 0) / 8 << 1 >>> 0) {
                                    if (r = D(48), i[u + 4 >> 2] = r, i[u + 8 >> 2] = 44, i[u + 12 >> 2] = -2147483600, e = l[7100] | l[7101] << 8 | (l[7102] << 16 | l[7103] << 24), f = l[7096] | l[7097] << 8 | (l[7098] << 16 | l[7099] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 44 | 0] = 0, e = l[7136] | l[7137] << 8 | (l[7138] << 16 | l[7139] << 24), o[r + 40 | 0] = e, o[r + 41 | 0] = e >>> 8, o[r + 42 | 0] = e >>> 16, o[r + 43 | 0] = e >>> 24, e = l[7132] | l[7133] << 8 | (l[7134] << 16 | l[7135] << 24), f = l[7128] | l[7129] << 8 | (l[7130] << 16 | l[7131] << 24), o[r + 32 | 0] = f, o[r + 33 | 0] = f >>> 8, o[r + 34 | 0] = f >>> 16, o[r + 35 | 0] = f >>> 24, o[r + 36 | 0] = e, o[r + 37 | 0] = e >>> 8, o[r + 38 | 0] = e >>> 16, o[r + 39 | 0] = e >>> 24, e = l[7124] | l[7125] << 8 | (l[7126] << 16 | l[7127] << 24), f = l[7120] | l[7121] << 8 | (l[7122] << 16 | l[7123] << 24), o[r + 24 | 0] = f, o[r + 25 | 0] = f >>> 8, o[r + 26 | 0] = f >>> 16, o[r + 27 | 0] = f >>> 24, o[r + 28 | 0] = e, o[r + 29 | 0] = e >>> 8, o[r + 30 | 0] = e >>> 16, o[r + 31 | 0] = e >>> 24, e = l[7116] | l[7117] << 8 | (l[7118] << 16 | l[7119] << 24), f = l[7112] | l[7113] << 8 | (l[7114] << 16 | l[7115] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[7108] | l[7109] << 8 | (l[7110] << 16 | l[7111] << 24), f = l[7104] | l[7105] << 8 | (l[7106] << 16 | l[7107] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 136, u + 4 | 0), o[u + 15 | 0] >= 0) break i;
                                    X(i[u + 4 >> 2]);
                                    break i;
                                }
                                s = l[n | 0], h = l[n + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        t = t + 4 | 0, n = l[n + 3 | 0] | (h << 16 | s << 24 | l[n + 2 | 0] << 8);
                                        break e;
                                    }
                                    t = t + 2 | 0, n = (h << 16 | s << 24) >> 16;
                                }
                                i[k >> 2] = t, i[r + 4 >> 2] = n, n = i[k >> 2], e = n + i[e >> 2] | 0, t = l[e | 0], s = l[e + 1 | 0];
                                e: {
                                    if ((f | 0) == 32) {
                                        f = n + 4 | 0, e = l[e + 3 | 0] | (s << 16 | t << 24 | l[e + 2 | 0] << 8);
                                        break e;
                                    }
                                    f = n + 2 | 0, e = (s << 16 | t << 24) >> 16;
                                }
                                if (i[k >> 2] = f, i[r + 8 >> 2] = e, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = u + 16 | 0;
                        }
                        function n5(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            i: {
                                e: {
                                    if (i[A + 64 >> 2]) break e;
                                    f = 2763;
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: {
                                                                            l: {
                                                                                h: {
                                                                                    v: {
                                                                                        _: switch(t = e & -3, t - 1 | 0){
                                                                                            case 4:
                                                                                            case 20:
                                                                                                break o;
                                                                                            case 19:
                                                                                                break s;
                                                                                            case 8:
                                                                                            case 24:
                                                                                                break u;
                                                                                            case 23:
                                                                                                break l;
                                                                                            case 7:
                                                                                                break h;
                                                                                            case 0:
                                                                                            case 16:
                                                                                                break v;
                                                                                            case 15:
                                                                                                break r;
                                                                                            case 1:
                                                                                            case 2:
                                                                                            case 3:
                                                                                            case 5:
                                                                                            case 6:
                                                                                            case 9:
                                                                                            case 10:
                                                                                            case 13:
                                                                                            case 14:
                                                                                            case 17:
                                                                                            case 18:
                                                                                            case 21:
                                                                                            case 22:
                                                                                            case 25:
                                                                                            case 26:
                                                                                                break A;
                                                                                            case 12:
                                                                                            case 28:
                                                                                                break f;
                                                                                            case 27:
                                                                                                break n;
                                                                                            case 11:
                                                                                                break t;
                                                                                            default:
                                                                                                break _;
                                                                                        }
                                                                                        _: switch(t - 48 | 0){
                                                                                            case 4:
                                                                                                break s;
                                                                                            case 0:
                                                                                                break r;
                                                                                            case 1:
                                                                                            case 2:
                                                                                            case 3:
                                                                                                break A;
                                                                                            default:
                                                                                                break _;
                                                                                        }
                                                                                        switch(t - 56 | 0){
                                                                                            case 0:
                                                                                                break w;
                                                                                            case 4:
                                                                                                break k;
                                                                                            default:
                                                                                                break A;
                                                                                        }
                                                                                    }
                                                                                    f = 15755;
                                                                                    break r;
                                                                                }
                                                                                f = 6505;
                                                                                break r;
                                                                            }
                                                                            f = 20131;
                                                                            break r;
                                                                        }
                                                                        f = 20128;
                                                                        break r;
                                                                    }
                                                                    f = 20134;
                                                                    break r;
                                                                }
                                                                f = 15094;
                                                                break r;
                                                            }
                                                            f = 15118;
                                                            break r;
                                                        }
                                                        f = 15097;
                                                        break r;
                                                    }
                                                    f = 15141;
                                                    break r;
                                                }
                                                f = 15137;
                                                break r;
                                            }
                                            f = 15145;
                                            break r;
                                        }
                                        f = 0;
                                    }
                                    if (t = f, !f) break e;
                                    u = m - 16 | 0, m = u;
                                    r: {
                                        A: {
                                            if (!M6(15149, o[f | 0])) {
                                                i[26064] = 28;
                                                break A;
                                            }
                                            if (f = 2, M6(t, 43) || (f = l[t | 0] != 114), f = M6(t, 120) ? f | 128 : f, f = M6(t, 101) ? f | 524288 : f, k = f, s = f | 64, f = l[t | 0], k = (f | 0) == 114 ? k : s, k = (f | 0) == 119 ? k | 512 : k, i[u >> 2] = 438, i[u + 4 >> 2] = 0, k = qs(-100, r | 0, ((f | 0) == 97 ? k | 1024 : k) | 32768, u | 0) | 0, k >>> 0 >= 4294963201 && (i[26064] = 0 - k, k = -1), (k | 0) < 0) break r;
                                            n = m - 32 | 0, m = n;
                                            f: {
                                                k: {
                                                    n: {
                                                        if (!M6(15149, o[t | 0])) {
                                                            i[26064] = 28;
                                                            break n;
                                                        }
                                                        if (f = Q2(1176), f) break k;
                                                    }
                                                    r = 0;
                                                    break f;
                                                }
                                                B0(f, 0, 144), M6(t, 43) || (i[f >> 2] = l[t | 0] == 114 ? 8 : 4);
                                                k: {
                                                    if (l[t | 0] != 97) {
                                                        r = i[f >> 2];
                                                        break k;
                                                    }
                                                    r = l7(k | 0, 3, 0) | 0, r & 1024 || (r = r | 1024, i[n + 16 >> 2] = r, i[n + 20 >> 2] = r >> 31, l7(k | 0, 4, n + 16 | 0)), r = i[f >> 2] | 128, i[f >> 2] = r;
                                                }
                                                i[f + 80 >> 2] = -1, i[f + 48 >> 2] = 1024, i[f + 60 >> 2] = k, i[f + 44 >> 2] = f + 152;
                                                k: {
                                                    if (r & 8 || (i[n >> 2] = n + 24, i[n + 4 >> 2] = 0, Os(k | 0, 21523, n | 0) | 0)) break k;
                                                    i[f + 80 >> 2] = 10;
                                                }
                                                i[f + 40 >> 2] = 1292, i[f + 36 >> 2] = 1291, i[f + 32 >> 2] = 1298, i[f + 12 >> 2] = 1290, l[104273] || (i[f + 76 >> 2] = -1), r = i[26067], i[f + 56 >> 2] = r, r && (i[r + 52 >> 2] = f), i[26067] = f, r = f;
                                            }
                                            if (m = n + 32 | 0, n = r, n) break r;
                                            s7(k | 0);
                                        }
                                        n = 0;
                                    }
                                    if (m = u + 16 | 0, i[A + 64 >> 2] = n, !n) break e;
                                    if (i[A + 88 >> 2] = e, !(e & 2) || !vr(n, 0, 0, 2)) break i;
                                    VA(i[A + 64 >> 2]), i[A + 64 >> 2] = 0;
                                }
                                return 0;
                            }
                            return A;
                        }
                        function t5(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = i[r >> 2];
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        w: {
                                                                            if (!f || (t = i[f >> 2], !t)) break w;
                                                                            if (!A) {
                                                                                f = e;
                                                                                break s;
                                                                            }
                                                                            i[f >> 2] = 0, f = e;
                                                                            break u;
                                                                        }
                                                                        w: {
                                                                            if (!i[i[26106] >> 2]) {
                                                                                if (!A) break w;
                                                                                if (!e) break i;
                                                                                for(t = e;;){
                                                                                    if (f = o[k | 0], f) {
                                                                                        if (i[A >> 2] = f & 57343, A = A + 4 | 0, k = k + 1 | 0, t = t - 1 | 0, t) continue;
                                                                                        break i;
                                                                                    }
                                                                                    break;
                                                                                }
                                                                                return i[A >> 2] = 0, i[r >> 2] = 0, e - t | 0;
                                                                            }
                                                                            if (f = e, !A) break o;
                                                                            break n;
                                                                        }
                                                                        return E2(k);
                                                                    }
                                                                    n = 1;
                                                                    break n;
                                                                }
                                                                n = 0;
                                                                break t;
                                                            }
                                                            n = 1;
                                                        }
                                                        for(;;){
                                                            if (!n) {
                                                                if (n = l[k | 0] >>> 3 | 0, (n - 16 | n + (t >> 26)) >>> 0 > 7) break k;
                                                                n = k + 1 | 0;
                                                                t: {
                                                                    if (!(t & 33554432)) break t;
                                                                    if ((l[n | 0] & 192) != 128) {
                                                                        k = k - 1 | 0;
                                                                        break A;
                                                                    }
                                                                    if (n = k + 2 | 0, !(t & 524288)) break t;
                                                                    if ((l[n | 0] & 192) != 128) {
                                                                        k = k - 1 | 0;
                                                                        break A;
                                                                    }
                                                                    n = k + 3 | 0;
                                                                }
                                                                k = n, f = f - 1 | 0, n = 1;
                                                                continue;
                                                            }
                                                            for(;;){
                                                                t = l[k | 0];
                                                                t: {
                                                                    if (k & 3 | t - 1 >>> 0 > 126 || (t = i[k >> 2], (t | t - 16843009) & -2139062144)) break t;
                                                                    for(; f = f - 4 | 0, t = i[k + 4 >> 2], k = k + 4 | 0, !((t - 16843009 | t) & -2139062144););
                                                                }
                                                                if (n = t & 255, n - 1 >>> 0 <= 126) {
                                                                    f = f - 1 | 0, k = k + 1 | 0;
                                                                    continue;
                                                                }
                                                                break;
                                                            }
                                                            if (n = n - 194 | 0, n >>> 0 > 50) break f;
                                                            k = k + 1 | 0, t = i[(n << 2) + 60816 >> 2], n = 0;
                                                        }
                                                    }
                                                    for(;;){
                                                        if (!n) {
                                                            if (!f) break i;
                                                            for(;;){
                                                                n: {
                                                                    n = l[k | 0], u = n - 1 | 0;
                                                                    t: {
                                                                        o: {
                                                                            if (u >>> 0 > 126) {
                                                                                t = n;
                                                                                break o;
                                                                            }
                                                                            if (k & 3 | f >>> 0 < 5) break t;
                                                                            s: {
                                                                                for(;;){
                                                                                    if (t = i[k >> 2], (t | t - 16843009) & -2139062144) break s;
                                                                                    if (i[A >> 2] = t & 255, i[A + 4 >> 2] = l[k + 1 | 0], i[A + 8 >> 2] = l[k + 2 | 0], i[A + 12 >> 2] = l[k + 3 | 0], A = A + 16 | 0, k = k + 4 | 0, f = f - 4 | 0, !(f >>> 0 > 4)) break;
                                                                                }
                                                                                t = l[k | 0];
                                                                            }
                                                                            n = t & 255, u = n - 1 | 0;
                                                                        }
                                                                        if (u >>> 0 > 126) break n;
                                                                    }
                                                                    if (i[A >> 2] = n, A = A + 4 | 0, k = k + 1 | 0, f = f - 1 | 0, f) continue;
                                                                    break i;
                                                                }
                                                                break;
                                                            }
                                                            if (n = n - 194 | 0, n >>> 0 > 50) break f;
                                                            k = k + 1 | 0, t = i[(n << 2) + 60816 >> 2], n = 1;
                                                            continue;
                                                        }
                                                        if (s = l[k | 0], n = s >>> 3 | 0, (n - 16 | n + (t >> 26)) >>> 0 > 7) break k;
                                                        n: {
                                                            t: {
                                                                u = k + 1 | 0, n = s - 128 | t << 6;
                                                                o: {
                                                                    if ((n | 0) >= 0) break o;
                                                                    if (u = l[u | 0] - 128 | 0, u >>> 0 > 63) break t;
                                                                    if (s = n << 6, n = u | s, u = k + 2 | 0, (s | 0) >= 0) break o;
                                                                    if (u = l[u | 0] - 128 | 0, u >>> 0 > 63) break t;
                                                                    n = u | n << 6, u = k + 3 | 0;
                                                                }
                                                                k = u, i[A >> 2] = n, f = f - 1 | 0, A = A + 4 | 0;
                                                                break n;
                                                            }
                                                            i[26064] = 25, k = k - 1 | 0;
                                                            break r;
                                                        }
                                                        n = 0;
                                                    }
                                                }
                                                if (k = k - 1 | 0, t) break A;
                                                t = l[k | 0];
                                            }
                                            if (t & 255) break A;
                                            return A && (i[A >> 2] = 0, i[r >> 2] = 0), e - f | 0;
                                        }
                                        if (i[26064] = 25, !A) break e;
                                    }
                                    i[r >> 2] = k;
                                }
                                return -1;
                            }
                            return i[r >> 2] = k, e;
                        }
                        function hv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (!e) {
                                    if (o[n | 0] = 0, o[n + 11 | 0] = 0, e = A, A = i0(n + 12 | 0, 5, 2001, n), r = i[r >> 2], j0(e, A, r ? r + 4 | 0 : 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[n + 11 | 0] >= 0) break i;
                                    X(i[n >> 2]);
                                    break i;
                                }
                                if (i[e >> 2] = 0, f = i[r >> 2], t = o[f + 167 | 0], k = (t | 0) < 0, t = Q2((k ? i[f + 160 >> 2] : t) + 1 | 0), !t) {
                                    if (e = D(48), i[n >> 2] = e, i[n + 4 >> 2] = 45, i[n + 8 >> 2] = -2147483600, f = l[9193] | l[9194] << 8 | (l[9195] << 16 | l[9196] << 24), k = l[9189] | l[9190] << 8 | (l[9191] << 16 | l[9192] << 24), o[e + 37 | 0] = k, o[e + 38 | 0] = k >>> 8, o[e + 39 | 0] = k >>> 16, o[e + 40 | 0] = k >>> 24, o[e + 41 | 0] = f, o[e + 42 | 0] = f >>> 8, o[e + 43 | 0] = f >>> 16, o[e + 44 | 0] = f >>> 24, f = l[9188] | l[9189] << 8 | (l[9190] << 16 | l[9191] << 24), k = l[9184] | l[9185] << 8 | (l[9186] << 16 | l[9187] << 24), o[e + 32 | 0] = k, o[e + 33 | 0] = k >>> 8, o[e + 34 | 0] = k >>> 16, o[e + 35 | 0] = k >>> 24, o[e + 36 | 0] = f, o[e + 37 | 0] = f >>> 8, o[e + 38 | 0] = f >>> 16, o[e + 39 | 0] = f >>> 24, f = l[9180] | l[9181] << 8 | (l[9182] << 16 | l[9183] << 24), k = l[9176] | l[9177] << 8 | (l[9178] << 16 | l[9179] << 24), o[e + 24 | 0] = k, o[e + 25 | 0] = k >>> 8, o[e + 26 | 0] = k >>> 16, o[e + 27 | 0] = k >>> 24, o[e + 28 | 0] = f, o[e + 29 | 0] = f >>> 8, o[e + 30 | 0] = f >>> 16, o[e + 31 | 0] = f >>> 24, f = l[9172] | l[9173] << 8 | (l[9174] << 16 | l[9175] << 24), k = l[9168] | l[9169] << 8 | (l[9170] << 16 | l[9171] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[9164] | l[9165] << 8 | (l[9166] << 16 | l[9167] << 24), k = l[9160] | l[9161] << 8 | (l[9162] << 16 | l[9163] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[9156] | l[9157] << 8 | (l[9158] << 16 | l[9159] << 24), k = l[9152] | l[9153] << 8 | (l[9154] << 16 | l[9155] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 45 | 0] = 0, e = A, A = i0(n + 12 | 0, 6, 0, n), r = i[r >> 2], j0(e, A, r ? r + 4 | 0 : 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[n + 11 | 0] >= 0) break i;
                                    X(i[n >> 2]);
                                    break i;
                                }
                                u = e, s = p6(t, k ? i[f + 156 >> 2] : f + 156 | 0), i[u >> 2] = s, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                            }
                            m = n + 32 | 0;
                        }
                        function o5(A, r, e, f, k, n, t, u, s, h, w, v, _) {
                            var B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0;
                            G = m, M = G, G = G - 19808 & -32, m = G, B = f, f = i[r + 16856 >> 2], C = Z(B, 2 / (f | 0) | 0), n = ((n | 0) / (f | 0) | 0) + (C >> 3) | 0, W = i[r + 16852 >> 2], B = Z(2 / (W | 0) | 0, e), e = ((k | 0) / (W | 0) | 0) + (B >> 3) | 0, k = i[r + 488 >> 2] / (f | 0) | 0, f = i[r + 484 >> 2] / (W | 0) | 0;
                            i: {
                                W = B & 7, B = C & 7;
                                e: {
                                    if (!(W | B)) {
                                        if (r = i[r + 16840 >> 2], !((e | 0) < 0 | (f | 0) < (e + w | 0) | ((n | 0) < 0 | (k | 0) < (n + v | 0)))) {
                                            if (r = ((e << 1) + s | 0) + (Z(n, h) << 1) | 0, (_ | 0) <= 8) {
                                                p[i[A + 204 >> 2]](t, u, r, h, w, v, 0, 0, 0), m = M;
                                                return;
                                            }
                                            p[i[A + 284 >> 2]](t, u, r, h, w, v, 0, 0, 0, _), m = M;
                                            return;
                                        }
                                        if ((v | 0) <= 0 | (w | 0) <= 0) break e;
                                        for(_ = 14 - r | 0, F = k - 1 | 0, G = f - 1 | 0, E = w & 2147483646, R = w & 1, A = 0;;){
                                            if (r = A + n | 0, W = (Z((r | 0) >= 0 ? (r | 0) < (k | 0) ? r : F : 0, h) << 1) + s | 0, C = (Z(A, u) << 1) + t | 0, r = 0, y = 0, (w | 0) != 1) for(; B = r + e | 0, Q[C + (r << 1) >> 1] = I[W + (((B | 0) >= 0 ? (f | 0) > (B | 0) ? B : G : 0) << 1) >> 1] << _, V = r | 1, B = V + e | 0, Q[C + (V << 1) >> 1] = I[W + (((B | 0) >= 0 ? (f | 0) > (B | 0) ? B : G : 0) << 1) >> 1] << _, r = r + 2 | 0, y = y + 2 | 0, (E | 0) != (y | 0););
                                            if (R && (B = C + (r << 1) | 0, r = r + e | 0, Q[B >> 1] = I[W + (((r | 0) >= 0 ? (r | 0) < (f | 0) ? r : G : 0) << 1) >> 1] << _), A = A + 1 | 0, (v | 0) == (A | 0)) break;
                                        }
                                        break e;
                                    }
                                    r: {
                                        if (!((e | 0) <= 0 | (e + w | 0) > (f - 2 | 0) | ((n | 0) <= 0 | (n + v | 0) > (k - 2 | 0)))) {
                                            r = ((e << 1) + s | 0) + (Z(n, h) << 1) | 0;
                                            break r;
                                        }
                                        if (!((v | 0) < -2 | (w | 0) < -2)) for(C = -1, T = k - 1 | 0, y = f - 1 | 0, r = v + 2 | 0, S = (r | 0) > 0 ? r : 0, r = w + 3 | 0, P = r & -2, $ = r & 1;;){
                                            if (r = n + C | 0, F = (Z((r | 0) >= 0 ? (r | 0) < (k | 0) ? r : T : 0, h) << 1) + s | 0, E = Z(C, 80) + 80 | 0, r = -1, R = 0, (w | 0) != -2) for(; H = r + 1 | 0, V = r + e | 0, Q[G + (E + H << 1) >> 1] = I[F + (((V | 0) >= 0 ? (f | 0) > (V | 0) ? V : y : 0) << 1) >> 1], r = r + 2 | 0, V = e + H | 0, Q[G + (E + r << 1) >> 1] = I[F + (((V | 0) >= 0 ? (f | 0) > (V | 0) ? V : y : 0) << 1) >> 1], R = R + 2 | 0, (P | 0) != (R | 0););
                                            if ($ && (V = G + (r + E << 1) | 0, r = r + e | 0, Q[V + 2 >> 1] = I[F + (((r | 0) >= 0 ? (r | 0) < (f | 0) ? r : y : 0) << 1) >> 1]), C = C + 1 | 0, (S | 0) == (C | 0)) break;
                                        }
                                        h = 80, r = G + 162 | 0;
                                    }
                                    f = (((_ | 0) < 9 ? 44 : 124) + A | 0) + 172 | 0;
                                    r: {
                                        if (!(!W | !B) || (e = (_ | 0) < 9, f = ((e ? 36 : 116) + A | 0) + 172 | 0, W)) break r;
                                        if (!B) break i;
                                        W = 0, f = ((e ? 40 : 120) + A | 0) + 172 | 0;
                                    }
                                    e = f, p[i[e >> 2]](t, u, r, h, w, v, W, B, G + 10720 | 0, _);
                                }
                                m = M;
                                return;
                            }
                            y0(10076, 14978, 269, 15647), z();
                        }
                        function wv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            k = m + -64 | 0, m = k, Go(i[r >> 2]), i[e >> 2] = 0, f = i[21480], n = i[21479];
                            i: {
                                e: {
                                    for(;;){
                                        r: {
                                            if (i[k + 44 >> 2] = 0, _7(i[r >> 2], k + 44 | 0)) break r;
                                            if (u = rt(i[r >> 2]), u) {
                                                if (f = i[e >> 2], f && p4(f), f = i[u + 20 >> 2], G = f, C3(k + 52 | 0, i[i[11665] + u >> 2], i[i[11668] + u >> 2], !f << 1, f, e), f = i[k + 52 >> 2], f) {
                                                    t = i[k + 60 >> 2], s = i[k + 56 >> 2];
                                                    break e;
                                                }
                                                for(n = 0, v = i[i[u + 124 >> 2] + i[11671] >> 2], W = (v + 7 | 0) / 8 | 0;;){
                                                    if (n >>> 0 <= 2 ? f = i[i[u + 124 >> 2] + i[(n << 2) + 46684 >> 2] >> 2] : f = 0, (f | 0) != (v | 0)) {
                                                        p4(i[e >> 2]), t = 13140, f = 4, s = 3003;
                                                        break e;
                                                    }
                                                    t = 46644, _ = a9(u, n, k + 48 | 0), s = 129, f = 7;
                                                    A: {
                                                        if (h = n >>> 0 <= 2 ? i[i[(n << 2) + 46660 >> 2] + u >> 2] : 0, w = n >>> 0 <= 2 ? i[i[(n << 2) + 46672 >> 2] + u >> 2] : 0, !((h | 0) <= 0 | (w | 0) <= 0)) {
                                                            if (s = i[(n << 2) + 46648 >> 2], WA(k + 52 | 0, i[e >> 2], s, h, w, v), f = i[k + 52 >> 2], !f) break A;
                                                            s = i[k + 56 >> 2], t = i[k + 60 >> 2];
                                                        }
                                                        p4(i[e >> 2]);
                                                        break e;
                                                    }
                                                    if (t = Z(h, W), f = 0, h = Ci(i[e >> 2], s, k + 52 | 0), (w | 0) != 1) for(C = w & 2147483646, s = 0; v0(h + Z(i[k + 52 >> 2], f) | 0, Z(i[k + 48 >> 2], f) + _ | 0, t), B = f | 1, v0(h + Z(B, i[k + 52 >> 2]) | 0, Z(i[k + 48 >> 2], B) + _ | 0, t), f = f + 2 | 0, s = s + 2 | 0, (C | 0) != (s | 0););
                                                    if (w & 1 && v0(h + Z(i[k + 52 >> 2], f) | 0, Z(i[k + 48 >> 2], f) + _ | 0, t), !(G && (f = n >>> 0 < 2, n = n + 1 | 0, f))) break;
                                                }
                                                if (f = ct(), fA(A, f, l[i[u + 124 >> 2] + 9018 | 0]), i[A >> 2]) {
                                                    if (l[r + 4 | 0] == 1) {
                                                        X(f), p4(i[e >> 2]), i[e >> 2] = 0;
                                                        break i;
                                                    }
                                                    t = i[e >> 2], i[k + 40 >> 2] = i[A + 8 >> 2], n = i[A + 4 >> 2], i[k + 32 >> 2] = i[A >> 2], i[k + 36 >> 2] = n, Le(t, k + 32 | 0);
                                                }
                                                if (kA(A, f, l[i[u + 124 >> 2] + 9019 | 0]), i[A >> 2]) {
                                                    if (l[r + 4 | 0] == 1) {
                                                        X(f), p4(i[e >> 2]), i[e >> 2] = 0;
                                                        break i;
                                                    }
                                                    t = i[e >> 2], i[k + 24 >> 2] = i[A + 8 >> 2], n = i[A + 4 >> 2], i[k + 16 >> 2] = i[A >> 2], i[k + 20 >> 2] = n, Le(t, k + 16 | 0);
                                                }
                                                if (rA(A, f, l[i[u + 124 >> 2] + 9020 | 0]), i[A >> 2]) {
                                                    if (l[r + 4 | 0] == 1) {
                                                        X(f), p4(i[e >> 2]), i[e >> 2] = 0;
                                                        break i;
                                                    }
                                                    t = i[e >> 2], i[k + 8 >> 2] = i[A + 8 >> 2], n = i[A + 4 >> 2], i[k >> 2] = i[A >> 2], i[k + 4 >> 2] = n, Le(t, k);
                                                }
                                                n = 0, o[f + 16 | 0] = l[i[u + 124 >> 2] + 9016 | 0] != 0, Xn(k + 52 | 0, i[e >> 2], f), X(f), Ft(i[r >> 2]), f = 46636;
                                            }
                                            if (i[k + 44 >> 2]) continue;
                                        }
                                        break;
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = n, i[A + 8 >> 2] = f;
                                    break i;
                                }
                                i[A >> 2] = f, i[A + 4 >> 2] = s, i[A + 8 >> 2] = t;
                            }
                            m = k - -64 | 0;
                        }
                        function u5(A, r, e, f, k, n, t, u, s, h, w, v, _, B, G) {
                            var W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            for(F = m - 16 | 0, m = F, i[e >> 2] = A, M = u ? 4 : 0, H = f & 512;;){
                                if ((E | 0) == 4) l[B + 11 | 0] >>> 7 | 0 ? k = i[B + 4 >> 2] : k = l[B + 11 | 0] & 127, k >>> 0 > 1 && (S = F, P = Q4(B), i[S + 12 >> 2] = P, S = e, P = w9(xA(F + 12 | 0, 1), M8(B), i[e >> 2]), i[S >> 2] = P), f = f & 176, (f | 0) != 16 && ((f | 0) == 32 && (A = i[e >> 2]), i[r >> 2] = A), m = F + 16 | 0;
                                else {
                                    i: {
                                        e: switch(l[s + E | 0]){
                                            case 0:
                                                i[r >> 2] = i[e >> 2];
                                                break i;
                                            case 1:
                                                i[r >> 2] = i[e >> 2], u = p[i[i[t >> 2] + 44 >> 2]](t, 32) | 0, W = i[e >> 2], i[e >> 2] = W + 4, i[W >> 2] = u;
                                                break i;
                                            case 3:
                                                if (l[B + 11 | 0] >>> 7 | 0 ? u = i[B + 4 >> 2] : u = l[B + 11 | 0] & 127, !u) break i;
                                                l[B + 11 | 0] >>> 7 | 0 ? u = i[B >> 2] : u = B, u = i[u >> 2], W = i[e >> 2], i[e >> 2] = W + 4, i[W >> 2] = u;
                                                break i;
                                            case 2:
                                                if (W = !H, l[_ + 11 | 0] >>> 7 | 0 ? u = i[_ + 4 >> 2] : u = l[_ + 11 | 0] & 127, W | !u) break i;
                                                S = e, P = w9(Q4(_), M8(_), i[e >> 2]), i[S >> 2] = P;
                                                break i;
                                            case 4:
                                                break e;
                                            default:
                                                break i;
                                        }
                                        for(T = i[e >> 2], k = k + M | 0, u = k;;){
                                            e: {
                                                if (n >>> 0 <= u >>> 0 || !(p[i[i[t >> 2] + 12 >> 2]](t, 64, i[u >> 2]) | 0)) break e;
                                                u = u + 4 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        if ((G | 0) > 0) {
                                            for(W = i[e >> 2], C = G;;){
                                                if (!(!C | k >>> 0 >= u >>> 0)) {
                                                    C = C - 1 | 0, u = u - 4 | 0, y = i[u >> 2], V = W + 4 | 0, i[e >> 2] = V, i[W >> 2] = y, W = V;
                                                    continue;
                                                }
                                                break;
                                            }
                                            e: {
                                                if (!C) {
                                                    V = 0;
                                                    break e;
                                                }
                                                V = p[i[i[t >> 2] + 44 >> 2]](t, 48) | 0, W = i[e >> 2];
                                            }
                                            for(;;){
                                                if (y = W + 4 | 0, (C | 0) > 0) {
                                                    i[W >> 2] = V, C = C - 1 | 0, W = y;
                                                    continue;
                                                }
                                                break;
                                            }
                                            i[e >> 2] = y, i[W >> 2] = h;
                                        }
                                        e: {
                                            if ((k | 0) == (u | 0)) {
                                                W = p[i[i[t >> 2] + 44 >> 2]](t, 48) | 0, C = i[e >> 2], u = C + 4 | 0, i[e >> 2] = u, i[C >> 2] = W;
                                                break e;
                                            }
                                            for(l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, V = o[W | 0], l[v + 11 | 0] >>> 7 | 0 ? W = i[v + 4 >> 2] : W = l[v + 11 | 0] & 127, V = W ? V : -1, W = 0, y = 0;;){
                                                if ((k | 0) != (u | 0)) {
                                                    r: {
                                                        if ((W | 0) != (V | 0)) {
                                                            C = W;
                                                            break r;
                                                        }
                                                        if (C = i[e >> 2], i[e >> 2] = C + 4, i[C >> 2] = w, C = 0, l[v + 11 | 0] >>> 7 | 0 ? V = i[v + 4 >> 2] : V = l[v + 11 | 0] & 127, y = y + 1 | 0, V >>> 0 <= y >>> 0) {
                                                            V = W;
                                                            break r;
                                                        }
                                                        if (l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, l[W + y | 0] == 127) {
                                                            V = -1;
                                                            break r;
                                                        }
                                                        l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, V = o[W + y | 0];
                                                    }
                                                    u = u - 4 | 0, W = i[u >> 2], R = i[e >> 2], i[e >> 2] = R + 4, i[R >> 2] = W, W = C + 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            u = i[e >> 2];
                                        }
                                        ir(T, u);
                                    }
                                    E = E + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                        }
                        function vv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            r = m - 96 | 0, m = r, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, i[r + 80 >> 2] = 0, i[r + 84 >> 2] = 0, i[r + 72 >> 2] = 0, i[r + 76 >> 2] = 0, i[r + 64 >> 2] = 0, i[r + 68 >> 2] = 0, k = i[e >> 2], e = i[e + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[r + 60 >> 2] = e, i[r + 56 >> 2] = k, p[i[i[f >> 2] + 100 >> 2]](r + 44 | 0, i[f + 4 >> 2], r + 56 | 0, n);
                            i: {
                                k = i[r + 44 >> 2];
                                e: {
                                    if (k) {
                                        if (f = i[r + 48 >> 2], t = i[r + 52 >> 2], e = E2(t), e >>> 0 >= 2147483640) break i;
                                        r: {
                                            A: {
                                                if (e >>> 0 >= 11) {
                                                    u = (e | 7) + 1 | 0, n = D(u), i[r + 20 >> 2] = u | -2147483648, i[r + 12 >> 2] = n, i[r + 16 >> 2] = e;
                                                    break A;
                                                }
                                                if (o[r + 23 | 0] = e, n = r + 12 | 0, !e) break r;
                                            }
                                            Q0(n, t, e);
                                        }
                                        o[e + n | 0] = 0, e = i0(r + 24 | 0, k, f, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                                        r: {
                                            if (o[e + 19 | 0] >= 0) {
                                                f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break r;
                                            X(i[e + 8 >> 2]);
                                        }
                                        if (o[r + 23 | 0] >= 0) break e;
                                        X(i[r + 12 >> 2]);
                                        break e;
                                    }
                                    for(i[r + 32 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, p[i[i[f >> 2] + 104 >> 2]](r + 12 | 0, i[f + 4 >> 2], r + 8 | 0, r + 4 | 0, 0);;){
                                        if (u = i[r + 8 >> 2], u) {
                                            n = i[r + 4 >> 2], e = i[r + 24 >> 2], k = i[r + 28 >> 2] - e | 0, t = n + k | 0;
                                            r: {
                                                if (k >>> 0 < t >>> 0) {
                                                    r1(r + 24 | 0, n), n = i[r + 4 >> 2], u = i[r + 8 >> 2], e = i[r + 24 >> 2];
                                                    break r;
                                                }
                                                if (k >>> 0 <= t >>> 0) break r;
                                                i[r + 28 >> 2] = e + t;
                                            }
                                            v0(e + k | 0, u, n), p[i[i[f >> 2] + 104 >> 2]](r + 12 | 0, i[f + 4 >> 2], r + 8 | 0, r + 4 | 0, 0);
                                            continue;
                                        }
                                        break;
                                    }
                                    if (e = i[r + 32 >> 2], i[r + 32 >> 2] = 0, i[r + 84 >> 2] = e, e = i[r + 28 >> 2], i[r + 76 >> 2] = i[r + 24 >> 2], i[r + 80 >> 2] = e, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, G6(A, r - -64 | 0), A = i[r + 24 >> 2], !A) break e;
                                    i[r + 28 >> 2] = A, X(A);
                                }
                                A = i[r + 60 >> 2];
                                e: {
                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[r + 76 >> 2], A && (i[r + 80 >> 2] = A, X(A)), A = i[r + 64 >> 2], A) {
                                    if (e = i[r + 68 >> 2], n = A, (e | 0) != (A | 0)) {
                                        for(;;){
                                            f = i[e - 4 >> 2];
                                            e: {
                                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break e;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            if (e = e - 8 | 0, (A | 0) == (e | 0)) break;
                                        }
                                        n = i[r + 64 >> 2];
                                    }
                                    i[r + 68 >> 2] = A, X(n);
                                }
                                m = r + 96 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function l5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                e: switch(b0(r - 8 | 0, 29) | 0){
                                    case 0:
                                        if (!o4(A, 1)) break i;
                                        r = i[A >> 2], e = i[A + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1);
                                        r: {
                                            if (!(p[i[i[r >> 2] + 16 >> 2]](r, n + 6 | 0, 1) | 0)) {
                                                D4(A), f = 0;
                                                break r;
                                            }
                                            f = l[n + 6 | 0];
                                        }
                                        if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        break i;
                                    case 1:
                                        if (!o4(A, 2)) break i;
                                        r = i[A >> 2], e = i[A + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1);
                                        r: {
                                            if (!(p[i[i[r >> 2] + 16 >> 2]](r, n + 7 | 0, 2) | 0)) {
                                                D4(A), f = 0;
                                                break r;
                                            }
                                            A = l[n + 7 | 0], t = A >>> 24 | 0, f = l[n + 8 | 0] | A << 8;
                                        }
                                        if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        break i;
                                    case 2:
                                        if (!o4(A, 3)) break i;
                                        r = i[A >> 2], k = i[A + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                        r: {
                                            if (!(p[i[i[r >> 2] + 16 >> 2]](r, n + 9 | 0, 3) | 0)) {
                                                D4(A), A = 0, t = 0;
                                                break r;
                                            }
                                            A = l[n + 10 | 0], r = A >>> 24 | 0, t = A << 8, f = r, A = l[n + 9 | 0], r = A >>> 16 | 0, A = l[n + 11 | 0] | (A << 16 | t), t = r | f;
                                        }
                                        if (f = A, !k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        break i;
                                    case 3:
                                        if (!o4(A, 4)) break i;
                                        r = i[A >> 2], k = i[A + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                        r: {
                                            if (!(p[i[i[r >> 2] + 16 >> 2]](r, n + 12 | 0, 4) | 0)) {
                                                D4(A), t = 0;
                                                break r;
                                            }
                                            A = l[n + 13 | 0], r = A >>> 16 | 0, t = A << 16, f = r, A = l[n + 12 | 0], r = A >>> 8 | 0, t = A << 24 | t, r = r | f, f = t, A = l[n + 14 | 0], t = A >>> 24 | 0, f = l[n + 15 | 0] | (f | A << 8), t = r | t;
                                        }
                                        if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                        p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                        break i;
                                    case 7:
                                        break e;
                                    default:
                                        break i;
                                }
                                e = m - 16 | 0, m = e;
                                e: {
                                    if (!o4(A, 8)) break e;
                                    r = i[A >> 2], u = i[A + 4 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1);
                                    r: {
                                        if (!(p[i[i[r >> 2] + 16 >> 2]](r, e + 8 | 0, 8) | 0)) {
                                            D4(A), f = 0;
                                            break r;
                                        }
                                        A = 0, f = l[e + 8 | 0] | l[e + 9 | 0] << 8 | (l[e + 10 | 0] << 16 | l[e + 11 | 0] << 24), k = f << 24 | (f & 65280) << 8, r = f & 16711680, t = r >>> 8 | 0, s = A, A = f & -16777216, r = s | (r << 24 | A << 8), t = k | (A >>> 24 | t), A = l[e + 12 | 0] | l[e + 13 | 0] << 8 | (l[e + 14 | 0] << 16 | l[e + 15 | 0] << 24), f = ((A & 255) << 24 | f >>> 8) & -16777216 | ((A & 16777215) << 8 | f >>> 24) & 16711680 | (A >>> 8 & 65280 | A >>> 24) | r;
                                    }
                                    if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                }
                                m = e + 16 | 0;
                            }
                            return m = n + 16 | 0, w0 = t, f;
                        }
                        function Ce(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            if (!A) return Q2(r);
                            if (r >>> 0 >= 4294967232) return i[26064] = 48, 0;
                            n = r >>> 0 < 11 ? 16 : r + 11 & -8, s = A - 8 | 0, h = i[s + 4 >> 2], k = h & -8;
                            i: {
                                if (!(h & 3)) {
                                    if (n >>> 0 < 256 || k >>> 0 >= n + 4 >>> 0 && (e = s, k - n >>> 0 <= i[26498] << 1 >>> 0)) break i;
                                    e = 0;
                                    break i;
                                }
                                t = k + s | 0;
                                e: {
                                    if (k >>> 0 >= n >>> 0) {
                                        if (f = k - n | 0, f >>> 0 < 16) break e;
                                        i[s + 4 >> 2] = h & 1 | n | 2, e = n + s | 0, i[e + 4 >> 2] = f | 3, i[t + 4 >> 2] = i[t + 4 >> 2] | 1, Be(e, f);
                                        break e;
                                    }
                                    if (i[26384] == (t | 0)) {
                                        if (k = k + i[26381] | 0, k >>> 0 <= n >>> 0) break i;
                                        i[s + 4 >> 2] = h & 1 | n | 2, f = n + s | 0, e = k - n | 0, i[f + 4 >> 2] = e | 1, i[26381] = e, i[26384] = f;
                                        break e;
                                    }
                                    if (i[26383] == (t | 0)) {
                                        if (k = k + i[26380] | 0, k >>> 0 < n >>> 0) break i;
                                        e = k - n | 0;
                                        r: {
                                            if (e >>> 0 >= 16) {
                                                i[s + 4 >> 2] = h & 1 | n | 2, f = n + s | 0, i[f + 4 >> 2] = e | 1, k = k + s | 0, i[k >> 2] = e, i[k + 4 >> 2] = i[k + 4 >> 2] & -2;
                                                break r;
                                            }
                                            i[s + 4 >> 2] = k | h & 1 | 2, e = k + s | 0, i[e + 4 >> 2] = i[e + 4 >> 2] | 1, e = 0;
                                        }
                                        i[26383] = f, i[26380] = e;
                                        break e;
                                    }
                                    if (f = i[t + 4 >> 2], f & 2 || (w = k + (f & -8) | 0, w >>> 0 < n >>> 0)) break i;
                                    _ = w - n | 0, u = i[t + 12 >> 2];
                                    r: {
                                        if (f >>> 0 <= 255) {
                                            if (e = i[t + 8 >> 2], (e | 0) == (u | 0)) {
                                                B = 105512, G = i[26378] & b0(-2, f >>> 3 | 0), i[B >> 2] = G;
                                                break r;
                                            }
                                            i[e + 12 >> 2] = u, i[u + 8 >> 2] = e;
                                            break r;
                                        }
                                        v = i[t + 24 >> 2];
                                        A: {
                                            if ((t | 0) != (u | 0)) {
                                                e = i[t + 8 >> 2], i[e + 12 >> 2] = u, i[u + 8 >> 2] = e;
                                                break A;
                                            }
                                            f: {
                                                if (e = i[t + 20 >> 2], e) f = t + 20 | 0;
                                                else {
                                                    if (e = i[t + 16 >> 2], !e) break f;
                                                    f = t + 16 | 0;
                                                }
                                                for(; k = f, u = e, f = e + 20 | 0, e = i[e + 20 >> 2], !(!e && (f = u + 16 | 0, e = i[u + 16 >> 2], !e)););
                                                i[k >> 2] = 0;
                                                break A;
                                            }
                                            u = 0;
                                        }
                                        if (!v) break r;
                                        f = i[t + 28 >> 2], e = (f << 2) + 105816 | 0;
                                        A: {
                                            if (i[e >> 2] == (t | 0)) {
                                                if (i[e >> 2] = u, u) break A;
                                                B = 105516, G = i[26379] & b0(-2, f), i[B >> 2] = G;
                                                break r;
                                            }
                                            if (i[(i[v + 16 >> 2] == (t | 0) ? 16 : 20) + v >> 2] = u, !u) break r;
                                        }
                                        if (i[u + 24 >> 2] = v, e = i[t + 16 >> 2], e && (i[u + 16 >> 2] = e, i[e + 24 >> 2] = u), e = i[t + 20 >> 2], !e) break r;
                                        i[u + 20 >> 2] = e, i[e + 24 >> 2] = u;
                                    }
                                    if (_ >>> 0 <= 15) {
                                        i[s + 4 >> 2] = h & 1 | w | 2, e = s + w | 0, i[e + 4 >> 2] = i[e + 4 >> 2] | 1;
                                        break e;
                                    }
                                    i[s + 4 >> 2] = h & 1 | n | 2, f = n + s | 0, i[f + 4 >> 2] = _ | 3, e = s + w | 0, i[e + 4 >> 2] = i[e + 4 >> 2] | 1, Be(f, _);
                                }
                                e = s;
                            }
                            return e ? e + 8 | 0 : (f = Q2(r), f ? (e = i[A - 4 >> 2], e = (e & 3 ? -4 : -8) + (e & -8) | 0, v0(f, A, r >>> 0 > e >>> 0 ? e : r), X(A), f) : 0);
                        }
                        function _v(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            f = i[i[A >> 2] + 36 >> 2], r = m - 128 | 0, m = r, k = i[A + 8 >> 2], e = i[k + 20 >> 2];
                            i: {
                                if (!e) break i;
                                for(u = k + 20 | 0, A = u; n = f >>> 0 > k0[e + 16 >> 2], A = n ? A : e, e = i[(n << 2) + e >> 2], !!e;);
                                if ((A | 0) == (u | 0) | f >>> 0 < k0[A + 16 >> 2]) break i;
                                e = i[A + 20 >> 2], n = i[A + 24 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), t = 1;
                                e: {
                                    if (i[e + 68 >> 2] || p[i[i[e >> 2] + 56 >> 2]](e) | 0) break e;
                                    p[i[i[e >> 2] + 48 >> 2]](r + 96 | 0, e, r + 124 | 0, r + 120 | 0), t = 0;
                                    r: {
                                        if (i[r + 96 >> 2] || (A = i[r + 120 >> 2], A >>> 0 <= 15 && (t = 1, 1 << A & 43008)) || (t = 0, (V6(i[k + 48 >> 2], f) | 0) != 1735551332)) break r;
                                        i[r + 92 >> 2] = 0, i[r + 84 >> 2] = 0, i[r + 88 >> 2] = 0, A = r + 84 | 0, ui(r - -64 | 0, i[k + 48 >> 2], f, A);
                                        A: {
                                            if (i[r + 64 >> 2] || (i[r + 56 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, K7(r + 24 | 0, r + 48 | 0, A), e = i[r + 28 >> 2], A = i[r + 24 >> 2], i[r + 96 >> 2] = A, i[r + 100 >> 2] = e, o[r + 115 | 0] < 0 && (X(i[r + 104 >> 2]), A = i[r + 96 >> 2]), e = i[r + 36 >> 2], i[r + 104 >> 2] = i[r + 32 >> 2], i[r + 108 >> 2] = e, i[r + 112 >> 2] = i[r + 40 >> 2], A)) break A;
                                            A = i[k + 48 >> 2], e = i[A + 84 >> 2], i[r + 16 >> 2] = e, A = i[A + 88 >> 2], i[r + 20 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1);
                                            f: {
                                                if (!e) break f;
                                                Q8(r + 24 | 0, e, f, 1684630887), s = i[r + 28 >> 2], f = i[r + 24 >> 2];
                                                k: {
                                                    if ((Z(I[r + 50 >> 1], I[r + 48 >> 1]) | 0) != s - f >> 2 || (e = (f | 0) == (s | 0), e)) break k;
                                                    for(A = f;;){
                                                        if (!L9(k, i[A >> 2])) break k;
                                                        if (A = A + 4 | 0, (s | 0) == (A | 0)) break;
                                                    }
                                                    if (e) break k;
                                                    for(;;){
                                                        n: {
                                                            if (A = i[u >> 2], !A) {
                                                                t = 0;
                                                                break n;
                                                            }
                                                            for(k = i[f >> 2], e = u; h = k >>> 0 > k0[A + 16 >> 2], e = h ? e : A, A = i[(h << 2) + A >> 2], !!A;);
                                                            if ((e | 0) == (u | 0)) {
                                                                t = 0;
                                                                break n;
                                                            }
                                                            if (k >>> 0 < k0[e + 16 >> 2]) {
                                                                t = 0;
                                                                break n;
                                                            }
                                                            if (k = i[e + 20 >> 2], i[r + 8 >> 2] = k, A = i[e + 24 >> 2], i[r + 12 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), t = i[k + 68 >> 2] != 0 | t, B1(r + 8 | 0), f = f + 4 | 0, (s | 0) != (f | 0)) continue;
                                                        }
                                                        break;
                                                    }
                                                    f = i[r + 24 >> 2];
                                                }
                                                if (!f) break f;
                                                i[r + 28 >> 2] = f, X(f);
                                            }
                                            B1(r + 16 | 0);
                                        }
                                        if (o[r + 83 | 0] < 0 && X(i[r + 72 >> 2]), A = i[r + 84 >> 2], !A) break r;
                                        i[r + 88 >> 2] = A, X(A);
                                    }
                                    if (o[r + 115 | 0] >= 0) break e;
                                    X(i[r + 104 >> 2]);
                                }
                                if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            return m = r + 128 | 0, t & 1;
                        }
                        function Bv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), t = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(I4(U(I4(U(k, 22893, 17), n0[r + 112 >> 3]), 25144, 2), n0[r + 120 >> 3]), 34895, 1);
                            i: {
                                if (l[r + 128 | 0] == 1) {
                                    n = f + 148 | 0, G0(n, e), t = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(I4(U(I4(U(k, 23898, 14), n0[r + 104 >> 3]), 25144, 2), n0[r + 136 >> 3]), 34895, 1), n = f + 148 | 0, G0(n, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(t, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(I4(U(f + 12 | 0, 22886, 6), n0[r + 144 >> 3]), 34895, 1);
                                    break i;
                                }
                                k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(I4(U(k, 23898, 14), n0[r + 104 >> 3]), 34895, 1), r = f + 148 | 0, G0(r, e), n = r, r = o[f + 159 | 0], e = (r | 0) < 0, U(k, e ? i[f + 148 >> 2] : n, e ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 25195, 8);
                            }
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function C3(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            s = m - 16 | 0, m = s;
                            i: {
                                if (!n) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 19354;
                                    break i;
                                }
                                f | k || (U(107396, 34190, 136), f = 2);
                                e: {
                                    r: {
                                        A: switch(f | 0){
                                            case 0:
                                                u = D(12), i[s + 4 >> 2] = u, t = u + 12 | 0, i[s + 12 >> 2] = t, i[u + 8 >> 2] = 3, i[u >> 2] = 1, i[u + 4 >> 2] = 2;
                                                break r;
                                            case 1:
                                                u = D(28), i[s + 4 >> 2] = u, t = u + 28 | 0, i[s + 12 >> 2] = t, i[u + 24 >> 2] = i[9776], h = i[9775], i[u + 16 >> 2] = i[9774], i[u + 20 >> 2] = h, h = i[9773], i[u + 8 >> 2] = i[9772], i[u + 12 >> 2] = h, h = i[9771], i[u >> 2] = i[9770], i[u + 4 >> 2] = h;
                                                break r;
                                            case 2:
                                                u = D(4), i[s + 4 >> 2] = u, t = u + 4 | 0, i[s + 12 >> 2] = t, i[u >> 2] = 0;
                                                break r;
                                            case 3:
                                                u = D(4), i[s + 4 >> 2] = u, t = u + 4 | 0, i[s + 12 >> 2] = t, i[u >> 2] = 99;
                                                break r;
                                            default:
                                                break A;
                                        }
                                        i[s + 12 >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0;
                                        break e;
                                    }
                                    i[s + 8 >> 2] = t;
                                }
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (u = i[s + 4 >> 2], t = u, h = i[s + 8 >> 2], (t | 0) == (h | 0)) break f;
                                                for(;;){
                                                    if (i[t >> 2] == (k | 0)) break f;
                                                    if (t = t + 4 | 0, (h | 0) == (t | 0)) break;
                                                }
                                                break A;
                                            }
                                            if ((t | 0) != (h | 0)) break r;
                                        }
                                        i[n >> 2] = 0, i[A + 8 >> 2] = 19403, i[A >> 2] = 5, i[A + 4 >> 2] = 2006;
                                        break e;
                                    }
                                    h = D(8), t = h, i[t >> 2] = 0, i[t + 4 >> 2] = 0, t = D(136), i[t >> 2] = 78252, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, B0(t + 20 | 0, 0, 104), u = i[t + 4 >> 2], v = u + 1 | 0, i[t + 4 >> 2] = v, i[t + 56 >> 2] = 0, i[t + 60 >> 2] = 0, i[t + 44 >> 2] = 99, i[t + 48 >> 2] = 99, i[t + 32 >> 2] = 4142, w = t - -64 | 0, i[w >> 2] = 0, i[w + 4 >> 2] = 0, i[t + 132 >> 2] = 0, i[t + 124 >> 2] = 0, i[t + 128 >> 2] = 0, i[t + 84 >> 2] = 1, i[t + 88 >> 2] = 1, i[t + 72 >> 2] = t + 76, i[t + 92 >> 2] = 0, i[t + 96 >> 2] = 0, i[t + 100 >> 2] = 0, i[t + 104 >> 2] = 0, i[t + 108 >> 2] = 0, i[t + 112 >> 2] = 0, o[t + 113 | 0] = 0, o[t + 114 | 0] = 0, o[t + 115 | 0] = 0, o[t + 116 | 0] = 0, o[t + 117 | 0] = 0, o[t + 118 | 0] = 0, o[t + 119 | 0] = 0, o[t + 120 | 0] = 0, w = t + 12 | 0, i[t + 12 >> 2] = w, i[t + 8 >> 2] = i[t + 8 >> 2] + 1, i[t + 4 >> 2] = u, i[t + 16 >> 2] = t, v || (p[i[i[t >> 2] + 8 >> 2]](t), g(t)), i[h >> 2] = w, u = i[h + 4 >> 2], i[h + 4 >> 2] = t;
                                    r: {
                                        if (!u || (t = i[u + 4 >> 2], i[u + 4 >> 2] = t - 1, t)) break r;
                                        p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                    }
                                    t = i[h >> 2], i[t + 36 >> 2] = k, i[t + 32 >> 2] = f, i[t + 28 >> 2] = e, i[t + 24 >> 2] = r, i[n >> 2] = h, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, u = i[s + 4 >> 2];
                                }
                                if (!u) break i;
                                i[s + 8 >> 2] = u, X(u);
                            }
                            m = s + 16 | 0;
                        }
                        function mv(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (A = m - 448 | 0, m = A, i[A + 440 >> 2] = e, i[A + 444 >> 2] = r, i[A + 20 >> 2] = 1414, h = A + 20 | 0, w = s1(A + 24 | 0, A + 32 | 0, h), u = A + 16 | 0, r = i[k + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108572), o[A + 15 | 0] = 0, J7(A + 444 | 0, e, f, u, i[k + 4 >> 2], n, A + 15 | 0, r, w, h, A + 432 | 0)) {
                                e = m - 16 | 0, m = e;
                                i: if (l[t + 11 | 0] >>> 7 | 0) break i;
                                i: {
                                    if (l[t + 11 | 0] >>> 7 | 0) {
                                        f = i[t >> 2], i[e + 12 >> 2] = 0, i[f >> 2] = i[e + 12 >> 2], i[t + 4 >> 2] = 0;
                                        break i;
                                    }
                                    i[e + 8 >> 2] = 0, i[t >> 2] = i[e + 8 >> 2], o[t + 11 | 0] = l[t + 11 | 0] & 128, o[t + 11 | 0] = l[t + 11 | 0] & 127;
                                }
                                for(m = e + 16 | 0, l[A + 15 | 0] == 1 && iA(t, p[i[i[r >> 2] + 44 >> 2]](r, 45) | 0), r = p[i[i[r >> 2] + 44 >> 2]](r, 48) | 0, e = i[w >> 2], s = i[A + 20 >> 2], f = s - 4 | 0;;){
                                    if (!((r | 0) != i[e >> 2] | e >>> 0 >= f >>> 0)) {
                                        e = e + 4 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                h = m - 16 | 0, m = h, l[t + 11 | 0] >>> 7 | 0 ? f = i[t + 4 >> 2] : f = l[t + 11 | 0] & 127, k = l[t + 11 | 0] >>> 7 | 0 ? (i[t + 8 >> 2] & 2147483647) - 1 | 0 : 1, r = s - e >> 2;
                                i: {
                                    if (!r) break i;
                                    if (l[t + 11 | 0] >>> 7 | 0 ? u = i[t >> 2] : u = t, _ = u, l[t + 11 | 0] >>> 7 | 0 ? u = i[t >> 2] : u = t, l[t + 11 | 0] >>> 7 | 0 ? v = i[t + 4 >> 2] : v = l[t + 11 | 0] & 127, !Xt(_, (u + (v << 2) | 0) + 4 | 0, e)) {
                                        for(r >>> 0 > k - f >>> 0 && In(t, k, r + (f - k | 0) | 0, f, f), l[t + 11 | 0] >>> 7 | 0 ? k = i[t >> 2] : k = t, k = k + (f << 2) | 0;;){
                                            if ((e | 0) != (s | 0)) {
                                                i[k >> 2] = i[e >> 2], e = e + 4 | 0, k = k + 4 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        i[h + 4 >> 2] = 0, i[k >> 2] = i[h + 4 >> 2], f6(t, r + f | 0);
                                        break i;
                                    }
                                    r = m - 16 | 0, m = r, f = h + 4 | 0, Hn(f, e, s), m = r + 16 | 0, l[f + 11 | 0] >>> 7 | 0 ? e = i[f >> 2] : e = f, s = m - 16 | 0, m = s, l[f + 11 | 0] >>> 7 | 0 ? r = i[f + 4 >> 2] : r = l[f + 11 | 0] & 127, u = l[t + 11 | 0] >>> 7 | 0 ? (i[t + 8 >> 2] & 2147483647) - 1 | 0 : 1, l[t + 11 | 0] >>> 7 | 0 ? k = i[t + 4 >> 2] : k = l[t + 11 | 0] & 127;
                                    e: {
                                        if (r >>> 0 <= u - k >>> 0) {
                                            if (!r) break e;
                                            u = e, l[t + 11 | 0] >>> 7 | 0 ? e = i[t >> 2] : e = t, r6(u, r, e + (k << 2) | 0), r = r + k | 0, f6(t, r), i[s + 12 >> 2] = 0, i[e + (r << 2) >> 2] = i[s + 12 >> 2];
                                            break e;
                                        }
                                        hn(t, u, k + (r - u | 0) | 0, k, k, 0, r, e);
                                    }
                                    m = s + 16 | 0, h1(f);
                                }
                                m = h + 16 | 0;
                            }
                            return S2(A + 444 | 0, A + 440 | 0) && (i[n >> 2] = i[n >> 2] | 2), e = i[A + 444 >> 2], d0(A + 16 | 0), r = i[w >> 2], i[w >> 2] = 0, r && p[i[w + 4 >> 2]](r), m = A + 448 | 0, e | 0;
                        }
                        function Zv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], h = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, t = f + 16 | 0, T0(h, t), i[h + 72 >> 2] = 0, i[h + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, h = z0(t), i[h >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, t = f + 148 | 0, D2(t, r, e), n = k, u = t, k = o[f + 159 | 0], t = (k | 0) < 0, U(n, t ? i[f + 148 >> 2] : u, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), n = k, k = o[f + 159 | 0], t = (k | 0) < 0, U(f + 12 | 0, t ? i[f + 148 >> 2] : n, t ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, s = U(k, 23990, 6), t = r + 104 | 0, n = o[r + 115 | 0], u = (n | 0) < 0, U(U(s, u ? i[r + 104 >> 2] : t, u ? i[r + 108 >> 2] : n), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, s = U(k, 24487, 6), n = o[r + 127 | 0], u = (n | 0) < 0, U(U(s, u ? i[r + 116 >> 2] : r + 116 | 0, u ? i[r + 120 >> 2] : n), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, s = U(k, 23539, 13), n = o[r + 139 | 0], u = (n | 0) < 0, U(U(s, u ? i[r + 128 >> 2] : r + 128 | 0, u ? i[r + 132 >> 2] : n), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(u, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(f + 12 | 0, 23191, 6), e = o[r + 115 | 0], k = (e | 0) < 0, U(U(n, k ? i[r + 104 >> 2] : t, k ? i[r + 108 >> 2] : e), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            t = (r | 7) + 1 | 0, e = D(t), i[A + 8 >> 2] = t | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[h >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(h), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Gv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), t = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(k, 25089, 25), U(M0(U(M0(U(k, 21011, 1), I[r + 100 >> 1]), 17465, 1), I[r + 106 >> 1]), 25143, 3), U(M0(U(M0(U(k, 21011, 1), I[r + 102 >> 1]), 17465, 1), I[r + 108 >> 1]), 25143, 3), U(M0(U(M0(U(k, 21011, 1), I[r + 104 >> 1]), 17465, 1), I[r + 110 >> 1]), 34894, 2), n = f + 148 | 0, G0(n, e), t = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(M0(U(k, 20992, 20), I[r + 112 >> 1]), 17465, 1), I[r + 114 >> 1]), 34894, 2), n = f + 148 | 0, G0(n, e), t = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(t, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(k, 24547, 33), i[r + 116 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(t, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 24581, 33), i[r + 120 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function s5(A, r, e, f, k, n, t, u, s, h, w, v, _, B, G) {
                            var W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0;
                            for(E = m - 16 | 0, m = E, i[e >> 2] = A, H = f & 512;;){
                                if ((R | 0) == 4) l[B + 11 | 0] >>> 7 | 0 ? k = i[B + 4 >> 2] : k = l[B + 11 | 0] & 127, k >>> 0 > 1 && (S = E, P = Q4(B), i[S + 12 >> 2] = P, S = e, P = v9(SA(E + 12 | 0, 1), U8(B), i[e >> 2]), i[S >> 2] = P), f = f & 176, (f | 0) != 16 && ((f | 0) == 32 && (A = i[e >> 2]), i[r >> 2] = A), m = E + 16 | 0;
                                else {
                                    i: {
                                        e: switch(l[s + R | 0]){
                                            case 0:
                                                i[r >> 2] = i[e >> 2];
                                                break i;
                                            case 1:
                                                i[r >> 2] = i[e >> 2], W = p[i[i[t >> 2] + 28 >> 2]](t, 32) | 0, C = i[e >> 2], i[e >> 2] = C + 1, o[C | 0] = W;
                                                break i;
                                            case 3:
                                                if (l[B + 11 | 0] >>> 7 | 0 ? W = i[B + 4 >> 2] : W = l[B + 11 | 0] & 127, !W) break i;
                                                l[B + 11 | 0] >>> 7 | 0 ? W = i[B >> 2] : W = B, W = l[W | 0], C = i[e >> 2], i[e >> 2] = C + 1, o[C | 0] = W;
                                                break i;
                                            case 2:
                                                if (C = !H, l[_ + 11 | 0] >>> 7 | 0 ? W = i[_ + 4 >> 2] : W = l[_ + 11 | 0] & 127, C | !W) break i;
                                                S = e, P = v9(Q4(_), U8(_), i[e >> 2]), i[S >> 2] = P;
                                                break i;
                                            case 4:
                                                break e;
                                            default:
                                                break i;
                                        }
                                        for(T = i[e >> 2], k = k + u | 0, V = k;;){
                                            e: {
                                                if (n >>> 0 <= V >>> 0 || (W = o[V | 0], (W | 0) >= 0 ? W = (i[i[t + 8 >> 2] + (W << 2) >> 2] & 64) != 0 : W = 0, !W)) break e;
                                                V = V + 1 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        if (W = G, (W | 0) > 0) {
                                            for(;;){
                                                if (!(!W | k >>> 0 >= V >>> 0)) {
                                                    W = W - 1 | 0, V = V - 1 | 0, C = l[V | 0], y = i[e >> 2], i[e >> 2] = y + 1, o[y | 0] = C;
                                                    continue;
                                                }
                                                break;
                                            }
                                            for(W ? C = p[i[i[t >> 2] + 28 >> 2]](t, 48) | 0 : C = 0;;){
                                                if (y = i[e >> 2], i[e >> 2] = y + 1, (W | 0) > 0) {
                                                    o[y | 0] = C, W = W - 1 | 0;
                                                    continue;
                                                }
                                                break;
                                            }
                                            o[y | 0] = h;
                                        }
                                        e: {
                                            if ((k | 0) == (V | 0)) {
                                                W = p[i[i[t >> 2] + 28 >> 2]](t, 48) | 0, C = i[e >> 2], i[e >> 2] = C + 1, o[C | 0] = W;
                                                break e;
                                            }
                                            for(l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, C = o[W | 0], l[v + 11 | 0] >>> 7 | 0 ? W = i[v + 4 >> 2] : W = l[v + 11 | 0] & 127, C = W ? C : -1, W = 0, F = 0;;){
                                                if ((k | 0) == (V | 0)) break e;
                                                r: {
                                                    if ((W | 0) != (C | 0)) {
                                                        y = W;
                                                        break r;
                                                    }
                                                    if (C = i[e >> 2], i[e >> 2] = C + 1, o[C | 0] = w, y = 0, l[v + 11 | 0] >>> 7 | 0 ? C = i[v + 4 >> 2] : C = l[v + 11 | 0] & 127, F = F + 1 | 0, C >>> 0 <= F >>> 0) {
                                                        C = W;
                                                        break r;
                                                    }
                                                    if (l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, l[W + F | 0] == 127) {
                                                        C = -1;
                                                        break r;
                                                    }
                                                    l[v + 11 | 0] >>> 7 | 0 ? W = i[v >> 2] : W = v, C = o[W + F | 0];
                                                }
                                                V = V - 1 | 0, W = l[V | 0], M = i[e >> 2], i[e >> 2] = M + 1, o[M | 0] = W, W = y + 1 | 0;
                                            }
                                        }
                                        e6(T, i[e >> 2]);
                                    }
                                    R = R + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                        }
                        function h5(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            k = m - 160 | 0, m = k, i[k + 68 >> 2] = 60132, t = i[15036], i[k + 12 >> 2] = t, n = i[t - 12 >> 2], t = k + 12 | 0, i[n + t >> 2] = i[15037], t = t + i[i[k + 12 >> 2] - 12 >> 2] | 0, h = k + 16 | 0, T0(t, h), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[k + 68 >> 2] = 60132, i[k + 12 >> 2] = 60112, h = z0(h), i[h >> 2] = 58864, i[k + 56 >> 2] = 0, i[k + 60 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 64 >> 2] = 16, t = 1, n = i[e >> 2], i[e >> 2] = n + 1;
                            i: {
                                e: {
                                    r: {
                                        w = i[r + 40 >> 2], r = i[r + 36 >> 2];
                                        A: {
                                            if ((w | 0) == (r | 0)) {
                                                i[e >> 2] = (n | 0) > 0 ? n : 0;
                                                break A;
                                            }
                                            if (f && (t = k + 148 | 0, G0(t, e), s = t, t = o[k + 159 | 0], n = (t | 0) < 0, U(k + 12 | 0, n ? i[k + 148 >> 2] : s, n ? i[k + 152 >> 2] : t), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), U(P0(U(k + 12 | 0, 22837, 7), 1), 34895, 1), t = 2), n = k + 148 | 0, u = i[r >> 2], p[i[i[u >> 2] + 8 >> 2]](n, u, e), s = n, n = o[k + 159 | 0], u = (n | 0) < 0, U(k + 12 | 0, u ? i[k + 148 >> 2] : s, u ? i[k + 152 >> 2] : n), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), r = r + 8 | 0, (w | 0) != (r | 0)) for(; n = k + 148 | 0, G0(n, e), s = n, n = o[k + 159 | 0], u = (n | 0) < 0, U(k + 12 | 0, u ? i[k + 148 >> 2] : s, u ? i[k + 152 >> 2] : n), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), n = k + 12 | 0, U(n, 34895, 1), f && (u = k + 148 | 0, G0(u, e), v = n, s = u, n = o[k + 159 | 0], u = (n | 0) < 0, U(v, u ? i[k + 148 >> 2] : s, u ? i[k + 152 >> 2] : n), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), U(P0(U(k + 12 | 0, 22837, 7), t), 34895, 1), t = t + 1 | 0), n = k + 148 | 0, u = i[r >> 2], p[i[i[u >> 2] + 8 >> 2]](n, u, e), s = n, n = o[k + 159 | 0], u = (n | 0) < 0, U(k + 12 | 0, u ? i[k + 148 >> 2] : s, u ? i[k + 152 >> 2] : n), o[k + 159 | 0] < 0 && X(i[k + 148 >> 2]), r = r + 8 | 0, (w | 0) != (r | 0););
                                            if (r = i[k + 64 >> 2], f = e, e = i[e >> 2], i[f >> 2] = (e | 0) > 0 ? e - 1 | 0 : 0, !(r & 16)) break r;
                                        }
                                        r = i[k + 60 >> 2], e = i[k + 40 >> 2], r >>> 0 < e >>> 0 && (i[k + 60 >> 2] = e, r = e), e = k + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[k + 32 >> 2], e = k + 24 | 0;
                                }
                                e: {
                                    if (f = i[e >> 2], r = r - f | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            t = (r | 7) + 1 | 0, e = D(t), i[A + 8 >> 2] = t | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, f, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[k + 12 >> 2] = A, i[i[A - 12 >> 2] + (k + 12 | 0) >> 2] = i[15038], i[h >> 2] = 58864, o[k + 59 | 0] < 0 && X(i[k + 48 >> 2]), x0(h), N0(k + 68 | 0), m = k + 160 | 0;
                        }
                        function w5(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            n = m - 160 | 0, m = n, i[n + 20 >> 2] = 59808, i[n + 76 >> 2] = 59828, u = i[14961], i[n + 12 >> 2] = u, t = n + 12 | 0, i[t + i[u - 12 >> 2] >> 2] = i[14962], i[n + 16 >> 2] = 0, u = t + i[i[n + 12 >> 2] - 12 >> 2] | 0, w = n + 24 | 0, T0(u, w), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, u = i[14963], i[n + 20 >> 2] = u, s = i[u - 12 >> 2], u = n + 20 | 0, i[s + u >> 2] = i[14964], s = i[14960], i[n + 12 >> 2] = s, i[t + i[s - 12 >> 2] >> 2] = i[14965], i[n + 76 >> 2] = 59828, i[n + 12 >> 2] = 59788, i[n + 20 >> 2] = 59808, w = z0(w), i[w >> 2] = 58864, t = n - -64 | 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, i[n + 56 >> 2] = 0, i[n + 60 >> 2] = 0, i[n + 72 >> 2] = 24, t = i[n + 20 >> 2] - 12 | 0, s = u + i[t >> 2] | 0, i[s + 4 >> 2] = i[s + 4 >> 2] & -75 | 8, s = u + i[t >> 2] | 0, i[s + 76 >> 2] == -1 && (h = n + 156 | 0, t = i[s + 28 >> 2], i[h >> 2] = t, (t | 0) != 108396 && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), t = K0(h, 108580), p[i[i[t >> 2] + 28 >> 2]](t, 32), d0(h)), i[s + 76 >> 2] = 48, t = n + 32 | 0;
                            i: {
                                if (!e) break i;
                                s = o[f + 11 | 0], h = (s | 0) < 0, U(u, h ? i[f >> 2] : f, h ? i[f + 4 >> 2] : s), i[i[i[n + 20 >> 2] - 12 >> 2] + t >> 2] = 4, U(M0(u, 0), 25140, 2), i[i[i[n + 20 >> 2] - 12 >> 2] + t >> 2] = 2, P0(u, l[r | 0]);
                                e: {
                                    if (s = e - 1 | 0, s) {
                                        f = 1;
                                        break e;
                                    }
                                    U(u, 34895, 1);
                                    break i;
                                }
                                for(;;){
                                    e: {
                                        r: {
                                            A: {
                                                f: switch(h = f & 15, h | 0){
                                                    case 0:
                                                        break f;
                                                    case 8:
                                                        break A;
                                                    default:
                                                        break r;
                                                }
                                                v = o[k + 11 | 0], _ = (v | 0) < 0, U(u, _ ? i[k >> 2] : k, _ ? i[k + 4 >> 2] : v), i[i[i[n + 20 >> 2] - 12 >> 2] + t >> 2] = 4, U(M0(u, f), 25140, 2);
                                                break e;
                                            }
                                            U(u, 25192, 2);
                                            break e;
                                        }
                                        U(u, 25193, 1);
                                    }
                                    if (i[i[i[n + 20 >> 2] - 12 >> 2] + t >> 2] = 2, P0(u, l[r + f | 0]), (f | 0) != (s | 0) & (h | 0) != 15 || U(u, 34895, 1), f = f + 1 | 0, (f | 0) == (e | 0)) break;
                                }
                            }
                            r = i[n + 72 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        t = n + 44 | 0, e = i[n + 68 >> 2], r = i[n + 48 >> 2], e >>> 0 < r >>> 0 ? i[n + 68 >> 2] = r : r = e;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        f = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[n + 40 >> 2];
                                }
                                e: {
                                    if (e = i[t >> 2], f = r - e | 0, f >>> 0 < 2147483640) {
                                        if (f >>> 0 >= 11) {
                                            k = (f | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = f, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = f, f) break e;
                                        f = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, e, f);
                            }
                            o[A + f | 0] = 0, A = i[14959], i[n + 12 >> 2] = A, i[i[A - 12 >> 2] + (n + 12 | 0) >> 2] = i[14967], i[n + 20 >> 2] = i[14968], i[w >> 2] = 58864, o[n + 67 | 0] < 0 && X(i[n + 56 >> 2]), x0(w), N0(n + 76 | 0), m = n + 160 | 0;
                        }
                        function v5(A, r, e, f, k, n, t, u, s, h, w, v, _) {
                            var B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0;
                            W = m, M = W, W = W - 14464 & -32, m = W, B = f, f = i[r + 16856 >> 2], C = Z(B, 2 / (f | 0) | 0), n = ((n | 0) / (f | 0) | 0) + (C >> 3) | 0, G = i[r + 16852 >> 2], B = Z(2 / (G | 0) | 0, e), e = ((k | 0) / (G | 0) | 0) + (B >> 3) | 0, k = i[r + 488 >> 2] / (f | 0) | 0, f = i[r + 484 >> 2] / (G | 0) | 0;
                            i: {
                                G = B & 7, B = C & 7;
                                e: {
                                    if (!(G | B)) {
                                        if (r = i[r + 16840 >> 2], !((e | 0) < 0 | (f | 0) < (e + w | 0) | ((n | 0) < 0 | (k | 0) < (n + v | 0)))) {
                                            if (r = (e + s | 0) + Z(n, h) | 0, (_ | 0) <= 8) {
                                                p[i[A + 204 >> 2]](t, u, r, h, w, v, 0, 0, 0), m = M;
                                                return;
                                            }
                                            p[i[A + 284 >> 2]](t, u, r, h, w, v, 0, 0, 0, _), m = M;
                                            return;
                                        }
                                        if ((v | 0) <= 0 | (w | 0) <= 0) break e;
                                        for(_ = 14 - r | 0, F = k - 1 | 0, W = f - 1 | 0, E = w & 2147483646, R = w & 1, A = 0;;){
                                            if (r = A + n | 0, G = Z((r | 0) >= 0 ? (r | 0) < (k | 0) ? r : F : 0, h) + s | 0, C = (Z(A, u) << 1) + t | 0, r = 0, y = 0, (w | 0) != 1) for(; B = r + e | 0, Q[C + (r << 1) >> 1] = l[G + ((B | 0) >= 0 ? (f | 0) > (B | 0) ? B : W : 0) | 0] << _, V = r | 1, B = V + e | 0, Q[C + (V << 1) >> 1] = l[G + ((B | 0) >= 0 ? (f | 0) > (B | 0) ? B : W : 0) | 0] << _, r = r + 2 | 0, y = y + 2 | 0, (E | 0) != (y | 0););
                                            if (R && (B = C + (r << 1) | 0, r = r + e | 0, Q[B >> 1] = l[G + ((r | 0) >= 0 ? (r | 0) < (f | 0) ? r : W : 0) | 0] << _), A = A + 1 | 0, (v | 0) == (A | 0)) break;
                                        }
                                        break e;
                                    }
                                    r: {
                                        if (!((e | 0) <= 0 | (e + w | 0) > (f - 2 | 0) | ((n | 0) <= 0 | (n + v | 0) > (k - 2 | 0)))) {
                                            r = (e + s | 0) + Z(n, h) | 0;
                                            break r;
                                        }
                                        if (!((v | 0) < -2 | (w | 0) < -2)) for(C = -1, S = k - 1 | 0, y = f - 1 | 0, r = v + 2 | 0, P = (r | 0) > 0 ? r : 0, r = w + 3 | 0, $ = r & -2, c = r & 1;;){
                                            if (r = n + C | 0, F = Z((r | 0) >= 0 ? (r | 0) < (k | 0) ? r : S : 0, h) + s | 0, E = Z(C, 80) + 80 | 0, r = -1, R = 0, (w | 0) != -2) for(; H = W + 16 | 0, T = r + 1 | 0, V = r + e | 0, o[H + (E + T | 0) | 0] = l[F + ((V | 0) >= 0 ? (f | 0) > (V | 0) ? V : y : 0) | 0], r = r + 2 | 0, V = e + T | 0, o[(E + r | 0) + H | 0] = l[F + ((V | 0) >= 0 ? (f | 0) > (V | 0) ? V : y : 0) | 0], R = R + 2 | 0, ($ | 0) != (R | 0););
                                            if (c && (V = W + (r + E | 0) | 0, r = r + e | 0, o[V + 17 | 0] = l[F + ((r | 0) >= 0 ? (r | 0) < (f | 0) ? r : y : 0) | 0]), C = C + 1 | 0, (P | 0) == (C | 0)) break;
                                        }
                                        h = 80, r = W + 97 | 0;
                                    }
                                    f = (((_ | 0) < 9 ? 44 : 124) + A | 0) + 172 | 0;
                                    r: {
                                        if (!(!G | !B) || (e = (_ | 0) < 9, f = ((e ? 36 : 116) + A | 0) + 172 | 0, G)) break r;
                                        if (!B) break i;
                                        G = 0, f = ((e ? 40 : 120) + A | 0) + 172 | 0;
                                    }
                                    e = f, p[i[e >> 2]](t, u, r, h, w, v, G, B, W + 5376 | 0, _);
                                }
                                m = M;
                                return;
                            }
                            y0(10076, 14978, 269, 15647), z();
                        }
                        function Wv(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (A = m - 144 | 0, m = A, i[A + 136 >> 2] = e, i[A + 140 >> 2] = r, i[A + 20 >> 2] = 1414, s = A + 20 | 0, h = s1(A + 24 | 0, A + 32 | 0, s), u = A + 16 | 0, r = i[k + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108580), o[A + 15 | 0] = 0, g7(A + 140 | 0, e, f, u, i[k + 4 >> 2], n, A + 15 | 0, r, h, s, A + 132 | 0)) {
                                e = m - 16 | 0, m = e;
                                i: if (l[t + 11 | 0] >>> 7 | 0) break i;
                                i: {
                                    if (l[t + 11 | 0] >>> 7 | 0) {
                                        f = i[t >> 2], o[e + 15 | 0] = 0, o[f | 0] = l[e + 15 | 0], i[t + 4 >> 2] = 0;
                                        break i;
                                    }
                                    o[e + 14 | 0] = 0, o[t | 0] = l[e + 14 | 0], o[t + 11 | 0] = l[t + 11 | 0] & 128, o[t + 11 | 0] = l[t + 11 | 0] & 127;
                                }
                                for(m = e + 16 | 0, l[A + 15 | 0] == 1 && Wi(t, p[i[i[r >> 2] + 28 >> 2]](r, 45) | 0), r = p[i[i[r >> 2] + 28 >> 2]](r, 48) | 0, e = i[h >> 2], s = i[A + 20 >> 2], f = s - 1 | 0, r = r & 255;;){
                                    if (!((r | 0) != l[e | 0] | e >>> 0 >= f >>> 0)) {
                                        e = e + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                f = m - 16 | 0, m = f, l[t + 11 | 0] >>> 7 | 0 ? u = i[t + 4 >> 2] : u = l[t + 11 | 0] & 127, k = l[t + 11 | 0] >>> 7 | 0 ? (i[t + 8 >> 2] & 2147483647) - 1 | 0 : 10, r = s - e | 0;
                                i: {
                                    if (!r) break i;
                                    if (l[t + 11 | 0] >>> 7 | 0 ? w = i[t >> 2] : w = t, _ = w, l[t + 11 | 0] >>> 7 | 0 ? w = i[t >> 2] : w = t, l[t + 11 | 0] >>> 7 | 0 ? v = i[t + 4 >> 2] : v = l[t + 11 | 0] & 127, !Xt(_, (w + v | 0) + 1 | 0, e)) {
                                        for(r >>> 0 > k - u >>> 0 && q3(t, k, r + (u - k | 0) | 0, u, u), l[t + 11 | 0] >>> 7 | 0 ? k = i[t >> 2] : k = t, k = k + u | 0;;){
                                            if ((e | 0) != (s | 0)) {
                                                o[k | 0] = l[e | 0], e = e + 1 | 0, k = k + 1 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        o[f + 15 | 0] = 0, o[k | 0] = l[f + 15 | 0], f6(t, r + u | 0);
                                        break i;
                                    }
                                    r = m - 16 | 0, m = r, xn(f, e, s), m = r + 16 | 0, l[f + 11 | 0] >>> 7 | 0 ? e = i[f >> 2] : e = f, s = m - 16 | 0, m = s, l[f + 11 | 0] >>> 7 | 0 ? r = i[f + 4 >> 2] : r = l[f + 11 | 0] & 127, u = l[t + 11 | 0] >>> 7 | 0 ? (i[t + 8 >> 2] & 2147483647) - 1 | 0 : 10, l[t + 11 | 0] >>> 7 | 0 ? k = i[t + 4 >> 2] : k = l[t + 11 | 0] & 127;
                                    e: {
                                        if (r >>> 0 <= u - k >>> 0) {
                                            if (!r) break e;
                                            u = e, l[t + 11 | 0] >>> 7 | 0 ? e = i[t >> 2] : e = t, f8(u, r, e + k | 0), r = r + k | 0, f6(t, r), o[s + 15 | 0] = 0, o[r + e | 0] = l[s + 15 | 0];
                                            break e;
                                        }
                                        xe(t, u, k + (r - u | 0) | 0, k, k, 0, r, e);
                                    }
                                    m = s + 16 | 0, a0(f);
                                }
                                m = f + 16 | 0;
                            }
                            return T2(A + 140 | 0, A + 136 | 0) && (i[n >> 2] = i[n >> 2] | 2), e = i[A + 140 >> 2], d0(A + 16 | 0), r = i[h >> 2], i[h >> 2] = 0, r && p[i[h + 4 >> 2]](r), m = A + 144 | 0, e | 0;
                        }
                        function _5(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            t = m - 80 | 0, m = t;
                            i: {
                                if (!k || !r | !f) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 3375;
                                    break i;
                                }
                                if ((e | 0) <= 0) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2006, i[A + 8 >> 2] = 9729;
                                    break i;
                                }
                                h = D(72), u = h, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 78588, r = ZA(u + 16 | 0, r, e, 0), i[t + 52 >> 2] = u, i[t + 48 >> 2] = r, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, r = i[t + 52 >> 2], i[t >> 2] = i[t + 48 >> 2], i[t + 4 >> 2] = r, _ = kr(t + 56 | 0, t, e, 0), i[t + 40 >> 2] = 0, i[t + 44 >> 2] = 0, c6(t + 20 | 0, _, t + 40 | 0, 78816);
                                e: {
                                    if (e = i[t + 20 >> 2], e) {
                                        if (r = i[t + 24 >> 2], i[A >> 2] = e, (r | 0) == 100) {
                                            i[A + 4 >> 2] = 100, i[A + 8 >> 2] = 15472;
                                            break e;
                                        }
                                        i[A + 4 >> 2] = r, i[A + 8 >> 2] = 2194;
                                        break e;
                                    }
                                    r: {
                                        A: {
                                            if (r = i[t + 40 >> 2], !r || (n = E0(r, 73632, 73932), !n)) break A;
                                            if (u = i[t + 44 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), r = 0, i[t + 16 >> 2] = 0, i[t + 8 >> 2] = 0, i[t + 12 >> 2] = 0, e = 0, w = i[n + 112 >> 2], n = i[n + 108 >> 2], (w | 0) != (n | 0)) {
                                                if (r = w - n | 0, (r | 0) < 0) break r;
                                                e = D(r), r = v0(e, n, r) + r | 0;
                                            }
                                            s = f, n = r - e | 0, f = Q2(n), i[s >> 2] = f, n = n >> 2, i[k >> 2] = n;
                                            f: {
                                                k: {
                                                    if ((r | 0) != (e | 0)) {
                                                        if (s = n >>> 0 <= 1 ? 1 : n, w = s & 3, k = 0, r = 0, n >>> 0 >= 4) for(B = s & -4, s = 0; n = r << 2, i[n + f >> 2] = i[e + n >> 2], v = n | 4, i[v + f >> 2] = i[e + v >> 2], v = n | 8, i[v + f >> 2] = i[e + v >> 2], n = n | 12, i[n + f >> 2] = i[e + n >> 2], r = r + 4 | 0, s = s + 4 | 0, (B | 0) != (s | 0););
                                                        if (w) for(; n = r << 2, i[n + f >> 2] = i[e + n >> 2], r = r + 1 | 0, k = k + 1 | 0, (w | 0) != (k | 0););
                                                        r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                                        break k;
                                                    }
                                                    if (r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], !e) break f;
                                                }
                                                X(e);
                                            }
                                            if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break e;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                            break e;
                                        }
                                        i[A >> 2] = 2, i[A + 4 >> 2] = 102, i[A + 8 >> 2] = 2217;
                                        break e;
                                    }
                                    p0(), z();
                                }
                                o[t + 39 | 0] < 0 && X(i[t + 28 >> 2]), A = i[t + 44 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = i[_ + 4 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            m = t + 80 | 0;
                        }
                        function Ve(A, r, e, f, k, n, t, u) {
                            var s = 0;
                            s = m - 160 | 0, m = s, i[r + 12 >> 2] = f, i[r + 8 >> 2] = e, o[r + 5 | 0] = t, o[r + 4 | 0] = n, i[r >> 2] = k, f = f + 1 & -2, k = f >>> 0 <= 64 ? 64 : f, i[r + 20 >> 2] = k, e = e + 1 & -2, e = e >>> 0 <= 64 ? 64 : e, i[r + 16 >> 2] = e, f = n & 255, n = 1;
                            i: {
                                if (f >>> 0 < 9 || (n = 2, f >>> 0 < 17) || (n = 4, f >>> 0 < 33)) break i;
                                n = f >>> 0 < 65 ? 8 : 16;
                            }
                            n = Z(n, Z(e, t)) + 15 & -16, i[r + 32 >> 2] = n;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (!u || (e = i[u + 40 >> 2], f = i[u + 44 >> 2], !(e | f)) || !f & e >>> 0 >= 15 | f && (e = _6(e - 15 | 0, f - (e >>> 0 < 15) | 0, n, 0), f = w0, !f & e >>> 0 >= k >>> 0 | f)) break f;
                                                i[s + 24 >> 2] = 59808, i[s + 80 >> 2] = 59828, e = i[14961], i[s + 16 >> 2] = e, f = i[e - 12 >> 2], e = s + 16 | 0, i[f + e >> 2] = i[14962], i[s + 20 >> 2] = 0, f = e + i[i[s + 16 >> 2] - 12 >> 2] | 0, k = s + 28 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[s + 24 >> 2] = f, n = s + 24 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[s + 16 >> 2] = f, i[e + i[f - 12 >> 2] >> 2] = i[14965], i[s + 80 >> 2] = 59828, i[s + 16 >> 2] = 59788, i[s + 24 >> 2] = 59808, f = z0(k), i[f >> 2] = 58864, i[s + 68 >> 2] = 0, i[s + 72 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 64 >> 2] = 0, i[s + 76 >> 2] = 24, U(K1(U(M0(U(n, 22026, 11), Z(i[r + 32 >> 2], i[r + 20 >> 2]) + 15 | 0), 22038, 37), i[u + 40 >> 2], i[u + 44 >> 2]), 4486, 6), r = i[s + 76 >> 2];
                                                k: {
                                                    if (r & 16) {
                                                        n = s + 48 | 0, e = i[s + 72 >> 2], r = i[s + 52 >> 2], e >>> 0 < r >>> 0 ? i[s + 72 >> 2] = r : r = e;
                                                        break k;
                                                    }
                                                    if (!(r & 8)) {
                                                        r = 0, o[s + 15 | 0] = 0, n = s + 4 | 0;
                                                        break e;
                                                    }
                                                    n = s + 36 | 0, r = i[s + 44 >> 2];
                                                }
                                                if (e = i[n >> 2], r = r - e | 0, r >>> 0 >= 2147483640) break A;
                                                if (r >>> 0 >= 11) {
                                                    k = (r | 7) + 1 | 0, n = D(k), i[s + 12 >> 2] = k | -2147483648, i[s + 4 >> 2] = n, i[s + 8 >> 2] = r;
                                                    break r;
                                                }
                                                if (o[s + 15 | 0] = r, n = s + 4 | 0, r) break r;
                                                r = 0;
                                                break e;
                                            }
                                            if (e = D(Z(k, n) | 15), i[r + 28 >> 2] = e, f = r, r = e & 15, i[f + 24 >> 2] = e + (r ? 16 - r | 0 : 0), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break i;
                                            }
                                            j(A, i[21670], i[21671]);
                                            break i;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(n, e, r);
                                }
                                o[r + n | 0] = 0, i0(A, 6, 1e3, s + 4 | 0), o[s + 15 | 0] < 0 && X(i[s + 4 >> 2]), A = i[14959], i[s + 16 >> 2] = A, i[i[A - 12 >> 2] + (s + 16 | 0) >> 2] = i[14967], i[s + 24 >> 2] = i[14968], i[f >> 2] = 58864, o[s + 71 | 0] < 0 && X(i[s + 60 >> 2]), x0(f), N0(s + 80 | 0);
                            }
                            m = s + 160 | 0;
                        }
                        function Xv(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            w = m - 32 | 0, m = w;
                            i: {
                                e: {
                                    r: {
                                        if (!(!r | !n) && (v = (f | 0) != 1970628964, k | v)) break r;
                                        i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 7560;
                                        break e;
                                    }
                                    h = D(128), i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, i[h >> 2] = 78096, _ = h + 16 | 0, i[_ + 8 >> 2] = 0, i[_ + 12 >> 2] = 0, i[_ + 16 >> 2] = 0, i[_ + 20 >> 2] = 0, i[_ + 24 >> 2] = 0, i[_ + 28 >> 2] = 0, i[_ + 32 >> 2] = 0, i[_ >> 2] = 73428, i[h + 60 >> 2] = 0, i[h + 64 >> 2] = 0, i[h + 52 >> 2] = 0, i[h + 56 >> 2] = 0, i[h + 72 >> 2] = -1, i[h + 76 >> 2] = -1, i[h + 80 >> 2] = -1, i[h + 84 >> 2] = -1, i[h + 88 >> 2] = 0, i[h + 92 >> 2] = 0, i[h + 96 >> 2] = 0, i[h + 100 >> 2] = 0, i[h + 104 >> 2] = 0, i[h + 108 >> 2] = 0, o[h + 112 | 0] = 0, i[_ >> 2] = 73736, i[h + 124 >> 2] = 0, i[h + 116 >> 2] = 0, i[h + 120 >> 2] = 0, i[h + 32 >> 2] = f;
                                    r: {
                                        if (v || (f = D(16), i[w + 20 >> 2] = f, W = f + 16 | 0, i[w + 28 >> 2] = W, v = l[k + 12 | 0] | l[k + 13 | 0] << 8 | (l[k + 14 | 0] << 16 | l[k + 15 | 0] << 24), B = l[k + 8 | 0] | l[k + 9 | 0] << 8 | (l[k + 10 | 0] << 16 | l[k + 11 | 0] << 24), o[f + 8 | 0] = B, o[f + 9 | 0] = B >>> 8, o[f + 10 | 0] = B >>> 16, o[f + 11 | 0] = B >>> 24, o[f + 12 | 0] = v, o[f + 13 | 0] = v >>> 8, o[f + 14 | 0] = v >>> 16, o[f + 15 | 0] = v >>> 24, v = l[k + 4 | 0] | l[k + 5 | 0] << 8 | (l[k + 6 | 0] << 16 | l[k + 7 | 0] << 24), k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), o[f | 0] = k, o[f + 1 | 0] = k >>> 8, o[f + 2 | 0] = k >>> 16, o[f + 3 | 0] = k >>> 24, o[f + 4 | 0] = v, o[f + 5 | 0] = v >>> 8, o[f + 6 | 0] = v >>> 16, o[f + 7 | 0] = v >>> 24, i[w + 24 >> 2] = W, i[_ + 16 >> 2] = 1970628964, f = _ + 20 | 0, (f | 0) != (w + 20 | 0) && (v = f, f = i[w + 20 >> 2], k = i[w + 24 >> 2], b4(v, f, k, k - f | 0)), f = i[w + 20 >> 2], !f)) break r;
                                        i[w + 24 >> 2] = f, X(f);
                                    }
                                    if (i[w + 28 >> 2] = 0, i[w + 20 >> 2] = 0, i[w + 24 >> 2] = 0, f = 0, t) {
                                        if ((t | 0) < 0) break i;
                                        f = D(t), i[w + 20 >> 2] = f, G = f + t | 0, i[w + 28 >> 2] = G, v0(f, n, t), i[w + 24 >> 2] = G;
                                    }
                                    if (b4(h + 116 | 0, f, G, G - f | 0), r = i[r >> 2], i[w + 16 >> 2] = h, i[w + 12 >> 2] = _, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, k = i[w + 16 >> 2], i[w >> 2] = i[w + 12 >> 2], i[w + 4 >> 2] = k, r = Qt(r, e, w, (u | 0) != 0), s && (i[s >> 2] = r), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], f && X(f), A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A) break e;
                                    p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                                }
                                m = w + 32 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function pv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, t = i[k - 12 >> 2], k = f + 12 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, W5(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(M0(U(f + 12 | 0, 24161, 11), I[r + 120 >> 1]), 2741, 1), I[r + 122 >> 1]), 34895, 1), k = i[r + 124 >> 2], w = i[r + 128 >> 2], (k | 0) != (w | 0)) for(r = 0; n = f + 148 | 0, G0(n, e), s = n, n = o[f + 159 | 0], t = (n | 0) < 0, U(f + 12 | 0, t ? i[f + 148 >> 2] : s, t ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(P0(U(f + 12 | 0, 21576, 6), r), 34114, 2), t = f + 148 | 0, G0(t, e), s = t, t = o[f + 159 | 0], h = (t | 0) < 0, U(n, h ? i[f + 148 >> 2] : s, h ? i[f + 152 >> 2] : t), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(n, 23937, 11), I[k >> 1]), 34895, 1), t = f + 148 | 0, G0(t, e), s = t, t = o[f + 159 | 0], h = (t | 0) < 0, U(n, h ? i[f + 148 >> 2] : s, h ? i[f + 152 >> 2] : t), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(P0(U(n, 23358, 9), I[k + 2 >> 1] + 1 | 0), 2741, 1), I[k + 4 >> 1] + 1 | 0), 34895, 1), r = r + 1 | 0, k = k + 6 | 0, (w | 0) != (k | 0););
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        k = i[f + 60 >> 2], r = i[f + 40 >> 2], k >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, k = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        k = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    k = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (e = i[r >> 2], k = k - e | 0, k >>> 0 < 2147483640) {
                                        if (k >>> 0 >= 11) {
                                            n = (k | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = k, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = k, k) break e;
                                        k = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, e, k);
                            }
                            o[A + k | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Qv(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (!(i[r + 8 >> 2] | i[r + 12 >> 2])) {
                                    if (r = D(32), i[f + 4 >> 2] = r, i[f + 8 >> 2] = 30, i[f + 12 >> 2] = -2147483616, e = l[9499] | l[9500] << 8 | (l[9501] << 16 | l[9502] << 24), k = l[9495] | l[9496] << 8 | (l[9497] << 16 | l[9498] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 30 | 0] = 0, e = l[9521] | l[9522] << 8 | (l[9523] << 16 | l[9524] << 24), k = l[9517] | l[9518] << 8 | (l[9519] << 16 | l[9520] << 24), o[r + 22 | 0] = k, o[r + 23 | 0] = k >>> 8, o[r + 24 | 0] = k >>> 16, o[r + 25 | 0] = k >>> 24, o[r + 26 | 0] = e, o[r + 27 | 0] = e >>> 8, o[r + 28 | 0] = e >>> 16, o[r + 29 | 0] = e >>> 24, e = l[9515] | l[9516] << 8 | (l[9517] << 16 | l[9518] << 24), k = l[9511] | l[9512] << 8 | (l[9513] << 16 | l[9514] << 24), o[r + 16 | 0] = k, o[r + 17 | 0] = k >>> 8, o[r + 18 | 0] = k >>> 16, o[r + 19 | 0] = k >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[9507] | l[9508] << 8 | (l[9509] << 16 | l[9510] << 24), k = l[9503] | l[9504] << 8 | (l[9505] << 16 | l[9506] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 0, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                u = r, s = X2(e) & 127, o[u + 97 | 0] = s, k = X2(e), o[r + 99 | 0] = k & 31, o[r + 98 | 0] = k >>> 5, k = X2(e), o[r + 106 | 0] = k & 3, o[r + 100 | 0] = k >>> 7, o[r + 105 | 0] = k >>> 2 & 1, o[r + 104 | 0] = k >>> 3 & 1, o[r + 103 | 0] = k >>> 4 & 1, o[r + 102 | 0] = k >>> 5 & 1, o[r + 101 | 0] = k >>> 6 & 1, k = X2(e), n = k >>> 4 & 1, o[r + 107 | 0] = n, n && (o[r + 108 | 0] = k & 15), n = i[r + 112 >> 2], t = i[r + 116 >> 2] - n | 0, k = i[e + 16 >> 2];
                                e: {
                                    if (t >>> 0 < k >>> 0) {
                                        r1(r + 112 | 0, k - t | 0), n = i[r + 112 >> 2];
                                        break e;
                                    }
                                    if (k >>> 0 >= t >>> 0) break e;
                                    i[r + 116 >> 2] = k + n;
                                }
                                if (Y6(e, n, k), l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function Cv(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            A = m - 1056 | 0, m = A, i[A + 16 >> 2] = n, i[A + 20 >> 2] = t, i[A + 24 >> 2] = u, i[A + 28 >> 2] = s, h = A + 944 | 0, i[A + 940 >> 2] = h, h = wr(h, 100, 9375, A + 16 | 0), i[A + 528 >> 2] = 1413, w = A + 528 | 0, B = s1(A + 520 | 0, 0, w), i[A + 528 >> 2] = 1413, v = s1(A + 512 | 0, 0, w);
                            i: {
                                if (h >>> 0 >= 100 && (h = L2(), i[A >> 2] = n, i[A + 4 >> 2] = t, i[A + 8 >> 2] = u, i[A + 12 >> 2] = s, h = e8(A + 940 | 0, h, 9375, A), (h | 0) == -1 || (n = i[B >> 2], i[B >> 2] = i[A + 940 >> 2], n && p[i[B + 4 >> 2]](n), t = Q2(h << 2), n = i[v >> 2], i[v >> 2] = t, n && p[i[v + 4 >> 2]](n), w = i[v >> 2], !w))) break i;
                                t = A + 508 | 0, n = i[f + 28 >> 2], i[t >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), V = K0(t, 108572), n = V, t = i[A + 940 >> 2], p[i[i[n >> 2] + 48 >> 2]](n, t, t + h | 0, w), C = (h | 0) > 0 ? l[i[A + 940 >> 2]] == 45 : C, t = m - 16 | 0, m = t, n = A + 484 | 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, u = A + 472 | 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, s = A + 460 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, m = t + 16 | 0, N5(e, C, A + 508 | 0, A + 504 | 0, A + 500 | 0, A + 496 | 0, n, u, s, A + 456 | 0), i[A + 48 >> 2] = 1413, e = A + 48 | 0, _ = s1(A + 40 | 0, 0, e), t = i[A + 456 >> 2];
                                e: {
                                    if ((t | 0) < (h | 0)) {
                                        l[u + 11 | 0] >>> 7 | 0 ? G = i[u + 4 >> 2] : G = l[u + 11 | 0] & 127, l[s + 11 | 0] >>> 7 | 0 ? W = i[s + 4 >> 2] : W = l[s + 11 | 0] & 127, t = (t + (G + (W + (h - t << 1) | 0) | 0) | 0) + 1 | 0;
                                        break e;
                                    }
                                    W = i[A + 456 >> 2], l[s + 11 | 0] >>> 7 | 0 ? t = i[s + 4 >> 2] : t = l[s + 11 | 0] & 127, l[u + 11 | 0] >>> 7 | 0 ? G = i[u + 4 >> 2] : G = l[u + 11 | 0] & 127, t = (W + (t + G | 0) | 0) + 2 | 0;
                                }
                                if (t >>> 0 >= 101 && (t = Q2(t << 2), e = i[_ >> 2], i[_ >> 2] = t, e && p[i[_ + 4 >> 2]](e), e = i[_ >> 2], !e)) break i;
                                return u5(e, A + 36 | 0, A + 32 | 0, i[f + 4 >> 2], w, (h << 2) + w | 0, V, C, A + 504 | 0, i[A + 500 >> 2], i[A + 496 >> 2], n, u, s, i[A + 456 >> 2]), e = X8(r, e, i[A + 36 >> 2], i[A + 32 >> 2], f, k), r = i[_ >> 2], i[_ >> 2] = 0, r && p[i[_ + 4 >> 2]](r), h1(s), h1(u), a0(n), d0(A + 508 | 0), r = i[v >> 2], i[v >> 2] = 0, r && p[i[v + 4 >> 2]](r), r = i[B >> 2], i[B >> 2] = 0, r && p[i[B + 4 >> 2]](r), m = A + 1056 | 0, e | 0;
                            }
                            w1(), z();
                        }
                        function B5(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 32 | 0, m = k, f = 180, t = 1;
                            i: {
                                e: {
                                    r: A: {
                                        f: switch(e - 2 | 0){
                                            case 2:
                                                t = 0;
                                                break e;
                                            case 3:
                                                f = 270, u = 1;
                                                break r;
                                            case 4:
                                                f = 270;
                                                break A;
                                            case 5:
                                                f = 270, t = 0, u = 1;
                                                break r;
                                            case 0:
                                                break e;
                                            case 1:
                                                break r;
                                            case 6:
                                                break f;
                                            default:
                                                break i;
                                        }
                                        f = 90;
                                    }
                                    e = D(120), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 76656, n = e + 16 | 0, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, i[n >> 2] = 73428, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 72 >> 2] = -1, i[e + 76 >> 2] = -1, i[e + 80 >> 2] = -1, i[e + 84 >> 2] = -1, i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, o[e + 112 | 0] = 0, i[n >> 2] = 74732, i[e + 116 >> 2] = f, i[e + 32 >> 2] = 1769107316, f = i[A + 52 >> 2], i[k + 28 >> 2] = e, i[k + 24 >> 2] = n, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, n = c8(f, k + 24 | 0), f = i[k + 28 >> 2];
                                    r: {
                                        if (!f || (s = i[f + 4 >> 2], i[f + 4 >> 2] = s - 1, s)) break r;
                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                    }
                                    if (f = i[A + 60 >> 2], o[k + 20 | 0] = 1, Q[k + 22 >> 1] = n + 1, i[k + 12 >> 2] = I[k + 20 >> 1] | I[k + 22 >> 1] << 16, v6(f, r, k + 12 | 0), f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f || (p[i[i[e >> 2] + 8 >> 2]](e), g(e)), !u) break i;
                                }
                                e = D(120), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 76696, f = e + 16 | 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, i[f >> 2] = 73428, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 72 >> 2] = -1, i[e + 76 >> 2] = -1, i[e + 80 >> 2] = -1, i[e + 84 >> 2] = -1, i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, o[e + 112 | 0] = 0, i[f >> 2] = 74804, i[e + 116 >> 2] = t, i[e + 32 >> 2] = 1768778098, n = i[A + 52 >> 2], i[k + 28 >> 2] = e, i[k + 24 >> 2] = f, i[e + 4 >> 2] = i[e + 4 >> 2] + 1, n = c8(n, k + 24 | 0), f = i[k + 28 >> 2];
                                e: {
                                    if (!f || (t = i[f + 4 >> 2], i[f + 4 >> 2] = t - 1, t)) break e;
                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                }
                                if (A = i[A + 60 >> 2], o[k + 16 | 0] = 1, Q[k + 18 >> 1] = n + 1, i[k + 8 >> 2] = I[k + 16 >> 1] | I[k + 18 >> 1] << 16, v6(A, r, k + 8 | 0), A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            m = k + 32 | 0;
                        }
                        function Vv(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            A = m - 448 | 0, m = A, i[A + 16 >> 2] = n, i[A + 20 >> 2] = t, i[A + 24 >> 2] = u, i[A + 28 >> 2] = s, h = A + 336 | 0, i[A + 332 >> 2] = h, h = wr(h, 100, 9375, A + 16 | 0), i[A + 224 >> 2] = 1413, w = A + 224 | 0, B = s1(A + 216 | 0, 0, w), i[A + 224 >> 2] = 1413, v = s1(A + 208 | 0, 0, w);
                            i: {
                                if (h >>> 0 >= 100 && (h = L2(), i[A >> 2] = n, i[A + 4 >> 2] = t, i[A + 8 >> 2] = u, i[A + 12 >> 2] = s, h = e8(A + 332 | 0, h, 9375, A), (h | 0) == -1 || (n = i[B >> 2], i[B >> 2] = i[A + 332 >> 2], n && p[i[B + 4 >> 2]](n), t = Q2(h), n = i[v >> 2], i[v >> 2] = t, n && p[i[v + 4 >> 2]](n), w = i[v >> 2], !w))) break i;
                                t = A + 204 | 0, n = i[f + 28 >> 2], i[t >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), V = K0(t, 108580), n = V, t = i[A + 332 >> 2], p[i[i[n >> 2] + 32 >> 2]](n, t, t + h | 0, w), C = (h | 0) > 0 ? l[i[A + 332 >> 2]] == 45 : C, t = m - 16 | 0, m = t, n = A + 184 | 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, u = A + 172 | 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, s = A + 160 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, m = t + 16 | 0, M5(e, C, A + 204 | 0, A + 200 | 0, A + 199 | 0, A + 198 | 0, n, u, s, A + 156 | 0), i[A + 48 >> 2] = 1413, e = A + 48 | 0, _ = s1(A + 40 | 0, 0, e), t = i[A + 156 >> 2];
                                e: {
                                    if ((t | 0) < (h | 0)) {
                                        l[u + 11 | 0] >>> 7 | 0 ? G = i[u + 4 >> 2] : G = l[u + 11 | 0] & 127, l[s + 11 | 0] >>> 7 | 0 ? W = i[s + 4 >> 2] : W = l[s + 11 | 0] & 127, t = (t + (G + (W + (h - t << 1) | 0) | 0) | 0) + 1 | 0;
                                        break e;
                                    }
                                    W = i[A + 156 >> 2], l[s + 11 | 0] >>> 7 | 0 ? t = i[s + 4 >> 2] : t = l[s + 11 | 0] & 127, l[u + 11 | 0] >>> 7 | 0 ? G = i[u + 4 >> 2] : G = l[u + 11 | 0] & 127, t = (W + (t + G | 0) | 0) + 2 | 0;
                                }
                                if (t >>> 0 >= 101 && (t = Q2(t), e = i[_ >> 2], i[_ >> 2] = t, e && p[i[_ + 4 >> 2]](e), e = i[_ >> 2], !e)) break i;
                                return s5(e, A + 36 | 0, A + 32 | 0, i[f + 4 >> 2], w, h + w | 0, V, C, A + 200 | 0, o[A + 199 | 0], o[A + 198 | 0], n, u, s, i[A + 156 >> 2]), e = p8(r, e, i[A + 36 >> 2], i[A + 32 >> 2], f, k), r = i[_ >> 2], i[_ >> 2] = 0, r && p[i[_ + 4 >> 2]](r), a0(s), a0(u), a0(n), d0(A + 204 | 0), r = i[v >> 2], i[v >> 2] = 0, r && p[i[v + 4 >> 2]](r), r = i[B >> 2], i[B >> 2] = 0, r && p[i[B + 4 >> 2]](r), m = A + 448 | 0, e | 0;
                            }
                            w1(), z();
                        }
                        function yv(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            for(C = m - 16 | 0, m = C, h = e;;){
                                i: {
                                    if ((f | 0) == (h | 0)) {
                                        h = f;
                                        break i;
                                    }
                                    if (!l[h | 0]) break i;
                                    h = h + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            for(i[u >> 2] = n, i[k >> 2] = e;;){
                                i: {
                                    e: {
                                        r: {
                                            if ((e | 0) == (f | 0) | (n | 0) == (t | 0)) break r;
                                            s = i[r + 4 >> 2], i[C + 8 >> 2] = i[r >> 2], i[C + 12 >> 2] = s, V = m - 16 | 0, m = V, i[V + 12 >> 2] = i[A + 8 >> 2], E = j4(V + 8 | 0, V + 12 | 0), G = h - e | 0, v = 0, B = m - 1040 | 0, m = B, s = i[k >> 2], i[B + 12 >> 2] = s, W = n || B + 16 | 0, _ = n ? t - n >> 2 : 256;
                                            A: {
                                                f: {
                                                    k: {
                                                        if (!(!s | !_)) {
                                                            for(;;){
                                                                if (w = G >>> 2 | 0, !(G >>> 0 > 131 | w >>> 0 >= _ >>> 0)) {
                                                                    w = s;
                                                                    break f;
                                                                }
                                                                if (y = t5(W, B + 12 | 0, w >>> 0 < _ >>> 0 ? w : _, r), w = i[B + 12 >> 2], (y | 0) == -1) {
                                                                    _ = 0, v = -1;
                                                                    break k;
                                                                }
                                                                if (F = (B + 16 | 0) != (W | 0) ? y : 0, _ = _ - F | 0, W = (F << 2) + W | 0, G = w ? (s + G | 0) - w | 0 : 0, v = v + y | 0, !w) break k;
                                                                if (s = w, !_) break;
                                                            }
                                                            break k;
                                                        }
                                                        w = s;
                                                    }
                                                    if (!w) break A;
                                                }
                                                if (!_ | !G) break A;
                                                for(s = v;;){
                                                    f: {
                                                        v = _i(W, w, G, r);
                                                        k: {
                                                            if (v + 2 >>> 0 <= 2) {
                                                                n: switch(v + 1 | 0){
                                                                    case 1:
                                                                        i[B + 12 >> 2] = 0;
                                                                        break k;
                                                                    case 0:
                                                                        break A;
                                                                    default:
                                                                        break n;
                                                                }
                                                                i[r >> 2] = 0;
                                                                break k;
                                                            }
                                                            if (w = i[B + 12 >> 2] + v | 0, i[B + 12 >> 2] = w, s = s + 1 | 0, _ = _ - 1 | 0, _) break f;
                                                        }
                                                        v = s;
                                                        break A;
                                                    }
                                                    if (W = W + 4 | 0, G = G - v | 0, v = s, !G) break;
                                                }
                                            }
                                            n && (i[k >> 2] = i[B + 12 >> 2]), m = B + 1040 | 0, s = i[E >> 2], s && (i[26106] = (s | 0) == -1 ? 104304 : s), m = V + 16 | 0;
                                            A: {
                                                f: {
                                                    k: {
                                                        n: {
                                                            if ((v | 0) == -1) for(;;){
                                                                if (i[u >> 2] = n, i[k >> 2] == (e | 0)) break r;
                                                                t = 1;
                                                                t: {
                                                                    o: {
                                                                        s: switch(r = Gt(n, e, h - e | 0, C + 8 | 0, i[A + 8 >> 2]), r + 2 | 0){
                                                                            case 0:
                                                                                break f;
                                                                            case 2:
                                                                                break t;
                                                                            case 1:
                                                                                break s;
                                                                            default:
                                                                                break o;
                                                                        }
                                                                        i[k >> 2] = e;
                                                                        break n;
                                                                    }
                                                                    t = r;
                                                                }
                                                                e = e + t | 0, n = i[u >> 2] + 4 | 0;
                                                            }
                                                            if (n = i[u >> 2] + (v << 2) | 0, i[u >> 2] = n, (n | 0) == (t | 0)) break A;
                                                            if (e = i[k >> 2], (f | 0) == (h | 0)) {
                                                                h = f;
                                                                continue;
                                                            }
                                                            if (!Gt(n, e, 1, r, i[A + 8 >> 2])) break k;
                                                        }
                                                        A = 2;
                                                        break e;
                                                    }
                                                    for(i[u >> 2] = i[u >> 2] + 4, e = i[k >> 2] + 1 | 0, i[k >> 2] = e, h = e;;){
                                                        if ((f | 0) == (h | 0)) {
                                                            h = f;
                                                            break i;
                                                        }
                                                        if (!l[h | 0]) break i;
                                                        h = h + 1 | 0;
                                                    }
                                                }
                                                i[k >> 2] = e, A = 1;
                                                break e;
                                            }
                                            e = i[k >> 2];
                                        }
                                        A = (e | 0) != (f | 0);
                                    }
                                    return m = C + 16 | 0, A | 0;
                                }
                                n = i[u >> 2];
                            }
                        }
                        function Iv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            k = m - 48 | 0, m = k, i[k + 44 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0;
                            i: {
                                if (!A) {
                                    A = i[10211], i[k + 24 >> 2] = i[10210], i[k + 28 >> 2] = A, A = i[10209], i[k + 16 >> 2] = i[10208], i[k + 20 >> 2] = A, A = i[10207], i[k + 8 >> 2] = i[10206], i[k + 12 >> 2] = A, a8(k + 36 | 0, k + 8 | 0, k + 32 | 0, 6);
                                    break i;
                                }
                                n = D(4), i[n >> 2] = A, A = n + 4 | 0, i[k + 44 >> 2] = A, i[k + 36 >> 2] = n, i[k + 40 >> 2] = A;
                            }
                            _r();
                            i: {
                                if (n = i[21678], (n | 0) == 86716 | i[k + 36 >> 2] == i[k + 40 >> 2]) break i;
                                e: {
                                    for(;;){
                                        r: {
                                            A = i[k + 36 >> 2], f = i[k + 40 >> 2];
                                            A: {
                                                if ((A | 0) == (f | 0)) break A;
                                                for(v = i[n + 16 >> 2];;){
                                                    if (_ = p[i[v + 16 >> 2]](i[A >> 2]) | 0, !_) {
                                                        if (A = A + 4 | 0, (f | 0) != (A | 0)) continue;
                                                        break A;
                                                    }
                                                    break;
                                                }
                                                if (u >>> 0 < h >>> 0) {
                                                    i[u + 4 >> 2] = _, i[u >> 2] = v, u = u + 8 | 0;
                                                    break A;
                                                }
                                                if (s = u - t >> 3, w = s + 1 | 0, w >>> 0 >= 536870912) break r;
                                                if (f = h - t | 0, A = f >> 2, h = f >>> 0 >= 2147483640 ? 536870911 : A >>> 0 > w >>> 0 ? A : w, h) {
                                                    if (h >>> 0 >= 536870912) break e;
                                                    f = D(h << 3);
                                                } else f = 0;
                                                if (s = f + (s << 3) | 0, i[s + 4 >> 2] = _, i[s >> 2] = v, A = s, (t | 0) != (u | 0)) for(; u = u - 8 | 0, w = i[u + 4 >> 2], A = A - 8 | 0, i[A >> 2] = i[u >> 2], i[A + 4 >> 2] = w, (t | 0) != (u | 0););
                                                h = f + (h << 3) | 0, u = s + 8 | 0, t && X(t), t = A;
                                            }
                                            f = i[n + 4 >> 2];
                                            A: {
                                                if (f) {
                                                    for(;;)if (A = f, f = i[A >> 2], !f) break A;
                                                }
                                                for(; A = i[n + 8 >> 2], f = i[A >> 2] != (n | 0), n = A, !!f;);
                                            }
                                            if (n = A, (A | 0) != 86716) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    FA(5280), z();
                                }
                                Z2(), z();
                            }
                            n = u - t >> 3;
                            i: {
                                if (!r || (A = 0, F7(t, u, (t | 0) != (u | 0) ? 62 - (e1(n) << 1) | 0 : 0, 1), n = (e | 0) > (n | 0) ? n : e, (n | 0) <= 0)) break i;
                                if (n >>> 0 >= 4) for(s = n & 2147483644, f = 0; i[(A << 2) + r >> 2] = i[(A << 3) + t >> 2], e = A | 1, i[(e << 2) + r >> 2] = i[(e << 3) + t >> 2], e = A | 2, i[(e << 2) + r >> 2] = i[(e << 3) + t >> 2], e = A | 3, i[(e << 2) + r >> 2] = i[(e << 3) + t >> 2], A = A + 4 | 0, f = f + 4 | 0, (s | 0) != (f | 0););
                                if (e = n & 3, !e) break i;
                                for(f = 0; i[(A << 2) + r >> 2] = i[(A << 3) + t >> 2], A = A + 1 | 0, f = f + 1 | 0, (e | 0) != (f | 0););
                            }
                            return A = i[k + 36 >> 2], A && (i[k + 40 >> 2] = A, X(A)), t && X(t), m = k + 48 | 0, n | 0;
                        }
                        function Fv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, t = i[15036], i[f + 12 >> 2] = t, n = f + 12 | 0, i[n + i[t - 12 >> 2] >> 2] = i[15037], t = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(t, k), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(k), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), u = n, s = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(u, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), u = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), u = U(f + 12 | 0, 24431, 10), n = o[r + 115 | 0], k = (n | 0) < 0, n = U(U(u, k ? i[r + 104 >> 2] : r + 104 | 0, k ? i[r + 108 >> 2] : n), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(n, 23343, 14), n = f + 24 | 0, e = i[r + 116 >> 2], s = i[r + 120 >> 2], (e | 0) != (s | 0)) for(; h = l[e | 0], r = i[f + 12 >> 2] - 12 | 0, k = t + i[r >> 2] | 0, i[k >> 2] = i[k >> 2] & -75 | 8, i[i[r >> 2] + n >> 2] = 2, k = i[r >> 2] + (f + 12 | 0) | 0, i[k + 76 >> 2] == -1 && (u = f + 148 | 0, r = i[k + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108580), p[i[i[r >> 2] + 28 >> 2]](r, 32), d0(u)), i[k + 76 >> 2] = 48, U(P0(f + 12 | 0, h), 25193, 1), e = e + 1 | 0, (s | 0) != (e | 0););
                            U(f + 12 | 0, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        n = f + 36 | 0, e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 ? i[f + 60 >> 2] = r : r = e;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2];
                                }
                                e: {
                                    if (n = i[n >> 2], e = r - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function V3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            e = i[A + 40 >> 2], e && (o[e + 48 | 0] = 0), e = i[r >> 2], o[e + 48 | 0] = 1, f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[A + 40 >> 2] = e, e = i[A + 44 >> 2], i[A + 44 >> 2] = f;
                            i: {
                                if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            if (u = i[i[r >> 2] + 36 >> 2], e = i[A + 48 >> 2], A = i[e + 92 >> 2], !A) {
                                t = e + 92 | 0, A = D(128), i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = 76296, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 80 >> 2] = -1, i[A + 84 >> 2] = -1, i[A + 116 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, Q[A + 112 >> 1] = 0, i[r >> 2] = 74168, i[A + 32 >> 2] = 1885959277, i[A + 120 >> 2] = 0, i[e + 92 >> 2] = r, r = i[e + 96 >> 2], i[e + 96 >> 2] = A;
                                i: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                k = m - 16 | 0, m = k, f = i[e + 44 >> 2], r = i[f + 36 >> 2], A = i[f + 40 >> 2];
                                i: {
                                    if ((r | 0) != (A | 0)) for(;;){
                                        e: {
                                            if (n = i[r >> 2], !n || !E0(n, 73632, 74220)) break e;
                                            if (A = i[r + 4 >> 2], !A | i[A + 4 >> 2] != -1 || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), A = i[t >> 2], f = i[t + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[r >> 2] = A, A = i[r + 4 >> 2], i[r + 4 >> 2] = f, !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            break i;
                                        }
                                        if (r = r + 8 | 0, (A | 0) == (r | 0)) break;
                                    }
                                    n = i[t >> 2], i[k + 8 >> 2] = n, r = i[t + 4 >> 2], i[k + 12 >> 2] = r;
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    if (!r) {
                                                        if (k0[f + 44 >> 2] <= A >>> 0) break f;
                                                        i[A + 4 >> 2] = r, i[A >> 2] = n;
                                                        break r;
                                                    }
                                                    if (i[r + 4 >> 2] = i[r + 4 >> 2] + 1, A = i[f + 40 >> 2], A >>> 0 < k0[f + 44 >> 2]) break A;
                                                }
                                                A = P2(f + 36 | 0, k + 8 | 0), r = i[k + 12 >> 2];
                                                break e;
                                            }
                                            i[A + 4 >> 2] = r, i[A >> 2] = n, i[r + 4 >> 2] = i[r + 4 >> 2] + 1;
                                        }
                                        A = A + 8 | 0;
                                    }
                                    i[f + 40 >> 2] = A;
                                    e: {
                                        if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                }
                                m = k + 16 | 0, A = i[e + 92 >> 2];
                            }
                            i[A + 104 >> 2] = u;
                        }
                        function Yv(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            k = m - 96 | 0, m = k, f5(k + 48 | 0, r, 0, 0);
                            i: {
                                if (i[k + 76 >> 2]) {
                                    if (r = i[k + 80 >> 2], i[A >> 2] = i[k + 76 >> 2], i[A + 4 >> 2] = r, r = A + 8 | 0, o[k + 95 | 0] >= 0) {
                                        A = i[k + 88 >> 2], i[r >> 2] = i[k + 84 >> 2], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[k + 92 >> 2];
                                        break i;
                                    }
                                    j(r, i[k + 84 >> 2], i[k + 88 >> 2]);
                                    break i;
                                }
                                u = i[r + 480 >> 2], w = i[k + 68 >> 2], i[k + 68 >> 2] = 0, v = i[k + 52 >> 2], i[k + 52 >> 2] = 0, n = i[k + 48 >> 2], i[k + 48 >> 2] = 0, _ = i[k + 60 >> 2], B = i[k + 64 >> 2], i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, t = i[k + 72 >> 2], h = l[k + 56 | 0], i[u + 4 >> 2] = n, s = i[u + 8 >> 2], i[u + 8 >> 2] = v;
                                e: {
                                    if (!s || (n = i[s + 4 >> 2], i[s + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                }
                                o[u + 12 | 0] = h, n = i[u + 16 >> 2], n && (i[u + 20 >> 2] = n, X(n)), i[u + 28 >> 2] = t, i[u + 24 >> 2] = w, i[u + 20 >> 2] = B, i[u + 16 >> 2] = _, n = i[r + 480 >> 2], p[i[i[n >> 2] + 20 >> 2]](k + 24 | 0, n, e, f);
                                e: {
                                    if (i[k + 24 >> 2]) {
                                        r = i[k + 28 >> 2], i[A >> 2] = i[k + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 40 >> 2], r = i[k + 36 >> 2], i[A + 8 >> 2] = i[k + 32 >> 2], i[A + 12 >> 2] = r, i[k + 40 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0;
                                        break e;
                                    }
                                    n = k + 4 | 0;
                                    r: {
                                        if (i[e >> 2] || (h = i[r + 192 >> 2], t = i[r + 196 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), I[h + 8 >> 1] | !h || (i[e >> 2] = 1, i[f >> 2] = 3), !t) || (r = i[t + 4 >> 2], i[t + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                    }
                                    r = i[21669], i[n >> 2] = i[21668], i[n + 4 >> 2] = r, e = n + 8 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            r = i[21671], i[e >> 2] = i[21670], i[e + 4 >> 2] = r, i[e + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(e, i[21670], i[21671]);
                                    }
                                    if (o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (o[k + 43 | 0] >= 0) break i;
                                X(i[k + 32 >> 2]);
                            }
                            o[k + 95 | 0] < 0 && X(i[k + 84 >> 2]), A = i[k + 60 >> 2], A && (i[k + 64 >> 2] = A, X(A)), r = i[k + 52 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = k + 96 | 0;
                        }
                        function Ev(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            Ar(A + 136 | 0, i[A + 140 >> 2]), r = i[A + 132 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 124 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 116 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 108 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 100 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 92 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 84 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 76 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 68 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 60 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 52 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 44 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (r = i[A + 28 >> 2], r) {
                                if (e = r, f = i[A + 32 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        e = i[f - 4 >> 2];
                                        i: {
                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (f = f - 8 | 0, (r | 0) == (f | 0)) break;
                                    }
                                    e = i[A + 28 >> 2];
                                }
                                i[A + 32 >> 2] = r, X(e);
                            }
                            r = i[A + 24 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            A = i[A + 16 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function ye(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            f = m - 48 | 0, m = f, i[f + 44 >> 2] = 0, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, e = i[r + 20 >> 2], n = i[e + 48 >> 2], e = i[e + 52 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), t = i[n + 52 >> 2], n = i[n + 56 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1);
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            e = i[r + 20 >> 2], k = i[e + 48 >> 2], e = i[e + 52 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[f + 28 >> 2] = i[k + 60 >> 2], k = i[k + 64 >> 2], i[f + 32 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            b7(f + 8 | 0, t, i[r + 36 >> 2], f + 28 | 0, f + 36 | 0), r = i[f + 8 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if (r) {
                                        if (r = i[f + 12 >> 2], i[A + 12 >> 2] = i[f + 8 >> 2], i[A + 16 >> 2] = r, A = A + 20 | 0, o[f + 27 | 0] >= 0) {
                                            r = i[f + 20 >> 2], i[A >> 2] = i[f + 16 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[f + 24 >> 2];
                                            break e;
                                        }
                                        j(A, i[f + 16 >> 2], i[f + 20 >> 2]);
                                        break e;
                                    }
                                    if (r = i[f + 36 >> 2], t = i[f + 40 >> 2], (r | 0) != (t | 0)) {
                                        if (k = t - r | 0, (k | 0) < 0) break i;
                                        for(e = D(k), i[A + 4 >> 2] = e, i[A >> 2] = e, i[A + 8 >> 2] = e + k; i[e >> 2] = i[r >> 2], k = i[r + 4 >> 2], i[e + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = e + 8 | 0, r = r + 8 | 0, (t | 0) != (r | 0););
                                        i[A + 4 >> 2] = e;
                                    }
                                    if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), A = i[f + 32 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                e: {
                                    if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                if (A = i[f + 36 >> 2], A) {
                                    if (e = i[f + 40 >> 2], r = A, (e | 0) != (A | 0)) {
                                        for(;;){
                                            r = i[e - 4 >> 2];
                                            e: {
                                                if (!r || (n = i[r + 4 >> 2], i[r + 4 >> 2] = n - 1, n)) break e;
                                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                            }
                                            if (e = e - 8 | 0, (A | 0) == (e | 0)) break;
                                        }
                                        r = i[f + 36 >> 2];
                                    }
                                    i[f + 40 >> 2] = A, X(r);
                                }
                                m = f + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function F1(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 82452, e = i[A + 360 >> 2], e) {
                                if (r = e, f = i[A + 364 >> 2], (r | 0) != (f | 0)) {
                                    for(; o[f - 1 | 0] < 0 && X(i[f - 12 >> 2]), f = f - 20 | 0, (e | 0) != (f | 0););
                                    r = i[A + 360 >> 2];
                                }
                                i[A + 364 >> 2] = e, X(r);
                            }
                            r = i[A + 212 >> 2], r && (i[A + 216 >> 2] = r, X(r)), r = i[A + 204 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 196 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (e = i[A + 180 >> 2], e) {
                                if (r = e, f = i[A + 184 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        r = i[f - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (f = f - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 180 >> 2];
                                }
                                i[A + 184 >> 2] = e, X(r);
                            }
                            if (e = i[A + 168 >> 2], e) {
                                if (r = e, f = i[A + 172 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        r = i[f - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (f = f - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 168 >> 2];
                                }
                                i[A + 172 >> 2] = e, X(r);
                            }
                            o[A + 167 | 0] < 0 && X(i[A + 156 >> 2]), r = i[A + 84 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 72 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (e = i[A + 52 >> 2], e) {
                                if (r = e, f = i[A + 56 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        r = i[f - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (f = f - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 52 >> 2];
                                }
                                i[A + 56 >> 2] = e, X(r);
                            }
                            if (e = i[A + 24 >> 2], e) {
                                if (r = e, f = i[A + 28 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        r = i[f - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (f = f - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 24 >> 2];
                                }
                                i[A + 28 >> 2] = e, X(r);
                            }
                            return o[A + 15 | 0] < 0 && X(i[A + 4 >> 2]), A | 0;
                        }
                        function m5(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            _ = m - 16 | 0, m = _, h = K0(t, 108572), G = K0(t, 108644), t = G, p[i[i[t >> 2] + 20 >> 2]](_ + 4 | 0, t), i[n >> 2] = f;
                            i: {
                                e: switch(s = A, t = l[s | 0], t - 43 | 0){
                                    case 0:
                                    case 2:
                                        break e;
                                    default:
                                        break i;
                                }
                                t = p[i[i[h >> 2] + 44 >> 2]](h, t << 24 >> 24) | 0, u = i[n >> 2], i[n >> 2] = u + 4, i[u >> 2] = t, s = A + 1 | 0;
                            }
                            i: {
                                if (t = s, !((e - t | 0) <= 1 | l[t | 0] != 48 | (l[t + 1 | 0] | 32) != 120)) for(u = p[i[i[h >> 2] + 44 >> 2]](h, 48) | 0, s = i[n >> 2], i[n >> 2] = s + 4, i[s >> 2] = u, u = p[i[i[h >> 2] + 44 >> 2]](h, o[t + 1 | 0]) | 0, s = i[n >> 2], i[n >> 2] = s + 4, i[s >> 2] = u, s = t + 2 | 0, t = s;;){
                                    if (e >>> 0 <= t >>> 0 || (u = o[t | 0], L2(), !(u - 48 >>> 0 < 10 | (u | 32) - 97 >>> 0 < 6))) break i;
                                    t = t + 1 | 0;
                                }
                                for(;;){
                                    if (e >>> 0 <= t >>> 0 || (u = o[t | 0], L2(), u - 48 >>> 0 >= 10)) break i;
                                    t = t + 1 | 0;
                                }
                            }
                            l[_ + 15 | 0] >>> 7 | 0 ? u = i[_ + 8 >> 2] : u = l[_ + 15 | 0] & 127;
                            i: {
                                if (!u) {
                                    p[i[i[h >> 2] + 48 >> 2]](h, s, t, i[n >> 2]), i[n >> 2] = i[n >> 2] + (t - s << 2);
                                    break i;
                                }
                                for(e6(s, t), C = p[i[i[G >> 2] + 16 >> 2]](G) | 0, u = s;;){
                                    if (t >>> 0 <= u >>> 0) ir((s - A << 2) + f | 0, i[n >> 2]);
                                    else {
                                        w = _ + 4 | 0;
                                        e: {
                                            if (l[w + 11 | 0] >>> 7 | 0) {
                                                B = i[w >> 2];
                                                break e;
                                            }
                                            B = w;
                                        }
                                        V = o[B + W | 0] <= 0, l[w + 11 | 0] >>> 7 | 0 ? B = i[w >> 2] : B = w, V | o[B + W | 0] != (v | 0) || (v = i[n >> 2], i[n >> 2] = v + 4, i[v >> 2] = C, l[w + 11 | 0] >>> 7 | 0 ? w = i[w + 4 >> 2] : w = l[w + 11 | 0] & 127, W = (w - 1 >>> 0 > W >>> 0) + W | 0, v = 0), w = p[i[i[h >> 2] + 44 >> 2]](h, o[u | 0]) | 0, B = i[n >> 2], i[n >> 2] = B + 4, i[B >> 2] = w, u = u + 1 | 0, v = v + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            i: {
                                e: {
                                    for(;;){
                                        if (e >>> 0 <= t >>> 0) break e;
                                        if (u = t + 1 | 0, t = o[t | 0], (t | 0) != 46) {
                                            t = p[i[i[h >> 2] + 44 >> 2]](h, t) | 0, s = i[n >> 2], i[n >> 2] = s + 4, i[s >> 2] = t, t = u;
                                            continue;
                                        }
                                        break;
                                    }
                                    t = p[i[i[G >> 2] + 12 >> 2]](G) | 0, s = i[n >> 2], v = s + 4 | 0, i[n >> 2] = v, i[s >> 2] = t;
                                    break i;
                                }
                                v = i[n >> 2], u = t;
                            }
                            p[i[i[h >> 2] + 48 >> 2]](h, u, e, v), t = n, n = i[n >> 2] + (e - u << 2) | 0, i[t >> 2] = n, i[k >> 2] = (r | 0) == (e | 0) ? n : (r - A << 2) + f | 0, a0(_ + 4 | 0), m = _ + 16 | 0;
                        }
                        function y3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            t = m - 32 | 0, m = t, w = i[r + 436 >> 2], n = f, f = i[r + 384 >> 2], k = n + Z(((f + i[r + 376 >> 2] | 0) - 1 >>> 0) / (f >>> 0) | 0, k) | 0, _ = k << 4, f = w + _ | 0;
                            i: {
                                e: {
                                    if (i[f >> 2] != 10 | i[f + 4 >> 2]) break e;
                                    for(v = m - 16 | 0, m = v, C = r + 372 | 0, f = i[r + 440 >> 2] - w >> 4, s = k0[r + 464 >> 2] / (l[r + 397 | 0] + l[r + 396 | 0] >>> 3 >>> 0) | 0, u = k;;){
                                        r: {
                                            if (u = u + 1 | 0, B = u - k | 0, f >>> 0 <= u >>> 0 | s >>> 0 <= B >>> 0) break r;
                                            if (n = (u << 4) + w | 0, h = i[n >> 2], !i[n + 4 >> 2] & (h | 0) == 10) continue;
                                        }
                                        break;
                                    }
                                    G = k >>> 0 > s >>> 0 ? s : k, V = k - G | 0, n = k;
                                    r: {
                                        for(;;){
                                            A: {
                                                if (f = n, !f || (h = k - f | 0, h >>> 0 >= s >>> 0)) break A;
                                                if (n = f - 1 | 0, W = (n << 4) + w | 0, !i[W + 4 >> 2] & i[W >> 2] == 10) continue;
                                                break r;
                                            }
                                            break;
                                        }
                                        f = V, h = G;
                                    }
                                    r: {
                                        if (u - f >>> 0 <= s >>> 0) break r;
                                        if (h >>> 0 < B >>> 0) {
                                            u = f + s | 0;
                                            break r;
                                        }
                                        f = u - s | 0;
                                    }
                                    n = v + 8 | 0, k = i[r + 20 >> 2], i[n >> 2] = i[k + 48 >> 2], k = i[k + 52 >> 2], i[n + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), D7(A, C, n, i[r + 36 >> 2], f, u, 0), f = i[v + 12 >> 2];
                                    r: {
                                        if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break r;
                                        p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                    }
                                    if (m = v + 16 | 0, i[A >> 2]) break i;
                                    if (o[A + 19 | 0] >= 0) break e;
                                    X(i[A + 8 >> 2]);
                                }
                                n = i[r + 436 >> 2] + _ | 0, f = i[n + 8 >> 2], k = i[n >> 2], u = i[n + 4 >> 2], n = i[r + 20 >> 2], i[t >> 2] = i[n + 48 >> 2], n = i[n + 52 >> 2], i[t + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), w6(t + 8 | 0, i[t >> 2], i[r + 36 >> 2], e, k, u, f, 0), r = i[t + 4 >> 2];
                                e: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = A + 8 | 0;
                                e: {
                                    if (i[t + 8 >> 2]) {
                                        e = i[t + 12 >> 2], i[A >> 2] = i[t + 8 >> 2], i[A + 4 >> 2] = e, i[r + 8 >> 2] = i[t + 24 >> 2], A = i[t + 20 >> 2], i[r >> 2] = i[t + 16 >> 2], i[r + 4 >> 2] = A, i[t + 24 >> 2] = 0, i[t + 16 >> 2] = 0, i[t + 20 >> 2] = 0;
                                        break e;
                                    }
                                    if (e = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = e, o[86691] >= 0) {
                                        A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(r, i[21670], i[21671]);
                                }
                                if (o[t + 27 | 0] >= 0) break i;
                                X(i[t + 16 >> 2]);
                            }
                            m = t + 32 | 0;
                        }
                        function gv(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), n = l[r + 97 | 0];
                            i: {
                                if (n >>> 0 >= 4) {
                                    s4(A, r, 12227);
                                    break i;
                                }
                                e: {
                                    r: {
                                        if (n >>> 0 >= 2) {
                                            i[r + 112 >> 2] = 0, k = r + 112 | 0;
                                            break r;
                                        }
                                        if (t = r, u = B2(e), i[t + 104 >> 2] = u, t = r, u = B2(e), Q[t + 108 >> 1] = u, B4(f + 20 | 0, e), o[r + 127 | 0] < 0 && X(i[r + 116 >> 2]), k = i[f + 24 >> 2], i[r + 116 >> 2] = i[f + 20 >> 2], i[r + 120 >> 2] = k, i[r + 124 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 139 | 0] < 0 && X(i[r + 128 >> 2]), k = i[f + 24 >> 2], i[r + 128 >> 2] = i[f + 20 >> 2], i[r + 132 >> 2] = k, i[r + 136 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 151 | 0] < 0 && X(i[r + 140 >> 2]), k = i[f + 24 >> 2], i[r + 140 >> 2] = i[f + 20 >> 2], i[r + 144 >> 2] = k, i[r + 148 >> 2] = i[f + 28 >> 2], i[r + 112 >> 2] = 0, n = l[r + 97 | 0], n >>> 0 < 2) break e;
                                        k = r + 112 | 0;
                                    }
                                    o[r + 164 | 0] = o[r + 100 | 0] & 1;
                                    r: {
                                        if ((n | 0) == 2) {
                                            n = B2(e);
                                            break r;
                                        }
                                        n = n2(e);
                                    }
                                    if (i[r + 104 >> 2] = n, t = r, u = B2(e), Q[t + 108 >> 1] = u, t = r, u = n2(e), i[t + 112 >> 2] = u, B4(f + 20 | 0, e), o[r + 127 | 0] < 0 && X(i[r + 116 >> 2]), n = i[f + 24 >> 2], i[r + 116 >> 2] = i[f + 20 >> 2], i[r + 120 >> 2] = n, i[r + 124 >> 2] = i[f + 28 >> 2], k = i[k >> 2], (k | 0) != 1970432288) {
                                        if ((k | 0) != 1835625829) break e;
                                        B4(f + 20 | 0, e), o[r + 139 | 0] < 0 && X(i[r + 128 >> 2]), k = i[f + 24 >> 2], i[r + 128 >> 2] = i[f + 20 >> 2], i[r + 132 >> 2] = k, i[r + 136 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 151 | 0] < 0 && X(i[r + 140 >> 2]), k = i[f + 24 >> 2], i[r + 140 >> 2] = i[f + 20 >> 2], i[r + 144 >> 2] = k, i[r + 148 >> 2] = i[f + 28 >> 2];
                                        break e;
                                    }
                                    B4(f + 20 | 0, e), o[r + 163 | 0] < 0 && X(i[r + 152 >> 2]), k = i[f + 24 >> 2], i[r + 152 >> 2] = i[f + 20 >> 2], i[r + 156 >> 2] = k, i[r + 160 >> 2] = i[f + 28 >> 2];
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function Jv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            t = m - 16 | 0, m = t;
                            i: {
                                if (!A) break i;
                                w = t + 4 | 0, u = w, A = i[i[A >> 2] + 48 >> 2], e = m - 160 | 0, m = e, i[e + 24 >> 2] = 59808, i[e + 80 >> 2] = 59828, f = i[14961], i[e + 16 >> 2] = f, s = e + 16 | 0, i[s + i[f - 12 >> 2] >> 2] = i[14962], i[e + 20 >> 2] = 0, f = s + i[i[e + 16 >> 2] - 12 >> 2] | 0, k = e + 28 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[e + 24 >> 2] = f, n = i[f - 12 >> 2], f = e + 24 | 0, i[n + f >> 2] = i[14964], n = i[14960], i[e + 16 >> 2] = n, i[s + i[n - 12 >> 2] >> 2] = i[14965], i[e + 80 >> 2] = 59828, i[e + 16 >> 2] = 59788, i[e + 24 >> 2] = 59808, s = z0(k), i[s >> 2] = 58864, i[e + 68 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 60 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 76 >> 2] = 24;
                                e: {
                                    r: {
                                        A: {
                                            if (k = i[A + 16 >> 2], n = i[A + 20 >> 2], (k | 0) != (n | 0)) {
                                                if (A = i[k >> 2], h = i[i[A >> 2] + 8 >> 2], i[e + 12 >> 2] = 0, p[h | 0](e, A, e + 12 | 0), A = o[e + 11 | 0], h = (A | 0) < 0, U(f, h ? i[e >> 2] : e, h ? i[e + 4 >> 2] : A), o[e + 11 | 0] < 0 && X(i[e >> 2]), A = k + 8 | 0, (n | 0) != (A | 0)) for(; U(f, 34895, 1), i[e + 12 >> 2] = 0, k = i[A >> 2], p[i[i[k >> 2] + 8 >> 2]](e, k, e + 12 | 0), k = o[e + 11 | 0], h = (k | 0) < 0, U(f, h ? i[e >> 2] : e, h ? i[e + 4 >> 2] : k), o[e + 11 | 0] < 0 && X(i[e >> 2]), A = A + 8 | 0, (n | 0) != (A | 0););
                                                if (A = i[e + 76 >> 2], !(A & 16)) break A;
                                            }
                                            A = i[e + 72 >> 2], f = i[e + 52 >> 2], A >>> 0 < f >>> 0 && (i[e + 72 >> 2] = f, A = f), f = e + 48 | 0;
                                            break r;
                                        }
                                        if (!(A & 8)) {
                                            A = 0, o[u + 11 | 0] = 0;
                                            break e;
                                        }
                                        A = i[e + 44 >> 2], f = e + 36 | 0;
                                    }
                                    r: {
                                        if (k = i[f >> 2], A = A - k | 0, A >>> 0 < 2147483640) {
                                            if (A >>> 0 >= 11) {
                                                n = (A | 7) + 1 | 0, f = D(n), i[u + 8 >> 2] = n | -2147483648, i[u >> 2] = f, i[u + 4 >> 2] = A, u = f;
                                                break r;
                                            }
                                            if (o[u + 11 | 0] = A, A) break r;
                                            A = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(u, k, A);
                                }
                                if (o[A + u | 0] = 0, A = i[14959], i[e + 16 >> 2] = A, i[i[A - 12 >> 2] + (e + 16 | 0) >> 2] = i[14967], i[e + 24 >> 2] = i[14968], i[s >> 2] = 58864, o[e + 71 | 0] < 0 && X(i[e + 60 >> 2]), x0(s), N0(e + 80 | 0), m = e + 160 | 0, f = r, A = o[t + 15 | 0], r = (A | 0) < 0, Zt(f, r ? i[t + 4 >> 2] : w, r ? i[t + 8 >> 2] : A), o[t + 15 | 0] >= 0) break i;
                                X(i[t + 4 >> 2]);
                            }
                            m = t + 16 | 0;
                        }
                        function Rv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]);
                            i: {
                                if (i[r + 100 >> 2]) {
                                    if (k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(f + 12 | 0, 24337, 13), n = f + 148 | 0, t = i[r + 100 >> 2], O4(n, p[i[i[t >> 2] + 8 >> 2]](t) | 0), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), 34895, 1), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, r = i[r + 100 >> 2], p[i[i[r >> 2] + 12 >> 2]](k, r, e), r = o[f + 159 | 0], e = (r | 0) < 0, U(f + 12 | 0, e ? i[f + 148 >> 2] : k, e ? i[f + 152 >> 2] : r), o[f + 159 | 0] >= 0) break i;
                                    X(i[f + 148 >> 2]);
                                    break i;
                                }
                                r = f + 148 | 0, G0(r, e), k = r, r = o[f + 159 | 0], e = (r | 0) < 0, U(f + 12 | 0, e ? i[f + 148 >> 2] : k, e ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), r = f + 12 | 0, U(r, 34642, 17), U(r, 25736, 17);
                            }
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Z5(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            v = m - 16 | 0, m = v, h = K0(t, 108580), G = K0(t, 108636), t = G, p[i[i[t >> 2] + 20 >> 2]](v + 4 | 0, t), i[n >> 2] = f;
                            i: {
                                e: switch(s = A, t = l[s | 0], t - 43 | 0){
                                    case 0:
                                    case 2:
                                        break e;
                                    default:
                                        break i;
                                }
                                t = p[i[i[h >> 2] + 28 >> 2]](h, t << 24 >> 24) | 0, u = i[n >> 2], i[n >> 2] = u + 1, o[u | 0] = t, s = A + 1 | 0;
                            }
                            i: {
                                if (t = s, !((e - t | 0) <= 1 | l[t | 0] != 48 | (l[t + 1 | 0] | 32) != 120)) for(u = p[i[i[h >> 2] + 28 >> 2]](h, 48) | 0, s = i[n >> 2], i[n >> 2] = s + 1, o[s | 0] = u, u = p[i[i[h >> 2] + 28 >> 2]](h, o[t + 1 | 0]) | 0, s = i[n >> 2], i[n >> 2] = s + 1, o[s | 0] = u, s = t + 2 | 0, t = s;;){
                                    if (e >>> 0 <= t >>> 0 || (u = o[t | 0], L2(), !(u - 48 >>> 0 < 10 | (u | 32) - 97 >>> 0 < 6))) break i;
                                    t = t + 1 | 0;
                                }
                                for(;;){
                                    if (e >>> 0 <= t >>> 0 || (u = o[t | 0], L2(), u - 48 >>> 0 >= 10)) break i;
                                    t = t + 1 | 0;
                                }
                            }
                            l[v + 15 | 0] >>> 7 | 0 ? u = i[v + 8 >> 2] : u = l[v + 15 | 0] & 127;
                            i: {
                                if (!u) {
                                    p[i[i[h >> 2] + 32 >> 2]](h, s, t, i[n >> 2]), i[n >> 2] = i[n >> 2] + (t - s | 0);
                                    break i;
                                }
                                for(e6(s, t), C = p[i[i[G >> 2] + 16 >> 2]](G) | 0, u = s;;){
                                    if (t >>> 0 <= u >>> 0) e6((s - A | 0) + f | 0, i[n >> 2]);
                                    else {
                                        w = v + 4 | 0;
                                        e: {
                                            if (l[w + 11 | 0] >>> 7 | 0) {
                                                _ = i[w >> 2];
                                                break e;
                                            }
                                            _ = w;
                                        }
                                        V = o[_ + W | 0] <= 0, l[w + 11 | 0] >>> 7 | 0 ? _ = i[w >> 2] : _ = w, V | o[_ + W | 0] != (B | 0) || (B = i[n >> 2], i[n >> 2] = B + 1, o[B | 0] = C, l[w + 11 | 0] >>> 7 | 0 ? w = i[w + 4 >> 2] : w = l[w + 11 | 0] & 127, W = (w - 1 >>> 0 > W >>> 0) + W | 0, B = 0), w = p[i[i[h >> 2] + 28 >> 2]](h, o[u | 0]) | 0, _ = i[n >> 2], i[n >> 2] = _ + 1, o[_ | 0] = w, u = u + 1 | 0, B = B + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            for(;;){
                                i: {
                                    e: {
                                        if (e >>> 0 <= t >>> 0) {
                                            u = t;
                                            break e;
                                        }
                                        if (u = t + 1 | 0, t = o[t | 0], (t | 0) != 46) break i;
                                        t = p[i[i[G >> 2] + 12 >> 2]](G) | 0, s = i[n >> 2], i[n >> 2] = s + 1, o[s | 0] = t;
                                    }
                                    p[i[i[h >> 2] + 32 >> 2]](h, u, e, i[n >> 2]), t = n, n = i[n >> 2] + (e - u | 0) | 0, i[t >> 2] = n, i[k >> 2] = (r | 0) == (e | 0) ? n : (r - A | 0) + f | 0, a0(v + 4 | 0), m = v + 16 | 0;
                                    return;
                                }
                                t = p[i[i[h >> 2] + 28 >> 2]](h, t) | 0, s = i[n >> 2], i[n >> 2] = s + 1, o[s | 0] = t, t = u;
                            }
                        }
                        function G5(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            k = m - 112 | 0, m = k, ye(k + 80 | 0, r);
                            i: {
                                e: {
                                    r: {
                                        if (i[k + 92 >> 2]) {
                                            if (r = i[k + 96 >> 2], i[A >> 2] = i[k + 92 >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[k + 111 | 0] < 0) break r;
                                            r = i[k + 104 >> 2], i[A >> 2] = i[k + 100 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 108 >> 2];
                                            break i;
                                        }
                                        if (p[i[i[r >> 2] + 72 >> 2]](k + 8 | 0, r), r = i[k + 84 >> 2], (r | 0) == i[k + 80 >> 2]) break e;
                                        for(h = k + 16 | 0, w = k + 12 | 0;;){
                                            u = r, r = r - 8 | 0, n = i[r >> 2];
                                            A: {
                                                if (!n) break A;
                                                if (t = E0(n, 73632, 74784), t) {
                                                    n = i[u - 4 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1);
                                                    f: {
                                                        k: {
                                                            if (t = i[t + 100 >> 2], (t | 0) != 270) {
                                                                if ((t | 0) == 180) break k;
                                                                if ((t | 0) != 90) break f;
                                                                t = i[f >> 2], s = i[k + 12 >> 2], i[f >> 2] = i[e >> 2], i[e >> 2] = s + (t ^ -1);
                                                                break f;
                                                            }
                                                            t = i[f >> 2], i[f >> 2] = i[k + 16 >> 2] + (i[e >> 2] ^ -1), i[e >> 2] = t;
                                                            break f;
                                                        }
                                                        i[e >> 2] = i[k + 12 >> 2] + (i[e >> 2] ^ -1), i[f >> 2] = i[k + 16 >> 2] + (i[f >> 2] ^ -1);
                                                    }
                                                    f: {
                                                        if (!n || (t = i[n + 4 >> 2], i[n + 4 >> 2] = t - 1, t)) break f;
                                                        p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                                    }
                                                    if (n = i[r >> 2], !n) break A;
                                                }
                                                if (s = E0(n, 73632, 74856), !s) break A;
                                                t = i[u - 4 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), u = w, n = e;
                                                f: switch(i[s + 100 >> 2]){
                                                    case 0:
                                                        u = h, n = f;
                                                    case 1:
                                                        i[n >> 2] = i[u >> 2] + (i[n >> 2] ^ -1);
                                                        break;
                                                    default:
                                                        break f;
                                                }
                                                if (!t || (n = i[t + 4 >> 2], i[t + 4 >> 2] = n - 1, n)) break A;
                                                p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                            }
                                            if (i[k + 80 >> 2] == (r | 0)) break;
                                        }
                                        break e;
                                    }
                                    j(A, i[k + 100 >> 2], i[k + 104 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            if (o[k + 111 | 0] < 0 && X(i[k + 100 >> 2]), A = i[k + 80 >> 2], A) {
                                if (r = i[k + 84 >> 2], n = A, (r | 0) != (n | 0)) {
                                    for(;;){
                                        e = i[r - 4 >> 2];
                                        i: {
                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (r = r - 8 | 0, (A | 0) == (r | 0)) break;
                                    }
                                    n = i[k + 80 >> 2];
                                }
                                i[k + 84 >> 2] = A, X(n);
                            }
                            m = k + 112 | 0;
                        }
                        function Nv(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                e: {
                                    if (!i[A + 64 >> 2]) {
                                        n = -1;
                                        break e;
                                    }
                                    if (r = i[A + 92 >> 2] & 8, !r) {
                                        i[A + 28 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0;
                                        r: {
                                            if (l[A + 98 | 0] == 1) {
                                                e = i[A + 32 >> 2], n = e + i[A + 52 >> 2] | 0, i[A + 16 >> 2] = n;
                                                break r;
                                            }
                                            e = i[A + 56 >> 2], n = e + i[A + 60 >> 2] | 0, i[A + 16 >> 2] = n;
                                        }
                                        i[A + 12 >> 2] = n, i[A + 8 >> 2] = e, i[A + 92 >> 2] = 8;
                                    }
                                    i[A + 12 >> 2] || (e = f + 16 | 0, i[A + 16 >> 2] = e, i[A + 12 >> 2] = e, i[A + 8 >> 2] = f + 15), r && (r = i[A + 16 >> 2], e = i[A + 8 >> 2], i[f + 4 >> 2] = 4, i[f + 8 >> 2] = (r - e | 0) / 2, r = m - 16 | 0, m = r, m = r + 16 | 0, r = f + 4 | 0, e = f + 8 | 0, t = i[(k0[r >> 2] < k0[e >> 2] ? r : e) >> 2]), n = -1, r = i[A + 16 >> 2];
                                    r: {
                                        if ((r | 0) == i[A + 12 >> 2]) {
                                            if (Q0(i[A + 8 >> 2], r - t | 0, t), l[A + 98 | 0] == 1) {
                                                if (r = i[A + 8 >> 2] + t | 0, r = p9(r, i[A + 16 >> 2] - r | 0, i[A + 64 >> 2]), !r) break r;
                                                e = i[A + 8 >> 2], n = i[A + 8 >> 2] + t | 0, i[A + 16 >> 2] = r + (i[A + 8 >> 2] + t | 0), i[A + 12 >> 2] = n, i[A + 8 >> 2] = e, n = l[i[A + 12 >> 2]];
                                                break r;
                                            }
                                            r = i[A + 40 >> 2], e = i[A + 36 >> 2];
                                            A: {
                                                if ((r | 0) == (e | 0)) {
                                                    e = r;
                                                    break A;
                                                }
                                                Q0(i[A + 32 >> 2], e, r - e | 0), r = i[A + 36 >> 2], e = i[A + 40 >> 2];
                                            }
                                            if (k = i[A + 32 >> 2], r = e - r | 0, i[A + 36 >> 2] = k + r, e = (k | 0) == (A + 44 | 0) ? 8 : i[A + 52 >> 2], i[A + 40 >> 2] = e + k, i[f + 8 >> 2] = i[A + 60 >> 2] - t, i[f + 4 >> 2] = e - r, r = m - 16 | 0, m = r, m = r + 16 | 0, e = f + 4 | 0, r = f + 8 | 0, e = i[(k0[e >> 2] < k0[r >> 2] ? e : r) >> 2], k = i[A + 76 >> 2], i[A + 80 >> 2] = i[A + 72 >> 2], i[A + 84 >> 2] = k, k = p9(i[A + 36 >> 2], e, i[A + 64 >> 2]), !k) break r;
                                            if (e = i[A + 68 >> 2], !e) break i;
                                            k = k + i[A + 36 >> 2] | 0, i[A + 40 >> 2] = k, u = k, k = i[A + 8 >> 2];
                                            A: {
                                                if ((p[i[i[e >> 2] + 16 >> 2]](e, A + 72 | 0, i[A + 32 >> 2], u, A + 36 | 0, k + t | 0, k + i[A + 60 >> 2] | 0, r) | 0) == 3) {
                                                    r = i[A + 32 >> 2], i[A + 16 >> 2] = i[A + 40 >> 2], i[A + 12 >> 2] = r, i[A + 8 >> 2] = r;
                                                    break A;
                                                }
                                                if (r = i[f + 8 >> 2], e = i[A + 8 >> 2], t = e + t | 0, (r | 0) == (t | 0)) break r;
                                                i[A + 16 >> 2] = r, i[A + 12 >> 2] = t, i[A + 8 >> 2] = e;
                                            }
                                            n = l[i[A + 12 >> 2]];
                                            break r;
                                        }
                                        n = l[i[A + 12 >> 2]];
                                    }
                                    if (i[A + 8 >> 2] != (f + 15 | 0)) break e;
                                    i[A + 16 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = 0;
                                }
                                return m = f + 16 | 0, n | 0;
                            }
                            w1(), z();
                        }
                        function J4(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (u = m - 16 | 0, m = u, n = i[A + 84 >> 2], !n) {
                                k = D(136), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 76776, n = k + 16 | 0, i[n + 8 >> 2] = 0, i[n + 12 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 32 >> 2] = 0, i[n >> 2] = 73428, i[k + 60 >> 2] = 0, i[k + 64 >> 2] = 0, i[k + 52 >> 2] = 0, i[k + 56 >> 2] = 0, i[k + 72 >> 2] = -1, i[k + 76 >> 2] = -1, i[k + 80 >> 2] = -1, i[k + 84 >> 2] = -1, i[k + 116 >> 2] = 0, i[k + 88 >> 2] = 0, i[k + 92 >> 2] = 0, i[k + 96 >> 2] = 0, i[k + 100 >> 2] = 0, i[k + 104 >> 2] = 0, i[k + 108 >> 2] = 0, Q[k + 112 >> 1] = 0, i[n >> 2] = 74948, i[k + 128 >> 2] = 0, i[k + 120 >> 2] = 0, i[k + 124 >> 2] = 0, i[k + 32 >> 2] = 1769104742, i[A + 84 >> 2] = n, t = i[A + 88 >> 2], i[A + 88 >> 2] = k;
                                i: {
                                    e: {
                                        r: {
                                            A: {
                                                f: {
                                                    if (!t) {
                                                        t = i[A + 44 >> 2], i[u + 12 >> 2] = k, i[u + 8 >> 2] = n;
                                                        break f;
                                                    }
                                                    if (k = i[t + 4 >> 2], i[t + 4 >> 2] = k - 1, k || (p[i[i[t >> 2] + 8 >> 2]](t), g(t)), t = i[A + 44 >> 2], n = i[A + 84 >> 2], k = i[A + 88 >> 2], i[u + 12 >> 2] = k, i[u + 8 >> 2] = n, !k) break A;
                                                }
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, h = t + 40 | 0, s = i[t + 40 >> 2], s >>> 0 >= k0[t + 44 >> 2]) break e;
                                                i[s + 4 >> 2] = k, i[s >> 2] = n, i[k + 4 >> 2] = i[k + 4 >> 2] + 1;
                                                break r;
                                            }
                                            if (h = t + 40 | 0, s = i[t + 40 >> 2], s >>> 0 >= k0[t + 44 >> 2]) break e;
                                            i[s + 4 >> 2] = 0, i[s >> 2] = n;
                                        }
                                        k = s + 8 | 0;
                                        break i;
                                    }
                                    k = P2(t + 36 | 0, u + 8 | 0);
                                }
                                i[h >> 2] = k, k = i[u + 12 >> 2];
                                i: {
                                    if (!k || (n = i[k + 4 >> 2], i[k + 4 >> 2] = n - 1, n)) break i;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                n = i[A + 84 >> 2];
                            }
                            A = m + -64 | 0, m = A, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 24 >> 2] = e, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 60 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 48 >> 2] = r, i[A + 8 >> 2] = 73428, r = A + 52 | 0, (r | 0) != (f | 0) && (k = r, r = i[f >> 2], e = i[f + 4 >> 2], a8(k, r, e, e - r >> 2)), r = i[n + 108 >> 2];
                            i: {
                                if (r >>> 0 < k0[n + 112 >> 2]) {
                                    Bi(r, A + 8 | 0), r = r + 56 | 0;
                                    break i;
                                }
                                r = L3(n + 104 | 0, A + 8 | 0);
                            }
                            i[n + 108 >> 2] = r, r = i[A + 52 >> 2], r && (i[A + 56 >> 2] = r, X(r)), i[A + 8 >> 2] = 73428, r = i[A + 28 >> 2], r && (i[A + 32 >> 2] = r, X(r)), m = A - -64 | 0, m = u + 16 | 0;
                        }
                        function Dv(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0;
                            f = m - 32 | 0, m = f, r = i[e >> 2], n = i[r + 28 >> 2], h = i[r + 24 >> 2], r = D(136), i[r >> 2] = 78252, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, B0(r + 20 | 0, 0, 104), u = i[r + 4 >> 2], s = u + 1 | 0, i[r + 4 >> 2] = s, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r + 44 >> 2] = 99, i[r + 48 >> 2] = 99, i[r + 32 >> 2] = 4142, k = r - -64 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[r + 132 >> 2] = 0, i[r + 124 >> 2] = 0, i[r + 128 >> 2] = 0, i[r + 84 >> 2] = 1, i[r + 88 >> 2] = 1, i[r + 72 >> 2] = r + 76, i[r + 92 >> 2] = 0, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, i[r + 112 >> 2] = 0, o[r + 113 | 0] = 0, o[r + 114 | 0] = 0, o[r + 115 | 0] = 0, o[r + 116 | 0] = 0, o[r + 117 | 0] = 0, o[r + 118 | 0] = 0, o[r + 119 | 0] = 0, o[r + 120 | 0] = 0, k = r + 12 | 0, i[r + 12 >> 2] = k, i[r + 8 >> 2] = i[r + 8 >> 2] + 1, i[r + 4 >> 2] = u, i[r + 16 >> 2] = r, s || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), u = i[e >> 2], s = i[u + 32 >> 2], i[k + 36 >> 2] = i[u + 36 >> 2], i[k + 32 >> 2] = s, i[k + 28 >> 2] = n, i[k + 24 >> 2] = h;
                            i: {
                                if (!A1(i[e >> 2], 0) || (J8(f + 12 | 0, k, e, 0, 0, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i: {
                                if (!A1(i[e >> 2], 1) || (J8(f + 12 | 0, k, e, 1, 1, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i: {
                                if (!A1(i[e >> 2], 2) || (J8(f + 12 | 0, k, e, 2, 2, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i: {
                                if (!A1(i[e >> 2], 3) || (J8(f + 12 | 0, k, e, 3, 3, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i: {
                                if (!A1(i[e >> 2], 4) || (J8(f + 12 | 0, k, e, 4, 4, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i: {
                                if (!A1(i[e >> 2], 5) || (J8(f + 12 | 0, k, e, 5, 5, t), o[f + 31 | 0] >= 0)) break i;
                                X(i[f + 20 >> 2]);
                            }
                            i[A + 4 >> 2] = r, i[A >> 2] = k, i[r + 4 >> 2] = i[r + 4 >> 2] + 1, e = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = e, A = A + 16 | 0;
                            i: {
                                if (o[86691] < 0) {
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                            }
                            A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A || (p[i[i[r >> 2] + 8 >> 2]](r), g(r)), m = f + 32 | 0;
                        }
                        function Mv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (t = m - 32 | 0, m = t, s = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 100 | 0]), f2(e, (l[r + 103 | 0] & 31 | (l[r + 102 | 0] << 5 | l[r + 101 | 0] << 6)) & 255), l2(e, i[r + 104 >> 2]), f = l[r + 108 | 0], k = f >>> 4 | 0, k = k & 2 | (k & 1 | (f >>> 2 & 2 | (f & 4 | f << 2 & 8))) << 2, f = f >>> 6 | 0, f2(e, ((k | f & 1) << 2 | f) & 254), f = i[r + 108 >> 2], k = f >>> 10 | 0, n = k & 2 | (f >>> 8 & 2 | k & 1) << 2, k = f >>> 12 | 0, f = f >>> 14 | 0, f2(e, (((n | k & 1) << 2 | k & 2 | f & 1) << 2 | f & 2) & 254), f = i[r + 108 >> 2], k = f >>> 18 | 0, n = k & 2 | (f >>> 16 & 2 | k & 1) << 2, k = f >>> 20 | 0, f = f >>> 22 | 0, f2(e, (((n | k & 1) << 2 | k & 2 | f & 1) << 2 | f & 2) & 254), f = i[r + 108 >> 2], k = f >>> 26 | 0, n = k & 2 | (f >>> 24 & 2 | k & 1) << 2, k = f >>> 28 | 0, f = f >>> 30 | 0, f2(e, (((n | k & 1) << 2 | k & 2 | f & 1) << 2 | f) & 254), f = l[r + 112 | 0], k = f >>> 4 | 0, k = k & 2 | (k & 1 | (f >>> 2 & 2 | (f & 4 | f << 2 & 8))) << 2, f = f >>> 6 | 0, f2(e, ((k | f & 1) << 2 | f) & 254), f = i[r + 112 >> 2], k = f >>> 10 | 0, n = k & 2 | (f >>> 8 & 2 | k & 1) << 2, k = f >>> 12 | 0, f = f >>> 14 | 0, f2(e, (((n | k & 1) << 2 | k & 2 | f & 1) << 2 | f & 2) & 254), f2(e, l[r + 116 | 0]), w2(e, I[r + 118 >> 1] | 61440), f2(e, l[r + 120 | 0] | 252), f2(e, l[r + 121 | 0] | 252), f2(e, l[r + 122 | 0] | 248), f2(e, l[r + 123 | 0] | 248), w2(e, I[r + 124 >> 1]), f2(e, (l[r + 132 | 0] - 1 & 3 | (l[r + 128 | 0] << 2 & 4 | (l[r + 127 | 0] << 3 & 56 | l[r + 126 | 0] << 6))) & 255), f2(e, i[r + 140 >> 2] - i[r + 136 >> 2] >>> 4 & 255), f = i[r + 136 >> 2], n = i[r + 140 >> 2], (f | 0) != (n | 0)) for(;;){
                                if (f2(e, l[f | 0] << 6 & 64 | l[f + 1 | 0] & 63), w2(e, (i[f + 8 >> 2] - i[f + 4 >> 2] | 0) / 12 & 65535), k = i[f + 4 >> 2], u = i[f + 8 >> 2], (k | 0) != (u | 0)) for(; w2(e, i[k + 4 >> 2] - i[k >> 2] & 65535), G4(e, k), k = k + 12 | 0, (u | 0) != (k | 0););
                                if (f = f + 16 | 0, (n | 0) == (f | 0)) break;
                            }
                            E4(t + 12 | 0, r, e, s), o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = t + 32 | 0;
                        }
                        function Uv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], u = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(u, k), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(k), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), s = n, t = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(s, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), t = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(f + 12 | 0, 24749, 13), i[r + 104 >> 2]), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], s = (k | 0) < 0, U(n, s ? i[f + 148 >> 2] : t, s ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(n, 24351, 14), O4(f, i[r + 108 >> 2]), t = n, n = o[f + 11 | 0], k = (n | 0) < 0, n = U(U(t, k ? i[f >> 2] : f, k ? i[f + 4 >> 2] : n), 34895, 1), k = f + 148 | 0, G0(k, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(n, 24487, 6), e = o[r + 135 | 0], n = (e | 0) < 0, U(U(k, n ? i[r + 124 >> 2] : r + 124 | 0, n ? i[r + 128 >> 2] : e), 34895, 1), o[f + 11 | 0] < 0 && X(i[f >> 2]), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[e >> 2], r = r - n | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            k = (r | 7) + 1 | 0, e = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Hv(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 48 | 0, m = k;
                            i: {
                                e: {
                                    if (!f) {
                                        if (o[k + 16 | 0] = 0, o[k + 27 | 0] = 0, e = A, A = i0(k + 28 | 0, 5, 2001, k + 16 | 0), r = i[r >> 2], j0(e, A, r ? r + 4 | 0 : 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[k + 27 | 0] >= 0) break e;
                                        X(i[k + 16 >> 2]);
                                        break e;
                                    }
                                    i[f >> 2] = 0, n = i[r >> 2], i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, u = i[n + 168 >> 2], s = i[n + 172 >> 2];
                                    r: {
                                        if ((u | 0) != (s | 0)) {
                                            if (n = s - u | 0, (n | 0) < 0) break i;
                                            for(t = D(n), i[k + 16 >> 2] = t, i[k + 24 >> 2] = n + t, n = t; i[n >> 2] = i[u >> 2], h = n, n = i[u + 4 >> 2], i[h + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = h + 8 | 0, u = u + 8 | 0, (s | 0) != (u | 0););
                                            for(i[k + 20 >> 2] = n, u = t;;){
                                                if (s = i[u >> 2], i[s + 36 >> 2] == (e | 0)) {
                                                    e = D(16), i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[f >> 2] = e, n = i[u + 4 >> 2];
                                                    A: {
                                                        if (!n) {
                                                            i[e + 4 >> 2] = n, i[e >> 2] = s;
                                                            break A;
                                                        }
                                                        if (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e >> 2] = s, t = i[e + 4 >> 2], i[e + 4 >> 2] = n, !t || (e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e)) break A;
                                                        p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                    }
                                                    e = i[r + 8 >> 2], f = i[f >> 2], t = i[r + 12 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[f + 8 >> 2] = e, e = i[f + 12 >> 2], i[f + 12 >> 2] = t;
                                                    A: {
                                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break A;
                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                    }
                                                    e = A, A = i[r >> 2], j0(e, 86672, A ? A + 4 | 0 : 0), t = i[k + 16 >> 2];
                                                    break r;
                                                }
                                                if (n = (u | 0) != (h | 0), u = u + 8 | 0, !n) break;
                                            }
                                        }
                                        if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, e = i0(k + 28 | 0, 5, 2e3, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break r;
                                        X(i[e + 8 >> 2]);
                                    }
                                    if (!t) break e;
                                    if (A = t, u = i[k + 20 >> 2], (u | 0) != (t | 0)) {
                                        for(;;){
                                            A = i[u - 4 >> 2];
                                            r: {
                                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break r;
                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            }
                                            if (u = u - 8 | 0, (u | 0) == (t | 0)) break;
                                        }
                                        A = i[k + 16 >> 2];
                                    }
                                    i[k + 20 >> 2] = t, X(A);
                                }
                                m = k + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function xv(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 48 | 0, m = k;
                            i: {
                                e: {
                                    if (!f) {
                                        if (o[k + 16 | 0] = 0, o[k + 27 | 0] = 0, e = A, A = i0(k + 28 | 0, 5, 2001, k + 16 | 0), r = i[r >> 2], j0(e, A, r ? r + 4 | 0 : 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[k + 27 | 0] >= 0) break e;
                                        X(i[k + 16 >> 2]);
                                        break e;
                                    }
                                    n = i[r >> 2], i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0, u = i[n + 52 >> 2], s = i[n + 56 >> 2];
                                    r: {
                                        if ((u | 0) != (s | 0)) {
                                            if (n = s - u | 0, (n | 0) < 0) break i;
                                            for(t = D(n), i[k + 16 >> 2] = t, i[k + 24 >> 2] = n + t, n = t; i[n >> 2] = i[u >> 2], h = n, n = i[u + 4 >> 2], i[h + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = h + 8 | 0, u = u + 8 | 0, (s | 0) != (u | 0););
                                            for(i[k + 20 >> 2] = n, u = t;;){
                                                if (s = i[u >> 2], i[s + 36 >> 2] == (e | 0)) {
                                                    e = D(16), i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[f >> 2] = e, n = i[u + 4 >> 2];
                                                    A: {
                                                        if (!n) {
                                                            i[e + 4 >> 2] = n, i[e >> 2] = s;
                                                            break A;
                                                        }
                                                        if (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e >> 2] = s, t = i[e + 4 >> 2], i[e + 4 >> 2] = n, !t || (e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e)) break A;
                                                        p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                    }
                                                    e = i[r + 8 >> 2], f = i[f >> 2], t = i[r + 12 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[f + 8 >> 2] = e, e = i[f + 12 >> 2], i[f + 12 >> 2] = t;
                                                    A: {
                                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break A;
                                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                                    }
                                                    e = A, A = i[r >> 2], j0(e, 86672, A ? A + 4 | 0 : 0), t = i[k + 16 >> 2];
                                                    break r;
                                                }
                                                if (n = (u | 0) != (h | 0), u = u + 8 | 0, !n) break;
                                            }
                                        }
                                        if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, e = i0(k + 28 | 0, 5, 2e3, k + 4 | 0), o[k + 15 | 0] < 0 && X(i[k + 4 >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break r;
                                        X(i[e + 8 >> 2]);
                                    }
                                    if (!t) break e;
                                    if (A = t, u = i[k + 20 >> 2], (u | 0) != (t | 0)) {
                                        for(;;){
                                            A = i[u - 4 >> 2];
                                            r: {
                                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break r;
                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            }
                                            if (u = u - 8 | 0, (u | 0) == (t | 0)) break;
                                        }
                                        A = i[k + 16 >> 2];
                                    }
                                    i[k + 20 >> 2] = t, X(A);
                                }
                                m = k + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function ui(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 48 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (n = i[r + 128 >> 2], !n) break A;
                                            for(s = r + 128 | 0, u = s, t = n; h = k0[t + 16 >> 2] < e >>> 0, u = h ? u : t, t = i[(h << 2) + t >> 2], !!t;);
                                            if ((u | 0) == (s | 0) | k0[u + 16 >> 2] > e >>> 0) break A;
                                            for(t = s; u = k0[n + 16 >> 2] < e >>> 0, t = u ? t : n, n = i[(u << 2) + n >> 2], !!n;);
                                            if (u = 0, !((t | 0) == (s | 0) | k0[t + 16 >> 2] > e >>> 0) && (n = i[t + 20 >> 2], u = i[t + 24 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), n)) break r;
                                            if (o[k + 12 | 0] = 0, o[k + 23 | 0] = 0, i0(A, 5, 2e3, k + 12 | 0), o[k + 23 | 0] >= 0) break e;
                                            X(i[k + 12 >> 2]);
                                            break e;
                                        }
                                        if (o[k + 12 | 0] = 0, o[k + 23 | 0] = 0, i0(A, 5, 2e3, k + 12 | 0), o[k + 23 | 0] >= 0) break i;
                                        X(i[k + 12 >> 2]);
                                        break i;
                                    }
                                    t = i[n + 112 >> 2];
                                    r: {
                                        if (o[n + 139 | 0] >= 0) {
                                            i[k + 40 >> 2] = i[n + 136 >> 2], s = i[n + 132 >> 2], i[k + 32 >> 2] = i[n + 128 >> 2], i[k + 36 >> 2] = s;
                                            break r;
                                        }
                                        j(k + 32 | 0, i[n + 128 >> 2], i[n + 132 >> 2]);
                                    }
                                    i[k + 12 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 28 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0;
                                    r: {
                                        A: {
                                            if ((t | 0) != 1835625829) break A;
                                            f: {
                                                if (o[n + 151 | 0] >= 0) {
                                                    i[k + 8 >> 2] = i[n + 148 >> 2], t = i[n + 144 >> 2], i[k >> 2] = i[n + 140 >> 2], i[k + 4 >> 2] = t;
                                                    break f;
                                                }
                                                j(k, i[n + 140 >> 2], i[n + 144 >> 2]);
                                            }
                                            n = o[k + 11 | 0], t = (n | 0) < 0;
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: switch(s = t ? i[k + 4 >> 2] : n, s - 2 | 0){
                                                                case 11:
                                                                    break n;
                                                                case 0:
                                                                    break t;
                                                                case 5:
                                                                    break o;
                                                                default:
                                                                    break f;
                                                            }
                                                            if (O2(t ? i[k >> 2] : k, 10068, s)) break f;
                                                            break k;
                                                        }
                                                        if (!O2(t ? i[k >> 2] : k, 6368, s)) break k;
                                                        break f;
                                                    }
                                                    if (O2(t ? i[k >> 2] : k, 15100, 13)) break f;
                                                }
                                                if (i0(A, 4, 3005, k), o[k + 11 | 0] >= 0) break r;
                                                X(i[k >> 2]);
                                                break r;
                                            }
                                            if ((n | 0) >= 0) break A;
                                            X(i[k >> 2]);
                                        }
                                        ei(A, i[r + 68 >> 2], e, r + 8 | 0, r + 76 | 0, f, 0, 0, -1, -1, i[r + 136 >> 2]);
                                    }
                                    if (o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), o[k + 43 | 0] >= 0) break e;
                                    X(i[k + 32 >> 2]);
                                }
                                if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            m = k + 48 | 0;
                        }
                        function zv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            A = m - 480 | 0, m = A, t = A + 476 | 0, u = i[f + 28 >> 2], i[t >> 2] = u, (u | 0) != 108396 && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), G = K0(t, 108572), l[n + 11 | 0] >>> 7 | 0 ? t = i[n + 4 >> 2] : t = l[n + 11 | 0] & 127, t && (l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, W = i[t >> 2] == (p[i[i[G >> 2] + 44 >> 2]](G, 45) | 0)), t = m - 16 | 0, m = t, v = A + 452 | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, i[v + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, s = A + 440 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, h = A + 428 | 0, i[h >> 2] = 0, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, m = t + 16 | 0, N5(e, W, A + 476 | 0, A + 472 | 0, A + 468 | 0, A + 464 | 0, v, s, h, A + 424 | 0), i[A + 16 >> 2] = 1413, e = A + 16 | 0, w = s1(A + 8 | 0, 0, e);
                            i: {
                                l[n + 11 | 0] >>> 7 | 0 ? t = i[n + 4 >> 2] : t = l[n + 11 | 0] & 127;
                                e: {
                                    if ((t | 0) > i[A + 424 >> 2]) {
                                        l[n + 11 | 0] >>> 7 | 0 ? u = i[n + 4 >> 2] : u = l[n + 11 | 0] & 127, t = i[A + 424 >> 2], l[s + 11 | 0] >>> 7 | 0 ? _ = i[s + 4 >> 2] : _ = l[s + 11 | 0] & 127, l[h + 11 | 0] >>> 7 | 0 ? B = i[h + 4 >> 2] : B = l[h + 11 | 0] & 127, t = (t + (_ + (B + (u - t << 1) | 0) | 0) | 0) + 1 | 0;
                                        break e;
                                    }
                                    _ = i[A + 424 >> 2], l[h + 11 | 0] >>> 7 | 0 ? t = i[h + 4 >> 2] : t = l[h + 11 | 0] & 127, l[s + 11 | 0] >>> 7 | 0 ? u = i[s + 4 >> 2] : u = l[s + 11 | 0] & 127, t = (_ + (t + u | 0) | 0) + 2 | 0;
                                }
                                if (t >>> 0 < 101 || (e = Q2(t << 2), t = i[w >> 2], i[w >> 2] = e, t && p[i[w + 4 >> 2]](t), e = i[w >> 2], e)) break i;
                                w1(), z();
                            }
                            return _ = A + 4 | 0, B = i[f + 4 >> 2], l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, u = t, l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, l[n + 11 | 0] >>> 7 | 0 ? n = i[n + 4 >> 2] : n = l[n + 11 | 0] & 127, u5(e, _, A, B, u, t + (n << 2) | 0, G, W, A + 472 | 0, i[A + 468 >> 2], i[A + 464 >> 2], v, s, h, i[A + 424 >> 2]), r = X8(r, e, i[A + 4 >> 2], i[A >> 2], f, k), e = i[w >> 2], i[w >> 2] = 0, e && p[i[w + 4 >> 2]](e), h1(h), h1(s), a0(v), d0(A + 476 | 0), m = A + 480 | 0, r | 0;
                        }
                        function Tv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            A = m - 176 | 0, m = A, t = A + 172 | 0, u = i[f + 28 >> 2], i[t >> 2] = u, (u | 0) != 108396 && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), G = K0(t, 108580), l[n + 11 | 0] >>> 7 | 0 ? t = i[n + 4 >> 2] : t = l[n + 11 | 0] & 127, t && (l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, W = l[t | 0] == (p[i[i[G >> 2] + 28 >> 2]](G, 45) & 255)), t = m - 16 | 0, m = t, v = A + 152 | 0, i[v >> 2] = 0, i[v + 4 >> 2] = 0, i[v + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, s = A + 140 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, m = t + 16 | 0, t = m - 16 | 0, m = t, h = A + 128 | 0, i[h >> 2] = 0, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, m = t + 16 | 0, M5(e, W, A + 172 | 0, A + 168 | 0, A + 167 | 0, A + 166 | 0, v, s, h, A + 124 | 0), i[A + 16 >> 2] = 1413, e = A + 16 | 0, w = s1(A + 8 | 0, 0, e);
                            i: {
                                l[n + 11 | 0] >>> 7 | 0 ? t = i[n + 4 >> 2] : t = l[n + 11 | 0] & 127;
                                e: {
                                    if ((t | 0) > i[A + 124 >> 2]) {
                                        l[n + 11 | 0] >>> 7 | 0 ? u = i[n + 4 >> 2] : u = l[n + 11 | 0] & 127, t = i[A + 124 >> 2], l[s + 11 | 0] >>> 7 | 0 ? _ = i[s + 4 >> 2] : _ = l[s + 11 | 0] & 127, l[h + 11 | 0] >>> 7 | 0 ? B = i[h + 4 >> 2] : B = l[h + 11 | 0] & 127, t = (t + (_ + (B + (u - t << 1) | 0) | 0) | 0) + 1 | 0;
                                        break e;
                                    }
                                    _ = i[A + 124 >> 2], l[h + 11 | 0] >>> 7 | 0 ? t = i[h + 4 >> 2] : t = l[h + 11 | 0] & 127, l[s + 11 | 0] >>> 7 | 0 ? u = i[s + 4 >> 2] : u = l[s + 11 | 0] & 127, t = (_ + (t + u | 0) | 0) + 2 | 0;
                                }
                                if (t >>> 0 < 101 || (e = Q2(t), t = i[w >> 2], i[w >> 2] = e, t && p[i[w + 4 >> 2]](t), e = i[w >> 2], e)) break i;
                                w1(), z();
                            }
                            return _ = A + 4 | 0, B = i[f + 4 >> 2], l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, u = t, l[n + 11 | 0] >>> 7 | 0 ? t = i[n >> 2] : t = n, l[n + 11 | 0] >>> 7 | 0 ? n = i[n + 4 >> 2] : n = l[n + 11 | 0] & 127, s5(e, _, A, B, u, t + n | 0, G, W, A + 168 | 0, o[A + 167 | 0], o[A + 166 | 0], v, s, h, i[A + 124 >> 2]), r = p8(r, e, i[A + 4 >> 2], i[A >> 2], f, k), e = i[w >> 2], i[w >> 2] = 0, e && p[i[w + 4 >> 2]](e), a0(h), a0(s), a0(v), d0(A + 172 | 0), m = A + 176 | 0, r | 0;
                        }
                        function Sv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, G0(n, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), o[f + 148 | 0] = 39, k = f + 148 | 0, n = U(f + 12 | 0, k, 1), O4(k, i[r + 100 >> 2]), u = n, s = k, k = o[f + 159 | 0], n = (k | 0) < 0, u = U(U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), 23523, 15), k = o[r + 123 | 0], n = (k | 0) < 0, U(U(u, n ? i[r + 112 >> 2] : r + 112 | 0, n ? i[r + 116 >> 2] : k), 34895, 1), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), n = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 22635, 10);
                            i: {
                                e: switch(i[r + 124 >> 2]){
                                    case 0:
                                        U(f + 12 | 0, 25567, 6);
                                        break i;
                                    case 1:
                                        U(f + 12 | 0, 25754, 10);
                                        break i;
                                    case 2:
                                        break e;
                                    default:
                                        break i;
                                }
                                U(f + 12 | 0, 25574, 9);
                            }
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function li(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0;
                            h = m - 32 | 0, m = h, m8(h + 24 | 0, i[r + 48 >> 2], n), n = i[h + 24 >> 2], o[n + 164 | 0] = 1, i[n + 100 >> 2] = i[n + 100 >> 2] & -2 | 1;
                            i: {
                                e: {
                                    if (!t) break e;
                                    if (v = i[h + 24 >> 2], n = E2(t), n >>> 0 >= 2147483640) break i;
                                    r: {
                                        A: {
                                            if (n >>> 0 >= 11) {
                                                _ = (n | 7) + 1 | 0, w = D(_), i[h + 20 >> 2] = _ | -2147483648, i[h + 12 >> 2] = w, i[h + 16 >> 2] = n;
                                                break A;
                                            }
                                            if (o[h + 23 | 0] = n, w = h + 12 | 0, !n) break r;
                                        }
                                        v0(w, t, n);
                                    }
                                    o[n + w | 0] = 0, n = v + 128 | 0;
                                    r: {
                                        if ((n | 0) == (h + 12 | 0)) break r;
                                        if (t = o[h + 23 | 0], o[v + 139 | 0] >= 0) {
                                            if ((t | 0) >= 0) {
                                                t = i[h + 16 >> 2], i[n >> 2] = i[h + 12 >> 2], i[n + 4 >> 2] = t, i[n + 8 >> 2] = i[h + 20 >> 2];
                                                break r;
                                            }
                                            X4(n, i[h + 12 >> 2], i[h + 16 >> 2]);
                                            break r;
                                        }
                                        w = n, n = (t | 0) < 0, Y4(w, n ? i[h + 12 >> 2] : h + 12 | 0, n ? i[h + 16 >> 2] : t);
                                    }
                                    if (o[h + 23 | 0] >= 0) break e;
                                    X(i[h + 12 >> 2]);
                                }
                                n = i[i[h + 24 >> 2] + 104 >> 2], s && (i[s >> 2] = n), t = i[r + 48 >> 2], s = i[i[e >> 2] + 36 >> 2], e = D(4), i[h + 12 >> 2] = e, w = e + 4 | 0, i[h + 20 >> 2] = w, i[e >> 2] = s, i[h + 16 >> 2] = w, J4(t, n, 1667527523, h + 12 | 0), e = i[h + 12 >> 2], e && (i[h + 16 >> 2] = e, X(e)), i[h + 20 >> 2] = 0, i[h + 12 >> 2] = 0, i[h + 16 >> 2] = 0;
                                e: {
                                    r: switch(u - 3 | 0){
                                        case 1:
                                            if (o[h | 0] = 0, o[h + 11 | 0] = 0, i0(A, 4, 3005, h), o[h + 11 | 0] >= 0) break e;
                                            X(i[h >> 2]);
                                            break e;
                                        case 0:
                                            if (o[h | 0] = 0, o[h + 11 | 0] = 0, i0(A, 4, 3005, h), o[h + 11 | 0] >= 0) break e;
                                            X(i[h >> 2]);
                                            break e;
                                        default:
                                            break r;
                                    }
                                    if (k ? (r1(h + 12 | 0, k), e = i[h + 12 >> 2]) : e = 0, v0(e, f, k), x8(i[r + 48 >> 2], n, h + 12 | 0, 0), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[h + 12 >> 2], A && (i[h + 16 >> 2] = A, X(A)), A = i[h + 28 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                m = h + 32 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function jv(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = m - 48 | 0, m = e;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    if (f = i[r + 24 >> 2], r = i[r + 28 >> 2], (f | 0) != (r | 0)) for(;;){
                                                        n: {
                                                            if (k = i[f >> 2], !k || (k = E0(k, 73632, 81996), !k)) break n;
                                                            if (f = i[f + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 20 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 16 >> 2] = 0, L7(k, e + 12 | 0)) break A;
                                                            if (o[e | 0] = 0, o[e + 11 | 0] = 0, r = i0(e + 24 | 0, 2, 117, e), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[r + 4 >> 2], i[A + 12 >> 2] = i[r >> 2], i[A + 16 >> 2] = k, A = A + 20 | 0, o[r + 19 | 0] < 0) break k;
                                                            k = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = k, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                            break f;
                                                        }
                                                        if (f = f + 8 | 0, (r | 0) == (f | 0)) break;
                                                    }
                                                    o[e + 12 | 0] = 0, o[e + 23 | 0] = 0, r = i0(e + 24 | 0, 2, 141, e + 12 | 0), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 4 >> 2], i[A + 12 >> 2] = i[r >> 2], i[A + 16 >> 2] = f, A = A + 20 | 0;
                                                    n: {
                                                        if (o[r + 19 | 0] >= 0) {
                                                            f = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                            break n;
                                                        }
                                                        if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break n;
                                                        X(i[r + 8 >> 2]);
                                                    }
                                                    if (o[e + 23 | 0] >= 0) break e;
                                                    X(i[e + 12 >> 2]);
                                                    break e;
                                                }
                                                if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break f;
                                                X(i[r + 8 >> 2]);
                                            }
                                            if (o[e + 11 | 0] >= 0) break r;
                                            X(i[e >> 2]);
                                            break r;
                                        }
                                        if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, n = i[e + 12 >> 2], r = i[e + 16 >> 2], (n | 0) != (r | 0)) {
                                            if (r = r - n | 0, (r | 0) < 0) break i;
                                            k = D(r), i[A + 4 >> 2] = k, i[A >> 2] = k, t = r + k | 0, i[A + 8 >> 2] = t, v0(k, n, r), i[A + 4 >> 2] = t;
                                        }
                                        if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    if (A = i[e + 12 >> 2], A && (i[e + 16 >> 2] = A, X(A)), !f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                }
                                m = e + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function W5(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(M0(U(f + 12 | 0, 24688, 10), i[r + 104 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), u = n, e = o[f + 159 | 0], n = (e | 0) < 0, U(k, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(k, 23481, 12), e = i[r + 108 >> 2], k = i[r + 112 >> 2];
                            i: {
                                if ((e | 0) == (k | 0) || (M0(f + 12 | 0, i[e >> 2]), r = e + 4 | 0, (k | 0) == (r | 0))) break i;
                                for(; e = i[r >> 2], o[f + 148 | 0] = 32, n = f + 12 | 0, U(n, f + 148 | 0, 1), M0(n, e), r = r + 4 | 0, (k | 0) != (r | 0););
                            }
                            U(f + 12 | 0, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function $2(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            u = m - 16 | 0, m = u;
                            i: {
                                e: {
                                    n = i[A + 4 >> 2], f = i[A + 8 >> 2];
                                    r: {
                                        if (n >>> 0 < f >>> 0) {
                                            i[u + 8 >> 2] = i[r + 20 >> 2], k = l[r + 23 | 0] | l[r + 24 | 0] << 8 | (l[r + 25 | 0] << 16 | l[r + 26 | 0] << 24), o[u + 11 | 0] = k, o[u + 12 | 0] = k >>> 8, o[u + 13 | 0] = k >>> 16, o[u + 14 | 0] = k >>> 24, e = i[e >> 2], k = i[r >> 2], s = i[r + 4 >> 2], f = i[r + 12 >> 2], i[n + 8 >> 2] = i[r + 8 >> 2], i[n + 12 >> 2] = f, i[n >> 2] = k, i[n + 4 >> 2] = s, i[n + 16 >> 2] = 78668, i[n + 20 >> 2] = i[u + 8 >> 2], r = l[u + 11 | 0] | l[u + 12 | 0] << 8 | (l[u + 13 | 0] << 16 | l[u + 14 | 0] << 24), o[n + 23 | 0] = r, o[n + 24 | 0] = r >>> 8, o[n + 25 | 0] = r >>> 16, o[n + 26 | 0] = r >>> 24, i[n + 28 >> 2] = e, h = n + 32 | 0;
                                            break r;
                                        }
                                        if (s = i[A >> 2], t = n - s >> 5, k = t + 1 | 0, k >>> 0 >= 134217728) break e;
                                        if (f = f - s | 0, h = f >> 4, k = f >>> 0 >= 2147483616 ? 134217727 : k >>> 0 < h >>> 0 ? h : k, k) {
                                            if (k >>> 0 >= 134217728) break i;
                                            f = D(k << 5);
                                        } else f = 0;
                                        h = i[e >> 2], e = f + (t << 5) | 0, t = i[r + 4 >> 2], i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = t, t = i[r + 8 >> 2], w = i[r + 12 >> 2], i[e + 16 >> 2] = 78668, i[e + 8 >> 2] = t, i[e + 12 >> 2] = w, i[e + 20 >> 2] = i[r + 20 >> 2], r = l[r + 23 | 0] | l[r + 24 | 0] << 8 | (l[r + 25 | 0] << 16 | l[r + 26 | 0] << 24), o[e + 23 | 0] = r, o[e + 24 | 0] = r >>> 8, o[e + 25 | 0] = r >>> 16, o[e + 26 | 0] = r >>> 24, i[e + 28 >> 2] = h, w = f + (k << 5) | 0, h = e + 32 | 0;
                                        A: {
                                            if ((n | 0) == (s | 0)) {
                                                r = e;
                                                break A;
                                            }
                                            for(; k = n - 32 | 0, f = i[k + 4 >> 2], r = e - 32 | 0, i[r >> 2] = i[k >> 2], i[r + 4 >> 2] = f, f = i[k + 12 >> 2], i[r + 8 >> 2] = i[k + 8 >> 2], i[r + 12 >> 2] = f, i[e - 16 >> 2] = 78668, f = e - 12 | 0, t = n - 12 | 0, i[f >> 2] = i[t >> 2], t = l[t + 3 | 0] | l[t + 4 | 0] << 8 | (l[t + 5 | 0] << 16 | l[t + 6 | 0] << 24), o[f + 3 | 0] = t, o[f + 4 | 0] = t >>> 8, o[f + 5 | 0] = t >>> 16, o[f + 6 | 0] = t >>> 24, i[e - 4 >> 2] = i[n - 4 >> 2], e = r, n = k, (n | 0) != (s | 0););
                                            s = i[A >> 2];
                                        }
                                        if (i[A + 8 >> 2] = w, i[A + 4 >> 2] = h, i[A >> 2] = r, !s) break r;
                                        X(s);
                                    }
                                    i[A + 4 >> 2] = h, m = u + 16 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function Ov(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], t = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(t, k), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(k), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, G0(k, e), u = n, s = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(u, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(f + 12 | 0, 23368, 18), I[r + 4 >> 1]), 34895, 1), k = f + 148 | 0, G0(k, e), s = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : s, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(n, 23454, 26), I[r + 6 >> 1]), 34895, 1), k = f + 148 | 0, G0(k, e), s = k, k = o[f + 159 | 0], u = (k | 0) < 0, U(n, u ? i[f + 148 >> 2] : s, u ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(n, 23052, 21), I[r + 8 >> 1]), 34895, 1), k = f + 148 | 0, G0(k, e), s = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(qe(U(n, 24017, 17), l[r + 10 | 0]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Pv(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            h = m - 16 | 0, m = h;
                            i: {
                                if (!Eo(t, 0)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2002, i[A + 8 >> 2] = 8228;
                                    break i;
                                }
                                if (s = D(44), i[s + 40 >> 2] = 0, i[s + 32 >> 2] = 0, i[s + 36 >> 2] = 0, i[s + 12 >> 2] = 79184, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, i[s + 28 >> 2] = n, i[s + 24 >> 2] = k, i[s + 20 >> 2] = f, i[s + 16 >> 2] = e, i[s >> 2] = 79428, e = s + 32 | 0, f = 0, k = Z(k, n) + 7 | 0, k >>> 0 >= 8 && (r1(e, k >>> 3 | 0), v = i[s + 36 >> 2], f = i[s + 32 >> 2]), _ = s + 12 | 0, k = 0, B0(f, 0, v - f | 0), n = i[t >> 2], f = i[n + 24 >> 2], n = i[n + 28 >> 2], v = Ci(t, 0, h + 12 | 0), !(!n | !f)) for(;;){
                                    for(t = 0; G = i[e >> 2] + ((B & 7) << 29 | w >>> 3) | 0, o[G | 0] = l[G | 0] | (l[(v + Z(i[h + 12 >> 2], k) | 0) + t | 0] & 128) >>> (w & 7), w = w + 1 | 0, B = w ? B : B + 1 | 0, t = t + 1 | 0, (f | 0) != (t | 0););
                                    if (k = k + 1 | 0, (n | 0) == (k | 0)) break;
                                }
                                e = i[r + 8 >> 2], i[h + 8 >> 2] = s, i[h + 4 >> 2] = _, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, f = i[e + 16 >> 2];
                                e: {
                                    r: {
                                        if (f >>> 0 < k0[e + 20 >> 2]) {
                                            i[f + 4 >> 2] = s, i[f >> 2] = _, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, n = s;
                                            break r;
                                        }
                                        if (f = P2(e + 12 | 0, h + 4 | 0), n = i[h + 8 >> 2], i[e + 16 >> 2] = f, !n) break e;
                                    }
                                    if (e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                e: {
                                    if (!u || (i[s + 4 >> 2] = i[s + 4 >> 2] + 1, e = D(24), i[s + 4 >> 2] = i[s + 4 >> 2] + 1, i[e + 20 >> 2] = s, i[e + 16 >> 2] = _, k = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = k, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[u >> 2] = e, r = i[s + 4 >> 2], i[s + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                }
                                if (r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            m = h + 16 | 0;
                        }
                        function Lv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(k, 23608, 22), i[r + 100 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(k, 22845, 17), I[r + 104 >> 1]), 34895, 1), n = f + 148 | 0, G0(n, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(u, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 22675, 17), I[r + 106 >> 1]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Kv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], t = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(t, k), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(k), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), u = n, s = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(u, k ? i[f + 148 >> 2] : s, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), u = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(f + 12 | 0, 24688, 10), i[r + 104 >> 2]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, k = o[f + 159 | 0], s = (k | 0) < 0, U(n, s ? i[f + 148 >> 2] : u, s ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(n, 25041, 15), i[i[r + 108 >> 2] >> 2]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(n, 25024, 16), i[i[r + 108 >> 2] + 4 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function qv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, t = i[k - 12 >> 2], k = f + 12 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(P0(U(P0(U(P0(U(P0(U(k, 24289, 16), i[r + 100 >> 2]), 18463, 1), i[r + 104 >> 2]), 21266, 3), i[r + 108 >> 2]), 18463, 1), i[r + 112 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(t, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(P0(U(P0(U(P0(U(f + 12 | 0, 22967, 8), i[r + 116 >> 2]), 18463, 1), i[r + 120 >> 2]), 22607, 3), i[r + 124 >> 2]), 18463, 1), i[r + 128 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function $v(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = m + -64 | 0, m = e, p[i[i[r >> 2] + 32 >> 2]](e + 32 | 0, r);
                            i: {
                                e: {
                                    r: {
                                        if (i[e + 44 >> 2]) {
                                            if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 48 >> 2], i[A + 12 >> 2] = i[e + 44 >> 2], i[A + 16 >> 2] = r, A = A + 20 | 0, o[e + 63 | 0] >= 0) {
                                                r = i[e + 56 >> 2], i[A >> 2] = i[e + 52 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 60 >> 2];
                                                break r;
                                            }
                                            j(A, i[e + 52 >> 2], i[e + 56 >> 2]);
                                            break r;
                                        }
                                        if (i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, f = i[e + 36 >> 2], k = i[e + 32 >> 2], (f | 0) != (k | 0)) {
                                            if (f = f - k | 0, (f | 0) < 0) break e;
                                            n = D(f), i[e + 20 >> 2] = n, t = f + n | 0, i[e + 28 >> 2] = t, v0(n, k, f), i[e + 24 >> 2] = t;
                                        }
                                        f = i[r + 20 >> 2], k = i[f + 48 >> 2], f = i[f + 52 >> 2];
                                        A: {
                                            if (!f) {
                                                w6(e, k, i[r + 36 >> 2], e + 20 | 0, 0, 0, -1, -1);
                                                break A;
                                            }
                                            if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, w6(e, k, i[r + 36 >> 2], e + 20 | 0, 0, 0, -1, -1), r = i[f + 4 >> 2], i[f + 4 >> 2] = r - 1, r) break A;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                        }
                                        r = i[e >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        A: {
                                            if (r) {
                                                if (r = i[e + 4 >> 2], i[A + 12 >> 2] = i[e >> 2], i[A + 16 >> 2] = r, A = A + 20 | 0, o[e + 19 | 0] >= 0) {
                                                    r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 16 >> 2];
                                                    break A;
                                                }
                                                j(A, i[e + 8 >> 2], i[e + 12 >> 2]);
                                                break A;
                                            }
                                            if (r = i[e + 24 >> 2], k = i[e + 20 >> 2], (r | 0) != (k | 0)) {
                                                if (r = r - k | 0, (r | 0) < 0) break i;
                                                f = D(r), i[A + 4 >> 2] = f, i[A >> 2] = f, n = r + f | 0, i[A + 8 >> 2] = n, v0(f, k, r), i[A + 4 >> 2] = n;
                                            }
                                            if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                                break A;
                                            }
                                            j(A, i[21670], i[21671]);
                                        }
                                        if (o[e + 19 | 0] < 0 && X(i[e + 8 >> 2]), A = i[e + 20 >> 2], !A) break r;
                                        i[e + 24 >> 2] = A, X(A);
                                    }
                                    o[e + 63 | 0] < 0 && X(i[e + 52 >> 2]), A = i[e + 32 >> 2], A && (i[e + 36 >> 2] = A, X(A)), m = e - -64 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function av(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            for(B = m - 16 | 0, m = B, s = e;;){
                                i: {
                                    if ((f | 0) == (s | 0)) {
                                        s = f;
                                        break i;
                                    }
                                    if (!i[s >> 2]) break i;
                                    s = s + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            i[u >> 2] = n, i[k >> 2] = e;
                            i: {
                                for(;;){
                                    e: {
                                        r: {
                                            if (!((e | 0) == (f | 0) | (n | 0) == (t | 0))) {
                                                h = i[r + 4 >> 2], i[B + 8 >> 2] = i[r >> 2], i[B + 12 >> 2] = h, y = 1, G = m - 16 | 0, m = G, i[G + 12 >> 2] = i[A + 8 >> 2], F = j4(G + 8 | 0, G + 12 | 0), h = n, w = t - h | 0, W = 0, C = m - 16 | 0, m = C, v = i[k >> 2], V = s - e >> 2;
                                                A: {
                                                    if (!v | !V) break A;
                                                    for(w = h ? w : 0;;){
                                                        if (_ = Ke(w >>> 0 < 4 ? C + 12 | 0 : h, i[v >> 2]), (_ | 0) == -1) {
                                                            W = -1;
                                                            break A;
                                                        }
                                                        if (h) {
                                                            if (w >>> 0 <= 3) {
                                                                if (w >>> 0 < _ >>> 0) break A;
                                                                v0(h, C + 12 | 0, _);
                                                            }
                                                            w = w - _ | 0, h = h + _ | 0;
                                                        } else h = 0;
                                                        if (!i[v >> 2]) {
                                                            v = 0;
                                                            break A;
                                                        }
                                                        if (W = W + _ | 0, v = v + 4 | 0, V = V - 1 | 0, !V) break;
                                                    }
                                                }
                                                h && (i[k >> 2] = v), m = C + 16 | 0, h = i[F >> 2], h && (i[26106] = (h | 0) == -1 ? 104304 : h), m = G + 16 | 0;
                                                A: {
                                                    f: {
                                                        k: switch(W + 1 | 0){
                                                            case 0:
                                                                for(i[u >> 2] = n;;){
                                                                    if (i[k >> 2] == (e | 0) || (r = MA(n, i[e >> 2], i[A + 8 >> 2]), (r | 0) == -1)) break f;
                                                                    n = r + i[u >> 2] | 0, i[u >> 2] = n, e = e + 4 | 0;
                                                                }
                                                            case 1:
                                                                break i;
                                                            default:
                                                                break k;
                                                        }
                                                        if (n = i[u >> 2] + W | 0, i[u >> 2] = n, (n | 0) == (t | 0)) break A;
                                                        if ((f | 0) == (s | 0)) {
                                                            e = i[k >> 2], s = f;
                                                            continue;
                                                        }
                                                        if (e = B + 4 | 0, s = MA(e, 0, i[A + 8 >> 2]), (s | 0) == -1) break e;
                                                        if (t - i[u >> 2] >>> 0 < s >>> 0) break i;
                                                        for(;;){
                                                            if (s) {
                                                                n = l[e | 0], h = i[u >> 2], i[u >> 2] = h + 1, o[h | 0] = n, s = s - 1 | 0, e = e + 1 | 0;
                                                                continue;
                                                            }
                                                            break;
                                                        }
                                                        for(e = i[k >> 2] + 4 | 0, i[k >> 2] = e, s = e;;){
                                                            if ((f | 0) == (s | 0)) {
                                                                s = f;
                                                                break r;
                                                            }
                                                            if (!i[s >> 2]) break r;
                                                            s = s + 4 | 0;
                                                        }
                                                    }
                                                    i[k >> 2] = e;
                                                    break e;
                                                }
                                                e = i[k >> 2];
                                            }
                                            y = (e | 0) != (f | 0);
                                            break i;
                                        }
                                        n = i[u >> 2];
                                        continue;
                                    }
                                    break;
                                }
                                y = 2;
                            }
                            return m = B + 16 | 0, y | 0;
                        }
                        function X5(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0;
                            A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n;
                            i: {
                                e: {
                                    r: {
                                        for(;;){
                                            A: {
                                                if (n = i[A + 12 >> 2], n >>> 0 >= f >>> 0 || (w = i[A + 8 >> 2], w >>> 0 >= t >>> 0)) break A;
                                                r = 2, s = l[n | 0];
                                                f: {
                                                    if (s << 24 >> 24 >= 0) {
                                                        Q[w >> 1] = s, r = n + 1 | 0;
                                                        break f;
                                                    }
                                                    if (s >>> 0 < 194) break e;
                                                    if (s >>> 0 <= 223) {
                                                        if (e = 1, (f - n | 0) < 2) break i;
                                                        if (e = l[n + 1 | 0], (e & 192) != 128) break r;
                                                        Q[w >> 1] = e & 63 | s << 6 & 1984, r = n + 2 | 0;
                                                        break f;
                                                    }
                                                    if (s >>> 0 <= 239) {
                                                        if (r = 1, h = f - n | 0, (h | 0) < 2) break r;
                                                        e = l[n + 1 | 0];
                                                        k: {
                                                            n: {
                                                                if ((s | 0) != 237) {
                                                                    if ((s | 0) != 224) break n;
                                                                    if ((e & 224) != 160) break e;
                                                                    break k;
                                                                }
                                                                if ((e & 224) != 128) break e;
                                                                break k;
                                                            }
                                                            if ((e & 192) != 128) break e;
                                                        }
                                                        if ((h | 0) == 2) break r;
                                                        if (r = l[n + 2 | 0], (r & 192) != 128) break e;
                                                        Q[w >> 1] = r & 63 | ((e & 63) << 6 | s << 12), r = n + 3 | 0;
                                                        break f;
                                                    }
                                                    if (s >>> 0 > 244) break e;
                                                    if (r = 1, h = f - n | 0, (h | 0) < 2) break r;
                                                    e = l[n + 1 | 0];
                                                    k: {
                                                        n: switch(s - 240 | 0){
                                                            case 0:
                                                                if ((e + 112 & 255) >>> 0 >= 48) break e;
                                                                break k;
                                                            case 4:
                                                                if ((e & 240) != 128) break e;
                                                                break k;
                                                            default:
                                                                break n;
                                                        }
                                                        if ((e & 192) != 128) break e;
                                                    }
                                                    if ((h | 0) == 2) break r;
                                                    if (v = l[n + 2 | 0], (v & 192) != 128) break e;
                                                    if ((h | 0) == 3) break r;
                                                    if (n = l[n + 3 | 0], (n & 192) != 128) break e;
                                                    if ((t - w | 0) < 3 || (r = 2, n = n & 63, h = v << 6, s = s & 7, (n | (h & 4032 | (e << 12 & 258048 | s << 18))) >>> 0 > 1114111)) break r;
                                                    r = e << 2, Q[w >> 1] = (v >>> 4 & 3 | (r & 192 | s << 8 | r & 60)) + 16320 | 55296, i[A + 8 >> 2] = w + 2, Q[w + 2 >> 1] = n | h & 960 | 56320, r = i[A + 12 >> 2] + 4 | 0;
                                                }
                                                i[A + 12 >> 2] = r, i[A + 8 >> 2] = i[A + 8 >> 2] + 2;
                                                continue;
                                            }
                                            break;
                                        }
                                        r = f >>> 0 > n >>> 0;
                                    }
                                    e = r;
                                    break i;
                                }
                                e = 2;
                            }
                            return i[k >> 2] = i[A + 12 >> 2], i[u >> 2] = i[A + 8 >> 2], m = A + 16 | 0, e | 0;
                        }
                        function bv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            f = m - 80 | 0, m = f, o[f + 56 | 0] = 0, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, k = i[r + 20 >> 2], i[f + 40 >> 2] = i[k + 48 >> 2], k = i[k + 52 >> 2], i[f + 44 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = i[r + 36 >> 2], n = i[f + 44 >> 2], i[f >> 2] = i[f + 40 >> 2], i[f + 4 >> 2] = n, i6(f + 48 | 0, f, k), p[i[i[r >> 2] + 76 >> 2]](f + 12 | 0, r);
                            i: {
                                if (i[f + 20 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[f + 24 >> 2], i[A + 8 >> 2] = i[f + 20 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[f + 39 | 0] >= 0) {
                                        r = i[f + 32 >> 2], i[A >> 2] = i[f + 28 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[f + 36 >> 2];
                                        break i;
                                    }
                                    j(A, i[f + 28 >> 2], i[f + 32 >> 2]);
                                    break i;
                                }
                                r = i[f + 12 >> 2], k = i[f + 16 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), u = i[f + 68 >> 2], i[f + 68 >> 2] = 0, t = i[f + 52 >> 2], n = i[f + 48 >> 2], i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, s = i[f + 60 >> 2], h = i[f + 64 >> 2], i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, w = i[f + 72 >> 2], v = l[f + 56 | 0], i[r + 4 >> 2] = n, n = i[r + 8 >> 2], i[r + 8 >> 2] = t;
                                e: {
                                    if (!n || (t = i[n + 4 >> 2], i[n + 4 >> 2] = t - 1, t)) break e;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                if (o[r + 12 | 0] = v, n = i[r + 16 >> 2], n && (i[r + 20 >> 2] = n, X(n)), i[r + 28 >> 2] = w, i[r + 24 >> 2] = u, i[r + 20 >> 2] = h, i[r + 16 >> 2] = s, p[i[i[r >> 2] + 28 >> 2]](A, r, e), !k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            o[f + 39 | 0] < 0 && X(i[f + 28 >> 2]), A = i[f + 16 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[f + 60 >> 2], A && (i[f + 64 >> 2] = A, X(A)), A = i[f + 52 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = f + 80 | 0;
                        }
                        function p5(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0;
                            r = i[A + 4 >> 2], k = i[r + 124 >> 2], i[A + 24 >> 2] = k, s = i[r + 132 >> 2], i[A + 28 >> 2] = s;
                            i: {
                                if (!i[A + 12 >> 2]) {
                                    f = 1, h = 1;
                                    break i;
                                }
                                f = i[k + 16856 >> 2], h = i[k + 16852 >> 2];
                            }
                            i[A + 300 >> 2] = f, i[A + 296 >> 2] = h, G = Z(i[A + 20 >> 2], f), W = i[k + 16892 >> 2], n = i[k + 16876 >> 2], e = i[A + 16 >> 2], C = Z(e, h), C || (o[A + 307 | 0] = 0, o[A + 304 | 0] = 0), G || (o[A + 307 | 0] = 0, o[A + 305 | 0] = 0, o[A + 306 | 0] = 0), V = i[A + 8 >> 2], w = Z(e + V | 0, h), (w | 0) >= i[k + 484 >> 2] && (o[A + 306 | 0] = 0), t = i[r + 140 >> 2], u = i[r + 152 >> 2], v = G >> n, E = t + Z(Z(u, v), 24) | 0, R = -1, e = C - 1 >> n, y = -1, _ = l[A + 304 | 0], y = (_ | 0) == 1 ? I[Z(e, 24) + E >> 1] : y, F = C >> n, r = G - 1 >> n, B = l[A + 305 | 0], (B | 0) == 1 && (R = I[(t + Z(Z(r, u), 24) | 0) + Z(F, 24) >> 1]), w = w >> n, M = -1, H = -1, T = l[A + 306 | 0], (T | 0) == 1 && (H = I[(t + Z(Z(r, u), 24) | 0) + Z(w, 24) >> 1]), S = l[A + 307 | 0], (S | 0) == 1 && (M = I[(t + Z(Z(r, u), 24) | 0) + Z(e, 24) >> 1]), u = Z(W, v) << 2, n = i[s + 8484 >> 2], t = -1, s = -1, s = _ ? i[u + (n + (e << 2) | 0) >> 2] : s, v = n + (F << 2) | 0, t = B ? i[v + (Z(r, W) << 2) >> 2] : t, _ = -1, B = -1, S && (B = i[(n + (e << 2) | 0) + (Z(r, W) << 2) >> 2]), e = I[Z(F, 24) + E >> 1], T && (_ = i[(n + (w << 2) | 0) + (Z(r, W) << 2) >> 2]), r = i[u + v >> 2], (e | 0) == (y | 0) & (r | 0) == (s | 0) || (o[A + 304 | 0] = 0), (e | 0) == (R | 0) & (r | 0) == (t | 0) || (o[A + 305 | 0] = 0), (e | 0) == (M | 0) & (r | 0) == (B | 0) || (o[A + 307 | 0] = 0), (e | 0) == (H | 0) & (r | 0) == (_ | 0) || (o[A + 306 | 0] = 0), f = (i[k + 488 >> 2] + ((G ^ -1) + f | 0) | 0) / (f | 0) | 0, r = V << 1, i[A + 308 >> 2] = (r | 0) > (f | 0) ? f : r, k = i[k + 484 >> 2], i[A + 316 >> 2] = 0, f = A + 160 | 0, i[A + 292 >> 2] = f, e = A, A = (k + ((C ^ -1) + h | 0) | 0) / (h | 0) | 0, i[e + 312 >> 2] = (A | 0) < (r | 0) ? A : r, B0(f - r | 0, 0, V << 2 | 1);
                        }
                        function dv(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, f = i[A + 8 >> 2], i[t + 12 >> 2] = 0, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0;
                            i: {
                                e: {
                                    r: {
                                        n = i[f + 12 >> 2], s = i[f + 16 >> 2];
                                        A: {
                                            if ((n | 0) == (s | 0)) {
                                                f = 0;
                                                break A;
                                            }
                                            if (f = s - n | 0, (f | 0) < 0) break r;
                                            for(k = D(f), i[t + 4 >> 2] = k, i[t + 12 >> 2] = f + k, f = k; i[f >> 2] = i[n >> 2], u = i[n + 4 >> 2], i[f + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), f = f + 8 | 0, n = n + 8 | 0, (s | 0) != (n | 0););
                                            i[t + 8 >> 2] = f;
                                        }
                                        if (f = f - k >> 3, u = (e | 0) > (f | 0) ? f : e, (u | 0) <= 0) break i;
                                        for(n = 0;;){
                                            e = D(24), i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, f = i[A >> 2], k = i[A + 4 >> 2];
                                            A: {
                                                if (!k) {
                                                    i[e + 4 >> 2] = k, i[e >> 2] = f;
                                                    break A;
                                                }
                                                if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, i[e >> 2] = f, f = i[e + 4 >> 2], i[e + 4 >> 2] = k, !f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            f = i[A + 8 >> 2], k = i[A + 12 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[e + 8 >> 2] = f, f = i[e + 12 >> 2], i[e + 12 >> 2] = k;
                                            A: {
                                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            f = i[t + 4 >> 2] + (n << 3) | 0, s = i[f >> 2], k = i[f + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[e + 16 >> 2] = s, f = i[e + 20 >> 2], i[e + 20 >> 2] = k;
                                            A: {
                                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break A;
                                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                            }
                                            if (i[(n << 2) + r >> 2] = e, n = n + 1 | 0, (u | 0) == (n | 0)) break;
                                        }
                                        break e;
                                    }
                                    p0(), z();
                                }
                                k = i[t + 4 >> 2];
                            }
                            if (k) {
                                if (f = i[t + 8 >> 2], (k | 0) != (f | 0)) {
                                    for(;;){
                                        A = i[f - 4 >> 2];
                                        i: {
                                            if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (f = f - 8 | 0, (k | 0) == (f | 0)) break;
                                    }
                                    k = i[t + 4 >> 2];
                                }
                                X(k);
                            }
                            return m = t + 16 | 0, u | 0;
                        }
                        function i4(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            G = i[A + 18592 >> 2], v = A + 18548 | 0, w = s2(v, i[A + 18572 >> 2] + 147 | 0), _ = w << 4 & 16 | l[A + 26 | 0] & -17, o[A + 26 | 0] = _, W = A + 16 | 0;
                            i: {
                                e: {
                                    if (w) {
                                        w = 0;
                                        r: {
                                            if (i[i[A + 18592 >> 2] + 812 >> 2] < 2 || !s2(v, i[A + 18572 >> 2] + 148 | 0) || (w = 32, i[i[A + 18592 >> 2] + 812 >> 2] < 3)) break r;
                                            for(w = 1; S1(v) && (w = w + 1 | 0, (w | 0) < (i[i[A + 18592 >> 2] + 812 >> 2] - 1 | 0)););
                                            w = w << 5;
                                        }
                                        u = l[A + 26 | 0] & 31 | w;
                                        break e;
                                    }
                                    w = 1;
                                    r: {
                                        A: {
                                            f: {
                                                if (!i[G + 28 >> 2]) {
                                                    if (w = i[A + 18572 >> 2], (n + t | 0) == 12 || !s2(v, (u + w | 0) + 156 | 0)) break f;
                                                    _ = l[A + 26 | 0], w = 3;
                                                }
                                                o[A + 26 | 0] = _ & 252 | w;
                                                break A;
                                            }
                                            if (w = s2(v, w + 160 | 0) + 1 | 0, o[A + 26 | 0] = w & 3 | l[A + 26 | 0] & 252, _ = 2, (w | 0) == 2) break r;
                                        }
                                        _ = w, w = 0, u = i[G + 336 >> 2];
                                        A: {
                                            if ((u | 0) < 2 || !s2(v, i[A + 18572 >> 2] + 154 | 0)) break A;
                                            if (B = u - 2 | 0, !B) {
                                                w = 1;
                                                break A;
                                            }
                                            if (w = 1, !s2(v, i[A + 18572 >> 2] + 155 | 0)) break A;
                                            for(u = u - 1 | 0;;){
                                                if ((w | 0) == (B | 0)) {
                                                    w = u;
                                                    break A;
                                                }
                                                if (w = w + 1 | 0, !S1(v)) break;
                                            }
                                        }
                                        if (o[A + 16 | 0] = w, Z9(A, 0), C = A, V = s2(v, i[A + 18572 >> 2] + 152 | 0) << 2 & 4 | l[A + 26 | 0] & 251, o[C + 26 | 0] = V, (_ | 0) == 1) break i;
                                    }
                                    w = 0, u = i[G + 340 >> 2];
                                    r: {
                                        if ((u | 0) < 2 || !s2(v, i[A + 18572 >> 2] + 154 | 0)) break r;
                                        if (B = u - 2 | 0, !B) {
                                            w = 1;
                                            break r;
                                        }
                                        if (w = 1, !s2(v, i[A + 18572 >> 2] + 155 | 0)) break r;
                                        for(u = u - 1 | 0;;){
                                            if ((w | 0) == (B | 0)) {
                                                w = u;
                                                break r;
                                            }
                                            if (w = w + 1 | 0, !S1(v)) break;
                                        }
                                    }
                                    o[A + 17 | 0] = w;
                                    r: {
                                        if (!(!l[G + 378 | 0] | (_ | 0) != 3)) {
                                            Q[A + 22 >> 1] = 0, Q[A + 24 >> 1] = 0;
                                            break r;
                                        }
                                        Z9(A, 1);
                                    }
                                    u = s2(v, i[A + 18572 >> 2] + 152 | 0) << 3 & 8 | l[A + 26 | 0] & -9;
                                }
                                o[A + 26 | 0] = u;
                            }
                            m7(i[A + 18584 >> 2], i[A + 18592 >> 2], i[A + 18588 >> 2], W, r, e, f, k, s, n, t, h);
                        }
                        function cv(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, r = m - 48 | 0, m = r, e = D(32), i[r + 12 >> 2] = e, i[r + 16 >> 2] = 29, i[r + 20 >> 2] = -2147483616, f = l[21068] | l[21069] << 8 | (l[21070] << 16 | l[21071] << 24), k = l[21064] | l[21065] << 8 | (l[21066] << 16 | l[21067] << 24), o[e + 21 | 0] = k, o[e + 22 | 0] = k >>> 8, o[e + 23 | 0] = k >>> 16, o[e + 24 | 0] = k >>> 24, o[e + 25 | 0] = f, o[e + 26 | 0] = f >>> 8, o[e + 27 | 0] = f >>> 16, o[e + 28 | 0] = f >>> 24, f = l[21063] | l[21064] << 8 | (l[21065] << 16 | l[21066] << 24), k = l[21059] | l[21060] << 8 | (l[21061] << 16 | l[21062] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[21055] | l[21056] << 8 | (l[21057] << 16 | l[21058] << 24), k = l[21051] | l[21052] << 8 | (l[21053] << 16 | l[21054] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[21047] | l[21048] << 8 | (l[21049] << 16 | l[21050] << 24), k = l[21043] | l[21044] << 8 | (l[21045] << 16 | l[21046] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 29 | 0] = 0, e = i0(r + 24 | 0, 4, 0, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                            i: {
                                if (o[e + 19 | 0] >= 0) {
                                    f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                    break i;
                                }
                                if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), m = r + 48 | 0;
                        }
                        function i_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, r = m - 48 | 0, m = r, e = D(32), i[r + 12 >> 2] = e, i[r + 16 >> 2] = 29, i[r + 20 >> 2] = -2147483616, f = l[21038] | l[21039] << 8 | (l[21040] << 16 | l[21041] << 24), k = l[21034] | l[21035] << 8 | (l[21036] << 16 | l[21037] << 24), o[e + 21 | 0] = k, o[e + 22 | 0] = k >>> 8, o[e + 23 | 0] = k >>> 16, o[e + 24 | 0] = k >>> 24, o[e + 25 | 0] = f, o[e + 26 | 0] = f >>> 8, o[e + 27 | 0] = f >>> 16, o[e + 28 | 0] = f >>> 24, f = l[21033] | l[21034] << 8 | (l[21035] << 16 | l[21036] << 24), k = l[21029] | l[21030] << 8 | (l[21031] << 16 | l[21032] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[21025] | l[21026] << 8 | (l[21027] << 16 | l[21028] << 24), k = l[21021] | l[21022] << 8 | (l[21023] << 16 | l[21024] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[21017] | l[21018] << 8 | (l[21019] << 16 | l[21020] << 24), k = l[21013] | l[21014] << 8 | (l[21015] << 16 | l[21016] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 29 | 0] = 0, e = i0(r + 24 | 0, 4, 0, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                            i: {
                                if (o[e + 19 | 0] >= 0) {
                                    f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                    break i;
                                }
                                if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), m = r + 48 | 0;
                        }
                        function e_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, r = m - 48 | 0, m = r, e = D(32), i[r + 12 >> 2] = e, i[r + 16 >> 2] = 29, i[r + 20 >> 2] = -2147483616, f = l[21128] | l[21129] << 8 | (l[21130] << 16 | l[21131] << 24), k = l[21124] | l[21125] << 8 | (l[21126] << 16 | l[21127] << 24), o[e + 21 | 0] = k, o[e + 22 | 0] = k >>> 8, o[e + 23 | 0] = k >>> 16, o[e + 24 | 0] = k >>> 24, o[e + 25 | 0] = f, o[e + 26 | 0] = f >>> 8, o[e + 27 | 0] = f >>> 16, o[e + 28 | 0] = f >>> 24, f = l[21123] | l[21124] << 8 | (l[21125] << 16 | l[21126] << 24), k = l[21119] | l[21120] << 8 | (l[21121] << 16 | l[21122] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[21115] | l[21116] << 8 | (l[21117] << 16 | l[21118] << 24), k = l[21111] | l[21112] << 8 | (l[21113] << 16 | l[21114] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[21107] | l[21108] << 8 | (l[21109] << 16 | l[21110] << 24), k = l[21103] | l[21104] << 8 | (l[21105] << 16 | l[21106] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 29 | 0] = 0, e = i0(r + 24 | 0, 4, 0, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                            i: {
                                if (o[e + 19 | 0] >= 0) {
                                    f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                    break i;
                                }
                                if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), m = r + 48 | 0;
                        }
                        function r_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, r = m - 48 | 0, m = r, e = D(32), i[r + 12 >> 2] = e, i[r + 16 >> 2] = 29, i[r + 20 >> 2] = -2147483616, f = l[21098] | l[21099] << 8 | (l[21100] << 16 | l[21101] << 24), k = l[21094] | l[21095] << 8 | (l[21096] << 16 | l[21097] << 24), o[e + 21 | 0] = k, o[e + 22 | 0] = k >>> 8, o[e + 23 | 0] = k >>> 16, o[e + 24 | 0] = k >>> 24, o[e + 25 | 0] = f, o[e + 26 | 0] = f >>> 8, o[e + 27 | 0] = f >>> 16, o[e + 28 | 0] = f >>> 24, f = l[21093] | l[21094] << 8 | (l[21095] << 16 | l[21096] << 24), k = l[21089] | l[21090] << 8 | (l[21091] << 16 | l[21092] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[21085] | l[21086] << 8 | (l[21087] << 16 | l[21088] << 24), k = l[21081] | l[21082] << 8 | (l[21083] << 16 | l[21084] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, f = l[21077] | l[21078] << 8 | (l[21079] << 16 | l[21080] << 24), k = l[21073] | l[21074] << 8 | (l[21075] << 16 | l[21076] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 29 | 0] = 0, e = i0(r + 24 | 0, 4, 0, r + 12 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[e + 4 >> 2], i[A + 32 >> 2] = i[e >> 2], i[A + 36 >> 2] = f, A = A + 40 | 0;
                            i: {
                                if (o[e + 19 | 0] >= 0) {
                                    f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[e + 16 >> 2];
                                    break i;
                                }
                                if (j(A, i[e + 8 >> 2], i[e + 12 >> 2]), o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), m = r + 48 | 0;
                        }
                        function Q5(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            G = m - 16 | 0, m = G, _ = i[A + 12 >> 2], h = i[A + 8 >> 2], w = _ - h >> 2;
                            i: {
                                if ((h | 0) != (_ | 0)) for(v = w >>> 0 <= 1 ? 1 : w;;){
                                    if (u = i[h + (s << 2) >> 2], !(l[u + 104 | 0] | i[u + 100 >> 2])) {
                                        a3(u), _ = i[A + 12 >> 2], w = _ - i[A + 8 >> 2] >> 2;
                                        break i;
                                    }
                                    if (s = s + 1 | 0, (v | 0) == (s | 0)) break;
                                }
                                s = -9;
                            }
                            i: {
                                if ((w - 1 | 0) == (s | 0) | k0[A + 4 >> 2] >= w >>> 0 || (h = i[_ - 4 >> 2], l[h + 104 | 0] | i[h + 100 >> 2])) break i;
                                X(K3(h)), _ = i[A + 12 >> 2] - 4 | 0, i[A + 12 >> 2] = _;
                            }
                            i: {
                                e: {
                                    r: {
                                        if ((s | 0) == -9) {
                                            W = i[A + 8 >> 2], w = Tn(D(416)), s = i[A + 12 >> 2], u = i[A + 16 >> 2];
                                            A: {
                                                if (s >>> 0 < u >>> 0) {
                                                    i[s >> 2] = w, w = s + 4 | 0;
                                                    break A;
                                                }
                                                if (v = i[A + 8 >> 2], B = s - v >> 2, h = B + 1 | 0, h >>> 0 >= 1073741824) break r;
                                                if (C = B << 2, u = u - v | 0, B = u >> 1, B = u >>> 0 >= 2147483644 ? 1073741823 : h >>> 0 < B >>> 0 ? B : h, B) {
                                                    if (B >>> 0 >= 1073741824) break e;
                                                    h = D(B << 2);
                                                } else h = 0;
                                                if (u = C + h | 0, i[u >> 2] = w, w = u + 4 | 0, (s | 0) != (v | 0)) {
                                                    for(; u = u - 4 | 0, s = s - 4 | 0, i[u >> 2] = i[s >> 2], (s | 0) != (v | 0););
                                                    v = i[A + 8 >> 2];
                                                }
                                                if (i[A + 16 >> 2] = h + (B << 2), i[A + 12 >> 2] = w, i[A + 8 >> 2] = u, !v) break A;
                                                X(v);
                                            }
                                            i[A + 12 >> 2] = w, s = _ - W >> 2;
                                        }
                                        A: {
                                            if ((s | 0) < 0) {
                                                u = i[r + 4 >> 2];
                                                break A;
                                            }
                                            if (h = i[r >> 2], w = i[h + 476 >> 2], w >>> 0 >= 4) break i;
                                            if (A = i[i[A + 8 >> 2] + (s << 2) >> 2], v = i[h + 488 >> 2], _ = i[h + 484 >> 2], i[G + 8 >> 2] = h, u = i[r + 4 >> 2], i[G + 12 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), r = i[G + 12 >> 2], i[G >> 2] = i[G + 8 >> 2], i[G + 4 >> 2] = r, r = z7(A, _, v, w, G, 1, e, f, k, n, t), r) {
                                                s = 0 - r | 0;
                                                break A;
                                            }
                                            o[A + 312 | 0] = 0;
                                        }
                                        A: {
                                            if (!u || (A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A)) break A;
                                            p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                        }
                                        return m = G + 16 | 0, s;
                                    }
                                    p0(), z();
                                }
                                Z2(), z();
                            }
                            y0(18461, 15078, 263, 11443), z();
                        }
                        function C5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e = i[A + 4 >> 2];
                                e: {
                                    if (e >>> 0 < r >>> 0) {
                                        t = r - e | 0, n = i[A + 8 >> 2], f = n << 5;
                                        r: {
                                            if (!(t >>> 0 > f >>> 0 | e >>> 0 > f - t >>> 0)) {
                                                i[A + 4 >> 2] = r, f = e & 31, r = i[A >> 2] + (e >>> 3 & 536870908) | 0;
                                                break r;
                                            }
                                            if (i[k + 12 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, (r | 0) < 0) break i;
                                            A: {
                                                if (f >>> 0 <= 1073741822 ? (e = n << 6, r = r + 31 & -32, r = r >>> 0 < e >>> 0 ? e : r) : r = 2147483647, r >>> 0 <= i[k + 12 >> 2] << 5 >>> 0) break A;
                                                if ((r | 0) >= 0) {
                                                    if (w = (r - 1 >>> 5 | 0) + 1 | 0, n = D(w << 2), f = i[k + 4 >> 2], r = i[k + 8 >> 2], i[n + ((r >>> 0 >= 33 ? r - 1 >>> 5 | 0 : 0) << 2) >> 2] = 0, r) for(v = r & 31, _ = f + (r >>> 3 & 536870908) | 0, r = n, e = f; u = 1 << s, i[e >> 2] >>> h & 1 ? u = u | i[r >> 2] : u = i[r >> 2] & (u ^ -1), i[r >> 2] = u, u = (s | 0) == 31, s = u ? 0 : s + 1 | 0, r = (u << 2) + r | 0, u = (h | 0) == 31, e = (u << 2) + e | 0, h = u ? 0 : h + 1 | 0, !!((v | 0) != (h | 0) | (e | 0) != (_ | 0)););
                                                    if (i[k + 12 >> 2] = w, i[k + 4 >> 2] = n, !f) break A;
                                                    X(f);
                                                    break A;
                                                }
                                                p0(), z();
                                            }
                                            f = i[A + 4 >> 2], i[k + 8 >> 2] = f + t, e = i[A >> 2], r = i[k + 4 >> 2];
                                            A: {
                                                if ((f | 0) <= 0) {
                                                    f = 0;
                                                    break A;
                                                }
                                                n = f >>> 5 | 0, f >>> 0 >= 32 && Q0(r, e, n << 2), n = n << 2, r = n + r | 0, f = f & 31, f && (s = -1 >>> 32 - f | 0, i[r >> 2] = i[r >> 2] & (s ^ -1) | s & i[e + n >> 2]), e = i[A >> 2];
                                            }
                                            if (i[A >> 2] = i[k + 4 >> 2], i[k + 4 >> 2] = e, n = i[A + 4 >> 2], i[A + 4 >> 2] = i[k + 8 >> 2], i[k + 8 >> 2] = n, n = i[A + 8 >> 2], i[A + 8 >> 2] = i[k + 12 >> 2], i[k + 12 >> 2] = n, !e) break r;
                                            X(e);
                                        }
                                        if (!t || (f && (A = 32 - f | 0, e = A >>> 0 < t >>> 0 ? A : t, i[r >> 2] = i[r >> 2] & (-1 << f & -1 >>> A - e ^ -1), t = t - e | 0, r = r + 4 | 0), A = t >>> 5 | 0, t >>> 0 >= 32 && B0(r, 0, A << 2), e = t & 31, !e)) break e;
                                        A = (A << 2) + r | 0, i[A >> 2] = i[A >> 2] & (-1 >>> 32 - e ^ -1);
                                        break e;
                                    }
                                    i[A + 4 >> 2] = r;
                                }
                                m = k + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function A_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = i[r + 12 >> 2];
                            i: {
                                if (!k & k0[r + 8 >> 2] >= k0[r + 32 >> 2] | k) {
                                    k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), e = U(f + 12 | 0, 23320, 22), k = i[r + 8 >> 2], n = i[r + 32 >> 2], U(K1(e, k - n | 0, i[r + 12 >> 2] - (k >>> 0 < n >>> 0) | 0), 34895, 1);
                                    break i;
                                }
                                r = f + 148 | 0, G0(r, e), k = r, r = o[f + 159 | 0], e = (r | 0) < 0, U(f + 12 | 0, e ? i[f + 148 >> 2] : k, e ? i[f + 152 >> 2] : r), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 25765, 32);
                            }
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function f_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            for(A = m - 272 | 0, m = A, i[A + 264 >> 2] = e, i[A + 268 >> 2] = r, BA(A + 208 | 0, f, A + 224 | 0, A + 223 | 0, A + 222 | 0), e = m - 16 | 0, m = e, r = A + 196 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 192 >> 2] = e, i[A + 28 >> 2] = A + 32, i[A + 24 >> 2] = 0, o[A + 23 | 0] = 1, o[A + 22 | 0] = 69;;){
                                i: {
                                    if (T2(A + 268 | 0, A + 264 | 0)) break i;
                                    t = i[A + 192 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 192 >> 2] = f + e), t = A + 268 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[u | 0];
                                    }
                                    if (E3(f << 24 >> 24, A + 23 | 0, A + 22 | 0, e, A + 192 | 0, o[A + 223 | 0], o[A + 222 | 0], A + 208 | 0, A + 32 | 0, A + 28 | 0, A + 24 | 0, A + 224 | 0)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 219 | 0] >>> 7 | 0 ? f = i[A + 212 >> 2] : f = l[A + 219 | 0] & 127;
                            i: {
                                if (!f | l[A + 23 | 0] != 1 || (f = i[A + 28 >> 2], (f - (A + 32 | 0) | 0) > 159)) break i;
                                i[A + 28 >> 2] = f + 4, i[f >> 2] = i[A + 24 >> 2];
                            }
                            return An(A, e, i[A + 192 >> 2], k), e = i[A >> 2], f = i[A + 4 >> 2], t = i[A + 12 >> 2], i[n + 8 >> 2] = i[A + 8 >> 2], i[n + 12 >> 2] = t, i[n >> 2] = e, i[n + 4 >> 2] = f, L1(A + 208 | 0, A + 32 | 0, i[A + 28 >> 2], k), T2(A + 268 | 0, A + 264 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 268 >> 2], a0(r), a0(A + 208 | 0), m = A + 272 | 0, e | 0;
                        }
                        function k_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            s = m - 32 | 0, m = s, u = i[r + 104 >> 2], n = i[r + 108 >> 2];
                            i: {
                                if ((u | 0) == (n | 0)) break i;
                                for(;;){
                                    e: {
                                        if (l[u + 4 | 0] != 1 || (f = i[u + 16 >> 2], t = i[u + 20 >> 2], (f | 0) == (t | 0))) break e;
                                        for(; k = (i[f + 28 >> 2] + k | 0) - i[f + 24 >> 2] | 0, f = f + 40 | 0, (t | 0) != (f | 0););
                                    }
                                    if (u = u + 32 | 0, (n | 0) == (u | 0)) break;
                                }
                                if (!k || (l2(e, k + 8 | 0), l2(e, 1768186228), k = i[r + 104 >> 2], n = i[r + 108 >> 2], (k | 0) == (n | 0))) break i;
                                for(;;){
                                    e: {
                                        if (l[k + 4 | 0] != 1 || (f = i[k + 16 >> 2], t = i[k + 20 >> 2], (f | 0) == (t | 0))) break e;
                                        for(; G4(e, f + 24 | 0), f = f + 40 | 0, (t | 0) != (f | 0););
                                    }
                                    if (k = k + 32 | 0, (n | 0) == (k | 0)) break;
                                }
                            }
                            if (h = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, i[r + 116 >> 2] = i[e + 12 >> 2], n = l[r + 97 | 0], t = n >>> 0 < 2, k = t ? 4 : 6, f = i[r + 104 >> 2], w = i[r + 108 >> 2], (f | 0) != (w | 0)) for(v = l[r + 123 | 0], _ = (((n | 0) != 0) << 1) + (t ? 6 : 8) | 0, u = (n ? l[r + 124 | 0] : 0) & 255, n = l[r + 121 | 0], t = l[r + 122 | 0], B = ((v + (_ + u | 0) | 0) + n | 0) + t | 0, u = t + (n + u | 0) | 0; n = i[f + 16 >> 2], t = i[f + 20 >> 2], (n | 0) == (t | 0) ? k = (k + _ | 0) + v | 0 : k = (k + B | 0) + Z(u, ((t - n | 0) - 40 >>> 0) / 40 | 0) | 0, f = f + 32 | 0, (w | 0) != (f | 0););
                            fr(e, k), i[e + 12 >> 2] = h, p[i[i[r >> 2] + 48 >> 2]](s + 12 | 0, r, e, i[e + 4 >> 2] - (h + i[e >> 2] | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[s + 31 | 0] < 0 && X(i[s + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, r = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    A = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = A, i[r + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(r, i[21670], i[21671]);
                            }
                            m = s + 32 | 0;
                        }
                        function n_(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 80 | 0, m = k, p[i[i[r >> 2] + 76 >> 2]](k + 52 | 0, r);
                            i: {
                                if (i[k + 60 >> 2]) {
                                    if (r = i[k + 64 >> 2], i[A >> 2] = i[k + 60 >> 2], i[A + 4 >> 2] = r, A = A + 8 | 0, o[k + 79 | 0] >= 0) {
                                        r = i[k + 72 >> 2], i[A >> 2] = i[k + 68 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[k + 76 >> 2];
                                        break i;
                                    }
                                    j(A, i[k + 68 >> 2], i[k + 72 >> 2]);
                                    break i;
                                }
                                t = i[k + 52 >> 2], n = i[k + 56 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), p[i[i[t >> 2] + 20 >> 2]](k + 32 | 0, t, e, f);
                                e: {
                                    if (i[k + 32 >> 2]) {
                                        r = i[k + 36 >> 2], i[A >> 2] = i[k + 32 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 48 >> 2], r = i[k + 44 >> 2], i[A + 8 >> 2] = i[k + 40 >> 2], i[A + 12 >> 2] = r, i[k + 48 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0;
                                        break e;
                                    }
                                    r: {
                                        if (i[e >> 2] || (t = i[r + 192 >> 2], r = i[r + 196 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), I[t + 8 >> 1] | !t || (i[e >> 2] = 1, i[f >> 2] = 3), !r) || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    r = i[21669], i[k + 8 >> 2] = i[21668], i[k + 12 >> 2] = r, r = k + 16 | 0;
                                    r: {
                                        if (o[86691] >= 0) {
                                            e = i[21671], i[r >> 2] = i[21670], i[r + 4 >> 2] = e, i[r + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(r, i[21670], i[21671]);
                                    }
                                    if (o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                if (o[k + 51 | 0] < 0 && X(i[k + 40 >> 2]), !n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            o[k + 79 | 0] < 0 && X(i[k + 68 >> 2]), A = i[k + 56 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = k + 80 | 0;
                        }
                        function t_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            for(A = m - 384 | 0, m = A, i[A + 376 >> 2] = e, i[A + 380 >> 2] = r, _A(A + 220 | 0, f, A + 240 | 0, A + 236 | 0, A + 232 | 0), e = m - 16 | 0, m = e, r = A + 208 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 204 >> 2] = e, i[A + 28 >> 2] = A + 32, i[A + 24 >> 2] = 0, o[A + 23 | 0] = 1, o[A + 22 | 0] = 69;;){
                                i: {
                                    if (S2(A + 380 | 0, A + 376 | 0)) break i;
                                    t = i[A + 204 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 204 >> 2] = f + e), t = A + 380 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[u >> 2];
                                    }
                                    if (Y3(f, A + 23 | 0, A + 22 | 0, e, A + 204 | 0, i[A + 236 >> 2], i[A + 232 >> 2], A + 220 | 0, A + 32 | 0, A + 28 | 0, A + 24 | 0, A + 240 | 0)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 231 | 0] >>> 7 | 0 ? f = i[A + 224 >> 2] : f = l[A + 231 | 0] & 127;
                            i: {
                                if (!f | l[A + 23 | 0] != 1 || (f = i[A + 28 >> 2], (f - (A + 32 | 0) | 0) > 159)) break i;
                                i[A + 28 >> 2] = f + 4, i[f >> 2] = i[A + 24 >> 2];
                            }
                            return An(A, e, i[A + 204 >> 2], k), e = i[A >> 2], f = i[A + 4 >> 2], t = i[A + 12 >> 2], i[n + 8 >> 2] = i[A + 8 >> 2], i[n + 12 >> 2] = t, i[n >> 2] = e, i[n + 4 >> 2] = f, L1(A + 220 | 0, A + 32 | 0, i[A + 28 >> 2], k), S2(A + 380 | 0, A + 376 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 380 >> 2], a0(r), a0(A + 220 | 0), m = A + 384 | 0, e | 0;
                        }
                        function J0(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0;
                            u = m + -64 | 0, m = u, i[u + 40 >> 2] = 0, i[u + 44 >> 2] = 0, i[u + 48 >> 2] = 0, i[u + 52 >> 2] = 0, i[u + 56 >> 2] = 0, i[u + 32 >> 2] = 0, i[u + 36 >> 2] = 0, Q[u + 28 >> 1] = 256, i[u + 24 >> 2] = 1, h = u + 24 | 0, w = k, s = i[r + 36 >> 2], k = (n | 0) == 24 && (s | 0) == 10 ? 8 : n, n = (s | 0) == 11 && (k | 0) == 32 ? 8 : k, k = 1;
                            i: {
                                e: switch(s | 0){
                                    case 10:
                                    case 12:
                                    case 14:
                                        k = 3;
                                        break i;
                                    case 11:
                                    case 13:
                                    case 15:
                                        k = 4;
                                        break i;
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 99:
                                        break i;
                                    default:
                                        break e;
                                }
                                k = 0;
                            }
                            Ve(u, h, f, w, 1, n, k, t);
                            i: {
                                if (i[u >> 2]) {
                                    r = i[u + 4 >> 2], i[A >> 2] = i[u >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[u + 16 >> 2], r = i[u + 12 >> 2], i[A + 8 >> 2] = i[u + 8 >> 2], i[A + 12 >> 2] = r, i[u + 16 >> 2] = 0, i[u + 8 >> 2] = 0, i[u + 12 >> 2] = 0;
                                    break i;
                                }
                                f = i[r + 64 >> 2];
                                e: {
                                    r: {
                                        if (!f) {
                                            t = r - -64 | 0, n = t;
                                            break r;
                                        }
                                        for(;;){
                                            if (n = f, k = i[f + 16 >> 2], (k | 0) > (e | 0)) {
                                                if (t = f, f = i[f >> 2], f) continue;
                                                break r;
                                            }
                                            if ((e | 0) <= (k | 0)) break e;
                                            if (f = i[n + 4 >> 2], !f) break;
                                        }
                                        t = n + 4 | 0;
                                    }
                                    f = D(56), i[f + 16 >> 2] = e, e = i[u + 28 >> 2], i[f + 20 >> 2] = i[u + 24 >> 2], i[f + 24 >> 2] = e, e = i[u + 36 >> 2], i[f + 28 >> 2] = i[u + 32 >> 2], i[f + 32 >> 2] = e, e = i[u + 44 >> 2], i[f + 36 >> 2] = i[u + 40 >> 2], i[f + 40 >> 2] = e, e = i[u + 52 >> 2], i[f + 44 >> 2] = i[u + 48 >> 2], i[f + 48 >> 2] = e, i[f + 52 >> 2] = i[u + 56 >> 2], i[f + 8 >> 2] = n, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[t >> 2] = f, e = i[i[r + 60 >> 2] >> 2], e && (i[r + 60 >> 2] = e, f = i[t >> 2]), h4(i[r + 64 >> 2], f), i[r + 68 >> 2] = i[r + 68 >> 2] + 1;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[u + 19 | 0] < 0 && X(i[u + 8 >> 2]), m = u - -64 | 0;
                        }
                        function o_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            n = m + -64 | 0, m = n;
                            i: {
                                if (Y1(r, 72408, 0)) {
                                    i[e >> 2] = 0, f = 1;
                                    break i;
                                }
                                e: {
                                    if (l[A + 8 | 0] & 24) k = 1;
                                    else {
                                        if (!r || (t = E0(r, 72044, 72140), !t)) break e;
                                        k = (l[t + 8 | 0] & 24) != 0;
                                    }
                                    k = Y1(A, r, k);
                                }
                                if (k) {
                                    if (f = 1, A = i[e >> 2], !A) break i;
                                    i[e >> 2] = i[A >> 2];
                                    break i;
                                }
                                e: {
                                    if (!r) break e;
                                    if (t = E0(r, 72044, 72188), !t || (r = i[e >> 2], r && (i[e >> 2] = i[r >> 2]), k = i[t + 8 >> 2], r = i[A + 8 >> 2], k & (r ^ -1) & 7 | r & (k ^ -1) & 96) || (f = 1, Y1(i[A + 12 >> 2], i[t + 12 >> 2], 0))) break i;
                                    if (Y1(i[A + 12 >> 2], 72396, 0)) {
                                        if (A = i[t + 12 >> 2], !A) break i;
                                        f = !E0(A, 72044, 72240);
                                        break i;
                                    }
                                    if (k = i[A + 12 >> 2], !k) break e;
                                    if (f = 0, r = E0(k, 72044, 72188), r) {
                                        if (!(o[A + 8 | 0] & 1)) break i;
                                        A = i[t + 12 >> 2], e = 0;
                                        r: {
                                            A: {
                                                for(;;){
                                                    if (f = 0, !A) break r;
                                                    if (A = E0(A, 72044, 72188), !A | i[A + 8 >> 2] & (i[r + 8 >> 2] ^ -1)) break A;
                                                    if (f = 1, Y1(i[r + 12 >> 2], i[A + 12 >> 2], 0)) break r;
                                                    if (!(o[r + 8 | 0] & 1) || (f = i[r + 12 >> 2], !f)) break A;
                                                    if (r = E0(f, 72044, 72188), r) {
                                                        A = i[A + 12 >> 2];
                                                        continue;
                                                    }
                                                    break;
                                                }
                                                if (r = E0(f, 72044, 72300), !r) break A;
                                                e = tt(r, i[A + 12 >> 2]);
                                            }
                                            f = e;
                                        }
                                        break i;
                                    }
                                    if (r = E0(k, 72044, 72300), r) {
                                        if (!(o[A + 8 | 0] & 1)) break i;
                                        f = tt(r, i[t + 12 >> 2]);
                                        break i;
                                    }
                                    if (k = E0(k, 72044, 72092), !k || (A = i[t + 12 >> 2], !A) || (A = E0(A, 72044, 72092), !A)) break i;
                                    r = i[e >> 2], B0(n + 8 | 0, 0, 56), o[n + 59 | 0] = (r | 0) != 0, i[n + 16 >> 2] = -1, i[n + 12 >> 2] = k, i[n + 4 >> 2] = A, i[n + 52 >> 2] = 1, p[i[i[A >> 2] + 28 >> 2]](A, n + 4 | 0, r, 1), A = i[n + 28 >> 2], (A | 0) == 1 && (i[e >> 2] = r ? i[n + 20 >> 2] : 0), f = (A | 0) == 1;
                                    break i;
                                }
                                f = 0;
                            }
                            return m = n - -64 | 0, f | 0;
                        }
                        function L8(A, r, e) {
                            return i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, o[A + 152 | 0] = 0, i[A + 20 >> 2] = r, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 68 >> 2] = 0, i[A + 72 >> 2] = 0, i[A + 80 >> 2] = 0, i[A + 84 >> 2] = 0, i[A + 156 >> 2] = 0, i[A + 160 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 4142, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, Q[A + 48 >> 1] = 0, Q[A + 58 >> 1] = 0, Q[A + 60 >> 1] = 0, Q[A + 62 >> 1] = 0, Q[A + 64 >> 1] = 0, o[A + 76 | 0] = 0, o[A + 88 | 0] = 0, i[A + 204 >> 2] = 0, i[A + 196 >> 2] = 0, i[A + 200 >> 2] = 0, i[A + 188 >> 2] = 0, i[A + 192 >> 2] = 0, i[A + 180 >> 2] = 0, i[A + 184 >> 2] = 0, i[A + 172 >> 2] = 0, i[A + 176 >> 2] = 0, i[A + 164 >> 2] = 0, i[A + 168 >> 2] = 0, i[A >> 2] = 82452, i[A + 288 >> 2] = 0, i[A + 280 >> 2] = 0, i[A + 284 >> 2] = 0, o[A + 208 | 0] = 1, i[A + 212 >> 2] = 0, i[A + 216 >> 2] = 0, o[A + 217 | 0] = 0, o[A + 218 | 0] = 0, o[A + 219 | 0] = 0, o[A + 220 | 0] = 0, o[A + 221 | 0] = 0, o[A + 222 | 0] = 0, o[A + 223 | 0] = 0, o[A + 224 | 0] = 0, i[A + 232 >> 2] = 0, i[A + 236 >> 2] = 0, i[A + 240 >> 2] = 0, i[A + 244 >> 2] = 0, i[A + 248 >> 2] = 0, i[A + 252 >> 2] = 0, i[A + 256 >> 2] = 0, i[A + 260 >> 2] = 0, i[A + 264 >> 2] = 0, i[A + 268 >> 2] = 0, o[A + 272 | 0] = 0, Q[A + 292 >> 1] = 1, i[A + 296 >> 2] = 0, i[A + 300 >> 2] = 0, i[A + 304 >> 2] = 0, i[A + 308 >> 2] = 0, i[A + 312 >> 2] = 0, i[A + 316 >> 2] = 0, i[A + 368 >> 2] = 0, i[A + 360 >> 2] = 0, i[A + 364 >> 2] = 0, i[A + 320 >> 2] = 0, i[A + 324 >> 2] = 1072693248, i[A + 144 >> 2] = 0, i[A + 148 >> 2] = 0, i[A + 136 >> 2] = 0, i[A + 140 >> 2] = 0, i[A + 128 >> 2] = 0, i[A + 132 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 112 >> 2] = 0, i[A + 116 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 352 >> 2] = 0, i[A + 344 >> 2] = 0, i[A + 348 >> 2] = 0, i[A + 336 >> 2] = 0, i[A + 340 >> 2] = 0, i[A + 328 >> 2] = 0, i[A + 332 >> 2] = 0, i[A + 36 >> 2] = e, A;
                        }
                        function Ie(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            _ = m - 128 | 0, m = _, i[_ + 124 >> 2] = r, i[_ + 16 >> 2] = 1413, h = _ + 16 | 0, B = s1(_ + 8 | 0, 0, h);
                            i: {
                                e: {
                                    r: {
                                        if (v = (f - e | 0) / 12 | 0, v >>> 0 >= 101) {
                                            if (h = Q2(v), !h) break r;
                                            r = i[B >> 2], i[B >> 2] = h, r && p[i[B + 4 >> 2]](r);
                                        }
                                        for(u = h, r = e;;)if ((r | 0) == (f | 0)) A: for(;;){
                                            if (r = _ + 124 | 0, y = T2(A, r), F = 1, E = v, E ? y : F) for(T2(A, r) && (i[n >> 2] = i[n >> 2] | 2);;){
                                                if ((e | 0) == (f | 0)) break e;
                                                if (l[h | 0] == 2) break i;
                                                h = h + 1 | 0, e = e + 12 | 0;
                                            }
                                            r = i[A >> 2], u = i[r + 12 >> 2];
                                            f: {
                                                if ((u | 0) == i[r + 16 >> 2]) {
                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                    break f;
                                                }
                                                r = l[u | 0];
                                            }
                                            for(W = r << 24 >> 24, t || (W = p[i[i[k >> 2] + 12 >> 2]](k, W) | 0), s = C + 1 | 0, V = 0, u = h, r = e;;)if ((r | 0) == (f | 0)) {
                                                if (C = s, !V || (g1(A), u = h, r = e, v + G >>> 0 < 2)) continue A;
                                                for(;;){
                                                    if ((r | 0) == (f | 0)) continue A;
                                                    l[r + 11 | 0] >>> 7 | 0 ? s = i[r + 4 >> 2] : s = l[r + 11 | 0] & 127, (s | 0) == (C | 0) | l[u | 0] != 2 || (o[u | 0] = 0, G = G - 1 | 0), u = u + 1 | 0, r = r + 12 | 0;
                                                }
                                            } else {
                                                f: {
                                                    if (l[u | 0] != 1) break f;
                                                    l[r + 11 | 0] >>> 7 | 0 ? w = i[r >> 2] : w = r, w = o[w + C | 0], t || (w = p[i[i[k >> 2] + 12 >> 2]](k, w) | 0);
                                                    k: {
                                                        if ((W | 0) == (w | 0)) {
                                                            if (V = 1, l[r + 11 | 0] >>> 7 | 0 ? w = i[r + 4 >> 2] : w = l[r + 11 | 0] & 127, (w | 0) != (s | 0)) break f;
                                                            o[u | 0] = 2, G = G + 1 | 0;
                                                            break k;
                                                        }
                                                        o[u | 0] = 0;
                                                    }
                                                    v = v - 1 | 0;
                                                }
                                                u = u + 1 | 0, r = r + 12 | 0;
                                                continue;
                                            }
                                        }
                                        else {
                                            l[r + 11 | 0] >>> 7 | 0 ? s = i[r + 4 >> 2] : s = l[r + 11 | 0] & 127, s = !s, o[u | 0] = s ? 2 : 1, u = u + 1 | 0, r = r + 12 | 0, G = G + s | 0, v = v - s | 0;
                                            continue;
                                        }
                                    }
                                    w1(), z();
                                }
                                i[n >> 2] = i[n >> 2] | 4;
                            }
                            return A = i[B >> 2], i[B >> 2] = 0, A && p[i[B + 4 >> 2]](A), m = _ + 128 | 0, e;
                        }
                        function Fe(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            _ = m - 128 | 0, m = _, i[_ + 124 >> 2] = r, i[_ + 16 >> 2] = 1413, h = _ + 16 | 0, B = s1(_ + 8 | 0, 0, h);
                            i: {
                                e: {
                                    r: {
                                        if (v = (f - e | 0) / 12 | 0, v >>> 0 >= 101) {
                                            if (h = Q2(v), !h) break r;
                                            r = i[B >> 2], i[B >> 2] = h, r && p[i[B + 4 >> 2]](r);
                                        }
                                        for(u = h, r = e;;)if ((r | 0) == (f | 0)) A: for(;;){
                                            if (r = _ + 124 | 0, y = S2(A, r), F = 1, E = v, E ? y : F) for(S2(A, r) && (i[n >> 2] = i[n >> 2] | 2);;){
                                                if ((e | 0) == (f | 0)) break e;
                                                if (l[h | 0] == 2) break i;
                                                h = h + 1 | 0, e = e + 12 | 0;
                                            }
                                            r = i[A >> 2], u = i[r + 12 >> 2];
                                            f: {
                                                if ((u | 0) == i[r + 16 >> 2]) {
                                                    s = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                    break f;
                                                }
                                                s = i[u >> 2];
                                            }
                                            for(t || (s = p[i[i[k >> 2] + 28 >> 2]](k, s) | 0), C = W + 1 | 0, V = 0, u = h, r = e;;)if ((r | 0) == (f | 0)) {
                                                if (W = C, !V || (J1(A), u = h, r = e, v + G >>> 0 < 2)) continue A;
                                                for(;;){
                                                    if ((r | 0) == (f | 0)) continue A;
                                                    l[r + 11 | 0] >>> 7 | 0 ? s = i[r + 4 >> 2] : s = l[r + 11 | 0] & 127, (s | 0) == (W | 0) | l[u | 0] != 2 || (o[u | 0] = 0, G = G - 1 | 0), u = u + 1 | 0, r = r + 12 | 0;
                                                }
                                            } else {
                                                f: {
                                                    if (l[u | 0] != 1) break f;
                                                    l[r + 11 | 0] >>> 7 | 0 ? w = i[r >> 2] : w = r, w = i[w + (W << 2) >> 2], t || (w = p[i[i[k >> 2] + 28 >> 2]](k, w) | 0);
                                                    k: {
                                                        if ((s | 0) == (w | 0)) {
                                                            if (V = 1, l[r + 11 | 0] >>> 7 | 0 ? w = i[r + 4 >> 2] : w = l[r + 11 | 0] & 127, (w | 0) != (C | 0)) break f;
                                                            o[u | 0] = 2, G = G + 1 | 0;
                                                            break k;
                                                        }
                                                        o[u | 0] = 0;
                                                    }
                                                    v = v - 1 | 0;
                                                }
                                                u = u + 1 | 0, r = r + 12 | 0;
                                                continue;
                                            }
                                        }
                                        else {
                                            l[r + 11 | 0] >>> 7 | 0 ? s = i[r + 4 >> 2] : s = l[r + 11 | 0] & 127, s = !s, o[u | 0] = s ? 2 : 1, u = u + 1 | 0, r = r + 12 | 0, G = s + G | 0, v = v - s | 0;
                                            continue;
                                        }
                                    }
                                    w1(), z();
                                }
                                i[n >> 2] = i[n >> 2] | 4;
                            }
                            return A = i[B >> 2], i[B >> 2] = 0, A && p[i[B + 4 >> 2]](A), m = _ + 128 | 0, e;
                        }
                        function u_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), e = f + 12 | 0, U(e, 23837, 18), k = i[r + 104 >> 2];
                            i: {
                                if ((k | 0) == i[r + 108 >> 2] || (P0(e, l[k | 0]), e = 1, i[r + 108 >> 2] - i[r + 104 >> 2] >>> 0 <= 1)) break i;
                                for(; k = f + 12 | 0, U(k, 20126, 1), P0(k, l[i[r + 104 >> 2] + e | 0]), e = e + 1 | 0, e >>> 0 < i[r + 108 >> 2] - i[r + 104 >> 2] >>> 0;);
                            }
                            U(f + 12 | 0, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function l_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), e = f + 12 | 0, M0(U(e, 24971, 4), (i[r + 116 >> 2] - i[r + 112 >> 2] | 0) / 12 | 0), P0(U(e, 25057, 7), i[r + 104 >> 2] - i[r + 100 >> 2] & 255), U(e, 25065, 5), e = i[r + 100 >> 2], r = i[r + 104 >> 2], (e | 0) != (r | 0)) for(; U(P0(f + 12 | 0, l[e | 0]), 25144, 2), e = e + 1 | 0, (r | 0) != (e | 0););
                            U(f + 12 | 0, 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function s_(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 16 | 0, m = f, n = i[r + 12 >> 2], u = n;
                            i: {
                                e: {
                                    r: {
                                        if (k = i[r + 8 >> 2], n | k) {
                                            if (n = i[r + 32 >> 2], s = n >>> 0 > k >>> 0, s & !u) break r;
                                            if (t = k - n | 0, n = u - s | 0, k = t, !n & k >>> 0 >= 2147483648 | n) {
                                                if (r = D(24), i[f + 4 >> 2] = r, i[f + 8 >> 2] = 18, i[f + 12 >> 2] = -2147483624, e = l[11170] | l[11171] << 8 | (l[11172] << 16 | l[11173] << 24), k = l[11166] | l[11167] << 8 | (l[11168] << 16 | l[11169] << 24), o[r | 0] = k, o[r + 1 | 0] = k >>> 8, o[r + 2 | 0] = k >>> 16, o[r + 3 | 0] = k >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 18 | 0] = 0, e = l[11182] | l[11183] << 8, o[r + 16 | 0] = e, o[r + 17 | 0] = e >>> 8, e = l[11178] | l[11179] << 8 | (l[11180] << 16 | l[11181] << 24), k = l[11174] | l[11175] << 8 | (l[11176] << 16 | l[11177] << 24), o[r + 8 | 0] = k, o[r + 9 | 0] = k >>> 8, o[r + 10 | 0] = k >>> 16, o[r + 11 | 0] = k >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 2, 1e3, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                                X(i[f + 4 >> 2]);
                                                break i;
                                            }
                                            n = i[r + 100 >> 2], t = i[r + 104 >> 2] - n | 0;
                                            A: {
                                                if (k >>> 0 > t >>> 0) {
                                                    r1(r + 100 | 0, k - t | 0), n = i[r + 100 >> 2];
                                                    break A;
                                                }
                                                if (k >>> 0 >= t >>> 0) break A;
                                                i[r + 104 >> 2] = k + n;
                                            }
                                            Y6(e, n, k);
                                        }
                                        if (l[e + 20 | 0] != 1) break e;
                                        if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                        X(i[f + 4 >> 2]);
                                        break i;
                                    }
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 101, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function h_(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            s = m - 16 | 0, m = s, n = D(32), i[n + 16 >> 2] = 1, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 12 >> 2] = 79096, i[n >> 2] = 79348, h = n + 12 | 0;
                            i: {
                                if (!f || (Dn(n + 20 | 0, f), (f | 0) <= 0)) break i;
                                if (u = i[n + 20 >> 2], (f | 0) != 1) for(G = f & 2147483646; t = v << 3, w = t + u | 0, _ = e + t | 0, i[w >> 2] = i[_ >> 2], i[w + 4 >> 2] = i[_ + 4 >> 2], t = t | 8, w = t + u | 0, t = e + t | 0, i[w >> 2] = i[t >> 2], i[w + 4 >> 2] = i[t + 4 >> 2], v = v + 2 | 0, B = B + 2 | 0, (G | 0) != (B | 0););
                                if (!(f & 1)) break i;
                                f = v << 3, u = f + u | 0, e = e + f | 0, i[u >> 2] = i[e >> 2], i[u + 4 >> 2] = i[e + 4 >> 2];
                            }
                            o[n + 16 | 0] = 1, e = i[r + 8 >> 2], i[s + 12 >> 2] = n, i[s + 8 >> 2] = h, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, f = i[e + 16 >> 2];
                            i: {
                                e: {
                                    if (f >>> 0 < k0[e + 20 >> 2]) {
                                        i[f + 4 >> 2] = n, i[f >> 2] = h, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, f = n;
                                        break e;
                                    }
                                    if (u = P2(e + 12 | 0, s + 8 | 0), f = i[s + 12 >> 2], i[e + 16 >> 2] = u, !f) break i;
                                }
                                if (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            i: {
                                if (!k || (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = D(24), i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e + 20 >> 2] = n, i[e + 16 >> 2] = h, h = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = h, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[k >> 2] = e, r = i[n + 4 >> 2], i[n + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = s + 16 | 0;
                        }
                        function w_(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            s = m - 16 | 0, m = s, n = D(32), i[n + 16 >> 2] = 1, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 12 >> 2] = 79096, i[n >> 2] = 79348, h = n + 12 | 0;
                            i: {
                                if (!f || (Dn(n + 20 | 0, f), (f | 0) <= 0)) break i;
                                if (u = i[n + 20 >> 2], (f | 0) != 1) for(G = f & 2147483646; t = v << 3, w = t + u | 0, _ = e + t | 0, i[w >> 2] = i[_ >> 2], i[w + 4 >> 2] = i[_ + 4 >> 2], t = t | 8, w = t + u | 0, t = e + t | 0, i[w >> 2] = i[t >> 2], i[w + 4 >> 2] = i[t + 4 >> 2], v = v + 2 | 0, B = B + 2 | 0, (G | 0) != (B | 0););
                                if (!(f & 1)) break i;
                                f = v << 3, u = f + u | 0, e = e + f | 0, i[u >> 2] = i[e >> 2], i[u + 4 >> 2] = i[e + 4 >> 2];
                            }
                            o[n + 16 | 0] = 0, e = i[r + 8 >> 2], i[s + 12 >> 2] = n, i[s + 8 >> 2] = h, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, f = i[e + 16 >> 2];
                            i: {
                                e: {
                                    if (f >>> 0 < k0[e + 20 >> 2]) {
                                        i[f + 4 >> 2] = n, i[f >> 2] = h, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, f = n;
                                        break e;
                                    }
                                    if (u = P2(e + 12 | 0, s + 8 | 0), f = i[s + 12 >> 2], i[e + 16 >> 2] = u, !f) break i;
                                }
                                if (e = i[f + 4 >> 2], i[f + 4 >> 2] = e - 1, e) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            i: {
                                if (!k || (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = D(24), i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e + 20 >> 2] = n, i[e + 16 >> 2] = h, h = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = h, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[k >> 2] = e, r = i[n + 4 >> 2], i[n + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = s + 16 | 0;
                        }
                        function v_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            n = m - 32 | 0, m = n, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l[r + 184 | 0] == 1 && l2(e, i[r + 104 >> 2]), l[r + 185 | 0] == 1 && l2(e, i[r + 108 >> 2]), l[r + 186 | 0] == 1 && l2(e, i[r + 112 >> 2]);
                            i: {
                                if (l[r + 187 | 0] != 1) break i;
                                if (l[r + 116 | 0] == 1) {
                                    if (f = n0[r + 120 >> 3], l[r + 117 | 0] == 1) {
                                        f = f * 1073741824;
                                        e: {
                                            if (r2(f) < 2147483648) {
                                                k = ~~f;
                                                break e;
                                            }
                                            k = -2147483648;
                                        }
                                        l2(e, k), f = n0[r + 128 >> 3] * 1073741824;
                                        e: {
                                            if (r2(f) < 2147483648) {
                                                k = ~~f;
                                                break e;
                                            }
                                            k = -2147483648;
                                        }
                                        if (l2(e, k), f = n0[r + 136 >> 3] * 1073741824, r2(f) < 2147483648) {
                                            l2(e, ~~f);
                                            break i;
                                        }
                                        l2(e, -2147483648);
                                        break i;
                                    }
                                    f = f * 16384;
                                    e: {
                                        if (r2(f) < 2147483648) {
                                            k = ~~f;
                                            break e;
                                        }
                                        k = -2147483648;
                                    }
                                    w2(e, k), f = n0[r + 128 >> 3] * 16384;
                                    e: {
                                        if (r2(f) < 2147483648) {
                                            k = ~~f;
                                            break e;
                                        }
                                        k = -2147483648;
                                    }
                                    if (w2(e, k), f = n0[r + 136 >> 3] * 16384, r2(f) < 2147483648) {
                                        w2(e, ~~f);
                                        break i;
                                    }
                                    w2(e, -2147483648);
                                    break i;
                                }
                                f = n0[r + 152 >> 3] * 65536;
                                e: {
                                    if (r2(f) < 2147483648) {
                                        k = ~~f;
                                        break e;
                                    }
                                    k = -2147483648;
                                }
                                l2(e, k), f = n0[r + 160 >> 3] * 65536;
                                e: {
                                    if (r2(f) < 2147483648) {
                                        k = ~~f;
                                        break e;
                                    }
                                    k = -2147483648;
                                }
                                l2(e, k), f = n0[r + 168 >> 3] * 65536;
                                e: {
                                    if (r2(f) < 2147483648) {
                                        k = ~~f;
                                        break e;
                                    }
                                    k = -2147483648;
                                }
                                l2(e, k);
                            }
                            l[r + 188 | 0] == 1 && l2(e, i[r + 176 >> 2]), i[e + 12 >> 2] = t, p[i[i[r >> 2] + 48 >> 2]](n + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + t | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function Z8(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            s = m - 16 | 0, m = s, i[s + 8 >> 2] = e, i[s + 12 >> 2] = r, e = s + 4 | 0, r = i[f + 28 >> 2], i[e >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), h = K0(e, 108580), d0(e), i[k >> 2] = 0, r = 0;
                            i: {
                                for(;;){
                                    if (r | (t | 0) == (u | 0)) break i;
                                    e: {
                                        if (T2(s + 12 | 0, s + 8 | 0)) break e;
                                        r: {
                                            if ((p[i[i[h >> 2] + 36 >> 2]](h, o[t | 0], 0) | 0) == 37) {
                                                if ((t + 1 | 0) == (u | 0)) break e;
                                                e = 0;
                                                A: {
                                                    f: {
                                                        if (r = p[i[i[h >> 2] + 36 >> 2]](h, o[t + 1 | 0], 0) | 0, (r | 0) == 69 || (w = 1, (r & 255) == 48)) break f;
                                                        break A;
                                                    }
                                                    if ((t + 2 | 0) == (u | 0)) break e;
                                                    w = 2, e = r, r = p[i[i[h >> 2] + 36 >> 2]](h, o[t + 2 | 0], 0) | 0;
                                                }
                                                v = s, _ = p[i[i[A >> 2] + 36 >> 2]](A, i[s + 12 >> 2], i[s + 8 >> 2], f, k, n, r, e) | 0, i[v + 12 >> 2] = _, t = (t + w | 0) + 1 | 0;
                                                break r;
                                            }
                                            if (r = o[t | 0], (r | 0) >= 0 ? r = i[i[h + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, r) {
                                                for(; t = t + 1 | 0, !!((u | 0) != (t | 0) && (r = o[t | 0], (r | 0) >= 0 ? r = i[i[h + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, r)););
                                                for(;;){
                                                    if (e = s + 12 | 0, T2(e, s + 8 | 0)) break r;
                                                    r = i[e >> 2], w = i[r + 12 >> 2];
                                                    A: {
                                                        if ((w | 0) == i[r + 16 >> 2]) {
                                                            r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                            break A;
                                                        }
                                                        r = l[w | 0];
                                                    }
                                                    if (r = r << 24 >> 24, (r | 0) >= 0 ? r = i[i[h + 8 >> 2] + (r << 2) >> 2] & 1 : r = 0, !r) break r;
                                                    g1(e);
                                                }
                                            }
                                            w = s + 12 | 0, r = i[w >> 2], e = i[r + 12 >> 2];
                                            A: {
                                                if ((e | 0) == i[r + 16 >> 2]) {
                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                    break A;
                                                }
                                                r = l[e | 0];
                                            }
                                            if ((p[i[i[h >> 2] + 12 >> 2]](h, r << 24 >> 24) | 0) == (p[i[i[h >> 2] + 12 >> 2]](h, o[t | 0]) | 0)) {
                                                t = t + 1 | 0, g1(w);
                                                break r;
                                            }
                                            i[k >> 2] = 4;
                                        }
                                        r = i[k >> 2];
                                        continue;
                                    }
                                    break;
                                }
                                i[k >> 2] = 4;
                            }
                            return T2(s + 12 | 0, s + 8 | 0) && (i[k >> 2] = i[k >> 2] | 2), m = s + 16 | 0, i[s + 12 >> 2];
                        }
                        function V5(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n;
                            i: {
                                e: {
                                    for(;;){
                                        r: {
                                            if (r = i[A + 12 >> 2], f >>> 0 <= r >>> 0 || (w = i[A + 8 >> 2], w >>> 0 >= t >>> 0)) break r;
                                            n = o[r | 0], e = n & 255;
                                            A: {
                                                if ((n | 0) >= 0) {
                                                    if (e >>> 0 > 1114111) break e;
                                                    h = 1;
                                                    break A;
                                                }
                                                if (n >>> 0 < 4294967234) break e;
                                                if (n >>> 0 <= 4294967263) {
                                                    if (n = 1, (f - r | 0) < 2 || (n = 2, s = l[r + 1 | 0], (s & 192) != 128)) break i;
                                                    h = 2, e = s & 63 | e << 6 & 1984;
                                                    break A;
                                                }
                                                if (n >>> 0 <= 4294967279) {
                                                    if (n = 1, h = f - r | 0, (h | 0) < 2) break i;
                                                    s = l[r + 1 | 0];
                                                    f: {
                                                        k: {
                                                            if ((e | 0) != 237) {
                                                                if ((e | 0) != 224) break k;
                                                                if ((s & 224) == 160) break f;
                                                                break e;
                                                            }
                                                            if ((s & 224) == 128) break f;
                                                            break e;
                                                        }
                                                        if ((s & 192) != 128) break e;
                                                    }
                                                    if ((h | 0) == 2) break i;
                                                    if (n = l[r + 2 | 0], (n & 192) != 128) break e;
                                                    h = 3, e = n & 63 | (e << 12 & 61440 | (s & 63) << 6);
                                                    break A;
                                                }
                                                if (n >>> 0 > 4294967284) break e;
                                                if (n = 1, h = f - r | 0, (h | 0) < 2) break i;
                                                s = l[r + 1 | 0];
                                                f: {
                                                    k: switch(e - 240 | 0){
                                                        case 0:
                                                            if ((s + 112 & 255) >>> 0 >= 48) break e;
                                                            break f;
                                                        case 4:
                                                            if ((s & 240) != 128) break e;
                                                            break f;
                                                        default:
                                                            break k;
                                                    }
                                                    if ((s & 192) != 128) break e;
                                                }
                                                if ((h | 0) == 2) break i;
                                                if (v = l[r + 2 | 0], (v & 192) != 128) break e;
                                                if ((h | 0) == 3) break i;
                                                if (_ = l[r + 3 | 0], (_ & 192) != 128) break e;
                                                if (h = 4, n = 2, e = _ & 63 | (v << 6 & 4032 | (e << 18 & 1835008 | (s & 63) << 12)), e >>> 0 > 1114111) break i;
                                            }
                                            i[w >> 2] = e, i[A + 12 >> 2] = r + h, i[A + 8 >> 2] = i[A + 8 >> 2] + 4;
                                            continue;
                                        }
                                        break;
                                    }
                                    n = r >>> 0 < f >>> 0;
                                    break i;
                                }
                                n = 2;
                            }
                            return i[k >> 2] = i[A + 12 >> 2], i[u >> 2] = i[A + 8 >> 2], m = A + 16 | 0, n | 0;
                        }
                        function Ye(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0;
                            i[A + 128 >> 2] = 0, i[A + 132 >> 2] = 0, f = B0(A, 0, 124), i[f + 136 >> 2] = 0, i[f + 124 >> 2] = f + 128, t = D(88), i[t >> 2] = 78508, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, n = m - 16 | 0, m = n, k = t + 16 | 0, A = k, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 1, i[A + 48 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 60 >> 2] = 0, A = A - -64 | 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, A = D(136), i[A >> 2] = 76176, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, r = A + 16 | 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 20 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 32 >> 2] = 0, i[r >> 2] = 73428, i[A + 60 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 88 >> 2] = 0, i[A + 92 >> 2] = 0, i[A + 72 >> 2] = -1, i[A + 76 >> 2] = -1, i[A + 96 >> 2] = 0, i[A + 100 >> 2] = 0, i[A + 104 >> 2] = 0, i[A + 108 >> 2] = 0, o[A + 112 | 0] = 0, i[r >> 2] = 73880, i[A + 132 >> 2] = 0, i[A + 124 >> 2] = 0, i[A + 128 >> 2] = 0, i[A + 116 >> 2] = 0, i[A + 120 >> 2] = 0, i[A + 80 >> 2] = 0, i[A + 84 >> 2] = 0, i[A + 32 >> 2] = 1718909296, i[n + 12 >> 2] = A, i[n + 8 >> 2] = r, i[A + 4 >> 2] = i[A + 4 >> 2] + 1, e = i[k + 20 >> 2];
                            i: {
                                if (e >>> 0 < k0[k + 24 >> 2]) {
                                    i[e + 4 >> 2] = A, i[e >> 2] = r, i[k + 20 >> 2] = e + 8;
                                    break i;
                                }
                                if (e = p2(k + 16 | 0, n + 8 | 0), r = i[n + 12 >> 2], i[k + 20 >> 2] = e, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), m = n + 16 | 0, i[f >> 2] = k, A = i[f + 4 >> 2], i[f + 4 >> 2] = t;
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return f;
                        }
                        function y5(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0;
                            A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, e = i[A + 12 >> 2];
                            i: {
                                e: {
                                    for(;;){
                                        if (e >>> 0 >= f >>> 0) {
                                            n = 0;
                                            break i;
                                        }
                                        n = 2;
                                        r: {
                                            r = I[e >> 1];
                                            A: {
                                                if (r >>> 0 <= 127) {
                                                    if (n = 1, e = i[A + 8 >> 2], (t - e | 0) <= 0) break i;
                                                    i[A + 8 >> 2] = e + 1, o[e | 0] = r;
                                                    break A;
                                                }
                                                if (r >>> 0 <= 2047) {
                                                    if (e = i[A + 8 >> 2], (t - e | 0) < 2) break e;
                                                    i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 | 192, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                                    break A;
                                                }
                                                if (r >>> 0 <= 55295) {
                                                    if (e = i[A + 8 >> 2], (t - e | 0) < 3) break e;
                                                    i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 12 | 224, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 & 63 | 128, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                                    break A;
                                                }
                                                if (r >>> 0 <= 56319) {
                                                    if (n = 1, (f - e | 0) < 3) break i;
                                                    if (s = I[e + 2 >> 1], (s & 64512) != 56320) break r;
                                                    if ((t - i[A + 8 >> 2] | 0) < 4) break i;
                                                    if (n = r & 960, (s & 1023 | (r << 10 & 64512 | n << 10)) >>> 0 > 1048575) break r;
                                                    i[A + 12 >> 2] = e + 2, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, h = e, e = (n >>> 6 | 0) + 1 | 0, o[h | 0] = e >>> 2 | 240, n = i[A + 8 >> 2], i[A + 8 >> 2] = n + 1, o[n | 0] = e << 4 & 48 | r >>> 2 & 15 | 128, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = s >>> 6 & 15 | r << 4 & 48 | 128, r = i[A + 8 >> 2], i[A + 8 >> 2] = r + 1, o[r | 0] = s & 63 | 128;
                                                    break A;
                                                }
                                                if (r >>> 0 < 57344) break i;
                                                if (e = i[A + 8 >> 2], (t - e | 0) < 3) break e;
                                                i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 12 | 224, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 & 191, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                            }
                                            e = i[A + 12 >> 2] + 2 | 0, i[A + 12 >> 2] = e;
                                            continue;
                                        }
                                        break;
                                    }
                                    n = 2;
                                    break i;
                                }
                                n = 1;
                            }
                            return i[k >> 2] = i[A + 12 >> 2], i[u >> 2] = i[A + 8 >> 2], m = A + 16 | 0, n | 0;
                        }
                        function Ee(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, G0(n, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = U(f + 12 | 0, 22716, 5), n = f + 148 | 0, si(n, r), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), 34634, 7), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), n = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(K1(U(f + 12 | 0, 24181, 6), i[r + 8 >> 2], i[r + 12 >> 2]), 24125, 17), i[r + 32 >> 2]), 34894, 2), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function __(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            f = m + -64 | 0, m = f, i[f + 60 >> 2] = 0, i[f + 56 >> 2] = 0, _5(f + 44 | 0, r, e, f + 60 | 0, f + 56 | 0);
                            i: {
                                if (i[f + 44 >> 2]) {
                                    r = i[f + 48 >> 2], i[A >> 2] = i[f + 44 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[f + 52 >> 2];
                                    break i;
                                }
                                e: {
                                    if ((e | 0) < 12 || (e = l[r + 8 | 0], !e) || (n = l[r + 9 | 0], !n) || (u = l[r + 10 | 0], !u) || (r = l[r + 11 | 0], !r)) break e;
                                    k = r | (n << 16 | e << 24 | u << 8);
                                }
                                r = i[10162], i[f + 24 >> 2] = i[10161], i[f + 28 >> 2] = r, r = i[10160], i[f + 16 >> 2] = i[10159], i[f + 20 >> 2] = r, r = i[10158], i[f + 8 >> 2] = i[10157], i[f + 12 >> 2] = r, i[f + 36 >> 2] = 0, i[f + 40 >> 2] = 0, n = f + 36 | 0, i[f + 32 >> 2] = n, r = i[10156], i[f >> 2] = i[10155], i[f + 4 >> 2] = r, r = f + 32 | 0, He(r, f, r), u = i[f + 36 >> 2];
                                e: {
                                    r: {
                                        if (u) {
                                            for(e = n, r = u; s = e, h = r, t = k0[r + 16 >> 2] < k >>> 0, e = t ? e : r, r = i[(t << 2) + r >> 2], !!r;);
                                            if (!((e | 0) != (n | 0) & k0[(t ? s : h) + 16 >> 2] <= k >>> 0)) {
                                                if (k = i[f + 60 >> 2], v = i[f + 56 >> 2], !u | (v | 0) <= 0) break r;
                                                for(t = 0;;){
                                                    for(_ = i[(t << 2) + k >> 2], e = n, r = u; s = e, h = r, w = k0[r + 16 >> 2] < _ >>> 0, e = w ? e : r, r = i[(w << 2) + r >> 2], !!r;);
                                                    if (!((e | 0) == (n | 0) | k0[(w ? s : h) + 16 >> 2] > _ >>> 0)) {
                                                        k && X(k), r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                                                        break e;
                                                    }
                                                    if (t = t + 1 | 0, (v | 0) == (t | 0)) break;
                                                }
                                                break r;
                                            }
                                            r = i[f + 60 >> 2], r && X(r), r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                                            break e;
                                        }
                                        k = i[f + 60 >> 2];
                                    }
                                    k && X(k), i[A >> 2] = 2, i[A + 4 >> 2] = 3001, i[A + 8 >> 2] = 19824;
                                }
                                T8(f + 32 | 0, i[f + 36 >> 2]);
                            }
                            m = f - -64 | 0;
                        }
                        function si(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = m - 144 | 0, m = f;
                            i: {
                                e: {
                                    if (e = i[r + 16 >> 2], (e | 0) == 1970628964) {
                                        for(i[f + 60 >> 2] = 60132, e = i[15036], i[f + 4 >> 2] = e, k = i[e - 12 >> 2], e = f + 4 | 0, i[k + e >> 2] = i[15037], k = e + i[i[f + 4 >> 2] - 12 >> 2] | 0, t = f + 8 | 0, T0(k, t), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, i[f + 60 >> 2] = 60132, i[f + 4 >> 2] = 60112, t = z0(t), i[t >> 2] = 58864, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 56 >> 2] = 16, k = i[f + 4 >> 2] - 12 | 0, n = e + i[k >> 2] | 0, i[n + 4 >> 2] = i[n + 4 >> 2] & -75 | 8, k = e + i[k >> 2] | 0, i[k + 76 >> 2] == -1 && (n = f + 140 | 0, e = i[k + 28 >> 2], i[n >> 2] = e, (e | 0) != 108396 && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = K0(n, 108580), p[i[i[e >> 2] + 28 >> 2]](e, 32), d0(n)), n = f + 60 | 0, i[k + 76 >> 2] = 48, k = f + 16 | 0, e = 0;;){
                                            r: switch((e & 13) - 4 | 0){
                                                case 0:
                                                case 4:
                                                    o[f + 140 | 0] = 45, U(f + 4 | 0, f + 140 | 0, 1);
                                                    break;
                                                default:
                                                    break r;
                                            }
                                            if (i[i[i[f + 4 >> 2] - 12 >> 2] + k >> 2] = 2, P0(f + 4 | 0, l[i[r + 20 >> 2] + e | 0]), e = e + 1 | 0, (e | 0) == 16) break;
                                        }
                                        break e;
                                    }
                                    O4(A, e);
                                    break i;
                                }
                                r = i[f + 56 >> 2];
                                e: {
                                    r: {
                                        if (r & 16) {
                                            k = f + 28 | 0, e = i[f + 52 >> 2], r = i[f + 32 >> 2], e >>> 0 < r >>> 0 ? i[f + 52 >> 2] = r : r = e;
                                            break r;
                                        }
                                        if (!(r & 8)) {
                                            e = 0, o[A + 11 | 0] = 0;
                                            break e;
                                        }
                                        r = i[f + 24 >> 2];
                                    }
                                    r: {
                                        if (k = i[k >> 2], e = r - k | 0, e >>> 0 < 2147483640) {
                                            if (e >>> 0 >= 11) {
                                                u = (e | 7) + 1 | 0, r = D(u), i[A + 8 >> 2] = u | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                                break r;
                                            }
                                            if (o[A + 11 | 0] = e, e) break r;
                                            e = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(A, k, e);
                                }
                                o[A + e | 0] = 0, A = i[15035], i[f + 4 >> 2] = A, i[i[A - 12 >> 2] + (f + 4 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 51 | 0] < 0 && X(i[f + 40 >> 2]), x0(t), N0(n);
                            }
                            m = f + 144 | 0;
                        }
                        function G8(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            i: {
                                e: {
                                    if ((k | 0) <= 0) break e;
                                    if (n = i[A + 8 >> 2], t = i[A + 4 >> 2], (n - t | 0) >= (k | 0)) {
                                        h = t - r | 0;
                                        r: {
                                            if ((h | 0) >= (k | 0)) {
                                                s = e + k | 0, u = t;
                                                break r;
                                            }
                                            if (s = e + h | 0, n = f - s | 0, (f | 0) != (s | 0) && Q0(t, s, n), u = n + t | 0, i[A + 4 >> 2] = u, (h | 0) <= 0) break e;
                                        }
                                        w = r + k | 0, f = u, n = f - k | 0;
                                        r: {
                                            if (t >>> 0 <= n >>> 0) break r;
                                            if (h = k + t | 0, k = h - f & 7, k) for(; o[f | 0] = l[n | 0], f = f + 1 | 0, n = n + 1 | 0, v = v + 1 | 0, (k | 0) != (v | 0););
                                            if (u - h >>> 0 >= 4294967289) break r;
                                            for(; o[f | 0] = l[n | 0], o[f + 1 | 0] = l[n + 1 | 0], o[f + 2 | 0] = l[n + 2 | 0], o[f + 3 | 0] = l[n + 3 | 0], o[f + 4 | 0] = l[n + 4 | 0], o[f + 5 | 0] = l[n + 5 | 0], o[f + 6 | 0] = l[n + 6 | 0], o[f + 7 | 0] = l[n + 7 | 0], f = f + 8 | 0, n = n + 8 | 0, (t | 0) != (n | 0););
                                        }
                                        if (i[A + 4 >> 2] = f, (u | 0) != (w | 0) && (A = u - w | 0, Q0(u - A | 0, r, A)), (e | 0) == (s | 0)) break e;
                                        Q0(r, e, s - e | 0);
                                        return;
                                    }
                                    if (s = i[A >> 2], u = (t - s | 0) + k | 0, (u | 0) < 0) break i;
                                    h = r - s | 0, n = n - s | 0, f = n << 1, w = n >>> 0 >= 1073741823 ? 2147483647 : f >>> 0 > u >>> 0 ? f : u, w ? u = D(w) : u = 0, e = v0(h + u | 0, e, k);
                                    r: {
                                        if ((r | 0) == (s | 0)) {
                                            n = e;
                                            break r;
                                        }
                                        t = h & 3;
                                        A: {
                                            if (!t) {
                                                n = e, f = r;
                                                break A;
                                            }
                                            for(n = e, f = r; n = n - 1 | 0, f = f - 1 | 0, o[n | 0] = l[f | 0], v = v + 1 | 0, (t | 0) != (v | 0););
                                        }
                                        if (s - r >>> 0 <= 4294967292) for(; o[n - 1 | 0] = l[f - 1 | 0], o[n - 2 | 0] = l[f - 2 | 0], o[n - 3 | 0] = l[f - 3 | 0], n = n - 4 | 0, f = f - 4 | 0, o[n | 0] = l[f | 0], (f | 0) != (s | 0););
                                        t = i[A + 4 >> 2];
                                    }
                                    f = e + k | 0, e = t - r | 0, (r | 0) != (t | 0) && Q0(f, r, e), i[A + 4 >> 2] = e + f, r = i[A >> 2], i[A >> 2] = n, i[A + 8 >> 2] = u + w, r && X(r);
                                }
                                return;
                            }
                            p0(), z();
                        }
                        function B_(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                e: {
                                    if (!i[A + 64 >> 2]) break e;
                                    if (!(l[A + 92 | 0] & 16)) {
                                        i[A + 16 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = 0, e = i[A + 52 >> 2];
                                        r: {
                                            if (e >>> 0 >= 9) {
                                                if (l[A + 98 | 0] == 1) {
                                                    n = e, e = i[A + 32 >> 2], i[A + 28 >> 2] = (n + e | 0) - 1, i[A + 20 >> 2] = e, i[A + 24 >> 2] = e;
                                                    break r;
                                                }
                                                e = i[A + 56 >> 2], i[A + 28 >> 2] = (e + i[A + 60 >> 2] | 0) - 1, i[A + 20 >> 2] = e, i[A + 24 >> 2] = e;
                                                break r;
                                            }
                                            i[A + 28 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0;
                                        }
                                        i[A + 92 >> 2] = 16;
                                    }
                                    if (t = i[A + 20 >> 2], u = i[A + 28 >> 2], (r | 0) != -1 && (i[A + 24 >> 2] || (i[A + 28 >> 2] = f + 16, e = f + 15 | 0, i[A + 20 >> 2] = e, i[A + 24 >> 2] = e), o[i[A + 24 >> 2]] = r << 24 >> 24, i[A + 24 >> 2] = i[A + 24 >> 2] + 1), k = i[A + 24 >> 2], e = i[A + 20 >> 2], (k | 0) != (e | 0)) {
                                        r: {
                                            if (l[A + 98 | 0] == 1) {
                                                if (n = e, e = k - e | 0, (E1(n, 1, e, i[A + 64 >> 2]) | 0) != (e | 0)) break e;
                                                break r;
                                            }
                                            for(i[f + 8 >> 2] = i[A + 32 >> 2], s = A + 72 | 0;;){
                                                if (e = i[A + 68 >> 2], e) {
                                                    if (k = i[A + 32 >> 2], e = p[i[i[e >> 2] + 12 >> 2]](e, s, i[A + 20 >> 2], i[A + 24 >> 2], f + 4 | 0, k, k + i[A + 52 >> 2] | 0, f + 8 | 0) | 0, i[A + 20 >> 2] == i[f + 4 >> 2]) break e;
                                                    if ((e | 0) == 3) {
                                                        if (e = i[A + 24 >> 2] - i[A + 20 >> 2] | 0, (E1(i[A + 20 >> 2], 1, e, i[A + 64 >> 2]) | 0) != (e | 0)) break e;
                                                        break r;
                                                    }
                                                    if (e >>> 0 > 1 || (n = i[A + 32 >> 2], k = i[f + 8 >> 2] - n | 0, (E1(n, 1, k, i[A + 64 >> 2]) | 0) != (k | 0))) break e;
                                                    if ((e | 0) != 1) break r;
                                                    e = i[f + 4 >> 2], i[A + 28 >> 2] = i[A + 24 >> 2], i[A + 20 >> 2] = e, i[A + 24 >> 2] = e, i[A + 24 >> 2] = i[A + 24 >> 2] + (i[A + 28 >> 2] - i[A + 20 >> 2] | 0);
                                                    continue;
                                                }
                                                break;
                                            }
                                            w1(), z();
                                        }
                                        i[A + 28 >> 2] = u, i[A + 20 >> 2] = t, i[A + 24 >> 2] = t;
                                    }
                                    A = (r | 0) != -1 ? r : 0;
                                    break i;
                                }
                                A = -1;
                            }
                            return m = f + 16 | 0, A | 0;
                        }
                        function w6(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0;
                            s = m - 160 | 0, m = s;
                            i: {
                                e: {
                                    if (w = i[r + 68 >> 2], h = i[w + 104 >> 2], v = i[w + 108 >> 2], (h | 0) == (v | 0)) break e;
                                    for(;;){
                                        if (i[h >> 2] != (e | 0)) {
                                            if (h = h + 32 | 0, (v | 0) != (h | 0)) continue;
                                            break e;
                                        }
                                        break;
                                    }
                                    ei(A, w, e, r + 8 | 0, r + 76 | 0, f, k, n, t, u, i[r + 136 >> 2]);
                                    break i;
                                }
                                i[s + 24 >> 2] = 59808, i[s + 80 >> 2] = 59828, r = i[14961], i[s + 16 >> 2] = r, f = i[r - 12 >> 2], r = s + 16 | 0, i[f + r >> 2] = i[14962], i[s + 20 >> 2] = 0, f = r + i[i[s + 16 >> 2] - 12 >> 2] | 0, k = s + 28 | 0, T0(f, k), i[f + 72 >> 2] = 0, i[f + 76 >> 2] = -1, f = i[14963], i[s + 24 >> 2] = f, n = s + 24 | 0, i[n + i[f - 12 >> 2] >> 2] = i[14964], f = i[14960], i[s + 16 >> 2] = f, i[r + i[f - 12 >> 2] >> 2] = i[14965], i[s + 80 >> 2] = 59828, i[s + 16 >> 2] = 59788, i[s + 24 >> 2] = 59808, f = z0(k), i[f >> 2] = 58864, i[s + 68 >> 2] = 0, i[s + 72 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 64 >> 2] = 0, i[s + 76 >> 2] = 24, U(M0(U(n, 22593, 13), e), 15606, 23), r = i[s + 76 >> 2];
                                e: {
                                    r: {
                                        if (r & 16) {
                                            h = i[s + 72 >> 2], r = i[s + 52 >> 2], h >>> 0 < r >>> 0 && (i[s + 72 >> 2] = r, h = r), r = s + 48 | 0;
                                            break r;
                                        }
                                        if (!(r & 8)) {
                                            h = 0, o[s + 15 | 0] = 0, e = s + 4 | 0;
                                            break e;
                                        }
                                        h = i[s + 44 >> 2], r = s + 36 | 0;
                                    }
                                    r: {
                                        if (r = i[r >> 2], h = h - r | 0, h >>> 0 < 2147483640) {
                                            if (h >>> 0 >= 11) {
                                                k = (h | 7) + 1 | 0, e = D(k), i[s + 12 >> 2] = k | -2147483648, i[s + 4 >> 2] = e, i[s + 8 >> 2] = h;
                                                break r;
                                            }
                                            if (o[s + 15 | 0] = h, e = s + 4 | 0, h) break r;
                                            h = 0;
                                            break e;
                                        }
                                        Y0(), z();
                                    }
                                    Q0(e, r, h);
                                }
                                o[e + h | 0] = 0, i0(A, 2, 117, s + 4 | 0), o[s + 15 | 0] < 0 && X(i[s + 4 >> 2]), A = i[14959], i[s + 16 >> 2] = A, i[i[A - 12 >> 2] + (s + 16 | 0) >> 2] = i[14967], i[s + 24 >> 2] = i[14968], i[f >> 2] = 58864, o[s + 71 | 0] < 0 && X(i[s + 60 >> 2]), x0(f), N0(s + 80 | 0);
                            }
                            m = s + 160 | 0;
                        }
                        function m_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, t = i[k - 12 >> 2], k = f + 12 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(k, 23979, 10), i[r + 100 >> 2]), 34895, 1), n = f + 148 | 0, G0(n, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(t, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 23968, 10), i[r + 104 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Z_(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            n = m - 32 | 0, m = n, Q3(n + 8 | 0, r, e, f);
                            i: {
                                if (i[n + 8 >> 2]) {
                                    r = i[n + 12 >> 2], i[A >> 2] = i[n + 8 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[n + 24 >> 2], r = i[n + 20 >> 2], i[A + 8 >> 2] = i[n + 16 >> 2], i[A + 12 >> 2] = r, i[n + 24 >> 2] = 0, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0;
                                    break i;
                                }
                                G = r, W = B2(e), Q[G + 120 >> 1] = W, G = r, W = B2(e), Q[G + 122 >> 1] = W;
                                e: {
                                    if (i[r + 112 >> 2] == i[r + 108 >> 2]) break e;
                                    r: {
                                        for(;;){
                                            A: {
                                                h = B2(e), w = B2(e), v = B2(e), f = i[r + 128 >> 2], k = i[r + 132 >> 2];
                                                f: {
                                                    if (f >>> 0 < k >>> 0) {
                                                        Q[f + 4 >> 1] = v, Q[f + 2 >> 1] = w, Q[f >> 1] = h, h = f + 6 | 0;
                                                        break f;
                                                    }
                                                    if (u = i[r + 124 >> 2], t = (f - u | 0) / 6 | 0, s = t + 1 | 0, s >>> 0 >= 715827883) break A;
                                                    if (B = Z(t, 6), k = (k - u | 0) / 6 | 0, t = k << 1, t = k >>> 0 >= 357913941 ? 715827882 : t >>> 0 > s >>> 0 ? t : s, t) {
                                                        if (t >>> 0 >= 715827883) break r;
                                                        s = D(Z(t, 6));
                                                    } else s = 0;
                                                    if (k = B + s | 0, Q[k + 4 >> 1] = v, Q[k + 2 >> 1] = w, Q[k >> 1] = h, h = k + 6 | 0, (f | 0) != (u | 0)) {
                                                        for(; k = k - 6 | 0, f = f - 6 | 0, w = I[f >> 1] | I[f + 2 >> 1] << 16, Q[k >> 1] = w, Q[k + 2 >> 1] = w >>> 16, Q[k + 4 >> 1] = I[f + 4 >> 1], (f | 0) != (u | 0););
                                                        u = i[r + 124 >> 2];
                                                    }
                                                    if (i[r + 132 >> 2] = s + Z(t, 6), i[r + 128 >> 2] = h, i[r + 124 >> 2] = k, !u) break f;
                                                    X(u);
                                                }
                                                if (i[r + 128 >> 2] = h, _ = _ + 1 | 0, _ >>> 0 < i[r + 112 >> 2] - i[r + 108 >> 2] >> 2 >>> 0) continue;
                                                break e;
                                            }
                                            break;
                                        }
                                        p0(), z();
                                    }
                                    Z2(), z();
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), m = n + 32 | 0;
                        }
                        function ge(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0;
                            _ = m - 2048 | 0, m = _;
                            i: {
                                if ((r | 0) < 2) {
                                    h = -1, F = 6, u = -2, E = 32, s = 5;
                                    break i;
                                }
                                for(k = r; h = n, n = n + 1 | 0, s = k >>> 0 > 3, k = k >>> 1 | 0, !!s;);
                                for(n = 0, k = r; t = n, n = n + 1 | 0, s = k >>> 0 > 3, k = k >>> 1 | 0, !!s;);
                                for(u = h - 1 | 0, n = 0, k = r; s = n, n = n + 1 | 0, B = k >>> 0 > 3, k = k >>> 1 | 0, !!B;);
                                E = 64 << t, F = t + 7 | 0, s = 4 - s | 0;
                            }
                            i: {
                                if ((r | 0) <= 0) break i;
                                for(G = 1 << u, C = r & 2147483646, B = r & 1, R = r - 1 | 0;;){
                                    for(V = (W << 1) + e | 0, u = 0;;){
                                        if (w = u << s, k = 0, n = 0, v = 0, R) for(; t = k | 1, M = Q[V + (Z(t, f) << 1) >> 1], y = t, t = (w << 5) + 49296 | 0, n = Z(M, o[y + t | 0]) + (Z(Q[V + (Z(f, k) << 1) >> 1], o[k + t | 0]) + n | 0) | 0, k = k + 2 | 0, v = v + 2 | 0, (C | 0) != (v | 0););
                                        if (t = (Z(r, u) + W << 1) + _ | 0, B && (n = Z(Q[V + (Z(f, k) << 1) >> 1], o[((w << 5) + k | 0) + 49296 | 0]) + n | 0), Q[t >> 1] = n + G >> h, u = u + 1 | 0, (u | 0) == (r | 0)) break;
                                    }
                                    if (W = W + 1 | 0, (W | 0) == (r | 0)) break;
                                }
                                if ((r | 0) <= 0) break i;
                                for(C = r & 2147483646, B = r & 1, h = 0;;){
                                    for(w = Z(r, h), t = (w << 1) + A | 0, e = 0;;){
                                        if (G = e << s, k = 0, n = 0, v = 0, R) for(; f = k | 1, u = Q[(f + w << 1) + _ >> 1], y = f, f = (G << 5) + 49296 | 0, n = Z(u, o[y + f | 0]) + (Z(Q[(k + w << 1) + _ >> 1], o[f + k | 0]) + n | 0) | 0, k = k + 2 | 0, v = v + 2 | 0, (C | 0) != (v | 0););
                                        if (f = t + (e << 1) | 0, B && (n = Z(Q[(k + w << 1) + _ >> 1], o[((G << 5) + k | 0) + 49296 | 0]) + n | 0), Q[f >> 1] = n + E >> F, e = e + 1 | 0, (e | 0) == (r | 0)) break;
                                    }
                                    if (h = h + 1 | 0, (h | 0) == (r | 0)) break;
                                }
                            }
                            m = _ + 2048 | 0;
                        }
                        function G_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, t = i[k - 12 >> 2], k = f + 12 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, k = o[f + 159 | 0], n = (k | 0) < 0, U(f + 12 | 0, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 12 | 0, U(M0(U(k, 23781, 25), I[r + 98 >> 1]), 34895, 1), n = f + 148 | 0, G0(n, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(t, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 23807, 29), I[r + 100 >> 1]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function W_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = J(0);
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, BA(A + 192 | 0, f, A + 208 | 0, A + 207 | 0, A + 206 | 0), e = m - 16 | 0, m = e, r = A + 180 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 176 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0, o[A + 7 | 0] = 1, o[A + 6 | 0] = 69;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 176 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 176 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[u | 0];
                                    }
                                    if (E3(f << 24 >> 24, A + 7 | 0, A + 6 | 0, e, A + 176 | 0, o[A + 207 | 0], o[A + 206 | 0], A + 192 | 0, A + 16 | 0, A + 12 | 0, A + 8 | 0, A + 208 | 0)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 203 | 0] >>> 7 | 0 ? f = i[A + 196 >> 2] : f = l[A + 203 | 0] & 127;
                            i: {
                                if (!f | l[A + 7 | 0] != 1 || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return s = n, h = l9(e, i[A + 176 >> 2], k), W0[s >> 2] = h, L1(A + 192 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 192 | 0), m = A + 256 | 0, e | 0;
                        }
                        function X_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, BA(A + 192 | 0, f, A + 208 | 0, A + 207 | 0, A + 206 | 0), e = m - 16 | 0, m = e, r = A + 180 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 176 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0, o[A + 7 | 0] = 1, o[A + 6 | 0] = 69;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 176 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 176 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[u | 0];
                                    }
                                    if (E3(f << 24 >> 24, A + 7 | 0, A + 6 | 0, e, A + 176 | 0, o[A + 207 | 0], o[A + 206 | 0], A + 192 | 0, A + 16 | 0, A + 12 | 0, A + 8 | 0, A + 208 | 0)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 203 | 0] >>> 7 | 0 ? f = i[A + 196 >> 2] : f = l[A + 203 | 0] & 127;
                            i: {
                                if (!f | l[A + 7 | 0] != 1 || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return s = n, h = h9(e, i[A + 176 >> 2], k), n0[s >> 3] = h, L1(A + 192 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 192 | 0), m = A + 256 | 0, e | 0;
                        }
                        function p_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, n = i[15036], i[f + 12 >> 2] = n, k = i[n - 12 >> 2], n = f + 12 | 0, i[k + n >> 2] = i[15037], t = n + i[i[f + 12 >> 2] - 12 >> 2] | 0, k = f + 16 | 0, T0(t, k), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(k), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, k = f + 148 | 0, D2(k, r, e), s = n, u = k, n = o[f + 159 | 0], k = (n | 0) < 0, U(s, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = f + 148 | 0, G0(n, e), u = n, n = o[f + 159 | 0], k = (n | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), n = U(M0(U(f + 12 | 0, 23913, 13), i[r + 104 >> 2]), 34895, 1), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(n, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(n, 22945, 14), i[r + 108 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Q_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = J(0);
                            for(A = m - 368 | 0, m = A, i[A + 360 >> 2] = e, i[A + 364 >> 2] = r, _A(A + 204 | 0, f, A + 224 | 0, A + 220 | 0, A + 216 | 0), e = m - 16 | 0, m = e, r = A + 192 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 188 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0, o[A + 7 | 0] = 1, o[A + 6 | 0] = 69;;){
                                i: {
                                    if (S2(A + 364 | 0, A + 360 | 0)) break i;
                                    t = i[A + 188 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 188 >> 2] = f + e), t = A + 364 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[u >> 2];
                                    }
                                    if (Y3(f, A + 7 | 0, A + 6 | 0, e, A + 188 | 0, i[A + 220 >> 2], i[A + 216 >> 2], A + 204 | 0, A + 16 | 0, A + 12 | 0, A + 8 | 0, A + 224 | 0)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 215 | 0] >>> 7 | 0 ? f = i[A + 208 >> 2] : f = l[A + 215 | 0] & 127;
                            i: {
                                if (!f | l[A + 7 | 0] != 1 || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return s = n, h = l9(e, i[A + 188 >> 2], k), W0[s >> 2] = h, L1(A + 204 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 364 | 0, A + 360 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 364 >> 2], a0(r), a0(A + 204 | 0), m = A + 368 | 0, e | 0;
                        }
                        function C_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0;
                            for(A = m - 368 | 0, m = A, i[A + 360 >> 2] = e, i[A + 364 >> 2] = r, _A(A + 204 | 0, f, A + 224 | 0, A + 220 | 0, A + 216 | 0), e = m - 16 | 0, m = e, r = A + 192 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 188 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0, o[A + 7 | 0] = 1, o[A + 6 | 0] = 69;;){
                                i: {
                                    if (S2(A + 364 | 0, A + 360 | 0)) break i;
                                    t = i[A + 188 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 188 >> 2] = f + e), t = A + 364 | 0, f = i[t >> 2], u = i[f + 12 >> 2];
                                    e: {
                                        if ((u | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[u >> 2];
                                    }
                                    if (Y3(f, A + 7 | 0, A + 6 | 0, e, A + 188 | 0, i[A + 220 >> 2], i[A + 216 >> 2], A + 204 | 0, A + 16 | 0, A + 12 | 0, A + 8 | 0, A + 224 | 0)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 215 | 0] >>> 7 | 0 ? f = i[A + 208 >> 2] : f = l[A + 215 | 0] & 127;
                            i: {
                                if (!f | l[A + 7 | 0] != 1 || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return s = n, h = h9(e, i[A + 188 >> 2], k), n0[s >> 3] = h, L1(A + 204 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 364 | 0, A + 360 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 364 >> 2], a0(r), a0(A + 204 | 0), m = A + 368 | 0, e | 0;
                        }
                        function I5(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            i: {
                                e: {
                                    if (!e) {
                                        if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 172 >> 2], r = i[r + 168 >> 2], (e | 0) == (r | 0)) break e;
                                        if (k = e - r | 0, (k | 0) < 0) break i;
                                        for(f = D(k), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + k; i[f >> 2] = i[r >> 2], k = i[r + 4 >> 2], i[f + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), f = f + 8 | 0, r = r + 8 | 0, (e | 0) != (r | 0););
                                        i[A + 4 >> 2] = f;
                                        return;
                                    }
                                    if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 168 >> 2], k = i[r + 172 >> 2], (f | 0) == (k | 0)) break e;
                                    if (n = e & 4, !(e & 2)) {
                                        if (r = 0, !n) for(;;){
                                            r: {
                                                if (k0[A + 8 >> 2] <= r >>> 0) {
                                                    r = P2(A, f);
                                                    break r;
                                                }
                                                i[r >> 2] = i[f >> 2], e = i[f + 4 >> 2], i[r + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r = r + 8 | 0;
                                            }
                                            if (i[A + 4 >> 2] = r, f = f + 8 | 0, (k | 0) == (f | 0)) break e;
                                        }
                                        for(;;){
                                            if (e = i[f >> 2], !l[e + 76 | 0]) {
                                                r: {
                                                    if (k0[A + 8 >> 2] <= r >>> 0) {
                                                        r = P2(A, f);
                                                        break r;
                                                    }
                                                    i[r >> 2] = e, e = i[f + 4 >> 2], i[r + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r = r + 8 | 0;
                                                }
                                                i[A + 4 >> 2] = r;
                                            }
                                            if (f = f + 8 | 0, (k | 0) == (f | 0)) break;
                                        }
                                        break e;
                                    }
                                    if (r = 0, !n) for(;;){
                                        if (e = i[f >> 2], !l[e + 64 | 0]) {
                                            r: {
                                                if (k0[A + 8 >> 2] <= r >>> 0) {
                                                    r = P2(A, f);
                                                    break r;
                                                }
                                                i[r >> 2] = e, e = i[f + 4 >> 2], i[r + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r = r + 8 | 0;
                                            }
                                            i[A + 4 >> 2] = r;
                                        }
                                        if (f = f + 8 | 0, (k | 0) == (f | 0)) break e;
                                    }
                                    for(;;){
                                        if (e = i[f >> 2], !(l[e + 64 | 0] | l[e + 76 | 0])) {
                                            r: {
                                                if (k0[A + 8 >> 2] > r >>> 0) {
                                                    i[r >> 2] = e, e = i[f + 4 >> 2], i[r + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r = r + 8 | 0;
                                                    break r;
                                                }
                                                r = P2(A, f);
                                            }
                                            i[A + 4 >> 2] = r;
                                        }
                                        if (f = f + 8 | 0, (k | 0) == (f | 0)) break;
                                    }
                                }
                                return;
                            }
                            p0(), z();
                        }
                        function V_(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            r = m - 48 | 0, m = r, e = D(40), i[r + 12 >> 2] = e, i[r + 16 >> 2] = 32, i[r + 20 >> 2] = -2147483608, k = l[3842] | l[3843] << 8 | (l[3844] << 16 | l[3845] << 24), f = l[3838] | l[3839] << 8 | (l[3840] << 16 | l[3841] << 24), o[e + 24 | 0] = f, o[e + 25 | 0] = f >>> 8, o[e + 26 | 0] = f >>> 16, o[e + 27 | 0] = f >>> 24, o[e + 28 | 0] = k, o[e + 29 | 0] = k >>> 8, o[e + 30 | 0] = k >>> 16, o[e + 31 | 0] = k >>> 24, k = l[3834] | l[3835] << 8 | (l[3836] << 16 | l[3837] << 24), f = l[3830] | l[3831] << 8 | (l[3832] << 16 | l[3833] << 24), o[e + 16 | 0] = f, o[e + 17 | 0] = f >>> 8, o[e + 18 | 0] = f >>> 16, o[e + 19 | 0] = f >>> 24, o[e + 20 | 0] = k, o[e + 21 | 0] = k >>> 8, o[e + 22 | 0] = k >>> 16, o[e + 23 | 0] = k >>> 24, k = l[3826] | l[3827] << 8 | (l[3828] << 16 | l[3829] << 24), f = l[3822] | l[3823] << 8 | (l[3824] << 16 | l[3825] << 24), o[e + 8 | 0] = f, o[e + 9 | 0] = f >>> 8, o[e + 10 | 0] = f >>> 16, o[e + 11 | 0] = f >>> 24, o[e + 12 | 0] = k, o[e + 13 | 0] = k >>> 8, o[e + 14 | 0] = k >>> 16, o[e + 15 | 0] = k >>> 24, k = l[3818] | l[3819] << 8 | (l[3820] << 16 | l[3821] << 24), f = l[3814] | l[3815] << 8 | (l[3816] << 16 | l[3817] << 24), o[e | 0] = f, o[e + 1 | 0] = f >>> 8, o[e + 2 | 0] = f >>> 16, o[e + 3 | 0] = f >>> 24, o[e + 4 | 0] = k, o[e + 5 | 0] = k >>> 8, o[e + 6 | 0] = k >>> 16, o[e + 7 | 0] = k >>> 24, o[e + 32 | 0] = 0, f = i0(r + 24 | 0, 4, 6003, r + 12 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[f + 4 >> 2], i[A + 8 >> 2] = i[f >> 2], i[A + 12 >> 2] = e, e = A + 16 | 0;
                            i: {
                                if (o[f + 19 | 0] >= 0) {
                                    A = i[f + 12 >> 2], i[e >> 2] = i[f + 8 >> 2], i[e + 4 >> 2] = A, i[e + 8 >> 2] = i[f + 16 >> 2];
                                    break i;
                                }
                                if (j(e, i[f + 8 >> 2], i[f + 12 >> 2]), o[f + 19 | 0] >= 0) break i;
                                X(i[f + 8 >> 2]);
                            }
                            o[r + 23 | 0] < 0 && X(i[r + 12 >> 2]), m = r + 48 | 0;
                        }
                        function y_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = i[r + 100 >> 2], r = i[r + 104 >> 2], (k | 0) != (r | 0)) for(; n = f + 148 | 0, G0(n, e), s = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(f + 12 | 0, u ? i[f + 148 >> 2] : s, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(M0(U(M0(U(f + 12 | 0, 22764, 15), I[k >> 1]), 24397, 16), I[k + 2 >> 1]), 23631, 23), I[k + 4 >> 1]), 34895, 1), k = k + 6 | 0, (r | 0) != (k | 0););
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        k = i[f + 60 >> 2], r = i[f + 40 >> 2], k >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, k = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        k = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    k = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (e = i[r >> 2], k = k - e | 0, k >>> 0 < 2147483640) {
                                        if (k >>> 0 >= 11) {
                                            n = (k | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = k, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = k, k) break e;
                                        k = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, e, k);
                            }
                            o[A + k | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function I_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = i[r + 104 >> 2], r = i[r + 108 >> 2], (k | 0) != (r | 0)) for(; n = f + 148 | 0, G0(n, e), s = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(f + 12 | 0, u ? i[f + 148 >> 2] : s, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(P0(U(M0(U(f + 12 | 0, 24677, 10), I[k >> 1]), 23172, 18), l[k + 2 | 0]), 23154, 17), I[k + 4 >> 1]), 34895, 1), k = k + 6 | 0, (r | 0) != (k | 0););
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        k = i[f + 60 >> 2], r = i[f + 40 >> 2], k >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, k = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        k = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    k = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (e = i[r >> 2], k = k - e | 0, k >>> 0 < 2147483640) {
                                        if (k >>> 0 >= 11) {
                                            n = (k | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = k, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = k, k) break e;
                                        k = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, e, k);
                            }
                            o[A + k | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function F_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, n = i[k - 12 >> 2], k = f + 12 | 0, i[n + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), u = k, s = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(u, n ? i[f + 148 >> 2] : s, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = i[r + 100 >> 2], r = i[r + 104 >> 2], (k | 0) != (r | 0)) for(; n = f + 148 | 0, G0(n, e), s = n, n = o[f + 159 | 0], u = (n | 0) < 0, U(f + 12 | 0, u ? i[f + 148 >> 2] : s, u ? i[f + 152 >> 2] : n), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(P0(U(M0(U(f + 12 | 0, 22722, 17), I[k >> 1]), 24414, 16), l[k + 2 | 0]), 23504, 18), l[k + 3 | 0]), 34895, 1), k = k + 4 | 0, (r | 0) != (k | 0););
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        k = i[f + 60 >> 2], r = i[f + 40 >> 2], k >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, k = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        k = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    k = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (e = i[r >> 2], k = k - e | 0, k >>> 0 < 2147483640) {
                                        if (k >>> 0 >= 11) {
                                            n = (k | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = k, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = k, k) break e;
                                        k = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, e, k);
                            }
                            o[A + k | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function Y_(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            h = m - 16 | 0, m = h;
                            i: {
                                if ((e | 0) < 0) break i;
                                A = i[A >> 2], n = i[A + 48 >> 2], A = i[A + 52 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), u = i[n + 84 >> 2], s = i[n + 88 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1);
                                e: {
                                    if (!A || (n = i[A + 4 >> 2], i[A + 4 >> 2] = n - 1, n)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                e: {
                                    if (!u) {
                                        n = 0;
                                        break e;
                                    }
                                    pA(h + 4 | 0, u, r), A = i[h + 8 >> 2], u = i[h + 4 >> 2];
                                    r: {
                                        if (((A - u | 0) / 56 | 0) > (e | 0)) {
                                            e = u + Z(e, 56) | 0, f && (i[f >> 2] = i[e + 16 >> 2]);
                                            A: {
                                                if (!k) {
                                                    r = i[e + 44 >> 2], n = i[e + 48 >> 2];
                                                    break A;
                                                }
                                                if (r = i[e + 48 >> 2] - i[e + 44 >> 2] | 0, w = D((r | 0) < 0 ? -1 : r), i[k >> 2] = w, r = i[e + 44 >> 2], n = i[e + 48 >> 2], (r | 0) == (n | 0)) {
                                                    r = n;
                                                    break A;
                                                }
                                                if (f = n - r >> 2, t = f >>> 0 <= 1 ? 1 : f, _ = t & 3, k = 0, e = 0, f >>> 0 >= 4) for(B = t & -4, f = 0; t = e << 2, i[t + w >> 2] = i[r + t >> 2], v = t | 4, i[v + w >> 2] = i[r + v >> 2], v = t | 8, i[v + w >> 2] = i[r + v >> 2], t = t | 12, i[t + w >> 2] = i[r + t >> 2], e = e + 4 | 0, f = f + 4 | 0, (B | 0) != (f | 0););
                                                if (!_) break A;
                                                for(; f = e << 2, i[f + w >> 2] = i[r + f >> 2], e = e + 1 | 0, k = k + 1 | 0, (_ | 0) != (k | 0););
                                            }
                                            n = n - r >> 2;
                                            break r;
                                        }
                                        if (n = 0, !u) break e;
                                    }
                                    if ((A | 0) == (u | 0)) A = u;
                                    else {
                                        for(; r = i[A - 12 >> 2], r && (i[A - 8 >> 2] = r, X(r)), r = A - 56 | 0, i[r >> 2] = 73428, e = i[A - 36 >> 2], e && (i[A - 32 >> 2] = e, X(e)), A = r, (u | 0) != (A | 0););
                                        A = i[h + 4 >> 2];
                                    }
                                    i[h + 8 >> 2] = u, X(A);
                                }
                                if (!s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            return m = h + 16 | 0, n | 0;
                        }
                        function E_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, r = m - 16 | 0, m = r, u = A + 196 | 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, m = r + 16 | 0, t = A + 16 | 0, r = i[f + 28 >> 2], i[t >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(t, 108580), p[i[i[r >> 2] + 32 >> 2]](r, 64960, 64986, A + 208 | 0), d0(t), r = m - 16 | 0, m = r, e = A + 184 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, m = r + 16 | 0, G2(e, l[e + 11 | 0] >>> 7 | 0 ? (i[e + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, i[A + 180 >> 2] = r, i[A + 12 >> 2] = t, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[e + 11 | 0] >>> 7 | 0 ? f = i[e + 4 >> 2] : f = l[e + 11 | 0] & 127, (t | 0) == (f + r | 0) && (l[e + 11 | 0] >>> 7 | 0 ? r = i[e + 4 >> 2] : r = l[e + 11 | 0] & 127, l[e + 11 | 0] >>> 7 | 0 ? f = i[e + 4 >> 2] : f = l[e + 11 | 0] & 127, G2(e, f << 1), G2(e, l[e + 11 | 0] >>> 7 | 0 ? (i[e + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = r, l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, i[A + 180 >> 2] = f + r), s = A + 252 | 0, f = i[s >> 2], t = i[f + 12 >> 2];
                                    e: {
                                        if ((t | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[t | 0];
                                    }
                                    if (m6(f << 24 >> 24, 16, r, A + 180 | 0, A + 8 | 0, 0, u, A + 16 | 0, A + 12 | 0, A + 208 | 0)) break i;
                                    g1(s);
                                    continue;
                                }
                                break;
                            }
                            return G2(e, i[A + 180 >> 2] - r | 0), l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, f = L2(), i[A >> 2] = n, (ht(r, f, A) | 0) != 1 && (i[k >> 2] = 4), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), r = i[A + 252 >> 2], a0(e), a0(u), m = A + 256 | 0, r | 0;
                        }
                        function g_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            for(A = m - 320 | 0, m = A, i[A + 312 >> 2] = e, i[A + 316 >> 2] = r, r = m - 16 | 0, m = r, u = A + 196 | 0, i[u >> 2] = 0, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, m = r + 16 | 0, t = A + 16 | 0, r = i[f + 28 >> 2], i[t >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(t, 108572), p[i[i[r >> 2] + 48 >> 2]](r, 64960, 64986, A + 208 | 0), d0(t), r = m - 16 | 0, m = r, e = A + 184 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, m = r + 16 | 0, G2(e, l[e + 11 | 0] >>> 7 | 0 ? (i[e + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, i[A + 180 >> 2] = r, i[A + 12 >> 2] = t, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 316 | 0, A + 312 | 0)) break i;
                                    t = i[A + 180 >> 2], l[e + 11 | 0] >>> 7 | 0 ? f = i[e + 4 >> 2] : f = l[e + 11 | 0] & 127, (t | 0) == (f + r | 0) && (l[e + 11 | 0] >>> 7 | 0 ? r = i[e + 4 >> 2] : r = l[e + 11 | 0] & 127, l[e + 11 | 0] >>> 7 | 0 ? f = i[e + 4 >> 2] : f = l[e + 11 | 0] & 127, G2(e, f << 1), G2(e, l[e + 11 | 0] >>> 7 | 0 ? (i[e + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = r, l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, i[A + 180 >> 2] = f + r), s = A + 316 | 0, f = i[s >> 2], t = i[f + 12 >> 2];
                                    e: {
                                        if ((t | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[t >> 2];
                                    }
                                    if (Z6(f, 16, r, A + 180 | 0, A + 8 | 0, 0, u, A + 16 | 0, A + 12 | 0, A + 208 | 0)) break i;
                                    J1(s);
                                    continue;
                                }
                                break;
                            }
                            return G2(e, i[A + 180 >> 2] - r | 0), l[e + 11 | 0] >>> 7 | 0 ? r = i[e >> 2] : r = e, f = L2(), i[A >> 2] = n, (ht(r, f, A) | 0) != 1 && (i[k >> 2] = 4), S2(A + 316 | 0, A + 312 | 0) && (i[k >> 2] = i[k >> 2] | 2), r = i[A + 316 >> 2], a0(e), a0(u), m = A + 320 | 0, r | 0;
                        }
                        function J_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            for(A = m - 336 | 0, m = A, i[A + 328 >> 2] = e, i[A + 332 >> 2] = r, u = k8(f), h = Ui(f, A + 208 | 0), Di(A + 196 | 0, f, A + 324 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 332 | 0, A + 328 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 332 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[s >> 2];
                                    }
                                    if (Z6(f, u, e, A + 180 | 0, A + 8 | 0, i[A + 324 >> 2], A + 196 | 0, A + 16 | 0, A + 12 | 0, h)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return w = n, v = o9(e, i[A + 180 >> 2], k, u), i[w >> 2] = v, i[n + 4 >> 2] = w0, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 332 | 0, A + 328 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 332 >> 2], a0(r), a0(A + 196 | 0), m = A + 336 | 0, e | 0;
                        }
                        function R_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            for(A = m - 336 | 0, m = A, i[A + 328 >> 2] = e, i[A + 332 >> 2] = r, u = k8(f), h = Ui(f, A + 208 | 0), Di(A + 196 | 0, f, A + 324 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 332 | 0, A + 328 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 332 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[s >> 2];
                                    }
                                    if (Z6(f, u, e, A + 180 | 0, A + 8 | 0, i[A + 324 >> 2], A + 196 | 0, A + 16 | 0, A + 12 | 0, h)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return w = n, v = Pn(e, i[A + 180 >> 2], k, u), i[w >> 2] = v, i[n + 4 >> 2] = w0, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 332 | 0, A + 328 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 332 >> 2], a0(r), a0(A + 196 | 0), m = A + 336 | 0, e | 0;
                        }
                        function N_(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            s = m - 256 | 0, m = s, i[s + 248 >> 2] = 37, i[s + 252 >> 2] = 0, w = s + 248 | 0, v = be(w | 1, 16167, i[e + 4 >> 2]), h = s + 208 | 0, i[s + 204 >> 2] = h, A = L2();
                            i: {
                                if (v) {
                                    B = i[e + 8 >> 2], _ = s - -64 | 0, i[_ >> 2] = t, i[_ + 4 >> 2] = u, i[s + 56 >> 2] = k, i[s + 60 >> 2] = n, i[s + 48 >> 2] = B, A = c1(h, 30, A, w, s + 48 | 0);
                                    break i;
                                }
                                i[s + 80 >> 2] = k, i[s + 84 >> 2] = n, i[s + 88 >> 2] = t, i[s + 92 >> 2] = u, A = c1(s + 208 | 0, 30, A, s + 248 | 0, s + 80 | 0);
                            }
                            i[s + 128 >> 2] = 1413, w = s1(s + 196 | 0, 0, s + 128 | 0), h = s + 208 | 0;
                            i: {
                                e: {
                                    if ((A | 0) >= 30) {
                                        A = L2();
                                        r: {
                                            if (v) {
                                                h = i[e + 8 >> 2], i[s + 16 >> 2] = t, i[s + 20 >> 2] = u, i[s + 8 >> 2] = k, i[s + 12 >> 2] = n, i[s >> 2] = h, A = e8(s + 204 | 0, A, s + 248 | 0, s);
                                                break r;
                                            }
                                            i[s + 32 >> 2] = k, i[s + 36 >> 2] = n, i[s + 40 >> 2] = t, i[s + 44 >> 2] = u, A = e8(s + 204 | 0, A, s + 248 | 0, s + 32 | 0);
                                        }
                                        if ((A | 0) == -1) break e;
                                        k = i[w >> 2], i[w >> 2] = i[s + 204 >> 2], k && p[i[w + 4 >> 2]](k), h = i[s + 204 >> 2];
                                    }
                                    k = h, h = A + h | 0, v = W4(k, h, e), i[s + 128 >> 2] = 1413, k = s + 128 | 0, n = s1(s + 120 | 0, 0, k), t = i[s + 204 >> 2];
                                    r: {
                                        if ((t | 0) == (s + 208 | 0)) {
                                            A = k;
                                            break r;
                                        }
                                        if (A = Q2(A << 1), !A) break e;
                                        k = i[n >> 2], i[n >> 2] = A, k && p[i[n + 4 >> 2]](k), t = i[s + 204 >> 2];
                                    }
                                    u = s + 108 | 0, k = i[e + 28 >> 2], i[u >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), Z5(t, v, h, A, s + 116 | 0, s + 112 | 0, u), d0(u), A = p8(r, A, i[s + 116 >> 2], i[s + 112 >> 2], e, f), r = i[n >> 2], i[n >> 2] = 0, r && p[i[n + 4 >> 2]](r), r = i[w >> 2], i[w >> 2] = 0, r && p[i[w + 4 >> 2]](r), m = s + 256 | 0;
                                    break i;
                                }
                                w1(), z();
                            }
                            return A | 0;
                        }
                        function D_(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            s = m - 416 | 0, m = s, i[s + 408 >> 2] = 37, i[s + 412 >> 2] = 0, w = s + 408 | 0, v = be(w | 1, 16167, i[e + 4 >> 2]), h = s + 368 | 0, i[s + 364 >> 2] = h, A = L2();
                            i: {
                                if (v) {
                                    B = i[e + 8 >> 2], _ = s - -64 | 0, i[_ >> 2] = t, i[_ + 4 >> 2] = u, i[s + 56 >> 2] = k, i[s + 60 >> 2] = n, i[s + 48 >> 2] = B, A = c1(h, 30, A, w, s + 48 | 0);
                                    break i;
                                }
                                i[s + 80 >> 2] = k, i[s + 84 >> 2] = n, i[s + 88 >> 2] = t, i[s + 92 >> 2] = u, A = c1(s + 368 | 0, 30, A, s + 408 | 0, s + 80 | 0);
                            }
                            i[s + 128 >> 2] = 1413, w = s1(s + 356 | 0, 0, s + 128 | 0), h = s + 368 | 0;
                            i: {
                                e: {
                                    if ((A | 0) >= 30) {
                                        A = L2();
                                        r: {
                                            if (v) {
                                                h = i[e + 8 >> 2], i[s + 16 >> 2] = t, i[s + 20 >> 2] = u, i[s + 8 >> 2] = k, i[s + 12 >> 2] = n, i[s >> 2] = h, A = e8(s + 364 | 0, A, s + 408 | 0, s);
                                                break r;
                                            }
                                            i[s + 32 >> 2] = k, i[s + 36 >> 2] = n, i[s + 40 >> 2] = t, i[s + 44 >> 2] = u, A = e8(s + 364 | 0, A, s + 408 | 0, s + 32 | 0);
                                        }
                                        if ((A | 0) == -1) break e;
                                        k = i[w >> 2], i[w >> 2] = i[s + 364 >> 2], k && p[i[w + 4 >> 2]](k), h = i[s + 364 >> 2];
                                    }
                                    k = h, h = A + h | 0, v = W4(k, h, e), i[s + 128 >> 2] = 1413, k = s + 128 | 0, n = s1(s + 120 | 0, 0, k), t = i[s + 364 >> 2];
                                    r: {
                                        if ((t | 0) == (s + 368 | 0)) {
                                            A = k;
                                            break r;
                                        }
                                        if (A = Q2(A << 3), !A) break e;
                                        k = i[n >> 2], i[n >> 2] = A, k && p[i[n + 4 >> 2]](k), t = i[s + 364 >> 2];
                                    }
                                    u = s + 108 | 0, k = i[e + 28 >> 2], i[u >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), m5(t, v, h, A, s + 116 | 0, s + 112 | 0, u), d0(u), A = X8(r, A, i[s + 116 >> 2], i[s + 112 >> 2], e, f), r = i[n >> 2], i[n >> 2] = 0, r && p[i[n + 4 >> 2]](r), r = i[w >> 2], i[w >> 2] = 0, r && p[i[w + 4 >> 2]](r), m = s + 416 | 0;
                                    break i;
                                }
                                w1(), z();
                            }
                            return A | 0;
                        }
                        function M_(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            n = m - 32 | 0, m = n, z1(n, r, e), o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]);
                            i: {
                                e: {
                                    if (l[r + 97 | 0]) {
                                        s4(A, r, 16425);
                                        break e;
                                    }
                                    if (B4(n + 20 | 0, e), o[r + 115 | 0] < 0 && X(i[r + 104 >> 2]), f = i[n + 24 >> 2], i[r + 104 >> 2] = i[n + 20 >> 2], i[r + 108 >> 2] = f, i[r + 112 >> 2] = i[n + 28 >> 2], i[e + 16 >> 2]) for(;;){
                                        f = X2(e), h = i[r + 120 >> 2], k = i[r + 124 >> 2];
                                        r: {
                                            if (h >>> 0 < k >>> 0) {
                                                o[h | 0] = f, t = h + 1 | 0;
                                                break r;
                                            }
                                            if (s = i[r + 116 >> 2], w = h - s | 0, u = w + 1 | 0, (u | 0) < 0) break i;
                                            k = k - s | 0, t = k << 1, t = k >>> 0 >= 1073741823 ? 2147483647 : t >>> 0 > u >>> 0 ? t : u, t ? u = D(t) : u = 0, k = w + u | 0, o[k | 0] = f, _ = t + u | 0, t = k + 1 | 0;
                                            A: {
                                                if ((s | 0) == (h | 0)) {
                                                    u = k;
                                                    break A;
                                                }
                                                if (v = 0, f = h, w = w & 3, w) for(; k = k - 1 | 0, f = f - 1 | 0, o[k | 0] = l[f | 0], v = v + 1 | 0, (w | 0) != (v | 0););
                                                if (s - h >>> 0 <= 4294967292) for(; o[k - 1 | 0] = l[f - 1 | 0], o[k - 2 | 0] = l[f - 2 | 0], o[k - 3 | 0] = l[f - 3 | 0], k = k - 4 | 0, f = f - 4 | 0, o[k | 0] = l[f | 0], (f | 0) != (s | 0););
                                                s = i[r + 116 >> 2];
                                            }
                                            if (i[r + 124 >> 2] = _, i[r + 120 >> 2] = t, i[r + 116 >> 2] = u, !s) break r;
                                            X(s);
                                        }
                                        if (i[r + 120 >> 2] = t, !i[e + 16 >> 2]) break;
                                    }
                                    if (l[e + 20 | 0] == 1) {
                                        if (o[n + 20 | 0] = 0, o[n + 31 | 0] = 0, i0(A, 2, 100, n + 20 | 0), o[n + 31 | 0] >= 0) break e;
                                        X(i[n + 20 >> 2]);
                                        break e;
                                    }
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                m = n + 32 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function U_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(f + 12 | 0, 23578, 18);
                            i: {
                                e: switch(i[r + 100 >> 2] + 1 | 0){
                                    case 1:
                                        U(f + 12 | 0, 25584, 9);
                                        break i;
                                    case 2:
                                        U(f + 12 | 0, 25555, 11);
                                        break i;
                                    case 0:
                                        break e;
                                    default:
                                        break i;
                                }
                                U(f + 12 | 0, 25789, 8);
                            }
                            r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function W8(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            s = m - 16 | 0, m = s, i[s + 8 >> 2] = e, i[s + 12 >> 2] = r, e = s + 4 | 0, r = i[f + 28 >> 2], i[e >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), h = K0(e, 108572), d0(e), i[k >> 2] = 0, r = 0;
                            i: {
                                for(;;){
                                    if (r | (t | 0) == (u | 0)) break i;
                                    e: {
                                        if (S2(s + 12 | 0, s + 8 | 0)) break e;
                                        r: {
                                            if ((p[i[i[h >> 2] + 52 >> 2]](h, i[t >> 2], 0) | 0) == 37) {
                                                if ((t + 4 | 0) == (u | 0)) break e;
                                                e = 0;
                                                A: {
                                                    f: {
                                                        if (r = p[i[i[h >> 2] + 52 >> 2]](h, i[t + 4 >> 2], 0) | 0, (r | 0) == 69 || (w = 4, (r & 255) == 48)) break f;
                                                        break A;
                                                    }
                                                    if ((t + 8 | 0) == (u | 0)) break e;
                                                    w = 8, e = r, r = p[i[i[h >> 2] + 52 >> 2]](h, i[t + 8 >> 2], 0) | 0;
                                                }
                                                v = s, _ = p[i[i[A >> 2] + 36 >> 2]](A, i[s + 12 >> 2], i[s + 8 >> 2], f, k, n, r, e) | 0, i[v + 12 >> 2] = _, t = (t + w | 0) + 4 | 0;
                                                break r;
                                            }
                                            if (p[i[i[h >> 2] + 12 >> 2]](h, 1, i[t >> 2]) | 0) {
                                                for(; t = t + 4 | 0, !!((u | 0) != (t | 0) && p[i[i[h >> 2] + 12 >> 2]](h, 1, i[t >> 2]) | 0););
                                                for(;;){
                                                    if (e = s + 12 | 0, S2(e, s + 8 | 0)) break r;
                                                    r = i[e >> 2], w = i[r + 12 >> 2];
                                                    A: {
                                                        if ((w | 0) == i[r + 16 >> 2]) {
                                                            r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                            break A;
                                                        }
                                                        r = i[w >> 2];
                                                    }
                                                    if (!(p[i[i[h >> 2] + 12 >> 2]](h, 1, r) | 0)) break r;
                                                    J1(e);
                                                }
                                            }
                                            w = s + 12 | 0, r = i[w >> 2], e = i[r + 12 >> 2];
                                            A: {
                                                if ((e | 0) == i[r + 16 >> 2]) {
                                                    r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                                    break A;
                                                }
                                                r = i[e >> 2];
                                            }
                                            if ((p[i[i[h >> 2] + 28 >> 2]](h, r) | 0) == (p[i[i[h >> 2] + 28 >> 2]](h, i[t >> 2]) | 0)) {
                                                t = t + 4 | 0, J1(w);
                                                break r;
                                            }
                                            i[k >> 2] = 4;
                                        }
                                        r = i[k >> 2];
                                        continue;
                                    }
                                    break;
                                }
                                i[k >> 2] = 4;
                            }
                            return S2(s + 12 | 0, s + 8 | 0) && (i[k >> 2] = i[k >> 2] | 2), m = s + 16 | 0, i[s + 12 >> 2];
                        }
                        function F5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                e = i[A + 4 >> 2];
                                                k: {
                                                    if ((e | 0) != i[A + 104 >> 2]) {
                                                        i[A + 4 >> 2] = e + 1, e = l[e | 0];
                                                        break k;
                                                    }
                                                    e = M2(A);
                                                }
                                                switch(e - 43 | 0){
                                                    case 0:
                                                    case 2:
                                                        break f;
                                                    default:
                                                        break A;
                                                }
                                            }
                                            t = (e | 0) == 45, r = !r, e = i[A + 4 >> 2];
                                            f: {
                                                if ((e | 0) != i[A + 104 >> 2]) {
                                                    i[A + 4 >> 2] = e + 1, e = l[e | 0];
                                                    break f;
                                                }
                                                e = M2(A);
                                            }
                                            if (f = e - 58 | 0, r | f >>> 0 > 4294967285) break r;
                                            if (i[A + 116 >> 2] < 0) break e;
                                            i[A + 4 >> 2] = i[A + 4 >> 2] - 1;
                                            break e;
                                        }
                                        f = e - 58 | 0;
                                    }
                                    if (f >>> 0 < 4294967286) break e;
                                    r: {
                                        if (e - 48 >>> 0 >= 10) break r;
                                        for(;;){
                                            k = (Z(k, 10) + e | 0) - 48 | 0, n = (k | 0) < 214748364, e = i[A + 4 >> 2];
                                            A: {
                                                if ((e | 0) != i[A + 104 >> 2]) {
                                                    i[A + 4 >> 2] = e + 1, e = l[e | 0];
                                                    break A;
                                                }
                                                e = M2(A);
                                            }
                                            if (r = e - 48 | 0, !(n & r >>> 0 <= 9)) break;
                                        }
                                        if (n = k >> 31, r >>> 0 >= 10) break r;
                                        for(;;){
                                            r = e, e = O0(k, n, 10, 0), f = r + e | 0, r = w0, k = f - 48 | 0, f = (e >>> 0 > f >>> 0 ? r + 1 | 0 : r) - (f >>> 0 < 48) | 0, n = f, f = k >>> 0 < 2061584302 & (f | 0) <= 21474836 | (f | 0) < 21474836, e = i[A + 4 >> 2];
                                            A: {
                                                if ((e | 0) != i[A + 104 >> 2]) {
                                                    i[A + 4 >> 2] = e + 1, e = l[e | 0];
                                                    break A;
                                                }
                                                e = M2(A);
                                            }
                                            if (r = e - 48 | 0, !(f & r >>> 0 <= 9)) break;
                                        }
                                        if (r >>> 0 >= 10) break r;
                                        for(;;){
                                            r = i[A + 4 >> 2];
                                            A: {
                                                if ((r | 0) != i[A + 104 >> 2]) {
                                                    i[A + 4 >> 2] = r + 1, r = l[r | 0];
                                                    break A;
                                                }
                                                r = M2(A);
                                            }
                                            if (!(r - 48 >>> 0 < 10)) break;
                                        }
                                    }
                                    r = i[A + 116 >> 2], (r | 0) > 0 ? r = 1 : r = (r | 0) >= 0, r && (i[A + 4 >> 2] = i[A + 4 >> 2] - 1), A = k, k = t ? 0 - A | 0 : A, n = t ? 0 - (((A | 0) != 0) + n | 0) | 0 : n;
                                    break i;
                                }
                                if (n = -2147483648, i[A + 116 >> 2] < 0) break i;
                                return i[A + 4 >> 2] = i[A + 4 >> 2] - 1, w0 = -2147483648, 0;
                            }
                            return w0 = n, k;
                        }
                        function H_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, u = k8(f), Mi(A + 196 | 0, f, A + 247 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[s | 0];
                                    }
                                    if (m6(f << 24 >> 24, u, e, A + 180 | 0, A + 8 | 0, o[A + 247 | 0], A + 196 | 0, A + 16 | 0, A + 12 | 0, 64960)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return h = n, w = o9(e, i[A + 180 >> 2], k, u), i[h >> 2] = w, i[n + 4 >> 2] = w0, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 196 | 0), m = A + 256 | 0, e | 0;
                        }
                        function x_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, u = k8(f), Mi(A + 196 | 0, f, A + 247 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[s | 0];
                                    }
                                    if (m6(f << 24 >> 24, u, e, A + 180 | 0, A + 8 | 0, o[A + 247 | 0], A + 196 | 0, A + 16 | 0, A + 12 | 0, 64960)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return h = n, w = Pn(e, i[A + 180 >> 2], k, u), i[h >> 2] = w, i[n + 4 >> 2] = w0, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 196 | 0), m = A + 256 | 0, e | 0;
                        }
                        function Y5(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            for(A = m - 336 | 0, m = A, i[A + 328 >> 2] = e, i[A + 332 >> 2] = r, u = k8(f), h = Ui(f, A + 208 | 0), Di(A + 196 | 0, f, A + 324 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 332 | 0, A + 328 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 332 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[s >> 2];
                                    }
                                    if (Z6(f, u, e, A + 180 | 0, A + 8 | 0, i[A + 324 >> 2], A + 196 | 0, A + 16 | 0, A + 12 | 0, h)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return w = n, v = dn(e, i[A + 180 >> 2], k, u), i[w >> 2] = v, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 332 | 0, A + 328 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 332 >> 2], a0(r), a0(A + 196 | 0), m = A + 336 | 0, e | 0;
                        }
                        function z_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            for(A = m - 336 | 0, m = A, i[A + 328 >> 2] = e, i[A + 332 >> 2] = r, u = k8(f), h = Ui(f, A + 208 | 0), Di(A + 196 | 0, f, A + 324 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 332 | 0, A + 328 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 332 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[s >> 2];
                                    }
                                    if (Z6(f, u, e, A + 180 | 0, A + 8 | 0, i[A + 324 >> 2], A + 196 | 0, A + 16 | 0, A + 12 | 0, h)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return w = n, v = Ln(e, i[A + 180 >> 2], k, u), i[w >> 2] = v, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 332 | 0, A + 328 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 332 >> 2], a0(r), a0(A + 196 | 0), m = A + 336 | 0, e | 0;
                        }
                        function T_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            for(A = m - 336 | 0, m = A, i[A + 328 >> 2] = e, i[A + 332 >> 2] = r, u = k8(f), h = Ui(f, A + 208 | 0), Di(A + 196 | 0, f, A + 324 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (S2(A + 332 | 0, A + 328 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 332 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = i[s >> 2];
                                    }
                                    if (Z6(f, u, e, A + 180 | 0, A + 8 | 0, i[A + 324 >> 2], A + 196 | 0, A + 16 | 0, A + 12 | 0, h)) break i;
                                    J1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return w = n, v = Kn(e, i[A + 180 >> 2], k, u), Q[w >> 1] = v, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), S2(A + 332 | 0, A + 328 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 332 >> 2], a0(r), a0(A + 196 | 0), m = A + 336 | 0, e | 0;
                        }
                        function S_(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0;
                            A = m - 624 | 0, m = A, i[A + 616 >> 2] = e, i[A + 620 >> 2] = r, i[A + 16 >> 2] = 1414, r = A + 16 | 0, s = s1(A + 200 | 0, A + 208 | 0, r), h = A + 192 | 0, u = i[k + 28 >> 2], i[h >> 2] = u, (u | 0) != 108396 && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), u = K0(h, 108572), o[A + 191 | 0] = 0;
                            i: {
                                if (!J7(A + 620 | 0, e, f, h, i[k + 4 >> 2], n, A + 191 | 0, u, s, A + 196 | 0, A + 608 | 0)) break i;
                                e = l[17502] | l[17503] << 8 | (l[17504] << 16 | l[17505] << 24), o[A + 183 | 0] = e, o[A + 184 | 0] = e >>> 8, o[A + 185 | 0] = e >>> 16, o[A + 186 | 0] = e >>> 24, e = l[17499] | l[17500] << 8 | (l[17501] << 16 | l[17502] << 24), i[A + 176 >> 2] = l[17495] | l[17496] << 8 | (l[17497] << 16 | l[17498] << 24), i[A + 180 >> 2] = e, p[i[i[u >> 2] + 48 >> 2]](u, A + 176 | 0, A + 186 | 0, A + 128 | 0), i[A + 16 >> 2] = 1413, f = s1(A + 8 | 0, 0, r), k = r;
                                e: {
                                    if (r = i[A + 196 >> 2] - i[s >> 2] | 0, (r | 0) >= 393 && (e = Q2((r >> 2) + 2 | 0), r = i[f >> 2], i[f >> 2] = e, r && p[i[f + 4 >> 2]](r), k = i[f >> 2], !k)) break e;
                                    for(l[A + 191 | 0] == 1 && (o[k | 0] = 45, k = k + 1 | 0), e = i[s >> 2];;){
                                        if (k0[A + 196 >> 2] <= e >>> 0) r: {
                                            if (o[k | 0] = 0, i[A >> 2] = t, (_o(A + 16 | 0, A) | 0) != 1) break r;
                                            r = i[f >> 2], i[f >> 2] = 0, r && p[i[f + 4 >> 2]](r);
                                            break i;
                                        }
                                        else {
                                            r = A + 128 | 0, w = k, v = l[(A + 176 | 0) + (qA(r, r + 40 | 0, e) - r >> 2) | 0], o[w | 0] = v, k = k + 1 | 0, e = e + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    w1(), z();
                                }
                                w1(), z();
                            }
                            return S2(A + 620 | 0, A + 616 | 0) && (i[n >> 2] = i[n >> 2] | 2), e = i[A + 620 >> 2], d0(A + 192 | 0), r = i[s >> 2], i[s >> 2] = 0, r && p[i[s + 4 >> 2]](r), m = A + 624 | 0, e | 0;
                        }
                        function j_(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                if (!i[A + 64 >> 2]) break i;
                                e: {
                                    if (f = i[A + 68 >> 2], f) {
                                        if (e = i[A + 92 >> 2], e & 16) {
                                            if (i[A + 24 >> 2] != i[A + 20 >> 2] && (r = -1, (p[i[i[A >> 2] + 52 >> 2]](A, -1) | 0) == -1)) break i;
                                            for(f = A + 72 | 0;;){
                                                if (r = i[A + 68 >> 2], e = i[A + 32 >> 2], e = p[i[i[r >> 2] + 20 >> 2]](r, f, e, e + i[A + 52 >> 2] | 0, k + 12 | 0) | 0, n = i[A + 32 >> 2], r = i[k + 12 >> 2] - n | 0, (E1(n, 1, r, i[A + 64 >> 2]) | 0) != (r | 0)) break e;
                                                r: switch(e - 1 | 0){
                                                    case 1:
                                                        break e;
                                                    case 0:
                                                        continue;
                                                    default:
                                                        break r;
                                                }
                                                break;
                                            }
                                            if (r = 0, !R8(i[A + 64 >> 2])) break i;
                                            break e;
                                        }
                                        if (!(e & 8)) break i;
                                        r = i[A + 84 >> 2], i[k >> 2] = i[A + 80 >> 2], i[k + 4 >> 2] = r;
                                        r: {
                                            A: {
                                                f: {
                                                    if (l[A + 98 | 0] == 1) {
                                                        r = i[A + 16 >> 2] - i[A + 12 >> 2] | 0, f = r >> 31;
                                                        break f;
                                                    }
                                                    if (e = p[i[i[f >> 2] + 24 >> 2]](f) | 0, r = i[A + 40 >> 2] - i[A + 36 >> 2] | 0, f = r >> 31, (e | 0) > 0) {
                                                        e = Z(e, i[A + 16 >> 2] - i[A + 12 >> 2] | 0), f = f + (e >> 31) | 0, n = r, r = r + e | 0, f = n >>> 0 > r >>> 0 ? f + 1 | 0 : f;
                                                        break f;
                                                    }
                                                    if (i[A + 12 >> 2] != i[A + 16 >> 2]) break A;
                                                }
                                                e = 0;
                                                break r;
                                            }
                                            e = i[A + 68 >> 2], e = p[i[i[e >> 2] + 32 >> 2]](e, k, i[A + 32 >> 2], i[A + 36 >> 2], i[A + 12 >> 2] - i[A + 8 >> 2] | 0) | 0, e = i[A + 36 >> 2] - (e + i[A + 32 >> 2] | 0) | 0, f = f + (e >> 31) | 0, n = r, r = r + e | 0, f = n >>> 0 > r >>> 0 ? f + 1 | 0 : f, e = 1;
                                        }
                                        if (vr(i[A + 64 >> 2], 0 - r | 0, 0 - (f + ((r | 0) != 0) | 0) | 0, 1)) break e;
                                        e && (r = i[k + 4 >> 2], i[A + 72 >> 2] = i[k >> 2], i[A + 76 >> 2] = r), r = i[A + 32 >> 2], i[A + 40 >> 2] = r, i[A + 36 >> 2] = r, r = 0, i[A + 16 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 92 >> 2] = 0;
                                        break i;
                                    }
                                    w1(), z();
                                }
                                r = -1;
                            }
                            return m = k + 16 | 0, r | 0;
                        }
                        function E5(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, u = k8(f), Mi(A + 196 | 0, f, A + 247 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[s | 0];
                                    }
                                    if (m6(f << 24 >> 24, u, e, A + 180 | 0, A + 8 | 0, o[A + 247 | 0], A + 196 | 0, A + 16 | 0, A + 12 | 0, 64960)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return h = n, w = dn(e, i[A + 180 >> 2], k, u), i[h >> 2] = w, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 196 | 0), m = A + 256 | 0, e | 0;
                        }
                        function O_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, u = k8(f), Mi(A + 196 | 0, f, A + 247 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[s | 0];
                                    }
                                    if (m6(f << 24 >> 24, u, e, A + 180 | 0, A + 8 | 0, o[A + 247 | 0], A + 196 | 0, A + 16 | 0, A + 12 | 0, 64960)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return h = n, w = Ln(e, i[A + 180 >> 2], k, u), i[h >> 2] = w, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 196 | 0), m = A + 256 | 0, e | 0;
                        }
                        function P_(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            for(A = m - 256 | 0, m = A, i[A + 248 >> 2] = e, i[A + 252 >> 2] = r, u = k8(f), Mi(A + 196 | 0, f, A + 247 | 0), e = m - 16 | 0, m = e, r = A + 184 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, m = e + 16 | 0, G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = e, i[A + 12 >> 2] = A + 16, i[A + 8 >> 2] = 0;;){
                                i: {
                                    if (T2(A + 252 | 0, A + 248 | 0)) break i;
                                    t = i[A + 180 >> 2], l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, (t | 0) == (f + e | 0) && (l[r + 11 | 0] >>> 7 | 0 ? e = i[r + 4 >> 2] : e = l[r + 11 | 0] & 127, l[r + 11 | 0] >>> 7 | 0 ? f = i[r + 4 >> 2] : f = l[r + 11 | 0] & 127, G2(r, f << 1), G2(r, l[r + 11 | 0] >>> 7 | 0 ? (i[r + 8 >> 2] & 2147483647) - 1 | 0 : 10), f = e, l[r + 11 | 0] >>> 7 | 0 ? e = i[r >> 2] : e = r, i[A + 180 >> 2] = f + e), t = A + 252 | 0, f = i[t >> 2], s = i[f + 12 >> 2];
                                    e: {
                                        if ((s | 0) == i[f + 16 >> 2]) {
                                            f = p[i[i[f >> 2] + 36 >> 2]](f) | 0;
                                            break e;
                                        }
                                        f = l[s | 0];
                                    }
                                    if (m6(f << 24 >> 24, u, e, A + 180 | 0, A + 8 | 0, o[A + 247 | 0], A + 196 | 0, A + 16 | 0, A + 12 | 0, 64960)) break i;
                                    g1(t);
                                    continue;
                                }
                                break;
                            }
                            l[A + 207 | 0] >>> 7 | 0 ? f = i[A + 200 >> 2] : f = l[A + 207 | 0] & 127;
                            i: {
                                if (!f || (f = i[A + 12 >> 2], (f - (A + 16 | 0) | 0) > 159)) break i;
                                i[A + 12 >> 2] = f + 4, i[f >> 2] = i[A + 8 >> 2];
                            }
                            return h = n, w = Kn(e, i[A + 180 >> 2], k, u), Q[h >> 1] = w, L1(A + 196 | 0, A + 16 | 0, i[A + 12 >> 2], k), T2(A + 252 | 0, A + 248 | 0) && (i[k >> 2] = i[k >> 2] | 2), e = i[A + 252 >> 2], a0(r), a0(A + 196 | 0), m = A + 256 | 0, e | 0;
                        }
                        function L_(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0;
                            A = m - 272 | 0, m = A, i[A + 264 >> 2] = e, i[A + 268 >> 2] = r, i[A + 16 >> 2] = 1414, r = A + 16 | 0, s = s1(A + 152 | 0, A + 160 | 0, r), h = A + 144 | 0, u = i[k + 28 >> 2], i[h >> 2] = u, (u | 0) != 108396 && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), u = K0(h, 108580), o[A + 143 | 0] = 0;
                            i: {
                                if (!g7(A + 268 | 0, e, f, h, i[k + 4 >> 2], n, A + 143 | 0, u, s, A + 148 | 0, A + 260 | 0)) break i;
                                e = l[17502] | l[17503] << 8 | (l[17504] << 16 | l[17505] << 24), o[A + 135 | 0] = e, o[A + 136 | 0] = e >>> 8, o[A + 137 | 0] = e >>> 16, o[A + 138 | 0] = e >>> 24, e = l[17499] | l[17500] << 8 | (l[17501] << 16 | l[17502] << 24), i[A + 128 >> 2] = l[17495] | l[17496] << 8 | (l[17497] << 16 | l[17498] << 24), i[A + 132 >> 2] = e, p[i[i[u >> 2] + 32 >> 2]](u, A + 128 | 0, A + 138 | 0, A + 118 | 0), i[A + 16 >> 2] = 1413, f = s1(A + 8 | 0, 0, r), k = r;
                                e: {
                                    if (r = i[A + 148 >> 2] - i[s >> 2] | 0, (r | 0) >= 99 && (e = Q2(r + 2 | 0), r = i[f >> 2], i[f >> 2] = e, r && p[i[f + 4 >> 2]](r), k = i[f >> 2], !k)) break e;
                                    for(l[A + 143 | 0] == 1 && (o[k | 0] = 45, k = k + 1 | 0), e = i[s >> 2];;){
                                        if (k0[A + 148 >> 2] <= e >>> 0) r: {
                                            if (o[k | 0] = 0, i[A >> 2] = t, (_o(A + 16 | 0, A) | 0) != 1) break r;
                                            r = i[f >> 2], i[f >> 2] = 0, r && p[i[f + 4 >> 2]](r);
                                            break i;
                                        }
                                        else {
                                            r = A + 118 | 0, w = k, v = l[(($A(r, r + 10 | 0, e) - A | 0) + A | 0) + 10 | 0], o[w | 0] = v, k = k + 1 | 0, e = e + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    w1(), z();
                                }
                                w1(), z();
                            }
                            return T2(A + 268 | 0, A + 264 | 0) && (i[n >> 2] = i[n >> 2] | 2), e = i[A + 268 >> 2], d0(A + 144 | 0), r = i[s >> 2], i[s >> 2] = 0, r && p[i[s + 4 >> 2]](r), m = A + 272 | 0, e | 0;
                        }
                        function K_(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0;
                            h = m - 16 | 0, m = h, s = D(36), i[s + 32 >> 2] = t, i[s + 28 >> 2] = n, i[s + 24 >> 2] = k, i[s + 20 >> 2] = f, i[s + 16 >> 2] = e, i[s + 12 >> 2] = 79140, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, i[s >> 2] = 79388, e = i[r + 8 >> 2], i[h + 12 >> 2] = s, n = s + 12 | 0, i[h + 8 >> 2] = n, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, f = i[e + 16 >> 2];
                            i: {
                                e: {
                                    if (f >>> 0 < k0[e + 20 >> 2]) {
                                        i[f + 4 >> 2] = s, i[f >> 2] = n, i[s + 4 >> 2] = i[s + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, k = s;
                                        break e;
                                    }
                                    if (f = P2(e + 12 | 0, h + 8 | 0), k = i[h + 12 >> 2], i[e + 16 >> 2] = f, !k) break i;
                                }
                                if (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            i: {
                                if (!u || (i[s + 4 >> 2] = i[s + 4 >> 2] + 1, e = D(24), i[s + 4 >> 2] = i[s + 4 >> 2] + 1, i[e + 20 >> 2] = s, i[e + 16 >> 2] = n, k = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = k, k = i[r >> 2], f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 4 >> 2] = f, i[e >> 2] = k, i[u >> 2] = e, e = i[s + 4 >> 2], i[s + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            f = i[r >> 2], e = i[r + 4 >> 2];
                            i: {
                                if (e) {
                                    if (i[e + 4 >> 2] = i[e + 4 >> 2] + 1, c9(f, i[i[r + 8 >> 2] >> 2], t), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A) break i;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    break i;
                                }
                                c9(f, i[i[r + 8 >> 2] >> 2], t), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                            }
                            A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A || (p[i[i[s >> 2] + 8 >> 2]](s), g(s)), m = h + 16 | 0;
                        }
                        function q_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0;
                            W = m - 80 | 0, m = W;
                            i: {
                                if (!(e && r)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 5, i[A + 4 >> 2] = 2001;
                                    break i;
                                }
                                f = W + 8 | 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, i[f + 32 >> 2] = 0, i[f + 36 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0;
                                e: {
                                    if (l[r + 12 | 0] == 1) {
                                        k = n0[r + 24 >> 3], n = n0[r + 32 >> 3], h = k * n, t = n0[r + 16 >> 3], s = n0[r + 40 >> 3], v = t * s, u = h - v, n0[f + 40 >> 3] = u + u, u = t * k, _ = n * s, w = u + _, n0[f + 24 >> 3] = w + w, w = t * n, s = k * s, B = w + s, n0[f + 16 >> 3] = B + B, u = u - _, n0[f + 8 >> 3] = u + u, t = t * t, n = n * n, u = t + n, n0[f + 32 >> 3] = 1 - (u + u), u = k * k, k = u + n, n0[f >> 3] = 1 - (k + k), n = t + u, n = 1 - (n + n), t = h + v, t = t + t, k = w - s, k = k + k;
                                        break e;
                                    }
                                    k = n0[r + 56 >> 3] * .017453292519943295, t = tA(k), s = nA(k), n = n0[r + 48 >> 3] * .017453292519943295, k = tA(n), n = nA(n), h = n0[r + 64 >> 3], u = s * 0, V = u + (0 - t), v = V * 0, _ = t * 0 + (s + 0), n0[f + 24 >> 3] = v + (k * _ + n * 0), n0[f >> 3] = v + (n * _ + k * -0), h = h * .017453292519943295, v = nA(h), G = t * -0, h = tA(h), w = h * -0, y = s * v + (G + w), F = y * 0, w = t * v + (u + w), B = v * 0, C = B + (0 - h), n0[f + 40 >> 3] = F + (k * w + n * C), G = s * h + (G + B), E = G * 0, t = t * h + (u + B), s = h * 0 + (v + 0), n0[f + 32 >> 3] = E + (k * t + n * s), n0[f + 16 >> 3] = F + (n * w - C * k), n0[f + 8 >> 3] = E + (n * t - s * k), n = y + (w * 0 + C * 0), t = G + (t * 0 + s * 0), k = V + (_ * 0 + 0);
                                }
                                n0[f + 64 >> 3] = n, n0[f + 56 >> 3] = t, n0[f + 48 >> 3] = k, v0(e, f, 72), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                            }
                            m = W + 80 | 0;
                        }
                        function v6(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            s = m - 16 | 0, m = s, n = i[A + 108 >> 2], f = i[A + 104 >> 2], t = n - f >> 4;
                            i: {
                                if ((f | 0) == (n | 0)) break i;
                                for(u = t >>> 0 <= 1 ? 1 : t;;){
                                    if (i[f + (k << 4) >> 2] == (r | 0)) break i;
                                    if (k = k + 1 | 0, (u | 0) == (k | 0)) break;
                                }
                                k = u;
                            }
                            if ((k | 0) == (t | 0)) {
                                f = A + 104 | 0, i[s + 12 >> 2] = 0, i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, i[s >> 2] = r;
                                i: {
                                    if (n >>> 0 < k0[A + 112 >> 2]) {
                                        i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = r, i[A + 108 >> 2] = n + 16;
                                        break i;
                                    }
                                    if (u = L5(f, s), r = i[s + 4 >> 2], i[A + 108 >> 2] = u, !r) break i;
                                    i[s + 8 >> 2] = r, X(r);
                                }
                                f = i[f >> 2];
                            }
                            i: {
                                e: {
                                    n = (k << 4) + f | 0, r = i[n + 4 >> 2], k = i[n + 8 >> 2], h = (r | 0) == (k | 0);
                                    r: {
                                        if (!h) for(A = I[e + 2 >> 1], f = r;;){
                                            if ((A | 0) == I[f + 2 >> 1]) break r;
                                            if (f = f + 4 | 0, (k | 0) == (f | 0)) break;
                                        }
                                        f = i[n + 12 >> 2];
                                        A: {
                                            if (f >>> 0 > k >>> 0) {
                                                A = I[e >> 1] | I[e + 2 >> 1] << 16, Q[k >> 1] = A, Q[k + 2 >> 1] = A >>> 16, A = k + 4 | 0;
                                                break A;
                                            }
                                            if (u = k - r >> 2, A = u + 1 | 0, A >>> 0 >= 1073741824) break e;
                                            if (w = u << 2, f = f - r | 0, t = f >> 1, t = f >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < t >>> 0 ? t : A, t) {
                                                if (t >>> 0 >= 1073741824) break i;
                                                u = D(t << 2);
                                            } else u = 0;
                                            if (f = w + u | 0, A = I[e >> 1] | I[e + 2 >> 1] << 16, Q[f >> 1] = A, Q[f + 2 >> 1] = A >>> 16, A = f + 4 | 0, !h) {
                                                for(; f = f - 4 | 0, k = k - 4 | 0, e = I[k >> 1] | I[k + 2 >> 1] << 16, Q[f >> 1] = e, Q[f + 2 >> 1] = e >>> 16, (r | 0) != (k | 0););
                                                r = i[n + 4 >> 2];
                                            }
                                            if (i[n + 12 >> 2] = u + (t << 2), i[n + 8 >> 2] = A, i[n + 4 >> 2] = f, !r) break A;
                                            X(r);
                                        }
                                        i[n + 8 >> 2] = A;
                                    }
                                    m = s + 16 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function $_(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            i[A + 4 >> 2] = 1, f = i[A + 8 >> 2], i[f + 324 >> 2] = i[f + 324 >> 2] - 1, i[f + 328 >> 2] = i[f + 328 >> 2] + 1, f = i[A + 12 >> 2], n = f + 1 | 0, e = i[A + 8 >> 2], r = i[e + 124 >> 2], s = i[r + 16884 >> 2] / 4 | 0, h = i[e + 276 >> 2], u = i[r + 16892 >> 2], k = u - 1 | 0, t = i[e + 272 >> 2], w = l[A + 16 | 0];
                            i: {
                                if (w) {
                                    r = i[r + 16900 >> 2] - 1 | 0, r8(e, A, k, (r | 0) < (n | 0) ? r : n, 1);
                                    break i;
                                }
                                if ((f | 0) <= 0 ? r = f : (r8(e, A, k, f - 1 | 0, 2), e = i[A + 8 >> 2], r = i[A + 12 >> 2]), r8(e, A, k, r, 2), e = i[A + 12 >> 2] + 1 | 0, r = i[A + 8 >> 2], (e | 0) >= i[i[r + 124 >> 2] + 16900 >> 2]) break i;
                                r8(r, A, k, e, 2);
                            }
                            r = i[A + 12 >> 2], e = i[A + 8 >> 2];
                            i: {
                                e: {
                                    if (l[A + 16 | 0] == 1) {
                                        if (r = O7(e, r), e = i[A + 8 >> 2], o[(i[e + 140 >> 2] + Z(Z(i[e + 152 >> 2], i[A + 12 >> 2]), 24) | 0) + 21 | 0] = r, !r) break i;
                                        k = l[A + 16 | 0];
                                        break e;
                                    }
                                    if (k = 0, l[(i[e + 140 >> 2] + Z(Z(r, i[e + 152 >> 2]), 24) | 0) + 21 | 0] != 1) break i;
                                }
                                f = Z(f, s), r = Z(n, s), r = (r | 0) < (h | 0) ? r : h, X3(e, k & 1, f, r, t), e = l[A + 16 | 0], k = i[A + 8 >> 2];
                                e: {
                                    if (i[i[k + 124 >> 2] + 16832 >> 2] >= 9) {
                                        _3(k, e & 1, f, r, t);
                                        break e;
                                    }
                                    m3(k, e & 1, f, r, t);
                                }
                                if (e = i[A + 8 >> 2], n = i[e + 124 >> 2], !i[n + 16848 >> 2]) break i;
                                if (k = l[A + 16 | 0], i[n + 16840 >> 2] >= 9) {
                                    G3(e, k & 1, f, r, t);
                                    break i;
                                }
                                W3(e, k & 1, f, r, t);
                            }
                            if (e = 0, (u | 0) > 0) for(f = w ? 2 : 3; r = i[A + 8 >> 2], r = (i[r + 320 >> 2] + Z(e, 76) | 0) + Z(Z(i[A + 12 >> 2], i[i[r + 124 >> 2] + 16892 >> 2]), 76) | 0, (f | 0) > i[r >> 2] && (i[r >> 2] = f), e = e + 1 | 0, (u | 0) != (e | 0););
                            i[A + 4 >> 2] = 3, ur(i[A + 8 >> 2]);
                        }
                        function a_(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            k = m - 32 | 0, m = k, z1(k + 12 | 0, r, e), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 9370);
                                    break i;
                                }
                                if (n = n2(e), (n | 0) < 0) {
                                    if (r = D(32), i[k >> 2] = r, i[k + 4 >> 2] = 30, i[k + 8 >> 2] = -2147483616, e = l[18581] | l[18582] << 8 | (l[18583] << 16 | l[18584] << 24), f = l[18577] | l[18578] << 8 | (l[18579] << 16 | l[18580] << 24), o[r | 0] = f, o[r + 1 | 0] = f >>> 8, o[r + 2 | 0] = f >>> 16, o[r + 3 | 0] = f >>> 24, o[r + 4 | 0] = e, o[r + 5 | 0] = e >>> 8, o[r + 6 | 0] = e >>> 16, o[r + 7 | 0] = e >>> 24, o[r + 30 | 0] = 0, e = l[18603] | l[18604] << 8 | (l[18605] << 16 | l[18606] << 24), f = l[18599] | l[18600] << 8 | (l[18601] << 16 | l[18602] << 24), o[r + 22 | 0] = f, o[r + 23 | 0] = f >>> 8, o[r + 24 | 0] = f >>> 16, o[r + 25 | 0] = f >>> 24, o[r + 26 | 0] = e, o[r + 27 | 0] = e >>> 8, o[r + 28 | 0] = e >>> 16, o[r + 29 | 0] = e >>> 24, e = l[18597] | l[18598] << 8 | (l[18599] << 16 | l[18600] << 24), f = l[18593] | l[18594] << 8 | (l[18595] << 16 | l[18596] << 24), o[r + 16 | 0] = f, o[r + 17 | 0] = f >>> 8, o[r + 18 | 0] = f >>> 16, o[r + 19 | 0] = f >>> 24, o[r + 20 | 0] = e, o[r + 21 | 0] = e >>> 8, o[r + 22 | 0] = e >>> 16, o[r + 23 | 0] = e >>> 24, e = l[18589] | l[18590] << 8 | (l[18591] << 16 | l[18592] << 24), f = l[18585] | l[18586] << 8 | (l[18587] << 16 | l[18588] << 24), o[r + 8 | 0] = f, o[r + 9 | 0] = f >>> 8, o[r + 10 | 0] = f >>> 16, o[r + 11 | 0] = f >>> 24, o[r + 12 | 0] = e, o[r + 13 | 0] = e >>> 8, o[r + 14 | 0] = e >>> 16, o[r + 15 | 0] = e >>> 24, i0(A, 6, 1e3, k), o[k + 11 | 0] >= 0) break i;
                                    X(i[k >> 2]);
                                    break i;
                                }
                                Ze(A, r, e, n, f);
                            }
                            m = k + 32 | 0;
                        }
                        function R1(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            n = i[A + 16 >> 2], u = i[A + 20 >> 2], f = i[A >> 2], e = i[A + 24 >> 2], h = i[A + 8 >> 2], t = h;
                            i: {
                                for(;;){
                                    if (!((e | 0) > 0)) {
                                        e = 64 - e | 0;
                                        e: {
                                            if (!t) {
                                                t = 0, k = e;
                                                break e;
                                            }
                                            B = 0;
                                            r: {
                                                for(;;){
                                                    if (v = f + 1 | 0, i[A >> 2] = v, f = l[f | 0], t = t - 1 | 0, i[A + 8 >> 2] = t, k = e - 8 | 0, _ = k & 31, h = A, (k & 63) >>> 0 >= 32 ? (s = f << _, f = 0) : (s = (1 << _) - 1 & f >>> 32 - _, f = f << _), n = f | n, i[A + 16 >> 2] = n, u = u | s, i[h + 20 >> 2] = u, (e | 0) <= 15) break r;
                                                    if (B = B - (e >>> 0 < 8) | 0, e = e - 8 | 0, f = v, !t) break;
                                                }
                                                h = t, t = 0, k = e;
                                                break e;
                                            }
                                            h = t, f = v;
                                        }
                                        e = 64 - k | 0;
                                    }
                                    if (v = u, k = e, e = e - 1 | 0, i[A + 24 >> 2] = e, s = v << 1 | n >>> 31, n = n << 1, i[A + 16 >> 2] = n, u = s, i[A + 20 >> 2] = u, (v | 0) > 0 | (v | 0) >= 0) {
                                        if (w = w + 1 | 0, (w | 0) != 21) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (G = r, w) {
                                    if (!((k | 0) > (w | 0) | (k | 0) > 57)) {
                                        for(e = 65 - k | 0, B = 0;;){
                                            e: {
                                                if (_ = e, !h) {
                                                    k = e;
                                                    break e;
                                                }
                                                if (t = f + 1 | 0, i[A >> 2] = t, r = l[f | 0], h = h - 1 | 0, i[A + 8 >> 2] = h, k = _ - 8 | 0, f = k & 31, (k & 63) >>> 0 >= 32 ? (s = r << f, r = 0) : (s = (1 << f) - 1 & r >>> 32 - f, r = r << f), n = r | n, r = u | s, u = r, i[A + 16 >> 2] = n, i[A + 20 >> 2] = r, r = e, e = e - 8 | 0, B = B - (r >>> 0 < 8) | 0, f = t, (_ | 0) > 15) continue;
                                            }
                                            break;
                                        }
                                        e = 64 - k | 0;
                                    }
                                    i[A + 24 >> 2] = e - w, r = n, e = w & 31, (w & 63) >>> 0 >= 32 ? (s = r << e, r = 0) : (s = (1 << e) - 1 & r >>> 32 - e | u << e, r = r << e), i[A + 16 >> 2] = r, i[A + 20 >> 2] = s, A = n, r = 64 - w | 0, e = r & 31, (r & 63) >>> 0 >= 32 ? A = u >>> e | 0 : A = ((1 << e) - 1 & u) << 32 - e | A >>> e, A = A + (-1 << w ^ -1) | 0;
                                } else A = 0;
                                i[G >> 2] = A;
                            }
                            return v >>> 31 | 0;
                        }
                        function q0(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            k = i[A + 8 >> 2], e = i[A + 12 >> 2], n = i[A + 16 >> 2];
                            i: {
                                for(;;){
                                    e: {
                                        if ((n | 0) > 0) {
                                            r = e, f = n;
                                            break e;
                                        }
                                        for(f = 64 - n | 0, w = 0, n = i[A + 4 >> 2], r = e;;){
                                            r: {
                                                if (s = f, !n) {
                                                    t = f;
                                                    break r;
                                                }
                                                if (e = i[A >> 2], i[A >> 2] = e + 1, e = l[e | 0], n = n - 1 | 0, i[A + 4 >> 2] = n, v = A, _ = k, t = s - 8 | 0, k = t & 31, (t & 63) >>> 0 >= 32 ? (h = e << k, e = 0) : (h = (1 << k) - 1 & e >>> 32 - k, e = e << k), k = _ | e, e = r | h, r = e, i[v + 8 >> 2] = k, i[v + 12 >> 2] = r, e = f, f = e - 8 | 0, w = w - (e >>> 0 < 8) | 0, (s | 0) > 15) continue;
                                            }
                                            break;
                                        }
                                        f = 64 - t | 0;
                                    }
                                    if (n = f - 1 | 0, i[A + 16 >> 2] = n, h = r << 1 | k >>> 31, k = k << 1, i[A + 8 >> 2] = k, e = h, i[A + 12 >> 2] = e, (r | 0) < 0) break i;
                                    if (u = u + 1 | 0, (u | 0) == 21) break;
                                }
                                return -99999;
                            }
                            if (!u) return 0;
                            if (!((f | 0) > (u | 0) | (f | 0) > 57)) {
                                for(f = 65 - f | 0, w = 0, n = i[A + 4 >> 2];;){
                                    i: {
                                        if (v = f, !n) {
                                            t = f;
                                            break i;
                                        }
                                        if (r = i[A >> 2], i[A >> 2] = r + 1, r = l[r | 0], n = n - 1 | 0, i[A + 4 >> 2] = n, h = A, _ = k, t = v - 8 | 0, k = t & 31, (t & 63) >>> 0 >= 32 ? (s = r << k, r = 0) : (s = (1 << k) - 1 & r >>> 32 - k, r = r << k), k = _ | r, i[h + 8 >> 2] = k, e = e | s, i[A + 12 >> 2] = e, r = f, f = r - 8 | 0, w = w - (r >>> 0 < 8) | 0, (v | 0) > 15) continue;
                                    }
                                    break;
                                }
                                n = 64 - t | 0;
                            }
                            if (i[A + 16 >> 2] = n - u, f = k, r = u & 31, (u & 63) >>> 0 >= 32 ? (s = k << r, f = 0) : (s = (1 << r) - 1 & f >>> 32 - r | e << r, f = f << r), i[A + 8 >> 2] = f, i[A + 12 >> 2] = s, A = k, f = 64 - u | 0, r = f & 31, (f & 63) >>> 0 >= 32 ? A = e >>> r | 0 : A = ((1 << r) - 1 & e) << 32 - r | A >>> r, A = A + (1 << u) | 0, (A | 0) > 1) return A - 1 | 0;
                            y0(18231, 15001, 146, 14793), z();
                        }
                        function b_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(M0(U(M0(U(f + 12 | 0, 15823, 14), i[r + 100 >> 2]), 20126, 1), i[r + 104 >> 2]), 20126, 1), i[r + 108 >> 2]), 34040, 2), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function d_(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0;
                            s = m - 80 | 0, m = s;
                            i: {
                                if (!r) {
                                    r = i[19869], i[A >> 2] = i[19868], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19870];
                                    break i;
                                }
                                w = i[i[r >> 2] + 36 >> 2], i[s + 48 >> 2] = 0, i[s + 52 >> 2] = 0, i[s + 40 >> 2] = 0, i[s + 44 >> 2] = 0, i[s + 56 >> 2] = 0, i[s + 60 >> 2] = 0, i[s + 72 >> 2] = 0, i[s + 76 >> 2] = 0, h = s - -64 | 0, i[h >> 2] = 2, i[h + 4 >> 2] = 2, i[s + 44 >> 2] = 0, i[s + 48 >> 2] = 0, Q[s + 52 >> 1] = 0, i[s + 32 >> 2] = 0, i[s + 36 >> 2] = 0, i[s + 36 >> 2] = 0, i[s + 40 >> 2] = 0, o[s + 32 | 0] = 6, o[s + 60 | 0] = 1;
                                e: {
                                    if (!n) break e;
                                    r: switch(l[n | 0] - 1 | 0){
                                        case 5:
                                            i[s + 76 >> 2] = i[n + 44 >> 2];
                                        case 4:
                                            h = i[n + 32 >> 2], i[s + 60 >> 2] = i[n + 28 >> 2], i[s + 64 >> 2] = h, h = i[n + 40 >> 2], i[s + 68 >> 2] = i[n + 36 >> 2], i[s + 72 >> 2] = h;
                                        case 3:
                                            i[s + 56 >> 2] = i[n + 24 >> 2];
                                        case 2:
                                            o[s + 53 | 0] = l[n + 21 | 0];
                                        case 1:
                                            o[s + 52 | 0] = l[n + 20 | 0];
                                            break;
                                        case 0:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    o[s + 33 | 0] = l[n + 1 | 0], i[s + 36 >> 2] = i[n + 4 >> 2], i[s + 40 >> 2] = i[n + 8 >> 2], i[s + 44 >> 2] = i[n + 12 >> 2], i[s + 48 >> 2] = i[n + 16 >> 2];
                                }
                                if (U7(s + 4 | 0, i[r + 8 >> 2], w, f, k, s + 32 | 0, 1, t, u), n = A, i[s + 12 >> 2] ? e = s + 12 | 0 : (k = i[s + 4 >> 2], f = i[s + 8 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), A = e, e = D(8), i[A >> 2] = e, i[e + 4 >> 2] = f, i[e >> 2] = k, e = 86672), A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[s + 31 | 0] < 0 && X(i[s + 20 >> 2]), A = i[s + 8 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = s + 80 | 0;
                        }
                        function g5(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = J(0), s = J(0), h = J(0), w = J(0), v = J(0), _ = J(0), B = J(0), G = J(0);
                            f = m - 16 | 0, m = f, i[e >> 2] = 0, k = Q2(52);
                            i: {
                                if (!k) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 6, 0, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (o[k + 16 | 0] = 1, i[k + 12 >> 2] = 6, i[k + 4 >> 2] = 1, i[k + 8 >> 2] = 13, o[k | 0] = 1, n = f + 4 | 0, fA(n, k, I[r + 4 >> 1]), t = i[f + 4 >> 2], t) {
                                    if (r = i[f + 8 >> 2], X(k), o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, t, r, n), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (n = f + 4 | 0, kA(n, k, I[r + 6 >> 1]), t = i[f + 4 >> 2], t) {
                                    if (r = i[f + 8 >> 2], X(k), o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, t, r, n), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (n = f + 4 | 0, rA(n, k, I[r + 8 >> 1]), t = i[f + 4 >> 2], t) {
                                    if (r = i[f + 8 >> 2], X(k), o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, t, r, n), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (o[k + 16 | 0] = l[r + 10 | 0], r = I[k + 4 >> 1] - 1 | 0, (r & 65535) >>> 0 <= 21 && (r = r << 2 & 262140, u = W0[r + 39872 >> 2], s = W0[r + 39520 >> 2], h = W0[r + 39432 >> 2], w = W0[r + 39344 >> 2], v = W0[r + 39256 >> 2], _ = W0[r + 39784 >> 2], B = W0[r + 39696 >> 2], G = W0[r + 39608 >> 2]), W0[k + 48 >> 2] = u, W0[k + 44 >> 2] = _, W0[k + 40 >> 2] = s, W0[k + 36 >> 2] = h, W0[k + 32 >> 2] = w, W0[k + 28 >> 2] = v, W0[k + 24 >> 2] = B, W0[k + 20 >> 2] = G, i[e >> 2] = k, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function c_(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, t = i[k - 12 >> 2], k = f + 12 | 0, i[t + k >> 2] = i[15037], u = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(u, n), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, u = z0(n), i[u >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, t = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : t, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), t = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : t, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), t = U(f + 12 | 0, 23655, 10), e = o[r + 115 | 0], k = (e | 0) < 0, U(U(t, k ? i[r + 104 >> 2] : r + 104 | 0, k ? i[r + 108 >> 2] : e), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[u >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(u), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function iB(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = m + -64 | 0, m = e, P8(e + 40 | 0, i[r + 20 >> 2], i[r + 36 >> 2], e + 60 | 0);
                            i: {
                                if (i[e + 40 >> 2]) {
                                    if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 44 >> 2], i[A + 8 >> 2] = i[e + 40 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[e + 59 | 0] >= 0) {
                                        r = i[e + 52 >> 2], i[A >> 2] = i[e + 48 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 56 >> 2];
                                        break i;
                                    }
                                    j(A, i[e + 48 >> 2], i[e + 52 >> 2]);
                                    break i;
                                }
                                f = e + 16 | 0, v4(f, i[r + 20 >> 2], i[e + 60 >> 2], 1), k = i[e + 20 >> 2], r = i[e + 16 >> 2];
                                e: {
                                    if (!r) {
                                        o[e + 4 | 0] = 0, o[e + 15 | 0] = 0, r = i0(f, 2, 2e3, e + 4 | 0), i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 4 >> 2], i[A + 8 >> 2] = i[r >> 2], i[A + 12 >> 2] = f, A = A + 16 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                f = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[e + 15 | 0] >= 0) break e;
                                        X(i[e + 4 >> 2]);
                                        break e;
                                    }
                                    if (p[i[i[r >> 2] + 20 >> 2]](e + 16 | 0, r), i[e + 16 >> 2]) {
                                        if (i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[e + 20 >> 2], i[A + 8 >> 2] = i[e + 16 >> 2], i[A + 12 >> 2] = r, A = A + 16 | 0, o[e + 35 | 0] >= 0) {
                                            r = i[e + 28 >> 2], i[A >> 2] = i[e + 24 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 32 >> 2];
                                            break e;
                                        }
                                        if (j(A, i[e + 24 >> 2], i[e + 28 >> 2]), o[e + 35 | 0] >= 0) break e;
                                        X(i[e + 24 >> 2]);
                                        break e;
                                    }
                                    o[e + 35 | 0] < 0 && X(i[e + 24 >> 2]), p[i[i[r >> 2] + 76 >> 2]](A, r);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            o[e + 59 | 0] < 0 && X(i[e + 48 >> 2]), m = e - -64 | 0;
                        }
                        function eB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            if (Y1(A, i[r + 8 >> 2], k)) {
                                i[r + 28 >> 2] == 1 | i[r + 4 >> 2] != (e | 0) || (i[r + 28 >> 2] = f);
                                return;
                            }
                            i: {
                                e: {
                                    if (Y1(A, i[r >> 2], k)) {
                                        if (!(i[r + 16 >> 2] != (e | 0) & i[r + 20 >> 2] != (e | 0))) {
                                            if ((f | 0) != 1) break i;
                                            i[r + 32 >> 2] = 1;
                                            return;
                                        }
                                        if (i[r + 32 >> 2] = f, i[r + 44 >> 2] == 4) break e;
                                        for(n = A + 16 | 0, t = n + (i[A + 12 >> 2] << 3) | 0, f = 0;;){
                                            r: {
                                                A: {
                                                    f: {
                                                        k: {
                                                            if (n >>> 0 >= t >>> 0 || (Q[r + 52 >> 1] = 0, HA(n, r, e, e, 1, k), l[r + 54 | 0])) break k;
                                                            if (l[r + 53 | 0] != 1) break r;
                                                            if (l[r + 52 | 0] == 1) {
                                                                if (i[r + 24 >> 2] == 1 || (f = 1, u = 1, !(l[A + 8 | 0] & 2))) break A;
                                                                break r;
                                                            }
                                                            if (f = 1, o[A + 8 | 0] & 1) break r;
                                                            A = 3;
                                                            break f;
                                                        }
                                                        A = f ? 3 : 4;
                                                    }
                                                    if (i[r + 44 >> 2] = A, u) break i;
                                                    break e;
                                                }
                                                i[r + 44 >> 2] = 3;
                                                break i;
                                            }
                                            n = n + 8 | 0;
                                        }
                                    }
                                    if (n = i[A + 12 >> 2], t = A + 16 | 0, or(t, r, e, f, k), (n | 0) < 2) break i;
                                    if (t = t + (n << 3) | 0, n = A + 24 | 0, A = i[A + 8 >> 2], !(!(A & 2) & i[r + 36 >> 2] != 1)) {
                                        for(;;){
                                            if (l[r + 54 | 0]) break i;
                                            if (or(n, r, e, f, k), n = n + 8 | 0, !(t >>> 0 > n >>> 0)) break;
                                        }
                                        break i;
                                    }
                                    if (!(A & 1)) for(;;){
                                        if (l[r + 54 | 0] | i[r + 36 >> 2] == 1) break i;
                                        if (or(n, r, e, f, k), n = n + 8 | 0, !(t >>> 0 > n >>> 0)) break i;
                                    }
                                    for(;;){
                                        if (l[r + 54 | 0] | i[r + 36 >> 2] == 1 & i[r + 24 >> 2] == 1) break i;
                                        if (or(n, r, e, f, k), n = n + 8 | 0, !(t >>> 0 > n >>> 0)) break;
                                    }
                                    break i;
                                }
                                if (i[r + 20 >> 2] = e, i[r + 40 >> 2] = i[r + 40 >> 2] + 1, i[r + 36 >> 2] != 1 | i[r + 24 >> 2] != 2) break i;
                                o[r + 54 | 0] = 1;
                            }
                        }
                        function hi(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            v = m - 16 | 0, m = v;
                            i: {
                                e: {
                                    r: {
                                        if ((e | 0) <= 36) {
                                            if (t = l[A | 0], t) break r;
                                            n = A;
                                            break e;
                                        }
                                        i[26064] = 28, f = 0, k = 0;
                                        break i;
                                    }
                                    n = A;
                                    r: {
                                        for(;;){
                                            if (u = t << 24 >> 24, !((u | 0) == 32 | u - 9 >>> 0 < 5)) break r;
                                            if (t = l[n + 1 | 0], n = n + 1 | 0, !t) break;
                                        }
                                        break e;
                                    }
                                    r: switch(u = t & 255, u - 43 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    h = (u | 0) == 45 ? -1 : 0, n = n + 1 | 0;
                                }
                                e: {
                                    if (!((e | 16) != 16 | l[n | 0] != 48)) {
                                        if (B = 1, (l[n + 1 | 0] & 223) == 88) {
                                            n = n + 2 | 0, _ = 16;
                                            break e;
                                        }
                                        n = n + 1 | 0, _ = e || 8;
                                        break e;
                                    }
                                    _ = e || 10;
                                }
                                for(e = 0;;){
                                    e: {
                                        u = l[n | 0], t = u - 48 | 0;
                                        r: {
                                            if ((t & 255) >>> 0 < 10) break r;
                                            if ((u - 97 & 255) >>> 0 <= 25) {
                                                t = u - 87 | 0;
                                                break r;
                                            }
                                            if ((u - 65 & 255) >>> 0 > 25) break e;
                                            t = u - 55 | 0;
                                        }
                                        if (t = t & 255, (t | 0) >= (_ | 0)) break e;
                                        x1(v, _, 0, 0, 0, w, s, 0, 0), u = 1;
                                        r: {
                                            if (i[v + 8 >> 2] | i[v + 12 >> 2] || (G = O0(w, s, _, 0), W = w0, (W | 0) == -1 & (t ^ -1) >>> 0 < G >>> 0)) break r;
                                            s = W, w = t + G | 0, s = w >>> 0 < t >>> 0 ? s + 1 | 0 : s, B = 1, u = e;
                                        }
                                        n = n + 1 | 0, e = u;
                                        continue;
                                    }
                                    break;
                                }
                                r && (i[r >> 2] = B ? n : A);
                                e: {
                                    r: {
                                        if (e) {
                                            i[26064] = 68, A = f & 1, h = A ? 0 : h, w = f, s = k;
                                            break r;
                                        }
                                        if ((k | 0) == (s | 0) & f >>> 0 > w >>> 0 | k >>> 0 > s >>> 0) break e;
                                        A = f & 1;
                                    }
                                    if (!(A | h)) {
                                        i[26064] = 68, A = f, f = A - 1 | 0, k = k - !A | 0;
                                        break i;
                                    }
                                    if ((k | 0) == (s | 0) & f >>> 0 >= w >>> 0 | k >>> 0 > s >>> 0) break e;
                                    i[26064] = 68;
                                    break i;
                                }
                                A = h ^ w, f = A - h | 0, r = h >> 31, k = (r ^ s) - ((A >>> 0 < h >>> 0) + r | 0) | 0;
                            }
                            return m = v + 16 | 0, w0 = k, f;
                        }
                        function I3(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = m - 80 | 0, m = t;
                            i: {
                                if (!e) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 20763;
                                    break i;
                                }
                                i[e >> 2] = 0, s = i[i[r >> 2] + 36 >> 2], i[t + 48 >> 2] = 0, i[t + 52 >> 2] = 0, i[t + 40 >> 2] = 0, i[t + 44 >> 2] = 0, i[t + 56 >> 2] = 0, i[t + 60 >> 2] = 0, i[t + 72 >> 2] = 0, i[t + 76 >> 2] = 0, u = t - -64 | 0, i[u >> 2] = 2, i[u + 4 >> 2] = 2, i[t + 44 >> 2] = 0, i[t + 48 >> 2] = 0, Q[t + 52 >> 1] = 0, i[t + 32 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 36 >> 2] = 0, i[t + 40 >> 2] = 0, o[t + 32 | 0] = 6, o[t + 60 | 0] = 1;
                                e: {
                                    if (!n) break e;
                                    r: switch(l[n | 0] - 1 | 0){
                                        case 5:
                                            i[t + 76 >> 2] = i[n + 44 >> 2];
                                        case 4:
                                            u = i[n + 32 >> 2], i[t + 60 >> 2] = i[n + 28 >> 2], i[t + 64 >> 2] = u, u = i[n + 40 >> 2], i[t + 68 >> 2] = i[n + 36 >> 2], i[t + 72 >> 2] = u;
                                        case 3:
                                            i[t + 56 >> 2] = i[n + 24 >> 2];
                                        case 2:
                                            o[t + 53 | 0] = l[n + 21 | 0];
                                        case 1:
                                            o[t + 52 | 0] = l[n + 20 | 0];
                                            break;
                                        case 0:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    o[t + 33 | 0] = l[n + 1 | 0], i[t + 36 >> 2] = i[n + 4 >> 2], i[t + 40 >> 2] = i[n + 8 >> 2], i[t + 44 >> 2] = i[n + 12 >> 2], i[t + 48 >> 2] = i[n + 16 >> 2];
                                }
                                if (U7(t + 4 | 0, i[r + 8 >> 2], s, f, k, t + 32 | 0, 0, 0, 0), n = A, i[t + 12 >> 2] ? e = t + 12 | 0 : (k = i[t + 4 >> 2], f = i[t + 8 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), A = e, e = D(8), i[A >> 2] = e, i[e + 4 >> 2] = f, i[e >> 2] = k, e = 86672), A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), A = i[t + 8 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = t + 80 | 0;
                        }
                        function K8(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0;
                            i: {
                                e: {
                                    u = i[A + 248 >> 2], s = r >> u;
                                    r: {
                                        if ((s | 0) < 0 || (h = i[A + 252 >> 2], (h | 0) <= (s | 0))) break r;
                                        if (u = e >> u, (u | 0) < 0 | (u | 0) >= i[A + 256 >> 2]) break e;
                                        if (!(l[(s + i[A + 240 >> 2] | 0) + Z(u, h) | 0] >>> k & 1)) {
                                            s = f, f = r;
                                            break i;
                                        }
                                        if (s = f - 1 | 0, u = k + 1 | 0, K8(A, r, e, s, u, n, t), k = 1 << f >> 1, f = k + r | 0, K8(A, f, e, s, u, 16, t), e = e + k | 0, K8(A, r, e, s, u, n, 32), r = i[A + 248 >> 2], k = f >> r, (k | 0) < 0) break r;
                                        for(r = e >> r;;){
                                            if (n = i[A + 252 >> 2], (n | 0) <= (k | 0)) break r;
                                            if ((r | 0) < 0 | i[A + 256 >> 2] <= (r | 0)) break e;
                                            if (!(l[(i[A + 240 >> 2] + k | 0) + Z(r, n) | 0] >>> u & 1)) {
                                                n = 16, t = 32;
                                                break i;
                                            }
                                            if (k = s - 1 | 0, u = u + 1 | 0, K8(A, f, e, k, u, 16, 32), r = 1 << s >> 1, n = r + f | 0, K8(A, n, e, k, u, 16, 32), e = r + e | 0, K8(A, f, e, k, u, 16, 32), t = i[A + 248 >> 2], r = e >> t, s = k, f = n, k = n >> t, !((k | 0) >= 0)) break;
                                        }
                                    }
                                    y0(4105, 9012, 118, 3731), z();
                                }
                                y0(4067, 9012, 119, 3731), z();
                            }
                            i: {
                                if ((s | 0) == 31) break i;
                                for(r = 1 << s, k = (f | 0) / 4 | 0, u = 0; w = i[A + 272 >> 2], h = (e + u | 0) / 4 | 0, (k | 0) >= (w | 0) | (h | 0) >= i[A + 276 >> 2] || (h = (k + i[A + 260 >> 2] | 0) + Z(h, w) | 0, o[h | 0] = l[h | 0] | n), u = u + 4 | 0, (r | 0) > (u | 0););
                                if ((s | 0) == 31) break i;
                                for(k = (e | 0) / 4 | 0, e = 0; n = (e + f | 0) / 4 | 0, s = i[A + 272 >> 2], (n | 0) >= (s | 0) | (k | 0) >= i[A + 276 >> 2] || (n = (n + i[A + 260 >> 2] | 0) + Z(k, s) | 0, o[n | 0] = l[n | 0] | t), e = e + 4 | 0, (r | 0) > (e | 0););
                            }
                        }
                        function rB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            u = m - 16 | 0, m = u, t = m - 16 | 0, m = t, s = i[r + 8 >> 2], m8(t, i[s + 48 >> 2], 1919377774), n = i[t >> 2], o[n + 164 | 0] = 1, i[n + 100 >> 2] = i[n + 100 >> 2] & -2 | 1, h = i[i[t >> 2] + 104 >> 2], n = D(36), i[n + 32 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 20 >> 2] = f, i[n + 16 >> 2] = e, i[n + 12 >> 2] = h, i[n >> 2] = 78372, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[u + 12 >> 2] = n, f = n + 12 | 0, i[u + 8 >> 2] = f, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[t + 12 >> 2] = n, i[t + 8 >> 2] = f, e = i[s + 132 >> 2];
                            i: {
                                if (e >>> 0 < k0[s + 136 >> 2]) {
                                    i[e + 4 >> 2] = n, i[e >> 2] = f, i[s + 132 >> 2] = e + 8;
                                    break i;
                                }
                                if (f = p2(s + 128 | 0, t + 8 | 0), e = i[t + 12 >> 2], i[s + 132 >> 2] = f, !e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            e = i[t + 4 >> 2];
                            i: {
                                if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            m = t + 16 | 0, Un(i[r >> 2], i[i[u + 8 >> 2] >> 2]);
                            i: {
                                if (k) {
                                    e = D(16), f = i[r + 8 >> 2], r = i[r + 12 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, r = i[u + 12 >> 2], i[e + 8 >> 2] = i[u + 8 >> 2], i[e + 12 >> 2] = r, i[k >> 2] = e, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                    break i;
                                }
                                if (r = i[u + 12 >> 2], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[19867], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = u + 16 | 0;
                        }
                        function AB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 23308, 11), i[r + 104 >> 2] - i[r + 100 >> 2] | 0), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function J5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            i: {
                                if (e = i[A >> 2], k = i[A + 4 >> 2] - e >> 5, t = k + 1 | 0, t >>> 0 < 134217728) {
                                    if (f = i[A + 8 >> 2] - e | 0, e = f >> 4, t = f >>> 0 >= 2147483616 ? 134217727 : e >>> 0 > t >>> 0 ? e : t, t) {
                                        if (t >>> 0 >= 134217728) break i;
                                        n = D(t << 5);
                                    }
                                    f = i[r + 4 >> 2], e = (k << 5) + n | 0, i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = f, k = i[r + 8 >> 2], f = i[r + 12 >> 2], i[e + 24 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 8 >> 2] = k, i[e + 12 >> 2] = f, f = i[r + 16 >> 2], r = i[r + 20 >> 2], $3(e + 16 | 0, f, r, (r - f | 0) / 40 | 0), t = (t << 5) + n | 0, h = e + 32 | 0, f = i[A + 4 >> 2], u = i[A >> 2];
                                    e: {
                                        if ((f | 0) == (u | 0)) {
                                            n = e;
                                            break e;
                                        }
                                        for(; r = f - 32 | 0, k = i[r + 4 >> 2], n = e - 32 | 0, i[n >> 2] = i[r >> 2], i[n + 4 >> 2] = k, k = i[r + 12 >> 2], i[n + 8 >> 2] = i[r + 8 >> 2], i[n + 12 >> 2] = k, k = e - 8 | 0, i[k >> 2] = 0, s = e - 16 | 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, w = s, s = f - 16 | 0, i[w >> 2] = i[s >> 2], i[e - 12 >> 2] = i[f - 12 >> 2], e = f - 8 | 0, i[k >> 2] = i[e >> 2], i[e >> 2] = 0, i[s >> 2] = 0, i[s + 4 >> 2] = 0, e = n, f = r, (r | 0) != (u | 0););
                                        f = i[A + 4 >> 2], u = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = h, i[A >> 2] = n, i[A + 8 >> 2] = t, (f | 0) != (u | 0)) for(;;){
                                        if (k = f - 16 | 0, A = i[k >> 2], A) {
                                            if (r = A, n = f - 12 | 0, e = i[n >> 2], (r | 0) != (e | 0)) {
                                                for(; r = i[e - 16 >> 2], r && (i[e - 12 >> 2] = r, X(r)), e = e - 40 | 0, (A | 0) != (e | 0););
                                                r = i[k >> 2];
                                            }
                                            i[n >> 2] = A, X(r);
                                        }
                                        if (f = f - 32 | 0, (u | 0) == (f | 0)) break;
                                    }
                                    return u && X(u), h;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function fB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                e: {
                                    r: {
                                        if (!(i[r + 104 >> 2] - i[r + 100 >> 2] & 255)) {
                                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] < 0) break r;
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break i;
                                        }
                                        if (h = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, (i[r + 116 >> 2] - i[r + 112 >> 2] | 0) / 12 & 255), f2(e, i[r + 104 >> 2] - i[r + 100 >> 2] & 255), f = i[r + 100 >> 2], k = i[r + 104 >> 2], (f | 0) != (k | 0)) for(; f2(e, l[f | 0]), f = f + 1 | 0, (k | 0) != (f | 0););
                                        if (k = i[r + 112 >> 2], s = i[r + 116 >> 2], (k | 0) == (s | 0)) break e;
                                        for(;;){
                                            if (i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, f = i[k + 4 >> 2], t = i[k >> 2], u = (f | 0) == (t | 0), !u) {
                                                A: {
                                                    if (f = f - t | 0, (f | 0) >= 0) {
                                                        if (t = v0(D(f), t, f), u) break A;
                                                        for(f = f >>> 1 | 0, w = f >>> 0 <= 1 ? 1 : f, f = 0;;){
                                                            u = I[t + (f << 1) >> 1];
                                                            f: {
                                                                if (l[i[r + 100 >> 2] + f | 0] <= 8) {
                                                                    f2(e, u & 255);
                                                                    break f;
                                                                }
                                                                w2(e, u);
                                                            }
                                                            if (f = f + 1 | 0, (w | 0) == (f | 0)) break;
                                                        }
                                                        break A;
                                                    }
                                                    p0(), z();
                                                }
                                                X(t);
                                            }
                                            if (k = k + 12 | 0, (s | 0) == (k | 0)) break;
                                        }
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                if (E4(n, r, e, h), o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function kB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(f + 12 | 0, 23597, 10), i[r + 100 >> 2]), 34881, 15), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function nB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(f + 12 | 0, 23764, 16), l[r + 104 | 0]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function tB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 24976, 9), i[r + 104 >> 2]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function oB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 24677, 10), I[r + 98 >> 1]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function uB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, D2(n, r, e), s = k, u = n, k = o[f + 159 | 0], n = (k | 0) < 0, U(s, n ? i[f + 148 >> 2] : u, n ? i[f + 152 >> 2] : k), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), k = f + 148 | 0, G0(k, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(f + 12 | 0, k ? i[f + 148 >> 2] : u, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(P0(U(f + 12 | 0, 22817, 10), l[r + 97 | 0]), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 60 >> 2], r = i[f + 40 >> 2], e >>> 0 < r >>> 0 && (i[f + 60 >> 2] = r, e = r), r = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 32 >> 2], r = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function R5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (l[A + 52 | 0] == 1) {
                                    if (e = i[A + 48 >> 2], !r) break i;
                                    o[A + 52 | 0] = 0, i[A + 48 >> 2] = -1;
                                    break i;
                                }
                                e: {
                                    if (l[A + 53 | 0] == 1) {
                                        e = i[A + 32 >> 2];
                                        r: {
                                            if (i[e + 76 >> 2] < 0) {
                                                e = wn(e);
                                                break r;
                                            }
                                            e = wn(e);
                                        }
                                        if ((e | 0) != -1 && (i[f + 24 >> 2] = e), (e | 0) == -1) break e;
                                        e = i[f + 24 >> 2];
                                        r: {
                                            if (!r) {
                                                if (!i9(e, i[A + 32 >> 2])) break e;
                                                break r;
                                            }
                                            i[A + 48 >> 2] = e;
                                        }
                                        e = i[f + 24 >> 2];
                                        break i;
                                    }
                                    for(i[f + 24 >> 2] = 1, k = m - 16 | 0, m = k, m = k + 16 | 0, k = A + 44 | 0, n = f + 24 | 0, k = i[(i[n >> 2] < i[k >> 2] ? k : n) >> 2], n = (k | 0) > 0 ? k : 0;;){
                                        if ((e | 0) != (n | 0)) {
                                            if (t = Vi(i[A + 32 >> 2]), (t | 0) == -1) break e;
                                            o[(f + 24 | 0) + e | 0] = t, e = e + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    h = f + 24 | 0;
                                    r: {
                                        for(;;){
                                            A: {
                                                n = i[A + 40 >> 2], e = i[n >> 2], w = i[n + 4 >> 2], u = f + 24 | 0, t = u + k | 0;
                                                f: switch(s = i[A + 36 >> 2], (p[i[i[s >> 2] + 16 >> 2]](s, n, u, t, f + 16 | 0, f + 20 | 0, h, f + 12 | 0) | 0) - 1 | 0){
                                                    case 2:
                                                        break A;
                                                    case 0:
                                                        break f;
                                                    case 1:
                                                        break e;
                                                    default:
                                                        break r;
                                                }
                                                if (n = i[A + 40 >> 2], i[n >> 2] = e, i[n + 4 >> 2] = w, (k | 0) == 8 || (e = Vi(i[A + 32 >> 2]), (e | 0) == -1)) break e;
                                                o[t | 0] = e, k = k + 1 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        i[f + 20 >> 2] = o[f + 24 | 0];
                                    }
                                    r: {
                                        if (!r) for(;;){
                                            if ((k | 0) <= 0) break r;
                                            if (k = k - 1 | 0, (F6(o[k + (f + 24 | 0) | 0], i[A + 32 >> 2]) | 0) == -1) break e;
                                        }
                                        i[A + 48 >> 2] = i[f + 20 >> 2];
                                    }
                                    e = i[f + 20 >> 2];
                                    break i;
                                }
                                e = -1;
                            }
                            return m = f + 32 | 0, e;
                        }
                        function Je(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            B = m - 16 | 0, m = B, w = K0(t, 108572), s = B + 4 | 0, t = K0(t, 108644), p[i[i[t >> 2] + 20 >> 2]](s, t), l[s + 11 | 0] >>> 7 | 0 ? u = i[s + 4 >> 2] : u = l[s + 11 | 0] & 127;
                            i: {
                                if (!u) {
                                    p[i[i[w >> 2] + 48 >> 2]](w, A, e, f), t = (e - A << 2) + f | 0, i[n >> 2] = t;
                                    break i;
                                }
                                i[n >> 2] = f;
                                e: {
                                    r: switch(s = A, u = l[s | 0], u - 43 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    s = p[i[i[w >> 2] + 44 >> 2]](w, u << 24 >> 24) | 0, u = i[n >> 2], i[n >> 2] = u + 4, i[u >> 2] = s, s = A + 1 | 0;
                                }
                                for(l[s | 0] != 48 | (e - s | 0) < 2 | (l[s + 1 | 0] | 32) != 120 || (u = p[i[i[w >> 2] + 44 >> 2]](w, 48) | 0, h = i[n >> 2], i[n >> 2] = h + 4, i[h >> 2] = u, u = p[i[i[w >> 2] + 44 >> 2]](w, o[s + 1 | 0]) | 0, h = i[n >> 2], i[n >> 2] = h + 4, i[h >> 2] = u, s = s + 2 | 0), e6(s, e), G = p[i[i[t >> 2] + 16 >> 2]](t) | 0, h = 0, t = s;;){
                                    if (e >>> 0 <= t >>> 0) ir((s - A << 2) + f | 0, i[n >> 2]), t = i[n >> 2];
                                    else {
                                        u = B + 4 | 0;
                                        e: {
                                            if (l[u + 11 | 0] >>> 7 | 0) {
                                                v = i[u >> 2];
                                                break e;
                                            }
                                            v = u;
                                        }
                                        W = !l[v + h | 0], l[u + 11 | 0] >>> 7 | 0 ? v = i[u >> 2] : v = u, W | o[v + h | 0] != (_ | 0) || (_ = i[n >> 2], i[n >> 2] = _ + 4, i[_ >> 2] = G, l[u + 11 | 0] >>> 7 | 0 ? u = i[u + 4 >> 2] : u = l[u + 11 | 0] & 127, h = (u - 1 >>> 0 > h >>> 0) + h | 0, _ = 0), u = p[i[i[w >> 2] + 44 >> 2]](w, o[t | 0]) | 0, v = i[n >> 2], i[n >> 2] = v + 4, i[v >> 2] = u, t = t + 1 | 0, _ = _ + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            i[k >> 2] = (r | 0) == (e | 0) ? t : (r - A << 2) + f | 0, a0(B + 4 | 0), m = B + 16 | 0;
                        }
                        function lB(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (e = A + 16 | 0, r = i[e + 16 >> 2], k = e + 20 | 0, (r | 0) != (k | 0)) for(;;){
                                f = i[r + 20 >> 2], A = i[r + 24 >> 2];
                                i: {
                                    if (!A) {
                                        sn(f);
                                        break i;
                                    }
                                    if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, sn(f), f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f) break i;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = i[r + 4 >> 2];
                                i: {
                                    if (A) {
                                        for(;;)if (r = A, A = i[A >> 2], !A) break i;
                                    }
                                    for(; A = r, r = i[r + 8 >> 2], (A | 0) != i[r >> 2];);
                                }
                                if ((r | 0) == (k | 0)) break;
                            }
                            if (f = i[e + 128 >> 2], f) {
                                if (A = f, r = i[e + 132 >> 2], (A | 0) != (r | 0)) {
                                    for(;;){
                                        A = i[r - 4 >> 2];
                                        i: {
                                            if (!A || (k = i[A + 4 >> 2], i[A + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (r = r - 8 | 0, (f | 0) == (r | 0)) break;
                                    }
                                    A = i[e + 128 >> 2];
                                }
                                i[e + 132 >> 2] = f, X(A);
                            }
                            A = i[e + 52 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 44 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            if (f = i[e + 28 >> 2], f) {
                                if (A = f, r = i[e + 32 >> 2], (A | 0) != (r | 0)) {
                                    for(;;){
                                        A = i[r - 4 >> 2];
                                        i: {
                                            if (!A || (k = i[A + 4 >> 2], i[A + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (r = r - 8 | 0, (f | 0) == (r | 0)) break;
                                    }
                                    A = i[e + 28 >> 2];
                                }
                                i[e + 32 >> 2] = f, X(A);
                            }
                            Hi(e + 16 | 0, i[e + 20 >> 2]), o[e + 11 | 0] < 0 && X(i[e >> 2]);
                        }
                        function F3(A, r, e, f, k, n, t, u) {
                            var s = 0;
                            s = m + -64 | 0, m = s, i[s + 40 >> 2] = 0, i[s + 44 >> 2] = 0, i[s + 48 >> 2] = 0, i[s + 52 >> 2] = 0, i[s + 56 >> 2] = 0, i[s + 32 >> 2] = 0, i[s + 36 >> 2] = 0, Q[s + 28 >> 1] = 256, i[s + 24 >> 2] = 1, Ve(s, s + 24 | 0, f, k, n, t, 1, u);
                            i: {
                                if (i[s >> 2]) {
                                    r = i[s + 4 >> 2], i[A >> 2] = i[s >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[s + 16 >> 2], r = i[s + 12 >> 2], i[A + 8 >> 2] = i[s + 8 >> 2], i[A + 12 >> 2] = r, i[s + 16 >> 2] = 0, i[s + 8 >> 2] = 0, i[s + 12 >> 2] = 0;
                                    break i;
                                }
                                t = i[r + 64 >> 2];
                                e: {
                                    r: {
                                        if (!t) {
                                            n = r - -64 | 0, u = n;
                                            break r;
                                        }
                                        for(;;){
                                            if (u = t, f = i[t + 16 >> 2], (f | 0) > (e | 0)) {
                                                if (n = t, t = i[t >> 2], t) continue;
                                                break r;
                                            }
                                            if ((e | 0) <= (f | 0)) break e;
                                            if (t = i[u + 4 >> 2], !t) break;
                                        }
                                        n = u + 4 | 0;
                                    }
                                    t = D(56), i[t + 16 >> 2] = e, e = i[s + 28 >> 2], i[t + 20 >> 2] = i[s + 24 >> 2], i[t + 24 >> 2] = e, e = i[s + 36 >> 2], i[t + 28 >> 2] = i[s + 32 >> 2], i[t + 32 >> 2] = e, e = i[s + 44 >> 2], i[t + 36 >> 2] = i[s + 40 >> 2], i[t + 40 >> 2] = e, e = i[s + 52 >> 2], i[t + 44 >> 2] = i[s + 48 >> 2], i[t + 48 >> 2] = e, i[t + 52 >> 2] = i[s + 56 >> 2], i[t + 8 >> 2] = u, i[t >> 2] = 0, i[t + 4 >> 2] = 0, i[n >> 2] = t, e = i[i[r + 60 >> 2] >> 2], e && (i[r + 60 >> 2] = e, t = i[n >> 2]), h4(i[r + 64 >> 2], t), i[r + 68 >> 2] = i[r + 68 >> 2] + 1;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[s + 19 | 0] < 0 && X(i[s + 8 >> 2]), m = s - -64 | 0;
                        }
                        function v0(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            if (e >>> 0 >= 512) return bs(A | 0, r | 0, e | 0), A | 0;
                            k = A + e | 0;
                            i: {
                                if (!((A ^ r) & 3)) {
                                    e: {
                                        if (!(A & 3)) {
                                            e = A;
                                            break e;
                                        }
                                        if (!e) {
                                            e = A;
                                            break e;
                                        }
                                        for(e = A;;){
                                            if (o[e | 0] = l[r | 0], r = r + 1 | 0, e = e + 1 | 0, !(e & 3)) break e;
                                            if (!(e >>> 0 < k >>> 0)) break;
                                        }
                                    }
                                    f = k & -4;
                                    e: {
                                        if (f >>> 0 < 64 || (n = f + -64 | 0, n >>> 0 < e >>> 0)) break e;
                                        for(; i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = i[r + 4 >> 2], i[e + 8 >> 2] = i[r + 8 >> 2], i[e + 12 >> 2] = i[r + 12 >> 2], i[e + 16 >> 2] = i[r + 16 >> 2], i[e + 20 >> 2] = i[r + 20 >> 2], i[e + 24 >> 2] = i[r + 24 >> 2], i[e + 28 >> 2] = i[r + 28 >> 2], i[e + 32 >> 2] = i[r + 32 >> 2], i[e + 36 >> 2] = i[r + 36 >> 2], i[e + 40 >> 2] = i[r + 40 >> 2], i[e + 44 >> 2] = i[r + 44 >> 2], i[e + 48 >> 2] = i[r + 48 >> 2], i[e + 52 >> 2] = i[r + 52 >> 2], i[e + 56 >> 2] = i[r + 56 >> 2], i[e + 60 >> 2] = i[r + 60 >> 2], r = r - -64 | 0, e = e - -64 | 0, n >>> 0 >= e >>> 0;);
                                    }
                                    if (e >>> 0 >= f >>> 0) break i;
                                    for(; i[e >> 2] = i[r >> 2], r = r + 4 | 0, e = e + 4 | 0, f >>> 0 > e >>> 0;);
                                    break i;
                                }
                                if (k >>> 0 < 4) {
                                    e = A;
                                    break i;
                                }
                                if (f = k - 4 | 0, f >>> 0 < A >>> 0) {
                                    e = A;
                                    break i;
                                }
                                for(e = A; o[e | 0] = l[r | 0], o[e + 1 | 0] = l[r + 1 | 0], o[e + 2 | 0] = l[r + 2 | 0], o[e + 3 | 0] = l[r + 3 | 0], r = r + 4 | 0, e = e + 4 | 0, f >>> 0 >= e >>> 0;);
                            }
                            if (e >>> 0 < k >>> 0) for(; o[e | 0] = l[r | 0], r = r + 1 | 0, e = e + 1 | 0, (k | 0) != (e | 0););
                            return A | 0;
                        }
                        function s4(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = m - 160 | 0, m = f, i[f + 24 >> 2] = 59808, i[f + 80 >> 2] = 59828, n = i[14961], i[f + 16 >> 2] = n, k = i[n - 12 >> 2], n = f + 16 | 0, i[k + n >> 2] = i[14962], i[f + 20 >> 2] = 0, k = n + i[i[f + 16 >> 2] - 12 >> 2] | 0, t = f + 28 | 0, T0(k, t), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, k = i[14963], i[f + 24 >> 2] = k, u = f + 24 | 0, i[u + i[k - 12 >> 2] >> 2] = i[14964], k = i[14960], i[f + 16 >> 2] = k, i[n + i[k - 12 >> 2] >> 2] = i[14965], i[f + 80 >> 2] = 59828, i[f + 16 >> 2] = 59788, i[f + 24 >> 2] = 59808, n = z0(t), i[n >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 24, U(P0(U(U(u, e, E2(e)), 21790, 18), l[r + 97 | 0]), 3679, 23), r = i[f + 76 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 72 >> 2], e = i[f + 52 >> 2], r >>> 0 < e >>> 0 && (i[f + 72 >> 2] = e, r = e), e = f + 48 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[f + 15 | 0] = 0, e = f + 4 | 0;
                                        break i;
                                    }
                                    r = i[f + 44 >> 2], e = f + 36 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            t = (r | 7) + 1 | 0, e = D(t), i[f + 12 >> 2] = t | -2147483648, i[f + 4 >> 2] = e, i[f + 8 >> 2] = r;
                                            break e;
                                        }
                                        if (o[f + 15 | 0] = r, e = f + 4 | 0, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(e, k, r);
                            }
                            o[r + e | 0] = 0, i0(A, 4, 3002, f + 4 | 0), o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), A = i[14959], i[f + 16 >> 2] = A, i[i[A - 12 >> 2] + (f + 16 | 0) >> 2] = i[14967], i[f + 24 >> 2] = i[14968], i[n >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(n), N0(f + 80 | 0), m = f + 160 | 0;
                        }
                        function Y3(A, r, e, f, k, n, t, u, s, h, w, v) {
                            var _ = 0;
                            _ = m - 16 | 0, m = _, i[_ + 12 >> 2] = A;
                            i: {
                                if ((A | 0) == (n | 0)) {
                                    if (A = -1, l[r | 0] != 1 || (A = 0, o[r | 0] = 0, r = i[k >> 2], i[k >> 2] = r + 1, o[r | 0] = 46, l[u + 11 | 0] >>> 7 | 0 ? r = i[u + 4 >> 2] : r = l[u + 11 | 0] & 127, !r) || (r = i[h >> 2], (r - s | 0) > 159)) break i;
                                    e = i[w >> 2], i[h >> 2] = r + 4, i[r >> 2] = e;
                                    break i;
                                }
                                if (l[u + 11 | 0] >>> 7 | 0 ? n = i[u + 4 >> 2] : n = l[u + 11 | 0] & 127, !(!n | (A | 0) != (t | 0))) {
                                    if (A = -1, l[r | 0] != 1 || (A = 0, r = i[h >> 2], (r - s | 0) > 159)) break i;
                                    A = i[w >> 2], i[h >> 2] = r + 4, i[r >> 2] = A, A = 0, i[w >> 2] = 0;
                                    break i;
                                }
                                if (A = -1, v = qA(v, v + 128 | 0, _ + 12 | 0) - v | 0, t = v >> 2, (t | 0) > 31) break i;
                                n = o[t + 64960 | 0];
                                e: {
                                    r: {
                                        if (A = v & -5, (A | 0) != 88) {
                                            if ((A | 0) != 96) break r;
                                            if (r = i[k >> 2], (r | 0) != (f | 0) && (A = -1, f = o[r - 1 | 0], e = o[e | 0], ((f - 97 >>> 0 < 26 ? f & 95 : f) | 0) != ((e - 97 >>> 0 < 26 ? e & 95 : e) | 0))) break i;
                                            i[k >> 2] = r + 1, o[r | 0] = n, A = 0;
                                            break i;
                                        }
                                        o[e | 0] = 80;
                                        break e;
                                    }
                                    if (A = n - 97 >>> 0 < 26 ? n & 95 : n, (A | 0) != o[e | 0] || (o[e | 0] = A - 65 >>> 0 < 26 ? A | 32 : A, l[r | 0] != 1) || (o[r | 0] = 0, l[u + 11 | 0] >>> 7 | 0 ? A = i[u + 4 >> 2] : A = l[u + 11 | 0] & 127, !A) || (A = i[h >> 2], (A - s | 0) > 159)) break e;
                                    r = i[w >> 2], i[h >> 2] = A + 4, i[A >> 2] = r;
                                }
                                if (A = i[k >> 2], i[k >> 2] = A + 1, o[A | 0] = n, A = 0, (t | 0) > 21) break i;
                                i[w >> 2] = i[w >> 2] + 1;
                            }
                            return m = _ + 16 | 0, A;
                        }
                        function Re(A, r, e, f, k, n, t) {
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            B = m - 16 | 0, m = B, w = K0(t, 108580), s = B + 4 | 0, t = K0(t, 108636), p[i[i[t >> 2] + 20 >> 2]](s, t), l[s + 11 | 0] >>> 7 | 0 ? u = i[s + 4 >> 2] : u = l[s + 11 | 0] & 127;
                            i: {
                                if (!u) {
                                    p[i[i[w >> 2] + 32 >> 2]](w, A, e, f), t = (e - A | 0) + f | 0, i[n >> 2] = t;
                                    break i;
                                }
                                i[n >> 2] = f;
                                e: {
                                    r: switch(s = A, u = l[s | 0], u - 43 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    s = p[i[i[w >> 2] + 28 >> 2]](w, u << 24 >> 24) | 0, u = i[n >> 2], i[n >> 2] = u + 1, o[u | 0] = s, s = A + 1 | 0;
                                }
                                for(l[s | 0] != 48 | (e - s | 0) < 2 | (l[s + 1 | 0] | 32) != 120 || (u = p[i[i[w >> 2] + 28 >> 2]](w, 48) | 0, h = i[n >> 2], i[n >> 2] = h + 1, o[h | 0] = u, u = p[i[i[w >> 2] + 28 >> 2]](w, o[s + 1 | 0]) | 0, h = i[n >> 2], i[n >> 2] = h + 1, o[h | 0] = u, s = s + 2 | 0), e6(s, e), G = p[i[i[t >> 2] + 16 >> 2]](t) | 0, h = 0, t = s;;){
                                    if (e >>> 0 <= t >>> 0) e6((s - A | 0) + f | 0, i[n >> 2]), t = i[n >> 2];
                                    else {
                                        u = B + 4 | 0;
                                        e: {
                                            if (l[u + 11 | 0] >>> 7 | 0) {
                                                v = i[u >> 2];
                                                break e;
                                            }
                                            v = u;
                                        }
                                        W = !l[v + h | 0], l[u + 11 | 0] >>> 7 | 0 ? v = i[u >> 2] : v = u, W | o[v + h | 0] != (_ | 0) || (_ = i[n >> 2], i[n >> 2] = _ + 1, o[_ | 0] = G, l[u + 11 | 0] >>> 7 | 0 ? u = i[u + 4 >> 2] : u = l[u + 11 | 0] & 127, h = (u - 1 >>> 0 > h >>> 0) + h | 0, _ = 0), u = p[i[i[w >> 2] + 28 >> 2]](w, o[t | 0]) | 0, v = i[n >> 2], i[n >> 2] = v + 1, o[v | 0] = u, t = t + 1 | 0, _ = _ + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                            }
                            i[k >> 2] = (r | 0) == (e | 0) ? t : (r - A | 0) + f | 0, a0(B + 4 | 0), m = B + 16 | 0;
                        }
                        function E3(A, r, e, f, k, n, t, u, s, h, w, v) {
                            var _ = 0;
                            _ = m - 16 | 0, m = _, o[_ + 15 | 0] = A;
                            i: {
                                if ((A | 0) == (n | 0)) {
                                    if (A = -1, l[r | 0] != 1 || (A = 0, o[r | 0] = 0, r = i[k >> 2], i[k >> 2] = r + 1, o[r | 0] = 46, l[u + 11 | 0] >>> 7 | 0 ? r = i[u + 4 >> 2] : r = l[u + 11 | 0] & 127, !r) || (r = i[h >> 2], (r - s | 0) > 159)) break i;
                                    e = i[w >> 2], i[h >> 2] = r + 4, i[r >> 2] = e;
                                    break i;
                                }
                                if (l[u + 11 | 0] >>> 7 | 0 ? n = i[u + 4 >> 2] : n = l[u + 11 | 0] & 127, !(!n | (A | 0) != (t | 0))) {
                                    if (A = -1, l[r | 0] != 1 || (A = 0, r = i[h >> 2], (r - s | 0) > 159)) break i;
                                    A = i[w >> 2], i[h >> 2] = r + 4, i[r >> 2] = A, A = 0, i[w >> 2] = 0;
                                    break i;
                                }
                                if (A = -1, t = $A(v, v + 32 | 0, _ + 15 | 0) - v | 0, (t | 0) > 31) break i;
                                n = o[t + 64960 | 0];
                                e: {
                                    r: switch((t & -2) - 22 | 0){
                                        case 2:
                                            if (r = i[k >> 2], (r | 0) != (f | 0) && (f = o[r - 1 | 0], e = o[e | 0], ((f - 97 >>> 0 < 26 ? f & 95 : f) | 0) != ((e - 97 >>> 0 < 26 ? e & 95 : e) | 0))) break i;
                                            i[k >> 2] = r + 1, o[r | 0] = n, A = 0;
                                            break i;
                                        case 0:
                                            o[e | 0] = 80;
                                            break e;
                                        default:
                                            break r;
                                    }
                                    if (A = n - 97 >>> 0 < 26 ? n & 95 : n, (A | 0) != o[e | 0] || (o[e | 0] = A - 65 >>> 0 < 26 ? A | 32 : A, l[r | 0] != 1) || (o[r | 0] = 0, l[u + 11 | 0] >>> 7 | 0 ? A = i[u + 4 >> 2] : A = l[u + 11 | 0] & 127, !A) || (A = i[h >> 2], (A - s | 0) > 159)) break e;
                                    r = i[w >> 2], i[h >> 2] = A + 4, i[A >> 2] = r;
                                }
                                if (A = i[k >> 2], i[k >> 2] = A + 1, o[A | 0] = n, A = 0, (t | 0) > 21) break i;
                                i[w >> 2] = i[w >> 2] + 1;
                            }
                            return m = _ + 16 | 0, A;
                        }
                        function l1(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            i: {
                                e: switch(r - 1 | 0){
                                    case 0:
                                        f2(A, e & 255);
                                        return;
                                    case 1:
                                        r = i[A + 12 >> 2], n = r + 2 | 0, k = i[A >> 2], t = i[A + 4 >> 2] - k | 0, n >>> 0 > t >>> 0 && (r1(A, n - t | 0), k = i[A >> 2], r = i[A + 12 >> 2]), i[A + 12 >> 2] = r + 1, o[r + k | 0] = (f & 255) << 24 | e >>> 8;
                                        break i;
                                    case 3:
                                        r = i[A + 12 >> 2], n = r + 4 | 0, k = i[A >> 2], t = i[A + 4 >> 2] - k | 0, n >>> 0 > t >>> 0 && (r1(A, n - t | 0), k = i[A >> 2], r = i[A + 12 >> 2]), i[A + 12 >> 2] = r + 1, o[r + k | 0] = (f & 16777215) << 8 | e >>> 24, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = (f & 65535) << 16 | e >>> 16, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = (f & 255) << 24 | e >>> 8;
                                        break i;
                                    case 7:
                                        r = i[A + 12 >> 2], n = r + 8 | 0, k = i[A >> 2], t = i[A + 4 >> 2] - k | 0, n >>> 0 > t >>> 0 && (r1(A, n - t | 0), k = i[A >> 2], r = i[A + 12 >> 2]), i[A + 12 >> 2] = r + 1, o[r + k | 0] = f >>> 24, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = f >>> 16, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = f >>> 8, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = f, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = (f & 16777215) << 8 | e >>> 24, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = (f & 65535) << 16 | e >>> 16, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = (f & 255) << 24 | e >>> 8, r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = e;
                                        break;
                                    default:
                                        break e;
                                }
                                return;
                            }
                            r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = e;
                        }
                        function g3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0;
                            n = m - 32 | 0, m = n, t = i[r >> 2], u = i[t + 48 >> 2], t = i[t + 52 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, F4(n, u, e, n + 20 | 0);
                            i: {
                                if (i[n >> 2]) {
                                    j0(A, n, i[r >> 2]);
                                    break i;
                                }
                                e: {
                                    if (f && (e = f - 1 | 0, r = i[n + 20 >> 2], e >>> 0 < i[n + 24 >> 2] - r >> 3 >>> 0)) break e;
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 11185;
                                    break i;
                                }
                                r = r + (e << 3) | 0, e = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), f = 0;
                                e: {
                                    if (!e) {
                                        e = 0;
                                        break e;
                                    }
                                    if (e = E0(e, 73632, 73788), !r | !e) break e;
                                    i[r + 4 >> 2] = i[r + 4 >> 2] + 1, f = r;
                                }
                                i[k >> 2] = e, e = i[k + 4 >> 2], i[k + 4 >> 2] = f;
                                e: {
                                    if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break e;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[19867], !r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]), e = i[n + 20 >> 2], e) {
                                if (A = e, r = i[n + 24 >> 2], (A | 0) != (r | 0)) {
                                    for(;;){
                                        A = i[r - 4 >> 2];
                                        i: {
                                            if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (r = r - 8 | 0, (e | 0) == (r | 0)) break;
                                    }
                                    A = i[n + 20 >> 2];
                                }
                                i[n + 24 >> 2] = e, X(A);
                            }
                            i: {
                                if (!t || (A = i[t + 4 >> 2], i[t + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                            }
                            m = n + 32 | 0;
                        }
                        function N5(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0;
                            w = m - 16 | 0, m = w;
                            i: {
                                if (A) {
                                    A = K0(e, 108332);
                                    e: {
                                        if (r) {
                                            r = w + 4 | 0, p[i[i[A >> 2] + 44 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 32 >> 2]](r, A);
                                            break e;
                                        }
                                        r = w + 4 | 0, p[i[i[A >> 2] + 40 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 28 >> 2]](r, A);
                                    }
                                    A8(s, r), h1(r), v = k, _ = p[i[i[A >> 2] + 12 >> 2]](A) | 0, i[v >> 2] = _, v = n, _ = p[i[i[A >> 2] + 16 >> 2]](A) | 0, i[v >> 2] = _, r = w + 4 | 0, p[i[i[A >> 2] + 20 >> 2]](r, A), $1(t, r), a0(r), p[i[i[A >> 2] + 24 >> 2]](r, A), A8(u, r), h1(r), A = p[i[i[A >> 2] + 36 >> 2]](A) | 0;
                                    break i;
                                }
                                A = K0(e, 108324);
                                e: {
                                    if (r) {
                                        r = w + 4 | 0, p[i[i[A >> 2] + 44 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 32 >> 2]](r, A);
                                        break e;
                                    }
                                    r = w + 4 | 0, p[i[i[A >> 2] + 40 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 28 >> 2]](r, A);
                                }
                                A8(s, r), h1(r), v = k, _ = p[i[i[A >> 2] + 12 >> 2]](A) | 0, i[v >> 2] = _, v = n, _ = p[i[i[A >> 2] + 16 >> 2]](A) | 0, i[v >> 2] = _, r = w + 4 | 0, p[i[i[A >> 2] + 20 >> 2]](r, A), $1(t, r), a0(r), p[i[i[A >> 2] + 24 >> 2]](r, A), A8(u, r), h1(r), A = p[i[i[A >> 2] + 36 >> 2]](A) | 0;
                            }
                            i[h >> 2] = A, m = w + 16 | 0;
                        }
                        function sB(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0;
                            v = m - 16 | 0, m = v, h = D(44), i[h + 40 >> 2] = 0, i[h + 32 >> 2] = 0, i[h + 36 >> 2] = 0, i[h + 12 >> 2] = 79184, i[h + 4 >> 2] = 0, i[h + 8 >> 2] = 0, i[h + 28 >> 2] = n, i[h + 24 >> 2] = k, i[h + 20 >> 2] = f, i[h + 16 >> 2] = e, i[h >> 2] = 79428, f = h + 12 | 0, u ? (r1(h + 32 | 0, u), w = i[h + 36 >> 2], e = i[h + 32 >> 2]) : e = 0, v0(e, t, w - e | 0), k = i[r + 8 >> 2], i[v + 12 >> 2] = h, i[v + 8 >> 2] = f, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, e = i[k + 16 >> 2];
                            i: {
                                e: {
                                    if (e >>> 0 < k0[k + 20 >> 2]) {
                                        i[e + 4 >> 2] = h, i[e >> 2] = f, i[h + 4 >> 2] = i[h + 4 >> 2] + 1, i[k + 16 >> 2] = e + 8, w = h;
                                        break e;
                                    }
                                    if (e = P2(k + 12 | 0, v + 8 | 0), w = i[v + 12 >> 2], i[k + 16 >> 2] = e, !w) break i;
                                }
                                if (e = i[w + 4 >> 2], i[w + 4 >> 2] = e - 1, e) break i;
                                p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                            }
                            i: {
                                if (!s || (i[h + 4 >> 2] = i[h + 4 >> 2] + 1, k = D(24), i[h + 4 >> 2] = i[h + 4 >> 2] + 1, i[k + 20 >> 2] = h, i[k + 16 >> 2] = f, e = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[k + 12 >> 2] = f, i[k + 8 >> 2] = e, e = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[k + 4 >> 2] = r, i[k >> 2] = e, i[s >> 2] = k, r = i[h + 4 >> 2], i[h + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[h >> 2] + 8 >> 2]](h), g(h);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[h + 4 >> 2], i[h + 4 >> 2] = A - 1, A || (p[i[i[h >> 2] + 8 >> 2]](h), g(h)), m = v + 16 | 0;
                        }
                        function D5(A, r) {
                            var e = 0, f = 0;
                            l[A | 0] && (e = A, f = l0(r, 2), o[e + 1 | 0] = f, e = A, f = l0(r, 1), o[e + 2 | 0] = f, e = A, f = l0(r, 5), i[e + 4 >> 2] = f, e = A, f = l0(r, 1), o[e + 8 | 0] = f, e = A, f = l0(r, 1), o[e + 9 | 0] = f, e = A, f = l0(r, 1), o[e + 10 | 0] = f, e = A, f = l0(r, 1), o[e + 11 | 0] = f, e = A, f = l0(r, 1), o[e + 12 | 0] = f, e = A, f = l0(r, 1), o[e + 13 | 0] = f, e = A, f = l0(r, 1), o[e + 14 | 0] = f, e = A, f = l0(r, 1), o[e + 15 | 0] = f, e = A, f = l0(r, 1), o[e + 16 | 0] = f, e = A, f = l0(r, 1), o[e + 17 | 0] = f, e = A, f = l0(r, 1), o[e + 18 | 0] = f, e = A, f = l0(r, 1), o[e + 19 | 0] = f, e = A, f = l0(r, 1), o[e + 20 | 0] = f, e = A, f = l0(r, 1), o[e + 21 | 0] = f, e = A, f = l0(r, 1), o[e + 22 | 0] = f, e = A, f = l0(r, 1), o[e + 23 | 0] = f, e = A, f = l0(r, 1), o[e + 24 | 0] = f, e = A, f = l0(r, 1), o[e + 25 | 0] = f, e = A, f = l0(r, 1), o[e + 26 | 0] = f, e = A, f = l0(r, 1), o[e + 27 | 0] = f, e = A, f = l0(r, 1), o[e + 28 | 0] = f, e = A, f = l0(r, 1), o[e + 29 | 0] = f, e = A, f = l0(r, 1), o[e + 30 | 0] = f, e = A, f = l0(r, 1), o[e + 31 | 0] = f, e = A, f = l0(r, 1), o[e + 32 | 0] = f, e = A, f = l0(r, 1), o[e + 33 | 0] = f, e = A, f = l0(r, 1), o[e + 34 | 0] = f, e = A, f = l0(r, 1), o[e + 35 | 0] = f, e = A, f = l0(r, 1), o[e + 36 | 0] = f, e = A, f = l0(r, 1), o[e + 37 | 0] = f, e = A, f = l0(r, 1), o[e + 38 | 0] = f, e = A, f = l0(r, 1), o[e + 39 | 0] = f, e = A, f = l0(r, 1), o[e + 40 | 0] = f, e = A, f = l0(r, 1), o[e + 41 | 0] = f, e = A, f = l0(r, 1), o[e + 42 | 0] = f, e = A, f = l0(r, 1), o[e + 43 | 0] = f, b8(r, 44)), l[A + 44 | 0] && (e = A, f = l0(r, 8), i[e + 48 >> 2] = f);
                        }
                        function M5(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0;
                            w = m - 16 | 0, m = w;
                            i: {
                                if (A) {
                                    A = K0(e, 108316);
                                    e: {
                                        if (r) {
                                            r = w + 4 | 0, p[i[i[A >> 2] + 44 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 32 >> 2]](r, A);
                                            break e;
                                        }
                                        r = w + 4 | 0, p[i[i[A >> 2] + 40 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 28 >> 2]](r, A);
                                    }
                                    $1(s, r), a0(r), v = k, _ = p[i[i[A >> 2] + 12 >> 2]](A) | 0, o[v | 0] = _, v = n, _ = p[i[i[A >> 2] + 16 >> 2]](A) | 0, o[v | 0] = _, r = w + 4 | 0, p[i[i[A >> 2] + 20 >> 2]](r, A), $1(t, r), a0(r), p[i[i[A >> 2] + 24 >> 2]](r, A), $1(u, r), a0(r), A = p[i[i[A >> 2] + 36 >> 2]](A) | 0;
                                    break i;
                                }
                                A = K0(e, 108308);
                                e: {
                                    if (r) {
                                        r = w + 4 | 0, p[i[i[A >> 2] + 44 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 32 >> 2]](r, A);
                                        break e;
                                    }
                                    r = w + 4 | 0, p[i[i[A >> 2] + 40 >> 2]](r, A), e = i[w + 4 >> 2], o[f | 0] = e, o[f + 1 | 0] = e >>> 8, o[f + 2 | 0] = e >>> 16, o[f + 3 | 0] = e >>> 24, p[i[i[A >> 2] + 28 >> 2]](r, A);
                                }
                                $1(s, r), a0(r), v = k, _ = p[i[i[A >> 2] + 12 >> 2]](A) | 0, o[v | 0] = _, v = n, _ = p[i[i[A >> 2] + 16 >> 2]](A) | 0, o[v | 0] = _, r = w + 4 | 0, p[i[i[A >> 2] + 20 >> 2]](r, A), $1(t, r), a0(r), p[i[i[A >> 2] + 24 >> 2]](r, A), $1(u, r), a0(r), A = p[i[i[A >> 2] + 36 >> 2]](A) | 0;
                            }
                            i[h >> 2] = A, m = w + 16 | 0;
                        }
                        function hB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                e: {
                                    r: {
                                        if (!i[e + 16 >> 2]) break r;
                                        for(;;){
                                            if (l[e + 20 | 0]) break r;
                                            s = B2(e), w = X2(e), v = X2(e), n = i[r + 104 >> 2], k = i[r + 108 >> 2];
                                            A: {
                                                if (n >>> 0 < k >>> 0) {
                                                    t = s | (v << 24 | w << 16), Q[n >> 1] = t, Q[n + 2 >> 1] = t >>> 16, s = n + 4 | 0;
                                                    break A;
                                                }
                                                if (h = i[r + 100 >> 2], u = n - h >> 2, t = u + 1 | 0, t >>> 0 >= 1073741824) break e;
                                                if (_ = u << 2, k = k - h | 0, u = k >> 1, u = k >>> 0 >= 2147483644 ? 1073741823 : u >>> 0 > t >>> 0 ? u : t, u) {
                                                    if (u >>> 0 >= 1073741824) break i;
                                                    t = D(u << 2);
                                                } else t = 0;
                                                if (k = _ + t | 0, s = s | (v << 24 | w << 16), Q[k >> 1] = s, Q[k + 2 >> 1] = s >>> 16, s = k + 4 | 0, (n | 0) != (h | 0)) {
                                                    for(; k = k - 4 | 0, n = n - 4 | 0, w = I[n >> 1] | I[n + 2 >> 1] << 16, Q[k >> 1] = w, Q[k + 2 >> 1] = w >>> 16, (n | 0) != (h | 0););
                                                    h = i[r + 100 >> 2];
                                                }
                                                if (i[r + 108 >> 2] = t + (u << 2), i[r + 104 >> 2] = s, i[r + 100 >> 2] = k, !h) break A;
                                                X(h);
                                            }
                                            if (i[r + 104 >> 2] = s, !i[e + 16 >> 2]) break;
                                        }
                                    }
                                    r: {
                                        if (l[e + 20 | 0] == 1) {
                                            if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break r;
                                            X(i[f + 4 >> 2]);
                                            break r;
                                        }
                                        if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                            r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                            break r;
                                        }
                                        j(A, i[21670], i[21671]);
                                    }
                                    m = f + 16 | 0;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function U5(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, e = i0(f + 28 | 0, 5, 2001, f + 16 | 0), o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), j0(A, e, i[r >> 2]), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                gt(f + 8 | 0, i[r >> 2]), n = i[f + 8 >> 2];
                                e: {
                                    if (!n) {
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, e = i0(f + 28 | 0, 2, 124, f + 16 | 0), o[f + 27 | 0] < 0 && X(i[f + 16 >> 2]), j0(A, e, i[r >> 2]), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    if (k = E0(n, 82544, 79952), k) {
                                        if (e = i[f + 12 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), n = f + 28 | 0, p[i[i[k >> 2] + 20 >> 2]](n, k), j0(A, n, i[r >> 2]), o[f + 47 | 0] < 0 && X(i[f + 36 >> 2]), !e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break e;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        break e;
                                    }
                                    k = D(16), i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[e >> 2] = k, e = i[f + 12 >> 2], i[f + 8 >> 2] = 0, i[f + 12 >> 2] = 0, i[k + 4 >> 2] = e, i[k >> 2] = n, e = i[r >> 2], n = i[r + 4 >> 2];
                                    r: {
                                        if (!n) {
                                            i[k + 12 >> 2] = n, i[k + 8 >> 2] = e;
                                            break r;
                                        }
                                        if (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[k + 8 >> 2] = e, e = i[k + 12 >> 2], i[k + 12 >> 2] = n, !e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    j0(A, 86672, i[r >> 2]);
                                }
                                if (A = i[f + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = f + 48 | 0;
                        }
                        function wB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 32 | 0, m = n, A = i[A >> 2], u = i[A + 48 >> 2], s = i[A + 52 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), i[n + 28 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 24 >> 2] = 0, F4(n, u, r, n + 20 | 0);
                            i: {
                                if (i[n >> 2] || (A = i[n + 20 >> 2], h = i[n + 24 >> 2], (A | 0) == (h | 0))) break i;
                                r = !f;
                                e: {
                                    if (!e) {
                                        if (r) break e;
                                        for(u = 1; e = r, (k | 0) > (t | 0) && (i[(t << 2) + f >> 2] = u, e = 1), u = u + 1 | 0, t = e + t | 0, A = A + 8 | 0, (h | 0) != (A | 0););
                                        break i;
                                    }
                                    if (!f) {
                                        for(;;)if (t = (r & i[i[A >> 2] + 16 >> 2] == (e | 0)) + t | 0, A = A + 8 | 0, (h | 0) == (A | 0)) break i;
                                    }
                                    for(u = 1;;){
                                        r: {
                                            if (i[i[A >> 2] + 16 >> 2] != (e | 0)) break r;
                                            if ((k | 0) > (t | 0)) {
                                                i[(t << 2) + f >> 2] = u, t = t + 1 | 0;
                                                break r;
                                            }
                                            t = r + t | 0;
                                        }
                                        if (u = u + 1 | 0, A = A + 8 | 0, (h | 0) == (A | 0)) break;
                                    }
                                    break i;
                                }
                                t = ((h - A | 0) - 8 >>> 3 | 0) + 1 | 0;
                            }
                            if (o[n + 19 | 0] < 0 && X(i[n + 8 >> 2]), e = i[n + 20 >> 2], e) {
                                if (A = i[n + 24 >> 2], r = e, (A | 0) != (r | 0)) {
                                    for(;;){
                                        r = i[A - 4 >> 2];
                                        i: {
                                            if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (A = A - 8 | 0, (e | 0) == (A | 0)) break;
                                    }
                                    r = i[n + 20 >> 2];
                                }
                                i[n + 24 >> 2] = e, X(r);
                            }
                            i: {
                                if (!s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                            }
                            return m = n + 32 | 0, t | 0;
                        }
                        function H5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (l[A + 52 | 0] == 1) {
                                    if (e = i[A + 48 >> 2], !r) break i;
                                    o[A + 52 | 0] = 0, i[A + 48 >> 2] = -1;
                                    break i;
                                }
                                e: {
                                    if (l[A + 53 | 0] == 1) {
                                        if (e = Vi(i[A + 32 >> 2]), (e | 0) != -1 && (o[f + 24 | 0] = e), (e | 0) == -1) break e;
                                        e = l[f + 24 | 0];
                                        r: {
                                            if (!r) {
                                                if (!Ko(e, i[A + 32 >> 2])) break e;
                                                break r;
                                            }
                                            i[A + 48 >> 2] = e;
                                        }
                                        e = l[f + 24 | 0];
                                        break i;
                                    }
                                    for(i[f + 24 >> 2] = 1, k = m - 16 | 0, m = k, m = k + 16 | 0, k = A + 44 | 0, n = f + 24 | 0, k = i[(i[n >> 2] < i[k >> 2] ? k : n) >> 2], n = (k | 0) > 0 ? k : 0;;){
                                        if ((e | 0) != (n | 0)) {
                                            if (t = Vi(i[A + 32 >> 2]), (t | 0) == -1) break e;
                                            o[(f + 24 | 0) + e | 0] = t, e = e + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    h = f + 24 | 0;
                                    r: {
                                        for(;;){
                                            A: {
                                                n = i[A + 40 >> 2], e = i[n >> 2], w = i[n + 4 >> 2], u = f + 24 | 0, t = u + k | 0;
                                                f: switch(s = i[A + 36 >> 2], (p[i[i[s >> 2] + 16 >> 2]](s, n, u, t, f + 16 | 0, f + 23 | 0, h, f + 12 | 0) | 0) - 1 | 0){
                                                    case 2:
                                                        break A;
                                                    case 0:
                                                        break f;
                                                    case 1:
                                                        break e;
                                                    default:
                                                        break r;
                                                }
                                                if (n = i[A + 40 >> 2], i[n >> 2] = e, i[n + 4 >> 2] = w, (k | 0) == 8 || (e = Vi(i[A + 32 >> 2]), (e | 0) == -1)) break e;
                                                o[t | 0] = e, k = k + 1 | 0;
                                                continue;
                                            }
                                            break;
                                        }
                                        o[f + 23 | 0] = l[f + 24 | 0];
                                    }
                                    r: {
                                        if (!r) for(;;){
                                            if ((k | 0) <= 0) break r;
                                            if (k = k - 1 | 0, (F6(l[k + (f + 24 | 0) | 0], i[A + 32 >> 2]) | 0) == -1) break e;
                                        }
                                        i[A + 48 >> 2] = l[f + 23 | 0];
                                    }
                                    e = l[f + 23 | 0];
                                    break i;
                                }
                                e = -1;
                            }
                            return m = f + 32 | 0, e;
                        }
                        function vB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 80 >> 2] = 60132, k = i[15036], i[f + 24 >> 2] = k, u = i[k - 12 >> 2], k = f + 24 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 24 >> 2] - 12 >> 2] | 0, n = f + 28 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 80 >> 2] = 60132, i[f + 24 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 16, n = f + 12 | 0, D2(n, r, e), s = k, u = n, k = o[f + 23 | 0], n = (k | 0) < 0, U(s, n ? i[f + 12 >> 2] : u, n ? i[f + 16 >> 2] : k), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), k = f + 12 | 0, h5(k, r, e, 1), r = o[f + 23 | 0], e = (r | 0) < 0, U(f + 24 | 0, e ? i[f + 12 >> 2] : k, e ? i[f + 16 >> 2] : r), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), r = i[f + 76 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 72 >> 2], r = i[f + 52 >> 2], e >>> 0 < r >>> 0 && (i[f + 72 >> 2] = r, e = r), r = f + 48 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 44 >> 2], r = f + 36 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 24 >> 2] = A, i[i[A - 12 >> 2] + (f + 24 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(t), N0(f + 80 | 0), m = f + 160 | 0;
                        }
                        function q8(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 160 | 0, m = f, i[f + 80 >> 2] = 60132, k = i[15036], i[f + 24 >> 2] = k, u = i[k - 12 >> 2], k = f + 24 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 24 >> 2] - 12 >> 2] | 0, n = f + 28 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 80 >> 2] = 60132, i[f + 24 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 16, n = f + 12 | 0, D2(n, r, e), s = k, u = n, k = o[f + 23 | 0], n = (k | 0) < 0, U(s, n ? i[f + 12 >> 2] : u, n ? i[f + 16 >> 2] : k), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), k = f + 12 | 0, h5(k, r, e, 0), r = o[f + 23 | 0], e = (r | 0) < 0, U(f + 24 | 0, e ? i[f + 12 >> 2] : k, e ? i[f + 16 >> 2] : r), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), r = i[f + 76 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 72 >> 2], r = i[f + 52 >> 2], e >>> 0 < r >>> 0 && (i[f + 72 >> 2] = r, e = r), r = f + 48 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 44 >> 2], r = f + 36 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], e = e - k | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            n = (e | 7) + 1 | 0, r = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 24 >> 2] = A, i[i[A - 12 >> 2] + (f + 24 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(t), N0(f + 80 | 0), m = f + 160 | 0;
                        }
                        function _B(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            r = m - 16 | 0, m = r, e = D(32), i[r + 4 >> 2] = e, i[r + 8 >> 2] = 29, i[r + 12 >> 2] = -2147483616, f = l[18551] | l[18552] << 8 | (l[18553] << 16 | l[18554] << 24), k = l[18547] | l[18548] << 8 | (l[18549] << 16 | l[18550] << 24), o[e | 0] = k, o[e + 1 | 0] = k >>> 8, o[e + 2 | 0] = k >>> 16, o[e + 3 | 0] = k >>> 24, o[e + 4 | 0] = f, o[e + 5 | 0] = f >>> 8, o[e + 6 | 0] = f >>> 16, o[e + 7 | 0] = f >>> 24, o[e + 29 | 0] = 0, f = l[18572] | l[18573] << 8 | (l[18574] << 16 | l[18575] << 24), k = l[18568] | l[18569] << 8 | (l[18570] << 16 | l[18571] << 24), o[e + 21 | 0] = k, o[e + 22 | 0] = k >>> 8, o[e + 23 | 0] = k >>> 16, o[e + 24 | 0] = k >>> 24, o[e + 25 | 0] = f, o[e + 26 | 0] = f >>> 8, o[e + 27 | 0] = f >>> 16, o[e + 28 | 0] = f >>> 24, f = l[18567] | l[18568] << 8 | (l[18569] << 16 | l[18570] << 24), k = l[18563] | l[18564] << 8 | (l[18565] << 16 | l[18566] << 24), o[e + 16 | 0] = k, o[e + 17 | 0] = k >>> 8, o[e + 18 | 0] = k >>> 16, o[e + 19 | 0] = k >>> 24, o[e + 20 | 0] = f, o[e + 21 | 0] = f >>> 8, o[e + 22 | 0] = f >>> 16, o[e + 23 | 0] = f >>> 24, f = l[18559] | l[18560] << 8 | (l[18561] << 16 | l[18562] << 24), k = l[18555] | l[18556] << 8 | (l[18557] << 16 | l[18558] << 24), o[e + 8 | 0] = k, o[e + 9 | 0] = k >>> 8, o[e + 10 | 0] = k >>> 16, o[e + 11 | 0] = k >>> 24, o[e + 12 | 0] = f, o[e + 13 | 0] = f >>> 8, o[e + 14 | 0] = f >>> 16, o[e + 15 | 0] = f >>> 24, i0(A, 5, 0, r + 4 | 0), o[r + 15 | 0] < 0 && X(i[r + 4 >> 2]), m = r + 16 | 0;
                        }
                        function BB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            r = m - 32 | 0, m = r, n = i[e + 12 >> 2];
                            i: {
                                if ((n | 0) >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if ((n | 0) != 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(i[e >> 2] == 1 & i[e + 4 >> 2] == 3)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (n = I[f + 24 >> 1], !(n >>> 0 > 14 | !(1 << n & 18688))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, n = i[f + 4 >> 2], !((n | 0) == 3 | (l[k + 12 | 0] ? i[k + 4 >> 2] != 1 : 0))) {
                                    i[r + 8 >> 2] = n, i[r + 4 >> 2] = 0, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, i[r + 24 >> 2] = i[f + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                                    break i;
                                }
                                i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, i[r + 24 >> 2] = i[f + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function mB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = +k;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            n = m - 368 | 0, m = n, i[n + 360 >> 2] = 37, i[n + 364 >> 2] = 0, t = n + 360 | 0, u = be(t | 1, 34896, i[e + 4 >> 2]), s = n + 320 | 0, i[n + 316 >> 2] = s, A = L2();
                            i: {
                                if (u) {
                                    h = i[e + 8 >> 2], n0[n + 40 >> 3] = k, i[n + 32 >> 2] = h, A = c1(s, 30, A, t, n + 32 | 0);
                                    break i;
                                }
                                n0[n + 48 >> 3] = k, A = c1(n + 320 | 0, 30, A, n + 360 | 0, n + 48 | 0);
                            }
                            i[n + 80 >> 2] = 1413, s = s1(n + 308 | 0, 0, n + 80 | 0), t = n + 320 | 0;
                            i: {
                                e: {
                                    if ((A | 0) >= 30) {
                                        A = L2();
                                        r: {
                                            if (u) {
                                                t = i[e + 8 >> 2], n0[n + 8 >> 3] = k, i[n >> 2] = t, A = e8(n + 316 | 0, A, n + 360 | 0, n);
                                                break r;
                                            }
                                            n0[n + 16 >> 3] = k, A = e8(n + 316 | 0, A, n + 360 | 0, n + 16 | 0);
                                        }
                                        if ((A | 0) == -1) break e;
                                        t = i[s >> 2], i[s >> 2] = i[n + 316 >> 2], t && p[i[s + 4 >> 2]](t), t = i[n + 316 >> 2];
                                    }
                                    v = A + t | 0, _ = W4(t, v, e), i[n + 80 >> 2] = 1413, t = n + 80 | 0, u = s1(n + 72 | 0, 0, t), h = i[n + 316 >> 2];
                                    r: {
                                        if ((h | 0) == (n + 320 | 0)) {
                                            A = t;
                                            break r;
                                        }
                                        if (A = Q2(A << 3), !A) break e;
                                        t = i[u >> 2], i[u >> 2] = A, t && p[i[u + 4 >> 2]](t), h = i[n + 316 >> 2];
                                    }
                                    w = n + 60 | 0, t = i[e + 28 >> 2], i[w >> 2] = t, (t | 0) != 108396 && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), m5(h, _, v, A, n + 68 | 0, n - -64 | 0, w), d0(w), A = X8(r, A, i[n + 68 >> 2], i[n + 64 >> 2], e, f), r = i[u >> 2], i[u >> 2] = 0, r && p[i[u + 4 >> 2]](r), r = i[s >> 2], i[s >> 2] = 0, r && p[i[s + 4 >> 2]](r), m = n + 368 | 0;
                                    break i;
                                }
                                w1(), z();
                            }
                            return A | 0;
                        }
                        function ZB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = +k;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            n = m - 208 | 0, m = n, i[n + 200 >> 2] = 37, i[n + 204 >> 2] = 0, t = n + 200 | 0, u = be(t | 1, 34896, i[e + 4 >> 2]), s = n + 160 | 0, i[n + 156 >> 2] = s, A = L2();
                            i: {
                                if (u) {
                                    h = i[e + 8 >> 2], n0[n + 40 >> 3] = k, i[n + 32 >> 2] = h, A = c1(s, 30, A, t, n + 32 | 0);
                                    break i;
                                }
                                n0[n + 48 >> 3] = k, A = c1(n + 160 | 0, 30, A, n + 200 | 0, n + 48 | 0);
                            }
                            i[n + 80 >> 2] = 1413, s = s1(n + 148 | 0, 0, n + 80 | 0), t = n + 160 | 0;
                            i: {
                                e: {
                                    if ((A | 0) >= 30) {
                                        A = L2();
                                        r: {
                                            if (u) {
                                                t = i[e + 8 >> 2], n0[n + 8 >> 3] = k, i[n >> 2] = t, A = e8(n + 156 | 0, A, n + 200 | 0, n);
                                                break r;
                                            }
                                            n0[n + 16 >> 3] = k, A = e8(n + 156 | 0, A, n + 200 | 0, n + 16 | 0);
                                        }
                                        if ((A | 0) == -1) break e;
                                        t = i[s >> 2], i[s >> 2] = i[n + 156 >> 2], t && p[i[s + 4 >> 2]](t), t = i[n + 156 >> 2];
                                    }
                                    v = A + t | 0, _ = W4(t, v, e), i[n + 80 >> 2] = 1413, t = n + 80 | 0, u = s1(n + 72 | 0, 0, t), h = i[n + 156 >> 2];
                                    r: {
                                        if ((h | 0) == (n + 160 | 0)) {
                                            A = t;
                                            break r;
                                        }
                                        if (A = Q2(A << 1), !A) break e;
                                        t = i[u >> 2], i[u >> 2] = A, t && p[i[u + 4 >> 2]](t), h = i[n + 156 >> 2];
                                    }
                                    w = n + 60 | 0, t = i[e + 28 >> 2], i[w >> 2] = t, (t | 0) != 108396 && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), Z5(h, _, v, A, n + 68 | 0, n - -64 | 0, w), d0(w), A = p8(r, A, i[n + 68 >> 2], i[n + 64 >> 2], e, f), r = i[u >> 2], i[u >> 2] = 0, r && p[i[u + 4 >> 2]](r), r = i[s >> 2], i[s >> 2] = 0, r && p[i[s + 4 >> 2]](r), m = n + 208 | 0;
                                    break i;
                                }
                                w1(), z();
                            }
                            return A | 0;
                        }
                        function J3(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            n = m - 32 | 0, m = n, t = f & 65535, u = f >>> 16 & 32767;
                            i: {
                                if (u - 15361 >>> 0 <= 2045) {
                                    k = e, e = t << 4 | e >>> 28, k = k << 4 | r >>> 28, t = u - 15360 | 0, r = r & 268435455;
                                    e: {
                                        if ((r | 0) == 134217728 & (A | 0) != 0 | r >>> 0 > 134217728) {
                                            k = k + 1 | 0, e = k ? e : e + 1 | 0;
                                            break e;
                                        }
                                        if (A | (r | 0) != 134217728) break e;
                                        A = k, k = k + (k & 1) | 0, e = A >>> 0 > k >>> 0 ? e + 1 | 0 : e;
                                    }
                                    A = e >>> 0 > 1048575, h = A ? 0 : k, w = A ? 0 : e, e = 0, k = A + t | 0, s = k >>> 0 < t >>> 0 ? 1 : e;
                                    break i;
                                }
                                if (!(!(A | e | (r | t)) | ((u | 0) != 32767 | (h | 0) != 0))) {
                                    A = e, e = t << 4 | e >>> 28, h = A << 4 | r >>> 28, w = e | 524288, k = 2047, s = 0;
                                    break i;
                                }
                                if (u >>> 0 > 17406) {
                                    k = 2047, s = 0;
                                    break i;
                                }
                                if (_ = !(h | u), B = _ ? 15360 : 15361, v = B - u | 0, s = 0, (v | 0) > 112) break i;
                                k = _ ? t : t | 65536, P1(n + 16 | 0, A, r, e, k, 128 - v | 0), d8(n, A, r, e, k, v), A = i[n + 8 >> 2], t = A << 4, r = i[n + 12 >> 2] << 4 | A >>> 28, k = i[n >> 2], A = i[n + 4 >> 2], e = A, A = e >>> 28 | t, e = e & 268435455, k = k | (u | 0) != (B | 0) & (i[n + 16 >> 2] | i[n + 24 >> 2] | (i[n + 20 >> 2] | i[n + 28 >> 2])) != 0;
                                e: {
                                    if ((e | 0) == 134217728 & (k | 0) != 0 | e >>> 0 > 134217728) {
                                        A = A + 1 | 0, r = A ? r : r + 1 | 0;
                                        break e;
                                    }
                                    if (k | (e | 0) != 134217728) break e;
                                    e = r, r = A, A = A + (A & 1) | 0, r = r >>> 0 > A >>> 0 ? e + 1 | 0 : e;
                                }
                                k = r >>> 0 > 1048575, h = A, w = k ? r ^ 1048576 : r, s = 0;
                            }
                            return m = n + 32 | 0, J2(0, h | 0), J2(1, w | (f & -2147483648 | k << 20)), +o1();
                        }
                        function G0(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = m - 144 | 0, m = e, i[e + 8 >> 2] = 59808, i[e + 64 >> 2] = 59828, f = i[14961], i[e >> 2] = f, i[i[f - 12 >> 2] + e >> 2] = i[14962], f = 0, i[e + 4 >> 2] = 0, k = i[i[e >> 2] - 12 >> 2] + e | 0, n = e + 12 | 0, T0(k, n), i[k + 72 >> 2] = 0, i[k + 76 >> 2] = -1, k = i[14963], i[e + 8 >> 2] = k, t = e + 8 | 0, i[t + i[k - 12 >> 2] >> 2] = i[14964], k = i[14960], i[e >> 2] = k, i[i[k - 12 >> 2] + e >> 2] = i[14965], i[e + 64 >> 2] = 59828, i[e >> 2] = 59788, i[e + 8 >> 2] = 59808, k = z0(n), i[k >> 2] = 58864, i[e + 52 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 60 >> 2] = 24;
                            i: {
                                e: {
                                    r: {
                                        if (i[r >> 2] > 0) {
                                            for(; U(t, 21245, 2), f = f + 1 | 0, (f | 0) < i[r >> 2];);
                                            if (r = i[e + 60 >> 2], !(r & 16)) break r;
                                        }
                                        f = i[e + 56 >> 2], r = i[e + 36 >> 2], f >>> 0 < r >>> 0 && (i[e + 56 >> 2] = r, f = r), r = e + 32 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        f = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    f = i[e + 28 >> 2], r = e + 20 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], f = f - n | 0, f >>> 0 < 2147483640) {
                                        if (f >>> 0 >= 11) {
                                            t = (f | 7) + 1 | 0, r = D(t), i[A + 8 >> 2] = t | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = f, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = f, f) break e;
                                        f = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, f);
                            }
                            o[A + f | 0] = 0, A = i[14959], i[e >> 2] = A, i[i[A - 12 >> 2] + e >> 2] = i[14967], i[e + 8 >> 2] = i[14968], i[k >> 2] = 58864, o[e + 55 | 0] < 0 && X(i[e + 44 >> 2]), x0(k), N0(e - -64 | 0), m = e + 144 | 0;
                        }
                        function GB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 80 | 0, m = f, n = -1;
                            i: {
                                if (!A | (r | 0) <= 0 | (!e | !l[e | 0]) || !l[e + 3 | 0] | (!l[e + 1 | 0] | !l[e + 2 | 0])) break i;
                                k = D(72), i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, i[k >> 2] = 78588, A = ZA(k + 16 | 0, A, r, 0), i[f + 52 >> 2] = k, i[f + 48 >> 2] = A, i[k + 4 >> 2] = i[k + 4 >> 2] + 1, A = i[f + 52 >> 2], i[f + 8 >> 2] = i[f + 48 >> 2], i[f + 12 >> 2] = A, t = kr(f + 56 | 0, f + 8 | 0, r, 0), i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 0, c6(f + 20 | 0, t, f + 40 | 0, 78816);
                                e: {
                                    if (i[f + 20 >> 2]) {
                                        n = i[f + 24 >> 2] == 100 ? -1 : -2;
                                        break e;
                                    }
                                    if (n = -2, A = i[f + 40 >> 2], !A || (r = E0(A, 73632, 73932), !r) || (A = i[f + 44 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), n = r, r = l[e | 0] | l[e + 1 | 0] << 8 | (l[e + 2 | 0] << 16 | l[e + 3 | 0] << 24), n = k6(n, r << 24 | (r & 65280) << 8 | (r >>> 8 & 65280 | r >>> 24)), !A) || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                o[f + 39 | 0] < 0 && X(i[f + 28 >> 2]), A = i[f + 44 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                A = i[t + 4 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                if (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            return m = f + 80 | 0, n | 0;
                        }
                        function WB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            t = m - 16 | 0, m = t;
                            i: {
                                e: {
                                    if (!r) {
                                        e = 0;
                                        break e;
                                    }
                                    if (A = i[A >> 2], i[t + 12 >> 2] = 0, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, f = i[A + 52 >> 2], k = i[A + 56 >> 2], (f | 0) != (k | 0)) {
                                        if (A = k - f | 0, (A | 0) < 0) break i;
                                        for(n = D(A), i[t + 4 >> 2] = n, i[t + 12 >> 2] = A + n, A = n; i[A >> 2] = i[f >> 2], u = i[f + 4 >> 2], i[A + 4 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), A = A + 8 | 0, f = f + 8 | 0, (k | 0) != (f | 0););
                                        i[t + 8 >> 2] = A, f = A - n >> 3, e = (e | 0) > (f | 0) ? f : e;
                                        r: {
                                            if ((e | 0) <= 0) break r;
                                            if (u = 0, f = 0, e >>> 0 >= 4) for(h = e & 2147483644, k = 0; i[(f << 2) + r >> 2] = i[i[(f << 3) + n >> 2] + 36 >> 2], s = f | 1, i[(s << 2) + r >> 2] = i[i[(s << 3) + n >> 2] + 36 >> 2], s = f | 2, i[(s << 2) + r >> 2] = i[i[(s << 3) + n >> 2] + 36 >> 2], s = f | 3, i[(s << 2) + r >> 2] = i[i[(s << 3) + n >> 2] + 36 >> 2], f = f + 4 | 0, k = k + 4 | 0, (h | 0) != (k | 0););
                                            if (k = e & 3, !k) break r;
                                            for(; i[(f << 2) + r >> 2] = i[i[(f << 3) + n >> 2] + 36 >> 2], f = f + 1 | 0, u = u + 1 | 0, (k | 0) != (u | 0););
                                        }
                                        for(;;){
                                            r = A - 8 | 0, A = i[A - 4 >> 2];
                                            r: {
                                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break r;
                                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                            }
                                            if (A = r, (n | 0) == (A | 0)) break;
                                        }
                                        X(i[t + 4 >> 2]);
                                        break e;
                                    }
                                    e = e >> 31 & e;
                                }
                                return m = t + 16 | 0, e | 0;
                            }
                            p0(), z();
                        }
                        function U(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            u = m - 16 | 0, m = u, v = C1(u + 4 | 0, A);
                            i: {
                                if (l[v | 0] != 1) break i;
                                s = r + e | 0, t = i[i[A >> 2] - 12 >> 2] + A | 0, h = (i[t + 4 >> 2] & 176) == 32 ? s : r, k = i[t + 24 >> 2], e = i[t + 76 >> 2], (e | 0) == -1 && (f = u + 12 | 0, e = i[t + 28 >> 2], i[f >> 2] = e, (e | 0) != 108396 && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), e = K0(f, 108580), e = p[i[i[e >> 2] + 28 >> 2]](e, 32) | 0, d0(f), i[t + 76 >> 2] = e), _ = e << 24 >> 24, e = 0, f = m - 16 | 0, m = f;
                                e: {
                                    r: {
                                        A: {
                                            if (!k || (n = i[t + 12 >> 2], w = h - r | 0, (w | 0) > 0 && (p[i[i[k >> 2] + 48 >> 2]](k, r, w) | 0) != (w | 0))) break A;
                                            if (r = s - r | 0, r = (r | 0) < (n | 0) ? n - r | 0 : 0, (r | 0) > 0) {
                                                if (r >>> 0 >= 2147483640) break r;
                                                f: {
                                                    if (r >>> 0 >= 11) {
                                                        e = (r | 7) + 1 | 0, n = D(e), i[f + 12 >> 2] = e | -2147483648, i[f + 4 >> 2] = n, i[f + 8 >> 2] = r;
                                                        break f;
                                                    }
                                                    o[f + 15 | 0] = r, n = f + 4 | 0;
                                                }
                                                if (e = 0, B = B0(n, _, r) + r | 0, G = 0, o[B | 0] = G, n = p[i[i[k >> 2] + 48 >> 2]](k, o[f + 15 | 0] < 0 ? i[f + 4 >> 2] : f + 4 | 0, r) | 0, o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), (r | 0) != (n | 0)) break A;
                                            }
                                            if (r = s - h | 0, (r | 0) > 0 && (p[i[i[k >> 2] + 48 >> 2]](k, h, r) | 0) != (r | 0)) break A;
                                            i[t + 12 >> 2] = 0, e = k;
                                        }
                                        m = f + 16 | 0;
                                        break e;
                                    }
                                    Y0(), z();
                                }
                                if (e) break i;
                                r = i[i[A >> 2] - 12 >> 2] + A | 0, N1(r, i[r + 16 >> 2] | 5);
                            }
                            return G1(v), m = u + 16 | 0, A;
                        }
                        function XB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0;
                            u = m - 160 | 0, m = u;
                            i: {
                                e: {
                                    if (s = i[r + 16 >> 2], !s || (w = E0(s, 78492, 79032), !w)) break e;
                                    if (s = i[r + 20 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), h = i[r >> 2], i[u + 104 >> 2] = i[h + 48 >> 2], h = i[h + 52 >> 2], i[u + 108 >> 2] = h, h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), r = i[r + 8 >> 2], h = i[r + 8 >> 2], v = i[r + 4 >> 2], r = i[u + 108 >> 2], i[u + 32 >> 2] = i[u + 104 >> 2], i[u + 36 >> 2] = r, r = u + 112 | 0, ve(r, u + 32 | 0, e, v, h), n0[u + 72 >> 3] = i[w + 4 >> 2], n0[u + 80 >> 3] = i[w + 8 >> 2], e = i[u + 84 >> 2], i[u + 24 >> 2] = i[u + 80 >> 2], i[u + 28 >> 2] = e, e = i[u + 76 >> 2], i[u + 16 >> 2] = i[u + 72 >> 2], i[u + 20 >> 2] = e, tr(u + 88 | 0, r, u + 16 | 0), n0[u + 40 >> 3] = k0[w + 12 >> 2], n0[u + 48 >> 3] = k0[w + 16 >> 2], e = i[u + 52 >> 2], i[u + 8 >> 2] = i[u + 48 >> 2], i[u + 12 >> 2] = e, e = i[u + 44 >> 2], i[u >> 2] = i[u + 40 >> 2], i[u + 4 >> 2] = e, Pt(u + 56 | 0, r, u), n0[f >> 3] = n0[u + 88 >> 3], n0[k >> 3] = n0[u + 96 >> 3], n0[n >> 3] = n0[u + 56 >> 3], n0[t >> 3] = n0[u + 64 >> 3], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, !s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                    break i;
                                }
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                            }
                            m = u + 160 | 0;
                        }
                        function pB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0;
                            u = m - 160 | 0, m = u;
                            i: {
                                e: {
                                    if (s = i[r + 16 >> 2], !s || (w = E0(s, 78492, 79076), !w)) break e;
                                    if (s = i[r + 20 >> 2], s && (i[s + 4 >> 2] = i[s + 4 >> 2] + 1), h = i[r >> 2], i[u + 104 >> 2] = i[h + 48 >> 2], h = i[h + 52 >> 2], i[u + 108 >> 2] = h, h && (i[h + 4 >> 2] = i[h + 4 >> 2] + 1), r = i[r + 8 >> 2], h = i[r + 8 >> 2], v = i[r + 4 >> 2], r = i[u + 108 >> 2], i[u + 32 >> 2] = i[u + 104 >> 2], i[u + 36 >> 2] = r, r = u + 112 | 0, ve(r, u + 32 | 0, e, v, h), n0[u + 72 >> 3] = i[w + 4 >> 2], n0[u + 80 >> 3] = i[w + 8 >> 2], e = i[u + 84 >> 2], i[u + 24 >> 2] = i[u + 80 >> 2], i[u + 28 >> 2] = e, e = i[u + 76 >> 2], i[u + 16 >> 2] = i[u + 72 >> 2], i[u + 20 >> 2] = e, tr(u + 88 | 0, r, u + 16 | 0), n0[u + 40 >> 3] = k0[w + 12 >> 2], n0[u + 48 >> 3] = k0[w + 16 >> 2], e = i[u + 52 >> 2], i[u + 8 >> 2] = i[u + 48 >> 2], i[u + 12 >> 2] = e, e = i[u + 44 >> 2], i[u >> 2] = i[u + 40 >> 2], i[u + 4 >> 2] = e, Pt(u + 56 | 0, r, u), n0[f >> 3] = n0[u + 88 >> 3], n0[k >> 3] = n0[u + 96 >> 3], n0[n >> 3] = n0[u + 56 >> 3], n0[t >> 3] = n0[u + 64 >> 3], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, !s || (A = i[s + 4 >> 2], i[s + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[s >> 2] + 8 >> 2]](s), g(s);
                                    break i;
                                }
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                            }
                            m = u + 160 | 0;
                        }
                        function h4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            k = (A | 0) == (r | 0), o[r + 12 | 0] = k;
                            i: {
                                if (k) break i;
                                for(;;){
                                    if (k = i[r + 8 >> 2], l[k + 12 | 0]) break i;
                                    e: {
                                        if (e = i[k + 8 >> 2], f = i[e >> 2], (k | 0) == (f | 0)) {
                                            if (n = i[e + 4 >> 2], !(!n | l[n + 12 | 0] == 1)) {
                                                f = n + 12 | 0;
                                                break e;
                                            }
                                            r: {
                                                if (i[k >> 2] == (r | 0)) {
                                                    r = k;
                                                    break r;
                                                }
                                                r = i[k + 4 >> 2], f = i[r >> 2], i[k + 4 >> 2] = f, A = k, f && (i[f + 8 >> 2] = k, e = i[k + 8 >> 2], A = i[e >> 2]), i[r + 8 >> 2] = e, i[(((A | 0) != (k | 0)) << 2) + e >> 2] = r, i[r >> 2] = k, i[k + 8 >> 2] = r, e = i[r + 8 >> 2], f = i[e >> 2];
                                            }
                                            o[r + 12 | 0] = 1, o[e + 12 | 0] = 0, A = i[f + 4 >> 2], i[e >> 2] = A, A && (i[A + 8 >> 2] = e), A = i[e + 8 >> 2], i[f + 8 >> 2] = A, i[A + ((i[A >> 2] != (e | 0)) << 2) >> 2] = f, i[f + 4 >> 2] = e, i[e + 8 >> 2] = f;
                                            return;
                                        }
                                        if (!(!f | l[f + 12 | 0] == 1)) {
                                            f = f + 12 | 0;
                                            break e;
                                        }
                                        f = i[k >> 2];
                                        r: {
                                            if ((f | 0) != (r | 0)) {
                                                f = k;
                                                break r;
                                            }
                                            A = i[f + 4 >> 2], i[k >> 2] = A, A && (i[A + 8 >> 2] = k, e = i[k + 8 >> 2]), i[f + 8 >> 2] = e, i[(((k | 0) != i[e >> 2]) << 2) + e >> 2] = f, i[f + 4 >> 2] = k, i[k + 8 >> 2] = f, e = i[f + 8 >> 2];
                                        }
                                        o[f + 12 | 0] = 1, o[e + 12 | 0] = 0, r = i[e + 4 >> 2], A = i[r >> 2], i[e + 4 >> 2] = A, A && (i[A + 8 >> 2] = e), A = i[e + 8 >> 2], i[r + 8 >> 2] = A, i[A + ((i[A >> 2] != (e | 0)) << 2) >> 2] = r, i[r >> 2] = e, i[e + 8 >> 2] = r;
                                        break i;
                                    }
                                    if (o[k + 12 | 0] = 1, o[e + 12 | 0] = (A | 0) == (e | 0), o[f | 0] = 1, r = e, (A | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function QB(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0;
                            h = m - 32 | 0, m = h, w = i[A >> 2], A = i[w + 48 >> 2], w = i[w + 52 >> 2], w && (i[w + 4 >> 2] = i[w + 4 >> 2] + 1), i[h + 28 >> 2] = 0, i[h + 20 >> 2] = 0, i[h + 24 >> 2] = 0, F4(h, A, r, h + 20 | 0);
                            i: {
                                if (i[h >> 2] | !e || (A = e - 1 | 0, r = i[h + 20 >> 2], A >>> 0 >= i[h + 24 >> 2] - r >> 3 >>> 0) || (r = r + (A << 3) | 0, A = i[r >> 2], !A) || (A = E0(A, 73632, 74928), !A) || (r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), n && (v = n, _ = oi(A, f), i[v >> 2] = _), u && (v = u, _ = (x3(A, f) ^ -1) + f | 0, i[v >> 2] = _), t && (v = t, _ = ti(A, k), i[v >> 2] = _), s && (v = s, _ = (z3(A, k) ^ -1) + k | 0, i[v >> 2] = _), !r) || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (o[h + 19 | 0] < 0 && X(i[h + 8 >> 2]), r = i[h + 20 >> 2], r) {
                                if (A = r, e = i[h + 24 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        f = i[e - 4 >> 2];
                                        i: {
                                            if (!f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break i;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                        }
                                        if (e = e - 8 | 0, (r | 0) == (e | 0)) break;
                                    }
                                    A = i[h + 20 >> 2];
                                }
                                i[h + 24 >> 2] = r, X(A);
                            }
                            i: {
                                if (!w || (A = i[w + 4 >> 2], i[w + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[w >> 2] + 8 >> 2]](w), g(w);
                            }
                            m = h + 32 | 0;
                        }
                        function CB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            k = m - 32 | 0, m = k, n = D(44), i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = 79920, t = n + 12 | 0, i[t >> 2] = 73384, i[n + 16 >> 2] = 0, i[n + 20 >> 2] = 0, i[n + 32 >> 2] = 0, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[n + 40 >> 2] = f, i[n + 36 >> 2] = e, i[n + 12 >> 2] = 73296, f = i[r >> 2], i[k + 8 >> 2] = n, i[k + 4 >> 2] = t, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, t = k + 12 | 0, h = k + 4 | 0, e = m - 32 | 0, m = e, s = D(152), i[s + 4 >> 2] = 0, i[s + 8 >> 2] = 0, i[s >> 2] = 78332, w = f, v = Ye(s + 12 | 0), i[w + 48 >> 2] = v, u = i[f + 52 >> 2], i[f + 52 >> 2] = s;
                            i: {
                                if (!u || (s = i[u + 4 >> 2], i[u + 4 >> 2] = s - 1, s)) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            u = i[f + 48 >> 2], i[u + 136 >> 2] = f - -64, s3(e + 8 | 0, u, h);
                            i: {
                                if (i[e + 8 >> 2]) {
                                    f = i[e + 12 >> 2], i[t >> 2] = i[e + 8 >> 2], i[t + 4 >> 2] = f, f = i[e + 20 >> 2], i[t + 8 >> 2] = i[e + 16 >> 2], i[t + 12 >> 2] = f, i[t + 16 >> 2] = i[e + 24 >> 2];
                                    break i;
                                }
                                if (l3(t, f), o[e + 27 | 0] >= 0) break i;
                                X(i[e + 16 >> 2]);
                            }
                            m = e + 32 | 0, e = i[k + 8 >> 2];
                            i: {
                                if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            j0(A, k + 12 | 0, i[r >> 2]), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = k + 32 | 0;
                        }
                        function VB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = m - 160 | 0, m = f, i[f + 68 >> 2] = 60132, k = i[15036], i[f + 12 >> 2] = k, u = i[k - 12 >> 2], k = f + 12 | 0, i[u + k >> 2] = i[15037], t = k + i[i[f + 12 >> 2] - 12 >> 2] | 0, n = f + 16 | 0, T0(t, n), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 68 >> 2] = 60132, i[f + 12 >> 2] = 60112, t = z0(n), i[t >> 2] = 58864, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 64 >> 2] = 16, n = f + 148 | 0, G0(n, e), u = k, e = o[f + 159 | 0], k = (e | 0) < 0, U(u, k ? i[f + 148 >> 2] : n, k ? i[f + 152 >> 2] : e), o[f + 159 | 0] < 0 && X(i[f + 148 >> 2]), U(M0(U(f + 12 | 0, 24173, 14), i[r + 12 >> 2] - i[r + 8 >> 2] | 0), 34895, 1), r = i[f + 64 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        r = i[f + 60 >> 2], e = i[f + 40 >> 2], r >>> 0 < e >>> 0 && (i[f + 60 >> 2] = e, r = e), e = f + 36 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    r = i[f + 32 >> 2], e = f + 24 | 0;
                                }
                                e: {
                                    if (k = i[e >> 2], r = r - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            n = (r | 7) + 1 | 0, e = D(n), i[A + 8 >> 2] = n | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0, A = i[15035], i[f + 12 >> 2] = A, i[i[A - 12 >> 2] + (f + 12 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 59 | 0] < 0 && X(i[f + 48 >> 2]), x0(t), N0(f + 68 | 0), m = f + 160 | 0;
                        }
                        function yB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 32 | 0, m = k, A = i[A >> 2], u = i[A + 48 >> 2], n = i[A + 52 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), i[k + 28 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, F4(k, u, r, k + 20 | 0);
                            i: {
                                if (i[k >> 2] || (A = i[k + 20 >> 2], u = i[k + 24 >> 2], (A | 0) == (u | 0))) break i;
                                if (r = !e, h = r, r) {
                                    for(;;)if (r = i[i[A >> 2] + 16 >> 2], !((r | 0) == 1668047216 | (r | 0) == 1769107316) & (r | 0) != 1768778098 || (t = t + h | 0), A = A + 8 | 0, (u | 0) == (A | 0)) break i;
                                }
                                for(r = 1;;){
                                    s = i[i[A >> 2] + 16 >> 2];
                                    e: {
                                        if (!((s | 0) == 1668047216 | (s | 0) == 1769107316) & (s | 0) != 1768778098) break e;
                                        if ((f | 0) > (t | 0)) {
                                            i[(t << 2) + e >> 2] = r, t = t + 1 | 0;
                                            break e;
                                        }
                                        t = t + h | 0;
                                    }
                                    if (r = r + 1 | 0, A = A + 8 | 0, (u | 0) == (A | 0)) break;
                                }
                            }
                            if (o[k + 19 | 0] < 0 && X(i[k + 8 >> 2]), e = i[k + 20 >> 2], e) {
                                if (A = i[k + 24 >> 2], r = e, (A | 0) != (r | 0)) {
                                    for(;;){
                                        r = i[A - 4 >> 2];
                                        i: {
                                            if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (A = A - 8 | 0, (e | 0) == (A | 0)) break;
                                    }
                                    r = i[k + 20 >> 2];
                                }
                                i[k + 24 >> 2] = e, X(r);
                            }
                            i: {
                                if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            return m = k + 32 | 0, t | 0;
                        }
                        function _6(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                k: {
                                                    n: {
                                                        t: {
                                                            o: {
                                                                s: {
                                                                    u: {
                                                                        if (r) {
                                                                            if (!e) break u;
                                                                            if (!f) break s;
                                                                            if (k = e1(f) - e1(r) | 0, k >>> 0 <= 31) break o;
                                                                            break r;
                                                                        }
                                                                        if ((f | 0) == 1 | f >>> 0 > 1) break r;
                                                                        w0 = 0, A = (A >>> 0) / (e >>> 0) | 0;
                                                                        break i;
                                                                    }
                                                                    if (!A) break t;
                                                                    if (!f | f - 1 & f) break n;
                                                                    A = r >>> Oi(f) | 0, w0 = 0;
                                                                    break i;
                                                                }
                                                                if (!(e - 1 & e)) break k;
                                                                u = (e1(e) + 33 | 0) - e1(r) | 0, t = 0 - u | 0;
                                                                break A;
                                                            }
                                                            u = k + 1 | 0, t = 63 - k | 0;
                                                            break A;
                                                        }
                                                        w0 = 0, A = (r >>> 0) / (f >>> 0) | 0;
                                                        break i;
                                                    }
                                                    if (k = e1(f) - e1(r) | 0, k >>> 0 < 31) break f;
                                                    break r;
                                                }
                                                if ((e | 0) == 1) break e;
                                                f = Oi(e), e = f & 31, (f & 63) >>> 0 >= 32 ? A = r >>> e | 0 : (k = r >>> e | 0, A = ((1 << e) - 1 & r) << 32 - e | A >>> e), w0 = k;
                                                break i;
                                            }
                                            u = k + 1 | 0, t = 63 - k | 0;
                                        }
                                        if (k = u & 63, n = k & 31, k >>> 0 >= 32 ? (k = 0, s = r >>> n | 0) : (k = r >>> n | 0, s = ((1 << n) - 1 & r) << 32 - n | A >>> n), t = t & 63, n = t & 31, t >>> 0 >= 32 ? (r = A << n, A = 0) : (r = (1 << n) - 1 & A >>> 32 - n | r << n, A = A << n), u) for(n = f - 1 | 0, t = e - 1 | 0, _ = (t | 0) != -1 ? n + 1 | 0 : n; h = k << 1 | s >>> 31, k = s << 1 | r >>> 31, n = _ - (h + (k >>> 0 > t >>> 0) | 0) >> 31, w = e & n, s = k - w | 0, k = h - ((f & n) + (k >>> 0 < w >>> 0) | 0) | 0, r = r << 1 | A >>> 31, A = v | A << 1, v = n & 1, u = u - 1 | 0, !!u;);
                                        w0 = r << 1 | A >>> 31, A = v | A << 1;
                                        break i;
                                    }
                                    A = 0, r = 0;
                                }
                                w0 = r;
                            }
                            return A;
                        }
                        function IB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            r = m - 32 | 0, m = r;
                            i: {
                                if (i[e + 12 >> 2] <= 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(i[e >> 2] == 1 & i[e + 4 >> 2] == 3)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (n = I[f + 24 >> 1], !(n >>> 0 > 14 | !(1 << n & 18688))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, n = i[f + 4 >> 2], !((n | 0) == 3 | (l[k + 12 | 0] ? i[k + 4 >> 2] != 1 : 0))) {
                                    i[r + 8 >> 2] = n, i[r + 4 >> 2] = 0, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, i[r + 24 >> 2] = i[f + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                                    break i;
                                }
                                i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, i[r + 24 >> 2] = i[f + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function FB(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = i[A + 16 >> 2], n = i[k + 18588 >> 2], t = i[n + 124 >> 2], u = i[t + 16892 >> 2], i[A + 4 >> 2] = 1, i[n + 324 >> 2] = i[n + 324 >> 2] - 1, i[n + 328 >> 2] = i[n + 328 >> 2] + 1, f = i[k + 18588 >> 2], e = i[f + 124 >> 2], r = i[e + 16908 >> 2], s = i[k + 4 >> 2];
                            i: {
                                if ((r | 0) > (s | 0)) {
                                    r = i[i[i[f + 132 >> 2] + 8460 >> 2] + (s << 2) >> 2], f = i[e + 16892 >> 2], e = (r | 0) / (f | 0) | 0, f = r - Z(e, f) | 0;
                                    break i;
                                }
                                f = i[e + 16892 >> 2], e = (r | 0) / (f | 0) | 0, f = r - Z(e, f) | 0;
                            }
                            i[k + 12 >> 2] = e, i[k + 8 >> 2] = f, i[k >> 2] = r, e = (r | 0) / (u | 0) | 0;
                            i: {
                                e: {
                                    if (l[A + 8 | 0] != 1 || N3(k)) break e;
                                    if ((u | 0) <= 0) break i;
                                    for(r = 0, e = Z(Z(e, u), 76); t = (e + i[n + 320 >> 2] | 0) + Z(r, 76) | 0, i[t >> 2] <= 0 && (i[t >> 2] = 1), r = r + 1 | 0, (u | 0) != (r | 0););
                                    break i;
                                }
                                if (Fi(k + 18548 | 0), he(k, 1, !(l[A + 8 | 0] != 1 || l[i[k + 18592 >> 2] + 20 | 0])), (e | 0) != i[k + 12 >> 2] || (r = i[k + 8 >> 2], f = i[t + 16892 >> 2], (r | 0) >= (f | 0))) break i;
                                for(u = Z(Z(e, u), 76); i[t + 16892 >> 2] <= (r | 0) | (e | 0) >= i[t + 16900 >> 2] || (s = (u + i[n + 320 >> 2] | 0) + Z(r, 76) | 0, i[s >> 2] <= 0 && (i[s >> 2] = 1)), r = r + 1 | 0, (f | 0) != (r | 0););
                            }
                            i[A + 4 >> 2] = 3, A = i[k + 18600 >> 2], i[A + 44 >> 2] = i[A + 44 >> 2] + 1, ur(n);
                        }
                        function x5(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 112 | 0, m = k;
                            i: {
                                if (!f) {
                                    r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                    break i;
                                }
                                e: {
                                    if (n = i[r + 16 >> 2], !n || (u = E0(n, 78492, 79120), !u)) break e;
                                    if (n = i[r + 20 >> 2], n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), t = i[r >> 2], i[k + 56 >> 2] = i[t + 48 >> 2], t = i[t + 52 >> 2], i[k + 60 >> 2] = t, t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), r = i[r + 8 >> 2], t = i[r + 8 >> 2], r = i[r + 4 >> 2], s = i[k + 60 >> 2], i[k + 16 >> 2] = i[k + 56 >> 2], i[k + 20 >> 2] = s, ve(k - -64 | 0, k + 16 | 0, e, r, t), e = i[u + 8 >> 2], (i[u + 12 >> 2] - e | 0) > 0) for(r = 0; e = (r << 3) + e | 0, n0[k + 24 >> 3] = i[e >> 2], n0[k + 32 >> 3] = i[e + 4 >> 2], e = i[k + 36 >> 2], i[k + 8 >> 2] = i[k + 32 >> 2], i[k + 12 >> 2] = e, e = i[k + 28 >> 2], i[k >> 2] = i[k + 24 >> 2], i[k + 4 >> 2] = e, tr(k + 40 | 0, k - -64 | 0, k), e = (r << 4) + f | 0, n0[e >> 3] = n0[k + 40 >> 3], n0[e + 8 >> 3] = n0[k + 48 >> 3], r = r + 1 | 0, e = i[u + 8 >> 2], (r | 0) < i[u + 12 >> 2] - e >> 3;);
                                    if (r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], !n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                    break i;
                                }
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                            }
                            m = k + 112 | 0;
                        }
                        function z5(A, r, e) {
                            var f = J(0), k = J(0), n = J(0), t = J(0), u = J(0), s = J(0), h = J(0), w = J(0), v = J(0), _ = J(0), B = J(0), G = J(0), W = J(0), C = J(0), V = J(0);
                            i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if ((r & 65534) == 12) {
                                        if (r = e - 1 & 65535, r >>> 0 <= 21 && (r = r << 2, u = W0[r + 39872 >> 2], v = W0[r + 39784 >> 2], k = W0[r + 39696 >> 2], s = W0[r + 39608 >> 2], n = W0[r + 39520 >> 2], h = W0[r + 39432 >> 2], t = W0[r + 39344 >> 2], f = W0[r + 39256 >> 2]), w = J(J(1) - J(f + t)), _ = J(J(1) - J(s + k)), W = J(J(k * w) - J(_ * t)), B = J(J(1) - J(h + n)), C = J(J(t * B) - J(w * n)), G = J(u * J(J(h * W) + J(J(s * C) + J(f * J(J(n * _) - J(B * k)))))), G == J(0)) break i;
                                        V = J(J(1) - J(v + u)), W0[A >> 2] = J(k * J(J(V * J(J(f * n) - J(t * h))) + J(J(v * C) + J(u * J(J(h * w) - J(B * f)))))) / G, f = J(J(n * J(J(V * J(J(s * t) - J(k * f))) + J(J(v * W) + J(u * J(J(f * _) - J(w * s)))))) / G);
                                        break e;
                                    }
                                    r: switch(r - 1 | 0){
                                        case 0:
                                            i[A >> 2] = 1046066128, f = J(.0722000002861023);
                                            break e;
                                        case 3:
                                            i[A >> 2] = 1050253722, f = J(.10999999940395355);
                                            break e;
                                        case 4:
                                        case 5:
                                            i[A >> 2] = 1050220167, f = J(.11400000005960464);
                                            break e;
                                        case 6:
                                            i[A >> 2] = 1046025863, f = J(.08699999749660492);
                                            break e;
                                        case 8:
                                        case 9:
                                            break r;
                                        default:
                                            break i;
                                    }
                                    i[A >> 2] = 1049002141, f = J(.059300001710653305);
                                }
                                W0[A + 4 >> 2] = f;
                            }
                        }
                        function T5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            i: {
                                if (e = i[A >> 2], k = i[A + 4 >> 2] - e >> 4, f = k + 1 | 0, f >>> 0 < 268435456) {
                                    if (e = i[A + 8 >> 2] - e | 0, u = e >> 3, e = e >>> 0 >= 2147483632 ? 268435455 : f >>> 0 < u >>> 0 ? u : f, e) {
                                        if (e >>> 0 >= 268435456) break i;
                                        n = D(e << 4);
                                    }
                                    u = I[r >> 1], f = (k << 4) + n | 0, i[f + 12 >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, Q[f >> 1] = u, k = i[r + 4 >> 2], r = i[r + 8 >> 2], eA(f + 4 | 0, k, r, (r - k | 0) / 12 | 0), s = (e << 4) + n | 0, u = f + 16 | 0, e = i[A + 4 >> 2], k = i[A >> 2];
                                    e: {
                                        if ((e | 0) == (k | 0)) {
                                            n = f;
                                            break e;
                                        }
                                        for(; r = e - 16 | 0, h = I[r >> 1], w = f - 4 | 0, i[w >> 2] = 0, t = f - 12 | 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, n = f - 16 | 0, Q[n >> 1] = h, h = t, t = e - 12 | 0, i[h >> 2] = i[t >> 2], i[f - 8 >> 2] = i[e - 8 >> 2], f = e - 4 | 0, i[w >> 2] = i[f >> 2], i[f >> 2] = 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, f = n, e = r, (k | 0) != (e | 0););
                                        e = i[A + 4 >> 2], k = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = u, i[A >> 2] = n, i[A + 8 >> 2] = s, (e | 0) != (k | 0)) for(;;){
                                        if (t = e - 12 | 0, A = i[t >> 2], A) {
                                            if (s = e - 8 | 0, f = i[s >> 2], r = A, (f | 0) != (A | 0)) {
                                                for(; r = f - 12 | 0, n = i[r >> 2], n && (i[f - 8 >> 2] = n, X(n)), f = r, (A | 0) != (f | 0););
                                                r = i[t >> 2];
                                            }
                                            i[s >> 2] = A, X(r);
                                        }
                                        if (e = e - 16 | 0, (k | 0) == (e | 0)) break;
                                    }
                                    return k && X(k), u;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function wi(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            i[A + 24 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = e, i[A + 4 >> 2] = e, i[A >> 2] = r, s = -64;
                            i: {
                                if (!e || (i[A >> 2] = r + 1, f = l[r | 0], k = e - 1 | 0, i[A + 8 >> 2] = k, f = f << 24, n = f, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = f, !k) || (i[A >> 2] = r + 2, f = l[r + 1 | 0], k = e - 2 | 0, i[A + 8 >> 2] = k, f = n | f << 16, t = f, i[A + 16 >> 2] = u, i[A + 20 >> 2] = f, !k) || (i[A >> 2] = r + 3, f = l[r + 2 | 0], k = e - 3 | 0, i[A + 8 >> 2] = k, f = t | f << 8, t = f, i[A + 16 >> 2] = u, i[A + 20 >> 2] = f, !k) || (i[A >> 2] = r + 4, f = l[r + 3 | 0], k = e - 4 | 0, i[A + 8 >> 2] = k, n = u, f = f | t, u = f, i[A + 16 >> 2] = n, i[A + 20 >> 2] = f, !k) || (i[A >> 2] = r + 5, f = l[r + 4 | 0], k = e - 5 | 0, i[A + 8 >> 2] = k, t = n, n = f >>> 8 | 0, f = t | f << 24, n = n | u, u = n, i[A + 16 >> 2] = f, i[A + 20 >> 2] = n, !k) || (i[A >> 2] = r + 6, n = l[r + 5 | 0], k = e - 6 | 0, i[A + 8 >> 2] = k, t = f, f = n >>> 16 | 0, n = t | n << 16, f = f | u, u = f, i[A + 16 >> 2] = n, i[A + 20 >> 2] = f, !k) || (i[A >> 2] = r + 7, f = l[r + 6 | 0], k = e - 7 | 0, i[A + 8 >> 2] = k, t = n, n = f >>> 24 | 0, f = t | f << 8, i[A + 16 >> 2] = f, n = n | u, i[A + 20 >> 2] = n, !k)) break i;
                                i[A >> 2] = r + 8, r = l[r + 7 | 0], i[A + 8 >> 2] = e - 8, i[A + 16 >> 2] = r | f, i[A + 20 >> 2] = n, s = -56;
                            }
                            return i[A + 24 >> 2] = (((e >>> 0 >= 7 ? 7 : e) << 3) + s | 0) - -64, A;
                        }
                        function YB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0, E = 0, R = 0, M = 0, H = 0, T = 0, S = 0, P = 0, $ = 0, c = 0, r0 = 0, f0 = 0;
                            f = Z(e, 6) + r | 0, _ = I[f + 6 >> 1], s = I[r + 6 >> 1], h = I[r + 2 >> 1], k = s + h | 0, B = I[r + 4 >> 1], w = I[r >> 1], t = B + w | 0, u = k + t | 0, n = (e << 2) + r | 0, G = I[n + 6 >> 1], W = I[n + 2 >> 1], C = G + W | 0, y = I[n >> 1], n = I[n + 4 >> 1], V = y + n | 0, v = C + V | 0, F = u - v | 0, r = (e << 1) + r | 0, e = I[r + 6 >> 1], E = I[r + 2 >> 1], R = e + E | 0, M = I[r + 4 >> 1], r = I[r >> 1], H = M + r | 0, T = R + H | 0, S = I[f + 2 >> 1], P = _ + S | 0, $ = I[f + 4 >> 1], f = I[f >> 1], c = $ + f | 0, r0 = P + c | 0, f0 = T - r0 | 0, Q[A + 24 >> 1] = F - f0, Q[A + 16 >> 1] = F + f0, u = u + v | 0, v = T + r0 | 0, Q[A + 8 >> 1] = u - v, Q[A >> 1] = u + v, k = t - k | 0, t = V - C | 0, u = k - t | 0, C = H - R | 0, V = c - P | 0, v = C - V | 0, Q[A + 26 >> 1] = u - v, Q[A + 18 >> 1] = u + v, k = k + t | 0, t = C + V | 0, Q[A + 10 >> 1] = k - t, Q[A + 2 >> 1] = k + t, s = h - s | 0, h = w - B | 0, k = s + h | 0, B = W - G | 0, n = y - n | 0, w = B + n | 0, t = k - w | 0, e = E - e | 0, r = r - M | 0, u = e + r | 0, _ = S - _ | 0, f = f - $ | 0, G = _ + f | 0, W = u - G | 0, Q[A + 28 >> 1] = t - W, Q[A + 20 >> 1] = t + W, k = k + w | 0, w = u + G | 0, Q[A + 12 >> 1] = k - w, Q[A + 4 >> 1] = k + w, s = h - s | 0, n = n - B | 0, h = s - n | 0, r = r - e | 0, e = f - _ | 0, f = r - e | 0, Q[A + 30 >> 1] = h - f, Q[A + 22 >> 1] = f + h, f = n + s | 0, r = r + e | 0, Q[A + 14 >> 1] = f - r, Q[A + 6 >> 1] = r + f;
                        }
                        function EB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                e: {
                                    if ((E2(e) | 0) != 4) {
                                        r = i[19872], i[A >> 2] = i[19871], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19873];
                                        break e;
                                    }
                                    if (t = l[e | 0] | l[e + 1 | 0] << 8 | (l[e + 2 | 0] << 16 | l[e + 3 | 0] << 24), i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, G8(n + 4 | 0, 0, f, f + k | 0, k), e = D(32), i[e + 28 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 16 >> 2] = t << 24 | (t & 65280) << 8 | (t >>> 8 & 65280 | t >>> 24), i[e + 12 >> 2] = 78628, i[e >> 2] = 78780, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, f = i[n + 8 >> 2], k = i[n + 4 >> 2], (f | 0) != (k | 0)) {
                                        if (f = f - k | 0, (f | 0) < 0) break i;
                                        t = D(f), i[e + 20 >> 2] = t, u = f + t | 0, i[e + 28 >> 2] = u, v0(t, k, f), i[e + 24 >> 2] = u;
                                    }
                                    f = i[r >> 2], i[e + 4 >> 2] = i[e + 4 >> 2] + 2, i[f + 52 >> 2] = e + 12, r = i[f + 56 >> 2], i[f + 56 >> 2] = e;
                                    r: {
                                        if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    if (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r || (p[i[i[e >> 2] + 8 >> 2]](e), g(e)), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A || (p[i[i[e >> 2] + 8 >> 2]](e), g(e)), A = i[n + 4 >> 2], !A) break e;
                                    i[n + 8 >> 2] = A, X(A);
                                }
                                m = n + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function gB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 32 | 0, m = k, r = i[r >> 2], n = i[r + 48 >> 2], r = i[r + 52 >> 2];
                            i: {
                                if (!r) {
                                    q1(k + 24 | 0, n, e);
                                    break i;
                                }
                                if (i[r + 4 >> 2] = i[r + 4 >> 2] + 1, q1(k + 24 | 0, n, e), e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i: {
                                n = i[k + 24 >> 2];
                                e: {
                                    if (!n) {
                                        i[A >> 2] = 1, i[A + 4 >> 2] = 2e3, i[A + 8 >> 2] = 3156;
                                        break e;
                                    }
                                    if (r = E2(f), r >>> 0 >= 2147483640) break i;
                                    r: {
                                        A: {
                                            if (r >>> 0 >= 11) {
                                                t = (r | 7) + 1 | 0, e = D(t), i[k + 20 >> 2] = t | -2147483648, i[k + 12 >> 2] = e, i[k + 16 >> 2] = r;
                                                break A;
                                            }
                                            if (o[k + 23 | 0] = r, e = k + 12 | 0, !r) break r;
                                        }
                                        v0(e, f, r);
                                    }
                                    o[r + e | 0] = 0, r = n + 116 | 0;
                                    r: {
                                        if ((r | 0) == (k + 12 | 0)) break r;
                                        if (e = o[k + 23 | 0], o[n + 127 | 0] >= 0) {
                                            if ((e | 0) >= 0) {
                                                e = i[k + 16 >> 2], i[r >> 2] = i[k + 12 >> 2], i[r + 4 >> 2] = e, i[r + 8 >> 2] = i[k + 20 >> 2];
                                                break r;
                                            }
                                            X4(r, i[k + 12 >> 2], i[k + 16 >> 2]);
                                            break r;
                                        }
                                        f = r, r = (e | 0) < 0, Y4(f, r ? i[k + 12 >> 2] : k + 12 | 0, r ? i[k + 16 >> 2] : e);
                                    }
                                    o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                A = i[k + 28 >> 2];
                                e: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                m = k + 32 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function S5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                if (e = i[A >> 2], n = i[A + 4 >> 2] - e >> 4, f = n + 1 | 0, f >>> 0 < 268435456) {
                                    if (e = i[A + 8 >> 2] - e | 0, u = e >> 3, e = e >>> 0 >= 2147483632 ? 268435455 : f >>> 0 < u >>> 0 ? u : f, e) {
                                        if (e >>> 0 >= 268435456) break i;
                                        k = D(e << 4);
                                    }
                                    f = (n << 4) + k | 0, Q[f >> 1] = I[r >> 1], i[f + 4 >> 2] = i[r + 4 >> 2], i[f + 8 >> 2] = i[r + 8 >> 2], i[f + 12 >> 2] = i[r + 12 >> 2], i[r + 12 >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, s = (e << 4) + k | 0, u = f + 16 | 0, e = i[A + 4 >> 2], n = i[A >> 2];
                                    e: {
                                        if ((e | 0) == (n | 0)) {
                                            k = f;
                                            break e;
                                        }
                                        for(; r = e - 16 | 0, t = I[r >> 1], h = f - 4 | 0, i[h >> 2] = 0, k = f - 16 | 0, Q[k >> 1] = t, t = e - 12 | 0, i[f - 12 >> 2] = i[t >> 2], i[f - 8 >> 2] = i[e - 8 >> 2], f = e - 4 | 0, i[h >> 2] = i[f >> 2], i[f >> 2] = 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0, f = k, e = r, (n | 0) != (e | 0););
                                        e = i[A + 4 >> 2], n = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = u, i[A >> 2] = k, i[A + 8 >> 2] = s, (e | 0) != (n | 0)) for(;;){
                                        if (t = e - 12 | 0, A = i[t >> 2], A) {
                                            if (s = e - 8 | 0, f = i[s >> 2], r = A, (f | 0) != (A | 0)) {
                                                for(; r = f - 12 | 0, k = i[r >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = r, (A | 0) != (f | 0););
                                                r = i[t >> 2];
                                            }
                                            i[s >> 2] = A, X(r);
                                        }
                                        if (e = e - 16 | 0, (n | 0) == (e | 0)) break;
                                    }
                                    return n && X(n), u;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function Ne(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (u = m - 16 | 0, m = u, s = A + 2140 | 0, Y9(s, 1)) {
                                k = (o[i[A + 1384 >> 2] + 13 | 0] << 3) + A | 0, t = i[k + 728 >> 2], n = i[k + 732 >> 2];
                                i: {
                                    if (!n) {
                                        i[u + 12 >> 2] = 0;
                                        break i;
                                    }
                                    i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[u + 12 >> 2] = n, i[n + 4 >> 2] = i[n + 4 >> 2] + 1;
                                }
                                if (i[u + 8 >> 2] = t, k = i[u + 12 >> 2], i[u >> 2] = i[u + 8 >> 2], i[u + 4 >> 2] = k, k = 0, s = Q5(s, u, A, 0, 0, 0, 0), (s | 0) >= 0) {
                                    if (t = i[A + 2152 >> 2], A = i[A + 2148 >> 2], s >>> 0 < t - A >> 2 >>> 0 && (k = i[A + (s << 2) >> 2]), A = 1 << i[r + 16840 >> 2] - 1, t = 1 << i[r + 16832 >> 2] - 1, (t | 0) >= 0 && B0(i[k + 4 >> 2], t, Z(i[k + 28 >> 2], i[k + 40 >> 2])), (A | 0) >= 0 && B0(i[k + 8 >> 2], A, Z(i[k + 36 >> 2], i[k + 44 >> 2])), (A | 0) >= 0 && B0(i[k + 12 >> 2], A, Z(i[k + 36 >> 2], i[k + 44 >> 2])), i[k + 164 >> 2] > 0) for(A = 0; t = i[k + 160 >> 2] + Z(A, 3) | 0, h = (l[t | 0] | l[t + 1 | 0] << 8) & 64767, o[t | 0] = h, o[t + 1 | 0] = h >>> 8, A = A + 1 | 0, (A | 0) < i[k + 164 >> 2];);
                                    i[k + 96 >> 2] = e, A = i[r + 16868 >> 2], o[k + 104 | 0] = 0, o[k + 312 | 0] = 1, i[k + 100 >> 2] = f ? 2 : 1, i[k + 92 >> 2] = A - 1 & e;
                                }
                                i: {
                                    if (!n || (A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                                }
                                return m = u + 16 | 0, s;
                            }
                            y0(20288, 14908, 1425, 10164), z();
                        }
                        function JB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0;
                            s = m - 16 | 0, m = s, u = D(32), i[u + 28 >> 2] = n, i[u + 24 >> 2] = k, i[u + 20 >> 2] = f, i[u + 16 >> 2] = e, i[u + 12 >> 2] = 79008, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 79268, e = i[r + 8 >> 2], i[s + 12 >> 2] = u, n = u + 12 | 0, i[s + 8 >> 2] = n, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, f = i[e + 16 >> 2];
                            i: {
                                e: {
                                    if (f >>> 0 < k0[e + 20 >> 2]) {
                                        i[f + 4 >> 2] = u, i[f >> 2] = n, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, k = u;
                                        break e;
                                    }
                                    if (f = P2(e + 12 | 0, s + 8 | 0), k = i[s + 12 >> 2], i[e + 16 >> 2] = f, !k) break i;
                                }
                                if (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            i: {
                                if (!t || (i[u + 4 >> 2] = i[u + 4 >> 2] + 1, e = D(24), i[u + 4 >> 2] = i[u + 4 >> 2] + 1, i[e + 20 >> 2] = u, i[e + 16 >> 2] = n, k = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = k, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[t >> 2] = e, r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = s + 16 | 0;
                        }
                        function RB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0;
                            s = m - 16 | 0, m = s, u = D(32), i[u + 28 >> 2] = n, i[u + 24 >> 2] = k, i[u + 20 >> 2] = f, i[u + 16 >> 2] = e, i[u + 12 >> 2] = 79052, i[u + 4 >> 2] = 0, i[u + 8 >> 2] = 0, i[u >> 2] = 79308, e = i[r + 8 >> 2], i[s + 12 >> 2] = u, n = u + 12 | 0, i[s + 8 >> 2] = n, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, f = i[e + 16 >> 2];
                            i: {
                                e: {
                                    if (f >>> 0 < k0[e + 20 >> 2]) {
                                        i[f + 4 >> 2] = u, i[f >> 2] = n, i[u + 4 >> 2] = i[u + 4 >> 2] + 1, i[e + 16 >> 2] = f + 8, k = u;
                                        break e;
                                    }
                                    if (f = P2(e + 12 | 0, s + 8 | 0), k = i[s + 12 >> 2], i[e + 16 >> 2] = f, !k) break i;
                                }
                                if (e = i[k + 4 >> 2], i[k + 4 >> 2] = e - 1, e) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            i: {
                                if (!t || (i[u + 4 >> 2] = i[u + 4 >> 2] + 1, e = D(24), i[u + 4 >> 2] = i[u + 4 >> 2] + 1, i[e + 20 >> 2] = u, i[e + 16 >> 2] = n, k = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = k, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[t >> 2] = e, r = i[u + 4 >> 2], i[u + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[u + 4 >> 2], i[u + 4 >> 2] = A - 1, A || (p[i[i[u >> 2] + 8 >> 2]](u), g(u)), m = s + 16 | 0;
                        }
                        function q4(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if (!((r + f | 0) <= (h | 0) | (r | 0) > (h | 0) | (e | 0) > (w | 0)) && (e + f | 0) > (w | 0)) break f;
                                                if (f = 0, (h | w) < 0 || (r = i[A + 124 >> 2], i[r + 484 >> 2] <= (h | 0) | i[r + 488 >> 2] <= (w | 0)) || (t = i[A + 132 >> 2], u = i[t + 8496 >> 2], e = i[r + 16936 >> 2], s = i[r + 16924 >> 2], i[(u + (h >>> e << 2) | 0) + (Z(s, w >>> e | 0) << 2) >> 2] > i[(u + (k >> e << 2) | 0) + (Z(s, n >> e) << 2) >> 2]) || (s = i[A + 140 >> 2], u = i[A + 152 >> 2], e = i[r + 16876 >> 2], n = n >> e, k = k >> e, v = w >>> e | 0, e = h >>> e | 0, I[(s + Z(Z(u, n), 24) | 0) + Z(k, 24) >> 1] != I[(s + Z(Z(u, v), 24) | 0) + Z(e, 24) >> 1])) break r;
                                                if (u = k << 2, k = i[t + 8484 >> 2], r = i[r + 16892 >> 2], i[(u + k | 0) + (Z(r, n) << 2) >> 2] == i[(k + (e << 2) | 0) + (Z(r, v) << 2) >> 2]) break A;
                                                break r;
                                            }
                                            if (t << 1 != (f | 0) | u << 1 != (f | 0) | ((s | 0) != 1 | (e + u | 0) > (w | 0))) break A;
                                            if (f = 0, (r + t | 0) > (h | 0)) break r;
                                        }
                                        if (e = i[A + 168 >> 2], r = h >> e, (r | 0) < 0 || (f = i[A + 172 >> 2], (f | 0) <= (r | 0))) break e;
                                        if (e = w >> e, (e | 0) < 0 | (e | 0) >= i[A + 176 >> 2]) break i;
                                        f = (l[((i[A + 160 >> 2] + Z(r, 3) | 0) + Z(Z(e, f), 3) | 0) + 1 | 0] & 3) != 0;
                                    }
                                    return f;
                                }
                                y0(4105, 9032, 118, 3731), z();
                            }
                            y0(4067, 9032, 119, 3731), z();
                        }
                        function R3(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                if (!f) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 34896;
                                    break i;
                                }
                                v4(k + 24 | 0, i[r >> 2], e, 1);
                                e: {
                                    r: {
                                        if (n = i[k + 24 >> 2], n) {
                                            if (t = E0(n, 82544, 79952), !t) break r;
                                            if (e = i[k + 28 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), f = k + 4 | 0, p[i[i[t >> 2] + 20 >> 2]](f, t), j0(A, f, i[r >> 2]), o[k + 23 | 0] < 0 && X(i[k + 12 >> 2]), !e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break e;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                            break e;
                                        }
                                        i[f >> 2] = 0, i[A + 8 >> 2] = 34896, i[A >> 2] = 5, i[A + 4 >> 2] = 2e3;
                                        break e;
                                    }
                                    e = D(16), i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[f >> 2] = e, f = i[k + 28 >> 2], i[k + 24 >> 2] = 0, i[k + 28 >> 2] = 0, i[e + 4 >> 2] = f, i[e >> 2] = n, n = i[r >> 2], f = i[r + 4 >> 2];
                                    r: {
                                        if (!f) {
                                            i[e + 12 >> 2] = f, i[e + 8 >> 2] = n;
                                            break r;
                                        }
                                        if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, i[e + 8 >> 2] = n, r = i[e + 12 >> 2], i[e + 12 >> 2] = f, !r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (A = i[k + 28 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = k + 32 | 0;
                        }
                        function N3(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                e = i[A + 18592 >> 2];
                                e: {
                                    r: {
                                        if (l[e + 20 | 0]) {
                                            if (r = i[A + 18588 >> 2], n = i[r + 52 >> 2], k = i[r + 132 >> 2], e = i[e + 24 >> 2], f = I[(i[r + 140 >> 2] + Z(i[(i[k + 8460 >> 2] + (i[i[k + 8448 >> 2] + (e << 2) >> 2] << 2) | 0) - 4 >> 2], 24) | 0) + 2 >> 1], f >>> 0 >= i[r + 56 >> 2] - n >> 2 >>> 0) break e;
                                            if (n = i[n + (f << 2) >> 2], f = i[i[r + 124 >> 2] + 16892 >> 2], r = (e | 0) / (f | 0) | 0, s9(k, e - Z(r, f) | 0, r)) {
                                                if (r = i[A + 18592 >> 2], e = i[r + 804 >> 2], e >>> 0 >= 3) break i;
                                                Ai(A + 18572 | 0, e, i[r + 800 >> 2]), o[A + 18580 | 0] = 0, o[A + 18581 | 0] = 0, o[A + 18582 | 0] = 0, o[A + 18583 | 0] = 0;
                                                break r;
                                            }
                                            if (r = i[A + 18596 >> 2], e = i[r + 424 >> 2], k = i[r + 428 >> 2] - e >> 2, k >>> 0 < 2) break e;
                                            for(f = i[A + 18600 >> 2], r = 1;;){
                                                if (t = e + (r << 2) | 0, (f | 0) != i[t >> 2]) {
                                                    if (r = r + 1 | 0, (k | 0) != (r | 0)) continue;
                                                    break e;
                                                }
                                                break;
                                            }
                                            if (r = i[t - 4 >> 2], !r || (mo(r + 44 | 0, i[r + 120 >> 2]), l[n + 1348 | 0] != 1)) break e;
                                            r = A + 18572 | 0, A = n + 1340 | 0, W6(r, A), x9(A);
                                            break r;
                                        }
                                        if (r = i[e + 804 >> 2], r >>> 0 >= 3) break i;
                                        Ai(A + 18572 | 0, r, i[e + 800 >> 2]), o[A + 18580 | 0] = 0, o[A + 18581 | 0] = 0, o[A + 18582 | 0] = 0, o[A + 18583 | 0] = 0;
                                    }
                                    u = 1;
                                }
                                return u;
                            }
                            y0(18036, 15050, 1520, 4390), z();
                        }
                        function De(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = i[e + 4 >> 2], u = i[r + 4 >> 2];
                            i: {
                                if ((u | 0) <= i[A + 4 >> 2]) {
                                    if ((k | 0) <= (u | 0) || (n = i[r >> 2], k = i[r + 4 >> 2], t = i[e + 4 >> 2], i[r >> 2] = i[e >> 2], i[r + 4 >> 2] = t, i[e >> 2] = n, i[e + 4 >> 2] = k, i[r + 4 >> 2] <= i[A + 4 >> 2])) break i;
                                    n = i[A >> 2], k = i[A + 4 >> 2], t = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = t, i[r >> 2] = n, i[r + 4 >> 2] = k, k = i[e + 4 >> 2];
                                    break i;
                                }
                                if (t = i[A >> 2], n = i[A + 4 >> 2], (k | 0) > (u | 0)) {
                                    k = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = k, i[e >> 2] = t, i[e + 4 >> 2] = n, k = n;
                                    break i;
                                }
                                if (k = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = k, i[r >> 2] = t, i[r + 4 >> 2] = n, k = i[e + 4 >> 2], (n | 0) >= (k | 0)) break i;
                                k = i[e + 4 >> 2], i[r >> 2] = i[e >> 2], i[r + 4 >> 2] = k, i[e >> 2] = t, i[e + 4 >> 2] = n, k = n;
                            }
                            i: {
                                if (i[f + 4 >> 2] <= (k | 0) || (n = i[e >> 2], k = i[e + 4 >> 2], t = i[f + 4 >> 2], i[e >> 2] = i[f >> 2], i[e + 4 >> 2] = t, i[f >> 2] = n, i[f + 4 >> 2] = k, i[e + 4 >> 2] <= i[r + 4 >> 2]) || (f = i[r >> 2], n = i[r + 4 >> 2], k = i[e + 4 >> 2], i[r >> 2] = i[e >> 2], i[r + 4 >> 2] = k, i[e >> 2] = f, i[e + 4 >> 2] = n, i[r + 4 >> 2] <= i[A + 4 >> 2])) break i;
                                e = i[A >> 2], f = i[A + 4 >> 2], n = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = n, i[r >> 2] = e, i[r + 4 >> 2] = f;
                            }
                        }
                        function NB(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            t = m - 32 | 0, m = t;
                            i: {
                                e: {
                                    if (e && (E2(e) | 0) == 4) break e;
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2006, i[A + 8 >> 2] = 19999;
                                    break i;
                                }
                                u = i[r >> 2], h = i[u + 48 >> 2], u = i[u + 52 >> 2], u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), s = l[e | 0] | l[e + 1 | 0] << 8 | (l[e + 2 | 0] << 16 | l[e + 3 | 0] << 24), e = m - 32 | 0, m = e, i[t + 8 >> 2] = 0, i[t + 12 >> 2] = 0, i[t + 16 >> 2] = 0, i[t + 28 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, w = e + 24 | 0, m8(w, h, s << 24 | (s & 65280) << 8 | (s >>> 8 & 65280 | s >>> 24)), s = i[e + 24 >> 2], o[s + 164 | 0] = 1, i[s + 100 >> 2] = i[s + 100 >> 2] & -2 | 1, i[t + 8 >> 2] = i[s + 104 >> 2], P3(e + 4 | 0, h, w, f, k, 0), o[e + 23 | 0] < 0 && X(i[e + 12 >> 2]), f = i[e + 28 >> 2];
                                e: {
                                    if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break e;
                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                }
                                m = e + 32 | 0;
                                e: {
                                    if (!u || (e = i[u + 4 >> 2], i[u + 4 >> 2] = e - 1, e)) break e;
                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                }
                                e: {
                                    if (!(i[t + 12 >> 2] | !n)) {
                                        i[n >> 2] = i[t + 8 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                        break e;
                                    }
                                    j0(A, t + 12 | 0, i[r >> 2]);
                                }
                                if (o[t + 31 | 0] >= 0) break i;
                                X(i[t + 20 >> 2]);
                            }
                            m = t + 32 | 0;
                        }
                        function j5(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, A = m - 16 | 0, m = A, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, i[A + 12 >> 2] = e, i[A + 8 >> 2] = n, r = i[A + 12 >> 2];
                            i: {
                                for(;;){
                                    if (r >>> 0 >= f >>> 0) {
                                        e = 0;
                                        break i;
                                    }
                                    if (e = 2, r = i[r >> 2], r >>> 0 > 1114111 | (r & -2048) == 55296) break i;
                                    e: {
                                        r: {
                                            if (r >>> 0 <= 127) {
                                                if (e = 1, n = i[A + 8 >> 2], (t - n | 0) <= 0) break i;
                                                i[A + 8 >> 2] = n + 1, o[n | 0] = r;
                                                break r;
                                            }
                                            if (r >>> 0 <= 2047) {
                                                if (e = i[A + 8 >> 2], (t - e | 0) < 2) break e;
                                                i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 | 192, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                                break r;
                                            }
                                            if (e = i[A + 8 >> 2], n = t - e | 0, r >>> 0 <= 65535) {
                                                if ((n | 0) < 3) break e;
                                                i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 12 | 224, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 & 63 | 128, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                                break r;
                                            }
                                            if ((n | 0) < 4) break e;
                                            i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 18 | 240, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 12 & 63 | 128, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r >>> 6 & 63 | 128, e = i[A + 8 >> 2], i[A + 8 >> 2] = e + 1, o[e | 0] = r & 63 | 128;
                                        }
                                        r = i[A + 12 >> 2] + 4 | 0, i[A + 12 >> 2] = r;
                                        continue;
                                    }
                                    break;
                                }
                                e = 1;
                            }
                            return i[k >> 2] = i[A + 12 >> 2], i[u >> 2] = i[A + 8 >> 2], m = A + 16 | 0, e | 0;
                        }
                        function D2(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 160 | 0, m = f, i[f + 80 >> 2] = 60132, n = i[15036], i[f + 24 >> 2] = n, k = i[n - 12 >> 2], n = f + 24 | 0, i[k + n >> 2] = i[15037], t = n + i[i[f + 24 >> 2] - 12 >> 2] | 0, k = f + 28 | 0, T0(t, k), i[t + 72 >> 2] = 0, i[t + 76 >> 2] = -1, i[f + 80 >> 2] = 60132, i[f + 24 >> 2] = 60112, t = z0(k), i[t >> 2] = 58864, i[f + 68 >> 2] = 0, i[f + 72 >> 2] = 0, i[f + 60 >> 2] = 0, i[f + 64 >> 2] = 0, i[f + 76 >> 2] = 16, k = f + 12 | 0, Ee(k, r, e), r = o[f + 23 | 0], e = (r | 0) < 0, U(n, e ? i[f + 12 >> 2] : k, e ? i[f + 16 >> 2] : r), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), r = i[f + 76 >> 2];
                            i: {
                                e: {
                                    if (r & 16) {
                                        e = i[f + 72 >> 2], r = i[f + 52 >> 2], e >>> 0 < r >>> 0 && (i[f + 72 >> 2] = r, e = r), r = f + 48 | 0;
                                        break e;
                                    }
                                    if (!(r & 8)) {
                                        e = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    e = i[f + 44 >> 2], r = f + 36 | 0;
                                }
                                e: {
                                    if (n = i[r >> 2], e = e - n | 0, e >>> 0 < 2147483640) {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, e) break e;
                                        e = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, n, e);
                            }
                            o[A + e | 0] = 0, A = i[15035], i[f + 24 >> 2] = A, i[i[A - 12 >> 2] + (f + 24 | 0) >> 2] = i[15038], i[t >> 2] = 58864, o[f + 71 | 0] < 0 && X(i[f + 60 >> 2]), x0(t), N0(f + 80 | 0), m = f + 160 | 0;
                        }
                        function DB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, n = D(24), i[n + 20 >> 2] = f, i[n + 16 >> 2] = e, i[n + 12 >> 2] = 78964, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = 79228, f = i[r + 8 >> 2], i[t + 12 >> 2] = n, u = n + 12 | 0, i[t + 8 >> 2] = u, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = i[f + 16 >> 2];
                            i: {
                                e: {
                                    if (e >>> 0 < k0[f + 20 >> 2]) {
                                        i[e + 4 >> 2] = n, i[e >> 2] = u, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[f + 16 >> 2] = e + 8, e = n;
                                        break e;
                                    }
                                    if (s = P2(f + 12 | 0, t + 8 | 0), e = i[t + 12 >> 2], i[f + 16 >> 2] = s, !e) break i;
                                }
                                if (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            i: {
                                if (!k || (i[n + 4 >> 2] = i[n + 4 >> 2] + 1, e = D(24), i[n + 4 >> 2] = i[n + 4 >> 2] + 1, i[e + 20 >> 2] = n, i[e + 16 >> 2] = u, u = i[r + 8 >> 2], f = i[r + 12 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[e + 12 >> 2] = f, i[e + 8 >> 2] = u, f = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 4 >> 2] = r, i[e >> 2] = f, i[k >> 2] = e, r = i[n + 4 >> 2], i[n + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[n + 4 >> 2], i[n + 4 >> 2] = A - 1, A || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = t + 16 | 0;
                        }
                        function MB() {
                            var A = 0, r = 0, e = 0, f = 0;
                            i: {
                                e: {
                                    r: switch(A = i[21684], A | 0){
                                        case 0:
                                            break i;
                                        case 1:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    if (A = i[21678], (A | 0) != 86716) for(;;){
                                        r = i[i[A + 16 >> 2] + 12 >> 2], r && p[r | 0](), r = i[A + 4 >> 2];
                                        r: {
                                            if (r) {
                                                for(;;)if (A = r, r = i[A >> 2], !r) break r;
                                            }
                                            for(; r = A, A = i[A + 8 >> 2], (r | 0) != i[A >> 2];);
                                        }
                                        if ((A | 0) == 86716) break;
                                    }
                                    if (Br(86712, i[21679]), i[21678] = 86716, i[21679] = 0, i[21680] = 0, A = i[21681], (A | 0) != 86728) for(;;){
                                        r = i[i[i[A + 16 >> 2] >> 2] + 32 >> 2], r && p[r | 0](), r = i[A + 4 >> 2];
                                        r: {
                                            if (r) {
                                                for(;;)if (A = r, r = i[A >> 2], !r) break r;
                                            }
                                            for(; r = A, A = i[A + 8 >> 2], (r | 0) != i[A >> 2];);
                                        }
                                        if ((A | 0) == 86728) break;
                                    }
                                    if (hr(86724, i[21682]), i[21681] = 86728, i[21682] = 0, i[21683] = 0, o[86740] = 1, r = i[21713], f = i[21712], (r | 0) != (f | 0)) for(;;){
                                        e = i[r - 4 >> 2];
                                        r: {
                                            if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break r;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (r = r - 8 | 0, (f | 0) == (r | 0)) break;
                                    }
                                    i[21713] = f, A = i[21684];
                                }
                                i[21684] = A - 1;
                            }
                        }
                        function E0(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            t = m - 16 | 0, m = t, k = i[A >> 2], n = i[k - 8 >> 2], i[t + 12 >> 2] = n, i[t + 4 >> 2] = A + n, i[t + 8 >> 2] = i[k - 4 >> 2], n = i[t + 8 >> 2], k = Y1(n, e, 0), u = i[t + 4 >> 2];
                            i: {
                                if (k) {
                                    A = m + -64 | 0, m = A, m = A - -64 | 0, f = i[t + 12 >> 2] ? 0 : u;
                                    break i;
                                }
                                if (k = m + -64 | 0, m = k, (A | 0) >= (u | 0) && (i[k + 28 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0, i[k + 40 >> 2] = 0, i[k + 44 >> 2] = 0, i[k + 48 >> 2] = 0, i[k + 20 >> 2] = 0, i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 12 >> 2] = e, i[k + 4 >> 2] = n, i[k + 60 >> 2] = 0, i[k + 52 >> 2] = 1, i[k + 56 >> 2] = 16777216, i[k + 8 >> 2] = A, p[i[i[n >> 2] + 20 >> 2]](n, k + 4 | 0, u, u, 1, 0), f = i[k + 28 >> 2] ? A : 0), m = k - -64 | 0, f) break i;
                                f = m + -64 | 0, m = f, i[f + 16 >> 2] = 0, i[f + 12 >> 2] = r, i[f + 8 >> 2] = A, i[f + 4 >> 2] = e, A = 0, B0(f + 20 | 0, 0, 39), i[f + 60 >> 2] = 0, o[f + 59 | 0] = 1, p[i[i[n >> 2] + 24 >> 2]](n, f + 4 | 0, u, 1, 0);
                                e: {
                                    r: switch(i[f + 40 >> 2]){
                                        case 0:
                                            A = i[f + 44 >> 2] == 1 && i[f + 32 >> 2] == 1 && i[f + 36 >> 2] == 1 ? i[f + 24 >> 2] : 0;
                                            break e;
                                        case 1:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    if (i[f + 28 >> 2] != 1 && i[f + 44 >> 2] | i[f + 32 >> 2] != 1 | i[f + 36 >> 2] != 1) break e;
                                    A = i[f + 20 >> 2];
                                }
                                m = f - -64 | 0, f = A;
                            }
                            return m = t + 16 | 0, f;
                        }
                        function UB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 16 | 0, m = f, k = i[r + 12 >> 2], u = k, n = i[r + 8 >> 2];
                            i: {
                                e: {
                                    if (!(k | n)) {
                                        for(r = e; i[r + 16 >> 2] = 0, r = i[r + 8 >> 2], !!r;);
                                        break e;
                                    }
                                    if (t = i[r + 32 >> 2], k = n - t | 0, n = u - (n >>> 0 < t >>> 0) | 0, !n & k >>> 0 >= 2147483648 | n) {
                                        if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 101, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                        X(i[f + 4 >> 2]);
                                        break i;
                                    }
                                    if (!o4(e, k) || (n = i[e >> 2], k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), u = i[r + 8 >> 2], t = i[r + 32 >> 2], s = u - t | 0, r = i[r + 12 >> 2] - (u >>> 0 < t >>> 0) | 0, t = p[i[i[n >> 2] + 8 >> 2]](n) | 0, u = t + s | 0, r = w0 + r | 0, p[i[i[n >> 2] + 20 >> 2]](n, u, u >>> 0 < t >>> 0 ? r + 1 | 0 : r), !k) || (r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r)) break e;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function O5(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            A = e;
                            i: if ((f - A | 0) < 3) break i;
                            for(;;){
                                i: {
                                    if (k >>> 0 <= u >>> 0 | A >>> 0 >= f >>> 0) break i;
                                    r = o[A | 0], t = r & 255;
                                    e: {
                                        if ((r | 0) >= 0) {
                                            r = 1;
                                            break e;
                                        }
                                        if (r >>> 0 < 4294967234) break i;
                                        if (r >>> 0 <= 4294967263) {
                                            if ((l[A + 1 | 0] & 192) != 128 | (f - A | 0) < 2) break i;
                                            r = 2;
                                            break e;
                                        }
                                        if (r >>> 0 <= 4294967279) {
                                            if ((f - A | 0) < 3) break i;
                                            n = l[A + 2 | 0], r = l[A + 1 | 0];
                                            r: {
                                                A: {
                                                    if ((t | 0) != 237) {
                                                        if ((t | 0) != 224) break A;
                                                        if ((r & 224) == 160) break r;
                                                        break i;
                                                    }
                                                    if ((r & 224) != 128) break i;
                                                    break r;
                                                }
                                                if ((r & 192) != 128) break i;
                                            }
                                            if ((n & 192) != 128) break i;
                                            r = 3;
                                            break e;
                                        }
                                        if ((f - A | 0) < 4 | r >>> 0 > 4294967284) break i;
                                        s = l[A + 3 | 0], h = l[A + 2 | 0], n = l[A + 1 | 0];
                                        r: {
                                            A: switch(t - 240 | 0){
                                                case 0:
                                                    if ((n + 112 & 255) >>> 0 >= 48) break i;
                                                    break r;
                                                case 4:
                                                    if ((n & 240) != 128) break i;
                                                    break r;
                                                default:
                                                    break A;
                                            }
                                            if ((n & 192) != 128) break i;
                                        }
                                        if ((h & 192) != 128 | (s & 192) != 128 || (r = 4, (s & 63 | (h << 6 & 4032 | (t << 18 & 1835008 | (n & 63) << 12))) >>> 0 > 1114111)) break i;
                                    }
                                    u = u + 1 | 0, A = A + r | 0;
                                    continue;
                                }
                                break;
                            }
                            return A - e | 0;
                        }
                        function HB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            B = n + 7 | 0, G = n + 4 | 0;
                            i: {
                                if ((G | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(C = t + 6 | 0, V = k & 2147483644, W = k & 3, _ = -3, y = k >>> 0 < 4;;){
                                        if (h = (_ << 1) + C | 0, s = (Z(f, _) << 1) + e | 0, w = 0, !y) for(; Q[h >> 1] = I[s >> 1], v = h, h = B << 1, v = v + h | 0, Q[v >> 1] = I[s + 2 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 4 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 6 >> 1], h = h + v | 0, s = s + 8 | 0, w = w + 4 | 0, (V | 0) != (w | 0););
                                        if (w = 0, W) for(; Q[h >> 1] = I[s >> 1], s = s + 2 | 0, h = (B << 1) + h | 0, w = w + 1 | 0, (W | 0) != (w | 0););
                                        if (_ = _ + 1 | 0, (G | 0) == (_ | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(f = u - 8 | 0, e = 0, r = r << 1;;){
                                    for(h = (e << 1) + A | 0, s = (Z(e, B) << 1) + t | 0, w = 0; Q[h >> 1] = (((((Q[s + 2 >> 1] << 2) - Q[s >> 1] | 0) + Z(Q[s + 8 >> 1] + Q[s + 6 >> 1] | 0, 40) | 0) + (Q[s + 12 >> 1] << 2) | 0) - Q[s + 14 >> 1] | 0) + Z(Q[s + 10 >> 1] + Q[s + 4 >> 1] | 0, -11) >> f, s = s + 2 | 0, h = r + h | 0, w = w + 1 | 0, (w | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function xB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            B = n + 6 | 0, G = n + 3 | 0;
                            i: {
                                if ((G | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(C = t + 6 | 0, V = k & 2147483644, W = k & 3, _ = -3, y = k >>> 0 < 4;;){
                                        if (h = (_ << 1) + C | 0, s = (Z(f, _) << 1) + e | 0, w = 0, !y) for(; Q[h >> 1] = I[s >> 1], v = h, h = B << 1, v = v + h | 0, Q[v >> 1] = I[s + 2 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 4 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 6 >> 1], h = h + v | 0, s = s + 8 | 0, w = w + 4 | 0, (V | 0) != (w | 0););
                                        if (w = 0, W) for(; Q[h >> 1] = I[s >> 1], s = s + 2 | 0, h = (B << 1) + h | 0, w = w + 1 | 0, (W | 0) != (w | 0););
                                        if (_ = _ + 1 | 0, (G | 0) == (_ | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(f = u - 8 | 0, e = 0, r = r << 1;;){
                                    for(h = (e << 1) + A | 0, s = (Z(e, B) << 1) + t | 0, w = 0; Q[h >> 1] = Q[s + 12 >> 1] + ((((((Q[s + 2 >> 1] << 2) - Q[s >> 1] | 0) + Z(Q[s + 4 >> 1], -10) | 0) + Z(Q[s + 6 >> 1], 58) | 0) + Z(Q[s + 8 >> 1], 17) | 0) + Z(Q[s + 10 >> 1], -5) | 0) >> f, s = s + 2 | 0, h = r + h | 0, w = w + 1 | 0, (w | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function zB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            B = n + 6 | 0, G = n + 4 | 0;
                            i: {
                                if ((G | 0) >= -1) {
                                    if ((k | 0) <= 0) break i;
                                    for(C = t + 4 | 0, V = k & 2147483644, W = k & 3, _ = -2, y = k >>> 0 < 4;;){
                                        if (h = (_ << 1) + C | 0, s = (Z(f, _) << 1) + e | 0, w = 0, !y) for(; Q[h >> 1] = I[s >> 1], v = h, h = B << 1, v = v + h | 0, Q[v >> 1] = I[s + 2 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 4 >> 1], v = h + v | 0, Q[v >> 1] = I[s + 6 >> 1], h = h + v | 0, s = s + 8 | 0, w = w + 4 | 0, (V | 0) != (w | 0););
                                        if (w = 0, W) for(; Q[h >> 1] = I[s >> 1], s = s + 2 | 0, h = (B << 1) + h | 0, w = w + 1 | 0, (W | 0) != (w | 0););
                                        if (_ = _ + 1 | 0, (G | 0) == (_ | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(f = u - 8 | 0, e = 0, r = r << 1;;){
                                    for(h = (e << 1) + A | 0, s = (Z(e, B) << 1) + t | 0, w = 0; Q[h >> 1] = (((((Q[s >> 1] + Z(Q[s + 2 >> 1], -5) | 0) + Z(Q[s + 4 >> 1], 17) | 0) + Z(Q[s + 6 >> 1], 58) | 0) + Z(Q[s + 8 >> 1], -10) | 0) + (Q[s + 10 >> 1] << 2) | 0) - Q[s + 12 >> 1] >> f, s = s + 2 | 0, h = r + h | 0, w = w + 1 | 0, (w | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function P5(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            A = e;
                            i: if ((f - A | 0) < 3) break i;
                            for(;;){
                                i: {
                                    if (k >>> 0 <= t >>> 0 | A >>> 0 >= f >>> 0) break i;
                                    r = l[A | 0], n = A + 1 | 0;
                                    e: {
                                        if (r << 24 >> 24 >= 0) break e;
                                        if (r >>> 0 < 194) break i;
                                        if (r >>> 0 <= 223) {
                                            if ((l[A + 1 | 0] & 192) != 128 | (f - A | 0) < 2) break i;
                                            n = A + 2 | 0;
                                            break e;
                                        }
                                        if (r >>> 0 <= 239) {
                                            if ((f - A | 0) < 3) break i;
                                            u = l[A + 2 | 0], n = l[A + 1 | 0];
                                            r: {
                                                A: {
                                                    if ((r | 0) != 237) {
                                                        if ((r | 0) != 224) break A;
                                                        if ((n & 224) == 160) break r;
                                                        break i;
                                                    }
                                                    if ((n & 224) != 128) break i;
                                                    break r;
                                                }
                                                if ((n & 192) != 128) break i;
                                            }
                                            if ((u & 192) != 128) break i;
                                            n = A + 3 | 0;
                                            break e;
                                        }
                                        if ((f - A | 0) < 4 | r >>> 0 > 244 | k - t >>> 0 < 2) break i;
                                        u = l[A + 3 | 0], s = l[A + 2 | 0], n = l[A + 1 | 0];
                                        r: {
                                            A: switch(r - 240 | 0){
                                                case 0:
                                                    if ((n + 112 & 255) >>> 0 >= 48) break i;
                                                    break r;
                                                case 4:
                                                    if ((n & 240) != 128) break i;
                                                    break r;
                                                default:
                                                    break A;
                                            }
                                            if ((n & 192) != 128) break i;
                                        }
                                        if ((s & 192) != 128 | (u & 192) != 128 | (u & 63 | (s << 6 & 4032 | (r << 18 & 1835008 | (n & 63) << 12))) >>> 0 > 1114111) break i;
                                        t = t + 1 | 0, n = A + 4 | 0;
                                    }
                                    A = n, t = t + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return A - e | 0;
                        }
                        function L5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                e: {
                                    if (f = i[A + 4 >> 2], u = i[A >> 2], n = f - u >> 4, t = n + 1 | 0, t >>> 0 < 268435456) {
                                        if (k = i[A + 8 >> 2] - u | 0, e = k >> 3, s = k >>> 0 >= 2147483632 ? 268435455 : e >>> 0 > t >>> 0 ? e : t, s) {
                                            if (s >>> 0 >= 268435456) break e;
                                            h = D(s << 4);
                                        }
                                        if (k = i[r >> 2], e = (n << 4) + h | 0, i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = k, k = i[r + 8 >> 2], n = i[r + 4 >> 2], (k | 0) != (n | 0)) {
                                            if (t = k - n | 0, (t | 0) < 0) break i;
                                            k = D(t), i[e + 4 >> 2] = k, r = k + t | 0, i[e + 12 >> 2] = r, v0(k, n, t), i[e + 8 >> 2] = r;
                                        }
                                        t = (s << 4) + h | 0, s = e + 16 | 0;
                                        r: {
                                            if ((f | 0) == (u | 0)) {
                                                h = e;
                                                break r;
                                            }
                                            for(; r = f - 16 | 0, n = i[r >> 2], k = e - 4 | 0, i[k >> 2] = 0, h = e - 16 | 0, i[h >> 2] = n, n = f - 12 | 0, i[e - 12 >> 2] = i[n >> 2], i[e - 8 >> 2] = i[f - 8 >> 2], e = f - 4 | 0, i[k >> 2] = i[e >> 2], i[e >> 2] = 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, e = h, f = r, (u | 0) != (f | 0););
                                            f = i[A + 4 >> 2], u = i[A >> 2];
                                        }
                                        if (i[A + 8 >> 2] = t, i[A + 4 >> 2] = s, i[A >> 2] = h, (f | 0) != (u | 0)) for(; A = i[f - 12 >> 2], A && (i[f - 8 >> 2] = A, X(A)), f = f - 16 | 0, (u | 0) != (f | 0););
                                        return u && X(u), s;
                                    }
                                    p0(), z();
                                }
                                Z2(), z();
                            }
                            p0(), z();
                        }
                        function K5(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            t = m - 32 | 0, m = t, n = f & 65535, u = f >>> 16 & 32767;
                            i: {
                                if (u - 16257 >>> 0 <= 253) {
                                    k = (n & 33554431) << 7 | e >>> 25, n = 0, e = e & 33554431;
                                    e: {
                                        if (!(!n & (e | 0) == 16777216 ? !(A | r) : !n & e >>> 0 < 16777216)) {
                                            k = k + 1 | 0;
                                            break e;
                                        }
                                        if (e ^ 16777216 | A | (r | n)) break e;
                                        k = (k & 1) + k | 0;
                                    }
                                    A = k >>> 0 > 8388607, k = A ? 0 : k, s = (A ? -16255 : -16256) + u | 0;
                                    break i;
                                }
                                if (!(!(A | e | (r | n)) | ((u | 0) != 32767 | (k | 0) != 0))) {
                                    k = (n & 33554431) << 7 | e >>> 25 | 4194304, s = 255;
                                    break i;
                                }
                                if (u >>> 0 > 16510) {
                                    s = 255;
                                    break i;
                                }
                                if (w = !(k | u), v = w ? 16256 : 16257, h = v - u | 0, (h | 0) > 112) break i;
                                n = w ? n : n | 65536, P1(t + 16 | 0, A, r, e, n, 128 - h | 0), d8(t, A, r, e, n, h), A = i[t + 8 >> 2], k = (i[t + 12 >> 2] & 33554431) << 7 | A >>> 25, e = i[t >> 2] | (u | 0) != (v | 0) & (i[t + 16 >> 2] | i[t + 24 >> 2] | (i[t + 20 >> 2] | i[t + 28 >> 2])) != 0, n = i[t + 4 >> 2], r = 0, A = A & 33554431;
                                e: {
                                    if (!(!r & (A | 0) == 16777216 ? !(e | n) : !r & A >>> 0 < 16777216)) {
                                        k = k + 1 | 0;
                                        break e;
                                    }
                                    if (A ^ 16777216 | e | (r | n)) break e;
                                    k = (k & 1) + k | 0;
                                }
                                s = k >>> 0 > 8388607, k = s ? k ^ 8388608 : k;
                            }
                            return m = t + 32 | 0, J2(2, f & -2147483648 | s << 23 | k), Q1();
                        }
                        function q5(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (t = m - 48 | 0, m = t, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, m8(t + 40 | 0, r, 1835625829), s = i[t + 40 >> 2], u = s, o[u + 164 | 0] = 1, i[u + 100 >> 2] = i[u + 100 >> 2] & -2 | 1, u = E2(e), u >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (u >>> 0 >= 11) {
                                            w = (u | 7) + 1 | 0, h = D(w), i[t + 36 >> 2] = w | -2147483648, i[t + 28 >> 2] = h, i[t + 32 >> 2] = u;
                                            break e;
                                        }
                                        if (o[t + 39 | 0] = u, h = t + 28 | 0, !u) break i;
                                    }
                                    v0(h, e, u);
                                }
                                o[u + h | 0] = 0, e = s + 128 | 0;
                                i: {
                                    if ((e | 0) == (t + 28 | 0)) break i;
                                    if (u = o[t + 39 | 0], o[s + 139 | 0] >= 0) {
                                        if ((u | 0) >= 0) {
                                            u = i[t + 32 >> 2], i[e >> 2] = i[t + 28 >> 2], i[e + 4 >> 2] = u, i[e + 8 >> 2] = i[t + 36 >> 2];
                                            break i;
                                        }
                                        X4(e, i[t + 28 >> 2], i[t + 32 >> 2]);
                                        break i;
                                    }
                                    s = e, e = (u | 0) < 0, Y4(s, e ? i[t + 28 >> 2] : t + 28 | 0, e ? i[t + 32 >> 2] : u);
                                }
                                o[t + 39 | 0] < 0 && X(i[t + 28 >> 2]), i[A >> 2] = i[i[t + 40 >> 2] + 104 >> 2], P3(t + 8 | 0, r, t + 40 | 0, k, n, f), o[t + 27 | 0] < 0 && X(i[t + 16 >> 2]), A = i[t + 44 >> 2];
                                i: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                m = t + 48 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Me(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                e: {
                                    if ((r | 0) == 8) {
                                        r = Q2(e);
                                        break e;
                                    }
                                    if (f = 28, r & 3 | r >>> 0 < 4 || (n = r >>> 2 | 0, n - 1 & n) || (f = 48, -64 - r >>> 0 < e >>> 0)) break i;
                                    n = 16, r = r >>> 0 <= 16 ? 16 : r, f = r >>> 0 <= 16 ? 16 : r;
                                    r: {
                                        if (!(f - 1 & f)) {
                                            r = f;
                                            break r;
                                        }
                                        for(; r = n, n = r << 1, r >>> 0 < f >>> 0;);
                                    }
                                    r: {
                                        if (-64 - r >>> 0 <= e >>> 0) {
                                            i[26064] = 48, e = 0;
                                            break r;
                                        }
                                        if (n = e >>> 0 < 11 ? 16 : e + 11 & -8, k = Q2((n + r | 0) + 12 | 0), e = 0, !k) break r;
                                        e = k - 8 | 0;
                                        A: {
                                            if (!(k & r - 1)) {
                                                r = e;
                                                break A;
                                            }
                                            if (t = k - 4 | 0, u = i[t >> 2], f = r, r = ((r + k | 0) - 1 & 0 - r) - 8 | 0, r = (r - e >>> 0 <= 15 ? f : 0) + r | 0, f = r - e | 0, k = (u & -8) - f | 0, !(u & 3)) {
                                                e = i[e >> 2], i[r + 4 >> 2] = k, i[r >> 2] = e + f;
                                                break A;
                                            }
                                            i[r + 4 >> 2] = k | i[r + 4 >> 2] & 1 | 2, k = r + k | 0, i[k + 4 >> 2] = i[k + 4 >> 2] | 1, i[t >> 2] = f | i[t >> 2] & 1 | 2, k = e + f | 0, i[k + 4 >> 2] = i[k + 4 >> 2] | 1, Be(e, f);
                                        }
                                        e = i[r + 4 >> 2];
                                        A: {
                                            if (!(e & 3) || (f = e & -8, f >>> 0 <= n + 16 >>> 0)) break A;
                                            i[r + 4 >> 2] = n | e & 1 | 2, e = r + n | 0, n = f - n | 0, i[e + 4 >> 2] = n | 3, f = r + f | 0, i[f + 4 >> 2] = i[f + 4 >> 2] | 1, Be(e, n);
                                        }
                                        e = r + 8 | 0;
                                    }
                                    r = e;
                                }
                                if (!r) return 48;
                                i[A >> 2] = r, f = 0;
                            }
                            return f;
                        }
                        function TB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 4926);
                                    break i;
                                }
                                if (B4(f + 20 | 0, e), o[r + 115 | 0] < 0 && X(i[r + 104 >> 2]), k = i[f + 24 >> 2], i[r + 104 >> 2] = i[f + 20 >> 2], i[r + 108 >> 2] = k, i[r + 112 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 127 | 0] < 0 && X(i[r + 116 >> 2]), k = i[f + 24 >> 2], i[r + 116 >> 2] = i[f + 20 >> 2], i[r + 120 >> 2] = k, i[r + 124 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 139 | 0] < 0 && X(i[r + 128 >> 2]), k = i[f + 24 >> 2], i[r + 128 >> 2] = i[f + 20 >> 2], i[r + 132 >> 2] = k, i[r + 136 >> 2] = i[f + 28 >> 2], B4(f + 20 | 0, e), o[r + 151 | 0] < 0 && X(i[r + 140 >> 2]), k = i[f + 24 >> 2], i[r + 140 >> 2] = i[f + 20 >> 2], i[r + 144 >> 2] = k, i[r + 148 >> 2] = i[f + 28 >> 2], l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function $5(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (n = m - 48 | 0, m = n, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, m8(n + 40 | 0, r, 1970432288), u = i[n + 40 >> 2], t = u, o[t + 164 | 0] = 1, i[t + 100 >> 2] = i[t + 100 >> 2] & -2 | 1, t = E2(e), t >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (t >>> 0 >= 11) {
                                            h = (t | 7) + 1 | 0, s = D(h), i[n + 36 >> 2] = h | -2147483648, i[n + 28 >> 2] = s, i[n + 32 >> 2] = t;
                                            break e;
                                        }
                                        if (o[n + 39 | 0] = t, s = n + 28 | 0, !t) break i;
                                    }
                                    v0(s, e, t);
                                }
                                o[t + s | 0] = 0, e = u + 152 | 0;
                                i: {
                                    if ((e | 0) == (n + 28 | 0)) break i;
                                    if (t = o[n + 39 | 0], o[u + 163 | 0] >= 0) {
                                        if ((t | 0) >= 0) {
                                            t = i[n + 32 >> 2], i[e >> 2] = i[n + 28 >> 2], i[e + 4 >> 2] = t, i[e + 8 >> 2] = i[n + 36 >> 2];
                                            break i;
                                        }
                                        X4(e, i[n + 28 >> 2], i[n + 32 >> 2]);
                                        break i;
                                    }
                                    u = e, e = (t | 0) < 0, Y4(u, e ? i[n + 28 >> 2] : n + 28 | 0, e ? i[n + 32 >> 2] : t);
                                }
                                o[n + 39 | 0] < 0 && X(i[n + 28 >> 2]), i[A >> 2] = i[i[n + 40 >> 2] + 104 >> 2], P3(n + 8 | 0, r, n + 40 | 0, f, k, 0), o[n + 27 | 0] < 0 && X(i[n + 16 >> 2]), A = i[n + 44 >> 2];
                                i: {
                                    if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                m = n + 48 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function SB(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 112 | 0, m = n;
                            i: {
                                if (!(k && f)) {
                                    r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                    break i;
                                }
                                e: {
                                    if (t = i[r + 16 >> 2], !t || (h = E0(t, 78492, 78988), !h)) break e;
                                    if (t = i[r + 20 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), u = i[r >> 2], i[n + 56 >> 2] = i[u + 48 >> 2], u = i[u + 52 >> 2], i[n + 60 >> 2] = u, u && (i[u + 4 >> 2] = i[u + 4 >> 2] + 1), r = i[r + 8 >> 2], u = i[r + 8 >> 2], r = i[r + 4 >> 2], s = i[n + 60 >> 2], i[n + 16 >> 2] = i[n + 56 >> 2], i[n + 20 >> 2] = s, s = n - -64 | 0, ve(s, n + 16 | 0, e, r, u), n0[n + 24 >> 3] = i[h + 4 >> 2], n0[n + 32 >> 3] = i[h + 8 >> 2], r = i[n + 36 >> 2], i[n + 8 >> 2] = i[n + 32 >> 2], i[n + 12 >> 2] = r, r = i[n + 28 >> 2], i[n >> 2] = i[n + 24 >> 2], i[n + 4 >> 2] = r, tr(n + 40 | 0, s, n), n0[f >> 3] = n0[n + 40 >> 3], n0[k >> 3] = n0[n + 48 >> 3], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, !t || (A = i[t + 4 >> 2], i[t + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                    break i;
                                }
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                            }
                            m = n + 112 | 0;
                        }
                        function jB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            _ = n + 7 | 0, B = n + 4 | 0;
                            i: {
                                if ((B | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(W = t + 6 | 0, C = k & 2147483644, G = k & 3, v = -3, V = k >>> 0 < 4;;){
                                        if (s = (v << 1) + W | 0, u = Z(f, v) + e | 0, h = 0, !V) for(; Q[s >> 1] = l[u | 0], w = s, s = _ << 1, w = w + s | 0, Q[w >> 1] = l[u + 1 | 0], w = s + w | 0, Q[w >> 1] = l[u + 2 | 0], w = s + w | 0, Q[w >> 1] = l[u + 3 | 0], s = s + w | 0, u = u + 4 | 0, h = h + 4 | 0, (C | 0) != (h | 0););
                                        if (h = 0, G) for(; Q[s >> 1] = l[u | 0], u = u + 1 | 0, s = (_ << 1) + s | 0, h = h + 1 | 0, (G | 0) != (h | 0););
                                        if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(e = 0, r = r << 1;;){
                                    for(s = (e << 1) + A | 0, u = (Z(e, _) << 1) + t | 0, h = 0; Q[s >> 1] = (((((I[u + 2 >> 1] << 2) - I[u >> 1] | 0) + Z(I[u + 8 >> 1] + I[u + 6 >> 1] | 0, 40) | 0) + (I[u + 12 >> 1] << 2) | 0) - I[u + 14 >> 1] | 0) + Z(I[u + 10 >> 1] + I[u + 4 >> 1] | 0, -11), u = u + 2 | 0, s = r + s | 0, h = h + 1 | 0, (h | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function D3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            i: {
                                if (f = i[A >> 2], u = (i[A + 4 >> 2] - f | 0) / 20 | 0, n = u + 1 | 0, n >>> 0 < 214748365) {
                                    if (e = (i[A + 8 >> 2] - f | 0) / 20 | 0, f = e << 1, n = e >>> 0 >= 107374182 ? 214748364 : f >>> 0 > n >>> 0 ? f : n, n) {
                                        if (n >>> 0 >= 214748365) break i;
                                        k = D(Z(n, 20));
                                    }
                                    f = i[r + 4 >> 2], e = Z(u, 20) + k | 0, i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = f, i[e + 16 >> 2] = i[r + 16 >> 2], f = i[r + 12 >> 2], i[e + 8 >> 2] = i[r + 8 >> 2], i[e + 12 >> 2] = f, i[r + 16 >> 2] = 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0, n = Z(n, 20) + k | 0, s = e + 20 | 0, r = i[A + 4 >> 2], t = i[A >> 2];
                                    e: {
                                        if ((r | 0) == (t | 0)) {
                                            f = e;
                                            break e;
                                        }
                                        for(; u = r - 20 | 0, k = i[u + 4 >> 2], f = e - 20 | 0, i[f >> 2] = i[u >> 2], i[f + 4 >> 2] = k, e = e - 12 | 0, k = r - 12 | 0, i[e + 8 >> 2] = i[k + 8 >> 2], r = i[k + 4 >> 2], i[e >> 2] = i[k >> 2], i[e + 4 >> 2] = r, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, e = f, r = u, (t | 0) != (r | 0););
                                        r = i[A + 4 >> 2], t = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = f, i[A + 8 >> 2] = n, (r | 0) != (t | 0)) for(; o[r - 1 | 0] < 0 && X(i[r - 12 >> 2]), r = r - 20 | 0, (t | 0) != (r | 0););
                                    return t && X(t), s;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function OB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            _ = n + 6 | 0, B = n + 3 | 0;
                            i: {
                                if ((B | 0) >= -2) {
                                    if ((k | 0) <= 0) break i;
                                    for(W = t + 6 | 0, C = k & 2147483644, G = k & 3, v = -3, V = k >>> 0 < 4;;){
                                        if (s = (v << 1) + W | 0, u = Z(f, v) + e | 0, h = 0, !V) for(; Q[s >> 1] = l[u | 0], w = s, s = _ << 1, w = w + s | 0, Q[w >> 1] = l[u + 1 | 0], w = s + w | 0, Q[w >> 1] = l[u + 2 | 0], w = s + w | 0, Q[w >> 1] = l[u + 3 | 0], s = s + w | 0, u = u + 4 | 0, h = h + 4 | 0, (C | 0) != (h | 0););
                                        if (h = 0, G) for(; Q[s >> 1] = l[u | 0], u = u + 1 | 0, s = (_ << 1) + s | 0, h = h + 1 | 0, (G | 0) != (h | 0););
                                        if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(e = 0, r = r << 1;;){
                                    for(s = (e << 1) + A | 0, u = (Z(e, _) << 1) + t | 0, h = 0; Q[s >> 1] = I[u + 12 >> 1] + ((((((I[u + 2 >> 1] << 2) - I[u >> 1] | 0) + Z(I[u + 4 >> 1], -10) | 0) + Z(I[u + 6 >> 1], 58) | 0) + Z(I[u + 8 >> 1], 17) | 0) + Z(I[u + 10 >> 1], -5) | 0), u = u + 2 | 0, s = r + s | 0, h = h + 1 | 0, (h | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function PB(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            _ = n + 6 | 0, B = n + 4 | 0;
                            i: {
                                if ((B | 0) >= -1) {
                                    if ((k | 0) <= 0) break i;
                                    for(W = t + 4 | 0, C = k & 2147483644, G = k & 3, v = -2, V = k >>> 0 < 4;;){
                                        if (s = (v << 1) + W | 0, u = Z(f, v) + e | 0, h = 0, !V) for(; Q[s >> 1] = l[u | 0], w = s, s = _ << 1, w = w + s | 0, Q[w >> 1] = l[u + 1 | 0], w = s + w | 0, Q[w >> 1] = l[u + 2 | 0], w = s + w | 0, Q[w >> 1] = l[u + 3 | 0], s = s + w | 0, u = u + 4 | 0, h = h + 4 | 0, (C | 0) != (h | 0););
                                        if (h = 0, G) for(; Q[s >> 1] = l[u | 0], u = u + 1 | 0, s = (_ << 1) + s | 0, h = h + 1 | 0, (G | 0) != (h | 0););
                                        if (v = v + 1 | 0, (B | 0) == (v | 0)) break;
                                    }
                                }
                                if ((k | 0) <= 0 | (n | 0) <= 0) break i;
                                for(e = 0, r = r << 1;;){
                                    for(s = (e << 1) + A | 0, u = (Z(e, _) << 1) + t | 0, h = 0; Q[s >> 1] = (((((I[u >> 1] + Z(I[u + 2 >> 1], -5) | 0) + Z(I[u + 4 >> 1], 17) | 0) + Z(I[u + 6 >> 1], 58) | 0) + Z(I[u + 8 >> 1], -10) | 0) + (I[u + 10 >> 1] << 2) | 0) - I[u + 12 >> 1], u = u + 2 | 0, s = r + s | 0, h = h + 1 | 0, (h | 0) != (n | 0););
                                    if (e = e + 1 | 0, (k | 0) == (e | 0)) break;
                                }
                            }
                        }
                        function a5(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = i[A + 8 >> 2], e = i[A + 4 >> 2], f - e >> 3 >>> 0 >= r >>> 0) {
                                if (r) for(r = (r << 3) + e | 0; i[e >> 2] = 0, i[e + 4 >> 2] = 0, e = e + 8 | 0, (r | 0) != (e | 0););
                                i[A + 4 >> 2] = e;
                                return;
                            }
                            i: {
                                if (k = i[A >> 2], n = e - k >> 3, t = n + r | 0, t >>> 0 < 536870912) {
                                    if (f = f - k | 0, k = f >> 2, t = f >>> 0 >= 2147483640 ? 536870911 : t >>> 0 < k >>> 0 ? k : t, t) {
                                        if (t >>> 0 >= 536870912) break i;
                                        k = D(t << 3);
                                    } else k = 0;
                                    for(f = k + (n << 3) | 0, n = f + (r << 3) | 0, r = f; i[r >> 2] = 0, i[r + 4 >> 2] = 0, r = r + 8 | 0, (n | 0) != (r | 0););
                                    if (e = i[A + 4 >> 2], u = i[A >> 2], (e | 0) != (u | 0)) {
                                        for(; f = f - 8 | 0, e = e - 8 | 0, s = m - 16 | 0, m = s, l[87597] == 1 && (i[s + 4 >> 2] = e, i[s >> 2] = f, n8(25524, s)), n = i[e + 4 >> 2], n && (i[n >> 2] = i[n >> 2] + 1), i[f + 4 >> 2] = n, i[f >> 2] = i[e >> 2], m = s + 16 | 0, (e | 0) != (u | 0););
                                        e = i[A + 4 >> 2], u = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = r, i[A >> 2] = f, i[A + 8 >> 2] = (t << 3) + k, (e | 0) != (u | 0)) for(; e = C8(e - 8 | 0), (u | 0) != (e | 0););
                                    u && X(u);
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function LB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            if (!(!r | !e)) {
                                f = I[r >> 1], W0[e >> 2] = (f + 28535 & 65535) >>> 0 < 28540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 6 >> 1], W0[e + 12 >> 2] = (f + 23535 & 65535) >>> 0 < 23540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 2 >> 1], W0[e + 4 >> 2] = (f + 28535 & 65535) >>> 0 < 28540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 8 >> 1], W0[e + 16 >> 2] = (f + 23535 & 65535) >>> 0 < 23540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 4 >> 1], W0[e + 8 >> 2] = (f + 28535 & 65535) >>> 0 < 28540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 10 >> 1], W0[e + 20 >> 2] = (f + 23535 & 65535) >>> 0 < 23540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 12 >> 1], W0[e + 24 >> 2] = (f + 28535 & 65535) >>> 0 < 28540 ? J(0) : J(+(f >>> 0) * 2e-5), f = I[r + 14 >> 1], W0[e + 28 >> 2] = (f + 23535 & 65535) >>> 0 < 23540 ? J(0) : J(+(f >>> 0) * 2e-5), f = i[r + 16 >> 2], n0[e + 32 >> 3] = f - 100000001 >>> 0 < 4195017295 ? 0 : +(f >>> 0) * 1e-4, r = i[r + 20 >> 2], n0[e + 40 >> 3] = r - 50001 >>> 0 < 4294917296 ? 0 : +(r >>> 0) * 1e-4, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                return;
                            }
                            r = i[19869], i[A >> 2] = i[19868], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19870];
                        }
                        function KB(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            e = m - 48 | 0, m = e, i[e + 44 >> 2] = 0, i[e + 36 >> 2] = 0, i[e + 40 >> 2] = 0;
                            i: {
                                e: {
                                    if (!L7(i[r + 32 >> 2], e + 36 | 0)) {
                                        o[e + 4 | 0] = 0, o[e + 15 | 0] = 0, r = i0(e + 16 | 0, 2, 117, e + 4 | 0), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 4 >> 2], i[A + 12 >> 2] = i[r >> 2], i[A + 16 >> 2] = f, A = A + 20 | 0;
                                        r: {
                                            if (o[r + 19 | 0] >= 0) {
                                                f = i[r + 12 >> 2], i[A >> 2] = i[r + 8 >> 2], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[r + 16 >> 2];
                                                break r;
                                            }
                                            if (j(A, i[r + 8 >> 2], i[r + 12 >> 2]), o[r + 19 | 0] >= 0) break r;
                                            X(i[r + 8 >> 2]);
                                        }
                                        if (o[e + 15 | 0] >= 0) break e;
                                        X(i[e + 4 >> 2]);
                                        break e;
                                    }
                                    if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[e + 36 >> 2], r = i[e + 40 >> 2], (k | 0) != (r | 0)) {
                                        if (r = r - k | 0, (r | 0) < 0) break i;
                                        f = D(r), i[A + 4 >> 2] = f, i[A >> 2] = f, n = r + f | 0, i[A + 8 >> 2] = n, v0(f, k, r), i[A + 4 >> 2] = n;
                                    }
                                    if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                A = i[e + 36 >> 2], A && (i[e + 40 >> 2] = A, X(A)), m = e + 48 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function qB(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f, A = i[A >> 2], n = i[A + 48 >> 2], k = i[A + 52 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[f + 28 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, F4(f, n, r, f + 20 | 0), n = -1;
                            i: {
                                if (i[f >> 2] | !e || (r = e - 1 | 0, A = i[f + 20 >> 2], r >>> 0 >= i[f + 24 >> 2] - A >> 3 >>> 0) || (A = A + (r << 3) | 0, r = i[A >> 2], !r) || (r = E0(r, 73632, 74856), !r)) break i;
                                if (A = i[A + 4 >> 2], !A) {
                                    n = i[r + 100 >> 2];
                                    break i;
                                }
                                if (e = i[A + 4 >> 2], t = e + 1 | 0, i[A + 4 >> 2] = t, n = i[r + 100 >> 2], i[A + 4 >> 2] = e, t) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            if (o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), r = i[f + 20 >> 2], r) {
                                if (A = r, e = i[f + 24 >> 2], (A | 0) != (e | 0)) {
                                    for(;;){
                                        A = i[e - 4 >> 2];
                                        i: {
                                            if (!A || (t = i[A + 4 >> 2], i[A + 4 >> 2] = t - 1, t)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (e = e - 8 | 0, (r | 0) == (e | 0)) break;
                                    }
                                    A = i[f + 20 >> 2];
                                }
                                i[f + 24 >> 2] = r, X(A);
                            }
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            return m = f + 32 | 0, n | 0;
                        }
                        function $B(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f, A = i[A >> 2], n = i[A + 48 >> 2], k = i[A + 52 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[f + 28 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, F4(f, n, r, f + 20 | 0), n = -1;
                            i: {
                                if (i[f >> 2] | !e || (r = e - 1 | 0, A = i[f + 20 >> 2], r >>> 0 >= i[f + 24 >> 2] - A >> 3 >>> 0) || (A = A + (r << 3) | 0, r = i[A >> 2], !r) || (r = E0(r, 73632, 74784), !r)) break i;
                                if (A = i[A + 4 >> 2], !A) {
                                    n = i[r + 100 >> 2];
                                    break i;
                                }
                                if (e = i[A + 4 >> 2], t = e + 1 | 0, i[A + 4 >> 2] = t, n = i[r + 100 >> 2], i[A + 4 >> 2] = e, t) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            if (o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), r = i[f + 20 >> 2], r) {
                                if (A = r, e = i[f + 24 >> 2], (A | 0) != (e | 0)) {
                                    for(;;){
                                        A = i[e - 4 >> 2];
                                        i: {
                                            if (!A || (t = i[A + 4 >> 2], i[A + 4 >> 2] = t - 1, t)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (e = e - 8 | 0, (r | 0) == (e | 0)) break;
                                    }
                                    A = i[f + 20 >> 2];
                                }
                                i[f + 24 >> 2] = r, X(A);
                            }
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            return m = f + 32 | 0, n | 0;
                        }
                        function B6(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                e: {
                                    if (n = i[A + 4 >> 2], t = i[A >> 2], u = (n - t | 0) / 12 | 0, e = u + 1 | 0, e >>> 0 < 357913942) {
                                        if (f = (i[A + 8 >> 2] - t | 0) / 12 | 0, k = f << 1, f = f >>> 0 >= 178956970 ? 357913941 : e >>> 0 < k >>> 0 ? k : e, f) {
                                            if (f >>> 0 >= 357913942) break e;
                                            s = D(Z(f, 12));
                                        }
                                        if (e = Z(u, 12) + s | 0, i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, k = i[r + 4 >> 2], u = i[r >> 2], (k | 0) != (u | 0)) {
                                            if (r = k - u | 0, (r | 0) < 0) break i;
                                            k = D(r), i[e >> 2] = k, h = r + k | 0, i[e + 8 >> 2] = h, v0(k, u, r), i[e + 4 >> 2] = h;
                                        }
                                        u = Z(f, 12) + s | 0, s = e + 12 | 0;
                                        r: {
                                            if ((n | 0) == (t | 0)) {
                                                r = e;
                                                break r;
                                            }
                                            for(; k = e - 4 | 0, i[k >> 2] = 0, r = e - 12 | 0, f = n - 12 | 0, i[r >> 2] = i[f >> 2], i[e - 8 >> 2] = i[n - 8 >> 2], e = n - 4 | 0, i[k >> 2] = i[e >> 2], i[e >> 2] = 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, e = r, n = f, (t | 0) != (f | 0););
                                            n = i[A + 4 >> 2], t = i[A >> 2];
                                        }
                                        if (i[A + 8 >> 2] = u, i[A + 4 >> 2] = s, i[A >> 2] = r, (n | 0) != (t | 0)) for(; A = n - 12 | 0, r = i[A >> 2], r && (i[n - 8 >> 2] = r, X(r)), n = A, (t | 0) != (A | 0););
                                        return t && X(t), s;
                                    }
                                    p0(), z();
                                }
                                Z2(), z();
                            }
                            p0(), z();
                        }
                        function aB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(v = u - 8 | 0, _ = e - 6 | 0;;){
                                    for(e = (w << 1) + t | 0, u = _ + (Z(f, w) << 1) | 0, s = 0; Q[e >> 1] = (((((I[u + 2 >> 1] << 2) - I[u >> 1] | 0) + Z(I[u + 8 >> 1] + I[u + 6 >> 1] | 0, 40) | 0) + (I[u + 12 >> 1] << 2) | 0) - I[u + 14 >> 1] | 0) + Z(I[u + 10 >> 1] + I[u + 4 >> 1] | 0, -11) >> v, u = u + 2 | 0, e = (n << 1) + e | 0, s = s + 1 | 0, (s | 0) != (k | 0););
                                    if (w = w + 1 | 0, (w | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (e = (f << 1) + A | 0, u = (Z(f, n) << 1) + t | 0, s = 0, !_) for(; Q[e >> 1] = I[u >> 1], h = e, e = r << 1, h = h + e | 0, Q[h >> 1] = I[u + 2 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 4 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 6 >> 1], e = e + h | 0, u = u + 8 | 0, s = s + 4 | 0, (v | 0) != (s | 0););
                                    if (s = 0, w) for(; Q[e >> 1] = I[u >> 1], u = u + 2 | 0, e = (r << 1) + e | 0, s = s + 1 | 0, (w | 0) != (s | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function Ue(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if (u = i[21681], (u | 0) != 86728) for(;;){
                                        w = i[u + 16 >> 2], f = i[w >> 2];
                                        r: {
                                            if (i[f + 4 >> 2] != (r | 0) && r || e && d1(e, i[f + 8 >> 2])) break r;
                                            t = i[A + 8 >> 2];
                                            A: {
                                                if (t >>> 0 > n >>> 0) {
                                                    i[n >> 2] = w, n = n + 4 | 0;
                                                    break A;
                                                }
                                                if (k = i[A >> 2], h = n - k >> 2, f = h + 1 | 0, f >>> 0 >= 1073741824) break e;
                                                if (v = h << 2, t = t - k | 0, s = t >> 1, s = t >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < s >>> 0 ? s : f, s) {
                                                    if (s >>> 0 >= 1073741824) break i;
                                                    h = D(s << 2);
                                                } else h = 0;
                                                if (t = v + h | 0, i[t >> 2] = w, f = t, (k | 0) != (n | 0)) {
                                                    for(; f = f - 4 | 0, n = n - 4 | 0, i[f >> 2] = i[n >> 2], (k | 0) != (n | 0););
                                                    k = i[A >> 2];
                                                }
                                                if (n = t + 4 | 0, i[A + 8 >> 2] = h + (s << 2), i[A >> 2] = f, !k) break A;
                                                X(k);
                                            }
                                            i[A + 4 >> 2] = n;
                                        }
                                        k = i[u + 4 >> 2];
                                        r: {
                                            if (k) {
                                                for(;;)if (f = k, k = i[f >> 2], !k) break r;
                                            }
                                            for(; f = i[u + 8 >> 2], k = i[f >> 2] != (u | 0), u = f, !!k;);
                                        }
                                        if (u = f, (f | 0) == 86728) break;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function bB(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 8710);
                                    break i;
                                }
                                if (t = X2(e), k = i[e >> 2], n = p[i[i[k >> 2] + 8 >> 2]](k) | 0, u = i[e >> 2], k = w0, n = t + n | 0, k = n >>> 0 < t >>> 0 ? k + 1 | 0 : k, p[i[i[u >> 2] + 12 >> 2]](u, n, k) | 0) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                k = r + 104 | 0, u = i[r + 104 >> 2], n = i[r + 108 >> 2] - u | 0;
                                e: {
                                    if (n >>> 0 < t >>> 0) {
                                        r1(k, t - n | 0);
                                        break e;
                                    }
                                    if (t >>> 0 >= n >>> 0) break e;
                                    i[r + 108 >> 2] = t + u;
                                }
                                if (t) for(r = 0; n = X2(e), o[i[k >> 2] + r | 0] = n, r = r + 1 | 0, (t | 0) != (r | 0););
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function dB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(v = u - 8 | 0, _ = e - 6 | 0;;){
                                    for(e = (w << 1) + t | 0, u = _ + (Z(f, w) << 1) | 0, s = 0; Q[e >> 1] = I[u + 12 >> 1] + ((((((I[u + 2 >> 1] << 2) - I[u >> 1] | 0) + Z(I[u + 4 >> 1], -10) | 0) + Z(I[u + 6 >> 1], 58) | 0) + Z(I[u + 8 >> 1], 17) | 0) + Z(I[u + 10 >> 1], -5) | 0) >> v, u = u + 2 | 0, e = (n << 1) + e | 0, s = s + 1 | 0, (s | 0) != (k | 0););
                                    if (w = w + 1 | 0, (w | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (e = (f << 1) + A | 0, u = (Z(f, n) << 1) + t | 0, s = 0, !_) for(; Q[e >> 1] = I[u >> 1], h = e, e = r << 1, h = h + e | 0, Q[h >> 1] = I[u + 2 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 4 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 6 >> 1], e = e + h | 0, u = u + 8 | 0, s = s + 4 | 0, (v | 0) != (s | 0););
                                    if (s = 0, w) for(; Q[e >> 1] = I[u >> 1], u = u + 2 | 0, e = (r << 1) + e | 0, s = s + 1 | 0, (w | 0) != (s | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function cB(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(v = u - 8 | 0, _ = e - 4 | 0;;){
                                    for(e = (w << 1) + t | 0, u = _ + (Z(f, w) << 1) | 0, s = 0; Q[e >> 1] = (((((I[u >> 1] + Z(I[u + 2 >> 1], -5) | 0) + Z(I[u + 4 >> 1], 17) | 0) + Z(I[u + 6 >> 1], 58) | 0) + Z(I[u + 8 >> 1], -10) | 0) + (I[u + 10 >> 1] << 2) | 0) - I[u + 12 >> 1] >> v, u = u + 2 | 0, e = (n << 1) + e | 0, s = s + 1 | 0, (s | 0) != (k | 0););
                                    if (w = w + 1 | 0, (w | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (e = (f << 1) + A | 0, u = (Z(f, n) << 1) + t | 0, s = 0, !_) for(; Q[e >> 1] = I[u >> 1], h = e, e = r << 1, h = h + e | 0, Q[h >> 1] = I[u + 2 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 4 >> 1], h = e + h | 0, Q[h >> 1] = I[u + 6 >> 1], e = e + h | 0, u = u + 8 | 0, s = s + 4 | 0, (v | 0) != (s | 0););
                                    if (s = 0, w) for(; Q[e >> 1] = I[u >> 1], u = u + 2 | 0, e = (r << 1) + e | 0, s = s + 1 | 0, (w | 0) != (s | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function im(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            s = i[r + 24 >> 2], s >>> 0 > k0[r + 44 >> 2] && (i[r + 44 >> 2] = s), s = -1, _ = -1, h = n & 24;
                            i: {
                                if (!h | (k | 0) == 1 & (h | 0) == 24) break i;
                                h = i[r + 44 >> 2], h && (t = r + 32 | 0, l[t + 11 | 0] >>> 7 | 0 && (t = i[t >> 2]), t = h - t | 0, w = t >> 31);
                                e: {
                                    r: switch(k | 0){
                                        case 1:
                                            if (n & 8) {
                                                u = i[r + 12 >> 2] - i[r + 8 >> 2] | 0, v = u >> 31;
                                                break e;
                                            }
                                            u = i[r + 24 >> 2] - i[r + 20 >> 2] | 0, v = u >> 31;
                                            break e;
                                        case 0:
                                            break e;
                                        case 2:
                                            break r;
                                        default:
                                            break i;
                                    }
                                    u = t, v = w;
                                }
                                if (f = f + v | 0, e = e + u | 0, f = u >>> 0 > e >>> 0 ? f + 1 | 0 : f, (f | 0) < 0 | (e >>> 0 > t >>> 0 & (f | 0) >= (w | 0) | (f | 0) > (w | 0))) break i;
                                k = n & 8;
                                e: {
                                    if (!(e | f)) break e;
                                    if (!i[r + 12 >> 2] && k) break i;
                                    if (!(n & 16)) break e;
                                    if (!i[r + 24 >> 2]) break i;
                                }
                                k && (k = i[r + 8 >> 2], i[r + 16 >> 2] = i[r + 44 >> 2], i[r + 12 >> 2] = e + k, i[r + 8 >> 2] = k), n & 16 && (k = i[r + 20 >> 2], i[r + 28 >> 2] = i[r + 28 >> 2], i[r + 20 >> 2] = k, i[r + 24 >> 2] = k, i[r + 24 >> 2] = e + i[r + 24 >> 2]), s = e, _ = f;
                            }
                            i[A + 8 >> 2] = s, i[A + 12 >> 2] = _, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function em(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (n = m - 32 | 0, m = n, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 108 >> 2] - i[r + 104 >> 2] >> 4), f = i[r + 104 >> 2], u = i[r + 108 >> 2], (f | 0) != (u | 0)) for(;;){
                                k = i[f >> 2];
                                i: {
                                    if (!l[r + 97 | 0]) {
                                        w2(e, k & 65535);
                                        break i;
                                    }
                                    l2(e, k);
                                }
                                if (f2(e, i[f + 8 >> 2] - i[f + 4 >> 2] >>> 2 & 255), k = i[f + 4 >> 2], s = i[f + 8 >> 2], (k | 0) != (s | 0)) for(;;){
                                    h = I[k + 2 >> 1], w = l[k | 0];
                                    i: {
                                        if (o[r + 100 | 0] & 1) {
                                            w2(e, (h & 32767 | (w & 1 ? -32768 : 0)) & 65535);
                                            break i;
                                        }
                                        f2(e, (h & 127 | (w & 1 ? -128 : 0)) & 255);
                                    }
                                    if (k = k + 4 | 0, (s | 0) == (k | 0)) break;
                                }
                                if (f = f + 16 | 0, (u | 0) == (f | 0)) break;
                            }
                            i[e + 12 >> 2] = t, p[i[i[r >> 2] + 48 >> 2]](n + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + t | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function rm(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            k = m - 16 | 0, m = k, f = i[r + 12 >> 2], A = i[r + 4 >> 2], w = (f + A | 0) - 1 | 0, n = (w | 0) % (f | 0) | 0, t = (f + ((A | 0) / l[e + 50 | 0] | 0) | 0) - 1 | 0, u = (t | 0) % (f | 0) | 0, s = i[r + 8 >> 2], h = (s | 0) / l[e + 51 | 0] | 0;
                            i: {
                                e: {
                                    r: {
                                        if (A = l[e + 48 | 0], (A - 8 & 255) >>> 0 < 9) {
                                            if (f = l[e + 49 | 0], (f - 8 & 255) >>> 0 >= 9) break r;
                                            if (r = 0, i[k + 4 >> 2] = 0, v = s, s = w - n | 0, A = Me(k + 4 | 0, 16, Z(Z(v, s), (A + 7 & 248) >>> 3 | 0)), n = A ? 0 : i[k + 4 >> 2], !i[e + 20 >> 2]) {
                                                if (h = 0, u = 0, !n) break i;
                                                break e;
                                            }
                                            if (i[k + 8 >> 2] = 0, u = t - u | 0, A = Z(Z(h, u), (f + 7 & 248) >>> 3 | 0), f = Me(k + 8 | 0, 16, A), r = i[k + 8 >> 2], i[k + 12 >> 2] = 0, A = Me(k + 12 | 0, 16, A), h = i[k + 12 >> 2], t = A ? 0 : h, A = f ? 0 : r, !(!n || !A | !t)) break e;
                                            if (n && X(n), A && X(A), r = 0, !t) break i;
                                            X(t);
                                            break i;
                                        }
                                        y0(17593, 15041, 117, 6090), z();
                                    }
                                    y0(17639, 15041, 118, 6090), z();
                                }
                                i[e + 292 >> 2] = 0, i[e + 4 >> 2] = n, i[e + 40 >> 2] = s, i[e + 8 >> 2] = r, i[e + 296 >> 2] = 0, i[e + 300 >> 2] = 0, i[e + 12 >> 2] = h, i[e + 44 >> 2] = u, r = 1;
                            }
                            return m = k + 16 | 0, r | 0;
                        }
                        function Am(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            t = m - 32 | 0, m = t, u = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, k = +(1 << i[r + 152 >> 2] >>> 0), n = n0[r + 104 >> 3] * k;
                            i: {
                                if (r2(n) < 2147483648) {
                                    f = ~~n;
                                    break i;
                                }
                                f = -2147483648;
                            }
                            l2(e, f), n = n0[r + 112 >> 3] * k;
                            i: {
                                if (r2(n) < 2147483648) {
                                    f = ~~n;
                                    break i;
                                }
                                f = -2147483648;
                            }
                            l2(e, f), n = n0[r + 120 >> 3] * k;
                            i: {
                                if (r2(n) < 2147483648) {
                                    f = ~~n;
                                    break i;
                                }
                                f = -2147483648;
                            }
                            if (l2(e, f), o[r + 100 | 0] & 1) {
                                k = n0[r + 136 >> 3] * k;
                                i: {
                                    if (r2(k) < 2147483648) {
                                        f = ~~k;
                                        break i;
                                    }
                                    f = -2147483648;
                                }
                                l2(e, f), k = n0[r + 144 >> 3] * +(1 << i[r + 156 >> 2] >>> 0);
                                i: {
                                    if (r2(k) < 2147483648) {
                                        f = ~~k;
                                        break i;
                                    }
                                    f = -2147483648;
                                }
                                l2(e, f);
                            }
                            i[e + 12 >> 2] = u, p[i[i[r >> 2] + 48 >> 2]](t + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + u | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = t + 32 | 0;
                        }
                        function fm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            e = m - 96 | 0, m = e;
                            i: {
                                e: {
                                    r: {
                                        if (i[A + 16 >> 2] != i[r + 16 >> 2]) break r;
                                        i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 80 >> 2] = 0, i[e + 84 >> 2] = 0, i[e + 72 >> 2] = 0, i[e + 76 >> 2] = 0, i[e + 64 >> 2] = 0, i[e + 68 >> 2] = 0, p[i[i[A >> 2] + 16 >> 2]](e + 44 | 0, A, e + 80 | 0), o[e + 63 | 0] < 0 && X(i[e + 52 >> 2]), p[i[i[r >> 2] + 16 >> 2]](e + 24 | 0, r, e - -64 | 0), o[e + 43 | 0] < 0 && X(i[e + 32 >> 2]), i[e + 20 >> 2] = 0, i[e + 12 >> 2] = 0, i[e + 16 >> 2] = 0, A = i[e + 84 >> 2], f = i[e + 80 >> 2];
                                        A: {
                                            if ((A | 0) == (f | 0)) {
                                                r = 0, f = 0;
                                                break A;
                                            }
                                            if (A = A - f | 0, (A | 0) < 0) break e;
                                            r = D(A), f = v0(r, f, A) + A | 0;
                                        }
                                        i[e + 8 >> 2] = 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, A = i[e + 68 >> 2], k = i[e + 64 >> 2];
                                        A: {
                                            if ((A | 0) == (k | 0)) {
                                                A = 0;
                                                break A;
                                            }
                                            if (n = A - k | 0, (n | 0) < 0) break i;
                                            A = D(n), n = v0(A, k, n) + n | 0;
                                        }
                                        if (k = 0, f = f - r | 0, (f | 0) == (n - A | 0) && (k = !O2(r, A, f)), A && X(A), r && X(r), A = i[e + 64 >> 2], A && (i[e + 68 >> 2] = A, X(A)), A = i[e + 80 >> 2], !A) break r;
                                        i[e + 84 >> 2] = A, X(A);
                                    }
                                    return m = e + 96 | 0, k | 0;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function km(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            i: {
                                if (n = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, k = i[n >> 2], !k) break i;
                                for(;;){
                                    if (d1(i[k + 4 >> 2], e)) {
                                        if (k = i[n + 4 >> 2], n = n + 4 | 0, k) continue;
                                        break i;
                                    }
                                    break;
                                }
                                e: switch(i[k + 8 >> 2] - 1 | 0){
                                    case 0:
                                        for(k = A, n = r, t = e; A = f, f = f + 1 | 0, r = o[A | 0], !!((r | 0) == 32 | r - 9 >>> 0 < 5););
                                        e = 1;
                                        r: switch((r & 255) - 43 | 0){
                                            case 2:
                                                e = 0;
                                            case 0:
                                                r = o[f | 0], A = f;
                                                break;
                                            default:
                                                break r;
                                        }
                                        if (f = 0, r = r - 48 | 0, r >>> 0 <= 9) for(; f = Z(f, 10) - r | 0, r = o[A + 1 | 0], A = A + 1 | 0, r = r - 48 | 0, r >>> 0 < 10;);
                                        vn(k, n, t, e ? 0 - f | 0 : f);
                                        return;
                                    case 1:
                                        k = 1;
                                        r: {
                                            if (!d1(f, 9769) || (k = 0, !d1(f, 10076) | l[f | 0] != 49)) break r;
                                            k = !l[f + 1 | 0];
                                        }
                                        p[i[i[r >> 2] + 80 >> 2]](A, i[r + 4 >> 2], e, k);
                                        return;
                                    case 2:
                                        p[i[i[r >> 2] + 88 >> 2]](A, i[r + 4 >> 2], e, f);
                                        return;
                                    default:
                                        break e;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                return;
                            }
                            p[i[i[r >> 2] + 88 >> 2]](A, i[r + 4 >> 2], e, f);
                        }
                        function nm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            n = m - 32 | 0, m = n, a7(A, r);
                            i: {
                                if (i[A >> 2]) break i;
                                if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f = i[r + 104 >> 2], u = i[r + 108 >> 2], (f | 0) != (u | 0)) for(k = l[r + 97 | 0], s = k ? 4 : 2, w = k ? 2 : 1;;){
                                    if (l2(e, ((i[f + 48 >> 2] - i[f + 44 >> 2] >> 2) + 1 << w) + 10 | 0), l2(e, i[f + 16 >> 2]), l1(e, s, i[f + 40 >> 2], 0), w2(e, i[f + 48 >> 2] - i[f + 44 >> 2] >>> 2 & 65535), k = i[f + 44 >> 2], h = i[f + 48 >> 2], (k | 0) != (h | 0)) for(; l1(e, s, i[k >> 2], 0), k = k + 4 | 0, (h | 0) != (k | 0););
                                    if (f = f + 56 | 0, (u | 0) == (f | 0)) break;
                                }
                                if (i[e + 12 >> 2] = t, p[i[i[r >> 2] + 48 >> 2]](n + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + t | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function tm(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0;
                            for(u = m - 416 | 0, m = u, f = u + 416 | 0, i[u + 12 >> 2] = f, e = m - 144 | 0, m = e, i[e + 28 >> 2] = e + 132, s = e + 32 | 0, K9(A + 8 | 0, s, e + 28 | 0, k, n, t), i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, i[e + 12 >> 2] = s, k = u + 16 | 0, t = i[u + 12 >> 2] - k >> 2, n = m - 16 | 0, m = n, i[n + 12 >> 2] = i[A + 8 >> 2], A = j4(n + 8 | 0, n + 12 | 0), t = t5(k, e + 12 | 0, t, e + 16 | 0), A = i[A >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = n + 16 | 0, (t | 0) == -1 && (w1(), z()), i[u + 12 >> 2] = k + (t << 2), m = e + 144 | 0, t = m - 16 | 0, m = t, A = m - 32 | 0, m = A, lr(A + 24 | 0, k, i[u + 12 >> 2]), u = A + 16 | 0, s = i[A + 28 >> 2], e = m - 16 | 0, m = e, n = i[A + 24 >> 2], i[e + 8 >> 2] = n, i[e + 12 >> 2] = r;;){
                                if ((n | 0) != (s | 0)) {
                                    At(e + 12 | 0, i[n >> 2]), n = n + 4 | 0, i[e + 8 >> 2] = n;
                                    continue;
                                }
                                break;
                            }
                            return i[u >> 2] = i[e + 8 >> 2], i[u + 4 >> 2] = i[e + 12 >> 2], m = e + 16 | 0, i[A + 12 >> 2] = k + (i[A + 16 >> 2] - k | 0), i[A + 8 >> 2] = i[A + 20 >> 2], i[t + 8 >> 2] = i[A + 12 >> 2], i[t + 12 >> 2] = i[A + 8 >> 2], m = A + 32 | 0, m = t + 16 | 0, m = f, i[t + 12 >> 2];
                        }
                        function b5(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (e = i[A + 8 >> 2], !!e) {
                                if (r = i[A + 4 >> 2], (r | 0) == 6) {
                                    r = i[e + 24 >> 2];
                                    i: {
                                        if ((r | 0) < i[e + 28 >> 2]) {
                                            f = i[e + 20 >> 2];
                                            break i;
                                        }
                                        if (n = r + 1 | 0, f = Q2(n), !f) return;
                                        k = i[e + 20 >> 2], k && (v0(f, k, r), X(k), r = i[e + 24 >> 2]), i[e + 28 >> 2] = n, i[e + 20 >> 2] = f;
                                    }
                                    o[r + f | 0] = 0, i[e + 24 >> 2] = i[e + 24 >> 2] + 1, r = i[A + 4 >> 2];
                                }
                                if ((r | 0) == 7) {
                                    f = i[e + 24 >> 2], k = f + 2 | 0;
                                    i: {
                                        if ((k | 0) <= i[e + 28 >> 2]) {
                                            r = i[e + 20 >> 2];
                                            break i;
                                        }
                                        if (r = Q2(k), !r) return;
                                        n = i[e + 20 >> 2], n && (v0(r, n, f), X(n), f = i[e + 24 >> 2]), i[e + 28 >> 2] = k, i[e + 20 >> 2] = r;
                                    }
                                    r = r + f | 0, o[r | 0] = 0, o[r + 1 | 0] = 0, i[e + 24 >> 2] = i[e + 24 >> 2] + 2, r = i[A + 4 >> 2];
                                }
                                (r | 0) >= 5 && (k = i[A + 32 >> 2], f = k + i[A + 28 >> 2] | 0, n = i[A + 20 >> 2], r = i[A + 16 >> 2], (f | 0) == (((r | 0) != (n | 0) ? (n - r << 8) - 1 | 0 : 0) | 0) && (me(A + 12 | 0), k = i[A + 32 >> 2], f = k + i[A + 28 >> 2] | 0, r = i[A + 16 >> 2]), i[i[r + (f >>> 8 & 16777212) >> 2] + ((f & 1023) << 2) >> 2] = e, i[A + 32 >> 2] = k + 1, r = i[e + 24 >> 2], i[A + 8 >> 2] = 0, i[A + 36 >> 2] = r + i[A + 36 >> 2]), i[A + 4 >> 2] = 0;
                            }
                        }
                        function d5() {
                            ih(72396, 12812), cs(72420, 8021, 1, 0), s8(72432, 6412, 1, -128, 127), s8(72456, 6405, 1, -128, 127), s8(72444, 6403, 1, 0, 255), s8(72468, 3310, 2, -32768, 32767), s8(72480, 3301, 2, 0, 65535), s8(72492, 3325, 4, -2147483648, 2147483647), s8(72504, 3316, 4, 0, -1), s8(72516, 9079, 4, -2147483648, 2147483647), s8(72528, 9070, 4, 0, -1), Ro(72540, 3883, -2147483648, 2147483647), Ro(72552, 3882, 0, -1), v7(72564, 3739, 4), v7(72576, 11084, 8), w7(79536, 9110), w7(51612, 17232), o3(51684, 4, 9084), o3(51760, 2, 9122), o3(51836, 4, 9137), ds(79636), H1(51876, 0, 17163), H1(51916, 0, 17265), H1(79744, 1, 17193), H1(51956, 2, 16728), H1(51996, 3, 16759), H1(52036, 4, 16799), H1(52076, 5, 16828), H1(52116, 4, 17302), H1(52156, 5, 17332), H1(51916, 0, 16930), H1(79744, 1, 16897), H1(51956, 2, 16996), H1(51996, 3, 16962), H1(52036, 4, 17130), H1(52076, 5, 17096), H1(52196, 8, 17063), H1(52236, 9, 17029), H1(52276, 6, 16866), H1(52316, 7, 17371);
                        }
                        function om(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(w = e - 3 | 0;;){
                                    for(s = (h << 1) + t | 0, e = w + Z(f, h) | 0, u = 0; Q[s >> 1] = (((((l[e + 1 | 0] << 2) - l[e | 0] | 0) + Z(l[e + 4 | 0] + l[e + 3 | 0] | 0, 40) | 0) + (l[e + 6 | 0] << 2) | 0) - l[e + 7 | 0] | 0) + Z(l[e + 5 | 0] + l[e + 2 | 0] | 0, -11), e = e + 1 | 0, s = (n << 1) + s | 0, u = u + 1 | 0, (u | 0) != (k | 0););
                                    if (h = h + 1 | 0, (h | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (s = (f << 1) + A | 0, e = (Z(f, n) << 1) + t | 0, h = 0, !_) for(; Q[s >> 1] = I[e >> 1], u = s, s = r << 1, u = u + s | 0, Q[u >> 1] = I[e + 2 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 4 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 6 >> 1], s = s + u | 0, e = e + 8 | 0, h = h + 4 | 0, (v | 0) != (h | 0););
                                    if (u = 0, w) for(; Q[s >> 1] = I[e >> 1], e = e + 2 | 0, s = (r << 1) + s | 0, u = u + 1 | 0, (w | 0) != (u | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function c5(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                if (!e | (!A | !r)) break i;
                                ae(n + 4 | 0, i[A >> 2]), t = i[n + 8 >> 2], A = i[n + 4 >> 2], f = t - A >> 3, f = (e | 0) > (f | 0) ? f : e;
                                e: {
                                    if ((f | 0) > 0) {
                                        if (e = 0, f >>> 0 >= 4) for(u = f & 2147483644; i[(e << 2) + r >> 2] = i[i[A + (e << 3) >> 2] + 36 >> 2], k = e | 1, i[(k << 2) + r >> 2] = i[i[A + (k << 3) >> 2] + 36 >> 2], k = e | 2, i[(k << 2) + r >> 2] = i[i[A + (k << 3) >> 2] + 36 >> 2], k = e | 3, i[(k << 2) + r >> 2] = i[i[A + (k << 3) >> 2] + 36 >> 2], e = e + 4 | 0, s = s + 4 | 0, (u | 0) != (s | 0););
                                        if (u = f & 3, !u) break e;
                                        for(; i[(e << 2) + r >> 2] = i[i[A + (e << 3) >> 2] + 36 >> 2], e = e + 1 | 0, h = h + 1 | 0, (u | 0) != (h | 0););
                                        break e;
                                    }
                                    if (!A) break i;
                                }
                                if ((A | 0) == (t | 0)) r = A;
                                else {
                                    for(;;){
                                        r = i[t - 4 >> 2];
                                        e: {
                                            if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break e;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (t = t - 8 | 0, (A | 0) == (t | 0)) break;
                                    }
                                    r = i[n + 4 >> 2];
                                }
                                i[n + 8 >> 2] = A, X(r);
                            }
                            return m = n + 16 | 0, f | 0;
                        }
                        function um(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(w = e - 2 | 0;;){
                                    for(s = (h << 1) + t | 0, e = w + Z(f, h) | 0, u = 0; Q[s >> 1] = (((((l[e | 0] + Z(l[e + 1 | 0], -5) | 0) + Z(l[e + 2 | 0], 17) | 0) + Z(l[e + 3 | 0], 58) | 0) + Z(l[e + 4 | 0], -10) | 0) + (l[e + 5 | 0] << 2) | 0) - l[e + 6 | 0], e = e + 1 | 0, s = (n << 1) + s | 0, u = u + 1 | 0, (u | 0) != (k | 0););
                                    if (h = h + 1 | 0, (h | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (s = (f << 1) + A | 0, e = (Z(f, n) << 1) + t | 0, h = 0, !_) for(; Q[s >> 1] = I[e >> 1], u = s, s = r << 1, u = u + s | 0, Q[u >> 1] = I[e + 2 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 4 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 6 >> 1], s = s + u | 0, e = e + 8 | 0, h = h + 4 | 0, (v | 0) != (h | 0););
                                    if (u = 0, w) for(; Q[s >> 1] = I[e >> 1], e = e + 2 | 0, s = (r << 1) + s | 0, u = u + 1 | 0, (w | 0) != (u | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function lm(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            i: {
                                if ((n | 0) <= 0 | (k | 0) <= 0) break i;
                                for(w = e - 3 | 0;;){
                                    for(s = (h << 1) + t | 0, e = w + Z(f, h) | 0, u = 0; Q[s >> 1] = l[e + 6 | 0] + ((((((l[e + 1 | 0] << 2) - l[e | 0] | 0) + Z(l[e + 2 | 0], -10) | 0) + Z(l[e + 3 | 0], 58) | 0) + Z(l[e + 4 | 0], 17) | 0) + Z(l[e + 5 | 0], -5) | 0), e = e + 1 | 0, s = (n << 1) + s | 0, u = u + 1 | 0, (u | 0) != (k | 0););
                                    if (h = h + 1 | 0, (h | 0) == (n | 0)) break;
                                }
                                if ((n | 0) <= 0) break i;
                                for(v = n & 2147483644, w = n & 3, f = 0, _ = n >>> 0 < 4;;){
                                    if (s = (f << 1) + A | 0, e = (Z(f, n) << 1) + t | 0, h = 0, !_) for(; Q[s >> 1] = I[e >> 1], u = s, s = r << 1, u = u + s | 0, Q[u >> 1] = I[e + 2 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 4 >> 1], u = s + u | 0, Q[u >> 1] = I[e + 6 >> 1], s = s + u | 0, e = e + 8 | 0, h = h + 4 | 0, (v | 0) != (h | 0););
                                    if (u = 0, w) for(; Q[s >> 1] = I[e >> 1], e = e + 2 | 0, s = (r << 1) + s | 0, u = u + 1 | 0, (w | 0) != (u | 0););
                                    if (f = f + 1 | 0, (k | 0) == (f | 0)) break;
                                }
                            }
                        }
                        function sm(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            t = m - 16 | 0, m = t;
                            i: {
                                if (!e) break i;
                                I5(t + 4 | 0, i[A >> 2], r), A = i[t + 8 >> 2], r = i[t + 4 >> 2], k = A - r >> 3, k = (f | 0) > (k | 0) ? k : f;
                                e: {
                                    if ((k | 0) > 0) {
                                        if (f = 0, k >>> 0 >= 4) for(u = k & 2147483644; i[(f << 2) + e >> 2] = i[i[r + (f << 3) >> 2] + 36 >> 2], n = f | 1, i[(n << 2) + e >> 2] = i[i[r + (n << 3) >> 2] + 36 >> 2], n = f | 2, i[(n << 2) + e >> 2] = i[i[r + (n << 3) >> 2] + 36 >> 2], n = f | 3, i[(n << 2) + e >> 2] = i[i[r + (n << 3) >> 2] + 36 >> 2], f = f + 4 | 0, s = s + 4 | 0, (u | 0) != (s | 0););
                                        if (u = k & 3, !u) break e;
                                        for(; i[(f << 2) + e >> 2] = i[i[r + (f << 3) >> 2] + 36 >> 2], f = f + 1 | 0, h = h + 1 | 0, (u | 0) != (h | 0););
                                        break e;
                                    }
                                    if (!r) break i;
                                }
                                if ((A | 0) == (r | 0)) A = r;
                                else {
                                    for(;;){
                                        e = i[A - 4 >> 2];
                                        e: {
                                            if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break e;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (A = A - 8 | 0, (r | 0) == (A | 0)) break;
                                    }
                                    A = i[t + 4 >> 2];
                                }
                                i[t + 8 >> 2] = r, X(A);
                            }
                            return m = t + 16 | 0, k | 0;
                        }
                        function hm(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            r = m + -64 | 0, m = r, o[r + 40 | 0] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, y3(r + 12 | 0, A, r + 44 | 0, 0, 0), o[r + 31 | 0] < 0 && X(i[r + 20 >> 2]), f = i[A + 480 >> 2], n = i[r + 52 >> 2], i[r + 52 >> 2] = 0, k = i[r + 36 >> 2], i[r + 36 >> 2] = 0, e = i[r + 32 >> 2], i[r + 32 >> 2] = 0, t = i[r + 44 >> 2], u = i[r + 48 >> 2], i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, s = i[r + 56 >> 2], h = l[r + 40 | 0], i[f + 4 >> 2] = e, e = i[f + 8 >> 2], i[f + 8 >> 2] = k;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            o[f + 12 | 0] = h, e = i[f + 16 >> 2], e && (i[f + 20 >> 2] = e, X(e)), i[f + 28 >> 2] = s, i[f + 24 >> 2] = n, i[f + 20 >> 2] = u, i[f + 16 >> 2] = t, A = i[A + 480 >> 2], f = p[i[i[A >> 2] + 12 >> 2]](A) | 0, A = i[r + 44 >> 2], A && (i[r + 48 >> 2] = A, X(A)), A = i[r + 36 >> 2];
                            i: {
                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = r - -64 | 0, f | 0;
                        }
                        function wm(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            r = m + -64 | 0, m = r, o[r + 40 | 0] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, y3(r + 12 | 0, A, r + 44 | 0, 0, 0), o[r + 31 | 0] < 0 && X(i[r + 20 >> 2]), f = i[A + 480 >> 2], n = i[r + 52 >> 2], i[r + 52 >> 2] = 0, k = i[r + 36 >> 2], i[r + 36 >> 2] = 0, e = i[r + 32 >> 2], i[r + 32 >> 2] = 0, t = i[r + 44 >> 2], u = i[r + 48 >> 2], i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, s = i[r + 56 >> 2], h = l[r + 40 | 0], i[f + 4 >> 2] = e, e = i[f + 8 >> 2], i[f + 8 >> 2] = k;
                            i: {
                                if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            o[f + 12 | 0] = h, e = i[f + 16 >> 2], e && (i[f + 20 >> 2] = e, X(e)), i[f + 28 >> 2] = s, i[f + 24 >> 2] = n, i[f + 20 >> 2] = u, i[f + 16 >> 2] = t, A = i[A + 480 >> 2], f = p[i[i[A >> 2] + 16 >> 2]](A) | 0, A = i[r + 44 >> 2], A && (i[r + 48 >> 2] = A, X(A)), A = i[r + 36 >> 2];
                            i: {
                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = r - -64 | 0, f | 0;
                        }
                        function vm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            f = m - 16 | 0, m = f, u = u7() | 0;
                            i: {
                                e: {
                                    if (!r) break e;
                                    if (ae(f, i[r >> 2]), k = i[f + 4 >> 2], n = i[f >> 2], n) {
                                        if (e = n, (k | 0) != (e | 0)) {
                                            for(e = k;;){
                                                t = i[e - 4 >> 2];
                                                r: {
                                                    if (!t || (s = i[t + 4 >> 2], i[t + 4 >> 2] = s - 1, s)) break r;
                                                    p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                                                }
                                                if (e = e - 8 | 0, (n | 0) == (e | 0)) break;
                                            }
                                            e = i[f >> 2];
                                        }
                                        i[f + 4 >> 2] = n, X(e);
                                    }
                                    if (e = k - n | 0, k = e >> 3, (k | 0) <= 0) break e;
                                    if (n = Q2(e >>> 1 | 0), n) {
                                        k = c5(r, n, k);
                                        r: {
                                            if (!k || (e = 0, (k | 0) <= 0)) break r;
                                            for(; i[f >> 2] = e, r = U1(72492, f | 0) | 0, i[f >> 2] = i[n + (e << 2) >> 2], t = U1(72504, f | 0) | 0, y4(u | 0, r | 0, t | 0), t >>> 0 >= 9 && t1(t | 0), r >>> 0 >= 9 && t1(r | 0), e = e + 1 | 0, (k | 0) != (e | 0););
                                        }
                                        X(n);
                                        break e;
                                    }
                                    if (r = D(12), i[r >> 2] = 6, i[r + 4 >> 2] = 1e3, i[f >> 2] = r, h = A, w = U1(79596, f | 0) | 0, i[h + 4 >> 2] = w, i[A >> 2] = 104328, u >>> 0 < 9) break i;
                                    t1(u | 0);
                                    break i;
                                }
                                i[A + 4 >> 2] = u, i[A >> 2] = 104328;
                            }
                            m = f + 16 | 0;
                        }
                        function en(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (!e) {
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                return;
                            }
                            i: {
                                if (f = i[r + 16 >> 2], !f || (n = E0(f, 78492, 79120), !n)) break i;
                                f = i[r + 20 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), r = i[n + 12 >> 2], n = i[n + 8 >> 2], s = r - n | 0, t = s >> 3;
                                e: {
                                    if ((t | 0) <= 0) break e;
                                    if (r = 0, (s | 0) != 8) for(w = t & 2147483646, t = 0; k = r << 3, u = k + e | 0, h = n + k | 0, i[u >> 2] = i[h >> 2], i[u + 4 >> 2] = i[h + 4 >> 2], k = k | 8, u = k + e | 0, k = n + k | 0, i[u >> 2] = i[k >> 2], i[u + 4 >> 2] = i[k + 4 >> 2], r = r + 2 | 0, t = t + 2 | 0, (w | 0) != (t | 0););
                                    if (!(s & 8)) break e;
                                    r = r << 3, e = r + e | 0, r = r + n | 0, i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = i[r + 4 >> 2];
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                e: {
                                    if (!f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                }
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function rn(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (r = i[A + 428 >> 2], e = i[A + 424 >> 2], (r | 0) != (e | 0)) for(;;){
                                if (k = i[(f << 2) + e >> 2], k) {
                                    if (w4(i[k + 140 >> 2] + 548 | 0, i[k >> 2]), r = i[k + 132 >> 2], r) {
                                        if (n = r - 4 | 0, e = i[n >> 2], e) for(e = r + Z(e, 18608) | 0; C8(e - 36 | 0), e = e - 18608 | 0, (r | 0) != (e | 0););
                                        X(n);
                                    }
                                    X(k), e = i[A + 424 >> 2], r = i[A + 428 >> 2];
                                }
                                if (f = f + 1 | 0, !(f >>> 0 < r - e >> 2 >>> 0)) break;
                            }
                            if (r = i[A + 456 >> 2], f = i[A + 460 >> 2], (r | 0) != (f | 0)) for(e = 0; k = i[(e << 2) + r >> 2], k && (p[i[i[k >> 2] + 4 >> 2]](k), f = i[A + 460 >> 2], r = i[A + 456 >> 2]), e = e + 1 | 0, e >>> 0 < f - r >> 2 >>> 0;);
                            if (f = i[A + 468 >> 2], f) {
                                if (r = f, e = i[A + 472 >> 2], (r | 0) != (e | 0)) {
                                    for(; e = C8(e - 8 | 0), (f | 0) != (e | 0););
                                    r = i[A + 468 >> 2];
                                }
                                i[A + 472 >> 2] = f, X(r), r = i[A + 456 >> 2];
                            }
                            return r && (i[A + 460 >> 2] = r, X(r)), r = i[A + 436 >> 2], r && (i[A + 440 >> 2] = r, X(r)), r = i[A + 424 >> 2], r && (i[A + 428 >> 2] = r, X(r)), K3(A + 8 | 0), A;
                        }
                        function _m() {
                            var A = 0, r = 0, e = 0;
                            return A = l[6174] | l[6175] << 8 | (l[6176] << 16 | l[6177] << 24), i[21716] = l[6170] | l[6171] << 8 | (l[6172] << 16 | l[6173] << 24), i[21717] = A, A = l[6188] | l[6189] << 8 | (l[6190] << 16 | l[6191] << 24), r = l[6184] | l[6185] << 8 | (l[6186] << 16 | l[6187] << 24), Q[43439] = r, Q[43440] = r >>> 16, Q[43441] = A, Q[43442] = A >>> 16, A = l[6182] | l[6183] << 8 | (l[6184] << 16 | l[6185] << 24), i[21718] = l[6178] | l[6179] << 8 | (l[6180] << 16 | l[6181] << 24), i[21719] = A, E2(17760) + 10 >>> 0 <= 79 && (A = E2(86864) + 86864 | 0, r = l[21841] | l[21842] << 8 | (l[21843] << 16 | l[21844] << 24), e = l[21837] | l[21838] << 8 | (l[21839] << 16 | l[21840] << 24), o[A | 0] = e, o[A + 1 | 0] = e >>> 8, o[A + 2 | 0] = e >>> 16, o[A + 3 | 0] = e >>> 24, o[A + 4 | 0] = r, o[A + 5 | 0] = r >>> 8, o[A + 6 | 0] = r >>> 16, o[A + 7 | 0] = r >>> 24, r = l[21844] | l[21845] << 8 | (l[21846] << 16 | l[21847] << 24), o[A + 7 | 0] = r, o[A + 8 | 0] = r >>> 8, o[A + 9 | 0] = r >>> 16, o[A + 10 | 0] = r >>> 24, p6(E2(86864) + 86864 | 0, 17760)), 86864;
                        }
                        function Bm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f, A = i[A >> 2], n = i[A + 48 >> 2], k = i[A + 52 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[f + 28 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0, F4(f, n, r, f + 20 | 0);
                            i: {
                                if (i[f >> 2] | !e || (r = e - 1 | 0, A = i[f + 20 >> 2], r >>> 0 >= i[f + 24 >> 2] - A >> 3 >>> 0)) break i;
                                if (A = A + (r << 3) | 0, r = i[A >> 2], A = i[A + 4 >> 2], !A) {
                                    t = i[r + 16 >> 2];
                                    break i;
                                }
                                if (e = i[A + 4 >> 2], n = e + 1 | 0, i[A + 4 >> 2] = n, t = i[r + 16 >> 2], i[A + 4 >> 2] = e, n) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            if (o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), r = i[f + 20 >> 2], r) {
                                if (A = r, e = i[f + 24 >> 2], (A | 0) != (e | 0)) {
                                    for(;;){
                                        A = i[e - 4 >> 2];
                                        i: {
                                            if (!A || (n = i[A + 4 >> 2], i[A + 4 >> 2] = n - 1, n)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (e = e - 8 | 0, (r | 0) == (e | 0)) break;
                                    }
                                    A = i[f + 20 >> 2];
                                }
                                i[f + 24 >> 2] = r, X(A);
                            }
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            return m = f + 32 | 0, t | 0;
                        }
                        function An(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            s = m - 32 | 0, m = s;
                            i: {
                                e: {
                                    r: {
                                        if ((r | 0) != (e | 0)) {
                                            if (w = i[26064], i[26064] = 0, t = m - 16 | 0, m = t, L2(), n = m - 16 | 0, m = n, k = m - 16 | 0, m = k, mA(k, r, s + 28 | 0, 2), u = i[k >> 2], h = i[k + 4 >> 2], r = n, n = i[k + 12 >> 2], i[r + 8 >> 2] = i[k + 8 >> 2], i[r + 12 >> 2] = n, i[r >> 2] = u, i[r + 4 >> 2] = h, m = k + 16 | 0, n = i[r >> 2], u = i[r + 4 >> 2], k = t, t = i[r + 12 >> 2], i[k + 8 >> 2] = i[r + 8 >> 2], i[k + 12 >> 2] = t, i[k >> 2] = n, i[k + 4 >> 2] = u, m = r + 16 | 0, t = i[k >> 2], n = i[k + 4 >> 2], u = i[k + 12 >> 2], r = s, i[r + 16 >> 2] = i[k + 8 >> 2], i[r + 20 >> 2] = u, i[r + 8 >> 2] = t, i[r + 12 >> 2] = n, m = k + 16 | 0, k = i[r + 16 >> 2], n = i[r + 20 >> 2], t = i[r + 8 >> 2], u = i[r + 12 >> 2], h = i[26064], !h) break r;
                                            if (i[r + 28 >> 2] != (e | 0)) break e;
                                            if (v = t, _ = u, B = k, G = n, (h | 0) != 68) break i;
                                            break e;
                                        }
                                        i[f >> 2] = 4;
                                        break i;
                                    }
                                    if (i[26064] = w, i[s + 28 >> 2] == (e | 0)) break i;
                                }
                                i[f >> 2] = 4, t = v, u = _, k = B, n = G;
                            }
                            i[A >> 2] = t, i[A + 4 >> 2] = u, i[A + 8 >> 2] = k, i[A + 12 >> 2] = n, m = s + 32 | 0;
                        }
                        function mm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            k = m - 32 | 0, m = k, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f = l[r + 97 | 0];
                            i: {
                                if (f >>> 0 <= 1 && (w2(e, I[r + 104 >> 1]), w2(e, I[r + 108 >> 1]), R4(e, r + 116 | 0), R4(e, r + 128 | 0), R4(e, r + 140 | 0), f = l[r + 97 | 0], f >>> 0 < 2)) break i;
                                e: {
                                    r: switch(f - 2 | 0){
                                        case 0:
                                            w2(e, I[r + 104 >> 1]);
                                            break e;
                                        case 1:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    l2(e, i[r + 104 >> 2]);
                                }
                                if (w2(e, I[r + 108 >> 1]), l2(e, i[r + 112 >> 2]), R4(e, r + 116 | 0), f = i[r + 112 >> 2], (f | 0) == 1970432288) f = 152;
                                else {
                                    if ((f | 0) != 1835625829) break i;
                                    R4(e, r + 128 | 0), f = 140;
                                }
                                R4(e, f + r | 0);
                            }
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](k + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 32 | 0;
                        }
                        function M3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            u = m - 32 | 0, m = u, t = D(152), i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0, i[t >> 2] = 78332, h = r, w = Ye(t + 12 | 0), i[h + 48 >> 2] = w, n = i[r + 52 >> 2], i[r + 52 >> 2] = t;
                            i: {
                                if (!n || (t = i[n + 4 >> 2], i[n + 4 >> 2] = t - 1, t)) break i;
                                p[i[i[n >> 2] + 8 >> 2]](n), g(n);
                            }
                            s = i[r + 48 >> 2], i[s + 136 >> 2] = r - -64, t = m - 16 | 0, m = t, n = D(72), i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0, i[n >> 2] = 78588, e = ZA(n + 16 | 0, e, f, k), i[t + 12 >> 2] = n, i[t + 8 >> 2] = e, i[n + 4 >> 2] = i[n + 4 >> 2] + 1, s3(u + 8 | 0, s, t + 8 | 0), e = i[t + 12 >> 2];
                            i: {
                                if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            e = i[n + 4 >> 2], i[n + 4 >> 2] = e - 1, e || (p[i[i[n >> 2] + 8 >> 2]](n), g(n)), m = t + 16 | 0;
                            i: {
                                if (i[u + 8 >> 2]) {
                                    r = i[u + 12 >> 2], i[A >> 2] = i[u + 8 >> 2], i[A + 4 >> 2] = r, r = i[u + 20 >> 2], i[A + 8 >> 2] = i[u + 16 >> 2], i[A + 12 >> 2] = r, i[A + 16 >> 2] = i[u + 24 >> 2];
                                    break i;
                                }
                                if (l3(A, r), o[u + 27 | 0] >= 0) break i;
                                X(i[u + 16 >> 2]);
                            }
                            m = u + 32 | 0;
                        }
                        function U3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            i: {
                                if (e = i[A >> 2], k = (i[A + 4 >> 2] - e | 0) / 12 | 0, t = k + 1 | 0, t >>> 0 < 357913942) {
                                    if (f = (i[A + 8 >> 2] - e | 0) / 12 | 0, e = f << 1, e = f >>> 0 >= 178956970 ? 357913941 : e >>> 0 > t >>> 0 ? e : t, e) {
                                        if (e >>> 0 >= 357913942) break i;
                                        u = D(Z(e, 12));
                                    }
                                    f = Z(k, 12) + u | 0, i[f >> 2] = i[r >> 2], i[f + 4 >> 2] = i[r + 4 >> 2], i[f + 8 >> 2] = i[r + 8 >> 2], i[r + 8 >> 2] = 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, t = Z(e, 12) + u | 0, s = f + 12 | 0, r = i[A + 4 >> 2], n = i[A >> 2];
                                    e: {
                                        if ((r | 0) == (n | 0)) {
                                            e = f;
                                            break e;
                                        }
                                        for(; u = f - 4 | 0, i[u >> 2] = 0, e = f - 12 | 0, k = r - 12 | 0, i[e >> 2] = i[k >> 2], i[f - 8 >> 2] = i[r - 8 >> 2], r = r - 4 | 0, i[u >> 2] = i[r >> 2], i[r >> 2] = 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, f = e, r = k, (n | 0) != (r | 0););
                                        r = i[A + 4 >> 2], n = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = s, i[A >> 2] = e, i[A + 8 >> 2] = t, (r | 0) != (n | 0)) for(; A = r - 12 | 0, e = i[A >> 2], e && (i[r - 8 >> 2] = e, X(e)), r = A, (n | 0) != (r | 0););
                                    return n && X(n), s;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function Zm(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (!f) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 20688;
                                    break i;
                                }
                                k = i[r >> 2], t = i[k + 80 >> 2], k = i[k + 84 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                e: {
                                    if (i[t + 36 >> 2] != (e | 0)) {
                                        if (i[f >> 2] = 0, o[n | 0] = 0, o[n + 11 | 0] = 0, e = i0(n + 12 | 0, 5, 2e3, n), o[n + 11 | 0] < 0 && X(i[n >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    e = D(16), i[e + 8 >> 2] = 0, i[e + 12 >> 2] = 0, i[f >> 2] = e, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), i[e + 4 >> 2] = k, i[e >> 2] = t, e = i[r + 8 >> 2], f = i[f >> 2], t = i[r + 12 >> 2], t && (i[t + 4 >> 2] = i[t + 4 >> 2] + 1), i[f + 8 >> 2] = e, e = i[f + 12 >> 2], i[f + 12 >> 2] = t;
                                    r: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    e = A, A = i[r >> 2], j0(e, 86672, A ? A + 4 | 0 : 0);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = n + 32 | 0;
                        }
                        function fn(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            i: {
                                e: {
                                    if (n = i[A + 20 >> 2], r = i[A + 24 >> 2], (n | 0) != (r | 0)) {
                                        if (f = r - n | 0, e = f >> 2, e >>> 0 < 2) break i;
                                        if (r = 1, k = e - 1 | 0, v = k & 1, e = i[i[n >> 2] + 96 >> 2], (f | 0) == 8) {
                                            k = 0;
                                            break e;
                                        }
                                        for(s = k & -2, k = 0, f = 0; t = i[i[(r << 2) + n >> 2] + 96 >> 2], u = (t | 0) < (e | 0), h = r + 1 | 0, w = i[i[(h << 2) + n >> 2] + 96 >> 2], e = u ? t : e, t = (w | 0) < (e | 0), e = t ? w : e, k = t ? h : u ? r : k, r = r + 2 | 0, f = f + 2 | 0, (s | 0) != (f | 0););
                                        break e;
                                    }
                                    y0(20574, 15078, 147, 6113), z();
                                }
                                if (!v) break i;
                                k = i[i[(r << 2) + n >> 2] + 96 >> 2] < (e | 0) ? r : k;
                            }
                            f = i[A + 52 >> 2], e = f + i[A + 48 >> 2] | 0, u = i[A + 40 >> 2], r = i[A + 36 >> 2], (e | 0) == (((r | 0) != (u | 0) ? (u - r << 8) - 1 | 0 : 0) | 0) ? (me(A + 32 | 0), f = i[A + 52 >> 2], e = f + i[A + 48 >> 2] | 0, s = i[A + 36 >> 2]) : s = r, r = k << 2, i[i[s + (e >>> 8 & 16777212) >> 2] + ((e & 1023) << 2) >> 2] = i[r + n >> 2], i[A + 52 >> 2] = f + 1, i[r + i[A + 20 >> 2] >> 2] = i[i[A + 24 >> 2] - 4 >> 2], i[A + 24 >> 2] = i[A + 24 >> 2] - 4;
                        }
                        function Gm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            n = m - 32 | 0, m = n, f = i[A + 28 >> 2], i[n + 16 >> 2] = f, t = i[A + 20 >> 2], i[n + 28 >> 2] = e, i[n + 24 >> 2] = r, r = t - f | 0, i[n + 20 >> 2] = r, t = r + e | 0, s = 2;
                            i: {
                                e: {
                                    r = n + 16 | 0, f = t3(i[A + 60 >> 2], r | 0, 2, n + 12 | 0) | 0, f ? (i[26064] = f, f = -1) : f = 0;
                                    r: {
                                        A: {
                                            if (f) {
                                                f = r;
                                                break A;
                                            }
                                            for(;;){
                                                if (k = i[n + 12 >> 2], (k | 0) == (t | 0)) break r;
                                                if ((k | 0) < 0) {
                                                    f = r;
                                                    break e;
                                                }
                                                if (u = i[r + 4 >> 2], h = u >>> 0 < k >>> 0, f = (h << 3) + r | 0, u = k - (h ? u : 0) | 0, i[f >> 2] = u + i[f >> 2], r = (h ? 12 : 4) + r | 0, i[r >> 2] = i[r >> 2] - u, t = t - k | 0, r = f, s = s - h | 0, k = t3(i[A + 60 >> 2], r | 0, s | 0, n + 12 | 0) | 0, k ? (i[26064] = k, k = -1) : k = 0, !!k) break;
                                            }
                                        }
                                        if ((t | 0) != -1) break e;
                                    }
                                    r = i[A + 44 >> 2], i[A + 28 >> 2] = r, i[A + 20 >> 2] = r, i[A + 16 >> 2] = r + i[A + 48 >> 2], A = e;
                                    break i;
                                }
                                if (i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A >> 2] = i[A >> 2] | 32, A = 0, (s | 0) == 2) break i;
                                A = e - i[f + 4 >> 2] | 0;
                            }
                            return m = n + 32 | 0, A | 0;
                        }
                        function M2(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            r = i[A + 112 >> 2], f = i[A + 116 >> 2], s = (r | f) != 0, u = r, k = i[A + 4 >> 2], n = i[A + 44 >> 2], r = k - n | 0, t = r, e = r + i[A + 120 >> 2] | 0, r = i[A + 124 >> 2] + (r >> 31) | 0;
                            i: {
                                if (r = e >>> 0 < t >>> 0 ? r + 1 | 0 : r, !(((r | 0) >= (f | 0) & e >>> 0 >= u >>> 0 | (r | 0) > (f | 0)) & s)) {
                                    if (s = nr(A), (s | 0) >= 0) break i;
                                    k = i[A + 4 >> 2], n = i[A + 44 >> 2];
                                }
                                return i[A + 112 >> 2] = -1, i[A + 116 >> 2] = -1, i[A + 104 >> 2] = k, t = e, e = n - k | 0, f = t + e | 0, r = (e >> 31) + r | 0, i[A + 120 >> 2] = f, i[A + 124 >> 2] = e >>> 0 > f >>> 0 ? r + 1 | 0 : r, -1;
                            }
                            f = e + 1 | 0, r = f ? r : r + 1 | 0, u = i[A + 4 >> 2], n = i[A + 8 >> 2], e = i[A + 116 >> 2], t = e, k = i[A + 112 >> 2];
                            i: {
                                if (!(e | k) || (e = k - f | 0, k = t - (r + (f >>> 0 > k >>> 0) | 0) | 0, h = n - u | 0, t = h >> 31, (k | 0) >= (t | 0) & e >>> 0 >= h >>> 0 | (k | 0) > (t | 0))) break i;
                                n = e + u | 0;
                            }
                            return i[A + 104 >> 2] = n, e = i[A + 44 >> 2], n = e - u | 0, f = n + f | 0, r = (n >> 31) + r | 0, i[A + 120 >> 2] = f, i[A + 124 >> 2] = f >>> 0 < n >>> 0 ? r + 1 | 0 : r, e >>> 0 >= u >>> 0 && (o[u - 1 | 0] = s), s;
                        }
                        function Wm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            i: {
                                if ((r | 0) < 12) break i;
                                if (e = kn(A + 8 | 0), (e & 27) - 1 >>> 0 < 2) return 14807;
                                if (e = e - 3 | 0, e >>> 0 >= 16 | !(50163 >>> e & 1)) break i;
                                return i[(e << 2) + 79964 >> 2];
                            }
                            e = 2;
                            i: {
                                if ((r | 0) < 12) break i;
                                e: {
                                    if (l[A | 0] != 255 | l[A + 1 | 0] != 216) break e;
                                    r: {
                                        if (l[A + 2 | 0] != 255 | l[A + 3 | 0] != 224 | (l[A + 4 | 0] | l[A + 5 | 0] != 16) || l[A + 6 | 0] != 74 | l[A + 7 | 0] != 70 | (l[A + 8 | 0] != 73 | l[A + 9 | 0] != 70) || l[A + 10 | 0]) break r;
                                        if (e = 1, l[A + 11 | 0] == 1) break i;
                                    }
                                    if (l[A + 2 | 0] != 255 | l[A + 3 | 0] != 225 | (l[A + 6 | 0] != 69 | l[A + 7 | 0] != 120) || l[A + 8 | 0] != 105 | l[A + 9 | 0] != 102 | (l[A + 10 | 0] | l[A + 11 | 0])) break e;
                                    e = 1;
                                    break i;
                                }
                                e = 0;
                            }
                            if ((e | 0) == 1) return 9263;
                            i: {
                                if (l[A | 0] != 137 | (r | 0) < 8 | (l[A + 1 | 0] != 80 | l[A + 2 | 0] != 78) || l[A + 3 | 0] != 71 | l[A + 4 | 0] != 13 | (l[A + 5 | 0] != 10 | l[A + 6 | 0] != 26) || l[A + 7 | 0] != 10) break i;
                                return 9060;
                            }
                            return 34896;
                        }
                        function Xm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (n = m - 32 | 0, m = n, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 104 >> 2]), l2(e, i[r + 112 >> 2] - i[r + 108 >> 2] >> 2), f = i[r + 108 >> 2], k = i[r + 112 >> 2], (f | 0) != (k | 0)) for(; l2(e, i[f >> 2]), f = f + 4 | 0, (k | 0) != (f | 0););
                            if (w2(e, I[r + 120 >> 1]), w2(e, I[r + 122 >> 1]), i[r + 112 >> 2] != i[r + 108 >> 2]) for(f = 0; k = i[r + 124 >> 2] + Z(f, 6) | 0, w2(e, I[k >> 1]), w2(e, I[k + 2 >> 1]), w2(e, I[k + 4 >> 1]), f = f + 1 | 0, f >>> 0 < i[r + 112 >> 2] - i[r + 108 >> 2] >> 2 >>> 0;);
                            i[e + 12 >> 2] = t, p[i[i[r >> 2] + 48 >> 2]](n + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + t | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = n + 32 | 0;
                        }
                        function kn(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            r = m - 16 | 0, m = r;
                            i: {
                                if (!A || (f = l[A | 0], !f) || (k = l[A + 1 | 0], !k) || (n = l[A + 2 | 0], !n) || (A = l[A + 3 | 0], !A)) break i;
                                if (o[r + 15 | 0] = 0, o[r + 14 | 0] = A, o[r + 13 | 0] = n, o[r + 12 | 0] = k, o[r + 11 | 0] = f, !O2(r + 11 | 0, 14813, 5)) {
                                    e = 1;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 2704, 5)) {
                                    e = 2;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 14673, 5)) {
                                    e = 3;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 1646, 5)) {
                                    e = 4;
                                    break i;
                                }
                                if (e = 5, A = r + 11 | 0, !O2(A, 7618, 5)) break i;
                                if (!O2(A, 4419, 5)) {
                                    e = 6;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 7592, 5)) {
                                    e = 7;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 3891, 5)) {
                                    e = 8;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 18072, 5)) {
                                    e = 9;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 18067, 5)) {
                                    e = 10;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 9345, 5)) {
                                    e = 11;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 4414, 5)) {
                                    e = 12;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 14802, 5)) {
                                    e = 13;
                                    break i;
                                }
                                if (!O2(r + 11 | 0, 8719, 5)) {
                                    e = 17;
                                    break i;
                                }
                                e = O2(r + 11 | 0, 4430, 5) ? 0 : 18;
                            }
                            return m = r + 16 | 0, e;
                        }
                        function pm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = m - 32 | 0, m = f, A = B0(A, 0, 72), i[A + 4 >> 2] = I[r + 374 >> 1], i[A + 8 >> 2] = I[r + 372 >> 1], i[A + 20 >> 2] = i[r + 376 >> 2], i[A + 24 >> 2] = i[r + 380 >> 2], i[f + 28 >> 2] = 0, i[f + 20 >> 2] = 0, i[f + 24 >> 2] = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (k = i[r + 384 >> 2], e = i[r + 388 >> 2], t = (k | 0) == (e | 0), t) break A;
                                            if (e = e - k | 0, (e | 0) < 0) break i;
                                            if (n = D(e), i[f + 20 >> 2] = n, u = e + n | 0, i[f + 28 >> 2] = u, e = v0(n, k, e), i[f + 24 >> 2] = u, t || (e = i[e >> 2], !e)) break A;
                                            if (v4(f, i[r + 20 >> 2], e, 1), r = i[f + 4 >> 2], e = i[f >> 2], !e || (p[i[i[e >> 2] + 20 >> 2]](f, e), k = i[f >> 2], o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), k)) break r;
                                            i[A + 12 >> 2] = i[e + 40 >> 2], i[A + 16 >> 2] = i[e + 44 >> 2];
                                            break r;
                                        }
                                        i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0;
                                        break e;
                                    }
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                A = i[f + 20 >> 2], A && X(A), m = f + 32 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function m6(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0, B = 0;
                            w = m - 16 | 0, m = w, o[w + 15 | 0] = A;
                            i: {
                                e: {
                                    r: {
                                        if (v = i[f >> 2], (v | 0) != (e | 0) || (_ = 43, B = A & 255, (B | 0) != l[h + 24 | 0] && (_ = 45, l[h + 25 | 0] != (B | 0)))) break r;
                                        i[f >> 2] = v + 1, o[v | 0] = _;
                                        break e;
                                    }
                                    if (l[t + 11 | 0] >>> 7 | 0 ? t = i[t + 4 >> 2] : t = l[t + 11 | 0] & 127, !(!t | (A | 0) != (n | 0))) {
                                        if (A = 0, r = i[s >> 2], (r - u | 0) > 159) break i;
                                        A = i[k >> 2], i[s >> 2] = r + 4, i[r >> 2] = A;
                                        break e;
                                    }
                                    if (A = -1, n = $A(h, h + 26 | 0, w + 15 | 0) - h | 0, (n | 0) > 23) break i;
                                    r: {
                                        A: switch(r - 8 | 0){
                                            case 0:
                                            case 2:
                                                if ((r | 0) > (n | 0)) break r;
                                                break i;
                                            case 1:
                                                break r;
                                            default:
                                                break A;
                                        }
                                        if ((r | 0) != 16 | (n | 0) < 22) break r;
                                        if (r = i[f >> 2], (r | 0) == (e | 0) | (r - e | 0) > 2 | l[r - 1 | 0] != 48) break i;
                                        A = 0, i[k >> 2] = 0, i[f >> 2] = r + 1, o[r | 0] = l[n + 64960 | 0];
                                        break i;
                                    }
                                    A = i[f >> 2], i[f >> 2] = A + 1, o[A | 0] = l[n + 64960 | 0], i[k >> 2] = i[k >> 2] + 1, A = 0;
                                    break i;
                                }
                                A = 0, i[k >> 2] = 0;
                            }
                            return m = w + 16 | 0, A;
                        }
                        function nn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k, t = i[26106], i[r + 72 >> 2] <= 0 && KA(r), i[26106] = i[r + 136 >> 2];
                            i: {
                                e: {
                                    r: {
                                        if (A >>> 0 <= 127) {
                                            A: {
                                                if (i[r + 80 >> 2] == (A | 0) || (e = i[r + 20 >> 2], (e | 0) == i[r + 16 >> 2])) break A;
                                                i[r + 20 >> 2] = e + 1, o[e | 0] = A;
                                                break i;
                                            }
                                            f = m - 16 | 0, m = f, o[f + 15 | 0] = A, e = i[r + 16 >> 2];
                                            A: {
                                                if (!e) {
                                                    if (e = -1, gA(r)) break A;
                                                    e = i[r + 16 >> 2];
                                                }
                                                f: {
                                                    if (n = i[r + 20 >> 2], (e | 0) == (n | 0) || (e = A & 255, (e | 0) == i[r + 80 >> 2])) break f;
                                                    i[r + 20 >> 2] = n + 1, o[n | 0] = A;
                                                    break A;
                                                }
                                                if (e = -1, (p[i[r + 36 >> 2]](r, f + 15 | 0, 1) | 0) != 1) break A;
                                                e = l[f + 15 | 0];
                                            }
                                            m = f + 16 | 0, A = e;
                                            break r;
                                        }
                                        if (e = i[r + 20 >> 2], k0[r + 16 >> 2] > e + 4 >>> 0) {
                                            if (e = Wr(e, A), (e | 0) < 0) break e;
                                            i[r + 20 >> 2] = e + i[r + 20 >> 2];
                                            break r;
                                        }
                                        if (f = k + 12 | 0, e = Wr(f, A), (e | 0) < 0 || $e(f, e, r) >>> 0 < e >>> 0) break e;
                                    }
                                    if ((A | 0) != -1) break i;
                                }
                                i[r >> 2] = i[r >> 2] | 32, A = -1;
                            }
                            return i[26106] = t, m = k + 16 | 0, A;
                        }
                        function H3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if (n = i[r + 124 >> 2], u = r + 128 | 0, (n | 0) != (u | 0)) for(;;){
                                        s = i[i[n + 20 >> 2] + 104 >> 2];
                                        r: {
                                            if (f >>> 0 < k >>> 0) {
                                                i[f >> 2] = s, e = f + 4 | 0;
                                                break r;
                                            }
                                            if (e = f - t >> 2, r = e + 1 | 0, r >>> 0 >= 1073741824) break e;
                                            if (h = e << 2, e = k - t | 0, k = e >> 1, e = e >>> 0 >= 2147483644 ? 1073741823 : r >>> 0 < k >>> 0 ? k : r, e) {
                                                if (e >>> 0 >= 1073741824) break i;
                                                k = D(e << 2);
                                            } else k = 0;
                                            if (r = h + k | 0, i[r >> 2] = s, k = k + (e << 2) | 0, e = r + 4 | 0, (f | 0) != (t | 0)) for(; r = r - 4 | 0, f = f - 4 | 0, i[r >> 2] = i[f >> 2], (f | 0) != (t | 0););
                                            i[A + 8 >> 2] = k, i[A + 4 >> 2] = e, i[A >> 2] = r, t && X(t), t = r;
                                        }
                                        f = e, i[A + 4 >> 2] = f, e = i[n + 4 >> 2];
                                        r: {
                                            if (e) {
                                                for(;;)if (r = e, e = i[r >> 2], !e) break r;
                                            }
                                            for(; r = i[n + 8 >> 2], e = i[r >> 2] != (n | 0), n = r, !!e;);
                                        }
                                        if (n = r, (r | 0) == (u | 0)) break;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function P2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                if (f = i[A + 4 >> 2], n = i[A >> 2], u = f - n >> 3, k = u + 1 | 0, k >>> 0 < 536870912) {
                                    if (e = i[A + 8 >> 2] - n | 0, t = e >> 2, e = e >>> 0 >= 2147483640 ? 536870911 : k >>> 0 < t >>> 0 ? t : k, e) {
                                        if (e >>> 0 >= 536870912) break i;
                                        t = D(e << 3);
                                    } else t = 0;
                                    k = t + (u << 3) | 0, i[k >> 2] = i[r >> 2], r = i[r + 4 >> 2], i[k + 4 >> 2] = r, u = t + (e << 3) | 0, t = k + 8 | 0, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1, n = i[A >> 2], f = i[A + 4 >> 2]);
                                    e: {
                                        if ((f | 0) == (n | 0)) {
                                            r = k;
                                            break e;
                                        }
                                        for(; r = k - 8 | 0, e = f - 8 | 0, i[r >> 2] = i[e >> 2], i[k - 4 >> 2] = i[f - 4 >> 2], i[e >> 2] = 0, i[e + 4 >> 2] = 0, k = r, f = e, (e | 0) != (n | 0););
                                        f = i[A + 4 >> 2], n = i[A >> 2];
                                    }
                                    if (i[A + 4 >> 2] = t, i[A >> 2] = r, i[A + 8 >> 2] = u, (f | 0) != (n | 0)) for(;;){
                                        A = i[f - 4 >> 2];
                                        e: {
                                            if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break e;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (f = f - 8 | 0, (n | 0) == (f | 0)) break;
                                    }
                                    return n && X(n), t;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function Qm(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 7465);
                                    break i;
                                }
                                k = i[r + 100 >> 2] >>> 8 | 0, i[r + 152 >> 2] = k & 31, t = 1, n = +(1 << k >>> 0), u = r, s = +(n2(e) | 0) / n, n0[u + 104 >> 3] = s, u = r, s = +(n2(e) | 0) / n, n0[u + 112 >> 3] = s, u = r, s = +(n2(e) | 0) / n, n0[u + 120 >> 3] = s, k = i[r + 100 >> 2];
                                e: {
                                    if (k & 1) {
                                        k = k >>> 16 | 0, i[r + 156 >> 2] = k & 31, u = r, s = +(n2(e) | 0) / n, n0[u + 136 >> 3] = s, n = +(n2(e) | 0) / +(1 << k >>> 0);
                                        break e;
                                    }
                                    i[r + 136 >> 2] = 0, i[r + 140 >> 2] = 0, t = 0, n = 0;
                                }
                                if (n0[r + 144 >> 3] = n, o[r + 128 | 0] = t, l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function Z6(A, r, e, f, k, n, t, u, s, h) {
                            var w = 0, v = 0, _ = 0;
                            w = m - 16 | 0, m = w, i[w + 12 >> 2] = A;
                            i: {
                                e: {
                                    r: {
                                        if (v = i[f >> 2], (v | 0) != (e | 0) || (_ = 43, i[h + 96 >> 2] != (A | 0) && (_ = 45, i[h + 100 >> 2] != (A | 0)))) break r;
                                        i[f >> 2] = v + 1, o[v | 0] = _;
                                        break e;
                                    }
                                    if (l[t + 11 | 0] >>> 7 | 0 ? t = i[t + 4 >> 2] : t = l[t + 11 | 0] & 127, !(!t | (A | 0) != (n | 0))) {
                                        if (A = 0, r = i[s >> 2], (r - u | 0) > 159) break i;
                                        A = i[k >> 2], i[s >> 2] = r + 4, i[r >> 2] = A;
                                        break e;
                                    }
                                    if (A = -1, n = qA(h, h + 104 | 0, w + 12 | 0) - h >> 2, (n | 0) > 23) break i;
                                    r: {
                                        A: switch(r - 8 | 0){
                                            case 0:
                                            case 2:
                                                if ((r | 0) > (n | 0)) break r;
                                                break i;
                                            case 1:
                                                break r;
                                            default:
                                                break A;
                                        }
                                        if ((r | 0) != 16 | (n | 0) < 22) break r;
                                        if (r = i[f >> 2], (r | 0) == (e | 0) | (r - e | 0) > 2 | l[r - 1 | 0] != 48) break i;
                                        A = 0, i[k >> 2] = 0, i[f >> 2] = r + 1, o[r | 0] = l[n + 64960 | 0];
                                        break i;
                                    }
                                    A = i[f >> 2], i[f >> 2] = A + 1, o[A | 0] = l[n + 64960 | 0], i[k >> 2] = i[k >> 2] + 1, A = 0;
                                    break i;
                                }
                                A = 0, i[k >> 2] = 0;
                            }
                            return m = w + 16 | 0, A;
                        }
                        function f2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                if (e = i[A + 12 >> 2], u = i[A + 4 >> 2], n = i[A >> 2], s = u - n | 0, (e | 0) == (s | 0)) {
                                    k = i[A + 8 >> 2];
                                    e: {
                                        if (k >>> 0 > u >>> 0) {
                                            o[u | 0] = r, h = u + 1 | 0;
                                            break e;
                                        }
                                        if (t = e + 1 | 0, (t | 0) < 0) break i;
                                        f = k - n | 0, k = f << 1, t = f >>> 0 >= 1073741823 ? 2147483647 : k >>> 0 > t >>> 0 ? k : t, t ? k = D(t) : k = 0, f = e + k | 0, o[f | 0] = r, t = k + t | 0, h = f + 1 | 0;
                                        r: {
                                            if ((n | 0) == (u | 0)) {
                                                k = f;
                                                break r;
                                            }
                                            s = s & 3;
                                            A: {
                                                if (!s) {
                                                    e = u;
                                                    break A;
                                                }
                                                for(r = 0, e = u; f = f - 1 | 0, e = e - 1 | 0, o[f | 0] = l[e | 0], r = r + 1 | 0, (s | 0) != (r | 0););
                                            }
                                            if (n - u >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[e - 1 | 0], o[f - 2 | 0] = l[e - 2 | 0], o[f - 3 | 0] = l[e - 3 | 0], f = f - 4 | 0, e = e - 4 | 0, o[f | 0] = l[e | 0], (e | 0) != (n | 0););
                                            n = i[A >> 2];
                                        }
                                        if (i[A + 8 >> 2] = t, i[A + 4 >> 2] = h, i[A >> 2] = k, !n) break e;
                                        X(n);
                                    }
                                    i[A + 4 >> 2] = h, i[A + 12 >> 2] = i[A + 12 >> 2] + 1;
                                    return;
                                }
                                i[A + 12 >> 2] = e + 1, o[e + n | 0] = r;
                                return;
                            }
                            p0(), z();
                        }
                        function x3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (e = i[A + 100 >> 2], n = i[A + 104 >> 2], f = n, t = e - f | 0, k = f >> 31, e = (e >> 31) - (k + (e >>> 0 < f >>> 0) | 0) | 0, s = e, (e - (t >>> 0 < 2147483648) | 0) != -1) {
                                for(; n = k >> 31, e = f + (n | 1) | 0, k = n + k | 0, f = m2(e, e >>> 0 < f >>> 0 ? k + 1 | 0 : k, 2, 0), k = w0, n = s >> 31, e = t + (n | 1) | 0, n = n + s | 0, t = m2(e, e >>> 0 < t >>> 0 ? n + 1 | 0 : n, 2, 0), e = w0, s = e, (e - (t >>> 0 < 2147483648) | 0) != -1;);
                                n = f, k = f >> 31;
                            }
                            if (e = f, u = k, A = oi(A, r), A = O0(e, k, A, A >> 31), k = s + w0 | 0, f = A + t | 0, k = f >>> 0 < t >>> 0 ? k + 1 | 0 : k, (k - (f >>> 0 < 2147483648) | 0) != -1) {
                                for(; A = u >> 31, r = e + (A | 1) | 0, A = A + u | 0, e = m2(r, r >>> 0 < e >>> 0 ? A + 1 | 0 : A, 2, 0), u = w0, A = k >> 31, n = A, A = f + (A | 1) | 0, n = n + k | 0, f = m2(A, A >>> 0 < f >>> 0 ? n + 1 | 0 : n, 2, 0), A = w0, k = A, (A - (f >>> 0 < 2147483648) | 0) != -1;);
                                n = e, u = e >> 31;
                            }
                            return r = f, A = (n | 0) / 2 | 0, f = A, r = r + A | 0, A = (A >> 31) + k | 0, m2(r, r >>> 0 < f >>> 0 ? A + 1 | 0 : A, e, u);
                        }
                        function z3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (e = i[A + 108 >> 2], n = i[A + 112 >> 2], f = n, t = e - f | 0, k = f >> 31, e = (e >> 31) - (k + (e >>> 0 < f >>> 0) | 0) | 0, s = e, (e - (t >>> 0 < 2147483648) | 0) != -1) {
                                for(; n = k >> 31, e = f + (n | 1) | 0, k = n + k | 0, f = m2(e, e >>> 0 < f >>> 0 ? k + 1 | 0 : k, 2, 0), k = w0, n = s >> 31, e = t + (n | 1) | 0, n = n + s | 0, t = m2(e, e >>> 0 < t >>> 0 ? n + 1 | 0 : n, 2, 0), e = w0, s = e, (e - (t >>> 0 < 2147483648) | 0) != -1;);
                                n = f, k = f >> 31;
                            }
                            if (e = f, u = k, A = ti(A, r), A = O0(e, k, A, A >> 31), k = s + w0 | 0, f = A + t | 0, k = f >>> 0 < t >>> 0 ? k + 1 | 0 : k, (k - (f >>> 0 < 2147483648) | 0) != -1) {
                                for(; A = u >> 31, r = e + (A | 1) | 0, A = A + u | 0, e = m2(r, r >>> 0 < e >>> 0 ? A + 1 | 0 : A, 2, 0), u = w0, A = k >> 31, n = A, A = f + (A | 1) | 0, n = n + k | 0, f = m2(A, A >>> 0 < f >>> 0 ? n + 1 | 0 : n, 2, 0), A = w0, k = A, (A - (f >>> 0 < 2147483648) | 0) != -1;);
                                n = e, u = e >> 31;
                            }
                            return r = f, A = (n | 0) / 2 | 0, f = A, r = r + A | 0, A = (A >> 31) + k | 0, m2(r, r >>> 0 < f >>> 0 ? A + 1 | 0 : A, e, u);
                        }
                        function T3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            u = r + 31 | 0, n = i[A + 12 >> 2] << 7, f = I[A + 20 >> 1], e = i[A + 16 >> 2];
                            i: {
                                for(;;){
                                    f = f + 1 | 0, Q[A + 20 >> 1] = f, e = e << 1, i[A + 16 >> 2] = e, f = f << 16 >> 16;
                                    e: {
                                        if ((f | 0) < 0 || (f = 65528, Q[A + 20 >> 1] = 65528, k = i[A + 4 >> 2], k >>> 0 >= k0[A + 8 >> 2])) break e;
                                        i[A + 4 >> 2] = k + 1, e = l[k | 0] | e, i[A + 16 >> 2] = e;
                                    }
                                    if (e >>> 0 < n >>> 0) break i;
                                    if (e = e - n | 0, i[A + 16 >> 2] = e, t = (1 << r) + t | 0, k = (r | 0) == (u | 0), r = r + 1 | 0, !!k) break;
                                }
                                return 0;
                            }
                            if ((r | 0) <= 8) {
                                if (!r) return t;
                                f = r + f | 0, Q[A + 20 >> 1] = f, e = e << r, i[A + 16 >> 2] = e, f = f << 16 >> 16;
                                i: {
                                    if ((f | 0) < 0 || (k = i[A + 4 >> 2], k >>> 0 >= k0[A + 8 >> 2])) break i;
                                    i[A + 4 >> 2] = k + 1, k = l[k | 0], Q[A + 20 >> 1] = f - 8, e = k << f | e;
                                }
                                return f = (e >>> 0) / (n >>> 0) | 0, r = 1 << r, (f | 0) >= (r | 0) && (f = r - 1 | 0), i[A + 16 >> 2] = e - Z(f, n), f + t | 0;
                            }
                            for(e = r - 8 | 0, r = y9(A); r = S1(A) | r << 1, e = e - 1 | 0, !!e;);
                            return r + t | 0;
                        }
                        function Cm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 1) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 8 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, !f) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 27 | 0] = f, o[r + 28 | 0] = f >>> 8, o[r + 29 | 0] = f >>> 16, o[r + 30 | 0] = f >>> 24, i[r + 24 >> 2] = i[e + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function Vm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 1) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 8 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] <= 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, !f) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 27 | 0] = f, o[r + 28 | 0] = f >>> 8, o[r + 29 | 0] = f >>> 16, o[r + 30 | 0] = f >>> 24, i[r + 24 >> 2] = i[e + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function ym(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 8 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, !f) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 27 | 0] = f, o[r + 28 | 0] = f >>> 8, o[r + 29 | 0] = f >>> 16, o[r + 30 | 0] = f >>> 24, i[r + 24 >> 2] = i[e + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function Im(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 8 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] <= 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, !f) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 27 | 0] = f, o[r + 28 | 0] = f >>> 8, o[r + 29 | 0] = f >>> 16, o[r + 30 | 0] = f >>> 24, i[r + 24 >> 2] = i[e + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function Fm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                if ((r | 0) != -1) {
                                    if (u = i[A + 12 >> 2], s = i[A + 8 >> 2], n = i[A + 24 >> 2], (n | 0) == i[A + 28 >> 2]) {
                                        if (e = -1, !(l[A + 48 | 0] & 16)) break i;
                                        t = i[A + 20 >> 2], h = i[A + 44 >> 2], f = A + 32 | 0, Wi(f, 0), G2(f, l[f + 11 | 0] >>> 7 | 0 ? (i[f + 8 >> 2] & 2147483647) - 1 | 0 : 10), l[f + 11 | 0] >>> 7 | 0 ? e = i[f >> 2] : e = f, l[f + 11 | 0] >>> 7 | 0 ? f = i[f + 4 >> 2] : f = l[f + 11 | 0] & 127, i[A + 28 >> 2] = f + e, i[A + 20 >> 2] = e, i[A + 24 >> 2] = e, i[A + 24 >> 2] = i[A + 24 >> 2] + (n - t | 0), i[A + 44 >> 2] = i[A + 20 >> 2] + (h - t | 0);
                                    }
                                    i[k + 12 >> 2] = i[A + 24 >> 2] + 1, e = m - 16 | 0, m = e, m = e + 16 | 0, f = A + 44 | 0, e = k + 12 | 0, i[A + 44 >> 2] = i[(k0[e >> 2] < k0[f >> 2] ? f : e) >> 2], l[A + 48 | 0] & 8 && (e = A + 32 | 0, l[e + 11 | 0] >>> 7 | 0 && (e = i[e >> 2]), i[A + 16 >> 2] = i[A + 44 >> 2], i[A + 12 >> 2] = e + (u - s | 0), i[A + 8 >> 2] = e), e = Yt(A, r << 24 >> 24);
                                    break i;
                                }
                                e = (r | 0) != -1 ? r : 0;
                            }
                            return m = k + 16 | 0, e | 0;
                        }
                        function Ym(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            k = m - 16 | 0, m = k, i[k + 12 >> 2] = e, i[A + 16 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0;
                            i: {
                                if (l[A + 96 | 0] != 1 || (f = i[A + 32 >> 2], !f)) break i;
                                X(f);
                            }
                            i: {
                                if (l[A + 97 | 0] != 1 || (f = i[A + 56 >> 2], !f)) break i;
                                X(f);
                            }
                            i[A + 52 >> 2] = e;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if (e >>> 0 >= 9) {
                                                if (f = l[A + 98 | 0], !r || (n = f & 1, !n)) break A;
                                                if (o[A + 96 | 0] = 0, i[A + 32 >> 2] = r, !n) break e;
                                                break r;
                                            }
                                            if (o[A + 96 | 0] = 0, i[A + 52 >> 2] = 8, i[A + 32 >> 2] = A + 44, o[A + 98 | 0] & 1) break r;
                                            break e;
                                        }
                                        if (e = D(e), o[A + 96 | 0] = 1, i[A + 32 >> 2] = e, !(f & 1)) break e;
                                    }
                                    r = 0, i[A + 60 >> 2] = 0, e = 0;
                                    break i;
                                }
                                if (i[k + 8 >> 2] = 8, e = m - 16 | 0, m = e, m = e + 16 | 0, e = k + 8 | 0, f = k + 12 | 0, f = i[(i[f >> 2] < i[e >> 2] ? e : f) >> 2], i[A + 60 >> 2] = f, r && (e = 0, f >>> 0 > 8)) break i;
                                r = D(f), e = 1;
                            }
                            return o[A + 97 | 0] = e, i[A + 56 >> 2] = r, m = k + 16 | 0, A | 0;
                        }
                        function tn(A) {
                            var r = 0;
                            r = D(208), i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r + 72 >> 2] = -1, i[r + 76 >> 2] = -1, i[r + 116 >> 2] = 0, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, Q[r + 132 >> 1] = 1, i[r + 128 >> 2] = 0, i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, i[r >> 2] = 77656, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r - -64 >> 2] = 0, i[r + 80 >> 2] = -1, i[r + 84 >> 2] = -1, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, Q[r + 112 >> 1] = 0, i[r + 16 >> 2] = 75980, i[r + 152 >> 2] = 0, i[r + 156 >> 2] = 0, i[r + 144 >> 2] = 0, i[r + 148 >> 2] = 0, i[r + 136 >> 2] = 0, i[r + 140 >> 2] = 0, i[r + 160 >> 2] = 0, i[r + 164 >> 2] = 1072693248, i[r + 192 >> 2] = 0, i[r + 184 >> 2] = 0, i[r + 188 >> 2] = 0, i[r + 176 >> 2] = 0, i[r + 180 >> 2] = 0, i[r + 168 >> 2] = 0, i[r + 172 >> 2] = 0, o[r + 204 | 0] = 0, i[r + 200 >> 2] = 0, i[r + 32 >> 2] = 1668113784, i[A + 4 >> 2] = r, i[A >> 2] = r + 16;
                        }
                        function G6(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if (f = i[r >> 2], n = i[r + 4 >> 2], (f | 0) != (n | 0)) {
                                        if (k = n - f | 0, (k | 0) < 0) break e;
                                        for(e = D(k), i[A + 4 >> 2] = e, i[A >> 2] = e, i[A + 8 >> 2] = e + k; i[e >> 2] = i[f >> 2], k = i[f + 4 >> 2], i[e + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = e + 8 | 0, f = f + 8 | 0, (n | 0) != (f | 0););
                                        i[A + 4 >> 2] = e;
                                    }
                                    if (i[A + 20 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, e = i[r + 16 >> 2], k = i[r + 12 >> 2], (e | 0) != (k | 0)) {
                                        if (e = e - k | 0, (e | 0) < 0) break i;
                                        f = D(e), i[A + 16 >> 2] = f, i[A + 12 >> 2] = f, n = e + f | 0, i[A + 20 >> 2] = n, v0(f, k, e), i[A + 16 >> 2] = n;
                                    }
                                    if (e = i[r + 28 >> 2], i[A + 24 >> 2] = i[r + 24 >> 2], i[A + 28 >> 2] = e, r = i[21669], i[A + 32 >> 2] = i[21668], i[A + 36 >> 2] = r, A = A + 40 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        return;
                                    }
                                    j(A, i[21670], i[21671]);
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function Q0(A, r, e) {
                            var f = 0, k = 0;
                            i: {
                                if ((A | 0) == (r | 0)) break i;
                                if (k = A + e | 0, r - k >>> 0 <= 0 - (e << 1) >>> 0) return v0(A, r, e);
                                f = (A ^ r) & 3;
                                e: {
                                    r: {
                                        if (A >>> 0 < r >>> 0) {
                                            if (f) {
                                                f = A;
                                                break e;
                                            }
                                            if (!(A & 3)) {
                                                f = A;
                                                break r;
                                            }
                                            for(f = A;;){
                                                if (!e) break i;
                                                if (o[f | 0] = l[r | 0], r = r + 1 | 0, e = e - 1 | 0, f = f + 1 | 0, !(f & 3)) break;
                                            }
                                            break r;
                                        }
                                        A: {
                                            if (f) break A;
                                            if (k & 3) for(;;){
                                                if (!e) break i;
                                                if (e = e - 1 | 0, f = e + A | 0, o[f | 0] = l[r + e | 0], !(f & 3)) break;
                                            }
                                            if (e >>> 0 <= 3) break A;
                                            for(; e = e - 4 | 0, i[e + A >> 2] = i[r + e >> 2], e >>> 0 > 3;);
                                        }
                                        if (!e) break i;
                                        for(; e = e - 1 | 0, o[e + A | 0] = l[r + e | 0], !!e;);
                                        break i;
                                    }
                                    if (e >>> 0 <= 3) break e;
                                    for(; i[f >> 2] = i[r >> 2], r = r + 4 | 0, f = f + 4 | 0, e = e - 4 | 0, e >>> 0 > 3;);
                                }
                                if (!e) break i;
                                for(; o[f | 0] = l[r | 0], f = f + 1 | 0, r = r + 1 | 0, e = e - 1 | 0, !!e;);
                            }
                            return A;
                        }
                        function Em(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (e = A + 12 | 0, A = i[e + 60 >> 2], k = e - -64 | 0, (A | 0) != (k | 0)) for(;;){
                                r = i[A + 48 >> 2], r && X(r), f = i[A + 4 >> 2];
                                i: {
                                    if (f) {
                                        for(;;)if (r = f, f = i[r >> 2], !f) break i;
                                    }
                                    for(; r = i[A + 8 >> 2], f = i[r >> 2] != (A | 0), A = r, !!f;);
                                }
                                if (A = r, (r | 0) == (k | 0)) break;
                            }
                            if (f = i[e + 112 >> 2], f) {
                                if (A = f, r = i[e + 116 >> 2], (A | 0) != (r | 0)) {
                                    for(; o[r - 1 | 0] < 0 && X(i[r - 12 >> 2]), r = r - 20 | 0, (f | 0) != (r | 0););
                                    A = i[e + 112 >> 2];
                                }
                                i[e + 116 >> 2] = f, X(A);
                            }
                            ff(e + 60 | 0, i[e + 64 >> 2]), r = i[e + 56 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[e + 48 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            o[e + 19 | 0] < 0 && X(i[e + 8 >> 2]), A = i[e + 4 >> 2], A && g(A);
                        }
                        function p2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                if (n = i[A + 4 >> 2], t = i[A >> 2], u = n - t >> 3, e = u + 1 | 0, e >>> 0 < 536870912) {
                                    if (f = i[A + 8 >> 2] - t | 0, k = f >> 2, f = f >>> 0 >= 2147483640 ? 536870911 : e >>> 0 < k >>> 0 ? k : e, f) {
                                        if (f >>> 0 >= 536870912) break i;
                                        k = D(f << 3);
                                    } else k = 0;
                                    e = k + (u << 3) | 0, i[e >> 2] = i[r >> 2], i[e + 4 >> 2] = i[r + 4 >> 2], i[r >> 2] = 0, i[r + 4 >> 2] = 0, u = k + (f << 3) | 0, k = e + 8 | 0;
                                    e: {
                                        if ((n | 0) == (t | 0)) {
                                            r = e;
                                            break e;
                                        }
                                        for(; r = e - 8 | 0, f = n - 8 | 0, i[r >> 2] = i[f >> 2], i[e - 4 >> 2] = i[n - 4 >> 2], i[f >> 2] = 0, i[f + 4 >> 2] = 0, e = r, n = f, (f | 0) != (t | 0););
                                    }
                                    if (e = i[A >> 2], i[A >> 2] = r, r = i[A + 4 >> 2], i[A + 4 >> 2] = k, i[A + 8 >> 2] = u, (r | 0) != (e | 0)) for(;;){
                                        A = i[r - 4 >> 2];
                                        e: {
                                            if (!A || (n = i[A + 4 >> 2], i[A + 4 >> 2] = n - 1, n)) break e;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (r = r - 8 | 0, (e | 0) == (r | 0)) break;
                                    }
                                    return e && X(e), k;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function gm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (!(k && r)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 7560;
                                    break i;
                                }
                                i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, g3(n + 12 | 0, r, e, f, n + 24 | 0);
                                e: {
                                    if (i[n + 12 >> 2]) {
                                        r = i[n + 16 >> 2], i[A >> 2] = i[n + 12 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 20 >> 2];
                                        break e;
                                    }
                                    if (r = i[n + 24 >> 2], !r) {
                                        i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 2155;
                                        break e;
                                    }
                                    if (i[n + 8 >> 2] = 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, f = i[r + 104 >> 2], e = i[r + 100 >> 2], t = (f | 0) == (e | 0), !t) {
                                        if (r = f - e | 0, (r | 0) >= 0) {
                                            e = v0(D(r), e, r), t || v0(k, e, r), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], X(e);
                                            break e;
                                        }
                                        p0(), z();
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (A = i[n + 28 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = n + 32 | 0;
                        }
                        function on(A, r, e, f) {
                            i: switch(r - 9 | 0){
                                case 0:
                                    r = i[e >> 2], i[e >> 2] = r + 4, i[A >> 2] = i[r >> 2];
                                    return;
                                case 6:
                                    r = i[e >> 2], i[e >> 2] = r + 4, r = Q[r >> 1], i[A >> 2] = r, i[A + 4 >> 2] = r >> 31;
                                    return;
                                case 7:
                                    r = i[e >> 2], i[e >> 2] = r + 4, i[A >> 2] = I[r >> 1], i[A + 4 >> 2] = 0;
                                    return;
                                case 8:
                                    r = i[e >> 2], i[e >> 2] = r + 4, r = o[r | 0], i[A >> 2] = r, i[A + 4 >> 2] = r >> 31;
                                    return;
                                case 9:
                                    r = i[e >> 2], i[e >> 2] = r + 4, i[A >> 2] = l[r | 0], i[A + 4 >> 2] = 0;
                                    return;
                                case 16:
                                    r = i[e >> 2] + 7 & -8, i[e >> 2] = r + 8, n0[A >> 3] = n0[r >> 3];
                                    return;
                                case 17:
                                    p[f | 0](A, e);
                                default:
                                    return;
                                case 1:
                                case 4:
                                case 14:
                                    r = i[e >> 2], i[e >> 2] = r + 4, r = i[r >> 2], i[A >> 2] = r, i[A + 4 >> 2] = r >> 31;
                                    return;
                                case 2:
                                case 5:
                                case 11:
                                case 15:
                                    r = i[e >> 2], i[e >> 2] = r + 4, i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = 0;
                                    return;
                                case 3:
                                case 10:
                                case 12:
                                case 13:
                                    break i;
                            }
                            r = i[e >> 2] + 7 & -8, i[e >> 2] = r + 8, e = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = e;
                        }
                        function Jm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((f | 0) == 3 | i[k + 8 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(!(i[e >> 2] | (f | 0) != 1) & i[e + 12 >> 2] > 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], !(f >>> 0 > 14 | !(1 << f & 18689))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 1, f = l[e + 8 | 0], o[r + 12 | 0] = f, i[r + 8 >> 2] = f ? 15 : 14, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, f = r + 4 | 0, $2(A, f, r), i[r + 4 >> 2] = 1, k = l[e + 8 | 0], o[r + 12 | 0] = k, i[r + 8 >> 2] = k ? 13 : 12, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, f, r);
                            }
                            m = r + 32 | 0;
                        }
                        function Rm(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            t = m - 32 | 0, m = t, i[t + 24 >> 2] = k, i[t + 28 >> 2] = f;
                            i: {
                                if (!(n && r)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 5, i[A + 4 >> 2] = 2001;
                                    break i;
                                }
                                e: {
                                    if (u = i[r >> 2], !u || (u = E0(u, 82544, 83232), !u)) break e;
                                    r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                                    r: {
                                        if (!(I[u + 374 >> 1] > f >>> 0 & I[u + 372 >> 1] > k >>> 0)) {
                                            i[A >> 2] = 5, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 11213;
                                            break r;
                                        }
                                        A: {
                                            if (!e || (G5(t + 4 | 0, u, t + 28 | 0, t + 24 | 0), o[t + 23 | 0] >= 0)) break A;
                                            X(i[t + 12 >> 2]);
                                        }
                                        i[n >> 2] = i[(i[u + 384 >> 2] + (Z(i[t + 24 >> 2], I[u + 374 >> 1]) << 2) | 0) + (i[t + 28 >> 2] << 2) >> 2], i[A + 8 >> 2] = i[20009], e = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = e;
                                    }
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    break i;
                                }
                                i[A >> 2] = 5, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 12108;
                            }
                            m = t + 32 | 0;
                        }
                        function L2() {
                            var A = 0, r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (l[108392]) return i[27097];
                            e = m - 32 | 0, m = e;
                            i: {
                                e: {
                                    for(;;){
                                        if (r = e + 8 | 0, f = ln(A, 1 << A & 2147483647 ? 16599 : 34896), i[r + (A << 2) >> 2] = f, (f | 0) == -1) break e;
                                        if (A = A + 1 | 0, (A | 0) == 6) break;
                                    }
                                    if (A = 60760, !O2(r, 60760, 24) || (A = 60784, !O2(r, 60784, 24))) break i;
                                    if (A = 0, !l[108148]) {
                                        for(; k = (A << 2) + 108100 | 0, n = ln(A, 34896), i[k >> 2] = n, A = A + 1 | 0, (A | 0) != 6;);
                                        o[108148] = 1, i[27031] = i[27025];
                                    }
                                    if (A = 108100, r = e + 8 | 0, !O2(r, 108100, 24) || (A = 108124, !O2(r, 108124, 24))) break i;
                                    if (A = Q2(24), !A) break e;
                                    r = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = r, r = i[e + 28 >> 2], i[A + 16 >> 2] = i[e + 24 >> 2], i[A + 20 >> 2] = r, r = i[e + 20 >> 2], i[A + 8 >> 2] = i[e + 16 >> 2], i[A + 12 >> 2] = r;
                                    break i;
                                }
                                A = 0;
                            }
                            return m = e + 32 | 0, o[108392] = 1, i[27097] = A, A;
                        }
                        function un(A, r, e, f, k, n) {
                            var t = 0;
                            t = m - 80 | 0, m = t;
                            i: {
                                if ((n | 0) >= 16384) {
                                    if (f1(t + 32 | 0, r, e, f, k, 0, 0, 0, 2147352576), f = i[t + 40 >> 2], k = i[t + 44 >> 2], r = i[t + 32 >> 2], e = i[t + 36 >> 2], n >>> 0 < 32767) {
                                        n = n - 16383 | 0;
                                        break i;
                                    }
                                    f1(t + 16 | 0, r, e, f, k, 0, 0, 0, 2147352576), n = (n >>> 0 >= 49149 ? 49149 : n) - 32766 | 0, f = i[t + 24 >> 2], k = i[t + 28 >> 2], r = i[t + 16 >> 2], e = i[t + 20 >> 2];
                                    break i;
                                }
                                if ((n | 0) > -16383) break i;
                                if (f1(t - -64 | 0, r, e, f, k, 0, 0, 0, 7471104), f = i[t + 72 >> 2], k = i[t + 76 >> 2], r = i[t + 64 >> 2], e = i[t + 68 >> 2], n >>> 0 > 4294934644) {
                                    n = n + 16269 | 0;
                                    break i;
                                }
                                f1(t + 48 | 0, r, e, f, k, 0, 0, 0, 7471104), n = (n >>> 0 <= 4294918376 ? -48920 : n) + 32538 | 0, f = i[t + 56 >> 2], k = i[t + 60 >> 2], r = i[t + 48 >> 2], e = i[t + 52 >> 2];
                            }
                            f1(t, r, e, f, k, 0, 0, 0, n + 16383 << 16), r = i[t + 12 >> 2], i[A + 8 >> 2] = i[t + 8 >> 2], i[A + 12 >> 2] = r, r = i[t + 4 >> 2], i[A >> 2] = i[t >> 2], i[A + 4 >> 2] = r, m = t + 80 | 0;
                        }
                        function s2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            f = i[A + 12 >> 2], e = l[((l[r | 0] << 1 & 508) + (f >>> 6 | 0) | 0) + 48396 | 0], f = f - e | 0, i[A + 12 >> 2] = f, k = i[A + 16 >> 2], f = f << 7;
                            i: {
                                if (k >>> 0 < f >>> 0) {
                                    if (k = r, e = l[r | 0], r = e & 1, o[k | 0] = r | l[(e >>> 1 | 0) + 48656 | 0] << 1, f >>> 0 > 32767 || (i[A + 12 >> 2] = f >>> 6, f = i[A + 16 >> 2] << 1, i[A + 16 >> 2] = f, e = I[A + 20 >> 1] + 1 | 0, Q[A + 20 >> 1] = e, (e | 0) == (e & 65535)) || (Q[A + 20 >> 1] = 65528, e = i[A + 4 >> 2], e >>> 0 >= k0[A + 8 >> 2])) break i;
                                    return i[A + 4 >> 2] = e + 1, i[A + 16 >> 2] = f | l[e | 0], r;
                                }
                                if (n = l[(e >>> 3 | 0) + 48720 | 0], i[A + 12 >> 2] = e << n, i[A + 16 >> 2] = k - f << n, e = r, f = l[e | 0], k = f & 1, r = !k, o[e | 0] = l[(f >>> 1 | 0) + 48752 | 0] << 1 | (f >>> 0 < 2 ? r : k), e = n + I[A + 20 >> 1] | 0, Q[A + 20 >> 1] = e, e = e << 16 >> 16, (e | 0) < 0) break i;
                                f = i[A + 4 >> 2], f >>> 0 < k0[A + 8 >> 2] && (i[A + 4 >> 2] = f + 1, i[A + 16 >> 2] = i[A + 16 >> 2] | l[f | 0] << e), Q[A + 20 >> 1] = e - 8;
                            }
                            return r;
                        }
                        function Nm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                e: {
                                    if (u = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, t = i[u >> 2], !t) break e;
                                    for(;;){
                                        if (d1(i[t + 4 >> 2], e)) {
                                            if (t = i[u + 4 >> 2], u = u + 4 | 0, t) continue;
                                            break e;
                                        }
                                        break;
                                    }
                                    r: {
                                        A: switch(i[t + 8 >> 2] - 1 | 0){
                                            case 0:
                                                if (p[i[i[r >> 2] + 76 >> 2]](A, i[r + 4 >> 2], e, n + 28 | 0), i[A >> 2]) break i;
                                                i[n >> 2] = i[n + 28 >> 2], wr(f, k, 14670, n);
                                                break r;
                                            case 1:
                                                if (p[i[i[r >> 2] + 84 >> 2]](A, i[r + 4 >> 2], e, n + 28 | 0), i[A >> 2]) break i;
                                                i[n + 16 >> 2] = i[n + 28 >> 2], wr(f, k, 14670, n + 16 | 0);
                                                break r;
                                            case 2:
                                                break A;
                                            default:
                                                break r;
                                        }
                                        if (p[i[i[r >> 2] + 92 >> 2]](A, i[r + 4 >> 2], e, f, k), i[A >> 2]) break i;
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                    break i;
                                }
                                r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                            }
                            m = n + 32 | 0;
                        }
                        function Dm(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            if (n = m - 16 | 0, m = n, t = i[r + 68 >> 2], t) {
                                t = p[i[i[t >> 2] + 24 >> 2]](t) | 0;
                                i: {
                                    e: {
                                        if (!(!i[r + 64 >> 2] | (e | f) != 0 & (t | 0) <= 0) && !(p[i[i[r >> 2] + 24 >> 2]](r) | 0)) break e;
                                        i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break i;
                                    }
                                    if (k >>> 0 >= 3) {
                                        i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break i;
                                    }
                                    if (u = i[r + 64 >> 2], f = O0(t, 0, e, f), e = (t | 0) > 0, vr(u, e ? f : 0, e ? w0 : 0, k)) {
                                        i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break i;
                                    }
                                    e = i[r + 64 >> 2];
                                    e: {
                                        if (i[e + 76 >> 2] < 0) {
                                            e = D9(e), f = w0;
                                            break e;
                                        }
                                        e = D9(e), f = w0;
                                    }
                                    i[A + 8 >> 2] = e, i[A + 12 >> 2] = f, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 72 >> 2], r = i[r + 76 >> 2], i[n >> 2] = e, i[n + 4 >> 2] = r, i[n + 8 >> 2] = e, i[n + 12 >> 2] = r, r = i[n + 4 >> 2], i[A >> 2] = i[n >> 2], i[A + 4 >> 2] = r;
                                }
                                m = n + 16 | 0;
                                return;
                            }
                            w1(), z();
                        }
                        function S3(A, r, e) {
                            i: {
                                e: switch(r - 1 | 0){
                                    case 0:
                                        r = i[A + 28 >> 2], i[r + 100 >> 2] = 1751476579, i[r + 104 >> 2] = 0, m4(r, 1835623985), m4(i[A + 28 >> 2], 1751476579);
                                        break i;
                                    case 3:
                                        r = i[A + 28 >> 2], i[r + 100 >> 2] = 1635150182, i[r + 104 >> 2] = 0, m4(r, 1635150182), m4(i[A + 28 >> 2], 1835623985);
                                        break i;
                                    case 4:
                                        r = i[A + 28 >> 2], i[r + 100 >> 2] = 1987471715, i[r + 104 >> 2] = 0, m4(r, 1835623985), m4(i[A + 28 >> 2], 1987471715);
                                        break i;
                                    case 2:
                                        r = i[A + 28 >> 2], i[r + 100 >> 2] = 1785750887, i[r + 104 >> 2] = 0, m4(r, 1785750887), m4(i[A + 28 >> 2], 1835623985);
                                        break i;
                                    case 7:
                                        r = i[A + 28 >> 2], i[r + 100 >> 2] = 1835623986, i[r + 104 >> 2] = 0, m4(r, 1835623985);
                                        break i;
                                    case 6:
                                    case 9:
                                        break e;
                                    default:
                                        break i;
                                }
                                r = i[A + 28 >> 2], i[r + 100 >> 2] = 1781689193, i[r + 104 >> 2] = 0, m4(r, 1835623985), m4(i[A + 28 >> 2], 1781689193);
                            }
                            e && m4(i[A + 28 >> 2], 1835622758);
                        }
                        function He(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            if ((r | 0) != (e | 0)) for(u = A + 4 | 0;;){
                                t = i[A + 4 >> 2];
                                i: {
                                    e: {
                                        r: {
                                            if (f = u, (f | 0) == i[A >> 2]) break r;
                                            n = f, k = t;
                                            A: {
                                                if (k) {
                                                    for(;;)if (f = k, k = i[f + 4 >> 2], !k) break A;
                                                }
                                                for(; f = i[n + 8 >> 2], k = i[f >> 2] == (n | 0), n = f, !!k;);
                                            }
                                            if (k = i[r >> 2], k >>> 0 > k0[f + 16 >> 2]) break r;
                                            if (n = u, f = n, !t) break e;
                                            for(;;){
                                                if (f = t, n = i[f + 16 >> 2], n >>> 0 > k >>> 0) {
                                                    if (n = f, t = i[f >> 2], t) continue;
                                                    break e;
                                                }
                                                if (k >>> 0 <= n >>> 0) break i;
                                                if (t = i[f + 4 >> 2], !t) break;
                                            }
                                            n = f + 4 | 0;
                                            break e;
                                        }
                                        if (n = t ? f + 4 | 0 : u, i[n >> 2]) break i;
                                        f = t ? f : u;
                                    }
                                    k = D(20), t = i[r >> 2], i[k + 8 >> 2] = f, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 16 >> 2] = t, i[n >> 2] = k, f = i[i[A >> 2] >> 2], f && (i[A >> 2] = f, k = i[n >> 2]), h4(i[A + 4 >> 2], k), i[A + 8 >> 2] = i[A + 8 >> 2] + 1;
                                }
                                if (r = r + 4 | 0, (e | 0) == (r | 0)) break;
                            }
                        }
                        function Mm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n, r = i[f + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((r | 0) == 3 | i[k + 4 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(!(i[e >> 2] != 1 | (i[e + 4 >> 2] & -4) != 12) & i[e + 12 >> 2] > 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (k = I[f + 24 >> 1], !(k >>> 0 > 14 | !(1 << k & 18689))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!l[f + 26 | 0]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != 1) break i;
                                r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = 1, o[r + 8 | 0] = l[e + 8 | 0], i[r + 12 >> 2] = i[e + 12 >> 2], i[r + 20 >> 2] = i[f + 20 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function B0(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            i: {
                                if (!e || (o[A | 0] = r, f = A + e | 0, o[f - 1 | 0] = r, e >>> 0 < 3) || (o[A + 2 | 0] = r, o[A + 1 | 0] = r, o[f - 3 | 0] = r, o[f - 2 | 0] = r, e >>> 0 < 7) || (o[A + 3 | 0] = r, o[f - 4 | 0] = r, e >>> 0 < 9) || (f = 0 - A & 3, k = f + A | 0, r = Z(r & 255, 16843009), i[k >> 2] = r, f = e - f & -4, e = f + k | 0, i[e - 4 >> 2] = r, f >>> 0 < 9) || (i[k + 8 >> 2] = r, i[k + 4 >> 2] = r, i[e - 8 >> 2] = r, i[e - 12 >> 2] = r, f >>> 0 < 25) || (i[k + 24 >> 2] = r, i[k + 20 >> 2] = r, i[k + 16 >> 2] = r, i[k + 12 >> 2] = r, i[e - 16 >> 2] = r, i[e - 20 >> 2] = r, i[e - 24 >> 2] = r, i[e - 28 >> 2] = r, t = k & 4 | 24, e = f - t | 0, e >>> 0 < 32)) break i;
                                for(f = O0(r, 0, 1, 1), n = w0, r = k + t | 0; i[r + 24 >> 2] = f, i[r + 28 >> 2] = n, i[r + 16 >> 2] = f, i[r + 20 >> 2] = n, i[r + 8 >> 2] = f, i[r + 12 >> 2] = n, i[r >> 2] = f, i[r + 4 >> 2] = n, r = r + 32 | 0, e = e - 32 | 0, e >>> 0 > 31;);
                            }
                            return A;
                        }
                        function Um(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0;
                            r = i[A + 20 >> 2], n = i[r + 18588 >> 2], i[A + 4 >> 2] = 1, i[n + 324 >> 2] = i[n + 324 >> 2] - 1, i[n + 328 >> 2] = i[n + 328 >> 2] + 1, e = i[r + 18588 >> 2], f = i[e + 124 >> 2], k = i[f + 16908 >> 2], t = i[r + 4 >> 2];
                            i: {
                                if ((k | 0) > (t | 0)) {
                                    k = i[i[i[e + 132 >> 2] + 8460 >> 2] + (t << 2) >> 2], e = i[f + 16892 >> 2], f = (k | 0) / (e | 0) | 0, e = k - Z(f, e) | 0;
                                    break i;
                                }
                                e = i[f + 16892 >> 2], f = (k | 0) / (e | 0) | 0, e = k - Z(f, e) | 0;
                            }
                            i[r + 12 >> 2] = f, i[r + 8 >> 2] = e, i[r >> 2] = k;
                            i: {
                                e: {
                                    r: {
                                        if (l[A + 8 | 0] == 1) {
                                            if (N3(r)) break r;
                                            break e;
                                        }
                                        if (k = i[r + 18592 >> 2], f = i[k + 804 >> 2], f >>> 0 >= 3) break i;
                                        Ai(r + 18572 | 0, f, i[k + 800 >> 2]), o[r + 18580 | 0] = 0, o[r + 18581 | 0] = 0, o[r + 18582 | 0] = 0, o[r + 18583 | 0] = 0;
                                    }
                                    Fi(r + 18548 | 0), he(r, 0, l[A + 8 | 0]);
                                }
                                i[A + 4 >> 2] = 3, A = i[r + 18600 >> 2], i[A + 44 >> 2] = i[A + 44 >> 2] + 1, ur(n);
                                return;
                            }
                            y0(18036, 15050, 1520, 4390), z();
                        }
                        function ln(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                if (l[r | 0] || (r = Pe(16149), l[r | 0] && r) || (r = Pe(Z(A, 12) + 61792 | 0), l[r | 0] && r) || (r = Pe(16218), l[r | 0] && r)) break i;
                                r = 17513;
                            }
                            i: {
                                for(;;){
                                    if (f = l[r + e | 0], !(!f | (f | 0) == 47)) {
                                        if (f = 23, e = e + 1 | 0, (e | 0) != 23) continue;
                                        break i;
                                    }
                                    break;
                                }
                                f = e;
                            }
                            k = 17513;
                            i: {
                                e: {
                                    e = l[r | 0];
                                    r: {
                                        A: {
                                            if (!(l[r + f | 0] | (e | 0) == 46) && (k = r, (e | 0) != 67)) break A;
                                            if (!l[k + 1 | 0]) break r;
                                        }
                                        if (!d1(k, 17513)) break r;
                                        if (d1(k, 15874)) break e;
                                    }
                                    if (!A && (e = 60724, l[k + 1 | 0] == 46)) break i;
                                    return 0;
                                }
                                if (e = i[27024], e) for(;;){
                                    if (!d1(k, e + 8 | 0)) break i;
                                    if (e = i[e + 32 >> 2], !e) break;
                                }
                                e = Q2(36), e && (r = i[15182], i[e >> 2] = i[15181], i[e + 4 >> 2] = r, r = e + 8 | 0, v0(r, k, f), o[r + f | 0] = 0, i[e + 32 >> 2] = i[27024], i[27024] = e), e = A | e ? e : 60724;
                            }
                            return e;
                        }
                        function sn(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (r = i[A + 56 >> 2], f = i[A + 52 >> 2], (r | 0) != (f | 0)) for(;;){
                                e = i[r - 4 >> 2];
                                i: {
                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (r = r - 8 | 0, (f | 0) == (r | 0)) break;
                            }
                            i[A + 56 >> 2] = f, r = i[A + 72 >> 2], i[A + 68 >> 2] = 0, i[A + 72 >> 2] = 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 84 >> 2], i[A + 80 >> 2] = 0, i[A + 84 >> 2] = 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (r = i[A + 172 >> 2], f = i[A + 168 >> 2], (r | 0) != (f | 0)) for(;;){
                                e = i[r - 4 >> 2];
                                i: {
                                    if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                    p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                }
                                if (r = r - 8 | 0, (f | 0) == (r | 0)) break;
                            }
                            i[A + 172 >> 2] = f;
                        }
                        function hn(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0;
                            if (h = m - 16 | 0, m = h, (r ^ -1) + 1073741815 >>> 0 >= e >>> 0) {
                                l[A + 11 | 0] >>> 7 | 0 ? s = i[A >> 2] : s = A, w = s, s = h + 4 | 0, v = s, r >>> 0 < 536870899 ? (i[h + 12 >> 2] = r << 1, i[h + 4 >> 2] = r + e, e = m - 16 | 0, m = e, m = e + 16 | 0, e = h + 12 | 0, e = i[(k0[s >> 2] < k0[e >> 2] ? e : s) >> 2], e >>> 0 >= 2 ? (s = e + 2 & -2, e = s - 1 | 0, e = (e | 0) == 2 ? s : e) : e = 1, e = e + 1 | 0) : e = 1073741815, D6(v, e), e = i[h + 4 >> 2], k && r6(w, k, e), t && r6(u, t, e + (k << 2) | 0), s = k + n | 0, u = f - s | 0, (f | 0) != (s | 0) && (f = k << 2, r6((f + w | 0) + (n << 2) | 0, u, (e + f | 0) + (t << 2) | 0)), (r | 0) != 1 && y8(w, 4), i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[h + 8 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, r = A, A = u + (k + t | 0) | 0, i[r + 4 >> 2] = A, i[h + 12 >> 2] = 0, i[e + (A << 2) >> 2] = i[h + 12 >> 2], m = h + 16 | 0;
                                return;
                            }
                            u4(), z();
                        }
                        function Hm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            if (!e) return 0;
                            i: {
                                e: {
                                    if (r = i[A >> 2], l[r + 76 | 0] == 1) {
                                        if (A = i[A + 4 >> 2], A) break e;
                                        A = 0;
                                        break i;
                                    }
                                    if (A = i[r + 84 >> 2], r = i[r + 80 >> 2], A) break e;
                                    A = 0;
                                    break i;
                                }
                                i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                            }
                            l[r + 88 | 0] == 1 && (f = D(56), k = i[r + 148 >> 2], i[f + 48 >> 2] = i[r + 144 >> 2], i[f + 52 >> 2] = k, k = i[r + 140 >> 2], i[f + 40 >> 2] = i[r + 136 >> 2], i[f + 44 >> 2] = k, k = i[r + 132 >> 2], i[f + 32 >> 2] = i[r + 128 >> 2], i[f + 36 >> 2] = k, k = i[r + 124 >> 2], i[f + 24 >> 2] = i[r + 120 >> 2], i[f + 28 >> 2] = k, k = i[r + 116 >> 2], i[f + 16 >> 2] = i[r + 112 >> 2], i[f + 20 >> 2] = k, k = i[r + 108 >> 2], i[f + 8 >> 2] = i[r + 104 >> 2], i[f + 12 >> 2] = k, k = i[r + 100 >> 2], i[f >> 2] = i[r + 96 >> 2], i[f + 4 >> 2] = k, k = 1), i[e >> 2] = f;
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return k | 0;
                        }
                        function $4(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            u = m - 16 | 0, m = u, i[u + 12 >> 2] = r, r = 0, t = 6;
                            i: {
                                e: {
                                    if (T2(A, u + 12 | 0)) break e;
                                    t = 4, n = i[A >> 2], s = i[n + 12 >> 2];
                                    r: {
                                        if ((s | 0) == i[n + 16 >> 2]) {
                                            n = p[i[i[n >> 2] + 36 >> 2]](n) | 0;
                                            break r;
                                        }
                                        n = l[s | 0];
                                    }
                                    if (n = n << 24 >> 24, (n | 0) >= 0 ? s = (i[i[f + 8 >> 2] + (n << 2) >> 2] & 64) != 0 : s = 0, !s) break e;
                                    for(r = p[i[i[f >> 2] + 36 >> 2]](f, n, 0) | 0;;){
                                        r: {
                                            if (g1(A), r = r - 48 | 0, T2(A, u + 12 | 0) | (k | 0) < 2) break r;
                                            t = i[A >> 2], n = i[t + 12 >> 2];
                                            A: {
                                                if ((n | 0) == i[t + 16 >> 2]) {
                                                    t = p[i[i[t >> 2] + 36 >> 2]](t) | 0;
                                                    break A;
                                                }
                                                t = l[n | 0];
                                            }
                                            if (t = t << 24 >> 24, (t | 0) >= 0 ? n = (i[i[f + 8 >> 2] + (t << 2) >> 2] & 64) != 0 : n = 0, !n) break i;
                                            k = k - 1 | 0, r = (p[i[i[f >> 2] + 36 >> 2]](f, t, 0) | 0) + Z(r, 10) | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    if (t = 2, !T2(A, u + 12 | 0)) break i;
                                }
                                i[e >> 2] = i[e >> 2] | t;
                            }
                            return m = u + 16 | 0, r;
                        }
                        function xm(A, r, e, f, k, n, t, u, s, h, w, v, _) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0, w = w | 0, v = v | 0, _ = _ | 0;
                            var B = 0, G = 0, W = 0, C = 0, V = 0, y = 0, F = 0;
                            if ((v | 0) > 0) {
                                if (!((t | 0) <= 0 | (n | 0) <= 0)) for(W = (s + w | 0) + 1 << v, C = v + 1 | 0, s = -1 << _ ^ -1, y = n & 2147483646, F = n & 1;;){
                                    if (v = (Z(r, G) << 1) + A | 0, w = Z(k, G) << 1, _ = w + f | 0, w = e + w | 0, V = 0, (n | 0) != 1) for(; B = (Z(Q[w >> 1], u) + W | 0) + Z(Q[_ >> 1], h) >> C, Q[v >> 1] = (B | 0) >= 0 ? (s | 0) > (B | 0) ? B : s : 0, B = (Z(Q[w + 2 >> 1], u) + W | 0) + Z(Q[_ + 2 >> 1], h) >> C, Q[v + 2 >> 1] = (B | 0) >= 0 ? (s | 0) > (B | 0) ? B : s : 0, _ = _ + 4 | 0, w = w + 4 | 0, v = v + 4 | 0, V = V + 2 | 0, (y | 0) != (V | 0););
                                    if (F && (w = (Z(Q[w >> 1], u) + W | 0) + Z(Q[_ >> 1], h) >> C, Q[v >> 1] = (w | 0) >= 0 ? (s | 0) > (w | 0) ? w : s : 0), G = G + 1 | 0, (G | 0) == (t | 0)) break;
                                }
                                return;
                            }
                            y0(18127, 14969, 213, 8590), z();
                        }
                        function zm(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0;
                            t = m - 32 | 0, m = t;
                            i: {
                                e: {
                                    if (u = i[r >> 2], s = i[u + 24 >> 2], (s | 0) > 0 && (h = i[u + 28 >> 2], (h | 0) > 0)) break e;
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 129, i[A + 8 >> 2] = 9599;
                                    break i;
                                }
                                Z3(t + 4 | 0, u, e, (f ^ -1) + s | 0, k, (n ^ -1) + h | 0, 0);
                                e: {
                                    if (i[t + 12 >> 2]) {
                                        e = A, A = i[r >> 2], j0(e, t + 12 | 0, A ? A + 8 | 0 : 0);
                                        break e;
                                    }
                                    e = i[t + 4 >> 2], f = i[t + 8 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[r >> 2] = e, e = i[r + 4 >> 2], i[r + 4 >> 2] = f;
                                    r: {
                                        if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break r;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), A = i[t + 8 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = t + 32 | 0;
                        }
                        function Tm(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if ((r | 0) == -1) {
                                    if (l[A + 52 | 0]) break i;
                                    r = i[A + 48 >> 2], o[A + 52 | 0] = (r | 0) != -1;
                                    break i;
                                }
                                e = l[A + 52 | 0];
                                e: {
                                    r: {
                                        A: {
                                            if (!l[A + 53 | 0]) {
                                                if (e & 1) break A;
                                                break e;
                                            }
                                            if (e = e & 1, e) {
                                                if (Ko(i[A + 48 >> 2], i[A + 32 >> 2])) break e;
                                                break r;
                                            }
                                            if (!e) break e;
                                        }
                                        o[f + 19 | 0] = i[A + 48 >> 2] << 24 >> 24;
                                        A: {
                                            f: switch(e = i[A + 36 >> 2], k = f + 20 | 0, (p[i[i[e >> 2] + 12 >> 2]](e, i[A + 40 >> 2], f + 19 | 0, k, f + 12 | 0, f + 24 | 0, f + 32 | 0, k) | 0) - 1 | 0){
                                                case 0:
                                                case 1:
                                                    break r;
                                                case 2:
                                                    break f;
                                                default:
                                                    break A;
                                            }
                                            e = i[A + 48 >> 2], i[f + 20 >> 2] = f + 25, o[f + 24 | 0] = e;
                                        }
                                        for(;;){
                                            if (e = i[f + 20 >> 2], e >>> 0 <= f + 24 >>> 0) break e;
                                            if (e = e - 1 | 0, i[f + 20 >> 2] = e, (F6(o[e | 0], i[A + 32 >> 2]) | 0) == -1) break;
                                        }
                                    }
                                    r = -1;
                                    break i;
                                }
                                o[A + 52 | 0] = 1, i[A + 48 >> 2] = r;
                            }
                            return m = f + 32 | 0, r | 0;
                        }
                        function Sm(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = m - 32 | 0, m = t;
                            i: {
                                if (!(n | !k)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 16079;
                                    break i;
                                }
                                i[t + 28 >> 2] = 0, i[t + 20 >> 2] = 0, i[t + 24 >> 2] = 0, u = i[r >> 2], s = i[u + 48 >> 2], u = i[u + 52 >> 2];
                                e: {
                                    if (!u) {
                                        i5(t, s, e, t + 20 | 0, f);
                                        break e;
                                    }
                                    if (i[u + 4 >> 2] = i[u + 4 >> 2] + 1, i5(t, s, e, t + 20 | 0, f), e = i[u + 4 >> 2], i[u + 4 >> 2] = e - 1, e) break e;
                                    p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                                }
                                e: {
                                    if (i[t >> 2]) {
                                        i[n >> 2] = 0, k && (i[k >> 2] = 0), j0(A, t, i[r >> 2]);
                                        break e;
                                    }
                                    n && (i[n >> 2] = i[t + 24 >> 2] - i[t + 20 >> 2]), k && (r = i[t + 20 >> 2], e = i[t + 24 >> 2] - r | 0, f = D(e), i[k >> 2] = f, v0(f, r, e)), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (o[t + 19 | 0] < 0 && X(i[t + 8 >> 2]), A = i[t + 20 >> 2], !A) break i;
                                i[t + 24 >> 2] = A, X(A);
                            }
                            m = t + 32 | 0;
                        }
                        function j3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (t = i[A + 108 >> 2], k = i[A + 112 >> 2], t >>> 0 < k >>> 0) {
                                o[t | 0] = r, i[A + 108 >> 2] = t + 1;
                                return;
                            }
                            if (u = i[A + 104 >> 2], e = t - u | 0, n = e + 1 | 0, (n | 0) >= 0) {
                                f = k - u | 0, k = f << 1, n = f >>> 0 >= 1073741823 ? 2147483647 : k >>> 0 > n >>> 0 ? k : n, n ? k = D(n) : k = 0, f = e + k | 0, o[f | 0] = r, h = k + n | 0, s = f + 1 | 0;
                                i: {
                                    if ((t | 0) == (u | 0)) {
                                        k = f;
                                        break i;
                                    }
                                    n = e & 3;
                                    e: {
                                        if (!n) {
                                            e = t;
                                            break e;
                                        }
                                        for(r = 0, e = t; f = f - 1 | 0, e = e - 1 | 0, o[f | 0] = l[e | 0], r = r + 1 | 0, (n | 0) != (r | 0););
                                    }
                                    if (u - t >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[e - 1 | 0], o[f - 2 | 0] = l[e - 2 | 0], o[f - 3 | 0] = l[e - 3 | 0], f = f - 4 | 0, e = e - 4 | 0, o[f | 0] = l[e | 0], (e | 0) != (u | 0););
                                    u = i[A + 104 >> 2];
                                }
                                i[A + 112 >> 2] = h, i[A + 108 >> 2] = s, i[A + 104 >> 2] = k, u && X(u), i[A + 108 >> 2] = s;
                                return;
                            }
                            p0(), z();
                        }
                        function B4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = m - 32 | 0, m = e, i[e + 24 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0;
                            i: {
                                if (i[r + 16 >> 2]) {
                                    for(;;){
                                        if (!o4(r, 1)) {
                                            i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0;
                                            break i;
                                        }
                                        k = i[r >> 2], f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1);
                                        e: {
                                            if (!(p[i[i[k >> 2] + 16 >> 2]](k, e + 15 | 0, 1) | 0)) {
                                                D4(r), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = 1;
                                                break e;
                                            }
                                            if (n = o[e + 15 | 0], k = 2, !n) break e;
                                            Wi(e + 16 | 0, n), k = 0;
                                        }
                                        e: {
                                            if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break e;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                        }
                                        if (k) break;
                                    }
                                    if ((k | 0) != 2) break i;
                                    r = i[e + 20 >> 2], i[A >> 2] = i[e + 16 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[e + 24 >> 2], i[e + 24 >> 2] = 0, i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0;
                                    break i;
                                }
                                i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0;
                            }
                            o[e + 27 | 0] < 0 && X(i[e + 16 >> 2]), m = e + 32 | 0;
                        }
                        function jm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(i[e >> 2] == 1 & (i[e + 4 >> 2] & -4) == 12)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, Q[r + 28 >> 1] = 2, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969;
                                e: {
                                    r: switch(f = i[e + 4 >> 2], f - 12 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    o[r + 12 | 0] = 0, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = (f | 0) == 14 ? 12 : 14, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r), f = i[e + 4 >> 2];
                                }
                                e: switch(f - 13 | 0){
                                    case 0:
                                    case 2:
                                        break e;
                                    default:
                                        break i;
                                }
                                o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = (f | 0) == 15 ? 13 : 15, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function Om(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if ((r | 0) == -1) {
                                    if (l[A + 52 | 0]) break i;
                                    r = i[A + 48 >> 2], o[A + 52 | 0] = (r | 0) != -1;
                                    break i;
                                }
                                e = l[A + 52 | 0];
                                e: {
                                    r: {
                                        A: {
                                            if (!l[A + 53 | 0]) {
                                                if (e & 1) break A;
                                                break e;
                                            }
                                            if (e = e & 1, e) {
                                                if (i9(i[A + 48 >> 2], i[A + 32 >> 2])) break e;
                                                break r;
                                            }
                                            if (!e) break e;
                                        }
                                        i[f + 16 >> 2] = i[A + 48 >> 2];
                                        A: {
                                            f: switch(e = i[A + 36 >> 2], k = f + 20 | 0, (p[i[i[e >> 2] + 12 >> 2]](e, i[A + 40 >> 2], f + 16 | 0, k, f + 12 | 0, f + 24 | 0, f + 32 | 0, k) | 0) - 1 | 0){
                                                case 0:
                                                case 1:
                                                    break r;
                                                case 2:
                                                    break f;
                                                default:
                                                    break A;
                                            }
                                            e = i[A + 48 >> 2], i[f + 20 >> 2] = f + 25, o[f + 24 | 0] = e;
                                        }
                                        for(;;){
                                            if (e = i[f + 20 >> 2], e >>> 0 <= f + 24 >>> 0) break e;
                                            if (e = e - 1 | 0, i[f + 20 >> 2] = e, (F6(o[e | 0], i[A + 32 >> 2]) | 0) == -1) break;
                                        }
                                    }
                                    r = -1;
                                    break i;
                                }
                                o[A + 52 | 0] = 1, i[A + 48 >> 2] = r;
                            }
                            return m = f + 32 | 0, r | 0;
                        }
                        function Z1(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (k = i[A + 24 >> 2], !((k | 0) >= (r | 0) | (k | 0) > 56)) {
                                for(f = 64 - k | 0, n = i[A + 16 >> 2], w = i[A + 20 >> 2], k = i[A + 8 >> 2], e = i[A >> 2];;){
                                    i: {
                                        if (t = f, !k) {
                                            s = f;
                                            break i;
                                        }
                                        if (u = e + 1 | 0, i[A >> 2] = u, e = l[e | 0], k = k - 1 | 0, i[A + 8 >> 2] = k, s = t - 8 | 0, h = s & 31, (s & 63) >>> 0 >= 32 ? (v = e << h, e = 0) : (v = (1 << h) - 1 & e >>> 32 - h, e = e << h), n = e | n, e = w | v, w = e, i[A + 16 >> 2] = n, i[A + 20 >> 2] = e, e = f, f = e - 8 | 0, _ = _ - (e >>> 0 < 8) | 0, e = u, (t | 0) > 15) continue;
                                    }
                                    break;
                                }
                                k = 64 - s | 0;
                            }
                            return i[A + 24 >> 2] = k - r, e = i[A + 16 >> 2], f = A, f = A, A = i[A + 20 >> 2], t = e, n = r & 31, (r & 63) >>> 0 >= 32 ? (u = e << n, t = 0) : (u = (1 << n) - 1 & t >>> 32 - n | A << n, t = t << n), i[f + 16 >> 2] = t, i[f + 20 >> 2] = u, f = 64 - r | 0, r = e, e = f & 31, (f & 63) >>> 0 >= 32 ? A = A >>> e | 0 : A = ((1 << e) - 1 & A) << 32 - e | r >>> e, A & 255;
                        }
                        function Pm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 3) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!I[e + 24 >> 1]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[f + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != 1) break i;
                                r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = 1, o[r + 8 | 0] = l[e + 8 | 0], i[r + 12 >> 2] = i[e + 12 >> 2], i[r + 20 >> 2] = i[e + 20 >> 2], e = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function Lm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 3) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] <= 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!I[e + 24 >> 1]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[f + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != 1) break i;
                                r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = 1, o[r + 8 | 0] = l[e + 8 | 0], i[r + 12 >> 2] = i[e + 12 >> 2], i[r + 20 >> 2] = i[e + 20 >> 2], e = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function Km(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 3) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!I[e + 24 >> 1]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[f + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != 2) break i;
                                r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = 2, o[r + 8 | 0] = l[e + 8 | 0], i[r + 12 >> 2] = i[e + 12 >> 2], i[r + 20 >> 2] = i[e + 20 >> 2], e = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function qm(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (i[e >> 2]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 4 >> 2] != 3) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[k + 4 >> 2] != 2) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e + 12 >> 2] <= 8) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!I[e + 24 >> 1]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[f + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != 2) break i;
                                r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = 2, o[r + 8 | 0] = l[e + 8 | 0], i[r + 12 >> 2] = i[e + 12 >> 2], i[r + 20 >> 2] = i[e + 20 >> 2], e = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function $0(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (k = i[A + 24 >> 2], !((k | 0) >= (r | 0) | (k | 0) > 56)) {
                                for(f = 64 - k | 0, n = i[A + 16 >> 2], w = i[A + 20 >> 2], k = i[A + 8 >> 2], e = i[A >> 2];;){
                                    i: {
                                        if (t = f, !k) {
                                            s = f;
                                            break i;
                                        }
                                        if (u = e + 1 | 0, i[A >> 2] = u, e = l[e | 0], k = k - 1 | 0, i[A + 8 >> 2] = k, s = t - 8 | 0, h = s & 31, (s & 63) >>> 0 >= 32 ? (v = e << h, e = 0) : (v = (1 << h) - 1 & e >>> 32 - h, e = e << h), n = e | n, e = w | v, w = e, i[A + 16 >> 2] = n, i[A + 20 >> 2] = e, e = f, f = e - 8 | 0, _ = _ - (e >>> 0 < 8) | 0, e = u, (t | 0) > 15) continue;
                                    }
                                    break;
                                }
                                k = 64 - s | 0;
                            }
                            return i[A + 24 >> 2] = k - r, e = i[A + 16 >> 2], f = A, f = A, A = i[A + 20 >> 2], t = e, n = r & 31, (r & 63) >>> 0 >= 32 ? (u = e << n, t = 0) : (u = (1 << n) - 1 & t >>> 32 - n | A << n, t = t << n), i[f + 16 >> 2] = t, i[f + 20 >> 2] = u, f = 64 - r | 0, r = e, e = f & 31, (f & 63) >>> 0 >= 32 ? A = A >>> e | 0 : A = ((1 << e) - 1 & A) << 32 - e | r >>> e, A;
                        }
                        function $m(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n, r = i[f + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((r | 0) == 3 | i[k + 4 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(i[e >> 2] == 1 & (i[e + 4 >> 2] & -2) == 10)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r - 1 >>> 0 >= 3) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (r = I[f + 24 >> 1], !(r >>> 0 > 14 | !(1 << r & 18689))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = V8(n + 4 | 0), i[r >> 2] = 0, i[r + 4 >> 2] = i[f + 4 >> 2], e = l[f + 8 | 0], i[r + 12 >> 2] = 8, o[r + 8 | 0] = e, i[r + 20 >> 2] = i[f + 20 >> 2], e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 23 | 0] = e, o[r + 24 | 0] = e >>> 8, o[r + 25 | 0] = e >>> 16, o[r + 26 | 0] = e >>> 24, i[n >> 2] = 11, $2(A, r, n);
                            }
                            m = n + 32 | 0;
                        }
                        function am(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 5851);
                                    break i;
                                }
                                if (n = r, t = n2(e), i[n + 104 >> 2] = t, n = r, t = n2(e), i[n + 108 >> 2] = t, n = r, t = n2(e), i[n + 112 >> 2] = t, n = r, t = n2(e), i[n + 116 >> 2] = t, n = r, t = n2(e), i[n + 120 >> 2] = t, B4(f + 20 | 0, e), o[r + 135 | 0] < 0 && X(i[r + 124 >> 2]), k = i[f + 24 >> 2], i[r + 124 >> 2] = i[f + 20 >> 2], i[r + 128 >> 2] = k, i[r + 132 >> 2] = i[f + 28 >> 2], l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function bm(A, r, e, f, k, n, t, u, s, h, w, v) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0, w = w | 0, v = v | 0;
                            var _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0, y = 0;
                            if ((v | 0) > 0) {
                                if (!((t | 0) <= 0 | (n | 0) <= 0)) for(G = (s + w | 0) + 1 << v, W = v + 1 | 0, V = n & 2147483646, y = n & 1;;){
                                    if (v = Z(r, B) + A | 0, s = Z(k, B) << 1, w = s + f | 0, s = e + s | 0, C = 0, (n | 0) != 1) for(; _ = (Z(Q[s >> 1], u) + G | 0) + Z(Q[w >> 1], h) >> W, _ = (_ | 0) >= 255 ? 255 : _, o[v | 0] = (_ | 0) > 0 ? _ : 0, _ = (Z(Q[s + 2 >> 1], u) + G | 0) + Z(Q[w + 2 >> 1], h) >> W, _ = (_ | 0) >= 255 ? 255 : _, o[v + 1 | 0] = (_ | 0) > 0 ? _ : 0, w = w + 4 | 0, s = s + 4 | 0, v = v + 2 | 0, C = C + 2 | 0, (V | 0) != (C | 0););
                                    if (y && (s = (Z(Q[s >> 1], u) + G | 0) + Z(Q[w >> 1], h) >> W, s = (s | 0) >= 255 ? 255 : s, o[v | 0] = (s | 0) > 0 ? s : 0), B = B + 1 | 0, (B | 0) == (t | 0)) break;
                                }
                                return;
                            }
                            y0(18127, 14969, 80, 8438), z();
                        }
                        function dm(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            r = i[A + 84 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 76 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 56 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 48 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            if (r = i[A + 32 >> 2], r) {
                                if (e = r, f = i[A + 36 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        e = i[f - 4 >> 2];
                                        i: {
                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (f = f - 8 | 0, (r | 0) == (f | 0)) break;
                                    }
                                    e = i[A + 32 >> 2];
                                }
                                i[A + 36 >> 2] = r, X(e);
                            }
                        }
                        function xe(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0;
                            if (h = m - 16 | 0, m = h, (r ^ -1) + 2147483639 >>> 0 >= e >>> 0) {
                                l[A + 11 | 0] >>> 7 | 0 ? s = i[A >> 2] : s = A, w = s, s = h + 4 | 0, v = s, r >>> 0 < 1073741811 ? (i[h + 12 >> 2] = r << 1, i[h + 4 >> 2] = r + e, e = m - 16 | 0, m = e, m = e + 16 | 0, e = h + 12 | 0, e = i[(k0[s >> 2] < k0[e >> 2] ? e : s) >> 2], e >>> 0 >= 11 ? (s = e + 8 & -8, e = s - 1 | 0, e = (e | 0) == 11 ? s : e) : e = 10, e = e + 1 | 0) : e = 2147483639, N6(v, e), e = i[h + 4 >> 2], k && f8(w, k, e), t && f8(u, t, e + k | 0), s = k + n | 0, u = f - s | 0, (f | 0) != (s | 0) && f8((k + w | 0) + n | 0, u, (e + k | 0) + t | 0), (r | 0) != 10 && y8(w, 1), i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[h + 8 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, r = A, A = u + (k + t | 0) | 0, i[r + 4 >> 2] = A, o[h + 12 | 0] = 0, o[A + e | 0] = l[h + 12 | 0], m = h + 16 | 0;
                                return;
                            }
                            u4(), z();
                        }
                        function cm(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                if (!(e && r)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 5, i[A + 4 >> 2] = 2001;
                                    break i;
                                }
                                if (!l[i[r >> 2] + 272 | 0]) {
                                    if (o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 5, 139, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                f = D(80), i[f + 16 >> 2] = 0, i[f + 20 >> 2] = 0, Q[f + 12 >> 1] = 1, i[f + 8 >> 2] = 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[f + 48 >> 2] = 0, i[f + 52 >> 2] = 0, i[f + 40 >> 2] = 0, i[f + 44 >> 2] = 1072693248, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, i[f + 32 >> 2] = 0, i[f + 36 >> 2] = 0, i[f + 56 >> 2] = 0, i[f + 60 >> 2] = 0, n = f - -64 | 0, i[n >> 2] = 0, i[n + 4 >> 2] = 0, i[f + 72 >> 2] = 0, i[e >> 2] = f, v0(f, i[r >> 2] + 280 | 0, 76), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                            }
                            m = k + 32 | 0;
                        }
                        function wn(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            n = i[26106], i[A + 72 >> 2] <= 0 && KA(A), i[26106] = i[A + 136 >> 2], e = m - 32 | 0, m = e;
                            i: {
                                e: {
                                    r: {
                                        if (r = i[A + 4 >> 2], f = i[A + 8 >> 2], (r | 0) == (f | 0) || (r = Qn(e + 28 | 0, r, f - r | 0), (r | 0) == -1)) break r;
                                        i[A + 4 >> 2] = !r + (r + i[A + 4 >> 2] | 0);
                                        break e;
                                    }
                                    for(i[e + 16 >> 2] = 0, i[e + 20 >> 2] = 0, r = 0;;){
                                        f = r;
                                        r: {
                                            if (r = i[A + 4 >> 2], (r | 0) != i[A + 8 >> 2]) {
                                                i[A + 4 >> 2] = r + 1, o[e + 15 | 0] = l[r | 0];
                                                break r;
                                            }
                                            if (r = nr(A), o[e + 15 | 0] = r, (r | 0) >= 0) break r;
                                            if (r = -1, !(f & 1)) break i;
                                            i[A >> 2] = i[A >> 2] | 32, i[26064] = 25;
                                            break i;
                                        }
                                        if (r = 1, k = _i(e + 28 | 0, e + 15 | 0, 1, e + 16 | 0), (k | 0) != -2) break;
                                    }
                                    if (r = -1, (k | 0) != -1) break e;
                                    if (!(f & 1)) break i;
                                    i[A >> 2] = i[A >> 2] | 32, F6(l[e + 15 | 0], A);
                                    break i;
                                }
                                r = i[e + 28 >> 2];
                            }
                            return m = e + 32 | 0, i[26106] = n, r;
                        }
                        function r1(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (n = i[A + 8 >> 2], f = i[A + 4 >> 2], n - f >>> 0 >= r >>> 0) {
                                r && (f = B0(f, 0, r) + r | 0), i[A + 4 >> 2] = f;
                                return;
                            }
                            if (k = i[A >> 2], t = f - k | 0, e = t + r | 0, (e | 0) >= 0) {
                                n = n - k | 0, u = n << 1, e = n >>> 0 >= 1073741823 ? 2147483647 : e >>> 0 < u >>> 0 ? u : e, e && (s = D(e)), n = e + s | 0, u = r, e = t + s | 0, r = B0(e, 0, r), u = u + r | 0;
                                i: {
                                    if ((f | 0) == (k | 0)) {
                                        s = r;
                                        break i;
                                    }
                                    h = t & 3;
                                    e: {
                                        if (!h) {
                                            r = f;
                                            break e;
                                        }
                                        for(t = 0, r = f; e = e - 1 | 0, r = r - 1 | 0, o[e | 0] = l[r | 0], t = t + 1 | 0, (h | 0) != (t | 0););
                                    }
                                    if (k - f >>> 0 <= 4294967292) for(; o[e - 1 | 0] = l[r - 1 | 0], o[e - 2 | 0] = l[r - 2 | 0], o[e - 3 | 0] = l[r - 3 | 0], e = e - 4 | 0, r = r - 4 | 0, o[e | 0] = l[r | 0], (r | 0) != (k | 0););
                                    k = i[A >> 2];
                                }
                                i[A + 8 >> 2] = n, i[A + 4 >> 2] = u, i[A >> 2] = s, k && X(k);
                                return;
                            }
                            p0(), z();
                        }
                        function iZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(i[e >> 2] == 1 & (i[e + 4 >> 2] & -2) == 10)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (I[f + 24 >> 1]) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (e = l[f + 26 | 0], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (e | 0) != 1) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, i[r + 16 >> 2] = 8, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 3, e = l[f + 8 | 0], i[r + 16 >> 2] = 8, o[r + 12 | 0] = e, e = l[f + 23 | 0] | l[f + 24 | 0] << 8 | (l[f + 25 | 0] << 16 | l[f + 26 | 0] << 24), o[r + 27 | 0] = e, o[r + 28 | 0] = e >>> 8, o[r + 29 | 0] = e >>> 16, o[r + 30 | 0] = e >>> 24, i[r + 24 >> 2] = i[f + 20 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function vn(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            i: {
                                if (n = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, k = i[n >> 2], k) for(;;){
                                    u = n;
                                    e: {
                                        if (d1(i[k + 4 >> 2], e)) break e;
                                        r: {
                                            if (i[k + 8 >> 2] == 1) {
                                                if (n = 0, s = 0, h = 0, w = l[k + 16 | 0], w && (h = i[k + 24 >> 2], s = i[k + 20 >> 2]), t = i[k + 32 >> 2], n = (t | 0) > 0 ? i[k + 28 >> 2] : n, !(!w | !((f | 0) < (s | 0) | (f | 0) > (h | 0)))) break i;
                                                if (k = 0, (t | 0) > 0) break r;
                                                break e;
                                            }
                                            i[A >> 2] = 5, r = i[19882], i[A + 4 >> 2] = i[19881], i[A + 8 >> 2] = r;
                                            return;
                                        }
                                        for(;;){
                                            if (i[(k << 2) + n >> 2] == (f | 0)) break e;
                                            if (k = k + 1 | 0, (t | 0) == (k | 0)) break;
                                        }
                                        break i;
                                    }
                                    if (n = u + 4 | 0, k = i[u + 4 >> 2], !k) break;
                                }
                                p[i[i[r >> 2] + 72 >> 2]](A, i[r + 4 >> 2], e, f);
                                return;
                            }
                            r = i[19878], i[A >> 2] = i[19877], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19879];
                        }
                        function eZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0;
                            f = m - 16 | 0, m = f, n = i[e >> 2], k = i[e + 4 >> 2];
                            i: {
                                if (k) {
                                    if (i[k + 4 >> 2] = i[k + 4 >> 2] + 1, t = r, u = p[i[i[n >> 2] + 8 >> 2]](n) | 0, i[t + 112 >> 2] = u, i[r + 116 >> 2] = w0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, r = i[k + 4 >> 2], i[k + 4 >> 2] = r - 1, r) break i;
                                    p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                                    break i;
                                }
                                t = r, u = p[i[i[n >> 2] + 8 >> 2]](n) | 0, i[t + 112 >> 2] = u, i[r + 116 >> 2] = w0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0;
                            }
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function _n(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (_r(), e = i[21678], (e | 0) == 86716) return 0;
                            i: {
                                if (!r) {
                                    for(;;){
                                        n = i[e + 16 >> 2], r = p[i[n + 16 >> 2]](A) | 0, k = (r | 0) > (t | 0), f = i[e + 4 >> 2];
                                        e: {
                                            if (f) {
                                                for(;;)if (e = f, f = i[e >> 2], !f) break e;
                                            }
                                            for(; f = e, e = i[e + 8 >> 2], (f | 0) != i[e >> 2];);
                                        }
                                        if (t = k ? r : t, s = k ? n : s, (e | 0) == 86716) break;
                                    }
                                    break i;
                                }
                                for(;;){
                                    e: {
                                        if (u = i[e + 16 >> 2], k = p[i[u + 16 >> 2]](A) | 0, (k | 0) <= 0 | i[u >> 2] < 3 || d1(r, i[u + 40 >> 2])) break e;
                                        return u;
                                    }
                                    n = (t | 0) < (k | 0), f = i[e + 4 >> 2];
                                    e: {
                                        if (f) {
                                            for(;;)if (e = f, f = i[e >> 2], !f) break e;
                                        }
                                        for(; f = e, e = i[e + 8 >> 2], (f | 0) != i[e >> 2];);
                                    }
                                    if (t = n ? k : t, s = n ? u : s, (e | 0) == 86716) break;
                                }
                            }
                            return s;
                        }
                        function Bn(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0;
                            if (n = D(24), i[n + 20 >> 2] = r, o[n + 8 | 0] = e, i[n >> 2] = 51180, i[n + 4 >> 2] = 0, i[n + 16 >> 2] = k, i[n + 12 >> 2] = f, i[r + 18604 >> 2] = n, Ii(A + 1392 | 0, n), f = i[r + 18596 >> 2], r = i[f + 460 >> 2], e = i[f + 464 >> 2], r >>> 0 < e >>> 0) {
                                i[r >> 2] = n, i[f + 460 >> 2] = r + 4;
                                return;
                            }
                            i: {
                                if (k = i[f + 456 >> 2], t = r - k >> 2, A = t + 1 | 0, A >>> 0 < 1073741824) {
                                    if (u = t << 2, e = e - k | 0, t = e >> 1, t = e >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < t >>> 0 ? t : A, t) {
                                        if (t >>> 0 >= 1073741824) break i;
                                        A = D(t << 2);
                                    } else A = 0;
                                    if (e = u + A | 0, i[e >> 2] = n, n = e + 4 | 0, (r | 0) != (k | 0)) {
                                        for(; e = e - 4 | 0, r = r - 4 | 0, i[e >> 2] = i[r >> 2], (r | 0) != (k | 0););
                                        k = i[f + 456 >> 2];
                                    }
                                    i[f + 464 >> 2] = A + (t << 2), i[f + 460 >> 2] = n, i[f + 456 >> 2] = e, k && X(k), i[f + 460 >> 2] = n;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function rZ(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = m - 32 | 0, m = t, i[t + 28 >> 2] = r;
                            i: {
                                if (!(i[f + 4 >> 2] & 1)) {
                                    i[t >> 2] = -1, r = p[i[i[A >> 2] + 16 >> 2]](A, r, e, f, k, t) | 0;
                                    e: switch(i[t >> 2]){
                                        case 0:
                                            o[n | 0] = 0;
                                            break i;
                                        case 1:
                                            o[n | 0] = 1;
                                            break i;
                                        default:
                                            break e;
                                    }
                                    o[n | 0] = 1, i[k >> 2] = 4;
                                    break i;
                                }
                                for(A = i[f + 28 >> 2], i[t >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), r = K0(t, 108580), d0(t), A = i[f + 28 >> 2], i[t >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(t, 108636), d0(t), p[i[i[A >> 2] + 24 >> 2]](t, A), p[i[i[A >> 2] + 28 >> 2]](t | 12, A), f = t + 24 | 0, u = n, s = (Ie(t + 28 | 0, e, t, f, r, k, 1) | 0) == (t | 0), o[u | 0] = s, r = i[t + 28 >> 2]; f = a0(f - 12 | 0), (t | 0) != (f | 0););
                            }
                            return m = t + 32 | 0, r | 0;
                        }
                        function AZ(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = m - 32 | 0, m = t, i[t + 28 >> 2] = r;
                            i: {
                                if (!(i[f + 4 >> 2] & 1)) {
                                    i[t >> 2] = -1, r = p[i[i[A >> 2] + 16 >> 2]](A, r, e, f, k, t) | 0;
                                    e: switch(i[t >> 2]){
                                        case 0:
                                            o[n | 0] = 0;
                                            break i;
                                        case 1:
                                            o[n | 0] = 1;
                                            break i;
                                        default:
                                            break e;
                                    }
                                    o[n | 0] = 1, i[k >> 2] = 4;
                                    break i;
                                }
                                for(A = i[f + 28 >> 2], i[t >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), r = K0(t, 108572), d0(t), A = i[f + 28 >> 2], i[t >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(t, 108644), d0(t), p[i[i[A >> 2] + 24 >> 2]](t, A), p[i[i[A >> 2] + 28 >> 2]](t | 12, A), f = t + 24 | 0, u = n, s = (Fe(t + 28 | 0, e, t, f, r, k, 1) | 0) == (t | 0), o[u | 0] = s, r = i[t + 28 >> 2]; f = h1(f - 12 | 0), (t | 0) != (f | 0););
                            }
                            return m = t + 32 | 0, r | 0;
                        }
                        function O3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            if (k = m - 16 | 0, m = k, i[k + 12 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, f = i[A + 28 >> 2], t = i[A + 32 >> 2], (f | 0) != (t | 0)) {
                                for(;;){
                                    if (n = i[f >> 2], (n | 0) != i[r >> 2]) {
                                        i: {
                                            if (k0[k + 12 >> 2] > e >>> 0) {
                                                i[e >> 2] = n, n = i[f + 4 >> 2], i[e + 4 >> 2] = n, n && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), e = e + 8 | 0;
                                                break i;
                                            }
                                            e = P2(k + 4 | 0, f);
                                        }
                                        i[k + 8 >> 2] = e;
                                    }
                                    if (f = f + 8 | 0, (t | 0) == (f | 0)) break;
                                }
                                f = i[A + 28 >> 2];
                            }
                            if (f) {
                                if (e = i[A + 32 >> 2], r = f, (e | 0) != (f | 0)) {
                                    for(;;){
                                        r = i[e - 4 >> 2];
                                        i: {
                                            if (!r || (n = i[r + 4 >> 2], i[r + 4 >> 2] = n - 1, n)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (e = e - 8 | 0, (f | 0) == (e | 0)) break;
                                    }
                                    r = i[A + 28 >> 2];
                                }
                                i[A + 32 >> 2] = f, X(r), e = i[k + 8 >> 2];
                            }
                            r = i[k + 4 >> 2], i[A + 32 >> 2] = e, i[A + 28 >> 2] = r, i[A + 36 >> 2] = i[k + 12 >> 2], m = k + 16 | 0;
                        }
                        function vi(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            B0(A + 38 | 0, 0, 2064), i[A + 18524 >> 2] = -1, i[A + 18528 >> 2] = -1;
                            i: {
                                e: {
                                    if (f = i[i[A + 18592 >> 2] + 24 >> 2], (f | 0) > 0) {
                                        if (t = i[A + 18588 >> 2], r = i[t + 124 >> 2], k = i[r + 484 >> 2] - 1 | 0, n = i[t + 132 >> 2], n = i[(i[n + 8460 >> 2] + (i[i[n + 8448 >> 2] + (f << 2) >> 2] << 2) | 0) - 4 >> 2], e = i[r + 16892 >> 2], f = (n | 0) / (e | 0) | 0, e = (n - Z(f, e) | 0) + 1 | 0, n = i[r + 16876 >> 2], e = (e << n) - 1 | 0, k = (k | 0) < (e | 0) ? k : e, e = i[t + 168 >> 2], k = k >> e, (k | 0) < 0 || (u = i[t + 172 >> 2], (k | 0) >= (u | 0))) break e;
                                        if (r = i[r + 488 >> 2] - 1 | 0, f = (f + 1 << n) - 1 | 0, r = ((r | 0) < (f | 0) ? r : f) >> e, (r | 0) < 0 | (r | 0) >= i[t + 176 >> 2]) break i;
                                        i[A + 18520 >> 2] = o[((i[t + 160 >> 2] + Z(k, 3) | 0) + Z(Z(r, u), 3) | 0) + 2 | 0];
                                    }
                                    return;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function ze(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (k = i[A + 8 >> 2], n = i[A + 4 >> 2], k - n >>> 0 >= r >>> 0) {
                                r && (n = B0(n, l[e | 0], r) + r | 0), i[A + 4 >> 2] = n;
                                return;
                            }
                            if (t = i[A >> 2], u = n - t | 0, f = u + r | 0, (f | 0) >= 0) {
                                if (k = k - t | 0, s = k << 1, k = k >>> 0 >= 1073741823 ? 2147483647 : f >>> 0 < s >>> 0 ? s : f, k ? f = D(k) : f = 0, k = f + k | 0, f = f + u | 0, s = B0(f, l[e | 0], r) + r | 0, (n | 0) != (t | 0)) {
                                    u = u & 3;
                                    i: {
                                        if (!u) {
                                            r = n;
                                            break i;
                                        }
                                        for(e = 0, r = n; f = f - 1 | 0, r = r - 1 | 0, o[f | 0] = l[r | 0], e = e + 1 | 0, (u | 0) != (e | 0););
                                    }
                                    if (t - n >>> 0 <= 4294967292) for(; o[f - 1 | 0] = l[r - 1 | 0], o[f - 2 | 0] = l[r - 2 | 0], o[f - 3 | 0] = l[r - 3 | 0], f = f - 4 | 0, r = r - 4 | 0, o[f | 0] = l[r | 0], (r | 0) != (t | 0););
                                    t = i[A >> 2];
                                }
                                i[A + 8 >> 2] = k, i[A + 4 >> 2] = s, i[A >> 2] = f, t && X(t);
                                return;
                            }
                            p0(), z();
                        }
                        function P3(A, r, e, f, k, n) {
                            var t = 0;
                            t = m - 32 | 0, m = t, i[t + 8 >> 2] = 0, i[t >> 2] = 0, i[t + 4 >> 2] = 0;
                            i: {
                                e: {
                                    if (n >>> 0 < 2) break e;
                                    r: switch(n - 3 | 0){
                                        case 1:
                                            if (o[t + 12 | 0] = 0, o[t + 23 | 0] = 0, i0(A, 4, 3005, t + 12 | 0), o[t + 23 | 0] >= 0) break i;
                                            X(i[t + 12 >> 2]);
                                            break i;
                                        case 0:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    if (o[t + 12 | 0] = 0, o[t + 23 | 0] = 0, i0(A, 4, 3005, t + 12 | 0), o[t + 23 | 0] >= 0) break i;
                                    X(i[t + 12 >> 2]);
                                    break i;
                                }
                                if (k && (r1(t, k), v0(i[t >> 2], f, k)), B3(t + 12 | 0, i[r + 68 >> 2], i[i[e >> 2] + 104 >> 2], t, 0), o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            A = i[t >> 2], A && (i[t + 4 >> 2] = A, X(A)), m = t + 32 | 0;
                        }
                        function mn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (e = m - 48 | 0, k = e, m = e, t = e - 48 | 0, m = t, o[t + 33 | 0] = 0, B0(t, 46, 33), s = t + 16 | 0, o[s | 0] = 124, e = l[A + 96 | 0], e) for(h = A - -64 | 0;;){
                                n = e, e = e - 1 | 0, u = l[h + e | 0], f = Q[(e << 1) + A >> 1];
                                i: {
                                    if (!((f | 0) >= -16 & (f | 0) <= 16)) {
                                        i[k + 32 >> 2] = f, i[k + 36 >> 2] = u ? 88 : 111, e0(r, 22586, k + 32 | 0);
                                        break i;
                                    }
                                    if (f = f + s | 0, u) {
                                        o[f | 0] = 88;
                                        break i;
                                    }
                                    o[f | 0] = 111;
                                }
                                if (!(n >>> 0 > 1)) break;
                            }
                            if (e = l[A + 97 | 0], e) for(u = A + 80 | 0, h = A + 32 | 0;;){
                                A = e, e = e - 1 | 0, f = l[u + e | 0], n = Q[h + (e << 1) >> 1];
                                i: {
                                    if (!((n | 0) >= -16 & (n | 0) <= 16)) {
                                        i[k + 16 >> 2] = n, i[k + 20 >> 2] = f ? 88 : 111, e0(r, 22586, k + 16 | 0);
                                        break i;
                                    }
                                    if (n = n + s | 0, f) {
                                        o[n | 0] = 88;
                                        break i;
                                    }
                                    o[n | 0] = 111;
                                }
                                if (!(A >>> 0 > 1)) break;
                            }
                            i[k >> 2] = t, e0(r, 25287, k), m = k + 48 | 0;
                        }
                        function Zn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (k = i[A + 8 >> 2], e = i[A + 4 >> 2], (k - e | 0) / 6 >>> 0 >= r >>> 0) {
                                r && (r = Z(r, 6) - 6 | 0, r = (r - ((r >>> 0) % 6 | 0) | 0) + 6 | 0, e = B0(e, 0, r) + r | 0), i[A + 4 >> 2] = e;
                                return;
                            }
                            i: {
                                if (n = i[A >> 2], t = (e - n | 0) / 6 | 0, f = t + r | 0, f >>> 0 < 715827883) {
                                    if (k = (k - n | 0) / 6 | 0, u = k << 1, k = k >>> 0 >= 357913941 ? 715827882 : f >>> 0 < u >>> 0 ? u : f, k) {
                                        if (k >>> 0 >= 715827883) break i;
                                        s = D(Z(k, 6));
                                    }
                                    if (f = Z(t, 6) + s | 0, r = Z(r, 6) - 6 | 0, r = (r - ((r >>> 0) % 6 | 0) | 0) + 6 | 0, r = B0(f, 0, r) + r | 0, (e | 0) != (n | 0)) {
                                        for(; f = f - 6 | 0, e = e - 6 | 0, t = I[e >> 1] | I[e + 2 >> 1] << 16, Q[f >> 1] = t, Q[f + 2 >> 1] = t >>> 16, Q[f + 4 >> 1] = I[e + 4 >> 1], (e | 0) != (n | 0););
                                        n = i[A >> 2];
                                    }
                                    i[A + 8 >> 2] = Z(k, 6) + s, i[A + 4 >> 2] = r, i[A >> 2] = f, n && X(n);
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function l0(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            if (k = i[A + 16 >> 2], !((k | 0) >= (r | 0) | (k | 0) > 56)) {
                                for(f = 64 - k | 0, k = i[A + 4 >> 2];;){
                                    i: {
                                        if (u = f, !k) {
                                            n = f;
                                            break i;
                                        }
                                        if (e = i[A >> 2], i[A >> 2] = e + 1, e = l[e | 0], k = k - 1 | 0, i[A + 4 >> 2] = k, t = i[A + 12 >> 2], n = u - 8 | 0, s = n & 31, w = A, (n & 63) >>> 0 >= 32 ? (h = e << s, e = 0) : (h = (1 << s) - 1 & e >>> 32 - s, e = e << s), i[w + 8 >> 2] = e | i[A + 8 >> 2], i[A + 12 >> 2] = t | h, e = f, f = e - 8 | 0, v = v - (e >>> 0 < 8) | 0, (u | 0) > 15) continue;
                                    }
                                    break;
                                }
                                k = 64 - n | 0;
                            }
                            return i[A + 16 >> 2] = k - r, e = i[A + 8 >> 2], f = A, f = A, A = i[A + 12 >> 2], n = e, t = r & 31, (r & 63) >>> 0 >= 32 ? (u = e << t, n = 0) : (u = (1 << t) - 1 & n >>> 32 - t | A << t, n = n << t), i[f + 8 >> 2] = n, i[f + 12 >> 2] = u, f = 64 - r | 0, r = e, e = f & 31, (f & 63) >>> 0 >= 32 ? A = A >>> e | 0 : A = ((1 << e) - 1 & A) << 32 - e | r >>> e, A;
                        }
                        function fZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 7997);
                                    break i;
                                }
                                e: {
                                    if (o[r + 100 | 0] & 1) {
                                        if (o[r + 115 | 0] < 0) {
                                            o[i[r + 104 >> 2]] = 0, i[r + 108 >> 2] = 0;
                                            break e;
                                        }
                                        o[r + 115 | 0] = 0, o[r + 104 | 0] = 0;
                                        break e;
                                    }
                                    B4(f + 20 | 0, e), o[r + 115 | 0] < 0 && X(i[r + 104 >> 2]), k = i[f + 24 >> 2], i[r + 104 >> 2] = i[f + 20 >> 2], i[r + 108 >> 2] = k, i[r + 112 >> 2] = i[f + 28 >> 2];
                                }
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function Gn(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            if (k = D(20), i[k + 16 >> 2] = r, o[k + 8 | 0] = e, i[k >> 2] = 51244, i[k + 4 >> 2] = 0, i[k + 12 >> 2] = f, i[r + 18604 >> 2] = k, Ii(A + 1392 | 0, k), t = i[r + 18596 >> 2], r = i[t + 460 >> 2], e = i[t + 464 >> 2], r >>> 0 < e >>> 0) {
                                i[r >> 2] = k, i[t + 460 >> 2] = r + 4;
                                return;
                            }
                            i: {
                                if (f = i[t + 456 >> 2], n = r - f >> 2, A = n + 1 | 0, A >>> 0 < 1073741824) {
                                    if (u = n << 2, e = e - f | 0, n = e >> 1, n = e >>> 0 >= 2147483644 ? 1073741823 : A >>> 0 < n >>> 0 ? n : A, n) {
                                        if (n >>> 0 >= 1073741824) break i;
                                        A = D(n << 2);
                                    } else A = 0;
                                    if (e = u + A | 0, i[e >> 2] = k, k = e + 4 | 0, (r | 0) != (f | 0)) {
                                        for(; e = e - 4 | 0, r = r - 4 | 0, i[e >> 2] = i[r >> 2], (r | 0) != (f | 0););
                                        f = i[t + 456 >> 2];
                                    }
                                    i[t + 464 >> 2] = A + (n << 2), i[t + 460 >> 2] = k, i[t + 456 >> 2] = e, f && X(f), i[t + 460 >> 2] = k;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function kZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            if (p[i[i[A >> 2] + 24 >> 2]](A), r = K0(r, 108588), i[A + 68 >> 2] = r, e = l[A + 98 | 0], r = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[A + 98 | 0] = r, (r | 0) != (e | 0)) {
                                if (i[A + 16 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0, r = l[A + 96 | 0], l[A + 98 | 0] == 1) {
                                    i: {
                                        if (!(r & 1) || (r = i[A + 32 >> 2], !r)) break i;
                                        X(r);
                                    }
                                    o[A + 96 | 0] = l[A + 97 | 0], i[A + 52 >> 2] = i[A + 60 >> 2], r = i[A + 56 >> 2], i[A + 56 >> 2] = 0, i[A + 60 >> 2] = 0, i[A + 32 >> 2] = r, o[A + 97 | 0] = 0;
                                    return;
                                }
                                i: {
                                    if (r & 1 || (r = i[A + 32 >> 2], (r | 0) == (A + 44 | 0))) break i;
                                    o[A + 97 | 0] = 0, i[A + 56 >> 2] = r, r = i[A + 52 >> 2], i[A + 60 >> 2] = r, r = D(r), o[A + 96 | 0] = 1, i[A + 32 >> 2] = r;
                                    return;
                                }
                                r = i[A + 52 >> 2], i[A + 60 >> 2] = r, r = D(r), o[A + 97 | 0] = 1, i[A + 56 >> 2] = r;
                            }
                        }
                        function nZ(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0;
                            i: {
                                if (h = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, r = i[h >> 2], !r) break i;
                                for(;;){
                                    if (d1(i[r + 4 >> 2], e)) {
                                        if (r = i[h + 4 >> 2], h = h + 4 | 0, r) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (i[r + 8 >> 2] != 1) {
                                    r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                    return;
                                }
                                e: {
                                    if (!l[r + 16 | 0] || (n && (i[n >> 2] = i[r + 20 >> 2]), !t)) break e;
                                    i[t >> 2] = i[r + 24 >> 2];
                                }
                                f && (i[f >> 2] = l[r + 16 | 0]), k && (i[k >> 2] = l[r + 16 | 0]), !s | i[r + 32 >> 2] <= 0 || (i[s >> 2] = i[r + 28 >> 2]), u && (i[u >> 2] = i[r + 32 >> 2]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                return;
                            }
                            r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                        }
                        function tZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                e: {
                                    if (t = i[r >> 2], n = i[t + 180 >> 2], s = i[t + 184 >> 2], (n | 0) == (s | 0)) break e;
                                    for(;;){
                                        if (u = i[n >> 2], i[u >> 2] != (e | 0)) {
                                            if (n = n + 8 | 0, (s | 0) != (n | 0)) continue;
                                            break e;
                                        }
                                        break;
                                    }
                                    if (e = i[u + 40 >> 2], n = i[u + 44 >> 2], (e | 0) != (n | 0)) {
                                        if (!f) {
                                            if (o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 5, 2001, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                            X(i[e + 8 >> 2]);
                                            break i;
                                        }
                                        v0(f, e, n - e | 0), t = i[r >> 2];
                                    }
                                    j0(A, 86672, t ? t + 4 | 0 : 0);
                                    break i;
                                }
                                if (o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 5, 2e3, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), f = A, A = i[r >> 2], j0(f, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                X(i[e + 8 >> 2]);
                            }
                            m = k + 32 | 0;
                        }
                        function oZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            e = m - 32 | 0, m = e;
                            i: {
                                e: {
                                    r: {
                                        if ((r | 0) == -1) break r;
                                        if (f = r << 24 >> 24, o[e + 23 | 0] = f, l[A + 44 | 0] == 1) {
                                            if (k = i[A + 32 >> 2], A = m - 16 | 0, m = A, o[A + 15 | 0] = f, f = E1(A + 15 | 0, 1, 1, k), m = A + 16 | 0, (f | 0) != 1) break e;
                                            break r;
                                        }
                                        for(n = e + 24 | 0, i[e + 16 >> 2] = n, u = e + 32 | 0, f = e + 23 | 0;;){
                                            if (k = i[A + 36 >> 2], k = p[i[i[k >> 2] + 12 >> 2]](k, i[A + 40 >> 2], f, n, e + 12 | 0, e + 24 | 0, u, e + 16 | 0) | 0, i[e + 12 >> 2] == (f | 0)) break e;
                                            if ((k | 0) == 3) {
                                                if ((E1(f, 1, 1, i[A + 32 >> 2]) | 0) == 1) break r;
                                                break e;
                                            }
                                            if (k >>> 0 > 1 || (t = e + 24 | 0, f = i[e + 16 >> 2] - t | 0, (E1(t, 1, f, i[A + 32 >> 2]) | 0) != (f | 0))) break e;
                                            if (f = i[e + 12 >> 2], (k | 0) != 1) break;
                                        }
                                    }
                                    A = (r | 0) != -1 ? r : 0;
                                    break i;
                                }
                                A = -1;
                            }
                            return m = e + 32 | 0, A | 0;
                        }
                        function uZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((f | 0) == 3 | i[k + 8 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(!(i[e >> 2] | (f | 0) != 1) & i[e + 12 >> 2] == 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], !(f >>> 0 > 14 | !(1 << f & 18689))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (e = l[e + 26 | 0], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (e | 0) != 1) break i;
                                o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, i[r + 16 >> 2] = 8, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 16 >> 2] = 8, o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 11, i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function lZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 5, 2001, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                k = i[r >> 2], n = i[k + 192 >> 2], k = i[k + 196 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                e: {
                                    if (!n) {
                                        if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 10, 0, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    if (t = f + 12 | 0, g5(t, n, e), e = A, A = i[r >> 2], j0(e, t, A ? A + 4 | 0 : 0), o[f + 31 | 0] >= 0) break e;
                                    X(i[f + 20 >> 2]);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 32 | 0;
                        }
                        function sZ(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0;
                            if (!((n | 0) <= 0 | (k | 0) <= 0)) for(t = k - 1 | 0, _ = t & 4, B = (t >>> 2 | 0) + 1 & 2147483646, G = k >>> 0 < 5;;){
                                if (k = Z(f, w) + e | 0, t = (Z(r, w) << 1) + A | 0, u = 0, !G) for(; s = l[k | 0], h = l[k + 1 | 0], v = l[k + 2 | 0], Q[t + 6 >> 1] = l[k + 3 | 0] << 6, Q[t + 4 >> 1] = v << 6, Q[t + 2 >> 1] = h << 6, Q[t >> 1] = s << 6, s = l[k + 4 | 0], h = l[k + 5 | 0], v = l[k + 6 | 0], Q[t + 14 >> 1] = l[k + 7 | 0] << 6, Q[t + 12 >> 1] = v << 6, Q[t + 10 >> 1] = h << 6, Q[t + 8 >> 1] = s << 6, k = k + 8 | 0, t = t + 16 | 0, u = u + 2 | 0, (B | 0) != (u | 0););
                                if (_ || (u = l[k | 0], s = l[k + 1 | 0], h = l[k + 2 | 0], Q[t + 6 >> 1] = l[k + 3 | 0] << 6, Q[t + 4 >> 1] = h << 6, Q[t + 2 >> 1] = s << 6, Q[t >> 1] = u << 6), w = w + 1 | 0, (w | 0) == (n | 0)) break;
                            }
                        }
                        function Wn(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if (n = i[A + 24 >> 2], k = i[A + 28 >> 2], n >>> 0 < k >>> 0) {
                                i[n + 8 >> 2] = f, i[n + 4 >> 2] = e, i[n >> 2] = r, i[A + 24 >> 2] = n + 12;
                                return;
                            }
                            i: {
                                if (u = i[A + 20 >> 2], t = (n - u | 0) / 12 | 0, s = t + 1 | 0, s >>> 0 < 357913942) {
                                    if (h = Z(t, 12), k = (k - u | 0) / 12 | 0, t = k << 1, t = k >>> 0 >= 178956970 ? 357913941 : t >>> 0 > s >>> 0 ? t : s, t) {
                                        if (t >>> 0 >= 357913942) break i;
                                        s = D(Z(t, 12));
                                    } else s = 0;
                                    if (k = h + s | 0, i[k + 8 >> 2] = f, i[k + 4 >> 2] = e, i[k >> 2] = r, r = k + 12 | 0, (n | 0) != (u | 0)) {
                                        for(; n = n - 12 | 0, e = i[n + 4 >> 2], k = k - 12 | 0, i[k >> 2] = i[n >> 2], i[k + 4 >> 2] = e, i[k + 8 >> 2] = i[n + 8 >> 2], (n | 0) != (u | 0););
                                        u = i[A + 20 >> 2];
                                    }
                                    i[A + 28 >> 2] = s + Z(t, 12), i[A + 24 >> 2] = r, i[A + 20 >> 2] = k, u && X(u), i[A + 24 >> 2] = r;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function hZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 5, 2001, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 8 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                k = i[r >> 2], n = i[k + 44 >> 2], k = i[k + 48 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                e: {
                                    if (!n) {
                                        if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 10, 0, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 8 | 0 : 0), o[e + 19 | 0] >= 0) break e;
                                        X(i[e + 8 >> 2]);
                                        break e;
                                    }
                                    if (t = f + 12 | 0, g5(t, n, e), e = A, A = i[r >> 2], j0(e, t, A ? A + 8 | 0 : 0), o[f + 31 | 0] >= 0) break e;
                                    X(i[f + 20 >> 2]);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 32 | 0;
                        }
                        function wZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            k = m - 32 | 0, m = k, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l1(e, l[r + 97 | 0] ? 4 : 2, i[r + 40 >> 2] - i[r + 36 >> 2] >> 3, 0), f = i[r + 36 >> 2], t = i[r + 40 >> 2];
                            i: {
                                if ((f | 0) != (t | 0)) for(;;){
                                    if (u = i[f >> 2], p[i[i[u >> 2] + 16 >> 2]](A, u, e), i[A >> 2]) break i;
                                    if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), f = f + 8 | 0, (t | 0) == (f | 0)) break;
                                }
                                if (f = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = f, A = A + 8 | 0, o[86691] >= 0) {
                                    f = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](k + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function vZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            n = m - 192 | 0, m = n, i[n + 112 >> 2] = 60468, t = i[15120], i[n + 8 >> 2] = t, u = i[t - 12 >> 2], t = n + 8 | 0, i[u + t >> 2] = i[15121], u = t + i[i[n + 8 >> 2] - 12 >> 2] | 0, s = n + 12 | 0, T0(u, s), i[u + 72 >> 2] = 0, i[u + 76 >> 2] = -1, i[n + 112 >> 2] = 60468, i[n + 8 >> 2] = 60448, u = $n(s), n5(u, k, 20) || (k = t + i[i[n + 8 >> 2] - 12 >> 2] | 0, N1(k, i[k + 16 >> 2] | 4)), t = m - 16 | 0, m = t, k = n + 8 | 0, C1(t + 8 | 0, k);
                            i: {
                                if (!f | !l[t + 8 | 0] || (s = i[(k + i[i[k >> 2] - 12 >> 2] | 0) + 24 >> 2], (p[i[i[s >> 2] + 48 >> 2]](s, e, f) | 0) == (f | 0))) break i;
                                Gf(k + i[i[k >> 2] - 12 >> 2] | 0, 1);
                            }
                            G1(t + 8 | 0), m = t + 16 | 0, j0(A, 86672, i[r >> 2]), A = i[15119], i[n + 8 >> 2] = A, i[k + i[A - 12 >> 2] >> 2] = i[15122], pi(u), N0(n + 112 | 0), m = n + 192 | 0;
                        }
                        function _Z(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 48 | 0, m = r;
                            i: {
                                if (!(!(!l[e + 8 | 0] | k0[e + 4 >> 2] > 3) & l[f + 8 | 0] != 1)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[r + 28 >> 2] = 8, o[r + 24 | 0] = 0, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 2, i[r + 36 >> 2] = 131074, i[r + 16 >> 2] = 99, i[r + 20 >> 2] = 99, i[r + 32 >> 2] = 78668, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 6, i[r + 36 >> 2] = 851969, f = i[e + 12 >> 2], i[r + 24 >> 2] = i[e + 8 >> 2], i[r + 28 >> 2] = f, f = i[e + 4 >> 2], i[r + 16 >> 2] = i[e >> 2], i[r + 20 >> 2] = f, f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 39 | 0] = f, o[r + 40 | 0] = f >>> 8, o[r + 41 | 0] = f >>> 16, o[r + 42 | 0] = f >>> 24, e = i[e + 20 >> 2], o[r + 24 | 0] = 0, i[r + 36 >> 2] = e, i[r + 12 >> 2] = 1, $2(A, r + 16 | 0, r + 12 | 0);
                            }
                            m = r + 48 | 0;
                        }
                        function Xn(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = D(24), o[f + 22 | 0] = 1, Q[f + 20 >> 1] = 2, i[f + 16 >> 2] = 131074, i[f + 12 >> 2] = 78668, i[f + 4 >> 2] = 0, i[f + 8 >> 2] = 0, i[f >> 2] = 78292, k = f + 12 | 0, o[k + 10 | 0] = 1, Q[k + 8 >> 1] = 6, i[k + 4 >> 2] = 851969, Q[f + 16 >> 1] = i[e + 4 >> 2], Q[f + 18 >> 1] = i[e + 8 >> 2], Q[f + 20 >> 1] = i[e + 12 >> 2], o[f + 22 | 0] = l[e + 16 | 0] != 0, e = i[r >> 2], i[f + 4 >> 2] = i[f + 4 >> 2] + 2, i[e + 44 >> 2] = k, r = i[e + 48 >> 2], i[e + 48 >> 2] = f;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[f + 4 >> 2], i[f + 4 >> 2] = r - 1, r || (p[i[i[f >> 2] + 8 >> 2]](f), g(f)), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A || (p[i[i[f >> 2] + 8 >> 2]](f), g(f));
                        }
                        function L3(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            i: {
                                if (e = i[A >> 2], k = (i[A + 4 >> 2] - e | 0) / 56 | 0, f = k + 1 | 0, f >>> 0 < 76695845) {
                                    if (e = (i[A + 8 >> 2] - e | 0) / 56 | 0, n = e << 1, n = e >>> 0 >= 38347922 ? 76695844 : f >>> 0 < n >>> 0 ? n : f, n) {
                                        if (n >>> 0 >= 76695845) break i;
                                        f = D(Z(n, 56));
                                    } else f = 0;
                                    if (k = f + Z(k, 56) | 0, Bi(k, r), t = k + 56 | 0, r = i[A + 4 >> 2], e = i[A >> 2], (r | 0) != (e | 0)) {
                                        for(; k = k - 56 | 0, r = r - 56 | 0, Bi(k, r), (r | 0) != (e | 0););
                                        e = i[A >> 2], r = i[A + 4 >> 2];
                                    }
                                    if (i[A + 4 >> 2] = t, i[A >> 2] = k, i[A + 8 >> 2] = Z(n, 56) + f, (r | 0) != (e | 0)) for(; A = i[r - 12 >> 2], A && (i[r - 8 >> 2] = A, X(A)), A = r - 56 | 0, i[A >> 2] = 73428, f = i[r - 36 >> 2], f && (i[r - 32 >> 2] = f, X(f)), r = A, (A | 0) != (e | 0););
                                    return e && X(e), t;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function BZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            e = m - 16 | 0, m = e, i[e + 12 >> 2] = 0, i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0;
                            i: {
                                r = i[r + 32 >> 2];
                                e: {
                                    if ((r | 0) == (e - 108 | 0)) {
                                        i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break e;
                                    }
                                    if (f = i[r + 112 >> 2], r = i[r + 116 >> 2], b4(e + 4 | 0, f, r, r - f | 0), r = i[e + 8 >> 2], f = i[e + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (r | 0) != (f | 0)) {
                                        if (r = r - f | 0, (r | 0) < 0) break i;
                                        k = D(r), i[A + 4 >> 2] = k, i[A >> 2] = k, n = r + k | 0, i[A + 8 >> 2] = n, v0(k, f, r), i[A + 4 >> 2] = n;
                                    }
                                }
                                r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]), f = i[e + 4 >> 2];
                                }
                                f && (i[e + 8 >> 2] = f, X(f)), m = e + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function mZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 48 | 0, m = r;
                            i: {
                                if (!(i[e + 12 >> 2] != 8 & k0[e + 4 >> 2] <= 3)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = i[f + 12 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (f | 0) != 8) break i;
                                o[r + 24 | 0] = 0, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 2, i[r + 36 >> 2] = 131074, i[r + 28 >> 2] = 8, i[r + 16 >> 2] = 99, i[r + 20 >> 2] = 99, i[r + 32 >> 2] = 78668, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 6, i[r + 36 >> 2] = 851969, i[r + 24 >> 2] = i[e + 8 >> 2], f = i[e + 4 >> 2], i[r + 16 >> 2] = i[e >> 2], i[r + 20 >> 2] = f, f = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 39 | 0] = f, o[r + 40 | 0] = f >>> 8, o[r + 41 | 0] = f >>> 16, o[r + 42 | 0] = f >>> 24, i[r + 36 >> 2] = i[e + 20 >> 2], i[r + 28 >> 2] = 8, i[r + 12 >> 2] = 11, $2(A, r + 16 | 0, r + 12 | 0);
                            }
                            m = r + 48 | 0;
                        }
                        function pn(A) {
                            var r = 0;
                            r = D(176), i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r + 72 >> 2] = -1, i[r + 76 >> 2] = -1, i[r + 116 >> 2] = 0, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, i[r >> 2] = 77616, i[r + 32 >> 2] = 0, i[r + 36 >> 2] = 0, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r - -64 >> 2] = 0, i[r + 80 >> 2] = -1, i[r + 84 >> 2] = -1, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, Q[r + 112 >> 1] = 0, i[r + 16 >> 2] = 75908, i[r + 128 >> 2] = 0, i[r + 132 >> 2] = 0, i[r + 136 >> 2] = 0, i[r + 140 >> 2] = 0, o[r + 144 | 0] = 0, i[r + 168 >> 2] = 0, i[r + 172 >> 2] = 0, i[r + 160 >> 2] = 0, i[r + 164 >> 2] = 0, i[r + 152 >> 2] = 0, i[r + 156 >> 2] = 0, i[r + 32 >> 2] = 1668114798, i[A + 4 >> 2] = r, i[A >> 2] = r + 16;
                        }
                        function ZZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            e = m - 32 | 0, m = e;
                            i: {
                                e: {
                                    r: {
                                        if ((r | 0) == -1) break r;
                                        if (i[e + 20 >> 2] = r, l[A + 44 | 0] == 1) {
                                            A = i[A + 32 >> 2];
                                            A: {
                                                if (i[A + 76 >> 2] < 0) {
                                                    A = nn(r, A);
                                                    break A;
                                                }
                                                A = nn(r, A);
                                            }
                                            if ((A | 0) == -1) break e;
                                            break r;
                                        }
                                        for(n = e + 24 | 0, i[e + 16 >> 2] = n, u = e + 32 | 0, f = e + 20 | 0;;){
                                            if (k = i[A + 36 >> 2], k = p[i[i[k >> 2] + 12 >> 2]](k, i[A + 40 >> 2], f, n, e + 12 | 0, e + 24 | 0, u, e + 16 | 0) | 0, i[e + 12 >> 2] == (f | 0)) break e;
                                            if ((k | 0) == 3) {
                                                if ((E1(f, 1, 1, i[A + 32 >> 2]) | 0) == 1) break r;
                                                break e;
                                            }
                                            if (k >>> 0 > 1 || (t = e + 24 | 0, f = i[e + 16 >> 2] - t | 0, (E1(t, 1, f, i[A + 32 >> 2]) | 0) != (f | 0))) break e;
                                            if (f = i[e + 12 >> 2], (k | 0) != 1) break;
                                        }
                                    }
                                    A = (r | 0) != -1 ? r : 0;
                                    break i;
                                }
                                A = -1;
                            }
                            return m = e + 32 | 0, A | 0;
                        }
                        function GZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 5, 2001, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                k = i[r >> 2], t = i[k + 200 >> 2], k = i[k + 204 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                e: {
                                    if (t) {
                                        n = e, e = i[t + 8 >> 2], v0(n, e, i[t + 12 >> 2] - e | 0), e = A, A = i[r >> 2], j0(e, 86672, A ? A + 4 | 0 : 0);
                                        break e;
                                    }
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 10, 0, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break e;
                                    X(i[e + 8 >> 2]);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 32 | 0;
                        }
                        function Qn(A, r, e) {
                            var f = 0, k = 0;
                            if (!r) return 0;
                            i: {
                                e: {
                                    if (!e) break e;
                                    if (f = l[r | 0], k = f << 24 >> 24, (k | 0) >= 0) return A && (i[A >> 2] = f), (k | 0) != 0;
                                    if (!i[i[26106] >> 2]) {
                                        if (r = 1, !A) break i;
                                        return i[A >> 2] = k & 57343, 1;
                                    }
                                    if (f = f - 194 | 0, f >>> 0 > 50 || (f = i[(f << 2) + 60816 >> 2], e >>> 0 <= 3 && f << Z(e, 6) - 6 < 0) || (e = l[r + 1 | 0], k = e >>> 3 | 0, (k - 16 | k + (f >> 26)) >>> 0 > 7)) break e;
                                    if (e = e - 128 | f << 6, (e | 0) >= 0) {
                                        if (r = 2, !A) break i;
                                        return i[A >> 2] = e, 2;
                                    }
                                    if (f = l[r + 2 | 0] - 128 | 0, f >>> 0 > 63) break e;
                                    if (k = f, f = e << 6, e = k | f, (f | 0) >= 0) {
                                        if (r = 3, !A) break i;
                                        return i[A >> 2] = e, 3;
                                    }
                                    if (f = l[r + 3 | 0] - 128 | 0, f >>> 0 > 63) break e;
                                    if (r = 4, !A) break i;
                                    return i[A >> 2] = f | e << 6, 4;
                                }
                                i[26064] = 25, r = -1;
                            }
                            return r;
                        }
                        function WZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 5, 2001, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 8 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                k = i[r >> 2], t = i[k + 52 >> 2], k = i[k + 56 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                                e: {
                                    if (t) {
                                        n = e, e = i[t + 8 >> 2], v0(n, e, i[t + 12 >> 2] - e | 0), e = A, A = i[r >> 2], j0(e, 86672, A ? A + 8 | 0 : 0);
                                        break e;
                                    }
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 10, 0, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), n = A, A = i[r >> 2], j0(n, e, A ? A + 8 | 0 : 0), o[e + 19 | 0] >= 0) break e;
                                    X(i[e + 8 >> 2]);
                                }
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                            m = f + 32 | 0;
                        }
                        function a4(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            u = m - 16 | 0, m = u, i[u + 12 >> 2] = r, r = 0, n = 6;
                            i: {
                                e: {
                                    if (S2(A, u + 12 | 0)) break e;
                                    n = 4, t = i[A >> 2], s = i[t + 12 >> 2];
                                    r: {
                                        if ((s | 0) == i[t + 16 >> 2]) {
                                            t = p[i[i[t >> 2] + 36 >> 2]](t) | 0;
                                            break r;
                                        }
                                        t = i[s >> 2];
                                    }
                                    if (!(p[i[i[f >> 2] + 12 >> 2]](f, 64, t) | 0)) break e;
                                    for(r = p[i[i[f >> 2] + 52 >> 2]](f, t, 0) | 0;;){
                                        r: {
                                            if (J1(A), r = r - 48 | 0, S2(A, u + 12 | 0) | (k | 0) < 2) break r;
                                            n = i[A >> 2], t = i[n + 12 >> 2];
                                            A: {
                                                if ((t | 0) == i[n + 16 >> 2]) {
                                                    n = p[i[i[n >> 2] + 36 >> 2]](n) | 0;
                                                    break A;
                                                }
                                                n = i[t >> 2];
                                            }
                                            if (!(p[i[i[f >> 2] + 12 >> 2]](f, 64, n) | 0)) break i;
                                            k = k - 1 | 0, r = (p[i[i[f >> 2] + 52 >> 2]](f, n, 0) | 0) + Z(r, 10) | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    if (n = 2, !S2(A, u + 12 | 0)) break i;
                                }
                                i[e >> 2] = i[e >> 2] | n;
                            }
                            return m = u + 16 | 0, r;
                        }
                        function $8(A, r, e, f, k, n, t, u) {
                            var s = 0, h = 0, w = 0, v = 0;
                            h = 1, s = f & 2147483647, w = s, v = (s | 0) == 2147418112;
                            i: {
                                if ((v & !e ? A | r : v & (e | 0) != 0 | s >>> 0 > 2147418112) || (s = u & 2147483647, !t & (s | 0) == 2147418112 ? k | n : (s | 0) == 2147418112 & (t | 0) != 0 | s >>> 0 > 2147418112)) break i;
                                if (!(A | k | (e | t) | (r | n | (s | w)))) return 0;
                                if (h = f & u, (h | 0) > 0 ? w = 1 : w = (h | 0) >= 0, w) {
                                    if (h = -1, (e | 0) == (t | 0) & (f | 0) == (u | 0) ? (r | 0) == (n | 0) & A >>> 0 < k >>> 0 | r >>> 0 < n >>> 0 : e >>> 0 < t >>> 0 & (f | 0) <= (u | 0) | (f | 0) < (u | 0)) break i;
                                    return (A ^ k | e ^ t | (r ^ n | f ^ u)) != 0;
                                }
                                if (h = -1, (e | 0) == (t | 0) & (f | 0) == (u | 0) ? (r | 0) == (n | 0) & A >>> 0 > k >>> 0 | r >>> 0 > n >>> 0 : e >>> 0 > t >>> 0 & (f | 0) >= (u | 0) | (f | 0) > (u | 0)) break i;
                                h = (A ^ k | e ^ t | (r ^ n | f ^ u)) != 0;
                            }
                            return h;
                        }
                        function Cn(A, r) {
                            var e = 0, f = 0, k = 0;
                            k = r + 24 | 0, f = i[r >> 2] & 63, o[k + f | 0] = 128, e = f + 1 | 0, f = f ^ 63, f >>> 0 <= 7 && (B0(e + k | 0, 0, f), f = 64, we(r, k, 64), e = 0), B0(e + k | 0, 0, f - 8 | 0), i[r + 84 >> 2] = i[r + 4 >> 2], e = i[r >> 2], o[r + 83 | 0] = e >>> 21, o[r + 82 | 0] = e >>> 13, o[r + 81 | 0] = e >>> 5, e = e << 3, o[r + 80 | 0] = e, i[r >> 2] = e, we(r, k, 64), o[A | 0] = i[r + 8 >> 2], o[A + 1 | 0] = i[r + 8 >> 2] >>> 8, o[A + 2 | 0] = I[r + 10 >> 1], o[A + 3 | 0] = l[r + 11 | 0], o[A + 4 | 0] = i[r + 12 >> 2], o[A + 5 | 0] = i[r + 12 >> 2] >>> 8, o[A + 6 | 0] = I[r + 14 >> 1], o[A + 7 | 0] = l[r + 15 | 0], o[A + 8 | 0] = i[r + 16 >> 2], o[A + 9 | 0] = i[r + 16 >> 2] >>> 8, o[A + 10 | 0] = I[r + 18 >> 1], o[A + 11 | 0] = l[r + 19 | 0], o[A + 12 | 0] = i[r + 20 >> 2], o[A + 13 | 0] = i[r + 20 >> 2] >>> 8, o[A + 14 | 0] = I[r + 22 >> 1], o[A + 15 | 0] = l[r + 23 | 0], B0(r, 0, 152);
                        }
                        function K3(A) {
                            var r = 0, e = 0, f = 0;
                            if (a3(A), r = i[A + 320 >> 2], r) {
                                if (f = r - 4 | 0, e = i[f >> 2], e) for(e = r + Z(e, 76) | 0; e = e - 76 | 0, (r | 0) != (e | 0););
                                X(f);
                            }
                            X(i[A + 260 >> 2]), X(i[A + 240 >> 2]), X(i[A + 220 >> 2]), X(i[A + 200 >> 2]), X(i[A + 180 >> 2]), X(i[A + 160 >> 2]), X(i[A + 140 >> 2]), r = i[A + 136 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 128 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 120 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return r = i[A + 52 >> 2], r && (i[A + 56 >> 2] = r, X(r)), A;
                        }
                        function XZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 48 | 0, m = f, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, k = i[r + 100 >> 2], l2(e, p[i[i[k >> 2] + 8 >> 2]](k) | 0), k = i[r + 100 >> 2], p[i[i[k >> 2] + 16 >> 2]](f + 24 | 0, k, e);
                            i: {
                                if (i[f + 24 >> 2]) {
                                    r = i[f + 28 >> 2], i[A >> 2] = i[f + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[f + 40 >> 2], r = i[f + 36 >> 2], i[A + 8 >> 2] = i[f + 32 >> 2], i[A + 12 >> 2] = r, i[f + 40 >> 2] = 0, i[f + 32 >> 2] = 0, i[f + 36 >> 2] = 0;
                                    break i;
                                }
                                if (E4(f + 4 | 0, r, e, n), o[f + 23 | 0] < 0 && X(i[f + 12 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[f + 43 | 0] < 0 && X(i[f + 32 >> 2]), m = f + 48 | 0;
                        }
                        function _i(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            t = f || 107048, f = i[t >> 2];
                            i: {
                                e: {
                                    r: {
                                        if (!r) {
                                            if (f) break r;
                                            return 0;
                                        }
                                        if (k = -2, !e) break e;
                                        A: {
                                            if (f) {
                                                k = e;
                                                break A;
                                            }
                                            if (f = l[r | 0], n = f << 24 >> 24, (n | 0) >= 0) return A && (i[A >> 2] = f), (n | 0) != 0;
                                            if (!i[i[26106] >> 2]) {
                                                if (k = 1, !A) break e;
                                                return i[A >> 2] = n & 57343, 1;
                                            }
                                            if (f = f - 194 | 0, f >>> 0 > 50) break r;
                                            if (f = i[(f << 2) + 60816 >> 2], k = e - 1 | 0, !k) break i;
                                            r = r + 1 | 0;
                                        }
                                        if (n = l[r | 0], u = n >>> 3 | 0, (u - 16 | (f >> 26) + u) >>> 0 > 7) break r;
                                        for(;;){
                                            if (k = k - 1 | 0, f = n - 128 | f << 6, (f | 0) >= 0) return i[t >> 2] = 0, A && (i[A >> 2] = f), e - k | 0;
                                            if (!k) break i;
                                            if (r = r + 1 | 0, n = l[r | 0], (n & 192) != 128) break;
                                        }
                                    }
                                    i[t >> 2] = 0, i[26064] = 25, k = -1;
                                }
                                return k;
                            }
                            return i[t >> 2] = f, -2;
                        }
                        function pZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 48 | 0, m = k, P8(k + 24 | 0, i[r + 20 >> 2], i[r + 36 >> 2], k + 44 | 0);
                            i: {
                                if (i[k + 24 >> 2]) {
                                    r = i[k + 28 >> 2], i[A >> 2] = i[k + 24 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 40 >> 2], r = i[k + 36 >> 2], i[A + 8 >> 2] = i[k + 32 >> 2], i[A + 12 >> 2] = r, i[k + 40 >> 2] = 0, i[k + 32 >> 2] = 0, i[k + 36 >> 2] = 0;
                                    break i;
                                }
                                t = k + 12 | 0, v4(t, i[r + 20 >> 2], i[k + 44 >> 2], 1), r = i[k + 16 >> 2], n = i[k + 12 >> 2];
                                e: {
                                    if (!n) {
                                        if (o[k + 12 | 0] = 0, o[k + 23 | 0] = 0, i0(A, 2, 2e3, t), o[k + 23 | 0] >= 0) break e;
                                        X(i[k + 12 >> 2]);
                                        break e;
                                    }
                                    p[i[i[n >> 2] + 48 >> 2]](A, n, e, f);
                                }
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            o[k + 43 | 0] < 0 && X(i[k + 32 >> 2]), m = k + 48 | 0;
                        }
                        function m4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            e = i[A + 108 >> 2], k = i[A + 112 >> 2], e = OA(e, r, k - e >> 2), u = e || k;
                            i: {
                                e: {
                                    if (k = i[A + 112 >> 2], (u | 0) == (k | 0)) {
                                        f = i[A + 116 >> 2];
                                        r: {
                                            if (f >>> 0 > u >>> 0) {
                                                i[k >> 2] = r, r = k + 4 | 0;
                                                break r;
                                            }
                                            if (t = i[A + 108 >> 2], n = u - t >> 2, e = n + 1 | 0, e >>> 0 >= 1073741824) break e;
                                            if (s = n << 2, f = f - t | 0, n = f >> 1, n = f >>> 0 >= 2147483644 ? 1073741823 : e >>> 0 < n >>> 0 ? n : e, n) {
                                                if (n >>> 0 >= 1073741824) break i;
                                                e = D(n << 2);
                                            } else e = 0;
                                            if (f = s + e | 0, i[f >> 2] = r, r = f + 4 | 0, (t | 0) != (u | 0)) for(; f = f - 4 | 0, k = k - 4 | 0, i[f >> 2] = i[k >> 2], (k | 0) != (t | 0););
                                            if (i[A + 116 >> 2] = e + (n << 2), i[A + 112 >> 2] = r, i[A + 108 >> 2] = f, !t) break r;
                                            X(t);
                                        }
                                        i[A + 112 >> 2] = r;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function W6(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = m - 48 | 0, m = f, l[87597] == 1 && (i[f + 36 >> 2] = r, i[f + 32 >> 2] = A, n8(25539, f + 32 | 0)), e = i[r + 4 >> 2];
                            i: {
                                if (!e) {
                                    if (l[87597] == 1 && (i[f + 4 >> 2] = i[A + 4 >> 2], i[f >> 2] = A, n8(25499, f)), r = i[A + 4 >> 2], !r) break i;
                                    e = i[r >> 2] - 1 | 0, i[r >> 2] = e;
                                    e: {
                                        if (e || (e = i[A >> 2], e && (X(e), r = i[A + 4 >> 2], !r))) break e;
                                        X(r);
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[e >> 2] = i[e >> 2] + 1, l[87597] == 1 && (i[f + 20 >> 2] = i[A + 4 >> 2], i[f + 16 >> 2] = A, n8(25499, f + 16 | 0)), e = i[A + 4 >> 2], e) {
                                    k = i[e >> 2] - 1 | 0, i[e >> 2] = k;
                                    e: {
                                        if (k || (k = i[A >> 2], k && (X(k), e = i[A + 4 >> 2], !e))) break e;
                                        X(e);
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                }
                                i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = i[r + 4 >> 2];
                            }
                            m = f + 48 | 0;
                        }
                        function Vn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            i: {
                                k = i[A + 4 >> 2], u = i[A >> 2];
                                e: {
                                    if ((k | 0) != (u | 0)) {
                                        e = k;
                                        break e;
                                    }
                                    if (f = i[A + 8 >> 2], e = i[A + 12 >> 2], f >>> 0 < e >>> 0) {
                                        n = ((e - f >> 2) + 1 | 0) / 2 << 2, t = f - k | 0, e = (n + f | 0) - t | 0, (f | 0) != (k | 0) && (Q0(e, k, t), f = i[A + 8 >> 2]), i[A + 4 >> 2] = e, i[A + 8 >> 2] = f + n;
                                        break e;
                                    }
                                    if (e = (e | 0) == (k | 0) ? 1 : e - k >> 1, e >>> 0 >= 1073741824) break i;
                                    if (n = e << 2, t = D(n), s = n + t | 0, e = t + (e + 3 & -4) | 0, n = e, (f | 0) != (k | 0)) for(h = (f - k | 0) + e | 0, f = k; i[n >> 2] = i[f >> 2], f = f + 4 | 0, n = n + 4 | 0, (h | 0) != (n | 0););
                                    if (i[A + 12 >> 2] = s, i[A + 8 >> 2] = n, i[A + 4 >> 2] = e, i[A >> 2] = t, !k) break e;
                                    X(u), e = i[A + 4 >> 2];
                                }
                                i[e - 4 >> 2] = i[r >> 2], i[A + 4 >> 2] = i[A + 4 >> 2] - 4;
                                return;
                            }
                            Z2(), z();
                        }
                        function QZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (!(k && r)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 7560;
                                    break i;
                                }
                                i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, g3(n + 12 | 0, r, e, f, n + 24 | 0);
                                e: {
                                    if (i[n + 12 >> 2]) {
                                        r = i[n + 16 >> 2], i[A >> 2] = i[n + 12 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 20 >> 2];
                                        break e;
                                    }
                                    if (r = i[n + 24 >> 2], !r) {
                                        i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 2155;
                                        break e;
                                    }
                                    if (GA(n, r), e = i[n + 4 >> 2], r = i[n >> 2], (e | 0) != (r | 0) && Q0(k, r, e - r | 0), e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[19867], !r) break e;
                                    i[n + 4 >> 2] = r, X(r);
                                }
                                if (A = i[n + 28 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = n + 32 | 0;
                        }
                        function CZ(A, r, e, f, k, n, t, u, s, h) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0;
                            var w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0, V = 0;
                            if ((s | 0) > 0) {
                                if (!((n | 0) <= 0 | (k | 0) <= 0)) for(G = 1 << s - 1, v = -1 << h ^ -1, C = k & 2147483646, V = k & 1;;){
                                    if (h = (Z(r, B) << 1) + A | 0, _ = (Z(f, B) << 1) + e | 0, W = 0, (k | 0) != 1) for(; w = (Z(Q[_ >> 1], t) + G >> s) + u | 0, Q[h >> 1] = (w | 0) >= 0 ? (v | 0) > (w | 0) ? w : v : 0, w = (Z(Q[_ + 2 >> 1], t) + G >> s) + u | 0, Q[h + 2 >> 1] = (w | 0) >= 0 ? (v | 0) > (w | 0) ? w : v : 0, _ = _ + 4 | 0, h = h + 4 | 0, W = W + 2 | 0, (C | 0) != (W | 0););
                                    if (V && (w = h, h = (Z(Q[_ >> 1], t) + G >> s) + u | 0, Q[w >> 1] = (h | 0) >= 0 ? (h | 0) < (v | 0) ? h : v : 0), B = B + 1 | 0, (B | 0) == (n | 0)) break;
                                }
                                return;
                            }
                            y0(18127, 14969, 193, 8654), z();
                        }
                        function VZ(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0;
                            i: {
                                if (!(!k | (!e | !f)) && n) break i;
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                return;
                            }
                            i: {
                                if (u = i[r + 16 >> 2], !u || (u = E0(u, 78492, 79208), !u)) break i;
                                r = i[r + 20 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e >> 2] = i[u + 4 >> 2], i[f >> 2] = i[u + 8 >> 2], i[k >> 2] = i[u + 12 >> 2], i[n >> 2] = i[u + 16 >> 2], e = i[u + 20 >> 2], v0(t, e, i[u + 24 >> 2] - e | 0), i[A + 8 >> 2] = i[19867], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e;
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function Te(A, r, e) {
                            var f = J(0), k = J(0), n = 0, t = J(0), u = J(0), s = J(0), h = J(0), w = J(0);
                            n = m - 16 | 0, m = n, z5(n + 8 | 0, r, e), f = W0[n + 12 >> 2], t = W0[n + 8 >> 2];
                            i: {
                                if (!(f != J(0) | t != J(0))) {
                                    w = J(-0.41868799924850464), u = J(-0.3312639892101288), f = J(.11400000005960464), h = J(.5870000123977661), t = J(.29899999499320984), k = J(-0.08131200075149536), s = J(-0.16873499751091003);
                                    break i;
                                }
                                k = J(J(1) - t), h = J(k - f), u = J(-h), w = J(J(u / k) * J(.5)), s = J(J(1) - f), u = J(J(u / s) * J(.5)), k = J(J(J(-f) / k) * J(.5)), s = J(J(J(-t) / s) * J(.5));
                            }
                            W0[A + 36 >> 2] = k, W0[A + 32 >> 2] = w, i[A + 24 >> 2] = 1056964608, i[A + 28 >> 2] = 1056964608, W0[A + 20 >> 2] = u, W0[A + 16 >> 2] = s, W0[A + 12 >> 2] = f, W0[A + 8 >> 2] = h, W0[A + 4 >> 2] = t, o[A | 0] = 1, m = n + 16 | 0;
                        }
                        function yZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = B2(e), Q[k + 100 >> 1] = n, k = r, n = B2(e), Q[k + 106 >> 1] = n, k = r, n = B2(e), Q[k + 102 >> 1] = n, k = r, n = B2(e), Q[k + 108 >> 1] = n, k = r, n = B2(e), Q[k + 104 >> 1] = n, k = r, n = B2(e), Q[k + 110 >> 1] = n, k = r, n = B2(e), Q[k + 112 >> 1] = n, k = r, n = B2(e), Q[k + 114 >> 1] = n, k = r, n = n2(e), i[k + 116 >> 2] = n, k = r, n = n2(e), i[k + 120 >> 2] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function Se(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            n = m - 208 | 0, m = n, i[n + 204 >> 2] = e, e = n + 160 | 0, B0(e, 0, 40), i[n + 200 >> 2] = i[n + 204 >> 2];
                            i: {
                                if ((M7(0, r, n + 200 | 0, n + 80 | 0, e, f, k) | 0) < 0) {
                                    k = -1;
                                    break i;
                                }
                                s = i[A + 76 >> 2] < 0, t = i[A >> 2], i[A >> 2] = t & -33;
                                e: {
                                    r: {
                                        A: {
                                            if (!i[A + 48 >> 2]) {
                                                i[A + 48 >> 2] = 80, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, u = i[A + 44 >> 2], i[A + 44 >> 2] = n;
                                                break A;
                                            }
                                            if (i[A + 16 >> 2]) break r;
                                        }
                                        if (e = -1, gA(A)) break e;
                                    }
                                    e = M7(A, r, n + 200 | 0, n + 80 | 0, n + 160 | 0, f, k);
                                }
                                if (u && (p[i[A + 36 >> 2]](A, 0, 0), i[A + 48 >> 2] = 0, i[A + 44 >> 2] = u, i[A + 28 >> 2] = 0, r = i[A + 20 >> 2], i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, e = r ? e : -1), r = A, A = i[A >> 2], i[r >> 2] = A | t & 32, k = A & 32 ? -1 : e, s) break i;
                            }
                            return m = n + 208 | 0, k;
                        }
                        function yn(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 82152, r = i[A + 140 >> 2], r) {
                                if (e = r, f = i[A + 144 >> 2], (r | 0) != (f | 0)) {
                                    for(; e = f - 12 | 0, k = i[e >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = e, (r | 0) != (f | 0););
                                    e = i[A + 140 >> 2];
                                }
                                i[A + 144 >> 2] = r, X(e);
                            }
                            if (r = i[A + 128 >> 2], r) {
                                if (e = r, f = i[A + 132 >> 2], (r | 0) != (f | 0)) {
                                    for(; e = f - 12 | 0, k = i[e >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = e, (r | 0) != (f | 0););
                                    e = i[A + 128 >> 2];
                                }
                                i[A + 132 >> 2] = r, X(e);
                            }
                            if (r = i[A + 116 >> 2], r) {
                                if (e = r, f = i[A + 120 >> 2], (r | 0) != (f | 0)) {
                                    for(; e = f - 12 | 0, k = i[e >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = e, (r | 0) != (f | 0););
                                    e = i[A + 116 >> 2];
                                }
                                i[A + 120 >> 2] = r, X(e);
                            }
                            return V2(A) | 0;
                        }
                        function IZ(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0;
                            i: {
                                if (!(!e | !f | (!k | !n)) && t) break i;
                                r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                                return;
                            }
                            i: {
                                if (u = i[r + 16 >> 2], !u || (u = E0(u, 78492, 79164), !u)) break i;
                                r = i[r + 20 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e >> 2] = i[u + 4 >> 2], i[f >> 2] = i[u + 8 >> 2], i[k >> 2] = i[u + 12 >> 2], i[n >> 2] = i[u + 16 >> 2], i[t >> 2] = i[u + 20 >> 2], i[A + 8 >> 2] = i[19867], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e;
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function FZ(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0, C = 0;
                            if ((s | 0) > 0) {
                                if (!((n | 0) <= 0 | (k | 0) <= 0)) for(G = 1 << s - 1, W = k & 2147483646, C = k & 1;;){
                                    if (h = Z(r, B) + A | 0, v = (Z(f, B) << 1) + e | 0, _ = 0, (k | 0) != 1) for(; w = (Z(Q[v >> 1], t) + G >> s) + u | 0, w = (w | 0) >= 255 ? 255 : w, o[h | 0] = (w | 0) > 0 ? w : 0, w = (Z(Q[v + 2 >> 1], t) + G >> s) + u | 0, w = (w | 0) >= 255 ? 255 : w, o[h + 1 | 0] = (w | 0) > 0 ? w : 0, v = v + 4 | 0, h = h + 2 | 0, _ = _ + 2 | 0, (W | 0) != (_ | 0););
                                    if (C && (_ = h, h = (Z(Q[v >> 1], t) + G >> s) + u | 0, h = (h | 0) >= 255 ? 255 : h, o[_ | 0] = (h | 0) > 0 ? h : 0), B = B + 1 | 0, (B | 0) == (n | 0)) break;
                                }
                                return;
                            }
                            y0(18127, 14969, 60, 8500), z();
                        }
                        function YZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            k = m - 32 | 0, m = k, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f = i[r + 36 >> 2], t = i[r + 40 >> 2];
                            i: {
                                if ((f | 0) != (t | 0)) for(;;){
                                    if (u = i[f >> 2], p[i[i[u >> 2] + 16 >> 2]](A, u, e), i[A >> 2]) break i;
                                    if (o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), f = f + 8 | 0, (t | 0) == (f | 0)) break;
                                }
                                if (f = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = f, A = A + 8 | 0, o[86691] >= 0) {
                                    f = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](k + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function EZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            r = m - 48 | 0, m = r, k = i[e + 12 >> 2], n = i[e + 4 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (k | 0) != 8 | n >>> 0 > 3 || (i[r + 28 >> 2] = 8, o[r + 24 | 0] = 0, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 2, i[r + 36 >> 2] = 131074, i[r + 16 >> 2] = 99, i[r + 20 >> 2] = 99, i[r + 32 >> 2] = 78668, o[r + 42 | 0] = 1, Q[r + 40 >> 1] = 6, i[r + 36 >> 2] = 851969, i[r + 24 >> 2] = i[e + 8 >> 2], k = i[e + 4 >> 2], i[r + 16 >> 2] = i[e >> 2], i[r + 20 >> 2] = k, k = l[e + 23 | 0] | l[e + 24 | 0] << 8 | (l[e + 25 | 0] << 16 | l[e + 26 | 0] << 24), o[r + 39 | 0] = k, o[r + 40 | 0] = k >>> 8, o[r + 41 | 0] = k >>> 16, o[r + 42 | 0] = k >>> 24, i[r + 36 >> 2] = i[e + 20 >> 2], i[r + 28 >> 2] = i[f + 12 >> 2], i[r + 12 >> 2] = 11, $2(A, r + 16 | 0, r + 12 | 0)), m = r + 48 | 0;
                        }
                        function gZ(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            if (Y1(A, i[r + 8 >> 2], n)) {
                                hA(r, e, f, k);
                                return;
                            }
                            u = l[r + 53 | 0], t = i[A + 12 >> 2], o[r + 53 | 0] = 0, s = l[r + 52 | 0], o[r + 52 | 0] = 0, h = A + 16 | 0, HA(h, r, e, f, k, n), w = l[r + 52 | 0], s = s | w, v = l[r + 53 | 0], u = u | v;
                            i: {
                                if ((t | 0) < 2) break i;
                                for(h = h + (t << 3) | 0, t = A + 24 | 0;;){
                                    if (l[r + 54 | 0]) break i;
                                    e: {
                                        if (w & 1) {
                                            if (i[r + 24 >> 2] == 1) break i;
                                            if (l[A + 8 | 0] & 2) break e;
                                            break i;
                                        }
                                        if (!(v & 1)) break e;
                                        if (!(o[A + 8 | 0] & 1)) break i;
                                    }
                                    if (Q[r + 52 >> 1] = 0, HA(t, r, e, f, k, n), v = l[r + 53 | 0], u = (v | u) & 1, w = l[r + 52 | 0], s = (w | s) & 1, t = t + 8 | 0, !(h >>> 0 > t >>> 0)) break;
                                }
                            }
                            o[r + 53 | 0] = u & 1, o[r + 52 | 0] = s & 1;
                        }
                        function C2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (k = i[A + 24 >> 2], (k | 0) >= (r | 0) | (k | 0) > 56) e = k;
                            else {
                                for(e = 64 - k | 0, t = i[A + 16 >> 2], s = i[A + 20 >> 2], k = i[A + 8 >> 2], f = i[A >> 2];;){
                                    i: {
                                        if (h = e, !k) {
                                            n = e;
                                            break i;
                                        }
                                        if (w = f + 1 | 0, i[A >> 2] = w, f = l[f | 0], k = k - 1 | 0, i[A + 8 >> 2] = k, n = h - 8 | 0, u = n & 31, (n & 63) >>> 0 >= 32 ? (v = f << u, f = 0) : (v = (1 << u) - 1 & f >>> 32 - u, f = f << u), t = f | t, f = s | v, s = f, i[A + 16 >> 2] = t, i[A + 20 >> 2] = f, f = e, e = f - 8 | 0, _ = _ - (f >>> 0 < 8) | 0, f = w, (h | 0) > 15) continue;
                                    }
                                    break;
                                }
                                e = 64 - n | 0;
                            }
                            i[A + 24 >> 2] = e - r, t = i[A + 20 >> 2], n = i[A + 16 >> 2], e = r & 31, (r & 63) >>> 0 >= 32 ? (r = n << e, e = 0) : (r = (1 << e) - 1 & n >>> 32 - e | t << e, e = n << e), i[A + 16 >> 2] = e, i[A + 20 >> 2] = r;
                        }
                        function JZ(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (!(l[n + 11 | 0] >>> 7 | 0)) {
                                    i[A + 8 >> 2] = i[n + 8 >> 2], r = i[n + 4 >> 2], i[A >> 2] = i[n >> 2], i[A + 4 >> 2] = r;
                                    break i;
                                }
                                e = i[n >> 2], k = m - 16 | 0, m = k;
                                e: {
                                    r: {
                                        n = i[n + 4 >> 2];
                                        A: {
                                            if (n >>> 0 < 2) {
                                                r = A, o[A + 11 | 0] = l[A + 11 | 0] & 128 | n & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127;
                                                break A;
                                            }
                                            if (n >>> 0 > 1073741815) break r;
                                            u = k + 8 | 0, n >>> 0 >= 2 ? (t = n + 2 & -2, r = t - 1 | 0, r = (r | 0) == 2 ? t : r) : r = 1, D6(u, r + 1 | 0), r = i[k + 8 >> 2], i[A >> 2] = r, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = n;
                                        }
                                        Yr(r, e, n + 1 | 0), m = k + 16 | 0;
                                        break e;
                                    }
                                    u4(), z();
                                }
                            }
                            m = f + 16 | 0;
                        }
                        function a8(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            if (k = i[A + 8 >> 2], n = i[A >> 2], k - n >> 2 >>> 0 >= f >>> 0) {
                                if (t = f, k = i[A + 4 >> 2], f = k - n | 0, t >>> 0 > f >> 2 >>> 0) {
                                    (k | 0) != (n | 0) && (Q0(n, r, f), k = i[A + 4 >> 2]), r = r + f | 0, f = e - r | 0, (r | 0) != (e | 0) && Q0(k, r, f), i[A + 4 >> 2] = f + k;
                                    return;
                                }
                                f = e - r | 0, (r | 0) != (e | 0) && Q0(n, r, f), i[A + 4 >> 2] = f + n;
                                return;
                            }
                            n && (i[A + 4 >> 2] = n, X(n), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = 0);
                            i: {
                                if (f >>> 0 >= 1073741824 || (n = k >> 1, f = k >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 < n >>> 0 ? n : f, f >>> 0 >= 1073741824)) break i;
                                k = f << 2, f = D(k), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + k, k = e - r | 0, (r | 0) != (e | 0) && v0(f, r, k), i[A + 4 >> 2] = f + k;
                                return;
                            }
                            p0(), z();
                        }
                        function Bi(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            i[A >> 2] = 73428, e = i[r + 12 >> 2], f = i[r + 8 >> 2], i[A + 8 >> 2] = f, i[A + 12 >> 2] = e, i[A + 16 >> 2] = i[r + 16 >> 2], i[A + 28 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 24 >> 2] = 0;
                            i: {
                                e: {
                                    if (e = i[r + 24 >> 2], k = i[r + 20 >> 2], (e | 0) != (k | 0)) {
                                        if (e = e - k | 0, (e | 0) < 0) break e;
                                        f = D(e), i[A + 24 >> 2] = f, i[A + 20 >> 2] = f, n = e + f | 0, i[A + 28 >> 2] = n, v0(f, k, e), i[A + 24 >> 2] = n;
                                    }
                                    if (i[A + 32 >> 2] = i[r + 32 >> 2], e = i[r + 40 >> 2], i[A + 52 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 40 >> 2] = e, e = i[r + 48 >> 2], f = i[r + 44 >> 2], (e | 0) != (f | 0)) {
                                        if (r = e - f | 0, (r | 0) < 0) break i;
                                        e = D(r), i[A + 48 >> 2] = e, i[A + 44 >> 2] = e, k = r + e | 0, i[A + 52 >> 2] = k, v0(e, f, r), i[A + 48 >> 2] = k;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function RZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, I[r + 100 >> 1]), w2(e, I[r + 106 >> 1]), w2(e, I[r + 102 >> 1]), w2(e, I[r + 108 >> 1]), w2(e, I[r + 104 >> 1]), w2(e, I[r + 110 >> 1]), w2(e, I[r + 112 >> 1]), w2(e, I[r + 114 >> 1]), l2(e, i[r + 116 >> 2]), l2(e, i[r + 120 >> 2]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function In(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t;
                            i: {
                                if (1073741815 - r >>> 0 >= e >>> 0) {
                                    l[A + 11 | 0] >>> 7 | 0 ? n = i[A >> 2] : n = A, u = n, n = t + 4 | 0, s = n, r >>> 0 < 536870899 ? (i[t + 12 >> 2] = r << 1, i[t + 4 >> 2] = r + e, e = m - 16 | 0, m = e, m = e + 16 | 0, e = t + 12 | 0, e = i[(k0[n >> 2] < k0[e >> 2] ? e : n) >> 2], e >>> 0 >= 2 ? (n = e + 2 & -2, e = n - 1 | 0, e = (e | 0) == 2 ? n : e) : e = 1, e = e + 1 | 0) : e = 1073741815, D6(s, e), e = i[t + 4 >> 2], k && Yr(e, u, k), (f | 0) != (k | 0) && (n = k << 2, Yr(n + e | 0, n + u | 0, f - k | 0)), (r | 0) != 1 && y8(u, 4), i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[t + 8 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, m = t + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            i[A + 4 >> 2] = f;
                        }
                        function q3(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t;
                            i: {
                                if (2147483639 - r >>> 0 >= e >>> 0) {
                                    l[A + 11 | 0] >>> 7 | 0 ? n = i[A >> 2] : n = A, u = n, n = t + 4 | 0, s = n, r >>> 0 < 1073741811 ? (i[t + 12 >> 2] = r << 1, i[t + 4 >> 2] = r + e, e = m - 16 | 0, m = e, m = e + 16 | 0, e = t + 12 | 0, e = i[(k0[n >> 2] < k0[e >> 2] ? e : n) >> 2], e >>> 0 >= 11 ? (n = e + 8 & -8, e = n - 1 | 0, e = (e | 0) == 11 ? n : e) : e = 10, e = e + 1 | 0) : e = 2147483639, N6(s, e), e = i[t + 4 >> 2], k && Zf(e, u, k), (f | 0) != (k | 0) && Zf(e + k | 0, k + u | 0, f - k | 0), (r | 0) != 10 && y8(u, 1), i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[t + 8 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, m = t + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            i[A + 4 >> 2] = f;
                        }
                        function $3(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            i: {
                                e: {
                                    if (f) {
                                        if (f >>> 0 >= 107374183) break e;
                                        if (k = Z(f, 40), f = D(k), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + k, (r | 0) != (e | 0)) for(;;){
                                            if (k = i[r + 4 >> 2], i[f >> 2] = i[r >> 2], i[f + 4 >> 2] = k, k = i[r + 20 >> 2], i[f + 16 >> 2] = i[r + 16 >> 2], i[f + 20 >> 2] = k, k = i[r + 12 >> 2], i[f + 8 >> 2] = i[r + 8 >> 2], i[f + 12 >> 2] = k, i[f + 32 >> 2] = 0, i[f + 24 >> 2] = 0, i[f + 28 >> 2] = 0, t = i[r + 24 >> 2], k = i[r + 28 >> 2], (t | 0) != (k | 0)) {
                                                if (k = k - t | 0, (k | 0) < 0) break i;
                                                n = D(k), i[f + 28 >> 2] = n, i[f + 24 >> 2] = n, u = k + n | 0, i[f + 32 >> 2] = u, v0(n, t, k), i[f + 28 >> 2] = u;
                                            }
                                            if (f = f + 40 | 0, r = r + 40 | 0, (e | 0) == (r | 0)) break;
                                        }
                                        i[A + 4 >> 2] = f;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function Fn(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;
                            i: {
                                if ((f | k) < 0 || (u = i[A + 124 >> 2], i[u + 484 >> 2] <= (f | 0) | i[u + 488 >> 2] <= (k | 0)) || (h = i[A + 132 >> 2], t = i[h + 8496 >> 2], n = i[u + 16936 >> 2], s = i[u + 16924 >> 2], i[(t + (f >>> n << 2) | 0) + (Z(s, k >>> n | 0) << 2) >> 2] > i[(t + (r >> n << 2) | 0) + (Z(e >> n, s) << 2) >> 2]) || (n = i[A + 152 >> 2], t = e, e = i[u + 16876 >> 2], t = t >> e, A = i[A + 140 >> 2], r = r >> e, s = I[(Z(Z(n, t), 24) + A | 0) + Z(r, 24) >> 1], k = k >>> e | 0, n = A + Z(Z(k, n), 24) | 0, A = f >>> e | 0, (s | 0) != I[n + Z(A, 24) >> 1])) break i;
                                f = r << 2, r = i[h + 8484 >> 2], e = i[u + 16892 >> 2], w = i[(f + r | 0) + (Z(e, t) << 2) >> 2] == i[(r + (A << 2) | 0) + (Z(e, k) << 2) >> 2];
                            }
                            return w;
                        }
                        function Yn(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            u = m - 16 | 0, m = u, k = m - 16 | 0, m = k, f = A;
                            i: {
                                if (r >>> 0 <= 1073741815) {
                                    e: {
                                        if (r >>> 0 < 2) {
                                            o[f + 11 | 0] = l[f + 11 | 0] & 128 | r & 127, o[f + 11 | 0] = l[f + 11 | 0] & 127;
                                            break e;
                                        }
                                        t = k + 8 | 0, r >>> 0 >= 2 ? (n = r + 2 & -2, A = n - 1 | 0, A = (A | 0) == 2 ? n : A) : A = 1, D6(t, A + 1 | 0), A = i[k + 8 >> 2], i[f >> 2] = A, i[f + 8 >> 2] = i[f + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[f + 8 >> 2] = i[f + 8 >> 2] | -2147483648, i[f + 4 >> 2] = r;
                                    }
                                    for(n = m - 16 | 0, m = n, i[n + 12 >> 2] = e, e = A, t = r;;){
                                        if (t) {
                                            i[e >> 2] = i[n + 12 >> 2], t = t - 1 | 0, e = e + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    m = n + 16 | 0, i[k + 4 >> 2] = 0, i[(r << 2) + A >> 2] = i[k + 4 >> 2], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            return m = u + 16 | 0, f;
                        }
                        function NZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 32 | 0, m = f, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, i[r + 108 >> 2] - i[r + 104 >> 2] & 255), k = i[r + 104 >> 2], (k | 0) != i[r + 108 >> 2]) for(; f2(e, l[k + n | 0]), n = n + 1 | 0, k = i[r + 104 >> 2], n >>> 0 < i[r + 108 >> 2] - k >>> 0;);
                            i[e + 12 >> 2] = t, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + t | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function je(A, r, e, f, k, n, t, u, s, h, w) {
                            var v = 0, _ = 0, B = 0, G = 0;
                            if (!l[e + 332 | 0]) {
                                Q[h >> 1] = 0, Q[h + 2 >> 1] = 0, o[w | 0] = 0;
                                return;
                            }
                            if (_ = i[i[r + 124 >> 2] + 16876 >> 2], i[e + 28 >> 2] | l[e + 380 | 0] ? v = 924 : v = 988, v = i[(v + e | 0) + (i[e + 384 >> 2] << 2) >> 2], !(p[i[i[A >> 2] + 12 >> 2]](A, v) | 0)) {
                                Q[h >> 1] = 0, Q[h + 2 >> 1] = 0, o[w | 0] = 0, W2(A + 4 | 0, 1012, 0);
                                return;
                            }
                            i: {
                                e: {
                                    r: {
                                        B = k + t | 0;
                                        A: {
                                            if (k >> _ != B >> _ || (G = f + n | 0, _ = i[r + 124 >> 2], (G | 0) >= i[_ + 484 >> 2])) break A;
                                            if (i[_ + 488 >> 2] > (B | 0)) break r;
                                        }
                                        Q[h >> 1] = 0, Q[h + 2 >> 1] = 0, o[w | 0] = 0;
                                        break e;
                                    }
                                    if (A5(A, r, e, v, G & -16, B & -16, u, s, h, w), l[w | 0]) break i;
                                }
                                A5(A, r, e, v, (n >> 1) + f & -16, (t >> 1) + k & -16, u, s, h, w);
                            }
                        }
                        function DZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 32 | 0, m = f, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 104 >> 2]), l2(e, i[r + 112 >> 2] - i[r + 108 >> 2] >> 2), k = i[r + 108 >> 2], t = i[r + 112 >> 2], (k | 0) != (t | 0)) for(; l2(e, i[k >> 2]), k = k + 4 | 0, (t | 0) != (k | 0););
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function MZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((f | 0) == 3 | i[k + 8 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(!i[e >> 2] & f - 1 >>> 0 <= 2)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                e: switch(I[e + 24 >> 1] - 11 | 0){
                                    case 0:
                                    case 3:
                                        i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break i;
                                    default:
                                        break e;
                                }
                                if (f = i[e + 12 >> 2], (f | 0) >= 9) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (f | 0) != 8) break i;
                                f = V8(r + 4 | 0), i[f >> 2] = 1, i[f + 4 >> 2] = 3, o[f + 8 | 0] = l[e + 8 | 0], i[f + 12 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, f, r);
                            }
                            m = r + 32 | 0;
                        }
                        function UZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((e | 0) > 0) for(v = e & 2147483644, h = e & 3, _ = e >>> 0 < 4;;){
                                if (w = Z(e, s), u = 0, f = 0, t = 0, !_) for(; n = f, f = u + w | 0, k = n + Q[(f << 1) + r >> 1] | 0, i[(f << 2) + A >> 2] = k, n = f + 1 | 0, k = k + Q[(n << 1) + r >> 1] | 0, i[(n << 2) + A >> 2] = k, n = f + 2 | 0, k = k + Q[(n << 1) + r >> 1] | 0, i[(n << 2) + A >> 2] = k, n = f + 3 | 0, f = k + Q[(n << 1) + r >> 1] | 0, i[(n << 2) + A >> 2] = f, u = u + 4 | 0, t = t + 4 | 0, (v | 0) != (t | 0););
                                if (t = 0, h) for(; k = u + w | 0, f = Q[(k << 1) + r >> 1] + f | 0, i[(k << 2) + A >> 2] = f, u = u + 1 | 0, t = t + 1 | 0, (h | 0) != (t | 0););
                                if (s = s + 1 | 0, (s | 0) == (e | 0)) break;
                            }
                        }
                        function En(A, r, e, f) {
                            var k = 0, n = 0;
                            i: {
                                if (!e) {
                                    r = I[r >> 1] | I[r + 2 >> 1] << 16, Q[A >> 1] = r, Q[A + 2 >> 1] = r >>> 16;
                                    break i;
                                }
                                k = (e | 0) >= 127 ? 127 : e, k = (k | 0) <= -128 ? -128 : k, n = k >> 31, f = (f | 0) >= 127 ? 127 : f, f = Z((((k ^ n) - n >>> 1 | 0) + 16384 << 16 >> 16) / (k | 0) << 16 >> 16, (f | 0) <= -128 ? -128 : f) + 32 >> 6, f = (f | 0) >= 4095 ? 4095 : f, n = (f | 0) <= -4096 ? -4096 : f, f = Z(n, Q[r >> 1]), k = f >> 31, f = Z(((f ^ k) - k | 0) + 127 >>> 8 | 0, (f | 0) < 0 ? -1 : (f | 0) != 0), f = (f | 0) >= 32767 ? 32767 : f, Q[A >> 1] = (f | 0) <= -32768 ? -32768 : f, r = Z(n, Q[r + 2 >> 1]), f = r >> 31, k = A, A = Z(((r ^ f) - f | 0) + 127 >>> 8 | 0, (r | 0) < 0 ? -1 : (r | 0) != 0), A = (A | 0) >= 32767 ? 32767 : A, Q[k + 2 >> 1] = (A | 0) <= -32768 ? -32768 : A;
                            }
                            return (e | 0) != 0;
                        }
                        function gn(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            k = m - 16 | 0, m = k, l2(e, f), l2(e, i[r + 16 >> 2]);
                            i: {
                                e: {
                                    if (i[r + 16 >> 2] != 1970628964) break e;
                                    if (i[k + 12 >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 8 >> 2] = 0, n = i[r + 24 >> 2], f = i[r + 20 >> 2], (n | 0) != (f | 0)) {
                                        if (r = n - f | 0, (r | 0) < 0) break i;
                                        n = D(r), i[k + 4 >> 2] = n, t = r + n | 0, i[k + 12 >> 2] = t, v0(n, f, r), i[k + 8 >> 2] = t;
                                    }
                                    if (G4(e, k + 4 | 0), r = i[k + 4 >> 2], !r) break e;
                                    i[k + 8 >> 2] = r, X(r);
                                }
                                r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                                e: {
                                    if (o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break e;
                                    }
                                    j(A, i[21670], i[21671]);
                                }
                                m = k + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function HZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 48 | 0, m = f;
                            i: {
                                if (!e) {
                                    if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, e = A, A = i0(f + 28 | 0, 5, 2001, f + 16 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 27 | 0] >= 0) break i;
                                    X(i[f + 16 >> 2]);
                                    break i;
                                }
                                gt(f + 8 | 0, i[r >> 2]), k = i[f + 8 >> 2];
                                e: {
                                    if (!k) {
                                        if (o[f + 16 | 0] = 0, o[f + 27 | 0] = 0, e = A, A = i0(f + 28 | 0, 2, 124, f + 16 | 0), j0(e, A, i[r >> 2]), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 27 | 0] >= 0) break e;
                                        X(i[f + 16 >> 2]);
                                        break e;
                                    }
                                    i[e >> 2] = i[k + 36 >> 2], j0(A, 86672, i[r >> 2]);
                                }
                                if (A = i[f + 12 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = f + 48 | 0;
                        }
                        function Oe(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            t = i[e >> 2], k = i[e + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1);
                            i: {
                                f = i[A + 20 >> 2];
                                e: {
                                    if (!f) {
                                        n = A + 20 | 0, e = n;
                                        break e;
                                    }
                                    for(;;){
                                        if (e = f, n = i[f + 16 >> 2], n >>> 0 > r >>> 0) {
                                            if (n = f, f = i[f >> 2], f) continue;
                                            break e;
                                        }
                                        if (r >>> 0 <= n >>> 0) break i;
                                        if (f = i[e + 4 >> 2], !f) break;
                                    }
                                    n = e + 4 | 0;
                                }
                                f = D(28), i[f + 24 >> 2] = k, i[f + 20 >> 2] = t, i[f + 16 >> 2] = r, i[f + 8 >> 2] = e, i[f >> 2] = 0, i[f + 4 >> 2] = 0, i[n >> 2] = f, r = i[i[A + 16 >> 2] >> 2], r && (i[A + 16 >> 2] = r, f = i[n >> 2]), h4(i[A + 20 >> 2], f), i[A + 24 >> 2] = i[A + 24 >> 2] + 1;
                                return;
                            }
                            i: {
                                if (!k || (A = i[k + 4 >> 2], i[k + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[k >> 2] + 8 >> 2]](k), g(k);
                            }
                        }
                        function xZ(A, r, e, f, k) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, Y1(A, i[r + 8 >> 2], k)) {
                                i[r + 28 >> 2] == 1 | i[r + 4 >> 2] != (e | 0) || (i[r + 28 >> 2] = f);
                                return;
                            }
                            i: {
                                if (Y1(A, i[r >> 2], k)) {
                                    if (!(i[r + 16 >> 2] != (e | 0) & i[r + 20 >> 2] != (e | 0))) {
                                        if ((f | 0) != 1) break i;
                                        i[r + 32 >> 2] = 1;
                                        return;
                                    }
                                    i[r + 32 >> 2] = f;
                                    e: {
                                        if (i[r + 44 >> 2] == 4) break e;
                                        if (Q[r + 52 >> 1] = 0, A = i[A + 8 >> 2], p[i[i[A >> 2] + 20 >> 2]](A, r, e, e, 1, k), l[r + 53 | 0] == 1) {
                                            if (i[r + 44 >> 2] = 3, !l[r + 52 | 0]) break e;
                                            break i;
                                        }
                                        i[r + 44 >> 2] = 4;
                                    }
                                    if (i[r + 20 >> 2] = e, i[r + 40 >> 2] = i[r + 40 >> 2] + 1, i[r + 36 >> 2] != 1 | i[r + 24 >> 2] != 2) break i;
                                    o[r + 54 | 0] = 1;
                                    return;
                                }
                                A = i[A + 8 >> 2], p[i[i[A >> 2] + 24 >> 2]](A, r, e, f, k);
                            }
                        }
                        function zZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            i: {
                                e: {
                                    r: {
                                        if (r = i[r + 32 >> 2], r) {
                                            if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 100 >> 2], r = i[r + 104 >> 2], (f | 0) != (r | 0)) {
                                                if (r = r - f | 0, (r | 0) < 0) break r;
                                                e = D(r), i[A + 4 >> 2] = e, i[A >> 2] = e, k = r + e | 0, i[A + 8 >> 2] = k, v0(e, f, r), i[A + 4 >> 2] = k;
                                            }
                                            if (r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) break e;
                                            break i;
                                        }
                                        if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) break e;
                                        break i;
                                    }
                                    p0(), z();
                                }
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function Jn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (r) for(f = i[A + 16 >> 2], k = i[A + 20 >> 2], n = i[A + 8 >> 2], e = i[A + 24 >> 2], t = i[A >> 2];;){
                                if ((e | 0) <= 7) {
                                    for(u = 64 - e | 0, v = 0, e = t;;){
                                        i: {
                                            if (_ = u, !n) {
                                                n = 0, t = e, s = u;
                                                break i;
                                            }
                                            if (t = e + 1 | 0, i[A >> 2] = t, e = l[e | 0], n = n - 1 | 0, i[A + 8 >> 2] = n, s = _ - 8 | 0, h = s & 31, (s & 63) >>> 0 >= 32 ? (w = e << h, e = 0) : (w = (1 << h) - 1 & e >>> 32 - h, e = e << h), f = e | f, e = k | w, k = e, i[A + 16 >> 2] = f, i[A + 20 >> 2] = e, e = u, u = e - 8 | 0, v = v - (e >>> 0 < 8) | 0, e = t, (_ | 0) > 15) continue;
                                        }
                                        break;
                                    }
                                    e = 64 - s | 0;
                                }
                                if (e = e - 8 | 0, i[A + 24 >> 2] = e, w = k << 8 | f >>> 24, f = f << 8, i[A + 16 >> 2] = f, k = w, i[A + 20 >> 2] = k, r = r - 1 | 0, !r) break;
                            }
                        }
                        function Rn(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0;
                            i: {
                                e: {
                                    if (n = i[f >> 2], f = i[n + 104 >> 2], n = i[n + 108 >> 2], (f | 0) != (n | 0)) for(;;){
                                        if (i[f >> 2] == (e | 0)) break e;
                                        if (f = f + 16 | 0, (n | 0) == (f | 0)) break;
                                    }
                                    break i;
                                }
                                e: {
                                    r: {
                                        if (e = i[f + 4 >> 2], f = i[f + 8 >> 2], (e | 0) == (f | 0)) break r;
                                        for(n = i[r + 36 >> 2], u = i[r + 40 >> 2] - n >> 3;;){
                                            if (r = I[e + 2 >> 1], !(r >>> 0 <= u >>> 0 && r)) break i;
                                            if (r = n + (r << 3) | 0, t = i[r - 8 >> 2], i[t + 16 >> 2] != (k | 0)) {
                                                if (e = e + 4 | 0, (f | 0) == (e | 0)) break r;
                                                continue;
                                            }
                                            break;
                                        }
                                        if (i[A >> 2] = t, e = A, A = i[r - 4 >> 2], i[e + 4 >> 2] = A, !A) break e;
                                        i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                                        return;
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                }
                                return;
                            }
                            i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function TZ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            f = i[r + 24 >> 2], r = i[r + 28 >> 2];
                            i: {
                                if ((f | 0) == (r | 0)) break i;
                                for(;;){
                                    e: {
                                        r: {
                                            if (e = i[f >> 2], !e || !E0(e, 73632, 81740)) break r;
                                            if (e = i[f + 4 >> 2], !e) break e;
                                            i[e + 4 >> 2] = i[e + 4 >> 2] + 1;
                                            break i;
                                        }
                                        if (f = f + 8 | 0, (r | 0) != (f | 0)) continue;
                                    }
                                    break;
                                }
                                e = 0;
                            }
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            i: {
                                if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                        }
                        function a3(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A + 4 >> 2] && (r = i[A + 308 >> 2], e = i[A + 112 >> 2], e && (f = i[e + 544 >> 2]), p[r | 0](e, A, f), i[A + 12 >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 72 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 68 >> 2] = 0), r = i[A + 52 >> 2], k = i[A + 56 >> 2], (r | 0) != (k | 0)) for(f = 0;;){
                                if (e = i[(f << 2) + r >> 2], e) {
                                    r = i[e + 1352 >> 2], r && (i[e + 1356 >> 2] = r, X(r)), C8(e + 1340 | 0), r = i[e + 784 >> 2], r && (i[e + 788 >> 2] = r, X(r)), r = i[e + 8 >> 2];
                                    i: {
                                        if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    X(e), k = i[A + 56 >> 2], r = i[A + 52 >> 2];
                                }
                                if (f = f + 1 | 0, !(f >>> 0 < k - r >> 2 >>> 0)) break;
                            }
                            i[A + 56 >> 2] = r;
                        }
                        function SZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 32 | 0, m = f, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 100 >> 2]), l2(e, i[r + 104 >> 2]), k = i[r + 108 >> 2], t = i[r + 112 >> 2], (k | 0) != (t | 0)) for(; l2(e, i[k >> 2]), k = k + 4 | 0, (t | 0) != (k | 0););
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function w4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                if (r) {
                                    if (f = i[A + 44 >> 2], t = i[A + 40 >> 2], k = f - t | 0, e = k >> 2, e >>> 0 <= 15) {
                                        if (n = i[A + 48 >> 2], n >>> 0 > f >>> 0) {
                                            i[f >> 2] = r, i[A + 44 >> 2] = f + 4;
                                            return;
                                        }
                                        if (n = n - t | 0, u = n >> 1, e = e + 1 | 0, e = n >>> 0 >= 2147483644 ? 1073741823 : e >>> 0 < u >>> 0 ? u : e, e >>> 0 >= 1073741824) break i;
                                        if (e = e << 2, n = D(e), k = n + k | 0, i[k >> 2] = r, r = k + 4 | 0, (f | 0) != (t | 0)) for(; k = k - 4 | 0, f = f - 4 | 0, i[k >> 2] = i[f >> 2], (f | 0) != (t | 0););
                                        i[A + 48 >> 2] = e + n, i[A + 44 >> 2] = r, i[A + 40 >> 2] = k, t && X(t), i[A + 44 >> 2] = r;
                                        return;
                                    }
                                    X(i[r + 20 >> 2]), A = i[r + 32 >> 2], A && (i[r + 36 >> 2] = A, X(A)), X(r);
                                }
                                return;
                            }
                            Z2(), z();
                        }
                        function Nn(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (i[A >> 2] = 81944, n = i[A + 176 >> 2], n) {
                                if (r = n, e = i[A + 180 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        if (u = e - 12 | 0, f = i[u >> 2], f) {
                                            if (k = f, s = e - 8 | 0, r = i[s >> 2], (f | 0) != (r | 0)) {
                                                for(; k = r - 12 | 0, t = i[k >> 2], t && (i[r - 8 >> 2] = t, X(t)), r = k, (f | 0) != (r | 0););
                                                k = i[u >> 2];
                                            }
                                            i[s >> 2] = f, X(k);
                                        }
                                        if (e = e - 16 | 0, (n | 0) == (e | 0)) break;
                                    }
                                    r = i[A + 176 >> 2];
                                }
                                i[A + 180 >> 2] = n, X(r);
                            }
                            return r = i[A + 156 >> 2], r && (i[A + 160 >> 2] = r, X(r)), r = i[A + 144 >> 2], r && (i[A + 148 >> 2] = r, X(r)), r = i[A + 132 >> 2], r && X(r), r = i[A + 120 >> 2], r && (i[A + 124 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function jZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = m - 32 | 0, m = n;
                            i: {
                                if (!(k && r)) {
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 7560;
                                    break i;
                                }
                                i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, g3(n + 12 | 0, r, e, f, n + 24 | 0);
                                e: {
                                    if (i[n + 12 >> 2]) {
                                        r = i[n + 16 >> 2], i[A >> 2] = i[n + 12 >> 2], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[n + 20 >> 2];
                                        break e;
                                    }
                                    if (r = i[n + 24 >> 2], !r) {
                                        i[A >> 2] = 5, i[A + 4 >> 2] = 2007, i[A + 8 >> 2] = 2155;
                                        break e;
                                    }
                                    i[k >> 2] = i[r + 104 >> 2] - i[r + 100 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                }
                                if (A = i[n + 28 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = n + 32 | 0;
                        }
                        function OZ(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0;
                            for(e = m - 128 | 0, m = e, i[e + 12 >> 2] = e + 116, f = e + 16 | 0, K9(A + 8 | 0, f, e + 12 | 0, k, n, t), t = m - 16 | 0, m = t, A = m - 32 | 0, m = A, lr(A + 24 | 0, f, i[e + 12 >> 2]), u = A + 16 | 0, s = i[A + 28 >> 2], k = m - 16 | 0, m = k, n = i[A + 24 >> 2], i[k + 8 >> 2] = n, i[k + 12 >> 2] = r;;){
                                if ((n | 0) != (s | 0)) {
                                    bA(k + 12 | 0, o[n | 0]), n = n + 1 | 0, i[k + 8 >> 2] = n;
                                    continue;
                                }
                                break;
                            }
                            return i[u >> 2] = i[k + 8 >> 2], i[u + 4 >> 2] = i[k + 12 >> 2], m = k + 16 | 0, i[A + 12 >> 2] = (i[A + 16 >> 2] - f | 0) + f, i[A + 8 >> 2] = i[A + 20 >> 2], i[t + 8 >> 2] = i[A + 12 >> 2], i[t + 12 >> 2] = i[A + 8 >> 2], m = A + 32 | 0, m = t + 16 | 0, m = e + 128 | 0, i[t + 12 >> 2];
                        }
                        function b8(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            if (k = i[A + 16 >> 2], !((k | 0) >= (r | 0) | (k | 0) > 56)) {
                                for(n = 64 - k | 0, k = i[A + 4 >> 2];;){
                                    i: {
                                        if (f = n, !k) {
                                            t = f;
                                            break i;
                                        }
                                        if (e = i[A >> 2], i[A >> 2] = e + 1, e = l[e | 0], k = k - 1 | 0, i[A + 4 >> 2] = k, h = i[A + 12 >> 2], t = f - 8 | 0, u = t & 31, w = A, (t & 63) >>> 0 >= 32 ? (s = e << u, e = 0) : (s = (1 << u) - 1 & e >>> 32 - u, e = e << u), i[w + 8 >> 2] = e | i[A + 8 >> 2], i[A + 12 >> 2] = s | h, e = n, n = e - 8 | 0, v = v - (e >>> 0 < 8) | 0, (f | 0) > 15) continue;
                                    }
                                    break;
                                }
                                k = 64 - t | 0;
                            }
                            i[A + 16 >> 2] = k - r, n = i[A + 12 >> 2], e = i[A + 8 >> 2], f = r & 31, (r & 63) >>> 0 >= 32 ? (r = e << f, f = 0) : (r = (1 << f) - 1 & e >>> 32 - f | n << f, f = e << f), i[A + 8 >> 2] = f, i[A + 12 >> 2] = r;
                        }
                        function PZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if ((f | 0) > 0) for(_ = f & 2147483646, B = f & 1, t = -1 << k ^ -1;;){
                                if (u = (Z(f, h) << 2) + e | 0, w = (Z(r, h) << 1) + A | 0, k = 0, v = 0, (f | 0) != 1) for(; s = w + (k << 1) | 0, n = i[(k << 2) + u >> 2] + I[s >> 1] | 0, Q[s >> 1] = (n | 0) >= 0 ? (n | 0) < (t | 0) ? n : t : 0, n = k | 1, s = w + (n << 1) | 0, n = i[(n << 2) + u >> 2] + I[s >> 1] | 0, Q[s >> 1] = (n | 0) >= 0 ? (n | 0) < (t | 0) ? n : t : 0, k = k + 2 | 0, v = v + 2 | 0, (_ | 0) != (v | 0););
                                if (B && (n = i[(k << 2) + u >> 2], u = w + (k << 1) | 0, k = n + I[u >> 1] | 0, Q[u >> 1] = (k | 0) >= 0 ? (k | 0) < (t | 0) ? k : t : 0), h = h + 1 | 0, (h | 0) == (f | 0)) break;
                            }
                        }
                        function LZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 100 >> 2]), l2(e, i[r + 104 >> 2]), l2(e, i[r + 108 >> 2]), l2(e, i[r + 112 >> 2]), l2(e, i[r + 116 >> 2]), l2(e, i[r + 120 >> 2]), l2(e, i[r + 124 >> 2]), l2(e, i[r + 128 >> 2]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function KZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(!(i[e >> 2] != 1 | i[e + 4 >> 2] != 3) & i[e + 12 >> 2] == 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, l[e + 8 | 0] || (o[r + 12 | 0] = 0, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 12, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r)), o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 13, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function qZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            n = m - 32 | 0, m = n, i[n + 28 >> 2] = r;
                            i: {
                                if (!(i[e + 4 >> 2] & 1)) {
                                    e = p[i[i[A >> 2] + 24 >> 2]](A, r, e, f, k) | 0;
                                    break i;
                                }
                                r = n + 16 | 0, A = i[e + 28 >> 2], i[r >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(r, 108644), d0(r);
                                e: {
                                    if (k) {
                                        p[i[i[A >> 2] + 24 >> 2]](r, A);
                                        break e;
                                    }
                                    p[i[i[A >> 2] + 28 >> 2]](n + 16 | 0, A);
                                }
                                for(t = n, u = Q4(n + 16 | 0), i[t + 12 >> 2] = u;;){
                                    if (A = n + 16 | 0, t = n, u = M8(A), i[t + 8 >> 2] = u, r = i[n + 12 >> 2], (r | 0) != i[n + 8 >> 2]) {
                                        At(n + 28 | 0, i[r >> 2]), i[n + 12 >> 2] = i[n + 12 >> 2] + 4;
                                        continue;
                                    } else e = i[n + 28 >> 2], h1(A);
                                    break;
                                }
                            }
                            return m = n + 32 | 0, e | 0;
                        }
                        function $Z(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(!(i[e >> 2] != 1 | i[e + 4 >> 2] != 3) & i[e + 12 >> 2] > 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, l[e + 8 | 0] || (o[r + 12 | 0] = 0, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 12, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r)), o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 13, i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function aZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, n = i[r + 12 >> 2];
                            i: {
                                if (!n & k0[r + 8 >> 2] >= k0[r + 32 >> 2] | n) {
                                    if (G4(e, r + 100 | 0), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                if (o[f | 0] = 0, o[f + 11 | 0] = 0, i0(A, 2, 101, f), o[f + 11 | 0] >= 0) break i;
                                X(i[f >> 2]);
                            }
                            m = f + 32 | 0;
                        }
                        function bZ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            n = m - 32 | 0, m = n, i[n + 28 >> 2] = r;
                            i: {
                                if (!(i[e + 4 >> 2] & 1)) {
                                    e = p[i[i[A >> 2] + 24 >> 2]](A, r, e, f, k) | 0;
                                    break i;
                                }
                                r = n + 16 | 0, A = i[e + 28 >> 2], i[r >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(r, 108636), d0(r);
                                e: {
                                    if (k) {
                                        p[i[i[A >> 2] + 24 >> 2]](r, A);
                                        break e;
                                    }
                                    p[i[i[A >> 2] + 28 >> 2]](n + 16 | 0, A);
                                }
                                for(t = n, u = Q4(n + 16 | 0), i[t + 12 >> 2] = u;;){
                                    if (A = n + 16 | 0, t = n, u = U8(A), i[t + 8 >> 2] = u, r = i[n + 12 >> 2], (r | 0) != i[n + 8 >> 2]) {
                                        bA(n + 28 | 0, o[r | 0]), i[n + 12 >> 2] = i[n + 12 >> 2] + 1;
                                        continue;
                                    } else e = i[n + 28 >> 2], a0(A);
                                    break;
                                }
                            }
                            return m = n + 32 | 0, e | 0;
                        }
                        function Dn(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (f = i[A + 8 >> 2], e = i[A + 4 >> 2], f - e >> 3 >>> 0 >= r >>> 0) {
                                r && (r = r << 3, e = B0(e, 0, r) + r | 0), i[A + 4 >> 2] = e;
                                return;
                            }
                            i: {
                                if (n = i[A >> 2], t = e - n >> 3, k = t + r | 0, k >>> 0 < 536870912) {
                                    if (f = f - n | 0, u = f >> 2, f = f >>> 0 >= 2147483640 ? 536870911 : k >>> 0 < u >>> 0 ? u : k, f) {
                                        if (f >>> 0 >= 536870912) break i;
                                        s = D(f << 3);
                                    }
                                    if (k = (t << 3) + s | 0, r = r << 3, r = B0(k, 0, r) + r | 0, (e | 0) != (n | 0)) {
                                        for(; e = e - 8 | 0, t = i[e + 4 >> 2], k = k - 8 | 0, i[k >> 2] = i[e >> 2], i[k + 4 >> 2] = t, (e | 0) != (n | 0););
                                        n = i[A >> 2];
                                    }
                                    i[A + 8 >> 2] = (f << 3) + s, i[A + 4 >> 2] = r, i[A >> 2] = k, n && X(n);
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function dZ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 32 | 0, m = f, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0;
                            i: {
                                e: {
                                    if (!(k0[r + 100 >> 2] > 65535 | k0[r + 104 >> 2] > 65535)) {
                                        if (k = k0[r + 108 >> 2] > 65535, f2(e, k), k) break e;
                                        w2(e, I[r + 100 >> 1]), w2(e, I[r + 104 >> 1]), w2(e, I[r + 108 >> 1]);
                                        break i;
                                    }
                                    f2(e, 1);
                                }
                                l2(e, i[r + 100 >> 2]), l2(e, i[r + 104 >> 2]), l2(e, i[r + 108 >> 2]);
                            }
                            E4(f + 12 | 0, r, e, n), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function cZ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0;
                            r = m - 16 | 0, m = r, f = i[e + 16 >> 2], f && (k = i[e + 8 >> 2], k && (dA(k, f), f = i[e + 16 >> 2]), k = i[e >> 2], t = p[i[i[k >> 2] + 8 >> 2]](k) | 0, n = w0, u = f, f = f + t | 0, n = u >>> 0 > f >>> 0 ? n + 1 | 0 : n, p[i[i[k >> 2] + 20 >> 2]](k, f, n), i[e + 16 >> 2] = 0);
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[r + 4 | 0] = 0, o[r + 15 | 0] = 0, i0(A, 2, 100, r + 4 | 0), o[r + 15 | 0] >= 0) break i;
                                    X(i[r + 4 >> 2]);
                                    break i;
                                }
                                if (e = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = e, A = A + 8 | 0, o[86691] >= 0) {
                                    e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = r + 16 | 0;
                        }
                        function iG(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            i: {
                                if (t = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, r = i[t >> 2], !r) break i;
                                for(;;){
                                    if (d1(i[r + 4 >> 2], e)) {
                                        if (r = i[t + 4 >> 2], t = t + 4 | 0, r) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (i[r + 8 >> 2] != 1) {
                                    r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                    return;
                                }
                                e: {
                                    if (!l[r + 16 | 0] || (k && (i[k >> 2] = i[r + 20 >> 2]), !n)) break e;
                                    i[n >> 2] = i[r + 24 >> 2];
                                }
                                f && (i[f >> 2] = l[r + 16 | 0]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                return;
                            }
                            r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                        }
                        function eG(A) {
                            return A = A | 0, l[108680] ? i[27169] : (l[109744] || (o[109744] = 1), x2(109456, 71224), x2(109468, 71256), x2(109480, 71292), x2(109492, 71316), x2(109504, 71340), x2(109516, 71356), x2(109528, 71376), x2(109540, 71396), x2(109552, 71424), x2(109564, 71464), x2(109576, 71496), x2(109588, 71532), x2(109600, 71568), x2(109612, 71584), x2(109624, 71600), x2(109636, 71616), x2(109648, 71340), x2(109660, 71632), x2(109672, 71648), x2(109684, 71664), x2(109696, 71680), x2(109708, 71696), x2(109720, 71712), x2(109732, 71728), o[108680] = 1, i[27169] = 109456, 109456);
                        }
                        function rG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 32 | 0, m = f, n = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, R4(e, r + 104 | 0), k = i[r + 116 >> 2], t = i[r + 120 >> 2], (k | 0) != (t | 0)) for(; f2(e, l[k | 0]), k = k + 1 | 0, (t | 0) != (k | 0););
                            i[e + 12 >> 2] = n, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + n | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function AG(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, i[t + 12 >> 2] = 0, i[t + 4 >> 2] = 0, i[t + 8 >> 2] = 0;
                            i: {
                                if (n) {
                                    if ((n | 0) < 0) break i;
                                    n = n << 2, u = D(n), i[t + 4 >> 2] = u, s = n + u | 0, i[t + 12 >> 2] = s, v0(u, k, n), i[t + 8 >> 2] = s;
                                }
                                r = i[r >> 2], k = i[r + 48 >> 2], r = i[r + 52 >> 2];
                                e: {
                                    if (!r) {
                                        J4(k, f, e, t + 4 | 0);
                                        break e;
                                    }
                                    if (i[r + 4 >> 2] = i[r + 4 >> 2] + 1, J4(k, f, e, t + 4 | 0), e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], A = i[t + 4 >> 2], A && (i[t + 8 >> 2] = A, X(A)), m = t + 16 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function fG(A, r, e, f, k, n, t, u, s, h) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0;
                            var w = 0, v = 0, _ = 0;
                            if (!((n | 0) <= 0 | (k | 0) <= 0)) for(t = 14 - h | 0, v = k & 2147483644, w = k & 3, s = 0, _ = k >>> 0 < 4;;){
                                if (k = (Z(f, s) << 1) + e | 0, h = (Z(r, s) << 1) + A | 0, u = 0, !_) for(; Q[h >> 1] = I[k >> 1] << t, Q[h + 2 >> 1] = I[k + 2 >> 1] << t, Q[h + 4 >> 1] = I[k + 4 >> 1] << t, Q[h + 6 >> 1] = I[k + 6 >> 1] << t, k = k + 8 | 0, h = h + 8 | 0, u = u + 4 | 0, (v | 0) != (u | 0););
                                if (u = 0, w) for(; Q[h >> 1] = I[k >> 1] << t, k = k + 2 | 0, h = h + 2 | 0, u = u + 1 | 0, (w | 0) != (u | 0););
                                if (s = s + 1 | 0, (s | 0) == (n | 0)) break;
                            }
                        }
                        function Mn(A, r, e, f, k, n) {
                            var t = 0, u = 0;
                            i: {
                                e: {
                                    r: {
                                        if (f = f - i[A + 208 >> 2] | 0, (f | 0) != 31) for(u = e, e = i[A + 124 >> 2], t = i[e + 16944 >> 2], e = Z(u >> t, i[e + 16948 >> 2]) + (r >> t) | 0, n = n ? k | -128 : k, r = 1 << f, f = 0;;){
                                            for(k = 0;;){
                                                if (t = i[A + 124 >> 2], i[t + 16948 >> 2] <= (k | 0)) break r;
                                                if (i[t + 16952 >> 2] <= (f | 0)) break e;
                                                if (t = (e + k | 0) + Z(i[A + 232 >> 2], f) | 0, (t | 0) >= i[A + 224 >> 2]) break i;
                                                if (o[t + i[A + 220 >> 2] | 0] = n, k = k + 1 | 0, (r | 0) == (k | 0)) break;
                                            }
                                            if (f = f + 1 | 0, (r | 0) == (f | 0)) break;
                                        }
                                        return;
                                    }
                                    y0(5191, 9012, 690, 16488), z();
                                }
                                y0(5166, 9012, 691, 16488), z();
                            }
                            y0(9449, 9012, 694, 16488), z();
                        }
                        function Un(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            if (k = i[A + 216 >> 2], e = i[A + 220 >> 2], k >>> 0 < e >>> 0) {
                                i[k >> 2] = r, i[A + 216 >> 2] = k + 4;
                                return;
                            }
                            i: {
                                if (t = i[A + 212 >> 2], f = k - t >> 2, n = f + 1 | 0, n >>> 0 < 1073741824) {
                                    if (u = f << 2, e = e - t | 0, f = e >> 1, f = e >>> 0 >= 2147483644 ? 1073741823 : f >>> 0 > n >>> 0 ? f : n, f) {
                                        if (f >>> 0 >= 1073741824) break i;
                                        n = D(f << 2);
                                    } else n = 0;
                                    if (e = u + n | 0, i[e >> 2] = r, r = e + 4 | 0, (k | 0) != (t | 0)) for(; e = e - 4 | 0, k = k - 4 | 0, i[e >> 2] = i[k >> 2], (k | 0) != (t | 0););
                                    i[A + 220 >> 2] = n + (f << 2), i[A + 216 >> 2] = r, i[A + 212 >> 2] = e, t && X(t), i[A + 216 >> 2] = r;
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function kG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((f | 0) == 3 | i[k + 8 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                e: {
                                    if (!(i[e >> 2] | (f | 0) != 1 | i[e + 12 >> 2] != 8) && l[e + 8 | 0] != 1) break e;
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (f = I[e + 24 >> 1], !(f >>> 0 > 14 | !(1 << f & 18689))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (e = l[e + 26 | 0], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (e | 0) != 1) break i;
                                e = V8(r + 4 | 0), i[e + 12 >> 2] = 8, o[e + 8 | 0] = 0, i[e >> 2] = 1, i[e + 4 >> 2] = 10, i[r >> 2] = 11, $2(A, e, r);
                            }
                            m = r + 32 | 0;
                        }
                        function nG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            for(n = m - 16 | 0, m = n;;){
                                i: {
                                    if ((e | 0) <= (t | 0)) break i;
                                    f = i[A + 12 >> 2], k = i[A + 16 >> 2];
                                    e: {
                                        if (f >>> 0 < k >>> 0) {
                                            i[n + 12 >> 2] = 2147483647, i[n + 8 >> 2] = k - f >> 2, i[n + 4 >> 2] = e - t, f = m - 16 | 0, m = f, m = f + 16 | 0, f = m - 16 | 0, m = f, m = f + 16 | 0, f = n + 4 | 0, k = n + 8 | 0, f = i[f >> 2] < i[k >> 2] ? f : k, k = n + 12 | 0, f = i[(i[f >> 2] < i[k >> 2] ? f : k) >> 2], r6(i[A + 12 >> 2], f, r), k = f << 2, i[A + 12 >> 2] = k + i[A + 12 >> 2], r = r + k | 0;
                                            break e;
                                        }
                                        if (f = p[i[i[A >> 2] + 40 >> 2]](A) | 0, (f | 0) == -1) break i;
                                        i[r >> 2] = f, f = 1, r = r + 4 | 0;
                                    }
                                    t = f + t | 0;
                                    continue;
                                }
                                break;
                            }
                            return m = n + 16 | 0, t | 0;
                        }
                        function tG(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0, G = 0, W = 0;
                            if (!(n & 1)) {
                                if (!((t | 0) <= 0 | (n | 0) <= 0)) for(G = 15 - u | 0, W = 1 << 14 - u, w = -1 << u ^ -1;;){
                                    for(u = (Z(r, v) << 1) + A | 0, s = Z(k, v) << 1, _ = s + f | 0, s = e + s | 0, B = 0; h = Q[_ >> 1] + (Q[s >> 1] + W | 0) >> G, Q[u >> 1] = (h | 0) >= 0 ? (h | 0) < (w | 0) ? h : w : 0, h = Q[_ + 2 >> 1] + (Q[s + 2 >> 1] + W | 0) >> G, Q[u + 2 >> 1] = (h | 0) >= 0 ? (h | 0) < (w | 0) ? h : w : 0, _ = _ + 4 | 0, s = s + 4 | 0, u = u + 4 | 0, B = B + 2 | 0, (B | 0) < (n | 0););
                                    if (v = v + 1 | 0, (v | 0) == (t | 0)) break;
                                }
                                return;
                            }
                            y0(18295, 14969, 238, 8556), z();
                        }
                        function b4(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            if (k = i[A + 8 >> 2], n = i[A >> 2], k - n >>> 0 >= f >>> 0) {
                                if (t = f, k = i[A + 4 >> 2], f = k - n | 0, t >>> 0 > f >>> 0) {
                                    (k | 0) != (n | 0) && (Q0(n, r, f), k = i[A + 4 >> 2]), r = r + f | 0, f = e - r | 0, (r | 0) != (e | 0) && Q0(k, r, f), i[A + 4 >> 2] = f + k;
                                    return;
                                }
                                f = e - r | 0, (r | 0) != (e | 0) && Q0(n, r, f), i[A + 4 >> 2] = f + n;
                                return;
                            }
                            if (n && (i[A + 4 >> 2] = n, X(n), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = 0), (f | 0) >= 0) {
                                n = k << 1, k = k >>> 0 >= 1073741823 ? 2147483647 : f >>> 0 < n >>> 0 ? n : f, f = D(k), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + k, k = e - r | 0, (r | 0) != (e | 0) && v0(f, r, k), i[A + 4 >> 2] = f + k;
                                return;
                            }
                            p0(), z();
                        }
                        function oG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if ((f | 0) > 0) for(_ = f & 2147483646, B = f & 1, t = -1 << k ^ -1;;){
                                if (u = Z(r, h) + A | 0, w = (Z(f, h) << 2) + e | 0, k = 0, v = 0, (f | 0) != 1) for(; s = k + u | 0, n = i[(k << 2) + w >> 2] + l[s | 0] | 0, o[s | 0] = (n | 0) >= 0 ? (n | 0) < (t | 0) ? n : t : 0, n = k | 1, s = n + u | 0, n = i[(n << 2) + w >> 2] + l[s | 0] | 0, o[s | 0] = (n | 0) >= 0 ? (n | 0) < (t | 0) ? n : t : 0, k = k + 2 | 0, v = v + 2 | 0, (_ | 0) != (v | 0););
                                if (B && (u = k + u | 0, k = i[(k << 2) + w >> 2] + l[u | 0] | 0, o[u | 0] = (k | 0) >= 0 ? (k | 0) < (t | 0) ? k : t : 0), h = h + 1 | 0, (h | 0) == (f | 0)) break;
                            }
                        }
                        function uG(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = i[A >> 2], A = i[e + 24 >> 2], e = i[e + 28 >> 2];
                            i: {
                                if ((A | 0) != (e | 0)) for(;;){
                                    e: {
                                        if (f = i[A >> 2], !f || (f = E0(f, 73632, 75876), !f)) break e;
                                        if (e = i[A + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r && (A = i[f + 104 >> 2], i[r >> 2] = i[f + 100 >> 2], i[r + 4 >> 2] = A, A = i[f + 120 >> 2], i[r + 16 >> 2] = i[f + 116 >> 2], i[r + 20 >> 2] = A, A = i[f + 112 >> 2], i[r + 8 >> 2] = i[f + 108 >> 2], i[r + 12 >> 2] = A), A = 1, !e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break i;
                                        return p[i[i[e >> 2] + 8 >> 2]](e), g(e), 1;
                                    }
                                    if (A = A + 8 | 0, (e | 0) == (A | 0)) break;
                                }
                                A = 0;
                            }
                            return A | 0;
                        }
                        function lG(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0;
                            var s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (!((n | 0) <= 0 | (k | 0) <= 0)) for(t = 14 - u | 0, v = k & 2147483644, w = k & 3, _ = k >>> 0 < 4;;){
                                if (k = (Z(r, h) << 1) + A | 0, u = (Z(f, h) << 1) + e | 0, s = 0, !_) for(; Q[k >> 1] = I[u >> 1] << t, Q[k + 2 >> 1] = I[u + 2 >> 1] << t, Q[k + 4 >> 1] = I[u + 4 >> 1] << t, Q[k + 6 >> 1] = I[u + 6 >> 1] << t, k = k + 8 | 0, u = u + 8 | 0, s = s + 4 | 0, (v | 0) != (s | 0););
                                if (s = 0, w) for(; Q[k >> 1] = I[u >> 1] << t, k = k + 2 | 0, u = u + 2 | 0, s = s + 1 | 0, (w | 0) != (s | 0););
                                if (h = h + 1 | 0, (h | 0) == (n | 0)) break;
                            }
                        }
                        function sG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0;
                            if ((e | 0) > 0) for(w = e & 2147483644, s = e & 3, v = e >>> 0 < 4;;){
                                if (h = Z(e, u), k = 0, n = 0, !v) for(; f = k + h | 0, i[(f << 2) + A >> 2] = Q[(f << 1) + r >> 1], t = f + 1 | 0, i[(t << 2) + A >> 2] = Q[(t << 1) + r >> 1], t = f + 2 | 0, i[(t << 2) + A >> 2] = Q[(t << 1) + r >> 1], f = f + 3 | 0, i[(f << 2) + A >> 2] = Q[(f << 1) + r >> 1], k = k + 4 | 0, n = n + 4 | 0, (w | 0) != (n | 0););
                                if (f = 0, s) for(; n = k + h | 0, i[(n << 2) + A >> 2] = Q[(n << 1) + r >> 1], k = k + 1 | 0, f = f + 1 | 0, (s | 0) != (f | 0););
                                if (u = u + 1 | 0, (u | 0) == (e | 0)) break;
                            }
                        }
                        function hG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 97 | 0] | 128), f2(e, l[r + 99 | 0] & 31 | l[r + 98 | 0] << 5 & 224), f2(e, l[r + 106 | 0] & 3 | ((l[r + 101 | 0] != 0) << 6 | (l[r + 100 | 0] != 0) << 7 | (l[r + 102 | 0] != 0) << 5 | (l[r + 103 | 0] != 0) << 4 | (l[r + 104 | 0] != 0) << 3 | (l[r + 105 | 0] != 0) << 2)), f2(e, 0), E4(f + 12 | 0, r, e, k), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function wG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            if (!f) {
                                i[A >> 2] = 5, i[A + 4 >> 2] = 2001, i[A + 8 >> 2] = 3375;
                                return;
                            }
                            if (n = i[r >> 2], k = i[n + 128 >> 2], n = i[n + 132 >> 2], (k | 0) != (n | 0)) for(;;){
                                if (t = i[k >> 2], i[t >> 2] == (e | 0)) {
                                    k = i[k + 4 >> 2], k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), e = D(16), n = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e + 12 >> 2] = k, i[e + 8 >> 2] = t, i[e + 4 >> 2] = r, i[e >> 2] = n, i[f >> 2] = e, i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                    return;
                                }
                                if (k = k + 8 | 0, (n | 0) == (k | 0)) break;
                            }
                            i[A >> 2] = 5, i[A + 4 >> 2] = 2e3, i[A + 8 >> 2] = 3129;
                        }
                        function vG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2];
                            i: {
                                if (!(!l[k + 12 | 0] | ((f | 0) == 3 | i[k + 8 >> 2] == 1))) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (!(!i[e >> 2] & f - 1 >>> 0 <= 2)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                e: switch(I[e + 24 >> 1] - 11 | 0){
                                    case 0:
                                    case 3:
                                        i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                        break i;
                                    default:
                                        break e;
                                }
                                if (f = i[e + 12 >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (f | 0) < 9) break i;
                                f = V8(r + 4 | 0), i[f >> 2] = 1, i[f + 4 >> 2] = 3, o[f + 8 | 0] = l[e + 8 | 0], i[f + 12 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, f, r);
                            }
                            m = r + 32 | 0;
                        }
                        function d4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (e = i[A + 8 >> 2], f = i[A + 4 >> 2], e - f >> 2 >>> 0 >= r >>> 0) {
                                r && (r = r << 2, f = B0(f, 0, r) + r | 0), i[A + 4 >> 2] = f;
                                return;
                            }
                            i: {
                                if (n = i[A >> 2], t = f - n >> 2, k = t + r | 0, k >>> 0 < 1073741824) {
                                    if (e = e - n | 0, u = e >> 1, k = e >>> 0 >= 2147483644 ? 1073741823 : k >>> 0 < u >>> 0 ? u : k, k) {
                                        if (k >>> 0 >= 1073741824) break i;
                                        s = D(k << 2);
                                    }
                                    if (e = (t << 2) + s | 0, r = r << 2, r = B0(e, 0, r) + r | 0, (f | 0) != (n | 0)) for(; e = e - 4 | 0, f = f - 4 | 0, i[e >> 2] = i[f >> 2], (f | 0) != (n | 0););
                                    i[A + 8 >> 2] = (k << 2) + s, i[A + 4 >> 2] = r, i[A >> 2] = e, n && X(n);
                                    return;
                                }
                                p0(), z();
                            }
                            Z2(), z();
                        }
                        function _G(A) {
                            return A = A | 0, l[108672] ? i[27167] : (l[109440] || (o[109440] = 1), z2(109152, 1508), z2(109164, 1499), z2(109176, 8995), z2(109188, 8049), z2(109200, 1642), z2(109212, 10501), z2(109224, 1516), z2(109236, 3050), z2(109248, 6349), z2(109260, 6242), z2(109272, 6340), z2(109284, 6359), z2(109296, 7588), z2(109308, 15114), z2(109320, 6465), z2(109332, 5276), z2(109344, 1642), z2(109356, 6595), z2(109368, 7993), z2(109380, 9056), z2(109392, 6537), z2(109404, 3735), z2(109416, 2800), z2(109428, 14904), o[108672] = 1, i[27167] = 109152, 109152);
                        }
                        function BG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            i: {
                                if (!(f && e) || (k = i[r + 16 >> 2], !k) || (k = E0(k, 78492, 78988), !k)) break i;
                                if (r = i[r + 20 >> 2], !r) {
                                    i[e >> 2] = i[k + 4 >> 2], i[f >> 2] = i[k + 8 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                    return;
                                }
                                i[r + 4 >> 2] = i[r + 4 >> 2] + 1, i[e >> 2] = i[k + 4 >> 2], i[f >> 2] = i[k + 8 >> 2], i[A + 8 >> 2] = i[19867], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e, A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A || (p[i[i[r >> 2] + 8 >> 2]](r), g(r));
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function mG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = i[A >> 2], A = i[k + 180 >> 2], u = i[k + 184 >> 2];
                            i: {
                                if ((A | 0) == (u | 0)) break i;
                                if (r) for(;;){
                                    k = i[A >> 2], t = o[k + 15 | 0], s = (t | 0) < 0, t = s ? i[k + 8 >> 2] : t;
                                    e: {
                                        if ((t | 0) != (E2(r) | 0) || O2(s ? i[k + 4 >> 2] : k + 4 | 0, r, t)) break e;
                                        if ((f | 0) <= (n | 0)) break i;
                                        i[(n << 2) + e >> 2] = i[k >> 2], n = n + 1 | 0;
                                    }
                                    if (A = A + 8 | 0, (u | 0) == (A | 0)) break i;
                                }
                                for(r = (f | 0) > 0 ? f : 0;;){
                                    if ((r | 0) == (n | 0)) return r | 0;
                                    if (i[(n << 2) + e >> 2] = i[i[A >> 2] >> 2], n = n + 1 | 0, A = A + 8 | 0, (u | 0) == (A | 0)) break;
                                }
                            }
                            return n | 0;
                        }
                        function ZG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (X2(e) & 1) {
                                    n = r, t = n2(e), i[n + 100 >> 2] = t, n = r, t = n2(e), i[n + 104 >> 2] = t, k = n2(e);
                                    break i;
                                }
                                n = r, t = B2(e), i[n + 100 >> 2] = t, n = r, t = B2(e), i[n + 104 >> 2] = t, k = B2(e);
                            }
                            i[r + 108 >> 2] = k;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function GG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            for(k = m - 16 | 0, m = k;;){
                                i: {
                                    if ((e | 0) <= (t | 0)) break i;
                                    f = i[A + 12 >> 2], n = i[A + 16 >> 2];
                                    e: {
                                        if (f >>> 0 < n >>> 0) {
                                            i[k + 12 >> 2] = 2147483647, i[k + 8 >> 2] = n - f, i[k + 4 >> 2] = e - t, f = m - 16 | 0, m = f, m = f + 16 | 0, f = m - 16 | 0, m = f, m = f + 16 | 0, f = k + 4 | 0, n = k + 8 | 0, f = i[f >> 2] < i[n >> 2] ? f : n, n = k + 12 | 0, f = i[(i[f >> 2] < i[n >> 2] ? f : n) >> 2], f8(i[A + 12 >> 2], f, r), i[A + 12 >> 2] = i[A + 12 >> 2] + f;
                                            break e;
                                        }
                                        if (f = p[i[i[A >> 2] + 40 >> 2]](A) | 0, (f | 0) == -1) break i;
                                        o[r | 0] = f << 24 >> 24, f = 1;
                                    }
                                    r = r + f | 0, t = f + t | 0;
                                    continue;
                                }
                                break;
                            }
                            return m = k + 16 | 0, t | 0;
                        }
                        function WG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                if (!f) {
                                    if (o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 5, 2001, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), j0(A, e, r ? i[r >> 2] : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                Ue(k + 12 | 0, e, 0), n = i[k + 12 >> 2];
                                e: {
                                    if ((n | 0) != i[k + 16 >> 2]) {
                                        r = D(8), e = i[i[n >> 2] >> 2], i[r + 4 >> 2] = 0, i[r >> 2] = e, i[f >> 2] = r, Nt(A, r);
                                        break e;
                                    }
                                    if (i[f >> 2] = 0, o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 3, 0, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), j0(A, e, r ? i[r >> 2] : 0), o[e + 19 | 0] < 0 && X(i[e + 8 >> 2]), !n) break i;
                                }
                                X(n);
                            }
                            m = k + 32 | 0;
                        }
                        function XG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (k = m - 32 | 0, m = k, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, (i[r + 104 >> 2] - i[r + 100 >> 2] | 0) / 6 & 65535), f = i[r + 100 >> 2], n = i[r + 104 >> 2], (f | 0) != (n | 0)) for(; w2(e, I[f >> 1]), w2(e, I[f + 2 >> 1]), w2(e, I[f + 4 >> 1]), f = f + 6 | 0, (n | 0) != (f | 0););
                            E4(k + 12 | 0, r, e, t), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 32 | 0;
                        }
                        function d8(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0;
                            i: {
                                if (n & 64) {
                                    e = n + -64 | 0, r = e & 31, (e & 63) >>> 0 >= 32 ? (e = 0, r = k >>> r | 0) : (e = k >>> r | 0, r = ((1 << r) - 1 & k) << 32 - r | f >>> r), f = 0, k = 0;
                                    break i;
                                }
                                if (!n) break i;
                                s = f, u = 64 - n | 0, t = u & 31, (u & 63) >>> 0 >= 32 ? (u = f << t, h = 0) : (u = (1 << t) - 1 & s >>> 32 - t | k << t, h = s << t), s = r, r = n & 31, (n & 63) >>> 0 >= 32 ? (t = 0, r = e >>> r | 0) : (t = e >>> r | 0, r = ((1 << r) - 1 & e) << 32 - r | s >>> r), r = h | r, e = t | u, t = f, f = n & 31, (n & 63) >>> 0 >= 32 ? (u = 0, f = k >>> f | 0) : (u = k >>> f | 0, f = ((1 << f) - 1 & k) << 32 - f | t >>> f), k = u;
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = f, i[A + 12 >> 2] = k;
                        }
                        function pG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (k = m - 32 | 0, m = k, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, (i[r + 108 >> 2] - i[r + 104 >> 2] | 0) / 6 & 65535), f = i[r + 104 >> 2], n = i[r + 108 >> 2], (f | 0) != (n | 0)) for(; w2(e, I[f >> 1]), f2(e, l[f + 2 | 0]), w2(e, I[f + 4 >> 1]), f = f + 6 | 0, (n | 0) != (f | 0););
                            E4(k + 12 | 0, r, e, t), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 32 | 0;
                        }
                        function QG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 104 >> 2]), l2(e, i[r + 108 >> 2]), l2(e, i[r + 112 >> 2]), l2(e, i[r + 116 >> 2]), l2(e, i[r + 120 >> 2]), R4(e, r + 124 | 0), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function CG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            r = m - 32 | 0, m = r, f = i[e + 12 >> 2], k = i[e + 4 >> 2], n = i[e >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k | (n | 0) != 2 | (f | 0) != 8 || (o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, l[e + 8 | 0] || (i[r + 16 >> 2] = 8, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 10, i[r >> 2] = 11, $2(A, r + 4 | 0, r)), i[r + 16 >> 2] = 8, o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 11, i[r >> 2] = 11, $2(A, r + 4 | 0, r)), m = r + 32 | 0;
                        }
                        function VG(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0, w = 0, v = 0;
                            if (!((n | 0) <= 0 | (k | 0) <= 0)) for(w = k & 2147483644, h = k & 3, s = 0, v = k >>> 0 < 4;;){
                                if (k = Z(f, s) + e | 0, t = (Z(r, s) << 1) + A | 0, u = 0, !v) for(; Q[t >> 1] = l[k | 0] << 6, Q[t + 2 >> 1] = l[k + 1 | 0] << 6, Q[t + 4 >> 1] = l[k + 2 | 0] << 6, Q[t + 6 >> 1] = l[k + 3 | 0] << 6, k = k + 4 | 0, t = t + 8 | 0, u = u + 4 | 0, (w | 0) != (u | 0););
                                if (u = 0, h) for(; Q[t >> 1] = l[k | 0] << 6, k = k + 1 | 0, t = t + 2 | 0, u = u + 1 | 0, (h | 0) != (u | 0););
                                if (s = s + 1 | 0, (s | 0) == (n | 0)) break;
                            }
                        }
                        function Hn(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                if (k = m - 16 | 0, m = k, n = e - r >> 2, n >>> 0 <= 1073741815) {
                                    e: {
                                        if (n >>> 0 < 2) {
                                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | n & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, f = A;
                                            break e;
                                        }
                                        u = k + 8 | 0, n >>> 0 >= 2 ? (t = n + 2 & -2, f = t - 1 | 0, f = (f | 0) == 2 ? t : f) : f = 1, D6(u, f + 1 | 0), f = i[k + 8 >> 2], i[A >> 2] = f, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = n;
                                    }
                                    for(;;){
                                        if ((r | 0) != (e | 0)) {
                                            i[f >> 2] = i[r >> 2], f = f + 4 | 0, r = r + 4 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    i[k + 4 >> 2] = 0, i[f >> 2] = i[k + 4 >> 2], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                        }
                        function xn(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            i: {
                                if (k = m - 16 | 0, m = k, n = e - r | 0, n >>> 0 <= 2147483639) {
                                    e: {
                                        if (n >>> 0 < 11) {
                                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | n & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, f = A;
                                            break e;
                                        }
                                        u = k + 8 | 0, n >>> 0 >= 11 ? (t = n + 8 & -8, f = t - 1 | 0, f = (f | 0) == 11 ? t : f) : f = 10, N6(u, f + 1 | 0), f = i[k + 8 >> 2], i[A >> 2] = f, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = n;
                                    }
                                    for(;;){
                                        if ((r | 0) != (e | 0)) {
                                            o[f | 0] = l[r | 0], f = f + 1 | 0, r = r + 1 | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    o[k + 7 | 0] = 0, o[f | 0] = l[k + 7 | 0], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                        }
                        function mi(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            i: {
                                e: {
                                    if (!f) {
                                        k = i[A + 12 >> 2], f = i[A + 8 >> 2], A = k - f >> 2;
                                        break e;
                                    }
                                    if (k = i[A + 12 >> 2], f = i[A + 8 >> 2], A = k - f >> 2, (f | 0) == (k | 0)) break e;
                                    for(u = A >>> 0 <= 1 ? 1 : A;;){
                                        if (t = i[(n << 2) + f >> 2], !(i[t + 96 >> 2] != (r | 0) | i[t + 108 >> 2] <= (e | 0)) & i[t + 100 >> 2] == 2) break i;
                                        if (n = n + 1 | 0, (u | 0) == (n | 0)) break;
                                    }
                                }
                                if (n = -1, (f | 0) == (k | 0)) break i;
                                for(t = A >>> 0 <= 1 ? 1 : A, A = 0;;){
                                    if (k = i[(A << 2) + f >> 2], !(i[k + 96 >> 2] != (r | 0) | i[k + 108 >> 2] <= (e | 0) | !i[k + 100 >> 2])) return A;
                                    if (A = A + 1 | 0, (t | 0) == (A | 0)) break;
                                }
                            }
                            return n;
                        }
                        function zn(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                e: {
                                    r: {
                                        if (f = r & 255, f) {
                                            if (A & 3) for(;;){
                                                if (e = l[A | 0], !e | (e | 0) == (f | 0)) break i;
                                                if (A = A + 1 | 0, !(A & 3)) break;
                                            }
                                            if (e = i[A >> 2], ((e | 16843008 - e) & -2139062144) != -2139062144) break r;
                                            for(k = Z(f, 16843009);;){
                                                if (f = e ^ k, ((16843008 - f | f) & -2139062144) != -2139062144) break r;
                                                if (e = i[A + 4 >> 2], f = A + 4 | 0, A = f, ((16843008 - e | e) & -2139062144) != -2139062144) break;
                                            }
                                            break e;
                                        }
                                        return E2(A) + A | 0;
                                    }
                                    f = A;
                                }
                                for(;;){
                                    if (A = f, e = l[A | 0], !e) break i;
                                    if (f = A + 1 | 0, (e | 0) == (r & 255)) break;
                                }
                            }
                            return A;
                        }
                        function yG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, k = m - 32 | 0, m = k, gn(k + 8 | 0, r, e, f, 0);
                            i: {
                                if (i[k + 8 >> 2]) {
                                    r = i[k + 12 >> 2], i[A >> 2] = i[k + 8 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 24 >> 2], r = i[k + 20 >> 2], i[A + 8 >> 2] = i[k + 16 >> 2], i[A + 12 >> 2] = r, i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0;
                                    break i;
                                }
                                if (l2(e, i[r + 100 >> 2] | l[r + 97 | 0] << 24), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), m = k + 32 | 0;
                        }
                        function IG(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((r | 0) >= 2) for(w = (r | 0) / 2 | 0, v = r & 2147483646, _ = r & 1;;){
                                for(n = (Z(r, k) << 1) + A | 0, u = (Z(r - k | 0, r) << 1) + A | 0, e = 0, s = 0; f = n + (e << 1) | 0, h = I[f >> 1], t = ((e ^ -1) << 1) + u | 0, Q[f >> 1] = I[t >> 1], Q[t >> 1] = h, h = I[f + 2 >> 1], t = f, f = ((e ^ 2147483646) << 1) + u | 0, Q[t + 2 >> 1] = I[f >> 1], Q[f >> 1] = h, e = e + 2 | 0, s = s + 2 | 0, (v | 0) != (s | 0););
                                if (_ && (f = n + (e << 1) | 0, n = I[f >> 1], e = ((e ^ -1) << 1) + u | 0, Q[f >> 1] = I[e >> 1], Q[e >> 1] = n), k = k + 1 | 0, (w | 0) == (k | 0)) break;
                            }
                        }
                        function v4(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                e: {
                                    n = i[r + 20 >> 2];
                                    r: {
                                        if (!n) break r;
                                        for(t = r + 20 | 0, r = t; u = k0[n + 16 >> 2] < e >>> 0, r = u ? r : n, n = i[(u << 2) + n >> 2], !!n;);
                                        if ((r | 0) == (t | 0)) break r;
                                        if (k0[r + 16 >> 2] <= e >>> 0) break e;
                                    }
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (e = i[r + 20 >> 2], p[i[i[e >> 2] + 20 >> 2]](k + 12 | 0, e), e = !i[k + 12 >> 2] | f, o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), !e) {
                                    i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (i[A >> 2] = i[r + 20 >> 2], e = A, A = i[r + 24 >> 2], i[e + 4 >> 2] = A, !A) break i;
                                i[A + 4 >> 2] = i[A + 4 >> 2] + 1;
                            }
                            m = k + 32 | 0;
                        }
                        function FG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            k = m - 32 | 0, m = k, P7(k + 8 | 0, r);
                            i: {
                                if (i[k + 8 >> 2]) {
                                    r = i[k + 12 >> 2], i[A >> 2] = i[k + 8 >> 2], i[A + 4 >> 2] = r, i[A + 16 >> 2] = i[k + 24 >> 2], r = i[k + 20 >> 2], i[A + 8 >> 2] = i[k + 16 >> 2], i[A + 12 >> 2] = r, i[k + 24 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 20 >> 2] = 0;
                                    break i;
                                }
                                if (r = i[r + 44 >> 2], i[f >> 2] = r, i[e >> 2] = !r << 1, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            o[k + 27 | 0] < 0 && X(i[k + 16 >> 2]), m = k + 32 | 0;
                        }
                        function YG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                if (!r) break i;
                                A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                                e: {
                                    if (!A) {
                                        H3(k + 4 | 0, f);
                                        break e;
                                    }
                                    if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, H3(k + 4 | 0, f), f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f) break e;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                e: {
                                    r: {
                                        if (n = i[k + 4 >> 2], f = i[k + 8 >> 2] - n >> 2, (f | 0) <= 0) break r;
                                        for(A = 0;;){
                                            if ((A | 0) == (e | 0)) {
                                                f = e;
                                                break r;
                                            }
                                            if (t = A << 2, i[t + r >> 2] = i[n + t >> 2], A = A + 1 | 0, (f | 0) == (A | 0)) break;
                                        }
                                        break e;
                                    }
                                    if (!n) break i;
                                }
                                i[k + 8 >> 2] = n, X(n);
                            }
                            return m = k + 16 | 0, f | 0;
                        }
                        function EG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            if (!(e && r)) {
                                i[A + 8 >> 2] = 0, i[A >> 2] = 5, i[A + 4 >> 2] = 2001;
                                return;
                            }
                            r = i[r >> 2], o[r + 64 | 0] = 1, f = i[e + 12 >> 2], i[r + 72 >> 2] = i[e + 8 >> 2], i[r + 76 >> 2] = f, f = i[e + 20 >> 2], i[r + 80 >> 2] = i[e + 16 >> 2], i[r + 84 >> 2] = f, i[r + 88 >> 2] = i[e + 24 >> 2], i[r + 92 >> 2] = i[e + 28 >> 2], i[r + 96 >> 2] = i[e + 32 >> 2], f = i[e + 44 >> 2], i[r + 104 >> 2] = i[e + 40 >> 2], i[r + 108 >> 2] = f, i[r + 112 >> 2] = i[e + 48 >> 2], i[r + 116 >> 2] = i[e + 52 >> 2], i[r + 120 >> 2] = i[e + 56 >> 2], i[r + 124 >> 2] = i[e + 60 >> 2], i[A + 8 >> 2] = i[20009], r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r;
                        }
                        function Pe(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (r = zn(A, 61), (r | 0) == (A | 0)) return 0;
                            k = r - A | 0;
                            i: {
                                if (l[k + A | 0] || (f = i[26065], !f) || (e = i[f >> 2], !e)) break i;
                                for(;;){
                                    e: {
                                        n = A, t = k, r = 0;
                                        r: {
                                            if (!k) break r;
                                            if (r = l[A | 0], r) A: {
                                                for(;;){
                                                    if (u = l[e | 0], (u | 0) != (r | 0) | !u || (t = t - 1 | 0, !t)) break A;
                                                    if (e = e + 1 | 0, r = l[n + 1 | 0], n = n + 1 | 0, !r) break;
                                                }
                                                r = 0;
                                            }
                                            else r = 0;
                                            r = r - l[e | 0] | 0;
                                        }
                                        if (!r && (r = i[f >> 2] + k | 0, l[r | 0] == 61)) break e;
                                        if (e = i[f + 4 >> 2], f = f + 4 | 0, e) continue;
                                        break i;
                                    }
                                    break;
                                }
                                s = r + 1 | 0;
                            }
                            return s;
                        }
                        function P1(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0;
                            i: {
                                if (n & 64) {
                                    k = n + -64 | 0, n = r, f = k & 31, (k & 63) >>> 0 >= 32 ? (k = n << f, f = 0) : (k = (1 << f) - 1 & n >>> 32 - f | e << f, f = n << f), r = 0, e = 0;
                                    break i;
                                }
                                if (!n) break i;
                                u = f, t = n & 31, (n & 63) >>> 0 >= 32 ? (s = f << t, u = 0) : (s = (1 << t) - 1 & u >>> 32 - t | k << t, u = u << t), t = r, k = 64 - n | 0, f = k & 31, (k & 63) >>> 0 >= 32 ? (k = 0, f = e >>> f | 0) : (k = e >>> f | 0, f = ((1 << f) - 1 & e) << 32 - f | t >>> f), f = u | f, k = k | s, u = r, t = n & 31, (n & 63) >>> 0 >= 32 ? (s = r << t, r = 0) : (s = (1 << t) - 1 & u >>> 32 - t | e << t, r = u << t), e = s;
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = f, i[A + 12 >> 2] = k;
                        }
                        function Tn(A) {
                            return o[A + 316 | 0] = 0, Q[A + 314 >> 1] = 0, i[A + 60 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, B0(A + 116 | 0, 0, 164), i[A + 108 >> 2] = 0, i[A + 112 >> 2] = 0, i[A >> 2] = -1, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 64 >> 2] = 0, i[A + 68 >> 2] = 0, i[A + 72 >> 2] = 0, i[A + 320 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 280 >> 2] = 0, i[A + 284 >> 2] = 0, i[A + 288 >> 2] = 0, i[A + 292 >> 2] = 0, i[A + 296 >> 2] = 0, i[A + 300 >> 2] = 0, o[A + 312 | 0] = 2, o[A + 104 | 0] = 0, i[A + 100 >> 2] = 0, i[A + 92 >> 2] = -1, i[A + 96 >> 2] = -1, i[A + 340 >> 2] = 0, i[A + 332 >> 2] = 0, i[A + 336 >> 2] = 0, i[A + 324 >> 2] = 0, i[A + 328 >> 2] = 0, A;
                        }
                        function gG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 12 >> 2], k = i[e + 4 >> 2], e = i[e >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, (e | 0) != 1 | (k | 0) != 3 | (f | 0) != 8 || (o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, i[r + 16 >> 2] = 8, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 16 >> 2] = 8, o[r + 12 | 0] = 1, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 11, i[r >> 2] = 11, e = r + 4 | 0, $2(A, e, r), i[r + 16 >> 2] = 8, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 10, i[r >> 2] = 11, $2(A, e, r)), m = r + 32 | 0;
                        }
                        function c4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            k = m - 16 | 0, m = k, I2(+r), f = c0(1) | 0, n = c0(0) | 0, h = f, e = f & 1048575, f = f >>> 20 & 2047;
                            i: {
                                if (f | 0) {
                                    if ((f | 0) != 2047 | t) {
                                        u = (e & 15) << 28 | n >>> 4, s = e >>> 4 | 0, t = f + 15360 | 0, f = n << 28, e = 0;
                                        break i;
                                    }
                                    u = (e & 15) << 28 | n >>> 4, s = e >>> 4 | 0, t = 32767, f = n << 28, e = 0;
                                    break i;
                                }
                                if (!(e | n)) {
                                    f = 0, e = 0;
                                    break i;
                                }
                                f = e, e = e ? e1(e) : e1(n) + 32 | 0, P1(k, n, f, 0, 0, e + 49 | 0), t = 15372 - e | 0, u = i[k + 8 >> 2], s = i[k + 12 >> 2] ^ 65536, f = i[k + 4 >> 2], e = i[k >> 2];
                            }
                            i[A >> 2] = e, i[A + 4 >> 2] = f, i[A + 8 >> 2] = u, i[A + 12 >> 2] = s | (h & -2147483648 | t << 16), m = k + 16 | 0;
                        }
                        function b3(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                if (e = i[r >> 2], !e) break i;
                                if (k = E0(e, 78236, 78648), k) {
                                    f = i[r + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), i[A + 200 >> 2] = k, e = i[A + 204 >> 2], i[A + 204 >> 2] = f;
                                    e: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break e;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    if (e = i[r >> 2], !e) break i;
                                }
                                if (f = E0(e, 78236, 78688), !f || (e = i[r + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), i[A + 192 >> 2] = f, r = i[A + 196 >> 2], i[A + 196 >> 2] = e, !r) || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                        }
                        function R8(A) {
                            var r = 0, e = 0, f = 0;
                            if (!A) {
                                if (A = i[21622], A && (r = R8(A)), A = i[21584], A && (r = R8(A) | r), A = i[26067], A) for(; i[A + 20 >> 2] != i[A + 28 >> 2] && (r = R8(A) | r), A = i[A + 56 >> 2], !!A;);
                                return r;
                            }
                            f = i[A + 76 >> 2] < 0;
                            i: {
                                e: {
                                    if (i[A + 20 >> 2] == i[A + 28 >> 2] || (p[i[A + 36 >> 2]](A, 0, 0) | 0, i[A + 20 >> 2])) break e;
                                    r = -1;
                                    break i;
                                }
                                if (r = i[A + 8 >> 2], e = i[A + 4 >> 2], (r | 0) != (e | 0) && (r = e - r | 0, p[i[A + 40 >> 2]](A, r, r >> 31, 1)), r = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, f) break i;
                            }
                            return r;
                        }
                        function c8(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = i[A + 40 >> 2], n = i[A + 36 >> 2];
                            i: {
                                if ((e | 0) != (n | 0)) for(;;){
                                    k = i[(f << 3) + n >> 2];
                                    e: {
                                        if (!k || (t = i[r >> 2], !t | i[k + 36 >> 2] != i[k + 40 >> 2] | i[t + 36 >> 2] != i[t + 40 >> 2])) break e;
                                        if (p[i[i[k >> 2] + 24 >> 2]](k, t) | 0) break i;
                                        n = i[A + 36 >> 2], e = i[A + 40 >> 2];
                                    }
                                    if (f = f + 1 | 0, !(f >>> 0 < e - n >> 3 >>> 0)) break;
                                }
                                e: {
                                    if (k0[A + 44 >> 2] > e >>> 0) {
                                        i[e >> 2] = i[r >> 2], r = i[r + 4 >> 2], i[e + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = e + 8 | 0;
                                        break e;
                                    }
                                    r = P2(A + 36 | 0, r);
                                }
                                i[A + 40 >> 2] = r, f = (r - i[A + 36 >> 2] >> 3) - 1 | 0;
                            }
                            return f;
                        }
                        function Sn(A) {
                            var r = 0, e = 0;
                            r = D(128), e = r + 32 | 0, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[r + 24 >> 2] = 0, i[r + 28 >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 0, i[r + 72 >> 2] = -1, i[r + 76 >> 2] = -1, i[r + 116 >> 2] = 0, i[r + 88 >> 2] = 0, i[r + 92 >> 2] = 0, i[r + 120 >> 2] = 0, i[r + 124 >> 2] = 0, i[r >> 2] = 76576, i[r + 40 >> 2] = 0, i[r + 44 >> 2] = 0, i[r + 48 >> 2] = 0, i[r + 52 >> 2] = 0, i[r + 56 >> 2] = 0, i[r + 60 >> 2] = 0, i[r - -64 >> 2] = 0, i[r + 80 >> 2] = -1, i[r + 84 >> 2] = -1, i[r + 96 >> 2] = 0, i[r + 100 >> 2] = 0, i[r + 104 >> 2] = 0, i[r + 108 >> 2] = 0, Q[r + 112 >> 1] = 0, i[r + 16 >> 2] = 74528, i[r + 32 >> 2] = 1769173093, i[A + 4 >> 2] = r, i[A >> 2] = r + 16;
                        }
                        function JG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            k = m - 32 | 0, m = k, i[k + 16 >> 2] = r, f = i[A + 48 >> 2], i[k + 20 >> 2] = e - ((f | 0) != 0), t = i[A + 44 >> 2], i[k + 28 >> 2] = f, i[k + 24 >> 2] = t;
                            i: {
                                e: {
                                    if (f = h7(i[A + 60 >> 2], k + 16 | 0, 2, k + 12 | 0) | 0, f ? (i[26064] = f, f = -1) : f = 0, f) r = 32;
                                    else {
                                        if (f = i[k + 12 >> 2], (f | 0) > 0) break e;
                                        r = f ? 32 : 16;
                                    }
                                    i[A >> 2] = r | i[A >> 2];
                                    break i;
                                }
                                if (n = f, t = i[k + 20 >> 2], t >>> 0 >= f >>> 0) break i;
                                n = i[A + 44 >> 2], i[A + 4 >> 2] = n, i[A + 8 >> 2] = n + (f - t | 0), i[A + 48 >> 2] && (i[A + 4 >> 2] = n + 1, o[(r + e | 0) - 1 | 0] = l[n | 0]), n = e;
                            }
                            return m = k + 32 | 0, n | 0;
                        }
                        function RG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!(e && r)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 5, i[A + 4 >> 2] = 2001;
                                    break i;
                                }
                                if (k = i[r >> 2], !l[k + 224 | 0]) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, e = i0(f + 12 | 0, 5, 138, f), o[f + 11 | 0] < 0 && X(i[f >> 2]), k = A, A = i[r >> 2], j0(k, e, A ? A + 4 | 0 : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                n0[e >> 3] = n0[k + 232 >> 3], n0[e + 8 >> 3] = n0[k + 240 >> 3], n0[e + 16 >> 3] = n0[k + 248 >> 3], n0[e + 24 >> 3] = n0[k + 256 >> 3], n0[e + 32 >> 3] = n0[k + 264 >> 3], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                            }
                            m = f + 32 | 0;
                        }
                        function NG(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            if (o[A + 121 | 0] = 0, o[A + 122 | 0] = 0, o[A + 123 | 0] = 0, o[A + 124 | 0] = 0, r = l[A + 120 | 0], e = r >>> 0 <= 2 ? 2 : r, n = r, t = i[A + 108 >> 2], r = i[A + 104 >> 2], e = t - r >>> 0 > 2097120 ? e : n, (r | 0) == (t | 0)) f = 4;
                            else {
                                for(; e = k0[r >> 2] > 65535 && (e | 0) <= 2 ? 2 : e, e = l[r + 4 | 0] && (e | 0) <= 1 ? 1 : e, u = i[r + 16 >> 2], f = f + i[u + 20 >> 2] | 0, n = k, k = k + i[u + 16 >> 2] | 0, f = n >>> 0 > k >>> 0 ? f + 1 | 0 : f, r = r + 32 | 0, (t | 0) != (r | 0););
                                f = (f - (k >>> 0 < 4026531840) | 0) != -1 ? 8 : 4;
                            }
                            o[A + 121 | 0] = 4, o[A + 122 | 0] = 4, o[A + 123 | 0] = f, o[A + 97 | 0] = e;
                        }
                        function DG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), k = l[r + 97 | 0];
                            i: {
                                if (k >>> 0 >= 2) {
                                    s4(A, r, 7597);
                                    break i;
                                }
                                e: {
                                    if (!k) {
                                        k = B2(e);
                                        break e;
                                    }
                                    k = n2(e);
                                }
                                if (i[r + 104 >> 2] = k, l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function d3(A, r, e) {
                            var f = 0, k = 0;
                            f = (e | 0) != 0;
                            i: {
                                e: {
                                    r: {
                                        if (!(A & 3) | !e) break r;
                                        for(k = r & 255;;){
                                            if ((k | 0) == l[A | 0]) break e;
                                            if (e = e - 1 | 0, f = (e | 0) != 0, A = A + 1 | 0, !(A & 3)) break r;
                                            if (!e) break;
                                        }
                                    }
                                    if (!f) break i;
                                    if (f = r & 255, !((f | 0) == l[A | 0] | e >>> 0 < 4)) for(f = Z(f, 16843009);;){
                                        if (k = f ^ i[A >> 2], ((16843008 - k | k) & -2139062144) != -2139062144) break e;
                                        if (A = A + 4 | 0, e = e - 4 | 0, !(e >>> 0 > 3)) break;
                                    }
                                    if (!e) break i;
                                }
                                for(r = r & 255;;){
                                    if ((r | 0) == l[A | 0]) return A;
                                    if (A = A + 1 | 0, e = e - 1 | 0, !e) break;
                                }
                            }
                            return 0;
                        }
                        function MG(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            r = m - 128 | 0, m = r, e = r + 96 | 0, Xe(e, A), A = -1;
                            i: {
                                if (i[r + 108 >> 2]) break i;
                                Q[r + 20 >> 1] = 0, B0(r + 24 | 0, 0, 72), X7(r, r + 20 | 0, e), A = -1;
                                e: {
                                    if (i[r >> 2] || (e = i[r + 56 >> 2], A = -1, i[r + 60 >> 2] - e >>> 0 < 5)) break e;
                                    A = l[e + 6 | 0];
                                }
                                if (o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), e = i[r + 80 >> 2], e && (i[r + 84 >> 2] = e, X(e)), e = i[r + 68 >> 2], e && (i[r + 72 >> 2] = e, X(e)), e = i[r + 56 >> 2], !e) break i;
                                i[r + 60 >> 2] = e, X(e);
                            }
                            return o[r + 127 | 0] < 0 && X(i[r + 116 >> 2]), e = i[r + 96 >> 2], e && (i[r + 100 >> 2] = e, X(e)), m = r + 128 | 0, A | 0;
                        }
                        function jn(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            if (i[A >> 2] = 73452, l[A + 132 | 0] == 1 && (r = Ks(-100, A + 140 | 0, 0) | 0, r >>> 0 >= 4294963201 && (i[26064] = 0 - r)), k = i[A + 104 >> 2], k) {
                                if (r = k, f = i[A + 108 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        if (t = f - 16 | 0, n = i[t >> 2], n) {
                                            if (u = f - 12 | 0, r = i[u >> 2], e = n, (r | 0) != (e | 0)) {
                                                for(; e = i[r - 16 >> 2], e && (i[r - 12 >> 2] = e, X(e)), r = r - 40 | 0, (n | 0) != (r | 0););
                                                e = i[t >> 2];
                                            }
                                            i[u >> 2] = n, X(e);
                                        }
                                        if (f = f - 32 | 0, (k | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 104 >> 2];
                                }
                                i[A + 108 >> 2] = k, X(r);
                            }
                            return V2(A) | 0;
                        }
                        function UG(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if (!(n & 1)) {
                                if (!((t | 0) <= 0 | (n | 0) <= 0)) for(;;){
                                    for(w = Z(r, h) + A | 0, s = Z(k, h) << 1, v = s + f | 0, s = e + s | 0, _ = 0; u = (Q[s >> 1] + Q[v >> 1] | 0) - -64 >> 7, u = (u | 0) >= 255 ? 255 : u, o[w | 0] = (u | 0) > 0 ? u : 0, u = (Q[s + 2 >> 1] + Q[v + 2 >> 1] | 0) - -64 >> 7, u = (u | 0) >= 255 ? 255 : u, o[w + 1 | 0] = (u | 0) > 0 ? u : 0, v = v + 4 | 0, s = s + 4 | 0, w = w + 2 | 0, _ = _ + 2 | 0, (_ | 0) < (n | 0););
                                    if (h = h + 1 | 0, (h | 0) == (t | 0)) break;
                                }
                                return;
                            }
                            y0(18295, 14969, 105, 8405), z();
                        }
                        function HG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 10496);
                                    break i;
                                }
                                if (k = r, n = n2(e), i[k + 104 >> 2] = n, k = r, n = n2(e), i[k + 108 >> 2] = n, l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function xG(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            r = m - 128 | 0, m = r, e = r + 96 | 0, Xe(e, A), A = -1;
                            i: {
                                if (i[r + 108 >> 2]) break i;
                                Q[r + 20 >> 1] = 0, B0(r + 24 | 0, 0, 72), X7(r, r + 20 | 0, e), A = -1;
                                e: {
                                    if (i[r >> 2] || (e = i[r + 56 >> 2], A = -1, (e | 0) == i[r + 60 >> 2])) break e;
                                    A = l[e + 2 | 0];
                                }
                                if (o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), e = i[r + 80 >> 2], e && (i[r + 84 >> 2] = e, X(e)), e = i[r + 68 >> 2], e && (i[r + 72 >> 2] = e, X(e)), e = i[r + 56 >> 2], !e) break i;
                                i[r + 60 >> 2] = e, X(e);
                            }
                            return o[r + 127 | 0] < 0 && X(i[r + 116 >> 2]), e = i[r + 96 >> 2], e && (i[r + 100 >> 2] = e, X(e)), m = r + 128 | 0, A | 0;
                        }
                        function zG(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0;
                            u = m - 32 | 0, m = u;
                            i: {
                                e: {
                                    if (n && (E2(n) | 0) == 4) break e;
                                    i[A >> 2] = 5, i[A + 4 >> 2] = 2006, i[A + 8 >> 2] = 20056;
                                    break i;
                                }
                                s = u + 12 | 0, h = e, e = l[n | 0] | l[n + 1 | 0] << 8 | (l[n + 2 | 0] << 16 | l[n + 3 | 0] << 24), li(s, i[r >> 2], h, f, k, e << 24 | (e & 65280) << 8 | (e >>> 8 & 65280 | e >>> 24), t, 0, 0);
                                e: {
                                    if (i[u + 12 >> 2] != i[21668]) {
                                        j0(A, s, i[r >> 2]);
                                        break e;
                                    }
                                    r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                }
                                if (o[u + 31 | 0] >= 0) break i;
                                X(i[u + 20 >> 2]);
                            }
                            m = u + 32 | 0;
                        }
                        function On(A, r) {
                            var e = 0;
                            e = D(128), i[e + 4 >> 2] = 0, i[e + 8 >> 2] = 0, i[e >> 2] = 78096, r = i[r >> 2], i[e + 32 >> 2] = 0, i[e + 36 >> 2] = 0, i[e - -64 >> 2] = 0, i[e + 56 >> 2] = 0, i[e + 60 >> 2] = 0, i[e + 48 >> 2] = 0, i[e + 52 >> 2] = 0, i[e + 40 >> 2] = 0, i[e + 44 >> 2] = 0, i[e + 24 >> 2] = 0, i[e + 28 >> 2] = 0, i[e + 72 >> 2] = -1, i[e + 76 >> 2] = -1, i[e + 80 >> 2] = -1, i[e + 84 >> 2] = -1, i[e + 88 >> 2] = 0, i[e + 92 >> 2] = 0, i[e + 96 >> 2] = 0, i[e + 100 >> 2] = 0, i[e + 104 >> 2] = 0, i[e + 108 >> 2] = 0, o[e + 112 | 0] = 0, i[e + 124 >> 2] = 0, i[e + 116 >> 2] = 0, i[e + 120 >> 2] = 0, i[e + 16 >> 2] = 73736, i[e + 32 >> 2] = r, i[A + 4 >> 2] = e, i[A >> 2] = e + 16;
                        }
                        function TG(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                e: {
                                    if (i[r + 64 >> 2] && !(p[i[i[r >> 2] + 24 >> 2]](r) | 0)) break e;
                                    i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                if (vr(i[r + 64 >> 2], i[e + 8 >> 2], i[e + 12 >> 2], 0)) {
                                    i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                k = i[e + 4 >> 2], i[f + 8 >> 2] = i[e >> 2], i[f + 12 >> 2] = k, k = i[f + 12 >> 2], i[r + 72 >> 2] = i[f + 8 >> 2], i[r + 76 >> 2] = k, r = i[e + 12 >> 2], i[A + 8 >> 2] = i[e + 8 >> 2], i[A + 12 >> 2] = r, r = i[e + 4 >> 2], i[A >> 2] = i[e >> 2], i[A + 4 >> 2] = r;
                            }
                            m = f + 16 | 0;
                        }
                        function Pn(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        if ((A | 0) != (r | 0)) A: {
                                            f: {
                                                if (n = l[A | 0], (n | 0) != 45 || (A = A + 1 | 0, (r | 0) != (A | 0))) break f;
                                                break A;
                                            }
                                            u = i[26064], i[26064] = 0, L2(), A = hi(A, k + 12 | 0, f, -1, -1), f = w0, t = i[26064];
                                            f: {
                                                if (t) {
                                                    if (i[k + 12 >> 2] != (r | 0)) break f;
                                                    if ((t | 0) == 68) break r;
                                                    break e;
                                                }
                                                if (i[26064] = u, i[k + 12 >> 2] == (r | 0)) break e;
                                            }
                                        }
                                        i[e >> 2] = 4, A = 0, r = 0;
                                        break i;
                                    }
                                    i[e >> 2] = 4, A = -1, r = -1;
                                    break i;
                                }
                                r = A, e = (n | 0) == 45, A = e ? 0 - r | 0 : r, r = e ? 0 - (f + ((r | 0) != 0) | 0) | 0 : f;
                            }
                            return m = k + 16 | 0, w0 = r, A;
                        }
                        function SG(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            if (r = o[A + 11 | 0], e = (r | 0) < 0, r = e ? i[A + 4 >> 2] : r, (r | 0) < 8) return 3;
                            i: {
                                A = e ? i[A >> 2] : A;
                                e: {
                                    if (l[A + 4 | 0] != 102 | l[A + 5 | 0] != 116 | (l[A + 6 | 0] != 121 | l[A + 7 | 0] != 112)) break e;
                                    if (r >>> 0 < 12) return 3;
                                    f = 1, A = yA(A, r);
                                    r: {
                                        if ((A | 0) <= 1781689192) {
                                            if ((A | 0) == 1635150182 | (A | 0) == 1751476579) break e;
                                            if ((A | 0) != 1751476600) break r;
                                            break e;
                                        }
                                        A: switch(A - 1835623985 | 0){
                                            case 0:
                                            case 1:
                                                break i;
                                            default:
                                                break A;
                                        }
                                        if ((A | 0) == 1781689193 | (A | 0) == 1785750887) break e;
                                    }
                                    f = 2;
                                }
                                return f | 0;
                            }
                            return 3;
                        }
                        function jG(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if (!(k & 1)) {
                                if (!((n | 0) <= 0 | (k | 0) <= 0)) for(_ = (t | 0) < 14 ? 1 << 13 - t : 0, B = 14 - t | 0, s = -1 << t ^ -1;;){
                                    for(t = (Z(r, h) << 1) + A | 0, w = (Z(f, h) << 1) + e | 0, v = 0; u = Q[w >> 1] + _ >> B, Q[t >> 1] = (u | 0) >= 0 ? (u | 0) < (s | 0) ? u : s : 0, u = Q[w + 2 >> 1] + _ >> B, Q[t + 2 >> 1] = (u | 0) >= 0 ? (u | 0) < (s | 0) ? u : s : 0, w = w + 4 | 0, t = t + 4 | 0, v = v + 2 | 0, (v | 0) < (k | 0););
                                    if (h = h + 1 | 0, (h | 0) == (n | 0)) break;
                                }
                                return;
                            }
                            y0(18295, 14969, 172, 8622), z();
                        }
                        function Zi(A, r, e) {
                            var f = 0, k = 0;
                            f = i[A + 28 >> 2];
                            i: {
                                if (f >>> 0 < k0[A + 32 >> 2]) {
                                    i[f >> 2] = i[r >> 2], k = i[r + 4 >> 2], i[f + 4 >> 2] = k, k && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), f = f + 8 | 0;
                                    break i;
                                }
                                f = P2(A + 24 | 0, r);
                            }
                            i[A + 28 >> 2] = f, f = i[A + 20 >> 2], k = i[f + 48 >> 2], f = i[f + 52 >> 2];
                            i: {
                                if (!f) {
                                    rr(k, i[A + 36 >> 2], r, e);
                                    break i;
                                }
                                if (i[f + 4 >> 2] = i[f + 4 >> 2] + 1, rr(k, i[A + 36 >> 2], r, e), A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            A = i[r + 4 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function Ln(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        if ((A | 0) != (r | 0)) {
                                            t = i[26064], i[26064] = 0, L2(), f = hi(A, k + 12 | 0, f, 0, -2147483648), A = w0, n = i[26064];
                                            A: {
                                                if (n) {
                                                    if (i[k + 12 >> 2] != (r | 0)) break A;
                                                    if ((n | 0) == 68) break e;
                                                    break r;
                                                }
                                                if (i[26064] = t, i[k + 12 >> 2] == (r | 0)) break r;
                                            }
                                        }
                                        i[e >> 2] = 4, r = 0;
                                        break i;
                                    }
                                    if ((A | 0) < 0 & f >>> 0 < 2147483648 | (A | 0) < -1 | (f >>> 0 > 2147483647 & (A | 0) >= 0 | (A | 0) > 0)) break e;
                                    r = f;
                                    break i;
                                }
                                if (i[e >> 2] = 4, r = 2147483647, !!f & (A | 0) >= 0 | (A | 0) > 0) break i;
                                r = -2147483648;
                            }
                            return m = k + 16 | 0, r;
                        }
                        function Le(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = m - 48 | 0, m = e, f = i[A >> 2], A = i[r + 4 >> 2], r = i[r >> 2], o[e + 12 | 0] = 0, o[e + 23 | 0] = 0, A = i0(e + 24 | 0, r, A, e + 12 | 0), r = i[f + 116 >> 2];
                            i: {
                                if (r >>> 0 < k0[f + 120 >> 2]) {
                                    k = i[A + 4 >> 2], i[r >> 2] = i[A >> 2], i[r + 4 >> 2] = k, i[r + 16 >> 2] = i[A + 16 >> 2], k = i[A + 12 >> 2], i[r + 8 >> 2] = i[A + 8 >> 2], i[r + 12 >> 2] = k, i[A + 16 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[f + 116 >> 2] = r + 20;
                                    break i;
                                }
                                if (r = D3(f + 112 | 0, A), k = o[A + 19 | 0], i[f + 116 >> 2] = r, (k | 0) >= 0) break i;
                                X(i[A + 8 >> 2]);
                            }
                            o[e + 23 | 0] < 0 && X(i[e + 12 >> 2]), m = e + 48 | 0;
                        }
                        function X6(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            n = m - 16 | 0, m = n, f = uo(r), k = m - 16 | 0, m = k;
                            i: {
                                if (f >>> 0 <= 1073741815) {
                                    e: {
                                        if (f >>> 0 < 2) {
                                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | f & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, e = A;
                                            break e;
                                        }
                                        u = k + 8 | 0, f >>> 0 >= 2 ? (t = f + 2 & -2, e = t - 1 | 0, e = (e | 0) == 2 ? t : e) : e = 1, D6(u, e + 1 | 0), e = i[k + 8 >> 2], i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = f;
                                    }
                                    Yr(e, r, f), i[k + 4 >> 2] = 0, i[(f << 2) + e >> 2] = i[k + 4 >> 2], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            m = n + 16 | 0;
                        }
                        function Kn(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if ((A | 0) != (r | 0)) f: {
                                                k: {
                                                    if (n = l[A | 0], (n | 0) != 45 || (A = A + 1 | 0, (r | 0) != (A | 0))) break k;
                                                    break f;
                                                }
                                                u = i[26064], i[26064] = 0, L2(), A = hi(A, k + 12 | 0, f, -1, -1), f = w0, t = i[26064];
                                                k: {
                                                    if (t) {
                                                        if (i[k + 12 >> 2] != (r | 0)) break k;
                                                        if ((t | 0) == 68) break r;
                                                        break A;
                                                    }
                                                    if (i[26064] = u, i[k + 12 >> 2] == (r | 0)) break A;
                                                }
                                            }
                                            i[e >> 2] = 4, A = 0;
                                            break i;
                                        }
                                        if (!f & A >>> 0 <= 65535) break e;
                                    }
                                    i[e >> 2] = 4, A = 65535;
                                    break i;
                                }
                                A = (n | 0) == 45 ? 0 - A | 0 : A;
                            }
                            return m = k + 16 | 0, A & 65535;
                        }
                        function OG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, n = i[r + 104 >> 2];
                            i: {
                                if (!l[r + 97 | 0]) {
                                    w2(e, n & 65535);
                                    break i;
                                }
                                l2(e, n);
                            }
                            i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function Gi(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            n = m - 16 | 0, m = n, f = E2(r), k = m - 16 | 0, m = k;
                            i: {
                                if (f >>> 0 <= 2147483639) {
                                    e: {
                                        if (f >>> 0 < 11) {
                                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | f & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, e = A;
                                            break e;
                                        }
                                        u = k + 8 | 0, f >>> 0 >= 11 ? (t = f + 8 & -8, e = t - 1 | 0, e = (e | 0) == 11 ? t : e) : e = 10, N6(u, e + 1 | 0), e = i[k + 8 >> 2], i[A >> 2] = e, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = f;
                                    }
                                    Zf(e, r, f), o[k + 7 | 0] = 0, o[f + e | 0] = l[k + 7 | 0], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            m = n + 16 | 0;
                        }
                        function qn(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            n = m - 16 | 0, m = n, k = m - 16 | 0, m = k;
                            i: {
                                if (r >>> 0 <= 2147483639) {
                                    e: {
                                        if (r >>> 0 < 11) {
                                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | r & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, f = A;
                                            break e;
                                        }
                                        u = k + 8 | 0, r >>> 0 >= 11 ? (t = r + 8 & -8, f = t - 1 | 0, f = (f | 0) == 11 ? t : f) : f = 10, N6(u, f + 1 | 0), f = i[k + 8 >> 2], i[A >> 2] = f, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = r;
                                    }
                                    Dt(f, r, e), o[k + 7 | 0] = 0, o[r + f | 0] = l[k + 7 | 0], m = k + 16 | 0;
                                    break i;
                                }
                                u4(), z();
                            }
                            return m = n + 16 | 0, A;
                        }
                        function PG(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            i: {
                                if (t = i[r + 16 >> 2], !t || (t = E0(t, 78492, 79032), !t)) break i;
                                r = i[r + 20 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e >> 2] = i[t + 4 >> 2], i[f >> 2] = i[t + 8 >> 2], i[k >> 2] = i[t + 12 >> 2], i[n >> 2] = i[t + 16 >> 2], i[A + 8 >> 2] = i[19867], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e;
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function LG(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            i: {
                                if (t = i[r + 16 >> 2], !t || (t = E0(t, 78492, 79076), !t)) break i;
                                r = i[r + 20 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[e >> 2] = i[t + 4 >> 2], i[f >> 2] = i[t + 8 >> 2], i[k >> 2] = i[t + 12 >> 2], i[n >> 2] = i[t + 16 >> 2], i[A + 8 >> 2] = i[19867], e = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = e;
                                e: {
                                    if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break e;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                return;
                            }
                            r = i[20014], i[A >> 2] = i[20013], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20015];
                        }
                        function c3(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A + 20 >> 2] = 0, e = i[A + 8 >> 2], r = i[A + 4 >> 2], f = e - r >> 2, f >>> 0 >= 3) for(; X(i[r >> 2]), r = i[A + 4 >> 2] + 4 | 0, i[A + 4 >> 2] = r, e = i[A + 8 >> 2], f = e - r >> 2, f >>> 0 > 2;);
                            k = 512;
                            i: switch(f - 1 | 0){
                                case 1:
                                    k = 1024;
                                case 0:
                                    i[A + 16 >> 2] = k;
                                    break;
                                default:
                                    break i;
                            }
                            i: {
                                if ((r | 0) == (e | 0)) break i;
                                for(; X(i[r >> 2]), r = r + 4 | 0, (e | 0) != (r | 0););
                                if (r = i[A + 8 >> 2], e = i[A + 4 >> 2], (r | 0) == (e | 0)) break i;
                                i[A + 8 >> 2] = r + ((e - r | 0) + 3 & -4);
                            }
                            A = i[A >> 2], A && X(A);
                        }
                        function KG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (k = m - 32 | 0, m = k, t = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f = i[r + 100 >> 2], n = i[r + 104 >> 2], (f | 0) != (n | 0)) for(; w2(e, I[f >> 1]), f2(e, l[f + 2 | 0]), f2(e, l[f + 3 | 0]), f = f + 4 | 0, (n | 0) != (f | 0););
                            E4(k + 12 | 0, r, e, t), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 32 | 0;
                        }
                        function qG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((e | 0) > 0) for(h = 1 << k - 1, v = e & 2147483646, _ = e & 1;;){
                                if (n = 0, t = 0, w = 0, (e | 0) != 1) for(; s = Z(e, n) + u | 0, t = ((Q[(s << 1) + r >> 1] << f) + h >> k) + t | 0, i[(s << 2) + A >> 2] = t, s = Z(n | 1, e) + u | 0, t = t + ((Q[(s << 1) + r >> 1] << f) + h >> k) | 0, i[(s << 2) + A >> 2] = t, n = n + 2 | 0, w = w + 2 | 0, (v | 0) != (w | 0););
                                if (_ && (n = Z(e, n) + u | 0, i[(n << 2) + A >> 2] = ((Q[(n << 1) + r >> 1] << f) + h >> k) + t), u = u + 1 | 0, (u | 0) == (e | 0)) break;
                            }
                        }
                        function $n(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            return f = m - 16 | 0, m = f, A = z0(A), i[A + 40 >> 2] = 0, i[A + 32 >> 2] = 0, i[A + 36 >> 2] = 0, i[A >> 2] = 58928, B0(A + 52 | 0, 0, 47), e = f + 12 | 0, r = i[A + 4 >> 2], i[e >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = so(i[e >> 2], n1(108588)), d0(e), r && (e = f + 8 | 0, r = i[A + 4 >> 2], i[e >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), k = A, n = K0(e, 108588), i[k + 68 >> 2] = n, d0(e), r = i[A + 68 >> 2], k = A, n = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[k + 98 | 0] = n), p[i[i[A >> 2] + 12 >> 2]](A, 0, 4096), m = f + 16 | 0, A;
                        }
                        function $G(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0, s = 0, h = 0;
                            s = m - 32 | 0, m = s, u = i[r >> 2], h = i[u + 48 >> 2], u = i[u + 52 >> 2];
                            i: {
                                if (!u) {
                                    q5(s + 8 | 0, h, e, f, k, n);
                                    break i;
                                }
                                if (i[u + 4 >> 2] = i[u + 4 >> 2] + 1, q5(s + 8 | 0, h, e, f, k, n), e = i[u + 4 >> 2], i[u + 4 >> 2] = e - 1, e) break i;
                                p[i[i[u >> 2] + 8 >> 2]](u), g(u);
                            }
                            i: {
                                if (!(i[s + 12 >> 2] | !t)) {
                                    i[t >> 2] = i[s + 8 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                    break i;
                                }
                                j0(A, s + 12 | 0, i[r >> 2]);
                            }
                            o[s + 31 | 0] < 0 && X(i[s + 20 >> 2]), m = s + 32 | 0;
                        }
                        function aG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            i: {
                                if (f = i[A >> 2], A = i[f + 24 >> 2], k = i[f + 28 >> 2], (A | 0) != (k | 0)) for(;;){
                                    e: {
                                        if (f = i[A >> 2], !f || (f = E0(f, 73632, 75720), !f)) break e;
                                        if (A = i[A + 4 >> 2], A) break i;
                                        return i[r >> 2] = i[f + 100 >> 2], i[e >> 2] = i[f + 104 >> 2], 1;
                                    }
                                    if (A = A + 8 | 0, (k | 0) == (A | 0)) break;
                                }
                                return i[r >> 2] = 1, i[e >> 2] = 1, 0;
                            }
                            return i[A + 4 >> 2] = i[A + 4 >> 2] + 1, i[r >> 2] = i[f + 100 >> 2], i[e >> 2] = i[f + 104 >> 2], r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), 1;
                        }
                        function bG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(!(i[e >> 2] != 1 | (i[e + 4 >> 2] & -2) != 10) & i[e + 12 >> 2] == 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[f + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function dG(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r;
                            i: {
                                if (!(!(i[e >> 2] != 1 | (i[e + 4 >> 2] & -2) != 12) & i[e + 12 >> 2] > 8)) {
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                    break i;
                                }
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 1, i[r + 8 >> 2] = 3, o[r + 12 | 0] = l[f + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 11, $2(A, r + 4 | 0, r);
                            }
                            m = r + 32 | 0;
                        }
                        function cG(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, R4(e, r + 104 | 0), R4(e, r + 116 | 0), R4(e, r + 128 | 0), R4(e, r + 140 | 0), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function iW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0, B = 0;
                            if ((e | 0) > 0) for(s = 1 << k - 1, _ = e & 2147483646, B = e & 1;;){
                                if (v = Z(e, h), u = 0, t = 0, w = 0, (e | 0) != 1) for(; n = u + v | 0, t = ((Q[(n << 1) + r >> 1] << f) + s >> k) + t | 0, i[(n << 2) + A >> 2] = t, n = n + 1 | 0, t = t + ((Q[(n << 1) + r >> 1] << f) + s >> k) | 0, i[(n << 2) + A >> 2] = t, u = u + 2 | 0, w = w + 2 | 0, (_ | 0) != (w | 0););
                                if (B && (n = u + v | 0, i[(n << 2) + A >> 2] = ((Q[(n << 1) + r >> 1] << f) + s >> k) + t), h = h + 1 | 0, (h | 0) == (e | 0)) break;
                            }
                        }
                        function eW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            e = m - 16 | 0, m = e, ae(e + 4 | 0, i[A >> 2]), f = i[e + 4 >> 2], k = i[e + 8 >> 2], n = (f | 0) == (k | 0);
                            i: {
                                if (n) break i;
                                for(A = f;;){
                                    if (t = i[i[A >> 2] + 36 >> 2] == (r | 0), t) break i;
                                    if (A = A + 8 | 0, (k | 0) == (A | 0)) break;
                                }
                            }
                            if (f) {
                                if (A = f, !n) {
                                    for(;;){
                                        A = i[k - 4 >> 2];
                                        i: {
                                            if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                            p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                        }
                                        if (k = k - 8 | 0, (k | 0) == (f | 0)) break;
                                    }
                                    A = i[e + 4 >> 2];
                                }
                                i[e + 8 >> 2] = f, X(A);
                            }
                            return m = e + 16 | 0, t | 0;
                        }
                        function an(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0;
                            u = -1, t = f & 2147483647, n = (t | 0) == 2147418112;
                            i: {
                                if ((n & !e ? A | r : n & (e | 0) != 0 | t >>> 0 > 2147418112) || (n = k & 2147483647, ((n | 0) == 2147418112 & 0 | n >>> 0 > 2147418112) & (n | 0) != 2147418112)) break i;
                                if (!(A | e | (n | t | r))) return 0;
                                if (n = f & k, (n | 0) > 0 ? n = 1 : n = (n | 0) >= 0, n) {
                                    if (((e | 0) != 0 | (f | 0) != (k | 0)) & (f | 0) < (k | 0)) break i;
                                    return (A | e | (f ^ k | r)) != 0;
                                }
                                if (!e & (f | 0) == (k | 0) ? A | r : (e | 0) != 0 & (f | 0) >= (k | 0) | (f | 0) > (k | 0)) break i;
                                u = (A | e | (f ^ k | r)) != 0;
                            }
                            return u;
                        }
                        function rW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 100 >> 2]), w2(e, I[r + 104 >> 1]), w2(e, I[r + 106 >> 1]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function bn(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            return i[A + 8 >> 2] = 59808, i[A + 64 >> 2] = 59828, r = i[14961], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[14962], i[A + 4 >> 2] = 0, r = i[i[A >> 2] - 12 >> 2] + A | 0, e = A + 12 | 0, T0(r, e), i[r + 72 >> 2] = 0, i[r + 76 >> 2] = -1, r = i[14963], i[A + 8 >> 2] = r, i[i[r - 12 >> 2] + (A + 8 | 0) >> 2] = i[14964], r = i[14960], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[14965], i[A + 64 >> 2] = 59828, i[A >> 2] = 59788, i[A + 8 >> 2] = 59808, f = z0(e), k = 58864, i[f >> 2] = k, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 60 >> 2] = 24, A;
                        }
                        function AW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, p[i[i[A >> 2] + 76 >> 2]](r + 4 | 0, A), e = 1;
                            i: {
                                if (i[r + 12 >> 2]) break i;
                                if (e = i[r + 4 >> 2], A = i[r + 8 >> 2], !A) {
                                    e = p[i[i[e >> 2] + 12 >> 2]](e) | 0;
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, e = p[i[i[e >> 2] + 12 >> 2]](e) | 0, f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            o[r + 31 | 0] < 0 && X(i[r + 20 >> 2]), A = i[r + 8 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = r + 32 | 0, e | 0;
                        }
                        function fW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, p[i[i[A >> 2] + 76 >> 2]](r + 4 | 0, A), e = 1;
                            i: {
                                if (i[r + 12 >> 2]) break i;
                                if (e = i[r + 4 >> 2], A = i[r + 8 >> 2], !A) {
                                    e = p[i[i[e >> 2] + 16 >> 2]](e) | 0;
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, e = p[i[i[e >> 2] + 16 >> 2]](e) | 0, f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            o[r + 31 | 0] < 0 && X(i[r + 20 >> 2]), A = i[r + 8 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = r + 32 | 0, e | 0;
                        }
                        function kW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            return t = p[i[i[A >> 2] + 8 >> 2]](A) | 0, f = w0, u = e + t | 0, f = u >>> 0 < e >>> 0 ? f + 1 | 0 : f, s = i[A + 36 >> 2], k = s, t = i[A + 32 >> 2], (f | 0) == (k | 0) & u >>> 0 <= t >>> 0 | f >>> 0 < k >>> 0 && (k = m - 16 | 0, m = k, A = i[A + 24 >> 2], i[A + 4 >> 2] = 0, EA(k + 15 | 0, A), n = 4, l[k + 15 | 0] && (n = i[(A + i[i[A >> 2] - 12 >> 2] | 0) + 24 >> 2], r = p[i[i[n >> 2] + 32 >> 2]](n, r, e) | 0, i[A + 4 >> 2] = r, n = (r | 0) != (e | 0) ? 6 : 0), Gf(A + i[i[A >> 2] - 12 >> 2] | 0, n), m = k + 16 | 0), (f | 0) == (s | 0) & t >>> 0 >= u >>> 0 | f >>> 0 < s >>> 0;
                        }
                        function G2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            i: {
                                if (l[A + 11 | 0] >>> 7 | 0 ? e = i[A + 4 >> 2] : e = l[A + 11 | 0] & 127, e >>> 0 < r >>> 0) {
                                    k = m - 16 | 0, m = k, e = r - e | 0, e && (f = l[A + 11 | 0] >>> 7 | 0 ? (i[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, l[A + 11 | 0] >>> 7 | 0 ? r = i[A + 4 >> 2] : r = l[A + 11 | 0] & 127, f - r >>> 0 < e >>> 0 && q3(A, f, r + (e - f | 0) | 0, r, r), l[A + 11 | 0] >>> 7 | 0 ? f = i[A >> 2] : f = A, Dt(f + r | 0, e, 0), n = A, A = r + e | 0, f6(n, A), o[k + 15 | 0] = 0, o[A + f | 0] = l[k + 15 | 0]), m = k + 16 | 0;
                                    break i;
                                }
                                e = A, l[A + 11 | 0] >>> 7 | 0 && (A = i[A >> 2]), xt(e, A, r);
                            }
                        }
                        function nW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            u = m - 32 | 0, m = u, t = i[r >> 2], s = i[t + 48 >> 2], t = i[t + 52 >> 2];
                            i: {
                                if (!t) {
                                    $5(u + 8 | 0, s, e, f, k);
                                    break i;
                                }
                                if (i[t + 4 >> 2] = i[t + 4 >> 2] + 1, $5(u + 8 | 0, s, e, f, k), e = i[t + 4 >> 2], i[t + 4 >> 2] = e - 1, e) break i;
                                p[i[i[t >> 2] + 8 >> 2]](t), g(t);
                            }
                            i: {
                                if (!(i[u + 12 >> 2] | !n)) {
                                    i[n >> 2] = i[u + 8 >> 2], i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                                    break i;
                                }
                                j0(A, u + 12 | 0, i[r >> 2]);
                            }
                            o[u + 31 | 0] < 0 && X(i[u + 20 >> 2]), m = u + 32 | 0;
                        }
                        function iA(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = m - 16 | 0, m = f, i[f + 12 >> 2] = r;
                            i: {
                                e: {
                                    e = l[A + 11 | 0], k = e >>> 7 | 0;
                                    r: {
                                        if (!k) {
                                            e = e & 127, r = 1;
                                            break r;
                                        }
                                        e = i[A + 4 >> 2], r = (i[A + 8 >> 2] & 2147483647) - 1 | 0;
                                    }
                                    if ((r | 0) == (e | 0)) {
                                        In(A, r, 1, r, r);
                                        r: if (l[A + 11 | 0] >>> 7 | 0) break r;
                                        break e;
                                    }
                                    r: if (l[A + 11 | 0] >>> 7 | 0) break r;
                                    if (k) break e;
                                    r = A, o[A + 11 | 0] = l[A + 11 | 0] & 128 | e + 1 & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127;
                                    break i;
                                }
                                r = i[A >> 2], i[A + 4 >> 2] = e + 1;
                            }
                            A = (e << 2) + r | 0, i[A >> 2] = i[f + 12 >> 2], i[f + 8 >> 2] = 0, i[A + 4 >> 2] = i[f + 8 >> 2], m = f + 16 | 0;
                        }
                        function dn(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            if ((A | 0) != (r | 0)) f: {
                                                k: {
                                                    if (n = l[A | 0], (n | 0) != 45 || (A = A + 1 | 0, (r | 0) != (A | 0))) break k;
                                                    break f;
                                                }
                                                u = i[26064], i[26064] = 0, L2(), A = hi(A, k + 12 | 0, f, -1, -1), f = w0, t = i[26064];
                                                k: {
                                                    if (t) {
                                                        if (i[k + 12 >> 2] != (r | 0)) break k;
                                                        if ((t | 0) == 68) break r;
                                                        break A;
                                                    }
                                                    if (i[26064] = u, i[k + 12 >> 2] == (r | 0)) break A;
                                                }
                                            }
                                            i[e >> 2] = 4, A = 0;
                                            break i;
                                        }
                                        if (!f) break e;
                                    }
                                    i[e >> 2] = 4, A = -1;
                                    break i;
                                }
                                A = (n | 0) == 45 ? 0 - A | 0 : A;
                            }
                            return m = k + 16 | 0, A;
                        }
                        function X8(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0;
                            u = m - 16 | 0, m = u;
                            i: {
                                if (!A || (t = i[k + 12 >> 2], s = e - r >> 2, (s | 0) > 0 && (p[i[i[A >> 2] + 48 >> 2]](A, r, s) | 0) != (s | 0))) break i;
                                if (r = f - r >> 2, t = (r | 0) < (t | 0) ? t - r | 0 : 0, (t | 0) > 0) {
                                    r = Yn(u + 4 | 0, t, n);
                                    e: {
                                        if (l[r + 11 | 0] >>> 7 | 0) {
                                            n = i[r >> 2];
                                            break e;
                                        }
                                        n = r;
                                    }
                                    if (n = p[i[i[A >> 2] + 48 >> 2]](A, n, t) | 0, h1(r), (n | 0) != (t | 0)) break i;
                                }
                                if (r = f - e >> 2, (r | 0) > 0 && (p[i[i[A >> 2] + 48 >> 2]](A, e, r) | 0) != (r | 0)) break i;
                                i[k + 12 >> 2] = 0, h = A;
                            }
                            return m = u + 16 | 0, h;
                        }
                        function Ke(A, r) {
                            i: {
                                if (A) {
                                    if (r >>> 0 <= 127) break i;
                                    e: {
                                        if (!i[i[26106] >> 2]) {
                                            if ((r & -128) == 57216) break i;
                                            break e;
                                        }
                                        if (r >>> 0 <= 2047) return o[A + 1 | 0] = r & 63 | 128, o[A | 0] = r >>> 6 | 192, 2;
                                        if (!((r & -8192) != 57344 & r >>> 0 >= 55296)) return o[A + 2 | 0] = r & 63 | 128, o[A | 0] = r >>> 12 | 224, o[A + 1 | 0] = r >>> 6 & 63 | 128, 3;
                                        if (r - 65536 >>> 0 <= 1048575) return o[A + 3 | 0] = r & 63 | 128, o[A | 0] = r >>> 18 | 240, o[A + 2 | 0] = r >>> 6 & 63 | 128, o[A + 1 | 0] = r >>> 12 & 63 | 128, 4;
                                    }
                                    i[26064] = 25, A = -1;
                                } else A = 1;
                                return A;
                            }
                            return o[A | 0] = r, 1;
                        }
                        function tW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            if ((r | 0) > 0) for(;;){
                                if (k = i[(n << 2) + A >> 2], k) {
                                    e = i[k + 20 >> 2];
                                    i: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    e = i[k + 12 >> 2];
                                    i: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    e = i[k + 4 >> 2];
                                    i: {
                                        if (!e || (f = i[e + 4 >> 2], i[e + 4 >> 2] = f - 1, f)) break i;
                                        p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                    }
                                    X(k);
                                }
                                if (n = n + 1 | 0, (n | 0) == (r | 0)) break;
                            }
                        }
                        function p6(A, r) {
                            var e = 0, f = 0;
                            f = A;
                            i: {
                                e: {
                                    if ((f ^ r) & 3) {
                                        e = l[r | 0];
                                        break e;
                                    }
                                    if (r & 3) for(;;){
                                        if (e = l[r | 0], o[f | 0] = e, !e) break i;
                                        if (f = f + 1 | 0, r = r + 1 | 0, !(r & 3)) break;
                                    }
                                    if (e = i[r >> 2], ((e | 16843008 - e) & -2139062144) != -2139062144) break e;
                                    for(; i[f >> 2] = e, f = f + 4 | 0, e = i[r + 4 >> 2], r = r + 4 | 0, ((16843008 - e | e) & -2139062144) == -2139062144;);
                                }
                                if (o[f | 0] = e, !(e & 255)) break i;
                                for(; e = l[r + 1 | 0], o[f + 1 | 0] = e, f = f + 1 | 0, r = r + 1 | 0, !!e;);
                            }
                            return A;
                        }
                        function p8(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0, h = 0;
                            u = m - 16 | 0, m = u;
                            i: {
                                if (!A || (t = i[k + 12 >> 2], s = e - r | 0, (s | 0) > 0 && (p[i[i[A >> 2] + 48 >> 2]](A, r, s) | 0) != (s | 0))) break i;
                                if (r = f - r | 0, t = (r | 0) < (t | 0) ? t - r | 0 : 0, (t | 0) > 0) {
                                    r = qn(u + 4 | 0, t, n);
                                    e: {
                                        if (l[r + 11 | 0] >>> 7 | 0) {
                                            n = i[r >> 2];
                                            break e;
                                        }
                                        n = r;
                                    }
                                    if (n = p[i[i[A >> 2] + 48 >> 2]](A, n, t) | 0, a0(r), (n | 0) != (t | 0)) break i;
                                }
                                if (r = f - e | 0, (r | 0) > 0 && (p[i[i[A >> 2] + 48 >> 2]](A, e, r) | 0) != (r | 0)) break i;
                                i[k + 12 >> 2] = 0, h = A;
                            }
                            return m = u + 16 | 0, h;
                        }
                        function oW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            e = i[A >> 2], r = i[e + 200 >> 2], e = i[e + 204 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1);
                            i: {
                                if (r) {
                                    A = p[i[i[r >> 2] + 8 >> 2]](r) | 0;
                                    break i;
                                }
                                if (r = i[A >> 2], A = i[r + 192 >> 2], r = i[r + 196 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), A ? A = p[i[i[A >> 2] + 8 >> 2]](A) | 0 : A = 0, !r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i: {
                                if (!e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            return A | 0;
                        }
                        function cn(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = i[A + 12 >> 2], k = i[A + 8 >> 2], A = f - k >> 2;
                            i: {
                                if ((f | 0) != (k | 0)) for(u = A >>> 0 <= 1 ? 1 : A;;){
                                    if (t = i[(n << 2) + k >> 2], !(i[t + 92 >> 2] != (r | 0) | i[t + 108 >> 2] <= (e | 0)) & i[t + 100 >> 2] == 2) break i;
                                    if (n = n + 1 | 0, (u | 0) == (n | 0)) break;
                                }
                                if (n = -1, (f | 0) == (k | 0)) break i;
                                for(t = A >>> 0 <= 1 ? 1 : A, A = 0;;){
                                    if (f = i[(A << 2) + k >> 2], !(i[f + 92 >> 2] != (r | 0) | i[f + 108 >> 2] <= (e | 0) | !i[f + 100 >> 2])) return A;
                                    if (A = A + 1 | 0, (t | 0) == (A | 0)) break;
                                }
                            }
                            return n;
                        }
                        function uW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                            i: {
                                if (!A) {
                                    q1(e + 8 | 0, f, r);
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, q1(e + 8 | 0, f, r), r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            r = 0, A = i[e + 8 >> 2], !A | i[A + 112 >> 2] != 1835625829 || (r = o[A + 139 | 0] < 0 ? i[A + 128 >> 2] : A + 128 | 0), A = i[e + 12 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = e + 16 | 0, r | 0;
                        }
                        function lW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                            i: {
                                if (!A) {
                                    q1(e + 8 | 0, f, r);
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, q1(e + 8 | 0, f, r), r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            r = 0, A = i[e + 8 >> 2], !A | i[A + 112 >> 2] != 1835625829 || (r = o[A + 151 | 0] < 0 ? i[A + 140 >> 2] : A + 140 | 0), A = i[e + 12 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = e + 16 | 0, r | 0;
                        }
                        function sW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                            i: {
                                if (!A) {
                                    q1(e + 8 | 0, f, r);
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, q1(e + 8 | 0, f, r), r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            r = 0, A = i[e + 8 >> 2], !A | i[A + 112 >> 2] != 1970432288 || (r = o[A + 163 | 0] < 0 ? i[A + 152 >> 2] : A + 152 | 0), A = i[e + 12 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = e + 16 | 0, r | 0;
                        }
                        function Wi(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = m - 16 | 0, m = f, o[f + 15 | 0] = r;
                            i: {
                                e: {
                                    e = l[A + 11 | 0], k = e >>> 7 | 0;
                                    r: {
                                        if (!k) {
                                            e = e & 127, r = 10;
                                            break r;
                                        }
                                        e = i[A + 4 >> 2], r = (i[A + 8 >> 2] & 2147483647) - 1 | 0;
                                    }
                                    if ((r | 0) == (e | 0)) {
                                        q3(A, r, 1, r, r);
                                        r: if (l[A + 11 | 0] >>> 7 | 0) break r;
                                        break e;
                                    }
                                    r: if (l[A + 11 | 0] >>> 7 | 0) break r;
                                    if (k) break e;
                                    r = A, o[A + 11 | 0] = l[A + 11 | 0] & 128 | e + 1 & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127;
                                    break i;
                                }
                                r = i[A >> 2], i[A + 4 >> 2] = e + 1;
                            }
                            A = r + e | 0, o[A | 0] = l[f + 15 | 0], o[f + 14 | 0] = 0, o[A + 1 | 0] = l[f + 14 | 0], m = f + 16 | 0;
                        }
                        function hW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 104 >> 2]), l2(e, i[r + 108 >> 2]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function wW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, l2(e, i[r + 100 >> 2]), l2(e, i[r + 104 >> 2]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function L1(A, r, e, f) {
                            var k = 0, n = 0;
                            i: {
                                if (l[A + 11 | 0] >>> 7 | 0 ? k = i[A + 4 >> 2] : k = l[A + 11 | 0] & 127, !k | (e - r | 0) < 5) break i;
                                ir(r, e), n = e - 4 | 0, l[A + 11 | 0] >>> 7 | 0 ? k = i[A + 4 >> 2] : k = l[A + 11 | 0] & 127, l[A + 11 | 0] >>> 7 | 0 && (A = i[A >> 2]), e = A, A = k + A | 0;
                                e: {
                                    for(;;){
                                        r: {
                                            if (k = o[e | 0], r >>> 0 >= n >>> 0) break r;
                                            if (!((k | 0) <= 0 | (k | 0) >= 127) & (k | 0) != i[r >> 2]) break e;
                                            r = r + 4 | 0, e = ((A - e | 0) > 1) + e | 0;
                                            continue;
                                        }
                                        break;
                                    }
                                    if ((k | 0) <= 0 | (k | 0) >= 127 | o[e | 0] >>> 0 > i[n >> 2] - 1 >>> 0) break i;
                                }
                                i[f >> 2] = 4;
                            }
                        }
                        function vW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            n = m - 32 | 0, m = n, i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, t = n + 4 | 0, h3(t, i[r >> 2], n + 24 | 0, f, k, 0), i[n + 4 >> 2] || (k = D(8), i[e >> 2] = k, f = i[n + 24 >> 2], e = i[n + 28 >> 2], i[n + 24 >> 2] = 0, i[n + 28 >> 2] = 0, i[k >> 2] = f, i[k + 4 >> 2] = e, t = 86672), e = A, A = i[r >> 2], j0(e, t, A ? A + 8 | 0 : 0), o[n + 23 | 0] < 0 && X(i[n + 12 >> 2]), r = i[n + 28 >> 2];
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            m = n + 32 | 0;
                        }
                        function _W(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, I[r + 98 >> 1]), w2(e, I[r + 100 >> 1]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function BW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            for(n = m - 16 | 0, m = n;;){
                                i: {
                                    if ((e | 0) <= (t | 0)) break i;
                                    if (f = i[A + 24 >> 2], k = i[A + 28 >> 2], f >>> 0 >= k >>> 0) {
                                        if ((p[i[i[A >> 2] + 52 >> 2]](A, i[r >> 2]) | 0) == -1) break i;
                                        t = t + 1 | 0, r = r + 4 | 0;
                                    } else i[n + 12 >> 2] = k - f >> 2, i[n + 8 >> 2] = e - t, f = m - 16 | 0, m = f, m = f + 16 | 0, f = n + 8 | 0, k = n + 12 | 0, f = i[(i[f >> 2] < i[k >> 2] ? f : k) >> 2], r6(r, f, i[A + 24 >> 2]), k = f << 2, i[A + 24 >> 2] = k + i[A + 24 >> 2], t = f + t | 0, r = r + k | 0;
                                    continue;
                                }
                                break;
                            }
                            return m = n + 16 | 0, t | 0;
                        }
                        function x1(A, r, e, f, k, n, t, u, s) {
                            var h = 0, w = 0, v = 0, _ = 0;
                            s = O0(r, e, u, s), u = w0, k = O0(f, k, n, t), s = k + s | 0, f = w0 + u | 0, u = k >>> 0 > s >>> 0 ? f + 1 | 0 : f, h = t, k = 0, w = e, f = 0, e = O0(t, k, e, f), t = e + s | 0, s = w0 + u | 0, v = t, e = e >>> 0 > t >>> 0 ? s + 1 | 0 : s, t = O0(n, 0, r, 0), u = w0, s = 0, f = O0(n, s, w, f), u = u + f | 0, n = w0 + s | 0, n = f >>> 0 > u >>> 0 ? n + 1 | 0 : n, s = n + v | 0, f = e, n = n >>> 0 > s >>> 0 ? f + 1 | 0 : f, r = O0(r, _, h, k) + u | 0, k = w0, k = r >>> 0 < u >>> 0 ? k + 1 | 0 : k, u = k + s | 0, s = n, i[A + 8 >> 2] = u, i[A + 12 >> 2] = k >>> 0 > u >>> 0 ? s + 1 | 0 : s, i[A >> 2] = t, i[A + 4 >> 2] = r;
                        }
                        function mW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            i: {
                                if (k = p[i[i[r >> 2] + 68 >> 2]](i[r + 4 >> 2]) | 0, r = i[k >> 2], !r) break i;
                                for(;;){
                                    if (d1(i[r + 4 >> 2], e)) {
                                        if (r = i[k + 4 >> 2], k = k + 4 | 0, r) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (i[r + 8 >> 2] != 3) {
                                    r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                    return;
                                }
                                f && (i[f >> 2] = i[r + 16 >> 2]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                                return;
                            }
                            r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                        }
                        function ZW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = i[A >> 2], e = i[r + 52 >> 2], r = i[r + 56 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                            i: {
                                e: {
                                    if (e) {
                                        A = r;
                                        break e;
                                    }
                                    A = i[A >> 2], e = i[A + 44 >> 2], A = i[A + 48 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1);
                                    r: {
                                        if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break r;
                                        p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                    }
                                    if (e) break e;
                                    r = 0;
                                    break i;
                                }
                                r = p[i[i[e >> 2] + 8 >> 2]](e) | 0;
                            }
                            i: {
                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return r | 0;
                        }
                        function GW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = i[A >> 2], A = i[e + 24 >> 2], e = i[e + 28 >> 2];
                            i: {
                                if ((A | 0) != (e | 0)) for(;;){
                                    e: {
                                        if (f = i[A >> 2], !f || (f = E0(f, 73632, 75864), !f)) break e;
                                        if (e = i[A + 4 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), r && (A = I[f + 98 >> 1] | I[f + 100 >> 1] << 16, Q[r >> 1] = A, Q[r + 2 >> 1] = A >>> 16), A = 1, !e || (r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r)) break i;
                                        return p[i[i[e >> 2] + 8 >> 2]](e), g(e), 1;
                                    }
                                    if (A = A + 8 | 0, (e | 0) == (A | 0)) break;
                                }
                                A = 0;
                            }
                            return A | 0;
                        }
                        function WW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, i[r + 100 >> 2] / 90 & 255), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function eA(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            i: {
                                e: {
                                    if (f) {
                                        if (f >>> 0 >= 357913942) break e;
                                        if (k = Z(f, 12), f = D(k), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + k, (r | 0) != (e | 0)) for(;;){
                                            if (i[f + 8 >> 2] = 0, i[f >> 2] = 0, i[f + 4 >> 2] = 0, t = i[r >> 2], k = i[r + 4 >> 2], (t | 0) != (k | 0)) {
                                                if (k = k - t | 0, (k | 0) < 0) break i;
                                                n = D(k), i[f + 4 >> 2] = n, i[f >> 2] = n, u = k + n | 0, i[f + 8 >> 2] = u, v0(n, t, k), i[f + 4 >> 2] = u;
                                            }
                                            if (f = f + 12 | 0, r = r + 12 | 0, (e | 0) == (r | 0)) break;
                                        }
                                        i[A + 4 >> 2] = f;
                                    }
                                    return;
                                }
                                p0(), z();
                            }
                            p0(), z();
                        }
                        function XW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            n = m - 16 | 0, m = n, r = i[r >> 2], s = i[r + 48 >> 2], r = i[r + 52 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), t = D(4), i[n + 4 >> 2] = t, u = t + 4 | 0, i[n + 12 >> 2] = u, i[t >> 2] = k, i[n + 8 >> 2] = u, J4(s, f, e, n + 4 | 0), e = i[n + 4 >> 2], e && (i[n + 8 >> 2] = e, X(e));
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867], m = n + 16 | 0;
                        }
                        function K1(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            f = m - 16 | 0, m = f, C1(f + 8 | 0, A);
                            i: {
                                if (!l[f + 8 | 0] || (n = f + 4 | 0, k = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 28 >> 2], i[n >> 2] = k, (k | 0) != 108396 && (i[k + 4 >> 2] = i[k + 4 >> 2] + 1), k = K0(n, 108260), d0(n), i[f >> 2] = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], t = i[i[A >> 2] - 12 >> 2] + A | 0, u = Yi(t), s = f, h = p[i[i[k >> 2] + 28 >> 2]](k, i[f >> 2], t, u, r, e) | 0, i[s + 4 >> 2] = h, i[n >> 2])) break i;
                                M4(i[i[A >> 2] - 12 >> 2] + A | 0, 5);
                            }
                            return G1(f + 8 | 0), m = f + 16 | 0, A;
                        }
                        function pW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = n2(e), i[k + 100 >> 2] = n, k = r, n = B2(e), Q[k + 104 >> 1] = n, k = r, n = B2(e), Q[k + 106 >> 1] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function QW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            i: {
                                if (f) for(;;){
                                    if (f - k >>> 0 <= 3 || (n = k + 4 | 0, k = e + k | 0, k = l[k | 0] | l[k + 1 | 0] << 8 | (l[k + 2 | 0] << 16 | l[k + 3 | 0] << 24), k = k << 24 | (k & 65280) << 8 | (k >>> 8 & 65280 | k >>> 24), f - n >>> 0 < k >>> 0)) break i;
                                    if (r5(i[r >> 2], e + n | 0, k, 0, 0, 0), k = k + n | 0, !(k >>> 0 < f >>> 0)) break;
                                }
                                r = i[21479], i[A >> 2] = i[21478], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21480];
                                return;
                            }
                            r = i[21476], i[A >> 2] = i[21475], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21477];
                        }
                        function Q6(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            e = i[r + 372 >> 2], r = i[r + 376 >> 2];
                            i: {
                                if (!r) {
                                    i[A + 4 >> 2] = 0, i[A >> 2] = e;
                                    break i;
                                }
                                i[r + 4 >> 2] = i[r + 4 >> 2] + 1, i[A + 4 >> 2] = r, i[A >> 2] = e, i[r + 4 >> 2] = i[r + 4 >> 2] + 1;
                            }
                            e = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = e, A = A + 16 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    e = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                        }
                        function CW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            for(k = m - 16 | 0, m = k;;){
                                i: {
                                    if ((e | 0) <= (n | 0)) break i;
                                    if (f = i[A + 24 >> 2], t = i[A + 28 >> 2], f >>> 0 >= t >>> 0) {
                                        if ((p[i[i[A >> 2] + 52 >> 2]](A, l[r | 0]) | 0) == -1) break i;
                                        n = n + 1 | 0, r = r + 1 | 0;
                                    } else i[k + 12 >> 2] = t - f, i[k + 8 >> 2] = e - n, f = m - 16 | 0, m = f, m = f + 16 | 0, f = k + 8 | 0, t = k + 12 | 0, f = i[(i[f >> 2] < i[t >> 2] ? f : t) >> 2], f8(r, f, i[A + 24 >> 2]), i[A + 24 >> 2] = f + i[A + 24 >> 2], n = f + n | 0, r = r + f | 0;
                                    continue;
                                }
                                break;
                            }
                            return m = k + 16 | 0, n | 0;
                        }
                        function VW(A, r, e, f, k, n, t, u) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, i[r + 8 >> 2] != 1) {
                                r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                return;
                            }
                            i: {
                                if (!l[r + 16 | 0] || (k && (i[k >> 2] = i[r + 20 >> 2]), !n)) break i;
                                i[n >> 2] = i[r + 24 >> 2];
                            }
                            e && (i[e >> 2] = l[r + 16 | 0]), f && (i[f >> 2] = l[r + 16 | 0]), !u | i[r + 32 >> 2] <= 0 || (i[u >> 2] = i[r + 28 >> 2]), t && (i[t >> 2] = i[r + 32 >> 2]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                        }
                        function V2(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 73676, o[A + 95 | 0] < 0 && X(i[A + 84 >> 2]), r = i[A + 72 >> 2], r && (i[A + 76 >> 2] = r, X(r)), r = i[A + 36 >> 2], r) {
                                if (e = r, f = i[A + 40 >> 2], (r | 0) != (f | 0)) {
                                    for(;;){
                                        e = i[f - 4 >> 2];
                                        i: {
                                            if (!e || (k = i[e + 4 >> 2], i[e + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (f = f - 8 | 0, (r | 0) == (f | 0)) break;
                                    }
                                    e = i[A + 36 >> 2];
                                }
                                i[A + 40 >> 2] = r, X(e);
                            }
                            return i[A >> 2] = 73428, r = i[A + 20 >> 2], r && (i[A + 24 >> 2] = r, X(r)), A | 0;
                        }
                        function yW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((e | 0) > 0) for(u = 1 << k - 1, v = e & 2147483646, _ = e & 1;;){
                                if (w = Z(e, s), n = 0, h = 0, (e | 0) != 1) for(; t = n + w | 0, i[(t << 2) + A >> 2] = (Q[(t << 1) + r >> 1] << f) + u >> k, t = t + 1 | 0, i[(t << 2) + A >> 2] = (Q[(t << 1) + r >> 1] << f) + u >> k, n = n + 2 | 0, h = h + 2 | 0, (v | 0) != (h | 0););
                                if (_ && (n = n + w | 0, i[(n << 2) + A >> 2] = (Q[(n << 1) + r >> 1] << f) + u >> k), s = s + 1 | 0, (s | 0) == (e | 0)) break;
                            }
                        }
                        function IW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 32 | 0, m = f, k = i[e >> 2], k >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (k >>> 0 >= 11) {
                                            t = (k | 7) + 1 | 0, n = D(t), i[f + 16 >> 2] = t | -2147483648, i[f + 8 >> 2] = n, i[f + 12 >> 2] = k;
                                            break e;
                                        }
                                        if (o[f + 19 | 0] = k, n = f + 8 | 0, !k) break i;
                                    }
                                    v0(n, e + 4 | 0, k);
                                }
                                return o[k + n | 0] = 0, p[A | 0](f + 20 | 0, r, f + 8 | 0), A = D(12), i[A + 8 >> 2] = i[f + 28 >> 2], r = i[f + 24 >> 2], i[A >> 2] = i[f + 20 >> 2], i[A + 4 >> 2] = r, o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), m = f + 32 | 0, A | 0;
                            }
                            Y0(), z();
                        }
                        function FW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            if ((r | 0) < 8) return 3;
                            i: {
                                e: {
                                    if (l[A + 4 | 0] != 102 | l[A + 5 | 0] != 116 | (l[A + 6 | 0] != 121 | l[A + 7 | 0] != 112)) break e;
                                    if (r >>> 0 < 12) return 3;
                                    e = 1, A = yA(A, r);
                                    r: {
                                        if ((A | 0) <= 1781689192) {
                                            if ((A | 0) == 1635150182 | (A | 0) == 1751476579) break e;
                                            if ((A | 0) != 1751476600) break r;
                                            break e;
                                        }
                                        A: switch(A - 1835623985 | 0){
                                            case 0:
                                            case 1:
                                                break i;
                                            default:
                                                break A;
                                        }
                                        if ((A | 0) == 1781689193 | (A | 0) == 1785750887) break e;
                                    }
                                    e = 2;
                                }
                                return e | 0;
                            }
                            return 3;
                        }
                        function qe(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            e = m - 16 | 0, m = e, C1(e + 8 | 0, A);
                            i: {
                                if (!l[e + 8 | 0] || (k = e + 4 | 0, f = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 28 >> 2], i[k >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(k, 108260), d0(k), i[e >> 2] = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], n = i[i[A >> 2] - 12 >> 2] + A | 0, t = Yi(n), u = e, s = p[i[i[f >> 2] + 12 >> 2]](f, i[e >> 2], n, t, r) | 0, i[u + 4 >> 2] = s, i[k >> 2])) break i;
                                M4(i[i[A >> 2] - 12 >> 2] + A | 0, 5);
                            }
                            return G1(e + 8 | 0), m = e + 16 | 0, A;
                        }
                        function P0(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            e = m - 16 | 0, m = e, C1(e + 8 | 0, A);
                            i: {
                                if (!l[e + 8 | 0] || (k = e + 4 | 0, f = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 28 >> 2], i[k >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(k, 108260), d0(k), i[e >> 2] = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], n = i[i[A >> 2] - 12 >> 2] + A | 0, t = Yi(n), u = e, s = p[i[i[f >> 2] + 16 >> 2]](f, i[e >> 2], n, t, r) | 0, i[u + 4 >> 2] = s, i[k >> 2])) break i;
                                M4(i[i[A >> 2] - 12 >> 2] + A | 0, 5);
                            }
                            return G1(e + 8 | 0), m = e + 16 | 0, A;
                        }
                        function M0(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            e = m - 16 | 0, m = e, C1(e + 8 | 0, A);
                            i: {
                                if (!l[e + 8 | 0] || (k = e + 4 | 0, f = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 28 >> 2], i[k >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(k, 108260), d0(k), i[e >> 2] = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], n = i[i[A >> 2] - 12 >> 2] + A | 0, t = Yi(n), u = e, s = p[i[i[f >> 2] + 24 >> 2]](f, i[e >> 2], n, t, r) | 0, i[u + 4 >> 2] = s, i[k >> 2])) break i;
                                M4(i[i[A >> 2] - 12 >> 2] + A | 0, 5);
                            }
                            return G1(e + 8 | 0), m = e + 16 | 0, A;
                        }
                        function I4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            e = m - 16 | 0, m = e, C1(e + 8 | 0, A);
                            i: {
                                if (!l[e + 8 | 0] || (k = e + 4 | 0, f = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 28 >> 2], i[k >> 2] = f, (f | 0) != 108396 && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), f = K0(k, 108260), d0(k), i[e >> 2] = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], n = i[i[A >> 2] - 12 >> 2] + A | 0, t = Yi(n), u = e, s = p[i[i[f >> 2] + 32 >> 2]](f, i[e >> 2], n, t, r) | 0, i[u + 4 >> 2] = s, i[k >> 2])) break i;
                                M4(i[i[A >> 2] - 12 >> 2] + A | 0, 5);
                            }
                            return G1(e + 8 | 0), m = e + 16 | 0, A;
                        }
                        function i9(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k, t = i[26106], i[r + 72 >> 2] <= 0 && KA(r), i[26106] = i[r + 136 >> 2], e = -1, i[r + 4 >> 2] || (Ei(r), f = !i[r + 4 >> 2]);
                            i: {
                                if (f | (A | 0) == -1 || (f = Ke(k + 12 | 0, A), (f | 0) < 0) || (n = i[r + 4 >> 2], n >>> 0 < (f + i[r + 44 >> 2] | 0) - 8 >>> 0)) break i;
                                e: {
                                    if (A >>> 0 <= 127) {
                                        e = n - 1 | 0, i[r + 4 >> 2] = e, o[e | 0] = A;
                                        break e;
                                    }
                                    e = n - f | 0, i[r + 4 >> 2] = e, v0(e, k + 12 | 0, f);
                                }
                                i[r >> 2] = i[r >> 2] & -17, e = A;
                            }
                            return i[26106] = t, m = k + 16 | 0, (e | 0) != -1;
                        }
                        function i8(A, r) {
                            var e = 0, f = 0, k = 0;
                            if ((r | 0) <= 8) {
                                if (!r) return 0;
                                f = i[A + 16 >> 2] << r, i[A + 16 >> 2] = f, e = I[A + 20 >> 1] + r | 0, Q[A + 20 >> 1] = e, e = e << 16 >> 16;
                                i: {
                                    if ((e | 0) < 0 || (k = i[A + 4 >> 2], k >>> 0 >= k0[A + 8 >> 2])) break i;
                                    i[A + 4 >> 2] = k + 1, k = l[k | 0], Q[A + 20 >> 1] = e - 8, f = k << e | f;
                                }
                                return k = i[A + 12 >> 2] << 7, e = (f >>> 0) / (k >>> 0) | 0, r = 1 << r, (e | 0) >= (r | 0) && (e = r - 1 | 0), i[A + 16 >> 2] = f - Z(e, k), e;
                            }
                            for(f = r - 8 | 0, r = y9(A); r = S1(A) | r << 1, f = f - 1 | 0, !!f;);
                            return r;
                        }
                        function YW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0, h = 0, w = 0;
                            if (!(k & 1)) {
                                if (!((n | 0) <= 0 | (k | 0) <= 0)) for(;;){
                                    for(s = Z(r, u) + A | 0, h = (Z(f, u) << 1) + e | 0, w = 0; t = Q[h >> 1] + 32 >> 6, t = (t | 0) >= 255 ? 255 : t, o[s | 0] = (t | 0) > 0 ? t : 0, t = Q[h + 2 >> 1] + 32 >> 6, t = (t | 0) >= 255 ? 255 : t, o[s + 1 | 0] = (t | 0) > 0 ? t : 0, h = h + 4 | 0, s = s + 2 | 0, w = w + 2 | 0, (w | 0) < (k | 0););
                                    if (u = u + 1 | 0, (u | 0) == (n | 0)) break;
                                }
                                return;
                            }
                            y0(18295, 14969, 40, 8469), z();
                        }
                        function EW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 100 | 0]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function gW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, w2(e, I[r + 98 >> 1]), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function JW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 32 | 0, m = f, z1(f, r, e), o[f + 19 | 0] < 0 && X(i[f + 8 >> 2]), k = r, n = X2(e), o[k + 104 | 0] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 20 | 0] = 0, o[f + 31 | 0] = 0, i0(A, 2, 100, f + 20 | 0), o[f + 31 | 0] >= 0) break i;
                                    X(i[f + 20 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function RW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            k = i[A >> 2], f = i[k + 128 >> 2], k = i[k + 132 >> 2];
                            i: {
                                if ((f | 0) != (k | 0)) for(n = i[i[A + 8 >> 2] >> 2];;){
                                    if (A = i[f >> 2], i[A >> 2] == (n | 0)) {
                                        if (f = i[f + 4 >> 2], !f) {
                                            f = 0;
                                            break i;
                                        }
                                        i[f + 4 >> 2] = i[f + 4 >> 2] + 1;
                                        break i;
                                    }
                                    if (f = f + 8 | 0, (k | 0) == (f | 0)) break;
                                }
                                f = 0, A = 0;
                            }
                            r && (i[r >> 2] = i[A + 4 >> 2]), e && (i[e >> 2] = i[A + 8 >> 2]);
                            i: {
                                if (!f || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                        }
                        function Xi(A, r, e) {
                            var f = J(0), k = J(0), n = J(0), t = J(0), u = 0, s = J(0);
                            u = m - 16 | 0, m = u, z5(u + 8 | 0, r, e), f = W0[u + 12 >> 2], k = W0[u + 8 >> 2];
                            i: {
                                if (!(f != J(0) | k != J(0))) {
                                    k = J(-0.714136004447937), f = J(-0.34413599967956543), n = J(1.7719999551773071), t = J(1.4019999504089355);
                                    break i;
                                }
                                t = J(J(1) - k), s = J(J(f + k) + J(-1)), k = J(J(J(k + k) * t) / s), n = J(J(1) - f), f = J(J(J(f + f) * n) / s), n = J(n + n), t = J(t + t);
                            }
                            W0[A + 16 >> 2] = n, W0[A + 12 >> 2] = k, W0[A + 8 >> 2] = f, W0[A + 4 >> 2] = t, o[A | 0] = 1, m = u + 16 | 0;
                        }
                        function NW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, G4(e, r + 120 | 0), i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function DW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                            i: {
                                if (!A) {
                                    q1(e + 8 | 0, f, r);
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, q1(e + 8 | 0, f, r), r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 8 >> 2], A ? A = o[A + 127 | 0] < 0 ? i[A + 116 >> 2] : A + 116 | 0 : A = 0, r = i[e + 12 >> 2];
                            i: {
                                if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = e + 16 | 0, A | 0;
                        }
                        function e9(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            r = i[A + 28 >> 2], r && p[r | 0](), r = D(4), i[r >> 2] = A, e = D(20), i[e + 16 >> 2] = r, f = i[21682];
                            i: {
                                if (!f) {
                                    A = 86728, r = 86728;
                                    break i;
                                }
                                for(k = i[A + 12 >> 2];;){
                                    if (A = f, i[i[i[A + 16 >> 2] >> 2] + 12 >> 2] < (k | 0)) {
                                        if (r = A, f = i[A >> 2], f) continue;
                                        break i;
                                    }
                                    if (f = i[A + 4 >> 2], !f) break;
                                }
                                r = A + 4 | 0;
                            }
                            i[e + 8 >> 2] = A, i[e >> 2] = 0, i[e + 4 >> 2] = 0, i[r >> 2] = e, A = i[i[21681] >> 2], A && (i[21681] = A, e = i[r >> 2]), h4(i[21682], e), i[21683] = i[21683] + 1;
                        }
                        function pi(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            i[A >> 2] = 58928, e = m - 16 | 0, m = e, r = i[A + 64 >> 2], r && (i[e + 4 >> 2] = 1299, r = s1(e + 8 | 0, r, e + 4 | 0), p[i[i[A >> 2] + 24 >> 2]](A), f = i[r >> 2], i[r >> 2] = 0, VA(f), i[A + 64 >> 2] = 0, p[i[i[A >> 2] + 12 >> 2]](A, 0, 0), f = i[r >> 2], i[r >> 2] = 0, f && p[i[r + 4 >> 2]](f)), m = e + 16 | 0;
                            i: {
                                if (l[A + 96 | 0] != 1 || (r = i[A + 32 >> 2], !r)) break i;
                                X(r);
                            }
                            i: {
                                if (l[A + 97 | 0] != 1 || (r = i[A + 56 >> 2], !r)) break i;
                                X(r);
                            }
                            return x0(A) | 0;
                        }
                        function MW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            A = i[A >> 2];
                            i: {
                                if ((r | 0) == 10) {
                                    if (f = 255, A = i[A + 36 >> 2] - 10 | 0, A >>> 0 >= 6) break i;
                                    r = A << 3, A = r & 31, (r & 63) >>> 0 >= 32 ? f = 16432 >>> A | 0 : f = ((1 << A) - 1 & 16432) << 32 - A | 1076895768 >>> A;
                                    break i;
                                }
                                if (e = i[A + 64 >> 2], !e) break i;
                                for(k = A - -64 | 0, A = k; n = i[e + 16 >> 2] < (r | 0), A = n ? A : e, e = i[(n << 2) + e >> 2], !!e;);
                                if ((A | 0) == (k | 0) | i[A + 16 >> 2] > (r | 0)) break i;
                                f = l[A + 24 | 0] + 7 & -8;
                            }
                            return f & 255;
                        }
                        function rA(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                e: {
                                    if (k = i[21695], !k) break e;
                                    for(n = 86780; t = k0[k + 16 >> 2] < e >>> 0, n = t ? n : k, k = i[(t << 2) + k >> 2], !!k;);
                                    if ((n | 0) == 86780 | k0[n + 16 >> 2] > e >>> 0) break e;
                                    i[r + 12 >> 2] = e, j0(A, 86672, 0);
                                    break i;
                                }
                                if (i[r + 12 >> 2] = 2, o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 2, 135, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                X(i[f >> 2]);
                            }
                            m = f + 32 | 0;
                        }
                        function AA() {
                            var A = 0, r = 0, e = 0;
                            A = i[21466], A && p[A | 0](), A = i[21679];
                            i: {
                                e: {
                                    if (!A) {
                                        r = 86716, e = 86716;
                                        break e;
                                    }
                                    for(;;){
                                        if (e = A, r = i[A + 16 >> 2], r >>> 0 > 85856) {
                                            if (r = A, A = i[A >> 2], A) continue;
                                            break e;
                                        }
                                        if (r >>> 0 >= 85856) break i;
                                        if (A = i[e + 4 >> 2], !A) break;
                                    }
                                    r = e + 4 | 0;
                                }
                                A = D(20), i[A + 8 >> 2] = e, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 16 >> 2] = 85856, i[r >> 2] = A, e = i[i[21678] >> 2], e && (i[21678] = e, A = i[r >> 2]), h4(i[21679], A), i[21680] = i[21680] + 1;
                            }
                            e9(85924);
                        }
                        function UW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0;
                            n = m - 16 | 0, m = n, u = i[A >> 2], t = i[u + 112 >> 2], k = (i[u + 116 >> 2] - t | 0) / 20 | 0;
                            i: {
                                if (!f || (f = (r | 0) >= (k | 0), k = 0, f)) break i;
                                for(; f = i[A >> 2], j0(n + 4 | 0, Z(r + k | 0, 20) + t | 0, f ? f + 8 | 0 : 0), f = Z(k, 12) + e | 0, i[f + 8 >> 2] = i[n + 12 >> 2], t = i[n + 8 >> 2], i[f >> 2] = i[n + 4 >> 2], i[f + 4 >> 2] = t, k = k + 1 | 0, t = i[u + 112 >> 2], (k + r | 0) < ((i[u + 116 >> 2] - t | 0) / 20 | 0););
                            }
                            return m = n + 16 | 0, k | 0;
                        }
                        function fA(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                e: {
                                    if (k = i[21689], !k) break e;
                                    for(n = 86756; t = k0[k + 16 >> 2] < e >>> 0, n = t ? n : k, k = i[(t << 2) + k >> 2], !!k;);
                                    if ((n | 0) == 86756 | k0[n + 16 >> 2] > e >>> 0) break e;
                                    i[r + 4 >> 2] = e, j0(A, 86672, 0);
                                    break i;
                                }
                                if (i[r + 4 >> 2] = 2, o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 2, 133, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                X(i[f >> 2]);
                            }
                            m = f + 32 | 0;
                        }
                        function kA(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                e: {
                                    if (k = i[21692], !k) break e;
                                    for(n = 86768; t = k0[k + 16 >> 2] < e >>> 0, n = t ? n : k, k = i[(t << 2) + k >> 2], !!k;);
                                    if ((n | 0) == 86768 | k0[n + 16 >> 2] > e >>> 0) break e;
                                    i[r + 8 >> 2] = e, j0(A, 86672, 0);
                                    break i;
                                }
                                if (i[r + 8 >> 2] = 2, o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 2, 134, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                X(i[f >> 2]);
                            }
                            m = f + 32 | 0;
                        }
                        function R4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            if (f = i[r + 4 >> 2], e = o[r + 11 | 0], t = (i[A + 12 >> 2] + ((e | 0) < 0 ? f : e) | 0) + 1 | 0, k = i[A + 4 >> 2] - i[A >> 2] | 0, t >>> 0 > k >>> 0 && (r1(A, t - k | 0), f = i[r + 4 >> 2], e = l[r + 11 | 0]), k = e, e = e << 24 >> 24 < 0, e ? f : k) for(; e = l[(e ? i[r >> 2] : r) + n | 0], f = i[A + 12 >> 2], i[A + 12 >> 2] = f + 1, o[f + i[A >> 2] | 0] = e, f = o[r + 11 | 0], e = f >>> 31 | 0, n = n + 1 | 0, n >>> 0 < ((f | 0) < 0 ? i[r + 4 >> 2] : f) >>> 0;);
                            r = i[A + 12 >> 2], i[A + 12 >> 2] = r + 1, o[r + i[A >> 2] | 0] = 0;
                        }
                        function Qi(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            i: {
                                if ((r | 0) <= 0) break i;
                                for(t = i[A + 12 >> 2] << 7, f = I[A + 20 >> 1], e = i[A + 16 >> 2];;){
                                    f = f + 1 | 0, Q[A + 20 >> 1] = f, e = e << 1, i[A + 16 >> 2] = e, f = f << 16 >> 16;
                                    e: {
                                        if ((f | 0) < 0 || (f = 65528, Q[A + 20 >> 1] = 65528, n = i[A + 4 >> 2], n >>> 0 >= k0[A + 8 >> 2])) break e;
                                        i[A + 4 >> 2] = n + 1, e = l[n | 0] | e, i[A + 16 >> 2] = e;
                                    }
                                    if (e >>> 0 < t >>> 0) break i;
                                    if (e = e - t | 0, i[A + 16 >> 2] = e, k = k + 1 | 0, (k | 0) == (r | 0)) break;
                                }
                                k = r;
                            }
                            return (r | 0) > (k | 0) ? k : r;
                        }
                        function HW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            return A = m - 256 | 0, m = A, i[A + 248 >> 2] = 37, i[A + 252 >> 2] = 0, t = A + 248 | 0, D8(t | 1, 8046, 1, i[e + 4 >> 2]), u = L2(), i[A >> 2] = k, i[A + 4 >> 2] = n, k = A + 224 | 0, t = c1(k, 24, u, t, A) + k | 0, s = W4(k, t, e), u = A + 20 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 32 | 0, Je(n, s, t, k, A + 28 | 0, A + 24 | 0, u), d0(u), r = X8(r, k, i[A + 28 >> 2], i[A + 24 >> 2], e, f), m = A + 256 | 0, r | 0;
                        }
                        function xW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            return A = m - 256 | 0, m = A, i[A + 248 >> 2] = 37, i[A + 252 >> 2] = 0, t = A + 248 | 0, D8(t | 1, 8046, 0, i[e + 4 >> 2]), u = L2(), i[A >> 2] = k, i[A + 4 >> 2] = n, k = A + 224 | 0, t = c1(k, 24, u, t, A) + k | 0, s = W4(k, t, e), u = A + 20 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 32 | 0, Je(n, s, t, k, A + 28 | 0, A + 24 | 0, u), d0(u), r = X8(r, k, i[A + 28 >> 2], i[A + 24 >> 2], e, f), m = A + 256 | 0, r | 0;
                        }
                        function j(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    if (e >>> 0 < 11) {
                                        f = A, o[A + 11 | 0] = l[A + 11 | 0] & 128 | e & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127;
                                        break e;
                                    }
                                    if (e >>> 0 > 2147483639) break i;
                                    t = k + 8 | 0, e >>> 0 >= 11 ? (n = e + 8 & -8, f = n - 1 | 0, f = (f | 0) == 11 ? n : f) : f = 10, N6(t, f + 1 | 0), f = i[k + 8 >> 2], i[A >> 2] = f, i[A + 8 >> 2] = i[A + 8 >> 2] & -2147483648 | i[k + 12 >> 2] & 2147483647, i[A + 8 >> 2] = i[A + 8 >> 2] | -2147483648, i[A + 4 >> 2] = e;
                                }
                                f8(r, e + 1 | 0, f), m = k + 16 | 0;
                                return;
                            }
                            u4(), z();
                        }
                        function zW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            return A = m - 112 | 0, m = A, i[A + 104 >> 2] = 37, i[A + 108 >> 2] = 0, t = A + 104 | 0, D8(t | 1, 8046, 1, i[e + 4 >> 2]), u = L2(), i[A >> 2] = k, i[A + 4 >> 2] = n, k = A + 80 | 0, t = c1(k, 24, u, t, A) + k | 0, s = W4(k, t, e), u = A + 20 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 32 | 0, Re(n, s, t, k, A + 28 | 0, A + 24 | 0, u), d0(u), r = p8(r, k, i[A + 28 >> 2], i[A + 24 >> 2], e, f), m = A + 112 | 0, r | 0;
                        }
                        function TW(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            return A = m - 112 | 0, m = A, i[A + 104 >> 2] = 37, i[A + 108 >> 2] = 0, t = A + 104 | 0, D8(t | 1, 8046, 0, i[e + 4 >> 2]), u = L2(), i[A >> 2] = k, i[A + 4 >> 2] = n, k = A + 80 | 0, t = c1(k, 24, u, t, A) + k | 0, s = W4(k, t, e), u = A + 20 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 32 | 0, Re(n, s, t, k, A + 28 | 0, A + 24 | 0, u), d0(u), r = p8(r, k, i[A + 28 >> 2], i[A + 24 >> 2], e, f), m = A + 112 | 0, r | 0;
                        }
                        function r9(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                if ((A | 0) != (r | 0)) {
                                    e = i[r + 4 >> 2];
                                    e: {
                                        if (!e) {
                                            e = 0;
                                            break e;
                                        }
                                        if (i[A + 8 >> 2] << 5 >>> 0 < e >>> 0) {
                                            if (f = i[A >> 2], f && (X(f), i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, e = i[r + 4 >> 2]), (e | 0) < 0) break i;
                                            e = (e - 1 >>> 5 | 0) + 1 | 0, f = D(e << 2), i[A + 8 >> 2] = e, i[A + 4 >> 2] = 0, i[A >> 2] = f, e = i[r + 4 >> 2];
                                        }
                                        if (f = i[r >> 2], k = (f + (e - 1 >>> 3 & 536870908) | 0) + 4 | 0, (k | 0) == (f | 0)) break e;
                                        Q0(i[A >> 2], f, k - f | 0), e = i[r + 4 >> 2];
                                    }
                                    i[A + 4 >> 2] = e;
                                }
                                return;
                            }
                            p0(), z();
                        }
                        function A9(A, r, e, f) {
                            var k = 0, n = 0;
                            i: {
                                if (f >>> 0 >= 3) {
                                    i[26064] = 28;
                                    break i;
                                }
                                e: {
                                    if ((f | 0) != 1 || (k = i[A + 8 >> 2], !k)) break e;
                                    n = r, k = k - i[A + 4 >> 2] | 0, r = r - k | 0, e = e - ((k >> 31) + (k >>> 0 > n >>> 0) | 0) | 0;
                                }
                                if (i[A + 20 >> 2] != i[A + 28 >> 2] && (p[i[A + 36 >> 2]](A, 0, 0), !i[A + 20 >> 2]) || (i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, p[i[A + 40 >> 2]](A, r, e, f), (w0 | 0) < 0)) break i;
                                return i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A >> 2] = i[A >> 2] & -17, 0;
                            }
                            return -1;
                        }
                        function Q8(A, r, e, f) {
                            var k = 0;
                            i: {
                                k = i[r + 104 >> 2], r = i[r + 108 >> 2];
                                e: {
                                    if ((k | 0) != (r | 0)) for(;;){
                                        if (!(i[k + 40 >> 2] != (e | 0) | i[k + 16 >> 2] != (f | 0))) {
                                            if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[k + 48 >> 2], e = i[k + 44 >> 2], (r | 0) == (e | 0)) break e;
                                            if (r = r - e | 0, (r | 0) < 0) break i;
                                            f = D(r), i[A >> 2] = f, k = r + f | 0, i[A + 8 >> 2] = k, v0(f, e, r), i[A + 4 >> 2] = k;
                                            return;
                                        }
                                        if (k = k + 56 | 0, (r | 0) == (k | 0)) break;
                                    }
                                    i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                }
                                return;
                            }
                            p0(), z();
                        }
                        function SW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (i[A >> 2] = 80464, n = i[A + 136 >> 2], n) {
                                if (r = n, e = i[A + 140 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        if (u = e - 12 | 0, f = i[u >> 2], f) {
                                            if (k = f, s = e - 8 | 0, r = i[s >> 2], (f | 0) != (r | 0)) {
                                                for(; k = r - 12 | 0, t = i[k >> 2], t && (i[r - 8 >> 2] = t, X(t)), r = k, (f | 0) != (r | 0););
                                                k = i[u >> 2];
                                            }
                                            i[s >> 2] = f, X(k);
                                        }
                                        if (e = e - 16 | 0, (n | 0) == (e | 0)) break;
                                    }
                                    r = i[A + 136 >> 2];
                                }
                                i[A + 140 >> 2] = n, X(r);
                            }
                            return V2(A) | 0;
                        }
                        function f9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            o[A + 44 | 0] = 1, o[A | 0] = 1, D5(A, r);
                            i: {
                                if ((e | 0) < 2) break i;
                                for(k = e - 1 | 0, t = A + 52 | 0; n = Z(f, 52) + t | 0, u = n, s = l0(r, 1), o[u | 0] = s, u = n, s = l0(r, 1), o[u + 44 | 0] = s, f = f + 1 | 0, (k | 0) != (f | 0););
                                if (e - 2 >>> 0 < 7) for(f = k; b8(r, 2), f = f + 1 | 0, (f | 0) != 8;);
                                if ((e | 0) < 2) break i;
                                for(A = A + 52 | 0, f = 0; D5(A + Z(f, 52) | 0, r), f = f + 1 | 0, (k | 0) != (f | 0););
                            }
                        }
                        function jW(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            if (i[A >> 2] = 80464, n = i[A + 136 >> 2], n) {
                                if (r = n, e = i[A + 140 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        if (u = e - 12 | 0, f = i[u >> 2], f) {
                                            if (k = f, s = e - 8 | 0, r = i[s >> 2], (f | 0) != (r | 0)) {
                                                for(; k = r - 12 | 0, t = i[k >> 2], t && (i[r - 8 >> 2] = t, X(t)), r = k, (f | 0) != (r | 0););
                                                k = i[u >> 2];
                                            }
                                            i[s >> 2] = f, X(k);
                                        }
                                        if (e = e - 16 | 0, (n | 0) == (e | 0)) break;
                                    }
                                    r = i[A + 136 >> 2];
                                }
                                i[A + 140 >> 2] = n, X(r);
                            }
                            X(V2(A));
                        }
                        function OW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, i[e + 12 >> 2] = k, p[i[i[r >> 2] + 48 >> 2]](f + 12 | 0, r, e, i[e + 4 >> 2] - (i[e >> 2] + k | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function $e(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = i[e + 16 >> 2];
                            i: {
                                if (!f) {
                                    if (gA(e)) break i;
                                    f = i[e + 16 >> 2];
                                }
                                if (k = i[e + 20 >> 2], f - k >>> 0 < r >>> 0) return p[i[e + 36 >> 2]](e, A, r) | 0;
                                e: {
                                    r: {
                                        if (!r | i[e + 80 >> 2] < 0) break r;
                                        for(f = r;;){
                                            if (n = A + f | 0, l[n - 1 | 0] != 10) {
                                                if (f = f - 1 | 0, f) continue;
                                                break r;
                                            }
                                            break;
                                        }
                                        if (k = p[i[e + 36 >> 2]](e, A, f) | 0, k >>> 0 < f >>> 0) break i;
                                        r = r - f | 0, k = i[e + 20 >> 2];
                                        break e;
                                    }
                                    n = A, f = 0;
                                }
                                v0(k, n, r), i[e + 20 >> 2] = i[e + 20 >> 2] + r, k = r + f | 0;
                            }
                            return k;
                        }
                        function PW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = n2(e), i[k + 100 >> 2] = n, k = r, n = n2(e), i[k + 104 >> 2] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function k9(A) {
                            var r = 0, e = 0, f = 0;
                            r = i[A + 8 >> 2], r && p[r | 0](), r = i[21679];
                            i: {
                                e: {
                                    if (!r) {
                                        e = 86716, f = 86716;
                                        break e;
                                    }
                                    for(;;){
                                        if (f = r, e = i[r + 16 >> 2], e >>> 0 > A >>> 0) {
                                            if (e = r, r = i[r >> 2], r) continue;
                                            break e;
                                        }
                                        if (A >>> 0 <= e >>> 0) break i;
                                        if (r = i[f + 4 >> 2], !r) break;
                                    }
                                    e = f + 4 | 0;
                                }
                                r = D(20), i[r + 8 >> 2] = f, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 16 >> 2] = A, i[e >> 2] = r, A = i[i[21678] >> 2], A && (i[21678] = A, r = i[e >> 2]), h4(i[21679], r), i[21680] = i[21680] + 1;
                            }
                        }
                        function LW(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = B2(e), Q[k + 98 >> 1] = n, k = r, n = B2(e), Q[k + 100 >> 1] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function n9(A, r) {
                            var e = 0, f = 0, k = 0;
                            e = i[r + 60 >> 2];
                            i: {
                                e: {
                                    if (e & 16) {
                                        f = i[r + 56 >> 2], e = i[r + 36 >> 2], f >>> 0 < e >>> 0 && (i[r + 56 >> 2] = e, f = e), r = r + 32 | 0;
                                        break e;
                                    }
                                    if (!(e & 8)) {
                                        r = 0, o[A + 11 | 0] = 0;
                                        break i;
                                    }
                                    f = i[r + 28 >> 2], r = r + 20 | 0;
                                }
                                e: {
                                    if (k = i[r >> 2], r = f - k | 0, r >>> 0 < 2147483640) {
                                        if (r >>> 0 >= 11) {
                                            f = (r | 7) + 1 | 0, e = D(f), i[A + 8 >> 2] = f | -2147483648, i[A >> 2] = e, i[A + 4 >> 2] = r, A = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = r, r) break e;
                                        r = 0;
                                        break i;
                                    }
                                    Y0(), z();
                                }
                                Q0(A, k, r);
                            }
                            o[A + r | 0] = 0;
                        }
                        function KW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = m - 32 | 0, m = r, f = i[e + 4 >> 2], k = i[e >> 2], i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f | (k | 0) != 2 || (o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 2, i[r + 24 >> 2] = 131074, o[r + 12 | 0] = 0, i[r + 4 >> 2] = 99, i[r + 8 >> 2] = 99, i[r + 16 >> 2] = 8, i[r + 20 >> 2] = 78668, o[r + 30 | 0] = 1, Q[r + 28 >> 1] = 6, i[r + 24 >> 2] = 851969, i[r + 4 >> 2] = 0, i[r + 8 >> 2] = 1, o[r + 12 | 0] = l[e + 8 | 0], i[r + 16 >> 2] = i[e + 12 >> 2], i[r >> 2] = 6, $2(A, r + 4 | 0, r)), m = r + 32 | 0;
                        }
                        function t9(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k, t = i[r + 48 >> 2], f = i[i[f >> 2] + 36 >> 2], e = i[i[e >> 2] + 36 >> 2], r = D(4), i[k + 4 >> 2] = r, n = r + 4 | 0, i[k + 12 >> 2] = n, i[r >> 2] = e, i[k + 8 >> 2] = n, J4(t, f, 1953000802, k + 4 | 0), r = i[k + 4 >> 2], r && (i[k + 8 >> 2] = r, X(r)), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = k + 16 | 0;
                        }
                        function qW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            for(var n = 0, t = 0, u = 0, s = 0, h = 0, w = 0;;){
                                i: {
                                    if ((e | 0) == (f | 0) | k >>> 0 <= s >>> 0) break i;
                                    u = 1, n = m - 16 | 0, m = n, i[n + 12 >> 2] = i[A + 8 >> 2], t = j4(n + 8 | 0, n + 12 | 0), h = _i(0, e, f - e | 0, r || 108224), t = i[t >> 2], t && (i[26106] = (t | 0) == -1 ? 104304 : t), m = n + 16 | 0;
                                    e: switch(h + 2 | 0){
                                        default:
                                            u = h;
                                            break;
                                        case 0:
                                        case 1:
                                            break i;
                                        case 2:
                                            break e;
                                    }
                                    s = s + 1 | 0, w = u + w | 0, e = e + u | 0;
                                    continue;
                                }
                                break;
                            }
                            return w | 0;
                        }
                        function $W(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            n = 2, t = f, r = i[r + 32 >> 2], k = 0;
                            i: {
                                if (l[r + 103 | 0] || (n = 0, f = l[r + 104 | 0], r = l[r + 105 | 0], k = 1, (f | 0) == 1 & (r | 0) == 1) || (f | 0) == 1 && (k = 2, !r)) break i;
                                k = r | f ? 99 : 3;
                            }
                            if (i[t >> 2] = k, i[e >> 2] = n, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function aW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = i[A + 24 >> 2], e >>> 0 > k0[A + 44 >> 2] && (i[A + 44 >> 2] = e);
                            i: {
                                if (e = i[A + 8 >> 2], f = i[A + 12 >> 2], e >>> 0 >= f >>> 0) break i;
                                if ((r | 0) == -1) return i[A + 16 >> 2] = i[A + 44 >> 2], i[A + 12 >> 2] = f - 1, i[A + 8 >> 2] = e, ((r | 0) != -1 ? r : 0) | 0;
                                if (f = i[A + 12 >> 2] - 1 | 0, !(l[A + 48 | 0] & 16) & l[f | 0] != (r & 255)) break i;
                                return e = i[A + 8 >> 2], i[A + 16 >> 2] = i[A + 44 >> 2], i[A + 12 >> 2] = f, i[A + 8 >> 2] = e, o[i[A + 12 >> 2]] = r << 24 >> 24, r | 0;
                            }
                            return -1;
                        }
                        function z1(A, r, e) {
                            var f = 0, k = 0;
                            f = m - 16 | 0, m = f, k = n2(e), i[r + 100 >> 2] = k & 16777215, o[r + 97 | 0] = k >>> 24, i[r + 32 >> 2] = i[r + 32 >> 2] + 4;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function bW(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            if ((e | 0) > 0) for(s = e & 2147483646, h = e & 1;;){
                                if (f = 0, k = 0, u = 0, (e | 0) != 1) for(; t = Z(e, f) + n | 0, k = Q[(t << 1) + r >> 1] + k | 0, i[(t << 2) + A >> 2] = k, t = Z(f | 1, e) + n | 0, k = k + Q[(t << 1) + r >> 1] | 0, i[(t << 2) + A >> 2] = k, f = f + 2 | 0, u = u + 2 | 0, (s | 0) != (u | 0););
                                if (h && (f = Z(e, f) + n | 0, i[(f << 2) + A >> 2] = Q[(f << 1) + r >> 1] + k), n = n + 1 | 0, (n | 0) == (e | 0)) break;
                            }
                        }
                        function dW(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, A = i[A >> 2], f = i[A + 48 >> 2], A = i[A + 52 >> 2];
                            i: {
                                if (!A) {
                                    q1(e + 8 | 0, f, r);
                                    break i;
                                }
                                if (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, q1(e + 8 | 0, f, r), r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            A = i[e + 8 >> 2], A ? A = l[A + 164 | 0] : A = 1, r = i[e + 12 >> 2];
                            i: {
                                if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = e + 16 | 0, A | 0;
                        }
                        function o9(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    if ((A | 0) != (r | 0)) {
                                        t = i[26064], i[26064] = 0, L2(), A = hi(A, k + 12 | 0, f, 0, -2147483648), f = w0, n = i[26064];
                                        r: {
                                            if (n) {
                                                if (i[k + 12 >> 2] != (r | 0)) break r;
                                                if ((n | 0) == 68) break e;
                                                break i;
                                            }
                                            if (i[26064] = t, i[k + 12 >> 2] == (r | 0)) break i;
                                        }
                                    }
                                    i[e >> 2] = 4, A = 0, f = 0;
                                    break i;
                                }
                                if (i[e >> 2] = 4, !!A & (f | 0) >= 0 | (f | 0) > 0) {
                                    A = -1, f = 2147483647;
                                    break i;
                                }
                                A = 0, f = -2147483648;
                            }
                            return m = k + 16 | 0, w0 = f, A;
                        }
                        function u9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 16 | 0, m = k, n = i[A + 4 >> 2], f = i[e >> 2] - i[A >> 2] | 0;
                            i: {
                                if (f >>> 0 < 2147483647) {
                                    f = f << 1;
                                    break i;
                                }
                                f = -1;
                            }
                            if (t = f >>> 0 <= 1 ? 1 : f, u = i[r >> 2], s = i[A >> 2], f = Ce((n | 0) != 1414 ? i[A >> 2] : 0, t), f) {
                                (n | 0) != 1414 && (i[A >> 2] = 0), i[k + 4 >> 2] = 1413, f = s1(k + 8 | 0, f, k + 4 | 0), qt(A, f), n = i[f >> 2], i[f >> 2] = 0, n && p[i[f + 4 >> 2]](n), i[r >> 2] = i[A >> 2] + (u - s | 0), i[e >> 2] = t + i[A >> 2], m = k + 16 | 0;
                                return;
                            }
                            w1(), z();
                        }
                        function o4(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (e = i[A + 16 >> 2], e >>> 0 < r >>> 0) {
                                if (e) {
                                    if (r = i[A + 8 >> 2], r) {
                                        for(; i[r + 16 >> 2] = i[r + 16 >> 2] - e, r = i[r + 8 >> 2], !!r;);
                                        e = i[A + 16 >> 2];
                                    }
                                    f = i[A >> 2], r = p[i[i[f >> 2] + 8 >> 2]](f) | 0, k = w0, r = r + e | 0, k = r >>> 0 < e >>> 0 ? k + 1 | 0 : k, p[i[i[f >> 2] + 20 >> 2]](f, r, k), i[A + 16 >> 2] = 0;
                                }
                                return o[A + 20 | 0] = 1, 0;
                            }
                            f = i[A + 8 >> 2];
                            i: {
                                if (f) {
                                    if (e = 0, !o4(f, r)) break i;
                                    e = i[A + 16 >> 2];
                                }
                                i[A + 16 >> 2] = e - r, e = 1;
                            }
                            return e;
                        }
                        function l9(A, r, e) {
                            var f = 0, k = 0, n = J(0), t = 0, u = J(0);
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        if ((A | 0) != (r | 0)) {
                                            if (t = i[26064], i[26064] = 0, L2(), f = m - 16 | 0, m = f, mA(f, A, k + 12 | 0, 0), n = K5(i[f >> 2], i[f + 4 >> 2], i[f + 8 >> 2], i[f + 12 >> 2]), m = f + 16 | 0, A = i[26064], !A) break r;
                                            if (i[k + 12 >> 2] != (r | 0)) break e;
                                            if (u = n, (A | 0) != 68) break i;
                                            break e;
                                        }
                                        i[e >> 2] = 4;
                                        break i;
                                    }
                                    if (i[26064] = t, i[k + 12 >> 2] == (r | 0)) break i;
                                }
                                i[e >> 2] = 4, n = u;
                            }
                            return m = k + 16 | 0, n;
                        }
                        function cW(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            return A = m - 144 | 0, m = A, i[A + 136 >> 2] = 37, i[A + 140 >> 2] = 0, n = A + 136 | 0, D8(n | 1, 8355, 1, i[e + 4 >> 2]), t = L2(), i[A >> 2] = k, k = A + 123 | 0, t = c1(k, 13, t, n, A) + k | 0, s = W4(k, t, e), u = A + 4 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 16 | 0, Je(n, s, t, k, A + 12 | 0, A + 8 | 0, u), d0(u), r = X8(r, k, i[A + 12 >> 2], i[A + 8 >> 2], e, f), m = A + 144 | 0, r | 0;
                        }
                        function iX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            return A = m - 144 | 0, m = A, i[A + 136 >> 2] = 37, i[A + 140 >> 2] = 0, n = A + 136 | 0, D8(n | 1, 8355, 0, i[e + 4 >> 2]), t = L2(), i[A >> 2] = k, k = A + 123 | 0, t = c1(k, 13, t, n, A) + k | 0, s = W4(k, t, e), u = A + 4 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 16 | 0, Je(n, s, t, k, A + 12 | 0, A + 8 | 0, u), d0(u), r = X8(r, k, i[A + 12 >> 2], i[A + 8 >> 2], e, f), m = A + 144 | 0, r | 0;
                        }
                        function C6(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0, s = 0;
                            k = m - 16 | 0, m = k, n = i[A + 4 >> 2], f = i[e >> 2] - i[A >> 2] | 0;
                            i: {
                                if (f >>> 0 < 2147483647) {
                                    f = f << 1;
                                    break i;
                                }
                                f = -1;
                            }
                            if (t = f || 4, u = i[r >> 2], s = i[A >> 2], f = Ce((n | 0) != 1414 ? i[A >> 2] : 0, t), f) {
                                (n | 0) != 1414 && (i[A >> 2] = 0), i[k + 4 >> 2] = 1413, f = s1(k + 8 | 0, f, k + 4 | 0), qt(A, f), n = i[f >> 2], i[f >> 2] = 0, n && p[i[f + 4 >> 2]](n), i[r >> 2] = i[A >> 2] + (u - s | 0), i[e >> 2] = i[A >> 2] + (t & -4), m = k + 16 | 0;
                                return;
                            }
                            w1(), z();
                        }
                        function s9(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            i: {
                                if (l[A + 46 | 0]) {
                                    if (n = 1, k = i[A + 48 >> 2], (k | 0) <= 0) break i;
                                    if (i[A + 8360 >> 2] != (r | 0)) {
                                        for(n = A + 8360 | 0;;){
                                            if (f = f + 1 | 0, (k | 0) == (f | 0)) break i;
                                            if (i[n + (f << 2) >> 2] == (r | 0)) break;
                                        }
                                        n = (f | 0) < (k | 0);
                                    }
                                    if (f = 0, r = i[A + 52 >> 2], (r | 0) > 0) for(k = A + 8404 | 0; A = i[k + (f << 2) >> 2] == (e | 0), !A && (f = f + 1 | 0, (r | 0) != (f | 0)););
                                    else A = 0;
                                    return A & n;
                                }
                                return !(r | e);
                            }
                            return 0;
                        }
                        function Ci(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            if (!e) return 0;
                            i: {
                                e: {
                                    r: {
                                        if (!A || (f = i[A >> 2], !f) || (A = i[f + 64 >> 2], !A)) break r;
                                        for(k = f - -64 | 0, f = k; n = i[A + 16 >> 2] < (r | 0), f = n ? f : A, A = i[(n << 2) + A >> 2], !!A;);
                                        if ((f | 0) == (k | 0)) break r;
                                        if (k = 0, A = 0, i[f + 16 >> 2] > (r | 0)) break e;
                                        if (A = 0, k = i[f + 52 >> 2], (k | 0) < 0) break i;
                                        A = i[f + 44 >> 2];
                                        break e;
                                    }
                                    k = 0, A = 0;
                                }
                                i[e >> 2] = k;
                            }
                            return A | 0;
                        }
                        function eX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            return A = m + -64 | 0, m = A, i[A + 56 >> 2] = 37, i[A + 60 >> 2] = 0, n = A + 56 | 0, D8(n | 1, 8355, 1, i[e + 4 >> 2]), t = L2(), i[A >> 2] = k, k = A + 43 | 0, t = c1(k, 13, t, n, A) + k | 0, s = W4(k, t, e), u = A + 4 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 16 | 0, Re(n, s, t, k, A + 12 | 0, A + 8 | 0, u), d0(u), r = p8(r, k, i[A + 12 >> 2], i[A + 8 >> 2], e, f), m = A - -64 | 0, r | 0;
                        }
                        function rX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0;
                            return A = m + -64 | 0, m = A, i[A + 56 >> 2] = 37, i[A + 60 >> 2] = 0, n = A + 56 | 0, D8(n | 1, 8355, 0, i[e + 4 >> 2]), t = L2(), i[A >> 2] = k, k = A + 43 | 0, t = c1(k, 13, t, n, A) + k | 0, s = W4(k, t, e), u = A + 4 | 0, n = i[e + 28 >> 2], i[u >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = k, k = A + 16 | 0, Re(n, s, t, k, A + 12 | 0, A + 8 | 0, u), d0(u), r = p8(r, k, i[A + 12 >> 2], i[A + 8 >> 2], e, f), m = A - -64 | 0, r | 0;
                        }
                        function n2(A) {
                            var r = 0, e = 0, f = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if (!o4(A, 4)) break i;
                                f = i[A >> 2], r = i[A + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                                e: {
                                    if (!(p[i[i[f >> 2] + 16 >> 2]](f, e + 12 | 0, 4) | 0)) {
                                        D4(A), f = 0;
                                        break e;
                                    }
                                    A = l[e + 12 | 0] | l[e + 13 | 0] << 8 | (l[e + 14 | 0] << 16 | l[e + 15 | 0] << 24), f = A << 24 | (A & 65280) << 8 | (A >>> 8 & 65280 | A >>> 24);
                                }
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = e + 16 | 0, f;
                        }
                        function h9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k;
                            i: {
                                e: {
                                    r: {
                                        if ((A | 0) != (r | 0)) {
                                            if (t = i[26064], i[26064] = 0, L2(), f = m - 16 | 0, m = f, mA(f, A, k + 12 | 0, 1), n = J3(i[f >> 2], i[f + 4 >> 2], i[f + 8 >> 2], i[f + 12 >> 2]), m = f + 16 | 0, A = i[26064], !A) break r;
                                            if (i[k + 12 >> 2] != (r | 0)) break e;
                                            if (u = n, (A | 0) != 68) break i;
                                            break e;
                                        }
                                        i[e >> 2] = 4;
                                        break i;
                                    }
                                    if (i[26064] = t, i[k + 12 >> 2] == (r | 0)) break i;
                                }
                                i[e >> 2] = 4, n = u;
                            }
                            return m = k + 16 | 0, n;
                        }
                        function AX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = Z(X2(e) & 3, 90), i[k + 100 >> 2] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function fX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            f = -1, r = i[A + 24 >> 2], A = i[A + 28 >> 2];
                            i: {
                                if ((r | 0) == (A | 0)) break i;
                                for(;;){
                                    e: {
                                        r: {
                                            if (e = i[r >> 2], !e || (e = E0(e, 73632, 82328), !e)) break r;
                                            if (A = i[r + 4 >> 2], A) break e;
                                            return l[e + 104 | 0];
                                        }
                                        if (r = r + 8 | 0, (A | 0) != (r | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (r = i[A + 4 >> 2], k = r + 1 | 0, i[A + 4 >> 2] = k, f = l[e + 104 | 0], i[A + 4 >> 2] = r, k) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return f | 0;
                        }
                        function kX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                if (f && (A = 0, (k | 0) <= 0)) break i;
                                Ue(n + 4 | 0, r, e), t = i[n + 8 >> 2], e = i[n + 4 >> 2], r = t - e >> 2;
                                e: {
                                    r: {
                                        if (!f) {
                                            A = r;
                                            break r;
                                        }
                                        if (A = 0, (e | 0) == (t | 0) | (k | 0) <= 0) break r;
                                        for(;;){
                                            if (t = A << 2, i[t + f >> 2] = i[e + t >> 2], A = A + 1 | 0, (k | 0) <= (A | 0)) break e;
                                            if (!(A >>> 0 < r >>> 0)) break;
                                        }
                                        break e;
                                    }
                                    if (!e) break i;
                                }
                                X(e);
                            }
                            return m = n + 16 | 0, A | 0;
                        }
                        function nX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = le() | 0;
                            i: {
                                if (!r) {
                                    i[A + 4 >> 2] = k, i[A >> 2] = 104328;
                                    break i;
                                }
                                R3(f + 8 | 0, r, e, f + 20 | 0);
                                e: {
                                    if (i[f + 8 >> 2]) {
                                        r = D(12), i[r + 8 >> 2] = i[f + 16 >> 2], e = i[f + 12 >> 2], i[r >> 2] = i[f + 8 >> 2], i[r + 4 >> 2] = e, i[f + 24 >> 2] = r, r = U1(79596, f + 24 | 0) | 0;
                                        break e;
                                    }
                                    i[f + 24 >> 2] = i[f + 20 >> 2], r = U1(79664, f + 24 | 0) | 0;
                                }
                                if (i[A + 4 >> 2] = r, i[A >> 2] = 104328, k >>> 0 < 9) break i;
                                t1(k | 0);
                            }
                            m = f + 32 | 0;
                        }
                        function tX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            return A = m - 208 | 0, m = A, n = L2(), i[A >> 2] = k, t = A + 176 | 0, s = c1(t, 20, n, 6550, A), u = t + s | 0, h = W4(t, u, e), k = A + 16 | 0, n = i[e + 28 >> 2], i[k >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = K0(k, 108572), d0(k), p[i[i[n >> 2] + 48 >> 2]](n, t, u, k), n = r, r = k + (s << 2) | 0, r = X8(n, k, (u | 0) == (h | 0) ? r : ((h - A << 2) + A | 0) - 688 | 0, r, e, f), m = A + 208 | 0, r | 0;
                        }
                        function nA(A) {
                            var r = 0, e = 0, f = 0;
                            f = m - 16 | 0, m = f, I2(+A), e = c0(1) | 0, c0(0), e = e & 2147483647;
                            i: {
                                if (e >>> 0 <= 1072243195) {
                                    if (r = 1, e >>> 0 < 1044816030) break i;
                                    r = Ri(A, 0);
                                    break i;
                                }
                                if (r = A - A, e >>> 0 >= 2146435072) break i;
                                e = N7(A, f), A = n0[f + 8 >> 3], r = n0[f >> 3];
                                e: switch((e & 3) - 1 | 0){
                                    default:
                                        r = Ri(r, A);
                                        break i;
                                    case 0:
                                        r = -yi(r, A, 1);
                                        break i;
                                    case 1:
                                        r = -Ri(r, A);
                                        break i;
                                    case 2:
                                        break e;
                                }
                                r = yi(r, A, 1);
                            }
                            return m = f + 16 | 0, r;
                        }
                        function oX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            f = m - 32 | 0, m = f, k = f + 12 | 0, v4(k, i[A + 20 >> 2], i[i[A + 384 >> 2] >> 2], 1), A = i[f + 16 >> 2], n = k, k = i[f + 12 >> 2], p[i[i[k >> 2] + 20 >> 2]](n, k), n = i[f + 12 >> 2], o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), n && (i[e >> 2] = 0, i[r >> 2] = 0), i[r >> 2] = i[k + 40 >> 2], i[e >> 2] = i[k + 44 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            m = f + 32 | 0;
                        }
                        function uX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = X2(e) & 1, i[k + 100 >> 2] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function tA(A) {
                            var r = 0, e = 0, f = 0;
                            e = m - 16 | 0, m = e, I2(+A), r = c0(1) | 0, c0(0), r = r & 2147483647;
                            i: {
                                if (r >>> 0 <= 1072243195) {
                                    if (r >>> 0 < 1045430272) break i;
                                    A = yi(A, 0, 0);
                                    break i;
                                }
                                if (r >>> 0 >= 2146435072) {
                                    A = A - A;
                                    break i;
                                }
                                r = N7(A, e), A = n0[e + 8 >> 3], f = n0[e >> 3];
                                e: switch((r & 3) - 1 | 0){
                                    default:
                                        A = yi(f, A, 1);
                                        break i;
                                    case 0:
                                        A = Ri(f, A);
                                        break i;
                                    case 1:
                                        A = -yi(f, A, 1);
                                        break i;
                                    case 2:
                                        break e;
                                }
                                A = -Ri(f, A);
                            }
                            return m = e + 16 | 0, A;
                        }
                        function lX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = m - 32 | 0, m = e, f = le() | 0;
                            i: {
                                if (!r) {
                                    i[A + 4 >> 2] = f, i[A >> 2] = 104328;
                                    break i;
                                }
                                U5(e + 8 | 0, r, e + 20 | 0);
                                e: {
                                    if (i[e + 8 >> 2]) {
                                        r = D(12), i[r + 8 >> 2] = i[e + 16 >> 2], k = i[e + 12 >> 2], i[r >> 2] = i[e + 8 >> 2], i[r + 4 >> 2] = k, i[e + 24 >> 2] = r, r = U1(79596, e + 24 | 0) | 0;
                                        break e;
                                    }
                                    i[e + 24 >> 2] = i[e + 20 >> 2], r = U1(79664, e + 24 | 0) | 0;
                                }
                                if (i[A + 4 >> 2] = r, i[A >> 2] = 104328, f >>> 0 < 9) break i;
                                t1(f | 0);
                            }
                            m = e + 32 | 0;
                        }
                        function sX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = B2(e), Q[k + 98 >> 1] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function hX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = r, n = X2(e), o[k + 97 | 0] = n;
                            i: {
                                if (l[e + 20 | 0] == 1) {
                                    if (o[f + 4 | 0] = 0, o[f + 15 | 0] = 0, i0(A, 2, 100, f + 4 | 0), o[f + 15 | 0] >= 0) break i;
                                    X(i[f + 4 >> 2]);
                                    break i;
                                }
                                if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 16 | 0;
                        }
                        function w9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            return k = m - 16 | 0, m = k, f = m - 32 | 0, m = f, yt(f + 24 | 0, A, r), Vt(f + 16 | 0, i[f + 24 >> 2], i[f + 28 >> 2], e), t = i[f + 16 >> 2], r = m - 16 | 0, m = r, i[r + 12 >> 2] = A, A = m - 16 | 0, m = A, n = r + 12 | 0, i[A + 12 >> 2] = i[n >> 2], m = A + 16 | 0, A = xA(n, t - i[A + 12 >> 2] >> 2), m = r + 16 | 0, i[f + 12 >> 2] = A, i[f + 8 >> 2] = (i[f + 20 >> 2] - e | 0) + e, i[k + 8 >> 2] = i[f + 12 >> 2], i[k + 12 >> 2] = i[f + 8 >> 2], m = f + 32 | 0, m = k + 16 | 0, i[k + 12 >> 2];
                        }
                        function wX(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0, s = 0, h = 0;
                            return A = m - 96 | 0, m = A, n = L2(), i[A >> 2] = k, t = A - -64 | 0, s = c1(t, 20, n, 6550, A), u = t + s | 0, h = W4(t, u, e), k = A + 16 | 0, n = i[e + 28 >> 2], i[k >> 2] = n, (n | 0) != 108396 && (i[n + 4 >> 2] = i[n + 4 >> 2] + 1), n = K0(k, 108580), d0(k), p[i[i[n >> 2] + 32 >> 2]](n, t, u, k), n = r, r = k + s | 0, r = p8(n, k, (u | 0) == (h | 0) ? r : ((h - A | 0) + A | 0) - 48 | 0, r, e, f), m = A + 96 | 0, r | 0;
                        }
                        function v9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            return k = m - 16 | 0, m = k, f = m - 32 | 0, m = f, yt(f + 24 | 0, A, r), It(f + 16 | 0, i[f + 24 >> 2], i[f + 28 >> 2], e), t = i[f + 16 >> 2], r = m - 16 | 0, m = r, i[r + 12 >> 2] = A, A = m - 16 | 0, m = A, n = r + 12 | 0, i[A + 12 >> 2] = i[n >> 2], m = A + 16 | 0, A = SA(n, t - i[A + 12 >> 2] | 0), m = r + 16 | 0, i[f + 12 >> 2] = A, i[f + 8 >> 2] = (i[f + 20 >> 2] - e | 0) + e, i[k + 8 >> 2] = i[f + 12 >> 2], i[k + 12 >> 2] = i[f + 8 >> 2], m = f + 32 | 0, m = k + 16 | 0, i[k + 12 >> 2];
                        }
                        function ae(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            n = m - 32 | 0, m = n, i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, k = i[r + 32 >> 2];
                            i: {
                                if (r = i[r + 28 >> 2], (k | 0) != (r | 0)) {
                                    if (e = k - r | 0, (e | 0) < 0) break i;
                                    for(f = D(e), i[A + 4 >> 2] = f, i[A >> 2] = f, i[A + 8 >> 2] = f + e; i[f >> 2] = i[r >> 2], e = i[r + 4 >> 2], i[f + 4 >> 2] = e, e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), f = f + 8 | 0, r = r + 8 | 0, (k | 0) != (r | 0););
                                    i[A + 4 >> 2] = f;
                                }
                                m = n + 32 | 0;
                                return;
                            }
                            p0(), z();
                        }
                        function be(A, r, e) {
                            var f = 0, k = 0;
                            for(e & 2048 && (o[A | 0] = 43, A = A + 1 | 0), e & 1024 && (o[A | 0] = 35, A = A + 1 | 0), f = e & 260, (f | 0) != 260 && (o[A | 0] = 46, o[A + 1 | 0] = 42, A = A + 2 | 0), e = e & 16384;;){
                                if (k = l[r | 0], k) {
                                    o[A | 0] = k, A = A + 1 | 0, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            i: {
                                e: {
                                    if ((f | 0) != 256) {
                                        if ((f | 0) != 4) break e;
                                        r = e ? 70 : 102;
                                        break i;
                                    }
                                    r = e ? 69 : 101;
                                    break i;
                                }
                                if (r = e ? 65 : 97, (f | 0) == 260) break i;
                                r = e ? 71 : 103;
                            }
                            return o[A | 0] = r, (f | 0) != 260;
                        }
                        function V6(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            f = i[A + 128 >> 2];
                            i: {
                                if (!f) break i;
                                for(k = A + 128 | 0, A = k; e = k0[f + 16 >> 2] < r >>> 0, A = e ? A : f, f = i[(e << 2) + f >> 2], !!f;);
                                if ((A | 0) == (k | 0) | k0[A + 16 >> 2] > r >>> 0 || (r = i[A + 20 >> 2], e = i[A + 24 >> 2], e && (i[e + 4 >> 2] = i[e + 4 >> 2] + 1), n = r ? i[r + 112 >> 2] : 0, !e) || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            return n;
                        }
                        function _9(A) {
                            var r = 0;
                            i: {
                                e: {
                                    r: {
                                        A: {
                                            f: {
                                                if ((A | 0) <= 1785750886) {
                                                    if ((A | 0) == 1635135537) break A;
                                                    if ((A | 0) == 1752589105) break f;
                                                    if ((A | 0) != 1781689137) break e;
                                                    return 7;
                                                }
                                                if ((A | 0) <= 1970168680) {
                                                    if (r = 3, (A | 0) == 1785750887) break i;
                                                    if ((A | 0) != 1836280681) break e;
                                                    return 9;
                                                }
                                                if ((A | 0) == 1970168681) break r;
                                                if ((A | 0) != 1987470129) break e;
                                                return 5;
                                            }
                                            return 1;
                                        }
                                        return 4;
                                    }
                                    return 8;
                                }
                                r = 0;
                            }
                            return r;
                        }
                        function vX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            n = m - 16 | 0, m = n;
                            i: {
                                if ((f | 0) <= 0 && e) break i;
                                Ue(n + 4 | 0, A, r), t = i[n + 8 >> 2], r = i[n + 4 >> 2], A = t - r >> 2;
                                e: {
                                    r: {
                                        if (!e) {
                                            k = A;
                                            break r;
                                        }
                                        if ((r | 0) == (t | 0) | (f | 0) <= 0) break r;
                                        for(;;){
                                            if (t = k << 2, i[t + e >> 2] = i[r + t >> 2], k = k + 1 | 0, (k | 0) >= (f | 0)) break e;
                                            if (!(A >>> 0 > k >>> 0)) break;
                                        }
                                        break e;
                                    }
                                    if (!r) break i;
                                }
                                X(r);
                            }
                            return m = n + 16 | 0, k | 0;
                        }
                        function _X(A, r, e, f, k) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, Y1(A, i[r + 8 >> 2], k)) {
                                i[r + 28 >> 2] == 1 | i[r + 4 >> 2] != (e | 0) || (i[r + 28 >> 2] = f);
                                return;
                            }
                            i: {
                                if (!Y1(A, i[r >> 2], k)) break i;
                                if (!(i[r + 16 >> 2] != (e | 0) & i[r + 20 >> 2] != (e | 0))) {
                                    if ((f | 0) != 1) break i;
                                    i[r + 32 >> 2] = 1;
                                    return;
                                }
                                i[r + 20 >> 2] = e, i[r + 32 >> 2] = f, i[r + 40 >> 2] = i[r + 40 >> 2] + 1, i[r + 36 >> 2] != 1 | i[r + 24 >> 2] != 2 || (o[r + 54 | 0] = 1), i[r + 44 >> 2] = 4;
                            }
                        }
                        function BX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            k = m - 32 | 0, m = k, z1(k + 12 | 0, r, e), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]);
                            i: {
                                if (!l[r + 97 | 0]) {
                                    n = B2(e);
                                    break i;
                                }
                                n = n2(e);
                            }
                            i: {
                                if (!n) {
                                    if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                        r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                        break i;
                                    }
                                    j(A, i[21670], i[21671]);
                                    break i;
                                }
                                Ze(A, r, e, n, f);
                            }
                            m = k + 32 | 0;
                        }
                        function mX(A) {
                            return A = A | 0, l[108664] ? i[27165] : (l[109144] || (o[109144] = 1), x2(108976, 70884), x2(108988, 70912), x2(109e3, 70940), x2(109012, 70972), x2(109024, 71012), x2(109036, 71048), x2(109048, 71076), x2(109060, 71112), x2(109072, 71128), x2(109084, 71144), x2(109096, 71160), x2(109108, 71176), x2(109120, 71192), x2(109132, 71208), o[108664] = 1, i[27165] = 108976, 108976);
                        }
                        function ZX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, P8(r, i[A + 20 >> 2], i[A + 36 >> 2], r + 20 | 0), e = -1;
                            i: {
                                if (i[r >> 2] || (v4(r + 24 | 0, i[A + 20 >> 2], i[r + 20 >> 2], 1), A = i[r + 28 >> 2], e = i[r + 24 >> 2], e ? e = p[i[i[e >> 2] + 40 >> 2]](e) | 0 : e = -1, !A) || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), m = r + 32 | 0, e | 0;
                        }
                        function oA(A) {
                            var r = 0, e = 0, f = 0;
                            if (r = i[A + 24 >> 2], A = i[A + 28 >> 2], (r | 0) == (A | 0)) return 0;
                            i: {
                                for(;;){
                                    e: {
                                        if (e = i[r >> 2], !e || (e = E0(e, 73632, 73656), !e)) break e;
                                        if (A = i[r + 4 >> 2], A) break i;
                                        return i[e + 104 >> 2];
                                    }
                                    if (r = r + 8 | 0, (A | 0) == (r | 0)) break;
                                }
                                return 0;
                            }
                            return r = i[A + 4 >> 2], f = r + 1 | 0, i[A + 4 >> 2] = f, e = i[e + 104 >> 2], i[A + 4 >> 2] = r, f || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), e;
                        }
                        function uA(A) {
                            var r = 0, e = 0, f = 0;
                            if (r = i[A + 24 >> 2], A = i[A + 28 >> 2], (r | 0) == (A | 0)) return 0;
                            i: {
                                for(;;){
                                    e: {
                                        if (e = i[r >> 2], !e || (e = E0(e, 73632, 73656), !e)) break e;
                                        if (A = i[r + 4 >> 2], A) break i;
                                        return i[e + 108 >> 2];
                                    }
                                    if (r = r + 8 | 0, (A | 0) == (r | 0)) break;
                                }
                                return 0;
                            }
                            return r = i[A + 4 >> 2], f = r + 1 | 0, i[A + 4 >> 2] = f, e = i[e + 108 >> 2], i[A + 4 >> 2] = r, f || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), e;
                        }
                        function B9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, P8(r, i[A + 20 >> 2], i[A + 36 >> 2], r + 20 | 0), e = -1;
                            i: {
                                if (i[r >> 2] || (v4(r + 24 | 0, i[A + 20 >> 2], i[r + 20 >> 2], 1), A = i[r + 28 >> 2], e = i[r + 24 >> 2], e ? e = p[i[i[e >> 2] + 36 >> 2]](e) | 0 : e = -1, !A) || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), m = r + 32 | 0, e | 0;
                        }
                        function m9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            for(i[A >> 2] = 65208, k = A + 8 | 0;;){
                                if (r = i[A + 8 >> 2], i[A + 12 >> 2] - r >> 2 >>> 0 > e >>> 0) {
                                    r = i[r + (e << 2) >> 2], r && (f = i[r + 4 >> 2] - 1 | 0, i[r + 4 >> 2] = f, (f | 0) == -1 && p[i[i[r >> 2] + 8 >> 2]](r)), e = e + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return a0(A + 144 | 0), r = m - 16 | 0, m = r, i[r + 12 >> 2] = k, e = i[r + 12 >> 2], i[e >> 2] && (su(e), Ao(i[r + 12 >> 2] + 12 | 0, i[i[r + 12 >> 2] >> 2])), m = r + 16 | 0, A | 0;
                        }
                        function GX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m + -64 | 0, m = f, k = 1;
                            i: {
                                if (Y1(A, r, 0) || (k = 0, !r) || (r = E0(r, 72044, 72092), k = 0, !r)) break i;
                                B0(f + 8 | 0, 0, 56), o[f + 59 | 0] = 1, i[f + 16 >> 2] = -1, i[f + 12 >> 2] = A, i[f + 4 >> 2] = r, i[f + 52 >> 2] = 1, p[i[i[r >> 2] + 28 >> 2]](r, f + 4 | 0, i[e >> 2], 1), A = i[f + 28 >> 2], (A | 0) == 1 && (i[e >> 2] = i[f + 20 >> 2]), k = (A | 0) == 1;
                            }
                            return A = k, m = f - -64 | 0, A | 0;
                        }
                        function WX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            e = A + 12 | 0, r = i[e + 8496 >> 2], r && (i[e + 8500 >> 2] = r, X(r)), r = i[e + 8484 >> 2], r && (i[e + 8488 >> 2] = r, X(r)), r = i[e + 8472 >> 2], r && (i[e + 8476 >> 2] = r, X(r)), r = i[e + 8460 >> 2], r && (i[e + 8464 >> 2] = r, X(r)), r = i[e + 8448 >> 2], r && (i[e + 8452 >> 2] = r, X(r)), A = i[A + 20 >> 2];
                            i: {
                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function XX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            return k = i[A + 84 >> 2], n = i[k >> 2], f = i[k + 4 >> 2], u = i[A + 28 >> 2], t = i[A + 20 >> 2] - u | 0, t = f >>> 0 < t >>> 0 ? f : t, t && (v0(n, u, t), n = t + i[k >> 2] | 0, i[k >> 2] = n, f = i[k + 4 >> 2] - t | 0, i[k + 4 >> 2] = f), f = e >>> 0 > f >>> 0 ? f : e, f && (v0(n, r, f), n = f + i[k >> 2] | 0, i[k >> 2] = n, i[k + 4 >> 2] = i[k + 4 >> 2] - f), o[n | 0] = 0, r = i[A + 44 >> 2], i[A + 28 >> 2] = r, i[A + 20 >> 2] = r, e | 0;
                        }
                        function lA(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 48 | 0, m = k, n = i[i[A >> 2] - 12 >> 2] + A | 0, t = i[n + 16 >> 2] & -3, N1(n, t), EA(k + 47 | 0, A), l[k + 47 | 0] && (n = k + 24 | 0, u = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], p[i[i[u >> 2] + 16 >> 2]](n, u, r, e, f, 8), r = k + 8 | 0, i[r + 8 >> 2] = -1, i[r + 12 >> 2] = -1, i[r >> 2] = 0, i[r + 4 >> 2] = 0, M4(i[i[A >> 2] - 12 >> 2] + A | 0, i[r + 8 >> 2] == i[n + 8 >> 2] & i[n + 12 >> 2] == i[r + 12 >> 2] ? t | 4 : t)), m = k + 48 | 0;
                        }
                        function x2(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                if (f = uo(r), e = l[A + 11 | 0] >>> 7 | 0 ? (i[A + 8 >> 2] & 2147483647) - 1 | 0 : 1, l[A + 11 | 0] >>> 7 | 0 ? k = i[A + 4 >> 2] : k = l[A + 11 | 0] & 127, f >>> 0 <= e >>> 0) {
                                    l[A + 11 | 0] >>> 7 | 0 ? e = i[A >> 2] : e = A, Lo(e, r, f), r = m - 16 | 0, m = r;
                                    e: if (l[A + 11 | 0] >>> 7 | 0) break e;
                                    f6(A, f), i[r + 12 >> 2] = 0, i[e + (f << 2) >> 2] = i[r + 12 >> 2], m = r + 16 | 0;
                                    break i;
                                }
                                hn(A, e, f - e | 0, k, 0, k, f, r);
                            }
                        }
                        function pX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((e | 0) != 31) for(w = e + 5 | 0, s = 1 << e;;){
                                for(v = A + t | 0, _ = (t << 1) + r | 0, k = 0, u = 0; u = ((Q[(k << e << 1) + _ >> 1] << w) + 2048 >> 12) + u | 0, h = Z(f, k) + v | 0, n = u + l[h | 0] | 0, n = (n | 0) >= 255 ? 255 : n, o[h | 0] = (n | 0) > 0 ? n : 0, k = k + 1 | 0, (s | 0) != (k | 0););
                                if (t = t + 1 | 0, (s | 0) == (t | 0)) break;
                            }
                        }
                        function QX(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0, w = 0, v = 0, _ = 0;
                            if ((e | 0) != 31) for(w = e + 5 | 0, s = 1 << e;;){
                                for(v = Z(f, t) + A | 0, _ = (t << e << 1) + r | 0, k = 0, u = 0; u = ((Q[(k << 1) + _ >> 1] << w) + 2048 >> 12) + u | 0, h = k + v | 0, n = u + l[h | 0] | 0, n = (n | 0) >= 255 ? 255 : n, o[h | 0] = (n | 0) > 0 ? n : 0, k = k + 1 | 0, (s | 0) != (k | 0););
                                if (t = t + 1 | 0, (s | 0) == (t | 0)) break;
                            }
                        }
                        function sA(A) {
                            var r = 0, e = 0;
                            if (r = m - 16 | 0, m = r, i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2]) {
                                i[r + 12 >> 2] = A, o[r + 8 | 0] = 0, i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 16 >> 2] || (e = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 72 >> 2], e && sA(e), o[r + 8 | 0] = 1);
                                i: {
                                    if (!l[r + 8 | 0] || (e = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], (p[i[i[e >> 2] + 24 >> 2]](e) | 0) != -1)) break i;
                                    M4(i[i[A >> 2] - 12 >> 2] + A | 0, 1);
                                }
                                G1(r + 8 | 0);
                            }
                            m = r + 16 | 0;
                        }
                        function hA(A, r, e, f) {
                            o[A + 53 | 0] = 1;
                            i: {
                                if (i[A + 4 >> 2] != (e | 0)) break i;
                                o[A + 52 | 0] = 1, e = i[A + 16 >> 2];
                                e: {
                                    if (!e) {
                                        if (i[A + 36 >> 2] = 1, i[A + 24 >> 2] = f, i[A + 16 >> 2] = r, (f | 0) != 1) break i;
                                        if (i[A + 48 >> 2] == 1) break e;
                                        break i;
                                    }
                                    if ((r | 0) == (e | 0)) {
                                        if (e = i[A + 24 >> 2], (e | 0) == 2 && (i[A + 24 >> 2] = f, e = f), i[A + 48 >> 2] != 1) break i;
                                        if ((e | 0) == 1) break e;
                                        break i;
                                    }
                                    i[A + 36 >> 2] = i[A + 36 >> 2] + 1;
                                }
                                o[A + 54 | 0] = 1;
                            }
                        }
                        function CX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            if (A) {
                                r = i[A + 20 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = i[A + 12 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = i[A + 4 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                X(A);
                            }
                        }
                        function T1(A, r) {
                            i: {
                                if ((r | 0) >= 1024) {
                                    if (A = A * 898846567431158e293, r >>> 0 < 2047) {
                                        r = r - 1023 | 0;
                                        break i;
                                    }
                                    A = A * 898846567431158e293, r = (r >>> 0 >= 3069 ? 3069 : r) - 2046 | 0;
                                    break i;
                                }
                                if ((r | 0) > -1023) break i;
                                if (A = A * 2004168360008973e-307, r >>> 0 > 4294965304) {
                                    r = r + 969 | 0;
                                    break i;
                                }
                                A = A * 2004168360008973e-307, r = (r >>> 0 <= 4294964336 ? -2960 : r) + 1938 | 0;
                            }
                            return J2(0, 0), J2(1, r + 1023 << 20), A * +o1();
                        }
                        function VX(A) {
                            return A = A | 0, l[108656] ? i[27163] : (l[108968] || (o[108968] = 1), z2(108800, 1621), z2(108812, 1628), z2(108824, 1594), z2(108836, 1602), z2(108848, 1585), z2(108860, 1635), z2(108872, 1612), z2(108884, 6591), z2(108896, 7461), z2(108908, 9956), z2(108920, 14588), z2(108932, 2804), z2(108944, 8715), z2(108956, 3878), o[108656] = 1, i[27163] = 108800, 108800);
                        }
                        function yX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            A = i[A >> 2], e = i[A + 48 >> 2], A = i[A + 52 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), f = i[e + 28 >> 2], e = i[e + 32 >> 2];
                            i: {
                                if (!e) {
                                    m4(f, r);
                                    break i;
                                }
                                if (i[e + 4 >> 2] = i[e + 4 >> 2] + 1, m4(f, r), r = i[e + 4 >> 2], i[e + 4 >> 2] = r - 1, r) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function IX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            if (f = m - 16 | 0, m = f, k = i[e >> 2], k >>> 0 < 2147483640) {
                                t = i[A >> 2];
                                i: {
                                    e: {
                                        if (k >>> 0 >= 11) {
                                            n = (k | 7) + 1 | 0, A = D(n), i[f + 12 >> 2] = n | -2147483648, i[f + 4 >> 2] = A, i[f + 8 >> 2] = k;
                                            break e;
                                        }
                                        if (o[f + 15 | 0] = k, A = f + 4 | 0, !k) break i;
                                    }
                                    v0(A, e + 4 | 0, k);
                                }
                                o[A + k | 0] = 0, p[t | 0](r, f + 4 | 0), o[f + 15 | 0] < 0 && X(i[f + 4 >> 2]), m = f + 16 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Z9(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            f = A + 18548 | 0, e = s2(f, i[A + 18572 >> 2] + 150 | 0), k = 1, n = s2(f, i[A + 18572 >> 2] + 150 | 0), t = 1, e && (t = !s2(f, i[A + 18572 >> 2] + 151 | 0)), n && (k = !s2(f, i[A + 18572 >> 2] + 151 | 0)), e && (e = -1, t || (e = T3(f, 1)), u = S1(f) ? 65534 - e | 0 : e + 2 | 0), r = (r << 2) + A | 0, n ? (e = -1, k || (e = T3(f, 1)), A = S1(f) ? 65534 - e | 0 : e + 2 | 0) : A = 0, Q[r + 20 >> 1] = A, Q[r + 18 >> 1] = u;
                        }
                        function FX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            if (e = m - 16 | 0, m = e, I5(e + 4 | 0, i[A >> 2], r), k = i[e + 8 >> 2], r = i[e + 4 >> 2], r) {
                                if (A = r, (r | 0) != (k | 0)) {
                                    for(A = k;;){
                                        f = i[A - 4 >> 2];
                                        i: {
                                            if (!f || (n = i[f + 4 >> 2], i[f + 4 >> 2] = n - 1, n)) break i;
                                            p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                                        }
                                        if (A = A - 8 | 0, (r | 0) == (A | 0)) break;
                                    }
                                    A = i[e + 4 >> 2];
                                }
                                i[e + 8 >> 2] = r, X(A);
                            }
                            return m = e + 16 | 0, k - r >> 3;
                        }
                        function YX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, P8(r, i[A + 20 >> 2], i[A + 36 >> 2], r + 20 | 0), e = -1;
                            i: {
                                if (i[r >> 2] || (v4(r + 24 | 0, i[A + 20 >> 2], i[r + 20 >> 2], 1), A = i[r + 28 >> 2], e = i[r + 24 >> 2], e = p[i[i[e >> 2] + 36 >> 2]](e) | 0, !A) || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), m = r + 32 | 0, e | 0;
                        }
                        function G9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 32 | 0, m = r, P8(r, i[A + 20 >> 2], i[A + 36 >> 2], r + 20 | 0), e = -1;
                            i: {
                                if (i[r >> 2] || (v4(r + 24 | 0, i[A + 20 >> 2], i[r + 20 >> 2], 1), A = i[r + 28 >> 2], e = i[r + 24 >> 2], e = p[i[i[e >> 2] + 40 >> 2]](e) | 0, !A) || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return o[r + 19 | 0] < 0 && X(i[r + 8 >> 2]), m = r + 32 | 0, e | 0;
                        }
                        function wA(A) {
                            var r = 0, e = 0, f = 0;
                            r = i[A + 12 >> 2] - 2 | 0, i[A + 12 >> 2] = r, f = 1, e = i[A + 16 >> 2], r = r << 7;
                            i: {
                                if (e >>> 0 >= r >>> 0 || (f = 0, r >>> 0 > 32767) || (e = e << 1, i[A + 16 >> 2] = e, i[A + 12 >> 2] = r >>> 6, r = I[A + 20 >> 1] + 1 | 0, Q[A + 20 >> 1] = r, (r | 0) == (r & 65535)) || (Q[A + 20 >> 1] = 65528, r = i[A + 4 >> 2], r >>> 0 >= k0[A + 8 >> 2])) break i;
                                i[A + 4 >> 2] = r + 1, i[A + 16 >> 2] = e + l[r | 0];
                            }
                            return f;
                        }
                        function W9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0;
                            r = m - 16 | 0, m = r, k = r + 16 | 0;
                            i: {
                                for(;;){
                                    if (f = i[A + 36 >> 2], e = r + 8 | 0, n = p[i[i[f >> 2] + 20 >> 2]](f, i[A + 40 >> 2], e, k, r + 4 | 0) | 0, f = -1, t = e, e = i[r + 4 >> 2] - e | 0, (E1(t, 1, e, i[A + 32 >> 2]) | 0) != (e | 0)) break i;
                                    e: switch(n - 1 | 0){
                                        case 1:
                                            break i;
                                        case 0:
                                            continue;
                                        default:
                                            break e;
                                    }
                                    break;
                                }
                                f = R8(i[A + 32 >> 2]) ? -1 : 0;
                            }
                            return m = r + 16 | 0, f | 0;
                        }
                        function EX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            if (f = m - 128 | 0, m = f, e = i[r + 16 >> 2], i[f >> 2] = i[r + 12 >> 2], i[f + 4 >> 2] = e, r = f + 16 | 0, de(r, 14620, f), e = E2(r), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, !e) break i;
                                    }
                                    v0(A, f + 16 | 0, e);
                                }
                                o[A + e | 0] = 0, m = f + 128 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function e8(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 16 | 0, m = k, i[k + 12 >> 2] = r, i[k + 8 >> 2] = f, t = j4(k + 4 | 0, k + 12 | 0), r = m - 16 | 0, m = r, f = i[k + 8 >> 2], i[r + 12 >> 2] = f, i[r + 8 >> 2] = f, n = -1, f = er(0, 0, e, f);
                            i: {
                                if ((f | 0) < 0 || (u = A, f = f + 1 | 0, A = Q2(f), i[u >> 2] = A, !A)) break i;
                                n = er(A, f, e, i[r + 12 >> 2]);
                            }
                            return m = r + 16 | 0, A = i[t >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = k + 16 | 0, n;
                        }
                        function X9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (r = m - 16 | 0, m = r, ae(r + 4 | 0, i[A >> 2]), k = i[r + 8 >> 2], f = i[r + 4 >> 2], f) {
                                if (A = f, (k | 0) != (A | 0)) {
                                    for(A = k;;){
                                        e = i[A - 4 >> 2];
                                        i: {
                                            if (!e || (n = i[e + 4 >> 2], i[e + 4 >> 2] = n - 1, n)) break i;
                                            p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                                        }
                                        if (A = A - 8 | 0, (f | 0) == (A | 0)) break;
                                    }
                                    A = i[r + 4 >> 2];
                                }
                                i[r + 8 >> 2] = f, X(A);
                            }
                            return m = r + 16 | 0, k - f >> 3;
                        }
                        function vA(A) {
                            var r = 0, e = 0, f = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if (!o4(A, 2)) break i;
                                f = i[A >> 2], r = i[A + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                                e: {
                                    if (!(p[i[i[f >> 2] + 16 >> 2]](f, e + 14 | 0, 2) | 0)) {
                                        D4(A), f = 0;
                                        break e;
                                    }
                                    A = l[e + 14 | 0] | l[e + 15 | 0] << 8, f = A << 8 | A >>> 8;
                                }
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = e + 16 | 0, f << 16 >> 16;
                        }
                        function gX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            if (e = i[A >> 2], A = i[e + 180 >> 2], k = i[e + 184 >> 2], (A | 0) == (k | 0)) return 0;
                            i: {
                                if (!r) {
                                    e = ((k - A | 0) - 8 >>> 3 | 0) + 1 | 0;
                                    break i;
                                }
                                for(n = E2(r), e = 0; f = i[A >> 2], t = o[f + 15 | 0], u = (t | 0) < 0, ((u ? i[f + 8 >> 2] : t) | 0) == (n | 0) && (e = !O2(u ? i[f + 4 >> 2] : f + 4 | 0, r, n) + e | 0), A = A + 8 | 0, (k | 0) != (A | 0););
                            }
                            return e | 0;
                        }
                        function JX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            if (e = m - 16 | 0, m = e, f = i[r >> 2], f >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (f >>> 0 >= 11) {
                                            n = (f | 7) + 1 | 0, k = D(n), i[e + 12 >> 2] = n | -2147483648, i[e + 4 >> 2] = k, i[e + 8 >> 2] = f;
                                            break e;
                                        }
                                        if (o[e + 15 | 0] = f, k = e + 4 | 0, !f) break i;
                                    }
                                    v0(k, r + 4 | 0, f);
                                }
                                return o[f + k | 0] = 0, A = p[A | 0](e + 4 | 0) | 0, o[e + 15 | 0] < 0 && X(i[e + 4 >> 2]), m = e + 16 | 0, A | 0;
                            }
                            Y0(), z();
                        }
                        function RX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!r) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 5, 2001, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                    X(i[f >> 2]);
                                    break i;
                                }
                                if (k = i[i[r >> 2] + 60 >> 2], k) {
                                    p[k | 0](A, i[r + 4 >> 2], e);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            m = f + 32 | 0;
                        }
                        function NX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            return f = i[A + 44 >> 2], k = i[A + 40 >> 2], t = e + k | 0, f = t >>> 0 < e >>> 0 ? f + 1 | 0 : f, n = i[A + 36 >> 2], u = i[A + 32 >> 2], (f | 0) == (n | 0) & u >>> 0 >= t >>> 0 | f >>> 0 < n >>> 0 && (v0(r, i[A + 24 >> 2] + k | 0, e), k = i[A + 44 >> 2], r = e + i[A + 40 >> 2] | 0, k = r >>> 0 < e >>> 0 ? k + 1 | 0 : k, i[A + 40 >> 2] = r, i[A + 44 >> 2] = k), (f | 0) == (n | 0) & t >>> 0 <= u >>> 0 | f >>> 0 < n >>> 0;
                        }
                        function B2(A) {
                            var r = 0, e = 0, f = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if (!o4(A, 2)) break i;
                                f = i[A >> 2], r = i[A + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                                e: {
                                    if (!(p[i[i[f >> 2] + 16 >> 2]](f, e + 14 | 0, 2) | 0)) {
                                        D4(A), f = 0;
                                        break e;
                                    }
                                    A = l[e + 14 | 0] | l[e + 15 | 0] << 8, f = A << 8 | A >>> 8;
                                }
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = e + 16 | 0, f & 65535;
                        }
                        function DX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 104 | 0]), E4(f + 12 | 0, r, e, k), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function MX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, f2(e, l[r + 97 | 0]), E4(f + 12 | 0, r, e, k), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function UX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (n = m - 16 | 0, m = n, r = i[A + 652 >> 2], r && (i[A + 656 >> 2] = r, X(r)), r = i[A + 640 >> 2], r && (i[A + 644 >> 2] = r, X(r)), r = i[A + 604 >> 2], r) {
                                if (e = r, f = i[A + 608 >> 2], (r | 0) != (f | 0)) {
                                    for(; e = f - 12 | 0, k = i[e >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = e, (r | 0) != (f | 0););
                                    e = i[A + 604 >> 2];
                                }
                                i[A + 608 >> 2] = r, X(e);
                            }
                            m = n + 16 | 0;
                        }
                        function _A(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, n = t + 12 | 0, r = i[r + 28 >> 2], i[n >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(n, 108572), p[i[i[r >> 2] + 48 >> 2]](r, 64960, 64992, e), r = K0(n, 108644), u = f, s = p[i[i[r >> 2] + 12 >> 2]](r) | 0, i[u >> 2] = s, u = k, s = p[i[i[r >> 2] + 16 >> 2]](r) | 0, i[u >> 2] = s, p[i[i[r >> 2] + 20 >> 2]](A, r), d0(n), m = t + 16 | 0;
                        }
                        function HX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            f = m - 32 | 0, m = f, k = p[i[i[r >> 2] + 44 >> 2]](r, e, 0) | 0, G4(e, r + 100 | 0), E4(f + 12 | 0, r, e, k), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0;
                            i: {
                                if (o[86691] >= 0) {
                                    r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                    break i;
                                }
                                j(A, i[21670], i[21671]);
                            }
                            m = f + 32 | 0;
                        }
                        function xX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (r = i[A + 104 >> 2], f = i[A + 108 >> 2], (r | 0) != (f | 0)) for(;;){
                                if (k0[r + 40 >> 2] > 65535) {
                                    o[A + 97 | 0] = 1;
                                    return;
                                }
                                e = i[r + 44 >> 2], k = i[r + 48 >> 2];
                                i: {
                                    if ((e | 0) == (k | 0)) break i;
                                    for(;;){
                                        if (k0[e >> 2] < 65536) {
                                            if (e = e + 4 | 0, (k | 0) != (e | 0)) continue;
                                            break i;
                                        }
                                        break;
                                    }
                                    n = 1;
                                }
                                if (r = r + 56 | 0, (f | 0) == (r | 0)) break;
                            }
                            o[A + 97 | 0] = n;
                        }
                        function BA(A, r, e, f, k) {
                            var n = 0, t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, n = t + 12 | 0, r = i[r + 28 >> 2], i[n >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(n, 108580), p[i[i[r >> 2] + 32 >> 2]](r, 64960, 64992, e), r = K0(n, 108636), u = f, s = p[i[i[r >> 2] + 12 >> 2]](r) | 0, o[u | 0] = s, u = k, s = p[i[i[r >> 2] + 16 >> 2]](r) | 0, o[u | 0] = s, p[i[i[r >> 2] + 20 >> 2]](A, r), d0(n), m = t + 16 | 0;
                        }
                        function i6(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            k = i[r >> 2], n = i[r + 4 >> 2], i[r >> 2] = 0, i[r + 4 >> 2] = 0, f = i[A + 4 >> 2], i[A >> 2] = k, i[A + 4 >> 2] = n;
                            i: {
                                if (!f || (k = i[f + 4 >> 2], i[f + 4 >> 2] = k - 1, k)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                            o[A + 8 | 0] = 1, i[A + 24 >> 2] = e, A = i[r + 4 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function p9(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            if (f = i[e + 72 >> 2], i[e + 72 >> 2] = f - 1 | f, f = i[e + 4 >> 2], k = i[e + 8 >> 2], (f | 0) == (k | 0) ? f = r : (n = f, f = k - f | 0, f = r >>> 0 > f >>> 0 ? f : r, v0(A, n, f), i[e + 4 >> 2] = f + i[e + 4 >> 2], A = A + f | 0, f = r - f | 0), f) for(;;){
                                i: {
                                    if (!Ei(e) && (k = p[i[e + 32 >> 2]](e, A, f) | 0, k)) break i;
                                    return r - f | 0;
                                }
                                if (A = A + k | 0, f = f - k | 0, !f) break;
                            }
                            return r;
                        }
                        function q1(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            i: {
                                f = i[r + 128 >> 2];
                                e: {
                                    if (!f) break e;
                                    for(k = r + 128 | 0, r = k; n = k0[f + 16 >> 2] < e >>> 0, r = n ? r : f, f = i[(n << 2) + f >> 2], !!f;);
                                    if ((r | 0) == (k | 0)) break e;
                                    if (k0[r + 16 >> 2] <= e >>> 0) break i;
                                }
                                i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                return;
                            }
                            i[A >> 2] = i[r + 20 >> 2], e = A, A = i[r + 24 >> 2], i[e + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1);
                        }
                        function Q9(A, r) {
                            var e = 0, f = 0;
                            e = m - 32 | 0, m = e, i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0, EA(e + 31 | 0, r), l[e + 31 | 0] && (f = i[(i[i[r >> 2] - 12 >> 2] + r | 0) + 24 >> 2], p[i[i[f >> 2] + 16 >> 2]](e + 8 | 0, f, 0, 0, 1, 8), f = i[e + 20 >> 2], i[A + 8 >> 2] = i[e + 16 >> 2], i[A + 12 >> 2] = f, f = i[e + 12 >> 2], i[A >> 2] = i[e + 8 >> 2], i[A + 4 >> 2] = f, M4(i[i[r >> 2] - 12 >> 2] + r | 0, 0)), m = e + 32 | 0;
                        }
                        function W2(A, r, e) {
                            var f = 0, k = 0;
                            i: {
                                e: {
                                    if (!e) break e;
                                    if (f = i[A + 164 >> 2], (f | 0) > 0) {
                                        for(k = A + 84 | 0, e = 0;;){
                                            if (i[(e << 2) + k >> 2] == (r | 0)) break i;
                                            if (e = e + 1 | 0, (f | 0) == (e | 0)) break;
                                        }
                                        if ((f | 0) > 19) break e;
                                    }
                                    i[A + 164 >> 2] = f + 1, i[((f << 2) + A | 0) + 84 >> 2] = r;
                                }
                                if (e = i[A + 80 >> 2], (e | 0) == 20) {
                                    i[A + 76 >> 2] = 1001;
                                    return;
                                }
                                i[A + 80 >> 2] = e + 1, i[(e << 2) + A >> 2] = r;
                            }
                        }
                        function zX(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            if (r = i[A + 104 >> 2], k = i[A + 108 >> 2], (r | 0) != (k | 0)) {
                                for(;;){
                                    if (u = k0[r >> 2] > 65535, e = i[r + 4 >> 2], n = i[r + 8 >> 2], (e | 0) != (n | 0)) for(; t = I[e + 2 >> 1] > 127 | t, e = e + 4 | 0, (n | 0) != (e | 0););
                                    if (f = u ? 1 : f, r = r + 16 | 0, (k | 0) == (r | 0)) break;
                                }
                                e = f, f = t & 1;
                            }
                            i[A + 100 >> 2] = f, o[A + 97 | 0] = e;
                        }
                        function TX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            i: {
                                e: {
                                    if (A = i[A + 4 >> 2], f = i[A + 168 >> 2], r = r >> f, (r | 0) < 0 || (k = i[A + 172 >> 2], (r | 0) >= (k | 0))) break e;
                                    if (e = e >> f, (e | 0) < 0 | (e | 0) >= i[A + 176 >> 2]) break i;
                                    return A = (i[A + 160 >> 2] + Z(r, 3) | 0) + Z(Z(e, k), 3) | 0, (l[A | 0] | l[A + 1 | 0] << 8) >>> 3 & 7;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function N8(A) {
                            var r = J(0), e = 0, f = 0;
                            if (e = (A2(A), c0(2)), f = e >>> 23 & 255, f >>> 0 <= 149) {
                                if (f >>> 0 <= 125) A = J(A * J(0));
                                else {
                                    A = J(r2(A)), r = J(J(J(A + J(8388608)) + J(-8388608)) - A);
                                    i: {
                                        if (r > J(.5)) {
                                            A = J(J(A + r) + J(-1));
                                            break i;
                                        }
                                        if (A = J(A + r), !(r <= J(-0.5))) break i;
                                        A = J(A + J(1));
                                    }
                                    A = (e | 0) < 0 ? J(-A) : A;
                                }
                            }
                            return J(r2(A)) < J(2147483648) ? ~~A : -2147483648;
                        }
                        function SX(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            n = m - 16 | 0, m = n, k = i[A >> 2], A = 0, i[n + 12 >> 2] = 0, i[n + 4 >> 2] = 0, i[n + 8 >> 2] = 0;
                            i: {
                                if (f = i[k + 216 >> 2], k = i[k + 212 >> 2], (f | 0) == (k | 0)) f = 0;
                                else {
                                    if (f = f - k | 0, (f | 0) < 0) break i;
                                    A = D(f), f = v0(A, k, f) + f | 0;
                                }
                                return k = r, r = f - A >> 2, r = (r | 0) < (e | 0) ? r : e, v0(k, A, r << 2), A && X(A), m = n + 16 | 0, r | 0;
                            }
                            p0(), z();
                        }
                        function jX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            i[A + 8 >> 2] = 1, i[A >> 2] = 1, i[A + 4 >> 2] = 1, i[A + 36 >> 2] = 0, e = i[r + 40 >> 2], i[A + 12 >> 2] = e, r = i[r + 44 >> 2], i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 24 >> 2] = r, i[A + 20 >> 2] = e, i[A + 16 >> 2] = r, i[A + 48 >> 2] = 0, i[A + 52 >> 2] = 0, i[A + 56 >> 2] = 0, i[A + 60 >> 2] = 0, r = A - -64 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 32 >> 2] = 0, o[A + 36 | 0] = 0;
                        }
                        function OX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            if (f = m - 128 | 0, m = f, i[f >> 2] = i[r + 12 >> 2], r = f + 16 | 0, de(r, 14658, f), e = E2(r), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, !e) break i;
                                    }
                                    v0(A, f + 16 | 0, e);
                                }
                                o[A + e | 0] = 0, m = f + 128 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function PX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            if (f = m - 128 | 0, m = f, i[f >> 2] = i[r + 12 >> 2], r = f + 16 | 0, de(r, 14640, f), e = E2(r), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, !e) break i;
                                    }
                                    v0(A, f + 16 | 0, e);
                                }
                                o[A + e | 0] = 0, m = f + 128 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function LX(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 32 | 0, m = t, u = i[16299], i[t + 24 >> 2] = i[16298], i[t + 28 >> 2] = u, u = i[16297], i[t + 16 >> 2] = i[16296], i[t + 20 >> 2] = u, u = i[16295], i[t + 8 >> 2] = i[16294], i[t + 12 >> 2] = u, u = i[16293], i[t >> 2] = i[16292], i[t + 4 >> 2] = u, u = A, A = t + 32 | 0, r = W8(u, r, e, f, k, n, t, A), m = A, r | 0;
                        }
                        function C9(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (r >>> 0 > 8) {
                                for(r = r >>> 0 <= 4 ? 4 : r, f = A >>> 0 <= 1 ? 1 : A;;){
                                    i: {
                                        if (A = 0, e = (r + f | 0) - 1 & 0 - r, k = e >>> 0 > f >>> 0 ? e : f, e = m - 16 | 0, m = e, (k >>> 0) % (r >>> 0) | r & 3 || (A = Me(e + 12 | 0, r, k), A = A ? 0 : i[e + 12 >> 2]), m = e + 16 | 0, A || (e = i[27531], !e)) break i;
                                        p[e | 0]();
                                        continue;
                                    }
                                    break;
                                }
                                return A || u4(), A;
                            }
                            return D(A);
                        }
                        function KX(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            if (f = m - 128 | 0, m = f, i[f >> 2] = i[r + 8 >> 2], r = f + 16 | 0, de(r, 14651, f), e = E2(r), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, !e) break i;
                                    }
                                    v0(A, f + 16 | 0, e);
                                }
                                o[A + e | 0] = 0, m = f + 128 | 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function l2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = i[A + 12 >> 2], k = e + 4 | 0, f = i[A >> 2], n = i[A + 4 >> 2] - f | 0, k >>> 0 > n >>> 0 && (r1(A, k - n | 0), f = i[A >> 2], e = i[A + 12 >> 2]), i[A + 12 >> 2] = e + 1, o[e + f | 0] = r >>> 24, e = i[A + 12 >> 2], i[A + 12 >> 2] = e + 1, o[e + i[A >> 2] | 0] = r >>> 16, e = i[A + 12 >> 2], i[A + 12 >> 2] = e + 1, o[e + i[A >> 2] | 0] = r >>> 8, e = i[A + 12 >> 2], i[A + 12 >> 2] = e + 1, o[e + i[A >> 2] | 0] = r;
                        }
                        function qX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 82224, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function $X(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80592, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function aX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81348, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function bX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80748, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function dX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81864, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function cX(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81192, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function de(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            n = m - 16 | 0, m = n, i[n + 12 >> 2] = e, f = m - 160 | 0, m = f, t = f + 8 | 0, v0(t, 57920, 144), i[f + 52 >> 2] = A, i[f + 28 >> 2] = A, k = -2 - A | 0, k = k >>> 0 > 2147483647 ? 2147483647 : k, i[f + 56 >> 2] = k, k = A + k | 0, i[f + 36 >> 2] = k, i[f + 24 >> 2] = k, iu(t, r, e), (A | 0) != -2 && (A = i[f + 28 >> 2], o[A - ((A | 0) == i[f + 24 >> 2]) | 0] = 0), m = f + 160 | 0, m = n + 16 | 0;
                        }
                        function ip(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            A = B0(A, 0, 72), f = i[r + 384 >> 2], k = i[r + 376 >> 2], i[A + 4 >> 2] = ((f + k | 0) - 1 >>> 0) / (f >>> 0), e = i[r + 388 >> 2], n = i[r + 380 >> 2], i[A + 24 >> 2] = n, i[A + 20 >> 2] = k, i[A + 16 >> 2] = e, i[A + 12 >> 2] = f, i[A + 8 >> 2] = ((e + n | 0) - 1 >>> 0) / (e >>> 0), e = l[r + 398 | 0], o[A + 36 | 0] = e, e && v0(A + 40 | 0, r + 400 | 0, (e >>> 0 >= 8 ? 8 : e) << 2);
                        }
                        function Vi(A) {
                            var r = 0, e = 0;
                            r = i[A + 76 >> 2];
                            i: {
                                if (!((r | 0) >= 0 & (!r | i[26088] != (r & 1073741823)))) {
                                    if (r = i[A + 4 >> 2], (r | 0) != i[A + 8 >> 2]) {
                                        i[A + 4 >> 2] = r + 1, A = l[r | 0];
                                        break i;
                                    }
                                    A = nr(A);
                                    break i;
                                }
                                r = A + 76 | 0, e = i[r >> 2], i[r >> 2] = e || 1073741823, e = i[A + 4 >> 2];
                                e: {
                                    if ((e | 0) != i[A + 8 >> 2]) {
                                        i[A + 4 >> 2] = e + 1, A = l[e | 0];
                                        break e;
                                    }
                                    A = nr(A);
                                }
                                i[r >> 2] = 0;
                            }
                            return A;
                        }
                        function ep(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 82224, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function rp(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80592, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function Ap(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81348, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function fp(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80748, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function kp(A, r, e, f, k) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, i[r + 8 >> 2] != 1) {
                                r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                return;
                            }
                            i: {
                                if (!l[r + 16 | 0] || (f && (i[f >> 2] = i[r + 20 >> 2]), !k)) break i;
                                i[k >> 2] = i[r + 24 >> 2];
                            }
                            e && (i[e >> 2] = l[r + 16 | 0]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                        }
                        function np(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 83460, r = i[A + 484 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 476 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return r = i[A + 436 >> 2], r && (i[A + 440 >> 2] = r, X(r)), F1(A) | 0;
                        }
                        function D8(A, r, e, f) {
                            var k = 0;
                            i: {
                                if (!(f & 2048) || (k = f & 74, !e | ((k | 0) == 8 | (k | 0) == 64))) break i;
                                o[A | 0] = 43, A = A + 1 | 0;
                            }
                            for(f & 512 && (o[A | 0] = 35, A = A + 1 | 0);;){
                                if (k = l[r | 0], k) {
                                    o[A | 0] = k, A = A + 1 | 0, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            k = f & 74, r = 111;
                            i: {
                                if ((k | 0) == 64 || (r = f & 16384 ? 88 : 120, (k | 0) == 8)) break i;
                                r = e ? 100 : 117;
                            }
                            o[A | 0] = r;
                        }
                        function E2(A) {
                            var r = 0, e = 0, f = 0;
                            i: {
                                e: {
                                    if (r = A, !(r & 3)) break e;
                                    if (!l[r | 0]) return 0;
                                    for(;;){
                                        if (r = r + 1 | 0, !(r & 3)) break e;
                                        if (!l[r | 0]) break;
                                    }
                                    break i;
                                }
                                for(; e = r, r = r + 4 | 0, f = i[e >> 2], ((f | 16843008 - f) & -2139062144) == -2139062144;);
                                for(; r = e, e = r + 1 | 0, !!l[r | 0];);
                            }
                            return r - A | 0;
                        }
                        function tp(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81864, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function op(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81192, r = i[A + 36 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(A);
                        }
                        function up(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            t = m - 16 | 0, m = t, i[k >> 2] = e, n = t + 12 | 0, A = MA(n, 0, i[A + 8 >> 2]), r = 2;
                            i: {
                                if (A + 1 >>> 0 < 2 || (e = A - 1 | 0, r = 1, e >>> 0 > f - i[k >> 2] >>> 0)) break i;
                                for(;;){
                                    if (e) {
                                        A = l[n | 0], r = i[k >> 2], i[k >> 2] = r + 1, o[r | 0] = A, e = e - 1 | 0, n = n + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                r = 0;
                            }
                            return m = t + 16 | 0, r | 0;
                        }
                        function lp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 74948, f = i[A + 104 >> 2], f) {
                                if (e = i[A + 108 >> 2], r = f, (e | 0) != (r | 0)) {
                                    for(; r = i[e - 12 >> 2], r && (i[e - 8 >> 2] = r, X(r)), r = e - 56 | 0, i[r >> 2] = 73428, k = i[e - 36 >> 2], k && (i[e - 32 >> 2] = k, X(k)), e = r, (f | 0) != (r | 0););
                                    r = i[A + 104 >> 2];
                                }
                                i[A + 108 >> 2] = f, X(r);
                            }
                            return V2(A) | 0;
                        }
                        function V9(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            i: {
                                e: {
                                    f = i[A + 64 >> 2];
                                    r: {
                                        if (!f) break r;
                                        for(k = A - -64 | 0, A = k; n = i[f + 16 >> 2] < (r | 0), A = n ? A : f, f = i[(n << 2) + f >> 2], !!f;);
                                        if ((A | 0) == (k | 0)) break r;
                                        if (i[A + 16 >> 2] <= (r | 0)) break e;
                                    }
                                    if (A = 0, !e) break i;
                                    return i[e >> 2] = 0, 0;
                                }
                                e && (i[e >> 2] = i[A + 52 >> 2]), A = i[A + 44 >> 2];
                            }
                            return A;
                        }
                        function sp(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 83460, r = i[A + 484 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 476 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            r = i[A + 436 >> 2], r && (i[A + 440 >> 2] = r, X(r)), X(F1(A));
                        }
                        function y9(A) {
                            var r = 0, e = 0, f = 0;
                            f = i[A + 16 >> 2] << 8, i[A + 16 >> 2] = f, r = I[A + 20 >> 1] + 8 | 0, Q[A + 20 >> 1] = r, r = r << 16 >> 16;
                            i: {
                                if ((r | 0) < 0 || (e = i[A + 4 >> 2], e >>> 0 >= k0[A + 8 >> 2])) break i;
                                i[A + 4 >> 2] = e + 1, e = l[e | 0], Q[A + 20 >> 1] = r - 8, f = e << r | f;
                            }
                            return e = i[A + 12 >> 2] << 7, r = (f >>> 0) / (e >>> 0) | 0, (r | 0) >= 256 && (r = 255), i[A + 16 >> 2] = f - Z(r, e), r;
                        }
                        function hp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = A, u = r, A = p[i[i[A + 8 >> 2] + 20 >> 2]](A + 8 | 0) | 0;
                            i: {
                                if (l[A + 11 | 0] >>> 7 | 0) {
                                    r = i[A >> 2];
                                    break i;
                                }
                                r = A;
                            }
                            return s = r, l[A + 11 | 0] >>> 7 | 0 ? r = i[A >> 2] : r = A, l[A + 11 | 0] >>> 7 | 0 ? A = i[A + 4 >> 2] : A = l[A + 11 | 0] & 127, W8(t, u, e, f, k, n, s, r + (A << 2) | 0) | 0;
                        }
                        function ce(A, r) {
                            var e = 0, f = 0, k = 0;
                            e = i[A + 128 >> 2];
                            i: {
                                if (!e) break i;
                                for(k = A + 128 | 0, A = k; f = k0[e + 16 >> 2] < r >>> 0, A = f ? A : e, e = i[(f << 2) + e >> 2], !!e;);
                                if (f = 0, (A | 0) == (k | 0) | k0[A + 16 >> 2] > r >>> 0 || (f = i[A + 20 >> 2], A = i[A + 24 >> 2], !A | i[A + 4 >> 2] != -1)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return (f | 0) != 0;
                        }
                        function X2(A) {
                            var r = 0, e = 0, f = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (!o4(A, 1)) break i;
                                e = i[A >> 2], r = i[A + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1);
                                e: {
                                    if (!(p[i[i[e >> 2] + 16 >> 2]](e, f + 15 | 0, 1) | 0)) {
                                        D4(A), e = 0;
                                        break e;
                                    }
                                    e = l[f + 15 | 0];
                                }
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return m = f + 16 | 0, e;
                        }
                        function wp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 74948, f = i[A + 104 >> 2], f) {
                                if (e = i[A + 108 >> 2], r = f, (e | 0) != (r | 0)) {
                                    for(; r = i[e - 12 >> 2], r && (i[e - 8 >> 2] = r, X(r)), r = e - 56 | 0, i[r >> 2] = 73428, k = i[e - 36 >> 2], k && (i[e - 32 >> 2] = k, X(k)), e = r, (f | 0) != (r | 0););
                                    r = i[A + 104 >> 2];
                                }
                                i[A + 108 >> 2] = f, X(r);
                            }
                            X(V2(A));
                        }
                        function O2(A, r, e) {
                            var f = 0, k = 0;
                            i: {
                                e: {
                                    if (e >>> 0 >= 4) {
                                        if ((A | r) & 3) break e;
                                        for(;;){
                                            if (i[A >> 2] != i[r >> 2]) break e;
                                            if (r = r + 4 | 0, A = A + 4 | 0, e = e - 4 | 0, !(e >>> 0 > 3)) break;
                                        }
                                    }
                                    if (!e) break i;
                                }
                                for(;;){
                                    if (f = l[A | 0], k = l[r | 0], (f | 0) == (k | 0)) {
                                        if (r = r + 1 | 0, A = A + 1 | 0, e = e - 1 | 0, e) continue;
                                        break i;
                                    }
                                    break;
                                }
                                return f - k | 0;
                            }
                            return 0;
                        }
                        function Z4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (!r) {
                                    r = 0;
                                    break i;
                                }
                                e = r >> 31, k = (e ^ r) - e | 0, e = e1(k), P1(f, k, 0, 0, 0, e + 81 | 0), k = 0 + i[f + 8 >> 2] | 0, e = (i[f + 12 >> 2] ^ 65536) + (16414 - e << 16) | 0, e = k >>> 0 < n >>> 0 ? e + 1 | 0 : e, n = r & -2147483648 | e, e = i[f + 4 >> 2], r = i[f >> 2];
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = k, i[A + 12 >> 2] = n, m = f + 16 | 0;
                        }
                        function vp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0, s = 0;
                            t = A, u = r, A = p[i[i[A + 8 >> 2] + 20 >> 2]](A + 8 | 0) | 0;
                            i: {
                                if (l[A + 11 | 0] >>> 7 | 0) {
                                    r = i[A >> 2];
                                    break i;
                                }
                                r = A;
                            }
                            return s = r, l[A + 11 | 0] >>> 7 | 0 ? r = i[A >> 2] : r = A, l[A + 11 | 0] >>> 7 | 0 ? A = i[A + 4 >> 2] : A = l[A + 11 | 0] & 127, Z8(t, u, e, f, k, n, s, r + A | 0) | 0;
                        }
                        function F4(A, r, e, f) {
                            var k = 0, n = 0;
                            k = m - 16 | 0, m = k, n = i[r + 52 >> 2];
                            i: {
                                if (!n) {
                                    if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, i0(A, 2, 108, k + 4 | 0), o[k + 15 | 0] >= 0) break i;
                                    X(i[k + 4 >> 2]);
                                    break i;
                                }
                                if (!i[r + 60 >> 2]) {
                                    if (o[k + 4 | 0] = 0, o[k + 15 | 0] = 0, i0(A, 2, 109, k + 4 | 0), o[k + 15 | 0] >= 0) break i;
                                    X(i[k + 4 >> 2]);
                                    break i;
                                }
                                b7(A, n, e, r + 60 | 0, f);
                            }
                            m = k + 16 | 0;
                        }
                        function mA(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            k = m - 160 | 0, m = k, i[k + 60 >> 2] = r, i[k + 20 >> 2] = r, i[k + 24 >> 2] = -1, n = k + 16 | 0, z4(n, 0, 0), Z7(k, n, f, 1), f = i[k + 8 >> 2], t = i[k + 12 >> 2], n = i[k >> 2], u = i[k + 4 >> 2], e && (i[e >> 2] = i[k + 136 >> 2] + ((i[k + 20 >> 2] - i[k + 60 >> 2] | 0) + r | 0)), i[A + 8 >> 2] = f, i[A + 12 >> 2] = t, i[A >> 2] = n, i[A + 4 >> 2] = u, m = k + 160 | 0;
                        }
                        function I9(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (r = i[A + 16 >> 2], !r) return 0;
                            r = E0(r, 78492, 79120);
                            i: {
                                if (!r) break i;
                                if (A = i[A + 20 >> 2], !A) return i[r + 12 >> 2] - i[r + 8 >> 2] >> 3;
                                if (e = i[A + 4 >> 2], f = e + 1 | 0, i[A + 4 >> 2] = f, k = i[r + 8 >> 2], r = i[r + 12 >> 2], i[A + 4 >> 2] = e, e = r - k >> 3, f) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return e | 0;
                        }
                        function _p(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (r = i[A + 16 >> 2], !r) return 0;
                            r = E0(r, 78492, 79208);
                            i: {
                                if (!r) break i;
                                if (A = i[A + 20 >> 2], !A) return i[r + 24 >> 2] - i[r + 20 >> 2] | 0;
                                if (e = i[A + 4 >> 2], f = e + 1 | 0, i[A + 4 >> 2] = f, k = i[r + 20 >> 2], r = i[r + 24 >> 2], i[A + 4 >> 2] = e, e = r - k | 0, f) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return e | 0;
                        }
                        function Bp(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            k = m - 32 | 0, m = k;
                            i: {
                                if (!(f && e)) {
                                    if (o[k | 0] = 0, o[k + 11 | 0] = 0, e = i0(k + 12 | 0, 5, 2001, k), o[k + 11 | 0] < 0 && X(i[k >> 2]), j0(A, e, r ? i[r >> 2] : 0), o[e + 19 | 0] >= 0) break i;
                                    X(i[e + 8 >> 2]);
                                    break i;
                                }
                                r = D(8), e = i[e >> 2], i[r + 4 >> 2] = 0, i[r >> 2] = e, i[f >> 2] = r, Nt(A, r);
                            }
                            m = k + 32 | 0;
                        }
                        function F9(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, r = A + 32 | 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[r >> 2] = 0, i[r + 4 >> 2] = 0, i[r + 16 >> 2] = 0, i[r + 8 >> 2] = 0, i[r + 12 >> 2] = 0;
                        }
                        function mp(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            i: {
                                e: {
                                    if (A = i[A + 4 >> 2], f = i[A + 188 >> 2], r = r >> f, (r | 0) < 0 || (k = i[A + 192 >> 2], (r | 0) >= (k | 0))) break e;
                                    if (e = e >> f, (e | 0) < 0 | (e | 0) >= i[A + 196 >> 2]) break i;
                                    return (i[A + 180 >> 2] + Z(r, 12) | 0) + Z(Z(e, k), 12) | 0;
                                }
                                y0(4105, 9012, 118, 3731), z();
                            }
                            y0(4067, 9012, 119, 3731), z();
                        }
                        function Zp(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0;
                            var u = 0;
                            n = m - 32 | 0, m = n, u = n + 12 | 0, li(u, i[r >> 2], e, f, k, 1970432288, 0, 0, t);
                            i: {
                                if (i[n + 12 >> 2] != i[21668]) {
                                    j0(A, u, i[r >> 2]);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), m = n + 32 | 0;
                        }
                        function Gp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            t = m - 32 | 0, m = t, u = t + 12 | 0, li(u, i[r >> 2], e, f, k, 1835625829, 8026, n, 0);
                            i: {
                                if (i[t + 12 >> 2] != i[21668]) {
                                    j0(A, u, i[r >> 2]);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), m = t + 32 | 0;
                        }
                        function Y9(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = 1;
                            i: {
                                if (r || (e = i[A + 12 >> 2], k = i[A + 8 >> 2], r = e - k >> 2, r >>> 0 < k0[A >> 2])) break i;
                                if ((e | 0) == (k | 0)) return 0;
                                for(f = r >>> 0 <= 1 ? 1 : r, A = 0;;){
                                    if (e = i[(A << 2) + k >> 2], !(l[e + 104 | 0] | i[e + 100 >> 2])) return 1;
                                    if (A = A + 1 | 0, (f | 0) == (A | 0)) break;
                                }
                                f = A >>> 0 < r >>> 0;
                            }
                            return f;
                        }
                        function Wp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 81544, e = i[A + 112 >> 2], e) {
                                if (r = e, f = i[A + 116 >> 2], (r | 0) != (f | 0)) {
                                    for(; r = f - 12 | 0, k = i[r >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = r, (r | 0) != (e | 0););
                                    r = i[A + 112 >> 2];
                                }
                                i[A + 116 >> 2] = e, X(r);
                            }
                            return r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function ZA(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            return i[A >> 2] = 73384, k = A + 4 | 0, i[k >> 2] = 0, i[k + 4 >> 2] = 0, i[k + 16 >> 2] = 0, i[k + 8 >> 2] = 0, i[k + 12 >> 2] = 0, i[A + 48 >> 2] = 0, i[A + 40 >> 2] = 0, i[A + 44 >> 2] = 0, i[A + 32 >> 2] = e, i[A + 36 >> 2] = 0, i[A >> 2] = 73252, f ? (f = D(e), i[A + 48 >> 2] = f, n = A, t = v0(f, r, e), i[n + 24 >> 2] = t, A) : (i[A + 24 >> 2] = r, A);
                        }
                        function GA(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (i[r + 16 >> 2] != 1970628964) {
                                i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                                return;
                            }
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                if (e = i[r + 20 >> 2], r = i[r + 24 >> 2], (e | 0) != (r | 0)) {
                                    if (r = r - e | 0, (r | 0) < 0) break i;
                                    f = D(r), i[A >> 2] = f, k = r + f | 0, i[A + 8 >> 2] = k, v0(f, e, r), i[A + 4 >> 2] = k;
                                }
                                return;
                            }
                            p0(), z();
                        }
                        function Xp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = i[A + 24 >> 2], r >>> 0 > k0[A + 44 >> 2] && (i[A + 44 >> 2] = r);
                            i: {
                                if (!(l[A + 48 | 0] & 8) || (r = i[A + 44 >> 2], r >>> 0 > k0[A + 16 >> 2] && (e = i[A + 8 >> 2], f = i[A + 12 >> 2], i[A + 16 >> 2] = r, i[A + 12 >> 2] = f, i[A + 8 >> 2] = e), r = i[A + 16 >> 2], A = i[A + 12 >> 2], r >>> 0 <= A >>> 0)) break i;
                                return l[A | 0];
                            }
                            return -1;
                        }
                        function E9(A, r, e) {
                            var f = 0;
                            if (e - 65537 >>> 0 < 4294836223) for(; r = (r | 0) / 2 | 0, e = (e | 0) / 2 | 0, e - 65537 >>> 0 < 4294836223;);
                            i: {
                                if ((e | 0) <= 1) break i;
                                for(;;){
                                    if (r - 65537 >>> 0 > 4294836222) break i;
                                    if (r = (r | 0) / 2 | 0, f = e >>> 0 > 3, e = e >>> 1 | 0, !f) break;
                                }
                            }
                            return i[A >> 2] = r, i[A + 4 >> 2] = e, A;
                        }
                        function pp(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0, t = 0;
                            k = m - 32 | 0, m = k, n = k + 12 | 0, t = i[r >> 2], p[i[i[t >> 2] + 48 >> 2]](n, t, e, f);
                            i: {
                                if (i[k + 12 >> 2]) {
                                    e = A, A = i[r >> 2], j0(e, n, A ? A + 4 | 0 : 0);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function Qp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (i[A >> 2] = 81544, e = i[A + 112 >> 2], e) {
                                if (r = e, f = i[A + 116 >> 2], (r | 0) != (f | 0)) {
                                    for(; r = f - 12 | 0, k = i[r >> 2], k && (i[f - 8 >> 2] = k, X(k)), f = r, (r | 0) != (e | 0););
                                    r = i[A + 112 >> 2];
                                }
                                i[A + 116 >> 2] = e, X(r);
                            }
                            r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), X(V2(A));
                        }
                        function C8(A) {
                            var r = 0, e = 0, f = 0;
                            e = m - 32 | 0, m = e, l[87597] == 1 && (i[e + 16 >> 2] = A, n8(25484, e + 16 | 0)), r = i[A + 4 >> 2];
                            i: {
                                if (!r || (f = r, r = i[r >> 2] - 1 | 0, i[f >> 2] = r, r) || (l[87597] == 1 && (i[e >> 2] = i[A >> 2], n8(25514, e)), r = i[A >> 2], r && X(r), r = i[A + 4 >> 2], !r)) break i;
                                X(r);
                            }
                            return m = e + 32 | 0, A;
                        }
                        function g9(A, r) {
                            var e = 0, f = 0;
                            e = l[A | 0];
                            i: {
                                if ((e | 0) != l[r | 0] || e && I[A + 4 >> 1] != I[r + 4 >> 1] | I[A + 6 >> 1] != I[r + 6 >> 1] | l[A + 2 | 0] != l[r + 2 | 0] || (e = l[A + 1 | 0], (e | 0) != l[r + 1 | 0]) || e && I[A + 8 >> 1] != I[r + 8 >> 1] | I[A + 10 >> 1] != I[r + 10 >> 1] | l[A + 3 | 0] != l[r + 3 | 0]) break i;
                                f = 1;
                            }
                            return f;
                        }
                        function J9(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (r = m - 16 | 0, m = r, l[87597] == 1 && (i[r + 4 >> 2] = i[A + 4 >> 2], i[r >> 2] = A, n8(34732, r)), e = i[A + 4 >> 2], e) {
                                f = i[e >> 2], (f | 0) >= 2 && (i[e >> 2] = f - 1, e = i[A >> 2], f = D(172), i[A >> 2] = f, k = A, A = D(4), i[k + 4 >> 2] = A, i[A >> 2] = 1, v0(f, e, 172)), m = r + 16 | 0;
                                return;
                            }
                            y0(3389, 15014, 95, 10668), z();
                        }
                        function Cp(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            n = m - 32 | 0, m = n, t = n + 12 | 0, li(t, i[r >> 2], e, f, k, 1835625829, 8026, 0, 0);
                            i: {
                                if (i[n + 12 >> 2] != i[21668]) {
                                    j0(A, t, i[r >> 2]);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[n + 31 | 0] < 0 && X(i[n + 20 >> 2]), m = n + 32 | 0;
                        }
                        function WA(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            t = m - 32 | 0, m = t, u = t + 12 | 0, J0(u, i[r >> 2], e, f, k, n, 0);
                            i: {
                                if (i[t + 12 >> 2]) {
                                    e = A, A = i[r >> 2], j0(e, u, A ? A + 8 | 0 : 0);
                                    break i;
                                }
                                r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                            }
                            o[t + 31 | 0] < 0 && X(i[t + 20 >> 2]), m = t + 32 | 0;
                        }
                        function S1(A) {
                            var r = 0, e = 0;
                            e = i[A + 16 >> 2] << 1, i[A + 16 >> 2] = e, r = I[A + 20 >> 1] + 1 | 0, Q[A + 20 >> 1] = r;
                            i: {
                                if (r << 16 >> 16 < 0 || (Q[A + 20 >> 1] = 65528, r = i[A + 4 >> 2], r >>> 0 >= k0[A + 8 >> 2])) break i;
                                i[A + 4 >> 2] = r + 1, e = l[r | 0] | e, i[A + 16 >> 2] = e;
                            }
                            return r = i[A + 12 >> 2] << 7, r >>> 0 <= e >>> 0 ? (i[A + 16 >> 2] = e - r, A = 1) : A = 0, A;
                        }
                        function Vp(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            i: {
                                if (!i[A + 64 >> 2] || (e = i[A + 12 >> 2], e >>> 0 <= k0[A + 8 >> 2])) break i;
                                if ((r | 0) == -1) return i[A + 12 >> 2] = e - 1, ((r | 0) != -1 ? r : 0) | 0;
                                if (e = i[A + 12 >> 2] - 1 | 0, !(l[A + 88 | 0] & 16) & l[e | 0] != (r & 255)) break i;
                                return i[A + 12 >> 2] = e, o[i[A + 12 >> 2]] = r << 24 >> 24, r | 0;
                            }
                            return -1;
                        }
                        function y6(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            i: {
                                if (!r) {
                                    f = r;
                                    break i;
                                }
                                for(; e = e - 1 | 0, k = A, A = _6(A, r, 10, 0), f = w0, n = e, t = k - O0(A, f, 10, 0) | 48, o[n | 0] = t, k = r >>> 0 > 9, r = f, !!k;);
                            }
                            if (A | f) for(; e = e - 1 | 0, r = (A >>> 0) / 10 | 0, o[e | 0] = A - Z(r, 10) | 48, f = A >>> 0 > 9, A = r, !!f;);
                            return e;
                        }
                        function yp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            if (f = i[A + 24 >> 2], f) {
                                if (r = f, e = i[A + 28 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        r = i[e - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (e = e - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A + 24 >> 2];
                                }
                                i[A + 28 >> 2] = f, X(r);
                            }
                        }
                        function XA(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            if (f = i[A >> 2], k = f + e & 536870911, i[A >> 2] = k, i[A + 4 >> 2] = i[A + 4 >> 2] + (f >>> 0 > k >>> 0) + (e >>> 29), f = f & 63, f) {
                                if (n = A + 24 | 0, k = f + n | 0, f = 64 - f | 0, f >>> 0 > e >>> 0) {
                                    v0(k, r, e);
                                    return;
                                }
                                v0(k, r, f), we(A, n, 64), e = e - f | 0, r = r + f | 0;
                            }
                            e >>> 0 >= 64 && (r = we(A, r, e & -64), e = e & 63), v0(A + 24 | 0, r, e);
                        }
                        function R9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0, u = 0;
                            for(n = m - 16 | 0, m = n, o[n + 14 | 0] = 0, f = m - 16 | 0, m = f, r = r - A >> 2;;){
                                if (r) {
                                    i[f + 12 >> 2] = A, k = r >>> 1 | 0, i[f + 12 >> 2] = i[f + 12 >> 2] + (k << 2), u = (k ^ -1) + r | 0, r = k, k = i[f + 12 >> 2], t = k0[k >> 2] < k0[e >> 2], r = t ? u : r, A = t ? k + 4 | 0 : A;
                                    continue;
                                }
                                break;
                            }
                            return m = f + 16 | 0, m = n + 16 | 0, A;
                        }
                        function Ip(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0, u = 0;
                            u = (k - f | 0) + r | 0;
                            i: {
                                for(;;){
                                    if ((f | 0) != (k | 0)) {
                                        if (A = -1, (r | 0) == (e | 0) || (n = o[r | 0], t = o[f | 0], (n | 0) < (t | 0))) break i;
                                        if ((n | 0) > (t | 0)) return 1;
                                        f = f + 1 | 0, r = r + 1 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                A = (e | 0) != (u | 0);
                            }
                            return A | 0;
                        }
                        function N9(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            if (i[A + 1884 >> 2] > 0 && (r = A + 1392 | 0, o[r | 0] = 1, i[r + 156 >> 2] > 0)) for(; e = e + 1 | 0, (e | 0) < i[r + 156 >> 2];);
                            return p[i[i[A >> 2] + 4 >> 2]](A), l[87596] || (o[87596] = 1), A = i[21892], (A | 0) <= 0 ? 12 : (A = A - 1 | 0, i[21892] = A, A || qo(), 0);
                        }
                        function yi(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            return f = A * A, n = f * (f * f) * (f * 158969099521155e-24 + -0.000000025050760253406863) + (f * (f * 27557313707070068e-22 + -0.0001984126982985795) + .00833333333332249), k = f * A, e ? A - (f * (r * .5 - n * k) - r + k * .16666666666666632) : k * (f * n + -0.16666666666666632) + A;
                        }
                        function ir(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, i[e + 12 >> 2] = A;
                            i: {
                                if ((A | 0) == (r | 0)) break i;
                                for(;;){
                                    if (r = r - 4 | 0, i[e + 8 >> 2] = r, A >>> 0 >= r >>> 0) break i;
                                    A = i[e + 12 >> 2], r = i[A >> 2], f = A, A = i[e + 8 >> 2], i[f >> 2] = i[A >> 2], i[A >> 2] = r, A = i[e + 12 >> 2] + 4 | 0, i[e + 12 >> 2] = A, r = i[e + 8 >> 2];
                                }
                            }
                            m = e + 16 | 0;
                        }
                        function I6(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if (!r) {
                                    r = 0;
                                    break i;
                                }
                                f = r, r = e1(r), P1(e, f, 0, 0, 0, 112 - (r ^ 31) | 0), f = 0 + i[e + 8 >> 2] | 0, r = (i[e + 12 >> 2] ^ 65536) + (16414 - r << 16) | 0, n = k >>> 0 > f >>> 0 ? r + 1 | 0 : r, k = i[e + 4 >> 2], r = i[e >> 2];
                            }
                            i[A >> 2] = r, i[A + 4 >> 2] = k, i[A + 8 >> 2] = f, i[A + 12 >> 2] = n, m = e + 16 | 0;
                        }
                        function D9(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            r = i[A + 40 >> 2], e = p[r | 0](A, 0, 0, l[A | 0] & 128 ? i[A + 20 >> 2] == i[A + 28 >> 2] ? 1 : 2 : 1) | 0, r = w0;
                            i: {
                                if ((r | 0) < 0 || (k = 4, f = i[A + 8 >> 2], !f && (k = 20, f = i[A + 28 >> 2], !f))) break i;
                                A = i[A + k >> 2] - f | 0, e = A + e | 0, r = (A >> 31) + r | 0, r = A >>> 0 > e >>> 0 ? r + 1 | 0 : r;
                            }
                            return w0 = r, e;
                        }
                        function Ii(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            l[A | 0] || (e = i[A + 24 >> 2], f = e + i[A + 20 >> 2] | 0, n = i[A + 12 >> 2], k = i[A + 8 >> 2], (f | 0) == (((k | 0) != (n | 0) ? (n - k << 8) - 1 | 0 : 0) | 0) && (me(A + 4 | 0), k = i[A + 8 >> 2], e = i[A + 24 >> 2], f = e + i[A + 20 >> 2] | 0), i[i[(f >>> 8 & 16777212) + k >> 2] + ((f & 1023) << 2) >> 2] = r, i[A + 24 >> 2] = e + 1);
                        }
                        function r8(A, r, e, f, k) {
                            e = Z(i[i[A + 124 >> 2] + 16892 >> 2], f) + e | 0;
                            i: {
                                if (!r || (e = i[A + 320 >> 2] + Z(e, 76) | 0, i[e >> 2] >= (k | 0))) break i;
                                i[A + 328 >> 2] = i[A + 328 >> 2] - 1, i[A + 332 >> 2] = i[A + 332 >> 2] + 1, i[r + 4 >> 2] = 2, mo(e, k), i[r + 4 >> 2] = 1, i[A + 332 >> 2] = i[A + 332 >> 2] - 1, i[A + 328 >> 2] = i[A + 328 >> 2] + 1;
                            }
                        }
                        function Fp(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            if (A = i[21712], A) {
                                if (r = A, e = i[21713], (r | 0) != (e | 0)) {
                                    for(;;){
                                        r = i[e - 4 >> 2];
                                        i: {
                                            if (!r || (f = i[r + 4 >> 2], i[r + 4 >> 2] = f - 1, f)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (e = e - 8 | 0, (e | 0) == (A | 0)) break;
                                    }
                                    r = i[21712];
                                }
                                i[21713] = A, X(r);
                            }
                        }
                        function e6(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, i[e + 12 >> 2] = A;
                            i: {
                                if ((A | 0) == (r | 0)) break i;
                                for(;;){
                                    if (r = r - 1 | 0, i[e + 8 >> 2] = r, A >>> 0 >= r >>> 0) break i;
                                    A = i[e + 12 >> 2], r = l[A | 0], f = A, A = i[e + 8 >> 2], o[f | 0] = l[A | 0], o[A | 0] = r, A = i[e + 12 >> 2] + 1 | 0, i[e + 12 >> 2] = A, r = i[e + 8 >> 2];
                                }
                            }
                            m = e + 16 | 0;
                        }
                        function F6(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = -1;
                            i: {
                                if ((A | 0) == -1) break i;
                                k = i[r + 76 >> 2] < 0;
                                e: {
                                    e = i[r + 4 >> 2];
                                    r: {
                                        if (!e && (Ei(r), e = i[r + 4 >> 2], !e)) break r;
                                        if (i[r + 44 >> 2] - 8 >>> 0 < e >>> 0) break e;
                                    }
                                    if (k) break i;
                                    return -1;
                                }
                                e = e - 1 | 0, i[r + 4 >> 2] = e, o[e | 0] = A, i[r >> 2] = i[r >> 2] & -17, f = A & 255;
                            }
                            return f;
                        }
                        function M9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 16 | 0, m = f, A = z0(A), i[A + 32 >> 2] = r, i[A >> 2] = 61128, k = f + 12 | 0, r = i[A + 4 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108588), d0(k), i[A + 40 >> 2] = e, i[A + 36 >> 2] = r, n = A, t = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[n + 44 | 0] = t, m = f + 16 | 0;
                        }
                        function U9(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 16 | 0, m = f, A = Mt(A), i[A + 32 >> 2] = r, i[A >> 2] = 61332, k = f + 12 | 0, r = i[A + 4 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108596), d0(k), i[A + 40 >> 2] = e, i[A + 36 >> 2] = r, n = A, t = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[n + 44 | 0] = t, m = f + 16 | 0;
                        }
                        function H9(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (f = i[A >> 2], f) {
                                if (r = f, e = i[A + 4 >> 2], (r | 0) != (e | 0)) {
                                    for(;;){
                                        r = i[e - 4 >> 2];
                                        i: {
                                            if (!r || (k = i[r + 4 >> 2], i[r + 4 >> 2] = k - 1, k)) break i;
                                            p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                        }
                                        if (e = e - 8 | 0, (e | 0) == (f | 0)) break;
                                    }
                                    r = i[A >> 2];
                                }
                                i[A + 4 >> 2] = f, X(r);
                            }
                        }
                        function Yp(A, r, e) {
                            if (A = A | 0, r = r | 0, e = e | 0, w2(e, I[r + 4 >> 1]), w2(e, I[r + 6 >> 1]), w2(e, I[r + 8 >> 1]), f2(e, l[r + 10 | 0] ? 128 : 0), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function A8(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, l[A + 11 | 0] >>> 7 | 0 && y8(i[A >> 2], 4);
                            i: if (l[r + 11 | 0] >>> 7 | 0) break i;
                            i[A + 8 >> 2] = i[r + 8 >> 2], f = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = f, o[r + 11 | 0] = l[r + 11 | 0] & 128, o[r + 11 | 0] = l[r + 11 | 0] & 127, i[e + 12 >> 2] = 0, i[r >> 2] = i[e + 12 >> 2], m = e + 16 | 0;
                        }
                        function Ep(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            if (Y1(A, i[r + 8 >> 2], 0)) {
                                QA(r, e, f);
                                return;
                            }
                            k = i[A + 12 >> 2], n = A + 16 | 0, j9(n, r, e, f);
                            i: {
                                if ((k | 0) < 2) break i;
                                for(k = (k << 3) + n | 0, A = A + 24 | 0;;){
                                    if (j9(A, r, e, f), l[r + 54 | 0]) break i;
                                    if (A = A + 8 | 0, !(k >>> 0 > A >>> 0)) break;
                                }
                            }
                        }
                        function Fi(A) {
                            var r = 0, e = 0, f = 0;
                            Q[A + 20 >> 1] = 8, i[A + 12 >> 2] = 510, i[A + 16 >> 2] = 0, r = i[A + 4 >> 2], f = i[A + 8 >> 2] - r | 0;
                            i: {
                                if ((f | 0) <= 0 || (i[A + 4 >> 2] = r + 1, e = l[r | 0], Q[A + 20 >> 1] = 0, e = e << 8, i[A + 16 >> 2] = e, (f | 0) == 1)) break i;
                                i[A + 4 >> 2] = r + 2, r = l[r + 1 | 0], Q[A + 20 >> 1] = 65528, i[A + 16 >> 2] = r | e;
                            }
                        }
                        function n1(A) {
                            var r = 0, e = 0, f = 0, k = 0;
                            if (e = m - 16 | 0, m = e, i[e + 12 >> 2] = A, f = m - 16 | 0, m = f, i[A >> 2] != -1) {
                                for(r = f + 12 | 0, i[r >> 2] = e + 12, k = f + 8 | 0, i[k >> 2] = r; r = i[A >> 2], (r | 0) == 1;);
                                r || (i[A >> 2] = 1, wo(k), i[A >> 2] = -1);
                            }
                            return m = f + 16 | 0, m = e + 16 | 0, i[A + 4 >> 2] - 1 | 0;
                        }
                        function $1(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, l[A + 11 | 0] >>> 7 | 0 && y8(i[A >> 2], 1);
                            i: if (l[r + 11 | 0] >>> 7 | 0) break i;
                            i[A + 8 >> 2] = i[r + 8 >> 2], f = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = f, o[r + 11 | 0] = l[r + 11 | 0] & 128, o[r + 11 | 0] = l[r + 11 | 0] & 127, o[e + 15 | 0] = 0, o[r | 0] = l[e + 15 | 0], m = e + 16 | 0;
                        }
                        function er(A, r, e, f) {
                            var k = 0, n = 0;
                            return k = m - 160 | 0, m = k, n = r ? A : k + 158 | 0, i[k + 148 >> 2] = n, A = r - 1 | 0, i[k + 152 >> 2] = A >>> 0 <= r >>> 0 ? A : 0, A = B0(k, 0, 144), i[A + 76 >> 2] = -1, i[A + 36 >> 2] = 1297, i[A + 80 >> 2] = -1, i[A + 44 >> 2] = A + 159, i[A + 84 >> 2] = A + 148, o[n | 0] = 0, r = Se(A, e, f, 1295, 1296), m = A + 160 | 0, r;
                        }
                        function Yi(A) {
                            var r = 0, e = 0, f = 0;
                            r = i[A + 76 >> 2];
                            i: {
                                if ((r | 0) != -1) {
                                    A = r;
                                    break i;
                                }
                                r = A, e = m - 16 | 0, m = e, f = e + 12 | 0, A = i[A + 28 >> 2], i[f >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(f, 108580), A = p[i[i[A >> 2] + 28 >> 2]](A, 32) | 0, d0(f), m = e + 16 | 0, i[r + 76 >> 2] = A;
                            }
                            return A << 24 >> 24;
                        }
                        function gp(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0, t = 0;
                            i: {
                                for(;;){
                                    if ((f | 0) != (k | 0)) {
                                        if (A = -1, (r | 0) == (e | 0) || (n = i[r >> 2], t = i[f >> 2], (n | 0) < (t | 0))) break i;
                                        if ((n | 0) > (t | 0)) return 1;
                                        f = f + 4 | 0, r = r + 4 | 0;
                                        continue;
                                    }
                                    break;
                                }
                                A = (r | 0) != (e | 0);
                            }
                            return A | 0;
                        }
                        function Jp(A, r, e) {
                            if (A = A | 0, r = r | 0, e = e | 0, !e) {
                                r = i[19869], i[A >> 2] = i[19868], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19870];
                                return;
                            }
                            if (i[e >> 2] >= 4) {
                                r = i[19875], i[A >> 2] = i[19874], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19876];
                                return;
                            }
                            k9(e), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                        }
                        function Ei(A) {
                            var r = 0, e = 0;
                            return r = i[A + 72 >> 2], i[A + 72 >> 2] = r - 1 | r, i[A + 20 >> 2] != i[A + 28 >> 2] && p[i[A + 36 >> 2]](A, 0, 0), i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, r = i[A >> 2], r & 4 ? (i[A >> 2] = r | 32, -1) : (e = i[A + 44 >> 2] + i[A + 48 >> 2] | 0, i[A + 8 >> 2] = e, i[A + 4 >> 2] = e, r << 27 >> 31);
                        }
                        function z2(A, r) {
                            var e = 0, f = 0, k = 0;
                            i: {
                                if (f = E2(r), e = l[A + 11 | 0] >>> 7 | 0 ? (i[A + 8 >> 2] & 2147483647) - 1 | 0 : 10, l[A + 11 | 0] >>> 7 | 0 ? k = i[A + 4 >> 2] : k = l[A + 11 | 0] & 127, f >>> 0 <= e >>> 0) {
                                    l[A + 11 | 0] >>> 7 | 0 ? e = i[A >> 2] : e = A, ao(e, r, f), xt(A, e, f);
                                    break i;
                                }
                                xe(A, e, f - e | 0, k, 0, k, f, r);
                            }
                        }
                        function pA(A, r, e) {
                            var f = 0, k = 0;
                            if (i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, f = i[r + 104 >> 2], r = i[r + 108 >> 2], (f | 0) != (r | 0)) for(;;){
                                if (i[f + 40 >> 2] == (e | 0)) {
                                    i: {
                                        if (k0[A + 8 >> 2] > k >>> 0) {
                                            Bi(k, f), k = k + 56 | 0;
                                            break i;
                                        }
                                        k = L3(A, f);
                                    }
                                    i[A + 4 >> 2] = k;
                                }
                                if (f = f + 56 | 0, (r | 0) == (f | 0)) break;
                            }
                        }
                        function G4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0, t = 0, u = 0;
                            e = i[r >> 2], f = i[r + 4 >> 2] - e | 0, k = i[A + 12 >> 2], t = f + k | 0, n = i[A >> 2], u = i[A + 4 >> 2] - n | 0, t >>> 0 > u >>> 0 && (r1(A, t - u | 0), k = i[A + 12 >> 2], n = i[A >> 2], e = i[r >> 2], f = i[r + 4 >> 2] - e | 0), v0(k + n | 0, e, f), i[A + 12 >> 2] = i[A + 12 >> 2] + (i[r + 4 >> 2] - i[r >> 2] | 0);
                        }
                        function QA(A, r, e) {
                            var f = 0;
                            if (f = i[A + 36 >> 2], !f) {
                                i[A + 24 >> 2] = e, i[A + 16 >> 2] = r, i[A + 36 >> 2] = 1, i[A + 20 >> 2] = i[A + 56 >> 2];
                                return;
                            }
                            i: {
                                if (!(i[A + 20 >> 2] != i[A + 56 >> 2] | i[A + 16 >> 2] != (r | 0))) {
                                    if (i[A + 24 >> 2] != 2) break i;
                                    i[A + 24 >> 2] = e;
                                    return;
                                }
                                o[A + 54 | 0] = 1, i[A + 24 >> 2] = 2, i[A + 36 >> 2] = f + 1;
                            }
                        }
                        function gi(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            for(r = m - 16 | 0, m = r, f = A + 4 | 0, e = i[f >> 2], i[r + 12 >> 2] = e;;){
                                i: {
                                    if ((e | 0) == -1) {
                                        A = 0;
                                        break i;
                                    }
                                    if (k = i[f >> 2], n = (k | 0) == i[r + 12 >> 2], i[f >> 2] = n ? e + 1 | 0 : k, n || (i[r + 12 >> 2] = k), n) break i;
                                    e = i[r + 12 >> 2];
                                    continue;
                                }
                                break;
                            }
                            return m = r + 16 | 0, A;
                        }
                        function x9(A) {
                            var r = 0, e = 0, f = 0;
                            if (e = m - 16 | 0, m = e, l[87597] == 1 && (i[e + 4 >> 2] = i[A + 4 >> 2], i[e >> 2] = A, n8(25499, e)), r = i[A + 4 >> 2], r) {
                                f = i[r >> 2] - 1 | 0, i[r >> 2] = f;
                                i: {
                                    if (f || (f = i[A >> 2], f && (X(f), r = i[A + 4 >> 2], !r))) break i;
                                    X(r);
                                }
                                i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            }
                            m = e + 16 | 0;
                        }
                        function z4(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            i[A + 112 >> 2] = r, i[A + 116 >> 2] = e, k = i[A + 4 >> 2], f = i[A + 44 >> 2] - k | 0, i[A + 120 >> 2] = f, i[A + 124 >> 2] = f >> 31, f = i[A + 8 >> 2];
                            i: {
                                if (!(r | e) || (n = f - k | 0, t = n >> 31, (e | 0) >= (t | 0) & r >>> 0 >= n >>> 0 | (e | 0) > (t | 0))) break i;
                                f = r + k | 0;
                            }
                            i[A + 104 >> 2] = f;
                        }
                        function Rp(A) {
                            A = A | 0;
                            var r = 0;
                            i: {
                                if (r = i[A + 12 >> 2], A = i[A + 8 >> 2], r - A >>> 0 > 524280) break i;
                                if ((A | 0) == (r | 0)) return 0;
                                for(;;){
                                    if (i[A >> 2] - 32768 >>> 0 < 4294901760 | i[A + 4 >> 2] - 32768 >>> 0 <= 4294901759) break i;
                                    if (A = A + 8 | 0, (r | 0) == (A | 0)) break;
                                }
                                return 0;
                            }
                            return 1;
                        }
                        function Np(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            if (f = i[r + 8 >> 2], e = E2(f), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, r = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = r, i[A + 4 >> 2] = e, A = r;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, !e) break i;
                                    }
                                    v0(A, f, e);
                                }
                                o[A + e | 0] = 0;
                                return;
                            }
                            Y0(), z();
                        }
                        function Dp(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            if (f2(r, l[A + 4 | 0] ? 3 : 6), l1(r, e, i[A + 12 >> 2] - i[A + 8 >> 2] >> 3, 0), f = i[A + 8 >> 2], k = i[A + 12 >> 2], (f | 0) != (k | 0)) for(; A = i[f >> 2], l1(r, e, A, A >> 31), A = i[f + 4 >> 2], l1(r, e, A, A >> 31), f = f + 8 | 0, (k | 0) != (f | 0););
                        }
                        function Mp(A, r, e, f, k, n, t) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21674], i[A + 8 >> 2] = i[21673], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86711] >= 0) {
                                r = i[21676], i[A >> 2] = i[21675], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21677];
                                return;
                            }
                            j(A, i[21675], i[21676]);
                        }
                        function Up(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!r) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 5, 2001, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                    X(i[f >> 2]);
                                    break i;
                                }
                                p[i[i[r >> 2] + 44 >> 2]](A, i[r + 4 >> 2], e);
                            }
                            m = f + 32 | 0;
                        }
                        function Hp(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f = m - 32 | 0, m = f;
                            i: {
                                if (!r) {
                                    if (o[f | 0] = 0, o[f + 11 | 0] = 0, r = A, A = i0(f + 12 | 0, 5, 2001, f), j0(r, A, 0), o[A + 19 | 0] < 0 && X(i[A + 8 >> 2]), o[f + 11 | 0] >= 0) break i;
                                    X(i[f >> 2]);
                                    break i;
                                }
                                p[i[i[r >> 2] + 52 >> 2]](A, i[r + 4 >> 2], e);
                            }
                            m = f + 32 | 0;
                        }
                        function z9(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            if (f = i[A >> 2], r = o[f | 0] - 48 | 0, r >>> 0 > 9) return 0;
                            for(; k = -1, e >>> 0 <= 214748364 && (e = Z(e, 10), k = (e ^ 2147483647) >>> 0 < r >>> 0 ? -1 : e + r | 0), r = f + 1 | 0, i[A >> 2] = r, n = o[f + 1 | 0], e = k, f = r, r = n - 48 | 0, r >>> 0 < 10;);
                            return e;
                        }
                        function xp(A, r) {
                            if (A = A | 0, r = r | 0, !r) {
                                r = i[19869], i[A >> 2] = i[19868], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19870];
                                return;
                            }
                            if (i[r >> 2] >= 4) {
                                r = i[19875], i[A >> 2] = i[19874], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19876];
                                return;
                            }
                            k9(r), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                        }
                        function zp(A, r) {
                            if (A = A | 0, r = r | 0, !r) {
                                r = i[19869], i[A >> 2] = i[19868], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19870];
                                return;
                            }
                            if (i[r >> 2] >= 4) {
                                r = i[19875], i[A >> 2] = i[19874], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19876];
                                return;
                            }
                            e9(r), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                        }
                        function Tp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 16 | 0, m = t, i[t + 12 >> 2] = r, u = t + 8 | 0, r = i[f + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108580), d0(u), Ut(A, n + 24 | 0, t + 12 | 0, e, k, r), m = t + 16 | 0, i[t + 12 >> 2];
                        }
                        function Sp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 16 | 0, m = t, i[t + 12 >> 2] = r, u = t + 8 | 0, r = i[f + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108580), d0(u), Jt(A, n + 16 | 0, t + 12 | 0, e, k, r), m = t + 16 | 0, i[t + 12 >> 2];
                        }
                        function jp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 16 | 0, m = t, i[t + 12 >> 2] = r, u = t + 8 | 0, r = i[f + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108572), d0(u), Ht(A, n + 24 | 0, t + 12 | 0, e, k, r), m = t + 16 | 0, i[t + 12 >> 2];
                        }
                        function Op(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 16 | 0, m = t, i[t + 12 >> 2] = r, u = t + 8 | 0, r = i[f + 28 >> 2], i[u >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(u, 108572), d0(u), Rt(A, n + 16 | 0, t + 12 | 0, e, k, r), m = t + 16 | 0, i[t + 12 >> 2];
                        }
                        function T9(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (I2(+A), f = c0(1) | 0, k = c0(0) | 0, e = f >>> 20 & 2047, (e | 0) != 2047) {
                                if (!e) return A == 0 ? e = 0 : (A = T9(A * 18446744073709552e3, r), e = i[r >> 2] + -64 | 0), i[r >> 2] = e, A;
                                i[r >> 2] = e - 1022, J2(0, k | 0), J2(1, f & -2146435073 | 1071644672), A = +o1();
                            }
                            return A;
                        }
                        function Pp(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            A = i[A >> 2], f = i[A + 80 >> 2], A = i[A + 84 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), !e | !f || (i[r >> 2] = i[f + 36 >> 2], k = 1);
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return k | 0;
                        }
                        function Lp(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = i[i[r + 32 >> 2] + 108 >> 2], i[f >> 2] = r, i[e >> 2] = !r << 1, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function S0(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = i[A + 64 >> 2], e = 255;
                            i: {
                                if (!f) break i;
                                for(k = A - -64 | 0, A = k; e = i[f + 16 >> 2] < (r | 0), A = e ? A : f, f = i[(e << 2) + f >> 2], !!f;);
                                if (e = 255, (A | 0) == (k | 0) || (e = 255, i[A + 16 >> 2] > (r | 0))) break i;
                                e = l[A + 24 | 0];
                            }
                            return e;
                        }
                        function Kp(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = l[i[r + 32 >> 2] + 121 | 0], i[f >> 2] = r, i[e >> 2] = !r << 1, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function Ji(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            if (A) {
                                r = i[A + 12 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                r = i[A + 4 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                X(A);
                            }
                        }
                        function qp(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = l[i[r + 32 >> 2] + 110 | 0], i[f >> 2] = r, i[e >> 2] = !r << 1, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function S9(A, r) {
                            if (i[A >> 2] = i[r >> 2], r = i[r + 4 >> 2], i[A + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = i[21669], i[A + 8 >> 2] = i[21668], i[A + 12 >> 2] = r, A = A + 16 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function $p(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            if (i[A >> 2] = 74588, f = i[A + 104 >> 2], f) {
                                if (r = f, e = i[A + 108 >> 2], (r | 0) != (e | 0)) {
                                    for(; r = i[e - 12 >> 2], r && (i[e - 8 >> 2] = r, X(r)), e = e - 16 | 0, (f | 0) != (e | 0););
                                    r = i[A + 104 >> 2];
                                }
                                i[A + 108 >> 2] = f, X(r);
                            }
                            return V2(A) | 0;
                        }
                        function Ri(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            return e = A * A, f = e * .5, k = 1 - f, n = 1 - k - f, f = e * e, k + (n + (e * (e * (e * (e * 2480158728947673e-20 + -0.001388888888887411) + .0416666666666666) + f * f * (e * (e * -0.000000000011359647557788195 + 2087572321298175e-24) + -0.00000027557314351390663)) - A * r));
                        }
                        function G1(A) {
                            var r = 0, e = 0;
                            i: {
                                if (r = i[A + 4 >> 2], e = i[i[r >> 2] - 12 >> 2], e = r + e | 0, !i[e + 24 >> 2] | (i[e + 16 >> 2] | !(i[e + 4 >> 2] & 8192)) || (r = i[(r + i[i[r >> 2] - 12 >> 2] | 0) + 24 >> 2], (p[i[i[r >> 2] + 24 >> 2]](r) | 0) != -1)) break i;
                                A = i[A + 4 >> 2], M4(i[i[A >> 2] - 12 >> 2] + A | 0, 1);
                            }
                        }
                        function j9(A, r, e, f) {
                            var k = 0, n = 0, t = 0;
                            n = i[A + 4 >> 2], t = n & 1;
                            i: {
                                if (l[r + 55 | 0] == 1) {
                                    if (k = n >> 8, !t) break i;
                                    k = i[i[e >> 2] + k >> 2];
                                    break i;
                                }
                                if (k = n >> 8, !t) break i;
                                i[r + 56 >> 2] = i[i[A >> 2] + 4 >> 2], n = i[A + 4 >> 2], e = 0, k = 0;
                            }
                            A = i[A >> 2], p[i[i[A >> 2] + 28 >> 2]](A, r, e + k | 0, n & 2 ? f : 2);
                        }
                        function O9(A) {
                            var r = 0, e = 0;
                            for(r = m - 16 | 0, m = r, i[r + 4 >> 2] = 108404, e = i[27102], i[r + 8 >> 2] = e, i[r + 12 >> 2] = e + (A << 2), A = i[r + 8 >> 2], e = i[r + 12 >> 2];;){
                                if ((A | 0) == (e | 0)) i[i[r + 4 >> 2] + 4 >> 2] = i[r + 8 >> 2], m = r + 16 | 0;
                                else {
                                    i[A >> 2] = 0, A = A + 4 | 0, i[r + 8 >> 2] = A;
                                    continue;
                                }
                                break;
                            }
                        }
                        function r6(A, r, e) {
                            var f = 0, k = 0;
                            k = m - 16 | 0, m = k, f = m - 32 | 0, m = f, lr(f + 24 | 0, A, (r << 2) + A | 0), Vt(f + 16 | 0, i[f + 24 >> 2], i[f + 28 >> 2], e), i[f + 12 >> 2] = (i[f + 16 >> 2] - A | 0) + A, i[f + 8 >> 2] = (i[f + 20 >> 2] - e | 0) + e, i[k + 8 >> 2] = i[f + 12 >> 2], i[k + 12 >> 2] = i[f + 8 >> 2], m = f + 32 | 0, m = k + 16 | 0;
                        }
                        function ap(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            return A = m - 16 | 0, m = A, i[A + 12 >> 2] = r, t = A + 8 | 0, r = i[f + 28 >> 2], i[t >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(t, 108580), d0(t), at(n + 20 | 0, A + 12 | 0, e, k, r), m = A + 16 | 0, i[A + 12 >> 2];
                        }
                        function bp(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            return A = m - 16 | 0, m = A, i[A + 12 >> 2] = r, t = A + 8 | 0, r = i[f + 28 >> 2], i[t >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(t, 108572), d0(t), bt(n + 20 | 0, A + 12 | 0, e, k, r), m = A + 16 | 0, i[A + 12 >> 2];
                        }
                        function Ni(A) {
                            var r = 0, e = 0;
                            if (r = m - 16 | 0, m = r, i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2]) {
                                C1(r + 8 | 0, A);
                                i: {
                                    if (!l[r + 8 | 0] || (e = i[(i[i[A >> 2] - 12 >> 2] + A | 0) + 24 >> 2], (p[i[i[e >> 2] + 24 >> 2]](e) | 0) != -1)) break i;
                                    M4(i[i[A >> 2] - 12 >> 2] + A | 0, 1);
                                }
                                G1(r + 8 | 0);
                            }
                            m = r + 16 | 0;
                        }
                        function dp(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = i[A >> 2], A = i[e + 180 >> 2], f = i[e + 184 >> 2];
                            i: {
                                if ((A | 0) == (f | 0)) break i;
                                for(;;){
                                    if (e = i[A >> 2], i[e >> 2] != (r | 0)) {
                                        if (A = A + 8 | 0, (f | 0) != (A | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                k = o[e + 27 | 0] < 0 ? i[e + 16 >> 2] : e + 16 | 0;
                            }
                            return k | 0;
                        }
                        function cp(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = i[A >> 2], A = i[e + 180 >> 2], f = i[e + 184 >> 2];
                            i: {
                                if ((A | 0) == (f | 0)) break i;
                                for(;;){
                                    if (e = i[A >> 2], i[e >> 2] != (r | 0)) {
                                        if (A = A + 8 | 0, (f | 0) != (A | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                k = o[e + 39 | 0] < 0 ? i[e + 28 >> 2] : e + 28 | 0;
                            }
                            return k | 0;
                        }
                        function iQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = i[A >> 2], A = i[e + 180 >> 2], f = i[e + 184 >> 2];
                            i: {
                                if ((A | 0) == (f | 0)) break i;
                                for(;;){
                                    if (e = i[A >> 2], i[e >> 2] != (r | 0)) {
                                        if (A = A + 8 | 0, (f | 0) != (A | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                k = o[e + 15 | 0] < 0 ? i[e + 4 >> 2] : e + 4 | 0;
                            }
                            return k | 0;
                        }
                        function eQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            if (i[A >> 2] = 74588, f = i[A + 104 >> 2], f) {
                                if (r = f, e = i[A + 108 >> 2], (r | 0) != (e | 0)) {
                                    for(; r = i[e - 12 >> 2], r && (i[e - 8 >> 2] = r, X(r)), e = e - 16 | 0, (f | 0) != (e | 0););
                                    r = i[A + 104 >> 2];
                                }
                                i[A + 108 >> 2] = f, X(r);
                            }
                            X(V2(A));
                        }
                        function f8(A, r, e) {
                            var f = 0, k = 0;
                            k = m - 16 | 0, m = k, f = m - 32 | 0, m = f, lr(f + 24 | 0, A, A + r | 0), It(f + 16 | 0, i[f + 24 >> 2], i[f + 28 >> 2], e), i[f + 12 >> 2] = (i[f + 16 >> 2] - A | 0) + A, i[f + 8 >> 2] = (i[f + 20 >> 2] - e | 0) + e, i[k + 8 >> 2] = i[f + 12 >> 2], i[k + 12 >> 2] = i[f + 8 >> 2], m = f + 32 | 0, m = k + 16 | 0;
                        }
                        function P9(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = e << 24 | (e & 65280) << 8 | (e >>> 8 & 65280 | e >>> 24), o[f + 12 | 0] = k, o[f + 13 | 0] = k >>> 8, o[f + 14 | 0] = k >>> 16, o[f + 15 | 0] = k >>> 24, k = A + 12 | 0, n = f + 12 | 0, f = f + 16 | 0, G8(k, i[A + 16 >> 2], n, f, 4), G8(k, i[A + 16 >> 2], r, r + e | 0, e), m = f;
                        }
                        function A1(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = A - -64 | 0, A = i[A + 64 >> 2];
                            i: {
                                e: {
                                    if (!A) break e;
                                    for(e = f; k = i[A + 16 >> 2] < (r | 0), e = k ? e : A, A = i[(k << 2) + A >> 2], !!A;);
                                    if ((e | 0) == (f | 0)) break e;
                                    if (i[e + 16 >> 2] <= (r | 0)) break i;
                                }
                                e = f;
                            }
                            return (e | 0) != (f | 0);
                        }
                        function N0(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            for(i[A >> 2] = 60660, r = i[A + 40 >> 2];;){
                                if (r) {
                                    r = r - 1 | 0, e = r << 2, p[i[i[A + 32 >> 2] + e >> 2]](0, A, i[e + i[A + 36 >> 2] >> 2]);
                                    continue;
                                }
                                break;
                            }
                            return d0(A + 28 | 0), X(i[A + 32 >> 2]), X(i[A + 36 >> 2]), X(i[A + 48 >> 2]), X(i[A + 60 >> 2]), A | 0;
                        }
                        function rQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = i[A >> 2], A = i[e + 180 >> 2], f = i[e + 184 >> 2];
                            i: {
                                if ((A | 0) == (f | 0)) break i;
                                for(;;){
                                    if (e = i[A >> 2], i[e >> 2] != (r | 0)) {
                                        if (A = A + 8 | 0, (f | 0) != (A | 0)) continue;
                                        break i;
                                    }
                                    break;
                                }
                                k = i[e + 44 >> 2] - i[e + 40 >> 2] | 0;
                            }
                            return k | 0;
                        }
                        function W4(A, r, e) {
                            if (e = i[e + 4 >> 2] & 176, (e | 0) == 32) return r;
                            i: {
                                if ((e | 0) != 16) break i;
                                e: {
                                    r: switch(e = l[A | 0], e - 43 | 0){
                                        case 0:
                                        case 2:
                                            break r;
                                        default:
                                            break e;
                                    }
                                    return A + 1 | 0;
                                }
                                if ((e | 0) != 48 | (r - A | 0) < 2 | (l[A + 1 | 0] | 32) != 120) break i;
                                A = A + 2 | 0;
                            }
                            return A;
                        }
                        function L9(A, r) {
                            var e = 0, f = 0, k = 0;
                            f = A + 20 | 0, A = i[A + 20 >> 2];
                            i: {
                                e: {
                                    if (!A) break e;
                                    for(e = f; k = k0[A + 16 >> 2] < r >>> 0, e = k ? e : A, A = i[(k << 2) + A >> 2], !!A;);
                                    if ((e | 0) == (f | 0)) break e;
                                    if (k0[e + 16 >> 2] <= r >>> 0) break i;
                                }
                                e = f;
                            }
                            return (e | 0) != (f | 0);
                        }
                        function AQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = p[i[i[A >> 2] + 68 >> 2]](i[A + 4 >> 2]) | 0, A = i[e >> 2];
                            i: {
                                if (!A) break i;
                                for(;;){
                                    if (d1(i[A + 4 >> 2], r)) {
                                        if (A = i[e + 4 >> 2], e = e + 4 | 0, A) continue;
                                        break i;
                                    }
                                    break;
                                }
                                if (f = 1, i[A >> 2] < 2) break i;
                                f = i[A + 36 >> 2];
                            }
                            return f | 0;
                        }
                        function Y6(A, r, e) {
                            var f = 0, k = 0;
                            i: {
                                if (!o4(A, e) || (k = i[A >> 2], f = i[A + 4 >> 2], f && (i[f + 4 >> 2] = i[f + 4 >> 2] + 1), p[i[i[k >> 2] + 16 >> 2]](k, r, e) | 0 || D4(A), !f) || (A = i[f + 4 >> 2], i[f + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[f >> 2] + 8 >> 2]](f), g(f);
                            }
                        }
                        function fQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            i: {
                                if (!l[A + 44 | 0]) for(e = (e | 0) > 0 ? e : 0;;){
                                    if ((e | 0) == (f | 0)) break i;
                                    if ((p[i[i[A >> 2] + 52 >> 2]](A, i[r >> 2]) | 0) == -1) return f | 0;
                                    r = r + 4 | 0, f = f + 1 | 0;
                                }
                                e = E1(r, 4, e, i[A + 32 >> 2]);
                            }
                            return e | 0;
                        }
                        function kQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            i: {
                                if (!l[A + 44 | 0]) for(e = (e | 0) > 0 ? e : 0;;){
                                    if ((e | 0) == (f | 0)) break i;
                                    if ((p[i[i[A >> 2] + 52 >> 2]](A, l[r | 0]) | 0) == -1) return f | 0;
                                    r = r + 1 | 0, f = f + 1 | 0;
                                }
                                e = E1(r, 1, e, i[A + 32 >> 2]);
                            }
                            return e | 0;
                        }
                        function nQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            if (r = m - 16 | 0, m = r, i[r + 12 >> 2] = i[A + 8 >> 2], e = j4(r + 8 | 0, r + 12 | 0), f = Qn(0, 0, 4), e = i[e >> 2], e && (i[26106] = (e | 0) == -1 ? 104304 : e), m = r + 16 | 0, f) A = -1;
                            else {
                                if (A = i[A + 8 >> 2], !A) return 1;
                                A = (Bt(A) | 0) == 1;
                            }
                            return A | 0;
                        }
                        function K9(A, r, e, f, k, n) {
                            var t = 0, u = 0, s = 0;
                            t = m - 16 | 0, m = t, o[t + 15 | 0] = 0, o[t + 14 | 0] = n, o[t + 13 | 0] = k, o[t + 12 | 0] = 37, n && (k = l[t + 13 | 0], o[t + 13 | 0] = l[t + 14 | 0], o[t + 14 | 0] = k), u = e, s = (js(r | 0, i[e >> 2] - r | 0, t + 12 | 0, f | 0, i[A >> 2]) | 0) + r | 0, i[u >> 2] = s, m = t + 16 | 0;
                        }
                        function a1(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (e = E2(r), e >>> 0 < 2147483640) {
                                i: {
                                    e: {
                                        if (e >>> 0 >= 11) {
                                            k = (e | 7) + 1 | 0, f = D(k), i[A + 8 >> 2] = k | -2147483648, i[A >> 2] = f, i[A + 4 >> 2] = e;
                                            break e;
                                        }
                                        if (o[A + 11 | 0] = e, f = A, !e) break i;
                                    }
                                    Q0(f, r, e);
                                }
                                return o[e + f | 0] = 0, A;
                            }
                            Y0(), z();
                        }
                        function CA(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            i: switch(r | 0){
                                case 6:
                                    o[A + 514 | 0] = (e | 0) != 0;
                                    return;
                                case 7:
                                    o[A + 532 | 0] = (e | 0) != 0;
                                    return;
                                case 8:
                                    o[A + 533 | 0] = (e | 0) != 0;
                                    return;
                                default:
                                    y0(10076, 15085, 535, 8001), z();
                                case 0:
                                    break i;
                            }
                            o[A + 512 | 0] = (e | 0) != 0;
                        }
                        function tQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            r = i[A >> 2], A = i[r + 200 >> 2], r = i[r + 204 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), A = A ? i[A + 12 >> 2] - i[A + 8 >> 2] | 0 : 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function Di(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 16 | 0, m = f, k = f + 12 | 0, r = i[r + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108644), n = e, t = p[i[i[r >> 2] + 16 >> 2]](r) | 0, i[n >> 2] = t, p[i[i[r >> 2] + 20 >> 2]](A, r), d0(k), m = f + 16 | 0;
                        }
                        function Mi(A, r, e) {
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 16 | 0, m = f, k = f + 12 | 0, r = i[r + 28 >> 2], i[k >> 2] = r, (r | 0) != 108396 && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), r = K0(k, 108636), n = e, t = p[i[i[r >> 2] + 16 >> 2]](r) | 0, o[n | 0] = t, p[i[i[r >> 2] + 20 >> 2]](A, r), d0(k), m = f + 16 | 0;
                        }
                        function oQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            r = i[A >> 2], A = i[r + 52 >> 2], r = i[r + 56 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), A = A ? i[A + 12 >> 2] - i[A + 8 >> 2] | 0 : 0;
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function m2(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0;
                            return n = r ^ f, t = n >> 31, k = r >> 31, A = A ^ k, u = A - k | 0, k = (r ^ k) - ((A >>> 0 < k >>> 0) + k | 0) | 0, A = f >> 31, r = e ^ A, n = n >> 31, A = _6(u, k, r - A | 0, (A ^ f) - ((A >>> 0 > r >>> 0) + A | 0) | 0) ^ n, r = A - n | 0, w0 = (t ^ w0) - ((A >>> 0 < n >>> 0) + t | 0) | 0, r;
                        }
                        function q9(A, r) {
                            if (A = A | 0, r = r | 0, i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0, r = i[21669], i[A + 12 >> 2] = i[21668], i[A + 16 >> 2] = r, A = A + 20 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function T4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = i[A + 64 >> 2];
                            i: {
                                if (!e) break i;
                                for(f = A - -64 | 0, A = f; k = i[e + 16 >> 2] < (r | 0), A = k ? A : e, e = i[(k << 2) + e >> 2], !!e;);
                                if ((A | 0) == (f | 0) | i[A + 16 >> 2] > (r | 0)) break i;
                                n = i[A + 28 >> 2];
                            }
                            return n;
                        }
                        function S4(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = i[A + 64 >> 2];
                            i: {
                                if (!e) break i;
                                for(f = A - -64 | 0, A = f; k = i[e + 16 >> 2] < (r | 0), A = k ? A : e, e = i[(k << 2) + e >> 2], !!e;);
                                if ((A | 0) == (f | 0) | i[A + 16 >> 2] > (r | 0)) break i;
                                n = i[A + 32 >> 2];
                            }
                            return n;
                        }
                        function $9(A, r) {
                            var e = 0, f = 0, k = 0;
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                if (e = i[r + 4 >> 2], e) {
                                    if (e >>> 0 >= 1073741824) break i;
                                    f = e << 2, e = D(f), i[A + 4 >> 2] = e, i[A >> 2] = e, k = e + f | 0, i[A + 8 >> 2] = k, Q0(e, i[r >> 2], f), i[A + 4 >> 2] = k;
                                }
                                return A;
                            }
                            p0(), z();
                        }
                        function uQ(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, i[e >> 2] = 1, i[f >> 2] = 3, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function lQ(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, i[e >> 2] = 0, i[f >> 2] = 3, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function Y4(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            k = m - 16 | 0, m = k, f = i[A + 4 >> 2], n = i[A + 8 >> 2] & 2147483647;
                            i: {
                                if (n >>> 0 > e >>> 0) {
                                    f = i[A >> 2], i[A + 4 >> 2] = e, f8(r, e, f), o[k + 15 | 0] = 0, o[e + f | 0] = l[k + 15 | 0];
                                    break i;
                                }
                                xe(A, n - 1 | 0, (e - n | 0) + 1 | 0, f, 0, f, e, r);
                            }
                            m = k + 16 | 0;
                        }
                        function X4(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = l[A + 11 | 0], n = k & 127;
                            i: {
                                if (e >>> 0 <= 10) {
                                    o[A + 11 | 0] = k & 128 | e & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127, f8(r, e, A), o[f + 15 | 0] = 0, o[A + e | 0] = l[f + 15 | 0];
                                    break i;
                                }
                                xe(A, 10, e - 10 | 0, n, 0, n, e, r);
                            }
                            m = f + 16 | 0;
                        }
                        function O0(A, r, e, f) {
                            var k = 0, n = 0, t = 0, u = 0, s = 0, h = 0;
                            return k = e >>> 16 | 0, n = A >>> 16 | 0, h = Z(k, n), t = e & 65535, u = A & 65535, s = Z(t, u), n = (s >>> 16 | 0) + Z(n, t) | 0, k = (n & 65535) + Z(k, u) | 0, w0 = (Z(r, e) + h | 0) + Z(A, f) + (n >>> 16) + (k >>> 16) | 0, s & 65535 | k << 16;
                        }
                        function sQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            if (e = i[r + 380 >> 2], i[A >> 2] = i[r + 376 >> 2], i[A + 4 >> 2] = e, A = A + 8 | 0, o[r + 395 | 0] >= 0) {
                                r = r + 384 | 0, e = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = e, i[A + 8 >> 2] = i[r + 8 >> 2];
                                return;
                            }
                            j(A, i[r + 384 >> 2], i[r + 388 >> 2]);
                        }
                        function VA(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            return f = R8(A), k = p[i[A + 12 >> 2]](A) | 0, o[A | 0] & 1 || (r = i[A + 56 >> 2], e = i[A + 52 >> 2], e && (i[e + 56 >> 2] = r), r && (i[r + 52 >> 2] = e), i[26067] == (A | 0) && (i[26067] = r), X(i[A + 96 >> 2]), X(A)), f | k;
                        }
                        function hQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0, t = 0;
                            A = i[A >> 2], e = i[A + 92 >> 2], f = i[A + 96 >> 2], k = i[A + 84 >> 2], n = i[A + 88 >> 2], t = i[A + 104 >> 2], i[r + 16 >> 2] = i[A + 100 >> 2], i[r + 20 >> 2] = t, i[r + 8 >> 2] = e, i[r + 12 >> 2] = f, i[r >> 2] = k, i[r + 4 >> 2] = n;
                        }
                        function wQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0, n = 0;
                            return e = m - 16 | 0, m = e, k = e + 4 | 0, p[i[A >> 2]](k, r), r = o[e + 15 | 0], A = (r | 0) < 0, r = A ? i[e + 8 >> 2] : r, f = Q2(r + 4 | 0), i[f >> 2] = r, n = i[e + 4 >> 2], v0(f + 4 | 0, A ? n : k, r), A && X(n), m = e + 16 | 0, f | 0;
                        }
                        function vQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            i: {
                                if ((r | 0) < 16 || (r = l[A + 12 | 0], !r) || (e = l[A + 13 | 0], !e) || (f = l[A + 14 | 0], !f) || (A = l[A + 15 | 0], !A)) break i;
                                k = A | (e << 16 | r << 24 | f << 8);
                            }
                            return k | 0;
                        }
                        function w2(A, r) {
                            var e = 0, f = 0, k = 0, n = 0;
                            e = i[A + 12 >> 2], k = e + 2 | 0, f = i[A >> 2], n = i[A + 4 >> 2] - f | 0, k >>> 0 > n >>> 0 && (r1(A, k - n | 0), f = i[A >> 2], e = i[A + 12 >> 2]), i[A + 12 >> 2] = e + 1, o[e + f | 0] = r >>> 8, e = i[A + 12 >> 2], i[A + 12 >> 2] = e + 1, o[e + i[A >> 2] | 0] = r;
                        }
                        function yA(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            i: {
                                if ((r | 0) < 12 || (r = l[A + 8 | 0], !r) || (e = l[A + 9 | 0], !e) || (f = l[A + 10 | 0], !f) || (A = l[A + 11 | 0], !A)) break i;
                                k = A | (e << 16 | r << 24 | f << 8);
                            }
                            return k | 0;
                        }
                        function _Q(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            r && (e = i[r + 4 >> 2], A = i[A >> 2], i[A + 84 >> 2] = i[r >> 2], i[A + 88 >> 2] = e, e = i[r + 20 >> 2], i[A + 100 >> 2] = i[r + 16 >> 2], i[A + 104 >> 2] = e, e = i[r + 12 >> 2], i[A + 92 >> 2] = i[r + 8 >> 2], i[A + 96 >> 2] = e, o[A + 108 | 0] = 1);
                        }
                        function BQ(A) {
                            A = A | 0;
                            var r = 0;
                            o[A + 11 | 0] = 6, o[A + 6 | 0] = 0, r = l[17506] | l[17507] << 8 | (l[17508] << 16 | l[17509] << 24), o[A | 0] = r, o[A + 1 | 0] = r >>> 8, o[A + 2 | 0] = r >>> 16, o[A + 3 | 0] = r >>> 24, r = l[17510] | l[17511] << 8, o[A + 4 | 0] = r, o[A + 5 | 0] = r >>> 8;
                        }
                        function IA(A, r, e, f, k, n) {
                            var t = 0;
                            if (e - 1 >>> 0 <= 1) {
                                e = 0, t = f >>> 0 < 4 ? i[(f << 2) + 39960 >> 2] : t, i[k >> 2] = ((t + A | 0) - 1 >>> 0) / (t >>> 0), e = f >>> 0 <= 3 ? i[(f << 2) + 39976 >> 2] : e, i[n >> 2] = ((e + r | 0) - 1 >>> 0) / (e >>> 0);
                                return;
                            }
                            i[k >> 2] = A, i[n >> 2] = r;
                        }
                        function a9(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            if (r >>> 0 < 3) return f = r << 2, k = i[(f + A | 0) - -64 >> 2], e && (i[e >> 2] = Z(i[(r ? 44 : 40) + A >> 2], (i[i[A + 124 >> 2] + i[f + 46684 >> 2] >> 2] + 7 | 0) / 8 | 0)), k | 0;
                            y0(18009, 15085, 671, 10527), z();
                        }
                        function mQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            return A = i[A >> 2], r = i[A + 48 >> 2], A = i[A + 52 >> 2], A ? (e = i[A + 4 >> 2], f = e + 1 | 0, i[A + 4 >> 2] = f, r = i[r + 132 >> 2], i[A + 4 >> 2] = e, f || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), r | 0) : i[r + 132 >> 2];
                        }
                        function ZQ(A, r, e) {
                            if (A = A | 0, r = r | 0, e = e | 0, i[r + 8 >> 2] != 3) {
                                r = i[19881], i[A >> 2] = i[19880], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19882];
                                return;
                            }
                            e && (i[e >> 2] = i[r + 16 >> 2]), r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19867];
                        }
                        function b9(A, r) {
                            var e = 0, f = 0, k = 0;
                            i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                            i: {
                                if (e = i[r + 4 >> 2], e) {
                                    if ((e | 0) < 0) break i;
                                    f = D(e), i[A + 4 >> 2] = f, i[A >> 2] = f, k = e + f | 0, i[A + 8 >> 2] = k, Q0(f, i[r >> 2], e), i[A + 4 >> 2] = k;
                                }
                                return A;
                            }
                            p0(), z();
                        }
                        function GQ(A, r, e) {
                            if (A = A | 0, r = r | 0, e = e | 0, G4(e, r + 8 | 0), r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function WQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0;
                            r = m - 16 | 0, m = r, _r(), Ue(r + 4 | 0, A, 0), e = i[r + 8 >> 2], A = i[r + 4 >> 2];
                            i: {
                                e: {
                                    if ((e | 0) != (A | 0)) {
                                        f = i[i[A >> 2] >> 2];
                                        break e;
                                    }
                                    if (!e) break i;
                                }
                                i[r + 8 >> 2] = A, X(A);
                            }
                            return m = r + 16 | 0, (f | 0) != 0 | 0;
                        }
                        function XQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            return A = i[A >> 2], e = i[A + 48 >> 2], A = i[A + 52 >> 2], A ? (i[A + 4 >> 2] = i[A + 4 >> 2] + 1, r = V6(e, r), e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), r | 0) : V6(e, r) | 0;
                        }
                        function pQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            return r = m - 16 | 0, m = r, k = r + 4 | 0, p[A | 0](k), e = o[r + 15 | 0], A = (e | 0) < 0, e = A ? i[r + 8 >> 2] : e, f = Q2(e + 4 | 0), i[f >> 2] = e, n = i[r + 4 >> 2], v0(f + 4 | 0, A ? n : k, e), A && X(n), m = r + 16 | 0, f | 0;
                        }
                        function QQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0, t = 0;
                            f = m - 32 | 0, m = f, k = f + 12 | 0, n = o[e + 11 | 0], t = (n | 0) < 0, M3(k, i[r >> 2], t ? i[e >> 2] : e, t ? i[e + 4 >> 2] : n, 1), j0(A, k, i[r >> 2]), o[f + 31 | 0] < 0 && X(i[f + 20 >> 2]), m = f + 32 | 0;
                        }
                        function FA(A) {
                            var r = 0, e = 0, f = 0, k = 0, n = 0;
                            r = lf(8), i[r >> 2] = 72960, i[r >> 2] = 73072, e = E2(A), f = D(e + 13 | 0), i[f + 8 >> 2] = 0, i[f + 4 >> 2] = e, i[f >> 2] = e, k = r, n = v0(f + 12 | 0, A, e + 1 | 0), i[k + 4 >> 2] = n, i[r >> 2] = 73120, u3(r | 0, 73152, 1), z();
                        }
                        function b1(A, r, e, f, k) {
                            var n = 0;
                            if (n = m - 256 | 0, m = n, !(k & 73728 | (e | 0) <= (f | 0))) {
                                if (f = e - f | 0, e = f >>> 0 < 256, B0(n, r, e ? f : 256), !e) for(; j1(A, n, 256), f = f - 256 | 0, f >>> 0 > 255;);
                                j1(A, n, f);
                            }
                            m = n + 256 | 0;
                        }
                        function CQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            r = K0(r, 108588), i[A + 36 >> 2] = r, e = A, f = p[i[i[r >> 2] + 24 >> 2]](r) | 0, i[e + 44 >> 2] = f, r = i[A + 36 >> 2], e = A, f = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[e + 53 | 0] = f, i[A + 44 >> 2] >= 9 && (w1(), z());
                        }
                        function VQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            r = K0(r, 108596), i[A + 36 >> 2] = r, e = A, f = p[i[i[r >> 2] + 24 >> 2]](r) | 0, i[e + 44 >> 2] = f, r = i[A + 36 >> 2], e = A, f = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[e + 53 | 0] = f, i[A + 44 >> 2] >= 9 && (w1(), z());
                        }
                        function YA(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e, m8(e + 8 | 0, A, r), r = i[i[e + 8 >> 2] + 104 >> 2], A = i[e + 12 >> 2];
                            i: {
                                if (!A || (f = i[A + 4 >> 2], i[A + 4 >> 2] = f - 1, f)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return m = e + 16 | 0, r;
                        }
                        function yQ(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function d9(A, r) {
                            var e = 0, f = 0;
                            if (e = i[A + 8 >> 2], A = i[A + 12 >> 2], (e | 0) != (A | 0)) for(A = A - e >> 2, f = A >>> 0 <= 1 ? 1 : A, A = 0;;){
                                if (i[i[(A << 2) + e >> 2] >> 2] == (r | 0)) return A;
                                if (A = A + 1 | 0, (f | 0) == (A | 0)) break;
                            }
                            return -1;
                        }
                        function c9(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f, n = i[A + 48 >> 2], A = D(4), i[f + 4 >> 2] = A, k = A + 4 | 0, i[f + 12 >> 2] = k, i[A >> 2] = e, i[f + 8 >> 2] = k, J4(n, r, 1835103083, f + 4 | 0), A = i[f + 4 >> 2], A && (i[f + 8 >> 2] = A, X(A)), m = f + 16 | 0;
                        }
                        function it() {
                            var A = 0;
                            return A = D(36), Q[A + 2 >> 1] = 0, Q[A + 4 >> 1] = 0, Q[A >> 1] = 263, o[A + 32 | 0] = 1, o[A + 28 | 0] = 0, i[A + 20 >> 2] = 2, i[A + 24 >> 2] = 2, o[A + 16 | 0] = 1, i[A + 12 >> 2] = 1, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, o[A + 8 | 0] = 0, A | 0;
                        }
                        function et(A, r) {
                            var e = 0;
                            e = i[r >> 2], r = i[r + 4 >> 2], r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[A >> 2] = e, e = i[A + 4 >> 2], i[A + 4 >> 2] = r;
                            i: {
                                if (!e || (A = i[e + 4 >> 2], i[e + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[e >> 2] + 8 >> 2]](e), g(e);
                            }
                        }
                        function Ui(A, r) {
                            var e = 0, f = 0;
                            return e = m - 16 | 0, m = e, f = e + 12 | 0, A = i[A + 28 >> 2], i[f >> 2] = A, (A | 0) != 108396 && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), A = K0(f, 108572), p[i[i[A >> 2] + 48 >> 2]](A, 64960, 64986, r), d0(f), m = e + 16 | 0, r;
                        }
                        function IQ(A) {
                            A = A | 0;
                            var r = 0, e = 0, f = 0, k = 0;
                            i: {
                                if (!A || (r = l[A | 0], !r) || (e = l[A + 1 | 0], !e) || (f = l[A + 2 | 0], !f) || (A = l[A + 3 | 0], !A)) break i;
                                k = A | (e << 16 | r << 24 | f << 8);
                            }
                            return k | 0;
                        }
                        function A6(A, r) {
                            var e = 0, f = 0;
                            e = i[r >> 2], f = i[r + 4 >> 2], i[r >> 2] = 0, i[r + 4 >> 2] = 0, r = i[A + 4 >> 2], i[A >> 2] = e, i[A + 4 >> 2] = f;
                            i: {
                                if (!r || (A = i[r + 4 >> 2], i[r + 4 >> 2] = A - 1, A)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                        }
                        function FQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80072, r = i[A + 16 >> 2], r && (i[A + 20 >> 2] = r, X(r)), r = i[A + 8 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return A | 0;
                        }
                        function rt(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i: {
                                if (i[A + 2192 >> 2] <= 0 || (r = i[A + 2188 >> 2], r = i[i[i[A + 2176 >> 2] + (r >>> 8 & 16777212) >> 2] + ((r & 1023) << 2) >> 2], !r)) break i;
                                o[r + 104 | 0] = 0, vt(A + 2140 | 0), e = r;
                            }
                            return e | 0;
                        }
                        function At(A, r) {
                            var e = 0, f = 0;
                            i: {
                                if (e = i[A >> 2], !e) break i;
                                f = i[e + 24 >> 2];
                                e: {
                                    if ((f | 0) == i[e + 28 >> 2]) {
                                        r = p[i[i[e >> 2] + 52 >> 2]](e, r) | 0;
                                        break e;
                                    }
                                    i[e + 24 >> 2] = f + 4, i[f >> 2] = r;
                                }
                                if ((r | 0) != -1) break i;
                                i[A >> 2] = 0;
                            }
                        }
                        function EA(A, r) {
                            var e = 0, f = 0;
                            f = m - 16 | 0, m = f, o[A | 0] = 0, e = i[i[r >> 2] - 12 >> 2] + r | 0;
                            i: {
                                if (!i[e + 16 >> 2]) {
                                    i[e + 72 >> 2] && Ni(i[e + 72 >> 2]), o[A | 0] = !i[(i[i[r >> 2] - 12 >> 2] + r | 0) + 16 >> 2];
                                    break i;
                                }
                                M4(e, 4);
                            }
                            m = f + 16 | 0;
                        }
                        function YQ() {
                            var A = 0;
                            return A = D(48), i[A + 24 >> 2] = 0, Q[A >> 1] = 6, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 44 >> 2] = 0, o[A + 40 | 0] = 0, i[A + 32 >> 2] = 2, i[A + 36 >> 2] = 2, o[A + 28 | 0] = 1, i[A + 12 >> 2] = 0, i[A + 16 >> 2] = 0, Q[A + 20 >> 1] = 0, A | 0;
                        }
                        function ft(A, r, e, f) {
                            var k = 0;
                            if (r - 1 >>> 0 > 1) return A;
                            r = 0, k = e >>> 0 <= 3 ? i[(e << 2) + 39960 >> 2] : k;
                            i: switch(f | 0){
                                case 1:
                                    A = (A + k | 0) - 1 | 0;
                                case 0:
                                case 2:
                                    r = (A >>> 0) / (k >>> 0) | 0;
                                    break;
                                default:
                                    break i;
                            }
                            return r;
                        }
                        function kt(A, r, e, f) {
                            var k = 0;
                            if (r - 1 >>> 0 > 1) return A;
                            r = 0, k = e >>> 0 <= 3 ? i[(e << 2) + 39976 >> 2] : k;
                            i: switch(f | 0){
                                case 1:
                                    A = (A + k | 0) - 1 | 0;
                                case 0:
                                case 2:
                                    r = (A >>> 0) / (k >>> 0) | 0;
                                    break;
                                default:
                                    break i;
                            }
                            return r;
                        }
                        function gA(A) {
                            var r = 0;
                            return r = i[A + 72 >> 2], i[A + 72 >> 2] = r - 1 | r, r = i[A >> 2], r & 8 ? (i[A >> 2] = r | 32, -1) : (i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, r = i[A + 44 >> 2], i[A + 28 >> 2] = r, i[A + 20 >> 2] = r, i[A + 16 >> 2] = r + i[A + 48 >> 2], 0);
                        }
                        function nt(A, r, e, f) {
                            i: {
                                if (!A) break i;
                                e: switch(r + 2 | 0){
                                    case 0:
                                        o[A | 0] = e;
                                        return;
                                    case 1:
                                        Q[A >> 1] = e;
                                        return;
                                    case 2:
                                    case 3:
                                        i[A >> 2] = e;
                                        return;
                                    case 5:
                                        break e;
                                    default:
                                        break i;
                                }
                                i[A >> 2] = e, i[A + 4 >> 2] = f;
                            }
                        }
                        function JA(A, r, e, f, k, n, t, u, s) {
                            var h = 0;
                            h = m - 16 | 0, m = h, l4(h, r, e, f, k, n, t, u, s ^ -2147483648), f = i[h >> 2], e = i[h + 4 >> 2], r = i[h + 12 >> 2], i[A + 8 >> 2] = i[h + 8 >> 2], i[A + 12 >> 2] = r, i[A >> 2] = f, i[A + 4 >> 2] = e, m = h + 16 | 0;
                        }
                        function EQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            return f = i[A + 36 >> 2], k = i[A + 32 >> 2], (f | 0) == (e | 0) & r >>> 0 <= k >>> 0 | e >>> 0 < f >>> 0 && (i[A + 40 >> 2] = r, i[A + 44 >> 2] = e), (e | 0) == (f | 0) & r >>> 0 <= k >>> 0 | e >>> 0 < f >>> 0;
                        }
                        function gQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0, n = 0;
                            return k = i[A + 84 >> 2], f = e + 256 | 0, n = d3(k, 0, f), f = n ? n - k | 0 : f, e = e >>> 0 > f >>> 0 ? f : e, v0(r, k, e), r = k + f | 0, i[A + 84 >> 2] = r, i[A + 8 >> 2] = r, i[A + 4 >> 2] = e + k, e | 0;
                        }
                        function d1(A, r) {
                            var e = 0, f = 0;
                            e = l[A | 0], f = l[r | 0];
                            i: {
                                if (!e | (e | 0) != (f | 0)) break i;
                                for(;;){
                                    if (f = l[r + 1 | 0], e = l[A + 1 | 0], !e) break i;
                                    if (r = r + 1 | 0, A = A + 1 | 0, (e | 0) != (f | 0)) break;
                                }
                            }
                            return e - f | 0;
                        }
                        function JQ(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0, u = 0;
                            return t = m - 16 | 0, m = t, i[t + 8 >> 2] = 624576549, i[t + 12 >> 2] = 1394948685, u = A, A = t + 16 | 0, r = Z8(u, r, e, f, k, n, t + 8 | 0, A), m = A, r | 0;
                        }
                        function tt(A, r) {
                            var e = 0;
                            i: {
                                if (!r || (r = E0(r, 72044, 72300), !r | i[r + 8 >> 2] & (i[A + 8 >> 2] ^ -1)) || !Y1(i[A + 12 >> 2], i[r + 12 >> 2], 0)) break i;
                                e = Y1(i[A + 16 >> 2], i[r + 16 >> 2], 0);
                            }
                            return e;
                        }
                        function ot(A, r) {
                            if (A = A | 0, r = r | 0, r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function RQ(A) {
                            return A = A | 0, i[A >> 2] = 74240, o[A + 163 | 0] < 0 && X(i[A + 152 >> 2]), o[A + 151 | 0] < 0 && X(i[A + 140 >> 2]), o[A + 139 | 0] < 0 && X(i[A + 128 >> 2]), o[A + 127 | 0] < 0 && X(i[A + 116 >> 2]), V2(A) | 0;
                        }
                        function NQ(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, A = m - 16 | 0, m = A, i[A + 12 >> 2] = k, i[A + 8 >> 2] = f - e, r = m - 16 | 0, m = r, m = r + 16 | 0, m = A + 16 | 0, r = A + 8 | 0, A = A + 12 | 0, i[(k0[r >> 2] < k0[A >> 2] ? r : A) >> 2];
                        }
                        function DQ(A) {
                            return A = A | 0, i[A >> 2] = 76052, o[A + 151 | 0] < 0 && X(i[A + 140 >> 2]), o[A + 139 | 0] < 0 && X(i[A + 128 >> 2]), o[A + 127 | 0] < 0 && X(i[A + 116 >> 2]), o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), V2(A) | 0;
                        }
                        function M8(A) {
                            var r = 0, e = 0;
                            return l[A + 11 | 0] >>> 7 | 0 ? r = i[A >> 2] : r = A, l[A + 11 | 0] >>> 7 | 0 ? e = i[A + 4 >> 2] : e = l[A + 11 | 0] & 127, A = m - 16 | 0, m = A, i[A + 12 >> 2] = (e << 2) + r, m = A + 16 | 0, i[A + 12 >> 2];
                        }
                        function MQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0, k = 0;
                            return f = i[A + 36 >> 2], k = i[A + 32 >> 2], (f | 0) == (e | 0) & r >>> 0 <= k >>> 0 | e >>> 0 < f >>> 0 && lA(i[A + 24 >> 2], r, e, 0), (e | 0) == (f | 0) & r >>> 0 <= k >>> 0 | e >>> 0 < f >>> 0;
                        }
                        function E6(A) {
                            A = A | 0;
                            var r = 0;
                            return r = i[14959], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[14967], i[A + 12 >> 2] = 58864, i[A + 8 >> 2] = i[14968], o[A + 55 | 0] < 0 && X(i[A + 44 >> 2]), x0(A + 12 | 0), N0(A - -64 | 0), A | 0;
                        }
                        function ut(A, r) {
                            var e = 0, f = 0, k = 0;
                            if (e = i[A + 4 >> 2], e >>> 0 < k0[A + 8 >> 2]) {
                                i[e >> 2] = i[r >> 2], r = i[r + 4 >> 2], i[e + 4 >> 2] = r, r && (i[r + 4 >> 2] = i[r + 4 >> 2] + 1), i[A + 4 >> 2] = e + 8;
                                return;
                            }
                            f = A, k = P2(A, r), i[f + 4 >> 2] = k;
                        }
                        function UQ(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            k = m - 32 | 0, m = k, z1(k + 12 | 0, r, e), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]);
                            i: {
                                if (l[r + 97 | 0]) {
                                    s4(A, r, 15153);
                                    break i;
                                }
                                Ze(A, r, e, -1, f);
                            }
                            m = k + 32 | 0;
                        }
                        function HQ(A, r, e, f) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = i[r >> 2], A >>> 0 <= 127 ? A = i[(A << 2) + 65280 >> 2] : A = 0, i[f >> 2] = A, f = f + 4 | 0, r = r + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function g6(A) {
                            var r = 0, e = 0;
                            r = i[21623], e = A + 7 & -8, A = r + e | 0;
                            i: {
                                if (!(A >>> 0 <= r >>> 0 && e) && (A >>> 0 <= hu() << 16 >>> 0 || Ls(A | 0) | 0)) break i;
                                return i[26064] = 48, -1;
                            }
                            return i[21623] = A, r;
                        }
                        function rr(A, r, e, f) {
                            var k = 0;
                            return k = m - 16 | 0, m = k, e = c8(i[A + 52 >> 2], e), A = i[A + 60 >> 2], e = e + 1 | 0, Q[k + 14 >> 1] = e, o[k + 12 | 0] = f, i[k + 8 >> 2] = I[k + 12 >> 1] | I[k + 14 >> 1] << 16, v6(A, r, k + 8 | 0), m = k + 16 | 0, e;
                        }
                        function J6(A) {
                            var r = 0;
                            if (r = i[21669], i[A >> 2] = i[21668], i[A + 4 >> 2] = r, A = A + 8 | 0, o[86691] >= 0) {
                                r = i[21671], i[A >> 2] = i[21670], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[21672];
                                return;
                            }
                            j(A, i[21670], i[21671]);
                        }
                        function xQ(A) {
                            A = A | 0, i[A >> 2] = 74240, o[A + 163 | 0] < 0 && X(i[A + 152 >> 2]), o[A + 151 | 0] < 0 && X(i[A + 140 >> 2]), o[A + 139 | 0] < 0 && X(i[A + 128 >> 2]), o[A + 127 | 0] < 0 && X(i[A + 116 >> 2]), X(V2(A));
                        }
                        function zQ(A) {
                            A = A | 0, i[A >> 2] = 76052, o[A + 151 | 0] < 0 && X(i[A + 140 >> 2]), o[A + 139 | 0] < 0 && X(i[A + 128 >> 2]), o[A + 127 | 0] < 0 && X(i[A + 116 >> 2]), o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), X(V2(A));
                        }
                        function U8(A) {
                            var r = 0, e = 0;
                            return l[A + 11 | 0] >>> 7 | 0 ? r = i[A >> 2] : r = A, l[A + 11 | 0] >>> 7 | 0 ? e = i[A + 4 >> 2] : e = l[A + 11 | 0] & 127, A = m - 16 | 0, m = A, i[A + 12 >> 2] = r + e, m = A + 16 | 0, i[A + 12 >> 2];
                        }
                        function TQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = D(8), i[e >> 2] = 0, i[e + 4 >> 2] = 0, f = i[21479], i[A >> 2] = i[21478], i[A + 4 >> 2] = f, i[A + 8 >> 2] = i[21480], A = j7(), i[e >> 2] = A, CA(A, 7, 1), CA(A, 8, 1), i[r >> 2] = e;
                        }
                        function lt(A) {
                            var r = 0, e = 0;
                            if (r = i[A >> 2], r) {
                                e = i[r + 12 >> 2];
                                i: {
                                    if ((e | 0) == i[r + 16 >> 2]) {
                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                        break i;
                                    }
                                    r = i[e >> 2];
                                }
                                if ((r | 0) != -1) return !i[A >> 2];
                                i[A >> 2] = 0;
                            }
                            return 1;
                        }
                        function V8(A) {
                            return o[A + 26 | 0] = 1, Q[A + 24 >> 1] = 2, i[A + 20 >> 2] = 131074, i[A + 12 >> 2] = 8, o[A + 8 | 0] = 0, i[A >> 2] = 99, i[A + 4 >> 2] = 99, i[A + 16 >> 2] = 78668, o[A + 26 | 0] = 1, Q[A + 24 >> 1] = 6, i[A + 20 >> 2] = 851969, A;
                        }
                        function c1(A, r, e, f, k) {
                            var n = 0;
                            return n = m - 16 | 0, m = n, i[n + 12 >> 2] = e, i[n + 8 >> 2] = k, e = j4(n + 4 | 0, n + 12 | 0), r = er(A, r, f, i[n + 8 >> 2]), A = i[e >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = n + 16 | 0, r;
                        }
                        function st(A) {
                            var r = 0, e = 0;
                            if (r = i[A >> 2], r) {
                                e = i[r + 12 >> 2];
                                i: {
                                    if ((e | 0) == i[r + 16 >> 2]) {
                                        r = p[i[i[r >> 2] + 36 >> 2]](r) | 0;
                                        break i;
                                    }
                                    r = l[e | 0];
                                }
                                if ((r | 0) != -1) return !i[A >> 2];
                                i[A >> 2] = 0;
                            }
                            return 1;
                        }
                        function ht(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, i[f + 12 >> 2] = r, i[f + 8 >> 2] = e, r = j4(f + 4 | 0, f + 12 | 0), e = C7(A, 6550, i[f + 8 >> 2]), A = i[r >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = f + 16 | 0, e;
                        }
                        function RA(A, r) {
                            var e = 0, f = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if (!(l[r + 11 | 0] >>> 7 | 0)) {
                                    i[A + 8 >> 2] = i[r + 8 >> 2], f = i[r + 4 >> 2], i[A >> 2] = i[r >> 2], i[A + 4 >> 2] = f;
                                    break i;
                                }
                                j(A, i[r >> 2], i[r + 4 >> 2]);
                            }
                            m = e + 16 | 0;
                        }
                        function SQ(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f2(r, 5), f = i[A + 4 >> 2], l1(r, e, f, f >> 31), f = i[A + 8 >> 2], l1(r, e, f, f >> 31), l1(r, e, i[A + 12 >> 2], 0), l1(r, e, i[A + 16 >> 2], 0), f2(r, 0), G4(r, A + 20 | 0);
                        }
                        function jQ(A, r, e, f) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0;;){
                                i: {
                                    if ((e | 0) == (f | 0) || (A = i[e >> 2], i[(A << 2) + 65280 >> 2] & r && A >>> 0 <= 127)) break i;
                                    e = e + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return e | 0;
                        }
                        function OQ(A, r, e, f) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0;;){
                                i: {
                                    if ((e | 0) == (f | 0) || (A = i[e >> 2], A >>> 0 > 127 | !(i[(A << 2) + 65280 >> 2] & r))) break i;
                                    e = e + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return e | 0;
                        }
                        function wt() {
                            var A = 0, r = 0;
                            return A = m - 16 | 0, m = A, i[A + 12 >> 2] = 1073741823, i[A + 8 >> 2] = 2147483647, r = m - 16 | 0, m = r, m = r + 16 | 0, m = A + 16 | 0, r = A + 8 | 0, A = A + 12 | 0, i[(k0[r >> 2] < k0[A >> 2] ? r : A) >> 2];
                        }
                        function NA(A) {
                            Q[A + 2 >> 1] = 0, Q[A + 4 >> 1] = 0, Q[A >> 1] = 263, o[A + 32 | 0] = 1, o[A + 28 | 0] = 0, i[A + 20 >> 2] = 2, i[A + 24 >> 2] = 2, o[A + 16 | 0] = 1, i[A + 12 >> 2] = 1, o[A + 5 | 0] = 0, o[A + 6 | 0] = 0, o[A + 7 | 0] = 0, o[A + 8 | 0] = 0;
                        }
                        function i0(A, r, e, f) {
                            return i[A + 4 >> 2] = e, i[A >> 2] = r, r = A + 8 | 0, o[f + 11 | 0] >= 0 ? (e = i[f + 4 >> 2], i[r >> 2] = i[f >> 2], i[r + 4 >> 2] = e, i[r + 8 >> 2] = i[f + 8 >> 2], A) : (j(r, i[f >> 2], i[f + 4 >> 2]), A);
                        }
                        function PQ(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            i: {
                                e: {
                                    if ((r | 0) > 0) {
                                        for(;;)if (f = i[((e << 4) + A | 0) + 8 >> 2], f && X(f), e = e + 1 | 0, (e | 0) == (r | 0)) break e;
                                    }
                                    if (!A) break i;
                                }
                                X(A);
                            }
                        }
                        function Ar(A, r) {
                            var e = 0;
                            if (r) {
                                Ar(A, i[r >> 2]), Ar(A, i[r + 4 >> 2]), A = i[r + 24 >> 2];
                                i: {
                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                X(r);
                            }
                        }
                        function Hi(A, r) {
                            var e = 0;
                            if (r) {
                                Hi(A, i[r >> 2]), Hi(A, i[r + 4 >> 2]), A = i[r + 24 >> 2];
                                i: {
                                    if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                                }
                                X(r);
                            }
                        }
                        function vt(A) {
                            var r = 0;
                            i[A + 52 >> 2] = i[A + 52 >> 2] - 1, r = i[A + 48 >> 2] + 1 | 0, i[A + 48 >> 2] = r, r >>> 0 >= 2048 && (X(i[i[A + 36 >> 2] >> 2]), i[A + 36 >> 2] = i[A + 36 >> 2] + 4, i[A + 48 >> 2] = i[A + 48 >> 2] - 1024);
                        }
                        function fr(A, r) {
                            var e = 0, f = 0, k = 0;
                            k = i[A >> 2], e = i[A + 4 >> 2] - k | 0, f = e + r | 0;
                            i: {
                                if (f >>> 0 > e >>> 0) {
                                    r1(A, r);
                                    break i;
                                }
                                if (f >>> 0 >= e >>> 0) break i;
                                i[A + 4 >> 2] = f + k;
                            }
                            i[A + 12 >> 2] = i[A + 12 >> 2] + r;
                        }
                        function LQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81244, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function KQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 78708, r = i[A + 104 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return V2(A) | 0;
                        }
                        function qQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80644, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function $Q(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81760, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function aQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81016, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function bQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80360, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function dQ(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 82048, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            return F1(A) | 0;
                        }
                        function cQ(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            k = m - 32 | 0, m = k, n = k + 12 | 0, M3(n, i[r >> 2], e, f, 1), j0(A, n, i[r >> 2]), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function iC(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            k = m - 32 | 0, m = k, n = k + 12 | 0, M3(n, i[r >> 2], e, f, 0), j0(A, n, i[r >> 2]), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function DA(A, r, e, f) {
                            var k = 0;
                            return k = i[r >> 2], i[A >> 2] = k, r = i[r + 4 >> 2], o[A + 20 | 0] = 0, i[A + 16 >> 2] = f, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, i[A + 4 >> 2] = r, p[i[i[k >> 2] + 20 >> 2]](k, e, 0), A;
                        }
                        function eC(A) {
                            A = A | 0;
                            var r = 0;
                            r = i[A + 52 >> 2], r && (i[A + 56 >> 2] = r, X(r)), o[A + 51 | 0] < 0 && X(i[A + 40 >> 2]), o[A + 39 | 0] < 0 && X(i[A + 28 >> 2]), o[A + 27 | 0] < 0 && X(i[A + 16 >> 2]);
                        }
                        function rC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81244, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function AC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 78708, r = i[A + 104 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(V2(A));
                        }
                        function fC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80644, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function kC(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            for(A = 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = i[r >> 2] + (A << 4) | 0, f = A & -268435456, A = (f | f >>> 24) ^ A, r = r + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return A | 0;
                        }
                        function _t(A, r, e, f) {
                            var k = 0;
                            return k = m - 16 | 0, m = k, A = Ts(A | 0, r | 0, e | 0, f & 255, k + 8 | 0) | 0, A ? (i[26064] = A, A = -1) : A = 0, m = k + 16 | 0, w0 = A ? -1 : i[k + 12 >> 2], A ? -1 : i[k + 8 >> 2];
                        }
                        function nC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81760, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function tC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 81016, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function Bt(A) {
                            var r = 0, e = 0;
                            return r = m - 16 | 0, m = r, i[r + 12 >> 2] = A, A = j4(r + 8 | 0, r + 12 | 0), e = i[i[26106] >> 2] ? 4 : 1, A = i[A >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = r + 16 | 0, e;
                        }
                        function oC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 80360, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function uC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            i[A >> 2] = 82048, r = i[A + 376 >> 2];
                            i: {
                                if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                            }
                            X(F1(A));
                        }
                        function lC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            e = -1;
                            i: {
                                if (!A | (r | 0) < 4 || (e = 0, l[A | 0] != 255 | l[A + 1 | 0] != 216 | l[A + 2 | 0] != 255)) break i;
                                e = (l[A + 3 | 0] & 240) == 224;
                            }
                            return e | 0;
                        }
                        function sC(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            for(A = 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = o[r | 0] + (A << 4) | 0, f = A & -268435456, A = (f | f >>> 24) ^ A, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return A | 0;
                        }
                        function mt() {
                            var A = 0, r = 0;
                            l[87596] || (o[87596] = 1), A = i[21892], i[21892] = A + 1;
                            i: {
                                if ((A | 0) > 0 || (y7(), E7())) break i;
                                i[21892] = i[21892] - 1, r = 11;
                            }
                            return r | 0;
                        }
                        function hC(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0, n = 0;
                            k = m - 32 | 0, m = k, n = k + 12 | 0, t9(n, i[r >> 2], f, e), j0(A, n, i[r >> 2]), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function Zt(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, i[f + 12 >> 2] = e, i[f + 8 >> 2] = r, A = t3(A | 0, f + 8 | 0, 1, f + 4 | 0) | 0, A ? (i[26064] = A, A = -1) : A = 0, m = f + 16 | 0, A ? -1 : i[f + 4 >> 2];
                        }
                        function wC(A, r, e) {
                            for(A = A | 0, r = r | 0, e = e | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = i[r >> 2], A >>> 0 <= 127 && (A = i[i[15466] + (A << 2) >> 2]), i[r >> 2] = A, r = r + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function vC(A, r, e) {
                            for(A = A | 0, r = r | 0, e = e | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = i[r >> 2], A >>> 0 <= 127 && (A = i[i[15852] + (A << 2) >> 2]), i[r >> 2] = A, r = r + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function Gt(A, r, e, f, k) {
                            var n = 0;
                            return n = m - 16 | 0, m = n, i[n + 12 >> 2] = k, k = j4(n + 8 | 0, n + 12 | 0), r = _i(A, r, e, f), A = i[k >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = n + 16 | 0, r;
                        }
                        function Wt(A) {
                            var r = 0;
                            o[A + 27 | 0] < 0 && X(i[A + 16 >> 2]), A = i[A + 4 >> 2];
                            i: {
                                if (!A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function Xt(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, i[f + 8 >> 2] = r, i[f + 12 >> 2] = A, i[f + 4 >> 2] = e, r = 0, m = f + 16 | 0, A = f + 4 | 0, k0[A >> 2] >= k0[f + 12 >> 2] && (r = k0[A >> 2] < k0[f + 8 >> 2]), r;
                        }
                        function _C(A) {
                            A = A | 0;
                            var r = 0;
                            return r = i[A + 24 >> 2], i[A + 24 >> 2] = 0, i[A >> 2] = 73208, r && p[i[i[r >> 2] + 4 >> 2]](r), i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), A | 0;
                        }
                        function BC(A) {
                            return A = A | 0, l[108688] ? i[27171] : (l[109784] || (o[109784] = 1), z2(109760, 16054), z2(109772, 16048), o[108688] = 1, i[27171] = 109760, 109760);
                        }
                        function mC(A) {
                            return A = A | 0, l[108696] ? i[27173] : (l[109816] || (o[109816] = 1), x2(109792, 71744), x2(109804, 71756), o[108696] = 1, i[27173] = 109792, 109792);
                        }
                        function pt(A) {
                            var r = 0;
                            if (p[i[i[A >> 2] + 20 >> 2]](A), r = i[A + 36 >> 2], A = i[A + 40 >> 2], (r | 0) != (A | 0)) for(; pt(i[r >> 2]), r = r + 8 | 0, (A | 0) != (r | 0););
                        }
                        function ZC(A, r, e) {
                            for(A = A | 0, r = r | 0, e = e | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = o[r | 0], (A | 0) >= 0 && (A = i[i[15852] + (A << 2) >> 2]), o[r | 0] = A, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function GC(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 75308, r = i[A + 124 >> 2], r && (i[A + 128 >> 2] = r, X(r)), i[A >> 2] = 75164, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function Qt(A, r, e, f) {
                            r = rr(i[A + 48 >> 2], r, e, f), A = i[e + 4 >> 2];
                            i: {
                                if (!A || (e = i[A + 4 >> 2], i[A + 4 >> 2] = e - 1, e)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                            return r;
                        }
                        function WC(A, r, e, f, k) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = i[r >> 2], o[k | 0] = A >>> 0 < 128 ? A : f, k = k + 1 | 0, r = r + 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function XC(A, r, e) {
                            for(A = A | 0, r = r | 0, e = e | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = o[r | 0], (A | 0) >= 0 && (A = i[i[15466] + (A << 2) >> 2]), o[r | 0] = A, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function pC(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f2(r, 1), f = i[A + 4 >> 2], l1(r, e, f, f >> 31), f = i[A + 8 >> 2], l1(r, e, f, f >> 31), l1(r, e, i[A + 12 >> 2], 0), l1(r, e, i[A + 16 >> 2], 0);
                        }
                        function QC(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f2(r, 2), f = i[A + 4 >> 2], l1(r, e, f, f >> 31), f = i[A + 8 >> 2], l1(r, e, f, f >> 31), l1(r, e, i[A + 12 >> 2], 0), l1(r, e, i[A + 16 >> 2], 0);
                        }
                        function CC(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f2(r, 4), f = i[A + 4 >> 2], l1(r, e, f, f >> 31), f = i[A + 8 >> 2], l1(r, e, f, f >> 31), l1(r, e, i[A + 12 >> 2], 0), l1(r, e, i[A + 16 >> 2], 0);
                        }
                        function e0(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = i[13797], n = l[r | 0] == 42, n || E1(24964, 6, 1, k), i[f + 12 >> 2] = e, Se(A, r + n | 0, e, 1295, 1296), R8(k), m = f + 16 | 0;
                        }
                        function kr(A, r, e, f) {
                            return i[A >> 2] = i[r >> 2], r = i[r + 4 >> 2], o[A + 20 | 0] = 0, i[A + 16 >> 2] = e, i[A + 12 >> 2] = 0, i[A + 8 >> 2] = f, i[A + 4 >> 2] = r, f && (i[A + 12 >> 2] = i[f + 12 >> 2] + 1), A;
                        }
                        function Ct(A) {
                            A = A | 0;
                            var r = 0;
                            return r = 1, i[A + 4 >> 2] - 32768 >>> 0 < 4294901760 | i[A + 8 >> 2] - 32768 >>> 0 < 4294901760 | k0[A + 12 >> 2] > 65535 || (r = k0[A + 16 >> 2] > 65535), r | 0;
                        }
                        function VC(A, r, e, f, k) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    A = o[r | 0], o[k | 0] = (A | 0) < 0 ? f : A, k = k + 1 | 0, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function Vt(A, r, e, f) {
                            var k = 0, n = 0;
                            k = m - 16 | 0, m = k, i[k + 12 >> 2] = e, n = r, r = e - r | 0, Lo(f, n, r >> 2), i[k + 8 >> 2] = r + f, i[A >> 2] = i[k + 12 >> 2], i[A + 4 >> 2] = i[k + 8 >> 2], m = k + 16 | 0;
                        }
                        function yC(A) {
                            A = A | 0;
                            var r = 0;
                            r = i[A + 24 >> 2], i[A + 24 >> 2] = 0, i[A >> 2] = 73208, r && p[i[i[r >> 2] + 4 >> 2]](r), i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), X(A);
                        }
                        function IC(A, r, e, f, k, n, t, u, s, h) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0, h = h | 0;
                            var w = 0;
                            return w = r, r = 0, p[A | 0](w, e, f, k, n, r | t, u, r | s, h) | 0;
                        }
                        function yt(A, r, e) {
                            var f = 0, k = 0, n = 0;
                            f = m - 16 | 0, m = f, k = f, n = H8(r), i[k + 12 >> 2] = n, k = f, n = H8(e), i[k + 8 >> 2] = n, i[A >> 2] = i[f + 12 >> 2], i[A + 4 >> 2] = i[f + 8 >> 2], m = f + 16 | 0;
                        }
                        function FC(A, r, e, f, k, n) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, Y1(A, i[r + 8 >> 2], n)) {
                                hA(r, e, f, k);
                                return;
                            }
                            A = i[A + 8 >> 2], p[i[i[A >> 2] + 20 >> 2]](A, r, e, f, k, n);
                        }
                        function D(A) {
                            var r = 0, e = 0;
                            for(e = A >>> 0 <= 1 ? 1 : A;;){
                                i: {
                                    if (A = Q2(e), A || (r = i[27531], !r)) break i;
                                    p[r | 0]();
                                    continue;
                                }
                                break;
                            }
                            return A || u4(), A;
                        }
                        function YC(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 75308, r = i[A + 124 >> 2], r && (i[A + 128 >> 2] = r, X(r)), i[A >> 2] = 75164, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), X(V2(A));
                        }
                        function MA(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, i[f + 12 >> 2] = e, e = j4(f + 8 | 0, f + 12 | 0), r = Ke(A, r), A = i[e >> 2], A && (i[26106] = (A | 0) == -1 ? 104304 : A), m = f + 16 | 0, r;
                        }
                        function EC(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = i[A + 32 >> 2], e = r, A = i[A + 36 >> 2], r = (k | 0) == (A | 0) & r >>> 0 < f >>> 0 | A >>> 0 < k >>> 0, w0 = r ? A : k, (r ? e : f) | 0;
                        }
                        function It(A, r, e, f) {
                            var k = 0, n = 0;
                            k = m - 16 | 0, m = k, i[k + 12 >> 2] = e, n = r, r = e - r | 0, ao(f, n, r), i[k + 8 >> 2] = r + f, i[A >> 2] = i[k + 12 >> 2], i[A + 4 >> 2] = i[k + 8 >> 2], m = k + 16 | 0;
                        }
                        function nr(A) {
                            var r = 0, e = 0;
                            r = m - 16 | 0, m = r, e = -1;
                            i: {
                                if (Ei(A) || (p[i[A + 32 >> 2]](A, r + 15 | 0, 1) | 0) != 1) break i;
                                e = l[r + 15 | 0];
                            }
                            return m = r + 16 | 0, e;
                        }
                        function p4(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            if (A) {
                                r = i[A + 4 >> 2];
                                i: {
                                    if (!r || (e = i[r + 4 >> 2], i[r + 4 >> 2] = e - 1, e)) break i;
                                    p[i[i[r >> 2] + 8 >> 2]](r), g(r);
                                }
                                X(A);
                            }
                        }
                        function E1(A, r, e, f) {
                            var k = 0;
                            k = Z(r, e);
                            i: {
                                if (i[f + 76 >> 2] < 0) {
                                    A = $e(A, k, f);
                                    break i;
                                }
                                A = $e(A, k, f);
                            }
                            return (k | 0) == (A | 0) ? r ? e : 0 : (A >>> 0) / (r >>> 0) | 0;
                        }
                        function gC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            return r = m - 32 | 0, m = r, P7(r + 12 | 0, A), A = l[A + 40 | 0], e = i[r + 12 >> 2], o[r + 31 | 0] < 0 && X(i[r + 20 >> 2]), m = r + 32 | 0, (e ? -1 : A) | 0;
                        }
                        function JC(A, r) {
                            A = A | 0, r = r | 0;
                            i: {
                                if (i[21684] || (w3(), !l[86740])) break i;
                                AA();
                            }
                            i[21684] = i[21684] + 1, i[A + 8 >> 2] = 38410, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function UA(A, r, e, f, k, n, t, u, s, h, w, v, _, B) {
                            if ((B | 0) <= 8) {
                                p[i[A + 12 >> 2]](r, e, f, k, n, t, u, s, h, w, v, _);
                                return;
                            }
                            p[i[A + 28 >> 2]](r, e, f, k, n, t, u, s, h, w, v, _, B);
                        }
                        function Ft(A) {
                            A = A | 0;
                            var r = 0;
                            i[A + 2192 >> 2] && (r = i[A + 2188 >> 2], o[i[i[i[A + 2176 >> 2] + (r >>> 8 & 16777212) >> 2] + ((r & 1023) << 2) >> 2] + 104 | 0] = 0, vt(A + 2140 | 0));
                        }
                        function RC(A) {
                            A = A | 0;
                            var r = 0;
                            A && (r = i[A + 4 >> 2], r && X(r), r = i[A + 8 >> 2], r && X(r), r = i[A + 12 >> 2], r && X(r), r = i[A + 16 >> 2], r && X(r), X(A));
                        }
                        function NC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            p[i[i[A >> 2] + 24 >> 2]](A), r = K0(r, 108588), i[A + 36 >> 2] = r, e = A, f = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[e + 44 | 0] = f;
                        }
                        function DC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            p[i[i[A >> 2] + 24 >> 2]](A), r = K0(r, 108596), i[A + 36 >> 2] = r, e = A, f = p[i[i[r >> 2] + 28 >> 2]](r) | 0, o[e + 44 | 0] = f;
                        }
                        function MC(A, r, e, f, k, n, t, u, s) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, s = s | 0;
                            var h = 0;
                            return h = r, r = 0, p[A | 0](h, e, f, k, r | n, t, r | u, s) | 0;
                        }
                        function UC(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 83252, r = i[A + 404 >> 2], r && (i[A + 408 >> 2] = r, X(r)), r = i[A + 392 >> 2], r && (i[A + 396 >> 2] = r, X(r)), F1(A) | 0;
                        }
                        function tr(A, r, e) {
                            var f = 0;
                            f = n0[e >> 3], n0[A >> 3] = n0[r + 32 >> 3] + (f * n0[r >> 3] + f * n0[r + 8 >> 3]), n0[A + 8 >> 3] = n0[r + 40 >> 3] + (f * n0[r + 16 >> 3] + n0[e + 8 >> 3] * n0[r + 24 >> 3]);
                        }
                        function HC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            e = r, r = i[r >> 2] + 7 & -8, i[e >> 2] = r + 16, f = A, k = J3(i[r >> 2], i[r + 4 >> 2], i[r + 8 >> 2], i[r + 12 >> 2]), n0[f >> 3] = k;
                        }
                        function Yt(A, r) {
                            var e = 0;
                            return e = i[A + 24 >> 2], (e | 0) == i[A + 28 >> 2] ? p[i[i[A >> 2] + 52 >> 2]](A, r & 255) | 0 : (i[A + 24 >> 2] = e + 1, o[e | 0] = r, r & 255);
                        }
                        function HA(A, r, e, f, k, n) {
                            var t = 0, u = 0;
                            t = i[A + 4 >> 2], u = t >> 8, A = i[A >> 2], t & 1 && (u = i[i[f >> 2] + u >> 2]), p[i[i[A >> 2] + 20 >> 2]](A, r, e, f + u | 0, t & 2 ? k : 2, n);
                        }
                        function Et(A, r, e) {
                            var f = 0;
                            f = m - 16 | 0, m = f;
                            i: {
                                if (!(o[r + 120 | 0] & 1 | e >>> 0 > 30)) {
                                    o[r + 120 | 0] = 1;
                                    break i;
                                }
                                r = po(e);
                            }
                            m = f + 16 | 0, i[A + 4 >> 2] = e, i[A >> 2] = r;
                        }
                        function xC(A) {
                            A = A | 0;
                            var r = 0;
                            return A = i[A >> 2], r = i[A + 80 >> 2], A = i[A + 84 >> 2], !A | i[A + 4 >> 2] != -1 || (p[i[i[A >> 2] + 8 >> 2]](A), g(A)), (r | 0) != 0 | 0;
                        }
                        function zC(A, r) {
                            A = A | 0, r = r | 0, r && (A = A << 24 | (A & 65280) << 8 | (A >>> 8 & 65280 | A >>> 24), o[r | 0] = A, o[r + 1 | 0] = A >>> 8, o[r + 2 | 0] = A >>> 16, o[r + 3 | 0] = A >>> 24);
                        }
                        function TC(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 83252, r = i[A + 404 >> 2], r && (i[A + 408 >> 2] = r, X(r)), r = i[A + 392 >> 2], r && (i[A + 396 >> 2] = r, X(r)), X(F1(A));
                        }
                        function or(A, r, e, f, k) {
                            var n = 0, t = 0;
                            n = i[A + 4 >> 2], t = n >> 8, A = i[A >> 2], n & 1 && (t = i[i[e >> 2] + t >> 2]), p[i[i[A >> 2] + 24 >> 2]](A, r, e + t | 0, n & 2 ? f : 2, k);
                        }
                        function SC(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 74660, r = i[A + 116 >> 2], r && (i[A + 120 >> 2] = r, X(r)), o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), V2(A) | 0;
                        }
                        function jC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            return r = E0(r, 73632, 73656), !r | i[A + 104 >> 2] != i[r + 104 >> 2] || (e = i[A + 108 >> 2] == i[r + 108 >> 2]), e | 0;
                        }
                        function gt(A, r) {
                            var e = 0, f = 0;
                            e = m - 32 | 0, m = e, i[A >> 2] = i[r + 40 >> 2], f = A, A = i[r + 44 >> 2], i[f + 4 >> 2] = A, A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), m = e + 32 | 0;
                        }
                        function OC(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, f && (i[f >> 2] = 0), r = i[19737], i[A >> 2] = i[19736], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19738];
                        }
                        function Jt(A, r, e, f, k, n) {
                            A = p[i[i[A + 8 >> 2] + 4 >> 2]](A + 8 | 0) | 0, A = Ie(e, f, A, A + 288 | 0, n, k, 0) - A | 0, (A | 0) <= 287 && (i[r >> 2] = ((A | 0) / 12 | 0) % 12);
                        }
                        function Rt(A, r, e, f, k, n) {
                            A = p[i[i[A + 8 >> 2] + 4 >> 2]](A + 8 | 0) | 0, A = Fe(e, f, A, A + 288 | 0, n, k, 0) - A | 0, (A | 0) <= 287 && (i[r >> 2] = ((A | 0) / 12 | 0) % 12);
                        }
                        function Nt(A, r) {
                            if (!i[r + 4 >> 2]) {
                                p[i[i[r >> 2] + 36 >> 2]](A, r + 4 | 0);
                                return;
                            }
                            r = i[19557], i[A >> 2] = i[19556], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19558];
                        }
                        function PC(A, r, e, f) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    i[f >> 2] = o[r | 0], f = f + 4 | 0, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function LC(A, r, e, f) {
                            for(A = A | 0, r = r | 0, e = e | 0, f = f | 0;;){
                                if ((r | 0) != (e | 0)) {
                                    o[f | 0] = l[r | 0], f = f + 1 | 0, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r | 0;
                        }
                        function Dt(A, r, e) {
                            var f = 0;
                            for(f = m - 16 | 0, m = f, o[f + 15 | 0] = e;;){
                                if (r) {
                                    o[A | 0] = l[f + 15 | 0], r = r - 1 | 0, A = A + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            m = f + 16 | 0;
                        }
                        function KC(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            return r = D(8), e = i[A + 8 >> 2], A = i[A + 12 >> 2], A && (i[A + 4 >> 2] = i[A + 4 >> 2] + 1), i[r + 4 >> 2] = A, i[r >> 2] = e, r | 0;
                        }
                        function qC(A, r, e, f) {
                            if (A = A | 0, r = r | 0, e = e | 0, f = f | 0, Y1(A, i[r + 8 >> 2], 0)) {
                                QA(r, e, f);
                                return;
                            }
                            A = i[A + 8 >> 2], p[i[i[A >> 2] + 28 >> 2]](A, r, e, f);
                        }
                        function $C(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 74660, r = i[A + 116 >> 2], r && (i[A + 120 >> 2] = r, X(r)), o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), X(V2(A));
                        }
                        function H8(A) {
                            var r = 0;
                            return r = m - 16 | 0, m = r, i[r + 12 >> 2] = A, A = m - 16 | 0, m = A, i[A + 12 >> 2] = i[r + 12 >> 2], m = A + 16 | 0, m = r + 16 | 0, i[A + 12 >> 2];
                        }
                        function g(A) {
                            var r = 0, e = 0;
                            i: {
                                if (r = A + 8 | 0, i[r >> 2] && (e = r, r = i[r >> 2] - 1 | 0, i[e >> 2] = r, (r | 0) != -1)) break i;
                                p[i[i[A >> 2] + 16 >> 2]](A);
                            }
                        }
                        function ur(A) {
                            var r = 0;
                            r = i[A + 328 >> 2], i[A + 328 >> 2] = r - 1, i[A + 336 >> 2] = i[A + 336 >> 2] + 1, !((r | 0) > 0) && (y0(18383, 15041, 677, 4754), z());
                        }
                        function aC(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = i[A + 24 >> 2], i[n >> 2] >= 2 && p[i[n + 24 >> 2]](r, e, f, k, i[A + 28 >> 2]);
                        }
                        function Mt(A) {
                            return i[A >> 2] = 58704, p3(A + 4 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, A;
                        }
                        function z0(A) {
                            return i[A >> 2] = 58456, p3(A + 4 | 0), i[A + 24 >> 2] = 0, i[A + 28 >> 2] = 0, i[A + 16 >> 2] = 0, i[A + 20 >> 2] = 0, i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, A;
                        }
                        function Ut(A, r, e, f, k, n) {
                            A = p[i[i[A + 8 >> 2] >> 2]](A + 8 | 0) | 0, A = Ie(e, f, A, A + 168 | 0, n, k, 0) - A | 0, (A | 0) <= 167 && (i[r >> 2] = ((A | 0) / 12 | 0) % 7);
                        }
                        function Ht(A, r, e, f, k, n) {
                            A = p[i[i[A + 8 >> 2] >> 2]](A + 8 | 0) | 0, A = Fe(e, f, A, A + 168 | 0, n, k, 0) - A | 0, (A | 0) <= 167 && (i[r >> 2] = ((A | 0) / 12 | 0) % 7);
                        }
                        function bC(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            return e = i[A + 2152 >> 2], A = i[A + 2148 >> 2], e - A >> 2 >>> 0 > r >>> 0 ? A = i[A + (r << 2) >> 2] : A = 0, A | 0;
                        }
                        function dC(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                            var n = 0;
                            n = i[A + 24 >> 2], i[n >> 2] >= 2 && p[i[n + 28 >> 2]](r, e, f, k, i[A + 28 >> 2]);
                        }
                        function T0(A, r) {
                            i[A + 20 >> 2] = 0, i[A + 24 >> 2] = r, i[A + 12 >> 2] = 0, i[A + 4 >> 2] = 4098, i[A + 8 >> 2] = 6, i[A + 16 >> 2] = !r, B0(A + 32 | 0, 0, 40), p3(A + 28 | 0);
                        }
                        function cC(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 73252, r = i[A + 48 >> 2], r && X(r), i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), A | 0;
                        }
                        function xt(A, r, e) {
                            var f = 0;
                            f = m - 16 | 0, m = f;
                            i: if (l[A + 11 | 0] >>> 7 | 0) break i;
                            f6(A, e), o[f + 15 | 0] = 0, o[r + e | 0] = l[f + 15 | 0], m = f + 16 | 0;
                        }
                        function B1(A) {
                            var r = 0;
                            i: {
                                if (A = i[A + 4 >> 2], !A || (r = i[A + 4 >> 2], i[A + 4 >> 2] = r - 1, r)) break i;
                                p[i[i[A >> 2] + 8 >> 2]](A), g(A);
                            }
                        }
                        function iV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            return f = i[r + 12 >> 2], A = i[A + 16 >> 2] == 1970628964 ? 24 : 8, fr(r, e ? A + 8 | 0 : A), fr(r, 4), f | 0;
                        }
                        function zt(A) {
                            var r = 0;
                            return r = i[A + 12 >> 2], (r | 0) == i[A + 16 >> 2] ? p[i[i[A >> 2] + 40 >> 2]](A) | 0 : (i[A + 12 >> 2] = r + 4, i[r >> 2]);
                        }
                        function eV(A) {
                            A = A | 0;
                            var r = 0;
                            return (p[i[i[A >> 2] + 36 >> 2]](A) | 0) == -1 ? -1 : (r = A, A = i[A + 12 >> 2], i[r + 12 >> 2] = A + 4, i[A >> 2]);
                        }
                        function Tt(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            return i[A >> 2] = 73072, r = i[A + 4 >> 2] - 12 | 0, e = i[r + 8 >> 2] - 1 | 0, i[r + 8 >> 2] = e, (e | 0) < 0 && X(r), A | 0;
                        }
                        function St() {
                            var A = 0;
                            return l[87596] || (o[87596] = 1), A = i[21892], (A | 0) <= 0 ? 12 : (A = A - 1 | 0, i[21892] = A, A || qo(), 0);
                        }
                        function jt(A) {
                            var r = 0;
                            i[A + 8 >> 2] = 0, i[A + 12 >> 2] = 0, r = i[A + 16 >> 2], i[A + 16 >> 2] = 0, r = r >> 3, i[A >> 2] = i[A >> 2] - r, i[A + 4 >> 2] = r + i[A + 4 >> 2];
                        }
                        function Ot(A) {
                            var r = 0;
                            return r = i[A + 12 >> 2], (r | 0) == i[A + 16 >> 2] ? p[i[i[A >> 2] + 40 >> 2]](A) | 0 : (i[A + 12 >> 2] = r + 1, l[r | 0]);
                        }
                        function rV(A) {
                            A = A | 0;
                            var r = 0;
                            return (p[i[i[A >> 2] + 36 >> 2]](A) | 0) == -1 ? -1 : (r = A, A = i[A + 12 >> 2], i[r + 12 >> 2] = A + 1, l[A | 0]);
                        }
                        function C1(A, r) {
                            return i[A + 4 >> 2] = r, o[A | 0] = 0, r = i[i[r >> 2] - 12 >> 2] + r | 0, i[r + 16 >> 2] || (r = i[r + 72 >> 2], r && Ni(r), o[A | 0] = 1), A;
                        }
                        function Pt(A, r, e) {
                            var f = 0, k = 0;
                            f = n0[e >> 3], k = n0[e + 8 >> 3], n0[A >> 3] = f * n0[r >> 3] + k * n0[r + 8 >> 3], n0[A + 8 >> 3] = f * n0[r + 16 >> 3] + k * n0[r + 24 >> 3];
                        }
                        function Lt(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            return f = i[A + 32 >> 2], A = i[A + 36 >> 2], ((e | 0) == (A | 0) & r >>> 0 > f >>> 0 | A >>> 0 < e >>> 0) << 1;
                        }
                        function E4(A, r, e, f) {
                            i[e + 12 >> 2] = f, p[i[i[r >> 2] + 48 >> 2]](A, r, e, i[e + 4 >> 2] - (i[e >> 2] + f | 0) | 0, 0), i[e + 12 >> 2] = i[e + 4 >> 2] - i[e >> 2];
                        }
                        function AV(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 73252, r = i[A + 48 >> 2], r && X(r), i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), X(A);
                        }
                        function d0(A) {
                            var r = 0;
                            A = i[A >> 2], (A | 0) != 108396 && (r = i[A + 4 >> 2] - 1 | 0, i[A + 4 >> 2] = r, (r | 0) == -1 && p[i[i[A >> 2] + 8 >> 2]](A));
                        }
                        function fV(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0;
                            e = D(1), i[A + 8 >> 2] = i[20009], f = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = f, i[r >> 2] = e;
                        }
                        function kV(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0;
                            var k = 0;
                            return k = m - 16 | 0, m = k, p[A | 0](k + 8 | 0, r, e, f), m = k + 16 | 0, i[k + 12 >> 2];
                        }
                        function nV(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            if (r = i[A >> 2], r) for(; X(r), e = e + 1 | 0, r = i[(e << 2) + A >> 2], !!r;);
                            X(A);
                        }
                        function Kt(A, r, e, f, k, n) {
                            i[A >> 2] = r, i[A + 4 >> 2] = e, i[A + 8 >> 2] = f, i[A + 12 >> 2] = k & 65535 | (n >>> 16 & 32768 | (k & 2147418112) >>> 16) << 16;
                        }
                        function lr(A, r, e) {
                            var f = 0;
                            f = m - 16 | 0, m = f, i[f + 12 >> 2] = r, i[f + 8 >> 2] = e, i[A >> 2] = i[f + 12 >> 2], i[A + 4 >> 2] = i[f + 8 >> 2], m = f + 16 | 0;
                        }
                        function j4(A, r) {
                            var e = 0;
                            return e = i[26106], r = i[r >> 2], r && (i[26106] = (r | 0) == -1 ? 104304 : r), i[A >> 2] = (e | 0) == 104304 ? -1 : e, A;
                        }
                        function tV(A) {
                            A = A | 0;
                            var r = 0;
                            return A = i[A >> 2], i[A + 32 >> 2] == 1 && (r = i[A + 36 >> 2] == 3 ? 4 : 10), A = T4(A, r), (A ? (A | 0) < 0 ? -1 : A : -1) | 0;
                        }
                        function oV(A) {
                            A = A | 0;
                            var r = 0;
                            return A = i[A >> 2], i[A + 32 >> 2] == 1 && (r = i[A + 36 >> 2] == 3 ? 4 : 10), A = S4(A, r), (A ? (A | 0) < 0 ? -1 : A : -1) | 0;
                        }
                        function xA(A, r) {
                            var e = 0;
                            return e = m - 16 | 0, m = e, i[e + 12 >> 2] = i[A >> 2], i[e + 12 >> 2] = i[e + 12 >> 2] + (r << 2), m = e + 16 | 0, i[e + 12 >> 2];
                        }
                        function uV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            return f = i[r + 12 >> 2], A = i[A + 16 >> 2] == 1970628964 ? 24 : 8, fr(r, e ? A + 8 | 0 : A), f | 0;
                        }
                        function x8(A, r, e, f) {
                            var k = 0;
                            k = m - 32 | 0, m = k, B3(k + 12 | 0, i[A + 68 >> 2], r, e, f), o[k + 31 | 0] < 0 && X(i[k + 20 >> 2]), m = k + 32 | 0;
                        }
                        function lV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f = m - 16 | 0, m = f, i[f + 8 >> 2] = 1, i[f + 12 >> 2] = 550, Q7(A, r, f + 8 | 0, e), m = f + 16 | 0;
                        }
                        function k8(A) {
                            i: {
                                if (A = i[A + 4 >> 2] & 74, A) {
                                    if ((A | 0) == 64) return 8;
                                    if ((A | 0) != 8) break i;
                                    return 16;
                                }
                                return 0;
                            }
                            return 10;
                        }
                        function sV(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = i[20011], i[A >> 2] = i[20010], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20012];
                        }
                        function hV(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                        }
                        function qt(A, r) {
                            var e = 0, f = 0;
                            f = i[r >> 2], i[r >> 2] = 0, e = i[A >> 2], i[A >> 2] = f, e && p[i[A + 4 >> 2]](e), i[A + 4 >> 2] = i[r + 4 >> 2];
                        }
                        function zA(A) {
                            A = A | 0;
                            var r = 0;
                            return r = i[15080], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[15083], pi(A + 8 | 0), N0(A + 108 | 0), A | 0;
                        }
                        function TA(A) {
                            A = A | 0;
                            var r = 0;
                            return r = i[15119], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[15122], pi(A + 4 | 0), N0(A + 104 | 0), A | 0;
                        }
                        function Y1(A, r, e) {
                            return e ? (A | 0) == (r | 0) ? 1 : !d1(i[A + 4 >> 2], i[r + 4 >> 2]) : i[A + 4 >> 2] == i[r + 4 >> 2];
                        }
                        function s1(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, i[f + 12 >> 2] = r, i[A >> 2] = i[f + 12 >> 2], i[A + 4 >> 2] = i[e >> 2], m = f + 16 | 0, A;
                        }
                        function SA(A, r) {
                            var e = 0;
                            return e = m - 16 | 0, m = e, i[e + 12 >> 2] = i[A >> 2], i[e + 12 >> 2] = i[e + 12 >> 2] + r, m = e + 16 | 0, i[e + 12 >> 2];
                        }
                        function wV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, A = i[r + 4 >> 2], A && X(A), A = i[r + 8 >> 2], A && X(A), A = i[r + 12 >> 2], A && X(A);
                        }
                        function jA(A) {
                            A = A | 0;
                            var r = 0;
                            return r = i[15035], i[A >> 2] = r, i[i[r - 12 >> 2] + A >> 2] = i[15038], Af(A + 4 | 0), N0(A + 56 | 0), A | 0;
                        }
                        function f6(A, r) {
                            if (l[A + 11 | 0] >>> 7 | 0) {
                                i[A + 4 >> 2] = r;
                                return;
                            }
                            o[A + 11 | 0] = l[A + 11 | 0] & 128 | r & 127, o[A + 11 | 0] = l[A + 11 | 0] & 127;
                        }
                        function vV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, V3(i[r >> 2], e), i[A + 8 >> 2] = i[19867], r = i[19866], i[A >> 2] = i[19865], i[A + 4 >> 2] = r;
                        }
                        function $t(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function at(A, r, e, f, k) {
                            r = $4(r, e, f, k, 4), l[f | 0] & 4 || (i[A >> 2] = ((r | 0) < 69 ? r + 2e3 | 0 : r >>> 0 < 100 ? r + 1900 | 0 : r) - 1900);
                        }
                        function bt(A, r, e, f, k) {
                            r = a4(r, e, f, k, 4), l[f | 0] & 4 || (i[A >> 2] = ((r | 0) < 69 ? r + 2e3 | 0 : r >>> 0 < 100 ? r + 1900 | 0 : r) - 1900);
                        }
                        function _V(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            f2(r, 0), f = i[A + 4 >> 2], l1(r, e, f, f >> 31), A = i[A + 8 >> 2], l1(r, e, A, A >> 31);
                        }
                        function k6(A, r) {
                            var e = 0, f = 0;
                            return e = i[A + 108 >> 2], f = r, r = i[A + 112 >> 2], e = OA(e, f, r - e >> 2), ((e || r) | 0) != i[A + 112 >> 2];
                        }
                        function BV(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            return t = r, r = 0, p[A | 0](t, r | e, f, r | k, n) | 0;
                        }
                        function OA(A, r, e) {
                            if (e) for(;;){
                                if (i[A >> 2] == (r | 0)) return A;
                                if (A = A + 4 | 0, e = e - 1 | 0, !e) break;
                            }
                            return 0;
                        }
                        function Q4(A) {
                            var r = 0;
                            return l[A + 11 | 0] >>> 7 | 0 && (A = i[A >> 2]), r = m - 16 | 0, m = r, i[r + 12 >> 2] = A, m = r + 16 | 0, i[r + 12 >> 2];
                        }
                        function mV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[e >> 2] = 100, i[A + 8 >> 2] = i[20009], r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r;
                        }
                        function PA(A, r) {
                            var e = 0;
                            e = A + 4 | 0, i[e >> 2] = 60660, i[e >> 2] = 58992, i[A >> 2] = 58572, i[e >> 2] = 58592, Zr(i[14640] + A | 0, r);
                        }
                        function LA(A, r) {
                            var e = 0;
                            e = A + 4 | 0, i[e >> 2] = 60660, i[e >> 2] = 59428, i[A >> 2] = 58820, i[e >> 2] = 58840, Zr(i[14702] + A | 0, r);
                        }
                        function ZV(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0, f = 0, k = 0;
                            A = i[A >> 2], e = r >> 31, f = A, k = O0(r, e, r, e), i[f + 72 >> 2] = k, i[A + 76 >> 2] = w0;
                        }
                        function dt(A, r) {
                            r && (Q[A + 4 >> 1] = i[r + 4 >> 2], Q[A + 6 >> 1] = i[r + 8 >> 2], Q[A + 8 >> 1] = i[r + 12 >> 2], o[A + 10 | 0] = l[r + 16 | 0] != 0);
                        }
                        function GV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                            var f = 0;
                            return f = m - 16 | 0, m = f, p[A | 0](f + 8 | 0, r, e), m = f + 16 | 0, i[f + 12 >> 2];
                        }
                        function ct() {
                            var A = 0;
                            return A = Q2(52), A && (o[A + 16 | 0] = 1, i[A + 12 >> 2] = 6, i[A + 4 >> 2] = 1, i[A + 8 >> 2] = 13, o[A | 0] = 1), A | 0;
                        }
                        function WV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[e >> 2] = 1, i[A + 8 >> 2] = i[20009], r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r;
                        }
                        function XV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[e >> 2] = 0, i[A + 8 >> 2] = i[20009], r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r;
                        }
                        function pV(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, A = p[i[i[A + 24 >> 2] + 16 >> 2]](r, e, i[A + 28 >> 2]) | 0, (A >>> 0 >= 3 ? 2 : A) & 255;
                        }
                        function io(A, r, e, f, k, n, t, u) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, i[k >> 2] = e, i[u >> 2] = n, 3;
                        }
                        function QV(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                        }
                        function m1(A) {
                            return A = q0(A), A && ((A | 0) != -99999 ? A = A & 1 ? A + 1 >> 1 : 0 - (A >> 1) | 0 : A = -99999, A);
                        }
                        function xi(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = i[20011], i[A >> 2] = i[20010], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20012];
                        }
                        function eo(A) {
                            I[A + 8 >> 1] == 2 && (Q[A + 8 >> 1] = 6), I[A + 4 >> 1] == 2 && (Q[A + 4 >> 1] = 1), I[A + 6 >> 1] == 2 && (Q[A + 6 >> 1] = 13);
                        }
                        function CV(A) {
                            A = A | 0;
                            var r = 0;
                            r = k0[A + 104 >> 2] > 65535 ? 3 : l[A + 164 | 0] ? 2 : 0, o[A + 97 | 0] = i[A + 112 >> 2] && r >>> 0 <= 2 ? 2 : r;
                        }
                        function VV(A) {
                            A = A | 0;
                            var r = 0, e = 0;
                            return A = i[A + 4 >> 2], r = E2(A) + 1 | 0, e = Q2(r), e ? A = v0(e, A, r) : A = 0, A | 0;
                        }
                        function yV(A) {
                            A = A | 0;
                            var r = 0;
                            return r = m - 16 | 0, m = r, Q9(r, i[A + 24 >> 2]), m = r + 16 | 0, w0 = i[r + 12 >> 2], i[r + 8 >> 2];
                        }
                        function ro(A) {
                            if (i[A + 20 >> 2] != i[A + 24 >> 2]) for(; fn(A), i[A + 20 >> 2] != i[A + 24 >> 2];);
                        }
                        function KA(A) {
                            i[A + 136 >> 2] || (i[A + 136 >> 2] = i[i[26106] >> 2] ? 60784 : 60760), i[A + 72 >> 2] || (i[A + 72 >> 2] = 1);
                        }
                        function IV() {
                            i[21761] = 1, i[21755] = 6371, i[21754] = 3, i[21753] = 9758, i[21752] = 2, i[21737] = 0, i[21736] = 87008;
                        }
                        function FV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 1, 1, u);
                        }
                        function YV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 1, 2, u);
                        }
                        function EV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 1, 3, u);
                        }
                        function gV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 2, 1, u);
                        }
                        function JV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 2, 2, u);
                        }
                        function RV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 2, 3, u);
                        }
                        function NV(A, r) {
                            return A = A | 0, r = r | 0, r >>> 0 <= 2 ? A = i[i[A + 124 >> 2] + i[(r << 2) + 46684 >> 2] >> 2] : A = 0, A | 0;
                        }
                        function DV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 3, 1, u);
                        }
                        function MV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 3, 2, u);
                        }
                        function UV(A, r, e, f, k, n, t, u) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, u = u | 0, _8(A, r, e, f, k, n, t, 3, 3, u);
                        }
                        function HV(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, e >>> 0 <= 127 ? A = (i[(e << 2) + 65280 >> 2] & r) != 0 : A = 0, A | 0;
                        }
                        function xV(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0;
                            var t = 0;
                            t = r, r = 0, p[A | 0](t, r | e, f, r | k, n);
                        }
                        function Ao(A, r) {
                            var e = 0;
                            e = m - 16 | 0, m = e;
                            i: {
                                if ((A | 0) == (r | 0)) {
                                    o[A + 120 | 0] = 0;
                                    break i;
                                }
                                y8(r, 4);
                            }
                            m = e + 16 | 0;
                        }
                        function qA(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, e = OA(A, i[e >> 2], r - A >> 2), m = f + 16 | 0, ((e || r) - A | 0) + A | 0;
                        }
                        function zV(A, r, e, f, k, n, t) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, p[A | 0](r, e, f, k, n, t) | 0;
                        }
                        function sr(A) {
                            if (i[A + 336 >> 2] != i[A + 340 >> 2]) for(; i[A + 336 >> 2] != i[A + 340 >> 2];);
                        }
                        function fo(A, r) {
                            var e = 0;
                            for(e = i[A + 4 >> 2];;){
                                if ((r | 0) != (e | 0)) {
                                    e = e - 4 | 0;
                                    continue;
                                }
                                break;
                            }
                            i[A + 4 >> 2] = r;
                        }
                        function TV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 75020, r = i[A + 120 >> 2], r && (i[A + 124 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function SV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 75164, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function jV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 75596, r = i[A + 104 >> 2], r && (i[A + 108 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function OV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 81400, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function PV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 81472, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function LV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 81616, r = i[A + 104 >> 2], r && (i[A + 108 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function hr(A, r) {
                            r && (hr(A, i[r >> 2]), hr(A, i[r + 4 >> 2]), A = i[r + 16 >> 2], i[r + 16 >> 2] = 0, A && X(A), X(r));
                        }
                        function KV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 80800, r = i[A + 112 >> 2], r && (i[A + 116 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function qV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 81120, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function $V(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 73736, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function aV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 83148, r = i[A + 384 >> 2], r && (i[A + 388 >> 2] = r, X(r)), F1(A) | 0;
                        }
                        function bV(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 73880, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), V2(A) | 0;
                        }
                        function dV(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            return e = m - 16 | 0, m = e, p[A | 0](e + 8 | 0, r), m = e + 16 | 0, i[e + 12 >> 2];
                        }
                        function $A(A, r, e) {
                            var f = 0;
                            return f = m - 16 | 0, m = f, e = d3(A, o[e | 0], r - A | 0), m = f + 16 | 0, ((e || r) - A | 0) + A | 0;
                        }
                        function cV(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, r = i[19737], i[A >> 2] = i[19736], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19738];
                        }
                        function iy(A) {
                            A = A | 0;
                            var r = 0;
                            A && (r = i[A + 4 >> 2], r && (p[i[i[A >> 2] + 40 >> 2]](r), i[A + 4 >> 2] = 0), X(A));
                        }
                        function O4(A, r) {
                            o[A + 4 | 0] = 0, o[A + 11 | 0] = 4, o[A + 3 | 0] = r, o[A + 2 | 0] = r >>> 8, o[A + 1 | 0] = r >>> 16, o[A | 0] = r >>> 24;
                        }
                        function ey(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, Y1(A, i[r + 8 >> 2], n) && hA(r, e, f, k);
                        }
                        function ko(A) {
                            A = A | 0;
                            var r = 0;
                            i: {
                                if (!A || (A = i[A >> 2], !A)) break i;
                                r = i[A + 40 >> 2];
                            }
                            return r | 0;
                        }
                        function no(A) {
                            A = A | 0;
                            var r = 0;
                            i: {
                                if (!A || (A = i[A >> 2], !A)) break i;
                                r = i[A + 44 >> 2];
                            }
                            return r | 0;
                        }
                        function aA(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, r = i[20008], i[A >> 2] = i[20007], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[20009];
                        }
                        function ry(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[i[i[r >> 2] + 16 >> 2]](A, r, i[e + 8 >> 2], i[e + 12 >> 2], 0, f);
                        }
                        function to(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 65228, r = i[A + 8 >> 2], !r | l[A + 12 | 0] != 1 || X(r), A | 0;
                        }
                        function zi(A, r, e) {
                            (e | 0) < 0 && (y0(18371, 15069, 138, 6151), z()), i[A + 4 >> 2] = r, i[A >> 2] = r, i[A + 8 >> 2] = r + e;
                        }
                        function oo(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, i[A + 8 >> 2] = -1, i[A + 12 >> 2] = -1, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function uo(A) {
                            var r = 0, e = 0;
                            for(e = A; r = e, e = r + 4 | 0, !!i[r >> 2];);
                            return r - A >> 2;
                        }
                        function Ay(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 75020, r = i[A + 120 >> 2], r && (i[A + 124 >> 2] = r, X(r)), X(V2(A));
                        }
                        function fy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 75596, r = i[A + 104 >> 2], r && (i[A + 108 >> 2] = r, X(r)), X(V2(A));
                        }
                        function ky(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 81400, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), X(V2(A));
                        }
                        function lo(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 75164, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), X(V2(A));
                        }
                        function ny(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 81472, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), X(V2(A));
                        }
                        function ty(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, p[i[i[r >> 2] + 92 >> 2]](A, i[r + 4 >> 2], e, f, k);
                        }
                        function oy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 81616, r = i[A + 104 >> 2], r && (i[A + 108 >> 2] = r, X(r)), X(V2(A));
                        }
                        function uy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 80800, r = i[A + 112 >> 2], r && (i[A + 116 >> 2] = r, X(r)), X(V2(A));
                        }
                        function so(A, r) {
                            var e = 0;
                            return e = A + 8 | 0, A = i[e >> 2], i[A + (r << 2) >> 2] != 0 & i[e + 4 >> 2] - A >> 2 >>> 0 > r >>> 0;
                        }
                        function ly(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 81120, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), X(V2(A));
                        }
                        function Z2() {
                            var A = 0;
                            A = lf(4), i[A >> 2] = 72960, i[A >> 2] = 72920, i[A >> 2] = 72940, u3(A | 0, 73052, 32), z();
                        }
                        function sy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 73736, r = i[A + 100 >> 2], r && (i[A + 104 >> 2] = r, X(r)), X(V2(A));
                        }
                        function hy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 83148, r = i[A + 384 >> 2], r && (i[A + 388 >> 2] = r, X(r)), X(F1(A));
                        }
                        function wy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 73880, r = i[A + 108 >> 2], r && (i[A + 112 >> 2] = r, X(r)), X(V2(A));
                        }
                        function vy(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 79184, r = i[A + 20 >> 2], r && (i[A + 24 >> 2] = r, X(r)), A | 0;
                        }
                        function _y(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 73428, r = i[A + 20 >> 2], r && (i[A + 24 >> 2] = r, X(r)), A | 0;
                        }
                        function bA(A, r) {
                            var e = 0;
                            i: {
                                if (e = i[A >> 2], !e || (Yt(e, r) | 0) != -1) break i;
                                i[A >> 2] = 0;
                            }
                        }
                        function By(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 78628, r = i[A + 8 >> 2], r && (i[A + 12 >> 2] = r, X(r)), A | 0;
                        }
                        function my(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 2, 1);
                        }
                        function Zy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 2, 2);
                        }
                        function Gy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 2, 3);
                        }
                        function Wy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 3, 1);
                        }
                        function Xy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 3, 2);
                        }
                        function py(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 3, 3);
                        }
                        function Qy(A) {
                            A = A | 0;
                            var r = 0;
                            i: {
                                if (!A || (A = i[A >> 2], !A)) break i;
                                r = oA(A);
                            }
                            return r | 0;
                        }
                        function Cy(A) {
                            A = A | 0;
                            var r = 0;
                            i: {
                                if (!A || (A = i[A >> 2], !A)) break i;
                                r = uA(A);
                            }
                            return r | 0;
                        }
                        function Vy(A) {
                            A = A | 0;
                            var r = 0;
                            return i[A >> 2] = 79096, r = i[A + 8 >> 2], r && (i[A + 12 >> 2] = r, X(r)), A | 0;
                        }
                        function yy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 1, 1);
                        }
                        function Iy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 1, 2);
                        }
                        function Fy(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, B8(A, r, e, f, k, n, t, 1, 3);
                        }
                        function Yy(A) {
                            return A = A | 0, i[A + 4 >> 2] - 32768 >>> 0 < 4294901760 | i[A + 8 >> 2] - 32768 >>> 0 < 4294901760;
                        }
                        function Ey(A, r, e, f, k, n, t) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, t = t | 0, p[A | 0](r, e, f, k, n, t);
                        }
                        function gy(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, !(p[i[i[A + 24 >> 2] + 12 >> 2]](r, e, i[A + 28 >> 2]) | 0) | 0;
                        }
                        function wr(A, r, e, f) {
                            var k = 0;
                            return k = m - 16 | 0, m = k, i[k + 12 >> 2] = f, A = er(A, r, e, f), m = k + 16 | 0, A;
                        }
                        function ho(A, r) {
                            A = A | 0, r = r | 0;
                            i: {
                                if (!r || (A = i[r >> 2], !A)) break i;
                                X(A), i[r >> 2] = 0;
                            }
                        }
                        function Jy(A) {
                            return A = A | 0, i[21702] = 6, o[86796] = 1, o[86812] = 1, i[21700] = 6, i[21701] = 6, 86796;
                        }
                        function Ry(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, !(p[i[i[A + 24 >> 2] + 8 >> 2]](r, e, i[A + 28 >> 2]) | 0) | 0;
                        }
                        function wo(A) {
                            A = A | 0;
                            var r = 0;
                            A = i[i[i[A >> 2] >> 2] >> 2], r = i[27142] + 1 | 0, i[27142] = r, i[A + 4 >> 2] = r;
                        }
                        function vo(A) {
                            (A | 0) != 0 & (A | 0) != 60760 & (A | 0) != 60784 & (A | 0) != 108100 & (A | 0) != 108124 && X(A);
                        }
                        function Ny(A, r) {
                            A = A | 0, r = r | 0, r = i[19737], i[A >> 2] = i[19736], i[A + 4 >> 2] = r, i[A + 8 >> 2] = i[19738];
                        }
                        function N4(A, r) {
                            A = A | 0, r = r | 0, r = m - 16 | 0, m = r, i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, m = r + 16 | 0;
                        }
                        function b0(A, r) {
                            var e = 0, f = 0;
                            return e = r & 31, f = (-1 >>> e & A) << e, e = A, A = 0 - r & 31, f | (e & -1 << A) >>> A;
                        }
                        function K0(A, r) {
                            return A = i[A >> 2], r = n1(r), so(A, r) || (w1(), z()), i[i[A + 8 >> 2] + (r << 2) >> 2];
                        }
                        function Dy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 79184, r = i[A + 20 >> 2], r && (i[A + 24 >> 2] = r, X(r)), X(A);
                        }
                        function My(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 73428, r = i[A + 20 >> 2], r && (i[A + 24 >> 2] = r, X(r)), X(A);
                        }
                        function _o(A, r) {
                            var e = 0;
                            return e = m - 16 | 0, m = e, i[e + 12 >> 2] = r, A = C7(A, 9381, r), m = e + 16 | 0, A;
                        }
                        function Uy(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, i[A + 8 >> 2] = 0, i[A >> 2] = 0, i[A + 4 >> 2] = 0;
                        }
                        function Hy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 78628, r = i[A + 8 >> 2], r && (i[A + 12 >> 2] = r, X(r)), X(A);
                        }
                        function xy(A, r, e, f, k, n) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, r5(A, r, e, f, k, n) | 0;
                        }
                        function zy(A) {
                            for(A = A | 0, A = 108968; A = a0(A - 12 | 0), (A | 0) != 108800;);
                        }
                        function Ty(A) {
                            for(A = A | 0, A = 109144; A = h1(A - 12 | 0), (A | 0) != 108976;);
                        }
                        function Sy(A) {
                            for(A = A | 0, A = 109440; A = a0(A - 12 | 0), (A | 0) != 109152;);
                        }
                        function jy(A) {
                            for(A = A | 0, A = 109744; A = h1(A - 12 | 0), (A | 0) != 109456;);
                        }
                        function Oy(A) {
                            A = A | 0;
                            var r = 0;
                            i[A >> 2] = 79096, r = i[A + 8 >> 2], r && (i[A + 12 >> 2] = r, X(r)), X(A);
                        }
                        function Py(A) {
                            for(A = A | 0, A = 109784; A = a0(A - 12 | 0), (A | 0) != 109760;);
                        }
                        function Ly(A) {
                            for(A = A | 0, A = 109816; A = h1(A - 12 | 0), (A | 0) != 109792;);
                        }
                        function Ky(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, A = i[A >> 2], i[r >> 2] = i[A + 72 >> 2], i[e >> 2] = i[A + 76 >> 2];
                        }
                        function qy(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, w0 = i[A + 36 >> 2], i[A + 32 >> 2];
                        }
                        function dA(A, r) {
                            for(; i[A + 16 >> 2] = i[A + 16 >> 2] - r, A = i[A + 8 >> 2], !!A;);
                        }
                        function Bo(A) {
                            return A = A | 0, i[A >> 2] = 66312, i[A + 8 >> 2] != (L2() | 0) && vo(i[A + 8 >> 2]), A | 0;
                        }
                        function $y(A, r) {
                            return A = A | 0, r = r | 0, (r | 0) >= 0 && (r = i[i[15852] + (r << 2) >> 2]), r << 24 >> 24;
                        }
                        function ay(A) {
                            return A = A | 0, i[A >> 2] = 74096, o[A + 135 | 0] < 0 && X(i[A + 124 >> 2]), V2(A) | 0;
                        }
                        function by(A) {
                            return A = A | 0, i[A >> 2] = 75524, o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), V2(A) | 0;
                        }
                        function dy(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[i[i[r >> 2] + 76 >> 2]](A, i[r + 4 >> 2], e, f);
                        }
                        function cy(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[i[i[r >> 2] + 80 >> 2]](A, i[r + 4 >> 2], e, f);
                        }
                        function iI(A) {
                            return A = A | 0, i[A >> 2] = 82816, o[A + 395 | 0] < 0 && X(i[A + 384 >> 2]), F1(A) | 0;
                        }
                        function eI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[i[i[r >> 2] + 88 >> 2]](A, i[r + 4 >> 2], e, f);
                        }
                        function rI(A) {
                            return A = A | 0, i[A >> 2] = 73808, o[A + 123 | 0] < 0 && X(i[A + 112 >> 2]), V2(A) | 0;
                        }
                        function AI(A, r) {
                            return A = A | 0, r = r | 0, (r | 0) >= 0 && (r = i[i[15466] + (r << 2) >> 2]), r << 24 >> 24;
                        }
                        function fI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[i[i[r >> 2] + 84 >> 2]](A, i[r + 4 >> 2], e, f);
                        }
                        function kI(A, r) {
                            A = A | 0, r = r | 0, r && (A = i[i[A >> 2] + 80 >> 2], Q[r >> 1] = A, Q[r + 2 >> 1] = A >>> 16);
                        }
                        function cA(A, r) {
                            A = A | 0, r = r | 0;
                            var e = 0;
                            e = A, A = i[r + 372 >> 2], p[i[i[A >> 2] + 24 >> 2]](e, A);
                        }
                        function nI(A) {
                            A = A | 0;
                            var r = 0;
                            r = A + 12 | 0, A = i[r + 8816 >> 2], A && (i[r + 8820 >> 2] = A, X(A));
                        }
                        function tI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = m - 16 | 0, m = r, xn(A, e, f), m = r + 16 | 0;
                        }
                        function oI(A, r) {
                            return A = A | 0, r = r | 0, i[A + 2152 >> 2] - i[A + 2148 >> 2] >> 2 > (r | 0) & (r | 0) >= 0;
                        }
                        function uI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, r = m - 16 | 0, m = r, Hn(A, e, f), m = r + 16 | 0;
                        }
                        function mo(A, r) {
                            if (i[A >> 2] < (r | 0)) for(; i[A >> 2] < (r | 0););
                        }
                        function lI(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, p[A | 0](r, e, f, k) | 0;
                        }
                        function sI(A) {
                            return A = A | 0, l[108712] || (X6(108700, 66476), o[108712] = 1), 108700;
                        }
                        function hI(A, r) {
                            return A = A | 0, r = r | 0, r >>> 0 <= 127 && (r = i[i[15466] + (r << 2) >> 2]), r | 0;
                        }
                        function wI(A) {
                            return A = A | 0, l[108728] || (X6(108716, 66512), o[108728] = 1), 108716;
                        }
                        function vI(A, r) {
                            return A = A | 0, r = r | 0, r >>> 0 <= 127 && (r = i[i[15852] + (r << 2) >> 2]), r | 0;
                        }
                        function _I(A) {
                            return A = A | 0, l[108744] || (Gi(108732, 15853), o[108744] = 1), 108732;
                        }
                        function BI(A) {
                            return A = A | 0, l[108760] || (X6(108748, 66548), o[108760] = 1), 108748;
                        }
                        function mI(A, r, e, f) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, A = _t(i[A + 60 >> 2], r, e, f), A | 0;
                        }
                        function ZI(A) {
                            return A = A | 0, l[108792] || (X6(108780, 66632), o[108792] = 1), 108780;
                        }
                        function GI(A) {
                            A = A | 0, i[A >> 2] = 74096, o[A + 135 | 0] < 0 && X(i[A + 124 >> 2]), X(V2(A));
                        }
                        function WI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, Y1(A, i[r + 8 >> 2], 0) && QA(r, e, f);
                        }
                        function XI(A) {
                            A = A | 0, i[A >> 2] = 75524, o[A + 115 | 0] < 0 && X(i[A + 104 >> 2]), X(V2(A));
                        }
                        function pI(A) {
                            A = A | 0, i[A >> 2] = 82816, o[A + 395 | 0] < 0 && X(i[A + 384 >> 2]), X(F1(A));
                        }
                        function QI(A) {
                            A = A | 0, i[A >> 2] = 73808, o[A + 123 | 0] < 0 && X(i[A + 112 >> 2]), X(V2(A));
                        }
                        function R6(A) {
                            for(var r = 0;;){
                                if (A) {
                                    A = A - 1 & A, r = r + 1 | 0;
                                    continue;
                                }
                                break;
                            }
                            return r;
                        }
                        function CI(A) {
                            return A = A | 0, l[108776] || (Gi(108764, 6541), o[108776] = 1), 108764;
                        }
                        function n8(A, r) {
                            var e = 0;
                            e = m - 16 | 0, m = e, i[e + 12 >> 2] = r, iu(86344, A, r), m = e + 16 | 0;
                        }
                        function VI(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[r >> 2] = i[A + 384 >> 2], i[e >> 2] = i[A + 388 >> 2];
                        }
                        function yI(A, r) {
                            return A = A | 0, r = r | 0, (r >>> 0 <= 2 ? i[i[(r << 2) + 46660 >> 2] + A >> 2] : 0) | 0;
                        }
                        function II(A, r) {
                            return A = A | 0, r = r | 0, (r >>> 0 <= 2 ? i[i[(r << 2) + 46672 >> 2] + A >> 2] : 0) | 0;
                        }
                        function FI(A) {
                            return A = A | 0, i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), A | 0;
                        }
                        function vr(A, r, e, f) {
                            return i[A + 76 >> 2], A9(A, r, e, f);
                        }
                        function YI() {
                            var A = 0;
                            return A = D(12), i[A >> 2] = 0, i[A + 4 >> 2] = 0, i[A + 8 >> 2] = 0, A | 0;
                        }
                        function EI(A, r) {
                            A = A | 0, r = r | 0, r && (i[i[A >> 2] + 80 >> 2] = I[r >> 1] | I[r + 2 >> 1] << 16);
                        }
                        function gI(A, r) {
                            return A = A | 0, r = r | 0, (r | 0) >= 12 ? A = kn(A + 8 | 0) : A = 0, A | 0;
                        }
                        function JI(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[r >> 2] = i[A + 40 >> 2], i[e >> 2] = i[A + 44 >> 2];
                        }
                        function RI(A) {
                            return A = A | 0, A = i[A + 32 >> 2], (l[A + 101 | 0] ? l[A + 102 | 0] ? 12 : 10 : 8) | 0;
                        }
                        function Zo(A, r) {
                            var e = 0;
                            e = Ot(i[r >> 2]), i[A + 4 >> 2] = i[r >> 2], o[A | 0] = e << 24 >> 24;
                        }
                        function N1(A, r) {
                            r = !i[A + 24 >> 2] | r, i[A + 16 >> 2] = r, r & i[A + 20 >> 2] && (w1(), z());
                        }
                        function NI(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, A = i[A >> 2], i[A + 76 >> 2] = e, i[A + 72 >> 2] = r;
                        }
                        function DI(A, r) {
                            return A = A | 0, r = r | 0, A = T4(i[A >> 2], r), (A ? (A | 0) < 0 ? -1 : A : -1) | 0;
                        }
                        function MI(A, r) {
                            return A = A | 0, r = r | 0, A = S4(i[A >> 2], r), (A ? (A | 0) < 0 ? -1 : A : -1) | 0;
                        }
                        function Go(A) {
                            A = A | 0;
                            var r = 0;
                            return r = A + 548 | 0, b5(r), b5(r), o[A + 548 | 0] = 1, 0;
                        }
                        function D4(A) {
                            var r = 0;
                            i[A + 16 >> 2] = 0, r = i[A + 8 >> 2], r && D4(r), o[A + 20 | 0] = 1;
                        }
                        function Ti(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, i[k >> 2] = e, 3;
                        }
                        function _r() {
                            i[21684] || (w3(), l[86740] && AA(), i[21684] = i[21684] + 1);
                        }
                        function UI(A) {
                            A = A | 0, i[A >> 2] = 73384, o[A + 23 | 0] < 0 && X(i[A + 12 >> 2]), X(A);
                        }
                        function HI(A) {
                            return A = A | 0, A = i[A + 32 >> 2], (l[A + 105 | 0] ? l[A + 111 | 0] + 8 | 0 : 8) | 0;
                        }
                        function xI(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, y0(18461, 14918, 68, 8529), z();
                        }
                        function z8(A, r) {
                            A = A | 0, r = r | 0, o[A | 0] = 2, o[A + 1 | 0] = 3, o[A + 2 | 0] = 0, o[A + 3 | 0] = 4;
                        }
                        function zI(A) {
                            return A = A | 0, A = p[i[i[A + 24 >> 2] + 4 >> 2]](i[A + 28 >> 2]) | 0, A | 0;
                        }
                        function TI(A) {
                            return A = A | 0, A ? (E0(A, 72044, 72188) | 0) != 0 | 0 : 0;
                        }
                        function ef(A) {
                            return A = A | 0, i[A + 8 >> 2] != (L2() | 0) && vo(i[A + 8 >> 2]), A | 0;
                        }
                        function SI(A, r, e, f) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, p[A | 0](r, e, f) | 0;
                        }
                        function jI(A, r, e, f, k, n) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, n = n | 0, RA(A, n);
                        }
                        function OI(A, r, e, f, k) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0, w0 = -1, -1;
                        }
                        function n6(A, r) {
                            return r ? A << 24 | (A & 65280) << 8 | (A >>> 8 & 65280 | A >>> 24) : A;
                        }
                        function Wo(A, r) {
                            A = A | 0, r = r | 0, r && (A = i[r >> 2], A && X(A), i[r >> 2] = 0);
                        }
                        function Xo(A, r) {
                            var e = 0;
                            e = zt(i[r >> 2]), i[A + 4 >> 2] = i[r >> 2], i[A >> 2] = e;
                        }
                        function PI(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, (r >>> 0 < 128 ? r : e) << 24 >> 24;
                        }
                        function LI(A) {
                            return A = A | 0, A = i[A + 16 >> 2], p[i[i[A >> 2] + 8 >> 2]](A) | 0;
                        }
                        function KI(A) {
                            A = A | 0, o[A + 12 | 0] = 1, i[A + 4 >> 2] = 2, i[A + 8 >> 2] = 2, o[A | 0] = 1;
                        }
                        function rf() {
                            var A = 0;
                            A = lf(4), i[A >> 2] = 71960, u3(A | 0, 71996, 472), z();
                        }
                        function qI(A) {
                            return A = A | 0, A = i[A >> 2], (I[A + 80 >> 1] | I[A + 82 >> 1]) != 0 | 0;
                        }
                        function $I(A) {
                            A = A | 0, Ni(107228), Ni(107564), sA(107312), sA(107648);
                        }
                        function aI(A) {
                            return A = A | 0, A = i[A >> 2], i[A + 216 >> 2] - i[A + 212 >> 2] >> 2;
                        }
                        function bI(A) {
                            return A = A | 0, A = i[A + 8 >> 2], i[A + 16 >> 2] - i[A + 12 >> 2] >> 3;
                        }
                        function dI(A) {
                            return A = A | 0, A = i[A + 8 >> 2], A ? Bt(A) | 0 : 1;
                        }
                        function cI(A) {
                            A = A | 0, o[A + 97 | 0] = i[A + 40 >> 2] - i[A + 36 >> 2] >>> 0 > 524280;
                        }
                        function iF(A) {
                            return A = A | 0, A = i[A >> 2], p[i[i[A >> 2] + 36 >> 2]](A) | 0;
                        }
                        function eF(A) {
                            return A = A | 0, A = i[A >> 2], p[i[i[A >> 2] + 40 >> 2]](A) | 0;
                        }
                        function rF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, y0(18461, 14918, 51, 8379), z();
                        }
                        function po(A) {
                            return A >>> 0 > 1073741823 && (w1(), z()), C9(A << 2, 4);
                        }
                        function AF(A) {
                            return A = A | 0, A = i[A >> 2], i[A + 56 >> 2] - i[A + 52 >> 2] >> 3;
                        }
                        function fF(A) {
                            return A = A | 0, p[i[i[A >> 2] + 68 >> 2]](i[A + 4 >> 2]) | 0;
                        }
                        function Af(A) {
                            return A = A | 0, i[A >> 2] = 58864, a0(A + 32 | 0), x0(A) | 0;
                        }
                        function kF(A, r) {
                            A = A | 0, r = r | 0, i[A + 8 >> 2] = o[r + 11 | 0] < 0 ? i[r >> 2] : r;
                        }
                        function nF(A, r) {
                            A = A | 0, r = r | 0, A && (o[i[A >> 2] + 40 | 0] = (r | 0) != 0);
                        }
                        function tF(A) {
                            return A = A | 0, l[108697] || (o[108697] = 1), 86640;
                        }
                        function oF(A) {
                            return A = A | 0, l[108713] || (o[108713] = 1), 86652;
                        }
                        function uF(A) {
                            return A = A | 0, A ? l[i[A >> 2] + 224 | 0] : 0;
                        }
                        function lF(A) {
                            return A = A | 0, A ? l[i[A >> 2] + 272 | 0] : 0;
                        }
                        function sF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, pe(A, 16, r, e, f);
                        }
                        function hF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, pe(A, 32, r, e, f);
                        }
                        function wF(A) {
                            return A = A | 0, A ? l[i[A >> 2] + 40 | 0] : 0;
                        }
                        function vF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, We(A, e, 16, r, f);
                        }
                        function _F(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, We(A, e, 32, r, f);
                        }
                        function BF(A) {
                            return A = A | 0, A ? i[i[A + 8 >> 2] >> 2] : -1;
                        }
                        function Br(A, r) {
                            r && (Br(A, i[r >> 2]), Br(A, i[r + 4 >> 2]), X(r));
                        }
                        function Si(A, r) {
                            r && (Si(A, i[r >> 2]), Si(A, i[r + 4 >> 2]), X(r));
                        }
                        function T8(A, r) {
                            r && (T8(A, i[r >> 2]), T8(A, i[r + 4 >> 2]), X(r));
                        }
                        function ff(A, r) {
                            r && (ff(A, i[r >> 2]), ff(A, i[r + 4 >> 2]), X(r));
                        }
                        function ji(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, Ze(A, r, e, -1, f);
                        }
                        function mF(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, ((r | 0) < 0 ? e : r) | 0;
                        }
                        function ZF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, pe(A, 4, r, e, f);
                        }
                        function GF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, pe(A, 8, r, e, f);
                        }
                        function WF(A) {
                            return A = A | 0, A ? i[A >> 2] - -64 | 0 : 0;
                        }
                        function XF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, We(A, e, 4, r, f);
                        }
                        function pF(A, r, e, f) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, We(A, e, 8, r, f);
                        }
                        function QF(A, r, e, f) {
                            return A = A | 0, r = r | 0, e = e | 0, f = f | 0, w0 = 0, 0;
                        }
                        function a0(A) {
                            return l[A + 11 | 0] >>> 7 | 0 && y8(i[A >> 2], 1), A;
                        }
                        function h1(A) {
                            return l[A + 11 | 0] >>> 7 | 0 && y8(i[A >> 2], 4), A;
                        }
                        function Qo(A) {
                            return A = A | 0, i[A >> 2] = 66400, a0(A + 16 | 0), A | 0;
                        }
                        function N6(A, r) {
                            var e = 0;
                            e = C9(r, 1), i[A + 4 >> 2] = r, i[A >> 2] = e;
                        }
                        function Co(A) {
                            return A = A | 0, i[A >> 2] = 66360, a0(A + 12 | 0), A | 0;
                        }
                        function kf(A) {
                            return A = A | 0, i[A >> 2] = 58704, d0(A + 4 | 0), A | 0;
                        }
                        function x0(A) {
                            return A = A | 0, i[A >> 2] = 58456, d0(A + 4 | 0), A | 0;
                        }
                        function Vo(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, Y1(A, r, 0) | 0;
                        }
                        function yo(A) {
                            return A = A | 0, pr(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function Io(A) {
                            return A = A | 0, Qr(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function CF(A) {
                            return A = A | 0, (i[A >> 2] >= 3 ? i[A + 40 >> 2] : 0) | 0;
                        }
                        function VF(A) {
                            return A = A | 0, Xr(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function Fo(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, i[i[A >> 2] + r >> 2] = e;
                        }
                        function yF(A) {
                            return A = A | 0, E6(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function IF(A) {
                            return A = A | 0, jA(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function FF(A) {
                            return A = A | 0, zA(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function YF(A) {
                            return A = A | 0, TA(i[i[A >> 2] - 12 >> 2] + A | 0) | 0;
                        }
                        function D6(A, r) {
                            var e = 0;
                            e = po(r), i[A + 4 >> 2] = r, i[A >> 2] = e;
                        }
                        function nf(A) {
                            return A = A | 0, p[i[i[A >> 2] + 12 >> 2]](A) | 0;
                        }
                        function M6(A, r) {
                            return A = zn(A, r), l[A | 0] == (r & 255) ? A : 0;
                        }
                        function EF(A) {
                            return A = A | 0, w0 = i[A + 44 >> 2], i[A + 40 >> 2];
                        }
                        function Yo(A) {
                            return A = A | 0, p[i[i[A >> 2] + 24 >> 2]]() | 0;
                        }
                        function mr(A, r, e, f, k) {
                            A = A | 0, r = r | 0, e = e | 0, f = f | 0, k = k | 0;
                        }
                        function Oi(A) {
                            return A ? 31 - e1(A - 1 ^ A) | 0 : 32;
                        }
                        function Zr(A, r) {
                            T0(A, r), i[A + 72 >> 2] = 0, i[A + 76 >> 2] = -1;
                        }
                        function gF(A, r) {
                            return A = A | 0, r = r | 0, S0(i[A >> 2], r) | 0;
                        }
                        function Eo(A, r) {
                            return A = A | 0, r = r | 0, A1(i[A >> 2], r) | 0;
                        }
                        function go(A, r) {
                            return A = A | 0, r = r | 0, i[i[A >> 2] + r >> 2];
                        }
                        function Y2(A) {
                            A = A | 0, p[i[i[A + 12 >> 2] >> 2]](A + 12 | 0);
                        }
                        function h2(A) {
                            A = A | 0, p[i[i[A + 16 >> 2] >> 2]](A + 16 | 0);
                        }
                        function JF() {
                            var A = 0;
                            return A = D(4), i[A >> 2] = 0, A | 0;
                        }
                        function Gr(A, r, e) {
                            G8(A + 12 | 0, i[A + 16 >> 2], r, r + e | 0, e);
                        }
                        function RF(A) {
                            A = A | 0, o[86691] < 0 && X(i[21670]);
                        }
                        function NF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, Qe(A, e, 16, r);
                        }
                        function DF(A) {
                            A = A | 0, o[86711] < 0 && X(i[21675]);
                        }
                        function MF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, Qe(A, e, 32, r);
                        }
                        function UF(A) {
                            return A = A | 0, l[i[A + 124 >> 2] + 9016 | 0];
                        }
                        function HF(A) {
                            return A = A | 0, l[i[A + 124 >> 2] + 9018 | 0];
                        }
                        function xF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, ge(A, 16, r, e);
                        }
                        function zF(A) {
                            return A = A | 0, l[i[A + 124 >> 2] + 9020 | 0];
                        }
                        function TF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, q7(A, 16, r, e);
                        }
                        function SF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, q7(A, 32, r, e);
                        }
                        function jF(A) {
                            return A = A | 0, i[i[A >> 2] + 80 >> 2] != 0 | 0;
                        }
                        function OF(A) {
                            return A = A | 0, l[i[A + 124 >> 2] + 9019 | 0];
                        }
                        function PF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, ge(A, 32, r, e);
                        }
                        function LF(A) {
                            return A = A | 0, l[i[A + 32 >> 2] + 112 | 0];
                        }
                        function KF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, Qe(A, e, 4, r);
                        }
                        function qF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, Qe(A, e, 8, r);
                        }
                        function $F(A) {
                            A = A | 0, o[A + 97 | 0] = k0[A + 104 >> 2] > 65535;
                        }
                        function aF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, ge(A, 4, r, e);
                        }
                        function bF(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0, ge(A, 8, r, e);
                        }
                        function tf(A, r) {
                            return A = A | 0, r = r | 0, p[A | 0](r) | 0;
                        }
                        function dF(A) {
                            return A = A | 0, l[i[A + 32 >> 2] + 113 | 0];
                        }
                        function cF(A) {
                            return A = A | 0, l[i[A + 32 >> 2] + 122 | 0];
                        }
                        function iY(A) {
                            return A = A | 0, l[i[A + 32 >> 2] + 123 | 0];
                        }
                        function Jo(A) {
                            var r = 0, e = 0;
                            r = A, e = L2(), i[r >> 2] = e;
                        }
                        function Ro(A, r, e, f) {
                            Ss(A | 0, r | 0, 8, 0, e | 0, -1, f | 0);
                        }
                        function y8(A, r) {
                            if (r >>> 0 > 8) {
                                X(A);
                                return;
                            }
                            X(A);
                        }
                        function eY(A, r) {
                            A = A | 0, r = r | 0, i[i[A >> 2] + 56 >> 2] = r;
                        }
                        function Wr(A, r) {
                            return A ? Ke(A, r) : 0;
                        }
                        function No(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, A | 0;
                        }
                        function j1(A, r, e) {
                            l[A | 0] & 32 || $e(r, e, A);
                        }
                        function rY(A, r) {
                            A = A | 0, r = r | 0, o[A + 4 | 0] = (r | 0) != 0;
                        }
                        function AY(A) {
                            return A = A | 0, i[A >> 2] = 77856, A | 0;
                        }
                        function fY(A) {
                            return A = A | 0, i[A >> 2] = 76816, A | 0;
                        }
                        function kY(A) {
                            return A = A | 0, i[A >> 2] = 80536, A | 0;
                        }
                        function Do(A) {
                            A = A | 0, vf(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function nY(A) {
                            return A = A | 0, i[A >> 2] = 84136, A | 0;
                        }
                        function tY(A) {
                            return A = A | 0, i[A >> 2] = 77896, A | 0;
                        }
                        function oY(A) {
                            return A = A | 0, i[A >> 2] = 76856, A | 0;
                        }
                        function uY(A) {
                            return A = A | 0, i[A >> 2] = 84176, A | 0;
                        }
                        function lY(A) {
                            return A = A | 0, i[A >> 2] = 77936, A | 0;
                        }
                        function sY(A) {
                            return A = A | 0, i[A >> 2] = 76896, A | 0;
                        }
                        function hY(A) {
                            return A = A | 0, i[A >> 2] = 84216, A | 0;
                        }
                        function wY(A) {
                            return A = A | 0, i[A >> 2] = 77976, A | 0;
                        }
                        function vY(A) {
                            return A = A | 0, p[i[A + 4 >> 2]]() | 0;
                        }
                        function Mo(A) {
                            A = A | 0, _f(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function _Y(A) {
                            return A = A | 0, i[A >> 2] = 76936, A | 0;
                        }
                        function BY(A) {
                            return A = A | 0, i[A >> 2] = 84292, A | 0;
                        }
                        function mY(A) {
                            return A = A | 0, i[A >> 2] = 78016, A | 0;
                        }
                        function ZY(A) {
                            return A = A | 0, i[A >> 2] = 78780, A | 0;
                        }
                        function GY(A) {
                            return A = A | 0, i[A >> 2] = 76976, A | 0;
                        }
                        function WY(A) {
                            return A = A | 0, i[A >> 2] = 84368, A | 0;
                        }
                        function XY(A) {
                            return A = A | 0, i[A >> 2] = 78056, A | 0;
                        }
                        function pY(A) {
                            return A = A | 0, i[A >> 2] = 77016, A | 0;
                        }
                        function QY(A) {
                            return A = A | 0, i[A >> 2] = 84408, A | 0;
                        }
                        function CY(A) {
                            return A = A | 0, i[A >> 2] = 78096, A | 0;
                        }
                        function VY(A) {
                            return A = A | 0, i[A >> 2] = 82576, A | 0;
                        }
                        function yY(A) {
                            return A = A | 0, _9(i[A + 392 >> 2]) | 0;
                        }
                        function IY(A) {
                            return A = A | 0, i[A >> 2] = 84448, A | 0;
                        }
                        function FY(A) {
                            return A = A | 0, i[A >> 2] = 77056, A | 0;
                        }
                        function YY(A) {
                            return A = A | 0, i[A >> 2] = 78136, A | 0;
                        }
                        function EY(A) {
                            return A = A | 0, i[A >> 2] = 82616, A | 0;
                        }
                        function gY(A) {
                            return A = A | 0, i[A >> 2] = 84488, A | 0;
                        }
                        function JY(A) {
                            A = A | 0, Bf(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function RY(A) {
                            return A = A | 0, i[A >> 2] = 77096, A | 0;
                        }
                        function NY(A) {
                            return A = A | 0, i[A >> 2] = 79880, A | 0;
                        }
                        function DY(A) {
                            return A = A | 0, i[A >> 2] = 82656, A | 0;
                        }
                        function MY(A) {
                            return A = A | 0, i[A >> 2] = 84528, A | 0;
                        }
                        function UY(A) {
                            return A = A | 0, i[A >> 2] = 77136, A | 0;
                        }
                        function HY(A) {
                            return A = A | 0, i[A >> 2] = 78252, A | 0;
                        }
                        function xY(A) {
                            return A = A | 0, i[A >> 2] = 82696, A | 0;
                        }
                        function zY(A, r) {
                            return A = A | 0, r = r | 0, _7(A, r) | 0;
                        }
                        function TY(A) {
                            return A = A | 0, i[A >> 2] = 79920, A | 0;
                        }
                        function SY(A) {
                            return A = A | 0, i[A >> 2] = 84568, A | 0;
                        }
                        function jY(A) {
                            return A = A | 0, i[A >> 2] = 77176, A | 0;
                        }
                        function OY(A) {
                            return A = A | 0, i[A >> 2] = 82736, A | 0;
                        }
                        function PY(A) {
                            return A = A | 0, i[A >> 2] = 78292, A | 0;
                        }
                        function LY(A) {
                            return A = A | 0, i[A >> 2] = 84644, A | 0;
                        }
                        function KY(A) {
                            return A = A | 0, i[A >> 2] = 76136, A | 0;
                        }
                        function qY(A) {
                            return A = A | 0, i[A >> 2] = 77216, A | 0;
                        }
                        function $Y(A) {
                            return A = A | 0, i[A >> 2] = 82776, A | 0;
                        }
                        function aY(A) {
                            return A = A | 0, i[A >> 2] = 84720, A | 0;
                        }
                        function bY(A) {
                            return A = A | 0, i[A >> 2] = 76176, A | 0;
                        }
                        function dY(A) {
                            return A = A | 0, i[A >> 2] = 77256, A | 0;
                        }
                        function cY(A) {
                            return A = A | 0, i[A >> 2] = 78332, A | 0;
                        }
                        function iE(A) {
                            return A = A | 0, i[A >> 2] = 84796, A | 0;
                        }
                        function eE(A) {
                            return A = A | 0, i[A >> 2] = 76216, A | 0;
                        }
                        function rE(A) {
                            return A = A | 0, i[A >> 2] = 76256, A | 0;
                        }
                        function AE(A) {
                            return A = A | 0, i[A >> 2] = 78372, A | 0;
                        }
                        function fE(A) {
                            return A = A | 0, i[A >> 2] = 84872, A | 0;
                        }
                        function kE(A) {
                            return A = A | 0, i[A >> 2] = 77336, A | 0;
                        }
                        function nE(A) {
                            return A = A | 0, i[A >> 2] = 83576, A | 0;
                        }
                        function tE(A) {
                            return A = A | 0, i[A >> 2] = 76296, A | 0;
                        }
                        function oE(A) {
                            return A = A | 0, i[A >> 2] = 82908, A | 0;
                        }
                        function uE(A) {
                            return A = A | 0, i[A >> 2] = 84948, A | 0;
                        }
                        function lE(A) {
                            return A = A | 0, i[A >> 2] = 77376, A | 0;
                        }
                        function sE(A) {
                            return A = A | 0, i[A >> 2] = 78460, A | 0;
                        }
                        function hE(A) {
                            return A = A | 0, i[A >> 2] = 76336, A | 0;
                        }
                        function wE(A) {
                            return A = A | 0, i[A >> 2] = 82948, A | 0;
                        }
                        function vE(A) {
                            return A = A | 0, i[A >> 2] = 83624, A | 0;
                        }
                        function _E(A) {
                            return A = A | 0, i[A >> 2] = 85024, A | 0;
                        }
                        function BE(A) {
                            return A = A | 0, i[A >> 2] = 77416, A | 0;
                        }
                        function mE(A) {
                            return A = A | 0, i[A >> 2] = 80120, A | 0;
                        }
                        function ZE(A) {
                            return A = A | 0, i[A >> 2] = 76376, A | 0;
                        }
                        function GE(A) {
                            return A = A | 0, i[A >> 2] = 82988, A | 0;
                        }
                        function WE(A) {
                            return A = A | 0, i[A >> 2] = 83664, A | 0;
                        }
                        function XE(A) {
                            return A = A | 0, i[A >> 2] = 85100, A | 0;
                        }
                        function pE(A) {
                            return A = A | 0, i[A >> 2] = 77456, A | 0;
                        }
                        function QE(A) {
                            return A = A | 0, i[A >> 2] = 80160, A | 0;
                        }
                        function CE(A) {
                            return A = A | 0, i[A >> 2] = 76416, A | 0;
                        }
                        function VE(A) {
                            return A = A | 0, i[A >> 2] = 83028, A | 0;
                        }
                        function yE(A) {
                            return A = A | 0, i[A >> 2] = 83740, A | 0;
                        }
                        function IE(A) {
                            return A = A | 0, i[A >> 2] = 85176, A | 0;
                        }
                        function FE(A) {
                            return A = A | 0, i[A >> 2] = 77496, A | 0;
                        }
                        function YE(A) {
                            return A = A | 0, i[A >> 2] = 80200, A | 0;
                        }
                        function Uo(A, r, e) {
                            return A = A | 0, r = r | 0, e = e | 0, -1;
                        }
                        function EE(A) {
                            return A = A | 0, i[A >> 2] = 48964, A | 0;
                        }
                        function gE(A) {
                            return A = A | 0, i[A >> 2] = 76456, A | 0;
                        }
                        function JE(A) {
                            return A = A | 0, i[A >> 2] = 78508, A | 0;
                        }
                        function RE(A) {
                            return A = A | 0, i[A >> 2] = 83816, A | 0;
                        }
                        function NE(A) {
                            return A = A | 0, i[A >> 2] = 77536, A | 0;
                        }
                        function DE(A) {
                            return A = A | 0, i[A >> 2] = 80240, A | 0;
                        }
                        function ME(A) {
                            return A = A | 0, i[A >> 2] = 83068, A | 0;
                        }
                        function UE(A) {
                            return A = A | 0, i[A >> 2] = 76496, A | 0;
                        }
                        function HE(A) {
                            return A = A | 0, i[A >> 2] = 79228, A | 0;
                        }
                        function xE(A) {
                            return A = A | 0, i[A >> 2] = 83856, A | 0;
                        }
                        function zE(A) {
                            return A = A | 0, i[A >> 2] = 49080, A | 0;
                        }
                        function TE(A) {
                            return A = A | 0, i[A >> 2] = 77576, A | 0;
                        }
                        function SE(A) {
                            return A = A | 0, i[A >> 2] = 80280, A | 0;
                        }
                        function jE(A) {
                            return A = A | 0, i[A >> 2] = 83108, A | 0;
                        }
                        function OE(A) {
                            return A = A | 0, i[A >> 2] = 76536, A | 0;
                        }
                        function PE(A) {
                            return A = A | 0, i[A >> 2] = 78548, A | 0;
                        }
                        function LE(A) {
                            return A = A | 0, i[A >> 2] = 79268, A | 0;
                        }
                        function KE(A) {
                            return A = A | 0, i[A >> 2] = 77616, A | 0;
                        }
                        function qE(A) {
                            return A = A | 0, i[A >> 2] = 80320, A | 0;
                        }
                        function $E(A) {
                            return A = A | 0, i[A >> 2] = 49192, A | 0;
                        }
                        function aE(A) {
                            A = A | 0, hf(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function bE(A) {
                            return A = A | 0, i[A >> 2] = 76576, A | 0;
                        }
                        function dE(A) {
                            return A = A | 0, i[A >> 2] = 78588, A | 0;
                        }
                        function cE(A) {
                            return A = A | 0, i[A >> 2] = 79308, A | 0;
                        }
                        function ig(A) {
                            return A = A | 0, i[A >> 2] = 83896, A | 0;
                        }
                        function eg(A) {
                            return A = A | 0, i[A >> 2] = 77656, A | 0;
                        }
                        function rg(A) {
                            A = A | 0, Au(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function Ag(A) {
                            return A = A | 0, i[A >> 2] = 76616, A | 0;
                        }
                        function fg(A) {
                            return A = A | 0, i[A >> 2] = 79348, A | 0;
                        }
                        function kg(A) {
                            return A = A | 0, i[A >> 2] = 83936, A | 0;
                        }
                        function ng(A) {
                            return A = A | 0, i[A >> 2] = 77696, A | 0;
                        }
                        function tg(A) {
                            return A = A | 0, i[A >> 2] = 76656, A | 0;
                        }
                        function og(A) {
                            return A = A | 0, i[A >> 2] = 83976, A | 0;
                        }
                        function ug(A) {
                            A = A | 0, fu(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function lg(A) {
                            return A = A | 0, i[A >> 2] = 77736, A | 0;
                        }
                        function sg(A) {
                            return A = A | 0, i[A >> 2] = 79388, A | 0;
                        }
                        function hg(A) {
                            return A = A | 0, i[A >> 2] = 76696, A | 0;
                        }
                        function wg(A) {
                            return A = A | 0, i[A >> 2] = 84016, A | 0;
                        }
                        function vg(A) {
                            A = A | 0, ku(i[i[A >> 2] - 12 >> 2] + A | 0);
                        }
                        function _g(A) {
                            return A = A | 0, i[A >> 2] = 77776, A | 0;
                        }
                        function Bg(A) {
                            return A = A | 0, i[A >> 2] = 79428, A | 0;
                        }
                        function mg(A) {
                            return A = A | 0, i[A >> 2] = 76736, A | 0;
                        }
                        function Zg(A) {
                            return A = A | 0, i[A >> 2] = 84056, A | 0;
                        }
                        function Gg(A) {
                            return A = A | 0, ((A | 0) == 1 ? 100 : 0) | 0;
                        }
                        function Wg(A) {
                            return A = A | 0, i[A >> 2] = 77816, A | 0;
                        }
                        function Xg(A) {
                            return A = A | 0, i[A >> 2] = 76776, A | 0;
                        }
                        function pg(A) {
                            return A = A | 0, i[A >> 2] = 84096, A | 0;
                        }
                        function Qg(A) {
                            return A = A | 0, i[A >> 2] = 77296, A | 0;
                        }
                        function Cg(A) {
                            return A = A | 0, l[i[A >> 2] + 108 | 0];
                        }
                        function Vg(A) {
                            return A = A | 0, i[i[A >> 2] + 32 >> 2];
                        }
                        function Ho(A) {
                            return A = A | 0, i[i[A >> 2] + 36 >> 2];
                        }
                        function xo(A) {
                            return A = A | 0, i[i[A >> 2] + 20 >> 2];
                        }
                        function yg(A) {
                            return A = A | 0, s7(i[A + 60 >> 2]) | 0;
                        }
                        function zo(A) {
                            return A = A | 0, i[i[A >> 2] + 16 >> 2];
                        }
                        function Ig(A) {
                            return A = A | 0, i[i[A >> 2] + 8 >> 2];
                        }
                        function Fg(A) {
                            return A = A | 0, i[i[A >> 2] + 4 >> 2];
                        }
                        function Yg(A) {
                            return A = A | 0, (_n(A, 0) | 0) != 0 | 0;
                        }
                        function To(A) {
                            return A = A | 0, l[i[A >> 2] + 48 | 0];
                        }
                        function Eg(A) {
                            return A = A | 0, (l[A + 4 | 0] ? 3 : 6) | 0;
                        }
                        function gg(A) {
                            return A = A | 0, l[i[A >> 2] + 65 | 0];
                        }
                        function Jg(A) {
                            A = A | 0, p[i[i[A >> 2] + 4 >> 2]](A);
                        }
                        function Xr(A) {
                            return A = A | 0, N0(A + 12 | 0), A | 0;
                        }
                        function pr(A) {
                            return A = A | 0, N0(A + 8 | 0), A | 0;
                        }
                        function Qr(A) {
                            return A = A | 0, N0(A + 4 | 0), A | 0;
                        }
                        function Rg(A, r) {
                            A = A | 0, r = r | 0, RA(A, r + 12 | 0);
                        }
                        function Ng(A, r) {
                            A = A | 0, r = r | 0, RA(A, r + 16 | 0);
                        }
                        function Dg(A) {
                            A = A | 0, i[A >> 2] = 77536, X(A);
                        }
                        function Mg(A) {
                            A = A | 0, i[A >> 2] = 76776, X(A);
                        }
                        function Ug(A) {
                            A = A | 0, i[A >> 2] = 84096, X(A);
                        }
                        function Hg(A) {
                            A = A | 0, i[A >> 2] = 77856, X(A);
                        }
                        function xg(A) {
                            A = A | 0, i[A >> 2] = 76816, X(A);
                        }
                        function zg(A) {
                            A = A | 0, i[A >> 2] = 80536, X(A);
                        }
                        function Tg(A) {
                            A = A | 0, i[A >> 2] = 84136, X(A);
                        }
                        function Sg(A) {
                            A = A | 0, i[A >> 2] = 77896, X(A);
                        }
                        function jg(A) {
                            A = A | 0, i[A >> 2] = 76856, X(A);
                        }
                        function Og(A) {
                            A = A | 0, i[A >> 2] = 84176, X(A);
                        }
                        function Pg(A) {
                            A = A | 0, i[A >> 2] = 77936, X(A);
                        }
                        function Lg(A) {
                            A = A | 0, i[A >> 2] = 76896, X(A);
                        }
                        function Kg(A) {
                            A = A | 0, i[A >> 2] = 84216, X(A);
                        }
                        function qg(A) {
                            A = A | 0, i[A >> 2] = 77976, X(A);
                        }
                        function $g(A) {
                            A = A | 0, i[A >> 2] = 76936, X(A);
                        }
                        function ag(A) {
                            A = A | 0, i[A >> 2] = 84292, X(A);
                        }
                        function bg(A) {
                            A = A | 0, i[A >> 2] = 78016, X(A);
                        }
                        function dg(A) {
                            A = A | 0, i[A >> 2] = 78780, X(A);
                        }
                        function cg(A) {
                            A = A | 0, i[A >> 2] = 76976, X(A);
                        }
                        function iJ(A) {
                            A = A | 0, i[A >> 2] = 84368, X(A);
                        }
                        function eJ(A) {
                            A = A | 0, i[A >> 2] = 78056, X(A);
                        }
                        function rJ(A) {
                            A = A | 0, i[A >> 2] = 77016, X(A);
                        }
                        function AJ(A) {
                            A = A | 0, i[A >> 2] = 84408, X(A);
                        }
                        function fJ(A) {
                            A = A | 0, i[A >> 2] = 78096, X(A);
                        }
                        function kJ(A) {
                            A = A | 0, i[A >> 2] = 82576, X(A);
                        }
                        function nJ(A) {
                            A = A | 0, i[A >> 2] = 84448, X(A);
                        }
                        function tJ(A) {
                            A = A | 0, i[A >> 2] = 77056, X(A);
                        }
                        function oJ(A) {
                            A = A | 0, i[A >> 2] = 78136, X(A);
                        }
                        function uJ(A) {
                            A = A | 0, i[A >> 2] = 82616, X(A);
                        }
                        function lJ(A) {
                            A = A | 0, i[A >> 2] = 84488, X(A);
                        }
                        function sJ(A) {
                            A = A | 0, i[A >> 2] = 77096, X(A);
                        }
                        function hJ(A) {
                            A = A | 0, i[A >> 2] = 79880, X(A);
                        }
                        function wJ(A) {
                            A = A | 0, i[A >> 2] = 82656, X(A);
                        }
                        function vJ(A) {
                            A = A | 0, i[A >> 2] = 84528, X(A);
                        }
                        function _J(A) {
                            A = A | 0, i[A >> 2] = 77136, X(A);
                        }
                        function BJ(A) {
                            A = A | 0, i[A >> 2] = 78252, X(A);
                        }
                        function mJ(A) {
                            A = A | 0, i[A >> 2] = 82696, X(A);
                        }
                        function ZJ(A) {
                            A = A | 0, i[A >> 2] = 79920, X(A);
                        }
                        function GJ(A) {
                            A = A | 0, i[A >> 2] = 84568, X(A);
                        }
                        function WJ(A) {
                            A = A | 0, i[A >> 2] = 77176, X(A);
                        }
                        function XJ(A) {
                            A = A | 0, i[A >> 2] = 82736, X(A);
                        }
                        function pJ(A) {
                            A = A | 0, i[A >> 2] = 78292, X(A);
                        }
                        function QJ(A) {
                            A = A | 0, i[A >> 2] = 84644, X(A);
                        }
                        function CJ(A) {
                            A = A | 0, i[A >> 2] = 76136, X(A);
                        }
                        function VJ(A) {
                            A = A | 0, i[A >> 2] = 77216, X(A);
                        }
                        function yJ(A) {
                            A = A | 0, i[A >> 2] = 82776, X(A);
                        }
                        function IJ(A, r) {
                            A = A | 0, r = r | 0, X6(A, 66432);
                        }
                        function FJ(A) {
                            A = A | 0, i[A >> 2] = 84720, X(A);
                        }
                        function YJ(A, r) {
                            A = A | 0, r = r | 0, Gi(A, 10076);
                        }
                        function EJ(A) {
                            A = A | 0, i[A >> 2] = 76176, X(A);
                        }
                        function gJ(A) {
                            A = A | 0, i[A >> 2] = 77256, X(A);
                        }
                        function JJ(A) {
                            A = A | 0, i[A >> 2] = 78332, X(A);
                        }
                        function RJ(A, r) {
                            A = A | 0, r = r | 0, X6(A, 66452);
                        }
                        function NJ(A) {
                            A = A | 0, i[A >> 2] = 77296, X(A);
                        }
                        function DJ(A) {
                            A = A | 0, i[A >> 2] = 76256, X(A);
                        }
                        function MJ(A) {
                            A = A | 0, i[A >> 2] = 78372, X(A);
                        }
                        function UJ(A) {
                            A = A | 0, i[A >> 2] = 84872, X(A);
                        }
                        function HJ(A) {
                            A = A | 0, i[A >> 2] = 77336, X(A);
                        }
                        function xJ(A) {
                            A = A | 0, i[A >> 2] = 83576, X(A);
                        }
                        function zJ(A) {
                            A = A | 0, i[A >> 2] = 76296, X(A);
                        }
                        function TJ(A) {
                            A = A | 0, i[A >> 2] = 82908, X(A);
                        }
                        function SJ(A) {
                            A = A | 0, i[A >> 2] = 84948, X(A);
                        }
                        function jJ(A) {
                            A = A | 0, i[A >> 2] = 77376, X(A);
                        }
                        function OJ(A) {
                            A = A | 0, i[A >> 2] = 78460, X(A);
                        }
                        function PJ(A) {
                            A = A | 0, i[A >> 2] = 76336, X(A);
                        }
                        function LJ(A) {
                            A = A | 0, i[A >> 2] = 82948, X(A);
                        }
                        function KJ(A) {
                            A = A | 0, i[A >> 2] = 83624, X(A);
                        }
                        function qJ(A) {
                            A = A | 0, i[A >> 2] = 85024, X(A);
                        }
                        function $J(A) {
                            A = A | 0, i[A >> 2] = 77416, X(A);
                        }
                        function aJ(A) {
                            A = A | 0, i[A >> 2] = 80120, X(A);
                        }
                        function bJ(A) {
                            A = A | 0, i[A >> 2] = 76376, X(A);
                        }
                        function dJ(A) {
                            A = A | 0, i[A >> 2] = 82988, X(A);
                        }
                        function cJ(A) {
                            A = A | 0, i[A >> 2] = 83664, X(A);
                        }
                        function iR(A) {
                            A = A | 0, i[A >> 2] = 85100, X(A);
                        }
                        function eR(A) {
                            A = A | 0, i[A >> 2] = 77456, X(A);
                        }
                        function rR(A) {
                            A = A | 0, i[A >> 2] = 80160, X(A);
                        }
                        function AR(A) {
                            A = A | 0, i[A >> 2] = 76416, X(A);
                        }
                        function fR(A) {
                            A = A | 0, i[A >> 2] = 83028, X(A);
                        }
                        function kR(A) {
                            A = A | 0, i[A >> 2] = 83740, X(A);
                        }
                        function nR(A) {
                            A = A | 0, i[A >> 2] = 85176, X(A);
                        }
                        function tR(A) {
                            A = A | 0, i[A >> 2] = 77496, X(A);
                        }
                        function oR(A) {
                            A = A | 0, i[A >> 2] = 80200, X(A);
                        }
                        function uR(A) {
                            A = A | 0, i[A >> 2] = 48964, X(A);
                        }
                        function lR(A) {
                            A = A | 0, i[A >> 2] = 76456, X(A);
                        }
                        function sR(A) {
                            A = A | 0, i[A >> 2] = 78508, X(A);
                        }
                        function hR(A) {
                            A = A | 0, i[A >> 2] = 83816, X(A);
                        }
                        function wR(A) {
                            A = A | 0, i[A >> 2] = 80240, X(A);
                        }
                        function vR(A) {
                            A = A | 0, i[A >> 2] = 83068, X(A);
                        }
                        function _R(A) {
                            A = A | 0, i[A >> 2] = 76496, X(A);
                        }
                        function BR(A) {
                            A = A | 0, i[A >> 2] = 79228, X(A);
                        }
                        function mR(A) {
                            A = A | 0, i[A >> 2] = 83856, X(A);
                        }
                        function ZR(A) {
                            A = A | 0, i[A >> 2] = 49080, X(A);
                        }
                        function GR(A) {
                            A = A | 0, i[A >> 2] = 77576, X(A);
                        }
                        function WR(A) {
                            A = A | 0, i[A >> 2] = 80280, X(A);
                        }
                        function XR(A) {
                            A = A | 0, i[A >> 2] = 83108, X(A);
                        }
                        function pR(A) {
                            A = A | 0, i[A >> 2] = 76536, X(A);
                        }
                        function QR(A) {
                            A = A | 0, i[A >> 2] = 78548, X(A);
                        }
                        function CR(A) {
                            A = A | 0, i[A >> 2] = 79268, X(A);
                        }
                        function VR(A) {
                            A = A | 0, i[A >> 2] = 77616, X(A);
                        }
                        function yR(A) {
                            A = A | 0, i[A >> 2] = 80320, X(A);
                        }
                        function IR(A) {
                            A = A | 0, i[A >> 2] = 49192, X(A);
                        }
                        function FR(A) {
                            A = A | 0, i[A >> 2] = 76576, X(A);
                        }
                        function YR(A) {
                            A = A | 0, i[A >> 2] = 78588, X(A);
                        }
                        function ER(A) {
                            A = A | 0, i[A >> 2] = 79308, X(A);
                        }
                        function gR(A) {
                            A = A | 0, i[A >> 2] = 83896, X(A);
                        }
                        function JR(A) {
                            A = A | 0, i[A >> 2] = 77656, X(A);
                        }
                        function RR(A) {
                            A = A | 0, i[A >> 2] = 76616, X(A);
                        }
                        function NR(A) {
                            A = A | 0, i[A >> 2] = 79348, X(A);
                        }
                        function DR(A) {
                            A = A | 0, i[A >> 2] = 83936, X(A);
                        }
                        function MR(A) {
                            A = A | 0, i[A >> 2] = 77696, X(A);
                        }
                        function UR(A) {
                            A = A | 0, i[A >> 2] = 76656, X(A);
                        }
                        function HR(A) {
                            A = A | 0, i[A >> 2] = 83976, X(A);
                        }
                        function xR(A) {
                            A = A | 0, i[A >> 2] = 77736, X(A);
                        }
                        function zR(A) {
                            A = A | 0, i[A >> 2] = 79388, X(A);
                        }
                        function TR(A) {
                            A = A | 0, i[A >> 2] = 76696, X(A);
                        }
                        function SR(A) {
                            A = A | 0, i[A >> 2] = 84016, X(A);
                        }
                        function jR(A) {
                            A = A | 0, i[A >> 2] = 77776, X(A);
                        }
                        function OR(A) {
                            A = A | 0, i[A >> 2] = 79428, X(A);
                        }
                        function PR(A) {
                            A = A | 0, i[A >> 2] = 76736, X(A);
                        }
                        function LR(A) {
                            A = A | 0, i[A >> 2] = 84056, X(A);
                        }
                        function KR(A) {
                            A = A | 0, i[A >> 2] = 77816, X(A);
                        }
                        function qR(A) {
                            A = A | 0, i[A >> 2] = 76216, X(A);
                        }
                        function $R(A) {
                            A = A | 0, i[A >> 2] = 84796, X(A);
                        }
                        function aR(A) {
                            return A = A | 0, Xr(A - 8 | 0) | 0;
                        }
                        function of(A, r) {
                            A = A | 0, r = r | 0, p[A | 0](r);
                        }
                        function So(A, r) {
                            A = A | 0, r = r | 0, qn(A, 1, 45);
                        }
                        function jo(A, r) {
                            A = A | 0, r = r | 0, Yn(A, 1, 45);
                        }
                        function bR(A, r) {
                            A = A | 0, r = r | 0, Gi(A, 9769);
                        }
                        function Oo(A) {
                            return A = A | 0, p[A | 0]() | 0;
                        }
                        function dR(A) {
                            A = A | 0, T8(86752, i[21689]);
                        }
                        function cR(A) {
                            A = A | 0, T8(86764, i[21692]);
                        }
                        function iN(A) {
                            A = A | 0, T8(86776, i[21695]);
                        }
                        function eN(A) {
                            return A = A | 0, E6(A - 8 | 0) | 0;
                        }
                        function Po(A, r) {
                            return A = A | 0, r = r | 0, r | 0;
                        }
                        function rN(A) {
                            A = A | 0, Br(86712, i[21679]);
                        }
                        function AN(A) {
                            A = A | 0, hr(86724, i[21682]);
                        }
                        function fN(A) {
                            return A = A | 0, i[A + 124 >> 2];
                        }
                        function kN(A) {
                            return A = A | 0, i[A + 372 >> 2];
                        }
                        function nN(A) {
                            return A = A | 0, 1781689137;
                        }
                        function tN(A) {
                            return A = A | 0, 1852009592;
                        }
                        function oN(A) {
                            return A = A | 0, 1768912492;
                        }
                        function uN(A) {
                            return A = A | 0, 1768187246;
                        }
                        function lN(A) {
                            return A = A | 0, 1635135537;
                        }
                        function sN(A) {
                            return A = A | 0, 1836280681;
                        }
                        function Cr(A) {
                            return A = A | 0, 2147483647;
                        }
                        function hN(A) {
                            return A = A | 0, i[A + 12 >> 2];
                        }
                        function Lo(A, r, e) {
                            e && Q0(A, r, e << 2);
                        }
                        function wN(A) {
                            return A = A | 0, i[A + 20 >> 2];
                        }
                        function vN(A) {
                            return A = A | 0, 1953066089;
                        }
                        function Ko(A, r) {
                            return (F6(A, r) | 0) != -1;
                        }
                        function _N(A) {
                            return A = A | 0, 1987470129;
                        }
                        function BN(A) {
                            return A = A | 0, 1785750887;
                        }
                        function mN(A) {
                            return A = A | 0, 1752589105;
                        }
                        function ZN(A) {
                            return A = A | 0, 1635148593;
                        }
                        function GN(A) {
                            return A = A | 0, 1735551332;
                        }
                        function WN(A) {
                            A = A | 0, N9(i[A >> 2]), X(A);
                        }
                        function uf(A) {
                            return A = A | 0, i[A + 4 >> 2];
                        }
                        function Vr(A, r) {
                            return A = A | 0, r = r | 0, -1;
                        }
                        function XN(A) {
                            return A = A | 0, H5(A, 0) | 0;
                        }
                        function pN(A) {
                            return A = A | 0, H5(A, 1) | 0;
                        }
                        function QN(A) {
                            return A = A | 0, R5(A, 0) | 0;
                        }
                        function CN(A) {
                            return A = A | 0, R5(A, 1) | 0;
                        }
                        function qo() {
                            X(i[25992]), i[25992] = 0;
                        }
                        function $o(A) {
                            return A = A | 0, i[A + 8 >> 2];
                        }
                        function T2(A, r) {
                            return st(A) ^ st(r) ^ 1;
                        }
                        function lf(A) {
                            return Q2(A + 80 | 0) + 80 | 0;
                        }
                        function S2(A, r) {
                            return lt(A) ^ lt(r) ^ 1;
                        }
                        function VN(A) {
                            return A = A | 0, l[A + 96 | 0];
                        }
                        function yN(A, r) {
                            return A = A | 0, r = r | 0, 0;
                        }
                        function IN(A, r, e) {
                            A = A | 0, r = r | 0, e = e | 0;
                        }
                        function FN(A) {
                            return A = A | 0, o[A + 8 | 0];
                        }
                        function YN(A) {
                            return A = A | 0, o[A + 9 | 0];
                        }
                        function g1(A) {
                            return Ot(i[A >> 2]), A;
                        }
                        function J1(A) {
                            return zt(i[A >> 2]), A;
                        }
                        function M4(A, r) {
                            N1(A, i[A + 16 >> 2] | r);
                        }
                        function ao(A, r, e) {
                            e && Q0(A, r, e);
                        }
                        function bo(A) {
                            return A = A | 0, N0(A) | 0;
                        }
                        function EN(A) {
                            return A = A | 0, 86944;
                        }
                        function gN(A) {
                            return A = A | 0, 79552;
                        }
                        function JN(A) {
                            return A = A | 0, 79656;
                        }
                        function RN(A) {
                            return A = A | 0, 79712;
                        }
                        function NN(A) {
                            return A = A | 0, 14697;
                        }
                        function yr(A) {
                            return A = A | 0, 15657;
                        }
                        function DN(A) {
                            return A = A | 0, 18137;
                        }
                        function I8(A) {
                            A = A | 0, A && X(A);
                        }
                        function MN(A) {
                            return A = A | 0, 5263;
                        }
                        function UN(A) {
                            A = A | 0, x0(A), X(A);
                        }
                        function HN(A) {
                            A = A | 0, kf(A), X(A);
                        }
                        function xN(A) {
                            return A = A | 0, 6599;
                        }
                        function co(A) {
                            A = A | 0, Tt(A), X(A);
                        }
                        function zN(A) {
                            return A = A | 0, 8941;
                        }
                        function iu(A, r, e) {
                            Se(A, r, e, 0, 0);
                        }
                        function TN(A) {
                            A = A | 0, o[A + 97 | 0] = 0;
                        }
                        function eu(A) {
                            A = A | 0, N0(A), X(A);
                        }
                        function SN(A) {
                            A = A | 0, pi(A), X(A);
                        }
                        function jN(A) {
                            A = A | 0, h1(108780);
                        }
                        function Ir(A) {
                            return A = A | 0, 127;
                        }
                        function _4(A) {
                            return A = A | 0, A | 0;
                        }
                        function ON(A) {
                            A = A | 0, h1(108700);
                        }
                        function PN(A) {
                            A = A | 0, h1(108716);
                        }
                        function LN(A) {
                            A = A | 0, a0(108732);
                        }
                        function sf(A, r) {
                            return w0 = A, r;
                        }
                        function KN(A) {
                            A = A | 0, h1(108748);
                        }
                        function qN(A) {
                            A = A | 0, a0(108764);
                        }
                        function $N(A) {
                            A = A | 0, X(yn(A));
                        }
                        function ru(A) {
                            A = A | 0, X(ef(A));
                        }
                        function hf(A) {
                            A = A | 0, X(E6(A));
                        }
                        function aN(A) {
                            A = A | 0, X(Bo(A));
                        }
                        function W1(A) {
                            A = A | 0, X(V2(A));
                        }
                        function Au(A) {
                            A = A | 0, X(jA(A));
                        }
                        function bN(A) {
                            A = A | 0, Bf(A - 8 | 0);
                        }
                        function fu(A) {
                            A = A | 0, X(zA(A));
                        }
                        function dN(A) {
                            A = A | 0, X(Co(A));
                        }
                        function ku(A) {
                            A = A | 0, X(TA(A));
                        }
                        function cN(A) {
                            A = A | 0, X(Qo(A));
                        }
                        function wf(A) {
                            A = A | 0, X(F1(A));
                        }
                        function nu(A) {
                            A = A | 0, X(x0(A));
                        }
                        function iD(A) {
                            A = A | 0, X(H7(A));
                        }
                        function tu(A) {
                            A = A | 0, X(kf(A));
                        }
                        function eD(A) {
                            A = A | 0, X(Af(A));
                        }
                        function rD(A) {
                            A = A | 0, X(jn(A));
                        }
                        function AD(A) {
                            A = A | 0, X(m9(A));
                        }
                        function fD(A) {
                            A = A | 0, a0(86640);
                        }
                        function kD(A) {
                            A = A | 0, hf(A - 8 | 0);
                        }
                        function nD(A) {
                            A = A | 0, a0(86652);
                        }
                        function tD(A) {
                            A = A | 0, X(Nn(A));
                        }
                        function vf(A) {
                            A = A | 0, X(pr(A));
                        }
                        function _f(A) {
                            A = A | 0, X(Qr(A));
                        }
                        function oD(A) {
                            A = A | 0, X(to(A));
                        }
                        function uD(A) {
                            A = A | 0, X(N0(A));
                        }
                        function Bf(A) {
                            A = A | 0, X(Xr(A));
                        }
                        function ou(A) {
                            return A = A | 0, 3;
                        }
                        function uu(A) {
                            return A = A | 0, 7;
                        }
                        function mf(A) {
                            return A = A | 0, 5;
                        }
                        function lu() {
                            return 18024448;
                        }
                        function X1(A) {
                            return A = A | 0, 1;
                        }
                        function lD(A) {
                            return A = A | 0, 9;
                        }
                        function t6(A) {
                            return A = A | 0, 4;
                        }
                        function C4(A) {
                            return A = A | 0, 2;
                        }
                        function Fr(A) {
                            return A = A | 0, -1;
                        }
                        function c2(A) {
                            return A = A | 0, 0;
                        }
                        function Yr(A, r, e) {
                            r6(r, e, A);
                        }
                        function su(A) {
                            fo(A, i[A >> 2]);
                        }
                        function Zf(A, r, e) {
                            f8(r, e, A);
                        }
                        function Pi(A, r) {
                            A = A | 0, r = r | 0;
                        }
                        function sD() {
                            return 78816;
                        }
                        function hD() {
                            return 78880;
                        }
                        function Y0() {
                            FA(9097), z();
                        }
                        function wD() {
                            return 17760;
                        }
                        function p0() {
                            FA(5280), z();
                        }
                        function _0(A) {
                            A = A | 0, X(A);
                        }
                        function Er(A) {
                            B0(A, 0, 100);
                        }
                        function vD() {
                            return 17506;
                        }
                        function _D() {
                            return 8374;
                        }
                        function gr(A) {
                            A = A | 0, z();
                        }
                        function Gf(A, r) {
                            M4(A, r);
                        }
                        function BD() {
                            return 19;
                        }
                        function mD() {
                            return 8;
                        }
                        function w1() {
                            Ps(), z();
                        }
                        function u4() {
                            w1(), z();
                        }
                        function ZD() {
                            return 1;
                        }
                        function F8(A) {
                            A = A | 0;
                        }
                        function GD() {
                            mt();
                        }
                        function WD() {
                            St();
                        }
                        function XD() {}
                        a = l, U0(b2);
                        var p = b([
                            null,
                            Tt,
                            _C,
                            yC,
                            yV,
                            Lt,
                            kW,
                            MQ,
                            EC,
                            mr,
                            mr,
                            cC,
                            AV,
                            EF,
                            Lt,
                            NX,
                            EQ,
                            qy,
                            mr,
                            mr,
                            FI,
                            UI,
                            zI,
                            pV,
                            Ry,
                            gy,
                            Th,
                            dC,
                            aC,
                            gr,
                            w1,
                            OI,
                            _4,
                            _y,
                            My,
                            Ee,
                            c2,
                            jn,
                            rD,
                            bh,
                            X1,
                            k_,
                            NG,
                            fm,
                            c2,
                            VN,
                            c2,
                            vh,
                            iV,
                            yG,
                            V2,
                            W1,
                            Gv,
                            RZ,
                            F8,
                            C4,
                            yZ,
                            uV,
                            gn,
                            W1,
                            Lv,
                            rW,
                            C4,
                            pW,
                            W1,
                            D2,
                            YZ,
                            UB,
                            $V,
                            sy,
                            fv,
                            aZ,
                            s_,
                            rI,
                            QI,
                            Sv,
                            _B,
                            fN,
                            yQ,
                            bV,
                            wy,
                            rv,
                            SZ,
                            Sw,
                            W1,
                            D2,
                            OW,
                            cZ,
                            W1,
                            q8,
                            TN,
                            UQ,
                            ay,
                            GI,
                            Uv,
                            QG,
                            am,
                            W1,
                            tB,
                            OG,
                            $F,
                            DG,
                            RQ,
                            xQ,
                            Dw,
                            mm,
                            CV,
                            gv,
                            W1,
                            q8,
                            wZ,
                            cI,
                            BX,
                            W1,
                            q8,
                            ji,
                            W1,
                            vB,
                            ji,
                            W1,
                            p_,
                            hW,
                            jC,
                            c2,
                            HG,
                            $p,
                            eQ,
                            Kh,
                            em,
                            zX,
                            Yw,
                            SC,
                            $C,
                            Fv,
                            rG,
                            X1,
                            M_,
                            W1,
                            kB,
                            WW,
                            X1,
                            X1,
                            X1,
                            AX,
                            W1,
                            U_,
                            EW,
                            X1,
                            X1,
                            X1,
                            uX,
                            W1,
                            qv,
                            LZ,
                            X1,
                            X1,
                            X1,
                            dw,
                            lp,
                            wp,
                            Pw,
                            nm,
                            xX,
                            jh,
                            TV,
                            Ay,
                            A_,
                            NW,
                            eZ,
                            W1,
                            q8,
                            ji,
                            SV,
                            lo,
                            W5,
                            DZ,
                            Q3,
                            lo,
                            Kv,
                            ev,
                            GC,
                            YC,
                            pv,
                            Xm,
                            X1,
                            Z_,
                            W1,
                            q8,
                            ji,
                            W1,
                            q8,
                            a_,
                            by,
                            XI,
                            c_,
                            fZ,
                            jV,
                            fy,
                            u_,
                            NZ,
                            C4,
                            bB,
                            W1,
                            m_,
                            wW,
                            C4,
                            PW,
                            W1,
                            oB,
                            gW,
                            C4,
                            sX,
                            W1,
                            G_,
                            _W,
                            C4,
                            LW,
                            W1,
                            Bv,
                            Am,
                            C4,
                            Qm,
                            W1,
                            $w,
                            v_,
                            C4,
                            Fw,
                            DQ,
                            zQ,
                            Zv,
                            cG,
                            C4,
                            TB,
                            KY,
                            CJ,
                            h2,
                            yN,
                            _0,
                            bY,
                            EJ,
                            h2,
                            _0,
                            eE,
                            qR,
                            h2,
                            _0,
                            rE,
                            DJ,
                            h2,
                            _0,
                            tE,
                            zJ,
                            h2,
                            _0,
                            hE,
                            PJ,
                            h2,
                            _0,
                            ZE,
                            bJ,
                            h2,
                            _0,
                            CE,
                            AR,
                            h2,
                            _0,
                            gE,
                            lR,
                            h2,
                            _0,
                            UE,
                            _R,
                            h2,
                            _0,
                            OE,
                            pR,
                            h2,
                            _0,
                            bE,
                            FR,
                            h2,
                            _0,
                            Ag,
                            RR,
                            h2,
                            _0,
                            tg,
                            UR,
                            h2,
                            _0,
                            hg,
                            TR,
                            h2,
                            _0,
                            mg,
                            PR,
                            h2,
                            _0,
                            Xg,
                            Mg,
                            h2,
                            _0,
                            fY,
                            xg,
                            h2,
                            _0,
                            oY,
                            jg,
                            h2,
                            _0,
                            sY,
                            Lg,
                            h2,
                            _0,
                            _Y,
                            $g,
                            h2,
                            _0,
                            GY,
                            cg,
                            h2,
                            _0,
                            pY,
                            rJ,
                            h2,
                            _0,
                            FY,
                            tJ,
                            h2,
                            _0,
                            RY,
                            sJ,
                            h2,
                            _0,
                            UY,
                            _J,
                            h2,
                            _0,
                            jY,
                            WJ,
                            h2,
                            _0,
                            qY,
                            VJ,
                            h2,
                            _0,
                            dY,
                            gJ,
                            h2,
                            _0,
                            Qg,
                            NJ,
                            h2,
                            _0,
                            kE,
                            HJ,
                            h2,
                            _0,
                            lE,
                            jJ,
                            h2,
                            _0,
                            BE,
                            $J,
                            h2,
                            _0,
                            pE,
                            eR,
                            h2,
                            _0,
                            FE,
                            tR,
                            h2,
                            _0,
                            NE,
                            Dg,
                            h2,
                            _0,
                            TE,
                            GR,
                            h2,
                            _0,
                            KE,
                            VR,
                            h2,
                            _0,
                            eg,
                            JR,
                            h2,
                            _0,
                            ng,
                            MR,
                            h2,
                            _0,
                            lg,
                            xR,
                            h2,
                            _0,
                            _g,
                            jR,
                            h2,
                            _0,
                            Wg,
                            KR,
                            h2,
                            _0,
                            AY,
                            Hg,
                            h2,
                            _0,
                            tY,
                            Sg,
                            h2,
                            _0,
                            lY,
                            Pg,
                            h2,
                            _0,
                            wY,
                            qg,
                            h2,
                            _0,
                            mY,
                            bg,
                            h2,
                            _0,
                            XY,
                            eJ,
                            h2,
                            _0,
                            CY,
                            fJ,
                            h2,
                            _0,
                            YY,
                            oJ,
                            h2,
                            _0,
                            RF,
                            DF,
                            HY,
                            BJ,
                            Em,
                            _0,
                            PY,
                            pJ,
                            Y2,
                            _0,
                            cY,
                            JJ,
                            Ev,
                            _0,
                            AE,
                            MJ,
                            yp,
                            _0,
                            sE,
                            OJ,
                            eC,
                            _0,
                            JE,
                            sR,
                            dm,
                            _0,
                            PE,
                            QR,
                            h2,
                            _0,
                            dE,
                            YR,
                            h2,
                            _0,
                            _4,
                            rN,
                            AN,
                            By,
                            Hy,
                            uf,
                            VB,
                            GQ,
                            _4,
                            _0,
                            tN,
                            Ov,
                            Yp,
                            KQ,
                            AC,
                            Rv,
                            XZ,
                            Oh,
                            ZY,
                            dg,
                            Y2,
                            _0,
                            _4,
                            _0,
                            c2,
                            sv,
                            Yy,
                            _V,
                            _0,
                            X1,
                            Kw,
                            Ct,
                            pC,
                            _0,
                            C4,
                            qw,
                            Ct,
                            QC,
                            Vy,
                            Oy,
                            Eg,
                            ww,
                            Rp,
                            Dp,
                            _0,
                            t6,
                            Hw,
                            c2,
                            CC,
                            vy,
                            Dy,
                            mf,
                            Hh,
                            SQ,
                            HE,
                            BR,
                            Y2,
                            _0,
                            LE,
                            CR,
                            Y2,
                            _0,
                            cE,
                            ER,
                            Y2,
                            _0,
                            fg,
                            NR,
                            Y2,
                            _0,
                            sg,
                            zR,
                            Y2,
                            _0,
                            Bg,
                            OR,
                            Y2,
                            _0,
                            vZ,
                            pQ,
                            BQ,
                            Oo,
                            lu,
                            Oo,
                            p7,
                            of,
                            p4,
                            IW,
                            QQ,
                            JX,
                            SG,
                            tf,
                            X9,
                            dV,
                            vm,
                            GV,
                            nX,
                            lX,
                            kV,
                            Mw,
                            of,
                            Ji,
                            tf,
                            ko,
                            no,
                            To,
                            of,
                            p4,
                            gN,
                            p4,
                            JN,
                            Ji,
                            RN,
                            p4,
                            YI,
                            I8,
                            go,
                            Fo,
                            go,
                            Fo,
                            Np,
                            kF,
                            wQ,
                            IX,
                            S7,
                            dR,
                            cR,
                            iN,
                            NY,
                            hJ,
                            lB,
                            _0,
                            TY,
                            ZJ,
                            Y2,
                            _0,
                            FQ,
                            gr,
                            ch,
                            mE,
                            aJ,
                            Y2,
                            _0,
                            QE,
                            rR,
                            Y2,
                            _0,
                            YE,
                            oR,
                            Y2,
                            _0,
                            DE,
                            wR,
                            Y2,
                            _0,
                            SE,
                            WR,
                            Y2,
                            _0,
                            qE,
                            yR,
                            Y2,
                            _0,
                            bQ,
                            oC,
                            mN,
                            DN,
                            c2,
                            ot,
                            c2,
                            X1,
                            cA,
                            AW,
                            fW,
                            JI,
                            n_,
                            F8,
                            c2,
                            uv,
                            bv,
                            $v,
                            jX,
                            Q6,
                            Wh,
                            SW,
                            jW,
                            mh,
                            Mv,
                            X1,
                            mw,
                            kY,
                            zg,
                            h2,
                            _0,
                            _4,
                            _0,
                            $X,
                            rp,
                            X1,
                            cF,
                            iY,
                            Kp,
                            hw,
                            qQ,
                            fC,
                            lN,
                            yr,
                            c2,
                            t6,
                            cA,
                            tv,
                            Q6,
                            Eh,
                            bX,
                            fp,
                            t6,
                            RI,
                            nf,
                            $W,
                            BZ,
                            KV,
                            uy,
                            pw,
                            hG,
                            X1,
                            Qv,
                            W1,
                            uB,
                            MX,
                            hX,
                            W1,
                            b_,
                            dZ,
                            ZG,
                            aQ,
                            tC,
                            BN,
                            yr,
                            Jy,
                            ou,
                            cA,
                            nv,
                            Q6,
                            vv,
                            qV,
                            ly,
                            AB,
                            HX,
                            yw,
                            cX,
                            op,
                            ou,
                            gC,
                            nf,
                            FG,
                            zZ,
                            LQ,
                            rC,
                            nN,
                            c2,
                            uu,
                            TZ,
                            Tw,
                            Q6,
                            Rh,
                            aX,
                            Ap,
                            uu,
                            xG,
                            MG,
                            lQ,
                            q9,
                            OV,
                            ky,
                            y_,
                            XG,
                            Vw,
                            PV,
                            ny,
                            F_,
                            KG,
                            hB,
                            Wp,
                            Qp,
                            l_,
                            fB,
                            kw,
                            LV,
                            oy,
                            I_,
                            pG,
                            Av,
                            W1,
                            q8,
                            X1,
                            ji,
                            $Q,
                            nC,
                            _N,
                            yr,
                            c2,
                            mf,
                            jv,
                            ov,
                            Q6,
                            oh,
                            dX,
                            tp,
                            mf,
                            HI,
                            nf,
                            qp,
                            KB,
                            Nn,
                            tD,
                            Yh,
                            lw,
                            X1,
                            Ih,
                            dQ,
                            uC,
                            ZN,
                            yr,
                            c2,
                            C4,
                            q9,
                            lv,
                            Q6,
                            F9,
                            yn,
                            $N,
                            lh,
                            wh,
                            X1,
                            bw,
                            qX,
                            ep,
                            C4,
                            LF,
                            dF,
                            Lp,
                            Bh,
                            W1,
                            nB,
                            DX,
                            X1,
                            JW,
                            F1,
                            wf,
                            sN,
                            X1,
                            c2,
                            lD,
                            fX,
                            c2,
                            ot,
                            yh,
                            V_,
                            ah,
                            wf,
                            c2,
                            c2,
                            F9,
                            VY,
                            kJ,
                            h2,
                            _0,
                            EY,
                            uJ,
                            h2,
                            _0,
                            DY,
                            wJ,
                            h2,
                            _0,
                            xY,
                            mJ,
                            h2,
                            _0,
                            OY,
                            XJ,
                            h2,
                            _0,
                            $Y,
                            yJ,
                            h2,
                            _0,
                            iI,
                            pI,
                            kN,
                            sQ,
                            Fr,
                            Fr,
                            oE,
                            TJ,
                            h2,
                            _0,
                            wE,
                            LJ,
                            h2,
                            _0,
                            GE,
                            dJ,
                            h2,
                            _0,
                            VE,
                            fR,
                            h2,
                            _0,
                            ME,
                            vR,
                            h2,
                            _0,
                            jE,
                            XR,
                            h2,
                            _0,
                            aV,
                            hy,
                            GN,
                            B9,
                            G9,
                            oX,
                            Aw,
                            kh,
                            pm,
                            iB,
                            e_,
                            UC,
                            TC,
                            oN,
                            YX,
                            G9,
                            uQ,
                            hh,
                            th,
                            cv,
                            wf,
                            uN,
                            B9,
                            ZX,
                            pZ,
                            Ch,
                            i_,
                            np,
                            sp,
                            vN,
                            yY,
                            hm,
                            wm,
                            VI,
                            Yv,
                            Iw,
                            nh,
                            jw,
                            ip,
                            r_,
                            Fp,
                            nE,
                            xJ,
                            Y2,
                            _0,
                            vE,
                            KJ,
                            Y2,
                            _0,
                            WE,
                            cJ,
                            Y2,
                            _0,
                            _4,
                            _0,
                            vG,
                            ph,
                            yE,
                            kR,
                            Y2,
                            _0,
                            _0,
                            MZ,
                            Vh,
                            RE,
                            hR,
                            Y2,
                            _0,
                            xE,
                            mR,
                            Y2,
                            _0,
                            ig,
                            gR,
                            Y2,
                            _0,
                            kg,
                            DR,
                            Y2,
                            _0,
                            og,
                            HR,
                            Y2,
                            _0,
                            wg,
                            SR,
                            Y2,
                            _0,
                            Zg,
                            LR,
                            Y2,
                            _0,
                            pg,
                            Ug,
                            Y2,
                            _0,
                            nY,
                            Tg,
                            Y2,
                            _0,
                            uY,
                            Og,
                            Y2,
                            _0,
                            hY,
                            Kg,
                            Y2,
                            _0,
                            _0,
                            BB,
                            Zh,
                            BY,
                            ag,
                            Y2,
                            _0,
                            _0,
                            IB,
                            _h,
                            WY,
                            iJ,
                            Y2,
                            _0,
                            QY,
                            AJ,
                            Y2,
                            _0,
                            IY,
                            nJ,
                            Y2,
                            _0,
                            gY,
                            lJ,
                            Y2,
                            _0,
                            MY,
                            vJ,
                            Y2,
                            _0,
                            SY,
                            GJ,
                            Y2,
                            _0,
                            _0,
                            Cm,
                            Xh,
                            LY,
                            QJ,
                            Y2,
                            _0,
                            _0,
                            Vm,
                            Gh,
                            aY,
                            FJ,
                            Y2,
                            _0,
                            _0,
                            ym,
                            Mh,
                            iE,
                            $R,
                            Y2,
                            _0,
                            _0,
                            Im,
                            Jh,
                            fE,
                            UJ,
                            Y2,
                            _0,
                            _0,
                            Pm,
                            Dh,
                            uE,
                            SJ,
                            Y2,
                            _0,
                            _0,
                            Lm,
                            gh,
                            _E,
                            qJ,
                            Y2,
                            _0,
                            _0,
                            Km,
                            zh,
                            XE,
                            iR,
                            Y2,
                            _0,
                            _0,
                            qm,
                            xh,
                            IE,
                            nR,
                            Y2,
                            _0,
                            _0,
                            Mm,
                            Nh,
                            _0,
                            $m,
                            uh,
                            _0,
                            iZ,
                            iw,
                            _0,
                            Uy,
                            Mp,
                            _0,
                            kG,
                            Gw,
                            _0,
                            uZ,
                            nw,
                            _0,
                            Jm,
                            rw,
                            _0,
                            gG,
                            ow,
                            _0,
                            $Z,
                            fw,
                            _0,
                            KZ,
                            vw,
                            _0,
                            dG,
                            $h,
                            _0,
                            bG,
                            ew,
                            _0,
                            jm,
                            Uw,
                            _0,
                            KW,
                            Uh,
                            _0,
                            CG,
                            Ww,
                            _0,
                            EZ,
                            Lw,
                            _0,
                            mZ,
                            Bw,
                            _0,
                            _Z,
                            Dv,
                            _m,
                            GD,
                            WD,
                            Gg,
                            TQ,
                            WN,
                            QW,
                            wv,
                            rY,
                            _D,
                            IV,
                            XD,
                            fV,
                            I8,
                            aA,
                            mV,
                            aA,
                            WV,
                            aA,
                            XV,
                            EN,
                            xi,
                            xi,
                            xi,
                            xi,
                            xi,
                            sV,
                            Pi,
                            QV,
                            hV,
                            IN,
                            F8,
                            _4,
                            _0,
                            $_,
                            OX,
                            _4,
                            gr,
                            H7,
                            iD,
                            bC,
                            oI,
                            EE,
                            uR,
                            UX,
                            _0,
                            zE,
                            ZR,
                            nI,
                            _0,
                            $E,
                            IR,
                            WX,
                            _0,
                            QX,
                            rF,
                            UV,
                            MV,
                            DV,
                            cB,
                            RV,
                            JV,
                            gV,
                            aB,
                            EV,
                            YV,
                            FV,
                            dB,
                            zB,
                            HB,
                            xB,
                            lG,
                            tw,
                            fG,
                            py,
                            Xy,
                            Wy,
                            um,
                            Gy,
                            Zy,
                            my,
                            om,
                            Fy,
                            Iy,
                            yy,
                            lm,
                            PB,
                            jB,
                            OB,
                            sZ,
                            uw,
                            VG,
                            xm,
                            CZ,
                            jG,
                            tG,
                            bm,
                            FZ,
                            YW,
                            UG,
                            UZ,
                            pX,
                            sG,
                            bW,
                            Ph,
                            KF,
                            qF,
                            NF,
                            MF,
                            xI,
                            Zw,
                            XF,
                            pF,
                            vF,
                            _F,
                            IG,
                            oG,
                            PZ,
                            iW,
                            yW,
                            qG,
                            SF,
                            TF,
                            Lh,
                            YB,
                            PF,
                            xF,
                            bF,
                            aF,
                            Ew,
                            hF,
                            sF,
                            GF,
                            ZF,
                            Jw,
                            rm,
                            wV,
                            _0,
                            zw,
                            KX,
                            TX,
                            mp,
                            _0,
                            Um,
                            EX,
                            _0,
                            FB,
                            PX,
                            d5,
                            yg,
                            Gm,
                            mI,
                            c2,
                            QF,
                            Sh,
                            HC,
                            XX,
                            JG,
                            VA,
                            x0,
                            UN,
                            Pi,
                            No,
                            $t,
                            oo,
                            c2,
                            c2,
                            GG,
                            Fr,
                            rV,
                            Vr,
                            CW,
                            Vr,
                            pr,
                            vf,
                            yo,
                            Do,
                            Qr,
                            _f,
                            Io,
                            Mo,
                            Xr,
                            Bf,
                            aR,
                            bN,
                            VF,
                            JY,
                            kf,
                            HN,
                            Pi,
                            No,
                            $t,
                            oo,
                            c2,
                            c2,
                            nG,
                            Fr,
                            eV,
                            Vr,
                            BW,
                            Vr,
                            pr,
                            vf,
                            yo,
                            Do,
                            Qr,
                            _f,
                            Io,
                            Mo,
                            Af,
                            eD,
                            im,
                            ry,
                            Xp,
                            aW,
                            Fm,
                            pi,
                            SN,
                            kZ,
                            Ym,
                            Dm,
                            TG,
                            j_,
                            Nv,
                            Vp,
                            B_,
                            bo,
                            eu,
                            bo,
                            eu,
                            E6,
                            hf,
                            eN,
                            kD,
                            yF,
                            aE,
                            jA,
                            Au,
                            IF,
                            rg,
                            zA,
                            fu,
                            FF,
                            ug,
                            TA,
                            ku,
                            YF,
                            vg,
                            N0,
                            uD,
                            $I,
                            nu,
                            CQ,
                            XN,
                            pN,
                            Tm,
                            nu,
                            NC,
                            W9,
                            kQ,
                            oZ,
                            tu,
                            VQ,
                            QN,
                            CN,
                            Om,
                            tu,
                            DC,
                            W9,
                            fQ,
                            ZZ,
                            gQ,
                            X,
                            F8,
                            F8,
                            F8,
                            F8,
                            wo,
                            zy,
                            Ty,
                            Sy,
                            jy,
                            Py,
                            Ly,
                            fD,
                            ON,
                            nD,
                            PN,
                            LN,
                            KN,
                            qN,
                            jN,
                            m9,
                            AD,
                            Jg,
                            to,
                            oD,
                            AI,
                            XC,
                            $y,
                            ZC,
                            Po,
                            LC,
                            mF,
                            VC,
                            Bo,
                            aN,
                            av,
                            yv,
                            up,
                            nQ,
                            c2,
                            qW,
                            dI,
                            Co,
                            dN,
                            FN,
                            YN,
                            Rg,
                            bR,
                            YJ,
                            Qo,
                            cN,
                            $o,
                            hN,
                            Ng,
                            IJ,
                            RJ,
                            _4,
                            _0,
                            _0,
                            HV,
                            HQ,
                            jQ,
                            OQ,
                            hI,
                            wC,
                            vI,
                            vC,
                            Po,
                            PC,
                            PI,
                            WC,
                            _0,
                            io,
                            io,
                            Ti,
                            X1,
                            X1,
                            NQ,
                            X1,
                            _0,
                            y5,
                            X5,
                            Ti,
                            c2,
                            c2,
                            P5,
                            t6,
                            _0,
                            y5,
                            X5,
                            Ti,
                            c2,
                            c2,
                            P5,
                            t6,
                            _0,
                            j5,
                            V5,
                            Ti,
                            c2,
                            c2,
                            O5,
                            t6,
                            _0,
                            j5,
                            V5,
                            Ti,
                            c2,
                            c2,
                            O5,
                            t6,
                            _4,
                            _0,
                            Ip,
                            tI,
                            sC,
                            _4,
                            _0,
                            gp,
                            uI,
                            kC,
                            _0,
                            rZ,
                            O_,
                            H_,
                            P_,
                            E5,
                            E5,
                            x_,
                            W_,
                            X_,
                            f_,
                            E_,
                            _0,
                            AZ,
                            z_,
                            J_,
                            T_,
                            Y5,
                            Y5,
                            R_,
                            Q_,
                            C_,
                            t_,
                            g_,
                            _0,
                            bZ,
                            eX,
                            zW,
                            rX,
                            TW,
                            ZB,
                            N_,
                            wX,
                            _0,
                            qZ,
                            cW,
                            HW,
                            iX,
                            xW,
                            mB,
                            D_,
                            tX,
                            _4,
                            _0,
                            C4,
                            JQ,
                            vp,
                            Tp,
                            Sp,
                            ap,
                            _w,
                            VX,
                            _G,
                            BC,
                            _I,
                            CI,
                            tF,
                            oF,
                            _4,
                            _0,
                            C4,
                            LX,
                            hp,
                            jp,
                            Op,
                            bp,
                            sw,
                            mX,
                            eG,
                            mC,
                            BI,
                            ZI,
                            sI,
                            wI,
                            ef,
                            ru,
                            OZ,
                            ef,
                            ru,
                            tm,
                            _0,
                            Ir,
                            Ir,
                            N4,
                            N4,
                            N4,
                            So,
                            c2,
                            z8,
                            z8,
                            _0,
                            Ir,
                            Ir,
                            N4,
                            N4,
                            N4,
                            So,
                            c2,
                            z8,
                            z8,
                            _0,
                            Cr,
                            Cr,
                            N4,
                            N4,
                            N4,
                            jo,
                            c2,
                            z8,
                            z8,
                            _0,
                            Cr,
                            Cr,
                            N4,
                            N4,
                            N4,
                            jo,
                            c2,
                            z8,
                            z8,
                            _0,
                            L_,
                            Wv,
                            _0,
                            S_,
                            mv,
                            _0,
                            Vv,
                            Tv,
                            _0,
                            Cv,
                            zv,
                            _0,
                            Uo,
                            jI,
                            Pi,
                            _0,
                            Uo,
                            JZ,
                            Pi,
                            _4,
                            gr,
                            _0,
                            MN,
                            _4,
                            _0,
                            F8,
                            F8,
                            Vo,
                            _0,
                            Vo,
                            _0,
                            GX,
                            ey,
                            _X,
                            WI,
                            _0,
                            FC,
                            xZ,
                            qC,
                            _0,
                            gZ,
                            eB,
                            Ep,
                            _0,
                            o_,
                            _0,
                            NN,
                            _0,
                            zN,
                            _0,
                            xN,
                            co,
                            uf,
                            co
                        ]);
                        function hu() {
                            return R2.byteLength / 65536 | 0;
                        }
                        function pD(A) {
                            A = A | 0;
                            var r = hu() | 0, e = r + A | 0;
                            if (r < e && e < 65536) {
                                var f = new ArrayBuffer(Z(e, 65536)), k = new Int8Array(f);
                                k.set(o), o = new Int8Array(f), Q = new Int16Array(f), i = new Int32Array(f), l = new Uint8Array(f), I = new Uint16Array(f), k0 = new Uint32Array(f), W0 = new Float32Array(f), n0 = new Float64Array(f), R2 = f, a = l;
                            }
                            return r;
                        }
                        return {
                            Q: Object.create(Object.prototype, {
                                grow: {
                                    value: pD
                                },
                                buffer: {
                                    get: function() {
                                        return R2;
                                    }
                                }
                            }),
                            R: Qw,
                            S: v0,
                            T: p,
                            U: KI,
                            V: Q2,
                            W: fA,
                            X: X,
                            Y: kA,
                            Z: rA,
                            _: JC,
                            $: MB,
                            aa: cV,
                            ba: Ny,
                            ca: OC,
                            da: JF,
                            ea: nV,
                            fa: vD,
                            ga: lu,
                            ha: ZD,
                            ia: BD,
                            ja: mD,
                            ka: FW,
                            la: yA,
                            ma: __,
                            na: _5,
                            oa: I8,
                            pa: lC,
                            qa: gI,
                            ra: IQ,
                            sa: vQ,
                            ta: zC,
                            ua: GB,
                            va: sD,
                            wa: Wm,
                            xa: hD,
                            ya: WF,
                            za: EG,
                            Aa: p7,
                            Ba: p4,
                            Ca: Xw,
                            Da: cQ,
                            Ea: iC,
                            Fa: CB,
                            Ga: Jv,
                            Ha: U5,
                            Ia: HZ,
                            Ja: eW,
                            Ka: X9,
                            La: c5,
                            Ma: R3,
                            Na: To,
                            Oa: Ho,
                            Pa: AF,
                            Qa: WB,
                            Ra: xv,
                            Sa: FX,
                            Ta: sm,
                            Ua: hv,
                            Va: ho,
                            Wa: ho,
                            Xa: Hv,
                            Ya: ko,
                            Za: no,
                            _a: Qy,
                            $a: Cy,
                            ab: KC,
                            bb: gw,
                            cb: Rm,
                            db: Nw,
                            eb: PQ,
                            fb: pp,
                            gb: _v,
                            hb: gg,
                            ib: iF,
                            jb: eF,
                            kb: jF,
                            lb: I8,
                            mb: Hm,
                            nb: xC,
                            ob: Pp,
                            pb: Zm,
                            qb: YQ,
                            rb: I8,
                            sb: I3,
                            tb: d_,
                            ub: C3,
                            vb: UW,
                            wb: Le,
                            xb: qI,
                            yb: kI,
                            zb: GW,
                            Ab: EI,
                            Bb: Cg,
                            Cb: hQ,
                            Db: uG,
                            Eb: _Q,
                            Fb: LB,
                            Gb: Ky,
                            Hb: aG,
                            Ib: NI,
                            Jb: p4,
                            Kb: Ji,
                            Lb: Vg,
                            Mb: Ho,
                            Nb: DI,
                            Ob: MI,
                            Pb: tV,
                            Qb: oV,
                            Rb: zm,
                            Sb: MW,
                            Tb: gF,
                            Ub: Eo,
                            Vb: WA,
                            Wb: Ci,
                            Xb: Ci,
                            Yb: nF,
                            Zb: wF,
                            _b: xw,
                            $b: vW,
                            ac: Rw,
                            bc: EB,
                            cc: Xn,
                            dc: gX,
                            ec: mG,
                            fc: iQ,
                            gc: dp,
                            hc: cp,
                            ic: rQ,
                            jc: tZ,
                            kc: oW,
                            lc: tQ,
                            mc: lZ,
                            nc: GZ,
                            oc: ZW,
                            pc: oQ,
                            qc: WZ,
                            rc: hZ,
                            sc: ct,
                            tc: _0,
                            uc: uF,
                            vc: RG,
                            wc: lF,
                            xc: cm,
                            yc: I8,
                            zc: q_,
                            Ac: Jp,
                            Bc: xp,
                            Cc: zp,
                            Dc: lV,
                            Ec: Q7,
                            Fc: yX,
                            Gc: kX,
                            Hc: vX,
                            Ic: Yo,
                            Jc: Ig,
                            Kc: Iv,
                            Lc: vY,
                            Mc: CF,
                            Nc: Fg,
                            Oc: zo,
                            Pc: xo,
                            Qc: zo,
                            Rc: xo,
                            Sc: Yo,
                            Tc: Bp,
                            Uc: Yg,
                            Vc: WQ,
                            Wc: WG,
                            Xc: iy,
                            Yc: Up,
                            Zc: Hp,
                            _c: RX,
                            $c: fF,
                            ad: uf,
                            bd: $o,
                            cd: vn,
                            dd: VW,
                            ed: dy,
                            fd: kp,
                            gd: ZQ,
                            hd: iG,
                            id: cy,
                            jd: fI,
                            kd: eI,
                            ld: ty,
                            md: mW,
                            nd: nZ,
                            od: km,
                            pd: Nm,
                            qd: AQ,
                            rd: it,
                            sd: I8,
                            td: kv,
                            ud: Fh,
                            vd: qh,
                            wd: sh,
                            xd: Qh,
                            yd: hC,
                            zd: dh,
                            Ad: vV,
                            Bd: Ow,
                            Cd: Cp,
                            Dd: Gp,
                            Ed: zG,
                            Fd: Zp,
                            Gd: ZV,
                            Hd: eY,
                            Id: aI,
                            Jd: SX,
                            Kd: wG,
                            Ld: BF,
                            Md: Ji,
                            Nd: RW,
                            Od: bI,
                            Pd: dv,
                            Qd: rB,
                            Rd: DB,
                            Sd: JB,
                            Td: RB,
                            Ud: h_,
                            Vd: w_,
                            Wd: K_,
                            Xd: sB,
                            Yd: Pv,
                            Zd: CX,
                            _d: tW,
                            $d: LI,
                            ae: BG,
                            be: SB,
                            ce: PG,
                            de: XB,
                            ee: LG,
                            fe: pB,
                            ge: I9,
                            he: I9,
                            ie: en,
                            je: en,
                            ke: x5,
                            le: x5,
                            me: IZ,
                            ne: _p,
                            oe: VZ,
                            pe: cw,
                            qe: wB,
                            re: yB,
                            se: Bm,
                            te: iv,
                            ue: Cw,
                            ve: qB,
                            we: $B,
                            xe: QB,
                            ye: RC,
                            ze: Xv,
                            Ae: jZ,
                            Be: gm,
                            Ce: QZ,
                            De: mQ,
                            Ee: YG,
                            Fe: XQ,
                            Ge: dW,
                            He: uW,
                            Ie: lW,
                            Je: sW,
                            Ke: DW,
                            Le: Sm,
                            Me: Wo,
                            Ne: Y_,
                            Oe: Wo,
                            Pe: NB,
                            Qe: $G,
                            Re: aw,
                            Se: nW,
                            Te: XW,
                            Ue: AG,
                            Ve: gB,
                            We: wD,
                            Xe: mt,
                            Ye: St,
                            Ze: j7,
                            _e: CA,
                            $e: N9,
                            af: xy,
                            bf: Go,
                            cf: zY,
                            df: rt,
                            ef: wN,
                            ff: yI,
                            gf: II,
                            hf: NV,
                            jf: a9,
                            kf: HF,
                            lf: OF,
                            mf: zF,
                            nf: UF,
                            of: Ft,
                            pf: VV,
                            qf: TI,
                            rf: tf,
                            sf: SI,
                            tf: BV,
                            uf: xV,
                            vf: lI,
                            wf: Ey,
                            xf: zV,
                            yf: MC,
                            zf: IC
                        };
                    }
                    return q2(O);
                }(N);
            },
            instantiate: function(Y, N) {
                return {
                    then: function(x) {
                        var O = new T6.Module(Y);
                        x({
                            instance: new T6.Instance(O, N)
                        });
                    }
                };
            },
            RuntimeError: Error
        };
        $i = [];
        var ai, gk = !1, Bu, M1, f4, t8, S6, F2, d2, Jk, Rk;
        function Nk() {
            var Y = ai.buffer;
            K.HEAP8 = M1 = new Int8Array(Y), K.HEAP16 = t8 = new Int16Array(Y), K.HEAPU8 = f4 = new Uint8Array(Y), K.HEAPU16 = S6 = new Uint16Array(Y), K.HEAP32 = F2 = new Int32Array(Y), K.HEAPU32 = d2 = new Uint32Array(Y), K.HEAPF32 = Jk = new Float32Array(Y), K.HEAPF64 = Rk = new Float64Array(Y);
        }
        var Dk = [], Mk = [], Uk = [], mu = !1;
        function Zu() {
            if (K.preRun) for(typeof K.preRun == "function" && (K.preRun = [
                K.preRun
            ]); K.preRun.length;)Xu(K.preRun.shift());
            Tr(Dk);
        }
        function Gu() {
            mu = !0, !K.noFSInit && !d.init.initialized && d.init(), d.ignorePermissions = !1, Y8.init(), Tr(Mk);
        }
        function Wu() {
            if (K.postRun) for(typeof K.postRun == "function" && (K.postRun = [
                K.postRun
            ]); K.postRun.length;)Qu(K.postRun.shift());
            Tr(Uk);
        }
        function Xu(Y) {
            Dk.unshift(Y);
        }
        function pu(Y) {
            Mk.unshift(Y);
        }
        function Qu(Y) {
            Uk.unshift(Y);
        }
        var S8 = 0, Hr = null, j6 = null;
        function CD(Y) {
            return Y;
        }
        function xr(Y) {
            var N;
            S8++, (N = K.monitorRunDependencies) == null || N.call(K, S8);
        }
        function bi(Y) {
            var x;
            if (S8--, (x = K.monitorRunDependencies) == null || x.call(K, S8), S8 == 0 && (Hr !== null && (clearInterval(Hr), Hr = null), j6)) {
                var N = j6;
                j6 = null, N();
            }
        }
        function O6(Y) {
            var x;
            (x = K.onAbort) == null || x.call(K, Y), Y = "Aborted(" + Y + ")", z6(Y), gk = !0, Bu = 1, Y += ". Build with -sASSERTIONS for more info.";
            var N = new T6.RuntimeError(Y);
            throw Rr(N), N;
        }
        var Cu = "data:application/octet-stream;base64,", Vu = (Y)=>Y.startsWith(Cu), zr = (Y)=>Y.startsWith("file://");
        function yu() {
            var Y = "libheif.wasm";
            return Vu(Y) ? Y : _u(Y);
        }
        var di;
        function Iu(Y) {
            if (Y == di && $i) return new Uint8Array($i);
            if (qi) return qi(Y);
            throw 'sync fetching of the wasm failed: you can preload it to Module["wasmBinary"] manually, or emcc.py will do that for you when generating HTML (but not JS)';
        }
        function Fu(Y, N) {
            var x, O = Iu(Y);
            x = new T6.Module(O);
            var b = new T6.Instance(x, N);
            return [
                b,
                x
            ];
        }
        function Yu() {
            return {
                a: Js
            };
        }
        function Eu() {
            var Y = Yu();
            function N(O, b) {
                return A0 = O.exports, ai = A0.Q, Nk(), $k = A0.T, pu(A0.R), bi("wasm-instantiate"), A0;
            }
            if (xr("wasm-instantiate"), K.instantiateWasm) try {
                return K.instantiateWasm(Y, N);
            } catch (O) {
                z6(`Module.instantiateWasm callback failed with error: ${O}`), Rr(O);
            }
            di || (di = yu());
            var x = Fu(di, Y);
            return N(x[0]);
        }
        var a2, O1, Tr = (Y)=>{
            for(; Y.length > 0;)Y.shift()(K);
        }, VD = K.noExitRuntime || !0, Hk = typeof TextDecoder != "undefined" ? new TextDecoder("utf8") : void 0, o6 = (Y, N, x)=>{
            for(var O = N + x, b = N; Y[b] && !(b >= O);)++b;
            if (b - N > 16 && Y.buffer && Hk) return Hk.decode(Y.subarray(N, b));
            for(var a = ""; N < b;){
                var o0 = Y[N++];
                if (!(o0 & 128)) {
                    a += String.fromCharCode(o0);
                    continue;
                }
                var h0 = Y[N++] & 63;
                if ((o0 & 224) == 192) {
                    a += String.fromCharCode((o0 & 31) << 6 | h0);
                    continue;
                }
                var u0 = Y[N++] & 63;
                if ((o0 & 240) == 224 ? o0 = (o0 & 15) << 12 | h0 << 6 | u0 : o0 = (o0 & 7) << 18 | h0 << 12 | u0 << 6 | Y[N++] & 63, o0 < 65536) a += String.fromCharCode(o0);
                else {
                    var U0 = o0 - 65536;
                    a += String.fromCharCode(55296 | U0 >> 10, 56320 | U0 & 1023);
                }
            }
            return a;
        }, j8 = (Y, N)=>Y ? o6(f4, Y, N) : "", gu = (Y, N, x, O)=>{
            O6(`Assertion failed: ${j8(Y)}, at: ` + [
                N ? j8(N) : "unknown filename",
                x,
                O ? j8(O) : "unknown function"
            ]);
        };
        class Ju {
            set_type(N) {
                d2[this.ptr + 4 >> 2] = N;
            }
            get_type() {
                return d2[this.ptr + 4 >> 2];
            }
            set_destructor(N) {
                d2[this.ptr + 8 >> 2] = N;
            }
            get_destructor() {
                return d2[this.ptr + 8 >> 2];
            }
            set_caught(N) {
                N = N ? 1 : 0, M1[this.ptr + 12] = N;
            }
            get_caught() {
                return M1[this.ptr + 12] != 0;
            }
            set_rethrown(N) {
                N = N ? 1 : 0, M1[this.ptr + 13] = N;
            }
            get_rethrown() {
                return M1[this.ptr + 13] != 0;
            }
            init(N, x) {
                this.set_adjusted_ptr(0), this.set_type(N), this.set_destructor(x);
            }
            set_adjusted_ptr(N) {
                d2[this.ptr + 16 >> 2] = N;
            }
            get_adjusted_ptr() {
                return d2[this.ptr + 16 >> 2];
            }
            get_exception_ptr() {
                var N = Ns(this.get_type());
                if (N) return d2[this.excPtr >> 2];
                var x = this.get_adjusted_ptr();
                return x !== 0 ? x : this.excPtr;
            }
            constructor(N){
                this.excPtr = N, this.ptr = N - 24;
            }
        }
        var xk = 0, Ru = 0, Nu = (Y, N, x)=>{
            var O = new Ju(Y);
            throw O.init(N, x), xk = Y, Ru++, xk;
        };
        function ci() {
            var Y = F2[+k4.varargs >> 2];
            return k4.varargs += 4, Y;
        }
        var u6 = ci, _1 = {
            isAbs: (Y)=>Y.charAt(0) === "/",
            splitPath: (Y)=>{
                var N = /^(\/?|)([\s\S]*?)((?:\.{1,2}|[^\/]+?|)(\.[^.\/]*|))(?:[\/]*)$/;
                return N.exec(Y).slice(1);
            },
            normalizeArray: (Y, N)=>{
                for(var x = 0, O = Y.length - 1; O >= 0; O--){
                    var b = Y[O];
                    b === "." ? Y.splice(O, 1) : b === ".." ? (Y.splice(O, 1), x++) : x && (Y.splice(O, 1), x--);
                }
                if (N) for(; x; x--)Y.unshift("..");
                return Y;
            },
            normalize: (Y)=>{
                var N = _1.isAbs(Y), x = Y.substr(-1) === "/";
                return Y = _1.normalizeArray(Y.split("/").filter((O)=>!!O), !N).join("/"), !Y && !N && (Y = "."), Y && x && (Y += "/"), (N ? "/" : "") + Y;
            },
            dirname: (Y)=>{
                var N = _1.splitPath(Y), x = N[0], O = N[1];
                return !x && !O ? "." : (O && (O = O.substr(0, O.length - 1)), x + O);
            },
            basename: (Y)=>{
                if (Y === "/") return "/";
                Y = _1.normalize(Y), Y = Y.replace(/\/$/, "");
                var N = Y.lastIndexOf("/");
                return N === -1 ? Y : Y.substr(N + 1);
            },
            join: (...Y)=>_1.normalize(Y.join("/")),
            join2: (Y, N)=>_1.normalize(Y + "/" + N)
        }, Du = ()=>{
            if (typeof crypto == "object" && typeof crypto.getRandomValues == "function") return (O)=>crypto.getRandomValues(O);
            if (Ki) try {
                var Y = (parcelRequire("6AGM7")), N = Y.randomFillSync;
                if (N) return (O)=>Y.randomFillSync(O);
                var x = Y.randomBytes;
                return (O)=>(O.set(x(O.byteLength)), O);
            } catch (e) {}
            O6("initRandomDevice");
        }, zk = (Y)=>(zk = Du())(Y), o8 = {
            resolve: (...Y)=>{
                for(var N = "", x = !1, O = Y.length - 1; O >= -1 && !x; O--){
                    var b = O >= 0 ? Y[O] : d.cwd();
                    if (typeof b != "string") throw new TypeError("Arguments to path.resolve must be strings");
                    if (!b) return "";
                    N = b + "/" + N, x = _1.isAbs(b);
                }
                return N = _1.normalizeArray(N.split("/").filter((a)=>!!a), !x).join("/"), (x ? "/" : "") + N || ".";
            },
            relative: (Y, N)=>{
                Y = o8.resolve(Y).substr(1), N = o8.resolve(N).substr(1);
                function x(U0) {
                    for(var L0 = 0; L0 < U0.length && U0[L0] === ""; L0++);
                    for(var _2 = U0.length - 1; _2 >= 0 && U0[_2] === ""; _2--);
                    return L0 > _2 ? [] : U0.slice(L0, _2 - L0 + 1);
                }
                for(var O = x(Y.split("/")), b = x(N.split("/")), a = Math.min(O.length, b.length), o0 = a, h0 = 0; h0 < a; h0++)if (O[h0] !== b[h0]) {
                    o0 = h0;
                    break;
                }
                for(var u0 = [], h0 = o0; h0 < O.length; h0++)u0.push("..");
                return u0 = u0.concat(b.slice(o0)), u0.join("/");
            }
        }, Sr = [], jr = (Y)=>{
            for(var N = 0, x = 0; x < Y.length; ++x){
                var O = Y.charCodeAt(x);
                O <= 127 ? N++ : O <= 2047 ? N += 2 : O >= 55296 && O <= 57343 ? (N += 4, ++x) : N += 3;
            }
            return N;
        }, Or = (Y, N, x, O)=>{
            if (!(O > 0)) return 0;
            for(var b = x, a = x + O - 1, o0 = 0; o0 < Y.length; ++o0){
                var h0 = Y.charCodeAt(o0);
                if (h0 >= 55296 && h0 <= 57343) {
                    var u0 = Y.charCodeAt(++o0);
                    h0 = 65536 + ((h0 & 1023) << 10) | u0 & 1023;
                }
                if (h0 <= 127) {
                    if (x >= a) break;
                    N[x++] = h0;
                } else if (h0 <= 2047) {
                    if (x + 1 >= a) break;
                    N[x++] = 192 | h0 >> 6, N[x++] = 128 | h0 & 63;
                } else if (h0 <= 65535) {
                    if (x + 2 >= a) break;
                    N[x++] = 224 | h0 >> 12, N[x++] = 128 | h0 >> 6 & 63, N[x++] = 128 | h0 & 63;
                } else {
                    if (x + 3 >= a) break;
                    N[x++] = 240 | h0 >> 18, N[x++] = 128 | h0 >> 12 & 63, N[x++] = 128 | h0 >> 6 & 63, N[x++] = 128 | h0 & 63;
                }
            }
            return N[x] = 0, x - b;
        };
        function ie(Y, N, x) {
            var O = x > 0 ? x : jr(Y) + 1, b = new Array(O), a = Or(Y, b, 0, b.length);
            return N && (b.length = a), b;
        }
        var Mu = ()=>{
            if (!Sr.length) {
                var Y = null;
                if (Ki) {
                    var N = 256, x = $a38dd11793775bea$require$Buffer.alloc(N), O = 0, b = $5XqL3.stdin.fd;
                    try {
                        O = Mr.readSync(b, x, 0, N);
                    } catch (a) {
                        if (a.toString().includes("EOF")) O = 0;
                        else throw a;
                    }
                    O > 0 && (Y = x.slice(0, O).toString("utf-8"));
                } else typeof window != "undefined" && typeof window.prompt == "function" && (Y = window.prompt("Input: "), Y !== null && (Y += `
`));
                if (!Y) return null;
                Sr = ie(Y, !0);
            }
            return Sr.shift();
        }, Y8 = {
            ttys: [],
            init () {},
            shutdown () {},
            register (Y, N) {
                Y8.ttys[Y] = {
                    input: [],
                    output: [],
                    ops: N
                }, d.registerDevice(Y, Y8.stream_ops);
            },
            stream_ops: {
                open (Y) {
                    var N = Y8.ttys[Y.node.rdev];
                    if (!N) throw new d.ErrnoError(43);
                    Y.tty = N, Y.seekable = !1;
                },
                close (Y) {
                    Y.tty.ops.fsync(Y.tty);
                },
                fsync (Y) {
                    Y.tty.ops.fsync(Y.tty);
                },
                read (Y, N, x, O, b) {
                    if (!Y.tty || !Y.tty.ops.get_char) throw new d.ErrnoError(60);
                    for(var a = 0, o0 = 0; o0 < O; o0++){
                        var h0;
                        try {
                            h0 = Y.tty.ops.get_char(Y.tty);
                        } catch (e) {
                            throw new d.ErrnoError(29);
                        }
                        if (h0 === void 0 && a === 0) throw new d.ErrnoError(6);
                        if (h0 == null) break;
                        a++, N[x + o0] = h0;
                    }
                    return a && (Y.node.timestamp = Date.now()), a;
                },
                write (Y, N, x, O, b) {
                    if (!Y.tty || !Y.tty.ops.put_char) throw new d.ErrnoError(60);
                    try {
                        for(var a = 0; a < O; a++)Y.tty.ops.put_char(Y.tty, N[x + a]);
                    } catch (e) {
                        throw new d.ErrnoError(29);
                    }
                    return O && (Y.node.timestamp = Date.now()), a;
                }
            },
            default_tty_ops: {
                get_char (Y) {
                    return Mu();
                },
                put_char (Y, N) {
                    N === null || N === 10 ? (Ur(o6(Y.output, 0)), Y.output = []) : N != 0 && Y.output.push(N);
                },
                fsync (Y) {
                    Y.output && Y.output.length > 0 && (Ur(o6(Y.output, 0)), Y.output = []);
                },
                ioctl_tcgets (Y) {
                    return {
                        c_iflag: 25856,
                        c_oflag: 5,
                        c_cflag: 191,
                        c_lflag: 35387,
                        c_cc: [
                            3,
                            28,
                            127,
                            21,
                            4,
                            0,
                            1,
                            0,
                            17,
                            19,
                            26,
                            0,
                            18,
                            15,
                            23,
                            22,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0,
                            0
                        ]
                    };
                },
                ioctl_tcsets (Y, N, x) {
                    return 0;
                },
                ioctl_tiocgwinsz (Y) {
                    return [
                        24,
                        80
                    ];
                }
            },
            default_tty1_ops: {
                put_char (Y, N) {
                    N === null || N === 10 ? (z6(o6(Y.output, 0)), Y.output = []) : N != 0 && Y.output.push(N);
                },
                fsync (Y) {
                    Y.output && Y.output.length > 0 && (z6(o6(Y.output, 0)), Y.output = []);
                }
            }
        }, Tk = (Y)=>{
            O6();
        }, g2 = {
            ops_table: null,
            mount (Y) {
                return g2.createNode(null, "/", 16895, 0);
            },
            createNode (Y, N, x, O) {
                if (d.isBlkdev(x) || d.isFIFO(x)) throw new d.ErrnoError(63);
                g2.ops_table || (g2.ops_table = {
                    dir: {
                        node: {
                            getattr: g2.node_ops.getattr,
                            setattr: g2.node_ops.setattr,
                            lookup: g2.node_ops.lookup,
                            mknod: g2.node_ops.mknod,
                            rename: g2.node_ops.rename,
                            unlink: g2.node_ops.unlink,
                            rmdir: g2.node_ops.rmdir,
                            readdir: g2.node_ops.readdir,
                            symlink: g2.node_ops.symlink
                        },
                        stream: {
                            llseek: g2.stream_ops.llseek
                        }
                    },
                    file: {
                        node: {
                            getattr: g2.node_ops.getattr,
                            setattr: g2.node_ops.setattr
                        },
                        stream: {
                            llseek: g2.stream_ops.llseek,
                            read: g2.stream_ops.read,
                            write: g2.stream_ops.write,
                            allocate: g2.stream_ops.allocate,
                            mmap: g2.stream_ops.mmap,
                            msync: g2.stream_ops.msync
                        }
                    },
                    link: {
                        node: {
                            getattr: g2.node_ops.getattr,
                            setattr: g2.node_ops.setattr,
                            readlink: g2.node_ops.readlink
                        },
                        stream: {}
                    },
                    chrdev: {
                        node: {
                            getattr: g2.node_ops.getattr,
                            setattr: g2.node_ops.setattr
                        },
                        stream: d.chrdev_stream_ops
                    }
                });
                var b = d.createNode(Y, N, x, O);
                return d.isDir(b.mode) ? (b.node_ops = g2.ops_table.dir.node, b.stream_ops = g2.ops_table.dir.stream, b.contents = {}) : d.isFile(b.mode) ? (b.node_ops = g2.ops_table.file.node, b.stream_ops = g2.ops_table.file.stream, b.usedBytes = 0, b.contents = null) : d.isLink(b.mode) ? (b.node_ops = g2.ops_table.link.node, b.stream_ops = g2.ops_table.link.stream) : d.isChrdev(b.mode) && (b.node_ops = g2.ops_table.chrdev.node, b.stream_ops = g2.ops_table.chrdev.stream), b.timestamp = Date.now(), Y && (Y.contents[N] = b, Y.timestamp = b.timestamp), b;
            },
            getFileDataAsTypedArray (Y) {
                return Y.contents ? Y.contents.subarray ? Y.contents.subarray(0, Y.usedBytes) : new Uint8Array(Y.contents) : new Uint8Array(0);
            },
            expandFileStorage (Y, N) {
                var x = Y.contents ? Y.contents.length : 0;
                if (!(x >= N)) {
                    var O = 1048576;
                    N = Math.max(N, x * (x < O ? 2 : 1.125) >>> 0), x != 0 && (N = Math.max(N, 256));
                    var b = Y.contents;
                    Y.contents = new Uint8Array(N), Y.usedBytes > 0 && Y.contents.set(b.subarray(0, Y.usedBytes), 0);
                }
            },
            resizeFileStorage (Y, N) {
                if (Y.usedBytes != N) {
                    if (N == 0) Y.contents = null, Y.usedBytes = 0;
                    else {
                        var x = Y.contents;
                        Y.contents = new Uint8Array(N), x && Y.contents.set(x.subarray(0, Math.min(N, Y.usedBytes))), Y.usedBytes = N;
                    }
                }
            },
            node_ops: {
                getattr (Y) {
                    var N = {};
                    return N.dev = d.isChrdev(Y.mode) ? Y.id : 1, N.ino = Y.id, N.mode = Y.mode, N.nlink = 1, N.uid = 0, N.gid = 0, N.rdev = Y.rdev, d.isDir(Y.mode) ? N.size = 4096 : d.isFile(Y.mode) ? N.size = Y.usedBytes : d.isLink(Y.mode) ? N.size = Y.link.length : N.size = 0, N.atime = new Date(Y.timestamp), N.mtime = new Date(Y.timestamp), N.ctime = new Date(Y.timestamp), N.blksize = 4096, N.blocks = Math.ceil(N.size / N.blksize), N;
                },
                setattr (Y, N) {
                    N.mode !== void 0 && (Y.mode = N.mode), N.timestamp !== void 0 && (Y.timestamp = N.timestamp), N.size !== void 0 && g2.resizeFileStorage(Y, N.size);
                },
                lookup (Y, N) {
                    throw d.genericErrors[44];
                },
                mknod (Y, N, x, O) {
                    return g2.createNode(Y, N, x, O);
                },
                rename (Y, N, x) {
                    if (d.isDir(Y.mode)) {
                        var O;
                        try {
                            O = d.lookupNode(N, x);
                        } catch (e) {}
                        if (O) for(var b in O.contents)throw new d.ErrnoError(55);
                    }
                    delete Y.parent.contents[Y.name], Y.parent.timestamp = Date.now(), Y.name = x, N.contents[x] = Y, N.timestamp = Y.parent.timestamp;
                },
                unlink (Y, N) {
                    delete Y.contents[N], Y.timestamp = Date.now();
                },
                rmdir (Y, N) {
                    var x = d.lookupNode(Y, N);
                    for(var O in x.contents)throw new d.ErrnoError(55);
                    delete Y.contents[N], Y.timestamp = Date.now();
                },
                readdir (Y) {
                    var N = [
                        ".",
                        ".."
                    ];
                    for (var x of Object.keys(Y.contents))N.push(x);
                    return N;
                },
                symlink (Y, N, x) {
                    var O = g2.createNode(Y, N, 41471, 0);
                    return O.link = x, O;
                },
                readlink (Y) {
                    if (!d.isLink(Y.mode)) throw new d.ErrnoError(28);
                    return Y.link;
                }
            },
            stream_ops: {
                read (Y, N, x, O, b) {
                    var a = Y.node.contents;
                    if (b >= Y.node.usedBytes) return 0;
                    var o0 = Math.min(Y.node.usedBytes - b, O);
                    if (o0 > 8 && a.subarray) N.set(a.subarray(b, b + o0), x);
                    else for(var h0 = 0; h0 < o0; h0++)N[x + h0] = a[b + h0];
                    return o0;
                },
                write (Y, N, x, O, b, a) {
                    if (N.buffer === M1.buffer && (a = !1), !O) return 0;
                    var o0 = Y.node;
                    if (o0.timestamp = Date.now(), N.subarray && (!o0.contents || o0.contents.subarray)) {
                        if (a) return o0.contents = N.subarray(x, x + O), o0.usedBytes = O, O;
                        if (o0.usedBytes === 0 && b === 0) return o0.contents = N.slice(x, x + O), o0.usedBytes = O, O;
                        if (b + O <= o0.usedBytes) return o0.contents.set(N.subarray(x, x + O), b), O;
                    }
                    if (g2.expandFileStorage(o0, b + O), o0.contents.subarray && N.subarray) o0.contents.set(N.subarray(x, x + O), b);
                    else for(var h0 = 0; h0 < O; h0++)o0.contents[b + h0] = N[x + h0];
                    return o0.usedBytes = Math.max(o0.usedBytes, b + O), O;
                },
                llseek (Y, N, x) {
                    var O = N;
                    if (x === 1 ? O += Y.position : x === 2 && d.isFile(Y.node.mode) && (O += Y.node.usedBytes), O < 0) throw new d.ErrnoError(28);
                    return O;
                },
                allocate (Y, N, x) {
                    g2.expandFileStorage(Y.node, N + x), Y.node.usedBytes = Math.max(Y.node.usedBytes, N + x);
                },
                mmap (Y, N, x, O, b) {
                    if (!d.isFile(Y.node.mode)) throw new d.ErrnoError(43);
                    var a, o0, h0 = Y.node.contents;
                    if (!(b & 2) && h0.buffer === M1.buffer) o0 = !1, a = h0.byteOffset;
                    else {
                        if ((x > 0 || x + N < h0.length) && (h0.subarray ? h0 = h0.subarray(x, x + N) : h0 = Array.prototype.slice.call(h0, x, x + N)), o0 = !0, a = Tk(N), !a) throw new d.ErrnoError(48);
                        M1.set(h0, a);
                    }
                    return {
                        ptr: a,
                        allocated: o0
                    };
                },
                msync (Y, N, x, O, b) {
                    return g2.stream_ops.write(Y, N, 0, O, x, !1), 0;
                }
            }
        }, Uu = (Y, N, x, O)=>{
            var b = O ? "" : `al ${Y}`;
            Dr(Y, (a)=>{
                N(new Uint8Array(a)), b && bi(b);
            }, (a)=>{
                if (x) x();
                else throw `Loading data file "${Y}" failed.`;
            }), b && xr(b);
        }, Hu = (Y, N, x, O, b, a)=>{
            d.createDataFile(Y, N, x, O, b, a);
        }, xu = K.preloadPlugins || [], zu = (Y, N, x, O)=>{
            typeof Browser != "undefined" && Browser.init();
            var b = !1;
            return xu.forEach((a)=>{
                b || a.canHandle(N) && (a.handle(Y, N, x, O), b = !0);
            }), b;
        }, Tu = (Y, N, x, O, b, a, o0, h0, u0, U0)=>{
            var L0 = N ? o8.resolve(_1.join2(Y, N)) : Y, _2 = `cp ${L0}`;
            function u2(o2) {
                function c0(J2) {
                    U0 == null || U0(), h0 || Hu(Y, N, J2, O, b, u0), a == null || a(), bi(_2);
                }
                zu(o2, L0, c0, ()=>{
                    o0 == null || o0(), bi(_2);
                }) || c0(o2);
            }
            xr(_2), typeof x == "string" ? Uu(x, u2, o0) : u2(x);
        }, Su = (Y)=>{
            var N = {
                r: 0,
                "r+": 2,
                w: 577,
                "w+": 578,
                a: 1089,
                "a+": 1090
            }, x = N[Y];
            if (typeof x == "undefined") throw new Error(`Unknown file open mode: ${Y}`);
            return x;
        }, Pr = (Y, N)=>{
            var x = 0;
            return Y && (x |= 365), N && (x |= 146), x;
        }, d = {
            root: null,
            mounts: [],
            devices: {},
            streams: [],
            nextInode: 1,
            nameTable: null,
            currentPath: "/",
            initialized: !1,
            ignorePermissions: !0,
            ErrnoError: class {
                constructor(Y){
                    this.name = "ErrnoError", this.errno = Y;
                }
            },
            genericErrors: {},
            filesystems: null,
            syncFSRequests: 0,
            FSStream: class {
                get object() {
                    return this.node;
                }
                set object(Y) {
                    this.node = Y;
                }
                get isRead() {
                    return (this.flags & 2097155) !== 1;
                }
                get isWrite() {
                    return (this.flags & 2097155) !== 0;
                }
                get isAppend() {
                    return this.flags & 1024;
                }
                get flags() {
                    return this.shared.flags;
                }
                set flags(Y) {
                    this.shared.flags = Y;
                }
                get position() {
                    return this.shared.position;
                }
                set position(Y) {
                    this.shared.position = Y;
                }
                constructor(){
                    this.shared = {};
                }
            },
            FSNode: class {
                get read() {
                    return (this.mode & this.readMode) === this.readMode;
                }
                set read(Y) {
                    Y ? this.mode |= this.readMode : this.mode &= ~this.readMode;
                }
                get write() {
                    return (this.mode & this.writeMode) === this.writeMode;
                }
                set write(Y) {
                    Y ? this.mode |= this.writeMode : this.mode &= ~this.writeMode;
                }
                get isFolder() {
                    return d.isDir(this.mode);
                }
                get isDevice() {
                    return d.isChrdev(this.mode);
                }
                constructor(Y, N, x, O){
                    Y || (Y = this), this.parent = Y, this.mount = Y.mount, this.mounted = null, this.id = d.nextInode++, this.name = N, this.mode = x, this.node_ops = {}, this.stream_ops = {}, this.rdev = O, this.readMode = 365, this.writeMode = 146;
                }
            },
            lookupPath (Y, N = {}) {
                if (Y = o8.resolve(Y), !Y) return {
                    path: "",
                    node: null
                };
                var x = {
                    follow_mount: !0,
                    recurse_count: 0
                };
                if (N = Object.assign(x, N), N.recurse_count > 8) throw new d.ErrnoError(32);
                for(var O = Y.split("/").filter((_2)=>!!_2), b = d.root, a = "/", o0 = 0; o0 < O.length; o0++){
                    var h0 = o0 === O.length - 1;
                    if (h0 && N.parent) break;
                    if (b = d.lookupNode(b, O[o0]), a = _1.join2(a, O[o0]), d.isMountpoint(b) && (!h0 || h0 && N.follow_mount) && (b = b.mounted.root), !h0 || N.follow) for(var u0 = 0; d.isLink(b.mode);){
                        var U0 = d.readlink(a);
                        a = o8.resolve(_1.dirname(a), U0);
                        var L0 = d.lookupPath(a, {
                            recurse_count: N.recurse_count + 1
                        });
                        if (b = L0.node, u0++ > 40) throw new d.ErrnoError(32);
                    }
                }
                return {
                    path: a,
                    node: b
                };
            },
            getPath (Y) {
                for(var N;;){
                    if (d.isRoot(Y)) {
                        var x = Y.mount.mountpoint;
                        return N ? x[x.length - 1] !== "/" ? `${x}/${N}` : x + N : x;
                    }
                    N = N ? `${Y.name}/${N}` : Y.name, Y = Y.parent;
                }
            },
            hashName (Y, N) {
                for(var x = 0, O = 0; O < N.length; O++)x = (x << 5) - x + N.charCodeAt(O) | 0;
                return (Y + x >>> 0) % d.nameTable.length;
            },
            hashAddNode (Y) {
                var N = d.hashName(Y.parent.id, Y.name);
                Y.name_next = d.nameTable[N], d.nameTable[N] = Y;
            },
            hashRemoveNode (Y) {
                var N = d.hashName(Y.parent.id, Y.name);
                if (d.nameTable[N] === Y) d.nameTable[N] = Y.name_next;
                else for(var x = d.nameTable[N]; x;){
                    if (x.name_next === Y) {
                        x.name_next = Y.name_next;
                        break;
                    }
                    x = x.name_next;
                }
            },
            lookupNode (Y, N) {
                var x = d.mayLookup(Y);
                if (x) throw new d.ErrnoError(x);
                for(var O = d.hashName(Y.id, N), b = d.nameTable[O]; b; b = b.name_next){
                    var a = b.name;
                    if (b.parent.id === Y.id && a === N) return b;
                }
                return d.lookup(Y, N);
            },
            createNode (Y, N, x, O) {
                var b = new d.FSNode(Y, N, x, O);
                return d.hashAddNode(b), b;
            },
            destroyNode (Y) {
                d.hashRemoveNode(Y);
            },
            isRoot (Y) {
                return Y === Y.parent;
            },
            isMountpoint (Y) {
                return !!Y.mounted;
            },
            isFile (Y) {
                return (Y & 61440) === 32768;
            },
            isDir (Y) {
                return (Y & 61440) === 16384;
            },
            isLink (Y) {
                return (Y & 61440) === 40960;
            },
            isChrdev (Y) {
                return (Y & 61440) === 8192;
            },
            isBlkdev (Y) {
                return (Y & 61440) === 24576;
            },
            isFIFO (Y) {
                return (Y & 61440) === 4096;
            },
            isSocket (Y) {
                return (Y & 49152) === 49152;
            },
            flagsToPermissionString (Y) {
                var N = [
                    "r",
                    "w",
                    "rw"
                ][Y & 3];
                return Y & 512 && (N += "w"), N;
            },
            nodePermissions (Y, N) {
                return d.ignorePermissions ? 0 : N.includes("r") && !(Y.mode & 292) || N.includes("w") && !(Y.mode & 146) || N.includes("x") && !(Y.mode & 73) ? 2 : 0;
            },
            mayLookup (Y) {
                if (!d.isDir(Y.mode)) return 54;
                var N = d.nodePermissions(Y, "x");
                return N || (Y.node_ops.lookup ? 0 : 2);
            },
            mayCreate (Y, N) {
                try {
                    var x = d.lookupNode(Y, N);
                    return 20;
                } catch (e) {}
                return d.nodePermissions(Y, "wx");
            },
            mayDelete (Y, N, x) {
                var O;
                try {
                    O = d.lookupNode(Y, N);
                } catch (a) {
                    return a.errno;
                }
                var b = d.nodePermissions(Y, "wx");
                if (b) return b;
                if (x) {
                    if (!d.isDir(O.mode)) return 54;
                    if (d.isRoot(O) || d.getPath(O) === d.cwd()) return 10;
                } else if (d.isDir(O.mode)) return 31;
                return 0;
            },
            mayOpen (Y, N) {
                return Y ? d.isLink(Y.mode) ? 32 : d.isDir(Y.mode) && (d.flagsToPermissionString(N) !== "r" || N & 512) ? 31 : d.nodePermissions(Y, d.flagsToPermissionString(N)) : 44;
            },
            MAX_OPEN_FDS: 4096,
            nextfd () {
                for(var Y = 0; Y <= d.MAX_OPEN_FDS; Y++)if (!d.streams[Y]) return Y;
                throw new d.ErrnoError(33);
            },
            getStreamChecked (Y) {
                var N = d.getStream(Y);
                if (!N) throw new d.ErrnoError(8);
                return N;
            },
            getStream: (Y)=>d.streams[Y],
            createStream (Y, N = -1) {
                return Y = Object.assign(new d.FSStream, Y), N == -1 && (N = d.nextfd()), Y.fd = N, d.streams[N] = Y, Y;
            },
            closeStream (Y) {
                d.streams[Y] = null;
            },
            dupStream (Y, N = -1) {
                var O, b;
                var x = d.createStream(Y, N);
                return (b = (O = x.stream_ops) == null ? void 0 : O.dup) == null || b.call(O, x), x;
            },
            chrdev_stream_ops: {
                open (Y) {
                    var x, O;
                    var N = d.getDevice(Y.node.rdev);
                    Y.stream_ops = N.stream_ops, (O = (x = Y.stream_ops).open) == null || O.call(x, Y);
                },
                llseek () {
                    throw new d.ErrnoError(70);
                }
            },
            major: (Y)=>Y >> 8,
            minor: (Y)=>Y & 255,
            makedev: (Y, N)=>Y << 8 | N,
            registerDevice (Y, N) {
                d.devices[Y] = {
                    stream_ops: N
                };
            },
            getDevice: (Y)=>d.devices[Y],
            getMounts (Y) {
                for(var N = [], x = [
                    Y
                ]; x.length;){
                    var O = x.pop();
                    N.push(O), x.push(...O.mounts);
                }
                return N;
            },
            syncfs (Y, N) {
                typeof Y == "function" && (N = Y, Y = !1), d.syncFSRequests++, d.syncFSRequests > 1 && z6(`warning: ${d.syncFSRequests} FS.syncfs operations in flight at once, probably just doing extra work`);
                var x = d.getMounts(d.root.mount), O = 0;
                function b(o0) {
                    return d.syncFSRequests--, N(o0);
                }
                function a(o0) {
                    if (o0) return a.errored ? void 0 : (a.errored = !0, b(o0));
                    ++O >= x.length && b(null);
                }
                x.forEach((o0)=>{
                    if (!o0.type.syncfs) return a(null);
                    o0.type.syncfs(o0, Y, a);
                });
            },
            mount (Y, N, x) {
                var O = x === "/", b = !x, a;
                if (O && d.root) throw new d.ErrnoError(10);
                if (!O && !b) {
                    var o0 = d.lookupPath(x, {
                        follow_mount: !1
                    });
                    if (x = o0.path, a = o0.node, d.isMountpoint(a)) throw new d.ErrnoError(10);
                    if (!d.isDir(a.mode)) throw new d.ErrnoError(54);
                }
                var h0 = {
                    type: Y,
                    opts: N,
                    mountpoint: x,
                    mounts: []
                }, u0 = Y.mount(h0);
                return u0.mount = h0, h0.root = u0, O ? d.root = u0 : a && (a.mounted = h0, a.mount && a.mount.mounts.push(h0)), u0;
            },
            unmount (Y) {
                var N = d.lookupPath(Y, {
                    follow_mount: !1
                });
                if (!d.isMountpoint(N.node)) throw new d.ErrnoError(28);
                var x = N.node, O = x.mounted, b = d.getMounts(O);
                Object.keys(d.nameTable).forEach((o0)=>{
                    for(var h0 = d.nameTable[o0]; h0;){
                        var u0 = h0.name_next;
                        b.includes(h0.mount) && d.destroyNode(h0), h0 = u0;
                    }
                }), x.mounted = null;
                var a = x.mount.mounts.indexOf(O);
                x.mount.mounts.splice(a, 1);
            },
            lookup (Y, N) {
                return Y.node_ops.lookup(Y, N);
            },
            mknod (Y, N, x) {
                var O = d.lookupPath(Y, {
                    parent: !0
                }), b = O.node, a = _1.basename(Y);
                if (!a || a === "." || a === "..") throw new d.ErrnoError(28);
                var o0 = d.mayCreate(b, a);
                if (o0) throw new d.ErrnoError(o0);
                if (!b.node_ops.mknod) throw new d.ErrnoError(63);
                return b.node_ops.mknod(b, a, N, x);
            },
            create (Y, N) {
                return N = N !== void 0 ? N : 438, N &= 4095, N |= 32768, d.mknod(Y, N, 0);
            },
            mkdir (Y, N) {
                return N = N !== void 0 ? N : 511, N &= 1023, N |= 16384, d.mknod(Y, N, 0);
            },
            mkdirTree (Y, N) {
                for(var x = Y.split("/"), O = "", b = 0; b < x.length; ++b)if (x[b]) {
                    O += "/" + x[b];
                    try {
                        d.mkdir(O, N);
                    } catch (a) {
                        if (a.errno != 20) throw a;
                    }
                }
            },
            mkdev (Y, N, x) {
                return typeof x == "undefined" && (x = N, N = 438), N |= 8192, d.mknod(Y, N, x);
            },
            symlink (Y, N) {
                if (!o8.resolve(Y)) throw new d.ErrnoError(44);
                var x = d.lookupPath(N, {
                    parent: !0
                }), O = x.node;
                if (!O) throw new d.ErrnoError(44);
                var b = _1.basename(N), a = d.mayCreate(O, b);
                if (a) throw new d.ErrnoError(a);
                if (!O.node_ops.symlink) throw new d.ErrnoError(63);
                return O.node_ops.symlink(O, b, Y);
            },
            rename (Y, N) {
                var x = _1.dirname(Y), O = _1.dirname(N), b = _1.basename(Y), a = _1.basename(N), o0, h0, u0;
                if (o0 = d.lookupPath(Y, {
                    parent: !0
                }), h0 = o0.node, o0 = d.lookupPath(N, {
                    parent: !0
                }), u0 = o0.node, !h0 || !u0) throw new d.ErrnoError(44);
                if (h0.mount !== u0.mount) throw new d.ErrnoError(75);
                var U0 = d.lookupNode(h0, b), L0 = o8.relative(Y, O);
                if (L0.charAt(0) !== ".") throw new d.ErrnoError(28);
                if (L0 = o8.relative(N, x), L0.charAt(0) !== ".") throw new d.ErrnoError(55);
                var _2;
                try {
                    _2 = d.lookupNode(u0, a);
                } catch (e) {}
                if (U0 !== _2) {
                    var u2 = d.isDir(U0.mode), o2 = d.mayDelete(h0, b, u2);
                    if (o2) throw new d.ErrnoError(o2);
                    if (o2 = _2 ? d.mayDelete(u0, a, u2) : d.mayCreate(u0, a), o2) throw new d.ErrnoError(o2);
                    if (!h0.node_ops.rename) throw new d.ErrnoError(63);
                    if (d.isMountpoint(U0) || _2 && d.isMountpoint(_2)) throw new d.ErrnoError(10);
                    if (u0 !== h0 && (o2 = d.nodePermissions(h0, "w"), o2)) throw new d.ErrnoError(o2);
                    d.hashRemoveNode(U0);
                    try {
                        h0.node_ops.rename(U0, u0, a), U0.parent = u0;
                    } catch (c0) {
                        throw c0;
                    } finally{
                        d.hashAddNode(U0);
                    }
                }
            },
            rmdir (Y) {
                var N = d.lookupPath(Y, {
                    parent: !0
                }), x = N.node, O = _1.basename(Y), b = d.lookupNode(x, O), a = d.mayDelete(x, O, !0);
                if (a) throw new d.ErrnoError(a);
                if (!x.node_ops.rmdir) throw new d.ErrnoError(63);
                if (d.isMountpoint(b)) throw new d.ErrnoError(10);
                x.node_ops.rmdir(x, O), d.destroyNode(b);
            },
            readdir (Y) {
                var N = d.lookupPath(Y, {
                    follow: !0
                }), x = N.node;
                if (!x.node_ops.readdir) throw new d.ErrnoError(54);
                return x.node_ops.readdir(x);
            },
            unlink (Y) {
                var N = d.lookupPath(Y, {
                    parent: !0
                }), x = N.node;
                if (!x) throw new d.ErrnoError(44);
                var O = _1.basename(Y), b = d.lookupNode(x, O), a = d.mayDelete(x, O, !1);
                if (a) throw new d.ErrnoError(a);
                if (!x.node_ops.unlink) throw new d.ErrnoError(63);
                if (d.isMountpoint(b)) throw new d.ErrnoError(10);
                x.node_ops.unlink(x, O), d.destroyNode(b);
            },
            readlink (Y) {
                var N = d.lookupPath(Y), x = N.node;
                if (!x) throw new d.ErrnoError(44);
                if (!x.node_ops.readlink) throw new d.ErrnoError(28);
                return o8.resolve(d.getPath(x.parent), x.node_ops.readlink(x));
            },
            stat (Y, N) {
                var x = d.lookupPath(Y, {
                    follow: !N
                }), O = x.node;
                if (!O) throw new d.ErrnoError(44);
                if (!O.node_ops.getattr) throw new d.ErrnoError(63);
                return O.node_ops.getattr(O);
            },
            lstat (Y) {
                return d.stat(Y, !0);
            },
            chmod (Y, N, x) {
                var O;
                if (typeof Y == "string") {
                    var b = d.lookupPath(Y, {
                        follow: !x
                    });
                    O = b.node;
                } else O = Y;
                if (!O.node_ops.setattr) throw new d.ErrnoError(63);
                O.node_ops.setattr(O, {
                    mode: N & 4095 | O.mode & -4096,
                    timestamp: Date.now()
                });
            },
            lchmod (Y, N) {
                d.chmod(Y, N, !0);
            },
            fchmod (Y, N) {
                var x = d.getStreamChecked(Y);
                d.chmod(x.node, N);
            },
            chown (Y, N, x, O) {
                var b;
                if (typeof Y == "string") {
                    var a = d.lookupPath(Y, {
                        follow: !O
                    });
                    b = a.node;
                } else b = Y;
                if (!b.node_ops.setattr) throw new d.ErrnoError(63);
                b.node_ops.setattr(b, {
                    timestamp: Date.now()
                });
            },
            lchown (Y, N, x) {
                d.chown(Y, N, x, !0);
            },
            fchown (Y, N, x) {
                var O = d.getStreamChecked(Y);
                d.chown(O.node, N, x);
            },
            truncate (Y, N) {
                if (N < 0) throw new d.ErrnoError(28);
                var x;
                if (typeof Y == "string") {
                    var O = d.lookupPath(Y, {
                        follow: !0
                    });
                    x = O.node;
                } else x = Y;
                if (!x.node_ops.setattr) throw new d.ErrnoError(63);
                if (d.isDir(x.mode)) throw new d.ErrnoError(31);
                if (!d.isFile(x.mode)) throw new d.ErrnoError(28);
                var b = d.nodePermissions(x, "w");
                if (b) throw new d.ErrnoError(b);
                x.node_ops.setattr(x, {
                    size: N,
                    timestamp: Date.now()
                });
            },
            ftruncate (Y, N) {
                var x = d.getStreamChecked(Y);
                if (!(x.flags & 2097155)) throw new d.ErrnoError(28);
                d.truncate(x.node, N);
            },
            utime (Y, N, x) {
                var O = d.lookupPath(Y, {
                    follow: !0
                }), b = O.node;
                b.node_ops.setattr(b, {
                    timestamp: Math.max(N, x)
                });
            },
            open (Y, N, x) {
                if (Y === "") throw new d.ErrnoError(44);
                N = typeof N == "string" ? Su(N) : N, N & 64 ? (x = typeof x == "undefined" ? 438 : x, x = x & 4095 | 32768) : x = 0;
                var O;
                if (typeof Y == "object") O = Y;
                else {
                    Y = _1.normalize(Y);
                    try {
                        var b = d.lookupPath(Y, {
                            follow: !(N & 131072)
                        });
                        O = b.node;
                    } catch (e) {}
                }
                var a = !1;
                if (N & 64) {
                    if (O) {
                        if (N & 128) throw new d.ErrnoError(20);
                    } else O = d.mknod(Y, x, 0), a = !0;
                }
                if (!O) throw new d.ErrnoError(44);
                if (d.isChrdev(O.mode) && (N &= -513), N & 65536 && !d.isDir(O.mode)) throw new d.ErrnoError(54);
                if (!a) {
                    var o0 = d.mayOpen(O, N);
                    if (o0) throw new d.ErrnoError(o0);
                }
                N & 512 && !a && d.truncate(O, 0), N &= -131713;
                var h0 = d.createStream({
                    node: O,
                    path: d.getPath(O),
                    flags: N,
                    seekable: !0,
                    position: 0,
                    stream_ops: O.stream_ops,
                    ungotten: [],
                    error: !1
                });
                return h0.stream_ops.open && h0.stream_ops.open(h0), K.logReadFiles && !(N & 1) && (d.readFiles || (d.readFiles = {}), Y in d.readFiles || (d.readFiles[Y] = 1)), h0;
            },
            close (Y) {
                if (d.isClosed(Y)) throw new d.ErrnoError(8);
                Y.getdents && (Y.getdents = null);
                try {
                    Y.stream_ops.close && Y.stream_ops.close(Y);
                } catch (N) {
                    throw N;
                } finally{
                    d.closeStream(Y.fd);
                }
                Y.fd = null;
            },
            isClosed (Y) {
                return Y.fd === null;
            },
            llseek (Y, N, x) {
                if (d.isClosed(Y)) throw new d.ErrnoError(8);
                if (!Y.seekable || !Y.stream_ops.llseek) throw new d.ErrnoError(70);
                if (x != 0 && x != 1 && x != 2) throw new d.ErrnoError(28);
                return Y.position = Y.stream_ops.llseek(Y, N, x), Y.ungotten = [], Y.position;
            },
            read (Y, N, x, O, b) {
                if (O < 0 || b < 0) throw new d.ErrnoError(28);
                if (d.isClosed(Y)) throw new d.ErrnoError(8);
                if ((Y.flags & 2097155) === 1) throw new d.ErrnoError(8);
                if (d.isDir(Y.node.mode)) throw new d.ErrnoError(31);
                if (!Y.stream_ops.read) throw new d.ErrnoError(28);
                var a = typeof b != "undefined";
                if (!a) b = Y.position;
                else if (!Y.seekable) throw new d.ErrnoError(70);
                var o0 = Y.stream_ops.read(Y, N, x, O, b);
                return a || (Y.position += o0), o0;
            },
            write (Y, N, x, O, b, a) {
                if (O < 0 || b < 0) throw new d.ErrnoError(28);
                if (d.isClosed(Y)) throw new d.ErrnoError(8);
                if (!(Y.flags & 2097155)) throw new d.ErrnoError(8);
                if (d.isDir(Y.node.mode)) throw new d.ErrnoError(31);
                if (!Y.stream_ops.write) throw new d.ErrnoError(28);
                Y.seekable && Y.flags & 1024 && d.llseek(Y, 0, 2);
                var o0 = typeof b != "undefined";
                if (!o0) b = Y.position;
                else if (!Y.seekable) throw new d.ErrnoError(70);
                var h0 = Y.stream_ops.write(Y, N, x, O, b, a);
                return o0 || (Y.position += h0), h0;
            },
            allocate (Y, N, x) {
                if (d.isClosed(Y)) throw new d.ErrnoError(8);
                if (N < 0 || x <= 0) throw new d.ErrnoError(28);
                if (!(Y.flags & 2097155)) throw new d.ErrnoError(8);
                if (!d.isFile(Y.node.mode) && !d.isDir(Y.node.mode)) throw new d.ErrnoError(43);
                if (!Y.stream_ops.allocate) throw new d.ErrnoError(138);
                Y.stream_ops.allocate(Y, N, x);
            },
            mmap (Y, N, x, O, b) {
                if (O & 2 && !(b & 2) && (Y.flags & 2097155) !== 2) throw new d.ErrnoError(2);
                if ((Y.flags & 2097155) === 1) throw new d.ErrnoError(2);
                if (!Y.stream_ops.mmap) throw new d.ErrnoError(43);
                return Y.stream_ops.mmap(Y, N, x, O, b);
            },
            msync (Y, N, x, O, b) {
                return Y.stream_ops.msync ? Y.stream_ops.msync(Y, N, x, O, b) : 0;
            },
            ioctl (Y, N, x) {
                if (!Y.stream_ops.ioctl) throw new d.ErrnoError(59);
                return Y.stream_ops.ioctl(Y, N, x);
            },
            readFile (Y, N = {}) {
                if (N.flags = N.flags || 0, N.encoding = N.encoding || "binary", N.encoding !== "utf8" && N.encoding !== "binary") throw new Error(`Invalid encoding type "${N.encoding}"`);
                var x, O = d.open(Y, N.flags), b = d.stat(Y), a = b.size, o0 = new Uint8Array(a);
                return d.read(O, o0, 0, a, 0), N.encoding === "utf8" ? x = o6(o0, 0) : N.encoding === "binary" && (x = o0), d.close(O), x;
            },
            writeFile (Y, N, x = {}) {
                x.flags = x.flags || 577;
                var O = d.open(Y, x.flags, x.mode);
                if (typeof N == "string") {
                    var b = new Uint8Array(jr(N) + 1), a = Or(N, b, 0, b.length);
                    d.write(O, b, 0, a, void 0, x.canOwn);
                } else if (ArrayBuffer.isView(N)) d.write(O, N, 0, N.byteLength, void 0, x.canOwn);
                else throw new Error("Unsupported data type");
                d.close(O);
            },
            cwd: ()=>d.currentPath,
            chdir (Y) {
                var N = d.lookupPath(Y, {
                    follow: !0
                });
                if (N.node === null) throw new d.ErrnoError(44);
                if (!d.isDir(N.node.mode)) throw new d.ErrnoError(54);
                var x = d.nodePermissions(N.node, "x");
                if (x) throw new d.ErrnoError(x);
                d.currentPath = N.path;
            },
            createDefaultDirectories () {
                d.mkdir("/tmp"), d.mkdir("/home"), d.mkdir("/home/web_user");
            },
            createDefaultDevices () {
                d.mkdir("/dev"), d.registerDevice(d.makedev(1, 3), {
                    read: ()=>0,
                    write: (O, b, a, o0, h0)=>o0
                }), d.mkdev("/dev/null", d.makedev(1, 3)), Y8.register(d.makedev(5, 0), Y8.default_tty_ops), Y8.register(d.makedev(6, 0), Y8.default_tty1_ops), d.mkdev("/dev/tty", d.makedev(5, 0)), d.mkdev("/dev/tty1", d.makedev(6, 0));
                var Y = new Uint8Array(1024), N = 0, x = ()=>(N === 0 && (N = zk(Y).byteLength), Y[--N]);
                d.createDevice("/dev", "random", x), d.createDevice("/dev", "urandom", x), d.mkdir("/dev/shm"), d.mkdir("/dev/shm/tmp");
            },
            createSpecialDirectories () {
                d.mkdir("/proc");
                var Y = d.mkdir("/proc/self");
                d.mkdir("/proc/self/fd"), d.mount({
                    mount () {
                        var N = d.createNode(Y, "fd", 16895, 73);
                        return N.node_ops = {
                            lookup (x, O) {
                                var b = +O, a = d.getStreamChecked(b), o0 = {
                                    parent: null,
                                    mount: {
                                        mountpoint: "fake"
                                    },
                                    node_ops: {
                                        readlink: ()=>a.path
                                    }
                                };
                                return o0.parent = o0, o0;
                            }
                        }, N;
                    }
                }, {}, "/proc/self/fd");
            },
            createStandardStreams () {
                K.stdin ? d.createDevice("/dev", "stdin", K.stdin) : d.symlink("/dev/tty", "/dev/stdin"), K.stdout ? d.createDevice("/dev", "stdout", null, K.stdout) : d.symlink("/dev/tty", "/dev/stdout"), K.stderr ? d.createDevice("/dev", "stderr", null, K.stderr) : d.symlink("/dev/tty1", "/dev/stderr");
                var Y = d.open("/dev/stdin", 0), N = d.open("/dev/stdout", 1), x = d.open("/dev/stderr", 1);
            },
            staticInit () {
                [
                    44
                ].forEach((Y)=>{
                    d.genericErrors[Y] = new d.ErrnoError(Y), d.genericErrors[Y].stack = "<generic error, no stack>";
                }), d.nameTable = new Array(4096), d.mount(g2, {}, "/"), d.createDefaultDirectories(), d.createDefaultDevices(), d.createSpecialDirectories(), d.filesystems = {
                    MEMFS: g2
                };
            },
            init (Y, N, x) {
                d.init.initialized = !0, K.stdin = Y || K.stdin, K.stdout = N || K.stdout, K.stderr = x || K.stderr, d.createStandardStreams();
            },
            quit () {
                d.init.initialized = !1;
                for(var Y = 0; Y < d.streams.length; Y++){
                    var N = d.streams[Y];
                    N && d.close(N);
                }
            },
            findObject (Y, N) {
                var x = d.analyzePath(Y, N);
                return x.exists ? x.object : null;
            },
            analyzePath (Y, N) {
                try {
                    var x = d.lookupPath(Y, {
                        follow: !N
                    });
                    Y = x.path;
                } catch (e) {}
                var O = {
                    isRoot: !1,
                    exists: !1,
                    error: 0,
                    name: null,
                    path: null,
                    object: null,
                    parentExists: !1,
                    parentPath: null,
                    parentObject: null
                };
                try {
                    var x = d.lookupPath(Y, {
                        parent: !0
                    });
                    O.parentExists = !0, O.parentPath = x.path, O.parentObject = x.node, O.name = _1.basename(Y), x = d.lookupPath(Y, {
                        follow: !N
                    }), O.exists = !0, O.path = x.path, O.object = x.node, O.name = x.node.name, O.isRoot = x.path === "/";
                } catch (b) {
                    O.error = b.errno;
                }
                return O;
            },
            createPath (Y, N, x, O) {
                Y = typeof Y == "string" ? Y : d.getPath(Y);
                for(var b = N.split("/").reverse(); b.length;){
                    var a = b.pop();
                    if (a) {
                        var o0 = _1.join2(Y, a);
                        try {
                            d.mkdir(o0);
                        } catch (e) {}
                        Y = o0;
                    }
                }
                return o0;
            },
            createFile (Y, N, x, O, b) {
                var a = _1.join2(typeof Y == "string" ? Y : d.getPath(Y), N), o0 = Pr(O, b);
                return d.create(a, o0);
            },
            createDataFile (Y, N, x, O, b, a) {
                var o0 = N;
                Y && (Y = typeof Y == "string" ? Y : d.getPath(Y), o0 = N ? _1.join2(Y, N) : Y);
                var h0 = Pr(O, b), u0 = d.create(o0, h0);
                if (x) {
                    if (typeof x == "string") {
                        for(var U0 = new Array(x.length), L0 = 0, _2 = x.length; L0 < _2; ++L0)U0[L0] = x.charCodeAt(L0);
                        x = U0;
                    }
                    d.chmod(u0, h0 | 146);
                    var u2 = d.open(u0, 577);
                    d.write(u2, x, 0, x.length, 0, a), d.close(u2), d.chmod(u0, h0);
                }
            },
            createDevice (Y, N, x, O) {
                var b = _1.join2(typeof Y == "string" ? Y : d.getPath(Y), N), a = Pr(!!x, !!O);
                d.createDevice.major || (d.createDevice.major = 64);
                var o0 = d.makedev(d.createDevice.major++, 0);
                return d.registerDevice(o0, {
                    open (h0) {
                        h0.seekable = !1;
                    },
                    close (h0) {
                        var u0;
                        (u0 = O == null ? void 0 : O.buffer) != null && u0.length && O(10);
                    },
                    read (h0, u0, U0, L0, _2) {
                        for(var u2 = 0, o2 = 0; o2 < L0; o2++){
                            var c0;
                            try {
                                c0 = x();
                            } catch (e) {
                                throw new d.ErrnoError(29);
                            }
                            if (c0 === void 0 && u2 === 0) throw new d.ErrnoError(6);
                            if (c0 == null) break;
                            u2++, u0[U0 + o2] = c0;
                        }
                        return u2 && (h0.node.timestamp = Date.now()), u2;
                    },
                    write (h0, u0, U0, L0, _2) {
                        for(var u2 = 0; u2 < L0; u2++)try {
                            O(u0[U0 + u2]);
                        } catch (e) {
                            throw new d.ErrnoError(29);
                        }
                        return L0 && (h0.node.timestamp = Date.now()), u2;
                    }
                }), d.mkdev(b, a, o0);
            },
            forceLoadFile (Y) {
                if (Y.isDevice || Y.isFolder || Y.link || Y.contents) return !0;
                if (typeof XMLHttpRequest != "undefined") throw new Error("Lazy loading should have been performed (contents set) in createLazyFile, but it was not. Lazy loading only works in web workers. Use --embed-file or --preload-file in emcc on the main thread.");
                if (x6) try {
                    Y.contents = ie(x6(Y.url), !0), Y.usedBytes = Y.contents.length;
                } catch (e) {
                    throw new d.ErrnoError(29);
                }
                else throw new Error("Cannot load without read() or XMLHttpRequest.");
            },
            createLazyFile (Y, N, x, O, b) {
                class a {
                    get(o2) {
                        if (!(o2 > this.length - 1 || o2 < 0)) {
                            var c0 = o2 % this.chunkSize, J2 = o2 / this.chunkSize | 0;
                            return this.getter(J2)[c0];
                        }
                    }
                    setDataGetter(o2) {
                        this.getter = o2;
                    }
                    cacheLength() {
                        var o2 = new XMLHttpRequest;
                        if (o2.open("HEAD", x, !1), o2.send(null), !(o2.status >= 200 && o2.status < 300 || o2.status === 304)) throw new Error("Couldn't load " + x + ". Status: " + o2.status);
                        var c0 = Number(o2.getResponseHeader("Content-length")), J2, o1 = (J2 = o2.getResponseHeader("Accept-Ranges")) && J2 === "bytes", I2 = (J2 = o2.getResponseHeader("Content-Encoding")) && J2 === "gzip", z = 1048576;
                        o1 || (z = c0);
                        var A2 = (q2, b2)=>{
                            if (q2 > b2) throw new Error("invalid range (" + q2 + ", " + b2 + ") or no bytes requested!");
                            if (b2 > c0 - 1) throw new Error("only " + c0 + " bytes available! programmer error!");
                            var R2 = new XMLHttpRequest;
                            if (R2.open("GET", x, !1), c0 !== z && R2.setRequestHeader("Range", "bytes=" + q2 + "-" + b2), R2.responseType = "arraybuffer", R2.overrideMimeType && R2.overrideMimeType("text/plain; charset=x-user-defined"), R2.send(null), !(R2.status >= 200 && R2.status < 300 || R2.status === 304)) throw new Error("Couldn't load " + x + ". Status: " + R2.status);
                            return R2.response !== void 0 ? new Uint8Array(R2.response || []) : ie(R2.responseText || "", !0);
                        }, Q1 = this;
                        Q1.setDataGetter((q2)=>{
                            var b2 = q2 * z, R2 = (q2 + 1) * z - 1;
                            if (R2 = Math.min(R2, c0 - 1), typeof Q1.chunks[q2] == "undefined" && (Q1.chunks[q2] = A2(b2, R2)), typeof Q1.chunks[q2] == "undefined") throw new Error("doXHR failed!");
                            return Q1.chunks[q2];
                        }), (I2 || !c0) && (z = c0 = 1, c0 = this.getter(0).length, z = c0, Ur("LazyFiles on gzip forces download of the whole file when length is accessed")), this._length = c0, this._chunkSize = z, this.lengthKnown = !0;
                    }
                    get length() {
                        return this.lengthKnown || this.cacheLength(), this._length;
                    }
                    get chunkSize() {
                        return this.lengthKnown || this.cacheLength(), this._chunkSize;
                    }
                    constructor(){
                        this.lengthKnown = !1, this.chunks = [];
                    }
                }
                if (typeof XMLHttpRequest != "undefined") {
                    if (!Li) throw "Cannot do synchronous binary XHRs outside webworkers in modern browsers. Use --embed-file or --preload-file in emcc";
                    var o0 = new a, h0 = {
                        isDevice: !1,
                        contents: o0
                    };
                } else var h0 = {
                    isDevice: !1,
                    url: x
                };
                var u0 = d.createFile(Y, N, h0, O, b);
                h0.contents ? u0.contents = h0.contents : h0.url && (u0.contents = null, u0.url = h0.url), Object.defineProperties(u0, {
                    usedBytes: {
                        get: function() {
                            return this.contents.length;
                        }
                    }
                });
                var U0 = {}, L0 = Object.keys(u0.stream_ops);
                L0.forEach((u2)=>{
                    var o2 = u0.stream_ops[u2];
                    U0[u2] = (...c0)=>(d.forceLoadFile(u0), o2(...c0));
                });
                function _2(u2, o2, c0, J2, o1) {
                    var I2 = u2.node.contents;
                    if (o1 >= I2.length) return 0;
                    var z = Math.min(I2.length - o1, J2);
                    if (I2.slice) for(var A2 = 0; A2 < z; A2++)o2[c0 + A2] = I2[o1 + A2];
                    else for(var A2 = 0; A2 < z; A2++)o2[c0 + A2] = I2.get(o1 + A2);
                    return z;
                }
                return U0.read = (u2, o2, c0, J2, o1)=>(d.forceLoadFile(u0), _2(u2, o2, c0, J2, o1)), U0.mmap = (u2, o2, c0, J2, o1)=>{
                    d.forceLoadFile(u0);
                    var I2 = Tk(o2);
                    if (!I2) throw new d.ErrnoError(48);
                    return _2(u2, M1, I2, o2, c0), {
                        ptr: I2,
                        allocated: !0
                    };
                }, u0.stream_ops = U0, u0;
            }
        }, k4 = {
            DEFAULT_POLLMASK: 5,
            calculateAt (Y, N, x) {
                if (_1.isAbs(N)) return N;
                var O;
                if (Y === -100) O = d.cwd();
                else {
                    var b = k4.getStreamFromFD(Y);
                    O = b.path;
                }
                if (N.length == 0) {
                    if (!x) throw new d.ErrnoError(44);
                    return O;
                }
                return _1.join2(O, N);
            },
            doStat (Y, N, x) {
                var O = Y(N);
                F2[x >> 2] = O.dev, F2[x + 4 >> 2] = O.mode, d2[x + 8 >> 2] = O.nlink, F2[x + 12 >> 2] = O.uid, F2[x + 16 >> 2] = O.gid, F2[x + 20 >> 2] = O.rdev, O1 = [
                    O.size >>> 0,
                    (a2 = O.size, +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[x + 24 >> 2] = O1[0], F2[x + 28 >> 2] = O1[1], F2[x + 32 >> 2] = 4096, F2[x + 36 >> 2] = O.blocks;
                var b = O.atime.getTime(), a = O.mtime.getTime(), o0 = O.ctime.getTime();
                return O1 = [
                    Math.floor(b / 1e3) >>> 0,
                    (a2 = Math.floor(b / 1e3), +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[x + 40 >> 2] = O1[0], F2[x + 44 >> 2] = O1[1], d2[x + 48 >> 2] = b % 1e3 * 1e3, O1 = [
                    Math.floor(a / 1e3) >>> 0,
                    (a2 = Math.floor(a / 1e3), +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[x + 56 >> 2] = O1[0], F2[x + 60 >> 2] = O1[1], d2[x + 64 >> 2] = a % 1e3 * 1e3, O1 = [
                    Math.floor(o0 / 1e3) >>> 0,
                    (a2 = Math.floor(o0 / 1e3), +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[x + 72 >> 2] = O1[0], F2[x + 76 >> 2] = O1[1], d2[x + 80 >> 2] = o0 % 1e3 * 1e3, O1 = [
                    O.ino >>> 0,
                    (a2 = O.ino, +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[x + 88 >> 2] = O1[0], F2[x + 92 >> 2] = O1[1], 0;
            },
            doMsync (Y, N, x, O, b) {
                if (!d.isFile(N.node.mode)) throw new d.ErrnoError(43);
                if (O & 2) return 0;
                var a = f4.slice(Y, Y + x);
                d.msync(N, a, b, x, O);
            },
            getStreamFromFD (Y) {
                var N = d.getStreamChecked(Y);
                return N;
            },
            varargs: void 0,
            getStr (Y) {
                var N = j8(Y);
                return N;
            }
        };
        function ju(Y, N, x) {
            k4.varargs = x;
            try {
                var O = k4.getStreamFromFD(Y);
                switch(N){
                    case 0:
                        var b = ci();
                        if (b < 0) return -28;
                        for(; d.streams[b];)b++;
                        var a;
                        return a = d.dupStream(O, b), a.fd;
                    case 1:
                    case 2:
                        return 0;
                    case 3:
                        return O.flags;
                    case 4:
                        var b = ci();
                        return O.flags |= b, 0;
                    case 12:
                        var b = u6(), o0 = 0;
                        return t8[b + o0 >> 1] = 2, 0;
                    case 13:
                    case 14:
                        return 0;
                }
                return -28;
            } catch (h0) {
                if (typeof d == "undefined" || h0.name !== "ErrnoError") throw h0;
                return -h0.errno;
            }
        }
        function Ou(Y, N, x) {
            k4.varargs = x;
            try {
                var O = k4.getStreamFromFD(Y);
                switch(N){
                    case 21509:
                        return O.tty ? 0 : -59;
                    case 21505:
                        if (!O.tty) return -59;
                        if (O.tty.ops.ioctl_tcgets) {
                            var b = O.tty.ops.ioctl_tcgets(O), a = u6();
                            F2[a >> 2] = b.c_iflag || 0, F2[a + 4 >> 2] = b.c_oflag || 0, F2[a + 8 >> 2] = b.c_cflag || 0, F2[a + 12 >> 2] = b.c_lflag || 0;
                            for(var o0 = 0; o0 < 32; o0++)M1[a + o0 + 17] = b.c_cc[o0] || 0;
                            return 0;
                        }
                        return 0;
                    case 21510:
                    case 21511:
                    case 21512:
                        return O.tty ? 0 : -59;
                    case 21506:
                    case 21507:
                    case 21508:
                        if (!O.tty) return -59;
                        if (O.tty.ops.ioctl_tcsets) {
                            for(var a = u6(), h0 = F2[a >> 2], u0 = F2[a + 4 >> 2], U0 = F2[a + 8 >> 2], L0 = F2[a + 12 >> 2], _2 = [], o0 = 0; o0 < 32; o0++)_2.push(M1[a + o0 + 17]);
                            return O.tty.ops.ioctl_tcsets(O.tty, N, {
                                c_iflag: h0,
                                c_oflag: u0,
                                c_cflag: U0,
                                c_lflag: L0,
                                c_cc: _2
                            });
                        }
                        return 0;
                    case 21519:
                        if (!O.tty) return -59;
                        var a = u6();
                        return F2[a >> 2] = 0, 0;
                    case 21520:
                        return O.tty ? -28 : -59;
                    case 21531:
                        var a = u6();
                        return d.ioctl(O, N, a);
                    case 21523:
                        if (!O.tty) return -59;
                        if (O.tty.ops.ioctl_tiocgwinsz) {
                            var u2 = O.tty.ops.ioctl_tiocgwinsz(O.tty), a = u6();
                            t8[a >> 1] = u2[0], t8[a + 2 >> 1] = u2[1];
                        }
                        return 0;
                    case 21524:
                        return O.tty ? 0 : -59;
                    case 21515:
                        return O.tty ? 0 : -59;
                    default:
                        return -28;
                }
            } catch (o2) {
                if (typeof d == "undefined" || o2.name !== "ErrnoError") throw o2;
                return -o2.errno;
            }
        }
        function Pu(Y, N, x, O) {
            k4.varargs = O;
            try {
                N = k4.getStr(N), N = k4.calculateAt(Y, N);
                var b = O ? ci() : 0;
                return d.open(N, x, b).fd;
            } catch (a) {
                if (typeof d == "undefined" || a.name !== "ErrnoError") throw a;
                return -a.errno;
            }
        }
        function Lu(Y, N, x) {
            try {
                return N = k4.getStr(N), N = k4.calculateAt(Y, N), x === 0 ? d.unlink(N) : x === 512 ? d.rmdir(N) : O6("Invalid flags passed to unlinkat"), 0;
            } catch (O) {
                if (typeof d == "undefined" || O.name !== "ErrnoError") throw O;
                return -O.errno;
            }
        }
        var Ku = ()=>{
            O6("");
        }, ee = {}, Lr = (Y)=>{
            for(; Y.length;){
                var N = Y.pop(), x = Y.pop();
                x(N);
            }
        };
        function P6(Y) {
            return this.fromWireType(d2[Y >> 2]);
        }
        var l6 = {}, O8 = {}, re = {}, Sk, Ae = (Y)=>{
            throw new Sk(Y);
        }, Kr = (Y, N, x)=>{
            Y.forEach(function(h0) {
                re[h0] = N;
            });
            function O(h0) {
                var u0 = x(h0);
                u0.length !== Y.length && Ae("Mismatched type converter count");
                for(var U0 = 0; U0 < Y.length; ++U0)P4(Y[U0], u0[U0]);
            }
            var b = new Array(N.length), a = [], o0 = 0;
            N.forEach((h0, u0)=>{
                O8.hasOwnProperty(h0) ? b[u0] = O8[h0] : (a.push(h0), l6.hasOwnProperty(h0) || (l6[h0] = []), l6[h0].push(()=>{
                    b[u0] = O8[h0], ++o0, o0 === a.length && O(b);
                }));
            }), a.length === 0 && O(b);
        }, qu = (Y)=>{
            var N = ee[Y];
            delete ee[Y];
            var x = N.rawConstructor, O = N.rawDestructor, b = N.fields, a = b.map((o0)=>o0.getterReturnType).concat(b.map((o0)=>o0.setterArgumentType));
            Kr([
                Y
            ], a, (o0)=>{
                var h0 = {};
                return b.forEach((u0, U0)=>{
                    var L0 = u0.fieldName, _2 = o0[U0], u2 = u0.getter, o2 = u0.getterContext, c0 = o0[U0 + b.length], J2 = u0.setter, o1 = u0.setterContext;
                    h0[L0] = {
                        read: (I2)=>_2.fromWireType(u2(o2, I2)),
                        write: (I2, z)=>{
                            var A2 = [];
                            J2(o1, I2, c0.toWireType(A2, z)), Lr(A2);
                        }
                    };
                }), [
                    {
                        name: N.name,
                        fromWireType: (u0)=>{
                            var U0 = {};
                            for(var L0 in h0)U0[L0] = h0[L0].read(u0);
                            return O(u0), U0;
                        },
                        toWireType: (u0, U0)=>{
                            for(var L0 in h0)if (!(L0 in U0)) throw new TypeError(`Missing field: "${L0}"`);
                            var _2 = x();
                            for(L0 in h0)h0[L0].write(_2, U0[L0]);
                            return u0 !== null && u0.push(O, _2), _2;
                        },
                        argPackAdvance: L4,
                        readValueFromPointer: P6,
                        destructorFunction: O
                    }
                ];
            });
        }, $u = (Y, N, x, O, b)=>{}, au = ()=>{
            for(var Y = new Array(256), N = 0; N < 256; ++N)Y[N] = String.fromCharCode(N);
            jk = Y;
        }, jk, n4 = (Y)=>{
            for(var N = "", x = Y; f4[x];)N += jk[f4[x++]];
            return N;
        }, L6, k1 = (Y)=>{
            throw new L6(Y);
        };
        function bu(Y, N, x = {}) {
            var O = N.name;
            if (Y || k1(`type "${O}" must have a positive integer typeid pointer`), O8.hasOwnProperty(Y)) {
                if (x.ignoreDuplicateRegistrations) return;
                k1(`Cannot register type '${O}' twice`);
            }
            if (O8[Y] = N, delete re[Y], l6.hasOwnProperty(Y)) {
                var b = l6[Y];
                delete l6[Y], b.forEach((a)=>a());
            }
        }
        function P4(Y, N, x = {}) {
            if (!("argPackAdvance" in N)) throw new TypeError("registerType registeredInstance requires argPackAdvance");
            return bu(Y, N, x);
        }
        var L4 = 8, du = (Y, N, x, O)=>{
            N = n4(N), P4(Y, {
                name: N,
                fromWireType: function(b) {
                    return !!b;
                },
                toWireType: function(b, a) {
                    return a ? x : O;
                },
                argPackAdvance: L4,
                readValueFromPointer: function(b) {
                    return this.fromWireType(f4[b]);
                },
                destructorFunction: null
            });
        }, cu = (Y)=>({
                count: Y.count,
                deleteScheduled: Y.deleteScheduled,
                preservePointerOnDelete: Y.preservePointerOnDelete,
                ptr: Y.ptr,
                ptrType: Y.ptrType,
                smartPtr: Y.smartPtr,
                smartPtrType: Y.smartPtrType
            }), qr = (Y)=>{
            function N(x) {
                return x.$$.ptrType.registeredClass.name;
            }
            k1(N(Y) + " instance already deleted");
        }, $r = !1, Ok = (Y)=>{}, il = (Y)=>{
            Y.smartPtr ? Y.smartPtrType.rawDestructor(Y.smartPtr) : Y.ptrType.registeredClass.rawDestructor(Y.ptr);
        }, Pk = (Y)=>{
            Y.count.value -= 1;
            var N = Y.count.value === 0;
            N && il(Y);
        }, Lk = (Y, N, x)=>{
            if (N === x) return Y;
            if (x.baseClass === void 0) return null;
            var O = Lk(Y, N, x.baseClass);
            return O === null ? null : x.downcast(O);
        }, Kk = {}, el = ()=>Object.keys($6).length, rl = ()=>{
            var Y = [];
            for(var N in $6)$6.hasOwnProperty(N) && Y.push($6[N]);
            return Y;
        }, K6 = [], ar = ()=>{
            for(; K6.length;){
                var Y = K6.pop();
                Y.$$.deleteScheduled = !1, Y.delete();
            }
        }, q6, Al = (Y)=>{
            q6 = Y, K6.length && q6 && q6(ar);
        }, fl = ()=>{
            K.getInheritedInstanceCount = el, K.getLiveInheritedInstances = rl, K.flushPendingDeletes = ar, K.setDelayFunction = Al;
        }, $6 = {}, kl = (Y, N)=>{
            for(N === void 0 && k1("ptr should not be undefined"); Y.baseClass;)N = Y.upcast(N), Y = Y.baseClass;
            return N;
        }, nl = (Y, N)=>(N = kl(Y, N), $6[N]), fe = (Y, N)=>{
            (!N.ptrType || !N.ptr) && Ae("makeClassHandle requires ptr and ptrType");
            var x = !!N.smartPtrType, O = !!N.smartPtr;
            return x !== O && Ae("Both smartPtrType and smartPtr must be specified"), N.count = {
                value: 1
            }, a6(Object.create(Y, {
                $$: {
                    value: N,
                    writable: !0
                }
            }));
        };
        function tl(Y) {
            var N = this.getPointee(Y);
            if (!N) return this.destructor(Y), null;
            var x = nl(this.registeredClass, N);
            if (x !== void 0) {
                if (x.$$.count.value === 0) return x.$$.ptr = N, x.$$.smartPtr = Y, x.clone();
                var O = x.clone();
                return this.destructor(Y), O;
            }
            function b() {
                return this.isSmartPointer ? fe(this.registeredClass.instancePrototype, {
                    ptrType: this.pointeeType,
                    ptr: N,
                    smartPtrType: this,
                    smartPtr: Y
                }) : fe(this.registeredClass.instancePrototype, {
                    ptrType: this,
                    ptr: Y
                });
            }
            var a = this.registeredClass.getActualType(N), o0 = Kk[a];
            if (!o0) return b.call(this);
            var h0;
            this.isConst ? h0 = o0.constPointerType : h0 = o0.pointerType;
            var u0 = Lk(N, this.registeredClass, h0.registeredClass);
            return u0 === null ? b.call(this) : this.isSmartPointer ? fe(h0.registeredClass.instancePrototype, {
                ptrType: h0,
                ptr: u0,
                smartPtrType: this,
                smartPtr: Y
            }) : fe(h0.registeredClass.instancePrototype, {
                ptrType: h0,
                ptr: u0
            });
        }
        var a6 = (Y)=>typeof FinalizationRegistry == "undefined" ? (a6 = (N)=>N, Y) : ($r = new FinalizationRegistry((N)=>{
                Pk(N.$$);
            }), a6 = (N)=>{
                var x = N.$$, O = !!x.smartPtr;
                if (O) {
                    var b = {
                        $$: x
                    };
                    $r.register(N, b, N);
                }
                return N;
            }, Ok = (N)=>$r.unregister(N), a6(Y)), ol = ()=>{
            Object.assign(ke.prototype, {
                isAliasOf (Y) {
                    if (!(this instanceof ke) || !(Y instanceof ke)) return !1;
                    var N = this.$$.ptrType.registeredClass, x = this.$$.ptr;
                    Y.$$ = Y.$$;
                    for(var O = Y.$$.ptrType.registeredClass, b = Y.$$.ptr; N.baseClass;)x = N.upcast(x), N = N.baseClass;
                    for(; O.baseClass;)b = O.upcast(b), O = O.baseClass;
                    return N === O && x === b;
                },
                clone () {
                    if (this.$$.ptr || qr(this), this.$$.preservePointerOnDelete) return this.$$.count.value += 1, this;
                    var Y = a6(Object.create(Object.getPrototypeOf(this), {
                        $$: {
                            value: cu(this.$$)
                        }
                    }));
                    return Y.$$.count.value += 1, Y.$$.deleteScheduled = !1, Y;
                },
                delete () {
                    this.$$.ptr || qr(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && k1("Object already scheduled for deletion"), Ok(this), Pk(this.$$), this.$$.preservePointerOnDelete || (this.$$.smartPtr = void 0, this.$$.ptr = void 0);
                },
                isDeleted () {
                    return !this.$$.ptr;
                },
                deleteLater () {
                    return this.$$.ptr || qr(this), this.$$.deleteScheduled && !this.$$.preservePointerOnDelete && k1("Object already scheduled for deletion"), K6.push(this), K6.length === 1 && q6 && q6(ar), this.$$.deleteScheduled = !0, this;
                }
            });
        };
        function ke() {}
        var b6 = (Y, N)=>Object.defineProperty(N, "name", {
                value: Y
            }), ul = (Y, N, x)=>{
            if (Y[N].overloadTable === void 0) {
                var O = Y[N];
                Y[N] = function(...b) {
                    return Y[N].overloadTable.hasOwnProperty(b.length) || k1(`Function '${x}' called with an invalid number of arguments (${b.length}) - expects one of (${Y[N].overloadTable})!`), Y[N].overloadTable[b.length].apply(this, b);
                }, Y[N].overloadTable = [], Y[N].overloadTable[O.argCount] = O;
            }
        }, br = (Y, N, x)=>{
            K.hasOwnProperty(Y) ? ((x === void 0 || K[Y].overloadTable !== void 0 && K[Y].overloadTable[x] !== void 0) && k1(`Cannot register public name '${Y}' twice`), ul(K, Y, Y), K.hasOwnProperty(x) && k1(`Cannot register multiple overloads of a function with the same number of arguments (${x})!`), K[Y].overloadTable[x] = N) : (K[Y] = N, x !== void 0 && (K[Y].numArguments = x));
        }, ll = 48, sl = 57, hl = (Y)=>{
            if (Y === void 0) return "_unknown";
            Y = Y.replace(/[^a-zA-Z0-9_]/g, "$");
            var N = Y.charCodeAt(0);
            return N >= ll && N <= sl ? `_${Y}` : Y;
        };
        function wl(Y, N, x, O, b, a, o0, h0) {
            this.name = Y, this.constructor = N, this.instancePrototype = x, this.rawDestructor = O, this.baseClass = b, this.getActualType = a, this.upcast = o0, this.downcast = h0, this.pureVirtualFunctions = [];
        }
        var dr = (Y, N, x)=>{
            for(; N !== x;)N.upcast || k1(`Expected null or instance of ${x.name}, got an instance of ${N.name}`), Y = N.upcast(Y), N = N.baseClass;
            return Y;
        };
        function vl(Y, N) {
            if (N === null) return this.isReference && k1(`null is not a valid ${this.name}`), 0;
            N.$$ || k1(`Cannot pass "${r3(N)}" as a ${this.name}`), N.$$.ptr || k1(`Cannot pass deleted object as a pointer of type ${this.name}`);
            var x = N.$$.ptrType.registeredClass, O = dr(N.$$.ptr, x, this.registeredClass);
            return O;
        }
        function _l(Y, N) {
            var x;
            if (N === null) return this.isReference && k1(`null is not a valid ${this.name}`), this.isSmartPointer ? (x = this.rawConstructor(), Y !== null && Y.push(this.rawDestructor, x), x) : 0;
            (!N || !N.$$) && k1(`Cannot pass "${r3(N)}" as a ${this.name}`), N.$$.ptr || k1(`Cannot pass deleted object as a pointer of type ${this.name}`), !this.isConst && N.$$.ptrType.isConst && k1(`Cannot convert argument of type ${N.$$.smartPtrType ? N.$$.smartPtrType.name : N.$$.ptrType.name} to parameter type ${this.name}`);
            var O = N.$$.ptrType.registeredClass;
            if (x = dr(N.$$.ptr, O, this.registeredClass), this.isSmartPointer) switch(N.$$.smartPtr === void 0 && k1("Passing raw pointer to smart pointer is illegal"), this.sharingPolicy){
                case 0:
                    N.$$.smartPtrType === this ? x = N.$$.smartPtr : k1(`Cannot convert argument of type ${N.$$.smartPtrType ? N.$$.smartPtrType.name : N.$$.ptrType.name} to parameter type ${this.name}`);
                    break;
                case 1:
                    x = N.$$.smartPtr;
                    break;
                case 2:
                    if (N.$$.smartPtrType === this) x = N.$$.smartPtr;
                    else {
                        var b = N.clone();
                        x = this.rawShare(x, V4.toHandle(()=>b.delete())), Y !== null && Y.push(this.rawDestructor, x);
                    }
                    break;
                default:
                    k1("Unsupporting sharing policy");
            }
            return x;
        }
        function Bl(Y, N) {
            if (N === null) return this.isReference && k1(`null is not a valid ${this.name}`), 0;
            N.$$ || k1(`Cannot pass "${r3(N)}" as a ${this.name}`), N.$$.ptr || k1(`Cannot pass deleted object as a pointer of type ${this.name}`), N.$$.ptrType.isConst && k1(`Cannot convert argument of type ${N.$$.ptrType.name} to parameter type ${this.name}`);
            var x = N.$$.ptrType.registeredClass, O = dr(N.$$.ptr, x, this.registeredClass);
            return O;
        }
        var ml = ()=>{
            Object.assign(ne.prototype, {
                getPointee (Y) {
                    return this.rawGetPointee && (Y = this.rawGetPointee(Y)), Y;
                },
                destructor (Y) {
                    var N;
                    (N = this.rawDestructor) == null || N.call(this, Y);
                },
                argPackAdvance: L4,
                readValueFromPointer: P6,
                fromWireType: tl
            });
        };
        function ne(Y, N, x, O, b, a, o0, h0, u0, U0, L0) {
            this.name = Y, this.registeredClass = N, this.isReference = x, this.isConst = O, this.isSmartPointer = b, this.pointeeType = a, this.sharingPolicy = o0, this.rawGetPointee = h0, this.rawConstructor = u0, this.rawShare = U0, this.rawDestructor = L0, !b && N.baseClass === void 0 ? O ? (this.toWireType = vl, this.destructorFunction = null) : (this.toWireType = Bl, this.destructorFunction = null) : this.toWireType = _l;
        }
        var qk = (Y, N, x)=>{
            K.hasOwnProperty(Y) || Ae("Replacing nonexistent public symbol"), K[Y].overloadTable !== void 0 && x !== void 0 ? K[Y].overloadTable[x] = N : (K[Y] = N, K[Y].argCount = x);
        }, Zl = (Y, N, x)=>{
            Y = Y.replace(/p/g, "i");
            var O = K["dynCall_" + Y];
            return O(N, ...x);
        }, te = [], $k, ak = (Y)=>{
            var N = te[Y];
            return N || (Y >= te.length && (te.length = Y + 1), te[Y] = N = $k.get(Y)), N;
        }, Gl = (Y, N, x = [])=>{
            if (Y.includes("j")) return Zl(Y, N, x);
            var O = ak(N)(...x);
            return O;
        }, Wl = (Y, N)=>(...x)=>Gl(Y, N, x), u8 = (Y, N)=>{
            Y = n4(Y);
            function x() {
                return Y.includes("j") ? Wl(Y, N) : ak(N);
            }
            var O = x();
            return typeof O != "function" && k1(`unknown function pointer with signature ${Y}: ${N}`), O;
        }, Xl = (Y, N)=>{
            var x = b6(N, function(O) {
                this.name = N, this.message = O;
                var b = new Error(O).stack;
                b !== void 0 && (this.stack = this.toString() + `
` + b.replace(/^Error(:[^\n]*)?\n/, ""));
            });
            return x.prototype = Object.create(Y.prototype), x.prototype.constructor = x, x.prototype.toString = function() {
                return this.message === void 0 ? this.name : `${this.name}: ${this.message}`;
            }, x;
        }, bk, dk = (Y)=>{
            var N = Rs(Y), x = n4(N);
            return E8(N), x;
        }, ck = (Y, N)=>{
            var x = [], O = {};
            function b(a) {
                if (!O[a] && !O8[a]) {
                    if (re[a]) {
                        re[a].forEach(b);
                        return;
                    }
                    x.push(a), O[a] = !0;
                }
            }
            throw N.forEach(b), new bk(`${Y}: ` + x.map(dk).join([
                ", "
            ]));
        }, pl = (Y, N, x, O, b, a, o0, h0, u0, U0, L0, _2, u2)=>{
            L0 = n4(L0), a = u8(b, a), h0 && (h0 = u8(o0, h0)), U0 && (U0 = u8(u0, U0)), u2 = u8(_2, u2);
            var o2 = hl(L0);
            br(o2, function() {
                ck(`Cannot construct ${L0} due to unbound types`, [
                    O
                ]);
            }), Kr([
                Y,
                N,
                x
            ], O ? [
                O
            ] : [], (c0)=>{
                var R2, o;
                c0 = c0[0];
                var J2, o1;
                O ? (J2 = c0.registeredClass, o1 = J2.instancePrototype) : o1 = ke.prototype;
                var I2 = b6(L0, function(...Q) {
                    if (Object.getPrototypeOf(this) !== z) throw new L6("Use 'new' to construct " + L0);
                    if (A2.constructor_body === void 0) throw new L6(L0 + " has no accessible constructor");
                    var i = A2.constructor_body[Q.length];
                    if (i === void 0) throw new L6(`Tried to invoke ctor of ${L0} with invalid number of parameters (${Q.length}) - expected (${Object.keys(A2.constructor_body).toString()}) parameters instead!`);
                    return i.apply(this, Q);
                }), z = Object.create(o1, {
                    constructor: {
                        value: I2
                    }
                });
                I2.prototype = z;
                var A2 = new wl(L0, I2, z, u2, J2, a, h0, U0);
                A2.baseClass && ((o = (R2 = A2.baseClass).__derivedClasses) != null || (R2.__derivedClasses = []), A2.baseClass.__derivedClasses.push(A2));
                var Q1 = new ne(L0, A2, !0, !1, !1), q2 = new ne(L0 + "*", A2, !1, !1, !1), b2 = new ne(L0 + " const*", A2, !1, !0, !1);
                return Kk[Y] = {
                    pointerType: q2,
                    constPointerType: b2
                }, qk(o2, I2), [
                    Q1,
                    q2,
                    b2
                ];
            });
        }, cr = [], l8 = [], i3 = (Y)=>{
            Y > 9 && --l8[Y + 1] === 0 && (l8[Y] = void 0, cr.push(Y));
        }, Ql = ()=>l8.length / 2 - 5 - cr.length, Cl = ()=>{
            l8.push(0, 1, void 0, 1, null, 1, !0, 1, !1, 1), K.count_emval_handles = Ql;
        }, V4 = {
            toValue: (Y)=>(Y || k1("Cannot use deleted val. handle = " + Y), l8[Y]),
            toHandle: (Y)=>{
                switch(Y){
                    case void 0:
                        return 2;
                    case null:
                        return 4;
                    case !0:
                        return 6;
                    case !1:
                        return 8;
                    default:
                        {
                            const N = cr.pop() || l8.length;
                            return l8[N] = Y, l8[N + 1] = 1, N;
                        }
                }
            }
        }, Vl = {
            name: "emscripten::val",
            fromWireType: (Y)=>{
                var N = V4.toValue(Y);
                return i3(Y), N;
            },
            toWireType: (Y, N)=>V4.toHandle(N),
            argPackAdvance: L4,
            readValueFromPointer: P6,
            destructorFunction: null
        }, yl = (Y)=>P4(Y, Vl), Il = (Y, N, x)=>{
            switch(N){
                case 1:
                    return x ? function(O) {
                        return this.fromWireType(M1[O]);
                    } : function(O) {
                        return this.fromWireType(f4[O]);
                    };
                case 2:
                    return x ? function(O) {
                        return this.fromWireType(t8[O >> 1]);
                    } : function(O) {
                        return this.fromWireType(S6[O >> 1]);
                    };
                case 4:
                    return x ? function(O) {
                        return this.fromWireType(F2[O >> 2]);
                    } : function(O) {
                        return this.fromWireType(d2[O >> 2]);
                    };
                default:
                    throw new TypeError(`invalid integer width (${N}): ${Y}`);
            }
        }, Fl = (Y, N, x, O)=>{
            N = n4(N);
            function b() {}
            b.values = {}, P4(Y, {
                name: N,
                constructor: b,
                fromWireType: function(a) {
                    return this.constructor.values[a];
                },
                toWireType: (a, o0)=>o0.value,
                argPackAdvance: L4,
                readValueFromPointer: Il(N, x, O),
                destructorFunction: null
            }), br(N, b);
        }, e3 = (Y, N)=>{
            var x = O8[Y];
            return x === void 0 && k1(`${N} has unknown type ${dk(Y)}`), x;
        }, Yl = (Y, N, x)=>{
            var O = e3(Y, "enum");
            N = n4(N);
            var b = O.constructor, a = Object.create(O.constructor.prototype, {
                value: {
                    value: x
                },
                constructor: {
                    value: b6(`${O.name}_${N}`, function() {})
                }
            });
            b.values[x] = a, b[N] = a;
        }, r3 = (Y)=>{
            if (Y === null) return "null";
            var N = typeof Y;
            return N === "object" || N === "array" || N === "function" ? Y.toString() : "" + Y;
        }, El = (Y, N)=>{
            switch(N){
                case 4:
                    return function(x) {
                        return this.fromWireType(Jk[x >> 2]);
                    };
                case 8:
                    return function(x) {
                        return this.fromWireType(Rk[x >> 3]);
                    };
                default:
                    throw new TypeError(`invalid float width (${N}): ${Y}`);
            }
        }, gl = (Y, N, x)=>{
            N = n4(N), P4(Y, {
                name: N,
                fromWireType: (O)=>O,
                toWireType: (O, b)=>b,
                argPackAdvance: L4,
                readValueFromPointer: El(N, x),
                destructorFunction: null
            });
        };
        function Jl(Y) {
            for(var N = 1; N < Y.length; ++N)if (Y[N] !== null && Y[N].destructorFunction === void 0) return !0;
            return !1;
        }
        function Rl(Y, N, x, O, b, a) {
            var o0 = N.length;
            o0 < 2 && k1("argTypes array size mismatch! Must at least get return value and 'this' types!");
            var h0 = N[1] !== null && x !== null, u0 = Jl(N), U0 = N[0].name !== "void", L0 = o0 - 2, _2 = new Array(L0), u2 = [], o2 = [], c0 = function(...J2) {
                J2.length !== L0 && k1(`function ${Y} called with ${J2.length} arguments, expected ${L0}`), o2.length = 0;
                var o1;
                u2.length = h0 ? 2 : 1, u2[0] = b, h0 && (o1 = N[1].toWireType(o2, this), u2[1] = o1);
                for(var I2 = 0; I2 < L0; ++I2)_2[I2] = N[I2 + 2].toWireType(o2, J2[I2]), u2.push(_2[I2]);
                var z = O(...u2);
                function A2(Q1) {
                    if (u0) Lr(o2);
                    else for(var q2 = h0 ? 1 : 2; q2 < N.length; q2++){
                        var b2 = q2 === 1 ? o1 : _2[q2 - 2];
                        N[q2].destructorFunction !== null && N[q2].destructorFunction(b2);
                    }
                    if (U0) return N[0].fromWireType(Q1);
                }
                return A2(z);
            };
            return b6(Y, c0);
        }
        var Nl = (Y, N)=>{
            for(var x = [], O = 0; O < Y; O++)x.push(d2[N + O * 4 >> 2]);
            return x;
        }, Dl = (Y)=>{
            Y = Y.trim();
            const N = Y.indexOf("(");
            return N !== -1 ? Y.substr(0, N) : Y;
        }, Ml = (Y, N, x, O, b, a, o0)=>{
            var h0 = Nl(N, x);
            Y = n4(Y), Y = Dl(Y), b = u8(O, b), br(Y, function() {
                ck(`Cannot call ${Y} due to unbound types`, h0);
            }, N - 1), Kr([], h0, (u0)=>{
                var U0 = [
                    u0[0],
                    null
                ].concat(u0.slice(1));
                return qk(Y, Rl(Y, U0, null, b, a, o0), N - 1), [];
            });
        }, Ul = (Y, N, x)=>{
            switch(N){
                case 1:
                    return x ? (O)=>M1[O] : (O)=>f4[O];
                case 2:
                    return x ? (O)=>t8[O >> 1] : (O)=>S6[O >> 1];
                case 4:
                    return x ? (O)=>F2[O >> 2] : (O)=>d2[O >> 2];
                default:
                    throw new TypeError(`invalid integer width (${N}): ${Y}`);
            }
        }, Hl = (Y, N, x, O, b)=>{
            N = n4(N), b === -1 && (b = 4294967295);
            var a = (L0)=>L0;
            if (O === 0) {
                var o0 = 32 - 8 * x;
                a = (L0)=>L0 << o0 >>> o0;
            }
            var h0 = N.includes("unsigned"), u0 = (L0, _2)=>{}, U0;
            h0 ? U0 = function(L0, _2) {
                return u0(_2, this.name), _2 >>> 0;
            } : U0 = function(L0, _2) {
                return u0(_2, this.name), _2;
            }, P4(Y, {
                name: N,
                fromWireType: a,
                toWireType: U0,
                argPackAdvance: L4,
                readValueFromPointer: Ul(N, x, O !== 0),
                destructorFunction: null
            });
        }, xl = (Y, N, x)=>{
            var O = [
                Int8Array,
                Uint8Array,
                Int16Array,
                Uint16Array,
                Int32Array,
                Uint32Array,
                Float32Array,
                Float64Array
            ], b = O[N];
            function a(o0) {
                var h0 = d2[o0 >> 2], u0 = d2[o0 + 4 >> 2];
                return new b(M1.buffer, u0, h0);
            }
            x = n4(x), P4(Y, {
                name: x,
                fromWireType: a,
                argPackAdvance: L4,
                readValueFromPointer: a
            }, {
                ignoreDuplicateRegistrations: !0
            });
        }, zl = (Y, N, x)=>Or(Y, f4, N, x), Tl = (Y, N)=>{
            N = n4(N);
            var x = N === "std::string";
            P4(Y, {
                name: N,
                fromWireType (O) {
                    var b = d2[O >> 2], a = O + 4, o0;
                    if (x) for(var h0 = a, u0 = 0; u0 <= b; ++u0){
                        var U0 = a + u0;
                        if (u0 == b || f4[U0] == 0) {
                            var L0 = U0 - h0, _2 = j8(h0, L0);
                            o0 === void 0 ? o0 = _2 : (o0 += "\0", o0 += _2), h0 = U0 + 1;
                        }
                    }
                    else {
                        for(var u2 = new Array(b), u0 = 0; u0 < b; ++u0)u2[u0] = String.fromCharCode(f4[a + u0]);
                        o0 = u2.join("");
                    }
                    return E8(O), o0;
                },
                toWireType (O, b) {
                    b instanceof ArrayBuffer && (b = new Uint8Array(b));
                    var a, o0 = typeof b == "string";
                    o0 || b instanceof Uint8Array || b instanceof Uint8ClampedArray || b instanceof Int8Array || k1("Cannot pass non-string to std::string"), x && o0 ? a = jr(b) : a = b.length;
                    var h0 = f7(4 + a + 1), u0 = h0 + 4;
                    if (d2[h0 >> 2] = a, x && o0) zl(b, u0, a + 1);
                    else if (o0) for(var U0 = 0; U0 < a; ++U0){
                        var L0 = b.charCodeAt(U0);
                        L0 > 255 && (E8(u0), k1("String has UTF-16 code units that do not fit in 8 bits")), f4[u0 + U0] = L0;
                    }
                    else for(var U0 = 0; U0 < a; ++U0)f4[u0 + U0] = b[U0];
                    return O !== null && O.push(E8, h0), h0;
                },
                argPackAdvance: L4,
                readValueFromPointer: P6,
                destructorFunction (O) {
                    E8(O);
                }
            });
        }, i7 = typeof TextDecoder != "undefined" ? new TextDecoder("utf-16le") : void 0, Sl = (Y, N)=>{
            for(var x = Y, O = x >> 1, b = O + N / 2; !(O >= b) && S6[O];)++O;
            if (x = O << 1, x - Y > 32 && i7) return i7.decode(f4.subarray(Y, x));
            for(var a = "", o0 = 0; !(o0 >= N / 2); ++o0){
                var h0 = t8[Y + o0 * 2 >> 1];
                if (h0 == 0) break;
                a += String.fromCharCode(h0);
            }
            return a;
        }, jl = (Y, N, x)=>{
            if (x != null || (x = 2147483647), x < 2) return 0;
            x -= 2;
            for(var O = N, b = x < Y.length * 2 ? x / 2 : Y.length, a = 0; a < b; ++a){
                var o0 = Y.charCodeAt(a);
                t8[N >> 1] = o0, N += 2;
            }
            return t8[N >> 1] = 0, N - O;
        }, Ol = (Y)=>Y.length * 2, Pl = (Y, N)=>{
            for(var x = 0, O = ""; !(x >= N / 4);){
                var b = F2[Y + x * 4 >> 2];
                if (b == 0) break;
                if (++x, b >= 65536) {
                    var a = b - 65536;
                    O += String.fromCharCode(55296 | a >> 10, 56320 | a & 1023);
                } else O += String.fromCharCode(b);
            }
            return O;
        }, Ll = (Y, N, x)=>{
            if (x != null || (x = 2147483647), x < 4) return 0;
            for(var O = N, b = O + x - 4, a = 0; a < Y.length; ++a){
                var o0 = Y.charCodeAt(a);
                if (o0 >= 55296 && o0 <= 57343) {
                    var h0 = Y.charCodeAt(++a);
                    o0 = 65536 + ((o0 & 1023) << 10) | h0 & 1023;
                }
                if (F2[N >> 2] = o0, N += 4, N + 4 > b) break;
            }
            return F2[N >> 2] = 0, N - O;
        }, Kl = (Y)=>{
            for(var N = 0, x = 0; x < Y.length; ++x){
                var O = Y.charCodeAt(x);
                O >= 55296 && O <= 57343 && ++x, N += 4;
            }
            return N;
        }, ql = (Y, N, x)=>{
            x = n4(x);
            var O, b, a, o0;
            N === 2 ? (O = Sl, b = jl, o0 = Ol, a = (h0)=>S6[h0 >> 1]) : N === 4 && (O = Pl, b = Ll, o0 = Kl, a = (h0)=>d2[h0 >> 2]), P4(Y, {
                name: x,
                fromWireType: (h0)=>{
                    for(var u0 = d2[h0 >> 2], U0, L0 = h0 + 4, _2 = 0; _2 <= u0; ++_2){
                        var u2 = h0 + 4 + _2 * N;
                        if (_2 == u0 || a(u2) == 0) {
                            var o2 = u2 - L0, c0 = O(L0, o2);
                            U0 === void 0 ? U0 = c0 : (U0 += "\0", U0 += c0), L0 = u2 + N;
                        }
                    }
                    return E8(h0), U0;
                },
                toWireType: (h0, u0)=>{
                    typeof u0 != "string" && k1(`Cannot pass non-string to C++ string type ${x}`);
                    var U0 = o0(u0), L0 = f7(4 + U0 + N);
                    return d2[L0 >> 2] = U0 / N, b(u0, L0 + 4, U0 + N), h0 !== null && h0.push(E8, L0), L0;
                },
                argPackAdvance: L4,
                readValueFromPointer: P6,
                destructorFunction (h0) {
                    E8(h0);
                }
            });
        }, $l = (Y, N, x, O, b, a)=>{
            ee[Y] = {
                name: n4(N),
                rawConstructor: u8(x, O),
                rawDestructor: u8(b, a),
                fields: []
            };
        }, al = (Y, N, x, O, b, a, o0, h0, u0, U0)=>{
            ee[Y].fields.push({
                fieldName: n4(N),
                getterReturnType: x,
                getter: u8(O, b),
                getterContext: a,
                setterArgumentType: o0,
                setter: u8(h0, u0),
                setterContext: U0
            });
        }, bl = (Y, N)=>{
            N = n4(N), P4(Y, {
                isVoid: !0,
                name: N,
                argPackAdvance: 0,
                fromWireType: ()=>{},
                toWireType: (x, O)=>{}
            });
        }, dl = (Y, N, x)=>f4.copyWithin(Y, N, N + x), cl = {}, e7 = (Y)=>{
            var N = cl[Y];
            return N === void 0 ? n4(Y) : N;
        }, A3 = [], is = (Y, N, x, O, b)=>(Y = A3[Y], N = V4.toValue(N), x = e7(x), Y(N, N[x], O, b)), es = (Y)=>{
            var N = A3.length;
            return A3.push(Y), N;
        }, rs = (Y, N)=>{
            for(var x = new Array(Y), O = 0; O < Y; ++O)x[O] = e3(d2[N + O * 4 >> 2], "parameter " + O);
            return x;
        }, As = Reflect.construct, fs = (Y, N, x)=>{
            var O = [], b = Y.toWireType(O, x);
            return O.length && (d2[N >> 2] = V4.toHandle(O)), b;
        }, ks = (Y, N, x)=>{
            var O = rs(Y, N), b = O.shift();
            Y--;
            var a = new Array(Y), o0 = (u0, U0, L0, _2)=>{
                for(var u2 = 0, o2 = 0; o2 < Y; ++o2)a[o2] = O[o2].readValueFromPointer(_2 + u2), u2 += O[o2].argPackAdvance;
                var c0 = x === 1 ? As(U0, a) : U0.apply(u0, a);
                return fs(b, L0, c0);
            }, h0 = `methodCaller<(${O.map((u0)=>u0.name).join(", ")}) => ${b.name}>`;
            return es(b6(h0, o0));
        }, ns = (Y)=>{
            Y > 9 && (l8[Y + 1] += 1);
        }, ts = ()=>V4.toHandle([]), os = (Y)=>V4.toHandle(e7(Y)), us = ()=>V4.toHandle({}), ls = (Y)=>{
            var N = V4.toValue(Y);
            Lr(N), i3(Y);
        }, ss = (Y, N, x)=>{
            Y = V4.toValue(Y), N = V4.toValue(N), x = V4.toValue(x), Y[N] = x;
        }, hs = (Y, N)=>{
            Y = e3(Y, "_emval_take_value");
            var x = Y.readValueFromPointer(N);
            return V4.toHandle(x);
        }, ws = ()=>2147483648, vs = (Y)=>{
            var N = ai.buffer, x = (Y - N.byteLength + 65535) / 65536;
            try {
                return ai.grow(x), Nk(), 1;
            } catch (e) {}
        }, _s = (Y)=>{
            var N = f4.length;
            Y >>>= 0;
            var x = ws();
            if (Y > x) return !1;
            for(var O = (u0, U0)=>u0 + (U0 - u0 % U0) % U0, b = 1; b <= 4; b *= 2){
                var a = N * (1 + .2 / b);
                a = Math.min(a, Y + 100663296);
                var o0 = Math.min(x, O(Math.max(Y, a), 65536)), h0 = vs(o0);
                if (h0) return !0;
            }
            return !1;
        }, f3 = {}, Bs = ()=>Nr || "./this.program", d6 = ()=>{
            if (!d6.strings) {
                var Y = (typeof navigator == "object" && navigator.languages && navigator.languages[0] || "C").replace("-", "_") + ".UTF-8", N = {
                    USER: "web_user",
                    LOGNAME: "web_user",
                    PATH: "/",
                    PWD: "/",
                    HOME: "/home/web_user",
                    LANG: Y,
                    _: Bs()
                };
                for(var x in f3)f3[x] === void 0 ? delete N[x] : N[x] = f3[x];
                var O = [];
                for(var x in N)O.push(`${x}=${N[x]}`);
                d6.strings = O;
            }
            return d6.strings;
        }, ms = (Y, N)=>{
            for(var x = 0; x < Y.length; ++x)M1[N++] = Y.charCodeAt(x);
            M1[N] = 0;
        }, Zs = (Y, N)=>{
            var x = 0;
            return d6().forEach((O, b)=>{
                var a = N + x;
                d2[Y + b * 4 >> 2] = a, ms(O, a), x += O.length + 1;
            }), 0;
        }, Gs = (Y, N)=>{
            var x = d6();
            d2[Y >> 2] = x.length;
            var O = 0;
            return x.forEach((b)=>O += b.length + 1), d2[N >> 2] = O, 0;
        };
        function Ws(Y) {
            try {
                var N = k4.getStreamFromFD(Y);
                return d.close(N), 0;
            } catch (x) {
                if (typeof d == "undefined" || x.name !== "ErrnoError") throw x;
                return x.errno;
            }
        }
        var Xs = (Y, N, x, O)=>{
            for(var b = 0, a = 0; a < x; a++){
                var o0 = d2[N >> 2], h0 = d2[N + 4 >> 2];
                N += 8;
                var u0 = d.read(Y, M1, o0, h0, O);
                if (u0 < 0) return -1;
                if (b += u0, u0 < h0) break;
                typeof O != "undefined" && (O += u0);
            }
            return b;
        };
        function ps(Y, N, x, O) {
            try {
                var b = k4.getStreamFromFD(Y), a = Xs(b, N, x);
                return d2[O >> 2] = a, 0;
            } catch (o0) {
                if (typeof d == "undefined" || o0.name !== "ErrnoError") throw o0;
                return o0.errno;
            }
        }
        var Qs = (Y, N)=>N + 2097152 >>> 0 < 4194305 - !!Y ? (Y >>> 0) + N * 4294967296 : NaN;
        function Cs(Y, N, x, O, b) {
            var a = Qs(N, x);
            try {
                if (isNaN(a)) return 61;
                var o0 = k4.getStreamFromFD(Y);
                return d.llseek(o0, a, O), O1 = [
                    o0.position >>> 0,
                    (a2 = o0.position, +Math.abs(a2) >= 1 ? a2 > 0 ? +Math.floor(a2 / 4294967296) >>> 0 : ~~+Math.ceil((a2 - +(~~a2 >>> 0)) / 4294967296) >>> 0 : 0)
                ], F2[b >> 2] = O1[0], F2[b + 4 >> 2] = O1[1], o0.getdents && a === 0 && O === 0 && (o0.getdents = null), 0;
            } catch (h0) {
                if (typeof d == "undefined" || h0.name !== "ErrnoError") throw h0;
                return h0.errno;
            }
        }
        var Vs = (Y, N, x, O)=>{
            for(var b = 0, a = 0; a < x; a++){
                var o0 = d2[N >> 2], h0 = d2[N + 4 >> 2];
                N += 8;
                var u0 = d.write(Y, M1, o0, h0, O);
                if (u0 < 0) return -1;
                b += u0, typeof O != "undefined" && (O += u0);
            }
            return b;
        };
        function ys(Y, N, x, O) {
            try {
                var b = k4.getStreamFromFD(Y), a = Vs(b, N, x);
                return d2[O >> 2] = a, 0;
            } catch (o0) {
                if (typeof d == "undefined" || o0.name !== "ErrnoError") throw o0;
                return o0.errno;
            }
        }
        var oe = (Y)=>Y % 4 === 0 && (Y % 100 !== 0 || Y % 400 === 0), Is = (Y, N)=>{
            for(var x = 0, O = 0; O <= N; x += Y[O++]);
            return x;
        }, r7 = [
            31,
            29,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ], A7 = [
            31,
            28,
            31,
            30,
            31,
            30,
            31,
            31,
            30,
            31,
            30,
            31
        ], Fs = (Y, N)=>{
            for(var x = new Date(Y.getTime()); N > 0;){
                var O = oe(x.getFullYear()), b = x.getMonth(), a = (O ? r7 : A7)[b];
                if (N > a - x.getDate()) N -= a - x.getDate() + 1, x.setDate(1), b < 11 ? x.setMonth(b + 1) : (x.setMonth(0), x.setFullYear(x.getFullYear() + 1));
                else return x.setDate(x.getDate() + N), x;
            }
            return x;
        }, Ys = (Y, N)=>{
            M1.set(Y, N);
        }, Es = (Y, N, x, O)=>{
            var b = d2[O + 40 >> 2], a = {
                tm_sec: F2[O >> 2],
                tm_min: F2[O + 4 >> 2],
                tm_hour: F2[O + 8 >> 2],
                tm_mday: F2[O + 12 >> 2],
                tm_mon: F2[O + 16 >> 2],
                tm_year: F2[O + 20 >> 2],
                tm_wday: F2[O + 24 >> 2],
                tm_yday: F2[O + 28 >> 2],
                tm_isdst: F2[O + 32 >> 2],
                tm_gmtoff: F2[O + 36 >> 2],
                tm_zone: b ? j8(b) : ""
            }, o0 = j8(x), h0 = {
                "%c": "%a %b %d %H:%M:%S %Y",
                "%D": "%m/%d/%y",
                "%F": "%Y-%m-%d",
                "%h": "%b",
                "%r": "%I:%M:%S %p",
                "%R": "%H:%M",
                "%T": "%H:%M:%S",
                "%x": "%m/%d/%y",
                "%X": "%H:%M:%S",
                "%Ec": "%c",
                "%EC": "%C",
                "%Ex": "%m/%d/%y",
                "%EX": "%H:%M:%S",
                "%Ey": "%y",
                "%EY": "%Y",
                "%Od": "%d",
                "%Oe": "%e",
                "%OH": "%H",
                "%OI": "%I",
                "%Om": "%m",
                "%OM": "%M",
                "%OS": "%S",
                "%Ou": "%u",
                "%OU": "%U",
                "%OV": "%V",
                "%Ow": "%w",
                "%OW": "%W",
                "%Oy": "%y"
            };
            for(var u0 in h0)o0 = o0.replace(new RegExp(u0, "g"), h0[u0]);
            var U0 = [
                "Sunday",
                "Monday",
                "Tuesday",
                "Wednesday",
                "Thursday",
                "Friday",
                "Saturday"
            ], L0 = [
                "January",
                "February",
                "March",
                "April",
                "May",
                "June",
                "July",
                "August",
                "September",
                "October",
                "November",
                "December"
            ];
            function _2(z, A2, Q1) {
                for(var q2 = typeof z == "number" ? z.toString() : z || ""; q2.length < A2;)q2 = Q1[0] + q2;
                return q2;
            }
            function u2(z, A2) {
                return _2(z, A2, "0");
            }
            function o2(z, A2) {
                function Q1(b2) {
                    return b2 < 0 ? -1 : b2 > 0 ? 1 : 0;
                }
                var q2;
                return (q2 = Q1(z.getFullYear() - A2.getFullYear())) === 0 && (q2 = Q1(z.getMonth() - A2.getMonth())) === 0 && (q2 = Q1(z.getDate() - A2.getDate())), q2;
            }
            function c0(z) {
                switch(z.getDay()){
                    case 0:
                        return new Date(z.getFullYear() - 1, 11, 29);
                    case 1:
                        return z;
                    case 2:
                        return new Date(z.getFullYear(), 0, 3);
                    case 3:
                        return new Date(z.getFullYear(), 0, 2);
                    case 4:
                        return new Date(z.getFullYear(), 0, 1);
                    case 5:
                        return new Date(z.getFullYear() - 1, 11, 31);
                    case 6:
                        return new Date(z.getFullYear() - 1, 11, 30);
                }
            }
            function J2(z) {
                var A2 = Fs(new Date(z.tm_year + 1900, 0, 1), z.tm_yday), Q1 = new Date(A2.getFullYear(), 0, 4), q2 = new Date(A2.getFullYear() + 1, 0, 4), b2 = c0(Q1), R2 = c0(q2);
                return o2(b2, A2) <= 0 ? o2(R2, A2) <= 0 ? A2.getFullYear() + 1 : A2.getFullYear() : A2.getFullYear() - 1;
            }
            var o1 = {
                "%a": (z)=>U0[z.tm_wday].substring(0, 3),
                "%A": (z)=>U0[z.tm_wday],
                "%b": (z)=>L0[z.tm_mon].substring(0, 3),
                "%B": (z)=>L0[z.tm_mon],
                "%C": (z)=>{
                    var A2 = z.tm_year + 1900;
                    return u2(A2 / 100 | 0, 2);
                },
                "%d": (z)=>u2(z.tm_mday, 2),
                "%e": (z)=>_2(z.tm_mday, 2, " "),
                "%g": (z)=>J2(z).toString().substring(2),
                "%G": J2,
                "%H": (z)=>u2(z.tm_hour, 2),
                "%I": (z)=>{
                    var A2 = z.tm_hour;
                    return A2 == 0 ? A2 = 12 : A2 > 12 && (A2 -= 12), u2(A2, 2);
                },
                "%j": (z)=>u2(z.tm_mday + Is(oe(z.tm_year + 1900) ? r7 : A7, z.tm_mon - 1), 3),
                "%m": (z)=>u2(z.tm_mon + 1, 2),
                "%M": (z)=>u2(z.tm_min, 2),
                "%n": ()=>`
`,
                "%p": (z)=>z.tm_hour >= 0 && z.tm_hour < 12 ? "AM" : "PM",
                "%S": (z)=>u2(z.tm_sec, 2),
                "%t": ()=>"	",
                "%u": (z)=>z.tm_wday || 7,
                "%U": (z)=>{
                    var A2 = z.tm_yday + 7 - z.tm_wday;
                    return u2(Math.floor(A2 / 7), 2);
                },
                "%V": (z)=>{
                    var A2 = Math.floor((z.tm_yday + 7 - (z.tm_wday + 6) % 7) / 7);
                    if ((z.tm_wday + 371 - z.tm_yday - 2) % 7 <= 2 && A2++, A2) {
                        if (A2 == 53) {
                            var q2 = (z.tm_wday + 371 - z.tm_yday) % 7;
                            q2 != 4 && (q2 != 3 || !oe(z.tm_year)) && (A2 = 1);
                        }
                    } else {
                        A2 = 52;
                        var Q1 = (z.tm_wday + 7 - z.tm_yday - 1) % 7;
                        (Q1 == 4 || Q1 == 5 && oe(z.tm_year % 400 - 1)) && A2++;
                    }
                    return u2(A2, 2);
                },
                "%w": (z)=>z.tm_wday,
                "%W": (z)=>{
                    var A2 = z.tm_yday + 7 - (z.tm_wday + 6) % 7;
                    return u2(Math.floor(A2 / 7), 2);
                },
                "%y": (z)=>(z.tm_year + 1900).toString().substring(2),
                "%Y": (z)=>z.tm_year + 1900,
                "%z": (z)=>{
                    var A2 = z.tm_gmtoff, Q1 = A2 >= 0;
                    return A2 = Math.abs(A2) / 60, A2 = A2 / 60 * 100 + A2 % 60, (Q1 ? "+" : "-") + ("0000" + A2).slice(-4);
                },
                "%Z": (z)=>z.tm_zone,
                "%%": ()=>"%"
            };
            o0 = o0.replace(/%%/g, "\0\0");
            for(var u0 in o1)o0.includes(u0) && (o0 = o0.replace(new RegExp(u0, "g"), o1[u0](a)));
            o0 = o0.replace(/\0\0/g, "%");
            var I2 = ie(o0, !1);
            return I2.length > N ? 0 : (Ys(I2, Y), I2.length - 1);
        }, gs = (Y, N, x, O, b)=>Es(Y, N, x, O);
        d.createPreloadedFile = Tu, d.staticInit(), Sk = K.InternalError = class extends Error {
            constructor(N){
                super(N), this.name = "InternalError";
            }
        }, au(), L6 = K.BindingError = class extends Error {
            constructor(N){
                super(N), this.name = "BindingError";
            }
        }, ol(), fl(), ml(), bk = K.UnboundTypeError = Xl(Error, "UnboundTypeError"), Cl();
        var Js = {
            b: gu,
            p: Nu,
            r: ju,
            B: Ou,
            F: Pu,
            E: Lu,
            C: Ku,
            w: qu,
            z: $u,
            K: du,
            m: pl,
            J: yl,
            j: Fl,
            a: Yl,
            v: gl,
            f: Ml,
            i: Hl,
            e: xl,
            u: Tl,
            o: ql,
            x: $l,
            l: al,
            L: bl,
            I: dl,
            N: is,
            c: i3,
            O: ks,
            P: ns,
            q: ts,
            h: os,
            k: us,
            M: ls,
            g: ss,
            d: hs,
            D: _s,
            G: Zs,
            H: Gs,
            s: Ws,
            t: ps,
            y: Cs,
            n: ys,
            A: gs
        }, A0 = Eu(), yD = A0.R, ID = K._memcpy = A0.S, FD = K._heif_color_conversion_options_set_defaults = A0.U, f7 = K._malloc = A0.V, YD = K._heif_nclx_color_profile_set_color_primaries = A0.W, E8 = K._free = A0.X, ED = K._heif_nclx_color_profile_set_transfer_characteristics = A0.Y, gD = K._heif_nclx_color_profile_set_matrix_coefficients = A0.Z, JD = K._heif_init = A0._, RD = K._heif_deinit = A0.$, ND = K._heif_load_plugin = A0.aa, DD = K._heif_unload_plugin = A0.ba, MD = K._heif_load_plugins = A0.ca, UD = K._heif_get_plugin_directories = A0.da, HD = K._heif_free_plugin_directories = A0.ea, xD = K._heif_get_version = A0.fa, zD = K._heif_get_version_number = A0.ga, TD = K._heif_get_version_number_major = A0.ha, SD = K._heif_get_version_number_minor = A0.ia, jD = K._heif_get_version_number_maintenance = A0.ja, OD = K._heif_check_filetype = A0.ka, PD = K._heif_read_main_brand = A0.la, LD = K._heif_has_compatible_filetype = A0.ma, KD = K._heif_list_compatible_brands = A0.na, qD = K._heif_free_list_of_compatible_brands = A0.oa, $D = K._heif_check_jpeg_filetype = A0.pa, aD = K._heif_main_brand = A0.qa, bD = K._heif_fourcc_to_brand = A0.ra, dD = K._heif_read_minor_version_brand = A0.sa, cD = K._heif_brand_to_fourcc = A0.ta, iM = K._heif_has_compatible_brand = A0.ua, eM = K._heif_get_global_security_limits = A0.va, rM = K._heif_get_file_mime_type = A0.wa, AM = K._heif_get_disabled_security_limits = A0.xa, fM = K._heif_context_get_security_limits = A0.ya, kM = K._heif_context_set_security_limits = A0.za, nM = K._heif_context_alloc = A0.Aa, tM = K._heif_context_free = A0.Ba, oM = K._heif_context_read_from_file = A0.Ca, uM = K._heif_context_read_from_memory = A0.Da, lM = K._heif_context_read_from_memory_without_copy = A0.Ea, sM = K._heif_context_read_from_reader = A0.Fa, hM = K._heif_context_debug_dump_boxes_to_file = A0.Ga, wM = K._heif_context_get_primary_image_handle = A0.Ha, vM = K._heif_context_get_primary_image_ID = A0.Ia, _M = K._heif_context_is_top_level_image_ID = A0.Ja, BM = K._heif_context_get_number_of_top_level_images = A0.Ka, mM = K._heif_context_get_list_of_top_level_image_IDs = A0.La, ZM = K._heif_context_get_image_handle = A0.Ma, GM = K._heif_image_handle_is_primary_image = A0.Na, WM = K._heif_image_handle_get_item_id = A0.Oa, XM = K._heif_image_handle_get_number_of_thumbnails = A0.Pa, pM = K._heif_image_handle_get_list_of_thumbnail_IDs = A0.Qa, QM = K._heif_image_handle_get_thumbnail = A0.Ra, CM = K._heif_image_handle_get_number_of_auxiliary_images = A0.Sa, VM = K._heif_image_handle_get_list_of_auxiliary_image_IDs = A0.Ta, yM = K._heif_image_handle_get_auxiliary_type = A0.Ua, IM = K._heif_image_handle_release_auxiliary_type = A0.Va, FM = K._heif_image_handle_free_auxiliary_types = A0.Wa, YM = K._heif_image_handle_get_auxiliary_image_handle = A0.Xa, EM = K._heif_image_handle_get_width = A0.Ya, gM = K._heif_image_handle_get_height = A0.Za, JM = K._heif_image_handle_get_ispe_width = A0._a, RM = K._heif_image_handle_get_ispe_height = A0.$a, NM = K._heif_image_handle_get_context = A0.ab, DM = K._heif_image_handle_get_image_tiling = A0.bb, MM = K._heif_image_handle_get_grid_image_tile_id = A0.cb, UM = K._heif_context_get_entity_groups = A0.db, HM = K._heif_entity_groups_release = A0.eb, xM = K._heif_image_handle_get_preferred_decoding_colorspace = A0.fb, zM = K._heif_image_handle_has_alpha_channel = A0.gb, TM = K._heif_image_handle_is_premultiplied_alpha = A0.hb, SM = K._heif_image_handle_get_luma_bits_per_pixel = A0.ib, jM = K._heif_image_handle_get_chroma_bits_per_pixel = A0.jb, OM = K._heif_image_handle_has_depth_image = A0.kb, PM = K._heif_depth_representation_info_free = A0.lb, LM = K._heif_image_handle_get_depth_image_representation_info = A0.mb, KM = K._heif_image_handle_get_number_of_depth_images = A0.nb, qM = K._heif_image_handle_get_list_of_depth_image_IDs = A0.ob, $M = K._heif_image_handle_get_depth_image_handle = A0.pb, aM = K._heif_decoding_options_alloc = A0.qb, bM = K._heif_decoding_options_free = A0.rb, dM = K._heif_decode_image = A0.sb, cM = K._heif_image_handle_decode_image_tile = A0.tb, iU = K._heif_image_create = A0.ub, eU = K._heif_image_get_decoding_warnings = A0.vb, rU = K._heif_image_add_decoding_warning = A0.wb, AU = K._heif_image_has_content_light_level = A0.xb, fU = K._heif_image_get_content_light_level = A0.yb, kU = K._heif_image_handle_get_content_light_level = A0.zb, nU = K._heif_image_set_content_light_level = A0.Ab, tU = K._heif_image_has_mastering_display_colour_volume = A0.Bb, oU = K._heif_image_get_mastering_display_colour_volume = A0.Cb, uU = K._heif_image_handle_get_mastering_display_colour_volume = A0.Db, lU = K._heif_image_set_mastering_display_colour_volume = A0.Eb, sU = K._heif_mastering_display_colour_volume_decode = A0.Fb, hU = K._heif_image_get_pixel_aspect_ratio = A0.Gb, wU = K._heif_image_handle_get_pixel_aspect_ratio = A0.Hb, vU = K._heif_image_set_pixel_aspect_ratio = A0.Ib, _U = K._heif_image_release = A0.Jb, BU = K._heif_image_handle_release = A0.Kb, mU = K._heif_image_get_colorspace = A0.Lb, ZU = K._heif_image_get_chroma_format = A0.Mb, GU = K._heif_image_get_width = A0.Nb, WU = K._heif_image_get_height = A0.Ob, XU = K._heif_image_get_primary_width = A0.Pb, pU = K._heif_image_get_primary_height = A0.Qb, QU = K._heif_image_crop = A0.Rb, CU = K._heif_image_get_bits_per_pixel = A0.Sb, VU = K._heif_image_get_bits_per_pixel_range = A0.Tb, yU = K._heif_image_has_channel = A0.Ub, IU = K._heif_image_add_plane = A0.Vb, FU = K._heif_image_get_plane_readonly = A0.Wb, YU = K._heif_image_get_plane = A0.Xb, EU = K._heif_image_set_premultiplied_alpha = A0.Yb, gU = K._heif_image_is_premultiplied_alpha = A0.Zb, JU = K._heif_image_extend_padding_to_size = A0._b, RU = K._heif_image_scale_image = A0.$b, NU = K._heif_image_extend_to_size_fill_with_zero = A0.ac, DU = K._heif_image_set_raw_color_profile = A0.bc, MU = K._heif_image_set_nclx_color_profile = A0.cc, UU = K._heif_image_handle_get_number_of_metadata_blocks = A0.dc, HU = K._heif_image_handle_get_list_of_metadata_block_IDs = A0.ec, xU = K._heif_image_handle_get_metadata_type = A0.fc, zU = K._heif_image_handle_get_metadata_content_type = A0.gc, TU = K._heif_image_handle_get_metadata_item_uri_type = A0.hc, SU = K._heif_image_handle_get_metadata_size = A0.ic, jU = K._heif_image_handle_get_metadata = A0.jc, OU = K._heif_image_handle_get_color_profile_type = A0.kc, PU = K._heif_image_handle_get_raw_color_profile_size = A0.lc, LU = K._heif_image_handle_get_nclx_color_profile = A0.mc, KU = K._heif_image_handle_get_raw_color_profile = A0.nc, qU = K._heif_image_get_color_profile_type = A0.oc, $U = K._heif_image_get_raw_color_profile_size = A0.pc, aU = K._heif_image_get_raw_color_profile = A0.qc, bU = K._heif_image_get_nclx_color_profile = A0.rc, dU = K._heif_nclx_color_profile_alloc = A0.sc, cU = K._heif_nclx_color_profile_free = A0.tc, iH = K._heif_image_handle_has_camera_intrinsic_matrix = A0.uc, eH = K._heif_image_handle_get_camera_intrinsic_matrix = A0.vc, rH = K._heif_image_handle_has_camera_extrinsic_matrix = A0.wc, AH = K._heif_image_handle_get_camera_extrinsic_matrix = A0.xc, fH = K._heif_camera_extrinsic_matrix_release = A0.yc, kH = K._heif_camera_extrinsic_matrix_get_rotation_matrix = A0.zc, nH = K._heif_register_decoder = A0.Ac, tH = K._heif_register_decoder_plugin = A0.Bc, oH = K._heif_register_encoder_plugin = A0.Cc, uH = K._heif_context_write_to_file = A0.Dc, lH = K._heif_context_write = A0.Ec, sH = K._heif_context_add_compatible_brand = A0.Fc, hH = K._heif_context_get_encoder_descriptors = A0.Gc, wH = K._heif_get_encoder_descriptors = A0.Hc, vH = K._heif_encoder_descriptor_get_name = A0.Ic, _H = K._heif_encoder_descriptor_get_id_name = A0.Jc, BH = K._heif_get_decoder_descriptors = A0.Kc, mH = K._heif_decoder_descriptor_get_name = A0.Lc, ZH = K._heif_decoder_descriptor_get_id_name = A0.Mc, GH = K._heif_encoder_descriptor_get_compression_format = A0.Nc, WH = K._heif_encoder_descriptor_supports_lossy_compression = A0.Oc, XH = K._heif_encoder_descriptor_supports_lossless_compression = A0.Pc, pH = K._heif_encoder_descriptor_supportes_lossy_compression = A0.Qc, QH = K._heif_encoder_descriptor_supportes_lossless_compression = A0.Rc, CH = K._heif_encoder_get_name = A0.Sc, VH = K._heif_context_get_encoder = A0.Tc, yH = K._heif_have_decoder_for_format = A0.Uc, IH = K._heif_have_encoder_for_format = A0.Vc, FH = K._heif_context_get_encoder_for_format = A0.Wc, YH = K._heif_encoder_release = A0.Xc, EH = K._heif_encoder_set_lossy_quality = A0.Yc, gH = K._heif_encoder_set_lossless = A0.Zc, JH = K._heif_encoder_set_logging_level = A0._c, RH = K._heif_encoder_list_parameters = A0.$c, NH = K._heif_encoder_parameter_get_name = A0.ad, DH = K._heif_encoder_parameter_get_type = A0.bd, MH = K._heif_encoder_set_parameter_integer = A0.cd, UH = K._heif_encoder_parameter_get_valid_integer_values = A0.dd, HH = K._heif_encoder_get_parameter_integer = A0.ed, xH = K._heif_encoder_parameter_get_valid_integer_range = A0.fd, zH = K._heif_encoder_parameter_get_valid_string_values = A0.gd, TH = K._heif_encoder_parameter_integer_valid_range = A0.hd, SH = K._heif_encoder_set_parameter_boolean = A0.id, jH = K._heif_encoder_get_parameter_boolean = A0.jd, OH = K._heif_encoder_set_parameter_string = A0.kd, PH = K._heif_encoder_get_parameter_string = A0.ld, LH = K._heif_encoder_parameter_string_valid_values = A0.md, KH = K._heif_encoder_parameter_integer_valid_values = A0.nd, qH = K._heif_encoder_set_parameter = A0.od, $H = K._heif_encoder_get_parameter = A0.pd, aH = K._heif_encoder_has_default = A0.qd, bH = K._heif_encoding_options_alloc = A0.rd, dH = K._heif_encoding_options_free = A0.sd, cH = K._heif_context_encode_image = A0.td, ix = K._heif_context_encode_grid = A0.ud, ex = K._heif_context_add_grid_image = A0.vd, rx = K._heif_context_add_overlay_image = A0.wd, Ax = K._heif_context_add_image_tile = A0.xd, fx = K._heif_context_assign_thumbnail = A0.yd, kx = K._heif_context_encode_thumbnail = A0.zd, nx = K._heif_context_set_primary_image = A0.Ad, tx = K._heif_context_add_exif_metadata = A0.Bd, ox = K._heif_context_add_XMP_metadata = A0.Cd, ux = K._heif_context_add_XMP_metadata2 = A0.Dd, lx = K._heif_context_add_generic_metadata = A0.Ed, sx = K._heif_context_add_generic_uri_metadata = A0.Fd, hx = K._heif_context_set_maximum_image_size_limit = A0.Gd, wx = K._heif_context_set_max_decoding_threads = A0.Hd, vx = K._heif_image_handle_get_number_of_region_items = A0.Id, _x = K._heif_image_handle_get_list_of_region_item_ids = A0.Jd, Bx = K._heif_context_get_region_item = A0.Kd, mx = K._heif_region_item_get_id = A0.Ld, Zx = K._heif_region_item_release = A0.Md, Gx = K._heif_region_item_get_reference_size = A0.Nd, Wx = K._heif_region_item_get_number_of_regions = A0.Od, Xx = K._heif_region_item_get_list_of_regions = A0.Pd, px = K._heif_image_handle_add_region_item = A0.Qd, Qx = K._heif_region_item_add_region_point = A0.Rd, Cx = K._heif_region_item_add_region_rectangle = A0.Sd, Vx = K._heif_region_item_add_region_ellipse = A0.Td, yx = K._heif_region_item_add_region_polygon = A0.Ud, Ix = K._heif_region_item_add_region_polyline = A0.Vd, Fx = K._heif_region_item_add_region_referenced_mask = A0.Wd, Yx = K._heif_region_item_add_region_inline_mask_data = A0.Xd, Ex = K._heif_region_item_add_region_inline_mask = A0.Yd, gx = K._heif_region_release = A0.Zd, Jx = K._heif_region_release_many = A0._d, Rx = K._heif_region_get_type = A0.$d, Nx = K._heif_region_get_point = A0.ae, Dx = K._heif_region_get_point_transformed = A0.be, Mx = K._heif_region_get_rectangle = A0.ce, Ux = K._heif_region_get_rectangle_transformed = A0.de, Hx = K._heif_region_get_ellipse = A0.ee, xx = K._heif_region_get_ellipse_transformed = A0.fe, zx = K._heif_region_get_polygon_num_points = A0.ge, Tx = K._heif_region_get_polyline_num_points = A0.he, Sx = K._heif_region_get_polygon_points = A0.ie, jx = K._heif_region_get_polyline_points = A0.je, Ox = K._heif_region_get_polygon_points_transformed = A0.ke, Px = K._heif_region_get_polyline_points_transformed = A0.le, Lx = K._heif_region_get_referenced_mask_ID = A0.me, Kx = K._heif_region_get_inline_mask_data_len = A0.ne, qx = K._heif_region_get_inline_mask_data = A0.oe, $x = K._heif_region_get_mask_image = A0.pe, ax = K._heif_item_get_properties_of_type = A0.qe, bx = K._heif_item_get_transformation_properties = A0.re, dx = K._heif_item_get_property_type = A0.se, cx = K._heif_item_get_property_user_description = A0.te, iz = K._heif_item_add_property_user_description = A0.ue, ez = K._heif_item_get_property_transform_mirror = A0.ve, rz = K._heif_item_get_property_transform_rotation_ccw = A0.we, Az = K._heif_item_get_property_transform_crop_borders = A0.xe, fz = K._heif_property_user_description_release = A0.ye, kz = K._heif_item_add_raw_property = A0.ze, nz = K._heif_item_get_property_raw_size = A0.Ae, tz = K._heif_item_get_property_raw_data = A0.Be, oz = K._heif_item_get_property_uuid_type = A0.Ce, uz = K._heif_context_get_number_of_items = A0.De, lz = K._heif_context_get_list_of_item_IDs = A0.Ee, sz = K._heif_item_get_item_type = A0.Fe, hz = K._heif_item_is_item_hidden = A0.Ge, wz = K._heif_item_get_mime_item_content_type = A0.He, vz = K._heif_item_get_mime_item_content_encoding = A0.Ie, _z = K._heif_item_get_uri_item_uri_type = A0.Je, Bz = K._heif_item_get_item_name = A0.Ke, mz = K._heif_item_get_item_data = A0.Le, Zz = K._heif_release_item_data = A0.Me, Gz = K._heif_context_get_item_references = A0.Ne, Wz = K._heif_release_item_references = A0.Oe, Xz = K._heif_context_add_item = A0.Pe, pz = K._heif_context_add_mime_item = A0.Qe, Qz = K._heif_context_add_precompressed_mime_item = A0.Re, Cz = K._heif_context_add_uri_item = A0.Se, Vz = K._heif_context_add_item_reference = A0.Te, yz = K._heif_context_add_item_references = A0.Ue, Iz = K._heif_item_set_item_name = A0.Ve, Fz = K._de265_get_version = A0.We, Yz = K._de265_init = A0.Xe, Ez = K._de265_free = A0.Ye, gz = K._de265_new_decoder = A0.Ze, Jz = K._de265_set_parameter_bool = A0._e, Rz = K._de265_free_decoder = A0.$e, Nz = K._de265_push_NAL = A0.af, Dz = K._de265_flush_data = A0.bf, Mz = K._de265_decode = A0.cf, Uz = K._de265_get_next_picture = A0.df, Hz = K._de265_get_chroma_format = A0.ef, xz = K._de265_get_image_width = A0.ff, zz = K._de265_get_image_height = A0.gf, Tz = K._de265_get_bits_per_pixel = A0.hf, Sz = K._de265_get_image_plane = A0.jf, jz = K._de265_get_image_colour_primaries = A0.kf, Oz = K._de265_get_image_transfer_characteristics = A0.lf, Pz = K._de265_get_image_matrix_coefficients = A0.mf, Lz = K._de265_get_image_full_range_flag = A0.nf, Kz = K._de265_release_next_picture = A0.of, Rs = A0.pf, Ns = A0.qf, qz = K.dynCall_ji = A0.rf, $z = K.dynCall_iij = A0.sf, az = K.dynCall_jijj = A0.tf, bz = K.dynCall_vijj = A0.uf, dz = K.dynCall_jiji = A0.vf, cz = K.dynCall_viijii = A0.wf, iT = K.dynCall_iiiiij = A0.xf, eT = K.dynCall_iiiiijj = A0.yf, rT = K.dynCall_iiiiiijj = A0.zf, AT = K._heif_error_ok = 80028, fT = K._heif_error_success = 79460, kT = K._heif_error_invalid_parameter_value = 80052, nT = K._heif_error_unsupported_parameter = 80040, ue;
        j6 = function Y() {
            ue || k7(), ue || (j6 = Y);
        };
        function k7() {
            if (S8 > 0 || (Zu(), S8 > 0)) return;
            function Y() {
                ue || (ue = !0, K.calledRun = !0, !gk && (Gu(), yk(K), K.onRuntimeInitialized && K.onRuntimeInitialized(), Wu()));
            }
            K.setStatus ? (K.setStatus("Running..."), setTimeout(function() {
                setTimeout(function() {
                    K.setStatus("");
                }, 1), Y();
            }, 1)) : Y();
        }
        if (K.preInit) for(typeof K.preInit == "function" && (K.preInit = [
            K.preInit
        ]); K.preInit.length > 0;)K.preInit.pop()();
        k7();
        function n7(Y) {
            for(var N = new ArrayBuffer(Y.length), x = new Uint8Array(N), O = 0, b = Y.length; O < b; O++)x[O] = Y.charCodeAt(O);
            return N;
        }
        var g8 = function(Y) {
            this.handle = Y, this.img = null;
        };
        g8.prototype.free = function() {
            this.handle && (K.heif_image_handle_release(this.handle), this.handle = null);
        }, g8.prototype._ensureImage = function() {
            if (!this.img) {
                var Y = K.heif_js_decode_image(this.handle, K.heif_colorspace.heif_colorspace_YCbCr, K.heif_chroma.heif_chroma_420);
                if (!Y || Y.code) {
                    console.log("Decoding image failed", this.handle, Y);
                    return;
                }
                this.data = new Uint8Array(n7(Y.data)), delete Y.data, this.img = Y, Y.alpha !== void 0 && (this.alpha = new Uint8Array(n7(Y.alpha)), delete Y.alpha);
            }
        }, g8.prototype.get_width = function() {
            return K.heif_image_handle_get_width(this.handle);
        }, g8.prototype.get_height = function() {
            return K.heif_image_handle_get_height(this.handle);
        }, g8.prototype.is_primary = function() {
            return !!heif_image_handle_is_primary_image(this.handle);
        }, g8.prototype.display = function(Y, N) {
            var x = this.get_width(), O = this.get_height();
            setTimeout((function() {
                if (!this.img) {
                    var b = K.heif_js_decode_image2(this.handle, K.heif_colorspace.heif_colorspace_RGB, K.heif_chroma.heif_chroma_interleaved_RGBA);
                    if (!b || b.code) {
                        console.log("Decoding image failed", this.handle, b), N(null);
                        return;
                    }
                    for (let a of b.channels)if (a.id == K.heif_channel.heif_channel_interleaved) {
                        if (a.stride == a.width * 4) Y.data.set(a.data);
                        else for(let o0 = 0; o0 < a.height; o0++){
                            let h0 = a.data.slice(o0 * a.stride, o0 * a.stride + a.width * 4), u0 = o0 * a.width * 4;
                            Y.data.set(h0, u0);
                        }
                    }
                    K.heif_image_release(b.image);
                }
                N(Y);
            }).bind(this), 0);
        };
        var t7 = function() {
            this.decoder = null;
        };
        t7.prototype.decode = function(Y) {
            if (this.decoder && K.heif_context_free(this.decoder), this.decoder = K.heif_context_alloc(), !this.decoder) return console.log("Could not create HEIF context"), [];
            var N = K.heif_context_read_from_memory(this.decoder, Y);
            if (N.code !== K.heif_error_code.heif_error_Ok) return console.log("Could not parse HEIF file", N.message), [];
            var x = K.heif_js_context_get_list_of_top_level_image_IDs(this.decoder);
            if (!x || x.code) return console.log("Error loading image ids", x), [];
            if (!x.length) return console.log("No images found"), [];
            for(var O = [], b = 0; b < x.length; b++){
                var a = K.heif_js_context_get_image_handle(this.decoder, x[b]);
                if (!a || a.code) {
                    console.log("Could not get image data for id", x[b], a);
                    continue;
                }
                O.push(new g8(a));
            }
            return O;
        };
        var Ds = function(Y) {
            return Y.charCodeAt(0) << 24 | Y.charCodeAt(1) << 16 | Y.charCodeAt(2) << 8 | Y.charCodeAt(3);
        };
        K.HeifImage = g8, K.HeifDecoder = t7, K.fourcc = Ds;
        const Ms = [
            "heif_error_code",
            "heif_suberror_code",
            "heif_compression_format",
            "heif_chroma",
            "heif_colorspace",
            "heif_channel"
        ];
        for (const Y of Ms)for(const N in K[Y])!K[Y].hasOwnProperty(N) || N === "values" || (K[N] = K[Y][N]);
        for(const Y in K)Y.indexOf("_heif_") !== 0 || K[Y.slice(1)] !== void 0 || (K[Y.slice(1)] = K[Y]);
        return Vk = K, Vk;
    };
})();
module.exports = $a38dd11793775bea$var$libheif;

});
parcelRegister("5Nzmz", function(module, exports) {
// 'path' module extracted from Node.js v8.11.1 (only the posix part)
// transplited with Babel
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
function $438cf5bd496bd527$var$assertPath(path) {
    if (typeof path !== 'string') throw new TypeError('Path must be a string. Received ' + JSON.stringify(path));
}
// Resolves . and .. elements in a path with directory names
function $438cf5bd496bd527$var$normalizeStringPosix(path, allowAboveRoot) {
    var res = '';
    var lastSegmentLength = 0;
    var lastSlash = -1;
    var dots = 0;
    var code;
    for(var i = 0; i <= path.length; ++i){
        if (i < path.length) code = path.charCodeAt(i);
        else if (code === 47 /*/*/ ) break;
        else code = 47 /*/*/ ;
        if (code === 47 /*/*/ ) {
            if (lastSlash === i - 1 || dots === 1) ;
            else if (lastSlash !== i - 1 && dots === 2) {
                if (res.length < 2 || lastSegmentLength !== 2 || res.charCodeAt(res.length - 1) !== 46 /*.*/  || res.charCodeAt(res.length - 2) !== 46 /*.*/ ) {
                    if (res.length > 2) {
                        var lastSlashIndex = res.lastIndexOf('/');
                        if (lastSlashIndex !== res.length - 1) {
                            if (lastSlashIndex === -1) {
                                res = '';
                                lastSegmentLength = 0;
                            } else {
                                res = res.slice(0, lastSlashIndex);
                                lastSegmentLength = res.length - 1 - res.lastIndexOf('/');
                            }
                            lastSlash = i;
                            dots = 0;
                            continue;
                        }
                    } else if (res.length === 2 || res.length === 1) {
                        res = '';
                        lastSegmentLength = 0;
                        lastSlash = i;
                        dots = 0;
                        continue;
                    }
                }
                if (allowAboveRoot) {
                    if (res.length > 0) res += '/..';
                    else res = '..';
                    lastSegmentLength = 2;
                }
            } else {
                if (res.length > 0) res += '/' + path.slice(lastSlash + 1, i);
                else res = path.slice(lastSlash + 1, i);
                lastSegmentLength = i - lastSlash - 1;
            }
            lastSlash = i;
            dots = 0;
        } else if (code === 46 /*.*/  && dots !== -1) ++dots;
        else dots = -1;
    }
    return res;
}
function $438cf5bd496bd527$var$_format(sep, pathObject) {
    var dir = pathObject.dir || pathObject.root;
    var base = pathObject.base || (pathObject.name || '') + (pathObject.ext || '');
    if (!dir) return base;
    if (dir === pathObject.root) return dir + base;
    return dir + sep + base;
}
var $438cf5bd496bd527$var$posix = {
    // path.resolve([from ...], to)
    resolve: function resolve() {
        var resolvedPath = '';
        var resolvedAbsolute = false;
        var cwd;
        for(var i = arguments.length - 1; i >= -1 && !resolvedAbsolute; i--){
            var path;
            if (i >= 0) path = arguments[i];
            else {
                if (cwd === undefined) cwd = $5XqL3.cwd();
                path = cwd;
            }
            $438cf5bd496bd527$var$assertPath(path);
            // Skip empty entries
            if (path.length === 0) continue;
            resolvedPath = path + '/' + resolvedPath;
            resolvedAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        }
        // At this point the path should be resolved to a full absolute path, but
        // handle relative paths to be safe (might happen when process.cwd() fails)
        // Normalize the path
        resolvedPath = $438cf5bd496bd527$var$normalizeStringPosix(resolvedPath, !resolvedAbsolute);
        if (resolvedAbsolute) {
            if (resolvedPath.length > 0) return '/' + resolvedPath;
            else return '/';
        } else if (resolvedPath.length > 0) return resolvedPath;
        else return '.';
    },
    normalize: function normalize(path) {
        $438cf5bd496bd527$var$assertPath(path);
        if (path.length === 0) return '.';
        var isAbsolute = path.charCodeAt(0) === 47 /*/*/ ;
        var trailingSeparator = path.charCodeAt(path.length - 1) === 47 /*/*/ ;
        // Normalize the path
        path = $438cf5bd496bd527$var$normalizeStringPosix(path, !isAbsolute);
        if (path.length === 0 && !isAbsolute) path = '.';
        if (path.length > 0 && trailingSeparator) path += '/';
        if (isAbsolute) return '/' + path;
        return path;
    },
    isAbsolute: function isAbsolute(path) {
        $438cf5bd496bd527$var$assertPath(path);
        return path.length > 0 && path.charCodeAt(0) === 47 /*/*/ ;
    },
    join: function join() {
        if (arguments.length === 0) return '.';
        var joined;
        for(var i = 0; i < arguments.length; ++i){
            var arg = arguments[i];
            $438cf5bd496bd527$var$assertPath(arg);
            if (arg.length > 0) {
                if (joined === undefined) joined = arg;
                else joined += '/' + arg;
            }
        }
        if (joined === undefined) return '.';
        return $438cf5bd496bd527$var$posix.normalize(joined);
    },
    relative: function relative(from, to) {
        $438cf5bd496bd527$var$assertPath(from);
        $438cf5bd496bd527$var$assertPath(to);
        if (from === to) return '';
        from = $438cf5bd496bd527$var$posix.resolve(from);
        to = $438cf5bd496bd527$var$posix.resolve(to);
        if (from === to) return '';
        // Trim any leading backslashes
        var fromStart = 1;
        for(; fromStart < from.length; ++fromStart){
            if (from.charCodeAt(fromStart) !== 47 /*/*/ ) break;
        }
        var fromEnd = from.length;
        var fromLen = fromEnd - fromStart;
        // Trim any leading backslashes
        var toStart = 1;
        for(; toStart < to.length; ++toStart){
            if (to.charCodeAt(toStart) !== 47 /*/*/ ) break;
        }
        var toEnd = to.length;
        var toLen = toEnd - toStart;
        // Compare paths to find the longest common path from root
        var length = fromLen < toLen ? fromLen : toLen;
        var lastCommonSep = -1;
        var i = 0;
        for(; i <= length; ++i){
            if (i === length) {
                if (toLen > length) {
                    if (to.charCodeAt(toStart + i) === 47 /*/*/ ) // We get here if `from` is the exact base path for `to`.
                    // For example: from='/foo/bar'; to='/foo/bar/baz'
                    return to.slice(toStart + i + 1);
                    else if (i === 0) // We get here if `from` is the root
                    // For example: from='/'; to='/foo'
                    return to.slice(toStart + i);
                } else if (fromLen > length) {
                    if (from.charCodeAt(fromStart + i) === 47 /*/*/ ) // We get here if `to` is the exact base path for `from`.
                    // For example: from='/foo/bar/baz'; to='/foo/bar'
                    lastCommonSep = i;
                    else if (i === 0) // We get here if `to` is the root.
                    // For example: from='/foo'; to='/'
                    lastCommonSep = 0;
                }
                break;
            }
            var fromCode = from.charCodeAt(fromStart + i);
            var toCode = to.charCodeAt(toStart + i);
            if (fromCode !== toCode) break;
            else if (fromCode === 47 /*/*/ ) lastCommonSep = i;
        }
        var out = '';
        // Generate the relative path based on the path difference between `to`
        // and `from`
        for(i = fromStart + lastCommonSep + 1; i <= fromEnd; ++i)if (i === fromEnd || from.charCodeAt(i) === 47 /*/*/ ) {
            if (out.length === 0) out += '..';
            else out += '/..';
        }
        // Lastly, append the rest of the destination (`to`) path that comes after
        // the common path parts
        if (out.length > 0) return out + to.slice(toStart + lastCommonSep);
        else {
            toStart += lastCommonSep;
            if (to.charCodeAt(toStart) === 47 /*/*/ ) ++toStart;
            return to.slice(toStart);
        }
    },
    _makeLong: function _makeLong(path) {
        return path;
    },
    dirname: function dirname(path) {
        $438cf5bd496bd527$var$assertPath(path);
        if (path.length === 0) return '.';
        var code = path.charCodeAt(0);
        var hasRoot = code === 47 /*/*/ ;
        var end = -1;
        var matchedSlash = true;
        for(var i = path.length - 1; i >= 1; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                if (!matchedSlash) {
                    end = i;
                    break;
                }
            } else // We saw the first non-path separator
            matchedSlash = false;
        }
        if (end === -1) return hasRoot ? '/' : '.';
        if (hasRoot && end === 1) return '//';
        return path.slice(0, end);
    },
    basename: function basename(path, ext) {
        if (ext !== undefined && typeof ext !== 'string') throw new TypeError('"ext" argument must be a string');
        $438cf5bd496bd527$var$assertPath(path);
        var start = 0;
        var end = -1;
        var matchedSlash = true;
        var i;
        if (ext !== undefined && ext.length > 0 && ext.length <= path.length) {
            if (ext.length === path.length && ext === path) return '';
            var extIdx = ext.length - 1;
            var firstNonSlashEnd = -1;
            for(i = path.length - 1; i >= 0; --i){
                var code = path.charCodeAt(i);
                if (code === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else {
                    if (firstNonSlashEnd === -1) {
                        // We saw the first non-path separator, remember this index in case
                        // we need it if the extension ends up not matching
                        matchedSlash = false;
                        firstNonSlashEnd = i + 1;
                    }
                    if (extIdx >= 0) {
                        // Try to match the explicit extension
                        if (code === ext.charCodeAt(extIdx)) {
                            if (--extIdx === -1) // We matched the extension, so mark this as the end of our path
                            // component
                            end = i;
                        } else {
                            // Extension does not match, so our result is the entire path
                            // component
                            extIdx = -1;
                            end = firstNonSlashEnd;
                        }
                    }
                }
            }
            if (start === end) end = firstNonSlashEnd;
            else if (end === -1) end = path.length;
            return path.slice(start, end);
        } else {
            for(i = path.length - 1; i >= 0; --i){
                if (path.charCodeAt(i) === 47 /*/*/ ) // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                {
                    if (!matchedSlash) {
                        start = i + 1;
                        break;
                    }
                } else if (end === -1) {
                    // We saw the first non-path separator, mark this as the end of our
                    // path component
                    matchedSlash = false;
                    end = i + 1;
                }
            }
            if (end === -1) return '';
            return path.slice(start, end);
        }
    },
    extname: function extname(path) {
        $438cf5bd496bd527$var$assertPath(path);
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        for(var i = path.length - 1; i >= 0; --i){
            var code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) return '';
        return path.slice(startDot, end);
    },
    format: function format(pathObject) {
        if (pathObject === null || typeof pathObject !== 'object') throw new TypeError('The "pathObject" argument must be of type Object. Received type ' + typeof pathObject);
        return $438cf5bd496bd527$var$_format('/', pathObject);
    },
    parse: function parse(path) {
        $438cf5bd496bd527$var$assertPath(path);
        var ret = {
            root: '',
            dir: '',
            base: '',
            ext: '',
            name: ''
        };
        if (path.length === 0) return ret;
        var code = path.charCodeAt(0);
        var isAbsolute = code === 47 /*/*/ ;
        var start;
        if (isAbsolute) {
            ret.root = '/';
            start = 1;
        } else start = 0;
        var startDot = -1;
        var startPart = 0;
        var end = -1;
        var matchedSlash = true;
        var i = path.length - 1;
        // Track the state of characters (if any) we see before our first dot and
        // after any path separator we find
        var preDotState = 0;
        // Get non-dir info
        for(; i >= start; --i){
            code = path.charCodeAt(i);
            if (code === 47 /*/*/ ) {
                // If we reached a path separator that was not part of a set of path
                // separators at the end of the string, stop now
                if (!matchedSlash) {
                    startPart = i + 1;
                    break;
                }
                continue;
            }
            if (end === -1) {
                // We saw the first non-path separator, mark this as the end of our
                // extension
                matchedSlash = false;
                end = i + 1;
            }
            if (code === 46 /*.*/ ) {
                // If this is our first dot, mark it as the start of our extension
                if (startDot === -1) startDot = i;
                else if (preDotState !== 1) preDotState = 1;
            } else if (startDot !== -1) // We saw a non-dot and non-path separator before our dot, so we should
            // have a good chance at having a non-empty extension
            preDotState = -1;
        }
        if (startDot === -1 || end === -1 || // We saw a non-dot character immediately before the dot
        preDotState === 0 || // The (right-most) trimmed path component is exactly '..'
        preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
            if (end !== -1) {
                if (startPart === 0 && isAbsolute) ret.base = ret.name = path.slice(1, end);
                else ret.base = ret.name = path.slice(startPart, end);
            }
        } else {
            if (startPart === 0 && isAbsolute) {
                ret.name = path.slice(1, startDot);
                ret.base = path.slice(1, end);
            } else {
                ret.name = path.slice(startPart, startDot);
                ret.base = path.slice(startPart, end);
            }
            ret.ext = path.slice(startDot, end);
        }
        if (startPart > 0) ret.dir = path.slice(0, startPart - 1);
        else if (isAbsolute) ret.dir = '/';
        return ret;
    },
    sep: '/',
    delimiter: ':',
    win32: null,
    posix: null
};
$438cf5bd496bd527$var$posix.posix = $438cf5bd496bd527$var$posix;
module.exports = $438cf5bd496bd527$var$posix;

});

parcelRegister("6AGM7", function(module, exports) {

$parcel$export(module.exports, "randomBytes", function () { return $4cc749234b8b2947$export$5f828d93ff035aa8; }, function (v) { return $4cc749234b8b2947$export$5f828d93ff035aa8 = v; });
$parcel$export(module.exports, "rng", function () { return $4cc749234b8b2947$export$cd94982b18c6332c; }, function (v) { return $4cc749234b8b2947$export$cd94982b18c6332c = v; });
$parcel$export(module.exports, "pseudoRandomBytes", function () { return $4cc749234b8b2947$export$1d518568e4f529b0; }, function (v) { return $4cc749234b8b2947$export$1d518568e4f529b0 = v; });
$parcel$export(module.exports, "prng", function () { return $4cc749234b8b2947$export$5285b6d41c912b41; }, function (v) { return $4cc749234b8b2947$export$5285b6d41c912b41 = v; });
$parcel$export(module.exports, "createHash", function () { return $4cc749234b8b2947$export$2fb37efbf6ae0c0e; }, function (v) { return $4cc749234b8b2947$export$2fb37efbf6ae0c0e = v; });
$parcel$export(module.exports, "Hash", function () { return $4cc749234b8b2947$export$ab85ecd77ce6a5cd; }, function (v) { return $4cc749234b8b2947$export$ab85ecd77ce6a5cd = v; });
$parcel$export(module.exports, "createHmac", function () { return $4cc749234b8b2947$export$da39cf97e1eb7c91; }, function (v) { return $4cc749234b8b2947$export$da39cf97e1eb7c91 = v; });
$parcel$export(module.exports, "Hmac", function () { return $4cc749234b8b2947$export$52a9039d7177394f; }, function (v) { return $4cc749234b8b2947$export$52a9039d7177394f = v; });
$parcel$export(module.exports, "getHashes", function () { return $4cc749234b8b2947$export$f7201db400317331; }, function (v) { return $4cc749234b8b2947$export$f7201db400317331 = v; });
$parcel$export(module.exports, "pbkdf2", function () { return $4cc749234b8b2947$export$448fa22aedc9dbca; }, function (v) { return $4cc749234b8b2947$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $4cc749234b8b2947$export$b80c7ba289c8fa56; }, function (v) { return $4cc749234b8b2947$export$b80c7ba289c8fa56 = v; });
$parcel$export(module.exports, "Cipher", function () { return $4cc749234b8b2947$export$26e5786e8ac8e530; }, function (v) { return $4cc749234b8b2947$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipher", function () { return $4cc749234b8b2947$export$bdd223f16383713e; }, function (v) { return $4cc749234b8b2947$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $4cc749234b8b2947$export$20533d26f07f1ee0; }, function (v) { return $4cc749234b8b2947$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $4cc749234b8b2947$export$2f64596b8cbf08b4; }, function (v) { return $4cc749234b8b2947$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Decipher", function () { return $4cc749234b8b2947$export$2ce6d8d0e8b04e1a; }, function (v) { return $4cc749234b8b2947$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipher", function () { return $4cc749234b8b2947$export$12ada9414fbc594c; }, function (v) { return $4cc749234b8b2947$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $4cc749234b8b2947$export$f5e7e39d57cd9700; }, function (v) { return $4cc749234b8b2947$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $4cc749234b8b2947$export$36b6d6ef312eab39; }, function (v) { return $4cc749234b8b2947$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $4cc749234b8b2947$export$58a258485f1e49f6; }, function (v) { return $4cc749234b8b2947$export$58a258485f1e49f6 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $4cc749234b8b2947$export$dedd8dc3dc62b370; }, function (v) { return $4cc749234b8b2947$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $4cc749234b8b2947$export$971862a2fcb1bb40; }, function (v) { return $4cc749234b8b2947$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $4cc749234b8b2947$export$c6ff6a88acbeaf40; }, function (v) { return $4cc749234b8b2947$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $4cc749234b8b2947$export$fdc27893e98845cc; }, function (v) { return $4cc749234b8b2947$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $4cc749234b8b2947$export$6671fb9a1323bed; }, function (v) { return $4cc749234b8b2947$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $4cc749234b8b2947$export$d74daf141a551db; }, function (v) { return $4cc749234b8b2947$export$d74daf141a551db = v; });
$parcel$export(module.exports, "createSign", function () { return $4cc749234b8b2947$export$45df7cae684751af; }, function (v) { return $4cc749234b8b2947$export$45df7cae684751af = v; });
$parcel$export(module.exports, "Sign", function () { return $4cc749234b8b2947$export$1db683ad541682f6; }, function (v) { return $4cc749234b8b2947$export$1db683ad541682f6 = v; });
$parcel$export(module.exports, "createVerify", function () { return $4cc749234b8b2947$export$6f65485f87568e37; }, function (v) { return $4cc749234b8b2947$export$6f65485f87568e37 = v; });
$parcel$export(module.exports, "Verify", function () { return $4cc749234b8b2947$export$91a8e56769aeb334; }, function (v) { return $4cc749234b8b2947$export$91a8e56769aeb334 = v; });
$parcel$export(module.exports, "createECDH", function () { return $4cc749234b8b2947$export$2d4117e99c2179e4; }, function (v) { return $4cc749234b8b2947$export$2d4117e99c2179e4 = v; });
$parcel$export(module.exports, "publicEncrypt", function () { return $4cc749234b8b2947$export$512823e338ddb1b7; }, function (v) { return $4cc749234b8b2947$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $4cc749234b8b2947$export$9d0e0c0c4a8d30f3; }, function (v) { return $4cc749234b8b2947$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $4cc749234b8b2947$export$b9d55ff329113abd; }, function (v) { return $4cc749234b8b2947$export$b9d55ff329113abd = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $4cc749234b8b2947$export$7efb24e2fddf99b9; }, function (v) { return $4cc749234b8b2947$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "randomFill", function () { return $4cc749234b8b2947$export$bb1abf2ce84fc7e8; }, function (v) { return $4cc749234b8b2947$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $4cc749234b8b2947$export$2f7171e78e524d5e; }, function (v) { return $4cc749234b8b2947$export$2f7171e78e524d5e = v; });
$parcel$export(module.exports, "createCredentials", function () { return $4cc749234b8b2947$export$e1d879b482f37d98; }, function (v) { return $4cc749234b8b2947$export$e1d879b482f37d98 = v; });
$parcel$export(module.exports, "constants", function () { return $4cc749234b8b2947$export$1a988e7317c65621; }, function (v) { return $4cc749234b8b2947$export$1a988e7317c65621 = v; });
// eslint-disable-next-line no-multi-assign
var $4cc749234b8b2947$export$5f828d93ff035aa8;
var $4cc749234b8b2947$export$cd94982b18c6332c;
var $4cc749234b8b2947$export$1d518568e4f529b0;
var $4cc749234b8b2947$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $4cc749234b8b2947$export$2fb37efbf6ae0c0e;
var $4cc749234b8b2947$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $4cc749234b8b2947$export$da39cf97e1eb7c91;
var $4cc749234b8b2947$export$52a9039d7177394f;
var $4cc749234b8b2947$export$f7201db400317331;
var $4cc749234b8b2947$export$448fa22aedc9dbca;
var $4cc749234b8b2947$export$b80c7ba289c8fa56;
var $4cc749234b8b2947$export$26e5786e8ac8e530;
var $4cc749234b8b2947$export$bdd223f16383713e;
var $4cc749234b8b2947$export$20533d26f07f1ee0;
var $4cc749234b8b2947$export$2f64596b8cbf08b4;
var $4cc749234b8b2947$export$2ce6d8d0e8b04e1a;
var $4cc749234b8b2947$export$12ada9414fbc594c;
var $4cc749234b8b2947$export$f5e7e39d57cd9700;
var $4cc749234b8b2947$export$36b6d6ef312eab39;
var $4cc749234b8b2947$export$58a258485f1e49f6;
var $4cc749234b8b2947$export$dedd8dc3dc62b370;
var $4cc749234b8b2947$export$971862a2fcb1bb40;
var $4cc749234b8b2947$export$c6ff6a88acbeaf40;
var $4cc749234b8b2947$export$fdc27893e98845cc;
var $4cc749234b8b2947$export$6671fb9a1323bed;
var $4cc749234b8b2947$export$d74daf141a551db;
var $4cc749234b8b2947$export$45df7cae684751af;
var $4cc749234b8b2947$export$1db683ad541682f6;
var $4cc749234b8b2947$export$6f65485f87568e37;
var $4cc749234b8b2947$export$91a8e56769aeb334;
var $4cc749234b8b2947$export$2d4117e99c2179e4;
var $4cc749234b8b2947$export$512823e338ddb1b7;
var $4cc749234b8b2947$export$9d0e0c0c4a8d30f3;
var $4cc749234b8b2947$export$b9d55ff329113abd;
var $4cc749234b8b2947$export$7efb24e2fddf99b9;
var $4cc749234b8b2947$export$bb1abf2ce84fc7e8;
var $4cc749234b8b2947$export$2f7171e78e524d5e;
var $4cc749234b8b2947$export$e1d879b482f37d98;
var $4cc749234b8b2947$export$1a988e7317c65621;
'use strict';

$4cc749234b8b2947$export$5f828d93ff035aa8 = $4cc749234b8b2947$export$cd94982b18c6332c = $4cc749234b8b2947$export$1d518568e4f529b0 = $4cc749234b8b2947$export$5285b6d41c912b41 = (parcelRequire("l0MtO"));

$4cc749234b8b2947$export$2fb37efbf6ae0c0e = $4cc749234b8b2947$export$ab85ecd77ce6a5cd = (parcelRequire("7y50W"));

$4cc749234b8b2947$export$da39cf97e1eb7c91 = $4cc749234b8b2947$export$52a9039d7177394f = (parcelRequire("kpRN9"));

var $fiIhd = parcelRequire("fiIhd");
var $4cc749234b8b2947$var$algoKeys = Object.keys($fiIhd);
var $4cc749234b8b2947$var$hashes = [
    'sha1',
    'sha224',
    'sha256',
    'sha384',
    'sha512',
    'md5',
    'rmd160'
].concat($4cc749234b8b2947$var$algoKeys);
$4cc749234b8b2947$export$f7201db400317331 = function() {
    return $4cc749234b8b2947$var$hashes;
};

var $356zK = parcelRequire("356zK");
$4cc749234b8b2947$export$448fa22aedc9dbca = $356zK.pbkdf2;
$4cc749234b8b2947$export$b80c7ba289c8fa56 = $356zK.pbkdf2Sync;

var $1jroU = parcelRequire("1jroU");
$4cc749234b8b2947$export$26e5786e8ac8e530 = $1jroU.Cipher;
$4cc749234b8b2947$export$bdd223f16383713e = $1jroU.createCipher;
$4cc749234b8b2947$export$20533d26f07f1ee0 = $1jroU.Cipheriv;
$4cc749234b8b2947$export$2f64596b8cbf08b4 = $1jroU.createCipheriv;
$4cc749234b8b2947$export$2ce6d8d0e8b04e1a = $1jroU.Decipher;
$4cc749234b8b2947$export$12ada9414fbc594c = $1jroU.createDecipher;
$4cc749234b8b2947$export$f5e7e39d57cd9700 = $1jroU.Decipheriv;
$4cc749234b8b2947$export$36b6d6ef312eab39 = $1jroU.createDecipheriv;
$4cc749234b8b2947$export$58a258485f1e49f6 = $1jroU.getCiphers;
$4cc749234b8b2947$export$dedd8dc3dc62b370 = $1jroU.listCiphers;

var $dtEem = parcelRequire("dtEem");
$4cc749234b8b2947$export$971862a2fcb1bb40 = $dtEem.DiffieHellmanGroup;
$4cc749234b8b2947$export$c6ff6a88acbeaf40 = $dtEem.createDiffieHellmanGroup;
$4cc749234b8b2947$export$fdc27893e98845cc = $dtEem.getDiffieHellman;
$4cc749234b8b2947$export$6671fb9a1323bed = $dtEem.createDiffieHellman;
$4cc749234b8b2947$export$d74daf141a551db = $dtEem.DiffieHellman;

var $2WSd0 = parcelRequire("2WSd0");
$4cc749234b8b2947$export$45df7cae684751af = $2WSd0.createSign;
$4cc749234b8b2947$export$1db683ad541682f6 = $2WSd0.Sign;
$4cc749234b8b2947$export$6f65485f87568e37 = $2WSd0.createVerify;
$4cc749234b8b2947$export$91a8e56769aeb334 = $2WSd0.Verify;

$4cc749234b8b2947$export$2d4117e99c2179e4 = (parcelRequire("gZ3PT"));

var $befyV = parcelRequire("befyV");
$4cc749234b8b2947$export$512823e338ddb1b7 = $befyV.publicEncrypt;
$4cc749234b8b2947$export$9d0e0c0c4a8d30f3 = $befyV.privateEncrypt;
$4cc749234b8b2947$export$b9d55ff329113abd = $befyV.publicDecrypt;
$4cc749234b8b2947$export$7efb24e2fddf99b9 = $befyV.privateDecrypt;

var $1BK8u = parcelRequire("1BK8u");
$4cc749234b8b2947$export$bb1abf2ce84fc7e8 = $1BK8u.randomFill;
$4cc749234b8b2947$export$2f7171e78e524d5e = $1BK8u.randomFillSync;
$4cc749234b8b2947$export$e1d879b482f37d98 = function() {
    throw new Error('sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify');
};
$4cc749234b8b2947$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};

});
parcelRegister("l0MtO", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $f4bf342b3bb6b54a$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $f4bf342b3bb6b54a$var$MAX_UINT32 = 4294967295;
function $f4bf342b3bb6b54a$var$oldBrowser() {
    throw new Error('Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11');
}

var $6arys = parcelRequire("6arys");
var $f4bf342b3bb6b54a$require$Buffer = $6arys.Buffer;
var $f4bf342b3bb6b54a$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($f4bf342b3bb6b54a$var$crypto && $f4bf342b3bb6b54a$var$crypto.getRandomValues) module.exports = $f4bf342b3bb6b54a$var$randomBytes;
else module.exports = $f4bf342b3bb6b54a$var$oldBrowser;
function $f4bf342b3bb6b54a$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $f4bf342b3bb6b54a$var$MAX_UINT32) throw new RangeError('requested too many random bytes');
    var bytes = $f4bf342b3bb6b54a$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $f4bf342b3bb6b54a$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $f4bf342b3bb6b54a$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $f4bf342b3bb6b54a$var$crypto.getRandomValues(bytes.slice(generated, generated + $f4bf342b3bb6b54a$var$MAX_BYTES));
        else $f4bf342b3bb6b54a$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === 'function') return $5XqL3.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("7y50W", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $hoDvy = parcelRequire("hoDvy");

var $8YCQL = parcelRequire("8YCQL");

var $jmBao = parcelRequire("jmBao");

var $4Wbxn = parcelRequire("4Wbxn");
function $57ef99177f02edb9$var$Hash(hash) {
    $4Wbxn.call(this, 'digest');
    this._hash = hash;
}
$gdc6A($57ef99177f02edb9$var$Hash, $4Wbxn);
$57ef99177f02edb9$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$57ef99177f02edb9$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === 'md5') return new $hoDvy();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $8YCQL();
    return new $57ef99177f02edb9$var$Hash($jmBao(alg));
};

});
parcelRegister("hoDvy", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $3C3UO = parcelRequire("3C3UO");

var $6arys = parcelRequire("6arys");
var $caa352fd518502ba$require$Buffer = $6arys.Buffer;
var $caa352fd518502ba$var$ARRAY16 = new Array(16);
function $caa352fd518502ba$var$MD5() {
    $3C3UO.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$gdc6A($caa352fd518502ba$var$MD5, $3C3UO);
$caa352fd518502ba$var$MD5.prototype._update = function() {
    var M = $caa352fd518502ba$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $caa352fd518502ba$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $caa352fd518502ba$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $caa352fd518502ba$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $caa352fd518502ba$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $caa352fd518502ba$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $caa352fd518502ba$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $caa352fd518502ba$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $caa352fd518502ba$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $caa352fd518502ba$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $caa352fd518502ba$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $caa352fd518502ba$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $caa352fd518502ba$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $caa352fd518502ba$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $caa352fd518502ba$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $caa352fd518502ba$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $caa352fd518502ba$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $caa352fd518502ba$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $caa352fd518502ba$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $caa352fd518502ba$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $caa352fd518502ba$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $caa352fd518502ba$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $caa352fd518502ba$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $caa352fd518502ba$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $caa352fd518502ba$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $caa352fd518502ba$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $caa352fd518502ba$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $caa352fd518502ba$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $caa352fd518502ba$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $caa352fd518502ba$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $caa352fd518502ba$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $caa352fd518502ba$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $caa352fd518502ba$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $caa352fd518502ba$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $caa352fd518502ba$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $caa352fd518502ba$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $caa352fd518502ba$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $caa352fd518502ba$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $caa352fd518502ba$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $caa352fd518502ba$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $caa352fd518502ba$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $caa352fd518502ba$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $caa352fd518502ba$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $caa352fd518502ba$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $caa352fd518502ba$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $caa352fd518502ba$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $caa352fd518502ba$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $caa352fd518502ba$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $caa352fd518502ba$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $caa352fd518502ba$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $caa352fd518502ba$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $caa352fd518502ba$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $caa352fd518502ba$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $caa352fd518502ba$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $caa352fd518502ba$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $caa352fd518502ba$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $caa352fd518502ba$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $caa352fd518502ba$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $caa352fd518502ba$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $caa352fd518502ba$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $caa352fd518502ba$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $caa352fd518502ba$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $caa352fd518502ba$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $caa352fd518502ba$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $caa352fd518502ba$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$caa352fd518502ba$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $caa352fd518502ba$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $caa352fd518502ba$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $caa352fd518502ba$var$fnF(a, b, c, d, m, k, s) {
    return $caa352fd518502ba$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $caa352fd518502ba$var$fnG(a, b, c, d, m, k, s) {
    return $caa352fd518502ba$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $caa352fd518502ba$var$fnH(a, b, c, d, m, k, s) {
    return $caa352fd518502ba$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $caa352fd518502ba$var$fnI(a, b, c, d, m, k, s) {
    return $caa352fd518502ba$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $caa352fd518502ba$var$MD5;

});
parcelRegister("3C3UO", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $2a17f539ad6664ca$require$Buffer = $6arys.Buffer;

var $2C97X = parcelRequire("2C97X");
var $2a17f539ad6664ca$require$Transform = $2C97X.Transform;

var $gdc6A = parcelRequire("gdc6A");
function $2a17f539ad6664ca$var$HashBase(blockSize) {
    $2a17f539ad6664ca$require$Transform.call(this);
    this._block = $2a17f539ad6664ca$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$gdc6A($2a17f539ad6664ca$var$HashBase, $2a17f539ad6664ca$require$Transform);
$2a17f539ad6664ca$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$2a17f539ad6664ca$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
var $2a17f539ad6664ca$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $2a17f539ad6664ca$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined' && ArrayBuffer.isView && ($2a17f539ad6664ca$require$Buffer.prototype instanceof Uint8Array || $2a17f539ad6664ca$require$Buffer.TYPED_ARRAY_SUPPORT);
function $2a17f539ad6664ca$var$toBuffer(data, encoding) {
    // No need to do anything for exact instance
    // This is only valid when safe-buffer.Buffer === buffer.Buffer, i.e. when Buffer.from/Buffer.alloc existed
    if (data instanceof $2a17f539ad6664ca$require$Buffer) return data;
    // Convert strings to Buffer
    if (typeof data === 'string') return $2a17f539ad6664ca$require$Buffer.from(data, encoding);
    /*
   * Wrap any TypedArray instances and DataViews
   * Makes sense only on engines with full TypedArray support -- let Buffer detect that
   */ if ($2a17f539ad6664ca$var$useArrayBuffer && ArrayBuffer.isView(data)) {
        if (data.byteLength === 0) return $2a17f539ad6664ca$require$Buffer.alloc(0) // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        ;
        var res = $2a17f539ad6664ca$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
        // Recheck result size, as offset/length doesn't work on Node.js <5.10
        // We just go to Uint8Array case if this fails
        if (res.byteLength === data.byteLength) return res;
    }
    /*
   * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
   * Doesn't make sense with other TypedArray instances
   */ if ($2a17f539ad6664ca$var$useUint8Array && data instanceof Uint8Array) return $2a17f539ad6664ca$require$Buffer.from(data);
    /*
   * Old Buffer polyfill on an engine that doesn't have TypedArray support
   * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
   * Convert to our current Buffer implementation
   */ if ($2a17f539ad6664ca$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $2a17f539ad6664ca$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be of type string or an instance of Buffer, TypedArray, or DataView.');
}
$2a17f539ad6664ca$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    data = $2a17f539ad6664ca$var$toBuffer(data, encoding) // asserts correct input type
    ;
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$2a17f539ad6664ca$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$2a17f539ad6664ca$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$2a17f539ad6664ca$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $2a17f539ad6664ca$var$HashBase;

});


parcelRegister("8YCQL", function(module, exports) {
'use strict';

var $kJBqN = parcelRequire("kJBqN");
var $68921020f6c6d1d9$require$Buffer = $kJBqN.Buffer;

var $gdc6A = parcelRequire("gdc6A");

var $281zH = parcelRequire("281zH");
var $68921020f6c6d1d9$var$ARRAY16 = new Array(16);
var $68921020f6c6d1d9$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $68921020f6c6d1d9$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $68921020f6c6d1d9$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $68921020f6c6d1d9$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $68921020f6c6d1d9$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $68921020f6c6d1d9$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $68921020f6c6d1d9$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $68921020f6c6d1d9$var$fn1(a, b, c, d, e, m, k, s) {
    return $68921020f6c6d1d9$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $68921020f6c6d1d9$var$fn2(a, b, c, d, e, m, k, s) {
    return $68921020f6c6d1d9$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $68921020f6c6d1d9$var$fn3(a, b, c, d, e, m, k, s) {
    return $68921020f6c6d1d9$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $68921020f6c6d1d9$var$fn4(a, b, c, d, e, m, k, s) {
    return $68921020f6c6d1d9$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $68921020f6c6d1d9$var$fn5(a, b, c, d, e, m, k, s) {
    return $68921020f6c6d1d9$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
function $68921020f6c6d1d9$var$RIPEMD160() {
    $281zH.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$gdc6A($68921020f6c6d1d9$var$RIPEMD160, $281zH);
$68921020f6c6d1d9$var$RIPEMD160.prototype._update = function() {
    var words = $68921020f6c6d1d9$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $68921020f6c6d1d9$var$fn1(al, bl, cl, dl, el, words[$68921020f6c6d1d9$var$zl[i]], $68921020f6c6d1d9$var$hl[0], $68921020f6c6d1d9$var$sl[i]);
            tr = $68921020f6c6d1d9$var$fn5(ar, br, cr, dr, er, words[$68921020f6c6d1d9$var$zr[i]], $68921020f6c6d1d9$var$hr[0], $68921020f6c6d1d9$var$sr[i]);
        } else if (i < 32) {
            tl = $68921020f6c6d1d9$var$fn2(al, bl, cl, dl, el, words[$68921020f6c6d1d9$var$zl[i]], $68921020f6c6d1d9$var$hl[1], $68921020f6c6d1d9$var$sl[i]);
            tr = $68921020f6c6d1d9$var$fn4(ar, br, cr, dr, er, words[$68921020f6c6d1d9$var$zr[i]], $68921020f6c6d1d9$var$hr[1], $68921020f6c6d1d9$var$sr[i]);
        } else if (i < 48) {
            tl = $68921020f6c6d1d9$var$fn3(al, bl, cl, dl, el, words[$68921020f6c6d1d9$var$zl[i]], $68921020f6c6d1d9$var$hl[2], $68921020f6c6d1d9$var$sl[i]);
            tr = $68921020f6c6d1d9$var$fn3(ar, br, cr, dr, er, words[$68921020f6c6d1d9$var$zr[i]], $68921020f6c6d1d9$var$hr[2], $68921020f6c6d1d9$var$sr[i]);
        } else if (i < 64) {
            tl = $68921020f6c6d1d9$var$fn4(al, bl, cl, dl, el, words[$68921020f6c6d1d9$var$zl[i]], $68921020f6c6d1d9$var$hl[3], $68921020f6c6d1d9$var$sl[i]);
            tr = $68921020f6c6d1d9$var$fn2(ar, br, cr, dr, er, words[$68921020f6c6d1d9$var$zr[i]], $68921020f6c6d1d9$var$hr[3], $68921020f6c6d1d9$var$sr[i]);
        } else {
            tl = $68921020f6c6d1d9$var$fn5(al, bl, cl, dl, el, words[$68921020f6c6d1d9$var$zl[i]], $68921020f6c6d1d9$var$hl[4], $68921020f6c6d1d9$var$sl[i]);
            tr = $68921020f6c6d1d9$var$fn1(ar, br, cr, dr, er, words[$68921020f6c6d1d9$var$zr[i]], $68921020f6c6d1d9$var$hr[4], $68921020f6c6d1d9$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $68921020f6c6d1d9$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $68921020f6c6d1d9$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$68921020f6c6d1d9$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset] = 0x80;
    this._blockOffset += 1;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $68921020f6c6d1d9$require$Buffer.alloc ? $68921020f6c6d1d9$require$Buffer.alloc(20) : new $68921020f6c6d1d9$require$Buffer(20); // eslint-disable-line no-buffer-constructor
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
module.exports = $68921020f6c6d1d9$var$RIPEMD160;

});
parcelRegister("281zH", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $18cd8cd301644683$require$Buffer = $6arys.Buffer;

var $3UEeX = parcelRequire("3UEeX");

var $hHGGV = parcelRequire("hHGGV");
var $18cd8cd301644683$require$Transform = $hHGGV.Transform;

var $gdc6A = parcelRequire("gdc6A");
function $18cd8cd301644683$var$HashBase(blockSize) {
    $18cd8cd301644683$require$Transform.call(this);
    this._block = $18cd8cd301644683$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$gdc6A($18cd8cd301644683$var$HashBase, $18cd8cd301644683$require$Transform);
$18cd8cd301644683$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$18cd8cd301644683$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$18cd8cd301644683$var$HashBase.prototype.update = function(data, encoding) {
    if (this._finalized) throw new Error('Digest already called');
    var dataBuffer = $3UEeX(data, encoding); // asserts correct input type
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + dataBuffer.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;){
            block[i] = dataBuffer[offset];
            i += 1;
            offset += 1;
        }
        this._update();
        this._blockOffset = 0;
    }
    while(offset < dataBuffer.length){
        block[this._blockOffset] = dataBuffer[offset];
        this._blockOffset += 1;
        offset += 1;
    }
    // update length
    for(var j = 0, carry = dataBuffer.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$18cd8cd301644683$var$HashBase.prototype._update = function() {
    throw new Error('_update is not implemented');
};
$18cd8cd301644683$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error('Digest already called');
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$18cd8cd301644683$var$HashBase.prototype._digest = function() {
    throw new Error('_digest is not implemented');
};
module.exports = $18cd8cd301644683$var$HashBase;

});
parcelRegister("3UEeX", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $2d95d0ea2525de47$require$Buffer = $6arys.Buffer;

var $b7zCt = parcelRequire("b7zCt");
var $2d95d0ea2525de47$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $2d95d0ea2525de47$var$useArrayBuffer = $2d95d0ea2525de47$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $2d95d0ea2525de47$var$isView = $2d95d0ea2525de47$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding) {
    if (typeof thing === 'string' || $2d95d0ea2525de47$require$Buffer.isBuffer(thing) || $2d95d0ea2525de47$var$useUint8Array && thing instanceof Uint8Array || $2d95d0ea2525de47$var$isView && $2d95d0ea2525de47$var$isView(thing)) return $b7zCt(thing, encoding);
    throw new TypeError('The "data" argument must be a string, a Buffer, a Uint8Array, or a DataView');
};

});
parcelRegister("b7zCt", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $818bfa76f163757a$require$Buffer = $6arys.Buffer;

var $5DVsJ = parcelRequire("5DVsJ");

var $hp7tG = parcelRequire("hp7tG");
var $818bfa76f163757a$var$isView = ArrayBuffer.isView || function isView(obj) {
    try {
        $hp7tG(obj);
        return true;
    } catch (e) {
        return false;
    }
};
var $818bfa76f163757a$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $818bfa76f163757a$var$useArrayBuffer = typeof ArrayBuffer !== 'undefined' && typeof Uint8Array !== 'undefined';
var $818bfa76f163757a$var$useFromArrayBuffer = $818bfa76f163757a$var$useArrayBuffer && ($818bfa76f163757a$require$Buffer.prototype instanceof Uint8Array || $818bfa76f163757a$require$Buffer.TYPED_ARRAY_SUPPORT);
module.exports = function toBuffer(data, encoding) {
    if ($818bfa76f163757a$require$Buffer.isBuffer(data)) {
        if (data.constructor && !('isBuffer' in data)) // probably a SlowBuffer
        return $818bfa76f163757a$require$Buffer.from(data);
        return data;
    }
    if (typeof data === 'string') return $818bfa76f163757a$require$Buffer.from(data, encoding);
    /*
	 * Wrap any TypedArray instances and DataViews
	 * Makes sense only on engines with full TypedArray support -- let Buffer detect that
	 */ if ($818bfa76f163757a$var$useArrayBuffer && $818bfa76f163757a$var$isView(data)) {
        // Bug in Node.js <6.3.1, which treats this as out-of-bounds
        if (data.byteLength === 0) return $818bfa76f163757a$require$Buffer.alloc(0);
        // When Buffer is based on Uint8Array, we can just construct it from ArrayBuffer
        if ($818bfa76f163757a$var$useFromArrayBuffer) {
            var res = $818bfa76f163757a$require$Buffer.from(data.buffer, data.byteOffset, data.byteLength);
            /*
			 * Recheck result size, as offset/length doesn't work on Node.js <5.10
			 * We just go to Uint8Array case if this fails
			 */ if (res.byteLength === data.byteLength) return res;
        }
        // Convert to Uint8Array bytes and then to Buffer
        var uint8 = data instanceof Uint8Array ? data : new Uint8Array(data.buffer, data.byteOffset, data.byteLength);
        var result = $818bfa76f163757a$require$Buffer.from(uint8);
        /*
		 * Let's recheck that conversion succeeded
		 * We have .length but not .byteLength when useFromArrayBuffer is false
		 */ if (result.length === data.byteLength) return result;
    }
    /*
	 * Uint8Array in engines where Buffer.from might not work with ArrayBuffer, just copy over
	 * Doesn't make sense with other TypedArray instances
	 */ if ($818bfa76f163757a$var$useUint8Array && data instanceof Uint8Array) return $818bfa76f163757a$require$Buffer.from(data);
    var isArr = $5DVsJ(data);
    if (isArr) for(var i = 0; i < data.length; i += 1){
        var x = data[i];
        if (typeof x !== 'number' || x < 0 || x > 255 || ~~x !== x // NaN and integer check
        ) throw new RangeError('Array items must be numbers in the range 0-255.');
    }
    /*
	 * Old Buffer polyfill on an engine that doesn't have TypedArray support
	 * Also, this is from a different Buffer polyfill implementation then we have, as instanceof check failed
	 * Convert to our current Buffer implementation
	 */ if (isArr || $818bfa76f163757a$require$Buffer.isBuffer(data) && data.constructor && typeof data.constructor.isBuffer === 'function' && data.constructor.isBuffer(data)) return $818bfa76f163757a$require$Buffer.from(data);
    throw new TypeError('The "data" argument must be a string, an Array, a Buffer, a Uint8Array, or a DataView.');
};

});
parcelRegister("5DVsJ", function(module, exports) {
var $41bd2b2167f562c2$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $41bd2b2167f562c2$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("hp7tG", function(module, exports) {
'use strict';

var $45GSV = parcelRequire("45GSV");

var $h0KKk = parcelRequire("h0KKk");
/** @type {undefined | ((thisArg: import('.').TypedArray) => Buffer<ArrayBufferLike>)} */ var $caba9266f80b7360$var$$typedArrayBuffer = $h0KKk('TypedArray.prototype.buffer', true);

var $7k9mr = parcelRequire("7k9mr");
/** @type {import('.')} */ // node <= 0.10, < 0.11.4 has a nonconfigurable own property instead of a prototype getter
module.exports = $caba9266f80b7360$var$$typedArrayBuffer || function typedArrayBuffer(x) {
    if (!$7k9mr(x)) throw new $45GSV('Not a Typed Array');
    return x.buffer;
};

});



parcelRegister("hHGGV", function(module, exports) {

exports = module.exports = (parcelRequire("csNaz"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("bttKv"));

exports.Duplex = (parcelRequire("iCtG8"));

exports.Transform = (parcelRequire("4e0yH"));

exports.PassThrough = (parcelRequire("l2EgX"));

});
parcelRegister("csNaz", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $5XqL3 = parcelRequire("5XqL3");
'use strict';

var $kVgpD = parcelRequire("kVgpD");
/*</replacement>*/ module.exports = $912e3d9b0d7582ac$var$Readable;

var $lGFYk = parcelRequire("lGFYk");
/*</replacement>*/ /*<replacement>*/ var $912e3d9b0d7582ac$var$Duplex;
/*</replacement>*/ $912e3d9b0d7582ac$var$Readable.ReadableState = $912e3d9b0d7582ac$var$ReadableState;

var $8mV0l = parcelRequire("8mV0l");
var $912e3d9b0d7582ac$require$EE = $8mV0l.EventEmitter;
var $912e3d9b0d7582ac$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $3vgVX = parcelRequire("3vgVX");

var $8BUdd = parcelRequire("8BUdd");
var $912e3d9b0d7582ac$require$Buffer = $8BUdd.Buffer;
var $912e3d9b0d7582ac$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $912e3d9b0d7582ac$var$_uint8ArrayToBuffer(chunk) {
    return $912e3d9b0d7582ac$require$Buffer.from(chunk);
}
function $912e3d9b0d7582ac$var$_isUint8Array(obj) {
    return $912e3d9b0d7582ac$require$Buffer.isBuffer(obj) || obj instanceof $912e3d9b0d7582ac$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $912e3d9b0d7582ac$var$util = Object.create((parcelRequire("kbpxW")));

$912e3d9b0d7582ac$var$util.inherits = (parcelRequire("gdc6A"));

var $hDwn7 = parcelRequire("hDwn7");
var $912e3d9b0d7582ac$var$debug = void 0;
if ($hDwn7 && $hDwn7.debuglog) $912e3d9b0d7582ac$var$debug = $hDwn7.debuglog('stream');
else $912e3d9b0d7582ac$var$debug = function() {};

var $aPaC1 = parcelRequire("aPaC1");

var $4w0OO = parcelRequire("4w0OO");
var $912e3d9b0d7582ac$var$StringDecoder;
$912e3d9b0d7582ac$var$util.inherits($912e3d9b0d7582ac$var$Readable, $3vgVX);
var $912e3d9b0d7582ac$var$kProxyEvents = [
    'error',
    'close',
    'destroy',
    'pause',
    'resume'
];
function $912e3d9b0d7582ac$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($lGFYk(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $912e3d9b0d7582ac$var$ReadableState(options, stream) {
    $912e3d9b0d7582ac$var$Duplex = $912e3d9b0d7582ac$var$Duplex || (parcelRequire("iCtG8"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $912e3d9b0d7582ac$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $aPaC1();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$912e3d9b0d7582ac$var$StringDecoder) $912e3d9b0d7582ac$var$StringDecoder = (parcelRequire("28QNy")).StringDecoder;
        this.decoder = new $912e3d9b0d7582ac$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $912e3d9b0d7582ac$var$Readable(options) {
    $912e3d9b0d7582ac$var$Duplex = $912e3d9b0d7582ac$var$Duplex || (parcelRequire("iCtG8"));
    if (!(this instanceof $912e3d9b0d7582ac$var$Readable)) return new $912e3d9b0d7582ac$var$Readable(options);
    this._readableState = new $912e3d9b0d7582ac$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === 'function') this._read = options.read;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
    }
    $3vgVX.call(this);
}
Object.defineProperty($912e3d9b0d7582ac$var$Readable.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$912e3d9b0d7582ac$var$Readable.prototype.destroy = $4w0OO.destroy;
$912e3d9b0d7582ac$var$Readable.prototype._undestroy = $4w0OO.undestroy;
$912e3d9b0d7582ac$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$912e3d9b0d7582ac$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === 'string') {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $912e3d9b0d7582ac$require$Buffer.from(chunk, encoding);
                encoding = '';
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $912e3d9b0d7582ac$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$912e3d9b0d7582ac$var$Readable.prototype.unshift = function(chunk) {
    return $912e3d9b0d7582ac$var$readableAddChunk(this, chunk, null, true, false);
};
function $912e3d9b0d7582ac$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $912e3d9b0d7582ac$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $912e3d9b0d7582ac$var$chunkInvalid(state, chunk);
        if (er) stream.emit('error', er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== $912e3d9b0d7582ac$require$Buffer.prototype) chunk = $912e3d9b0d7582ac$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));
                else $912e3d9b0d7582ac$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit('error', new Error('stream.push() after EOF'));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $912e3d9b0d7582ac$var$addChunk(stream, state, chunk, false);
                    else $912e3d9b0d7582ac$var$maybeReadMore(stream, state);
                } else $912e3d9b0d7582ac$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $912e3d9b0d7582ac$var$needMoreData(state);
}
function $912e3d9b0d7582ac$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit('data', chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $912e3d9b0d7582ac$var$emitReadable(stream);
    }
    $912e3d9b0d7582ac$var$maybeReadMore(stream, state);
}
function $912e3d9b0d7582ac$var$chunkInvalid(state, chunk) {
    var er;
    if (!$912e3d9b0d7582ac$var$_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $912e3d9b0d7582ac$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$912e3d9b0d7582ac$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$912e3d9b0d7582ac$var$Readable.prototype.setEncoding = function(enc) {
    if (!$912e3d9b0d7582ac$var$StringDecoder) $912e3d9b0d7582ac$var$StringDecoder = (parcelRequire("28QNy")).StringDecoder;
    this._readableState.decoder = new $912e3d9b0d7582ac$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $912e3d9b0d7582ac$var$MAX_HWM = 0x800000;
function $912e3d9b0d7582ac$var$computeNewHighWaterMark(n) {
    if (n >= $912e3d9b0d7582ac$var$MAX_HWM) n = $912e3d9b0d7582ac$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $912e3d9b0d7582ac$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $912e3d9b0d7582ac$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$912e3d9b0d7582ac$var$Readable.prototype.read = function(n) {
    $912e3d9b0d7582ac$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $912e3d9b0d7582ac$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $912e3d9b0d7582ac$var$endReadable(this);
        else $912e3d9b0d7582ac$var$emitReadable(this);
        return null;
    }
    n = $912e3d9b0d7582ac$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $912e3d9b0d7582ac$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $912e3d9b0d7582ac$var$debug('need readable', doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $912e3d9b0d7582ac$var$debug('length less than watermark', doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $912e3d9b0d7582ac$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $912e3d9b0d7582ac$var$debug('do read');
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $912e3d9b0d7582ac$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $912e3d9b0d7582ac$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $912e3d9b0d7582ac$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $912e3d9b0d7582ac$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $912e3d9b0d7582ac$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $912e3d9b0d7582ac$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $912e3d9b0d7582ac$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $kVgpD.nextTick($912e3d9b0d7582ac$var$emitReadable_, stream);
        else $912e3d9b0d7582ac$var$emitReadable_(stream);
    }
}
function $912e3d9b0d7582ac$var$emitReadable_(stream) {
    $912e3d9b0d7582ac$var$debug('emit readable');
    stream.emit('readable');
    $912e3d9b0d7582ac$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $912e3d9b0d7582ac$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $kVgpD.nextTick($912e3d9b0d7582ac$var$maybeReadMore_, stream, state);
    }
}
function $912e3d9b0d7582ac$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $912e3d9b0d7582ac$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$912e3d9b0d7582ac$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('_read() is not implemented'));
};
$912e3d9b0d7582ac$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $912e3d9b0d7582ac$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $5XqL3.stdout && dest !== $5XqL3.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $kVgpD.nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $912e3d9b0d7582ac$var$debug('onunpipe');
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $912e3d9b0d7582ac$var$debug('onend');
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $912e3d9b0d7582ac$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $912e3d9b0d7582ac$var$debug('cleanup');
        // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', unpipe);
        src.removeListener('data', ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $912e3d9b0d7582ac$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $912e3d9b0d7582ac$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $912e3d9b0d7582ac$var$debug('false write response, pause', state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $912e3d9b0d7582ac$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($912e3d9b0d7582ac$var$EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
    }
    // Make sure our error handler is attached before userland ones.
    $912e3d9b0d7582ac$var$prependListener(dest, 'error', onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $912e3d9b0d7582ac$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $912e3d9b0d7582ac$var$debug('unpipe');
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit('pipe', src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $912e3d9b0d7582ac$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $912e3d9b0d7582ac$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $912e3d9b0d7582ac$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $912e3d9b0d7582ac$var$EElistenerCount(src, 'data')) {
            state.flowing = true;
            $912e3d9b0d7582ac$var$flow(src);
        }
    };
}
$912e3d9b0d7582ac$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit('unpipe', this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $912e3d9b0d7582ac$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$912e3d9b0d7582ac$var$Readable.prototype.on = function(ev, fn) {
    var res = $3vgVX.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $kVgpD.nextTick($912e3d9b0d7582ac$var$nReadingNextTick, this);
            else if (state.length) $912e3d9b0d7582ac$var$emitReadable(this);
        }
    }
    return res;
};
$912e3d9b0d7582ac$var$Readable.prototype.addListener = $912e3d9b0d7582ac$var$Readable.prototype.on;
function $912e3d9b0d7582ac$var$nReadingNextTick(self1) {
    $912e3d9b0d7582ac$var$debug('readable nexttick read 0');
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$912e3d9b0d7582ac$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $912e3d9b0d7582ac$var$debug('resume');
        state.flowing = true;
        $912e3d9b0d7582ac$var$resume(this, state);
    }
    return this;
};
function $912e3d9b0d7582ac$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $kVgpD.nextTick($912e3d9b0d7582ac$var$resume_, stream, state);
    }
}
function $912e3d9b0d7582ac$var$resume_(stream, state) {
    if (!state.reading) {
        $912e3d9b0d7582ac$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $912e3d9b0d7582ac$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$912e3d9b0d7582ac$var$Readable.prototype.pause = function() {
    $912e3d9b0d7582ac$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $912e3d9b0d7582ac$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $912e3d9b0d7582ac$var$flow(stream) {
    var state = stream._readableState;
    $912e3d9b0d7582ac$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$912e3d9b0d7582ac$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on('end', function() {
        $912e3d9b0d7582ac$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on('data', function(chunk) {
        $912e3d9b0d7582ac$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $912e3d9b0d7582ac$var$kProxyEvents.length; n++)stream.on($912e3d9b0d7582ac$var$kProxyEvents[n], this.emit.bind(this, $912e3d9b0d7582ac$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $912e3d9b0d7582ac$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($912e3d9b0d7582ac$var$Readable.prototype, 'readableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$912e3d9b0d7582ac$var$Readable._fromList = $912e3d9b0d7582ac$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $912e3d9b0d7582ac$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $912e3d9b0d7582ac$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $912e3d9b0d7582ac$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $912e3d9b0d7582ac$var$copyFromBufferString(n, list) : $912e3d9b0d7582ac$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $912e3d9b0d7582ac$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $912e3d9b0d7582ac$var$copyFromBuffer(n, list) {
    var ret = $912e3d9b0d7582ac$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $912e3d9b0d7582ac$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $kVgpD.nextTick($912e3d9b0d7582ac$var$endReadableNT, state, stream);
    }
}
function $912e3d9b0d7582ac$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $912e3d9b0d7582ac$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("kVgpD", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
module.exports = {
    nextTick: $f3b5dcb29891ef42$var$nextTick
};
function $f3b5dcb29891ef42$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== 'function') throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $5XqL3.nextTick(fn);
        case 2:
            return $5XqL3.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $5XqL3.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $5XqL3.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $5XqL3.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("lGFYk", function(module, exports) {
var $fc9e1403db43f359$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $fc9e1403db43f359$var$toString.call(arr) == '[object Array]';
};

});

parcelRegister("3vgVX", function(module, exports) {

module.exports = (parcelRequire("8mV0l")).EventEmitter;

});

parcelRegister("8BUdd", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $kJBqN = parcelRequire("kJBqN");
var $644d61fc17915866$var$Buffer = $kJBqN.Buffer;
// alternative to using Object.keys for old browsers
function $644d61fc17915866$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($644d61fc17915866$var$Buffer.from && $644d61fc17915866$var$Buffer.alloc && $644d61fc17915866$var$Buffer.allocUnsafe && $644d61fc17915866$var$Buffer.allocUnsafeSlow) module.exports = $kJBqN;
else {
    // Copy properties from require('buffer')
    $644d61fc17915866$var$copyProps($kJBqN, module.exports);
    module.exports.Buffer = $644d61fc17915866$var$SafeBuffer;
}
function $644d61fc17915866$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $644d61fc17915866$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$644d61fc17915866$var$copyProps($644d61fc17915866$var$Buffer, $644d61fc17915866$var$SafeBuffer);
$644d61fc17915866$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === 'number') throw new TypeError('Argument must not be a number');
    return $644d61fc17915866$var$Buffer(arg, encodingOrOffset, length);
};
$644d61fc17915866$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    var buf = $644d61fc17915866$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === 'string') buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$644d61fc17915866$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $644d61fc17915866$var$Buffer(size);
};
$644d61fc17915866$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== 'number') throw new TypeError('Argument must be a number');
    return $kJBqN.SlowBuffer(size);
};

});

parcelRegister("kbpxW", function(module, exports) {

$parcel$export(module.exports, "isArray", function () { return $eb18a6b2688000da$export$43bee75e5e14138e; }, function (v) { return $eb18a6b2688000da$export$43bee75e5e14138e = v; });
$parcel$export(module.exports, "isBoolean", function () { return $eb18a6b2688000da$export$f9ce7b637dfbe238; }, function (v) { return $eb18a6b2688000da$export$f9ce7b637dfbe238 = v; });
$parcel$export(module.exports, "isNull", function () { return $eb18a6b2688000da$export$630801d484da15df; }, function (v) { return $eb18a6b2688000da$export$630801d484da15df = v; });
$parcel$export(module.exports, "isNullOrUndefined", function () { return $eb18a6b2688000da$export$bedb7023a7733221; }, function (v) { return $eb18a6b2688000da$export$bedb7023a7733221 = v; });
$parcel$export(module.exports, "isNumber", function () { return $eb18a6b2688000da$export$7e4aa119212bc614; }, function (v) { return $eb18a6b2688000da$export$7e4aa119212bc614 = v; });
$parcel$export(module.exports, "isString", function () { return $eb18a6b2688000da$export$844ec244b1367d54; }, function (v) { return $eb18a6b2688000da$export$844ec244b1367d54 = v; });
$parcel$export(module.exports, "isSymbol", function () { return $eb18a6b2688000da$export$a244864fd9645c7f; }, function (v) { return $eb18a6b2688000da$export$a244864fd9645c7f = v; });
$parcel$export(module.exports, "isUndefined", function () { return $eb18a6b2688000da$export$fce6876652108ab; }, function (v) { return $eb18a6b2688000da$export$fce6876652108ab = v; });
$parcel$export(module.exports, "isRegExp", function () { return $eb18a6b2688000da$export$49841c62b9eff15; }, function (v) { return $eb18a6b2688000da$export$49841c62b9eff15 = v; });
$parcel$export(module.exports, "isObject", function () { return $eb18a6b2688000da$export$a6cdc56e425d0d0a; }, function (v) { return $eb18a6b2688000da$export$a6cdc56e425d0d0a = v; });
$parcel$export(module.exports, "isDate", function () { return $eb18a6b2688000da$export$871608497c498473; }, function (v) { return $eb18a6b2688000da$export$871608497c498473 = v; });
$parcel$export(module.exports, "isError", function () { return $eb18a6b2688000da$export$e6127cc7fe7395c3; }, function (v) { return $eb18a6b2688000da$export$e6127cc7fe7395c3 = v; });
$parcel$export(module.exports, "isFunction", function () { return $eb18a6b2688000da$export$f6e2535fb5126e54; }, function (v) { return $eb18a6b2688000da$export$f6e2535fb5126e54 = v; });
$parcel$export(module.exports, "isPrimitive", function () { return $eb18a6b2688000da$export$c3825b437cbdea5c; }, function (v) { return $eb18a6b2688000da$export$c3825b437cbdea5c = v; });
$parcel$export(module.exports, "isBuffer", function () { return $eb18a6b2688000da$export$a7884ebc965f8f54; }, function (v) { return $eb18a6b2688000da$export$a7884ebc965f8f54 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $eb18a6b2688000da$export$43bee75e5e14138e;
var $eb18a6b2688000da$export$f9ce7b637dfbe238;
var $eb18a6b2688000da$export$630801d484da15df;
var $eb18a6b2688000da$export$bedb7023a7733221;
var $eb18a6b2688000da$export$7e4aa119212bc614;
var $eb18a6b2688000da$export$844ec244b1367d54;
var $eb18a6b2688000da$export$a244864fd9645c7f;
var $eb18a6b2688000da$export$fce6876652108ab;
var $eb18a6b2688000da$export$49841c62b9eff15;
var $eb18a6b2688000da$export$a6cdc56e425d0d0a;
var $eb18a6b2688000da$export$871608497c498473;
var $eb18a6b2688000da$export$e6127cc7fe7395c3;
var $eb18a6b2688000da$export$f6e2535fb5126e54;
var $eb18a6b2688000da$export$c3825b437cbdea5c;
var $eb18a6b2688000da$export$a7884ebc965f8f54;
function $eb18a6b2688000da$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $eb18a6b2688000da$var$objectToString(arg) === '[object Array]';
}
$eb18a6b2688000da$export$43bee75e5e14138e = $eb18a6b2688000da$var$isArray;
function $eb18a6b2688000da$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
$eb18a6b2688000da$export$f9ce7b637dfbe238 = $eb18a6b2688000da$var$isBoolean;
function $eb18a6b2688000da$var$isNull(arg) {
    return arg === null;
}
$eb18a6b2688000da$export$630801d484da15df = $eb18a6b2688000da$var$isNull;
function $eb18a6b2688000da$var$isNullOrUndefined(arg) {
    return arg == null;
}
$eb18a6b2688000da$export$bedb7023a7733221 = $eb18a6b2688000da$var$isNullOrUndefined;
function $eb18a6b2688000da$var$isNumber(arg) {
    return typeof arg === 'number';
}
$eb18a6b2688000da$export$7e4aa119212bc614 = $eb18a6b2688000da$var$isNumber;
function $eb18a6b2688000da$var$isString(arg) {
    return typeof arg === 'string';
}
$eb18a6b2688000da$export$844ec244b1367d54 = $eb18a6b2688000da$var$isString;
function $eb18a6b2688000da$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
$eb18a6b2688000da$export$a244864fd9645c7f = $eb18a6b2688000da$var$isSymbol;
function $eb18a6b2688000da$var$isUndefined(arg) {
    return arg === void 0;
}
$eb18a6b2688000da$export$fce6876652108ab = $eb18a6b2688000da$var$isUndefined;
function $eb18a6b2688000da$var$isRegExp(re) {
    return $eb18a6b2688000da$var$objectToString(re) === '[object RegExp]';
}
$eb18a6b2688000da$export$49841c62b9eff15 = $eb18a6b2688000da$var$isRegExp;
function $eb18a6b2688000da$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
$eb18a6b2688000da$export$a6cdc56e425d0d0a = $eb18a6b2688000da$var$isObject;
function $eb18a6b2688000da$var$isDate(d) {
    return $eb18a6b2688000da$var$objectToString(d) === '[object Date]';
}
$eb18a6b2688000da$export$871608497c498473 = $eb18a6b2688000da$var$isDate;
function $eb18a6b2688000da$var$isError(e) {
    return $eb18a6b2688000da$var$objectToString(e) === '[object Error]' || e instanceof Error;
}
$eb18a6b2688000da$export$e6127cc7fe7395c3 = $eb18a6b2688000da$var$isError;
function $eb18a6b2688000da$var$isFunction(arg) {
    return typeof arg === 'function';
}
$eb18a6b2688000da$export$f6e2535fb5126e54 = $eb18a6b2688000da$var$isFunction;
function $eb18a6b2688000da$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
$eb18a6b2688000da$export$c3825b437cbdea5c = $eb18a6b2688000da$var$isPrimitive;

$eb18a6b2688000da$export$a7884ebc965f8f54 = (parcelRequire("kJBqN")).Buffer.isBuffer;
function $eb18a6b2688000da$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("aPaC1", function(module, exports) {
'use strict';
function $7e16e6304396887e$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $8BUdd = parcelRequire("8BUdd");
var $7e16e6304396887e$require$Buffer = $8BUdd.Buffer;

var $hDwn7 = parcelRequire("hDwn7");
function $7e16e6304396887e$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $7e16e6304396887e$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return '';
        var p = this.head;
        var ret = '' + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $7e16e6304396887e$require$Buffer.alloc(0);
        var ret = $7e16e6304396887e$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $7e16e6304396887e$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($hDwn7 && $hDwn7.inspect && $hDwn7.inspect.custom) module.exports.prototype[$hDwn7.inspect.custom] = function() {
    var obj = $hDwn7.inspect({
        length: this.length
    });
    return this.constructor.name + ' ' + obj;
};

});

parcelRegister("4w0OO", function(module, exports) {
'use strict';

var $kVgpD = parcelRequire("kVgpD");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $349ac927c23f1a1d$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $kVgpD.nextTick($349ac927c23f1a1d$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $kVgpD.nextTick($349ac927c23f1a1d$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $kVgpD.nextTick($349ac927c23f1a1d$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $kVgpD.nextTick($349ac927c23f1a1d$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $349ac927c23f1a1d$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $349ac927c23f1a1d$var$emitErrorNT(self, err) {
    self.emit('error', err);
}
module.exports = {
    destroy: $349ac927c23f1a1d$var$destroy,
    undestroy: $349ac927c23f1a1d$var$undestroy
};

});

parcelRegister("iCtG8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
'use strict';

var $kVgpD = parcelRequire("kVgpD");
/*</replacement>*/ /*<replacement>*/ var $d8e2cc2ba6123556$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $d8e2cc2ba6123556$var$Duplex;

/*<replacement>*/ var $d8e2cc2ba6123556$var$util = Object.create((parcelRequire("kbpxW")));

$d8e2cc2ba6123556$var$util.inherits = (parcelRequire("gdc6A"));

var $csNaz = parcelRequire("csNaz");

var $bttKv = parcelRequire("bttKv");
$d8e2cc2ba6123556$var$util.inherits($d8e2cc2ba6123556$var$Duplex, $csNaz);
// avoid scope creep, the keys array can then be collected
var $d8e2cc2ba6123556$var$keys = $d8e2cc2ba6123556$var$objectKeys($bttKv.prototype);
for(var $d8e2cc2ba6123556$var$v = 0; $d8e2cc2ba6123556$var$v < $d8e2cc2ba6123556$var$keys.length; $d8e2cc2ba6123556$var$v++){
    var $d8e2cc2ba6123556$var$method = $d8e2cc2ba6123556$var$keys[$d8e2cc2ba6123556$var$v];
    if (!$d8e2cc2ba6123556$var$Duplex.prototype[$d8e2cc2ba6123556$var$method]) $d8e2cc2ba6123556$var$Duplex.prototype[$d8e2cc2ba6123556$var$method] = $bttKv.prototype[$d8e2cc2ba6123556$var$method];
}
function $d8e2cc2ba6123556$var$Duplex(options) {
    if (!(this instanceof $d8e2cc2ba6123556$var$Duplex)) return new $d8e2cc2ba6123556$var$Duplex(options);
    $csNaz.call(this, options);
    $bttKv.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $d8e2cc2ba6123556$var$onend);
}
Object.defineProperty($d8e2cc2ba6123556$var$Duplex.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $d8e2cc2ba6123556$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $kVgpD.nextTick($d8e2cc2ba6123556$var$onEndNT, this);
}
function $d8e2cc2ba6123556$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($d8e2cc2ba6123556$var$Duplex.prototype, 'destroyed', {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$d8e2cc2ba6123556$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $kVgpD.nextTick(cb, err);
};

});
parcelRegister("bttKv", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
'use strict';

var $kVgpD = parcelRequire("kVgpD");
/*</replacement>*/ module.exports = $85a97ab1ecf5330c$var$Writable;
/* <replacement> */ function $85a97ab1ecf5330c$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $85a97ab1ecf5330c$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $85a97ab1ecf5330c$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $85a97ab1ecf5330c$var$asyncWrite = (0, $kVgpD.nextTick);
/*</replacement>*/ /*<replacement>*/ var $85a97ab1ecf5330c$var$Duplex;
/*</replacement>*/ $85a97ab1ecf5330c$var$Writable.WritableState = $85a97ab1ecf5330c$var$WritableState;

/*<replacement>*/ var $85a97ab1ecf5330c$var$util = Object.create((parcelRequire("kbpxW")));

$85a97ab1ecf5330c$var$util.inherits = (parcelRequire("gdc6A"));

/*</replacement>*/ /*<replacement>*/ var $85a97ab1ecf5330c$var$internalUtil = {
    deprecate: (parcelRequire("ta1YL"))
};

var $3vgVX = parcelRequire("3vgVX");

var $8BUdd = parcelRequire("8BUdd");
var $85a97ab1ecf5330c$require$Buffer = $8BUdd.Buffer;
var $85a97ab1ecf5330c$var$OurUint8Array = (typeof $parcel$global !== 'undefined' ? $parcel$global : typeof window !== 'undefined' ? window : typeof self !== 'undefined' ? self : {}).Uint8Array || function() {};
function $85a97ab1ecf5330c$var$_uint8ArrayToBuffer(chunk) {
    return $85a97ab1ecf5330c$require$Buffer.from(chunk);
}
function $85a97ab1ecf5330c$var$_isUint8Array(obj) {
    return $85a97ab1ecf5330c$require$Buffer.isBuffer(obj) || obj instanceof $85a97ab1ecf5330c$var$OurUint8Array;
}

var $4w0OO = parcelRequire("4w0OO");
$85a97ab1ecf5330c$var$util.inherits($85a97ab1ecf5330c$var$Writable, $3vgVX);
function $85a97ab1ecf5330c$var$nop() {}

function $85a97ab1ecf5330c$var$WritableState(options, stream) {
    $85a97ab1ecf5330c$var$Duplex = $85a97ab1ecf5330c$var$Duplex || (parcelRequire("iCtG8"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $85a97ab1ecf5330c$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8';
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $85a97ab1ecf5330c$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $85a97ab1ecf5330c$var$CorkedRequest(this);
}
$85a97ab1ecf5330c$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($85a97ab1ecf5330c$var$WritableState.prototype, 'buffer', {
            get: $85a97ab1ecf5330c$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", 'DEP0003')
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $85a97ab1ecf5330c$var$realHasInstance;
if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
    $85a97ab1ecf5330c$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($85a97ab1ecf5330c$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($85a97ab1ecf5330c$var$realHasInstance.call(this, object)) return true;
            if (this !== $85a97ab1ecf5330c$var$Writable) return false;
            return object && object._writableState instanceof $85a97ab1ecf5330c$var$WritableState;
        }
    });
} else $85a97ab1ecf5330c$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $85a97ab1ecf5330c$var$Writable(options) {
    $85a97ab1ecf5330c$var$Duplex = $85a97ab1ecf5330c$var$Duplex || (parcelRequire("iCtG8"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$85a97ab1ecf5330c$var$realHasInstance.call($85a97ab1ecf5330c$var$Writable, this) && !(this instanceof $85a97ab1ecf5330c$var$Duplex)) return new $85a97ab1ecf5330c$var$Writable(options);
    this._writableState = new $85a97ab1ecf5330c$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
        if (typeof options.destroy === 'function') this._destroy = options.destroy;
        if (typeof options.final === 'function') this._final = options.final;
    }
    $3vgVX.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$85a97ab1ecf5330c$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $85a97ab1ecf5330c$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end');
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $kVgpD.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $85a97ab1ecf5330c$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $kVgpD.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$85a97ab1ecf5330c$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $85a97ab1ecf5330c$var$_isUint8Array(chunk);
    if (isBuf && !$85a97ab1ecf5330c$require$Buffer.isBuffer(chunk)) chunk = $85a97ab1ecf5330c$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $85a97ab1ecf5330c$var$nop;
    if (state.ended) $85a97ab1ecf5330c$var$writeAfterEnd(this, cb);
    else if (isBuf || $85a97ab1ecf5330c$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $85a97ab1ecf5330c$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$85a97ab1ecf5330c$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$85a97ab1ecf5330c$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $85a97ab1ecf5330c$var$clearBuffer(this, state);
    }
};
$85a97ab1ecf5330c$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $85a97ab1ecf5330c$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $85a97ab1ecf5330c$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($85a97ab1ecf5330c$var$Writable.prototype, 'writableHighWaterMark', {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $85a97ab1ecf5330c$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $85a97ab1ecf5330c$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = 'buffer';
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $85a97ab1ecf5330c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $85a97ab1ecf5330c$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $85a97ab1ecf5330c$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $kVgpD.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $kVgpD.nextTick($85a97ab1ecf5330c$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit('error', er);
        // this can emit finish, but finish must
        // always follow error
        $85a97ab1ecf5330c$var$finishMaybe(stream, state);
    }
}
function $85a97ab1ecf5330c$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $85a97ab1ecf5330c$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $85a97ab1ecf5330c$var$onwriteStateUpdate(state);
    if (er) $85a97ab1ecf5330c$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $85a97ab1ecf5330c$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $85a97ab1ecf5330c$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $85a97ab1ecf5330c$var$asyncWrite($85a97ab1ecf5330c$var$afterWrite, stream, state, finished, cb);
        else $85a97ab1ecf5330c$var$afterWrite(stream, state, finished, cb);
    }
}
function $85a97ab1ecf5330c$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $85a97ab1ecf5330c$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $85a97ab1ecf5330c$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $85a97ab1ecf5330c$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
}
// if there's something in the buffer waiting, then process it
function $85a97ab1ecf5330c$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $85a97ab1ecf5330c$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $85a97ab1ecf5330c$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $85a97ab1ecf5330c$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$85a97ab1ecf5330c$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('_write() is not implemented'));
};
$85a97ab1ecf5330c$var$Writable.prototype._writev = null;
$85a97ab1ecf5330c$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $85a97ab1ecf5330c$var$endWritable(this, state, cb);
};
function $85a97ab1ecf5330c$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $85a97ab1ecf5330c$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit('error', err);
        state.prefinished = true;
        stream.emit('prefinish');
        $85a97ab1ecf5330c$var$finishMaybe(stream, state);
    });
}
function $85a97ab1ecf5330c$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === 'function') {
            state.pendingcb++;
            state.finalCalled = true;
            $kVgpD.nextTick($85a97ab1ecf5330c$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit('prefinish');
        }
    }
}
function $85a97ab1ecf5330c$var$finishMaybe(stream, state) {
    var need = $85a97ab1ecf5330c$var$needFinish(state);
    if (need) {
        $85a97ab1ecf5330c$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit('finish');
        }
    }
    return need;
}
function $85a97ab1ecf5330c$var$endWritable(stream, state, cb) {
    state.ending = true;
    $85a97ab1ecf5330c$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $kVgpD.nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $85a97ab1ecf5330c$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($85a97ab1ecf5330c$var$Writable.prototype, 'destroyed', {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$85a97ab1ecf5330c$var$Writable.prototype.destroy = $4w0OO.destroy;
$85a97ab1ecf5330c$var$Writable.prototype._undestroy = $4w0OO.undestroy;
$85a97ab1ecf5330c$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("28QNy", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", function () { return $18f548c90a911243$export$63a7aa211a91ed69; }, function (v) { return $18f548c90a911243$export$63a7aa211a91ed69 = v; });
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $18f548c90a911243$export$63a7aa211a91ed69;
'use strict';

var $8BUdd = parcelRequire("8BUdd");
var $18f548c90a911243$require$Buffer = $8BUdd.Buffer;
/*</replacement>*/ var $18f548c90a911243$var$isEncoding = $18f548c90a911243$require$Buffer.isEncoding || function(encoding) {
    encoding = '' + encoding;
    switch(encoding && encoding.toLowerCase()){
        case 'hex':
        case 'utf8':
        case 'utf-8':
        case 'ascii':
        case 'binary':
        case 'base64':
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
        case 'raw':
            return true;
        default:
            return false;
    }
};
function $18f548c90a911243$var$_normalizeEncoding(enc) {
    if (!enc) return 'utf8';
    var retried;
    while(true)switch(enc){
        case 'utf8':
        case 'utf-8':
            return 'utf8';
        case 'ucs2':
        case 'ucs-2':
        case 'utf16le':
        case 'utf-16le':
            return 'utf16le';
        case 'latin1':
        case 'binary':
            return 'latin1';
        case 'base64':
        case 'ascii':
        case 'hex':
            return enc;
        default:
            if (retried) return; // undefined
            enc = ('' + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $18f548c90a911243$var$normalizeEncoding(enc) {
    var nenc = $18f548c90a911243$var$_normalizeEncoding(enc);
    if (typeof nenc !== 'string' && ($18f548c90a911243$require$Buffer.isEncoding === $18f548c90a911243$var$isEncoding || !$18f548c90a911243$var$isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
    return nenc || enc;
}
$18f548c90a911243$export$63a7aa211a91ed69 = $18f548c90a911243$var$StringDecoder;
function $18f548c90a911243$var$StringDecoder(encoding) {
    this.encoding = $18f548c90a911243$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case 'utf16le':
            this.text = $18f548c90a911243$var$utf16Text;
            this.end = $18f548c90a911243$var$utf16End;
            nb = 4;
            break;
        case 'utf8':
            this.fillLast = $18f548c90a911243$var$utf8FillLast;
            nb = 4;
            break;
        case 'base64':
            this.text = $18f548c90a911243$var$base64Text;
            this.end = $18f548c90a911243$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $18f548c90a911243$var$simpleWrite;
            this.end = $18f548c90a911243$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $18f548c90a911243$require$Buffer.allocUnsafe(nb);
}
$18f548c90a911243$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return '';
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return '';
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || '';
};
$18f548c90a911243$var$StringDecoder.prototype.end = $18f548c90a911243$var$utf8End;
// Returns only complete characters in a Buffer
$18f548c90a911243$var$StringDecoder.prototype.text = $18f548c90a911243$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$18f548c90a911243$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $18f548c90a911243$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $18f548c90a911243$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $18f548c90a911243$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $18f548c90a911243$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $18f548c90a911243$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $18f548c90a911243$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return '\ufffd';
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return '\ufffd';
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return '\ufffd';
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $18f548c90a911243$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $18f548c90a911243$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $18f548c90a911243$var$utf8Text(buf, i) {
    var total = $18f548c90a911243$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString('utf8', i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString('utf8', i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $18f548c90a911243$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + '\ufffd';
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $18f548c90a911243$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString('utf16le', i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString('utf16le', i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $18f548c90a911243$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString('utf16le', 0, end);
    }
    return r;
}
function $18f548c90a911243$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString('base64', i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString('base64', i, buf.length - n);
}
function $18f548c90a911243$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : '';
    if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $18f548c90a911243$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $18f548c90a911243$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : '';
}

});


parcelRegister("4e0yH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
'use strict';
module.exports = $3138e7255e5ae100$var$Transform;

var $iCtG8 = parcelRequire("iCtG8");

/*<replacement>*/ var $3138e7255e5ae100$var$util = Object.create((parcelRequire("kbpxW")));

$3138e7255e5ae100$var$util.inherits = (parcelRequire("gdc6A"));
/*</replacement>*/ $3138e7255e5ae100$var$util.inherits($3138e7255e5ae100$var$Transform, $iCtG8);
function $3138e7255e5ae100$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit('error', new Error('write callback called multiple times'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $3138e7255e5ae100$var$Transform(options) {
    if (!(this instanceof $3138e7255e5ae100$var$Transform)) return new $3138e7255e5ae100$var$Transform(options);
    $iCtG8.call(this, options);
    this._transformState = {
        afterTransform: $3138e7255e5ae100$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on('prefinish', $3138e7255e5ae100$var$prefinish);
}
function $3138e7255e5ae100$var$prefinish() {
    var _this = this;
    if (typeof this._flush === 'function') this._flush(function(er, data) {
        $3138e7255e5ae100$var$done(_this, er, data);
    });
    else $3138e7255e5ae100$var$done(this, null, null);
}
$3138e7255e5ae100$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $iCtG8.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$3138e7255e5ae100$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('_transform() is not implemented');
};
$3138e7255e5ae100$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$3138e7255e5ae100$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$3138e7255e5ae100$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $iCtG8.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit('close');
    });
};
function $3138e7255e5ae100$var$done(stream, er, data) {
    if (er) return stream.emit('error', er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error('Calling transform done when ws.length != 0');
    if (stream._transformState.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}

});

parcelRegister("l2EgX", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
'use strict';
module.exports = $f519062a7560b7bb$var$PassThrough;

var $4e0yH = parcelRequire("4e0yH");

/*<replacement>*/ var $f519062a7560b7bb$var$util = Object.create((parcelRequire("kbpxW")));

$f519062a7560b7bb$var$util.inherits = (parcelRequire("gdc6A"));
/*</replacement>*/ $f519062a7560b7bb$var$util.inherits($f519062a7560b7bb$var$PassThrough, $4e0yH);
function $f519062a7560b7bb$var$PassThrough(options) {
    if (!(this instanceof $f519062a7560b7bb$var$PassThrough)) return new $f519062a7560b7bb$var$PassThrough(options);
    $4e0yH.call(this, options);
}
$f519062a7560b7bb$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});




parcelRegister("jmBao", function(module, exports) {
'use strict';
module.exports = function SHA(algorithm) {
    var alg = algorithm.toLowerCase();
    var Algorithm = module.exports[alg];
    if (!Algorithm) throw new Error(alg + ' is not supported (we accept pull requests)');
    return new Algorithm();
};

module.exports.sha = (parcelRequire("JR7pd"));

module.exports.sha1 = (parcelRequire("8Xc8R"));

module.exports.sha224 = (parcelRequire("5Ttix"));

module.exports.sha256 = (parcelRequire("gHLts"));

module.exports.sha384 = (parcelRequire("cQH78"));

module.exports.sha512 = (parcelRequire("hdIEp"));

});
parcelRegister("JR7pd", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $089d684d0a20e250$require$Buffer = $6arys.Buffer;
var $089d684d0a20e250$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $089d684d0a20e250$var$W = new Array(80);
function $089d684d0a20e250$var$Sha() {
    this.init();
    this._w = $089d684d0a20e250$var$W;
    $jgyft.call(this, 64, 56);
}
$gdc6A($089d684d0a20e250$var$Sha, $jgyft);
$089d684d0a20e250$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $089d684d0a20e250$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $089d684d0a20e250$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $089d684d0a20e250$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$089d684d0a20e250$var$Sha.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $089d684d0a20e250$var$rotl5(a) + $089d684d0a20e250$var$ft(s, b, c, d) + e + w[j] + $089d684d0a20e250$var$K[s] | 0;
        e = d;
        d = c;
        c = $089d684d0a20e250$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$089d684d0a20e250$var$Sha.prototype._hash = function() {
    var H = $089d684d0a20e250$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $089d684d0a20e250$var$Sha;

});
parcelRegister("jgyft", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $e06a1404fa889325$require$Buffer = $6arys.Buffer;

var $b7zCt = parcelRequire("b7zCt");
// prototype class for hash functions
function $e06a1404fa889325$var$Hash(blockSize, finalSize) {
    this._block = $e06a1404fa889325$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$e06a1404fa889325$var$Hash.prototype.update = function(data, enc) {
    /* eslint no-param-reassign: 0 */ data = $b7zCt(data, enc || 'utf8');
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$e06a1404fa889325$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    /*
	 * zero (rem + 1) trailing bits, where (rem + 1) is the smallest
	 * non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
	 */ this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$e06a1404fa889325$var$Hash.prototype._update = function() {
    throw new Error('_update must be implemented by subclass');
};
module.exports = $e06a1404fa889325$var$Hash;

});


parcelRegister("8Xc8R", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $684d408c89f949f7$require$Buffer = $6arys.Buffer;
var $684d408c89f949f7$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $684d408c89f949f7$var$W = new Array(80);
function $684d408c89f949f7$var$Sha1() {
    this.init();
    this._w = $684d408c89f949f7$var$W;
    $jgyft.call(this, 64, 56);
}
$gdc6A($684d408c89f949f7$var$Sha1, $jgyft);
$684d408c89f949f7$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $684d408c89f949f7$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $684d408c89f949f7$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $684d408c89f949f7$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $684d408c89f949f7$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$684d408c89f949f7$var$Sha1.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)w[i] = $684d408c89f949f7$var$rotl1(w[i - 3] ^ w[i - 8] ^ w[i - 14] ^ w[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $684d408c89f949f7$var$rotl5(a) + $684d408c89f949f7$var$ft(s, b, c, d) + e + w[j] + $684d408c89f949f7$var$K[s] | 0;
        e = d;
        d = c;
        c = $684d408c89f949f7$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$684d408c89f949f7$var$Sha1.prototype._hash = function() {
    var H = $684d408c89f949f7$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $684d408c89f949f7$var$Sha1;

});

parcelRegister("5Ttix", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $gHLts = parcelRequire("gHLts");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $44a8d0cad3141136$require$Buffer = $6arys.Buffer;
var $44a8d0cad3141136$var$W = new Array(64);
function $44a8d0cad3141136$var$Sha224() {
    this.init();
    this._w = $44a8d0cad3141136$var$W; // new Array(64)
    $jgyft.call(this, 64, 56);
}
$gdc6A($44a8d0cad3141136$var$Sha224, $gHLts);
$44a8d0cad3141136$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$44a8d0cad3141136$var$Sha224.prototype._hash = function() {
    var H = $44a8d0cad3141136$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $44a8d0cad3141136$var$Sha224;

});
parcelRegister("gHLts", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $c2957cdcadb8357a$require$Buffer = $6arys.Buffer;
var $c2957cdcadb8357a$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $c2957cdcadb8357a$var$W = new Array(64);
function $c2957cdcadb8357a$var$Sha256() {
    this.init();
    this._w = $c2957cdcadb8357a$var$W; // new Array(64)
    $jgyft.call(this, 64, 56);
}
$gdc6A($c2957cdcadb8357a$var$Sha256, $jgyft);
$c2957cdcadb8357a$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $c2957cdcadb8357a$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $c2957cdcadb8357a$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $c2957cdcadb8357a$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $c2957cdcadb8357a$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $c2957cdcadb8357a$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $c2957cdcadb8357a$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$c2957cdcadb8357a$var$Sha256.prototype._update = function(M) {
    var w = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)w[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)w[i] = $c2957cdcadb8357a$var$gamma1(w[i - 2]) + w[i - 7] + $c2957cdcadb8357a$var$gamma0(w[i - 15]) + w[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $c2957cdcadb8357a$var$sigma1(e) + $c2957cdcadb8357a$var$ch(e, f, g) + $c2957cdcadb8357a$var$K[j] + w[j] | 0;
        var T2 = $c2957cdcadb8357a$var$sigma0(a) + $c2957cdcadb8357a$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$c2957cdcadb8357a$var$Sha256.prototype._hash = function() {
    var H = $c2957cdcadb8357a$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $c2957cdcadb8357a$var$Sha256;

});


parcelRegister("cQH78", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $hdIEp = parcelRequire("hdIEp");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $95abc8eb7fdf1325$require$Buffer = $6arys.Buffer;
var $95abc8eb7fdf1325$var$W = new Array(160);
function $95abc8eb7fdf1325$var$Sha384() {
    this.init();
    this._w = $95abc8eb7fdf1325$var$W;
    $jgyft.call(this, 128, 112);
}
$gdc6A($95abc8eb7fdf1325$var$Sha384, $hdIEp);
$95abc8eb7fdf1325$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$95abc8eb7fdf1325$var$Sha384.prototype._hash = function() {
    var H = $95abc8eb7fdf1325$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $95abc8eb7fdf1325$var$Sha384;

});
parcelRegister("hdIEp", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $jgyft = parcelRequire("jgyft");

var $6arys = parcelRequire("6arys");
var $c89649474b913826$require$Buffer = $6arys.Buffer;
var $c89649474b913826$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $c89649474b913826$var$W = new Array(160);
function $c89649474b913826$var$Sha512() {
    this.init();
    this._w = $c89649474b913826$var$W;
    $jgyft.call(this, 128, 112);
}
$gdc6A($c89649474b913826$var$Sha512, $jgyft);
$c89649474b913826$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $c89649474b913826$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $c89649474b913826$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $c89649474b913826$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $c89649474b913826$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $c89649474b913826$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $c89649474b913826$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $c89649474b913826$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $c89649474b913826$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $c89649474b913826$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$c89649474b913826$var$Sha512.prototype._update = function(M) {
    var w = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        w[i] = M.readInt32BE(i * 4);
        w[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = w[i - 30];
        var xl = w[i - 30 + 1];
        var gamma0 = $c89649474b913826$var$Gamma0(xh, xl);
        var gamma0l = $c89649474b913826$var$Gamma0l(xl, xh);
        xh = w[i - 4];
        xl = w[i - 4 + 1];
        var gamma1 = $c89649474b913826$var$Gamma1(xh, xl);
        var gamma1l = $c89649474b913826$var$Gamma1l(xl, xh);
        // w[i] = gamma0 + w[i - 7] + gamma1 + w[i - 16]
        var Wi7h = w[i - 14];
        var Wi7l = w[i - 14 + 1];
        var Wi16h = w[i - 32];
        var Wi16l = w[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $c89649474b913826$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $c89649474b913826$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $c89649474b913826$var$getCarry(Wil, Wi16l) | 0;
        w[i] = Wih;
        w[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = w[j];
        Wil = w[j + 1];
        var majh = $c89649474b913826$var$maj(ah, bh, ch);
        var majl = $c89649474b913826$var$maj(al, bl, cl);
        var sigma0h = $c89649474b913826$var$sigma0(ah, al);
        var sigma0l = $c89649474b913826$var$sigma0(al, ah);
        var sigma1h = $c89649474b913826$var$sigma1(eh, el);
        var sigma1l = $c89649474b913826$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + w[j]
        var Kih = $c89649474b913826$var$K[j];
        var Kil = $c89649474b913826$var$K[j + 1];
        var chh = $c89649474b913826$var$Ch(eh, fh, gh);
        var chl = $c89649474b913826$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $c89649474b913826$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $c89649474b913826$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $c89649474b913826$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $c89649474b913826$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $c89649474b913826$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $c89649474b913826$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $c89649474b913826$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $c89649474b913826$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $c89649474b913826$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $c89649474b913826$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $c89649474b913826$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $c89649474b913826$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $c89649474b913826$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $c89649474b913826$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $c89649474b913826$var$getCarry(this._hl, hl) | 0;
};
$c89649474b913826$var$Sha512.prototype._hash = function() {
    var H = $c89649474b913826$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $c89649474b913826$var$Sha512;

});



parcelRegister("4Wbxn", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $3985874366fec647$require$Buffer = $6arys.Buffer;

var $2C97X = parcelRequire("2C97X");
var $3985874366fec647$require$Transform = $2C97X.Transform;

var $jzifX = parcelRequire("jzifX");
var $3985874366fec647$require$StringDecoder = $jzifX.StringDecoder;

var $gdc6A = parcelRequire("gdc6A");

var $b7zCt = parcelRequire("b7zCt");
function $3985874366fec647$var$CipherBase(hashMode) {
    $3985874366fec647$require$Transform.call(this);
    this.hashMode = typeof hashMode === 'string';
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this['final'] = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$gdc6A($3985874366fec647$var$CipherBase, $3985874366fec647$require$Transform);
$3985874366fec647$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    var bufferData = $b7zCt(data, inputEnc); // asserts correct input type
    var outData = this._update(bufferData);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$3985874366fec647$var$CipherBase.prototype.setAutoPadding = function() {};
$3985874366fec647$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error('trying to get auth tag in unsupported state');
};
$3985874366fec647$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error('trying to set auth tag in unsupported state');
};
$3985874366fec647$var$CipherBase.prototype.setAAD = function() {
    throw new Error('trying to set aad in unsupported state');
};
$3985874366fec647$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$3985874366fec647$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$3985874366fec647$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $3985874366fec647$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$3985874366fec647$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $3985874366fec647$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can\u2019t switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $3985874366fec647$var$CipherBase;

});


parcelRegister("kpRN9", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $d7uN5 = parcelRequire("d7uN5");

var $4Wbxn = parcelRequire("4Wbxn");

var $6arys = parcelRequire("6arys");
var $edcfde5ae4288a39$require$Buffer = $6arys.Buffer;

var $4TMvN = parcelRequire("4TMvN");

var $8YCQL = parcelRequire("8YCQL");

var $jmBao = parcelRequire("jmBao");
var $edcfde5ae4288a39$var$ZEROS = $edcfde5ae4288a39$require$Buffer.alloc(128);
function $edcfde5ae4288a39$var$Hmac(alg, key) {
    $4Wbxn.call(this, 'digest');
    if (typeof key === 'string') key = $edcfde5ae4288a39$require$Buffer.from(key);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === 'rmd160' ? new $8YCQL() : $jmBao(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $edcfde5ae4288a39$require$Buffer.concat([
        key,
        $edcfde5ae4288a39$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $edcfde5ae4288a39$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $edcfde5ae4288a39$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === 'rmd160' ? new $8YCQL() : $jmBao(alg);
    this._hash.update(ipad);
}
$gdc6A($edcfde5ae4288a39$var$Hmac, $4Wbxn);
$edcfde5ae4288a39$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$edcfde5ae4288a39$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === 'rmd160' ? new $8YCQL() : $jmBao(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === 'rmd160' || alg === 'ripemd160') return new $edcfde5ae4288a39$var$Hmac('rmd160', key);
    if (alg === 'md5') return new $d7uN5($4TMvN, key);
    return new $edcfde5ae4288a39$var$Hmac(alg, key);
};

});
parcelRegister("d7uN5", function(module, exports) {
'use strict';

var $gdc6A = parcelRequire("gdc6A");

var $6arys = parcelRequire("6arys");
var $98d3d031cc88a718$require$Buffer = $6arys.Buffer;

var $4Wbxn = parcelRequire("4Wbxn");
var $98d3d031cc88a718$var$ZEROS = $98d3d031cc88a718$require$Buffer.alloc(128);
var $98d3d031cc88a718$var$blocksize = 64;
function $98d3d031cc88a718$var$Hmac(alg, key) {
    $4Wbxn.call(this, 'digest');
    if (typeof key === 'string') key = $98d3d031cc88a718$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $98d3d031cc88a718$var$blocksize) key = alg(key);
    else if (key.length < $98d3d031cc88a718$var$blocksize) key = $98d3d031cc88a718$require$Buffer.concat([
        key,
        $98d3d031cc88a718$var$ZEROS
    ], $98d3d031cc88a718$var$blocksize);
    var ipad = this._ipad = $98d3d031cc88a718$require$Buffer.allocUnsafe($98d3d031cc88a718$var$blocksize);
    var opad = this._opad = $98d3d031cc88a718$require$Buffer.allocUnsafe($98d3d031cc88a718$var$blocksize);
    for(var i = 0; i < $98d3d031cc88a718$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$gdc6A($98d3d031cc88a718$var$Hmac, $4Wbxn);
$98d3d031cc88a718$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$98d3d031cc88a718$var$Hmac.prototype._final = function() {
    var h = this._alg($98d3d031cc88a718$require$Buffer.concat(this._hash));
    return this._alg($98d3d031cc88a718$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $98d3d031cc88a718$var$Hmac;

});

parcelRegister("4TMvN", function(module, exports) {

var $hoDvy = parcelRequire("hoDvy");
module.exports = function(buffer) {
    return new $hoDvy().update(buffer).digest();
};

});


parcelRegister("fiIhd", function(module, exports) {
'use strict';

module.exports = (parcelRequire("iZgai"));

});
parcelRegister("iZgai", function(module, exports) {
module.exports = JSON.parse("{\"sha224WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"RSA-SHA224\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha224\",\"id\":\"302d300d06096086480165030402040500041c\"},\"sha256WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"RSA-SHA256\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha256\",\"id\":\"3031300d060960864801650304020105000420\"},\"sha384WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"RSA-SHA384\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha384\",\"id\":\"3041300d060960864801650304020205000430\"},\"sha512WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA512\":{\"sign\":\"ecdsa/rsa\",\"hash\":\"sha512\",\"id\":\"3051300d060960864801650304020305000440\"},\"RSA-SHA1\":{\"sign\":\"rsa\",\"hash\":\"sha1\",\"id\":\"3021300906052b0e03021a05000414\"},\"ecdsa-with-SHA1\":{\"sign\":\"ecdsa\",\"hash\":\"sha1\",\"id\":\"\"},\"sha256\":{\"sign\":\"ecdsa\",\"hash\":\"sha256\",\"id\":\"\"},\"sha224\":{\"sign\":\"ecdsa\",\"hash\":\"sha224\",\"id\":\"\"},\"sha384\":{\"sign\":\"ecdsa\",\"hash\":\"sha384\",\"id\":\"\"},\"sha512\":{\"sign\":\"ecdsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-SHA1\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA\":{\"sign\":\"dsa\",\"hash\":\"sha1\",\"id\":\"\"},\"DSA-WITH-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-SHA224\":{\"sign\":\"dsa\",\"hash\":\"sha224\",\"id\":\"\"},\"DSA-WITH-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-SHA256\":{\"sign\":\"dsa\",\"hash\":\"sha256\",\"id\":\"\"},\"DSA-WITH-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-SHA384\":{\"sign\":\"dsa\",\"hash\":\"sha384\",\"id\":\"\"},\"DSA-WITH-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-SHA512\":{\"sign\":\"dsa\",\"hash\":\"sha512\",\"id\":\"\"},\"DSA-RIPEMD160\":{\"sign\":\"dsa\",\"hash\":\"rmd160\",\"id\":\"\"},\"ripemd160WithRSA\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"RSA-RIPEMD160\":{\"sign\":\"rsa\",\"hash\":\"rmd160\",\"id\":\"3021300906052b2403020105000414\"},\"md5WithRSAEncryption\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"},\"RSA-MD5\":{\"sign\":\"rsa\",\"hash\":\"md5\",\"id\":\"3020300c06082a864886f70d020505000410\"}}");

});


parcelRegister("356zK", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", function () { return $23e6f080793703d9$export$448fa22aedc9dbca; }, function (v) { return $23e6f080793703d9$export$448fa22aedc9dbca = v; });
$parcel$export(module.exports, "pbkdf2Sync", function () { return $23e6f080793703d9$export$b80c7ba289c8fa56; }, function (v) { return $23e6f080793703d9$export$b80c7ba289c8fa56 = v; });
var $23e6f080793703d9$export$448fa22aedc9dbca;
var $23e6f080793703d9$export$b80c7ba289c8fa56;
'use strict';

$23e6f080793703d9$export$448fa22aedc9dbca = (parcelRequire("8vuZ4"));

$23e6f080793703d9$export$b80c7ba289c8fa56 = (parcelRequire("3ypXD"));

});
parcelRegister("8vuZ4", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $631940c2e5461f95$require$Buffer = $6arys.Buffer;

var $5es4X = parcelRequire("5es4X");

var $8vs9n = parcelRequire("8vs9n");

var $3ypXD = parcelRequire("3ypXD");

var $lHyIE = parcelRequire("lHyIE");
var $631940c2e5461f95$var$ZERO_BUF;
var $631940c2e5461f95$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $631940c2e5461f95$var$toBrowser = {
    sha: 'SHA-1',
    'sha-1': 'SHA-1',
    sha1: 'SHA-1',
    sha256: 'SHA-256',
    'sha-256': 'SHA-256',
    sha384: 'SHA-384',
    'sha-384': 'SHA-384',
    'sha-512': 'SHA-512',
    sha512: 'SHA-512'
};
var $631940c2e5461f95$var$checks = [];
var $631940c2e5461f95$var$nextTick;
function $631940c2e5461f95$var$getNextTick() {
    if ($631940c2e5461f95$var$nextTick) return $631940c2e5461f95$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $631940c2e5461f95$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $631940c2e5461f95$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $631940c2e5461f95$var$nextTick = $parcel$global.setImmediate;
    else $631940c2e5461f95$var$nextTick = $parcel$global.setTimeout;
    return $631940c2e5461f95$var$nextTick;
}
function $631940c2e5461f95$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $631940c2e5461f95$var$subtle.importKey('raw', password, {
        name: 'PBKDF2'
    }, false, [
        'deriveBits'
    ]).then(function(key) {
        return $631940c2e5461f95$var$subtle.deriveBits({
            name: 'PBKDF2',
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $631940c2e5461f95$require$Buffer.from(res);
    });
}
function $631940c2e5461f95$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$631940c2e5461f95$var$subtle || !$631940c2e5461f95$var$subtle.importKey || !$631940c2e5461f95$var$subtle.deriveBits) return Promise.resolve(false);
    if ($631940c2e5461f95$var$checks[algo] !== undefined) return $631940c2e5461f95$var$checks[algo];
    $631940c2e5461f95$var$ZERO_BUF = $631940c2e5461f95$var$ZERO_BUF || $631940c2e5461f95$require$Buffer.alloc(8);
    var prom = $631940c2e5461f95$var$browserPbkdf2($631940c2e5461f95$var$ZERO_BUF, $631940c2e5461f95$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }, function() {
        return false;
    });
    $631940c2e5461f95$var$checks[algo] = prom;
    return prom;
}
function $631940c2e5461f95$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $631940c2e5461f95$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $631940c2e5461f95$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === 'function') {
        callback = digest;
        digest = undefined;
    }
    $5es4X(iterations, keylen);
    password = $lHyIE(password, $8vs9n, 'Password');
    salt = $lHyIE(salt, $8vs9n, 'Salt');
    if (typeof callback !== 'function') throw new Error('No callback provided to pbkdf2');
    digest = digest || 'sha1';
    var algo = $631940c2e5461f95$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== 'function') {
        $631940c2e5461f95$var$getNextTick()(function() {
            var out;
            try {
                out = $3ypXD(password, salt, iterations, keylen, digest);
            } catch (e) {
                callback(e);
                return;
            }
            callback(null, out);
        });
        return;
    }
    $631940c2e5461f95$var$resolvePromise($631940c2e5461f95$var$checkNative(algo).then(function(resp) {
        if (resp) return $631940c2e5461f95$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $3ypXD(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("5es4X", function(module, exports) {
'use strict';
var $3cf40a722867a095$var$$isFinite = isFinite;
var $3cf40a722867a095$var$MAX_ALLOC = Math.pow(2, 30) - 1; // default in iojs
module.exports = function(iterations, keylen) {
    if (typeof iterations !== 'number') throw new TypeError('Iterations not a number');
    if (iterations < 0 || !$3cf40a722867a095$var$$isFinite(iterations)) throw new TypeError('Bad iterations');
    if (typeof keylen !== 'number') throw new TypeError('Key length not a number');
    if (keylen < 0 || keylen > $3cf40a722867a095$var$MAX_ALLOC || keylen !== keylen) throw new TypeError('Bad key length');
};

});

parcelRegister("8vs9n", function(module, exports) {

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
var $63170e0df9d207df$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $63170e0df9d207df$var$defaultEncoding = 'utf-8';
else if ($parcel$global.process && $parcel$global.process.version) {
    var $63170e0df9d207df$var$pVersionMajor = parseInt($5XqL3.version.split('.')[0].slice(1), 10);
    $63170e0df9d207df$var$defaultEncoding = $63170e0df9d207df$var$pVersionMajor >= 6 ? 'utf-8' : 'binary';
} else $63170e0df9d207df$var$defaultEncoding = 'utf-8';
module.exports = $63170e0df9d207df$var$defaultEncoding;

});

parcelRegister("3ypXD", function(module, exports) {
'use strict';

var $4TMvN = parcelRequire("4TMvN");

var $8YCQL = parcelRequire("8YCQL");

var $jmBao = parcelRequire("jmBao");

var $6arys = parcelRequire("6arys");
var $2968af5f276dc341$require$Buffer = $6arys.Buffer;

var $5es4X = parcelRequire("5es4X");

var $8vs9n = parcelRequire("8vs9n");

var $lHyIE = parcelRequire("lHyIE");
var $2968af5f276dc341$var$ZEROS = $2968af5f276dc341$require$Buffer.alloc(128);
var $2968af5f276dc341$var$sizes = {
    __proto__: null,
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    'sha512-256': 32,
    ripemd160: 20,
    rmd160: 20
};
var $2968af5f276dc341$var$mapping = {
    __proto__: null,
    'sha-1': 'sha1',
    'sha-224': 'sha224',
    'sha-256': 'sha256',
    'sha-384': 'sha384',
    'sha-512': 'sha512',
    'ripemd-160': 'ripemd160'
};
function $2968af5f276dc341$var$rmd160Func(data) {
    return new $8YCQL().update(data).digest();
}
function $2968af5f276dc341$var$getDigest(alg) {
    function shaFunc(data) {
        return $jmBao(alg).update(data).digest();
    }
    if (alg === 'rmd160' || alg === 'ripemd160') return $2968af5f276dc341$var$rmd160Func;
    if (alg === 'md5') return $4TMvN;
    return shaFunc;
}
function $2968af5f276dc341$var$Hmac(alg, key, saltLen) {
    var hash = $2968af5f276dc341$var$getDigest(alg);
    var blocksize = alg === 'sha512' || alg === 'sha384' ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $2968af5f276dc341$require$Buffer.concat([
        key,
        $2968af5f276dc341$var$ZEROS
    ], blocksize);
    var ipad = $2968af5f276dc341$require$Buffer.allocUnsafe(blocksize + $2968af5f276dc341$var$sizes[alg]);
    var opad = $2968af5f276dc341$require$Buffer.allocUnsafe(blocksize + $2968af5f276dc341$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $2968af5f276dc341$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $2968af5f276dc341$var$sizes[alg];
}
$2968af5f276dc341$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $2968af5f276dc341$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $5es4X(iterations, keylen);
    password = $lHyIE(password, $8vs9n, 'Password');
    salt = $lHyIE(salt, $8vs9n, 'Salt');
    var lowerDigest = (digest || 'sha1').toLowerCase();
    var mappedDigest = $2968af5f276dc341$var$mapping[lowerDigest] || lowerDigest;
    var size = $2968af5f276dc341$var$sizes[mappedDigest];
    if (typeof size !== 'number' || !size) throw new TypeError('Digest algorithm not supported: ' + digest);
    var hmac = new $2968af5f276dc341$var$Hmac(mappedDigest, password, salt.length);
    var DK = $2968af5f276dc341$require$Buffer.allocUnsafe(keylen);
    var block1 = $2968af5f276dc341$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = size;
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $2968af5f276dc341$var$pbkdf2;

});
parcelRegister("lHyIE", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $fcc88b9db98040ff$require$Buffer = $6arys.Buffer;

var $b7zCt = parcelRequire("b7zCt");
var $fcc88b9db98040ff$var$useUint8Array = typeof Uint8Array !== 'undefined';
var $fcc88b9db98040ff$var$useArrayBuffer = $fcc88b9db98040ff$var$useUint8Array && typeof ArrayBuffer !== 'undefined';
var $fcc88b9db98040ff$var$isView = $fcc88b9db98040ff$var$useArrayBuffer && ArrayBuffer.isView;
module.exports = function(thing, encoding, name) {
    if (typeof thing === 'string' || $fcc88b9db98040ff$require$Buffer.isBuffer(thing) || $fcc88b9db98040ff$var$useUint8Array && thing instanceof Uint8Array || $fcc88b9db98040ff$var$isView && $fcc88b9db98040ff$var$isView(thing)) return $b7zCt(thing, encoding);
    throw new TypeError(name + ' must be a string, a Buffer, a Uint8Array, or a DataView');
};

});




parcelRegister("1jroU", function(module, exports) {

$parcel$export(module.exports, "createCipher", function () { return $0f4cd2065f62481e$export$bdd223f16383713e; }, function (v) { return $0f4cd2065f62481e$export$bdd223f16383713e = v; });
$parcel$export(module.exports, "Cipher", function () { return $0f4cd2065f62481e$export$26e5786e8ac8e530; }, function (v) { return $0f4cd2065f62481e$export$26e5786e8ac8e530 = v; });
$parcel$export(module.exports, "createCipheriv", function () { return $0f4cd2065f62481e$export$2f64596b8cbf08b4; }, function (v) { return $0f4cd2065f62481e$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "Cipheriv", function () { return $0f4cd2065f62481e$export$20533d26f07f1ee0; }, function (v) { return $0f4cd2065f62481e$export$20533d26f07f1ee0 = v; });
$parcel$export(module.exports, "createDecipher", function () { return $0f4cd2065f62481e$export$12ada9414fbc594c; }, function (v) { return $0f4cd2065f62481e$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "Decipher", function () { return $0f4cd2065f62481e$export$2ce6d8d0e8b04e1a; }, function (v) { return $0f4cd2065f62481e$export$2ce6d8d0e8b04e1a = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $0f4cd2065f62481e$export$36b6d6ef312eab39; }, function (v) { return $0f4cd2065f62481e$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "Decipheriv", function () { return $0f4cd2065f62481e$export$f5e7e39d57cd9700; }, function (v) { return $0f4cd2065f62481e$export$f5e7e39d57cd9700 = v; });
$parcel$export(module.exports, "listCiphers", function () { return $0f4cd2065f62481e$export$dedd8dc3dc62b370; }, function (v) { return $0f4cd2065f62481e$export$dedd8dc3dc62b370 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $0f4cd2065f62481e$export$58a258485f1e49f6; }, function (v) { return $0f4cd2065f62481e$export$58a258485f1e49f6 = v; });
var $0f4cd2065f62481e$export$bdd223f16383713e;
var $0f4cd2065f62481e$export$26e5786e8ac8e530;
var $0f4cd2065f62481e$export$2f64596b8cbf08b4;
var $0f4cd2065f62481e$export$20533d26f07f1ee0;
var $0f4cd2065f62481e$export$12ada9414fbc594c;
var $0f4cd2065f62481e$export$2ce6d8d0e8b04e1a;
var $0f4cd2065f62481e$export$36b6d6ef312eab39;
var $0f4cd2065f62481e$export$f5e7e39d57cd9700;
var $0f4cd2065f62481e$export$dedd8dc3dc62b370;
var $0f4cd2065f62481e$export$58a258485f1e49f6;

var $dSBWp = parcelRequire("dSBWp");

var $fAIFp = parcelRequire("fAIFp");

var $j2N95 = parcelRequire("j2N95");

var $6NUeb = parcelRequire("6NUeb");

var $CSL7y = parcelRequire("CSL7y");
function $0f4cd2065f62481e$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($j2N95[suite]) {
        keyLen = $j2N95[suite].key;
        ivLen = $j2N95[suite].iv;
    } else if ($6NUeb[suite]) {
        keyLen = $6NUeb[suite].key * 8;
        ivLen = $6NUeb[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $CSL7y(password, false, keyLen, ivLen);
    return $0f4cd2065f62481e$var$createCipheriv(suite, keys.key, keys.iv);
}
function $0f4cd2065f62481e$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($j2N95[suite]) {
        keyLen = $j2N95[suite].key;
        ivLen = $j2N95[suite].iv;
    } else if ($6NUeb[suite]) {
        keyLen = $6NUeb[suite].key * 8;
        ivLen = $6NUeb[suite].iv;
    } else throw new TypeError('invalid suite type');
    var keys = $CSL7y(password, false, keyLen, ivLen);
    return $0f4cd2065f62481e$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $0f4cd2065f62481e$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($j2N95[suite]) return $fAIFp.createCipheriv(suite, key, iv);
    if ($6NUeb[suite]) return new $dSBWp({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError('invalid suite type');
}
function $0f4cd2065f62481e$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($j2N95[suite]) return $fAIFp.createDecipheriv(suite, key, iv);
    if ($6NUeb[suite]) return new $dSBWp({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError('invalid suite type');
}
function $0f4cd2065f62481e$var$getCiphers() {
    return Object.keys($6NUeb).concat($fAIFp.getCiphers());
}
$0f4cd2065f62481e$export$bdd223f16383713e = $0f4cd2065f62481e$export$26e5786e8ac8e530 = $0f4cd2065f62481e$var$createCipher;
$0f4cd2065f62481e$export$2f64596b8cbf08b4 = $0f4cd2065f62481e$export$20533d26f07f1ee0 = $0f4cd2065f62481e$var$createCipheriv;
$0f4cd2065f62481e$export$12ada9414fbc594c = $0f4cd2065f62481e$export$2ce6d8d0e8b04e1a = $0f4cd2065f62481e$var$createDecipher;
$0f4cd2065f62481e$export$36b6d6ef312eab39 = $0f4cd2065f62481e$export$f5e7e39d57cd9700 = $0f4cd2065f62481e$var$createDecipheriv;
$0f4cd2065f62481e$export$dedd8dc3dc62b370 = $0f4cd2065f62481e$export$58a258485f1e49f6 = $0f4cd2065f62481e$var$getCiphers;

});
parcelRegister("dSBWp", function(module, exports) {

var $4Wbxn = parcelRequire("4Wbxn");

var $jhaQq = parcelRequire("jhaQq");

var $gdc6A = parcelRequire("gdc6A");

var $6arys = parcelRequire("6arys");
var $a1adbfd5c06bccca$require$Buffer = $6arys.Buffer;
var $a1adbfd5c06bccca$var$modes = {
    'des-ede3-cbc': $jhaQq.CBC.instantiate($jhaQq.EDE),
    'des-ede3': $jhaQq.EDE,
    'des-ede-cbc': $jhaQq.CBC.instantiate($jhaQq.EDE),
    'des-ede': $jhaQq.EDE,
    'des-cbc': $jhaQq.CBC.instantiate($jhaQq.DES),
    'des-ecb': $jhaQq.DES
};
$a1adbfd5c06bccca$var$modes.des = $a1adbfd5c06bccca$var$modes['des-cbc'];
$a1adbfd5c06bccca$var$modes.des3 = $a1adbfd5c06bccca$var$modes['des-ede3-cbc'];
module.exports = $a1adbfd5c06bccca$var$DES;
$gdc6A($a1adbfd5c06bccca$var$DES, $4Wbxn);
function $a1adbfd5c06bccca$var$DES(opts) {
    $4Wbxn.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $a1adbfd5c06bccca$var$modes[modeName];
    var type;
    if (opts.decrypt) type = 'decrypt';
    else type = 'encrypt';
    var key = opts.key;
    if (!$a1adbfd5c06bccca$require$Buffer.isBuffer(key)) key = $a1adbfd5c06bccca$require$Buffer.from(key);
    if (modeName === 'des-ede' || modeName === 'des-ede-cbc') key = $a1adbfd5c06bccca$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$a1adbfd5c06bccca$require$Buffer.isBuffer(iv)) iv = $a1adbfd5c06bccca$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$a1adbfd5c06bccca$var$DES.prototype._update = function(data) {
    return $a1adbfd5c06bccca$require$Buffer.from(this._des.update(data));
};
$a1adbfd5c06bccca$var$DES.prototype._final = function() {
    return $a1adbfd5c06bccca$require$Buffer.from(this._des.final());
};

});
parcelRegister("jhaQq", function(module, exports) {

$parcel$export(module.exports, "DES", function () { return $e088046122baa21b$export$cc8859615686b300; }, function (v) { return $e088046122baa21b$export$cc8859615686b300 = v; });
$parcel$export(module.exports, "CBC", function () { return $e088046122baa21b$export$8ad3f227af08fcc5; }, function (v) { return $e088046122baa21b$export$8ad3f227af08fcc5 = v; });
$parcel$export(module.exports, "EDE", function () { return $e088046122baa21b$export$947646e34766044f; }, function (v) { return $e088046122baa21b$export$947646e34766044f = v; });
var $e088046122baa21b$export$eab97d15b1788b8d;
var $e088046122baa21b$export$26e5786e8ac8e530;
var $e088046122baa21b$export$cc8859615686b300;
var $e088046122baa21b$export$8ad3f227af08fcc5;
var $e088046122baa21b$export$947646e34766044f;
'use strict';

$e088046122baa21b$export$eab97d15b1788b8d = (parcelRequire("lJisr"));

$e088046122baa21b$export$26e5786e8ac8e530 = (parcelRequire("1YYJB"));

$e088046122baa21b$export$cc8859615686b300 = (parcelRequire("8AYR4"));

$e088046122baa21b$export$8ad3f227af08fcc5 = (parcelRequire("cX5tY"));

$e088046122baa21b$export$947646e34766044f = (parcelRequire("hJDNU"));

});
parcelRegister("lJisr", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", function () { return $fd1c1e47703a2407$export$cfaef8ed399428b0; }, function (v) { return $fd1c1e47703a2407$export$cfaef8ed399428b0 = v; });
$parcel$export(module.exports, "writeUInt32BE", function () { return $fd1c1e47703a2407$export$a80c7deaea7cbd80; }, function (v) { return $fd1c1e47703a2407$export$a80c7deaea7cbd80 = v; });
$parcel$export(module.exports, "ip", function () { return $fd1c1e47703a2407$export$ed7577ae6e1cd0ef; }, function (v) { return $fd1c1e47703a2407$export$ed7577ae6e1cd0ef = v; });
$parcel$export(module.exports, "rip", function () { return $fd1c1e47703a2407$export$5dcbef3aa594f567; }, function (v) { return $fd1c1e47703a2407$export$5dcbef3aa594f567 = v; });
$parcel$export(module.exports, "pc1", function () { return $fd1c1e47703a2407$export$5bc8001ca71ed9c5; }, function (v) { return $fd1c1e47703a2407$export$5bc8001ca71ed9c5 = v; });
$parcel$export(module.exports, "r28shl", function () { return $fd1c1e47703a2407$export$3e714e2c5d5d8cb2; }, function (v) { return $fd1c1e47703a2407$export$3e714e2c5d5d8cb2 = v; });
$parcel$export(module.exports, "pc2", function () { return $fd1c1e47703a2407$export$94c3e544fd062b7f; }, function (v) { return $fd1c1e47703a2407$export$94c3e544fd062b7f = v; });
$parcel$export(module.exports, "expand", function () { return $fd1c1e47703a2407$export$9f77e0932fb78f72; }, function (v) { return $fd1c1e47703a2407$export$9f77e0932fb78f72 = v; });
$parcel$export(module.exports, "substitute", function () { return $fd1c1e47703a2407$export$d865ce2836f5927f; }, function (v) { return $fd1c1e47703a2407$export$d865ce2836f5927f = v; });
$parcel$export(module.exports, "permute", function () { return $fd1c1e47703a2407$export$95e62ad65da8b7d2; }, function (v) { return $fd1c1e47703a2407$export$95e62ad65da8b7d2 = v; });
$parcel$export(module.exports, "padSplit", function () { return $fd1c1e47703a2407$export$209139ff098c441a; }, function (v) { return $fd1c1e47703a2407$export$209139ff098c441a = v; });
var $fd1c1e47703a2407$export$cfaef8ed399428b0;
var $fd1c1e47703a2407$export$a80c7deaea7cbd80;
var $fd1c1e47703a2407$export$ed7577ae6e1cd0ef;
var $fd1c1e47703a2407$export$5dcbef3aa594f567;
var $fd1c1e47703a2407$export$5bc8001ca71ed9c5;
var $fd1c1e47703a2407$export$3e714e2c5d5d8cb2;
var $fd1c1e47703a2407$export$94c3e544fd062b7f;
var $fd1c1e47703a2407$export$9f77e0932fb78f72;
var $fd1c1e47703a2407$export$d865ce2836f5927f;
var $fd1c1e47703a2407$export$95e62ad65da8b7d2;
var $fd1c1e47703a2407$export$209139ff098c441a;
'use strict';
$fd1c1e47703a2407$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$fd1c1e47703a2407$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$fd1c1e47703a2407$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fd1c1e47703a2407$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fd1c1e47703a2407$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fd1c1e47703a2407$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $fd1c1e47703a2407$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$fd1c1e47703a2407$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $fd1c1e47703a2407$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $fd1c1e47703a2407$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $fd1c1e47703a2407$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $fd1c1e47703a2407$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$fd1c1e47703a2407$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $fd1c1e47703a2407$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$fd1c1e47703a2407$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $fd1c1e47703a2407$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $fd1c1e47703a2407$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $fd1c1e47703a2407$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$fd1c1e47703a2407$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $fd1c1e47703a2407$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $fd1c1e47703a2407$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$fd1c1e47703a2407$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = '0' + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(' ');
};

});

parcelRegister("1YYJB", function(module, exports) {
'use strict';

var $jYzim = parcelRequire("jYzim");
function $171a81abe6a5571e$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $171a81abe6a5571e$var$Cipher;
$171a81abe6a5571e$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$171a81abe6a5571e$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === 'decrypt') return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$171a81abe6a5571e$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$171a81abe6a5571e$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$171a81abe6a5571e$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$171a81abe6a5571e$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$171a81abe6a5571e$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === 'encrypt') last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$171a81abe6a5571e$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$171a81abe6a5571e$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$171a81abe6a5571e$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$171a81abe6a5571e$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $jYzim.equal(this.bufferOff, this.blockSize, 'Not enough data to decrypt');
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});
parcelRegister("jYzim", function(module, exports) {
module.exports = $e8aeffcb33370f73$var$assert;
function $e8aeffcb33370f73$var$assert(val, msg) {
    if (!val) throw new Error(msg || 'Assertion failed');
}
$e8aeffcb33370f73$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || 'Assertion failed: ' + l + ' != ' + r);
};

});


parcelRegister("8AYR4", function(module, exports) {
'use strict';

var $jYzim = parcelRequire("jYzim");

var $gdc6A = parcelRequire("gdc6A");

var $lJisr = parcelRequire("lJisr");

var $1YYJB = parcelRequire("1YYJB");
function $6420e40ccaff3599$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $6420e40ccaff3599$var$DES(options) {
    $1YYJB.call(this, options);
    var state = new $6420e40ccaff3599$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$gdc6A($6420e40ccaff3599$var$DES, $1YYJB);
module.exports = $6420e40ccaff3599$var$DES;
$6420e40ccaff3599$var$DES.create = function create(options) {
    return new $6420e40ccaff3599$var$DES(options);
};
var $6420e40ccaff3599$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$6420e40ccaff3599$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $jYzim.equal(key.length, this.blockSize, 'Invalid key length');
    var kL = $lJisr.readUInt32BE(key, 0);
    var kR = $lJisr.readUInt32BE(key, 4);
    $lJisr.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $6420e40ccaff3599$var$shiftTable[i >>> 1];
        kL = $lJisr.r28shl(kL, shift);
        kR = $lJisr.r28shl(kR, shift);
        $lJisr.pc2(kL, kR, state.keys, i);
    }
};
$6420e40ccaff3599$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $lJisr.readUInt32BE(inp, inOff);
    var r = $lJisr.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $lJisr.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === 'encrypt') this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $lJisr.writeUInt32BE(out, l, outOff);
    $lJisr.writeUInt32BE(out, r, outOff + 4);
};
$6420e40ccaff3599$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$6420e40ccaff3599$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$jYzim.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$6420e40ccaff3599$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $lJisr.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $lJisr.substitute(keyL, keyR);
        var f = $lJisr.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $lJisr.rip(r, l, out, off);
};
$6420e40ccaff3599$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $lJisr.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $lJisr.substitute(keyL, keyR);
        var f = $lJisr.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $lJisr.rip(l, r, out, off);
};

});

parcelRegister("cX5tY", function(module, exports) {

$parcel$export(module.exports, "instantiate", function () { return $96df3f6ffc7cd8ef$export$f9bb8d20ccc7477a; }, function (v) { return $96df3f6ffc7cd8ef$export$f9bb8d20ccc7477a = v; });
var $96df3f6ffc7cd8ef$export$f9bb8d20ccc7477a;
'use strict';

var $jYzim = parcelRequire("jYzim");

var $gdc6A = parcelRequire("gdc6A");
var $96df3f6ffc7cd8ef$var$proto = {};
function $96df3f6ffc7cd8ef$var$CBCState(iv) {
    $jYzim.equal(iv.length, 8, 'Invalid IV length');
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $96df3f6ffc7cd8ef$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $gdc6A(CBC, Base);
    var keys = Object.keys($96df3f6ffc7cd8ef$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $96df3f6ffc7cd8ef$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$96df3f6ffc7cd8ef$export$f9bb8d20ccc7477a = $96df3f6ffc7cd8ef$var$instantiate;
$96df3f6ffc7cd8ef$var$proto._cbcInit = function _cbcInit() {
    var state = new $96df3f6ffc7cd8ef$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$96df3f6ffc7cd8ef$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === 'encrypt') {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("hJDNU", function(module, exports) {
'use strict';

var $jYzim = parcelRequire("jYzim");

var $gdc6A = parcelRequire("gdc6A");

var $1YYJB = parcelRequire("1YYJB");

var $8AYR4 = parcelRequire("8AYR4");
function $ce9583dd472d9202$var$EDEState(type, key) {
    $jYzim.equal(key.length, 24, 'Invalid key length');
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === 'encrypt') this.ciphers = [
        $8AYR4.create({
            type: 'encrypt',
            key: k1
        }),
        $8AYR4.create({
            type: 'decrypt',
            key: k2
        }),
        $8AYR4.create({
            type: 'encrypt',
            key: k3
        })
    ];
    else this.ciphers = [
        $8AYR4.create({
            type: 'decrypt',
            key: k3
        }),
        $8AYR4.create({
            type: 'encrypt',
            key: k2
        }),
        $8AYR4.create({
            type: 'decrypt',
            key: k1
        })
    ];
}
function $ce9583dd472d9202$var$EDE(options) {
    $1YYJB.call(this, options);
    var state = new $ce9583dd472d9202$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$gdc6A($ce9583dd472d9202$var$EDE, $1YYJB);
module.exports = $ce9583dd472d9202$var$EDE;
$ce9583dd472d9202$var$EDE.create = function create(options) {
    return new $ce9583dd472d9202$var$EDE(options);
};
$ce9583dd472d9202$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$ce9583dd472d9202$var$EDE.prototype._pad = $8AYR4.prototype._pad;
$ce9583dd472d9202$var$EDE.prototype._unpad = $8AYR4.prototype._unpad;

});



parcelRegister("fAIFp", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $b59cddb3ce46e7f7$export$2f64596b8cbf08b4; }, function (v) { return $b59cddb3ce46e7f7$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $b59cddb3ce46e7f7$export$36b6d6ef312eab39; }, function (v) { return $b59cddb3ce46e7f7$export$36b6d6ef312eab39 = v; });
$parcel$export(module.exports, "getCiphers", function () { return $b59cddb3ce46e7f7$export$58a258485f1e49f6; }, function (v) { return $b59cddb3ce46e7f7$export$58a258485f1e49f6 = v; });
var $b59cddb3ce46e7f7$export$bdd223f16383713e;
var $b59cddb3ce46e7f7$export$26e5786e8ac8e530;
var $b59cddb3ce46e7f7$export$2f64596b8cbf08b4;
var $b59cddb3ce46e7f7$export$20533d26f07f1ee0;
var $b59cddb3ce46e7f7$export$12ada9414fbc594c;
var $b59cddb3ce46e7f7$export$2ce6d8d0e8b04e1a;
var $b59cddb3ce46e7f7$export$36b6d6ef312eab39;
var $b59cddb3ce46e7f7$export$f5e7e39d57cd9700;
var $b59cddb3ce46e7f7$export$dedd8dc3dc62b370;
var $b59cddb3ce46e7f7$export$58a258485f1e49f6;

var $ccvwJ = parcelRequire("ccvwJ");

var $aHtGX = parcelRequire("aHtGX");

var $4wput = parcelRequire("4wput");
function $b59cddb3ce46e7f7$var$getCiphers() {
    return Object.keys($4wput);
}
$b59cddb3ce46e7f7$export$bdd223f16383713e = $b59cddb3ce46e7f7$export$26e5786e8ac8e530 = $ccvwJ.createCipher;
$b59cddb3ce46e7f7$export$2f64596b8cbf08b4 = $b59cddb3ce46e7f7$export$20533d26f07f1ee0 = $ccvwJ.createCipheriv;
$b59cddb3ce46e7f7$export$12ada9414fbc594c = $b59cddb3ce46e7f7$export$2ce6d8d0e8b04e1a = $aHtGX.createDecipher;
$b59cddb3ce46e7f7$export$36b6d6ef312eab39 = $b59cddb3ce46e7f7$export$f5e7e39d57cd9700 = $aHtGX.createDecipheriv;
$b59cddb3ce46e7f7$export$dedd8dc3dc62b370 = $b59cddb3ce46e7f7$export$58a258485f1e49f6 = $b59cddb3ce46e7f7$var$getCiphers;

});
parcelRegister("ccvwJ", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", function () { return $8e1f0f980d7feda3$export$2f64596b8cbf08b4; }, function (v) { return $8e1f0f980d7feda3$export$2f64596b8cbf08b4 = v; });
$parcel$export(module.exports, "createCipher", function () { return $8e1f0f980d7feda3$export$bdd223f16383713e; }, function (v) { return $8e1f0f980d7feda3$export$bdd223f16383713e = v; });
var $8e1f0f980d7feda3$export$2f64596b8cbf08b4;
var $8e1f0f980d7feda3$export$bdd223f16383713e;

var $j2N95 = parcelRequire("j2N95");

var $7J6cz = parcelRequire("7J6cz");

var $6arys = parcelRequire("6arys");
var $8e1f0f980d7feda3$require$Buffer = $6arys.Buffer;

var $7jLnt = parcelRequire("7jLnt");

var $4Wbxn = parcelRequire("4Wbxn");

var $JV6Nk = parcelRequire("JV6Nk");

var $CSL7y = parcelRequire("CSL7y");

var $gdc6A = parcelRequire("gdc6A");
function $8e1f0f980d7feda3$var$Cipher(mode, key, iv) {
    $4Wbxn.call(this);
    this._cache = new $8e1f0f980d7feda3$var$Splitter();
    this._cipher = new $JV6Nk.AES(key);
    this._prev = $8e1f0f980d7feda3$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$gdc6A($8e1f0f980d7feda3$var$Cipher, $4Wbxn);
$8e1f0f980d7feda3$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $8e1f0f980d7feda3$require$Buffer.concat(out);
};
var $8e1f0f980d7feda3$var$PADDING = $8e1f0f980d7feda3$require$Buffer.alloc(16, 0x10);
$8e1f0f980d7feda3$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($8e1f0f980d7feda3$var$PADDING)) {
        this._cipher.scrub();
        throw new Error('data not multiple of block length');
    }
};
$8e1f0f980d7feda3$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $8e1f0f980d7feda3$var$Splitter() {
    this.cache = $8e1f0f980d7feda3$require$Buffer.allocUnsafe(0);
}
$8e1f0f980d7feda3$var$Splitter.prototype.add = function(data) {
    this.cache = $8e1f0f980d7feda3$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$8e1f0f980d7feda3$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$8e1f0f980d7feda3$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $8e1f0f980d7feda3$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $8e1f0f980d7feda3$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $8e1f0f980d7feda3$var$createCipheriv(suite, password, iv) {
    var config = $j2N95[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof password === 'string') password = $8e1f0f980d7feda3$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (typeof iv === 'string') iv = $8e1f0f980d7feda3$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (config.type === 'stream') return new $7jLnt(config.module, password, iv);
    else if (config.type === 'auth') return new $7J6cz(config.module, password, iv);
    return new $8e1f0f980d7feda3$var$Cipher(config.module, password, iv);
}
function $8e1f0f980d7feda3$var$createCipher(suite, password) {
    var config = $j2N95[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $CSL7y(password, false, config.key, config.iv);
    return $8e1f0f980d7feda3$var$createCipheriv(suite, keys.key, keys.iv);
}
$8e1f0f980d7feda3$export$2f64596b8cbf08b4 = $8e1f0f980d7feda3$var$createCipheriv;
$8e1f0f980d7feda3$export$bdd223f16383713e = $8e1f0f980d7feda3$var$createCipher;

});
parcelRegister("j2N95", function(module, exports) {








var $ddd453858c8a66c0$var$modeModules = {
    ECB: (parcelRequire("ePlWq")),
    CBC: (parcelRequire("22SyV")),
    CFB: (parcelRequire("6uRHH")),
    CFB8: (parcelRequire("lk4fY")),
    CFB1: (parcelRequire("2OKOp")),
    OFB: (parcelRequire("lGrZo")),
    CTR: (parcelRequire("7rHJx")),
    GCM: (parcelRequire("7rHJx"))
};

var $4wput = parcelRequire("4wput");
for(var $ddd453858c8a66c0$var$key in $4wput)$4wput[$ddd453858c8a66c0$var$key].module = $ddd453858c8a66c0$var$modeModules[$4wput[$ddd453858c8a66c0$var$key].mode];
module.exports = $4wput;

});
parcelRegister("ePlWq", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $acb6d93664d3007a$export$5b0f6292f11d1d18; }, function (v) { return $acb6d93664d3007a$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $acb6d93664d3007a$export$e85a0c9a1067c5d3; }, function (v) { return $acb6d93664d3007a$export$e85a0c9a1067c5d3 = v; });
var $acb6d93664d3007a$export$5b0f6292f11d1d18;
var $acb6d93664d3007a$export$e85a0c9a1067c5d3;
$acb6d93664d3007a$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$acb6d93664d3007a$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("22SyV", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $17d6179f927365e2$export$5b0f6292f11d1d18; }, function (v) { return $17d6179f927365e2$export$5b0f6292f11d1d18 = v; });
$parcel$export(module.exports, "decrypt", function () { return $17d6179f927365e2$export$e85a0c9a1067c5d3; }, function (v) { return $17d6179f927365e2$export$e85a0c9a1067c5d3 = v; });
var $17d6179f927365e2$export$5b0f6292f11d1d18;
var $17d6179f927365e2$export$e85a0c9a1067c5d3;

var $jvchf = parcelRequire("jvchf");
$17d6179f927365e2$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $jvchf(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$17d6179f927365e2$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $jvchf(out, pad);
};

});
parcelRegister("jvchf", function(module, exports) {

var $kJBqN = parcelRequire("kJBqN");
var $e32a6f8e80ecb9e0$require$Buffer = $kJBqN.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $e32a6f8e80ecb9e0$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("6uRHH", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $4baf33df25374fff$export$5b0f6292f11d1d18; }, function (v) { return $4baf33df25374fff$export$5b0f6292f11d1d18 = v; });
var $4baf33df25374fff$export$5b0f6292f11d1d18;

var $6arys = parcelRequire("6arys");
var $4baf33df25374fff$require$Buffer = $6arys.Buffer;

var $jvchf = parcelRequire("jvchf");
function $4baf33df25374fff$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $jvchf(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $4baf33df25374fff$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$4baf33df25374fff$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $4baf33df25374fff$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $4baf33df25374fff$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $4baf33df25374fff$require$Buffer.concat([
                out,
                $4baf33df25374fff$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $4baf33df25374fff$require$Buffer.concat([
                out,
                $4baf33df25374fff$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("lk4fY", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $f85ec4849b014537$export$5b0f6292f11d1d18; }, function (v) { return $f85ec4849b014537$export$5b0f6292f11d1d18 = v; });
var $f85ec4849b014537$export$5b0f6292f11d1d18;

var $6arys = parcelRequire("6arys");
var $f85ec4849b014537$require$Buffer = $6arys.Buffer;
function $f85ec4849b014537$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $f85ec4849b014537$require$Buffer.concat([
        self._prev.slice(1),
        $f85ec4849b014537$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$f85ec4849b014537$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $f85ec4849b014537$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $f85ec4849b014537$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("2OKOp", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $20d4902a3eb09f06$export$5b0f6292f11d1d18; }, function (v) { return $20d4902a3eb09f06$export$5b0f6292f11d1d18 = v; });
var $20d4902a3eb09f06$export$5b0f6292f11d1d18;

var $6arys = parcelRequire("6arys");
var $20d4902a3eb09f06$require$Buffer = $6arys.Buffer;
function $20d4902a3eb09f06$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $20d4902a3eb09f06$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $20d4902a3eb09f06$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $20d4902a3eb09f06$require$Buffer.allocUnsafe(buffer.length);
    buffer = $20d4902a3eb09f06$require$Buffer.concat([
        buffer,
        $20d4902a3eb09f06$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$20d4902a3eb09f06$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $20d4902a3eb09f06$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $20d4902a3eb09f06$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("lGrZo", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $fc933b4c17838bae$export$5b0f6292f11d1d18; }, function (v) { return $fc933b4c17838bae$export$5b0f6292f11d1d18 = v; });
var $fc933b4c17838bae$export$5b0f6292f11d1d18;

var $kJBqN = parcelRequire("kJBqN");
var $fc933b4c17838bae$require$Buffer = $kJBqN.Buffer;

var $jvchf = parcelRequire("jvchf");
function $fc933b4c17838bae$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$fc933b4c17838bae$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $fc933b4c17838bae$require$Buffer.concat([
        self._cache,
        $fc933b4c17838bae$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $jvchf(chunk, pad);
};

});

parcelRegister("7rHJx", function(module, exports) {

$parcel$export(module.exports, "encrypt", function () { return $56bcfa98dbf68d20$export$5b0f6292f11d1d18; }, function (v) { return $56bcfa98dbf68d20$export$5b0f6292f11d1d18 = v; });
var $56bcfa98dbf68d20$export$5b0f6292f11d1d18;

var $jvchf = parcelRequire("jvchf");

var $6arys = parcelRequire("6arys");
var $56bcfa98dbf68d20$require$Buffer = $6arys.Buffer;

var $fTPHl = parcelRequire("fTPHl");
function $56bcfa98dbf68d20$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $fTPHl(self._prev);
    return out;
}
var $56bcfa98dbf68d20$var$blockSize = 16;
$56bcfa98dbf68d20$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $56bcfa98dbf68d20$var$blockSize);
    var start = self._cache.length;
    self._cache = $56bcfa98dbf68d20$require$Buffer.concat([
        self._cache,
        $56bcfa98dbf68d20$require$Buffer.allocUnsafe(chunkNum * $56bcfa98dbf68d20$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $56bcfa98dbf68d20$var$getBlock(self);
        var offset = start + i * $56bcfa98dbf68d20$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $jvchf(chunk, pad);
};

});
parcelRegister("fTPHl", function(module, exports) {
function $b9341842b3f404b0$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $b9341842b3f404b0$var$incr32;

});


parcelRegister("4wput", function(module, exports) {
module.exports = JSON.parse("{\"aes-128-ecb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-192-ecb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-256-ecb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":0,\"mode\":\"ECB\",\"type\":\"block\"},\"aes-128-cbc\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-192-cbc\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-256-cbc\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes128\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes192\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes256\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CBC\",\"type\":\"block\"},\"aes-128-cfb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-192-cfb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-256-cfb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB\",\"type\":\"stream\"},\"aes-128-cfb8\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-192-cfb8\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-256-cfb8\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB8\",\"type\":\"stream\"},\"aes-128-cfb1\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-192-cfb1\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-256-cfb1\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CFB1\",\"type\":\"stream\"},\"aes-128-ofb\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-192-ofb\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-256-ofb\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"OFB\",\"type\":\"stream\"},\"aes-128-ctr\":{\"cipher\":\"AES\",\"key\":128,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-192-ctr\":{\"cipher\":\"AES\",\"key\":192,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-256-ctr\":{\"cipher\":\"AES\",\"key\":256,\"iv\":16,\"mode\":\"CTR\",\"type\":\"stream\"},\"aes-128-gcm\":{\"cipher\":\"AES\",\"key\":128,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-192-gcm\":{\"cipher\":\"AES\",\"key\":192,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"},\"aes-256-gcm\":{\"cipher\":\"AES\",\"key\":256,\"iv\":12,\"mode\":\"GCM\",\"type\":\"auth\"}}");

});


parcelRegister("7J6cz", function(module, exports) {

var $JV6Nk = parcelRequire("JV6Nk");

var $6arys = parcelRequire("6arys");
var $5a018bea9ec85902$require$Buffer = $6arys.Buffer;

var $4Wbxn = parcelRequire("4Wbxn");

var $gdc6A = parcelRequire("gdc6A");

var $h6gA0 = parcelRequire("h6gA0");

var $jvchf = parcelRequire("jvchf");

var $fTPHl = parcelRequire("fTPHl");
function $5a018bea9ec85902$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $5a018bea9ec85902$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $5a018bea9ec85902$require$Buffer.concat([
            iv,
            $5a018bea9ec85902$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $5a018bea9ec85902$require$Buffer.concat([
            iv,
            $5a018bea9ec85902$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $h6gA0(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($5a018bea9ec85902$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($5a018bea9ec85902$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $5a018bea9ec85902$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $5a018bea9ec85902$require$Buffer.from(self._finID);
    $fTPHl(out);
    return out;
}
function $5a018bea9ec85902$var$StreamCipher(mode, key, iv, decrypt) {
    $4Wbxn.call(this);
    var h = $5a018bea9ec85902$require$Buffer.alloc(4, 0);
    this._cipher = new $JV6Nk.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $h6gA0(ck);
    iv = $5a018bea9ec85902$var$calcIv(this, iv, ck);
    this._prev = $5a018bea9ec85902$require$Buffer.from(iv);
    this._cache = $5a018bea9ec85902$require$Buffer.allocUnsafe(0);
    this._secCache = $5a018bea9ec85902$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$gdc6A($5a018bea9ec85902$var$StreamCipher, $4Wbxn);
$5a018bea9ec85902$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $5a018bea9ec85902$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$5a018bea9ec85902$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error('Unsupported state or unable to authenticate data');
    var tag = $jvchf(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $5a018bea9ec85902$var$xorTest(tag, this._authTag)) throw new Error('Unsupported state or unable to authenticate data');
    this._authTag = tag;
    this._cipher.scrub();
};
$5a018bea9ec85902$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$5a018bea9ec85902$require$Buffer.isBuffer(this._authTag)) throw new Error('Attempting to get auth tag in unsupported state');
    return this._authTag;
};
$5a018bea9ec85902$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error('Attempting to set auth tag in unsupported state');
    this._authTag = tag;
};
$5a018bea9ec85902$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error('Attempting to set AAD in unsupported state');
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $5a018bea9ec85902$var$StreamCipher;

});
parcelRegister("JV6Nk", function(module, exports) {

$parcel$export(module.exports, "AES", function () { return $08a080a8fc8ccbd0$export$b80fbe1c3a2b92b5; }, function (v) { return $08a080a8fc8ccbd0$export$b80fbe1c3a2b92b5 = v; });
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $08a080a8fc8ccbd0$export$b80fbe1c3a2b92b5;

var $6arys = parcelRequire("6arys");
var $08a080a8fc8ccbd0$require$Buffer = $6arys.Buffer;
function $08a080a8fc8ccbd0$var$asUInt32Array(buf) {
    if (!$08a080a8fc8ccbd0$require$Buffer.isBuffer(buf)) buf = $08a080a8fc8ccbd0$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $08a080a8fc8ccbd0$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $08a080a8fc8ccbd0$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $08a080a8fc8ccbd0$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $08a080a8fc8ccbd0$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $08a080a8fc8ccbd0$var$AES(key) {
    this._key = $08a080a8fc8ccbd0$var$asUInt32Array(key);
    this._reset();
}
$08a080a8fc8ccbd0$var$AES.blockSize = 16;
$08a080a8fc8ccbd0$var$AES.keySize = 32;
$08a080a8fc8ccbd0$var$AES.prototype.blockSize = $08a080a8fc8ccbd0$var$AES.blockSize;
$08a080a8fc8ccbd0$var$AES.prototype.keySize = $08a080a8fc8ccbd0$var$AES.keySize;
$08a080a8fc8ccbd0$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $08a080a8fc8ccbd0$var$G.SBOX[t >>> 24] << 24 | $08a080a8fc8ccbd0$var$G.SBOX[t >>> 16 & 0xff] << 16 | $08a080a8fc8ccbd0$var$G.SBOX[t >>> 8 & 0xff] << 8 | $08a080a8fc8ccbd0$var$G.SBOX[t & 0xff];
            t ^= $08a080a8fc8ccbd0$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $08a080a8fc8ccbd0$var$G.SBOX[t >>> 24] << 24 | $08a080a8fc8ccbd0$var$G.SBOX[t >>> 16 & 0xff] << 16 | $08a080a8fc8ccbd0$var$G.SBOX[t >>> 8 & 0xff] << 8 | $08a080a8fc8ccbd0$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $08a080a8fc8ccbd0$var$G.INV_SUB_MIX[0][$08a080a8fc8ccbd0$var$G.SBOX[tt >>> 24]] ^ $08a080a8fc8ccbd0$var$G.INV_SUB_MIX[1][$08a080a8fc8ccbd0$var$G.SBOX[tt >>> 16 & 0xff]] ^ $08a080a8fc8ccbd0$var$G.INV_SUB_MIX[2][$08a080a8fc8ccbd0$var$G.SBOX[tt >>> 8 & 0xff]] ^ $08a080a8fc8ccbd0$var$G.INV_SUB_MIX[3][$08a080a8fc8ccbd0$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$08a080a8fc8ccbd0$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $08a080a8fc8ccbd0$var$asUInt32Array(M);
    return $08a080a8fc8ccbd0$var$cryptBlock(M, this._keySchedule, $08a080a8fc8ccbd0$var$G.SUB_MIX, $08a080a8fc8ccbd0$var$G.SBOX, this._nRounds);
};
$08a080a8fc8ccbd0$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $08a080a8fc8ccbd0$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$08a080a8fc8ccbd0$var$AES.prototype.decryptBlock = function(M) {
    M = $08a080a8fc8ccbd0$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $08a080a8fc8ccbd0$var$cryptBlock(M, this._invKeySchedule, $08a080a8fc8ccbd0$var$G.INV_SUB_MIX, $08a080a8fc8ccbd0$var$G.INV_SBOX, this._nRounds);
    var buf = $08a080a8fc8ccbd0$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$08a080a8fc8ccbd0$var$AES.prototype.scrub = function() {
    $08a080a8fc8ccbd0$var$scrubVec(this._keySchedule);
    $08a080a8fc8ccbd0$var$scrubVec(this._invKeySchedule);
    $08a080a8fc8ccbd0$var$scrubVec(this._key);
};
$08a080a8fc8ccbd0$export$b80fbe1c3a2b92b5 = $08a080a8fc8ccbd0$var$AES;

});

parcelRegister("h6gA0", function(module, exports) {

var $6arys = parcelRequire("6arys");
var $c72fdb9500e932a0$require$Buffer = $6arys.Buffer;
var $c72fdb9500e932a0$var$ZEROES = $c72fdb9500e932a0$require$Buffer.alloc(16, 0);
function $c72fdb9500e932a0$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $c72fdb9500e932a0$var$fromArray(out) {
    var buf = $c72fdb9500e932a0$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $c72fdb9500e932a0$var$GHASH(key) {
    this.h = key;
    this.state = $c72fdb9500e932a0$require$Buffer.alloc(16, 0);
    this.cache = $c72fdb9500e932a0$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$c72fdb9500e932a0$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$c72fdb9500e932a0$var$GHASH.prototype._multiply = function() {
    var Vi = $c72fdb9500e932a0$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $c72fdb9500e932a0$var$fromArray(Zi);
};
$c72fdb9500e932a0$var$GHASH.prototype.update = function(buf) {
    this.cache = $c72fdb9500e932a0$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$c72fdb9500e932a0$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($c72fdb9500e932a0$require$Buffer.concat([
        this.cache,
        $c72fdb9500e932a0$var$ZEROES
    ], 16));
    this.ghash($c72fdb9500e932a0$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $c72fdb9500e932a0$var$GHASH;

});


parcelRegister("7jLnt", function(module, exports) {

var $JV6Nk = parcelRequire("JV6Nk");

var $6arys = parcelRequire("6arys");
var $553f0eeea796fd47$require$Buffer = $6arys.Buffer;

var $4Wbxn = parcelRequire("4Wbxn");

var $gdc6A = parcelRequire("gdc6A");
function $553f0eeea796fd47$var$StreamCipher(mode, key, iv, decrypt) {
    $4Wbxn.call(this);
    this._cipher = new $JV6Nk.AES(key);
    this._prev = $553f0eeea796fd47$require$Buffer.from(iv);
    this._cache = $553f0eeea796fd47$require$Buffer.allocUnsafe(0);
    this._secCache = $553f0eeea796fd47$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$gdc6A($553f0eeea796fd47$var$StreamCipher, $4Wbxn);
$553f0eeea796fd47$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$553f0eeea796fd47$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $553f0eeea796fd47$var$StreamCipher;

});

parcelRegister("CSL7y", function(module, exports) {

var $6arys = parcelRequire("6arys");
var $074e06b97013f9a0$require$Buffer = $6arys.Buffer;

var $hoDvy = parcelRequire("hoDvy");
/* eslint-disable camelcase */ function $074e06b97013f9a0$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$074e06b97013f9a0$require$Buffer.isBuffer(password)) password = $074e06b97013f9a0$require$Buffer.from(password, 'binary');
    if (salt) {
        if (!$074e06b97013f9a0$require$Buffer.isBuffer(salt)) salt = $074e06b97013f9a0$require$Buffer.from(salt, 'binary');
        if (salt.length !== 8) throw new RangeError('salt should be Buffer with 8 byte length');
    }
    var keyLen = keyBits / 8;
    var key = $074e06b97013f9a0$require$Buffer.alloc(keyLen);
    var iv = $074e06b97013f9a0$require$Buffer.alloc(ivLen || 0);
    var tmp = $074e06b97013f9a0$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $hoDvy();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $074e06b97013f9a0$var$EVP_BytesToKey;

});


parcelRegister("aHtGX", function(module, exports) {

$parcel$export(module.exports, "createDecipher", function () { return $7ca4f3be7eaab95c$export$12ada9414fbc594c; }, function (v) { return $7ca4f3be7eaab95c$export$12ada9414fbc594c = v; });
$parcel$export(module.exports, "createDecipheriv", function () { return $7ca4f3be7eaab95c$export$36b6d6ef312eab39; }, function (v) { return $7ca4f3be7eaab95c$export$36b6d6ef312eab39 = v; });
var $7ca4f3be7eaab95c$export$12ada9414fbc594c;
var $7ca4f3be7eaab95c$export$36b6d6ef312eab39;

var $7J6cz = parcelRequire("7J6cz");

var $6arys = parcelRequire("6arys");
var $7ca4f3be7eaab95c$require$Buffer = $6arys.Buffer;

var $j2N95 = parcelRequire("j2N95");

var $7jLnt = parcelRequire("7jLnt");

var $4Wbxn = parcelRequire("4Wbxn");

var $JV6Nk = parcelRequire("JV6Nk");

var $CSL7y = parcelRequire("CSL7y");

var $gdc6A = parcelRequire("gdc6A");
function $7ca4f3be7eaab95c$var$Decipher(mode, key, iv) {
    $4Wbxn.call(this);
    this._cache = new $7ca4f3be7eaab95c$var$Splitter();
    this._last = void 0;
    this._cipher = new $JV6Nk.AES(key);
    this._prev = $7ca4f3be7eaab95c$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$gdc6A($7ca4f3be7eaab95c$var$Decipher, $4Wbxn);
$7ca4f3be7eaab95c$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7ca4f3be7eaab95c$require$Buffer.concat(out);
};
$7ca4f3be7eaab95c$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7ca4f3be7eaab95c$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error('data not multiple of block length');
};
$7ca4f3be7eaab95c$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7ca4f3be7eaab95c$var$Splitter() {
    this.cache = $7ca4f3be7eaab95c$require$Buffer.allocUnsafe(0);
}
$7ca4f3be7eaab95c$var$Splitter.prototype.add = function(data) {
    this.cache = $7ca4f3be7eaab95c$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7ca4f3be7eaab95c$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7ca4f3be7eaab95c$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7ca4f3be7eaab95c$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error('unable to decrypt data');
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error('unable to decrypt data');
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7ca4f3be7eaab95c$var$createDecipheriv(suite, password, iv) {
    var config = $j2N95[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    if (typeof iv === 'string') iv = $7ca4f3be7eaab95c$require$Buffer.from(iv);
    if (config.mode !== 'GCM' && iv.length !== config.iv) throw new TypeError('invalid iv length ' + iv.length);
    if (typeof password === 'string') password = $7ca4f3be7eaab95c$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError('invalid key length ' + password.length);
    if (config.type === 'stream') return new $7jLnt(config.module, password, iv, true);
    else if (config.type === 'auth') return new $7J6cz(config.module, password, iv, true);
    return new $7ca4f3be7eaab95c$var$Decipher(config.module, password, iv);
}
function $7ca4f3be7eaab95c$var$createDecipher(suite, password) {
    var config = $j2N95[suite.toLowerCase()];
    if (!config) throw new TypeError('invalid suite type');
    var keys = $CSL7y(password, false, config.key, config.iv);
    return $7ca4f3be7eaab95c$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7ca4f3be7eaab95c$export$12ada9414fbc594c = $7ca4f3be7eaab95c$var$createDecipher;
$7ca4f3be7eaab95c$export$36b6d6ef312eab39 = $7ca4f3be7eaab95c$var$createDecipheriv;

});


parcelRegister("6NUeb", function(module, exports) {

$parcel$export(module.exports, "des-ecb", function () { return $4f42ef5dcfff0750$export$116f8a5cee447347; }, function (v) { return $4f42ef5dcfff0750$export$116f8a5cee447347 = v; });
$parcel$export(module.exports, "des-cbc", function () { return $4f42ef5dcfff0750$export$7483c4066bfb7ae9; }, function (v) { return $4f42ef5dcfff0750$export$7483c4066bfb7ae9 = v; });
$parcel$export(module.exports, "des", function () { return $4f42ef5dcfff0750$export$e7a565d2e588bb06; }, function (v) { return $4f42ef5dcfff0750$export$e7a565d2e588bb06 = v; });
$parcel$export(module.exports, "des-ede3-cbc", function () { return $4f42ef5dcfff0750$export$aaa2f54a426f3eb8; }, function (v) { return $4f42ef5dcfff0750$export$aaa2f54a426f3eb8 = v; });
$parcel$export(module.exports, "des3", function () { return $4f42ef5dcfff0750$export$eba20568dde4ada; }, function (v) { return $4f42ef5dcfff0750$export$eba20568dde4ada = v; });
$parcel$export(module.exports, "des-ede3", function () { return $4f42ef5dcfff0750$export$d3b5e5996938f5ae; }, function (v) { return $4f42ef5dcfff0750$export$d3b5e5996938f5ae = v; });
$parcel$export(module.exports, "des-ede-cbc", function () { return $4f42ef5dcfff0750$export$57c08356130bc99b; }, function (v) { return $4f42ef5dcfff0750$export$57c08356130bc99b = v; });
$parcel$export(module.exports, "des-ede", function () { return $4f42ef5dcfff0750$export$c7169791d5c1e65d; }, function (v) { return $4f42ef5dcfff0750$export$c7169791d5c1e65d = v; });
var $4f42ef5dcfff0750$export$116f8a5cee447347;
var $4f42ef5dcfff0750$export$7483c4066bfb7ae9;
var $4f42ef5dcfff0750$export$e7a565d2e588bb06;
var $4f42ef5dcfff0750$export$aaa2f54a426f3eb8;
var $4f42ef5dcfff0750$export$eba20568dde4ada;
var $4f42ef5dcfff0750$export$d3b5e5996938f5ae;
var $4f42ef5dcfff0750$export$57c08356130bc99b;
var $4f42ef5dcfff0750$export$c7169791d5c1e65d;
$4f42ef5dcfff0750$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$4f42ef5dcfff0750$export$7483c4066bfb7ae9 = $4f42ef5dcfff0750$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$4f42ef5dcfff0750$export$aaa2f54a426f3eb8 = $4f42ef5dcfff0750$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$4f42ef5dcfff0750$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$4f42ef5dcfff0750$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$4f42ef5dcfff0750$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};

});


parcelRegister("dtEem", function(module, exports) {

$parcel$export(module.exports, "DiffieHellmanGroup", function () { return $9cfd30c4827588e7$export$971862a2fcb1bb40; }, function (v) { return $9cfd30c4827588e7$export$971862a2fcb1bb40 = v; });
$parcel$export(module.exports, "createDiffieHellmanGroup", function () { return $9cfd30c4827588e7$export$c6ff6a88acbeaf40; }, function (v) { return $9cfd30c4827588e7$export$c6ff6a88acbeaf40 = v; });
$parcel$export(module.exports, "getDiffieHellman", function () { return $9cfd30c4827588e7$export$fdc27893e98845cc; }, function (v) { return $9cfd30c4827588e7$export$fdc27893e98845cc = v; });
$parcel$export(module.exports, "createDiffieHellman", function () { return $9cfd30c4827588e7$export$6671fb9a1323bed; }, function (v) { return $9cfd30c4827588e7$export$6671fb9a1323bed = v; });
$parcel$export(module.exports, "DiffieHellman", function () { return $9cfd30c4827588e7$export$d74daf141a551db; }, function (v) { return $9cfd30c4827588e7$export$d74daf141a551db = v; });
var $9cfd30c4827588e7$export$971862a2fcb1bb40;
var $9cfd30c4827588e7$export$c6ff6a88acbeaf40;
var $9cfd30c4827588e7$export$fdc27893e98845cc;
var $9cfd30c4827588e7$export$6671fb9a1323bed;
var $9cfd30c4827588e7$export$d74daf141a551db;

var $kJBqN = parcelRequire("kJBqN");
var $9cfd30c4827588e7$require$Buffer = $kJBqN.Buffer;

var $hO6NZ = parcelRequire("hO6NZ");

var $gmHyS = parcelRequire("gmHyS");

var $9SBGE = parcelRequire("9SBGE");
function $9cfd30c4827588e7$var$getDiffieHellman(mod) {
    var prime = new $9cfd30c4827588e7$require$Buffer($gmHyS[mod].prime, 'hex');
    var gen = new $9cfd30c4827588e7$require$Buffer($gmHyS[mod].gen, 'hex');
    return new $9SBGE(prime, gen);
}
var $9cfd30c4827588e7$var$ENCODINGS = {
    'binary': true,
    'hex': true,
    'base64': true
};
function $9cfd30c4827588e7$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($9cfd30c4827588e7$require$Buffer.isBuffer(enc) || $9cfd30c4827588e7$var$ENCODINGS[enc] === undefined) return $9cfd30c4827588e7$var$createDiffieHellman(prime, 'binary', enc, generator);
    enc = enc || 'binary';
    genc = genc || 'binary';
    generator = generator || new $9cfd30c4827588e7$require$Buffer([
        2
    ]);
    if (!$9cfd30c4827588e7$require$Buffer.isBuffer(generator)) generator = new $9cfd30c4827588e7$require$Buffer(generator, genc);
    if (typeof prime === 'number') return new $9SBGE($hO6NZ(prime, generator), generator, true);
    if (!$9cfd30c4827588e7$require$Buffer.isBuffer(prime)) prime = new $9cfd30c4827588e7$require$Buffer(prime, enc);
    return new $9SBGE(prime, generator, true);
}
$9cfd30c4827588e7$export$971862a2fcb1bb40 = $9cfd30c4827588e7$export$c6ff6a88acbeaf40 = $9cfd30c4827588e7$export$fdc27893e98845cc = $9cfd30c4827588e7$var$getDiffieHellman;
$9cfd30c4827588e7$export$6671fb9a1323bed = $9cfd30c4827588e7$export$d74daf141a551db = $9cfd30c4827588e7$var$createDiffieHellman;

});
parcelRegister("hO6NZ", function(module, exports) {

var $l0MtO = parcelRequire("l0MtO");
module.exports = $cf6c629533cf52e2$var$findPrime;
$cf6c629533cf52e2$var$findPrime.simpleSieve = $cf6c629533cf52e2$var$simpleSieve;
$cf6c629533cf52e2$var$findPrime.fermatTest = $cf6c629533cf52e2$var$fermatTest;

var $hyFoa = parcelRequire("hyFoa");
var $cf6c629533cf52e2$var$TWENTYFOUR = new $hyFoa(24);

var $4zw3r = parcelRequire("4zw3r");
var $cf6c629533cf52e2$var$millerRabin = new $4zw3r();
var $cf6c629533cf52e2$var$ONE = new $hyFoa(1);
var $cf6c629533cf52e2$var$TWO = new $hyFoa(2);
var $cf6c629533cf52e2$var$FIVE = new $hyFoa(5);
var $cf6c629533cf52e2$var$SIXTEEN = new $hyFoa(16);
var $cf6c629533cf52e2$var$EIGHT = new $hyFoa(8);
var $cf6c629533cf52e2$var$TEN = new $hyFoa(10);
var $cf6c629533cf52e2$var$THREE = new $hyFoa(3);
var $cf6c629533cf52e2$var$SEVEN = new $hyFoa(7);
var $cf6c629533cf52e2$var$ELEVEN = new $hyFoa(11);
var $cf6c629533cf52e2$var$FOUR = new $hyFoa(4);
var $cf6c629533cf52e2$var$TWELVE = new $hyFoa(12);
var $cf6c629533cf52e2$var$primes = null;
function $cf6c629533cf52e2$var$_getPrimes() {
    if ($cf6c629533cf52e2$var$primes !== null) return $cf6c629533cf52e2$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $cf6c629533cf52e2$var$primes = res;
    return res;
}
function $cf6c629533cf52e2$var$simpleSieve(p) {
    var primes = $cf6c629533cf52e2$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $cf6c629533cf52e2$var$fermatTest(p) {
    var red = $hyFoa.mont(p);
    return $cf6c629533cf52e2$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $cf6c629533cf52e2$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $hyFoa([
            0x8c,
            0x7b
        ]);
        else return new $hyFoa([
            0x8c,
            0x27
        ]);
    }
    gen = new $hyFoa(gen);
    var num, n2;
    while(true){
        num = new $hyFoa($l0MtO(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($cf6c629533cf52e2$var$ONE);
        if (!num.testn(1)) num.iadd($cf6c629533cf52e2$var$TWO);
        if (!gen.cmp($cf6c629533cf52e2$var$TWO)) while(num.mod($cf6c629533cf52e2$var$TWENTYFOUR).cmp($cf6c629533cf52e2$var$ELEVEN))num.iadd($cf6c629533cf52e2$var$FOUR);
        else if (!gen.cmp($cf6c629533cf52e2$var$FIVE)) while(num.mod($cf6c629533cf52e2$var$TEN).cmp($cf6c629533cf52e2$var$THREE))num.iadd($cf6c629533cf52e2$var$FOUR);
        n2 = num.shrn(1);
        if ($cf6c629533cf52e2$var$simpleSieve(n2) && $cf6c629533cf52e2$var$simpleSieve(num) && $cf6c629533cf52e2$var$fermatTest(n2) && $cf6c629533cf52e2$var$fermatTest(num) && $cf6c629533cf52e2$var$millerRabin.test(n2) && $cf6c629533cf52e2$var$millerRabin.test(num)) return num;
    }
}

});
parcelRegister("hyFoa", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("4zw3r", function(module, exports) {

var $4cf3v = parcelRequire("4cf3v");

var $71KMl = parcelRequire("71KMl");
function $35434bb0aa2830e3$var$MillerRabin(rand) {
    this.rand = rand || new $71KMl.Rand();
}
module.exports = $35434bb0aa2830e3$var$MillerRabin;
$35434bb0aa2830e3$var$MillerRabin.create = function create(rand) {
    return new $35434bb0aa2830e3$var$MillerRabin(rand);
};
$35434bb0aa2830e3$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $4cf3v(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$35434bb0aa2830e3$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$35434bb0aa2830e3$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $4cf3v.mont(n);
    var rone = new $4cf3v(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $4cf3v(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$35434bb0aa2830e3$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $4cf3v.mont(n);
    var rone = new $4cf3v(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $4cf3v(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};

});
parcelRegister("4cf3v", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("71KMl", function(module, exports) {
var $51dce9aad2b01195$var$r;
module.exports = function rand(len) {
    if (!$51dce9aad2b01195$var$r) $51dce9aad2b01195$var$r = new $51dce9aad2b01195$var$Rand(null);
    return $51dce9aad2b01195$var$r.generate(len);
};
function $51dce9aad2b01195$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $51dce9aad2b01195$var$Rand;
$51dce9aad2b01195$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$51dce9aad2b01195$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === 'object') {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $51dce9aad2b01195$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $51dce9aad2b01195$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === 'object') // Old junk
    $51dce9aad2b01195$var$Rand.prototype._rand = function() {
        throw new Error('Not implemented yet');
    };
} else // Node.js or Web worker with no crypto support
try {
    var $51dce9aad2b01195$var$crypto = (parcelRequire("hDwn7"));
    if (typeof $51dce9aad2b01195$var$crypto.randomBytes !== 'function') throw new Error('Not supported');
    $51dce9aad2b01195$var$Rand.prototype._rand = function _rand(n) {
        return $51dce9aad2b01195$var$crypto.randomBytes(n);
    };
} catch (e) {}

});



parcelRegister("gmHyS", function(module, exports) {
module.exports = JSON.parse("{\"modp1\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff\"},\"modp2\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff\"},\"modp5\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff\"},\"modp14\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff\"},\"modp15\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff\"},\"modp16\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff\"},\"modp17\":{\"gen\":\"02\",\"prime\":\"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff\"},\"modp18\":{\"gen\":\"02\",\"prime\":\"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\"}}");

});

parcelRegister("9SBGE", function(module, exports) {

var $kJBqN = parcelRequire("kJBqN");
var $7316640c20995aab$require$Buffer = $kJBqN.Buffer;

var $hyFoa = parcelRequire("hyFoa");

var $4zw3r = parcelRequire("4zw3r");
var $7316640c20995aab$var$millerRabin = new $4zw3r();
var $7316640c20995aab$var$TWENTYFOUR = new $hyFoa(24);
var $7316640c20995aab$var$ELEVEN = new $hyFoa(11);
var $7316640c20995aab$var$TEN = new $hyFoa(10);
var $7316640c20995aab$var$THREE = new $hyFoa(3);
var $7316640c20995aab$var$SEVEN = new $hyFoa(7);

var $hO6NZ = parcelRequire("hO6NZ");

var $l0MtO = parcelRequire("l0MtO");
module.exports = $7316640c20995aab$var$DH;
function $7316640c20995aab$var$setPublicKey(pub, enc) {
    enc = enc || 'utf8';
    if (!$7316640c20995aab$require$Buffer.isBuffer(pub)) pub = new $7316640c20995aab$require$Buffer(pub, enc);
    this._pub = new $hyFoa(pub);
    return this;
}
function $7316640c20995aab$var$setPrivateKey(priv, enc) {
    enc = enc || 'utf8';
    if (!$7316640c20995aab$require$Buffer.isBuffer(priv)) priv = new $7316640c20995aab$require$Buffer(priv, enc);
    this._priv = new $hyFoa(priv);
    return this;
}
var $7316640c20995aab$var$primeCache = {};
function $7316640c20995aab$var$checkPrime(prime, generator) {
    var gen = generator.toString('hex');
    var hex = [
        gen,
        prime.toString(16)
    ].join('_');
    if (hex in $7316640c20995aab$var$primeCache) return $7316640c20995aab$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$hO6NZ.simpleSieve || !$hO6NZ.fermatTest(prime) || !$7316640c20995aab$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === '02' || gen === '05') // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $7316640c20995aab$var$primeCache[hex] = error;
        return error;
    }
    if (!$7316640c20995aab$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case '02':
            if (prime.mod($7316640c20995aab$var$TWENTYFOUR).cmp($7316640c20995aab$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case '05':
            rem = prime.mod($7316640c20995aab$var$TEN);
            if (rem.cmp($7316640c20995aab$var$THREE) && rem.cmp($7316640c20995aab$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $7316640c20995aab$var$primeCache[hex] = error;
    return error;
}
function $7316640c20995aab$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $hyFoa(prime);
    this._prime = $hyFoa.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $7316640c20995aab$var$setPublicKey;
        this.setPrivateKey = $7316640c20995aab$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($7316640c20995aab$var$DH.prototype, 'verifyError', {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== 'number') this._primeCode = $7316640c20995aab$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$7316640c20995aab$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $hyFoa($l0MtO(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$7316640c20995aab$var$DH.prototype.computeSecret = function(other) {
    other = new $hyFoa(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $7316640c20995aab$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $7316640c20995aab$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $7316640c20995aab$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$7316640c20995aab$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $7316640c20995aab$var$formatReturnValue(this._pub, enc);
};
$7316640c20995aab$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $7316640c20995aab$var$formatReturnValue(this._priv, enc);
};
$7316640c20995aab$var$DH.prototype.getPrime = function(enc) {
    return $7316640c20995aab$var$formatReturnValue(this.__prime, enc);
};
$7316640c20995aab$var$DH.prototype.getGenerator = function(enc) {
    return $7316640c20995aab$var$formatReturnValue(this._gen, enc);
};
$7316640c20995aab$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || 'utf8';
    if (!$7316640c20995aab$require$Buffer.isBuffer(gen)) gen = new $7316640c20995aab$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $hyFoa(gen);
    return this;
};
function $7316640c20995aab$var$formatReturnValue(bn, enc) {
    var buf = new $7316640c20995aab$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}

});


parcelRegister("2WSd0", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $225b0c4ad28e7e7a$require$Buffer = $6arys.Buffer;

var $7y50W = parcelRequire("7y50W");

var $hHGGV = parcelRequire("hHGGV");

var $gdc6A = parcelRequire("gdc6A");

var $2l4Em = parcelRequire("2l4Em");

var $gsk8z = parcelRequire("gsk8z");

var $iZgai = parcelRequire("iZgai");
Object.keys($iZgai).forEach(function(key) {
    $iZgai[key].id = $225b0c4ad28e7e7a$require$Buffer.from($iZgai[key].id, 'hex');
    $iZgai[key.toLowerCase()] = $iZgai[key];
});
function $225b0c4ad28e7e7a$var$Sign(algorithm) {
    $hHGGV.Writable.call(this);
    var data = $iZgai[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hashType = data.hash;
    this._hash = $7y50W(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$gdc6A($225b0c4ad28e7e7a$var$Sign, $hHGGV.Writable);
$225b0c4ad28e7e7a$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$225b0c4ad28e7e7a$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $225b0c4ad28e7e7a$require$Buffer.from(data, enc) : data);
    return this;
};
$225b0c4ad28e7e7a$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $2l4Em(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $225b0c4ad28e7e7a$var$Verify(algorithm) {
    $hHGGV.Writable.call(this);
    var data = $iZgai[algorithm];
    if (!data) throw new Error('Unknown message digest');
    this._hash = $7y50W(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$gdc6A($225b0c4ad28e7e7a$var$Verify, $hHGGV.Writable);
$225b0c4ad28e7e7a$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$225b0c4ad28e7e7a$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === 'string' ? $225b0c4ad28e7e7a$require$Buffer.from(data, enc) : data);
    return this;
};
$225b0c4ad28e7e7a$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === 'string' ? $225b0c4ad28e7e7a$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $gsk8z(sigBuffer, hash, key, this._signType, this._tag);
};
function $225b0c4ad28e7e7a$var$createSign(algorithm) {
    return new $225b0c4ad28e7e7a$var$Sign(algorithm);
}
function $225b0c4ad28e7e7a$var$createVerify(algorithm) {
    return new $225b0c4ad28e7e7a$var$Verify(algorithm);
}
module.exports = {
    Sign: $225b0c4ad28e7e7a$var$createSign,
    Verify: $225b0c4ad28e7e7a$var$createVerify,
    createSign: $225b0c4ad28e7e7a$var$createSign,
    createVerify: $225b0c4ad28e7e7a$var$createVerify
};

});
parcelRegister("2l4Em", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $1b412656de8cba8d$require$Buffer = $6arys.Buffer;

var $kpRN9 = parcelRequire("kpRN9");

var $6TJhl = parcelRequire("6TJhl");

var $7xbBA = parcelRequire("7xbBA");
var $1b412656de8cba8d$require$EC = $7xbBA.ec;

var $1dK1s = parcelRequire("1dK1s");

var $azRsG = parcelRequire("azRsG");

var $lhhvi = parcelRequire("lhhvi");
var $1b412656de8cba8d$var$RSA_PKCS1_PADDING = 1;
function $1b412656de8cba8d$var$sign(hash, key, hashType, signType, tag) {
    var priv = $azRsG(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
        return $1b412656de8cba8d$var$ecSign(hash, priv);
    } else if (priv.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong private key type');
        return $1b412656de8cba8d$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong private key type');
    if (key.padding !== undefined && key.padding !== $1b412656de8cba8d$var$RSA_PKCS1_PADDING) throw new Error('illegal or unsupported padding mode');
    hash = $1b412656de8cba8d$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $6TJhl(pad, priv);
    return out;
}
function $1b412656de8cba8d$var$ecSign(hash, priv) {
    var curveId = $lhhvi[priv.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + priv.curve.join('.'));
    var curve = new $1b412656de8cba8d$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $1b412656de8cba8d$require$Buffer.from(out.toDER());
}
function $1b412656de8cba8d$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $1dK1s(0);
    var k;
    var H = $1b412656de8cba8d$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $1b412656de8cba8d$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $1b412656de8cba8d$var$makeKey(q, kv, algo);
        r = $1b412656de8cba8d$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $1dK1s(0);
        }
    }
    return $1b412656de8cba8d$var$toDER(r, s);
}
function $1b412656de8cba8d$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $1b412656de8cba8d$require$Buffer.from(res);
}
function $1b412656de8cba8d$var$getKey(x, q, hash, algo) {
    x = $1b412656de8cba8d$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $1b412656de8cba8d$require$Buffer.alloc(q.byteLength() - x.length);
        x = $1b412656de8cba8d$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $1b412656de8cba8d$var$bits2octets(hash, q);
    var v = $1b412656de8cba8d$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $1b412656de8cba8d$require$Buffer.alloc(hlen);
    k = $kpRN9(algo, k).update(v).update($1b412656de8cba8d$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $kpRN9(algo, k).update(v).digest();
    k = $kpRN9(algo, k).update(v).update($1b412656de8cba8d$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $kpRN9(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $1b412656de8cba8d$var$bits2int(obits, q) {
    var bits = new $1dK1s(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $1b412656de8cba8d$var$bits2octets(bits, q) {
    bits = $1b412656de8cba8d$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $1b412656de8cba8d$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $1b412656de8cba8d$require$Buffer.alloc(q.byteLength() - out.length);
        out = $1b412656de8cba8d$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $1b412656de8cba8d$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $1b412656de8cba8d$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $kpRN9(algo, kv.k).update(kv.v).digest();
            t = $1b412656de8cba8d$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $1b412656de8cba8d$var$bits2int(t, q);
        kv.k = $kpRN9(algo, kv.k).update(kv.v).update($1b412656de8cba8d$require$Buffer.from([
            0
        ])).digest();
        kv.v = $kpRN9(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $1b412656de8cba8d$var$makeR(g, k, p, q) {
    return g.toRed($1dK1s.mont(p)).redPow(k).fromRed().mod(q);
}
module.exports = $1b412656de8cba8d$var$sign;
module.exports.getKey = $1b412656de8cba8d$var$getKey;
module.exports.makeKey = $1b412656de8cba8d$var$makeKey;

});
parcelRegister("6TJhl", function(module, exports) {
'use strict';

var $1dK1s = parcelRequire("1dK1s");

var $l0MtO = parcelRequire("l0MtO");

var $6arys = parcelRequire("6arys");
var $505b008c233f2f66$require$Buffer = $6arys.Buffer;
function $505b008c233f2f66$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $1dK1s($l0MtO(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $505b008c233f2f66$var$blind(priv) {
    var r = $505b008c233f2f66$var$getr(priv);
    var blinder = r.toRed($1dK1s.mont(priv.modulus)).redPow(new $1dK1s(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $505b008c233f2f66$var$crt(msg, priv) {
    var blinds = $505b008c233f2f66$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $1dK1s(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($1dK1s.mont(priv.prime1));
    var c2 = blinded.toRed($1dK1s.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($505b008c233f2f66$require$Buffer, 'be', len);
}
$505b008c233f2f66$var$crt.getr = $505b008c233f2f66$var$getr;
module.exports = $505b008c233f2f66$var$crt;

});
parcelRegister("1dK1s", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, 'Invalid character in ' + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, 'Invalid character');
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== 'undefined' && typeof Symbol.for === 'function') try {
        BN.prototype[Symbol.for('nodejs.util.inspect.custom')] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === 'le' ? 'LE' : 'BE';
        this['_toArrayLike' + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("7xbBA", function(module, exports) {
'use strict';
var $57c49e0b9173b115$var$elliptic = module.exports;

$57c49e0b9173b115$var$elliptic.version = (parcelRequire("2sANt")).version;

$57c49e0b9173b115$var$elliptic.utils = (parcelRequire("aySOc"));

$57c49e0b9173b115$var$elliptic.rand = (parcelRequire("71KMl"));

$57c49e0b9173b115$var$elliptic.curve = (parcelRequire("dIiOF"));

$57c49e0b9173b115$var$elliptic.curves = (parcelRequire("dcalr"));

// Protocols
$57c49e0b9173b115$var$elliptic.ec = (parcelRequire("03Jl3"));

$57c49e0b9173b115$var$elliptic.eddsa = (parcelRequire("9SVuJ"));

});
parcelRegister("2sANt", function(module, exports) {
module.exports = JSON.parse("{\"name\":\"elliptic\",\"version\":\"6.6.1\",\"description\":\"EC cryptography\",\"main\":\"lib/elliptic.js\",\"files\":[\"lib\"],\"scripts\":{\"lint\":\"eslint lib test\",\"lint:fix\":\"npm run lint -- --fix\",\"unit\":\"istanbul test _mocha --reporter=spec test/index.js\",\"test\":\"npm run lint && npm run unit\",\"version\":\"grunt dist && git add dist/\"},\"repository\":{\"type\":\"git\",\"url\":\"git@github.com:indutny/elliptic\"},\"keywords\":[\"EC\",\"Elliptic\",\"curve\",\"Cryptography\"],\"author\":\"Fedor Indutny <fedor@indutny.com>\",\"license\":\"MIT\",\"bugs\":{\"url\":\"https://github.com/indutny/elliptic/issues\"},\"homepage\":\"https://github.com/indutny/elliptic\",\"devDependencies\":{\"brfs\":\"^2.0.2\",\"coveralls\":\"^3.1.0\",\"eslint\":\"^7.6.0\",\"grunt\":\"^1.2.1\",\"grunt-browserify\":\"^5.3.0\",\"grunt-cli\":\"^1.3.2\",\"grunt-contrib-connect\":\"^3.0.0\",\"grunt-contrib-copy\":\"^1.0.0\",\"grunt-contrib-uglify\":\"^5.0.0\",\"grunt-mocha-istanbul\":\"^5.0.2\",\"grunt-saucelabs\":\"^9.0.1\",\"istanbul\":\"^0.4.5\",\"mocha\":\"^8.0.1\"},\"dependencies\":{\"bn.js\":\"^4.11.9\",\"brorand\":\"^1.1.0\",\"hash.js\":\"^1.0.0\",\"hmac-drbg\":\"^1.0.1\",\"inherits\":\"^2.0.4\",\"minimalistic-assert\":\"^1.0.1\",\"minimalistic-crypto-utils\":\"^1.0.1\"}}");

});

parcelRegister("aySOc", function(module, exports) {
'use strict';
var $7b07983b57f1e549$var$utils = module.exports;

var $crOW0 = parcelRequire("crOW0");

var $jYzim = parcelRequire("jYzim");

var $aTJ3h = parcelRequire("aTJ3h");
$7b07983b57f1e549$var$utils.assert = $jYzim;
$7b07983b57f1e549$var$utils.toArray = $aTJ3h.toArray;
$7b07983b57f1e549$var$utils.zero2 = $aTJ3h.zero2;
$7b07983b57f1e549$var$utils.toHex = $aTJ3h.toHex;
$7b07983b57f1e549$var$utils.encode = $aTJ3h.encode;
// Represent num in a w-NAF form
function $7b07983b57f1e549$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$7b07983b57f1e549$var$utils.getNAF = $7b07983b57f1e549$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $7b07983b57f1e549$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$7b07983b57f1e549$var$utils.getJSF = $7b07983b57f1e549$var$getJSF;
function $7b07983b57f1e549$var$cachedProperty(obj, name, computer) {
    var key = '_' + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$7b07983b57f1e549$var$utils.cachedProperty = $7b07983b57f1e549$var$cachedProperty;
function $7b07983b57f1e549$var$parseBytes(bytes) {
    return typeof bytes === 'string' ? $7b07983b57f1e549$var$utils.toArray(bytes, 'hex') : bytes;
}
$7b07983b57f1e549$var$utils.parseBytes = $7b07983b57f1e549$var$parseBytes;
function $7b07983b57f1e549$var$intFromLE(bytes) {
    return new $crOW0(bytes, 'hex', 'le');
}
$7b07983b57f1e549$var$utils.intFromLE = $7b07983b57f1e549$var$intFromLE;

});
parcelRegister("crOW0", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("aTJ3h", function(module, exports) {
'use strict';
var $7ef1fcd2af1670aa$var$utils = module.exports;
function $7ef1fcd2af1670aa$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== 'string') {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === 'hex') {
        msg = msg.replace(/[^a-z0-9]+/ig, '');
        if (msg.length % 2 !== 0) msg = '0' + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$7ef1fcd2af1670aa$var$utils.toArray = $7ef1fcd2af1670aa$var$toArray;
function $7ef1fcd2af1670aa$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$7ef1fcd2af1670aa$var$utils.zero2 = $7ef1fcd2af1670aa$var$zero2;
function $7ef1fcd2af1670aa$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $7ef1fcd2af1670aa$var$zero2(msg[i].toString(16));
    return res;
}
$7ef1fcd2af1670aa$var$utils.toHex = $7ef1fcd2af1670aa$var$toHex;
$7ef1fcd2af1670aa$var$utils.encode = function encode(arr, enc) {
    if (enc === 'hex') return $7ef1fcd2af1670aa$var$toHex(arr);
    else return arr;
};

});


parcelRegister("dIiOF", function(module, exports) {
'use strict';
var $9fbdfaf2bfb7d871$var$curve = module.exports;

$9fbdfaf2bfb7d871$var$curve.base = (parcelRequire("cSBwJ"));

$9fbdfaf2bfb7d871$var$curve.short = (parcelRequire("jl6QI"));

$9fbdfaf2bfb7d871$var$curve.mont = (parcelRequire("fkdXj"));

$9fbdfaf2bfb7d871$var$curve.edwards = (parcelRequire("iQ8i1"));

});
parcelRegister("cSBwJ", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $aySOc = parcelRequire("aySOc");
var $9607a33ebff24526$var$getNAF = $aySOc.getNAF;
var $9607a33ebff24526$var$getJSF = $aySOc.getJSF;
var $9607a33ebff24526$var$assert = $aySOc.assert;
function $9607a33ebff24526$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $crOW0(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $crOW0.red(conf.prime) : $crOW0.mont(this.p);
    // Useful for many curves
    this.zero = new $crOW0(0).toRed(this.red);
    this.one = new $crOW0(1).toRed(this.red);
    this.two = new $crOW0(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $crOW0(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $9607a33ebff24526$var$BaseCurve;
$9607a33ebff24526$var$BaseCurve.prototype.point = function point() {
    throw new Error('Not implemented');
};
$9607a33ebff24526$var$BaseCurve.prototype.validate = function validate() {
    throw new Error('Not implemented');
};
$9607a33ebff24526$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $9607a33ebff24526$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $9607a33ebff24526$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$9607a33ebff24526$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $9607a33ebff24526$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $9607a33ebff24526$var$assert(z !== 0);
        if (p.type === 'affine') {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === 'affine' ? acc.toP() : acc;
};
$9607a33ebff24526$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $9607a33ebff24526$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $9607a33ebff24526$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $9607a33ebff24526$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === 'affine') acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $9607a33ebff24526$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$9607a33ebff24526$var$BaseCurve.BasePoint = $9607a33ebff24526$var$BasePoint;
$9607a33ebff24526$var$BasePoint.prototype.eq = function eq() {
    throw new Error('Not implemented');
};
$9607a33ebff24526$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$9607a33ebff24526$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $aySOc.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $9607a33ebff24526$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $9607a33ebff24526$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error('Unknown point format');
};
$9607a33ebff24526$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$9607a33ebff24526$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray('be', len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray('be', len));
};
$9607a33ebff24526$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $aySOc.encode(this._encode(compact), enc);
};
$9607a33ebff24526$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$9607a33ebff24526$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$9607a33ebff24526$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$9607a33ebff24526$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$9607a33ebff24526$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$9607a33ebff24526$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("jl6QI", function(module, exports) {
'use strict';

var $aySOc = parcelRequire("aySOc");

var $crOW0 = parcelRequire("crOW0");

var $gdc6A = parcelRequire("gdc6A");

var $cSBwJ = parcelRequire("cSBwJ");
var $e1454a95cf191a44$var$assert = $aySOc.assert;
function $e1454a95cf191a44$var$ShortCurve(conf) {
    $cSBwJ.call(this, 'short', conf);
    this.a = new $crOW0(conf.a, 16).toRed(this.red);
    this.b = new $crOW0(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$gdc6A($e1454a95cf191a44$var$ShortCurve, $cSBwJ);
module.exports = $e1454a95cf191a44$var$ShortCurve;
$e1454a95cf191a44$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $crOW0(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $crOW0(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $e1454a95cf191a44$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $crOW0(vec.a, 16),
            b: new $crOW0(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$e1454a95cf191a44$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $crOW0.mont(num);
    var tinv = new $crOW0(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $crOW0(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$e1454a95cf191a44$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $crOW0(1);
    var y1 = new $crOW0(0);
    var x2 = new $crOW0(0);
    var y2 = new $crOW0(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$e1454a95cf191a44$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$e1454a95cf191a44$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $crOW0(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$e1454a95cf191a44$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$e1454a95cf191a44$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $e1454a95cf191a44$var$Point(curve, x, y, isRed) {
    $cSBwJ.BasePoint.call(this, curve, 'affine');
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $crOW0(x, 16);
        this.y = new $crOW0(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$gdc6A($e1454a95cf191a44$var$Point, $cSBwJ.BasePoint);
$e1454a95cf191a44$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $e1454a95cf191a44$var$Point(this, x, y, isRed);
};
$e1454a95cf191a44$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $e1454a95cf191a44$var$Point.fromJSON(this, obj, red);
};
$e1454a95cf191a44$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$e1454a95cf191a44$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$e1454a95cf191a44$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === 'string') obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$e1454a95cf191a44$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + '>';
};
$e1454a95cf191a44$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$e1454a95cf191a44$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$e1454a95cf191a44$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$e1454a95cf191a44$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$e1454a95cf191a44$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$e1454a95cf191a44$var$Point.prototype.mul = function mul(k) {
    k = new $crOW0(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$e1454a95cf191a44$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$e1454a95cf191a44$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$e1454a95cf191a44$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$e1454a95cf191a44$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$e1454a95cf191a44$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $e1454a95cf191a44$var$JPoint(curve, x, y, z) {
    $cSBwJ.BasePoint.call(this, curve, 'jacobian');
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $crOW0(0);
    } else {
        this.x = new $crOW0(x, 16);
        this.y = new $crOW0(y, 16);
        this.z = new $crOW0(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$gdc6A($e1454a95cf191a44$var$JPoint, $cSBwJ.BasePoint);
$e1454a95cf191a44$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $e1454a95cf191a44$var$JPoint(this, x, y, z);
};
$e1454a95cf191a44$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$e1454a95cf191a44$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$e1454a95cf191a44$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$e1454a95cf191a44$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$e1454a95cf191a44$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$e1454a95cf191a44$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $crOW0(k, kbase);
    return this.curve._wnafMul(this, k);
};
$e1454a95cf191a44$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === 'affine') return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$e1454a95cf191a44$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$e1454a95cf191a44$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC JPoint Infinity>';
    return '<EC JPoint x: ' + this.x.toString(16, 2) + ' y: ' + this.y.toString(16, 2) + ' z: ' + this.z.toString(16, 2) + '>';
};
$e1454a95cf191a44$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("fkdXj", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $gdc6A = parcelRequire("gdc6A");

var $cSBwJ = parcelRequire("cSBwJ");

var $aySOc = parcelRequire("aySOc");
function $b2838c96c3535d96$var$MontCurve(conf) {
    $cSBwJ.call(this, 'mont', conf);
    this.a = new $crOW0(conf.a, 16).toRed(this.red);
    this.b = new $crOW0(conf.b, 16).toRed(this.red);
    this.i4 = new $crOW0(4).toRed(this.red).redInvm();
    this.two = new $crOW0(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$gdc6A($b2838c96c3535d96$var$MontCurve, $cSBwJ);
module.exports = $b2838c96c3535d96$var$MontCurve;
$b2838c96c3535d96$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $b2838c96c3535d96$var$Point(curve, x, z) {
    $cSBwJ.BasePoint.call(this, curve, 'projective');
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $crOW0(x, 16);
        this.z = new $crOW0(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$gdc6A($b2838c96c3535d96$var$Point, $cSBwJ.BasePoint);
$b2838c96c3535d96$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($aySOc.toArray(bytes, enc), 1);
};
$b2838c96c3535d96$var$MontCurve.prototype.point = function point(x, z) {
    return new $b2838c96c3535d96$var$Point(this, x, z);
};
$b2838c96c3535d96$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $b2838c96c3535d96$var$Point.fromJSON(this, obj);
};
$b2838c96c3535d96$var$Point.prototype.precompute = function precompute() {
// No-op
};
$b2838c96c3535d96$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray('be', this.curve.p.byteLength());
};
$b2838c96c3535d96$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $b2838c96c3535d96$var$Point(curve, obj[0], obj[1] || curve.one);
};
$b2838c96c3535d96$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$b2838c96c3535d96$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$b2838c96c3535d96$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$b2838c96c3535d96$var$Point.prototype.add = function add() {
    throw new Error('Not supported on Montgomery curve');
};
$b2838c96c3535d96$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$b2838c96c3535d96$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$b2838c96c3535d96$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$b2838c96c3535d96$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error('Not supported on Montgomery curve');
};
$b2838c96c3535d96$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$b2838c96c3535d96$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$b2838c96c3535d96$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("iQ8i1", function(module, exports) {
'use strict';

var $aySOc = parcelRequire("aySOc");

var $crOW0 = parcelRequire("crOW0");

var $gdc6A = parcelRequire("gdc6A");

var $cSBwJ = parcelRequire("cSBwJ");
var $db738374e1223707$var$assert = $aySOc.assert;
function $db738374e1223707$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $cSBwJ.call(this, 'edwards', conf);
    this.a = new $crOW0(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $crOW0(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $crOW0(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $db738374e1223707$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$gdc6A($db738374e1223707$var$EdwardsCurve, $cSBwJ);
module.exports = $db738374e1223707$var$EdwardsCurve;
$db738374e1223707$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$db738374e1223707$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$db738374e1223707$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$db738374e1223707$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $crOW0(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error('invalid point');
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$db738374e1223707$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $crOW0(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error('invalid point');
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error('invalid point');
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$db738374e1223707$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $db738374e1223707$var$Point(curve, x, y, z, t) {
    $cSBwJ.BasePoint.call(this, curve, 'projective');
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $crOW0(x, 16);
        this.y = new $crOW0(y, 16);
        this.z = z ? new $crOW0(z, 16) : this.curve.one;
        this.t = t && new $crOW0(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$gdc6A($db738374e1223707$var$Point, $cSBwJ.BasePoint);
$db738374e1223707$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $db738374e1223707$var$Point.fromJSON(this, obj);
};
$db738374e1223707$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $db738374e1223707$var$Point(this, x, y, z, t);
};
$db738374e1223707$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $db738374e1223707$var$Point(curve, obj[0], obj[1], obj[2]);
};
$db738374e1223707$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return '<EC Point Infinity>';
    return '<EC Point x: ' + this.x.fromRed().toString(16, 2) + ' y: ' + this.y.fromRed().toString(16, 2) + ' z: ' + this.z.fromRed().toString(16, 2) + '>';
};
$db738374e1223707$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$db738374e1223707$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$db738374e1223707$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$db738374e1223707$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$db738374e1223707$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$db738374e1223707$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$db738374e1223707$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$db738374e1223707$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$db738374e1223707$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$db738374e1223707$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$db738374e1223707$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$db738374e1223707$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$db738374e1223707$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$db738374e1223707$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$db738374e1223707$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$db738374e1223707$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$db738374e1223707$var$Point.prototype.toP = $db738374e1223707$var$Point.prototype.normalize;
$db738374e1223707$var$Point.prototype.mixedAdd = $db738374e1223707$var$Point.prototype.add;

});


parcelRegister("dcalr", function(module, exports) {
'use strict';
var $99b46b99f9f183ea$var$curves = module.exports;

var $80ODB = parcelRequire("80ODB");

var $dIiOF = parcelRequire("dIiOF");

var $aySOc = parcelRequire("aySOc");
var $99b46b99f9f183ea$var$assert = $aySOc.assert;
function $99b46b99f9f183ea$var$PresetCurve(options) {
    if (options.type === 'short') this.curve = new $dIiOF.short(options);
    else if (options.type === 'edwards') this.curve = new $dIiOF.edwards(options);
    else this.curve = new $dIiOF.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $99b46b99f9f183ea$var$assert(this.g.validate(), 'Invalid curve');
    $99b46b99f9f183ea$var$assert(this.g.mul(this.n).isInfinity(), 'Invalid curve, G*N != O');
}
$99b46b99f9f183ea$var$curves.PresetCurve = $99b46b99f9f183ea$var$PresetCurve;
function $99b46b99f9f183ea$var$defineCurve(name, options) {
    Object.defineProperty($99b46b99f9f183ea$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $99b46b99f9f183ea$var$PresetCurve(options);
            Object.defineProperty($99b46b99f9f183ea$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$99b46b99f9f183ea$var$defineCurve('p192', {
    type: 'short',
    prime: 'p192',
    p: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc',
    b: '64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1',
    n: 'ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831',
    hash: $80ODB.sha256,
    gRed: false,
    g: [
        '188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012',
        '07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811'
    ]
});
$99b46b99f9f183ea$var$defineCurve('p224', {
    type: 'short',
    prime: 'p224',
    p: 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001',
    a: 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe',
    b: 'b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4',
    n: 'ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d',
    hash: $80ODB.sha256,
    gRed: false,
    g: [
        'b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21',
        'bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34'
    ]
});
$99b46b99f9f183ea$var$defineCurve('p256', {
    type: 'short',
    prime: null,
    p: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff',
    a: 'ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc',
    b: '5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b',
    n: 'ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551',
    hash: $80ODB.sha256,
    gRed: false,
    g: [
        '6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296',
        '4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5'
    ]
});
$99b46b99f9f183ea$var$defineCurve('p384', {
    type: 'short',
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $80ODB.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$99b46b99f9f183ea$var$defineCurve('p521', {
    type: 'short',
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $80ODB.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$99b46b99f9f183ea$var$defineCurve('curve25519', {
    type: 'mont',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '76d06',
    b: '1',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $80ODB.sha256,
    gRed: false,
    g: [
        '9'
    ]
});
$99b46b99f9f183ea$var$defineCurve('ed25519', {
    type: 'edwards',
    prime: 'p25519',
    p: '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed',
    a: '-1',
    c: '1',
    // -121665 * (121666^(-1)) (mod P)
    d: '52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3',
    n: '1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed',
    hash: $80ODB.sha256,
    gRed: false,
    g: [
        '216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a',
        // 4/5
        '6666666666666666666666666666666666666666666666666666666666666658'
    ]
});
var $99b46b99f9f183ea$var$pre;

try {
    $99b46b99f9f183ea$var$pre = (parcelRequire("48kJp"));
} catch (e) {
    $99b46b99f9f183ea$var$pre = undefined;
}
$99b46b99f9f183ea$var$defineCurve('secp256k1', {
    type: 'short',
    prime: 'k256',
    p: 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f',
    a: '0',
    b: '7',
    n: 'ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141',
    h: '1',
    hash: $80ODB.sha256,
    // Precomputed endomorphism
    beta: '7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee',
    lambda: '5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72',
    basis: [
        {
            a: '3086d221a7d46bcde86c90e49284eb15',
            b: '-e4437ed6010e88286f547fa90abfe4c3'
        },
        {
            a: '114ca50f7a8e2f3f657c1108d9d44cfd8',
            b: '3086d221a7d46bcde86c90e49284eb15'
        }
    ],
    gRed: false,
    g: [
        '79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798',
        '483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8',
        $99b46b99f9f183ea$var$pre
    ]
});

});
parcelRegister("80ODB", function(module, exports) {
var $5d559a7098517adb$var$hash = module.exports;

$5d559a7098517adb$var$hash.utils = (parcelRequire("dI1aK"));

$5d559a7098517adb$var$hash.common = (parcelRequire("eBwUf"));

$5d559a7098517adb$var$hash.sha = (parcelRequire("hcdm2"));

$5d559a7098517adb$var$hash.ripemd = (parcelRequire("jbOHA"));

$5d559a7098517adb$var$hash.hmac = (parcelRequire("7JAvW"));
// Proxy hash functions to the main object
$5d559a7098517adb$var$hash.sha1 = $5d559a7098517adb$var$hash.sha.sha1;
$5d559a7098517adb$var$hash.sha256 = $5d559a7098517adb$var$hash.sha.sha256;
$5d559a7098517adb$var$hash.sha224 = $5d559a7098517adb$var$hash.sha.sha224;
$5d559a7098517adb$var$hash.sha384 = $5d559a7098517adb$var$hash.sha.sha384;
$5d559a7098517adb$var$hash.sha512 = $5d559a7098517adb$var$hash.sha.sha512;
$5d559a7098517adb$var$hash.ripemd160 = $5d559a7098517adb$var$hash.ripemd.ripemd160;

});
parcelRegister("dI1aK", function(module, exports) {

$parcel$export(module.exports, "inherits", function () { return $02935c0d561a0650$export$69f1b2dcda23c5f8; }, function (v) { return $02935c0d561a0650$export$69f1b2dcda23c5f8 = v; });
$parcel$export(module.exports, "toArray", function () { return $02935c0d561a0650$export$45b10814cc054894; }, function (v) { return $02935c0d561a0650$export$45b10814cc054894 = v; });
$parcel$export(module.exports, "toHex", function () { return $02935c0d561a0650$export$7ea66e3774a60b67; }, function (v) { return $02935c0d561a0650$export$7ea66e3774a60b67 = v; });
$parcel$export(module.exports, "htonl", function () { return $02935c0d561a0650$export$34a52f00f601f6f1; }, function (v) { return $02935c0d561a0650$export$34a52f00f601f6f1 = v; });
$parcel$export(module.exports, "toHex32", function () { return $02935c0d561a0650$export$812b0cbd5e8a72ab; }, function (v) { return $02935c0d561a0650$export$812b0cbd5e8a72ab = v; });
$parcel$export(module.exports, "zero2", function () { return $02935c0d561a0650$export$f24f9e11d63bb314; }, function (v) { return $02935c0d561a0650$export$f24f9e11d63bb314 = v; });
$parcel$export(module.exports, "zero8", function () { return $02935c0d561a0650$export$b71357c7e07ca1f1; }, function (v) { return $02935c0d561a0650$export$b71357c7e07ca1f1 = v; });
$parcel$export(module.exports, "join32", function () { return $02935c0d561a0650$export$2e58a4b541fdcbe8; }, function (v) { return $02935c0d561a0650$export$2e58a4b541fdcbe8 = v; });
$parcel$export(module.exports, "split32", function () { return $02935c0d561a0650$export$183b950bde9faab8; }, function (v) { return $02935c0d561a0650$export$183b950bde9faab8 = v; });
$parcel$export(module.exports, "rotr32", function () { return $02935c0d561a0650$export$4785c77169fea59e; }, function (v) { return $02935c0d561a0650$export$4785c77169fea59e = v; });
$parcel$export(module.exports, "rotl32", function () { return $02935c0d561a0650$export$242a185dfcffac5b; }, function (v) { return $02935c0d561a0650$export$242a185dfcffac5b = v; });
$parcel$export(module.exports, "sum32", function () { return $02935c0d561a0650$export$58c04ae0ae31877d; }, function (v) { return $02935c0d561a0650$export$58c04ae0ae31877d = v; });
$parcel$export(module.exports, "sum32_3", function () { return $02935c0d561a0650$export$d058ca695f8c6f11; }, function (v) { return $02935c0d561a0650$export$d058ca695f8c6f11 = v; });
$parcel$export(module.exports, "sum32_4", function () { return $02935c0d561a0650$export$a1efd7fc3e986367; }, function (v) { return $02935c0d561a0650$export$a1efd7fc3e986367 = v; });
$parcel$export(module.exports, "sum32_5", function () { return $02935c0d561a0650$export$bbfea4a2b5abaab4; }, function (v) { return $02935c0d561a0650$export$bbfea4a2b5abaab4 = v; });
$parcel$export(module.exports, "sum64", function () { return $02935c0d561a0650$export$97ad4afc7de86152; }, function (v) { return $02935c0d561a0650$export$97ad4afc7de86152 = v; });
$parcel$export(module.exports, "sum64_hi", function () { return $02935c0d561a0650$export$ce4673d9a79f6a4b; }, function (v) { return $02935c0d561a0650$export$ce4673d9a79f6a4b = v; });
$parcel$export(module.exports, "sum64_lo", function () { return $02935c0d561a0650$export$786cc99fc6eedc0b; }, function (v) { return $02935c0d561a0650$export$786cc99fc6eedc0b = v; });
$parcel$export(module.exports, "sum64_4_hi", function () { return $02935c0d561a0650$export$45c59b9a1848dd0; }, function (v) { return $02935c0d561a0650$export$45c59b9a1848dd0 = v; });
$parcel$export(module.exports, "sum64_4_lo", function () { return $02935c0d561a0650$export$50d8f613e76d3034; }, function (v) { return $02935c0d561a0650$export$50d8f613e76d3034 = v; });
$parcel$export(module.exports, "sum64_5_hi", function () { return $02935c0d561a0650$export$b8e83683c60ee162; }, function (v) { return $02935c0d561a0650$export$b8e83683c60ee162 = v; });
$parcel$export(module.exports, "sum64_5_lo", function () { return $02935c0d561a0650$export$aeeb51790d1bcc4a; }, function (v) { return $02935c0d561a0650$export$aeeb51790d1bcc4a = v; });
$parcel$export(module.exports, "rotr64_hi", function () { return $02935c0d561a0650$export$bb7c616f719ad9c; }, function (v) { return $02935c0d561a0650$export$bb7c616f719ad9c = v; });
$parcel$export(module.exports, "rotr64_lo", function () { return $02935c0d561a0650$export$4d63290824f9d7df; }, function (v) { return $02935c0d561a0650$export$4d63290824f9d7df = v; });
$parcel$export(module.exports, "shr64_hi", function () { return $02935c0d561a0650$export$2f64ceb90ef28ea1; }, function (v) { return $02935c0d561a0650$export$2f64ceb90ef28ea1 = v; });
$parcel$export(module.exports, "shr64_lo", function () { return $02935c0d561a0650$export$8d2089d465f6d10d; }, function (v) { return $02935c0d561a0650$export$8d2089d465f6d10d = v; });
var $02935c0d561a0650$export$69f1b2dcda23c5f8;
var $02935c0d561a0650$export$45b10814cc054894;
var $02935c0d561a0650$export$7ea66e3774a60b67;
var $02935c0d561a0650$export$34a52f00f601f6f1;
var $02935c0d561a0650$export$812b0cbd5e8a72ab;
var $02935c0d561a0650$export$f24f9e11d63bb314;
var $02935c0d561a0650$export$b71357c7e07ca1f1;
var $02935c0d561a0650$export$2e58a4b541fdcbe8;
var $02935c0d561a0650$export$183b950bde9faab8;
var $02935c0d561a0650$export$4785c77169fea59e;
var $02935c0d561a0650$export$242a185dfcffac5b;
var $02935c0d561a0650$export$58c04ae0ae31877d;
var $02935c0d561a0650$export$d058ca695f8c6f11;
var $02935c0d561a0650$export$a1efd7fc3e986367;
var $02935c0d561a0650$export$bbfea4a2b5abaab4;
var $02935c0d561a0650$export$97ad4afc7de86152;
var $02935c0d561a0650$export$ce4673d9a79f6a4b;
var $02935c0d561a0650$export$786cc99fc6eedc0b;
var $02935c0d561a0650$export$45c59b9a1848dd0;
var $02935c0d561a0650$export$50d8f613e76d3034;
var $02935c0d561a0650$export$b8e83683c60ee162;
var $02935c0d561a0650$export$aeeb51790d1bcc4a;
var $02935c0d561a0650$export$bb7c616f719ad9c;
var $02935c0d561a0650$export$4d63290824f9d7df;
var $02935c0d561a0650$export$2f64ceb90ef28ea1;
var $02935c0d561a0650$export$8d2089d465f6d10d;
'use strict';

var $jYzim = parcelRequire("jYzim");

var $gdc6A = parcelRequire("gdc6A");
$02935c0d561a0650$export$69f1b2dcda23c5f8 = $gdc6A;
function $02935c0d561a0650$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $02935c0d561a0650$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === 'string') {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($02935c0d561a0650$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === 'hex') {
            msg = msg.replace(/[^a-z0-9]+/ig, '');
            if (msg.length % 2 !== 0) msg = '0' + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$02935c0d561a0650$export$45b10814cc054894 = $02935c0d561a0650$var$toArray;
function $02935c0d561a0650$var$toHex(msg) {
    var res = '';
    for(var i = 0; i < msg.length; i++)res += $02935c0d561a0650$var$zero2(msg[i].toString(16));
    return res;
}
$02935c0d561a0650$export$7ea66e3774a60b67 = $02935c0d561a0650$var$toHex;
function $02935c0d561a0650$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$02935c0d561a0650$export$34a52f00f601f6f1 = $02935c0d561a0650$var$htonl;
function $02935c0d561a0650$var$toHex32(msg, endian) {
    var res = '';
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === 'little') w = $02935c0d561a0650$var$htonl(w);
        res += $02935c0d561a0650$var$zero8(w.toString(16));
    }
    return res;
}
$02935c0d561a0650$export$812b0cbd5e8a72ab = $02935c0d561a0650$var$toHex32;
function $02935c0d561a0650$var$zero2(word) {
    if (word.length === 1) return '0' + word;
    else return word;
}
$02935c0d561a0650$export$f24f9e11d63bb314 = $02935c0d561a0650$var$zero2;
function $02935c0d561a0650$var$zero8(word) {
    if (word.length === 7) return '0' + word;
    else if (word.length === 6) return '00' + word;
    else if (word.length === 5) return '000' + word;
    else if (word.length === 4) return '0000' + word;
    else if (word.length === 3) return '00000' + word;
    else if (word.length === 2) return '000000' + word;
    else if (word.length === 1) return '0000000' + word;
    else return word;
}
$02935c0d561a0650$export$b71357c7e07ca1f1 = $02935c0d561a0650$var$zero8;
function $02935c0d561a0650$var$join32(msg, start, end, endian) {
    var len = end - start;
    $jYzim(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === 'big') w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$02935c0d561a0650$export$2e58a4b541fdcbe8 = $02935c0d561a0650$var$join32;
function $02935c0d561a0650$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === 'big') {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$02935c0d561a0650$export$183b950bde9faab8 = $02935c0d561a0650$var$split32;
function $02935c0d561a0650$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$02935c0d561a0650$export$4785c77169fea59e = $02935c0d561a0650$var$rotr32;
function $02935c0d561a0650$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$02935c0d561a0650$export$242a185dfcffac5b = $02935c0d561a0650$var$rotl32;
function $02935c0d561a0650$var$sum32(a, b) {
    return a + b >>> 0;
}
$02935c0d561a0650$export$58c04ae0ae31877d = $02935c0d561a0650$var$sum32;
function $02935c0d561a0650$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$02935c0d561a0650$export$d058ca695f8c6f11 = $02935c0d561a0650$var$sum32_3;
function $02935c0d561a0650$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$02935c0d561a0650$export$a1efd7fc3e986367 = $02935c0d561a0650$var$sum32_4;
function $02935c0d561a0650$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$02935c0d561a0650$export$bbfea4a2b5abaab4 = $02935c0d561a0650$var$sum32_5;
function $02935c0d561a0650$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$02935c0d561a0650$export$97ad4afc7de86152 = $02935c0d561a0650$var$sum64;
function $02935c0d561a0650$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$02935c0d561a0650$export$ce4673d9a79f6a4b = $02935c0d561a0650$var$sum64_hi;
function $02935c0d561a0650$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$02935c0d561a0650$export$786cc99fc6eedc0b = $02935c0d561a0650$var$sum64_lo;
function $02935c0d561a0650$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$02935c0d561a0650$export$45c59b9a1848dd0 = $02935c0d561a0650$var$sum64_4_hi;
function $02935c0d561a0650$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$02935c0d561a0650$export$50d8f613e76d3034 = $02935c0d561a0650$var$sum64_4_lo;
function $02935c0d561a0650$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$02935c0d561a0650$export$b8e83683c60ee162 = $02935c0d561a0650$var$sum64_5_hi;
function $02935c0d561a0650$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$02935c0d561a0650$export$aeeb51790d1bcc4a = $02935c0d561a0650$var$sum64_5_lo;
function $02935c0d561a0650$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$02935c0d561a0650$export$bb7c616f719ad9c = $02935c0d561a0650$var$rotr64_hi;
function $02935c0d561a0650$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$02935c0d561a0650$export$4d63290824f9d7df = $02935c0d561a0650$var$rotr64_lo;
function $02935c0d561a0650$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$02935c0d561a0650$export$2f64ceb90ef28ea1 = $02935c0d561a0650$var$shr64_hi;
function $02935c0d561a0650$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$02935c0d561a0650$export$8d2089d465f6d10d = $02935c0d561a0650$var$shr64_lo;

});

parcelRegister("eBwUf", function(module, exports) {

$parcel$export(module.exports, "BlockHash", function () { return $aa1e0bdde71bc118$export$8687658379b577e6; }, function (v) { return $aa1e0bdde71bc118$export$8687658379b577e6 = v; });
var $aa1e0bdde71bc118$export$8687658379b577e6;
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $jYzim = parcelRequire("jYzim");
function $aa1e0bdde71bc118$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = 'big';
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$aa1e0bdde71bc118$export$8687658379b577e6 = $aa1e0bdde71bc118$var$BlockHash;
$aa1e0bdde71bc118$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $dI1aK.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $dI1aK.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$aa1e0bdde71bc118$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $jYzim(this.pending === null);
    return this._digest(enc);
};
$aa1e0bdde71bc118$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === 'big') {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("hcdm2", function(module, exports) {

$parcel$export(module.exports, "sha1", function () { return $c84dea92eff2ffc2$export$5091bdda49ba90f5; }, function (v) { return $c84dea92eff2ffc2$export$5091bdda49ba90f5 = v; });
$parcel$export(module.exports, "sha224", function () { return $c84dea92eff2ffc2$export$97b70509d4e397ea; }, function (v) { return $c84dea92eff2ffc2$export$97b70509d4e397ea = v; });
$parcel$export(module.exports, "sha256", function () { return $c84dea92eff2ffc2$export$bced8d2aada2d1c9; }, function (v) { return $c84dea92eff2ffc2$export$bced8d2aada2d1c9 = v; });
$parcel$export(module.exports, "sha384", function () { return $c84dea92eff2ffc2$export$612d47d55dedde45; }, function (v) { return $c84dea92eff2ffc2$export$612d47d55dedde45 = v; });
$parcel$export(module.exports, "sha512", function () { return $c84dea92eff2ffc2$export$a888d2532e6dc7bb; }, function (v) { return $c84dea92eff2ffc2$export$a888d2532e6dc7bb = v; });
var $c84dea92eff2ffc2$export$5091bdda49ba90f5;
var $c84dea92eff2ffc2$export$97b70509d4e397ea;
var $c84dea92eff2ffc2$export$bced8d2aada2d1c9;
var $c84dea92eff2ffc2$export$612d47d55dedde45;
var $c84dea92eff2ffc2$export$a888d2532e6dc7bb;
'use strict';

$c84dea92eff2ffc2$export$5091bdda49ba90f5 = (parcelRequire("j9ASR"));

$c84dea92eff2ffc2$export$97b70509d4e397ea = (parcelRequire("4YLz3"));

$c84dea92eff2ffc2$export$bced8d2aada2d1c9 = (parcelRequire("61P78"));

$c84dea92eff2ffc2$export$612d47d55dedde45 = (parcelRequire("4By0K"));

$c84dea92eff2ffc2$export$a888d2532e6dc7bb = (parcelRequire("kxN2p"));

});
parcelRegister("j9ASR", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $eBwUf = parcelRequire("eBwUf");

var $bp78H = parcelRequire("bp78H");
var $df1b77ef28767da0$var$rotl32 = $dI1aK.rotl32;
var $df1b77ef28767da0$var$sum32 = $dI1aK.sum32;
var $df1b77ef28767da0$var$sum32_5 = $dI1aK.sum32_5;
var $df1b77ef28767da0$var$ft_1 = $bp78H.ft_1;
var $df1b77ef28767da0$var$BlockHash = $eBwUf.BlockHash;
var $df1b77ef28767da0$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $df1b77ef28767da0$var$SHA1() {
    if (!(this instanceof $df1b77ef28767da0$var$SHA1)) return new $df1b77ef28767da0$var$SHA1();
    $df1b77ef28767da0$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$dI1aK.inherits($df1b77ef28767da0$var$SHA1, $df1b77ef28767da0$var$BlockHash);
module.exports = $df1b77ef28767da0$var$SHA1;
$df1b77ef28767da0$var$SHA1.blockSize = 512;
$df1b77ef28767da0$var$SHA1.outSize = 160;
$df1b77ef28767da0$var$SHA1.hmacStrength = 80;
$df1b77ef28767da0$var$SHA1.padLength = 64;
$df1b77ef28767da0$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $df1b77ef28767da0$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $df1b77ef28767da0$var$sum32_5($df1b77ef28767da0$var$rotl32(a, 5), $df1b77ef28767da0$var$ft_1(s, b, c, d), e, W[i], $df1b77ef28767da0$var$sha1_K[s]);
        e = d;
        d = c;
        c = $df1b77ef28767da0$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $df1b77ef28767da0$var$sum32(this.h[0], a);
    this.h[1] = $df1b77ef28767da0$var$sum32(this.h[1], b);
    this.h[2] = $df1b77ef28767da0$var$sum32(this.h[2], c);
    this.h[3] = $df1b77ef28767da0$var$sum32(this.h[3], d);
    this.h[4] = $df1b77ef28767da0$var$sum32(this.h[4], e);
};
$df1b77ef28767da0$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $dI1aK.toHex32(this.h, 'big');
    else return $dI1aK.split32(this.h, 'big');
};

});
parcelRegister("bp78H", function(module, exports) {

$parcel$export(module.exports, "ft_1", function () { return $84d79135b9998d0f$export$5a92649d7ddb9f63; }, function (v) { return $84d79135b9998d0f$export$5a92649d7ddb9f63 = v; });
$parcel$export(module.exports, "ch32", function () { return $84d79135b9998d0f$export$c6d0d020c3a6269; }, function (v) { return $84d79135b9998d0f$export$c6d0d020c3a6269 = v; });
$parcel$export(module.exports, "maj32", function () { return $84d79135b9998d0f$export$eb90c27fca05f956; }, function (v) { return $84d79135b9998d0f$export$eb90c27fca05f956 = v; });
$parcel$export(module.exports, "s0_256", function () { return $84d79135b9998d0f$export$14a4a98e063b1999; }, function (v) { return $84d79135b9998d0f$export$14a4a98e063b1999 = v; });
$parcel$export(module.exports, "s1_256", function () { return $84d79135b9998d0f$export$d20cecfa1564c686; }, function (v) { return $84d79135b9998d0f$export$d20cecfa1564c686 = v; });
$parcel$export(module.exports, "g0_256", function () { return $84d79135b9998d0f$export$44fd472a12fc6db; }, function (v) { return $84d79135b9998d0f$export$44fd472a12fc6db = v; });
$parcel$export(module.exports, "g1_256", function () { return $84d79135b9998d0f$export$1ed238bb6ea1dd47; }, function (v) { return $84d79135b9998d0f$export$1ed238bb6ea1dd47 = v; });
var $84d79135b9998d0f$export$5a92649d7ddb9f63;
var $84d79135b9998d0f$export$c6d0d020c3a6269;
var $84d79135b9998d0f$export$eb90c27fca05f956;
var $84d79135b9998d0f$export$cc992891a14496a1;
var $84d79135b9998d0f$export$14a4a98e063b1999;
var $84d79135b9998d0f$export$d20cecfa1564c686;
var $84d79135b9998d0f$export$44fd472a12fc6db;
var $84d79135b9998d0f$export$1ed238bb6ea1dd47;
'use strict';

var $dI1aK = parcelRequire("dI1aK");
var $84d79135b9998d0f$var$rotr32 = $dI1aK.rotr32;
function $84d79135b9998d0f$var$ft_1(s, x, y, z) {
    if (s === 0) return $84d79135b9998d0f$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $84d79135b9998d0f$var$p32(x, y, z);
    if (s === 2) return $84d79135b9998d0f$var$maj32(x, y, z);
}
$84d79135b9998d0f$export$5a92649d7ddb9f63 = $84d79135b9998d0f$var$ft_1;
function $84d79135b9998d0f$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$84d79135b9998d0f$export$c6d0d020c3a6269 = $84d79135b9998d0f$var$ch32;
function $84d79135b9998d0f$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$84d79135b9998d0f$export$eb90c27fca05f956 = $84d79135b9998d0f$var$maj32;
function $84d79135b9998d0f$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$84d79135b9998d0f$export$cc992891a14496a1 = $84d79135b9998d0f$var$p32;
function $84d79135b9998d0f$var$s0_256(x) {
    return $84d79135b9998d0f$var$rotr32(x, 2) ^ $84d79135b9998d0f$var$rotr32(x, 13) ^ $84d79135b9998d0f$var$rotr32(x, 22);
}
$84d79135b9998d0f$export$14a4a98e063b1999 = $84d79135b9998d0f$var$s0_256;
function $84d79135b9998d0f$var$s1_256(x) {
    return $84d79135b9998d0f$var$rotr32(x, 6) ^ $84d79135b9998d0f$var$rotr32(x, 11) ^ $84d79135b9998d0f$var$rotr32(x, 25);
}
$84d79135b9998d0f$export$d20cecfa1564c686 = $84d79135b9998d0f$var$s1_256;
function $84d79135b9998d0f$var$g0_256(x) {
    return $84d79135b9998d0f$var$rotr32(x, 7) ^ $84d79135b9998d0f$var$rotr32(x, 18) ^ x >>> 3;
}
$84d79135b9998d0f$export$44fd472a12fc6db = $84d79135b9998d0f$var$g0_256;
function $84d79135b9998d0f$var$g1_256(x) {
    return $84d79135b9998d0f$var$rotr32(x, 17) ^ $84d79135b9998d0f$var$rotr32(x, 19) ^ x >>> 10;
}
$84d79135b9998d0f$export$1ed238bb6ea1dd47 = $84d79135b9998d0f$var$g1_256;

});


parcelRegister("4YLz3", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $61P78 = parcelRequire("61P78");
function $3a01a951d278ea89$var$SHA224() {
    if (!(this instanceof $3a01a951d278ea89$var$SHA224)) return new $3a01a951d278ea89$var$SHA224();
    $61P78.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$dI1aK.inherits($3a01a951d278ea89$var$SHA224, $61P78);
module.exports = $3a01a951d278ea89$var$SHA224;
$3a01a951d278ea89$var$SHA224.blockSize = 512;
$3a01a951d278ea89$var$SHA224.outSize = 224;
$3a01a951d278ea89$var$SHA224.hmacStrength = 192;
$3a01a951d278ea89$var$SHA224.padLength = 64;
$3a01a951d278ea89$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === 'hex') return $dI1aK.toHex32(this.h.slice(0, 7), 'big');
    else return $dI1aK.split32(this.h.slice(0, 7), 'big');
};

});
parcelRegister("61P78", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $eBwUf = parcelRequire("eBwUf");

var $bp78H = parcelRequire("bp78H");

var $jYzim = parcelRequire("jYzim");
var $463a7c4439f60da8$var$sum32 = $dI1aK.sum32;
var $463a7c4439f60da8$var$sum32_4 = $dI1aK.sum32_4;
var $463a7c4439f60da8$var$sum32_5 = $dI1aK.sum32_5;
var $463a7c4439f60da8$var$ch32 = $bp78H.ch32;
var $463a7c4439f60da8$var$maj32 = $bp78H.maj32;
var $463a7c4439f60da8$var$s0_256 = $bp78H.s0_256;
var $463a7c4439f60da8$var$s1_256 = $bp78H.s1_256;
var $463a7c4439f60da8$var$g0_256 = $bp78H.g0_256;
var $463a7c4439f60da8$var$g1_256 = $bp78H.g1_256;
var $463a7c4439f60da8$var$BlockHash = $eBwUf.BlockHash;
var $463a7c4439f60da8$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $463a7c4439f60da8$var$SHA256() {
    if (!(this instanceof $463a7c4439f60da8$var$SHA256)) return new $463a7c4439f60da8$var$SHA256();
    $463a7c4439f60da8$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $463a7c4439f60da8$var$sha256_K;
    this.W = new Array(64);
}
$dI1aK.inherits($463a7c4439f60da8$var$SHA256, $463a7c4439f60da8$var$BlockHash);
module.exports = $463a7c4439f60da8$var$SHA256;
$463a7c4439f60da8$var$SHA256.blockSize = 512;
$463a7c4439f60da8$var$SHA256.outSize = 256;
$463a7c4439f60da8$var$SHA256.hmacStrength = 192;
$463a7c4439f60da8$var$SHA256.padLength = 64;
$463a7c4439f60da8$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $463a7c4439f60da8$var$sum32_4($463a7c4439f60da8$var$g1_256(W[i - 2]), W[i - 7], $463a7c4439f60da8$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $jYzim(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $463a7c4439f60da8$var$sum32_5(h, $463a7c4439f60da8$var$s1_256(e), $463a7c4439f60da8$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $463a7c4439f60da8$var$sum32($463a7c4439f60da8$var$s0_256(a), $463a7c4439f60da8$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $463a7c4439f60da8$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $463a7c4439f60da8$var$sum32(T1, T2);
    }
    this.h[0] = $463a7c4439f60da8$var$sum32(this.h[0], a);
    this.h[1] = $463a7c4439f60da8$var$sum32(this.h[1], b);
    this.h[2] = $463a7c4439f60da8$var$sum32(this.h[2], c);
    this.h[3] = $463a7c4439f60da8$var$sum32(this.h[3], d);
    this.h[4] = $463a7c4439f60da8$var$sum32(this.h[4], e);
    this.h[5] = $463a7c4439f60da8$var$sum32(this.h[5], f);
    this.h[6] = $463a7c4439f60da8$var$sum32(this.h[6], g);
    this.h[7] = $463a7c4439f60da8$var$sum32(this.h[7], h);
};
$463a7c4439f60da8$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $dI1aK.toHex32(this.h, 'big');
    else return $dI1aK.split32(this.h, 'big');
};

});


parcelRegister("4By0K", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $kxN2p = parcelRequire("kxN2p");
function $35a4fffe3e4163ae$var$SHA384() {
    if (!(this instanceof $35a4fffe3e4163ae$var$SHA384)) return new $35a4fffe3e4163ae$var$SHA384();
    $kxN2p.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$dI1aK.inherits($35a4fffe3e4163ae$var$SHA384, $kxN2p);
module.exports = $35a4fffe3e4163ae$var$SHA384;
$35a4fffe3e4163ae$var$SHA384.blockSize = 1024;
$35a4fffe3e4163ae$var$SHA384.outSize = 384;
$35a4fffe3e4163ae$var$SHA384.hmacStrength = 192;
$35a4fffe3e4163ae$var$SHA384.padLength = 128;
$35a4fffe3e4163ae$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $dI1aK.toHex32(this.h.slice(0, 12), 'big');
    else return $dI1aK.split32(this.h.slice(0, 12), 'big');
};

});
parcelRegister("kxN2p", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $eBwUf = parcelRequire("eBwUf");

var $jYzim = parcelRequire("jYzim");
var $ef4ced9940f9159f$var$rotr64_hi = $dI1aK.rotr64_hi;
var $ef4ced9940f9159f$var$rotr64_lo = $dI1aK.rotr64_lo;
var $ef4ced9940f9159f$var$shr64_hi = $dI1aK.shr64_hi;
var $ef4ced9940f9159f$var$shr64_lo = $dI1aK.shr64_lo;
var $ef4ced9940f9159f$var$sum64 = $dI1aK.sum64;
var $ef4ced9940f9159f$var$sum64_hi = $dI1aK.sum64_hi;
var $ef4ced9940f9159f$var$sum64_lo = $dI1aK.sum64_lo;
var $ef4ced9940f9159f$var$sum64_4_hi = $dI1aK.sum64_4_hi;
var $ef4ced9940f9159f$var$sum64_4_lo = $dI1aK.sum64_4_lo;
var $ef4ced9940f9159f$var$sum64_5_hi = $dI1aK.sum64_5_hi;
var $ef4ced9940f9159f$var$sum64_5_lo = $dI1aK.sum64_5_lo;
var $ef4ced9940f9159f$var$BlockHash = $eBwUf.BlockHash;
var $ef4ced9940f9159f$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $ef4ced9940f9159f$var$SHA512() {
    if (!(this instanceof $ef4ced9940f9159f$var$SHA512)) return new $ef4ced9940f9159f$var$SHA512();
    $ef4ced9940f9159f$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $ef4ced9940f9159f$var$sha512_K;
    this.W = new Array(160);
}
$dI1aK.inherits($ef4ced9940f9159f$var$SHA512, $ef4ced9940f9159f$var$BlockHash);
module.exports = $ef4ced9940f9159f$var$SHA512;
$ef4ced9940f9159f$var$SHA512.blockSize = 1024;
$ef4ced9940f9159f$var$SHA512.outSize = 512;
$ef4ced9940f9159f$var$SHA512.hmacStrength = 192;
$ef4ced9940f9159f$var$SHA512.padLength = 128;
$ef4ced9940f9159f$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $ef4ced9940f9159f$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $ef4ced9940f9159f$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $ef4ced9940f9159f$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $ef4ced9940f9159f$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $ef4ced9940f9159f$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $ef4ced9940f9159f$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$ef4ced9940f9159f$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $jYzim(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $ef4ced9940f9159f$var$s1_512_hi(eh, el);
        var c1_lo = $ef4ced9940f9159f$var$s1_512_lo(eh, el);
        var c2_hi = $ef4ced9940f9159f$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $ef4ced9940f9159f$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $ef4ced9940f9159f$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $ef4ced9940f9159f$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $ef4ced9940f9159f$var$s0_512_hi(ah, al);
        c0_lo = $ef4ced9940f9159f$var$s0_512_lo(ah, al);
        c1_hi = $ef4ced9940f9159f$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $ef4ced9940f9159f$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $ef4ced9940f9159f$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $ef4ced9940f9159f$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $ef4ced9940f9159f$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $ef4ced9940f9159f$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $ef4ced9940f9159f$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $ef4ced9940f9159f$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $ef4ced9940f9159f$var$sum64(this.h, 0, ah, al);
    $ef4ced9940f9159f$var$sum64(this.h, 2, bh, bl);
    $ef4ced9940f9159f$var$sum64(this.h, 4, ch, cl);
    $ef4ced9940f9159f$var$sum64(this.h, 6, dh, dl);
    $ef4ced9940f9159f$var$sum64(this.h, 8, eh, el);
    $ef4ced9940f9159f$var$sum64(this.h, 10, fh, fl);
    $ef4ced9940f9159f$var$sum64(this.h, 12, gh, gl);
    $ef4ced9940f9159f$var$sum64(this.h, 14, hh, hl);
};
$ef4ced9940f9159f$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $dI1aK.toHex32(this.h, 'big');
    else return $dI1aK.split32(this.h, 'big');
};
function $ef4ced9940f9159f$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$s0_512_hi(xh, xl) {
    var c0_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $ef4ced9940f9159f$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $ef4ced9940f9159f$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$s0_512_lo(xh, xl) {
    var c0_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $ef4ced9940f9159f$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $ef4ced9940f9159f$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$s1_512_hi(xh, xl) {
    var c0_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $ef4ced9940f9159f$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$s1_512_lo(xh, xl) {
    var c0_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $ef4ced9940f9159f$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$g0_512_hi(xh, xl) {
    var c0_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $ef4ced9940f9159f$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$g0_512_lo(xh, xl) {
    var c0_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $ef4ced9940f9159f$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$g1_512_hi(xh, xl) {
    var c0_hi = $ef4ced9940f9159f$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $ef4ced9940f9159f$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $ef4ced9940f9159f$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $ef4ced9940f9159f$var$g1_512_lo(xh, xl) {
    var c0_lo = $ef4ced9940f9159f$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $ef4ced9940f9159f$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $ef4ced9940f9159f$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("jbOHA", function(module, exports) {

$parcel$export(module.exports, "ripemd160", function () { return $df865fc9f0c0bbc7$export$d1cea0ee4e3f0d3e; }, function (v) { return $df865fc9f0c0bbc7$export$d1cea0ee4e3f0d3e = v; });
var $df865fc9f0c0bbc7$export$d1cea0ee4e3f0d3e;
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $eBwUf = parcelRequire("eBwUf");
var $df865fc9f0c0bbc7$var$rotl32 = $dI1aK.rotl32;
var $df865fc9f0c0bbc7$var$sum32 = $dI1aK.sum32;
var $df865fc9f0c0bbc7$var$sum32_3 = $dI1aK.sum32_3;
var $df865fc9f0c0bbc7$var$sum32_4 = $dI1aK.sum32_4;
var $df865fc9f0c0bbc7$var$BlockHash = $eBwUf.BlockHash;
function $df865fc9f0c0bbc7$var$RIPEMD160() {
    if (!(this instanceof $df865fc9f0c0bbc7$var$RIPEMD160)) return new $df865fc9f0c0bbc7$var$RIPEMD160();
    $df865fc9f0c0bbc7$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = 'little';
}
$dI1aK.inherits($df865fc9f0c0bbc7$var$RIPEMD160, $df865fc9f0c0bbc7$var$BlockHash);
$df865fc9f0c0bbc7$export$d1cea0ee4e3f0d3e = $df865fc9f0c0bbc7$var$RIPEMD160;
$df865fc9f0c0bbc7$var$RIPEMD160.blockSize = 512;
$df865fc9f0c0bbc7$var$RIPEMD160.outSize = 160;
$df865fc9f0c0bbc7$var$RIPEMD160.hmacStrength = 192;
$df865fc9f0c0bbc7$var$RIPEMD160.padLength = 64;
$df865fc9f0c0bbc7$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $df865fc9f0c0bbc7$var$sum32($df865fc9f0c0bbc7$var$rotl32($df865fc9f0c0bbc7$var$sum32_4(A, $df865fc9f0c0bbc7$var$f(j, B, C, D), msg[$df865fc9f0c0bbc7$var$r[j] + start], $df865fc9f0c0bbc7$var$K(j)), $df865fc9f0c0bbc7$var$s[j]), E);
        A = E;
        E = D;
        D = $df865fc9f0c0bbc7$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $df865fc9f0c0bbc7$var$sum32($df865fc9f0c0bbc7$var$rotl32($df865fc9f0c0bbc7$var$sum32_4(Ah, $df865fc9f0c0bbc7$var$f(79 - j, Bh, Ch, Dh), msg[$df865fc9f0c0bbc7$var$rh[j] + start], $df865fc9f0c0bbc7$var$Kh(j)), $df865fc9f0c0bbc7$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $df865fc9f0c0bbc7$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $df865fc9f0c0bbc7$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $df865fc9f0c0bbc7$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $df865fc9f0c0bbc7$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $df865fc9f0c0bbc7$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $df865fc9f0c0bbc7$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$df865fc9f0c0bbc7$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === 'hex') return $dI1aK.toHex32(this.h, 'little');
    else return $dI1aK.split32(this.h, 'little');
};
function $df865fc9f0c0bbc7$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $df865fc9f0c0bbc7$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $df865fc9f0c0bbc7$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $df865fc9f0c0bbc7$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $df865fc9f0c0bbc7$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $df865fc9f0c0bbc7$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $df865fc9f0c0bbc7$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("7JAvW", function(module, exports) {
'use strict';

var $dI1aK = parcelRequire("dI1aK");

var $jYzim = parcelRequire("jYzim");
function $5a190f529df3c7b5$var$Hmac(hash, key, enc) {
    if (!(this instanceof $5a190f529df3c7b5$var$Hmac)) return new $5a190f529df3c7b5$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($dI1aK.toArray(key, enc));
}
module.exports = $5a190f529df3c7b5$var$Hmac;
$5a190f529df3c7b5$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $jYzim(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$5a190f529df3c7b5$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$5a190f529df3c7b5$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("48kJp", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                'e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a',
                'f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821'
            ],
            [
                '8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508',
                '11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf'
            ],
            [
                '175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739',
                'd3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695'
            ],
            [
                '363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640',
                '4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9'
            ],
            [
                '8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c',
                '4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36'
            ],
            [
                '723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda',
                '96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f'
            ],
            [
                'eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa',
                '5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999'
            ],
            [
                '100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0',
                'cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09'
            ],
            [
                'e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d',
                '9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d'
            ],
            [
                'feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d',
                'e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088'
            ],
            [
                'da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1',
                '9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d'
            ],
            [
                '53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0',
                '5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8'
            ],
            [
                '8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047',
                '10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a'
            ],
            [
                '385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862',
                '283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453'
            ],
            [
                '6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7',
                '7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160'
            ],
            [
                '3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd',
                '56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0'
            ],
            [
                '85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83',
                '7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6'
            ],
            [
                '948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a',
                '53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589'
            ],
            [
                '6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8',
                'bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17'
            ],
            [
                'e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d',
                '4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda'
            ],
            [
                'e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725',
                '7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd'
            ],
            [
                '213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754',
                '4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2'
            ],
            [
                '4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c',
                '17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6'
            ],
            [
                'fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6',
                '6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f'
            ],
            [
                '76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39',
                'c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01'
            ],
            [
                'c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891',
                '893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3'
            ],
            [
                'd895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b',
                'febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f'
            ],
            [
                'b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03',
                '2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7'
            ],
            [
                'e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d',
                'eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78'
            ],
            [
                'a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070',
                '7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1'
            ],
            [
                '90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4',
                'e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150'
            ],
            [
                '8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da',
                '662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82'
            ],
            [
                'e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11',
                '1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc'
            ],
            [
                '8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e',
                'efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b'
            ],
            [
                'e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41',
                '2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51'
            ],
            [
                'b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef',
                '67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45'
            ],
            [
                'd68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8',
                'db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120'
            ],
            [
                '324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d',
                '648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84'
            ],
            [
                '4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96',
                '35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d'
            ],
            [
                '9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd',
                'ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d'
            ],
            [
                '6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5',
                '9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8'
            ],
            [
                'a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266',
                '40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8'
            ],
            [
                '7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71',
                '34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac'
            ],
            [
                '928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac',
                'c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f'
            ],
            [
                '85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751',
                '1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962'
            ],
            [
                'ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e',
                '493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907'
            ],
            [
                '827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241',
                'c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec'
            ],
            [
                'eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3',
                'be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d'
            ],
            [
                'e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f',
                '4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414'
            ],
            [
                '1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19',
                'aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd'
            ],
            [
                '146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be',
                'b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0'
            ],
            [
                'fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9',
                '6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811'
            ],
            [
                'da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2',
                '8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1'
            ],
            [
                'a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13',
                '7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c'
            ],
            [
                '174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c',
                'ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73'
            ],
            [
                '959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba',
                '2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd'
            ],
            [
                'd2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151',
                'e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405'
            ],
            [
                '64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073',
                'd99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589'
            ],
            [
                '8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458',
                '38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e'
            ],
            [
                '13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b',
                '69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27'
            ],
            [
                'bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366',
                'd3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1'
            ],
            [
                '8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa',
                '40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482'
            ],
            [
                '8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0',
                '620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945'
            ],
            [
                'dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787',
                '7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573'
            ],
            [
                'f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e',
                'ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82'
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                'f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9',
                '388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672'
            ],
            [
                '2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4',
                'd8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6'
            ],
            [
                '5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc',
                '6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da'
            ],
            [
                'acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe',
                'cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37'
            ],
            [
                '774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb',
                'd984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b'
            ],
            [
                'f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8',
                'ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81'
            ],
            [
                'd7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e',
                '581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58'
            ],
            [
                'defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34',
                '4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77'
            ],
            [
                '2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c',
                '85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a'
            ],
            [
                '352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5',
                '321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c'
            ],
            [
                '2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f',
                '2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67'
            ],
            [
                '9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714',
                '73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402'
            ],
            [
                'daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729',
                'a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55'
            ],
            [
                'c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db',
                '2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482'
            ],
            [
                '6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4',
                'e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82'
            ],
            [
                '1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5',
                'b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396'
            ],
            [
                '605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479',
                '2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49'
            ],
            [
                '62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d',
                '80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf'
            ],
            [
                '80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f',
                '1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a'
            ],
            [
                '7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb',
                'd0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7'
            ],
            [
                'd528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9',
                'eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933'
            ],
            [
                '49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963',
                '758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a'
            ],
            [
                '77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74',
                '958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6'
            ],
            [
                'f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530',
                'e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37'
            ],
            [
                '463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b',
                '5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e'
            ],
            [
                'f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247',
                'cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6'
            ],
            [
                'caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1',
                'cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476'
            ],
            [
                '2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120',
                '4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40'
            ],
            [
                '7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435',
                '91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61'
            ],
            [
                '754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18',
                '673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683'
            ],
            [
                'e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8',
                '59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5'
            ],
            [
                '186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb',
                '3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b'
            ],
            [
                'df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f',
                '55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417'
            ],
            [
                '5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143',
                'efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868'
            ],
            [
                '290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba',
                'e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a'
            ],
            [
                'af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45',
                'f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6'
            ],
            [
                '766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a',
                '744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996'
            ],
            [
                '59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e',
                'c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e'
            ],
            [
                'f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8',
                'e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d'
            ],
            [
                '7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c',
                '30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2'
            ],
            [
                '948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519',
                'e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e'
            ],
            [
                '7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab',
                '100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437'
            ],
            [
                '3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca',
                'ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311'
            ],
            [
                'd3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf',
                '8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4'
            ],
            [
                '1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610',
                '68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575'
            ],
            [
                '733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4',
                'f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d'
            ],
            [
                '15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c',
                'd56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d'
            ],
            [
                'a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940',
                'edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629'
            ],
            [
                'e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980',
                'a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06'
            ],
            [
                '311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3',
                '66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374'
            ],
            [
                '34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf',
                '9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee'
            ],
            [
                'f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63',
                '4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1'
            ],
            [
                'd7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448',
                'fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b'
            ],
            [
                '32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf',
                '5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661'
            ],
            [
                '7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5',
                '8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6'
            ],
            [
                'ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6',
                '8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e'
            ],
            [
                '16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5',
                '5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d'
            ],
            [
                'eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99',
                'f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc'
            ],
            [
                '78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51',
                'f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4'
            ],
            [
                '494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5',
                '42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c'
            ],
            [
                'a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5',
                '204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b'
            ],
            [
                'c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997',
                '4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913'
            ],
            [
                '841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881',
                '73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154'
            ],
            [
                '5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5',
                '39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865'
            ],
            [
                '36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66',
                'd2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc'
            ],
            [
                '336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726',
                'ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224'
            ],
            [
                '8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede',
                '6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e'
            ],
            [
                '1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94',
                '60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6'
            ],
            [
                '85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31',
                '3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511'
            ],
            [
                '29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51',
                'b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b'
            ],
            [
                'a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252',
                'ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2'
            ],
            [
                '4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5',
                'cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c'
            ],
            [
                'd24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b',
                '6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3'
            ],
            [
                'ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4',
                '322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d'
            ],
            [
                'af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f',
                '6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700'
            ],
            [
                'e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889',
                '2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4'
            ],
            [
                '591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246',
                'b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196'
            ],
            [
                '11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984',
                '998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4'
            ],
            [
                '3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a',
                'b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257'
            ],
            [
                'cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030',
                'bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13'
            ],
            [
                'c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197',
                '6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096'
            ],
            [
                'c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593',
                'c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38'
            ],
            [
                'a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef',
                '21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f'
            ],
            [
                '347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38',
                '60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448'
            ],
            [
                'da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a',
                '49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a'
            ],
            [
                'c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111',
                '5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4'
            ],
            [
                '4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502',
                '7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437'
            ],
            [
                '3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea',
                'be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7'
            ],
            [
                'cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26',
                '8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d'
            ],
            [
                'b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986',
                '39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a'
            ],
            [
                'd4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e',
                '62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54'
            ],
            [
                '48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4',
                '25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77'
            ],
            [
                'dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda',
                'ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517'
            ],
            [
                '6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859',
                'cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10'
            ],
            [
                'e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f',
                'f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125'
            ],
            [
                'eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c',
                '6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e'
            ],
            [
                '13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942',
                'fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1'
            ],
            [
                'ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a',
                '1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2'
            ],
            [
                'b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80',
                '5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423'
            ],
            [
                'ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d',
                '438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8'
            ],
            [
                '8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1',
                'cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758'
            ],
            [
                '52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63',
                'c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375'
            ],
            [
                'e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352',
                '6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d'
            ],
            [
                '7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193',
                'ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec'
            ],
            [
                '5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00',
                '9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0'
            ],
            [
                '32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58',
                'ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c'
            ],
            [
                'e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7',
                'd3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4'
            ],
            [
                '8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8',
                'c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f'
            ],
            [
                '4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e',
                '67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649'
            ],
            [
                '3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d',
                'cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826'
            ],
            [
                '674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b',
                '299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5'
            ],
            [
                'd32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f',
                'f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87'
            ],
            [
                '30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6',
                '462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b'
            ],
            [
                'be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297',
                '62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc'
            ],
            [
                '93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a',
                '7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c'
            ],
            [
                'b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c',
                'ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f'
            ],
            [
                'd5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52',
                '4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a'
            ],
            [
                'd3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb',
                'bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46'
            ],
            [
                '463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065',
                'bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f'
            ],
            [
                '7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917',
                '603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03'
            ],
            [
                '74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9',
                'cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08'
            ],
            [
                '30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3',
                '553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8'
            ],
            [
                '9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57',
                '712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373'
            ],
            [
                '176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66',
                'ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3'
            ],
            [
                '75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8',
                '9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8'
            ],
            [
                '809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721',
                '9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1'
            ],
            [
                '1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180',
                '4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9'
            ]
        ]
    }
};

});


parcelRegister("03Jl3", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $bnFMi = parcelRequire("bnFMi");

var $aySOc = parcelRequire("aySOc");

var $dcalr = parcelRequire("dcalr");

var $71KMl = parcelRequire("71KMl");
var $00b3733ef0e5df6e$var$assert = $aySOc.assert;

var $04rUh = parcelRequire("04rUh");

var $99mvd = parcelRequire("99mvd");
function $00b3733ef0e5df6e$var$EC(options) {
    if (!(this instanceof $00b3733ef0e5df6e$var$EC)) return new $00b3733ef0e5df6e$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === 'string') {
        $00b3733ef0e5df6e$var$assert(Object.prototype.hasOwnProperty.call($dcalr, options), 'Unknown curve ' + options);
        options = $dcalr[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $dcalr.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $00b3733ef0e5df6e$var$EC;
$00b3733ef0e5df6e$var$EC.prototype.keyPair = function keyPair(options) {
    return new $04rUh(this, options);
};
$00b3733ef0e5df6e$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $04rUh.fromPrivate(this, priv, enc);
};
$00b3733ef0e5df6e$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $04rUh.fromPublic(this, pub, enc);
};
$00b3733ef0e5df6e$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $bnFMi({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8',
        entropy: options.entropy || $71KMl(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || 'utf8',
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $crOW0(2));
    for(;;){
        var priv = new $crOW0(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$00b3733ef0e5df6e$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($crOW0.isBN(msg) || typeof msg === 'number') {
        msg = new $crOW0(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === 'object') {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $crOW0(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $crOW0(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== 'number') bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$00b3733ef0e5df6e$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === 'object') {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== 'string' && typeof msg !== 'number' && !$crOW0.isBN(msg)) {
        $00b3733ef0e5df6e$var$assert(typeof msg === 'object' && msg && typeof msg.length === 'number', 'Expected message to be an array-like, a hex string, or a BN instance');
        $00b3733ef0e5df6e$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$00b3733ef0e5df6e$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $00b3733ef0e5df6e$var$assert(!msg.isNeg(), 'Can not sign a negative message');
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray('be', bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray('be', bytes);
    // Recheck nonce to be bijective to msg
    $00b3733ef0e5df6e$var$assert(new $crOW0(nonce).eq(msg), 'Can not sign message');
    // Instantiate Hmac_DRBG
    var drbg = new $bnFMi({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || 'utf8'
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $crOW0(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $crOW0(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $99mvd({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$00b3733ef0e5df6e$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $99mvd(signature, 'hex');
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$00b3733ef0e5df6e$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $00b3733ef0e5df6e$var$assert((3 & j) === j, 'The recovery param is more than two bits');
    signature = new $99mvd(signature, enc);
    var n = this.n;
    var e = new $crOW0(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error('Unable to find sencond key candinate');
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$00b3733ef0e5df6e$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $99mvd(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error('Unable to find valid recovery factor');
};

});
parcelRegister("bnFMi", function(module, exports) {
'use strict';

var $80ODB = parcelRequire("80ODB");

var $aTJ3h = parcelRequire("aTJ3h");

var $jYzim = parcelRequire("jYzim");
function $84923ff27d078916$var$HmacDRBG(options) {
    if (!(this instanceof $84923ff27d078916$var$HmacDRBG)) return new $84923ff27d078916$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $aTJ3h.toArray(options.entropy, options.entropyEnc || 'hex');
    var nonce = $aTJ3h.toArray(options.nonce, options.nonceEnc || 'hex');
    var pers = $aTJ3h.toArray(options.pers, options.persEnc || 'hex');
    $jYzim(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._init(entropy, nonce, pers);
}
module.exports = $84923ff27d078916$var$HmacDRBG;
$84923ff27d078916$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$84923ff27d078916$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $80ODB.hmac(this.hash, this.K);
};
$84923ff27d078916$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$84923ff27d078916$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== 'string') {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $aTJ3h.toArray(entropy, entropyEnc);
    add = $aTJ3h.toArray(add, addEnc);
    $jYzim(entropy.length >= this.minEntropy / 8, 'Not enough entropy. Minimum is: ' + this.minEntropy + ' bits');
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$84923ff27d078916$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error('Reseed is required');
    // Optional encoding
    if (typeof enc !== 'string') {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $aTJ3h.toArray(add, addEnc || 'hex');
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $aTJ3h.encode(res, enc);
};

});

parcelRegister("04rUh", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $aySOc = parcelRequire("aySOc");
var $00d6058b9ac48dfa$var$assert = $aySOc.assert;
function $00d6058b9ac48dfa$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $00d6058b9ac48dfa$var$KeyPair;
$00d6058b9ac48dfa$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $00d6058b9ac48dfa$var$KeyPair) return pub;
    return new $00d6058b9ac48dfa$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$00d6058b9ac48dfa$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $00d6058b9ac48dfa$var$KeyPair) return priv;
    return new $00d6058b9ac48dfa$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$00d6058b9ac48dfa$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: 'Invalid public key'
    };
    if (!pub.validate()) return {
        result: false,
        reason: 'Public key is not a point'
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: 'Public key * N != O'
    };
    return {
        result: true,
        reason: null
    };
};
$00d6058b9ac48dfa$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === 'string') {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$00d6058b9ac48dfa$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === 'hex') return this.priv.toString(16, 2);
    else return this.priv;
};
$00d6058b9ac48dfa$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $crOW0(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$00d6058b9ac48dfa$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === 'mont') $00d6058b9ac48dfa$var$assert(key.x, 'Need x coordinate');
        else if (this.ec.curve.type === 'short' || this.ec.curve.type === 'edwards') $00d6058b9ac48dfa$var$assert(key.x && key.y, 'Need both x and y coordinate');
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$00d6058b9ac48dfa$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $00d6058b9ac48dfa$var$assert(pub.validate(), 'public point not validated');
    return pub.mul(this.priv).getX();
};
// ECDSA
$00d6058b9ac48dfa$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$00d6058b9ac48dfa$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$00d6058b9ac48dfa$var$KeyPair.prototype.inspect = function inspect() {
    return '<Key priv: ' + (this.priv && this.priv.toString(16, 2)) + ' pub: ' + (this.pub && this.pub.inspect()) + ' >';
};

});

parcelRegister("99mvd", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $aySOc = parcelRequire("aySOc");
var $6a9668db42de3e95$var$assert = $aySOc.assert;
function $6a9668db42de3e95$var$Signature(options, enc) {
    if (options instanceof $6a9668db42de3e95$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $6a9668db42de3e95$var$assert(options.r && options.s, 'Signature without r or s');
    this.r = new $crOW0(options.r, 16);
    this.s = new $crOW0(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $6a9668db42de3e95$var$Signature;
function $6a9668db42de3e95$var$Position() {
    this.place = 0;
}
function $6a9668db42de3e95$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $6a9668db42de3e95$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$6a9668db42de3e95$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $aySOc.toArray(data, enc);
    var p = new $6a9668db42de3e95$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $6a9668db42de3e95$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $6a9668db42de3e95$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $6a9668db42de3e95$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $crOW0(r);
    this.s = new $crOW0(s);
    this.recoveryParam = null;
    return true;
};
function $6a9668db42de3e95$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$6a9668db42de3e95$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $6a9668db42de3e95$var$rmPadding(r);
    s = $6a9668db42de3e95$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $6a9668db42de3e95$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $6a9668db42de3e95$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $6a9668db42de3e95$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $aySOc.encode(res, enc);
};

});


parcelRegister("9SVuJ", function(module, exports) {
'use strict';

var $80ODB = parcelRequire("80ODB");

var $dcalr = parcelRequire("dcalr");

var $aySOc = parcelRequire("aySOc");
var $7325c16f8c0c721e$var$assert = $aySOc.assert;
var $7325c16f8c0c721e$var$parseBytes = $aySOc.parseBytes;

var $efKpm = parcelRequire("efKpm");

var $22rJ4 = parcelRequire("22rJ4");
function $7325c16f8c0c721e$var$EDDSA(curve) {
    $7325c16f8c0c721e$var$assert(curve === 'ed25519', 'only tested with ed25519 so far');
    if (!(this instanceof $7325c16f8c0c721e$var$EDDSA)) return new $7325c16f8c0c721e$var$EDDSA(curve);
    curve = $dcalr[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $80ODB.sha512;
}
module.exports = $7325c16f8c0c721e$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $7325c16f8c0c721e$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $7325c16f8c0c721e$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $7325c16f8c0c721e$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $7325c16f8c0c721e$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$7325c16f8c0c721e$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $aySOc.intFromLE(hash.digest()).umod(this.curve.n);
};
$7325c16f8c0c721e$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $efKpm.fromPublic(this, pub);
};
$7325c16f8c0c721e$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $efKpm.fromSecret(this, secret);
};
$7325c16f8c0c721e$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $22rJ4) return sig;
    return new $22rJ4(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $7325c16f8c0c721e$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray('le', this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$7325c16f8c0c721e$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $aySOc.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $aySOc.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$7325c16f8c0c721e$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray('le', this.encodingLength);
};
$7325c16f8c0c721e$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $aySOc.intFromLE(bytes);
};
$7325c16f8c0c721e$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("efKpm", function(module, exports) {
'use strict';

var $aySOc = parcelRequire("aySOc");
var $a6067717bfa98618$var$assert = $aySOc.assert;
var $a6067717bfa98618$var$parseBytes = $aySOc.parseBytes;
var $a6067717bfa98618$var$cachedProperty = $aySOc.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $a6067717bfa98618$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $a6067717bfa98618$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $a6067717bfa98618$var$parseBytes(params.pub);
}
$a6067717bfa98618$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $a6067717bfa98618$var$KeyPair) return pub;
    return new $a6067717bfa98618$var$KeyPair(eddsa, {
        pub: pub
    });
};
$a6067717bfa98618$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $a6067717bfa98618$var$KeyPair) return secret;
    return new $a6067717bfa98618$var$KeyPair(eddsa, {
        secret: secret
    });
};
$a6067717bfa98618$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'pubBytes', function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'pub', function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'privBytes', function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'priv', function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'hash', function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$a6067717bfa98618$var$cachedProperty($a6067717bfa98618$var$KeyPair, 'messagePrefix', function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$a6067717bfa98618$var$KeyPair.prototype.sign = function sign(message) {
    $a6067717bfa98618$var$assert(this._secret, 'KeyPair can only verify');
    return this.eddsa.sign(message, this);
};
$a6067717bfa98618$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$a6067717bfa98618$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $a6067717bfa98618$var$assert(this._secret, 'KeyPair is public only');
    return $aySOc.encode(this.secret(), enc);
};
$a6067717bfa98618$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $aySOc.encode(this.pubBytes(), enc);
};
module.exports = $a6067717bfa98618$var$KeyPair;

});

parcelRegister("22rJ4", function(module, exports) {
'use strict';

var $crOW0 = parcelRequire("crOW0");

var $aySOc = parcelRequire("aySOc");
var $17c1467e76eb133f$var$assert = $aySOc.assert;
var $17c1467e76eb133f$var$cachedProperty = $aySOc.cachedProperty;
var $17c1467e76eb133f$var$parseBytes = $aySOc.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $17c1467e76eb133f$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== 'object') sig = $17c1467e76eb133f$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $17c1467e76eb133f$var$assert(sig.length === eddsa.encodingLength * 2, 'Signature has invalid size');
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $17c1467e76eb133f$var$assert(sig.R && sig.S, 'Signature without R or S');
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $crOW0) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$17c1467e76eb133f$var$cachedProperty($17c1467e76eb133f$var$Signature, 'S', function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$17c1467e76eb133f$var$cachedProperty($17c1467e76eb133f$var$Signature, 'R', function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$17c1467e76eb133f$var$cachedProperty($17c1467e76eb133f$var$Signature, 'Rencoded', function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$17c1467e76eb133f$var$cachedProperty($17c1467e76eb133f$var$Signature, 'Sencoded', function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$17c1467e76eb133f$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$17c1467e76eb133f$var$Signature.prototype.toHex = function toHex() {
    return $aySOc.encode(this.toBytes(), 'hex').toUpperCase();
};
module.exports = $17c1467e76eb133f$var$Signature;

});



parcelRegister("azRsG", function(module, exports) {
'use strict';

var $wHMk9 = parcelRequire("wHMk9");

var $5uAfa = parcelRequire("5uAfa");

var $co1YS = parcelRequire("co1YS");

var $fAIFp = parcelRequire("fAIFp");

var $356zK = parcelRequire("356zK");
var $7b36a4a1285bf317$require$pbkdf2Sync = $356zK.pbkdf2Sync;

var $6arys = parcelRequire("6arys");
var $7b36a4a1285bf317$require$Buffer = $6arys.Buffer;
function $7b36a4a1285bf317$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5uAfa[data.algorithm.decrypt.cipher.algo.join('.')];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split('-')[1], 10) / 8;
    var key = $7b36a4a1285bf317$require$pbkdf2Sync(password, salt, iters, keylen, 'sha1');
    var cipher = $fAIFp.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher['final']());
    return $7b36a4a1285bf317$require$Buffer.concat(out);
}
function $7b36a4a1285bf317$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === 'object' && !$7b36a4a1285bf317$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === 'string') buffer = $7b36a4a1285bf317$require$Buffer.from(buffer);
    var stripped = $co1YS(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case 'CERTIFICATE':
            ndata = $wHMk9.certificate.decode(data, 'der').tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case 'PUBLIC KEY':
            if (!ndata) ndata = $wHMk9.PublicKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $wHMk9.RSAPublicKey.decode(ndata.subjectPublicKey.data, 'der');
                case '1.2.840.10045.2.1':
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: 'ec',
                        data: ndata
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.pub_key = $wHMk9.DSAparam.decode(ndata.subjectPublicKey.data, 'der');
                    return {
                        type: 'dsa',
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'ENCRYPTED PRIVATE KEY':
            data = $wHMk9.EncryptedPrivateKey.decode(data, 'der');
            data = $7b36a4a1285bf317$var$decrypt(data, password);
        // falls through
        case 'PRIVATE KEY':
            ndata = $wHMk9.PrivateKey.decode(data, 'der');
            subtype = ndata.algorithm.algorithm.join('.');
            switch(subtype){
                case '1.2.840.113549.1.1.1':
                    return $wHMk9.RSAPrivateKey.decode(ndata.subjectPrivateKey, 'der');
                case '1.2.840.10045.2.1':
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $wHMk9.ECPrivateKey.decode(ndata.subjectPrivateKey, 'der').privateKey
                    };
                case '1.2.840.10040.4.1':
                    ndata.algorithm.params.priv_key = $wHMk9.DSAparam.decode(ndata.subjectPrivateKey, 'der');
                    return {
                        type: 'dsa',
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error('unknown key id ' + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case 'RSA PUBLIC KEY':
            return $wHMk9.RSAPublicKey.decode(data, 'der');
        case 'RSA PRIVATE KEY':
            return $wHMk9.RSAPrivateKey.decode(data, 'der');
        case 'DSA PRIVATE KEY':
            return {
                type: 'dsa',
                params: $wHMk9.DSAPrivateKey.decode(data, 'der')
            };
        case 'EC PRIVATE KEY':
            data = $wHMk9.ECPrivateKey.decode(data, 'der');
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error('unknown key type ' + type);
    }
}
$7b36a4a1285bf317$var$parseKeys.signature = $wHMk9.signature;
module.exports = $7b36a4a1285bf317$var$parseKeys;

});
parcelRegister("wHMk9", function(module, exports) {

$parcel$export(module.exports, "certificate", function () { return $0624f2c18c9a45a3$export$c98397a6eb8d0678; }, function (v) { return $0624f2c18c9a45a3$export$c98397a6eb8d0678 = v; });
$parcel$export(module.exports, "RSAPrivateKey", function () { return $0624f2c18c9a45a3$export$f4aab6816f64fa6b; }, function (v) { return $0624f2c18c9a45a3$export$f4aab6816f64fa6b = v; });
$parcel$export(module.exports, "RSAPublicKey", function () { return $0624f2c18c9a45a3$export$4471f5c65d097c11; }, function (v) { return $0624f2c18c9a45a3$export$4471f5c65d097c11 = v; });
$parcel$export(module.exports, "PublicKey", function () { return $0624f2c18c9a45a3$export$ca8b6604d6ce14de; }, function (v) { return $0624f2c18c9a45a3$export$ca8b6604d6ce14de = v; });
$parcel$export(module.exports, "PrivateKey", function () { return $0624f2c18c9a45a3$export$8f54525b330fd87b; }, function (v) { return $0624f2c18c9a45a3$export$8f54525b330fd87b = v; });
$parcel$export(module.exports, "EncryptedPrivateKey", function () { return $0624f2c18c9a45a3$export$23cd2842b44ca3e7; }, function (v) { return $0624f2c18c9a45a3$export$23cd2842b44ca3e7 = v; });
$parcel$export(module.exports, "DSAPrivateKey", function () { return $0624f2c18c9a45a3$export$245c9aaa9f5ce4ce; }, function (v) { return $0624f2c18c9a45a3$export$245c9aaa9f5ce4ce = v; });
$parcel$export(module.exports, "DSAparam", function () { return $0624f2c18c9a45a3$export$8ad762e3e6399afe; }, function (v) { return $0624f2c18c9a45a3$export$8ad762e3e6399afe = v; });
$parcel$export(module.exports, "ECPrivateKey", function () { return $0624f2c18c9a45a3$export$32ef6f92e22c6ab0; }, function (v) { return $0624f2c18c9a45a3$export$32ef6f92e22c6ab0 = v; });
$parcel$export(module.exports, "signature", function () { return $0624f2c18c9a45a3$export$c9cd164b539ebb63; }, function (v) { return $0624f2c18c9a45a3$export$c9cd164b539ebb63 = v; });
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $0624f2c18c9a45a3$export$c98397a6eb8d0678;
var $0624f2c18c9a45a3$export$f4aab6816f64fa6b;
var $0624f2c18c9a45a3$export$4471f5c65d097c11;
var $0624f2c18c9a45a3$export$ca8b6604d6ce14de;
var $0624f2c18c9a45a3$export$8f54525b330fd87b;
var $0624f2c18c9a45a3$export$23cd2842b44ca3e7;
var $0624f2c18c9a45a3$export$245c9aaa9f5ce4ce;
var $0624f2c18c9a45a3$export$8ad762e3e6399afe;
var $0624f2c18c9a45a3$export$32ef6f92e22c6ab0;
var $0624f2c18c9a45a3$export$c9cd164b539ebb63;
'use strict';

var $1yzSj = parcelRequire("1yzSj");

$0624f2c18c9a45a3$export$c98397a6eb8d0678 = (parcelRequire("4cT3F"));
var $0624f2c18c9a45a3$var$RSAPrivateKey = $1yzSj.define('RSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('modulus')['int'](), this.key('publicExponent')['int'](), this.key('privateExponent')['int'](), this.key('prime1')['int'](), this.key('prime2')['int'](), this.key('exponent1')['int'](), this.key('exponent2')['int'](), this.key('coefficient')['int']());
});
$0624f2c18c9a45a3$export$f4aab6816f64fa6b = $0624f2c18c9a45a3$var$RSAPrivateKey;
var $0624f2c18c9a45a3$var$RSAPublicKey = $1yzSj.define('RSAPublicKey', function() {
    this.seq().obj(this.key('modulus')['int'](), this.key('publicExponent')['int']());
});
$0624f2c18c9a45a3$export$4471f5c65d097c11 = $0624f2c18c9a45a3$var$RSAPublicKey;
var $0624f2c18c9a45a3$var$AlgorithmIdentifier = $1yzSj.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('none').null_().optional(), this.key('curve').objid().optional(), this.key('params').seq().obj(this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int']()).optional());
});
var $0624f2c18c9a45a3$var$PublicKey = $1yzSj.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($0624f2c18c9a45a3$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
$0624f2c18c9a45a3$export$ca8b6604d6ce14de = $0624f2c18c9a45a3$var$PublicKey;
var $0624f2c18c9a45a3$var$PrivateKeyInfo = $1yzSj.define('PrivateKeyInfo', function() {
    this.seq().obj(this.key('version')['int'](), this.key('algorithm').use($0624f2c18c9a45a3$var$AlgorithmIdentifier), this.key('subjectPrivateKey').octstr());
});
$0624f2c18c9a45a3$export$8f54525b330fd87b = $0624f2c18c9a45a3$var$PrivateKeyInfo;
var $0624f2c18c9a45a3$var$EncryptedPrivateKeyInfo = $1yzSj.define('EncryptedPrivateKeyInfo', function() {
    this.seq().obj(this.key('algorithm').seq().obj(this.key('id').objid(), this.key('decrypt').seq().obj(this.key('kde').seq().obj(this.key('id').objid(), this.key('kdeparams').seq().obj(this.key('salt').octstr(), this.key('iters')['int']())), this.key('cipher').seq().obj(this.key('algo').objid(), this.key('iv').octstr()))), this.key('subjectPrivateKey').octstr());
});
$0624f2c18c9a45a3$export$23cd2842b44ca3e7 = $0624f2c18c9a45a3$var$EncryptedPrivateKeyInfo;
var $0624f2c18c9a45a3$var$DSAPrivateKey = $1yzSj.define('DSAPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('p')['int'](), this.key('q')['int'](), this.key('g')['int'](), this.key('pub_key')['int'](), this.key('priv_key')['int']());
});
$0624f2c18c9a45a3$export$245c9aaa9f5ce4ce = $0624f2c18c9a45a3$var$DSAPrivateKey;
$0624f2c18c9a45a3$export$8ad762e3e6399afe = $1yzSj.define('DSAparam', function() {
    this['int']();
});
var $0624f2c18c9a45a3$var$ECParameters = $1yzSj.define('ECParameters', function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $0624f2c18c9a45a3$var$ECPrivateKey = $1yzSj.define('ECPrivateKey', function() {
    this.seq().obj(this.key('version')['int'](), this.key('privateKey').octstr(), this.key('parameters').optional().explicit(0).use($0624f2c18c9a45a3$var$ECParameters), this.key('publicKey').optional().explicit(1).bitstr());
});
$0624f2c18c9a45a3$export$32ef6f92e22c6ab0 = $0624f2c18c9a45a3$var$ECPrivateKey;
$0624f2c18c9a45a3$export$c9cd164b539ebb63 = $1yzSj.define('signature', function() {
    this.seq().obj(this.key('r')['int'](), this.key('s')['int']());
});

});
parcelRegister("1yzSj", function(module, exports) {
var $1224cb74fe39c047$var$asn1 = module.exports;

$1224cb74fe39c047$var$asn1.bignum = (parcelRequire("edamG"));

$1224cb74fe39c047$var$asn1.define = (parcelRequire("kdPOP")).define;

$1224cb74fe39c047$var$asn1.base = (parcelRequire("2KdUl"));

$1224cb74fe39c047$var$asn1.constants = (parcelRequire("iqatA"));

$1224cb74fe39c047$var$asn1.decoders = (parcelRequire("8aM9p"));

$1224cb74fe39c047$var$asn1.encoders = (parcelRequire("jItRs"));

});
parcelRegister("edamG", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("kdPOP", function(module, exports) {

var $1yzSj = parcelRequire("1yzSj");

var $gdc6A = parcelRequire("gdc6A");
var $eb8d37b17ccf600d$var$api = module.exports;
$eb8d37b17ccf600d$var$api.define = function define(name, body) {
    return new $eb8d37b17ccf600d$var$Entity(name, body);
};
function $eb8d37b17ccf600d$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$eb8d37b17ccf600d$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("1BoK8")).runInThisContext('(function ' + this.name + '(entity) {\n' + '  this._initNamed(entity);\n' + '})');
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $gdc6A(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$eb8d37b17ccf600d$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || 'der';
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($1yzSj.decoders[enc]);
    return this.decoders[enc];
};
$eb8d37b17ccf600d$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$eb8d37b17ccf600d$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || 'der';
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($1yzSj.encoders[enc]);
    return this.encoders[enc];
};
$eb8d37b17ccf600d$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("1BoK8", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, '_', {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    'Array',
    'Boolean',
    'Date',
    'Error',
    'EvalError',
    'Function',
    'Infinity',
    'JSON',
    'Math',
    'NaN',
    'Number',
    'Object',
    'RangeError',
    'ReferenceError',
    'RegExp',
    'String',
    'SyntaxError',
    'TypeError',
    'URIError',
    'decodeURI',
    'decodeURIComponent',
    'encodeURI',
    'encodeURIComponent',
    'escape',
    'eval',
    'isFinite',
    'isNaN',
    'parseFloat',
    'parseInt',
    'undefined',
    'unescape'
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement('iframe');
    if (!iframe.style) iframe.style = {};
    iframe.style.display = 'none';
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, 'null');
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === 'object') forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("2KdUl", function(module, exports) {
var $1ffaaa6c5840c386$var$base = module.exports;

$1ffaaa6c5840c386$var$base.Reporter = (parcelRequire("xgQeC")).Reporter;

$1ffaaa6c5840c386$var$base.DecoderBuffer = (parcelRequire("jEybD")).DecoderBuffer;

$1ffaaa6c5840c386$var$base.EncoderBuffer = (parcelRequire("jEybD")).EncoderBuffer;

$1ffaaa6c5840c386$var$base.Node = (parcelRequire("eAg8g"));

});
parcelRegister("xgQeC", function(module, exports) {

$parcel$export(module.exports, "Reporter", function () { return $0640258d5aa312ec$export$957313a2f485e5ed; }, function (v) { return $0640258d5aa312ec$export$957313a2f485e5ed = v; });
var $0640258d5aa312ec$export$957313a2f485e5ed;

var $gdc6A = parcelRequire("gdc6A");
function $0640258d5aa312ec$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$0640258d5aa312ec$export$957313a2f485e5ed = $0640258d5aa312ec$var$Reporter;
$0640258d5aa312ec$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $0640258d5aa312ec$var$ReporterError;
};
$0640258d5aa312ec$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$0640258d5aa312ec$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$0640258d5aa312ec$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$0640258d5aa312ec$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$0640258d5aa312ec$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$0640258d5aa312ec$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join('/');
};
$0640258d5aa312ec$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$0640258d5aa312ec$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$0640258d5aa312ec$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $0640258d5aa312ec$var$ReporterError;
    if (inherited) err = msg;
    else err = new $0640258d5aa312ec$var$ReporterError(state.path.map(function(elem) {
        return '[' + JSON.stringify(elem) + ']';
    }).join(''), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$0640258d5aa312ec$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $0640258d5aa312ec$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$gdc6A($0640258d5aa312ec$var$ReporterError, Error);
$0640258d5aa312ec$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + ' at: ' + (this.path || '(shallow)');
    if (Error.captureStackTrace) Error.captureStackTrace(this, $0640258d5aa312ec$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("jEybD", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", function () { return $e4ec4580017d9e14$export$bf9f79cdc4a49163; }, function (v) { return $e4ec4580017d9e14$export$bf9f79cdc4a49163 = v; });
$parcel$export(module.exports, "EncoderBuffer", function () { return $e4ec4580017d9e14$export$8ff24f7760c7a78e; }, function (v) { return $e4ec4580017d9e14$export$8ff24f7760c7a78e = v; });
var $e4ec4580017d9e14$export$bf9f79cdc4a49163;
var $e4ec4580017d9e14$export$8ff24f7760c7a78e;

var $gdc6A = parcelRequire("gdc6A");

var $2KdUl = parcelRequire("2KdUl");
var $e4ec4580017d9e14$require$Reporter = $2KdUl.Reporter;

var $kJBqN = parcelRequire("kJBqN");
var $e4ec4580017d9e14$require$Buffer = $kJBqN.Buffer;
function $e4ec4580017d9e14$var$DecoderBuffer(base, options) {
    $e4ec4580017d9e14$require$Reporter.call(this, options);
    if (!$e4ec4580017d9e14$require$Buffer.isBuffer(base)) {
        this.error('Input not Buffer');
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$gdc6A($e4ec4580017d9e14$var$DecoderBuffer, $e4ec4580017d9e14$require$Reporter);
$e4ec4580017d9e14$export$bf9f79cdc4a49163 = $e4ec4580017d9e14$var$DecoderBuffer;
$e4ec4580017d9e14$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $e4ec4580017d9e14$require$Reporter.prototype.save.call(this)
    };
};
$e4ec4580017d9e14$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $e4ec4580017d9e14$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $e4ec4580017d9e14$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$e4ec4580017d9e14$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$e4ec4580017d9e14$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || 'DecoderBuffer overrun');
};
$e4ec4580017d9e14$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || 'DecoderBuffer overrun');
    var res = new $e4ec4580017d9e14$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$e4ec4580017d9e14$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $e4ec4580017d9e14$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $e4ec4580017d9e14$var$EncoderBuffer)) item = new $e4ec4580017d9e14$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === 'number') {
        if (!(0 <= value && value <= 0xff)) return reporter.error('non-byte EncoderBuffer value');
        this.value = value;
        this.length = 1;
    } else if (typeof value === 'string') {
        this.value = value;
        this.length = $e4ec4580017d9e14$require$Buffer.byteLength(value);
    } else if ($e4ec4580017d9e14$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error('Unsupported type: ' + typeof value);
}
$e4ec4580017d9e14$export$8ff24f7760c7a78e = $e4ec4580017d9e14$var$EncoderBuffer;
$e4ec4580017d9e14$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $e4ec4580017d9e14$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === 'number') out[offset] = this.value;
        else if (typeof this.value === 'string') out.write(this.value, offset);
        else if ($e4ec4580017d9e14$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("eAg8g", function(module, exports) {

var $2KdUl = parcelRequire("2KdUl");
var $a9e0f10a356caab6$require$Reporter = $2KdUl.Reporter;

var $2KdUl = parcelRequire("2KdUl");
var $a9e0f10a356caab6$require$EncoderBuffer = $2KdUl.EncoderBuffer;

var $2KdUl = parcelRequire("2KdUl");
var $a9e0f10a356caab6$require$DecoderBuffer = $2KdUl.DecoderBuffer;

var $jYzim = parcelRequire("jYzim");
// Supported tags
var $a9e0f10a356caab6$var$tags = [
    'seq',
    'seqof',
    'set',
    'setof',
    'objid',
    'bool',
    'gentime',
    'utctime',
    'null_',
    'enum',
    'int',
    'objDesc',
    'bitstr',
    'bmpstr',
    'charstr',
    'genstr',
    'graphstr',
    'ia5str',
    'iso646str',
    'numstr',
    'octstr',
    'printstr',
    't61str',
    'unistr',
    'utf8str',
    'videostr'
];
// Public methods list
var $a9e0f10a356caab6$var$methods = [
    'key',
    'obj',
    'use',
    'optional',
    'explicit',
    'implicit',
    'def',
    'choice',
    'any',
    'contains'
].concat($a9e0f10a356caab6$var$tags);
// Overrided methods list
var $a9e0f10a356caab6$var$overrided = [
    '_peekTag',
    '_decodeTag',
    '_use',
    '_decodeStr',
    '_decodeObjid',
    '_decodeTime',
    '_decodeNull',
    '_decodeInt',
    '_decodeBool',
    '_decodeList',
    '_encodeComposite',
    '_encodeStr',
    '_encodeObjid',
    '_encodeTime',
    '_encodeNull',
    '_encodeInt',
    '_encodeBool'
];
function $a9e0f10a356caab6$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state['default'] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $a9e0f10a356caab6$var$Node;
var $a9e0f10a356caab6$var$stateProps = [
    'enc',
    'parent',
    'children',
    'tag',
    'args',
    'reverseArgs',
    'choice',
    'optional',
    'any',
    'obj',
    'use',
    'alteredUse',
    'key',
    'default',
    'explicit',
    'implicit',
    'contains'
];
$a9e0f10a356caab6$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $a9e0f10a356caab6$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$a9e0f10a356caab6$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $a9e0f10a356caab6$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$a9e0f10a356caab6$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $jYzim(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $jYzim.equal(state.children.length, 1, 'Root node can have only one child');
};
$a9e0f10a356caab6$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $jYzim(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $jYzim(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== 'object' || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$a9e0f10a356caab6$var$overrided.forEach(function(method) {
    $a9e0f10a356caab6$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + ' not implemented for encoding: ' + state.enc);
    };
});
//
// Public methods
//
$a9e0f10a356caab6$var$tags.forEach(function(tag) {
    $a9e0f10a356caab6$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $jYzim(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$a9e0f10a356caab6$var$Node.prototype.use = function use(item) {
    $jYzim(item);
    var state = this._baseState;
    $jYzim(state.use === null);
    state.use = item;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $jYzim(state['default'] === null);
    state['default'] = val;
    state.optional = true;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $jYzim(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $jYzim(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $jYzim(state.key === null);
    state.key = newKey;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $jYzim(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$a9e0f10a356caab6$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $jYzim(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$a9e0f10a356caab6$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state['default'];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, 'tagged');
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, 'content');
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === 'octstr' || state.tag === 'bitstr')) {
            var data = new $a9e0f10a356caab6$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$a9e0f10a356caab6$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === 'seq' || tag === 'set') return null;
    if (tag === 'seqof' || tag === 'setof') return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === 'objid' && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === 'objid') return this._decodeObjid(input, null, null, options);
    else if (tag === 'gentime' || tag === 'utctime') return this._decodeTime(input, tag, options);
    else if (tag === 'null_') return this._decodeNull(input, options);
    else if (tag === 'bool') return this._decodeBool(input, options);
    else if (tag === 'objDesc') return this._decodeStr(input, tag, options);
    else if (tag === 'int' || tag === 'enum') return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error('unknown tag: ' + tag);
};
$a9e0f10a356caab6$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $jYzim(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$a9e0f10a356caab6$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error('Choice not matched');
    return result;
};
//
// Encoding
//
$a9e0f10a356caab6$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $a9e0f10a356caab6$require$EncoderBuffer(data, this.reporter);
};
$a9e0f10a356caab6$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state['default'] !== null && state['default'] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$a9e0f10a356caab6$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $a9e0f10a356caab6$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state['default'] !== null) data = state['default'];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === 'null_') return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error('Child should have a key');
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== 'object') return reporter.error('Child expected, but input is not object');
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === 'seqof' || state.tag === 'setof') {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error('Too many args for : ' + state.tag);
            if (!Array.isArray(data)) return reporter.error('seqof/setof, but data is not Array');
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? 'universal' : 'context';
        if (tag === null) {
            if (state.use === null) reporter.error('Tag could be omitted only for .use()');
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, 'context', result);
    return result;
};
$a9e0f10a356caab6$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $jYzim(false, data.type + ' not found in ' + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$a9e0f10a356caab6$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === 'objid' && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === 'objid') return this._encodeObjid(data, null, null);
    else if (tag === 'gentime' || tag === 'utctime') return this._encodeTime(data, tag);
    else if (tag === 'null_') return this._encodeNull();
    else if (tag === 'int' || tag === 'enum') return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === 'bool') return this._encodeBool(data);
    else if (tag === 'objDesc') return this._encodeStr(data, tag);
    else throw new Error('Unsupported tag: ' + tag);
};
$a9e0f10a356caab6$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$a9e0f10a356caab6$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("iqatA", function(module, exports) {
var $d692c80d7ae22b79$var$constants = module.exports;
// Helper
$d692c80d7ae22b79$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$d692c80d7ae22b79$var$constants.der = (parcelRequire("bwd9t"));

});
parcelRegister("bwd9t", function(module, exports) {

$parcel$export(module.exports, "tagClass", function () { return $862ce2844c5bffd4$export$3584c46ed60baee8; }, function (v) { return $862ce2844c5bffd4$export$3584c46ed60baee8 = v; });
$parcel$export(module.exports, "tagClassByName", function () { return $862ce2844c5bffd4$export$f18596ef8d632e49; }, function (v) { return $862ce2844c5bffd4$export$f18596ef8d632e49 = v; });
$parcel$export(module.exports, "tag", function () { return $862ce2844c5bffd4$export$2b067c6666111485; }, function (v) { return $862ce2844c5bffd4$export$2b067c6666111485 = v; });
$parcel$export(module.exports, "tagByName", function () { return $862ce2844c5bffd4$export$f17df38a421ab9e3; }, function (v) { return $862ce2844c5bffd4$export$f17df38a421ab9e3 = v; });
var $862ce2844c5bffd4$export$3584c46ed60baee8;
var $862ce2844c5bffd4$export$f18596ef8d632e49;
var $862ce2844c5bffd4$export$2b067c6666111485;
var $862ce2844c5bffd4$export$f17df38a421ab9e3;

var $iqatA = parcelRequire("iqatA");
$862ce2844c5bffd4$export$3584c46ed60baee8 = {
    0: 'universal',
    1: 'application',
    2: 'context',
    3: 'private'
};
$862ce2844c5bffd4$export$f18596ef8d632e49 = $iqatA._reverse($862ce2844c5bffd4$export$3584c46ed60baee8);
$862ce2844c5bffd4$export$2b067c6666111485 = {
    0x00: 'end',
    0x01: 'bool',
    0x02: 'int',
    0x03: 'bitstr',
    0x04: 'octstr',
    0x05: 'null_',
    0x06: 'objid',
    0x07: 'objDesc',
    0x08: 'external',
    0x09: 'real',
    0x0a: 'enum',
    0x0b: 'embed',
    0x0c: 'utf8str',
    0x0d: 'relativeOid',
    0x10: 'seq',
    0x11: 'set',
    0x12: 'numstr',
    0x13: 'printstr',
    0x14: 't61str',
    0x15: 'videostr',
    0x16: 'ia5str',
    0x17: 'utctime',
    0x18: 'gentime',
    0x19: 'graphstr',
    0x1a: 'iso646str',
    0x1b: 'genstr',
    0x1c: 'unistr',
    0x1d: 'charstr',
    0x1e: 'bmpstr'
};
$862ce2844c5bffd4$export$f17df38a421ab9e3 = $iqatA._reverse($862ce2844c5bffd4$export$2b067c6666111485);

});


parcelRegister("8aM9p", function(module, exports) {
var $5f349ba2ce9182a7$var$decoders = module.exports;

$5f349ba2ce9182a7$var$decoders.der = (parcelRequire("2rSed"));

$5f349ba2ce9182a7$var$decoders.pem = (parcelRequire("3CAJd"));

});
parcelRegister("2rSed", function(module, exports) {

var $gdc6A = parcelRequire("gdc6A");

var $1yzSj = parcelRequire("1yzSj");
var $1c882afbe54c69ae$var$base = $1yzSj.base;
var $1c882afbe54c69ae$var$bignum = $1yzSj.bignum;
// Import DER constants
var $1c882afbe54c69ae$var$der = $1yzSj.constants.der;
function $1c882afbe54c69ae$var$DERDecoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1c882afbe54c69ae$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1c882afbe54c69ae$var$DERDecoder;
$1c882afbe54c69ae$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $1c882afbe54c69ae$var$base.DecoderBuffer)) data = new $1c882afbe54c69ae$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $1c882afbe54c69ae$var$DERNode(parent) {
    $1c882afbe54c69ae$var$base.Node.call(this, 'der', parent);
}
$gdc6A($1c882afbe54c69ae$var$DERNode, $1c882afbe54c69ae$var$base.Node);
$1c882afbe54c69ae$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $1c882afbe54c69ae$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + 'of' === tag || any;
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $1c882afbe54c69ae$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $1c882afbe54c69ae$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + 'of' !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$1c882afbe54c69ae$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $1c882afbe54c69ae$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $1c882afbe54c69ae$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === 'end') break;
    }
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, 'end');
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, 'der', options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === 'bitstr') {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === 'bmpstr') {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error('Decoding of string type: bmpstr length mismatch');
        var str = '';
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === 'numstr') {
        var numstr = buffer.raw().toString('ascii');
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === 'octstr') return buffer.raw();
    else if (tag === 'objDesc') return buffer.raw();
    else if (tag === 'printstr') {
        var printstr = buffer.raw().toString('ascii');
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error('Decoding of string type: ' + tag + ' unsupported');
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(' ')];
        if (tmp === undefined) tmp = values[result.join('.')];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === 'gentime') {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === 'utctime') {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error('Decoding ' + tag + ' time is not supported yet');
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$1c882afbe54c69ae$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $1c882afbe54c69ae$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$1c882afbe54c69ae$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getDecoder('der').tree;
};
// Utility methods
function $1c882afbe54c69ae$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $1c882afbe54c69ae$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $1c882afbe54c69ae$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $1c882afbe54c69ae$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error('length octect is too long');
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("3CAJd", function(module, exports) {

var $gdc6A = parcelRequire("gdc6A");

var $kJBqN = parcelRequire("kJBqN");
var $2a316930825ea0db$require$Buffer = $kJBqN.Buffer;

var $2rSed = parcelRequire("2rSed");
function $2a316930825ea0db$var$PEMDecoder(entity) {
    $2rSed.call(this, entity);
    this.enc = 'pem';
}
$gdc6A($2a316930825ea0db$var$PEMDecoder, $2rSed);
module.exports = $2a316930825ea0db$var$PEMDecoder;
$2a316930825ea0db$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== 'BEGIN') break;
            start = i;
        } else {
            if (match[1] !== 'END') break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error('PEM section not found for: ' + label);
    var base64 = lines.slice(start + 1, end).join('');
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, '');
    var input = new $2a316930825ea0db$require$Buffer(base64, 'base64');
    return $2rSed.prototype.decode.call(this, input, options);
};

});


parcelRegister("jItRs", function(module, exports) {
var $e5a94a3177b5208d$var$encoders = module.exports;

$e5a94a3177b5208d$var$encoders.der = (parcelRequire("g0nPj"));

$e5a94a3177b5208d$var$encoders.pem = (parcelRequire("61MfG"));

});
parcelRegister("g0nPj", function(module, exports) {

var $gdc6A = parcelRequire("gdc6A");

var $kJBqN = parcelRequire("kJBqN");
var $ba6f20e7c6958988$require$Buffer = $kJBqN.Buffer;

var $1yzSj = parcelRequire("1yzSj");
var $ba6f20e7c6958988$var$base = $1yzSj.base;
// Import DER constants
var $ba6f20e7c6958988$var$der = $1yzSj.constants.der;
function $ba6f20e7c6958988$var$DEREncoder(entity) {
    this.enc = 'der';
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $ba6f20e7c6958988$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $ba6f20e7c6958988$var$DEREncoder;
$ba6f20e7c6958988$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $ba6f20e7c6958988$var$DERNode(parent) {
    $ba6f20e7c6958988$var$base.Node.call(this, 'der', parent);
}
$gdc6A($ba6f20e7c6958988$var$DERNode, $ba6f20e7c6958988$var$base.Node);
$ba6f20e7c6958988$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $ba6f20e7c6958988$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $ba6f20e7c6958988$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $ba6f20e7c6958988$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$ba6f20e7c6958988$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === 'bitstr') return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === 'bmpstr') {
        var buf = new $ba6f20e7c6958988$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === 'numstr') {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === 'printstr') {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === 'objDesc') return this._createEncoderBuffer(str);
    else return this.reporter.error('Encoding of string type: ' + tag + ' unsupported');
};
$ba6f20e7c6958988$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === 'string') {
        if (!values) return this.reporter.error('string objid given, but no values map found');
        if (!values.hasOwnProperty(id)) return this.reporter.error('objid not found in values map');
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error('Second objid identifier OOB');
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $ba6f20e7c6958988$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $ba6f20e7c6958988$var$two(num) {
    if (num < 10) return '0' + num;
    else return num;
}
$ba6f20e7c6958988$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === 'gentime') str = [
        $ba6f20e7c6958988$var$two(date.getFullYear()),
        $ba6f20e7c6958988$var$two(date.getUTCMonth() + 1),
        $ba6f20e7c6958988$var$two(date.getUTCDate()),
        $ba6f20e7c6958988$var$two(date.getUTCHours()),
        $ba6f20e7c6958988$var$two(date.getUTCMinutes()),
        $ba6f20e7c6958988$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else if (tag === 'utctime') str = [
        $ba6f20e7c6958988$var$two(date.getFullYear() % 100),
        $ba6f20e7c6958988$var$two(date.getUTCMonth() + 1),
        $ba6f20e7c6958988$var$two(date.getUTCDate()),
        $ba6f20e7c6958988$var$two(date.getUTCHours()),
        $ba6f20e7c6958988$var$two(date.getUTCMinutes()),
        $ba6f20e7c6958988$var$two(date.getUTCSeconds()),
        'Z'
    ].join('');
    else this.reporter.error('Encoding ' + tag + ' time is not supported yet');
    return this._encodeStr(str, 'octstr');
};
$ba6f20e7c6958988$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer('');
};
$ba6f20e7c6958988$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === 'string') {
        if (!values) return this.reporter.error('String int or enum given, but no values map');
        if (!values.hasOwnProperty(num)) return this.reporter.error('Values map doesn\'t contain: ' + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== 'number' && !$ba6f20e7c6958988$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $ba6f20e7c6958988$require$Buffer(numArray);
    }
    if ($ba6f20e7c6958988$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $ba6f20e7c6958988$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $ba6f20e7c6958988$require$Buffer(out));
};
$ba6f20e7c6958988$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$ba6f20e7c6958988$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === 'function') entity = entity(obj);
    return entity._getEncoder('der').tree;
};
$ba6f20e7c6958988$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state['default'] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state['default'], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $ba6f20e7c6958988$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === 'seqof') tag = 'seq';
    else if (tag === 'setof') tag = 'set';
    if ($ba6f20e7c6958988$var$der.tagByName.hasOwnProperty(tag)) res = $ba6f20e7c6958988$var$der.tagByName[tag];
    else if (typeof tag === 'number' && (tag | 0) === tag) res = tag;
    else return reporter.error('Unknown tag: ' + tag);
    if (res >= 0x1f) return reporter.error('Multi-octet tag encoding unsupported');
    if (!primitive) res |= 0x20;
    res |= $ba6f20e7c6958988$var$der.tagClassByName[cls || 'universal'] << 6;
    return res;
}

});

parcelRegister("61MfG", function(module, exports) {

var $gdc6A = parcelRequire("gdc6A");

var $g0nPj = parcelRequire("g0nPj");
function $463843e6ed14ee17$var$PEMEncoder(entity) {
    $g0nPj.call(this, entity);
    this.enc = 'pem';
}
$gdc6A($463843e6ed14ee17$var$PEMEncoder, $g0nPj);
module.exports = $463843e6ed14ee17$var$PEMEncoder;
$463843e6ed14ee17$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $g0nPj.prototype.encode.call(this, data);
    var p = buf.toString('base64');
    var out = [
        '-----BEGIN ' + options.label + '-----'
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push('-----END ' + options.label + '-----');
    return out.join('\n');
};

});



parcelRegister("4cT3F", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
'use strict';

var $1yzSj = parcelRequire("1yzSj");
var $3102fdca1e3b006e$var$Time = $1yzSj.define('Time', function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $3102fdca1e3b006e$var$AttributeTypeValue = $1yzSj.define('AttributeTypeValue', function() {
    this.seq().obj(this.key('type').objid(), this.key('value').any());
});
var $3102fdca1e3b006e$var$AlgorithmIdentifier = $1yzSj.define('AlgorithmIdentifier', function() {
    this.seq().obj(this.key('algorithm').objid(), this.key('parameters').optional(), this.key('curve').objid().optional());
});
var $3102fdca1e3b006e$var$SubjectPublicKeyInfo = $1yzSj.define('SubjectPublicKeyInfo', function() {
    this.seq().obj(this.key('algorithm').use($3102fdca1e3b006e$var$AlgorithmIdentifier), this.key('subjectPublicKey').bitstr());
});
var $3102fdca1e3b006e$var$RelativeDistinguishedName = $1yzSj.define('RelativeDistinguishedName', function() {
    this.setof($3102fdca1e3b006e$var$AttributeTypeValue);
});
var $3102fdca1e3b006e$var$RDNSequence = $1yzSj.define('RDNSequence', function() {
    this.seqof($3102fdca1e3b006e$var$RelativeDistinguishedName);
});
var $3102fdca1e3b006e$var$Name = $1yzSj.define('Name', function() {
    this.choice({
        rdnSequence: this.use($3102fdca1e3b006e$var$RDNSequence)
    });
});
var $3102fdca1e3b006e$var$Validity = $1yzSj.define('Validity', function() {
    this.seq().obj(this.key('notBefore').use($3102fdca1e3b006e$var$Time), this.key('notAfter').use($3102fdca1e3b006e$var$Time));
});
var $3102fdca1e3b006e$var$Extension = $1yzSj.define('Extension', function() {
    this.seq().obj(this.key('extnID').objid(), this.key('critical').bool().def(false), this.key('extnValue').octstr());
});
var $3102fdca1e3b006e$var$TBSCertificate = $1yzSj.define('TBSCertificate', function() {
    this.seq().obj(this.key('version').explicit(0)['int']().optional(), this.key('serialNumber')['int'](), this.key('signature').use($3102fdca1e3b006e$var$AlgorithmIdentifier), this.key('issuer').use($3102fdca1e3b006e$var$Name), this.key('validity').use($3102fdca1e3b006e$var$Validity), this.key('subject').use($3102fdca1e3b006e$var$Name), this.key('subjectPublicKeyInfo').use($3102fdca1e3b006e$var$SubjectPublicKeyInfo), this.key('issuerUniqueID').implicit(1).bitstr().optional(), this.key('subjectUniqueID').implicit(2).bitstr().optional(), this.key('extensions').explicit(3).seqof($3102fdca1e3b006e$var$Extension).optional());
});
var $3102fdca1e3b006e$var$X509Certificate = $1yzSj.define('X509Certificate', function() {
    this.seq().obj(this.key('tbsCertificate').use($3102fdca1e3b006e$var$TBSCertificate), this.key('signatureAlgorithm').use($3102fdca1e3b006e$var$AlgorithmIdentifier), this.key('signatureValue').bitstr());
});
module.exports = $3102fdca1e3b006e$var$X509Certificate;

});


parcelRegister("5uAfa", function(module, exports) {
module.exports = JSON.parse("{\"2.16.840.1.101.3.4.1.1\":\"aes-128-ecb\",\"2.16.840.1.101.3.4.1.2\":\"aes-128-cbc\",\"2.16.840.1.101.3.4.1.3\":\"aes-128-ofb\",\"2.16.840.1.101.3.4.1.4\":\"aes-128-cfb\",\"2.16.840.1.101.3.4.1.21\":\"aes-192-ecb\",\"2.16.840.1.101.3.4.1.22\":\"aes-192-cbc\",\"2.16.840.1.101.3.4.1.23\":\"aes-192-ofb\",\"2.16.840.1.101.3.4.1.24\":\"aes-192-cfb\",\"2.16.840.1.101.3.4.1.41\":\"aes-256-ecb\",\"2.16.840.1.101.3.4.1.42\":\"aes-256-cbc\",\"2.16.840.1.101.3.4.1.43\":\"aes-256-ofb\",\"2.16.840.1.101.3.4.1.44\":\"aes-256-cfb\"}");

});

parcelRegister("co1YS", function(module, exports) {
'use strict';
// adapted from https://github.com/apatil/pemstrip
var $9049434d80a64a59$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $9049434d80a64a59$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $9049434d80a64a59$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $CSL7y = parcelRequire("CSL7y");

var $fAIFp = parcelRequire("fAIFp");

var $6arys = parcelRequire("6arys");
var $9049434d80a64a59$require$Buffer = $6arys.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($9049434d80a64a59$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($9049434d80a64a59$var$fullRegex);
        decrypted = $9049434d80a64a59$require$Buffer.from(match2[2].replace(/[\r\n]/g, ''), 'base64');
    } else {
        var suite = 'aes' + match[1];
        var iv = $9049434d80a64a59$require$Buffer.from(match[2], 'hex');
        var cipherText = $9049434d80a64a59$require$Buffer.from(match[3].replace(/[\r\n]/g, ''), 'base64');
        var cipherKey = $CSL7y(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $fAIFp.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher['final']());
        decrypted = $9049434d80a64a59$require$Buffer.concat(out);
    }
    var tag = key.match($9049434d80a64a59$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});


parcelRegister("lhhvi", function(module, exports) {
module.exports = JSON.parse("{\"1.3.132.0.10\":\"secp256k1\",\"1.3.132.0.33\":\"p224\",\"1.2.840.10045.3.1.1\":\"p192\",\"1.2.840.10045.3.1.7\":\"p256\",\"1.3.132.0.34\":\"p384\",\"1.3.132.0.35\":\"p521\"}");

});


parcelRegister("gsk8z", function(module, exports) {
'use strict';

var $6arys = parcelRequire("6arys");
var $bfaee1b2b67736e7$require$Buffer = $6arys.Buffer;

var $1dK1s = parcelRequire("1dK1s");

var $7xbBA = parcelRequire("7xbBA");
var $bfaee1b2b67736e7$require$EC = $7xbBA.ec;

var $azRsG = parcelRequire("azRsG");

var $lhhvi = parcelRequire("lhhvi");
function $bfaee1b2b67736e7$var$verify(sig, hash, key, signType, tag) {
    var pub = $azRsG(key);
    if (pub.type === 'ec') {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== 'ecdsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
        return $bfaee1b2b67736e7$var$ecVerify(sig, hash, pub);
    } else if (pub.type === 'dsa') {
        if (signType !== 'dsa') throw new Error('wrong public key type');
        return $bfaee1b2b67736e7$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== 'rsa' && signType !== 'ecdsa/rsa') throw new Error('wrong public key type');
    hash = $bfaee1b2b67736e7$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $bfaee1b2b67736e7$require$Buffer.from(pad);
    var red = $1dK1s.mont(pub.modulus);
    sig = new $1dK1s(sig).toRed(red);
    sig = sig.redPow(new $1dK1s(pub.publicExponent));
    sig = $bfaee1b2b67736e7$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $bfaee1b2b67736e7$var$ecVerify(sig, hash, pub) {
    var curveId = $lhhvi[pub.data.algorithm.curve.join('.')];
    if (!curveId) throw new Error('unknown curve ' + pub.data.algorithm.curve.join('.'));
    var curve = new $bfaee1b2b67736e7$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $bfaee1b2b67736e7$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $azRsG.signature.decode(sig, 'der');
    var s = unpacked.s;
    var r = unpacked.r;
    $bfaee1b2b67736e7$var$checkValue(s, q);
    $bfaee1b2b67736e7$var$checkValue(r, q);
    var montp = $1dK1s.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $1dK1s(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $bfaee1b2b67736e7$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error('invalid sig');
    if (b.cmp(q) >= 0) throw new Error('invalid sig');
}
module.exports = $bfaee1b2b67736e7$var$verify;

});


parcelRegister("gZ3PT", function(module, exports) {

var $kJBqN = parcelRequire("kJBqN");
var $c5d5519ae179cb0f$require$Buffer = $kJBqN.Buffer;

var $7xbBA = parcelRequire("7xbBA");

var $iI9zS = parcelRequire("iI9zS");
module.exports = function createECDH(curve) {
    return new $c5d5519ae179cb0f$var$ECDH(curve);
};
var $c5d5519ae179cb0f$var$aliases = {
    secp256k1: {
        name: 'secp256k1',
        byteLength: 32
    },
    secp224r1: {
        name: 'p224',
        byteLength: 28
    },
    prime256v1: {
        name: 'p256',
        byteLength: 32
    },
    prime192v1: {
        name: 'p192',
        byteLength: 24
    },
    ed25519: {
        name: 'ed25519',
        byteLength: 32
    },
    secp384r1: {
        name: 'p384',
        byteLength: 48
    },
    secp521r1: {
        name: 'p521',
        byteLength: 66
    }
};
$c5d5519ae179cb0f$var$aliases.p224 = $c5d5519ae179cb0f$var$aliases.secp224r1;
$c5d5519ae179cb0f$var$aliases.p256 = $c5d5519ae179cb0f$var$aliases.secp256r1 = $c5d5519ae179cb0f$var$aliases.prime256v1;
$c5d5519ae179cb0f$var$aliases.p192 = $c5d5519ae179cb0f$var$aliases.secp192r1 = $c5d5519ae179cb0f$var$aliases.prime192v1;
$c5d5519ae179cb0f$var$aliases.p384 = $c5d5519ae179cb0f$var$aliases.secp384r1;
$c5d5519ae179cb0f$var$aliases.p521 = $c5d5519ae179cb0f$var$aliases.secp521r1;
function $c5d5519ae179cb0f$var$ECDH(curve) {
    this.curveType = $c5d5519ae179cb0f$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $7xbBA.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$c5d5519ae179cb0f$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$c5d5519ae179cb0f$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || 'utf8';
    if (!$c5d5519ae179cb0f$require$Buffer.isBuffer(other)) other = new $c5d5519ae179cb0f$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $c5d5519ae179cb0f$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$c5d5519ae179cb0f$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === 'compressed', true);
    if (format === 'hybrid') {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $c5d5519ae179cb0f$var$formatReturnValue(key, enc);
};
$c5d5519ae179cb0f$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $c5d5519ae179cb0f$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$c5d5519ae179cb0f$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || 'utf8';
    if (!$c5d5519ae179cb0f$require$Buffer.isBuffer(pub)) pub = new $c5d5519ae179cb0f$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$c5d5519ae179cb0f$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || 'utf8';
    if (!$c5d5519ae179cb0f$require$Buffer.isBuffer(priv)) priv = new $c5d5519ae179cb0f$require$Buffer(priv, enc);
    var _priv = new $iI9zS(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $c5d5519ae179cb0f$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $c5d5519ae179cb0f$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $c5d5519ae179cb0f$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $c5d5519ae179cb0f$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("iI9zS", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("befyV", function(module, exports) {

$parcel$export(module.exports, "publicEncrypt", function () { return $82cd12d91d0c7555$export$512823e338ddb1b7; }, function (v) { return $82cd12d91d0c7555$export$512823e338ddb1b7 = v; });
$parcel$export(module.exports, "privateDecrypt", function () { return $82cd12d91d0c7555$export$7efb24e2fddf99b9; }, function (v) { return $82cd12d91d0c7555$export$7efb24e2fddf99b9 = v; });
$parcel$export(module.exports, "privateEncrypt", function () { return $82cd12d91d0c7555$export$9d0e0c0c4a8d30f3; }, function (v) { return $82cd12d91d0c7555$export$9d0e0c0c4a8d30f3 = v; });
$parcel$export(module.exports, "publicDecrypt", function () { return $82cd12d91d0c7555$export$b9d55ff329113abd; }, function (v) { return $82cd12d91d0c7555$export$b9d55ff329113abd = v; });
var $82cd12d91d0c7555$export$512823e338ddb1b7;
var $82cd12d91d0c7555$export$7efb24e2fddf99b9;
var $82cd12d91d0c7555$export$9d0e0c0c4a8d30f3;
var $82cd12d91d0c7555$export$b9d55ff329113abd;

$82cd12d91d0c7555$export$512823e338ddb1b7 = (parcelRequire("96u1j"));

$82cd12d91d0c7555$export$7efb24e2fddf99b9 = (parcelRequire("bAyyp"));
$82cd12d91d0c7555$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $82cd12d91d0c7555$export$512823e338ddb1b7(key, buf, true);
};
$82cd12d91d0c7555$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $82cd12d91d0c7555$export$7efb24e2fddf99b9(key, buf, true);
};

});
parcelRegister("96u1j", function(module, exports) {

var $azRsG = parcelRequire("azRsG");

var $l0MtO = parcelRequire("l0MtO");

var $7y50W = parcelRequire("7y50W");

var $iP8y9 = parcelRequire("iP8y9");

var $g6TCQ = parcelRequire("g6TCQ");

var $kDdu6 = parcelRequire("kDdu6");

var $gYUtc = parcelRequire("gYUtc");

var $6TJhl = parcelRequire("6TJhl");

var $6arys = parcelRequire("6arys");
var $6a0bf5f4f045decc$require$Buffer = $6arys.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $azRsG(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a0bf5f4f045decc$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a0bf5f4f045decc$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $kDdu6(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error('data too long for modulus');
    } else throw new Error('unknown padding');
    if (reverse) return $6TJhl(paddedMsg, key);
    else return $gYUtc(paddedMsg, key);
};
function $6a0bf5f4f045decc$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $7y50W('sha1').update($6a0bf5f4f045decc$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error('message too long');
    var ps = $6a0bf5f4f045decc$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $l0MtO(hLen);
    var maskedDb = $g6TCQ($6a0bf5f4f045decc$require$Buffer.concat([
        iHash,
        ps,
        $6a0bf5f4f045decc$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $iP8y9(seed, dblen));
    var maskedSeed = $g6TCQ(seed, $iP8y9(maskedDb, hLen));
    return new $kDdu6($6a0bf5f4f045decc$require$Buffer.concat([
        $6a0bf5f4f045decc$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a0bf5f4f045decc$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error('message too long');
    var ps;
    if (reverse) ps = $6a0bf5f4f045decc$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a0bf5f4f045decc$var$nonZero(k - mLen - 3);
    return new $kDdu6($6a0bf5f4f045decc$require$Buffer.concat([
        $6a0bf5f4f045decc$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a0bf5f4f045decc$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a0bf5f4f045decc$var$nonZero(len) {
    var out = $6a0bf5f4f045decc$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $l0MtO(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $l0MtO(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("iP8y9", function(module, exports) {

var $7y50W = parcelRequire("7y50W");

var $6arys = parcelRequire("6arys");
var $db439f3b5d20ccf8$require$Buffer = $6arys.Buffer;
module.exports = function(seed, len) {
    var t = $db439f3b5d20ccf8$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $db439f3b5d20ccf8$var$i2ops(i++);
        t = $db439f3b5d20ccf8$require$Buffer.concat([
            t,
            $7y50W('sha1').update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $db439f3b5d20ccf8$var$i2ops(c) {
    var out = $db439f3b5d20ccf8$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("g6TCQ", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("kDdu6", function(module, exports) {

(function(module1, exports) {
    'use strict';
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || 'Assertion failed');
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === 'le' || base === 'be') {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || 'be');
        }
    }
    if (typeof module1 === 'object') module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== 'undefined' && typeof window.Buffer !== 'undefined') Buffer = window.Buffer;
        else Buffer = (parcelRequire("hDwn7")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === 'object' && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === 'number') return this._initNumber(number, base, endian);
        if (typeof number === 'object') return this._initArray(number, base, endian);
        if (base === 'hex') base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, '');
        var start = 0;
        if (number[0] === '-') {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === 'le') this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== 'le') return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === 'number');
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === 'be') for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === 'le') for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === 'be') for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? '<BN-R: ' : '<BN: ') + this.toString(16) + '>';
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        '',
        '0',
        '00',
        '000',
        '0000',
        '00000',
        '000000',
        '0000000',
        '00000000',
        '000000000',
        '0000000000',
        '00000000000',
        '000000000000',
        '0000000000000',
        '00000000000000',
        '000000000000000',
        '0000000000000000',
        '00000000000000000',
        '000000000000000000',
        '0000000000000000000',
        '00000000000000000000',
        '000000000000000000000',
        '0000000000000000000000',
        '00000000000000000000000',
        '000000000000000000000000',
        '0000000000000000000000000'
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === 'hex') {
            out = '';
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = '';
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = '0' + out;
            while(out.length % padding !== 0)out = '0' + out;
            if (this.negative !== 0) out = '-' + out;
            return out;
        }
        assert(false, 'Base should be between 2 and 36');
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, 'Number can only safely store up to 53 bits');
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== 'undefined');
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, 'byte array longer than desired length');
        assert(reqLength > 0, 'Requested array length <= 0');
        this.strip();
        var littleEndian = endian === 'le';
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === 'number' && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === 'number' && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        this.length = num === 0 ? 1 : this.length;
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === 'number' && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === 'number' && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === 'number' && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, 'imaskn works only with positive numbers');
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === 'number');
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== 'mod') {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== 'div' && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== 'mod') div = res.div.neg();
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== 'mod') div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== 'div') {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === 'div') return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === 'mod') return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, 'div', false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, 'mod', false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, 'mod', true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === 'number');
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, 'Number is too big');
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        assert(this.negative === 0, 'red works only with positives');
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, 'fromRed works only with numbers in reduction context');
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, 'Already a number in reduction context');
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, 'redAdd works only with red numbers');
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, 'redIAdd works only with red numbers');
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, 'redSub works only with red numbers');
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, 'redISub works only with red numbers');
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, 'redShl works only with red numbers');
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, 'redMul works only with red numbers');
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, 'redSqr works only with red numbers');
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, 'redISqr works only with red numbers');
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, 'redSqrt works only with red numbers');
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, 'redInvm works only with red numbers');
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, 'redNeg works only with red numbers');
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, 'redPow(normalNum)');
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, 'k256', 'ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f');
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, 'p224', 'ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001');
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, 'p192', 'ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff');
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, '25519', '7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed');
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === 'k256') prime = new K256();
        else if (name === 'p224') prime = new P224();
        else if (name === 'p192') prime = new P192();
        else if (name === 'p25519') prime = new P25519();
        else throw new Error('Unknown prime ' + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === 'string') {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), 'modulus must be greater than 1');
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, 'red works only with positives');
        assert(a.red, 'red works only with red numbers');
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, 'red works only with positives');
        assert(a.red && a.red === b.red, 'red works only with red numbers');
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("gYUtc", function(module, exports) {

var $kDdu6 = parcelRequire("kDdu6");

var $6arys = parcelRequire("6arys");
var $c5ce0dac0fbde86e$require$Buffer = $6arys.Buffer;
function $c5ce0dac0fbde86e$var$withPublic(paddedMsg, key) {
    return $c5ce0dac0fbde86e$require$Buffer.from(paddedMsg.toRed($kDdu6.mont(key.modulus)).redPow(new $kDdu6(key.publicExponent)).fromRed().toArray());
}
module.exports = $c5ce0dac0fbde86e$var$withPublic;

});


parcelRegister("bAyyp", function(module, exports) {

var $azRsG = parcelRequire("azRsG");

var $iP8y9 = parcelRequire("iP8y9");

var $g6TCQ = parcelRequire("g6TCQ");

var $kDdu6 = parcelRequire("kDdu6");

var $6TJhl = parcelRequire("6TJhl");

var $7y50W = parcelRequire("7y50W");

var $gYUtc = parcelRequire("gYUtc");

var $6arys = parcelRequire("6arys");
var $86fddc37c5dbf164$require$Buffer = $6arys.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $azRsG(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $kDdu6(enc).cmp(key.modulus) >= 0) throw new Error('decryption error');
    var msg;
    if (reverse) msg = $gYUtc(new $kDdu6(enc), key);
    else msg = $6TJhl(enc, key);
    var zBuffer = $86fddc37c5dbf164$require$Buffer.alloc(k - msg.length);
    msg = $86fddc37c5dbf164$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $86fddc37c5dbf164$var$oaep(key, msg);
    else if (padding === 1) return $86fddc37c5dbf164$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error('unknown padding');
};
function $86fddc37c5dbf164$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $7y50W('sha1').update($86fddc37c5dbf164$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error('decryption error');
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $g6TCQ(maskedSeed, $iP8y9(maskedDb, hLen));
    var db = $g6TCQ(maskedDb, $iP8y9(seed, k - hLen - 1));
    if ($86fddc37c5dbf164$var$compare(iHash, db.slice(0, hLen))) throw new Error('decryption error');
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error('decryption error');
    return db.slice(i);
}
function $86fddc37c5dbf164$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString('hex') !== '0002' && !reverse || p1.toString('hex') !== '0001' && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error('decryption error');
    return msg.slice(i);
}
function $86fddc37c5dbf164$var$compare(a, b) {
    a = $86fddc37c5dbf164$require$Buffer.from(a);
    b = $86fddc37c5dbf164$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});


parcelRegister("1BK8u", function(module, exports) {

$parcel$export(module.exports, "randomFill", function () { return $12bd08cbd3be6661$export$bb1abf2ce84fc7e8; }, function (v) { return $12bd08cbd3be6661$export$bb1abf2ce84fc7e8 = v; });
$parcel$export(module.exports, "randomFillSync", function () { return $12bd08cbd3be6661$export$2f7171e78e524d5e; }, function (v) { return $12bd08cbd3be6661$export$2f7171e78e524d5e = v; });
var $12bd08cbd3be6661$export$bb1abf2ce84fc7e8;
var $12bd08cbd3be6661$export$2f7171e78e524d5e;

var $5XqL3 = parcelRequire("5XqL3");
'use strict';
function $12bd08cbd3be6661$var$oldBrowser() {
    throw new Error('secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11');
}

var $6arys = parcelRequire("6arys");

var $l0MtO = parcelRequire("l0MtO");
var $12bd08cbd3be6661$var$Buffer = $6arys.Buffer;
var $12bd08cbd3be6661$var$kBufferMaxLength = $6arys.kMaxLength;
var $12bd08cbd3be6661$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $12bd08cbd3be6661$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $12bd08cbd3be6661$var$assertOffset(offset, length) {
    if (typeof offset !== 'number' || offset !== offset) throw new TypeError('offset must be a number');
    if (offset > $12bd08cbd3be6661$var$kMaxUint32 || offset < 0) throw new TypeError('offset must be a uint32');
    if (offset > $12bd08cbd3be6661$var$kBufferMaxLength || offset > length) throw new RangeError('offset out of range');
}
function $12bd08cbd3be6661$var$assertSize(size, offset, length) {
    if (typeof size !== 'number' || size !== size) throw new TypeError('size must be a number');
    if (size > $12bd08cbd3be6661$var$kMaxUint32 || size < 0) throw new TypeError('size must be a uint32');
    if (size + offset > length || size > $12bd08cbd3be6661$var$kBufferMaxLength) throw new RangeError('buffer too small');
}
if ($12bd08cbd3be6661$var$crypto && $12bd08cbd3be6661$var$crypto.getRandomValues || false) {
    $12bd08cbd3be6661$export$bb1abf2ce84fc7e8 = $12bd08cbd3be6661$var$randomFill;
    $12bd08cbd3be6661$export$2f7171e78e524d5e = $12bd08cbd3be6661$var$randomFillSync;
} else {
    $12bd08cbd3be6661$export$bb1abf2ce84fc7e8 = $12bd08cbd3be6661$var$oldBrowser;
    $12bd08cbd3be6661$export$2f7171e78e524d5e = $12bd08cbd3be6661$var$oldBrowser;
}
function $12bd08cbd3be6661$var$randomFill(buf, offset, size, cb) {
    if (!$12bd08cbd3be6661$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === 'function') {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === 'function') {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== 'function') throw new TypeError('"cb" argument must be a function');
    $12bd08cbd3be6661$var$assertOffset(offset, buf.length);
    $12bd08cbd3be6661$var$assertSize(size, offset, buf.length);
    return $12bd08cbd3be6661$var$actualFill(buf, offset, size, cb);
}
function $12bd08cbd3be6661$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $12bd08cbd3be6661$var$crypto.getRandomValues(uint);
    if (cb) {
        $5XqL3.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $l0MtO(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $l0MtO(size);
    bytes.copy(buf, offset);
    return buf;
}
function $12bd08cbd3be6661$var$randomFillSync(buf, offset, size) {
    if (typeof offset === 'undefined') offset = 0;
    if (!$12bd08cbd3be6661$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $12bd08cbd3be6661$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $12bd08cbd3be6661$var$assertSize(size, offset, buf.length);
    return $12bd08cbd3be6661$var$actualFill(buf, offset, size);
}

});



parcelRegister("2oTAP", function(module, exports) {

$parcel$export(module.exports, "NonFullScreenPageMode", function () { return NonFullScreenPageMode; });
$parcel$export(module.exports, "ReadingDirection", function () { return ReadingDirection; });
$parcel$export(module.exports, "PrintScaling", function () { return PrintScaling; });
$parcel$export(module.exports, "Duplex", function () { return Duplex; });
$parcel$export(module.exports, "default", function () { return $1bf8f2401bb0a5af$export$2e2bcd8739ae039; });

var $cUVc9 = parcelRequire("cUVc9");

var $gxKrW = parcelRequire("gxKrW");

var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var asEnum = function(rawValue, enumType) {
    if (rawValue === undefined) return undefined;
    return enumType[rawValue];
};
var NonFullScreenPageMode;
(function(NonFullScreenPageMode) {
    /**
     * After exiting FullScreen mode, neither the document outline nor thumbnail
     * images should be visible.
     */ NonFullScreenPageMode["UseNone"] = "UseNone";
    /** After exiting FullScreen mode, the document outline should be visible. */ NonFullScreenPageMode["UseOutlines"] = "UseOutlines";
    /** After exiting FullScreen mode, thumbnail images should be visible. */ NonFullScreenPageMode["UseThumbs"] = "UseThumbs";
    /**
     * After exiting FullScreen mode, the optional content group panel should be
     * visible.
     */ NonFullScreenPageMode["UseOC"] = "UseOC";
})(NonFullScreenPageMode || (NonFullScreenPageMode = {}));
var ReadingDirection;
(function(ReadingDirection) {
    /** The predominant reading order is Left to Right. */ ReadingDirection["L2R"] = "L2R";
    /**
     * The predominant reading order is Right to left (including vertical writing
     * systems, such as Chinese, Japanese and Korean).
     */ ReadingDirection["R2L"] = "R2L";
})(ReadingDirection || (ReadingDirection = {}));
var PrintScaling;
(function(PrintScaling) {
    /** No page scaling. */ PrintScaling["None"] = "None";
    /* Use the PDF reader's default print scaling. */ PrintScaling["AppDefault"] = "AppDefault";
})(PrintScaling || (PrintScaling = {}));
var Duplex;
(function(Duplex) {
    /** The PDF reader should print single-sided. */ Duplex["Simplex"] = "Simplex";
    /**
     * The PDF reader should print double sided and flip on the short edge of the
     * sheet.
     */ Duplex["DuplexFlipShortEdge"] = "DuplexFlipShortEdge";
    /**
     * The PDF reader should print double sided and flip on the long edge of the
     * sheet.
     */ Duplex["DuplexFlipLongEdge"] = "DuplexFlipLongEdge";
})(Duplex || (Duplex = {}));
var ViewerPreferences = /** @class */ function() {
    /** @ignore */ function ViewerPreferences(dict) {
        this.dict = dict;
    }
    ViewerPreferences.prototype.lookupBool = function(key) {
        var returnObj = this.dict.lookup((0, $btXS2.default).of(key));
        if (returnObj instanceof (0, $gxKrW.default)) return returnObj;
        return undefined;
    };
    ViewerPreferences.prototype.lookupName = function(key) {
        var returnObj = this.dict.lookup((0, $btXS2.default).of(key));
        if (returnObj instanceof (0, $btXS2.default)) return returnObj;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.HideToolbar = function() {
        return this.lookupBool('HideToolbar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideMenubar = function() {
        return this.lookupBool('HideMenubar');
    };
    /** @ignore */ ViewerPreferences.prototype.HideWindowUI = function() {
        return this.lookupBool('HideWindowUI');
    };
    /** @ignore */ ViewerPreferences.prototype.FitWindow = function() {
        return this.lookupBool('FitWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.CenterWindow = function() {
        return this.lookupBool('CenterWindow');
    };
    /** @ignore */ ViewerPreferences.prototype.DisplayDocTitle = function() {
        return this.lookupBool('DisplayDocTitle');
    };
    /** @ignore */ ViewerPreferences.prototype.NonFullScreenPageMode = function() {
        return this.lookupName('NonFullScreenPageMode');
    };
    /** @ignore */ ViewerPreferences.prototype.Direction = function() {
        return this.lookupName('Direction');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintScaling = function() {
        return this.lookupName('PrintScaling');
    };
    /** @ignore */ ViewerPreferences.prototype.Duplex = function() {
        return this.lookupName('Duplex');
    };
    /** @ignore */ ViewerPreferences.prototype.PickTrayByPDFSize = function() {
        return this.lookupBool('PickTrayByPDFSize');
    };
    /** @ignore */ ViewerPreferences.prototype.PrintPageRange = function() {
        var PrintPageRange = this.dict.lookup((0, $btXS2.default).of('PrintPageRange'));
        if (PrintPageRange instanceof (0, $cUVc9.default)) return PrintPageRange;
        return undefined;
    };
    /** @ignore */ ViewerPreferences.prototype.NumCopies = function() {
        var NumCopies = this.dict.lookup((0, $btXS2.default).of('NumCopies'));
        if (NumCopies instanceof (0, $8LDYe.default)) return NumCopies;
        return undefined;
    };
    /**
     * Returns `true` if PDF readers should hide the toolbar menus when displaying
     * this document.
     * @returns Whether or not toolbars should be hidden.
     */ ViewerPreferences.prototype.getHideToolbar = function() {
        var _a, _b;
        return (_b = (_a = this.HideToolbar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the menu bar when displaying this
     * document.
     * @returns Whether or not the menu bar should be hidden.
     */ ViewerPreferences.prototype.getHideMenubar = function() {
        var _a, _b;
        return (_b = (_a = this.HideMenubar()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should hide the user interface elements in
     * the document's window (such as scroll bars and navigation controls),
     * leaving only the document's contents displayed.
     * @returns Whether or not user interface elements should be hidden.
     */ ViewerPreferences.prototype.getHideWindowUI = function() {
        var _a, _b;
        return (_b = (_a = this.HideWindowUI()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should resize the document's window to fit
     * the size of the first displayed page.
     * @returns Whether or not the window should be resized to fit.
     */ ViewerPreferences.prototype.getFitWindow = function() {
        var _a, _b;
        return (_b = (_a = this.FitWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if PDF readers should position the document's window in the
     * center of the screen.
     * @returns Whether or not to center the document window.
     */ ViewerPreferences.prototype.getCenterWindow = function() {
        var _a, _b;
        return (_b = (_a = this.CenterWindow()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns `true` if the window's title bar should display the document
     * `Title`, taken from the document metadata (see [[PDFDocument.getTitle]]).
     * Returns `false` if the title bar should instead display the filename of the
     * PDF file.
     * @returns Whether to display the document title.
     */ ViewerPreferences.prototype.getDisplayDocTitle = function() {
        var _a, _b;
        return (_b = (_a = this.DisplayDocTitle()) === null || _a === void 0 ? void 0 : _a.asBoolean()) !== null && _b !== void 0 ? _b : false;
    };
    /**
     * Returns the page mode, which tells the PDF reader how to display the
     * document after exiting full-screen mode.
     * @returns The page mode after exiting full-screen mode.
     */ ViewerPreferences.prototype.getNonFullScreenPageMode = function() {
        var _a, _b;
        var mode = (_a = this.NonFullScreenPageMode()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(mode, NonFullScreenPageMode)) !== null && _b !== void 0 ? _b : NonFullScreenPageMode.UseNone;
    };
    /**
     * Returns the predominant reading order for text.
     * @returns The text reading order.
     */ ViewerPreferences.prototype.getReadingDirection = function() {
        var _a, _b;
        var direction = (_a = this.Direction()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(direction, ReadingDirection)) !== null && _b !== void 0 ? _b : ReadingDirection.L2R;
    };
    /**
     * Returns the page scaling option that the PDF reader should select when the
     * print dialog is displayed.
     * @returns The page scaling option.
     */ ViewerPreferences.prototype.getPrintScaling = function() {
        var _a, _b;
        var scaling = (_a = this.PrintScaling()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return (_b = asEnum(scaling, PrintScaling)) !== null && _b !== void 0 ? _b : PrintScaling.AppDefault;
    };
    /**
     * Returns the paper handling option that should be used when printing the
     * file from the print dialog.
     * @returns The paper handling option.
     */ ViewerPreferences.prototype.getDuplex = function() {
        var _a;
        var duplex = (_a = this.Duplex()) === null || _a === void 0 ? void 0 : _a.decodeText();
        return asEnum(duplex, Duplex);
    };
    /**
     * Returns `true` if the PDF page size should be used to select the input
     * paper tray.
     * @returns Whether or not the PDF page size should be used to select the
     *          input paper tray.
     */ ViewerPreferences.prototype.getPickTrayByPDFSize = function() {
        var _a;
        return (_a = this.PickTrayByPDFSize()) === null || _a === void 0 ? void 0 : _a.asBoolean();
    };
    /**
     * Returns an array of page number ranges, which are the values used to
     * initialize the print dialog box when the file is printed. Each range
     * specifies the first (`start`) and last (`end`) pages in a sub-range of
     * pages to be printed. The first page of the PDF file is denoted by 0.
     * For example:
     * ```js
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * const includesPage3 = viewerPrefs
     *   .getPrintRanges()
     *   .some(pr => pr.start =< 2 && pr.end >= 2)
     * if (includesPage3) console.log('printRange includes page 3')
     * ```
     * @returns An array of objects, each with the properties `start` and `end`,
     *          denoting page indices. If not, specified an empty array is
     *          returned.
     */ ViewerPreferences.prototype.getPrintPageRange = function() {
        var rng = this.PrintPageRange();
        if (!rng) return [];
        var pageRanges = [];
        for(var i = 0; i < rng.size(); i += 2){
            // Despite the spec clearly stating that "The first page of the PDF file
            // shall be donoted by 1", several test PDFs (spec 1.7) created in
            // Acrobat XI 11.0 and also read with Reader DC 2020.013 indicate this is
            // actually a 0 based index.
            var start = rng.lookup(i, (0, $8LDYe.default)).asNumber();
            var end = rng.lookup(i + 1, (0, $8LDYe.default)).asNumber();
            pageRanges.push({
                start: start,
                end: end
            });
        }
        return pageRanges;
    };
    /**
     * Returns the number of copies to be printed when the print dialog is opened
     * for this document.
     * @returns The default number of copies to be printed.
     */ ViewerPreferences.prototype.getNumCopies = function() {
        var _a, _b;
        return (_b = (_a = this.NumCopies()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    /**
     * Choose whether the PDF reader's toolbars should be hidden while the
     * document is active.
     * @param hideToolbar `true` if the toolbar should be hidden.
     */ ViewerPreferences.prototype.setHideToolbar = function(hideToolbar) {
        var HideToolbar = this.dict.context.obj(hideToolbar);
        this.dict.set((0, $btXS2.default).of('HideToolbar'), HideToolbar);
    };
    /**
     * Choose whether the PDF reader's menu bar should be hidden while the
     * document is active.
     * @param hideMenubar `true` if the menu bar should be hidden.
     */ ViewerPreferences.prototype.setHideMenubar = function(hideMenubar) {
        var HideMenubar = this.dict.context.obj(hideMenubar);
        this.dict.set((0, $btXS2.default).of('HideMenubar'), HideMenubar);
    };
    /**
     * Choose whether the PDF reader should hide user interface elements in the
     * document's window (such as scroll bars and navigation controls), leaving
     * only the document's contents displayed.
     * @param hideWindowUI `true` if the user interface elements should be hidden.
     */ ViewerPreferences.prototype.setHideWindowUI = function(hideWindowUI) {
        var HideWindowUI = this.dict.context.obj(hideWindowUI);
        this.dict.set((0, $btXS2.default).of('HideWindowUI'), HideWindowUI);
    };
    /**
     * Choose whether the PDF reader should resize the document's window to fit
     * the size of the first displayed page.
     * @param fitWindow `true` if the window should be resized.
     */ ViewerPreferences.prototype.setFitWindow = function(fitWindow) {
        var FitWindow = this.dict.context.obj(fitWindow);
        this.dict.set((0, $btXS2.default).of('FitWindow'), FitWindow);
    };
    /**
     * Choose whether the PDF reader should position the document's window in the
     * center of the screen.
     * @param centerWindow `true` if the window should be centered.
     */ ViewerPreferences.prototype.setCenterWindow = function(centerWindow) {
        var CenterWindow = this.dict.context.obj(centerWindow);
        this.dict.set((0, $btXS2.default).of('CenterWindow'), CenterWindow);
    };
    /**
     * Choose whether the window's title bar should display the document `Title`
     * taken from the document metadata (see [[PDFDocument.setTitle]]). If
     * `false`, the title bar should instead display the PDF filename.
     * @param displayTitle `true` if the document title should be displayed.
     */ ViewerPreferences.prototype.setDisplayDocTitle = function(displayTitle) {
        var DisplayDocTitle = this.dict.context.obj(displayTitle);
        this.dict.set((0, $btXS2.default).of('DisplayDocTitle'), DisplayDocTitle);
    };
    /**
     * Choose how the PDF reader should display the document upon exiting
     * full-screen mode. This entry is meaningful only if the value of the
     * `PageMode` entry in the document's [[PDFCatalog]] is `FullScreen`.
     *
     * For example:
     * ```js
     * import { PDFDocument, NonFullScreenPageMode, PDFName } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     *
     * // Set the PageMode
     * pdfDoc.catalog.set(PDFName.of('PageMode'),PDFName.of('FullScreen'))
     *
     * // Set what happens when full-screen is closed
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setNonFullScreenPageMode(NonFullScreenPageMode.UseOutlines)
     * ```
     *
     * @param nonFullScreenPageMode How the document should be displayed upon
     *                              exiting full screen mode.
     */ ViewerPreferences.prototype.setNonFullScreenPageMode = function(nonFullScreenPageMode) {
        (0, $fYigW.assertIsOneOf)(nonFullScreenPageMode, 'nonFullScreenPageMode', NonFullScreenPageMode);
        var mode = (0, $btXS2.default).of(nonFullScreenPageMode);
        this.dict.set((0, $btXS2.default).of('NonFullScreenPageMode'), mode);
    };
    /**
     * Choose the predominant reading order for text.
     *
     * This entry has no direct effect on the document's contents or page
     * numbering, but may be used to determine the relative positioning of pages
     * when displayed side by side or printed n-up.
     *
     * For example:
     * ```js
     * import { PDFDocument, ReadingDirection } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setReadingDirection(ReadingDirection.R2L)
     * ```
     *
     * @param readingDirection The reading order for text.
     */ ViewerPreferences.prototype.setReadingDirection = function(readingDirection) {
        (0, $fYigW.assertIsOneOf)(readingDirection, 'readingDirection', ReadingDirection);
        var direction = (0, $btXS2.default).of(readingDirection);
        this.dict.set((0, $btXS2.default).of('Direction'), direction);
    };
    /**
     * Choose the page scaling option that should be selected when a print dialog
     * is displayed for this document.
     *
     * For example:
     * ```js
     * import { PDFDocument, PrintScaling } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setPrintScaling(PrintScaling.None)
     * ```
     *
     * @param printScaling The print scaling option.
     */ ViewerPreferences.prototype.setPrintScaling = function(printScaling) {
        (0, $fYigW.assertIsOneOf)(printScaling, 'printScaling', PrintScaling);
        var scaling = (0, $btXS2.default).of(printScaling);
        this.dict.set((0, $btXS2.default).of('PrintScaling'), scaling);
    };
    /**
     * Choose the paper handling option that should be selected by default in the
     * print dialog.
     *
     * For example:
     * ```js
     * import { PDFDocument, Duplex } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     * viewerPrefs.setDuplex(Duplex.DuplexFlipShortEdge)
     * ```
     *
     * @param duplex The double or single sided printing option.
     */ ViewerPreferences.prototype.setDuplex = function(duplex) {
        (0, $fYigW.assertIsOneOf)(duplex, 'duplex', Duplex);
        var dup = (0, $btXS2.default).of(duplex);
        this.dict.set((0, $btXS2.default).of('Duplex'), dup);
    };
    /**
     * Choose whether the PDF document's page size should be used to select the
     * input paper tray when printing. This setting influences only the preset
     * values used to populate the print dialog presented by a PDF reader.
     *
     * If PickTrayByPDFSize is true, the check box in the print dialog associated
     * with input paper tray should be checked. This setting has no effect on
     * operating systems that do not provide the ability to pick the input tray
     * by size.
     *
     * @param pickTrayByPDFSize `true` if the document's page size should be used
     *                          to select the input paper tray.
     */ ViewerPreferences.prototype.setPickTrayByPDFSize = function(pickTrayByPDFSize) {
        var PickTrayByPDFSize = this.dict.context.obj(pickTrayByPDFSize);
        this.dict.set((0, $btXS2.default).of('PickTrayByPDFSize'), PickTrayByPDFSize);
    };
    /**
     * Choose the page numbers used to initialize the print dialog box when the
     * file is printed. The first page of the PDF file is denoted by 0.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const viewerPrefs = pdfDoc.catalog.getOrCreateViewerPreferences()
     *
     * // We can set the default print range to only the first page
     * viewerPrefs.setPrintPageRange({ start: 0, end: 0 })
     *
     * // Or we can supply noncontiguous ranges (e.g. pages 1, 3, and 5-7)
     * viewerPrefs.setPrintPageRange([
     *   { start: 0, end: 0 },
     *   { start: 2, end: 2 },
     *   { start: 4, end: 6 },
     * ])
     * ```
     *
     * @param printPageRange An object or array of objects, each with the
     *                       properties `start` and `end`, denoting a range of
     *                       page indices.
     */ ViewerPreferences.prototype.setPrintPageRange = function(printPageRange) {
        if (!Array.isArray(printPageRange)) printPageRange = [
            printPageRange
        ];
        var flatRange = [];
        for(var idx = 0, len = printPageRange.length; idx < len; idx++){
            flatRange.push(printPageRange[idx].start);
            flatRange.push(printPageRange[idx].end);
        }
        (0, $fYigW.assertEachIs)(flatRange, 'printPageRange', [
            'number'
        ]);
        var pageRanges = this.dict.context.obj(flatRange);
        this.dict.set((0, $btXS2.default).of('PrintPageRange'), pageRanges);
    };
    /**
     * Choose the default number of copies to be printed when the print dialog is
     * opened for this file.
     * @param numCopies The default number of copies.
     */ ViewerPreferences.prototype.setNumCopies = function(numCopies) {
        (0, $fYigW.assertRange)(numCopies, 'numCopies', 1, Number.MAX_VALUE);
        (0, $fYigW.assertInteger)(numCopies, 'numCopies');
        var NumCopies = this.dict.context.obj(numCopies);
        this.dict.set((0, $btXS2.default).of('NumCopies'), NumCopies);
    };
    /** @ignore */ ViewerPreferences.fromDict = function(dict) {
        return new ViewerPreferences(dict);
    };
    /** @ignore */ ViewerPreferences.create = function(context) {
        var dict = context.obj({});
        return new ViewerPreferences(dict);
    };
    return ViewerPreferences;
}();
var $1bf8f2401bb0a5af$export$2e2bcd8739ae039 = ViewerPreferences;

});
parcelRegister("cUVc9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $967714bf755d458a$export$2e2bcd8739ae039; });

var $70JnX = parcelRequire("70JnX");

var $8LDYe = parcelRequire("8LDYe");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");

var $1jVcF = parcelRequire("1jVcF");
var $967714bf755d458a$var$PDFArray = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFArray, _super);
    function PDFArray(context) {
        var _this = _super.call(this) || this;
        _this.array = [];
        _this.context = context;
        return _this;
    }
    PDFArray.prototype.size = function() {
        return this.array.length;
    };
    PDFArray.prototype.push = function(object) {
        this.array.push(object);
    };
    PDFArray.prototype.insert = function(index, object) {
        this.array.splice(index, 0, object);
    };
    PDFArray.prototype.indexOf = function(object) {
        var index = this.array.indexOf(object);
        return index === -1 ? undefined : index;
    };
    PDFArray.prototype.remove = function(index) {
        this.array.splice(index, 1);
    };
    PDFArray.prototype.set = function(idx, object) {
        this.array[idx] = object;
    };
    PDFArray.prototype.get = function(index) {
        return this.array[index];
    };
    PDFArray.prototype.lookupMaybe = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookupMaybe.apply(_a, (0, $70JnX.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.lookup = function(index) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        return (_a = this.context).lookup.apply(_a, (0, $70JnX.__spreadArrays)([
            this.get(index)
        ], types));
    };
    PDFArray.prototype.asRectangle = function() {
        if (this.size() !== 4) throw new (0, $1jVcF.PDFArrayIsNotRectangleError)(this.size());
        var lowerLeftX = this.lookup(0, (0, $8LDYe.default)).asNumber();
        var lowerLeftY = this.lookup(1, (0, $8LDYe.default)).asNumber();
        var upperRightX = this.lookup(2, (0, $8LDYe.default)).asNumber();
        var upperRightY = this.lookup(3, (0, $8LDYe.default)).asNumber();
        var x = lowerLeftX;
        var y = lowerLeftY;
        var width = upperRightX - lowerLeftX;
        var height = upperRightY - lowerLeftY;
        return {
            x: x,
            y: y,
            width: width,
            height: height
        };
    };
    PDFArray.prototype.asArray = function() {
        return this.array.slice();
    };
    PDFArray.prototype.clone = function(context) {
        var clone = PDFArray.withContext(context || this.context);
        for(var idx = 0, len = this.size(); idx < len; idx++)clone.push(this.array[idx]);
        return clone;
    };
    PDFArray.prototype.toString = function() {
        var arrayString = '[ ';
        for(var idx = 0, len = this.size(); idx < len; idx++){
            arrayString += this.get(idx).toString();
            arrayString += ' ';
        }
        arrayString += ']';
        return arrayString;
    };
    PDFArray.prototype.sizeInBytes = function() {
        var size = 3;
        for(var idx = 0, len = this.size(); idx < len; idx++)size += this.get(idx).sizeInBytes() + 1;
        return size;
    };
    PDFArray.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).LeftSquareBracket;
        buffer[offset++] = (0, $lJYRg.default).Space;
        for(var idx = 0, len = this.size(); idx < len; idx++){
            offset += this.get(idx).copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
        }
        buffer[offset++] = (0, $lJYRg.default).RightSquareBracket;
        return offset - initialOffset;
    };
    PDFArray.prototype.scalePDFNumbers = function(x, y) {
        for(var idx = 0, len = this.size(); idx < len; idx++){
            var el = this.lookup(idx);
            if (el instanceof (0, $8LDYe.default)) {
                var factor = idx % 2 === 0 ? x : y;
                this.set(idx, (0, $8LDYe.default).of(el.asNumber() * factor));
            }
        }
    };
    PDFArray.withContext = function(context) {
        return new PDFArray(context);
    };
    return PDFArray;
}((0, $iyqEO.default));
var $967714bf755d458a$export$2e2bcd8739ae039 = $967714bf755d458a$var$PDFArray;

});
parcelRegister("70JnX", function(module, exports) {

$parcel$export(module.exports, "__extends", function () { return $51abbd1b996056dd$export$a8ba968b8961cb8a; });
$parcel$export(module.exports, "__assign", function () { return $51abbd1b996056dd$export$18ce0697a983be9b; });
$parcel$export(module.exports, "__rest", function () { return $51abbd1b996056dd$export$3c9a16f847548506; });
$parcel$export(module.exports, "__awaiter", function () { return $51abbd1b996056dd$export$1050f835b63b671e; });
$parcel$export(module.exports, "__generator", function () { return $51abbd1b996056dd$export$67ebef60e6f28a6; });
$parcel$export(module.exports, "__spreadArrays", function () { return $51abbd1b996056dd$export$6388937ca91ccae8; });
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise */ var $51abbd1b996056dd$var$extendStatics = function(d, b) {
    $51abbd1b996056dd$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return $51abbd1b996056dd$var$extendStatics(d, b);
};
function $51abbd1b996056dd$export$a8ba968b8961cb8a(d, b) {
    $51abbd1b996056dd$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $51abbd1b996056dd$export$18ce0697a983be9b = function() {
    $51abbd1b996056dd$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $51abbd1b996056dd$export$18ce0697a983be9b.apply(this, arguments);
};
function $51abbd1b996056dd$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $51abbd1b996056dd$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $51abbd1b996056dd$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $51abbd1b996056dd$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $51abbd1b996056dd$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $51abbd1b996056dd$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g;
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
function $51abbd1b996056dd$export$45d3717a4c69092e(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}
function $51abbd1b996056dd$export$f33643c0debef087(m, exports) {
    for(var p in m)if (p !== "default" && !exports.hasOwnProperty(p)) exports[p] = m[p];
}
function $51abbd1b996056dd$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $51abbd1b996056dd$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $51abbd1b996056dd$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($51abbd1b996056dd$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $51abbd1b996056dd$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $51abbd1b996056dd$export$10c90e4f7922046c(v) {
    return this instanceof $51abbd1b996056dd$export$10c90e4f7922046c ? (this.v = v, this) : new $51abbd1b996056dd$export$10c90e4f7922046c(v);
}
function $51abbd1b996056dd$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function verb(n) {
        if (g[n]) i[n] = function(v) {
            return new Promise(function(a, b) {
                q.push([
                    n,
                    v,
                    a,
                    b
                ]) > 1 || resume(n, v);
            });
        };
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $51abbd1b996056dd$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $51abbd1b996056dd$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $51abbd1b996056dd$export$10c90e4f7922046c(o[n](v)),
                done: n === "return"
            } : f ? f(v) : v;
        } : f;
    }
}
function $51abbd1b996056dd$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $51abbd1b996056dd$export$19a8beecd37a4c45 === "function" ? $51abbd1b996056dd$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $51abbd1b996056dd$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
function $51abbd1b996056dd$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    }
    result.default = mod;
    return result;
}
function $51abbd1b996056dd$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $51abbd1b996056dd$export$d5dcaf168c640c35(receiver, privateMap) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to get private field on non-instance");
    return privateMap.get(receiver);
}
function $51abbd1b996056dd$export$d40a35129aaff81f(receiver, privateMap, value) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to set private field on non-instance");
    privateMap.set(receiver, value);
    return value;
}

});

parcelRegister("8LDYe", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6621b7d6bfc3d3cd$export$2e2bcd8739ae039; });

var $70JnX = parcelRequire("70JnX");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $5ypEP = parcelRequire("5ypEP");

var $iyqEO = parcelRequire("iyqEO");
var $6621b7d6bfc3d3cd$var$PDFNumber = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFNumber, _super);
    function PDFNumber(value) {
        var _this = _super.call(this) || this;
        _this.numberValue = value;
        _this.stringValue = (0, $5ypEP.numberToString)(value);
        return _this;
    }
    PDFNumber.prototype.asNumber = function() {
        return this.numberValue;
    };
    /** @deprecated in favor of [[PDFNumber.asNumber]] */ PDFNumber.prototype.value = function() {
        return this.numberValue;
    };
    PDFNumber.prototype.clone = function() {
        return PDFNumber.of(this.numberValue);
    };
    PDFNumber.prototype.toString = function() {
        return this.stringValue;
    };
    PDFNumber.prototype.sizeInBytes = function() {
        return this.stringValue.length;
    };
    PDFNumber.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.stringValue, buffer, offset);
        return this.stringValue.length;
    };
    PDFNumber.of = function(value) {
        return new PDFNumber(value);
    };
    return PDFNumber;
}((0, $iyqEO.default));
var $6621b7d6bfc3d3cd$export$2e2bcd8739ae039 = $6621b7d6bfc3d3cd$var$PDFNumber;

});
parcelRegister("JEL7f", function(module, exports) {
$parcel$export(module.exports, "arrayAsString", function () { return (parcelRequire("9uJGW")).arrayAsString; });
$parcel$export(module.exports, "byAscendingId", function () { return (parcelRequire("9uJGW")).byAscendingId; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return (parcelRequire("9uJGW")).canBeConvertedToUint8Array; });
$parcel$export(module.exports, "last", function () { return (parcelRequire("9uJGW")).last; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return (parcelRequire("9uJGW")).mergeIntoTypedArray; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return (parcelRequire("9uJGW")).mergeUint8Arrays; });
$parcel$export(module.exports, "pluckIndices", function () { return (parcelRequire("9uJGW")).pluckIndices; });
$parcel$export(module.exports, "range", function () { return (parcelRequire("9uJGW")).range; });
$parcel$export(module.exports, "reverseArray", function () { return (parcelRequire("9uJGW")).reverseArray; });
$parcel$export(module.exports, "sortedUniq", function () { return (parcelRequire("9uJGW")).sortedUniq; });
$parcel$export(module.exports, "sum", function () { return (parcelRequire("9uJGW")).sum; });
$parcel$export(module.exports, "toUint8Array", function () { return (parcelRequire("9uJGW")).toUint8Array; });
$parcel$export(module.exports, "typedArrayFor", function () { return (parcelRequire("9uJGW")).typedArrayFor; });
$parcel$export(module.exports, "waitForTick", function () { return (parcelRequire("fAfk5")).waitForTick; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return (parcelRequire("c6a2W")).breakTextIntoLines; });
$parcel$export(module.exports, "charAtIndex", function () { return (parcelRequire("c6a2W")).charAtIndex; });
$parcel$export(module.exports, "charFromCode", function () { return (parcelRequire("c6a2W")).charFromCode; });
$parcel$export(module.exports, "charFromHexCode", function () { return (parcelRequire("c6a2W")).charFromHexCode; });
$parcel$export(module.exports, "charSplit", function () { return (parcelRequire("c6a2W")).charSplit; });
$parcel$export(module.exports, "cleanText", function () { return (parcelRequire("c6a2W")).cleanText; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return (parcelRequire("c6a2W")).copyStringIntoBuffer; });
$parcel$export(module.exports, "findLastMatch", function () { return (parcelRequire("c6a2W")).findLastMatch; });
$parcel$export(module.exports, "lineSplit", function () { return (parcelRequire("c6a2W")).lineSplit; });
$parcel$export(module.exports, "mergeLines", function () { return (parcelRequire("c6a2W")).mergeLines; });
$parcel$export(module.exports, "padStart", function () { return (parcelRequire("c6a2W")).padStart; });
$parcel$export(module.exports, "parseDate", function () { return (parcelRequire("c6a2W")).parseDate; });
$parcel$export(module.exports, "toCharCode", function () { return (parcelRequire("c6a2W")).toCharCode; });
$parcel$export(module.exports, "toCodePoint", function () { return (parcelRequire("c6a2W")).toCodePoint; });
$parcel$export(module.exports, "toHexString", function () { return (parcelRequire("c6a2W")).toHexString; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return (parcelRequire("c6a2W")).toHexStringOfMinLength; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return (parcelRequire("9ZNih")).hasUtf16BOM; });
$parcel$export(module.exports, "utf16Decode", function () { return (parcelRequire("9ZNih")).utf16Decode; });
$parcel$export(module.exports, "utf16Encode", function () { return (parcelRequire("9ZNih")).utf16Encode; });
$parcel$export(module.exports, "bytesFor", function () { return (parcelRequire("5ypEP")).bytesFor; });
$parcel$export(module.exports, "numberToString", function () { return (parcelRequire("5ypEP")).numberToString; });
$parcel$export(module.exports, "sizeInBytes", function () { return (parcelRequire("5ypEP")).sizeInBytes; });
$parcel$export(module.exports, "error", function () { return (parcelRequire("dXsOT")).error; });
$parcel$export(module.exports, "encodeToBase64", function () { return (parcelRequire("h8dd0")).encodeToBase64; });
$parcel$export(module.exports, "isStandardFont", function () { return (parcelRequire("3JpTw")).isStandardFont; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return (parcelRequire("3JpTw")).rectanglesAreEqual; });
$parcel$export(module.exports, "assertEachIs", function () { return (parcelRequire("fYigW")).assertEachIs; });
$parcel$export(module.exports, "assertInteger", function () { return (parcelRequire("fYigW")).assertInteger; });
$parcel$export(module.exports, "assertIs", function () { return (parcelRequire("fYigW")).assertIs; });
$parcel$export(module.exports, "assertIsOneOf", function () { return (parcelRequire("fYigW")).assertIsOneOf; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return (parcelRequire("fYigW")).assertIsOneOfOrUndefined; });
$parcel$export(module.exports, "assertIsSubset", function () { return (parcelRequire("fYigW")).assertIsSubset; });
$parcel$export(module.exports, "assertMultiple", function () { return (parcelRequire("fYigW")).assertMultiple; });
$parcel$export(module.exports, "assertOrUndefined", function () { return (parcelRequire("fYigW")).assertOrUndefined; });
$parcel$export(module.exports, "assertPositive", function () { return (parcelRequire("fYigW")).assertPositive; });
$parcel$export(module.exports, "assertRange", function () { return (parcelRequire("fYigW")).assertRange; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return (parcelRequire("fYigW")).assertRangeOrUndefined; });
$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return (parcelRequire("aMBsn")).pdfDocEncodingDecode; });

$parcel$export(module.exports, "Cache", function () { return (parcelRequire("cLyfO")).default; });
parcelRequire("9uJGW");
parcelRequire("fAfk5");
parcelRequire("c6a2W");
parcelRequire("9ZNih");
parcelRequire("5ypEP");
parcelRequire("dXsOT");
parcelRequire("h8dd0");
parcelRequire("3JpTw");
parcelRequire("fYigW");
parcelRequire("aMBsn");

var $cLyfO = parcelRequire("cLyfO");

});
parcelRegister("9uJGW", function(module, exports) {

$parcel$export(module.exports, "last", function () { return $6e9a5bc915166fa7$export$4c7897fafd92b108; });
$parcel$export(module.exports, "typedArrayFor", function () { return $6e9a5bc915166fa7$export$98b44e66722b6f4d; });
$parcel$export(module.exports, "mergeIntoTypedArray", function () { return $6e9a5bc915166fa7$export$8907b5381cbcd9a7; });
$parcel$export(module.exports, "mergeUint8Arrays", function () { return $6e9a5bc915166fa7$export$99cee7ee2de7e6e4; });
$parcel$export(module.exports, "arrayAsString", function () { return $6e9a5bc915166fa7$export$5f8f9664fe5c5f14; });
$parcel$export(module.exports, "byAscendingId", function () { return $6e9a5bc915166fa7$export$55b6b1f56c6e1ba5; });
$parcel$export(module.exports, "sortedUniq", function () { return $6e9a5bc915166fa7$export$720e3b5aefb27114; });
$parcel$export(module.exports, "reverseArray", function () { return $6e9a5bc915166fa7$export$c9b97e771c4a8302; });
$parcel$export(module.exports, "sum", function () { return $6e9a5bc915166fa7$export$8a63f25cc62965f1; });
$parcel$export(module.exports, "range", function () { return $6e9a5bc915166fa7$export$d02631cccf789723; });
$parcel$export(module.exports, "pluckIndices", function () { return $6e9a5bc915166fa7$export$279d041ff3481d88; });
$parcel$export(module.exports, "canBeConvertedToUint8Array", function () { return $6e9a5bc915166fa7$export$20e9c5ed92218c4b; });
$parcel$export(module.exports, "toUint8Array", function () { return $6e9a5bc915166fa7$export$73470fd2221e6aef; });

var $h8dd0 = parcelRequire("h8dd0");

var $c6a2W = parcelRequire("c6a2W");
var $6e9a5bc915166fa7$export$4c7897fafd92b108 = function(array) {
    return array[array.length - 1];
};
var $6e9a5bc915166fa7$export$98b44e66722b6f4d = function(value) {
    if (value instanceof Uint8Array) return value;
    var length = value.length;
    var typedArray = new Uint8Array(length);
    for(var idx = 0; idx < length; idx++)typedArray[idx] = value.charCodeAt(idx);
    return typedArray;
};
var $6e9a5bc915166fa7$export$8907b5381cbcd9a7 = function() {
    var arrays = [];
    for(var _i = 0; _i < arguments.length; _i++)arrays[_i] = arguments[_i];
    var arrayCount = arrays.length;
    var typedArrays = [];
    for(var idx = 0; idx < arrayCount; idx++){
        var element = arrays[idx];
        typedArrays[idx] = element instanceof Uint8Array ? element : $6e9a5bc915166fa7$export$98b44e66722b6f4d(element);
    }
    var totalSize = 0;
    for(var idx = 0; idx < arrayCount; idx++)totalSize += arrays[idx].length;
    var merged = new Uint8Array(totalSize);
    var offset = 0;
    for(var arrIdx = 0; arrIdx < arrayCount; arrIdx++){
        var arr = typedArrays[arrIdx];
        for(var byteIdx = 0, arrLen = arr.length; byteIdx < arrLen; byteIdx++)merged[offset++] = arr[byteIdx];
    }
    return merged;
};
var $6e9a5bc915166fa7$export$99cee7ee2de7e6e4 = function(arrays) {
    var totalSize = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++)totalSize += arrays[idx].length;
    var mergedBuffer = new Uint8Array(totalSize);
    var offset = 0;
    for(var idx = 0, len = arrays.length; idx < len; idx++){
        var array = arrays[idx];
        mergedBuffer.set(array, offset);
        offset += array.length;
    }
    return mergedBuffer;
};
var $6e9a5bc915166fa7$export$5f8f9664fe5c5f14 = function(array) {
    var str = '';
    for(var idx = 0, len = array.length; idx < len; idx++)str += (0, $c6a2W.charFromCode)(array[idx]);
    return str;
};
var $6e9a5bc915166fa7$export$55b6b1f56c6e1ba5 = function(a, b) {
    return a.id - b.id;
};
var $6e9a5bc915166fa7$export$720e3b5aefb27114 = function(array, indexer) {
    var uniq = [];
    for(var idx = 0, len = array.length; idx < len; idx++){
        var curr = array[idx];
        var prev = array[idx - 1];
        if (idx === 0 || indexer(curr) !== indexer(prev)) uniq.push(curr);
    }
    return uniq;
};
var $6e9a5bc915166fa7$export$c9b97e771c4a8302 = function(array) {
    var arrayLen = array.length;
    for(var idx = 0, len = Math.floor(arrayLen / 2); idx < len; idx++){
        var leftIdx = idx;
        var rightIdx = arrayLen - idx - 1;
        var temp = array[idx];
        array[leftIdx] = array[rightIdx];
        array[rightIdx] = temp;
    }
    return array;
};
var $6e9a5bc915166fa7$export$8a63f25cc62965f1 = function(array) {
    var total = 0;
    for(var idx = 0, len = array.length; idx < len; idx++)total += array[idx];
    return total;
};
var $6e9a5bc915166fa7$export$d02631cccf789723 = function(start, end) {
    var arr = new Array(end - start);
    for(var idx = 0, len = arr.length; idx < len; idx++)arr[idx] = start + idx;
    return arr;
};
var $6e9a5bc915166fa7$export$279d041ff3481d88 = function(arr, indices) {
    var plucked = new Array(indices.length);
    for(var idx = 0, len = indices.length; idx < len; idx++)plucked[idx] = arr[indices[idx]];
    return plucked;
};
var $6e9a5bc915166fa7$export$20e9c5ed92218c4b = function(input) {
    return input instanceof Uint8Array || input instanceof ArrayBuffer || typeof input === 'string';
};
var $6e9a5bc915166fa7$export$73470fd2221e6aef = function(input) {
    if (typeof input === 'string') return (0, $h8dd0.decodeFromBase64DataUri)(input);
    else if (input instanceof ArrayBuffer) return new Uint8Array(input);
    else if (input instanceof Uint8Array) return input;
    else throw new TypeError('`input` must be one of `string | ArrayBuffer | Uint8Array`');
};

});
parcelRegister("h8dd0", function(module, exports) {

$parcel$export(module.exports, "encodeToBase64", function () { return $c78d6dfe00d23344$export$373f4c3083978ffd; });
$parcel$export(module.exports, "decodeFromBase64DataUri", function () { return $c78d6dfe00d23344$export$f6810f5086699d73; });
/*
 * The `chars`, `lookup`, `encode`, and `decode` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ var $c78d6dfe00d23344$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $c78d6dfe00d23344$var$lookup = new Uint8Array(256);
for(var $c78d6dfe00d23344$var$i = 0; $c78d6dfe00d23344$var$i < $c78d6dfe00d23344$var$chars.length; $c78d6dfe00d23344$var$i++)$c78d6dfe00d23344$var$lookup[$c78d6dfe00d23344$var$chars.charCodeAt($c78d6dfe00d23344$var$i)] = $c78d6dfe00d23344$var$i;
var $c78d6dfe00d23344$export$373f4c3083978ffd = function(bytes) {
    var base64 = '';
    var len = bytes.length;
    for(var i = 0; i < len; i += 3){
        base64 += $c78d6dfe00d23344$var$chars[bytes[i] >> 2];
        base64 += $c78d6dfe00d23344$var$chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
        base64 += $c78d6dfe00d23344$var$chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
        base64 += $c78d6dfe00d23344$var$chars[bytes[i + 2] & 63];
    }
    if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + '=';
    else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + '==';
    return base64;
};
var $c78d6dfe00d23344$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $c78d6dfe00d23344$var$lookup[base64.charCodeAt(i)];
        encoded2 = $c78d6dfe00d23344$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $c78d6dfe00d23344$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $c78d6dfe00d23344$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
// This regex is designed to be as flexible as possible. It will parse certain
// invalid data URIs.
var $c78d6dfe00d23344$var$DATA_URI_PREFIX_REGEX = /^(data)?:?([\w\/\+]+)?;?(charset=[\w-]+|base64)?.*,/i;
var $c78d6dfe00d23344$export$f6810f5086699d73 = function(dataUri) {
    var trimmedUri = dataUri.trim();
    var prefix = trimmedUri.substring(0, 100);
    var res = prefix.match($c78d6dfe00d23344$var$DATA_URI_PREFIX_REGEX);
    // Assume it's not a data URI - just a plain base64 string
    if (!res) return $c78d6dfe00d23344$export$83edfd8fcc66ec17(trimmedUri);
    // Remove the data URI prefix and parse the remainder as a base64 string
    var fullMatch = res[0];
    var data = trimmedUri.substring(fullMatch.length);
    return $c78d6dfe00d23344$export$83edfd8fcc66ec17(data);
};

});

parcelRegister("c6a2W", function(module, exports) {

$parcel$export(module.exports, "toCharCode", function () { return $8cedd6940ce3742d$export$d90166409dd04e85; });
$parcel$export(module.exports, "toCodePoint", function () { return $8cedd6940ce3742d$export$93bf578f015d73f0; });
$parcel$export(module.exports, "toHexStringOfMinLength", function () { return $8cedd6940ce3742d$export$6ac97d2d1bf41f39; });
$parcel$export(module.exports, "padStart", function () { return $8cedd6940ce3742d$export$36cf564d487b5178; });
$parcel$export(module.exports, "toHexString", function () { return $8cedd6940ce3742d$export$f4915efbb94d4d01; });
$parcel$export(module.exports, "charFromCode", function () { return $8cedd6940ce3742d$export$207031940e6950ad; });
$parcel$export(module.exports, "charFromHexCode", function () { return $8cedd6940ce3742d$export$ceedd1b69dcde7a5; });
$parcel$export(module.exports, "copyStringIntoBuffer", function () { return $8cedd6940ce3742d$export$c41a03555c37a984; });
$parcel$export(module.exports, "cleanText", function () { return $8cedd6940ce3742d$export$6b5e57d20078142b; });
$parcel$export(module.exports, "lineSplit", function () { return $8cedd6940ce3742d$export$4f60280859794d8c; });
$parcel$export(module.exports, "mergeLines", function () { return $8cedd6940ce3742d$export$b5bf5e120f07cbe; });
$parcel$export(module.exports, "charAtIndex", function () { return $8cedd6940ce3742d$export$1a93fc5af577aa5c; });
$parcel$export(module.exports, "charSplit", function () { return $8cedd6940ce3742d$export$78f5a8ab9b5e7f1e; });
$parcel$export(module.exports, "breakTextIntoLines", function () { return $8cedd6940ce3742d$export$38936f7739928807; });
$parcel$export(module.exports, "parseDate", function () { return $8cedd6940ce3742d$export$6b862160d295c8e; });
$parcel$export(module.exports, "findLastMatch", function () { return $8cedd6940ce3742d$export$dc1d7d42f51764e3; });
var $8cedd6940ce3742d$export$d90166409dd04e85 = function(character) {
    return character.charCodeAt(0);
};
var $8cedd6940ce3742d$export$93bf578f015d73f0 = function(character) {
    return character.codePointAt(0);
};
var $8cedd6940ce3742d$export$6ac97d2d1bf41f39 = function(num, minLength) {
    return $8cedd6940ce3742d$export$36cf564d487b5178(num.toString(16), minLength, '0').toUpperCase();
};
var $8cedd6940ce3742d$export$f4915efbb94d4d01 = function(num) {
    return $8cedd6940ce3742d$export$6ac97d2d1bf41f39(num, 2);
};
var $8cedd6940ce3742d$export$207031940e6950ad = function(code) {
    return String.fromCharCode(code);
};
var $8cedd6940ce3742d$export$ceedd1b69dcde7a5 = function(hex) {
    return $8cedd6940ce3742d$export$207031940e6950ad(parseInt(hex, 16));
};
var $8cedd6940ce3742d$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};
var $8cedd6940ce3742d$export$c41a03555c37a984 = function(str, buffer, offset) {
    var length = str.length;
    for(var idx = 0; idx < length; idx++)buffer[offset++] = str.charCodeAt(idx);
    return length;
};
var $8cedd6940ce3742d$export$505d8f7c00d806ca = function(prefix, suffixLength) {
    if (suffixLength === void 0) suffixLength = 4;
    return prefix + "-" + Math.floor(Math.random() * Math.pow(10, suffixLength));
};
var $8cedd6940ce3742d$export$7c57da42ce8e346f = function(str) {
    return str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
};
var $8cedd6940ce3742d$export$6b5e57d20078142b = function(text) {
    return text.replace(/\t|\u0085|\u2028|\u2029/g, '    ').replace(/[\b\v]/g, '');
};
var $8cedd6940ce3742d$export$60bd2eb6e5a75df0 = [
    '\\n',
    '\\f',
    '\\r',
    '\\u000B'
];
var $8cedd6940ce3742d$export$634cc0013ed0f624 = [
    '\n',
    '\f',
    '\r',
    '\u000B'
];
var $8cedd6940ce3742d$export$3fc8feceeed3beb0 = function(text) {
    return /^[\n\f\r\u000B]$/.test(text);
};
var $8cedd6940ce3742d$export$4f60280859794d8c = function(text) {
    return text.split(/[\n\f\r\u000B]/);
};
var $8cedd6940ce3742d$export$b5bf5e120f07cbe = function(text) {
    return text.replace(/[\n\f\r\u000B]/g, ' ');
};
var $8cedd6940ce3742d$export$1a93fc5af577aa5c = function(text, index) {
    // Get the first code unit and code unit value
    var cuFirst = text.charCodeAt(index);
    var cuSecond;
    var nextIndex = index + 1;
    var length = 1;
    if (// Check if it's the start of a surrogate pair.
    cuFirst >= 0xd800 && cuFirst <= 0xdbff && // high surrogate
    text.length > nextIndex // there is a next code unit
    ) {
        cuSecond = text.charCodeAt(nextIndex);
        if (cuSecond >= 0xdc00 && cuSecond <= 0xdfff) length = 2; // low surrogate
    }
    return [
        text.slice(index, index + length),
        length
    ];
};
var $8cedd6940ce3742d$export$78f5a8ab9b5e7f1e = function(text) {
    var chars = [];
    for(var idx = 0, len = text.length; idx < len;){
        var _a = $8cedd6940ce3742d$export$1a93fc5af577aa5c(text, idx), c = _a[0], cLen = _a[1];
        chars.push(c);
        idx += cLen;
    }
    return chars;
};
var $8cedd6940ce3742d$var$buildWordBreakRegex = function(wordBreaks) {
    var newlineCharUnion = $8cedd6940ce3742d$export$60bd2eb6e5a75df0.join('|');
    var escapedRules = [
        '$'
    ];
    for(var idx = 0, len = wordBreaks.length; idx < len; idx++){
        var wordBreak = wordBreaks[idx];
        if ($8cedd6940ce3742d$export$3fc8feceeed3beb0(wordBreak)) throw new TypeError("`wordBreak` must not include " + newlineCharUnion);
        escapedRules.push(wordBreak === '' ? '.' : $8cedd6940ce3742d$export$7c57da42ce8e346f(wordBreak));
    }
    var breakRules = escapedRules.join('|');
    return new RegExp("(" + newlineCharUnion + ")|((.*?)(" + breakRules + "))", 'gm');
};
var $8cedd6940ce3742d$export$38936f7739928807 = function(text, wordBreaks, maxWidth, computeWidthOfText) {
    var regex = $8cedd6940ce3742d$var$buildWordBreakRegex(wordBreaks);
    var words = $8cedd6940ce3742d$export$6b5e57d20078142b(text).match(regex);
    var currLine = '';
    var currWidth = 0;
    var lines = [];
    var pushCurrLine = function() {
        if (currLine !== '') lines.push(currLine);
        currLine = '';
        currWidth = 0;
    };
    for(var idx = 0, len = words.length; idx < len; idx++){
        var word = words[idx];
        if ($8cedd6940ce3742d$export$3fc8feceeed3beb0(word)) pushCurrLine();
        else {
            var width = computeWidthOfText(word);
            if (currWidth + width > maxWidth) pushCurrLine();
            currLine += word;
            currWidth += width;
        }
    }
    pushCurrLine();
    return lines;
};
// See section "7.9.4 Dates" of the PDF specification
var $8cedd6940ce3742d$var$dateRegex = /^D:(\d\d\d\d)(\d\d)?(\d\d)?(\d\d)?(\d\d)?(\d\d)?([+\-Z])?(\d\d)?'?(\d\d)?'?$/;
var $8cedd6940ce3742d$export$6b862160d295c8e = function(dateStr) {
    var match = dateStr.match($8cedd6940ce3742d$var$dateRegex);
    if (!match) return undefined;
    var year = match[1], _a = match[2], month = _a === void 0 ? '01' : _a, _b = match[3], day = _b === void 0 ? '01' : _b, _c = match[4], hours = _c === void 0 ? '00' : _c, _d = match[5], mins = _d === void 0 ? '00' : _d, _e = match[6], secs = _e === void 0 ? '00' : _e, _f = match[7], offsetSign = _f === void 0 ? 'Z' : _f, _g = match[8], offsetHours = _g === void 0 ? '00' : _g, _h = match[9], offsetMins = _h === void 0 ? '00' : _h;
    // http://www.ecma-international.org/ecma-262/5.1/#sec-15.9.1.15
    var tzOffset = offsetSign === 'Z' ? 'Z' : "" + offsetSign + offsetHours + ":" + offsetMins;
    var date = new Date(year + "-" + month + "-" + day + "T" + hours + ":" + mins + ":" + secs + tzOffset);
    return date;
};
var $8cedd6940ce3742d$export$dc1d7d42f51764e3 = function(value, regex) {
    var _a;
    var position = 0;
    var lastMatch;
    while(position < value.length){
        var match = value.substring(position).match(regex);
        if (!match) return {
            match: lastMatch,
            pos: position
        };
        lastMatch = match;
        position += ((_a = match.index) !== null && _a !== void 0 ? _a : 0) + match[0].length;
    }
    return {
        match: lastMatch,
        pos: position
    };
};

});


parcelRegister("fAfk5", function(module, exports) {

$parcel$export(module.exports, "waitForTick", function () { return $b5861a9f1f349244$export$3b7198a3beef1a5f; });
/**
 * Returns a Promise that resolves after at least one tick of the
 * Macro Task Queue occurs.
 */ var $b5861a9f1f349244$export$3b7198a3beef1a5f = function() {
    return new Promise(function(resolve) {
        setTimeout(function() {
            return resolve();
        }, 0);
    });
};

});

parcelRegister("9ZNih", function(module, exports) {

$parcel$export(module.exports, "utf16Encode", function () { return $74700c4bc91628c1$export$73704d2337848c8e; });
$parcel$export(module.exports, "highSurrogate", function () { return $74700c4bc91628c1$export$8d3bd4086f36eaeb; });
$parcel$export(module.exports, "lowSurrogate", function () { return $74700c4bc91628c1$export$382051c72943492d; });
$parcel$export(module.exports, "isWithinBMP", function () { return $74700c4bc91628c1$export$919ae47c3852aa15; });
$parcel$export(module.exports, "hasSurrogates", function () { return $74700c4bc91628c1$export$d5ab89e7561b44ab; });
$parcel$export(module.exports, "utf16Decode", function () { return $74700c4bc91628c1$export$b89f54f9db637f79; });
$parcel$export(module.exports, "hasUtf16BOM", function () { return $74700c4bc91628c1$export$41e7c15c75b1b24d; });

var $c6a2W = parcelRequire("c6a2W");
var $74700c4bc91628c1$export$e1b32e613f230dc6 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xef, 0xbb, 0xbf);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // One byte encoding
        if (codePoint < 0x80) {
            var byte1 = codePoint & 0x7f;
            encoded.push(byte1);
            idx += 1;
        } else if (codePoint < 0x0800) {
            var byte1 = codePoint >> 6 & 0x1f | 0xc0;
            var byte2 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2);
            idx += 1;
        } else if (codePoint < 0x010000) {
            var byte1 = codePoint >> 12 & 0x0f | 0xe0;
            var byte2 = codePoint >> 6 & 0x3f | 0x80;
            var byte3 = codePoint & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3);
            idx += 1;
        } else if (codePoint < 0x110000) {
            var byte1 = codePoint >> 18 & 0x07 | 0xf0;
            var byte2 = codePoint >> 12 & 0x3f | 0x80;
            var byte3 = codePoint >> 6 & 0x3f | 0x80;
            var byte4 = codePoint >> 0 & 0x3f | 0x80;
            encoded.push(byte1, byte2, byte3, byte4);
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $c6a2W.toHexString)(codePoint));
    }
    return new Uint8Array(encoded);
};
var $74700c4bc91628c1$export$73704d2337848c8e = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    var encoded = [];
    if (byteOrderMark) encoded.push(0xfeff);
    for(var idx = 0, len = input.length; idx < len;){
        var codePoint = input.codePointAt(idx);
        // Two byte encoding
        if (codePoint < 0x010000) {
            encoded.push(codePoint);
            idx += 1;
        } else if (codePoint < 0x110000) {
            encoded.push($74700c4bc91628c1$export$8d3bd4086f36eaeb(codePoint), $74700c4bc91628c1$export$382051c72943492d(codePoint));
            idx += 2;
        } else throw new Error("Invalid code point: 0x" + (0, $c6a2W.toHexString)(codePoint));
    }
    return new Uint16Array(encoded);
};
var $74700c4bc91628c1$export$919ae47c3852aa15 = function(codePoint) {
    return codePoint >= 0 && codePoint <= 0xffff;
};
var $74700c4bc91628c1$export$d5ab89e7561b44ab = function(codePoint) {
    return codePoint >= 0x010000 && codePoint <= 0x10ffff;
};
var $74700c4bc91628c1$export$8d3bd4086f36eaeb = function(codePoint) {
    return Math.floor((codePoint - 0x10000) / 0x400) + 0xd800;
};
var $74700c4bc91628c1$export$382051c72943492d = function(codePoint) {
    return (codePoint - 0x10000) % 0x400 + 0xdc00;
};
var $74700c4bc91628c1$var$ByteOrder;
(function(ByteOrder) {
    ByteOrder["BigEndian"] = "BigEndian";
    ByteOrder["LittleEndian"] = "LittleEndian";
})($74700c4bc91628c1$var$ByteOrder || ($74700c4bc91628c1$var$ByteOrder = {}));
var $74700c4bc91628c1$var$REPLACEMENT = "\uFFFD".codePointAt(0);
var $74700c4bc91628c1$export$b89f54f9db637f79 = function(input, byteOrderMark) {
    if (byteOrderMark === void 0) byteOrderMark = true;
    // Need at least 2 bytes of data in UTF-16 encodings
    if (input.length <= 1) return String.fromCodePoint($74700c4bc91628c1$var$REPLACEMENT);
    var byteOrder = byteOrderMark ? $74700c4bc91628c1$var$readBOM(input) : $74700c4bc91628c1$var$ByteOrder.BigEndian;
    // Skip byte order mark if needed
    var idx = byteOrderMark ? 2 : 0;
    var codePoints = [];
    while(input.length - idx >= 2){
        var first = $74700c4bc91628c1$var$decodeValues(input[idx++], input[idx++], byteOrder);
        if ($74700c4bc91628c1$var$isHighSurrogate(first)) {
            if (input.length - idx < 2) // Need at least 2 bytes left for the low surrogate that is required
            codePoints.push($74700c4bc91628c1$var$REPLACEMENT);
            else {
                var second = $74700c4bc91628c1$var$decodeValues(input[idx++], input[idx++], byteOrder);
                if ($74700c4bc91628c1$var$isLowSurrogate(second)) codePoints.push(first, second);
                else // Low surrogates should always follow high surrogates
                codePoints.push($74700c4bc91628c1$var$REPLACEMENT);
            }
        } else if ($74700c4bc91628c1$var$isLowSurrogate(first)) {
            // High surrogates should always come first since `decodeValues()`
            // accounts for the byte ordering
            idx += 2;
            codePoints.push($74700c4bc91628c1$var$REPLACEMENT);
        } else codePoints.push(first);
    }
    // There shouldn't be extra byte(s) left over
    if (idx < input.length) codePoints.push($74700c4bc91628c1$var$REPLACEMENT);
    return String.fromCodePoint.apply(String, codePoints);
};
/**
 * Returns `true` if the given `codePoint` is a high surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $74700c4bc91628c1$var$isHighSurrogate = function(codePoint) {
    return codePoint >= 0xd800 && codePoint <= 0xdbff;
};
/**
 * Returns `true` if the given `codePoint` is a low surrogate.
 * @param codePoint The code point to be evaluated.
 *
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Description
 */ var $74700c4bc91628c1$var$isLowSurrogate = function(codePoint) {
    return codePoint >= 0xdc00 && codePoint <= 0xdfff;
};
/**
 * Decodes the given utf-16 values first and second using the specified
 * byte order.
 * @param first The first byte of the encoding.
 * @param second The second byte of the encoding.
 * @param byteOrder The byte order of the encoding.
 * Reference: https://en.wikipedia.org/wiki/UTF-16#Examples
 */ var $74700c4bc91628c1$var$decodeValues = function(first, second, byteOrder) {
    // Append the binary representation of the preceding byte by shifting the
    // first one 8 to the left and than applying a bitwise or-operator to append
    // the second one.
    if (byteOrder === $74700c4bc91628c1$var$ByteOrder.LittleEndian) return second << 8 | first;
    if (byteOrder === $74700c4bc91628c1$var$ByteOrder.BigEndian) return first << 8 | second;
    throw new Error("Invalid byteOrder: " + byteOrder);
};
/**
 * Returns whether the given array contains a byte order mark for the
 * UTF-16BE or UTF-16LE encoding. If it has neither, BigEndian is assumed.
 *
 * Reference: https://en.wikipedia.org/wiki/Byte_order_mark#UTF-16
 *
 * @param bytes The byte array to be evaluated.
 */ // prettier-ignore
var $74700c4bc91628c1$var$readBOM = function(bytes) {
    return $74700c4bc91628c1$var$hasUtf16BigEndianBOM(bytes) ? $74700c4bc91628c1$var$ByteOrder.BigEndian : $74700c4bc91628c1$var$hasUtf16LittleEndianBOM(bytes) ? $74700c4bc91628c1$var$ByteOrder.LittleEndian : $74700c4bc91628c1$var$ByteOrder.BigEndian;
};
var $74700c4bc91628c1$var$hasUtf16BigEndianBOM = function(bytes) {
    return bytes[0] === 0xfe && bytes[1] === 0xff;
};
var $74700c4bc91628c1$var$hasUtf16LittleEndianBOM = function(bytes) {
    return bytes[0] === 0xff && bytes[1] === 0xfe;
};
var $74700c4bc91628c1$export$41e7c15c75b1b24d = function(bytes) {
    return $74700c4bc91628c1$var$hasUtf16BigEndianBOM(bytes) || $74700c4bc91628c1$var$hasUtf16LittleEndianBOM(bytes);
};

});

parcelRegister("5ypEP", function(module, exports) {

$parcel$export(module.exports, "numberToString", function () { return $40b407c4ba1748d7$export$f67be9d9b0e25d7b; });
$parcel$export(module.exports, "sizeInBytes", function () { return $40b407c4ba1748d7$export$cc6acfd7a782614d; });
$parcel$export(module.exports, "bytesFor", function () { return $40b407c4ba1748d7$export$3c7962b7d5fa4e42; });
// tslint:disable radix
/**
 * Converts a number to its string representation in decimal. This function
 * differs from simply converting a number to a string with `.toString()`
 * because this function's output string will **not** contain exponential
 * notation.
 *
 * Credit: https://stackoverflow.com/a/46545519
 */ var $40b407c4ba1748d7$export$f67be9d9b0e25d7b = function(num) {
    var numStr = String(num);
    if (Math.abs(num) < 1.0) {
        var e = parseInt(num.toString().split('e-')[1]);
        if (e) {
            var negative = num < 0;
            if (negative) num *= -1;
            num *= Math.pow(10, e - 1);
            numStr = '0.' + new Array(e).join('0') + num.toString().substring(2);
            if (negative) numStr = '-' + numStr;
        }
    } else {
        var e = parseInt(num.toString().split('+')[1]);
        if (e > 20) {
            e -= 20;
            num /= Math.pow(10, e);
            numStr = num.toString() + new Array(e + 1).join('0');
        }
    }
    return numStr;
};
var $40b407c4ba1748d7$export$cc6acfd7a782614d = function(n) {
    return Math.ceil(n.toString(2).length / 8);
};
var $40b407c4ba1748d7$export$3c7962b7d5fa4e42 = function(n) {
    var bytes = new Uint8Array($40b407c4ba1748d7$export$cc6acfd7a782614d(n));
    for(var i = 1; i <= bytes.length; i++)bytes[i - 1] = n >> (bytes.length - i) * 8;
    return bytes;
};

});

parcelRegister("dXsOT", function(module, exports) {

$parcel$export(module.exports, "error", function () { return $a297241238331b21$export$a3bc9b8ed74fc; });
var $a297241238331b21$export$a3bc9b8ed74fc = function(msg) {
    throw new Error(msg);
};

});

parcelRegister("3JpTw", function(module, exports) {

$parcel$export(module.exports, "values", function () { return $2b79a931d9a3d4c1$export$68c286be0e7e55b7; });
$parcel$export(module.exports, "isStandardFont", function () { return $2b79a931d9a3d4c1$export$f2950432a4491977; });
$parcel$export(module.exports, "rectanglesAreEqual", function () { return $2b79a931d9a3d4c1$export$93263d7e9f52c023; });
parcelRequire("d2BN5");
var $4alS3 = parcelRequire("4alS3");
var $2b79a931d9a3d4c1$export$68c286be0e7e55b7 = function(obj) {
    return Object.keys(obj).map(function(k) {
        return obj[k];
    });
};
var $2b79a931d9a3d4c1$export$59252e21bbb61725 = $2b79a931d9a3d4c1$export$68c286be0e7e55b7((0, $4alS3.FontNames));
var $2b79a931d9a3d4c1$export$f2950432a4491977 = function(input) {
    return $2b79a931d9a3d4c1$export$59252e21bbb61725.includes(input);
};
var $2b79a931d9a3d4c1$export$93263d7e9f52c023 = function(a, b) {
    return a.x === b.x && a.y === b.y && a.width === b.width && a.height === b.height;
};

});
parcelRegister("d2BN5", function(module, exports) {
$parcel$export(module.exports, "Font", function () { return (parcelRequire("4alS3")).Font; });
$parcel$export(module.exports, "FontNames", function () { return (parcelRequire("4alS3")).FontNames; });
$parcel$export(module.exports, "Encodings", function () { return (parcelRequire("a7rt6")).Encodings; });
parcelRequire("4alS3");
parcelRequire("a7rt6");

});
parcelRegister("4alS3", function(module, exports) {

$parcel$export(module.exports, "FontNames", function () { return $30890fb05f326281$export$a1e7b970f5a14844; });
$parcel$export(module.exports, "Font", function () { return $30890fb05f326281$export$89abf52a030e56ee; });

var $gSkZj = parcelRequire("gSkZj");

var $ldWOI = parcelRequire("ldWOI");

var $8N3bv = parcelRequire("8N3bv");

var $aKyyR = parcelRequire("aKyyR");

var $7zgV3 = parcelRequire("7zgV3");

var $jJp2f = parcelRequire("jJp2f");

var $5hS71 = parcelRequire("5hS71");

var $iL1Ux = parcelRequire("iL1Ux");

var $fqn6X = parcelRequire("fqn6X");

var $e7blo = parcelRequire("e7blo");

var $iAjWf = parcelRequire("iAjWf");

var $5pEbO = parcelRequire("5pEbO");

var $cH3rT = parcelRequire("cH3rT");

var $dfWYq = parcelRequire("dfWYq");

var $1C8FV = parcelRequire("1C8FV");
// prettier-ignore
var $30890fb05f326281$var$compressedJsonForFontName = {
    'Courier': (0, (/*@__PURE__*/$parcel$interopDefault($7zgV3))),
    'Courier-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($ldWOI))),
    'Courier-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($aKyyR))),
    'Courier-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($8N3bv))),
    'Helvetica': (0, (/*@__PURE__*/$parcel$interopDefault($fqn6X))),
    'Helvetica-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($jJp2f))),
    'Helvetica-Oblique': (0, (/*@__PURE__*/$parcel$interopDefault($iL1Ux))),
    'Helvetica-BoldOblique': (0, (/*@__PURE__*/$parcel$interopDefault($5hS71))),
    'Times-Roman': (0, (/*@__PURE__*/$parcel$interopDefault($cH3rT))),
    'Times-Bold': (0, (/*@__PURE__*/$parcel$interopDefault($e7blo))),
    'Times-Italic': (0, (/*@__PURE__*/$parcel$interopDefault($5pEbO))),
    'Times-BoldItalic': (0, (/*@__PURE__*/$parcel$interopDefault($iAjWf))),
    'Symbol': (0, (/*@__PURE__*/$parcel$interopDefault($dfWYq))),
    'ZapfDingbats': (0, (/*@__PURE__*/$parcel$interopDefault($1C8FV)))
};
var $30890fb05f326281$export$a1e7b970f5a14844;
(function(FontNames) {
    FontNames["Courier"] = "Courier";
    FontNames["CourierBold"] = "Courier-Bold";
    FontNames["CourierOblique"] = "Courier-Oblique";
    FontNames["CourierBoldOblique"] = "Courier-BoldOblique";
    FontNames["Helvetica"] = "Helvetica";
    FontNames["HelveticaBold"] = "Helvetica-Bold";
    FontNames["HelveticaOblique"] = "Helvetica-Oblique";
    FontNames["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    FontNames["TimesRoman"] = "Times-Roman";
    FontNames["TimesRomanBold"] = "Times-Bold";
    FontNames["TimesRomanItalic"] = "Times-Italic";
    FontNames["TimesRomanBoldItalic"] = "Times-BoldItalic";
    FontNames["Symbol"] = "Symbol";
    FontNames["ZapfDingbats"] = "ZapfDingbats";
})($30890fb05f326281$export$a1e7b970f5a14844 || ($30890fb05f326281$export$a1e7b970f5a14844 = {}));
var $30890fb05f326281$var$fontCache = {};
var $30890fb05f326281$export$89abf52a030e56ee = /** @class */ function() {
    function Font() {
        var _this = this;
        this.getWidthOfGlyph = function(glyphName) {
            return _this.CharWidths[glyphName];
        };
        this.getXAxisKerningForPair = function(leftGlyphName, rightGlyphName) {
            return (_this.KernPairXAmounts[leftGlyphName] || {})[rightGlyphName];
        };
    }
    Font.load = function(fontName) {
        var cachedFont = $30890fb05f326281$var$fontCache[fontName];
        if (cachedFont) return cachedFont;
        var json = (0, $gSkZj.decompressJson)($30890fb05f326281$var$compressedJsonForFontName[fontName]);
        var font = Object.assign(new Font(), JSON.parse(json));
        font.CharWidths = font.CharMetrics.reduce(function(acc, metric) {
            acc[metric.N] = metric.WX;
            return acc;
        }, {});
        font.KernPairXAmounts = font.KernPairs.reduce(function(acc, _a) {
            var name1 = _a[0], name2 = _a[1], width = _a[2];
            if (!acc[name1]) acc[name1] = {};
            acc[name1][name2] = width;
            return acc;
        }, {});
        $30890fb05f326281$var$fontCache[fontName] = font;
        return font;
    };
    return Font;
}();

});
parcelRegister("gSkZj", function(module, exports) {

$parcel$export(module.exports, "decompressJson", function () { return $c491f840ba779862$export$134b8d792d6efd14; });
$parcel$export(module.exports, "padStart", function () { return $c491f840ba779862$export$36cf564d487b5178; });
/*
 * The `chars`, `lookup`, and `decodeFromBase64` members of this file are
 * licensed under the following:
 *
 *     base64-arraybuffer
 *     https://github.com/niklasvh/base64-arraybuffer
 *
 *     Copyright (c) 2012 Niklas von Hertzen
 *     Licensed under the MIT license.
 *
 */ 
var $czuCz = parcelRequire("czuCz");
var $c491f840ba779862$var$chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
// Use a lookup table to find the index.
var $c491f840ba779862$var$lookup = new Uint8Array(256);
for(var $c491f840ba779862$var$i = 0; $c491f840ba779862$var$i < $c491f840ba779862$var$chars.length; $c491f840ba779862$var$i++)$c491f840ba779862$var$lookup[$c491f840ba779862$var$chars.charCodeAt($c491f840ba779862$var$i)] = $c491f840ba779862$var$i;
var $c491f840ba779862$export$83edfd8fcc66ec17 = function(base64) {
    var bufferLength = base64.length * 0.75;
    var len = base64.length;
    var i;
    var p = 0;
    var encoded1;
    var encoded2;
    var encoded3;
    var encoded4;
    if (base64[base64.length - 1] === '=') {
        bufferLength--;
        if (base64[base64.length - 2] === '=') bufferLength--;
    }
    var bytes = new Uint8Array(bufferLength);
    for(i = 0; i < len; i += 4){
        encoded1 = $c491f840ba779862$var$lookup[base64.charCodeAt(i)];
        encoded2 = $c491f840ba779862$var$lookup[base64.charCodeAt(i + 1)];
        encoded3 = $c491f840ba779862$var$lookup[base64.charCodeAt(i + 2)];
        encoded4 = $c491f840ba779862$var$lookup[base64.charCodeAt(i + 3)];
        bytes[p++] = encoded1 << 2 | encoded2 >> 4;
        bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
        bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
    }
    return bytes;
};
var $c491f840ba779862$var$arrayToString = function(array) {
    var str = '';
    for(var i = 0; i < array.length; i++)str += String.fromCharCode(array[i]);
    return str;
};
var $c491f840ba779862$export$134b8d792d6efd14 = function(compressedJson) {
    return $c491f840ba779862$var$arrayToString((0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($c491f840ba779862$export$83edfd8fcc66ec17(compressedJson)));
};
var $c491f840ba779862$export$36cf564d487b5178 = function(value, length, padChar) {
    var padding = '';
    for(var idx = 0, len = length - value.length; idx < len; idx++)padding += padChar;
    return padding + value;
};

});
parcelRegister("czuCz", function(module, exports) {
// Top level file is just a mixin of submodules & constants
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");
var $9270819f8d10331c$require$assign = $8NmFQ.assign;

var $bg0pR = parcelRequire("bg0pR");

var $3VANP = parcelRequire("3VANP");

var $69DFd = parcelRequire("69DFd");
var $9270819f8d10331c$var$pako = {};
$9270819f8d10331c$require$assign($9270819f8d10331c$var$pako, $bg0pR, $3VANP, $69DFd);
module.exports = $9270819f8d10331c$var$pako;

});
parcelRegister("bg0pR", function(module, exports) {

$parcel$export(module.exports, "Deflate", function () { return $832182f77462420f$export$ae157b6234afe138; }, function (v) { return $832182f77462420f$export$ae157b6234afe138 = v; });
$parcel$export(module.exports, "deflate", function () { return $832182f77462420f$export$2316623ecd1285ab; }, function (v) { return $832182f77462420f$export$2316623ecd1285ab = v; });
$parcel$export(module.exports, "deflateRaw", function () { return $832182f77462420f$export$e95d6a8f69fb340a; }, function (v) { return $832182f77462420f$export$e95d6a8f69fb340a = v; });
$parcel$export(module.exports, "gzip", function () { return $832182f77462420f$export$69f0ea7cf3a331a8; }, function (v) { return $832182f77462420f$export$69f0ea7cf3a331a8 = v; });
var $832182f77462420f$export$ae157b6234afe138;
var $832182f77462420f$export$2316623ecd1285ab;
var $832182f77462420f$export$e95d6a8f69fb340a;
var $832182f77462420f$export$69f0ea7cf3a331a8;
'use strict';

var $jN9NG = parcelRequire("jN9NG");

var $8NmFQ = parcelRequire("8NmFQ");

var $cYEZc = parcelRequire("cYEZc");

var $d1Xv2 = parcelRequire("d1Xv2");

var $hJ3h6 = parcelRequire("hJ3h6");
var $832182f77462420f$var$toString = Object.prototype.toString;
/* Public constants ==========================================================*/ /* ===========================================================================*/ var $832182f77462420f$var$Z_NO_FLUSH = 0;
var $832182f77462420f$var$Z_FINISH = 4;
var $832182f77462420f$var$Z_OK = 0;
var $832182f77462420f$var$Z_STREAM_END = 1;
var $832182f77462420f$var$Z_SYNC_FLUSH = 2;
var $832182f77462420f$var$Z_DEFAULT_COMPRESSION = -1;
var $832182f77462420f$var$Z_DEFAULT_STRATEGY = 0;
var $832182f77462420f$var$Z_DEFLATED = 8;
/* ===========================================================================*/ /**
 * class Deflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[deflate]],
 * [[deflateRaw]] and [[gzip]].
 **/ /* internal
 * Deflate.chunks -> Array
 *
 * Chunks of output data, if [[Deflate#onData]] not overridden.
 **/ /**
 * Deflate.result -> Uint8Array|Array
 *
 * Compressed result, generated by default [[Deflate#onData]]
 * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
 * push a chunk with explicit flush (call [[Deflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Deflate.err -> Number
 *
 * Error code after deflate finished. 0 (Z_OK) on success.
 * You will not need it in real life, because deflate errors
 * are possible only on wrong options or bad `onData` / `onEnd`
 * custom handlers.
 **/ /**
 * Deflate.msg -> String
 *
 * Error message, if [[Deflate.err]] != 0
 **/ /**
 * new Deflate(options)
 * - options (Object): zlib deflate options.
 *
 * Creates new deflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `level`
 * - `windowBits`
 * - `memLevel`
 * - `strategy`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw deflate
 * - `gzip` (Boolean) - create gzip wrapper
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 * - `header` (Object) - custom header for gzip
 *   - `text` (Boolean) - true if compressed data believed to be text
 *   - `time` (Number) - modification time, unix timestamp
 *   - `os` (Number) - operation system code
 *   - `extra` (Array) - array of bytes with extra data (max 65536)
 *   - `name` (String) - file name (binary string)
 *   - `comment` (String) - comment (binary string)
 *   - `hcrc` (Boolean) - true if header crc should be added
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var deflate = new pako.Deflate({ level: 3});
 *
 * deflate.push(chunk1, false);
 * deflate.push(chunk2, true);  // true -> last chunk
 *
 * if (deflate.err) { throw new Error(deflate.err); }
 *
 * console.log(deflate.result);
 * ```
 **/ function $832182f77462420f$var$Deflate(options) {
    if (!(this instanceof $832182f77462420f$var$Deflate)) return new $832182f77462420f$var$Deflate(options);
    this.options = $8NmFQ.assign({
        level: $832182f77462420f$var$Z_DEFAULT_COMPRESSION,
        method: $832182f77462420f$var$Z_DEFLATED,
        chunkSize: 16384,
        windowBits: 15,
        memLevel: 8,
        strategy: $832182f77462420f$var$Z_DEFAULT_STRATEGY,
        to: ''
    }, options || {});
    var opt = this.options;
    if (opt.raw && opt.windowBits > 0) opt.windowBits = -opt.windowBits;
    else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) opt.windowBits += 16;
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $hJ3h6();
    this.strm.avail_out = 0;
    var status = $jN9NG.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
    if (status !== $832182f77462420f$var$Z_OK) throw new Error($d1Xv2[status]);
    if (opt.header) $jN9NG.deflateSetHeader(this.strm, opt.header);
    if (opt.dictionary) {
        var dict;
        // Convert data if needed
        if (typeof opt.dictionary === 'string') // If we need to compress text, change encoding to utf8.
        dict = $cYEZc.string2buf(opt.dictionary);
        else if ($832182f77462420f$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') dict = new Uint8Array(opt.dictionary);
        else dict = opt.dictionary;
        status = $jN9NG.deflateSetDictionary(this.strm, dict);
        if (status !== $832182f77462420f$var$Z_OK) throw new Error($d1Xv2[status]);
        this._dict_set = true;
    }
}
/**
 * Deflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
 *   converted to utf8 byte sequence.
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
 * new compressed chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the compression context.
 *
 * On fail call [[Deflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * array format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $832182f77462420f$var$Deflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var status, _mode;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $832182f77462420f$var$Z_FINISH : $832182f77462420f$var$Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // If we need to compress text, change encoding to utf8.
    strm.input = $cYEZc.string2buf(data);
    else if ($832182f77462420f$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $8NmFQ.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $jN9NG.deflate(strm, _mode); /* no bad return value */ 
        if (status !== $832182f77462420f$var$Z_STREAM_END && status !== $832182f77462420f$var$Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === $832182f77462420f$var$Z_FINISH || _mode === $832182f77462420f$var$Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') this.onData($cYEZc.buf2binstring($8NmFQ.shrinkBuf(strm.output, strm.next_out)));
            else this.onData($8NmFQ.shrinkBuf(strm.output, strm.next_out));
        }
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $832182f77462420f$var$Z_STREAM_END);
    // Finalize on the last chunk.
    if (_mode === $832182f77462420f$var$Z_FINISH) {
        status = $jN9NG.deflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $832182f77462420f$var$Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $832182f77462420f$var$Z_SYNC_FLUSH) {
        this.onEnd($832182f77462420f$var$Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Deflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $832182f77462420f$var$Deflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Deflate#onEnd(status) -> Void
 * - status (Number): deflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called once after you tell deflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $832182f77462420f$var$Deflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $832182f77462420f$var$Z_OK) {
        if (this.options.to === 'string') this.result = this.chunks.join('');
        else this.result = $8NmFQ.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * deflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * Compress `data` with deflate algorithm and `options`.
 *
 * Supported options are:
 *
 * - level
 * - windowBits
 * - memLevel
 * - strategy
 * - dictionary
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be "binary string"
 *    (each char code [0..255])
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
 *
 * console.log(pako.deflate(data));
 * ```
 **/ function $832182f77462420f$var$deflate(input, options) {
    var deflator = new $832182f77462420f$var$Deflate(options);
    deflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (deflator.err) throw deflator.msg || $d1Xv2[deflator.err];
    return deflator.result;
}
/**
 * deflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $832182f77462420f$var$deflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $832182f77462420f$var$deflate(input, options);
}
/**
 * gzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to compress.
 * - options (Object): zlib deflate options.
 *
 * The same as [[deflate]], but create gzip wrapper instead of
 * deflate one.
 **/ function $832182f77462420f$var$gzip(input, options) {
    options = options || {};
    options.gzip = true;
    return $832182f77462420f$var$deflate(input, options);
}
$832182f77462420f$export$ae157b6234afe138 = $832182f77462420f$var$Deflate;
$832182f77462420f$export$2316623ecd1285ab = $832182f77462420f$var$deflate;
$832182f77462420f$export$e95d6a8f69fb340a = $832182f77462420f$var$deflateRaw;
$832182f77462420f$export$69f0ea7cf3a331a8 = $832182f77462420f$var$gzip;

});
parcelRegister("cYEZc", function(module, exports) {

$parcel$export(module.exports, "string2buf", function () { return $972ae1a1019084e0$export$7a4c1b2f775b5a9f; }, function (v) { return $972ae1a1019084e0$export$7a4c1b2f775b5a9f = v; });
$parcel$export(module.exports, "buf2binstring", function () { return $972ae1a1019084e0$export$a751fe64af8a9a51; }, function (v) { return $972ae1a1019084e0$export$a751fe64af8a9a51 = v; });
$parcel$export(module.exports, "binstring2buf", function () { return $972ae1a1019084e0$export$1d1a7119601ff18c; }, function (v) { return $972ae1a1019084e0$export$1d1a7119601ff18c = v; });
$parcel$export(module.exports, "buf2string", function () { return $972ae1a1019084e0$export$49a50563f377746; }, function (v) { return $972ae1a1019084e0$export$49a50563f377746 = v; });
$parcel$export(module.exports, "utf8border", function () { return $972ae1a1019084e0$export$53dee3f58a714214; }, function (v) { return $972ae1a1019084e0$export$53dee3f58a714214 = v; });
// String encode/decode helpers
// convert string to array (typed, when possible)
var $972ae1a1019084e0$export$7a4c1b2f775b5a9f;
// Convert byte array to binary string
var $972ae1a1019084e0$export$a751fe64af8a9a51;
// Convert binary string (typed, when possible)
var $972ae1a1019084e0$export$1d1a7119601ff18c;
// convert array to string
var $972ae1a1019084e0$export$49a50563f377746;
// Calculate max possible position in utf8 buffer,
// that will not break sequence. If that's not possible
// - (very small limits) return max size as is.
//
// buf[] - utf8 bytes array
// max   - length limit (mandatory);
var $972ae1a1019084e0$export$53dee3f58a714214;
'use strict';

var $8NmFQ = parcelRequire("8NmFQ");
// Quick check if we can use fast array to bin string conversion
//
// - apply(Array) can fail on Android 2.2
// - apply(Uint8Array) can fail on iOS 5.1 Safari
//
var $972ae1a1019084e0$var$STR_APPLY_OK = true;
var $972ae1a1019084e0$var$STR_APPLY_UIA_OK = true;
try {
    String.fromCharCode.apply(null, [
        0
    ]);
} catch (__) {
    $972ae1a1019084e0$var$STR_APPLY_OK = false;
}
try {
    String.fromCharCode.apply(null, new Uint8Array(1));
} catch (__) {
    $972ae1a1019084e0$var$STR_APPLY_UIA_OK = false;
}
// Table with utf8 lengths (calculated by first byte of sequence)
// Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
// because max possible codepoint is 0x10ffff
var $972ae1a1019084e0$var$_utf8len = new $8NmFQ.Buf8(256);
for(var $972ae1a1019084e0$var$q = 0; $972ae1a1019084e0$var$q < 256; $972ae1a1019084e0$var$q++)$972ae1a1019084e0$var$_utf8len[$972ae1a1019084e0$var$q] = $972ae1a1019084e0$var$q >= 252 ? 6 : $972ae1a1019084e0$var$q >= 248 ? 5 : $972ae1a1019084e0$var$q >= 240 ? 4 : $972ae1a1019084e0$var$q >= 224 ? 3 : $972ae1a1019084e0$var$q >= 192 ? 2 : 1;
$972ae1a1019084e0$var$_utf8len[254] = $972ae1a1019084e0$var$_utf8len[254] = 1; // Invalid sequence start
$972ae1a1019084e0$export$7a4c1b2f775b5a9f = function(str) {
    var buf, c, c2, m_pos, i, str_len = str.length, buf_len = 0;
    // count binary size
    for(m_pos = 0; m_pos < str_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
    }
    // allocate buffer
    buf = new $8NmFQ.Buf8(buf_len);
    // convert
    for(i = 0, m_pos = 0; i < buf_len; m_pos++){
        c = str.charCodeAt(m_pos);
        if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
                c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
                m_pos++;
            }
        }
        if (c < 0x80) /* one byte */ buf[i++] = c;
        else if (c < 0x800) {
            /* two bytes */ buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
        } else if (c < 0x10000) {
            /* three bytes */ buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        } else {
            /* four bytes */ buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
        }
    }
    return buf;
};
// Helper (used in 2 places)
function $972ae1a1019084e0$var$buf2binstring(buf, len) {
    // On Chrome, the arguments in a function call that are allowed is `65534`.
    // If the length of the buffer is smaller than that, we can use this optimization,
    // otherwise we will take a slower path.
    if (len < 65534) {
        if (buf.subarray && $972ae1a1019084e0$var$STR_APPLY_UIA_OK || !buf.subarray && $972ae1a1019084e0$var$STR_APPLY_OK) return String.fromCharCode.apply(null, $8NmFQ.shrinkBuf(buf, len));
    }
    var result = '';
    for(var i = 0; i < len; i++)result += String.fromCharCode(buf[i]);
    return result;
}
$972ae1a1019084e0$export$a751fe64af8a9a51 = function(buf) {
    return $972ae1a1019084e0$var$buf2binstring(buf, buf.length);
};
$972ae1a1019084e0$export$1d1a7119601ff18c = function(str) {
    var buf = new $8NmFQ.Buf8(str.length);
    for(var i = 0, len = buf.length; i < len; i++)buf[i] = str.charCodeAt(i);
    return buf;
};
$972ae1a1019084e0$export$49a50563f377746 = function(buf, max) {
    var i, out, c, c_len;
    var len = max || buf.length;
    // Reserve max possible length (2 words per char)
    // NB: by unknown reasons, Array is significantly faster for
    //     String.fromCharCode.apply than Uint16Array.
    var utf16buf = new Array(len * 2);
    for(out = 0, i = 0; i < len;){
        c = buf[i++];
        // quick process ascii
        if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
        }
        c_len = $972ae1a1019084e0$var$_utf8len[c];
        // skip 5 & 6 byte codes
        if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
        }
        // apply mask on first byte
        c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
        // join the rest
        while(c_len > 1 && i < len){
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
        }
        // terminated by end of string?
        if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
        }
        if (c < 0x10000) utf16buf[out++] = c;
        else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
        }
    }
    return $972ae1a1019084e0$var$buf2binstring(utf16buf, out);
};
$972ae1a1019084e0$export$53dee3f58a714214 = function(buf, max) {
    var pos;
    max = max || buf.length;
    if (max > buf.length) max = buf.length;
    // go back from last position, until start of sequence found
    pos = max - 1;
    while(pos >= 0 && (buf[pos] & 0xC0) === 0x80)pos--;
    // Very small and broken sequence,
    // return max, because we should return something anyway.
    if (pos < 0) return max;
    // If we came to start of buffer - that means buffer is too small,
    // return max too.
    if (pos === 0) return max;
    return pos + $972ae1a1019084e0$var$_utf8len[buf[pos]] > max ? pos : max;
};

});


parcelRegister("3VANP", function(module, exports) {

$parcel$export(module.exports, "Inflate", function () { return $2dc33e31736e39e2$export$d1de70a877d6e43c; }, function (v) { return $2dc33e31736e39e2$export$d1de70a877d6e43c = v; });
$parcel$export(module.exports, "inflate", function () { return $2dc33e31736e39e2$export$cae1ce83fe4a1782; }, function (v) { return $2dc33e31736e39e2$export$cae1ce83fe4a1782 = v; });
$parcel$export(module.exports, "inflateRaw", function () { return $2dc33e31736e39e2$export$d0f0aa2d05c905c5; }, function (v) { return $2dc33e31736e39e2$export$d0f0aa2d05c905c5 = v; });
$parcel$export(module.exports, "ungzip", function () { return $2dc33e31736e39e2$export$95adf9d270383091; }, function (v) { return $2dc33e31736e39e2$export$95adf9d270383091 = v; });
/**
 * ungzip(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Just shortcut to [[inflate]], because it autodetects format
 * by header.content. Done for convenience.
 **/ var $2dc33e31736e39e2$export$d1de70a877d6e43c;
var $2dc33e31736e39e2$export$cae1ce83fe4a1782;
var $2dc33e31736e39e2$export$d0f0aa2d05c905c5;
var $2dc33e31736e39e2$export$95adf9d270383091;
'use strict';

var $582gc = parcelRequire("582gc");

var $8NmFQ = parcelRequire("8NmFQ");

var $cYEZc = parcelRequire("cYEZc");

var $69DFd = parcelRequire("69DFd");

var $d1Xv2 = parcelRequire("d1Xv2");

var $hJ3h6 = parcelRequire("hJ3h6");

var $7Yyze = parcelRequire("7Yyze");
var $2dc33e31736e39e2$var$toString = Object.prototype.toString;
/**
 * class Inflate
 *
 * Generic JS-style wrapper for zlib calls. If you don't need
 * streaming behaviour - use more simple functions: [[inflate]]
 * and [[inflateRaw]].
 **/ /* internal
 * inflate.chunks -> Array
 *
 * Chunks of output data, if [[Inflate#onData]] not overridden.
 **/ /**
 * Inflate.result -> Uint8Array|Array|String
 *
 * Uncompressed result, generated by default [[Inflate#onData]]
 * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
 * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
 * push a chunk with explicit flush (call [[Inflate#push]] with
 * `Z_SYNC_FLUSH` param).
 **/ /**
 * Inflate.err -> Number
 *
 * Error code after inflate finished. 0 (Z_OK) on success.
 * Should be checked if broken data possible.
 **/ /**
 * Inflate.msg -> String
 *
 * Error message, if [[Inflate.err]] != 0
 **/ /**
 * new Inflate(options)
 * - options (Object): zlib inflate options.
 *
 * Creates new inflator instance with specified params. Throws exception
 * on bad params. Supported options:
 *
 * - `windowBits`
 * - `dictionary`
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information on these.
 *
 * Additional options, for internal needs:
 *
 * - `chunkSize` - size of generated data chunks (16K by default)
 * - `raw` (Boolean) - do raw inflate
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 * By default, when no options set, autodetect deflate/gzip data format via
 * wrapper header.
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
 *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
 *
 * var inflate = new pako.Inflate({ level: 3});
 *
 * inflate.push(chunk1, false);
 * inflate.push(chunk2, true);  // true -> last chunk
 *
 * if (inflate.err) { throw new Error(inflate.err); }
 *
 * console.log(inflate.result);
 * ```
 **/ function $2dc33e31736e39e2$var$Inflate(options) {
    if (!(this instanceof $2dc33e31736e39e2$var$Inflate)) return new $2dc33e31736e39e2$var$Inflate(options);
    this.options = $8NmFQ.assign({
        chunkSize: 16384,
        windowBits: 0,
        to: ''
    }, options || {});
    var opt = this.options;
    // Force window size for `raw` data, if not set directly,
    // because we have no header for autodetect.
    if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
        opt.windowBits = -opt.windowBits;
        if (opt.windowBits === 0) opt.windowBits = -15;
    }
    // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
    if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) opt.windowBits += 32;
    // Gzip header has no info about windows size, we can do autodetect only
    // for deflate. So, if window size not set, force it to max when gzip possible
    if (opt.windowBits > 15 && opt.windowBits < 48) // bit 3 (16) -> gzipped data
    // bit 4 (32) -> autodetect gzip/deflate
    {
        if ((opt.windowBits & 15) === 0) opt.windowBits |= 15;
    }
    this.err = 0; // error code, if happens (0 = Z_OK)
    this.msg = ''; // error message
    this.ended = false; // used to avoid multiple onEnd() calls
    this.chunks = []; // chunks of compressed data
    this.strm = new $hJ3h6();
    this.strm.avail_out = 0;
    var status = $582gc.inflateInit2(this.strm, opt.windowBits);
    if (status !== $69DFd.Z_OK) throw new Error($d1Xv2[status]);
    this.header = new $7Yyze();
    $582gc.inflateGetHeader(this.strm, this.header);
    // Setup dictionary
    if (opt.dictionary) {
        // Convert data if needed
        if (typeof opt.dictionary === 'string') opt.dictionary = $cYEZc.string2buf(opt.dictionary);
        else if ($2dc33e31736e39e2$var$toString.call(opt.dictionary) === '[object ArrayBuffer]') opt.dictionary = new Uint8Array(opt.dictionary);
        if (opt.raw) {
            status = $582gc.inflateSetDictionary(this.strm, opt.dictionary);
            if (status !== $69DFd.Z_OK) throw new Error($d1Xv2[status]);
        }
    }
}
/**
 * Inflate#push(data[, mode]) -> Boolean
 * - data (Uint8Array|Array|ArrayBuffer|String): input data
 * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
 *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` means Z_FINISH.
 *
 * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
 * new output chunks. Returns `true` on success. The last data block must have
 * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
 * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
 * can use mode Z_SYNC_FLUSH, keeping the decompression context.
 *
 * On fail call [[Inflate#onEnd]] with error code and return false.
 *
 * We strongly recommend to use `Uint8Array` on input for best speed (output
 * format is detected automatically). Also, don't skip last param and always
 * use the same type in your code (boolean or number). That will improve JS speed.
 *
 * For regular `Array`-s make sure all elements are [0..255].
 *
 * ##### Example
 *
 * ```javascript
 * push(chunk, false); // push one of data chunks
 * ...
 * push(chunk, true);  // push last chunk
 * ```
 **/ $2dc33e31736e39e2$var$Inflate.prototype.push = function(data, mode) {
    var strm = this.strm;
    var chunkSize = this.options.chunkSize;
    var dictionary = this.options.dictionary;
    var status, _mode;
    var next_out_utf8, tail, utf8str;
    // Flag to properly process Z_BUF_ERROR on testing inflate call
    // when we check that all output data was flushed.
    var allowBufError = false;
    if (this.ended) return false;
    _mode = mode === ~~mode ? mode : mode === true ? $69DFd.Z_FINISH : $69DFd.Z_NO_FLUSH;
    // Convert data if needed
    if (typeof data === 'string') // Only binary strings can be decompressed on practice
    strm.input = $cYEZc.binstring2buf(data);
    else if ($2dc33e31736e39e2$var$toString.call(data) === '[object ArrayBuffer]') strm.input = new Uint8Array(data);
    else strm.input = data;
    strm.next_in = 0;
    strm.avail_in = strm.input.length;
    do {
        if (strm.avail_out === 0) {
            strm.output = new $8NmFQ.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
        }
        status = $582gc.inflate(strm, $69DFd.Z_NO_FLUSH); /* no bad return value */ 
        if (status === $69DFd.Z_NEED_DICT && dictionary) status = $582gc.inflateSetDictionary(this.strm, dictionary);
        if (status === $69DFd.Z_BUF_ERROR && allowBufError === true) {
            status = $69DFd.Z_OK;
            allowBufError = false;
        }
        if (status !== $69DFd.Z_STREAM_END && status !== $69DFd.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
        }
        if (strm.next_out) {
            if (strm.avail_out === 0 || status === $69DFd.Z_STREAM_END || strm.avail_in === 0 && (_mode === $69DFd.Z_FINISH || _mode === $69DFd.Z_SYNC_FLUSH)) {
                if (this.options.to === 'string') {
                    next_out_utf8 = $cYEZc.utf8border(strm.output, strm.next_out);
                    tail = strm.next_out - next_out_utf8;
                    utf8str = $cYEZc.buf2string(strm.output, next_out_utf8);
                    // move tail
                    strm.next_out = tail;
                    strm.avail_out = chunkSize - tail;
                    if (tail) $8NmFQ.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                    this.onData(utf8str);
                } else this.onData($8NmFQ.shrinkBuf(strm.output, strm.next_out));
            }
        }
        // When no more input data, we should check that internal inflate buffers
        // are flushed. The only way to do it when avail_out = 0 - run one more
        // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
        // Here we set flag to process this error properly.
        //
        // NOTE. Deflate does not return error in this case and does not needs such
        // logic.
        if (strm.avail_in === 0 && strm.avail_out === 0) allowBufError = true;
    }while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== $69DFd.Z_STREAM_END);
    if (status === $69DFd.Z_STREAM_END) _mode = $69DFd.Z_FINISH;
    // Finalize on the last chunk.
    if (_mode === $69DFd.Z_FINISH) {
        status = $582gc.inflateEnd(this.strm);
        this.onEnd(status);
        this.ended = true;
        return status === $69DFd.Z_OK;
    }
    // callback interim results if Z_SYNC_FLUSH.
    if (_mode === $69DFd.Z_SYNC_FLUSH) {
        this.onEnd($69DFd.Z_OK);
        strm.avail_out = 0;
        return true;
    }
    return true;
};
/**
 * Inflate#onData(chunk) -> Void
 * - chunk (Uint8Array|Array|String): output data. Type of array depends
 *   on js engine support. When string output requested, each chunk
 *   will be string.
 *
 * By default, stores data blocks in `chunks[]` property and glue
 * those in `onEnd`. Override this handler, if you need another behaviour.
 **/ $2dc33e31736e39e2$var$Inflate.prototype.onData = function(chunk) {
    this.chunks.push(chunk);
};
/**
 * Inflate#onEnd(status) -> Void
 * - status (Number): inflate status. 0 (Z_OK) on success,
 *   other if not.
 *
 * Called either after you tell inflate that the input stream is
 * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
 * or if an error happened. By default - join collected chunks,
 * free memory and fill `results` / `err` properties.
 **/ $2dc33e31736e39e2$var$Inflate.prototype.onEnd = function(status) {
    // On success - join
    if (status === $69DFd.Z_OK) {
        if (this.options.to === 'string') // Glue & convert here, until we teach pako to send
        // utf8 aligned strings to onData
        this.result = this.chunks.join('');
        else this.result = $8NmFQ.flattenChunks(this.chunks);
    }
    this.chunks = [];
    this.err = status;
    this.msg = this.strm.msg;
};
/**
 * inflate(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * Decompress `data` with inflate/ungzip and `options`. Autodetect
 * format via wrapper header by default. That's why we don't provide
 * separate `ungzip` method.
 *
 * Supported options are:
 *
 * - windowBits
 *
 * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
 * for more information.
 *
 * Sugar (options):
 *
 * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
 *   negative windowBits implicitly.
 * - `to` (String) - if equal to 'string', then result will be converted
 *   from utf8 to utf16 (javascript) string. When string output requested,
 *   chunk length can differ from `chunkSize`, depending on content.
 *
 *
 * ##### Example:
 *
 * ```javascript
 * var pako = require('pako')
 *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
 *   , output;
 *
 * try {
 *   output = pako.inflate(input);
 * } catch (err)
 *   console.log(err);
 * }
 * ```
 **/ function $2dc33e31736e39e2$var$inflate(input, options) {
    var inflator = new $2dc33e31736e39e2$var$Inflate(options);
    inflator.push(input, true);
    // That will never happens, if you don't cheat with options :)
    if (inflator.err) throw inflator.msg || $d1Xv2[inflator.err];
    return inflator.result;
}
/**
 * inflateRaw(data[, options]) -> Uint8Array|Array|String
 * - data (Uint8Array|Array|String): input data to decompress.
 * - options (Object): zlib inflate options.
 *
 * The same as [[inflate]], but creates raw data, without wrapper
 * (header and adler32 crc).
 **/ function $2dc33e31736e39e2$var$inflateRaw(input, options) {
    options = options || {};
    options.raw = true;
    return $2dc33e31736e39e2$var$inflate(input, options);
}
$2dc33e31736e39e2$export$d1de70a877d6e43c = $2dc33e31736e39e2$var$Inflate;
$2dc33e31736e39e2$export$cae1ce83fe4a1782 = $2dc33e31736e39e2$var$inflate;
$2dc33e31736e39e2$export$d0f0aa2d05c905c5 = $2dc33e31736e39e2$var$inflateRaw;
$2dc33e31736e39e2$export$95adf9d270383091 = $2dc33e31736e39e2$var$inflate;

});
parcelRegister("7Yyze", function(module, exports) {
'use strict';
// (C) 1995-2013 Jean-loup Gailly and Mark Adler
// (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
//
// This software is provided 'as-is', without any express or implied
// warranty. In no event will the authors be held liable for any damages
// arising from the use of this software.
//
// Permission is granted to anyone to use this software for any purpose,
// including commercial applications, and to alter it and redistribute it
// freely, subject to the following restrictions:
//
// 1. The origin of this software must not be misrepresented; you must not
//   claim that you wrote the original software. If you use this software
//   in a product, an acknowledgment in the product documentation would be
//   appreciated but is not required.
// 2. Altered source versions must be plainly marked as such, and must not be
//   misrepresented as being the original software.
// 3. This notice may not be removed or altered from any source distribution.
function $5ce8f35425db586e$var$GZheader() {
    /* true if compressed data believed to be text */ this.text = 0;
    /* modification time */ this.time = 0;
    /* extra flags (not used when writing a gzip file) */ this.xflags = 0;
    /* operating system */ this.os = 0;
    /* pointer to extra field or Z_NULL if none */ this.extra = null;
    /* extra field length (valid if extra != Z_NULL) */ this.extra_len = 0; // Actually, we don't need it in JS,
    // but leave for few code modifications
    //
    // Setup limits is not necessary because in js we should not preallocate memory
    // for inflate use constant limit in 65536 bytes
    //
    /* space at extra (only when reading header) */ // this.extra_max  = 0;
    /* pointer to zero-terminated file name or Z_NULL */ this.name = '';
    /* space at name (only when reading header) */ // this.name_max   = 0;
    /* pointer to zero-terminated comment or Z_NULL */ this.comment = '';
    /* space at comment (only when reading header) */ // this.comm_max   = 0;
    /* true if there was or will be a header crc */ this.hcrc = 0;
    /* true when done reading gzip header (not used when writing a gzip file) */ this.done = false;
}
module.exports = $5ce8f35425db586e$var$GZheader;

});




parcelRegister("ldWOI", function(module, exports) {
module.exports = JSON.parse("\"eJyFWdtyGjkQ/RVqnnar8Bb4lpg3jEnCxgEvGDtxKg9iphm01oyILrZxKv++mrGd3az6KC8UnNa0+nrUGr5lI11VVLtskF198FaU1Dns9w9OOkf7/ePDrJu90bWbiorCgpH2RpLZO9WqaCReqZ8lnReJqKTa/SwL8DXJctPs9Lxs4oSS+bAuVVjXC7/tG/lAxYV0+SYbOOOpm402wojckVlQ8+T4wVFdUDHXlaifrTs91Q/Z4PNeMLu7t3/U6746POm+7vW/dLNlWGuUrOlCW+mkrrPBXr/X+4/gciPz25qszQbhyeyKjG2XZb3ewR+9Xi/sMdVO5k+ebHemcaHzW/57p3/y+qQbPk967We//TxoP191hoVeUWexs44q25nUuTZbbYSj4o9OZ6hUZ97osZ05WTJ3AQ37jMOqQtblIt9QG7lWycKJuhCmeJGGhSOxffccyqPj/W728eXX4cFJNxvavAmRyQbH++HnGf34vdc/etXNFq54d50NXh+2X6/C137v+CnQH8gZmYdQfP6WXX8MCppQTYMlditCBL53/wfTQ65EFeNfvQ6erlQsqX21akJc1rGs0EoJE+NbMnlToZFAVEFkQ3iABW2uGH3CUK1ojUTgMWEbjfaWeUp5G6N5aCwRw5vddkOM98EVqRlPrBJ2E8OPZHSM6prJkrtnVrqNIWbtOjQrg8o7Zq2VDwxId5x3xMe0lpzBuVaa0WGpkkCkmgaON/3qBVODpaHQiIybXz3ZliTi3DO2D2PoNIZGMXQWQ+MYehNDb2PoXQxNYujPGHofQ+cx9CGGpjE0i6GLGPorhuYxtIihyxhaxtBVDF3H0McY+hRDNzG0CqfQLTmeNlZBBvr0+TnIKbmUuTS5Z1jUN6xtw8nBtEjLb7wxDOesmB5j+JfpIIYLmIZiWC6GZAz9HUMMvTItzESL6VqG9rZMKGOI4QaGXpjY+xi6i6H7GGKYdMeQPl9foBBW3GHark9Vo5OqgEd9oe+ZOPOnc3NcqmZgiUuomehYnt1xZ8daaSPZ8wBoyb0Jx3jOBLBtGyvbiRNOLXw0Sy+DpNKAAhpxq/gXYhD6NdMda6bwwyTH0kwhypI70p5wdhR7Gjia3JEhpvfDLCRKI7YcqYXJnxgv/g3vSthEhNNSEKIfCQByUkpurWQaNXjqNtqjSfHp0OdLOwSAG31E7h03uLRMvlbEtDPoq0rkhqvhlSFu40I7kfP9VoRLFrH+G7YLcypCQLkJ1delML5SwjPb6DIMmQxL54L1gyq+YIfMyKNNsQ4zHj8UnoMDdoZwfoMqkJxX7A6Cj3czWzLdqcC+GuGM9tCa4RobSp5J2gTnk0D5CVA0Pp1RAqn7hC0o5J3kqvkTsGyY6gwBHlqmHtqBh2x77UI9QimVS75PljgMAjXDEljn0QNjvMlZIAju/pF0NH95VcFshSgnB3Ug+LhMkwYoVKOAUS+T2kZIG2DVcYInLXDTQkKUYHelH6kuGcEcbPE26aRPNklKOEQpNcCQHPp6k4jc5UYbRtkM7T4HcVsAvADWLtEGnq/M9t2G9e2Aw8xEM1CCQ4QDWq28cnKrmDHTAwcvgYNh1HJSqEKumdvVDlPDFOwjU8UyTpZZ4tTBohzYUSMaRAmdggBNgKLmzVsYGLjXbyujb6lm70CGSmnB1PsWJHuSYhQfupq/ioxBTRngkEaRuQEP3ICIPb/kAq/Axo6ZUEaQFFSStxwa/eDpiARDND4kqhIE+BG1Btp7hjKCjh6UKYt2xk7MkmMJ8PCMlGNy5XiSdvc6wYjYtIp5pSGBRTo9Z45R6Asw4bQ8HgrYhEJmTFsk6pWvyPfJOj4HiXNGFFQJw1hOCVaYgChNUOGcA6tD0DZCMSdDczMBDa5TFVWDqWn5i/yB+BByqARcGhx6ziqXVD4Ii2TqZmnLi8AS3L8dGqRoBIzwkM0LmXNpOAOKTNKbKciPBvg8XdZJ6RDoHEKO5meuGdDzmOiQMTrt0d63SVfAIDBJtgIwwaUvN7ps8l1r7v0I5lKPRUEV+rcqfaHlDvJH4FSdVBVCjk8IiXp87Jv/Ib90s/dk6gshTfPv8Zfv/wDUfBK2\"");

});

parcelRegister("8N3bv", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("aKyyR", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("7zgV3", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("jJp2f", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("5hS71", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("iL1Ux", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("fqn6X", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("e7blo", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("iAjWf", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("5pEbO", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("cH3rT", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("dfWYq", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});

parcelRegister("1C8FV", function(module, exports) {
module.exports = JSON.parse("\"eJxtmNtu20YQhl+F4FULyMGeD7pz3AY1ChtG7NpFA18w1NomIlECSRcxgrx7SVk7+wOdG8H5OJydf2Z2d5gf9cV+t0v9VK/r+6vXsXlOlbHe28paq229qj/t++m62aXZ4J/m8PRb1z9/baZxefK63Z6eXN5dVMvTCh83u277xr/6kLrnl2XNq7TpXnczuZyabdee98/b2VzM/x4/dd/T5qab2pd6PQ2vaVVfvDRD005puE3Lu7eH1HbN9hTjx4/77/X6y5lcnUmjVzHIVVDicVX/1W/SsO36dLMfu6nb9/X6TAoBD+5euvZbn8axXtuZ36dhPJrVQqgPQoh5hev91LWLkIv94W1Ygq9+aX+tZAx2tfz64284/sblN/rqfLP/mqrbt3FKu7G67Nv9cNgPzZQ2H6rz7bb6vLgZq89pTMO/M/xfEqturJpqSM/d7GJIm2oamk3aNcO3av80O5xh3yyKmm1193ZIT02bqovTKjP+MAf++7zsZvZ3276kYyWWXB0z99S18/PbafPHQ71W4fjn/fxnFO+ZvkrT0LVzTr78qB/+nk38bHM9exgP8zr1z9U7jt6840YW5uSJKcZOCaBBnKgm5mU8MVNYyMwWFvO7Ukagkmgg6sDWQ5yFFqjzUrLEaQ3BEmiwNsMSaZS0vgWfOkPHWQowNeTUc0kumnxZvsgPxlGai6VTGUqAVCTQ6QkWnc77DKEiLktSUBJKqHIQZ86d8gCpHYoiEzMsb1ubYy8vW50DChB5ZhGqrijD0EqUIeiaEHIfCg5Kpuu0ApiToaGPSY0uaQsyr65L2oKi1yFt1PLaQ3lzfXTgXodGoJYzglndSLDMPg1sTPJpQJHJigw0QrGERqD9YhyTOgONQDUyuF1zaxuokc/BW2ztXCMrGZ9WMW1oQZHIXWNBkSCfRZEL5BMUiZw6CzVSFCfUSGZFNjIldoKDkonTKQiJIGzWmFd3BizJJ9SINoLDriOfUCOZS+zg+KGD1qGiLNMLxtJD1/ns00ON6EzyUCM6vbxhoBKaqbG3DFQCNiL1iHccBPV0DHhQH/JW8EW90dkyFKGywCJU0WkVSvSGeiSUODWFFD0HYdPQVoiRgfPMA+/nnRgiAyNYSjpWNQcNSMrtFCUH4ZIRpSCWocFCSuhCEY6hoUClc0WC52BJlCYYLQdhN+hygRRRlo5BKRRLS6oihSqh+ZzzRGG1Mo4Iz1LoP0qsxDGFzk0JE42ji0jCPejomJKCuwil4m5CiRMEUMVSzVLDUstSx1Juc0oVWMpqY295qVltmtWmWW2a1aZZbZrVplltmtWmWW2G1WZYbYbVZlhthtVmWG2G1WZYbYbVZlhtltVmWW2W1WZZbZbVZlltltVmWW2W1QYjQCh7E2aAQHeGhCFgPoNoy8KNb2wxBhmGKBxoUZXlLGsLI6AsftEDHV0wIURVbANLcTKlGGBIKPOAxCmhePCKUwFzAmpDFRQvjA9R06Hq8TONvshgKDCuRAZTXigUxjxNFfKRo3CLhnIJBMFRvMZpqpNBMlQJzGT5WFQMVQI/AikPMIhEU1aDjqJvQwmjSHB05cC9jbYwc5UtAHNLhDw41ha+lEqF4JaH3gmB61SYcqInxTDmQK8v08vjqv4zDf1N0w3Lf4A8/vwPpfK11w==\"");

});


parcelRegister("a7rt6", function(module, exports) {

$parcel$export(module.exports, "Encodings", function () { return $75dfdd80b14771e3$export$c85030bb86979d84; });
/* tslint:disable max-classes-per-file */ 
var $gSkZj = parcelRequire("gSkZj");

var $6cMRN = parcelRequire("6cMRN");
var $75dfdd80b14771e3$var$decompressedEncodings = (0, $gSkZj.decompressJson)((0, (/*@__PURE__*/$parcel$interopDefault($6cMRN))));
var $75dfdd80b14771e3$var$allUnicodeMappings = JSON.parse($75dfdd80b14771e3$var$decompressedEncodings);
var $75dfdd80b14771e3$var$Encoding = /** @class */ function() {
    function Encoding(name, unicodeMappings) {
        var _this = this;
        this.canEncodeUnicodeCodePoint = function(codePoint) {
            return codePoint in _this.unicodeMappings;
        };
        this.encodeUnicodeCodePoint = function(codePoint) {
            var mapped = _this.unicodeMappings[codePoint];
            if (!mapped) {
                var str = String.fromCharCode(codePoint);
                var hexCode = "0x" + (0, $gSkZj.padStart)(codePoint.toString(16), 4, '0');
                var msg = _this.name + " cannot encode \"" + str + "\" (" + hexCode + ")";
                throw new Error(msg);
            }
            return {
                code: mapped[0],
                name: mapped[1]
            };
        };
        this.name = name;
        this.supportedCodePoints = Object.keys(unicodeMappings).map(Number).sort(function(a, b) {
            return a - b;
        });
        this.unicodeMappings = unicodeMappings;
    }
    return Encoding;
}();
var $75dfdd80b14771e3$export$c85030bb86979d84 = {
    Symbol: new $75dfdd80b14771e3$var$Encoding('Symbol', $75dfdd80b14771e3$var$allUnicodeMappings.symbol),
    ZapfDingbats: new $75dfdd80b14771e3$var$Encoding('ZapfDingbats', $75dfdd80b14771e3$var$allUnicodeMappings.zapfdingbats),
    WinAnsi: new $75dfdd80b14771e3$var$Encoding('WinAnsi', $75dfdd80b14771e3$var$allUnicodeMappings.win1252)
};

});
parcelRegister("6cMRN", function(module, exports) {
module.exports = JSON.parse("\"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\"");

});




parcelRegister("fYigW", function(module, exports) {

$parcel$export(module.exports, "assertIsOneOf", function () { return $ba0aa214942faae0$export$8883a3014ee46cd1; });
$parcel$export(module.exports, "assertIsOneOfOrUndefined", function () { return $ba0aa214942faae0$export$846079600c50354e; });
$parcel$export(module.exports, "assertIsSubset", function () { return $ba0aa214942faae0$export$dce66947695c582f; });
$parcel$export(module.exports, "assertIs", function () { return $ba0aa214942faae0$export$6fee1f82edcf4a03; });
$parcel$export(module.exports, "assertOrUndefined", function () { return $ba0aa214942faae0$export$92143017cb173fb0; });
$parcel$export(module.exports, "assertEachIs", function () { return $ba0aa214942faae0$export$47fbce961905bcd0; });
$parcel$export(module.exports, "assertRange", function () { return $ba0aa214942faae0$export$6698b6d148bc9b0c; });
$parcel$export(module.exports, "assertRangeOrUndefined", function () { return $ba0aa214942faae0$export$bce4080186be486; });
$parcel$export(module.exports, "assertMultiple", function () { return $ba0aa214942faae0$export$c9f5acf8e31d1a2e; });
$parcel$export(module.exports, "assertInteger", function () { return $ba0aa214942faae0$export$a59e49f1e2708383; });
$parcel$export(module.exports, "assertPositive", function () { return $ba0aa214942faae0$export$2cad8b74f3cf13dd; });
/* tslint:disable:ban-types */ 
var $3JpTw = parcelRequire("3JpTw");
var $ba0aa214942faae0$export$c7ce26e85cccb3a8 = function(val) {
    return "`" + val + "`";
};
var $ba0aa214942faae0$export$1909b7b8a28995a9 = function(val) {
    return "'" + val + "'";
};
// prettier-ignore
var $ba0aa214942faae0$var$formatValue = function(value) {
    var type = typeof value;
    if (type === 'string') return $ba0aa214942faae0$export$1909b7b8a28995a9(value);
    else if (type === 'undefined') return $ba0aa214942faae0$export$c7ce26e85cccb3a8(value);
    else return value;
};
var $ba0aa214942faae0$export$2ac73c5d250d45a9 = function(value, valueName, values) {
    var allowedValues = new Array(values.length);
    for(var idx = 0, len = values.length; idx < len; idx++){
        var v = values[idx];
        allowedValues[idx] = $ba0aa214942faae0$var$formatValue(v);
    }
    var joinedValues = allowedValues.join(' or ');
    // prettier-ignore
    return $ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be one of " + joinedValues + ", but was actually " + $ba0aa214942faae0$var$formatValue(value);
};
var $ba0aa214942faae0$export$8883a3014ee46cd1 = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $3JpTw.values)(allowedValues);
    for(var idx = 0, len = allowedValues.length; idx < len; idx++){
        if (value === allowedValues[idx]) return;
    }
    throw new TypeError($ba0aa214942faae0$export$2ac73c5d250d45a9(value, valueName, allowedValues));
};
var $ba0aa214942faae0$export$846079600c50354e = function(value, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $3JpTw.values)(allowedValues);
    $ba0aa214942faae0$export$8883a3014ee46cd1(value, valueName, allowedValues.concat(undefined));
};
var $ba0aa214942faae0$export$dce66947695c582f = function(values, valueName, allowedValues) {
    if (!Array.isArray(allowedValues)) allowedValues = (0, $3JpTw.values)(allowedValues);
    for(var idx = 0, len = values.length; idx < len; idx++)$ba0aa214942faae0$export$8883a3014ee46cd1(values[idx], valueName, allowedValues);
};
var $ba0aa214942faae0$export$e2b5c5db9e2009fd = function(val) {
    if (val === null) return 'null';
    if (val === undefined) return 'undefined';
    if (typeof val === 'string') return 'string';
    if (isNaN(val)) return 'NaN';
    if (typeof val === 'number') return 'number';
    if (typeof val === 'boolean') return 'boolean';
    if (typeof val === 'symbol') return 'symbol';
    if (typeof val === 'bigint') return 'bigint';
    if (val.constructor && val.constructor.name) return val.constructor.name;
    if (val.name) return val.name;
    if (val.constructor) return String(val.constructor);
    return String(val);
};
var $ba0aa214942faae0$export$26b9f946b448f23e = function(value, type) {
    if (type === 'null') return value === null;
    if (type === 'undefined') return value === undefined;
    if (type === 'string') return typeof value === 'string';
    if (type === 'number') return typeof value === 'number' && !isNaN(value);
    if (type === 'boolean') return typeof value === 'boolean';
    if (type === 'symbol') return typeof value === 'symbol';
    if (type === 'bigint') return typeof value === 'bigint';
    if (type === Date) return value instanceof Date;
    if (type === Array) return value instanceof Array;
    if (type === Uint8Array) return value instanceof Uint8Array;
    if (type === ArrayBuffer) return value instanceof ArrayBuffer;
    if (type === Function) return value instanceof Function;
    return value instanceof type[0];
};
var $ba0aa214942faae0$export$6e3e1e6304e79984 = function(value, valueName, types) {
    var allowedTypes = new Array(types.length);
    for(var idx = 0, len = types.length; idx < len; idx++){
        var type = types[idx];
        if (type === 'null') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('null');
        if (type === 'undefined') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('undefined');
        if (type === 'string') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('string');
        else if (type === 'number') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('number');
        else if (type === 'boolean') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('boolean');
        else if (type === 'symbol') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('symbol');
        else if (type === 'bigint') allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('bigint');
        else if (type === Array) allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('Array');
        else if (type === Uint8Array) allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('Uint8Array');
        else if (type === ArrayBuffer) allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8('ArrayBuffer');
        else allowedTypes[idx] = $ba0aa214942faae0$export$c7ce26e85cccb3a8(type[1]);
    }
    var joinedTypes = allowedTypes.join(' or ');
    // prettier-ignore
    return $ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be of type " + joinedTypes + ", but was actually of type " + $ba0aa214942faae0$export$c7ce26e85cccb3a8($ba0aa214942faae0$export$e2b5c5db9e2009fd(value));
};
var $ba0aa214942faae0$export$6fee1f82edcf4a03 = function(value, valueName, types) {
    for(var idx = 0, len = types.length; idx < len; idx++){
        if ($ba0aa214942faae0$export$26b9f946b448f23e(value, types[idx])) return;
    }
    throw new TypeError($ba0aa214942faae0$export$6e3e1e6304e79984(value, valueName, types));
};
var $ba0aa214942faae0$export$92143017cb173fb0 = function(value, valueName, types) {
    $ba0aa214942faae0$export$6fee1f82edcf4a03(value, valueName, types.concat('undefined'));
};
var $ba0aa214942faae0$export$47fbce961905bcd0 = function(values, valueName, types) {
    for(var idx = 0, len = values.length; idx < len; idx++)$ba0aa214942faae0$export$6fee1f82edcf4a03(values[idx], valueName, types);
};
var $ba0aa214942faae0$export$6698b6d148bc9b0c = function(value, valueName, min, max) {
    $ba0aa214942faae0$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    $ba0aa214942faae0$export$6fee1f82edcf4a03(min, 'min', [
        'number'
    ]);
    $ba0aa214942faae0$export$6fee1f82edcf4a03(max, 'max', [
        'number'
    ]);
    max = Math.max(min, max);
    if (value < min || value > max) // prettier-ignore
    throw new Error($ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be at least " + min + " and at most " + max + ", but was actually " + value);
};
var $ba0aa214942faae0$export$bce4080186be486 = function(value, valueName, min, max) {
    $ba0aa214942faae0$export$6fee1f82edcf4a03(value, valueName, [
        'number',
        'undefined'
    ]);
    if (typeof value === 'number') $ba0aa214942faae0$export$6698b6d148bc9b0c(value, valueName, min, max);
};
var $ba0aa214942faae0$export$c9f5acf8e31d1a2e = function(value, valueName, multiplier) {
    $ba0aa214942faae0$export$6fee1f82edcf4a03(value, valueName, [
        'number'
    ]);
    if (value % multiplier !== 0) // prettier-ignore
    throw new Error($ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be a multiple of " + multiplier + ", but was actually " + value);
};
var $ba0aa214942faae0$export$a59e49f1e2708383 = function(value, valueName) {
    if (!Number.isInteger(value)) throw new Error($ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be an integer, but was actually " + value);
};
var $ba0aa214942faae0$export$2cad8b74f3cf13dd = function(value, valueName) {
    if (![
        1,
        0
    ].includes(Math.sign(value))) // prettier-ignore
    throw new Error($ba0aa214942faae0$export$c7ce26e85cccb3a8(valueName) + " must be a positive number or 0, but was actually " + value);
};

});

parcelRegister("aMBsn", function(module, exports) {

$parcel$export(module.exports, "pdfDocEncodingDecode", function () { return $7d9b7135183518ff$export$ea426b9c784ba215; });

var $c6a2W = parcelRequire("c6a2W");
// Mapping from PDFDocEncoding to Unicode code point
var $7d9b7135183518ff$var$pdfDocEncodingToUnicode = new Uint16Array(256);
// Initialize the code points which are the same
for(var $7d9b7135183518ff$var$idx = 0; $7d9b7135183518ff$var$idx < 256; $7d9b7135183518ff$var$idx++)$7d9b7135183518ff$var$pdfDocEncodingToUnicode[$7d9b7135183518ff$var$idx] = $7d9b7135183518ff$var$idx;
// Set differences (see "Table D.2 – PDFDocEncoding Character Set" of the PDF spec)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x16] = (0, $c6a2W.toCharCode)('\u0017'); // SYNCRONOUS IDLE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x18] = (0, $c6a2W.toCharCode)('\u02D8'); // BREVE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x19] = (0, $c6a2W.toCharCode)('\u02C7'); // CARON
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1a] = (0, $c6a2W.toCharCode)('\u02C6'); // MODIFIER LETTER CIRCUMFLEX ACCENT
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1b] = (0, $c6a2W.toCharCode)('\u02D9'); // DOT ABOVE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1c] = (0, $c6a2W.toCharCode)('\u02DD'); // DOUBLE ACUTE ACCENT
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1d] = (0, $c6a2W.toCharCode)('\u02DB'); // OGONEK
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1e] = (0, $c6a2W.toCharCode)('\u02DA'); // RING ABOVE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x1f] = (0, $c6a2W.toCharCode)('\u02DC'); // SMALL TILDE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x7f] = (0, $c6a2W.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x80] = (0, $c6a2W.toCharCode)('\u2022'); // BULLET
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x81] = (0, $c6a2W.toCharCode)('\u2020'); // DAGGER
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x82] = (0, $c6a2W.toCharCode)('\u2021'); // DOUBLE DAGGER
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x83] = (0, $c6a2W.toCharCode)('\u2026'); // HORIZONTAL ELLIPSIS
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x84] = (0, $c6a2W.toCharCode)('\u2014'); // EM DASH
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x85] = (0, $c6a2W.toCharCode)('\u2013'); // EN DASH
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x86] = (0, $c6a2W.toCharCode)('\u0192'); // LATIN SMALL LETTER SCRIPT F
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x87] = (0, $c6a2W.toCharCode)('\u2044'); // FRACTION SLASH (solidus)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x88] = (0, $c6a2W.toCharCode)('\u2039'); // SINGLE LEFT-POINTING ANGLE QUOTATION MARK
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x89] = (0, $c6a2W.toCharCode)('\u203A'); // SINGLE RIGHT-POINTING ANGLE QUOTATION MARK
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8a] = (0, $c6a2W.toCharCode)('\u2212'); // MINUS SIGN
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8b] = (0, $c6a2W.toCharCode)('\u2030'); // PER MILLE SIGN
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8c] = (0, $c6a2W.toCharCode)('\u201E'); // DOUBLE LOW-9 QUOTATION MARK (quotedblbase)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8d] = (0, $c6a2W.toCharCode)('\u201C'); // LEFT DOUBLE QUOTATION MARK (quotedblleft)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8e] = (0, $c6a2W.toCharCode)('\u201D'); // RIGHT DOUBLE QUOTATION MARK (quotedblright)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x8f] = (0, $c6a2W.toCharCode)('\u2018'); // LEFT SINGLE QUOTATION MARK (quoteleft)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x90] = (0, $c6a2W.toCharCode)('\u2019'); // RIGHT SINGLE QUOTATION MARK (quoteright)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x91] = (0, $c6a2W.toCharCode)('\u201A'); // SINGLE LOW-9 QUOTATION MARK (quotesinglbase)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x92] = (0, $c6a2W.toCharCode)('\u2122'); // TRADE MARK SIGN
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x93] = (0, $c6a2W.toCharCode)('\uFB01'); // LATIN SMALL LIGATURE FI
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x94] = (0, $c6a2W.toCharCode)('\uFB02'); // LATIN SMALL LIGATURE FL
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x95] = (0, $c6a2W.toCharCode)('\u0141'); // LATIN CAPITAL LETTER L WITH STROKE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x96] = (0, $c6a2W.toCharCode)('\u0152'); // LATIN CAPITAL LIGATURE OE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x97] = (0, $c6a2W.toCharCode)('\u0160'); // LATIN CAPITAL LETTER S WITH CARON
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x98] = (0, $c6a2W.toCharCode)('\u0178'); // LATIN CAPITAL LETTER Y WITH DIAERESIS
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x99] = (0, $c6a2W.toCharCode)('\u017D'); // LATIN CAPITAL LETTER Z WITH CARON
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9a] = (0, $c6a2W.toCharCode)('\u0131'); // LATIN SMALL LETTER DOTLESS I
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9b] = (0, $c6a2W.toCharCode)('\u0142'); // LATIN SMALL LETTER L WITH STROKE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9c] = (0, $c6a2W.toCharCode)('\u0153'); // LATIN SMALL LIGATURE OE
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9d] = (0, $c6a2W.toCharCode)('\u0161'); // LATIN SMALL LETTER S WITH CARON
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9e] = (0, $c6a2W.toCharCode)('\u017E'); // LATIN SMALL LETTER Z WITH CARON
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0x9f] = (0, $c6a2W.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0xa0] = (0, $c6a2W.toCharCode)('\u20AC'); // EURO SIGN
$7d9b7135183518ff$var$pdfDocEncodingToUnicode[0xad] = (0, $c6a2W.toCharCode)('\uFFFD'); // REPLACEMENT CHARACTER (box with questionmark)
var $7d9b7135183518ff$export$ea426b9c784ba215 = function(bytes) {
    var codePoints = new Array(bytes.length);
    for(var idx = 0, len = bytes.length; idx < len; idx++)codePoints[idx] = $7d9b7135183518ff$var$pdfDocEncodingToUnicode[bytes[idx]];
    return String.fromCodePoint.apply(String, codePoints);
};

});

parcelRegister("cLyfO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $94b471eff0d3b1b2$export$2e2bcd8739ae039; });
var $94b471eff0d3b1b2$var$Cache = /** @class */ function() {
    function Cache(populate) {
        this.populate = populate;
        this.value = undefined;
    }
    Cache.prototype.getValue = function() {
        return this.value;
    };
    Cache.prototype.access = function() {
        if (!this.value) this.value = this.populate();
        return this.value;
    };
    Cache.prototype.invalidate = function() {
        this.value = undefined;
    };
    Cache.populatedBy = function(populate) {
        return new Cache(populate);
    };
    return Cache;
}();
var $94b471eff0d3b1b2$export$2e2bcd8739ae039 = $94b471eff0d3b1b2$var$Cache;

});


parcelRegister("iyqEO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d820148930c99603$export$2e2bcd8739ae039; });

var $1jVcF = parcelRequire("1jVcF");
var $d820148930c99603$var$PDFObject = /** @class */ function() {
    function PDFObject() {}
    PDFObject.prototype.clone = function(_context) {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFObject.prototype.toString = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'toString');
    };
    PDFObject.prototype.sizeInBytes = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'sizeInBytes');
    };
    PDFObject.prototype.copyBytesInto = function(_buffer, _offset) {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'copyBytesInto');
    };
    return PDFObject;
}();
var $d820148930c99603$export$2e2bcd8739ae039 = $d820148930c99603$var$PDFObject;

});
parcelRegister("1jVcF", function(module, exports) {

$parcel$export(module.exports, "MethodNotImplementedError", function () { return $0f63f02916bbdde3$export$b549a6777be1bc17; });
$parcel$export(module.exports, "PrivateConstructorError", function () { return $0f63f02916bbdde3$export$20e18464cd4b43a; });
$parcel$export(module.exports, "UnexpectedObjectTypeError", function () { return $0f63f02916bbdde3$export$ab03f98a62c22159; });
$parcel$export(module.exports, "UnsupportedEncodingError", function () { return $0f63f02916bbdde3$export$5de8fe8a6031fb92; });
$parcel$export(module.exports, "ReparseError", function () { return $0f63f02916bbdde3$export$df523155c7c35e23; });
$parcel$export(module.exports, "MissingPageContentsEmbeddingError", function () { return $0f63f02916bbdde3$export$48e9be38307e3c37; });
$parcel$export(module.exports, "UnrecognizedStreamTypeError", function () { return $0f63f02916bbdde3$export$f8343077e7fd3a86; });
$parcel$export(module.exports, "PageEmbeddingMismatchedContextError", function () { return $0f63f02916bbdde3$export$22c55e00f6509a2c; });
$parcel$export(module.exports, "PDFArrayIsNotRectangleError", function () { return $0f63f02916bbdde3$export$a76bae7761f3d760; });
$parcel$export(module.exports, "InvalidPDFDateStringError", function () { return $0f63f02916bbdde3$export$8638e3ad1edceac8; });
$parcel$export(module.exports, "InvalidTargetIndexError", function () { return $0f63f02916bbdde3$export$845c01ec1ddb8877; });
$parcel$export(module.exports, "CorruptPageTreeError", function () { return $0f63f02916bbdde3$export$1012d63cae1523f8; });
$parcel$export(module.exports, "IndexOutOfBoundsError", function () { return $0f63f02916bbdde3$export$19a77d83c7473130; });
$parcel$export(module.exports, "InvalidAcroFieldValueError", function () { return $0f63f02916bbdde3$export$d39c49ea9be644ec; });
$parcel$export(module.exports, "MultiSelectValueError", function () { return $0f63f02916bbdde3$export$6606fe23b6c4542c; });
$parcel$export(module.exports, "MissingDAEntryError", function () { return $0f63f02916bbdde3$export$dfa101de065b3cc2; });
$parcel$export(module.exports, "MissingTfOperatorError", function () { return $0f63f02916bbdde3$export$b5ee390f1267b133; });
$parcel$export(module.exports, "NumberParsingError", function () { return $0f63f02916bbdde3$export$81adf4c464255546; });
$parcel$export(module.exports, "NextByteAssertionError", function () { return $0f63f02916bbdde3$export$fda6cb3cf0fe0c76; });
$parcel$export(module.exports, "PDFObjectParsingError", function () { return $0f63f02916bbdde3$export$b8907968b8d7f502; });
$parcel$export(module.exports, "PDFInvalidObjectParsingError", function () { return $0f63f02916bbdde3$export$72474f06fb3a1c6b; });
$parcel$export(module.exports, "PDFStreamParsingError", function () { return $0f63f02916bbdde3$export$b1a91b84397f50d6; });
$parcel$export(module.exports, "UnbalancedParenthesisError", function () { return $0f63f02916bbdde3$export$92803ff0e03167f9; });
$parcel$export(module.exports, "StalledParserError", function () { return $0f63f02916bbdde3$export$b934c61834236c8; });
$parcel$export(module.exports, "MissingPDFHeaderError", function () { return $0f63f02916bbdde3$export$cf6bd1b11dd05d74; });
$parcel$export(module.exports, "MissingKeywordError", function () { return $0f63f02916bbdde3$export$bc024c15c94be864; });

var $70JnX = parcelRequire("70JnX");
parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
var $0f63f02916bbdde3$export$b549a6777be1bc17 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MethodNotImplementedError, _super);
    function MethodNotImplementedError(className, methodName) {
        var _this = this;
        var msg = "Method " + className + "." + methodName + "() not implemented";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MethodNotImplementedError;
}(Error);
var $0f63f02916bbdde3$export$20e18464cd4b43a = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PrivateConstructorError, _super);
    function PrivateConstructorError(className) {
        var _this = this;
        var msg = "Cannot construct " + className + " - it has a private constructor";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PrivateConstructorError;
}(Error);
var $0f63f02916bbdde3$export$ab03f98a62c22159 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(UnexpectedObjectTypeError, _super);
    function UnexpectedObjectTypeError(expected, actual) {
        var _this = this;
        var name = function(t) {
            var _a, _b;
            return (_a = t === null || t === void 0 ? void 0 : t.name) !== null && _a !== void 0 ? _a : (_b = t === null || t === void 0 ? void 0 : t.constructor) === null || _b === void 0 ? void 0 : _b.name;
        };
        var expectedTypes = Array.isArray(expected) ? expected.map(name) : [
            name(expected)
        ];
        var msg = "Expected instance of " + expectedTypes.join(' or ') + ", " + ("but got instance of " + (actual ? name(actual) : actual));
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedObjectTypeError;
}(Error);
var $0f63f02916bbdde3$export$5de8fe8a6031fb92 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(UnsupportedEncodingError, _super);
    function UnsupportedEncodingError(encoding) {
        var _this = this;
        var msg = encoding + " stream encoding not supported";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnsupportedEncodingError;
}(Error);
var $0f63f02916bbdde3$export$df523155c7c35e23 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(ReparseError, _super);
    function ReparseError(className, methodName) {
        var _this = this;
        var msg = "Cannot call " + className + "." + methodName + "() more than once";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ReparseError;
}(Error);
var $0f63f02916bbdde3$export$3afc9350d4666214 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingCatalogError, _super);
    function MissingCatalogError(ref) {
        var _this = this;
        var msg = "Missing catalog (ref=" + ref + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingCatalogError;
}(Error);
var $0f63f02916bbdde3$export$48e9be38307e3c37 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingPageContentsEmbeddingError, _super);
    function MissingPageContentsEmbeddingError() {
        var _this = this;
        var msg = "Can't embed page with missing Contents";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingPageContentsEmbeddingError;
}(Error);
var $0f63f02916bbdde3$export$f8343077e7fd3a86 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(UnrecognizedStreamTypeError, _super);
    function UnrecognizedStreamTypeError(stream) {
        var _a, _b, _c;
        var _this = this;
        var streamType = (_c = (_b = (_a = stream === null || stream === void 0 ? void 0 : stream.contructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : stream === null || stream === void 0 ? void 0 : stream.name) !== null && _c !== void 0 ? _c : stream;
        var msg = "Unrecognized stream type: " + streamType;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnrecognizedStreamTypeError;
}(Error);
var $0f63f02916bbdde3$export$22c55e00f6509a2c = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PageEmbeddingMismatchedContextError, _super);
    function PageEmbeddingMismatchedContextError() {
        var _this = this;
        var msg = "Found mismatched contexts while embedding pages. All pages in the array passed to `PDFDocument.embedPages()` must be from the same document.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PageEmbeddingMismatchedContextError;
}(Error);
var $0f63f02916bbdde3$export$a76bae7761f3d760 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFArrayIsNotRectangleError, _super);
    function PDFArrayIsNotRectangleError(size) {
        var _this = this;
        var msg = "Attempted to convert PDFArray with " + size + " elements to rectangle, but must have exactly 4 elements.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFArrayIsNotRectangleError;
}(Error);
var $0f63f02916bbdde3$export$8638e3ad1edceac8 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(InvalidPDFDateStringError, _super);
    function InvalidPDFDateStringError(value) {
        var _this = this;
        var msg = "Attempted to convert \"" + value + "\" to a date, but it does not match the PDF date string format.";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidPDFDateStringError;
}(Error);
var $0f63f02916bbdde3$export$845c01ec1ddb8877 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(InvalidTargetIndexError, _super);
    function InvalidTargetIndexError(targetIndex, Count) {
        var _this = this;
        var msg = "Invalid targetIndex specified: targetIndex=" + targetIndex + " must be less than Count=" + Count;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidTargetIndexError;
}(Error);
var $0f63f02916bbdde3$export$1012d63cae1523f8 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(CorruptPageTreeError, _super);
    function CorruptPageTreeError(targetIndex, operation) {
        var _this = this;
        var msg = "Failed to " + operation + " at targetIndex=" + targetIndex + " due to corrupt page tree: It is likely that one or more 'Count' entries are invalid";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CorruptPageTreeError;
}(Error);
var $0f63f02916bbdde3$export$19a77d83c7473130 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(IndexOutOfBoundsError, _super);
    function IndexOutOfBoundsError(index, min, max) {
        var _this = this;
        var msg = "index should be at least " + min + " and at most " + max + ", but was actually " + index;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return IndexOutOfBoundsError;
}(Error);
var $0f63f02916bbdde3$export$d39c49ea9be644ec = /** @class */ function(_super) {
    (0, $70JnX.__extends)(InvalidAcroFieldValueError, _super);
    function InvalidAcroFieldValueError() {
        var _this = this;
        var msg = "Attempted to set invalid field value";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidAcroFieldValueError;
}(Error);
var $0f63f02916bbdde3$export$6606fe23b6c4542c = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MultiSelectValueError, _super);
    function MultiSelectValueError() {
        var _this = this;
        var msg = "Attempted to select multiple values for single-select field";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MultiSelectValueError;
}(Error);
var $0f63f02916bbdde3$export$dfa101de065b3cc2 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingDAEntryError, _super);
    function MissingDAEntryError(fieldName) {
        var _this = this;
        var msg = "No /DA (default appearance) entry found for field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingDAEntryError;
}(Error);
var $0f63f02916bbdde3$export$b5ee390f1267b133 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingTfOperatorError, _super);
    function MissingTfOperatorError(fieldName) {
        var _this = this;
        var msg = "No Tf operator found for DA of field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingTfOperatorError;
}(Error);
var $0f63f02916bbdde3$export$81adf4c464255546 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(NumberParsingError, _super);
    function NumberParsingError(pos, value) {
        var _this = this;
        var msg = "Failed to parse number " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): \"" + value + "\"");
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NumberParsingError;
}(Error);
var $0f63f02916bbdde3$export$fd202455a19cb700 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFParsingError, _super);
    function PDFParsingError(pos, details) {
        var _this = this;
        var msg = "Failed to parse PDF document " + ("(line:" + pos.line + " col:" + pos.column + " offset=" + pos.offset + "): " + details);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return PDFParsingError;
}(Error);
var $0f63f02916bbdde3$export$fda6cb3cf0fe0c76 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(NextByteAssertionError, _super);
    function NextByteAssertionError(pos, expectedByte, actualByte) {
        var _this = this;
        var msg = "Expected next byte to be " + expectedByte + " but it was actually " + actualByte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return NextByteAssertionError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$b8907968b8d7f502 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFObjectParsingError, _super);
    function PDFObjectParsingError(pos, byte) {
        var _this = this;
        var msg = "Failed to parse PDF object starting with the following byte: " + byte;
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFObjectParsingError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$72474f06fb3a1c6b = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFInvalidObjectParsingError, _super);
    function PDFInvalidObjectParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse invalid PDF object";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFInvalidObjectParsingError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$b1a91b84397f50d6 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFStreamParsingError, _super);
    function PDFStreamParsingError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF stream";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return PDFStreamParsingError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$92803ff0e03167f9 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(UnbalancedParenthesisError, _super);
    function UnbalancedParenthesisError(pos) {
        var _this = this;
        var msg = "Failed to parse PDF literal string due to unbalanced parenthesis";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return UnbalancedParenthesisError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$b934c61834236c8 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(StalledParserError, _super);
    function StalledParserError(pos) {
        var _this = this;
        var msg = "Parser stalled";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return StalledParserError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$cf6bd1b11dd05d74 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingPDFHeaderError, _super);
    function MissingPDFHeaderError(pos) {
        var _this = this;
        var msg = "No PDF header found";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingPDFHeaderError;
}($0f63f02916bbdde3$export$fd202455a19cb700);
var $0f63f02916bbdde3$export$bc024c15c94be864 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingKeywordError, _super);
    function MissingKeywordError(pos, keyword) {
        var _this = this;
        var msg = "Did not find expected keyword '" + (0, $9uJGW.arrayAsString)(keyword) + "'";
        _this = _super.call(this, pos, msg) || this;
        return _this;
    }
    return MissingKeywordError;
}($0f63f02916bbdde3$export$fd202455a19cb700);

});



parcelRegister("lJYRg", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $fd3d021a126e83ed$export$2e2bcd8739ae039; });
var $fd3d021a126e83ed$var$CharCodes;
(function(CharCodes) {
    CharCodes[CharCodes["Null"] = 0] = "Null";
    CharCodes[CharCodes["Backspace"] = 8] = "Backspace";
    CharCodes[CharCodes["Tab"] = 9] = "Tab";
    CharCodes[CharCodes["Newline"] = 10] = "Newline";
    CharCodes[CharCodes["FormFeed"] = 12] = "FormFeed";
    CharCodes[CharCodes["CarriageReturn"] = 13] = "CarriageReturn";
    CharCodes[CharCodes["Space"] = 32] = "Space";
    CharCodes[CharCodes["ExclamationPoint"] = 33] = "ExclamationPoint";
    CharCodes[CharCodes["Hash"] = 35] = "Hash";
    CharCodes[CharCodes["Percent"] = 37] = "Percent";
    CharCodes[CharCodes["LeftParen"] = 40] = "LeftParen";
    CharCodes[CharCodes["RightParen"] = 41] = "RightParen";
    CharCodes[CharCodes["Plus"] = 43] = "Plus";
    CharCodes[CharCodes["Minus"] = 45] = "Minus";
    CharCodes[CharCodes["Dash"] = 45] = "Dash";
    CharCodes[CharCodes["Period"] = 46] = "Period";
    CharCodes[CharCodes["ForwardSlash"] = 47] = "ForwardSlash";
    CharCodes[CharCodes["Zero"] = 48] = "Zero";
    CharCodes[CharCodes["One"] = 49] = "One";
    CharCodes[CharCodes["Two"] = 50] = "Two";
    CharCodes[CharCodes["Three"] = 51] = "Three";
    CharCodes[CharCodes["Four"] = 52] = "Four";
    CharCodes[CharCodes["Five"] = 53] = "Five";
    CharCodes[CharCodes["Six"] = 54] = "Six";
    CharCodes[CharCodes["Seven"] = 55] = "Seven";
    CharCodes[CharCodes["Eight"] = 56] = "Eight";
    CharCodes[CharCodes["Nine"] = 57] = "Nine";
    CharCodes[CharCodes["LessThan"] = 60] = "LessThan";
    CharCodes[CharCodes["GreaterThan"] = 62] = "GreaterThan";
    CharCodes[CharCodes["A"] = 65] = "A";
    CharCodes[CharCodes["D"] = 68] = "D";
    CharCodes[CharCodes["E"] = 69] = "E";
    CharCodes[CharCodes["F"] = 70] = "F";
    CharCodes[CharCodes["O"] = 79] = "O";
    CharCodes[CharCodes["P"] = 80] = "P";
    CharCodes[CharCodes["R"] = 82] = "R";
    CharCodes[CharCodes["LeftSquareBracket"] = 91] = "LeftSquareBracket";
    CharCodes[CharCodes["BackSlash"] = 92] = "BackSlash";
    CharCodes[CharCodes["RightSquareBracket"] = 93] = "RightSquareBracket";
    CharCodes[CharCodes["a"] = 97] = "a";
    CharCodes[CharCodes["b"] = 98] = "b";
    CharCodes[CharCodes["d"] = 100] = "d";
    CharCodes[CharCodes["e"] = 101] = "e";
    CharCodes[CharCodes["f"] = 102] = "f";
    CharCodes[CharCodes["i"] = 105] = "i";
    CharCodes[CharCodes["j"] = 106] = "j";
    CharCodes[CharCodes["l"] = 108] = "l";
    CharCodes[CharCodes["m"] = 109] = "m";
    CharCodes[CharCodes["n"] = 110] = "n";
    CharCodes[CharCodes["o"] = 111] = "o";
    CharCodes[CharCodes["r"] = 114] = "r";
    CharCodes[CharCodes["s"] = 115] = "s";
    CharCodes[CharCodes["t"] = 116] = "t";
    CharCodes[CharCodes["u"] = 117] = "u";
    CharCodes[CharCodes["x"] = 120] = "x";
    CharCodes[CharCodes["LeftCurly"] = 123] = "LeftCurly";
    CharCodes[CharCodes["RightCurly"] = 125] = "RightCurly";
    CharCodes[CharCodes["Tilde"] = 126] = "Tilde";
})($fd3d021a126e83ed$var$CharCodes || ($fd3d021a126e83ed$var$CharCodes = {}));
var $fd3d021a126e83ed$export$2e2bcd8739ae039 = $fd3d021a126e83ed$var$CharCodes;

});


parcelRegister("gxKrW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c0b3c254d94d9cd5$export$2e2bcd8739ae039; });

var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
var $c0b3c254d94d9cd5$var$ENFORCER = {};
var $c0b3c254d94d9cd5$var$PDFBool = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFBool, _super);
    function PDFBool(enforcer, value) {
        var _this = this;
        if (enforcer !== $c0b3c254d94d9cd5$var$ENFORCER) throw new (0, $1jVcF.PrivateConstructorError)('PDFBool');
        _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFBool.prototype.asBoolean = function() {
        return this.value;
    };
    PDFBool.prototype.clone = function() {
        return this;
    };
    PDFBool.prototype.toString = function() {
        return String(this.value);
    };
    PDFBool.prototype.sizeInBytes = function() {
        return this.value ? 4 : 5;
    };
    PDFBool.prototype.copyBytesInto = function(buffer, offset) {
        if (this.value) {
            buffer[offset++] = (0, $lJYRg.default).t;
            buffer[offset++] = (0, $lJYRg.default).r;
            buffer[offset++] = (0, $lJYRg.default).u;
            buffer[offset++] = (0, $lJYRg.default).e;
            return 4;
        } else {
            buffer[offset++] = (0, $lJYRg.default).f;
            buffer[offset++] = (0, $lJYRg.default).a;
            buffer[offset++] = (0, $lJYRg.default).l;
            buffer[offset++] = (0, $lJYRg.default).s;
            buffer[offset++] = (0, $lJYRg.default).e;
            return 5;
        }
    };
    PDFBool.True = new PDFBool($c0b3c254d94d9cd5$var$ENFORCER, true);
    PDFBool.False = new PDFBool($c0b3c254d94d9cd5$var$ENFORCER, false);
    return PDFBool;
}((0, $iyqEO.default));
var $c0b3c254d94d9cd5$export$2e2bcd8739ae039 = $c0b3c254d94d9cd5$var$PDFBool;

});

parcelRegister("btXS2", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $85c0d82b010ac3a4$export$2e2bcd8739ae039; });

var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");

var $6yehA = parcelRequire("6yehA");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $85c0d82b010ac3a4$var$decodeName = function(name) {
    return name.replace(/#([\dABCDEF]{2})/g, function(_, hex) {
        return (0, $c6a2W.charFromHexCode)(hex);
    });
};
var $85c0d82b010ac3a4$var$isRegularChar = function(charCode) {
    return charCode >= (0, $lJYRg.default).ExclamationPoint && charCode <= (0, $lJYRg.default).Tilde && !(0, $6yehA.IsIrregular)[charCode];
};
var $85c0d82b010ac3a4$var$ENFORCER = {};
var $85c0d82b010ac3a4$var$pool = new Map();
var $85c0d82b010ac3a4$var$PDFName = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFName, _super);
    function PDFName(enforcer, name) {
        var _this = this;
        if (enforcer !== $85c0d82b010ac3a4$var$ENFORCER) throw new (0, $1jVcF.PrivateConstructorError)('PDFName');
        _this = _super.call(this) || this;
        var encodedName = '/';
        for(var idx = 0, len = name.length; idx < len; idx++){
            var character = name[idx];
            var code = (0, $c6a2W.toCharCode)(character);
            encodedName += $85c0d82b010ac3a4$var$isRegularChar(code) ? character : "#" + (0, $c6a2W.toHexString)(code);
        }
        _this.encodedName = encodedName;
        return _this;
    }
    PDFName.prototype.asBytes = function() {
        var bytes = [];
        var hex = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 1, len = this.encodedName.length; idx < len; idx++){
            var char = this.encodedName[idx];
            var byte = (0, $c6a2W.toCharCode)(char);
            var nextChar = this.encodedName[idx + 1];
            if (!escaped) {
                if (byte === (0, $lJYRg.default).Hash) escaped = true;
                else pushByte(byte);
            } else if (byte >= (0, $lJYRg.default).Zero && byte <= (0, $lJYRg.default).Nine || byte >= (0, $lJYRg.default).a && byte <= (0, $lJYRg.default).f || byte >= (0, $lJYRg.default).A && byte <= (0, $lJYRg.default).F) {
                hex += char;
                if (hex.length === 2 || !(nextChar >= '0' && nextChar <= '9' || nextChar >= 'a' && nextChar <= 'f' || nextChar >= 'A' && nextChar <= 'F')) {
                    pushByte(parseInt(hex, 16));
                    hex = '';
                }
            } else pushByte(byte);
        }
        return new Uint8Array(bytes);
    };
    // TODO: This should probably use `utf8Decode()`
    // TODO: Polyfill Array.from?
    PDFName.prototype.decodeText = function() {
        var bytes = this.asBytes();
        return String.fromCharCode.apply(String, Array.from(bytes));
    };
    PDFName.prototype.asString = function() {
        return this.encodedName;
    };
    /** @deprecated in favor of [[PDFName.asString]] */ PDFName.prototype.value = function() {
        return this.encodedName;
    };
    PDFName.prototype.clone = function() {
        return this;
    };
    PDFName.prototype.toString = function() {
        return this.encodedName;
    };
    PDFName.prototype.sizeInBytes = function() {
        return this.encodedName.length;
    };
    PDFName.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.encodedName, buffer, offset);
        return this.encodedName.length;
    };
    PDFName.of = function(name) {
        var decodedValue = $85c0d82b010ac3a4$var$decodeName(name);
        var instance = $85c0d82b010ac3a4$var$pool.get(decodedValue);
        if (!instance) {
            instance = new PDFName($85c0d82b010ac3a4$var$ENFORCER, decodedValue);
            $85c0d82b010ac3a4$var$pool.set(decodedValue, instance);
        }
        return instance;
    };
    /* tslint:disable member-ordering */ PDFName.Length = PDFName.of('Length');
    PDFName.FlateDecode = PDFName.of('FlateDecode');
    PDFName.Resources = PDFName.of('Resources');
    PDFName.Font = PDFName.of('Font');
    PDFName.XObject = PDFName.of('XObject');
    PDFName.ExtGState = PDFName.of('ExtGState');
    PDFName.Contents = PDFName.of('Contents');
    PDFName.Type = PDFName.of('Type');
    PDFName.Parent = PDFName.of('Parent');
    PDFName.MediaBox = PDFName.of('MediaBox');
    PDFName.Page = PDFName.of('Page');
    PDFName.Annots = PDFName.of('Annots');
    PDFName.TrimBox = PDFName.of('TrimBox');
    PDFName.ArtBox = PDFName.of('ArtBox');
    PDFName.BleedBox = PDFName.of('BleedBox');
    PDFName.CropBox = PDFName.of('CropBox');
    PDFName.Rotate = PDFName.of('Rotate');
    PDFName.Title = PDFName.of('Title');
    PDFName.Author = PDFName.of('Author');
    PDFName.Subject = PDFName.of('Subject');
    PDFName.Creator = PDFName.of('Creator');
    PDFName.Keywords = PDFName.of('Keywords');
    PDFName.Producer = PDFName.of('Producer');
    PDFName.CreationDate = PDFName.of('CreationDate');
    PDFName.ModDate = PDFName.of('ModDate');
    return PDFName;
}((0, $iyqEO.default));
var $85c0d82b010ac3a4$export$2e2bcd8739ae039 = $85c0d82b010ac3a4$var$PDFName;

});
parcelRegister("6yehA", function(module, exports) {

$parcel$export(module.exports, "IsIrregular", function () { return $4c50ff479915415c$export$5a447e10c710a69b; });

var $lJYRg = parcelRequire("lJYRg");

var $aXwzD = parcelRequire("aXwzD");

var $7gWQz = parcelRequire("7gWQz");
var $4c50ff479915415c$export$5a447e10c710a69b = new Uint8Array(256);
for(var $4c50ff479915415c$var$idx = 0, $4c50ff479915415c$var$len = 256; $4c50ff479915415c$var$idx < $4c50ff479915415c$var$len; $4c50ff479915415c$var$idx++)$4c50ff479915415c$export$5a447e10c710a69b[$4c50ff479915415c$var$idx] = (0, $7gWQz.IsWhitespace)[$4c50ff479915415c$var$idx] || (0, $aXwzD.IsDelimiter)[$4c50ff479915415c$var$idx] ? 1 : 0;
$4c50ff479915415c$export$5a447e10c710a69b[(0, $lJYRg.default).Hash] = 1;

});
parcelRegister("aXwzD", function(module, exports) {

$parcel$export(module.exports, "IsDelimiter", function () { return $7fa8ae89fd331294$export$30620680eaa3becd; });

var $lJYRg = parcelRequire("lJYRg");
var $7fa8ae89fd331294$export$30620680eaa3becd = new Uint8Array(256);
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).LeftParen] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).RightParen] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).LessThan] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).GreaterThan] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).LeftSquareBracket] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).RightSquareBracket] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).LeftCurly] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).RightCurly] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).ForwardSlash] = 1;
$7fa8ae89fd331294$export$30620680eaa3becd[(0, $lJYRg.default).Percent] = 1;

});

parcelRegister("7gWQz", function(module, exports) {

$parcel$export(module.exports, "IsWhitespace", function () { return $54b7acca2c392d87$export$38c4de915d0e2c37; });

var $lJYRg = parcelRequire("lJYRg");
var $54b7acca2c392d87$export$38c4de915d0e2c37 = new Uint8Array(256);
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).Null] = 1;
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).Tab] = 1;
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).Newline] = 1;
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).FormFeed] = 1;
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).CarriageReturn] = 1;
$54b7acca2c392d87$export$38c4de915d0e2c37[(0, $lJYRg.default).Space] = 1;

});




var $1b86355b1205a2ea$exports = {};
$parcel$extendImportMap({
    "jehra": "pdf.worker.min.a509e2a3.js",
    "hTvjn": "NotoSansJP-Regular.f0d6b8ca.ttf"
});


/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */ function $12b3d2ab131f1390$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $12b3d2ab131f1390$var$_objectSpread2(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $12b3d2ab131f1390$var$ownKeys(Object(source), true).forEach(function(key) {
            $12b3d2ab131f1390$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $12b3d2ab131f1390$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $12b3d2ab131f1390$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $12b3d2ab131f1390$var$_typeof = function(obj) {
        return typeof obj;
    };
    else $12b3d2ab131f1390$var$_typeof = function(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $12b3d2ab131f1390$var$_typeof(obj);
}
function $12b3d2ab131f1390$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $12b3d2ab131f1390$var$_extends() {
    $12b3d2ab131f1390$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $12b3d2ab131f1390$var$_extends.apply(this, arguments);
}
function $12b3d2ab131f1390$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $12b3d2ab131f1390$var$_objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = $12b3d2ab131f1390$var$_objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function $12b3d2ab131f1390$var$_toConsumableArray(arr) {
    return $12b3d2ab131f1390$var$_arrayWithoutHoles(arr) || $12b3d2ab131f1390$var$_iterableToArray(arr) || $12b3d2ab131f1390$var$_unsupportedIterableToArray(arr) || $12b3d2ab131f1390$var$_nonIterableSpread();
}
function $12b3d2ab131f1390$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $12b3d2ab131f1390$var$_arrayLikeToArray(arr);
}
function $12b3d2ab131f1390$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function $12b3d2ab131f1390$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $12b3d2ab131f1390$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $12b3d2ab131f1390$var$_arrayLikeToArray(o, minLen);
}
function $12b3d2ab131f1390$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $12b3d2ab131f1390$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
var $12b3d2ab131f1390$var$version = "1.15.6";
function $12b3d2ab131f1390$var$userAgent(pattern) {
    if (typeof window !== 'undefined' && window.navigator) return !!/*@__PURE__*/ navigator.userAgent.match(pattern);
}
var $12b3d2ab131f1390$var$IE11OrLess = $12b3d2ab131f1390$var$userAgent(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i);
var $12b3d2ab131f1390$var$Edge = $12b3d2ab131f1390$var$userAgent(/Edge/i);
var $12b3d2ab131f1390$var$FireFox = $12b3d2ab131f1390$var$userAgent(/firefox/i);
var $12b3d2ab131f1390$var$Safari = $12b3d2ab131f1390$var$userAgent(/safari/i) && !$12b3d2ab131f1390$var$userAgent(/chrome/i) && !$12b3d2ab131f1390$var$userAgent(/android/i);
var $12b3d2ab131f1390$var$IOS = $12b3d2ab131f1390$var$userAgent(/iP(ad|od|hone)/i);
var $12b3d2ab131f1390$var$ChromeForAndroid = $12b3d2ab131f1390$var$userAgent(/chrome/i) && $12b3d2ab131f1390$var$userAgent(/android/i);
var $12b3d2ab131f1390$var$captureMode = {
    capture: false,
    passive: false
};
function $12b3d2ab131f1390$var$on(el, event, fn) {
    el.addEventListener(event, fn, !$12b3d2ab131f1390$var$IE11OrLess && $12b3d2ab131f1390$var$captureMode);
}
function $12b3d2ab131f1390$var$off(el, event, fn) {
    el.removeEventListener(event, fn, !$12b3d2ab131f1390$var$IE11OrLess && $12b3d2ab131f1390$var$captureMode);
}
function $12b3d2ab131f1390$var$matches(/**HTMLElement*/ el, /**String*/ selector) {
    if (!selector) return;
    selector[0] === '>' && (selector = selector.substring(1));
    if (el) try {
        if (el.matches) return el.matches(selector);
        else if (el.msMatchesSelector) return el.msMatchesSelector(selector);
        else if (el.webkitMatchesSelector) return el.webkitMatchesSelector(selector);
    } catch (_) {
        return false;
    }
    return false;
}
function $12b3d2ab131f1390$var$getParentOrHost(el) {
    return el.host && el !== document && el.host.nodeType ? el.host : el.parentNode;
}
function $12b3d2ab131f1390$var$closest(/**HTMLElement*/ el, /**String*/ selector, /**HTMLElement*/ ctx, includeCTX) {
    if (el) {
        ctx = ctx || document;
        do {
            if (selector != null && (selector[0] === '>' ? el.parentNode === ctx && $12b3d2ab131f1390$var$matches(el, selector) : $12b3d2ab131f1390$var$matches(el, selector)) || includeCTX && el === ctx) return el;
            if (el === ctx) break;
        /* jshint boss:true */ }while (el = $12b3d2ab131f1390$var$getParentOrHost(el));
    }
    return null;
}
var $12b3d2ab131f1390$var$R_SPACE = /\s+/g;
function $12b3d2ab131f1390$var$toggleClass(el, name, state) {
    if (el && name) {
        if (el.classList) el.classList[state ? 'add' : 'remove'](name);
        else {
            var className = (' ' + el.className + ' ').replace($12b3d2ab131f1390$var$R_SPACE, ' ').replace(' ' + name + ' ', ' ');
            el.className = (className + (state ? ' ' + name : '')).replace($12b3d2ab131f1390$var$R_SPACE, ' ');
        }
    }
}
function $12b3d2ab131f1390$var$css(el, prop, val) {
    var style = el && el.style;
    if (style) {
        if (val === void 0) {
            if (document.defaultView && document.defaultView.getComputedStyle) val = document.defaultView.getComputedStyle(el, '');
            else if (el.currentStyle) val = el.currentStyle;
            return prop === void 0 ? val : val[prop];
        } else {
            if (!(prop in style) && prop.indexOf('webkit') === -1) prop = '-webkit-' + prop;
            style[prop] = val + (typeof val === 'string' ? '' : 'px');
        }
    }
}
function $12b3d2ab131f1390$var$matrix(el, selfOnly) {
    var appliedTransforms = '';
    if (typeof el === 'string') appliedTransforms = el;
    else do {
        var transform = $12b3d2ab131f1390$var$css(el, 'transform');
        if (transform && transform !== 'none') appliedTransforms = transform + ' ' + appliedTransforms;
    /* jshint boss:true */ }while (!selfOnly && (el = el.parentNode));
    var matrixFn = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
    /*jshint -W056 */ return matrixFn && new matrixFn(appliedTransforms);
}
function $12b3d2ab131f1390$var$find(ctx, tagName, iterator) {
    if (ctx) {
        var list = ctx.getElementsByTagName(tagName), i = 0, n = list.length;
        if (iterator) for(; i < n; i++)iterator(list[i], i);
        return list;
    }
    return [];
}
function $12b3d2ab131f1390$var$getWindowScrollingElement() {
    var scrollingElement = document.scrollingElement;
    if (scrollingElement) return scrollingElement;
    else return document.documentElement;
}
/**
 * Returns the "bounding client rect" of given element
 * @param  {HTMLElement} el                       The element whose boundingClientRect is wanted
 * @param  {[Boolean]} relativeToContainingBlock  Whether the rect should be relative to the containing block of (including) the container
 * @param  {[Boolean]} relativeToNonStaticParent  Whether the rect should be relative to the relative parent of (including) the contaienr
 * @param  {[Boolean]} undoScale                  Whether the container's scale() should be undone
 * @param  {[HTMLElement]} container              The parent the element will be placed in
 * @return {Object}                               The boundingClientRect of el, with specified adjustments
 */ function $12b3d2ab131f1390$var$getRect(el, relativeToContainingBlock, relativeToNonStaticParent, undoScale, container) {
    if (!el.getBoundingClientRect && el !== window) return;
    var elRect, top, left, bottom, right, height, width;
    if (el !== window && el.parentNode && el !== $12b3d2ab131f1390$var$getWindowScrollingElement()) {
        elRect = el.getBoundingClientRect();
        top = elRect.top;
        left = elRect.left;
        bottom = elRect.bottom;
        right = elRect.right;
        height = elRect.height;
        width = elRect.width;
    } else {
        top = 0;
        left = 0;
        bottom = window.innerHeight;
        right = window.innerWidth;
        height = window.innerHeight;
        width = window.innerWidth;
    }
    if ((relativeToContainingBlock || relativeToNonStaticParent) && el !== window) {
        // Adjust for translate()
        container = container || el.parentNode;
        // solves #1123 (see: https://stackoverflow.com/a/37953806/6088312)
        // Not needed on <= IE11
        if (!$12b3d2ab131f1390$var$IE11OrLess) {
            do if (container && container.getBoundingClientRect && ($12b3d2ab131f1390$var$css(container, 'transform') !== 'none' || relativeToNonStaticParent && $12b3d2ab131f1390$var$css(container, 'position') !== 'static')) {
                var containerRect = container.getBoundingClientRect();
                // Set relative to edges of padding box of container
                top -= containerRect.top + parseInt($12b3d2ab131f1390$var$css(container, 'border-top-width'));
                left -= containerRect.left + parseInt($12b3d2ab131f1390$var$css(container, 'border-left-width'));
                bottom = top + elRect.height;
                right = left + elRect.width;
                break;
            }
            while (container = container.parentNode);
        }
    }
    if (undoScale && el !== window) {
        // Adjust for scale()
        var elMatrix = $12b3d2ab131f1390$var$matrix(container || el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d;
        if (elMatrix) {
            top /= scaleY;
            left /= scaleX;
            width /= scaleX;
            height /= scaleY;
            bottom = top + height;
            right = left + width;
        }
    }
    return {
        top: top,
        left: left,
        bottom: bottom,
        right: right,
        width: width,
        height: height
    };
}
/**
 * Checks if a side of an element is scrolled past a side of its parents
 * @param  {HTMLElement}  el           The element who's side being scrolled out of view is in question
 * @param  {String}       elSide       Side of the element in question ('top', 'left', 'right', 'bottom')
 * @param  {String}       parentSide   Side of the parent in question ('top', 'left', 'right', 'bottom')
 * @return {HTMLElement}               The parent scroll element that the el's side is scrolled past, or null if there is no such element
 */ function $12b3d2ab131f1390$var$isScrolledPast(el, elSide, parentSide) {
    var parent = $12b3d2ab131f1390$var$getParentAutoScrollElement(el, true), elSideVal = $12b3d2ab131f1390$var$getRect(el)[elSide];
    /* jshint boss:true */ while(parent){
        var parentSideVal = $12b3d2ab131f1390$var$getRect(parent)[parentSide], visible = void 0;
        if (parentSide === 'top' || parentSide === 'left') visible = elSideVal >= parentSideVal;
        else visible = elSideVal <= parentSideVal;
        if (!visible) return parent;
        if (parent === $12b3d2ab131f1390$var$getWindowScrollingElement()) break;
        parent = $12b3d2ab131f1390$var$getParentAutoScrollElement(parent, false);
    }
    return false;
}
/**
 * Gets nth child of el, ignoring hidden children, sortable's elements (does not ignore clone if it's visible)
 * and non-draggable elements
 * @param  {HTMLElement} el       The parent element
 * @param  {Number} childNum      The index of the child
 * @param  {Object} options       Parent Sortable's options
 * @return {HTMLElement}          The child at index childNum, or null if not found
 */ function $12b3d2ab131f1390$var$getChild(el, childNum, options, includeDragEl) {
    var currentChild = 0, i = 0, children = el.children;
    while(i < children.length){
        if (children[i].style.display !== 'none' && children[i] !== $12b3d2ab131f1390$export$31b3ca70d8f57423.ghost && (includeDragEl || children[i] !== $12b3d2ab131f1390$export$31b3ca70d8f57423.dragged) && $12b3d2ab131f1390$var$closest(children[i], options.draggable, el, false)) {
            if (currentChild === childNum) return children[i];
            currentChild++;
        }
        i++;
    }
    return null;
}
/**
 * Gets the last child in the el, ignoring ghostEl or invisible elements (clones)
 * @param  {HTMLElement} el       Parent element
 * @param  {selector} selector    Any other elements that should be ignored
 * @return {HTMLElement}          The last child, ignoring ghostEl
 */ function $12b3d2ab131f1390$var$lastChild(el, selector) {
    var last = el.lastElementChild;
    while(last && (last === $12b3d2ab131f1390$export$31b3ca70d8f57423.ghost || $12b3d2ab131f1390$var$css(last, 'display') === 'none' || selector && !$12b3d2ab131f1390$var$matches(last, selector)))last = last.previousElementSibling;
    return last || null;
}
/**
 * Returns the index of an element within its parent for a selected set of
 * elements
 * @param  {HTMLElement} el
 * @param  {selector} selector
 * @return {number}
 */ function $12b3d2ab131f1390$var$index(el, selector) {
    var index = 0;
    if (!el || !el.parentNode) return -1;
    /* jshint boss:true */ while(el = el.previousElementSibling)if (el.nodeName.toUpperCase() !== 'TEMPLATE' && el !== $12b3d2ab131f1390$export$31b3ca70d8f57423.clone && (!selector || $12b3d2ab131f1390$var$matches(el, selector))) index++;
    return index;
}
/**
 * Returns the scroll offset of the given element, added with all the scroll offsets of parent elements.
 * The value is returned in real pixels.
 * @param  {HTMLElement} el
 * @return {Array}             Offsets in the format of [left, top]
 */ function $12b3d2ab131f1390$var$getRelativeScrollOffset(el) {
    var offsetLeft = 0, offsetTop = 0, winScroller = $12b3d2ab131f1390$var$getWindowScrollingElement();
    if (el) do {
        var elMatrix = $12b3d2ab131f1390$var$matrix(el), scaleX = elMatrix.a, scaleY = elMatrix.d;
        offsetLeft += el.scrollLeft * scaleX;
        offsetTop += el.scrollTop * scaleY;
    }while (el !== winScroller && (el = el.parentNode));
    return [
        offsetLeft,
        offsetTop
    ];
}
/**
 * Returns the index of the object within the given array
 * @param  {Array} arr   Array that may or may not hold the object
 * @param  {Object} obj  An object that has a key-value pair unique to and identical to a key-value pair in the object you want to find
 * @return {Number}      The index of the object in the array, or -1
 */ function $12b3d2ab131f1390$var$indexOfObject(arr, obj) {
    for(var i in arr){
        if (!arr.hasOwnProperty(i)) continue;
        for(var key in obj){
            if (obj.hasOwnProperty(key) && obj[key] === arr[i][key]) return Number(i);
        }
    }
    return -1;
}
function $12b3d2ab131f1390$var$getParentAutoScrollElement(el, includeSelf) {
    // skip to window
    if (!el || !el.getBoundingClientRect) return $12b3d2ab131f1390$var$getWindowScrollingElement();
    var elem = el;
    var gotSelf = false;
    do // we don't need to get elem css if it isn't even overflowing in the first place (performance)
    if (elem.clientWidth < elem.scrollWidth || elem.clientHeight < elem.scrollHeight) {
        var elemCSS = $12b3d2ab131f1390$var$css(elem);
        if (elem.clientWidth < elem.scrollWidth && (elemCSS.overflowX == 'auto' || elemCSS.overflowX == 'scroll') || elem.clientHeight < elem.scrollHeight && (elemCSS.overflowY == 'auto' || elemCSS.overflowY == 'scroll')) {
            if (!elem.getBoundingClientRect || elem === document.body) return $12b3d2ab131f1390$var$getWindowScrollingElement();
            if (gotSelf || includeSelf) return elem;
            gotSelf = true;
        }
    }
    while (elem = elem.parentNode);
    return $12b3d2ab131f1390$var$getWindowScrollingElement();
}
function $12b3d2ab131f1390$var$extend(dst, src) {
    if (dst && src) {
        for(var key in src)if (src.hasOwnProperty(key)) dst[key] = src[key];
    }
    return dst;
}
function $12b3d2ab131f1390$var$isRectEqual(rect1, rect2) {
    return Math.round(rect1.top) === Math.round(rect2.top) && Math.round(rect1.left) === Math.round(rect2.left) && Math.round(rect1.height) === Math.round(rect2.height) && Math.round(rect1.width) === Math.round(rect2.width);
}
var $12b3d2ab131f1390$var$_throttleTimeout;
function $12b3d2ab131f1390$var$throttle(callback, ms) {
    return function() {
        if (!$12b3d2ab131f1390$var$_throttleTimeout) {
            var args = arguments, _this = this;
            if (args.length === 1) callback.call(_this, args[0]);
            else callback.apply(_this, args);
            $12b3d2ab131f1390$var$_throttleTimeout = setTimeout(function() {
                $12b3d2ab131f1390$var$_throttleTimeout = void 0;
            }, ms);
        }
    };
}
function $12b3d2ab131f1390$var$cancelThrottle() {
    clearTimeout($12b3d2ab131f1390$var$_throttleTimeout);
    $12b3d2ab131f1390$var$_throttleTimeout = void 0;
}
function $12b3d2ab131f1390$var$scrollBy(el, x, y) {
    el.scrollLeft += x;
    el.scrollTop += y;
}
function $12b3d2ab131f1390$var$clone(el) {
    var Polymer = window.Polymer;
    var $ = window.jQuery || window.Zepto;
    if (Polymer && Polymer.dom) return Polymer.dom(el).cloneNode(true);
    else if ($) return $(el).clone(true)[0];
    else return el.cloneNode(true);
}
function $12b3d2ab131f1390$var$setRect(el, rect) {
    $12b3d2ab131f1390$var$css(el, 'position', 'absolute');
    $12b3d2ab131f1390$var$css(el, 'top', rect.top);
    $12b3d2ab131f1390$var$css(el, 'left', rect.left);
    $12b3d2ab131f1390$var$css(el, 'width', rect.width);
    $12b3d2ab131f1390$var$css(el, 'height', rect.height);
}
function $12b3d2ab131f1390$var$unsetRect(el) {
    $12b3d2ab131f1390$var$css(el, 'position', '');
    $12b3d2ab131f1390$var$css(el, 'top', '');
    $12b3d2ab131f1390$var$css(el, 'left', '');
    $12b3d2ab131f1390$var$css(el, 'width', '');
    $12b3d2ab131f1390$var$css(el, 'height', '');
}
function $12b3d2ab131f1390$var$getChildContainingRectFromElement(container, options, ghostEl) {
    var rect = {};
    Array.from(container.children).forEach(function(child) {
        var _rect$left, _rect$top, _rect$right, _rect$bottom;
        if (!$12b3d2ab131f1390$var$closest(child, options.draggable, container, false) || child.animated || child === ghostEl) return;
        var childRect = $12b3d2ab131f1390$var$getRect(child);
        rect.left = Math.min((_rect$left = rect.left) !== null && _rect$left !== void 0 ? _rect$left : Infinity, childRect.left);
        rect.top = Math.min((_rect$top = rect.top) !== null && _rect$top !== void 0 ? _rect$top : Infinity, childRect.top);
        rect.right = Math.max((_rect$right = rect.right) !== null && _rect$right !== void 0 ? _rect$right : -Infinity, childRect.right);
        rect.bottom = Math.max((_rect$bottom = rect.bottom) !== null && _rect$bottom !== void 0 ? _rect$bottom : -Infinity, childRect.bottom);
    });
    rect.width = rect.right - rect.left;
    rect.height = rect.bottom - rect.top;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
var $12b3d2ab131f1390$var$expando = 'Sortable' + new Date().getTime();
function $12b3d2ab131f1390$var$AnimationStateManager() {
    var animationStates = [], animationCallbackId;
    return {
        captureAnimationState: function captureAnimationState() {
            animationStates = [];
            if (!this.options.animation) return;
            var children = [].slice.call(this.el.children);
            children.forEach(function(child) {
                if ($12b3d2ab131f1390$var$css(child, 'display') === 'none' || child === $12b3d2ab131f1390$export$31b3ca70d8f57423.ghost) return;
                animationStates.push({
                    target: child,
                    rect: $12b3d2ab131f1390$var$getRect(child)
                });
                var fromRect = $12b3d2ab131f1390$var$_objectSpread2({}, animationStates[animationStates.length - 1].rect);
                // If animating: compensate for current animation
                if (child.thisAnimationDuration) {
                    var childMatrix = $12b3d2ab131f1390$var$matrix(child, true);
                    if (childMatrix) {
                        fromRect.top -= childMatrix.f;
                        fromRect.left -= childMatrix.e;
                    }
                }
                child.fromRect = fromRect;
            });
        },
        addAnimationState: function addAnimationState(state) {
            animationStates.push(state);
        },
        removeAnimationState: function removeAnimationState(target) {
            animationStates.splice($12b3d2ab131f1390$var$indexOfObject(animationStates, {
                target: target
            }), 1);
        },
        animateAll: function animateAll(callback) {
            var _this = this;
            if (!this.options.animation) {
                clearTimeout(animationCallbackId);
                if (typeof callback === 'function') callback();
                return;
            }
            var animating = false, animationTime = 0;
            animationStates.forEach(function(state) {
                var time = 0, target = state.target, fromRect = target.fromRect, toRect = $12b3d2ab131f1390$var$getRect(target), prevFromRect = target.prevFromRect, prevToRect = target.prevToRect, animatingRect = state.rect, targetMatrix = $12b3d2ab131f1390$var$matrix(target, true);
                if (targetMatrix) {
                    // Compensate for current animation
                    toRect.top -= targetMatrix.f;
                    toRect.left -= targetMatrix.e;
                }
                target.toRect = toRect;
                if (target.thisAnimationDuration) // Could also check if animatingRect is between fromRect and toRect
                {
                    if ($12b3d2ab131f1390$var$isRectEqual(prevFromRect, toRect) && !$12b3d2ab131f1390$var$isRectEqual(fromRect, toRect) && // Make sure animatingRect is on line between toRect & fromRect
                    (animatingRect.top - toRect.top) / (animatingRect.left - toRect.left) === (fromRect.top - toRect.top) / (fromRect.left - toRect.left)) // If returning to same place as started from animation and on same axis
                    time = $12b3d2ab131f1390$var$calculateRealTime(animatingRect, prevFromRect, prevToRect, _this.options);
                }
                // if fromRect != toRect: animate
                if (!$12b3d2ab131f1390$var$isRectEqual(toRect, fromRect)) {
                    target.prevFromRect = fromRect;
                    target.prevToRect = toRect;
                    if (!time) time = _this.options.animation;
                    _this.animate(target, animatingRect, toRect, time);
                }
                if (time) {
                    animating = true;
                    animationTime = Math.max(animationTime, time);
                    clearTimeout(target.animationResetTimer);
                    target.animationResetTimer = setTimeout(function() {
                        target.animationTime = 0;
                        target.prevFromRect = null;
                        target.fromRect = null;
                        target.prevToRect = null;
                        target.thisAnimationDuration = null;
                    }, time);
                    target.thisAnimationDuration = time;
                }
            });
            clearTimeout(animationCallbackId);
            if (!animating) {
                if (typeof callback === 'function') callback();
            } else animationCallbackId = setTimeout(function() {
                if (typeof callback === 'function') callback();
            }, animationTime);
            animationStates = [];
        },
        animate: function animate(target, currentRect, toRect, duration) {
            if (duration) {
                $12b3d2ab131f1390$var$css(target, 'transition', '');
                $12b3d2ab131f1390$var$css(target, 'transform', '');
                var elMatrix = $12b3d2ab131f1390$var$matrix(this.el), scaleX = elMatrix && elMatrix.a, scaleY = elMatrix && elMatrix.d, translateX = (currentRect.left - toRect.left) / (scaleX || 1), translateY = (currentRect.top - toRect.top) / (scaleY || 1);
                target.animatingX = !!translateX;
                target.animatingY = !!translateY;
                $12b3d2ab131f1390$var$css(target, 'transform', 'translate3d(' + translateX + 'px,' + translateY + 'px,0)');
                this.forRepaintDummy = $12b3d2ab131f1390$var$repaint(target); // repaint
                $12b3d2ab131f1390$var$css(target, 'transition', 'transform ' + duration + 'ms' + (this.options.easing ? ' ' + this.options.easing : ''));
                $12b3d2ab131f1390$var$css(target, 'transform', 'translate3d(0,0,0)');
                typeof target.animated === 'number' && clearTimeout(target.animated);
                target.animated = setTimeout(function() {
                    $12b3d2ab131f1390$var$css(target, 'transition', '');
                    $12b3d2ab131f1390$var$css(target, 'transform', '');
                    target.animated = false;
                    target.animatingX = false;
                    target.animatingY = false;
                }, duration);
            }
        }
    };
}
function $12b3d2ab131f1390$var$repaint(target) {
    return target.offsetWidth;
}
function $12b3d2ab131f1390$var$calculateRealTime(animatingRect, fromRect, toRect, options) {
    return Math.sqrt(Math.pow(fromRect.top - animatingRect.top, 2) + Math.pow(fromRect.left - animatingRect.left, 2)) / Math.sqrt(Math.pow(fromRect.top - toRect.top, 2) + Math.pow(fromRect.left - toRect.left, 2)) * options.animation;
}
var $12b3d2ab131f1390$var$plugins = [];
var $12b3d2ab131f1390$var$defaults = {
    initializeByDefault: true
};
var $12b3d2ab131f1390$var$PluginManager = {
    mount: function mount(plugin) {
        // Set default static properties
        for(var option in $12b3d2ab131f1390$var$defaults)if ($12b3d2ab131f1390$var$defaults.hasOwnProperty(option) && !(option in plugin)) plugin[option] = $12b3d2ab131f1390$var$defaults[option];
        $12b3d2ab131f1390$var$plugins.forEach(function(p) {
            if (p.pluginName === plugin.pluginName) throw "Sortable: Cannot mount plugin ".concat(plugin.pluginName, " more than once");
        });
        $12b3d2ab131f1390$var$plugins.push(plugin);
    },
    pluginEvent: function pluginEvent(eventName, sortable, evt) {
        var _this = this;
        this.eventCanceled = false;
        evt.cancel = function() {
            _this.eventCanceled = true;
        };
        var eventNameGlobal = eventName + 'Global';
        $12b3d2ab131f1390$var$plugins.forEach(function(plugin) {
            if (!sortable[plugin.pluginName]) return;
            // Fire global events if it exists in this sortable
            if (sortable[plugin.pluginName][eventNameGlobal]) sortable[plugin.pluginName][eventNameGlobal]($12b3d2ab131f1390$var$_objectSpread2({
                sortable: sortable
            }, evt));
            // Only fire plugin event if plugin is enabled in this sortable,
            // and plugin has event defined
            if (sortable.options[plugin.pluginName] && sortable[plugin.pluginName][eventName]) sortable[plugin.pluginName][eventName]($12b3d2ab131f1390$var$_objectSpread2({
                sortable: sortable
            }, evt));
        });
    },
    initializePlugins: function initializePlugins(sortable, el, defaults, options) {
        $12b3d2ab131f1390$var$plugins.forEach(function(plugin) {
            var pluginName = plugin.pluginName;
            if (!sortable.options[pluginName] && !plugin.initializeByDefault) return;
            var initialized = new plugin(sortable, el, sortable.options);
            initialized.sortable = sortable;
            initialized.options = sortable.options;
            sortable[pluginName] = initialized;
            // Add default options from plugin
            $12b3d2ab131f1390$var$_extends(defaults, initialized.defaults);
        });
        for(var option in sortable.options){
            if (!sortable.options.hasOwnProperty(option)) continue;
            var modified = this.modifyOption(sortable, option, sortable.options[option]);
            if (typeof modified !== 'undefined') sortable.options[option] = modified;
        }
    },
    getEventProperties: function getEventProperties(name, sortable) {
        var eventProperties = {};
        $12b3d2ab131f1390$var$plugins.forEach(function(plugin) {
            if (typeof plugin.eventProperties !== 'function') return;
            $12b3d2ab131f1390$var$_extends(eventProperties, plugin.eventProperties.call(sortable[plugin.pluginName], name));
        });
        return eventProperties;
    },
    modifyOption: function modifyOption(sortable, name, value) {
        var modifiedValue;
        $12b3d2ab131f1390$var$plugins.forEach(function(plugin) {
            // Plugin must exist on the Sortable
            if (!sortable[plugin.pluginName]) return;
            // If static option listener exists for this option, call in the context of the Sortable's instance of this plugin
            if (plugin.optionListeners && typeof plugin.optionListeners[name] === 'function') modifiedValue = plugin.optionListeners[name].call(sortable[plugin.pluginName], value);
        });
        return modifiedValue;
    }
};
function $12b3d2ab131f1390$var$dispatchEvent(_ref) {
    var sortable = _ref.sortable, rootEl = _ref.rootEl, name = _ref.name, targetEl = _ref.targetEl, cloneEl = _ref.cloneEl, toEl = _ref.toEl, fromEl = _ref.fromEl, oldIndex = _ref.oldIndex, newIndex = _ref.newIndex, oldDraggableIndex = _ref.oldDraggableIndex, newDraggableIndex = _ref.newDraggableIndex, originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, extraEventProperties = _ref.extraEventProperties;
    sortable = sortable || rootEl && rootEl[$12b3d2ab131f1390$var$expando];
    if (!sortable) return;
    var evt, options = sortable.options, onName = 'on' + name.charAt(0).toUpperCase() + name.substr(1);
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$12b3d2ab131f1390$var$IE11OrLess && !$12b3d2ab131f1390$var$Edge) evt = new CustomEvent(name, {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent(name, true, true);
    }
    evt.to = toEl || rootEl;
    evt.from = fromEl || rootEl;
    evt.item = targetEl || rootEl;
    evt.clone = cloneEl;
    evt.oldIndex = oldIndex;
    evt.newIndex = newIndex;
    evt.oldDraggableIndex = oldDraggableIndex;
    evt.newDraggableIndex = newDraggableIndex;
    evt.originalEvent = originalEvent;
    evt.pullMode = putSortable ? putSortable.lastPutMode : undefined;
    var allEventProperties = $12b3d2ab131f1390$var$_objectSpread2($12b3d2ab131f1390$var$_objectSpread2({}, extraEventProperties), $12b3d2ab131f1390$var$PluginManager.getEventProperties(name, sortable));
    for(var option in allEventProperties)evt[option] = allEventProperties[option];
    if (rootEl) rootEl.dispatchEvent(evt);
    if (options[onName]) options[onName].call(sortable, evt);
}
var $12b3d2ab131f1390$var$_excluded = [
    "evt"
];
var $12b3d2ab131f1390$var$pluginEvent = function pluginEvent(eventName, sortable) {
    var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {}, originalEvent = _ref.evt, data = $12b3d2ab131f1390$var$_objectWithoutProperties(_ref, $12b3d2ab131f1390$var$_excluded);
    $12b3d2ab131f1390$var$PluginManager.pluginEvent.bind($12b3d2ab131f1390$export$31b3ca70d8f57423)(eventName, sortable, $12b3d2ab131f1390$var$_objectSpread2({
        dragEl: $12b3d2ab131f1390$var$dragEl,
        parentEl: $12b3d2ab131f1390$var$parentEl,
        ghostEl: $12b3d2ab131f1390$var$ghostEl,
        rootEl: $12b3d2ab131f1390$var$rootEl,
        nextEl: $12b3d2ab131f1390$var$nextEl,
        lastDownEl: $12b3d2ab131f1390$var$lastDownEl,
        cloneEl: $12b3d2ab131f1390$var$cloneEl,
        cloneHidden: $12b3d2ab131f1390$var$cloneHidden,
        dragStarted: $12b3d2ab131f1390$var$moved,
        putSortable: $12b3d2ab131f1390$var$putSortable,
        activeSortable: $12b3d2ab131f1390$export$31b3ca70d8f57423.active,
        originalEvent: originalEvent,
        oldIndex: $12b3d2ab131f1390$var$oldIndex,
        oldDraggableIndex: $12b3d2ab131f1390$var$oldDraggableIndex,
        newIndex: $12b3d2ab131f1390$var$newIndex,
        newDraggableIndex: $12b3d2ab131f1390$var$newDraggableIndex,
        hideGhostForTarget: $12b3d2ab131f1390$var$_hideGhostForTarget,
        unhideGhostForTarget: $12b3d2ab131f1390$var$_unhideGhostForTarget,
        cloneNowHidden: function cloneNowHidden() {
            $12b3d2ab131f1390$var$cloneHidden = true;
        },
        cloneNowShown: function cloneNowShown() {
            $12b3d2ab131f1390$var$cloneHidden = false;
        },
        dispatchSortableEvent: function dispatchSortableEvent(name) {
            $12b3d2ab131f1390$var$_dispatchEvent({
                sortable: sortable,
                name: name,
                originalEvent: originalEvent
            });
        }
    }, data));
};
function $12b3d2ab131f1390$var$_dispatchEvent(info) {
    $12b3d2ab131f1390$var$dispatchEvent($12b3d2ab131f1390$var$_objectSpread2({
        putSortable: $12b3d2ab131f1390$var$putSortable,
        cloneEl: $12b3d2ab131f1390$var$cloneEl,
        targetEl: $12b3d2ab131f1390$var$dragEl,
        rootEl: $12b3d2ab131f1390$var$rootEl,
        oldIndex: $12b3d2ab131f1390$var$oldIndex,
        oldDraggableIndex: $12b3d2ab131f1390$var$oldDraggableIndex,
        newIndex: $12b3d2ab131f1390$var$newIndex,
        newDraggableIndex: $12b3d2ab131f1390$var$newDraggableIndex
    }, info));
}
var $12b3d2ab131f1390$var$dragEl, $12b3d2ab131f1390$var$parentEl, $12b3d2ab131f1390$var$ghostEl, $12b3d2ab131f1390$var$rootEl, $12b3d2ab131f1390$var$nextEl, $12b3d2ab131f1390$var$lastDownEl, $12b3d2ab131f1390$var$cloneEl, $12b3d2ab131f1390$var$cloneHidden, $12b3d2ab131f1390$var$oldIndex, $12b3d2ab131f1390$var$newIndex, $12b3d2ab131f1390$var$oldDraggableIndex, $12b3d2ab131f1390$var$newDraggableIndex, $12b3d2ab131f1390$var$activeGroup, $12b3d2ab131f1390$var$putSortable, $12b3d2ab131f1390$var$awaitingDragStarted = false, $12b3d2ab131f1390$var$ignoreNextClick = false, $12b3d2ab131f1390$var$sortables = [], $12b3d2ab131f1390$var$tapEvt, $12b3d2ab131f1390$var$touchEvt, $12b3d2ab131f1390$var$lastDx, $12b3d2ab131f1390$var$lastDy, $12b3d2ab131f1390$var$tapDistanceLeft, $12b3d2ab131f1390$var$tapDistanceTop, $12b3d2ab131f1390$var$moved, $12b3d2ab131f1390$var$lastTarget, $12b3d2ab131f1390$var$lastDirection, $12b3d2ab131f1390$var$pastFirstInvertThresh = false, $12b3d2ab131f1390$var$isCircumstantialInvert = false, $12b3d2ab131f1390$var$targetMoveDistance, // For positioning ghost absolutely
$12b3d2ab131f1390$var$ghostRelativeParent, $12b3d2ab131f1390$var$ghostRelativeParentInitialScroll = [], // (left, top)
$12b3d2ab131f1390$var$_silent = false, $12b3d2ab131f1390$var$savedInputChecked = [];
/** @const */ var $12b3d2ab131f1390$var$documentExists = typeof document !== 'undefined', $12b3d2ab131f1390$var$PositionGhostAbsolutely = $12b3d2ab131f1390$var$IOS, $12b3d2ab131f1390$var$CSSFloatProperty = $12b3d2ab131f1390$var$Edge || $12b3d2ab131f1390$var$IE11OrLess ? 'cssFloat' : 'float', // This will not pass for IE9, because IE9 DnD only works on anchors
$12b3d2ab131f1390$var$supportDraggable = $12b3d2ab131f1390$var$documentExists && !$12b3d2ab131f1390$var$ChromeForAndroid && !$12b3d2ab131f1390$var$IOS && 'draggable' in document.createElement('div'), $12b3d2ab131f1390$var$supportCssPointerEvents = function() {
    if (!$12b3d2ab131f1390$var$documentExists) return;
    // false when <= IE11
    if ($12b3d2ab131f1390$var$IE11OrLess) return false;
    var el = document.createElement('x');
    el.style.cssText = 'pointer-events:auto';
    return el.style.pointerEvents === 'auto';
}(), $12b3d2ab131f1390$var$_detectDirection = function _detectDirection(el, options) {
    var elCSS = $12b3d2ab131f1390$var$css(el), elWidth = parseInt(elCSS.width) - parseInt(elCSS.paddingLeft) - parseInt(elCSS.paddingRight) - parseInt(elCSS.borderLeftWidth) - parseInt(elCSS.borderRightWidth), child1 = $12b3d2ab131f1390$var$getChild(el, 0, options), child2 = $12b3d2ab131f1390$var$getChild(el, 1, options), firstChildCSS = child1 && $12b3d2ab131f1390$var$css(child1), secondChildCSS = child2 && $12b3d2ab131f1390$var$css(child2), firstChildWidth = firstChildCSS && parseInt(firstChildCSS.marginLeft) + parseInt(firstChildCSS.marginRight) + $12b3d2ab131f1390$var$getRect(child1).width, secondChildWidth = secondChildCSS && parseInt(secondChildCSS.marginLeft) + parseInt(secondChildCSS.marginRight) + $12b3d2ab131f1390$var$getRect(child2).width;
    if (elCSS.display === 'flex') return elCSS.flexDirection === 'column' || elCSS.flexDirection === 'column-reverse' ? 'vertical' : 'horizontal';
    if (elCSS.display === 'grid') return elCSS.gridTemplateColumns.split(' ').length <= 1 ? 'vertical' : 'horizontal';
    if (child1 && firstChildCSS["float"] && firstChildCSS["float"] !== 'none') {
        var touchingSideChild2 = firstChildCSS["float"] === 'left' ? 'left' : 'right';
        return child2 && (secondChildCSS.clear === 'both' || secondChildCSS.clear === touchingSideChild2) ? 'vertical' : 'horizontal';
    }
    return child1 && (firstChildCSS.display === 'block' || firstChildCSS.display === 'flex' || firstChildCSS.display === 'table' || firstChildCSS.display === 'grid' || firstChildWidth >= elWidth && elCSS[$12b3d2ab131f1390$var$CSSFloatProperty] === 'none' || child2 && elCSS[$12b3d2ab131f1390$var$CSSFloatProperty] === 'none' && firstChildWidth + secondChildWidth > elWidth) ? 'vertical' : 'horizontal';
}, $12b3d2ab131f1390$var$_dragElInRowColumn = function _dragElInRowColumn(dragRect, targetRect, vertical) {
    var dragElS1Opp = vertical ? dragRect.left : dragRect.top, dragElS2Opp = vertical ? dragRect.right : dragRect.bottom, dragElOppLength = vertical ? dragRect.width : dragRect.height, targetS1Opp = vertical ? targetRect.left : targetRect.top, targetS2Opp = vertical ? targetRect.right : targetRect.bottom, targetOppLength = vertical ? targetRect.width : targetRect.height;
    return dragElS1Opp === targetS1Opp || dragElS2Opp === targetS2Opp || dragElS1Opp + dragElOppLength / 2 === targetS1Opp + targetOppLength / 2;
}, /**
   * Detects first nearest empty sortable to X and Y position using emptyInsertThreshold.
   * @param  {Number} x      X position
   * @param  {Number} y      Y position
   * @return {HTMLElement}   Element of the first found nearest Sortable
   */ $12b3d2ab131f1390$var$_detectNearestEmptySortable = function _detectNearestEmptySortable(x, y) {
    var ret;
    $12b3d2ab131f1390$var$sortables.some(function(sortable) {
        var threshold = sortable[$12b3d2ab131f1390$var$expando].options.emptyInsertThreshold;
        if (!threshold || $12b3d2ab131f1390$var$lastChild(sortable)) return;
        var rect = $12b3d2ab131f1390$var$getRect(sortable), insideHorizontally = x >= rect.left - threshold && x <= rect.right + threshold, insideVertically = y >= rect.top - threshold && y <= rect.bottom + threshold;
        if (insideHorizontally && insideVertically) return ret = sortable;
    });
    return ret;
}, $12b3d2ab131f1390$var$_prepareGroup = function _prepareGroup(options) {
    function toFn(value, pull) {
        return function(to, from, dragEl, evt) {
            var sameGroup = to.options.group.name && from.options.group.name && to.options.group.name === from.options.group.name;
            if (value == null && (pull || sameGroup)) // Default pull value
            // Default pull and put value if same group
            return true;
            else if (value == null || value === false) return false;
            else if (pull && value === 'clone') return value;
            else if (typeof value === 'function') return toFn(value(to, from, dragEl, evt), pull)(to, from, dragEl, evt);
            else {
                var otherGroup = (pull ? to : from).options.group.name;
                return value === true || typeof value === 'string' && value === otherGroup || value.join && value.indexOf(otherGroup) > -1;
            }
        };
    }
    var group = {};
    var originalGroup = options.group;
    if (!originalGroup || $12b3d2ab131f1390$var$_typeof(originalGroup) != 'object') originalGroup = {
        name: originalGroup
    };
    group.name = originalGroup.name;
    group.checkPull = toFn(originalGroup.pull, true);
    group.checkPut = toFn(originalGroup.put);
    group.revertClone = originalGroup.revertClone;
    options.group = group;
}, $12b3d2ab131f1390$var$_hideGhostForTarget = function _hideGhostForTarget() {
    if (!$12b3d2ab131f1390$var$supportCssPointerEvents && $12b3d2ab131f1390$var$ghostEl) $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'display', 'none');
}, $12b3d2ab131f1390$var$_unhideGhostForTarget = function _unhideGhostForTarget() {
    if (!$12b3d2ab131f1390$var$supportCssPointerEvents && $12b3d2ab131f1390$var$ghostEl) $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'display', '');
};
// #1184 fix - Prevent click event on fallback if dragged but item not changed position
if ($12b3d2ab131f1390$var$documentExists && !$12b3d2ab131f1390$var$ChromeForAndroid) document.addEventListener('click', function(evt) {
    if ($12b3d2ab131f1390$var$ignoreNextClick) {
        evt.preventDefault();
        evt.stopPropagation && evt.stopPropagation();
        evt.stopImmediatePropagation && evt.stopImmediatePropagation();
        $12b3d2ab131f1390$var$ignoreNextClick = false;
        return false;
    }
}, true);
var $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent = function nearestEmptyInsertDetectEvent(evt) {
    if ($12b3d2ab131f1390$var$dragEl) {
        evt = evt.touches ? evt.touches[0] : evt;
        var nearest = $12b3d2ab131f1390$var$_detectNearestEmptySortable(evt.clientX, evt.clientY);
        if (nearest) {
            // Create imitation event
            var event = {};
            for(var i in evt)if (evt.hasOwnProperty(i)) event[i] = evt[i];
            event.target = event.rootEl = nearest;
            event.preventDefault = void 0;
            event.stopPropagation = void 0;
            nearest[$12b3d2ab131f1390$var$expando]._onDragOver(event);
        }
    }
};
var $12b3d2ab131f1390$var$_checkOutsideTargetEl = function _checkOutsideTargetEl(evt) {
    if ($12b3d2ab131f1390$var$dragEl) $12b3d2ab131f1390$var$dragEl.parentNode[$12b3d2ab131f1390$var$expando]._isOutsideThisEl(evt.target);
};
/**
 * @class  Sortable
 * @param  {HTMLElement}  el
 * @param  {Object}       [options]
 */ function $12b3d2ab131f1390$export$31b3ca70d8f57423(el, options) {
    if (!(el && el.nodeType && el.nodeType === 1)) throw "Sortable: `el` must be an HTMLElement, not ".concat(({}).toString.call(el));
    this.el = el; // root element
    this.options = options = $12b3d2ab131f1390$var$_extends({}, options);
    // Export instance
    el[$12b3d2ab131f1390$var$expando] = this;
    var defaults = {
        group: null,
        sort: true,
        disabled: false,
        store: null,
        handle: null,
        draggable: /^[uo]l$/i.test(el.nodeName) ? '>li' : '>*',
        swapThreshold: 1,
        // percentage; 0 <= x <= 1
        invertSwap: false,
        // invert always
        invertedSwapThreshold: null,
        // will be set to same as swapThreshold if default
        removeCloneOnHide: true,
        direction: function direction() {
            return $12b3d2ab131f1390$var$_detectDirection(el, this.options);
        },
        ghostClass: 'sortable-ghost',
        chosenClass: 'sortable-chosen',
        dragClass: 'sortable-drag',
        ignore: 'a, img',
        filter: null,
        preventOnFilter: true,
        animation: 0,
        easing: null,
        setData: function setData(dataTransfer, dragEl) {
            dataTransfer.setData('Text', dragEl.textContent);
        },
        dropBubble: false,
        dragoverBubble: false,
        dataIdAttr: 'data-id',
        delay: 0,
        delayOnTouchOnly: false,
        touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
        forceFallback: false,
        fallbackClass: 'sortable-fallback',
        fallbackOnBody: false,
        fallbackTolerance: 0,
        fallbackOffset: {
            x: 0,
            y: 0
        },
        // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
        supportPointer: $12b3d2ab131f1390$export$31b3ca70d8f57423.supportPointer !== false && 'PointerEvent' in window && (!$12b3d2ab131f1390$var$Safari || $12b3d2ab131f1390$var$IOS),
        emptyInsertThreshold: 5
    };
    $12b3d2ab131f1390$var$PluginManager.initializePlugins(this, el, defaults);
    // Set default options
    for(var name in defaults)!(name in options) && (options[name] = defaults[name]);
    $12b3d2ab131f1390$var$_prepareGroup(options);
    // Bind all private methods
    for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    // Setup drag mode
    this.nativeDraggable = options.forceFallback ? false : $12b3d2ab131f1390$var$supportDraggable;
    if (this.nativeDraggable) // Touch start threshold cannot be greater than the native dragstart threshold
    this.options.touchStartThreshold = 1;
    // Bind events
    if (options.supportPointer) $12b3d2ab131f1390$var$on(el, 'pointerdown', this._onTapStart);
    else {
        $12b3d2ab131f1390$var$on(el, 'mousedown', this._onTapStart);
        $12b3d2ab131f1390$var$on(el, 'touchstart', this._onTapStart);
    }
    if (this.nativeDraggable) {
        $12b3d2ab131f1390$var$on(el, 'dragover', this);
        $12b3d2ab131f1390$var$on(el, 'dragenter', this);
    }
    $12b3d2ab131f1390$var$sortables.push(this.el);
    // Restore sorting
    options.store && options.store.get && this.sort(options.store.get(this) || []);
    // Add animation state manager
    $12b3d2ab131f1390$var$_extends(this, $12b3d2ab131f1390$var$AnimationStateManager());
}
$12b3d2ab131f1390$export$31b3ca70d8f57423.prototype = /** @lends Sortable.prototype */ {
    constructor: $12b3d2ab131f1390$export$31b3ca70d8f57423,
    _isOutsideThisEl: function _isOutsideThisEl(target) {
        if (!this.el.contains(target) && target !== this.el) $12b3d2ab131f1390$var$lastTarget = null;
    },
    _getDirection: function _getDirection(evt, target) {
        return typeof this.options.direction === 'function' ? this.options.direction.call(this, evt, target, $12b3d2ab131f1390$var$dragEl) : this.options.direction;
    },
    _onTapStart: function _onTapStart(/** Event|TouchEvent */ evt) {
        if (!evt.cancelable) return;
        var _this = this, el = this.el, options = this.options, preventOnFilter = options.preventOnFilter, type = evt.type, touch = evt.touches && evt.touches[0] || evt.pointerType && evt.pointerType === 'touch' && evt, target = (touch || evt).target, originalTarget = evt.target.shadowRoot && (evt.path && evt.path[0] || evt.composedPath && evt.composedPath()[0]) || target, filter = options.filter;
        $12b3d2ab131f1390$var$_saveInputCheckedState(el);
        // Don't trigger start event when an element is been dragged, otherwise the evt.oldindex always wrong when set option.group.
        if ($12b3d2ab131f1390$var$dragEl) return;
        if (/mousedown|pointerdown/.test(type) && evt.button !== 0 || options.disabled) return; // only left button and enabled
        // cancel dnd if original target is content editable
        if (originalTarget.isContentEditable) return;
        // Safari ignores further event handling after mousedown
        if (!this.nativeDraggable && $12b3d2ab131f1390$var$Safari && target && target.tagName.toUpperCase() === 'SELECT') return;
        target = $12b3d2ab131f1390$var$closest(target, options.draggable, el, false);
        if (target && target.animated) return;
        if ($12b3d2ab131f1390$var$lastDownEl === target) // Ignoring duplicate `down`
        return;
        // Get the index of the dragged element within its parent
        $12b3d2ab131f1390$var$oldIndex = $12b3d2ab131f1390$var$index(target);
        $12b3d2ab131f1390$var$oldDraggableIndex = $12b3d2ab131f1390$var$index(target, options.draggable);
        // Check filter
        if (typeof filter === 'function') {
            if (filter.call(this, evt, target, this)) {
                $12b3d2ab131f1390$var$_dispatchEvent({
                    sortable: _this,
                    rootEl: originalTarget,
                    name: 'filter',
                    targetEl: target,
                    toEl: el,
                    fromEl: el
                });
                $12b3d2ab131f1390$var$pluginEvent('filter', _this, {
                    evt: evt
                });
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        } else if (filter) {
            filter = filter.split(',').some(function(criteria) {
                criteria = $12b3d2ab131f1390$var$closest(originalTarget, criteria.trim(), el, false);
                if (criteria) {
                    $12b3d2ab131f1390$var$_dispatchEvent({
                        sortable: _this,
                        rootEl: criteria,
                        name: 'filter',
                        targetEl: target,
                        fromEl: el,
                        toEl: el
                    });
                    $12b3d2ab131f1390$var$pluginEvent('filter', _this, {
                        evt: evt
                    });
                    return true;
                }
            });
            if (filter) {
                preventOnFilter && evt.preventDefault();
                return; // cancel dnd
            }
        }
        if (options.handle && !$12b3d2ab131f1390$var$closest(originalTarget, options.handle, el, false)) return;
        // Prepare `dragstart`
        this._prepareDragStart(evt, touch, target);
    },
    _prepareDragStart: function _prepareDragStart(/** Event */ evt, /** Touch */ touch, /** HTMLElement */ target) {
        var _this = this, el = _this.el, options = _this.options, ownerDocument = el.ownerDocument, dragStartFn;
        if (target && !$12b3d2ab131f1390$var$dragEl && target.parentNode === el) {
            var dragRect = $12b3d2ab131f1390$var$getRect(target);
            $12b3d2ab131f1390$var$rootEl = el;
            $12b3d2ab131f1390$var$dragEl = target;
            $12b3d2ab131f1390$var$parentEl = $12b3d2ab131f1390$var$dragEl.parentNode;
            $12b3d2ab131f1390$var$nextEl = $12b3d2ab131f1390$var$dragEl.nextSibling;
            $12b3d2ab131f1390$var$lastDownEl = target;
            $12b3d2ab131f1390$var$activeGroup = options.group;
            $12b3d2ab131f1390$export$31b3ca70d8f57423.dragged = $12b3d2ab131f1390$var$dragEl;
            $12b3d2ab131f1390$var$tapEvt = {
                target: $12b3d2ab131f1390$var$dragEl,
                clientX: (touch || evt).clientX,
                clientY: (touch || evt).clientY
            };
            $12b3d2ab131f1390$var$tapDistanceLeft = $12b3d2ab131f1390$var$tapEvt.clientX - dragRect.left;
            $12b3d2ab131f1390$var$tapDistanceTop = $12b3d2ab131f1390$var$tapEvt.clientY - dragRect.top;
            this._lastX = (touch || evt).clientX;
            this._lastY = (touch || evt).clientY;
            $12b3d2ab131f1390$var$dragEl.style['will-change'] = 'all';
            dragStartFn = function dragStartFn() {
                $12b3d2ab131f1390$var$pluginEvent('delayEnded', _this, {
                    evt: evt
                });
                if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
                    _this._onDrop();
                    return;
                }
                // Delayed drag has been triggered
                // we can re-enable the events: touchmove/mousemove
                _this._disableDelayedDragEvents();
                if (!$12b3d2ab131f1390$var$FireFox && _this.nativeDraggable) $12b3d2ab131f1390$var$dragEl.draggable = true;
                // Bind the events: dragstart/dragend
                _this._triggerDragStart(evt, touch);
                // Drag start event
                $12b3d2ab131f1390$var$_dispatchEvent({
                    sortable: _this,
                    name: 'choose',
                    originalEvent: evt
                });
                // Chosen item
                $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, options.chosenClass, true);
            };
            // Disable "draggable"
            options.ignore.split(',').forEach(function(criteria) {
                $12b3d2ab131f1390$var$find($12b3d2ab131f1390$var$dragEl, criteria.trim(), $12b3d2ab131f1390$var$_disableDraggable);
            });
            $12b3d2ab131f1390$var$on(ownerDocument, 'dragover', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
            $12b3d2ab131f1390$var$on(ownerDocument, 'mousemove', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
            $12b3d2ab131f1390$var$on(ownerDocument, 'touchmove', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
            if (options.supportPointer) {
                $12b3d2ab131f1390$var$on(ownerDocument, 'pointerup', _this._onDrop);
                // Native D&D triggers pointercancel
                !this.nativeDraggable && $12b3d2ab131f1390$var$on(ownerDocument, 'pointercancel', _this._onDrop);
            } else {
                $12b3d2ab131f1390$var$on(ownerDocument, 'mouseup', _this._onDrop);
                $12b3d2ab131f1390$var$on(ownerDocument, 'touchend', _this._onDrop);
                $12b3d2ab131f1390$var$on(ownerDocument, 'touchcancel', _this._onDrop);
            }
            // Make dragEl draggable (must be before delay for FireFox)
            if ($12b3d2ab131f1390$var$FireFox && this.nativeDraggable) {
                this.options.touchStartThreshold = 4;
                $12b3d2ab131f1390$var$dragEl.draggable = true;
            }
            $12b3d2ab131f1390$var$pluginEvent('delayStart', this, {
                evt: evt
            });
            // Delay is impossible for native DnD in Edge or IE
            if (options.delay && (!options.delayOnTouchOnly || touch) && (!this.nativeDraggable || !($12b3d2ab131f1390$var$Edge || $12b3d2ab131f1390$var$IE11OrLess))) {
                if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
                    this._onDrop();
                    return;
                }
                // If the user moves the pointer or let go the click or touch
                // before the delay has been reached:
                // disable the delayed drag
                if (options.supportPointer) {
                    $12b3d2ab131f1390$var$on(ownerDocument, 'pointerup', _this._disableDelayedDrag);
                    $12b3d2ab131f1390$var$on(ownerDocument, 'pointercancel', _this._disableDelayedDrag);
                } else {
                    $12b3d2ab131f1390$var$on(ownerDocument, 'mouseup', _this._disableDelayedDrag);
                    $12b3d2ab131f1390$var$on(ownerDocument, 'touchend', _this._disableDelayedDrag);
                    $12b3d2ab131f1390$var$on(ownerDocument, 'touchcancel', _this._disableDelayedDrag);
                }
                $12b3d2ab131f1390$var$on(ownerDocument, 'mousemove', _this._delayedDragTouchMoveHandler);
                $12b3d2ab131f1390$var$on(ownerDocument, 'touchmove', _this._delayedDragTouchMoveHandler);
                options.supportPointer && $12b3d2ab131f1390$var$on(ownerDocument, 'pointermove', _this._delayedDragTouchMoveHandler);
                _this._dragStartTimer = setTimeout(dragStartFn, options.delay);
            } else dragStartFn();
        }
    },
    _delayedDragTouchMoveHandler: function _delayedDragTouchMoveHandler(/** TouchEvent|PointerEvent **/ e) {
        var touch = e.touches ? e.touches[0] : e;
        if (Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1))) this._disableDelayedDrag();
    },
    _disableDelayedDrag: function _disableDelayedDrag() {
        $12b3d2ab131f1390$var$dragEl && $12b3d2ab131f1390$var$_disableDraggable($12b3d2ab131f1390$var$dragEl);
        clearTimeout(this._dragStartTimer);
        this._disableDelayedDragEvents();
    },
    _disableDelayedDragEvents: function _disableDelayedDragEvents() {
        var ownerDocument = this.el.ownerDocument;
        $12b3d2ab131f1390$var$off(ownerDocument, 'mouseup', this._disableDelayedDrag);
        $12b3d2ab131f1390$var$off(ownerDocument, 'touchend', this._disableDelayedDrag);
        $12b3d2ab131f1390$var$off(ownerDocument, 'touchcancel', this._disableDelayedDrag);
        $12b3d2ab131f1390$var$off(ownerDocument, 'pointerup', this._disableDelayedDrag);
        $12b3d2ab131f1390$var$off(ownerDocument, 'pointercancel', this._disableDelayedDrag);
        $12b3d2ab131f1390$var$off(ownerDocument, 'mousemove', this._delayedDragTouchMoveHandler);
        $12b3d2ab131f1390$var$off(ownerDocument, 'touchmove', this._delayedDragTouchMoveHandler);
        $12b3d2ab131f1390$var$off(ownerDocument, 'pointermove', this._delayedDragTouchMoveHandler);
    },
    _triggerDragStart: function _triggerDragStart(/** Event */ evt, /** Touch */ touch) {
        touch = touch || evt.pointerType == 'touch' && evt;
        if (!this.nativeDraggable || touch) {
            if (this.options.supportPointer) $12b3d2ab131f1390$var$on(document, 'pointermove', this._onTouchMove);
            else if (touch) $12b3d2ab131f1390$var$on(document, 'touchmove', this._onTouchMove);
            else $12b3d2ab131f1390$var$on(document, 'mousemove', this._onTouchMove);
        } else {
            $12b3d2ab131f1390$var$on($12b3d2ab131f1390$var$dragEl, 'dragend', this);
            $12b3d2ab131f1390$var$on($12b3d2ab131f1390$var$rootEl, 'dragstart', this._onDragStart);
        }
        try {
            if (document.selection) $12b3d2ab131f1390$var$_nextTick(function() {
                document.selection.empty();
            });
            else window.getSelection().removeAllRanges();
        } catch (err) {}
    },
    _dragStarted: function _dragStarted(fallback, evt) {
        $12b3d2ab131f1390$var$awaitingDragStarted = false;
        if ($12b3d2ab131f1390$var$rootEl && $12b3d2ab131f1390$var$dragEl) {
            $12b3d2ab131f1390$var$pluginEvent('dragStarted', this, {
                evt: evt
            });
            if (this.nativeDraggable) $12b3d2ab131f1390$var$on(document, 'dragover', $12b3d2ab131f1390$var$_checkOutsideTargetEl);
            var options = this.options;
            // Apply effect
            !fallback && $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, options.dragClass, false);
            $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, options.ghostClass, true);
            $12b3d2ab131f1390$export$31b3ca70d8f57423.active = this;
            fallback && this._appendGhost();
            // Drag start event
            $12b3d2ab131f1390$var$_dispatchEvent({
                sortable: this,
                name: 'start',
                originalEvent: evt
            });
        } else this._nulling();
    },
    _emulateDragOver: function _emulateDragOver() {
        if ($12b3d2ab131f1390$var$touchEvt) {
            this._lastX = $12b3d2ab131f1390$var$touchEvt.clientX;
            this._lastY = $12b3d2ab131f1390$var$touchEvt.clientY;
            $12b3d2ab131f1390$var$_hideGhostForTarget();
            var target = document.elementFromPoint($12b3d2ab131f1390$var$touchEvt.clientX, $12b3d2ab131f1390$var$touchEvt.clientY);
            var parent = target;
            while(target && target.shadowRoot){
                target = target.shadowRoot.elementFromPoint($12b3d2ab131f1390$var$touchEvt.clientX, $12b3d2ab131f1390$var$touchEvt.clientY);
                if (target === parent) break;
                parent = target;
            }
            $12b3d2ab131f1390$var$dragEl.parentNode[$12b3d2ab131f1390$var$expando]._isOutsideThisEl(target);
            if (parent) do {
                if (parent[$12b3d2ab131f1390$var$expando]) {
                    var inserted = void 0;
                    inserted = parent[$12b3d2ab131f1390$var$expando]._onDragOver({
                        clientX: $12b3d2ab131f1390$var$touchEvt.clientX,
                        clientY: $12b3d2ab131f1390$var$touchEvt.clientY,
                        target: target,
                        rootEl: parent
                    });
                    if (inserted && !this.options.dragoverBubble) break;
                }
                target = parent; // store last element
            }while (parent = $12b3d2ab131f1390$var$getParentOrHost(parent));
            $12b3d2ab131f1390$var$_unhideGhostForTarget();
        }
    },
    _onTouchMove: function _onTouchMove(/**TouchEvent*/ evt) {
        if ($12b3d2ab131f1390$var$tapEvt) {
            var options = this.options, fallbackTolerance = options.fallbackTolerance, fallbackOffset = options.fallbackOffset, touch = evt.touches ? evt.touches[0] : evt, ghostMatrix = $12b3d2ab131f1390$var$ghostEl && $12b3d2ab131f1390$var$matrix($12b3d2ab131f1390$var$ghostEl, true), scaleX = $12b3d2ab131f1390$var$ghostEl && ghostMatrix && ghostMatrix.a, scaleY = $12b3d2ab131f1390$var$ghostEl && ghostMatrix && ghostMatrix.d, relativeScrollOffset = $12b3d2ab131f1390$var$PositionGhostAbsolutely && $12b3d2ab131f1390$var$ghostRelativeParent && $12b3d2ab131f1390$var$getRelativeScrollOffset($12b3d2ab131f1390$var$ghostRelativeParent), dx = (touch.clientX - $12b3d2ab131f1390$var$tapEvt.clientX + fallbackOffset.x) / (scaleX || 1) + (relativeScrollOffset ? relativeScrollOffset[0] - $12b3d2ab131f1390$var$ghostRelativeParentInitialScroll[0] : 0) / (scaleX || 1), dy = (touch.clientY - $12b3d2ab131f1390$var$tapEvt.clientY + fallbackOffset.y) / (scaleY || 1) + (relativeScrollOffset ? relativeScrollOffset[1] - $12b3d2ab131f1390$var$ghostRelativeParentInitialScroll[1] : 0) / (scaleY || 1);
            // only set the status to dragging, when we are actually dragging
            if (!$12b3d2ab131f1390$export$31b3ca70d8f57423.active && !$12b3d2ab131f1390$var$awaitingDragStarted) {
                if (fallbackTolerance && Math.max(Math.abs(touch.clientX - this._lastX), Math.abs(touch.clientY - this._lastY)) < fallbackTolerance) return;
                this._onDragStart(evt, true);
            }
            if ($12b3d2ab131f1390$var$ghostEl) {
                if (ghostMatrix) {
                    ghostMatrix.e += dx - ($12b3d2ab131f1390$var$lastDx || 0);
                    ghostMatrix.f += dy - ($12b3d2ab131f1390$var$lastDy || 0);
                } else ghostMatrix = {
                    a: 1,
                    b: 0,
                    c: 0,
                    d: 1,
                    e: dx,
                    f: dy
                };
                var cssMatrix = "matrix(".concat(ghostMatrix.a, ",").concat(ghostMatrix.b, ",").concat(ghostMatrix.c, ",").concat(ghostMatrix.d, ",").concat(ghostMatrix.e, ",").concat(ghostMatrix.f, ")");
                $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'webkitTransform', cssMatrix);
                $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'mozTransform', cssMatrix);
                $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'msTransform', cssMatrix);
                $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'transform', cssMatrix);
                $12b3d2ab131f1390$var$lastDx = dx;
                $12b3d2ab131f1390$var$lastDy = dy;
                $12b3d2ab131f1390$var$touchEvt = touch;
            }
            evt.cancelable && evt.preventDefault();
        }
    },
    _appendGhost: function _appendGhost() {
        // Bug if using scale(): https://stackoverflow.com/questions/2637058
        // Not being adjusted for
        if (!$12b3d2ab131f1390$var$ghostEl) {
            var container = this.options.fallbackOnBody ? document.body : $12b3d2ab131f1390$var$rootEl, rect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$dragEl, true, $12b3d2ab131f1390$var$PositionGhostAbsolutely, true, container), options = this.options;
            // Position absolutely
            if ($12b3d2ab131f1390$var$PositionGhostAbsolutely) {
                // Get relatively positioned parent
                $12b3d2ab131f1390$var$ghostRelativeParent = container;
                while($12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostRelativeParent, 'position') === 'static' && $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostRelativeParent, 'transform') === 'none' && $12b3d2ab131f1390$var$ghostRelativeParent !== document)$12b3d2ab131f1390$var$ghostRelativeParent = $12b3d2ab131f1390$var$ghostRelativeParent.parentNode;
                if ($12b3d2ab131f1390$var$ghostRelativeParent !== document.body && $12b3d2ab131f1390$var$ghostRelativeParent !== document.documentElement) {
                    if ($12b3d2ab131f1390$var$ghostRelativeParent === document) $12b3d2ab131f1390$var$ghostRelativeParent = $12b3d2ab131f1390$var$getWindowScrollingElement();
                    rect.top += $12b3d2ab131f1390$var$ghostRelativeParent.scrollTop;
                    rect.left += $12b3d2ab131f1390$var$ghostRelativeParent.scrollLeft;
                } else $12b3d2ab131f1390$var$ghostRelativeParent = $12b3d2ab131f1390$var$getWindowScrollingElement();
                $12b3d2ab131f1390$var$ghostRelativeParentInitialScroll = $12b3d2ab131f1390$var$getRelativeScrollOffset($12b3d2ab131f1390$var$ghostRelativeParent);
            }
            $12b3d2ab131f1390$var$ghostEl = $12b3d2ab131f1390$var$dragEl.cloneNode(true);
            $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$ghostEl, options.ghostClass, false);
            $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$ghostEl, options.fallbackClass, true);
            $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$ghostEl, options.dragClass, true);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'transition', '');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'transform', '');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'box-sizing', 'border-box');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'margin', 0);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'top', rect.top);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'left', rect.left);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'width', rect.width);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'height', rect.height);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'opacity', '0.8');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'position', $12b3d2ab131f1390$var$PositionGhostAbsolutely ? 'absolute' : 'fixed');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'zIndex', '100000');
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'pointerEvents', 'none');
            $12b3d2ab131f1390$export$31b3ca70d8f57423.ghost = $12b3d2ab131f1390$var$ghostEl;
            container.appendChild($12b3d2ab131f1390$var$ghostEl);
            // Set transform-origin
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$ghostEl, 'transform-origin', $12b3d2ab131f1390$var$tapDistanceLeft / parseInt($12b3d2ab131f1390$var$ghostEl.style.width) * 100 + '% ' + $12b3d2ab131f1390$var$tapDistanceTop / parseInt($12b3d2ab131f1390$var$ghostEl.style.height) * 100 + '%');
        }
    },
    _onDragStart: function _onDragStart(/**Event*/ evt, /**boolean*/ fallback) {
        var _this = this;
        var dataTransfer = evt.dataTransfer;
        var options = _this.options;
        $12b3d2ab131f1390$var$pluginEvent('dragStart', this, {
            evt: evt
        });
        if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
            this._onDrop();
            return;
        }
        $12b3d2ab131f1390$var$pluginEvent('setupClone', this);
        if (!$12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
            $12b3d2ab131f1390$var$cloneEl = $12b3d2ab131f1390$var$clone($12b3d2ab131f1390$var$dragEl);
            $12b3d2ab131f1390$var$cloneEl.removeAttribute("id");
            $12b3d2ab131f1390$var$cloneEl.draggable = false;
            $12b3d2ab131f1390$var$cloneEl.style['will-change'] = '';
            this._hideClone();
            $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$cloneEl, this.options.chosenClass, false);
            $12b3d2ab131f1390$export$31b3ca70d8f57423.clone = $12b3d2ab131f1390$var$cloneEl;
        }
        // #1143: IFrame support workaround
        _this.cloneId = $12b3d2ab131f1390$var$_nextTick(function() {
            $12b3d2ab131f1390$var$pluginEvent('clone', _this);
            if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) return;
            if (!_this.options.removeCloneOnHide) $12b3d2ab131f1390$var$rootEl.insertBefore($12b3d2ab131f1390$var$cloneEl, $12b3d2ab131f1390$var$dragEl);
            _this._hideClone();
            $12b3d2ab131f1390$var$_dispatchEvent({
                sortable: _this,
                name: 'clone'
            });
        });
        !fallback && $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, options.dragClass, true);
        // Set proper drop events
        if (fallback) {
            $12b3d2ab131f1390$var$ignoreNextClick = true;
            _this._loopId = setInterval(_this._emulateDragOver, 50);
        } else {
            // Undo what was set in _prepareDragStart before drag started
            $12b3d2ab131f1390$var$off(document, 'mouseup', _this._onDrop);
            $12b3d2ab131f1390$var$off(document, 'touchend', _this._onDrop);
            $12b3d2ab131f1390$var$off(document, 'touchcancel', _this._onDrop);
            if (dataTransfer) {
                dataTransfer.effectAllowed = 'move';
                options.setData && options.setData.call(_this, dataTransfer, $12b3d2ab131f1390$var$dragEl);
            }
            $12b3d2ab131f1390$var$on(document, 'drop', _this);
            // #1276 fix:
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$dragEl, 'transform', 'translateZ(0)');
        }
        $12b3d2ab131f1390$var$awaitingDragStarted = true;
        _this._dragStartId = $12b3d2ab131f1390$var$_nextTick(_this._dragStarted.bind(_this, fallback, evt));
        $12b3d2ab131f1390$var$on(document, 'selectstart', _this);
        $12b3d2ab131f1390$var$moved = true;
        window.getSelection().removeAllRanges();
        if ($12b3d2ab131f1390$var$Safari) $12b3d2ab131f1390$var$css(document.body, 'user-select', 'none');
    },
    // Returns true - if no further action is needed (either inserted or another condition)
    _onDragOver: function _onDragOver(/**Event*/ evt) {
        var el = this.el, target = evt.target, dragRect, targetRect, revert, options = this.options, group = options.group, activeSortable = $12b3d2ab131f1390$export$31b3ca70d8f57423.active, isOwner = $12b3d2ab131f1390$var$activeGroup === group, canSort = options.sort, fromSortable = $12b3d2ab131f1390$var$putSortable || activeSortable, vertical, _this = this, completedFired = false;
        if ($12b3d2ab131f1390$var$_silent) return;
        function dragOverEvent(name, extra) {
            $12b3d2ab131f1390$var$pluginEvent(name, _this, $12b3d2ab131f1390$var$_objectSpread2({
                evt: evt,
                isOwner: isOwner,
                axis: vertical ? 'vertical' : 'horizontal',
                revert: revert,
                dragRect: dragRect,
                targetRect: targetRect,
                canSort: canSort,
                fromSortable: fromSortable,
                target: target,
                completed: completed,
                onMove: function onMove(target, after) {
                    return $12b3d2ab131f1390$var$_onMove($12b3d2ab131f1390$var$rootEl, el, $12b3d2ab131f1390$var$dragEl, dragRect, target, $12b3d2ab131f1390$var$getRect(target), evt, after);
                },
                changed: changed
            }, extra));
        }
        // Capture animation state
        function capture() {
            dragOverEvent('dragOverAnimationCapture');
            _this.captureAnimationState();
            if (_this !== fromSortable) fromSortable.captureAnimationState();
        }
        // Return invocation when dragEl is inserted (or completed)
        function completed(insertion) {
            dragOverEvent('dragOverCompleted', {
                insertion: insertion
            });
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                else activeSortable._showClone(_this);
                if (_this !== fromSortable) {
                    // Set ghost class to new sortable's ghost class
                    $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, $12b3d2ab131f1390$var$putSortable ? $12b3d2ab131f1390$var$putSortable.options.ghostClass : activeSortable.options.ghostClass, false);
                    $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, options.ghostClass, true);
                }
                if ($12b3d2ab131f1390$var$putSortable !== _this && _this !== $12b3d2ab131f1390$export$31b3ca70d8f57423.active) $12b3d2ab131f1390$var$putSortable = _this;
                else if (_this === $12b3d2ab131f1390$export$31b3ca70d8f57423.active && $12b3d2ab131f1390$var$putSortable) $12b3d2ab131f1390$var$putSortable = null;
                // Animation
                if (fromSortable === _this) _this._ignoreWhileAnimating = target;
                _this.animateAll(function() {
                    dragOverEvent('dragOverAnimationComplete');
                    _this._ignoreWhileAnimating = null;
                });
                if (_this !== fromSortable) {
                    fromSortable.animateAll();
                    fromSortable._ignoreWhileAnimating = null;
                }
            }
            // Null lastTarget if it is not inside a previously swapped element
            if (target === $12b3d2ab131f1390$var$dragEl && !$12b3d2ab131f1390$var$dragEl.animated || target === el && !target.animated) $12b3d2ab131f1390$var$lastTarget = null;
            // no bubbling and not fallback
            if (!options.dragoverBubble && !evt.rootEl && target !== document) {
                $12b3d2ab131f1390$var$dragEl.parentNode[$12b3d2ab131f1390$var$expando]._isOutsideThisEl(evt.target);
                // Do not detect for empty insert if already inserted
                !insertion && $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent(evt);
            }
            !options.dragoverBubble && evt.stopPropagation && evt.stopPropagation();
            return completedFired = true;
        }
        // Call when dragEl has been inserted
        function changed() {
            $12b3d2ab131f1390$var$newIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl);
            $12b3d2ab131f1390$var$newDraggableIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl, options.draggable);
            $12b3d2ab131f1390$var$_dispatchEvent({
                sortable: _this,
                name: 'change',
                toEl: el,
                newIndex: $12b3d2ab131f1390$var$newIndex,
                newDraggableIndex: $12b3d2ab131f1390$var$newDraggableIndex,
                originalEvent: evt
            });
        }
        if (evt.preventDefault !== void 0) evt.cancelable && evt.preventDefault();
        target = $12b3d2ab131f1390$var$closest(target, options.draggable, el, true);
        dragOverEvent('dragOver');
        if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) return completedFired;
        if ($12b3d2ab131f1390$var$dragEl.contains(evt.target) || target.animated && target.animatingX && target.animatingY || _this._ignoreWhileAnimating === target) return completed(false);
        $12b3d2ab131f1390$var$ignoreNextClick = false;
        if (activeSortable && !options.disabled && (isOwner ? canSort || (revert = $12b3d2ab131f1390$var$parentEl !== $12b3d2ab131f1390$var$rootEl // Reverting item into the original list
        ) : $12b3d2ab131f1390$var$putSortable === this || (this.lastPutMode = $12b3d2ab131f1390$var$activeGroup.checkPull(this, activeSortable, $12b3d2ab131f1390$var$dragEl, evt)) && group.checkPut(this, activeSortable, $12b3d2ab131f1390$var$dragEl, evt))) {
            vertical = this._getDirection(evt, target) === 'vertical';
            dragRect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$dragEl);
            dragOverEvent('dragOverValid');
            if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) return completedFired;
            if (revert) {
                $12b3d2ab131f1390$var$parentEl = $12b3d2ab131f1390$var$rootEl; // actualization
                capture();
                this._hideClone();
                dragOverEvent('revert');
                if (!$12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
                    if ($12b3d2ab131f1390$var$nextEl) $12b3d2ab131f1390$var$rootEl.insertBefore($12b3d2ab131f1390$var$dragEl, $12b3d2ab131f1390$var$nextEl);
                    else $12b3d2ab131f1390$var$rootEl.appendChild($12b3d2ab131f1390$var$dragEl);
                }
                return completed(true);
            }
            var elLastChild = $12b3d2ab131f1390$var$lastChild(el, options.draggable);
            if (!elLastChild || $12b3d2ab131f1390$var$_ghostIsLast(evt, vertical, this) && !elLastChild.animated) {
                // Insert to end of list
                // If already at end of list: Do not insert
                if (elLastChild === $12b3d2ab131f1390$var$dragEl) return completed(false);
                // if there is a last element, it is the target
                if (elLastChild && el === evt.target) target = elLastChild;
                if (target) targetRect = $12b3d2ab131f1390$var$getRect(target);
                if ($12b3d2ab131f1390$var$_onMove($12b3d2ab131f1390$var$rootEl, el, $12b3d2ab131f1390$var$dragEl, dragRect, target, targetRect, evt, !!target) !== false) {
                    capture();
                    if (elLastChild && elLastChild.nextSibling) // the last draggable element is not the last node
                    el.insertBefore($12b3d2ab131f1390$var$dragEl, elLastChild.nextSibling);
                    else el.appendChild($12b3d2ab131f1390$var$dragEl);
                    $12b3d2ab131f1390$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (elLastChild && $12b3d2ab131f1390$var$_ghostIsFirst(evt, vertical, this)) {
                // Insert to start of list
                var firstChild = $12b3d2ab131f1390$var$getChild(el, 0, options, true);
                if (firstChild === $12b3d2ab131f1390$var$dragEl) return completed(false);
                target = firstChild;
                targetRect = $12b3d2ab131f1390$var$getRect(target);
                if ($12b3d2ab131f1390$var$_onMove($12b3d2ab131f1390$var$rootEl, el, $12b3d2ab131f1390$var$dragEl, dragRect, target, targetRect, evt, false) !== false) {
                    capture();
                    el.insertBefore($12b3d2ab131f1390$var$dragEl, firstChild);
                    $12b3d2ab131f1390$var$parentEl = el; // actualization
                    changed();
                    return completed(true);
                }
            } else if (target.parentNode === el) {
                targetRect = $12b3d2ab131f1390$var$getRect(target);
                var direction = 0, targetBeforeFirstSwap, differentLevel = $12b3d2ab131f1390$var$dragEl.parentNode !== el, differentRowCol = !$12b3d2ab131f1390$var$_dragElInRowColumn($12b3d2ab131f1390$var$dragEl.animated && $12b3d2ab131f1390$var$dragEl.toRect || dragRect, target.animated && target.toRect || targetRect, vertical), side1 = vertical ? 'top' : 'left', scrolledPastTop = $12b3d2ab131f1390$var$isScrolledPast(target, 'top', 'top') || $12b3d2ab131f1390$var$isScrolledPast($12b3d2ab131f1390$var$dragEl, 'top', 'top'), scrollBefore = scrolledPastTop ? scrolledPastTop.scrollTop : void 0;
                if ($12b3d2ab131f1390$var$lastTarget !== target) {
                    targetBeforeFirstSwap = targetRect[side1];
                    $12b3d2ab131f1390$var$pastFirstInvertThresh = false;
                    $12b3d2ab131f1390$var$isCircumstantialInvert = !differentRowCol && options.invertSwap || differentLevel;
                }
                direction = $12b3d2ab131f1390$var$_getSwapDirection(evt, target, targetRect, vertical, differentRowCol ? 1 : options.swapThreshold, options.invertedSwapThreshold == null ? options.swapThreshold : options.invertedSwapThreshold, $12b3d2ab131f1390$var$isCircumstantialInvert, $12b3d2ab131f1390$var$lastTarget === target);
                var sibling;
                if (direction !== 0) {
                    // Check if target is beside dragEl in respective direction (ignoring hidden elements)
                    var dragIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl);
                    do {
                        dragIndex -= direction;
                        sibling = $12b3d2ab131f1390$var$parentEl.children[dragIndex];
                    }while (sibling && ($12b3d2ab131f1390$var$css(sibling, 'display') === 'none' || sibling === $12b3d2ab131f1390$var$ghostEl));
                }
                // If dragEl is already beside target: Do not insert
                if (direction === 0 || sibling === target) return completed(false);
                $12b3d2ab131f1390$var$lastTarget = target;
                $12b3d2ab131f1390$var$lastDirection = direction;
                var nextSibling = target.nextElementSibling, after = false;
                after = direction === 1;
                var moveVector = $12b3d2ab131f1390$var$_onMove($12b3d2ab131f1390$var$rootEl, el, $12b3d2ab131f1390$var$dragEl, dragRect, target, targetRect, evt, after);
                if (moveVector !== false) {
                    if (moveVector === 1 || moveVector === -1) after = moveVector === 1;
                    $12b3d2ab131f1390$var$_silent = true;
                    setTimeout($12b3d2ab131f1390$var$_unsilent, 30);
                    capture();
                    if (after && !nextSibling) el.appendChild($12b3d2ab131f1390$var$dragEl);
                    else target.parentNode.insertBefore($12b3d2ab131f1390$var$dragEl, after ? nextSibling : target);
                    // Undo chrome's scroll adjustment (has no effect on other browsers)
                    if (scrolledPastTop) $12b3d2ab131f1390$var$scrollBy(scrolledPastTop, 0, scrollBefore - scrolledPastTop.scrollTop);
                    $12b3d2ab131f1390$var$parentEl = $12b3d2ab131f1390$var$dragEl.parentNode; // actualization
                    // must be done before animation
                    if (targetBeforeFirstSwap !== undefined && !$12b3d2ab131f1390$var$isCircumstantialInvert) $12b3d2ab131f1390$var$targetMoveDistance = Math.abs(targetBeforeFirstSwap - $12b3d2ab131f1390$var$getRect(target)[side1]);
                    changed();
                    return completed(true);
                }
            }
            if (el.contains($12b3d2ab131f1390$var$dragEl)) return completed(false);
        }
        return false;
    },
    _ignoreWhileAnimating: null,
    _offMoveEvents: function _offMoveEvents() {
        $12b3d2ab131f1390$var$off(document, 'mousemove', this._onTouchMove);
        $12b3d2ab131f1390$var$off(document, 'touchmove', this._onTouchMove);
        $12b3d2ab131f1390$var$off(document, 'pointermove', this._onTouchMove);
        $12b3d2ab131f1390$var$off(document, 'dragover', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
        $12b3d2ab131f1390$var$off(document, 'mousemove', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
        $12b3d2ab131f1390$var$off(document, 'touchmove', $12b3d2ab131f1390$var$nearestEmptyInsertDetectEvent);
    },
    _offUpEvents: function _offUpEvents() {
        var ownerDocument = this.el.ownerDocument;
        $12b3d2ab131f1390$var$off(ownerDocument, 'mouseup', this._onDrop);
        $12b3d2ab131f1390$var$off(ownerDocument, 'touchend', this._onDrop);
        $12b3d2ab131f1390$var$off(ownerDocument, 'pointerup', this._onDrop);
        $12b3d2ab131f1390$var$off(ownerDocument, 'pointercancel', this._onDrop);
        $12b3d2ab131f1390$var$off(ownerDocument, 'touchcancel', this._onDrop);
        $12b3d2ab131f1390$var$off(document, 'selectstart', this);
    },
    _onDrop: function _onDrop(/**Event*/ evt) {
        var el = this.el, options = this.options;
        // Get the index of the dragged element within its parent
        $12b3d2ab131f1390$var$newIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl);
        $12b3d2ab131f1390$var$newDraggableIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl, options.draggable);
        $12b3d2ab131f1390$var$pluginEvent('drop', this, {
            evt: evt
        });
        $12b3d2ab131f1390$var$parentEl = $12b3d2ab131f1390$var$dragEl && $12b3d2ab131f1390$var$dragEl.parentNode;
        // Get again after plugin event
        $12b3d2ab131f1390$var$newIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl);
        $12b3d2ab131f1390$var$newDraggableIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl, options.draggable);
        if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) {
            this._nulling();
            return;
        }
        $12b3d2ab131f1390$var$awaitingDragStarted = false;
        $12b3d2ab131f1390$var$isCircumstantialInvert = false;
        $12b3d2ab131f1390$var$pastFirstInvertThresh = false;
        clearInterval(this._loopId);
        clearTimeout(this._dragStartTimer);
        $12b3d2ab131f1390$var$_cancelNextTick(this.cloneId);
        $12b3d2ab131f1390$var$_cancelNextTick(this._dragStartId);
        // Unbind events
        if (this.nativeDraggable) {
            $12b3d2ab131f1390$var$off(document, 'drop', this);
            $12b3d2ab131f1390$var$off(el, 'dragstart', this._onDragStart);
        }
        this._offMoveEvents();
        this._offUpEvents();
        if ($12b3d2ab131f1390$var$Safari) $12b3d2ab131f1390$var$css(document.body, 'user-select', '');
        $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$dragEl, 'transform', '');
        if (evt) {
            if ($12b3d2ab131f1390$var$moved) {
                evt.cancelable && evt.preventDefault();
                !options.dropBubble && evt.stopPropagation();
            }
            $12b3d2ab131f1390$var$ghostEl && $12b3d2ab131f1390$var$ghostEl.parentNode && $12b3d2ab131f1390$var$ghostEl.parentNode.removeChild($12b3d2ab131f1390$var$ghostEl);
            if ($12b3d2ab131f1390$var$rootEl === $12b3d2ab131f1390$var$parentEl || $12b3d2ab131f1390$var$putSortable && $12b3d2ab131f1390$var$putSortable.lastPutMode !== 'clone') // Remove clone(s)
            $12b3d2ab131f1390$var$cloneEl && $12b3d2ab131f1390$var$cloneEl.parentNode && $12b3d2ab131f1390$var$cloneEl.parentNode.removeChild($12b3d2ab131f1390$var$cloneEl);
            if ($12b3d2ab131f1390$var$dragEl) {
                if (this.nativeDraggable) $12b3d2ab131f1390$var$off($12b3d2ab131f1390$var$dragEl, 'dragend', this);
                $12b3d2ab131f1390$var$_disableDraggable($12b3d2ab131f1390$var$dragEl);
                $12b3d2ab131f1390$var$dragEl.style['will-change'] = '';
                // Remove classes
                // ghostClass is added in dragStarted
                if ($12b3d2ab131f1390$var$moved && !$12b3d2ab131f1390$var$awaitingDragStarted) $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, $12b3d2ab131f1390$var$putSortable ? $12b3d2ab131f1390$var$putSortable.options.ghostClass : this.options.ghostClass, false);
                $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl, this.options.chosenClass, false);
                // Drag stop event
                $12b3d2ab131f1390$var$_dispatchEvent({
                    sortable: this,
                    name: 'unchoose',
                    toEl: $12b3d2ab131f1390$var$parentEl,
                    newIndex: null,
                    newDraggableIndex: null,
                    originalEvent: evt
                });
                if ($12b3d2ab131f1390$var$rootEl !== $12b3d2ab131f1390$var$parentEl) {
                    if ($12b3d2ab131f1390$var$newIndex >= 0) {
                        // Add event
                        $12b3d2ab131f1390$var$_dispatchEvent({
                            rootEl: $12b3d2ab131f1390$var$parentEl,
                            name: 'add',
                            toEl: $12b3d2ab131f1390$var$parentEl,
                            fromEl: $12b3d2ab131f1390$var$rootEl,
                            originalEvent: evt
                        });
                        // Remove event
                        $12b3d2ab131f1390$var$_dispatchEvent({
                            sortable: this,
                            name: 'remove',
                            toEl: $12b3d2ab131f1390$var$parentEl,
                            originalEvent: evt
                        });
                        // drag from one list and drop into another
                        $12b3d2ab131f1390$var$_dispatchEvent({
                            rootEl: $12b3d2ab131f1390$var$parentEl,
                            name: 'sort',
                            toEl: $12b3d2ab131f1390$var$parentEl,
                            fromEl: $12b3d2ab131f1390$var$rootEl,
                            originalEvent: evt
                        });
                        $12b3d2ab131f1390$var$_dispatchEvent({
                            sortable: this,
                            name: 'sort',
                            toEl: $12b3d2ab131f1390$var$parentEl,
                            originalEvent: evt
                        });
                    }
                    $12b3d2ab131f1390$var$putSortable && $12b3d2ab131f1390$var$putSortable.save();
                } else {
                    if ($12b3d2ab131f1390$var$newIndex !== $12b3d2ab131f1390$var$oldIndex) {
                        if ($12b3d2ab131f1390$var$newIndex >= 0) {
                            // drag & drop within the same list
                            $12b3d2ab131f1390$var$_dispatchEvent({
                                sortable: this,
                                name: 'update',
                                toEl: $12b3d2ab131f1390$var$parentEl,
                                originalEvent: evt
                            });
                            $12b3d2ab131f1390$var$_dispatchEvent({
                                sortable: this,
                                name: 'sort',
                                toEl: $12b3d2ab131f1390$var$parentEl,
                                originalEvent: evt
                            });
                        }
                    }
                }
                if ($12b3d2ab131f1390$export$31b3ca70d8f57423.active) {
                    /* jshint eqnull:true */ if ($12b3d2ab131f1390$var$newIndex == null || $12b3d2ab131f1390$var$newIndex === -1) {
                        $12b3d2ab131f1390$var$newIndex = $12b3d2ab131f1390$var$oldIndex;
                        $12b3d2ab131f1390$var$newDraggableIndex = $12b3d2ab131f1390$var$oldDraggableIndex;
                    }
                    $12b3d2ab131f1390$var$_dispatchEvent({
                        sortable: this,
                        name: 'end',
                        toEl: $12b3d2ab131f1390$var$parentEl,
                        originalEvent: evt
                    });
                    // Save sorting
                    this.save();
                }
            }
        }
        this._nulling();
    },
    _nulling: function _nulling() {
        $12b3d2ab131f1390$var$pluginEvent('nulling', this);
        $12b3d2ab131f1390$var$rootEl = $12b3d2ab131f1390$var$dragEl = $12b3d2ab131f1390$var$parentEl = $12b3d2ab131f1390$var$ghostEl = $12b3d2ab131f1390$var$nextEl = $12b3d2ab131f1390$var$cloneEl = $12b3d2ab131f1390$var$lastDownEl = $12b3d2ab131f1390$var$cloneHidden = $12b3d2ab131f1390$var$tapEvt = $12b3d2ab131f1390$var$touchEvt = $12b3d2ab131f1390$var$moved = $12b3d2ab131f1390$var$newIndex = $12b3d2ab131f1390$var$newDraggableIndex = $12b3d2ab131f1390$var$oldIndex = $12b3d2ab131f1390$var$oldDraggableIndex = $12b3d2ab131f1390$var$lastTarget = $12b3d2ab131f1390$var$lastDirection = $12b3d2ab131f1390$var$putSortable = $12b3d2ab131f1390$var$activeGroup = $12b3d2ab131f1390$export$31b3ca70d8f57423.dragged = $12b3d2ab131f1390$export$31b3ca70d8f57423.ghost = $12b3d2ab131f1390$export$31b3ca70d8f57423.clone = $12b3d2ab131f1390$export$31b3ca70d8f57423.active = null;
        $12b3d2ab131f1390$var$savedInputChecked.forEach(function(el) {
            el.checked = true;
        });
        $12b3d2ab131f1390$var$savedInputChecked.length = $12b3d2ab131f1390$var$lastDx = $12b3d2ab131f1390$var$lastDy = 0;
    },
    handleEvent: function handleEvent(/**Event*/ evt) {
        switch(evt.type){
            case 'drop':
            case 'dragend':
                this._onDrop(evt);
                break;
            case 'dragenter':
            case 'dragover':
                if ($12b3d2ab131f1390$var$dragEl) {
                    this._onDragOver(evt);
                    $12b3d2ab131f1390$var$_globalDragOver(evt);
                }
                break;
            case 'selectstart':
                evt.preventDefault();
                break;
        }
    },
    /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */ toArray: function toArray() {
        var order = [], el, children = this.el.children, i = 0, n = children.length, options = this.options;
        for(; i < n; i++){
            el = children[i];
            if ($12b3d2ab131f1390$var$closest(el, options.draggable, this.el, false)) order.push(el.getAttribute(options.dataIdAttr) || $12b3d2ab131f1390$var$_generateId(el));
        }
        return order;
    },
    /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */ sort: function sort(order, useAnimation) {
        var items = {}, rootEl = this.el;
        this.toArray().forEach(function(id, i) {
            var el = rootEl.children[i];
            if ($12b3d2ab131f1390$var$closest(el, this.options.draggable, rootEl, false)) items[id] = el;
        }, this);
        useAnimation && this.captureAnimationState();
        order.forEach(function(id) {
            if (items[id]) {
                rootEl.removeChild(items[id]);
                rootEl.appendChild(items[id]);
            }
        });
        useAnimation && this.animateAll();
    },
    /**
   * Save the current sorting
   */ save: function save() {
        var store = this.options.store;
        store && store.set && store.set(this);
    },
    /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */ closest: function closest$1(el, selector) {
        return $12b3d2ab131f1390$var$closest(el, selector || this.options.draggable, this.el, false);
    },
    /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */ option: function option(name, value) {
        var options = this.options;
        if (value === void 0) return options[name];
        else {
            var modifiedValue = $12b3d2ab131f1390$var$PluginManager.modifyOption(this, name, value);
            if (typeof modifiedValue !== 'undefined') options[name] = modifiedValue;
            else options[name] = value;
            if (name === 'group') $12b3d2ab131f1390$var$_prepareGroup(options);
        }
    },
    /**
   * Destroy
   */ destroy: function destroy() {
        $12b3d2ab131f1390$var$pluginEvent('destroy', this);
        var el = this.el;
        el[$12b3d2ab131f1390$var$expando] = null;
        $12b3d2ab131f1390$var$off(el, 'mousedown', this._onTapStart);
        $12b3d2ab131f1390$var$off(el, 'touchstart', this._onTapStart);
        $12b3d2ab131f1390$var$off(el, 'pointerdown', this._onTapStart);
        if (this.nativeDraggable) {
            $12b3d2ab131f1390$var$off(el, 'dragover', this);
            $12b3d2ab131f1390$var$off(el, 'dragenter', this);
        }
        // Remove draggable attributes
        Array.prototype.forEach.call(el.querySelectorAll('[draggable]'), function(el) {
            el.removeAttribute('draggable');
        });
        this._onDrop();
        this._disableDelayedDragEvents();
        $12b3d2ab131f1390$var$sortables.splice($12b3d2ab131f1390$var$sortables.indexOf(this.el), 1);
        this.el = el = null;
    },
    _hideClone: function _hideClone() {
        if (!$12b3d2ab131f1390$var$cloneHidden) {
            $12b3d2ab131f1390$var$pluginEvent('hideClone', this);
            if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) return;
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$cloneEl, 'display', 'none');
            if (this.options.removeCloneOnHide && $12b3d2ab131f1390$var$cloneEl.parentNode) $12b3d2ab131f1390$var$cloneEl.parentNode.removeChild($12b3d2ab131f1390$var$cloneEl);
            $12b3d2ab131f1390$var$cloneHidden = true;
        }
    },
    _showClone: function _showClone(putSortable) {
        if (putSortable.lastPutMode !== 'clone') {
            this._hideClone();
            return;
        }
        if ($12b3d2ab131f1390$var$cloneHidden) {
            $12b3d2ab131f1390$var$pluginEvent('showClone', this);
            if ($12b3d2ab131f1390$export$31b3ca70d8f57423.eventCanceled) return;
            // show clone at dragEl or original position
            if ($12b3d2ab131f1390$var$dragEl.parentNode == $12b3d2ab131f1390$var$rootEl && !this.options.group.revertClone) $12b3d2ab131f1390$var$rootEl.insertBefore($12b3d2ab131f1390$var$cloneEl, $12b3d2ab131f1390$var$dragEl);
            else if ($12b3d2ab131f1390$var$nextEl) $12b3d2ab131f1390$var$rootEl.insertBefore($12b3d2ab131f1390$var$cloneEl, $12b3d2ab131f1390$var$nextEl);
            else $12b3d2ab131f1390$var$rootEl.appendChild($12b3d2ab131f1390$var$cloneEl);
            if (this.options.group.revertClone) this.animate($12b3d2ab131f1390$var$dragEl, $12b3d2ab131f1390$var$cloneEl);
            $12b3d2ab131f1390$var$css($12b3d2ab131f1390$var$cloneEl, 'display', '');
            $12b3d2ab131f1390$var$cloneHidden = false;
        }
    }
};
function $12b3d2ab131f1390$var$_globalDragOver(/**Event*/ evt) {
    if (evt.dataTransfer) evt.dataTransfer.dropEffect = 'move';
    evt.cancelable && evt.preventDefault();
}
function $12b3d2ab131f1390$var$_onMove(fromEl, toEl, dragEl, dragRect, targetEl, targetRect, originalEvent, willInsertAfter) {
    var evt, sortable = fromEl[$12b3d2ab131f1390$var$expando], onMoveFn = sortable.options.onMove, retVal;
    // Support for new CustomEvent feature
    if (window.CustomEvent && !$12b3d2ab131f1390$var$IE11OrLess && !$12b3d2ab131f1390$var$Edge) evt = new CustomEvent('move', {
        bubbles: true,
        cancelable: true
    });
    else {
        evt = document.createEvent('Event');
        evt.initEvent('move', true, true);
    }
    evt.to = toEl;
    evt.from = fromEl;
    evt.dragged = dragEl;
    evt.draggedRect = dragRect;
    evt.related = targetEl || toEl;
    evt.relatedRect = targetRect || $12b3d2ab131f1390$var$getRect(toEl);
    evt.willInsertAfter = willInsertAfter;
    evt.originalEvent = originalEvent;
    fromEl.dispatchEvent(evt);
    if (onMoveFn) retVal = onMoveFn.call(sortable, evt, originalEvent);
    return retVal;
}
function $12b3d2ab131f1390$var$_disableDraggable(el) {
    el.draggable = false;
}
function $12b3d2ab131f1390$var$_unsilent() {
    $12b3d2ab131f1390$var$_silent = false;
}
function $12b3d2ab131f1390$var$_ghostIsFirst(evt, vertical, sortable) {
    var firstElRect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$getChild(sortable.el, 0, sortable.options, true));
    var childContainingRect = $12b3d2ab131f1390$var$getChildContainingRectFromElement(sortable.el, sortable.options, $12b3d2ab131f1390$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX < childContainingRect.left - spacer || evt.clientY < firstElRect.top && evt.clientX < firstElRect.right : evt.clientY < childContainingRect.top - spacer || evt.clientY < firstElRect.bottom && evt.clientX < firstElRect.left;
}
function $12b3d2ab131f1390$var$_ghostIsLast(evt, vertical, sortable) {
    var lastElRect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$lastChild(sortable.el, sortable.options.draggable));
    var childContainingRect = $12b3d2ab131f1390$var$getChildContainingRectFromElement(sortable.el, sortable.options, $12b3d2ab131f1390$var$ghostEl);
    var spacer = 10;
    return vertical ? evt.clientX > childContainingRect.right + spacer || evt.clientY > lastElRect.bottom && evt.clientX > lastElRect.left : evt.clientY > childContainingRect.bottom + spacer || evt.clientX > lastElRect.right && evt.clientY > lastElRect.top;
}
function $12b3d2ab131f1390$var$_getSwapDirection(evt, target, targetRect, vertical, swapThreshold, invertedSwapThreshold, invertSwap, isLastTarget) {
    var mouseOnAxis = vertical ? evt.clientY : evt.clientX, targetLength = vertical ? targetRect.height : targetRect.width, targetS1 = vertical ? targetRect.top : targetRect.left, targetS2 = vertical ? targetRect.bottom : targetRect.right, invert = false;
    if (!invertSwap) {
        // Never invert or create dragEl shadow when target movemenet causes mouse to move past the end of regular swapThreshold
        if (isLastTarget && $12b3d2ab131f1390$var$targetMoveDistance < targetLength * swapThreshold) {
            // multiplied only by swapThreshold because mouse will already be inside target by (1 - threshold) * targetLength / 2
            // check if past first invert threshold on side opposite of lastDirection
            if (!$12b3d2ab131f1390$var$pastFirstInvertThresh && ($12b3d2ab131f1390$var$lastDirection === 1 ? mouseOnAxis > targetS1 + targetLength * invertedSwapThreshold / 2 : mouseOnAxis < targetS2 - targetLength * invertedSwapThreshold / 2)) // past first invert threshold, do not restrict inverted threshold to dragEl shadow
            $12b3d2ab131f1390$var$pastFirstInvertThresh = true;
            if (!$12b3d2ab131f1390$var$pastFirstInvertThresh) {
                // dragEl shadow (target move distance shadow)
                if ($12b3d2ab131f1390$var$lastDirection === 1 ? mouseOnAxis < targetS1 + $12b3d2ab131f1390$var$targetMoveDistance // over dragEl shadow
                 : mouseOnAxis > targetS2 - $12b3d2ab131f1390$var$targetMoveDistance) return -$12b3d2ab131f1390$var$lastDirection;
            } else invert = true;
        } else {
            // Regular
            if (mouseOnAxis > targetS1 + targetLength * (1 - swapThreshold) / 2 && mouseOnAxis < targetS2 - targetLength * (1 - swapThreshold) / 2) return $12b3d2ab131f1390$var$_getInsertDirection(target);
        }
    }
    invert = invert || invertSwap;
    if (invert) {
        // Invert of regular
        if (mouseOnAxis < targetS1 + targetLength * invertedSwapThreshold / 2 || mouseOnAxis > targetS2 - targetLength * invertedSwapThreshold / 2) return mouseOnAxis > targetS1 + targetLength / 2 ? 1 : -1;
    }
    return 0;
}
/**
 * Gets the direction dragEl must be swapped relative to target in order to make it
 * seem that dragEl has been "inserted" into that element's position
 * @param  {HTMLElement} target       The target whose position dragEl is being inserted at
 * @return {Number}                   Direction dragEl must be swapped
 */ function $12b3d2ab131f1390$var$_getInsertDirection(target) {
    if ($12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl) < $12b3d2ab131f1390$var$index(target)) return 1;
    else return -1;
}
/**
 * Generate id
 * @param   {HTMLElement} el
 * @returns {String}
 * @private
 */ function $12b3d2ab131f1390$var$_generateId(el) {
    var str = el.tagName + el.className + el.src + el.href + el.textContent, i = str.length, sum = 0;
    while(i--)sum += str.charCodeAt(i);
    return sum.toString(36);
}
function $12b3d2ab131f1390$var$_saveInputCheckedState(root) {
    $12b3d2ab131f1390$var$savedInputChecked.length = 0;
    var inputs = root.getElementsByTagName('input');
    var idx = inputs.length;
    while(idx--){
        var el = inputs[idx];
        el.checked && $12b3d2ab131f1390$var$savedInputChecked.push(el);
    }
}
function $12b3d2ab131f1390$var$_nextTick(fn) {
    return setTimeout(fn, 0);
}
function $12b3d2ab131f1390$var$_cancelNextTick(id) {
    return clearTimeout(id);
}
// Fixed #973:
if ($12b3d2ab131f1390$var$documentExists) $12b3d2ab131f1390$var$on(document, 'touchmove', function(evt) {
    if (($12b3d2ab131f1390$export$31b3ca70d8f57423.active || $12b3d2ab131f1390$var$awaitingDragStarted) && evt.cancelable) evt.preventDefault();
});
// Export utils
$12b3d2ab131f1390$export$31b3ca70d8f57423.utils = {
    on: $12b3d2ab131f1390$var$on,
    off: $12b3d2ab131f1390$var$off,
    css: $12b3d2ab131f1390$var$css,
    find: $12b3d2ab131f1390$var$find,
    is: function is(el, selector) {
        return !!$12b3d2ab131f1390$var$closest(el, selector, el, false);
    },
    extend: $12b3d2ab131f1390$var$extend,
    throttle: $12b3d2ab131f1390$var$throttle,
    closest: $12b3d2ab131f1390$var$closest,
    toggleClass: $12b3d2ab131f1390$var$toggleClass,
    clone: $12b3d2ab131f1390$var$clone,
    index: $12b3d2ab131f1390$var$index,
    nextTick: $12b3d2ab131f1390$var$_nextTick,
    cancelNextTick: $12b3d2ab131f1390$var$_cancelNextTick,
    detectDirection: $12b3d2ab131f1390$var$_detectDirection,
    getChild: $12b3d2ab131f1390$var$getChild,
    expando: $12b3d2ab131f1390$var$expando
};
/**
 * Get the Sortable instance of an element
 * @param  {HTMLElement} element The element
 * @return {Sortable|undefined}         The instance of Sortable
 */ $12b3d2ab131f1390$export$31b3ca70d8f57423.get = function(element) {
    return element[$12b3d2ab131f1390$var$expando];
};
/**
 * Mount a plugin to Sortable
 * @param  {...SortablePlugin|SortablePlugin[]} plugins       Plugins being mounted
 */ $12b3d2ab131f1390$export$31b3ca70d8f57423.mount = function() {
    for(var _len = arguments.length, plugins = new Array(_len), _key = 0; _key < _len; _key++)plugins[_key] = arguments[_key];
    if (plugins[0].constructor === Array) plugins = plugins[0];
    plugins.forEach(function(plugin) {
        if (!plugin.prototype || !plugin.prototype.constructor) throw "Sortable: Mounted plugin must be a constructor function, not ".concat(({}).toString.call(plugin));
        if (plugin.utils) $12b3d2ab131f1390$export$31b3ca70d8f57423.utils = $12b3d2ab131f1390$var$_objectSpread2($12b3d2ab131f1390$var$_objectSpread2({}, $12b3d2ab131f1390$export$31b3ca70d8f57423.utils), plugin.utils);
        $12b3d2ab131f1390$var$PluginManager.mount(plugin);
    });
};
/**
 * Create sortable instance
 * @param {HTMLElement}  el
 * @param {Object}      [options]
 */ $12b3d2ab131f1390$export$31b3ca70d8f57423.create = function(el, options) {
    return new $12b3d2ab131f1390$export$31b3ca70d8f57423(el, options);
};
// Export
$12b3d2ab131f1390$export$31b3ca70d8f57423.version = $12b3d2ab131f1390$var$version;
var $12b3d2ab131f1390$var$autoScrolls = [], $12b3d2ab131f1390$var$scrollEl, $12b3d2ab131f1390$var$scrollRootEl, $12b3d2ab131f1390$var$scrolling = false, $12b3d2ab131f1390$var$lastAutoScrollX, $12b3d2ab131f1390$var$lastAutoScrollY, $12b3d2ab131f1390$var$touchEvt$1, $12b3d2ab131f1390$var$pointerElemChangedInterval;
function $12b3d2ab131f1390$var$AutoScrollPlugin() {
    function AutoScroll() {
        this.defaults = {
            scroll: true,
            forceAutoScrollFallback: false,
            scrollSensitivity: 30,
            scrollSpeed: 10,
            bubbleScroll: true
        };
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
    }
    AutoScroll.prototype = {
        dragStarted: function dragStarted(_ref) {
            var originalEvent = _ref.originalEvent;
            if (this.sortable.nativeDraggable) $12b3d2ab131f1390$var$on(document, 'dragover', this._handleAutoScroll);
            else {
                if (this.options.supportPointer) $12b3d2ab131f1390$var$on(document, 'pointermove', this._handleFallbackAutoScroll);
                else if (originalEvent.touches) $12b3d2ab131f1390$var$on(document, 'touchmove', this._handleFallbackAutoScroll);
                else $12b3d2ab131f1390$var$on(document, 'mousemove', this._handleFallbackAutoScroll);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref2) {
            var originalEvent = _ref2.originalEvent;
            // For when bubbling is canceled and using fallback (fallback 'touchmove' always reached)
            if (!this.options.dragOverBubble && !originalEvent.rootEl) this._handleAutoScroll(originalEvent);
        },
        drop: function drop() {
            if (this.sortable.nativeDraggable) $12b3d2ab131f1390$var$off(document, 'dragover', this._handleAutoScroll);
            else {
                $12b3d2ab131f1390$var$off(document, 'pointermove', this._handleFallbackAutoScroll);
                $12b3d2ab131f1390$var$off(document, 'touchmove', this._handleFallbackAutoScroll);
                $12b3d2ab131f1390$var$off(document, 'mousemove', this._handleFallbackAutoScroll);
            }
            $12b3d2ab131f1390$var$clearPointerElemChangedInterval();
            $12b3d2ab131f1390$var$clearAutoScrolls();
            $12b3d2ab131f1390$var$cancelThrottle();
        },
        nulling: function nulling() {
            $12b3d2ab131f1390$var$touchEvt$1 = $12b3d2ab131f1390$var$scrollRootEl = $12b3d2ab131f1390$var$scrollEl = $12b3d2ab131f1390$var$scrolling = $12b3d2ab131f1390$var$pointerElemChangedInterval = $12b3d2ab131f1390$var$lastAutoScrollX = $12b3d2ab131f1390$var$lastAutoScrollY = null;
            $12b3d2ab131f1390$var$autoScrolls.length = 0;
        },
        _handleFallbackAutoScroll: function _handleFallbackAutoScroll(evt) {
            this._handleAutoScroll(evt, true);
        },
        _handleAutoScroll: function _handleAutoScroll(evt, fallback) {
            var _this = this;
            var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, elem = document.elementFromPoint(x, y);
            $12b3d2ab131f1390$var$touchEvt$1 = evt;
            // IE does not seem to have native autoscroll,
            // Edge's autoscroll seems too conditional,
            // MACOS Safari does not have autoscroll,
            // Firefox and Chrome are good
            if (fallback || this.options.forceAutoScrollFallback || $12b3d2ab131f1390$var$Edge || $12b3d2ab131f1390$var$IE11OrLess || $12b3d2ab131f1390$var$Safari) {
                $12b3d2ab131f1390$var$autoScroll(evt, this.options, elem, fallback);
                // Listener for pointer element change
                var ogElemScroller = $12b3d2ab131f1390$var$getParentAutoScrollElement(elem, true);
                if ($12b3d2ab131f1390$var$scrolling && (!$12b3d2ab131f1390$var$pointerElemChangedInterval || x !== $12b3d2ab131f1390$var$lastAutoScrollX || y !== $12b3d2ab131f1390$var$lastAutoScrollY)) {
                    $12b3d2ab131f1390$var$pointerElemChangedInterval && $12b3d2ab131f1390$var$clearPointerElemChangedInterval();
                    // Detect for pointer elem change, emulating native DnD behaviour
                    $12b3d2ab131f1390$var$pointerElemChangedInterval = setInterval(function() {
                        var newElem = $12b3d2ab131f1390$var$getParentAutoScrollElement(document.elementFromPoint(x, y), true);
                        if (newElem !== ogElemScroller) {
                            ogElemScroller = newElem;
                            $12b3d2ab131f1390$var$clearAutoScrolls();
                        }
                        $12b3d2ab131f1390$var$autoScroll(evt, _this.options, newElem, fallback);
                    }, 10);
                    $12b3d2ab131f1390$var$lastAutoScrollX = x;
                    $12b3d2ab131f1390$var$lastAutoScrollY = y;
                }
            } else {
                // if DnD is enabled (and browser has good autoscrolling), first autoscroll will already scroll, so get parent autoscroll of first autoscroll
                if (!this.options.bubbleScroll || $12b3d2ab131f1390$var$getParentAutoScrollElement(elem, true) === $12b3d2ab131f1390$var$getWindowScrollingElement()) {
                    $12b3d2ab131f1390$var$clearAutoScrolls();
                    return;
                }
                $12b3d2ab131f1390$var$autoScroll(evt, this.options, $12b3d2ab131f1390$var$getParentAutoScrollElement(elem, false), false);
            }
        }
    };
    return $12b3d2ab131f1390$var$_extends(AutoScroll, {
        pluginName: 'scroll',
        initializeByDefault: true
    });
}
function $12b3d2ab131f1390$var$clearAutoScrolls() {
    $12b3d2ab131f1390$var$autoScrolls.forEach(function(autoScroll) {
        clearInterval(autoScroll.pid);
    });
    $12b3d2ab131f1390$var$autoScrolls = [];
}
function $12b3d2ab131f1390$var$clearPointerElemChangedInterval() {
    clearInterval($12b3d2ab131f1390$var$pointerElemChangedInterval);
}
var $12b3d2ab131f1390$var$autoScroll = $12b3d2ab131f1390$var$throttle(function(evt, options, rootEl, isFallback) {
    // Bug: https://bugzilla.mozilla.org/show_bug.cgi?id=505521
    if (!options.scroll) return;
    var x = (evt.touches ? evt.touches[0] : evt).clientX, y = (evt.touches ? evt.touches[0] : evt).clientY, sens = options.scrollSensitivity, speed = options.scrollSpeed, winScroller = $12b3d2ab131f1390$var$getWindowScrollingElement();
    var scrollThisInstance = false, scrollCustomFn;
    // New scroll root, set scrollEl
    if ($12b3d2ab131f1390$var$scrollRootEl !== rootEl) {
        $12b3d2ab131f1390$var$scrollRootEl = rootEl;
        $12b3d2ab131f1390$var$clearAutoScrolls();
        $12b3d2ab131f1390$var$scrollEl = options.scroll;
        scrollCustomFn = options.scrollFn;
        if ($12b3d2ab131f1390$var$scrollEl === true) $12b3d2ab131f1390$var$scrollEl = $12b3d2ab131f1390$var$getParentAutoScrollElement(rootEl, true);
    }
    var layersOut = 0;
    var currentParent = $12b3d2ab131f1390$var$scrollEl;
    do {
        var el = currentParent, rect = $12b3d2ab131f1390$var$getRect(el), top = rect.top, bottom = rect.bottom, left = rect.left, right = rect.right, width = rect.width, height = rect.height, canScrollX = void 0, canScrollY = void 0, scrollWidth = el.scrollWidth, scrollHeight = el.scrollHeight, elCSS = $12b3d2ab131f1390$var$css(el), scrollPosX = el.scrollLeft, scrollPosY = el.scrollTop;
        if (el === winScroller) {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll' || elCSS.overflowX === 'visible');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll' || elCSS.overflowY === 'visible');
        } else {
            canScrollX = width < scrollWidth && (elCSS.overflowX === 'auto' || elCSS.overflowX === 'scroll');
            canScrollY = height < scrollHeight && (elCSS.overflowY === 'auto' || elCSS.overflowY === 'scroll');
        }
        var vx = canScrollX && (Math.abs(right - x) <= sens && scrollPosX + width < scrollWidth) - (Math.abs(left - x) <= sens && !!scrollPosX);
        var vy = canScrollY && (Math.abs(bottom - y) <= sens && scrollPosY + height < scrollHeight) - (Math.abs(top - y) <= sens && !!scrollPosY);
        if (!$12b3d2ab131f1390$var$autoScrolls[layersOut]) {
            for(var i = 0; i <= layersOut; i++)if (!$12b3d2ab131f1390$var$autoScrolls[i]) $12b3d2ab131f1390$var$autoScrolls[i] = {};
        }
        if ($12b3d2ab131f1390$var$autoScrolls[layersOut].vx != vx || $12b3d2ab131f1390$var$autoScrolls[layersOut].vy != vy || $12b3d2ab131f1390$var$autoScrolls[layersOut].el !== el) {
            $12b3d2ab131f1390$var$autoScrolls[layersOut].el = el;
            $12b3d2ab131f1390$var$autoScrolls[layersOut].vx = vx;
            $12b3d2ab131f1390$var$autoScrolls[layersOut].vy = vy;
            clearInterval($12b3d2ab131f1390$var$autoScrolls[layersOut].pid);
            if (vx != 0 || vy != 0) {
                scrollThisInstance = true;
                /* jshint loopfunc:true */ $12b3d2ab131f1390$var$autoScrolls[layersOut].pid = setInterval((function() {
                    // emulate drag over during autoscroll (fallback), emulating native DnD behaviour
                    if (isFallback && this.layer === 0) $12b3d2ab131f1390$export$31b3ca70d8f57423.active._onTouchMove($12b3d2ab131f1390$var$touchEvt$1); // To move ghost if it is positioned absolutely
                    var scrollOffsetY = $12b3d2ab131f1390$var$autoScrolls[this.layer].vy ? $12b3d2ab131f1390$var$autoScrolls[this.layer].vy * speed : 0;
                    var scrollOffsetX = $12b3d2ab131f1390$var$autoScrolls[this.layer].vx ? $12b3d2ab131f1390$var$autoScrolls[this.layer].vx * speed : 0;
                    if (typeof scrollCustomFn === 'function') {
                        if (scrollCustomFn.call($12b3d2ab131f1390$export$31b3ca70d8f57423.dragged.parentNode[$12b3d2ab131f1390$var$expando], scrollOffsetX, scrollOffsetY, evt, $12b3d2ab131f1390$var$touchEvt$1, $12b3d2ab131f1390$var$autoScrolls[this.layer].el) !== 'continue') return;
                    }
                    $12b3d2ab131f1390$var$scrollBy($12b3d2ab131f1390$var$autoScrolls[this.layer].el, scrollOffsetX, scrollOffsetY);
                }).bind({
                    layer: layersOut
                }), 24);
            }
        }
        layersOut++;
    }while (options.bubbleScroll && currentParent !== winScroller && (currentParent = $12b3d2ab131f1390$var$getParentAutoScrollElement(currentParent, false)));
    $12b3d2ab131f1390$var$scrolling = scrollThisInstance; // in case another function catches scrolling as false in between when it is not
}, 30);
var $12b3d2ab131f1390$var$drop = function drop(_ref) {
    var originalEvent = _ref.originalEvent, putSortable = _ref.putSortable, dragEl = _ref.dragEl, activeSortable = _ref.activeSortable, dispatchSortableEvent = _ref.dispatchSortableEvent, hideGhostForTarget = _ref.hideGhostForTarget, unhideGhostForTarget = _ref.unhideGhostForTarget;
    if (!originalEvent) return;
    var toSortable = putSortable || activeSortable;
    hideGhostForTarget();
    var touch = originalEvent.changedTouches && originalEvent.changedTouches.length ? originalEvent.changedTouches[0] : originalEvent;
    var target = document.elementFromPoint(touch.clientX, touch.clientY);
    unhideGhostForTarget();
    if (toSortable && !toSortable.el.contains(target)) {
        dispatchSortableEvent('spill');
        this.onSpill({
            dragEl: dragEl,
            putSortable: putSortable
        });
    }
};
function $12b3d2ab131f1390$var$Revert() {}
$12b3d2ab131f1390$var$Revert.prototype = {
    startIndex: null,
    dragStart: function dragStart(_ref2) {
        var oldDraggableIndex = _ref2.oldDraggableIndex;
        this.startIndex = oldDraggableIndex;
    },
    onSpill: function onSpill(_ref3) {
        var dragEl = _ref3.dragEl, putSortable = _ref3.putSortable;
        this.sortable.captureAnimationState();
        if (putSortable) putSortable.captureAnimationState();
        var nextSibling = $12b3d2ab131f1390$var$getChild(this.sortable.el, this.startIndex, this.options);
        if (nextSibling) this.sortable.el.insertBefore(dragEl, nextSibling);
        else this.sortable.el.appendChild(dragEl);
        this.sortable.animateAll();
        if (putSortable) putSortable.animateAll();
    },
    drop: $12b3d2ab131f1390$var$drop
};
$12b3d2ab131f1390$var$_extends($12b3d2ab131f1390$var$Revert, {
    pluginName: 'revertOnSpill'
});
function $12b3d2ab131f1390$var$Remove() {}
$12b3d2ab131f1390$var$Remove.prototype = {
    onSpill: function onSpill(_ref4) {
        var dragEl = _ref4.dragEl, putSortable = _ref4.putSortable;
        var parentSortable = putSortable || this.sortable;
        parentSortable.captureAnimationState();
        dragEl.parentNode && dragEl.parentNode.removeChild(dragEl);
        parentSortable.animateAll();
    },
    drop: $12b3d2ab131f1390$var$drop
};
$12b3d2ab131f1390$var$_extends($12b3d2ab131f1390$var$Remove, {
    pluginName: 'removeOnSpill'
});
var $12b3d2ab131f1390$var$lastSwapEl;
function $12b3d2ab131f1390$export$bdb5f0a1b77546f4() {
    function Swap() {
        this.defaults = {
            swapClass: 'sortable-swap-highlight'
        };
    }
    Swap.prototype = {
        dragStart: function dragStart(_ref) {
            var dragEl = _ref.dragEl;
            $12b3d2ab131f1390$var$lastSwapEl = dragEl;
        },
        dragOverValid: function dragOverValid(_ref2) {
            var completed = _ref2.completed, target = _ref2.target, onMove = _ref2.onMove, activeSortable = _ref2.activeSortable, changed = _ref2.changed, cancel = _ref2.cancel;
            if (!activeSortable.options.swap) return;
            var el = this.sortable.el, options = this.options;
            if (target && target !== el) {
                var prevSwapEl = $12b3d2ab131f1390$var$lastSwapEl;
                if (onMove(target) !== false) {
                    $12b3d2ab131f1390$var$toggleClass(target, options.swapClass, true);
                    $12b3d2ab131f1390$var$lastSwapEl = target;
                } else $12b3d2ab131f1390$var$lastSwapEl = null;
                if (prevSwapEl && prevSwapEl !== $12b3d2ab131f1390$var$lastSwapEl) $12b3d2ab131f1390$var$toggleClass(prevSwapEl, options.swapClass, false);
            }
            changed();
            completed(true);
            cancel();
        },
        drop: function drop(_ref3) {
            var activeSortable = _ref3.activeSortable, putSortable = _ref3.putSortable, dragEl = _ref3.dragEl;
            var toSortable = putSortable || this.sortable;
            var options = this.options;
            $12b3d2ab131f1390$var$lastSwapEl && $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$lastSwapEl, options.swapClass, false);
            if ($12b3d2ab131f1390$var$lastSwapEl && (options.swap || putSortable && putSortable.options.swap)) {
                if (dragEl !== $12b3d2ab131f1390$var$lastSwapEl) {
                    toSortable.captureAnimationState();
                    if (toSortable !== activeSortable) activeSortable.captureAnimationState();
                    $12b3d2ab131f1390$var$swapNodes(dragEl, $12b3d2ab131f1390$var$lastSwapEl);
                    toSortable.animateAll();
                    if (toSortable !== activeSortable) activeSortable.animateAll();
                }
            }
        },
        nulling: function nulling() {
            $12b3d2ab131f1390$var$lastSwapEl = null;
        }
    };
    return $12b3d2ab131f1390$var$_extends(Swap, {
        pluginName: 'swap',
        eventProperties: function eventProperties() {
            return {
                swapItem: $12b3d2ab131f1390$var$lastSwapEl
            };
        }
    });
}
function $12b3d2ab131f1390$var$swapNodes(n1, n2) {
    var p1 = n1.parentNode, p2 = n2.parentNode, i1, i2;
    if (!p1 || !p2 || p1.isEqualNode(n2) || p2.isEqualNode(n1)) return;
    i1 = $12b3d2ab131f1390$var$index(n1);
    i2 = $12b3d2ab131f1390$var$index(n2);
    if (p1.isEqualNode(p2) && i1 < i2) i2++;
    p1.insertBefore(n2, p1.children[i1]);
    p2.insertBefore(n1, p2.children[i2]);
}
var $12b3d2ab131f1390$var$multiDragElements = [], $12b3d2ab131f1390$var$multiDragClones = [], $12b3d2ab131f1390$var$lastMultiDragSelect, // for selection with modifier key down (SHIFT)
$12b3d2ab131f1390$var$multiDragSortable, $12b3d2ab131f1390$var$initialFolding = false, // Initial multi-drag fold when drag started
$12b3d2ab131f1390$var$folding = false, // Folding any other time
$12b3d2ab131f1390$var$dragStarted = false, $12b3d2ab131f1390$var$dragEl$1, $12b3d2ab131f1390$var$clonesFromRect, $12b3d2ab131f1390$var$clonesHidden;
function $12b3d2ab131f1390$export$18e5d2a5d1df842d() {
    function MultiDrag(sortable) {
        // Bind all private methods
        for(var fn in this)if (fn.charAt(0) === '_' && typeof this[fn] === 'function') this[fn] = this[fn].bind(this);
        if (!sortable.options.avoidImplicitDeselect) {
            if (sortable.options.supportPointer) $12b3d2ab131f1390$var$on(document, 'pointerup', this._deselectMultiDrag);
            else {
                $12b3d2ab131f1390$var$on(document, 'mouseup', this._deselectMultiDrag);
                $12b3d2ab131f1390$var$on(document, 'touchend', this._deselectMultiDrag);
            }
        }
        $12b3d2ab131f1390$var$on(document, 'keydown', this._checkKeyDown);
        $12b3d2ab131f1390$var$on(document, 'keyup', this._checkKeyUp);
        this.defaults = {
            selectedClass: 'sortable-selected',
            multiDragKey: null,
            avoidImplicitDeselect: false,
            setData: function setData(dataTransfer, dragEl) {
                var data = '';
                if ($12b3d2ab131f1390$var$multiDragElements.length && $12b3d2ab131f1390$var$multiDragSortable === sortable) $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement, i) {
                    data += (!i ? '' : ', ') + multiDragElement.textContent;
                });
                else data = dragEl.textContent;
                dataTransfer.setData('Text', data);
            }
        };
    }
    MultiDrag.prototype = {
        multiDragKeyDown: false,
        isMultiDrag: false,
        delayStartGlobal: function delayStartGlobal(_ref) {
            var dragged = _ref.dragEl;
            $12b3d2ab131f1390$var$dragEl$1 = dragged;
        },
        delayEnded: function delayEnded() {
            this.isMultiDrag = ~$12b3d2ab131f1390$var$multiDragElements.indexOf($12b3d2ab131f1390$var$dragEl$1);
        },
        setupClone: function setupClone(_ref2) {
            var sortable = _ref2.sortable, cancel = _ref2.cancel;
            if (!this.isMultiDrag) return;
            for(var i = 0; i < $12b3d2ab131f1390$var$multiDragElements.length; i++){
                $12b3d2ab131f1390$var$multiDragClones.push($12b3d2ab131f1390$var$clone($12b3d2ab131f1390$var$multiDragElements[i]));
                $12b3d2ab131f1390$var$multiDragClones[i].sortableIndex = $12b3d2ab131f1390$var$multiDragElements[i].sortableIndex;
                $12b3d2ab131f1390$var$multiDragClones[i].draggable = false;
                $12b3d2ab131f1390$var$multiDragClones[i].style['will-change'] = '';
                $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$multiDragClones[i], this.options.selectedClass, false);
                $12b3d2ab131f1390$var$multiDragElements[i] === $12b3d2ab131f1390$var$dragEl$1 && $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$multiDragClones[i], this.options.chosenClass, false);
            }
            sortable._hideClone();
            cancel();
        },
        clone: function clone(_ref3) {
            var sortable = _ref3.sortable, rootEl = _ref3.rootEl, dispatchSortableEvent = _ref3.dispatchSortableEvent, cancel = _ref3.cancel;
            if (!this.isMultiDrag) return;
            if (!this.options.removeCloneOnHide) {
                if ($12b3d2ab131f1390$var$multiDragElements.length && $12b3d2ab131f1390$var$multiDragSortable === sortable) {
                    $12b3d2ab131f1390$var$insertMultiDragClones(true, rootEl);
                    dispatchSortableEvent('clone');
                    cancel();
                }
            }
        },
        showClone: function showClone(_ref4) {
            var cloneNowShown = _ref4.cloneNowShown, rootEl = _ref4.rootEl, cancel = _ref4.cancel;
            if (!this.isMultiDrag) return;
            $12b3d2ab131f1390$var$insertMultiDragClones(false, rootEl);
            $12b3d2ab131f1390$var$multiDragClones.forEach(function(clone) {
                $12b3d2ab131f1390$var$css(clone, 'display', '');
            });
            cloneNowShown();
            $12b3d2ab131f1390$var$clonesHidden = false;
            cancel();
        },
        hideClone: function hideClone(_ref5) {
            var _this = this;
            var sortable = _ref5.sortable, cloneNowHidden = _ref5.cloneNowHidden, cancel = _ref5.cancel;
            if (!this.isMultiDrag) return;
            $12b3d2ab131f1390$var$multiDragClones.forEach(function(clone) {
                $12b3d2ab131f1390$var$css(clone, 'display', 'none');
                if (_this.options.removeCloneOnHide && clone.parentNode) clone.parentNode.removeChild(clone);
            });
            cloneNowHidden();
            $12b3d2ab131f1390$var$clonesHidden = true;
            cancel();
        },
        dragStartGlobal: function dragStartGlobal(_ref6) {
            var sortable = _ref6.sortable;
            if (!this.isMultiDrag && $12b3d2ab131f1390$var$multiDragSortable) $12b3d2ab131f1390$var$multiDragSortable.multiDrag._deselectMultiDrag();
            $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.sortableIndex = $12b3d2ab131f1390$var$index(multiDragElement);
            });
            // Sort multi-drag elements
            $12b3d2ab131f1390$var$multiDragElements = $12b3d2ab131f1390$var$multiDragElements.sort(function(a, b) {
                return a.sortableIndex - b.sortableIndex;
            });
            $12b3d2ab131f1390$var$dragStarted = true;
        },
        dragStarted: function dragStarted(_ref7) {
            var _this2 = this;
            var sortable = _ref7.sortable;
            if (!this.isMultiDrag) return;
            if (this.options.sort) {
                // Capture rects,
                // hide multi drag elements (by positioning them absolute),
                // set multi drag elements rects to dragRect,
                // show multi drag elements,
                // animate to rects,
                // unset rects & remove from DOM
                sortable.captureAnimationState();
                if (this.options.animation) {
                    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $12b3d2ab131f1390$var$dragEl$1) return;
                        $12b3d2ab131f1390$var$css(multiDragElement, 'position', 'absolute');
                    });
                    var dragRect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$dragEl$1, false, true, true);
                    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $12b3d2ab131f1390$var$dragEl$1) return;
                        $12b3d2ab131f1390$var$setRect(multiDragElement, dragRect);
                    });
                    $12b3d2ab131f1390$var$folding = true;
                    $12b3d2ab131f1390$var$initialFolding = true;
                }
            }
            sortable.animateAll(function() {
                $12b3d2ab131f1390$var$folding = false;
                $12b3d2ab131f1390$var$initialFolding = false;
                if (_this2.options.animation) $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                    $12b3d2ab131f1390$var$unsetRect(multiDragElement);
                });
                // Remove all auxiliary multidrag items from el, if sorting enabled
                if (_this2.options.sort) $12b3d2ab131f1390$var$removeMultiDragElements();
            });
        },
        dragOver: function dragOver(_ref8) {
            var target = _ref8.target, completed = _ref8.completed, cancel = _ref8.cancel;
            if ($12b3d2ab131f1390$var$folding && ~$12b3d2ab131f1390$var$multiDragElements.indexOf(target)) {
                completed(false);
                cancel();
            }
        },
        revert: function revert(_ref9) {
            var fromSortable = _ref9.fromSortable, rootEl = _ref9.rootEl, sortable = _ref9.sortable, dragRect = _ref9.dragRect;
            if ($12b3d2ab131f1390$var$multiDragElements.length > 1) {
                // Setup unfold animation
                $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                    sortable.addAnimationState({
                        target: multiDragElement,
                        rect: $12b3d2ab131f1390$var$folding ? $12b3d2ab131f1390$var$getRect(multiDragElement) : dragRect
                    });
                    $12b3d2ab131f1390$var$unsetRect(multiDragElement);
                    multiDragElement.fromRect = dragRect;
                    fromSortable.removeAnimationState(multiDragElement);
                });
                $12b3d2ab131f1390$var$folding = false;
                $12b3d2ab131f1390$var$insertMultiDragElements(!this.options.removeCloneOnHide, rootEl);
            }
        },
        dragOverCompleted: function dragOverCompleted(_ref10) {
            var sortable = _ref10.sortable, isOwner = _ref10.isOwner, insertion = _ref10.insertion, activeSortable = _ref10.activeSortable, parentEl = _ref10.parentEl, putSortable = _ref10.putSortable;
            var options = this.options;
            if (insertion) {
                // Clones must be hidden before folding animation to capture dragRectAbsolute properly
                if (isOwner) activeSortable._hideClone();
                $12b3d2ab131f1390$var$initialFolding = false;
                // If leaving sort:false root, or already folding - Fold to new location
                if (options.animation && $12b3d2ab131f1390$var$multiDragElements.length > 1 && ($12b3d2ab131f1390$var$folding || !isOwner && !activeSortable.options.sort && !putSortable)) {
                    // Fold: Set all multi drag elements's rects to dragEl's rect when multi-drag elements are invisible
                    var dragRectAbsolute = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$dragEl$1, false, true, true);
                    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                        if (multiDragElement === $12b3d2ab131f1390$var$dragEl$1) return;
                        $12b3d2ab131f1390$var$setRect(multiDragElement, dragRectAbsolute);
                        // Move element(s) to end of parentEl so that it does not interfere with multi-drag clones insertion if they are inserted
                        // while folding, and so that we can capture them again because old sortable will no longer be fromSortable
                        parentEl.appendChild(multiDragElement);
                    });
                    $12b3d2ab131f1390$var$folding = true;
                }
                // Clones must be shown (and check to remove multi drags) after folding when interfering multiDragElements are moved out
                if (!isOwner) {
                    // Only remove if not folding (folding will remove them anyways)
                    if (!$12b3d2ab131f1390$var$folding) $12b3d2ab131f1390$var$removeMultiDragElements();
                    if ($12b3d2ab131f1390$var$multiDragElements.length > 1) {
                        var clonesHiddenBefore = $12b3d2ab131f1390$var$clonesHidden;
                        activeSortable._showClone(sortable);
                        // Unfold animation for clones if showing from hidden
                        if (activeSortable.options.animation && !$12b3d2ab131f1390$var$clonesHidden && clonesHiddenBefore) $12b3d2ab131f1390$var$multiDragClones.forEach(function(clone) {
                            activeSortable.addAnimationState({
                                target: clone,
                                rect: $12b3d2ab131f1390$var$clonesFromRect
                            });
                            clone.fromRect = $12b3d2ab131f1390$var$clonesFromRect;
                            clone.thisAnimationDuration = null;
                        });
                    } else activeSortable._showClone(sortable);
                }
            }
        },
        dragOverAnimationCapture: function dragOverAnimationCapture(_ref11) {
            var dragRect = _ref11.dragRect, isOwner = _ref11.isOwner, activeSortable = _ref11.activeSortable;
            $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                multiDragElement.thisAnimationDuration = null;
            });
            if (activeSortable.options.animation && !isOwner && activeSortable.multiDrag.isMultiDrag) {
                $12b3d2ab131f1390$var$clonesFromRect = $12b3d2ab131f1390$var$_extends({}, dragRect);
                var dragMatrix = $12b3d2ab131f1390$var$matrix($12b3d2ab131f1390$var$dragEl$1, true);
                $12b3d2ab131f1390$var$clonesFromRect.top -= dragMatrix.f;
                $12b3d2ab131f1390$var$clonesFromRect.left -= dragMatrix.e;
            }
        },
        dragOverAnimationComplete: function dragOverAnimationComplete() {
            if ($12b3d2ab131f1390$var$folding) {
                $12b3d2ab131f1390$var$folding = false;
                $12b3d2ab131f1390$var$removeMultiDragElements();
            }
        },
        drop: function drop(_ref12) {
            var evt = _ref12.originalEvent, rootEl = _ref12.rootEl, parentEl = _ref12.parentEl, sortable = _ref12.sortable, dispatchSortableEvent = _ref12.dispatchSortableEvent, oldIndex = _ref12.oldIndex, putSortable = _ref12.putSortable;
            var toSortable = putSortable || this.sortable;
            if (!evt) return;
            var options = this.options, children = parentEl.children;
            // Multi-drag selection
            if (!$12b3d2ab131f1390$var$dragStarted) {
                if (options.multiDragKey && !this.multiDragKeyDown) this._deselectMultiDrag();
                $12b3d2ab131f1390$var$toggleClass($12b3d2ab131f1390$var$dragEl$1, options.selectedClass, !~$12b3d2ab131f1390$var$multiDragElements.indexOf($12b3d2ab131f1390$var$dragEl$1));
                if (!~$12b3d2ab131f1390$var$multiDragElements.indexOf($12b3d2ab131f1390$var$dragEl$1)) {
                    $12b3d2ab131f1390$var$multiDragElements.push($12b3d2ab131f1390$var$dragEl$1);
                    $12b3d2ab131f1390$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'select',
                        targetEl: $12b3d2ab131f1390$var$dragEl$1,
                        originalEvent: evt
                    });
                    // Modifier activated, select from last to dragEl
                    if (evt.shiftKey && $12b3d2ab131f1390$var$lastMultiDragSelect && sortable.el.contains($12b3d2ab131f1390$var$lastMultiDragSelect)) {
                        var lastIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$lastMultiDragSelect), currentIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl$1);
                        if (~lastIndex && ~currentIndex && lastIndex !== currentIndex) (function() {
                            // Must include lastMultiDragSelect (select it), in case modified selection from no selection
                            // (but previous selection existed)
                            var n, i;
                            if (currentIndex > lastIndex) {
                                i = lastIndex;
                                n = currentIndex;
                            } else {
                                i = currentIndex;
                                n = lastIndex + 1;
                            }
                            var filter = options.filter;
                            for(; i < n; i++){
                                if (~$12b3d2ab131f1390$var$multiDragElements.indexOf(children[i])) continue;
                                // Check if element is draggable
                                if (!$12b3d2ab131f1390$var$closest(children[i], options.draggable, parentEl, false)) continue;
                                // Check if element is filtered
                                var filtered = filter && (typeof filter === 'function' ? filter.call(sortable, evt, children[i], sortable) : filter.split(',').some(function(criteria) {
                                    return $12b3d2ab131f1390$var$closest(children[i], criteria.trim(), parentEl, false);
                                }));
                                if (filtered) continue;
                                $12b3d2ab131f1390$var$toggleClass(children[i], options.selectedClass, true);
                                $12b3d2ab131f1390$var$multiDragElements.push(children[i]);
                                $12b3d2ab131f1390$var$dispatchEvent({
                                    sortable: sortable,
                                    rootEl: rootEl,
                                    name: 'select',
                                    targetEl: children[i],
                                    originalEvent: evt
                                });
                            }
                        })();
                    } else $12b3d2ab131f1390$var$lastMultiDragSelect = $12b3d2ab131f1390$var$dragEl$1;
                    $12b3d2ab131f1390$var$multiDragSortable = toSortable;
                } else {
                    $12b3d2ab131f1390$var$multiDragElements.splice($12b3d2ab131f1390$var$multiDragElements.indexOf($12b3d2ab131f1390$var$dragEl$1), 1);
                    $12b3d2ab131f1390$var$lastMultiDragSelect = null;
                    $12b3d2ab131f1390$var$dispatchEvent({
                        sortable: sortable,
                        rootEl: rootEl,
                        name: 'deselect',
                        targetEl: $12b3d2ab131f1390$var$dragEl$1,
                        originalEvent: evt
                    });
                }
            }
            // Multi-drag drop
            if ($12b3d2ab131f1390$var$dragStarted && this.isMultiDrag) {
                $12b3d2ab131f1390$var$folding = false;
                // Do not "unfold" after around dragEl if reverted
                if ((parentEl[$12b3d2ab131f1390$var$expando].options.sort || parentEl !== rootEl) && $12b3d2ab131f1390$var$multiDragElements.length > 1) {
                    var dragRect = $12b3d2ab131f1390$var$getRect($12b3d2ab131f1390$var$dragEl$1), multiDragIndex = $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl$1, ':not(.' + this.options.selectedClass + ')');
                    if (!$12b3d2ab131f1390$var$initialFolding && options.animation) $12b3d2ab131f1390$var$dragEl$1.thisAnimationDuration = null;
                    toSortable.captureAnimationState();
                    if (!$12b3d2ab131f1390$var$initialFolding) {
                        if (options.animation) {
                            $12b3d2ab131f1390$var$dragEl$1.fromRect = dragRect;
                            $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                                multiDragElement.thisAnimationDuration = null;
                                if (multiDragElement !== $12b3d2ab131f1390$var$dragEl$1) {
                                    var rect = $12b3d2ab131f1390$var$folding ? $12b3d2ab131f1390$var$getRect(multiDragElement) : dragRect;
                                    multiDragElement.fromRect = rect;
                                    // Prepare unfold animation
                                    toSortable.addAnimationState({
                                        target: multiDragElement,
                                        rect: rect
                                    });
                                }
                            });
                        }
                        // Multi drag elements are not necessarily removed from the DOM on drop, so to reinsert
                        // properly they must all be removed
                        $12b3d2ab131f1390$var$removeMultiDragElements();
                        $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                            if (children[multiDragIndex]) parentEl.insertBefore(multiDragElement, children[multiDragIndex]);
                            else parentEl.appendChild(multiDragElement);
                            multiDragIndex++;
                        });
                        // If initial folding is done, the elements may have changed position because they are now
                        // unfolding around dragEl, even though dragEl may not have his index changed, so update event
                        // must be fired here as Sortable will not.
                        if (oldIndex === $12b3d2ab131f1390$var$index($12b3d2ab131f1390$var$dragEl$1)) {
                            var update = false;
                            $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                                if (multiDragElement.sortableIndex !== $12b3d2ab131f1390$var$index(multiDragElement)) {
                                    update = true;
                                    return;
                                }
                            });
                            if (update) {
                                dispatchSortableEvent('update');
                                dispatchSortableEvent('sort');
                            }
                        }
                    }
                    // Must be done after capturing individual rects (scroll bar)
                    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                        $12b3d2ab131f1390$var$unsetRect(multiDragElement);
                    });
                    toSortable.animateAll();
                }
                $12b3d2ab131f1390$var$multiDragSortable = toSortable;
            }
            // Remove clones if necessary
            if (rootEl === parentEl || putSortable && putSortable.lastPutMode !== 'clone') $12b3d2ab131f1390$var$multiDragClones.forEach(function(clone) {
                clone.parentNode && clone.parentNode.removeChild(clone);
            });
        },
        nullingGlobal: function nullingGlobal() {
            this.isMultiDrag = $12b3d2ab131f1390$var$dragStarted = false;
            $12b3d2ab131f1390$var$multiDragClones.length = 0;
        },
        destroyGlobal: function destroyGlobal() {
            this._deselectMultiDrag();
            $12b3d2ab131f1390$var$off(document, 'pointerup', this._deselectMultiDrag);
            $12b3d2ab131f1390$var$off(document, 'mouseup', this._deselectMultiDrag);
            $12b3d2ab131f1390$var$off(document, 'touchend', this._deselectMultiDrag);
            $12b3d2ab131f1390$var$off(document, 'keydown', this._checkKeyDown);
            $12b3d2ab131f1390$var$off(document, 'keyup', this._checkKeyUp);
        },
        _deselectMultiDrag: function _deselectMultiDrag(evt) {
            if (typeof $12b3d2ab131f1390$var$dragStarted !== "undefined" && $12b3d2ab131f1390$var$dragStarted) return;
            // Only deselect if selection is in this sortable
            if ($12b3d2ab131f1390$var$multiDragSortable !== this.sortable) return;
            // Only deselect if target is not item in this sortable
            if (evt && $12b3d2ab131f1390$var$closest(evt.target, this.options.draggable, this.sortable.el, false)) return;
            // Only deselect if left click
            if (evt && evt.button !== 0) return;
            while($12b3d2ab131f1390$var$multiDragElements.length){
                var el = $12b3d2ab131f1390$var$multiDragElements[0];
                $12b3d2ab131f1390$var$toggleClass(el, this.options.selectedClass, false);
                $12b3d2ab131f1390$var$multiDragElements.shift();
                $12b3d2ab131f1390$var$dispatchEvent({
                    sortable: this.sortable,
                    rootEl: this.sortable.el,
                    name: 'deselect',
                    targetEl: el,
                    originalEvent: evt
                });
            }
        },
        _checkKeyDown: function _checkKeyDown(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = true;
        },
        _checkKeyUp: function _checkKeyUp(evt) {
            if (evt.key === this.options.multiDragKey) this.multiDragKeyDown = false;
        }
    };
    return $12b3d2ab131f1390$var$_extends(MultiDrag, {
        // Static methods & properties
        pluginName: 'multiDrag',
        utils: {
            /**
       * Selects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be selected
       */ select: function select(el) {
                var sortable = el.parentNode[$12b3d2ab131f1390$var$expando];
                if (!sortable || !sortable.options.multiDrag || ~$12b3d2ab131f1390$var$multiDragElements.indexOf(el)) return;
                if ($12b3d2ab131f1390$var$multiDragSortable && $12b3d2ab131f1390$var$multiDragSortable !== sortable) {
                    $12b3d2ab131f1390$var$multiDragSortable.multiDrag._deselectMultiDrag();
                    $12b3d2ab131f1390$var$multiDragSortable = sortable;
                }
                $12b3d2ab131f1390$var$toggleClass(el, sortable.options.selectedClass, true);
                $12b3d2ab131f1390$var$multiDragElements.push(el);
            },
            /**
       * Deselects the provided multi-drag item
       * @param  {HTMLElement} el    The element to be deselected
       */ deselect: function deselect(el) {
                var sortable = el.parentNode[$12b3d2ab131f1390$var$expando], index = $12b3d2ab131f1390$var$multiDragElements.indexOf(el);
                if (!sortable || !sortable.options.multiDrag || !~index) return;
                $12b3d2ab131f1390$var$toggleClass(el, sortable.options.selectedClass, false);
                $12b3d2ab131f1390$var$multiDragElements.splice(index, 1);
            }
        },
        eventProperties: function eventProperties() {
            var _this3 = this;
            var oldIndicies = [], newIndicies = [];
            $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
                oldIndicies.push({
                    multiDragElement: multiDragElement,
                    index: multiDragElement.sortableIndex
                });
                // multiDragElements will already be sorted if folding
                var newIndex;
                if ($12b3d2ab131f1390$var$folding && multiDragElement !== $12b3d2ab131f1390$var$dragEl$1) newIndex = -1;
                else if ($12b3d2ab131f1390$var$folding) newIndex = $12b3d2ab131f1390$var$index(multiDragElement, ':not(.' + _this3.options.selectedClass + ')');
                else newIndex = $12b3d2ab131f1390$var$index(multiDragElement);
                newIndicies.push({
                    multiDragElement: multiDragElement,
                    index: newIndex
                });
            });
            return {
                items: $12b3d2ab131f1390$var$_toConsumableArray($12b3d2ab131f1390$var$multiDragElements),
                clones: [].concat($12b3d2ab131f1390$var$multiDragClones),
                oldIndicies: oldIndicies,
                newIndicies: newIndicies
            };
        },
        optionListeners: {
            multiDragKey: function multiDragKey(key) {
                key = key.toLowerCase();
                if (key === 'ctrl') key = 'Control';
                else if (key.length > 1) key = key.charAt(0).toUpperCase() + key.substr(1);
                return key;
            }
        }
    });
}
function $12b3d2ab131f1390$var$insertMultiDragElements(clonesInserted, rootEl) {
    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement, i) {
        var target = rootEl.children[multiDragElement.sortableIndex + (clonesInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(multiDragElement, target);
        else rootEl.appendChild(multiDragElement);
    });
}
/**
 * Insert multi-drag clones
 * @param  {[Boolean]} elementsInserted  Whether the multi-drag elements are inserted
 * @param  {HTMLElement} rootEl
 */ function $12b3d2ab131f1390$var$insertMultiDragClones(elementsInserted, rootEl) {
    $12b3d2ab131f1390$var$multiDragClones.forEach(function(clone, i) {
        var target = rootEl.children[clone.sortableIndex + (elementsInserted ? Number(i) : 0)];
        if (target) rootEl.insertBefore(clone, target);
        else rootEl.appendChild(clone);
    });
}
function $12b3d2ab131f1390$var$removeMultiDragElements() {
    $12b3d2ab131f1390$var$multiDragElements.forEach(function(multiDragElement) {
        if (multiDragElement === $12b3d2ab131f1390$var$dragEl$1) return;
        multiDragElement.parentNode && multiDragElement.parentNode.removeChild(multiDragElement);
    });
}
$12b3d2ab131f1390$export$31b3ca70d8f57423.mount(new $12b3d2ab131f1390$var$AutoScrollPlugin());
$12b3d2ab131f1390$export$31b3ca70d8f57423.mount($12b3d2ab131f1390$var$Remove, $12b3d2ab131f1390$var$Revert);
var $12b3d2ab131f1390$export$2e2bcd8739ae039 = $12b3d2ab131f1390$export$31b3ca70d8f57423;



var $1etvo = parcelRequire("1etvo");

var $ajWU5 = parcelRequire("ajWU5");
var $0bf20c284735f0ff$exports = {};
$0bf20c284735f0ff$exports = $parcel$resolve("jehra");



var $kJBqN = parcelRequire("kJBqN");
var $203bba2ce8792506$exports = {};

var $1etvo = parcelRequire("1etvo");

var $kJBqN = parcelRequire("kJBqN");
var $203bba2ce8792506$require$Buffer = $kJBqN.Buffer;
var $c0b535f73fd0ccc6$exports = {};
var $53b4d4551365c212$exports = {};
/*
  Copyright (c) 2008, Adobe Systems Incorporated
  All rights reserved.

  Redistribution and use in source and binary forms, with or without 
  modification, are permitted provided that the following conditions are
  met:

  * Redistributions of source code must retain the above copyright notice, 
    this list of conditions and the following disclaimer.
  
  * Redistributions in binary form must reproduce the above copyright
    notice, this list of conditions and the following disclaimer in the 
    documentation and/or other materials provided with the distribution.
  
  * Neither the name of Adobe Systems Incorporated nor the names of its 
    contributors may be used to endorse or promote products derived from 
    this software without specific prior written permission.

  THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS
  IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO,
  THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR
  PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR 
  CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL,
  EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO,
  PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR
  PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF
  LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING
  NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
  SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/ /*
JPEG encoder ported to JavaScript and optimized by Andreas Ritter, www.bytestrom.eu, 11/2009

Basic GUI blocking jpeg encoder
*/ 
var $kJBqN = parcelRequire("kJBqN");
var $53b4d4551365c212$require$Buffer = $kJBqN.Buffer;
var $53b4d4551365c212$var$btoa = $53b4d4551365c212$var$btoa || function(buf) {
    return $53b4d4551365c212$require$Buffer.from(buf).toString('base64');
};
function $53b4d4551365c212$var$JPEGEncoder(quality) {
    var self = this;
    var fround = Math.round;
    var ffloor = Math.floor;
    var YTable = new Array(64);
    var UVTable = new Array(64);
    var fdtbl_Y = new Array(64);
    var fdtbl_UV = new Array(64);
    var YDC_HT;
    var UVDC_HT;
    var YAC_HT;
    var UVAC_HT;
    var bitcode = new Array(65535);
    var category = new Array(65535);
    var outputfDCTQuant = new Array(64);
    var DU = new Array(64);
    var byteout = [];
    var bytenew = 0;
    var bytepos = 7;
    var YDU = new Array(64);
    var UDU = new Array(64);
    var VDU = new Array(64);
    var clt = new Array(256);
    var RGB_YUV_TABLE = new Array(2048);
    var currentQuality;
    var ZigZag = [
        0,
        1,
        5,
        6,
        14,
        15,
        27,
        28,
        2,
        4,
        7,
        13,
        16,
        26,
        29,
        42,
        3,
        8,
        12,
        17,
        25,
        30,
        41,
        43,
        9,
        11,
        18,
        24,
        31,
        40,
        44,
        53,
        10,
        19,
        23,
        32,
        39,
        45,
        52,
        54,
        20,
        22,
        33,
        38,
        46,
        51,
        55,
        60,
        21,
        34,
        37,
        47,
        50,
        56,
        59,
        61,
        35,
        36,
        48,
        49,
        57,
        58,
        62,
        63
    ];
    var std_dc_luminance_nrcodes = [
        0,
        0,
        1,
        5,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var std_dc_luminance_values = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ];
    var std_ac_luminance_nrcodes = [
        0,
        0,
        2,
        1,
        3,
        3,
        2,
        4,
        3,
        5,
        5,
        4,
        4,
        0,
        0,
        1,
        0x7d
    ];
    var std_ac_luminance_values = [
        0x01,
        0x02,
        0x03,
        0x00,
        0x04,
        0x11,
        0x05,
        0x12,
        0x21,
        0x31,
        0x41,
        0x06,
        0x13,
        0x51,
        0x61,
        0x07,
        0x22,
        0x71,
        0x14,
        0x32,
        0x81,
        0x91,
        0xa1,
        0x08,
        0x23,
        0x42,
        0xb1,
        0xc1,
        0x15,
        0x52,
        0xd1,
        0xf0,
        0x24,
        0x33,
        0x62,
        0x72,
        0x82,
        0x09,
        0x0a,
        0x16,
        0x17,
        0x18,
        0x19,
        0x1a,
        0x25,
        0x26,
        0x27,
        0x28,
        0x29,
        0x2a,
        0x34,
        0x35,
        0x36,
        0x37,
        0x38,
        0x39,
        0x3a,
        0x43,
        0x44,
        0x45,
        0x46,
        0x47,
        0x48,
        0x49,
        0x4a,
        0x53,
        0x54,
        0x55,
        0x56,
        0x57,
        0x58,
        0x59,
        0x5a,
        0x63,
        0x64,
        0x65,
        0x66,
        0x67,
        0x68,
        0x69,
        0x6a,
        0x73,
        0x74,
        0x75,
        0x76,
        0x77,
        0x78,
        0x79,
        0x7a,
        0x83,
        0x84,
        0x85,
        0x86,
        0x87,
        0x88,
        0x89,
        0x8a,
        0x92,
        0x93,
        0x94,
        0x95,
        0x96,
        0x97,
        0x98,
        0x99,
        0x9a,
        0xa2,
        0xa3,
        0xa4,
        0xa5,
        0xa6,
        0xa7,
        0xa8,
        0xa9,
        0xaa,
        0xb2,
        0xb3,
        0xb4,
        0xb5,
        0xb6,
        0xb7,
        0xb8,
        0xb9,
        0xba,
        0xc2,
        0xc3,
        0xc4,
        0xc5,
        0xc6,
        0xc7,
        0xc8,
        0xc9,
        0xca,
        0xd2,
        0xd3,
        0xd4,
        0xd5,
        0xd6,
        0xd7,
        0xd8,
        0xd9,
        0xda,
        0xe1,
        0xe2,
        0xe3,
        0xe4,
        0xe5,
        0xe6,
        0xe7,
        0xe8,
        0xe9,
        0xea,
        0xf1,
        0xf2,
        0xf3,
        0xf4,
        0xf5,
        0xf6,
        0xf7,
        0xf8,
        0xf9,
        0xfa
    ];
    var std_dc_chrominance_nrcodes = [
        0,
        0,
        3,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        1,
        0,
        0,
        0,
        0,
        0
    ];
    var std_dc_chrominance_values = [
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        10,
        11
    ];
    var std_ac_chrominance_nrcodes = [
        0,
        0,
        2,
        1,
        2,
        4,
        4,
        3,
        4,
        7,
        5,
        4,
        4,
        0,
        1,
        2,
        0x77
    ];
    var std_ac_chrominance_values = [
        0x00,
        0x01,
        0x02,
        0x03,
        0x11,
        0x04,
        0x05,
        0x21,
        0x31,
        0x06,
        0x12,
        0x41,
        0x51,
        0x07,
        0x61,
        0x71,
        0x13,
        0x22,
        0x32,
        0x81,
        0x08,
        0x14,
        0x42,
        0x91,
        0xa1,
        0xb1,
        0xc1,
        0x09,
        0x23,
        0x33,
        0x52,
        0xf0,
        0x15,
        0x62,
        0x72,
        0xd1,
        0x0a,
        0x16,
        0x24,
        0x34,
        0xe1,
        0x25,
        0xf1,
        0x17,
        0x18,
        0x19,
        0x1a,
        0x26,
        0x27,
        0x28,
        0x29,
        0x2a,
        0x35,
        0x36,
        0x37,
        0x38,
        0x39,
        0x3a,
        0x43,
        0x44,
        0x45,
        0x46,
        0x47,
        0x48,
        0x49,
        0x4a,
        0x53,
        0x54,
        0x55,
        0x56,
        0x57,
        0x58,
        0x59,
        0x5a,
        0x63,
        0x64,
        0x65,
        0x66,
        0x67,
        0x68,
        0x69,
        0x6a,
        0x73,
        0x74,
        0x75,
        0x76,
        0x77,
        0x78,
        0x79,
        0x7a,
        0x82,
        0x83,
        0x84,
        0x85,
        0x86,
        0x87,
        0x88,
        0x89,
        0x8a,
        0x92,
        0x93,
        0x94,
        0x95,
        0x96,
        0x97,
        0x98,
        0x99,
        0x9a,
        0xa2,
        0xa3,
        0xa4,
        0xa5,
        0xa6,
        0xa7,
        0xa8,
        0xa9,
        0xaa,
        0xb2,
        0xb3,
        0xb4,
        0xb5,
        0xb6,
        0xb7,
        0xb8,
        0xb9,
        0xba,
        0xc2,
        0xc3,
        0xc4,
        0xc5,
        0xc6,
        0xc7,
        0xc8,
        0xc9,
        0xca,
        0xd2,
        0xd3,
        0xd4,
        0xd5,
        0xd6,
        0xd7,
        0xd8,
        0xd9,
        0xda,
        0xe2,
        0xe3,
        0xe4,
        0xe5,
        0xe6,
        0xe7,
        0xe8,
        0xe9,
        0xea,
        0xf2,
        0xf3,
        0xf4,
        0xf5,
        0xf6,
        0xf7,
        0xf8,
        0xf9,
        0xfa
    ];
    function initQuantTables(sf) {
        var YQT = [
            16,
            11,
            10,
            16,
            24,
            40,
            51,
            61,
            12,
            12,
            14,
            19,
            26,
            58,
            60,
            55,
            14,
            13,
            16,
            24,
            40,
            57,
            69,
            56,
            14,
            17,
            22,
            29,
            51,
            87,
            80,
            62,
            18,
            22,
            37,
            56,
            68,
            109,
            103,
            77,
            24,
            35,
            55,
            64,
            81,
            104,
            113,
            92,
            49,
            64,
            78,
            87,
            103,
            121,
            120,
            101,
            72,
            92,
            95,
            98,
            112,
            100,
            103,
            99
        ];
        for(var i = 0; i < 64; i++){
            var t = ffloor((YQT[i] * sf + 50) / 100);
            if (t < 1) t = 1;
            else if (t > 255) t = 255;
            YTable[ZigZag[i]] = t;
        }
        var UVQT = [
            17,
            18,
            24,
            47,
            99,
            99,
            99,
            99,
            18,
            21,
            26,
            66,
            99,
            99,
            99,
            99,
            24,
            26,
            56,
            99,
            99,
            99,
            99,
            99,
            47,
            66,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99,
            99
        ];
        for(var j = 0; j < 64; j++){
            var u = ffloor((UVQT[j] * sf + 50) / 100);
            if (u < 1) u = 1;
            else if (u > 255) u = 255;
            UVTable[ZigZag[j]] = u;
        }
        var aasf = [
            1.0,
            1.387039845,
            1.306562965,
            1.175875602,
            1.0,
            0.785694958,
            0.541196100,
            0.275899379
        ];
        var k = 0;
        for(var row = 0; row < 8; row++)for(var col = 0; col < 8; col++){
            fdtbl_Y[k] = 1.0 / (YTable[ZigZag[k]] * aasf[row] * aasf[col] * 8.0);
            fdtbl_UV[k] = 1.0 / (UVTable[ZigZag[k]] * aasf[row] * aasf[col] * 8.0);
            k++;
        }
    }
    function computeHuffmanTbl(nrcodes, std_table) {
        var codevalue = 0;
        var pos_in_table = 0;
        var HT = new Array();
        for(var k = 1; k <= 16; k++){
            for(var j = 1; j <= nrcodes[k]; j++){
                HT[std_table[pos_in_table]] = [];
                HT[std_table[pos_in_table]][0] = codevalue;
                HT[std_table[pos_in_table]][1] = k;
                pos_in_table++;
                codevalue++;
            }
            codevalue *= 2;
        }
        return HT;
    }
    function initHuffmanTbl() {
        YDC_HT = computeHuffmanTbl(std_dc_luminance_nrcodes, std_dc_luminance_values);
        UVDC_HT = computeHuffmanTbl(std_dc_chrominance_nrcodes, std_dc_chrominance_values);
        YAC_HT = computeHuffmanTbl(std_ac_luminance_nrcodes, std_ac_luminance_values);
        UVAC_HT = computeHuffmanTbl(std_ac_chrominance_nrcodes, std_ac_chrominance_values);
    }
    function initCategoryNumber() {
        var nrlower = 1;
        var nrupper = 2;
        for(var cat = 1; cat <= 15; cat++){
            //Positive numbers
            for(var nr = nrlower; nr < nrupper; nr++){
                category[32767 + nr] = cat;
                bitcode[32767 + nr] = [];
                bitcode[32767 + nr][1] = cat;
                bitcode[32767 + nr][0] = nr;
            }
            //Negative numbers
            for(var nrneg = -(nrupper - 1); nrneg <= -nrlower; nrneg++){
                category[32767 + nrneg] = cat;
                bitcode[32767 + nrneg] = [];
                bitcode[32767 + nrneg][1] = cat;
                bitcode[32767 + nrneg][0] = nrupper - 1 + nrneg;
            }
            nrlower <<= 1;
            nrupper <<= 1;
        }
    }
    function initRGBYUVTable() {
        for(var i = 0; i < 256; i++){
            RGB_YUV_TABLE[i] = 19595 * i;
            RGB_YUV_TABLE[i + 256 >> 0] = 38470 * i;
            RGB_YUV_TABLE[i + 512 >> 0] = 7471 * i + 0x8000;
            RGB_YUV_TABLE[i + 768 >> 0] = -11059 * i;
            RGB_YUV_TABLE[i + 1024 >> 0] = -21709 * i;
            RGB_YUV_TABLE[i + 1280 >> 0] = 32768 * i + 0x807FFF;
            RGB_YUV_TABLE[i + 1536 >> 0] = -27439 * i;
            RGB_YUV_TABLE[i + 1792 >> 0] = -5329 * i;
        }
    }
    // IO functions
    function writeBits(bs) {
        var value = bs[0];
        var posval = bs[1] - 1;
        while(posval >= 0){
            if (value & 1 << posval) bytenew |= 1 << bytepos;
            posval--;
            bytepos--;
            if (bytepos < 0) {
                if (bytenew == 0xFF) {
                    writeByte(0xFF);
                    writeByte(0);
                } else writeByte(bytenew);
                bytepos = 7;
                bytenew = 0;
            }
        }
    }
    function writeByte(value) {
        //byteout.push(clt[value]); // write char directly instead of converting later
        byteout.push(value);
    }
    function writeWord(value) {
        writeByte(value >> 8 & 0xFF);
        writeByte(value & 0xFF);
    }
    // DCT & quantization core
    function fDCTQuant(data, fdtbl) {
        var d0, d1, d2, d3, d4, d5, d6, d7;
        /* Pass 1: process rows. */ var dataOff = 0;
        var i;
        var I8 = 8;
        var I64 = 64;
        for(i = 0; i < I8; ++i){
            d0 = data[dataOff];
            d1 = data[dataOff + 1];
            d2 = data[dataOff + 2];
            d3 = data[dataOff + 3];
            d4 = data[dataOff + 4];
            d5 = data[dataOff + 5];
            d6 = data[dataOff + 6];
            d7 = data[dataOff + 7];
            var tmp0 = d0 + d7;
            var tmp7 = d0 - d7;
            var tmp1 = d1 + d6;
            var tmp6 = d1 - d6;
            var tmp2 = d2 + d5;
            var tmp5 = d2 - d5;
            var tmp3 = d3 + d4;
            var tmp4 = d3 - d4;
            /* Even part */ var tmp10 = tmp0 + tmp3; /* phase 2 */ 
            var tmp13 = tmp0 - tmp3;
            var tmp11 = tmp1 + tmp2;
            var tmp12 = tmp1 - tmp2;
            data[dataOff] = tmp10 + tmp11; /* phase 3 */ 
            data[dataOff + 4] = tmp10 - tmp11;
            var z1 = (tmp12 + tmp13) * 0.707106781; /* c4 */ 
            data[dataOff + 2] = tmp13 + z1; /* phase 5 */ 
            data[dataOff + 6] = tmp13 - z1;
            /* Odd part */ tmp10 = tmp4 + tmp5; /* phase 2 */ 
            tmp11 = tmp5 + tmp6;
            tmp12 = tmp6 + tmp7;
            /* The rotator is modified from fig 4-8 to avoid extra negations. */ var z5 = (tmp10 - tmp12) * 0.382683433; /* c6 */ 
            var z2 = 0.541196100 * tmp10 + z5; /* c2-c6 */ 
            var z4 = 1.306562965 * tmp12 + z5; /* c2+c6 */ 
            var z3 = tmp11 * 0.707106781; /* c4 */ 
            var z11 = tmp7 + z3; /* phase 5 */ 
            var z13 = tmp7 - z3;
            data[dataOff + 5] = z13 + z2; /* phase 6 */ 
            data[dataOff + 3] = z13 - z2;
            data[dataOff + 1] = z11 + z4;
            data[dataOff + 7] = z11 - z4;
            dataOff += 8; /* advance pointer to next row */ 
        }
        /* Pass 2: process columns. */ dataOff = 0;
        for(i = 0; i < I8; ++i){
            d0 = data[dataOff];
            d1 = data[dataOff + 8];
            d2 = data[dataOff + 16];
            d3 = data[dataOff + 24];
            d4 = data[dataOff + 32];
            d5 = data[dataOff + 40];
            d6 = data[dataOff + 48];
            d7 = data[dataOff + 56];
            var tmp0p2 = d0 + d7;
            var tmp7p2 = d0 - d7;
            var tmp1p2 = d1 + d6;
            var tmp6p2 = d1 - d6;
            var tmp2p2 = d2 + d5;
            var tmp5p2 = d2 - d5;
            var tmp3p2 = d3 + d4;
            var tmp4p2 = d3 - d4;
            /* Even part */ var tmp10p2 = tmp0p2 + tmp3p2; /* phase 2 */ 
            var tmp13p2 = tmp0p2 - tmp3p2;
            var tmp11p2 = tmp1p2 + tmp2p2;
            var tmp12p2 = tmp1p2 - tmp2p2;
            data[dataOff] = tmp10p2 + tmp11p2; /* phase 3 */ 
            data[dataOff + 32] = tmp10p2 - tmp11p2;
            var z1p2 = (tmp12p2 + tmp13p2) * 0.707106781; /* c4 */ 
            data[dataOff + 16] = tmp13p2 + z1p2; /* phase 5 */ 
            data[dataOff + 48] = tmp13p2 - z1p2;
            /* Odd part */ tmp10p2 = tmp4p2 + tmp5p2; /* phase 2 */ 
            tmp11p2 = tmp5p2 + tmp6p2;
            tmp12p2 = tmp6p2 + tmp7p2;
            /* The rotator is modified from fig 4-8 to avoid extra negations. */ var z5p2 = (tmp10p2 - tmp12p2) * 0.382683433; /* c6 */ 
            var z2p2 = 0.541196100 * tmp10p2 + z5p2; /* c2-c6 */ 
            var z4p2 = 1.306562965 * tmp12p2 + z5p2; /* c2+c6 */ 
            var z3p2 = tmp11p2 * 0.707106781; /* c4 */ 
            var z11p2 = tmp7p2 + z3p2; /* phase 5 */ 
            var z13p2 = tmp7p2 - z3p2;
            data[dataOff + 40] = z13p2 + z2p2; /* phase 6 */ 
            data[dataOff + 24] = z13p2 - z2p2;
            data[dataOff + 8] = z11p2 + z4p2;
            data[dataOff + 56] = z11p2 - z4p2;
            dataOff++; /* advance pointer to next column */ 
        }
        // Quantize/descale the coefficients
        var fDCTQuant;
        for(i = 0; i < I64; ++i){
            // Apply the quantization and scaling factor & Round to nearest integer
            fDCTQuant = data[i] * fdtbl[i];
            outputfDCTQuant[i] = fDCTQuant > 0.0 ? fDCTQuant + 0.5 | 0 : fDCTQuant - 0.5 | 0;
        //outputfDCTQuant[i] = fround(fDCTQuant);
        }
        return outputfDCTQuant;
    }
    function writeAPP0() {
        writeWord(0xFFE0); // marker
        writeWord(16); // length
        writeByte(0x4A); // J
        writeByte(0x46); // F
        writeByte(0x49); // I
        writeByte(0x46); // F
        writeByte(0); // = "JFIF",'\0'
        writeByte(1); // versionhi
        writeByte(1); // versionlo
        writeByte(0); // xyunits
        writeWord(1); // xdensity
        writeWord(1); // ydensity
        writeByte(0); // thumbnwidth
        writeByte(0); // thumbnheight
    }
    function writeAPP1(exifBuffer) {
        if (!exifBuffer) return;
        writeWord(0xFFE1); // APP1 marker
        if (exifBuffer[0] === 0x45 && exifBuffer[1] === 0x78 && exifBuffer[2] === 0x69 && exifBuffer[3] === 0x66) // Buffer already starts with EXIF, just use it directly
        writeWord(exifBuffer.length + 2); // length is buffer + length itself!
        else {
            // Buffer doesn't start with EXIF, write it for them
            writeWord(exifBuffer.length + 5 + 2); // length is buffer + EXIF\0 + length itself!
            writeByte(0x45); // E
            writeByte(0x78); // X
            writeByte(0x69); // I
            writeByte(0x66); // F
            writeByte(0); // = "EXIF",'\0'
        }
        for(var i = 0; i < exifBuffer.length; i++)writeByte(exifBuffer[i]);
    }
    function writeSOF0(width, height) {
        writeWord(0xFFC0); // marker
        writeWord(17); // length, truecolor YUV JPG
        writeByte(8); // precision
        writeWord(height);
        writeWord(width);
        writeByte(3); // nrofcomponents
        writeByte(1); // IdY
        writeByte(0x11); // HVY
        writeByte(0); // QTY
        writeByte(2); // IdU
        writeByte(0x11); // HVU
        writeByte(1); // QTU
        writeByte(3); // IdV
        writeByte(0x11); // HVV
        writeByte(1); // QTV
    }
    function writeDQT() {
        writeWord(0xFFDB); // marker
        writeWord(132); // length
        writeByte(0);
        for(var i = 0; i < 64; i++)writeByte(YTable[i]);
        writeByte(1);
        for(var j = 0; j < 64; j++)writeByte(UVTable[j]);
    }
    function writeDHT() {
        writeWord(0xFFC4); // marker
        writeWord(0x01A2); // length
        writeByte(0); // HTYDCinfo
        for(var i = 0; i < 16; i++)writeByte(std_dc_luminance_nrcodes[i + 1]);
        for(var j = 0; j <= 11; j++)writeByte(std_dc_luminance_values[j]);
        writeByte(0x10); // HTYACinfo
        for(var k = 0; k < 16; k++)writeByte(std_ac_luminance_nrcodes[k + 1]);
        for(var l = 0; l <= 161; l++)writeByte(std_ac_luminance_values[l]);
        writeByte(1); // HTUDCinfo
        for(var m = 0; m < 16; m++)writeByte(std_dc_chrominance_nrcodes[m + 1]);
        for(var n = 0; n <= 11; n++)writeByte(std_dc_chrominance_values[n]);
        writeByte(0x11); // HTUACinfo
        for(var o = 0; o < 16; o++)writeByte(std_ac_chrominance_nrcodes[o + 1]);
        for(var p = 0; p <= 161; p++)writeByte(std_ac_chrominance_values[p]);
    }
    function writeCOM(comments) {
        if (typeof comments === "undefined" || comments.constructor !== Array) return;
        comments.forEach((e)=>{
            if (typeof e !== "string") return;
            writeWord(0xFFFE); // marker
            var l = e.length;
            writeWord(l + 2); // length itself as well
            var i;
            for(i = 0; i < l; i++)writeByte(e.charCodeAt(i));
        });
    }
    function writeSOS() {
        writeWord(0xFFDA); // marker
        writeWord(12); // length
        writeByte(3); // nrofcomponents
        writeByte(1); // IdY
        writeByte(0); // HTY
        writeByte(2); // IdU
        writeByte(0x11); // HTU
        writeByte(3); // IdV
        writeByte(0x11); // HTV
        writeByte(0); // Ss
        writeByte(0x3f); // Se
        writeByte(0); // Bf
    }
    function processDU(CDU, fdtbl, DC, HTDC, HTAC) {
        var EOB = HTAC[0x00];
        var M16zeroes = HTAC[0xF0];
        var pos;
        var I16 = 16;
        var I63 = 63;
        var I64 = 64;
        var DU_DCT = fDCTQuant(CDU, fdtbl);
        //ZigZag reorder
        for(var j = 0; j < I64; ++j)DU[ZigZag[j]] = DU_DCT[j];
        var Diff = DU[0] - DC;
        DC = DU[0];
        //Encode DC
        if (Diff == 0) writeBits(HTDC[0]); // Diff might be 0
        else {
            pos = 32767 + Diff;
            writeBits(HTDC[category[pos]]);
            writeBits(bitcode[pos]);
        }
        //Encode ACs
        var end0pos = 63; // was const... which is crazy
        for(; end0pos > 0 && DU[end0pos] == 0; end0pos--);
        //end0pos = first element in reverse order !=0
        if (end0pos == 0) {
            writeBits(EOB);
            return DC;
        }
        var i = 1;
        var lng;
        while(i <= end0pos){
            var startpos = i;
            for(; DU[i] == 0 && i <= end0pos; ++i);
            var nrzeroes = i - startpos;
            if (nrzeroes >= I16) {
                lng = nrzeroes >> 4;
                for(var nrmarker = 1; nrmarker <= lng; ++nrmarker)writeBits(M16zeroes);
                nrzeroes = nrzeroes & 0xF;
            }
            pos = 32767 + DU[i];
            writeBits(HTAC[(nrzeroes << 4) + category[pos]]);
            writeBits(bitcode[pos]);
            i++;
        }
        if (end0pos != I63) writeBits(EOB);
        return DC;
    }
    function initCharLookupTable() {
        var sfcc = String.fromCharCode;
        for(var i = 0; i < 256; i++)clt[i] = sfcc(i);
    }
    this.encode = function(image, quality) {
        var time_start = new Date().getTime();
        if (quality) setQuality(quality);
        // Initialize bit writer
        byteout = new Array();
        bytenew = 0;
        bytepos = 7;
        // Add JPEG headers
        writeWord(0xFFD8); // SOI
        writeAPP0();
        writeCOM(image.comments);
        writeAPP1(image.exifBuffer);
        writeDQT();
        writeSOF0(image.width, image.height);
        writeDHT();
        writeSOS();
        // Encode 8x8 macroblocks
        var DCY = 0;
        var DCU = 0;
        var DCV = 0;
        bytenew = 0;
        bytepos = 7;
        this.encode.displayName = "_encode_";
        var imageData = image.data;
        var width = image.width;
        var height = image.height;
        var quadWidth = width * 4;
        var tripleWidth = width * 3;
        var x, y = 0;
        var r, g, b;
        var start, p, col, row, pos;
        while(y < height){
            x = 0;
            while(x < quadWidth){
                start = quadWidth * y + x;
                p = start;
                col = -1;
                row = 0;
                for(pos = 0; pos < 64; pos++){
                    row = pos >> 3; // /8
                    col = (pos & 7) * 4; // %8
                    p = start + row * quadWidth + col;
                    if (y + row >= height) p -= quadWidth * (y + 1 + row - height);
                    if (x + col >= quadWidth) p -= x + col - quadWidth + 4;
                    r = imageData[p++];
                    g = imageData[p++];
                    b = imageData[p++];
                    /* // calculate YUV values dynamically
					YDU[pos]=((( 0.29900)*r+( 0.58700)*g+( 0.11400)*b))-128; //-0x80
					UDU[pos]=(((-0.16874)*r+(-0.33126)*g+( 0.50000)*b));
					VDU[pos]=((( 0.50000)*r+(-0.41869)*g+(-0.08131)*b));
					*/ // use lookup table (slightly faster)
                    YDU[pos] = (RGB_YUV_TABLE[r] + RGB_YUV_TABLE[g + 256 >> 0] + RGB_YUV_TABLE[b + 512 >> 0] >> 16) - 128;
                    UDU[pos] = (RGB_YUV_TABLE[r + 768 >> 0] + RGB_YUV_TABLE[g + 1024 >> 0] + RGB_YUV_TABLE[b + 1280 >> 0] >> 16) - 128;
                    VDU[pos] = (RGB_YUV_TABLE[r + 1280 >> 0] + RGB_YUV_TABLE[g + 1536 >> 0] + RGB_YUV_TABLE[b + 1792 >> 0] >> 16) - 128;
                }
                DCY = processDU(YDU, fdtbl_Y, DCY, YDC_HT, YAC_HT);
                DCU = processDU(UDU, fdtbl_UV, DCU, UVDC_HT, UVAC_HT);
                DCV = processDU(VDU, fdtbl_UV, DCV, UVDC_HT, UVAC_HT);
                x += 32;
            }
            y += 8;
        }
        ////////////////////////////////////////////////////////////////
        // Do the bit alignment of the EOI marker
        if (bytepos >= 0) {
            var fillbits = [];
            fillbits[1] = bytepos + 1;
            fillbits[0] = (1 << bytepos + 1) - 1;
            writeBits(fillbits);
        }
        writeWord(0xFFD9); //EOI
        var jpegDataUri, duration;
        return $53b4d4551365c212$require$Buffer.from(byteout);
    };
    function setQuality(quality) {
        if (quality <= 0) quality = 1;
        if (quality > 100) quality = 100;
        if (currentQuality == quality) return; // don't recalc if unchanged
        var sf = 0;
        if (quality < 50) sf = Math.floor(5000 / quality);
        else sf = Math.floor(200 - quality * 2);
        initQuantTables(sf);
        currentQuality = quality;
    //console.log('Quality set to: '+quality +'%');
    }
    function init() {
        var time_start = new Date().getTime();
        if (!quality) quality = 50;
        // Create tables
        initCharLookupTable();
        initHuffmanTbl();
        initCategoryNumber();
        initRGBYUVTable();
        setQuality(quality);
        var duration = new Date().getTime() - time_start;
    //console.log('Initialization '+ duration + 'ms');
    }
    init();
}
$53b4d4551365c212$exports = $53b4d4551365c212$var$encode;
function $53b4d4551365c212$var$encode(imgData, qu) {
    if (typeof qu === 'undefined') qu = 50;
    var encoder = new $53b4d4551365c212$var$JPEGEncoder(qu);
    var data = encoder.encode(imgData, qu);
    return {
        data: data,
        width: imgData.width,
        height: imgData.height
    };
}
// helper function to get the imageData of an existing image on the current page.
function $53b4d4551365c212$var$getImageDataFromImage(idOrElement) {
    var theImg = typeof idOrElement == 'string' ? document.getElementById(idOrElement) : idOrElement;
    var cvs = document.createElement('canvas');
    cvs.width = theImg.width;
    cvs.height = theImg.height;
    var ctx = cvs.getContext("2d");
    ctx.drawImage(theImg, 0, 0);
    return ctx.getImageData(0, 0, cvs.width, cvs.height);
}


var $46aef114a95be856$exports = {};
/* -*- tab-width: 2; indent-tabs-mode: nil; c-basic-offset: 2 -*- /
/* vim: set shiftwidth=2 tabstop=2 autoindent cindent expandtab: */ /*
   Copyright 2011 notmasteryet

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

       http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ // - The JPEG specification can be found in the ITU CCITT Recommendation T.81
//   (www.w3.org/Graphics/JPEG/itu-t81.pdf)
// - The JFIF specification can be found in the JPEG File Interchange Format
//   (www.w3.org/Graphics/JPEG/jfif3.pdf)
// - The Adobe Application-Specific JPEG markers in the Supporting the DCT Filters
//   in PostScript Level 2, Technical Note #5116
//   (partners.adobe.com/public/developer/en/ps/sdk/5116.DCT_Filter.pdf)

var $cTSGB = parcelRequire("cTSGB");

var $kJBqN = parcelRequire("kJBqN");
var $46aef114a95be856$require$Buffer = $kJBqN.Buffer;
var $46aef114a95be856$var$JpegImage = function jpegImage() {
    "use strict";
    var dctZigZag = new Int32Array([
        0,
        1,
        8,
        16,
        9,
        2,
        3,
        10,
        17,
        24,
        32,
        25,
        18,
        11,
        4,
        5,
        12,
        19,
        26,
        33,
        40,
        48,
        41,
        34,
        27,
        20,
        13,
        6,
        7,
        14,
        21,
        28,
        35,
        42,
        49,
        56,
        57,
        50,
        43,
        36,
        29,
        22,
        15,
        23,
        30,
        37,
        44,
        51,
        58,
        59,
        52,
        45,
        38,
        31,
        39,
        46,
        53,
        60,
        61,
        54,
        47,
        55,
        62,
        63
    ]);
    var dctCos1 = 4017 // cos(pi/16)
    ;
    var dctSin1 = 799 // sin(pi/16)
    ;
    var dctCos3 = 3406 // cos(3*pi/16)
    ;
    var dctSin3 = 2276 // sin(3*pi/16)
    ;
    var dctCos6 = 1567 // cos(6*pi/16)
    ;
    var dctSin6 = 3784 // sin(6*pi/16)
    ;
    var dctSqrt2 = 5793 // sqrt(2)
    ;
    var dctSqrt1d2 = 2896 // sqrt(2) / 2
    ;
    function constructor() {}
    function buildHuffmanTable(codeLengths, values) {
        var k = 0, code = [], i, j, length = 16;
        while(length > 0 && !codeLengths[length - 1])length--;
        code.push({
            children: [],
            index: 0
        });
        var p = code[0], q;
        for(i = 0; i < length; i++){
            for(j = 0; j < codeLengths[i]; j++){
                p = code.pop();
                p.children[p.index] = values[k];
                while(p.index > 0){
                    if (code.length === 0) throw new Error('Could not recreate Huffman Table');
                    p = code.pop();
                }
                p.index++;
                code.push(p);
                while(code.length <= i){
                    code.push(q = {
                        children: [],
                        index: 0
                    });
                    p.children[p.index] = q.children;
                    p = q;
                }
                k++;
            }
            if (i + 1 < length) {
                // p here points to last code
                code.push(q = {
                    children: [],
                    index: 0
                });
                p.children[p.index] = q.children;
                p = q;
            }
        }
        return code[0].children;
    }
    function decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successivePrev, successive, opts) {
        var precision = frame.precision;
        var samplesPerLine = frame.samplesPerLine;
        var scanLines = frame.scanLines;
        var mcusPerLine = frame.mcusPerLine;
        var progressive = frame.progressive;
        var maxH = frame.maxH, maxV = frame.maxV;
        var startOffset = offset, bitsData = 0, bitsCount = 0;
        function readBit() {
            if (bitsCount > 0) {
                bitsCount--;
                return bitsData >> bitsCount & 1;
            }
            bitsData = data[offset++];
            if (bitsData == 0xFF) {
                var nextByte = data[offset++];
                if (nextByte) throw new Error("unexpected marker: " + (bitsData << 8 | nextByte).toString(16));
            // unstuff 0
            }
            bitsCount = 7;
            return bitsData >>> 7;
        }
        function decodeHuffman(tree) {
            var node = tree, bit;
            while((bit = readBit()) !== null){
                node = node[bit];
                if (typeof node === 'number') return node;
                if (typeof node !== 'object') throw new Error("invalid huffman sequence");
            }
            return null;
        }
        function receive(length) {
            var n = 0;
            while(length > 0){
                var bit = readBit();
                if (bit === null) return;
                n = n << 1 | bit;
                length--;
            }
            return n;
        }
        function receiveAndExtend(length) {
            var n = receive(length);
            if (n >= 1 << length - 1) return n;
            return n + (-1 << length) + 1;
        }
        function decodeBaseline(component, zz) {
            var t = decodeHuffman(component.huffmanTableDC);
            var diff = t === 0 ? 0 : receiveAndExtend(t);
            zz[0] = component.pred += diff;
            var k = 1;
            while(k < 64){
                var rs = decodeHuffman(component.huffmanTableAC);
                var s = rs & 15, r = rs >> 4;
                if (s === 0) {
                    if (r < 15) break;
                    k += 16;
                    continue;
                }
                k += r;
                var z = dctZigZag[k];
                zz[z] = receiveAndExtend(s);
                k++;
            }
        }
        function decodeDCFirst(component, zz) {
            var t = decodeHuffman(component.huffmanTableDC);
            var diff = t === 0 ? 0 : receiveAndExtend(t) << successive;
            zz[0] = component.pred += diff;
        }
        function decodeDCSuccessive(component, zz) {
            zz[0] |= readBit() << successive;
        }
        var eobrun = 0;
        function decodeACFirst(component, zz) {
            if (eobrun > 0) {
                eobrun--;
                return;
            }
            var k = spectralStart, e = spectralEnd;
            while(k <= e){
                var rs = decodeHuffman(component.huffmanTableAC);
                var s = rs & 15, r = rs >> 4;
                if (s === 0) {
                    if (r < 15) {
                        eobrun = receive(r) + (1 << r) - 1;
                        break;
                    }
                    k += 16;
                    continue;
                }
                k += r;
                var z = dctZigZag[k];
                zz[z] = receiveAndExtend(s) * (1 << successive);
                k++;
            }
        }
        var successiveACState = 0, successiveACNextValue;
        function decodeACSuccessive(component, zz) {
            var k = spectralStart, e = spectralEnd, r = 0;
            while(k <= e){
                var z = dctZigZag[k];
                var direction = zz[z] < 0 ? -1 : 1;
                switch(successiveACState){
                    case 0:
                        var rs = decodeHuffman(component.huffmanTableAC);
                        var s = rs & 15, r = rs >> 4;
                        if (s === 0) {
                            if (r < 15) {
                                eobrun = receive(r) + (1 << r);
                                successiveACState = 4;
                            } else {
                                r = 16;
                                successiveACState = 1;
                            }
                        } else {
                            if (s !== 1) throw new Error("invalid ACn encoding");
                            successiveACNextValue = receiveAndExtend(s);
                            successiveACState = r ? 2 : 3;
                        }
                        continue;
                    case 1:
                    case 2:
                        if (zz[z]) zz[z] += (readBit() << successive) * direction;
                        else {
                            r--;
                            if (r === 0) successiveACState = successiveACState == 2 ? 3 : 0;
                        }
                        break;
                    case 3:
                        if (zz[z]) zz[z] += (readBit() << successive) * direction;
                        else {
                            zz[z] = successiveACNextValue << successive;
                            successiveACState = 0;
                        }
                        break;
                    case 4:
                        if (zz[z]) zz[z] += (readBit() << successive) * direction;
                        break;
                }
                k++;
            }
            if (successiveACState === 4) {
                eobrun--;
                if (eobrun === 0) successiveACState = 0;
            }
        }
        function decodeMcu(component, decode, mcu, row, col) {
            var mcuRow = mcu / mcusPerLine | 0;
            var mcuCol = mcu % mcusPerLine;
            var blockRow = mcuRow * component.v + row;
            var blockCol = mcuCol * component.h + col;
            // If the block is missing and we're in tolerant mode, just skip it.
            if (component.blocks[blockRow] === undefined && opts.tolerantDecoding) return;
            decode(component, component.blocks[blockRow][blockCol]);
        }
        function decodeBlock(component, decode, mcu) {
            var blockRow = mcu / component.blocksPerLine | 0;
            var blockCol = mcu % component.blocksPerLine;
            // If the block is missing and we're in tolerant mode, just skip it.
            if (component.blocks[blockRow] === undefined && opts.tolerantDecoding) return;
            decode(component, component.blocks[blockRow][blockCol]);
        }
        var componentsLength = components.length;
        var component, i, j, k, n;
        var decodeFn;
        if (progressive) {
            if (spectralStart === 0) decodeFn = successivePrev === 0 ? decodeDCFirst : decodeDCSuccessive;
            else decodeFn = successivePrev === 0 ? decodeACFirst : decodeACSuccessive;
        } else decodeFn = decodeBaseline;
        var mcu = 0, marker;
        var mcuExpected;
        if (componentsLength == 1) mcuExpected = components[0].blocksPerLine * components[0].blocksPerColumn;
        else mcuExpected = mcusPerLine * frame.mcusPerColumn;
        if (!resetInterval) resetInterval = mcuExpected;
        var h, v;
        while(mcu < mcuExpected){
            // reset interval stuff
            for(i = 0; i < componentsLength; i++)components[i].pred = 0;
            eobrun = 0;
            if (componentsLength == 1) {
                component = components[0];
                for(n = 0; n < resetInterval; n++){
                    decodeBlock(component, decodeFn, mcu);
                    mcu++;
                }
            } else for(n = 0; n < resetInterval; n++){
                for(i = 0; i < componentsLength; i++){
                    component = components[i];
                    h = component.h;
                    v = component.v;
                    for(j = 0; j < v; j++)for(k = 0; k < h; k++)decodeMcu(component, decodeFn, mcu, j, k);
                }
                mcu++;
                // If we've reached our expected MCU's, stop decoding
                if (mcu === mcuExpected) break;
            }
            if (mcu === mcuExpected) // Skip trailing bytes at the end of the scan - until we reach the next marker
            do {
                if (data[offset] === 0xFF) {
                    if (data[offset + 1] !== 0x00) break;
                }
                offset += 1;
            }while (offset < data.length - 2);
            // find marker
            bitsCount = 0;
            marker = data[offset] << 8 | data[offset + 1];
            if (marker < 0xFF00) throw new Error("marker was not found");
            if (marker >= 0xFFD0 && marker <= 0xFFD7) offset += 2;
            else break;
        }
        return offset - startOffset;
    }
    function buildComponentData(frame, component) {
        var lines = [];
        var blocksPerLine = component.blocksPerLine;
        var blocksPerColumn = component.blocksPerColumn;
        var samplesPerLine = blocksPerLine << 3;
        // Only 1 used per invocation of this function and garbage collected after invocation, so no need to account for its memory footprint.
        var R = new Int32Array(64), r = new Uint8Array(64);
        // A port of poppler's IDCT method which in turn is taken from:
        //   Christoph Loeffler, Adriaan Ligtenberg, George S. Moschytz,
        //   "Practical Fast 1-D DCT Algorithms with 11 Multiplications",
        //   IEEE Intl. Conf. on Acoustics, Speech & Signal Processing, 1989,
        //   988-991.
        function quantizeAndInverse(zz, dataOut, dataIn) {
            var qt = component.quantizationTable;
            var v0, v1, v2, v3, v4, v5, v6, v7, t;
            var p = dataIn;
            var i;
            // dequant
            for(i = 0; i < 64; i++)p[i] = zz[i] * qt[i];
            // inverse DCT on rows
            for(i = 0; i < 8; ++i){
                var row = 8 * i;
                // check for all-zero AC coefficients
                if (p[1 + row] == 0 && p[2 + row] == 0 && p[3 + row] == 0 && p[4 + row] == 0 && p[5 + row] == 0 && p[6 + row] == 0 && p[7 + row] == 0) {
                    t = dctSqrt2 * p[0 + row] + 512 >> 10;
                    p[0 + row] = t;
                    p[1 + row] = t;
                    p[2 + row] = t;
                    p[3 + row] = t;
                    p[4 + row] = t;
                    p[5 + row] = t;
                    p[6 + row] = t;
                    p[7 + row] = t;
                    continue;
                }
                // stage 4
                v0 = dctSqrt2 * p[0 + row] + 128 >> 8;
                v1 = dctSqrt2 * p[4 + row] + 128 >> 8;
                v2 = p[2 + row];
                v3 = p[6 + row];
                v4 = dctSqrt1d2 * (p[1 + row] - p[7 + row]) + 128 >> 8;
                v7 = dctSqrt1d2 * (p[1 + row] + p[7 + row]) + 128 >> 8;
                v5 = p[3 + row] << 4;
                v6 = p[5 + row] << 4;
                // stage 3
                t = v0 - v1 + 1 >> 1;
                v0 = v0 + v1 + 1 >> 1;
                v1 = t;
                t = v2 * dctSin6 + v3 * dctCos6 + 128 >> 8;
                v2 = v2 * dctCos6 - v3 * dctSin6 + 128 >> 8;
                v3 = t;
                t = v4 - v6 + 1 >> 1;
                v4 = v4 + v6 + 1 >> 1;
                v6 = t;
                t = v7 + v5 + 1 >> 1;
                v5 = v7 - v5 + 1 >> 1;
                v7 = t;
                // stage 2
                t = v0 - v3 + 1 >> 1;
                v0 = v0 + v3 + 1 >> 1;
                v3 = t;
                t = v1 - v2 + 1 >> 1;
                v1 = v1 + v2 + 1 >> 1;
                v2 = t;
                t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                v7 = t;
                t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                v6 = t;
                // stage 1
                p[0 + row] = v0 + v7;
                p[7 + row] = v0 - v7;
                p[1 + row] = v1 + v6;
                p[6 + row] = v1 - v6;
                p[2 + row] = v2 + v5;
                p[5 + row] = v2 - v5;
                p[3 + row] = v3 + v4;
                p[4 + row] = v3 - v4;
            }
            // inverse DCT on columns
            for(i = 0; i < 8; ++i){
                var col = i;
                // check for all-zero AC coefficients
                if (p[8 + col] == 0 && p[16 + col] == 0 && p[24 + col] == 0 && p[32 + col] == 0 && p[40 + col] == 0 && p[48 + col] == 0 && p[56 + col] == 0) {
                    t = dctSqrt2 * dataIn[i + 0] + 8192 >> 14;
                    p[0 + col] = t;
                    p[8 + col] = t;
                    p[16 + col] = t;
                    p[24 + col] = t;
                    p[32 + col] = t;
                    p[40 + col] = t;
                    p[48 + col] = t;
                    p[56 + col] = t;
                    continue;
                }
                // stage 4
                v0 = dctSqrt2 * p[0 + col] + 2048 >> 12;
                v1 = dctSqrt2 * p[32 + col] + 2048 >> 12;
                v2 = p[16 + col];
                v3 = p[48 + col];
                v4 = dctSqrt1d2 * (p[8 + col] - p[56 + col]) + 2048 >> 12;
                v7 = dctSqrt1d2 * (p[8 + col] + p[56 + col]) + 2048 >> 12;
                v5 = p[24 + col];
                v6 = p[40 + col];
                // stage 3
                t = v0 - v1 + 1 >> 1;
                v0 = v0 + v1 + 1 >> 1;
                v1 = t;
                t = v2 * dctSin6 + v3 * dctCos6 + 2048 >> 12;
                v2 = v2 * dctCos6 - v3 * dctSin6 + 2048 >> 12;
                v3 = t;
                t = v4 - v6 + 1 >> 1;
                v4 = v4 + v6 + 1 >> 1;
                v6 = t;
                t = v7 + v5 + 1 >> 1;
                v5 = v7 - v5 + 1 >> 1;
                v7 = t;
                // stage 2
                t = v0 - v3 + 1 >> 1;
                v0 = v0 + v3 + 1 >> 1;
                v3 = t;
                t = v1 - v2 + 1 >> 1;
                v1 = v1 + v2 + 1 >> 1;
                v2 = t;
                t = v4 * dctSin3 + v7 * dctCos3 + 2048 >> 12;
                v4 = v4 * dctCos3 - v7 * dctSin3 + 2048 >> 12;
                v7 = t;
                t = v5 * dctSin1 + v6 * dctCos1 + 2048 >> 12;
                v5 = v5 * dctCos1 - v6 * dctSin1 + 2048 >> 12;
                v6 = t;
                // stage 1
                p[0 + col] = v0 + v7;
                p[56 + col] = v0 - v7;
                p[8 + col] = v1 + v6;
                p[48 + col] = v1 - v6;
                p[16 + col] = v2 + v5;
                p[40 + col] = v2 - v5;
                p[24 + col] = v3 + v4;
                p[32 + col] = v3 - v4;
            }
            // convert to 8-bit integers
            for(i = 0; i < 64; ++i){
                var sample = 128 + (p[i] + 8 >> 4);
                dataOut[i] = sample < 0 ? 0 : sample > 0xFF ? 0xFF : sample;
            }
        }
        requestMemoryAllocation(samplesPerLine * blocksPerColumn * 8);
        var i, j;
        for(var blockRow = 0; blockRow < blocksPerColumn; blockRow++){
            var scanLine = blockRow << 3;
            for(i = 0; i < 8; i++)lines.push(new Uint8Array(samplesPerLine));
            for(var blockCol = 0; blockCol < blocksPerLine; blockCol++){
                quantizeAndInverse(component.blocks[blockRow][blockCol], r, R);
                var offset = 0, sample = blockCol << 3;
                for(j = 0; j < 8; j++){
                    var line = lines[scanLine + j];
                    for(i = 0; i < 8; i++)line[sample + i] = r[offset++];
                }
            }
        }
        return lines;
    }
    function clampTo8bit(a) {
        return a < 0 ? 0 : a > 255 ? 255 : a;
    }
    constructor.prototype = {
        load: function load(path) {
            var xhr = new XMLHttpRequest();
            xhr.open("GET", path, true);
            xhr.responseType = "arraybuffer";
            xhr.onload = (function() {
                // TODO catch parse error
                var data = new Uint8Array(xhr.response || xhr.mozResponseArrayBuffer);
                this.parse(data);
                if (this.onload) this.onload();
            }).bind(this);
            xhr.send(null);
        },
        parse: function parse(data) {
            var maxResolutionInPixels = this.opts.maxResolutionInMP * 1000000;
            var offset = 0, length = data.length;
            function readUint16() {
                var value = data[offset] << 8 | data[offset + 1];
                offset += 2;
                return value;
            }
            function readDataBlock() {
                var length = readUint16();
                var array = data.subarray(offset, offset + length - 2);
                offset += array.length;
                return array;
            }
            function prepareComponents(frame) {
                // According to the JPEG standard, the sampling factor must be between 1 and 4
                // See https://github.com/libjpeg-turbo/libjpeg-turbo/blob/9abeff46d87bd201a952e276f3e4339556a403a3/libjpeg.txt#L1138-L1146
                var maxH = 1, maxV = 1;
                var component, componentId;
                for(componentId in frame.components)if (frame.components.hasOwnProperty(componentId)) {
                    component = frame.components[componentId];
                    if (maxH < component.h) maxH = component.h;
                    if (maxV < component.v) maxV = component.v;
                }
                var mcusPerLine = Math.ceil(frame.samplesPerLine / 8 / maxH);
                var mcusPerColumn = Math.ceil(frame.scanLines / 8 / maxV);
                for(componentId in frame.components)if (frame.components.hasOwnProperty(componentId)) {
                    component = frame.components[componentId];
                    var blocksPerLine = Math.ceil(Math.ceil(frame.samplesPerLine / 8) * component.h / maxH);
                    var blocksPerColumn = Math.ceil(Math.ceil(frame.scanLines / 8) * component.v / maxV);
                    var blocksPerLineForMcu = mcusPerLine * component.h;
                    var blocksPerColumnForMcu = mcusPerColumn * component.v;
                    var blocksToAllocate = blocksPerColumnForMcu * blocksPerLineForMcu;
                    var blocks = [];
                    // Each block is a Int32Array of length 64 (4 x 64 = 256 bytes)
                    requestMemoryAllocation(blocksToAllocate * 256);
                    for(var i = 0; i < blocksPerColumnForMcu; i++){
                        var row = [];
                        for(var j = 0; j < blocksPerLineForMcu; j++)row.push(new Int32Array(64));
                        blocks.push(row);
                    }
                    component.blocksPerLine = blocksPerLine;
                    component.blocksPerColumn = blocksPerColumn;
                    component.blocks = blocks;
                }
                frame.maxH = maxH;
                frame.maxV = maxV;
                frame.mcusPerLine = mcusPerLine;
                frame.mcusPerColumn = mcusPerColumn;
            }
            var jfif = null;
            var adobe = null;
            var pixels = null;
            var frame, resetInterval;
            var quantizationTables = [], frames = [];
            var huffmanTablesAC = [], huffmanTablesDC = [];
            var fileMarker = readUint16();
            var malformedDataOffset = -1;
            this.comments = [];
            if (fileMarker != 0xFFD8) throw new Error("SOI not found");
            fileMarker = readUint16();
            while(fileMarker != 0xFFD9){
                var i, j, l;
                switch(fileMarker){
                    case 0xFF00:
                        break;
                    case 0xFFE0:
                    case 0xFFE1:
                    case 0xFFE2:
                    case 0xFFE3:
                    case 0xFFE4:
                    case 0xFFE5:
                    case 0xFFE6:
                    case 0xFFE7:
                    case 0xFFE8:
                    case 0xFFE9:
                    case 0xFFEA:
                    case 0xFFEB:
                    case 0xFFEC:
                    case 0xFFED:
                    case 0xFFEE:
                    case 0xFFEF:
                    case 0xFFFE:
                        var appData = readDataBlock();
                        if (fileMarker === 0xFFFE) {
                            var comment = String.fromCharCode.apply(null, appData);
                            this.comments.push(comment);
                        }
                        if (fileMarker === 0xFFE0) {
                            if (appData[0] === 0x4A && appData[1] === 0x46 && appData[2] === 0x49 && appData[3] === 0x46 && appData[4] === 0) jfif = {
                                version: {
                                    major: appData[5],
                                    minor: appData[6]
                                },
                                densityUnits: appData[7],
                                xDensity: appData[8] << 8 | appData[9],
                                yDensity: appData[10] << 8 | appData[11],
                                thumbWidth: appData[12],
                                thumbHeight: appData[13],
                                thumbData: appData.subarray(14, 14 + 3 * appData[12] * appData[13])
                            };
                        }
                        // TODO APP1 - Exif
                        if (fileMarker === 0xFFE1) {
                            if (appData[0] === 0x45 && appData[1] === 0x78 && appData[2] === 0x69 && appData[3] === 0x66 && appData[4] === 0) this.exifBuffer = appData.subarray(5, appData.length);
                        }
                        if (fileMarker === 0xFFEE) {
                            if (appData[0] === 0x41 && appData[1] === 0x64 && appData[2] === 0x6F && appData[3] === 0x62 && appData[4] === 0x65 && appData[5] === 0) adobe = {
                                version: appData[6],
                                flags0: appData[7] << 8 | appData[8],
                                flags1: appData[9] << 8 | appData[10],
                                transformCode: appData[11]
                            };
                        }
                        break;
                    case 0xFFDB:
                        var quantizationTablesLength = readUint16();
                        var quantizationTablesEnd = quantizationTablesLength + offset - 2;
                        while(offset < quantizationTablesEnd){
                            var quantizationTableSpec = data[offset++];
                            requestMemoryAllocation(256);
                            var tableData = new Int32Array(64);
                            if (quantizationTableSpec >> 4 === 0) for(j = 0; j < 64; j++){
                                var z = dctZigZag[j];
                                tableData[z] = data[offset++];
                            }
                            else if (quantizationTableSpec >> 4 === 1) for(j = 0; j < 64; j++){
                                var z = dctZigZag[j];
                                tableData[z] = readUint16();
                            }
                            else throw new Error("DQT: invalid table spec");
                            quantizationTables[quantizationTableSpec & 15] = tableData;
                        }
                        break;
                    case 0xFFC0:
                    case 0xFFC1:
                    case 0xFFC2:
                        readUint16(); // skip data length
                        frame = {};
                        frame.extended = fileMarker === 0xFFC1;
                        frame.progressive = fileMarker === 0xFFC2;
                        frame.precision = data[offset++];
                        frame.scanLines = readUint16();
                        frame.samplesPerLine = readUint16();
                        frame.components = {};
                        frame.componentsOrder = [];
                        var pixelsInFrame = frame.scanLines * frame.samplesPerLine;
                        if (pixelsInFrame > maxResolutionInPixels) {
                            var exceededAmount = Math.ceil((pixelsInFrame - maxResolutionInPixels) / 1e6);
                            throw new Error(`maxResolutionInMP limit exceeded by ${exceededAmount}MP`);
                        }
                        var componentsCount = data[offset++], componentId;
                        var maxH = 0, maxV = 0;
                        for(i = 0; i < componentsCount; i++){
                            componentId = data[offset];
                            var h = data[offset + 1] >> 4;
                            var v = data[offset + 1] & 15;
                            var qId = data[offset + 2];
                            if (h <= 0 || v <= 0) throw new Error('Invalid sampling factor, expected values above 0');
                            frame.componentsOrder.push(componentId);
                            frame.components[componentId] = {
                                h: h,
                                v: v,
                                quantizationIdx: qId
                            };
                            offset += 3;
                        }
                        prepareComponents(frame);
                        frames.push(frame);
                        break;
                    case 0xFFC4:
                        var huffmanLength = readUint16();
                        for(i = 2; i < huffmanLength;){
                            var huffmanTableSpec = data[offset++];
                            var codeLengths = new Uint8Array(16);
                            var codeLengthSum = 0;
                            for(j = 0; j < 16; j++, offset++)codeLengthSum += codeLengths[j] = data[offset];
                            requestMemoryAllocation(16 + codeLengthSum);
                            var huffmanValues = new Uint8Array(codeLengthSum);
                            for(j = 0; j < codeLengthSum; j++, offset++)huffmanValues[j] = data[offset];
                            i += 17 + codeLengthSum;
                            (huffmanTableSpec >> 4 === 0 ? huffmanTablesDC : huffmanTablesAC)[huffmanTableSpec & 15] = buildHuffmanTable(codeLengths, huffmanValues);
                        }
                        break;
                    case 0xFFDD:
                        readUint16(); // skip data length
                        resetInterval = readUint16();
                        break;
                    case 0xFFDC:
                        readUint16() // skip data length
                        ;
                        readUint16() // Ignore this data since it represents the image height
                        ;
                        break;
                    case 0xFFDA:
                        var scanLength = readUint16();
                        var selectorsCount = data[offset++];
                        var components = [], component;
                        for(i = 0; i < selectorsCount; i++){
                            component = frame.components[data[offset++]];
                            var tableSpec = data[offset++];
                            component.huffmanTableDC = huffmanTablesDC[tableSpec >> 4];
                            component.huffmanTableAC = huffmanTablesAC[tableSpec & 15];
                            components.push(component);
                        }
                        var spectralStart = data[offset++];
                        var spectralEnd = data[offset++];
                        var successiveApproximation = data[offset++];
                        var processed = decodeScan(data, offset, frame, components, resetInterval, spectralStart, spectralEnd, successiveApproximation >> 4, successiveApproximation & 15, this.opts);
                        offset += processed;
                        break;
                    case 0xFFFF:
                        if (data[offset] !== 0xFF) offset--;
                        break;
                    default:
                        if (data[offset - 3] == 0xFF && data[offset - 2] >= 0xC0 && data[offset - 2] <= 0xFE) {
                            // could be incorrect encoding -- last 0xFF byte of the previous
                            // block was eaten by the encoder
                            offset -= 3;
                            break;
                        } else if (fileMarker === 0xE0 || fileMarker == 0xE1) {
                            // Recover from malformed APP1 markers popular in some phone models.
                            // See https://github.com/eugeneware/jpeg-js/issues/82
                            if (malformedDataOffset !== -1) throw new Error(`first unknown JPEG marker at offset ${malformedDataOffset.toString(16)}, second unknown JPEG marker ${fileMarker.toString(16)} at offset ${(offset - 1).toString(16)}`);
                            malformedDataOffset = offset - 1;
                            const nextOffset = readUint16();
                            if (data[offset + nextOffset - 2] === 0xFF) {
                                offset += nextOffset - 2;
                                break;
                            }
                        }
                        throw new Error("unknown JPEG marker " + fileMarker.toString(16));
                }
                fileMarker = readUint16();
            }
            if (frames.length != 1) throw new Error("only single frame JPEGs supported");
            // set each frame's components quantization table
            for(var i = 0; i < frames.length; i++){
                var cp = frames[i].components;
                for(var j in cp){
                    cp[j].quantizationTable = quantizationTables[cp[j].quantizationIdx];
                    delete cp[j].quantizationIdx;
                }
            }
            this.width = frame.samplesPerLine;
            this.height = frame.scanLines;
            this.jfif = jfif;
            this.adobe = adobe;
            this.components = [];
            for(var i = 0; i < frame.componentsOrder.length; i++){
                var component = frame.components[frame.componentsOrder[i]];
                this.components.push({
                    lines: buildComponentData(frame, component),
                    scaleX: component.h / frame.maxH,
                    scaleY: component.v / frame.maxV
                });
            }
        },
        getData: function getData(width, height) {
            var scaleX = this.width / width, scaleY = this.height / height;
            var component1, component2, component3, component4;
            var component1Line, component2Line, component3Line, component4Line;
            var x, y;
            var offset = 0;
            var Y, Cb, Cr, K, C, M, Ye, R, G, B;
            var colorTransform;
            var dataLength = width * height * this.components.length;
            requestMemoryAllocation(dataLength);
            var data = new Uint8Array(dataLength);
            switch(this.components.length){
                case 1:
                    component1 = this.components[0];
                    for(y = 0; y < height; y++){
                        component1Line = component1.lines[0 | y * component1.scaleY * scaleY];
                        for(x = 0; x < width; x++){
                            Y = component1Line[0 | x * component1.scaleX * scaleX];
                            data[offset++] = Y;
                        }
                    }
                    break;
                case 2:
                    // PDF might compress two component data in custom colorspace
                    component1 = this.components[0];
                    component2 = this.components[1];
                    for(y = 0; y < height; y++){
                        component1Line = component1.lines[0 | y * component1.scaleY * scaleY];
                        component2Line = component2.lines[0 | y * component2.scaleY * scaleY];
                        for(x = 0; x < width; x++){
                            Y = component1Line[0 | x * component1.scaleX * scaleX];
                            data[offset++] = Y;
                            Y = component2Line[0 | x * component2.scaleX * scaleX];
                            data[offset++] = Y;
                        }
                    }
                    break;
                case 3:
                    // The default transform for three components is true
                    colorTransform = true;
                    // The adobe transform marker overrides any previous setting
                    if (this.adobe && this.adobe.transformCode) colorTransform = true;
                    else if (typeof this.opts.colorTransform !== 'undefined') colorTransform = !!this.opts.colorTransform;
                    component1 = this.components[0];
                    component2 = this.components[1];
                    component3 = this.components[2];
                    for(y = 0; y < height; y++){
                        component1Line = component1.lines[0 | y * component1.scaleY * scaleY];
                        component2Line = component2.lines[0 | y * component2.scaleY * scaleY];
                        component3Line = component3.lines[0 | y * component3.scaleY * scaleY];
                        for(x = 0; x < width; x++){
                            if (!colorTransform) {
                                R = component1Line[0 | x * component1.scaleX * scaleX];
                                G = component2Line[0 | x * component2.scaleX * scaleX];
                                B = component3Line[0 | x * component3.scaleX * scaleX];
                            } else {
                                Y = component1Line[0 | x * component1.scaleX * scaleX];
                                Cb = component2Line[0 | x * component2.scaleX * scaleX];
                                Cr = component3Line[0 | x * component3.scaleX * scaleX];
                                R = clampTo8bit(Y + 1.402 * (Cr - 128));
                                G = clampTo8bit(Y - 0.3441363 * (Cb - 128) - 0.71413636 * (Cr - 128));
                                B = clampTo8bit(Y + 1.772 * (Cb - 128));
                            }
                            data[offset++] = R;
                            data[offset++] = G;
                            data[offset++] = B;
                        }
                    }
                    break;
                case 4:
                    if (!this.adobe) throw new Error('Unsupported color mode (4 components)');
                    // The default transform for four components is false
                    colorTransform = false;
                    // The adobe transform marker overrides any previous setting
                    if (this.adobe && this.adobe.transformCode) colorTransform = true;
                    else if (typeof this.opts.colorTransform !== 'undefined') colorTransform = !!this.opts.colorTransform;
                    component1 = this.components[0];
                    component2 = this.components[1];
                    component3 = this.components[2];
                    component4 = this.components[3];
                    for(y = 0; y < height; y++){
                        component1Line = component1.lines[0 | y * component1.scaleY * scaleY];
                        component2Line = component2.lines[0 | y * component2.scaleY * scaleY];
                        component3Line = component3.lines[0 | y * component3.scaleY * scaleY];
                        component4Line = component4.lines[0 | y * component4.scaleY * scaleY];
                        for(x = 0; x < width; x++){
                            if (!colorTransform) {
                                C = component1Line[0 | x * component1.scaleX * scaleX];
                                M = component2Line[0 | x * component2.scaleX * scaleX];
                                Ye = component3Line[0 | x * component3.scaleX * scaleX];
                                K = component4Line[0 | x * component4.scaleX * scaleX];
                            } else {
                                Y = component1Line[0 | x * component1.scaleX * scaleX];
                                Cb = component2Line[0 | x * component2.scaleX * scaleX];
                                Cr = component3Line[0 | x * component3.scaleX * scaleX];
                                K = component4Line[0 | x * component4.scaleX * scaleX];
                                C = 255 - clampTo8bit(Y + 1.402 * (Cr - 128));
                                M = 255 - clampTo8bit(Y - 0.3441363 * (Cb - 128) - 0.71413636 * (Cr - 128));
                                Ye = 255 - clampTo8bit(Y + 1.772 * (Cb - 128));
                            }
                            data[offset++] = 255 - C;
                            data[offset++] = 255 - M;
                            data[offset++] = 255 - Ye;
                            data[offset++] = 255 - K;
                        }
                    }
                    break;
                default:
                    throw new Error('Unsupported color mode');
            }
            return data;
        },
        copyToImageData: function copyToImageData(imageData, formatAsRGBA) {
            var width = imageData.width, height = imageData.height;
            var imageDataArray = imageData.data;
            var data = this.getData(width, height);
            var i = 0, j = 0, x, y;
            var Y, K, C, M, R, G, B;
            switch(this.components.length){
                case 1:
                    for(y = 0; y < height; y++)for(x = 0; x < width; x++){
                        Y = data[i++];
                        imageDataArray[j++] = Y;
                        imageDataArray[j++] = Y;
                        imageDataArray[j++] = Y;
                        if (formatAsRGBA) imageDataArray[j++] = 255;
                    }
                    break;
                case 3:
                    for(y = 0; y < height; y++)for(x = 0; x < width; x++){
                        R = data[i++];
                        G = data[i++];
                        B = data[i++];
                        imageDataArray[j++] = R;
                        imageDataArray[j++] = G;
                        imageDataArray[j++] = B;
                        if (formatAsRGBA) imageDataArray[j++] = 255;
                    }
                    break;
                case 4:
                    for(y = 0; y < height; y++)for(x = 0; x < width; x++){
                        C = data[i++];
                        M = data[i++];
                        Y = data[i++];
                        K = data[i++];
                        R = 255 - clampTo8bit(C * (1 - K / 255) + K);
                        G = 255 - clampTo8bit(M * (1 - K / 255) + K);
                        B = 255 - clampTo8bit(Y * (1 - K / 255) + K);
                        imageDataArray[j++] = R;
                        imageDataArray[j++] = G;
                        imageDataArray[j++] = B;
                        if (formatAsRGBA) imageDataArray[j++] = 255;
                    }
                    break;
                default:
                    throw new Error('Unsupported color mode');
            }
        }
    };
    // We cap the amount of memory used by jpeg-js to avoid unexpected OOMs from untrusted content.
    var totalBytesAllocated = 0;
    var maxMemoryUsageBytes = 0;
    function requestMemoryAllocation(increaseAmount = 0) {
        var totalMemoryImpactBytes = totalBytesAllocated + increaseAmount;
        if (totalMemoryImpactBytes > maxMemoryUsageBytes) {
            var exceededAmount = Math.ceil((totalMemoryImpactBytes - maxMemoryUsageBytes) / 1024 / 1024);
            throw new Error(`maxMemoryUsageInMB limit exceeded by at least ${exceededAmount}MB`);
        }
        totalBytesAllocated = totalMemoryImpactBytes;
    }
    constructor.resetMaxMemoryUsage = function(maxMemoryUsageBytes_) {
        totalBytesAllocated = 0;
        maxMemoryUsageBytes = maxMemoryUsageBytes_;
    };
    constructor.getBytesAllocated = function() {
        return totalBytesAllocated;
    };
    constructor.requestMemoryAllocation = requestMemoryAllocation;
    return constructor;
}();
$46aef114a95be856$exports = $46aef114a95be856$var$decode;
function $46aef114a95be856$var$decode(jpegData, userOpts = {}) {
    var defaultOpts = {
        // "undefined" means "Choose whether to transform colors based on the image’s color model."
        colorTransform: undefined,
        useTArray: false,
        formatAsRGBA: true,
        tolerantDecoding: true,
        maxResolutionInMP: 100,
        maxMemoryUsageInMB: 512
    };
    var opts = (0, $cTSGB._)({}, defaultOpts, userOpts);
    var arr = new Uint8Array(jpegData);
    var decoder = new $46aef114a95be856$var$JpegImage();
    decoder.opts = opts;
    // If this constructor ever supports async decoding this will need to be done differently.
    // Until then, treating as singleton limit is fine.
    $46aef114a95be856$var$JpegImage.resetMaxMemoryUsage(opts.maxMemoryUsageInMB * 1048576);
    decoder.parse(arr);
    var channels = opts.formatAsRGBA ? 4 : 3;
    var bytesNeeded = decoder.width * decoder.height * channels;
    try {
        $46aef114a95be856$var$JpegImage.requestMemoryAllocation(bytesNeeded);
        var image = {
            width: decoder.width,
            height: decoder.height,
            exifBuffer: decoder.exifBuffer,
            data: opts.useTArray ? new Uint8Array(bytesNeeded) : $46aef114a95be856$require$Buffer.alloc(bytesNeeded)
        };
        if (decoder.comments.length > 0) image["comments"] = decoder.comments;
    } catch (err) {
        if (err instanceof RangeError) throw new Error("Could not allocate enough memory for the image. Required: " + bytesNeeded);
        if (err instanceof ReferenceError) {
            if (err.message === "Buffer is not defined") throw new Error("Buffer is not globally defined in this environment. Consider setting useTArray to true");
        }
        throw err;
    }
    decoder.copyToImageData(image, opts.formatAsRGBA);
    return image;
}


$c0b535f73fd0ccc6$exports = {
    encode: $53b4d4551365c212$exports,
    decode: $46aef114a95be856$exports
};


var $4acb61a97e3722f6$export$1f536085c24cc947;

var $kJBqN = parcelRequire("kJBqN");
var $4acb61a97e3722f6$require$Buffer = $kJBqN.Buffer;

var $5XqL3 = parcelRequire("5XqL3");
'use strict';

var $hHIjR = parcelRequire("hHIjR");

var $2C97X = parcelRequire("2C97X");
var $a944d1fd254584c5$exports = {};
'use strict';

var $hHIjR = parcelRequire("hHIjR");

var $dy7q9 = parcelRequire("dy7q9");
var $a15ee1fb6e2366de$exports = {};

var $5XqL3 = parcelRequire("5XqL3");

var $kJBqN = parcelRequire("kJBqN");
var $a15ee1fb6e2366de$require$Buffer = $kJBqN.Buffer;
'use strict';

var $hHIjR = parcelRequire("hHIjR");

var $2C97X = parcelRequire("2C97X");
var $a15ee1fb6e2366de$var$ChunkStream = $a15ee1fb6e2366de$exports = function() {
    $2C97X.call(this);
    this._buffers = [];
    this._buffered = 0;
    this._reads = [];
    this._paused = false;
    this._encoding = 'utf8';
    this.writable = true;
};
$hHIjR.inherits($a15ee1fb6e2366de$var$ChunkStream, $2C97X);
$a15ee1fb6e2366de$var$ChunkStream.prototype.read = function(length, callback) {
    this._reads.push({
        length: Math.abs(length),
        allowLess: length < 0,
        func: callback
    });
    $5XqL3.nextTick((function() {
        this._process();
        // its paused and there is not enought data then ask for more
        if (this._paused && this._reads.length > 0) {
            this._paused = false;
            this.emit('drain');
        }
    }).bind(this));
};
$a15ee1fb6e2366de$var$ChunkStream.prototype.write = function(data, encoding) {
    if (!this.writable) {
        this.emit('error', new Error('Stream not writable'));
        return false;
    }
    var dataBuffer;
    if ($a15ee1fb6e2366de$require$Buffer.isBuffer(data)) dataBuffer = data;
    else dataBuffer = new $a15ee1fb6e2366de$require$Buffer(data, encoding || this._encoding);
    this._buffers.push(dataBuffer);
    this._buffered += dataBuffer.length;
    this._process();
    // ok if there are no more read requests
    if (this._reads && this._reads.length === 0) this._paused = true;
    return this.writable && !this._paused;
};
$a15ee1fb6e2366de$var$ChunkStream.prototype.end = function(data, encoding) {
    if (data) this.write(data, encoding);
    this.writable = false;
    // already destroyed
    if (!this._buffers) return;
    // enqueue or handle end
    if (this._buffers.length === 0) this._end();
    else {
        this._buffers.push(null);
        this._process();
    }
};
$a15ee1fb6e2366de$var$ChunkStream.prototype.destroySoon = $a15ee1fb6e2366de$var$ChunkStream.prototype.end;
$a15ee1fb6e2366de$var$ChunkStream.prototype._end = function() {
    if (this._reads.length > 0) this.emit('error', new Error('Unexpected end of input'));
    this.destroy();
};
$a15ee1fb6e2366de$var$ChunkStream.prototype.destroy = function() {
    if (!this._buffers) return;
    this.writable = false;
    this._reads = null;
    this._buffers = null;
    this.emit('close');
};
$a15ee1fb6e2366de$var$ChunkStream.prototype._processReadAllowingLess = function(read) {
    // ok there is any data so that we can satisfy this request
    this._reads.shift(); // == read
    // first we need to peek into first buffer
    var smallerBuf = this._buffers[0];
    // ok there is more data than we need
    if (smallerBuf.length > read.length) {
        this._buffered -= read.length;
        this._buffers[0] = smallerBuf.slice(read.length);
        read.func.call(this, smallerBuf.slice(0, read.length));
    } else {
        // ok this is less than maximum length so use it all
        this._buffered -= smallerBuf.length;
        this._buffers.shift(); // == smallerBuf
        read.func.call(this, smallerBuf);
    }
};
$a15ee1fb6e2366de$var$ChunkStream.prototype._processRead = function(read) {
    this._reads.shift(); // == read
    var pos = 0;
    var count = 0;
    var data = new $a15ee1fb6e2366de$require$Buffer(read.length);
    // create buffer for all data
    while(pos < read.length){
        var buf = this._buffers[count++];
        var len = Math.min(buf.length, read.length - pos);
        buf.copy(data, pos, 0, len);
        pos += len;
        // last buffer wasn't used all so just slice it and leave
        if (len !== buf.length) this._buffers[--count] = buf.slice(len);
    }
    // remove all used buffers
    if (count > 0) this._buffers.splice(0, count);
    this._buffered -= read.length;
    read.func.call(this, data);
};
$a15ee1fb6e2366de$var$ChunkStream.prototype._process = function() {
    try {
        // as long as there is any data and read requests
        while(this._buffered > 0 && this._reads && this._reads.length > 0){
            var read = this._reads[0];
            // read any data (but no more than length)
            if (read.allowLess) this._processReadAllowingLess(read);
            else if (this._buffered >= read.length) // ok we can meet some expectations
            this._processRead(read);
            else break;
        }
        if (this._buffers && !this.writable) this._end();
    } catch (ex) {
        this.emit('error', ex);
    }
};


var $f970b98bd60b22f6$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $f970b98bd60b22f6$require$Buffer = $kJBqN.Buffer;
'use strict';

var $hHIjR = parcelRequire("hHIjR");

var $ef76d489b13e3d4c$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $ef76d489b13e3d4c$require$Buffer = $kJBqN.Buffer;
'use strict';
var $73d134d8ad2436b6$export$a07d0d6171f4e862;
var $73d134d8ad2436b6$export$45f10fc460b6d16b;
'use strict';
// Adam 7
//   0 1 2 3 4 5 6 7
// 0 x 6 4 6 x 6 4 6
// 1 7 7 7 7 7 7 7 7
// 2 5 6 5 6 5 6 5 6
// 3 7 7 7 7 7 7 7 7
// 4 3 6 4 6 3 6 4 6
// 5 7 7 7 7 7 7 7 7
// 6 5 6 5 6 5 6 5 6
// 7 7 7 7 7 7 7 7 7
var $73d134d8ad2436b6$var$imagePasses = [
    {
        x: [
            0
        ],
        y: [
            0
        ]
    },
    {
        x: [
            4
        ],
        y: [
            0
        ]
    },
    {
        x: [
            0,
            4
        ],
        y: [
            4
        ]
    },
    {
        x: [
            2,
            6
        ],
        y: [
            0,
            4
        ]
    },
    {
        x: [
            0,
            2,
            4,
            6
        ],
        y: [
            2,
            6
        ]
    },
    {
        x: [
            1,
            3,
            5,
            7
        ],
        y: [
            0,
            2,
            4,
            6
        ]
    },
    {
        x: [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7
        ],
        y: [
            1,
            3,
            5,
            7
        ]
    }
];
$73d134d8ad2436b6$export$a07d0d6171f4e862 = function(width, height) {
    var images = [];
    var xLeftOver = width % 8;
    var yLeftOver = height % 8;
    var xRepeats = (width - xLeftOver) / 8;
    var yRepeats = (height - yLeftOver) / 8;
    for(var i = 0; i < $73d134d8ad2436b6$var$imagePasses.length; i++){
        var pass = $73d134d8ad2436b6$var$imagePasses[i];
        var passWidth = xRepeats * pass.x.length;
        var passHeight = yRepeats * pass.y.length;
        for(var j = 0; j < pass.x.length; j++){
            if (pass.x[j] < xLeftOver) passWidth++;
            else break;
        }
        for(j = 0; j < pass.y.length; j++){
            if (pass.y[j] < yLeftOver) passHeight++;
            else break;
        }
        if (passWidth > 0 && passHeight > 0) images.push({
            width: passWidth,
            height: passHeight,
            index: i
        });
    }
    return images;
};
$73d134d8ad2436b6$export$45f10fc460b6d16b = function(width) {
    return function(x, y, pass) {
        var outerXLeftOver = x % $73d134d8ad2436b6$var$imagePasses[pass].x.length;
        var outerX = (x - outerXLeftOver) / $73d134d8ad2436b6$var$imagePasses[pass].x.length * 8 + $73d134d8ad2436b6$var$imagePasses[pass].x[outerXLeftOver];
        var outerYLeftOver = y % $73d134d8ad2436b6$var$imagePasses[pass].y.length;
        var outerY = (y - outerYLeftOver) / $73d134d8ad2436b6$var$imagePasses[pass].y.length * 8 + $73d134d8ad2436b6$var$imagePasses[pass].y[outerYLeftOver];
        return outerX * 4 + outerY * width * 4;
    };
};


var $55cf86e7d5152e90$exports = {};
'use strict';
$55cf86e7d5152e90$exports = function paethPredictor(left, above, upLeft) {
    var paeth = left + above - upLeft;
    var pLeft = Math.abs(paeth - left);
    var pAbove = Math.abs(paeth - above);
    var pUpLeft = Math.abs(paeth - upLeft);
    if (pLeft <= pAbove && pLeft <= pUpLeft) return left;
    if (pAbove <= pUpLeft) return above;
    return upLeft;
};


function $ef76d489b13e3d4c$var$getByteWidth(width, bpp, depth) {
    var byteWidth = width * bpp;
    if (depth !== 8) byteWidth = Math.ceil(byteWidth / (8 / depth));
    return byteWidth;
}
var $ef76d489b13e3d4c$var$Filter = $ef76d489b13e3d4c$exports = function(bitmapInfo, dependencies) {
    var width = bitmapInfo.width;
    var height = bitmapInfo.height;
    var interlace = bitmapInfo.interlace;
    var bpp = bitmapInfo.bpp;
    var depth = bitmapInfo.depth;
    this.read = dependencies.read;
    this.write = dependencies.write;
    this.complete = dependencies.complete;
    this._imageIndex = 0;
    this._images = [];
    if (interlace) {
        var passes = $73d134d8ad2436b6$export$a07d0d6171f4e862(width, height);
        for(var i = 0; i < passes.length; i++)this._images.push({
            byteWidth: $ef76d489b13e3d4c$var$getByteWidth(passes[i].width, bpp, depth),
            height: passes[i].height,
            lineIndex: 0
        });
    } else this._images.push({
        byteWidth: $ef76d489b13e3d4c$var$getByteWidth(width, bpp, depth),
        height: height,
        lineIndex: 0
    });
    // when filtering the line we look at the pixel to the left
    // the spec also says it is done on a byte level regardless of the number of pixels
    // so if the depth is byte compatible (8 or 16) we subtract the bpp in order to compare back
    // a pixel rather than just a different byte part. However if we are sub byte, we ignore.
    if (depth === 8) this._xComparison = bpp;
    else if (depth === 16) this._xComparison = bpp * 2;
    else this._xComparison = 1;
};
$ef76d489b13e3d4c$var$Filter.prototype.start = function() {
    this.read(this._images[this._imageIndex].byteWidth + 1, this._reverseFilterLine.bind(this));
};
$ef76d489b13e3d4c$var$Filter.prototype._unFilterType1 = function(rawData, unfilteredLine, byteWidth) {
    var xComparison = this._xComparison;
    var xBiggerThan = xComparison - 1;
    for(var x = 0; x < byteWidth; x++){
        var rawByte = rawData[1 + x];
        var f1Left = x > xBiggerThan ? unfilteredLine[x - xComparison] : 0;
        unfilteredLine[x] = rawByte + f1Left;
    }
};
$ef76d489b13e3d4c$var$Filter.prototype._unFilterType2 = function(rawData, unfilteredLine, byteWidth) {
    var lastLine = this._lastLine;
    for(var x = 0; x < byteWidth; x++){
        var rawByte = rawData[1 + x];
        var f2Up = lastLine ? lastLine[x] : 0;
        unfilteredLine[x] = rawByte + f2Up;
    }
};
$ef76d489b13e3d4c$var$Filter.prototype._unFilterType3 = function(rawData, unfilteredLine, byteWidth) {
    var xComparison = this._xComparison;
    var xBiggerThan = xComparison - 1;
    var lastLine = this._lastLine;
    for(var x = 0; x < byteWidth; x++){
        var rawByte = rawData[1 + x];
        var f3Up = lastLine ? lastLine[x] : 0;
        var f3Left = x > xBiggerThan ? unfilteredLine[x - xComparison] : 0;
        var f3Add = Math.floor((f3Left + f3Up) / 2);
        unfilteredLine[x] = rawByte + f3Add;
    }
};
$ef76d489b13e3d4c$var$Filter.prototype._unFilterType4 = function(rawData, unfilteredLine, byteWidth) {
    var xComparison = this._xComparison;
    var xBiggerThan = xComparison - 1;
    var lastLine = this._lastLine;
    for(var x = 0; x < byteWidth; x++){
        var rawByte = rawData[1 + x];
        var f4Up = lastLine ? lastLine[x] : 0;
        var f4Left = x > xBiggerThan ? unfilteredLine[x - xComparison] : 0;
        var f4UpLeft = x > xBiggerThan && lastLine ? lastLine[x - xComparison] : 0;
        var f4Add = $55cf86e7d5152e90$exports(f4Left, f4Up, f4UpLeft);
        unfilteredLine[x] = rawByte + f4Add;
    }
};
$ef76d489b13e3d4c$var$Filter.prototype._reverseFilterLine = function(rawData) {
    var filter = rawData[0];
    var unfilteredLine;
    var currentImage = this._images[this._imageIndex];
    var byteWidth = currentImage.byteWidth;
    if (filter === 0) unfilteredLine = rawData.slice(1, byteWidth + 1);
    else {
        unfilteredLine = new $ef76d489b13e3d4c$require$Buffer(byteWidth);
        switch(filter){
            case 1:
                this._unFilterType1(rawData, unfilteredLine, byteWidth);
                break;
            case 2:
                this._unFilterType2(rawData, unfilteredLine, byteWidth);
                break;
            case 3:
                this._unFilterType3(rawData, unfilteredLine, byteWidth);
                break;
            case 4:
                this._unFilterType4(rawData, unfilteredLine, byteWidth);
                break;
            default:
                throw new Error('Unrecognised filter type - ' + filter);
        }
    }
    this.write(unfilteredLine);
    currentImage.lineIndex++;
    if (currentImage.lineIndex >= currentImage.height) {
        this._lastLine = null;
        this._imageIndex++;
        currentImage = this._images[this._imageIndex];
    } else this._lastLine = unfilteredLine;
    if (currentImage) // read, using the byte width that may be from the new current image
    this.read(currentImage.byteWidth + 1, this._reverseFilterLine.bind(this));
    else {
        this._lastLine = null;
        this.complete();
    }
};


var $f970b98bd60b22f6$var$FilterAsync = $f970b98bd60b22f6$exports = function(bitmapInfo) {
    $a15ee1fb6e2366de$exports.call(this);
    var buffers = [];
    var that = this;
    this._filter = new $ef76d489b13e3d4c$exports(bitmapInfo, {
        read: this.read.bind(this),
        write: function(buffer) {
            buffers.push(buffer);
        },
        complete: function() {
            that.emit('complete', $f970b98bd60b22f6$require$Buffer.concat(buffers));
        }
    });
    this._filter.start();
};
$hHIjR.inherits($f970b98bd60b22f6$var$FilterAsync, $a15ee1fb6e2366de$exports);


var $bbee00b57d09ebcf$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $bbee00b57d09ebcf$require$Buffer = $kJBqN.Buffer;
'use strict';
var $e8caaa618cc972fc$exports = {};
'use strict';
$e8caaa618cc972fc$exports = {
    PNG_SIGNATURE: [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ],
    TYPE_IHDR: 0x49484452,
    TYPE_IEND: 0x49454e44,
    TYPE_IDAT: 0x49444154,
    TYPE_PLTE: 0x504c5445,
    TYPE_tRNS: 0x74524e53,
    TYPE_gAMA: 0x67414d41,
    // color-type bits
    COLORTYPE_GRAYSCALE: 0,
    COLORTYPE_PALETTE: 1,
    COLORTYPE_COLOR: 2,
    COLORTYPE_ALPHA: 4,
    // color-type combinations
    COLORTYPE_PALETTE_COLOR: 3,
    COLORTYPE_COLOR_ALPHA: 6,
    COLORTYPE_TO_BPP_MAP: {
        0: 1,
        2: 3,
        3: 1,
        4: 2,
        6: 4
    },
    GAMMA_DIVISION: 100000
};


var $1790a4cd5611ca09$exports = {};
'use strict';
var $1790a4cd5611ca09$var$crcTable = [];
(function() {
    for(var i = 0; i < 256; i++){
        var currentCrc = i;
        for(var j = 0; j < 8; j++)if (currentCrc & 1) currentCrc = 0xedb88320 ^ currentCrc >>> 1;
        else currentCrc = currentCrc >>> 1;
        $1790a4cd5611ca09$var$crcTable[i] = currentCrc;
    }
})();
var $1790a4cd5611ca09$var$CrcCalculator = $1790a4cd5611ca09$exports = function() {
    this._crc = -1;
};
$1790a4cd5611ca09$var$CrcCalculator.prototype.write = function(data) {
    for(var i = 0; i < data.length; i++)this._crc = $1790a4cd5611ca09$var$crcTable[(this._crc ^ data[i]) & 0xff] ^ this._crc >>> 8;
    return true;
};
$1790a4cd5611ca09$var$CrcCalculator.prototype.crc32 = function() {
    return this._crc ^ -1;
};
$1790a4cd5611ca09$var$CrcCalculator.crc32 = function(buf) {
    var crc = -1;
    for(var i = 0; i < buf.length; i++)crc = $1790a4cd5611ca09$var$crcTable[(crc ^ buf[i]) & 0xff] ^ crc >>> 8;
    return crc ^ -1;
};


var $bbee00b57d09ebcf$var$Parser = $bbee00b57d09ebcf$exports = function(options, dependencies) {
    this._options = options;
    options.checkCRC = options.checkCRC !== false;
    this._hasIHDR = false;
    this._hasIEND = false;
    this._emittedHeadersFinished = false;
    // input flags/metadata
    this._palette = [];
    this._colorType = 0;
    this._chunks = {};
    this._chunks[$e8caaa618cc972fc$exports.TYPE_IHDR] = this._handleIHDR.bind(this);
    this._chunks[$e8caaa618cc972fc$exports.TYPE_IEND] = this._handleIEND.bind(this);
    this._chunks[$e8caaa618cc972fc$exports.TYPE_IDAT] = this._handleIDAT.bind(this);
    this._chunks[$e8caaa618cc972fc$exports.TYPE_PLTE] = this._handlePLTE.bind(this);
    this._chunks[$e8caaa618cc972fc$exports.TYPE_tRNS] = this._handleTRNS.bind(this);
    this._chunks[$e8caaa618cc972fc$exports.TYPE_gAMA] = this._handleGAMA.bind(this);
    this.read = dependencies.read;
    this.error = dependencies.error;
    this.metadata = dependencies.metadata;
    this.gamma = dependencies.gamma;
    this.transColor = dependencies.transColor;
    this.palette = dependencies.palette;
    this.parsed = dependencies.parsed;
    this.inflateData = dependencies.inflateData;
    this.finished = dependencies.finished;
    this.simpleTransparency = dependencies.simpleTransparency;
    this.headersFinished = dependencies.headersFinished || function() {};
};
$bbee00b57d09ebcf$var$Parser.prototype.start = function() {
    this.read($e8caaa618cc972fc$exports.PNG_SIGNATURE.length, this._parseSignature.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseSignature = function(data) {
    var signature = $e8caaa618cc972fc$exports.PNG_SIGNATURE;
    for(var i = 0; i < signature.length; i++)if (data[i] !== signature[i]) {
        this.error(new Error('Invalid file signature'));
        return;
    }
    this.read(8, this._parseChunkBegin.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseChunkBegin = function(data) {
    // chunk content length
    var length = data.readUInt32BE(0);
    // chunk type
    var type = data.readUInt32BE(4);
    var name = '';
    for(var i = 4; i < 8; i++)name += String.fromCharCode(data[i]);
    //console.log('chunk ', name, length);
    // chunk flags
    var ancillary = Boolean(data[4] & 0x20); // or critical
    //    priv = Boolean(data[5] & 0x20), // or public
    //    safeToCopy = Boolean(data[7] & 0x20); // or unsafe
    if (!this._hasIHDR && type !== $e8caaa618cc972fc$exports.TYPE_IHDR) {
        this.error(new Error('Expected IHDR on beggining'));
        return;
    }
    this._crc = new $1790a4cd5611ca09$exports();
    this._crc.write(new $bbee00b57d09ebcf$require$Buffer(name));
    if (this._chunks[type]) return this._chunks[type](length);
    if (!ancillary) {
        this.error(new Error('Unsupported critical chunk type ' + name));
        return;
    }
    this.read(length + 4, this._skipChunk.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._skipChunk = function() {
    this.read(8, this._parseChunkBegin.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._handleChunkEnd = function() {
    this.read(4, this._parseChunkEnd.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseChunkEnd = function(data) {
    var fileCrc = data.readInt32BE(0);
    var calcCrc = this._crc.crc32();
    // check CRC
    if (this._options.checkCRC && calcCrc !== fileCrc) {
        this.error(new Error('Crc error - ' + fileCrc + ' - ' + calcCrc));
        return;
    }
    if (!this._hasIEND) this.read(8, this._parseChunkBegin.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._handleIHDR = function(length) {
    this.read(length, this._parseIHDR.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseIHDR = function(data) {
    this._crc.write(data);
    var width = data.readUInt32BE(0);
    var height = data.readUInt32BE(4);
    var depth = data[8];
    var colorType = data[9]; // bits: 1 palette, 2 color, 4 alpha
    var compr = data[10];
    var filter = data[11];
    var interlace = data[12];
    // console.log('    width', width, 'height', height,
    //     'depth', depth, 'colorType', colorType,
    //     'compr', compr, 'filter', filter, 'interlace', interlace
    // );
    if (depth !== 8 && depth !== 4 && depth !== 2 && depth !== 1 && depth !== 16) {
        this.error(new Error('Unsupported bit depth ' + depth));
        return;
    }
    if (!(colorType in $e8caaa618cc972fc$exports.COLORTYPE_TO_BPP_MAP)) {
        this.error(new Error('Unsupported color type'));
        return;
    }
    if (compr !== 0) {
        this.error(new Error('Unsupported compression method'));
        return;
    }
    if (filter !== 0) {
        this.error(new Error('Unsupported filter method'));
        return;
    }
    if (interlace !== 0 && interlace !== 1) {
        this.error(new Error('Unsupported interlace method'));
        return;
    }
    this._colorType = colorType;
    var bpp = $e8caaa618cc972fc$exports.COLORTYPE_TO_BPP_MAP[this._colorType];
    this._hasIHDR = true;
    this.metadata({
        width: width,
        height: height,
        depth: depth,
        interlace: Boolean(interlace),
        palette: Boolean(colorType & $e8caaa618cc972fc$exports.COLORTYPE_PALETTE),
        color: Boolean(colorType & $e8caaa618cc972fc$exports.COLORTYPE_COLOR),
        alpha: Boolean(colorType & $e8caaa618cc972fc$exports.COLORTYPE_ALPHA),
        bpp: bpp,
        colorType: colorType
    });
    this._handleChunkEnd();
};
$bbee00b57d09ebcf$var$Parser.prototype._handlePLTE = function(length) {
    this.read(length, this._parsePLTE.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parsePLTE = function(data) {
    this._crc.write(data);
    var entries = Math.floor(data.length / 3);
    // console.log('Palette:', entries);
    for(var i = 0; i < entries; i++)this._palette.push([
        data[i * 3],
        data[i * 3 + 1],
        data[i * 3 + 2],
        0xff
    ]);
    this.palette(this._palette);
    this._handleChunkEnd();
};
$bbee00b57d09ebcf$var$Parser.prototype._handleTRNS = function(length) {
    this.simpleTransparency();
    this.read(length, this._parseTRNS.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseTRNS = function(data) {
    this._crc.write(data);
    // palette
    if (this._colorType === $e8caaa618cc972fc$exports.COLORTYPE_PALETTE_COLOR) {
        if (this._palette.length === 0) {
            this.error(new Error('Transparency chunk must be after palette'));
            return;
        }
        if (data.length > this._palette.length) {
            this.error(new Error('More transparent colors than palette size'));
            return;
        }
        for(var i = 0; i < data.length; i++)this._palette[i][3] = data[i];
        this.palette(this._palette);
    }
    // for colorType 0 (grayscale) and 2 (rgb)
    // there might be one gray/color defined as transparent
    if (this._colorType === $e8caaa618cc972fc$exports.COLORTYPE_GRAYSCALE) // grey, 2 bytes
    this.transColor([
        data.readUInt16BE(0)
    ]);
    if (this._colorType === $e8caaa618cc972fc$exports.COLORTYPE_COLOR) this.transColor([
        data.readUInt16BE(0),
        data.readUInt16BE(2),
        data.readUInt16BE(4)
    ]);
    this._handleChunkEnd();
};
$bbee00b57d09ebcf$var$Parser.prototype._handleGAMA = function(length) {
    this.read(length, this._parseGAMA.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseGAMA = function(data) {
    this._crc.write(data);
    this.gamma(data.readUInt32BE(0) / $e8caaa618cc972fc$exports.GAMMA_DIVISION);
    this._handleChunkEnd();
};
$bbee00b57d09ebcf$var$Parser.prototype._handleIDAT = function(length) {
    if (!this._emittedHeadersFinished) {
        this._emittedHeadersFinished = true;
        this.headersFinished();
    }
    this.read(-length, this._parseIDAT.bind(this, length));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseIDAT = function(length, data) {
    this._crc.write(data);
    if (this._colorType === $e8caaa618cc972fc$exports.COLORTYPE_PALETTE_COLOR && this._palette.length === 0) throw new Error('Expected palette not found');
    this.inflateData(data);
    var leftOverLength = length - data.length;
    if (leftOverLength > 0) this._handleIDAT(leftOverLength);
    else this._handleChunkEnd();
};
$bbee00b57d09ebcf$var$Parser.prototype._handleIEND = function(length) {
    this.read(length, this._parseIEND.bind(this));
};
$bbee00b57d09ebcf$var$Parser.prototype._parseIEND = function(data) {
    this._crc.write(data);
    this._hasIEND = true;
    this._handleChunkEnd();
    if (this.finished) this.finished();
};


var $c1b78c610250048d$export$17fca68e4c5b17e1;

var $kJBqN = parcelRequire("kJBqN");
var $c1b78c610250048d$require$Buffer = $kJBqN.Buffer;
'use strict';

var $c1b78c610250048d$var$pixelBppMapper = [
    // 0 - dummy entry
    function() {},
    // 1 - L
    // 0: 0, 1: 0, 2: 0, 3: 0xff
    function(pxData, data, pxPos, rawPos) {
        if (rawPos === data.length) throw new Error('Ran out of data');
        var pixel = data[rawPos];
        pxData[pxPos] = pixel;
        pxData[pxPos + 1] = pixel;
        pxData[pxPos + 2] = pixel;
        pxData[pxPos + 3] = 0xff;
    },
    // 2 - LA
    // 0: 0, 1: 0, 2: 0, 3: 1
    function(pxData, data, pxPos, rawPos) {
        if (rawPos + 1 >= data.length) throw new Error('Ran out of data');
        var pixel = data[rawPos];
        pxData[pxPos] = pixel;
        pxData[pxPos + 1] = pixel;
        pxData[pxPos + 2] = pixel;
        pxData[pxPos + 3] = data[rawPos + 1];
    },
    // 3 - RGB
    // 0: 0, 1: 1, 2: 2, 3: 0xff
    function(pxData, data, pxPos, rawPos) {
        if (rawPos + 2 >= data.length) throw new Error('Ran out of data');
        pxData[pxPos] = data[rawPos];
        pxData[pxPos + 1] = data[rawPos + 1];
        pxData[pxPos + 2] = data[rawPos + 2];
        pxData[pxPos + 3] = 0xff;
    },
    // 4 - RGBA
    // 0: 0, 1: 1, 2: 2, 3: 3
    function(pxData, data, pxPos, rawPos) {
        if (rawPos + 3 >= data.length) throw new Error('Ran out of data');
        pxData[pxPos] = data[rawPos];
        pxData[pxPos + 1] = data[rawPos + 1];
        pxData[pxPos + 2] = data[rawPos + 2];
        pxData[pxPos + 3] = data[rawPos + 3];
    }
];
var $c1b78c610250048d$var$pixelBppCustomMapper = [
    // 0 - dummy entry
    function() {},
    // 1 - L
    // 0: 0, 1: 0, 2: 0, 3: 0xff
    function(pxData, pixelData, pxPos, maxBit) {
        var pixel = pixelData[0];
        pxData[pxPos] = pixel;
        pxData[pxPos + 1] = pixel;
        pxData[pxPos + 2] = pixel;
        pxData[pxPos + 3] = maxBit;
    },
    // 2 - LA
    // 0: 0, 1: 0, 2: 0, 3: 1
    function(pxData, pixelData, pxPos) {
        var pixel = pixelData[0];
        pxData[pxPos] = pixel;
        pxData[pxPos + 1] = pixel;
        pxData[pxPos + 2] = pixel;
        pxData[pxPos + 3] = pixelData[1];
    },
    // 3 - RGB
    // 0: 0, 1: 1, 2: 2, 3: 0xff
    function(pxData, pixelData, pxPos, maxBit) {
        pxData[pxPos] = pixelData[0];
        pxData[pxPos + 1] = pixelData[1];
        pxData[pxPos + 2] = pixelData[2];
        pxData[pxPos + 3] = maxBit;
    },
    // 4 - RGBA
    // 0: 0, 1: 1, 2: 2, 3: 3
    function(pxData, pixelData, pxPos) {
        pxData[pxPos] = pixelData[0];
        pxData[pxPos + 1] = pixelData[1];
        pxData[pxPos + 2] = pixelData[2];
        pxData[pxPos + 3] = pixelData[3];
    }
];
function $c1b78c610250048d$var$bitRetriever(data, depth) {
    var leftOver = [];
    var i = 0;
    function split() {
        if (i === data.length) throw new Error('Ran out of data');
        var byte = data[i];
        i++;
        var byte8, byte7, byte6, byte5, byte4, byte3, byte2, byte1;
        switch(depth){
            default:
                throw new Error('unrecognised depth');
            case 16:
                byte2 = data[i];
                i++;
                leftOver.push((byte << 8) + byte2);
                break;
            case 4:
                byte2 = byte & 0x0f;
                byte1 = byte >> 4;
                leftOver.push(byte1, byte2);
                break;
            case 2:
                byte4 = byte & 3;
                byte3 = byte >> 2 & 3;
                byte2 = byte >> 4 & 3;
                byte1 = byte >> 6 & 3;
                leftOver.push(byte1, byte2, byte3, byte4);
                break;
            case 1:
                byte8 = byte & 1;
                byte7 = byte >> 1 & 1;
                byte6 = byte >> 2 & 1;
                byte5 = byte >> 3 & 1;
                byte4 = byte >> 4 & 1;
                byte3 = byte >> 5 & 1;
                byte2 = byte >> 6 & 1;
                byte1 = byte >> 7 & 1;
                leftOver.push(byte1, byte2, byte3, byte4, byte5, byte6, byte7, byte8);
                break;
        }
    }
    return {
        get: function(count) {
            while(leftOver.length < count)split();
            var returner = leftOver.slice(0, count);
            leftOver = leftOver.slice(count);
            return returner;
        },
        resetAfterLine: function() {
            leftOver.length = 0;
        },
        end: function() {
            if (i !== data.length) throw new Error('extra data found');
        }
    };
}
function $c1b78c610250048d$var$mapImage8Bit(image, pxData, getPxPos, bpp, data, rawPos) {
    var imageWidth = image.width;
    var imageHeight = image.height;
    var imagePass = image.index;
    for(var y = 0; y < imageHeight; y++)for(var x = 0; x < imageWidth; x++){
        var pxPos = getPxPos(x, y, imagePass);
        $c1b78c610250048d$var$pixelBppMapper[bpp](pxData, data, pxPos, rawPos);
        rawPos += bpp; //eslint-disable-line no-param-reassign
    }
    return rawPos;
}
function $c1b78c610250048d$var$mapImageCustomBit(image, pxData, getPxPos, bpp, bits, maxBit) {
    var imageWidth = image.width;
    var imageHeight = image.height;
    var imagePass = image.index;
    for(var y = 0; y < imageHeight; y++){
        for(var x = 0; x < imageWidth; x++){
            var pixelData = bits.get(bpp);
            var pxPos = getPxPos(x, y, imagePass);
            $c1b78c610250048d$var$pixelBppCustomMapper[bpp](pxData, pixelData, pxPos, maxBit);
        }
        bits.resetAfterLine();
    }
}
$c1b78c610250048d$export$17fca68e4c5b17e1 = function(data, bitmapInfo) {
    var width = bitmapInfo.width;
    var height = bitmapInfo.height;
    var depth = bitmapInfo.depth;
    var bpp = bitmapInfo.bpp;
    var interlace = bitmapInfo.interlace;
    if (depth !== 8) var bits = $c1b78c610250048d$var$bitRetriever(data, depth);
    var pxData;
    if (depth <= 8) pxData = new $c1b78c610250048d$require$Buffer(width * height * 4);
    else pxData = new Uint16Array(width * height * 4);
    var maxBit = Math.pow(2, depth) - 1;
    var rawPos = 0;
    var images;
    var getPxPos;
    if (interlace) {
        images = $73d134d8ad2436b6$export$a07d0d6171f4e862(width, height);
        getPxPos = $73d134d8ad2436b6$export$45f10fc460b6d16b(width, height);
    } else {
        var nonInterlacedPxPos = 0;
        getPxPos = function() {
            var returner = nonInterlacedPxPos;
            nonInterlacedPxPos += 4;
            return returner;
        };
        images = [
            {
                width: width,
                height: height
            }
        ];
    }
    for(var imageIndex = 0; imageIndex < images.length; imageIndex++)if (depth === 8) rawPos = $c1b78c610250048d$var$mapImage8Bit(images[imageIndex], pxData, getPxPos, bpp, data, rawPos);
    else $c1b78c610250048d$var$mapImageCustomBit(images[imageIndex], pxData, getPxPos, bpp, bits, maxBit);
    if (depth === 8) {
        if (rawPos !== data.length) throw new Error('extra data found');
    } else bits.end();
    return pxData;
};


var $17e38d29653e818b$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $17e38d29653e818b$require$Buffer = $kJBqN.Buffer;
'use strict';
function $17e38d29653e818b$var$dePalette(indata, outdata, width, height, palette) {
    var pxPos = 0;
    // use values from palette
    for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
        var color = palette[indata[pxPos]];
        if (!color) throw new Error('index ' + indata[pxPos] + ' not in palette');
        for(var i = 0; i < 4; i++)outdata[pxPos + i] = color[i];
        pxPos += 4;
    }
}
function $17e38d29653e818b$var$replaceTransparentColor(indata, outdata, width, height, transColor) {
    var pxPos = 0;
    for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
        var makeTrans = false;
        if (transColor.length === 1) {
            if (transColor[0] === indata[pxPos]) makeTrans = true;
        } else if (transColor[0] === indata[pxPos] && transColor[1] === indata[pxPos + 1] && transColor[2] === indata[pxPos + 2]) makeTrans = true;
        if (makeTrans) for(var i = 0; i < 4; i++)outdata[pxPos + i] = 0;
        pxPos += 4;
    }
}
function $17e38d29653e818b$var$scaleDepth(indata, outdata, width, height, depth) {
    var maxOutSample = 255;
    var maxInSample = Math.pow(2, depth) - 1;
    var pxPos = 0;
    for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
        for(var i = 0; i < 4; i++)outdata[pxPos + i] = Math.floor(indata[pxPos + i] * maxOutSample / maxInSample + 0.5);
        pxPos += 4;
    }
}
$17e38d29653e818b$exports = function(indata, imageData) {
    var depth = imageData.depth;
    var width = imageData.width;
    var height = imageData.height;
    var colorType = imageData.colorType;
    var transColor = imageData.transColor;
    var palette = imageData.palette;
    var outdata = indata; // only different for 16 bits
    if (colorType === 3) $17e38d29653e818b$var$dePalette(indata, outdata, width, height, palette);
    else {
        if (transColor) $17e38d29653e818b$var$replaceTransparentColor(indata, outdata, width, height, transColor);
        // if it needs scaling
        if (depth !== 8) {
            // if we need to change the buffer size
            if (depth === 16) outdata = new $17e38d29653e818b$require$Buffer(width * height * 4);
            $17e38d29653e818b$var$scaleDepth(indata, outdata, width, height, depth);
        }
    }
    return outdata;
};


var $a944d1fd254584c5$var$ParserAsync = $a944d1fd254584c5$exports = function(options) {
    $a15ee1fb6e2366de$exports.call(this);
    this._parser = new $bbee00b57d09ebcf$exports(options, {
        read: this.read.bind(this),
        error: this._handleError.bind(this),
        metadata: this._handleMetaData.bind(this),
        gamma: this.emit.bind(this, 'gamma'),
        palette: this._handlePalette.bind(this),
        transColor: this._handleTransColor.bind(this),
        finished: this._finished.bind(this),
        inflateData: this._inflateData.bind(this),
        simpleTransparency: this._simpleTransparency.bind(this),
        headersFinished: this._headersFinished.bind(this)
    });
    this._options = options;
    this.writable = true;
    this._parser.start();
};
$hHIjR.inherits($a944d1fd254584c5$var$ParserAsync, $a15ee1fb6e2366de$exports);
$a944d1fd254584c5$var$ParserAsync.prototype._handleError = function(err) {
    this.emit('error', err);
    this.writable = false;
    this.destroy();
    if (this._inflate && this._inflate.destroy) this._inflate.destroy();
    if (this._filter) {
        this._filter.destroy();
        // For backward compatibility with Node 7 and below.
        // Suppress errors due to _inflate calling write() even after
        // it's destroy()'ed.
        this._filter.on('error', function() {});
    }
    this.errord = true;
};
$a944d1fd254584c5$var$ParserAsync.prototype._inflateData = function(data) {
    if (!this._inflate) {
        if (this._bitmapInfo.interlace) {
            this._inflate = $dy7q9.createInflate();
            this._inflate.on('error', this.emit.bind(this, 'error'));
            this._filter.on('complete', this._complete.bind(this));
            this._inflate.pipe(this._filter);
        } else {
            var rowSize = (this._bitmapInfo.width * this._bitmapInfo.bpp * this._bitmapInfo.depth + 7 >> 3) + 1;
            var imageSize = rowSize * this._bitmapInfo.height;
            var chunkSize = Math.max(imageSize, $dy7q9.Z_MIN_CHUNK);
            this._inflate = $dy7q9.createInflate({
                chunkSize: chunkSize
            });
            var leftToInflate = imageSize;
            var emitError = this.emit.bind(this, 'error');
            this._inflate.on('error', function(err) {
                if (!leftToInflate) return;
                emitError(err);
            });
            this._filter.on('complete', this._complete.bind(this));
            var filterWrite = this._filter.write.bind(this._filter);
            this._inflate.on('data', function(chunk) {
                if (!leftToInflate) return;
                if (chunk.length > leftToInflate) chunk = chunk.slice(0, leftToInflate);
                leftToInflate -= chunk.length;
                filterWrite(chunk);
            });
            this._inflate.on('end', this._filter.end.bind(this._filter));
        }
    }
    this._inflate.write(data);
};
$a944d1fd254584c5$var$ParserAsync.prototype._handleMetaData = function(metaData) {
    this._metaData = metaData;
    this._bitmapInfo = Object.create(metaData);
    this._filter = new $f970b98bd60b22f6$exports(this._bitmapInfo);
};
$a944d1fd254584c5$var$ParserAsync.prototype._handleTransColor = function(transColor) {
    this._bitmapInfo.transColor = transColor;
};
$a944d1fd254584c5$var$ParserAsync.prototype._handlePalette = function(palette) {
    this._bitmapInfo.palette = palette;
};
$a944d1fd254584c5$var$ParserAsync.prototype._simpleTransparency = function() {
    this._metaData.alpha = true;
};
$a944d1fd254584c5$var$ParserAsync.prototype._headersFinished = function() {
    // Up until this point, we don't know if we have a tRNS chunk (alpha)
    // so we can't emit metadata any earlier
    this.emit('metadata', this._metaData);
};
$a944d1fd254584c5$var$ParserAsync.prototype._finished = function() {
    if (this.errord) return;
    if (!this._inflate) this.emit('error', 'No Inflate block');
    else // no more data to inflate
    this._inflate.end();
    this.destroySoon();
};
$a944d1fd254584c5$var$ParserAsync.prototype._complete = function(filteredData) {
    if (this.errord) return;
    try {
        var bitmapData = $c1b78c610250048d$export$17fca68e4c5b17e1(filteredData, this._bitmapInfo);
        var normalisedBitmapData = $17e38d29653e818b$exports(bitmapData, this._bitmapInfo);
        bitmapData = null;
    } catch (ex) {
        this._handleError(ex);
        return;
    }
    this.emit('parsed', normalisedBitmapData);
};


var $6dfa457ed5b39b96$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $6dfa457ed5b39b96$require$Buffer = $kJBqN.Buffer;
'use strict';

var $hHIjR = parcelRequire("hHIjR");

var $2C97X = parcelRequire("2C97X");

var $69bc1011f5b2d0ac$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $69bc1011f5b2d0ac$require$Buffer = $kJBqN.Buffer;
'use strict';


var $be3bc9b1ea2488e9$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $be3bc9b1ea2488e9$require$Buffer = $kJBqN.Buffer;
'use strict';

$be3bc9b1ea2488e9$exports = function(dataIn, width, height, options) {
    var outHasAlpha = [
        $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA,
        $e8caaa618cc972fc$exports.COLORTYPE_ALPHA
    ].indexOf(options.colorType) !== -1;
    if (options.colorType === options.inputColorType) {
        var bigEndian = function() {
            var buffer = new ArrayBuffer(2);
            new DataView(buffer).setInt16(0, 256, true);
            // Int16Array uses the platform's endianness.
            return new Int16Array(buffer)[0] !== 256;
        }();
        // If no need to convert to grayscale and alpha is present/absent in both, take a fast route
        if (options.bitDepth === 8 || options.bitDepth === 16 && bigEndian) return dataIn;
    }
    // map to a UInt16 array if data is 16bit, fix endianness below
    var data = options.bitDepth !== 16 ? dataIn : new Uint16Array(dataIn.buffer);
    var maxValue = 255;
    var inBpp = $e8caaa618cc972fc$exports.COLORTYPE_TO_BPP_MAP[options.inputColorType];
    if (inBpp === 4 && !options.inputHasAlpha) inBpp = 3;
    var outBpp = $e8caaa618cc972fc$exports.COLORTYPE_TO_BPP_MAP[options.colorType];
    if (options.bitDepth === 16) {
        maxValue = 65535;
        outBpp *= 2;
    }
    var outData = new $be3bc9b1ea2488e9$require$Buffer(width * height * outBpp);
    var inIndex = 0;
    var outIndex = 0;
    var bgColor = options.bgColor || {};
    if (bgColor.red === undefined) bgColor.red = maxValue;
    if (bgColor.green === undefined) bgColor.green = maxValue;
    if (bgColor.blue === undefined) bgColor.blue = maxValue;
    function getRGBA() {
        var red;
        var green;
        var blue;
        var alpha = maxValue;
        switch(options.inputColorType){
            case $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA:
                alpha = data[inIndex + 3];
                red = data[inIndex];
                green = data[inIndex + 1];
                blue = data[inIndex + 2];
                break;
            case $e8caaa618cc972fc$exports.COLORTYPE_COLOR:
                red = data[inIndex];
                green = data[inIndex + 1];
                blue = data[inIndex + 2];
                break;
            case $e8caaa618cc972fc$exports.COLORTYPE_ALPHA:
                alpha = data[inIndex + 1];
                red = data[inIndex];
                green = red;
                blue = red;
                break;
            case $e8caaa618cc972fc$exports.COLORTYPE_GRAYSCALE:
                red = data[inIndex];
                green = red;
                blue = red;
                break;
            default:
                throw new Error('input color type:' + options.inputColorType + ' is not supported at present');
        }
        if (options.inputHasAlpha) {
            if (!outHasAlpha) {
                alpha /= maxValue;
                red = Math.min(Math.max(Math.round((1 - alpha) * bgColor.red + alpha * red), 0), maxValue);
                green = Math.min(Math.max(Math.round((1 - alpha) * bgColor.green + alpha * green), 0), maxValue);
                blue = Math.min(Math.max(Math.round((1 - alpha) * bgColor.blue + alpha * blue), 0), maxValue);
            }
        }
        return {
            red: red,
            green: green,
            blue: blue,
            alpha: alpha
        };
    }
    for(var y = 0; y < height; y++)for(var x = 0; x < width; x++){
        var rgba = getRGBA(data, inIndex);
        switch(options.colorType){
            case $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA:
            case $e8caaa618cc972fc$exports.COLORTYPE_COLOR:
                if (options.bitDepth === 8) {
                    outData[outIndex] = rgba.red;
                    outData[outIndex + 1] = rgba.green;
                    outData[outIndex + 2] = rgba.blue;
                    if (outHasAlpha) outData[outIndex + 3] = rgba.alpha;
                } else {
                    outData.writeUInt16BE(rgba.red, outIndex);
                    outData.writeUInt16BE(rgba.green, outIndex + 2);
                    outData.writeUInt16BE(rgba.blue, outIndex + 4);
                    if (outHasAlpha) outData.writeUInt16BE(rgba.alpha, outIndex + 6);
                }
                break;
            case $e8caaa618cc972fc$exports.COLORTYPE_ALPHA:
            case $e8caaa618cc972fc$exports.COLORTYPE_GRAYSCALE:
                // Convert to grayscale and alpha
                var grayscale = (rgba.red + rgba.green + rgba.blue) / 3;
                if (options.bitDepth === 8) {
                    outData[outIndex] = grayscale;
                    if (outHasAlpha) outData[outIndex + 1] = rgba.alpha;
                } else {
                    outData.writeUInt16BE(grayscale, outIndex);
                    if (outHasAlpha) outData.writeUInt16BE(rgba.alpha, outIndex + 2);
                }
                break;
            default:
                throw new Error('unrecognised color Type ' + options.colorType);
        }
        inIndex += inBpp;
        outIndex += outBpp;
    }
    return outData;
};


var $03e7dfdcbf4b170c$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $03e7dfdcbf4b170c$require$Buffer = $kJBqN.Buffer;
'use strict';

function $03e7dfdcbf4b170c$var$filterNone(pxData, pxPos, byteWidth, rawData, rawPos) {
    for(var x = 0; x < byteWidth; x++)rawData[rawPos + x] = pxData[pxPos + x];
}
function $03e7dfdcbf4b170c$var$filterSumNone(pxData, pxPos, byteWidth) {
    var sum = 0;
    var length = pxPos + byteWidth;
    for(var i = pxPos; i < length; i++)sum += Math.abs(pxData[i]);
    return sum;
}
function $03e7dfdcbf4b170c$var$filterSub(pxData, pxPos, byteWidth, rawData, rawPos, bpp) {
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var val = pxData[pxPos + x] - left;
        rawData[rawPos + x] = val;
    }
}
function $03e7dfdcbf4b170c$var$filterSumSub(pxData, pxPos, byteWidth, bpp) {
    var sum = 0;
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var val = pxData[pxPos + x] - left;
        sum += Math.abs(val);
    }
    return sum;
}
function $03e7dfdcbf4b170c$var$filterUp(pxData, pxPos, byteWidth, rawData, rawPos) {
    for(var x = 0; x < byteWidth; x++){
        var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
        var val = pxData[pxPos + x] - up;
        rawData[rawPos + x] = val;
    }
}
function $03e7dfdcbf4b170c$var$filterSumUp(pxData, pxPos, byteWidth) {
    var sum = 0;
    var length = pxPos + byteWidth;
    for(var x = pxPos; x < length; x++){
        var up = pxPos > 0 ? pxData[x - byteWidth] : 0;
        var val = pxData[x] - up;
        sum += Math.abs(val);
    }
    return sum;
}
function $03e7dfdcbf4b170c$var$filterAvg(pxData, pxPos, byteWidth, rawData, rawPos, bpp) {
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
        var val = pxData[pxPos + x] - (left + up >> 1);
        rawData[rawPos + x] = val;
    }
}
function $03e7dfdcbf4b170c$var$filterSumAvg(pxData, pxPos, byteWidth, bpp) {
    var sum = 0;
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
        var val = pxData[pxPos + x] - (left + up >> 1);
        sum += Math.abs(val);
    }
    return sum;
}
function $03e7dfdcbf4b170c$var$filterPaeth(pxData, pxPos, byteWidth, rawData, rawPos, bpp) {
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
        var upleft = pxPos > 0 && x >= bpp ? pxData[pxPos + x - (byteWidth + bpp)] : 0;
        var val = pxData[pxPos + x] - $55cf86e7d5152e90$exports(left, up, upleft);
        rawData[rawPos + x] = val;
    }
}
function $03e7dfdcbf4b170c$var$filterSumPaeth(pxData, pxPos, byteWidth, bpp) {
    var sum = 0;
    for(var x = 0; x < byteWidth; x++){
        var left = x >= bpp ? pxData[pxPos + x - bpp] : 0;
        var up = pxPos > 0 ? pxData[pxPos + x - byteWidth] : 0;
        var upleft = pxPos > 0 && x >= bpp ? pxData[pxPos + x - (byteWidth + bpp)] : 0;
        var val = pxData[pxPos + x] - $55cf86e7d5152e90$exports(left, up, upleft);
        sum += Math.abs(val);
    }
    return sum;
}
var $03e7dfdcbf4b170c$var$filters = {
    0: $03e7dfdcbf4b170c$var$filterNone,
    1: $03e7dfdcbf4b170c$var$filterSub,
    2: $03e7dfdcbf4b170c$var$filterUp,
    3: $03e7dfdcbf4b170c$var$filterAvg,
    4: $03e7dfdcbf4b170c$var$filterPaeth
};
var $03e7dfdcbf4b170c$var$filterSums = {
    0: $03e7dfdcbf4b170c$var$filterSumNone,
    1: $03e7dfdcbf4b170c$var$filterSumSub,
    2: $03e7dfdcbf4b170c$var$filterSumUp,
    3: $03e7dfdcbf4b170c$var$filterSumAvg,
    4: $03e7dfdcbf4b170c$var$filterSumPaeth
};
$03e7dfdcbf4b170c$exports = function(pxData, width, height, options, bpp) {
    var filterTypes;
    if (!('filterType' in options) || options.filterType === -1) filterTypes = [
        0,
        1,
        2,
        3,
        4
    ];
    else if (typeof options.filterType === 'number') filterTypes = [
        options.filterType
    ];
    else throw new Error('unrecognised filter types');
    if (options.bitDepth === 16) bpp *= 2;
    var byteWidth = width * bpp;
    var rawPos = 0;
    var pxPos = 0;
    var rawData = new $03e7dfdcbf4b170c$require$Buffer((byteWidth + 1) * height);
    var sel = filterTypes[0];
    for(var y = 0; y < height; y++){
        if (filterTypes.length > 1) {
            // find best filter for this line (with lowest sum of values)
            var min = Infinity;
            for(var i = 0; i < filterTypes.length; i++){
                var sum = $03e7dfdcbf4b170c$var$filterSums[filterTypes[i]](pxData, pxPos, byteWidth, bpp);
                if (sum < min) {
                    sel = filterTypes[i];
                    min = sum;
                }
            }
        }
        rawData[rawPos] = sel;
        rawPos++;
        $03e7dfdcbf4b170c$var$filters[sel](pxData, pxPos, byteWidth, rawData, rawPos, bpp);
        rawPos += byteWidth;
        pxPos += byteWidth;
    }
    return rawData;
};



var $dy7q9 = parcelRequire("dy7q9");
var $69bc1011f5b2d0ac$var$Packer = $69bc1011f5b2d0ac$exports = function(options) {
    this._options = options;
    options.deflateChunkSize = options.deflateChunkSize || 32768;
    options.deflateLevel = options.deflateLevel != null ? options.deflateLevel : 9;
    options.deflateStrategy = options.deflateStrategy != null ? options.deflateStrategy : 3;
    options.inputHasAlpha = options.inputHasAlpha != null ? options.inputHasAlpha : true;
    options.deflateFactory = options.deflateFactory || $dy7q9.createDeflate;
    options.bitDepth = options.bitDepth || 8;
    // This is outputColorType
    options.colorType = typeof options.colorType === 'number' ? options.colorType : $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA;
    options.inputColorType = typeof options.inputColorType === 'number' ? options.inputColorType : $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA;
    if ([
        $e8caaa618cc972fc$exports.COLORTYPE_GRAYSCALE,
        $e8caaa618cc972fc$exports.COLORTYPE_COLOR,
        $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA,
        $e8caaa618cc972fc$exports.COLORTYPE_ALPHA
    ].indexOf(options.colorType) === -1) throw new Error('option color type:' + options.colorType + ' is not supported at present');
    if ([
        $e8caaa618cc972fc$exports.COLORTYPE_GRAYSCALE,
        $e8caaa618cc972fc$exports.COLORTYPE_COLOR,
        $e8caaa618cc972fc$exports.COLORTYPE_COLOR_ALPHA,
        $e8caaa618cc972fc$exports.COLORTYPE_ALPHA
    ].indexOf(options.inputColorType) === -1) throw new Error('option input color type:' + options.inputColorType + ' is not supported at present');
    if (options.bitDepth !== 8 && options.bitDepth !== 16) throw new Error('option bit depth:' + options.bitDepth + ' is not supported at present');
};
$69bc1011f5b2d0ac$var$Packer.prototype.getDeflateOptions = function() {
    return {
        chunkSize: this._options.deflateChunkSize,
        level: this._options.deflateLevel,
        strategy: this._options.deflateStrategy
    };
};
$69bc1011f5b2d0ac$var$Packer.prototype.createDeflate = function() {
    return this._options.deflateFactory(this.getDeflateOptions());
};
$69bc1011f5b2d0ac$var$Packer.prototype.filterData = function(data, width, height) {
    // convert to correct format for filtering (e.g. right bpp and bit depth)
    var packedData = $be3bc9b1ea2488e9$exports(data, width, height, this._options);
    // filter pixel data
    var bpp = $e8caaa618cc972fc$exports.COLORTYPE_TO_BPP_MAP[this._options.colorType];
    var filteredData = $03e7dfdcbf4b170c$exports(packedData, width, height, this._options, bpp);
    return filteredData;
};
$69bc1011f5b2d0ac$var$Packer.prototype._packChunk = function(type, data) {
    var len = data ? data.length : 0;
    var buf = new $69bc1011f5b2d0ac$require$Buffer(len + 12);
    buf.writeUInt32BE(len, 0);
    buf.writeUInt32BE(type, 4);
    if (data) data.copy(buf, 8);
    buf.writeInt32BE($1790a4cd5611ca09$exports.crc32(buf.slice(4, buf.length - 4)), buf.length - 4);
    return buf;
};
$69bc1011f5b2d0ac$var$Packer.prototype.packGAMA = function(gamma) {
    var buf = new $69bc1011f5b2d0ac$require$Buffer(4);
    buf.writeUInt32BE(Math.floor(gamma * $e8caaa618cc972fc$exports.GAMMA_DIVISION), 0);
    return this._packChunk($e8caaa618cc972fc$exports.TYPE_gAMA, buf);
};
$69bc1011f5b2d0ac$var$Packer.prototype.packIHDR = function(width, height) {
    var buf = new $69bc1011f5b2d0ac$require$Buffer(13);
    buf.writeUInt32BE(width, 0);
    buf.writeUInt32BE(height, 4);
    buf[8] = this._options.bitDepth; // Bit depth
    buf[9] = this._options.colorType; // colorType
    buf[10] = 0; // compression
    buf[11] = 0; // filter
    buf[12] = 0; // interlace
    return this._packChunk($e8caaa618cc972fc$exports.TYPE_IHDR, buf);
};
$69bc1011f5b2d0ac$var$Packer.prototype.packIDAT = function(data) {
    return this._packChunk($e8caaa618cc972fc$exports.TYPE_IDAT, data);
};
$69bc1011f5b2d0ac$var$Packer.prototype.packIEND = function() {
    return this._packChunk($e8caaa618cc972fc$exports.TYPE_IEND, null);
};


var $6dfa457ed5b39b96$var$PackerAsync = $6dfa457ed5b39b96$exports = function(opt) {
    $2C97X.call(this);
    var options = opt || {};
    this._packer = new $69bc1011f5b2d0ac$exports(options);
    this._deflate = this._packer.createDeflate();
    this.readable = true;
};
$hHIjR.inherits($6dfa457ed5b39b96$var$PackerAsync, $2C97X);
$6dfa457ed5b39b96$var$PackerAsync.prototype.pack = function(data, width, height, gamma) {
    // Signature
    this.emit('data', new $6dfa457ed5b39b96$require$Buffer($e8caaa618cc972fc$exports.PNG_SIGNATURE));
    this.emit('data', this._packer.packIHDR(width, height));
    if (gamma) this.emit('data', this._packer.packGAMA(gamma));
    var filteredData = this._packer.filterData(data, width, height);
    // compress it
    this._deflate.on('error', this.emit.bind(this, 'error'));
    this._deflate.on('data', (function(compressedData) {
        this.emit('data', this._packer.packIDAT(compressedData));
    }).bind(this));
    this._deflate.on('end', (function() {
        this.emit('data', this._packer.packIEND());
        this.emit('end');
    }).bind(this));
    this._deflate.end(filteredData);
};


var $f70732e6f757cf21$exports = {};

$parcel$export($f70732e6f757cf21$exports, "read", function () { return $f70732e6f757cf21$export$aafa59e2e03f2942; }, function (v) { return $f70732e6f757cf21$export$aafa59e2e03f2942 = v; });
$parcel$export($f70732e6f757cf21$exports, "write", function () { return $f70732e6f757cf21$export$68d8715fc104d294; }, function (v) { return $f70732e6f757cf21$export$68d8715fc104d294 = v; });
var $f70732e6f757cf21$export$aafa59e2e03f2942;
var $f70732e6f757cf21$export$68d8715fc104d294;
'use strict';
var $0633c680c393f723$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $0633c680c393f723$require$Buffer = $kJBqN.Buffer;
'use strict';
var $0633c680c393f723$var$hasSyncZlib = true;

var $dy7q9 = parcelRequire("dy7q9");

var $iFEO0 = parcelRequire("iFEO0");
if (!$dy7q9.deflateSync) $0633c680c393f723$var$hasSyncZlib = false;
var $18265f3720318801$exports = {};
'use strict';
var $18265f3720318801$var$SyncReader = $18265f3720318801$exports = function(buffer) {
    this._buffer = buffer;
    this._reads = [];
};
$18265f3720318801$var$SyncReader.prototype.read = function(length, callback) {
    this._reads.push({
        length: Math.abs(length),
        allowLess: length < 0,
        func: callback
    });
};
$18265f3720318801$var$SyncReader.prototype.process = function() {
    // as long as there is any data and read requests
    while(this._reads.length > 0 && this._buffer.length){
        var read = this._reads[0];
        if (this._buffer.length && (this._buffer.length >= read.length || read.allowLess)) {
            // ok there is any data so that we can satisfy this request
            this._reads.shift(); // == read
            var buf = this._buffer;
            this._buffer = buf.slice(read.length);
            read.func.call(this, buf.slice(0, read.length));
        } else break;
    }
    if (this._reads.length > 0) return new Error('There are some read requests waitng on finished stream');
    if (this._buffer.length > 0) return new Error('unrecognised content at end of stream');
};


var $0ade59f190e9276a$export$e54fe5b0f43758f7;

var $kJBqN = parcelRequire("kJBqN");
var $0ade59f190e9276a$require$Buffer = $kJBqN.Buffer;
'use strict';


$0ade59f190e9276a$export$e54fe5b0f43758f7 = function(inBuffer, bitmapInfo) {
    var outBuffers = [];
    var reader = new $18265f3720318801$exports(inBuffer);
    var filter = new $ef76d489b13e3d4c$exports(bitmapInfo, {
        read: reader.read.bind(reader),
        write: function(bufferPart) {
            outBuffers.push(bufferPart);
        },
        complete: function() {}
    });
    filter.start();
    reader.process();
    return $0ade59f190e9276a$require$Buffer.concat(outBuffers);
};





$0633c680c393f723$exports = function(buffer, options) {
    if (!$0633c680c393f723$var$hasSyncZlib) throw new Error('To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0');
    var err;
    function handleError(_err_) {
        err = _err_;
    }
    var metaData;
    function handleMetaData(_metaData_) {
        metaData = _metaData_;
    }
    function handleTransColor(transColor) {
        metaData.transColor = transColor;
    }
    function handlePalette(palette) {
        metaData.palette = palette;
    }
    function handleSimpleTransparency() {
        metaData.alpha = true;
    }
    var gamma;
    function handleGamma(_gamma_) {
        gamma = _gamma_;
    }
    var inflateDataList = [];
    function handleInflateData(inflatedData) {
        inflateDataList.push(inflatedData);
    }
    var reader = new $18265f3720318801$exports(buffer);
    var parser = new $bbee00b57d09ebcf$exports(options, {
        read: reader.read.bind(reader),
        error: handleError,
        metadata: handleMetaData,
        gamma: handleGamma,
        palette: handlePalette,
        transColor: handleTransColor,
        inflateData: handleInflateData,
        simpleTransparency: handleSimpleTransparency
    });
    parser.start();
    reader.process();
    if (err) throw err;
    //join together the inflate datas
    var inflateData = $0633c680c393f723$require$Buffer.concat(inflateDataList);
    inflateDataList.length = 0;
    var inflatedData;
    if (metaData.interlace) inflatedData = $dy7q9.inflateSync(inflateData);
    else {
        var rowSize = (metaData.width * metaData.bpp * metaData.depth + 7 >> 3) + 1;
        var imageSize = rowSize * metaData.height;
        inflatedData = $iFEO0(inflateData, {
            chunkSize: imageSize,
            maxLength: imageSize
        });
    }
    inflateData = null;
    if (!inflatedData || !inflatedData.length) throw new Error('bad png - invalid inflate data response');
    var unfilteredData = $0ade59f190e9276a$export$e54fe5b0f43758f7(inflatedData, metaData);
    inflateData = null;
    var bitmapData = $c1b78c610250048d$export$17fca68e4c5b17e1(unfilteredData, metaData);
    unfilteredData = null;
    var normalisedBitmapData = $17e38d29653e818b$exports(bitmapData, metaData);
    metaData.data = normalisedBitmapData;
    metaData.gamma = gamma || 0;
    return metaData;
};


var $70b50d123dd4665e$exports = {};

var $kJBqN = parcelRequire("kJBqN");
var $70b50d123dd4665e$require$Buffer = $kJBqN.Buffer;
'use strict';
var $70b50d123dd4665e$var$hasSyncZlib = true;

var $dy7q9 = parcelRequire("dy7q9");
if (!$dy7q9.deflateSync) $70b50d123dd4665e$var$hasSyncZlib = false;


$70b50d123dd4665e$exports = function(metaData, opt) {
    if (!$70b50d123dd4665e$var$hasSyncZlib) throw new Error('To use the sync capability of this library in old node versions, please pin pngjs to v2.3.0');
    var options = opt || {};
    var packer = new $69bc1011f5b2d0ac$exports(options);
    var chunks = [];
    // Signature
    chunks.push(new $70b50d123dd4665e$require$Buffer($e8caaa618cc972fc$exports.PNG_SIGNATURE));
    // Header
    chunks.push(packer.packIHDR(metaData.width, metaData.height));
    if (metaData.gamma) chunks.push(packer.packGAMA(metaData.gamma));
    var filteredData = packer.filterData(metaData.data, metaData.width, metaData.height);
    // compress it
    var compressedData = $dy7q9.deflateSync(filteredData, packer.getDeflateOptions());
    filteredData = null;
    if (!compressedData || !compressedData.length) throw new Error('bad png - invalid compressed data response');
    chunks.push(packer.packIDAT(compressedData));
    // End
    chunks.push(packer.packIEND());
    return $70b50d123dd4665e$require$Buffer.concat(chunks);
};


$f70732e6f757cf21$export$aafa59e2e03f2942 = function(buffer, options) {
    return $0633c680c393f723$exports(buffer, options || {});
};
$f70732e6f757cf21$export$68d8715fc104d294 = function(png, options) {
    return $70b50d123dd4665e$exports(png, options);
};


var $4acb61a97e3722f6$var$PNG = $4acb61a97e3722f6$export$1f536085c24cc947 = function(options) {
    $2C97X.call(this);
    options = options || {}; // eslint-disable-line no-param-reassign
    // coerce pixel dimensions to integers (also coerces undefined -> 0):
    this.width = options.width | 0;
    this.height = options.height | 0;
    this.data = this.width > 0 && this.height > 0 ? new $4acb61a97e3722f6$require$Buffer(4 * this.width * this.height) : null;
    if (options.fill && this.data) this.data.fill(0);
    this.gamma = 0;
    this.readable = this.writable = true;
    this._parser = new $a944d1fd254584c5$exports(options);
    this._parser.on('error', this.emit.bind(this, 'error'));
    this._parser.on('close', this._handleClose.bind(this));
    this._parser.on('metadata', this._metadata.bind(this));
    this._parser.on('gamma', this._gamma.bind(this));
    this._parser.on('parsed', (function(data) {
        this.data = data;
        this.emit('parsed', data);
    }).bind(this));
    this._packer = new $6dfa457ed5b39b96$exports(options);
    this._packer.on('data', this.emit.bind(this, 'data'));
    this._packer.on('end', this.emit.bind(this, 'end'));
    this._parser.on('close', this._handleClose.bind(this));
    this._packer.on('error', this.emit.bind(this, 'error'));
};
$hHIjR.inherits($4acb61a97e3722f6$var$PNG, $2C97X);
$4acb61a97e3722f6$var$PNG.sync = $f70732e6f757cf21$exports;
$4acb61a97e3722f6$var$PNG.prototype.pack = function() {
    if (!this.data || !this.data.length) {
        this.emit('error', 'No data provided');
        return this;
    }
    $5XqL3.nextTick((function() {
        this._packer.pack(this.data, this.width, this.height, this.gamma);
    }).bind(this));
    return this;
};
$4acb61a97e3722f6$var$PNG.prototype.parse = function(data, callback) {
    if (callback) {
        var onParsed, onError;
        onParsed = (function(parsedData) {
            this.removeListener('error', onError);
            this.data = parsedData;
            callback(null, this);
        }).bind(this);
        onError = (function(err) {
            this.removeListener('parsed', onParsed);
            callback(err, null);
        }).bind(this);
        this.once('parsed', onParsed);
        this.once('error', onError);
    }
    this.end(data);
    return this;
};
$4acb61a97e3722f6$var$PNG.prototype.write = function(data) {
    this._parser.write(data);
    return true;
};
$4acb61a97e3722f6$var$PNG.prototype.end = function(data) {
    this._parser.end(data);
};
$4acb61a97e3722f6$var$PNG.prototype._metadata = function(metadata) {
    this.width = metadata.width;
    this.height = metadata.height;
    this.emit('metadata', metadata);
};
$4acb61a97e3722f6$var$PNG.prototype._gamma = function(gamma) {
    this.gamma = gamma;
};
$4acb61a97e3722f6$var$PNG.prototype._handleClose = function() {
    if (!this._parser.writable && !this._packer.readable) this.emit('close');
};
$4acb61a97e3722f6$var$PNG.bitblt = function(src, dst, srcX, srcY, width, height, deltaX, deltaY) {
    // coerce pixel dimensions to integers (also coerces undefined -> 0):
    /* eslint-disable no-param-reassign */ srcX |= 0;
    srcY |= 0;
    width |= 0;
    height |= 0;
    deltaX |= 0;
    deltaY |= 0;
    /* eslint-enable no-param-reassign */ if (srcX > src.width || srcY > src.height || srcX + width > src.width || srcY + height > src.height) throw new Error('bitblt reading outside image');
    if (deltaX > dst.width || deltaY > dst.height || deltaX + width > dst.width || deltaY + height > dst.height) throw new Error('bitblt writing outside image');
    for(var y = 0; y < height; y++)src.data.copy(dst.data, (deltaY + y) * dst.width + deltaX << 2, (srcY + y) * src.width + srcX << 2, (srcY + y) * src.width + srcX + width << 2);
};
$4acb61a97e3722f6$var$PNG.prototype.bitblt = function(dst, srcX, srcY, width, height, deltaX, deltaY) {
    $4acb61a97e3722f6$var$PNG.bitblt(this, dst, srcX, srcY, width, height, deltaX, deltaY);
    return this;
};
$4acb61a97e3722f6$var$PNG.adjustGamma = function(src) {
    if (src.gamma) {
        for(var y = 0; y < src.height; y++)for(var x = 0; x < src.width; x++){
            var idx = src.width * y + x << 2;
            for(var i = 0; i < 3; i++){
                var sample = src.data[idx + i] / 255;
                sample = Math.pow(sample, 1 / 2.2 / src.gamma);
                src.data[idx + i] = Math.round(sample * 255);
            }
        }
        src.gamma = 0;
    }
};
$4acb61a97e3722f6$var$PNG.prototype.adjustGamma = function() {
    $4acb61a97e3722f6$var$PNG.adjustGamma(this);
};


var $203bba2ce8792506$require$PNG = $4acb61a97e3722f6$export$1f536085c24cc947;
var $70f869cabaf8cc1b$exports = {};

var $1etvo = parcelRequire("1etvo");
var $bacfbddf0ee3c8f8$exports = {};

$bacfbddf0ee3c8f8$exports = (parcelRequire("e2AP9"))();


const $70f869cabaf8cc1b$var$uint8ArrayUtf8ByteString = (array, start, end)=>{
    return String.fromCharCode(...array.slice(start, end));
};
// brands explained: https://github.com/strukturag/libheif/issues/83
// code adapted from: https://github.com/sindresorhus/file-type/blob/6f901bd82b849a85ca4ddba9c9a4baacece63d31/core.js#L428-L438
const $70f869cabaf8cc1b$var$isHeic = (buffer)=>{
    const brandMajor = $70f869cabaf8cc1b$var$uint8ArrayUtf8ByteString(buffer, 8, 12).replace('\0', ' ').trim();
    switch(brandMajor){
        case 'mif1':
            return true; // {ext: 'heic', mime: 'image/heif'};
        case 'msf1':
            return true; // {ext: 'heic', mime: 'image/heif-sequence'};
        case 'heic':
        case 'heix':
            return true; // {ext: 'heic', mime: 'image/heic'};
        case 'hevc':
        case 'hevx':
            return true; // {ext: 'heic', mime: 'image/heic-sequence'};
    }
    return false;
};
const $70f869cabaf8cc1b$var$decodeImage = (image)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const width = image.get_width();
        const height = image.get_height();
        const arrayBuffer = yield new Promise((resolve, reject)=>{
            image.display({
                data: new Uint8ClampedArray(width * height * 4),
                width: width,
                height: height
            }, (displayData)=>{
                if (!displayData) return reject(new Error('HEIF processing error'));
                // get the ArrayBuffer from the Uint8Array
                resolve(displayData.data.buffer);
            });
        });
        return {
            width: width,
            height: height,
            data: arrayBuffer
        };
    })();
const $70f869cabaf8cc1b$var$decodeBuffer = ({ buffer: buffer, all: all })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        if (!$70f869cabaf8cc1b$var$isHeic(buffer)) throw new TypeError('input buffer is not a HEIC image');
        const decoder = new $bacfbddf0ee3c8f8$exports.HeifDecoder();
        const data = decoder.decode(buffer);
        if (!data.length) throw new Error('HEIF image not found');
        if (!all) return yield $70f869cabaf8cc1b$var$decodeImage(data[0]);
        return data.map((image)=>{
            return {
                decode: ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        return yield $70f869cabaf8cc1b$var$decodeImage(image);
                    })()
            };
        });
    })();
$70f869cabaf8cc1b$exports = ({ buffer: buffer })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        return yield $70f869cabaf8cc1b$var$decodeBuffer({
            buffer: buffer,
            all: false
        });
    })();
$70f869cabaf8cc1b$exports.all = ({ buffer: buffer })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        return yield $70f869cabaf8cc1b$var$decodeBuffer({
            buffer: buffer,
            all: true
        });
    })();


const $203bba2ce8792506$var$to = {
    JPEG: ({ data: data, width: width, height: height, quality: quality })=>$c0b535f73fd0ccc6$exports.encode({
            data: data,
            width: width,
            height: height
        }, quality).data,
    PNG: ({ data: data, width: width, height: height })=>{
        const png = new $203bba2ce8792506$require$PNG({
            width: width,
            height: height
        });
        png.data = data;
        return $203bba2ce8792506$require$PNG.sync.write(png, {
            width: width,
            height: height,
            deflateLevel: 9,
            deflateStrategy: 3,
            filterType: -1,
            colorType: 6,
            inputHasAlpha: true
        });
    }
};
const $203bba2ce8792506$var$convertImage = ({ image: image, format: format, quality: quality })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        return yield $203bba2ce8792506$var$to[format]({
            width: image.width,
            height: image.height,
            data: $203bba2ce8792506$require$Buffer.from(image.data),
            quality: Math.floor(quality * 100)
        });
    })();
const $203bba2ce8792506$var$convert = ({ buffer: buffer, format: format, quality: quality, all: all })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        if (!$203bba2ce8792506$var$to[format]) throw new Error(`output format needs to be one of [${Object.keys($203bba2ce8792506$var$to)}]`);
        if (!all) {
            const image = yield $70f869cabaf8cc1b$exports({
                buffer: buffer
            });
            return yield $203bba2ce8792506$var$convertImage({
                image: image,
                format: format,
                quality: quality
            });
        }
        const images = yield $70f869cabaf8cc1b$exports.all({
            buffer: buffer
        });
        return images.map((image)=>{
            return {
                convert: ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        return yield $203bba2ce8792506$var$convertImage({
                            image: yield image.decode(),
                            format: format,
                            quality: quality
                        });
                    })()
            };
        });
    })();
$203bba2ce8792506$exports = ({ buffer: buffer, format: format, quality: quality = 0.92 })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        return yield $203bba2ce8792506$var$convert({
            buffer: buffer,
            format: format,
            quality: quality,
            all: false
        });
    })();
$203bba2ce8792506$exports.all = ({ buffer: buffer, format: format, quality: quality = 0.92 })=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        return yield $203bba2ce8792506$var$convert({
            buffer: buffer,
            format: format,
            quality: quality,
            all: true
        });
    })();


if (!Promise.withResolvers) Promise.withResolvers = function() {
    let resolve, reject;
    const promise = new Promise((res, rej)=>{
        resolve = res;
        reject = rej;
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
};
$ajWU5.GlobalWorkerOptions.workerSrc = (0, (/*@__PURE__*/$parcel$interopDefault($0bf20c284735f0ff$exports)));
window.fontCache = window.fontCache || {}; // フォントキャッシュをグローバルスコープに定義
const $fb4c7c5aada7368a$export$3306ededec248893 = window.fontCache; // 既存のコードとの互換性のために参照を保持
const $fb4c7c5aada7368a$export$729c8b7179294ba = document.getElementById('app');
const $fb4c7c5aada7368a$export$63950c2525d2f62b = document.getElementById('loadingOverlay');
let $fb4c7c5aada7368a$export$ca26e1dd869a40e = null;
let $fb4c7c5aada7368a$export$4b1af53a3b1595e3 = {
    width: 595.28,
    height: 841.89
}; // A4のデフォルト値(pt)
let $fb4c7c5aada7368a$export$eba19cacbe4413 = []; // [{ file: File, previewUrl: string, pdfEmbedBytes: ArrayBuffer, pdfEmbedType: string, aspectRatio: number }]
let $fb4c7c5aada7368a$export$ac139a6b71f5ce7f = null; // 処理済みPDFのバイトデータを保持
let $fb4c7c5aada7368a$export$9108de792d9756a9 = 1; // カルーセルで選択されたページ番号
let $fb4c7c5aada7368a$export$35a17b9c20c01f8b = null; // PDFドキュメントインスタンスをキャッシュ
const $fb4c7c5aada7368a$export$d16800b7e59a8051 = (id)=>document.getElementById(id);
const $fb4c7c5aada7368a$export$b538fd7a9cc7f22b = (file)=>{
    $fb4c7c5aada7368a$export$ca26e1dd869a40e = file;
};
const $fb4c7c5aada7368a$export$725f9d85e8117bbe = (size)=>{
    $fb4c7c5aada7368a$export$4b1af53a3b1595e3 = size;
};
const $fb4c7c5aada7368a$export$7ec495ac665155d4 = (files)=>{
    $fb4c7c5aada7368a$export$eba19cacbe4413 = files;
};
const $fb4c7c5aada7368a$export$73192c261dae2ece = (bytes)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        $fb4c7c5aada7368a$export$ac139a6b71f5ce7f = bytes;
        if (bytes) {
            const loadingTask = $ajWU5.getDocument({
                data: $fb4c7c5aada7368a$export$ac139a6b71f5ce7f.slice(0)
            });
            const pdf = yield loadingTask.promise;
            $fb4c7c5aada7368a$export$6fa298e0c95c9ddf(pdf);
        } else $fb4c7c5aada7368a$export$6fa298e0c95c9ddf(null);
    })();
const $fb4c7c5aada7368a$export$70aa06bd6f3c73dc = (page)=>{
    $fb4c7c5aada7368a$export$9108de792d9756a9 = page;
};
const $fb4c7c5aada7368a$export$6fa298e0c95c9ddf = (instance)=>{
    $fb4c7c5aada7368a$export$35a17b9c20c01f8b = instance;
}; // Setter関数を追加
// 共通のPDFページレンダリング関数
function $fb4c7c5aada7368a$var$renderPdfPages(pdf, pdfPreviewContainer, firstViewport) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        // PDF選択後にjustify-contentをflex-startに変更
        pdfPreviewContainer.style.justifyContent = 'flex-start';
        // PDFプレビューコンテナのスタイルを動的に設定
        // コンテナの幅に基づいて高さを計算し、アスペクト比を維持
        const containerWidth = pdfPreviewContainer.clientWidth;
        const calculatedHeight = containerWidth / (firstViewport.width / firstViewport.height);
        pdfPreviewContainer.style.height = `${calculatedHeight}px`;
        pdfPreviewContainer.style.aspectRatio = `${firstViewport.width} / ${firstViewport.height}`;
        // すべてのページをレンダリング
        for(let i = 1; i <= pdf.numPages; i++){
            const page = yield pdf.getPage(i);
            const viewport = page.getViewport({
                scale: 1
            });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            // コンテナの幅に合わせてスケールを調整
            const scale = containerWidth / viewport.width;
            const scaledViewport = page.getViewport({
                scale: scale
            });
            canvas.height = scaledViewport.height;
            canvas.width = scaledViewport.width;
            canvas.classList.add('pdf-preview-canvas'); // スタイル適用のためクラスを追加
            pdfPreviewContainer.appendChild(canvas);
            const renderContext = {
                canvasContext: context,
                viewport: scaledViewport
            };
            yield page.render(renderContext).promise;
        }
    })();
}
function $fb4c7c5aada7368a$export$51cb8b3d5d1d2fee(file) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const pdfPreviewContainer = $fb4c7c5aada7368a$export$d16800b7e59a8051('pdfPreviewContainer');
        if (!pdfPreviewContainer) return;
        if (!file) {
            pdfPreviewContainer.innerHTML = "<p>PDF\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>";
            return;
        }
        pdfPreviewContainer.innerHTML = ''; // 既存のコンテンツをクリア
        const reader = new FileReader();
        reader.onload = (e)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                if (e.target && e.target.result) {
                    const pdfData = new Uint8Array(e.target.result);
                    try {
                        const loadingTask = $ajWU5.getDocument({
                            data: pdfData.slice(0)
                        });
                        const pdf = yield loadingTask.promise;
                        // 最初のページのサイズを取得して設定
                        const firstPage = yield pdf.getPage(1);
                        const firstViewport = firstPage.getViewport({
                            scale: 1
                        });
                        $fb4c7c5aada7368a$export$725f9d85e8117bbe({
                            width: firstViewport.width,
                            height: firstViewport.height
                        });
                        yield $fb4c7c5aada7368a$var$renderPdfPages(pdf, pdfPreviewContainer, firstViewport);
                    // コンテナのアスペクト比は最初のページに合わせて設定 (不要になったため削除)
                    // pdfPreviewContainer.style.paddingBottom = `${(firstViewport.height / firstViewport.width) * 100}%`;
                    } catch (error) {
                        console.error("PDF\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0\u306B\u5931\u6557\u3057\u307E\u3057\u305F:", error);
                        pdfPreviewContainer.innerHTML = "<p>PDF\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u8868\u793A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002</p>";
                    }
                }
            })();
        reader.readAsArrayBuffer(file);
    })();
}
function $fb4c7c5aada7368a$export$708ba2836d544b94(pdfBytes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const pdfPreviewContainer = $fb4c7c5aada7368a$export$d16800b7e59a8051('pdfPreviewContainer');
        const downloadLink = $fb4c7c5aada7368a$export$d16800b7e59a8051('downloadLink');
        if (!pdfPreviewContainer || !downloadLink) return;
        pdfPreviewContainer.innerHTML = ''; // 既存のコンテンツをクリア
        const blob = new Blob([
            pdfBytes
        ], {
            type: 'application/pdf'
        });
        const url = URL.createObjectURL(blob);
        try {
            const loadingTask = $ajWU5.getDocument({
                data: pdfBytes.slice(0)
            });
            const pdf = yield loadingTask.promise;
            const firstPage = yield pdf.getPage(1);
            const firstViewport = firstPage.getViewport({
                scale: 1
            });
            yield $fb4c7c5aada7368a$var$renderPdfPages(pdf, pdfPreviewContainer, firstViewport);
            downloadLink.href = url;
            downloadLink.download = 'modified.pdf';
            downloadLink.style.display = 'block';
        } catch (error) {
            console.error("\u51E6\u7406\u6E08\u307FPDF\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0\u306B\u5931\u6557\u3057\u307E\u3057\u305F:", error);
            pdfPreviewContainer.innerHTML = "<p>\u51E6\u7406\u6E08\u307FPDF\u30D7\u30EC\u30D3\u30E5\u30FC\u306E\u8868\u793A\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002</p>";
        }
    })();
}
function $fb4c7c5aada7368a$export$ae150752c2ffc03c(numImages, pageWidth, pageHeight, marginTop, marginBottom, marginLeft, marginRight, imageSpacing, userColumns, imageAspectRatios, captionFontSizes, captionMarginTopBottom) {
    const placements = [];
    // Updated to use individual margins
    const usableWidth = pageWidth - marginLeft - marginRight;
    const usableHeight = pageHeight - marginTop - marginBottom;
    let bestCols = userColumns > 0 ? userColumns : 1;
    let bestRows = Math.ceil(numImages / bestCols);
    if (userColumns === 0) {
        let currentBestArea = 0;
        for(let cols = 1; cols <= numImages; cols++){
            const rows = Math.ceil(numImages / cols);
            // Use usableWidth and usableHeight for grid cell calculation
            const gridCellWidth = usableWidth / cols;
            const gridCellHeight = usableHeight / rows;
            const blockUsableWidth = gridCellWidth - imageSpacing;
            const blockUsableHeight = gridCellHeight - imageSpacing;
            if (blockUsableWidth <= 0 || blockUsableHeight <= 0) continue;
            let allImagesFit = true;
            const maxCaptionFontSize = Math.max(...captionFontSizes);
            const captionHeightWithSpacingForTest = maxCaptionFontSize + captionMarginTopBottom * 2;
            for (const aspectRatio of imageAspectRatios){
                const imageOnlyUsableHeight = blockUsableHeight - captionHeightWithSpacingForTest;
                if (imageOnlyUsableHeight <= 0) {
                    allImagesFit = false;
                    break;
                }
                let currentImgWidth = blockUsableWidth;
                let currentImgHeight = blockUsableWidth / aspectRatio;
                if (currentImgHeight > imageOnlyUsableHeight) {
                    currentImgHeight = imageOnlyUsableHeight;
                    currentImgWidth = imageOnlyUsableHeight * aspectRatio;
                }
                if (currentImgWidth > blockUsableWidth || currentImgHeight > imageOnlyUsableHeight) {
                    allImagesFit = false;
                    break;
                }
            }
            if (allImagesFit) {
                if (blockUsableWidth * blockUsableHeight > currentBestArea) {
                    currentBestArea = blockUsableWidth * blockUsableHeight;
                    bestCols = cols;
                    bestRows = rows;
                }
            }
        }
    }
    if (bestCols === 0 || bestRows === 0) return null;
    // Use usableWidth and usableHeight for grid cell calculation
    const gridCellWidth = usableWidth / bestCols;
    const gridCellHeight = usableHeight / bestRows;
    const blockUsableWidth = gridCellWidth - imageSpacing;
    const blockUsableHeight = gridCellHeight - imageSpacing;
    if (blockUsableWidth <= 0 || blockUsableHeight <= 0) return null;
    for(let i = 0; i < numImages; i++){
        const col = i % bestCols;
        const row = Math.floor(i / bestCols);
        const aspectRatio = imageAspectRatios[i];
        const currentCaptionFontSize = captionFontSizes[i];
        const captionHeightWithSpacing = currentCaptionFontSize + captionMarginTopBottom * 2;
        const imageOnlyUsableHeight = blockUsableHeight - captionHeightWithSpacing;
        let imgWidth = blockUsableWidth;
        let imgHeight = blockUsableWidth / aspectRatio;
        if (imgHeight > imageOnlyUsableHeight) {
            imgHeight = imageOnlyUsableHeight;
            imgWidth = imageOnlyUsableHeight * aspectRatio;
        }
        const totalBlockHeight = imgHeight + captionHeightWithSpacing;
        const blockXOffset = (blockUsableWidth - imgWidth) / 2;
        const blockYOffset = (blockUsableHeight - totalBlockHeight) / 2;
        // Updated to use individual margins for positioning
        const imageX = marginLeft + col * gridCellWidth + blockXOffset;
        const imageY_realtime = marginTop + row * gridCellHeight + blockYOffset;
        const imageBottomY_pdf = pageHeight - (imageY_realtime + imgHeight);
        const captionX = imageX;
        const captionY_realtime = imageY_realtime + imgHeight + captionMarginTopBottom;
        const captionY_pdf = pageHeight - (captionY_realtime + currentCaptionFontSize);
        placements.push({
            image: {
                x: imageX,
                y_pdf: imageBottomY_pdf,
                y_realtime: imageY_realtime,
                width: imgWidth,
                height: imgHeight
            },
            caption: {
                x: captionX,
                y_pdf: captionY_pdf,
                y_realtime: captionY_realtime,
                width: imgWidth,
                height: currentCaptionFontSize
            }
        });
    }
    return placements;
}
function $fb4c7c5aada7368a$export$313a8a6b1cb8b92() {
    const realtimePreviewContainer = $fb4c7c5aada7368a$export$d16800b7e59a8051('realtimePreviewContainer');
    if (!realtimePreviewContainer) return;
    console.log("updateRealtimePreview: \u30EA\u30A2\u30EB\u30BF\u30A4\u30E0\u30D7\u30EC\u30D3\u30E5\u30FC\u66F4\u65B0\u95A2\u6570\u304C\u547C\u3073\u51FA\u3055\u308C\u307E\u3057\u305F\u3002");
    const images = realtimePreviewContainer.querySelectorAll('.realtime-preview-image');
    images.forEach((img)=>img.remove());
    const captions = realtimePreviewContainer.querySelectorAll('.realtime-preview-caption');
    captions.forEach((caption)=>caption.remove());
    const message = realtimePreviewContainer.querySelector('p');
    if (message) message.remove();
    const existingMarginGuide = realtimePreviewContainer.querySelector('.page-margin-guide');
    if (existingMarginGuide) existingMarginGuide.remove();
    if ($fb4c7c5aada7368a$export$eba19cacbe4413.length === 0) {
        if (!$fb4c7c5aada7368a$export$ca26e1dd869a40e) realtimePreviewContainer.innerHTML = "<p>\u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3059\u308B\u3068\u3053\u3053\u306B\u30D7\u30EC\u30D3\u30E5\u30FC\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002</p>";
        console.log("updateRealtimePreview: \u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002");
        return;
    }
    const previewContainerWidth = realtimePreviewContainer.clientWidth;
    const { width: pageWidth, height: pageHeight } = $fb4c7c5aada7368a$export$4b1af53a3b1595e3;
    const scale = previewContainerWidth / pageWidth;
    // Get individual margin values from DOM elements
    const pageMarginTopNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('pageMarginTopNumber');
    const pageMarginBottomNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('pageMarginBottomNumber');
    const pageMarginLeftNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('pageMarginLeftNumber');
    const pageMarginRightNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('pageMarginRightNumber');
    const marginTop = parseInt(pageMarginTopNumber.value) || 0;
    const marginBottom = parseInt(pageMarginBottomNumber.value) || 0;
    const marginLeft = parseInt(pageMarginLeftNumber.value) || 0;
    const marginRight = parseInt(pageMarginRightNumber.value) || 0;
    const imageSpacingNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('imageSpacingNumber');
    const columnsNumber = $fb4c7c5aada7368a$export$d16800b7e59a8051('columnsNumber');
    if (!imageSpacingNumber || !columnsNumber) return;
    const imageSpacing = parseInt(imageSpacingNumber.value) || 0;
    const userColumns = parseInt(columnsNumber.value) || 0;
    const pageMarginGuide = document.createElement('div');
    pageMarginGuide.classList.add('page-margin-guide');
    pageMarginGuide.style.left = `${marginLeft * scale}px`; // Use marginLeft
    pageMarginGuide.style.top = `${marginTop * scale}px`; // Use marginTop
    pageMarginGuide.style.width = `${(pageWidth - marginLeft - marginRight) * scale}px`; // Use marginLeft and marginRight
    pageMarginGuide.style.height = `${(pageHeight - marginTop - marginBottom) * scale}px`; // Use marginTop and marginBottom
    realtimePreviewContainer.appendChild(pageMarginGuide);
    const numImages = $fb4c7c5aada7368a$export$eba19cacbe4413.length;
    const imageAspectRatios = $fb4c7c5aada7368a$export$eba19cacbe4413.map((img)=>img.aspectRatio);
    const captionFontSizes = $fb4c7c5aada7368a$export$eba19cacbe4413.map((img)=>img.captionFontSize || 10);
    const captionMarginTopBottom = 5;
    // Pass individual margins to calculateImagePlacements
    const placements = $fb4c7c5aada7368a$export$ae150752c2ffc03c(numImages, pageWidth, pageHeight, marginTop, marginBottom, marginLeft, marginRight, imageSpacing, userColumns, imageAspectRatios, captionFontSizes, captionMarginTopBottom);
    if (!placements) {
        realtimePreviewContainer.innerHTML = "<p>\u753B\u50CF\u3092\u914D\u7F6E\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002</p>";
        console.log("updateRealtimePreview: \u753B\u50CF\u914D\u7F6E\u8A08\u7B97\u5931\u6557\u3002");
        return;
    }
    $fb4c7c5aada7368a$export$eba19cacbe4413.forEach((imageObj, i)=>{
        const placement = placements[i];
        const imgElement = document.createElement('img');
        imgElement.src = imageObj.previewUrl;
        imgElement.classList.add('realtime-preview-image');
        imgElement.style.left = `${placement.image.x * scale}px`;
        imgElement.style.top = `${placement.image.y_realtime * scale}px`;
        imgElement.style.width = `${placement.image.width * scale}px`;
        imgElement.style.height = `${placement.image.height * scale}px`;
        realtimePreviewContainer.appendChild(imgElement);
        if (imageObj.caption) {
            const captionElement = document.createElement('div');
            captionElement.classList.add('realtime-preview-caption');
            captionElement.textContent = imageObj.caption;
            captionElement.style.fontSize = `${placement.caption.height * scale}px`;
            captionElement.style.left = `${(placement.image.x + placement.image.width / 2) * scale}px`;
            captionElement.style.transform = `translateX(-50%)`;
            captionElement.style.top = `${placement.caption.y_realtime * scale}px`;
            captionElement.style.width = `auto`;
            captionElement.style.textAlign = 'center';
            captionElement.style.whiteSpace = 'normal';
            captionElement.style.overflow = 'visible';
            captionElement.style.textOverflow = 'clip';
            captionElement.style.color = imageObj.captionFontColor || '#000000';
            captionElement.style.fontFamily = imageObj.captionFontFamily || 'Helvetica';
            realtimePreviewContainer.appendChild(captionElement);
        }
    });
}



var $1etvo = parcelRequire("1etvo");
var $c4c3496a922e0fe8$exports = {};
$parcel$export($c4c3496a922e0fe8$exports, "PDFDocument", function () { return $c8198d59b2f6ab16$export$2e2bcd8739ae039; });
$parcel$export($c4c3496a922e0fe8$exports, "rgb", function () { return $883da9eab467c3c8$export$8972dc0e6ad9238f; });
$parcel$export($c4c3496a922e0fe8$exports, "StandardFonts", function () { return $3f3628f4443054b9$export$7dcb046109e65a3d; });

var $70JnX = parcelRequire("70JnX");

var $70JnX = parcelRequire("70JnX");
parcelRequire("1jVcF");

var $lJYRg = parcelRequire("lJYRg");

var $70JnX = parcelRequire("70JnX");

var $czuCz = parcelRequire("czuCz");

var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $f5613438da36c90d$var$PDFHeader = /** @class */ function() {
    function PDFHeader(major, minor) {
        this.major = String(major);
        this.minor = String(minor);
    }
    PDFHeader.prototype.toString = function() {
        var bc = (0, $c6a2W.charFromCode)(129);
        return "%PDF-" + this.major + "." + this.minor + "\n%" + bc + bc + bc + bc;
    };
    PDFHeader.prototype.sizeInBytes = function() {
        return 12 + this.major.length + this.minor.length;
    };
    PDFHeader.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).Percent;
        buffer[offset++] = (0, $lJYRg.default).P;
        buffer[offset++] = (0, $lJYRg.default).D;
        buffer[offset++] = (0, $lJYRg.default).F;
        buffer[offset++] = (0, $lJYRg.default).Dash;
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.major, buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).Period;
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.minor, buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).Newline;
        buffer[offset++] = (0, $lJYRg.default).Percent;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        buffer[offset++] = 129;
        return offset - initialOffset;
    };
    PDFHeader.forVersion = function(major, minor) {
        return new PDFHeader(major, minor);
    };
    return PDFHeader;
}();
var $f5613438da36c90d$export$2e2bcd8739ae039 = $f5613438da36c90d$var$PDFHeader;



var $1jVcF = parcelRequire("1jVcF");

var $cUVc9 = parcelRequire("cUVc9");

var $gxKrW = parcelRequire("gxKrW");

var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");

var $70JnX = parcelRequire("70JnX");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
var $92faf6a1e2d86453$var$PDFNull = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFNull, _super);
    function PDFNull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFNull.prototype.asNull = function() {
        return null;
    };
    PDFNull.prototype.clone = function() {
        return this;
    };
    PDFNull.prototype.toString = function() {
        return 'null';
    };
    PDFNull.prototype.sizeInBytes = function() {
        return 4;
    };
    PDFNull.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $lJYRg.default).n;
        buffer[offset++] = (0, $lJYRg.default).u;
        buffer[offset++] = (0, $lJYRg.default).l;
        buffer[offset++] = (0, $lJYRg.default).l;
        return 4;
    };
    return PDFNull;
}((0, $iyqEO.default));
var $92faf6a1e2d86453$export$2e2bcd8739ae039 = new $92faf6a1e2d86453$var$PDFNull();



var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
var $a128f87a2ae876f3$var$PDFDict = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFDict, _super);
    function PDFDict(map, context) {
        var _this = _super.call(this) || this;
        _this.dict = map;
        _this.context = context;
        return _this;
    }
    PDFDict.prototype.keys = function() {
        return Array.from(this.dict.keys());
    };
    PDFDict.prototype.values = function() {
        return Array.from(this.dict.values());
    };
    PDFDict.prototype.entries = function() {
        return Array.from(this.dict.entries());
    };
    PDFDict.prototype.set = function(key, value) {
        this.dict.set(key, value);
    };
    PDFDict.prototype.get = function(key, // TODO: `preservePDFNull` is for backwards compatibility. Should be
    // removed in next breaking API change.
    preservePDFNull) {
        if (preservePDFNull === void 0) preservePDFNull = false;
        var value = this.dict.get(key);
        if (value === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.has = function(key) {
        var value = this.dict.get(key);
        return value !== undefined && value !== (0, $92faf6a1e2d86453$export$2e2bcd8739ae039);
    };
    PDFDict.prototype.lookupMaybe = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $92faf6a1e2d86453$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookupMaybe.apply(_a, (0, $70JnX.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.lookup = function(key) {
        var _a;
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $92faf6a1e2d86453$export$2e2bcd8739ae039));
        var value = (_a = this.context).lookup.apply(_a, (0, $70JnX.__spreadArrays)([
            this.get(key, preservePDFNull)
        ], types));
        if (value === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        return value;
    };
    PDFDict.prototype.delete = function(key) {
        return this.dict.delete(key);
    };
    PDFDict.prototype.asMap = function() {
        return new Map(this.dict);
    };
    /** Generate a random key that doesn't exist in current key set */ PDFDict.prototype.uniqueKey = function(tag) {
        if (tag === void 0) tag = '';
        var existingKeys = this.keys();
        var key = (0, $btXS2.default).of(this.context.addRandomSuffix(tag, 10));
        while(existingKeys.includes(key))key = (0, $btXS2.default).of(this.context.addRandomSuffix(tag, 10));
        return key;
    };
    PDFDict.prototype.clone = function(context) {
        var clone = PDFDict.withContext(context || this.context);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFDict.prototype.toString = function() {
        var dictString = '<<\n';
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            dictString += key.toString() + ' ' + value.toString() + '\n';
        }
        dictString += '>>';
        return dictString;
    };
    PDFDict.prototype.sizeInBytes = function() {
        var size = 5;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            size += key.sizeInBytes() + value.sizeInBytes() + 2;
        }
        return size;
    };
    PDFDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).LessThan;
        buffer[offset++] = (0, $lJYRg.default).LessThan;
        buffer[offset++] = (0, $lJYRg.default).Newline;
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            offset += key.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
            offset += value.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Newline;
        }
        buffer[offset++] = (0, $lJYRg.default).GreaterThan;
        buffer[offset++] = (0, $lJYRg.default).GreaterThan;
        return offset - initialOffset;
    };
    PDFDict.withContext = function(context) {
        return new PDFDict(new Map(), context);
    };
    PDFDict.fromMapWithContext = function(map, context) {
        return new PDFDict(map, context);
    };
    return PDFDict;
}((0, $iyqEO.default));
var $a128f87a2ae876f3$export$2e2bcd8739ae039 = $a128f87a2ae876f3$var$PDFDict;



var $btXS2 = parcelRequire("btXS2");


var $8LDYe = parcelRequire("8LDYe");

var $iyqEO = parcelRequire("iyqEO");

var $70JnX = parcelRequire("70JnX");

var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
var $cdfe10fee47b0c90$var$PDFStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFStream, _super);
    function PDFStream(dict) {
        var _this = _super.call(this) || this;
        _this.dict = dict;
        return _this;
    }
    PDFStream.prototype.clone = function(_context) {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'clone');
    };
    PDFStream.prototype.getContentsString = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'getContentsString');
    };
    PDFStream.prototype.getContents = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'getContents');
    };
    PDFStream.prototype.getContentsSize = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'getContentsSize');
    };
    PDFStream.prototype.updateDict = function() {
        var contentsSize = this.getContentsSize();
        this.dict.set((0, $btXS2.default).Length, (0, $8LDYe.default).of(contentsSize));
    };
    PDFStream.prototype.sizeInBytes = function() {
        this.updateDict();
        return this.dict.sizeInBytes() + this.getContentsSize() + 18;
    };
    PDFStream.prototype.toString = function() {
        this.updateDict();
        var streamString = this.dict.toString();
        streamString += '\nstream\n';
        streamString += this.getContentsString();
        streamString += '\nendstream';
        return streamString;
    };
    PDFStream.prototype.copyBytesInto = function(buffer, offset) {
        this.updateDict();
        var initialOffset = offset;
        offset += this.dict.copyBytesInto(buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).Newline;
        buffer[offset++] = (0, $lJYRg.default).s;
        buffer[offset++] = (0, $lJYRg.default).t;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).a;
        buffer[offset++] = (0, $lJYRg.default).m;
        buffer[offset++] = (0, $lJYRg.default).Newline;
        var contents = this.getContents();
        for(var idx = 0, len = contents.length; idx < len; idx++)buffer[offset++] = contents[idx];
        buffer[offset++] = (0, $lJYRg.default).Newline;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).n;
        buffer[offset++] = (0, $lJYRg.default).d;
        buffer[offset++] = (0, $lJYRg.default).s;
        buffer[offset++] = (0, $lJYRg.default).t;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).a;
        buffer[offset++] = (0, $lJYRg.default).m;
        return offset - initialOffset;
    };
    return PDFStream;
}((0, $iyqEO.default));
var $cdfe10fee47b0c90$export$2e2bcd8739ae039 = $cdfe10fee47b0c90$var$PDFStream;


parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
var $d814c40cb5e196cb$var$PDFRawStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFRawStream, _super);
    function PDFRawStream(dict, contents) {
        var _this = _super.call(this, dict) || this;
        _this.contents = contents;
        return _this;
    }
    PDFRawStream.prototype.asUint8Array = function() {
        return this.contents.slice();
    };
    PDFRawStream.prototype.clone = function(context) {
        return PDFRawStream.of(this.dict.clone(context), this.contents.slice());
    };
    PDFRawStream.prototype.getContentsString = function() {
        return (0, $9uJGW.arrayAsString)(this.contents);
    };
    PDFRawStream.prototype.getContents = function() {
        return this.contents;
    };
    PDFRawStream.prototype.getContentsSize = function() {
        return this.contents.length;
    };
    PDFRawStream.of = function(dict, contents) {
        return new PDFRawStream(dict, contents);
    };
    return PDFRawStream;
}((0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
var $d814c40cb5e196cb$export$2e2bcd8739ae039 = $d814c40cb5e196cb$var$PDFRawStream;



var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $iyqEO = parcelRequire("iyqEO");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $d2803e164f1400b0$var$ENFORCER = {};
var $d2803e164f1400b0$var$pool = new Map();
var $d2803e164f1400b0$var$PDFRef = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFRef, _super);
    function PDFRef(enforcer, objectNumber, generationNumber) {
        var _this = this;
        if (enforcer !== $d2803e164f1400b0$var$ENFORCER) throw new (0, $1jVcF.PrivateConstructorError)('PDFRef');
        _this = _super.call(this) || this;
        _this.objectNumber = objectNumber;
        _this.generationNumber = generationNumber;
        _this.tag = objectNumber + " " + generationNumber + " R";
        return _this;
    }
    PDFRef.prototype.clone = function() {
        return this;
    };
    PDFRef.prototype.toString = function() {
        return this.tag;
    };
    PDFRef.prototype.sizeInBytes = function() {
        return this.tag.length;
    };
    PDFRef.prototype.copyBytesInto = function(buffer, offset) {
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.tag, buffer, offset);
        return this.tag.length;
    };
    PDFRef.of = function(objectNumber, generationNumber) {
        if (generationNumber === void 0) generationNumber = 0;
        var tag = objectNumber + " " + generationNumber + " R";
        var instance = $d2803e164f1400b0$var$pool.get(tag);
        if (!instance) {
            instance = new PDFRef($d2803e164f1400b0$var$ENFORCER, objectNumber, generationNumber);
            $d2803e164f1400b0$var$pool.set(tag, instance);
        }
        return instance;
    };
    return PDFRef;
}((0, $iyqEO.default));
var $d2803e164f1400b0$export$2e2bcd8739ae039 = $d2803e164f1400b0$var$PDFRef;



var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $0b9dd4dab9c74310$var$PDFOperator = /** @class */ function() {
    function PDFOperator(name, args) {
        this.name = name;
        this.args = args || [];
    }
    PDFOperator.prototype.clone = function(context) {
        var args = new Array(this.args.length);
        for(var idx = 0, len = args.length; idx < len; idx++){
            var arg = this.args[idx];
            args[idx] = arg instanceof (0, $iyqEO.default) ? arg.clone(context) : arg;
        }
        return PDFOperator.of(this.name, args);
    };
    PDFOperator.prototype.toString = function() {
        var value = '';
        for(var idx = 0, len = this.args.length; idx < len; idx++)value += String(this.args[idx]) + ' ';
        value += this.name;
        return value;
    };
    PDFOperator.prototype.sizeInBytes = function() {
        var size = 0;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            size += (arg instanceof (0, $iyqEO.default) ? arg.sizeInBytes() : arg.length) + 1;
        }
        size += this.name.length;
        return size;
    };
    PDFOperator.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        for(var idx = 0, len = this.args.length; idx < len; idx++){
            var arg = this.args[idx];
            if (arg instanceof (0, $iyqEO.default)) offset += arg.copyBytesInto(buffer, offset);
            else offset += (0, $c6a2W.copyStringIntoBuffer)(arg, buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
        }
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.name, buffer, offset);
        return offset - initialOffset;
    };
    PDFOperator.of = function(name, args) {
        return new PDFOperator(name, args);
    };
    return PDFOperator;
}();
var $0b9dd4dab9c74310$export$2e2bcd8739ae039 = $0b9dd4dab9c74310$var$PDFOperator;


var $1cc3dd00b8bf8e36$var$PDFOperatorNames;
(function(PDFOperatorNames) {
    // Non Stroking Color Operators
    PDFOperatorNames["NonStrokingColor"] = "sc";
    PDFOperatorNames["NonStrokingColorN"] = "scn";
    PDFOperatorNames["NonStrokingColorRgb"] = "rg";
    PDFOperatorNames["NonStrokingColorGray"] = "g";
    PDFOperatorNames["NonStrokingColorCmyk"] = "k";
    PDFOperatorNames["NonStrokingColorspace"] = "cs";
    // Stroking Color Operators
    PDFOperatorNames["StrokingColor"] = "SC";
    PDFOperatorNames["StrokingColorN"] = "SCN";
    PDFOperatorNames["StrokingColorRgb"] = "RG";
    PDFOperatorNames["StrokingColorGray"] = "G";
    PDFOperatorNames["StrokingColorCmyk"] = "K";
    PDFOperatorNames["StrokingColorspace"] = "CS";
    // Marked Content Operators
    PDFOperatorNames["BeginMarkedContentSequence"] = "BDC";
    PDFOperatorNames["BeginMarkedContent"] = "BMC";
    PDFOperatorNames["EndMarkedContent"] = "EMC";
    PDFOperatorNames["MarkedContentPointWithProps"] = "DP";
    PDFOperatorNames["MarkedContentPoint"] = "MP";
    PDFOperatorNames["DrawObject"] = "Do";
    // Graphics State Operators
    PDFOperatorNames["ConcatTransformationMatrix"] = "cm";
    PDFOperatorNames["PopGraphicsState"] = "Q";
    PDFOperatorNames["PushGraphicsState"] = "q";
    PDFOperatorNames["SetFlatness"] = "i";
    PDFOperatorNames["SetGraphicsStateParams"] = "gs";
    PDFOperatorNames["SetLineCapStyle"] = "J";
    PDFOperatorNames["SetLineDashPattern"] = "d";
    PDFOperatorNames["SetLineJoinStyle"] = "j";
    PDFOperatorNames["SetLineMiterLimit"] = "M";
    PDFOperatorNames["SetLineWidth"] = "w";
    PDFOperatorNames["SetTextMatrix"] = "Tm";
    PDFOperatorNames["SetRenderingIntent"] = "ri";
    // Graphics Operators
    PDFOperatorNames["AppendRectangle"] = "re";
    PDFOperatorNames["BeginInlineImage"] = "BI";
    PDFOperatorNames["BeginInlineImageData"] = "ID";
    PDFOperatorNames["EndInlineImage"] = "EI";
    PDFOperatorNames["ClipEvenOdd"] = "W*";
    PDFOperatorNames["ClipNonZero"] = "W";
    PDFOperatorNames["CloseAndStroke"] = "s";
    PDFOperatorNames["CloseFillEvenOddAndStroke"] = "b*";
    PDFOperatorNames["CloseFillNonZeroAndStroke"] = "b";
    PDFOperatorNames["ClosePath"] = "h";
    PDFOperatorNames["AppendBezierCurve"] = "c";
    PDFOperatorNames["CurveToReplicateFinalPoint"] = "y";
    PDFOperatorNames["CurveToReplicateInitialPoint"] = "v";
    PDFOperatorNames["EndPath"] = "n";
    PDFOperatorNames["FillEvenOddAndStroke"] = "B*";
    PDFOperatorNames["FillEvenOdd"] = "f*";
    PDFOperatorNames["FillNonZeroAndStroke"] = "B";
    PDFOperatorNames["FillNonZero"] = "f";
    PDFOperatorNames["LegacyFillNonZero"] = "F";
    PDFOperatorNames["LineTo"] = "l";
    PDFOperatorNames["MoveTo"] = "m";
    PDFOperatorNames["ShadingFill"] = "sh";
    PDFOperatorNames["StrokePath"] = "S";
    // Text Operators
    PDFOperatorNames["BeginText"] = "BT";
    PDFOperatorNames["EndText"] = "ET";
    PDFOperatorNames["MoveText"] = "Td";
    PDFOperatorNames["MoveTextSetLeading"] = "TD";
    PDFOperatorNames["NextLine"] = "T*";
    PDFOperatorNames["SetCharacterSpacing"] = "Tc";
    PDFOperatorNames["SetFontAndSize"] = "Tf";
    PDFOperatorNames["SetTextHorizontalScaling"] = "Tz";
    PDFOperatorNames["SetTextLineHeight"] = "TL";
    PDFOperatorNames["SetTextRenderingMode"] = "Tr";
    PDFOperatorNames["SetTextRise"] = "Ts";
    PDFOperatorNames["SetWordSpacing"] = "Tw";
    PDFOperatorNames["ShowText"] = "Tj";
    PDFOperatorNames["ShowTextAdjusted"] = "TJ";
    PDFOperatorNames["ShowTextLine"] = "'";
    PDFOperatorNames["ShowTextLineAndSpace"] = "\"";
    // Type3 Font Operators
    PDFOperatorNames["Type3D0"] = "d0";
    PDFOperatorNames["Type3D1"] = "d1";
    // Compatibility Section Operators
    PDFOperatorNames["BeginCompatibilitySection"] = "BX";
    PDFOperatorNames["EndCompatibilitySection"] = "EX";
})($1cc3dd00b8bf8e36$var$PDFOperatorNames || ($1cc3dd00b8bf8e36$var$PDFOperatorNames = {}));
var $1cc3dd00b8bf8e36$export$2e2bcd8739ae039 = $1cc3dd00b8bf8e36$var$PDFOperatorNames;



var $70JnX = parcelRequire("70JnX");

var $70JnX = parcelRequire("70JnX");

var $czuCz = parcelRequire("czuCz");

var $1jVcF = parcelRequire("1jVcF");

var $btXS2 = parcelRequire("btXS2");

parcelRequire("JEL7f");
var $cLyfO = parcelRequire("cLyfO");
var $d7e314ea28ae86c1$var$PDFFlateStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFFlateStream, _super);
    function PDFFlateStream(dict, encode) {
        var _this = _super.call(this, dict) || this;
        _this.computeContents = function() {
            var unencodedContents = _this.getUnencodedContents();
            return _this.encode ? (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).deflate(unencodedContents) : unencodedContents;
        };
        _this.encode = encode;
        if (encode) dict.set((0, $btXS2.default).of('Filter'), (0, $btXS2.default).of('FlateDecode'));
        _this.contentsCache = (0, $cLyfO.default).populatedBy(_this.computeContents);
        return _this;
    }
    PDFFlateStream.prototype.getContents = function() {
        return this.contentsCache.access();
    };
    PDFFlateStream.prototype.getContentsSize = function() {
        return this.contentsCache.access().length;
    };
    PDFFlateStream.prototype.getUnencodedContents = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'getUnencodedContents');
    };
    return PDFFlateStream;
}((0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
var $d7e314ea28ae86c1$export$2e2bcd8739ae039 = $d7e314ea28ae86c1$var$PDFFlateStream;



var $lJYRg = parcelRequire("lJYRg");
var $0cd7a4dbcbade137$var$PDFContentStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFContentStream, _super);
    function PDFContentStream(dict, operators, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        _this.operators = operators;
        return _this;
    }
    PDFContentStream.prototype.push = function() {
        var _a;
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        (_a = this.operators).push.apply(_a, operators);
    };
    PDFContentStream.prototype.clone = function(context) {
        var operators = new Array(this.operators.length);
        for(var idx = 0, len = this.operators.length; idx < len; idx++)operators[idx] = this.operators[idx].clone(context);
        var _a = this, dict = _a.dict, encode = _a.encode;
        return PDFContentStream.of(dict.clone(context), operators, encode);
    };
    PDFContentStream.prototype.getContentsString = function() {
        var value = '';
        for(var idx = 0, len = this.operators.length; idx < len; idx++)value += this.operators[idx] + "\n";
        return value;
    };
    PDFContentStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++){
            offset += this.operators[idx].copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Newline;
        }
        return buffer;
    };
    PDFContentStream.prototype.getUnencodedContentsSize = function() {
        var size = 0;
        for(var idx = 0, len = this.operators.length; idx < len; idx++)size += this.operators[idx].sizeInBytes() + 1;
        return size;
    };
    PDFContentStream.of = function(dict, operators, encode) {
        if (encode === void 0) encode = true;
        return new PDFContentStream(dict, operators, encode);
    };
    return PDFContentStream;
}((0, $d7e314ea28ae86c1$export$2e2bcd8739ae039));
var $0cd7a4dbcbade137$export$2e2bcd8739ae039 = $0cd7a4dbcbade137$var$PDFContentStream;


parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
/**
 * Generates a pseudo random number. Although it is not cryptographically secure
 * and uniformly distributed, it is not a concern for the intended use-case,
 * which is to generate distinct numbers.
 *
 * Credit: https://stackoverflow.com/a/19303725/10254049
 */ var $28b228d2ab5e2fae$export$205b650d120b95b5 = /** @class */ function() {
    function SimpleRNG(seed) {
        this.seed = seed;
    }
    SimpleRNG.prototype.nextInt = function() {
        var x = Math.sin(this.seed++) * 10000;
        return x - Math.floor(x);
    };
    SimpleRNG.withSeed = function(seed) {
        return new SimpleRNG(seed);
    };
    return SimpleRNG;
}();


var $ec19a68ebeedd71c$var$byAscendingObjectNumber = function(_a, _b) {
    var a = _a[0];
    var b = _b[0];
    return a.objectNumber - b.objectNumber;
};
var $ec19a68ebeedd71c$var$PDFContext = /** @class */ function() {
    function PDFContext() {
        this.largestObjectNumber = 0;
        this.header = (0, $f5613438da36c90d$export$2e2bcd8739ae039).forVersion(1, 7);
        this.trailerInfo = {};
        this.indirectObjects = new Map();
        this.rng = (0, $28b228d2ab5e2fae$export$205b650d120b95b5).withSeed(1);
    }
    PDFContext.prototype.assign = function(ref, object) {
        this.indirectObjects.set(ref, object);
        if (ref.objectNumber > this.largestObjectNumber) this.largestObjectNumber = ref.objectNumber;
    };
    PDFContext.prototype.nextRef = function() {
        this.largestObjectNumber += 1;
        return (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(this.largestObjectNumber);
    };
    PDFContext.prototype.register = function(object) {
        var ref = this.nextRef();
        this.assign(ref, object);
        return ref;
    };
    PDFContext.prototype.delete = function(ref) {
        return this.indirectObjects.delete(ref);
    };
    PDFContext.prototype.lookupMaybe = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        // TODO: `preservePDFNull` is for backwards compatibility. Should be
        // removed in next breaking API change.
        var preservePDFNull = types.includes((0, $92faf6a1e2d86453$export$2e2bcd8739ae039));
        var result = ref instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (!result || result === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039) && !preservePDFNull) return undefined;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039)) {
                if (result === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $1jVcF.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.lookup = function(ref) {
        var types = [];
        for(var _i = 1; _i < arguments.length; _i++)types[_i - 1] = arguments[_i];
        var result = ref instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039) ? this.indirectObjects.get(ref) : ref;
        if (types.length === 0) return result;
        for(var idx = 0, len = types.length; idx < len; idx++){
            var type = types[idx];
            if (type === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039)) {
                if (result === (0, $92faf6a1e2d86453$export$2e2bcd8739ae039)) return result;
            } else {
                if (result instanceof type) return result;
            }
        }
        throw new (0, $1jVcF.UnexpectedObjectTypeError)(types, result);
    };
    PDFContext.prototype.getObjectRef = function(pdfObject) {
        var entries = Array.from(this.indirectObjects.entries());
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], ref = _a[0], object = _a[1];
            if (object === pdfObject) return ref;
        }
        return undefined;
    };
    PDFContext.prototype.enumerateIndirectObjects = function() {
        return Array.from(this.indirectObjects.entries()).sort($ec19a68ebeedd71c$var$byAscendingObjectNumber);
    };
    PDFContext.prototype.obj = function(literal) {
        if (literal instanceof (0, $iyqEO.default)) return literal;
        else if (literal === null || literal === undefined) return 0, $92faf6a1e2d86453$export$2e2bcd8739ae039;
        else if (typeof literal === 'string') return (0, $btXS2.default).of(literal);
        else if (typeof literal === 'number') return (0, $8LDYe.default).of(literal);
        else if (typeof literal === 'boolean') return literal ? (0, $gxKrW.default).True : (0, $gxKrW.default).False;
        else if (Array.isArray(literal)) {
            var array = (0, $cUVc9.default).withContext(this);
            for(var idx = 0, len = literal.length; idx < len; idx++)array.push(this.obj(literal[idx]));
            return array;
        } else {
            var dict = (0, $a128f87a2ae876f3$export$2e2bcd8739ae039).withContext(this);
            var keys = Object.keys(literal);
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                var value = literal[key];
                if (value !== undefined) dict.set((0, $btXS2.default).of(key), this.obj(value));
            }
            return dict;
        }
    };
    PDFContext.prototype.stream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return (0, $d814c40cb5e196cb$export$2e2bcd8739ae039).of(this.obj(dict), (0, $9uJGW.typedArrayFor)(contents));
    };
    PDFContext.prototype.flateStream = function(contents, dict) {
        if (dict === void 0) dict = {};
        return this.stream((0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).deflate((0, $9uJGW.typedArrayFor)(contents)), (0, $70JnX.__assign)((0, $70JnX.__assign)({}, dict), {
            Filter: 'FlateDecode'
        }));
    };
    PDFContext.prototype.contentStream = function(operators, dict) {
        if (dict === void 0) dict = {};
        return (0, $0cd7a4dbcbade137$export$2e2bcd8739ae039).of(this.obj(dict), operators);
    };
    PDFContext.prototype.formXObject = function(operators, dict) {
        if (dict === void 0) dict = {};
        return this.contentStream(operators, (0, $70JnX.__assign)((0, $70JnX.__assign)({
            BBox: this.obj([
                0,
                0,
                0,
                0
            ]),
            Matrix: this.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        }, dict), {
            Type: 'XObject',
            Subtype: 'Form'
        }));
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPushGraphicsStateContentStream = function() {
        if (this.pushGraphicsStateContentStreamRef) return this.pushGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).PushGraphicsState);
        var stream = (0, $0cd7a4dbcbade137$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.pushGraphicsStateContentStreamRef = this.register(stream);
        return this.pushGraphicsStateContentStreamRef;
    };
    /*
     * Reference to PDFContentStream that contains a single PDFOperator: `Q`.
     * Used by [[PDFPageLeaf]] instances to ensure that when content streams are
     * added to a modified PDF, they start in the default, unchanged graphics
     * state.
     */ PDFContext.prototype.getPopGraphicsStateContentStream = function() {
        if (this.popGraphicsStateContentStreamRef) return this.popGraphicsStateContentStreamRef;
        var dict = this.obj({});
        var op = (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).PopGraphicsState);
        var stream = (0, $0cd7a4dbcbade137$export$2e2bcd8739ae039).of(dict, [
            op
        ]);
        this.popGraphicsStateContentStreamRef = this.register(stream);
        return this.popGraphicsStateContentStreamRef;
    };
    PDFContext.prototype.addRandomSuffix = function(prefix, suffixLength) {
        if (suffixLength === void 0) suffixLength = 4;
        return prefix + "-" + Math.floor(this.rng.nextInt() * Math.pow(10, suffixLength));
    };
    PDFContext.create = function() {
        return new PDFContext();
    };
    return PDFContext;
}();
var $ec19a68ebeedd71c$export$2e2bcd8739ae039 = $ec19a68ebeedd71c$var$PDFContext;



var $cUVc9 = parcelRequire("cUVc9");


var $btXS2 = parcelRequire("btXS2");



var $70JnX = parcelRequire("70JnX");

var $cUVc9 = parcelRequire("cUVc9");


var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");

var $2bc0df8a0eb000e9$var$PDFPageLeaf = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFPageLeaf, _super);
    function PDFPageLeaf(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        var _this = _super.call(this, map, context) || this;
        _this.normalized = false;
        _this.autoNormalizeCTM = autoNormalizeCTM;
        return _this;
    }
    PDFPageLeaf.prototype.clone = function(context) {
        var clone = PDFPageLeaf.fromMapWithContext(new Map(), context || this.context, this.autoNormalizeCTM);
        var entries = this.entries();
        for(var idx = 0, len = entries.length; idx < len; idx++){
            var _a = entries[idx], key = _a[0], value = _a[1];
            clone.set(key, value);
        }
        return clone;
    };
    PDFPageLeaf.prototype.Parent = function() {
        return this.lookupMaybe((0, $btXS2.default).Parent, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.Contents = function() {
        return this.lookup((0, $btXS2.default).of('Contents'));
    };
    PDFPageLeaf.prototype.Annots = function() {
        return this.lookupMaybe((0, $btXS2.default).Annots, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.BleedBox = function() {
        return this.lookupMaybe((0, $btXS2.default).BleedBox, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.TrimBox = function() {
        return this.lookupMaybe((0, $btXS2.default).TrimBox, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.ArtBox = function() {
        return this.lookupMaybe((0, $btXS2.default).ArtBox, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.Resources = function() {
        var dictOrRef = this.getInheritableAttribute((0, $btXS2.default).Resources);
        return this.context.lookupMaybe(dictOrRef, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFPageLeaf.prototype.MediaBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $btXS2.default).MediaBox);
        return this.context.lookup(arrayOrRef, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.CropBox = function() {
        var arrayOrRef = this.getInheritableAttribute((0, $btXS2.default).CropBox);
        return this.context.lookupMaybe(arrayOrRef, (0, $cUVc9.default));
    };
    PDFPageLeaf.prototype.Rotate = function() {
        var numberOrRef = this.getInheritableAttribute((0, $btXS2.default).Rotate);
        return this.context.lookupMaybe(numberOrRef, (0, $8LDYe.default));
    };
    PDFPageLeaf.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.get(name);
        });
        return attribute;
    };
    PDFPageLeaf.prototype.setParent = function(parentRef) {
        this.set((0, $btXS2.default).Parent, parentRef);
    };
    PDFPageLeaf.prototype.addContentStream = function(contentStreamRef) {
        var Contents = this.normalizedEntries().Contents || this.context.obj([]);
        this.set((0, $btXS2.default).Contents, Contents);
        Contents.push(contentStreamRef);
    };
    PDFPageLeaf.prototype.wrapContentStreams = function(startStream, endStream) {
        var Contents = this.Contents();
        if (Contents instanceof (0, $cUVc9.default)) {
            Contents.insert(0, startStream);
            Contents.push(endStream);
            return true;
        }
        return false;
    };
    PDFPageLeaf.prototype.addAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        Annots.push(annotRef);
    };
    PDFPageLeaf.prototype.removeAnnot = function(annotRef) {
        var Annots = this.normalizedEntries().Annots;
        var index = Annots.indexOf(annotRef);
        if (index !== undefined) Annots.remove(index);
    };
    PDFPageLeaf.prototype.setFontDictionary = function(name, fontDictRef) {
        var Font = this.normalizedEntries().Font;
        Font.set(name, fontDictRef);
    };
    PDFPageLeaf.prototype.newFontDictionaryKey = function(tag) {
        var Font = this.normalizedEntries().Font;
        return Font.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newFontDictionary = function(tag, fontDictRef) {
        var key = this.newFontDictionaryKey(tag);
        this.setFontDictionary(key, fontDictRef);
        return key;
    };
    PDFPageLeaf.prototype.setXObject = function(name, xObjectRef) {
        var XObject = this.normalizedEntries().XObject;
        XObject.set(name, xObjectRef);
    };
    PDFPageLeaf.prototype.newXObjectKey = function(tag) {
        var XObject = this.normalizedEntries().XObject;
        return XObject.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newXObject = function(tag, xObjectRef) {
        var key = this.newXObjectKey(tag);
        this.setXObject(key, xObjectRef);
        return key;
    };
    PDFPageLeaf.prototype.setExtGState = function(name, extGStateRef) {
        var ExtGState = this.normalizedEntries().ExtGState;
        ExtGState.set(name, extGStateRef);
    };
    PDFPageLeaf.prototype.newExtGStateKey = function(tag) {
        var ExtGState = this.normalizedEntries().ExtGState;
        return ExtGState.uniqueKey(tag);
    };
    PDFPageLeaf.prototype.newExtGState = function(tag, extGStateRef) {
        var key = this.newExtGStateKey(tag);
        this.setExtGState(key, extGStateRef);
        return key;
    };
    PDFPageLeaf.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    PDFPageLeaf.prototype.normalize = function() {
        if (this.normalized) return;
        var context = this.context;
        var contentsRef = this.get((0, $btXS2.default).Contents);
        var contents = this.context.lookup(contentsRef);
        if (contents instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039)) this.set((0, $btXS2.default).Contents, context.obj([
            contentsRef
        ]));
        if (this.autoNormalizeCTM) this.wrapContentStreams(this.context.getPushGraphicsStateContentStream(), this.context.getPopGraphicsStateContentStream());
        // TODO: Clone `Resources` if it is inherited
        var dictOrRef = this.getInheritableAttribute((0, $btXS2.default).Resources);
        var Resources = context.lookupMaybe(dictOrRef, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) || context.obj({});
        this.set((0, $btXS2.default).Resources, Resources);
        // TODO: Clone `Font` if it is inherited
        var Font = Resources.lookupMaybe((0, $btXS2.default).Font, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $btXS2.default).Font, Font);
        // TODO: Clone `XObject` if it is inherited
        var XObject = Resources.lookupMaybe((0, $btXS2.default).XObject, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $btXS2.default).XObject, XObject);
        // TODO: Clone `ExtGState` if it is inherited
        var ExtGState = Resources.lookupMaybe((0, $btXS2.default).ExtGState, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) || context.obj({});
        Resources.set((0, $btXS2.default).ExtGState, ExtGState);
        var Annots = this.Annots() || context.obj([]);
        this.set((0, $btXS2.default).Annots, Annots);
        this.normalized = true;
    };
    PDFPageLeaf.prototype.normalizedEntries = function() {
        this.normalize();
        var Annots = this.Annots();
        var Resources = this.Resources();
        var Contents = this.Contents();
        return {
            Annots: Annots,
            Resources: Resources,
            Contents: Contents,
            Font: Resources.lookup((0, $btXS2.default).Font, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)),
            XObject: Resources.lookup((0, $btXS2.default).XObject, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)),
            ExtGState: Resources.lookup((0, $btXS2.default).ExtGState, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039))
        };
    };
    PDFPageLeaf.InheritableEntries = [
        'Resources',
        'MediaBox',
        'CropBox',
        'Rotate'
    ];
    PDFPageLeaf.withContextAndParent = function(context, parent) {
        var dict = new Map();
        dict.set((0, $btXS2.default).Type, (0, $btXS2.default).Page);
        dict.set((0, $btXS2.default).Parent, parent);
        dict.set((0, $btXS2.default).Resources, context.obj({}));
        dict.set((0, $btXS2.default).MediaBox, context.obj([
            0,
            0,
            612,
            792
        ]));
        return new PDFPageLeaf(dict, context, false);
    };
    PDFPageLeaf.fromMapWithContext = function(map, context, autoNormalizeCTM) {
        if (autoNormalizeCTM === void 0) autoNormalizeCTM = true;
        return new PDFPageLeaf(map, context, autoNormalizeCTM);
    };
    return PDFPageLeaf;
}((0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
var $2bc0df8a0eb000e9$export$2e2bcd8739ae039 = $2bc0df8a0eb000e9$var$PDFPageLeaf;


/**
 * PDFObjectCopier copies PDFObjects from a src context to a dest context.
 * The primary use case for this is to copy pages between PDFs.
 *
 * _Copying_ an object with a PDFObjectCopier is different from _cloning_ an
 * object with its [[PDFObject.clone]] method:
 *
 * ```
 *   const src: PDFContext = ...
 *   const dest: PDFContext = ...
 *   const originalObject: PDFObject = ...
 *   const copiedObject = PDFObjectCopier.for(src, dest).copy(originalObject);
 *   const clonedObject = originalObject.clone();
 * ```
 *
 * Copying an object is equivalent to cloning it and then copying over any other
 * objects that it references. Note that only dictionaries, arrays, and streams
 * (or structures build from them) can contain indirect references to other
 * objects. Copying a PDFObject that is not a dictionary, array, or stream is
 * supported, but is equivalent to cloning it.
 */ var $0e849e39b0ca1497$var$PDFObjectCopier = /** @class */ function() {
    function PDFObjectCopier(src, dest) {
        var _this = this;
        this.traversedObjects = new Map();
        // prettier-ignore
        this.copy = function(object) {
            return object instanceof (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039) ? _this.copyPDFPage(object) : object instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039) ? _this.copyPDFDict(object) : object instanceof (0, $cUVc9.default) ? _this.copyPDFArray(object) : object instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039) ? _this.copyPDFStream(object) : object instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039) ? _this.copyPDFIndirectObject(object) : object.clone();
        };
        this.copyPDFPage = function(originalPage) {
            var clonedPage = originalPage.clone();
            // Move any entries that the originalPage is inheriting from its parent
            // tree nodes directly into originalPage so they are preserved during
            // the copy.
            var InheritableEntries = (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039).InheritableEntries;
            for(var idx = 0, len = InheritableEntries.length; idx < len; idx++){
                var key = (0, $btXS2.default).of(InheritableEntries[idx]);
                var value = clonedPage.getInheritableAttribute(key);
                if (!clonedPage.get(key) && value) clonedPage.set(key, value);
            }
            // Remove the parent reference to prevent the whole donor document's page
            // tree from being copied when we only need a single page.
            clonedPage.delete((0, $btXS2.default).of('Parent'));
            return _this.copyPDFDict(clonedPage);
        };
        this.copyPDFDict = function(originalDict) {
            if (_this.traversedObjects.has(originalDict)) return _this.traversedObjects.get(originalDict);
            var clonedDict = originalDict.clone(_this.dest);
            _this.traversedObjects.set(originalDict, clonedDict);
            var entries = originalDict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedDict.set(key, _this.copy(value));
            }
            return clonedDict;
        };
        this.copyPDFArray = function(originalArray) {
            if (_this.traversedObjects.has(originalArray)) return _this.traversedObjects.get(originalArray);
            var clonedArray = originalArray.clone(_this.dest);
            _this.traversedObjects.set(originalArray, clonedArray);
            for(var idx = 0, len = originalArray.size(); idx < len; idx++){
                var value = originalArray.get(idx);
                clonedArray.set(idx, _this.copy(value));
            }
            return clonedArray;
        };
        this.copyPDFStream = function(originalStream) {
            if (_this.traversedObjects.has(originalStream)) return _this.traversedObjects.get(originalStream);
            var clonedStream = originalStream.clone(_this.dest);
            _this.traversedObjects.set(originalStream, clonedStream);
            var entries = originalStream.dict.entries();
            for(var idx = 0, len = entries.length; idx < len; idx++){
                var _a = entries[idx], key = _a[0], value = _a[1];
                clonedStream.dict.set(key, _this.copy(value));
            }
            return clonedStream;
        };
        this.copyPDFIndirectObject = function(ref) {
            var alreadyMapped = _this.traversedObjects.has(ref);
            if (!alreadyMapped) {
                var newRef = _this.dest.nextRef();
                _this.traversedObjects.set(ref, newRef);
                var dereferencedValue = _this.src.lookup(ref);
                if (dereferencedValue) {
                    var cloned = _this.copy(dereferencedValue);
                    _this.dest.assign(newRef, cloned);
                }
            }
            return _this.traversedObjects.get(ref);
        };
        this.src = src;
        this.dest = dest;
    }
    PDFObjectCopier.for = function(src, dest) {
        return new PDFObjectCopier(src, dest);
    };
    return PDFObjectCopier;
}();
var $0e849e39b0ca1497$export$2e2bcd8739ae039 = $0e849e39b0ca1497$var$PDFObjectCopier;



var $70JnX = parcelRequire("70JnX");


var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
/**
 * Entries should be added using the [[addEntry]] and [[addDeletedEntry]]
 * methods **in order of ascending object number**.
 */ var $b2a262b904f5b87f$var$PDFCrossRefSection = /** @class */ function() {
    function PDFCrossRefSection(firstEntry) {
        this.subsections = firstEntry ? [
            [
                firstEntry
            ]
        ] : [];
        this.chunkIdx = 0;
        this.chunkLength = firstEntry ? 1 : 0;
    }
    PDFCrossRefSection.prototype.addEntry = function(ref, offset) {
        this.append({
            ref: ref,
            offset: offset,
            deleted: false
        });
    };
    PDFCrossRefSection.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        this.append({
            ref: ref,
            offset: nextFreeObjectNumber,
            deleted: true
        });
    };
    PDFCrossRefSection.prototype.toString = function() {
        var section = "xref\n";
        for(var rangeIdx = 0, rangeLen = this.subsections.length; rangeIdx < rangeLen; rangeIdx++){
            var range = this.subsections[rangeIdx];
            section += range[0].ref.objectNumber + " " + range.length + "\n";
            for(var entryIdx = 0, entryLen = range.length; entryIdx < entryLen; entryIdx++){
                var entry = range[entryIdx];
                section += (0, $c6a2W.padStart)(String(entry.offset), 10, '0');
                section += ' ';
                section += (0, $c6a2W.padStart)(String(entry.ref.generationNumber), 5, '0');
                section += ' ';
                section += entry.deleted ? 'f' : 'n';
                section += ' \n';
            }
        }
        return section;
    };
    PDFCrossRefSection.prototype.sizeInBytes = function() {
        var size = 5;
        for(var idx = 0, len = this.subsections.length; idx < len; idx++){
            var subsection = this.subsections[idx];
            var subsectionLength = subsection.length;
            var firstEntry = subsection[0];
            size += 2;
            size += String(firstEntry.ref.objectNumber).length;
            size += String(subsectionLength).length;
            size += 20 * subsectionLength;
        }
        return size;
    };
    PDFCrossRefSection.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).x;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).f;
        buffer[offset++] = (0, $lJYRg.default).Newline;
        offset += this.copySubsectionsIntoBuffer(this.subsections, buffer, offset);
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copySubsectionsIntoBuffer = function(subsections, buffer, offset) {
        var initialOffset = offset;
        var length = subsections.length;
        for(var idx = 0; idx < length; idx++){
            var subsection = this.subsections[idx];
            var firstObjectNumber = String(subsection[0].ref.objectNumber);
            offset += (0, $c6a2W.copyStringIntoBuffer)(firstObjectNumber, buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
            var rangeLength = String(subsection.length);
            offset += (0, $c6a2W.copyStringIntoBuffer)(rangeLength, buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Newline;
            offset += this.copyEntriesIntoBuffer(subsection, buffer, offset);
        }
        return offset - initialOffset;
    };
    PDFCrossRefSection.prototype.copyEntriesIntoBuffer = function(entries, buffer, offset) {
        var length = entries.length;
        for(var idx = 0; idx < length; idx++){
            var entry = entries[idx];
            var entryOffset = (0, $c6a2W.padStart)(String(entry.offset), 10, '0');
            offset += (0, $c6a2W.copyStringIntoBuffer)(entryOffset, buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
            var entryGen = (0, $c6a2W.padStart)(String(entry.ref.generationNumber), 5, '0');
            offset += (0, $c6a2W.copyStringIntoBuffer)(entryGen, buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Space;
            buffer[offset++] = entry.deleted ? (0, $lJYRg.default).f : (0, $lJYRg.default).n;
            buffer[offset++] = (0, $lJYRg.default).Space;
            buffer[offset++] = (0, $lJYRg.default).Newline;
        }
        return 20 * length;
    };
    PDFCrossRefSection.prototype.append = function(currEntry) {
        if (this.chunkLength === 0) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx = 0;
            this.chunkLength = 1;
            return;
        }
        var chunk = this.subsections[this.chunkIdx];
        var prevEntry = chunk[this.chunkLength - 1];
        if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
            this.subsections.push([
                currEntry
            ]);
            this.chunkIdx += 1;
            this.chunkLength = 1;
        } else {
            chunk.push(currEntry);
            this.chunkLength += 1;
        }
    };
    PDFCrossRefSection.create = function() {
        return new PDFCrossRefSection({
            ref: (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(0, 65535),
            offset: 0,
            deleted: true
        });
    };
    PDFCrossRefSection.createEmpty = function() {
        return new PDFCrossRefSection();
    };
    return PDFCrossRefSection;
}();
var $b2a262b904f5b87f$export$2e2bcd8739ae039 = $b2a262b904f5b87f$var$PDFCrossRefSection;




var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $6d6dcbc50b56a324$var$PDFTrailer = /** @class */ function() {
    function PDFTrailer(lastXRefOffset) {
        this.lastXRefOffset = String(lastXRefOffset);
    }
    PDFTrailer.prototype.toString = function() {
        return "startxref\n" + this.lastXRefOffset + "\n%%EOF";
    };
    PDFTrailer.prototype.sizeInBytes = function() {
        return 16 + this.lastXRefOffset.length;
    };
    PDFTrailer.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).s;
        buffer[offset++] = (0, $lJYRg.default).t;
        buffer[offset++] = (0, $lJYRg.default).a;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).t;
        buffer[offset++] = (0, $lJYRg.default).x;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).f;
        buffer[offset++] = (0, $lJYRg.default).Newline;
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.lastXRefOffset, buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).Newline;
        buffer[offset++] = (0, $lJYRg.default).Percent;
        buffer[offset++] = (0, $lJYRg.default).Percent;
        buffer[offset++] = (0, $lJYRg.default).E;
        buffer[offset++] = (0, $lJYRg.default).O;
        buffer[offset++] = (0, $lJYRg.default).F;
        return offset - initialOffset;
    };
    PDFTrailer.forLastCrossRefSectionOffset = function(offset) {
        return new PDFTrailer(offset);
    };
    return PDFTrailer;
}();
var $6d6dcbc50b56a324$export$2e2bcd8739ae039 = $6d6dcbc50b56a324$var$PDFTrailer;



var $lJYRg = parcelRequire("lJYRg");
var $90f6da15ffd246e4$var$PDFTrailerDict = /** @class */ function() {
    function PDFTrailerDict(dict) {
        this.dict = dict;
    }
    PDFTrailerDict.prototype.toString = function() {
        return "trailer\n" + this.dict.toString();
    };
    PDFTrailerDict.prototype.sizeInBytes = function() {
        return 8 + this.dict.sizeInBytes();
    };
    PDFTrailerDict.prototype.copyBytesInto = function(buffer, offset) {
        var initialOffset = offset;
        buffer[offset++] = (0, $lJYRg.default).t;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).a;
        buffer[offset++] = (0, $lJYRg.default).i;
        buffer[offset++] = (0, $lJYRg.default).l;
        buffer[offset++] = (0, $lJYRg.default).e;
        buffer[offset++] = (0, $lJYRg.default).r;
        buffer[offset++] = (0, $lJYRg.default).Newline;
        offset += this.dict.copyBytesInto(buffer, offset);
        return offset - initialOffset;
    };
    PDFTrailerDict.of = function(dict) {
        return new PDFTrailerDict(dict);
    };
    return PDFTrailerDict;
}();
var $90f6da15ffd246e4$export$2e2bcd8739ae039 = $90f6da15ffd246e4$var$PDFTrailerDict;



var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");


var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $9uJGW = parcelRequire("9uJGW");
var $8e78bed3cca47bde$var$PDFObjectStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFObjectStream, _super);
    function PDFObjectStream(context, objects, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, context.obj({}), encode) || this;
        _this.objects = objects;
        _this.offsets = _this.computeObjectOffsets();
        _this.offsetsString = _this.computeOffsetsString();
        _this.dict.set((0, $btXS2.default).of('Type'), (0, $btXS2.default).of('ObjStm'));
        _this.dict.set((0, $btXS2.default).of('N'), (0, $8LDYe.default).of(_this.objects.length));
        _this.dict.set((0, $btXS2.default).of('First'), (0, $8LDYe.default).of(_this.offsetsString.length));
        return _this;
    }
    PDFObjectStream.prototype.getObjectsCount = function() {
        return this.objects.length;
    };
    PDFObjectStream.prototype.clone = function(context) {
        return PDFObjectStream.withContextAndObjects(context || this.dict.context, this.objects.slice(), this.encode);
    };
    PDFObjectStream.prototype.getContentsString = function() {
        var value = this.offsetsString;
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            value += object + "\n";
        }
        return value;
    };
    PDFObjectStream.prototype.getUnencodedContents = function() {
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = (0, $c6a2W.copyStringIntoBuffer)(this.offsetsString, buffer, 0);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], object = _a[1];
            offset += object.copyBytesInto(buffer, offset);
            buffer[offset++] = (0, $lJYRg.default).Newline;
        }
        return buffer;
    };
    PDFObjectStream.prototype.getUnencodedContentsSize = function() {
        return this.offsetsString.length + (0, $9uJGW.last)(this.offsets)[1] + (0, $9uJGW.last)(this.objects)[1].sizeInBytes() + 1;
    };
    PDFObjectStream.prototype.computeOffsetsString = function() {
        var offsetsString = '';
        for(var idx = 0, len = this.offsets.length; idx < len; idx++){
            var _a = this.offsets[idx], objectNumber = _a[0], offset = _a[1];
            offsetsString += objectNumber + " " + offset + " ";
        }
        return offsetsString;
    };
    PDFObjectStream.prototype.computeObjectOffsets = function() {
        var offset = 0;
        var offsets = new Array(this.objects.length);
        for(var idx = 0, len = this.objects.length; idx < len; idx++){
            var _a = this.objects[idx], ref = _a[0], object = _a[1];
            offsets[idx] = [
                ref.objectNumber,
                offset
            ];
            offset += object.sizeInBytes() + 1; // '\n'
        }
        return offsets;
    };
    PDFObjectStream.withContextAndObjects = function(context, objects, encode) {
        if (encode === void 0) encode = true;
        return new PDFObjectStream(context, objects, encode);
    };
    return PDFObjectStream;
}((0, $d7e314ea28ae86c1$export$2e2bcd8739ae039));
var $8e78bed3cca47bde$export$2e2bcd8739ae039 = $8e78bed3cca47bde$var$PDFObjectStream;



var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $fAfk5 = parcelRequire("fAfk5");
var $f2f3b70d990f0d2f$var$PDFWriter = /** @class */ function() {
    function PDFWriter(context, objectsPerTick) {
        var _this = this;
        this.parsedObjects = 0;
        this.shouldWaitForTick = function(n) {
            _this.parsedObjects += n;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        this.context = context;
        this.objectsPerTick = objectsPerTick;
    }
    PDFWriter.prototype.serializeToBuffer = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, size, header, indirectObjects, xref, trailerDict, trailer, offset, buffer, idx, len, _b, ref, object, objectNumber, generationNumber, n;
            return (0, $70JnX.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.computeBufferSize()
                        ];
                    case 1:
                        _a = _c.sent(), size = _a.size, header = _a.header, indirectObjects = _a.indirectObjects, xref = _a.xref, trailerDict = _a.trailerDict, trailer = _a.trailer;
                        offset = 0;
                        buffer = new Uint8Array(size);
                        offset += header.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        idx = 0, len = indirectObjects.length;
                        _c.label = 2;
                    case 2:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            5
                        ];
                        _b = indirectObjects[idx], ref = _b[0], object = _b[1];
                        objectNumber = String(ref.objectNumber);
                        offset += (0, $c6a2W.copyStringIntoBuffer)(objectNumber, buffer, offset);
                        buffer[offset++] = (0, $lJYRg.default).Space;
                        generationNumber = String(ref.generationNumber);
                        offset += (0, $c6a2W.copyStringIntoBuffer)(generationNumber, buffer, offset);
                        buffer[offset++] = (0, $lJYRg.default).Space;
                        buffer[offset++] = (0, $lJYRg.default).o;
                        buffer[offset++] = (0, $lJYRg.default).b;
                        buffer[offset++] = (0, $lJYRg.default).j;
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        offset += object.copyBytesInto(buffer, offset);
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        buffer[offset++] = (0, $lJYRg.default).e;
                        buffer[offset++] = (0, $lJYRg.default).n;
                        buffer[offset++] = (0, $lJYRg.default).d;
                        buffer[offset++] = (0, $lJYRg.default).o;
                        buffer[offset++] = (0, $lJYRg.default).b;
                        buffer[offset++] = (0, $lJYRg.default).j;
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        buffer[offset++] = (0, $lJYRg.default).Newline;
                        n = object instanceof (0, $8e78bed3cca47bde$export$2e2bcd8739ae039) ? object.getObjectsCount() : 1;
                        if (!this.shouldWaitForTick(n)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 3:
                        _c.sent();
                        _c.label = 4;
                    case 4:
                        idx++;
                        return [
                            3 /*break*/ ,
                            2
                        ];
                    case 5:
                        if (xref) {
                            offset += xref.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $lJYRg.default).Newline;
                        }
                        if (trailerDict) {
                            offset += trailerDict.copyBytesInto(buffer, offset);
                            buffer[offset++] = (0, $lJYRg.default).Newline;
                            buffer[offset++] = (0, $lJYRg.default).Newline;
                        }
                        offset += trailer.copyBytesInto(buffer, offset);
                        return [
                            2 /*return*/ ,
                            buffer
                        ];
                }
            });
        });
    };
    PDFWriter.prototype.computeIndirectObjectSize = function(_a) {
        var ref = _a[0], object = _a[1];
        var refSize = ref.sizeInBytes() + 3; // 'R' -> 'obj\n'
        var objectSize = object.sizeInBytes() + 9; // '\nendobj\n\n'
        return refSize + objectSize;
    };
    PDFWriter.prototype.createTrailerDict = function() {
        return this.context.obj({
            Size: this.context.largestObjectNumber + 1,
            Root: this.context.trailerInfo.Root,
            Encrypt: this.context.trailerInfo.Encrypt,
            Info: this.context.trailerInfo.Info,
            ID: this.context.trailerInfo.ID
        });
    };
    PDFWriter.prototype.computeBufferSize = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var header, size, xref, indirectObjects, idx, len, indirectObject, ref, xrefOffset, trailerDict, trailer;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        header = (0, $f5613438da36c90d$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xref = (0, $b2a262b904f5b87f$export$2e2bcd8739ae039).create();
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0];
                        xref.addEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        xrefOffset = size;
                        size += xref.sizeInBytes() + 1; // '\n'
                        trailerDict = (0, $90f6da15ffd246e4$export$2e2bcd8739ae039).of(this.createTrailerDict());
                        size += trailerDict.sizeInBytes() + 2; // '\n\n'
                        trailer = (0, $6d6dcbc50b56a324$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: indirectObjects,
                                xref: xref,
                                trailerDict: trailerDict,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFWriter.forContext = function(context, objectsPerTick) {
        return new PDFWriter(context, objectsPerTick);
    };
    return PDFWriter;
}();
var $f2f3b70d990f0d2f$export$2e2bcd8739ae039 = $f2f3b70d990f0d2f$var$PDFWriter;



var $70JnX = parcelRequire("70JnX");



var $70JnX = parcelRequire("70JnX");

var $iyqEO = parcelRequire("iyqEO");
var $f45442108e8c0086$var$PDFInvalidObject = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFInvalidObject, _super);
    function PDFInvalidObject(data) {
        var _this = _super.call(this) || this;
        _this.data = data;
        return _this;
    }
    PDFInvalidObject.prototype.clone = function() {
        return PDFInvalidObject.of(this.data.slice());
    };
    PDFInvalidObject.prototype.toString = function() {
        return "PDFInvalidObject(" + this.data.length + " bytes)";
    };
    PDFInvalidObject.prototype.sizeInBytes = function() {
        return this.data.length;
    };
    PDFInvalidObject.prototype.copyBytesInto = function(buffer, offset) {
        var length = this.data.length;
        for(var idx = 0; idx < length; idx++)buffer[offset++] = this.data[idx];
        return length;
    };
    PDFInvalidObject.of = function(data) {
        return new PDFInvalidObject(data);
    };
    return PDFInvalidObject;
}((0, $iyqEO.default));
var $f45442108e8c0086$export$2e2bcd8739ae039 = $f45442108e8c0086$var$PDFInvalidObject;



var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");



var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");


parcelRequire("JEL7f");
var $5ypEP = parcelRequire("5ypEP");
var $cLyfO = parcelRequire("cLyfO");
var $9uJGW = parcelRequire("9uJGW");
var $c48137c8ce877bbb$export$e41c32906b33062a;
(function(EntryType) {
    EntryType[EntryType["Deleted"] = 0] = "Deleted";
    EntryType[EntryType["Uncompressed"] = 1] = "Uncompressed";
    EntryType[EntryType["Compressed"] = 2] = "Compressed";
})($c48137c8ce877bbb$export$e41c32906b33062a || ($c48137c8ce877bbb$export$e41c32906b33062a = {}));
/**
 * Entries should be added using the [[addDeletedEntry]],
 * [[addUncompressedEntry]], and [[addCompressedEntry]] methods
 * **in order of ascending object number**.
 */ var $c48137c8ce877bbb$var$PDFCrossRefStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFCrossRefStream, _super);
    function PDFCrossRefStream(dict, entries, encode) {
        if (encode === void 0) encode = true;
        var _this = _super.call(this, dict, encode) || this;
        // Returns an array of integer pairs for each subsection of the cross ref
        // section, where each integer pair represents:
        //   firstObjectNumber(OfSection), length(OfSection)
        _this.computeIndex = function() {
            var subsections = [];
            var subsectionLength = 0;
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var currEntry = _this.entries[idx];
                var prevEntry = _this.entries[idx - 1];
                if (idx === 0) subsections.push(currEntry.ref.objectNumber);
                else if (currEntry.ref.objectNumber - prevEntry.ref.objectNumber > 1) {
                    subsections.push(subsectionLength);
                    subsections.push(currEntry.ref.objectNumber);
                    subsectionLength = 0;
                }
                subsectionLength += 1;
            }
            subsections.push(subsectionLength);
            return subsections;
        };
        _this.computeEntryTuples = function() {
            var entryTuples = new Array(_this.entries.length);
            for(var idx = 0, len = _this.entries.length; idx < len; idx++){
                var entry = _this.entries[idx];
                if (entry.type === $c48137c8ce877bbb$export$e41c32906b33062a.Deleted) {
                    var type = entry.type, nextFreeObjectNumber = entry.nextFreeObjectNumber, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        nextFreeObjectNumber,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $c48137c8ce877bbb$export$e41c32906b33062a.Uncompressed) {
                    var type = entry.type, offset = entry.offset, ref = entry.ref;
                    entryTuples[idx] = [
                        type,
                        offset,
                        ref.generationNumber
                    ];
                }
                if (entry.type === $c48137c8ce877bbb$export$e41c32906b33062a.Compressed) {
                    var type = entry.type, objectStreamRef = entry.objectStreamRef, index = entry.index;
                    entryTuples[idx] = [
                        type,
                        objectStreamRef.objectNumber,
                        index
                    ];
                }
            }
            return entryTuples;
        };
        _this.computeMaxEntryByteWidths = function() {
            var entryTuples = _this.entryTuplesCache.access();
            var widths = [
                0,
                0,
                0
            ];
            for(var idx = 0, len = entryTuples.length; idx < len; idx++){
                var _a = entryTuples[idx], first = _a[0], second = _a[1], third = _a[2];
                var firstSize = (0, $5ypEP.sizeInBytes)(first);
                var secondSize = (0, $5ypEP.sizeInBytes)(second);
                var thirdSize = (0, $5ypEP.sizeInBytes)(third);
                if (firstSize > widths[0]) widths[0] = firstSize;
                if (secondSize > widths[1]) widths[1] = secondSize;
                if (thirdSize > widths[2]) widths[2] = thirdSize;
            }
            return widths;
        };
        _this.entries = entries || [];
        _this.entryTuplesCache = (0, $cLyfO.default).populatedBy(_this.computeEntryTuples);
        _this.maxByteWidthsCache = (0, $cLyfO.default).populatedBy(_this.computeMaxEntryByteWidths);
        _this.indexCache = (0, $cLyfO.default).populatedBy(_this.computeIndex);
        dict.set((0, $btXS2.default).of('Type'), (0, $btXS2.default).of('XRef'));
        return _this;
    }
    PDFCrossRefStream.prototype.addDeletedEntry = function(ref, nextFreeObjectNumber) {
        var type = $c48137c8ce877bbb$export$e41c32906b33062a.Deleted;
        this.entries.push({
            type: type,
            ref: ref,
            nextFreeObjectNumber: nextFreeObjectNumber
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addUncompressedEntry = function(ref, offset) {
        var type = $c48137c8ce877bbb$export$e41c32906b33062a.Uncompressed;
        this.entries.push({
            type: type,
            ref: ref,
            offset: offset
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.addCompressedEntry = function(ref, objectStreamRef, index) {
        var type = $c48137c8ce877bbb$export$e41c32906b33062a.Compressed;
        this.entries.push({
            type: type,
            ref: ref,
            objectStreamRef: objectStreamRef,
            index: index
        });
        this.entryTuplesCache.invalidate();
        this.maxByteWidthsCache.invalidate();
        this.indexCache.invalidate();
        this.contentsCache.invalidate();
    };
    PDFCrossRefStream.prototype.clone = function(context) {
        var _a = this, dict = _a.dict, entries = _a.entries, encode = _a.encode;
        return PDFCrossRefStream.of(dict.clone(context), entries.slice(), encode);
    };
    PDFCrossRefStream.prototype.getContentsString = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var value = '';
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(first));
            var secondBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(second));
            var thirdBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)value += (firstBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)value += (secondBytes[idx] || 0).toString(2);
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)value += (thirdBytes[idx] || 0).toString(2);
        }
        return value;
    };
    PDFCrossRefStream.prototype.getUnencodedContents = function() {
        var entryTuples = this.entryTuplesCache.access();
        var byteWidths = this.maxByteWidthsCache.access();
        var buffer = new Uint8Array(this.getUnencodedContentsSize());
        var offset = 0;
        for(var entryIdx = 0, entriesLen = entryTuples.length; entryIdx < entriesLen; entryIdx++){
            var _a = entryTuples[entryIdx], first = _a[0], second = _a[1], third = _a[2];
            var firstBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(first));
            var secondBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(second));
            var thirdBytes = (0, $9uJGW.reverseArray)((0, $5ypEP.bytesFor)(third));
            for(var idx = byteWidths[0] - 1; idx >= 0; idx--)buffer[offset++] = firstBytes[idx] || 0;
            for(var idx = byteWidths[1] - 1; idx >= 0; idx--)buffer[offset++] = secondBytes[idx] || 0;
            for(var idx = byteWidths[2] - 1; idx >= 0; idx--)buffer[offset++] = thirdBytes[idx] || 0;
        }
        return buffer;
    };
    PDFCrossRefStream.prototype.getUnencodedContentsSize = function() {
        var byteWidths = this.maxByteWidthsCache.access();
        var entryWidth = (0, $9uJGW.sum)(byteWidths);
        return entryWidth * this.entries.length;
    };
    PDFCrossRefStream.prototype.updateDict = function() {
        _super.prototype.updateDict.call(this);
        var byteWidths = this.maxByteWidthsCache.access();
        var index = this.indexCache.access();
        var context = this.dict.context;
        this.dict.set((0, $btXS2.default).of('W'), context.obj(byteWidths));
        this.dict.set((0, $btXS2.default).of('Index'), context.obj(index));
    };
    PDFCrossRefStream.create = function(dict, encode) {
        if (encode === void 0) encode = true;
        var stream = new PDFCrossRefStream(dict, [], encode);
        stream.addDeletedEntry((0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(0, 65535), 0);
        return stream;
    };
    PDFCrossRefStream.of = function(dict, entries, encode) {
        if (encode === void 0) encode = true;
        return new PDFCrossRefStream(dict, entries, encode);
    };
    return PDFCrossRefStream;
}((0, $d7e314ea28ae86c1$export$2e2bcd8739ae039));
var $c48137c8ce877bbb$export$2e2bcd8739ae039 = $c48137c8ce877bbb$var$PDFCrossRefStream;




parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
var $fAfk5 = parcelRequire("fAfk5");
var $343225d647cb5158$var$PDFStreamWriter = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFStreamWriter, _super);
    function PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream) {
        var _this = _super.call(this, context, objectsPerTick) || this;
        _this.encodeStreams = encodeStreams;
        _this.objectsPerStream = objectsPerStream;
        return _this;
    }
    PDFStreamWriter.prototype.computeBufferSize = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var objectNumber, header, size, xrefStream, uncompressedObjects, compressedObjects, objectStreamRefs, indirectObjects, idx, len, indirectObject, ref, object, shouldNotCompress, chunk, objectStreamRef, idx, len, chunk, ref, objectStream, xrefStreamRef, xrefOffset, trailer;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        objectNumber = this.context.largestObjectNumber + 1;
                        header = (0, $f5613438da36c90d$export$2e2bcd8739ae039).forVersion(1, 7);
                        size = header.sizeInBytes() + 2;
                        xrefStream = (0, $c48137c8ce877bbb$export$2e2bcd8739ae039).create(this.createTrailerDict(), this.encodeStreams);
                        uncompressedObjects = [];
                        compressedObjects = [];
                        objectStreamRefs = [];
                        indirectObjects = this.context.enumerateIndirectObjects();
                        idx = 0, len = indirectObjects.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            6
                        ];
                        indirectObject = indirectObjects[idx];
                        ref = indirectObject[0], object = indirectObject[1];
                        shouldNotCompress = ref === this.context.trailerInfo.Encrypt || object instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039) || object instanceof (0, $f45442108e8c0086$export$2e2bcd8739ae039) || ref.generationNumber !== 0;
                        if (!shouldNotCompress) return [
                            3 /*break*/ ,
                            4
                        ];
                        uncompressedObjects.push(indirectObject);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize(indirectObject);
                        if (!this.shouldWaitForTick(1)) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        chunk = (0, $9uJGW.last)(compressedObjects);
                        objectStreamRef = (0, $9uJGW.last)(objectStreamRefs);
                        if (!chunk || chunk.length % this.objectsPerStream === 0) {
                            chunk = [];
                            compressedObjects.push(chunk);
                            objectStreamRef = (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber++);
                            objectStreamRefs.push(objectStreamRef);
                        }
                        xrefStream.addCompressedEntry(ref, objectStreamRef, chunk.length);
                        chunk.push(indirectObject);
                        _a.label = 5;
                    case 5:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 6:
                        idx = 0, len = compressedObjects.length;
                        _a.label = 7;
                    case 7:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            10
                        ];
                        chunk = compressedObjects[idx];
                        ref = objectStreamRefs[idx];
                        objectStream = (0, $8e78bed3cca47bde$export$2e2bcd8739ae039).withContextAndObjects(this.context, chunk, this.encodeStreams);
                        xrefStream.addUncompressedEntry(ref, size);
                        size += this.computeIndirectObjectSize([
                            ref,
                            objectStream
                        ]);
                        uncompressedObjects.push([
                            ref,
                            objectStream
                        ]);
                        if (!this.shouldWaitForTick(chunk.length)) return [
                            3 /*break*/ ,
                            9
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 8:
                        _a.sent();
                        _a.label = 9;
                    case 9:
                        idx++;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 10:
                        xrefStreamRef = (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber++);
                        xrefStream.dict.set((0, $btXS2.default).of('Size'), (0, $8LDYe.default).of(objectNumber));
                        xrefStream.addUncompressedEntry(xrefStreamRef, size);
                        xrefOffset = size;
                        size += this.computeIndirectObjectSize([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        uncompressedObjects.push([
                            xrefStreamRef,
                            xrefStream
                        ]);
                        trailer = (0, $6d6dcbc50b56a324$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(xrefOffset);
                        size += trailer.sizeInBytes();
                        return [
                            2 /*return*/ ,
                            {
                                size: size,
                                header: header,
                                indirectObjects: uncompressedObjects,
                                trailer: trailer
                            }
                        ];
                }
            });
        });
    };
    PDFStreamWriter.forContext = function(context, objectsPerTick, encodeStreams, objectsPerStream) {
        if (encodeStreams === void 0) encodeStreams = true;
        if (objectsPerStream === void 0) objectsPerStream = 50;
        return new PDFStreamWriter(context, objectsPerTick, encodeStreams, objectsPerStream);
    };
    return PDFStreamWriter;
}((0, $f2f3b70d990f0d2f$export$2e2bcd8739ae039));
var $343225d647cb5158$export$2e2bcd8739ae039 = $343225d647cb5158$var$PDFStreamWriter;






parcelRequire("d2BN5");
var $a7rt6 = parcelRequire("a7rt6");
var $4alS3 = parcelRequire("4alS3");

var $70JnX = parcelRequire("70JnX");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $9ZNih = parcelRequire("9ZNih");
var $aMBsn = parcelRequire("aMBsn");

var $1jVcF = parcelRequire("1jVcF");
var $2b3daf6a3e32a14e$var$PDFHexString = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFHexString, _super);
    function PDFHexString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFHexString.prototype.asBytes = function() {
        // Append a zero if the number of digits is odd. See PDF spec 7.3.4.3
        var hex = this.value + (this.value.length % 2 === 1 ? '0' : '');
        var hexLength = hex.length;
        var bytes = new Uint8Array(hex.length / 2);
        var hexOffset = 0;
        var bytesOffset = 0;
        // Interpret each pair of hex digits as a single byte
        while(hexOffset < hexLength){
            var byte = parseInt(hex.substring(hexOffset, hexOffset + 2), 16);
            bytes[bytesOffset] = byte;
            hexOffset += 2;
            bytesOffset += 1;
        }
        return bytes;
    };
    PDFHexString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $9ZNih.hasUtf16BOM)(bytes)) return (0, $9ZNih.utf16Decode)(bytes);
        return (0, $aMBsn.pdfDocEncodingDecode)(bytes);
    };
    PDFHexString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $c6a2W.parseDate)(text);
        if (!date) throw new (0, $1jVcF.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFHexString.prototype.asString = function() {
        return this.value;
    };
    PDFHexString.prototype.clone = function() {
        return PDFHexString.of(this.value);
    };
    PDFHexString.prototype.toString = function() {
        return "<" + this.value + ">";
    };
    PDFHexString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFHexString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $lJYRg.default).LessThan;
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).GreaterThan;
        return this.value.length + 2;
    };
    PDFHexString.of = function(value) {
        return new PDFHexString(value);
    };
    PDFHexString.fromText = function(value) {
        var encoded = (0, $9ZNih.utf16Encode)(value);
        var hex = '';
        for(var idx = 0, len = encoded.length; idx < len; idx++)hex += (0, $c6a2W.toHexStringOfMinLength)(encoded[idx], 4);
        return new PDFHexString(hex);
    };
    return PDFHexString;
}((0, $iyqEO.default));
var $2b3daf6a3e32a14e$export$2e2bcd8739ae039 = $2b3daf6a3e32a14e$var$PDFHexString;


parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/f91bdd61c164a72ea06be1a43dc0a412afc3925f/lib/font/afm.coffee
 */ var $b2a95496f8f41048$var$StandardFontEmbedder = /** @class */ function() {
    function StandardFontEmbedder(fontName, customName) {
        // prettier-ignore
        this.encoding = fontName === (0, $4alS3.FontNames).ZapfDingbats ? (0, $a7rt6.Encodings).ZapfDingbats : fontName === (0, $4alS3.FontNames).Symbol ? (0, $a7rt6.Encodings).Symbol : (0, $a7rt6.Encodings).WinAnsi;
        this.font = (0, $4alS3.Font).load(fontName);
        this.fontName = this.font.FontName;
        this.customName = customName;
    }
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but standard fonts use either WinAnsi, ZapfDingbats, or Symbol
     * encodings)
     */ StandardFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $c6a2W.toHexString)(glyphs[idx].code);
        return (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    StandardFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.encodeTextAsGlyphs(text);
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var left = glyphs[idx].name;
            var right = (glyphs[idx + 1] || {}).name;
            var kernAmount = this.font.getXAxisKerningForPair(left, right) || 0;
            totalWidth += this.widthOfGlyph(left) + kernAmount;
        }
        var scale = size / 1000;
        return totalWidth * scale;
    };
    StandardFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, Ascender = _b.Ascender, Descender = _b.Descender, FontBBox = _b.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        var height = yTop - yBottom;
        if (!descender) height += Descender || 0;
        return height / 1000 * size;
    };
    StandardFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, Ascender = _a.Ascender, Descender = _a.Descender, FontBBox = _a.FontBBox;
        var yTop = Ascender || FontBBox[3];
        var yBottom = Descender || FontBBox[1];
        return 1000 * height / (yTop - yBottom);
    };
    StandardFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        var fontDict = context.obj({
            Type: 'Font',
            Subtype: 'Type1',
            BaseFont: this.customName || this.fontName,
            Encoding: this.encoding === (0, $a7rt6.Encodings).WinAnsi ? 'WinAnsiEncoding' : undefined
        });
        if (ref) {
            context.assign(ref, fontDict);
            return ref;
        } else return context.register(fontDict);
    };
    StandardFontEmbedder.prototype.widthOfGlyph = function(glyphName) {
        // Default to 250 if font doesn't specify a width
        return this.font.getWidthOfGlyph(glyphName) || 250;
    };
    StandardFontEmbedder.prototype.encodeTextAsGlyphs = function(text) {
        var codePoints = Array.from(text);
        var glyphs = new Array(codePoints.length);
        for(var idx = 0, len = codePoints.length; idx < len; idx++){
            var codePoint = (0, $c6a2W.toCodePoint)(codePoints[idx]);
            glyphs[idx] = this.encoding.encodeUnicodeCodePoint(codePoint);
        }
        return glyphs;
    };
    StandardFontEmbedder.for = function(fontName, customName) {
        return new StandardFontEmbedder(fontName, customName);
    };
    return StandardFontEmbedder;
}();
var $b2a95496f8f41048$export$2e2bcd8739ae039 = $b2a95496f8f41048$var$StandardFontEmbedder;



var $70JnX = parcelRequire("70JnX");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");

var $9ZNih = parcelRequire("9ZNih");
var $e06a638e7679b1d8$export$ecb273704ecc155f = function(glyphs, glyphId) {
    var bfChars = new Array(glyphs.length);
    for(var idx = 0, len = glyphs.length; idx < len; idx++){
        var glyph = glyphs[idx];
        var id = $e06a638e7679b1d8$var$cmapHexFormat($e06a638e7679b1d8$var$cmapHexString(glyphId(glyph)));
        var unicode = $e06a638e7679b1d8$var$cmapHexFormat.apply(void 0, glyph.codePoints.map($e06a638e7679b1d8$var$cmapCodePointFormat));
        bfChars[idx] = [
            id,
            unicode
        ];
    }
    return $e06a638e7679b1d8$var$fillCmapTemplate(bfChars);
};
/* =============================== Templates ================================ */ var $e06a638e7679b1d8$var$fillCmapTemplate = function(bfChars) {
    return "/CIDInit /ProcSet findresource begin\n12 dict begin\nbegincmap\n/CIDSystemInfo <<\n  /Registry (Adobe)\n  /Ordering (UCS)\n  /Supplement 0\n>> def\n/CMapName /Adobe-Identity-UCS def\n/CMapType 2 def\n1 begincodespacerange\n<0000><ffff>\nendcodespacerange\n" + bfChars.length + " beginbfchar\n" + bfChars.map(function(_a) {
        var glyphId = _a[0], codePoint = _a[1];
        return glyphId + " " + codePoint;
    }).join('\n') + "\nendbfchar\nendcmap\nCMapName currentdict /CMap defineresource pop\nend\nend";
};
/* =============================== Utilities ================================ */ var $e06a638e7679b1d8$var$cmapHexFormat = function() {
    var values = [];
    for(var _i = 0; _i < arguments.length; _i++)values[_i] = arguments[_i];
    return "<" + values.join('') + ">";
};
var $e06a638e7679b1d8$var$cmapHexString = function(value) {
    return (0, $c6a2W.toHexStringOfMinLength)(value, 4);
};
var $e06a638e7679b1d8$var$cmapCodePointFormat = function(codePoint) {
    if ((0, $9ZNih.isWithinBMP)(codePoint)) return $e06a638e7679b1d8$var$cmapHexString(codePoint);
    if ((0, $9ZNih.hasSurrogates)(codePoint)) {
        var hs = (0, $9ZNih.highSurrogate)(codePoint);
        var ls = (0, $9ZNih.lowSurrogate)(codePoint);
        return "" + $e06a638e7679b1d8$var$cmapHexString(hs) + $e06a638e7679b1d8$var$cmapHexString(ls);
    }
    var hex = (0, $c6a2W.toHexString)(codePoint);
    var msg = "0x" + hex + " is not a valid UTF-8 or UTF-16 codepoint.";
    throw new Error(msg);
};


// prettier-ignore
var $b0fcbdbac9e9550b$var$makeFontFlags = function(options) {
    var flags = 0;
    var flipBit = function(bit) {
        flags |= 1 << bit - 1;
    };
    if (options.fixedPitch) flipBit(1);
    if (options.serif) flipBit(2);
    if (options.symbolic) flipBit(3);
    if (options.script) flipBit(4);
    if (options.nonsymbolic) flipBit(6);
    if (options.italic) flipBit(7);
    if (options.allCap) flipBit(17);
    if (options.smallCap) flipBit(18);
    if (options.forceBold) flipBit(19);
    return flags;
};
var $b0fcbdbac9e9550b$export$aa92af1a056b24e8 = function(font) {
    var familyClass = font['OS/2'] ? font['OS/2'].sFamilyClass : 0;
    var flags = $b0fcbdbac9e9550b$var$makeFontFlags({
        fixedPitch: font.post.isFixedPitch,
        serif: 1 <= familyClass && familyClass <= 7,
        symbolic: true,
        script: familyClass === 10,
        italic: font.head.macStyle.italic
    });
    return flags;
};




var $70JnX = parcelRequire("70JnX");

var $iyqEO = parcelRequire("iyqEO");

var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $9ZNih = parcelRequire("9ZNih");
var $aMBsn = parcelRequire("aMBsn");

var $1jVcF = parcelRequire("1jVcF");
var $47c89398cba1043c$var$PDFString = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFString, _super);
    function PDFString(value) {
        var _this = _super.call(this) || this;
        _this.value = value;
        return _this;
    }
    PDFString.prototype.asBytes = function() {
        var bytes = [];
        var octal = '';
        var escaped = false;
        var pushByte = function(byte) {
            if (byte !== undefined) bytes.push(byte);
            escaped = false;
        };
        for(var idx = 0, len = this.value.length; idx < len; idx++){
            var char = this.value[idx];
            var byte = (0, $c6a2W.toCharCode)(char);
            var nextChar = this.value[idx + 1];
            if (!escaped) {
                if (byte === (0, $lJYRg.default).BackSlash) escaped = true;
                else pushByte(byte);
            } else {
                if (byte === (0, $lJYRg.default).Newline) pushByte();
                else if (byte === (0, $lJYRg.default).CarriageReturn) pushByte();
                else if (byte === (0, $lJYRg.default).n) pushByte((0, $lJYRg.default).Newline);
                else if (byte === (0, $lJYRg.default).r) pushByte((0, $lJYRg.default).CarriageReturn);
                else if (byte === (0, $lJYRg.default).t) pushByte((0, $lJYRg.default).Tab);
                else if (byte === (0, $lJYRg.default).b) pushByte((0, $lJYRg.default).Backspace);
                else if (byte === (0, $lJYRg.default).f) pushByte((0, $lJYRg.default).FormFeed);
                else if (byte === (0, $lJYRg.default).LeftParen) pushByte((0, $lJYRg.default).LeftParen);
                else if (byte === (0, $lJYRg.default).RightParen) pushByte((0, $lJYRg.default).RightParen);
                else if (byte === (0, $lJYRg.default).Backspace) pushByte((0, $lJYRg.default).BackSlash);
                else if (byte >= (0, $lJYRg.default).Zero && byte <= (0, $lJYRg.default).Seven) {
                    octal += char;
                    if (octal.length === 3 || !(nextChar >= '0' && nextChar <= '7')) {
                        pushByte(parseInt(octal, 8));
                        octal = '';
                    }
                } else pushByte(byte);
            }
        }
        return new Uint8Array(bytes);
    };
    PDFString.prototype.decodeText = function() {
        var bytes = this.asBytes();
        if ((0, $9ZNih.hasUtf16BOM)(bytes)) return (0, $9ZNih.utf16Decode)(bytes);
        return (0, $aMBsn.pdfDocEncodingDecode)(bytes);
    };
    PDFString.prototype.decodeDate = function() {
        var text = this.decodeText();
        var date = (0, $c6a2W.parseDate)(text);
        if (!date) throw new (0, $1jVcF.InvalidPDFDateStringError)(text);
        return date;
    };
    PDFString.prototype.asString = function() {
        return this.value;
    };
    PDFString.prototype.clone = function() {
        return PDFString.of(this.value);
    };
    PDFString.prototype.toString = function() {
        return "(" + this.value + ")";
    };
    PDFString.prototype.sizeInBytes = function() {
        return this.value.length + 2;
    };
    PDFString.prototype.copyBytesInto = function(buffer, offset) {
        buffer[offset++] = (0, $lJYRg.default).LeftParen;
        offset += (0, $c6a2W.copyStringIntoBuffer)(this.value, buffer, offset);
        buffer[offset++] = (0, $lJYRg.default).RightParen;
        return this.value.length + 2;
    };
    // The PDF spec allows newlines and parens to appear directly within a literal
    // string. These character _may_ be escaped. But they do not _have_ to be. So
    // for simplicity, we will not bother escaping them.
    PDFString.of = function(value) {
        return new PDFString(value);
    };
    PDFString.fromDate = function(date) {
        var year = (0, $c6a2W.padStart)(String(date.getUTCFullYear()), 4, '0');
        var month = (0, $c6a2W.padStart)(String(date.getUTCMonth() + 1), 2, '0');
        var day = (0, $c6a2W.padStart)(String(date.getUTCDate()), 2, '0');
        var hours = (0, $c6a2W.padStart)(String(date.getUTCHours()), 2, '0');
        var mins = (0, $c6a2W.padStart)(String(date.getUTCMinutes()), 2, '0');
        var secs = (0, $c6a2W.padStart)(String(date.getUTCSeconds()), 2, '0');
        return new PDFString("D:" + year + month + day + hours + mins + secs + "Z");
    };
    return PDFString;
}((0, $iyqEO.default));
var $47c89398cba1043c$export$2e2bcd8739ae039 = $47c89398cba1043c$var$PDFString;


parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
var $cLyfO = parcelRequire("cLyfO");
var $c6a2W = parcelRequire("c6a2W");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $ce290f01ecd7d7e1$var$CustomFontEmbedder = /** @class */ function() {
    function CustomFontEmbedder(font, fontData, customName, fontFeatures) {
        var _this = this;
        this.allGlyphsInFontSortedById = function() {
            var glyphs = new Array(_this.font.characterSet.length);
            for(var idx = 0, len = glyphs.length; idx < len; idx++){
                var codePoint = _this.font.characterSet[idx];
                glyphs[idx] = _this.font.glyphForCodePoint(codePoint);
            }
            return (0, $9uJGW.sortedUniq)(glyphs.sort((0, $9uJGW.byAscendingId)), function(g) {
                return g.id;
            });
        };
        this.font = font;
        this.scale = 1000 / this.font.unitsPerEm;
        this.fontData = fontData;
        this.fontName = this.font.postscriptName || 'Font';
        this.customName = customName;
        this.fontFeatures = fontFeatures;
        this.baseFontName = '';
        this.glyphCache = (0, $cLyfO.default).populatedBy(this.allGlyphsInFontSortedById);
    }
    CustomFontEmbedder.for = function(fontkit, fontData, customName, fontFeatures) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontEmbedder(font, fontData, customName, fontFeatures)
                        ];
                }
            });
        });
    };
    /**
     * Encode the JavaScript string into this font. (JavaScript encodes strings in
     * Unicode, but embedded fonts use their own custom encodings)
     */ CustomFontEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++)hexCodes[idx] = (0, $c6a2W.toHexStringOfMinLength)(glyphs[idx].id, 4);
        return (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    // The advanceWidth takes into account kerning automatically, so we don't
    // have to do that manually like we do for the standard fonts.
    CustomFontEmbedder.prototype.widthOfTextAtSize = function(text, size) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var totalWidth = 0;
        for(var idx = 0, len = glyphs.length; idx < len; idx++)totalWidth += glyphs[idx].advanceWidth * this.scale;
        var scale = size / 1000;
        return totalWidth * scale;
    };
    CustomFontEmbedder.prototype.heightOfFontAtSize = function(size, options) {
        if (options === void 0) options = {};
        var _a = options.descender, descender = _a === void 0 ? true : _a;
        var _b = this.font, ascent = _b.ascent, descent = _b.descent, bbox = _b.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        var height = yTop - yBottom;
        if (!descender) height -= Math.abs(descent) || 0;
        return height / 1000 * size;
    };
    CustomFontEmbedder.prototype.sizeOfFontAtHeight = function(height) {
        var _a = this.font, ascent = _a.ascent, descent = _a.descent, bbox = _a.bbox;
        var yTop = (ascent || bbox.maxY) * this.scale;
        var yBottom = (descent || bbox.minY) * this.scale;
        return 1000 * height / (yTop - yBottom);
    };
    CustomFontEmbedder.prototype.embedIntoContext = function(context, ref) {
        this.baseFontName = this.customName || context.addRandomSuffix(this.fontName);
        return this.embedFontDict(context, ref);
    };
    CustomFontEmbedder.prototype.embedFontDict = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var cidFontDictRef, unicodeCMapRef, fontDict;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedCIDFontDict(context)
                        ];
                    case 1:
                        cidFontDictRef = _a.sent();
                        unicodeCMapRef = this.embedUnicodeCmap(context);
                        fontDict = context.obj({
                            Type: 'Font',
                            Subtype: 'Type0',
                            BaseFont: this.baseFontName,
                            Encoding: 'Identity-H',
                            DescendantFonts: [
                                cidFontDictRef
                            ],
                            ToUnicode: unicodeCMapRef
                        });
                        if (ref) {
                            context.assign(ref, fontDict);
                            return [
                                2 /*return*/ ,
                                ref
                            ];
                        } else return [
                            2 /*return*/ ,
                            context.register(fontDict)
                        ];
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.isCFF = function() {
        return this.font.cff;
    };
    CustomFontEmbedder.prototype.embedCIDFontDict = function(context) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var fontDescriptorRef, cidFontDict;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontDescriptor(context)
                        ];
                    case 1:
                        fontDescriptorRef = _a.sent();
                        cidFontDict = context.obj({
                            Type: 'Font',
                            Subtype: this.isCFF() ? 'CIDFontType0' : 'CIDFontType2',
                            CIDToGIDMap: 'Identity',
                            BaseFont: this.baseFontName,
                            CIDSystemInfo: {
                                Registry: (0, $47c89398cba1043c$export$2e2bcd8739ae039).of('Adobe'),
                                Ordering: (0, $47c89398cba1043c$export$2e2bcd8739ae039).of('Identity'),
                                Supplement: 0
                            },
                            FontDescriptor: fontDescriptorRef,
                            W: this.computeWidths()
                        });
                        return [
                            2 /*return*/ ,
                            context.register(cidFontDict)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontDescriptor = function(context) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var fontStreamRef, scale, _a, italicAngle, ascent, descent, capHeight, xHeight, _b, minX, minY, maxX, maxY, fontDescriptor;
            var _c;
            return (0, $70JnX.__generator)(this, function(_d) {
                switch(_d.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedFontStream(context)
                        ];
                    case 1:
                        fontStreamRef = _d.sent();
                        scale = this.scale;
                        _a = this.font, italicAngle = _a.italicAngle, ascent = _a.ascent, descent = _a.descent, capHeight = _a.capHeight, xHeight = _a.xHeight;
                        _b = this.font.bbox, minX = _b.minX, minY = _b.minY, maxX = _b.maxX, maxY = _b.maxY;
                        fontDescriptor = context.obj((_c = {
                            Type: 'FontDescriptor',
                            FontName: this.baseFontName,
                            Flags: (0, $b0fcbdbac9e9550b$export$aa92af1a056b24e8)(this.font),
                            FontBBox: [
                                minX * scale,
                                minY * scale,
                                maxX * scale,
                                maxY * scale
                            ],
                            ItalicAngle: italicAngle,
                            Ascent: ascent * scale,
                            Descent: descent * scale,
                            CapHeight: (capHeight || ascent) * scale,
                            XHeight: (xHeight || 0) * scale,
                            // Not sure how to compute/find this, nor is anybody else really:
                            // https://stackoverflow.com/questions/35485179/stemv-value-of-the-truetype-font
                            StemV: 0
                        }, _c[this.isCFF() ? 'FontFile3' : 'FontFile2'] = fontStreamRef, _c));
                        return [
                            2 /*return*/ ,
                            context.register(fontDescriptor)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.serializeFont = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    this.fontData
                ];
            });
        });
    };
    CustomFontEmbedder.prototype.embedFontStream = function(context) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var fontStream, _a, _b;
            return (0, $70JnX.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _b = (_a = context).flateStream;
                        return [
                            4 /*yield*/ ,
                            this.serializeFont()
                        ];
                    case 1:
                        fontStream = _b.apply(_a, [
                            _c.sent(),
                            {
                                Subtype: this.isCFF() ? 'CIDFontType0C' : undefined
                            }
                        ]);
                        return [
                            2 /*return*/ ,
                            context.register(fontStream)
                        ];
                }
            });
        });
    };
    CustomFontEmbedder.prototype.embedUnicodeCmap = function(context) {
        var cmap = (0, $e06a638e7679b1d8$export$ecb273704ecc155f)(this.glyphCache.access(), this.glyphId.bind(this));
        var cmapStream = context.flateStream(cmap);
        return context.register(cmapStream);
    };
    CustomFontEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? glyph.id : -1;
    };
    CustomFontEmbedder.prototype.computeWidths = function() {
        var glyphs = this.glyphCache.access();
        var widths = [];
        var currSection = [];
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var currGlyph = glyphs[idx];
            var prevGlyph = glyphs[idx - 1];
            var currGlyphId = this.glyphId(currGlyph);
            var prevGlyphId = this.glyphId(prevGlyph);
            if (idx === 0) widths.push(currGlyphId);
            else if (currGlyphId - prevGlyphId !== 1) {
                widths.push(currSection);
                widths.push(currGlyphId);
                currSection = [];
            }
            currSection.push(currGlyph.advanceWidth * this.scale);
        }
        widths.push(currSection);
        return widths;
    };
    return CustomFontEmbedder;
}();
var $ce290f01ecd7d7e1$export$2e2bcd8739ae039 = $ce290f01ecd7d7e1$var$CustomFontEmbedder;



var $70JnX = parcelRequire("70JnX");


parcelRequire("JEL7f");
var $cLyfO = parcelRequire("cLyfO");
var $9uJGW = parcelRequire("9uJGW");
var $c6a2W = parcelRequire("c6a2W");
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/jpeg.coffee
 */ var $e801409ba06cce4c$var$CustomFontSubsetEmbedder = /** @class */ function(_super) {
    (0, $70JnX.__extends)(CustomFontSubsetEmbedder, _super);
    function CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures) {
        var _this = _super.call(this, font, fontData, customFontName, fontFeatures) || this;
        _this.subset = _this.font.createSubset();
        _this.glyphs = [];
        _this.glyphCache = (0, $cLyfO.default).populatedBy(function() {
            return _this.glyphs;
        });
        _this.glyphIdMap = new Map();
        return _this;
    }
    CustomFontSubsetEmbedder.for = function(fontkit, fontData, customFontName, fontFeatures) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var font;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            fontkit.create(fontData)
                        ];
                    case 1:
                        font = _a.sent();
                        return [
                            2 /*return*/ ,
                            new CustomFontSubsetEmbedder(font, fontData, customFontName, fontFeatures)
                        ];
                }
            });
        });
    };
    CustomFontSubsetEmbedder.prototype.encodeText = function(text) {
        var glyphs = this.font.layout(text, this.fontFeatures).glyphs;
        var hexCodes = new Array(glyphs.length);
        for(var idx = 0, len = glyphs.length; idx < len; idx++){
            var glyph = glyphs[idx];
            var subsetGlyphId = this.subset.includeGlyph(glyph);
            this.glyphs[subsetGlyphId - 1] = glyph;
            this.glyphIdMap.set(glyph.id, subsetGlyphId);
            hexCodes[idx] = (0, $c6a2W.toHexStringOfMinLength)(subsetGlyphId, 4);
        }
        this.glyphCache.invalidate();
        return (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).of(hexCodes.join(''));
    };
    CustomFontSubsetEmbedder.prototype.isCFF = function() {
        return this.subset.cff;
    };
    CustomFontSubsetEmbedder.prototype.glyphId = function(glyph) {
        return glyph ? this.glyphIdMap.get(glyph.id) : -1;
    };
    CustomFontSubsetEmbedder.prototype.serializeFont = function() {
        var _this = this;
        return new Promise(function(resolve, reject) {
            var parts = [];
            _this.subset.encodeStream().on('data', function(bytes) {
                return parts.push(bytes);
            }).on('end', function() {
                return resolve((0, $9uJGW.mergeUint8Arrays)(parts));
            }).on('error', function(err) {
                return reject(err);
            });
        });
    };
    return CustomFontSubsetEmbedder;
}((0, $ce290f01ecd7d7e1$export$2e2bcd8739ae039));
var $e801409ba06cce4c$export$2e2bcd8739ae039 = $e801409ba06cce4c$var$CustomFontSubsetEmbedder;



var $70JnX = parcelRequire("70JnX");


var $905acc2e8a6e5b91$export$c12eac46fbec1b74;
(function(AFRelationship) {
    AFRelationship["Source"] = "Source";
    AFRelationship["Data"] = "Data";
    AFRelationship["Alternative"] = "Alternative";
    AFRelationship["Supplement"] = "Supplement";
    AFRelationship["EncryptedPayload"] = "EncryptedPayload";
    AFRelationship["FormData"] = "EncryptedPayload";
    AFRelationship["Schema"] = "Schema";
    AFRelationship["Unspecified"] = "Unspecified";
})($905acc2e8a6e5b91$export$c12eac46fbec1b74 || ($905acc2e8a6e5b91$export$c12eac46fbec1b74 = {}));
var $905acc2e8a6e5b91$var$FileEmbedder = /** @class */ function() {
    function FileEmbedder(fileData, fileName, options) {
        if (options === void 0) options = {};
        this.fileData = fileData;
        this.fileName = fileName;
        this.options = options;
    }
    FileEmbedder.for = function(bytes, fileName, options) {
        if (options === void 0) options = {};
        return new FileEmbedder(bytes, fileName, options);
    };
    FileEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, mimeType, description, creationDate, modificationDate, afRelationship, embeddedFileStream, embeddedFileStreamRef, fileSpecDict;
            return (0, $70JnX.__generator)(this, function(_b) {
                _a = this.options, mimeType = _a.mimeType, description = _a.description, creationDate = _a.creationDate, modificationDate = _a.modificationDate, afRelationship = _a.afRelationship;
                embeddedFileStream = context.flateStream(this.fileData, {
                    Type: 'EmbeddedFile',
                    Subtype: mimeType !== null && mimeType !== void 0 ? mimeType : undefined,
                    Params: {
                        Size: this.fileData.length,
                        CreationDate: creationDate ? (0, $47c89398cba1043c$export$2e2bcd8739ae039).fromDate(creationDate) : undefined,
                        ModDate: modificationDate ? (0, $47c89398cba1043c$export$2e2bcd8739ae039).fromDate(modificationDate) : undefined
                    }
                });
                embeddedFileStreamRef = context.register(embeddedFileStream);
                fileSpecDict = context.obj({
                    Type: 'Filespec',
                    F: (0, $47c89398cba1043c$export$2e2bcd8739ae039).of(this.fileName),
                    UF: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(this.fileName),
                    EF: {
                        F: embeddedFileStreamRef
                    },
                    Desc: description ? (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(description) : undefined,
                    AFRelationship: afRelationship !== null && afRelationship !== void 0 ? afRelationship : undefined
                });
                if (ref) {
                    context.assign(ref, fileSpecDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(fileSpecDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return FileEmbedder;
}();
var $905acc2e8a6e5b91$export$2e2bcd8739ae039 = $905acc2e8a6e5b91$var$FileEmbedder;



var $70JnX = parcelRequire("70JnX");
// prettier-ignore
var $b0d34f0e58769ca2$var$MARKERS = [
    0xffc0,
    0xffc1,
    0xffc2,
    0xffc3,
    0xffc5,
    0xffc6,
    0xffc7,
    0xffc8,
    0xffc9,
    0xffca,
    0xffcb,
    0xffcc,
    0xffcd,
    0xffce,
    0xffcf
];
var $b0d34f0e58769ca2$var$ColorSpace;
(function(ColorSpace) {
    ColorSpace["DeviceGray"] = "DeviceGray";
    ColorSpace["DeviceRGB"] = "DeviceRGB";
    ColorSpace["DeviceCMYK"] = "DeviceCMYK";
})($b0d34f0e58769ca2$var$ColorSpace || ($b0d34f0e58769ca2$var$ColorSpace = {}));
var $b0d34f0e58769ca2$var$ChannelToColorSpace = {
    1: $b0d34f0e58769ca2$var$ColorSpace.DeviceGray,
    3: $b0d34f0e58769ca2$var$ColorSpace.DeviceRGB,
    4: $b0d34f0e58769ca2$var$ColorSpace.DeviceCMYK
};
/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/foliojs/pdfkit/blob/a6af76467ce06bd6a2af4aa7271ccac9ff152a7d/lib/image/jpeg.js
 */ var $b0d34f0e58769ca2$var$JpegEmbedder = /** @class */ function() {
    function JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace) {
        this.imageData = imageData;
        this.bitsPerComponent = bitsPerComponent;
        this.width = width;
        this.height = height;
        this.colorSpace = colorSpace;
    }
    JpegEmbedder.for = function(imageData) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var dataView, soi, pos, marker, bitsPerComponent, height, width, channelByte, channelName, colorSpace;
            return (0, $70JnX.__generator)(this, function(_a) {
                dataView = new DataView(imageData.buffer);
                soi = dataView.getUint16(0);
                if (soi !== 0xffd8) throw new Error('SOI not found in JPEG');
                pos = 2;
                while(pos < dataView.byteLength){
                    marker = dataView.getUint16(pos);
                    pos += 2;
                    if ($b0d34f0e58769ca2$var$MARKERS.includes(marker)) break;
                    pos += dataView.getUint16(pos);
                }
                if (!$b0d34f0e58769ca2$var$MARKERS.includes(marker)) throw new Error('Invalid JPEG');
                pos += 2;
                bitsPerComponent = dataView.getUint8(pos++);
                height = dataView.getUint16(pos);
                pos += 2;
                width = dataView.getUint16(pos);
                pos += 2;
                channelByte = dataView.getUint8(pos++);
                channelName = $b0d34f0e58769ca2$var$ChannelToColorSpace[channelByte];
                if (!channelName) throw new Error('Unknown JPEG channel.');
                colorSpace = channelName;
                return [
                    2 /*return*/ ,
                    new JpegEmbedder(imageData, bitsPerComponent, width, height, colorSpace)
                ];
            });
        });
    };
    JpegEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var xObject;
            return (0, $70JnX.__generator)(this, function(_a) {
                xObject = context.stream(this.imageData, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.bitsPerComponent,
                    Width: this.width,
                    Height: this.height,
                    ColorSpace: this.colorSpace,
                    Filter: 'DCTDecode',
                    // CMYK JPEG streams in PDF are typically stored complemented,
                    // with 1 as 'off' and 0 as 'on' (PDF 32000-1:2008, 8.6.4.4).
                    //
                    // Standalone CMYK JPEG (usually exported by Photoshop) are
                    // stored inverse, with 0 as 'off' and 1 as 'on', like RGB.
                    //
                    // Applying a swap here as a hedge that most bytes passing
                    // through this method will benefit from it.
                    Decode: this.colorSpace === $b0d34f0e58769ca2$var$ColorSpace.DeviceCMYK ? [
                        1,
                        0,
                        1,
                        0,
                        1,
                        0,
                        1,
                        0
                    ] : undefined
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JpegEmbedder;
}();
var $b0d34f0e58769ca2$export$2e2bcd8739ae039 = $b0d34f0e58769ca2$var$JpegEmbedder;



var $70JnX = parcelRequire("70JnX");

var $czuCz = parcelRequire("czuCz");
var $42fb3a9da620d66a$var$UPNG = {};
$42fb3a9da620d66a$var$UPNG.toRGBA8 = function(out) {
    var w = out.width, h = out.height;
    if (out.tabs.acTL == null) return [
        $42fb3a9da620d66a$var$UPNG.toRGBA8.decodeImage(out.data, w, h, out).buffer
    ];
    var frms = [];
    if (out.frames[0].data == null) out.frames[0].data = out.data;
    var len = w * h * 4, img = new Uint8Array(len), empty = new Uint8Array(len), prev = new Uint8Array(len);
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i];
        var fx = frm.rect.x, fy = frm.rect.y, fw = frm.rect.width, fh = frm.rect.height;
        var fdata = $42fb3a9da620d66a$var$UPNG.toRGBA8.decodeImage(frm.data, fw, fh, out);
        if (i != 0) for(var j = 0; j < len; j++)prev[j] = img[j];
        if (frm.blend == 0) $42fb3a9da620d66a$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.blend == 1) $42fb3a9da620d66a$var$UPNG._copyTile(fdata, fw, fh, img, w, h, fx, fy, 1);
        frms.push(img.buffer.slice(0));
        if (frm.dispose == 0) ;
        else if (frm.dispose == 1) $42fb3a9da620d66a$var$UPNG._copyTile(empty, fw, fh, img, w, h, fx, fy, 0);
        else if (frm.dispose == 2) for(var j = 0; j < len; j++)img[j] = prev[j];
    }
    return frms;
};
$42fb3a9da620d66a$var$UPNG.toRGBA8.decodeImage = function(data, w, h, out) {
    var area = w * h, bpp = $42fb3a9da620d66a$var$UPNG.decode._getBPP(out);
    var bpl = Math.ceil(w * bpp / 8); // bytes per line
    var bf = new Uint8Array(area * 4), bf32 = new Uint32Array(bf.buffer);
    var ctype = out.ctype, depth = out.depth;
    var rs = $42fb3a9da620d66a$var$UPNG._bin.readUshort;
    //console.log(ctype, depth);
    var time = Date.now();
    if (ctype == 6) {
        var qarea = area << 2;
        if (depth == 8) for(var i = 0; i < qarea; i += 4){
            bf[i] = data[i];
            bf[i + 1] = data[i + 1];
            bf[i + 2] = data[i + 2];
            bf[i + 3] = data[i + 3];
        }
        if (depth == 16) for(var i = 0; i < qarea; i++)bf[i] = data[i << 1];
    } else if (ctype == 2) {
        var ts = out.tabs["tRNS"];
        if (ts == null) {
            if (depth == 8) for(var i = 0; i < area; i++){
                var ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
            }
        } else {
            var tr = ts[0], tg = ts[1], tb = ts[2];
            if (depth == 8) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 3;
                bf32[i] = -16777216 | data[ti + 2] << 16 | data[ti + 1] << 8 | data[ti];
                if (data[ti] == tr && data[ti + 1] == tg && data[ti + 2] == tb) bf[qi + 3] = 0;
            }
            if (depth == 16) for(var i = 0; i < area; i++){
                var qi = i << 2, ti = i * 6;
                bf32[i] = -16777216 | data[ti + 4] << 16 | data[ti + 2] << 8 | data[ti];
                if (rs(data, ti) == tr && rs(data, ti + 2) == tg && rs(data, ti + 4) == tb) bf[qi + 3] = 0;
            }
        }
    } else if (ctype == 3) {
        var p = out.tabs["PLTE"], ap = out.tabs["tRNS"], tl = ap ? ap.length : 0;
        //console.log(p, ap);
        if (depth == 1) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 3)] >> 7 - ((i & 7) << 0) & 1, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 2) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 2)] >> 6 - ((i & 3) << 1) & 3, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 4) for(var y = 0; y < h; y++){
            var s0 = y * bpl, t0 = y * w;
            for(var i = 0; i < w; i++){
                var qi = t0 + i << 2, j = data[s0 + (i >> 1)] >> 4 - ((i & 1) << 2) & 15, cj = 3 * j;
                bf[qi] = p[cj];
                bf[qi + 1] = p[cj + 1];
                bf[qi + 2] = p[cj + 2];
                bf[qi + 3] = j < tl ? ap[j] : 255;
            }
        }
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, j = data[i], cj = 3 * j;
            bf[qi] = p[cj];
            bf[qi + 1] = p[cj + 1];
            bf[qi + 2] = p[cj + 2];
            bf[qi + 3] = j < tl ? ap[j] : 255;
        }
    } else if (ctype == 4) {
        if (depth == 8) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 1, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 1];
        }
        if (depth == 16) for(var i = 0; i < area; i++){
            var qi = i << 2, di = i << 2, gr = data[di];
            bf[qi] = gr;
            bf[qi + 1] = gr;
            bf[qi + 2] = gr;
            bf[qi + 3] = data[di + 2];
        }
    } else if (ctype == 0) {
        var tr = out.tabs["tRNS"] ? out.tabs["tRNS"] : -1;
        for(var y = 0; y < h; y++){
            var off = y * bpl, to = y * w;
            if (depth == 1) for(var x = 0; x < w; x++){
                var gr = 255 * (data[off + (x >>> 3)] >>> 7 - (x & 7) & 1), al = gr == tr * 255 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 2) for(var x = 0; x < w; x++){
                var gr = 85 * (data[off + (x >>> 2)] >>> 6 - ((x & 3) << 1) & 3), al = gr == tr * 85 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 4) for(var x = 0; x < w; x++){
                var gr = 17 * (data[off + (x >>> 1)] >>> 4 - ((x & 1) << 2) & 15), al = gr == tr * 17 ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 8) for(var x = 0; x < w; x++){
                var gr = data[off + x], al = gr == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
            else if (depth == 16) for(var x = 0; x < w; x++){
                var gr = data[off + (x << 1)], al = rs(data, off + (x << i)) == tr ? 0 : 255;
                bf32[to + x] = al << 24 | gr << 16 | gr << 8 | gr;
            }
        }
    }
    //console.log(Date.now()-time);
    return bf;
};
$42fb3a9da620d66a$var$UPNG.decode = function(buff) {
    var data = new Uint8Array(buff), offset = 8, bin = $42fb3a9da620d66a$var$UPNG._bin, rUs = bin.readUshort, rUi = bin.readUint;
    var out = {
        tabs: {},
        frames: []
    };
    var dd = new Uint8Array(data.length), doff = 0; // put all IDAT data into it
    var fd, foff = 0; // frames
    var mgck = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)if (data[i] != mgck[i]) throw "The input is not a PNG file!";
    while(offset < data.length){
        var len = bin.readUint(data, offset);
        offset += 4;
        var type = bin.readASCII(data, offset, 4);
        offset += 4;
        //console.log(type,len);
        if (type == "IHDR") $42fb3a9da620d66a$var$UPNG.decode._IHDR(data, offset, out);
        else if (type == "IDAT") {
            for(var i = 0; i < len; i++)dd[doff + i] = data[offset + i];
            doff += len;
        } else if (type == "acTL") {
            out.tabs[type] = {
                num_frames: rUi(data, offset),
                num_plays: rUi(data, offset + 4)
            };
            fd = new Uint8Array(data.length);
        } else if (type == "fcTL") {
            if (foff != 0) {
                var fr = out.frames[out.frames.length - 1];
                fr.data = $42fb3a9da620d66a$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
                foff = 0;
            }
            var rct = {
                x: rUi(data, offset + 12),
                y: rUi(data, offset + 16),
                width: rUi(data, offset + 4),
                height: rUi(data, offset + 8)
            };
            var del = rUs(data, offset + 22);
            del = rUs(data, offset + 20) / (del == 0 ? 100 : del);
            var frm = {
                rect: rct,
                delay: Math.round(del * 1000),
                dispose: data[offset + 24],
                blend: data[offset + 25]
            };
            //console.log(frm);
            out.frames.push(frm);
        } else if (type == "fdAT") {
            for(var i = 0; i < len - 4; i++)fd[foff + i] = data[offset + i + 4];
            foff += len - 4;
        } else if (type == "pHYs") out.tabs[type] = [
            bin.readUint(data, offset),
            bin.readUint(data, offset + 4),
            data[offset + 8]
        ];
        else if (type == "cHRM") {
            out.tabs[type] = [];
            for(var i = 0; i < 8; i++)out.tabs[type].push(bin.readUint(data, offset + i * 4));
        } else if (type == "tEXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = bin.nextZero(data, offset);
            var keyw = bin.readASCII(data, offset, nz - offset);
            var text = bin.readASCII(data, nz + 1, offset + len - nz - 1);
            out.tabs[type][keyw] = text;
        } else if (type == "iTXt") {
            if (out.tabs[type] == null) out.tabs[type] = {};
            var nz = 0, off = offset;
            nz = bin.nextZero(data, off);
            var keyw = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            var cflag = data[off], cmeth = data[off + 1];
            off += 2;
            nz = bin.nextZero(data, off);
            var ltag = bin.readASCII(data, off, nz - off);
            off = nz + 1;
            nz = bin.nextZero(data, off);
            var tkeyw = bin.readUTF8(data, off, nz - off);
            off = nz + 1;
            var text = bin.readUTF8(data, off, len - (off - offset));
            out.tabs[type][keyw] = text;
        } else if (type == "PLTE") out.tabs[type] = bin.readBytes(data, offset, len);
        else if (type == "hIST") {
            var pl = out.tabs["PLTE"].length / 3;
            out.tabs[type] = [];
            for(var i = 0; i < pl; i++)out.tabs[type].push(rUs(data, offset + i * 2));
        } else if (type == "tRNS") {
            if (out.ctype == 3) out.tabs[type] = bin.readBytes(data, offset, len);
            else if (out.ctype == 0) out.tabs[type] = rUs(data, offset);
            else if (out.ctype == 2) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
        //else console.log("tRNS for unsupported color type",out.ctype, len);
        } else if (type == "gAMA") out.tabs[type] = bin.readUint(data, offset) / 100000;
        else if (type == "sRGB") out.tabs[type] = data[offset];
        else if (type == "bKGD") {
            if (out.ctype == 0 || out.ctype == 4) out.tabs[type] = [
                rUs(data, offset)
            ];
            else if (out.ctype == 2 || out.ctype == 6) out.tabs[type] = [
                rUs(data, offset),
                rUs(data, offset + 2),
                rUs(data, offset + 4)
            ];
            else if (out.ctype == 3) out.tabs[type] = data[offset];
        } else if (type == "IEND") break;
        //else {  log("unknown chunk type", type, len);  }
        offset += len;
        var crc = bin.readUint(data, offset);
        offset += 4;
    }
    if (foff != 0) {
        var fr = out.frames[out.frames.length - 1];
        fr.data = $42fb3a9da620d66a$var$UPNG.decode._decompress(out, fd.slice(0, foff), fr.rect.width, fr.rect.height);
        foff = 0;
    }
    out.data = $42fb3a9da620d66a$var$UPNG.decode._decompress(out, dd, out.width, out.height);
    delete out.compress;
    delete out.interlace;
    delete out.filter;
    return out;
};
$42fb3a9da620d66a$var$UPNG.decode._decompress = function(out, dd, w, h) {
    var time = Date.now();
    var bpp = $42fb3a9da620d66a$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), buff = new Uint8Array((bpl + 1 + out.interlace) * h);
    dd = $42fb3a9da620d66a$var$UPNG.decode._inflate(dd, buff);
    //console.log(dd.length, buff.length);
    //console.log(Date.now()-time);
    var time = Date.now();
    if (out.interlace == 0) dd = $42fb3a9da620d66a$var$UPNG.decode._filterZero(dd, out, 0, w, h);
    else if (out.interlace == 1) dd = $42fb3a9da620d66a$var$UPNG.decode._readInterlace(dd, out);
    //console.log(Date.now()-time);
    return dd;
};
$42fb3a9da620d66a$var$UPNG.decode._inflate = function(data, buff) {
    var out = $42fb3a9da620d66a$var$UPNG["inflateRaw"](new Uint8Array(data.buffer, 2, data.length - 6), buff);
    return out;
};
$42fb3a9da620d66a$var$UPNG.inflateRaw = function() {
    var H = {};
    H.H = {};
    H.H.N = function(N, W) {
        var R = Uint8Array, i = 0, m = 0, J = 0, h = 0, Q = 0, X = 0, u = 0, w = 0, d = 0, v, C;
        if (N[0] == 3 && N[1] == 0) return W ? W : new R(0);
        var V = H.H, n = V.b, A = V.e, l = V.R, M = V.n, I = V.A, e = V.Z, b = V.m, Z = W == null;
        if (Z) W = new R(N.length >>> 2 << 3);
        while(i == 0){
            i = n(N, d, 1);
            m = n(N, d + 1, 2);
            d += 3;
            if (m == 0) {
                if ((d & 7) != 0) d += 8 - (d & 7);
                var D = (d >>> 3) + 4, q = N[D - 4] | N[D - 3] << 8;
                if (Z) W = H.H.W(W, w + q);
                W.set(new R(N.buffer, N.byteOffset + D, q), w);
                d = D + q << 3;
                w += q;
                continue;
            }
            if (Z) W = H.H.W(W, w + 131072);
            if (m == 1) {
                v = b.J;
                C = b.h;
                X = 511;
                u = 31;
            }
            if (m == 2) {
                J = A(N, d, 5) + 257;
                h = A(N, d + 5, 5) + 1;
                Q = A(N, d + 10, 4) + 4;
                d += 14;
                var E = d, j = 1;
                for(var c = 0; c < 38; c += 2){
                    b.Q[c] = 0;
                    b.Q[c + 1] = 0;
                }
                for(var c = 0; c < Q; c++){
                    var K = A(N, d + c * 3, 3);
                    b.Q[(b.X[c] << 1) + 1] = K;
                    if (K > j) j = K;
                }
                d += 3 * Q;
                M(b.Q, j);
                I(b.Q, j, b.u);
                v = b.w;
                C = b.d;
                d = l(b.u, (1 << j) - 1, J + h, N, d, b.v);
                var r = V.V(b.v, 0, J, b.C);
                X = (1 << r) - 1;
                var S = V.V(b.v, J, h, b.D);
                u = (1 << S) - 1;
                M(b.C, r);
                I(b.C, r, v);
                M(b.D, S);
                I(b.D, S, C);
            }
            while(true){
                var T = v[e(N, d) & X];
                d += T & 15;
                var p = T >>> 4;
                if (p >>> 8 == 0) W[w++] = p;
                else if (p == 256) break;
                else {
                    var z = w + p - 254;
                    if (p > 264) {
                        var _ = b.q[p - 257];
                        z = w + (_ >>> 3) + A(N, d, _ & 7);
                        d += _ & 7;
                    }
                    var $ = C[e(N, d) & u];
                    d += $ & 15;
                    var s = $ >>> 4, Y = b.c[s], a = (Y >>> 4) + n(N, d, Y & 15);
                    d += Y & 15;
                    while(w < z){
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                        W[w] = W[w++ - a];
                    }
                    w = z;
                }
            }
        }
        return W.length == w ? W : W.slice(0, w);
    };
    H.H.W = function(N, W) {
        var R = N.length;
        if (W <= R) return N;
        var V = new Uint8Array(R << 1);
        V.set(N, 0);
        return V;
    };
    H.H.R = function(N, W, R, V, n, A) {
        var l = H.H.e, M = H.H.Z, I = 0;
        while(I < R){
            var e = N[M(V, n) & W];
            n += e & 15;
            var b = e >>> 4;
            if (b <= 15) {
                A[I] = b;
                I++;
            } else {
                var Z = 0, m = 0;
                if (b == 16) {
                    m = 3 + l(V, n, 2);
                    n += 2;
                    Z = A[I - 1];
                } else if (b == 17) {
                    m = 3 + l(V, n, 3);
                    n += 3;
                } else if (b == 18) {
                    m = 11 + l(V, n, 7);
                    n += 7;
                }
                var J = I + m;
                while(I < J){
                    A[I] = Z;
                    I++;
                }
            }
        }
        return n;
    };
    H.H.V = function(N, W, R, V) {
        var n = 0, A = 0, l = V.length >>> 1;
        while(A < R){
            var M = N[A + W];
            V[A << 1] = 0;
            V[(A << 1) + 1] = M;
            if (M > n) n = M;
            A++;
        }
        while(A < l){
            V[A << 1] = 0;
            V[(A << 1) + 1] = 0;
            A++;
        }
        return n;
    };
    H.H.n = function(N, W) {
        var R = H.H.m, V = N.length, n, A, l, M, I, e = R.j;
        for(var M = 0; M <= W; M++)e[M] = 0;
        for(M = 1; M < V; M += 2)e[N[M]]++;
        var b = R.K;
        n = 0;
        e[0] = 0;
        for(A = 1; A <= W; A++){
            n = n + e[A - 1] << 1;
            b[A] = n;
        }
        for(l = 0; l < V; l += 2){
            I = N[l + 1];
            if (I != 0) {
                N[l] = b[I];
                b[I]++;
            }
        }
    };
    H.H.A = function(N, W, R) {
        var V = N.length, n = H.H.m, A = n.r;
        for(var l = 0; l < V; l += 2)if (N[l + 1] != 0) {
            var M = l >> 1, I = N[l + 1], e = M << 4 | I, b = W - I, Z = N[l] << b, m = Z + (1 << b);
            while(Z != m){
                var J = A[Z] >>> 15 - W;
                R[J] = e;
                Z++;
            }
        }
    };
    H.H.l = function(N, W) {
        var R = H.H.m.r, V = 15 - W;
        for(var n = 0; n < N.length; n += 2){
            var A = N[n] << W - N[n + 1];
            N[n] = R[A] >>> V;
        }
    };
    H.H.M = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
    };
    H.H.I = function(N, W, R) {
        R = R << (W & 7);
        var V = W >>> 3;
        N[V] |= R;
        N[V + 1] |= R >>> 8;
        N[V + 2] |= R >>> 16;
    };
    H.H.e = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.b = function(N, W, R) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7) & (1 << R) - 1;
    };
    H.H.Z = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16) >>> (W & 7);
    };
    H.H.i = function(N, W) {
        return (N[W >>> 3] | N[(W >>> 3) + 1] << 8 | N[(W >>> 3) + 2] << 16 | N[(W >>> 3) + 3] << 24) >>> (W & 7);
    };
    H.H.m = function() {
        var N = Uint16Array, W = Uint32Array;
        return {
            K: new N(16),
            j: new N(16),
            X: [
                16,
                17,
                18,
                0,
                8,
                7,
                9,
                6,
                10,
                5,
                11,
                4,
                12,
                3,
                13,
                2,
                14,
                1,
                15
            ],
            S: [
                3,
                4,
                5,
                6,
                7,
                8,
                9,
                10,
                11,
                13,
                15,
                17,
                19,
                23,
                27,
                31,
                35,
                43,
                51,
                59,
                67,
                83,
                99,
                115,
                131,
                163,
                195,
                227,
                258,
                999,
                999,
                999
            ],
            T: [
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                0,
                1,
                1,
                1,
                1,
                2,
                2,
                2,
                2,
                3,
                3,
                3,
                3,
                4,
                4,
                4,
                4,
                5,
                5,
                5,
                5,
                0,
                0,
                0,
                0
            ],
            q: new N(32),
            p: [
                1,
                2,
                3,
                4,
                5,
                7,
                9,
                13,
                17,
                25,
                33,
                49,
                65,
                97,
                129,
                193,
                257,
                385,
                513,
                769,
                1025,
                1537,
                2049,
                3073,
                4097,
                6145,
                8193,
                12289,
                16385,
                24577,
                65535,
                65535
            ],
            z: [
                0,
                0,
                0,
                0,
                1,
                1,
                2,
                2,
                3,
                3,
                4,
                4,
                5,
                5,
                6,
                6,
                7,
                7,
                8,
                8,
                9,
                9,
                10,
                10,
                11,
                11,
                12,
                12,
                13,
                13,
                0,
                0
            ],
            c: new W(32),
            J: new N(512),
            _: [],
            h: new N(32),
            $: [],
            w: new N(32768),
            C: [],
            v: [],
            d: new N(32768),
            D: [],
            u: new N(512),
            Q: [],
            r: new N(32768),
            s: new W(286),
            Y: new W(30),
            a: new W(19),
            t: new W(15e3),
            k: new N(65536),
            g: new N(32768)
        };
    }();
    (function() {
        var N = H.H.m, W = 32768;
        for(var R = 0; R < W; R++){
            var V = R;
            V = (V & 2863311530) >>> 1 | (V & 1431655765) << 1;
            V = (V & 3435973836) >>> 2 | (V & 858993459) << 2;
            V = (V & 4042322160) >>> 4 | (V & 252645135) << 4;
            V = (V & 4278255360) >>> 8 | (V & 16711935) << 8;
            N.r[R] = (V >>> 16 | V << 16) >>> 17;
        }
        function n(A, l, M) {
            while(l-- != 0)A.push(0, M);
        }
        for(var R = 0; R < 32; R++){
            N.q[R] = N.S[R] << 3 | N.T[R];
            N.c[R] = N.p[R] << 4 | N.z[R];
        }
        n(N._, 144, 8);
        n(N._, 112, 9);
        n(N._, 24, 7);
        n(N._, 8, 8);
        H.H.n(N._, 9);
        H.H.A(N._, 9, N.J);
        H.H.l(N._, 9);
        n(N.$, 32, 5);
        H.H.n(N.$, 5);
        H.H.A(N.$, 5, N.h);
        H.H.l(N.$, 5);
        n(N.Q, 19, 0);
        n(N.C, 286, 0);
        n(N.D, 30, 0);
        n(N.v, 320, 0);
    })();
    return H.H.N;
}();
$42fb3a9da620d66a$var$UPNG.decode._readInterlace = function(data, out) {
    var w = out.width, h = out.height;
    var bpp = $42fb3a9da620d66a$var$UPNG.decode._getBPP(out), cbpp = bpp >> 3, bpl = Math.ceil(w * bpp / 8);
    var img = new Uint8Array(h * bpl);
    var di = 0;
    var starting_row = [
        0,
        0,
        4,
        0,
        2,
        0,
        1
    ];
    var starting_col = [
        0,
        4,
        0,
        2,
        0,
        1,
        0
    ];
    var row_increment = [
        8,
        8,
        8,
        4,
        4,
        2,
        2
    ];
    var col_increment = [
        8,
        8,
        4,
        4,
        2,
        2,
        1
    ];
    var pass = 0;
    while(pass < 7){
        var ri = row_increment[pass], ci = col_increment[pass];
        var sw = 0, sh = 0;
        var cr = starting_row[pass];
        while(cr < h){
            cr += ri;
            sh++;
        }
        var cc = starting_col[pass];
        while(cc < w){
            cc += ci;
            sw++;
        }
        var bpll = Math.ceil(sw * bpp / 8);
        $42fb3a9da620d66a$var$UPNG.decode._filterZero(data, out, di, sw, sh);
        var y = 0, row = starting_row[pass];
        while(row < h){
            var col = starting_col[pass];
            var cdi = di + y * bpll << 3;
            while(col < w){
                if (bpp == 1) {
                    var val = data[cdi >> 3];
                    val = val >> 7 - (cdi & 7) & 1;
                    img[row * bpl + (col >> 3)] |= val << 7 - ((col & 7) << 0);
                }
                if (bpp == 2) {
                    var val = data[cdi >> 3];
                    val = val >> 6 - (cdi & 7) & 3;
                    img[row * bpl + (col >> 2)] |= val << 6 - ((col & 3) << 1);
                }
                if (bpp == 4) {
                    var val = data[cdi >> 3];
                    val = val >> 4 - (cdi & 7) & 15;
                    img[row * bpl + (col >> 1)] |= val << 4 - ((col & 1) << 2);
                }
                if (bpp >= 8) {
                    var ii = row * bpl + col * cbpp;
                    for(var j = 0; j < cbpp; j++)img[ii + j] = data[(cdi >> 3) + j];
                }
                cdi += bpp;
                col += ci;
            }
            y++;
            row += ri;
        }
        if (sw * sh != 0) di += sh * (1 + bpll);
        pass = pass + 1;
    }
    return img;
};
$42fb3a9da620d66a$var$UPNG.decode._getBPP = function(out) {
    var noc = [
        1,
        null,
        3,
        1,
        2,
        null,
        4
    ][out.ctype];
    return noc * out.depth;
};
$42fb3a9da620d66a$var$UPNG.decode._filterZero = function(data, out, off, w, h) {
    var bpp = $42fb3a9da620d66a$var$UPNG.decode._getBPP(out), bpl = Math.ceil(w * bpp / 8), paeth = $42fb3a9da620d66a$var$UPNG.decode._paeth;
    bpp = Math.ceil(bpp / 8);
    var i = 0, di = 1, type = data[off], x = 0;
    if (type > 1) data[off] = [
        0,
        0,
        1
    ][type - 2];
    if (type == 3) for(x = bpp; x < bpl; x++)data[x + 1] = data[x + 1] + (data[x + 1 - bpp] >>> 1) & 255;
    for(var y = 0; y < h; y++){
        i = off + y * bpl;
        di = i + y + 1;
        type = data[di - 1];
        x = 0;
        if (type == 0) for(; x < bpl; x++)data[i + x] = data[di + x];
        else if (type == 1) {
            for(; x < bpp; x++)data[i + x] = data[di + x];
            for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpp];
        } else if (type == 2) for(; x < bpl; x++)data[i + x] = data[di + x] + data[i + x - bpl];
        else if (type == 3) {
            for(; x < bpp; x++)data[i + x] = data[di + x] + (data[i + x - bpl] >>> 1);
            for(; x < bpl; x++)data[i + x] = data[di + x] + (data[i + x - bpl] + data[i + x - bpp] >>> 1);
        } else {
            for(; x < bpp; x++)data[i + x] = data[di + x] + paeth(0, data[i + x - bpl], 0);
            for(; x < bpl; x++)data[i + x] = data[di + x] + paeth(data[i + x - bpp], data[i + x - bpl], data[i + x - bpp - bpl]);
        }
    }
    return data;
};
$42fb3a9da620d66a$var$UPNG.decode._paeth = function(a, b, c) {
    var p = a + b - c, pa = p - a, pb = p - b, pc = p - c;
    if (pa * pa <= pb * pb && pa * pa <= pc * pc) return a;
    else if (pb * pb <= pc * pc) return b;
    return c;
};
$42fb3a9da620d66a$var$UPNG.decode._IHDR = function(data, offset, out) {
    var bin = $42fb3a9da620d66a$var$UPNG._bin;
    out.width = bin.readUint(data, offset);
    offset += 4;
    out.height = bin.readUint(data, offset);
    offset += 4;
    out.depth = data[offset];
    offset++;
    out.ctype = data[offset];
    offset++;
    out.compress = data[offset];
    offset++;
    out.filter = data[offset];
    offset++;
    out.interlace = data[offset];
    offset++;
};
$42fb3a9da620d66a$var$UPNG._bin = {
    nextZero: function(data, p) {
        while(data[p] != 0)p++;
        return p;
    },
    readUshort: function(buff, p) {
        return buff[p] << 8 | buff[p + 1];
    },
    writeUshort: function(buff, p, n) {
        buff[p] = n >> 8 & 255;
        buff[p + 1] = n & 255;
    },
    readUint: function(buff, p) {
        return buff[p] * 16777216 + (buff[p + 1] << 16 | buff[p + 2] << 8 | buff[p + 3]);
    },
    writeUint: function(buff, p, n) {
        buff[p] = n >> 24 & 255;
        buff[p + 1] = n >> 16 & 255;
        buff[p + 2] = n >> 8 & 255;
        buff[p + 3] = n & 255;
    },
    readASCII: function(buff, p, l) {
        var s = "";
        for(var i = 0; i < l; i++)s += String.fromCharCode(buff[p + i]);
        return s;
    },
    writeASCII: function(data, p, s) {
        for(var i = 0; i < s.length; i++)data[p + i] = s.charCodeAt(i);
    },
    readBytes: function(buff, p, l) {
        var arr = [];
        for(var i = 0; i < l; i++)arr.push(buff[p + i]);
        return arr;
    },
    pad: function(n) {
        return n.length < 2 ? "0" + n : n;
    },
    readUTF8: function(buff, p, l) {
        var s = "", ns;
        for(var i = 0; i < l; i++)s += "%" + $42fb3a9da620d66a$var$UPNG._bin.pad(buff[p + i].toString(16));
        try {
            ns = decodeURIComponent(s);
        } catch (e) {
            return $42fb3a9da620d66a$var$UPNG._bin.readASCII(buff, p, l);
        }
        return ns;
    }
};
$42fb3a9da620d66a$var$UPNG._copyTile = function(sb, sw, sh, tb, tw, th, xoff, yoff, mode) {
    var w = Math.min(sw, tw), h = Math.min(sh, th);
    var si = 0, ti = 0;
    for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
        if (xoff >= 0 && yoff >= 0) {
            si = y * sw + x << 2;
            ti = (yoff + y) * tw + xoff + x << 2;
        } else {
            si = (-yoff + y) * sw - xoff + x << 2;
            ti = y * tw + x << 2;
        }
        if (mode == 0) {
            tb[ti] = sb[si];
            tb[ti + 1] = sb[si + 1];
            tb[ti + 2] = sb[si + 2];
            tb[ti + 3] = sb[si + 3];
        } else if (mode == 1) {
            var fa = sb[si + 3] * (1 / 255), fr = sb[si] * fa, fg = sb[si + 1] * fa, fb = sb[si + 2] * fa;
            var ba = tb[ti + 3] * (1 / 255), br = tb[ti] * ba, bg = tb[ti + 1] * ba, bb = tb[ti + 2] * ba;
            var ifa = 1 - fa, oa = fa + ba * ifa, ioa = oa == 0 ? 0 : 1 / oa;
            tb[ti + 3] = 255 * oa;
            tb[ti + 0] = (fr + br * ifa) * ioa;
            tb[ti + 1] = (fg + bg * ifa) * ioa;
            tb[ti + 2] = (fb + bb * ifa) * ioa;
        } else if (mode == 2) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) {
                tb[ti] = 0;
                tb[ti + 1] = 0;
                tb[ti + 2] = 0;
                tb[ti + 3] = 0;
            } else {
                tb[ti] = fr;
                tb[ti + 1] = fg;
                tb[ti + 2] = fb;
                tb[ti + 3] = fa;
            }
        } else if (mode == 3) {
            var fa = sb[si + 3], fr = sb[si], fg = sb[si + 1], fb = sb[si + 2];
            var ba = tb[ti + 3], br = tb[ti], bg = tb[ti + 1], bb = tb[ti + 2];
            if (fa == ba && fr == br && fg == bg && fb == bb) continue;
            //if(fa!=255 && ba!=0) return false;
            if (fa < 220 && ba > 20) return false;
        }
    }
    return true;
};
$42fb3a9da620d66a$var$UPNG.encode = function(bufs, w, h, ps, dels, tabs, forbidPlte) {
    if (ps == null) ps = 0;
    if (forbidPlte == null) forbidPlte = false;
    var nimg = $42fb3a9da620d66a$var$UPNG.encode.compress(bufs, w, h, ps, [
        false,
        false,
        false,
        0,
        forbidPlte
    ]);
    $42fb3a9da620d66a$var$UPNG.encode.compressPNG(nimg, -1);
    return $42fb3a9da620d66a$var$UPNG.encode._main(nimg, w, h, dels, tabs);
};
$42fb3a9da620d66a$var$UPNG.encodeLL = function(bufs, w, h, cc, ac, depth, dels, tabs) {
    var nimg = {
        ctype: 0 + (cc == 1 ? 0 : 2) + (ac == 0 ? 0 : 4),
        depth: depth,
        frames: []
    };
    var time = Date.now();
    var bipp = (cc + ac) * depth, bipl = bipp * w;
    for(var i = 0; i < bufs.length; i++)nimg.frames.push({
        rect: {
            x: 0,
            y: 0,
            width: w,
            height: h
        },
        img: new Uint8Array(bufs[i]),
        blend: 0,
        dispose: 1,
        bpp: Math.ceil(bipp / 8),
        bpl: Math.ceil(bipl / 8)
    });
    $42fb3a9da620d66a$var$UPNG.encode.compressPNG(nimg, 0, true);
    var out = $42fb3a9da620d66a$var$UPNG.encode._main(nimg, w, h, dels, tabs);
    return out;
};
$42fb3a9da620d66a$var$UPNG.encode._main = function(nimg, w, h, dels, tabs) {
    if (tabs == null) tabs = {};
    var crc = $42fb3a9da620d66a$var$UPNG.crc.crc, wUi = $42fb3a9da620d66a$var$UPNG._bin.writeUint, wUs = $42fb3a9da620d66a$var$UPNG._bin.writeUshort, wAs = $42fb3a9da620d66a$var$UPNG._bin.writeASCII;
    var offset = 8, anim = nimg.frames.length > 1, pltAlpha = false;
    var leng = 33 + (anim ? 20 : 0);
    if (tabs["sRGB"] != null) leng += 13;
    if (tabs["pHYs"] != null) leng += 21;
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        for(var i = 0; i < dl; i++)if (nimg.plte[i] >>> 24 != 255) pltAlpha = true;
        leng += 8 + dl * 3 + 4 + (pltAlpha ? 8 + dl * 1 + 4 : 0);
    }
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) leng += 38;
        leng += fr.cimg.length + 12;
        if (j != 0) leng += 4;
    }
    leng += 12;
    var data = new Uint8Array(leng);
    var wr = [
        0x89,
        0x50,
        0x4e,
        0x47,
        0x0d,
        0x0a,
        0x1a,
        0x0a
    ];
    for(var i = 0; i < 8; i++)data[i] = wr[i];
    wUi(data, offset, 13);
    offset += 4;
    wAs(data, offset, "IHDR");
    offset += 4;
    wUi(data, offset, w);
    offset += 4;
    wUi(data, offset, h);
    offset += 4;
    data[offset] = nimg.depth;
    offset++; // depth
    data[offset] = nimg.ctype;
    offset++; // ctype
    data[offset] = 0;
    offset++; // compress
    data[offset] = 0;
    offset++; // filter
    data[offset] = 0;
    offset++; // interlace
    wUi(data, offset, crc(data, offset - 17, 17));
    offset += 4; // crc
    // 13 bytes to say, that it is sRGB
    if (tabs["sRGB"] != null) {
        wUi(data, offset, 1);
        offset += 4;
        wAs(data, offset, "sRGB");
        offset += 4;
        data[offset] = tabs["sRGB"];
        offset++;
        wUi(data, offset, crc(data, offset - 5, 5));
        offset += 4; // crc
    }
    if (tabs["pHYs"] != null) {
        wUi(data, offset, 9);
        offset += 4;
        wAs(data, offset, "pHYs");
        offset += 4;
        wUi(data, offset, tabs["pHYs"][0]);
        offset += 4;
        wUi(data, offset, tabs["pHYs"][1]);
        offset += 4;
        data[offset] = tabs["pHYs"][2];
        offset++;
        wUi(data, offset, crc(data, offset - 13, 13));
        offset += 4; // crc
    }
    if (anim) {
        wUi(data, offset, 8);
        offset += 4;
        wAs(data, offset, "acTL");
        offset += 4;
        wUi(data, offset, nimg.frames.length);
        offset += 4;
        wUi(data, offset, tabs["loop"] != null ? tabs["loop"] : 0);
        offset += 4;
        wUi(data, offset, crc(data, offset - 12, 12));
        offset += 4; // crc
    }
    if (nimg.ctype == 3) {
        var dl = nimg.plte.length;
        wUi(data, offset, dl * 3);
        offset += 4;
        wAs(data, offset, "PLTE");
        offset += 4;
        for(var i = 0; i < dl; i++){
            var ti = i * 3, c = nimg.plte[i], r = c & 255, g = c >>> 8 & 255, b = c >>> 16 & 255;
            data[offset + ti + 0] = r;
            data[offset + ti + 1] = g;
            data[offset + ti + 2] = b;
        }
        offset += dl * 3;
        wUi(data, offset, crc(data, offset - dl * 3 - 4, dl * 3 + 4));
        offset += 4; // crc
        if (pltAlpha) {
            wUi(data, offset, dl);
            offset += 4;
            wAs(data, offset, "tRNS");
            offset += 4;
            for(var i = 0; i < dl; i++)data[offset + i] = nimg.plte[i] >>> 24 & 255;
            offset += dl;
            wUi(data, offset, crc(data, offset - dl - 4, dl + 4));
            offset += 4; // crc
        }
    }
    var fi = 0;
    for(var j = 0; j < nimg.frames.length; j++){
        var fr = nimg.frames[j];
        if (anim) {
            wUi(data, offset, 26);
            offset += 4;
            wAs(data, offset, "fcTL");
            offset += 4;
            wUi(data, offset, fi++);
            offset += 4;
            wUi(data, offset, fr.rect.width);
            offset += 4;
            wUi(data, offset, fr.rect.height);
            offset += 4;
            wUi(data, offset, fr.rect.x);
            offset += 4;
            wUi(data, offset, fr.rect.y);
            offset += 4;
            wUs(data, offset, dels[j]);
            offset += 2;
            wUs(data, offset, 1000);
            offset += 2;
            data[offset] = fr.dispose;
            offset++; // dispose
            data[offset] = fr.blend;
            offset++; // blend
            wUi(data, offset, crc(data, offset - 30, 30));
            offset += 4; // crc
        }
        var imgd = fr.cimg, dl = imgd.length;
        wUi(data, offset, dl + (j == 0 ? 0 : 4));
        offset += 4;
        var ioff = offset;
        wAs(data, offset, j == 0 ? "IDAT" : "fdAT");
        offset += 4;
        if (j != 0) {
            wUi(data, offset, fi++);
            offset += 4;
        }
        data.set(imgd, offset);
        offset += dl;
        wUi(data, offset, crc(data, ioff, offset - ioff));
        offset += 4; // crc
    }
    wUi(data, offset, 0);
    offset += 4;
    wAs(data, offset, "IEND");
    offset += 4;
    wUi(data, offset, crc(data, offset - 4, 4));
    offset += 4; // crc
    return data.buffer;
};
$42fb3a9da620d66a$var$UPNG.encode.compressPNG = function(out, filter, levelZero) {
    for(var i = 0; i < out.frames.length; i++){
        var frm = out.frames[i], nw = frm.rect.width, nh = frm.rect.height;
        var fdata = new Uint8Array(nh * frm.bpl + nh);
        frm.cimg = $42fb3a9da620d66a$var$UPNG.encode._filterZero(frm.img, nh, frm.bpp, frm.bpl, fdata, filter, levelZero);
    }
};
$42fb3a9da620d66a$var$UPNG.encode.compress = function(bufs, w, h, ps, prms) {
    //var time = Date.now();
    var onlyBlend = prms[0], evenCrd = prms[1], forbidPrev = prms[2], minBits = prms[3], forbidPlte = prms[4];
    var ctype = 6, depth = 8, alphaAnd = 255;
    for(var j = 0; j < bufs.length; j++){
        var img = new Uint8Array(bufs[j]), ilen = img.length;
        for(var i = 0; i < ilen; i += 4)alphaAnd &= img[i + 3];
    }
    var gotAlpha = alphaAnd != 255;
    //console.log("alpha check", Date.now()-time);  time = Date.now();
    //var brute = gotAlpha && forGIF;		// brute : frames can only be copied, not "blended"
    var frms = $42fb3a9da620d66a$var$UPNG.encode.framize(bufs, w, h, onlyBlend, evenCrd, forbidPrev);
    //console.log("framize", Date.now()-time);  time = Date.now();
    var cmap = {}, plte = [], inds = [];
    if (ps != 0) {
        var nbufs = [];
        for(var i = 0; i < frms.length; i++)nbufs.push(frms[i].img.buffer);
        var abuf = $42fb3a9da620d66a$var$UPNG.encode.concatRGBA(nbufs), qres = $42fb3a9da620d66a$var$UPNG.quantize(abuf, ps);
        var cof = 0, bb = new Uint8Array(qres.abuf);
        for(var i = 0; i < frms.length; i++){
            var ti = frms[i].img, bln = ti.length;
            inds.push(new Uint8Array(qres.inds.buffer, cof >> 2, bln >> 2));
            for(var j = 0; j < bln; j += 4){
                ti[j] = bb[cof + j];
                ti[j + 1] = bb[cof + j + 1];
                ti[j + 2] = bb[cof + j + 2];
                ti[j + 3] = bb[cof + j + 3];
            }
            cof += bln;
        }
        for(var i = 0; i < qres.plte.length; i++)plte.push(qres.plte[i].est.rgba);
    //console.log("quantize", Date.now()-time);  time = Date.now();
    } else // what if ps==0, but there are <=256 colors?  we still need to detect, if the palette could be used
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], img32 = new Uint32Array(frm.img.buffer), nw = frm.rect.width, ilen = img32.length;
        var ind = new Uint8Array(ilen);
        inds.push(ind);
        for(var i = 0; i < ilen; i++){
            var c = img32[i];
            if (i != 0 && c == img32[i - 1]) ind[i] = ind[i - 1];
            else if (i > nw && c == img32[i - nw]) ind[i] = ind[i - nw];
            else {
                var cmc = cmap[c];
                if (cmc == null) {
                    cmap[c] = cmc = plte.length;
                    plte.push(c);
                    if (plte.length >= 300) break;
                }
                ind[i] = cmc;
            }
        }
    }
    var cc = plte.length; //console.log("colors:",cc);
    if (cc <= 256 && forbidPlte == false) {
        if (cc <= 2) depth = 1;
        else if (cc <= 4) depth = 2;
        else if (cc <= 16) depth = 4;
        else depth = 8;
        depth = Math.max(depth, minBits);
    }
    for(var j = 0; j < frms.length; j++){
        var frm = frms[j], nx = frm.rect.x, ny = frm.rect.y, nw = frm.rect.width, nh = frm.rect.height;
        var cimg = frm.img, cimg32 = new Uint32Array(cimg.buffer);
        var bpl = 4 * nw, bpp = 4;
        if (cc <= 256 && forbidPlte == false) {
            bpl = Math.ceil(depth * nw / 8);
            var nimg = new Uint8Array(bpl * nh);
            var inj = inds[j];
            for(var y = 0; y < nh; y++){
                var i = y * bpl, ii = y * nw;
                if (depth == 8) for(var x = 0; x < nw; x++)nimg[i + x] = inj[ii + x];
                else if (depth == 4) for(var x = 0; x < nw; x++)nimg[i + (x >> 1)] |= inj[ii + x] << 4 - (x & 1) * 4;
                else if (depth == 2) for(var x = 0; x < nw; x++)nimg[i + (x >> 2)] |= inj[ii + x] << 6 - (x & 3) * 2;
                else if (depth == 1) for(var x = 0; x < nw; x++)nimg[i + (x >> 3)] |= inj[ii + x] << 7 - (x & 7) * 1;
            }
            cimg = nimg;
            ctype = 3;
            bpp = 1;
        } else if (gotAlpha == false && frms.length == 1) {
            var nimg = new Uint8Array(nw * nh * 3), area = nw * nh;
            for(var i = 0; i < area; i++){
                var ti = i * 3, qi = i * 4;
                nimg[ti] = cimg[qi];
                nimg[ti + 1] = cimg[qi + 1];
                nimg[ti + 2] = cimg[qi + 2];
            }
            cimg = nimg;
            ctype = 2;
            bpp = 3;
            bpl = 3 * nw;
        }
        frm.img = cimg;
        frm.bpl = bpl;
        frm.bpp = bpp;
    }
    //console.log("colors => palette indices", Date.now()-time);  time = Date.now();
    return {
        ctype: ctype,
        depth: depth,
        plte: plte,
        frames: frms
    };
};
$42fb3a9da620d66a$var$UPNG.encode.framize = function(bufs, w, h, alwaysBlend, evenCrd, forbidPrev) {
    /*  DISPOSE
	    - 0 : no change
		- 1 : clear to transparent
		- 2 : retstore to content before rendering (previous frame disposed)
		BLEND
		- 0 : replace
		- 1 : blend
	*/ var frms = [];
    for(var j = 0; j < bufs.length; j++){
        var cimg = new Uint8Array(bufs[j]), cimg32 = new Uint32Array(cimg.buffer);
        var nimg;
        var nx = 0, ny = 0, nw = w, nh = h, blend = alwaysBlend ? 1 : 0;
        if (j != 0) {
            var tlim = forbidPrev || alwaysBlend || j == 1 || frms[j - 2].dispose != 0 ? 1 : 2, tstp = 0, tarea = 1e9;
            for(var it = 0; it < tlim; it++){
                var pimg = new Uint8Array(bufs[j - 1 - it]), p32 = new Uint32Array(bufs[j - 1 - it]);
                var mix = w, miy = h, max = -1, may = -1;
                for(var y = 0; y < h; y++)for(var x = 0; x < w; x++){
                    var i = y * w + x;
                    if (cimg32[i] != p32[i]) {
                        if (x < mix) mix = x;
                        if (x > max) max = x;
                        if (y < miy) miy = y;
                        if (y > may) may = y;
                    }
                }
                if (max == -1) mix = miy = max = may = 0;
                if (evenCrd) {
                    if ((mix & 1) == 1) mix--;
                    if ((miy & 1) == 1) miy--;
                }
                var sarea = (max - mix + 1) * (may - miy + 1);
                if (sarea < tarea) {
                    tarea = sarea;
                    tstp = it;
                    nx = mix;
                    ny = miy;
                    nw = max - mix + 1;
                    nh = may - miy + 1;
                }
            }
            // alwaysBlend: pokud zjistím, že blendit nelze, nastavím předchozímu snímku dispose=1. Zajistím, aby obsahoval můj obdélník.
            var pimg = new Uint8Array(bufs[j - 1 - tstp]);
            if (tstp == 1) frms[j - 1].dispose = 2;
            nimg = new Uint8Array(nw * nh * 4);
            $42fb3a9da620d66a$var$UPNG._copyTile(pimg, w, h, nimg, nw, nh, -nx, -ny, 0);
            blend = $42fb3a9da620d66a$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 3) ? 1 : 0;
            if (blend == 1) $42fb3a9da620d66a$var$UPNG.encode._prepareDiff(cimg, w, h, nimg, {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            });
            else $42fb3a9da620d66a$var$UPNG._copyTile(cimg, w, h, nimg, nw, nh, -nx, -ny, 0);
        //UPNG._copyTile(cimg,w,h, nimg,nw,nh, -nx,-ny, blend==1?2:0);
        } else nimg = cimg.slice(0); // img may be rewritten further ... don't rewrite input
        frms.push({
            rect: {
                x: nx,
                y: ny,
                width: nw,
                height: nh
            },
            img: nimg,
            blend: blend,
            dispose: 0
        });
    }
    if (alwaysBlend) for(var j = 0; j < frms.length; j++){
        var frm = frms[j];
        if (frm.blend == 1) continue;
        var r0 = frm.rect, r1 = frms[j - 1].rect;
        var miX = Math.min(r0.x, r1.x), miY = Math.min(r0.y, r1.y);
        var maX = Math.max(r0.x + r0.width, r1.x + r1.width), maY = Math.max(r0.y + r0.height, r1.y + r1.height);
        var r = {
            x: miX,
            y: miY,
            width: maX - miX,
            height: maY - miY
        };
        frms[j - 1].dispose = 1;
        if (j - 1 != 0) $42fb3a9da620d66a$var$UPNG.encode._updateFrame(bufs, w, h, frms, j - 1, r, evenCrd);
        $42fb3a9da620d66a$var$UPNG.encode._updateFrame(bufs, w, h, frms, j, r, evenCrd);
    }
    var area = 0;
    if (bufs.length != 1) for(var i = 0; i < frms.length; i++){
        var frm = frms[i];
        area += frm.rect.width * frm.rect.height;
    //if(i==0 || frm.blend!=1) continue;
    //var ob = new Uint8Array(
    //console.log(frm.blend, frm.dispose, frm.rect);
    }
    //if(area!=0) console.log(area);
    return frms;
};
$42fb3a9da620d66a$var$UPNG.encode._updateFrame = function(bufs, w, h, frms, i, r, evenCrd) {
    var U8 = Uint8Array, U32 = Uint32Array;
    var pimg = new U8(bufs[i - 1]), pimg32 = new U32(bufs[i - 1]), nimg = i + 1 < bufs.length ? new U8(bufs[i + 1]) : null;
    var cimg = new U8(bufs[i]), cimg32 = new U32(cimg.buffer);
    var mix = w, miy = h, max = -1, may = -1;
    for(var y = 0; y < r.height; y++)for(var x = 0; x < r.width; x++){
        var cx = r.x + x, cy = r.y + y;
        var j = cy * w + cx, cc = cimg32[j];
        // no need to draw transparency, or to dispose it. Or, if writing the same color and the next one does not need transparency.
        if (cc == 0 || frms[i - 1].dispose == 0 && pimg32[j] == cc && (nimg == null || nimg[j * 4 + 3] != 0)) ;
        else {
            if (cx < mix) mix = cx;
            if (cx > max) max = cx;
            if (cy < miy) miy = cy;
            if (cy > may) may = cy;
        }
    }
    if (max == -1) mix = miy = max = may = 0;
    if (evenCrd) {
        if ((mix & 1) == 1) mix--;
        if ((miy & 1) == 1) miy--;
    }
    r = {
        x: mix,
        y: miy,
        width: max - mix + 1,
        height: may - miy + 1
    };
    var fr = frms[i];
    fr.rect = r;
    fr.blend = 1;
    fr.img = new Uint8Array(r.width * r.height * 4);
    if (frms[i - 1].dispose == 0) {
        $42fb3a9da620d66a$var$UPNG._copyTile(pimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
        $42fb3a9da620d66a$var$UPNG.encode._prepareDiff(cimg, w, h, fr.img, r);
    //UPNG._copyTile(cimg,w,h, fr.img,r.width,r.height, -r.x,-r.y, 2);
    } else $42fb3a9da620d66a$var$UPNG._copyTile(cimg, w, h, fr.img, r.width, r.height, -r.x, -r.y, 0);
};
$42fb3a9da620d66a$var$UPNG.encode._prepareDiff = function(cimg, w, h, nimg, rec) {
    $42fb3a9da620d66a$var$UPNG._copyTile(cimg, w, h, nimg, rec.width, rec.height, -rec.x, -rec.y, 2);
/*
	var n32 = new Uint32Array(nimg.buffer);
	var og = new Uint8Array(rec.width*rec.height*4), o32 = new Uint32Array(og.buffer);
	UPNG._copyTile(cimg,w,h, og,rec.width,rec.height, -rec.x,-rec.y, 0);
	for(var i=4; i<nimg.length; i+=4) {
		if(nimg[i-1]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)-1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}
	for(var i=nimg.length-8; i>0; i-=4) {
		if(nimg[i+7]!=0 && nimg[i+3]==0 && o32[i>>>2]==o32[(i>>>2)+1]) {
			n32[i>>>2]=o32[i>>>2];
			//var j = i, c=p32[(i>>>2)-1];
			//while(p32[j>>>2]==c) {  n32[j>>>2]=c;  j+=4;  }
		}
	}*/ };
$42fb3a9da620d66a$var$UPNG.encode._filterZero = function(img, h, bpp, bpl, data, filter, levelZero) {
    var fls = [], ftry = [
        0,
        1,
        2,
        3,
        4
    ];
    if (filter != -1) ftry = [
        filter
    ];
    else if (h * bpl > 500000 || bpp == 1) ftry = [
        0
    ];
    var opts;
    if (levelZero) opts = {
        level: 0
    };
    var CMPR = levelZero && UZIP != null ? UZIP : (0, (/*@__PURE__*/$parcel$interopDefault($czuCz)));
    for(var i = 0; i < ftry.length; i++){
        for(var y = 0; y < h; y++)$42fb3a9da620d66a$var$UPNG.encode._filterLine(data, img, y, bpl, bpp, ftry[i]);
        //var nimg = new Uint8Array(data.length);
        //var sz = UZIP.F.deflate(data, nimg);  fls.push(nimg.slice(0,sz));
        //var dfl = pako["deflate"](data), dl=dfl.length-4;
        //var crc = (dfl[dl+3]<<24)|(dfl[dl+2]<<16)|(dfl[dl+1]<<8)|(dfl[dl+0]<<0);
        //console.log(crc, UZIP.adler(data,2,data.length-6));
        fls.push(CMPR["deflate"](data, opts));
    }
    var ti, tsize = 1e9;
    for(var i = 0; i < fls.length; i++)if (fls[i].length < tsize) {
        ti = i;
        tsize = fls[i].length;
    }
    return fls[ti];
};
$42fb3a9da620d66a$var$UPNG.encode._filterLine = function(data, img, y, bpl, bpp, type) {
    var i = y * bpl, di = i + y, paeth = $42fb3a9da620d66a$var$UPNG.decode._paeth;
    data[di] = type;
    di++;
    if (type == 0) {
        if (bpl < 500) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x];
        else data.set(new Uint8Array(img.buffer, i, bpl), di);
    } else if (type == 1) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - img[i + x - bpp] + 256 & 255;
    } else if (y == 0) {
        for(var x = 0; x < bpp; x++)data[di + x] = img[i + x];
        if (type == 2) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x];
        if (type == 3) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - (img[i + x - bpp] >> 1) + 256 & 255;
        if (type == 4) for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] - paeth(img[i + x - bpp], 0, 0) + 256 & 255;
    } else {
        if (type == 2) for(var x = 0; x < bpl; x++)data[di + x] = img[i + x] + 256 - img[i + x - bpl] & 255;
        if (type == 3) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] >> 1) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - (img[i + x - bpl] + img[i + x - bpp] >> 1) & 255;
        }
        if (type == 4) {
            for(var x = 0; x < bpp; x++)data[di + x] = img[i + x] + 256 - paeth(0, img[i + x - bpl], 0) & 255;
            for(var x = bpp; x < bpl; x++)data[di + x] = img[i + x] + 256 - paeth(img[i + x - bpp], img[i + x - bpl], img[i + x - bpp - bpl]) & 255;
        }
    }
};
$42fb3a9da620d66a$var$UPNG.crc = {
    table: function() {
        var tab = new Uint32Array(256);
        for(var n = 0; n < 256; n++){
            var c = n;
            for(var k = 0; k < 8; k++)if (c & 1) c = 0xedb88320 ^ c >>> 1;
            else c = c >>> 1;
            tab[n] = c;
        }
        return tab;
    }(),
    update: function(c, buf, off, len) {
        for(var i = 0; i < len; i++)c = $42fb3a9da620d66a$var$UPNG.crc.table[(c ^ buf[off + i]) & 0xff] ^ c >>> 8;
        return c;
    },
    crc: function(b, o, l) {
        return $42fb3a9da620d66a$var$UPNG.crc.update(0xffffffff, b, o, l) ^ 0xffffffff;
    }
};
$42fb3a9da620d66a$var$UPNG.quantize = function(abuf, ps) {
    var oimg = new Uint8Array(abuf), nimg = oimg.slice(0), nimg32 = new Uint32Array(nimg.buffer);
    var KD = $42fb3a9da620d66a$var$UPNG.quantize.getKDtree(nimg, ps);
    var root = KD[0], leafs = KD[1];
    var planeDst = $42fb3a9da620d66a$var$UPNG.quantize.planeDst;
    var sb = oimg, tb = nimg32, len = sb.length;
    var inds = new Uint8Array(oimg.length >> 2);
    for(var i = 0; i < len; i += 4){
        var r = sb[i] * (1 / 255), g = sb[i + 1] * (1 / 255), b = sb[i + 2] * (1 / 255), a = sb[i + 3] * (1 / 255);
        //  exact, but too slow :(
        var nd = $42fb3a9da620d66a$var$UPNG.quantize.getNearest(root, r, g, b, a);
        //var nd = root;
        //while(nd.left) nd = (planeDst(nd.est,r,g,b,a)<=0) ? nd.left : nd.right;
        inds[i >> 2] = nd.ind;
        tb[i >> 2] = nd.est.rgba;
    }
    return {
        abuf: nimg.buffer,
        inds: inds,
        plte: leafs
    };
};
$42fb3a9da620d66a$var$UPNG.quantize.getKDtree = function(nimg, ps, err) {
    if (err == null) err = 0.0001;
    var nimg32 = new Uint32Array(nimg.buffer);
    var root = {
        i0: 0,
        i1: nimg.length,
        bst: null,
        est: null,
        tdst: 0,
        left: null,
        right: null
    }; // basic statistic, extra statistic
    root.bst = $42fb3a9da620d66a$var$UPNG.quantize.stats(nimg, root.i0, root.i1);
    root.est = $42fb3a9da620d66a$var$UPNG.quantize.estats(root.bst);
    var leafs = [
        root
    ];
    while(leafs.length < ps){
        var maxL = 0, mi = 0;
        for(var i = 0; i < leafs.length; i++)if (leafs[i].est.L > maxL) {
            maxL = leafs[i].est.L;
            mi = i;
        }
        if (maxL < err) break;
        var node = leafs[mi];
        var s0 = $42fb3a9da620d66a$var$UPNG.quantize.splitPixels(nimg, nimg32, node.i0, node.i1, node.est.e, node.est.eMq255);
        var s0wrong = node.i0 >= s0 || node.i1 <= s0;
        //console.log(maxL, leafs.length, mi);
        if (s0wrong) {
            node.est.L = 0;
            continue;
        }
        var ln = {
            i0: node.i0,
            i1: s0,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        ln.bst = $42fb3a9da620d66a$var$UPNG.quantize.stats(nimg, ln.i0, ln.i1);
        ln.est = $42fb3a9da620d66a$var$UPNG.quantize.estats(ln.bst);
        var rn = {
            i0: s0,
            i1: node.i1,
            bst: null,
            est: null,
            tdst: 0,
            left: null,
            right: null
        };
        rn.bst = {
            R: [],
            m: [],
            N: node.bst.N - ln.bst.N
        };
        for(var i = 0; i < 16; i++)rn.bst.R[i] = node.bst.R[i] - ln.bst.R[i];
        for(var i = 0; i < 4; i++)rn.bst.m[i] = node.bst.m[i] - ln.bst.m[i];
        rn.est = $42fb3a9da620d66a$var$UPNG.quantize.estats(rn.bst);
        node.left = ln;
        node.right = rn;
        leafs[mi] = ln;
        leafs.push(rn);
    }
    leafs.sort(function(a, b) {
        return b.bst.N - a.bst.N;
    });
    for(var i = 0; i < leafs.length; i++)leafs[i].ind = i;
    return [
        root,
        leafs
    ];
};
$42fb3a9da620d66a$var$UPNG.quantize.getNearest = function(nd, r, g, b, a) {
    if (nd.left == null) {
        nd.tdst = $42fb3a9da620d66a$var$UPNG.quantize.dist(nd.est.q, r, g, b, a);
        return nd;
    }
    var planeDst = $42fb3a9da620d66a$var$UPNG.quantize.planeDst(nd.est, r, g, b, a);
    var node0 = nd.left, node1 = nd.right;
    if (planeDst > 0) {
        node0 = nd.right;
        node1 = nd.left;
    }
    var ln = $42fb3a9da620d66a$var$UPNG.quantize.getNearest(node0, r, g, b, a);
    if (ln.tdst <= planeDst * planeDst) return ln;
    var rn = $42fb3a9da620d66a$var$UPNG.quantize.getNearest(node1, r, g, b, a);
    return rn.tdst < ln.tdst ? rn : ln;
};
$42fb3a9da620d66a$var$UPNG.quantize.planeDst = function(est, r, g, b, a) {
    var e = est.e;
    return e[0] * r + e[1] * g + e[2] * b + e[3] * a - est.eMq;
};
$42fb3a9da620d66a$var$UPNG.quantize.dist = function(q, r, g, b, a) {
    var d0 = r - q[0], d1 = g - q[1], d2 = b - q[2], d3 = a - q[3];
    return d0 * d0 + d1 * d1 + d2 * d2 + d3 * d3;
};
$42fb3a9da620d66a$var$UPNG.quantize.splitPixels = function(nimg, nimg32, i0, i1, e, eMq) {
    var vecDot = $42fb3a9da620d66a$var$UPNG.quantize.vecDot;
    i1 -= 4;
    var shfs = 0;
    while(i0 < i1){
        while(vecDot(nimg, i0, e) <= eMq)i0 += 4;
        while(vecDot(nimg, i1, e) > eMq)i1 -= 4;
        if (i0 >= i1) break;
        var t = nimg32[i0 >> 2];
        nimg32[i0 >> 2] = nimg32[i1 >> 2];
        nimg32[i1 >> 2] = t;
        i0 += 4;
        i1 -= 4;
    }
    while(vecDot(nimg, i0, e) > eMq)i0 -= 4;
    return i0 + 4;
};
$42fb3a9da620d66a$var$UPNG.quantize.vecDot = function(nimg, i, e) {
    return nimg[i] * e[0] + nimg[i + 1] * e[1] + nimg[i + 2] * e[2] + nimg[i + 3] * e[3];
};
$42fb3a9da620d66a$var$UPNG.quantize.stats = function(nimg, i0, i1) {
    var R = [
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ];
    var m = [
        0,
        0,
        0,
        0
    ];
    var N = i1 - i0 >> 2;
    for(var i = i0; i < i1; i += 4){
        var r = nimg[i] * (1 / 255), g = nimg[i + 1] * (1 / 255), b = nimg[i + 2] * (1 / 255), a = nimg[i + 3] * (1 / 255);
        //var r = nimg[i], g = nimg[i+1], b = nimg[i+2], a = nimg[i+3];
        m[0] += r;
        m[1] += g;
        m[2] += b;
        m[3] += a;
        R[0] += r * r;
        R[1] += r * g;
        R[2] += r * b;
        R[3] += r * a;
        R[5] += g * g;
        R[6] += g * b;
        R[7] += g * a;
        R[10] += b * b;
        R[11] += b * a;
        R[15] += a * a;
    }
    R[4] = R[1];
    R[8] = R[2];
    R[9] = R[6];
    R[12] = R[3];
    R[13] = R[7];
    R[14] = R[11];
    return {
        R: R,
        m: m,
        N: N
    };
};
$42fb3a9da620d66a$var$UPNG.quantize.estats = function(stats) {
    var R = stats.R, m = stats.m, N = stats.N;
    // when all samples are equal, but N is large (millions), the Rj can be non-zero ( 0.0003.... - precission error)
    var m0 = m[0], m1 = m[1], m2 = m[2], m3 = m[3], iN = N == 0 ? 0 : 1 / N;
    var Rj = [
        R[0] - m0 * m0 * iN,
        R[1] - m0 * m1 * iN,
        R[2] - m0 * m2 * iN,
        R[3] - m0 * m3 * iN,
        R[4] - m1 * m0 * iN,
        R[5] - m1 * m1 * iN,
        R[6] - m1 * m2 * iN,
        R[7] - m1 * m3 * iN,
        R[8] - m2 * m0 * iN,
        R[9] - m2 * m1 * iN,
        R[10] - m2 * m2 * iN,
        R[11] - m2 * m3 * iN,
        R[12] - m3 * m0 * iN,
        R[13] - m3 * m1 * iN,
        R[14] - m3 * m2 * iN,
        R[15] - m3 * m3 * iN
    ];
    var A = Rj, M = $42fb3a9da620d66a$var$UPNG.M4;
    var b = [
        0.5,
        0.5,
        0.5,
        0.5
    ], mi = 0, tmi = 0;
    if (N != 0) for(var i = 0; i < 10; i++){
        b = M.multVec(A, b);
        tmi = Math.sqrt(M.dot(b, b));
        b = M.sml(1 / tmi, b);
        if (Math.abs(tmi - mi) < 1e-9) break;
        mi = tmi;
    }
    //b = [0,0,1,0];  mi=N;
    var q = [
        m0 * iN,
        m1 * iN,
        m2 * iN,
        m3 * iN
    ];
    var eMq255 = M.dot(M.sml(255, q), b);
    return {
        Cov: Rj,
        q: q,
        e: b,
        L: mi,
        eMq255: eMq255,
        eMq: M.dot(b, q),
        rgba: (Math.round(255 * q[3]) << 24 | Math.round(255 * q[2]) << 16 | Math.round(255 * q[1]) << 8 | Math.round(255 * q[0]) << 0) >>> 0
    };
};
$42fb3a9da620d66a$var$UPNG.M4 = {
    multVec: function(m, v) {
        return [
            m[0] * v[0] + m[1] * v[1] + m[2] * v[2] + m[3] * v[3],
            m[4] * v[0] + m[5] * v[1] + m[6] * v[2] + m[7] * v[3],
            m[8] * v[0] + m[9] * v[1] + m[10] * v[2] + m[11] * v[3],
            m[12] * v[0] + m[13] * v[1] + m[14] * v[2] + m[15] * v[3]
        ];
    },
    dot: function(x, y) {
        return x[0] * y[0] + x[1] * y[1] + x[2] * y[2] + x[3] * y[3];
    },
    sml: function(a, y) {
        return [
            a * y[0],
            a * y[1],
            a * y[2],
            a * y[3]
        ];
    }
};
$42fb3a9da620d66a$var$UPNG.encode.concatRGBA = function(bufs) {
    var tlen = 0;
    for(var i = 0; i < bufs.length; i++)tlen += bufs[i].byteLength;
    var nimg = new Uint8Array(tlen), noff = 0;
    for(var i = 0; i < bufs.length; i++){
        var img = new Uint8Array(bufs[i]), il = img.length;
        for(var j = 0; j < il; j += 4){
            var r = img[j], g = img[j + 1], b = img[j + 2], a = img[j + 3];
            if (a == 0) r = g = b = 0;
            nimg[noff + j] = r;
            nimg[noff + j + 1] = g;
            nimg[noff + j + 2] = b;
            nimg[noff + j + 3] = a;
        }
        noff += il;
    }
    return nimg.buffer;
};
var $42fb3a9da620d66a$export$2e2bcd8739ae039 = $42fb3a9da620d66a$var$UPNG;


var $f709196c4ca8817d$var$getImageType = function(ctype) {
    if (ctype === 0) return $f709196c4ca8817d$export$3ff975e8f63e458c.Greyscale;
    if (ctype === 2) return $f709196c4ca8817d$export$3ff975e8f63e458c.Truecolour;
    if (ctype === 3) return $f709196c4ca8817d$export$3ff975e8f63e458c.IndexedColour;
    if (ctype === 4) return $f709196c4ca8817d$export$3ff975e8f63e458c.GreyscaleWithAlpha;
    if (ctype === 6) return $f709196c4ca8817d$export$3ff975e8f63e458c.TruecolourWithAlpha;
    throw new Error("Unknown color type: " + ctype);
};
var $f709196c4ca8817d$var$splitAlphaChannel = function(rgbaChannel) {
    var pixelCount = Math.floor(rgbaChannel.length / 4);
    var rgbChannel = new Uint8Array(pixelCount * 3);
    var alphaChannel = new Uint8Array(pixelCount * 1);
    var rgbaOffset = 0;
    var rgbOffset = 0;
    var alphaOffset = 0;
    while(rgbaOffset < rgbaChannel.length){
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        rgbChannel[rgbOffset++] = rgbaChannel[rgbaOffset++];
        alphaChannel[alphaOffset++] = rgbaChannel[rgbaOffset++];
    }
    return {
        rgbChannel: rgbChannel,
        alphaChannel: alphaChannel
    };
};
var $f709196c4ca8817d$export$3ff975e8f63e458c;
(function(PngType) {
    PngType["Greyscale"] = "Greyscale";
    PngType["Truecolour"] = "Truecolour";
    PngType["IndexedColour"] = "IndexedColour";
    PngType["GreyscaleWithAlpha"] = "GreyscaleWithAlpha";
    PngType["TruecolourWithAlpha"] = "TruecolourWithAlpha";
})($f709196c4ca8817d$export$3ff975e8f63e458c || ($f709196c4ca8817d$export$3ff975e8f63e458c = {}));
var $f709196c4ca8817d$export$1f536085c24cc947 = /** @class */ function() {
    function PNG(pngData) {
        var upng = (0, $42fb3a9da620d66a$export$2e2bcd8739ae039).decode(pngData);
        var frames = (0, $42fb3a9da620d66a$export$2e2bcd8739ae039).toRGBA8(upng);
        if (frames.length > 1) throw new Error("Animated PNGs are not supported");
        var frame = new Uint8Array(frames[0]);
        var _a = $f709196c4ca8817d$var$splitAlphaChannel(frame), rgbChannel = _a.rgbChannel, alphaChannel = _a.alphaChannel;
        this.rgbChannel = rgbChannel;
        var hasAlphaValues = alphaChannel.some(function(a) {
            return a < 255;
        });
        if (hasAlphaValues) this.alphaChannel = alphaChannel;
        this.type = $f709196c4ca8817d$var$getImageType(upng.ctype);
        this.width = upng.width;
        this.height = upng.height;
        this.bitsPerComponent = 8;
    }
    PNG.load = function(pngData) {
        return new PNG(pngData);
    };
    return PNG;
}();


/**
 * A note of thanks to the developers of https://github.com/foliojs/pdfkit, as
 * this class borrows from:
 *   https://github.com/devongovett/pdfkit/blob/e71edab0dd4657b5a767804ba86c94c58d01fbca/lib/image/png.coffee
 */ var $3c0d99ae5c827c27$var$PngEmbedder = /** @class */ function() {
    function PngEmbedder(png) {
        this.image = png;
        this.bitsPerComponent = png.bitsPerComponent;
        this.width = png.width;
        this.height = png.height;
        this.colorSpace = 'DeviceRGB';
    }
    PngEmbedder.for = function(imageData) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var png;
            return (0, $70JnX.__generator)(this, function(_a) {
                png = (0, $f709196c4ca8817d$export$1f536085c24cc947).load(imageData);
                return [
                    2 /*return*/ ,
                    new PngEmbedder(png)
                ];
            });
        });
    };
    PngEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var SMask, xObject;
            return (0, $70JnX.__generator)(this, function(_a) {
                SMask = this.embedAlphaChannel(context);
                xObject = context.flateStream(this.image.rgbChannel, {
                    Type: 'XObject',
                    Subtype: 'Image',
                    BitsPerComponent: this.image.bitsPerComponent,
                    Width: this.image.width,
                    Height: this.image.height,
                    ColorSpace: this.colorSpace,
                    SMask: SMask
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    PngEmbedder.prototype.embedAlphaChannel = function(context) {
        if (!this.image.alphaChannel) return undefined;
        var xObject = context.flateStream(this.image.alphaChannel, {
            Type: 'XObject',
            Subtype: 'Image',
            Height: this.image.height,
            Width: this.image.width,
            BitsPerComponent: this.image.bitsPerComponent,
            ColorSpace: 'DeviceGray',
            Decode: [
                0,
                1
            ]
        });
        return context.register(xObject);
    };
    return PngEmbedder;
}();
var $3c0d99ae5c827c27$export$2e2bcd8739ae039 = $3c0d99ae5c827c27$var$PngEmbedder;



var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $8LDYe = parcelRequire("8LDYe");



var $1jVcF = parcelRequire("1jVcF");

var $cUVc9 = parcelRequire("cUVc9");


var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Ascii85Stream class contained in this file is a TypeScript port of the
 * JavaScript Ascii85Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");
/*
 * Copyright 2012 Mozilla Foundation
 *
 * The Stream class contained in this file is a TypeScript port of the
 * JavaScript Stream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ var $aecdbf1ad8d08a69$var$Stream = /** @class */ function() {
    function Stream(buffer, start, length) {
        this.bytes = buffer;
        this.start = start || 0;
        this.pos = this.start;
        this.end = !!start && !!length ? start + length : this.bytes.length;
    }
    Object.defineProperty(Stream.prototype, "length", {
        get: function() {
            return this.end - this.start;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Stream.prototype, "isEmpty", {
        get: function() {
            return this.length === 0;
        },
        enumerable: false,
        configurable: true
    });
    Stream.prototype.getByte = function() {
        if (this.pos >= this.end) return -1;
        return this.bytes[this.pos++];
    };
    Stream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    Stream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    // Returns subarray of original buffer, should only be read.
    Stream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.bytes;
        var pos = this.pos;
        var strEnd = this.end;
        if (!length) {
            var subarray = bytes.subarray(pos, strEnd);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        } else {
            var end = pos + length;
            if (end > strEnd) end = strEnd;
            this.pos = end;
            var subarray = bytes.subarray(pos, end);
            // `this.bytes` is always a `Uint8Array` here.
            return forceClamped ? new Uint8ClampedArray(subarray) : subarray;
        }
    };
    Stream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    Stream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    Stream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    Stream.prototype.reset = function() {
        this.pos = this.start;
    };
    Stream.prototype.moveStart = function() {
        this.start = this.pos;
    };
    Stream.prototype.makeSubStream = function(start, length) {
        return new Stream(this.bytes, start, length);
    };
    Stream.prototype.decode = function() {
        return this.bytes;
    };
    return Stream;
}();
var $aecdbf1ad8d08a69$export$2e2bcd8739ae039 = $aecdbf1ad8d08a69$var$Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The DecodeStream class contained in this file is a TypeScript port of the
 * JavaScript DecodeStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ // Lots of DecodeStreams are created whose buffers are never used.  For these
// we share a single empty buffer. This is (a) space-efficient and (b) avoids
// having special cases that would be required if we used |null| for an empty
// buffer.
var $b7c9e74223d0896f$var$emptyBuffer = new Uint8Array(0);
/**
 * Super class for the decoding streams
 */ var $b7c9e74223d0896f$var$DecodeStream = /** @class */ function() {
    function DecodeStream(maybeMinBufferLength) {
        this.pos = 0;
        this.bufferLength = 0;
        this.eof = false;
        this.buffer = $b7c9e74223d0896f$var$emptyBuffer;
        this.minBufferLength = 512;
        if (maybeMinBufferLength) // Compute the first power of two that is as big as maybeMinBufferLength.
        while(this.minBufferLength < maybeMinBufferLength)this.minBufferLength *= 2;
    }
    Object.defineProperty(DecodeStream.prototype, "isEmpty", {
        get: function() {
            while(!this.eof && this.bufferLength === 0)this.readBlock();
            return this.bufferLength === 0;
        },
        enumerable: false,
        configurable: true
    });
    DecodeStream.prototype.getByte = function() {
        var pos = this.pos;
        while(this.bufferLength <= pos){
            if (this.eof) return -1;
            this.readBlock();
        }
        return this.buffer[this.pos++];
    };
    DecodeStream.prototype.getUint16 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        if (b0 === -1 || b1 === -1) return -1;
        return (b0 << 8) + b1;
    };
    DecodeStream.prototype.getInt32 = function() {
        var b0 = this.getByte();
        var b1 = this.getByte();
        var b2 = this.getByte();
        var b3 = this.getByte();
        return (b0 << 24) + (b1 << 16) + (b2 << 8) + b3;
    };
    DecodeStream.prototype.getBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var end;
        var pos = this.pos;
        if (length) {
            this.ensureBuffer(pos + length);
            end = pos + length;
            while(!this.eof && this.bufferLength < end)this.readBlock();
            var bufEnd = this.bufferLength;
            if (end > bufEnd) end = bufEnd;
        } else {
            while(!this.eof)this.readBlock();
            end = this.bufferLength;
        }
        this.pos = end;
        var subarray = this.buffer.subarray(pos, end);
        // `this.buffer` is either a `Uint8Array` or `Uint8ClampedArray` here.
        return forceClamped && !(subarray instanceof Uint8ClampedArray) ? new Uint8ClampedArray(subarray) : subarray;
    };
    DecodeStream.prototype.peekByte = function() {
        var peekedByte = this.getByte();
        this.pos--;
        return peekedByte;
    };
    DecodeStream.prototype.peekBytes = function(length, forceClamped) {
        if (forceClamped === void 0) forceClamped = false;
        var bytes = this.getBytes(length, forceClamped);
        this.pos -= bytes.length;
        return bytes;
    };
    DecodeStream.prototype.skip = function(n) {
        if (!n) n = 1;
        this.pos += n;
    };
    DecodeStream.prototype.reset = function() {
        this.pos = 0;
    };
    DecodeStream.prototype.makeSubStream = function(start, length /* dict */ ) {
        var end = start + length;
        while(this.bufferLength <= end && !this.eof)this.readBlock();
        return new (0, $aecdbf1ad8d08a69$export$2e2bcd8739ae039)(this.buffer, start, length /* dict */ );
    };
    DecodeStream.prototype.decode = function() {
        while(!this.eof)this.readBlock();
        return this.buffer.subarray(0, this.bufferLength);
    };
    DecodeStream.prototype.readBlock = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'readBlock');
    };
    DecodeStream.prototype.ensureBuffer = function(requested) {
        var buffer = this.buffer;
        if (requested <= buffer.byteLength) return buffer;
        var size = this.minBufferLength;
        while(size < requested)size *= 2;
        var buffer2 = new Uint8Array(size);
        buffer2.set(buffer);
        return this.buffer = buffer2;
    };
    return DecodeStream;
}();
var $b7c9e74223d0896f$export$2e2bcd8739ae039 = $b7c9e74223d0896f$var$DecodeStream;


var $1e33e085d3b9c778$var$isSpace = function(ch) {
    return ch === 0x20 || ch === 0x09 || ch === 0x0d || ch === 0x0a;
};
var $1e33e085d3b9c778$var$Ascii85Stream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(Ascii85Stream, _super);
    function Ascii85Stream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.input = new Uint8Array(5);
        // Most streams increase in size when decoded, but Ascii85 streams
        // typically shrink by ~20%.
        if (maybeLength) maybeLength = 0.8 * maybeLength;
        return _this;
    }
    Ascii85Stream.prototype.readBlock = function() {
        var TILDA_CHAR = 0x7e; // '~'
        var Z_LOWER_CHAR = 0x7a; // 'z'
        var EOF = -1;
        var stream = this.stream;
        var c = stream.getByte();
        while($1e33e085d3b9c778$var$isSpace(c))c = stream.getByte();
        if (c === EOF || c === TILDA_CHAR) {
            this.eof = true;
            return;
        }
        var bufferLength = this.bufferLength;
        var buffer;
        var i;
        // special code for z
        if (c === Z_LOWER_CHAR) {
            buffer = this.ensureBuffer(bufferLength + 4);
            for(i = 0; i < 4; ++i)buffer[bufferLength + i] = 0;
            this.bufferLength += 4;
        } else {
            var input = this.input;
            input[0] = c;
            for(i = 1; i < 5; ++i){
                c = stream.getByte();
                while($1e33e085d3b9c778$var$isSpace(c))c = stream.getByte();
                input[i] = c;
                if (c === EOF || c === TILDA_CHAR) break;
            }
            buffer = this.ensureBuffer(bufferLength + i - 1);
            this.bufferLength += i - 1;
            // partial ending;
            if (i < 5) {
                for(; i < 5; ++i)input[i] = 117;
                this.eof = true;
            }
            var t = 0;
            for(i = 0; i < 5; ++i)t = t * 85 + (input[i] - 0x21);
            for(i = 3; i >= 0; --i){
                buffer[bufferLength + i] = t & 0xff;
                t >>= 8;
            }
        }
    };
    return Ascii85Stream;
}((0, $b7c9e74223d0896f$export$2e2bcd8739ae039));
var $1e33e085d3b9c778$export$2e2bcd8739ae039 = $1e33e085d3b9c778$var$Ascii85Stream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The AsciiHexStream class contained in this file is a TypeScript port of the
 * JavaScript AsciiHexStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $70JnX = parcelRequire("70JnX");

var $5b84d90f6a1e69f9$var$AsciiHexStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(AsciiHexStream, _super);
    function AsciiHexStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.firstDigit = -1;
        // Most streams increase in size when decoded, but AsciiHex streams shrink
        // by 50%.
        if (maybeLength) maybeLength = 0.5 * maybeLength;
        return _this;
    }
    AsciiHexStream.prototype.readBlock = function() {
        var UPSTREAM_BLOCK_SIZE = 8000;
        var bytes = this.stream.getBytes(UPSTREAM_BLOCK_SIZE);
        if (!bytes.length) {
            this.eof = true;
            return;
        }
        var maxDecodeLength = bytes.length + 1 >> 1;
        var buffer = this.ensureBuffer(this.bufferLength + maxDecodeLength);
        var bufferLength = this.bufferLength;
        var firstDigit = this.firstDigit;
        for(var i = 0, ii = bytes.length; i < ii; i++){
            var ch = bytes[i];
            var digit = void 0;
            if (ch >= 0x30 && ch <= 0x39) // '0'-'9'
            digit = ch & 0x0f;
            else if (ch >= 0x41 && ch <= 0x46 || ch >= 0x61 && ch <= 0x66) // 'A'-'Z', 'a'-'z'
            digit = (ch & 0x0f) + 9;
            else if (ch === 0x3e) {
                // '>'
                this.eof = true;
                break;
            } else continue; // ignoring
            if (firstDigit < 0) firstDigit = digit;
            else {
                buffer[bufferLength++] = firstDigit << 4 | digit;
                firstDigit = -1;
            }
        }
        if (firstDigit >= 0 && this.eof) {
            // incomplete byte
            buffer[bufferLength++] = firstDigit << 4;
            firstDigit = -1;
        }
        this.firstDigit = firstDigit;
        this.bufferLength = bufferLength;
    };
    return AsciiHexStream;
}((0, $b7c9e74223d0896f$export$2e2bcd8739ae039));
var $5b84d90f6a1e69f9$export$2e2bcd8739ae039 = $5b84d90f6a1e69f9$var$AsciiHexStream;


/*
 * Copyright 1996-2003 Glyph & Cog, LLC
 *
 * The flate stream implementation contained in this file is a JavaScript port
 * of XPDF's implementation, made available under the Apache 2.0 open source
 * license.
 */ 
var $70JnX = parcelRequire("70JnX");

// prettier-ignore
var $5587aca36a0c26c4$var$codeLenCodeMap = new Int32Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
// prettier-ignore
var $5587aca36a0c26c4$var$lengthDecode = new Int32Array([
    0x00003,
    0x00004,
    0x00005,
    0x00006,
    0x00007,
    0x00008,
    0x00009,
    0x0000a,
    0x1000b,
    0x1000d,
    0x1000f,
    0x10011,
    0x20013,
    0x20017,
    0x2001b,
    0x2001f,
    0x30023,
    0x3002b,
    0x30033,
    0x3003b,
    0x40043,
    0x40053,
    0x40063,
    0x40073,
    0x50083,
    0x500a3,
    0x500c3,
    0x500e3,
    0x00102,
    0x00102,
    0x00102
]);
// prettier-ignore
var $5587aca36a0c26c4$var$distDecode = new Int32Array([
    0x00001,
    0x00002,
    0x00003,
    0x00004,
    0x10005,
    0x10007,
    0x20009,
    0x2000d,
    0x30011,
    0x30019,
    0x40021,
    0x40031,
    0x50041,
    0x50061,
    0x60081,
    0x600c1,
    0x70101,
    0x70181,
    0x80201,
    0x80301,
    0x90401,
    0x90601,
    0xa0801,
    0xa0c01,
    0xb1001,
    0xb1801,
    0xc2001,
    0xc3001,
    0xd4001,
    0xd6001
]);
// prettier-ignore
var $5587aca36a0c26c4$var$fixedLitCodeTab = [
    new Int32Array([
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c0,
        0x70108,
        0x80060,
        0x80020,
        0x900a0,
        0x80000,
        0x80080,
        0x80040,
        0x900e0,
        0x70104,
        0x80058,
        0x80018,
        0x90090,
        0x70114,
        0x80078,
        0x80038,
        0x900d0,
        0x7010c,
        0x80068,
        0x80028,
        0x900b0,
        0x80008,
        0x80088,
        0x80048,
        0x900f0,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c8,
        0x7010a,
        0x80064,
        0x80024,
        0x900a8,
        0x80004,
        0x80084,
        0x80044,
        0x900e8,
        0x70106,
        0x8005c,
        0x8001c,
        0x90098,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d8,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b8,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f8,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c4,
        0x70109,
        0x80062,
        0x80022,
        0x900a4,
        0x80002,
        0x80082,
        0x80042,
        0x900e4,
        0x70105,
        0x8005a,
        0x8001a,
        0x90094,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d4,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b4,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f4,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cc,
        0x7010b,
        0x80066,
        0x80026,
        0x900ac,
        0x80006,
        0x80086,
        0x80046,
        0x900ec,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009c,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dc,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bc,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fc,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c2,
        0x70108,
        0x80061,
        0x80021,
        0x900a2,
        0x80001,
        0x80081,
        0x80041,
        0x900e2,
        0x70104,
        0x80059,
        0x80019,
        0x90092,
        0x70114,
        0x80079,
        0x80039,
        0x900d2,
        0x7010c,
        0x80069,
        0x80029,
        0x900b2,
        0x80009,
        0x80089,
        0x80049,
        0x900f2,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900ca,
        0x7010a,
        0x80065,
        0x80025,
        0x900aa,
        0x80005,
        0x80085,
        0x80045,
        0x900ea,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009a,
        0x70116,
        0x8007d,
        0x8003d,
        0x900da,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900ba,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fa,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c6,
        0x70109,
        0x80063,
        0x80023,
        0x900a6,
        0x80003,
        0x80083,
        0x80043,
        0x900e6,
        0x70105,
        0x8005b,
        0x8001b,
        0x90096,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d6,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b6,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f6,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900ce,
        0x7010b,
        0x80067,
        0x80027,
        0x900ae,
        0x80007,
        0x80087,
        0x80047,
        0x900ee,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009e,
        0x70117,
        0x8007f,
        0x8003f,
        0x900de,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900be,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900fe,
        0x70100,
        0x80050,
        0x80010,
        0x80118,
        0x70110,
        0x80070,
        0x80030,
        0x900c1,
        0x70108,
        0x80060,
        0x80020,
        0x900a1,
        0x80000,
        0x80080,
        0x80040,
        0x900e1,
        0x70104,
        0x80058,
        0x80018,
        0x90091,
        0x70114,
        0x80078,
        0x80038,
        0x900d1,
        0x7010c,
        0x80068,
        0x80028,
        0x900b1,
        0x80008,
        0x80088,
        0x80048,
        0x900f1,
        0x70102,
        0x80054,
        0x80014,
        0x8011c,
        0x70112,
        0x80074,
        0x80034,
        0x900c9,
        0x7010a,
        0x80064,
        0x80024,
        0x900a9,
        0x80004,
        0x80084,
        0x80044,
        0x900e9,
        0x70106,
        0x8005c,
        0x8001c,
        0x90099,
        0x70116,
        0x8007c,
        0x8003c,
        0x900d9,
        0x7010e,
        0x8006c,
        0x8002c,
        0x900b9,
        0x8000c,
        0x8008c,
        0x8004c,
        0x900f9,
        0x70101,
        0x80052,
        0x80012,
        0x8011a,
        0x70111,
        0x80072,
        0x80032,
        0x900c5,
        0x70109,
        0x80062,
        0x80022,
        0x900a5,
        0x80002,
        0x80082,
        0x80042,
        0x900e5,
        0x70105,
        0x8005a,
        0x8001a,
        0x90095,
        0x70115,
        0x8007a,
        0x8003a,
        0x900d5,
        0x7010d,
        0x8006a,
        0x8002a,
        0x900b5,
        0x8000a,
        0x8008a,
        0x8004a,
        0x900f5,
        0x70103,
        0x80056,
        0x80016,
        0x8011e,
        0x70113,
        0x80076,
        0x80036,
        0x900cd,
        0x7010b,
        0x80066,
        0x80026,
        0x900ad,
        0x80006,
        0x80086,
        0x80046,
        0x900ed,
        0x70107,
        0x8005e,
        0x8001e,
        0x9009d,
        0x70117,
        0x8007e,
        0x8003e,
        0x900dd,
        0x7010f,
        0x8006e,
        0x8002e,
        0x900bd,
        0x8000e,
        0x8008e,
        0x8004e,
        0x900fd,
        0x70100,
        0x80051,
        0x80011,
        0x80119,
        0x70110,
        0x80071,
        0x80031,
        0x900c3,
        0x70108,
        0x80061,
        0x80021,
        0x900a3,
        0x80001,
        0x80081,
        0x80041,
        0x900e3,
        0x70104,
        0x80059,
        0x80019,
        0x90093,
        0x70114,
        0x80079,
        0x80039,
        0x900d3,
        0x7010c,
        0x80069,
        0x80029,
        0x900b3,
        0x80009,
        0x80089,
        0x80049,
        0x900f3,
        0x70102,
        0x80055,
        0x80015,
        0x8011d,
        0x70112,
        0x80075,
        0x80035,
        0x900cb,
        0x7010a,
        0x80065,
        0x80025,
        0x900ab,
        0x80005,
        0x80085,
        0x80045,
        0x900eb,
        0x70106,
        0x8005d,
        0x8001d,
        0x9009b,
        0x70116,
        0x8007d,
        0x8003d,
        0x900db,
        0x7010e,
        0x8006d,
        0x8002d,
        0x900bb,
        0x8000d,
        0x8008d,
        0x8004d,
        0x900fb,
        0x70101,
        0x80053,
        0x80013,
        0x8011b,
        0x70111,
        0x80073,
        0x80033,
        0x900c7,
        0x70109,
        0x80063,
        0x80023,
        0x900a7,
        0x80003,
        0x80083,
        0x80043,
        0x900e7,
        0x70105,
        0x8005b,
        0x8001b,
        0x90097,
        0x70115,
        0x8007b,
        0x8003b,
        0x900d7,
        0x7010d,
        0x8006b,
        0x8002b,
        0x900b7,
        0x8000b,
        0x8008b,
        0x8004b,
        0x900f7,
        0x70103,
        0x80057,
        0x80017,
        0x8011f,
        0x70113,
        0x80077,
        0x80037,
        0x900cf,
        0x7010b,
        0x80067,
        0x80027,
        0x900af,
        0x80007,
        0x80087,
        0x80047,
        0x900ef,
        0x70107,
        0x8005f,
        0x8001f,
        0x9009f,
        0x70117,
        0x8007f,
        0x8003f,
        0x900df,
        0x7010f,
        0x8006f,
        0x8002f,
        0x900bf,
        0x8000f,
        0x8008f,
        0x8004f,
        0x900ff
    ]),
    9
];
// prettier-ignore
var $5587aca36a0c26c4$var$fixedDistCodeTab = [
    new Int32Array([
        0x50000,
        0x50010,
        0x50008,
        0x50018,
        0x50004,
        0x50014,
        0x5000c,
        0x5001c,
        0x50002,
        0x50012,
        0x5000a,
        0x5001a,
        0x50006,
        0x50016,
        0x5000e,
        0x00000,
        0x50001,
        0x50011,
        0x50009,
        0x50019,
        0x50005,
        0x50015,
        0x5000d,
        0x5001d,
        0x50003,
        0x50013,
        0x5000b,
        0x5001b,
        0x50007,
        0x50017,
        0x5000f,
        0x00000
    ]),
    5
];
var $5587aca36a0c26c4$var$FlateStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(FlateStream, _super);
    function FlateStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        var cmf = stream.getByte();
        var flg = stream.getByte();
        if (cmf === -1 || flg === -1) throw new Error("Invalid header in flate stream: " + cmf + ", " + flg);
        if ((cmf & 0x0f) !== 0x08) throw new Error("Unknown compression method in flate stream: " + cmf + ", " + flg);
        if (((cmf << 8) + flg) % 31 !== 0) throw new Error("Bad FCHECK in flate stream: " + cmf + ", " + flg);
        if (flg & 0x20) throw new Error("FDICT bit set in flate stream: " + cmf + ", " + flg);
        _this.codeSize = 0;
        _this.codeBuf = 0;
        return _this;
    }
    FlateStream.prototype.readBlock = function() {
        var buffer;
        var len;
        var str = this.stream;
        // read block header
        var hdr = this.getBits(3);
        if (hdr & 1) this.eof = true;
        hdr >>= 1;
        if (hdr === 0) {
            // uncompressed block
            var b = void 0;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var blockLen = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            blockLen |= b << 8;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            var check = b;
            if ((b = str.getByte()) === -1) throw new Error('Bad block header in flate stream');
            check |= b << 8;
            if (check !== (~blockLen & 0xffff) && (blockLen !== 0 || check !== 0)) // Ignoring error for bad "empty" block (see issue 1277)
            throw new Error('Bad uncompressed block length in flate stream');
            this.codeBuf = 0;
            this.codeSize = 0;
            var bufferLength = this.bufferLength;
            buffer = this.ensureBuffer(bufferLength + blockLen);
            var end = bufferLength + blockLen;
            this.bufferLength = end;
            if (blockLen === 0) {
                if (str.peekByte() === -1) this.eof = true;
            } else for(var n = bufferLength; n < end; ++n){
                if ((b = str.getByte()) === -1) {
                    this.eof = true;
                    break;
                }
                buffer[n] = b;
            }
            return;
        }
        var litCodeTable;
        var distCodeTable;
        if (hdr === 1) {
            // compressed block, fixed codes
            litCodeTable = $5587aca36a0c26c4$var$fixedLitCodeTab;
            distCodeTable = $5587aca36a0c26c4$var$fixedDistCodeTab;
        } else if (hdr === 2) {
            // compressed block, dynamic codes
            var numLitCodes = this.getBits(5) + 257;
            var numDistCodes = this.getBits(5) + 1;
            var numCodeLenCodes = this.getBits(4) + 4;
            // build the code lengths code table
            var codeLenCodeLengths = new Uint8Array($5587aca36a0c26c4$var$codeLenCodeMap.length);
            var i = void 0;
            for(i = 0; i < numCodeLenCodes; ++i)codeLenCodeLengths[$5587aca36a0c26c4$var$codeLenCodeMap[i]] = this.getBits(3);
            var codeLenCodeTab = this.generateHuffmanTable(codeLenCodeLengths);
            // build the literal and distance code tables
            len = 0;
            i = 0;
            var codes = numLitCodes + numDistCodes;
            var codeLengths = new Uint8Array(codes);
            var bitsLength = void 0;
            var bitsOffset = void 0;
            var what = void 0;
            while(i < codes){
                var code = this.getCode(codeLenCodeTab);
                if (code === 16) {
                    bitsLength = 2;
                    bitsOffset = 3;
                    what = len;
                } else if (code === 17) {
                    bitsLength = 3;
                    bitsOffset = 3;
                    what = len = 0;
                } else if (code === 18) {
                    bitsLength = 7;
                    bitsOffset = 11;
                    what = len = 0;
                } else {
                    codeLengths[i++] = len = code;
                    continue;
                }
                var repeatLength = this.getBits(bitsLength) + bitsOffset;
                while(repeatLength-- > 0)codeLengths[i++] = what;
            }
            litCodeTable = this.generateHuffmanTable(codeLengths.subarray(0, numLitCodes));
            distCodeTable = this.generateHuffmanTable(codeLengths.subarray(numLitCodes, codes));
        } else throw new Error('Unknown block type in flate stream');
        buffer = this.buffer;
        var limit = buffer ? buffer.length : 0;
        var pos = this.bufferLength;
        while(true){
            var code1 = this.getCode(litCodeTable);
            if (code1 < 256) {
                if (pos + 1 >= limit) {
                    buffer = this.ensureBuffer(pos + 1);
                    limit = buffer.length;
                }
                buffer[pos++] = code1;
                continue;
            }
            if (code1 === 256) {
                this.bufferLength = pos;
                return;
            }
            code1 -= 257;
            code1 = $5587aca36a0c26c4$var$lengthDecode[code1];
            var code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            len = (code1 & 0xffff) + code2;
            code1 = this.getCode(distCodeTable);
            code1 = $5587aca36a0c26c4$var$distDecode[code1];
            code2 = code1 >> 16;
            if (code2 > 0) code2 = this.getBits(code2);
            var dist = (code1 & 0xffff) + code2;
            if (pos + len >= limit) {
                buffer = this.ensureBuffer(pos + len);
                limit = buffer.length;
            }
            for(var k = 0; k < len; ++k, ++pos)buffer[pos] = buffer[pos - dist];
        }
    };
    FlateStream.prototype.getBits = function(bits) {
        var str = this.stream;
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < bits){
            if ((b = str.getByte()) === -1) throw new Error('Bad encoding in flate stream');
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        b = codeBuf & (1 << bits) - 1;
        this.codeBuf = codeBuf >> bits;
        this.codeSize = codeSize -= bits;
        return b;
    };
    FlateStream.prototype.getCode = function(table) {
        var str = this.stream;
        var codes = table[0];
        var maxLen = table[1];
        var codeSize = this.codeSize;
        var codeBuf = this.codeBuf;
        var b;
        while(codeSize < maxLen){
            if ((b = str.getByte()) === -1) break;
            codeBuf |= b << codeSize;
            codeSize += 8;
        }
        var code = codes[codeBuf & (1 << maxLen) - 1];
        if (typeof codes === 'number') console.log('FLATE:', code);
        var codeLen = code >> 16;
        var codeVal = code & 0xffff;
        if (codeLen < 1 || codeSize < codeLen) throw new Error('Bad encoding in flate stream');
        this.codeBuf = codeBuf >> codeLen;
        this.codeSize = codeSize - codeLen;
        return codeVal;
    };
    FlateStream.prototype.generateHuffmanTable = function(lengths) {
        var n = lengths.length;
        // find max code length
        var maxLen = 0;
        var i;
        for(i = 0; i < n; ++i)if (lengths[i] > maxLen) maxLen = lengths[i];
        // build the table
        var size = 1 << maxLen;
        var codes = new Int32Array(size);
        for(var len = 1, code = 0, skip = 2; len <= maxLen; ++len, code <<= 1, skip <<= 1){
            for(var val = 0; val < n; ++val)if (lengths[val] === len) {
                // bit-reverse the code
                var code2 = 0;
                var t = code;
                for(i = 0; i < len; ++i){
                    code2 = code2 << 1 | t & 1;
                    t >>= 1;
                }
                // fill the table entries
                for(i = code2; i < size; i += skip)codes[i] = len << 16 | val;
                ++code;
            }
        }
        return [
            codes,
            maxLen
        ];
    };
    return FlateStream;
}((0, $b7c9e74223d0896f$export$2e2bcd8739ae039));
var $5587aca36a0c26c4$export$2e2bcd8739ae039 = $5587aca36a0c26c4$var$FlateStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The LZWStream class contained in this file is a TypeScript port of the
 * JavaScript LZWStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $70JnX = parcelRequire("70JnX");

var $176d3d2677fde3ef$var$LZWStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(LZWStream, _super);
    function LZWStream(stream, maybeLength, earlyChange) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        _this.cachedData = 0;
        _this.bitsCached = 0;
        var maxLzwDictionarySize = 4096;
        var lzwState = {
            earlyChange: earlyChange,
            codeLength: 9,
            nextCode: 258,
            dictionaryValues: new Uint8Array(maxLzwDictionarySize),
            dictionaryLengths: new Uint16Array(maxLzwDictionarySize),
            dictionaryPrevCodes: new Uint16Array(maxLzwDictionarySize),
            currentSequence: new Uint8Array(maxLzwDictionarySize),
            currentSequenceLength: 0
        };
        for(var i = 0; i < 256; ++i){
            lzwState.dictionaryValues[i] = i;
            lzwState.dictionaryLengths[i] = 1;
        }
        _this.lzwState = lzwState;
        return _this;
    }
    LZWStream.prototype.readBlock = function() {
        var blockSize = 512;
        var estimatedDecodedSize = blockSize * 2;
        var decodedSizeDelta = blockSize;
        var i;
        var j;
        var q;
        var lzwState = this.lzwState;
        if (!lzwState) return; // eof was found
        var earlyChange = lzwState.earlyChange;
        var nextCode = lzwState.nextCode;
        var dictionaryValues = lzwState.dictionaryValues;
        var dictionaryLengths = lzwState.dictionaryLengths;
        var dictionaryPrevCodes = lzwState.dictionaryPrevCodes;
        var codeLength = lzwState.codeLength;
        var prevCode = lzwState.prevCode;
        var currentSequence = lzwState.currentSequence;
        var currentSequenceLength = lzwState.currentSequenceLength;
        var decodedLength = 0;
        var currentBufferLength = this.bufferLength;
        var buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
        for(i = 0; i < blockSize; i++){
            var code = this.readBits(codeLength);
            var hasPrev = currentSequenceLength > 0;
            if (!code || code < 256) {
                currentSequence[0] = code;
                currentSequenceLength = 1;
            } else if (code >= 258) {
                if (code < nextCode) {
                    currentSequenceLength = dictionaryLengths[code];
                    for(j = currentSequenceLength - 1, q = code; j >= 0; j--){
                        currentSequence[j] = dictionaryValues[q];
                        q = dictionaryPrevCodes[q];
                    }
                } else currentSequence[currentSequenceLength++] = currentSequence[0];
            } else if (code === 256) {
                codeLength = 9;
                nextCode = 258;
                currentSequenceLength = 0;
                continue;
            } else {
                this.eof = true;
                delete this.lzwState;
                break;
            }
            if (hasPrev) {
                dictionaryPrevCodes[nextCode] = prevCode;
                dictionaryLengths[nextCode] = dictionaryLengths[prevCode] + 1;
                dictionaryValues[nextCode] = currentSequence[0];
                nextCode++;
                codeLength = nextCode + earlyChange & nextCode + earlyChange - 1 ? codeLength : Math.min(Math.log(nextCode + earlyChange) / 0.6931471805599453 + 1, 12) | 0;
            }
            prevCode = code;
            decodedLength += currentSequenceLength;
            if (estimatedDecodedSize < decodedLength) {
                do estimatedDecodedSize += decodedSizeDelta;
                while (estimatedDecodedSize < decodedLength);
                buffer = this.ensureBuffer(this.bufferLength + estimatedDecodedSize);
            }
            for(j = 0; j < currentSequenceLength; j++)buffer[currentBufferLength++] = currentSequence[j];
        }
        lzwState.nextCode = nextCode;
        lzwState.codeLength = codeLength;
        lzwState.prevCode = prevCode;
        lzwState.currentSequenceLength = currentSequenceLength;
        this.bufferLength = currentBufferLength;
    };
    LZWStream.prototype.readBits = function(n) {
        var bitsCached = this.bitsCached;
        var cachedData = this.cachedData;
        while(bitsCached < n){
            var c = this.stream.getByte();
            if (c === -1) {
                this.eof = true;
                return null;
            }
            cachedData = cachedData << 8 | c;
            bitsCached += 8;
        }
        this.bitsCached = bitsCached -= n;
        this.cachedData = cachedData;
        return cachedData >>> bitsCached & (1 << n) - 1;
    };
    return LZWStream;
}((0, $b7c9e74223d0896f$export$2e2bcd8739ae039));
var $176d3d2677fde3ef$export$2e2bcd8739ae039 = $176d3d2677fde3ef$var$LZWStream;


/*
 * Copyright 2012 Mozilla Foundation
 *
 * The RunLengthStream class contained in this file is a TypeScript port of the
 * JavaScript RunLengthStream class in Mozilla's pdf.js project, made available
 * under the Apache 2.0 open source license.
 */ 
var $70JnX = parcelRequire("70JnX");

var $e33a8f0a2c341980$var$RunLengthStream = /** @class */ function(_super) {
    (0, $70JnX.__extends)(RunLengthStream, _super);
    function RunLengthStream(stream, maybeLength) {
        var _this = _super.call(this, maybeLength) || this;
        _this.stream = stream;
        return _this;
    }
    RunLengthStream.prototype.readBlock = function() {
        // The repeatHeader has following format. The first byte defines type of run
        // and amount of bytes to repeat/copy: n = 0 through 127 - copy next n bytes
        // (in addition to the second byte from the header), n = 129 through 255 -
        // duplicate the second byte from the header (257 - n) times, n = 128 - end.
        var repeatHeader = this.stream.getBytes(2);
        if (!repeatHeader || repeatHeader.length < 2 || repeatHeader[0] === 128) {
            this.eof = true;
            return;
        }
        var buffer;
        var bufferLength = this.bufferLength;
        var n = repeatHeader[0];
        if (n < 128) {
            // copy n bytes
            buffer = this.ensureBuffer(bufferLength + n + 1);
            buffer[bufferLength++] = repeatHeader[1];
            if (n > 0) {
                var source = this.stream.getBytes(n);
                buffer.set(source, bufferLength);
                bufferLength += n;
            }
        } else {
            n = 257 - n;
            var b = repeatHeader[1];
            buffer = this.ensureBuffer(bufferLength + n + 1);
            for(var i = 0; i < n; i++)buffer[bufferLength++] = b;
        }
        this.bufferLength = bufferLength;
    };
    return RunLengthStream;
}((0, $b7c9e74223d0896f$export$2e2bcd8739ae039));
var $e33a8f0a2c341980$export$2e2bcd8739ae039 = $e33a8f0a2c341980$var$RunLengthStream;



var $9ebb7188d9360698$var$decodeStream = function(stream, encoding, params) {
    if (encoding === (0, $btXS2.default).of('FlateDecode')) return new (0, $5587aca36a0c26c4$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $btXS2.default).of('LZWDecode')) {
        var earlyChange = 1;
        if (params instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) {
            var EarlyChange = params.lookup((0, $btXS2.default).of('EarlyChange'));
            if (EarlyChange instanceof (0, $8LDYe.default)) earlyChange = EarlyChange.asNumber();
        }
        return new (0, $176d3d2677fde3ef$export$2e2bcd8739ae039)(stream, undefined, earlyChange);
    }
    if (encoding === (0, $btXS2.default).of('ASCII85Decode')) return new (0, $1e33e085d3b9c778$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $btXS2.default).of('ASCIIHexDecode')) return new (0, $5b84d90f6a1e69f9$export$2e2bcd8739ae039)(stream);
    if (encoding === (0, $btXS2.default).of('RunLengthDecode')) return new (0, $e33a8f0a2c341980$export$2e2bcd8739ae039)(stream);
    throw new (0, $1jVcF.UnsupportedEncodingError)(encoding.asString());
};
var $9ebb7188d9360698$export$b8317e68ca978594 = function(_a) {
    var dict = _a.dict, contents = _a.contents;
    var stream = new (0, $aecdbf1ad8d08a69$export$2e2bcd8739ae039)(contents);
    var Filter = dict.lookup((0, $btXS2.default).of('Filter'));
    var DecodeParms = dict.lookup((0, $btXS2.default).of('DecodeParms'));
    if (Filter instanceof (0, $btXS2.default)) stream = $9ebb7188d9360698$var$decodeStream(stream, Filter, DecodeParms);
    else if (Filter instanceof (0, $cUVc9.default)) for(var idx = 0, len = Filter.size(); idx < len; idx++)stream = $9ebb7188d9360698$var$decodeStream(stream, Filter.lookup(idx, (0, $btXS2.default)), DecodeParms && DecodeParms.lookupMaybe(idx, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)));
    else if (!!Filter) throw new (0, $1jVcF.UnexpectedObjectTypeError)([
        (0, $btXS2.default),
        (0, $cUVc9.default)
    ], Filter);
    return stream;
};




var $lJYRg = parcelRequire("lJYRg");
parcelRequire("JEL7f");
var $9uJGW = parcelRequire("9uJGW");
var $6a885455e88efc51$var$fullPageBoundingBox = function(page) {
    var mediaBox = page.MediaBox();
    var width = mediaBox.lookup(2, (0, $8LDYe.default)).asNumber() - mediaBox.lookup(0, (0, $8LDYe.default)).asNumber();
    var height = mediaBox.lookup(3, (0, $8LDYe.default)).asNumber() - mediaBox.lookup(1, (0, $8LDYe.default)).asNumber();
    return {
        left: 0,
        bottom: 0,
        right: width,
        top: height
    };
};
// Returns the identity matrix, modified to position the content of the given
// bounding box at (0, 0).
var $6a885455e88efc51$var$boundingBoxAdjustedMatrix = function(bb) {
    return [
        1,
        0,
        0,
        1,
        -bb.left,
        -bb.bottom
    ];
};
var $6a885455e88efc51$var$PDFPageEmbedder = /** @class */ function() {
    function PDFPageEmbedder(page, boundingBox, transformationMatrix) {
        this.page = page;
        var bb = boundingBox !== null && boundingBox !== void 0 ? boundingBox : $6a885455e88efc51$var$fullPageBoundingBox(page);
        this.width = bb.right - bb.left;
        this.height = bb.top - bb.bottom;
        this.boundingBox = bb;
        this.transformationMatrix = transformationMatrix !== null && transformationMatrix !== void 0 ? transformationMatrix : $6a885455e88efc51$var$boundingBoxAdjustedMatrix(bb);
    }
    PDFPageEmbedder.for = function(page, boundingBox, transformationMatrix) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                return [
                    2 /*return*/ ,
                    new PDFPageEmbedder(page, boundingBox, transformationMatrix)
                ];
            });
        });
    };
    PDFPageEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, Contents, Resources, decodedContents, _b, left, bottom, right, top, xObject;
            return (0, $70JnX.__generator)(this, function(_c) {
                _a = this.page.normalizedEntries(), Contents = _a.Contents, Resources = _a.Resources;
                if (!Contents) throw new (0, $1jVcF.MissingPageContentsEmbeddingError)();
                decodedContents = this.decodeContents(Contents);
                _b = this.boundingBox, left = _b.left, bottom = _b.bottom, right = _b.right, top = _b.top;
                xObject = context.flateStream(decodedContents, {
                    Type: 'XObject',
                    Subtype: 'Form',
                    FormType: 1,
                    BBox: [
                        left,
                        bottom,
                        right,
                        top
                    ],
                    Matrix: this.transformationMatrix,
                    Resources: Resources
                });
                if (ref) {
                    context.assign(ref, xObject);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(xObject)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    // `contents` is an array of streams which are merged to include them in the XObject.
    // This methods extracts each stream and joins them with a newline character.
    PDFPageEmbedder.prototype.decodeContents = function(contents) {
        var newline = Uint8Array.of((0, $lJYRg.default).Newline);
        var decodedContents = [];
        for(var idx = 0, len = contents.size(); idx < len; idx++){
            var stream = contents.lookup(idx, (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
            var content = void 0;
            if (stream instanceof (0, $d814c40cb5e196cb$export$2e2bcd8739ae039)) content = (0, $9ebb7188d9360698$export$b8317e68ca978594)(stream).decode();
            else if (stream instanceof (0, $0cd7a4dbcbade137$export$2e2bcd8739ae039)) content = stream.getUnencodedContents();
            else throw new (0, $1jVcF.UnrecognizedStreamTypeError)(stream);
            decodedContents.push(content, newline);
        }
        return (0, $9uJGW.mergeIntoTypedArray).apply(void 0, decodedContents);
    };
    return PDFPageEmbedder;
}();
var $6a885455e88efc51$export$2e2bcd8739ae039 = $6a885455e88efc51$var$PDFPageEmbedder;



var $2oTAP = parcelRequire("2oTAP");

var $iyqEO = parcelRequire("iyqEO");

var $gxKrW = parcelRequire("gxKrW");

var $8LDYe = parcelRequire("8LDYe");



var $btXS2 = parcelRequire("btXS2");


var $cUVc9 = parcelRequire("cUVc9");






var $70JnX = parcelRequire("70JnX");


var $btXS2 = parcelRequire("btXS2");

var $70JnX = parcelRequire("70JnX");



var $cUVc9 = parcelRequire("cUVc9");

var $btXS2 = parcelRequire("btXS2");

var $70JnX = parcelRequire("70JnX");


var $btXS2 = parcelRequire("btXS2");




var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");

var $cUVc9 = parcelRequire("cUVc9");

parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");

var $1jVcF = parcelRequire("1jVcF");
// Examples:
//   `/Helv 12 Tf` -> ['Helv', '12']
//   `/HeBo 8.00 Tf` -> ['HeBo', '8.00']
//   `/HeBo Tf` -> ['HeBo', undefined]
var $037b899aa622655e$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+Tf/;
var $037b899aa622655e$var$PDFAcroField = /** @class */ function() {
    function PDFAcroField(dict, ref) {
        this.dict = dict;
        this.ref = ref;
    }
    PDFAcroField.prototype.T = function() {
        return this.dict.lookupMaybe((0, $btXS2.default).of('T'), (0, $47c89398cba1043c$export$2e2bcd8739ae039), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039));
    };
    PDFAcroField.prototype.Ff = function() {
        var numberOrRef = this.getInheritableAttribute((0, $btXS2.default).of('Ff'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $8LDYe.default));
    };
    PDFAcroField.prototype.V = function() {
        var valueOrRef = this.getInheritableAttribute((0, $btXS2.default).of('V'));
        return this.dict.context.lookup(valueOrRef);
    };
    PDFAcroField.prototype.Kids = function() {
        return this.dict.lookupMaybe((0, $btXS2.default).of('Kids'), (0, $cUVc9.default));
    };
    // Parent(): PDFDict | undefined {
    //   return this.dict.lookupMaybe(PDFName.of('Parent'), PDFDict);
    // }
    PDFAcroField.prototype.DA = function() {
        var da = this.dict.lookup((0, $btXS2.default).of('DA'));
        if (da instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || da instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFAcroField.prototype.setKids = function(kids) {
        this.dict.set((0, $btXS2.default).of('Kids'), this.dict.context.obj(kids));
    };
    PDFAcroField.prototype.getParent = function() {
        // const parent = this.Parent();
        // if (!parent) return undefined;
        // return new PDFAcroField(parent);
        var parentRef = this.dict.get((0, $btXS2.default).of('Parent'));
        if (parentRef instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039)) {
            var parent_1 = this.dict.lookup((0, $btXS2.default).of('Parent'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
            return new PDFAcroField(parent_1, parentRef);
        }
        return undefined;
    };
    PDFAcroField.prototype.setParent = function(parent) {
        if (!parent) this.dict.delete((0, $btXS2.default).of('Parent'));
        else this.dict.set((0, $btXS2.default).of('Parent'), parent);
    };
    PDFAcroField.prototype.getFullyQualifiedName = function() {
        var parent = this.getParent();
        if (!parent) return this.getPartialName();
        return parent.getFullyQualifiedName() + "." + this.getPartialName();
    };
    PDFAcroField.prototype.getPartialName = function() {
        var _a;
        return (_a = this.T()) === null || _a === void 0 ? void 0 : _a.decodeText();
    };
    PDFAcroField.prototype.setPartialName = function(partialName) {
        if (!partialName) this.dict.delete((0, $btXS2.default).of('T'));
        else this.dict.set((0, $btXS2.default).of('T'), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(partialName));
    };
    PDFAcroField.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $btXS2.default).of('DA'), (0, $47c89398cba1043c$export$2e2bcd8739ae039).of(appearance));
    };
    PDFAcroField.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFAcroField.prototype.setFontSize = function(fontSize) {
        var _a;
        var name = (_a = this.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
        var da = this.getDefaultAppearance();
        if (!da) throw new (0, $1jVcF.MissingDAEntryError)(name);
        var daMatch = (0, $c6a2W.findLastMatch)(da, $037b899aa622655e$var$tfRegex);
        if (!daMatch.match) throw new (0, $1jVcF.MissingTfOperatorError)(name);
        var daStart = da.slice(0, daMatch.pos - daMatch.match[0].length);
        var daEnd = daMatch.pos <= da.length ? da.slice(daMatch.pos) : '';
        var fontName = daMatch.match[1];
        var modifiedDa = daStart + " /" + fontName + " " + fontSize + " Tf " + daEnd;
        this.setDefaultAppearance(modifiedDa);
    };
    PDFAcroField.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.Ff()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAcroField.prototype.setFlags = function(flags) {
        this.dict.set((0, $btXS2.default).of('Ff'), (0, $8LDYe.default).of(flags));
    };
    PDFAcroField.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAcroField.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAcroField.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAcroField.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAcroField.prototype.getInheritableAttribute = function(name) {
        var attribute;
        this.ascend(function(node) {
            if (!attribute) attribute = node.dict.get(name);
        });
        return attribute;
    };
    PDFAcroField.prototype.ascend = function(visitor) {
        visitor(this);
        var parent = this.getParent();
        if (parent) parent.ascend(visitor);
    };
    return PDFAcroField;
}();
var $037b899aa622655e$export$2e2bcd8739ae039 = $037b899aa622655e$var$PDFAcroField;



var $70JnX = parcelRequire("70JnX");


var $btXS2 = parcelRequire("btXS2");




var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");
// TODO: Also handle the `/S` and `/D` entries
var $0dbbf0fcb01a01ca$var$BorderStyle = /** @class */ function() {
    function BorderStyle(dict) {
        this.dict = dict;
    }
    BorderStyle.prototype.W = function() {
        var W = this.dict.lookup((0, $btXS2.default).of('W'));
        if (W instanceof (0, $8LDYe.default)) return W;
        return undefined;
    };
    BorderStyle.prototype.getWidth = function() {
        var _a, _b;
        return (_b = (_a = this.W()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 1;
    };
    BorderStyle.prototype.setWidth = function(width) {
        var W = this.dict.context.obj(width);
        this.dict.set((0, $btXS2.default).of('W'), W);
    };
    BorderStyle.fromDict = function(dict) {
        return new BorderStyle(dict);
    };
    return BorderStyle;
}();
var $0dbbf0fcb01a01ca$export$2e2bcd8739ae039 = $0dbbf0fcb01a01ca$var$BorderStyle;




var $btXS2 = parcelRequire("btXS2");


var $cUVc9 = parcelRequire("cUVc9");


var $8LDYe = parcelRequire("8LDYe");
var $2fb68d72533b0cf7$var$PDFAnnotation = /** @class */ function() {
    function PDFAnnotation(dict) {
        this.dict = dict;
    }
    // This is technically required by the PDF spec
    PDFAnnotation.prototype.Rect = function() {
        return this.dict.lookup((0, $btXS2.default).of('Rect'), (0, $cUVc9.default));
    };
    PDFAnnotation.prototype.AP = function() {
        return this.dict.lookupMaybe((0, $btXS2.default).of('AP'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFAnnotation.prototype.F = function() {
        var numberOrRef = this.dict.lookup((0, $btXS2.default).of('F'));
        return this.dict.context.lookupMaybe(numberOrRef, (0, $8LDYe.default));
    };
    PDFAnnotation.prototype.getRectangle = function() {
        var _a;
        var Rect = this.Rect();
        return (_a = Rect === null || Rect === void 0 ? void 0 : Rect.asRectangle()) !== null && _a !== void 0 ? _a : {
            x: 0,
            y: 0,
            width: 0,
            height: 0
        };
    };
    PDFAnnotation.prototype.setRectangle = function(rect) {
        var x = rect.x, y = rect.y, width = rect.width, height = rect.height;
        var Rect = this.dict.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.dict.set((0, $btXS2.default).of('Rect'), Rect);
    };
    PDFAnnotation.prototype.getAppearanceState = function() {
        var AS = this.dict.lookup((0, $btXS2.default).of('AS'));
        if (AS instanceof (0, $btXS2.default)) return AS;
        return undefined;
    };
    PDFAnnotation.prototype.setAppearanceState = function(state) {
        this.dict.set((0, $btXS2.default).of('AS'), state);
    };
    PDFAnnotation.prototype.setAppearances = function(appearances) {
        this.dict.set((0, $btXS2.default).of('AP'), appearances);
    };
    PDFAnnotation.prototype.ensureAP = function() {
        var AP = this.AP();
        if (!AP) {
            AP = this.dict.context.obj({});
            this.dict.set((0, $btXS2.default).of('AP'), AP);
        }
        return AP;
    };
    PDFAnnotation.prototype.getNormalAppearance = function() {
        var AP = this.ensureAP();
        var N = AP.get((0, $btXS2.default).of('N'));
        if (N instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039) || N instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) return N;
        throw new Error("Unexpected N type: " + (N === null || N === void 0 ? void 0 : N.constructor.name));
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setNormalAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $btXS2.default).of('N'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setRolloverAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $btXS2.default).of('R'), appearance);
    };
    /** @param appearance A PDFDict or PDFStream (direct or ref) */ PDFAnnotation.prototype.setDownAppearance = function(appearance) {
        var AP = this.ensureAP();
        AP.set((0, $btXS2.default).of('D'), appearance);
    };
    PDFAnnotation.prototype.removeRolloverAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $btXS2.default).of('R'));
    };
    PDFAnnotation.prototype.removeDownAppearance = function() {
        var AP = this.AP();
        AP === null || AP === void 0 || AP.delete((0, $btXS2.default).of('D'));
    };
    PDFAnnotation.prototype.getAppearances = function() {
        var AP = this.AP();
        if (!AP) return undefined;
        var N = AP.lookup((0, $btXS2.default).of('N'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039), (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
        var R = AP.lookupMaybe((0, $btXS2.default).of('R'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039), (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
        var D = AP.lookupMaybe((0, $btXS2.default).of('D'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039), (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039));
        return {
            normal: N,
            rollover: R,
            down: D
        };
    };
    PDFAnnotation.prototype.getFlags = function() {
        var _a, _b;
        return (_b = (_a = this.F()) === null || _a === void 0 ? void 0 : _a.asNumber()) !== null && _b !== void 0 ? _b : 0;
    };
    PDFAnnotation.prototype.setFlags = function(flags) {
        this.dict.set((0, $btXS2.default).of('F'), (0, $8LDYe.default).of(flags));
    };
    PDFAnnotation.prototype.hasFlag = function(flag) {
        var flags = this.getFlags();
        return (flags & flag) !== 0;
    };
    PDFAnnotation.prototype.setFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags | flag);
    };
    PDFAnnotation.prototype.clearFlag = function(flag) {
        var flags = this.getFlags();
        this.setFlags(flags & ~flag);
    };
    PDFAnnotation.prototype.setFlagTo = function(flag, enable) {
        if (enable) this.setFlag(flag);
        else this.clearFlag(flag);
    };
    PDFAnnotation.fromDict = function(dict) {
        return new PDFAnnotation(dict);
    };
    return PDFAnnotation;
}();
var $2fb68d72533b0cf7$export$2e2bcd8739ae039 = $2fb68d72533b0cf7$var$PDFAnnotation;



var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");

var $cUVc9 = parcelRequire("cUVc9");


var $4c3eee57afd0f82e$var$AppearanceCharacteristics = /** @class */ function() {
    function AppearanceCharacteristics(dict) {
        this.dict = dict;
    }
    AppearanceCharacteristics.prototype.R = function() {
        var R = this.dict.lookup((0, $btXS2.default).of('R'));
        if (R instanceof (0, $8LDYe.default)) return R;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BC = function() {
        var BC = this.dict.lookup((0, $btXS2.default).of('BC'));
        if (BC instanceof (0, $cUVc9.default)) return BC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.BG = function() {
        var BG = this.dict.lookup((0, $btXS2.default).of('BG'));
        if (BG instanceof (0, $cUVc9.default)) return BG;
        return undefined;
    };
    AppearanceCharacteristics.prototype.CA = function() {
        var CA = this.dict.lookup((0, $btXS2.default).of('CA'));
        if (CA instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039) || CA instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039)) return CA;
        return undefined;
    };
    AppearanceCharacteristics.prototype.RC = function() {
        var RC = this.dict.lookup((0, $btXS2.default).of('RC'));
        if (RC instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039) || RC instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039)) return RC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.AC = function() {
        var AC = this.dict.lookup((0, $btXS2.default).of('AC'));
        if (AC instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039) || AC instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039)) return AC;
        return undefined;
    };
    AppearanceCharacteristics.prototype.getRotation = function() {
        var _a;
        return (_a = this.R()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    AppearanceCharacteristics.prototype.getBorderColor = function() {
        var BC = this.BC();
        if (!BC) return undefined;
        var components = [];
        for(var idx = 0, len = BC === null || BC === void 0 ? void 0 : BC.size(); idx < len; idx++){
            var component = BC.get(idx);
            if (component instanceof (0, $8LDYe.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getBackgroundColor = function() {
        var BG = this.BG();
        if (!BG) return undefined;
        var components = [];
        for(var idx = 0, len = BG === null || BG === void 0 ? void 0 : BG.size(); idx < len; idx++){
            var component = BG.get(idx);
            if (component instanceof (0, $8LDYe.default)) components.push(component.asNumber());
        }
        return components;
    };
    AppearanceCharacteristics.prototype.getCaptions = function() {
        var CA = this.CA();
        var RC = this.RC();
        var AC = this.AC();
        return {
            normal: CA === null || CA === void 0 ? void 0 : CA.decodeText(),
            rollover: RC === null || RC === void 0 ? void 0 : RC.decodeText(),
            down: AC === null || AC === void 0 ? void 0 : AC.decodeText()
        };
    };
    AppearanceCharacteristics.prototype.setRotation = function(rotation) {
        var R = this.dict.context.obj(rotation);
        this.dict.set((0, $btXS2.default).of('R'), R);
    };
    AppearanceCharacteristics.prototype.setBorderColor = function(color) {
        var BC = this.dict.context.obj(color);
        this.dict.set((0, $btXS2.default).of('BC'), BC);
    };
    AppearanceCharacteristics.prototype.setBackgroundColor = function(color) {
        var BG = this.dict.context.obj(color);
        this.dict.set((0, $btXS2.default).of('BG'), BG);
    };
    AppearanceCharacteristics.prototype.setCaptions = function(captions) {
        var CA = (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(captions.normal);
        this.dict.set((0, $btXS2.default).of('CA'), CA);
        if (captions.rollover) {
            var RC = (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(captions.rollover);
            this.dict.set((0, $btXS2.default).of('RC'), RC);
        } else this.dict.delete((0, $btXS2.default).of('RC'));
        if (captions.down) {
            var AC = (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(captions.down);
            this.dict.set((0, $btXS2.default).of('AC'), AC);
        } else this.dict.delete((0, $btXS2.default).of('AC'));
    };
    AppearanceCharacteristics.fromDict = function(dict) {
        return new AppearanceCharacteristics(dict);
    };
    return AppearanceCharacteristics;
}();
var $4c3eee57afd0f82e$export$2e2bcd8739ae039 = $4c3eee57afd0f82e$var$AppearanceCharacteristics;


var $746c51fc65011bd5$var$PDFWidgetAnnotation = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFWidgetAnnotation, _super);
    function PDFWidgetAnnotation() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFWidgetAnnotation.prototype.MK = function() {
        var MK = this.dict.lookup((0, $btXS2.default).of('MK'));
        if (MK instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) return MK;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.BS = function() {
        var BS = this.dict.lookup((0, $btXS2.default).of('BS'));
        if (BS instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) return BS;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.DA = function() {
        var da = this.dict.lookup((0, $btXS2.default).of('DA'));
        if (da instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || da instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return da;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.P = function() {
        var P = this.dict.get((0, $btXS2.default).of('P'));
        if (P instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039)) return P;
        return undefined;
    };
    PDFWidgetAnnotation.prototype.setP = function(page) {
        this.dict.set((0, $btXS2.default).of('P'), page);
    };
    PDFWidgetAnnotation.prototype.setDefaultAppearance = function(appearance) {
        this.dict.set((0, $btXS2.default).of('DA'), (0, $47c89398cba1043c$export$2e2bcd8739ae039).of(appearance));
    };
    PDFWidgetAnnotation.prototype.getDefaultAppearance = function() {
        var DA = this.DA();
        if (DA instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return DA.decodeText();
        return DA === null || DA === void 0 ? void 0 : DA.asString();
    };
    PDFWidgetAnnotation.prototype.getAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4c3eee57afd0f82e$export$2e2bcd8739ae039).fromDict(MK);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateAppearanceCharacteristics = function() {
        var MK = this.MK();
        if (MK) return (0, $4c3eee57afd0f82e$export$2e2bcd8739ae039).fromDict(MK);
        var ac = (0, $4c3eee57afd0f82e$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $btXS2.default).of('MK'), ac.dict);
        return ac;
    };
    PDFWidgetAnnotation.prototype.getBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $0dbbf0fcb01a01ca$export$2e2bcd8739ae039).fromDict(BS);
        return undefined;
    };
    PDFWidgetAnnotation.prototype.getOrCreateBorderStyle = function() {
        var BS = this.BS();
        if (BS) return (0, $0dbbf0fcb01a01ca$export$2e2bcd8739ae039).fromDict(BS);
        var bs = (0, $0dbbf0fcb01a01ca$export$2e2bcd8739ae039).fromDict(this.dict.context.obj({}));
        this.dict.set((0, $btXS2.default).of('BS'), bs.dict);
        return bs;
    };
    PDFWidgetAnnotation.prototype.getOnValue = function() {
        var _a;
        var normal = (_a = this.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
        if (normal instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) {
            var keys = normal.keys();
            for(var idx = 0, len = keys.length; idx < len; idx++){
                var key = keys[idx];
                if (key !== (0, $btXS2.default).of('Off')) return key;
            }
        }
        return undefined;
    };
    PDFWidgetAnnotation.fromDict = function(dict) {
        return new PDFWidgetAnnotation(dict);
    };
    PDFWidgetAnnotation.create = function(context, parent) {
        var dict = context.obj({
            Type: 'Annot',
            Subtype: 'Widget',
            Rect: [
                0,
                0,
                0,
                0
            ],
            Parent: parent
        });
        return new PDFWidgetAnnotation(dict);
    };
    return PDFWidgetAnnotation;
}((0, $2fb68d72533b0cf7$export$2e2bcd8739ae039));
var $746c51fc65011bd5$export$2e2bcd8739ae039 = $746c51fc65011bd5$var$PDFWidgetAnnotation;



var $1jVcF = parcelRequire("1jVcF");
var $c767daefd50ee8ad$var$PDFAcroTerminal = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroTerminal, _super);
    function PDFAcroTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroTerminal.prototype.FT = function() {
        var nameOrRef = this.getInheritableAttribute((0, $btXS2.default).of('FT'));
        return this.dict.context.lookup(nameOrRef, (0, $btXS2.default));
    };
    PDFAcroTerminal.prototype.getWidgets = function() {
        var kidDicts = this.Kids();
        // This field is itself a widget
        if (!kidDicts) return [
            (0, $746c51fc65011bd5$export$2e2bcd8739ae039).fromDict(this.dict)
        ];
        // This field's kids are its widgets
        var widgets = new Array(kidDicts.size());
        for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
            var dict = kidDicts.lookup(idx, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
            widgets[idx] = (0, $746c51fc65011bd5$export$2e2bcd8739ae039).fromDict(dict);
        }
        return widgets;
    };
    PDFAcroTerminal.prototype.addWidget = function(ref) {
        var Kids = this.normalizedEntries().Kids;
        Kids.push(ref);
    };
    PDFAcroTerminal.prototype.removeWidget = function(idx) {
        var kidDicts = this.Kids();
        if (!kidDicts) {
            // This field is itself a widget
            if (idx !== 0) throw new (0, $1jVcF.IndexOutOfBoundsError)(idx, 0, 0);
            this.setKids([]);
        } else {
            // This field's kids are its widgets
            if (idx < 0 || idx > kidDicts.size()) throw new (0, $1jVcF.IndexOutOfBoundsError)(idx, 0, kidDicts.size());
            kidDicts.remove(idx);
        }
    };
    PDFAcroTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        // If this field is itself a widget (because it was only rendered once in
        // the document, so the field and widget properties were merged) then we
        // add itself to the `Kids` array. The alternative would be to try
        // splitting apart the widget properties and creating a separate object
        // for them.
        if (!Kids) {
            Kids = this.dict.context.obj([
                this.ref
            ]);
            this.dict.set((0, $btXS2.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroTerminal.fromDict = function(dict, ref) {
        return new PDFAcroTerminal(dict, ref);
    };
    return PDFAcroTerminal;
}((0, $037b899aa622655e$export$2e2bcd8739ae039));
var $c767daefd50ee8ad$export$2e2bcd8739ae039 = $c767daefd50ee8ad$var$PDFAcroTerminal;



var $1jVcF = parcelRequire("1jVcF");
var $0350c23ce5d51172$var$PDFAcroButton = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroButton, _super);
    function PDFAcroButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroButton.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $btXS2.default).of('Opt'), (0, $47c89398cba1043c$export$2e2bcd8739ae039), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039), (0, $cUVc9.default));
    };
    PDFAcroButton.prototype.setOpt = function(opt) {
        this.dict.set((0, $btXS2.default).of('Opt'), this.dict.context.obj(opt));
    };
    PDFAcroButton.prototype.getExportValues = function() {
        var opt = this.Opt();
        if (!opt) return undefined;
        if (opt instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || opt instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return [
            opt
        ];
        var values = [];
        for(var idx = 0, len = opt.size(); idx < len; idx++){
            var value = opt.lookup(idx);
            if (value instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || value instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) values.push(value);
        }
        return values;
    };
    PDFAcroButton.prototype.removeExportValue = function(idx) {
        var opt = this.Opt();
        if (!opt) return;
        if (opt instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || opt instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) {
            if (idx !== 0) throw new (0, $1jVcF.IndexOutOfBoundsError)(idx, 0, 0);
            this.setOpt([]);
        } else {
            if (idx < 0 || idx > opt.size()) throw new (0, $1jVcF.IndexOutOfBoundsError)(idx, 0, opt.size());
            opt.remove(idx);
        }
    };
    // Enforce use use of /Opt even if it isn't strictly necessary
    PDFAcroButton.prototype.normalizeExportValues = function() {
        var _a, _b, _c, _d;
        var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
        var Opt = [];
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var exportVal = (_b = exportValues[idx]) !== null && _b !== void 0 ? _b : (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText((_d = (_c = widget.getOnValue()) === null || _c === void 0 ? void 0 : _c.decodeText()) !== null && _d !== void 0 ? _d : '');
            Opt.push(exportVal);
        }
        this.setOpt(Opt);
    };
    /**
     * Reuses existing opt if one exists with the same value (assuming
     * `useExistingIdx` is `true`). Returns index of existing (or new) opt.
     */ PDFAcroButton.prototype.addOpt = function(opt, useExistingOptIdx) {
        var _a;
        this.normalizeExportValues();
        var optText = opt.decodeText();
        var existingIdx;
        if (useExistingOptIdx) {
            var exportValues = (_a = this.getExportValues()) !== null && _a !== void 0 ? _a : [];
            for(var idx = 0, len = exportValues.length; idx < len; idx++){
                var exportVal = exportValues[idx];
                if (exportVal.decodeText() === optText) existingIdx = idx;
            }
        }
        var Opt = this.Opt();
        Opt.push(opt);
        return existingIdx !== null && existingIdx !== void 0 ? existingIdx : Opt.size() - 1;
    };
    PDFAcroButton.prototype.addWidgetWithOpt = function(widget, opt, useExistingOptIdx) {
        var optIdx = this.addOpt(opt, useExistingOptIdx);
        var apStateValue = (0, $btXS2.default).of(String(optIdx));
        this.addWidget(widget);
        return apStateValue;
    };
    return PDFAcroButton;
}((0, $c767daefd50ee8ad$export$2e2bcd8739ae039));
var $0350c23ce5d51172$export$2e2bcd8739ae039 = $0350c23ce5d51172$var$PDFAcroButton;



var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");


var $1jVcF = parcelRequire("1jVcF");
var $4e7ed1a5388e159e$var$PDFAcroCheckBox = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroCheckBox, _super);
    function PDFAcroCheckBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroCheckBox.prototype.setValue = function(value) {
        var _a;
        var onValue = (_a = this.getOnValue()) !== null && _a !== void 0 ? _a : (0, $btXS2.default).of('Yes');
        if (value !== onValue && value !== (0, $btXS2.default).of('Off')) throw new (0, $1jVcF.InvalidAcroFieldValueError)();
        this.dict.set((0, $btXS2.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $btXS2.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroCheckBox.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $btXS2.default)) return v;
        return (0, $btXS2.default).of('Off');
    };
    PDFAcroCheckBox.prototype.getOnValue = function() {
        var widget = this.getWidgets()[0];
        return widget === null || widget === void 0 ? void 0 : widget.getOnValue();
    };
    PDFAcroCheckBox.fromDict = function(dict, ref) {
        return new PDFAcroCheckBox(dict, ref);
    };
    PDFAcroCheckBox.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroCheckBox(dict, ref);
    };
    return PDFAcroCheckBox;
}((0, $0350c23ce5d51172$export$2e2bcd8739ae039));
var $4e7ed1a5388e159e$export$2e2bcd8739ae039 = $4e7ed1a5388e159e$var$PDFAcroCheckBox;



var $70JnX = parcelRequire("70JnX");




var $cUVc9 = parcelRequire("cUVc9");

var $btXS2 = parcelRequire("btXS2");
var $248d91c4d95d4c44$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $248d91c4d95d4c44$export$3600c95532547643;
(function(AcroFieldFlags) {
    /**
     * If set, the user may not change the value of the field. Any associated
     * widget annotations will not interact with the user; that is, they will not
     * respond to mouse clicks or change their appearance in response to mouse
     * motions. This flag is useful for fields whose values are computed or
     * imported from a database.
     */ AcroFieldFlags[AcroFieldFlags["ReadOnly"] = $248d91c4d95d4c44$var$flag(0)] = "ReadOnly";
    /**
     * If set, the field shall have a value at the time it is exported by a
     * submit-form action (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["Required"] = $248d91c4d95d4c44$var$flag(1)] = "Required";
    /**
     * If set, the field shall not be exported by a submit-form action
     * (see 12.7.5.2, "Submit-Form Action").
     */ AcroFieldFlags[AcroFieldFlags["NoExport"] = $248d91c4d95d4c44$var$flag(2)] = "NoExport";
})($248d91c4d95d4c44$export$3600c95532547643 || ($248d91c4d95d4c44$export$3600c95532547643 = {}));
var $248d91c4d95d4c44$export$59f660e89ffb4f8a;
(function(AcroButtonFlags) {
    /**
     * (Radio buttons only) If set, exactly one radio button shall be selected at
     * all times; selecting the currently selected button has no effect. If clear,
     * clicking the selected button deselects it, leaving no button selected.
     */ AcroButtonFlags[AcroButtonFlags["NoToggleToOff"] = $248d91c4d95d4c44$var$flag(14)] = "NoToggleToOff";
    /**
     * If set, the field is a set of radio buttons; if clear, the field is a check
     * box. This flag may be set only if the Pushbutton flag is clear.
     */ AcroButtonFlags[AcroButtonFlags["Radio"] = $248d91c4d95d4c44$var$flag(15)] = "Radio";
    /**
     * If set, the field is a pushbutton that does not retain a permanent value.
     */ AcroButtonFlags[AcroButtonFlags["PushButton"] = $248d91c4d95d4c44$var$flag(16)] = "PushButton";
    /**
     * If set, a group of radio buttons within a radio button field that use the
     * same value for the on state will turn on and off in unison; that is if one
     * is checked, they are all checked. If clear, the buttons are mutually
     * exclusive (the same behavior as HTML radio buttons).
     */ AcroButtonFlags[AcroButtonFlags["RadiosInUnison"] = $248d91c4d95d4c44$var$flag(25)] = "RadiosInUnison";
})($248d91c4d95d4c44$export$59f660e89ffb4f8a || ($248d91c4d95d4c44$export$59f660e89ffb4f8a = {}));
var $248d91c4d95d4c44$export$389fc7b97397dc8b;
(function(AcroTextFlags) {
    /**
     * If set, the field may contain multiple lines of text; if clear, the field's
     * text shall be restricted to a single line.
     */ AcroTextFlags[AcroTextFlags["Multiline"] = $248d91c4d95d4c44$var$flag(12)] = "Multiline";
    /**
     * If set, the field is intended for entering a secure password that should
     * not be echoed visibly to the screen. Characters typed from the keyboard
     * shall instead be echoed in some unreadable form, such as asterisks or
     * bullet characters.
     * > NOTE   To protect password confidentiality, readers should never store
     * >        the value of the text field in the PDF file if this flag is set.
     */ AcroTextFlags[AcroTextFlags["Password"] = $248d91c4d95d4c44$var$flag(13)] = "Password";
    /**
     * If set, the text entered in the field represents the pathname of a file
     * whose contents shall be submitted as the value of the field.
     */ AcroTextFlags[AcroTextFlags["FileSelect"] = $248d91c4d95d4c44$var$flag(20)] = "FileSelect";
    /**
     * If set, text entered in the field shall not be spell-checked.
     */ AcroTextFlags[AcroTextFlags["DoNotSpellCheck"] = $248d91c4d95d4c44$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the field shall not scroll (horizontally for single-line fields,
     * vertically for multiple-line fields) to accommodate more text than fits
     * within its annotation rectangle. Once the field is full, no further text
     * shall be accepted for interactive form filling; for non-interactive form
     * filling, the filler should take care not to add more character than will
     * visibly fit in the defined area.
     */ AcroTextFlags[AcroTextFlags["DoNotScroll"] = $248d91c4d95d4c44$var$flag(23)] = "DoNotScroll";
    /**
     * May be set only if the MaxLen entry is present in the text field dictionary
     * (see Table 229) and if the Multiline, Password, and FileSelect flags are
     * clear. If set, the field shall be automatically divided into as many
     * equally spaced positions, or combs, as the value of MaxLen, and the text
     * is laid out into those combs.
     */ AcroTextFlags[AcroTextFlags["Comb"] = $248d91c4d95d4c44$var$flag(24)] = "Comb";
    /**
     * If set, the value of this field shall be a rich text string
     * (see 12.7.3.4, "Rich Text Strings"). If the field has a value, the RV
     * entry of the field dictionary (Table 222) shall specify the rich text
     * string.
     */ AcroTextFlags[AcroTextFlags["RichText"] = $248d91c4d95d4c44$var$flag(25)] = "RichText";
})($248d91c4d95d4c44$export$389fc7b97397dc8b || ($248d91c4d95d4c44$export$389fc7b97397dc8b = {}));
var $248d91c4d95d4c44$export$eb88827058402599;
(function(AcroChoiceFlags) {
    /**
     * If set, the field is a combo box; if clear, the field is a list box.
     */ AcroChoiceFlags[AcroChoiceFlags["Combo"] = $248d91c4d95d4c44$var$flag(17)] = "Combo";
    /**
     * If set, the combo box shall include an editable text box as well as a
     * drop-down list; if clear, it shall include only a drop-down list. This
     * flag shall be used only if the Combo flag is set.
     */ AcroChoiceFlags[AcroChoiceFlags["Edit"] = $248d91c4d95d4c44$var$flag(18)] = "Edit";
    /**
     * If set, the field's option items shall be sorted alphabetically. This flag
     * is intended for use by writers, not by readers. Conforming readers shall
     * display the options in the order in which they occur in the Opt array
     * (see Table 231).
     */ AcroChoiceFlags[AcroChoiceFlags["Sort"] = $248d91c4d95d4c44$var$flag(19)] = "Sort";
    /**
     * If set, more than one of the field's option items may be selected
     * simultaneously; if clear, at most one item shall be selected.
     */ AcroChoiceFlags[AcroChoiceFlags["MultiSelect"] = $248d91c4d95d4c44$var$flag(21)] = "MultiSelect";
    /**
     * If set, text entered in the field shall not be spell-checked. This flag
     * shall not be used unless the Combo and Edit flags are both set.
     */ AcroChoiceFlags[AcroChoiceFlags["DoNotSpellCheck"] = $248d91c4d95d4c44$var$flag(22)] = "DoNotSpellCheck";
    /**
     * If set, the new value shall be committed as soon as a selection is made
     * (commonly with the pointing device). In this case, supplying a value for
     * a field involves three actions: selecting the field for fill-in,
     * selecting a choice for the fill-in value, and leaving that field, which
     * finalizes or "commits" the data choice and triggers any actions associated
     * with the entry or changing of this data. If this flag is on, then
     * processing does not wait for leaving the field action to occur, but
     * immediately proceeds to the third step.
     *
     * This option enables applications to perform an action once a selection is
     * made, without requiring the user to exit the field. If clear, the new
     * value is not committed until the user exits the field.
     */ AcroChoiceFlags[AcroChoiceFlags["CommitOnSelChange"] = $248d91c4d95d4c44$var$flag(26)] = "CommitOnSelChange";
})($248d91c4d95d4c44$export$eb88827058402599 || ($248d91c4d95d4c44$export$eb88827058402599 = {}));



var $1jVcF = parcelRequire("1jVcF");
var $5417d956ec76da1d$var$PDFAcroChoice = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroChoice, _super);
    function PDFAcroChoice() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroChoice.prototype.setValues = function(values) {
        if (this.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).Combo) && !this.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).Edit) && !this.valuesAreValid(values)) throw new (0, $1jVcF.InvalidAcroFieldValueError)();
        if (values.length === 0) this.dict.delete((0, $btXS2.default).of('V'));
        if (values.length === 1) this.dict.set((0, $btXS2.default).of('V'), values[0]);
        if (values.length > 1) {
            if (!this.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect)) throw new (0, $1jVcF.MultiSelectValueError)();
            this.dict.set((0, $btXS2.default).of('V'), this.dict.context.obj(values));
        }
        this.updateSelectedIndices(values);
    };
    PDFAcroChoice.prototype.valuesAreValid = function(values) {
        var options = this.getOptions();
        var _loop_1 = function(idx, len) {
            var val = values[idx].decodeText();
            if (!options.find(function(o) {
                return val === (o.display || o.value).decodeText();
            })) return {
                value: false
            };
        };
        for(var idx = 0, len = values.length; idx < len; idx++){
            var state_1 = _loop_1(idx, len);
            if (typeof state_1 === "object") return state_1.value;
        }
        return true;
    };
    PDFAcroChoice.prototype.updateSelectedIndices = function(values) {
        if (values.length > 1) {
            var indices = new Array(values.length);
            var options = this.getOptions();
            var _loop_2 = function(idx, len) {
                var val = values[idx].decodeText();
                indices[idx] = options.findIndex(function(o) {
                    return val === (o.display || o.value).decodeText();
                });
            };
            for(var idx = 0, len = values.length; idx < len; idx++)_loop_2(idx, len);
            this.dict.set((0, $btXS2.default).of('I'), this.dict.context.obj(indices.sort()));
        } else this.dict.delete((0, $btXS2.default).of('I'));
    };
    PDFAcroChoice.prototype.getValues = function() {
        var v = this.V();
        if (v instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || v instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return [
            v
        ];
        if (v instanceof (0, $cUVc9.default)) {
            var values = [];
            for(var idx = 0, len = v.size(); idx < len; idx++){
                var value = v.lookup(idx);
                if (value instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || value instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) values.push(value);
            }
            return values;
        }
        return [];
    };
    PDFAcroChoice.prototype.Opt = function() {
        return this.dict.lookupMaybe((0, $btXS2.default).of('Opt'), (0, $47c89398cba1043c$export$2e2bcd8739ae039), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039), (0, $cUVc9.default));
    };
    PDFAcroChoice.prototype.setOptions = function(options) {
        var newOpt = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = options[idx], value = _a.value, display = _a.display;
            newOpt[idx] = this.dict.context.obj([
                value,
                display || value
            ]);
        }
        this.dict.set((0, $btXS2.default).of('Opt'), this.dict.context.obj(newOpt));
    };
    PDFAcroChoice.prototype.getOptions = function() {
        var Opt = this.Opt();
        // Not supposed to happen - Opt _should_ always be `PDFArray | undefined`
        if (Opt instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || Opt instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return [
            {
                value: Opt,
                display: Opt
            }
        ];
        if (Opt instanceof (0, $cUVc9.default)) {
            var res = [];
            for(var idx = 0, len = Opt.size(); idx < len; idx++){
                var item = Opt.lookup(idx);
                // If `item` is a string, use that as both the export and text value
                if (item instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || item instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) res.push({
                    value: item,
                    display: item
                });
                // If `item` is an array of one, treat it the same as just a string,
                // if it's an array of two then `item[0]` is the export value and
                // `item[1]` is the text value
                if (item instanceof (0, $cUVc9.default)) {
                    if (item.size() > 0) {
                        var first = item.lookup(0, (0, $47c89398cba1043c$export$2e2bcd8739ae039), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039));
                        var second = item.lookupMaybe(1, (0, $47c89398cba1043c$export$2e2bcd8739ae039), (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039));
                        res.push({
                            value: first,
                            display: second || first
                        });
                    }
                }
            }
            return res;
        }
        return [];
    };
    return PDFAcroChoice;
}((0, $c767daefd50ee8ad$export$2e2bcd8739ae039));
var $5417d956ec76da1d$export$2e2bcd8739ae039 = $5417d956ec76da1d$var$PDFAcroChoice;



var $70JnX = parcelRequire("70JnX");


var $b9e1c95445e29e3a$var$PDFAcroComboBox = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroComboBox, _super);
    function PDFAcroComboBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroComboBox.fromDict = function(dict, ref) {
        return new PDFAcroComboBox(dict, ref);
    };
    PDFAcroComboBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Ff: (0, $248d91c4d95d4c44$export$eb88827058402599).Combo,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroComboBox(dict, ref);
    };
    return PDFAcroComboBox;
}((0, $5417d956ec76da1d$export$2e2bcd8739ae039));
var $b9e1c95445e29e3a$export$2e2bcd8739ae039 = $b9e1c95445e29e3a$var$PDFAcroComboBox;





var $cUVc9 = parcelRequire("cUVc9");

var $btXS2 = parcelRequire("btXS2");

var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");

var $dbfd42e360237923$var$PDFAcroNonTerminal = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroNonTerminal, _super);
    function PDFAcroNonTerminal() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroNonTerminal.prototype.addField = function(field) {
        var Kids = this.normalizedEntries().Kids;
        Kids === null || Kids === void 0 || Kids.push(field);
    };
    PDFAcroNonTerminal.prototype.normalizedEntries = function() {
        var Kids = this.Kids();
        if (!Kids) {
            Kids = this.dict.context.obj([]);
            this.dict.set((0, $btXS2.default).of('Kids'), Kids);
        }
        return {
            Kids: Kids
        };
    };
    PDFAcroNonTerminal.fromDict = function(dict, ref) {
        return new PDFAcroNonTerminal(dict, ref);
    };
    PDFAcroNonTerminal.create = function(context) {
        var dict = context.obj({});
        var ref = context.register(dict);
        return new PDFAcroNonTerminal(dict, ref);
    };
    return PDFAcroNonTerminal;
}((0, $037b899aa622655e$export$2e2bcd8739ae039));
var $dbfd42e360237923$export$2e2bcd8739ae039 = $dbfd42e360237923$var$PDFAcroNonTerminal;



var $8LDYe = parcelRequire("8LDYe");


var $btXS2 = parcelRequire("btXS2");

var $cUVc9 = parcelRequire("cUVc9");




var $70JnX = parcelRequire("70JnX");

var $8236815884bcced8$var$PDFAcroSignature = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroSignature, _super);
    function PDFAcroSignature() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroSignature.fromDict = function(dict, ref) {
        return new PDFAcroSignature(dict, ref);
    };
    return PDFAcroSignature;
}((0, $c767daefd50ee8ad$export$2e2bcd8739ae039));
var $8236815884bcced8$export$2e2bcd8739ae039 = $8236815884bcced8$var$PDFAcroSignature;



var $70JnX = parcelRequire("70JnX");

var $8LDYe = parcelRequire("8LDYe");



var $btXS2 = parcelRequire("btXS2");

var $d76660bc35a07b3f$var$PDFAcroText = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroText, _super);
    function PDFAcroText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroText.prototype.MaxLen = function() {
        var maxLen = this.dict.lookup((0, $btXS2.default).of('MaxLen'));
        if (maxLen instanceof (0, $8LDYe.default)) return maxLen;
        return undefined;
    };
    PDFAcroText.prototype.Q = function() {
        var q = this.dict.lookup((0, $btXS2.default).of('Q'));
        if (q instanceof (0, $8LDYe.default)) return q;
        return undefined;
    };
    PDFAcroText.prototype.setMaxLength = function(maxLength) {
        this.dict.set((0, $btXS2.default).of('MaxLen'), (0, $8LDYe.default).of(maxLength));
    };
    PDFAcroText.prototype.removeMaxLength = function() {
        this.dict.delete((0, $btXS2.default).of('MaxLen'));
    };
    PDFAcroText.prototype.getMaxLength = function() {
        var _a;
        return (_a = this.MaxLen()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setQuadding = function(quadding) {
        this.dict.set((0, $btXS2.default).of('Q'), (0, $8LDYe.default).of(quadding));
    };
    PDFAcroText.prototype.getQuadding = function() {
        var _a;
        return (_a = this.Q()) === null || _a === void 0 ? void 0 : _a.asNumber();
    };
    PDFAcroText.prototype.setValue = function(value) {
        this.dict.set((0, $btXS2.default).of('V'), value);
    // const widgets = this.getWidgets();
    // for (let idx = 0, len = widgets.length; idx < len; idx++) {
    //   const widget = widgets[idx];
    //   const state = widget.getOnValue() === value ? value : PDFName.of('Off');
    //   widget.setAppearanceState(state);
    // }
    };
    PDFAcroText.prototype.removeValue = function() {
        this.dict.delete((0, $btXS2.default).of('V'));
    };
    PDFAcroText.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039) || v instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) return v;
        return undefined;
    };
    PDFAcroText.fromDict = function(dict, ref) {
        return new PDFAcroText(dict, ref);
    };
    PDFAcroText.create = function(context) {
        var dict = context.obj({
            FT: 'Tx',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroText(dict, ref);
    };
    return PDFAcroText;
}((0, $c767daefd50ee8ad$export$2e2bcd8739ae039));
var $d76660bc35a07b3f$export$2e2bcd8739ae039 = $d76660bc35a07b3f$var$PDFAcroText;



var $70JnX = parcelRequire("70JnX");


var $3cdc71d89ed382a8$var$PDFAcroPushButton = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroPushButton, _super);
    function PDFAcroPushButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroPushButton.fromDict = function(dict, ref) {
        return new PDFAcroPushButton(dict, ref);
    };
    PDFAcroPushButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).PushButton,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroPushButton(dict, ref);
    };
    return PDFAcroPushButton;
}((0, $0350c23ce5d51172$export$2e2bcd8739ae039));
var $3cdc71d89ed382a8$export$2e2bcd8739ae039 = $3cdc71d89ed382a8$var$PDFAcroPushButton;



var $70JnX = parcelRequire("70JnX");

var $btXS2 = parcelRequire("btXS2");



var $1jVcF = parcelRequire("1jVcF");
var $03ea7ddf4d3e4901$var$PDFAcroRadioButton = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroRadioButton, _super);
    function PDFAcroRadioButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroRadioButton.prototype.setValue = function(value) {
        var onValues = this.getOnValues();
        if (!onValues.includes(value) && value !== (0, $btXS2.default).of('Off')) throw new (0, $1jVcF.InvalidAcroFieldValueError)();
        this.dict.set((0, $btXS2.default).of('V'), value);
        var widgets = this.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getOnValue() === value ? value : (0, $btXS2.default).of('Off');
            widget.setAppearanceState(state);
        }
    };
    PDFAcroRadioButton.prototype.getValue = function() {
        var v = this.V();
        if (v instanceof (0, $btXS2.default)) return v;
        return (0, $btXS2.default).of('Off');
    };
    PDFAcroRadioButton.prototype.getOnValues = function() {
        var widgets = this.getWidgets();
        var onValues = [];
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var onValue = widgets[idx].getOnValue();
            if (onValue) onValues.push(onValue);
        }
        return onValues;
    };
    PDFAcroRadioButton.fromDict = function(dict, ref) {
        return new PDFAcroRadioButton(dict, ref);
    };
    PDFAcroRadioButton.create = function(context) {
        var dict = context.obj({
            FT: 'Btn',
            Ff: (0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).Radio,
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroRadioButton(dict, ref);
    };
    return PDFAcroRadioButton;
}((0, $0350c23ce5d51172$export$2e2bcd8739ae039));
var $03ea7ddf4d3e4901$export$2e2bcd8739ae039 = $03ea7ddf4d3e4901$var$PDFAcroRadioButton;





var $70JnX = parcelRequire("70JnX");

var $8b549563259095fa$var$PDFAcroListBox = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFAcroListBox, _super);
    function PDFAcroListBox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFAcroListBox.fromDict = function(dict, ref) {
        return new PDFAcroListBox(dict, ref);
    };
    PDFAcroListBox.create = function(context) {
        var dict = context.obj({
            FT: 'Ch',
            Kids: []
        });
        var ref = context.register(dict);
        return new PDFAcroListBox(dict, ref);
    };
    return PDFAcroListBox;
}((0, $5417d956ec76da1d$export$2e2bcd8739ae039));
var $8b549563259095fa$export$2e2bcd8739ae039 = $8b549563259095fa$var$PDFAcroListBox;



var $ffdc75f5fada1491$export$34b4fb8893136c4c = function(kidDicts) {
    if (!kidDicts) return [];
    var kids = [];
    for(var idx = 0, len = kidDicts.size(); idx < len; idx++){
        var ref = kidDicts.get(idx);
        var dict = kidDicts.lookup(idx);
        // if (dict instanceof PDFDict) kids.push(PDFAcroField.fromDict(dict));
        if (ref instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039) && dict instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) kids.push([
            $ffdc75f5fada1491$export$fe770f59a8fbe6d(dict, ref),
            ref
        ]);
    }
    return kids;
};
var $ffdc75f5fada1491$export$fe770f59a8fbe6d = function(dict, ref) {
    var isNonTerminal = $ffdc75f5fada1491$var$isNonTerminalAcroField(dict);
    if (isNonTerminal) return (0, $dbfd42e360237923$export$2e2bcd8739ae039).fromDict(dict, ref);
    return $ffdc75f5fada1491$var$createPDFAcroTerminal(dict, ref);
};
// TODO: Maybe just check if the dict is *not* a widget? That might be better.
// According to the PDF spec:
//
//   > A field's children in the hierarchy may also include widget annotations
//   > that define its appearance on the page. A field that has children that
//   > are fields is called a non-terminal field. A field that does not have
//   > children that are fields is called a terminal field.
//
// The spec is not entirely clear about how to determine whether a given
// dictionary represents an acrofield or a widget annotation. So we will assume
// that a dictionary is an acrofield if it is a member of the `/Kids` array
// and it contains a `/T` entry (widgets do not have `/T` entries). This isn't
// a bullet proof solution, because the `/T` entry is technically defined as
// optional for acrofields by the PDF spec. But in practice all acrofields seem
// to have a `/T` entry defined.
var $ffdc75f5fada1491$var$isNonTerminalAcroField = function(dict) {
    var kids = dict.lookup((0, $btXS2.default).of('Kids'));
    if (kids instanceof (0, $cUVc9.default)) for(var idx = 0, len = kids.size(); idx < len; idx++){
        var kid = kids.lookup(idx);
        var kidIsField = kid instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039) && kid.has((0, $btXS2.default).of('T'));
        if (kidIsField) return true;
    }
    return false;
};
var $ffdc75f5fada1491$var$createPDFAcroTerminal = function(dict, ref) {
    var ftNameOrRef = $ffdc75f5fada1491$var$getInheritableAttribute(dict, (0, $btXS2.default).of('FT'));
    var type = dict.context.lookup(ftNameOrRef, (0, $btXS2.default));
    if (type === (0, $btXS2.default).of('Btn')) return $ffdc75f5fada1491$var$createPDFAcroButton(dict, ref);
    if (type === (0, $btXS2.default).of('Ch')) return $ffdc75f5fada1491$var$createPDFAcroChoice(dict, ref);
    if (type === (0, $btXS2.default).of('Tx')) return (0, $d76660bc35a07b3f$export$2e2bcd8739ae039).fromDict(dict, ref);
    if (type === (0, $btXS2.default).of('Sig')) return (0, $8236815884bcced8$export$2e2bcd8739ae039).fromDict(dict, ref);
    // We should never reach this line. But there are a lot of weird PDFs out
    // there. So, just to be safe, we'll try to handle things gracefully instead
    // of throwing an error.
    return (0, $c767daefd50ee8ad$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $ffdc75f5fada1491$var$createPDFAcroButton = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $ffdc75f5fada1491$var$getInheritableAttribute(dict, (0, $btXS2.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $8LDYe.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($ffdc75f5fada1491$var$flagIsSet(flags, (0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).PushButton)) return (0, $3cdc71d89ed382a8$export$2e2bcd8739ae039).fromDict(dict, ref);
    else if ($ffdc75f5fada1491$var$flagIsSet(flags, (0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).Radio)) return (0, $03ea7ddf4d3e4901$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $4e7ed1a5388e159e$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $ffdc75f5fada1491$var$createPDFAcroChoice = function(dict, ref) {
    var _a;
    var ffNumberOrRef = $ffdc75f5fada1491$var$getInheritableAttribute(dict, (0, $btXS2.default).of('Ff'));
    var ffNumber = dict.context.lookupMaybe(ffNumberOrRef, (0, $8LDYe.default));
    var flags = (_a = ffNumber === null || ffNumber === void 0 ? void 0 : ffNumber.asNumber()) !== null && _a !== void 0 ? _a : 0;
    if ($ffdc75f5fada1491$var$flagIsSet(flags, (0, $248d91c4d95d4c44$export$eb88827058402599).Combo)) return (0, $b9e1c95445e29e3a$export$2e2bcd8739ae039).fromDict(dict, ref);
    else return (0, $8b549563259095fa$export$2e2bcd8739ae039).fromDict(dict, ref);
};
var $ffdc75f5fada1491$var$flagIsSet = function(flags, flag) {
    return (flags & flag) !== 0;
};
var $ffdc75f5fada1491$var$getInheritableAttribute = function(startNode, name) {
    var attribute;
    $ffdc75f5fada1491$var$ascend(startNode, function(node) {
        if (!attribute) attribute = node.get(name);
    });
    return attribute;
};
var $ffdc75f5fada1491$var$ascend = function(startNode, visitor) {
    visitor(startNode);
    var Parent = startNode.lookupMaybe((0, $btXS2.default).of('Parent'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    if (Parent) $ffdc75f5fada1491$var$ascend(Parent, visitor);
};


var $e870fb8cfe287dc6$var$PDFAcroForm = /** @class */ function() {
    function PDFAcroForm(dict) {
        this.dict = dict;
    }
    PDFAcroForm.prototype.Fields = function() {
        var fields = this.dict.lookup((0, $btXS2.default).of('Fields'));
        if (fields instanceof (0, $cUVc9.default)) return fields;
        return undefined;
    };
    PDFAcroForm.prototype.getFields = function() {
        var Fields = this.normalizedEntries().Fields;
        var fields = new Array(Fields.size());
        for(var idx = 0, len = Fields.size(); idx < len; idx++){
            var ref = Fields.get(idx);
            var dict = Fields.lookup(idx, (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
            fields[idx] = [
                (0, $ffdc75f5fada1491$export$fe770f59a8fbe6d)(dict, ref),
                ref
            ];
        }
        return fields;
    };
    PDFAcroForm.prototype.getAllFields = function() {
        var allFields = [];
        var pushFields = function(fields) {
            if (!fields) return;
            for(var idx = 0, len = fields.length; idx < len; idx++){
                var field = fields[idx];
                allFields.push(field);
                var fieldModel = field[0];
                if (fieldModel instanceof (0, $dbfd42e360237923$export$2e2bcd8739ae039)) pushFields((0, $ffdc75f5fada1491$export$34b4fb8893136c4c)(fieldModel.Kids()));
            }
        };
        pushFields(this.getFields());
        return allFields;
    };
    PDFAcroForm.prototype.addField = function(field) {
        var Fields = this.normalizedEntries().Fields;
        Fields === null || Fields === void 0 || Fields.push(field);
    };
    PDFAcroForm.prototype.removeField = function(field) {
        var parent = field.getParent();
        var fields = parent === undefined ? this.normalizedEntries().Fields : parent.Kids();
        var index = fields === null || fields === void 0 ? void 0 : fields.indexOf(field.ref);
        if (fields === undefined || index === undefined) throw new Error("Tried to remove inexistent field " + field.getFullyQualifiedName());
        fields.remove(index);
        if (parent !== undefined && fields.size() === 0) this.removeField(parent);
    };
    PDFAcroForm.prototype.normalizedEntries = function() {
        var Fields = this.Fields();
        if (!Fields) {
            Fields = this.dict.context.obj([]);
            this.dict.set((0, $btXS2.default).of('Fields'), Fields);
        }
        return {
            Fields: Fields
        };
    };
    PDFAcroForm.fromDict = function(dict) {
        return new PDFAcroForm(dict);
    };
    PDFAcroForm.create = function(context) {
        var dict = context.obj({
            Fields: []
        });
        return new PDFAcroForm(dict);
    };
    return PDFAcroForm;
}();
var $e870fb8cfe287dc6$export$2e2bcd8739ae039 = $e870fb8cfe287dc6$var$PDFAcroForm;














var $2oTAP = parcelRequire("2oTAP");
var $f572ef30ca0090ff$var$PDFCatalog = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFCatalog, _super);
    function PDFCatalog() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFCatalog.prototype.Pages = function() {
        return this.lookup((0, $btXS2.default).of('Pages'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.AcroForm = function() {
        return this.lookupMaybe((0, $btXS2.default).of('AcroForm'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getAcroForm = function() {
        var dict = this.AcroForm();
        if (!dict) return undefined;
        return (0, $e870fb8cfe287dc6$export$2e2bcd8739ae039).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateAcroForm = function() {
        var acroForm = this.getAcroForm();
        if (!acroForm) {
            acroForm = (0, $e870fb8cfe287dc6$export$2e2bcd8739ae039).create(this.context);
            var acroFormRef = this.context.register(acroForm.dict);
            this.set((0, $btXS2.default).of('AcroForm'), acroFormRef);
        }
        return acroForm;
    };
    PDFCatalog.prototype.ViewerPreferences = function() {
        return this.lookupMaybe((0, $btXS2.default).of('ViewerPreferences'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
    };
    PDFCatalog.prototype.getViewerPreferences = function() {
        var dict = this.ViewerPreferences();
        if (!dict) return undefined;
        return (0, $2oTAP.default).fromDict(dict);
    };
    PDFCatalog.prototype.getOrCreateViewerPreferences = function() {
        var viewerPrefs = this.getViewerPreferences();
        if (!viewerPrefs) {
            viewerPrefs = (0, $2oTAP.default).create(this.context);
            var viewerPrefsRef = this.context.register(viewerPrefs.dict);
            this.set((0, $btXS2.default).of('ViewerPreferences'), viewerPrefsRef);
        }
        return viewerPrefs;
    };
    /**
     * Inserts the given ref as a leaf node of this catalog's page tree at the
     * specified index (zero-based). Also increments the `Count` of each node in
     * the page tree hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted.
     */ PDFCatalog.prototype.insertLeafNode = function(leafRef, index) {
        var pagesRef = this.get((0, $btXS2.default).of('Pages'));
        var maybeParentRef = this.Pages().insertLeafNode(leafRef, index);
        return maybeParentRef || pagesRef;
    };
    PDFCatalog.prototype.removeLeafNode = function(index) {
        this.Pages().removeLeafNode(index);
    };
    PDFCatalog.withContextAndPages = function(context, pages) {
        var dict = new Map();
        dict.set((0, $btXS2.default).of('Type'), (0, $btXS2.default).of('Catalog'));
        dict.set((0, $btXS2.default).of('Pages'), pages);
        return new PDFCatalog(dict, context);
    };
    PDFCatalog.fromMapWithContext = function(map, context) {
        return new PDFCatalog(map, context);
    };
    return PDFCatalog;
}((0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
var $f572ef30ca0090ff$export$2e2bcd8739ae039 = $f572ef30ca0090ff$var$PDFCatalog;






var $70JnX = parcelRequire("70JnX");

var $cUVc9 = parcelRequire("cUVc9");


var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");


var $1jVcF = parcelRequire("1jVcF");
var $fa27c364c3830342$var$PDFPageTree = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFPageTree, _super);
    function PDFPageTree() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PDFPageTree.prototype.Parent = function() {
        return this.lookup((0, $btXS2.default).of('Parent'));
    };
    PDFPageTree.prototype.Kids = function() {
        return this.lookup((0, $btXS2.default).of('Kids'), (0, $cUVc9.default));
    };
    PDFPageTree.prototype.Count = function() {
        return this.lookup((0, $btXS2.default).of('Count'), (0, $8LDYe.default));
    };
    PDFPageTree.prototype.pushTreeNode = function(treeRef) {
        var Kids = this.Kids();
        Kids.push(treeRef);
    };
    PDFPageTree.prototype.pushLeafNode = function(leafRef) {
        var Kids = this.Kids();
        this.insertLeafKid(Kids.size(), leafRef);
    };
    /**
     * Inserts the given ref as a leaf node of this page tree at the specified
     * index (zero-based). Also increments the `Count` of each page tree in the
     * hierarchy to accomodate the new page.
     *
     * Returns the ref of the PDFPageTree node into which `leafRef` was inserted,
     * or `undefined` if it was inserted into the root node (the PDFPageTree upon
     * which the method was first called).
     */ PDFPageTree.prototype.insertLeafNode = function(leafRef, targetIndex) {
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex > Count) throw new (0, $1jVcF.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            if (leafsRemainingUntilTarget === 0) {
                // Insert page and return
                this.insertLeafKid(idx, leafRef);
                return undefined;
            }
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) // Dig in
                return kid.insertLeafNode(leafRef, leafsRemainingUntilTarget) || kidRef;
                else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039)) // Move on
            leafsRemainingUntilTarget -= 1;
        }
        if (leafsRemainingUntilTarget === 0) {
            // Insert page at the end and return
            this.insertLeafKid(Kids.size(), leafRef);
            return undefined;
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $1jVcF.CorruptPageTreeError)(targetIndex, 'insertLeafNode');
    };
    /**
     * Removes the leaf node at the specified index (zero-based) from this page
     * tree. Also decrements the `Count` of each page tree in the hierarchy to
     * account for the removed page.
     *
     * If `prune` is true, then intermediate tree nodes will be removed from the
     * tree if they contain 0 children after the leaf node is removed.
     */ PDFPageTree.prototype.removeLeafNode = function(targetIndex, prune) {
        if (prune === void 0) prune = true;
        var Kids = this.Kids();
        var Count = this.Count().asNumber();
        if (targetIndex >= Count) throw new (0, $1jVcF.InvalidTargetIndexError)(targetIndex, Count);
        var leafsRemainingUntilTarget = targetIndex;
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) {
                if (kid.Count().asNumber() > leafsRemainingUntilTarget) {
                    // Dig in
                    kid.removeLeafNode(leafsRemainingUntilTarget, prune);
                    if (prune && kid.Kids().size() === 0) Kids.remove(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= kid.Count().asNumber();
            }
            if (kid instanceof (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039)) {
                if (leafsRemainingUntilTarget === 0) {
                    // Remove page and return
                    this.removeKid(idx);
                    return;
                } else // Move on
                leafsRemainingUntilTarget -= 1;
            }
        }
        // Should never get here if `targetIndex` is valid
        throw new (0, $1jVcF.CorruptPageTreeError)(targetIndex, 'removeLeafNode');
    };
    PDFPageTree.prototype.ascend = function(visitor) {
        visitor(this);
        var Parent = this.Parent();
        if (Parent) Parent.ascend(visitor);
    };
    /** Performs a Post-Order traversal of this page tree */ PDFPageTree.prototype.traverse = function(visitor) {
        var Kids = this.Kids();
        for(var idx = 0, len = Kids.size(); idx < len; idx++){
            var kidRef = Kids.get(idx);
            var kid = this.context.lookup(kidRef);
            if (kid instanceof PDFPageTree) kid.traverse(visitor);
            visitor(kid, kidRef);
        }
    };
    PDFPageTree.prototype.insertLeafKid = function(kidIdx, leafRef) {
        var Kids = this.Kids();
        this.ascend(function(node) {
            var newCount = node.Count().asNumber() + 1;
            node.set((0, $btXS2.default).of('Count'), (0, $8LDYe.default).of(newCount));
        });
        Kids.insert(kidIdx, leafRef);
    };
    PDFPageTree.prototype.removeKid = function(kidIdx) {
        var Kids = this.Kids();
        var kid = Kids.lookup(kidIdx);
        if (kid instanceof (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039)) this.ascend(function(node) {
            var newCount = node.Count().asNumber() - 1;
            node.set((0, $btXS2.default).of('Count'), (0, $8LDYe.default).of(newCount));
        });
        Kids.remove(kidIdx);
    };
    PDFPageTree.withContext = function(context, parent) {
        var dict = new Map();
        dict.set((0, $btXS2.default).of('Type'), (0, $btXS2.default).of('Pages'));
        dict.set((0, $btXS2.default).of('Kids'), context.obj([]));
        dict.set((0, $btXS2.default).of('Count'), context.obj(0));
        if (parent) dict.set((0, $btXS2.default).of('Parent'), parent);
        return new PDFPageTree(dict, context);
    };
    PDFPageTree.fromMapWithContext = function(map, context) {
        return new PDFPageTree(map, context);
    };
    return PDFPageTree;
}((0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
var $fa27c364c3830342$export$2e2bcd8739ae039 = $fa27c364c3830342$var$PDFPageTree;







var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $cUVc9 = parcelRequire("cUVc9");

var $gxKrW = parcelRequire("gxKrW");



var $btXS2 = parcelRequire("btXS2");


var $8LDYe = parcelRequire("8LDYe");




var $1jVcF = parcelRequire("1jVcF");

var $lJYRg = parcelRequire("lJYRg");

var $lJYRg = parcelRequire("lJYRg");
var $0b1938ce1d96f12c$export$9492c31549e88980 = new Uint8Array(256);
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Zero] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).One] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Two] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Three] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Four] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Five] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Six] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Seven] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Eight] = 1;
$0b1938ce1d96f12c$export$9492c31549e88980[(0, $lJYRg.default).Nine] = 1;
var $0b1938ce1d96f12c$export$d438b84505bee68c = new Uint8Array(256);
$0b1938ce1d96f12c$export$d438b84505bee68c[(0, $lJYRg.default).Period] = 1;
$0b1938ce1d96f12c$export$d438b84505bee68c[(0, $lJYRg.default).Plus] = 1;
$0b1938ce1d96f12c$export$d438b84505bee68c[(0, $lJYRg.default).Minus] = 1;
var $0b1938ce1d96f12c$export$4d926b029fa61cfe = new Uint8Array(256);
for(var $0b1938ce1d96f12c$var$idx = 0, $0b1938ce1d96f12c$var$len = 256; $0b1938ce1d96f12c$var$idx < $0b1938ce1d96f12c$var$len; $0b1938ce1d96f12c$var$idx++)$0b1938ce1d96f12c$export$4d926b029fa61cfe[$0b1938ce1d96f12c$var$idx] = $0b1938ce1d96f12c$export$9492c31549e88980[$0b1938ce1d96f12c$var$idx] || $0b1938ce1d96f12c$export$d438b84505bee68c[$0b1938ce1d96f12c$var$idx] ? 1 : 0;



var $7gWQz = parcelRequire("7gWQz");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $14a792751966c9e7$var$Newline = (0, $lJYRg.default).Newline, $14a792751966c9e7$var$CarriageReturn = (0, $lJYRg.default).CarriageReturn;
// TODO: Throw error if eof is reached before finishing object parse...
var $14a792751966c9e7$var$BaseParser = /** @class */ function() {
    function BaseParser(bytes, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        this.bytes = bytes;
        this.capNumbers = capNumbers;
    }
    BaseParser.prototype.parseRawInt = function() {
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $0b1938ce1d96f12c$export$9492c31549e88980)[byte]) break;
            value += (0, $c6a2W.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $1jVcF.NumberParsingError)(this.bytes.position(), value);
        return numberValue;
    };
    // TODO: Maybe handle exponential format?
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    BaseParser.prototype.parseRawNumber = function() {
        var value = '';
        // Parse integer-part, the leading (+ | - | . | 0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $0b1938ce1d96f12c$export$4d926b029fa61cfe)[byte]) break;
            value += (0, $c6a2W.charFromCode)(this.bytes.next());
            if (byte === (0, $lJYRg.default).Period) break;
        }
        // Parse decimal-part, the trailing (0-9)
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (!(0, $0b1938ce1d96f12c$export$9492c31549e88980)[byte]) break;
            value += (0, $c6a2W.charFromCode)(this.bytes.next());
        }
        var numberValue = Number(value);
        if (!value || !isFinite(numberValue)) throw new (0, $1jVcF.NumberParsingError)(this.bytes.position(), value);
        if (numberValue > Number.MAX_SAFE_INTEGER) {
            if (this.capNumbers) {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", using Number.MAX_SAFE_INTEGER instead.";
                console.warn(msg);
                return Number.MAX_SAFE_INTEGER;
            } else {
                var msg = "Parsed number that is too large for some PDF readers: " + value + ", not capping.";
                console.warn(msg);
            }
        }
        return numberValue;
    };
    BaseParser.prototype.skipWhitespace = function() {
        while(!this.bytes.done() && (0, $7gWQz.IsWhitespace)[this.bytes.peek()])this.bytes.next();
    };
    BaseParser.prototype.skipLine = function() {
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $14a792751966c9e7$var$Newline || byte === $14a792751966c9e7$var$CarriageReturn) return;
            this.bytes.next();
        }
    };
    BaseParser.prototype.skipComment = function() {
        if (this.bytes.peek() !== (0, $lJYRg.default).Percent) return false;
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if (byte === $14a792751966c9e7$var$Newline || byte === $14a792751966c9e7$var$CarriageReturn) return true;
            this.bytes.next();
        }
        return true;
    };
    BaseParser.prototype.skipWhitespaceAndComments = function() {
        this.skipWhitespace();
        while(this.skipComment())this.skipWhitespace();
    };
    BaseParser.prototype.matchKeyword = function(keyword) {
        var initialOffset = this.bytes.offset();
        for(var idx = 0, len = keyword.length; idx < len; idx++)if (this.bytes.done() || this.bytes.next() !== keyword[idx]) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
        return true;
    };
    return BaseParser;
}();
var $14a792751966c9e7$export$2e2bcd8739ae039 = $14a792751966c9e7$var$BaseParser;



var $1jVcF = parcelRequire("1jVcF");


var $lJYRg = parcelRequire("lJYRg");
// TODO: See how line/col tracking affects performance
var $915f8f5837676beb$var$ByteStream = /** @class */ function() {
    function ByteStream(bytes) {
        this.idx = 0;
        this.line = 0;
        this.column = 0;
        this.bytes = bytes;
        this.length = this.bytes.length;
    }
    ByteStream.prototype.moveTo = function(offset) {
        this.idx = offset;
    };
    ByteStream.prototype.next = function() {
        var byte = this.bytes[this.idx++];
        if (byte === (0, $lJYRg.default).Newline) {
            this.line += 1;
            this.column = 0;
        } else this.column += 1;
        return byte;
    };
    ByteStream.prototype.assertNext = function(expected) {
        if (this.peek() !== expected) throw new (0, $1jVcF.NextByteAssertionError)(this.position(), expected, this.peek());
        return this.next();
    };
    ByteStream.prototype.peek = function() {
        return this.bytes[this.idx];
    };
    ByteStream.prototype.peekAhead = function(steps) {
        return this.bytes[this.idx + steps];
    };
    ByteStream.prototype.peekAt = function(offset) {
        return this.bytes[offset];
    };
    ByteStream.prototype.done = function() {
        return this.idx >= this.length;
    };
    ByteStream.prototype.offset = function() {
        return this.idx;
    };
    ByteStream.prototype.slice = function(start, end) {
        return this.bytes.slice(start, end);
    };
    ByteStream.prototype.position = function() {
        return {
            line: this.line,
            column: this.column,
            offset: this.idx
        };
    };
    ByteStream.of = function(bytes) {
        return new ByteStream(bytes);
    };
    ByteStream.fromPDFRawStream = function(rawStream) {
        return ByteStream.of((0, $9ebb7188d9360698$export$b8317e68ca978594)(rawStream).decode());
    };
    return ByteStream;
}();
var $915f8f5837676beb$export$2e2bcd8739ae039 = $915f8f5837676beb$var$ByteStream;






var $lJYRg = parcelRequire("lJYRg");

var $aXwzD = parcelRequire("aXwzD");

var $70JnX = parcelRequire("70JnX");

var $lJYRg = parcelRequire("lJYRg");
var $349df892377ee393$var$Space = (0, $lJYRg.default).Space, $349df892377ee393$var$CarriageReturn = (0, $lJYRg.default).CarriageReturn, $349df892377ee393$var$Newline = (0, $lJYRg.default).Newline;
var $349df892377ee393$var$stream = [
    (0, $lJYRg.default).s,
    (0, $lJYRg.default).t,
    (0, $lJYRg.default).r,
    (0, $lJYRg.default).e,
    (0, $lJYRg.default).a,
    (0, $lJYRg.default).m
];
var $349df892377ee393$var$endstream = [
    (0, $lJYRg.default).e,
    (0, $lJYRg.default).n,
    (0, $lJYRg.default).d,
    (0, $lJYRg.default).s,
    (0, $lJYRg.default).t,
    (0, $lJYRg.default).r,
    (0, $lJYRg.default).e,
    (0, $lJYRg.default).a,
    (0, $lJYRg.default).m
];
var $349df892377ee393$export$93ad50ccfacdd77 = {
    header: [
        (0, $lJYRg.default).Percent,
        (0, $lJYRg.default).P,
        (0, $lJYRg.default).D,
        (0, $lJYRg.default).F,
        (0, $lJYRg.default).Dash
    ],
    eof: [
        (0, $lJYRg.default).Percent,
        (0, $lJYRg.default).Percent,
        (0, $lJYRg.default).E,
        (0, $lJYRg.default).O,
        (0, $lJYRg.default).F
    ],
    obj: [
        (0, $lJYRg.default).o,
        (0, $lJYRg.default).b,
        (0, $lJYRg.default).j
    ],
    endobj: [
        (0, $lJYRg.default).e,
        (0, $lJYRg.default).n,
        (0, $lJYRg.default).d,
        (0, $lJYRg.default).o,
        (0, $lJYRg.default).b,
        (0, $lJYRg.default).j
    ],
    xref: [
        (0, $lJYRg.default).x,
        (0, $lJYRg.default).r,
        (0, $lJYRg.default).e,
        (0, $lJYRg.default).f
    ],
    trailer: [
        (0, $lJYRg.default).t,
        (0, $lJYRg.default).r,
        (0, $lJYRg.default).a,
        (0, $lJYRg.default).i,
        (0, $lJYRg.default).l,
        (0, $lJYRg.default).e,
        (0, $lJYRg.default).r
    ],
    startxref: [
        (0, $lJYRg.default).s,
        (0, $lJYRg.default).t,
        (0, $lJYRg.default).a,
        (0, $lJYRg.default).r,
        (0, $lJYRg.default).t,
        (0, $lJYRg.default).x,
        (0, $lJYRg.default).r,
        (0, $lJYRg.default).e,
        (0, $lJYRg.default).f
    ],
    true: [
        (0, $lJYRg.default).t,
        (0, $lJYRg.default).r,
        (0, $lJYRg.default).u,
        (0, $lJYRg.default).e
    ],
    false: [
        (0, $lJYRg.default).f,
        (0, $lJYRg.default).a,
        (0, $lJYRg.default).l,
        (0, $lJYRg.default).s,
        (0, $lJYRg.default).e
    ],
    null: [
        (0, $lJYRg.default).n,
        (0, $lJYRg.default).u,
        (0, $lJYRg.default).l,
        (0, $lJYRg.default).l
    ],
    stream: $349df892377ee393$var$stream,
    streamEOF1: (0, $70JnX.__spreadArrays)($349df892377ee393$var$stream, [
        $349df892377ee393$var$Space,
        $349df892377ee393$var$CarriageReturn,
        $349df892377ee393$var$Newline
    ]),
    streamEOF2: (0, $70JnX.__spreadArrays)($349df892377ee393$var$stream, [
        $349df892377ee393$var$CarriageReturn,
        $349df892377ee393$var$Newline
    ]),
    streamEOF3: (0, $70JnX.__spreadArrays)($349df892377ee393$var$stream, [
        $349df892377ee393$var$CarriageReturn
    ]),
    streamEOF4: (0, $70JnX.__spreadArrays)($349df892377ee393$var$stream, [
        $349df892377ee393$var$Newline
    ]),
    endstream: $349df892377ee393$var$endstream,
    EOF1endstream: (0, $70JnX.__spreadArrays)([
        $349df892377ee393$var$CarriageReturn,
        $349df892377ee393$var$Newline
    ], $349df892377ee393$var$endstream),
    EOF2endstream: (0, $70JnX.__spreadArrays)([
        $349df892377ee393$var$CarriageReturn
    ], $349df892377ee393$var$endstream),
    EOF3endstream: (0, $70JnX.__spreadArrays)([
        $349df892377ee393$var$Newline
    ], $349df892377ee393$var$endstream)
};




var $7gWQz = parcelRequire("7gWQz");
parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
// TODO: Throw error if eof is reached before finishing object parse...
var $f3e02057562c7302$var$PDFObjectParser = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFObjectParser, _super);
    function PDFObjectParser(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, byteStream, capNumbers) || this;
        _this.context = context;
        return _this;
    }
    // TODO: Is it possible to reduce duplicate parsing for ref lookaheads?
    PDFObjectParser.prototype.parseObject = function() {
        this.skipWhitespaceAndComments();
        if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).true)) return (0, $gxKrW.default).True;
        if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).false)) return (0, $gxKrW.default).False;
        if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).null)) return 0, $92faf6a1e2d86453$export$2e2bcd8739ae039;
        var byte = this.bytes.peek();
        if (byte === (0, $lJYRg.default).LessThan && this.bytes.peekAhead(1) === (0, $lJYRg.default).LessThan) return this.parseDictOrStream();
        if (byte === (0, $lJYRg.default).LessThan) return this.parseHexString();
        if (byte === (0, $lJYRg.default).LeftParen) return this.parseString();
        if (byte === (0, $lJYRg.default).ForwardSlash) return this.parseName();
        if (byte === (0, $lJYRg.default).LeftSquareBracket) return this.parseArray();
        if ((0, $0b1938ce1d96f12c$export$4d926b029fa61cfe)[byte]) return this.parseNumberOrRef();
        throw new (0, $1jVcF.PDFObjectParsingError)(this.bytes.position(), byte);
    };
    PDFObjectParser.prototype.parseNumberOrRef = function() {
        var firstNum = this.parseRawNumber();
        this.skipWhitespaceAndComments();
        var lookaheadStart = this.bytes.offset();
        if ((0, $0b1938ce1d96f12c$export$9492c31549e88980)[this.bytes.peek()]) {
            var secondNum = this.parseRawNumber();
            this.skipWhitespaceAndComments();
            if (this.bytes.peek() === (0, $lJYRg.default).R) {
                this.bytes.assertNext((0, $lJYRg.default).R);
                return (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(firstNum, secondNum);
            }
        }
        this.bytes.moveTo(lookaheadStart);
        return (0, $8LDYe.default).of(firstNum);
    };
    // TODO: Maybe update PDFHexString.of() logic to remove whitespace and validate input?
    PDFObjectParser.prototype.parseHexString = function() {
        var value = '';
        this.bytes.assertNext((0, $lJYRg.default).LessThan);
        while(!this.bytes.done() && this.bytes.peek() !== (0, $lJYRg.default).GreaterThan)value += (0, $c6a2W.charFromCode)(this.bytes.next());
        this.bytes.assertNext((0, $lJYRg.default).GreaterThan);
        return (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).of(value);
    };
    PDFObjectParser.prototype.parseString = function() {
        var nestingLvl = 0;
        var isEscaped = false;
        var value = '';
        while(!this.bytes.done()){
            var byte = this.bytes.next();
            value += (0, $c6a2W.charFromCode)(byte);
            // Check for unescaped parenthesis
            if (!isEscaped) {
                if (byte === (0, $lJYRg.default).LeftParen) nestingLvl += 1;
                if (byte === (0, $lJYRg.default).RightParen) nestingLvl -= 1;
            }
            // Track whether current character is being escaped or not
            if (byte === (0, $lJYRg.default).BackSlash) isEscaped = !isEscaped;
            else if (isEscaped) isEscaped = false;
            // Once (if) the unescaped parenthesis balance out, return their contents
            if (nestingLvl === 0) // Remove the outer parens so they aren't part of the contents
            return (0, $47c89398cba1043c$export$2e2bcd8739ae039).of(value.substring(1, value.length - 1));
        }
        throw new (0, $1jVcF.UnbalancedParenthesisError)(this.bytes.position());
    };
    // TODO: Compare performance of string concatenation to charFromCode(...bytes)
    // TODO: Maybe preallocate small Uint8Array if can use charFromCode?
    PDFObjectParser.prototype.parseName = function() {
        this.bytes.assertNext((0, $lJYRg.default).ForwardSlash);
        var name = '';
        while(!this.bytes.done()){
            var byte = this.bytes.peek();
            if ((0, $7gWQz.IsWhitespace)[byte] || (0, $aXwzD.IsDelimiter)[byte]) break;
            name += (0, $c6a2W.charFromCode)(byte);
            this.bytes.next();
        }
        return (0, $btXS2.default).of(name);
    };
    PDFObjectParser.prototype.parseArray = function() {
        this.bytes.assertNext((0, $lJYRg.default).LeftSquareBracket);
        this.skipWhitespaceAndComments();
        var pdfArray = (0, $cUVc9.default).withContext(this.context);
        while(this.bytes.peek() !== (0, $lJYRg.default).RightSquareBracket){
            var element = this.parseObject();
            pdfArray.push(element);
            this.skipWhitespaceAndComments();
        }
        this.bytes.assertNext((0, $lJYRg.default).RightSquareBracket);
        return pdfArray;
    };
    PDFObjectParser.prototype.parseDict = function() {
        this.bytes.assertNext((0, $lJYRg.default).LessThan);
        this.bytes.assertNext((0, $lJYRg.default).LessThan);
        this.skipWhitespaceAndComments();
        var dict = new Map();
        while(!this.bytes.done() && this.bytes.peek() !== (0, $lJYRg.default).GreaterThan && this.bytes.peekAhead(1) !== (0, $lJYRg.default).GreaterThan){
            var key = this.parseName();
            var value = this.parseObject();
            dict.set(key, value);
            this.skipWhitespaceAndComments();
        }
        this.skipWhitespaceAndComments();
        this.bytes.assertNext((0, $lJYRg.default).GreaterThan);
        this.bytes.assertNext((0, $lJYRg.default).GreaterThan);
        var Type = dict.get((0, $btXS2.default).of('Type'));
        if (Type === (0, $btXS2.default).of('Catalog')) return (0, $f572ef30ca0090ff$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $btXS2.default).of('Pages')) return (0, $fa27c364c3830342$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else if (Type === (0, $btXS2.default).of('Page')) return (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
        else return (0, $a128f87a2ae876f3$export$2e2bcd8739ae039).fromMapWithContext(dict, this.context);
    };
    PDFObjectParser.prototype.parseDictOrStream = function() {
        var startPos = this.bytes.position();
        var dict = this.parseDict();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).streamEOF1) && !this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).streamEOF2) && !this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).streamEOF3) && !this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).streamEOF4) && !this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).stream)) return dict;
        var start = this.bytes.offset();
        var end;
        var Length = dict.get((0, $btXS2.default).of('Length'));
        if (Length instanceof (0, $8LDYe.default)) {
            end = start + Length.asNumber();
            this.bytes.moveTo(end);
            this.skipWhitespaceAndComments();
            if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).endstream)) {
                this.bytes.moveTo(start);
                end = this.findEndOfStreamFallback(startPos);
            }
        } else end = this.findEndOfStreamFallback(startPos);
        var contents = this.bytes.slice(start, end);
        return (0, $d814c40cb5e196cb$export$2e2bcd8739ae039).of(dict, contents);
    };
    PDFObjectParser.prototype.findEndOfStreamFallback = function(startPos) {
        // Move to end of stream, while handling nested streams
        var nestingLvl = 1;
        var end = this.bytes.offset();
        while(!this.bytes.done()){
            end = this.bytes.offset();
            if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).stream)) nestingLvl += 1;
            else if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).EOF1endstream) || this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).EOF2endstream) || this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).EOF3endstream) || this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).endstream)) nestingLvl -= 1;
            else this.bytes.next();
            if (nestingLvl === 0) break;
        }
        if (nestingLvl !== 0) throw new (0, $1jVcF.PDFStreamParsingError)(startPos);
        return end;
    };
    PDFObjectParser.forBytes = function(bytes, context, capNumbers) {
        return new PDFObjectParser((0, $915f8f5837676beb$export$2e2bcd8739ae039).of(bytes), context, capNumbers);
    };
    PDFObjectParser.forByteStream = function(byteStream, context, capNumbers) {
        if (capNumbers === void 0) capNumbers = false;
        return new PDFObjectParser(byteStream, context, capNumbers);
    };
    return PDFObjectParser;
}((0, $14a792751966c9e7$export$2e2bcd8739ae039));
var $f3e02057562c7302$export$2e2bcd8739ae039 = $f3e02057562c7302$var$PDFObjectParser;



var $70JnX = parcelRequire("70JnX");

var $1jVcF = parcelRequire("1jVcF");

var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");



parcelRequire("JEL7f");
var $fAfk5 = parcelRequire("fAfk5");
var $99c9dcb828a040cb$var$PDFObjectStreamParser = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFObjectStreamParser, _super);
    function PDFObjectStreamParser(rawStream, shouldWaitForTick) {
        var _this = _super.call(this, (0, $915f8f5837676beb$export$2e2bcd8739ae039).fromPDFRawStream(rawStream), rawStream.dict.context) || this;
        var dict = rawStream.dict;
        _this.alreadyParsed = false;
        _this.shouldWaitForTick = shouldWaitForTick || function() {
            return false;
        };
        _this.firstOffset = dict.lookup((0, $btXS2.default).of('First'), (0, $8LDYe.default)).asNumber();
        _this.objectCount = dict.lookup((0, $btXS2.default).of('N'), (0, $8LDYe.default)).asNumber();
        return _this;
    }
    PDFObjectStreamParser.prototype.parseIntoContext = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var offsetsAndObjectNumbers, idx, len, _a, objectNumber, offset, object, ref;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $1jVcF.ReparseError)('PDFObjectStreamParser', 'parseIntoContext');
                        this.alreadyParsed = true;
                        offsetsAndObjectNumbers = this.parseOffsetsAndObjectNumbers();
                        idx = 0, len = offsetsAndObjectNumbers.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        _a = offsetsAndObjectNumbers[idx], objectNumber = _a.objectNumber, offset = _a.offset;
                        this.bytes.moveTo(this.firstOffset + offset);
                        object = this.parseObject();
                        ref = (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber, 0);
                        this.context.assign(ref, object);
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 2:
                        _b.sent();
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFObjectStreamParser.prototype.parseOffsetsAndObjectNumbers = function() {
        var offsetsAndObjectNumbers = [];
        for(var idx = 0, len = this.objectCount; idx < len; idx++){
            this.skipWhitespaceAndComments();
            var objectNumber = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var offset = this.parseRawInt();
            offsetsAndObjectNumbers.push({
                objectNumber: objectNumber,
                offset: offset
            });
        }
        return offsetsAndObjectNumbers;
    };
    PDFObjectStreamParser.forStream = function(rawStream, shouldWaitForTick) {
        return new PDFObjectStreamParser(rawStream, shouldWaitForTick);
    };
    return PDFObjectStreamParser;
}((0, $f3e02057562c7302$export$2e2bcd8739ae039));
var $99c9dcb828a040cb$export$2e2bcd8739ae039 = $99c9dcb828a040cb$var$PDFObjectStreamParser;



var $70JnX = parcelRequire("70JnX");




var $1jVcF = parcelRequire("1jVcF");



var $btXS2 = parcelRequire("btXS2");






var $1jVcF = parcelRequire("1jVcF");

var $cUVc9 = parcelRequire("cUVc9");

var $btXS2 = parcelRequire("btXS2");

var $8LDYe = parcelRequire("8LDYe");


var $5db613ebfecf7ee3$var$PDFXRefStreamParser = /** @class */ function() {
    function PDFXRefStreamParser(rawStream) {
        this.alreadyParsed = false;
        this.dict = rawStream.dict;
        this.bytes = (0, $915f8f5837676beb$export$2e2bcd8739ae039).fromPDFRawStream(rawStream);
        this.context = this.dict.context;
        var Size = this.dict.lookup((0, $btXS2.default).of('Size'), (0, $8LDYe.default));
        var Index = this.dict.lookup((0, $btXS2.default).of('Index'));
        if (Index instanceof (0, $cUVc9.default)) {
            this.subsections = [];
            for(var idx = 0, len = Index.size(); idx < len; idx += 2){
                var firstObjectNumber = Index.lookup(idx + 0, (0, $8LDYe.default)).asNumber();
                var length_1 = Index.lookup(idx + 1, (0, $8LDYe.default)).asNumber();
                this.subsections.push({
                    firstObjectNumber: firstObjectNumber,
                    length: length_1
                });
            }
        } else this.subsections = [
            {
                firstObjectNumber: 0,
                length: Size.asNumber()
            }
        ];
        var W = this.dict.lookup((0, $btXS2.default).of('W'), (0, $cUVc9.default));
        this.byteWidths = [
            -1,
            -1,
            -1
        ];
        for(var idx = 0, len = W.size(); idx < len; idx++)this.byteWidths[idx] = W.lookup(idx, (0, $8LDYe.default)).asNumber();
    }
    PDFXRefStreamParser.prototype.parseIntoContext = function() {
        if (this.alreadyParsed) throw new (0, $1jVcF.ReparseError)('PDFXRefStreamParser', 'parseIntoContext');
        this.alreadyParsed = true;
        this.context.trailerInfo = {
            Root: this.dict.get((0, $btXS2.default).of('Root')),
            Encrypt: this.dict.get((0, $btXS2.default).of('Encrypt')),
            Info: this.dict.get((0, $btXS2.default).of('Info')),
            ID: this.dict.get((0, $btXS2.default).of('ID'))
        };
        var entries = this.parseEntries();
        // for (let idx = 0, len = entries.length; idx < len; idx++) {
        // const entry = entries[idx];
        // if (entry.deleted) this.context.delete(entry.ref);
        // }
        return entries;
    };
    PDFXRefStreamParser.prototype.parseEntries = function() {
        var entries = [];
        var _a = this.byteWidths, typeFieldWidth = _a[0], offsetFieldWidth = _a[1], genFieldWidth = _a[2];
        for(var subsectionIdx = 0, subsectionLen = this.subsections.length; subsectionIdx < subsectionLen; subsectionIdx++){
            var _b = this.subsections[subsectionIdx], firstObjectNumber = _b.firstObjectNumber, length_2 = _b.length;
            for(var objIdx = 0; objIdx < length_2; objIdx++){
                var type = 0;
                for(var idx = 0, len = typeFieldWidth; idx < len; idx++)type = type << 8 | this.bytes.next();
                var offset = 0;
                for(var idx = 0, len = offsetFieldWidth; idx < len; idx++)offset = offset << 8 | this.bytes.next();
                var generationNumber = 0;
                for(var idx = 0, len = genFieldWidth; idx < len; idx++)generationNumber = generationNumber << 8 | this.bytes.next();
                // When the `type` field is absent, it defaults to 1
                if (typeFieldWidth === 0) type = 1;
                var objectNumber = firstObjectNumber + objIdx;
                var entry = {
                    ref: (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber, generationNumber),
                    offset: offset,
                    deleted: type === 0,
                    inObjectStream: type === 2
                };
                entries.push(entry);
            }
        }
        return entries;
    };
    PDFXRefStreamParser.forStream = function(rawStream) {
        return new PDFXRefStreamParser(rawStream);
    };
    return PDFXRefStreamParser;
}();
var $5db613ebfecf7ee3$export$2e2bcd8739ae039 = $5db613ebfecf7ee3$var$PDFXRefStreamParser;




var $lJYRg = parcelRequire("lJYRg");


parcelRequire("JEL7f");
var $fAfk5 = parcelRequire("fAfk5");
var $e3e3cae9bc5989a7$var$PDFParser = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFParser, _super);
    function PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        if (objectsPerTick === void 0) objectsPerTick = Infinity;
        if (throwOnInvalidObject === void 0) throwOnInvalidObject = false;
        if (capNumbers === void 0) capNumbers = false;
        var _this = _super.call(this, (0, $915f8f5837676beb$export$2e2bcd8739ae039).of(pdfBytes), (0, $ec19a68ebeedd71c$export$2e2bcd8739ae039).create(), capNumbers) || this;
        _this.alreadyParsed = false;
        _this.parsedObjects = 0;
        _this.shouldWaitForTick = function() {
            _this.parsedObjects += 1;
            return _this.parsedObjects % _this.objectsPerTick === 0;
        };
        _this.objectsPerTick = objectsPerTick;
        _this.throwOnInvalidObject = throwOnInvalidObject;
        return _this;
    }
    PDFParser.prototype.parseDocument = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var prevOffset, offset;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (this.alreadyParsed) throw new (0, $1jVcF.ReparseError)('PDFParser', 'parseDocument');
                        this.alreadyParsed = true;
                        this.context.header = this.parseHeader();
                        _a.label = 1;
                    case 1:
                        if (!!this.bytes.done()) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            this.parseDocumentSection()
                        ];
                    case 2:
                        _a.sent();
                        offset = this.bytes.offset();
                        if (offset === prevOffset) throw new (0, $1jVcF.StalledParserError)(this.bytes.position());
                        prevOffset = offset;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 3:
                        this.maybeRecoverRoot();
                        if (this.context.lookup((0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(0))) {
                            console.warn('Removing parsed object: 0 0 R');
                            this.context.delete((0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(0));
                        }
                        return [
                            2 /*return*/ ,
                            this.context
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeRecoverRoot = function() {
        var isValidCatalog = function(obj) {
            return obj instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039) && obj.lookup((0, $btXS2.default).of('Type')) === (0, $btXS2.default).of('Catalog');
        };
        var catalog = this.context.lookup(this.context.trailerInfo.Root);
        if (!isValidCatalog(catalog)) {
            var indirectObjects = this.context.enumerateIndirectObjects();
            for(var idx = 0, len = indirectObjects.length; idx < len; idx++){
                var _a = indirectObjects[idx], ref = _a[0], object = _a[1];
                if (isValidCatalog(object)) this.context.trailerInfo.Root = ref;
            }
        }
    };
    PDFParser.prototype.parseHeader = function() {
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).header)) {
                var major = this.parseRawInt();
                this.bytes.assertNext((0, $lJYRg.default).Period);
                var minor = this.parseRawInt();
                var header = (0, $f5613438da36c90d$export$2e2bcd8739ae039).forVersion(major, minor);
                this.skipBinaryHeaderComment();
                return header;
            }
            this.bytes.next();
        }
        throw new (0, $1jVcF.MissingPDFHeaderError)(this.bytes.position());
    };
    PDFParser.prototype.parseIndirectObjectHeader = function() {
        this.skipWhitespaceAndComments();
        var objectNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        var generationNumber = this.parseRawInt();
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).obj)) throw new (0, $1jVcF.MissingKeywordError)(this.bytes.position(), (0, $349df892377ee393$export$93ad50ccfacdd77).obj);
        return (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber, generationNumber);
    };
    PDFParser.prototype.matchIndirectObjectHeader = function() {
        var initialOffset = this.bytes.offset();
        try {
            this.parseIndirectObjectHeader();
            return true;
        } catch (e) {
            this.bytes.moveTo(initialOffset);
            return false;
        }
    };
    PDFParser.prototype.parseIndirectObject = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var ref, object;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        ref = this.parseIndirectObjectHeader();
                        this.skipWhitespaceAndComments();
                        object = this.parseObject();
                        this.skipWhitespaceAndComments();
                        // if (!this.matchKeyword(Keywords.endobj)) {
                        // throw new MissingKeywordError(this.bytes.position(), Keywords.endobj);
                        // }
                        // TODO: Log a warning if this fails...
                        this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).endobj);
                        if (!(object instanceof (0, $d814c40cb5e196cb$export$2e2bcd8739ae039) && object.dict.lookup((0, $btXS2.default).of('Type')) === (0, $btXS2.default).of('ObjStm'))) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $99c9dcb828a040cb$export$2e2bcd8739ae039).forStream(object, this.shouldWaitForTick).parseIntoContext()
                        ];
                    case 1:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 2:
                        if (object instanceof (0, $d814c40cb5e196cb$export$2e2bcd8739ae039) && object.dict.lookup((0, $btXS2.default).of('Type')) === (0, $btXS2.default).of('XRef')) (0, $5db613ebfecf7ee3$export$2e2bcd8739ae039).forStream(object).parseIntoContext();
                        else this.context.assign(ref, object);
                        _a.label = 3;
                    case 3:
                        return [
                            2 /*return*/ ,
                            ref
                        ];
                }
            });
        });
    };
    // TODO: Improve and clean this up
    PDFParser.prototype.tryToParseInvalidIndirectObject = function() {
        var startPos = this.bytes.position();
        var msg = "Trying to parse invalid object: " + JSON.stringify(startPos) + ")";
        if (this.throwOnInvalidObject) throw new Error(msg);
        console.warn(msg);
        var ref = this.parseIndirectObjectHeader();
        console.warn("Invalid object ref: " + ref);
        this.skipWhitespaceAndComments();
        var start = this.bytes.offset();
        var failed = true;
        while(!this.bytes.done()){
            if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).endobj)) failed = false;
            if (!failed) break;
            this.bytes.next();
        }
        if (failed) throw new (0, $1jVcF.PDFInvalidObjectParsingError)(startPos);
        var end = this.bytes.offset() - (0, $349df892377ee393$export$93ad50ccfacdd77).endobj.length;
        var object = (0, $f45442108e8c0086$export$2e2bcd8739ae039).of(this.bytes.slice(start, end));
        this.context.assign(ref, object);
        return ref;
    };
    PDFParser.prototype.parseIndirectObjects = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var initialOffset, e_1;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        this.skipWhitespaceAndComments();
                        _a.label = 1;
                    case 1:
                        if (!(!this.bytes.done() && (0, $0b1938ce1d96f12c$export$9492c31549e88980)[this.bytes.peek()])) return [
                            3 /*break*/ ,
                            8
                        ];
                        initialOffset = this.bytes.offset();
                        _a.label = 2;
                    case 2:
                        _a.trys.push([
                            2,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObject()
                        ];
                    case 3:
                        _a.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 4:
                        e_1 = _a.sent();
                        // TODO: Add tracing/logging mechanism to track when this happens!
                        this.bytes.moveTo(initialOffset);
                        this.tryToParseInvalidIndirectObject();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 5:
                        this.skipWhitespaceAndComments();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        if (!this.shouldWaitForTick()) return [
                            3 /*break*/ ,
                            7
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $fAfk5.waitForTick)()
                        ];
                    case 6:
                        _a.sent();
                        _a.label = 7;
                    case 7:
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 8:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFParser.prototype.maybeParseCrossRefSection = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).xref)) return;
        this.skipWhitespaceAndComments();
        var objectNumber = -1;
        var xref = (0, $b2a262b904f5b87f$export$2e2bcd8739ae039).createEmpty();
        while(!this.bytes.done() && (0, $0b1938ce1d96f12c$export$9492c31549e88980)[this.bytes.peek()]){
            var firstInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var secondInt = this.parseRawInt();
            this.skipWhitespaceAndComments();
            var byte = this.bytes.peek();
            if (byte === (0, $lJYRg.default).n || byte === (0, $lJYRg.default).f) {
                var ref = (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(objectNumber, secondInt);
                if (this.bytes.next() === (0, $lJYRg.default).n) xref.addEntry(ref, firstInt);
                else // this.context.delete(ref);
                xref.addDeletedEntry(ref, firstInt);
                objectNumber += 1;
            } else objectNumber = firstInt;
            this.skipWhitespaceAndComments();
        }
        return xref;
    };
    PDFParser.prototype.maybeParseTrailerDict = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).trailer)) return;
        this.skipWhitespaceAndComments();
        var dict = this.parseDict();
        var context = this.context;
        context.trailerInfo = {
            Root: dict.get((0, $btXS2.default).of('Root')) || context.trailerInfo.Root,
            Encrypt: dict.get((0, $btXS2.default).of('Encrypt')) || context.trailerInfo.Encrypt,
            Info: dict.get((0, $btXS2.default).of('Info')) || context.trailerInfo.Info,
            ID: dict.get((0, $btXS2.default).of('ID')) || context.trailerInfo.ID
        };
    };
    PDFParser.prototype.maybeParseTrailer = function() {
        this.skipWhitespaceAndComments();
        if (!this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).startxref)) return;
        this.skipWhitespaceAndComments();
        var offset = this.parseRawInt();
        this.skipWhitespace();
        this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).eof);
        this.skipWhitespaceAndComments();
        return (0, $6d6dcbc50b56a324$export$2e2bcd8739ae039).forLastCrossRefSectionOffset(offset);
    };
    PDFParser.prototype.parseDocumentSection = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.parseIndirectObjects()
                        ];
                    case 1:
                        _a.sent();
                        this.maybeParseCrossRefSection();
                        this.maybeParseTrailerDict();
                        this.maybeParseTrailer();
                        // TODO: Can this be done only when needed, to avoid harming performance?
                        this.skipJibberish();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * This operation is not necessary for valid PDF files. But some invalid PDFs
     * contain jibberish in between indirect objects. This method is designed to
     * skip past that jibberish, should it exist, until it reaches the next
     * indirect object header, an xref table section, or the file trailer.
     */ PDFParser.prototype.skipJibberish = function() {
        this.skipWhitespaceAndComments();
        while(!this.bytes.done()){
            var initialOffset = this.bytes.offset();
            var byte = this.bytes.peek();
            var isAlphaNumeric = byte >= (0, $lJYRg.default).Space && byte <= (0, $lJYRg.default).Tilde;
            if (isAlphaNumeric) {
                if (this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).xref) || this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).trailer) || this.matchKeyword((0, $349df892377ee393$export$93ad50ccfacdd77).startxref) || this.matchIndirectObjectHeader()) {
                    this.bytes.moveTo(initialOffset);
                    break;
                }
            }
            this.bytes.next();
        }
    };
    /**
     * Skips the binary comment following a PDF header. The specification
     * defines this binary comment (section 7.5.2 File Header) as a sequence of 4
     * or more bytes that are 128 or greater, and which are preceded by a "%".
     *
     * This would imply that to strip out this binary comment, we could check for
     * a sequence of bytes starting with "%", and remove all subsequent bytes that
     * are 128 or greater. This works for many documents that properly comply with
     * the spec. But in the wild, there are PDFs that omit the leading "%", and
     * include bytes that are less than 128 (e.g. 0 or 1). So in order to parse
     * these headers correctly, we just throw out all bytes leading up to the
     * first indirect object header.
     */ PDFParser.prototype.skipBinaryHeaderComment = function() {
        this.skipWhitespaceAndComments();
        try {
            var initialOffset = this.bytes.offset();
            this.parseIndirectObjectHeader();
            this.bytes.moveTo(initialOffset);
        } catch (e) {
            this.bytes.next();
            this.skipWhitespaceAndComments();
        }
    };
    PDFParser.forBytesWithOptions = function(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers) {
        return new PDFParser(pdfBytes, objectsPerTick, throwOnInvalidObject, capNumbers);
    };
    return PDFParser;
}((0, $f3e02057562c7302$export$2e2bcd8739ae039));
var $e3e3cae9bc5989a7$export$2e2bcd8739ae039 = $e3e3cae9bc5989a7$var$PDFParser;







var $a02e75f562c07fbe$var$flag = function(bitIndex) {
    return 1 << bitIndex;
};
var $a02e75f562c07fbe$export$1fa7b68b35026177;
(function(AnnotationFlags) {
    /**
     * If set, do not display the annotation if it does not belong to one of the
     * standard annotation types and no annotation handler is available. If clear,
     * display such an unknown annotation using an appearance stream specified by
     * its appearance dictionary, if any.
     */ AnnotationFlags[AnnotationFlags["Invisible"] = $a02e75f562c07fbe$var$flag(0)] = "Invisible";
    /**
     * If set, do not display or print the annotation or allow it to interact with
     * the user, regardless of its annotation type or whether an annotation
     * handler is available.
     *
     * In cases where screen space is limited, the ability to hide and show
     * annotations selectively can be used in combination with appearance streams
     * to display auxiliary pop-up information similar in function to online help
     * systems.
     */ AnnotationFlags[AnnotationFlags["Hidden"] = $a02e75f562c07fbe$var$flag(1)] = "Hidden";
    /**
     * If set, print the annotation when the page is printed. If clear, never
     * print the annotation, regardless of whether it is displayed on the screen.
     *
     * This can be useful for annotations representing interactive pushbuttons,
     * which would serve no meaningful purpose on the printed page.
     */ AnnotationFlags[AnnotationFlags["Print"] = $a02e75f562c07fbe$var$flag(2)] = "Print";
    /**
     * If set, do not scale the annotation’s appearance to match the magnification
     * of the page. The location of the annotation on the page (defined by the
     * upper-left corner of its annotation rectangle) shall remain fixed,
     * regardless of the page magnification.
     */ AnnotationFlags[AnnotationFlags["NoZoom"] = $a02e75f562c07fbe$var$flag(3)] = "NoZoom";
    /**
     * If set, do not rotate the annotation’s appearance to match the rotation of
     * the page. The upper-left corner of the annotation rectangle shall remain in
     * a fixed location on the page, regardless of the page rotation.
     */ AnnotationFlags[AnnotationFlags["NoRotate"] = $a02e75f562c07fbe$var$flag(4)] = "NoRotate";
    /**
     * If set, do not display the annotation on the screen or allow it to interact
     * with the user. The annotation may be printed (depending on the setting of
     * the Print flag) but should be considered hidden for purposes of on-screen
     * display and user interaction.
     */ AnnotationFlags[AnnotationFlags["NoView"] = $a02e75f562c07fbe$var$flag(5)] = "NoView";
    /**
     * If set, do not allow the annotation to interact with the user. The
     * annotation may be displayed or printed (depending on the settings of the
     * NoView and Print flags) but should not respond to mouse clicks or change
     * its appearance in response to mouse motions.
     *
     * This flag shall be ignored for widget annotations; its function is
     * subsumed by the ReadOnly flag of the associated form field.
     */ AnnotationFlags[AnnotationFlags["ReadOnly"] = $a02e75f562c07fbe$var$flag(6)] = "ReadOnly";
    /**
     * If set, do not allow the annotation to be deleted or its properties
     * (including position and size) to be modified by the user. However, this
     * flag does not restrict changes to the annotation’s contents, such as the
     * value of a form field.
     */ AnnotationFlags[AnnotationFlags["Locked"] = $a02e75f562c07fbe$var$flag(7)] = "Locked";
    /**
     * If set, invert the interpretation of the NoView flag for certain events.
     *
     * A typical use is to have an annotation that appears only when a mouse
     * cursor is held over it.
     */ AnnotationFlags[AnnotationFlags["ToggleNoView"] = $a02e75f562c07fbe$var$flag(8)] = "ToggleNoView";
    /**
     * If set, do not allow the contents of the annotation to be modified by the
     * user. This flag does not restrict deletion of the annotation or changes to
     * other annotation properties, such as position and size.
     */ AnnotationFlags[AnnotationFlags["LockedContents"] = $a02e75f562c07fbe$var$flag(9)] = "LockedContents";
})($a02e75f562c07fbe$export$1fa7b68b35026177 || ($a02e75f562c07fbe$export$1fa7b68b35026177 = {}));







var $btXS2 = parcelRequire("btXS2");
var $8LDYe = parcelRequire("8LDYe");
var $38443af77d9815b6$export$69d5e1b305482e08 = function(name) {
    return name instanceof (0, $btXS2.default) ? name : (0, $btXS2.default).of(name);
};
var $38443af77d9815b6$export$fb5b5e76a3a5c568 = function(num) {
    return num instanceof (0, $8LDYe.default) ? num : (0, $8LDYe.default).of(num);
};
var $38443af77d9815b6$export$37576b9ba69b50db = function(num) {
    return num instanceof (0, $8LDYe.default) ? num.asNumber() : num;
};


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $dXsOT = parcelRequire("dXsOT");
var $1adec95b95f779ee$export$c3cc0f63dbb3500f;
(function(RotationTypes) {
    RotationTypes["Degrees"] = "degrees";
    RotationTypes["Radians"] = "radians";
})($1adec95b95f779ee$export$c3cc0f63dbb3500f || ($1adec95b95f779ee$export$c3cc0f63dbb3500f = {}));
var $1adec95b95f779ee$export$8449e153fbd325fc = function(radianAngle) {
    (0, $fYigW.assertIs)(radianAngle, 'radianAngle', [
        'number'
    ]);
    return {
        type: $1adec95b95f779ee$export$c3cc0f63dbb3500f.Radians,
        angle: radianAngle
    };
};
var $1adec95b95f779ee$export$41fc368e1a942b97 = function(degreeAngle) {
    (0, $fYigW.assertIs)(degreeAngle, 'degreeAngle', [
        'number'
    ]);
    return {
        type: $1adec95b95f779ee$export$c3cc0f63dbb3500f.Degrees,
        angle: degreeAngle
    };
};
var $1adec95b95f779ee$var$Radians = $1adec95b95f779ee$export$c3cc0f63dbb3500f.Radians, $1adec95b95f779ee$var$Degrees = $1adec95b95f779ee$export$c3cc0f63dbb3500f.Degrees;
var $1adec95b95f779ee$export$c9fcf1a7df975d78 = function(degree) {
    return degree * Math.PI / 180;
};
var $1adec95b95f779ee$export$c41dd2a8460d3196 = function(radian) {
    return radian * 180 / Math.PI;
};
var $1adec95b95f779ee$export$cba01ba138429a1d = function(rotation) {
    return rotation.type === $1adec95b95f779ee$var$Radians ? rotation.angle : rotation.type === $1adec95b95f779ee$var$Degrees ? $1adec95b95f779ee$export$c9fcf1a7df975d78(rotation.angle) : (0, $dXsOT.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $1adec95b95f779ee$export$56cb859c01fa134d = function(rotation) {
    return rotation.type === $1adec95b95f779ee$var$Radians ? $1adec95b95f779ee$export$c41dd2a8460d3196(rotation.angle) : rotation.type === $1adec95b95f779ee$var$Degrees ? rotation.angle : (0, $dXsOT.error)("Invalid rotation: " + JSON.stringify(rotation));
};
var $1adec95b95f779ee$export$ee0ed07fe78ec05 = function(degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var quadrants = degreeAngle / 90 % 4;
    if (quadrants === 0) return 0;
    if (quadrants === 1) return 90;
    if (quadrants === 2) return 180;
    if (quadrants === 3) return 270;
    return 0; // `degreeAngle` is not a multiple of 90
};
var $1adec95b95f779ee$export$312e44550db33c6a = function(dims, degreeAngle) {
    if (degreeAngle === void 0) degreeAngle = 0;
    var rotation = $1adec95b95f779ee$export$ee0ed07fe78ec05(degreeAngle);
    return rotation === 90 || rotation === 270 ? {
        width: dims.height,
        height: dims.width
    } : {
        width: dims.width,
        height: dims.height
    };
};
var $1adec95b95f779ee$export$afddc3b8600307a4 = function(rectangle, borderWidth, degreeAngle) {
    if (borderWidth === void 0) borderWidth = 0;
    if (degreeAngle === void 0) degreeAngle = 0;
    var x = rectangle.x, y = rectangle.y, w = rectangle.width, h = rectangle.height;
    var r = $1adec95b95f779ee$export$ee0ed07fe78ec05(degreeAngle);
    var b = borderWidth / 2;
    // prettier-ignore
    if (r === 0) return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
    else if (r === 90) return {
        x: x - h + b,
        y: y - b,
        width: h,
        height: w
    };
    else if (r === 180) return {
        x: x - w + b,
        y: y - h + b,
        width: w,
        height: h
    };
    else if (r === 270) return {
        x: x - b,
        y: y - w + b,
        width: h,
        height: w
    };
    else return {
        x: x - b,
        y: y - b,
        width: w,
        height: h
    };
};



var $6bb514fadaf8543d$export$e0b576e7a74416cd = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).ClipNonZero);
};
var $6bb514fadaf8543d$export$dd6fb25f201b5a7a = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).ClipEvenOdd);
};
/* ==================== Graphics State Operators ==================== */ var $6bb514fadaf8543d$var$cos = Math.cos, $6bb514fadaf8543d$var$sin = Math.sin, $6bb514fadaf8543d$var$tan = Math.tan;
var $6bb514fadaf8543d$export$ed5b99ee38154497 = function(a, b, c, d, e, f) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).ConcatTransformationMatrix, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(a),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(b),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(c),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(d),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(e),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $6bb514fadaf8543d$export$d73ee8ef04f5226a = function(xPos, yPos) {
    return $6bb514fadaf8543d$export$ed5b99ee38154497(1, 0, 0, 1, xPos, yPos);
};
var $6bb514fadaf8543d$export$dcdf75081b88279d = function(xPos, yPos) {
    return $6bb514fadaf8543d$export$ed5b99ee38154497(xPos, 0, 0, yPos, 0, 0);
};
var $6bb514fadaf8543d$export$a2ba89726971a90f = function(angle) {
    return $6bb514fadaf8543d$export$ed5b99ee38154497($6bb514fadaf8543d$var$cos((0, $38443af77d9815b6$export$37576b9ba69b50db)(angle)), $6bb514fadaf8543d$var$sin((0, $38443af77d9815b6$export$37576b9ba69b50db)(angle)), -$6bb514fadaf8543d$var$sin((0, $38443af77d9815b6$export$37576b9ba69b50db)(angle)), $6bb514fadaf8543d$var$cos((0, $38443af77d9815b6$export$37576b9ba69b50db)(angle)), 0, 0);
};
var $6bb514fadaf8543d$export$91df22fbff99d059 = function(angle) {
    return $6bb514fadaf8543d$export$a2ba89726971a90f((0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(angle)));
};
var $6bb514fadaf8543d$export$985cb1d69d6a3add = function(xSkewAngle, ySkewAngle) {
    return $6bb514fadaf8543d$export$ed5b99ee38154497(1, $6bb514fadaf8543d$var$tan((0, $38443af77d9815b6$export$37576b9ba69b50db)(xSkewAngle)), $6bb514fadaf8543d$var$tan((0, $38443af77d9815b6$export$37576b9ba69b50db)(ySkewAngle)), 1, 0, 0);
};
var $6bb514fadaf8543d$export$8ecb831b3efbb169 = function(xSkewAngle, ySkewAngle) {
    return $6bb514fadaf8543d$export$985cb1d69d6a3add((0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(xSkewAngle)), (0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(ySkewAngle)));
};
var $6bb514fadaf8543d$export$e0e900d241274e06 = function(dashArray, dashPhase) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetLineDashPattern, [
        "[" + dashArray.map((0, $38443af77d9815b6$export$fb5b5e76a3a5c568)).join(' ') + "]",
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(dashPhase)
    ]);
};
var $6bb514fadaf8543d$export$d10d019aadfd45c7 = function() {
    return $6bb514fadaf8543d$export$e0e900d241274e06([], 0);
};
var $6bb514fadaf8543d$export$7a77bc708e50709e;
(function(LineCapStyle) {
    LineCapStyle[LineCapStyle["Butt"] = 0] = "Butt";
    LineCapStyle[LineCapStyle["Round"] = 1] = "Round";
    LineCapStyle[LineCapStyle["Projecting"] = 2] = "Projecting";
})($6bb514fadaf8543d$export$7a77bc708e50709e || ($6bb514fadaf8543d$export$7a77bc708e50709e = {}));
var $6bb514fadaf8543d$export$6c65ed24e870eec = function(style) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetLineCapStyle, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $6bb514fadaf8543d$export$cba5d0f1cde60b86;
(function(LineJoinStyle) {
    LineJoinStyle[LineJoinStyle["Miter"] = 0] = "Miter";
    LineJoinStyle[LineJoinStyle["Round"] = 1] = "Round";
    LineJoinStyle[LineJoinStyle["Bevel"] = 2] = "Bevel";
})($6bb514fadaf8543d$export$cba5d0f1cde60b86 || ($6bb514fadaf8543d$export$cba5d0f1cde60b86 = {}));
var $6bb514fadaf8543d$export$97dfb3b4509cd5bc = function(style) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetLineJoinStyle, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(style)
    ]);
};
var $6bb514fadaf8543d$export$568567f665d3f3bb = function(state) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetGraphicsStateParams, [
        (0, $38443af77d9815b6$export$69d5e1b305482e08)(state)
    ]);
};
var $6bb514fadaf8543d$export$cb182c48e35739ac = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).PushGraphicsState);
};
var $6bb514fadaf8543d$export$10581a6f45bf75eb = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).PopGraphicsState);
};
var $6bb514fadaf8543d$export$558e0f90d8262345 = function(width) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetLineWidth, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(width)
    ]);
};
var $6bb514fadaf8543d$export$45bd49bb15a3c5cb = function(x1, y1, x2, y2, x3, y3) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).AppendBezierCurve, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x1),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y1),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x2),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y2),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x3),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y3)
    ]);
};
var $6bb514fadaf8543d$export$6f4913b22432f892 = function(x1, y1, x2, y2) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).CurveToReplicateInitialPoint, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x1),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y1),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x2),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y2)
    ]);
};
var $6bb514fadaf8543d$export$21f87e210c424cd0 = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).ClosePath);
};
var $6bb514fadaf8543d$export$75f1ccd6dc32e80a = function(xPos, yPos) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).MoveTo, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(xPos),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $6bb514fadaf8543d$export$73abee0cf983cb99 = function(xPos, yPos) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).LineTo, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(xPos),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(yPos)
    ]);
};
var $6bb514fadaf8543d$export$405b065079b7caf2 = function(xPos, yPos, width, height) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).AppendRectangle, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(xPos),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(yPos),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(width),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(height)
    ]);
};
var $6bb514fadaf8543d$export$dd4f28cef696bc7d = function(xPos, yPos, size) {
    return $6bb514fadaf8543d$export$405b065079b7caf2(xPos, yPos, size, size);
};
var $6bb514fadaf8543d$export$d9b706f8d0a70aef = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).StrokePath);
};
var $6bb514fadaf8543d$export$9563e054e6f787fb = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).FillNonZero);
};
var $6bb514fadaf8543d$export$76d37801baac10fb = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).FillNonZeroAndStroke);
};
var $6bb514fadaf8543d$export$d366e9c0a9bd860f = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).EndPath);
};
var $6bb514fadaf8543d$export$829ffc2dbe358942 = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).NextLine);
};
var $6bb514fadaf8543d$export$b84c1833e225e397 = function(x, y) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).MoveText, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(x),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(y)
    ]);
};
var $6bb514fadaf8543d$export$778bfc3c1a2b7ba4 = function(text) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).ShowText, [
        text
    ]);
};
var $6bb514fadaf8543d$export$337b8dbf65fbb95e = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).BeginText);
};
var $6bb514fadaf8543d$export$e3caa83a99d72806 = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).EndText);
};
var $6bb514fadaf8543d$export$df01d619ff6ce7f7 = function(name, size) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetFontAndSize, [
        (0, $38443af77d9815b6$export$69d5e1b305482e08)(name),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(size)
    ]);
};
var $6bb514fadaf8543d$export$710392ce2617f080 = function(spacing) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetCharacterSpacing, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $6bb514fadaf8543d$export$a2801242b2f8967d = function(spacing) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetWordSpacing, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(spacing)
    ]);
};
var $6bb514fadaf8543d$export$20dbb065c447b4da = function(squeeze) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetTextHorizontalScaling, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(squeeze)
    ]);
};
var $6bb514fadaf8543d$export$79399e66b6bb212c = function(lineHeight) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetTextLineHeight, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(lineHeight)
    ]);
};
var $6bb514fadaf8543d$export$ad1653459b07f70c = function(rise) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetTextRise, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(rise)
    ]);
};
var $6bb514fadaf8543d$export$ca45e4ab114d4814;
(function(TextRenderingMode) {
    TextRenderingMode[TextRenderingMode["Fill"] = 0] = "Fill";
    TextRenderingMode[TextRenderingMode["Outline"] = 1] = "Outline";
    TextRenderingMode[TextRenderingMode["FillAndOutline"] = 2] = "FillAndOutline";
    TextRenderingMode[TextRenderingMode["Invisible"] = 3] = "Invisible";
    TextRenderingMode[TextRenderingMode["FillAndClip"] = 4] = "FillAndClip";
    TextRenderingMode[TextRenderingMode["OutlineAndClip"] = 5] = "OutlineAndClip";
    TextRenderingMode[TextRenderingMode["FillAndOutlineAndClip"] = 6] = "FillAndOutlineAndClip";
    TextRenderingMode[TextRenderingMode["Clip"] = 7] = "Clip";
})($6bb514fadaf8543d$export$ca45e4ab114d4814 || ($6bb514fadaf8543d$export$ca45e4ab114d4814 = {}));
var $6bb514fadaf8543d$export$99f0dc2c4cb099ab = function(mode) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetTextRenderingMode, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(mode)
    ]);
};
var $6bb514fadaf8543d$export$d3656d656af31043 = function(a, b, c, d, e, f) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).SetTextMatrix, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(a),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(b),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(c),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(d),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(e),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(f)
    ]);
};
var $6bb514fadaf8543d$export$f567083ac6aa5aa3 = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $6bb514fadaf8543d$export$d3656d656af31043($6bb514fadaf8543d$var$cos((0, $38443af77d9815b6$export$37576b9ba69b50db)(rotationAngle)), $6bb514fadaf8543d$var$sin((0, $38443af77d9815b6$export$37576b9ba69b50db)(rotationAngle)) + $6bb514fadaf8543d$var$tan((0, $38443af77d9815b6$export$37576b9ba69b50db)(xSkewAngle)), -$6bb514fadaf8543d$var$sin((0, $38443af77d9815b6$export$37576b9ba69b50db)(rotationAngle)) + $6bb514fadaf8543d$var$tan((0, $38443af77d9815b6$export$37576b9ba69b50db)(ySkewAngle)), $6bb514fadaf8543d$var$cos((0, $38443af77d9815b6$export$37576b9ba69b50db)(rotationAngle)), x, y);
};
var $6bb514fadaf8543d$export$909384d9b9d39aff = function(rotationAngle, xSkewAngle, ySkewAngle, x, y) {
    return $6bb514fadaf8543d$export$f567083ac6aa5aa3((0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(rotationAngle)), (0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(xSkewAngle)), (0, $1adec95b95f779ee$export$c9fcf1a7df975d78)((0, $38443af77d9815b6$export$37576b9ba69b50db)(ySkewAngle)), x, y);
};
var $6bb514fadaf8543d$export$382c18f8bccd9e2b = function(name) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).DrawObject, [
        (0, $38443af77d9815b6$export$69d5e1b305482e08)(name)
    ]);
};
var $6bb514fadaf8543d$export$f30201749d00f572 = function(gray) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).NonStrokingColorGray, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $6bb514fadaf8543d$export$6502921112196b8f = function(gray) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).StrokingColorGray, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(gray)
    ]);
};
var $6bb514fadaf8543d$export$f59cae633978eea7 = function(red, green, blue) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).NonStrokingColorRgb, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(red),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(green),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $6bb514fadaf8543d$export$e743468c48a4fd5a = function(red, green, blue) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).StrokingColorRgb, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(red),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(green),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(blue)
    ]);
};
var $6bb514fadaf8543d$export$e836aceb3db98cc0 = function(cyan, magenta, yellow, key) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).NonStrokingColorCmyk, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(cyan),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(magenta),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(yellow),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $6bb514fadaf8543d$export$4004b818fda831c1 = function(cyan, magenta, yellow, key) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).StrokingColorCmyk, [
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(cyan),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(magenta),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(yellow),
        (0, $38443af77d9815b6$export$fb5b5e76a3a5c568)(key)
    ]);
};
var $6bb514fadaf8543d$export$a028b403e40f1ab2 = function(tag) {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).BeginMarkedContent, [
        (0, $38443af77d9815b6$export$69d5e1b305482e08)(tag)
    ]);
};
var $6bb514fadaf8543d$export$935e2334f5a50589 = function() {
    return (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039).of((0, $1cc3dd00b8bf8e36$export$2e2bcd8739ae039).EndMarkedContent);
};


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $dXsOT = parcelRequire("dXsOT");
var $883da9eab467c3c8$export$4eb09b1c0a6dec24;
(function(ColorTypes) {
    ColorTypes["Grayscale"] = "Grayscale";
    ColorTypes["RGB"] = "RGB";
    ColorTypes["CMYK"] = "CMYK";
})($883da9eab467c3c8$export$4eb09b1c0a6dec24 || ($883da9eab467c3c8$export$4eb09b1c0a6dec24 = {}));
var $883da9eab467c3c8$export$6f416a6db2dfcd5c = function(gray) {
    (0, $fYigW.assertRange)(gray, 'gray', 0.0, 1.0);
    return {
        type: $883da9eab467c3c8$export$4eb09b1c0a6dec24.Grayscale,
        gray: gray
    };
};
var $883da9eab467c3c8$export$8972dc0e6ad9238f = function(red, green, blue) {
    (0, $fYigW.assertRange)(red, 'red', 0, 1);
    (0, $fYigW.assertRange)(green, 'green', 0, 1);
    (0, $fYigW.assertRange)(blue, 'blue', 0, 1);
    return {
        type: $883da9eab467c3c8$export$4eb09b1c0a6dec24.RGB,
        red: red,
        green: green,
        blue: blue
    };
};
var $883da9eab467c3c8$export$358b1a66a3c77756 = function(cyan, magenta, yellow, key) {
    (0, $fYigW.assertRange)(cyan, 'cyan', 0, 1);
    (0, $fYigW.assertRange)(magenta, 'magenta', 0, 1);
    (0, $fYigW.assertRange)(yellow, 'yellow', 0, 1);
    (0, $fYigW.assertRange)(key, 'key', 0, 1);
    return {
        type: $883da9eab467c3c8$export$4eb09b1c0a6dec24.CMYK,
        cyan: cyan,
        magenta: magenta,
        yellow: yellow,
        key: key
    };
};
var $883da9eab467c3c8$var$Grayscale = $883da9eab467c3c8$export$4eb09b1c0a6dec24.Grayscale, $883da9eab467c3c8$var$RGB = $883da9eab467c3c8$export$4eb09b1c0a6dec24.RGB, $883da9eab467c3c8$var$CMYK = $883da9eab467c3c8$export$4eb09b1c0a6dec24.CMYK;
var $883da9eab467c3c8$export$6126e5d7ba707741 = function(color) {
    return color.type === $883da9eab467c3c8$var$Grayscale ? (0, $6bb514fadaf8543d$export$f30201749d00f572)(color.gray) : color.type === $883da9eab467c3c8$var$RGB ? (0, $6bb514fadaf8543d$export$f59cae633978eea7)(color.red, color.green, color.blue) : color.type === $883da9eab467c3c8$var$CMYK ? (0, $6bb514fadaf8543d$export$e836aceb3db98cc0)(color.cyan, color.magenta, color.yellow, color.key) : (0, $dXsOT.error)("Invalid color: " + JSON.stringify(color));
};
var $883da9eab467c3c8$export$ae31e5cacc8bb23d = function(color) {
    return color.type === $883da9eab467c3c8$var$Grayscale ? (0, $6bb514fadaf8543d$export$6502921112196b8f)(color.gray) : color.type === $883da9eab467c3c8$var$RGB ? (0, $6bb514fadaf8543d$export$e743468c48a4fd5a)(color.red, color.green, color.blue) : color.type === $883da9eab467c3c8$var$CMYK ? (0, $6bb514fadaf8543d$export$4004b818fda831c1)(color.cyan, color.magenta, color.yellow, color.key) : (0, $dXsOT.error)("Invalid color: " + JSON.stringify(color));
};
var $883da9eab467c3c8$export$8750a268217b0987 = function(comps, scale) {
    if (scale === void 0) scale = 1;
    return (comps === null || comps === void 0 ? void 0 : comps.length) === 1 ? $883da9eab467c3c8$export$6f416a6db2dfcd5c(comps[0] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 3 ? $883da9eab467c3c8$export$8972dc0e6ad9238f(comps[0] * scale, comps[1] * scale, comps[2] * scale) : (comps === null || comps === void 0 ? void 0 : comps.length) === 4 ? $883da9eab467c3c8$export$358b1a66a3c77756(comps[0] * scale, comps[1] * scale, comps[2] * scale, comps[3] * scale) : undefined;
};
var $883da9eab467c3c8$export$ffee2793812e3e56 = function(color) {
    return color.type === $883da9eab467c3c8$var$Grayscale ? [
        color.gray
    ] : color.type === $883da9eab467c3c8$var$RGB ? [
        color.red,
        color.green,
        color.blue
    ] : color.type === $883da9eab467c3c8$var$CMYK ? [
        color.cyan,
        color.magenta,
        color.yellow,
        color.key
    ] : (0, $dXsOT.error)("Invalid color: " + JSON.stringify(color));
};




// Originated from pdfkit Copyright (c) 2014 Devon Govett
// https://github.com/foliojs/pdfkit/blob/1e62e6ffe24b378eb890df507a47610f4c4a7b24/lib/path.js
// MIT LICENSE
// Updated for pdf-lib & TypeScript by Jeremy Messenger

var $d54a3e6a2d696ccc$var$cx = 0;
var $d54a3e6a2d696ccc$var$cy = 0;
var $d54a3e6a2d696ccc$var$px = 0;
var $d54a3e6a2d696ccc$var$py = 0;
var $d54a3e6a2d696ccc$var$sx = 0;
var $d54a3e6a2d696ccc$var$sy = 0;
var $d54a3e6a2d696ccc$var$parameters = new Map([
    [
        'A',
        7
    ],
    [
        'a',
        7
    ],
    [
        'C',
        6
    ],
    [
        'c',
        6
    ],
    [
        'H',
        1
    ],
    [
        'h',
        1
    ],
    [
        'L',
        2
    ],
    [
        'l',
        2
    ],
    [
        'M',
        2
    ],
    [
        'm',
        2
    ],
    [
        'Q',
        4
    ],
    [
        'q',
        4
    ],
    [
        'S',
        4
    ],
    [
        's',
        4
    ],
    [
        'T',
        2
    ],
    [
        't',
        2
    ],
    [
        'V',
        1
    ],
    [
        'v',
        1
    ],
    [
        'Z',
        0
    ],
    [
        'z',
        0
    ]
]);
var $d54a3e6a2d696ccc$var$parse = function(path) {
    var cmd;
    var ret = [];
    var args = [];
    var curArg = '';
    var foundDecimal = false;
    var params = 0;
    for(var _i = 0, path_1 = path; _i < path_1.length; _i++){
        var c = path_1[_i];
        if ($d54a3e6a2d696ccc$var$parameters.has(c)) {
            params = $d54a3e6a2d696ccc$var$parameters.get(c);
            if (cmd) {
                // save existing command
                if (curArg.length > 0) args[args.length] = +curArg;
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [];
                curArg = '';
                foundDecimal = false;
            }
            cmd = c;
        } else if ([
            ' ',
            ','
        ].includes(c) || c === '-' && curArg.length > 0 && curArg[curArg.length - 1] !== 'e' || c === '.' && foundDecimal) {
            if (curArg.length === 0) continue;
            if (args.length === params) {
                // handle reused commands
                ret[ret.length] = {
                    cmd: cmd,
                    args: args
                };
                args = [
                    +curArg
                ];
                // handle assumed commands
                if (cmd === 'M') cmd = 'L';
                if (cmd === 'm') cmd = 'l';
            } else args[args.length] = +curArg;
            foundDecimal = c === '.';
            // fix for negative numbers or repeated decimals with no delimeter between commands
            curArg = [
                '-',
                '.'
            ].includes(c) ? c : '';
        } else {
            curArg += c;
            if (c === '.') foundDecimal = true;
        }
    }
    // add the last command
    if (curArg.length > 0) {
        if (args.length === params) {
            // handle reused commands
            ret[ret.length] = {
                cmd: cmd,
                args: args
            };
            args = [
                +curArg
            ];
            // handle assumed commands
            if (cmd === 'M') cmd = 'L';
            if (cmd === 'm') cmd = 'l';
        } else args[args.length] = +curArg;
    }
    ret[ret.length] = {
        cmd: cmd,
        args: args
    };
    return ret;
};
var $d54a3e6a2d696ccc$var$apply = function(commands) {
    // current point, control point, and subpath starting point
    $d54a3e6a2d696ccc$var$cx = $d54a3e6a2d696ccc$var$cy = $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$sx = $d54a3e6a2d696ccc$var$sy = 0;
    // run the commands
    var cmds = [];
    for(var i = 0; i < commands.length; i++){
        var c = commands[i];
        if (c.cmd && typeof $d54a3e6a2d696ccc$var$runners[c.cmd] === 'function') {
            var cmd = $d54a3e6a2d696ccc$var$runners[c.cmd](c.args);
            if (Array.isArray(cmd)) cmds = cmds.concat(cmd);
            else cmds.push(cmd);
        }
    }
    return cmds;
};
var $d54a3e6a2d696ccc$var$runners = {
    M: function(a) {
        $d54a3e6a2d696ccc$var$cx = a[0];
        $d54a3e6a2d696ccc$var$cy = a[1];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        $d54a3e6a2d696ccc$var$sx = $d54a3e6a2d696ccc$var$cx;
        $d54a3e6a2d696ccc$var$sy = $d54a3e6a2d696ccc$var$cy;
        return (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    m: function(a) {
        $d54a3e6a2d696ccc$var$cx += a[0];
        $d54a3e6a2d696ccc$var$cy += a[1];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        $d54a3e6a2d696ccc$var$sx = $d54a3e6a2d696ccc$var$cx;
        $d54a3e6a2d696ccc$var$sy = $d54a3e6a2d696ccc$var$cy;
        return (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    C: function(a) {
        $d54a3e6a2d696ccc$var$cx = a[4];
        $d54a3e6a2d696ccc$var$cy = a[5];
        $d54a3e6a2d696ccc$var$px = a[2];
        $d54a3e6a2d696ccc$var$py = a[3];
        return (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(a[0], a[1], a[2], a[3], a[4], a[5]);
    },
    c: function(a) {
        var cmd = (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(a[0] + $d54a3e6a2d696ccc$var$cx, a[1] + $d54a3e6a2d696ccc$var$cy, a[2] + $d54a3e6a2d696ccc$var$cx, a[3] + $d54a3e6a2d696ccc$var$cy, a[4] + $d54a3e6a2d696ccc$var$cx, a[5] + $d54a3e6a2d696ccc$var$cy);
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx + a[2];
        $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy + a[3];
        $d54a3e6a2d696ccc$var$cx += a[4];
        $d54a3e6a2d696ccc$var$cy += a[5];
        return cmd;
    },
    S: function(a) {
        if ($d54a3e6a2d696ccc$var$px === null || $d54a3e6a2d696ccc$var$py === null) {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx;
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy;
        }
        var cmd = (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)($d54a3e6a2d696ccc$var$cx - ($d54a3e6a2d696ccc$var$px - $d54a3e6a2d696ccc$var$cx), $d54a3e6a2d696ccc$var$cy - ($d54a3e6a2d696ccc$var$py - $d54a3e6a2d696ccc$var$cy), a[0], a[1], a[2], a[3]);
        $d54a3e6a2d696ccc$var$px = a[0];
        $d54a3e6a2d696ccc$var$py = a[1];
        $d54a3e6a2d696ccc$var$cx = a[2];
        $d54a3e6a2d696ccc$var$cy = a[3];
        return cmd;
    },
    s: function(a) {
        if ($d54a3e6a2d696ccc$var$px === null || $d54a3e6a2d696ccc$var$py === null) {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx;
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy;
        }
        var cmd = (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)($d54a3e6a2d696ccc$var$cx - ($d54a3e6a2d696ccc$var$px - $d54a3e6a2d696ccc$var$cx), $d54a3e6a2d696ccc$var$cy - ($d54a3e6a2d696ccc$var$py - $d54a3e6a2d696ccc$var$cy), $d54a3e6a2d696ccc$var$cx + a[0], $d54a3e6a2d696ccc$var$cy + a[1], $d54a3e6a2d696ccc$var$cx + a[2], $d54a3e6a2d696ccc$var$cy + a[3]);
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx + a[0];
        $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy + a[1];
        $d54a3e6a2d696ccc$var$cx += a[2];
        $d54a3e6a2d696ccc$var$cy += a[3];
        return cmd;
    },
    Q: function(a) {
        $d54a3e6a2d696ccc$var$px = a[0];
        $d54a3e6a2d696ccc$var$py = a[1];
        $d54a3e6a2d696ccc$var$cx = a[2];
        $d54a3e6a2d696ccc$var$cy = a[3];
        return (0, $6bb514fadaf8543d$export$6f4913b22432f892)(a[0], a[1], $d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    q: function(a) {
        var cmd = (0, $6bb514fadaf8543d$export$6f4913b22432f892)(a[0] + $d54a3e6a2d696ccc$var$cx, a[1] + $d54a3e6a2d696ccc$var$cy, a[2] + $d54a3e6a2d696ccc$var$cx, a[3] + $d54a3e6a2d696ccc$var$cy);
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx + a[0];
        $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy + a[1];
        $d54a3e6a2d696ccc$var$cx += a[2];
        $d54a3e6a2d696ccc$var$cy += a[3];
        return cmd;
    },
    T: function(a) {
        if ($d54a3e6a2d696ccc$var$px === null || $d54a3e6a2d696ccc$var$py === null) {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx;
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy;
        } else {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx - ($d54a3e6a2d696ccc$var$px - $d54a3e6a2d696ccc$var$cx);
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy - ($d54a3e6a2d696ccc$var$py - $d54a3e6a2d696ccc$var$cy);
        }
        var cmd = (0, $6bb514fadaf8543d$export$6f4913b22432f892)($d54a3e6a2d696ccc$var$px, $d54a3e6a2d696ccc$var$py, a[0], a[1]);
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx - ($d54a3e6a2d696ccc$var$px - $d54a3e6a2d696ccc$var$cx);
        $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy - ($d54a3e6a2d696ccc$var$py - $d54a3e6a2d696ccc$var$cy);
        $d54a3e6a2d696ccc$var$cx = a[0];
        $d54a3e6a2d696ccc$var$cy = a[1];
        return cmd;
    },
    t: function(a) {
        if ($d54a3e6a2d696ccc$var$px === null || $d54a3e6a2d696ccc$var$py === null) {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx;
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy;
        } else {
            $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$cx - ($d54a3e6a2d696ccc$var$px - $d54a3e6a2d696ccc$var$cx);
            $d54a3e6a2d696ccc$var$py = $d54a3e6a2d696ccc$var$cy - ($d54a3e6a2d696ccc$var$py - $d54a3e6a2d696ccc$var$cy);
        }
        var cmd = (0, $6bb514fadaf8543d$export$6f4913b22432f892)($d54a3e6a2d696ccc$var$px, $d54a3e6a2d696ccc$var$py, $d54a3e6a2d696ccc$var$cx + a[0], $d54a3e6a2d696ccc$var$cy + a[1]);
        $d54a3e6a2d696ccc$var$cx += a[0];
        $d54a3e6a2d696ccc$var$cy += a[1];
        return cmd;
    },
    A: function(a) {
        var cmds = $d54a3e6a2d696ccc$var$solveArc($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy, a);
        $d54a3e6a2d696ccc$var$cx = a[5];
        $d54a3e6a2d696ccc$var$cy = a[6];
        return cmds;
    },
    a: function(a) {
        a[5] += $d54a3e6a2d696ccc$var$cx;
        a[6] += $d54a3e6a2d696ccc$var$cy;
        var cmds = $d54a3e6a2d696ccc$var$solveArc($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy, a);
        $d54a3e6a2d696ccc$var$cx = a[5];
        $d54a3e6a2d696ccc$var$cy = a[6];
        return cmds;
    },
    L: function(a) {
        $d54a3e6a2d696ccc$var$cx = a[0];
        $d54a3e6a2d696ccc$var$cy = a[1];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    l: function(a) {
        $d54a3e6a2d696ccc$var$cx += a[0];
        $d54a3e6a2d696ccc$var$cy += a[1];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    H: function(a) {
        $d54a3e6a2d696ccc$var$cx = a[0];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    h: function(a) {
        $d54a3e6a2d696ccc$var$cx += a[0];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    V: function(a) {
        $d54a3e6a2d696ccc$var$cy = a[0];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    v: function(a) {
        $d54a3e6a2d696ccc$var$cy += a[0];
        $d54a3e6a2d696ccc$var$px = $d54a3e6a2d696ccc$var$py = null;
        return (0, $6bb514fadaf8543d$export$73abee0cf983cb99)($d54a3e6a2d696ccc$var$cx, $d54a3e6a2d696ccc$var$cy);
    },
    Z: function() {
        var cmd = (0, $6bb514fadaf8543d$export$21f87e210c424cd0)();
        $d54a3e6a2d696ccc$var$cx = $d54a3e6a2d696ccc$var$sx;
        $d54a3e6a2d696ccc$var$cy = $d54a3e6a2d696ccc$var$sy;
        return cmd;
    },
    z: function() {
        var cmd = (0, $6bb514fadaf8543d$export$21f87e210c424cd0)();
        $d54a3e6a2d696ccc$var$cx = $d54a3e6a2d696ccc$var$sx;
        $d54a3e6a2d696ccc$var$cy = $d54a3e6a2d696ccc$var$sy;
        return cmd;
    }
};
var $d54a3e6a2d696ccc$var$solveArc = function(x, y, coords) {
    var rx = coords[0], ry = coords[1], rot = coords[2], large = coords[3], sweep = coords[4], ex = coords[5], ey = coords[6];
    var segs = $d54a3e6a2d696ccc$var$arcToSegments(ex, ey, rx, ry, large, sweep, rot, x, y);
    var cmds = [];
    for(var _i = 0, segs_1 = segs; _i < segs_1.length; _i++){
        var seg = segs_1[_i];
        var bez = $d54a3e6a2d696ccc$var$segmentToBezier.apply(void 0, seg);
        cmds.push((0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb).apply(void 0, bez));
    }
    return cmds;
};
// from Inkscape svgtopdf, thanks!
var $d54a3e6a2d696ccc$var$arcToSegments = function(x, y, rx, ry, large, sweep, rotateX, ox, oy) {
    var th = rotateX * (Math.PI / 180);
    var sinTh = Math.sin(th);
    var cosTh = Math.cos(th);
    rx = Math.abs(rx);
    ry = Math.abs(ry);
    $d54a3e6a2d696ccc$var$px = cosTh * (ox - x) * 0.5 + sinTh * (oy - y) * 0.5;
    $d54a3e6a2d696ccc$var$py = cosTh * (oy - y) * 0.5 - sinTh * (ox - x) * 0.5;
    var pl = $d54a3e6a2d696ccc$var$px * $d54a3e6a2d696ccc$var$px / (rx * rx) + $d54a3e6a2d696ccc$var$py * $d54a3e6a2d696ccc$var$py / (ry * ry);
    if (pl > 1) {
        pl = Math.sqrt(pl);
        rx *= pl;
        ry *= pl;
    }
    var a00 = cosTh / rx;
    var a01 = sinTh / rx;
    var a10 = -sinTh / ry;
    var a11 = cosTh / ry;
    var x0 = a00 * ox + a01 * oy;
    var y0 = a10 * ox + a11 * oy;
    var x1 = a00 * x + a01 * y;
    var y1 = a10 * x + a11 * y;
    var d = (x1 - x0) * (x1 - x0) + (y1 - y0) * (y1 - y0);
    var sfactorSq = 1 / d - 0.25;
    if (sfactorSq < 0) sfactorSq = 0;
    var sfactor = Math.sqrt(sfactorSq);
    if (sweep === large) sfactor = -sfactor;
    var xc = 0.5 * (x0 + x1) - sfactor * (y1 - y0);
    var yc = 0.5 * (y0 + y1) + sfactor * (x1 - x0);
    var th0 = Math.atan2(y0 - yc, x0 - xc);
    var th1 = Math.atan2(y1 - yc, x1 - xc);
    var thArc = th1 - th0;
    if (thArc < 0 && sweep === 1) thArc += 2 * Math.PI;
    else if (thArc > 0 && sweep === 0) thArc -= 2 * Math.PI;
    var segments = Math.ceil(Math.abs(thArc / (Math.PI * 0.5 + 0.001)));
    var result = [];
    for(var i = 0; i < segments; i++){
        var th2 = th0 + i * thArc / segments;
        var th3 = th0 + (i + 1) * thArc / segments;
        result[i] = [
            xc,
            yc,
            th2,
            th3,
            rx,
            ry,
            sinTh,
            cosTh
        ];
    }
    return result;
};
var $d54a3e6a2d696ccc$var$segmentToBezier = function(cx1, cy1, th0, th1, rx, ry, sinTh, cosTh) {
    var a00 = cosTh * rx;
    var a01 = -sinTh * ry;
    var a10 = sinTh * rx;
    var a11 = cosTh * ry;
    var thHalf = 0.5 * (th1 - th0);
    var t = 8 / 3 * Math.sin(thHalf * 0.5) * Math.sin(thHalf * 0.5) / Math.sin(thHalf);
    var x1 = cx1 + Math.cos(th0) - t * Math.sin(th0);
    var y1 = cy1 + Math.sin(th0) + t * Math.cos(th0);
    var x3 = cx1 + Math.cos(th1);
    var y3 = cy1 + Math.sin(th1);
    var x2 = x3 + t * Math.sin(th1);
    var y2 = y3 - t * Math.cos(th1);
    var result = [
        a00 * x1 + a01 * y1,
        a10 * x1 + a11 * y1,
        a00 * x2 + a01 * y2,
        a10 * x2 + a11 * y2,
        a00 * x3 + a01 * y3,
        a10 * x3 + a11 * y3
    ];
    return result;
};
var $d54a3e6a2d696ccc$export$8de5166f0a5bde2a = function(path) {
    return $d54a3e6a2d696ccc$var$apply($d54a3e6a2d696ccc$var$parse(path));
};



var $cf63ff38d178ccc1$export$b11bd9a0808bdc9 = function(line, options) {
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        (0, $6bb514fadaf8543d$export$337b8dbf65fbb95e)(),
        (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        (0, $6bb514fadaf8543d$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $6bb514fadaf8543d$export$f567083ac6aa5aa3)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew), options.x, options.y),
        (0, $6bb514fadaf8543d$export$778bfc3c1a2b7ba4)(line),
        (0, $6bb514fadaf8543d$export$e3caa83a99d72806)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$export$f7b8b44d3d84bc26 = function(lines, options) {
    var operators = [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        (0, $6bb514fadaf8543d$export$337b8dbf65fbb95e)(),
        (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        (0, $6bb514fadaf8543d$export$df01d619ff6ce7f7)(options.font, options.size),
        (0, $6bb514fadaf8543d$export$79399e66b6bb212c)(options.lineHeight),
        (0, $6bb514fadaf8543d$export$f567083ac6aa5aa3)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew), options.x, options.y)
    ].filter(Boolean);
    for(var idx = 0, len = lines.length; idx < len; idx++)operators.push((0, $6bb514fadaf8543d$export$778bfc3c1a2b7ba4)(lines[idx]), (0, $6bb514fadaf8543d$export$829ffc2dbe358942)());
    operators.push((0, $6bb514fadaf8543d$export$e3caa83a99d72806)(), (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)());
    return operators;
};
var $cf63ff38d178ccc1$export$21a059be5bfd5fb = function(name, options) {
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $6bb514fadaf8543d$export$a2ba89726971a90f)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate)),
        (0, $6bb514fadaf8543d$export$dcdf75081b88279d)(options.width, options.height),
        (0, $6bb514fadaf8543d$export$985cb1d69d6a3add)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew)),
        (0, $6bb514fadaf8543d$export$382c18f8bccd9e2b)(name),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$export$f8ea28c31069cbc9 = function(name, options) {
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $6bb514fadaf8543d$export$a2ba89726971a90f)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate)),
        (0, $6bb514fadaf8543d$export$dcdf75081b88279d)(options.xScale, options.yScale),
        (0, $6bb514fadaf8543d$export$985cb1d69d6a3add)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew)),
        (0, $6bb514fadaf8543d$export$382c18f8bccd9e2b)(name),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$export$819db45aec5fcbe5 = function(options) {
    var _a, _b;
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $883da9eab467c3c8$export$ae31e5cacc8bb23d)(options.color),
        (0, $6bb514fadaf8543d$export$558e0f90d8262345)(options.thickness),
        (0, $6bb514fadaf8543d$export$e0e900d241274e06)((_a = options.dashArray) !== null && _a !== void 0 ? _a : [], (_b = options.dashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        options.lineCap && (0, $6bb514fadaf8543d$export$6c65ed24e870eec)(options.lineCap),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(options.start.x, options.start.y),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(options.end.x, options.end.y),
        (0, $6bb514fadaf8543d$export$d9b706f8d0a70aef)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$export$cac848e0621718d8 = function(options) {
    var _a, _b;
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $883da9eab467c3c8$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $6bb514fadaf8543d$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $6bb514fadaf8543d$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $6bb514fadaf8543d$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0),
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $6bb514fadaf8543d$export$a2ba89726971a90f)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate)),
        (0, $6bb514fadaf8543d$export$985cb1d69d6a3add)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew)),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(0, 0),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(0, options.height),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(options.width, options.height),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(options.width, 0),
        (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        // prettier-ignore
        options.color && options.borderWidth ? (0, $6bb514fadaf8543d$export$76d37801baac10fb)() : options.color ? (0, $6bb514fadaf8543d$export$9563e054e6f787fb)() : options.borderColor ? (0, $6bb514fadaf8543d$export$d9b706f8d0a70aef)() : (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$var$KAPPA = 4.0 * ((Math.sqrt(2) - 1.0) / 3.0);
var $cf63ff38d178ccc1$export$f219d5f4b18063ad = function(config) {
    var x = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.x);
    var y = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.yScale);
    x -= xScale;
    y -= yScale;
    var ox = xScale * $cf63ff38d178ccc1$var$KAPPA;
    var oy = yScale * $cf63ff38d178ccc1$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(x, ym),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ];
};
var $cf63ff38d178ccc1$var$drawEllipseCurves = function(config) {
    var centerX = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.x);
    var centerY = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.y);
    var xScale = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.xScale);
    var yScale = (0, $38443af77d9815b6$export$37576b9ba69b50db)(config.yScale);
    var x = -xScale;
    var y = -yScale;
    var ox = xScale * $cf63ff38d178ccc1$var$KAPPA;
    var oy = yScale * $cf63ff38d178ccc1$var$KAPPA;
    var xe = x + xScale * 2;
    var ye = y + yScale * 2;
    var xm = x + xScale;
    var ym = y + yScale;
    return [
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(centerX, centerY),
        (0, $6bb514fadaf8543d$export$a2ba89726971a90f)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(config.rotate)),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(x, ym),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(x, ym - oy, xm - ox, y, xm, y),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xm + ox, y, xe, ym - oy, xe, ym),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xe, ym + oy, xm + ox, ye, xm, ye),
        (0, $6bb514fadaf8543d$export$45bd49bb15a3c5cb)(xm - ox, ye, x, ym + oy, x, ym)
    ];
};
var $cf63ff38d178ccc1$export$43c9e2bb0dc74582 = function(options) {
    var _a, _b, _c;
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        options.color && (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $883da9eab467c3c8$export$ae31e5cacc8bb23d)(options.borderColor),
        (0, $6bb514fadaf8543d$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $6bb514fadaf8543d$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $6bb514fadaf8543d$export$e0e900d241274e06)((_a = options.borderDashArray) !== null && _a !== void 0 ? _a : [], (_b = options.borderDashPhase) !== null && _b !== void 0 ? _b : 0)
    ], options.rotate === undefined ? $cf63ff38d178ccc1$export$f219d5f4b18063ad({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale
    }) : $cf63ff38d178ccc1$var$drawEllipseCurves({
        x: options.x,
        y: options.y,
        xScale: options.xScale,
        yScale: options.yScale,
        rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    }), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $6bb514fadaf8543d$export$76d37801baac10fb)() : options.color ? (0, $6bb514fadaf8543d$export$9563e054e6f787fb)() : options.borderColor ? (0, $6bb514fadaf8543d$export$d9b706f8d0a70aef)() : (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $cf63ff38d178ccc1$export$47c8a640c39d0756 = function(path, options) {
    var _a, _b, _c;
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.graphicsState && (0, $6bb514fadaf8543d$export$568567f665d3f3bb)(options.graphicsState),
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $6bb514fadaf8543d$export$a2ba89726971a90f)((0, $1adec95b95f779ee$export$cba01ba138429a1d)((_a = options.rotate) !== null && _a !== void 0 ? _a : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0))),
        // SVG path Y axis is opposite pdf-lib's
        options.scale ? (0, $6bb514fadaf8543d$export$dcdf75081b88279d)(options.scale, -options.scale) : (0, $6bb514fadaf8543d$export$dcdf75081b88279d)(1, -1),
        options.color && (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        options.borderColor && (0, $883da9eab467c3c8$export$ae31e5cacc8bb23d)(options.borderColor),
        options.borderWidth && (0, $6bb514fadaf8543d$export$558e0f90d8262345)(options.borderWidth),
        options.borderLineCap && (0, $6bb514fadaf8543d$export$6c65ed24e870eec)(options.borderLineCap),
        (0, $6bb514fadaf8543d$export$e0e900d241274e06)((_b = options.borderDashArray) !== null && _b !== void 0 ? _b : [], (_c = options.borderDashPhase) !== null && _c !== void 0 ? _c : 0)
    ], (0, $d54a3e6a2d696ccc$export$8de5166f0a5bde2a)(path), [
        // prettier-ignore
        options.color && options.borderWidth ? (0, $6bb514fadaf8543d$export$76d37801baac10fb)() : options.color ? (0, $6bb514fadaf8543d$export$9563e054e6f787fb)() : options.borderColor ? (0, $6bb514fadaf8543d$export$d9b706f8d0a70aef)() : (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]).filter(Boolean);
};
var $cf63ff38d178ccc1$export$695703ffa02b3ffb = function(options) {
    var size = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.size);
    /*********************** Define Check Mark Points ***************************/ // A check mark is defined by three points in some coordinate space. Here, we
    // define these points in a unit coordinate system, where the range of the x
    // and y axis are both [-1, 1].
    //
    // Note that we do not hard code `p1y` in case we wish to change the
    // size/shape of the check mark in the future. We want the check mark to
    // always form a right angle. This means that the dot product between (p1-p2)
    // and (p3-p2) should be zero:
    //
    //   (p1x-p2x) * (p3x-p2x) + (p1y-p2y) * (p3y-p2y) = 0
    //
    // We can now rejigger this equation to solve for `p1y`:
    //
    //   (p1y-p2y) * (p3y-p2y) = -((p1x-p2x) * (p3x-p2x))
    //   (p1y-p2y) = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y)
    //   p1y = -((p1x-p2x) * (p3x-p2x)) / (p3y-p2y) + p2y
    //
    // Thanks to my friend Joel Walker (https://github.com/JWalker1995) for
    // devising the above equation and unit coordinate system approach!
    // (x, y) coords of the check mark's bottommost point
    var p2x = -0.25;
    var p2y = -0.49;
    // (x, y) coords of the check mark's topmost point
    var p3y = 0.475;
    var p3x = 0.69;
    // (x, y) coords of the check mark's center (vertically) point
    var p1x = -0.675;
    var p1y = -((p1x - p2x) * (p3x - p2x)) / (p3y - p2y) + p2y;
    /****************************************************************************/ return [
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
        options.color && (0, $883da9eab467c3c8$export$ae31e5cacc8bb23d)(options.color),
        (0, $6bb514fadaf8543d$export$558e0f90d8262345)(options.thickness),
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.x, options.y),
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(p1x * size, p1y * size),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(p2x * size, p2y * size),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(p3x * size, p3y * size),
        (0, $6bb514fadaf8543d$export$d9b706f8d0a70aef)(),
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ].filter(Boolean);
};
var $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6 = function(options) {
    return options.rotation === 0 ? [
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(0, 0),
        (0, $6bb514fadaf8543d$export$91df22fbff99d059)(0)
    ] : options.rotation === 90 ? [
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.width, 0),
        (0, $6bb514fadaf8543d$export$91df22fbff99d059)(90)
    ] : options.rotation === 180 ? [
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(options.width, options.height),
        (0, $6bb514fadaf8543d$export$91df22fbff99d059)(180)
    ] : options.rotation === 270 ? [
        (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(0, options.height),
        (0, $6bb514fadaf8543d$export$91df22fbff99d059)(270)
    ] : [];
}; // Invalid rotation - noop
var $cf63ff38d178ccc1$export$1c2f7a8d0ec539ab = function(options) {
    var outline = $cf63ff38d178ccc1$export$cac848e0621718d8({
        x: options.x,
        y: options.y,
        width: options.width,
        height: options.height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    if (!options.filled) return outline;
    var width = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.width);
    var height = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.height);
    var checkMarkSize = Math.min(width, height) / 2;
    var checkMark = $cf63ff38d178ccc1$export$695703ffa02b3ffb({
        x: width / 2,
        y: height / 2,
        size: checkMarkSize,
        thickness: options.thickness,
        color: options.markColor
    });
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], outline, checkMark, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]);
};
var $cf63ff38d178ccc1$export$d01bb537f184a293 = function(options) {
    var width = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.width);
    var height = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.height);
    var outlineScale = Math.min(width, height) / 2;
    var outline = $cf63ff38d178ccc1$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale,
        yScale: outlineScale,
        color: options.color,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth
    });
    if (!options.filled) return outline;
    var dot = $cf63ff38d178ccc1$export$43c9e2bb0dc74582({
        x: options.x,
        y: options.y,
        xScale: outlineScale * 0.45,
        yScale: outlineScale * 0.45,
        color: options.dotColor,
        borderColor: undefined,
        borderWidth: 0
    });
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], outline, dot, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]);
};
var $cf63ff38d178ccc1$export$31046eb8c5070d92 = function(options) {
    var x = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.x);
    var y = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.y);
    var width = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.width);
    var height = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.height);
    var background = $cf63ff38d178ccc1$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    var lines = $cf63ff38d178ccc1$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], background, lines, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]);
};
var $cf63ff38d178ccc1$export$8a28629e0fa0aec4 = function(lines, options) {
    var operators = [
        (0, $6bb514fadaf8543d$export$337b8dbf65fbb95e)(),
        (0, $883da9eab467c3c8$export$6126e5d7ba707741)(options.color),
        (0, $6bb514fadaf8543d$export$df01d619ff6ce7f7)(options.font, options.size)
    ];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var _a = lines[idx], encoded = _a.encoded, x = _a.x, y = _a.y;
        operators.push((0, $6bb514fadaf8543d$export$f567083ac6aa5aa3)((0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.rotate), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.xSkew), (0, $1adec95b95f779ee$export$cba01ba138429a1d)(options.ySkew), x, y), (0, $6bb514fadaf8543d$export$778bfc3c1a2b7ba4)(encoded));
    }
    operators.push((0, $6bb514fadaf8543d$export$e3caa83a99d72806)());
    return operators;
};
var $cf63ff38d178ccc1$export$7d8517ad99905084 = function(options) {
    var x = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.x);
    var y = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.y);
    var width = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.width);
    var height = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.height);
    var borderWidth = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        (0, $6bb514fadaf8543d$export$e0b576e7a74416cd)(),
        (0, $6bb514fadaf8543d$export$d366e9c0a9bd860f)()
    ];
    var background = $cf63ff38d178ccc1$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    var lines = $cf63ff38d178ccc1$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$a028b403e40f1ab2)('Tx'),
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], lines, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)(),
        (0, $6bb514fadaf8543d$export$935e2334f5a50589)()
    ]);
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], background, clippingArea, markedContent, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]);
};
var $cf63ff38d178ccc1$export$5a3093287b85b7c0 = function(options) {
    var x = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.x);
    var y = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.y);
    var width = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.width);
    var height = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.height);
    var lineHeight = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.lineHeight);
    var borderWidth = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.borderWidth);
    var padding = (0, $38443af77d9815b6$export$37576b9ba69b50db)(options.padding);
    var clipX = x + borderWidth / 2 + padding;
    var clipY = y + borderWidth / 2 + padding;
    var clipWidth = width - (borderWidth / 2 + padding) * 2;
    var clipHeight = height - (borderWidth / 2 + padding) * 2;
    var clippingArea = [
        (0, $6bb514fadaf8543d$export$75f1ccd6dc32e80a)(clipX, clipY),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX, clipY + clipHeight),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX + clipWidth, clipY + clipHeight),
        (0, $6bb514fadaf8543d$export$73abee0cf983cb99)(clipX + clipWidth, clipY),
        (0, $6bb514fadaf8543d$export$21f87e210c424cd0)(),
        (0, $6bb514fadaf8543d$export$e0b576e7a74416cd)(),
        (0, $6bb514fadaf8543d$export$d366e9c0a9bd860f)()
    ];
    var background = $cf63ff38d178ccc1$export$cac848e0621718d8({
        x: x,
        y: y,
        width: width,
        height: height,
        borderWidth: options.borderWidth,
        color: options.color,
        borderColor: options.borderColor,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    var highlights = [];
    for(var idx = 0, len = options.selectedLines.length; idx < len; idx++){
        var line = options.textLines[options.selectedLines[idx]];
        highlights.push.apply(highlights, $cf63ff38d178ccc1$export$cac848e0621718d8({
            x: line.x - padding,
            y: line.y - (lineHeight - line.height) / 2,
            width: width - borderWidth,
            height: line.height + (lineHeight - line.height) / 2,
            borderWidth: 0,
            color: options.selectedColor,
            borderColor: undefined,
            rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
        }));
    }
    var lines = $cf63ff38d178ccc1$export$8a28629e0fa0aec4(options.textLines, {
        color: options.textColor,
        font: options.font,
        size: options.fontSize,
        rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
        ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
    });
    var markedContent = (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$a028b403e40f1ab2)('Tx'),
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], lines, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)(),
        (0, $6bb514fadaf8543d$export$935e2334f5a50589)()
    ]);
    return (0, $70JnX.__spreadArrays)([
        (0, $6bb514fadaf8543d$export$cb182c48e35739ac)()
    ], background, highlights, clippingArea, markedContent, [
        (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
    ]);
};




// tslint:disable: max-classes-per-file

var $70JnX = parcelRequire("70JnX");
// TODO: Include link to documentation with example
var $071c8956483bdcac$export$20fcceeca2b098d2 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(EncryptedPDFError, _super);
    function EncryptedPDFError() {
        var _this = this;
        var msg = 'Input document to `PDFDocument.load` is encrypted. You can use `PDFDocument.load(..., { ignoreEncryption: true })` if you wish to load the document anyways.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return EncryptedPDFError;
}(Error);
// TODO: Include link to documentation with example
var $071c8956483bdcac$export$529a7c74d0636a48 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(FontkitNotRegisteredError, _super);
    function FontkitNotRegisteredError() {
        var _this = this;
        var msg = 'Input to `PDFDocument.embedFont` was a custom font, but no `fontkit` instance was found. You must register a `fontkit` instance with `PDFDocument.registerFontkit(...)` before embedding custom fonts.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FontkitNotRegisteredError;
}(Error);
// TODO: Include link to documentation with example
var $071c8956483bdcac$export$9564a4d28d94eae2 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(ForeignPageError, _super);
    function ForeignPageError() {
        var _this = this;
        var msg = 'A `page` passed to `PDFDocument.addPage` or `PDFDocument.insertPage` was from a different (foreign) PDF document. If you want to copy pages from one PDFDocument to another, you must use `PDFDocument.copyPages(...)` to copy the pages before adding or inserting them.';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ForeignPageError;
}(Error);
// TODO: Include link to documentation with example
var $071c8956483bdcac$export$cdca06c5927ddc2d = /** @class */ function(_super) {
    (0, $70JnX.__extends)(RemovePageFromEmptyDocumentError, _super);
    function RemovePageFromEmptyDocumentError() {
        var _this = this;
        var msg = 'PDFDocument has no pages so `PDFDocument.removePage` cannot be called';
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RemovePageFromEmptyDocumentError;
}(Error);
var $071c8956483bdcac$export$5bc08baa4a027cbd = /** @class */ function(_super) {
    (0, $70JnX.__extends)(NoSuchFieldError, _super);
    function NoSuchFieldError(name) {
        var _this = this;
        var msg = "PDFDocument has no form field with the name \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return NoSuchFieldError;
}(Error);
var $071c8956483bdcac$export$8909da6c566ff652 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(UnexpectedFieldTypeError, _super);
    function UnexpectedFieldTypeError(name, expected, actual) {
        var _a, _b;
        var _this = this;
        var expectedType = expected === null || expected === void 0 ? void 0 : expected.name;
        var actualType = (_b = (_a = actual === null || actual === void 0 ? void 0 : actual.constructor) === null || _a === void 0 ? void 0 : _a.name) !== null && _b !== void 0 ? _b : actual;
        var msg = "Expected field \"" + name + "\" to be of type " + expectedType + ", " + ("but it is actually of type " + actualType);
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return UnexpectedFieldTypeError;
}(Error);
var $071c8956483bdcac$export$3437b42908c7d7a3 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(MissingOnValueCheckError, _super);
    function MissingOnValueCheckError(onValue) {
        var _this = this;
        var msg = "Failed to select check box due to missing onValue: \"" + onValue + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return MissingOnValueCheckError;
}(Error);
var $071c8956483bdcac$export$c428cfe4dc6c68df = /** @class */ function(_super) {
    (0, $70JnX.__extends)(FieldAlreadyExistsError, _super);
    function FieldAlreadyExistsError(name) {
        var _this = this;
        var msg = "A field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldAlreadyExistsError;
}(Error);
var $071c8956483bdcac$export$83c39fdacfe38500 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(InvalidFieldNamePartError, _super);
    function InvalidFieldNamePartError(namePart) {
        var _this = this;
        var msg = "Field name contains invalid component: \"" + namePart + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidFieldNamePartError;
}(Error);
var $071c8956483bdcac$export$6353a2ffd9106bd2 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(FieldExistsAsNonTerminalError, _super);
    function FieldExistsAsNonTerminalError(name) {
        var _this = this;
        var msg = "A non-terminal field already exists with the specified name: \"" + name + "\"";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return FieldExistsAsNonTerminalError;
}(Error);
var $071c8956483bdcac$export$f2fed572e1ed57ab = /** @class */ function(_super) {
    (0, $70JnX.__extends)(RichTextFieldReadError, _super);
    function RichTextFieldReadError(fieldName) {
        var _this = this;
        var msg = "Reading rich text fields is not supported: Attempted to read rich text field: " + fieldName;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return RichTextFieldReadError;
}(Error);
var $071c8956483bdcac$export$5283dffc620a5c9f = /** @class */ function(_super) {
    (0, $70JnX.__extends)(CombedTextLayoutError, _super);
    function CombedTextLayoutError(lineLength, cellCount) {
        var _this = this;
        var msg = "Failed to layout combed text as lineLength=" + lineLength + " is greater than cellCount=" + cellCount;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return CombedTextLayoutError;
}(Error);
var $071c8956483bdcac$export$1577e99040d42609 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(ExceededMaxLengthError, _super);
    function ExceededMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set text with length=" + textLength + " for TextField with maxLength=" + maxLength + " and name=" + name;
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return ExceededMaxLengthError;
}(Error);
var $071c8956483bdcac$export$6da6c372180e79b0 = /** @class */ function(_super) {
    (0, $70JnX.__extends)(InvalidMaxLengthError, _super);
    function InvalidMaxLengthError(textLength, maxLength, name) {
        var _this = this;
        var msg = "Attempted to set maxLength=" + maxLength + ", which is less than " + textLength + ", the length of this field's current value (name=" + name + ")";
        _this = _super.call(this, msg) || this;
        return _this;
    }
    return InvalidMaxLengthError;
}(Error);


var $40510ba2913036d8$export$84b2d1b68830363f;
(function(TextAlignment) {
    TextAlignment[TextAlignment["Left"] = 0] = "Left";
    TextAlignment[TextAlignment["Center"] = 1] = "Center";
    TextAlignment[TextAlignment["Right"] = 2] = "Right";
})($40510ba2913036d8$export$84b2d1b68830363f || ($40510ba2913036d8$export$84b2d1b68830363f = {}));


parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $f317cbad684d410b$var$MIN_FONT_SIZE = 4;
var $f317cbad684d410b$var$MAX_FONT_SIZE = 500;
var $f317cbad684d410b$var$computeFontSize = function(lines, font, bounds, multiline) {
    if (multiline === void 0) multiline = false;
    var fontSize = $f317cbad684d410b$var$MIN_FONT_SIZE;
    while(fontSize < $f317cbad684d410b$var$MAX_FONT_SIZE){
        var linesUsed = 0;
        for(var lineIdx = 0, lineLen = lines.length; lineIdx < lineLen; lineIdx++){
            linesUsed += 1;
            var line = lines[lineIdx];
            var words = line.split(' ');
            // Layout the words using the current `fontSize`, line wrapping
            // whenever we reach the end of the current line.
            var spaceInLineRemaining = bounds.width;
            for(var idx = 0, len = words.length; idx < len; idx++){
                var isLastWord = idx === len - 1;
                var word = isLastWord ? words[idx] : words[idx] + ' ';
                var widthOfWord = font.widthOfTextAtSize(word, fontSize);
                spaceInLineRemaining -= widthOfWord;
                if (spaceInLineRemaining <= 0) {
                    linesUsed += 1;
                    spaceInLineRemaining = bounds.width - widthOfWord;
                }
            }
        }
        // Return if we exceeded the allowed width
        if (!multiline && linesUsed > lines.length) return fontSize - 1;
        var height = font.heightAtSize(fontSize);
        var lineHeight = height + height * 0.2;
        var totalHeight = lineHeight * linesUsed;
        // Return if we exceeded the allowed height
        if (totalHeight > Math.abs(bounds.height)) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $f317cbad684d410b$var$computeCombedFontSize = function(line, font, bounds, cellCount) {
    var cellWidth = bounds.width / cellCount;
    var cellHeight = bounds.height;
    var fontSize = $f317cbad684d410b$var$MIN_FONT_SIZE;
    var chars = (0, $c6a2W.charSplit)(line);
    while(fontSize < $f317cbad684d410b$var$MAX_FONT_SIZE){
        for(var idx = 0, len = chars.length; idx < len; idx++){
            var c = chars[idx];
            var tooLong = font.widthOfTextAtSize(c, fontSize) > cellWidth * 0.75;
            if (tooLong) return fontSize - 1;
        }
        var height = font.heightAtSize(fontSize, {
            descender: false
        });
        if (height > cellHeight) return fontSize - 1;
        fontSize += 1;
    }
    return fontSize;
};
var $f317cbad684d410b$var$lastIndexOfWhitespace = function(line) {
    for(var idx = line.length; idx > 0; idx--){
        if (/\s/.test(line[idx])) return idx;
    }
    return undefined;
};
var $f317cbad684d410b$var$splitOutLines = function(input, maxWidth, font, fontSize) {
    var _a;
    var lastWhitespaceIdx = input.length;
    while(lastWhitespaceIdx > 0){
        var line = input.substring(0, lastWhitespaceIdx);
        var encoded = font.encodeText(line);
        var width = font.widthOfTextAtSize(line, fontSize);
        if (width < maxWidth) {
            var remainder = input.substring(lastWhitespaceIdx) || undefined;
            return {
                line: line,
                encoded: encoded,
                width: width,
                remainder: remainder
            };
        }
        lastWhitespaceIdx = (_a = $f317cbad684d410b$var$lastIndexOfWhitespace(line)) !== null && _a !== void 0 ? _a : 0;
    }
    // We were unable to split the input enough to get a chunk that would fit
    // within the specified `maxWidth` so we'll just return everything
    return {
        line: input,
        encoded: font.encodeText(input),
        width: font.widthOfTextAtSize(input, fontSize),
        remainder: undefined
    };
};
var $f317cbad684d410b$export$f6ba9f13f815cc95 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var lines = (0, $c6a2W.lineSplit)((0, $c6a2W.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $f317cbad684d410b$var$computeFontSize(lines, font, bounds, true);
    var height = font.heightAtSize(fontSize);
    var lineHeight = height + height * 0.2;
    var textLines = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var y = bounds.y + bounds.height;
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var prevRemainder = lines[idx];
        while(prevRemainder !== undefined){
            var _b = $f317cbad684d410b$var$splitOutLines(prevRemainder, bounds.width, font, fontSize), line = _b.line, encoded = _b.encoded, width = _b.width, remainder = _b.remainder;
            // prettier-ignore
            var x = alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
            y -= lineHeight;
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (x + width > maxX) maxX = x + width;
            if (y + height > maxY) maxY = y + height;
            textLines.push({
                text: line,
                encoded: encoded,
                width: width,
                height: height,
                x: x,
                y: y
            });
            // Only trim lines that we had to split ourselves. So we won't trim lines
            // that the user provided themselves with whitespace.
            prevRemainder = remainder === null || remainder === void 0 ? void 0 : remainder.trim();
        }
    }
    return {
        fontSize: fontSize,
        lineHeight: lineHeight,
        lines: textLines,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $f317cbad684d410b$export$deba41d88dd75dfc = function(text, _a) {
    var fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds, cellCount = _a.cellCount;
    var line = (0, $c6a2W.mergeLines)((0, $c6a2W.cleanText)(text));
    if (line.length > cellCount) throw new (0, $071c8956483bdcac$export$5283dffc620a5c9f)(line.length, cellCount);
    if (fontSize === undefined || fontSize === 0) fontSize = $f317cbad684d410b$var$computeCombedFontSize(line, font, bounds, cellCount);
    var cellWidth = bounds.width / cellCount;
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    var y = bounds.y + (bounds.height / 2 - height / 2);
    var cells = [];
    var minX = bounds.x;
    var minY = bounds.y;
    var maxX = bounds.x + bounds.width;
    var maxY = bounds.y + bounds.height;
    var cellOffset = 0;
    var charOffset = 0;
    while(cellOffset < cellCount){
        var _b = (0, $c6a2W.charAtIndex)(line, charOffset), char = _b[0], charLength = _b[1];
        var encoded = font.encodeText(char);
        var width = font.widthOfTextAtSize(char, fontSize);
        var cellCenter = bounds.x + (cellWidth * cellOffset + cellWidth / 2);
        var x = cellCenter - width / 2;
        if (x < minX) minX = x;
        if (y < minY) minY = y;
        if (x + width > maxX) maxX = x + width;
        if (y + height > maxY) maxY = y + height;
        cells.push({
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        });
        cellOffset += 1;
        charOffset += charLength;
    }
    return {
        fontSize: fontSize,
        cells: cells,
        bounds: {
            x: minX,
            y: minY,
            width: maxX - minX,
            height: maxY - minY
        }
    };
};
var $f317cbad684d410b$export$c0030606588cf6f2 = function(text, _a) {
    var alignment = _a.alignment, fontSize = _a.fontSize, font = _a.font, bounds = _a.bounds;
    var line = (0, $c6a2W.mergeLines)((0, $c6a2W.cleanText)(text));
    if (fontSize === undefined || fontSize === 0) fontSize = $f317cbad684d410b$var$computeFontSize([
        line
    ], font, bounds);
    var encoded = font.encodeText(line);
    var width = font.widthOfTextAtSize(line, fontSize);
    var height = font.heightAtSize(fontSize, {
        descender: false
    });
    // prettier-ignore
    var x = alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Left ? bounds.x : alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Center ? bounds.x + bounds.width / 2 - width / 2 : alignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Right ? bounds.x + bounds.width - width : bounds.x;
    var y = bounds.y + (bounds.height / 2 - height / 2);
    return {
        fontSize: fontSize,
        line: {
            text: line,
            encoded: encoded,
            width: width,
            height: height,
            x: x,
            y: y
        },
        bounds: {
            x: x,
            y: y,
            width: width,
            height: height
        }
    };
};




parcelRequire("JEL7f");
var $c6a2W = parcelRequire("c6a2W");
var $bb10ac27e6f27957$export$8a3aea031520d39b = function(appearance) {
    if ('normal' in appearance) return appearance;
    return {
        normal: appearance
    };
};
// Examples:
//   `/Helv 12 Tf` -> ['/Helv 12 Tf', 'Helv', '12']
//   `/HeBo 8.00 Tf` -> ['/HeBo 8 Tf', 'HeBo', '8.00']
var $bb10ac27e6f27957$var$tfRegex = /\/([^\0\t\n\f\r\ ]+)[\0\t\n\f\r\ ]+(\d*\.\d+|\d+)[\0\t\n\f\r\ ]+Tf/;
var $bb10ac27e6f27957$var$getDefaultFontSize = function(field) {
    var _a, _b;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (_b = (0, $c6a2W.findLastMatch)(da, $bb10ac27e6f27957$var$tfRegex).match) !== null && _b !== void 0 ? _b : [];
    var defaultFontSize = Number(daMatch[2]);
    return isFinite(defaultFontSize) ? defaultFontSize : undefined;
};
// Examples:
//   `0.3 g` -> ['0.3', 'g']
//   `0.3 1 .3 rg` -> ['0.3', '1', '.3', 'rg']
//   `0.3 1 .3 0 k` -> ['0.3', '1', '.3', '0', 'k']
var $bb10ac27e6f27957$var$colorRegex = /(\d*\.\d+|\d+)[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]*(\d*\.\d+|\d+)?[\0\t\n\f\r\ ]+(g|rg|k)/;
var $bb10ac27e6f27957$var$getDefaultColor = function(field) {
    var _a;
    var da = (_a = field.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
    var daMatch = (0, $c6a2W.findLastMatch)(da, $bb10ac27e6f27957$var$colorRegex).match;
    var _b = daMatch !== null && daMatch !== void 0 ? daMatch : [], c1 = _b[1], c2 = _b[2], c3 = _b[3], c4 = _b[4], colorSpace = _b[5];
    if (colorSpace === 'g' && c1) return (0, $883da9eab467c3c8$export$6f416a6db2dfcd5c)(Number(c1));
    if (colorSpace === 'rg' && c1 && c2 && c3) return (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(Number(c1), Number(c2), Number(c3));
    if (colorSpace === 'k' && c1 && c2 && c3 && c4) return (0, $883da9eab467c3c8$export$358b1a66a3c77756)(Number(c1), Number(c2), Number(c3), Number(c4));
    return undefined;
};
var $bb10ac27e6f27957$var$updateDefaultAppearance = function(field, color, font, fontSize) {
    var _a;
    if (fontSize === void 0) fontSize = 0;
    var da = [
        (0, $883da9eab467c3c8$export$6126e5d7ba707741)(color).toString(),
        (0, $6bb514fadaf8543d$export$df01d619ff6ce7f7)((_a = font === null || font === void 0 ? void 0 : font.name) !== null && _a !== void 0 ? _a : 'dummy__noop', fontSize).toString()
    ].join('\n');
    field.setDefaultAppearance(da);
};
var $bb10ac27e6f27957$export$e11eab3ac6c06eb0 = function(checkBox, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(checkBox.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(checkBox.acroField, textColor);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        thickness: 1.5,
        borderWidth: borderWidth,
        borderColor: borderColor,
        markColor: textColor
    };
    return {
        normal: {
            on: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$1c2f7a8d0ec539ab)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$1c2f7a8d0ec539ab)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$1c2f7a8d0ec539ab)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$1c2f7a8d0ec539ab)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $bb10ac27e6f27957$export$6440094330a99ef8 = function(radioGroup, widget) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(radioGroup.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (_b = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor())) !== null && _b !== void 0 ? _b : black;
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    // Update color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(radioGroup.acroField, textColor);
    var options = {
        x: width / 2,
        y: height / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        dotColor: textColor
    };
    return {
        normal: {
            on: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$d01bb537f184a293)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: true
            }))),
            off: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$d01bb537f184a293)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: normalBackgroundColor,
                filled: false
            })))
        },
        down: {
            on: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$d01bb537f184a293)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: downBackgroundColor,
                filled: true
            }))),
            off: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$d01bb537f184a293)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
                color: downBackgroundColor,
                filled: false
            })))
        }
    };
};
var $bb10ac27e6f27957$export$68f9b19f48ffeeec = function(button, widget, font) {
    var _a, _b, _c, _d, _e;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(button.acroField);
    var widgetFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(widget);
    var fieldFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(button.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var captions = ap === null || ap === void 0 ? void 0 : ap.getCaptions();
    var normalText = (_a = captions === null || captions === void 0 ? void 0 : captions.normal) !== null && _a !== void 0 ? _a : '';
    var downText = (_c = (_b = captions === null || captions === void 0 ? void 0 : captions.down) !== null && _b !== void 0 ? _b : normalText) !== null && _c !== void 0 ? _c : '';
    var borderWidth = (_d = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _d !== void 0 ? _d : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _f = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _f.width, height = _f.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var downBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor(), 0.8);
    var bounds = {
        x: borderWidth,
        y: borderWidth,
        width: width - borderWidth * 2,
        height: height - borderWidth * 2
    };
    var normalLayout = (0, $f317cbad684d410b$export$c0030606588cf6f2)(normalText, {
        alignment: (0, $40510ba2913036d8$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    var downLayout = (0, $f317cbad684d410b$export$c0030606588cf6f2)(downText, {
        alignment: (0, $40510ba2913036d8$export$84b2d1b68830363f).Center,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    });
    // Update font size and color
    var fontSize = Math.min(normalLayout.fontSize, downLayout.fontSize);
    var textColor = (_e = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _e !== void 0 ? _e : black;
    if (widgetColor || widgetFontSize !== undefined) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(button.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize
    };
    return {
        normal: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$31046eb8c5070d92)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
            color: normalBackgroundColor,
            textLines: [
                normalLayout.line
            ]
        }))),
        down: (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$31046eb8c5070d92)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
            color: downBackgroundColor,
            textLines: [
                downLayout.line
            ]
        })))
    };
};
var $bb10ac27e6f27957$export$42ba95e6b8df3d7 = function(textField, widget, font) {
    var _a, _b, _c, _d;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(textField.acroField);
    var widgetFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(widget);
    var fieldFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(textField.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = textField.getText()) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _e = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _e.width, height = _e.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var textLines;
    var fontSize;
    var padding = textField.isCombed() ? 0 : 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    if (textField.isMultiline()) {
        var layout = (0, $f317cbad684d410b$export$f6ba9f13f815cc95)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = layout.lines;
        fontSize = layout.fontSize;
    } else if (textField.isCombed()) {
        var layout = (0, $f317cbad684d410b$export$deba41d88dd75dfc)(text, {
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds,
            cellCount: (_c = textField.getMaxLength()) !== null && _c !== void 0 ? _c : 0
        });
        textLines = layout.cells;
        fontSize = layout.fontSize;
    } else {
        var layout = (0, $f317cbad684d410b$export$c0030606588cf6f2)(text, {
            alignment: textField.getAlignment(),
            fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
            font: font,
            bounds: bounds
        });
        textLines = [
            layout.line
        ];
        fontSize = layout.fontSize;
    }
    // Update font size and color
    var textColor = (_d = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _d !== void 0 ? _d : black;
    if (widgetColor || widgetFontSize !== undefined) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(textField.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: textLines,
        padding: padding
    };
    return (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$7d8517ad99905084)(options));
};
var $bb10ac27e6f27957$export$90f1ca03d512ec5 = function(dropdown, widget, font) {
    var _a, _b, _c;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(dropdown.acroField);
    var widgetFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(widget);
    var fieldFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(dropdown.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var text = (_a = dropdown.getSelected()[0]) !== null && _a !== void 0 ? _a : '';
    var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _d = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _d.width, height = _d.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _e = (0, $f317cbad684d410b$export$c0030606588cf6f2)(text, {
        alignment: (0, $40510ba2913036d8$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), line = _e.line, fontSize = _e.fontSize;
    // Update font size and color
    var textColor = (_c = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _c !== void 0 ? _c : black;
    if (widgetColor || widgetFontSize !== undefined) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(dropdown.acroField, textColor, font, fontSize);
    var options = {
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: [
            line
        ],
        padding: padding
    };
    return (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$7d8517ad99905084)(options));
};
var $bb10ac27e6f27957$export$f9fab495286778d2 = function(optionList, widget, font) {
    var _a, _b;
    // The `/DA` entry can be at the widget or field level - so we handle both
    var widgetColor = $bb10ac27e6f27957$var$getDefaultColor(widget);
    var fieldColor = $bb10ac27e6f27957$var$getDefaultColor(optionList.acroField);
    var widgetFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(widget);
    var fieldFontSize = $bb10ac27e6f27957$var$getDefaultFontSize(optionList.acroField);
    var rectangle = widget.getRectangle();
    var ap = widget.getAppearanceCharacteristics();
    var bs = widget.getBorderStyle();
    var borderWidth = (_a = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _a !== void 0 ? _a : 0;
    var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
    var _c = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation), width = _c.width, height = _c.height;
    var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
        rotation: rotation
    }));
    var black = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
    var borderColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBorderColor());
    var normalBackgroundColor = (0, $883da9eab467c3c8$export$8750a268217b0987)(ap === null || ap === void 0 ? void 0 : ap.getBackgroundColor());
    var options = optionList.getOptions();
    var selected = optionList.getSelected();
    if (optionList.isSorted()) options.sort();
    var text = '';
    for(var idx = 0, len = options.length; idx < len; idx++){
        text += options[idx];
        if (idx < len - 1) text += '\n';
    }
    var padding = 1;
    var bounds = {
        x: borderWidth + padding,
        y: borderWidth + padding,
        width: width - (borderWidth + padding) * 2,
        height: height - (borderWidth + padding) * 2
    };
    var _d = (0, $f317cbad684d410b$export$f6ba9f13f815cc95)(text, {
        alignment: (0, $40510ba2913036d8$export$84b2d1b68830363f).Left,
        fontSize: widgetFontSize !== null && widgetFontSize !== void 0 ? widgetFontSize : fieldFontSize,
        font: font,
        bounds: bounds
    }), lines = _d.lines, fontSize = _d.fontSize, lineHeight = _d.lineHeight;
    var selectedLines = [];
    for(var idx = 0, len = lines.length; idx < len; idx++){
        var line = lines[idx];
        if (selected.includes(line.text)) selectedLines.push(idx);
    }
    var blue = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0.6, 193 / 255, 218 / 255);
    // Update font size and color
    var textColor = (_b = widgetColor !== null && widgetColor !== void 0 ? widgetColor : fieldColor) !== null && _b !== void 0 ? _b : black;
    if (widgetColor || widgetFontSize !== undefined) $bb10ac27e6f27957$var$updateDefaultAppearance(widget, textColor, font, fontSize);
    else $bb10ac27e6f27957$var$updateDefaultAppearance(optionList.acroField, textColor, font, fontSize);
    return (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$5a3093287b85b7c0)({
        x: 0 + borderWidth / 2,
        y: 0 + borderWidth / 2,
        width: width - borderWidth,
        height: height - borderWidth,
        borderWidth: borderWidth !== null && borderWidth !== void 0 ? borderWidth : 0,
        borderColor: borderColor,
        textColor: textColor,
        font: font.name,
        fontSize: fontSize,
        color: normalBackgroundColor,
        textLines: lines,
        lineHeight: lineHeight,
        selectedColor: blue,
        selectedLines: selectedLines,
        padding: padding
    }));
};



var $70JnX = parcelRequire("70JnX");

var $70JnX = parcelRequire("70JnX");




var $70JnX = parcelRequire("70JnX");


var $70JnX = parcelRequire("70JnX");


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a PDF page that has been embedded in a [[PDFDocument]].
 */ var $1fe054a60e239076$var$PDFEmbeddedPage = /** @class */ function() {
    function PDFEmbeddedPage(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        (0, $fYigW.assertIs)(ref, 'ref', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $fYigW.assertIs)(embedder, 'embedder', [
            [
                (0, $6a885455e88efc51$export$2e2bcd8739ae039),
                'PDFPageEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this page after being scaled by the
     * given `factor`. For example:
     * ```js
     * embeddedPage.width  // => 500
     * embeddedPage.height // => 250
     *
     * const scaled = embeddedPage.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing a page with
     * [[PDFPage.drawPage]] to compute the `width` and `height` options.
     * @param factor The factor by which this page should be scaled.
     * @returns The width and height of the page after being scaled.
     */ PDFEmbeddedPage.prototype.scale = function(factor) {
        (0, $fYigW.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this page. For example:
     * ```js
     * const { width, height } = embeddedPage.size()
     * ```
     * @returns The width and height of the page.
     */ PDFEmbeddedPage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable pages get embedded.
     *
     * Embed this embeddable page in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedPage.prototype.embed = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPdf]] and
     * > [[PDFDocument.embedPage]] methods, which will create instances of
     * > [[PDFEmbeddedPage]] for you.
     *
     * Create an instance of [[PDFEmbeddedPage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this embedded page.
     * @param doc The document to which the embedded page will belong.
     * @param embedder The embedder that will be used to embed the page.
     */ PDFEmbeddedPage.of = function(ref, doc, embedder) {
        return new PDFEmbeddedPage(ref, doc, embedder);
    };
    return PDFEmbeddedPage;
}();
var $1fe054a60e239076$export$2e2bcd8739ae039 = $1fe054a60e239076$var$PDFEmbeddedPage;



var $70JnX = parcelRequire("70JnX");


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a font that has been embedded in a [[PDFDocument]].
 */ var $9982052d55be794b$var$PDFFont = /** @class */ function() {
    function PDFFont(ref, doc, embedder) {
        this.modified = true;
        (0, $fYigW.assertIs)(ref, 'ref', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $fYigW.assertIs)(embedder, 'embedder', [
            [
                (0, $ce290f01ecd7d7e1$export$2e2bcd8739ae039),
                'CustomFontEmbedder'
            ],
            [
                (0, $b2a95496f8f41048$export$2e2bcd8739ae039),
                'StandardFontEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.name = embedder.fontName;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFPage.drawText]] method will automatically encode the text it is
     * > given.
     *
     * Encodes a string of text in this font.
     *
     * @param text The text to be encoded.
     * @returns The encoded text as a hex string.
     */ PDFFont.prototype.encodeText = function(text) {
        (0, $fYigW.assertIs)(text, 'text', [
            'string'
        ]);
        this.modified = true;
        return this.embedder.encodeText(text);
    };
    /**
     * Measure the width of a string of text drawn in this font at a given size.
     * For example:
     * ```js
     * const width = font.widthOfTextAtSize('Foo Bar Qux Baz', 36)
     * ```
     * @param text The string of text to be measured.
     * @param size The font size to be used for this measurement.
     * @returns The width of the string of text when drawn in this font at the
     *          given size.
     */ PDFFont.prototype.widthOfTextAtSize = function(text, size) {
        (0, $fYigW.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $fYigW.assertIs)(size, 'size', [
            'number'
        ]);
        return this.embedder.widthOfTextAtSize(text, size);
    };
    /**
     * Measure the height of this font at a given size. For example:
     * ```js
     * const height = font.heightAtSize(24)
     * ```
     *
     * The `options.descender` value controls whether or not the font's
     * descender is included in the height calculation.
     *
     * @param size The font size to be used for this measurement.
     * @param options The options to be used when computing this measurement.
     * @returns The height of this font at the given size.
     */ PDFFont.prototype.heightAtSize = function(size, options) {
        var _a;
        (0, $fYigW.assertIs)(size, 'size', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.descender, 'options.descender', [
            'boolean'
        ]);
        return this.embedder.heightOfFontAtSize(size, {
            descender: (_a = options === null || options === void 0 ? void 0 : options.descender) !== null && _a !== void 0 ? _a : true
        });
    };
    /**
     * Compute the font size at which this font is a given height. For example:
     * ```js
     * const fontSize = font.sizeAtHeight(12)
     * ```
     * @param height The height to be used for this calculation.
     * @returns The font size at which this font is the given height.
     */ PDFFont.prototype.sizeAtHeight = function(height) {
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        return this.embedder.sizeOfFontAtHeight(height);
    };
    /**
     * Get the set of unicode code points that can be represented by this font.
     * @returns The set of unicode code points supported by this font.
     */ PDFFont.prototype.getCharacterSet = function() {
        if (this.embedder instanceof (0, $b2a95496f8f41048$export$2e2bcd8739ae039)) return this.embedder.encoding.supportedCodePoints;
        else return this.embedder.font.characterSet;
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all fonts get embedded.
     *
     * Embed this font in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFFont.prototype.embed = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!this.modified) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        _a.sent();
                        this.modified = false;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedFont]] and
     * > [[PDFDocument.embedStandardFont]] methods, which will create instances
     * > of [[PDFFont]] for you.
     *
     * Create an instance of [[PDFFont]] from an existing ref and embedder
     *
     * @param ref The unique reference for this font.
     * @param doc The document to which the font will belong.
     * @param embedder The embedder that will be used to embed the font.
     */ PDFFont.of = function(ref, doc, embedder) {
        return new PDFFont(ref, doc, embedder);
    };
    return PDFFont;
}();
var $9982052d55be794b$export$2e2bcd8739ae039 = $9982052d55be794b$var$PDFFont;



var $70JnX = parcelRequire("70JnX");


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents an image that has been embedded in a [[PDFDocument]].
 */ var $2c09e59199b6bc75$var$PDFImage = /** @class */ function() {
    function PDFImage(ref, doc, embedder) {
        (0, $fYigW.assertIs)(ref, 'ref', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        (0, $fYigW.assertIs)(embedder, 'embedder', [
            [
                (0, $b0d34f0e58769ca2$export$2e2bcd8739ae039),
                'JpegEmbedder'
            ],
            [
                (0, $3c0d99ae5c827c27$export$2e2bcd8739ae039),
                'PngEmbedder'
            ]
        ]);
        this.ref = ref;
        this.doc = doc;
        this.width = embedder.width;
        this.height = embedder.height;
        this.embedder = embedder;
    }
    /**
     * Compute the width and height of this image after being scaled by the
     * given `factor`. For example:
     * ```js
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scale(0.5)
     * scaled.width  // => 250
     * scaled.height // => 125
     * ```
     * This operation is often useful before drawing an image with
     * [[PDFPage.drawImage]] to compute the `width` and `height` options.
     * @param factor The factor by which this image should be scaled.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scale = function(factor) {
        (0, $fYigW.assertIs)(factor, 'factor', [
            'number'
        ]);
        return {
            width: this.width * factor,
            height: this.height * factor
        };
    };
    /**
     * Get the width and height of this image after scaling it as large as
     * possible while maintaining its aspect ratio and not exceeding the
     * specified `width` and `height`. For example:
     * ```
     * image.width  // => 500
     * image.height // => 250
     *
     * const scaled = image.scaleToFit(750, 1000)
     * scaled.width  // => 750
     * scaled.height // => 375
     * ```
     * The `width` and `height` parameters can also be thought of as the width
     * and height of a box that the scaled image must fit within.
     * @param width The bounding box's width.
     * @param height The bounding box's height.
     * @returns The width and height of the image after being scaled.
     */ PDFImage.prototype.scaleToFit = function(width, height) {
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var imgWidthScale = width / this.width;
        var imgHeightScale = height / this.height;
        var scale = Math.min(imgWidthScale, imgHeightScale);
        return this.scale(scale);
    };
    /**
     * Get the width and height of this image. For example:
     * ```js
     * const { width, height } = image.size()
     * ```
     * @returns The width and height of the image.
     */ PDFImage.prototype.size = function() {
        return this.scale(1);
    };
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all images get embedded.
     *
     * Embed this image in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFImage.prototype.embed = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, doc, ref;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!this.embedder) return [
                            2 /*return*/ 
                        ];
                        // The image should only be embedded once. If there's a pending embed
                        // operation then wait on it. Otherwise we need to start the embed.
                        if (!this.embedTask) {
                            _a = this, doc = _a.doc, ref = _a.ref;
                            this.embedTask = this.embedder.embedIntoContext(doc.context, ref);
                        }
                        return [
                            4 /*yield*/ ,
                            this.embedTask
                        ];
                    case 1:
                        _b.sent();
                        // We clear `this.embedder` so that the indirectly referenced image data
                        // can be garbage collected, thus avoiding a memory leak.
                        // See https://github.com/Hopding/pdf-lib/pull/1032/files.
                        this.embedder = undefined;
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.embedPng]] and [[PDFDocument.embedJpg]]
     * > methods, which will create instances of [[PDFImage]] for you.
     *
     * Create an instance of [[PDFImage]] from an existing ref and embedder
     *
     * @param ref The unique reference for this image.
     * @param doc The document to which the image will belong.
     * @param embedder The embedder that will be used to embed the image.
     */ PDFImage.of = function(ref, doc, embedder) {
        return new PDFImage(ref, doc, embedder);
    };
    return PDFImage;
}();
var $2c09e59199b6bc75$export$2e2bcd8739ae039 = $2c09e59199b6bc75$var$PDFImage;




var $70JnX = parcelRequire("70JnX");



var $70JnX = parcelRequire("70JnX");





var $70JnX = parcelRequire("70JnX");




var $1jVcF = parcelRequire("1jVcF");
var $btXS2 = parcelRequire("btXS2");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $ffba0304b419c0f0$export$8efa99ca8f041e7e;
(function(ImageAlignment) {
    ImageAlignment[ImageAlignment["Left"] = 0] = "Left";
    ImageAlignment[ImageAlignment["Center"] = 1] = "Center";
    ImageAlignment[ImageAlignment["Right"] = 2] = "Right";
})($ffba0304b419c0f0$export$8efa99ca8f041e7e || ($ffba0304b419c0f0$export$8efa99ca8f041e7e = {}));





var $0a2bc0f9ee5488f0$export$55643210f1835a35 = function(options) {
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.x, 'options.x', [
        'number'
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.y, 'options.y', [
        'number'
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.width, 'options.width', [
        'number'
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.height, 'options.height', [
        'number'
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.textColor, 'options.textColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.backgroundColor, 'options.backgroundColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderColor, 'options.borderColor', [
        [
            Object,
            'Color'
        ]
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.borderWidth, 'options.borderWidth', [
        'number'
    ]);
    (0, $fYigW.assertOrUndefined)(options === null || options === void 0 ? void 0 : options.rotate, 'options.rotate', [
        [
            Object,
            'Rotation'
        ]
    ]);
};
/**
 * Represents a field of a [[PDFForm]].
 *
 * This class is effectively abstract. All fields in a [[PDFForm]] will
 * actually be an instance of a subclass of this class.
 *
 * Note that each field in a PDF is represented by a single field object.
 * However, a given field object may be rendered at multiple locations within
 * the document (across one or more pages). The rendering of a field is
 * controlled by its widgets. Each widget causes its field to be displayed at a
 * particular location in the document.
 *
 * Most of the time each field in a PDF has only a single widget, and thus is
 * only rendered once. However, if a field is rendered multiple times, it will
 * have multiple widgets - one for each location it is rendered.
 *
 * This abstraction of field objects and widgets is defined in the PDF
 * specification and dictates how PDF files store fields and where they are
 * to be rendered.
 */ var $0a2bc0f9ee5488f0$var$PDFField = /** @class */ function() {
    function PDFField(acroField, ref, doc) {
        (0, $fYigW.assertIs)(acroField, 'acroField', [
            [
                (0, $c767daefd50ee8ad$export$2e2bcd8739ae039),
                'PDFAcroTerminal'
            ]
        ]);
        (0, $fYigW.assertIs)(ref, 'ref', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroField = acroField;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Get the fully qualified name of this field. For example:
     * ```js
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const name = field.getName()
     *   console.log('Field name:', name)
     * })
     * ```
     * Note that PDF fields are structured as a tree. Each field is the
     * descendent of a series of ancestor nodes all the way up to the form node,
     * which is always the root of the tree. Each node in the tree (except for
     * the form node) has a partial name. Partial names can be composed of any
     * unicode characters except a period (`.`). The fully qualified name of a
     * field is composed of the partial names of all its ancestors joined
     * with periods. This means that splitting the fully qualified name on
     * periods and taking the last element of the resulting array will give you
     * the partial name of a specific field.
     * @returns The fully qualified name of this field.
     */ PDFField.prototype.getName = function() {
        var _a;
        return (_a = this.acroField.getFullyQualifiedName()) !== null && _a !== void 0 ? _a : '';
    };
    /**
     * Returns `true` if this field is read only. This means that PDF readers
     * will not allow users to interact with the field or change its value. See
     * [[PDFField.enableReadOnly]] and [[PDFField.disableReadOnly]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isReadOnly()) console.log('Read only is enabled')
     * ```
     * @returns Whether or not this is a read only field.
     */ PDFField.prototype.isReadOnly = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$3600c95532547643).ReadOnly);
    };
    /**
     * Prevent PDF readers from allowing users to interact with this field or
     * change its value. The field will not respond to mouse or keyboard input.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableReadOnly()
     * ```
     * Useful for fields whose values are computed, imported from a database, or
     * prefilled by software before being displayed to the user.
     */ PDFField.prototype.enableReadOnly = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).ReadOnly, true);
    };
    /**
     * Allow users to interact with this field and change its value in PDF
     * readers via mouse and keyboard input. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableReadOnly()
     * ```
     */ PDFField.prototype.disableReadOnly = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).ReadOnly, false);
    };
    /**
     * Returns `true` if this field must have a value when the form is submitted.
     * See [[PDFField.enableRequired]] and [[PDFField.disableRequired]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isRequired()) console.log('Field is required')
     * ```
     * @returns Whether or not this field is required.
     */ PDFField.prototype.isRequired = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$3600c95532547643).Required);
    };
    /**
     * Require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableRequired()
     * ```
     */ PDFField.prototype.enableRequired = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).Required, true);
    };
    /**
     * Do not require this field to have a value when the form is submitted.
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableRequired()
     * ```
     */ PDFField.prototype.disableRequired = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).Required, false);
    };
    /**
     * Returns `true` if this field's value should be exported when the form is
     * submitted. See [[PDFField.enableExporting]] and
     * [[PDFField.disableExporting]].
     * For example:
     * ```js
     * const field = form.getField('some.field')
     * if (field.isExported()) console.log('Exporting is enabled')
     * ```
     * @returns Whether or not this field's value should be exported.
     */ PDFField.prototype.isExported = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$3600c95532547643).NoExport);
    };
    /**
     * Indicate that this field's value should be exported when the form is
     * submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.enableExporting()
     * ```
     */ PDFField.prototype.enableExporting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).NoExport, false);
    };
    /**
     * Indicate that this field's value should **not** be exported when the form
     * is submitted in a PDF reader. For example:
     * ```js
     * const field = form.getField('some.field')
     * field.disableExporting()
     * ```
     */ PDFField.prototype.disableExporting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$3600c95532547643).NoExport, true);
    };
    /** @ignore */ PDFField.prototype.needsAppearancesUpdate = function() {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'needsAppearancesUpdate');
    };
    /** @ignore */ PDFField.prototype.defaultUpdateAppearances = function(_font) {
        throw new (0, $1jVcF.MethodNotImplementedError)(this.constructor.name, 'defaultUpdateAppearances');
    };
    PDFField.prototype.markAsDirty = function() {
        this.doc.getForm().markFieldAsDirty(this.ref);
    };
    PDFField.prototype.markAsClean = function() {
        this.doc.getForm().markFieldAsClean(this.ref);
    };
    PDFField.prototype.isDirty = function() {
        return this.doc.getForm().fieldIsDirty(this.ref);
    };
    PDFField.prototype.createWidget = function(options) {
        var _a;
        var textColor = options.textColor;
        var backgroundColor = options.backgroundColor;
        var borderColor = options.borderColor;
        var borderWidth = options.borderWidth;
        var degreesAngle = (0, $1adec95b95f779ee$export$56cb859c01fa134d)(options.rotate);
        var caption = options.caption;
        var x = options.x;
        var y = options.y;
        var width = options.width + borderWidth;
        var height = options.height + borderWidth;
        var hidden = Boolean(options.hidden);
        var pageRef = options.page;
        (0, $fYigW.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        // Create a widget for this field
        var widget = (0, $746c51fc65011bd5$export$2e2bcd8739ae039).create(this.doc.context, this.ref);
        // Set widget properties
        var rect = (0, $1adec95b95f779ee$export$afddc3b8600307a4)({
            x: x,
            y: y,
            width: width,
            height: height
        }, borderWidth, degreesAngle);
        widget.setRectangle(rect);
        if (pageRef) widget.setP(pageRef);
        var ac = widget.getOrCreateAppearanceCharacteristics();
        if (backgroundColor) ac.setBackgroundColor((0, $883da9eab467c3c8$export$ffee2793812e3e56)(backgroundColor));
        ac.setRotation(degreesAngle);
        if (caption) ac.setCaptions({
            normal: caption
        });
        if (borderColor) ac.setBorderColor((0, $883da9eab467c3c8$export$ffee2793812e3e56)(borderColor));
        var bs = widget.getOrCreateBorderStyle();
        if (borderWidth !== undefined) bs.setWidth(borderWidth);
        widget.setFlagTo((0, $a02e75f562c07fbe$export$1fa7b68b35026177).Print, true);
        widget.setFlagTo((0, $a02e75f562c07fbe$export$1fa7b68b35026177).Hidden, hidden);
        widget.setFlagTo((0, $a02e75f562c07fbe$export$1fa7b68b35026177).Invisible, false);
        // Set acrofield properties
        if (textColor) {
            var da = (_a = this.acroField.getDefaultAppearance()) !== null && _a !== void 0 ? _a : '';
            var newDa = da + '\n' + (0, $883da9eab467c3c8$export$6126e5d7ba707741)(textColor).toString();
            this.acroField.setDefaultAppearance(newDa);
        }
        return widget;
    };
    PDFField.prototype.updateWidgetAppearanceWithFont = function(widget, font, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceStream(widget, normal, font),
            rollover: rollover && this.createAppearanceStream(widget, rollover, font),
            down: down && this.createAppearanceStream(widget, down, font)
        });
    };
    PDFField.prototype.updateOnOffWidgetAppearance = function(widget, onValue, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        this.updateWidgetAppearances(widget, {
            normal: this.createAppearanceDict(widget, normal, onValue),
            rollover: rollover && this.createAppearanceDict(widget, rollover, onValue),
            down: down && this.createAppearanceDict(widget, down, onValue)
        });
    };
    PDFField.prototype.updateWidgetAppearances = function(widget, _a) {
        var normal = _a.normal, rollover = _a.rollover, down = _a.down;
        widget.setNormalAppearance(normal);
        if (rollover) widget.setRolloverAppearance(rollover);
        else widget.removeRolloverAppearance();
        if (down) widget.setDownAppearance(down);
        else widget.removeDownAppearance();
    };
    // // TODO: Do we need to do this...?
    // private foo(font: PDFFont, dict: PDFDict) {
    //   if (!dict.lookup(PDFName.of('DR'))) {
    //     dict.set(PDFName.of('DR'), dict.context.obj({}));
    //   }
    //   const DR = dict.lookup(PDFName.of('DR'), PDFDict);
    //   if (!DR.lookup(PDFName.of('Font'))) {
    //     DR.set(PDFName.of('Font'), dict.context.obj({}));
    //   }
    //   const Font = DR.lookup(PDFName.of('Font'), PDFDict);
    //   Font.set(PDFName.of(font.name), font.ref);
    // }
    PDFField.prototype.createAppearanceStream = function(widget, appearance, font) {
        var _a;
        var context = this.acroField.dict.context;
        var _b = widget.getRectangle(), width = _b.width, height = _b.height;
        // TODO: Do we need to do this...?
        // if (font) {
        //   this.foo(font, widget.dict);
        //   this.foo(font, this.doc.getForm().acroForm.dict);
        // }
        // END TODO
        var Resources = font && {
            Font: (_a = {}, _a[font.name] = font.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                width,
                height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        var streamRef = context.register(stream);
        return streamRef;
    };
    /**
     * Create a FormXObject of the supplied image and add it to context.
     * The FormXObject size is calculated based on the widget (including
     * the alignment).
     * @param widget The widget that should display the image.
     * @param alignment The alignment of the image.
     * @param image The image that should be displayed.
     * @returns The ref for the FormXObject that was added to the context.
     */ PDFField.prototype.createImageAppearanceStream = function(widget, image, alignment) {
        // NOTE: This implementation doesn't handle image borders.
        // NOTE: Acrobat seems to resize the image (maybe even skewing its aspect
        //       ratio) to fit perfectly within the widget's rectangle. This method
        //       does not currently do that. Should there be an option for that?
        var _a;
        var _b;
        var context = this.acroField.dict.context;
        var rectangle = widget.getRectangle();
        var ap = widget.getAppearanceCharacteristics();
        var bs = widget.getBorderStyle();
        var borderWidth = (_b = bs === null || bs === void 0 ? void 0 : bs.getWidth()) !== null && _b !== void 0 ? _b : 0;
        var rotation = (0, $1adec95b95f779ee$export$ee0ed07fe78ec05)(ap === null || ap === void 0 ? void 0 : ap.getRotation());
        var rotate = (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
            rotation: rotation
        }));
        var adj = (0, $1adec95b95f779ee$export$312e44550db33c6a)(rectangle, rotation);
        var imageDims = image.scaleToFit(adj.width - borderWidth * 2, adj.height - borderWidth * 2);
        // Support borders on images and maybe other properties
        var options = {
            x: borderWidth,
            y: borderWidth,
            width: imageDims.width,
            height: imageDims.height,
            //
            rotate: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0)
        };
        if (alignment === (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Center) {
            options.x += (adj.width - borderWidth * 2) / 2 - imageDims.width / 2;
            options.y += (adj.height - borderWidth * 2) / 2 - imageDims.height / 2;
        } else if (alignment === (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Right) {
            options.x = adj.width - borderWidth - imageDims.width;
            options.y = adj.height - borderWidth - imageDims.height;
        }
        var imageName = this.doc.context.addRandomSuffix('Image', 10);
        var appearance = (0, $70JnX.__spreadArrays)(rotate, (0, $cf63ff38d178ccc1$export$21a059be5bfd5fb)(imageName, options));
        ////////////
        var Resources = {
            XObject: (_a = {}, _a[imageName] = image.ref, _a)
        };
        var stream = context.formXObject(appearance, {
            Resources: Resources,
            BBox: context.obj([
                0,
                0,
                rectangle.width,
                rectangle.height
            ]),
            Matrix: context.obj([
                1,
                0,
                0,
                1,
                0,
                0
            ])
        });
        return context.register(stream);
    };
    PDFField.prototype.createAppearanceDict = function(widget, appearance, onValue) {
        var context = this.acroField.dict.context;
        var onStreamRef = this.createAppearanceStream(widget, appearance.on);
        var offStreamRef = this.createAppearanceStream(widget, appearance.off);
        var appearanceDict = context.obj({});
        appearanceDict.set(onValue, onStreamRef);
        appearanceDict.set((0, $btXS2.default).of('Off'), offStreamRef);
        return appearanceDict;
    };
    return PDFField;
}();
var $0a2bc0f9ee5488f0$export$2e2bcd8739ae039 = $0a2bc0f9ee5488f0$var$PDFField;



var $btXS2 = parcelRequire("btXS2");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a check box field of a [[PDFForm]].
 *
 * [[PDFCheckBox]] fields are interactive boxes that users can click with their
 * mouse. This type of [[PDFField]] has two states: `on` and `off`. The purpose
 * of a check box is to enable users to select from one or more options, where
 * each option is represented by a single check box. Check boxes are typically
 * square in shape and display a check mark when they are in the `on` state.
 */ var $7634ed9aabad7442$var$PDFCheckBox = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFCheckBox, _super);
    function PDFCheckBox(acroCheckBox, ref, doc) {
        var _this = _super.call(this, acroCheckBox, ref, doc) || this;
        (0, $fYigW.assertIs)(acroCheckBox, 'acroCheckBox', [
            [
                (0, $4e7ed1a5388e159e$export$2e2bcd8739ae039),
                'PDFAcroCheckBox'
            ]
        ]);
        _this.acroField = acroCheckBox;
        return _this;
    }
    /**
     * Mark this check box. This operation is analogous to a human user clicking
     * a check box to fill it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been selected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.check()
     * ```
     *
     * This method will mark this check box as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a check mark inside the widgets of this check box
     * field.
     */ PDFCheckBox.prototype.check = function() {
        var _a;
        var onValue = (_a = this.acroField.getOnValue()) !== null && _a !== void 0 ? _a : (0, $btXS2.default).of('Yes');
        this.markAsDirty();
        this.acroField.setValue(onValue);
    };
    /**
     * Clears this check box. This operation is analogous to a human user clicking
     * a check box to unmark it in a PDF reader. This method will update the
     * underlying state of the check box field to indicate it has been deselected.
     * PDF libraries and readers will be able to extract this value from the
     * saved document and determine that it was not selected.
     *
     * For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.uncheck()
     * ```
     *
     * This method will mark this check box as dirty. See [[PDFCheckBox.check]]
     * for more details about what this means.
     */ PDFCheckBox.prototype.uncheck = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $btXS2.default).of('Off'));
    };
    /**
     * Returns `true` if this check box is selected (either by a human user via
     * a PDF reader, or else programmatically via software). For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.isChecked()) console.log('check box is selected')
     * ```
     * @returns Whether or not this check box is selected.
     */ PDFCheckBox.prototype.isChecked = function() {
        var onValue = this.acroField.getOnValue();
        return !!onValue && onValue === this.acroField.getValue();
    };
    /**
     * Show this check box on the specified page. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('some.checkBox.field')
     *
     * checkBox.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * })
     * ```
     * This will create a new widget for this check box field.
     * @param page The page to which this check box widget should be added.
     * @param options The options to be used when adding this check box widget.
     */ PDFCheckBox.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f;
        (0, $fYigW.assertIs)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this check box
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        widget.setAppearanceState((0, $btXS2.default).of('Off'));
        this.updateWidgetAppearance(widget, (0, $btXS2.default).of('Yes'));
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this check box's widgets do not have an
     * appearance stream for its current state. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * if (checkBox.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this check box needs an appearance update.
     */ PDFCheckBox.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the default appearance provider for check boxes. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.defaultUpdateAppearances()
     * ```
     */ PDFCheckBox.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    /**
     * Update the appearance streams for each of this check box's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for check boxs will be used. For example:
     * ```js
     * const checkBox = form.getCheckBox('some.checkBox.field')
     * checkBox.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *     down: { on: drawCheckBox(...), off: drawCheckBox(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFCheckBox.prototype.updateAppearances = function(provider) {
        var _a;
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = (_a = widget.getOnValue()) !== null && _a !== void 0 ? _a : (0, $btXS2.default).of('Yes');
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
        this.markAsClean();
    };
    PDFCheckBox.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$e11eab3ac6c06eb0);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getCheckBox]] method, which will create an
     * > instance of [[PDFCheckBox]] for you.
     *
     * Create an instance of [[PDFCheckBox]] from an existing acroCheckBox and ref
     *
     * @param acroCheckBox The underlying `PDFAcroCheckBox` for this check box.
     * @param ref The unique reference for this check box.
     * @param doc The document to which this check box will belong.
     */ PDFCheckBox.of = function(acroCheckBox, ref, doc) {
        return new PDFCheckBox(acroCheckBox, ref, doc);
    };
    return PDFCheckBox;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $7634ed9aabad7442$export$2e2bcd8739ae039 = $7634ed9aabad7442$var$PDFCheckBox;



var $70JnX = parcelRequire("70JnX");







parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a dropdown field of a [[PDFForm]].
 *
 * [[PDFDropdown]] fields are interactive text boxes that display a single
 * element (the currently selected value). The purpose of a dropdown is to
 * enable users to select a single option from a set of possible options. Users
 * can click on a dropdown to view the full list of options it provides.
 * Clicking on an option in the list will cause it to be selected and displayed
 * in the dropdown's text box. Some dropdowns allow users to enter text
 * directly into the box from their keyboard, rather than only being allowed to
 * choose an option from the list (see [[PDFDropdown.isEditable]]).
 */ var $ef7090d16eb3bab5$var$PDFDropdown = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFDropdown, _super);
    function PDFDropdown(acroComboBox, ref, doc) {
        var _this = _super.call(this, acroComboBox, ref, doc) || this;
        (0, $fYigW.assertIs)(acroComboBox, 'acroComboBox', [
            [
                (0, $b9e1c95445e29e3a$export$2e2bcd8739ae039),
                'PDFAcroComboBox'
            ]
        ]);
        _this.acroField = acroComboBox;
        return _this;
    }
    /**
     * Get the list of available options for this dropdown. These options will be
     * displayed to users who click on this dropdown in a PDF reader.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const options = dropdown.getOptions()
     * console.log('Dropdown options:', options)
     * ```
     * @returns The options for this dropdown.
     */ PDFDropdown.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this dropdown. These are the values that were
     * selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * const selections = dropdown.getSelected()
     * console.log('Dropdown selections:', selections)
     * ```
     * > **NOTE:** Note that PDF readers only display one selected option when
     * > rendering dropdowns. However, the PDF specification does allow for
     * > multiple values to be selected in a dropdown. As such, the `pdf-lib`
     * > API supports this. However, in most cases the array returned by this
     * > method will contain only a single element (or no elements).
     * @returns The selected options in this dropdown.
     */ PDFDropdown.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this dropdown. These are
     * the values that will be available for users to select when they view this
     * dropdown in a PDF reader. Note that preexisting options for this dropdown
     * will be removed. Only the values passed as `options` will be available to
     * select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('planets.dropdown')
     * dropdown.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     * @param options The options that should be available in this dropdown.
     */ PDFDropdown.prototype.setOptions = function(options) {
        (0, $fYigW.assertIs)(options, 'options', [
            Array
        ]);
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this dropdown. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this dropdown will
     * still be available for users to select.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('rockets.dropdown')
     * dropdown.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * @param options New options that should be available in this dropdown.
     */ PDFDropdown.prototype.addOptions = function(options) {
        (0, $fYigW.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this dropdown. This operation is analogous
     * to a human user opening the dropdown in a PDF reader and clicking on a
     * value to select it. This method will update the underlying state of the
     * dropdown to indicate which values have been selected. PDF libraries and
     * readers will be able to extract these values from the saved document and
     * determine which values were selected.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('best.superhero.dropdown')
     * dropdown.select('One Punch Man')
     * ```
     *
     * This method will mark this dropdown as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the selected option inside the widgets of this dropdown.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if the selected option for this field
     * contains characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFDropdown.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * Selecting an option that does not exist in this dropdown's option list
     * (see [[PDFDropdown.getOptions]]) will enable editing on this dropdown
     * (see [[PDFDropdown.enableEditing]]).
     *
     * > **NOTE:** PDF readers only display one selected option when rendering
     * > dropdowns. However, the PDF specification does allow for multiple values
     * > to be selected in a dropdown. As such, the `pdf-lib` API supports this.
     * > However, it is not recommended to select more than one value with this
     * > method, as only one will be visible. [[PDFOptionList]] fields are better
     * > suited for displaying multiple selected values.
     *
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFDropdown.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $fYigW.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $fYigW.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        var hasCustomOption = optionsArr.find(function(option) {
            return !validOptions.includes(option);
        });
        if (hasCustomOption) this.enableEditing();
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this dropdown. This operation is equivalent
     * to selecting an empty list. This method will update the underlying state
     * of the dropdown to indicate that no values have been selected.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.clear()
     * ```
     * This method will mark this text field as dirty. See [[PDFDropdown.select]]
     * for more details about what this means.
     */ PDFDropdown.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this dropdown. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.setFontSize(4)
     * dropdown.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFDropdown.prototype.setFontSize = function(fontSize) {
        (0, $fYigW.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if users are allowed to edit the selected value of this
     * dropdown directly and are not constrained by the list of available
     * options. See [[PDFDropdown.enableEditing]] and
     * [[PDFDropdown.disableEditing]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isEditable()) console.log('Editing is enabled')
     * ```
     * @returns Whether or not this dropdown is editable.
     */ PDFDropdown.prototype.isEditable = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).Edit);
    };
    /**
     * Allow users to edit the selected value of this dropdown in PDF readers
     * with their keyboard. This means that the selected value of this dropdown
     * will not be constrained by the list of available options. However, if this
     * dropdown has any available options, users will still be allowed to select
     * from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableEditing()
     * ```
     */ PDFDropdown.prototype.enableEditing = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Edit, true);
    };
    /**
     * Do not allow users to edit the selected value of this dropdown in PDF
     * readers with their keyboard. This will constrain the selected value of
     * this dropdown to the list of available options. Users will only be able
     * to select an option from that list.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableEditing()
     * ```
     */ PDFDropdown.prototype.disableEditing = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Edit, false);
    };
    /**
     * Returns `true` if the option list of this dropdown is always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the dropdown. See [[PDFDropdown.enableSorting]] and
     * [[PDFDropdown.disableSorting]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this dropdown's options are sorted.
     */ PDFDropdown.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).Sort);
    };
    /**
     * Always display the option list of this dropdown in alphabetical order,
     * irrespective of the order in which the options were added to this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSorting()
     * ```
     */ PDFDropdown.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the option list of this dropdown in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to the list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSorting()
     * ```
     */ PDFDropdown.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this dropdown's
     * option list. See [[PDFDropdown.enableMultiselect]] and
     * [[PDFDropdown.disableMultiselect]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFDropdown.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this dropdown's option
     * list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableMultiselect()
     * ```
     */ PDFDropdown.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this dropdown's
     * option list. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableMultiselect()
     * ```
     */ PDFDropdown.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the selected option should be spell checked by PDF
     * readers. Spell checking will only be performed if this dropdown allows
     * editing (see [[PDFDropdown.isEditable]]). See
     * [[PDFDropdown.enableSpellChecking]] and
     * [[PDFDropdown.disableSpellChecking]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this dropdown can be spell checked.
     */ PDFDropdown.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the selected option of this dropdown.
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSpellChecking()
     * ```
     */ PDFDropdown.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the selected option of this
     * dropdown. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSpellChecking()
     * ```
     */ PDFDropdown.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this dropdown field (by clicking
     * outside of it - on another field, for example). See
     * [[PDFDropdown.enableSelectOnClick]] and
     * [[PDFDropdown.disableSelectOnClick]]. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFDropdown.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this dropdown field (by clicking
     * outside of it - on another field, for example). For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.enableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this dropdown
     * field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.disableSelectOnClick()
     * ```
     */ PDFDropdown.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this dropdown on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('best.gundam')
     * dropdown.setOptions(['Exia', 'Dynames'])
     * dropdown.select('Exia')
     *
     * dropdown.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this dropdown field.
     * @param page The page to which this dropdown widget should be added.
     * @param options The options to be used when adding this dropdown widget.
     */ PDFDropdown.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $fYigW.assertIs)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this dropdown
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this dropdown has been marked as dirty, or if any of
     * this dropdown's widgets do not have an appearance stream. For example:
     * ```js
     * const dropdown = form.getDropdown('some.dropdown.field')
     * if (dropdown.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this dropdown needs an appearance update.
     */ PDFDropdown.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the default appearance provider for dropdowns. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFDropdown.prototype.defaultUpdateAppearances = function(font) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this dropdown's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for dropdowns will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const dropdown = form.getDropdown('some.dropdown.field')
     * dropdown.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFDropdown.prototype.updateAppearances = function(font, provider) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFDropdown.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$90f1ca03d512ec5);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getDropdown]] method, which will create an
     * > instance of [[PDFDropdown]] for you.
     *
     * Create an instance of [[PDFDropdown]] from an existing acroComboBox and ref
     *
     * @param acroComboBox The underlying `PDFAcroComboBox` for this dropdown.
     * @param ref The unique reference for this dropdown.
     * @param doc The document to which this dropdown will belong.
     */ PDFDropdown.of = function(acroComboBox, ref, doc) {
        return new PDFDropdown(acroComboBox, ref, doc);
    };
    return PDFDropdown;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $ef7090d16eb3bab5$export$2e2bcd8739ae039 = $ef7090d16eb3bab5$var$PDFDropdown;



var $70JnX = parcelRequire("70JnX");







parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents an option list field of a [[PDFForm]].
 *
 * [[PDFOptionList]] fields are interactive lists of options. The purpose of an
 * option list is to enable users to select one or more options from a set of
 * possible options. Users are able to see the full set of options without
 * first having to click on the field (though scrolling may be necessary).
 * Clicking an option in the list will cause it to be selected and displayed
 * with a highlighted background. Some option lists allow users to select
 * more than one option (see [[PDFOptionList.isMultiselect]]).
 */ var $f59ac96bda398d3a$var$PDFOptionList = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFOptionList, _super);
    function PDFOptionList(acroListBox, ref, doc) {
        var _this = _super.call(this, acroListBox, ref, doc) || this;
        (0, $fYigW.assertIs)(acroListBox, 'acroListBox', [
            [
                (0, $8b549563259095fa$export$2e2bcd8739ae039),
                'PDFAcroListBox'
            ]
        ]);
        _this.acroField = acroListBox;
        return _this;
    }
    /**
     * Get the list of available options for this option list. These options will
     * be displayed to users who view this option list in a PDF reader.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const options = optionList.getOptions()
     * console.log('Option List options:', options)
     * ```
     * @returns The options for this option list.
     */ PDFOptionList.prototype.getOptions = function() {
        var rawOptions = this.acroField.getOptions();
        var options = new Array(rawOptions.length);
        for(var idx = 0, len = options.length; idx < len; idx++){
            var _a = rawOptions[idx], display = _a.display, value = _a.value;
            options[idx] = (display !== null && display !== void 0 ? display : value).decodeText();
        }
        return options;
    };
    /**
     * Get the selected options for this option list. These are the values that
     * were selected by a human user via a PDF reader, or programatically via
     * software.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * const selections = optionList.getSelected()
     * console.log('Option List selections:', selections)
     * ```
     * @returns The selected options for this option list.
     */ PDFOptionList.prototype.getSelected = function() {
        var values = this.acroField.getValues();
        var selected = new Array(values.length);
        for(var idx = 0, len = values.length; idx < len; idx++)selected[idx] = values[idx].decodeText();
        return selected;
    };
    /**
     * Set the list of options that are available for this option list. These are
     * the values that will be available for users to select when they view this
     * option list in a PDF reader. Note that preexisting options for this
     * option list will be removed. Only the values passed as `options` will be
     * available to select.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('planets.optionList')
     * optionList.setOptions(['Earth', 'Mars', 'Pluto', 'Venus'])
     * ```
     *
     * This method will mark this option list as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the options this field contains inside the widgets of this text
     * field (with selected options highlighted).
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains any options
     * with characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFOptionList.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * @param options The options that should be available in this option list.
     */ PDFOptionList.prototype.setOptions = function(options) {
        (0, $fYigW.assertIs)(options, 'options', [
            Array
        ]);
        this.markAsDirty();
        var optionObjects = new Array(options.length);
        for(var idx = 0, len = options.length; idx < len; idx++)optionObjects[idx] = {
            value: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(options[idx])
        };
        this.acroField.setOptions(optionObjects);
    };
    /**
     * Add to the list of options that are available for this option list. Users
     * will be able to select these values in a PDF reader. In addition to the
     * values passed as `options`, any preexisting options for this option list
     * will still be available for users to select.
     * For example:
     * ```js
     * const optionList = form.getOptionList('rockets.optionList')
     * optionList.addOptions(['Saturn IV', 'Falcon Heavy'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options New options that should be available in this option list.
     */ PDFOptionList.prototype.addOptions = function(options) {
        (0, $fYigW.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        this.markAsDirty();
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var existingOptions = this.acroField.getOptions();
        var newOptions = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)newOptions[idx] = {
            value: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(optionsArr[idx])
        };
        this.acroField.setOptions(existingOptions.concat(newOptions));
    };
    /**
     * Select one or more values for this option list. This operation is analogous
     * to a human user opening the option list in a PDF reader and clicking on one
     * or more values to select them. This method will update the underlying state
     * of the option list to indicate which values have been selected. PDF
     * libraries and readers will be able to extract these values from the saved
     * document and determine which values were selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('best.superheroes.optionList')
     * optionList.select(['One Punch Man', 'Iron Man'])
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     * @param options The options to be selected.
     * @param merge Whether or not existing selections should be preserved.
     */ PDFOptionList.prototype.select = function(options, merge) {
        if (merge === void 0) merge = false;
        (0, $fYigW.assertIs)(options, 'options', [
            'string',
            Array
        ]);
        (0, $fYigW.assertIs)(merge, 'merge', [
            'boolean'
        ]);
        var optionsArr = Array.isArray(options) ? options : [
            options
        ];
        var validOptions = this.getOptions();
        (0, $fYigW.assertIsSubset)(optionsArr, 'option', validOptions);
        this.markAsDirty();
        if (optionsArr.length > 1 || optionsArr.length === 1 && merge) this.enableMultiselect();
        var values = new Array(optionsArr.length);
        for(var idx = 0, len = optionsArr.length; idx < len; idx++)values[idx] = (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(optionsArr[idx]);
        if (merge) {
            var existingValues = this.acroField.getValues();
            this.acroField.setValues(existingValues.concat(values));
        } else this.acroField.setValues(values);
    };
    /**
     * Clear all selected values for this option list. This operation is
     * equivalent to selecting an empty list. This method will update the
     * underlying state of the option list to indicate that no values have been
     * selected.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.clear()
     * ```
     * This method will mark this option list as dirty. See
     * [[PDFOptionList.setOptions]] for more details about what this means.
     */ PDFOptionList.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValues([]);
    };
    /**
     * Set the font size for the text in this field. There needs to be a
     * default appearance string (DA) set with a font value specified
     * for this to work. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4);
     * ```
     * @param fontSize The font size to set the font to.
     */ /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this option list. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.setFontSize(4)
     * optionList.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFOptionList.prototype.setFontSize = function(fontSize) {
        (0, $fYigW.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if the options of this option list are always displayed
     * in alphabetical order, irrespective of the order in which the options
     * were added to the option list. See [[PDFOptionList.enableSorting]] and
     * [[PDFOptionList.disableSorting]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSorted()) console.log('Sorting is enabled')
     * ```
     * @returns Whether or not this option list is sorted.
     */ PDFOptionList.prototype.isSorted = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).Sort);
    };
    /**
     * Always display the options of this option list in alphabetical order,
     * irrespective of the order in which the options were added to this option
     * list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSorting()
     * ```
     */ PDFOptionList.prototype.enableSorting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Sort, true);
    };
    /**
     * Do not always display the options of this option list in alphabetical
     * order. Instead, display the options in whichever order they were added
     * to this option list. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSorting()
     * ```
     */ PDFOptionList.prototype.disableSorting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).Sort, false);
    };
    /**
     * Returns `true` if multiple options can be selected from this option list.
     * See [[PDFOptionList.enableMultiselect]] and
     * [[PDFOptionList.disableMultiselect]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isMultiselect()) console.log('Multiselect is enabled')
     * ```
     * @returns Whether or not multiple options can be selected.
     */ PDFOptionList.prototype.isMultiselect = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect);
    };
    /**
     * Allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableMultiselect()
     * ```
     */ PDFOptionList.prototype.enableMultiselect = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect, true);
    };
    /**
     * Do not allow users to select more than one option from this option list.
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableMultiselect()
     * ```
     */ PDFOptionList.prototype.disableMultiselect = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).MultiSelect, false);
    };
    /**
     * Returns `true` if the option selected by a user is stored, or "committed",
     * when the user clicks the option. The alternative is that the user's
     * selection is stored when the user leaves this option list field (by
     * clicking outside of it - on another field, for example). See
     * [[PDFOptionList.enableSelectOnClick]] and
     * [[PDFOptionList.disableSelectOnClick]]. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.isSelectOnClick()) console.log('Select on click is enabled')
     * ```
     * @returns Whether or not options are selected immediately after they are
     *          clicked.
     */ PDFOptionList.prototype.isSelectOnClick = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange);
    };
    /**
     * Store the option selected by a user immediately after the user clicks the
     * option. Do not wait for the user to leave this option list field (by
     * clicking outside of it - on another field, for example). For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.enableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.enableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange, true);
    };
    /**
     * Wait to store the option selected by a user until they leave this option
     * list field (by clicking outside of it - on another field, for example).
     * For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.disableSelectOnClick()
     * ```
     */ PDFOptionList.prototype.disableSelectOnClick = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$eb88827058402599).CommitOnSelChange, false);
    };
    /**
     * Show this option list on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('best.gundams')
     * optionList.setOptions(['Exia', 'Dynames', 'Kyrios', 'Virtue'])
     * optionList.select(['Exia', 'Virtue'])
     *
     * optionList.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this option list field.
     * @param page The page to which this option list widget should be added.
     * @param options The options to be used when adding this option list widget.
     */ PDFOptionList.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $fYigW.assertIs)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this option list
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this option list has been marked as dirty, or if any of
     * this option list's widgets do not have an appearance stream. For example:
     * ```js
     * const optionList = form.getOptionList('some.optionList.field')
     * if (optionList.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this option list needs an appearance update.
     */ PDFOptionList.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the default appearance provider for option lists. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFOptionList.prototype.defaultUpdateAppearances = function(font) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this option list's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for option lists will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const optionList = form.getOptionList('some.optionList.field')
     * optionList.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawOptionList(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFOptionList.prototype.updateAppearances = function(font, provider) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    // getOption(index: number): string {}
    // getSelectedIndices(): number[] {}
    // removeOptions(option: string | string[]) {}
    // removeIndices(option: number[]) {}
    // deselect(options: string | string[]) {}
    // deselectIndices(optionIndices: number[]) {}
    PDFOptionList.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$f9fab495286778d2);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create
     * > an instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroListBox and
     * ref
     *
     * @param acroComboBox The underlying `PDFAcroListBox` for this option list.
     * @param ref The unique reference for this option list.
     * @param doc The document to which this option list will belong.
     */ PDFOptionList.of = function(acroListBox, ref, doc) {
        return new PDFOptionList(acroListBox, ref, doc);
    };
    return PDFOptionList;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $f59ac96bda398d3a$export$2e2bcd8739ae039 = $f59ac96bda398d3a$var$PDFOptionList;



var $70JnX = parcelRequire("70JnX");






var $btXS2 = parcelRequire("btXS2");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a radio group field of a [[PDFForm]].
 *
 * [[PDFRadioGroup]] fields are collections of radio buttons. The purpose of a
 * radio group is to enable users to select one option from a set of mutually
 * exclusive choices. Each choice in a radio group is represented by a radio
 * button. Radio buttons each have two states: `on` and `off`. At most one
 * radio button in a group may be in the `on` state at any time. Users can
 * click on a radio button to select it (and thereby automatically deselect any
 * other radio button that might have already been selected). Some radio
 * groups allow users to toggle a selected radio button `off` by clicking on
 * it (see [[PDFRadioGroup.isOffToggleable]]).
 *
 * Note that some radio groups allow multiple radio buttons to be in the `on`
 * state at the same type **if** they represent the same underlying value (see
 * [[PDFRadioGroup.isMutuallyExclusive]]).
 */ var $6d3b7571b9a9d3dc$var$PDFRadioGroup = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFRadioGroup, _super);
    function PDFRadioGroup(acroRadioButton, ref, doc) {
        var _this = _super.call(this, acroRadioButton, ref, doc) || this;
        (0, $fYigW.assertIs)(acroRadioButton, 'acroRadioButton', [
            [
                (0, $03ea7ddf4d3e4901$export$2e2bcd8739ae039),
                'PDFAcroRadioButton'
            ]
        ]);
        _this.acroField = acroRadioButton;
        return _this;
    }
    /**
     * Get the list of available options for this radio group. Each option is
     * represented by a radio button. These radio buttons are displayed at
     * various locations in the document, potentially on different pages (though
     * typically they are stacked horizontally or vertically on the same page).
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const options = radioGroup.getOptions()
     * console.log('Radio Group options:', options)
     * ```
     * @returns The options for this radio group.
     */ PDFRadioGroup.prototype.getOptions = function() {
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var exportOptions = new Array(exportValues.length);
            for(var idx = 0, len = exportValues.length; idx < len; idx++)exportOptions[idx] = exportValues[idx].decodeText();
            return exportOptions;
        }
        var onValues = this.acroField.getOnValues();
        var onOptions = new Array(onValues.length);
        for(var idx = 0, len = onOptions.length; idx < len; idx++)onOptions[idx] = onValues[idx].decodeText();
        return onOptions;
    };
    /**
     * Get the selected option for this radio group. The selected option is
     * represented by the radio button in this group that is turned on. At most
     * one radio button in a group can be selected. If no buttons in this group
     * are selected, `undefined` is returned.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * const selected = radioGroup.getSelected()
     * console.log('Selected radio button:', selected)
     * ```
     * @returns The selected option for this radio group.
     */ PDFRadioGroup.prototype.getSelected = function() {
        var value = this.acroField.getValue();
        if (value === (0, $btXS2.default).of('Off')) return undefined;
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            var onValues = this.acroField.getOnValues();
            for(var idx = 0, len = onValues.length; idx < len; idx++){
                if (onValues[idx] === value) return exportValues[idx].decodeText();
            }
        }
        return value.decodeText();
    };
    // // TODO: Figure out why this seems to crash Acrobat. Maybe it's because we
    // //       aren't removing the widget reference from the page's Annots?
    // removeOption(option: string) {
    //   assertIs(option, 'option', ['string']);
    //   // TODO: Assert is valid `option`!
    //   const onValues = this.acroField.getOnValues();
    //   const exportValues = this.acroField.getExportValues();
    //   if (exportValues) {
    //     for (let idx = 0, len = exportValues.length; idx < len; idx++) {
    //       if (exportValues[idx].decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   } else {
    //     for (let idx = 0, len = onValues.length; idx < len; idx++) {
    //       const value = onValues[idx];
    //       if (value.decodeText() === option) {
    //         this.acroField.removeWidget(idx);
    //         this.acroField.removeExportValue(idx);
    //       }
    //     }
    //   }
    // }
    /**
     * Select an option for this radio group. This operation is analogous to a
     * human user clicking one of the radio buttons in this group via a PDF
     * reader to toggle it on. This method will update the underlying state of
     * the radio group to indicate which option has been selected. PDF libraries
     * and readers will be able to extract this value from the saved document and
     * determine which option was selected.
     *
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('best.superhero.radioGroup')
     * radioGroup.select('One Punch Man')
     * ```
     *
     * This method will mark this radio group as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated appearance
     * streams will display a dot inside the widget of this check box field
     * that represents the selected option.
     *
     * @param option The option to be selected.
     */ PDFRadioGroup.prototype.select = function(option) {
        (0, $fYigW.assertIs)(option, 'option', [
            'string'
        ]);
        var validOptions = this.getOptions();
        (0, $fYigW.assertIsOneOf)(option, 'option', validOptions);
        this.markAsDirty();
        var onValues = this.acroField.getOnValues();
        var exportValues = this.acroField.getExportValues();
        if (exportValues) {
            for(var idx = 0, len = exportValues.length; idx < len; idx++)if (exportValues[idx].decodeText() === option) this.acroField.setValue(onValues[idx]);
        } else for(var idx = 0, len = onValues.length; idx < len; idx++){
            var value = onValues[idx];
            if (value.decodeText() === option) this.acroField.setValue(value);
        }
    };
    /**
     * Clear any selected option for this dropdown. This will result in all
     * radio buttons in this group being toggled off. This method will update
     * the underlying state of the dropdown to indicate that no radio buttons
     * have been selected.
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.clear()
     * ```
     * This method will mark this radio group as dirty. See
     * [[PDFRadioGroup.select]] for more details about what this means.
     */ PDFRadioGroup.prototype.clear = function() {
        this.markAsDirty();
        this.acroField.setValue((0, $btXS2.default).of('Off'));
    };
    /**
     * Returns `true` if users can click on radio buttons in this group to toggle
     * them off. The alternative is that once a user clicks on a radio button
     * to select it, the only way to deselect it is by selecting on another radio
     * button in the group. See [[PDFRadioGroup.enableOffToggling]] and
     * [[PDFRadioGroup.disableOffToggling]]. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isOffToggleable()) console.log('Off toggling is enabled')
     * ```
     */ PDFRadioGroup.prototype.isOffToggleable = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).NoToggleToOff);
    };
    /**
     * Allow users to click on selected radio buttons in this group to toggle
     * them off. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableOffToggling()
     * ```
     * > **NOTE:** This feature is documented in the PDF specification
     * > (Table 226). However, most PDF readers do not respect this option and
     * > prevent users from toggling radio buttons off even when it is enabled.
     * > At the time of this writing (9/6/2020) Mac's Preview software did
     * > respect the option. Adobe Acrobat, Foxit Reader, and Google Chrome did
     * > not.
     */ PDFRadioGroup.prototype.enableOffToggling = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).NoToggleToOff, false);
    };
    /**
     * Prevent users from clicking on selected radio buttons in this group to
     * toggle them off. Clicking on a selected radio button will have no effect.
     * The only way to deselect a selected radio button is to click on a
     * different radio button in the group. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableOffToggling()
     * ```
     */ PDFRadioGroup.prototype.disableOffToggling = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).NoToggleToOff, true);
    };
    /**
     * Returns `true` if the radio buttons in this group are mutually exclusive.
     * This means that when the user selects a radio button, only that specific
     * button will be turned on. Even if other radio buttons in the group
     * represent the same value, they will not be enabled. The alternative to
     * this is that clicking a radio button will select that button along with
     * any other radio buttons in the group that share the same value. See
     * [[PDFRadioGroup.enableMutualExclusion]] and
     * [[PDFRadioGroup.disableMutualExclusion]].
     * For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.isMutuallyExclusive()) console.log('Mutual exclusion is enabled')
     * ```
     */ PDFRadioGroup.prototype.isMutuallyExclusive = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).RadiosInUnison);
    };
    /**
     * When the user clicks a radio button in this group it will be selected. In
     * addition, any other radio buttons in this group that share the same
     * underlying value will also be selected. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.enableMutualExclusion()
     * ```
     * Note that this option must be enabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.enableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).RadiosInUnison, false);
    };
    /**
     * When the user clicks a radio button in this group only it will be selected.
     * No other radio buttons in the group will be selected, even if they share
     * the same underlying value. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.disableMutualExclusion()
     * ```
     * Note that this option must be disabled prior to adding options to the
     * radio group. It does not currently apply retroactively to existing
     * radio buttons in the group.
     */ PDFRadioGroup.prototype.disableMutualExclusion = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$59f660e89ffb4f8a).RadiosInUnison, true);
    };
    /**
     * Add a new radio button to this group on the specified page. For example:
     * ```js
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('best.gundam')
     *
     * const options = {
     *   x: 50,
     *   width: 25,
     *   height: 25,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     * }
     *
     * radioGroup.addOptionToPage('Exia', page, { ...options, y: 50 })
     * radioGroup.addOptionToPage('Dynames', page, { ...options, y: 110 })
     * ```
     * This will create a new radio button widget for this radio group field.
     * @param option The option that the radio button widget represents.
     * @param page The page to which the radio button widget should be added.
     * @param options The options to be used when adding the radio button widget.
     */ PDFRadioGroup.prototype.addOptionToPage = function(option, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        (0, $fYigW.assertIs)(option, 'option', [
            'string'
        ]);
        (0, $fYigW.assertIs)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        // Create a widget for this radio button
        var widget = this.createWidget({
            x: (_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options === null || options === void 0 ? void 0 : options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options === null || options === void 0 ? void 0 : options.width) !== null && _c !== void 0 ? _c : 50,
            height: (_d = options === null || options === void 0 ? void 0 : options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: (_e = options === null || options === void 0 ? void 0 : options.textColor) !== null && _e !== void 0 ? _e : (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_f = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _f !== void 0 ? _f : (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(1, 1, 1),
            borderColor: (_g = options === null || options === void 0 ? void 0 : options.borderColor) !== null && _g !== void 0 ? _g : (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0),
            borderWidth: (_h = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _h !== void 0 ? _h : 1,
            rotate: (_j = options === null || options === void 0 ? void 0 : options.rotate) !== null && _j !== void 0 ? _j : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        var apStateValue = this.acroField.addWidgetWithOpt(widgetRef, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(option), !this.isMutuallyExclusive());
        // Set appearance streams for widget
        widget.setAppearanceState((0, $btXS2.default).of('Off'));
        this.updateWidgetAppearance(widget, apStateValue);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if any of this group's radio button widgets do not have an
     * appearance stream for their current state. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * if (radioGroup.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this radio group needs an appearance update.
     */ PDFRadioGroup.prototype.needsAppearancesUpdate = function() {
        var _a;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var state = widget.getAppearanceState();
            var normal = (_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal;
            if (!(normal instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039))) return true;
            if (state && !normal.has(state)) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the default appearance provider for radio groups. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.defaultUpdateAppearances()
     * ```
     */ PDFRadioGroup.prototype.defaultUpdateAppearances = function() {
        this.updateAppearances();
    };
    // rg.updateAppearances((field: any, widget: any) => {
    //   assert(field === rg);
    //   assert(widget instanceof PDFWidgetAnnotation);
    //   return { on: [...rectangle, ...circle], off: [...rectangle, ...circle] };
    // });
    /**
     * Update the appearance streams for each of this group's radio button widgets
     * using the given appearance provider. If no `provider` is passed, the
     * default appearance provider for radio groups will be used. For example:
     * ```js
     * const radioGroup = form.getRadioGroup('some.radioGroup.field')
     * radioGroup.updateAppearances((field, widget) => {
     *   ...
     *   return {
     *     normal: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *     down: { on: drawRadioButton(...), off: drawRadioButton(...) },
     *   }
     * })
     * ```
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFRadioGroup.prototype.updateAppearances = function(provider) {
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var onValue = widget.getOnValue();
            if (!onValue) continue;
            this.updateWidgetAppearance(widget, onValue, provider);
        }
    };
    PDFRadioGroup.prototype.updateWidgetAppearance = function(widget, onValue, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$6440094330a99ef8);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget));
        this.updateOnOffWidgetAppearance(widget, onValue, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getOptionList]] method, which will create an
     * > instance of [[PDFOptionList]] for you.
     *
     * Create an instance of [[PDFOptionList]] from an existing acroRadioButton
     * and ref
     *
     * @param acroRadioButton The underlying `PDFAcroRadioButton` for this
     *                        radio group.
     * @param ref The unique reference for this radio group.
     * @param doc The document to which this radio group will belong.
     */ PDFRadioGroup.of = function(acroRadioButton, ref, doc) {
        return new PDFRadioGroup(acroRadioButton, ref, doc);
    };
    return PDFRadioGroup;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $6d3b7571b9a9d3dc$export$2e2bcd8739ae039 = $6d3b7571b9a9d3dc$var$PDFRadioGroup;



var $70JnX = parcelRequire("70JnX");


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a signature field of a [[PDFForm]].
 *
 * [[PDFSignature]] fields are digital signatures. `pdf-lib` does not
 * currently provide any specialized APIs for creating digital signatures or
 * reading the contents of existing digital signatures.
 */ var $eb55c83d847e5305$var$PDFSignature = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFSignature, _super);
    function PDFSignature(acroSignature, ref, doc) {
        var _this = _super.call(this, acroSignature, ref, doc) || this;
        (0, $fYigW.assertIs)(acroSignature, 'acroSignature', [
            [
                (0, $8236815884bcced8$export$2e2bcd8739ae039),
                'PDFAcroSignature'
            ]
        ]);
        _this.acroField = acroSignature;
        return _this;
    }
    PDFSignature.prototype.needsAppearancesUpdate = function() {
        return false;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getSignature]] method, which will create an
     * > instance of [[PDFSignature]] for you.
     *
     * Create an instance of [[PDFSignature]] from an existing acroSignature and
     * ref
     *
     * @param acroSignature The underlying `PDFAcroSignature` for this signature.
     * @param ref The unique reference for this signature.
     * @param doc The document to which this signature will belong.
     */ PDFSignature.of = function(acroSignature, ref, doc) {
        return new PDFSignature(acroSignature, ref, doc);
    };
    return PDFSignature;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $eb55c83d847e5305$export$2e2bcd8739ae039 = $eb55c83d847e5305$var$PDFSignature;



var $70JnX = parcelRequire("70JnX");










parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a text field of a [[PDFForm]].
 *
 * [[PDFTextField]] fields are boxes that display text entered by the user. The
 * purpose of a text field is to enable users to enter text or view text values
 * in the document prefilled by software. Users can click on a text field and
 * input text via their keyboard. Some text fields allow multiple lines of text
 * to be entered (see [[PDFTextField.isMultiline]]).
 */ var $88d35ffb92c3ce20$var$PDFTextField = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFTextField, _super);
    function PDFTextField(acroText, ref, doc) {
        var _this = _super.call(this, acroText, ref, doc) || this;
        (0, $fYigW.assertIs)(acroText, 'acroText', [
            [
                (0, $d76660bc35a07b3f$export$2e2bcd8739ae039),
                'PDFAcroText'
            ]
        ]);
        _this.acroField = acroText;
        return _this;
    }
    /**
     * Get the text that this field contains. This text is visible to users who
     * view this field in a PDF reader.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const text = textField.getText()
     * console.log('Text field contents:', text)
     * ```
     *
     * Note that if this text field contains no underlying value, `undefined`
     * will be returned. Text fields may also contain an underlying value that
     * is simply an empty string (`''`). This detail is largely irrelevant for
     * most applications. In general, you'll want to treat both cases the same
     * way and simply consider the text field to be empty. In either case, the
     * text field will appear empty to users when viewed in a PDF reader.
     *
     * An error will be thrown if this is a rich text field. `pdf-lib` does not
     * support reading rich text fields. Nor do most PDF readers and writers.
     * Rich text fields are based on XFA (XML Forms Architecture). Relatively few
     * PDFs use rich text fields or XFA. Unlike PDF itself, XFA is not an ISO
     * standard. XFA has been deprecated in PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     *
     * @returns The text contained in this text field.
     */ PDFTextField.prototype.getText = function() {
        var value = this.acroField.getValue();
        if (!value && this.isRichFormatted()) throw new (0, $071c8956483bdcac$export$f2fed572e1ed57ab)(this.getName());
        return value === null || value === void 0 ? void 0 : value.decodeText();
    };
    /**
     * Set the text for this field. This operation is analogous to a human user
     * clicking on the text field in a PDF reader and typing in text via their
     * keyboard. This method will update the underlying state of the text field
     * to indicate what text has been set. PDF libraries and readers will be able
     * to extract these values from the saved document and determine what text
     * was set.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('best.superhero.text.field')
     * textField.setText('One Punch Man')
     * ```
     *
     * This method will mark this text field as dirty, causing its appearance
     * streams to be updated when either [[PDFDocument.save]] or
     * [[PDFForm.updateFieldAppearances]] is called. The updated streams will
     * display the text this field contains inside the widgets of this text
     * field.
     *
     * **IMPORTANT:** The default font used to update appearance streams is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if this field contains text outside
     * the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing it to
     * [[PDFForm.updateFieldAppearances]] or [[PDFTextField.updateAppearances]]
     * allows you to generate appearance streams with characters outside the
     * latin alphabet (assuming the custom font supports them).
     *
     * If this is a rich text field, it will be converted to a standard text
     * field in order to set the text. `pdf-lib` does not support writing rich
     * text strings. Nor do most PDF readers and writers. See
     * [[PDFTextField.getText]] for more information about rich text fields and
     * their deprecation in PDF 2.0.
     *
     * @param text The text this field should contain.
     */ PDFTextField.prototype.setText = function(text) {
        (0, $fYigW.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        var maxLength = this.getMaxLength();
        if (maxLength !== undefined && text && text.length > maxLength) throw new (0, $071c8956483bdcac$export$1577e99040d42609)(text.length, maxLength, this.getName());
        this.markAsDirty();
        this.disableRichFormatting();
        if (text) this.acroField.setValue((0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(text));
        else this.acroField.removeValue();
    };
    /**
     * Get the alignment for this text field. This value represents the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const alignment = textField.getAlignment()
     * if (alignment === TextAlignment.Left) console.log('Text is left justified')
     * if (alignment === TextAlignment.Center) console.log('Text is centered')
     * if (alignment === TextAlignment.Right) console.log('Text is right justified')
     * ```
     * @returns The alignment of this text field.
     */ PDFTextField.prototype.getAlignment = function() {
        var quadding = this.acroField.getQuadding();
        // prettier-ignore
        return quadding === 0 ? (0, $40510ba2913036d8$export$84b2d1b68830363f).Left : quadding === 1 ? (0, $40510ba2913036d8$export$84b2d1b68830363f).Center : quadding === 2 ? (0, $40510ba2913036d8$export$84b2d1b68830363f).Right : (0, $40510ba2913036d8$export$84b2d1b68830363f).Left;
    };
    /**
     * Set the alignment for this text field. This will determine the
     * justification of the text when it is displayed to the user in PDF readers.
     * There are three possible alignments: left, center, and right. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Text will be left justified when displayed
     * textField.setAlignment(TextAlignment.Left)
     *
     * // Text will be centered when displayed
     * textField.setAlignment(TextAlignment.Center)
     *
     * // Text will be right justified when displayed
     * textField.setAlignment(TextAlignment.Right)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param alignment The alignment for this text field.
     */ PDFTextField.prototype.setAlignment = function(alignment) {
        (0, $fYigW.assertIsOneOf)(alignment, 'alignment', (0, $40510ba2913036d8$export$84b2d1b68830363f));
        this.markAsDirty();
        this.acroField.setQuadding(alignment);
    };
    /**
     * Get the maximum length of this field. This value represents the maximum
     * number of characters that can be typed into this field by the user. If
     * this field does not have a maximum length, `undefined` is returned.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * const maxLength = textField.getMaxLength()
     * if (maxLength === undefined) console.log('No max length')
     * else console.log(`Max length is ${maxLength}`)
     * ```
     * @returns The maximum number of characters allowed in this field, or
     *          `undefined` if no limit exists.
     */ PDFTextField.prototype.getMaxLength = function() {
        return this.acroField.getMaxLength();
    };
    /**
     * Set the maximum length of this field. This limits the number of characters
     * that can be typed into this field by the user. This also limits the length
     * of the string that can be passed to [[PDFTextField.setText]]. This limit
     * can be removed by passing `undefined` as `maxLength`. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     *
     * // Allow between 0 and 5 characters to be entered
     * textField.setMaxLength(5)
     *
     * // Allow any number of characters to be entered
     * textField.setMaxLength(undefined)
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     * @param maxLength The maximum number of characters allowed in this field, or
     *                  `undefined` to remove the limit.
     */ PDFTextField.prototype.setMaxLength = function(maxLength) {
        (0, $fYigW.assertRangeOrUndefined)(maxLength, 'maxLength', 0, Number.MAX_SAFE_INTEGER);
        this.markAsDirty();
        if (maxLength === undefined) this.acroField.removeMaxLength();
        else {
            var text = this.getText();
            if (text && text.length > maxLength) throw new (0, $071c8956483bdcac$export$6da6c372180e79b0)(text.length, maxLength, this.getName());
            this.acroField.setMaxLength(maxLength);
        }
    };
    /**
     * Remove the maximum length for this text field. This allows any number of
     * characters to be typed into this field by the user. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.removeMaxLength()
     * ```
     * Calling this method is equivalent to passing `undefined` to
     * [[PDFTextField.setMaxLength]].
     */ PDFTextField.prototype.removeMaxLength = function() {
        this.markAsDirty();
        this.acroField.removeMaxLength();
    };
    /**
     * Display an image inside the bounds of this text field's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const textField = form.getTextField('some.text.field')
     * textField.setImage(pngImage)
     * ```
     * This will update the appearances streams for each of this text field's widgets.
     * @param image The image that should be displayed.
     */ PDFTextField.prototype.setImage = function(image) {
        var fieldAlignment = this.getAlignment();
        // prettier-ignore
        var alignment = fieldAlignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Center ? (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Center : fieldAlignment === (0, $40510ba2913036d8$export$84b2d1b68830363f).Right ? (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Right : (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Left;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this text field. Font sizes
     * may be integer or floating point numbers. Supplying a negative font size
     * will cause this method to throw an error.
     *
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.setFontSize(4)
     * textField.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFTextField.prototype.setFontSize = function(fontSize) {
        (0, $fYigW.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Returns `true` if each line of text is shown on a new line when this
     * field is displayed in a PDF reader. The alternative is that all lines of
     * text are merged onto a single line when displayed. See
     * [[PDFTextField.enableMultiline]] and [[PDFTextField.disableMultiline]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isMultiline()) console.log('Multiline is enabled')
     * ```
     * @returns Whether or not this is a multiline text field.
     */ PDFTextField.prototype.isMultiline = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Multiline);
    };
    /**
     * Display each line of text on a new line when this field is displayed in a
     * PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Multiline, true);
    };
    /**
     * Display each line of text on the same line when this field is displayed
     * in a PDF reader. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableMultiline()
     * ```
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableMultiline = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Multiline, false);
    };
    /**
     * Returns `true` if this is a password text field. This means that the field
     * is intended for storing a secure password. See
     * [[PDFTextField.enablePassword]] and [[PDFTextField.disablePassword]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isPassword()) console.log('Password is enabled')
     * ```
     * @returns Whether or not this is a password text field.
     */ PDFTextField.prototype.isPassword = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Password);
    };
    /**
     * Indicate that this text field is intended for storing a secure password.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enablePassword()
     * ```
     * Values entered into password text fields should not be displayed on the
     * screen by PDF readers. Most PDF readers will display the value as
     * asterisks or bullets. PDF readers should never store values entered by the
     * user into password text fields. Similarly, applications should not
     * write data to a password text field.
     *
     * **Please note that this method does not cause entered values to be
     * encrypted or secured in any way! It simply sets a flag that PDF software
     * and readers can access to determine the _purpose_ of this field.**
     */ PDFTextField.prototype.enablePassword = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Password, true);
    };
    /**
     * Indicate that this text field is **not** intended for storing a secure
     * password. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disablePassword()
     * ```
     */ PDFTextField.prototype.disablePassword = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Password, false);
    };
    /**
     * Returns `true` if the contents of this text field represent a file path.
     * See [[PDFTextField.enableFileSelection]] and
     * [[PDFTextField.disableFileSelection]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isFileSelector()) console.log('Is a file selector')
     * ```
     * @returns Whether or not this field should contain file paths.
     */ PDFTextField.prototype.isFileSelector = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).FileSelect);
    };
    /**
     * Indicate that this text field is intended to store a file path. The
     * contents of the file stored at that path should be submitted as the value
     * of the field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableFileSelection()
     * ```
     */ PDFTextField.prototype.enableFileSelection = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).FileSelect, true);
    };
    /**
     * Indicate that this text field is **not** intended to store a file path.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableFileSelection()
     * ```
     */ PDFTextField.prototype.disableFileSelection = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).FileSelect, false);
    };
    /**
     * Returns `true` if the text entered in this field should be spell checked
     * by PDF readers. See [[PDFTextField.enableSpellChecking]] and
     * [[PDFTextField.disableSpellChecking]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isSpellChecked()) console.log('Spell checking is enabled')
     * ```
     * @returns Whether or not this field should be spell checked.
     */ PDFTextField.prototype.isSpellChecked = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotSpellCheck);
    };
    /**
     * Allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableSpellChecking()
     * ```
     */ PDFTextField.prototype.enableSpellChecking = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotSpellCheck, false);
    };
    /**
     * Do not allow PDF readers to spell check the text entered in this field.
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableSpellChecking()
     * ```
     */ PDFTextField.prototype.disableSpellChecking = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotSpellCheck, true);
    };
    /**
     * Returns `true` if PDF readers should allow the user to scroll the text
     * field when its contents do not fit within the field's view bounds. See
     * [[PDFTextField.enableScrolling]] and [[PDFTextField.disableScrolling]].
     * For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isScrollable()) console.log('Scrolling is enabled')
     * ```
     * @returns Whether or not the field is scrollable in PDF readers.
     */ PDFTextField.prototype.isScrollable = function() {
        return !this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotScroll);
    };
    /**
     * Allow PDF readers to present a scroll bar to the user when the contents
     * of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableScrolling()
     * ```
     * A horizontal scroll bar should be shown for singleline fields. A vertical
     * scroll bar should be shown for multiline fields.
     */ PDFTextField.prototype.enableScrolling = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotScroll, false);
    };
    /**
     * Do not allow PDF readers to present a scroll bar to the user when the
     * contents of this text field do not fit within its view bounds. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableScrolling()
     * ```
     */ PDFTextField.prototype.disableScrolling = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).DoNotScroll, true);
    };
    /**
     * Returns `true` if this is a combed text field. This means that the field
     * is split into `n` equal size cells with one character in each (where `n`
     * is equal to the max length of the text field). The result is that all
     * characters in this field are displayed an equal distance apart from one
     * another. See [[PDFTextField.enableCombing]] and
     * [[PDFTextField.disableCombing]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isCombed()) console.log('Combing is enabled')
     * ```
     * Note that in order for a text field to be combed, the following must be
     * true (in addition to enabling combing):
     * * It must not be a multiline field (see [[PDFTextField.isMultiline]])
     * * It must not be a password field (see [[PDFTextField.isPassword]])
     * * It must not be a file selector field (see [[PDFTextField.isFileSelector]])
     * * It must have a max length defined (see [[PDFTextField.setMaxLength]])
     * @returns Whether or not this field is combed.
     */ PDFTextField.prototype.isCombed = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Comb) && !this.isMultiline() && !this.isPassword() && !this.isFileSelector() && this.getMaxLength() !== undefined;
    };
    /**
     * Split this field into `n` equal size cells with one character in each
     * (where `n` is equal to the max length of the text field). This will cause
     * all characters in the field to be displayed an equal distance apart from
     * one another. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableCombing()
     * ```
     *
     * In addition to calling this method, text fields must have a max length
     * defined in order to be combed (see [[PDFTextField.setMaxLength]]).
     *
     * This method will also call the following three methods internally:
     * * [[PDFTextField.disableMultiline]]
     * * [[PDFTextField.disablePassword]]
     * * [[PDFTextField.disableFileSelection]]
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.enableCombing = function() {
        if (this.getMaxLength() === undefined) {
            var msg = "PDFTextFields must have a max length in order to be combed";
            console.warn(msg);
        }
        this.markAsDirty();
        this.disableMultiline();
        this.disablePassword();
        this.disableFileSelection();
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Comb, true);
    };
    /**
     * Turn off combing for this text field. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableCombing()
     * ```
     * See [[PDFTextField.isCombed]] and [[PDFTextField.enableCombing]] for more
     * information about what combing is.
     *
     * This method will mark this text field as dirty. See
     * [[PDFTextField.setText]] for more details about what this means.
     */ PDFTextField.prototype.disableCombing = function() {
        this.markAsDirty();
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).Comb, false);
    };
    /**
     * Returns `true` if this text field contains rich text. See
     * [[PDFTextField.enableRichFormatting]] and
     * [[PDFTextField.disableRichFormatting]]. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.isRichFormatted()) console.log('Rich formatting enabled')
     * ```
     * @returns Whether or not this field contains rich text.
     */ PDFTextField.prototype.isRichFormatted = function() {
        return this.acroField.hasFlag((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).RichText);
    };
    /**
     * Indicate that this field contains XFA data - or rich text. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.enableRichFormatting()
     * ```
     * Note that `pdf-lib` does not support reading or writing rich text fields.
     * Nor do most PDF readers and writers. Rich text fields are based on XFA
     * (XML Forms Architecture). Relatively few PDFs use rich text fields or XFA.
     * Unlike PDF itself, XFA is not an ISO standard. XFA has been deprecated in
     * PDF 2.0:
     * * https://en.wikipedia.org/wiki/XFA
     * * http://blog.pdfshareforms.com/pdf-2-0-release-bid-farewell-xfa-forms/
     */ PDFTextField.prototype.enableRichFormatting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).RichText, true);
    };
    /**
     * Indicate that this is a standard text field that does not XFA data (rich
     * text). For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * textField.disableRichFormatting()
     * ```
     */ PDFTextField.prototype.disableRichFormatting = function() {
        this.acroField.setFlagTo((0, $248d91c4d95d4c44$export$389fc7b97397dc8b).RichText, false);
    };
    /**
     * Show this text field on the specified page. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('best.gundam')
     * textField.setText('Exia')
     *
     * textField.addToPage(page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this text field.
     * @param page The page to which this text field widget should be added.
     * @param options The options to be used when adding this text field widget.
     */ PDFTextField.prototype.addToPage = function(page, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        (0, $fYigW.assertIs)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        if (!options) options = {};
        if (!('textColor' in options)) options.textColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('backgroundColor' in options)) options.backgroundColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(1, 1, 1);
        if (!('borderColor' in options)) options.borderColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        if (!('borderWidth' in options)) options.borderWidth = 1;
        // Create a widget for this text field
        var widget = this.createWidget({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : 0,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : 0,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 200,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 50,
            textColor: options.textColor,
            backgroundColor: options.backgroundColor,
            borderColor: options.borderColor,
            borderWidth: (_e = options.borderWidth) !== null && _e !== void 0 ? _e : 0,
            rotate: (_f = options.rotate) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            hidden: options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_g = options.font) !== null && _g !== void 0 ? _g : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this text field has been marked as dirty, or if any of
     * this text field's widgets do not have an appearance stream. For example:
     * ```js
     * const textField = form.getTextField('some.text.field')
     * if (textField.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this text field needs an appearance update.
     */ PDFTextField.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the default appearance provider for text fields. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFTextField.prototype.defaultUpdateAppearances = function(font) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this text field's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for text fields will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const textField = form.getTextField('some.text.field')
     * textField.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return drawTextField(...)
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFTextField.prototype.updateAppearances = function(font, provider) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
        this.markAsClean();
    };
    PDFTextField.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$42ba95e6b8df3d7);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getTextField]] method, which will create an
     * > instance of [[PDFTextField]] for you.
     *
     * Create an instance of [[PDFTextField]] from an existing acroText and ref
     *
     * @param acroText The underlying `PDFAcroText` for this text field.
     * @param ref The unique reference for this text field.
     * @param doc The document to which this text field will belong.
     */ PDFTextField.of = function(acroText, ref, doc) {
        return new PDFTextField(acroText, ref, doc);
    };
    return PDFTextField;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $88d35ffb92c3ce20$export$2e2bcd8739ae039 = $88d35ffb92c3ce20$var$PDFTextField;




var $3f3628f4443054b9$export$7dcb046109e65a3d;
(function(StandardFonts) {
    StandardFonts["Courier"] = "Courier";
    StandardFonts["CourierBold"] = "Courier-Bold";
    StandardFonts["CourierOblique"] = "Courier-Oblique";
    StandardFonts["CourierBoldOblique"] = "Courier-BoldOblique";
    StandardFonts["Helvetica"] = "Helvetica";
    StandardFonts["HelveticaBold"] = "Helvetica-Bold";
    StandardFonts["HelveticaOblique"] = "Helvetica-Oblique";
    StandardFonts["HelveticaBoldOblique"] = "Helvetica-BoldOblique";
    StandardFonts["TimesRoman"] = "Times-Roman";
    StandardFonts["TimesRomanBold"] = "Times-Bold";
    StandardFonts["TimesRomanItalic"] = "Times-Italic";
    StandardFonts["TimesRomanBoldItalic"] = "Times-BoldItalic";
    StandardFonts["Symbol"] = "Symbol";
    StandardFonts["ZapfDingbats"] = "ZapfDingbats";
})($3f3628f4443054b9$export$7dcb046109e65a3d || ($3f3628f4443054b9$export$7dcb046109e65a3d = {}));





var $btXS2 = parcelRequire("btXS2");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $cLyfO = parcelRequire("cLyfO");
/**
 * Represents the interactive form of a [[PDFDocument]].
 *
 * Interactive forms (sometimes called _AcroForms_) are collections of fields
 * designed to gather information from a user. A PDF document may contains any
 * number of fields that appear on various pages, all of which make up a single,
 * global interactive form spanning the entire document. This means that
 * instances of [[PDFDocument]] shall contain at most one [[PDFForm]].
 *
 * The fields of an interactive form are represented by [[PDFField]] instances.
 */ var $71885f85fdaea8a8$var$PDFForm = /** @class */ function() {
    function PDFForm(acroForm, doc) {
        var _this = this;
        this.embedDefaultFont = function() {
            return _this.doc.embedStandardFont((0, $3f3628f4443054b9$export$7dcb046109e65a3d).Helvetica);
        };
        (0, $fYigW.assertIs)(acroForm, 'acroForm', [
            [
                (0, $e870fb8cfe287dc6$export$2e2bcd8739ae039),
                'PDFAcroForm'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.acroForm = acroForm;
        this.doc = doc;
        this.dirtyFields = new Set();
        this.defaultFontCache = (0, $cLyfO.default).populatedBy(this.embedDefaultFont);
    }
    /**
     * Returns `true` if this [[PDFForm]] has XFA data. Most PDFs with form
     * fields do not use XFA as it is not widely supported by PDF readers.
     *
     * > `pdf-lib` does not support creation, modification, or reading of XFA
     * > fields.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * if (form.hasXFA()) console.log('PDF has XFA data')
     * ```
     * @returns Whether or not this form has XFA data.
     */ PDFForm.prototype.hasXFA = function() {
        return this.acroForm.dict.has((0, $btXS2.default).of('XFA'));
    };
    /**
     * Disconnect the XFA data from this [[PDFForm]] (if any exists). This will
     * force readers to fallback to standard fields if the [[PDFDocument]]
     * contains any. For example:
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * form.deleteXFA()
     * ```
     */ PDFForm.prototype.deleteXFA = function() {
        this.acroForm.dict.delete((0, $btXS2.default).of('XFA'));
    };
    /**
     * Get all fields contained in this [[PDFForm]]. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns An array of all fields in this form.
     */ PDFForm.prototype.getFields = function() {
        var allFields = this.acroForm.getAllFields();
        var fields = [];
        for(var idx = 0, len = allFields.length; idx < len; idx++){
            var _a = allFields[idx], acroField = _a[0], ref = _a[1];
            var field = $71885f85fdaea8a8$var$convertToPDFField(acroField, ref, this.doc);
            if (field) fields.push(field);
        }
        return fields;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getFieldMaybe('Page1.Foo.Bar[0]')
     * if (field) console.log('Field exists!')
     * ```
     * @param name A fully qualified field name.
     * @returns The field with the specified name, if one exists.
     */ PDFForm.prototype.getFieldMaybe = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.getName() === name) return field;
        }
        return undefined;
    };
    /**
     * Get the field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('Page1.Foo.Bar[0]')
     * ```
     * If no field exists with the provided name, an error will be thrown.
     * @param name A fully qualified field name.
     * @returns The field with the specified name.
     */ PDFForm.prototype.getField = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getFieldMaybe(name);
        if (field) return field;
        throw new (0, $071c8956483bdcac$export$5bc08baa4a027cbd)(name);
    };
    /**
     * Get the button field in this [[PDFForm]] with the given name. For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const button = form.getButton('Page1.Foo.Button[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a button.
     * @param name A fully qualified button name.
     * @returns The button with the specified name.
     */ PDFForm.prototype.getButton = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $888b65c91f171a50$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $888b65c91f171a50$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const checkBox = form.getCheckBox('Page1.Foo.CheckBox[0]')
     * checkBox.check()
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a check box.
     * @param name A fully qualified check box name.
     * @returns The check box with the specified name.
     */ PDFForm.prototype.getCheckBox = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $7634ed9aabad7442$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $7634ed9aabad7442$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const dropdown = form.getDropdown('Page1.Foo.Dropdown[0]')
     * const options = dropdown.getOptions()
     * dropdown.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a dropdown.
     * @param name A fully qualified dropdown name.
     * @returns The dropdown with the specified name.
     */ PDFForm.prototype.getDropdown = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $ef7090d16eb3bab5$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $ef7090d16eb3bab5$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const optionList = form.getOptionList('Page1.Foo.OptionList[0]')
     * const options = optionList.getOptions()
     * optionList.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not an option list.
     * @param name A fully qualified option list name.
     * @returns The option list with the specified name.
     */ PDFForm.prototype.getOptionList = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $f59ac96bda398d3a$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $f59ac96bda398d3a$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const radioGroup = form.getRadioGroup('Page1.Foo.RadioGroup[0]')
     * const options = radioGroup.getOptions()
     * radioGroup.select(options[0])
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a radio group.
     * @param name A fully qualified radio group name.
     * @returns The radio group with the specified name.
     */ PDFForm.prototype.getRadioGroup = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $6d3b7571b9a9d3dc$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $6d3b7571b9a9d3dc$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the signature field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const signature = form.getSignature('Page1.Foo.Signature[0]')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a signature.
     * @param name A fully qualified signature name.
     * @returns The signature with the specified name.
     */ PDFForm.prototype.getSignature = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $eb55c83d847e5305$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $eb55c83d847e5305$export$2e2bcd8739ae039), field);
    };
    /**
     * Get the text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const textField = form.getTextField('Page1.Foo.TextField[0]')
     * textField.setText('Are you designed to act or to be acted upon?')
     * ```
     * An error will be thrown if no field exists with the provided name, or if
     * the field exists but is not a text field.
     * @param name A fully qualified text field name.
     * @returns The text field with the specified name.
     */ PDFForm.prototype.getTextField = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var field = this.getField(name);
        if (field instanceof (0, $88d35ffb92c3ce20$export$2e2bcd8739ae039)) return field;
        throw new (0, $071c8956483bdcac$export$8909da6c566ff652)(name, (0, $88d35ffb92c3ce20$export$2e2bcd8739ae039), field);
    };
    /**
     * Create a new button field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('cool.new.button')
     *
     * button.addToPage('Do Stuff', font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new button.
     * @returns The new button field.
     */ PDFForm.prototype.createButton = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var button = (0, $3cdc71d89ed382a8$export$2e2bcd8739ae039).create(this.doc.context);
        button.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            button,
            button.ref
        ], nameParts.terminal);
        return (0, $888b65c91f171a50$export$2e2bcd8739ae039).of(button, button.ref, this.doc);
    };
    /**
     * Create a new check box field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const checkBox = form.createCheckBox('cool.new.checkBox')
     *
     * checkBox.addToPage(page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new check box.
     * @returns The new check box field.
     */ PDFForm.prototype.createCheckBox = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var checkBox = (0, $4e7ed1a5388e159e$export$2e2bcd8739ae039).create(this.doc.context);
        checkBox.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            checkBox,
            checkBox.ref
        ], nameParts.terminal);
        return (0, $7634ed9aabad7442$export$2e2bcd8739ae039).of(checkBox, checkBox.ref, this.doc);
    };
    /**
     * Create a new dropdown field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const dropdown = form.createDropdown('cool.new.dropdown')
     *
     * dropdown.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new dropdown.
     * @returns The new dropdown field.
     */ PDFForm.prototype.createDropdown = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var comboBox = (0, $b9e1c95445e29e3a$export$2e2bcd8739ae039).create(this.doc.context);
        comboBox.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            comboBox,
            comboBox.ref
        ], nameParts.terminal);
        return (0, $ef7090d16eb3bab5$export$2e2bcd8739ae039).of(comboBox, comboBox.ref, this.doc);
    };
    /**
     * Create a new option list field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const optionList = form.createOptionList('cool.new.optionList')
     *
     * optionList.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new option list.
     * @returns The new option list field.
     */ PDFForm.prototype.createOptionList = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var listBox = (0, $8b549563259095fa$export$2e2bcd8739ae039).create(this.doc.context);
        listBox.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            listBox,
            listBox.ref
        ], nameParts.terminal);
        return (0, $f59ac96bda398d3a$export$2e2bcd8739ae039).of(listBox, listBox.ref, this.doc);
    };
    /**
     * Create a new radio group field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const radioGroup = form.createRadioGroup('cool.new.radioGroup')
     *
     * radioGroup.addOptionToPage('is-dog', page, { y: 0 })
     * radioGroup.addOptionToPage('is-cat', page, { y: 75 })
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createRadioGroup = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var radioButton = (0, $03ea7ddf4d3e4901$export$2e2bcd8739ae039).create(this.doc.context);
        radioButton.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            radioButton,
            radioButton.ref
        ], nameParts.terminal);
        return (0, $6d3b7571b9a9d3dc$export$2e2bcd8739ae039).of(radioButton, radioButton.ref, this.doc);
    };
    /**
     * Create a new text field in this [[PDFForm]] with the given name.
     * For example:
     * ```js
     * const font = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const textField = form.createTextField('cool.new.textField')
     *
     * textField.addToPage(font, page)
     * ```
     * An error will be thrown if a field already exists with the provided name.
     * @param name The fully qualified name for the new radio group.
     * @returns The new radio group field.
     */ PDFForm.prototype.createTextField = function(name) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        var nameParts = $71885f85fdaea8a8$var$splitFieldName(name);
        var parent = this.findOrCreateNonTerminals(nameParts.nonTerminal);
        var text = (0, $d76660bc35a07b3f$export$2e2bcd8739ae039).create(this.doc.context);
        text.setPartialName(nameParts.terminal);
        $71885f85fdaea8a8$var$addFieldToParent(parent, [
            text,
            text.ref
        ], nameParts.terminal);
        return (0, $88d35ffb92c3ce20$export$2e2bcd8739ae039).of(text, text.ref, this.doc);
    };
    /**
     * Flatten all fields in this [[PDFForm]].
     *
     * Flattening a form field will take the current appearance for each of that
     * field's widgets and make them part of their page's content stream. All form
     * fields and annotations associated are then removed. Note that once a form
     * has been flattened its fields can no longer be accessed or edited.
     *
     * This operation is often used after filling form fields to ensure a
     * consistent appearance across different PDF readers and/or printers.
     * Another common use case is to copy a template document with form fields
     * into another document. In this scenario you would load the template
     * document, fill its fields, flatten it, and then copy its pages into the
     * recipient document - the filled fields will be copied over.
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * form.flatten();
     * ```
     */ PDFForm.prototype.flatten = function(options) {
        if (options === void 0) options = {
            updateFieldAppearances: true
        };
        if (options.updateFieldAppearances) this.updateFieldAppearances();
        var fields = this.getFields();
        for(var i = 0, lenFields = fields.length; i < lenFields; i++){
            var field = fields[i];
            var widgets = field.acroField.getWidgets();
            for(var j = 0, lenWidgets = widgets.length; j < lenWidgets; j++){
                var widget = widgets[j];
                var page = this.findWidgetPage(widget);
                var widgetRef = this.findWidgetAppearanceRef(field, widget);
                var xObjectKey = page.node.newXObject('FlatWidget', widgetRef);
                var rectangle = widget.getRectangle();
                var operators = (0, $70JnX.__spreadArrays)([
                    (0, $6bb514fadaf8543d$export$cb182c48e35739ac)(),
                    (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(rectangle.x, rectangle.y)
                ], (0, $cf63ff38d178ccc1$export$5dd9a0a87f38a2a6)((0, $70JnX.__assign)((0, $70JnX.__assign)({}, rectangle), {
                    rotation: 0
                })), [
                    (0, $6bb514fadaf8543d$export$382c18f8bccd9e2b)(xObjectKey),
                    (0, $6bb514fadaf8543d$export$10581a6f45bf75eb)()
                ]).filter(Boolean);
                page.pushOperators.apply(page, operators);
            }
            this.removeField(field);
        }
    };
    /**
     * Remove a field from this [[PDFForm]].
     *
     * For example:
     * ```js
     * const form = pdfDoc.getForm();
     * const ageField = form.getFields().find(x => x.getName() === 'Age');
     * form.removeField(ageField);
     * ```
     */ PDFForm.prototype.removeField = function(field) {
        var widgets = field.acroField.getWidgets();
        var pages = new Set();
        for(var i = 0, len = widgets.length; i < len; i++){
            var widget = widgets[i];
            var widgetRef = this.findWidgetAppearanceRef(field, widget);
            var page = this.findWidgetPage(widget);
            pages.add(page);
            page.node.removeAnnot(widgetRef);
        }
        pages.forEach(function(page) {
            return page.node.removeAnnot(field.ref);
        });
        this.acroForm.removeField(field.acroField);
        var fieldKids = field.acroField.normalizedEntries().Kids;
        var kidsCount = fieldKids.size();
        for(var childIndex = 0; childIndex < kidsCount; childIndex++){
            var child = fieldKids.get(childIndex);
            if (child instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039)) this.doc.context.delete(child);
        }
        this.doc.context.delete(field.ref);
    };
    /**
     * Update the appearance streams for all widgets of all fields in this
     * [[PDFForm]]. Appearance streams will only be created for a widget if it
     * does not have any existing appearance streams, or the field's value has
     * changed (e.g. by calling [[PDFTextField.setText]] or
     * [[PDFDropdown.select]]).
     *
     * For example:
     * ```js
     * const courier = await pdfDoc.embedFont(StandardFonts.Courier)
     * const form = pdfDoc.getForm()
     * form.updateFieldAppearances(courier)
     * ```
     *
     * **IMPORTANT:** The default value for the `font` parameter is
     * [[StandardFonts.Helvetica]]. Note that this is a WinAnsi font. This means
     * that encoding errors will be thrown if any fields contain text with
     * characters outside the WinAnsi character set (the latin alphabet).
     *
     * Embedding a custom font and passing that as the `font`
     * parameter allows you to generate appearance streams with non WinAnsi
     * characters (assuming your custom font supports them).
     *
     * > **NOTE:** The [[PDFDocument.save]] method will call this method to
     * > update appearances automatically if a form was accessed via the
     * > [[PDFDocument.getForm]] method prior to saving.
     *
     * @param font Optionally, the font to use when creating new appearances.
     */ PDFForm.prototype.updateFieldAppearances = function(font) {
        (0, $fYigW.assertOrUndefined)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        font = font !== null && font !== void 0 ? font : this.getDefaultFont();
        var fields = this.getFields();
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var field = fields[idx];
            if (field.needsAppearancesUpdate()) field.defaultUpdateAppearances(font);
        }
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsDirty(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsDirty = function(fieldRef) {
        (0, $fYigW.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.add(fieldRef);
    };
    /**
     * Mark a field as dirty. This will cause its appearance streams to not be
     * updated by [[PDFForm.updateFieldAppearances]].
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * form.markFieldAsClean(field.ref)
     * ```
     * @param fieldRef The reference to the field that should be marked.
     */ PDFForm.prototype.markFieldAsClean = function(fieldRef) {
        (0, $fYigW.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        this.dirtyFields.delete(fieldRef);
    };
    /**
     * Returns `true` is the specified field has been marked as dirty.
     * ```js
     * const form = pdfDoc.getForm()
     * const field = form.getField('foo.bar')
     * if (form.fieldIsDirty(field.ref)) console.log('Field is dirty')
     * ```
     * @param fieldRef The reference to the field that should be checked.
     * @returns Whether or not the specified field is dirty.
     */ PDFForm.prototype.fieldIsDirty = function(fieldRef) {
        (0, $fYigW.assertOrUndefined)(fieldRef, 'fieldRef', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        return this.dirtyFields.has(fieldRef);
    };
    PDFForm.prototype.getDefaultFont = function() {
        return this.defaultFontCache.access();
    };
    PDFForm.prototype.findWidgetPage = function(widget) {
        var pageRef = widget.P();
        var page = this.doc.getPages().find(function(x) {
            return x.ref === pageRef;
        });
        if (page === undefined) {
            var widgetRef = this.doc.context.getObjectRef(widget.dict);
            if (widgetRef === undefined) throw new Error('Could not find PDFRef for PDFObject');
            page = this.doc.findPageForAnnotationRef(widgetRef);
            if (page === undefined) throw new Error("Could not find page for PDFRef " + widgetRef);
        }
        return page;
    };
    PDFForm.prototype.findWidgetAppearanceRef = function(field, widget) {
        var _a;
        var refOrDict = widget.getNormalAppearance();
        if (refOrDict instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039) && (field instanceof (0, $7634ed9aabad7442$export$2e2bcd8739ae039) || field instanceof (0, $6d3b7571b9a9d3dc$export$2e2bcd8739ae039))) {
            var value = field.acroField.getValue();
            var ref = (_a = refOrDict.get(value)) !== null && _a !== void 0 ? _a : refOrDict.get((0, $btXS2.default).of('Off'));
            if (ref instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039)) refOrDict = ref;
        }
        if (!(refOrDict instanceof (0, $d2803e164f1400b0$export$2e2bcd8739ae039))) {
            var name_1 = field.getName();
            throw new Error("Failed to extract appearance ref for: " + name_1);
        }
        return refOrDict;
    };
    PDFForm.prototype.findOrCreateNonTerminals = function(partialNames) {
        var nonTerminal = [
            this.acroForm
        ];
        for(var idx = 0, len = partialNames.length; idx < len; idx++){
            var namePart = partialNames[idx];
            if (!namePart) throw new (0, $071c8956483bdcac$export$83c39fdacfe38500)(namePart);
            var parent_1 = nonTerminal[0], parentRef = nonTerminal[1];
            var res = this.findNonTerminal(namePart, parent_1);
            if (res) nonTerminal = res;
            else {
                var node = (0, $dbfd42e360237923$export$2e2bcd8739ae039).create(this.doc.context);
                node.setPartialName(namePart);
                node.setParent(parentRef);
                var nodeRef = this.doc.context.register(node.dict);
                parent_1.addField(nodeRef);
                nonTerminal = [
                    node,
                    nodeRef
                ];
            }
        }
        return nonTerminal;
    };
    PDFForm.prototype.findNonTerminal = function(partialName, parent) {
        var fields = parent instanceof (0, $e870fb8cfe287dc6$export$2e2bcd8739ae039) ? this.acroForm.getFields() : (0, $ffdc75f5fada1491$export$34b4fb8893136c4c)(parent.Kids());
        for(var idx = 0, len = fields.length; idx < len; idx++){
            var _a = fields[idx], field = _a[0], ref = _a[1];
            if (field.getPartialName() === partialName) {
                if (field instanceof (0, $dbfd42e360237923$export$2e2bcd8739ae039)) return [
                    field,
                    ref
                ];
                throw new (0, $071c8956483bdcac$export$c428cfe4dc6c68df)(partialName);
            }
        }
        return undefined;
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.getForm]] method, which will create an
     * > instance of [[PDFForm]] for you.
     *
     * Create an instance of [[PDFForm]] from an existing acroForm and embedder
     *
     * @param acroForm The underlying `PDFAcroForm` for this form.
     * @param doc The document to which the form will belong.
     */ PDFForm.of = function(acroForm, doc) {
        return new PDFForm(acroForm, doc);
    };
    return PDFForm;
}();
var $71885f85fdaea8a8$export$2e2bcd8739ae039 = $71885f85fdaea8a8$var$PDFForm;
var $71885f85fdaea8a8$var$convertToPDFField = function(field, ref, doc) {
    if (field instanceof (0, $3cdc71d89ed382a8$export$2e2bcd8739ae039)) return (0, $888b65c91f171a50$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $4e7ed1a5388e159e$export$2e2bcd8739ae039)) return (0, $7634ed9aabad7442$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $b9e1c95445e29e3a$export$2e2bcd8739ae039)) return (0, $ef7090d16eb3bab5$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $8b549563259095fa$export$2e2bcd8739ae039)) return (0, $f59ac96bda398d3a$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $d76660bc35a07b3f$export$2e2bcd8739ae039)) return (0, $88d35ffb92c3ce20$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $03ea7ddf4d3e4901$export$2e2bcd8739ae039)) return (0, $6d3b7571b9a9d3dc$export$2e2bcd8739ae039).of(field, ref, doc);
    if (field instanceof (0, $8236815884bcced8$export$2e2bcd8739ae039)) return (0, $eb55c83d847e5305$export$2e2bcd8739ae039).of(field, ref, doc);
    return undefined;
};
var $71885f85fdaea8a8$var$splitFieldName = function(fullyQualifiedName) {
    if (fullyQualifiedName.length === 0) throw new Error('PDF field names must not be empty strings');
    var parts = fullyQualifiedName.split('.');
    for(var idx = 0, len = parts.length; idx < len; idx++){
        if (parts[idx] === '') throw new Error("Periods in PDF field names must be separated by at least one character: \"" + fullyQualifiedName + "\"");
    }
    if (parts.length === 1) return {
        nonTerminal: [],
        terminal: parts[0]
    };
    return {
        nonTerminal: parts.slice(0, parts.length - 1),
        terminal: parts[parts.length - 1]
    };
};
var $71885f85fdaea8a8$var$addFieldToParent = function(_a, _b, partialName) {
    var parent = _a[0], parentRef = _a[1];
    var field = _b[0], fieldRef = _b[1];
    var entries = parent.normalizedEntries();
    var fields = (0, $ffdc75f5fada1491$export$34b4fb8893136c4c)('Kids' in entries ? entries.Kids : entries.Fields);
    for(var idx = 0, len = fields.length; idx < len; idx++){
        if (fields[idx][0].getPartialName() === partialName) throw new (0, $071c8956483bdcac$export$c428cfe4dc6c68df)(partialName);
    }
    parent.addField(fieldRef);
    field.setParent(parentRef);
};


var $18599b3f7958399f$export$b4a05ae367f5515c = {
    '4A0': [
        4767.87,
        6740.79
    ],
    '2A0': [
        3370.39,
        4767.87
    ],
    A0: [
        2383.94,
        3370.39
    ],
    A1: [
        1683.78,
        2383.94
    ],
    A2: [
        1190.55,
        1683.78
    ],
    A3: [
        841.89,
        1190.55
    ],
    A4: [
        595.28,
        841.89
    ],
    A5: [
        419.53,
        595.28
    ],
    A6: [
        297.64,
        419.53
    ],
    A7: [
        209.76,
        297.64
    ],
    A8: [
        147.4,
        209.76
    ],
    A9: [
        104.88,
        147.4
    ],
    A10: [
        73.7,
        104.88
    ],
    B0: [
        2834.65,
        4008.19
    ],
    B1: [
        2004.09,
        2834.65
    ],
    B2: [
        1417.32,
        2004.09
    ],
    B3: [
        1000.63,
        1417.32
    ],
    B4: [
        708.66,
        1000.63
    ],
    B5: [
        498.9,
        708.66
    ],
    B6: [
        354.33,
        498.9
    ],
    B7: [
        249.45,
        354.33
    ],
    B8: [
        175.75,
        249.45
    ],
    B9: [
        124.72,
        175.75
    ],
    B10: [
        87.87,
        124.72
    ],
    C0: [
        2599.37,
        3676.54
    ],
    C1: [
        1836.85,
        2599.37
    ],
    C2: [
        1298.27,
        1836.85
    ],
    C3: [
        918.43,
        1298.27
    ],
    C4: [
        649.13,
        918.43
    ],
    C5: [
        459.21,
        649.13
    ],
    C6: [
        323.15,
        459.21
    ],
    C7: [
        229.61,
        323.15
    ],
    C8: [
        161.57,
        229.61
    ],
    C9: [
        113.39,
        161.57
    ],
    C10: [
        79.37,
        113.39
    ],
    RA0: [
        2437.8,
        3458.27
    ],
    RA1: [
        1729.13,
        2437.8
    ],
    RA2: [
        1218.9,
        1729.13
    ],
    RA3: [
        864.57,
        1218.9
    ],
    RA4: [
        609.45,
        864.57
    ],
    SRA0: [
        2551.18,
        3628.35
    ],
    SRA1: [
        1814.17,
        2551.18
    ],
    SRA2: [
        1275.59,
        1814.17
    ],
    SRA3: [
        907.09,
        1275.59
    ],
    SRA4: [
        637.8,
        907.09
    ],
    Executive: [
        521.86,
        756.0
    ],
    Folio: [
        612.0,
        936.0
    ],
    Legal: [
        612.0,
        1008.0
    ],
    Letter: [
        612.0,
        792.0
    ],
    Tabloid: [
        792.0,
        1224.0
    ]
};



var $1jVcF = parcelRequire("1jVcF");
var $btXS2 = parcelRequire("btXS2");
var $e1ae7e8c55867113$export$ba19d141a3749548;
(function(ParseSpeeds) {
    ParseSpeeds[ParseSpeeds["Fastest"] = Infinity] = "Fastest";
    ParseSpeeds[ParseSpeeds["Fast"] = 1500] = "Fast";
    ParseSpeeds[ParseSpeeds["Medium"] = 500] = "Medium";
    ParseSpeeds[ParseSpeeds["Slow"] = 100] = "Slow";
})($e1ae7e8c55867113$export$ba19d141a3749548 || ($e1ae7e8c55867113$export$ba19d141a3749548 = {}));


parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $cLyfO = parcelRequire("cLyfO");
var $9uJGW = parcelRequire("9uJGW");
var $h8dd0 = parcelRequire("h8dd0");
var $3JpTw = parcelRequire("3JpTw");


var $70JnX = parcelRequire("70JnX");

var $cUVc9 = parcelRequire("cUVc9");
var $btXS2 = parcelRequire("btXS2");
/**
 * Represents a file that has been embedded in a [[PDFDocument]].
 */ var $a0445b9de8d5b167$var$PDFEmbeddedFile = /** @class */ function() {
    function PDFEmbeddedFile(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all embeddable files get embedded.
     *
     * Embed this embeddable file in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFEmbeddedFile.prototype.embed = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var ref, Names, EmbeddedFiles, EFNames, AF;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _a.sent();
                        if (!this.doc.catalog.has((0, $btXS2.default).of('Names'))) this.doc.catalog.set((0, $btXS2.default).of('Names'), this.doc.context.obj({}));
                        Names = this.doc.catalog.lookup((0, $btXS2.default).of('Names'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
                        if (!Names.has((0, $btXS2.default).of('EmbeddedFiles'))) Names.set((0, $btXS2.default).of('EmbeddedFiles'), this.doc.context.obj({}));
                        EmbeddedFiles = Names.lookup((0, $btXS2.default).of('EmbeddedFiles'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
                        if (!EmbeddedFiles.has((0, $btXS2.default).of('Names'))) EmbeddedFiles.set((0, $btXS2.default).of('Names'), this.doc.context.obj([]));
                        EFNames = EmbeddedFiles.lookup((0, $btXS2.default).of('Names'), (0, $cUVc9.default));
                        EFNames.push((0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(this.embedder.fileName));
                        EFNames.push(ref);
                        /**
                         * The AF-Tag is needed to achieve PDF-A3 compliance for embedded files
                         *
                         * The following document outlines the uses cases of the associated files (AF) tag.
                         * See:
                         * https://www.pdfa.org/wp-content/uploads/2018/10/PDF20_AN002-AF.pdf
                         */ if (!this.doc.catalog.has((0, $btXS2.default).of('AF'))) this.doc.catalog.set((0, $btXS2.default).of('AF'), this.doc.context.obj([]));
                        AF = this.doc.catalog.lookup((0, $btXS2.default).of('AF'), (0, $cUVc9.default));
                        AF.push(ref);
                        this.alreadyEmbedded = true;
                        _a.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.attach]] method, which will create
     * instances of [[PDFEmbeddedFile]] for you.
     *
     * Create an instance of [[PDFEmbeddedFile]] from an existing ref and embedder
     *
     * @param ref The unique reference for this file.
     * @param doc The document to which the file will belong.
     * @param embedder The embedder that will be used to embed the file.
     */ PDFEmbeddedFile.of = function(ref, doc, embedder) {
        return new PDFEmbeddedFile(ref, doc, embedder);
    };
    return PDFEmbeddedFile;
}();
var $a0445b9de8d5b167$export$2e2bcd8739ae039 = $a0445b9de8d5b167$var$PDFEmbeddedFile;



var $70JnX = parcelRequire("70JnX");

var $cUVc9 = parcelRequire("cUVc9");
var $btXS2 = parcelRequire("btXS2");
/**
 * Represents JavaScript that has been embedded in a [[PDFDocument]].
 */ var $841cf62f79082352$var$PDFJavaScript = /** @class */ function() {
    function PDFJavaScript(ref, doc, embedder) {
        this.alreadyEmbedded = false;
        this.ref = ref;
        this.doc = doc;
        this.embedder = embedder;
    }
    /**
     * > **NOTE:** You probably don't need to call this method directly. The
     * > [[PDFDocument.save]] and [[PDFDocument.saveAsBase64]] methods will
     * > automatically ensure all JavaScripts get embedded.
     *
     * Embed this JavaScript in its document.
     *
     * @returns Resolves when the embedding is complete.
     */ PDFJavaScript.prototype.embed = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, catalog, context, ref, Names, Javascript, JSNames;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (!!this.alreadyEmbedded) return [
                            3 /*break*/ ,
                            2
                        ];
                        _a = this.doc, catalog = _a.catalog, context = _a.context;
                        return [
                            4 /*yield*/ ,
                            this.embedder.embedIntoContext(this.doc.context, this.ref)
                        ];
                    case 1:
                        ref = _b.sent();
                        if (!catalog.has((0, $btXS2.default).of('Names'))) catalog.set((0, $btXS2.default).of('Names'), context.obj({}));
                        Names = catalog.lookup((0, $btXS2.default).of('Names'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
                        if (!Names.has((0, $btXS2.default).of('JavaScript'))) Names.set((0, $btXS2.default).of('JavaScript'), context.obj({}));
                        Javascript = Names.lookup((0, $btXS2.default).of('JavaScript'), (0, $a128f87a2ae876f3$export$2e2bcd8739ae039));
                        if (!Javascript.has((0, $btXS2.default).of('Names'))) Javascript.set((0, $btXS2.default).of('Names'), context.obj([]));
                        JSNames = Javascript.lookup((0, $btXS2.default).of('Names'), (0, $cUVc9.default));
                        JSNames.push((0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(this.embedder.scriptName));
                        JSNames.push(ref);
                        this.alreadyEmbedded = true;
                        _b.label = 2;
                    case 2:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addJavaScript]] method, which will
     * create instances of [[PDFJavaScript]] for you.
     *
     * Create an instance of [[PDFJavaScript]] from an existing ref and script
     *
     * @param ref The unique reference for this script.
     * @param doc The document to which the script will belong.
     * @param embedder The embedder that will be used to embed the script.
     */ PDFJavaScript.of = function(ref, doc, embedder) {
        return new PDFJavaScript(ref, doc, embedder);
    };
    return PDFJavaScript;
}();
var $841cf62f79082352$export$2e2bcd8739ae039 = $841cf62f79082352$var$PDFJavaScript;



var $70JnX = parcelRequire("70JnX");

var $7252d3dbafa17440$var$JavaScriptEmbedder = /** @class */ function() {
    function JavaScriptEmbedder(script, scriptName) {
        this.script = script;
        this.scriptName = scriptName;
    }
    JavaScriptEmbedder.for = function(script, scriptName) {
        return new JavaScriptEmbedder(script, scriptName);
    };
    JavaScriptEmbedder.prototype.embedIntoContext = function(context, ref) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var jsActionDict;
            return (0, $70JnX.__generator)(this, function(_a) {
                jsActionDict = context.obj({
                    Type: 'Action',
                    S: 'JavaScript',
                    JS: (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(this.script)
                });
                if (ref) {
                    context.assign(ref, jsActionDict);
                    return [
                        2 /*return*/ ,
                        ref
                    ];
                } else return [
                    2 /*return*/ ,
                    context.register(jsActionDict)
                ];
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    return JavaScriptEmbedder;
}();
var $7252d3dbafa17440$export$2e2bcd8739ae039 = $7252d3dbafa17440$var$JavaScriptEmbedder;


/**
 * Represents a PDF document.
 */ var $c8198d59b2f6ab16$var$PDFDocument = /** @class */ function() {
    function PDFDocument(context, ignoreEncryption, updateMetadata) {
        var _this = this;
        /** The default word breaks used in PDFPage.drawText */ this.defaultWordBreaks = [
            ' '
        ];
        this.computePages = function() {
            var pages = [];
            _this.catalog.Pages().traverse(function(node, ref) {
                if (node instanceof (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039)) {
                    var page = _this.pageMap.get(node);
                    if (!page) {
                        page = (0, $f470fd80980f0cb4$export$2e2bcd8739ae039).of(node, ref, _this);
                        _this.pageMap.set(node, page);
                    }
                    pages.push(page);
                }
            });
            return pages;
        };
        this.getOrCreateForm = function() {
            var acroForm = _this.catalog.getOrCreateAcroForm();
            return (0, $71885f85fdaea8a8$export$2e2bcd8739ae039).of(acroForm, _this);
        };
        (0, $fYigW.assertIs)(context, 'context', [
            [
                (0, $ec19a68ebeedd71c$export$2e2bcd8739ae039),
                'PDFContext'
            ]
        ]);
        (0, $fYigW.assertIs)(ignoreEncryption, 'ignoreEncryption', [
            'boolean'
        ]);
        this.context = context;
        this.catalog = context.lookup(context.trailerInfo.Root);
        this.isEncrypted = !!context.lookup(context.trailerInfo.Encrypt);
        this.pageCache = (0, $cLyfO.default).populatedBy(this.computePages);
        this.pageMap = new Map();
        this.formCache = (0, $cLyfO.default).populatedBy(this.getOrCreateForm);
        this.fonts = [];
        this.images = [];
        this.embeddedPages = [];
        this.embeddedFiles = [];
        this.javaScripts = [];
        if (!ignoreEncryption && this.isEncrypted) throw new (0, $071c8956483bdcac$export$20fcceeca2b098d2)();
        if (updateMetadata) this.updateInfoDict();
    }
    /**
     * Load an existing [[PDFDocument]]. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                               |
     * | ------------- | ------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PDF |
     * | `Uint8Array`  | The raw bytes of a PDF                                 |
     * | `ArrayBuffer` | The raw bytes of a PDF                                 |
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     *
     * // pdf=string
     * const base64 =
     *  'JVBERi0xLjcKJYGBgYEKCjUgMCBvYmoKPDwKL0ZpbHRlciAvRmxhdGVEZWNvZGUKL0xlbm' +
     *  'd0aCAxMDQKPj4Kc3RyZWFtCniccwrhMlAAwaJ0Ln2P1Jyy1JLM5ERdc0MjCwUjE4WQNC4Q' +
     *  '6cNlCFZkqGCqYGSqEJLLZWNuYGZiZmbkYuZsZmlmZGRgZmluDCQNzc3NTM2NzdzMXMxMjQ' +
     *  'ztFEKyuEK0uFxDuAAOERdVCmVuZHN0cmVhbQplbmRvYmoKCjYgMCBvYmoKPDwKL0ZpbHRl' +
     *  'ciAvRmxhdGVEZWNvZGUKL1R5cGUgL09ialN0bQovTiA0Ci9GaXJzdCAyMAovTGVuZ3RoID' +
     *  'IxNQo+PgpzdHJlYW0KeJxVj9GqwjAMhu/zFHkBzTo3nCCCiiKIHPEICuJF3cKoSCu2E8/b' +
     *  '20wPIr1p8v9/8kVhgilmGfawX2CGaVrgcAi0/bsy0lrX7IGWpvJ4iJYEN3gEmrrGBlQwGs' +
     *  'HHO9VBX1wNrxAqMX87RBD5xpJuddqwd82tjAHxzV1U5LPgy52DKXWnr1Lheg+j/c/pzGVr' +
     *  'iqV0VlwZPXGPCJjElw/ybkwUmeoWgxesDXGhHJC/D/iikp1Av80ptKU0FdBEe25pPihAM1' +
     *  'u6ytgaaWfs2Hrz35CJT1+EWmAKZW5kc3RyZWFtCmVuZG9iagoKNyAwIG9iago8PAovU2l6' +
     *  'ZSA4Ci9Sb290IDIgMCBSCi9GaWx0ZXIgL0ZsYXRlRGVjb2RlCi9UeXBlIC9YUmVmCi9MZW' +
     *  '5ndGggMzgKL1cgWyAxIDIgMiBdCi9JbmRleCBbIDAgOCBdCj4+CnN0cmVhbQp4nBXEwREA' +
     *  'EBAEsCwz3vrvRmOOyyOoGhZdutHN2MT55fIAVocD+AplbmRzdHJlYW0KZW5kb2JqCgpzdG' +
     *  'FydHhyZWYKNTEwCiUlRU9G'
     *
     * const dataUri = 'data:application/pdf;base64,' + base64
     *
     * const pdfDoc1 = await PDFDocument.load(base64)
     * const pdfDoc2 = await PDFDocument.load(dataUri)
     *
     * // pdf=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('with_update_sections.pdf')
     * const pdfDoc3 = await PDFDocument.load(uint8Array)
     *
     * // pdf=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/with_update_sections.pdf'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const pdfDoc4 = await PDFDocument.load(arrayBuffer)
     *
     * ```
     *
     * @param pdf The input data containing a PDF document.
     * @param options The options to be used when loading the document.
     * @returns Resolves with a document loaded from the input.
     */ PDFDocument.load = function(pdf, options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, ignoreEncryption, _b, parseSpeed, _c, throwOnInvalidObject, _d, updateMetadata, _e, capNumbers, bytes, context;
            return (0, $70JnX.__generator)(this, function(_f) {
                switch(_f.label){
                    case 0:
                        _a = options.ignoreEncryption, ignoreEncryption = _a === void 0 ? false : _a, _b = options.parseSpeed, parseSpeed = _b === void 0 ? (0, $e1ae7e8c55867113$export$ba19d141a3749548).Slow : _b, _c = options.throwOnInvalidObject, throwOnInvalidObject = _c === void 0 ? false : _c, _d = options.updateMetadata, updateMetadata = _d === void 0 ? true : _d, _e = options.capNumbers, capNumbers = _e === void 0 ? false : _e;
                        (0, $fYigW.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $fYigW.assertIs)(ignoreEncryption, 'ignoreEncryption', [
                            'boolean'
                        ]);
                        (0, $fYigW.assertIs)(parseSpeed, 'parseSpeed', [
                            'number'
                        ]);
                        (0, $fYigW.assertIs)(throwOnInvalidObject, 'throwOnInvalidObject', [
                            'boolean'
                        ]);
                        bytes = (0, $9uJGW.toUint8Array)(pdf);
                        return [
                            4 /*yield*/ ,
                            (0, $e3e3cae9bc5989a7$export$2e2bcd8739ae039).forBytesWithOptions(bytes, parseSpeed, throwOnInvalidObject, capNumbers).parseDocument()
                        ];
                    case 1:
                        context = _f.sent();
                        return [
                            2 /*return*/ ,
                            new PDFDocument(context, ignoreEncryption, updateMetadata)
                        ];
                }
            });
        });
    };
    /**
     * Create a new [[PDFDocument]].
     * @returns Resolves with the newly created document.
     */ PDFDocument.create = function(options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, updateMetadata, context, pageTree, pageTreeRef, catalog;
            return (0, $70JnX.__generator)(this, function(_b) {
                _a = options.updateMetadata, updateMetadata = _a === void 0 ? true : _a;
                context = (0, $ec19a68ebeedd71c$export$2e2bcd8739ae039).create();
                pageTree = (0, $fa27c364c3830342$export$2e2bcd8739ae039).withContext(context);
                pageTreeRef = context.register(pageTree);
                catalog = (0, $f572ef30ca0090ff$export$2e2bcd8739ae039).withContextAndPages(context, pageTreeRef);
                context.trailerInfo.Root = context.register(catalog);
                return [
                    2 /*return*/ ,
                    new PDFDocument(context, false, updateMetadata)
                ];
            });
        });
    };
    /**
     * Register a fontkit instance. This must be done before custom fonts can
     * be embedded. See [here](https://github.com/Hopding/pdf-lib/tree/master#fontkit-installation)
     * for instructions on how to install and register a fontkit instance.
     *
     * > You do **not** need to call this method to embed standard fonts.
     *
     * For example:
     * ```js
     * import { PDFDocument } from 'pdf-lib'
     * import fontkit from '@pdf-lib/fontkit'
     *
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.registerFontkit(fontkit)
     * ```
     *
     * @param fontkit The fontkit instance to be registered.
     */ PDFDocument.prototype.registerFontkit = function(fontkit) {
        this.fontkit = fontkit;
    };
    /**
     * Get the [[PDFForm]] containing all interactive fields for this document.
     * For example:
     * ```js
     * const form = pdfDoc.getForm()
     * const fields = form.getFields()
     * fields.forEach(field => {
     *   const type = field.constructor.name
     *   const name = field.getName()
     *   console.log(`${type}: ${name}`)
     * })
     * ```
     * @returns The form for this document.
     */ PDFDocument.prototype.getForm = function() {
        var form = this.formCache.access();
        if (form.hasXFA()) {
            console.warn('Removing XFA form data as pdf-lib does not support reading or writing XFA');
            form.deleteXFA();
        }
        return form;
    };
    /**
     * Get this document's title metadata. The title appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const title = pdfDoc.getTitle()
     * ```
     * @returns A string containing the title of this document, if it has one.
     */ PDFDocument.prototype.getTitle = function() {
        var title = this.getInfoDict().lookup((0, $btXS2.default).Title);
        if (!title) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(title);
        return title.decodeText();
    };
    /**
     * Get this document's author metadata. The author appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const author = pdfDoc.getAuthor()
     * ```
     * @returns A string containing the author of this document, if it has one.
     */ PDFDocument.prototype.getAuthor = function() {
        var author = this.getInfoDict().lookup((0, $btXS2.default).Author);
        if (!author) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(author);
        return author.decodeText();
    };
    /**
     * Get this document's subject metadata. The subject appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const subject = pdfDoc.getSubject()
     * ```
     * @returns A string containing the subject of this document, if it has one.
     */ PDFDocument.prototype.getSubject = function() {
        var subject = this.getInfoDict().lookup((0, $btXS2.default).Subject);
        if (!subject) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(subject);
        return subject.decodeText();
    };
    /**
     * Get this document's keywords metadata. The keywords appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const keywords = pdfDoc.getKeywords()
     * ```
     * @returns A string containing the keywords of this document, if it has any.
     */ PDFDocument.prototype.getKeywords = function() {
        var keywords = this.getInfoDict().lookup((0, $btXS2.default).Keywords);
        if (!keywords) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(keywords);
        return keywords.decodeText();
    };
    /**
     * Get this document's creator metadata. The creator appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creator = pdfDoc.getCreator()
     * ```
     * @returns A string containing the creator of this document, if it has one.
     */ PDFDocument.prototype.getCreator = function() {
        var creator = this.getInfoDict().lookup((0, $btXS2.default).Creator);
        if (!creator) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(creator);
        return creator.decodeText();
    };
    /**
     * Get this document's producer metadata. The producer appears in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * const producer = pdfDoc.getProducer()
     * ```
     * @returns A string containing the producer of this document, if it has one.
     */ PDFDocument.prototype.getProducer = function() {
        var producer = this.getInfoDict().lookup((0, $btXS2.default).Producer);
        if (!producer) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(producer);
        return producer.decodeText();
    };
    /**
     * Get this document's creation date metadata. The creation date appears in
     * the "Document Properties" section of most PDF readers. For example:
     * ```js
     * const creationDate = pdfDoc.getCreationDate()
     * ```
     * @returns A Date containing the creation date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getCreationDate = function() {
        var creationDate = this.getInfoDict().lookup((0, $btXS2.default).CreationDate);
        if (!creationDate) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(creationDate);
        return creationDate.decodeDate();
    };
    /**
     * Get this document's modification date metadata. The modification date
     * appears in the "Document Properties" section of most PDF readers.
     * For example:
     * ```js
     * const modification = pdfDoc.getModificationDate()
     * ```
     * @returns A Date containing the modification date of this document,
     *          if it has one.
     */ PDFDocument.prototype.getModificationDate = function() {
        var modificationDate = this.getInfoDict().lookup((0, $btXS2.default).ModDate);
        if (!modificationDate) return undefined;
        $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(modificationDate);
        return modificationDate.decodeDate();
    };
    /**
     * Set this document's title metadata. The title will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳')
     * ```
     *
     * To display the title in the window's title bar, set the
     * `showInWindowTitleBar` option to `true` (works for _most_ PDF readers).
     * For example:
     * ```js
     * pdfDoc.setTitle('🥚 The Life of an Egg 🍳', { showInWindowTitleBar: true })
     * ```
     *
     * @param title The title of this document.
     * @param options The options to be used when setting the title.
     */ PDFDocument.prototype.setTitle = function(title, options) {
        (0, $fYigW.assertIs)(title, 'title', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Title');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(title));
        // Indicate that readers should display the title rather than the filename
        if (options === null || options === void 0 ? void 0 : options.showInWindowTitleBar) {
            var prefs = this.catalog.getOrCreateViewerPreferences();
            prefs.setDisplayDocTitle(true);
        }
    };
    /**
     * Set this document's author metadata. The author will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setAuthor('Humpty Dumpty')
     * ```
     * @param author The author of this document.
     */ PDFDocument.prototype.setAuthor = function(author) {
        (0, $fYigW.assertIs)(author, 'author', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Author');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(author));
    };
    /**
     * Set this document's subject metadata. The subject will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setSubject('📘 An Epic Tale of Woe 📖')
     * ```
     * @param subject The subject of this document.
     */ PDFDocument.prototype.setSubject = function(subject) {
        (0, $fYigW.assertIs)(subject, 'author', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Subject');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(subject));
    };
    /**
     * Set this document's keyword metadata. These keywords will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setKeywords(['eggs', 'wall', 'fall', 'king', 'horses', 'men'])
     * ```
     * @param keywords An array of keywords associated with this document.
     */ PDFDocument.prototype.setKeywords = function(keywords) {
        (0, $fYigW.assertIs)(keywords, 'keywords', [
            Array
        ]);
        var key = (0, $btXS2.default).of('Keywords');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(keywords.join(' ')));
    };
    /**
     * Set this document's creator metadata. The creator will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreator('PDF App 9000 🤖')
     * ```
     * @param creator The creator of this document.
     */ PDFDocument.prototype.setCreator = function(creator) {
        (0, $fYigW.assertIs)(creator, 'creator', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Creator');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(creator));
    };
    /**
     * Set this document's producer metadata. The producer will appear in the
     * "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setProducer('PDF App 9000 🤖')
     * ```
     * @param producer The producer of this document.
     */ PDFDocument.prototype.setProducer = function(producer) {
        (0, $fYigW.assertIs)(producer, 'creator', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Producer');
        this.getInfoDict().set(key, (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039).fromText(producer));
    };
    /**
     * Set this document's language metadata. The language will appear in the
     * "Document Properties" section of some PDF readers. For example:
     * ```js
     * pdfDoc.setLanguage('en-us')
     * ```
     *
     * @param language An RFC 3066 _Language-Tag_ denoting the language of this
     *                 document, or an empty string if the language is unknown.
     */ PDFDocument.prototype.setLanguage = function(language) {
        (0, $fYigW.assertIs)(language, 'language', [
            'string'
        ]);
        var key = (0, $btXS2.default).of('Lang');
        this.catalog.set(key, (0, $47c89398cba1043c$export$2e2bcd8739ae039).of(language));
    };
    /**
     * Set this document's creation date metadata. The creation date will appear
     * in the "Document Properties" section of most PDF readers. For example:
     * ```js
     * pdfDoc.setCreationDate(new Date())
     * ```
     * @param creationDate The date this document was created.
     */ PDFDocument.prototype.setCreationDate = function(creationDate) {
        (0, $fYigW.assertIs)(creationDate, 'creationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $btXS2.default).of('CreationDate');
        this.getInfoDict().set(key, (0, $47c89398cba1043c$export$2e2bcd8739ae039).fromDate(creationDate));
    };
    /**
     * Set this document's modification date metadata. The modification date will
     * appear in the "Document Properties" section of most PDF readers. For
     * example:
     * ```js
     * pdfDoc.setModificationDate(new Date())
     * ```
     * @param modificationDate The date this document was last modified.
     */ PDFDocument.prototype.setModificationDate = function(modificationDate) {
        (0, $fYigW.assertIs)(modificationDate, 'modificationDate', [
            [
                Date,
                'Date'
            ]
        ]);
        var key = (0, $btXS2.default).of('ModDate');
        this.getInfoDict().set(key, (0, $47c89398cba1043c$export$2e2bcd8739ae039).fromDate(modificationDate));
    };
    /**
     * Get the number of pages contained in this document. For example:
     * ```js
     * const totalPages = pdfDoc.getPageCount()
     * ```
     * @returns The number of pages in this document.
     */ PDFDocument.prototype.getPageCount = function() {
        if (this.pageCount === undefined) this.pageCount = this.getPages().length;
        return this.pageCount;
    };
    /**
     * Get an array of all the pages contained in this document. The pages are
     * stored in the array in the same order that they are rendered in the
     * document. For example:
     * ```js
     * const pages = pdfDoc.getPages()
     * pages[0]   // The first page of the document
     * pages[2]   // The third page of the document
     * pages[197] // The 198th page of the document
     * ```
     * @returns An array of all the pages contained in this document.
     */ PDFDocument.prototype.getPages = function() {
        return this.pageCache.access();
    };
    /**
     * Get the page rendered at a particular `index` of the document. For example:
     * ```js
     * pdfDoc.getPage(0)   // The first page of the document
     * pdfDoc.getPage(2)   // The third page of the document
     * pdfDoc.getPage(197) // The 198th page of the document
     * ```
     * @returns The [[PDFPage]] rendered at the given `index` of the document.
     */ PDFDocument.prototype.getPage = function(index) {
        var pages = this.getPages();
        (0, $fYigW.assertRange)(index, 'index', 0, pages.length - 1);
        return pages[index];
    };
    /**
     * Get an array of indices for all the pages contained in this document. The
     * array will contain a range of integers from
     * `0..pdfDoc.getPageCount() - 1`. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     * pdfDoc.addPage()
     *
     * const indices = pdfDoc.getPageIndices()
     * indices // => [0, 1, 2]
     * ```
     * @returns An array of indices for all pages contained in this document.
     */ PDFDocument.prototype.getPageIndices = function() {
        return (0, $9uJGW.range)(0, this.getPageCount());
    };
    /**
     * Remove the page at a given index from this document. For example:
     * ```js
     * pdfDoc.removePage(0)   // Remove the first page of the document
     * pdfDoc.removePage(2)   // Remove the third page of the document
     * pdfDoc.removePage(197) // Remove the 198th page of the document
     * ```
     * Once a page has been removed, it will no longer be rendered at that index
     * in the document.
     * @param index The index of the page to be removed.
     */ PDFDocument.prototype.removePage = function(index) {
        var pageCount = this.getPageCount();
        if (this.pageCount === 0) throw new (0, $071c8956483bdcac$export$cdca06c5927ddc2d)();
        (0, $fYigW.assertRange)(index, 'index', 0, pageCount - 1);
        this.catalog.removeLeafNode(index);
        this.pageCount = pageCount - 1;
    };
    /**
     * Add a page to the end of this document. This method accepts three
     * different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                            |
     * | ------------------ | ----------------------------------------------------------------------------------- |
     * | `undefined`        | Create a new page and add it to the end of this document                            |
     * | `[number, number]` | Create a new page with the given dimensions and add it to the end of this document  |
     * | `PDFPage`          | Add the existing page to the end of this document                                   |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.addPage()
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.addPage(PageSizes.A7)
     * const newPage2 = pdfDoc.addPage(PageSizes.Letter)
     * const newPage3 = pdfDoc.addPage([500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.addPage(existingPage)
     * ```
     *
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.addPage = function(page) {
        (0, $fYigW.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        return this.insertPage(this.getPageCount(), page);
    };
    /**
     * Insert a page at a given index within this document. This method accepts
     * three different value types for the `page` parameter:
     *
     * | Type               | Behavior                                                                       |
     * | ------------------ | ------------------------------------------------------------------------------ |
     * | `undefined`        | Create a new page and insert it into this document                             |
     * | `[number, number]` | Create a new page with the given dimensions and insert it into this document   |
     * | `PDFPage`          | Insert the existing page into this document                                    |
     *
     * For example:
     * ```js
     * // page=undefined
     * const newPage = pdfDoc.insertPage(2)
     *
     * // page=[number, number]
     * import { PageSizes } from 'pdf-lib'
     * const newPage1 = pdfDoc.insertPage(2, PageSizes.A7)
     * const newPage2 = pdfDoc.insertPage(0, PageSizes.Letter)
     * const newPage3 = pdfDoc.insertPage(198, [500, 750])
     *
     * // page=PDFPage
     * const pdfDoc1 = await PDFDocument.create()
     * const pdfDoc2 = await PDFDocument.load(...)
     * const [existingPage] = await pdfDoc1.copyPages(pdfDoc2, [0])
     * pdfDoc1.insertPage(0, existingPage)
     * ```
     *
     * @param index The index at which the page should be inserted (zero-based).
     * @param page Optionally, the desired dimensions or existing page.
     * @returns The newly created (or existing) page.
     */ PDFDocument.prototype.insertPage = function(index, page) {
        var pageCount = this.getPageCount();
        (0, $fYigW.assertRange)(index, 'index', 0, pageCount);
        (0, $fYigW.assertIs)(page, 'page', [
            'undefined',
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ],
            Array
        ]);
        if (!page || Array.isArray(page)) {
            var dims = Array.isArray(page) ? page : (0, $18599b3f7958399f$export$b4a05ae367f5515c).A4;
            page = (0, $f470fd80980f0cb4$export$2e2bcd8739ae039).create(this);
            page.setSize.apply(page, dims);
        } else if (page.doc !== this) throw new (0, $071c8956483bdcac$export$9564a4d28d94eae2)();
        var parentRef = this.catalog.insertLeafNode(page.ref, index);
        page.node.setParent(parentRef);
        this.pageMap.set(page.node, page);
        this.pageCache.invalidate();
        this.pageCount = pageCount + 1;
        return page;
    };
    /**
     * Copy pages from a source document into this document. Allows pages to be
     * copied between different [[PDFDocument]] instances. For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     * const srcDoc = await PDFDocument.load(...)
     *
     * const copiedPages = await pdfDoc.copyPages(srcDoc, [0, 3, 89])
     * const [firstPage, fourthPage, ninetiethPage] = copiedPages;
     *
     * pdfDoc.addPage(fourthPage)
     * pdfDoc.insertPage(0, ninetiethPage)
     * pdfDoc.addPage(firstPage)
     * ```
     * @param srcDoc The document from which pages should be copied.
     * @param indices The indices of the pages that should be copied.
     * @returns Resolves with an array of pages copied into this document.
     */ PDFDocument.prototype.copyPages = function(srcDoc, indices) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var copier, srcPages, copiedPages, idx, len, srcPage, copiedPage, ref;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $fYigW.assertIs)(srcDoc, 'srcDoc', [
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $fYigW.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        return [
                            4 /*yield*/ ,
                            srcDoc.flush()
                        ];
                    case 1:
                        _a.sent();
                        copier = (0, $0e849e39b0ca1497$export$2e2bcd8739ae039).for(srcDoc.context, this.context);
                        srcPages = srcDoc.getPages();
                        copiedPages = new Array(indices.length);
                        for(idx = 0, len = indices.length; idx < len; idx++){
                            srcPage = srcPages[indices[idx]];
                            copiedPage = copier.copy(srcPage.node);
                            ref = this.context.register(copiedPage);
                            copiedPages[idx] = (0, $f470fd80980f0cb4$export$2e2bcd8739ae039).of(copiedPage, ref, this);
                        }
                        return [
                            2 /*return*/ ,
                            copiedPages
                        ];
                }
            });
        });
    };
    /**
     * Get a copy of this document.
     *
     * For example:
     * ```js
     * const srcDoc = await PDFDocument.load(...)
     * const pdfDoc = await srcDoc.copy()
     * ```
     *
     * > **NOTE:**  This method won't copy all information over to the new
     * > document (acroforms, outlines, etc...).
     *
     * @returns Resolves with a copy this document.
     */ PDFDocument.prototype.copy = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var pdfCopy, contentPages, idx, len;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.create()
                        ];
                    case 1:
                        pdfCopy = _a.sent();
                        return [
                            4 /*yield*/ ,
                            pdfCopy.copyPages(this, this.getPageIndices())
                        ];
                    case 2:
                        contentPages = _a.sent();
                        for(idx = 0, len = contentPages.length; idx < len; idx++)pdfCopy.addPage(contentPages[idx]);
                        if (this.getAuthor() !== undefined) pdfCopy.setAuthor(this.getAuthor());
                        if (this.getCreationDate() !== undefined) pdfCopy.setCreationDate(this.getCreationDate());
                        if (this.getCreator() !== undefined) pdfCopy.setCreator(this.getCreator());
                        if (this.getModificationDate() !== undefined) pdfCopy.setModificationDate(this.getModificationDate());
                        if (this.getProducer() !== undefined) pdfCopy.setProducer(this.getProducer());
                        if (this.getSubject() !== undefined) pdfCopy.setSubject(this.getSubject());
                        if (this.getTitle() !== undefined) pdfCopy.setTitle(this.getTitle());
                        pdfCopy.defaultWordBreaks = this.defaultWordBreaks;
                        return [
                            2 /*return*/ ,
                            pdfCopy
                        ];
                }
            });
        });
    };
    /**
     * Add JavaScript to this document. The supplied `script` is executed when the
     * document is opened. The `script` can be used to perform some operation
     * when the document is opened (e.g. logging to the console), or it can be
     * used to define a function that can be referenced later in a JavaScript
     * action. For example:
     * ```js
     * // Show "Hello World!" in the console when the PDF is opened
     * pdfDoc.addJavaScript(
     *   'main',
     *   'console.show(); console.println("Hello World!");'
     * );
     *
     * // Define a function named "foo" that can be called in JavaScript Actions
     * pdfDoc.addJavaScript(
     *   'foo',
     *   'function foo() { return "foo"; }'
     * );
     * ```
     * See the [JavaScript for Acrobat API Reference](https://www.adobe.com/content/dam/acom/en/devnet/acrobat/pdfs/js_api_reference.pdf)
     * for details.
     * @param name The name of the script. Must be unique per document.
     * @param script The JavaScript to execute.
     */ PDFDocument.prototype.addJavaScript = function(name, script) {
        (0, $fYigW.assertIs)(name, 'name', [
            'string'
        ]);
        (0, $fYigW.assertIs)(script, 'script', [
            'string'
        ]);
        var embedder = (0, $7252d3dbafa17440$export$2e2bcd8739ae039).for(script, name);
        var ref = this.context.nextRef();
        var javaScript = (0, $841cf62f79082352$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.javaScripts.push(javaScript);
    };
    /**
     * Add an attachment to this document. Attachments are visible in the
     * "Attachments" panel of Adobe Acrobat and some other PDF readers. Any
     * type of file can be added as an attachment. This includes, but is not
     * limited to, `.png`, `.jpg`, `.pdf`, `.csv`, `.docx`, and `.xlsx` files.
     *
     * The input data can be provided in multiple formats:
     *
     * | Type          | Contents                                                       |
     * | ------------- | -------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing an attachment |
     * | `Uint8Array`  | The raw bytes of an attachment                                 |
     * | `ArrayBuffer` | The raw bytes of an attachment                                 |
     *
     * For example:
     * ```js
     * // attachment=string
     * await pdfDoc.attach('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * await pdfDoc.attach('data:image/jpeg;base64,/9j/4AAQ...', 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * await pdfDoc.attach(uint8Array, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     *
     * // attachment=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * await pdfDoc.attach(arrayBuffer, 'cat_riding_unicorn.jpg', {
     *   mimeType: 'image/jpeg',
     *   description: 'Cool cat riding a unicorn! 🦄🐈🕶️',
     *   creationDate: new Date('2019/12/01'),
     *   modificationDate: new Date('2020/04/19'),
     * })
     * ```
     *
     * @param attachment The input data containing the file to be attached.
     * @param name The name of the file to be attached.
     * @returns Resolves when the attachment is complete.
     */ PDFDocument.prototype.attach = function(attachment, name, options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, embeddedFile;
            return (0, $70JnX.__generator)(this, function(_a) {
                (0, $fYigW.assertIs)(attachment, 'attachment', [
                    'string',
                    Uint8Array,
                    ArrayBuffer
                ]);
                (0, $fYigW.assertIs)(name, 'name', [
                    'string'
                ]);
                (0, $fYigW.assertOrUndefined)(options.mimeType, 'mimeType', [
                    'string'
                ]);
                (0, $fYigW.assertOrUndefined)(options.description, 'description', [
                    'string'
                ]);
                (0, $fYigW.assertOrUndefined)(options.creationDate, 'options.creationDate', [
                    Date
                ]);
                (0, $fYigW.assertOrUndefined)(options.modificationDate, 'options.modificationDate', [
                    Date
                ]);
                (0, $fYigW.assertIsOneOfOrUndefined)(options.afRelationship, 'options.afRelationship', (0, $905acc2e8a6e5b91$export$c12eac46fbec1b74));
                bytes = (0, $9uJGW.toUint8Array)(attachment);
                embedder = (0, $905acc2e8a6e5b91$export$2e2bcd8739ae039).for(bytes, name, options);
                ref = this.context.nextRef();
                embeddedFile = (0, $a0445b9de8d5b167$export$2e2bcd8739ae039).of(ref, this, embedder);
                this.embeddedFiles.push(embeddedFile);
                return [
                    2 /*return*/ 
                ];
            });
        });
    };
    /**
     * Embed a font into this document. The input data can be provided in multiple
     * formats:
     *
     * | Type            | Contents                                                |
     * | --------------- | ------------------------------------------------------- |
     * | `StandardFonts` | One of the standard 14 fonts                            |
     * | `string`        | A base64 encoded string (or data URI) containing a font |
     * | `Uint8Array`    | The raw bytes of a font                                 |
     * | `ArrayBuffer`   | The raw bytes of a font                                 |
     *
     * For example:
     * ```js
     * // font=StandardFonts
     * import { StandardFonts } from 'pdf-lib'
     * const font1 = await pdfDoc.embedFont(StandardFonts.Helvetica)
     *
     * // font=string
     * const font2 = await pdfDoc.embedFont('AAEAAAAVAQAABABQRFNJRx/upe...')
     * const font3 = await pdfDoc.embedFont('data:font/opentype;base64,AAEAAA...')
     *
     * // font=Uint8Array
     * import fs from 'fs'
     * const font4 = await pdfDoc.embedFont(fs.readFileSync('Ubuntu-R.ttf'))
     *
     * // font=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/ubuntu/Ubuntu-R.ttf'
     * const ubuntuBytes = await fetch(url).then(res => res.arrayBuffer())
     * const font5 = await pdfDoc.embedFont(ubuntuBytes)
     * ```
     * See also: [[registerFontkit]]
     * @param font The input data for a font.
     * @param options The options to be used when embedding the font.
     * @returns Resolves with the embedded font.
     */ PDFDocument.prototype.embedFont = function(font, options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, subset, customName, features, embedder, bytes, fontkit, _b, ref, pdfFont;
            return (0, $70JnX.__generator)(this, function(_c) {
                switch(_c.label){
                    case 0:
                        _a = options.subset, subset = _a === void 0 ? false : _a, customName = options.customName, features = options.features;
                        (0, $fYigW.assertIs)(font, 'font', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        (0, $fYigW.assertIs)(subset, 'subset', [
                            'boolean'
                        ]);
                        if (!(0, $3JpTw.isStandardFont)(font)) return [
                            3 /*break*/ ,
                            1
                        ];
                        embedder = (0, $b2a95496f8f41048$export$2e2bcd8739ae039).for(font, customName);
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 1:
                        if (!(0, $9uJGW.canBeConvertedToUint8Array)(font)) return [
                            3 /*break*/ ,
                            6
                        ];
                        bytes = (0, $9uJGW.toUint8Array)(font);
                        fontkit = this.assertFontkit();
                        if (!subset) return [
                            3 /*break*/ ,
                            3
                        ];
                        return [
                            4 /*yield*/ ,
                            (0, $e801409ba06cce4c$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 2:
                        _b = _c.sent();
                        return [
                            3 /*break*/ ,
                            5
                        ];
                    case 3:
                        return [
                            4 /*yield*/ ,
                            (0, $ce290f01ecd7d7e1$export$2e2bcd8739ae039).for(fontkit, bytes, customName, features)
                        ];
                    case 4:
                        _b = _c.sent();
                        _c.label = 5;
                    case 5:
                        embedder = _b;
                        return [
                            3 /*break*/ ,
                            7
                        ];
                    case 6:
                        throw new TypeError('`font` must be one of `StandardFonts | string | Uint8Array | ArrayBuffer`');
                    case 7:
                        ref = this.context.nextRef();
                        pdfFont = (0, $9982052d55be794b$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.fonts.push(pdfFont);
                        return [
                            2 /*return*/ ,
                            pdfFont
                        ];
                }
            });
        });
    };
    /**
     * Embed a standard font into this document.
     * For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     * const helveticaFont = pdfDoc.embedFont(StandardFonts.Helvetica)
     * ```
     * @param font The standard font to be embedded.
     * @param customName The name to be used when embedding the font.
     * @returns The embedded font.
     */ PDFDocument.prototype.embedStandardFont = function(font, customName) {
        (0, $fYigW.assertIs)(font, 'font', [
            'string'
        ]);
        if (!(0, $3JpTw.isStandardFont)(font)) throw new TypeError('`font` must be one of type `StandardFonts`');
        var embedder = (0, $b2a95496f8f41048$export$2e2bcd8739ae039).for(font, customName);
        var ref = this.context.nextRef();
        var pdfFont = (0, $9982052d55be794b$export$2e2bcd8739ae039).of(ref, this, embedder);
        this.fonts.push(pdfFont);
        return pdfFont;
    };
    /**
     * Embed a JPEG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                      |
     * | ------------- | ------------------------------------------------------------- |
     * | `string`      | A base64 encoded string (or data URI) containing a JPEG image |
     * | `Uint8Array`  | The raw bytes of a JPEG image                                 |
     * | `ArrayBuffer` | The raw bytes of a JPEG image                                 |
     *
     * For example:
     * ```js
     * // jpg=string
     * const image1 = await pdfDoc.embedJpg('/9j/4AAQSkZJRgABAQAAAQABAAD/2wBD...')
     * const image2 = await pdfDoc.embedJpg('data:image/jpeg;base64,/9j/4AAQ...')
     *
     * // jpg=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('cat_riding_unicorn.jpg')
     * const image3 = await pdfDoc.embedJpg(uint8Array)
     *
     * // jpg=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedJpg(arrayBuffer)
     * ```
     *
     * @param jpg The input data for a JPEG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedJpg = function(jpg) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $fYigW.assertIs)(jpg, 'jpg', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $9uJGW.toUint8Array)(jpg);
                        return [
                            4 /*yield*/ ,
                            (0, $b0d34f0e58769ca2$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $2c09e59199b6bc75$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed a PNG image into this document. The input data can be provided in
     * multiple formats:
     *
     * | Type          | Contents                                                     |
     * | ------------- | ------------------------------------------------------------ |
     * | `string`      | A base64 encoded string (or data URI) containing a PNG image |
     * | `Uint8Array`  | The raw bytes of a PNG image                                 |
     * | `ArrayBuffer` | The raw bytes of a PNG image                                 |
     *
     * For example:
     * ```js
     * // png=string
     * const image1 = await pdfDoc.embedPng('iVBORw0KGgoAAAANSUhEUgAAAlgAAAF3...')
     * const image2 = await pdfDoc.embedPng('data:image/png;base64,iVBORw0KGg...')
     *
     * // png=Uint8Array
     * import fs from 'fs'
     * const uint8Array = fs.readFileSync('small_mario.png')
     * const image3 = await pdfDoc.embedPng(uint8Array)
     *
     * // png=ArrayBuffer
     * const url = 'https://pdf-lib.js.org/assets/small_mario.png'
     * const arrayBuffer = await fetch(url).then(res => res.arrayBuffer())
     * const image4 = await pdfDoc.embedPng(arrayBuffer)
     * ```
     *
     * @param png The input data for a PNG image.
     * @returns Resolves with the embedded image.
     */ PDFDocument.prototype.embedPng = function(png) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var bytes, embedder, ref, pdfImage;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $fYigW.assertIs)(png, 'png', [
                            'string',
                            Uint8Array,
                            ArrayBuffer
                        ]);
                        bytes = (0, $9uJGW.toUint8Array)(png);
                        return [
                            4 /*yield*/ ,
                            (0, $3c0d99ae5c827c27$export$2e2bcd8739ae039).for(bytes)
                        ];
                    case 1:
                        embedder = _a.sent();
                        ref = this.context.nextRef();
                        pdfImage = (0, $2c09e59199b6bc75$export$2e2bcd8739ae039).of(ref, this, embedder);
                        this.images.push(pdfImage);
                        return [
                            2 /*return*/ ,
                            pdfImage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 of `sourcePdf` into `pdfDoc`
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, [73])
     * ```
     *
     * See [[PDFDocument.load]] for examples of the allowed input data formats.
     *
     * @param pdf The input data containing a PDF document.
     * @param indices The indices of the pages that should be embedded.
     * @returns Resolves with an array of the embedded pages.
     */ PDFDocument.prototype.embedPdf = function(pdf, indices) {
        if (indices === void 0) indices = [
            0
        ];
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var srcDoc, _a, srcPages;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        (0, $fYigW.assertIs)(pdf, 'pdf', [
                            'string',
                            Uint8Array,
                            ArrayBuffer,
                            [
                                PDFDocument,
                                'PDFDocument'
                            ]
                        ]);
                        (0, $fYigW.assertIs)(indices, 'indices', [
                            Array
                        ]);
                        if (!(pdf instanceof PDFDocument)) return [
                            3 /*break*/ ,
                            1
                        ];
                        _a = pdf;
                        return [
                            3 /*break*/ ,
                            3
                        ];
                    case 1:
                        return [
                            4 /*yield*/ ,
                            PDFDocument.load(pdf)
                        ];
                    case 2:
                        _a = _b.sent();
                        _b.label = 3;
                    case 3:
                        srcDoc = _a;
                        srcPages = (0, $9uJGW.pluckIndices)(srcDoc.getPages(), indices);
                        return [
                            2 /*return*/ ,
                            this.embedPages(srcPages)
                        ];
                }
            });
        });
    };
    /**
     * Embed a single PDF page into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     * const sourcePdfPage = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPage = await pdfDoc.embedPage(
     *   sourcePdfPage,
     *
     *   // Clip a section of the source page so that we only embed part of it
     *   { left: 100, right: 450, bottom: 330, top: 570 },
     *
     *   // Translate all drawings of the embedded page by (10, 200) units
     *   [1, 0, 0, 1, 10, 200],
     * )
     * ```
     *
     * @param page The page to be embedded.
     * @param boundingBox
     * Optionally, an area of the source page that should be embedded
     * (defaults to entire page).
     * @param transformationMatrix
     * Optionally, a transformation matrix that is always applied to the embedded
     * page anywhere it is drawn.
     * @returns Resolves with the embedded pdf page.
     */ PDFDocument.prototype.embedPage = function(page, boundingBox, transformationMatrix) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var embeddedPage;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        (0, $fYigW.assertIs)(page, 'page', [
                            [
                                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                                'PDFPage'
                            ]
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.embedPages([
                                page
                            ], [
                                boundingBox
                            ], [
                                transformationMatrix
                            ])
                        ];
                    case 1:
                        embeddedPage = _a.sent()[0];
                        return [
                            2 /*return*/ ,
                            embeddedPage
                        ];
                }
            });
        });
    };
    /**
     * Embed one or more PDF pages into this document.
     *
     * For example:
     * ```js
     * const pdfDoc = await PDFDocument.create()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourceBuffer = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     * const sourcePdfDoc = await PDFDocument.load(sourceBuffer)
     *
     * const page1 = sourcePdfDoc.getPages()[0]
     * const page2 = sourcePdfDoc.getPages()[52]
     * const page3 = sourcePdfDoc.getPages()[73]
     *
     * const embeddedPages = await pdfDoc.embedPages([page1, page2, page3])
     * ```
     *
     * @param page
     * The pages to be embedded (they must all share the same context).
     * @param boundingBoxes
     * Optionally, an array of clipping boundaries - one for each page
     * (defaults to entirety of each page).
     * @param transformationMatrices
     * Optionally, an array of transformation matrices - one for each page
     * (each page's transformation will apply anywhere it is drawn).
     * @returns Resolves with an array of the embedded pdf pages.
     */ PDFDocument.prototype.embedPages = function(pages, boundingBoxes, transformationMatrices) {
        if (boundingBoxes === void 0) boundingBoxes = [];
        if (transformationMatrices === void 0) transformationMatrices = [];
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var idx, len, currPage, nextPage, context, maybeCopyPage, embeddedPages, idx, len, page, box, matrix, embedder, ref;
            var _a;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        if (pages.length === 0) return [
                            2 /*return*/ ,
                            []
                        ];
                        // Assert all pages have the same context
                        for(idx = 0, len = pages.length - 1; idx < len; idx++){
                            currPage = pages[idx];
                            nextPage = pages[idx + 1];
                            if (currPage.node.context !== nextPage.node.context) throw new (0, $1jVcF.PageEmbeddingMismatchedContextError)();
                        }
                        context = pages[0].node.context;
                        maybeCopyPage = context === this.context ? function(p) {
                            return p;
                        } : (0, $0e849e39b0ca1497$export$2e2bcd8739ae039).for(context, this.context).copy;
                        embeddedPages = new Array(pages.length);
                        idx = 0, len = pages.length;
                        _b.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        page = maybeCopyPage(pages[idx].node);
                        box = boundingBoxes[idx];
                        matrix = transformationMatrices[idx];
                        return [
                            4 /*yield*/ ,
                            (0, $6a885455e88efc51$export$2e2bcd8739ae039).for(page, box, matrix)
                        ];
                    case 2:
                        embedder = _b.sent();
                        ref = this.context.nextRef();
                        embeddedPages[idx] = (0, $1fe054a60e239076$export$2e2bcd8739ae039).of(ref, this, embedder);
                        _b.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        (_a = this.embeddedPages).push.apply(_a, embeddedPages);
                        return [
                            2 /*return*/ ,
                            embeddedPages
                        ];
                }
            });
        });
    };
    /**
     * > **NOTE:** You shouldn't need to call this method directly. The [[save]]
     * > and [[saveAsBase64]] methods will automatically ensure that all embedded
     * > assets are flushed before serializing the document.
     *
     * Flush all embedded fonts, PDF pages, and images to this document's
     * [[context]].
     *
     * @returns Resolves when the flush is complete.
     */ PDFDocument.prototype.flush = function() {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.fonts)
                        ];
                    case 1:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.images)
                        ];
                    case 2:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedPages)
                        ];
                    case 3:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.embeddedFiles)
                        ];
                    case 4:
                        _a.sent();
                        return [
                            4 /*yield*/ ,
                            this.embedAll(this.javaScripts)
                        ];
                    case 5:
                        _a.sent();
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to an array of bytes making up a PDF file.
     * For example:
     * ```js
     * const pdfBytes = await pdfDoc.save()
     * ```
     *
     * There are a number of things you can do with the serialized document,
     * depending on the JavaScript environment you're running in:
     * * Write it to a file in Node or React Native
     * * Download it as a Blob in the browser
     * * Render it in an `iframe`
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with the bytes of the serialized document.
     */ PDFDocument.prototype.save = function(options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, useObjectStreams, _b, addDefaultPage, _c, objectsPerTick, _d, updateFieldAppearances, form, Writer;
            return (0, $70JnX.__generator)(this, function(_e) {
                switch(_e.label){
                    case 0:
                        _a = options.useObjectStreams, useObjectStreams = _a === void 0 ? true : _a, _b = options.addDefaultPage, addDefaultPage = _b === void 0 ? true : _b, _c = options.objectsPerTick, objectsPerTick = _c === void 0 ? 50 : _c, _d = options.updateFieldAppearances, updateFieldAppearances = _d === void 0 ? true : _d;
                        (0, $fYigW.assertIs)(useObjectStreams, 'useObjectStreams', [
                            'boolean'
                        ]);
                        (0, $fYigW.assertIs)(addDefaultPage, 'addDefaultPage', [
                            'boolean'
                        ]);
                        (0, $fYigW.assertIs)(objectsPerTick, 'objectsPerTick', [
                            'number'
                        ]);
                        (0, $fYigW.assertIs)(updateFieldAppearances, 'updateFieldAppearances', [
                            'boolean'
                        ]);
                        if (addDefaultPage && this.getPageCount() === 0) this.addPage();
                        if (updateFieldAppearances) {
                            form = this.formCache.getValue();
                            if (form) form.updateFieldAppearances();
                        }
                        return [
                            4 /*yield*/ ,
                            this.flush()
                        ];
                    case 1:
                        _e.sent();
                        Writer = useObjectStreams ? (0, $343225d647cb5158$export$2e2bcd8739ae039) : (0, $f2f3b70d990f0d2f$export$2e2bcd8739ae039);
                        return [
                            2 /*return*/ ,
                            Writer.forContext(this.context, objectsPerTick).serializeToBuffer()
                        ];
                }
            });
        });
    };
    /**
     * Serialize this document to a base64 encoded string or data URI making up a
     * PDF file. For example:
     * ```js
     * const base64String = await pdfDoc.saveAsBase64()
     * base64String // => 'JVBERi0xLjcKJYGBgYEKC...'
     *
     * const base64DataUri = await pdfDoc.saveAsBase64({ dataUri: true })
     * base64DataUri // => 'data:application/pdf;base64,JVBERi0xLjcKJYGBgYEKC...'
     * ```
     *
     * @param options The options to be used when saving the document.
     * @returns Resolves with a base64 encoded string or data URI of the
     *          serialized document.
     */ PDFDocument.prototype.saveAsBase64 = function(options) {
        if (options === void 0) options = {};
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var _a, dataUri, otherOptions, bytes, base64;
            return (0, $70JnX.__generator)(this, function(_b) {
                switch(_b.label){
                    case 0:
                        _a = options.dataUri, dataUri = _a === void 0 ? false : _a, otherOptions = (0, $70JnX.__rest)(options, [
                            "dataUri"
                        ]);
                        (0, $fYigW.assertIs)(dataUri, 'dataUri', [
                            'boolean'
                        ]);
                        return [
                            4 /*yield*/ ,
                            this.save(otherOptions)
                        ];
                    case 1:
                        bytes = _b.sent();
                        base64 = (0, $h8dd0.encodeToBase64)(bytes);
                        return [
                            2 /*return*/ ,
                            dataUri ? "data:application/pdf;base64," + base64 : base64
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.findPageForAnnotationRef = function(ref) {
        var pages = this.getPages();
        for(var idx = 0, len = pages.length; idx < len; idx++){
            var page = pages[idx];
            var annotations = page.node.Annots();
            if ((annotations === null || annotations === void 0 ? void 0 : annotations.indexOf(ref)) !== undefined) return page;
        }
        return undefined;
    };
    PDFDocument.prototype.embedAll = function(embeddables) {
        return (0, $70JnX.__awaiter)(this, void 0, void 0, function() {
            var idx, len;
            return (0, $70JnX.__generator)(this, function(_a) {
                switch(_a.label){
                    case 0:
                        idx = 0, len = embeddables.length;
                        _a.label = 1;
                    case 1:
                        if (!(idx < len)) return [
                            3 /*break*/ ,
                            4
                        ];
                        return [
                            4 /*yield*/ ,
                            embeddables[idx].embed()
                        ];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        idx++;
                        return [
                            3 /*break*/ ,
                            1
                        ];
                    case 4:
                        return [
                            2 /*return*/ 
                        ];
                }
            });
        });
    };
    PDFDocument.prototype.updateInfoDict = function() {
        var pdfLib = "pdf-lib (https://github.com/Hopding/pdf-lib)";
        var now = new Date();
        var info = this.getInfoDict();
        this.setProducer(pdfLib);
        this.setModificationDate(now);
        if (!info.get((0, $btXS2.default).of('Creator'))) this.setCreator(pdfLib);
        if (!info.get((0, $btXS2.default).of('CreationDate'))) this.setCreationDate(now);
    };
    PDFDocument.prototype.getInfoDict = function() {
        var existingInfo = this.context.lookup(this.context.trailerInfo.Info);
        if (existingInfo instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) return existingInfo;
        var newInfo = this.context.obj({});
        this.context.trailerInfo.Info = this.context.register(newInfo);
        return newInfo;
    };
    PDFDocument.prototype.assertFontkit = function() {
        if (!this.fontkit) throw new (0, $071c8956483bdcac$export$529a7c74d0636a48)();
        return this.fontkit;
    };
    return PDFDocument;
}();
var $c8198d59b2f6ab16$export$2e2bcd8739ae039 = $c8198d59b2f6ab16$var$PDFDocument;
/* tslint:disable-next-line only-arrow-functions */ function $c8198d59b2f6ab16$var$assertIsLiteralOrHexString(pdfObject) {
    if (!(pdfObject instanceof (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039)) && !(pdfObject instanceof (0, $47c89398cba1043c$export$2e2bcd8739ae039))) throw new (0, $1jVcF.UnexpectedObjectTypeError)([
        (0, $2b3daf6a3e32a14e$export$2e2bcd8739ae039),
        (0, $47c89398cba1043c$export$2e2bcd8739ae039)
    ], pdfObject);
}





var $2d7363b4c64ff6aa$export$c9b8fe72ac71821;
(function(BlendMode) {
    BlendMode["Normal"] = "Normal";
    BlendMode["Multiply"] = "Multiply";
    BlendMode["Screen"] = "Screen";
    BlendMode["Overlay"] = "Overlay";
    BlendMode["Darken"] = "Darken";
    BlendMode["Lighten"] = "Lighten";
    BlendMode["ColorDodge"] = "ColorDodge";
    BlendMode["ColorBurn"] = "ColorBurn";
    BlendMode["HardLight"] = "HardLight";
    BlendMode["SoftLight"] = "SoftLight";
    BlendMode["Difference"] = "Difference";
    BlendMode["Exclusion"] = "Exclusion";
})($2d7363b4c64ff6aa$export$c9b8fe72ac71821 || ($2d7363b4c64ff6aa$export$c9b8fe72ac71821 = {}));





var $cUVc9 = parcelRequire("cUVc9");
var $btXS2 = parcelRequire("btXS2");
parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
var $c6a2W = parcelRequire("c6a2W");
var $3JpTw = parcelRequire("3JpTw");
/**
 * Represents a single page of a [[PDFDocument]].
 */ var $f470fd80980f0cb4$var$PDFPage = /** @class */ function() {
    function PDFPage(leafNode, ref, doc) {
        this.fontSize = 24;
        this.fontColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        this.lineHeight = 24;
        this.x = 0;
        this.y = 0;
        (0, $fYigW.assertIs)(leafNode, 'leafNode', [
            [
                (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039),
                'PDFPageLeaf'
            ]
        ]);
        (0, $fYigW.assertIs)(ref, 'ref', [
            [
                (0, $d2803e164f1400b0$export$2e2bcd8739ae039),
                'PDFRef'
            ]
        ]);
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        this.node = leafNode;
        this.ref = ref;
        this.doc = doc;
    }
    /**
     * Rotate this page by a multiple of 90 degrees. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * page.setRotation(degrees(-90))
     * page.setRotation(degrees(0))
     * page.setRotation(degrees(90))
     * page.setRotation(degrees(180))
     * page.setRotation(degrees(270))
     * ```
     * @param angle The angle to rotate this page.
     */ PDFPage.prototype.setRotation = function(angle) {
        var degreesAngle = (0, $1adec95b95f779ee$export$56cb859c01fa134d)(angle);
        (0, $fYigW.assertMultiple)(degreesAngle, 'degreesAngle', 90);
        this.node.set((0, $btXS2.default).of('Rotate'), this.doc.context.obj(degreesAngle));
    };
    /**
     * Get this page's rotation angle in degrees. For example:
     * ```js
     * const rotationAngle = page.getRotation().angle;
     * ```
     * @returns The rotation angle of the page in degrees (always a multiple of
     *          90 degrees).
     */ PDFPage.prototype.getRotation = function() {
        var Rotate = this.node.Rotate();
        return (0, $1adec95b95f779ee$export$41fc368e1a942b97)(Rotate ? Rotate.asNumber() : 0);
    };
    /**
     * Resize this page by increasing or decreasing its width and height. For
     * example:
     * ```js
     * page.setSize(250, 500)
     * page.setSize(page.getWidth() + 50, page.getHeight() + 100)
     * page.setSize(page.getWidth() - 50, page.getHeight() - 100)
     * ```
     *
     * Note that the PDF specification does not allow for pages to have explicit
     * widths and heights. Instead it defines the "size" of a page in terms of
     * five rectangles: the MediaBox, CropBox, BleedBox, TrimBox, and ArtBox. As a
     * result, this method cannot directly change the width and height of a page.
     * Instead, it works by adjusting these five boxes.
     *
     * This method performs the following steps:
     *   1. Set width & height of MediaBox.
     *   2. Set width & height of CropBox, if it has same dimensions as MediaBox.
     *   3. Set width & height of BleedBox, if it has same dimensions as MediaBox.
     *   4. Set width & height of TrimBox, if it has same dimensions as MediaBox.
     *   5. Set width & height of ArtBox, if it has same dimensions as MediaBox.
     *
     * This approach works well for most PDF documents as all PDF pages must
     * have a MediaBox, but relatively few have a CropBox, BleedBox, TrimBox, or
     * ArtBox. And when they do have these additional boxes, they often have the
     * same dimensions as the MediaBox. However, if you find this method does not
     * work for your document, consider setting the boxes directly:
     *   * [[PDFPage.setMediaBox]]
     *   * [[PDFPage.setCropBox]]
     *   * [[PDFPage.setBleedBox]]
     *   * [[PDFPage.setTrimBox]]
     *   * [[PDFPage.setArtBox]]
     *
     * @param width The new width of the page.
     * @param height The new height of the page.
     */ PDFPage.prototype.setSize = function(width, height) {
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.getMediaBox();
        this.setMediaBox(mediaBox.x, mediaBox.y, width, height);
        var cropBox = this.getCropBox();
        var bleedBox = this.getBleedBox();
        var trimBox = this.getTrimBox();
        var artBox = this.getArtBox();
        var hasCropBox = this.node.CropBox();
        var hasBleedBox = this.node.BleedBox();
        var hasTrimBox = this.node.TrimBox();
        var hasArtBox = this.node.ArtBox();
        if (hasCropBox && (0, $3JpTw.rectanglesAreEqual)(cropBox, mediaBox)) this.setCropBox(mediaBox.x, mediaBox.y, width, height);
        if (hasBleedBox && (0, $3JpTw.rectanglesAreEqual)(bleedBox, mediaBox)) this.setBleedBox(mediaBox.x, mediaBox.y, width, height);
        if (hasTrimBox && (0, $3JpTw.rectanglesAreEqual)(trimBox, mediaBox)) this.setTrimBox(mediaBox.x, mediaBox.y, width, height);
        if (hasArtBox && (0, $3JpTw.rectanglesAreEqual)(artBox, mediaBox)) this.setArtBox(mediaBox.x, mediaBox.y, width, height);
    };
    /**
     * Resize this page by increasing or decreasing its width. For example:
     * ```js
     * page.setWidth(250)
     * page.setWidth(page.getWidth() + 50)
     * page.setWidth(page.getWidth() - 50)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's width.
     *
     * @param width The new width of the page.
     */ PDFPage.prototype.setWidth = function(width) {
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        this.setSize(width, this.getSize().height);
    };
    /**
     * Resize this page by increasing or decreasing its height. For example:
     * ```js
     * page.setHeight(500)
     * page.setHeight(page.getWidth() + 100)
     * page.setHeight(page.getWidth() - 100)
     * ```
     *
     * This method uses [[PDFPage.setSize]] to set the page's height.
     *
     * @param height The new height of the page.
     */ PDFPage.prototype.setHeight = function(height) {
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        this.setSize(this.getSize().width, height);
    };
    /**
     * Set the MediaBox of this page. For example:
     * ```js
     * const mediaBox = page.getMediaBox()
     *
     * page.setMediaBox(0, 0, 250, 500)
     * page.setMediaBox(mediaBox.x, mediaBox.y, 50, 100)
     * page.setMediaBox(15, 5, mediaBox.width - 50, mediaBox.height - 100)
     * ```
     *
     * See [[PDFPage.getMediaBox]] for details about what the MediaBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new MediaBox.
     * @param y The y coordinate of the lower left corner of the new MediaBox.
     * @param width The width of the new MediaBox.
     * @param height The height of the new MediaBox.
     */ PDFPage.prototype.setMediaBox = function(x, y, width, height) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var mediaBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $btXS2.default).MediaBox, mediaBox);
    };
    /**
     * Set the CropBox of this page. For example:
     * ```js
     * const cropBox = page.getCropBox()
     *
     * page.setCropBox(0, 0, 250, 500)
     * page.setCropBox(cropBox.x, cropBox.y, 50, 100)
     * page.setCropBox(15, 5, cropBox.width - 50, cropBox.height - 100)
     * ```
     *
     * See [[PDFPage.getCropBox]] for details about what the CropBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new CropBox.
     * @param y The y coordinate of the lower left corner of the new CropBox.
     * @param width The width of the new CropBox.
     * @param height The height of the new CropBox.
     */ PDFPage.prototype.setCropBox = function(x, y, width, height) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var cropBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $btXS2.default).CropBox, cropBox);
    };
    /**
     * Set the BleedBox of this page. For example:
     * ```js
     * const bleedBox = page.getBleedBox()
     *
     * page.setBleedBox(0, 0, 250, 500)
     * page.setBleedBox(bleedBox.x, bleedBox.y, 50, 100)
     * page.setBleedBox(15, 5, bleedBox.width - 50, bleedBox.height - 100)
     * ```
     *
     * See [[PDFPage.getBleedBox]] for details about what the BleedBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new BleedBox.
     * @param y The y coordinate of the lower left corner of the new BleedBox.
     * @param width The width of the new BleedBox.
     * @param height The height of the new BleedBox.
     */ PDFPage.prototype.setBleedBox = function(x, y, width, height) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var bleedBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $btXS2.default).BleedBox, bleedBox);
    };
    /**
     * Set the TrimBox of this page. For example:
     * ```js
     * const trimBox = page.getTrimBox()
     *
     * page.setTrimBox(0, 0, 250, 500)
     * page.setTrimBox(trimBox.x, trimBox.y, 50, 100)
     * page.setTrimBox(15, 5, trimBox.width - 50, trimBox.height - 100)
     * ```
     *
     * See [[PDFPage.getTrimBox]] for details about what the TrimBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new TrimBox.
     * @param y The y coordinate of the lower left corner of the new TrimBox.
     * @param width The width of the new TrimBox.
     * @param height The height of the new TrimBox.
     */ PDFPage.prototype.setTrimBox = function(x, y, width, height) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var trimBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $btXS2.default).TrimBox, trimBox);
    };
    /**
     * Set the ArtBox of this page. For example:
     * ```js
     * const artBox = page.getArtBox()
     *
     * page.setArtBox(0, 0, 250, 500)
     * page.setArtBox(artBox.x, artBox.y, 50, 100)
     * page.setArtBox(15, 5, artBox.width - 50, artBox.height - 100)
     * ```
     *
     * See [[PDFPage.getArtBox]] for details about what the ArtBox represents.
     *
     * @param x The x coordinate of the lower left corner of the new ArtBox.
     * @param y The y coordinate of the lower left corner of the new ArtBox.
     * @param width The width of the new ArtBox.
     * @param height The height of the new ArtBox.
     */ PDFPage.prototype.setArtBox = function(x, y, width, height) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(width, 'width', [
            'number'
        ]);
        (0, $fYigW.assertIs)(height, 'height', [
            'number'
        ]);
        var artBox = this.doc.context.obj([
            x,
            y,
            x + width,
            y + height
        ]);
        this.node.set((0, $btXS2.default).ArtBox, artBox);
    };
    /**
     * Get this page's width and height. For example:
     * ```js
     * const { width, height } = page.getSize()
     * ```
     *
     * This method uses [[PDFPage.getMediaBox]] to obtain the page's
     * width and height.
     *
     * @returns The width and height of the page.
     */ PDFPage.prototype.getSize = function() {
        var _a = this.getMediaBox(), width = _a.width, height = _a.height;
        return {
            width: width,
            height: height
        };
    };
    /**
     * Get this page's width. For example:
     * ```js
     * const width = page.getWidth()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The width of the page.
     */ PDFPage.prototype.getWidth = function() {
        return this.getSize().width;
    };
    /**
     * Get this page's height. For example:
     * ```js
     * const height = page.getHeight()
     * ```
     *
     * This method uses [[PDFPage.getSize]] to obtain the page's size.
     *
     * @returns The height of the page.
     */ PDFPage.prototype.getHeight = function() {
        return this.getSize().height;
    };
    /**
     * Get the rectangle defining this page's MediaBox. For example:
     * ```js
     * const { x, y, width, height } = page.getMediaBox()
     * ```
     *
     * The MediaBox of a page defines the boundaries of the physical medium on
     * which the page is to be displayed/printed. It may include extended area
     * surrounding the page content for bleed marks, printing marks, etc...
     * It may also include areas close to the edges of the medium that cannot be
     * marked because of physical limitations of the output device. Content
     * falling outside this boundary may safely be discarded without affecting
     * the meaning of the PDF file.
     *
     * @returns An object defining the lower left corner of the MediaBox and its
     *          width & height.
     */ PDFPage.prototype.getMediaBox = function() {
        var mediaBox = this.node.MediaBox();
        return mediaBox.asRectangle();
    };
    /**
     * Get the rectangle defining this page's CropBox. For example:
     * ```js
     * const { x, y, width, height } = page.getCropBox()
     * ```
     *
     * The CropBox of a page defines the region to which the contents of the page
     * shall be clipped when displayed or printed. Unlike the other boxes, the
     * CropBox does not necessarily represent the physical page geometry. It
     * merely imposes clipping on the page contents.
     *
     * The CropBox's default value is the page's MediaBox.
     *
     * @returns An object defining the lower left corner of the CropBox and its
     *          width & height.
     */ PDFPage.prototype.getCropBox = function() {
        var _a;
        var cropBox = this.node.CropBox();
        return (_a = cropBox === null || cropBox === void 0 ? void 0 : cropBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getMediaBox();
    };
    /**
     * Get the rectangle defining this page's BleedBox. For example:
     * ```js
     * const { x, y, width, height } = page.getBleedBox()
     * ```
     *
     * The BleedBox of a page defines the region to which the contents of the
     * page shall be clipped when output in a production environment. This may
     * include any extra bleed area needed to accommodate the physical
     * limitations of cutting, folding, and trimming equipment. The actual
     * printed page may include printing marks that fall outside the BleedBox.
     *
     * The BleedBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the BleedBox and its
     *          width & height.
     */ PDFPage.prototype.getBleedBox = function() {
        var _a;
        var bleedBox = this.node.BleedBox();
        return (_a = bleedBox === null || bleedBox === void 0 ? void 0 : bleedBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's TrimBox. For example:
     * ```js
     * const { x, y, width, height } = page.getTrimBox()
     * ```
     *
     * The TrimBox of a page defines the intended dimensions of the finished
     * page after trimming. It may be smaller than the MediaBox to allow for
     * production-related content, such as printing instructions, cut marks, or
     * color bars.
     *
     * The TrimBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the TrimBox and its
     *          width & height.
     */ PDFPage.prototype.getTrimBox = function() {
        var _a;
        var trimBox = this.node.TrimBox();
        return (_a = trimBox === null || trimBox === void 0 ? void 0 : trimBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Get the rectangle defining this page's ArtBox. For example:
     * ```js
     * const { x, y, width, height } = page.getArtBox()
     * ```
     *
     * The ArtBox of a page defines the extent of the page's meaningful content
     * (including potential white space).
     *
     * The ArtBox's default value is the page's CropBox.
     *
     * @returns An object defining the lower left corner of the ArtBox and its
     *          width & height.
     */ PDFPage.prototype.getArtBox = function() {
        var _a;
        var artBox = this.node.ArtBox();
        return (_a = artBox === null || artBox === void 0 ? void 0 : artBox.asRectangle()) !== null && _a !== void 0 ? _a : this.getCropBox();
    };
    /**
     * Translate this page's content to a new location on the page. This operation
     * is often useful after resizing the page with [[setSize]]. For example:
     * ```js
     * // Add 50 units of whitespace to the top and right of the page
     * page.setSize(page.getWidth() + 50, page.getHeight() + 50)
     *
     * // Move the page's content from the lower-left corner of the page
     * // to the top-right corner.
     * page.translateContent(50, 50)
     *
     * // Now there are 50 units of whitespace to the left and bottom of the page
     * ```
     * See also: [[resetPosition]]
     * @param x The new position on the x-axis for this page's content.
     * @param y The new position on the y-axis for this page's content.
     */ PDFPage.prototype.translateContent = function(x, y) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $6bb514fadaf8543d$export$cb182c48e35739ac)(), (0, $6bb514fadaf8543d$export$d73ee8ef04f5226a)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $6bb514fadaf8543d$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the size, content, and annotations of a page.
     *
     * For example:
     * ```js
     * page.scale(0.5, 0.5);
     * ```
     *
     * @param x The factor by which the width for the page should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the height for the page should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scale = function(x, y) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        this.setSize(this.getWidth() * x, this.getHeight() * y);
        this.scaleContent(x, y);
        this.scaleAnnotations(x, y);
    };
    /**
     * Scale the content of a page. This is useful after resizing an existing
     * page. This scales only the content, not the annotations.
     *
     * For example:
     * ```js
     * // Bisect the size of the page
     * page.setSize(page.getWidth() / 2, page.getHeight() / 2);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     * ```
     * See also: [[scaleAnnotations]]
     * @param x The factor by which the x-axis for the content should be scaled
     *          (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the content should be scaled
     *          (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleContent = function(x, y) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        this.node.normalize();
        this.getContentStream();
        var start = this.createContentStream((0, $6bb514fadaf8543d$export$cb182c48e35739ac)(), (0, $6bb514fadaf8543d$export$dcdf75081b88279d)(x, y));
        var startRef = this.doc.context.register(start);
        var end = this.createContentStream((0, $6bb514fadaf8543d$export$10581a6f45bf75eb)());
        var endRef = this.doc.context.register(end);
        this.node.wrapContentStreams(startRef, endRef);
    };
    /**
     * Scale the annotations of a page. This is useful if you want to scale a
     * page with comments or other annotations.
     * ```js
     * // Scale the content of the page down by 50% in x and y
     * page.scaleContent(0.5, 0.5);
     *
     * // Scale the content of the page down by 50% in x and y
     * page.scaleAnnotations(0.5, 0.5);
     * ```
     * See also: [[scaleContent]]
     * @param x The factor by which the x-axis for the annotations should be
     *          scaled (e.g. `0.5` is 50%).
     * @param y The factor by which the y-axis for the annotations should be
     *          scaled (e.g. `2.0` is 200%).
     */ PDFPage.prototype.scaleAnnotations = function(x, y) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        var annots = this.node.Annots();
        if (!annots) return;
        for(var idx = 0; idx < annots.size(); idx++){
            var annot = annots.lookup(idx);
            if (annot instanceof (0, $a128f87a2ae876f3$export$2e2bcd8739ae039)) this.scaleAnnot(annot, x, y);
        }
    };
    /**
     * Reset the x and y coordinates of this page to `(0, 0)`. This operation is
     * often useful after calling [[translateContent]]. For example:
     * ```js
     * // Shift the page's contents up and to the right by 50 units
     * page.translateContent(50, 50)
     *
     * // This text will shifted - it will be drawn at (50, 50)
     * page.drawText('I am shifted')
     *
     * // Move back to (0, 0)
     * page.resetPosition()
     *
     * // This text will not be shifted - it will be drawn at (0, 0)
     * page.drawText('I am not shifted')
     * ```
     */ PDFPage.prototype.resetPosition = function() {
        this.getContentStream(false);
        this.x = 0;
        this.y = 0;
    };
    /**
     * Choose a default font for this page. The default font will be used whenever
     * text is drawn on this page and no font is specified. For example:
     * ```js
     * import { StandardFonts } from 'pdf-lib'
     *
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const courierFont = await pdfDoc.embedFont(StandardFonts.Courier)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     * page.drawText('I will be drawn in Helvetica')
     *
     * page.setFont(timesRomanFont)
     * page.drawText('I will be drawn in Courier', { font: courierFont })
     * ```
     * @param font The default font to be used when drawing text on this page.
     */ PDFPage.prototype.setFont = function(font) {
        // TODO: Reuse image Font name if we've already added this image to Resources.Fonts
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.font = font;
        this.fontKey = this.node.newFontDictionary(this.font.name, this.font.ref);
    };
    /**
     * Choose a default font size for this page. The default font size will be
     * used whenever text is drawn on this page and no font size is specified.
     * For example:
     * ```js
     * page.setFontSize(12)
     * page.drawText('I will be drawn in size 12')
     *
     * page.setFontSize(36)
     * page.drawText('I will be drawn in size 24', { fontSize: 24 })
     * ```
     * @param fontSize The default font size to be used when drawing text on this
     *                 page.
     */ PDFPage.prototype.setFontSize = function(fontSize) {
        (0, $fYigW.assertIs)(fontSize, 'fontSize', [
            'number'
        ]);
        this.fontSize = fontSize;
    };
    /**
     * Choose a default font color for this page. The default font color will be
     * used whenever text is drawn on this page and no font color is specified.
     * For example:
     * ```js
     * import { rgb, cmyk, grayscale } from 'pdf-lib'
     *
     * page.setFontColor(rgb(0.97, 0.02, 0.97))
     * page.drawText('I will be drawn in pink')
     *
     * page.setFontColor(cmyk(0.4, 0.7, 0.39, 0.15))
     * page.drawText('I will be drawn in gray', { color: grayscale(0.5) })
     * ```
     * @param fontColor The default font color to be used when drawing text on
     *                  this page.
     */ PDFPage.prototype.setFontColor = function(fontColor) {
        (0, $fYigW.assertIs)(fontColor, 'fontColor', [
            [
                Object,
                'Color'
            ]
        ]);
        this.fontColor = fontColor;
    };
    /**
     * Choose a default line height for this page. The default line height will be
     * used whenever text is drawn on this page and no line height is specified.
     * For example:
     * ```js
     * page.setLineHeight(12);
     * page.drawText('These lines will be vertically \n separated by 12 units')
     *
     * page.setLineHeight(36);
     * page.drawText('These lines will be vertically \n separated by 24 units', {
     *   lineHeight: 24
     * })
     * ```
     * @param lineHeight The default line height to be used when drawing text on
     *                   this page.
     */ PDFPage.prototype.setLineHeight = function(lineHeight) {
        (0, $fYigW.assertIs)(lineHeight, 'lineHeight', [
            'number'
        ]);
        this.lineHeight = lineHeight;
    };
    /**
     * Get the default position of this page. For example:
     * ```js
     * const { x, y } = page.getPosition()
     * ```
     * @returns The default position of the page.
     */ PDFPage.prototype.getPosition = function() {
        return {
            x: this.x,
            y: this.y
        };
    };
    /**
     * Get the default x coordinate of this page. For example:
     * ```js
     * const x = page.getX()
     * ```
     * @returns The default x coordinate of the page.
     */ PDFPage.prototype.getX = function() {
        return this.x;
    };
    /**
     * Get the default y coordinate of this page. For example:
     * ```js
     * const y = page.getY()
     * ```
     * @returns The default y coordinate of the page.
     */ PDFPage.prototype.getY = function() {
        return this.y;
    };
    /**
     * Change the default position of this page. For example:
     * ```js
     * page.moveTo(0, 0)
     * page.drawText('I will be drawn at the origin')
     *
     * page.moveTo(0, 25)
     * page.drawText('I will be drawn 25 units up')
     *
     * page.moveTo(25, 25)
     * page.drawText('I will be drawn 25 units up and 25 units to the right')
     * ```
     * @param x The new default position on the x-axis for this page.
     * @param y The new default position on the y-axis for this page.
     */ PDFPage.prototype.moveTo = function(x, y) {
        (0, $fYigW.assertIs)(x, 'x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(y, 'y', [
            'number'
        ]);
        this.x = x;
        this.y = y;
    };
    /**
     * Change the default position of this page to be further down the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveDown(10)
     * page.drawText('I will be drawn at (50, 40)')
     * ```
     * @param yDecrease The amount by which the page's default position along the
     *                  y-axis should be decreased.
     */ PDFPage.prototype.moveDown = function(yDecrease) {
        (0, $fYigW.assertIs)(yDecrease, 'yDecrease', [
            'number'
        ]);
        this.y -= yDecrease;
    };
    /**
     * Change the default position of this page to be further up the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveUp(10)
     * page.drawText('I will be drawn at (50, 60)')
     * ```
     * @param yIncrease The amount by which the page's default position along the
     *                  y-axis should be increased.
     */ PDFPage.prototype.moveUp = function(yIncrease) {
        (0, $fYigW.assertIs)(yIncrease, 'yIncrease', [
            'number'
        ]);
        this.y += yIncrease;
    };
    /**
     * Change the default position of this page to be further left on the x-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveLeft(10)
     * page.drawText('I will be drawn at (40, 50)')
     * ```
     * @param xDecrease The amount by which the page's default position along the
     *                  x-axis should be decreased.
     */ PDFPage.prototype.moveLeft = function(xDecrease) {
        (0, $fYigW.assertIs)(xDecrease, 'xDecrease', [
            'number'
        ]);
        this.x -= xDecrease;
    };
    /**
     * Change the default position of this page to be further right on the y-axis.
     * For example:
     * ```js
     * page.moveTo(50, 50)
     * page.drawText('I will be drawn at (50, 50)')
     *
     * page.moveRight(10)
     * page.drawText('I will be drawn at (60, 50)')
     * ```
     * @param xIncrease The amount by which the page's default position along the
     *                  x-axis should be increased.
     */ PDFPage.prototype.moveRight = function(xIncrease) {
        (0, $fYigW.assertIs)(xIncrease, 'xIncrease', [
            'number'
        ]);
        this.x += xIncrease;
    };
    /**
     * Push one or more operators to the end of this page's current content
     * stream. For example:
     * ```js
     * import {
     *   pushGraphicsState,
     *   moveTo,
     *   lineTo,
     *   closePath,
     *   setFillingColor,
     *   rgb,
     *   fill,
     *   popGraphicsState,
     * } from 'pdf-lib'
     *
     * // Draw a green triangle in the lower-left corner of the page
     * page.pushOperators(
     *   pushGraphicsState(),
     *   moveTo(0, 0),
     *   lineTo(100, 0),
     *   lineTo(50, 100),
     *   closePath(),
     *   setFillingColor(rgb(0.0, 1.0, 0.0)),
     *   fill(),
     *   popGraphicsState(),
     * )
     * ```
     * @param operator The operators to be pushed.
     */ PDFPage.prototype.pushOperators = function() {
        var operator = [];
        for(var _i = 0; _i < arguments.length; _i++)operator[_i] = arguments[_i];
        (0, $fYigW.assertEachIs)(operator, 'operator', [
            [
                (0, $0b9dd4dab9c74310$export$2e2bcd8739ae039),
                'PDFOperator'
            ]
        ]);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, operator);
    };
    /**
     * Draw one or more lines of text on this page. For example:
     * ```js
     * import { StandardFonts, rgb } from 'pdf-lib'
     *
     * const helveticaFont = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const timesRomanFont = await pdfDoc.embedFont(StandardFonts.TimesRoman)
     *
     * const page = pdfDoc.addPage()
     *
     * page.setFont(helveticaFont)
     *
     * page.moveTo(5, 200)
     * page.drawText('The Life of an Egg', { size: 36 })
     *
     * page.moveDown(36)
     * page.drawText('An Epic Tale of Woe', { size: 30 })
     *
     * page.drawText(
     *   `Humpty Dumpty sat on a wall \n` +
     *   `Humpty Dumpty had a great fall; \n` +
     *   `All the king's horses and all the king's men \n` +
     *   `Couldn't put Humpty together again. \n`,
     *   {
     *     x: 25,
     *     y: 100,
     *     font: timesRomanFont,
     *     size: 24,
     *     color: rgb(1, 0, 0),
     *     lineHeight: 24,
     *     opacity: 0.75,
     *   },
     * )
     * ```
     * @param text The text to be drawn.
     * @param options The options to be used when drawing the text.
     */ PDFPage.prototype.drawText = function(text, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        (0, $fYigW.assertIs)(text, 'text', [
            'string'
        ]);
        (0, $fYigW.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertOrUndefined)(options.font, 'options.font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.size, 'options.size', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.lineHeight, 'options.lineHeight', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.maxWidth, 'options.maxWidth', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.wordBreaks, 'options.wordBreaks', [
            Array
        ]);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var _h = this.setOrEmbedFont(options.font), oldFont = _h.oldFont, newFont = _h.newFont, newFontKey = _h.newFontKey;
        var fontSize = options.size || this.fontSize;
        var wordBreaks = options.wordBreaks || this.doc.defaultWordBreaks;
        var textWidth = function(t) {
            return newFont.widthOfTextAtSize(t, fontSize);
        };
        var lines = options.maxWidth === undefined ? (0, $c6a2W.lineSplit)((0, $c6a2W.cleanText)(text)) : (0, $c6a2W.breakTextIntoLines)(text, wordBreaks, options.maxWidth, textWidth);
        var encodedLines = new Array(lines.length);
        for(var idx = 0, len = lines.length; idx < len; idx++)encodedLines[idx] = newFont.encodeText(lines[idx]);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$f7b8b44d3d84bc26)(encodedLines, {
            color: (_a = options.color) !== null && _a !== void 0 ? _a : this.fontColor,
            font: newFontKey,
            size: fontSize,
            rotate: (_b = options.rotate) !== null && _b !== void 0 ? _b : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (_c = options.xSkew) !== null && _c !== void 0 ? _c : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (_d = options.ySkew) !== null && _d !== void 0 ? _d : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            x: (_e = options.x) !== null && _e !== void 0 ? _e : this.x,
            y: (_f = options.y) !== null && _f !== void 0 ? _f : this.y,
            lineHeight: (_g = options.lineHeight) !== null && _g !== void 0 ? _g : this.lineHeight,
            graphicsState: graphicsStateKey
        }));
        if (options.font) {
            if (oldFont) this.setFont(oldFont);
            else this.resetFont();
        }
    };
    /**
     * Draw an image on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const jpgUrl = 'https://pdf-lib.js.org/assets/cat_riding_unicorn.jpg'
     * const jpgImageBytes = await fetch(jpgUrl).then((res) => res.arrayBuffer())
     *
     * const jpgImage = await pdfDoc.embedJpg(jpgImageBytes)
     * const jpgDims = jpgImage.scale(0.5)
     *
     * const page = pdfDoc.addPage()
     *
     * page.drawImage(jpgImage, {
     *   x: 25,
     *   y: 25,
     *   width: jpgDims.width,
     *   height: jpgDims.height,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     * @param image The image to be drawn.
     * @param options The options to be used when drawing the image.
     */ PDFPage.prototype.drawImage = function(image, options) {
        var _a, _b, _c, _d, _e, _f, _g;
        if (options === void 0) options = {};
        // TODO: Reuse image XObject name if we've already added this image to Resources.XObjects
        (0, $fYigW.assertIs)(image, 'image', [
            [
                (0, $2c09e59199b6bc75$export$2e2bcd8739ae039),
                'PDFImage'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('Image', image.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$21a059be5bfd5fb)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : image.size().width,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : image.size().height,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an embedded PDF page on this page. For example:
     * ```js
     * import { degrees } from 'pdf-lib'
     *
     * const pdfDoc = await PDFDocument.create()
     * const page = pdfDoc.addPage()
     *
     * const sourcePdfUrl = 'https://pdf-lib.js.org/assets/with_large_page_count.pdf'
     * const sourcePdf = await fetch(sourcePdfUrl).then((res) => res.arrayBuffer())
     *
     * // Embed page 74 from the PDF
     * const [embeddedPage] = await pdfDoc.embedPdf(sourcePdf, 73)
     *
     * page.drawPage(embeddedPage, {
     *   x: 250,
     *   y: 200,
     *   xScale: 0.5,
     *   yScale: 0.5,
     *   rotate: degrees(30),
     *   opacity: 0.75,
     * })
     * ```
     *
     * The `options` argument accepts both `width`/`height` and `xScale`/`yScale`
     * as options. Since each of these options defines the size of the drawn page,
     * if both options are given, `width` and `height` take precedence and the
     * corresponding scale variants are ignored.
     *
     * @param embeddedPage The embedded page to be drawn.
     * @param options The options to be used when drawing the embedded page.
     */ PDFPage.prototype.drawPage = function(embeddedPage, options) {
        var _a, _b, _c, _d, _e;
        if (options === void 0) options = {};
        // TODO: Reuse embeddedPage XObject name if we've already added this embeddedPage to Resources.XObjects
        (0, $fYigW.assertIs)(embeddedPage, 'embeddedPage', [
            [
                (0, $1fe054a60e239076$export$2e2bcd8739ae039),
                'PDFEmbeddedPage'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var xObjectKey = this.node.newXObject('EmbeddedPdfPage', embeddedPage.ref);
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            blendMode: options.blendMode
        });
        // prettier-ignore
        var xScale = options.width !== undefined ? options.width / embeddedPage.width : options.xScale !== undefined ? options.xScale : 1;
        // prettier-ignore
        var yScale = options.height !== undefined ? options.height / embeddedPage.height : options.yScale !== undefined ? options.yScale : 1;
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$f8ea28c31069cbc9)(xObjectKey, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: xScale,
            yScale: yScale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (_d = options.xSkew) !== null && _d !== void 0 ? _d : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (_e = options.ySkew) !== null && _e !== void 0 ? _e : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw an SVG path on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * const svgPath = 'M 0,20 L 100,160 Q 130,200 150,120 C 190,-40 200,200 300,150 L 400,90'
     *
     * // Draw path as black line
     * page.drawSvgPath(svgPath, { x: 25, y: 75 })
     *
     * // Change border style and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 275,
     *   borderColor: rgb(0.5, 0.5, 0.5),
     *   borderWidth: 2,
     *   borderOpacity: 0.75,
     * })
     *
     * // Set fill color and opacity
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 475,
     *   color: rgb(1.0, 0, 0),
     *   opacity: 0.75,
     * })
     *
     * // Draw 50% of original size
     * page.drawSvgPath(svgPath, {
     *   x: 25,
     *   y: 675,
     *   scale: 0.5,
     * })
     * ```
     * @param path The SVG path to be drawn.
     * @param options The options to be used when drawing the SVG path.
     */ PDFPage.prototype.drawSvgPath = function(path, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        if (options === void 0) options = {};
        (0, $fYigW.assertIs)(path, 'path', [
            'string'
        ]);
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.scale, 'options.scale', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $6bb514fadaf8543d$export$7a77bc708e50709e));
        (0, $fYigW.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.borderColor = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$47c8a640c39d0756)(path, {
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            scale: options.scale,
            rotate: (_c = options.rotate) !== null && _c !== void 0 ? _c : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            color: (_d = options.color) !== null && _d !== void 0 ? _d : undefined,
            borderColor: (_e = options.borderColor) !== null && _e !== void 0 ? _e : undefined,
            borderWidth: (_f = options.borderWidth) !== null && _f !== void 0 ? _f : 0,
            borderDashArray: (_g = options.borderDashArray) !== null && _g !== void 0 ? _g : undefined,
            borderDashPhase: (_h = options.borderDashPhase) !== null && _h !== void 0 ? _h : undefined,
            borderLineCap: (_j = options.borderLineCap) !== null && _j !== void 0 ? _j : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a line on this page. For example:
     * ```js
     * import { rgb } from 'pdf-lib'
     *
     * page.drawLine({
     *   start: { x: 25, y: 75 },
     *   end: { x: 125, y: 175 },
     *   thickness: 2,
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the line.
     */ PDFPage.prototype.drawLine = function(options) {
        var _a, _b, _c, _d, _e;
        (0, $fYigW.assertIs)(options.start, 'options.start', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $fYigW.assertIs)(options.end, 'options.end', [
            [
                Object,
                '{ x: number, y: number }'
            ]
        ]);
        (0, $fYigW.assertIs)(options.start.x, 'options.start.x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(options.start.y, 'options.start.y', [
            'number'
        ]);
        (0, $fYigW.assertIs)(options.end.x, 'options.end.x', [
            'number'
        ]);
        (0, $fYigW.assertIs)(options.end.y, 'options.end.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.thickness, 'options.thickness', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.dashArray, 'options.dashArray', [
            Array
        ]);
        (0, $fYigW.assertOrUndefined)(options.dashPhase, 'options.dashPhase', [
            'number'
        ]);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.lineCap, 'options.lineCap', (0, $6bb514fadaf8543d$export$7a77bc708e50709e));
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            borderOpacity: options.opacity,
            blendMode: options.blendMode
        });
        if (!('color' in options)) options.color = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$819db45aec5fcbe5)({
            start: options.start,
            end: options.end,
            thickness: (_a = options.thickness) !== null && _a !== void 0 ? _a : 1,
            color: (_b = options.color) !== null && _b !== void 0 ? _b : undefined,
            dashArray: (_c = options.dashArray) !== null && _c !== void 0 ? _c : undefined,
            dashPhase: (_d = options.dashPhase) !== null && _d !== void 0 ? _d : undefined,
            lineCap: (_e = options.lineCap) !== null && _e !== void 0 ? _e : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a rectangle on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawRectangle({
     *   x: 25,
     *   y: 75,
     *   width: 250,
     *   height: 75,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the rectangle.
     */ PDFPage.prototype.drawRectangle = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        if (options === void 0) options = {};
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.width, 'options.width', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.height, 'options.height', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.xSkew, 'options.xSkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.ySkew, 'options.ySkew', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $6bb514fadaf8543d$export$7a77bc708e50709e));
        (0, $fYigW.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$cac848e0621718d8)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            width: (_c = options.width) !== null && _c !== void 0 ? _c : 150,
            height: (_d = options.height) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            xSkew: (_f = options.xSkew) !== null && _f !== void 0 ? _f : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            ySkew: (_g = options.ySkew) !== null && _g !== void 0 ? _g : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            color: (_j = options.color) !== null && _j !== void 0 ? _j : undefined,
            borderColor: (_k = options.borderColor) !== null && _k !== void 0 ? _k : undefined,
            borderDashArray: (_l = options.borderDashArray) !== null && _l !== void 0 ? _l : undefined,
            borderDashPhase: (_m = options.borderDashPhase) !== null && _m !== void 0 ? _m : undefined,
            graphicsState: graphicsStateKey,
            borderLineCap: (_o = options.borderLineCap) !== null && _o !== void 0 ? _o : undefined
        }));
    };
    /**
     * Draw a square on this page. For example:
     * ```js
     * import { degrees, grayscale, rgb } from 'pdf-lib'
     *
     * page.drawSquare({
     *   x: 25,
     *   y: 75,
     *   size: 100,
     *   rotate: degrees(-15),
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the square.
     */ PDFPage.prototype.drawSquare = function(options) {
        if (options === void 0) options = {};
        var size = options.size;
        (0, $fYigW.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawRectangle((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
            width: size,
            height: size
        }));
    };
    /**
     * Draw an ellipse on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawEllipse({
     *   x: 200,
     *   y: 75,
     *   xScale: 100,
     *   yScale: 50,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawEllipse = function(options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        if (options === void 0) options = {};
        (0, $fYigW.assertOrUndefined)(options.x, 'options.x', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.y, 'options.y', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.xScale, 'options.xScale', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.yScale, 'options.yScale', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.rotate, 'options.rotate', [
            [
                Object,
                'Rotation'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(options.color, 'options.color', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.opacity, 'opacity.opacity', 0, 1);
        (0, $fYigW.assertOrUndefined)(options.borderColor, 'options.borderColor', [
            [
                Object,
                'Color'
            ]
        ]);
        (0, $fYigW.assertRangeOrUndefined)(options.borderOpacity, 'options.borderOpacity', 0, 1);
        (0, $fYigW.assertOrUndefined)(options.borderWidth, 'options.borderWidth', [
            'number'
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashArray, 'options.borderDashArray', [
            Array
        ]);
        (0, $fYigW.assertOrUndefined)(options.borderDashPhase, 'options.borderDashPhase', [
            'number'
        ]);
        (0, $fYigW.assertIsOneOfOrUndefined)(options.borderLineCap, 'options.borderLineCap', (0, $6bb514fadaf8543d$export$7a77bc708e50709e));
        (0, $fYigW.assertIsOneOfOrUndefined)(options.blendMode, 'options.blendMode', (0, $2d7363b4c64ff6aa$export$c9b8fe72ac71821));
        var graphicsStateKey = this.maybeEmbedGraphicsState({
            opacity: options.opacity,
            borderOpacity: options.borderOpacity,
            blendMode: options.blendMode
        });
        if (!('color' in options) && !('borderColor' in options)) options.color = (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0);
        var contentStream = this.getContentStream();
        contentStream.push.apply(contentStream, (0, $cf63ff38d178ccc1$export$43c9e2bb0dc74582)({
            x: (_a = options.x) !== null && _a !== void 0 ? _a : this.x,
            y: (_b = options.y) !== null && _b !== void 0 ? _b : this.y,
            xScale: (_c = options.xScale) !== null && _c !== void 0 ? _c : 100,
            yScale: (_d = options.yScale) !== null && _d !== void 0 ? _d : 100,
            rotate: (_e = options.rotate) !== null && _e !== void 0 ? _e : undefined,
            color: (_f = options.color) !== null && _f !== void 0 ? _f : undefined,
            borderColor: (_g = options.borderColor) !== null && _g !== void 0 ? _g : undefined,
            borderWidth: (_h = options.borderWidth) !== null && _h !== void 0 ? _h : 0,
            borderDashArray: (_j = options.borderDashArray) !== null && _j !== void 0 ? _j : undefined,
            borderDashPhase: (_k = options.borderDashPhase) !== null && _k !== void 0 ? _k : undefined,
            borderLineCap: (_l = options.borderLineCap) !== null && _l !== void 0 ? _l : undefined,
            graphicsState: graphicsStateKey
        }));
    };
    /**
     * Draw a circle on this page. For example:
     * ```js
     * import { grayscale, rgb } from 'pdf-lib'
     *
     * page.drawCircle({
     *   x: 200,
     *   y: 150,
     *   size: 100,
     *   borderWidth: 5,
     *   borderColor: grayscale(0.5),
     *   color: rgb(0.75, 0.2, 0.2),
     *   opacity: 0.5,
     *   borderOpacity: 0.75,
     * })
     * ```
     * @param options The options to be used when drawing the ellipse.
     */ PDFPage.prototype.drawCircle = function(options) {
        if (options === void 0) options = {};
        var _a = options.size, size = _a === void 0 ? 100 : _a;
        (0, $fYigW.assertOrUndefined)(size, 'size', [
            'number'
        ]);
        this.drawEllipse((0, $70JnX.__assign)((0, $70JnX.__assign)({}, options), {
            xScale: size,
            yScale: size
        }));
    };
    PDFPage.prototype.setOrEmbedFont = function(font) {
        var oldFont = this.font;
        var oldFontKey = this.fontKey;
        if (font) this.setFont(font);
        else this.getFont();
        var newFont = this.font;
        var newFontKey = this.fontKey;
        return {
            oldFont: oldFont,
            oldFontKey: oldFontKey,
            newFont: newFont,
            newFontKey: newFontKey
        };
    };
    PDFPage.prototype.getFont = function() {
        if (!this.font || !this.fontKey) {
            var font = this.doc.embedStandardFont((0, $3f3628f4443054b9$export$7dcb046109e65a3d).Helvetica);
            this.setFont(font);
        }
        return [
            this.font,
            this.fontKey
        ];
    };
    PDFPage.prototype.resetFont = function() {
        this.font = undefined;
        this.fontKey = undefined;
    };
    PDFPage.prototype.getContentStream = function(useExisting) {
        if (useExisting === void 0) useExisting = true;
        if (useExisting && this.contentStream) return this.contentStream;
        this.contentStream = this.createContentStream();
        this.contentStreamRef = this.doc.context.register(this.contentStream);
        this.node.addContentStream(this.contentStreamRef);
        return this.contentStream;
    };
    PDFPage.prototype.createContentStream = function() {
        var operators = [];
        for(var _i = 0; _i < arguments.length; _i++)operators[_i] = arguments[_i];
        var dict = this.doc.context.obj({});
        var contentStream = (0, $0cd7a4dbcbade137$export$2e2bcd8739ae039).of(dict, operators);
        return contentStream;
    };
    PDFPage.prototype.maybeEmbedGraphicsState = function(options) {
        var opacity = options.opacity, borderOpacity = options.borderOpacity, blendMode = options.blendMode;
        if (opacity === undefined && borderOpacity === undefined && blendMode === undefined) return undefined;
        var graphicsState = this.doc.context.obj({
            Type: 'ExtGState',
            ca: opacity,
            CA: borderOpacity,
            BM: blendMode
        });
        var key = this.node.newExtGState('GS', graphicsState);
        return key;
    };
    PDFPage.prototype.scaleAnnot = function(annot, x, y) {
        var selectors = [
            'RD',
            'CL',
            'Vertices',
            'QuadPoints',
            'L',
            'Rect'
        ];
        for(var idx = 0, len = selectors.length; idx < len; idx++){
            var list = annot.lookup((0, $btXS2.default).of(selectors[idx]));
            if (list instanceof (0, $cUVc9.default)) list.scalePDFNumbers(x, y);
        }
        var inkLists = annot.lookup((0, $btXS2.default).of('InkList'));
        if (inkLists instanceof (0, $cUVc9.default)) for(var idx = 0, len = inkLists.size(); idx < len; idx++){
            var arr = inkLists.lookup(idx);
            if (arr instanceof (0, $cUVc9.default)) arr.scalePDFNumbers(x, y);
        }
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]] from an existing leaf node.
     *
     * @param leafNode The leaf node to be wrapped.
     * @param ref The unique reference for the page.
     * @param doc The document to which the page will belong.
     */ PDFPage.of = function(leafNode, ref, doc) {
        return new PDFPage(leafNode, ref, doc);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFDocument.addPage]] and [[PDFDocument.insertPage]]
     * > methods, which can create instances of [[PDFPage]] for you.
     *
     * Create an instance of [[PDFPage]].
     *
     * @param doc The document to which the page will belong.
     */ PDFPage.create = function(doc) {
        (0, $fYigW.assertIs)(doc, 'doc', [
            [
                (0, $c8198d59b2f6ab16$export$2e2bcd8739ae039),
                'PDFDocument'
            ]
        ]);
        var dummyRef = (0, $d2803e164f1400b0$export$2e2bcd8739ae039).of(-1);
        var pageLeaf = (0, $2bc0df8a0eb000e9$export$2e2bcd8739ae039).withContextAndParent(doc.context, dummyRef);
        var pageRef = doc.context.register(pageLeaf);
        return new PDFPage(pageLeaf, pageRef, doc);
    };
    return PDFPage;
}();
var $f470fd80980f0cb4$export$2e2bcd8739ae039 = $f470fd80980f0cb4$var$PDFPage;









parcelRequire("JEL7f");
var $fYigW = parcelRequire("fYigW");
/**
 * Represents a button field of a [[PDFForm]].
 *
 * [[PDFButton]] fields are interactive controls that users can click with their
 * mouse. This type of [[PDFField]] is not stateful. The purpose of a button
 * is to perform an action when the user clicks on it, such as opening a print
 * modal or resetting the form. Buttons are typically rectangular in shape and
 * have a text label describing the action that they perform when clicked.
 */ var $888b65c91f171a50$var$PDFButton = /** @class */ function(_super) {
    (0, $70JnX.__extends)(PDFButton, _super);
    function PDFButton(acroPushButton, ref, doc) {
        var _this = _super.call(this, acroPushButton, ref, doc) || this;
        (0, $fYigW.assertIs)(acroPushButton, 'acroButton', [
            [
                (0, $3cdc71d89ed382a8$export$2e2bcd8739ae039),
                'PDFAcroPushButton'
            ]
        ]);
        _this.acroField = acroPushButton;
        return _this;
    }
    /**
     * Display an image inside the bounds of this button's widgets. For example:
     * ```js
     * const pngImage = await pdfDoc.embedPng(...)
     * const button = form.getButton('some.button.field')
     * button.setImage(pngImage, ImageAlignment.Center)
     * ```
     * This will update the appearances streams for each of this button's widgets.
     * @param image The image that should be displayed.
     * @param alignment The alignment of the image.
     */ PDFButton.prototype.setImage = function(image, alignment) {
        if (alignment === void 0) alignment = (0, $ffba0304b419c0f0$export$8efa99ca8f041e7e).Center;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var streamRef = this.createImageAppearanceStream(widget, image, alignment);
            this.updateWidgetAppearances(widget, {
                normal: streamRef
            });
        }
        this.markAsClean();
    };
    /**
     * Set the font size for this field. Larger font sizes will result in larger
     * text being displayed when PDF readers render this button. Font sizes may
     * be integer or floating point numbers. Supplying a negative font size will
     * cause this method to throw an error.
     *
     * For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * button.setFontSize(4)
     * button.setFontSize(15.7)
     * ```
     *
     * > This method depends upon the existence of a default appearance
     * > (`/DA`) string. If this field does not have a default appearance string,
     * > or that string does not contain a font size (via the `Tf` operator),
     * > then this method will throw an error.
     *
     * @param fontSize The font size to be used when rendering text in this field.
     */ PDFButton.prototype.setFontSize = function(fontSize) {
        (0, $fYigW.assertPositive)(fontSize, 'fontSize');
        this.acroField.setFontSize(fontSize);
        this.markAsDirty();
    };
    /**
     * Show this button on the specified page with the given text. For example:
     * ```js
     * const ubuntuFont = await pdfDoc.embedFont(ubuntuFontBytes)
     * const page = pdfDoc.addPage()
     *
     * const form = pdfDoc.getForm()
     * const button = form.createButton('some.button.field')
     *
     * button.addToPage('Do Stuff', page, {
     *   x: 50,
     *   y: 75,
     *   width: 200,
     *   height: 100,
     *   textColor: rgb(1, 0, 0),
     *   backgroundColor: rgb(0, 1, 0),
     *   borderColor: rgb(0, 0, 1),
     *   borderWidth: 2,
     *   rotate: degrees(90),
     *   font: ubuntuFont,
     * })
     * ```
     * This will create a new widget for this button field.
     * @param text The text to be displayed for this button widget.
     * @param page The page to which this button widget should be added.
     * @param options The options to be used when adding this button widget.
     */ PDFButton.prototype.addToPage = function(// TODO: This needs to be optional, e.g. for image buttons
    text, page, options) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        (0, $fYigW.assertOrUndefined)(text, 'text', [
            'string'
        ]);
        (0, $fYigW.assertOrUndefined)(page, 'page', [
            [
                (0, $f470fd80980f0cb4$export$2e2bcd8739ae039),
                'PDFPage'
            ]
        ]);
        (0, $0a2bc0f9ee5488f0$export$55643210f1835a35)(options);
        // Create a widget for this button
        var widget = this.createWidget({
            x: ((_a = options === null || options === void 0 ? void 0 : options.x) !== null && _a !== void 0 ? _a : 0) - ((_b = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _b !== void 0 ? _b : 0) / 2,
            y: ((_c = options === null || options === void 0 ? void 0 : options.y) !== null && _c !== void 0 ? _c : 0) - ((_d = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _d !== void 0 ? _d : 0) / 2,
            width: (_e = options === null || options === void 0 ? void 0 : options.width) !== null && _e !== void 0 ? _e : 100,
            height: (_f = options === null || options === void 0 ? void 0 : options.height) !== null && _f !== void 0 ? _f : 50,
            textColor: (_g = options === null || options === void 0 ? void 0 : options.textColor) !== null && _g !== void 0 ? _g : (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0, 0, 0),
            backgroundColor: (_h = options === null || options === void 0 ? void 0 : options.backgroundColor) !== null && _h !== void 0 ? _h : (0, $883da9eab467c3c8$export$8972dc0e6ad9238f)(0.75, 0.75, 0.75),
            borderColor: options === null || options === void 0 ? void 0 : options.borderColor,
            borderWidth: (_j = options === null || options === void 0 ? void 0 : options.borderWidth) !== null && _j !== void 0 ? _j : 0,
            rotate: (_k = options === null || options === void 0 ? void 0 : options.rotate) !== null && _k !== void 0 ? _k : (0, $1adec95b95f779ee$export$41fc368e1a942b97)(0),
            caption: text,
            hidden: options === null || options === void 0 ? void 0 : options.hidden,
            page: page.ref
        });
        var widgetRef = this.doc.context.register(widget.dict);
        // Add widget to this field
        this.acroField.addWidget(widgetRef);
        // Set appearance streams for widget
        var font = (_l = options === null || options === void 0 ? void 0 : options.font) !== null && _l !== void 0 ? _l : this.doc.getForm().getDefaultFont();
        this.updateWidgetAppearance(widget, font);
        // Add widget to the given page
        page.node.addAnnot(widgetRef);
    };
    /**
     * Returns `true` if this button has been marked as dirty, or if any of this
     * button's widgets do not have an appearance stream. For example:
     * ```js
     * const button = form.getButton('some.button.field')
     * if (button.needsAppearancesUpdate()) console.log('Needs update')
     * ```
     * @returns Whether or not this button needs an appearance update.
     */ PDFButton.prototype.needsAppearancesUpdate = function() {
        var _a;
        if (this.isDirty()) return true;
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            var hasAppearances = ((_a = widget.getAppearances()) === null || _a === void 0 ? void 0 : _a.normal) instanceof (0, $cdfe10fee47b0c90$export$2e2bcd8739ae039);
            if (!hasAppearances) return true;
        }
        return false;
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the default appearance provider for buttons. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.defaultUpdateAppearances(helvetica)
     * ```
     * @param font The font to be used for creating the appearance streams.
     */ PDFButton.prototype.defaultUpdateAppearances = function(font) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        this.updateAppearances(font);
    };
    /**
     * Update the appearance streams for each of this button's widgets using
     * the given appearance provider. If no `provider` is passed, the default
     * appearance provider for buttons will be used. For example:
     * ```js
     * const helvetica = await pdfDoc.embedFont(StandardFonts.Helvetica)
     * const button = form.getButton('some.button.field')
     * button.updateAppearances(helvetica, (field, widget, font) => {
     *   ...
     *   return {
     *     normal: drawButton(...),
     *     down: drawButton(...),
     *   }
     * })
     * ```
     * @param font The font to be used for creating the appearance streams.
     * @param provider Optionally, the appearance provider to be used for
     *                 generating the contents of the appearance streams.
     */ PDFButton.prototype.updateAppearances = function(font, provider) {
        (0, $fYigW.assertIs)(font, 'font', [
            [
                (0, $9982052d55be794b$export$2e2bcd8739ae039),
                'PDFFont'
            ]
        ]);
        (0, $fYigW.assertOrUndefined)(provider, 'provider', [
            Function
        ]);
        var widgets = this.acroField.getWidgets();
        for(var idx = 0, len = widgets.length; idx < len; idx++){
            var widget = widgets[idx];
            this.updateWidgetAppearance(widget, font, provider);
        }
    };
    PDFButton.prototype.updateWidgetAppearance = function(widget, font, provider) {
        var apProvider = provider !== null && provider !== void 0 ? provider : (0, $bb10ac27e6f27957$export$68f9b19f48ffeeec);
        var appearances = (0, $bb10ac27e6f27957$export$8a3aea031520d39b)(apProvider(this, widget, font));
        this.updateWidgetAppearanceWithFont(widget, font, appearances);
    };
    /**
     * > **NOTE:** You probably don't want to call this method directly. Instead,
     * > consider using the [[PDFForm.getButton]] method, which will create an
     * > instance of [[PDFButton]] for you.
     *
     * Create an instance of [[PDFButton]] from an existing acroPushButton and ref
     *
     * @param acroPushButton The underlying `PDFAcroPushButton` for this button.
     * @param ref The unique reference for this button.
     * @param doc The document to which this button will belong.
     */ PDFButton.of = function(acroPushButton, ref, doc) {
        return new PDFButton(acroPushButton, ref, doc);
    };
    return PDFButton;
}((0, $0a2bc0f9ee5488f0$export$2e2bcd8739ae039));
var $888b65c91f171a50$export$2e2bcd8739ae039 = $888b65c91f171a50$var$PDFButton;




































var $bec259e74507538d$exports = {};


parcelRequire("JEL7f");
$parcel$exportWildcard($c4c3496a922e0fe8$exports, $bec259e74507538d$exports);



var $ajWU5 = parcelRequire("ajWU5");
function $78afc7a7197e166b$export$38de6a934e5ef13() {
    const pdfFile = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pdfFile');
    const pdfFileNameSpan = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pdfFileName');
    const nextButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nextToImageSelect');
    if (!pdfFile || !pdfFileNameSpan || !nextButton) {
        console.warn("PDF\u9078\u629E\u753B\u9762\u306EDOM\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002");
        return;
    }
    pdfFile.onchange = (event)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
            const target = event.target;
            if (target.files && target.files.length > 0) {
                (0, $fb4c7c5aada7368a$export$b538fd7a9cc7f22b)(target.files[0]);
                (0, $fb4c7c5aada7368a$export$51cb8b3d5d1d2fee)((0, $fb4c7c5aada7368a$export$ca26e1dd869a40e));
                pdfFileNameSpan.textContent = (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).name;
                try {
                    const pdfBytes = yield (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).arrayBuffer();
                    const loadingTask = (0, $ajWU5).getDocument({
                        data: pdfBytes.slice(0)
                    }); // PDF.jsでドキュメントをロード
                    const pdf = yield loadingTask.promise;
                    (0, $fb4c7c5aada7368a$export$6fa298e0c95c9ddf)(pdf); // PDFドキュメントインスタンスをキャッシュ
                    const pdfDoc = yield $c8198d59b2f6ab16$export$2e2bcd8739ae039.load(pdfBytes); // グローバルなPDFLibを使用 (PDF-LIB用)
                    const pages = pdfDoc.getPages();
                    (0, $fb4c7c5aada7368a$export$725f9d85e8117bbe)(pages[0].getSize()); // 最初のページのサイズを取得
                } catch (error) {
                    console.error("PDF\u306E\u30DA\u30FC\u30B8\u30B5\u30A4\u30BA\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F:", error);
                    (0, $fb4c7c5aada7368a$export$725f9d85e8117bbe)({
                        width: 595.28,
                        height: 841.89
                    }); // エラー時はデフォルト(A4)に戻す
                }
            } else {
                (0, $fb4c7c5aada7368a$export$b538fd7a9cc7f22b)(null);
                pdfFileNameSpan.textContent = "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093";
                (0, $fb4c7c5aada7368a$export$725f9d85e8117bbe)({
                    width: 595.28,
                    height: 841.89
                });
            }
        })();
    nextButton.onclick = ()=>{
        if (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e) window.location.hash = '/image-select';
        else alert("PDF\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
    };
    // 既存のPDFファイルがあればプレビューを表示
    if (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e) {
        (0, $fb4c7c5aada7368a$export$51cb8b3d5d1d2fee)((0, $fb4c7c5aada7368a$export$ca26e1dd869a40e));
        pdfFileNameSpan.textContent = (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).name;
    }
}



var $1etvo = parcelRequire("1etvo");

var $kJBqN = parcelRequire("kJBqN");
var $ajWU5 = parcelRequire("ajWU5");

function $cdce58d4b9fe69a2$export$8d096eb89503b162(imageFileObjects) {
    const imagePreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imagePreviewContainer');
    if (!imagePreviewContainer) return;
    console.log("displayImagePreviews: \u8907\u6570\u753B\u50CF\u30D7\u30EC\u30D3\u30E5\u30FC\u8868\u793A\u95A2\u6570\u304C\u547C\u3073\u51FA\u3055\u308C\u307E\u3057\u305F\u3002");
    imagePreviewContainer.innerHTML = ''; // 以前のプレビューをクリア
    if (imageFileObjects.length === 0) {
        imagePreviewContainer.innerHTML = "<p>\u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3059\u308B\u3068\u3053\u3053\u306B\u30D7\u30EC\u30D3\u30E5\u30FC\u304C\u8868\u793A\u3055\u308C\u307E\u3059\u3002</p>";
        console.log("displayImagePreviews: \u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u304C\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093\u3002\u30E1\u30C3\u30BB\u30FC\u30B8\u3092\u8868\u793A\u3057\u307E\u3057\u305F\u3002");
        return;
    }
    imageFileObjects.forEach((imageObj, index)=>{
        console.log(`displayImagePreviews: \u{30D5}\u{30A1}\u{30A4}\u{30EB} ${index} (${imageObj.file.name}) \u{306E}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{3092}\u{8868}\u{793A}\u{4E2D}...`);
        $cdce58d4b9fe69a2$export$53ea044138b9e45d(imageObj.previewUrl, imageObj.file.name, imageObj.id); // imageObj.idを使用
    });
}
function $cdce58d4b9fe69a2$export$53ea044138b9e45d(src, fileName, id) {
    const imagePreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imagePreviewContainer');
    if (!imagePreviewContainer) return;
    const previewItem = document.createElement('div');
    previewItem.classList.add('image-preview-item');
    previewItem.dataset.id = id; // SortableJSのためにdataset.idを使用
    const dragHandle = document.createElement('div');
    dragHandle.classList.add('drag-handle');
    dragHandle.innerHTML = '<div></div><div></div><div></div>'; // 三本線アイコン
    const img = document.createElement('img');
    img.src = src;
    img.classList.add('image-preview');
    img.alt = fileName;
    const captionInputGroup = document.createElement('div');
    captionInputGroup.classList.add('inputs-wrapper', 'caption-input-group');
    const captionLabel = document.createElement('label');
    captionLabel.textContent = "\u30AD\u30E3\u30D7\u30B7\u30E7\u30F3:";
    captionLabel.htmlFor = `caption-input-${id}`;
    captionInputGroup.appendChild(captionLabel);
    const captionInput = document.createElement('input');
    captionInput.type = 'text';
    captionInput.id = `caption-input-${id}`;
    captionInput.classList.add('image-caption-input');
    captionInput.placeholder = "\u30AD\u30E3\u30D7\u30B7\u30E7\u30F3\u3092\u5165\u529B";
    captionInputGroup.appendChild(captionInput);
    const imageObj = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
    if (imageObj && imageObj.caption !== undefined) captionInput.value = imageObj.caption;
    else {
        captionInput.value = fileName;
        if (imageObj) imageObj.caption = fileName;
    }
    captionInput.addEventListener('input', (event)=>{
        const targetImage = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
        if (targetImage) {
            targetImage.caption = event.target.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
    });
    const removeButton = document.createElement('button');
    removeButton.classList.add('remove-image-btn');
    removeButton.textContent = 'X';
    removeButton.addEventListener('click', ()=>{
        $cdce58d4b9fe69a2$export$d65c55ff4ffe089f(id);
    });
    const captionFontSizeWrapper = document.createElement('div');
    captionFontSizeWrapper.classList.add('inputs-wrapper', 'caption-font-size-wrapper');
    const captionFontSizeLabel = document.createElement('label');
    captionFontSizeLabel.textContent = "\u30D5\u30A9\u30F3\u30C8\u30B5\u30A4\u30BA:";
    captionFontSizeWrapper.appendChild(captionFontSizeLabel);
    const captionFontSizeSlider = document.createElement('input');
    captionFontSizeSlider.type = 'range';
    captionFontSizeSlider.min = '5';
    captionFontSizeSlider.max = '30';
    captionFontSizeSlider.value = imageObj ? imageObj.captionFontSize : '10';
    captionFontSizeSlider.classList.add('caption-font-size-slider');
    captionFontSizeWrapper.appendChild(captionFontSizeSlider);
    const captionFontSizeNumber = document.createElement('input');
    captionFontSizeNumber.type = 'number';
    captionFontSizeNumber.min = '5';
    captionFontSizeNumber.max = '30';
    captionFontSizeNumber.value = imageObj ? imageObj.captionFontSize : '10';
    captionFontSizeNumber.classList.add('caption-font-size-number');
    captionFontSizeWrapper.appendChild(captionFontSizeNumber);
    captionFontSizeSlider.addEventListener('input', (event)=>{
        captionFontSizeNumber.value = event.target.value;
        const targetImage = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
        if (targetImage) {
            targetImage.captionFontSize = parseInt(event.target.value);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
    });
    captionFontSizeNumber.addEventListener('input', (event)=>{
        captionFontSizeSlider.value = event.target.value;
        const targetImage = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
        if (targetImage) {
            targetImage.captionFontSize = parseInt(event.target.value);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
    });
    const textAndControlsWrapper = document.createElement('div');
    textAndControlsWrapper.classList.add('inputs-wrapper', 'image-caption-controls-wrapper');
    textAndControlsWrapper.appendChild(captionInputGroup);
    textAndControlsWrapper.appendChild(captionFontSizeWrapper);
    const fontColorWrapper = document.createElement('div');
    fontColorWrapper.classList.add('inputs-wrapper', 'caption-font-color-wrapper');
    const fontColorLabel = document.createElement('label');
    fontColorLabel.textContent = "\u30D5\u30A9\u30F3\u30C8\u30AB\u30E9\u30FC:";
    fontColorWrapper.appendChild(fontColorLabel);
    const fontColorInput = document.createElement('input');
    fontColorInput.type = 'color';
    fontColorInput.value = imageObj ? imageObj.captionFontColor : '#000000';
    fontColorInput.classList.add('caption-font-color-input');
    fontColorWrapper.appendChild(fontColorInput);
    textAndControlsWrapper.appendChild(fontColorWrapper);
    fontColorInput.addEventListener('input', (event)=>{
        const targetImage = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
        if (targetImage) {
            targetImage.captionFontColor = event.target.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
    });
    const fontFamilyWrapper = document.createElement('div');
    fontFamilyWrapper.classList.add('inputs-wrapper', 'caption-font-family-wrapper');
    const fontFamilyLabel = document.createElement('label');
    fontFamilyLabel.textContent = "\u30D5\u30A9\u30F3\u30C8\u30D5\u30A1\u30DF\u30EA\u30FC:";
    fontFamilyWrapper.appendChild(fontFamilyLabel);
    const fontFamilySelect = document.createElement('select');
    fontFamilySelect.classList.add('caption-font-family-select');
    const fonts = [
        {
            value: 'Helvetica',
            text: 'Helvetica'
        },
        {
            value: 'Times-Roman',
            text: 'Times-Roman'
        },
        {
            value: 'Courier',
            text: 'Courier'
        },
        {
            value: 'ZapfDingbats',
            text: 'ZapfDingbats'
        },
        {
            value: 'Symbol',
            text: 'Symbol'
        },
        {
            value: 'NotoSansJP',
            text: 'Noto Sans JP'
        }
    ];
    fonts.forEach((font)=>{
        const option = document.createElement('option');
        option.value = font.value;
        option.textContent = font.text;
        fontFamilySelect.appendChild(option);
    });
    fontFamilySelect.value = imageObj ? imageObj.captionFontFamily : 'Helvetica';
    fontFamilyWrapper.appendChild(fontFamilySelect);
    textAndControlsWrapper.appendChild(fontFamilyWrapper);
    fontFamilySelect.addEventListener('change', (event)=>{
        const targetImage = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).find((item)=>item.id === id);
        if (targetImage) {
            targetImage.captionFontFamily = event.target.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
    });
    previewItem.appendChild(dragHandle);
    previewItem.appendChild(img);
    previewItem.appendChild(textAndControlsWrapper);
    previewItem.appendChild(removeButton);
    imagePreviewContainer.appendChild(previewItem);
    console.log(`displayImagePreviews: \u{30D5}\u{30A1}\u{30A4}\u{30EB} ${id} (${fileName}) \u{306E}\u{753B}\u{50CF}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{30A2}\u{30A4}\u{30C6}\u{30E0}\u{304C}\u{30B3}\u{30F3}\u{30C6}\u{30CA}\u{306B}\u{8FFD}\u{52A0}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}\u{3002}`);
}
function $cdce58d4b9fe69a2$export$d65c55ff4ffe089f(idToRemove) {
    const imageFileNamesSpan = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageFileNames');
    console.log(`removeImage: ID ${idToRemove} \u{306E}\u{753B}\u{50CF}\u{3092}\u{524A}\u{9664}\u{3057}\u{307E}\u{3059}\u{3002}`);
    const indexToRemove = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).findIndex((img)=>img.id === idToRemove);
    if (indexToRemove > -1) {
        if ((0, $fb4c7c5aada7368a$export$eba19cacbe4413)[indexToRemove] && (0, $fb4c7c5aada7368a$export$eba19cacbe4413)[indexToRemove].previewUrl) URL.revokeObjectURL((0, $fb4c7c5aada7368a$export$eba19cacbe4413)[indexToRemove].previewUrl);
        (0, $fb4c7c5aada7368a$export$eba19cacbe4413).splice(indexToRemove, 1);
        $cdce58d4b9fe69a2$export$8d096eb89503b162((0, $fb4c7c5aada7368a$export$eba19cacbe4413));
        (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        if (imageFileNamesSpan) imageFileNamesSpan.textContent = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).length > 0 ? `${(0, $fb4c7c5aada7368a$export$eba19cacbe4413).length} \u{500B}\u{306E}\u{753B}\u{50CF}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}` : "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093";
    }
}
function $cdce58d4b9fe69a2$export$938c1f6f80bafb78() {
    const imageFilesInput = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageFiles');
    const imageFileNamesSpan = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageFileNames');
    // プレビューURLを解放
    (0, $fb4c7c5aada7368a$export$eba19cacbe4413).forEach((imageObj)=>{
        if (imageObj.previewUrl) URL.revokeObjectURL(imageObj.previewUrl);
    });
    (0, $fb4c7c5aada7368a$export$7ec495ac665155d4)([]); // グローバルな画像ファイルリストをクリア
    $cdce58d4b9fe69a2$export$8d096eb89503b162((0, $fb4c7c5aada7368a$export$eba19cacbe4413)); // プレビュー表示をクリア
    (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)(); // リアルタイムプレビューもクリア
    if (imageFileNamesSpan) imageFileNamesSpan.textContent = "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093";
    // ファイル選択インプットをリセット
    if (imageFilesInput) imageFilesInput.value = '';
    console.log("\u9078\u629E\u3055\u308C\u305F\u753B\u50CF\u304C\u3059\u3079\u3066\u30AF\u30EA\u30A2\u3055\u308C\u307E\u3057\u305F\u3002");
}
function $cdce58d4b9fe69a2$export$bed4af8c9b9c2e64() {
    const imageFilesInput = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageFiles');
    const imageFileNamesSpan = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageFileNames');
    const prevButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('prevToPdfSelect');
    const clearButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('clearButton');
    const nextButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nextToResult');
    const imagePreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imagePreviewContainer');
    if (!imageFilesInput || !imageFileNamesSpan || !prevButton || !clearButton || !nextButton || !imagePreviewContainer) {
        console.warn("\u753B\u50CF\u9078\u629E\u753B\u9762\u306EDOM\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002");
        return;
    }
    imageFilesInput.onchange = (event)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
            const target = event.target;
            if (target.files && target.files.length > 0) {
                (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'flex';
                const newFiles = Array.from(target.files);
                const tempSelectedImageFiles = [];
                for (const file of newFiles){
                    let previewUrl = '';
                    let pdfEmbedBytes = null;
                    let pdfEmbedType = '';
                    if (file.type === 'image/heic' || file.type === 'image/heif' || file.name.toLowerCase().endsWith('.heic') || file.name.toLowerCase().endsWith('.heif')) try {
                        const arrayBuffer = yield file.arrayBuffer();
                        const buffer = (0, $kJBqN.Buffer).from(arrayBuffer);
                        const outputBuffer = yield (0, (/*@__PURE__*/$parcel$interopDefault($203bba2ce8792506$exports)))({
                            buffer: buffer,
                            format: 'JPEG',
                            quality: 0.7
                        });
                        const previewBlob = new Blob([
                            outputBuffer.buffer
                        ], {
                            type: 'image/jpeg'
                        });
                        previewUrl = URL.createObjectURL(previewBlob);
                        const pdfEmbedOutputBuffer = yield (0, (/*@__PURE__*/$parcel$interopDefault($203bba2ce8792506$exports)))({
                            buffer: buffer,
                            format: 'JPEG',
                            quality: 0.9
                        });
                        pdfEmbedBytes = pdfEmbedOutputBuffer.buffer;
                        pdfEmbedType = 'image/jpeg';
                    } catch (error) {
                        console.error(`HEIC\u{5909}\u{63DB}\u{30A8}\u{30E9}\u{30FC}: ${file.name}`, error);
                        previewUrl = URL.createObjectURL(file);
                        pdfEmbedBytes = yield file.arrayBuffer();
                        pdfEmbedType = file.type;
                    }
                    else {
                        previewUrl = URL.createObjectURL(file);
                        pdfEmbedBytes = yield file.arrayBuffer();
                        pdfEmbedType = file.type;
                    }
                    const img = new Image();
                    img.src = previewUrl;
                    yield new Promise((resolve)=>img.onload = resolve);
                    const aspectRatio = img.width / img.height;
                    const id = Date.now() + Math.random();
                    tempSelectedImageFiles.push({
                        id: id,
                        file: file,
                        previewUrl: previewUrl,
                        pdfEmbedBytes: pdfEmbedBytes,
                        pdfEmbedType: pdfEmbedType,
                        aspectRatio: aspectRatio,
                        caption: file.name,
                        captionFontSize: 10,
                        captionFontColor: '#000000',
                        captionFontFamily: 'NotoSansJP'
                    });
                }
                (0, $fb4c7c5aada7368a$export$7ec495ac665155d4)([
                    ...(0, $fb4c7c5aada7368a$export$eba19cacbe4413),
                    ...tempSelectedImageFiles
                ]);
                $cdce58d4b9fe69a2$export$8d096eb89503b162((0, $fb4c7c5aada7368a$export$eba19cacbe4413));
                (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)(); // リアルタイムプレビューを更新
                imageFileNamesSpan.textContent = `${(0, $fb4c7c5aada7368a$export$eba19cacbe4413).length} \u{500B}\u{306E}\u{753B}\u{50CF}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}`;
                (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
            } else {
                (0, $fb4c7c5aada7368a$export$7ec495ac665155d4)([]);
                $cdce58d4b9fe69a2$export$8d096eb89503b162((0, $fb4c7c5aada7368a$export$eba19cacbe4413));
                imageFileNamesSpan.textContent = "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093";
                (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
            }
        })();
    prevButton.onclick = ()=>{
        window.location.hash = '/pdf-select';
    };
    nextButton.onclick = ()=>{
        window.location.hash = '/result';
    };
    clearButton.onclick = $cdce58d4b9fe69a2$export$938c1f6f80bafb78;
    // 既存の画像があればプレビューを表示
    $cdce58d4b9fe69a2$export$8d096eb89503b162((0, $fb4c7c5aada7368a$export$eba19cacbe4413));
    if (imageFileNamesSpan) imageFileNamesSpan.textContent = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).length > 0 ? `${(0, $fb4c7c5aada7368a$export$eba19cacbe4413).length} \u{500B}\u{306E}\u{753B}\u{50CF}\u{304C}\u{9078}\u{629E}\u{3055}\u{308C}\u{307E}\u{3057}\u{305F}` : "\u9078\u629E\u3055\u308C\u3066\u3044\u307E\u305B\u3093";
    // SortableJSの初期化
    new (0, $12b3d2ab131f1390$export$2e2bcd8739ae039)(imagePreviewContainer, {
        animation: 200,
        ghostClass: 'sortable-ghost',
        handle: '.drag-handle',
        onEnd: function(evt) {
            const oldIndex = evt.oldIndex;
            const newIndex = evt.newIndex;
            const [movedItem] = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).splice(oldIndex, 1);
            (0, $fb4c7c5aada7368a$export$eba19cacbe4413).splice(newIndex, 0, movedItem);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
            console.log("\u753B\u50CF\u306E\u9806\u5E8F\u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F:", (0, $fb4c7c5aada7368a$export$eba19cacbe4413).map((img)=>img.file.name));
        }
    });
    $cdce58d4b9fe69a2$export$901579c443c5a6a5();
}
function $cdce58d4b9fe69a2$export$82766c9801b74cc7() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const realtimePreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('realtimePreviewContainer');
        if (!realtimePreviewContainer) return;
        if (!(0, $fb4c7c5aada7368a$export$ca26e1dd869a40e)) {
            realtimePreviewContainer.style.backgroundImage = 'none';
            return;
        }
        try {
            const pageNumber = (0, $fb4c7c5aada7368a$export$9108de792d9756a9);
            let pdf;
            if (0, $fb4c7c5aada7368a$export$35a17b9c20c01f8b) pdf = (0, $fb4c7c5aada7368a$export$35a17b9c20c01f8b);
            else if (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f) {
                const loadingTask = (0, $ajWU5).getDocument({
                    data: (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f).slice(0)
                });
                pdf = yield loadingTask.promise;
                (0, $fb4c7c5aada7368a$export$6fa298e0c95c9ddf)(pdf); // 新しくロードされたPDFドキュメントインスタンスをキャッシュ
            } else {
                const pdfBytes = yield (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).arrayBuffer();
                const loadingTask = (0, $ajWU5).getDocument({
                    data: pdfBytes.slice(0)
                });
                pdf = yield loadingTask.promise;
                (0, $fb4c7c5aada7368a$export$6fa298e0c95c9ddf)(pdf); // 新しくロードされたPDFドキュメントインスタンスをキャッシュ
            }
            if (pageNumber < 1 || pageNumber > pdf.numPages) return;
            const page = yield pdf.getPage(pageNumber);
            const viewport = page.getViewport({
                scale: 1
            });
            const canvas = document.createElement('canvas');
            const context = canvas.getContext('2d');
            canvas.height = viewport.height;
            canvas.width = viewport.width;
            const renderContext = {
                canvasContext: context,
                viewport: viewport
            };
            yield page.render(renderContext).promise;
            realtimePreviewContainer.style.backgroundImage = `url(${canvas.toDataURL()})`;
            realtimePreviewContainer.style.backgroundSize = 'contain';
            realtimePreviewContainer.style.backgroundRepeat = 'no-repeat';
            realtimePreviewContainer.style.backgroundPosition = 'center';
        } catch (error) {
            console.error("PDF\u30DA\u30FC\u30B8\u306E\u30EC\u30F3\u30C0\u30EA\u30F3\u30B0\u306B\u5931\u6557\u3057\u307E\u3057\u305F:", error);
            realtimePreviewContainer.style.backgroundImage = 'none';
        }
    })();
}
function $cdce58d4b9fe69a2$export$901579c443c5a6a5() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const carouselContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pdfPageCarousel');
        if (!carouselContainer || !(0, $fb4c7c5aada7368a$export$ca26e1dd869a40e)) return;
        carouselContainer.innerHTML = ''; // Clear previous content
        try {
            let pdf;
            if (0, $fb4c7c5aada7368a$export$35a17b9c20c01f8b) pdf = (0, $fb4c7c5aada7368a$export$35a17b9c20c01f8b);
            else if (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f) {
                const loadingTask = (0, $ajWU5).getDocument({
                    data: (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f).slice(0)
                });
                pdf = yield loadingTask.promise;
                (0, $fb4c7c5aada7368a$export$6fa298e0c95c9ddf)(pdf); // 新しくロードされたPDFドキュメントインスタンスをキャッシュ
            } else {
                const pdfBytes = yield (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).arrayBuffer();
                const loadingTask = (0, $ajWU5).getDocument({
                    data: pdfBytes.slice(0)
                });
                pdf = yield loadingTask.promise;
                (0, $fb4c7c5aada7368a$export$6fa298e0c95c9ddf)(pdf); // 新しくロードされたPDFドキュメントインスタンスをキャッシュ
            }
            const numPages = pdf.numPages;
            const renderPromises = [];
            for(let i = 1; i <= numPages; i++){
                const canvas = document.createElement('canvas');
                const context = canvas.getContext('2d');
                canvas.dataset.pageNumber = i;
                canvas.classList.add('pdf-carousel-page');
                if (i === (0, $fb4c7c5aada7368a$export$9108de792d9756a9)) canvas.classList.add('selected');
                carouselContainer.appendChild(canvas); // キャンバスを先にDOMに追加
                renderPromises.push(((pageNum, canvas, context)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        const page = yield pdf.getPage(pageNum);
                        const viewport = page.getViewport({
                            scale: 0.5
                        }); // Use a smaller scale for thumbnails
                        canvas.height = viewport.height;
                        canvas.width = viewport.width;
                        const renderContext = {
                            canvasContext: context,
                            viewport: viewport
                        };
                        yield page.render(renderContext).promise;
                    })())(i, canvas, context));
                canvas.onclick = (event)=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                        const pageNum = parseInt(event.target.dataset.pageNumber);
                        (0, $fb4c7c5aada7368a$export$70aa06bd6f3c73dc)(pageNum);
                        // Update selected state
                        document.querySelectorAll('.pdf-carousel-page').forEach((p)=>p.classList.remove('selected'));
                        event.target.classList.add('selected');
                        // Update background preview
                        $cdce58d4b9fe69a2$export$82766c9801b74cc7();
                    })();
            }
            yield Promise.all(renderPromises); // すべてのレンダリングが完了するのを待つ
        } catch (error) {
            console.error('PDF page carousel setup failed:', error);
        }
    })();
}



var $1etvo = parcelRequire("1etvo");


var $czuCz = parcelRequire("czuCz");
var $07144aea14354eb9$var$commonjsGlobal = typeof globalThis !== 'undefined' ? globalThis : typeof window !== 'undefined' ? window : typeof $parcel$global !== 'undefined' ? $parcel$global : typeof self !== 'undefined' ? self : {};
function $07144aea14354eb9$var$createCommonjsModule(fn, module) {
    return module = {
        exports: {}
    }, fn(module, module.exports), module.exports;
}
function $07144aea14354eb9$var$getCjsExportFromNamespace(n) {
    return n && n['default'] || n;
}
var $07144aea14354eb9$var$byteLength_1 = $07144aea14354eb9$var$byteLength;
var $07144aea14354eb9$var$toByteArray_1 = $07144aea14354eb9$var$toByteArray;
var $07144aea14354eb9$var$fromByteArray_1 = $07144aea14354eb9$var$fromByteArray;
var $07144aea14354eb9$var$lookup = [];
var $07144aea14354eb9$var$revLookup = [];
var $07144aea14354eb9$var$Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $07144aea14354eb9$var$code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $07144aea14354eb9$var$i = 0, $07144aea14354eb9$var$len = $07144aea14354eb9$var$code.length; $07144aea14354eb9$var$i < $07144aea14354eb9$var$len; ++$07144aea14354eb9$var$i){
    $07144aea14354eb9$var$lookup[$07144aea14354eb9$var$i] = $07144aea14354eb9$var$code[$07144aea14354eb9$var$i];
    $07144aea14354eb9$var$revLookup[$07144aea14354eb9$var$code.charCodeAt($07144aea14354eb9$var$i)] = $07144aea14354eb9$var$i;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$07144aea14354eb9$var$revLookup['-'.charCodeAt(0)] = 62;
$07144aea14354eb9$var$revLookup['_'.charCodeAt(0)] = 63;
function $07144aea14354eb9$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function $07144aea14354eb9$var$byteLength(b64) {
    var lens = $07144aea14354eb9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $07144aea14354eb9$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $07144aea14354eb9$var$toByteArray(b64) {
    var tmp;
    var lens = $07144aea14354eb9$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $07144aea14354eb9$var$Arr($07144aea14354eb9$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $07144aea14354eb9$var$revLookup[b64.charCodeAt(i)] << 18 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $07144aea14354eb9$var$revLookup[b64.charCodeAt(i)] << 2 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $07144aea14354eb9$var$revLookup[b64.charCodeAt(i)] << 10 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $07144aea14354eb9$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $07144aea14354eb9$var$tripletToBase64(num) {
    return $07144aea14354eb9$var$lookup[num >> 18 & 0x3F] + $07144aea14354eb9$var$lookup[num >> 12 & 0x3F] + $07144aea14354eb9$var$lookup[num >> 6 & 0x3F] + $07144aea14354eb9$var$lookup[num & 0x3F];
}
function $07144aea14354eb9$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($07144aea14354eb9$var$tripletToBase64(tmp));
    }
    return output.join('');
}
function $07144aea14354eb9$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($07144aea14354eb9$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($07144aea14354eb9$var$lookup[tmp >> 2] + $07144aea14354eb9$var$lookup[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($07144aea14354eb9$var$lookup[tmp >> 10] + $07144aea14354eb9$var$lookup[tmp >> 4 & 0x3F] + $07144aea14354eb9$var$lookup[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $07144aea14354eb9$var$base64Js = {
    byteLength: $07144aea14354eb9$var$byteLength_1,
    toByteArray: $07144aea14354eb9$var$toByteArray_1,
    fromByteArray: $07144aea14354eb9$var$fromByteArray_1
};
var $07144aea14354eb9$var$read = function read(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
var $07144aea14354eb9$var$write = function write(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};
var $07144aea14354eb9$var$ieee754 = {
    read: $07144aea14354eb9$var$read,
    write: $07144aea14354eb9$var$write
};
var $07144aea14354eb9$var$buffer = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    var customInspectSymbol = typeof Symbol === 'function' && typeof Symbol["for"] === 'function' ? Symbol["for"]('nodejs.util.inspect.custom') : null;
    exports.Buffer = Buffer;
    exports.SlowBuffer = SlowBuffer;
    exports.INSPECT_MAX_BYTES = 50;
    var K_MAX_LENGTH = 0x7fffffff;
    exports.kMaxLength = K_MAX_LENGTH;
    /**
   * If `Buffer.TYPED_ARRAY_SUPPORT`:
   *   === true    Use Uint8Array implementation (fastest)
   *   === false   Print warning and recommend using `buffer` v4.x which has an Object
   *               implementation (most compatible, even IE6)
   *
   * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
   * Opera 11.6+, iOS 4.2+.
   *
   * We report that the browser does not support typed arrays if the are not subclassable
   * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
   * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
   * for __proto__ and has a buggy typed array implementation.
   */ Buffer.TYPED_ARRAY_SUPPORT = typedArraySupport();
    if (!Buffer.TYPED_ARRAY_SUPPORT && typeof console !== 'undefined' && typeof console.error === 'function') console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
    function typedArraySupport() {
        // Can typed array instances can be augmented?
        try {
            var arr = new Uint8Array(1);
            var proto = {
                foo: function foo() {
                    return 42;
                }
            };
            Object.setPrototypeOf(proto, Uint8Array.prototype);
            Object.setPrototypeOf(arr, proto);
            return arr.foo() === 42;
        } catch (e) {
            return false;
        }
    }
    Object.defineProperty(Buffer.prototype, 'parent', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.buffer;
        }
    });
    Object.defineProperty(Buffer.prototype, 'offset', {
        enumerable: true,
        get: function get() {
            if (!Buffer.isBuffer(this)) return undefined;
            return this.byteOffset;
        }
    });
    function createBuffer(length) {
        if (length > K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
         // Return an augmented `Uint8Array` instance
        var buf = new Uint8Array(length);
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    /**
   * The Buffer constructor returns instances of `Uint8Array` that have their
   * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
   * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
   * and the `Uint8Array` methods. Square bracket notation works as expected -- it
   * returns a single octet.
   *
   * The `Uint8Array` prototype remains unmodified.
   */ function Buffer(arg, encodingOrOffset, length) {
        // Common case.
        if (typeof arg === 'number') {
            if (typeof encodingOrOffset === 'string') throw new TypeError('The "string" argument must be of type string. Received type number');
            return allocUnsafe(arg);
        }
        return from(arg, encodingOrOffset, length);
    }
    Buffer.poolSize = 8192; // not used by this implementation
    function from(value, encodingOrOffset, length) {
        if (typeof value === 'string') return fromString(value, encodingOrOffset);
        if (ArrayBuffer.isView(value)) return fromArrayLike(value);
        if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
        if (isInstance(value, ArrayBuffer) || value && isInstance(value.buffer, ArrayBuffer)) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof SharedArrayBuffer !== 'undefined' && (isInstance(value, SharedArrayBuffer) || value && isInstance(value.buffer, SharedArrayBuffer))) return fromArrayBuffer(value, encodingOrOffset, length);
        if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type number');
        var valueOf = value.valueOf && value.valueOf();
        if (valueOf != null && valueOf !== value) return Buffer.from(valueOf, encodingOrOffset, length);
        var b = fromObject(value);
        if (b) return b;
        if (typeof Symbol !== 'undefined' && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === 'function') return Buffer.from(value[Symbol.toPrimitive]('string'), encodingOrOffset, length);
        throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    }
    /**
   * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
   * if value is a number.
   * Buffer.from(str[, encoding])
   * Buffer.from(array)
   * Buffer.from(buffer)
   * Buffer.from(arrayBuffer[, byteOffset[, length]])
   **/ Buffer.from = function(value, encodingOrOffset, length) {
        return from(value, encodingOrOffset, length);
    }; // Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
    // https://github.com/feross/buffer/pull/148
    Object.setPrototypeOf(Buffer.prototype, Uint8Array.prototype);
    Object.setPrototypeOf(Buffer, Uint8Array);
    function assertSize(size) {
        if (typeof size !== 'number') throw new TypeError('"size" argument must be of type number');
        else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    }
    function alloc(size, fill, encoding) {
        assertSize(size);
        if (size <= 0) return createBuffer(size);
        if (fill !== undefined) // Only pay attention to encoding if it's a string. This
        // prevents accidentally sending in a number that would
        // be interpretted as a start offset.
        return typeof encoding === 'string' ? createBuffer(size).fill(fill, encoding) : createBuffer(size).fill(fill);
        return createBuffer(size);
    }
    /**
   * Creates a new filled Buffer instance.
   * alloc(size[, fill[, encoding]])
   **/ Buffer.alloc = function(size, fill, encoding) {
        return alloc(size, fill, encoding);
    };
    function allocUnsafe(size) {
        assertSize(size);
        return createBuffer(size < 0 ? 0 : checked(size) | 0);
    }
    /**
   * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
   * */ Buffer.allocUnsafe = function(size) {
        return allocUnsafe(size);
    };
    /**
   * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
   */ Buffer.allocUnsafeSlow = function(size) {
        return allocUnsafe(size);
    };
    function fromString(string, encoding) {
        if (typeof encoding !== 'string' || encoding === '') encoding = 'utf8';
        if (!Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
        var length = byteLength(string, encoding) | 0;
        var buf = createBuffer(length);
        var actual = buf.write(string, encoding);
        if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
        // cause everything after the first invalid character to be ignored. (e.g.
        // 'abxxcd' will be treated as 'ab')
        buf = buf.slice(0, actual);
        return buf;
    }
    function fromArrayLike(array) {
        var length = array.length < 0 ? 0 : checked(array.length) | 0;
        var buf = createBuffer(length);
        for(var i = 0; i < length; i += 1)buf[i] = array[i] & 255;
        return buf;
    }
    function fromArrayBuffer(array, byteOffset, length) {
        if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
        if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
        var buf;
        if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
        else if (length === undefined) buf = new Uint8Array(array, byteOffset);
        else buf = new Uint8Array(array, byteOffset, length);
         // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(buf, Buffer.prototype);
        return buf;
    }
    function fromObject(obj) {
        if (Buffer.isBuffer(obj)) {
            var len = checked(obj.length) | 0;
            var buf = createBuffer(len);
            if (buf.length === 0) return buf;
            obj.copy(buf, 0, 0, len);
            return buf;
        }
        if (obj.length !== undefined) {
            if (typeof obj.length !== 'number' || numberIsNaN(obj.length)) return createBuffer(0);
            return fromArrayLike(obj);
        }
        if (obj.type === 'Buffer' && Array.isArray(obj.data)) return fromArrayLike(obj.data);
    }
    function checked(length) {
        // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
        // length is NaN (which is otherwise coerced to zero.)
        if (length >= K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + K_MAX_LENGTH.toString(16) + ' bytes');
        return length | 0;
    }
    function SlowBuffer(length) {
        if (+length != length) // eslint-disable-line eqeqeq
        length = 0;
        return Buffer.alloc(+length);
    }
    Buffer.isBuffer = function isBuffer(b) {
        return b != null && b._isBuffer === true && b !== Buffer.prototype; // so Buffer.isBuffer(Buffer.prototype) will be false
    };
    Buffer.compare = function compare(a, b) {
        if (isInstance(a, Uint8Array)) a = Buffer.from(a, a.offset, a.byteLength);
        if (isInstance(b, Uint8Array)) b = Buffer.from(b, b.offset, b.byteLength);
        if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
        if (a === b) return 0;
        var x = a.length;
        var y = b.length;
        for(var i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
            x = a[i];
            y = b[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    };
    Buffer.isEncoding = function isEncoding(encoding) {
        switch(String(encoding).toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'latin1':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return true;
            default:
                return false;
        }
    };
    Buffer.concat = function concat(list, length) {
        if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
        if (list.length === 0) return Buffer.alloc(0);
        var i;
        if (length === undefined) {
            length = 0;
            for(i = 0; i < list.length; ++i)length += list[i].length;
        }
        var buffer = Buffer.allocUnsafe(length);
        var pos = 0;
        for(i = 0; i < list.length; ++i){
            var buf = list[i];
            if (isInstance(buf, Uint8Array)) buf = Buffer.from(buf);
            if (!Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
            buf.copy(buffer, pos);
            pos += buf.length;
        }
        return buffer;
    };
    function byteLength(string, encoding) {
        if (Buffer.isBuffer(string)) return string.length;
        if (ArrayBuffer.isView(string) || isInstance(string, ArrayBuffer)) return string.byteLength;
        if (typeof string !== 'string') throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
        var len = string.length;
        var mustMatch = arguments.length > 2 && arguments[2] === true;
        if (!mustMatch && len === 0) return 0; // Use a for loop to avoid recursion
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'ascii':
            case 'latin1':
            case 'binary':
                return len;
            case 'utf8':
            case 'utf-8':
                return utf8ToBytes(string).length;
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return len * 2;
            case 'hex':
                return len >>> 1;
            case 'base64':
                return base64ToBytes(string).length;
            default:
                if (loweredCase) return mustMatch ? -1 : utf8ToBytes(string).length; // assume utf8
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    }
    Buffer.byteLength = byteLength;
    function slowToString(encoding, start, end) {
        var loweredCase = false; // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
        // property of a typed array.
        // This behaves neither like String nor Uint8Array in that we set start/end
        // to their upper/lower bounds if the value passed is out of range.
        // undefined is handled specially as per ECMA-262 6th Edition,
        // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
        if (start === undefined || start < 0) start = 0;
         // Return early if start > this.length. Done here to prevent potential uint32
        // coercion fail below.
        if (start > this.length) return '';
        if (end === undefined || end > this.length) end = this.length;
        if (end <= 0) return '';
         // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
        end >>>= 0;
        start >>>= 0;
        if (end <= start) return '';
        if (!encoding) encoding = 'utf8';
        while(true)switch(encoding){
            case 'hex':
                return hexSlice(this, start, end);
            case 'utf8':
            case 'utf-8':
                return utf8Slice(this, start, end);
            case 'ascii':
                return asciiSlice(this, start, end);
            case 'latin1':
            case 'binary':
                return latin1Slice(this, start, end);
            case 'base64':
                return base64Slice(this, start, end);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return utf16leSlice(this, start, end);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = (encoding + '').toLowerCase();
                loweredCase = true;
        }
    } // This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
    // to detect a Buffer instance. It's not possible to use `instanceof Buffer`
    // reliably in a browserify context because there could be multiple different
    // copies of the 'buffer' package in use. This method works even for Buffer
    // instances that were created from another copy of the `buffer` package.
    // See: https://github.com/feross/buffer/issues/154
    Buffer.prototype._isBuffer = true;
    function swap(b, n, m) {
        var i = b[n];
        b[n] = b[m];
        b[m] = i;
    }
    Buffer.prototype.swap16 = function swap16() {
        var len = this.length;
        if (len % 2 !== 0) throw new RangeError('Buffer size must be a multiple of 16-bits');
        for(var i = 0; i < len; i += 2)swap(this, i, i + 1);
        return this;
    };
    Buffer.prototype.swap32 = function swap32() {
        var len = this.length;
        if (len % 4 !== 0) throw new RangeError('Buffer size must be a multiple of 32-bits');
        for(var i = 0; i < len; i += 4){
            swap(this, i, i + 3);
            swap(this, i + 1, i + 2);
        }
        return this;
    };
    Buffer.prototype.swap64 = function swap64() {
        var len = this.length;
        if (len % 8 !== 0) throw new RangeError('Buffer size must be a multiple of 64-bits');
        for(var i = 0; i < len; i += 8){
            swap(this, i, i + 7);
            swap(this, i + 1, i + 6);
            swap(this, i + 2, i + 5);
            swap(this, i + 3, i + 4);
        }
        return this;
    };
    Buffer.prototype.toString = function toString() {
        var length = this.length;
        if (length === 0) return '';
        if (arguments.length === 0) return utf8Slice(this, 0, length);
        return slowToString.apply(this, arguments);
    };
    Buffer.prototype.toLocaleString = Buffer.prototype.toString;
    Buffer.prototype.equals = function equals(b) {
        if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer');
        if (this === b) return true;
        return Buffer.compare(this, b) === 0;
    };
    Buffer.prototype.inspect = function inspect() {
        var str = '';
        var max = exports.INSPECT_MAX_BYTES;
        str = this.toString('hex', 0, max).replace(/(.{2})/g, '$1 ').trim();
        if (this.length > max) str += ' ... ';
        return '<Buffer ' + str + '>';
    };
    if (customInspectSymbol) Buffer.prototype[customInspectSymbol] = Buffer.prototype.inspect;
    Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
        if (isInstance(target, Uint8Array)) target = Buffer.from(target, target.offset, target.byteLength);
        if (!Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
        if (start === undefined) start = 0;
        if (end === undefined) end = target ? target.length : 0;
        if (thisStart === undefined) thisStart = 0;
        if (thisEnd === undefined) thisEnd = this.length;
        if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError('out of range index');
        if (thisStart >= thisEnd && start >= end) return 0;
        if (thisStart >= thisEnd) return -1;
        if (start >= end) return 1;
        start >>>= 0;
        end >>>= 0;
        thisStart >>>= 0;
        thisEnd >>>= 0;
        if (this === target) return 0;
        var x = thisEnd - thisStart;
        var y = end - start;
        var len = Math.min(x, y);
        var thisCopy = this.slice(thisStart, thisEnd);
        var targetCopy = target.slice(start, end);
        for(var i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
            x = thisCopy[i];
            y = targetCopy[i];
            break;
        }
        if (x < y) return -1;
        if (y < x) return 1;
        return 0;
    }; // Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
    // OR the last index of `val` in `buffer` at offset <= `byteOffset`.
    //
    // Arguments:
    // - buffer - a Buffer to search
    // - val - a string, Buffer, or number
    // - byteOffset - an index into `buffer`; will be clamped to an int32
    // - encoding - an optional encoding, relevant is val is a string
    // - dir - true for indexOf, false for lastIndexOf
    function bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
        // Empty buffer means no match
        if (buffer.length === 0) return -1; // Normalize byteOffset
        if (typeof byteOffset === 'string') {
            encoding = byteOffset;
            byteOffset = 0;
        } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
        else if (byteOffset < -2147483648) byteOffset = -2147483648;
        byteOffset = +byteOffset; // Coerce to Number.
        if (numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
        byteOffset = dir ? 0 : buffer.length - 1;
         // Normalize byteOffset: negative offsets start from the end of the buffer
        if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
        if (byteOffset >= buffer.length) {
            if (dir) return -1;
            else byteOffset = buffer.length - 1;
        } else if (byteOffset < 0) {
            if (dir) byteOffset = 0;
            else return -1;
        } // Normalize val
        if (typeof val === 'string') val = Buffer.from(val, encoding);
         // Finally, search either indexOf (if dir is true) or lastIndexOf
        if (Buffer.isBuffer(val)) {
            // Special case: looking for empty string/buffer always fails
            if (val.length === 0) return -1;
            return arrayIndexOf(buffer, val, byteOffset, encoding, dir);
        } else if (typeof val === 'number') {
            val = val & 0xFF; // Search for a byte value [0-255]
            if (typeof Uint8Array.prototype.indexOf === 'function') {
                if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
                else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
            }
            return arrayIndexOf(buffer, [
                val
            ], byteOffset, encoding, dir);
        }
        throw new TypeError('val must be string, number or Buffer');
    }
    function arrayIndexOf(arr, val, byteOffset, encoding, dir) {
        var indexSize = 1;
        var arrLength = arr.length;
        var valLength = val.length;
        if (encoding !== undefined) {
            encoding = String(encoding).toLowerCase();
            if (encoding === 'ucs2' || encoding === 'ucs-2' || encoding === 'utf16le' || encoding === 'utf-16le') {
                if (arr.length < 2 || val.length < 2) return -1;
                indexSize = 2;
                arrLength /= 2;
                valLength /= 2;
                byteOffset /= 2;
            }
        }
        function read(buf, i) {
            if (indexSize === 1) return buf[i];
            else return buf.readUInt16BE(i * indexSize);
        }
        var i;
        if (dir) {
            var foundIndex = -1;
            for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
                if (foundIndex === -1) foundIndex = i;
                if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
            } else {
                if (foundIndex !== -1) i -= i - foundIndex;
                foundIndex = -1;
            }
        } else {
            if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
            for(i = byteOffset; i >= 0; i--){
                var found = true;
                for(var j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                    found = false;
                    break;
                }
                if (found) return i;
            }
        }
        return -1;
    }
    Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
        return this.indexOf(val, byteOffset, encoding) !== -1;
    };
    Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, true);
    };
    Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
        return bidirectionalIndexOf(this, val, byteOffset, encoding, false);
    };
    function hexWrite(buf, string, offset, length) {
        offset = Number(offset) || 0;
        var remaining = buf.length - offset;
        if (!length) length = remaining;
        else {
            length = Number(length);
            if (length > remaining) length = remaining;
        }
        var strLen = string.length;
        if (length > strLen / 2) length = strLen / 2;
        for(var i = 0; i < length; ++i){
            var parsed = parseInt(string.substr(i * 2, 2), 16);
            if (numberIsNaN(parsed)) return i;
            buf[offset + i] = parsed;
        }
        return i;
    }
    function utf8Write(buf, string, offset, length) {
        return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length);
    }
    function asciiWrite(buf, string, offset, length) {
        return blitBuffer(asciiToBytes(string), buf, offset, length);
    }
    function latin1Write(buf, string, offset, length) {
        return asciiWrite(buf, string, offset, length);
    }
    function base64Write(buf, string, offset, length) {
        return blitBuffer(base64ToBytes(string), buf, offset, length);
    }
    function ucs2Write(buf, string, offset, length) {
        return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length);
    }
    Buffer.prototype.write = function write(string, offset, length, encoding) {
        // Buffer#write(string)
        if (offset === undefined) {
            encoding = 'utf8';
            length = this.length;
            offset = 0; // Buffer#write(string, encoding)
        } else if (length === undefined && typeof offset === 'string') {
            encoding = offset;
            length = this.length;
            offset = 0; // Buffer#write(string, offset[, length][, encoding])
        } else if (isFinite(offset)) {
            offset = offset >>> 0;
            if (isFinite(length)) {
                length = length >>> 0;
                if (encoding === undefined) encoding = 'utf8';
            } else {
                encoding = length;
                length = undefined;
            }
        } else throw new Error('Buffer.write(string, encoding, offset[, length]) is no longer supported');
        var remaining = this.length - offset;
        if (length === undefined || length > remaining) length = remaining;
        if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError('Attempt to write outside buffer bounds');
        if (!encoding) encoding = 'utf8';
        var loweredCase = false;
        for(;;)switch(encoding){
            case 'hex':
                return hexWrite(this, string, offset, length);
            case 'utf8':
            case 'utf-8':
                return utf8Write(this, string, offset, length);
            case 'ascii':
                return asciiWrite(this, string, offset, length);
            case 'latin1':
            case 'binary':
                return latin1Write(this, string, offset, length);
            case 'base64':
                // Warning: maxLength not taken into account in base64Write
                return base64Write(this, string, offset, length);
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
                return ucs2Write(this, string, offset, length);
            default:
                if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding);
                encoding = ('' + encoding).toLowerCase();
                loweredCase = true;
        }
    };
    Buffer.prototype.toJSON = function toJSON() {
        return {
            type: 'Buffer',
            data: Array.prototype.slice.call(this._arr || this, 0)
        };
    };
    function base64Slice(buf, start, end) {
        if (start === 0 && end === buf.length) return $07144aea14354eb9$var$base64Js.fromByteArray(buf);
        else return $07144aea14354eb9$var$base64Js.fromByteArray(buf.slice(start, end));
    }
    function utf8Slice(buf, start, end) {
        end = Math.min(buf.length, end);
        var res = [];
        var i = start;
        while(i < end){
            var firstByte = buf[i];
            var codePoint = null;
            var bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
            if (i + bytesPerSequence <= end) {
                var secondByte, thirdByte, fourthByte, tempCodePoint;
                switch(bytesPerSequence){
                    case 1:
                        if (firstByte < 0x80) codePoint = firstByte;
                        break;
                    case 2:
                        secondByte = buf[i + 1];
                        if ((secondByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                            if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                        }
                        break;
                    case 3:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                        }
                        break;
                    case 4:
                        secondByte = buf[i + 1];
                        thirdByte = buf[i + 2];
                        fourthByte = buf[i + 3];
                        if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                        }
                }
            }
            if (codePoint === null) {
                // we did not generate a valid codePoint so insert a
                // replacement char (U+FFFD) and advance only 1 byte
                codePoint = 0xFFFD;
                bytesPerSequence = 1;
            } else if (codePoint > 0xFFFF) {
                // encode to utf16 (surrogate pair dance)
                codePoint -= 0x10000;
                res.push(codePoint >>> 10 & 0x3FF | 0xD800);
                codePoint = 0xDC00 | codePoint & 0x3FF;
            }
            res.push(codePoint);
            i += bytesPerSequence;
        }
        return decodeCodePointsArray(res);
    } // Based on http://stackoverflow.com/a/22747272/680742, the browser with
    // the lowest limit is Chrome, with 0x10000 args.
    // We go 1 magnitude less, for safety
    var MAX_ARGUMENTS_LENGTH = 0x1000;
    function decodeCodePointsArray(codePoints) {
        var len = codePoints.length;
        if (len <= MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints); // avoid extra slice()
         // Decode in chunks to avoid "call stack size exceeded".
        var res = '';
        var i = 0;
        while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH));
        return res;
    }
    function asciiSlice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
        return ret;
    }
    function latin1Slice(buf, start, end) {
        var ret = '';
        end = Math.min(buf.length, end);
        for(var i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
        return ret;
    }
    function hexSlice(buf, start, end) {
        var len = buf.length;
        if (!start || start < 0) start = 0;
        if (!end || end < 0 || end > len) end = len;
        var out = '';
        for(var i = start; i < end; ++i)out += hexSliceLookupTable[buf[i]];
        return out;
    }
    function utf16leSlice(buf, start, end) {
        var bytes = buf.slice(start, end);
        var res = '';
        for(var i = 0; i < bytes.length; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
        return res;
    }
    Buffer.prototype.slice = function slice(start, end) {
        var len = this.length;
        start = ~~start;
        end = end === undefined ? len : ~~end;
        if (start < 0) {
            start += len;
            if (start < 0) start = 0;
        } else if (start > len) start = len;
        if (end < 0) {
            end += len;
            if (end < 0) end = 0;
        } else if (end > len) end = len;
        if (end < start) end = start;
        var newBuf = this.subarray(start, end); // Return an augmented `Uint8Array` instance
        Object.setPrototypeOf(newBuf, Buffer.prototype);
        return newBuf;
    };
    /*
   * Need to make sure that buffer isn't trying to write out of bounds.
   */ function checkOffset(offset, ext, length) {
        if (offset % 1 !== 0 || offset < 0) throw new RangeError('offset is not uint');
        if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length');
    }
    Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        return val;
    };
    Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset + --byteLength];
        var mul = 1;
        while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
        return val;
    };
    Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        return this[offset];
    };
    Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] | this[offset + 1] << 8;
    };
    Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        return this[offset] << 8 | this[offset + 1];
    };
    Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
    };
    Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
    };
    Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var val = this[offset];
        var mul = 1;
        var i = 0;
        while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) checkOffset(offset, byteLength, this.length);
        var i = byteLength;
        var mul = 1;
        var val = this[offset + --i];
        while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
        mul *= 0x80;
        if (val >= mul) val -= Math.pow(2, 8 * byteLength);
        return val;
    };
    Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 1, this.length);
        if (!(this[offset] & 0x80)) return this[offset];
        return (0xff - this[offset] + 1) * -1;
    };
    Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset] | this[offset + 1] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 2, this.length);
        var val = this[offset + 1] | this[offset] << 8;
        return val & 0x8000 ? val | 0xFFFF0000 : val;
    };
    Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
    };
    Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
    };
    Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $07144aea14354eb9$var$ieee754.read(this, offset, true, 23, 4);
    };
    Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 4, this.length);
        return $07144aea14354eb9$var$ieee754.read(this, offset, false, 23, 4);
    };
    Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $07144aea14354eb9$var$ieee754.read(this, offset, true, 52, 8);
    };
    Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
        offset = offset >>> 0;
        if (!noAssert) checkOffset(offset, 8, this.length);
        return $07144aea14354eb9$var$ieee754.read(this, offset, false, 52, 8);
    };
    function checkInt(buf, value, offset, ext, max, min) {
        if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
        if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
    }
    Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var mul = 1;
        var i = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        byteLength = byteLength >>> 0;
        if (!noAssert) {
            var maxBytes = Math.pow(2, 8 * byteLength) - 1;
            checkInt(this, value, offset, byteLength, maxBytes, 0);
        }
        var i = byteLength - 1;
        var mul = 1;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
        return offset + byteLength;
    };
    Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0);
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset + 3] = value >>> 24;
        this[offset + 2] = value >>> 16;
        this[offset + 1] = value >>> 8;
        this[offset] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0);
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = 0;
        var mul = 1;
        var sub = 0;
        this[offset] = value & 0xFF;
        while(++i < byteLength && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) {
            var limit = Math.pow(2, 8 * byteLength - 1);
            checkInt(this, value, offset, byteLength, limit - 1, -limit);
        }
        var i = byteLength - 1;
        var mul = 1;
        var sub = 0;
        this[offset + i] = value & 0xFF;
        while(--i >= 0 && (mul *= 0x100)){
            if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
            this[offset + i] = (value / mul >> 0) - sub & 0xFF;
        }
        return offset + byteLength;
    };
    Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -128);
        if (value < 0) value = 0xff + value + 1;
        this[offset] = value & 0xff;
        return offset + 1;
    };
    Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        return offset + 2;
    };
    Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -32768);
        this[offset] = value >>> 8;
        this[offset + 1] = value & 0xff;
        return offset + 2;
    };
    Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        this[offset] = value & 0xff;
        this[offset + 1] = value >>> 8;
        this[offset + 2] = value >>> 16;
        this[offset + 3] = value >>> 24;
        return offset + 4;
    };
    Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
        if (value < 0) value = 0xffffffff + value + 1;
        this[offset] = value >>> 24;
        this[offset + 1] = value >>> 16;
        this[offset + 2] = value >>> 8;
        this[offset + 3] = value & 0xff;
        return offset + 4;
    };
    function checkIEEE754(buf, value, offset, ext, max, min) {
        if (offset + ext > buf.length) throw new RangeError('Index out of range');
        if (offset < 0) throw new RangeError('Index out of range');
    }
    function writeFloat(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 4);
        $07144aea14354eb9$var$ieee754.write(buf, value, offset, littleEndian, 23, 4);
        return offset + 4;
    }
    Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
        return writeFloat(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
        return writeFloat(this, value, offset, false, noAssert);
    };
    function writeDouble(buf, value, offset, littleEndian, noAssert) {
        value = +value;
        offset = offset >>> 0;
        if (!noAssert) checkIEEE754(buf, value, offset, 8);
        $07144aea14354eb9$var$ieee754.write(buf, value, offset, littleEndian, 52, 8);
        return offset + 8;
    }
    Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
        return writeDouble(this, value, offset, true, noAssert);
    };
    Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
        return writeDouble(this, value, offset, false, noAssert);
    }; // copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
    Buffer.prototype.copy = function copy(target, targetStart, start, end) {
        if (!Buffer.isBuffer(target)) throw new TypeError('argument should be a Buffer');
        if (!start) start = 0;
        if (!end && end !== 0) end = this.length;
        if (targetStart >= target.length) targetStart = target.length;
        if (!targetStart) targetStart = 0;
        if (end > 0 && end < start) end = start; // Copy 0 bytes; we're done
        if (end === start) return 0;
        if (target.length === 0 || this.length === 0) return 0; // Fatal error conditions
        if (targetStart < 0) throw new RangeError('targetStart out of bounds');
        if (start < 0 || start >= this.length) throw new RangeError('Index out of range');
        if (end < 0) throw new RangeError('sourceEnd out of bounds'); // Are we oob?
        if (end > this.length) end = this.length;
        if (target.length - targetStart < end - start) end = target.length - targetStart + start;
        var len = end - start;
        if (this === target && typeof Uint8Array.prototype.copyWithin === 'function') // Use built-in when available, missing from IE11
        this.copyWithin(targetStart, start, end);
        else if (this === target && start < targetStart && targetStart < end) // descending copy from end
        for(var i = len - 1; i >= 0; --i)target[i + targetStart] = this[i + start];
        else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
        return len;
    }; // Usage:
    //    buffer.fill(number[, offset[, end]])
    //    buffer.fill(buffer[, offset[, end]])
    //    buffer.fill(string[, offset[, end]][, encoding])
    Buffer.prototype.fill = function fill(val, start, end, encoding) {
        // Handle string cases:
        if (typeof val === 'string') {
            if (typeof start === 'string') {
                encoding = start;
                start = 0;
                end = this.length;
            } else if (typeof end === 'string') {
                encoding = end;
                end = this.length;
            }
            if (encoding !== undefined && typeof encoding !== 'string') throw new TypeError('encoding must be a string');
            if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) throw new TypeError('Unknown encoding: ' + encoding);
            if (val.length === 1) {
                var code = val.charCodeAt(0);
                if (encoding === 'utf8' && code < 128 || encoding === 'latin1') // Fast path: If `val` fits into a single byte, use that numeric value.
                val = code;
            }
        } else if (typeof val === 'number') val = val & 255;
        else if (typeof val === 'boolean') val = Number(val);
         // Invalid ranges are not set to a default, so can range check early.
        if (start < 0 || this.length < start || this.length < end) throw new RangeError('Out of range index');
        if (end <= start) return this;
        start = start >>> 0;
        end = end === undefined ? this.length : end >>> 0;
        if (!val) val = 0;
        var i;
        if (typeof val === 'number') for(i = start; i < end; ++i)this[i] = val;
        else {
            var bytes = Buffer.isBuffer(val) ? val : Buffer.from(val, encoding);
            var len = bytes.length;
            if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
            for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
        }
        return this;
    }; // HELPER FUNCTIONS
    // ================
    var INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
    function base64clean(str) {
        // Node takes equal signs as end of the Base64 encoding
        str = str.split('=')[0]; // Node strips out invalid characters like \n and \t from the string, base64-js does not
        str = str.trim().replace(INVALID_BASE64_RE, ''); // Node converts strings with length < 2 to ''
        if (str.length < 2) return ''; // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
        while(str.length % 4 !== 0)str = str + '=';
        return str;
    }
    function utf8ToBytes(string, units) {
        units = units || Infinity;
        var codePoint;
        var length = string.length;
        var leadSurrogate = null;
        var bytes = [];
        for(var i = 0; i < length; ++i){
            codePoint = string.charCodeAt(i); // is surrogate component
            if (codePoint > 0xD7FF && codePoint < 0xE000) {
                // last char was a lead
                if (!leadSurrogate) {
                    // no lead yet
                    if (codePoint > 0xDBFF) {
                        // unexpected trail
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } else if (i + 1 === length) {
                        // unpaired lead
                        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                        continue;
                    } // valid lead
                    leadSurrogate = codePoint;
                    continue;
                } // 2 leads in a row
                if (codePoint < 0xDC00) {
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    leadSurrogate = codePoint;
                    continue;
                } // valid surrogate pair
                codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
            } else if (leadSurrogate) // valid bmp char, but last char was a lead
            {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
            }
            leadSurrogate = null; // encode utf8
            if (codePoint < 0x80) {
                if ((units -= 1) < 0) break;
                bytes.push(codePoint);
            } else if (codePoint < 0x800) {
                if ((units -= 2) < 0) break;
                bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x10000) {
                if ((units -= 3) < 0) break;
                bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else if (codePoint < 0x110000) {
                if ((units -= 4) < 0) break;
                bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
            } else throw new Error('Invalid code point');
        }
        return bytes;
    }
    function asciiToBytes(str) {
        var byteArray = [];
        for(var i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
        byteArray.push(str.charCodeAt(i) & 0xFF);
        return byteArray;
    }
    function utf16leToBytes(str, units) {
        var c, hi, lo;
        var byteArray = [];
        for(var i = 0; i < str.length; ++i){
            if ((units -= 2) < 0) break;
            c = str.charCodeAt(i);
            hi = c >> 8;
            lo = c % 256;
            byteArray.push(lo);
            byteArray.push(hi);
        }
        return byteArray;
    }
    function base64ToBytes(str) {
        return $07144aea14354eb9$var$base64Js.toByteArray(base64clean(str));
    }
    function blitBuffer(src, dst, offset, length) {
        for(var i = 0; i < length; ++i){
            if (i + offset >= dst.length || i >= src.length) break;
            dst[i + offset] = src[i];
        }
        return i;
    } // ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
    // the `instanceof` check but they should be treated as of that type.
    // See: https://github.com/feross/buffer/issues/166
    function isInstance(obj, type) {
        return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
    }
    function numberIsNaN(obj) {
        // For IE11 support
        return obj !== obj; // eslint-disable-line no-self-compare
    } // Create lookup table for `toString('hex')`
    // See: https://github.com/feross/buffer/issues/219
    var hexSliceLookupTable = function() {
        var alphabet = '0123456789abcdef';
        var table = new Array(256);
        for(var i = 0; i < 16; ++i){
            var i16 = i * 16;
            for(var j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
        }
        return table;
    }();
});
var $07144aea14354eb9$var$buffer_1 = $07144aea14354eb9$var$buffer.Buffer;
var $07144aea14354eb9$var$buffer_2 = $07144aea14354eb9$var$buffer.SlowBuffer;
var $07144aea14354eb9$var$buffer_3 = $07144aea14354eb9$var$buffer.INSPECT_MAX_BYTES;
var $07144aea14354eb9$var$buffer_4 = $07144aea14354eb9$var$buffer.kMaxLength;
var $07144aea14354eb9$var$domain; // This constructor is used to store event handlers. Instantiating this is
// faster than explicitly calling `Object.create(null)` to get a "clean" empty
// object (tested with v8 v4.9).
function $07144aea14354eb9$var$EventHandlers() {}
$07144aea14354eb9$var$EventHandlers.prototype = Object.create(null);
function $07144aea14354eb9$var$EventEmitter() {
    $07144aea14354eb9$var$EventEmitter.init.call(this);
}
// require('events') === require('events').EventEmitter
$07144aea14354eb9$var$EventEmitter.EventEmitter = $07144aea14354eb9$var$EventEmitter;
$07144aea14354eb9$var$EventEmitter.usingDomains = false;
$07144aea14354eb9$var$EventEmitter.prototype.domain = undefined;
$07144aea14354eb9$var$EventEmitter.prototype._events = undefined;
$07144aea14354eb9$var$EventEmitter.prototype._maxListeners = undefined; // By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
$07144aea14354eb9$var$EventEmitter.defaultMaxListeners = 10;
$07144aea14354eb9$var$EventEmitter.init = function() {
    this.domain = null;
    if ($07144aea14354eb9$var$EventEmitter.usingDomains) // if there is an active domain, then attach to it.
    $07144aea14354eb9$var$domain.active;
    if (!this._events || this._events === Object.getPrototypeOf(this)._events) {
        this._events = new $07144aea14354eb9$var$EventHandlers();
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
}; // Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$07144aea14354eb9$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || isNaN(n)) throw new TypeError('"n" argument must be a positive number');
    this._maxListeners = n;
    return this;
};
function $07144aea14354eb9$var$$getMaxListeners(that) {
    if (that._maxListeners === undefined) return $07144aea14354eb9$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$07144aea14354eb9$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $07144aea14354eb9$var$$getMaxListeners(this);
}; // These standalone emit* functions are used to optimize calling of event
// handlers for fast cases because emit() itself often has a variable number of
// arguments and can be deoptimized because of that. These functions always have
// the same number of arguments and thus do not get deoptimized, so the code
// inside them can execute faster.
function $07144aea14354eb9$var$emitNone(handler, isFn, self1) {
    if (isFn) handler.call(self1);
    else {
        var len = handler.length;
        var listeners = $07144aea14354eb9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1);
    }
}
function $07144aea14354eb9$var$emitOne(handler, isFn, self1, arg1) {
    if (isFn) handler.call(self1, arg1);
    else {
        var len = handler.length;
        var listeners = $07144aea14354eb9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1);
    }
}
function $07144aea14354eb9$var$emitTwo(handler, isFn, self1, arg1, arg2) {
    if (isFn) handler.call(self1, arg1, arg2);
    else {
        var len = handler.length;
        var listeners = $07144aea14354eb9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2);
    }
}
function $07144aea14354eb9$var$emitThree(handler, isFn, self1, arg1, arg2, arg3) {
    if (isFn) handler.call(self1, arg1, arg2, arg3);
    else {
        var len = handler.length;
        var listeners = $07144aea14354eb9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].call(self1, arg1, arg2, arg3);
    }
}
function $07144aea14354eb9$var$emitMany(handler, isFn, self1, args) {
    if (isFn) handler.apply(self1, args);
    else {
        var len = handler.length;
        var listeners = $07144aea14354eb9$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)listeners[i].apply(self1, args);
    }
}
$07144aea14354eb9$var$EventEmitter.prototype.emit = function emit(type) {
    var er, handler, len, args, i, events, domain;
    var doError = type === 'error';
    events = this._events;
    if (events) doError = doError && events.error == null;
    else if (!doError) return false;
    domain = this.domain; // If there is no 'error' event listener then throw.
    if (doError) {
        er = arguments[1];
        if (domain) {
            if (!er) er = new Error('Uncaught, unspecified "error" event');
            er.domainEmitter = this;
            er.domain = domain;
            er.domainThrown = false;
            domain.emit('error', er);
        } else if (er instanceof Error) throw er; // Unhandled 'error' event
        else {
            // At least give some kind of context to the user
            var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
            err.context = er;
            throw err;
        }
        return false;
    }
    handler = events[type];
    if (!handler) return false;
    var isFn = typeof handler === 'function';
    len = arguments.length;
    switch(len){
        // fast cases
        case 1:
            $07144aea14354eb9$var$emitNone(handler, isFn, this);
            break;
        case 2:
            $07144aea14354eb9$var$emitOne(handler, isFn, this, arguments[1]);
            break;
        case 3:
            $07144aea14354eb9$var$emitTwo(handler, isFn, this, arguments[1], arguments[2]);
            break;
        case 4:
            $07144aea14354eb9$var$emitThree(handler, isFn, this, arguments[1], arguments[2], arguments[3]);
            break;
        // slower
        default:
            args = new Array(len - 1);
            for(i = 1; i < len; i++)args[i - 1] = arguments[i];
            $07144aea14354eb9$var$emitMany(handler, isFn, this, args);
    }
    return true;
};
function $07144aea14354eb9$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = target._events;
    if (!events) {
        events = target._events = new $07144aea14354eb9$var$EventHandlers();
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener); // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (!existing) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else // If we've already got an array, just append.
        if (prepend) existing.unshift(listener);
        else existing.push(listener);
         // Check for listener leak
        if (!existing.warned) {
            m = $07144aea14354eb9$var$$getMaxListeners(target);
            if (m && m > 0 && existing.length > m) {
                existing.warned = true;
                var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + type + ' listeners added. ' + 'Use emitter.setMaxListeners() to increase limit');
                w.name = 'MaxListenersExceededWarning';
                w.emitter = target;
                w.type = type;
                w.count = existing.length;
                $07144aea14354eb9$var$emitWarning(w);
            }
        }
    }
    return target;
}
function $07144aea14354eb9$var$emitWarning(e) {
    typeof console.warn === 'function' ? console.warn(e) : console.log(e);
}
$07144aea14354eb9$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $07144aea14354eb9$var$_addListener(this, type, listener, false);
};
$07144aea14354eb9$var$EventEmitter.prototype.on = $07144aea14354eb9$var$EventEmitter.prototype.addListener;
$07144aea14354eb9$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $07144aea14354eb9$var$_addListener(this, type, listener, true);
};
function $07144aea14354eb9$var$_onceWrap(target, type, listener) {
    var fired = false;
    function g() {
        target.removeListener(type, g);
        if (!fired) {
            fired = true;
            listener.apply(target, arguments);
        }
    }
    g.listener = listener;
    return g;
}
$07144aea14354eb9$var$EventEmitter.prototype.once = function once(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.on(type, $07144aea14354eb9$var$_onceWrap(this, type, listener));
    return this;
};
$07144aea14354eb9$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    this.prependListener(type, $07144aea14354eb9$var$_onceWrap(this, type, listener));
    return this;
}; // emits a 'removeListener' event iff the listener was removed
$07144aea14354eb9$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    if (typeof listener !== 'function') throw new TypeError('"listener" argument must be a function');
    events = this._events;
    if (!events) return this;
    list = events[type];
    if (!list) return this;
    if (list === listener || list.listener && list.listener === listener) {
        if (--this._eventsCount === 0) this._events = new $07144aea14354eb9$var$EventHandlers();
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length; i-- > 0;)if (list[i] === listener || list[i].listener && list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (list.length === 1) {
            list[0] = undefined;
            if (--this._eventsCount === 0) {
                this._events = new $07144aea14354eb9$var$EventHandlers();
                return this;
            } else delete events[type];
        } else $07144aea14354eb9$var$spliceOne(list, position);
        if (events.removeListener) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$07144aea14354eb9$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events;
    events = this._events;
    if (!events) return this; // not listening for removeListener, no need to emit
    if (!events.removeListener) {
        if (arguments.length === 0) {
            this._events = new $07144aea14354eb9$var$EventHandlers();
            this._eventsCount = 0;
        } else if (events[type]) {
            if (--this._eventsCount === 0) this._events = new $07144aea14354eb9$var$EventHandlers();
            else delete events[type];
        }
        return this;
    } // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        for(var i = 0, key; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = new $07144aea14354eb9$var$EventHandlers();
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners) // LIFO order
    do this.removeListener(type, listeners[listeners.length - 1]);
    while (listeners[0]);
    return this;
};
$07144aea14354eb9$var$EventEmitter.prototype.listeners = function listeners(type) {
    var evlistener;
    var ret;
    var events = this._events;
    if (!events) ret = [];
    else {
        evlistener = events[type];
        if (!evlistener) ret = [];
        else if (typeof evlistener === 'function') ret = [
            evlistener.listener || evlistener
        ];
        else ret = $07144aea14354eb9$var$unwrapListeners(evlistener);
    }
    return ret;
};
$07144aea14354eb9$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $07144aea14354eb9$var$listenerCount.call(emitter, type);
};
$07144aea14354eb9$var$EventEmitter.prototype.listenerCount = $07144aea14354eb9$var$listenerCount;
function $07144aea14354eb9$var$listenerCount(type) {
    var events = this._events;
    if (events) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener) return evlistener.length;
    }
    return 0;
}
$07144aea14354eb9$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? Reflect.ownKeys(this._events) : [];
}; // About 1.5x faster than the two-arg version of Array#splice().
function $07144aea14354eb9$var$spliceOne(list, index) {
    for(var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1)list[i] = list[k];
    list.pop();
}
function $07144aea14354eb9$var$arrayClone(arr, i) {
    var copy = new Array(i);
    while(i--)copy[i] = arr[i];
    return copy;
}
function $07144aea14354eb9$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
var $07144aea14354eb9$var$global$1 = typeof $parcel$global !== "undefined" ? $parcel$global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {};
// shim for using process in browser
// based off https://github.com/defunctzombie/node-process/blob/master/browser.js
function $07144aea14354eb9$var$defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function $07144aea14354eb9$var$defaultClearTimeout() {
    throw new Error('clearTimeout has not been defined');
}
var $07144aea14354eb9$var$cachedSetTimeout = $07144aea14354eb9$var$defaultSetTimout;
var $07144aea14354eb9$var$cachedClearTimeout = $07144aea14354eb9$var$defaultClearTimeout;
if (typeof $07144aea14354eb9$var$global$1.setTimeout === 'function') $07144aea14354eb9$var$cachedSetTimeout = setTimeout;
if (typeof $07144aea14354eb9$var$global$1.clearTimeout === 'function') $07144aea14354eb9$var$cachedClearTimeout = clearTimeout;
function $07144aea14354eb9$var$runTimeout(fun) {
    if ($07144aea14354eb9$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
     // if setTimeout wasn't available but was latter defined
    if (($07144aea14354eb9$var$cachedSetTimeout === $07144aea14354eb9$var$defaultSetTimout || !$07144aea14354eb9$var$cachedSetTimeout) && setTimeout) {
        $07144aea14354eb9$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $07144aea14354eb9$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $07144aea14354eb9$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $07144aea14354eb9$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $07144aea14354eb9$var$runClearTimeout(marker) {
    if ($07144aea14354eb9$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
     // if clearTimeout wasn't available but was latter defined
    if (($07144aea14354eb9$var$cachedClearTimeout === $07144aea14354eb9$var$defaultClearTimeout || !$07144aea14354eb9$var$cachedClearTimeout) && clearTimeout) {
        $07144aea14354eb9$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $07144aea14354eb9$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $07144aea14354eb9$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $07144aea14354eb9$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $07144aea14354eb9$var$queue = [];
var $07144aea14354eb9$var$draining = false;
var $07144aea14354eb9$var$currentQueue;
var $07144aea14354eb9$var$queueIndex = -1;
function $07144aea14354eb9$var$cleanUpNextTick() {
    if (!$07144aea14354eb9$var$draining || !$07144aea14354eb9$var$currentQueue) return;
    $07144aea14354eb9$var$draining = false;
    if ($07144aea14354eb9$var$currentQueue.length) $07144aea14354eb9$var$queue = $07144aea14354eb9$var$currentQueue.concat($07144aea14354eb9$var$queue);
    else $07144aea14354eb9$var$queueIndex = -1;
    if ($07144aea14354eb9$var$queue.length) $07144aea14354eb9$var$drainQueue();
}
function $07144aea14354eb9$var$drainQueue() {
    if ($07144aea14354eb9$var$draining) return;
    var timeout = $07144aea14354eb9$var$runTimeout($07144aea14354eb9$var$cleanUpNextTick);
    $07144aea14354eb9$var$draining = true;
    var len = $07144aea14354eb9$var$queue.length;
    while(len){
        $07144aea14354eb9$var$currentQueue = $07144aea14354eb9$var$queue;
        $07144aea14354eb9$var$queue = [];
        while(++$07144aea14354eb9$var$queueIndex < len)if ($07144aea14354eb9$var$currentQueue) $07144aea14354eb9$var$currentQueue[$07144aea14354eb9$var$queueIndex].run();
        $07144aea14354eb9$var$queueIndex = -1;
        len = $07144aea14354eb9$var$queue.length;
    }
    $07144aea14354eb9$var$currentQueue = null;
    $07144aea14354eb9$var$draining = false;
    $07144aea14354eb9$var$runClearTimeout(timeout);
}
function $07144aea14354eb9$var$nextTick(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $07144aea14354eb9$var$queue.push(new $07144aea14354eb9$var$Item(fun, args));
    if ($07144aea14354eb9$var$queue.length === 1 && !$07144aea14354eb9$var$draining) $07144aea14354eb9$var$runTimeout($07144aea14354eb9$var$drainQueue);
} // v8 likes predictible objects
function $07144aea14354eb9$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$07144aea14354eb9$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
var $07144aea14354eb9$var$title = 'browser';
var $07144aea14354eb9$var$platform = 'browser';
var $07144aea14354eb9$var$browser = true;
var $07144aea14354eb9$var$env = {};
var $07144aea14354eb9$var$argv = [];
var $07144aea14354eb9$var$version = ''; // empty string to avoid regexp issues
var $07144aea14354eb9$var$versions = {};
var $07144aea14354eb9$var$release = {};
var $07144aea14354eb9$var$config = {};
function $07144aea14354eb9$var$noop() {}
var $07144aea14354eb9$var$on = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$addListener = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$once = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$off = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$removeListener = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$removeAllListeners = $07144aea14354eb9$var$noop;
var $07144aea14354eb9$var$emit = $07144aea14354eb9$var$noop;
function $07144aea14354eb9$var$binding(name) {
    throw new Error('process.binding is not supported');
}
function $07144aea14354eb9$var$cwd() {
    return '/';
}
function $07144aea14354eb9$var$chdir(dir) {
    throw new Error('process.chdir is not supported');
}
function $07144aea14354eb9$var$umask() {
    return 0;
} // from https://github.com/kumavis/browser-process-hrtime/blob/master/index.js
var $07144aea14354eb9$var$performance = $07144aea14354eb9$var$global$1.performance || {};
var $07144aea14354eb9$var$performanceNow = $07144aea14354eb9$var$performance.now || $07144aea14354eb9$var$performance.mozNow || $07144aea14354eb9$var$performance.msNow || $07144aea14354eb9$var$performance.oNow || $07144aea14354eb9$var$performance.webkitNow || function() {
    return new Date().getTime();
}; // generate timestamp or delta
// see http://nodejs.org/api/process.html#process_process_hrtime
function $07144aea14354eb9$var$hrtime(previousTimestamp) {
    var clocktime = $07144aea14354eb9$var$performanceNow.call($07144aea14354eb9$var$performance) * 1e-3;
    var seconds = Math.floor(clocktime);
    var nanoseconds = Math.floor(clocktime % 1 * 1e9);
    if (previousTimestamp) {
        seconds = seconds - previousTimestamp[0];
        nanoseconds = nanoseconds - previousTimestamp[1];
        if (nanoseconds < 0) {
            seconds--;
            nanoseconds += 1e9;
        }
    }
    return [
        seconds,
        nanoseconds
    ];
}
var $07144aea14354eb9$var$startTime = new Date();
function $07144aea14354eb9$var$uptime() {
    var currentTime = new Date();
    var dif = currentTime - $07144aea14354eb9$var$startTime;
    return dif / 1000;
}
var $07144aea14354eb9$var$process = {
    nextTick: $07144aea14354eb9$var$nextTick,
    title: $07144aea14354eb9$var$title,
    browser: $07144aea14354eb9$var$browser,
    env: $07144aea14354eb9$var$env,
    argv: $07144aea14354eb9$var$argv,
    version: $07144aea14354eb9$var$version,
    versions: $07144aea14354eb9$var$versions,
    on: $07144aea14354eb9$var$on,
    addListener: $07144aea14354eb9$var$addListener,
    once: $07144aea14354eb9$var$once,
    off: $07144aea14354eb9$var$off,
    removeListener: $07144aea14354eb9$var$removeListener,
    removeAllListeners: $07144aea14354eb9$var$removeAllListeners,
    emit: $07144aea14354eb9$var$emit,
    binding: $07144aea14354eb9$var$binding,
    cwd: $07144aea14354eb9$var$cwd,
    chdir: $07144aea14354eb9$var$chdir,
    umask: $07144aea14354eb9$var$umask,
    hrtime: $07144aea14354eb9$var$hrtime,
    platform: $07144aea14354eb9$var$platform,
    release: $07144aea14354eb9$var$release,
    config: $07144aea14354eb9$var$config,
    uptime: $07144aea14354eb9$var$uptime
};
var $07144aea14354eb9$var$inherits;
if (typeof Object.create === 'function') $07144aea14354eb9$var$inherits = function inherits(ctor, superCtor) {
    // implementation from standard node.js 'util' module
    ctor.super_ = superCtor;
    ctor.prototype = Object.create(superCtor.prototype, {
        constructor: {
            value: ctor,
            enumerable: false,
            writable: true,
            configurable: true
        }
    });
};
else $07144aea14354eb9$var$inherits = function inherits(ctor, superCtor) {
    ctor.super_ = superCtor;
    var TempCtor = function TempCtor() {};
    TempCtor.prototype = superCtor.prototype;
    ctor.prototype = new TempCtor();
    ctor.prototype.constructor = ctor;
};
var $07144aea14354eb9$var$inherits$1 = $07144aea14354eb9$var$inherits;
var $07144aea14354eb9$var$formatRegExp = /%[sdj%]/g;
function $07144aea14354eb9$var$format(f) {
    if (!$07144aea14354eb9$var$isString(f)) {
        var objects = [];
        for(var i = 0; i < arguments.length; i++)objects.push($07144aea14354eb9$var$inspect(arguments[i]));
        return objects.join(' ');
    }
    var i = 1;
    var args = arguments;
    var len = args.length;
    var str = String(f).replace($07144aea14354eb9$var$formatRegExp, function(x) {
        if (x === '%%') return '%';
        if (i >= len) return x;
        switch(x){
            case '%s':
                return String(args[i++]);
            case '%d':
                return Number(args[i++]);
            case '%j':
                try {
                    return JSON.stringify(args[i++]);
                } catch (_) {
                    return '[Circular]';
                }
            default:
                return x;
        }
    });
    for(var x = args[i]; i < len; x = args[++i])if ($07144aea14354eb9$var$isNull(x) || !$07144aea14354eb9$var$isObject(x)) str += ' ' + x;
    else str += ' ' + $07144aea14354eb9$var$inspect(x);
    return str;
}
// Returns a modified function which warns once by default.
// If --no-deprecation is set, then it is a no-op.
function $07144aea14354eb9$var$deprecate(fn, msg) {
    // Allow for deprecating things in the process of starting up.
    if ($07144aea14354eb9$var$isUndefined($07144aea14354eb9$var$global$1.process)) return function() {
        return $07144aea14354eb9$var$deprecate(fn, msg).apply(this, arguments);
    };
    if ($07144aea14354eb9$var$process.noDeprecation === true) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($07144aea14354eb9$var$process.throwDeprecation) throw new Error(msg);
            else if ($07144aea14354eb9$var$process.traceDeprecation) console.trace(msg);
            else console.error(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
var $07144aea14354eb9$var$debugs = {};
var $07144aea14354eb9$var$debugEnviron;
function $07144aea14354eb9$var$debuglog(set) {
    if ($07144aea14354eb9$var$isUndefined($07144aea14354eb9$var$debugEnviron)) $07144aea14354eb9$var$debugEnviron = $07144aea14354eb9$var$process.env.NODE_DEBUG || '';
    set = set.toUpperCase();
    if (!$07144aea14354eb9$var$debugs[set]) {
        if (new RegExp('\\b' + set + '\\b', 'i').test($07144aea14354eb9$var$debugEnviron)) {
            var pid = 0;
            $07144aea14354eb9$var$debugs[set] = function() {
                var msg = $07144aea14354eb9$var$format.apply(null, arguments);
                console.error('%s %d: %s', set, pid, msg);
            };
        } else $07144aea14354eb9$var$debugs[set] = function() {};
    }
    return $07144aea14354eb9$var$debugs[set];
}
/**
 * Echos the value of a value. Trys to print the value out
 * in the best way possible given the different types.
 *
 * @param {Object} obj The object to print out.
 * @param {Object} opts Optional options object that alters the output.
 */ /* legacy: obj, showHidden, depth, colors*/ function $07144aea14354eb9$var$inspect(obj, opts) {
    // default options
    var ctx = {
        seen: [],
        stylize: $07144aea14354eb9$var$stylizeNoColor
    }; // legacy...
    if (arguments.length >= 3) ctx.depth = arguments[2];
    if (arguments.length >= 4) ctx.colors = arguments[3];
    if ($07144aea14354eb9$var$isBoolean(opts)) // legacy...
    ctx.showHidden = opts;
    else if (opts) // got an "options" object
    $07144aea14354eb9$var$_extend(ctx, opts);
     // set default options
    if ($07144aea14354eb9$var$isUndefined(ctx.showHidden)) ctx.showHidden = false;
    if ($07144aea14354eb9$var$isUndefined(ctx.depth)) ctx.depth = 2;
    if ($07144aea14354eb9$var$isUndefined(ctx.colors)) ctx.colors = false;
    if ($07144aea14354eb9$var$isUndefined(ctx.customInspect)) ctx.customInspect = true;
    if (ctx.colors) ctx.stylize = $07144aea14354eb9$var$stylizeWithColor;
    return $07144aea14354eb9$var$formatValue(ctx, obj, ctx.depth);
} // http://en.wikipedia.org/wiki/ANSI_escape_code#graphics
$07144aea14354eb9$var$inspect.colors = {
    'bold': [
        1,
        22
    ],
    'italic': [
        3,
        23
    ],
    'underline': [
        4,
        24
    ],
    'inverse': [
        7,
        27
    ],
    'white': [
        37,
        39
    ],
    'grey': [
        90,
        39
    ],
    'black': [
        30,
        39
    ],
    'blue': [
        34,
        39
    ],
    'cyan': [
        36,
        39
    ],
    'green': [
        32,
        39
    ],
    'magenta': [
        35,
        39
    ],
    'red': [
        31,
        39
    ],
    'yellow': [
        33,
        39
    ]
}; // Don't use 'blue' not visible on cmd.exe
$07144aea14354eb9$var$inspect.styles = {
    'special': 'cyan',
    'number': 'yellow',
    'boolean': 'yellow',
    'undefined': 'grey',
    'null': 'bold',
    'string': 'green',
    'date': 'magenta',
    // "name": intentionally not styling
    'regexp': 'red'
};
function $07144aea14354eb9$var$stylizeWithColor(str, styleType) {
    var style = $07144aea14354eb9$var$inspect.styles[styleType];
    if (style) return "\x1B[" + $07144aea14354eb9$var$inspect.colors[style][0] + 'm' + str + "\x1B[" + $07144aea14354eb9$var$inspect.colors[style][1] + 'm';
    else return str;
}
function $07144aea14354eb9$var$stylizeNoColor(str, styleType) {
    return str;
}
function $07144aea14354eb9$var$arrayToHash(array) {
    var hash = {};
    array.forEach(function(val, idx) {
        hash[val] = true;
    });
    return hash;
}
function $07144aea14354eb9$var$formatValue(ctx, value, recurseTimes) {
    // Provide a hook for user-specified inspect functions.
    // Check that value is an object with an inspect function on it
    if (ctx.customInspect && value && $07144aea14354eb9$var$isFunction(value.inspect) && // Filter out the util module, it's inspect function is special
    value.inspect !== $07144aea14354eb9$var$inspect && // Also filter out any prototype objects using the circular check.
    !(value.constructor && value.constructor.prototype === value)) {
        var ret = value.inspect(recurseTimes, ctx);
        if (!$07144aea14354eb9$var$isString(ret)) ret = $07144aea14354eb9$var$formatValue(ctx, ret, recurseTimes);
        return ret;
    } // Primitive types cannot have properties
    var primitive = $07144aea14354eb9$var$formatPrimitive(ctx, value);
    if (primitive) return primitive;
     // Look up the keys of the object.
    var keys = Object.keys(value);
    var visibleKeys = $07144aea14354eb9$var$arrayToHash(keys);
    if (ctx.showHidden) keys = Object.getOwnPropertyNames(value);
     // IE doesn't make error fields non-enumerable
    // http://msdn.microsoft.com/en-us/library/ie/dww52sbt(v=vs.94).aspx
    if ($07144aea14354eb9$var$isError(value) && (keys.indexOf('message') >= 0 || keys.indexOf('description') >= 0)) return $07144aea14354eb9$var$formatError(value);
     // Some type of object without properties can be shortcutted.
    if (keys.length === 0) {
        if ($07144aea14354eb9$var$isFunction(value)) {
            var name = value.name ? ': ' + value.name : '';
            return ctx.stylize('[Function' + name + ']', 'special');
        }
        if ($07144aea14354eb9$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        if ($07144aea14354eb9$var$isDate(value)) return ctx.stylize(Date.prototype.toString.call(value), 'date');
        if ($07144aea14354eb9$var$isError(value)) return $07144aea14354eb9$var$formatError(value);
    }
    var base = '', array = false, braces = [
        '{',
        '}'
    ]; // Make Array say that they are Array
    if ($07144aea14354eb9$var$isArray(value)) {
        array = true;
        braces = [
            '[',
            ']'
        ];
    } // Make functions say that they are functions
    if ($07144aea14354eb9$var$isFunction(value)) {
        var n = value.name ? ': ' + value.name : '';
        base = ' [Function' + n + ']';
    } // Make RegExps say that they are RegExps
    if ($07144aea14354eb9$var$isRegExp(value)) base = ' ' + RegExp.prototype.toString.call(value);
     // Make dates with properties first say the date
    if ($07144aea14354eb9$var$isDate(value)) base = ' ' + Date.prototype.toUTCString.call(value);
     // Make error with message first say the error
    if ($07144aea14354eb9$var$isError(value)) base = ' ' + $07144aea14354eb9$var$formatError(value);
    if (keys.length === 0 && (!array || value.length == 0)) return braces[0] + base + braces[1];
    if (recurseTimes < 0) {
        if ($07144aea14354eb9$var$isRegExp(value)) return ctx.stylize(RegExp.prototype.toString.call(value), 'regexp');
        else return ctx.stylize('[Object]', 'special');
    }
    ctx.seen.push(value);
    var output;
    if (array) output = $07144aea14354eb9$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys);
    else output = keys.map(function(key) {
        return $07144aea14354eb9$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array);
    });
    ctx.seen.pop();
    return $07144aea14354eb9$var$reduceToSingleString(output, base, braces);
}
function $07144aea14354eb9$var$formatPrimitive(ctx, value) {
    if ($07144aea14354eb9$var$isUndefined(value)) return ctx.stylize('undefined', 'undefined');
    if ($07144aea14354eb9$var$isString(value)) {
        var simple = '\'' + JSON.stringify(value).replace(/^"|"$/g, '').replace(/'/g, "\\'").replace(/\\"/g, '"') + '\'';
        return ctx.stylize(simple, 'string');
    }
    if ($07144aea14354eb9$var$isNumber(value)) return ctx.stylize('' + value, 'number');
    if ($07144aea14354eb9$var$isBoolean(value)) return ctx.stylize('' + value, 'boolean'); // For some reason typeof null is "object", so special case here.
    if ($07144aea14354eb9$var$isNull(value)) return ctx.stylize('null', 'null');
}
function $07144aea14354eb9$var$formatError(value) {
    return '[' + Error.prototype.toString.call(value) + ']';
}
function $07144aea14354eb9$var$formatArray(ctx, value, recurseTimes, visibleKeys, keys) {
    var output = [];
    for(var i = 0, l = value.length; i < l; ++i)if ($07144aea14354eb9$var$hasOwnProperty(value, String(i))) output.push($07144aea14354eb9$var$formatProperty(ctx, value, recurseTimes, visibleKeys, String(i), true));
    else output.push('');
    keys.forEach(function(key) {
        if (!key.match(/^\d+$/)) output.push($07144aea14354eb9$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, true));
    });
    return output;
}
function $07144aea14354eb9$var$formatProperty(ctx, value, recurseTimes, visibleKeys, key, array) {
    var name, str, desc;
    desc = Object.getOwnPropertyDescriptor(value, key) || {
        value: value[key]
    };
    if (desc.get) {
        if (desc.set) str = ctx.stylize('[Getter/Setter]', 'special');
        else str = ctx.stylize('[Getter]', 'special');
    } else if (desc.set) str = ctx.stylize('[Setter]', 'special');
    if (!$07144aea14354eb9$var$hasOwnProperty(visibleKeys, key)) name = '[' + key + ']';
    if (!str) {
        if (ctx.seen.indexOf(desc.value) < 0) {
            if ($07144aea14354eb9$var$isNull(recurseTimes)) str = $07144aea14354eb9$var$formatValue(ctx, desc.value, null);
            else str = $07144aea14354eb9$var$formatValue(ctx, desc.value, recurseTimes - 1);
            if (str.indexOf('\n') > -1) {
                if (array) str = str.split('\n').map(function(line) {
                    return '  ' + line;
                }).join('\n').substr(2);
                else str = '\n' + str.split('\n').map(function(line) {
                    return '   ' + line;
                }).join('\n');
            }
        } else str = ctx.stylize('[Circular]', 'special');
    }
    if ($07144aea14354eb9$var$isUndefined(name)) {
        if (array && key.match(/^\d+$/)) return str;
        name = JSON.stringify('' + key);
        if (name.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/)) {
            name = name.substr(1, name.length - 2);
            name = ctx.stylize(name, 'name');
        } else {
            name = name.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'");
            name = ctx.stylize(name, 'string');
        }
    }
    return name + ': ' + str;
}
function $07144aea14354eb9$var$reduceToSingleString(output, base, braces) {
    var length = output.reduce(function(prev, cur) {
        cur.indexOf('\n');
        return prev + cur.replace(/\u001b\[\d\d?m/g, '').length + 1;
    }, 0);
    if (length > 60) return braces[0] + (base === '' ? '' : base + '\n ') + ' ' + output.join(',\n  ') + ' ' + braces[1];
    return braces[0] + base + ' ' + output.join(', ') + ' ' + braces[1];
} // NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
function $07144aea14354eb9$var$isArray(ar) {
    return Array.isArray(ar);
}
function $07144aea14354eb9$var$isBoolean(arg) {
    return typeof arg === 'boolean';
}
function $07144aea14354eb9$var$isNull(arg) {
    return arg === null;
}
function $07144aea14354eb9$var$isNullOrUndefined(arg) {
    return arg == null;
}
function $07144aea14354eb9$var$isNumber(arg) {
    return typeof arg === 'number';
}
function $07144aea14354eb9$var$isString(arg) {
    return typeof arg === 'string';
}
function $07144aea14354eb9$var$isSymbol(arg) {
    return typeof arg === 'symbol';
}
function $07144aea14354eb9$var$isUndefined(arg) {
    return arg === void 0;
}
function $07144aea14354eb9$var$isRegExp(re) {
    return $07144aea14354eb9$var$isObject(re) && $07144aea14354eb9$var$objectToString(re) === '[object RegExp]';
}
function $07144aea14354eb9$var$isObject(arg) {
    return typeof arg === 'object' && arg !== null;
}
function $07144aea14354eb9$var$isDate(d) {
    return $07144aea14354eb9$var$isObject(d) && $07144aea14354eb9$var$objectToString(d) === '[object Date]';
}
function $07144aea14354eb9$var$isError(e) {
    return $07144aea14354eb9$var$isObject(e) && ($07144aea14354eb9$var$objectToString(e) === '[object Error]' || e instanceof Error);
}
function $07144aea14354eb9$var$isFunction(arg) {
    return typeof arg === 'function';
}
function $07144aea14354eb9$var$isPrimitive(arg) {
    return arg === null || typeof arg === 'boolean' || typeof arg === 'number' || typeof arg === 'string' || typeof arg === 'symbol' || // ES6 symbol
    typeof arg === 'undefined';
}
function $07144aea14354eb9$var$isBuffer(maybeBuf) {
    return $07144aea14354eb9$var$buffer_1.isBuffer(maybeBuf);
}
function $07144aea14354eb9$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}
function $07144aea14354eb9$var$pad(n) {
    return n < 10 ? '0' + n.toString(10) : n.toString(10);
}
var $07144aea14354eb9$var$months = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec'
]; // 26 Feb 16:19:34
function $07144aea14354eb9$var$timestamp() {
    var d = new Date();
    var time = [
        $07144aea14354eb9$var$pad(d.getHours()),
        $07144aea14354eb9$var$pad(d.getMinutes()),
        $07144aea14354eb9$var$pad(d.getSeconds())
    ].join(':');
    return [
        d.getDate(),
        $07144aea14354eb9$var$months[d.getMonth()],
        time
    ].join(' ');
} // log is just a thin wrapper to console.log that prepends a timestamp
function $07144aea14354eb9$var$log() {
    console.log('%s - %s', $07144aea14354eb9$var$timestamp(), $07144aea14354eb9$var$format.apply(null, arguments));
}
function $07144aea14354eb9$var$_extend(origin, add) {
    // Don't do anything if add isn't an object
    if (!add || !$07144aea14354eb9$var$isObject(add)) return origin;
    var keys = Object.keys(add);
    var i = keys.length;
    while(i--)origin[keys[i]] = add[keys[i]];
    return origin;
}
function $07144aea14354eb9$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
var $07144aea14354eb9$var$require$$3 = {
    inherits: $07144aea14354eb9$var$inherits$1,
    _extend: $07144aea14354eb9$var$_extend,
    log: $07144aea14354eb9$var$log,
    isBuffer: $07144aea14354eb9$var$isBuffer,
    isPrimitive: $07144aea14354eb9$var$isPrimitive,
    isFunction: $07144aea14354eb9$var$isFunction,
    isError: $07144aea14354eb9$var$isError,
    isDate: $07144aea14354eb9$var$isDate,
    isObject: $07144aea14354eb9$var$isObject,
    isRegExp: $07144aea14354eb9$var$isRegExp,
    isUndefined: $07144aea14354eb9$var$isUndefined,
    isSymbol: $07144aea14354eb9$var$isSymbol,
    isString: $07144aea14354eb9$var$isString,
    isNumber: $07144aea14354eb9$var$isNumber,
    isNullOrUndefined: $07144aea14354eb9$var$isNullOrUndefined,
    isNull: $07144aea14354eb9$var$isNull,
    isBoolean: $07144aea14354eb9$var$isBoolean,
    isArray: $07144aea14354eb9$var$isArray,
    inspect: $07144aea14354eb9$var$inspect,
    deprecate: $07144aea14354eb9$var$deprecate,
    format: $07144aea14354eb9$var$format,
    debuglog: $07144aea14354eb9$var$debuglog
};
function $07144aea14354eb9$var$BufferList() {
    this.head = null;
    this.tail = null;
    this.length = 0;
}
$07144aea14354eb9$var$BufferList.prototype.push = function(v) {
    var entry = {
        data: v,
        next: null
    };
    if (this.length > 0) this.tail.next = entry;
    else this.head = entry;
    this.tail = entry;
    ++this.length;
};
$07144aea14354eb9$var$BufferList.prototype.unshift = function(v) {
    var entry = {
        data: v,
        next: this.head
    };
    if (this.length === 0) this.tail = entry;
    this.head = entry;
    ++this.length;
};
$07144aea14354eb9$var$BufferList.prototype.shift = function() {
    if (this.length === 0) return;
    var ret = this.head.data;
    if (this.length === 1) this.head = this.tail = null;
    else this.head = this.head.next;
    --this.length;
    return ret;
};
$07144aea14354eb9$var$BufferList.prototype.clear = function() {
    this.head = this.tail = null;
    this.length = 0;
};
$07144aea14354eb9$var$BufferList.prototype.join = function(s) {
    if (this.length === 0) return '';
    var p = this.head;
    var ret = '' + p.data;
    while(p = p.next)ret += s + p.data;
    return ret;
};
$07144aea14354eb9$var$BufferList.prototype.concat = function(n) {
    if (this.length === 0) return $07144aea14354eb9$var$buffer_1.alloc(0);
    if (this.length === 1) return this.head.data;
    var ret = $07144aea14354eb9$var$buffer_1.allocUnsafe(n >>> 0);
    var p = this.head;
    var i = 0;
    while(p){
        p.data.copy(ret, i);
        i += p.data.length;
        p = p.next;
    }
    return ret;
};
var $07144aea14354eb9$var$string_decoder = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // Copyright Joyent, Inc. and other Node contributors.
    //
    // Permission is hereby granted, free of charge, to any person obtaining a
    // copy of this software and associated documentation files (the
    // "Software"), to deal in the Software without restriction, including
    // without limitation the rights to use, copy, modify, merge, publish,
    // distribute, sublicense, and/or sell copies of the Software, and to permit
    // persons to whom the Software is furnished to do so, subject to the
    // following conditions:
    //
    // The above copyright notice and this permission notice shall be included
    // in all copies or substantial portions of the Software.
    //
    // THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
    // OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
    // MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
    // NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
    // DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
    // OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
    // USE OR OTHER DEALINGS IN THE SOFTWARE.
    var Buffer = $07144aea14354eb9$var$buffer.Buffer;
    var isBufferEncoding = Buffer.isEncoding || function(encoding) {
        switch(encoding && encoding.toLowerCase()){
            case 'hex':
            case 'utf8':
            case 'utf-8':
            case 'ascii':
            case 'binary':
            case 'base64':
            case 'ucs2':
            case 'ucs-2':
            case 'utf16le':
            case 'utf-16le':
            case 'raw':
                return true;
            default:
                return false;
        }
    };
    function assertEncoding(encoding) {
        if (encoding && !isBufferEncoding(encoding)) throw new Error('Unknown encoding: ' + encoding);
    } // StringDecoder provides an interface for efficiently splitting a series of
    // buffers into a series of JS strings without breaking apart multi-byte
    // characters. CESU-8 is handled as part of the UTF-8 encoding.
    //
    // @TODO Handling all encodings inside a single object makes it very difficult
    // to reason about this code, so it should be split up in the future.
    // @TODO There should be a utf8-strict encoding that rejects invalid UTF-8 code
    // points as used by CESU-8.
    var StringDecoder = exports.StringDecoder = function(encoding) {
        this.encoding = (encoding || 'utf8').toLowerCase().replace(/[-_]/, '');
        assertEncoding(encoding);
        switch(this.encoding){
            case 'utf8':
                // CESU-8 represents each of Surrogate Pair by 3-bytes
                this.surrogateSize = 3;
                break;
            case 'ucs2':
            case 'utf16le':
                // UTF-16 represents each of Surrogate Pair by 2-bytes
                this.surrogateSize = 2;
                this.detectIncompleteChar = utf16DetectIncompleteChar;
                break;
            case 'base64':
                // Base-64 stores 3 bytes in 4 chars, and pads the remainder.
                this.surrogateSize = 3;
                this.detectIncompleteChar = base64DetectIncompleteChar;
                break;
            default:
                this.write = passThroughWrite;
                return;
        } // Enough space to store all bytes of a single character. UTF-8 needs 4
        // bytes, but CESU-8 may require up to 6 (3 bytes per surrogate).
        this.charBuffer = new Buffer(6); // Number of bytes received for the current incomplete multi-byte character.
        this.charReceived = 0; // Number of bytes expected for the current incomplete multi-byte character.
        this.charLength = 0;
    }; // write decodes the given buffer and returns it as JS string that is
    // guaranteed to not contain any partial multi-byte characters. Any partial
    // character found at the end of the buffer is buffered up, and will be
    // returned when calling write again with the remaining bytes.
    //
    // Note: Converting a Buffer containing an orphan surrogate to a String
    // currently works, but converting a String to a Buffer (via `new Buffer`, or
    // Buffer#write) will replace incomplete surrogates with the unicode
    // replacement character. See https://codereview.chromium.org/121173009/ .
    StringDecoder.prototype.write = function(buffer) {
        var charStr = ''; // if our last write ended with an incomplete multibyte character
        while(this.charLength){
            // determine how many remaining bytes this buffer has to offer for this char
            var available = buffer.length >= this.charLength - this.charReceived ? this.charLength - this.charReceived : buffer.length; // add the new bytes to the char buffer
            buffer.copy(this.charBuffer, this.charReceived, 0, available);
            this.charReceived += available;
            if (this.charReceived < this.charLength) // still not enough chars in this buffer? wait for more ...
            return '';
             // remove bytes belonging to the current character from the buffer
            buffer = buffer.slice(available, buffer.length); // get the character that was split
            charStr = this.charBuffer.slice(0, this.charLength).toString(this.encoding); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
            var charCode = charStr.charCodeAt(charStr.length - 1);
            if (charCode >= 0xD800 && charCode <= 0xDBFF) {
                this.charLength += this.surrogateSize;
                charStr = '';
                continue;
            }
            this.charReceived = this.charLength = 0; // if there are no more bytes in this buffer, just emit our char
            if (buffer.length === 0) return charStr;
            break;
        } // determine and set charLength / charReceived
        this.detectIncompleteChar(buffer);
        var end = buffer.length;
        if (this.charLength) {
            // buffer the incomplete character bytes we got
            buffer.copy(this.charBuffer, 0, buffer.length - this.charReceived, end);
            end -= this.charReceived;
        }
        charStr += buffer.toString(this.encoding, 0, end);
        var end = charStr.length - 1;
        var charCode = charStr.charCodeAt(end); // CESU-8: lead surrogate (D800-DBFF) is also the incomplete character
        if (charCode >= 0xD800 && charCode <= 0xDBFF) {
            var size = this.surrogateSize;
            this.charLength += size;
            this.charReceived += size;
            this.charBuffer.copy(this.charBuffer, size, 0, size);
            buffer.copy(this.charBuffer, 0, 0, size);
            return charStr.substring(0, end);
        } // or just emit the charStr
        return charStr;
    }; // detectIncompleteChar determines if there is an incomplete UTF-8 character at
    // the end of the given buffer. If so, it sets this.charLength to the byte
    // length that character, and sets this.charReceived to the number of bytes
    // that are available for this character.
    StringDecoder.prototype.detectIncompleteChar = function(buffer) {
        // determine how many bytes we have to check at the end of this buffer
        var i = buffer.length >= 3 ? 3 : buffer.length; // Figure out if one of the last i bytes of our buffer announces an
        // incomplete char.
        for(; i > 0; i--){
            var c = buffer[buffer.length - i]; // See http://en.wikipedia.org/wiki/UTF-8#Description
            // 110XXXXX
            if (i == 1 && c >> 5 == 0x06) {
                this.charLength = 2;
                break;
            } // 1110XXXX
            if (i <= 2 && c >> 4 == 0x0E) {
                this.charLength = 3;
                break;
            } // 11110XXX
            if (i <= 3 && c >> 3 == 0x1E) {
                this.charLength = 4;
                break;
            }
        }
        this.charReceived = i;
    };
    StringDecoder.prototype.end = function(buffer) {
        var res = '';
        if (buffer && buffer.length) res = this.write(buffer);
        if (this.charReceived) {
            var cr = this.charReceived;
            var buf = this.charBuffer;
            var enc = this.encoding;
            res += buf.slice(0, cr).toString(enc);
        }
        return res;
    };
    function passThroughWrite(buffer) {
        return buffer.toString(this.encoding);
    }
    function utf16DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 2;
        this.charLength = this.charReceived ? 2 : 0;
    }
    function base64DetectIncompleteChar(buffer) {
        this.charReceived = buffer.length % 3;
        this.charLength = this.charReceived ? 3 : 0;
    }
});
var $07144aea14354eb9$var$string_decoder_1 = $07144aea14354eb9$var$string_decoder.StringDecoder;
$07144aea14354eb9$var$Readable.ReadableState = $07144aea14354eb9$var$ReadableState;
var $07144aea14354eb9$var$debug = $07144aea14354eb9$var$debuglog('stream');
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$Readable, $07144aea14354eb9$var$EventEmitter);
function $07144aea14354eb9$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === 'function') return emitter.prependListener(event, fn);
    else {
        // This is a hack to make sure that our error handler is attached before any
        // userland ones.  NEVER DO THIS. This is here only because this code needs
        // to continue to work with older versions of Node.js that do not include
        // the prependListener() method. The goal is to eventually remove this hack.
        if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
        else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
        else emitter._events[event] = [
            fn,
            emitter._events[event]
        ];
    }
}
function $07144aea14354eb9$var$listenerCount$1(emitter, type) {
    return emitter.listeners(type).length;
}
function $07144aea14354eb9$var$ReadableState(options, stream) {
    options = options || {}; // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (stream instanceof $07144aea14354eb9$var$Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode; // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.
    this.highWaterMark = ~~this.highWaterMark; // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $07144aea14354eb9$var$BufferList();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // when piping, we only care about 'readable' events that happen
    // after read()ing all the bytes and not getting any pushback.
    this.ranOut = false; // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0; // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        this.decoder = new $07144aea14354eb9$var$string_decoder_1(options.encoding);
        this.encoding = options.encoding;
    }
}
function $07144aea14354eb9$var$Readable(options) {
    if (!(this instanceof $07144aea14354eb9$var$Readable)) return new $07144aea14354eb9$var$Readable(options);
    this._readableState = new $07144aea14354eb9$var$ReadableState(options, this); // legacy
    this.readable = true;
    if (options && typeof options.read === 'function') this._read = options.read;
    $07144aea14354eb9$var$EventEmitter.call(this);
} // Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$07144aea14354eb9$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    if (!state.objectMode && typeof chunk === 'string') {
        encoding = encoding || state.defaultEncoding;
        if (encoding !== state.encoding) {
            chunk = $07144aea14354eb9$var$buffer_1.from(chunk, encoding);
            encoding = '';
        }
    }
    return $07144aea14354eb9$var$readableAddChunk(this, state, chunk, encoding, false);
}; // Unshift should *always* be something directly out of read()
$07144aea14354eb9$var$Readable.prototype.unshift = function(chunk) {
    var state = this._readableState;
    return $07144aea14354eb9$var$readableAddChunk(this, state, chunk, '', true);
};
$07144aea14354eb9$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};
function $07144aea14354eb9$var$readableAddChunk(stream, state, chunk, encoding, addToFront) {
    var er = $07144aea14354eb9$var$chunkInvalid(state, chunk);
    if (er) stream.emit('error', er);
    else if (chunk === null) {
        state.reading = false;
        $07144aea14354eb9$var$onEofChunk(stream, state);
    } else if (state.objectMode || chunk && chunk.length > 0) {
        if (state.ended && !addToFront) {
            var e = new Error('stream.push() after EOF');
            stream.emit('error', e);
        } else if (state.endEmitted && addToFront) {
            var _e = new Error('stream.unshift() after end event');
            stream.emit('error', _e);
        } else {
            var skipAdd;
            if (state.decoder && !addToFront && !encoding) {
                chunk = state.decoder.write(chunk);
                skipAdd = !state.objectMode && chunk.length === 0;
            }
            if (!addToFront) state.reading = false; // Don't add to the buffer if we've decoded to an empty string chunk and
            // we're not in object mode
            if (!skipAdd) {
                // if we want the data now, just emit it.
                if (state.flowing && state.length === 0 && !state.sync) {
                    stream.emit('data', chunk);
                    stream.read(0);
                } else {
                    // update the buffer info.
                    state.length += state.objectMode ? 1 : chunk.length;
                    if (addToFront) state.buffer.unshift(chunk);
                    else state.buffer.push(chunk);
                    if (state.needReadable) $07144aea14354eb9$var$emitReadable(stream);
                }
            }
            $07144aea14354eb9$var$maybeReadMore(stream, state);
        }
    } else if (!addToFront) state.reading = false;
    return $07144aea14354eb9$var$needMoreData(state);
} // if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $07144aea14354eb9$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
} // backwards compatibility.
$07144aea14354eb9$var$Readable.prototype.setEncoding = function(enc) {
    this._readableState.decoder = new $07144aea14354eb9$var$string_decoder_1(enc);
    this._readableState.encoding = enc;
    return this;
}; // Don't raise the hwm > 8MB
var $07144aea14354eb9$var$MAX_HWM = 0x800000;
function $07144aea14354eb9$var$computeNewHighWaterMark(n) {
    if (n >= $07144aea14354eb9$var$MAX_HWM) n = $07144aea14354eb9$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
} // This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $07144aea14354eb9$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    } // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $07144aea14354eb9$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n; // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
} // you can override either this method, or the async _read(n) below.
$07144aea14354eb9$var$Readable.prototype.read = function(n) {
    $07144aea14354eb9$var$debug('read', n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false; // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $07144aea14354eb9$var$debug('read: emitReadable', state.length, state.ended);
        if (state.length === 0 && state.ended) $07144aea14354eb9$var$endReadable(this);
        else $07144aea14354eb9$var$emitReadable(this);
        return null;
    }
    n = $07144aea14354eb9$var$howMuchToRead(n, state); // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $07144aea14354eb9$var$endReadable(this);
        return null;
    } // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $07144aea14354eb9$var$debug('need readable', doRead); // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $07144aea14354eb9$var$debug('length less than watermark', doRead);
    } // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $07144aea14354eb9$var$debug('reading or ended', doRead);
    } else if (doRead) {
        $07144aea14354eb9$var$debug('do read');
        state.reading = true;
        state.sync = true; // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true; // call internal read method
        this._read(state.highWaterMark);
        state.sync = false; // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $07144aea14354eb9$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $07144aea14354eb9$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true; // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $07144aea14354eb9$var$endReadable(this);
    }
    if (ret !== null) this.emit('data', ret);
    return ret;
};
function $07144aea14354eb9$var$chunkInvalid(state, chunk) {
    var er = null;
    if (!$07144aea14354eb9$var$buffer_1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== null && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    return er;
}
function $07144aea14354eb9$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true; // emit 'readable' now to make sure it gets picked up.
    $07144aea14354eb9$var$emitReadable(stream);
} // Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $07144aea14354eb9$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $07144aea14354eb9$var$debug('emitReadable', state.flowing);
        state.emittedReadable = true;
        if (state.sync) $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$emitReadable_, stream);
        else $07144aea14354eb9$var$emitReadable_(stream);
    }
}
function $07144aea14354eb9$var$emitReadable_(stream) {
    $07144aea14354eb9$var$debug('emit readable');
    stream.emit('readable');
    $07144aea14354eb9$var$flow(stream);
} // at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $07144aea14354eb9$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$maybeReadMore_, stream, state);
    }
}
function $07144aea14354eb9$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $07144aea14354eb9$var$debug('maybeReadMore read 0');
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
} // abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$07144aea14354eb9$var$Readable.prototype._read = function(n) {
    this.emit('error', new Error('not implemented'));
};
$07144aea14354eb9$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $07144aea14354eb9$var$debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
    var doEnd = !pipeOpts || pipeOpts.end !== false;
    var endFn = doEnd ? onend : cleanup;
    if (state.endEmitted) $07144aea14354eb9$var$nextTick(endFn);
    else src.once('end', endFn);
    dest.on('unpipe', onunpipe);
    function onunpipe(readable) {
        $07144aea14354eb9$var$debug('onunpipe');
        if (readable === src) cleanup();
    }
    function onend() {
        $07144aea14354eb9$var$debug('onend');
        dest.end();
    } // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $07144aea14354eb9$var$pipeOnDrain(src);
    dest.on('drain', ondrain);
    var cleanedUp = false;
    function cleanup() {
        $07144aea14354eb9$var$debug('cleanup'); // cleanup event handlers once the pipe is broken
        dest.removeListener('close', onclose);
        dest.removeListener('finish', onfinish);
        dest.removeListener('drain', ondrain);
        dest.removeListener('error', onerror);
        dest.removeListener('unpipe', onunpipe);
        src.removeListener('end', onend);
        src.removeListener('end', cleanup);
        src.removeListener('data', ondata);
        cleanedUp = true; // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    } // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on('data', ondata);
    function ondata(chunk) {
        $07144aea14354eb9$var$debug('ondata');
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $07144aea14354eb9$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $07144aea14354eb9$var$debug('false write response, pause', src._readableState.awaitDrain);
                src._readableState.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    } // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $07144aea14354eb9$var$debug('onerror', er);
        unpipe();
        dest.removeListener('error', onerror);
        if ($07144aea14354eb9$var$listenerCount$1(dest, 'error') === 0) dest.emit('error', er);
    } // Make sure our error handler is attached before userland ones.
    $07144aea14354eb9$var$prependListener(dest, 'error', onerror); // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener('finish', onfinish);
        unpipe();
    }
    dest.once('close', onclose);
    function onfinish() {
        $07144aea14354eb9$var$debug('onfinish');
        dest.removeListener('close', onclose);
        unpipe();
    }
    dest.once('finish', onfinish);
    function unpipe() {
        $07144aea14354eb9$var$debug('unpipe');
        src.unpipe(dest);
    } // tell the dest that it's being piped to
    dest.emit('pipe', src); // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $07144aea14354eb9$var$debug('pipe resume');
        src.resume();
    }
    return dest;
};
function $07144aea14354eb9$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $07144aea14354eb9$var$debug('pipeOnDrain', state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && src.listeners('data').length) {
            state.flowing = true;
            $07144aea14354eb9$var$flow(src);
        }
    };
}
$07144aea14354eb9$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState; // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this; // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes; // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit('unpipe', this);
        return this;
    } // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var _i = 0; _i < len; _i++)dests[_i].emit('unpipe', this);
        return this;
    } // try to find the right one.
    var i = $07144aea14354eb9$var$indexOf(state.pipes, dest);
    if (i === -1) return this;
    state.pipes.splice(i, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit('unpipe', this);
    return this;
}; // set up data events if they are asked for
// Ensure readable listeners eventually get something
$07144aea14354eb9$var$Readable.prototype.on = function(ev, fn) {
    var res = $07144aea14354eb9$var$EventEmitter.prototype.on.call(this, ev, fn);
    if (ev === 'data') // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === 'readable') {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$nReadingNextTick, this);
            else if (state.length) $07144aea14354eb9$var$emitReadable(this);
        }
    }
    return res;
};
$07144aea14354eb9$var$Readable.prototype.addListener = $07144aea14354eb9$var$Readable.prototype.on;
function $07144aea14354eb9$var$nReadingNextTick(self1) {
    $07144aea14354eb9$var$debug('readable nexttick read 0');
    self1.read(0);
} // pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$07144aea14354eb9$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $07144aea14354eb9$var$debug('resume');
        state.flowing = true;
        $07144aea14354eb9$var$resume(this, state);
    }
    return this;
};
function $07144aea14354eb9$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$resume_, stream, state);
    }
}
function $07144aea14354eb9$var$resume_(stream, state) {
    if (!state.reading) {
        $07144aea14354eb9$var$debug('resume read 0');
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit('resume');
    $07144aea14354eb9$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$07144aea14354eb9$var$Readable.prototype.pause = function() {
    $07144aea14354eb9$var$debug('call pause flowing=%j', this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $07144aea14354eb9$var$debug('pause');
        this._readableState.flowing = false;
        this.emit('pause');
    }
    return this;
};
function $07144aea14354eb9$var$flow(stream) {
    var state = stream._readableState;
    $07144aea14354eb9$var$debug('flow', state.flowing);
    while(state.flowing && stream.read() !== null);
} // wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$07144aea14354eb9$var$Readable.prototype.wrap = function(stream) {
    var state = this._readableState;
    var paused = false;
    var self1 = this;
    stream.on('end', function() {
        $07144aea14354eb9$var$debug('wrapped end');
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) self1.push(chunk);
        }
        self1.push(null);
    });
    stream.on('data', function(chunk) {
        $07144aea14354eb9$var$debug('wrapped data');
        if (state.decoder) chunk = state.decoder.write(chunk); // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = self1.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    }); // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === 'function') this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
     // proxy certain important events.
    var events = [
        'error',
        'close',
        'destroy',
        'pause',
        'resume'
    ];
    $07144aea14354eb9$var$forEach(events, function(ev) {
        stream.on(ev, self1.emit.bind(self1, ev));
    }); // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    self1._read = function(n) {
        $07144aea14354eb9$var$debug('wrapped _read', n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return self1;
}; // exposed for testing purposes only.
$07144aea14354eb9$var$Readable._fromList = $07144aea14354eb9$var$fromList; // Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $07144aea14354eb9$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join('');
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $07144aea14354eb9$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
} // Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $07144aea14354eb9$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $07144aea14354eb9$var$copyFromBufferString(n, list) : $07144aea14354eb9$var$copyFromBuffer(n, list);
    return ret;
} // Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $07144aea14354eb9$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
} // Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $07144aea14354eb9$var$copyFromBuffer(n, list) {
    var ret = $07144aea14354eb9$var$buffer_1.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $07144aea14354eb9$var$endReadable(stream) {
    var state = stream._readableState; // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$endReadableNT, state, stream);
    }
}
function $07144aea14354eb9$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit('end');
    }
}
function $07144aea14354eb9$var$forEach(xs, f) {
    for(var i = 0, l = xs.length; i < l; i++)f(xs[i], i);
}
function $07144aea14354eb9$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}
// A bit simpler than readable streams.
$07144aea14354eb9$var$Writable.WritableState = $07144aea14354eb9$var$WritableState;
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$Writable, $07144aea14354eb9$var$EventEmitter);
function $07144aea14354eb9$var$nop() {}
function $07144aea14354eb9$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
function $07144aea14354eb9$var$WritableState(options, stream) {
    Object.defineProperty(this, 'buffer', {
        get: $07144aea14354eb9$var$deprecate(function() {
            return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.")
    });
    options = options || {}; // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (stream instanceof $07144aea14354eb9$var$Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode; // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm; // cast to ints.
    this.highWaterMark = ~~this.highWaterMark;
    this.needDrain = false; // at the start of calling end()
    this.ending = false; // when end() has been called, and returned
    this.ended = false; // when 'finish' is emitted
    this.finished = false; // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode; // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || 'utf8'; // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0; // a flag to see when we're in the middle of a write.
    this.writing = false; // when true all writes will be buffered until .uncork() call
    this.corked = 0; // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true; // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false; // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $07144aea14354eb9$var$onwrite(stream, er);
    }; // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null; // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null; // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0; // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false; // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false; // count buffered requests
    this.bufferedRequestCount = 0; // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $07144aea14354eb9$var$CorkedRequest(this);
}
$07144aea14354eb9$var$WritableState.prototype.getBuffer = function writableStateGetBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
function $07144aea14354eb9$var$Writable(options) {
    // Writable ctor is applied to Duplexes, though they're not
    // instanceof Writable, they're instanceof Readable.
    if (!(this instanceof $07144aea14354eb9$var$Writable) && !(this instanceof $07144aea14354eb9$var$Duplex)) return new $07144aea14354eb9$var$Writable(options);
    this._writableState = new $07144aea14354eb9$var$WritableState(options, this); // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === 'function') this._write = options.write;
        if (typeof options.writev === 'function') this._writev = options.writev;
    }
    $07144aea14354eb9$var$EventEmitter.call(this);
} // Otherwise people can pipe Writable streams, which is just wrong.
$07144aea14354eb9$var$Writable.prototype.pipe = function() {
    this.emit('error', new Error('Cannot pipe, not readable'));
};
function $07144aea14354eb9$var$writeAfterEnd(stream, cb) {
    var er = new Error('write after end'); // TODO: defer error events consistently everywhere, not just the cb
    stream.emit('error', er);
    $07144aea14354eb9$var$nextTick(cb, er);
} // If we get something that is not a buffer, string, null, or undefined,
// and we're not in objectMode, then that's an error.
// Otherwise stream chunks are all considered to be of length=1, and the
// watermarks determine how many objects to keep in the buffer, rather than
// how many bytes or characters.
function $07144aea14354eb9$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false; // Always throw error if a null is written
    // if we are not in object mode then throw
    // if it is not a buffer, string, or undefined.
    if (chunk === null) er = new TypeError('May not write null values to stream');
    else if (!$07144aea14354eb9$var$buffer_1.isBuffer(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) er = new TypeError('Invalid non-string/buffer chunk');
    if (er) {
        stream.emit('error', er);
        $07144aea14354eb9$var$nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$07144aea14354eb9$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if ($07144aea14354eb9$var$buffer_1.isBuffer(chunk)) encoding = 'buffer';
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== 'function') cb = $07144aea14354eb9$var$nop;
    if (state.ended) $07144aea14354eb9$var$writeAfterEnd(this, cb);
    else if ($07144aea14354eb9$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $07144aea14354eb9$var$writeOrBuffer(this, state, chunk, encoding, cb);
    }
    return ret;
};
$07144aea14354eb9$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$07144aea14354eb9$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) $07144aea14354eb9$var$clearBuffer(this, state);
    }
};
$07144aea14354eb9$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === 'string') encoding = encoding.toLowerCase();
    if (!([
        'hex',
        'utf8',
        'utf-8',
        'ascii',
        'binary',
        'base64',
        'ucs2',
        'ucs-2',
        'utf16le',
        'utf-16le',
        'raw'
    ].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $07144aea14354eb9$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') chunk = $07144aea14354eb9$var$buffer_1.from(chunk, encoding);
    return chunk;
} // if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $07144aea14354eb9$var$writeOrBuffer(stream, state, chunk, encoding, cb) {
    chunk = $07144aea14354eb9$var$decodeChunk(state, chunk, encoding);
    if ($07144aea14354eb9$var$buffer_1.isBuffer(chunk)) encoding = 'buffer';
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark; // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = new $07144aea14354eb9$var$WriteReq(chunk, encoding, cb);
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $07144aea14354eb9$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $07144aea14354eb9$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $07144aea14354eb9$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) $07144aea14354eb9$var$nextTick(cb, er);
    else cb(er);
    stream._writableState.errorEmitted = true;
    stream.emit('error', er);
}
function $07144aea14354eb9$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $07144aea14354eb9$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $07144aea14354eb9$var$onwriteStateUpdate(state);
    if (er) $07144aea14354eb9$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $07144aea14354eb9$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $07144aea14354eb9$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$afterWrite, stream, state, finished, cb);
        else $07144aea14354eb9$var$afterWrite(stream, state, finished, cb);
    }
}
function $07144aea14354eb9$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $07144aea14354eb9$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $07144aea14354eb9$var$finishMaybe(stream, state);
} // Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $07144aea14354eb9$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit('drain');
    }
} // if there's something in the buffer waiting, then process it
function $07144aea14354eb9$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        while(entry){
            buffer[count] = entry;
            entry = entry.next;
            count += 1;
        }
        $07144aea14354eb9$var$doWrite(stream, state, true, state.length, buffer, '', holder.finish); // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $07144aea14354eb9$var$CorkedRequest(state);
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $07144aea14354eb9$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next; // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequestCount = 0;
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$07144aea14354eb9$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error('not implemented'));
};
$07144aea14354eb9$var$Writable.prototype._writev = null;
$07144aea14354eb9$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === 'function') {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === 'function') {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding); // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    } // ignore unnecessary end() calls.
    if (!state.ending && !state.finished) $07144aea14354eb9$var$endWritable(this, state, cb);
};
function $07144aea14354eb9$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $07144aea14354eb9$var$prefinish(stream, state) {
    if (!state.prefinished) {
        state.prefinished = true;
        stream.emit('prefinish');
    }
}
function $07144aea14354eb9$var$finishMaybe(stream, state) {
    var need = $07144aea14354eb9$var$needFinish(state);
    if (need) {
        if (state.pendingcb === 0) {
            $07144aea14354eb9$var$prefinish(stream, state);
            state.finished = true;
            stream.emit('finish');
        } else $07144aea14354eb9$var$prefinish(stream, state);
    }
    return need;
}
function $07144aea14354eb9$var$endWritable(stream, state, cb) {
    state.ending = true;
    $07144aea14354eb9$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $07144aea14354eb9$var$nextTick(cb);
        else stream.once('finish', cb);
    }
    state.ended = true;
    stream.writable = false;
} // It seems a linked list but it is not
// there will be only 2 of these for each stream
function $07144aea14354eb9$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function(err) {
        var entry = _this.entry;
        _this.entry = null;
        while(entry){
            var cb = entry.callback;
            state.pendingcb--;
            cb(err);
            entry = entry.next;
        }
        if (state.corkedRequestsFree) state.corkedRequestsFree.next = _this;
        else state.corkedRequestsFree = _this;
    };
}
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$Duplex, $07144aea14354eb9$var$Readable);
var $07144aea14354eb9$var$keys = Object.keys($07144aea14354eb9$var$Writable.prototype);
for(var $07144aea14354eb9$var$v = 0; $07144aea14354eb9$var$v < $07144aea14354eb9$var$keys.length; $07144aea14354eb9$var$v++){
    var $07144aea14354eb9$var$method = $07144aea14354eb9$var$keys[$07144aea14354eb9$var$v];
    if (!$07144aea14354eb9$var$Duplex.prototype[$07144aea14354eb9$var$method]) $07144aea14354eb9$var$Duplex.prototype[$07144aea14354eb9$var$method] = $07144aea14354eb9$var$Writable.prototype[$07144aea14354eb9$var$method];
}
function $07144aea14354eb9$var$Duplex(options) {
    if (!(this instanceof $07144aea14354eb9$var$Duplex)) return new $07144aea14354eb9$var$Duplex(options);
    $07144aea14354eb9$var$Readable.call(this, options);
    $07144aea14354eb9$var$Writable.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once('end', $07144aea14354eb9$var$onend);
} // the no-half-open enforcer
function $07144aea14354eb9$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return; // no more data can be written.
    // But allow more writes to happen in this tick.
    $07144aea14354eb9$var$nextTick($07144aea14354eb9$var$onEndNT, this);
}
function $07144aea14354eb9$var$onEndNT(self1) {
    self1.end();
}
// a transform stream is a readable/writable stream where you do
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$Transform, $07144aea14354eb9$var$Duplex);
function $07144aea14354eb9$var$TransformState(stream) {
    this.afterTransform = function(er, data) {
        return $07144aea14354eb9$var$afterTransform(stream, er, data);
    };
    this.needTransform = false;
    this.transforming = false;
    this.writecb = null;
    this.writechunk = null;
    this.writeencoding = null;
}
function $07144aea14354eb9$var$afterTransform(stream, er, data) {
    var ts = stream._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return stream.emit('error', new Error('no writecb in Transform class'));
    ts.writechunk = null;
    ts.writecb = null;
    if (data !== null && data !== undefined) stream.push(data);
    cb(er);
    var rs = stream._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) stream._read(rs.highWaterMark);
}
function $07144aea14354eb9$var$Transform(options) {
    if (!(this instanceof $07144aea14354eb9$var$Transform)) return new $07144aea14354eb9$var$Transform(options);
    $07144aea14354eb9$var$Duplex.call(this, options);
    this._transformState = new $07144aea14354eb9$var$TransformState(this); // when the writable side finishes, then flush out anything remaining.
    var stream = this; // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true; // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === 'function') this._transform = options.transform;
        if (typeof options.flush === 'function') this._flush = options.flush;
    }
    this.once('prefinish', function() {
        if (typeof this._flush === 'function') this._flush(function(er) {
            $07144aea14354eb9$var$done(stream, er);
        });
        else $07144aea14354eb9$var$done(stream);
    });
}
$07144aea14354eb9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $07144aea14354eb9$var$Duplex.prototype.push.call(this, chunk, encoding);
}; // This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$07144aea14354eb9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error('Not implemented');
};
$07144aea14354eb9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
}; // Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$07144aea14354eb9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
function $07144aea14354eb9$var$done(stream, er) {
    if (er) return stream.emit('error', er); // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    var ws = stream._writableState;
    var ts = stream._transformState;
    if (ws.length) throw new Error('Calling transform done when ws.length != 0');
    if (ts.transforming) throw new Error('Calling transform done when still transforming');
    return stream.push(null);
}
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$PassThrough, $07144aea14354eb9$var$Transform);
function $07144aea14354eb9$var$PassThrough(options) {
    if (!(this instanceof $07144aea14354eb9$var$PassThrough)) return new $07144aea14354eb9$var$PassThrough(options);
    $07144aea14354eb9$var$Transform.call(this, options);
}
$07144aea14354eb9$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};
$07144aea14354eb9$var$inherits$1($07144aea14354eb9$var$Stream, $07144aea14354eb9$var$EventEmitter);
$07144aea14354eb9$var$Stream.Readable = $07144aea14354eb9$var$Readable;
$07144aea14354eb9$var$Stream.Writable = $07144aea14354eb9$var$Writable;
$07144aea14354eb9$var$Stream.Duplex = $07144aea14354eb9$var$Duplex;
$07144aea14354eb9$var$Stream.Transform = $07144aea14354eb9$var$Transform;
$07144aea14354eb9$var$Stream.PassThrough = $07144aea14354eb9$var$PassThrough; // Backwards-compat with node 0.4.x
$07144aea14354eb9$var$Stream.Stream = $07144aea14354eb9$var$Stream;
// part of this class) is overridden in the Readable class.
function $07144aea14354eb9$var$Stream() {
    $07144aea14354eb9$var$EventEmitter.call(this);
}
$07144aea14354eb9$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on('data', ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on('drain', ondrain); // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on('end', onend);
        source.on('close', onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === 'function') dest.destroy();
    } // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($07144aea14354eb9$var$EventEmitter.listenerCount(this, 'error') === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on('error', onerror);
    dest.on('error', onerror); // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener('data', ondata);
        dest.removeListener('drain', ondrain);
        source.removeListener('end', onend);
        source.removeListener('close', onclose);
        source.removeListener('error', onerror);
        dest.removeListener('error', onerror);
        source.removeListener('end', cleanup);
        source.removeListener('close', cleanup);
        dest.removeListener('close', cleanup);
    }
    source.on('end', cleanup);
    source.on('close', cleanup);
    dest.on('close', cleanup);
    dest.emit('pipe', source); // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};
var $07144aea14354eb9$var$Buffer = $07144aea14354eb9$var$buffer.Buffer;
var $07144aea14354eb9$var$safer = {};
var $07144aea14354eb9$var$key;
for($07144aea14354eb9$var$key in $07144aea14354eb9$var$buffer){
    if (!$07144aea14354eb9$var$buffer.hasOwnProperty($07144aea14354eb9$var$key)) continue;
    if ($07144aea14354eb9$var$key === 'SlowBuffer' || $07144aea14354eb9$var$key === 'Buffer') continue;
    $07144aea14354eb9$var$safer[$07144aea14354eb9$var$key] = $07144aea14354eb9$var$buffer[$07144aea14354eb9$var$key];
}
var $07144aea14354eb9$var$Safer = $07144aea14354eb9$var$safer.Buffer = {};
for($07144aea14354eb9$var$key in $07144aea14354eb9$var$Buffer){
    if (!$07144aea14354eb9$var$Buffer.hasOwnProperty($07144aea14354eb9$var$key)) continue;
    if ($07144aea14354eb9$var$key === 'allocUnsafe' || $07144aea14354eb9$var$key === 'allocUnsafeSlow') continue;
    $07144aea14354eb9$var$Safer[$07144aea14354eb9$var$key] = $07144aea14354eb9$var$Buffer[$07144aea14354eb9$var$key];
}
$07144aea14354eb9$var$safer.Buffer.prototype = $07144aea14354eb9$var$Buffer.prototype;
if (!$07144aea14354eb9$var$Safer.from || $07144aea14354eb9$var$Safer.from === Uint8Array.from) $07144aea14354eb9$var$Safer.from = function(value, encodingOrOffset, length) {
    if (typeof value === 'number') throw new TypeError('The "value" argument must not be of type number. Received type ' + typeof value);
    if (value && typeof value.length === 'undefined') throw new TypeError('The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type ' + typeof value);
    return $07144aea14354eb9$var$Buffer(value, encodingOrOffset, length);
};
if (!$07144aea14354eb9$var$Safer.alloc) $07144aea14354eb9$var$Safer.alloc = function(size, fill, encoding) {
    if (typeof size !== 'number') throw new TypeError('The "size" argument must be of type number. Received type ' + typeof size);
    if (size < 0 || size >= 2 * 1073741824) throw new RangeError('The value "' + size + '" is invalid for option "size"');
    var buf = $07144aea14354eb9$var$Buffer(size);
    if (!fill || fill.length === 0) buf.fill(0);
    else if (typeof encoding === 'string') buf.fill(fill, encoding);
    else buf.fill(fill);
    return buf;
};
if (!$07144aea14354eb9$var$safer.kStringMaxLength) try {
    $07144aea14354eb9$var$safer.kStringMaxLength = $07144aea14354eb9$var$process.binding('buffer').kStringMaxLength;
} catch (e) {
// is unsupported, so let's not set it
}
if (!$07144aea14354eb9$var$safer.constants) {
    $07144aea14354eb9$var$safer.constants = {
        MAX_LENGTH: $07144aea14354eb9$var$safer.kMaxLength
    };
    if ($07144aea14354eb9$var$safer.kStringMaxLength) $07144aea14354eb9$var$safer.constants.MAX_STRING_LENGTH = $07144aea14354eb9$var$safer.kStringMaxLength;
}
var $07144aea14354eb9$var$safer_1 = $07144aea14354eb9$var$safer;
var $07144aea14354eb9$var$BOMChar = "\uFEFF";
var $07144aea14354eb9$var$PrependBOM = $07144aea14354eb9$var$PrependBOMWrapper;
function $07144aea14354eb9$var$PrependBOMWrapper(encoder, options) {
    this.encoder = encoder;
    this.addBOM = true;
}
$07144aea14354eb9$var$PrependBOMWrapper.prototype.write = function(str) {
    if (this.addBOM) {
        str = $07144aea14354eb9$var$BOMChar + str;
        this.addBOM = false;
    }
    return this.encoder.write(str);
};
$07144aea14354eb9$var$PrependBOMWrapper.prototype.end = function() {
    return this.encoder.end();
}; //------------------------------------------------------------------------------
var $07144aea14354eb9$var$StripBOM = $07144aea14354eb9$var$StripBOMWrapper;
function $07144aea14354eb9$var$StripBOMWrapper(decoder, options) {
    this.decoder = decoder;
    this.pass = false;
    this.options = options || {};
}
$07144aea14354eb9$var$StripBOMWrapper.prototype.write = function(buf) {
    var res = this.decoder.write(buf);
    if (this.pass || !res) return res;
    if (res[0] === $07144aea14354eb9$var$BOMChar) {
        res = res.slice(1);
        if (typeof this.options.stripBOM === 'function') this.options.stripBOM();
    }
    this.pass = true;
    return res;
};
$07144aea14354eb9$var$StripBOMWrapper.prototype.end = function() {
    return this.decoder.end();
};
var $07144aea14354eb9$var$bomHandling = {
    PrependBOM: $07144aea14354eb9$var$PrependBOM,
    StripBOM: $07144aea14354eb9$var$StripBOM
};
var $07144aea14354eb9$var$Buffer$1 = $07144aea14354eb9$var$safer_1.Buffer; // Export Node.js internal encodings.
var $07144aea14354eb9$var$internal = {
    // Encodings
    utf8: {
        type: "_internal",
        bomAware: true
    },
    cesu8: {
        type: "_internal",
        bomAware: true
    },
    unicode11utf8: "utf8",
    ucs2: {
        type: "_internal",
        bomAware: true
    },
    utf16le: "ucs2",
    binary: {
        type: "_internal"
    },
    base64: {
        type: "_internal"
    },
    hex: {
        type: "_internal"
    },
    // Codec.
    _internal: $07144aea14354eb9$var$InternalCodec
}; //------------------------------------------------------------------------------
function $07144aea14354eb9$var$InternalCodec(codecOptions, iconv) {
    this.enc = codecOptions.encodingName;
    this.bomAware = codecOptions.bomAware;
    if (this.enc === "base64") this.encoder = $07144aea14354eb9$var$InternalEncoderBase64;
    else if (this.enc === "cesu8") {
        this.enc = "utf8"; // Use utf8 for decoding.
        this.encoder = $07144aea14354eb9$var$InternalEncoderCesu8; // Add decoder for versions of Node not supporting CESU-8
        if ($07144aea14354eb9$var$Buffer$1.from('eda0bdedb2a9', 'hex').toString() !== "\uD83D\uDCA9") {
            this.decoder = $07144aea14354eb9$var$InternalDecoderCesu8;
            this.defaultCharUnicode = iconv.defaultCharUnicode;
        }
    }
}
$07144aea14354eb9$var$InternalCodec.prototype.encoder = $07144aea14354eb9$var$InternalEncoder;
$07144aea14354eb9$var$InternalCodec.prototype.decoder = $07144aea14354eb9$var$InternalDecoder; //------------------------------------------------------------------------------
// We use node.js internal decoder. Its signature is the same as ours.
var $07144aea14354eb9$var$StringDecoder = $07144aea14354eb9$var$string_decoder.StringDecoder;
if (!$07144aea14354eb9$var$StringDecoder.prototype.end) $07144aea14354eb9$var$StringDecoder.prototype.end = function() {};
function $07144aea14354eb9$var$InternalDecoder(options, codec) {
    $07144aea14354eb9$var$StringDecoder.call(this, codec.enc);
}
$07144aea14354eb9$var$InternalDecoder.prototype = $07144aea14354eb9$var$StringDecoder.prototype; //------------------------------------------------------------------------------
// Encoder is mostly trivial
function $07144aea14354eb9$var$InternalEncoder(options, codec) {
    this.enc = codec.enc;
}
$07144aea14354eb9$var$InternalEncoder.prototype.write = function(str) {
    return $07144aea14354eb9$var$Buffer$1.from(str, this.enc);
};
$07144aea14354eb9$var$InternalEncoder.prototype.end = function() {}; //------------------------------------------------------------------------------
// Except base64 encoder, which must keep its state.
function $07144aea14354eb9$var$InternalEncoderBase64(options, codec) {
    this.prevStr = '';
}
$07144aea14354eb9$var$InternalEncoderBase64.prototype.write = function(str) {
    str = this.prevStr + str;
    var completeQuads = str.length - str.length % 4;
    this.prevStr = str.slice(completeQuads);
    str = str.slice(0, completeQuads);
    return $07144aea14354eb9$var$Buffer$1.from(str, "base64");
};
$07144aea14354eb9$var$InternalEncoderBase64.prototype.end = function() {
    return $07144aea14354eb9$var$Buffer$1.from(this.prevStr, "base64");
}; //------------------------------------------------------------------------------
// CESU-8 encoder is also special.
function $07144aea14354eb9$var$InternalEncoderCesu8(options, codec) {}
$07144aea14354eb9$var$InternalEncoderCesu8.prototype.write = function(str) {
    var buf = $07144aea14354eb9$var$Buffer$1.alloc(str.length * 3), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var charCode = str.charCodeAt(i); // Naive implementation, but it works because CESU-8 is especially easy
        // to convert from UTF-16 (which all JS strings are encoded in).
        if (charCode < 0x80) buf[bufIdx++] = charCode;
        else if (charCode < 0x800) {
            buf[bufIdx++] = 0xC0 + (charCode >>> 6);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        } else {
            // charCode will always be < 0x10000 in javascript.
            buf[bufIdx++] = 0xE0 + (charCode >>> 12);
            buf[bufIdx++] = 0x80 + (charCode >>> 6 & 0x3f);
            buf[bufIdx++] = 0x80 + (charCode & 0x3f);
        }
    }
    return buf.slice(0, bufIdx);
};
$07144aea14354eb9$var$InternalEncoderCesu8.prototype.end = function() {}; //------------------------------------------------------------------------------
// CESU-8 decoder is not implemented in Node v4.0+
function $07144aea14354eb9$var$InternalDecoderCesu8(options, codec) {
    this.acc = 0;
    this.contBytes = 0;
    this.accBytes = 0;
    this.defaultCharUnicode = codec.defaultCharUnicode;
}
$07144aea14354eb9$var$InternalDecoderCesu8.prototype.write = function(buf) {
    var acc = this.acc, contBytes = this.contBytes, accBytes = this.accBytes, res = '';
    for(var i = 0; i < buf.length; i++){
        var curByte = buf[i];
        if ((curByte & 0xC0) !== 0x80) {
            // Leading byte
            if (contBytes > 0) {
                // Previous code is invalid
                res += this.defaultCharUnicode;
                contBytes = 0;
            }
            if (curByte < 0x80) // Single-byte code
            res += String.fromCharCode(curByte);
            else if (curByte < 0xE0) {
                // Two-byte code
                acc = curByte & 0x1F;
                contBytes = 1;
                accBytes = 1;
            } else if (curByte < 0xF0) {
                // Three-byte code
                acc = curByte & 0x0F;
                contBytes = 2;
                accBytes = 1;
            } else // Four or more are not supported for CESU-8.
            res += this.defaultCharUnicode;
        } else // Continuation byte
        if (contBytes > 0) {
            // We're waiting for it.
            acc = acc << 6 | curByte & 0x3f;
            contBytes--;
            accBytes++;
            if (contBytes === 0) {
                // Check for overlong encoding, but support Modified UTF-8 (encoding NULL as C0 80)
                if (accBytes === 2 && acc < 0x80 && acc > 0) res += this.defaultCharUnicode;
                else if (accBytes === 3 && acc < 0x800) res += this.defaultCharUnicode;
                else res += String.fromCharCode(acc);
            }
        } else // Unexpected continuation byte
        res += this.defaultCharUnicode;
    }
    this.acc = acc;
    this.contBytes = contBytes;
    this.accBytes = accBytes;
    return res;
};
$07144aea14354eb9$var$InternalDecoderCesu8.prototype.end = function() {
    var res = 0;
    if (this.contBytes > 0) res += this.defaultCharUnicode;
    return res;
};
var $07144aea14354eb9$var$Buffer$2 = $07144aea14354eb9$var$safer_1.Buffer; // Note: UTF16-LE (or UCS2) codec is Node.js native. See encodings/internal.js
// == UTF16-BE codec. ==========================================================
var $07144aea14354eb9$var$utf16be = $07144aea14354eb9$var$Utf16BECodec;
function $07144aea14354eb9$var$Utf16BECodec() {}
$07144aea14354eb9$var$Utf16BECodec.prototype.encoder = $07144aea14354eb9$var$Utf16BEEncoder;
$07144aea14354eb9$var$Utf16BECodec.prototype.decoder = $07144aea14354eb9$var$Utf16BEDecoder;
$07144aea14354eb9$var$Utf16BECodec.prototype.bomAware = true; // -- Encoding
function $07144aea14354eb9$var$Utf16BEEncoder() {}
$07144aea14354eb9$var$Utf16BEEncoder.prototype.write = function(str) {
    var buf = $07144aea14354eb9$var$Buffer$2.from(str, 'ucs2');
    for(var i = 0; i < buf.length; i += 2){
        var tmp = buf[i];
        buf[i] = buf[i + 1];
        buf[i + 1] = tmp;
    }
    return buf;
};
$07144aea14354eb9$var$Utf16BEEncoder.prototype.end = function() {}; // -- Decoding
function $07144aea14354eb9$var$Utf16BEDecoder() {
    this.overflowByte = -1;
}
$07144aea14354eb9$var$Utf16BEDecoder.prototype.write = function(buf) {
    if (buf.length == 0) return '';
    var buf2 = $07144aea14354eb9$var$Buffer$2.alloc(buf.length + 1), i = 0, j = 0;
    if (this.overflowByte !== -1) {
        buf2[0] = buf[0];
        buf2[1] = this.overflowByte;
        i = 1;
        j = 2;
    }
    for(; i < buf.length - 1; i += 2, j += 2){
        buf2[j] = buf[i + 1];
        buf2[j + 1] = buf[i];
    }
    this.overflowByte = i == buf.length - 1 ? buf[buf.length - 1] : -1;
    return buf2.slice(0, j).toString('ucs2');
};
$07144aea14354eb9$var$Utf16BEDecoder.prototype.end = function() {}; // == UTF-16 codec =============================================================
// Decoder chooses automatically from UTF-16LE and UTF-16BE using BOM and space-based heuristic.
// Defaults to UTF-16LE, as it's prevalent and default in Node.
// http://en.wikipedia.org/wiki/UTF-16 and http://encoding.spec.whatwg.org/#utf-16le
// Decoder default can be changed: iconv.decode(buf, 'utf16', {defaultEncoding: 'utf-16be'});
// Encoder uses UTF-16LE and prepends BOM (which can be overridden with addBOM: false).
var $07144aea14354eb9$var$utf16_1 = $07144aea14354eb9$var$Utf16Codec;
function $07144aea14354eb9$var$Utf16Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$07144aea14354eb9$var$Utf16Codec.prototype.encoder = $07144aea14354eb9$var$Utf16Encoder;
$07144aea14354eb9$var$Utf16Codec.prototype.decoder = $07144aea14354eb9$var$Utf16Decoder; // -- Encoding (pass-through)
function $07144aea14354eb9$var$Utf16Encoder(options, codec) {
    options = options || {};
    if (options.addBOM === undefined) options.addBOM = true;
    this.encoder = codec.iconv.getEncoder('utf-16le', options);
}
$07144aea14354eb9$var$Utf16Encoder.prototype.write = function(str) {
    return this.encoder.write(str);
};
$07144aea14354eb9$var$Utf16Encoder.prototype.end = function() {
    return this.encoder.end();
}; // -- Decoding
function $07144aea14354eb9$var$Utf16Decoder(options, codec) {
    this.decoder = null;
    this.initialBytes = [];
    this.initialBytesLen = 0;
    this.options = options || {};
    this.iconv = codec.iconv;
}
$07144aea14354eb9$var$Utf16Decoder.prototype.write = function(buf) {
    if (!this.decoder) {
        // Codec is not chosen yet. Accumulate initial bytes.
        this.initialBytes.push(buf);
        this.initialBytesLen += buf.length;
        if (this.initialBytesLen < 16) return ''; // We have enough bytes -> detect endianness.
        var buf = $07144aea14354eb9$var$Buffer$2.concat(this.initialBytes), encoding = $07144aea14354eb9$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        this.initialBytes.length = this.initialBytesLen = 0;
    }
    return this.decoder.write(buf);
};
$07144aea14354eb9$var$Utf16Decoder.prototype.end = function() {
    if (!this.decoder) {
        var buf = $07144aea14354eb9$var$Buffer$2.concat(this.initialBytes), encoding = $07144aea14354eb9$var$detectEncoding(buf, this.options.defaultEncoding);
        this.decoder = this.iconv.getDecoder(encoding, this.options);
        var res = this.decoder.write(buf), trail = this.decoder.end();
        return trail ? res + trail : res;
    }
    return this.decoder.end();
};
function $07144aea14354eb9$var$detectEncoding(buf, defaultEncoding) {
    var enc = defaultEncoding || 'utf-16le';
    if (buf.length >= 2) {
        // Check BOM.
        if (buf[0] == 0xFE && buf[1] == 0xFF) enc = 'utf-16be';
        else if (buf[0] == 0xFF && buf[1] == 0xFE) enc = 'utf-16le';
        else {
            // No BOM found. Try to deduce encoding from initial content.
            // Most of the time, the content has ASCII chars (U+00**), but the opposite (U+**00) is uncommon.
            // So, we count ASCII as if it was LE or BE, and decide from that.
            var asciiCharsLE = 0, asciiCharsBE = 0, // Counts of chars in both positions
            _len = Math.min(buf.length - buf.length % 2, 64); // Len is always even.
            for(var i = 0; i < _len; i += 2){
                if (buf[i] === 0 && buf[i + 1] !== 0) asciiCharsBE++;
                if (buf[i] !== 0 && buf[i + 1] === 0) asciiCharsLE++;
            }
            if (asciiCharsBE > asciiCharsLE) enc = 'utf-16be';
            else if (asciiCharsBE < asciiCharsLE) enc = 'utf-16le';
        }
    }
    return enc;
}
var $07144aea14354eb9$var$utf16 = {
    utf16be: $07144aea14354eb9$var$utf16be,
    utf16: $07144aea14354eb9$var$utf16_1
};
var $07144aea14354eb9$var$Buffer$3 = $07144aea14354eb9$var$safer_1.Buffer; // UTF-7 codec, according to https://tools.ietf.org/html/rfc2152
// See also below a UTF-7-IMAP codec, according to http://tools.ietf.org/html/rfc3501#section-5.1.3
var $07144aea14354eb9$var$utf7_1 = $07144aea14354eb9$var$Utf7Codec;
var $07144aea14354eb9$var$unicode11utf7 = 'utf7'; // Alias UNICODE-1-1-UTF-7
function $07144aea14354eb9$var$Utf7Codec(codecOptions, iconv) {
    this.iconv = iconv;
}
$07144aea14354eb9$var$Utf7Codec.prototype.encoder = $07144aea14354eb9$var$Utf7Encoder;
$07144aea14354eb9$var$Utf7Codec.prototype.decoder = $07144aea14354eb9$var$Utf7Decoder;
$07144aea14354eb9$var$Utf7Codec.prototype.bomAware = true; // -- Encoding
var $07144aea14354eb9$var$nonDirectChars = /[^A-Za-z0-9'\(\),-\.\/:\? \n\r\t]+/g;
function $07144aea14354eb9$var$Utf7Encoder(options, codec) {
    this.iconv = codec.iconv;
}
$07144aea14354eb9$var$Utf7Encoder.prototype.write = function(str) {
    // Naive implementation.
    // Non-direct chars are encoded as "+<base64>-"; single "+" char is encoded as "+-".
    return $07144aea14354eb9$var$Buffer$3.from(str.replace($07144aea14354eb9$var$nonDirectChars, (function(chunk) {
        return "+" + (chunk === '+' ? '' : this.iconv.encode(chunk, 'utf16-be').toString('base64').replace(/=+$/, '')) + "-";
    }).bind(this)));
};
$07144aea14354eb9$var$Utf7Encoder.prototype.end = function() {}; // -- Decoding
function $07144aea14354eb9$var$Utf7Decoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $07144aea14354eb9$var$base64Regex = /[A-Za-z0-9\/+]/;
var $07144aea14354eb9$var$base64Chars = [];
for(var $07144aea14354eb9$var$i$1 = 0; $07144aea14354eb9$var$i$1 < 256; $07144aea14354eb9$var$i$1++)$07144aea14354eb9$var$base64Chars[$07144aea14354eb9$var$i$1] = $07144aea14354eb9$var$base64Regex.test(String.fromCharCode($07144aea14354eb9$var$i$1));
var $07144aea14354eb9$var$plusChar = '+'.charCodeAt(0), $07144aea14354eb9$var$minusChar = '-'.charCodeAt(0), $07144aea14354eb9$var$andChar = '&'.charCodeAt(0);
$07144aea14354eb9$var$Utf7Decoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum; // The decoder is more involved as we must handle chunks in stream.
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // We're in direct mode.
        // Write direct chars until '+'
        {
            if (buf[i] == $07144aea14354eb9$var$plusChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else // We decode base64.
        if (!$07144aea14354eb9$var$base64Chars[buf[i]]) {
            // Base64 ended.
            if (i == lastI && buf[i] == $07144aea14354eb9$var$minusChar) // "+-" -> "+"
            res += "+";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString();
                res += this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $07144aea14354eb9$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString();
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$07144aea14354eb9$var$Utf7Decoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
}; // UTF-7-IMAP codec.
// RFC3501 Sec. 5.1.3 Modified UTF-7 (http://tools.ietf.org/html/rfc3501#section-5.1.3)
// Differences:
//  * Base64 part is started by "&" instead of "+"
//  * Direct characters are 0x20-0x7E, except "&" (0x26)
//  * In Base64, "," is used instead of "/"
//  * Base64 must not be used to represent direct characters.
//  * No implicit shift back from Base64 (should always end with '-')
//  * String must end in non-shifted position.
//  * "-&" while in base64 is not allowed.
var $07144aea14354eb9$var$utf7imap = $07144aea14354eb9$var$Utf7IMAPCodec;
function $07144aea14354eb9$var$Utf7IMAPCodec(codecOptions, iconv) {
    this.iconv = iconv;
}
$07144aea14354eb9$var$Utf7IMAPCodec.prototype.encoder = $07144aea14354eb9$var$Utf7IMAPEncoder;
$07144aea14354eb9$var$Utf7IMAPCodec.prototype.decoder = $07144aea14354eb9$var$Utf7IMAPDecoder;
$07144aea14354eb9$var$Utf7IMAPCodec.prototype.bomAware = true; // -- Encoding
function $07144aea14354eb9$var$Utf7IMAPEncoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = $07144aea14354eb9$var$Buffer$3.alloc(6);
    this.base64AccumIdx = 0;
}
$07144aea14354eb9$var$Utf7IMAPEncoder.prototype.write = function(str) {
    var inBase64 = this.inBase64, base64Accum = this.base64Accum, base64AccumIdx = this.base64AccumIdx, buf = $07144aea14354eb9$var$Buffer$3.alloc(str.length * 5 + 10), bufIdx = 0;
    for(var i = 0; i < str.length; i++){
        var uChar = str.charCodeAt(i);
        if (0x20 <= uChar && uChar <= 0x7E) {
            // Direct character or '&'.
            if (inBase64) {
                if (base64AccumIdx > 0) {
                    bufIdx += buf.write(base64Accum.slice(0, base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
                    base64AccumIdx = 0;
                }
                buf[bufIdx++] = $07144aea14354eb9$var$minusChar; // Write '-', then go to direct mode.
                inBase64 = false;
            }
            if (!inBase64) {
                buf[bufIdx++] = uChar; // Write direct character
                if (uChar === $07144aea14354eb9$var$andChar) buf[bufIdx++] = $07144aea14354eb9$var$minusChar;
            }
        } else {
            // Non-direct character
            if (!inBase64) {
                buf[bufIdx++] = $07144aea14354eb9$var$andChar; // Write '&', then go to base64 mode.
                inBase64 = true;
            }
            if (inBase64) {
                base64Accum[base64AccumIdx++] = uChar >> 8;
                base64Accum[base64AccumIdx++] = uChar & 0xFF;
                if (base64AccumIdx == base64Accum.length) {
                    bufIdx += buf.write(base64Accum.toString('base64').replace(/\//g, ','), bufIdx);
                    base64AccumIdx = 0;
                }
            }
        }
    }
    this.inBase64 = inBase64;
    this.base64AccumIdx = base64AccumIdx;
    return buf.slice(0, bufIdx);
};
$07144aea14354eb9$var$Utf7IMAPEncoder.prototype.end = function() {
    var buf = $07144aea14354eb9$var$Buffer$3.alloc(10), bufIdx = 0;
    if (this.inBase64) {
        if (this.base64AccumIdx > 0) {
            bufIdx += buf.write(this.base64Accum.slice(0, this.base64AccumIdx).toString('base64').replace(/\//g, ',').replace(/=+$/, ''), bufIdx);
            this.base64AccumIdx = 0;
        }
        buf[bufIdx++] = $07144aea14354eb9$var$minusChar; // Write '-', then go to direct mode.
        this.inBase64 = false;
    }
    return buf.slice(0, bufIdx);
}; // -- Decoding
function $07144aea14354eb9$var$Utf7IMAPDecoder(options, codec) {
    this.iconv = codec.iconv;
    this.inBase64 = false;
    this.base64Accum = '';
}
var $07144aea14354eb9$var$base64IMAPChars = $07144aea14354eb9$var$base64Chars.slice();
$07144aea14354eb9$var$base64IMAPChars[','.charCodeAt(0)] = true;
$07144aea14354eb9$var$Utf7IMAPDecoder.prototype.write = function(buf) {
    var res = "", lastI = 0, inBase64 = this.inBase64, base64Accum = this.base64Accum; // The decoder is more involved as we must handle chunks in stream.
    // It is forgiving, closer to standard UTF-7 (for example, '-' is optional at the end).
    for(var i = 0; i < buf.length; i++){
        if (!inBase64) // We're in direct mode.
        // Write direct chars until '&'
        {
            if (buf[i] == $07144aea14354eb9$var$andChar) {
                res += this.iconv.decode(buf.slice(lastI, i), "ascii"); // Write direct chars.
                lastI = i + 1;
                inBase64 = true;
            }
        } else // We decode base64.
        if (!$07144aea14354eb9$var$base64IMAPChars[buf[i]]) {
            // Base64 ended.
            if (i == lastI && buf[i] == $07144aea14354eb9$var$minusChar) // "&-" -> "&"
            res += "&";
            else {
                var b64str = base64Accum + buf.slice(lastI, i).toString().replace(/,/g, '/');
                res += this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
            }
            if (buf[i] != $07144aea14354eb9$var$minusChar) i--;
            lastI = i + 1;
            inBase64 = false;
            base64Accum = '';
        }
    }
    if (!inBase64) res += this.iconv.decode(buf.slice(lastI), "ascii"); // Write direct chars.
    else {
        var b64str = base64Accum + buf.slice(lastI).toString().replace(/,/g, '/');
        var canBeDecoded = b64str.length - b64str.length % 8; // Minimal chunk: 2 quads -> 2x3 bytes -> 3 chars.
        base64Accum = b64str.slice(canBeDecoded); // The rest will be decoded in future.
        b64str = b64str.slice(0, canBeDecoded);
        res += this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(b64str, 'base64'), "utf16-be");
    }
    this.inBase64 = inBase64;
    this.base64Accum = base64Accum;
    return res;
};
$07144aea14354eb9$var$Utf7IMAPDecoder.prototype.end = function() {
    var res = "";
    if (this.inBase64 && this.base64Accum.length > 0) res = this.iconv.decode($07144aea14354eb9$var$Buffer$3.from(this.base64Accum, 'base64'), "utf16-be");
    this.inBase64 = false;
    this.base64Accum = '';
    return res;
};
var $07144aea14354eb9$var$utf7 = {
    utf7: $07144aea14354eb9$var$utf7_1,
    unicode11utf7: $07144aea14354eb9$var$unicode11utf7,
    utf7imap: $07144aea14354eb9$var$utf7imap
};
var $07144aea14354eb9$var$Buffer$4 = $07144aea14354eb9$var$safer_1.Buffer; // Single-byte codec. Needs a 'chars' string parameter that contains 256 or 128 chars that
// correspond to encoded bytes (if 128 - then lower half is ASCII). 
var $07144aea14354eb9$var$_sbcs = $07144aea14354eb9$var$SBCSCodec;
function $07144aea14354eb9$var$SBCSCodec(codecOptions, iconv) {
    if (!codecOptions) throw new Error("SBCS codec is called without the data."); // Prepare char buffer for decoding.
    if (!codecOptions.chars || codecOptions.chars.length !== 128 && codecOptions.chars.length !== 256) throw new Error("Encoding '" + codecOptions.type + "' has incorrect 'chars' (must be of len 128 or 256)");
    if (codecOptions.chars.length === 128) {
        var asciiString = "";
        for(var i = 0; i < 128; i++)asciiString += String.fromCharCode(i);
        codecOptions.chars = asciiString + codecOptions.chars;
    }
    this.decodeBuf = $07144aea14354eb9$var$Buffer$4.from(codecOptions.chars, 'ucs2'); // Encoding buffer.
    var encodeBuf = $07144aea14354eb9$var$Buffer$4.alloc(65536, iconv.defaultCharSingleByte.charCodeAt(0));
    for(var i = 0; i < codecOptions.chars.length; i++)encodeBuf[codecOptions.chars.charCodeAt(i)] = i;
    this.encodeBuf = encodeBuf;
}
$07144aea14354eb9$var$SBCSCodec.prototype.encoder = $07144aea14354eb9$var$SBCSEncoder;
$07144aea14354eb9$var$SBCSCodec.prototype.decoder = $07144aea14354eb9$var$SBCSDecoder;
function $07144aea14354eb9$var$SBCSEncoder(options, codec) {
    this.encodeBuf = codec.encodeBuf;
}
$07144aea14354eb9$var$SBCSEncoder.prototype.write = function(str) {
    var buf = $07144aea14354eb9$var$Buffer$4.alloc(str.length);
    for(var i = 0; i < str.length; i++)buf[i] = this.encodeBuf[str.charCodeAt(i)];
    return buf;
};
$07144aea14354eb9$var$SBCSEncoder.prototype.end = function() {};
function $07144aea14354eb9$var$SBCSDecoder(options, codec) {
    this.decodeBuf = codec.decodeBuf;
}
$07144aea14354eb9$var$SBCSDecoder.prototype.write = function(buf) {
    // Strings are immutable in JS -> we use ucs2 buffer to speed up computations.
    var decodeBuf = this.decodeBuf;
    var newBuf = $07144aea14354eb9$var$Buffer$4.alloc(buf.length * 2);
    var idx1 = 0, idx2 = 0;
    for(var i = 0; i < buf.length; i++){
        idx1 = buf[i] * 2;
        idx2 = i * 2;
        newBuf[idx2] = decodeBuf[idx1];
        newBuf[idx2 + 1] = decodeBuf[idx1 + 1];
    }
    return newBuf.toString('ucs2');
};
$07144aea14354eb9$var$SBCSDecoder.prototype.end = function() {};
var $07144aea14354eb9$var$sbcsCodec = {
    _sbcs: $07144aea14354eb9$var$_sbcs
};
var $07144aea14354eb9$var$sbcsData = {
    // Not supported by iconv, not sure why.
    "10029": "maccenteuro",
    "maccenteuro": {
        "type": "_sbcs",
        "chars": "\xc4\u0100\u0101\xc9\u0104\xd6\xdc\xe1\u0105\u010C\xe4\u010D\u0106\u0107\xe9\u0179\u017A\u010E\xed\u010F\u0112\u0113\u0116\xf3\u0117\xf4\xf6\xf5\xfa\u011A\u011B\xfc\u2020\xb0\u0118\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\u0119\xa8\u2260\u0123\u012E\u012F\u012A\u2264\u2265\u012B\u0136\u2202\u2211\u0142\u013B\u013C\u013D\u013E\u0139\u013A\u0145\u0146\u0143\xac\u221A\u0144\u0147\u2206\xab\xbb\u2026\xa0\u0148\u0150\xd5\u0151\u014C\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\u014D\u0154\u0155\u0158\u2039\u203A\u0159\u0156\u0157\u0160\u201A\u201E\u0161\u015A\u015B\xc1\u0164\u0165\xcd\u017D\u017E\u016A\xd3\xd4\u016B\u016E\xda\u016F\u0170\u0171\u0172\u0173\xdd\xfd\u0137\u017B\u0141\u017C\u0122\u02C7"
    },
    "808": "cp808",
    "ibm808": "cp808",
    "cp808": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\u20AC\u25A0\xa0"
    },
    "mik": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2514\u2534\u252C\u251C\u2500\u253C\u2563\u2551\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2510\u2591\u2592\u2593\u2502\u2524\u2116\xa7\u2557\u255D\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    // Aliases of generated encodings.
    "ascii8bit": "ascii",
    "usascii": "ascii",
    "ansix34": "ascii",
    "ansix341968": "ascii",
    "ansix341986": "ascii",
    "csascii": "ascii",
    "cp367": "ascii",
    "ibm367": "ascii",
    "isoir6": "ascii",
    "iso646us": "ascii",
    "iso646irv": "ascii",
    "us": "ascii",
    "latin1": "iso88591",
    "latin2": "iso88592",
    "latin3": "iso88593",
    "latin4": "iso88594",
    "latin5": "iso88599",
    "latin6": "iso885910",
    "latin7": "iso885913",
    "latin8": "iso885914",
    "latin9": "iso885915",
    "latin10": "iso885916",
    "csisolatin1": "iso88591",
    "csisolatin2": "iso88592",
    "csisolatin3": "iso88593",
    "csisolatin4": "iso88594",
    "csisolatincyrillic": "iso88595",
    "csisolatinarabic": "iso88596",
    "csisolatingreek": "iso88597",
    "csisolatinhebrew": "iso88598",
    "csisolatin5": "iso88599",
    "csisolatin6": "iso885910",
    "l1": "iso88591",
    "l2": "iso88592",
    "l3": "iso88593",
    "l4": "iso88594",
    "l5": "iso88599",
    "l6": "iso885910",
    "l7": "iso885913",
    "l8": "iso885914",
    "l9": "iso885915",
    "l10": "iso885916",
    "isoir14": "iso646jp",
    "isoir57": "iso646cn",
    "isoir100": "iso88591",
    "isoir101": "iso88592",
    "isoir109": "iso88593",
    "isoir110": "iso88594",
    "isoir144": "iso88595",
    "isoir127": "iso88596",
    "isoir126": "iso88597",
    "isoir138": "iso88598",
    "isoir148": "iso88599",
    "isoir157": "iso885910",
    "isoir166": "tis620",
    "isoir179": "iso885913",
    "isoir199": "iso885914",
    "isoir203": "iso885915",
    "isoir226": "iso885916",
    "cp819": "iso88591",
    "ibm819": "iso88591",
    "cyrillic": "iso88595",
    "arabic": "iso88596",
    "arabic8": "iso88596",
    "ecma114": "iso88596",
    "asmo708": "iso88596",
    "greek": "iso88597",
    "greek8": "iso88597",
    "ecma118": "iso88597",
    "elot928": "iso88597",
    "hebrew": "iso88598",
    "hebrew8": "iso88598",
    "turkish": "iso88599",
    "turkish8": "iso88599",
    "thai": "iso885911",
    "thai8": "iso885911",
    "celtic": "iso885914",
    "celtic8": "iso885914",
    "isoceltic": "iso885914",
    "tis6200": "tis620",
    "tis62025291": "tis620",
    "tis62025330": "tis620",
    "10000": "macroman",
    "10006": "macgreek",
    "10007": "maccyrillic",
    "10079": "maciceland",
    "10081": "macturkish",
    "cspc8codepage437": "cp437",
    "cspc775baltic": "cp775",
    "cspc850multilingual": "cp850",
    "cspcp852": "cp852",
    "cspc862latinhebrew": "cp862",
    "cpgr": "cp869",
    "msee": "cp1250",
    "mscyrl": "cp1251",
    "msansi": "cp1252",
    "msgreek": "cp1253",
    "msturk": "cp1254",
    "mshebr": "cp1255",
    "msarab": "cp1256",
    "winbaltrim": "cp1257",
    "cp20866": "koi8r",
    "20866": "koi8r",
    "ibm878": "koi8r",
    "cskoi8r": "koi8r",
    "cp21866": "koi8u",
    "21866": "koi8u",
    "ibm1168": "koi8u",
    "strk10482002": "rk1048",
    "tcvn5712": "tcvn",
    "tcvn57121": "tcvn",
    "gb198880": "iso646cn",
    "cn": "iso646cn",
    "csiso14jisc6220ro": "iso646jp",
    "jisc62201969ro": "iso646jp",
    "jp": "iso646jp",
    "cshproman8": "hproman8",
    "r8": "hproman8",
    "roman8": "hproman8",
    "xroman8": "hproman8",
    "ibm1051": "hproman8",
    "mac": "macintosh",
    "csmacintosh": "macintosh"
};
var $07144aea14354eb9$var$sbcsDataGenerated = {
    "437": "cp437",
    "737": "cp737",
    "775": "cp775",
    "850": "cp850",
    "852": "cp852",
    "855": "cp855",
    "856": "cp856",
    "857": "cp857",
    "858": "cp858",
    "860": "cp860",
    "861": "cp861",
    "862": "cp862",
    "863": "cp863",
    "864": "cp864",
    "865": "cp865",
    "866": "cp866",
    "869": "cp869",
    "874": "windows874",
    "922": "cp922",
    "1046": "cp1046",
    "1124": "cp1124",
    "1125": "cp1125",
    "1129": "cp1129",
    "1133": "cp1133",
    "1161": "cp1161",
    "1162": "cp1162",
    "1163": "cp1163",
    "1250": "windows1250",
    "1251": "windows1251",
    "1252": "windows1252",
    "1253": "windows1253",
    "1254": "windows1254",
    "1255": "windows1255",
    "1256": "windows1256",
    "1257": "windows1257",
    "1258": "windows1258",
    "28591": "iso88591",
    "28592": "iso88592",
    "28593": "iso88593",
    "28594": "iso88594",
    "28595": "iso88595",
    "28596": "iso88596",
    "28597": "iso88597",
    "28598": "iso88598",
    "28599": "iso88599",
    "28600": "iso885910",
    "28601": "iso885911",
    "28603": "iso885913",
    "28604": "iso885914",
    "28605": "iso885915",
    "28606": "iso885916",
    "windows874": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\uFFFD\uFFFD\uFFFD\u2026\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "win874": "windows874",
    "cp874": "windows874",
    "windows1250": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\u0160\u2039\u015A\u0164\u017D\u0179\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0161\u203A\u015B\u0165\u017E\u017A\xa0\u02C7\u02D8\u0141\xa4\u0104\xa6\xa7\xa8\xa9\u015E\xab\xac\xad\xae\u017B\xb0\xb1\u02DB\u0142\xb4\xb5\xb6\xb7\xb8\u0105\u015F\xbb\u013D\u02DD\u013E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "win1250": "windows1250",
    "cp1250": "windows1250",
    "windows1251": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u040C\u040B\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u045C\u045B\u045F\xa0\u040E\u045E\u0408\xa4\u0490\xa6\xa7\u0401\xa9\u0404\xab\xac\xad\xae\u0407\xb0\xb1\u0406\u0456\u0491\xb5\xb6\xb7\u0451\u2116\u0454\xbb\u0458\u0405\u0455\u0457\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "win1251": "windows1251",
    "cp1251": "windows1251",
    "windows1252": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\u017D\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\u017E\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "win1252": "windows1252",
    "cp1252": "windows1252",
    "windows1253": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\u0385\u0386\xa3\xa4\xa5\xa6\xa7\xa8\xa9\uFFFD\xab\xac\xad\xae\u2015\xb0\xb1\xb2\xb3\u0384\xb5\xb6\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "win1253": "windows1253",
    "cp1253": "windows1253",
    "windows1254": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "win1254": "windows1254",
    "cp1254": "windows1254",
    "windows1255": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\xa0\xa1\xa2\xa3\u20AA\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\xbf\u05B0\u05B1\u05B2\u05B3\u05B4\u05B5\u05B6\u05B7\u05B8\u05B9\u05BA\u05BB\u05BC\u05BD\u05BE\u05BF\u05C0\u05C1\u05C2\u05C3\u05F0\u05F1\u05F2\u05F3\u05F4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "win1255": "windows1255",
    "cp1255": "windows1255",
    "windows1256": {
        "type": "_sbcs",
        "chars": "\u20AC\u067E\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0679\u2039\u0152\u0686\u0698\u0688\u06AF\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u06A9\u2122\u0691\u203A\u0153\u200C\u200D\u06BA\xa0\u060C\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\u06BE\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\u061B\xbb\xbc\xbd\xbe\u061F\u06C1\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\xd7\u0637\u0638\u0639\u063A\u0640\u0641\u0642\u0643\xe0\u0644\xe2\u0645\u0646\u0647\u0648\xe7\xe8\xe9\xea\xeb\u0649\u064A\xee\xef\u064B\u064C\u064D\u064E\xf4\u064F\u0650\xf7\u0651\xf9\u0652\xfb\xfc\u200E\u200F\u06D2"
    },
    "win1256": "windows1256",
    "cp1256": "windows1256",
    "windows1257": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\uFFFD\u201E\u2026\u2020\u2021\uFFFD\u2030\uFFFD\u2039\uFFFD\xa8\u02C7\xb8\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\xaf\u02DB\uFFFD\xa0\uFFFD\xa2\xa3\xa4\uFFFD\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u02D9"
    },
    "win1257": "windows1257",
    "cp1257": "windows1257",
    "windows1258": {
        "type": "_sbcs",
        "chars": "\u20AC\uFFFD\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\uFFFD\u2039\u0152\uFFFD\uFFFD\uFFFD\uFFFD\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\uFFFD\u203A\u0153\uFFFD\uFFFD\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "win1258": "windows1258",
    "cp1258": "windows1258",
    "iso88591": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28591": "iso88591",
    "iso88592": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u02D8\u0141\xa4\u013D\u015A\xa7\xa8\u0160\u015E\u0164\u0179\xad\u017D\u017B\xb0\u0105\u02DB\u0142\xb4\u013E\u015B\u02C7\xb8\u0161\u015F\u0165\u017A\u02DD\u017E\u017C\u0154\xc1\xc2\u0102\xc4\u0139\u0106\xc7\u010C\xc9\u0118\xcb\u011A\xcd\xce\u010E\u0110\u0143\u0147\xd3\xd4\u0150\xd6\xd7\u0158\u016E\xda\u0170\xdc\xdd\u0162\xdf\u0155\xe1\xe2\u0103\xe4\u013A\u0107\xe7\u010D\xe9\u0119\xeb\u011B\xed\xee\u010F\u0111\u0144\u0148\xf3\xf4\u0151\xf6\xf7\u0159\u016F\xfa\u0171\xfc\xfd\u0163\u02D9"
    },
    "cp28592": "iso88592",
    "iso88593": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0126\u02D8\xa3\xa4\uFFFD\u0124\xa7\xa8\u0130\u015E\u011E\u0134\xad\uFFFD\u017B\xb0\u0127\xb2\xb3\xb4\xb5\u0125\xb7\xb8\u0131\u015F\u011F\u0135\xbd\uFFFD\u017C\xc0\xc1\xc2\uFFFD\xc4\u010A\u0108\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\uFFFD\xd1\xd2\xd3\xd4\u0120\xd6\xd7\u011C\xd9\xda\xdb\xdc\u016C\u015C\xdf\xe0\xe1\xe2\uFFFD\xe4\u010B\u0109\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\uFFFD\xf1\xf2\xf3\xf4\u0121\xf6\xf7\u011D\xf9\xfa\xfb\xfc\u016D\u015D\u02D9"
    },
    "cp28593": "iso88593",
    "iso88594": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0138\u0156\xa4\u0128\u013B\xa7\xa8\u0160\u0112\u0122\u0166\xad\u017D\xaf\xb0\u0105\u02DB\u0157\xb4\u0129\u013C\u02C7\xb8\u0161\u0113\u0123\u0167\u014A\u017E\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\u012A\u0110\u0145\u014C\u0136\xd4\xd5\xd6\xd7\xd8\u0172\xda\xdb\xdc\u0168\u016A\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\u012B\u0111\u0146\u014D\u0137\xf4\xf5\xf6\xf7\xf8\u0173\xfa\xfb\xfc\u0169\u016B\u02D9"
    },
    "cp28594": "iso88594",
    "iso88595": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0403\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0453\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "cp28595": "iso88595",
    "iso88596": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\uFFFD\uFFFD\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u060C\xad\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u061B\uFFFD\uFFFD\uFFFD\u061F\uFFFD\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\u0638\u0639\u063A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28596": "iso88596",
    "iso88597": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u2018\u2019\xa3\u20AC\u20AF\xa6\xa7\xa8\xa9\u037A\xab\xac\xad\uFFFD\u2015\xb0\xb1\xb2\xb3\u0384\u0385\u0386\xb7\u0388\u0389\u038A\xbb\u038C\xbd\u038E\u038F\u0390\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\uFFFD\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03AA\u03AB\u03AC\u03AD\u03AE\u03AF\u03B0\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C2\u03C3\u03C4\u03C5\u03C6\u03C7\u03C8\u03C9\u03CA\u03CB\u03CC\u03CD\u03CE\uFFFD"
    },
    "cp28597": "iso88597",
    "iso88598": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xd7\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xf7\xbb\xbc\xbd\xbe\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2017\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\uFFFD\u200E\u200F\uFFFD"
    },
    "cp28598": "iso88598",
    "iso88599": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u011E\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\u0130\u015E\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u011F\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u0131\u015F\xff"
    },
    "cp28599": "iso88599",
    "iso885910": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0112\u0122\u012A\u0128\u0136\xa7\u013B\u0110\u0160\u0166\u017D\xad\u016A\u014A\xb0\u0105\u0113\u0123\u012B\u0129\u0137\xb7\u013C\u0111\u0161\u0167\u017E\u2015\u016B\u014B\u0100\xc1\xc2\xc3\xc4\xc5\xc6\u012E\u010C\xc9\u0118\xcb\u0116\xcd\xce\xcf\xd0\u0145\u014C\xd3\xd4\xd5\xd6\u0168\xd8\u0172\xda\xdb\xdc\xdd\xde\xdf\u0101\xe1\xe2\xe3\xe4\xe5\xe6\u012F\u010D\xe9\u0119\xeb\u0117\xed\xee\xef\xf0\u0146\u014D\xf3\xf4\xf5\xf6\u0169\xf8\u0173\xfa\xfb\xfc\xfd\xfe\u0138"
    },
    "cp28600": "iso885910",
    "iso885911": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "cp28601": "iso885911",
    "iso885913": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u201D\xa2\xa3\xa4\u201E\xa6\xa7\xd8\xa9\u0156\xab\xac\xad\xae\xc6\xb0\xb1\xb2\xb3\u201C\xb5\xb6\xb7\xf8\xb9\u0157\xbb\xbc\xbd\xbe\xe6\u0104\u012E\u0100\u0106\xc4\xc5\u0118\u0112\u010C\xc9\u0179\u0116\u0122\u0136\u012A\u013B\u0160\u0143\u0145\xd3\u014C\xd5\xd6\xd7\u0172\u0141\u015A\u016A\xdc\u017B\u017D\xdf\u0105\u012F\u0101\u0107\xe4\xe5\u0119\u0113\u010D\xe9\u017A\u0117\u0123\u0137\u012B\u013C\u0161\u0144\u0146\xf3\u014D\xf5\xf6\xf7\u0173\u0142\u015B\u016B\xfc\u017C\u017E\u2019"
    },
    "cp28603": "iso885913",
    "iso885914": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u1E02\u1E03\xa3\u010A\u010B\u1E0A\xa7\u1E80\xa9\u1E82\u1E0B\u1EF2\xad\xae\u0178\u1E1E\u1E1F\u0120\u0121\u1E40\u1E41\xb6\u1E56\u1E81\u1E57\u1E83\u1E60\u1EF3\u1E84\u1E85\u1E61\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0174\xd1\xd2\xd3\xd4\xd5\xd6\u1E6A\xd8\xd9\xda\xdb\xdc\xdd\u0176\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0175\xf1\xf2\xf3\xf4\xf5\xf6\u1E6B\xf8\xf9\xfa\xfb\xfc\xfd\u0177\xff"
    },
    "cp28604": "iso885914",
    "iso885915": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\u0160\xa7\u0161\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u017D\xb5\xb6\xb7\u017E\xb9\xba\xbb\u0152\u0153\u0178\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\xd0\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\xde\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "cp28605": "iso885915",
    "iso885916": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0104\u0105\u0141\u20AC\u201E\u0160\xa7\u0161\xa9\u0218\xab\u0179\xad\u017A\u017B\xb0\xb1\u010C\u0142\u017D\u201D\xb6\xb7\u017E\u010D\u0219\xbb\u0152\u0153\u0178\u017C\xc0\xc1\xc2\u0102\xc4\u0106\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0110\u0143\xd2\xd3\xd4\u0150\xd6\u015A\u0170\xd9\xda\xdb\xdc\u0118\u021A\xdf\xe0\xe1\xe2\u0103\xe4\u0107\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0111\u0144\xf2\xf3\xf4\u0151\xf6\u015B\u0171\xf9\xfa\xfb\xfc\u0119\u021B\xff"
    },
    "cp28606": "iso885916",
    "cp437": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm437": "cp437",
    "csibm437": "cp437",
    "cp737": {
        "type": "_sbcs",
        "chars": "\u0391\u0392\u0393\u0394\u0395\u0396\u0397\u0398\u0399\u039A\u039B\u039C\u039D\u039E\u039F\u03A0\u03A1\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u03B4\u03B5\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u03C5\u03C6\u03C7\u03C8\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03C9\u03AC\u03AD\u03AE\u03CA\u03AF\u03CC\u03CD\u03CB\u03CE\u0386\u0388\u0389\u038A\u038C\u038E\u038F\xb1\u2265\u2264\u03AA\u03AB\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm737": "cp737",
    "csibm737": "cp737",
    "cp775": {
        "type": "_sbcs",
        "chars": "\u0106\xfc\xe9\u0101\xe4\u0123\xe5\u0107\u0142\u0113\u0156\u0157\u012B\u0179\xc4\xc5\xc9\xe6\xc6\u014D\xf6\u0122\xa2\u015A\u015B\xd6\xdc\xf8\xa3\xd8\xd7\xa4\u0100\u012A\xf3\u017B\u017C\u017A\u201D\xa6\xa9\xae\xac\xbd\xbc\u0141\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0104\u010C\u0118\u0116\u2563\u2551\u2557\u255D\u012E\u0160\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0172\u016A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u017D\u0105\u010D\u0119\u0117\u012F\u0161\u0173\u016B\u017E\u2518\u250C\u2588\u2584\u258C\u2590\u2580\xd3\xdf\u014C\u0143\xf5\xd5\xb5\u0144\u0136\u0137\u013B\u013C\u0146\u0112\u0145\u2019\xad\xb1\u201C\xbe\xb6\xa7\xf7\u201E\xb0\u2219\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm775": "cp775",
    "csibm775": "cp775",
    "cp850": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u0131\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm850": "cp850",
    "csibm850": "cp850",
    "cp852": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\u016F\u0107\xe7\u0142\xeb\u0150\u0151\xee\u0179\xc4\u0106\xc9\u0139\u013A\xf4\xf6\u013D\u013E\u015A\u015B\xd6\xdc\u0164\u0165\u0141\xd7\u010D\xe1\xed\xf3\xfa\u0104\u0105\u017D\u017E\u0118\u0119\xac\u017A\u010C\u015F\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\u011A\u015E\u2563\u2551\u2557\u255D\u017B\u017C\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u0102\u0103\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u0111\u0110\u010E\xcb\u010F\u0147\xcd\xce\u011B\u2518\u250C\u2588\u2584\u0162\u016E\u2580\xd3\xdf\xd4\u0143\u0144\u0148\u0160\u0161\u0154\xda\u0155\u0170\xfd\xdd\u0163\xb4\xad\u02DD\u02DB\u02C7\u02D8\xa7\xf7\xb8\xb0\xa8\u02D9\u0171\u0158\u0159\u25A0\xa0"
    },
    "ibm852": "cp852",
    "csibm852": "cp852",
    "cp855": {
        "type": "_sbcs",
        "chars": "\u0452\u0402\u0453\u0403\u0451\u0401\u0454\u0404\u0455\u0405\u0456\u0406\u0457\u0407\u0458\u0408\u0459\u0409\u045A\u040A\u045B\u040B\u045C\u040C\u045E\u040E\u045F\u040F\u044E\u042E\u044A\u042A\u0430\u0410\u0431\u0411\u0446\u0426\u0434\u0414\u0435\u0415\u0444\u0424\u0433\u0413\xab\xbb\u2591\u2592\u2593\u2502\u2524\u0445\u0425\u0438\u0418\u2563\u2551\u2557\u255D\u0439\u0419\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u043A\u041A\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\u043B\u041B\u043C\u041C\u043D\u041D\u043E\u041E\u043F\u2518\u250C\u2588\u2584\u041F\u044F\u2580\u042F\u0440\u0420\u0441\u0421\u0442\u0422\u0443\u0423\u0436\u0416\u0432\u0412\u044C\u042C\u2116\xad\u044B\u042B\u0437\u0417\u0448\u0428\u044D\u042D\u0449\u0429\u0447\u0427\xa7\u25A0\xa0"
    },
    "ibm855": "cp855",
    "csibm855": "cp855",
    "cp856": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\uFFFD\xa3\uFFFD\xd7\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xae\xac\xbd\xbc\uFFFD\xab\xbb\u2591\u2592\u2593\u2502\u2524\uFFFD\uFFFD\uFFFD\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\uFFFD\uFFFD\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u2518\u250C\u2588\u2584\xa6\uFFFD\u2580\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xb5\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm856": "cp856",
    "csibm856": "cp856",
    "cp857": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\u0131\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\u0130\xd6\xdc\xf8\xa3\xd8\u015E\u015F\xe1\xed\xf3\xfa\xf1\xd1\u011E\u011F\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xba\xaa\xca\xcb\xc8\uFFFD\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\uFFFD\xd7\xda\xdb\xd9\xec\xff\xaf\xb4\xad\xb1\uFFFD\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm857": "cp857",
    "csibm857": "cp857",
    "cp858": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\xd7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xae\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\xc1\xc2\xc0\xa9\u2563\u2551\u2557\u255D\xa2\xa5\u2510\u2514\u2534\u252C\u251C\u2500\u253C\xe3\xc3\u255A\u2554\u2569\u2566\u2560\u2550\u256C\xa4\xf0\xd0\xca\xcb\xc8\u20AC\xcd\xce\xcf\u2518\u250C\u2588\u2584\xa6\xcc\u2580\xd3\xdf\xd4\xd2\xf5\xd5\xb5\xfe\xde\xda\xdb\xd9\xfd\xdd\xaf\xb4\xad\xb1\u2017\xbe\xb6\xa7\xf7\xb8\xb0\xa8\xb7\xb9\xb3\xb2\u25A0\xa0"
    },
    "ibm858": "cp858",
    "csibm858": "cp858",
    "cp860": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe3\xe0\xc1\xe7\xea\xca\xe8\xcd\xd4\xec\xc3\xc2\xc9\xc0\xc8\xf4\xf5\xf2\xda\xf9\xcc\xd5\xdc\xa2\xa3\xd9\u20A7\xd3\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\xd2\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm860": "cp860",
    "csibm860": "cp860",
    "cp861": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xd0\xf0\xde\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xfe\xfb\xdd\xfd\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xc1\xcd\xd3\xda\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm861": "cp861",
    "csibm861": "cp861",
    "cp862": {
        "type": "_sbcs",
        "chars": "\u05D0\u05D1\u05D2\u05D3\u05D4\u05D5\u05D6\u05D7\u05D8\u05D9\u05DA\u05DB\u05DC\u05DD\u05DE\u05DF\u05E0\u05E1\u05E2\u05E3\u05E4\u05E5\u05E6\u05E7\u05E8\u05E9\u05EA\xa2\xa3\xa5\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm862": "cp862",
    "csibm862": "cp862",
    "cp863": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xc2\xe0\xb6\xe7\xea\xeb\xe8\xef\xee\u2017\xc0\xa7\xc9\xc8\xca\xf4\xcb\xcf\xfb\xf9\xa4\xd4\xdc\xa2\xa3\xd9\xdb\u0192\xa6\xb4\xf3\xfa\xa8\xb8\xb3\xaf\xce\u2310\xac\xbd\xbc\xbe\xab\xbb\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm863": "cp863",
    "csibm863": "cp863",
    "cp864": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$\u066A&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\xB0\xB7\u2219\u221A\u2592\u2500\u2502\u253C\u2524\u252C\u251C\u2534\u2510\u250C\u2514\u2518\u03B2\u221E\u03C6\xB1\xBD\xBC\u2248\xAB\xBB\uFEF7\uFEF8\uFFFD\uFFFD\uFEFB\uFEFC\uFFFD\xA0\xAD\uFE82\xA3\xA4\uFE84\uFFFD\uFFFD\uFE8E\uFE8F\uFE95\uFE99\u060C\uFE9D\uFEA1\uFEA5\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFED1\u061B\uFEB1\uFEB5\uFEB9\u061F\xA2\uFE80\uFE81\uFE83\uFE85\uFECA\uFE8B\uFE8D\uFE91\uFE93\uFE97\uFE9B\uFE9F\uFEA3\uFEA7\uFEA9\uFEAB\uFEAD\uFEAF\uFEB3\uFEB7\uFEBB\uFEBF\uFEC1\uFEC5\uFECB\uFECF\xA6\xAC\xF7\xD7\uFEC9\u0640\uFED3\uFED7\uFEDB\uFEDF\uFEE3\uFEE7\uFEEB\uFEED\uFEEF\uFEF3\uFEBD\uFECC\uFECE\uFECD\uFEE1\uFE7D\u0651\uFEE5\uFEE9\uFEEC\uFEF0\uFEF2\uFED0\uFED5\uFEF5\uFEF6\uFEDD\uFED9\uFEF1\u25A0\uFFFD"
    },
    "ibm864": "cp864",
    "csibm864": "cp864",
    "cp865": {
        "type": "_sbcs",
        "chars": "\xc7\xfc\xe9\xe2\xe4\xe0\xe5\xe7\xea\xeb\xe8\xef\xee\xec\xc4\xc5\xc9\xe6\xc6\xf4\xf6\xf2\xfb\xf9\xff\xd6\xdc\xf8\xa3\xd8\u20A7\u0192\xe1\xed\xf3\xfa\xf1\xd1\xaa\xba\xbf\u2310\xac\xbd\xbc\xa1\xab\xa4\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u03B1\xdf\u0393\u03C0\u03A3\u03C3\xb5\u03C4\u03A6\u0398\u03A9\u03B4\u221E\u03C6\u03B5\u2229\u2261\xb1\u2265\u2264\u2320\u2321\xf7\u2248\xb0\u2219\xb7\u221A\u207F\xb2\u25A0\xa0"
    },
    "ibm865": "cp865",
    "csibm865": "cp865",
    "cp866": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0404\u0454\u0407\u0457\u040E\u045E\xb0\u2219\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm866": "cp866",
    "csibm866": "cp866",
    "cp869": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0386\uFFFD\xb7\xac\xa6\u2018\u2019\u0388\u2015\u0389\u038A\u03AA\u038C\uFFFD\uFFFD\u038E\u03AB\xa9\u038F\xb2\xb3\u03AC\xa3\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03CD\u0391\u0392\u0393\u0394\u0395\u0396\u0397\xbd\u0398\u0399\xab\xbb\u2591\u2592\u2593\u2502\u2524\u039A\u039B\u039C\u039D\u2563\u2551\u2557\u255D\u039E\u039F\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u03A0\u03A1\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u03A3\u03A4\u03A5\u03A6\u03A7\u03A8\u03A9\u03B1\u03B2\u03B3\u2518\u250C\u2588\u2584\u03B4\u03B5\u2580\u03B6\u03B7\u03B8\u03B9\u03BA\u03BB\u03BC\u03BD\u03BE\u03BF\u03C0\u03C1\u03C3\u03C2\u03C4\u0384\xad\xb1\u03C5\u03C6\u03C7\xa7\u03C8\u0385\xb0\xa8\u03C9\u03CB\u03B0\u03CE\u25A0\xa0"
    },
    "ibm869": "cp869",
    "csibm869": "cp869",
    "cp922": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\u203E\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\xc3\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\xcc\xcd\xce\xcf\u0160\xd1\xd2\xd3\xd4\xd5\xd6\xd7\xd8\xd9\xda\xdb\xdc\xdd\u017D\xdf\xe0\xe1\xe2\xe3\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\u0161\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\u017E\xff"
    },
    "ibm922": "cp922",
    "csibm922": "cp922",
    "cp1046": {
        "type": "_sbcs",
        "chars": "\uFE88\xd7\xf7\uF8F6\uF8F5\uF8F4\uF8F7\uFE71\x88\u25A0\u2502\u2500\u2510\u250C\u2514\u2518\uFE79\uFE7B\uFE7D\uFE7F\uFE77\uFE8A\uFEF0\uFEF3\uFEF2\uFECE\uFECF\uFED0\uFEF6\uFEF8\uFEFA\uFEFC\xa0\uF8FA\uF8F9\uF8F8\xa4\uF8FB\uFE8B\uFE91\uFE97\uFE9B\uFE9F\uFEA3\u060C\xad\uFEA7\uFEB3\u0660\u0661\u0662\u0663\u0664\u0665\u0666\u0667\u0668\u0669\uFEB7\u061B\uFEBB\uFEBF\uFECA\u061F\uFECB\u0621\u0622\u0623\u0624\u0625\u0626\u0627\u0628\u0629\u062A\u062B\u062C\u062D\u062E\u062F\u0630\u0631\u0632\u0633\u0634\u0635\u0636\u0637\uFEC7\u0639\u063A\uFECC\uFE82\uFE84\uFE8E\uFED3\u0640\u0641\u0642\u0643\u0644\u0645\u0646\u0647\u0648\u0649\u064A\u064B\u064C\u064D\u064E\u064F\u0650\u0651\u0652\uFED7\uFEDB\uFEDF\uF8FC\uFEF5\uFEF7\uFEF9\uFEFB\uFEE3\uFEE7\uFEEC\uFEE9\uFFFD"
    },
    "ibm1046": "cp1046",
    "csibm1046": "cp1046",
    "cp1124": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0401\u0402\u0490\u0404\u0405\u0406\u0407\u0408\u0409\u040A\u040B\u040C\xad\u040E\u040F\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u2116\u0451\u0452\u0491\u0454\u0455\u0456\u0457\u0458\u0459\u045A\u045B\u045C\xa7\u045E\u045F"
    },
    "ibm1124": "cp1124",
    "csibm1124": "cp1124",
    "cp1125": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u2591\u2592\u2593\u2502\u2524\u2561\u2562\u2556\u2555\u2563\u2551\u2557\u255D\u255C\u255B\u2510\u2514\u2534\u252C\u251C\u2500\u253C\u255E\u255F\u255A\u2554\u2569\u2566\u2560\u2550\u256C\u2567\u2568\u2564\u2565\u2559\u2558\u2552\u2553\u256B\u256A\u2518\u250C\u2588\u2584\u258C\u2590\u2580\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F\u0401\u0451\u0490\u0491\u0404\u0454\u0406\u0456\u0407\u0457\xb7\u221A\u2116\xa4\u25A0\xa0"
    },
    "ibm1125": "cp1125",
    "csibm1125": "cp1125",
    "cp1129": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1129": "cp1129",
    "csibm1129": "cp1129",
    "cp1133": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E81\u0E82\u0E84\u0E87\u0E88\u0EAA\u0E8A\u0E8D\u0E94\u0E95\u0E96\u0E97\u0E99\u0E9A\u0E9B\u0E9C\u0E9D\u0E9E\u0E9F\u0EA1\u0EA2\u0EA3\u0EA5\u0EA7\u0EAB\u0EAD\u0EAE\uFFFD\uFFFD\uFFFD\u0EAF\u0EB0\u0EB2\u0EB3\u0EB4\u0EB5\u0EB6\u0EB7\u0EB8\u0EB9\u0EBC\u0EB1\u0EBB\u0EBD\uFFFD\uFFFD\uFFFD\u0EC0\u0EC1\u0EC2\u0EC3\u0EC4\u0EC8\u0EC9\u0ECA\u0ECB\u0ECC\u0ECD\u0EC6\uFFFD\u0EDC\u0EDD\u20AD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0ED0\u0ED1\u0ED2\u0ED3\u0ED4\u0ED5\u0ED6\u0ED7\u0ED8\u0ED9\uFFFD\uFFFD\xa2\xac\xa6\uFFFD"
    },
    "ibm1133": "cp1133",
    "csibm1133": "cp1133",
    "cp1161": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E48\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\u0E49\u0E4A\u0E4B\u20AC\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\xa2\xac\xa6\xa0"
    },
    "ibm1161": "cp1161",
    "csibm1161": "cp1161",
    "cp1162": {
        "type": "_sbcs",
        "chars": "\u20AC\x81\x82\x83\x84\u2026\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "ibm1162": "cp1162",
    "csibm1162": "cp1162",
    "cp1163": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xa1\xa2\xa3\u20AC\xa5\xa6\xa7\u0153\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\u0178\xb5\xb6\xb7\u0152\xb9\xba\xbb\xbc\xbd\xbe\xbf\xc0\xc1\xc2\u0102\xc4\xc5\xc6\xc7\xc8\xc9\xca\xcb\u0300\xcd\xce\xcf\u0110\xd1\u0309\xd3\xd4\u01A0\xd6\xd7\xd8\xd9\xda\xdb\xdc\u01AF\u0303\xdf\xe0\xe1\xe2\u0103\xe4\xe5\xe6\xe7\xe8\xe9\xea\xeb\u0301\xed\xee\xef\u0111\xf1\u0323\xf3\xf4\u01A1\xf6\xf7\xf8\xf9\xfa\xfb\xfc\u01B0\u20AB\xff"
    },
    "ibm1163": "cp1163",
    "csibm1163": "cp1163",
    "maccroatian": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\u0160\u2122\xb4\xa8\u2260\u017D\xd8\u221E\xb1\u2264\u2265\u2206\xb5\u2202\u2211\u220F\u0161\u222B\xaa\xba\u2126\u017E\xf8\xbf\xa1\xac\u221A\u0192\u2248\u0106\xab\u010C\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u0110\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\uFFFD\xa9\u2044\xa4\u2039\u203A\xc6\xbb\u2013\xb7\u201A\u201E\u2030\xc2\u0107\xc1\u010D\xc8\xcd\xce\xcf\xcc\xd3\xd4\u0111\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u03C0\xcb\u02DA\xb8\xca\xe6\u02C7"
    },
    "maccyrillic": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\xa2\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u2202\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "macgreek": {
        "type": "_sbcs",
        "chars": "\xc4\xb9\xb2\xc9\xb3\xd6\xdc\u0385\xe0\xe2\xe4\u0384\xa8\xe7\xe9\xe8\xea\xeb\xa3\u2122\xee\xef\u2022\xbd\u2030\xf4\xf6\xa6\xad\xf9\xfb\xfc\u2020\u0393\u0394\u0398\u039B\u039E\u03A0\xdf\xae\xa9\u03A3\u03AA\xa7\u2260\xb0\u0387\u0391\xb1\u2264\u2265\xa5\u0392\u0395\u0396\u0397\u0399\u039A\u039C\u03A6\u03AB\u03A8\u03A9\u03AC\u039D\xac\u039F\u03A1\u2248\u03A4\xab\xbb\u2026\xa0\u03A5\u03A7\u0386\u0388\u0153\u2013\u2015\u201C\u201D\u2018\u2019\xf7\u0389\u038A\u038C\u038E\u03AD\u03AE\u03AF\u03CC\u038F\u03CD\u03B1\u03B2\u03C8\u03B4\u03B5\u03C6\u03B3\u03B7\u03B9\u03BE\u03BA\u03BB\u03BC\u03BD\u03BF\u03C0\u03CE\u03C1\u03C3\u03C4\u03B8\u03C9\u03C2\u03C7\u03C5\u03B6\u03CA\u03CB\u0390\u03B0\uFFFD"
    },
    "maciceland": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\xdd\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\xd0\xf0\xde\xfe\xfd\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macroman": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macromania": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\u0102\u015E\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\u0103\u015F\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\u0162\u0163\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macthai": {
        "type": "_sbcs",
        "chars": "\xab\xbb\u2026\uF88C\uF88F\uF892\uF895\uF898\uF88B\uF88E\uF891\uF894\uF897\u201C\u201D\uF899\uFFFD\u2022\uF884\uF889\uF885\uF886\uF887\uF888\uF88A\uF88D\uF890\uF893\uF896\u2018\u2019\uFFFD\xa0\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFEFF\u200B\u2013\u2014\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u2122\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\xae\xa9\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "macturkish": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u011E\u011F\u0130\u0131\u015E\u015F\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\uFFFD\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "macukraine": {
        "type": "_sbcs",
        "chars": "\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u2020\xb0\u0490\xa3\xa7\u2022\xb6\u0406\xae\xa9\u2122\u0402\u0452\u2260\u0403\u0453\u221E\xb1\u2264\u2265\u0456\xb5\u0491\u0408\u0404\u0454\u0407\u0457\u0409\u0459\u040A\u045A\u0458\u0405\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\u040B\u045B\u040C\u045C\u0455\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u201E\u040E\u045E\u040F\u045F\u2116\u0401\u0451\u044F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\xa4"
    },
    "koi8r": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u2553\u2554\u2555\u2556\u2557\u2558\u2559\u255A\u255B\u255C\u255D\u255E\u255F\u2560\u2561\u0401\u2562\u2563\u2564\u2565\u2566\u2567\u2568\u2569\u256A\u256B\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8u": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u255D\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u256C\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8ru": {
        "type": "_sbcs",
        "chars": "\u2500\u2502\u250C\u2510\u2514\u2518\u251C\u2524\u252C\u2534\u253C\u2580\u2584\u2588\u258C\u2590\u2591\u2592\u2593\u2320\u25A0\u2219\u221A\u2248\u2264\u2265\xa0\u2321\xb0\xb2\xb7\xf7\u2550\u2551\u2552\u0451\u0454\u2554\u0456\u0457\u2557\u2558\u2559\u255A\u255B\u0491\u045E\u255E\u255F\u2560\u2561\u0401\u0404\u2563\u0406\u0407\u2566\u2567\u2568\u2569\u256A\u0490\u040E\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "koi8t": {
        "type": "_sbcs",
        "chars": "\u049B\u0493\u201A\u0492\u201E\u2026\u2020\u2021\uFFFD\u2030\u04B3\u2039\u04B2\u04B7\u04B6\uFFFD\u049A\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\uFFFD\u203A\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u04EF\u04EE\u0451\xa4\u04E3\xa6\xa7\uFFFD\uFFFD\uFFFD\xab\xac\xad\xae\uFFFD\xb0\xb1\xb2\u0401\uFFFD\u04E2\xb6\xb7\uFFFD\u2116\uFFFD\xbb\uFFFD\uFFFD\uFFFD\xa9\u044E\u0430\u0431\u0446\u0434\u0435\u0444\u0433\u0445\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u044F\u0440\u0441\u0442\u0443\u0436\u0432\u044C\u044B\u0437\u0448\u044D\u0449\u0447\u044A\u042E\u0410\u0411\u0426\u0414\u0415\u0424\u0413\u0425\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u042F\u0420\u0421\u0422\u0423\u0416\u0412\u042C\u042B\u0417\u0428\u042D\u0429\u0427\u042A"
    },
    "armscii8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\uFFFD\u0587\u0589)(\xbb\xab\u2014.\u055D,-\u058A\u2026\u055C\u055B\u055E\u0531\u0561\u0532\u0562\u0533\u0563\u0534\u0564\u0535\u0565\u0536\u0566\u0537\u0567\u0538\u0568\u0539\u0569\u053A\u056A\u053B\u056B\u053C\u056C\u053D\u056D\u053E\u056E\u053F\u056F\u0540\u0570\u0541\u0571\u0542\u0572\u0543\u0573\u0544\u0574\u0545\u0575\u0546\u0576\u0547\u0577\u0548\u0578\u0549\u0579\u054A\u057A\u054B\u057B\u054C\u057C\u054D\u057D\u054E\u057E\u054F\u057F\u0550\u0580\u0551\u0581\u0552\u0582\u0553\u0583\u0554\u0584\u0555\u0585\u0556\u0586\u055A\uFFFD"
    },
    "rk1048": {
        "type": "_sbcs",
        "chars": "\u0402\u0403\u201A\u0453\u201E\u2026\u2020\u2021\u20AC\u2030\u0409\u2039\u040A\u049A\u04BA\u040F\u0452\u2018\u2019\u201C\u201D\u2022\u2013\u2014\uFFFD\u2122\u0459\u203A\u045A\u049B\u04BB\u045F\xa0\u04B0\u04B1\u04D8\xa4\u04E8\xa6\xa7\u0401\xa9\u0492\xab\xac\xad\xae\u04AE\xb0\xb1\u0406\u0456\u04E9\xb5\xb6\xb7\u0451\u2116\u0493\xbb\u04D9\u04A2\u04A3\u04AF\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "tcvn": {
        "type": "_sbcs",
        "chars": "\0\xDA\u1EE4\x03\u1EEA\u1EEC\u1EEE\x07\b\t\n\x0B\f\r\x0E\x0F\x10\u1EE8\u1EF0\u1EF2\u1EF6\u1EF8\xDD\u1EF4\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\xC0\u1EA2\xC3\xC1\u1EA0\u1EB6\u1EAC\xC8\u1EBA\u1EBC\xC9\u1EB8\u1EC6\xCC\u1EC8\u0128\xCD\u1ECA\xD2\u1ECE\xD5\xD3\u1ECC\u1ED8\u1EDC\u1EDE\u1EE0\u1EDA\u1EE2\xD9\u1EE6\u0168\xA0\u0102\xC2\xCA\xD4\u01A0\u01AF\u0110\u0103\xE2\xEA\xF4\u01A1\u01B0\u0111\u1EB0\u0300\u0309\u0303\u0301\u0323\xE0\u1EA3\xE3\xE1\u1EA1\u1EB2\u1EB1\u1EB3\u1EB5\u1EAF\u1EB4\u1EAE\u1EA6\u1EA8\u1EAA\u1EA4\u1EC0\u1EB7\u1EA7\u1EA9\u1EAB\u1EA5\u1EAD\xE8\u1EC2\u1EBB\u1EBD\xE9\u1EB9\u1EC1\u1EC3\u1EC5\u1EBF\u1EC7\xEC\u1EC9\u1EC4\u1EBE\u1ED2\u0129\xED\u1ECB\xF2\u1ED4\u1ECF\xF5\xF3\u1ECD\u1ED3\u1ED5\u1ED7\u1ED1\u1ED9\u1EDD\u1EDF\u1EE1\u1EDB\u1EE3\xF9\u1ED6\u1EE7\u0169\xFA\u1EE5\u1EEB\u1EED\u1EEF\u1EE9\u1EF1\u1EF3\u1EF7\u1EF9\xFD\u1EF5\u1ED0"
    },
    "georgianacademy": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10EF\u10F0\u10F1\u10F2\u10F3\u10F4\u10F5\u10F6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "georgianps": {
        "type": "_sbcs",
        "chars": "\x80\x81\u201A\u0192\u201E\u2026\u2020\u2021\u02C6\u2030\u0160\u2039\u0152\x8d\x8e\x8f\x90\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u02DC\u2122\u0161\u203A\u0153\x9d\x9e\u0178\xa0\xa1\xa2\xa3\xa4\xa5\xa6\xa7\xa8\xa9\xaa\xab\xac\xad\xae\xaf\xb0\xb1\xb2\xb3\xb4\xb5\xb6\xb7\xb8\xb9\xba\xbb\xbc\xbd\xbe\xbf\u10D0\u10D1\u10D2\u10D3\u10D4\u10D5\u10D6\u10F1\u10D7\u10D8\u10D9\u10DA\u10DB\u10DC\u10F2\u10DD\u10DE\u10DF\u10E0\u10E1\u10E2\u10F3\u10E3\u10E4\u10E5\u10E6\u10E7\u10E8\u10E9\u10EA\u10EB\u10EC\u10ED\u10EE\u10F4\u10EF\u10F0\u10F5\xe6\xe7\xe8\xe9\xea\xeb\xec\xed\xee\xef\xf0\xf1\xf2\xf3\xf4\xf5\xf6\xf7\xf8\xf9\xfa\xfb\xfc\xfd\xfe\xff"
    },
    "pt154": {
        "type": "_sbcs",
        "chars": "\u0496\u0492\u04EE\u0493\u201E\u2026\u04B6\u04AE\u04B2\u04AF\u04A0\u04E2\u04A2\u049A\u04BA\u04B8\u0497\u2018\u2019\u201C\u201D\u2022\u2013\u2014\u04B3\u04B7\u04A1\u04E3\u04A3\u049B\u04BB\u04B9\xa0\u040E\u045E\u0408\u04E8\u0498\u04B0\xa7\u0401\xa9\u04D8\xab\xac\u04EF\xae\u049C\xb0\u04B1\u0406\u0456\u0499\u04E9\xb6\xb7\u0451\u2116\u04D9\xbb\u0458\u04AA\u04AB\u049D\u0410\u0411\u0412\u0413\u0414\u0415\u0416\u0417\u0418\u0419\u041A\u041B\u041C\u041D\u041E\u041F\u0420\u0421\u0422\u0423\u0424\u0425\u0426\u0427\u0428\u0429\u042A\u042B\u042C\u042D\u042E\u042F\u0430\u0431\u0432\u0433\u0434\u0435\u0436\u0437\u0438\u0439\u043A\u043B\u043C\u043D\u043E\u043F\u0440\u0441\u0442\u0443\u0444\u0445\u0446\u0447\u0448\u0449\u044A\u044B\u044C\u044D\u044E\u044F"
    },
    "viscii": {
        "type": "_sbcs",
        "chars": "\0\x01\u1EB2\x03\x04\u1EB4\u1EAA\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\u1EF6\x15\x16\x17\x18\u1EF8\x1A\x1B\x1C\x1D\u1EF4\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}~\x7F\u1EA0\u1EAE\u1EB0\u1EB6\u1EA4\u1EA6\u1EA8\u1EAC\u1EBC\u1EB8\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EE2\u1EDA\u1EDC\u1EDE\u1ECA\u1ECE\u1ECC\u1EC8\u1EE6\u0168\u1EE4\u1EF2\xD5\u1EAF\u1EB1\u1EB7\u1EA5\u1EA7\u1EA9\u1EAD\u1EBD\u1EB9\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1ED1\u1ED3\u1ED5\u1ED7\u1EE0\u01A0\u1ED9\u1EDD\u1EDF\u1ECB\u1EF0\u1EE8\u1EEA\u1EEC\u01A1\u1EDB\u01AF\xC0\xC1\xC2\xC3\u1EA2\u0102\u1EB3\u1EB5\xC8\xC9\xCA\u1EBA\xCC\xCD\u0128\u1EF3\u0110\u1EE9\xD2\xD3\xD4\u1EA1\u1EF7\u1EEB\u1EED\xD9\xDA\u1EF9\u1EF5\xDD\u1EE1\u01B0\xE0\xE1\xE2\xE3\u1EA3\u0103\u1EEF\u1EAB\xE8\xE9\xEA\u1EBB\xEC\xED\u0129\u1EC9\u0111\u1EF1\xF2\xF3\xF4\xF5\u1ECF\u1ECD\u1EE5\xF9\xFA\u0169\u1EE7\xFD\u1EE3\u1EEE"
    },
    "iso646cn": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#\xA5%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\\]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "iso646jp": {
        "type": "_sbcs",
        "chars": "\0\x01\x02\x03\x04\x05\x06\x07\b\t\n\x0B\f\r\x0E\x0F\x10\x11\x12\x13\x14\x15\x16\x17\x18\x19\x1A\x1B\x1C\x1D\x1E\x1F !\"#$%&'()*+,-./0123456789:;<=>?@ABCDEFGHIJKLMNOPQRSTUVWXYZ[\xA5]^_`abcdefghijklmnopqrstuvwxyz{|}\u203E\x7F\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "hproman8": {
        "type": "_sbcs",
        "chars": "\x80\x81\x82\x83\x84\x85\x86\x87\x88\x89\x8a\x8b\x8c\x8d\x8e\x8f\x90\x91\x92\x93\x94\x95\x96\x97\x98\x99\x9a\x9b\x9c\x9d\x9e\x9f\xa0\xc0\xc2\xc8\xca\xcb\xce\xcf\xb4\u02CB\u02C6\xa8\u02DC\xd9\xdb\u20A4\xaf\xdd\xfd\xb0\xc7\xe7\xd1\xf1\xa1\xbf\xa4\xa3\xa5\xa7\u0192\xa2\xe2\xea\xf4\xfb\xe1\xe9\xf3\xfa\xe0\xe8\xf2\xf9\xe4\xeb\xf6\xfc\xc5\xee\xd8\xc6\xe5\xed\xf8\xe6\xc4\xec\xd6\xdc\xc9\xef\xdf\xd4\xc1\xc3\xe3\xd0\xf0\xcd\xcc\xd3\xd2\xd5\xf5\u0160\u0161\xda\u0178\xff\xde\xfe\xb7\xb5\xb6\xbe\u2014\xbc\xbd\xaa\xba\xab\u25A0\xbb\xb1\uFFFD"
    },
    "macintosh": {
        "type": "_sbcs",
        "chars": "\xc4\xc5\xc7\xc9\xd1\xd6\xdc\xe1\xe0\xe2\xe4\xe3\xe5\xe7\xe9\xe8\xea\xeb\xed\xec\xee\xef\xf1\xf3\xf2\xf4\xf6\xf5\xfa\xf9\xfb\xfc\u2020\xb0\xa2\xa3\xa7\u2022\xb6\xdf\xae\xa9\u2122\xb4\xa8\u2260\xc6\xd8\u221E\xb1\u2264\u2265\xa5\xb5\u2202\u2211\u220F\u03C0\u222B\xaa\xba\u2126\xe6\xf8\xbf\xa1\xac\u221A\u0192\u2248\u2206\xab\xbb\u2026\xa0\xc0\xc3\xd5\u0152\u0153\u2013\u2014\u201C\u201D\u2018\u2019\xf7\u25CA\xff\u0178\u2044\xa4\u2039\u203A\uFB01\uFB02\u2021\xb7\u201A\u201E\u2030\xc2\xca\xc1\xcb\xc8\xcd\xce\xcf\xcc\xd3\xd4\uFFFD\xd2\xda\xdb\xd9\u0131\u02C6\u02DC\xaf\u02D8\u02D9\u02DA\xb8\u02DD\u02DB\u02C7"
    },
    "ascii": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD"
    },
    "tis620": {
        "type": "_sbcs",
        "chars": "\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\uFFFD\u0E01\u0E02\u0E03\u0E04\u0E05\u0E06\u0E07\u0E08\u0E09\u0E0A\u0E0B\u0E0C\u0E0D\u0E0E\u0E0F\u0E10\u0E11\u0E12\u0E13\u0E14\u0E15\u0E16\u0E17\u0E18\u0E19\u0E1A\u0E1B\u0E1C\u0E1D\u0E1E\u0E1F\u0E20\u0E21\u0E22\u0E23\u0E24\u0E25\u0E26\u0E27\u0E28\u0E29\u0E2A\u0E2B\u0E2C\u0E2D\u0E2E\u0E2F\u0E30\u0E31\u0E32\u0E33\u0E34\u0E35\u0E36\u0E37\u0E38\u0E39\u0E3A\uFFFD\uFFFD\uFFFD\uFFFD\u0E3F\u0E40\u0E41\u0E42\u0E43\u0E44\u0E45\u0E46\u0E47\u0E48\u0E49\u0E4A\u0E4B\u0E4C\u0E4D\u0E4E\u0E4F\u0E50\u0E51\u0E52\u0E53\u0E54\u0E55\u0E56\u0E57\u0E58\u0E59\u0E5A\u0E5B\uFFFD\uFFFD\uFFFD\uFFFD"
    }
};
var $07144aea14354eb9$var$Buffer$5 = $07144aea14354eb9$var$safer_1.Buffer; // Multibyte codec. In this scheme, a character is represented by 1 or more bytes.
// Our codec supports UTF-16 surrogates, extensions for GB18030 and unicode sequences.
// To save memory and loading time, we read table files only when requested.
var $07144aea14354eb9$var$_dbcs = $07144aea14354eb9$var$DBCSCodec;
var $07144aea14354eb9$var$UNASSIGNED = -1, $07144aea14354eb9$var$GB18030_CODE = -2, $07144aea14354eb9$var$SEQ_START = -10, $07144aea14354eb9$var$NODE_START = -1000, $07144aea14354eb9$var$UNASSIGNED_NODE = new Array(0x100), $07144aea14354eb9$var$DEF_CHAR = -1;
for(var $07144aea14354eb9$var$i$2 = 0; $07144aea14354eb9$var$i$2 < 0x100; $07144aea14354eb9$var$i$2++)$07144aea14354eb9$var$UNASSIGNED_NODE[$07144aea14354eb9$var$i$2] = $07144aea14354eb9$var$UNASSIGNED;
 // Class DBCSCodec reads and initializes mapping tables.
function $07144aea14354eb9$var$DBCSCodec(codecOptions, iconv) {
    this.encodingName = codecOptions.encodingName;
    if (!codecOptions) throw new Error("DBCS codec is called without the data.");
    if (!codecOptions.table) throw new Error("Encoding '" + this.encodingName + "' has no data."); // Load tables.
    var mappingTable = codecOptions.table(); // Decode tables: MBCS -> Unicode.
    // decodeTables is a trie, encoded as an array of arrays of integers. Internal arrays are trie nodes and all have len = 256.
    // Trie root is decodeTables[0].
    // Values: >=  0 -> unicode character code. can be > 0xFFFF
    //         == UNASSIGNED -> unknown/unassigned sequence.
    //         == GB18030_CODE -> this is the end of a GB18030 4-byte sequence.
    //         <= NODE_START -> index of the next node in our trie to process next byte.
    //         <= SEQ_START  -> index of the start of a character code sequence, in decodeTableSeq.
    this.decodeTables = [];
    this.decodeTables[0] = $07144aea14354eb9$var$UNASSIGNED_NODE.slice(0); // Create root node.
    // Sometimes a MBCS char corresponds to a sequence of unicode chars. We store them as arrays of integers here. 
    this.decodeTableSeq = []; // Actual mapping tables consist of chunks. Use them to fill up decode tables.
    for(var i = 0; i < mappingTable.length; i++)this._addDecodeChunk(mappingTable[i]);
    this.defaultCharUnicode = iconv.defaultCharUnicode; // Encode tables: Unicode -> DBCS.
    // `encodeTable` is array mapping from unicode char to encoded char. All its values are integers for performance.
    // Because it can be sparse, it is represented as array of buckets by 256 chars each. Bucket can be null.
    // Values: >=  0 -> it is a normal char. Write the value (if <=256 then 1 byte, if <=65536 then 2 bytes, etc.).
    //         == UNASSIGNED -> no conversion found. Output a default char.
    //         <= SEQ_START  -> it's an index in encodeTableSeq, see below. The character starts a sequence.
    this.encodeTable = []; // `encodeTableSeq` is used when a sequence of unicode characters is encoded as a single code. We use a tree of
    // objects where keys correspond to characters in sequence and leafs are the encoded dbcs values. A special DEF_CHAR key
    // means end of sequence (needed when one sequence is a strict subsequence of another).
    // Objects are kept separately from encodeTable to increase performance.
    this.encodeTableSeq = []; // Some chars can be decoded, but need not be encoded.
    var skipEncodeChars = {};
    if (codecOptions.encodeSkipVals) for(var i = 0; i < codecOptions.encodeSkipVals.length; i++){
        var val = codecOptions.encodeSkipVals[i];
        if (typeof val === 'number') skipEncodeChars[val] = true;
        else for(var j = val.from; j <= val.to; j++)skipEncodeChars[j] = true;
    } // Use decode trie to recursively fill out encode tables.
    this._fillEncodeTable(0, 0, skipEncodeChars); // Add more encoding pairs when needed.
    if (codecOptions.encodeAdd) {
        for(var uChar in codecOptions.encodeAdd)if (Object.prototype.hasOwnProperty.call(codecOptions.encodeAdd, uChar)) this._setEncodeChar(uChar.charCodeAt(0), codecOptions.encodeAdd[uChar]);
    }
    this.defCharSB = this.encodeTable[0][iconv.defaultCharSingleByte.charCodeAt(0)];
    if (this.defCharSB === $07144aea14354eb9$var$UNASSIGNED) this.defCharSB = this.encodeTable[0]['?'];
    if (this.defCharSB === $07144aea14354eb9$var$UNASSIGNED) this.defCharSB = "?".charCodeAt(0); // Load & create GB18030 tables when needed.
    if (typeof codecOptions.gb18030 === 'function') {
        this.gb18030 = codecOptions.gb18030(); // Load GB18030 ranges.
        // Add GB18030 decode tables.
        var thirdByteNodeIdx = this.decodeTables.length;
        var thirdByteNode = this.decodeTables[thirdByteNodeIdx] = $07144aea14354eb9$var$UNASSIGNED_NODE.slice(0);
        var fourthByteNodeIdx = this.decodeTables.length;
        var fourthByteNode = this.decodeTables[fourthByteNodeIdx] = $07144aea14354eb9$var$UNASSIGNED_NODE.slice(0);
        for(var i = 0x81; i <= 0xFE; i++){
            var secondByteNodeIdx = $07144aea14354eb9$var$NODE_START - this.decodeTables[0][i];
            var secondByteNode = this.decodeTables[secondByteNodeIdx];
            for(var j = 0x30; j <= 0x39; j++)secondByteNode[j] = $07144aea14354eb9$var$NODE_START - thirdByteNodeIdx;
        }
        for(var i = 0x81; i <= 0xFE; i++)thirdByteNode[i] = $07144aea14354eb9$var$NODE_START - fourthByteNodeIdx;
        for(var i = 0x30; i <= 0x39; i++)fourthByteNode[i] = $07144aea14354eb9$var$GB18030_CODE;
    }
}
$07144aea14354eb9$var$DBCSCodec.prototype.encoder = $07144aea14354eb9$var$DBCSEncoder;
$07144aea14354eb9$var$DBCSCodec.prototype.decoder = $07144aea14354eb9$var$DBCSDecoder; // Decoder helpers
$07144aea14354eb9$var$DBCSCodec.prototype._getDecodeTrieNode = function(addr) {
    var bytes = [];
    for(; addr > 0; addr >>= 8)bytes.push(addr & 0xFF);
    if (bytes.length == 0) bytes.push(0);
    var node = this.decodeTables[0];
    for(var i = bytes.length - 1; i > 0; i--){
        // Traverse nodes deeper into the trie.
        var val = node[bytes[i]];
        if (val == $07144aea14354eb9$var$UNASSIGNED) {
            // Create new node.
            node[bytes[i]] = $07144aea14354eb9$var$NODE_START - this.decodeTables.length;
            this.decodeTables.push(node = $07144aea14354eb9$var$UNASSIGNED_NODE.slice(0));
        } else if (val <= $07144aea14354eb9$var$NODE_START) // Existing node.
        node = this.decodeTables[$07144aea14354eb9$var$NODE_START - val];
        else throw new Error("Overwrite byte in " + this.encodingName + ", addr: " + addr.toString(16));
    }
    return node;
};
$07144aea14354eb9$var$DBCSCodec.prototype._addDecodeChunk = function(chunk) {
    // First element of chunk is the hex mbcs code where we start.
    var curAddr = parseInt(chunk[0], 16); // Choose the decoding node where we'll write our chars.
    var writeTable = this._getDecodeTrieNode(curAddr);
    curAddr = curAddr & 0xFF; // Write all other elements of the chunk to the table.
    for(var k = 1; k < chunk.length; k++){
        var part = chunk[k];
        if (typeof part === "string") // String, write as-is.
        for(var l = 0; l < part.length;){
            var code = part.charCodeAt(l++);
            if (0xD800 <= code && code < 0xDC00) {
                // Decode surrogate
                var codeTrail = part.charCodeAt(l++);
                if (0xDC00 <= codeTrail && codeTrail < 0xE000) writeTable[curAddr++] = 0x10000 + (code - 0xD800) * 0x400 + (codeTrail - 0xDC00);
                else throw new Error("Incorrect surrogate pair in " + this.encodingName + " at chunk " + chunk[0]);
            } else if (0x0FF0 < code && code <= 0x0FFF) {
                // Character sequence (our own encoding used)
                var len = 0xFFF - code + 2;
                var seq = [];
                for(var m = 0; m < len; m++)seq.push(part.charCodeAt(l++));
                 // Simple variation: don't support surrogates or subsequences in seq.
                writeTable[curAddr++] = $07144aea14354eb9$var$SEQ_START - this.decodeTableSeq.length;
                this.decodeTableSeq.push(seq);
            } else writeTable[curAddr++] = code; // Basic char
        }
        else if (typeof part === "number") {
            // Integer, meaning increasing sequence starting with prev character.
            var charCode = writeTable[curAddr - 1] + 1;
            for(var l = 0; l < part; l++)writeTable[curAddr++] = charCode++;
        } else throw new Error("Incorrect type '" + typeof part + "' given in " + this.encodingName + " at chunk " + chunk[0]);
    }
    if (curAddr > 0xFF) throw new Error("Incorrect chunk in " + this.encodingName + " at addr " + chunk[0] + ": too long" + curAddr);
}; // Encoder helpers
$07144aea14354eb9$var$DBCSCodec.prototype._getEncodeBucket = function(uCode) {
    var high = uCode >> 8; // This could be > 0xFF because of astral characters.
    if (this.encodeTable[high] === undefined) this.encodeTable[high] = $07144aea14354eb9$var$UNASSIGNED_NODE.slice(0); // Create bucket on demand.
    return this.encodeTable[high];
};
$07144aea14354eb9$var$DBCSCodec.prototype._setEncodeChar = function(uCode, dbcsCode) {
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    if (bucket[low] <= $07144aea14354eb9$var$SEQ_START) this.encodeTableSeq[$07144aea14354eb9$var$SEQ_START - bucket[low]][$07144aea14354eb9$var$DEF_CHAR] = dbcsCode; // There's already a sequence, set a single-char subsequence of it.
    else if (bucket[low] == $07144aea14354eb9$var$UNASSIGNED) bucket[low] = dbcsCode;
};
$07144aea14354eb9$var$DBCSCodec.prototype._setEncodeSequence = function(seq, dbcsCode) {
    // Get the root of character tree according to first character of the sequence.
    var uCode = seq[0];
    var bucket = this._getEncodeBucket(uCode);
    var low = uCode & 0xFF;
    var node;
    if (bucket[low] <= $07144aea14354eb9$var$SEQ_START) // There's already a sequence with  - use it.
    node = this.encodeTableSeq[$07144aea14354eb9$var$SEQ_START - bucket[low]];
    else {
        // There was no sequence object - allocate a new one.
        node = {};
        if (bucket[low] !== $07144aea14354eb9$var$UNASSIGNED) node[$07144aea14354eb9$var$DEF_CHAR] = bucket[low]; // If a char was set before - make it a single-char subsequence.
        bucket[low] = $07144aea14354eb9$var$SEQ_START - this.encodeTableSeq.length;
        this.encodeTableSeq.push(node);
    } // Traverse the character tree, allocating new nodes as needed.
    for(var j = 1; j < seq.length - 1; j++){
        var oldVal = node[uCode];
        if (typeof oldVal === 'object') node = oldVal;
        else {
            node = node[uCode] = {};
            if (oldVal !== undefined) node[$07144aea14354eb9$var$DEF_CHAR] = oldVal;
        }
    } // Set the leaf to given dbcsCode.
    uCode = seq[seq.length - 1];
    node[uCode] = dbcsCode;
};
$07144aea14354eb9$var$DBCSCodec.prototype._fillEncodeTable = function(nodeIdx, prefix, skipEncodeChars) {
    var node = this.decodeTables[nodeIdx];
    for(var i = 0; i < 0x100; i++){
        var uCode = node[i];
        var mbCode = prefix + i;
        if (skipEncodeChars[mbCode]) continue;
        if (uCode >= 0) this._setEncodeChar(uCode, mbCode);
        else if (uCode <= $07144aea14354eb9$var$NODE_START) this._fillEncodeTable($07144aea14354eb9$var$NODE_START - uCode, mbCode << 8, skipEncodeChars);
        else if (uCode <= $07144aea14354eb9$var$SEQ_START) this._setEncodeSequence(this.decodeTableSeq[$07144aea14354eb9$var$SEQ_START - uCode], mbCode);
    }
}; // == Encoder ==================================================================
function $07144aea14354eb9$var$DBCSEncoder(options, codec) {
    // Encoder state
    this.leadSurrogate = -1;
    this.seqObj = undefined; // Static data
    this.encodeTable = codec.encodeTable;
    this.encodeTableSeq = codec.encodeTableSeq;
    this.defaultCharSingleByte = codec.defCharSB;
    this.gb18030 = codec.gb18030;
}
$07144aea14354eb9$var$DBCSEncoder.prototype.write = function(str) {
    var newBuf = $07144aea14354eb9$var$Buffer$5.alloc(str.length * (this.gb18030 ? 4 : 3)), leadSurrogate = this.leadSurrogate, seqObj = this.seqObj, nextChar = -1, i = 0, j = 0;
    while(true){
        // 0. Get next character.
        if (nextChar === -1) {
            if (i == str.length) break;
            var uCode = str.charCodeAt(i++);
        } else {
            var uCode = nextChar;
            nextChar = -1;
        } // 1. Handle surrogates.
        if (0xD800 <= uCode && uCode < 0xE000) {
            // Char is one of surrogates.
            if (uCode < 0xDC00) {
                // We've got lead surrogate.
                if (leadSurrogate === -1) {
                    leadSurrogate = uCode;
                    continue;
                } else {
                    leadSurrogate = uCode; // Double lead surrogate found.
                    uCode = $07144aea14354eb9$var$UNASSIGNED;
                }
            } else // We've got trail surrogate.
            if (leadSurrogate !== -1) {
                uCode = 0x10000 + (leadSurrogate - 0xD800) * 0x400 + (uCode - 0xDC00);
                leadSurrogate = -1;
            } else // Incomplete surrogate pair - only trail surrogate found.
            uCode = $07144aea14354eb9$var$UNASSIGNED;
        } else if (leadSurrogate !== -1) {
            // Incomplete surrogate pair - only lead surrogate found.
            nextChar = uCode;
            uCode = $07144aea14354eb9$var$UNASSIGNED; // Write an error, then current char.
            leadSurrogate = -1;
        } // 2. Convert uCode character.
        var dbcsCode = $07144aea14354eb9$var$UNASSIGNED;
        if (seqObj !== undefined && uCode != $07144aea14354eb9$var$UNASSIGNED) {
            // We are in the middle of the sequence
            var resCode = seqObj[uCode];
            if (typeof resCode === 'object') {
                // Sequence continues.
                seqObj = resCode;
                continue;
            } else if (typeof resCode == 'number') // Sequence finished. Write it.
            dbcsCode = resCode;
            else if (resCode == undefined) {
                // Current character is not part of the sequence.
                // Try default character for this sequence
                resCode = seqObj[$07144aea14354eb9$var$DEF_CHAR];
                if (resCode !== undefined) {
                    dbcsCode = resCode; // Found. Write it.
                    nextChar = uCode; // Current character will be written too in the next iteration.
                }
            }
            seqObj = undefined;
        } else if (uCode >= 0) {
            // Regular character
            var subtable = this.encodeTable[uCode >> 8];
            if (subtable !== undefined) dbcsCode = subtable[uCode & 0xFF];
            if (dbcsCode <= $07144aea14354eb9$var$SEQ_START) {
                // Sequence start
                seqObj = this.encodeTableSeq[$07144aea14354eb9$var$SEQ_START - dbcsCode];
                continue;
            }
            if (dbcsCode == $07144aea14354eb9$var$UNASSIGNED && this.gb18030) {
                // Use GB18030 algorithm to find character(s) to write.
                var idx = $07144aea14354eb9$var$findIdx(this.gb18030.uChars, uCode);
                if (idx != -1) {
                    var dbcsCode = this.gb18030.gbChars[idx] + (uCode - this.gb18030.uChars[idx]);
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 12600);
                    dbcsCode = dbcsCode % 12600;
                    newBuf[j++] = 0x30 + Math.floor(dbcsCode / 1260);
                    dbcsCode = dbcsCode % 1260;
                    newBuf[j++] = 0x81 + Math.floor(dbcsCode / 10);
                    dbcsCode = dbcsCode % 10;
                    newBuf[j++] = 0x30 + dbcsCode;
                    continue;
                }
            }
        } // 3. Write dbcsCode character.
        if (dbcsCode === $07144aea14354eb9$var$UNASSIGNED) dbcsCode = this.defaultCharSingleByte;
        if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
        else if (dbcsCode < 0x10000) {
            newBuf[j++] = dbcsCode >> 8; // high byte
            newBuf[j++] = dbcsCode & 0xFF; // low byte
        } else {
            newBuf[j++] = dbcsCode >> 16;
            newBuf[j++] = dbcsCode >> 8 & 0xFF;
            newBuf[j++] = dbcsCode & 0xFF;
        }
    }
    this.seqObj = seqObj;
    this.leadSurrogate = leadSurrogate;
    return newBuf.slice(0, j);
};
$07144aea14354eb9$var$DBCSEncoder.prototype.end = function() {
    if (this.leadSurrogate === -1 && this.seqObj === undefined) return; // All clean. Most often case.
    var newBuf = $07144aea14354eb9$var$Buffer$5.alloc(10), j = 0;
    if (this.seqObj) {
        // We're in the sequence.
        var dbcsCode = this.seqObj[$07144aea14354eb9$var$DEF_CHAR];
        if (dbcsCode !== undefined) {
            // Write beginning of the sequence.
            if (dbcsCode < 0x100) newBuf[j++] = dbcsCode;
            else {
                newBuf[j++] = dbcsCode >> 8; // high byte
                newBuf[j++] = dbcsCode & 0xFF; // low byte
            }
        }
        this.seqObj = undefined;
    }
    if (this.leadSurrogate !== -1) {
        // Incomplete surrogate pair - only lead surrogate found.
        newBuf[j++] = this.defaultCharSingleByte;
        this.leadSurrogate = -1;
    }
    return newBuf.slice(0, j);
}; // Export for testing
$07144aea14354eb9$var$DBCSEncoder.prototype.findIdx = $07144aea14354eb9$var$findIdx; // == Decoder ==================================================================
function $07144aea14354eb9$var$DBCSDecoder(options, codec) {
    // Decoder state
    this.nodeIdx = 0;
    this.prevBuf = $07144aea14354eb9$var$Buffer$5.alloc(0); // Static data
    this.decodeTables = codec.decodeTables;
    this.decodeTableSeq = codec.decodeTableSeq;
    this.defaultCharUnicode = codec.defaultCharUnicode;
    this.gb18030 = codec.gb18030;
}
$07144aea14354eb9$var$DBCSDecoder.prototype.write = function(buf) {
    var newBuf = $07144aea14354eb9$var$Buffer$5.alloc(buf.length * 2), nodeIdx = this.nodeIdx, prevBuf = this.prevBuf, prevBufOffset = this.prevBuf.length, seqStart = -this.prevBuf.length, // idx of the start of current parsed sequence.
    uCode;
    if (prevBufOffset > 0) prevBuf = $07144aea14354eb9$var$Buffer$5.concat([
        prevBuf,
        buf.slice(0, 10)
    ]);
    for(var i = 0, j = 0; i < buf.length; i++){
        var curByte = i >= 0 ? buf[i] : prevBuf[i + prevBufOffset]; // Lookup in current trie node.
        var uCode = this.decodeTables[nodeIdx][curByte];
        if (uCode >= 0) ;
        else if (uCode === $07144aea14354eb9$var$UNASSIGNED) {
            // Unknown char.
            // TODO: Callback with seq.
            //var curSeq = (seqStart >= 0) ? buf.slice(seqStart, i+1) : prevBuf.slice(seqStart + prevBufOffset, i+1 + prevBufOffset);
            i = seqStart; // Try to parse again, after skipping first byte of the sequence ('i' will be incremented by 'for' cycle).
            uCode = this.defaultCharUnicode.charCodeAt(0);
        } else if (uCode === $07144aea14354eb9$var$GB18030_CODE) {
            var curSeq = seqStart >= 0 ? buf.slice(seqStart, i + 1) : prevBuf.slice(seqStart + prevBufOffset, i + 1 + prevBufOffset);
            var ptr = (curSeq[0] - 0x81) * 12600 + (curSeq[1] - 0x30) * 1260 + (curSeq[2] - 0x81) * 10 + (curSeq[3] - 0x30);
            var idx = $07144aea14354eb9$var$findIdx(this.gb18030.gbChars, ptr);
            uCode = this.gb18030.uChars[idx] + ptr - this.gb18030.gbChars[idx];
        } else if (uCode <= $07144aea14354eb9$var$NODE_START) {
            // Go to next trie node.
            nodeIdx = $07144aea14354eb9$var$NODE_START - uCode;
            continue;
        } else if (uCode <= $07144aea14354eb9$var$SEQ_START) {
            // Output a sequence of chars.
            var seq = this.decodeTableSeq[$07144aea14354eb9$var$SEQ_START - uCode];
            for(var k = 0; k < seq.length - 1; k++){
                uCode = seq[k];
                newBuf[j++] = uCode & 0xFF;
                newBuf[j++] = uCode >> 8;
            }
            uCode = seq[seq.length - 1];
        } else throw new Error("iconv-lite internal error: invalid decoding table value " + uCode + " at " + nodeIdx + "/" + curByte); // Write the character to buffer, handling higher planes using surrogate pair.
        if (uCode > 0xFFFF) {
            uCode -= 0x10000;
            var uCodeLead = 0xD800 + Math.floor(uCode / 0x400);
            newBuf[j++] = uCodeLead & 0xFF;
            newBuf[j++] = uCodeLead >> 8;
            uCode = 0xDC00 + uCode % 0x400;
        }
        newBuf[j++] = uCode & 0xFF;
        newBuf[j++] = uCode >> 8; // Reset trie node.
        nodeIdx = 0;
        seqStart = i + 1;
    }
    this.nodeIdx = nodeIdx;
    this.prevBuf = seqStart >= 0 ? buf.slice(seqStart) : prevBuf.slice(seqStart + prevBufOffset);
    return newBuf.slice(0, j).toString('ucs2');
};
$07144aea14354eb9$var$DBCSDecoder.prototype.end = function() {
    var ret = ''; // Try to parse all remaining chars.
    while(this.prevBuf.length > 0){
        // Skip 1 character in the buffer.
        ret += this.defaultCharUnicode;
        var buf = this.prevBuf.slice(1); // Parse remaining as usual.
        this.prevBuf = $07144aea14354eb9$var$Buffer$5.alloc(0);
        this.nodeIdx = 0;
        if (buf.length > 0) ret += this.write(buf);
    }
    this.nodeIdx = 0;
    return ret;
}; // Binary search for GB18030. Returns largest i such that table[i] <= val.
function $07144aea14354eb9$var$findIdx(table, val) {
    if (table[0] > val) return -1;
    var l = 0, r = table.length;
    while(l < r - 1){
        // always table[l] <= val < table[r]
        var mid = l + Math.floor((r - l + 1) / 2);
        if (table[mid] <= val) l = mid;
        else r = mid;
    }
    return l;
}
var $07144aea14354eb9$var$dbcsCodec = {
    _dbcs: $07144aea14354eb9$var$_dbcs
};
var $07144aea14354eb9$var$shiftjis = [
    [
        "0",
        "\u0000",
        128
    ],
    [
        "a1",
        "\uFF61",
        62
    ],
    [
        "8140",
        "\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",
        9,
        "\uFF0B\uFF0D\xb1\xd7"
    ],
    [
        "8180",
        "\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "81b8",
        "\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"
    ],
    [
        "81c8",
        "\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"
    ],
    [
        "81da",
        "\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"
    ],
    [
        "81f0",
        "\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"
    ],
    [
        "81fc",
        "\u25EF"
    ],
    [
        "824f",
        "\uFF10",
        9
    ],
    [
        "8260",
        "\uFF21",
        25
    ],
    [
        "8281",
        "\uFF41",
        25
    ],
    [
        "829f",
        "\u3041",
        82
    ],
    [
        "8340",
        "\u30A1",
        62
    ],
    [
        "8380",
        "\u30E0",
        22
    ],
    [
        "839f",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "83bf",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "8440",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "8470",
        "\u0430",
        5,
        "\u0451\u0436",
        7
    ],
    [
        "8480",
        "\u043E",
        17
    ],
    [
        "849f",
        "\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"
    ],
    [
        "8740",
        "\u2460",
        19,
        "\u2160",
        9
    ],
    [
        "875f",
        "\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"
    ],
    [
        "877e",
        "\u337B"
    ],
    [
        "8780",
        "\u301D\u301F\u2116\u33CD\u2121\u32A4",
        4,
        "\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"
    ],
    [
        "889f",
        "\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"
    ],
    [
        "8940",
        "\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186"
    ],
    [
        "8980",
        "\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"
    ],
    [
        "8a40",
        "\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B"
    ],
    [
        "8a80",
        "\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"
    ],
    [
        "8b40",
        "\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551"
    ],
    [
        "8b80",
        "\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"
    ],
    [
        "8c40",
        "\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8"
    ],
    [
        "8c80",
        "\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"
    ],
    [
        "8d40",
        "\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D"
    ],
    [
        "8d80",
        "\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"
    ],
    [
        "8e40",
        "\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62"
    ],
    [
        "8e80",
        "\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"
    ],
    [
        "8f40",
        "\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3"
    ],
    [
        "8f80",
        "\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"
    ],
    [
        "9040",
        "\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8"
    ],
    [
        "9080",
        "\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"
    ],
    [
        "9140",
        "\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB"
    ],
    [
        "9180",
        "\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"
    ],
    [
        "9240",
        "\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4"
    ],
    [
        "9280",
        "\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"
    ],
    [
        "9340",
        "\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC"
    ],
    [
        "9380",
        "\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"
    ],
    [
        "9440",
        "\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885"
    ],
    [
        "9480",
        "\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"
    ],
    [
        "9540",
        "\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577"
    ],
    [
        "9580",
        "\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"
    ],
    [
        "9640",
        "\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6"
    ],
    [
        "9680",
        "\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"
    ],
    [
        "9740",
        "\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32"
    ],
    [
        "9780",
        "\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"
    ],
    [
        "9840",
        "\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"
    ],
    [
        "989f",
        "\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"
    ],
    [
        "9940",
        "\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED"
    ],
    [
        "9980",
        "\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"
    ],
    [
        "9a40",
        "\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638"
    ],
    [
        "9a80",
        "\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"
    ],
    [
        "9b40",
        "\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80"
    ],
    [
        "9b80",
        "\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"
    ],
    [
        "9c40",
        "\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060"
    ],
    [
        "9c80",
        "\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"
    ],
    [
        "9d40",
        "\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B"
    ],
    [
        "9d80",
        "\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"
    ],
    [
        "9e40",
        "\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E"
    ],
    [
        "9e80",
        "\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"
    ],
    [
        "9f40",
        "\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF"
    ],
    [
        "9f80",
        "\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"
    ],
    [
        "e040",
        "\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD"
    ],
    [
        "e080",
        "\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"
    ],
    [
        "e140",
        "\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF"
    ],
    [
        "e180",
        "\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"
    ],
    [
        "e240",
        "\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0"
    ],
    [
        "e280",
        "\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"
    ],
    [
        "e340",
        "\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37"
    ],
    [
        "e380",
        "\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"
    ],
    [
        "e440",
        "\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264"
    ],
    [
        "e480",
        "\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"
    ],
    [
        "e540",
        "\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC"
    ],
    [
        "e580",
        "\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"
    ],
    [
        "e640",
        "\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7"
    ],
    [
        "e680",
        "\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"
    ],
    [
        "e740",
        "\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C"
    ],
    [
        "e780",
        "\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"
    ],
    [
        "e840",
        "\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599"
    ],
    [
        "e880",
        "\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"
    ],
    [
        "e940",
        "\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43"
    ],
    [
        "e980",
        "\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"
    ],
    [
        "ea40",
        "\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF"
    ],
    [
        "ea80",
        "\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0\u582F\u69C7\u9059\u7464\u51DC\u7199"
    ],
    [
        "ed40",
        "\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F"
    ],
    [
        "ed80",
        "\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"
    ],
    [
        "ee40",
        "\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559"
    ],
    [
        "ee80",
        "\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ],
    [
        "eeef",
        "\u2170",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02"
    ],
    [
        "f040",
        "\uE000",
        62
    ],
    [
        "f080",
        "\uE03F",
        124
    ],
    [
        "f140",
        "\uE0BC",
        62
    ],
    [
        "f180",
        "\uE0FB",
        124
    ],
    [
        "f240",
        "\uE178",
        62
    ],
    [
        "f280",
        "\uE1B7",
        124
    ],
    [
        "f340",
        "\uE234",
        62
    ],
    [
        "f380",
        "\uE273",
        124
    ],
    [
        "f440",
        "\uE2F0",
        62
    ],
    [
        "f480",
        "\uE32F",
        124
    ],
    [
        "f540",
        "\uE3AC",
        62
    ],
    [
        "f580",
        "\uE3EB",
        124
    ],
    [
        "f640",
        "\uE468",
        62
    ],
    [
        "f680",
        "\uE4A7",
        124
    ],
    [
        "f740",
        "\uE524",
        62
    ],
    [
        "f780",
        "\uE563",
        124
    ],
    [
        "f840",
        "\uE5E0",
        62
    ],
    [
        "f880",
        "\uE61F",
        124
    ],
    [
        "f940",
        "\uE69C"
    ],
    [
        "fa40",
        "\u2170",
        9,
        "\u2160",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u2235\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A"
    ],
    [
        "fa80",
        "\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F"
    ],
    [
        "fb40",
        "\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19"
    ],
    [
        "fb80",
        "\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9"
    ],
    [
        "fc40",
        "\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ]
];
var $07144aea14354eb9$var$shiftjis$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$shiftjis
});
var $07144aea14354eb9$var$eucjp = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "8ea1",
        "\uFF61",
        62
    ],
    [
        "a1a1",
        "\u3000\u3001\u3002\uFF0C\uFF0E\u30FB\uFF1A\uFF1B\uFF1F\uFF01\u309B\u309C\xb4\uFF40\xa8\uFF3E\uFFE3\uFF3F\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\u2015\u2010\uFF0F\uFF3C\uFF5E\u2225\uFF5C\u2026\u2025\u2018\u2019\u201C\u201D\uFF08\uFF09\u3014\u3015\uFF3B\uFF3D\uFF5B\uFF5D\u3008",
        9,
        "\uFF0B\uFF0D\xb1\xd7\xf7\uFF1D\u2260\uFF1C\uFF1E\u2266\u2267\u221E\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFFE5\uFF04\uFFE0\uFFE1\uFF05\uFF03\uFF06\uFF0A\uFF20\xa7\u2606\u2605\u25CB\u25CF\u25CE\u25C7"
    ],
    [
        "a2a1",
        "\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u203B\u3012\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "a2ba",
        "\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229"
    ],
    [
        "a2ca",
        "\u2227\u2228\uFFE2\u21D2\u21D4\u2200\u2203"
    ],
    [
        "a2dc",
        "\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C"
    ],
    [
        "a2f2",
        "\u212B\u2030\u266F\u266D\u266A\u2020\u2021\xb6"
    ],
    [
        "a2fe",
        "\u25EF"
    ],
    [
        "a3b0",
        "\uFF10",
        9
    ],
    [
        "a3c1",
        "\uFF21",
        25
    ],
    [
        "a3e1",
        "\uFF41",
        25
    ],
    [
        "a4a1",
        "\u3041",
        82
    ],
    [
        "a5a1",
        "\u30A1",
        85
    ],
    [
        "a6a1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a6c1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a7a1",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "a7d1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "a8a1",
        "\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542"
    ],
    [
        "ada1",
        "\u2460",
        19,
        "\u2160",
        9
    ],
    [
        "adc0",
        "\u3349\u3314\u3322\u334D\u3318\u3327\u3303\u3336\u3351\u3357\u330D\u3326\u3323\u332B\u334A\u333B\u339C\u339D\u339E\u338E\u338F\u33C4\u33A1"
    ],
    [
        "addf",
        "\u337B\u301D\u301F\u2116\u33CD\u2121\u32A4",
        4,
        "\u3231\u3232\u3239\u337E\u337D\u337C\u2252\u2261\u222B\u222E\u2211\u221A\u22A5\u2220\u221F\u22BF\u2235\u2229\u222A"
    ],
    [
        "b0a1",
        "\u4E9C\u5516\u5A03\u963F\u54C0\u611B\u6328\u59F6\u9022\u8475\u831C\u7A50\u60AA\u63E1\u6E25\u65ED\u8466\u82A6\u9BF5\u6893\u5727\u65A1\u6271\u5B9B\u59D0\u867B\u98F4\u7D62\u7DBE\u9B8E\u6216\u7C9F\u88B7\u5B89\u5EB5\u6309\u6697\u6848\u95C7\u978D\u674F\u4EE5\u4F0A\u4F4D\u4F9D\u5049\u56F2\u5937\u59D4\u5A01\u5C09\u60DF\u610F\u6170\u6613\u6905\u70BA\u754F\u7570\u79FB\u7DAD\u7DEF\u80C3\u840E\u8863\u8B02\u9055\u907A\u533B\u4E95\u4EA5\u57DF\u80B2\u90C1\u78EF\u4E00\u58F1\u6EA2\u9038\u7A32\u8328\u828B\u9C2F\u5141\u5370\u54BD\u54E1\u56E0\u59FB\u5F15\u98F2\u6DEB\u80E4\u852D"
    ],
    [
        "b1a1",
        "\u9662\u9670\u96A0\u97FB\u540B\u53F3\u5B87\u70CF\u7FBD\u8FC2\u96E8\u536F\u9D5C\u7ABA\u4E11\u7893\u81FC\u6E26\u5618\u5504\u6B1D\u851A\u9C3B\u59E5\u53A9\u6D66\u74DC\u958F\u5642\u4E91\u904B\u96F2\u834F\u990C\u53E1\u55B6\u5B30\u5F71\u6620\u66F3\u6804\u6C38\u6CF3\u6D29\u745B\u76C8\u7A4E\u9834\u82F1\u885B\u8A60\u92ED\u6DB2\u75AB\u76CA\u99C5\u60A6\u8B01\u8D8A\u95B2\u698E\u53AD\u5186\u5712\u5830\u5944\u5BB4\u5EF6\u6028\u63A9\u63F4\u6CBF\u6F14\u708E\u7114\u7159\u71D5\u733F\u7E01\u8276\u82D1\u8597\u9060\u925B\u9D1B\u5869\u65BC\u6C5A\u7525\u51F9\u592E\u5965\u5F80\u5FDC"
    ],
    [
        "b2a1",
        "\u62BC\u65FA\u6A2A\u6B27\u6BB4\u738B\u7FC1\u8956\u9D2C\u9D0E\u9EC4\u5CA1\u6C96\u837B\u5104\u5C4B\u61B6\u81C6\u6876\u7261\u4E59\u4FFA\u5378\u6069\u6E29\u7A4F\u97F3\u4E0B\u5316\u4EEE\u4F55\u4F3D\u4FA1\u4F73\u52A0\u53EF\u5609\u590F\u5AC1\u5BB6\u5BE1\u79D1\u6687\u679C\u67B6\u6B4C\u6CB3\u706B\u73C2\u798D\u79BE\u7A3C\u7B87\u82B1\u82DB\u8304\u8377\u83EF\u83D3\u8766\u8AB2\u5629\u8CA8\u8FE6\u904E\u971E\u868A\u4FC4\u5CE8\u6211\u7259\u753B\u81E5\u82BD\u86FE\u8CC0\u96C5\u9913\u99D5\u4ECB\u4F1A\u89E3\u56DE\u584A\u58CA\u5EFB\u5FEB\u602A\u6094\u6062\u61D0\u6212\u62D0\u6539"
    ],
    [
        "b3a1",
        "\u9B41\u6666\u68B0\u6D77\u7070\u754C\u7686\u7D75\u82A5\u87F9\u958B\u968E\u8C9D\u51F1\u52BE\u5916\u54B3\u5BB3\u5D16\u6168\u6982\u6DAF\u788D\u84CB\u8857\u8A72\u93A7\u9AB8\u6D6C\u99A8\u86D9\u57A3\u67FF\u86CE\u920E\u5283\u5687\u5404\u5ED3\u62E1\u64B9\u683C\u6838\u6BBB\u7372\u78BA\u7A6B\u899A\u89D2\u8D6B\u8F03\u90ED\u95A3\u9694\u9769\u5B66\u5CB3\u697D\u984D\u984E\u639B\u7B20\u6A2B\u6A7F\u68B6\u9C0D\u6F5F\u5272\u559D\u6070\u62EC\u6D3B\u6E07\u6ED1\u845B\u8910\u8F44\u4E14\u9C39\u53F6\u691B\u6A3A\u9784\u682A\u515C\u7AC3\u84B2\u91DC\u938C\u565B\u9D28\u6822\u8305\u8431"
    ],
    [
        "b4a1",
        "\u7CA5\u5208\u82C5\u74E6\u4E7E\u4F83\u51A0\u5BD2\u520A\u52D8\u52E7\u5DFB\u559A\u582A\u59E6\u5B8C\u5B98\u5BDB\u5E72\u5E79\u60A3\u611F\u6163\u61BE\u63DB\u6562\u67D1\u6853\u68FA\u6B3E\u6B53\u6C57\u6F22\u6F97\u6F45\u74B0\u7518\u76E3\u770B\u7AFF\u7BA1\u7C21\u7DE9\u7F36\u7FF0\u809D\u8266\u839E\u89B3\u8ACC\u8CAB\u9084\u9451\u9593\u9591\u95A2\u9665\u97D3\u9928\u8218\u4E38\u542B\u5CB8\u5DCC\u73A9\u764C\u773C\u5CA9\u7FEB\u8D0B\u96C1\u9811\u9854\u9858\u4F01\u4F0E\u5371\u559C\u5668\u57FA\u5947\u5B09\u5BC4\u5C90\u5E0C\u5E7E\u5FCC\u63EE\u673A\u65D7\u65E2\u671F\u68CB\u68C4"
    ],
    [
        "b5a1",
        "\u6A5F\u5E30\u6BC5\u6C17\u6C7D\u757F\u7948\u5B63\u7A00\u7D00\u5FBD\u898F\u8A18\u8CB4\u8D77\u8ECC\u8F1D\u98E2\u9A0E\u9B3C\u4E80\u507D\u5100\u5993\u5B9C\u622F\u6280\u64EC\u6B3A\u72A0\u7591\u7947\u7FA9\u87FB\u8ABC\u8B70\u63AC\u83CA\u97A0\u5409\u5403\u55AB\u6854\u6A58\u8A70\u7827\u6775\u9ECD\u5374\u5BA2\u811A\u8650\u9006\u4E18\u4E45\u4EC7\u4F11\u53CA\u5438\u5BAE\u5F13\u6025\u6551\u673D\u6C42\u6C72\u6CE3\u7078\u7403\u7A76\u7AAE\u7B08\u7D1A\u7CFE\u7D66\u65E7\u725B\u53BB\u5C45\u5DE8\u62D2\u62E0\u6319\u6E20\u865A\u8A31\u8DDD\u92F8\u6F01\u79A6\u9B5A\u4EA8\u4EAB\u4EAC"
    ],
    [
        "b6a1",
        "\u4F9B\u4FA0\u50D1\u5147\u7AF6\u5171\u51F6\u5354\u5321\u537F\u53EB\u55AC\u5883\u5CE1\u5F37\u5F4A\u602F\u6050\u606D\u631F\u6559\u6A4B\u6CC1\u72C2\u72ED\u77EF\u80F8\u8105\u8208\u854E\u90F7\u93E1\u97FF\u9957\u9A5A\u4EF0\u51DD\u5C2D\u6681\u696D\u5C40\u66F2\u6975\u7389\u6850\u7C81\u50C5\u52E4\u5747\u5DFE\u9326\u65A4\u6B23\u6B3D\u7434\u7981\u79BD\u7B4B\u7DCA\u82B9\u83CC\u887F\u895F\u8B39\u8FD1\u91D1\u541F\u9280\u4E5D\u5036\u53E5\u533A\u72D7\u7396\u77E9\u82E6\u8EAF\u99C6\u99C8\u99D2\u5177\u611A\u865E\u55B0\u7A7A\u5076\u5BD3\u9047\u9685\u4E32\u6ADB\u91E7\u5C51\u5C48"
    ],
    [
        "b7a1",
        "\u6398\u7A9F\u6C93\u9774\u8F61\u7AAA\u718A\u9688\u7C82\u6817\u7E70\u6851\u936C\u52F2\u541B\u85AB\u8A13\u7FA4\u8ECD\u90E1\u5366\u8888\u7941\u4FC2\u50BE\u5211\u5144\u5553\u572D\u73EA\u578B\u5951\u5F62\u5F84\u6075\u6176\u6167\u61A9\u63B2\u643A\u656C\u666F\u6842\u6E13\u7566\u7A3D\u7CFB\u7D4C\u7D99\u7E4B\u7F6B\u830E\u834A\u86CD\u8A08\u8A63\u8B66\u8EFD\u981A\u9D8F\u82B8\u8FCE\u9BE8\u5287\u621F\u6483\u6FC0\u9699\u6841\u5091\u6B20\u6C7A\u6F54\u7A74\u7D50\u8840\u8A23\u6708\u4EF6\u5039\u5026\u5065\u517C\u5238\u5263\u55A7\u570F\u5805\u5ACC\u5EFA\u61B2\u61F8\u62F3\u6372"
    ],
    [
        "b8a1",
        "\u691C\u6A29\u727D\u72AC\u732E\u7814\u786F\u7D79\u770C\u80A9\u898B\u8B19\u8CE2\u8ED2\u9063\u9375\u967A\u9855\u9A13\u9E78\u5143\u539F\u53B3\u5E7B\u5F26\u6E1B\u6E90\u7384\u73FE\u7D43\u8237\u8A00\u8AFA\u9650\u4E4E\u500B\u53E4\u547C\u56FA\u59D1\u5B64\u5DF1\u5EAB\u5F27\u6238\u6545\u67AF\u6E56\u72D0\u7CCA\u88B4\u80A1\u80E1\u83F0\u864E\u8A87\u8DE8\u9237\u96C7\u9867\u9F13\u4E94\u4E92\u4F0D\u5348\u5449\u543E\u5A2F\u5F8C\u5FA1\u609F\u68A7\u6A8E\u745A\u7881\u8A9E\u8AA4\u8B77\u9190\u4E5E\u9BC9\u4EA4\u4F7C\u4FAF\u5019\u5016\u5149\u516C\u529F\u52B9\u52FE\u539A\u53E3\u5411"
    ],
    [
        "b9a1",
        "\u540E\u5589\u5751\u57A2\u597D\u5B54\u5B5D\u5B8F\u5DE5\u5DE7\u5DF7\u5E78\u5E83\u5E9A\u5EB7\u5F18\u6052\u614C\u6297\u62D8\u63A7\u653B\u6602\u6643\u66F4\u676D\u6821\u6897\u69CB\u6C5F\u6D2A\u6D69\u6E2F\u6E9D\u7532\u7687\u786C\u7A3F\u7CE0\u7D05\u7D18\u7D5E\u7DB1\u8015\u8003\u80AF\u80B1\u8154\u818F\u822A\u8352\u884C\u8861\u8B1B\u8CA2\u8CFC\u90CA\u9175\u9271\u783F\u92FC\u95A4\u964D\u9805\u9999\u9AD8\u9D3B\u525B\u52AB\u53F7\u5408\u58D5\u62F7\u6FE0\u8C6A\u8F5F\u9EB9\u514B\u523B\u544A\u56FD\u7A40\u9177\u9D60\u9ED2\u7344\u6F09\u8170\u7511\u5FFD\u60DA\u9AA8\u72DB\u8FBC"
    ],
    [
        "baa1",
        "\u6B64\u9803\u4ECA\u56F0\u5764\u58BE\u5A5A\u6068\u61C7\u660F\u6606\u6839\u68B1\u6DF7\u75D5\u7D3A\u826E\u9B42\u4E9B\u4F50\u53C9\u5506\u5D6F\u5DE6\u5DEE\u67FB\u6C99\u7473\u7802\u8A50\u9396\u88DF\u5750\u5EA7\u632B\u50B5\u50AC\u518D\u6700\u54C9\u585E\u59BB\u5BB0\u5F69\u624D\u63A1\u683D\u6B73\u6E08\u707D\u91C7\u7280\u7815\u7826\u796D\u658E\u7D30\u83DC\u88C1\u8F09\u969B\u5264\u5728\u6750\u7F6A\u8CA1\u51B4\u5742\u962A\u583A\u698A\u80B4\u54B2\u5D0E\u57FC\u7895\u9DFA\u4F5C\u524A\u548B\u643E\u6628\u6714\u67F5\u7A84\u7B56\u7D22\u932F\u685C\u9BAD\u7B39\u5319\u518A\u5237"
    ],
    [
        "bba1",
        "\u5BDF\u62F6\u64AE\u64E6\u672D\u6BBA\u85A9\u96D1\u7690\u9BD6\u634C\u9306\u9BAB\u76BF\u6652\u4E09\u5098\u53C2\u5C71\u60E8\u6492\u6563\u685F\u71E6\u73CA\u7523\u7B97\u7E82\u8695\u8B83\u8CDB\u9178\u9910\u65AC\u66AB\u6B8B\u4ED5\u4ED4\u4F3A\u4F7F\u523A\u53F8\u53F2\u55E3\u56DB\u58EB\u59CB\u59C9\u59FF\u5B50\u5C4D\u5E02\u5E2B\u5FD7\u601D\u6307\u652F\u5B5C\u65AF\u65BD\u65E8\u679D\u6B62\u6B7B\u6C0F\u7345\u7949\u79C1\u7CF8\u7D19\u7D2B\u80A2\u8102\u81F3\u8996\u8A5E\u8A69\u8A66\u8A8C\u8AEE\u8CC7\u8CDC\u96CC\u98FC\u6B6F\u4E8B\u4F3C\u4F8D\u5150\u5B57\u5BFA\u6148\u6301\u6642"
    ],
    [
        "bca1",
        "\u6B21\u6ECB\u6CBB\u723E\u74BD\u75D4\u78C1\u793A\u800C\u8033\u81EA\u8494\u8F9E\u6C50\u9E7F\u5F0F\u8B58\u9D2B\u7AFA\u8EF8\u5B8D\u96EB\u4E03\u53F1\u57F7\u5931\u5AC9\u5BA4\u6089\u6E7F\u6F06\u75BE\u8CEA\u5B9F\u8500\u7BE0\u5072\u67F4\u829D\u5C61\u854A\u7E1E\u820E\u5199\u5C04\u6368\u8D66\u659C\u716E\u793E\u7D17\u8005\u8B1D\u8ECA\u906E\u86C7\u90AA\u501F\u52FA\u5C3A\u6753\u707C\u7235\u914C\u91C8\u932B\u82E5\u5BC2\u5F31\u60F9\u4E3B\u53D6\u5B88\u624B\u6731\u6B8A\u72E9\u73E0\u7A2E\u816B\u8DA3\u9152\u9996\u5112\u53D7\u546A\u5BFF\u6388\u6A39\u7DAC\u9700\u56DA\u53CE\u5468"
    ],
    [
        "bda1",
        "\u5B97\u5C31\u5DDE\u4FEE\u6101\u62FE\u6D32\u79C0\u79CB\u7D42\u7E4D\u7FD2\u81ED\u821F\u8490\u8846\u8972\u8B90\u8E74\u8F2F\u9031\u914B\u916C\u96C6\u919C\u4EC0\u4F4F\u5145\u5341\u5F93\u620E\u67D4\u6C41\u6E0B\u7363\u7E26\u91CD\u9283\u53D4\u5919\u5BBF\u6DD1\u795D\u7E2E\u7C9B\u587E\u719F\u51FA\u8853\u8FF0\u4FCA\u5CFB\u6625\u77AC\u7AE3\u821C\u99FF\u51C6\u5FAA\u65EC\u696F\u6B89\u6DF3\u6E96\u6F64\u76FE\u7D14\u5DE1\u9075\u9187\u9806\u51E6\u521D\u6240\u6691\u66D9\u6E1A\u5EB6\u7DD2\u7F72\u66F8\u85AF\u85F7\u8AF8\u52A9\u53D9\u5973\u5E8F\u5F90\u6055\u92E4\u9664\u50B7\u511F"
    ],
    [
        "bea1",
        "\u52DD\u5320\u5347\u53EC\u54E8\u5546\u5531\u5617\u5968\u59BE\u5A3C\u5BB5\u5C06\u5C0F\u5C11\u5C1A\u5E84\u5E8A\u5EE0\u5F70\u627F\u6284\u62DB\u638C\u6377\u6607\u660C\u662D\u6676\u677E\u68A2\u6A1F\u6A35\u6CBC\u6D88\u6E09\u6E58\u713C\u7126\u7167\u75C7\u7701\u785D\u7901\u7965\u79F0\u7AE0\u7B11\u7CA7\u7D39\u8096\u83D6\u848B\u8549\u885D\u88F3\u8A1F\u8A3C\u8A54\u8A73\u8C61\u8CDE\u91A4\u9266\u937E\u9418\u969C\u9798\u4E0A\u4E08\u4E1E\u4E57\u5197\u5270\u57CE\u5834\u58CC\u5B22\u5E38\u60C5\u64FE\u6761\u6756\u6D44\u72B6\u7573\u7A63\u84B8\u8B72\u91B8\u9320\u5631\u57F4\u98FE"
    ],
    [
        "bfa1",
        "\u62ED\u690D\u6B96\u71ED\u7E54\u8077\u8272\u89E6\u98DF\u8755\u8FB1\u5C3B\u4F38\u4FE1\u4FB5\u5507\u5A20\u5BDD\u5BE9\u5FC3\u614E\u632F\u65B0\u664B\u68EE\u699B\u6D78\u6DF1\u7533\u75B9\u771F\u795E\u79E6\u7D33\u81E3\u82AF\u85AA\u89AA\u8A3A\u8EAB\u8F9B\u9032\u91DD\u9707\u4EBA\u4EC1\u5203\u5875\u58EC\u5C0B\u751A\u5C3D\u814E\u8A0A\u8FC5\u9663\u976D\u7B25\u8ACF\u9808\u9162\u56F3\u53A8\u9017\u5439\u5782\u5E25\u63A8\u6C34\u708A\u7761\u7C8B\u7FE0\u8870\u9042\u9154\u9310\u9318\u968F\u745E\u9AC4\u5D07\u5D69\u6570\u67A2\u8DA8\u96DB\u636E\u6749\u6919\u83C5\u9817\u96C0\u88FE"
    ],
    [
        "c0a1",
        "\u6F84\u647A\u5BF8\u4E16\u702C\u755D\u662F\u51C4\u5236\u52E2\u59D3\u5F81\u6027\u6210\u653F\u6574\u661F\u6674\u68F2\u6816\u6B63\u6E05\u7272\u751F\u76DB\u7CBE\u8056\u58F0\u88FD\u897F\u8AA0\u8A93\u8ACB\u901D\u9192\u9752\u9759\u6589\u7A0E\u8106\u96BB\u5E2D\u60DC\u621A\u65A5\u6614\u6790\u77F3\u7A4D\u7C4D\u7E3E\u810A\u8CAC\u8D64\u8DE1\u8E5F\u78A9\u5207\u62D9\u63A5\u6442\u6298\u8A2D\u7A83\u7BC0\u8AAC\u96EA\u7D76\u820C\u8749\u4ED9\u5148\u5343\u5360\u5BA3\u5C02\u5C16\u5DDD\u6226\u6247\u64B0\u6813\u6834\u6CC9\u6D45\u6D17\u67D3\u6F5C\u714E\u717D\u65CB\u7A7F\u7BAD\u7DDA"
    ],
    [
        "c1a1",
        "\u7E4A\u7FA8\u817A\u821B\u8239\u85A6\u8A6E\u8CCE\u8DF5\u9078\u9077\u92AD\u9291\u9583\u9BAE\u524D\u5584\u6F38\u7136\u5168\u7985\u7E55\u81B3\u7CCE\u564C\u5851\u5CA8\u63AA\u66FE\u66FD\u695A\u72D9\u758F\u758E\u790E\u7956\u79DF\u7C97\u7D20\u7D44\u8607\u8A34\u963B\u9061\u9F20\u50E7\u5275\u53CC\u53E2\u5009\u55AA\u58EE\u594F\u723D\u5B8B\u5C64\u531D\u60E3\u60F3\u635C\u6383\u633F\u63BB\u64CD\u65E9\u66F9\u5DE3\u69CD\u69FD\u6F15\u71E5\u4E89\u75E9\u76F8\u7A93\u7CDF\u7DCF\u7D9C\u8061\u8349\u8358\u846C\u84BC\u85FB\u88C5\u8D70\u9001\u906D\u9397\u971C\u9A12\u50CF\u5897\u618E"
    ],
    [
        "c2a1",
        "\u81D3\u8535\u8D08\u9020\u4FC3\u5074\u5247\u5373\u606F\u6349\u675F\u6E2C\u8DB3\u901F\u4FD7\u5C5E\u8CCA\u65CF\u7D9A\u5352\u8896\u5176\u63C3\u5B58\u5B6B\u5C0A\u640D\u6751\u905C\u4ED6\u591A\u592A\u6C70\u8A51\u553E\u5815\u59A5\u60F0\u6253\u67C1\u8235\u6955\u9640\u99C4\u9A28\u4F53\u5806\u5BFE\u8010\u5CB1\u5E2F\u5F85\u6020\u614B\u6234\u66FF\u6CF0\u6EDE\u80CE\u817F\u82D4\u888B\u8CB8\u9000\u902E\u968A\u9EDB\u9BDB\u4EE3\u53F0\u5927\u7B2C\u918D\u984C\u9DF9\u6EDD\u7027\u5353\u5544\u5B85\u6258\u629E\u62D3\u6CA2\u6FEF\u7422\u8A17\u9438\u6FC1\u8AFE\u8338\u51E7\u86F8\u53EA"
    ],
    [
        "c3a1",
        "\u53E9\u4F46\u9054\u8FB0\u596A\u8131\u5DFD\u7AEA\u8FBF\u68DA\u8C37\u72F8\u9C48\u6A3D\u8AB0\u4E39\u5358\u5606\u5766\u62C5\u63A2\u65E6\u6B4E\u6DE1\u6E5B\u70AD\u77ED\u7AEF\u7BAA\u7DBB\u803D\u80C6\u86CB\u8A95\u935B\u56E3\u58C7\u5F3E\u65AD\u6696\u6A80\u6BB5\u7537\u8AC7\u5024\u77E5\u5730\u5F1B\u6065\u667A\u6C60\u75F4\u7A1A\u7F6E\u81F4\u8718\u9045\u99B3\u7BC9\u755C\u7AF9\u7B51\u84C4\u9010\u79E9\u7A92\u8336\u5AE1\u7740\u4E2D\u4EF2\u5B99\u5FE0\u62BD\u663C\u67F1\u6CE8\u866B\u8877\u8A3B\u914E\u92F3\u99D0\u6A17\u7026\u732A\u82E7\u8457\u8CAF\u4E01\u5146\u51CB\u558B\u5BF5"
    ],
    [
        "c4a1",
        "\u5E16\u5E33\u5E81\u5F14\u5F35\u5F6B\u5FB4\u61F2\u6311\u66A2\u671D\u6F6E\u7252\u753A\u773A\u8074\u8139\u8178\u8776\u8ABF\u8ADC\u8D85\u8DF3\u929A\u9577\u9802\u9CE5\u52C5\u6357\u76F4\u6715\u6C88\u73CD\u8CC3\u93AE\u9673\u6D25\u589C\u690E\u69CC\u8FFD\u939A\u75DB\u901A\u585A\u6802\u63B4\u69FB\u4F43\u6F2C\u67D8\u8FBB\u8526\u7DB4\u9354\u693F\u6F70\u576A\u58F7\u5B2C\u7D2C\u722A\u540A\u91E3\u9DB4\u4EAD\u4F4E\u505C\u5075\u5243\u8C9E\u5448\u5824\u5B9A\u5E1D\u5E95\u5EAD\u5EF7\u5F1F\u608C\u62B5\u633A\u63D0\u68AF\u6C40\u7887\u798E\u7A0B\u7DE0\u8247\u8A02\u8AE6\u8E44\u9013"
    ],
    [
        "c5a1",
        "\u90B8\u912D\u91D8\u9F0E\u6CE5\u6458\u64E2\u6575\u6EF4\u7684\u7B1B\u9069\u93D1\u6EBA\u54F2\u5FB9\u64A4\u8F4D\u8FED\u9244\u5178\u586B\u5929\u5C55\u5E97\u6DFB\u7E8F\u751C\u8CBC\u8EE2\u985B\u70B9\u4F1D\u6BBF\u6FB1\u7530\u96FB\u514E\u5410\u5835\u5857\u59AC\u5C60\u5F92\u6597\u675C\u6E21\u767B\u83DF\u8CED\u9014\u90FD\u934D\u7825\u783A\u52AA\u5EA6\u571F\u5974\u6012\u5012\u515A\u51AC\u51CD\u5200\u5510\u5854\u5858\u5957\u5B95\u5CF6\u5D8B\u60BC\u6295\u642D\u6771\u6843\u68BC\u68DF\u76D7\u6DD8\u6E6F\u6D9B\u706F\u71C8\u5F53\u75D8\u7977\u7B49\u7B54\u7B52\u7CD6\u7D71\u5230"
    ],
    [
        "c6a1",
        "\u8463\u8569\u85E4\u8A0E\u8B04\u8C46\u8E0F\u9003\u900F\u9419\u9676\u982D\u9A30\u95D8\u50CD\u52D5\u540C\u5802\u5C0E\u61A7\u649E\u6D1E\u77B3\u7AE5\u80F4\u8404\u9053\u9285\u5CE0\u9D07\u533F\u5F97\u5FB3\u6D9C\u7279\u7763\u79BF\u7BE4\u6BD2\u72EC\u8AAD\u6803\u6A61\u51F8\u7A81\u6934\u5C4A\u9CF6\u82EB\u5BC5\u9149\u701E\u5678\u5C6F\u60C7\u6566\u6C8C\u8C5A\u9041\u9813\u5451\u66C7\u920D\u5948\u90A3\u5185\u4E4D\u51EA\u8599\u8B0E\u7058\u637A\u934B\u6962\u99B4\u7E04\u7577\u5357\u6960\u8EDF\u96E3\u6C5D\u4E8C\u5C3C\u5F10\u8FE9\u5302\u8CD1\u8089\u8679\u5EFF\u65E5\u4E73\u5165"
    ],
    [
        "c7a1",
        "\u5982\u5C3F\u97EE\u4EFB\u598A\u5FCD\u8A8D\u6FE1\u79B0\u7962\u5BE7\u8471\u732B\u71B1\u5E74\u5FF5\u637B\u649A\u71C3\u7C98\u4E43\u5EFC\u4E4B\u57DC\u56A2\u60A9\u6FC3\u7D0D\u80FD\u8133\u81BF\u8FB2\u8997\u86A4\u5DF4\u628A\u64AD\u8987\u6777\u6CE2\u6D3E\u7436\u7834\u5A46\u7F75\u82AD\u99AC\u4FF3\u5EC3\u62DD\u6392\u6557\u676F\u76C3\u724C\u80CC\u80BA\u8F29\u914D\u500D\u57F9\u5A92\u6885\u6973\u7164\u72FD\u8CB7\u58F2\u8CE0\u966A\u9019\u877F\u79E4\u77E7\u8429\u4F2F\u5265\u535A\u62CD\u67CF\u6CCA\u767D\u7B94\u7C95\u8236\u8584\u8FEB\u66DD\u6F20\u7206\u7E1B\u83AB\u99C1\u9EA6"
    ],
    [
        "c8a1",
        "\u51FD\u7BB1\u7872\u7BB8\u8087\u7B48\u6AE8\u5E61\u808C\u7551\u7560\u516B\u9262\u6E8C\u767A\u9197\u9AEA\u4F10\u7F70\u629C\u7B4F\u95A5\u9CE9\u567A\u5859\u86E4\u96BC\u4F34\u5224\u534A\u53CD\u53DB\u5E06\u642C\u6591\u677F\u6C3E\u6C4E\u7248\u72AF\u73ED\u7554\u7E41\u822C\u85E9\u8CA9\u7BC4\u91C6\u7169\u9812\u98EF\u633D\u6669\u756A\u76E4\u78D0\u8543\u86EE\u532A\u5351\u5426\u5983\u5E87\u5F7C\u60B2\u6249\u6279\u62AB\u6590\u6BD4\u6CCC\u75B2\u76AE\u7891\u79D8\u7DCB\u7F77\u80A5\u88AB\u8AB9\u8CBB\u907F\u975E\u98DB\u6A0B\u7C38\u5099\u5C3E\u5FAE\u6787\u6BD8\u7435\u7709\u7F8E"
    ],
    [
        "c9a1",
        "\u9F3B\u67CA\u7A17\u5339\u758B\u9AED\u5F66\u819D\u83F1\u8098\u5F3C\u5FC5\u7562\u7B46\u903C\u6867\u59EB\u5A9B\u7D10\u767E\u8B2C\u4FF5\u5F6A\u6A19\u6C37\u6F02\u74E2\u7968\u8868\u8A55\u8C79\u5EDF\u63CF\u75C5\u79D2\u82D7\u9328\u92F2\u849C\u86ED\u9C2D\u54C1\u5F6C\u658C\u6D5C\u7015\u8CA7\u8CD3\u983B\u654F\u74F6\u4E0D\u4ED8\u57E0\u592B\u5A66\u5BCC\u51A8\u5E03\u5E9C\u6016\u6276\u6577\u65A7\u666E\u6D6E\u7236\u7B26\u8150\u819A\u8299\u8B5C\u8CA0\u8CE6\u8D74\u961C\u9644\u4FAE\u64AB\u6B66\u821E\u8461\u856A\u90E8\u5C01\u6953\u98A8\u847A\u8557\u4F0F\u526F\u5FA9\u5E45\u670D"
    ],
    [
        "caa1",
        "\u798F\u8179\u8907\u8986\u6DF5\u5F17\u6255\u6CB8\u4ECF\u7269\u9B92\u5206\u543B\u5674\u58B3\u61A4\u626E\u711A\u596E\u7C89\u7CDE\u7D1B\u96F0\u6587\u805E\u4E19\u4F75\u5175\u5840\u5E63\u5E73\u5F0A\u67C4\u4E26\u853D\u9589\u965B\u7C73\u9801\u50FB\u58C1\u7656\u78A7\u5225\u77A5\u8511\u7B86\u504F\u5909\u7247\u7BC7\u7DE8\u8FBA\u8FD4\u904D\u4FBF\u52C9\u5A29\u5F01\u97AD\u4FDD\u8217\u92EA\u5703\u6355\u6B69\u752B\u88DC\u8F14\u7A42\u52DF\u5893\u6155\u620A\u66AE\u6BCD\u7C3F\u83E9\u5023\u4FF8\u5305\u5446\u5831\u5949\u5B9D\u5CF0\u5CEF\u5D29\u5E96\u62B1\u6367\u653E\u65B9\u670B"
    ],
    [
        "cba1",
        "\u6CD5\u6CE1\u70F9\u7832\u7E2B\u80DE\u82B3\u840C\u84EC\u8702\u8912\u8A2A\u8C4A\u90A6\u92D2\u98FD\u9CF3\u9D6C\u4E4F\u4EA1\u508D\u5256\u574A\u59A8\u5E3D\u5FD8\u5FD9\u623F\u66B4\u671B\u67D0\u68D2\u5192\u7D21\u80AA\u81A8\u8B00\u8C8C\u8CBF\u927E\u9632\u5420\u982C\u5317\u50D5\u535C\u58A8\u64B2\u6734\u7267\u7766\u7A46\u91E6\u52C3\u6CA1\u6B86\u5800\u5E4C\u5954\u672C\u7FFB\u51E1\u76C6\u6469\u78E8\u9B54\u9EBB\u57CB\u59B9\u6627\u679A\u6BCE\u54E9\u69D9\u5E55\u819C\u6795\u9BAA\u67FE\u9C52\u685D\u4EA6\u4FE3\u53C8\u62B9\u672B\u6CAB\u8FC4\u4FAD\u7E6D\u9EBF\u4E07\u6162\u6E80"
    ],
    [
        "cca1",
        "\u6F2B\u8513\u5473\u672A\u9B45\u5DF3\u7B95\u5CAC\u5BC6\u871C\u6E4A\u84D1\u7A14\u8108\u5999\u7C8D\u6C11\u7720\u52D9\u5922\u7121\u725F\u77DB\u9727\u9D61\u690B\u5A7F\u5A18\u51A5\u540D\u547D\u660E\u76DF\u8FF7\u9298\u9CF4\u59EA\u725D\u6EC5\u514D\u68C9\u7DBF\u7DEC\u9762\u9EBA\u6478\u6A21\u8302\u5984\u5B5F\u6BDB\u731B\u76F2\u7DB2\u8017\u8499\u5132\u6728\u9ED9\u76EE\u6762\u52FF\u9905\u5C24\u623B\u7C7E\u8CB0\u554F\u60B6\u7D0B\u9580\u5301\u4E5F\u51B6\u591C\u723A\u8036\u91CE\u5F25\u77E2\u5384\u5F79\u7D04\u85AC\u8A33\u8E8D\u9756\u67F3\u85AE\u9453\u6109\u6108\u6CB9\u7652"
    ],
    [
        "cda1",
        "\u8AED\u8F38\u552F\u4F51\u512A\u52C7\u53CB\u5BA5\u5E7D\u60A0\u6182\u63D6\u6709\u67DA\u6E67\u6D8C\u7336\u7337\u7531\u7950\u88D5\u8A98\u904A\u9091\u90F5\u96C4\u878D\u5915\u4E88\u4F59\u4E0E\u8A89\u8F3F\u9810\u50AD\u5E7C\u5996\u5BB9\u5EB8\u63DA\u63FA\u64C1\u66DC\u694A\u69D8\u6D0B\u6EB6\u7194\u7528\u7AAF\u7F8A\u8000\u8449\u84C9\u8981\u8B21\u8E0A\u9065\u967D\u990A\u617E\u6291\u6B32\u6C83\u6D74\u7FCC\u7FFC\u6DC0\u7F85\u87BA\u88F8\u6765\u83B1\u983C\u96F7\u6D1B\u7D61\u843D\u916A\u4E71\u5375\u5D50\u6B04\u6FEB\u85CD\u862D\u89A7\u5229\u540F\u5C65\u674E\u68A8\u7406\u7483"
    ],
    [
        "cea1",
        "\u75E2\u88CF\u88E1\u91CC\u96E2\u9678\u5F8B\u7387\u7ACB\u844E\u63A0\u7565\u5289\u6D41\u6E9C\u7409\u7559\u786B\u7C92\u9686\u7ADC\u9F8D\u4FB6\u616E\u65C5\u865C\u4E86\u4EAE\u50DA\u4E21\u51CC\u5BEE\u6599\u6881\u6DBC\u731F\u7642\u77AD\u7A1C\u7CE7\u826F\u8AD2\u907C\u91CF\u9675\u9818\u529B\u7DD1\u502B\u5398\u6797\u6DCB\u71D0\u7433\u81E8\u8F2A\u96A3\u9C57\u9E9F\u7460\u5841\u6D99\u7D2F\u985E\u4EE4\u4F36\u4F8B\u51B7\u52B1\u5DBA\u601C\u73B2\u793C\u82D3\u9234\u96B7\u96F6\u970A\u9E97\u9F62\u66A6\u6B74\u5217\u52A3\u70C8\u88C2\u5EC9\u604B\u6190\u6F23\u7149\u7C3E\u7DF4\u806F"
    ],
    [
        "cfa1",
        "\u84EE\u9023\u932C\u5442\u9B6F\u6AD3\u7089\u8CC2\u8DEF\u9732\u52B4\u5A41\u5ECA\u5F04\u6717\u697C\u6994\u6D6A\u6F0F\u7262\u72FC\u7BED\u8001\u807E\u874B\u90CE\u516D\u9E93\u7984\u808B\u9332\u8AD6\u502D\u548C\u8A71\u6B6A\u8CC4\u8107\u60D1\u67A0\u9DF2\u4E99\u4E98\u9C10\u8A6B\u85C1\u8568\u6900\u6E7E\u7897\u8155"
    ],
    [
        "d0a1",
        "\u5F0C\u4E10\u4E15\u4E2A\u4E31\u4E36\u4E3C\u4E3F\u4E42\u4E56\u4E58\u4E82\u4E85\u8C6B\u4E8A\u8212\u5F0D\u4E8E\u4E9E\u4E9F\u4EA0\u4EA2\u4EB0\u4EB3\u4EB6\u4ECE\u4ECD\u4EC4\u4EC6\u4EC2\u4ED7\u4EDE\u4EED\u4EDF\u4EF7\u4F09\u4F5A\u4F30\u4F5B\u4F5D\u4F57\u4F47\u4F76\u4F88\u4F8F\u4F98\u4F7B\u4F69\u4F70\u4F91\u4F6F\u4F86\u4F96\u5118\u4FD4\u4FDF\u4FCE\u4FD8\u4FDB\u4FD1\u4FDA\u4FD0\u4FE4\u4FE5\u501A\u5028\u5014\u502A\u5025\u5005\u4F1C\u4FF6\u5021\u5029\u502C\u4FFE\u4FEF\u5011\u5006\u5043\u5047\u6703\u5055\u5050\u5048\u505A\u5056\u506C\u5078\u5080\u509A\u5085\u50B4\u50B2"
    ],
    [
        "d1a1",
        "\u50C9\u50CA\u50B3\u50C2\u50D6\u50DE\u50E5\u50ED\u50E3\u50EE\u50F9\u50F5\u5109\u5101\u5102\u5116\u5115\u5114\u511A\u5121\u513A\u5137\u513C\u513B\u513F\u5140\u5152\u514C\u5154\u5162\u7AF8\u5169\u516A\u516E\u5180\u5182\u56D8\u518C\u5189\u518F\u5191\u5193\u5195\u5196\u51A4\u51A6\u51A2\u51A9\u51AA\u51AB\u51B3\u51B1\u51B2\u51B0\u51B5\u51BD\u51C5\u51C9\u51DB\u51E0\u8655\u51E9\u51ED\u51F0\u51F5\u51FE\u5204\u520B\u5214\u520E\u5227\u522A\u522E\u5233\u5239\u524F\u5244\u524B\u524C\u525E\u5254\u526A\u5274\u5269\u5273\u527F\u527D\u528D\u5294\u5292\u5271\u5288\u5291\u8FA8"
    ],
    [
        "d2a1",
        "\u8FA7\u52AC\u52AD\u52BC\u52B5\u52C1\u52CD\u52D7\u52DE\u52E3\u52E6\u98ED\u52E0\u52F3\u52F5\u52F8\u52F9\u5306\u5308\u7538\u530D\u5310\u530F\u5315\u531A\u5323\u532F\u5331\u5333\u5338\u5340\u5346\u5345\u4E17\u5349\u534D\u51D6\u535E\u5369\u536E\u5918\u537B\u5377\u5382\u5396\u53A0\u53A6\u53A5\u53AE\u53B0\u53B6\u53C3\u7C12\u96D9\u53DF\u66FC\u71EE\u53EE\u53E8\u53ED\u53FA\u5401\u543D\u5440\u542C\u542D\u543C\u542E\u5436\u5429\u541D\u544E\u548F\u5475\u548E\u545F\u5471\u5477\u5470\u5492\u547B\u5480\u5476\u5484\u5490\u5486\u54C7\u54A2\u54B8\u54A5\u54AC\u54C4\u54C8\u54A8"
    ],
    [
        "d3a1",
        "\u54AB\u54C2\u54A4\u54BE\u54BC\u54D8\u54E5\u54E6\u550F\u5514\u54FD\u54EE\u54ED\u54FA\u54E2\u5539\u5540\u5563\u554C\u552E\u555C\u5545\u5556\u5557\u5538\u5533\u555D\u5599\u5580\u54AF\u558A\u559F\u557B\u557E\u5598\u559E\u55AE\u557C\u5583\u55A9\u5587\u55A8\u55DA\u55C5\u55DF\u55C4\u55DC\u55E4\u55D4\u5614\u55F7\u5616\u55FE\u55FD\u561B\u55F9\u564E\u5650\u71DF\u5634\u5636\u5632\u5638\u566B\u5664\u562F\u566C\u566A\u5686\u5680\u568A\u56A0\u5694\u568F\u56A5\u56AE\u56B6\u56B4\u56C2\u56BC\u56C1\u56C3\u56C0\u56C8\u56CE\u56D1\u56D3\u56D7\u56EE\u56F9\u5700\u56FF\u5704\u5709"
    ],
    [
        "d4a1",
        "\u5708\u570B\u570D\u5713\u5718\u5716\u55C7\u571C\u5726\u5737\u5738\u574E\u573B\u5740\u574F\u5769\u57C0\u5788\u5761\u577F\u5789\u5793\u57A0\u57B3\u57A4\u57AA\u57B0\u57C3\u57C6\u57D4\u57D2\u57D3\u580A\u57D6\u57E3\u580B\u5819\u581D\u5872\u5821\u5862\u584B\u5870\u6BC0\u5852\u583D\u5879\u5885\u58B9\u589F\u58AB\u58BA\u58DE\u58BB\u58B8\u58AE\u58C5\u58D3\u58D1\u58D7\u58D9\u58D8\u58E5\u58DC\u58E4\u58DF\u58EF\u58FA\u58F9\u58FB\u58FC\u58FD\u5902\u590A\u5910\u591B\u68A6\u5925\u592C\u592D\u5932\u5938\u593E\u7AD2\u5955\u5950\u594E\u595A\u5958\u5962\u5960\u5967\u596C\u5969"
    ],
    [
        "d5a1",
        "\u5978\u5981\u599D\u4F5E\u4FAB\u59A3\u59B2\u59C6\u59E8\u59DC\u598D\u59D9\u59DA\u5A25\u5A1F\u5A11\u5A1C\u5A09\u5A1A\u5A40\u5A6C\u5A49\u5A35\u5A36\u5A62\u5A6A\u5A9A\u5ABC\u5ABE\u5ACB\u5AC2\u5ABD\u5AE3\u5AD7\u5AE6\u5AE9\u5AD6\u5AFA\u5AFB\u5B0C\u5B0B\u5B16\u5B32\u5AD0\u5B2A\u5B36\u5B3E\u5B43\u5B45\u5B40\u5B51\u5B55\u5B5A\u5B5B\u5B65\u5B69\u5B70\u5B73\u5B75\u5B78\u6588\u5B7A\u5B80\u5B83\u5BA6\u5BB8\u5BC3\u5BC7\u5BC9\u5BD4\u5BD0\u5BE4\u5BE6\u5BE2\u5BDE\u5BE5\u5BEB\u5BF0\u5BF6\u5BF3\u5C05\u5C07\u5C08\u5C0D\u5C13\u5C20\u5C22\u5C28\u5C38\u5C39\u5C41\u5C46\u5C4E\u5C53"
    ],
    [
        "d6a1",
        "\u5C50\u5C4F\u5B71\u5C6C\u5C6E\u4E62\u5C76\u5C79\u5C8C\u5C91\u5C94\u599B\u5CAB\u5CBB\u5CB6\u5CBC\u5CB7\u5CC5\u5CBE\u5CC7\u5CD9\u5CE9\u5CFD\u5CFA\u5CED\u5D8C\u5CEA\u5D0B\u5D15\u5D17\u5D5C\u5D1F\u5D1B\u5D11\u5D14\u5D22\u5D1A\u5D19\u5D18\u5D4C\u5D52\u5D4E\u5D4B\u5D6C\u5D73\u5D76\u5D87\u5D84\u5D82\u5DA2\u5D9D\u5DAC\u5DAE\u5DBD\u5D90\u5DB7\u5DBC\u5DC9\u5DCD\u5DD3\u5DD2\u5DD6\u5DDB\u5DEB\u5DF2\u5DF5\u5E0B\u5E1A\u5E19\u5E11\u5E1B\u5E36\u5E37\u5E44\u5E43\u5E40\u5E4E\u5E57\u5E54\u5E5F\u5E62\u5E64\u5E47\u5E75\u5E76\u5E7A\u9EBC\u5E7F\u5EA0\u5EC1\u5EC2\u5EC8\u5ED0\u5ECF"
    ],
    [
        "d7a1",
        "\u5ED6\u5EE3\u5EDD\u5EDA\u5EDB\u5EE2\u5EE1\u5EE8\u5EE9\u5EEC\u5EF1\u5EF3\u5EF0\u5EF4\u5EF8\u5EFE\u5F03\u5F09\u5F5D\u5F5C\u5F0B\u5F11\u5F16\u5F29\u5F2D\u5F38\u5F41\u5F48\u5F4C\u5F4E\u5F2F\u5F51\u5F56\u5F57\u5F59\u5F61\u5F6D\u5F73\u5F77\u5F83\u5F82\u5F7F\u5F8A\u5F88\u5F91\u5F87\u5F9E\u5F99\u5F98\u5FA0\u5FA8\u5FAD\u5FBC\u5FD6\u5FFB\u5FE4\u5FF8\u5FF1\u5FDD\u60B3\u5FFF\u6021\u6060\u6019\u6010\u6029\u600E\u6031\u601B\u6015\u602B\u6026\u600F\u603A\u605A\u6041\u606A\u6077\u605F\u604A\u6046\u604D\u6063\u6043\u6064\u6042\u606C\u606B\u6059\u6081\u608D\u60E7\u6083\u609A"
    ],
    [
        "d8a1",
        "\u6084\u609B\u6096\u6097\u6092\u60A7\u608B\u60E1\u60B8\u60E0\u60D3\u60B4\u5FF0\u60BD\u60C6\u60B5\u60D8\u614D\u6115\u6106\u60F6\u60F7\u6100\u60F4\u60FA\u6103\u6121\u60FB\u60F1\u610D\u610E\u6147\u613E\u6128\u6127\u614A\u613F\u613C\u612C\u6134\u613D\u6142\u6144\u6173\u6177\u6158\u6159\u615A\u616B\u6174\u616F\u6165\u6171\u615F\u615D\u6153\u6175\u6199\u6196\u6187\u61AC\u6194\u619A\u618A\u6191\u61AB\u61AE\u61CC\u61CA\u61C9\u61F7\u61C8\u61C3\u61C6\u61BA\u61CB\u7F79\u61CD\u61E6\u61E3\u61F6\u61FA\u61F4\u61FF\u61FD\u61FC\u61FE\u6200\u6208\u6209\u620D\u620C\u6214\u621B"
    ],
    [
        "d9a1",
        "\u621E\u6221\u622A\u622E\u6230\u6232\u6233\u6241\u624E\u625E\u6263\u625B\u6260\u6268\u627C\u6282\u6289\u627E\u6292\u6293\u6296\u62D4\u6283\u6294\u62D7\u62D1\u62BB\u62CF\u62FF\u62C6\u64D4\u62C8\u62DC\u62CC\u62CA\u62C2\u62C7\u629B\u62C9\u630C\u62EE\u62F1\u6327\u6302\u6308\u62EF\u62F5\u6350\u633E\u634D\u641C\u634F\u6396\u638E\u6380\u63AB\u6376\u63A3\u638F\u6389\u639F\u63B5\u636B\u6369\u63BE\u63E9\u63C0\u63C6\u63E3\u63C9\u63D2\u63F6\u63C4\u6416\u6434\u6406\u6413\u6426\u6436\u651D\u6417\u6428\u640F\u6467\u646F\u6476\u644E\u652A\u6495\u6493\u64A5\u64A9\u6488\u64BC"
    ],
    [
        "daa1",
        "\u64DA\u64D2\u64C5\u64C7\u64BB\u64D8\u64C2\u64F1\u64E7\u8209\u64E0\u64E1\u62AC\u64E3\u64EF\u652C\u64F6\u64F4\u64F2\u64FA\u6500\u64FD\u6518\u651C\u6505\u6524\u6523\u652B\u6534\u6535\u6537\u6536\u6538\u754B\u6548\u6556\u6555\u654D\u6558\u655E\u655D\u6572\u6578\u6582\u6583\u8B8A\u659B\u659F\u65AB\u65B7\u65C3\u65C6\u65C1\u65C4\u65CC\u65D2\u65DB\u65D9\u65E0\u65E1\u65F1\u6772\u660A\u6603\u65FB\u6773\u6635\u6636\u6634\u661C\u664F\u6644\u6649\u6641\u665E\u665D\u6664\u6667\u6668\u665F\u6662\u6670\u6683\u6688\u668E\u6689\u6684\u6698\u669D\u66C1\u66B9\u66C9\u66BE\u66BC"
    ],
    [
        "dba1",
        "\u66C4\u66B8\u66D6\u66DA\u66E0\u663F\u66E6\u66E9\u66F0\u66F5\u66F7\u670F\u6716\u671E\u6726\u6727\u9738\u672E\u673F\u6736\u6741\u6738\u6737\u6746\u675E\u6760\u6759\u6763\u6764\u6789\u6770\u67A9\u677C\u676A\u678C\u678B\u67A6\u67A1\u6785\u67B7\u67EF\u67B4\u67EC\u67B3\u67E9\u67B8\u67E4\u67DE\u67DD\u67E2\u67EE\u67B9\u67CE\u67C6\u67E7\u6A9C\u681E\u6846\u6829\u6840\u684D\u6832\u684E\u68B3\u682B\u6859\u6863\u6877\u687F\u689F\u688F\u68AD\u6894\u689D\u689B\u6883\u6AAE\u68B9\u6874\u68B5\u68A0\u68BA\u690F\u688D\u687E\u6901\u68CA\u6908\u68D8\u6922\u6926\u68E1\u690C\u68CD"
    ],
    [
        "dca1",
        "\u68D4\u68E7\u68D5\u6936\u6912\u6904\u68D7\u68E3\u6925\u68F9\u68E0\u68EF\u6928\u692A\u691A\u6923\u6921\u68C6\u6979\u6977\u695C\u6978\u696B\u6954\u697E\u696E\u6939\u6974\u693D\u6959\u6930\u6961\u695E\u695D\u6981\u696A\u69B2\u69AE\u69D0\u69BF\u69C1\u69D3\u69BE\u69CE\u5BE8\u69CA\u69DD\u69BB\u69C3\u69A7\u6A2E\u6991\u69A0\u699C\u6995\u69B4\u69DE\u69E8\u6A02\u6A1B\u69FF\u6B0A\u69F9\u69F2\u69E7\u6A05\u69B1\u6A1E\u69ED\u6A14\u69EB\u6A0A\u6A12\u6AC1\u6A23\u6A13\u6A44\u6A0C\u6A72\u6A36\u6A78\u6A47\u6A62\u6A59\u6A66\u6A48\u6A38\u6A22\u6A90\u6A8D\u6AA0\u6A84\u6AA2\u6AA3"
    ],
    [
        "dda1",
        "\u6A97\u8617\u6ABB\u6AC3\u6AC2\u6AB8\u6AB3\u6AAC\u6ADE\u6AD1\u6ADF\u6AAA\u6ADA\u6AEA\u6AFB\u6B05\u8616\u6AFA\u6B12\u6B16\u9B31\u6B1F\u6B38\u6B37\u76DC\u6B39\u98EE\u6B47\u6B43\u6B49\u6B50\u6B59\u6B54\u6B5B\u6B5F\u6B61\u6B78\u6B79\u6B7F\u6B80\u6B84\u6B83\u6B8D\u6B98\u6B95\u6B9E\u6BA4\u6BAA\u6BAB\u6BAF\u6BB2\u6BB1\u6BB3\u6BB7\u6BBC\u6BC6\u6BCB\u6BD3\u6BDF\u6BEC\u6BEB\u6BF3\u6BEF\u9EBE\u6C08\u6C13\u6C14\u6C1B\u6C24\u6C23\u6C5E\u6C55\u6C62\u6C6A\u6C82\u6C8D\u6C9A\u6C81\u6C9B\u6C7E\u6C68\u6C73\u6C92\u6C90\u6CC4\u6CF1\u6CD3\u6CBD\u6CD7\u6CC5\u6CDD\u6CAE\u6CB1\u6CBE"
    ],
    [
        "dea1",
        "\u6CBA\u6CDB\u6CEF\u6CD9\u6CEA\u6D1F\u884D\u6D36\u6D2B\u6D3D\u6D38\u6D19\u6D35\u6D33\u6D12\u6D0C\u6D63\u6D93\u6D64\u6D5A\u6D79\u6D59\u6D8E\u6D95\u6FE4\u6D85\u6DF9\u6E15\u6E0A\u6DB5\u6DC7\u6DE6\u6DB8\u6DC6\u6DEC\u6DDE\u6DCC\u6DE8\u6DD2\u6DC5\u6DFA\u6DD9\u6DE4\u6DD5\u6DEA\u6DEE\u6E2D\u6E6E\u6E2E\u6E19\u6E72\u6E5F\u6E3E\u6E23\u6E6B\u6E2B\u6E76\u6E4D\u6E1F\u6E43\u6E3A\u6E4E\u6E24\u6EFF\u6E1D\u6E38\u6E82\u6EAA\u6E98\u6EC9\u6EB7\u6ED3\u6EBD\u6EAF\u6EC4\u6EB2\u6ED4\u6ED5\u6E8F\u6EA5\u6EC2\u6E9F\u6F41\u6F11\u704C\u6EEC\u6EF8\u6EFE\u6F3F\u6EF2\u6F31\u6EEF\u6F32\u6ECC"
    ],
    [
        "dfa1",
        "\u6F3E\u6F13\u6EF7\u6F86\u6F7A\u6F78\u6F81\u6F80\u6F6F\u6F5B\u6FF3\u6F6D\u6F82\u6F7C\u6F58\u6F8E\u6F91\u6FC2\u6F66\u6FB3\u6FA3\u6FA1\u6FA4\u6FB9\u6FC6\u6FAA\u6FDF\u6FD5\u6FEC\u6FD4\u6FD8\u6FF1\u6FEE\u6FDB\u7009\u700B\u6FFA\u7011\u7001\u700F\u6FFE\u701B\u701A\u6F74\u701D\u7018\u701F\u7030\u703E\u7032\u7051\u7063\u7099\u7092\u70AF\u70F1\u70AC\u70B8\u70B3\u70AE\u70DF\u70CB\u70DD\u70D9\u7109\u70FD\u711C\u7119\u7165\u7155\u7188\u7166\u7162\u714C\u7156\u716C\u718F\u71FB\u7184\u7195\u71A8\u71AC\u71D7\u71B9\u71BE\u71D2\u71C9\u71D4\u71CE\u71E0\u71EC\u71E7\u71F5\u71FC"
    ],
    [
        "e0a1",
        "\u71F9\u71FF\u720D\u7210\u721B\u7228\u722D\u722C\u7230\u7232\u723B\u723C\u723F\u7240\u7246\u724B\u7258\u7274\u727E\u7282\u7281\u7287\u7292\u7296\u72A2\u72A7\u72B9\u72B2\u72C3\u72C6\u72C4\u72CE\u72D2\u72E2\u72E0\u72E1\u72F9\u72F7\u500F\u7317\u730A\u731C\u7316\u731D\u7334\u732F\u7329\u7325\u733E\u734E\u734F\u9ED8\u7357\u736A\u7368\u7370\u7378\u7375\u737B\u737A\u73C8\u73B3\u73CE\u73BB\u73C0\u73E5\u73EE\u73DE\u74A2\u7405\u746F\u7425\u73F8\u7432\u743A\u7455\u743F\u745F\u7459\u7441\u745C\u7469\u7470\u7463\u746A\u7476\u747E\u748B\u749E\u74A7\u74CA\u74CF\u74D4\u73F1"
    ],
    [
        "e1a1",
        "\u74E0\u74E3\u74E7\u74E9\u74EE\u74F2\u74F0\u74F1\u74F8\u74F7\u7504\u7503\u7505\u750C\u750E\u750D\u7515\u7513\u751E\u7526\u752C\u753C\u7544\u754D\u754A\u7549\u755B\u7546\u755A\u7569\u7564\u7567\u756B\u756D\u7578\u7576\u7586\u7587\u7574\u758A\u7589\u7582\u7594\u759A\u759D\u75A5\u75A3\u75C2\u75B3\u75C3\u75B5\u75BD\u75B8\u75BC\u75B1\u75CD\u75CA\u75D2\u75D9\u75E3\u75DE\u75FE\u75FF\u75FC\u7601\u75F0\u75FA\u75F2\u75F3\u760B\u760D\u7609\u761F\u7627\u7620\u7621\u7622\u7624\u7634\u7630\u763B\u7647\u7648\u7646\u765C\u7658\u7661\u7662\u7668\u7669\u766A\u7667\u766C\u7670"
    ],
    [
        "e2a1",
        "\u7672\u7676\u7678\u767C\u7680\u7683\u7688\u768B\u768E\u7696\u7693\u7699\u769A\u76B0\u76B4\u76B8\u76B9\u76BA\u76C2\u76CD\u76D6\u76D2\u76DE\u76E1\u76E5\u76E7\u76EA\u862F\u76FB\u7708\u7707\u7704\u7729\u7724\u771E\u7725\u7726\u771B\u7737\u7738\u7747\u775A\u7768\u776B\u775B\u7765\u777F\u777E\u7779\u778E\u778B\u7791\u77A0\u779E\u77B0\u77B6\u77B9\u77BF\u77BC\u77BD\u77BB\u77C7\u77CD\u77D7\u77DA\u77DC\u77E3\u77EE\u77FC\u780C\u7812\u7926\u7820\u792A\u7845\u788E\u7874\u7886\u787C\u789A\u788C\u78A3\u78B5\u78AA\u78AF\u78D1\u78C6\u78CB\u78D4\u78BE\u78BC\u78C5\u78CA\u78EC"
    ],
    [
        "e3a1",
        "\u78E7\u78DA\u78FD\u78F4\u7907\u7912\u7911\u7919\u792C\u792B\u7940\u7960\u7957\u795F\u795A\u7955\u7953\u797A\u797F\u798A\u799D\u79A7\u9F4B\u79AA\u79AE\u79B3\u79B9\u79BA\u79C9\u79D5\u79E7\u79EC\u79E1\u79E3\u7A08\u7A0D\u7A18\u7A19\u7A20\u7A1F\u7980\u7A31\u7A3B\u7A3E\u7A37\u7A43\u7A57\u7A49\u7A61\u7A62\u7A69\u9F9D\u7A70\u7A79\u7A7D\u7A88\u7A97\u7A95\u7A98\u7A96\u7AA9\u7AC8\u7AB0\u7AB6\u7AC5\u7AC4\u7ABF\u9083\u7AC7\u7ACA\u7ACD\u7ACF\u7AD5\u7AD3\u7AD9\u7ADA\u7ADD\u7AE1\u7AE2\u7AE6\u7AED\u7AF0\u7B02\u7B0F\u7B0A\u7B06\u7B33\u7B18\u7B19\u7B1E\u7B35\u7B28\u7B36\u7B50"
    ],
    [
        "e4a1",
        "\u7B7A\u7B04\u7B4D\u7B0B\u7B4C\u7B45\u7B75\u7B65\u7B74\u7B67\u7B70\u7B71\u7B6C\u7B6E\u7B9D\u7B98\u7B9F\u7B8D\u7B9C\u7B9A\u7B8B\u7B92\u7B8F\u7B5D\u7B99\u7BCB\u7BC1\u7BCC\u7BCF\u7BB4\u7BC6\u7BDD\u7BE9\u7C11\u7C14\u7BE6\u7BE5\u7C60\u7C00\u7C07\u7C13\u7BF3\u7BF7\u7C17\u7C0D\u7BF6\u7C23\u7C27\u7C2A\u7C1F\u7C37\u7C2B\u7C3D\u7C4C\u7C43\u7C54\u7C4F\u7C40\u7C50\u7C58\u7C5F\u7C64\u7C56\u7C65\u7C6C\u7C75\u7C83\u7C90\u7CA4\u7CAD\u7CA2\u7CAB\u7CA1\u7CA8\u7CB3\u7CB2\u7CB1\u7CAE\u7CB9\u7CBD\u7CC0\u7CC5\u7CC2\u7CD8\u7CD2\u7CDC\u7CE2\u9B3B\u7CEF\u7CF2\u7CF4\u7CF6\u7CFA\u7D06"
    ],
    [
        "e5a1",
        "\u7D02\u7D1C\u7D15\u7D0A\u7D45\u7D4B\u7D2E\u7D32\u7D3F\u7D35\u7D46\u7D73\u7D56\u7D4E\u7D72\u7D68\u7D6E\u7D4F\u7D63\u7D93\u7D89\u7D5B\u7D8F\u7D7D\u7D9B\u7DBA\u7DAE\u7DA3\u7DB5\u7DC7\u7DBD\u7DAB\u7E3D\u7DA2\u7DAF\u7DDC\u7DB8\u7D9F\u7DB0\u7DD8\u7DDD\u7DE4\u7DDE\u7DFB\u7DF2\u7DE1\u7E05\u7E0A\u7E23\u7E21\u7E12\u7E31\u7E1F\u7E09\u7E0B\u7E22\u7E46\u7E66\u7E3B\u7E35\u7E39\u7E43\u7E37\u7E32\u7E3A\u7E67\u7E5D\u7E56\u7E5E\u7E59\u7E5A\u7E79\u7E6A\u7E69\u7E7C\u7E7B\u7E83\u7DD5\u7E7D\u8FAE\u7E7F\u7E88\u7E89\u7E8C\u7E92\u7E90\u7E93\u7E94\u7E96\u7E8E\u7E9B\u7E9C\u7F38\u7F3A"
    ],
    [
        "e6a1",
        "\u7F45\u7F4C\u7F4D\u7F4E\u7F50\u7F51\u7F55\u7F54\u7F58\u7F5F\u7F60\u7F68\u7F69\u7F67\u7F78\u7F82\u7F86\u7F83\u7F88\u7F87\u7F8C\u7F94\u7F9E\u7F9D\u7F9A\u7FA3\u7FAF\u7FB2\u7FB9\u7FAE\u7FB6\u7FB8\u8B71\u7FC5\u7FC6\u7FCA\u7FD5\u7FD4\u7FE1\u7FE6\u7FE9\u7FF3\u7FF9\u98DC\u8006\u8004\u800B\u8012\u8018\u8019\u801C\u8021\u8028\u803F\u803B\u804A\u8046\u8052\u8058\u805A\u805F\u8062\u8068\u8073\u8072\u8070\u8076\u8079\u807D\u807F\u8084\u8086\u8085\u809B\u8093\u809A\u80AD\u5190\u80AC\u80DB\u80E5\u80D9\u80DD\u80C4\u80DA\u80D6\u8109\u80EF\u80F1\u811B\u8129\u8123\u812F\u814B"
    ],
    [
        "e7a1",
        "\u968B\u8146\u813E\u8153\u8151\u80FC\u8171\u816E\u8165\u8166\u8174\u8183\u8188\u818A\u8180\u8182\u81A0\u8195\u81A4\u81A3\u815F\u8193\u81A9\u81B0\u81B5\u81BE\u81B8\u81BD\u81C0\u81C2\u81BA\u81C9\u81CD\u81D1\u81D9\u81D8\u81C8\u81DA\u81DF\u81E0\u81E7\u81FA\u81FB\u81FE\u8201\u8202\u8205\u8207\u820A\u820D\u8210\u8216\u8229\u822B\u8238\u8233\u8240\u8259\u8258\u825D\u825A\u825F\u8264\u8262\u8268\u826A\u826B\u822E\u8271\u8277\u8278\u827E\u828D\u8292\u82AB\u829F\u82BB\u82AC\u82E1\u82E3\u82DF\u82D2\u82F4\u82F3\u82FA\u8393\u8303\u82FB\u82F9\u82DE\u8306\u82DC\u8309\u82D9"
    ],
    [
        "e8a1",
        "\u8335\u8334\u8316\u8332\u8331\u8340\u8339\u8350\u8345\u832F\u832B\u8317\u8318\u8385\u839A\u83AA\u839F\u83A2\u8396\u8323\u838E\u8387\u838A\u837C\u83B5\u8373\u8375\u83A0\u8389\u83A8\u83F4\u8413\u83EB\u83CE\u83FD\u8403\u83D8\u840B\u83C1\u83F7\u8407\u83E0\u83F2\u840D\u8422\u8420\u83BD\u8438\u8506\u83FB\u846D\u842A\u843C\u855A\u8484\u8477\u846B\u84AD\u846E\u8482\u8469\u8446\u842C\u846F\u8479\u8435\u84CA\u8462\u84B9\u84BF\u849F\u84D9\u84CD\u84BB\u84DA\u84D0\u84C1\u84C6\u84D6\u84A1\u8521\u84FF\u84F4\u8517\u8518\u852C\u851F\u8515\u8514\u84FC\u8540\u8563\u8558\u8548"
    ],
    [
        "e9a1",
        "\u8541\u8602\u854B\u8555\u8580\u85A4\u8588\u8591\u858A\u85A8\u856D\u8594\u859B\u85EA\u8587\u859C\u8577\u857E\u8590\u85C9\u85BA\u85CF\u85B9\u85D0\u85D5\u85DD\u85E5\u85DC\u85F9\u860A\u8613\u860B\u85FE\u85FA\u8606\u8622\u861A\u8630\u863F\u864D\u4E55\u8654\u865F\u8667\u8671\u8693\u86A3\u86A9\u86AA\u868B\u868C\u86B6\u86AF\u86C4\u86C6\u86B0\u86C9\u8823\u86AB\u86D4\u86DE\u86E9\u86EC\u86DF\u86DB\u86EF\u8712\u8706\u8708\u8700\u8703\u86FB\u8711\u8709\u870D\u86F9\u870A\u8734\u873F\u8737\u873B\u8725\u8729\u871A\u8760\u875F\u8778\u874C\u874E\u8774\u8757\u8768\u876E\u8759"
    ],
    [
        "eaa1",
        "\u8753\u8763\u876A\u8805\u87A2\u879F\u8782\u87AF\u87CB\u87BD\u87C0\u87D0\u96D6\u87AB\u87C4\u87B3\u87C7\u87C6\u87BB\u87EF\u87F2\u87E0\u880F\u880D\u87FE\u87F6\u87F7\u880E\u87D2\u8811\u8816\u8815\u8822\u8821\u8831\u8836\u8839\u8827\u883B\u8844\u8842\u8852\u8859\u885E\u8862\u886B\u8881\u887E\u889E\u8875\u887D\u88B5\u8872\u8882\u8897\u8892\u88AE\u8899\u88A2\u888D\u88A4\u88B0\u88BF\u88B1\u88C3\u88C4\u88D4\u88D8\u88D9\u88DD\u88F9\u8902\u88FC\u88F4\u88E8\u88F2\u8904\u890C\u890A\u8913\u8943\u891E\u8925\u892A\u892B\u8941\u8944\u893B\u8936\u8938\u894C\u891D\u8960\u895E"
    ],
    [
        "eba1",
        "\u8966\u8964\u896D\u896A\u896F\u8974\u8977\u897E\u8983\u8988\u898A\u8993\u8998\u89A1\u89A9\u89A6\u89AC\u89AF\u89B2\u89BA\u89BD\u89BF\u89C0\u89DA\u89DC\u89DD\u89E7\u89F4\u89F8\u8A03\u8A16\u8A10\u8A0C\u8A1B\u8A1D\u8A25\u8A36\u8A41\u8A5B\u8A52\u8A46\u8A48\u8A7C\u8A6D\u8A6C\u8A62\u8A85\u8A82\u8A84\u8AA8\u8AA1\u8A91\u8AA5\u8AA6\u8A9A\u8AA3\u8AC4\u8ACD\u8AC2\u8ADA\u8AEB\u8AF3\u8AE7\u8AE4\u8AF1\u8B14\u8AE0\u8AE2\u8AF7\u8ADE\u8ADB\u8B0C\u8B07\u8B1A\u8AE1\u8B16\u8B10\u8B17\u8B20\u8B33\u97AB\u8B26\u8B2B\u8B3E\u8B28\u8B41\u8B4C\u8B4F\u8B4E\u8B49\u8B56\u8B5B\u8B5A\u8B6B"
    ],
    [
        "eca1",
        "\u8B5F\u8B6C\u8B6F\u8B74\u8B7D\u8B80\u8B8C\u8B8E\u8B92\u8B93\u8B96\u8B99\u8B9A\u8C3A\u8C41\u8C3F\u8C48\u8C4C\u8C4E\u8C50\u8C55\u8C62\u8C6C\u8C78\u8C7A\u8C82\u8C89\u8C85\u8C8A\u8C8D\u8C8E\u8C94\u8C7C\u8C98\u621D\u8CAD\u8CAA\u8CBD\u8CB2\u8CB3\u8CAE\u8CB6\u8CC8\u8CC1\u8CE4\u8CE3\u8CDA\u8CFD\u8CFA\u8CFB\u8D04\u8D05\u8D0A\u8D07\u8D0F\u8D0D\u8D10\u9F4E\u8D13\u8CCD\u8D14\u8D16\u8D67\u8D6D\u8D71\u8D73\u8D81\u8D99\u8DC2\u8DBE\u8DBA\u8DCF\u8DDA\u8DD6\u8DCC\u8DDB\u8DCB\u8DEA\u8DEB\u8DDF\u8DE3\u8DFC\u8E08\u8E09\u8DFF\u8E1D\u8E1E\u8E10\u8E1F\u8E42\u8E35\u8E30\u8E34\u8E4A"
    ],
    [
        "eda1",
        "\u8E47\u8E49\u8E4C\u8E50\u8E48\u8E59\u8E64\u8E60\u8E2A\u8E63\u8E55\u8E76\u8E72\u8E7C\u8E81\u8E87\u8E85\u8E84\u8E8B\u8E8A\u8E93\u8E91\u8E94\u8E99\u8EAA\u8EA1\u8EAC\u8EB0\u8EC6\u8EB1\u8EBE\u8EC5\u8EC8\u8ECB\u8EDB\u8EE3\u8EFC\u8EFB\u8EEB\u8EFE\u8F0A\u8F05\u8F15\u8F12\u8F19\u8F13\u8F1C\u8F1F\u8F1B\u8F0C\u8F26\u8F33\u8F3B\u8F39\u8F45\u8F42\u8F3E\u8F4C\u8F49\u8F46\u8F4E\u8F57\u8F5C\u8F62\u8F63\u8F64\u8F9C\u8F9F\u8FA3\u8FAD\u8FAF\u8FB7\u8FDA\u8FE5\u8FE2\u8FEA\u8FEF\u9087\u8FF4\u9005\u8FF9\u8FFA\u9011\u9015\u9021\u900D\u901E\u9016\u900B\u9027\u9036\u9035\u9039\u8FF8"
    ],
    [
        "eea1",
        "\u904F\u9050\u9051\u9052\u900E\u9049\u903E\u9056\u9058\u905E\u9068\u906F\u9076\u96A8\u9072\u9082\u907D\u9081\u9080\u908A\u9089\u908F\u90A8\u90AF\u90B1\u90B5\u90E2\u90E4\u6248\u90DB\u9102\u9112\u9119\u9132\u9130\u914A\u9156\u9158\u9163\u9165\u9169\u9173\u9172\u918B\u9189\u9182\u91A2\u91AB\u91AF\u91AA\u91B5\u91B4\u91BA\u91C0\u91C1\u91C9\u91CB\u91D0\u91D6\u91DF\u91E1\u91DB\u91FC\u91F5\u91F6\u921E\u91FF\u9214\u922C\u9215\u9211\u925E\u9257\u9245\u9249\u9264\u9248\u9295\u923F\u924B\u9250\u929C\u9296\u9293\u929B\u925A\u92CF\u92B9\u92B7\u92E9\u930F\u92FA\u9344\u932E"
    ],
    [
        "efa1",
        "\u9319\u9322\u931A\u9323\u933A\u9335\u933B\u935C\u9360\u937C\u936E\u9356\u93B0\u93AC\u93AD\u9394\u93B9\u93D6\u93D7\u93E8\u93E5\u93D8\u93C3\u93DD\u93D0\u93C8\u93E4\u941A\u9414\u9413\u9403\u9407\u9410\u9436\u942B\u9435\u9421\u943A\u9441\u9452\u9444\u945B\u9460\u9462\u945E\u946A\u9229\u9470\u9475\u9477\u947D\u945A\u947C\u947E\u9481\u947F\u9582\u9587\u958A\u9594\u9596\u9598\u9599\u95A0\u95A8\u95A7\u95AD\u95BC\u95BB\u95B9\u95BE\u95CA\u6FF6\u95C3\u95CD\u95CC\u95D5\u95D4\u95D6\u95DC\u95E1\u95E5\u95E2\u9621\u9628\u962E\u962F\u9642\u964C\u964F\u964B\u9677\u965C\u965E"
    ],
    [
        "f0a1",
        "\u965D\u965F\u9666\u9672\u966C\u968D\u9698\u9695\u9697\u96AA\u96A7\u96B1\u96B2\u96B0\u96B4\u96B6\u96B8\u96B9\u96CE\u96CB\u96C9\u96CD\u894D\u96DC\u970D\u96D5\u96F9\u9704\u9706\u9708\u9713\u970E\u9711\u970F\u9716\u9719\u9724\u972A\u9730\u9739\u973D\u973E\u9744\u9746\u9748\u9742\u9749\u975C\u9760\u9764\u9766\u9768\u52D2\u976B\u9771\u9779\u9785\u977C\u9781\u977A\u9786\u978B\u978F\u9790\u979C\u97A8\u97A6\u97A3\u97B3\u97B4\u97C3\u97C6\u97C8\u97CB\u97DC\u97ED\u9F4F\u97F2\u7ADF\u97F6\u97F5\u980F\u980C\u9838\u9824\u9821\u9837\u983D\u9846\u984F\u984B\u986B\u986F\u9870"
    ],
    [
        "f1a1",
        "\u9871\u9874\u9873\u98AA\u98AF\u98B1\u98B6\u98C4\u98C3\u98C6\u98E9\u98EB\u9903\u9909\u9912\u9914\u9918\u9921\u991D\u991E\u9924\u9920\u992C\u992E\u993D\u993E\u9942\u9949\u9945\u9950\u994B\u9951\u9952\u994C\u9955\u9997\u9998\u99A5\u99AD\u99AE\u99BC\u99DF\u99DB\u99DD\u99D8\u99D1\u99ED\u99EE\u99F1\u99F2\u99FB\u99F8\u9A01\u9A0F\u9A05\u99E2\u9A19\u9A2B\u9A37\u9A45\u9A42\u9A40\u9A43\u9A3E\u9A55\u9A4D\u9A5B\u9A57\u9A5F\u9A62\u9A65\u9A64\u9A69\u9A6B\u9A6A\u9AAD\u9AB0\u9ABC\u9AC0\u9ACF\u9AD1\u9AD3\u9AD4\u9ADE\u9ADF\u9AE2\u9AE3\u9AE6\u9AEF\u9AEB\u9AEE\u9AF4\u9AF1\u9AF7"
    ],
    [
        "f2a1",
        "\u9AFB\u9B06\u9B18\u9B1A\u9B1F\u9B22\u9B23\u9B25\u9B27\u9B28\u9B29\u9B2A\u9B2E\u9B2F\u9B32\u9B44\u9B43\u9B4F\u9B4D\u9B4E\u9B51\u9B58\u9B74\u9B93\u9B83\u9B91\u9B96\u9B97\u9B9F\u9BA0\u9BA8\u9BB4\u9BC0\u9BCA\u9BB9\u9BC6\u9BCF\u9BD1\u9BD2\u9BE3\u9BE2\u9BE4\u9BD4\u9BE1\u9C3A\u9BF2\u9BF1\u9BF0\u9C15\u9C14\u9C09\u9C13\u9C0C\u9C06\u9C08\u9C12\u9C0A\u9C04\u9C2E\u9C1B\u9C25\u9C24\u9C21\u9C30\u9C47\u9C32\u9C46\u9C3E\u9C5A\u9C60\u9C67\u9C76\u9C78\u9CE7\u9CEC\u9CF0\u9D09\u9D08\u9CEB\u9D03\u9D06\u9D2A\u9D26\u9DAF\u9D23\u9D1F\u9D44\u9D15\u9D12\u9D41\u9D3F\u9D3E\u9D46\u9D48"
    ],
    [
        "f3a1",
        "\u9D5D\u9D5E\u9D64\u9D51\u9D50\u9D59\u9D72\u9D89\u9D87\u9DAB\u9D6F\u9D7A\u9D9A\u9DA4\u9DA9\u9DB2\u9DC4\u9DC1\u9DBB\u9DB8\u9DBA\u9DC6\u9DCF\u9DC2\u9DD9\u9DD3\u9DF8\u9DE6\u9DED\u9DEF\u9DFD\u9E1A\u9E1B\u9E1E\u9E75\u9E79\u9E7D\u9E81\u9E88\u9E8B\u9E8C\u9E92\u9E95\u9E91\u9E9D\u9EA5\u9EA9\u9EB8\u9EAA\u9EAD\u9761\u9ECC\u9ECE\u9ECF\u9ED0\u9ED4\u9EDC\u9EDE\u9EDD\u9EE0\u9EE5\u9EE8\u9EEF\u9EF4\u9EF6\u9EF7\u9EF9\u9EFB\u9EFC\u9EFD\u9F07\u9F08\u76B7\u9F15\u9F21\u9F2C\u9F3E\u9F4A\u9F52\u9F54\u9F63\u9F5F\u9F60\u9F61\u9F66\u9F67\u9F6C\u9F6A\u9F77\u9F72\u9F76\u9F95\u9F9C\u9FA0"
    ],
    [
        "f4a1",
        "\u582F\u69C7\u9059\u7464\u51DC\u7199"
    ],
    [
        "f9a1",
        "\u7E8A\u891C\u9348\u9288\u84DC\u4FC9\u70BB\u6631\u68C8\u92F9\u66FB\u5F45\u4E28\u4EE1\u4EFC\u4F00\u4F03\u4F39\u4F56\u4F92\u4F8A\u4F9A\u4F94\u4FCD\u5040\u5022\u4FFF\u501E\u5046\u5070\u5042\u5094\u50F4\u50D8\u514A\u5164\u519D\u51BE\u51EC\u5215\u529C\u52A6\u52C0\u52DB\u5300\u5307\u5324\u5372\u5393\u53B2\u53DD\uFA0E\u549C\u548A\u54A9\u54FF\u5586\u5759\u5765\u57AC\u57C8\u57C7\uFA0F\uFA10\u589E\u58B2\u590B\u5953\u595B\u595D\u5963\u59A4\u59BA\u5B56\u5BC0\u752F\u5BD8\u5BEC\u5C1E\u5CA6\u5CBA\u5CF5\u5D27\u5D53\uFA11\u5D42\u5D6D\u5DB8\u5DB9\u5DD0\u5F21\u5F34\u5F67\u5FB7"
    ],
    [
        "faa1",
        "\u5FDE\u605D\u6085\u608A\u60DE\u60D5\u6120\u60F2\u6111\u6137\u6130\u6198\u6213\u62A6\u63F5\u6460\u649D\u64CE\u654E\u6600\u6615\u663B\u6609\u662E\u661E\u6624\u6665\u6657\u6659\uFA12\u6673\u6699\u66A0\u66B2\u66BF\u66FA\u670E\uF929\u6766\u67BB\u6852\u67C0\u6801\u6844\u68CF\uFA13\u6968\uFA14\u6998\u69E2\u6A30\u6A6B\u6A46\u6A73\u6A7E\u6AE2\u6AE4\u6BD6\u6C3F\u6C5C\u6C86\u6C6F\u6CDA\u6D04\u6D87\u6D6F\u6D96\u6DAC\u6DCF\u6DF8\u6DF2\u6DFC\u6E39\u6E5C\u6E27\u6E3C\u6EBF\u6F88\u6FB5\u6FF5\u7005\u7007\u7028\u7085\u70AB\u710F\u7104\u715C\u7146\u7147\uFA15\u71C1\u71FE\u72B1"
    ],
    [
        "fba1",
        "\u72BE\u7324\uFA16\u7377\u73BD\u73C9\u73D6\u73E3\u73D2\u7407\u73F5\u7426\u742A\u7429\u742E\u7462\u7489\u749F\u7501\u756F\u7682\u769C\u769E\u769B\u76A6\uFA17\u7746\u52AF\u7821\u784E\u7864\u787A\u7930\uFA18\uFA19\uFA1A\u7994\uFA1B\u799B\u7AD1\u7AE7\uFA1C\u7AEB\u7B9E\uFA1D\u7D48\u7D5C\u7DB7\u7DA0\u7DD6\u7E52\u7F47\u7FA1\uFA1E\u8301\u8362\u837F\u83C7\u83F6\u8448\u84B4\u8553\u8559\u856B\uFA1F\u85B0\uFA20\uFA21\u8807\u88F5\u8A12\u8A37\u8A79\u8AA7\u8ABE\u8ADF\uFA22\u8AF6\u8B53\u8B7F\u8CF0\u8CF4\u8D12\u8D76\uFA23\u8ECF\uFA24\uFA25\u9067\u90DE\uFA26\u9115\u9127\u91DA"
    ],
    [
        "fca1",
        "\u91D7\u91DE\u91ED\u91EE\u91E4\u91E5\u9206\u9210\u920A\u923A\u9240\u923C\u924E\u9259\u9251\u9239\u9267\u92A7\u9277\u9278\u92E7\u92D7\u92D9\u92D0\uFA27\u92D5\u92E0\u92D3\u9325\u9321\u92FB\uFA28\u931E\u92FF\u931D\u9302\u9370\u9357\u93A4\u93C6\u93DE\u93F8\u9431\u9445\u9448\u9592\uF9DC\uFA29\u969D\u96AF\u9733\u973B\u9743\u974D\u974F\u9751\u9755\u9857\u9865\uFA2A\uFA2B\u9927\uFA2C\u999E\u9A4E\u9AD9\u9ADC\u9B75\u9B72\u9B8F\u9BB1\u9BBB\u9C00\u9D70\u9D6B\uFA2D\u9E19\u9ED1"
    ],
    [
        "fcf1",
        "\u2170",
        9,
        "\uFFE2\uFFE4\uFF07\uFF02"
    ],
    [
        "8fa2af",
        "\u02D8\u02C7\xb8\u02D9\u02DD\xaf\u02DB\u02DA\uFF5E\u0384\u0385"
    ],
    [
        "8fa2c2",
        "\xa1\xa6\xbf"
    ],
    [
        "8fa2eb",
        "\xba\xaa\xa9\xae\u2122\xa4\u2116"
    ],
    [
        "8fa6e1",
        "\u0386\u0388\u0389\u038A\u03AA"
    ],
    [
        "8fa6e7",
        "\u038C"
    ],
    [
        "8fa6e9",
        "\u038E\u03AB"
    ],
    [
        "8fa6ec",
        "\u038F"
    ],
    [
        "8fa6f1",
        "\u03AC\u03AD\u03AE\u03AF\u03CA\u0390\u03CC\u03C2\u03CD\u03CB\u03B0\u03CE"
    ],
    [
        "8fa7c2",
        "\u0402",
        10,
        "\u040E\u040F"
    ],
    [
        "8fa7f2",
        "\u0452",
        10,
        "\u045E\u045F"
    ],
    [
        "8fa9a1",
        "\xc6\u0110"
    ],
    [
        "8fa9a4",
        "\u0126"
    ],
    [
        "8fa9a6",
        "\u0132"
    ],
    [
        "8fa9a8",
        "\u0141\u013F"
    ],
    [
        "8fa9ab",
        "\u014A\xd8\u0152"
    ],
    [
        "8fa9af",
        "\u0166\xde"
    ],
    [
        "8fa9c1",
        "\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0142\u0140\u0149\u014B\xf8\u0153\xdf\u0167\xfe"
    ],
    [
        "8faaa1",
        "\xc1\xc0\xc4\xc2\u0102\u01CD\u0100\u0104\xc5\xc3\u0106\u0108\u010C\xc7\u010A\u010E\xc9\xc8\xcb\xca\u011A\u0116\u0112\u0118"
    ],
    [
        "8faaba",
        "\u011C\u011E\u0122\u0120\u0124\xcd\xcc\xcf\xce\u01CF\u0130\u012A\u012E\u0128\u0134\u0136\u0139\u013D\u013B\u0143\u0147\u0145\xd1\xd3\xd2\xd6\xd4\u01D1\u0150\u014C\xd5\u0154\u0158\u0156\u015A\u015C\u0160\u015E\u0164\u0162\xda\xd9\xdc\xdb\u016C\u01D3\u0170\u016A\u0172\u016E\u0168\u01D7\u01DB\u01D9\u01D5\u0174\xdd\u0178\u0176\u0179\u017D\u017B"
    ],
    [
        "8faba1",
        "\xe1\xe0\xe4\xe2\u0103\u01CE\u0101\u0105\xe5\xe3\u0107\u0109\u010D\xe7\u010B\u010F\xe9\xe8\xeb\xea\u011B\u0117\u0113\u0119\u01F5\u011D\u011F"
    ],
    [
        "8fabbd",
        "\u0121\u0125\xed\xec\xef\xee\u01D0"
    ],
    [
        "8fabc5",
        "\u012B\u012F\u0129\u0135\u0137\u013A\u013E\u013C\u0144\u0148\u0146\xf1\xf3\xf2\xf6\xf4\u01D2\u0151\u014D\xf5\u0155\u0159\u0157\u015B\u015D\u0161\u015F\u0165\u0163\xfa\xf9\xfc\xfb\u016D\u01D4\u0171\u016B\u0173\u016F\u0169\u01D8\u01DC\u01DA\u01D6\u0175\xfd\xff\u0177\u017A\u017E\u017C"
    ],
    [
        "8fb0a1",
        "\u4E02\u4E04\u4E05\u4E0C\u4E12\u4E1F\u4E23\u4E24\u4E28\u4E2B\u4E2E\u4E2F\u4E30\u4E35\u4E40\u4E41\u4E44\u4E47\u4E51\u4E5A\u4E5C\u4E63\u4E68\u4E69\u4E74\u4E75\u4E79\u4E7F\u4E8D\u4E96\u4E97\u4E9D\u4EAF\u4EB9\u4EC3\u4ED0\u4EDA\u4EDB\u4EE0\u4EE1\u4EE2\u4EE8\u4EEF\u4EF1\u4EF3\u4EF5\u4EFD\u4EFE\u4EFF\u4F00\u4F02\u4F03\u4F08\u4F0B\u4F0C\u4F12\u4F15\u4F16\u4F17\u4F19\u4F2E\u4F31\u4F60\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E\u4F40\u4F42\u4F48\u4F49\u4F4B\u4F4C\u4F52\u4F54\u4F56\u4F58\u4F5F\u4F63\u4F6A\u4F6C\u4F6E\u4F71\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F7E\u4F81\u4F82\u4F84"
    ],
    [
        "8fb1a1",
        "\u4F85\u4F89\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F94\u4F97\u4F99\u4F9A\u4F9E\u4F9F\u4FB2\u4FB7\u4FB9\u4FBB\u4FBC\u4FBD\u4FBE\u4FC0\u4FC1\u4FC5\u4FC6\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FCF\u4FD2\u4FDC\u4FE0\u4FE2\u4FF0\u4FF2\u4FFC\u4FFD\u4FFF\u5000\u5001\u5004\u5007\u500A\u500C\u500E\u5010\u5013\u5017\u5018\u501B\u501C\u501D\u501E\u5022\u5027\u502E\u5030\u5032\u5033\u5035\u5040\u5041\u5042\u5045\u5046\u504A\u504C\u504E\u5051\u5052\u5053\u5057\u5059\u505F\u5060\u5062\u5063\u5066\u5067\u506A\u506D\u5070\u5071\u503B\u5081\u5083\u5084\u5086\u508A\u508E\u508F\u5090"
    ],
    [
        "8fb2a1",
        "\u5092\u5093\u5094\u5096\u509B\u509C\u509E",
        4,
        "\u50AA\u50AF\u50B0\u50B9\u50BA\u50BD\u50C0\u50C3\u50C4\u50C7\u50CC\u50CE\u50D0\u50D3\u50D4\u50D8\u50DC\u50DD\u50DF\u50E2\u50E4\u50E6\u50E8\u50E9\u50EF\u50F1\u50F6\u50FA\u50FE\u5103\u5106\u5107\u5108\u510B\u510C\u510D\u510E\u50F2\u5110\u5117\u5119\u511B\u511C\u511D\u511E\u5123\u5127\u5128\u512C\u512D\u512F\u5131\u5133\u5134\u5135\u5138\u5139\u5142\u514A\u514F\u5153\u5155\u5157\u5158\u515F\u5164\u5166\u517E\u5183\u5184\u518B\u518E\u5198\u519D\u51A1\u51A3\u51AD\u51B8\u51BA\u51BC\u51BE\u51BF\u51C2"
    ],
    [
        "8fb3a1",
        "\u51C8\u51CF\u51D1\u51D2\u51D3\u51D5\u51D8\u51DE\u51E2\u51E5\u51EE\u51F2\u51F3\u51F4\u51F7\u5201\u5202\u5205\u5212\u5213\u5215\u5216\u5218\u5222\u5228\u5231\u5232\u5235\u523C\u5245\u5249\u5255\u5257\u5258\u525A\u525C\u525F\u5260\u5261\u5266\u526E\u5277\u5278\u5279\u5280\u5282\u5285\u528A\u528C\u5293\u5295\u5296\u5297\u5298\u529A\u529C\u52A4\u52A5\u52A6\u52A7\u52AF\u52B0\u52B6\u52B7\u52B8\u52BA\u52BB\u52BD\u52C0\u52C4\u52C6\u52C8\u52CC\u52CF\u52D1\u52D4\u52D6\u52DB\u52DC\u52E1\u52E5\u52E8\u52E9\u52EA\u52EC\u52F0\u52F1\u52F4\u52F6\u52F7\u5300\u5303\u530A\u530B"
    ],
    [
        "8fb4a1",
        "\u530C\u5311\u5313\u5318\u531B\u531C\u531E\u531F\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u5330\u5332\u5335\u533C\u533D\u533E\u5342\u534C\u534B\u5359\u535B\u5361\u5363\u5365\u536C\u536D\u5372\u5379\u537E\u5383\u5387\u5388\u538E\u5393\u5394\u5399\u539D\u53A1\u53A4\u53AA\u53AB\u53AF\u53B2\u53B4\u53B5\u53B7\u53B8\u53BA\u53BD\u53C0\u53C5\u53CF\u53D2\u53D3\u53D5\u53DA\u53DD\u53DE\u53E0\u53E6\u53E7\u53F5\u5402\u5413\u541A\u5421\u5427\u5428\u542A\u542F\u5431\u5434\u5435\u5443\u5444\u5447\u544D\u544F\u545E\u5462\u5464\u5466\u5467\u5469\u546B\u546D\u546E\u5474\u547F"
    ],
    [
        "8fb5a1",
        "\u5481\u5483\u5485\u5488\u5489\u548D\u5491\u5495\u5496\u549C\u549F\u54A1\u54A6\u54A7\u54A9\u54AA\u54AD\u54AE\u54B1\u54B7\u54B9\u54BA\u54BB\u54BF\u54C6\u54CA\u54CD\u54CE\u54E0\u54EA\u54EC\u54EF\u54F6\u54FC\u54FE\u54FF\u5500\u5501\u5505\u5508\u5509\u550C\u550D\u550E\u5515\u552A\u552B\u5532\u5535\u5536\u553B\u553C\u553D\u5541\u5547\u5549\u554A\u554D\u5550\u5551\u5558\u555A\u555B\u555E\u5560\u5561\u5564\u5566\u557F\u5581\u5582\u5586\u5588\u558E\u558F\u5591\u5592\u5593\u5594\u5597\u55A3\u55A4\u55AD\u55B2\u55BF\u55C1\u55C3\u55C6\u55C9\u55CB\u55CC\u55CE\u55D1\u55D2"
    ],
    [
        "8fb6a1",
        "\u55D3\u55D7\u55D8\u55DB\u55DE\u55E2\u55E9\u55F6\u55FF\u5605\u5608\u560A\u560D",
        5,
        "\u5619\u562C\u5630\u5633\u5635\u5637\u5639\u563B\u563C\u563D\u563F\u5640\u5641\u5643\u5644\u5646\u5649\u564B\u564D\u564F\u5654\u565E\u5660\u5661\u5662\u5663\u5666\u5669\u566D\u566F\u5671\u5672\u5675\u5684\u5685\u5688\u568B\u568C\u5695\u5699\u569A\u569D\u569E\u569F\u56A6\u56A7\u56A8\u56A9\u56AB\u56AC\u56AD\u56B1\u56B3\u56B7\u56BE\u56C5\u56C9\u56CA\u56CB\u56CF\u56D0\u56CC\u56CD\u56D9\u56DC\u56DD\u56DF\u56E1\u56E4",
        4,
        "\u56F1\u56EB\u56ED"
    ],
    [
        "8fb7a1",
        "\u56F6\u56F7\u5701\u5702\u5707\u570A\u570C\u5711\u5715\u571A\u571B\u571D\u5720\u5722\u5723\u5724\u5725\u5729\u572A\u572C\u572E\u572F\u5733\u5734\u573D\u573E\u573F\u5745\u5746\u574C\u574D\u5752\u5762\u5765\u5767\u5768\u576B\u576D",
        4,
        "\u5773\u5774\u5775\u5777\u5779\u577A\u577B\u577C\u577E\u5781\u5783\u578C\u5794\u5797\u5799\u579A\u579C\u579D\u579E\u579F\u57A1\u5795\u57A7\u57A8\u57A9\u57AC\u57B8\u57BD\u57C7\u57C8\u57CC\u57CF\u57D5\u57DD\u57DE\u57E4\u57E6\u57E7\u57E9\u57ED\u57F0\u57F5\u57F6\u57F8\u57FD\u57FE\u57FF\u5803\u5804\u5808\u5809\u57E1"
    ],
    [
        "8fb8a1",
        "\u580C\u580D\u581B\u581E\u581F\u5820\u5826\u5827\u582D\u5832\u5839\u583F\u5849\u584C\u584D\u584F\u5850\u5855\u585F\u5861\u5864\u5867\u5868\u5878\u587C\u587F\u5880\u5881\u5887\u5888\u5889\u588A\u588C\u588D\u588F\u5890\u5894\u5896\u589D\u58A0\u58A1\u58A2\u58A6\u58A9\u58B1\u58B2\u58C4\u58BC\u58C2\u58C8\u58CD\u58CE\u58D0\u58D2\u58D4\u58D6\u58DA\u58DD\u58E1\u58E2\u58E9\u58F3\u5905\u5906\u590B\u590C\u5912\u5913\u5914\u8641\u591D\u5921\u5923\u5924\u5928\u592F\u5930\u5933\u5935\u5936\u593F\u5943\u5946\u5952\u5953\u5959\u595B\u595D\u595E\u595F\u5961\u5963\u596B\u596D"
    ],
    [
        "8fb9a1",
        "\u596F\u5972\u5975\u5976\u5979\u597B\u597C\u598B\u598C\u598E\u5992\u5995\u5997\u599F\u59A4\u59A7\u59AD\u59AE\u59AF\u59B0\u59B3\u59B7\u59BA\u59BC\u59C1\u59C3\u59C4\u59C8\u59CA\u59CD\u59D2\u59DD\u59DE\u59DF\u59E3\u59E4\u59E7\u59EE\u59EF\u59F1\u59F2\u59F4\u59F7\u5A00\u5A04\u5A0C\u5A0D\u5A0E\u5A12\u5A13\u5A1E\u5A23\u5A24\u5A27\u5A28\u5A2A\u5A2D\u5A30\u5A44\u5A45\u5A47\u5A48\u5A4C\u5A50\u5A55\u5A5E\u5A63\u5A65\u5A67\u5A6D\u5A77\u5A7A\u5A7B\u5A7E\u5A8B\u5A90\u5A93\u5A96\u5A99\u5A9C\u5A9E\u5A9F\u5AA0\u5AA2\u5AA7\u5AAC\u5AB1\u5AB2\u5AB3\u5AB5\u5AB8\u5ABA\u5ABB\u5ABF"
    ],
    [
        "8fbaa1",
        "\u5AC4\u5AC6\u5AC8\u5ACF\u5ADA\u5ADC\u5AE0\u5AE5\u5AEA\u5AEE\u5AF5\u5AF6\u5AFD\u5B00\u5B01\u5B08\u5B17\u5B34\u5B19\u5B1B\u5B1D\u5B21\u5B25\u5B2D\u5B38\u5B41\u5B4B\u5B4C\u5B52\u5B56\u5B5E\u5B68\u5B6E\u5B6F\u5B7C\u5B7D\u5B7E\u5B7F\u5B81\u5B84\u5B86\u5B8A\u5B8E\u5B90\u5B91\u5B93\u5B94\u5B96\u5BA8\u5BA9\u5BAC\u5BAD\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBC\u5BC0\u5BC1\u5BCD\u5BCF\u5BD6",
        4,
        "\u5BE0\u5BEF\u5BF1\u5BF4\u5BFD\u5C0C\u5C17\u5C1E\u5C1F\u5C23\u5C26\u5C29\u5C2B\u5C2C\u5C2E\u5C30\u5C32\u5C35\u5C36\u5C59\u5C5A\u5C5C\u5C62\u5C63\u5C67\u5C68\u5C69"
    ],
    [
        "8fbba1",
        "\u5C6D\u5C70\u5C74\u5C75\u5C7A\u5C7B\u5C7C\u5C7D\u5C87\u5C88\u5C8A\u5C8F\u5C92\u5C9D\u5C9F\u5CA0\u5CA2\u5CA3\u5CA6\u5CAA\u5CB2\u5CB4\u5CB5\u5CBA\u5CC9\u5CCB\u5CD2\u5CDD\u5CD7\u5CEE\u5CF1\u5CF2\u5CF4\u5D01\u5D06\u5D0D\u5D12\u5D2B\u5D23\u5D24\u5D26\u5D27\u5D31\u5D34\u5D39\u5D3D\u5D3F\u5D42\u5D43\u5D46\u5D48\u5D55\u5D51\u5D59\u5D4A\u5D5F\u5D60\u5D61\u5D62\u5D64\u5D6A\u5D6D\u5D70\u5D79\u5D7A\u5D7E\u5D7F\u5D81\u5D83\u5D88\u5D8A\u5D92\u5D93\u5D94\u5D95\u5D99\u5D9B\u5D9F\u5DA0\u5DA7\u5DAB\u5DB0\u5DB4\u5DB8\u5DB9\u5DC3\u5DC7\u5DCB\u5DD0\u5DCE\u5DD8\u5DD9\u5DE0\u5DE4"
    ],
    [
        "8fbca1",
        "\u5DE9\u5DF8\u5DF9\u5E00\u5E07\u5E0D\u5E12\u5E14\u5E15\u5E18\u5E1F\u5E20\u5E2E\u5E28\u5E32\u5E35\u5E3E\u5E4B\u5E50\u5E49\u5E51\u5E56\u5E58\u5E5B\u5E5C\u5E5E\u5E68\u5E6A",
        4,
        "\u5E70\u5E80\u5E8B\u5E8E\u5EA2\u5EA4\u5EA5\u5EA8\u5EAA\u5EAC\u5EB1\u5EB3\u5EBD\u5EBE\u5EBF\u5EC6\u5ECC\u5ECB\u5ECE\u5ED1\u5ED2\u5ED4\u5ED5\u5EDC\u5EDE\u5EE5\u5EEB\u5F02\u5F06\u5F07\u5F08\u5F0E\u5F19\u5F1C\u5F1D\u5F21\u5F22\u5F23\u5F24\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F34\u5F36\u5F3B\u5F3D\u5F3F\u5F40\u5F44\u5F45\u5F47\u5F4D\u5F50\u5F54\u5F58\u5F5B\u5F60\u5F63\u5F64\u5F67"
    ],
    [
        "8fbda1",
        "\u5F6F\u5F72\u5F74\u5F75\u5F78\u5F7A\u5F7D\u5F7E\u5F89\u5F8D\u5F8F\u5F96\u5F9C\u5F9D\u5FA2\u5FA7\u5FAB\u5FA4\u5FAC\u5FAF\u5FB0\u5FB1\u5FB8\u5FC4\u5FC7\u5FC8\u5FC9\u5FCB\u5FD0",
        4,
        "\u5FDE\u5FE1\u5FE2\u5FE8\u5FE9\u5FEA\u5FEC\u5FED\u5FEE\u5FEF\u5FF2\u5FF3\u5FF6\u5FFA\u5FFC\u6007\u600A\u600D\u6013\u6014\u6017\u6018\u601A\u601F\u6024\u602D\u6033\u6035\u6040\u6047\u6048\u6049\u604C\u6051\u6054\u6056\u6057\u605D\u6061\u6067\u6071\u607E\u607F\u6082\u6086\u6088\u608A\u608E\u6091\u6093\u6095\u6098\u609D\u609E\u60A2\u60A4\u60A5\u60A8\u60B0\u60B1\u60B7"
    ],
    [
        "8fbea1",
        "\u60BB\u60BE\u60C2\u60C4\u60C8\u60C9\u60CA\u60CB\u60CE\u60CF\u60D4\u60D5\u60D9\u60DB\u60DD\u60DE\u60E2\u60E5\u60F2\u60F5\u60F8\u60FC\u60FD\u6102\u6107\u610A\u610C\u6110",
        4,
        "\u6116\u6117\u6119\u611C\u611E\u6122\u612A\u612B\u6130\u6131\u6135\u6136\u6137\u6139\u6141\u6145\u6146\u6149\u615E\u6160\u616C\u6172\u6178\u617B\u617C\u617F\u6180\u6181\u6183\u6184\u618B\u618D\u6192\u6193\u6197\u6198\u619C\u619D\u619F\u61A0\u61A5\u61A8\u61AA\u61AD\u61B8\u61B9\u61BC\u61C0\u61C1\u61C2\u61CE\u61CF\u61D5\u61DC\u61DD\u61DE\u61DF\u61E1\u61E2\u61E7\u61E9\u61E5"
    ],
    [
        "8fbfa1",
        "\u61EC\u61ED\u61EF\u6201\u6203\u6204\u6207\u6213\u6215\u621C\u6220\u6222\u6223\u6227\u6229\u622B\u6239\u623D\u6242\u6243\u6244\u6246\u624C\u6250\u6251\u6252\u6254\u6256\u625A\u625C\u6264\u626D\u626F\u6273\u627A\u627D\u628D\u628E\u628F\u6290\u62A6\u62A8\u62B3\u62B6\u62B7\u62BA\u62BE\u62BF\u62C4\u62CE\u62D5\u62D6\u62DA\u62EA\u62F2\u62F4\u62FC\u62FD\u6303\u6304\u630A\u630B\u630D\u6310\u6313\u6316\u6318\u6329\u632A\u632D\u6335\u6336\u6339\u633C\u6341\u6342\u6343\u6344\u6346\u634A\u634B\u634E\u6352\u6353\u6354\u6358\u635B\u6365\u6366\u636C\u636D\u6371\u6374\u6375"
    ],
    [
        "8fc0a1",
        "\u6378\u637C\u637D\u637F\u6382\u6384\u6387\u638A\u6390\u6394\u6395\u6399\u639A\u639E\u63A4\u63A6\u63AD\u63AE\u63AF\u63BD\u63C1\u63C5\u63C8\u63CE\u63D1\u63D3\u63D4\u63D5\u63DC\u63E0\u63E5\u63EA\u63EC\u63F2\u63F3\u63F5\u63F8\u63F9\u6409\u640A\u6410\u6412\u6414\u6418\u641E\u6420\u6422\u6424\u6425\u6429\u642A\u642F\u6430\u6435\u643D\u643F\u644B\u644F\u6451\u6452\u6453\u6454\u645A\u645B\u645C\u645D\u645F\u6460\u6461\u6463\u646D\u6473\u6474\u647B\u647D\u6485\u6487\u648F\u6490\u6491\u6498\u6499\u649B\u649D\u649F\u64A1\u64A3\u64A6\u64A8\u64AC\u64B3\u64BD\u64BE\u64BF"
    ],
    [
        "8fc1a1",
        "\u64C4\u64C9\u64CA\u64CB\u64CC\u64CE\u64D0\u64D1\u64D5\u64D7\u64E4\u64E5\u64E9\u64EA\u64ED\u64F0\u64F5\u64F7\u64FB\u64FF\u6501\u6504\u6508\u6509\u650A\u650F\u6513\u6514\u6516\u6519\u651B\u651E\u651F\u6522\u6526\u6529\u652E\u6531\u653A\u653C\u653D\u6543\u6547\u6549\u6550\u6552\u6554\u655F\u6560\u6567\u656B\u657A\u657D\u6581\u6585\u658A\u6592\u6595\u6598\u659D\u65A0\u65A3\u65A6\u65AE\u65B2\u65B3\u65B4\u65BF\u65C2\u65C8\u65C9\u65CE\u65D0\u65D4\u65D6\u65D8\u65DF\u65F0\u65F2\u65F4\u65F5\u65F9\u65FE\u65FF\u6600\u6604\u6608\u6609\u660D\u6611\u6612\u6615\u6616\u661D"
    ],
    [
        "8fc2a1",
        "\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6631\u6633\u6639\u6637\u6640\u6645\u6646\u664A\u664C\u6651\u664E\u6657\u6658\u6659\u665B\u665C\u6660\u6661\u66FB\u666A\u666B\u666C\u667E\u6673\u6675\u667F\u6677\u6678\u6679\u667B\u6680\u667C\u668B\u668C\u668D\u6690\u6692\u6699\u669A\u669B\u669C\u669F\u66A0\u66A4\u66AD\u66B1\u66B2\u66B5\u66BB\u66BF\u66C0\u66C2\u66C3\u66C8\u66CC\u66CE\u66CF\u66D4\u66DB\u66DF\u66E8\u66EB\u66EC\u66EE\u66FA\u6705\u6707\u670E\u6713\u6719\u671C\u6720\u6722\u6733\u673E\u6745\u6747\u6748\u674C\u6754\u6755\u675D"
    ],
    [
        "8fc3a1",
        "\u6766\u676C\u676E\u6774\u6776\u677B\u6781\u6784\u678E\u678F\u6791\u6793\u6796\u6798\u6799\u679B\u67B0\u67B1\u67B2\u67B5\u67BB\u67BC\u67BD\u67F9\u67C0\u67C2\u67C3\u67C5\u67C8\u67C9\u67D2\u67D7\u67D9\u67DC\u67E1\u67E6\u67F0\u67F2\u67F6\u67F7\u6852\u6814\u6819\u681D\u681F\u6828\u6827\u682C\u682D\u682F\u6830\u6831\u6833\u683B\u683F\u6844\u6845\u684A\u684C\u6855\u6857\u6858\u685B\u686B\u686E",
        4,
        "\u6875\u6879\u687A\u687B\u687C\u6882\u6884\u6886\u6888\u6896\u6898\u689A\u689C\u68A1\u68A3\u68A5\u68A9\u68AA\u68AE\u68B2\u68BB\u68C5\u68C8\u68CC\u68CF"
    ],
    [
        "8fc4a1",
        "\u68D0\u68D1\u68D3\u68D6\u68D9\u68DC\u68DD\u68E5\u68E8\u68EA\u68EB\u68EC\u68ED\u68F0\u68F1\u68F5\u68F6\u68FB\u68FC\u68FD\u6906\u6909\u690A\u6910\u6911\u6913\u6916\u6917\u6931\u6933\u6935\u6938\u693B\u6942\u6945\u6949\u694E\u6957\u695B\u6963\u6964\u6965\u6966\u6968\u6969\u696C\u6970\u6971\u6972\u697A\u697B\u697F\u6980\u698D\u6992\u6996\u6998\u69A1\u69A5\u69A6\u69A8\u69AB\u69AD\u69AF\u69B7\u69B8\u69BA\u69BC\u69C5\u69C8\u69D1\u69D6\u69D7\u69E2\u69E5\u69EE\u69EF\u69F1\u69F3\u69F5\u69FE\u6A00\u6A01\u6A03\u6A0F\u6A11\u6A15\u6A1A\u6A1D\u6A20\u6A24\u6A28\u6A30\u6A32"
    ],
    [
        "8fc5a1",
        "\u6A34\u6A37\u6A3B\u6A3E\u6A3F\u6A45\u6A46\u6A49\u6A4A\u6A4E\u6A50\u6A51\u6A52\u6A55\u6A56\u6A5B\u6A64\u6A67\u6A6A\u6A71\u6A73\u6A7E\u6A81\u6A83\u6A86\u6A87\u6A89\u6A8B\u6A91\u6A9B\u6A9D\u6A9E\u6A9F\u6AA5\u6AAB\u6AAF\u6AB0\u6AB1\u6AB4\u6ABD\u6ABE\u6ABF\u6AC6\u6AC9\u6AC8\u6ACC\u6AD0\u6AD4\u6AD5\u6AD6\u6ADC\u6ADD\u6AE4\u6AE7\u6AEC\u6AF0\u6AF1\u6AF2\u6AFC\u6AFD\u6B02\u6B03\u6B06\u6B07\u6B09\u6B0F\u6B10\u6B11\u6B17\u6B1B\u6B1E\u6B24\u6B28\u6B2B\u6B2C\u6B2F\u6B35\u6B36\u6B3B\u6B3F\u6B46\u6B4A\u6B4D\u6B52\u6B56\u6B58\u6B5D\u6B60\u6B67\u6B6B\u6B6E\u6B70\u6B75\u6B7D"
    ],
    [
        "8fc6a1",
        "\u6B7E\u6B82\u6B85\u6B97\u6B9B\u6B9F\u6BA0\u6BA2\u6BA3\u6BA8\u6BA9\u6BAC\u6BAD\u6BAE\u6BB0\u6BB8\u6BB9\u6BBD\u6BBE\u6BC3\u6BC4\u6BC9\u6BCC\u6BD6\u6BDA\u6BE1\u6BE3\u6BE6\u6BE7\u6BEE\u6BF1\u6BF7\u6BF9\u6BFF\u6C02\u6C04\u6C05\u6C09\u6C0D\u6C0E\u6C10\u6C12\u6C19\u6C1F\u6C26\u6C27\u6C28\u6C2C\u6C2E\u6C33\u6C35\u6C36\u6C3A\u6C3B\u6C3F\u6C4A\u6C4B\u6C4D\u6C4F\u6C52\u6C54\u6C59\u6C5B\u6C5C\u6C6B\u6C6D\u6C6F\u6C74\u6C76\u6C78\u6C79\u6C7B\u6C85\u6C86\u6C87\u6C89\u6C94\u6C95\u6C97\u6C98\u6C9C\u6C9F\u6CB0\u6CB2\u6CB4\u6CC2\u6CC6\u6CCD\u6CCF\u6CD0\u6CD1\u6CD2\u6CD4\u6CD6"
    ],
    [
        "8fc7a1",
        "\u6CDA\u6CDC\u6CE0\u6CE7\u6CE9\u6CEB\u6CEC\u6CEE\u6CF2\u6CF4\u6D04\u6D07\u6D0A\u6D0E\u6D0F\u6D11\u6D13\u6D1A\u6D26\u6D27\u6D28\u6C67\u6D2E\u6D2F\u6D31\u6D39\u6D3C\u6D3F\u6D57\u6D5E\u6D5F\u6D61\u6D65\u6D67\u6D6F\u6D70\u6D7C\u6D82\u6D87\u6D91\u6D92\u6D94\u6D96\u6D97\u6D98\u6DAA\u6DAC\u6DB4\u6DB7\u6DB9\u6DBD\u6DBF\u6DC4\u6DC8\u6DCA\u6DCE\u6DCF\u6DD6\u6DDB\u6DDD\u6DDF\u6DE0\u6DE2\u6DE5\u6DE9\u6DEF\u6DF0\u6DF4\u6DF6\u6DFC\u6E00\u6E04\u6E1E\u6E22\u6E27\u6E32\u6E36\u6E39\u6E3B\u6E3C\u6E44\u6E45\u6E48\u6E49\u6E4B\u6E4F\u6E51\u6E52\u6E53\u6E54\u6E57\u6E5C\u6E5D\u6E5E"
    ],
    [
        "8fc8a1",
        "\u6E62\u6E63\u6E68\u6E73\u6E7B\u6E7D\u6E8D\u6E93\u6E99\u6EA0\u6EA7\u6EAD\u6EAE\u6EB1\u6EB3\u6EBB\u6EBF\u6EC0\u6EC1\u6EC3\u6EC7\u6EC8\u6ECA\u6ECD\u6ECE\u6ECF\u6EEB\u6EED\u6EEE\u6EF9\u6EFB\u6EFD\u6F04\u6F08\u6F0A\u6F0C\u6F0D\u6F16\u6F18\u6F1A\u6F1B\u6F26\u6F29\u6F2A\u6F2F\u6F30\u6F33\u6F36\u6F3B\u6F3C\u6F2D\u6F4F\u6F51\u6F52\u6F53\u6F57\u6F59\u6F5A\u6F5D\u6F5E\u6F61\u6F62\u6F68\u6F6C\u6F7D\u6F7E\u6F83\u6F87\u6F88\u6F8B\u6F8C\u6F8D\u6F90\u6F92\u6F93\u6F94\u6F96\u6F9A\u6F9F\u6FA0\u6FA5\u6FA6\u6FA7\u6FA8\u6FAE\u6FAF\u6FB0\u6FB5\u6FB6\u6FBC\u6FC5\u6FC7\u6FC8\u6FCA"
    ],
    [
        "8fc9a1",
        "\u6FDA\u6FDE\u6FE8\u6FE9\u6FF0\u6FF5\u6FF9\u6FFC\u6FFD\u7000\u7005\u7006\u7007\u700D\u7017\u7020\u7023\u702F\u7034\u7037\u7039\u703C\u7043\u7044\u7048\u7049\u704A\u704B\u7054\u7055\u705D\u705E\u704E\u7064\u7065\u706C\u706E\u7075\u7076\u707E\u7081\u7085\u7086\u7094",
        4,
        "\u709B\u70A4\u70AB\u70B0\u70B1\u70B4\u70B7\u70CA\u70D1\u70D3\u70D4\u70D5\u70D6\u70D8\u70DC\u70E4\u70FA\u7103",
        4,
        "\u710B\u710C\u710F\u711E\u7120\u712B\u712D\u712F\u7130\u7131\u7138\u7141\u7145\u7146\u7147\u714A\u714B\u7150\u7152\u7157\u715A\u715C\u715E\u7160"
    ],
    [
        "8fcaa1",
        "\u7168\u7179\u7180\u7185\u7187\u718C\u7192\u719A\u719B\u71A0\u71A2\u71AF\u71B0\u71B2\u71B3\u71BA\u71BF\u71C0\u71C1\u71C4\u71CB\u71CC\u71D3\u71D6\u71D9\u71DA\u71DC\u71F8\u71FE\u7200\u7207\u7208\u7209\u7213\u7217\u721A\u721D\u721F\u7224\u722B\u722F\u7234\u7238\u7239\u7241\u7242\u7243\u7245\u724E\u724F\u7250\u7253\u7255\u7256\u725A\u725C\u725E\u7260\u7263\u7268\u726B\u726E\u726F\u7271\u7277\u7278\u727B\u727C\u727F\u7284\u7289\u728D\u728E\u7293\u729B\u72A8\u72AD\u72AE\u72B1\u72B4\u72BE\u72C1\u72C7\u72C9\u72CC\u72D5\u72D6\u72D8\u72DF\u72E5\u72F3\u72F4\u72FA\u72FB"
    ],
    [
        "8fcba1",
        "\u72FE\u7302\u7304\u7305\u7307\u730B\u730D\u7312\u7313\u7318\u7319\u731E\u7322\u7324\u7327\u7328\u732C\u7331\u7332\u7335\u733A\u733B\u733D\u7343\u734D\u7350\u7352\u7356\u7358\u735D\u735E\u735F\u7360\u7366\u7367\u7369\u736B\u736C\u736E\u736F\u7371\u7377\u7379\u737C\u7380\u7381\u7383\u7385\u7386\u738E\u7390\u7393\u7395\u7397\u7398\u739C\u739E\u739F\u73A0\u73A2\u73A5\u73A6\u73AA\u73AB\u73AD\u73B5\u73B7\u73B9\u73BC\u73BD\u73BF\u73C5\u73C6\u73C9\u73CB\u73CC\u73CF\u73D2\u73D3\u73D6\u73D9\u73DD\u73E1\u73E3\u73E6\u73E7\u73E9\u73F4\u73F5\u73F7\u73F9\u73FA\u73FB\u73FD"
    ],
    [
        "8fcca1",
        "\u73FF\u7400\u7401\u7404\u7407\u740A\u7411\u741A\u741B\u7424\u7426\u7428",
        9,
        "\u7439\u7440\u7443\u7444\u7446\u7447\u744B\u744D\u7451\u7452\u7457\u745D\u7462\u7466\u7467\u7468\u746B\u746D\u746E\u7471\u7472\u7480\u7481\u7485\u7486\u7487\u7489\u748F\u7490\u7491\u7492\u7498\u7499\u749A\u749C\u749F\u74A0\u74A1\u74A3\u74A6\u74A8\u74A9\u74AA\u74AB\u74AE\u74AF\u74B1\u74B2\u74B5\u74B9\u74BB\u74BF\u74C8\u74C9\u74CC\u74D0\u74D3\u74D8\u74DA\u74DB\u74DE\u74DF\u74E4\u74E8\u74EA\u74EB\u74EF\u74F4\u74FA\u74FB\u74FC\u74FF\u7506"
    ],
    [
        "8fcda1",
        "\u7512\u7516\u7517\u7520\u7521\u7524\u7527\u7529\u752A\u752F\u7536\u7539\u753D\u753E\u753F\u7540\u7543\u7547\u7548\u754E\u7550\u7552\u7557\u755E\u755F\u7561\u756F\u7571\u7579",
        5,
        "\u7581\u7585\u7590\u7592\u7593\u7595\u7599\u759C\u75A2\u75A4\u75B4\u75BA\u75BF\u75C0\u75C1\u75C4\u75C6\u75CC\u75CE\u75CF\u75D7\u75DC\u75DF\u75E0\u75E1\u75E4\u75E7\u75EC\u75EE\u75EF\u75F1\u75F9\u7600\u7602\u7603\u7604\u7607\u7608\u760A\u760C\u760F\u7612\u7613\u7615\u7616\u7619\u761B\u761C\u761D\u761E\u7623\u7625\u7626\u7629\u762D\u7632\u7633\u7635\u7638\u7639"
    ],
    [
        "8fcea1",
        "\u763A\u763C\u764A\u7640\u7641\u7643\u7644\u7645\u7649\u764B\u7655\u7659\u765F\u7664\u7665\u766D\u766E\u766F\u7671\u7674\u7681\u7685\u768C\u768D\u7695\u769B\u769C\u769D\u769F\u76A0\u76A2",
        6,
        "\u76AA\u76AD\u76BD\u76C1\u76C5\u76C9\u76CB\u76CC\u76CE\u76D4\u76D9\u76E0\u76E6\u76E8\u76EC\u76F0\u76F1\u76F6\u76F9\u76FC\u7700\u7706\u770A\u770E\u7712\u7714\u7715\u7717\u7719\u771A\u771C\u7722\u7728\u772D\u772E\u772F\u7734\u7735\u7736\u7739\u773D\u773E\u7742\u7745\u7746\u774A\u774D\u774E\u774F\u7752\u7756\u7757\u775C\u775E\u775F\u7760\u7762"
    ],
    [
        "8fcfa1",
        "\u7764\u7767\u776A\u776C\u7770\u7772\u7773\u7774\u777A\u777D\u7780\u7784\u778C\u778D\u7794\u7795\u7796\u779A\u779F\u77A2\u77A7\u77AA\u77AE\u77AF\u77B1\u77B5\u77BE\u77C3\u77C9\u77D1\u77D2\u77D5\u77D9\u77DE\u77DF\u77E0\u77E4\u77E6\u77EA\u77EC\u77F0\u77F1\u77F4\u77F8\u77FB\u7805\u7806\u7809\u780D\u780E\u7811\u781D\u7821\u7822\u7823\u782D\u782E\u7830\u7835\u7837\u7843\u7844\u7847\u7848\u784C\u784E\u7852\u785C\u785E\u7860\u7861\u7863\u7864\u7868\u786A\u786E\u787A\u787E\u788A\u788F\u7894\u7898\u78A1\u789D\u789E\u789F\u78A4\u78A8\u78AC\u78AD\u78B0\u78B1\u78B2\u78B3"
    ],
    [
        "8fd0a1",
        "\u78BB\u78BD\u78BF\u78C7\u78C8\u78C9\u78CC\u78CE\u78D2\u78D3\u78D5\u78D6\u78E4\u78DB\u78DF\u78E0\u78E1\u78E6\u78EA\u78F2\u78F3\u7900\u78F6\u78F7\u78FA\u78FB\u78FF\u7906\u790C\u7910\u791A\u791C\u791E\u791F\u7920\u7925\u7927\u7929\u792D\u7931\u7934\u7935\u793B\u793D\u793F\u7944\u7945\u7946\u794A\u794B\u794F\u7951\u7954\u7958\u795B\u795C\u7967\u7969\u796B\u7972\u7979\u797B\u797C\u797E\u798B\u798C\u7991\u7993\u7994\u7995\u7996\u7998\u799B\u799C\u79A1\u79A8\u79A9\u79AB\u79AF\u79B1\u79B4\u79B8\u79BB\u79C2\u79C4\u79C7\u79C8\u79CA\u79CF\u79D4\u79D6\u79DA\u79DD\u79DE"
    ],
    [
        "8fd1a1",
        "\u79E0\u79E2\u79E5\u79EA\u79EB\u79ED\u79F1\u79F8\u79FC\u7A02\u7A03\u7A07\u7A09\u7A0A\u7A0C\u7A11\u7A15\u7A1B\u7A1E\u7A21\u7A27\u7A2B\u7A2D\u7A2F\u7A30\u7A34\u7A35\u7A38\u7A39\u7A3A\u7A44\u7A45\u7A47\u7A48\u7A4C\u7A55\u7A56\u7A59\u7A5C\u7A5D\u7A5F\u7A60\u7A65\u7A67\u7A6A\u7A6D\u7A75\u7A78\u7A7E\u7A80\u7A82\u7A85\u7A86\u7A8A\u7A8B\u7A90\u7A91\u7A94\u7A9E\u7AA0\u7AA3\u7AAC\u7AB3\u7AB5\u7AB9\u7ABB\u7ABC\u7AC6\u7AC9\u7ACC\u7ACE\u7AD1\u7ADB\u7AE8\u7AE9\u7AEB\u7AEC\u7AF1\u7AF4\u7AFB\u7AFD\u7AFE\u7B07\u7B14\u7B1F\u7B23\u7B27\u7B29\u7B2A\u7B2B\u7B2D\u7B2E\u7B2F\u7B30"
    ],
    [
        "8fd2a1",
        "\u7B31\u7B34\u7B3D\u7B3F\u7B40\u7B41\u7B47\u7B4E\u7B55\u7B60\u7B64\u7B66\u7B69\u7B6A\u7B6D\u7B6F\u7B72\u7B73\u7B77\u7B84\u7B89\u7B8E\u7B90\u7B91\u7B96\u7B9B\u7B9E\u7BA0\u7BA5\u7BAC\u7BAF\u7BB0\u7BB2\u7BB5\u7BB6\u7BBA\u7BBB\u7BBC\u7BBD\u7BC2\u7BC5\u7BC8\u7BCA\u7BD4\u7BD6\u7BD7\u7BD9\u7BDA\u7BDB\u7BE8\u7BEA\u7BF2\u7BF4\u7BF5\u7BF8\u7BF9\u7BFA\u7BFC\u7BFE\u7C01\u7C02\u7C03\u7C04\u7C06\u7C09\u7C0B\u7C0C\u7C0E\u7C0F\u7C19\u7C1B\u7C20\u7C25\u7C26\u7C28\u7C2C\u7C31\u7C33\u7C34\u7C36\u7C39\u7C3A\u7C46\u7C4A\u7C55\u7C51\u7C52\u7C53\u7C59",
        5
    ],
    [
        "8fd3a1",
        "\u7C61\u7C63\u7C67\u7C69\u7C6D\u7C6E\u7C70\u7C72\u7C79\u7C7C\u7C7D\u7C86\u7C87\u7C8F\u7C94\u7C9E\u7CA0\u7CA6\u7CB0\u7CB6\u7CB7\u7CBA\u7CBB\u7CBC\u7CBF\u7CC4\u7CC7\u7CC8\u7CC9\u7CCD\u7CCF\u7CD3\u7CD4\u7CD5\u7CD7\u7CD9\u7CDA\u7CDD\u7CE6\u7CE9\u7CEB\u7CF5\u7D03\u7D07\u7D08\u7D09\u7D0F\u7D11\u7D12\u7D13\u7D16\u7D1D\u7D1E\u7D23\u7D26\u7D2A\u7D2D\u7D31\u7D3C\u7D3D\u7D3E\u7D40\u7D41\u7D47\u7D48\u7D4D\u7D51\u7D53\u7D57\u7D59\u7D5A\u7D5C\u7D5D\u7D65\u7D67\u7D6A\u7D70\u7D78\u7D7A\u7D7B\u7D7F\u7D81\u7D82\u7D83\u7D85\u7D86\u7D88\u7D8B\u7D8C\u7D8D\u7D91\u7D96\u7D97\u7D9D"
    ],
    [
        "8fd4a1",
        "\u7D9E\u7DA6\u7DA7\u7DAA\u7DB3\u7DB6\u7DB7\u7DB9\u7DC2",
        4,
        "\u7DCC\u7DCD\u7DCE\u7DD7\u7DD9\u7E00\u7DE2\u7DE5\u7DE6\u7DEA\u7DEB\u7DED\u7DF1\u7DF5\u7DF6\u7DF9\u7DFA\u7E08\u7E10\u7E11\u7E15\u7E17\u7E1C\u7E1D\u7E20\u7E27\u7E28\u7E2C\u7E2D\u7E2F\u7E33\u7E36\u7E3F\u7E44\u7E45\u7E47\u7E4E\u7E50\u7E52\u7E58\u7E5F\u7E61\u7E62\u7E65\u7E6B\u7E6E\u7E6F\u7E73\u7E78\u7E7E\u7E81\u7E86\u7E87\u7E8A\u7E8D\u7E91\u7E95\u7E98\u7E9A\u7E9D\u7E9E\u7F3C\u7F3B\u7F3D\u7F3E\u7F3F\u7F43\u7F44\u7F47\u7F4F\u7F52\u7F53\u7F5B\u7F5C\u7F5D\u7F61\u7F63\u7F64\u7F65\u7F66\u7F6D"
    ],
    [
        "8fd5a1",
        "\u7F71\u7F7D\u7F7E\u7F7F\u7F80\u7F8B\u7F8D\u7F8F\u7F90\u7F91\u7F96\u7F97\u7F9C\u7FA1\u7FA2\u7FA6\u7FAA\u7FAD\u7FB4\u7FBC\u7FBF\u7FC0\u7FC3\u7FC8\u7FCE\u7FCF\u7FDB\u7FDF\u7FE3\u7FE5\u7FE8\u7FEC\u7FEE\u7FEF\u7FF2\u7FFA\u7FFD\u7FFE\u7FFF\u8007\u8008\u800A\u800D\u800E\u800F\u8011\u8013\u8014\u8016\u801D\u801E\u801F\u8020\u8024\u8026\u802C\u802E\u8030\u8034\u8035\u8037\u8039\u803A\u803C\u803E\u8040\u8044\u8060\u8064\u8066\u806D\u8071\u8075\u8081\u8088\u808E\u809C\u809E\u80A6\u80A7\u80AB\u80B8\u80B9\u80C8\u80CD\u80CF\u80D2\u80D4\u80D5\u80D7\u80D8\u80E0\u80ED\u80EE"
    ],
    [
        "8fd6a1",
        "\u80F0\u80F2\u80F3\u80F6\u80F9\u80FA\u80FE\u8103\u810B\u8116\u8117\u8118\u811C\u811E\u8120\u8124\u8127\u812C\u8130\u8135\u813A\u813C\u8145\u8147\u814A\u814C\u8152\u8157\u8160\u8161\u8167\u8168\u8169\u816D\u816F\u8177\u8181\u8190\u8184\u8185\u8186\u818B\u818E\u8196\u8198\u819B\u819E\u81A2\u81AE\u81B2\u81B4\u81BB\u81CB\u81C3\u81C5\u81CA\u81CE\u81CF\u81D5\u81D7\u81DB\u81DD\u81DE\u81E1\u81E4\u81EB\u81EC\u81F0\u81F1\u81F2\u81F5\u81F6\u81F8\u81F9\u81FD\u81FF\u8200\u8203\u820F\u8213\u8214\u8219\u821A\u821D\u8221\u8222\u8228\u8232\u8234\u823A\u8243\u8244\u8245\u8246"
    ],
    [
        "8fd7a1",
        "\u824B\u824E\u824F\u8251\u8256\u825C\u8260\u8263\u8267\u826D\u8274\u827B\u827D\u827F\u8280\u8281\u8283\u8284\u8287\u8289\u828A\u828E\u8291\u8294\u8296\u8298\u829A\u829B\u82A0\u82A1\u82A3\u82A4\u82A7\u82A8\u82A9\u82AA\u82AE\u82B0\u82B2\u82B4\u82B7\u82BA\u82BC\u82BE\u82BF\u82C6\u82D0\u82D5\u82DA\u82E0\u82E2\u82E4\u82E8\u82EA\u82ED\u82EF\u82F6\u82F7\u82FD\u82FE\u8300\u8301\u8307\u8308\u830A\u830B\u8354\u831B\u831D\u831E\u831F\u8321\u8322\u832C\u832D\u832E\u8330\u8333\u8337\u833A\u833C\u833D\u8342\u8343\u8344\u8347\u834D\u834E\u8351\u8355\u8356\u8357\u8370\u8378"
    ],
    [
        "8fd8a1",
        "\u837D\u837F\u8380\u8382\u8384\u8386\u838D\u8392\u8394\u8395\u8398\u8399\u839B\u839C\u839D\u83A6\u83A7\u83A9\u83AC\u83BE\u83BF\u83C0\u83C7\u83C9\u83CF\u83D0\u83D1\u83D4\u83DD\u8353\u83E8\u83EA\u83F6\u83F8\u83F9\u83FC\u8401\u8406\u840A\u840F\u8411\u8415\u8419\u83AD\u842F\u8439\u8445\u8447\u8448\u844A\u844D\u844F\u8451\u8452\u8456\u8458\u8459\u845A\u845C\u8460\u8464\u8465\u8467\u846A\u8470\u8473\u8474\u8476\u8478\u847C\u847D\u8481\u8485\u8492\u8493\u8495\u849E\u84A6\u84A8\u84A9\u84AA\u84AF\u84B1\u84B4\u84BA\u84BD\u84BE\u84C0\u84C2\u84C7\u84C8\u84CC\u84CF\u84D3"
    ],
    [
        "8fd9a1",
        "\u84DC\u84E7\u84EA\u84EF\u84F0\u84F1\u84F2\u84F7\u8532\u84FA\u84FB\u84FD\u8502\u8503\u8507\u850C\u850E\u8510\u851C\u851E\u8522\u8523\u8524\u8525\u8527\u852A\u852B\u852F\u8533\u8534\u8536\u853F\u8546\u854F",
        4,
        "\u8556\u8559\u855C",
        6,
        "\u8564\u856B\u856F\u8579\u857A\u857B\u857D\u857F\u8581\u8585\u8586\u8589\u858B\u858C\u858F\u8593\u8598\u859D\u859F\u85A0\u85A2\u85A5\u85A7\u85B4\u85B6\u85B7\u85B8\u85BC\u85BD\u85BE\u85BF\u85C2\u85C7\u85CA\u85CB\u85CE\u85AD\u85D8\u85DA\u85DF\u85E0\u85E6\u85E8\u85ED\u85F3\u85F6\u85FC"
    ],
    [
        "8fdaa1",
        "\u85FF\u8600\u8604\u8605\u860D\u860E\u8610\u8611\u8612\u8618\u8619\u861B\u861E\u8621\u8627\u8629\u8636\u8638\u863A\u863C\u863D\u8640\u8642\u8646\u8652\u8653\u8656\u8657\u8658\u8659\u865D\u8660",
        4,
        "\u8669\u866C\u866F\u8675\u8676\u8677\u867A\u868D\u8691\u8696\u8698\u869A\u869C\u86A1\u86A6\u86A7\u86A8\u86AD\u86B1\u86B3\u86B4\u86B5\u86B7\u86B8\u86B9\u86BF\u86C0\u86C1\u86C3\u86C5\u86D1\u86D2\u86D5\u86D7\u86DA\u86DC\u86E0\u86E3\u86E5\u86E7\u8688\u86FA\u86FC\u86FD\u8704\u8705\u8707\u870B\u870E\u870F\u8710\u8713\u8714\u8719\u871E\u871F\u8721\u8723"
    ],
    [
        "8fdba1",
        "\u8728\u872E\u872F\u8731\u8732\u8739\u873A\u873C\u873D\u873E\u8740\u8743\u8745\u874D\u8758\u875D\u8761\u8764\u8765\u876F\u8771\u8772\u877B\u8783",
        6,
        "\u878B\u878C\u8790\u8793\u8795\u8797\u8798\u8799\u879E\u87A0\u87A3\u87A7\u87AC\u87AD\u87AE\u87B1\u87B5\u87BE\u87BF\u87C1\u87C8\u87C9\u87CA\u87CE\u87D5\u87D6\u87D9\u87DA\u87DC\u87DF\u87E2\u87E3\u87E4\u87EA\u87EB\u87ED\u87F1\u87F3\u87F8\u87FA\u87FF\u8801\u8803\u8806\u8809\u880A\u880B\u8810\u8819\u8812\u8813\u8814\u8818\u881A\u881B\u881C\u881E\u881F\u8828\u882D\u882E\u8830\u8832\u8835"
    ],
    [
        "8fdca1",
        "\u883A\u883C\u8841\u8843\u8845\u8848\u8849\u884A\u884B\u884E\u8851\u8855\u8856\u8858\u885A\u885C\u885F\u8860\u8864\u8869\u8871\u8879\u887B\u8880\u8898\u889A\u889B\u889C\u889F\u88A0\u88A8\u88AA\u88BA\u88BD\u88BE\u88C0\u88CA",
        4,
        "\u88D1\u88D2\u88D3\u88DB\u88DE\u88E7\u88EF\u88F0\u88F1\u88F5\u88F7\u8901\u8906\u890D\u890E\u890F\u8915\u8916\u8918\u8919\u891A\u891C\u8920\u8926\u8927\u8928\u8930\u8931\u8932\u8935\u8939\u893A\u893E\u8940\u8942\u8945\u8946\u8949\u894F\u8952\u8957\u895A\u895B\u895C\u8961\u8962\u8963\u896B\u896E\u8970\u8973\u8975\u897A"
    ],
    [
        "8fdda1",
        "\u897B\u897C\u897D\u8989\u898D\u8990\u8994\u8995\u899B\u899C\u899F\u89A0\u89A5\u89B0\u89B4\u89B5\u89B6\u89B7\u89BC\u89D4",
        4,
        "\u89E5\u89E9\u89EB\u89ED\u89F1\u89F3\u89F6\u89F9\u89FD\u89FF\u8A04\u8A05\u8A07\u8A0F\u8A11\u8A12\u8A14\u8A15\u8A1E\u8A20\u8A22\u8A24\u8A26\u8A2B\u8A2C\u8A2F\u8A35\u8A37\u8A3D\u8A3E\u8A40\u8A43\u8A45\u8A47\u8A49\u8A4D\u8A4E\u8A53\u8A56\u8A57\u8A58\u8A5C\u8A5D\u8A61\u8A65\u8A67\u8A75\u8A76\u8A77\u8A79\u8A7A\u8A7B\u8A7E\u8A7F\u8A80\u8A83\u8A86\u8A8B\u8A8F\u8A90\u8A92\u8A96\u8A97\u8A99\u8A9F\u8AA7\u8AA9\u8AAE\u8AAF\u8AB3"
    ],
    [
        "8fdea1",
        "\u8AB6\u8AB7\u8ABB\u8ABE\u8AC3\u8AC6\u8AC8\u8AC9\u8ACA\u8AD1\u8AD3\u8AD4\u8AD5\u8AD7\u8ADD\u8ADF\u8AEC\u8AF0\u8AF4\u8AF5\u8AF6\u8AFC\u8AFF\u8B05\u8B06\u8B0B\u8B11\u8B1C\u8B1E\u8B1F\u8B0A\u8B2D\u8B30\u8B37\u8B3C\u8B42",
        4,
        "\u8B48\u8B52\u8B53\u8B54\u8B59\u8B4D\u8B5E\u8B63\u8B6D\u8B76\u8B78\u8B79\u8B7C\u8B7E\u8B81\u8B84\u8B85\u8B8B\u8B8D\u8B8F\u8B94\u8B95\u8B9C\u8B9E\u8B9F\u8C38\u8C39\u8C3D\u8C3E\u8C45\u8C47\u8C49\u8C4B\u8C4F\u8C51\u8C53\u8C54\u8C57\u8C58\u8C5B\u8C5D\u8C59\u8C63\u8C64\u8C66\u8C68\u8C69\u8C6D\u8C73\u8C75\u8C76\u8C7B\u8C7E\u8C86"
    ],
    [
        "8fdfa1",
        "\u8C87\u8C8B\u8C90\u8C92\u8C93\u8C99\u8C9B\u8C9C\u8CA4\u8CB9\u8CBA\u8CC5\u8CC6\u8CC9\u8CCB\u8CCF\u8CD6\u8CD5\u8CD9\u8CDD\u8CE1\u8CE8\u8CEC\u8CEF\u8CF0\u8CF2\u8CF5\u8CF7\u8CF8\u8CFE\u8CFF\u8D01\u8D03\u8D09\u8D12\u8D17\u8D1B\u8D65\u8D69\u8D6C\u8D6E\u8D7F\u8D82\u8D84\u8D88\u8D8D\u8D90\u8D91\u8D95\u8D9E\u8D9F\u8DA0\u8DA6\u8DAB\u8DAC\u8DAF\u8DB2\u8DB5\u8DB7\u8DB9\u8DBB\u8DC0\u8DC5\u8DC6\u8DC7\u8DC8\u8DCA\u8DCE\u8DD1\u8DD4\u8DD5\u8DD7\u8DD9\u8DE4\u8DE5\u8DE7\u8DEC\u8DF0\u8DBC\u8DF1\u8DF2\u8DF4\u8DFD\u8E01\u8E04\u8E05\u8E06\u8E0B\u8E11\u8E14\u8E16\u8E20\u8E21\u8E22"
    ],
    [
        "8fe0a1",
        "\u8E23\u8E26\u8E27\u8E31\u8E33\u8E36\u8E37\u8E38\u8E39\u8E3D\u8E40\u8E41\u8E4B\u8E4D\u8E4E\u8E4F\u8E54\u8E5B\u8E5C\u8E5D\u8E5E\u8E61\u8E62\u8E69\u8E6C\u8E6D\u8E6F\u8E70\u8E71\u8E79\u8E7A\u8E7B\u8E82\u8E83\u8E89\u8E90\u8E92\u8E95\u8E9A\u8E9B\u8E9D\u8E9E\u8EA2\u8EA7\u8EA9\u8EAD\u8EAE\u8EB3\u8EB5\u8EBA\u8EBB\u8EC0\u8EC1\u8EC3\u8EC4\u8EC7\u8ECF\u8ED1\u8ED4\u8EDC\u8EE8\u8EEE\u8EF0\u8EF1\u8EF7\u8EF9\u8EFA\u8EED\u8F00\u8F02\u8F07\u8F08\u8F0F\u8F10\u8F16\u8F17\u8F18\u8F1E\u8F20\u8F21\u8F23\u8F25\u8F27\u8F28\u8F2C\u8F2D\u8F2E\u8F34\u8F35\u8F36\u8F37\u8F3A\u8F40\u8F41"
    ],
    [
        "8fe1a1",
        "\u8F43\u8F47\u8F4F\u8F51",
        4,
        "\u8F58\u8F5D\u8F5E\u8F65\u8F9D\u8FA0\u8FA1\u8FA4\u8FA5\u8FA6\u8FB5\u8FB6\u8FB8\u8FBE\u8FC0\u8FC1\u8FC6\u8FCA\u8FCB\u8FCD\u8FD0\u8FD2\u8FD3\u8FD5\u8FE0\u8FE3\u8FE4\u8FE8\u8FEE\u8FF1\u8FF5\u8FF6\u8FFB\u8FFE\u9002\u9004\u9008\u900C\u9018\u901B\u9028\u9029\u902F\u902A\u902C\u902D\u9033\u9034\u9037\u903F\u9043\u9044\u904C\u905B\u905D\u9062\u9066\u9067\u906C\u9070\u9074\u9079\u9085\u9088\u908B\u908C\u908E\u9090\u9095\u9097\u9098\u9099\u909B\u90A0\u90A1\u90A2\u90A5\u90B0\u90B2\u90B3\u90B4\u90B6\u90BD\u90CC\u90BE\u90C3"
    ],
    [
        "8fe2a1",
        "\u90C4\u90C5\u90C7\u90C8\u90D5\u90D7\u90D8\u90D9\u90DC\u90DD\u90DF\u90E5\u90D2\u90F6\u90EB\u90EF\u90F0\u90F4\u90FE\u90FF\u9100\u9104\u9105\u9106\u9108\u910D\u9110\u9114\u9116\u9117\u9118\u911A\u911C\u911E\u9120\u9125\u9122\u9123\u9127\u9129\u912E\u912F\u9131\u9134\u9136\u9137\u9139\u913A\u913C\u913D\u9143\u9147\u9148\u914F\u9153\u9157\u9159\u915A\u915B\u9161\u9164\u9167\u916D\u9174\u9179\u917A\u917B\u9181\u9183\u9185\u9186\u918A\u918E\u9191\u9193\u9194\u9195\u9198\u919E\u91A1\u91A6\u91A8\u91AC\u91AD\u91AE\u91B0\u91B1\u91B2\u91B3\u91B6\u91BB\u91BC\u91BD\u91BF"
    ],
    [
        "8fe3a1",
        "\u91C2\u91C3\u91C5\u91D3\u91D4\u91D7\u91D9\u91DA\u91DE\u91E4\u91E5\u91E9\u91EA\u91EC",
        5,
        "\u91F7\u91F9\u91FB\u91FD\u9200\u9201\u9204\u9205\u9206\u9207\u9209\u920A\u920C\u9210\u9212\u9213\u9216\u9218\u921C\u921D\u9223\u9224\u9225\u9226\u9228\u922E\u922F\u9230\u9233\u9235\u9236\u9238\u9239\u923A\u923C\u923E\u9240\u9242\u9243\u9246\u9247\u924A\u924D\u924E\u924F\u9251\u9258\u9259\u925C\u925D\u9260\u9261\u9265\u9267\u9268\u9269\u926E\u926F\u9270\u9275",
        4,
        "\u927B\u927C\u927D\u927F\u9288\u9289\u928A\u928D\u928E\u9292\u9297"
    ],
    [
        "8fe4a1",
        "\u9299\u929F\u92A0\u92A4\u92A5\u92A7\u92A8\u92AB\u92AF\u92B2\u92B6\u92B8\u92BA\u92BB\u92BC\u92BD\u92BF",
        4,
        "\u92C5\u92C6\u92C7\u92C8\u92CB\u92CC\u92CD\u92CE\u92D0\u92D3\u92D5\u92D7\u92D8\u92D9\u92DC\u92DD\u92DF\u92E0\u92E1\u92E3\u92E5\u92E7\u92E8\u92EC\u92EE\u92F0\u92F9\u92FB\u92FF\u9300\u9302\u9308\u930D\u9311\u9314\u9315\u931C\u931D\u931E\u931F\u9321\u9324\u9325\u9327\u9329\u932A\u9333\u9334\u9336\u9337\u9347\u9348\u9349\u9350\u9351\u9352\u9355\u9357\u9358\u935A\u935E\u9364\u9365\u9367\u9369\u936A\u936D\u936F\u9370\u9371\u9373\u9374\u9376"
    ],
    [
        "8fe5a1",
        "\u937A\u937D\u937F\u9380\u9381\u9382\u9388\u938A\u938B\u938D\u938F\u9392\u9395\u9398\u939B\u939E\u93A1\u93A3\u93A4\u93A6\u93A8\u93AB\u93B4\u93B5\u93B6\u93BA\u93A9\u93C1\u93C4\u93C5\u93C6\u93C7\u93C9",
        4,
        "\u93D3\u93D9\u93DC\u93DE\u93DF\u93E2\u93E6\u93E7\u93F9\u93F7\u93F8\u93FA\u93FB\u93FD\u9401\u9402\u9404\u9408\u9409\u940D\u940E\u940F\u9415\u9416\u9417\u941F\u942E\u942F\u9431\u9432\u9433\u9434\u943B\u943F\u943D\u9443\u9445\u9448\u944A\u944C\u9455\u9459\u945C\u945F\u9461\u9463\u9468\u946B\u946D\u946E\u946F\u9471\u9472\u9484\u9483\u9578\u9579"
    ],
    [
        "8fe6a1",
        "\u957E\u9584\u9588\u958C\u958D\u958E\u959D\u959E\u959F\u95A1\u95A6\u95A9\u95AB\u95AC\u95B4\u95B6\u95BA\u95BD\u95BF\u95C6\u95C8\u95C9\u95CB\u95D0\u95D1\u95D2\u95D3\u95D9\u95DA\u95DD\u95DE\u95DF\u95E0\u95E4\u95E6\u961D\u961E\u9622\u9624\u9625\u9626\u962C\u9631\u9633\u9637\u9638\u9639\u963A\u963C\u963D\u9641\u9652\u9654\u9656\u9657\u9658\u9661\u966E\u9674\u967B\u967C\u967E\u967F\u9681\u9682\u9683\u9684\u9689\u9691\u9696\u969A\u969D\u969F\u96A4\u96A5\u96A6\u96A9\u96AE\u96AF\u96B3\u96BA\u96CA\u96D2\u5DB2\u96D8\u96DA\u96DD\u96DE\u96DF\u96E9\u96EF\u96F1\u96FA\u9702"
    ],
    [
        "8fe7a1",
        "\u9703\u9705\u9709\u971A\u971B\u971D\u9721\u9722\u9723\u9728\u9731\u9733\u9741\u9743\u974A\u974E\u974F\u9755\u9757\u9758\u975A\u975B\u9763\u9767\u976A\u976E\u9773\u9776\u9777\u9778\u977B\u977D\u977F\u9780\u9789\u9795\u9796\u9797\u9799\u979A\u979E\u979F\u97A2\u97AC\u97AE\u97B1\u97B2\u97B5\u97B6\u97B8\u97B9\u97BA\u97BC\u97BE\u97BF\u97C1\u97C4\u97C5\u97C7\u97C9\u97CA\u97CC\u97CD\u97CE\u97D0\u97D1\u97D4\u97D7\u97D8\u97D9\u97DD\u97DE\u97E0\u97DB\u97E1\u97E4\u97EF\u97F1\u97F4\u97F7\u97F8\u97FA\u9807\u980A\u9819\u980D\u980E\u9814\u9816\u981C\u981E\u9820\u9823\u9826"
    ],
    [
        "8fe8a1",
        "\u982B\u982E\u982F\u9830\u9832\u9833\u9835\u9825\u983E\u9844\u9847\u984A\u9851\u9852\u9853\u9856\u9857\u9859\u985A\u9862\u9863\u9865\u9866\u986A\u986C\u98AB\u98AD\u98AE\u98B0\u98B4\u98B7\u98B8\u98BA\u98BB\u98BF\u98C2\u98C5\u98C8\u98CC\u98E1\u98E3\u98E5\u98E6\u98E7\u98EA\u98F3\u98F6\u9902\u9907\u9908\u9911\u9915\u9916\u9917\u991A\u991B\u991C\u991F\u9922\u9926\u9927\u992B\u9931",
        4,
        "\u9939\u993A\u993B\u993C\u9940\u9941\u9946\u9947\u9948\u994D\u994E\u9954\u9958\u9959\u995B\u995C\u995E\u995F\u9960\u999B\u999D\u999F\u99A6\u99B0\u99B1\u99B2\u99B5"
    ],
    [
        "8fe9a1",
        "\u99B9\u99BA\u99BD\u99BF\u99C3\u99C9\u99D3\u99D4\u99D9\u99DA\u99DC\u99DE\u99E7\u99EA\u99EB\u99EC\u99F0\u99F4\u99F5\u99F9\u99FD\u99FE\u9A02\u9A03\u9A04\u9A0B\u9A0C\u9A10\u9A11\u9A16\u9A1E\u9A20\u9A22\u9A23\u9A24\u9A27\u9A2D\u9A2E\u9A33\u9A35\u9A36\u9A38\u9A47\u9A41\u9A44\u9A4A\u9A4B\u9A4C\u9A4E\u9A51\u9A54\u9A56\u9A5D\u9AAA\u9AAC\u9AAE\u9AAF\u9AB2\u9AB4\u9AB5\u9AB6\u9AB9\u9ABB\u9ABE\u9ABF\u9AC1\u9AC3\u9AC6\u9AC8\u9ACE\u9AD0\u9AD2\u9AD5\u9AD6\u9AD7\u9ADB\u9ADC\u9AE0\u9AE4\u9AE5\u9AE7\u9AE9\u9AEC\u9AF2\u9AF3\u9AF5\u9AF9\u9AFA\u9AFD\u9AFF",
        4
    ],
    [
        "8feaa1",
        "\u9B04\u9B05\u9B08\u9B09\u9B0B\u9B0C\u9B0D\u9B0E\u9B10\u9B12\u9B16\u9B19\u9B1B\u9B1C\u9B20\u9B26\u9B2B\u9B2D\u9B33\u9B34\u9B35\u9B37\u9B39\u9B3A\u9B3D\u9B48\u9B4B\u9B4C\u9B55\u9B56\u9B57\u9B5B\u9B5E\u9B61\u9B63\u9B65\u9B66\u9B68\u9B6A",
        4,
        "\u9B73\u9B75\u9B77\u9B78\u9B79\u9B7F\u9B80\u9B84\u9B85\u9B86\u9B87\u9B89\u9B8A\u9B8B\u9B8D\u9B8F\u9B90\u9B94\u9B9A\u9B9D\u9B9E\u9BA6\u9BA7\u9BA9\u9BAC\u9BB0\u9BB1\u9BB2\u9BB7\u9BB8\u9BBB\u9BBC\u9BBE\u9BBF\u9BC1\u9BC7\u9BC8\u9BCE\u9BD0\u9BD7\u9BD8\u9BDD\u9BDF\u9BE5\u9BE7\u9BEA\u9BEB\u9BEF\u9BF3\u9BF7\u9BF8"
    ],
    [
        "8feba1",
        "\u9BF9\u9BFA\u9BFD\u9BFF\u9C00\u9C02\u9C0B\u9C0F\u9C11\u9C16\u9C18\u9C19\u9C1A\u9C1C\u9C1E\u9C22\u9C23\u9C26",
        4,
        "\u9C31\u9C35\u9C36\u9C37\u9C3D\u9C41\u9C43\u9C44\u9C45\u9C49\u9C4A\u9C4E\u9C4F\u9C50\u9C53\u9C54\u9C56\u9C58\u9C5B\u9C5D\u9C5E\u9C5F\u9C63\u9C69\u9C6A\u9C5C\u9C6B\u9C68\u9C6E\u9C70\u9C72\u9C75\u9C77\u9C7B\u9CE6\u9CF2\u9CF7\u9CF9\u9D0B\u9D02\u9D11\u9D17\u9D18\u9D1C\u9D1D\u9D1E\u9D2F\u9D30\u9D32\u9D33\u9D34\u9D3A\u9D3C\u9D45\u9D3D\u9D42\u9D43\u9D47\u9D4A\u9D53\u9D54\u9D5F\u9D63\u9D62\u9D65\u9D69\u9D6A\u9D6B\u9D70\u9D76\u9D77\u9D7B"
    ],
    [
        "8feca1",
        "\u9D7C\u9D7E\u9D83\u9D84\u9D86\u9D8A\u9D8D\u9D8E\u9D92\u9D93\u9D95\u9D96\u9D97\u9D98\u9DA1\u9DAA\u9DAC\u9DAE\u9DB1\u9DB5\u9DB9\u9DBC\u9DBF\u9DC3\u9DC7\u9DC9\u9DCA\u9DD4\u9DD5\u9DD6\u9DD7\u9DDA\u9DDE\u9DDF\u9DE0\u9DE5\u9DE7\u9DE9\u9DEB\u9DEE\u9DF0\u9DF3\u9DF4\u9DFE\u9E0A\u9E02\u9E07\u9E0E\u9E10\u9E11\u9E12\u9E15\u9E16\u9E19\u9E1C\u9E1D\u9E7A\u9E7B\u9E7C\u9E80\u9E82\u9E83\u9E84\u9E85\u9E87\u9E8E\u9E8F\u9E96\u9E98\u9E9B\u9E9E\u9EA4\u9EA8\u9EAC\u9EAE\u9EAF\u9EB0\u9EB3\u9EB4\u9EB5\u9EC6\u9EC8\u9ECB\u9ED5\u9EDF\u9EE4\u9EE7\u9EEC\u9EED\u9EEE\u9EF0\u9EF1\u9EF2\u9EF5"
    ],
    [
        "8feda1",
        "\u9EF8\u9EFF\u9F02\u9F03\u9F09\u9F0F\u9F10\u9F11\u9F12\u9F14\u9F16\u9F17\u9F19\u9F1A\u9F1B\u9F1F\u9F22\u9F26\u9F2A\u9F2B\u9F2F\u9F31\u9F32\u9F34\u9F37\u9F39\u9F3A\u9F3C\u9F3D\u9F3F\u9F41\u9F43",
        4,
        "\u9F53\u9F55\u9F56\u9F57\u9F58\u9F5A\u9F5D\u9F5E\u9F68\u9F69\u9F6D",
        4,
        "\u9F73\u9F75\u9F7A\u9F7D\u9F8F\u9F90\u9F91\u9F92\u9F94\u9F96\u9F97\u9F9E\u9FA1\u9FA2\u9FA3\u9FA5"
    ]
];
var $07144aea14354eb9$var$eucjp$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$eucjp
});
var $07144aea14354eb9$var$cp936 = [
    [
        "0",
        "\u0000",
        127,
        "\u20AC"
    ],
    [
        "8140",
        "\u4E02\u4E04\u4E05\u4E06\u4E0F\u4E12\u4E17\u4E1F\u4E20\u4E21\u4E23\u4E26\u4E29\u4E2E\u4E2F\u4E31\u4E33\u4E35\u4E37\u4E3C\u4E40\u4E41\u4E42\u4E44\u4E46\u4E4A\u4E51\u4E55\u4E57\u4E5A\u4E5B\u4E62\u4E63\u4E64\u4E65\u4E67\u4E68\u4E6A",
        5,
        "\u4E72\u4E74",
        9,
        "\u4E7F",
        6,
        "\u4E87\u4E8A"
    ],
    [
        "8180",
        "\u4E90\u4E96\u4E97\u4E99\u4E9C\u4E9D\u4E9E\u4EA3\u4EAA\u4EAF\u4EB0\u4EB1\u4EB4\u4EB6\u4EB7\u4EB8\u4EB9\u4EBC\u4EBD\u4EBE\u4EC8\u4ECC\u4ECF\u4ED0\u4ED2\u4EDA\u4EDB\u4EDC\u4EE0\u4EE2\u4EE6\u4EE7\u4EE9\u4EED\u4EEE\u4EEF\u4EF1\u4EF4\u4EF8\u4EF9\u4EFA\u4EFC\u4EFE\u4F00\u4F02",
        6,
        "\u4F0B\u4F0C\u4F12",
        4,
        "\u4F1C\u4F1D\u4F21\u4F23\u4F28\u4F29\u4F2C\u4F2D\u4F2E\u4F31\u4F33\u4F35\u4F37\u4F39\u4F3B\u4F3E",
        4,
        "\u4F44\u4F45\u4F47",
        5,
        "\u4F52\u4F54\u4F56\u4F61\u4F62\u4F66\u4F68\u4F6A\u4F6B\u4F6D\u4F6E\u4F71\u4F72\u4F75\u4F77\u4F78\u4F79\u4F7A\u4F7D\u4F80\u4F81\u4F82\u4F85\u4F86\u4F87\u4F8A\u4F8C\u4F8E\u4F90\u4F92\u4F93\u4F95\u4F96\u4F98\u4F99\u4F9A\u4F9C\u4F9E\u4F9F\u4FA1\u4FA2"
    ],
    [
        "8240",
        "\u4FA4\u4FAB\u4FAD\u4FB0",
        4,
        "\u4FB6",
        8,
        "\u4FC0\u4FC1\u4FC2\u4FC6\u4FC7\u4FC8\u4FC9\u4FCB\u4FCC\u4FCD\u4FD2",
        4,
        "\u4FD9\u4FDB\u4FE0\u4FE2\u4FE4\u4FE5\u4FE7\u4FEB\u4FEC\u4FF0\u4FF2\u4FF4\u4FF5\u4FF6\u4FF7\u4FF9\u4FFB\u4FFC\u4FFD\u4FFF",
        11
    ],
    [
        "8280",
        "\u500B\u500E\u5010\u5011\u5013\u5015\u5016\u5017\u501B\u501D\u501E\u5020\u5022\u5023\u5024\u5027\u502B\u502F",
        10,
        "\u503B\u503D\u503F\u5040\u5041\u5042\u5044\u5045\u5046\u5049\u504A\u504B\u504D\u5050",
        4,
        "\u5056\u5057\u5058\u5059\u505B\u505D",
        7,
        "\u5066",
        5,
        "\u506D",
        8,
        "\u5078\u5079\u507A\u507C\u507D\u5081\u5082\u5083\u5084\u5086\u5087\u5089\u508A\u508B\u508C\u508E",
        20,
        "\u50A4\u50A6\u50AA\u50AB\u50AD",
        4,
        "\u50B3",
        6,
        "\u50BC"
    ],
    [
        "8340",
        "\u50BD",
        17,
        "\u50D0",
        5,
        "\u50D7\u50D8\u50D9\u50DB",
        10,
        "\u50E8\u50E9\u50EA\u50EB\u50EF\u50F0\u50F1\u50F2\u50F4\u50F6",
        4,
        "\u50FC",
        9,
        "\u5108"
    ],
    [
        "8380",
        "\u5109\u510A\u510C",
        5,
        "\u5113",
        13,
        "\u5122",
        28,
        "\u5142\u5147\u514A\u514C\u514E\u514F\u5150\u5152\u5153\u5157\u5158\u5159\u515B\u515D",
        4,
        "\u5163\u5164\u5166\u5167\u5169\u516A\u516F\u5172\u517A\u517E\u517F\u5183\u5184\u5186\u5187\u518A\u518B\u518E\u518F\u5190\u5191\u5193\u5194\u5198\u519A\u519D\u519E\u519F\u51A1\u51A3\u51A6",
        4,
        "\u51AD\u51AE\u51B4\u51B8\u51B9\u51BA\u51BE\u51BF\u51C1\u51C2\u51C3\u51C5\u51C8\u51CA\u51CD\u51CE\u51D0\u51D2",
        5
    ],
    [
        "8440",
        "\u51D8\u51D9\u51DA\u51DC\u51DE\u51DF\u51E2\u51E3\u51E5",
        5,
        "\u51EC\u51EE\u51F1\u51F2\u51F4\u51F7\u51FE\u5204\u5205\u5209\u520B\u520C\u520F\u5210\u5213\u5214\u5215\u521C\u521E\u521F\u5221\u5222\u5223\u5225\u5226\u5227\u522A\u522C\u522F\u5231\u5232\u5234\u5235\u523C\u523E\u5244",
        5,
        "\u524B\u524E\u524F\u5252\u5253\u5255\u5257\u5258"
    ],
    [
        "8480",
        "\u5259\u525A\u525B\u525D\u525F\u5260\u5262\u5263\u5264\u5266\u5268\u526B\u526C\u526D\u526E\u5270\u5271\u5273",
        9,
        "\u527E\u5280\u5283",
        4,
        "\u5289",
        6,
        "\u5291\u5292\u5294",
        6,
        "\u529C\u52A4\u52A5\u52A6\u52A7\u52AE\u52AF\u52B0\u52B4",
        9,
        "\u52C0\u52C1\u52C2\u52C4\u52C5\u52C6\u52C8\u52CA\u52CC\u52CD\u52CE\u52CF\u52D1\u52D3\u52D4\u52D5\u52D7\u52D9",
        5,
        "\u52E0\u52E1\u52E2\u52E3\u52E5",
        10,
        "\u52F1",
        7,
        "\u52FB\u52FC\u52FD\u5301\u5302\u5303\u5304\u5307\u5309\u530A\u530B\u530C\u530E"
    ],
    [
        "8540",
        "\u5311\u5312\u5313\u5314\u5318\u531B\u531C\u531E\u531F\u5322\u5324\u5325\u5327\u5328\u5329\u532B\u532C\u532D\u532F",
        9,
        "\u533C\u533D\u5340\u5342\u5344\u5346\u534B\u534C\u534D\u5350\u5354\u5358\u5359\u535B\u535D\u5365\u5368\u536A\u536C\u536D\u5372\u5376\u5379\u537B\u537C\u537D\u537E\u5380\u5381\u5383\u5387\u5388\u538A\u538E\u538F"
    ],
    [
        "8580",
        "\u5390",
        4,
        "\u5396\u5397\u5399\u539B\u539C\u539E\u53A0\u53A1\u53A4\u53A7\u53AA\u53AB\u53AC\u53AD\u53AF",
        6,
        "\u53B7\u53B8\u53B9\u53BA\u53BC\u53BD\u53BE\u53C0\u53C3",
        4,
        "\u53CE\u53CF\u53D0\u53D2\u53D3\u53D5\u53DA\u53DC\u53DD\u53DE\u53E1\u53E2\u53E7\u53F4\u53FA\u53FE\u53FF\u5400\u5402\u5405\u5407\u540B\u5414\u5418\u5419\u541A\u541C\u5422\u5424\u5425\u542A\u5430\u5433\u5436\u5437\u543A\u543D\u543F\u5441\u5442\u5444\u5445\u5447\u5449\u544C\u544D\u544E\u544F\u5451\u545A\u545D",
        4,
        "\u5463\u5465\u5467\u5469",
        7,
        "\u5474\u5479\u547A\u547E\u547F\u5481\u5483\u5485\u5487\u5488\u5489\u548A\u548D\u5491\u5493\u5497\u5498\u549C\u549E\u549F\u54A0\u54A1"
    ],
    [
        "8640",
        "\u54A2\u54A5\u54AE\u54B0\u54B2\u54B5\u54B6\u54B7\u54B9\u54BA\u54BC\u54BE\u54C3\u54C5\u54CA\u54CB\u54D6\u54D8\u54DB\u54E0",
        4,
        "\u54EB\u54EC\u54EF\u54F0\u54F1\u54F4",
        5,
        "\u54FB\u54FE\u5500\u5502\u5503\u5504\u5505\u5508\u550A",
        4,
        "\u5512\u5513\u5515",
        5,
        "\u551C\u551D\u551E\u551F\u5521\u5525\u5526"
    ],
    [
        "8680",
        "\u5528\u5529\u552B\u552D\u5532\u5534\u5535\u5536\u5538\u5539\u553A\u553B\u553D\u5540\u5542\u5545\u5547\u5548\u554B",
        4,
        "\u5551\u5552\u5553\u5554\u5557",
        4,
        "\u555D\u555E\u555F\u5560\u5562\u5563\u5568\u5569\u556B\u556F",
        5,
        "\u5579\u557A\u557D\u557F\u5585\u5586\u558C\u558D\u558E\u5590\u5592\u5593\u5595\u5596\u5597\u559A\u559B\u559E\u55A0",
        6,
        "\u55A8",
        8,
        "\u55B2\u55B4\u55B6\u55B8\u55BA\u55BC\u55BF",
        4,
        "\u55C6\u55C7\u55C8\u55CA\u55CB\u55CE\u55CF\u55D0\u55D5\u55D7",
        4,
        "\u55DE\u55E0\u55E2\u55E7\u55E9\u55ED\u55EE\u55F0\u55F1\u55F4\u55F6\u55F8",
        4,
        "\u55FF\u5602\u5603\u5604\u5605"
    ],
    [
        "8740",
        "\u5606\u5607\u560A\u560B\u560D\u5610",
        7,
        "\u5619\u561A\u561C\u561D\u5620\u5621\u5622\u5625\u5626\u5628\u5629\u562A\u562B\u562E\u562F\u5630\u5633\u5635\u5637\u5638\u563A\u563C\u563D\u563E\u5640",
        11,
        "\u564F",
        4,
        "\u5655\u5656\u565A\u565B\u565D",
        4
    ],
    [
        "8780",
        "\u5663\u5665\u5666\u5667\u566D\u566E\u566F\u5670\u5672\u5673\u5674\u5675\u5677\u5678\u5679\u567A\u567D",
        7,
        "\u5687",
        6,
        "\u5690\u5691\u5692\u5694",
        14,
        "\u56A4",
        10,
        "\u56B0",
        6,
        "\u56B8\u56B9\u56BA\u56BB\u56BD",
        12,
        "\u56CB",
        8,
        "\u56D5\u56D6\u56D8\u56D9\u56DC\u56E3\u56E5",
        5,
        "\u56EC\u56EE\u56EF\u56F2\u56F3\u56F6\u56F7\u56F8\u56FB\u56FC\u5700\u5701\u5702\u5705\u5707\u570B",
        6
    ],
    [
        "8840",
        "\u5712",
        9,
        "\u571D\u571E\u5720\u5721\u5722\u5724\u5725\u5726\u5727\u572B\u5731\u5732\u5734",
        4,
        "\u573C\u573D\u573F\u5741\u5743\u5744\u5745\u5746\u5748\u5749\u574B\u5752",
        4,
        "\u5758\u5759\u5762\u5763\u5765\u5767\u576C\u576E\u5770\u5771\u5772\u5774\u5775\u5778\u5779\u577A\u577D\u577E\u577F\u5780"
    ],
    [
        "8880",
        "\u5781\u5787\u5788\u5789\u578A\u578D",
        4,
        "\u5794",
        6,
        "\u579C\u579D\u579E\u579F\u57A5\u57A8\u57AA\u57AC\u57AF\u57B0\u57B1\u57B3\u57B5\u57B6\u57B7\u57B9",
        8,
        "\u57C4",
        6,
        "\u57CC\u57CD\u57D0\u57D1\u57D3\u57D6\u57D7\u57DB\u57DC\u57DE\u57E1\u57E2\u57E3\u57E5",
        7,
        "\u57EE\u57F0\u57F1\u57F2\u57F3\u57F5\u57F6\u57F7\u57FB\u57FC\u57FE\u57FF\u5801\u5803\u5804\u5805\u5808\u5809\u580A\u580C\u580E\u580F\u5810\u5812\u5813\u5814\u5816\u5817\u5818\u581A\u581B\u581C\u581D\u581F\u5822\u5823\u5825",
        4,
        "\u582B",
        4,
        "\u5831\u5832\u5833\u5834\u5836",
        7
    ],
    [
        "8940",
        "\u583E",
        5,
        "\u5845",
        6,
        "\u584E\u584F\u5850\u5852\u5853\u5855\u5856\u5857\u5859",
        4,
        "\u585F",
        5,
        "\u5866",
        4,
        "\u586D",
        16,
        "\u587F\u5882\u5884\u5886\u5887\u5888\u588A\u588B\u588C"
    ],
    [
        "8980",
        "\u588D",
        4,
        "\u5894",
        4,
        "\u589B\u589C\u589D\u58A0",
        7,
        "\u58AA",
        17,
        "\u58BD\u58BE\u58BF\u58C0\u58C2\u58C3\u58C4\u58C6",
        10,
        "\u58D2\u58D3\u58D4\u58D6",
        13,
        "\u58E5",
        5,
        "\u58ED\u58EF\u58F1\u58F2\u58F4\u58F5\u58F7\u58F8\u58FA",
        7,
        "\u5903\u5905\u5906\u5908",
        4,
        "\u590E\u5910\u5911\u5912\u5913\u5917\u5918\u591B\u591D\u591E\u5920\u5921\u5922\u5923\u5926\u5928\u592C\u5930\u5932\u5933\u5935\u5936\u593B"
    ],
    [
        "8a40",
        "\u593D\u593E\u593F\u5940\u5943\u5945\u5946\u594A\u594C\u594D\u5950\u5952\u5953\u5959\u595B",
        4,
        "\u5961\u5963\u5964\u5966",
        12,
        "\u5975\u5977\u597A\u597B\u597C\u597E\u597F\u5980\u5985\u5989\u598B\u598C\u598E\u598F\u5990\u5991\u5994\u5995\u5998\u599A\u599B\u599C\u599D\u599F\u59A0\u59A1\u59A2\u59A6"
    ],
    [
        "8a80",
        "\u59A7\u59AC\u59AD\u59B0\u59B1\u59B3",
        5,
        "\u59BA\u59BC\u59BD\u59BF",
        6,
        "\u59C7\u59C8\u59C9\u59CC\u59CD\u59CE\u59CF\u59D5\u59D6\u59D9\u59DB\u59DE",
        4,
        "\u59E4\u59E6\u59E7\u59E9\u59EA\u59EB\u59ED",
        11,
        "\u59FA\u59FC\u59FD\u59FE\u5A00\u5A02\u5A0A\u5A0B\u5A0D\u5A0E\u5A0F\u5A10\u5A12\u5A14\u5A15\u5A16\u5A17\u5A19\u5A1A\u5A1B\u5A1D\u5A1E\u5A21\u5A22\u5A24\u5A26\u5A27\u5A28\u5A2A",
        6,
        "\u5A33\u5A35\u5A37",
        4,
        "\u5A3D\u5A3E\u5A3F\u5A41",
        4,
        "\u5A47\u5A48\u5A4B",
        9,
        "\u5A56\u5A57\u5A58\u5A59\u5A5B",
        5
    ],
    [
        "8b40",
        "\u5A61\u5A63\u5A64\u5A65\u5A66\u5A68\u5A69\u5A6B",
        8,
        "\u5A78\u5A79\u5A7B\u5A7C\u5A7D\u5A7E\u5A80",
        17,
        "\u5A93",
        6,
        "\u5A9C",
        13,
        "\u5AAB\u5AAC"
    ],
    [
        "8b80",
        "\u5AAD",
        4,
        "\u5AB4\u5AB6\u5AB7\u5AB9",
        4,
        "\u5ABF\u5AC0\u5AC3",
        5,
        "\u5ACA\u5ACB\u5ACD",
        4,
        "\u5AD3\u5AD5\u5AD7\u5AD9\u5ADA\u5ADB\u5ADD\u5ADE\u5ADF\u5AE2\u5AE4\u5AE5\u5AE7\u5AE8\u5AEA\u5AEC",
        4,
        "\u5AF2",
        22,
        "\u5B0A",
        11,
        "\u5B18",
        25,
        "\u5B33\u5B35\u5B36\u5B38",
        7,
        "\u5B41",
        6
    ],
    [
        "8c40",
        "\u5B48",
        7,
        "\u5B52\u5B56\u5B5E\u5B60\u5B61\u5B67\u5B68\u5B6B\u5B6D\u5B6E\u5B6F\u5B72\u5B74\u5B76\u5B77\u5B78\u5B79\u5B7B\u5B7C\u5B7E\u5B7F\u5B82\u5B86\u5B8A\u5B8D\u5B8E\u5B90\u5B91\u5B92\u5B94\u5B96\u5B9F\u5BA7\u5BA8\u5BA9\u5BAC\u5BAD\u5BAE\u5BAF\u5BB1\u5BB2\u5BB7\u5BBA\u5BBB\u5BBC\u5BC0\u5BC1\u5BC3\u5BC8\u5BC9\u5BCA\u5BCB\u5BCD\u5BCE\u5BCF"
    ],
    [
        "8c80",
        "\u5BD1\u5BD4",
        8,
        "\u5BE0\u5BE2\u5BE3\u5BE6\u5BE7\u5BE9",
        4,
        "\u5BEF\u5BF1",
        6,
        "\u5BFD\u5BFE\u5C00\u5C02\u5C03\u5C05\u5C07\u5C08\u5C0B\u5C0C\u5C0D\u5C0E\u5C10\u5C12\u5C13\u5C17\u5C19\u5C1B\u5C1E\u5C1F\u5C20\u5C21\u5C23\u5C26\u5C28\u5C29\u5C2A\u5C2B\u5C2D\u5C2E\u5C2F\u5C30\u5C32\u5C33\u5C35\u5C36\u5C37\u5C43\u5C44\u5C46\u5C47\u5C4C\u5C4D\u5C52\u5C53\u5C54\u5C56\u5C57\u5C58\u5C5A\u5C5B\u5C5C\u5C5D\u5C5F\u5C62\u5C64\u5C67",
        6,
        "\u5C70\u5C72",
        6,
        "\u5C7B\u5C7C\u5C7D\u5C7E\u5C80\u5C83",
        4,
        "\u5C89\u5C8A\u5C8B\u5C8E\u5C8F\u5C92\u5C93\u5C95\u5C9D",
        4,
        "\u5CA4",
        4
    ],
    [
        "8d40",
        "\u5CAA\u5CAE\u5CAF\u5CB0\u5CB2\u5CB4\u5CB6\u5CB9\u5CBA\u5CBB\u5CBC\u5CBE\u5CC0\u5CC2\u5CC3\u5CC5",
        5,
        "\u5CCC",
        5,
        "\u5CD3",
        5,
        "\u5CDA",
        6,
        "\u5CE2\u5CE3\u5CE7\u5CE9\u5CEB\u5CEC\u5CEE\u5CEF\u5CF1",
        9,
        "\u5CFC",
        4
    ],
    [
        "8d80",
        "\u5D01\u5D04\u5D05\u5D08",
        5,
        "\u5D0F",
        4,
        "\u5D15\u5D17\u5D18\u5D19\u5D1A\u5D1C\u5D1D\u5D1F",
        4,
        "\u5D25\u5D28\u5D2A\u5D2B\u5D2C\u5D2F",
        4,
        "\u5D35",
        7,
        "\u5D3F",
        7,
        "\u5D48\u5D49\u5D4D",
        10,
        "\u5D59\u5D5A\u5D5C\u5D5E",
        10,
        "\u5D6A\u5D6D\u5D6E\u5D70\u5D71\u5D72\u5D73\u5D75",
        12,
        "\u5D83",
        21,
        "\u5D9A\u5D9B\u5D9C\u5D9E\u5D9F\u5DA0"
    ],
    [
        "8e40",
        "\u5DA1",
        21,
        "\u5DB8",
        12,
        "\u5DC6",
        6,
        "\u5DCE",
        12,
        "\u5DDC\u5DDF\u5DE0\u5DE3\u5DE4\u5DEA\u5DEC\u5DED"
    ],
    [
        "8e80",
        "\u5DF0\u5DF5\u5DF6\u5DF8",
        4,
        "\u5DFF\u5E00\u5E04\u5E07\u5E09\u5E0A\u5E0B\u5E0D\u5E0E\u5E12\u5E13\u5E17\u5E1E",
        7,
        "\u5E28",
        4,
        "\u5E2F\u5E30\u5E32",
        4,
        "\u5E39\u5E3A\u5E3E\u5E3F\u5E40\u5E41\u5E43\u5E46",
        5,
        "\u5E4D",
        6,
        "\u5E56",
        4,
        "\u5E5C\u5E5D\u5E5F\u5E60\u5E63",
        14,
        "\u5E75\u5E77\u5E79\u5E7E\u5E81\u5E82\u5E83\u5E85\u5E88\u5E89\u5E8C\u5E8D\u5E8E\u5E92\u5E98\u5E9B\u5E9D\u5EA1\u5EA2\u5EA3\u5EA4\u5EA8",
        4,
        "\u5EAE",
        4,
        "\u5EB4\u5EBA\u5EBB\u5EBC\u5EBD\u5EBF",
        6
    ],
    [
        "8f40",
        "\u5EC6\u5EC7\u5EC8\u5ECB",
        5,
        "\u5ED4\u5ED5\u5ED7\u5ED8\u5ED9\u5EDA\u5EDC",
        11,
        "\u5EE9\u5EEB",
        8,
        "\u5EF5\u5EF8\u5EF9\u5EFB\u5EFC\u5EFD\u5F05\u5F06\u5F07\u5F09\u5F0C\u5F0D\u5F0E\u5F10\u5F12\u5F14\u5F16\u5F19\u5F1A\u5F1C\u5F1D\u5F1E\u5F21\u5F22\u5F23\u5F24"
    ],
    [
        "8f80",
        "\u5F28\u5F2B\u5F2C\u5F2E\u5F30\u5F32",
        6,
        "\u5F3B\u5F3D\u5F3E\u5F3F\u5F41",
        14,
        "\u5F51\u5F54\u5F59\u5F5A\u5F5B\u5F5C\u5F5E\u5F5F\u5F60\u5F63\u5F65\u5F67\u5F68\u5F6B\u5F6E\u5F6F\u5F72\u5F74\u5F75\u5F76\u5F78\u5F7A\u5F7D\u5F7E\u5F7F\u5F83\u5F86\u5F8D\u5F8E\u5F8F\u5F91\u5F93\u5F94\u5F96\u5F9A\u5F9B\u5F9D\u5F9E\u5F9F\u5FA0\u5FA2",
        5,
        "\u5FA9\u5FAB\u5FAC\u5FAF",
        5,
        "\u5FB6\u5FB8\u5FB9\u5FBA\u5FBB\u5FBE",
        4,
        "\u5FC7\u5FC8\u5FCA\u5FCB\u5FCE\u5FD3\u5FD4\u5FD5\u5FDA\u5FDB\u5FDC\u5FDE\u5FDF\u5FE2\u5FE3\u5FE5\u5FE6\u5FE8\u5FE9\u5FEC\u5FEF\u5FF0\u5FF2\u5FF3\u5FF4\u5FF6\u5FF7\u5FF9\u5FFA\u5FFC\u6007"
    ],
    [
        "9040",
        "\u6008\u6009\u600B\u600C\u6010\u6011\u6013\u6017\u6018\u601A\u601E\u601F\u6022\u6023\u6024\u602C\u602D\u602E\u6030",
        4,
        "\u6036",
        4,
        "\u603D\u603E\u6040\u6044",
        6,
        "\u604C\u604E\u604F\u6051\u6053\u6054\u6056\u6057\u6058\u605B\u605C\u605E\u605F\u6060\u6061\u6065\u6066\u606E\u6071\u6072\u6074\u6075\u6077\u607E\u6080"
    ],
    [
        "9080",
        "\u6081\u6082\u6085\u6086\u6087\u6088\u608A\u608B\u608E\u608F\u6090\u6091\u6093\u6095\u6097\u6098\u6099\u609C\u609E\u60A1\u60A2\u60A4\u60A5\u60A7\u60A9\u60AA\u60AE\u60B0\u60B3\u60B5\u60B6\u60B7\u60B9\u60BA\u60BD",
        7,
        "\u60C7\u60C8\u60C9\u60CC",
        4,
        "\u60D2\u60D3\u60D4\u60D6\u60D7\u60D9\u60DB\u60DE\u60E1",
        4,
        "\u60EA\u60F1\u60F2\u60F5\u60F7\u60F8\u60FB",
        4,
        "\u6102\u6103\u6104\u6105\u6107\u610A\u610B\u610C\u6110",
        4,
        "\u6116\u6117\u6118\u6119\u611B\u611C\u611D\u611E\u6121\u6122\u6125\u6128\u6129\u612A\u612C",
        18,
        "\u6140",
        6
    ],
    [
        "9140",
        "\u6147\u6149\u614B\u614D\u614F\u6150\u6152\u6153\u6154\u6156",
        6,
        "\u615E\u615F\u6160\u6161\u6163\u6164\u6165\u6166\u6169",
        6,
        "\u6171\u6172\u6173\u6174\u6176\u6178",
        18,
        "\u618C\u618D\u618F",
        4,
        "\u6195"
    ],
    [
        "9180",
        "\u6196",
        6,
        "\u619E",
        8,
        "\u61AA\u61AB\u61AD",
        9,
        "\u61B8",
        5,
        "\u61BF\u61C0\u61C1\u61C3",
        4,
        "\u61C9\u61CC",
        4,
        "\u61D3\u61D5",
        16,
        "\u61E7",
        13,
        "\u61F6",
        8,
        "\u6200",
        5,
        "\u6207\u6209\u6213\u6214\u6219\u621C\u621D\u621E\u6220\u6223\u6226\u6227\u6228\u6229\u622B\u622D\u622F\u6230\u6231\u6232\u6235\u6236\u6238",
        4,
        "\u6242\u6244\u6245\u6246\u624A"
    ],
    [
        "9240",
        "\u624F\u6250\u6255\u6256\u6257\u6259\u625A\u625C",
        6,
        "\u6264\u6265\u6268\u6271\u6272\u6274\u6275\u6277\u6278\u627A\u627B\u627D\u6281\u6282\u6283\u6285\u6286\u6287\u6288\u628B",
        5,
        "\u6294\u6299\u629C\u629D\u629E\u62A3\u62A6\u62A7\u62A9\u62AA\u62AD\u62AE\u62AF\u62B0\u62B2\u62B3\u62B4\u62B6\u62B7\u62B8\u62BA\u62BE\u62C0\u62C1"
    ],
    [
        "9280",
        "\u62C3\u62CB\u62CF\u62D1\u62D5\u62DD\u62DE\u62E0\u62E1\u62E4\u62EA\u62EB\u62F0\u62F2\u62F5\u62F8\u62F9\u62FA\u62FB\u6300\u6303\u6304\u6305\u6306\u630A\u630B\u630C\u630D\u630F\u6310\u6312\u6313\u6314\u6315\u6317\u6318\u6319\u631C\u6326\u6327\u6329\u632C\u632D\u632E\u6330\u6331\u6333",
        5,
        "\u633B\u633C\u633E\u633F\u6340\u6341\u6344\u6347\u6348\u634A\u6351\u6352\u6353\u6354\u6356",
        7,
        "\u6360\u6364\u6365\u6366\u6368\u636A\u636B\u636C\u636F\u6370\u6372\u6373\u6374\u6375\u6378\u6379\u637C\u637D\u637E\u637F\u6381\u6383\u6384\u6385\u6386\u638B\u638D\u6391\u6393\u6394\u6395\u6397\u6399",
        6,
        "\u63A1\u63A4\u63A6\u63AB\u63AF\u63B1\u63B2\u63B5\u63B6\u63B9\u63BB\u63BD\u63BF\u63C0"
    ],
    [
        "9340",
        "\u63C1\u63C2\u63C3\u63C5\u63C7\u63C8\u63CA\u63CB\u63CC\u63D1\u63D3\u63D4\u63D5\u63D7",
        6,
        "\u63DF\u63E2\u63E4",
        4,
        "\u63EB\u63EC\u63EE\u63EF\u63F0\u63F1\u63F3\u63F5\u63F7\u63F9\u63FA\u63FB\u63FC\u63FE\u6403\u6404\u6406",
        4,
        "\u640D\u640E\u6411\u6412\u6415",
        5,
        "\u641D\u641F\u6422\u6423\u6424"
    ],
    [
        "9380",
        "\u6425\u6427\u6428\u6429\u642B\u642E",
        5,
        "\u6435",
        4,
        "\u643B\u643C\u643E\u6440\u6442\u6443\u6449\u644B",
        6,
        "\u6453\u6455\u6456\u6457\u6459",
        4,
        "\u645F",
        7,
        "\u6468\u646A\u646B\u646C\u646E",
        9,
        "\u647B",
        6,
        "\u6483\u6486\u6488",
        8,
        "\u6493\u6494\u6497\u6498\u649A\u649B\u649C\u649D\u649F",
        4,
        "\u64A5\u64A6\u64A7\u64A8\u64AA\u64AB\u64AF\u64B1\u64B2\u64B3\u64B4\u64B6\u64B9\u64BB\u64BD\u64BE\u64BF\u64C1\u64C3\u64C4\u64C6",
        6,
        "\u64CF\u64D1\u64D3\u64D4\u64D5\u64D6\u64D9\u64DA"
    ],
    [
        "9440",
        "\u64DB\u64DC\u64DD\u64DF\u64E0\u64E1\u64E3\u64E5\u64E7",
        24,
        "\u6501",
        7,
        "\u650A",
        7,
        "\u6513",
        4,
        "\u6519",
        8
    ],
    [
        "9480",
        "\u6522\u6523\u6524\u6526",
        4,
        "\u652C\u652D\u6530\u6531\u6532\u6533\u6537\u653A\u653C\u653D\u6540",
        4,
        "\u6546\u6547\u654A\u654B\u654D\u654E\u6550\u6552\u6553\u6554\u6557\u6558\u655A\u655C\u655F\u6560\u6561\u6564\u6565\u6567\u6568\u6569\u656A\u656D\u656E\u656F\u6571\u6573\u6575\u6576\u6578",
        14,
        "\u6588\u6589\u658A\u658D\u658E\u658F\u6592\u6594\u6595\u6596\u6598\u659A\u659D\u659E\u65A0\u65A2\u65A3\u65A6\u65A8\u65AA\u65AC\u65AE\u65B1",
        7,
        "\u65BA\u65BB\u65BE\u65BF\u65C0\u65C2\u65C7\u65C8\u65C9\u65CA\u65CD\u65D0\u65D1\u65D3\u65D4\u65D5\u65D8",
        7,
        "\u65E1\u65E3\u65E4\u65EA\u65EB"
    ],
    [
        "9540",
        "\u65F2\u65F3\u65F4\u65F5\u65F8\u65F9\u65FB",
        4,
        "\u6601\u6604\u6605\u6607\u6608\u6609\u660B\u660D\u6610\u6611\u6612\u6616\u6617\u6618\u661A\u661B\u661C\u661E\u6621\u6622\u6623\u6624\u6626\u6629\u662A\u662B\u662C\u662E\u6630\u6632\u6633\u6637",
        4,
        "\u663D\u663F\u6640\u6642\u6644",
        6,
        "\u664D\u664E\u6650\u6651\u6658"
    ],
    [
        "9580",
        "\u6659\u665B\u665C\u665D\u665E\u6660\u6662\u6663\u6665\u6667\u6669",
        4,
        "\u6671\u6672\u6673\u6675\u6678\u6679\u667B\u667C\u667D\u667F\u6680\u6681\u6683\u6685\u6686\u6688\u6689\u668A\u668B\u668D\u668E\u668F\u6690\u6692\u6693\u6694\u6695\u6698",
        4,
        "\u669E",
        8,
        "\u66A9",
        4,
        "\u66AF",
        4,
        "\u66B5\u66B6\u66B7\u66B8\u66BA\u66BB\u66BC\u66BD\u66BF",
        25,
        "\u66DA\u66DE",
        7,
        "\u66E7\u66E8\u66EA",
        5,
        "\u66F1\u66F5\u66F6\u66F8\u66FA\u66FB\u66FD\u6701\u6702\u6703"
    ],
    [
        "9640",
        "\u6704\u6705\u6706\u6707\u670C\u670E\u670F\u6711\u6712\u6713\u6716\u6718\u6719\u671A\u671C\u671E\u6720",
        5,
        "\u6727\u6729\u672E\u6730\u6732\u6733\u6736\u6737\u6738\u6739\u673B\u673C\u673E\u673F\u6741\u6744\u6745\u6747\u674A\u674B\u674D\u6752\u6754\u6755\u6757",
        4,
        "\u675D\u6762\u6763\u6764\u6766\u6767\u676B\u676C\u676E\u6771\u6774\u6776"
    ],
    [
        "9680",
        "\u6778\u6779\u677A\u677B\u677D\u6780\u6782\u6783\u6785\u6786\u6788\u678A\u678C\u678D\u678E\u678F\u6791\u6792\u6793\u6794\u6796\u6799\u679B\u679F\u67A0\u67A1\u67A4\u67A6\u67A9\u67AC\u67AE\u67B1\u67B2\u67B4\u67B9",
        7,
        "\u67C2\u67C5",
        9,
        "\u67D5\u67D6\u67D7\u67DB\u67DF\u67E1\u67E3\u67E4\u67E6\u67E7\u67E8\u67EA\u67EB\u67ED\u67EE\u67F2\u67F5",
        7,
        "\u67FE\u6801\u6802\u6803\u6804\u6806\u680D\u6810\u6812\u6814\u6815\u6818",
        4,
        "\u681E\u681F\u6820\u6822",
        6,
        "\u682B",
        6,
        "\u6834\u6835\u6836\u683A\u683B\u683F\u6847\u684B\u684D\u684F\u6852\u6856",
        5
    ],
    [
        "9740",
        "\u685C\u685D\u685E\u685F\u686A\u686C",
        7,
        "\u6875\u6878",
        8,
        "\u6882\u6884\u6887",
        7,
        "\u6890\u6891\u6892\u6894\u6895\u6896\u6898",
        9,
        "\u68A3\u68A4\u68A5\u68A9\u68AA\u68AB\u68AC\u68AE\u68B1\u68B2\u68B4\u68B6\u68B7\u68B8"
    ],
    [
        "9780",
        "\u68B9",
        6,
        "\u68C1\u68C3",
        5,
        "\u68CA\u68CC\u68CE\u68CF\u68D0\u68D1\u68D3\u68D4\u68D6\u68D7\u68D9\u68DB",
        4,
        "\u68E1\u68E2\u68E4",
        9,
        "\u68EF\u68F2\u68F3\u68F4\u68F6\u68F7\u68F8\u68FB\u68FD\u68FE\u68FF\u6900\u6902\u6903\u6904\u6906",
        4,
        "\u690C\u690F\u6911\u6913",
        11,
        "\u6921\u6922\u6923\u6925",
        7,
        "\u692E\u692F\u6931\u6932\u6933\u6935\u6936\u6937\u6938\u693A\u693B\u693C\u693E\u6940\u6941\u6943",
        16,
        "\u6955\u6956\u6958\u6959\u695B\u695C\u695F"
    ],
    [
        "9840",
        "\u6961\u6962\u6964\u6965\u6967\u6968\u6969\u696A\u696C\u696D\u696F\u6970\u6972",
        4,
        "\u697A\u697B\u697D\u697E\u697F\u6981\u6983\u6985\u698A\u698B\u698C\u698E",
        5,
        "\u6996\u6997\u6999\u699A\u699D",
        9,
        "\u69A9\u69AA\u69AC\u69AE\u69AF\u69B0\u69B2\u69B3\u69B5\u69B6\u69B8\u69B9\u69BA\u69BC\u69BD"
    ],
    [
        "9880",
        "\u69BE\u69BF\u69C0\u69C2",
        7,
        "\u69CB\u69CD\u69CF\u69D1\u69D2\u69D3\u69D5",
        5,
        "\u69DC\u69DD\u69DE\u69E1",
        11,
        "\u69EE\u69EF\u69F0\u69F1\u69F3",
        9,
        "\u69FE\u6A00",
        9,
        "\u6A0B",
        11,
        "\u6A19",
        5,
        "\u6A20\u6A22",
        5,
        "\u6A29\u6A2B\u6A2C\u6A2D\u6A2E\u6A30\u6A32\u6A33\u6A34\u6A36",
        6,
        "\u6A3F",
        4,
        "\u6A45\u6A46\u6A48",
        7,
        "\u6A51",
        6,
        "\u6A5A"
    ],
    [
        "9940",
        "\u6A5C",
        4,
        "\u6A62\u6A63\u6A64\u6A66",
        10,
        "\u6A72",
        6,
        "\u6A7A\u6A7B\u6A7D\u6A7E\u6A7F\u6A81\u6A82\u6A83\u6A85",
        8,
        "\u6A8F\u6A92",
        4,
        "\u6A98",
        7,
        "\u6AA1",
        5
    ],
    [
        "9980",
        "\u6AA7\u6AA8\u6AAA\u6AAD",
        114,
        "\u6B25\u6B26\u6B28",
        6
    ],
    [
        "9a40",
        "\u6B2F\u6B30\u6B31\u6B33\u6B34\u6B35\u6B36\u6B38\u6B3B\u6B3C\u6B3D\u6B3F\u6B40\u6B41\u6B42\u6B44\u6B45\u6B48\u6B4A\u6B4B\u6B4D",
        11,
        "\u6B5A",
        7,
        "\u6B68\u6B69\u6B6B",
        13,
        "\u6B7A\u6B7D\u6B7E\u6B7F\u6B80\u6B85\u6B88"
    ],
    [
        "9a80",
        "\u6B8C\u6B8E\u6B8F\u6B90\u6B91\u6B94\u6B95\u6B97\u6B98\u6B99\u6B9C",
        4,
        "\u6BA2",
        7,
        "\u6BAB",
        7,
        "\u6BB6\u6BB8",
        6,
        "\u6BC0\u6BC3\u6BC4\u6BC6",
        4,
        "\u6BCC\u6BCE\u6BD0\u6BD1\u6BD8\u6BDA\u6BDC",
        4,
        "\u6BE2",
        7,
        "\u6BEC\u6BED\u6BEE\u6BF0\u6BF1\u6BF2\u6BF4\u6BF6\u6BF7\u6BF8\u6BFA\u6BFB\u6BFC\u6BFE",
        6,
        "\u6C08",
        4,
        "\u6C0E\u6C12\u6C17\u6C1C\u6C1D\u6C1E\u6C20\u6C23\u6C25\u6C2B\u6C2C\u6C2D\u6C31\u6C33\u6C36\u6C37\u6C39\u6C3A\u6C3B\u6C3C\u6C3E\u6C3F\u6C43\u6C44\u6C45\u6C48\u6C4B",
        4,
        "\u6C51\u6C52\u6C53\u6C56\u6C58"
    ],
    [
        "9b40",
        "\u6C59\u6C5A\u6C62\u6C63\u6C65\u6C66\u6C67\u6C6B",
        4,
        "\u6C71\u6C73\u6C75\u6C77\u6C78\u6C7A\u6C7B\u6C7C\u6C7F\u6C80\u6C84\u6C87\u6C8A\u6C8B\u6C8D\u6C8E\u6C91\u6C92\u6C95\u6C96\u6C97\u6C98\u6C9A\u6C9C\u6C9D\u6C9E\u6CA0\u6CA2\u6CA8\u6CAC\u6CAF\u6CB0\u6CB4\u6CB5\u6CB6\u6CB7\u6CBA\u6CC0\u6CC1\u6CC2\u6CC3\u6CC6\u6CC7\u6CC8\u6CCB\u6CCD\u6CCE\u6CCF\u6CD1\u6CD2\u6CD8"
    ],
    [
        "9b80",
        "\u6CD9\u6CDA\u6CDC\u6CDD\u6CDF\u6CE4\u6CE6\u6CE7\u6CE9\u6CEC\u6CED\u6CF2\u6CF4\u6CF9\u6CFF\u6D00\u6D02\u6D03\u6D05\u6D06\u6D08\u6D09\u6D0A\u6D0D\u6D0F\u6D10\u6D11\u6D13\u6D14\u6D15\u6D16\u6D18\u6D1C\u6D1D\u6D1F",
        5,
        "\u6D26\u6D28\u6D29\u6D2C\u6D2D\u6D2F\u6D30\u6D34\u6D36\u6D37\u6D38\u6D3A\u6D3F\u6D40\u6D42\u6D44\u6D49\u6D4C\u6D50\u6D55\u6D56\u6D57\u6D58\u6D5B\u6D5D\u6D5F\u6D61\u6D62\u6D64\u6D65\u6D67\u6D68\u6D6B\u6D6C\u6D6D\u6D70\u6D71\u6D72\u6D73\u6D75\u6D76\u6D79\u6D7A\u6D7B\u6D7D",
        4,
        "\u6D83\u6D84\u6D86\u6D87\u6D8A\u6D8B\u6D8D\u6D8F\u6D90\u6D92\u6D96",
        4,
        "\u6D9C\u6DA2\u6DA5\u6DAC\u6DAD\u6DB0\u6DB1\u6DB3\u6DB4\u6DB6\u6DB7\u6DB9",
        5,
        "\u6DC1\u6DC2\u6DC3\u6DC8\u6DC9\u6DCA"
    ],
    [
        "9c40",
        "\u6DCD\u6DCE\u6DCF\u6DD0\u6DD2\u6DD3\u6DD4\u6DD5\u6DD7\u6DDA\u6DDB\u6DDC\u6DDF\u6DE2\u6DE3\u6DE5\u6DE7\u6DE8\u6DE9\u6DEA\u6DED\u6DEF\u6DF0\u6DF2\u6DF4\u6DF5\u6DF6\u6DF8\u6DFA\u6DFD",
        7,
        "\u6E06\u6E07\u6E08\u6E09\u6E0B\u6E0F\u6E12\u6E13\u6E15\u6E18\u6E19\u6E1B\u6E1C\u6E1E\u6E1F\u6E22\u6E26\u6E27\u6E28\u6E2A\u6E2C\u6E2E\u6E30\u6E31\u6E33\u6E35"
    ],
    [
        "9c80",
        "\u6E36\u6E37\u6E39\u6E3B",
        7,
        "\u6E45",
        7,
        "\u6E4F\u6E50\u6E51\u6E52\u6E55\u6E57\u6E59\u6E5A\u6E5C\u6E5D\u6E5E\u6E60",
        10,
        "\u6E6C\u6E6D\u6E6F",
        14,
        "\u6E80\u6E81\u6E82\u6E84\u6E87\u6E88\u6E8A",
        4,
        "\u6E91",
        6,
        "\u6E99\u6E9A\u6E9B\u6E9D\u6E9E\u6EA0\u6EA1\u6EA3\u6EA4\u6EA6\u6EA8\u6EA9\u6EAB\u6EAC\u6EAD\u6EAE\u6EB0\u6EB3\u6EB5\u6EB8\u6EB9\u6EBC\u6EBE\u6EBF\u6EC0\u6EC3\u6EC4\u6EC5\u6EC6\u6EC8\u6EC9\u6ECA\u6ECC\u6ECD\u6ECE\u6ED0\u6ED2\u6ED6\u6ED8\u6ED9\u6EDB\u6EDC\u6EDD\u6EE3\u6EE7\u6EEA",
        5
    ],
    [
        "9d40",
        "\u6EF0\u6EF1\u6EF2\u6EF3\u6EF5\u6EF6\u6EF7\u6EF8\u6EFA",
        7,
        "\u6F03\u6F04\u6F05\u6F07\u6F08\u6F0A",
        4,
        "\u6F10\u6F11\u6F12\u6F16",
        9,
        "\u6F21\u6F22\u6F23\u6F25\u6F26\u6F27\u6F28\u6F2C\u6F2E\u6F30\u6F32\u6F34\u6F35\u6F37",
        6,
        "\u6F3F\u6F40\u6F41\u6F42"
    ],
    [
        "9d80",
        "\u6F43\u6F44\u6F45\u6F48\u6F49\u6F4A\u6F4C\u6F4E",
        9,
        "\u6F59\u6F5A\u6F5B\u6F5D\u6F5F\u6F60\u6F61\u6F63\u6F64\u6F65\u6F67",
        5,
        "\u6F6F\u6F70\u6F71\u6F73\u6F75\u6F76\u6F77\u6F79\u6F7B\u6F7D",
        6,
        "\u6F85\u6F86\u6F87\u6F8A\u6F8B\u6F8F",
        12,
        "\u6F9D\u6F9E\u6F9F\u6FA0\u6FA2",
        4,
        "\u6FA8",
        10,
        "\u6FB4\u6FB5\u6FB7\u6FB8\u6FBA",
        5,
        "\u6FC1\u6FC3",
        5,
        "\u6FCA",
        6,
        "\u6FD3",
        10,
        "\u6FDF\u6FE2\u6FE3\u6FE4\u6FE5"
    ],
    [
        "9e40",
        "\u6FE6",
        7,
        "\u6FF0",
        32,
        "\u7012",
        7,
        "\u701C",
        6,
        "\u7024",
        6
    ],
    [
        "9e80",
        "\u702B",
        9,
        "\u7036\u7037\u7038\u703A",
        17,
        "\u704D\u704E\u7050",
        13,
        "\u705F",
        11,
        "\u706E\u7071\u7072\u7073\u7074\u7077\u7079\u707A\u707B\u707D\u7081\u7082\u7083\u7084\u7086\u7087\u7088\u708B\u708C\u708D\u708F\u7090\u7091\u7093\u7097\u7098\u709A\u709B\u709E",
        12,
        "\u70B0\u70B2\u70B4\u70B5\u70B6\u70BA\u70BE\u70BF\u70C4\u70C5\u70C6\u70C7\u70C9\u70CB",
        12,
        "\u70DA"
    ],
    [
        "9f40",
        "\u70DC\u70DD\u70DE\u70E0\u70E1\u70E2\u70E3\u70E5\u70EA\u70EE\u70F0",
        6,
        "\u70F8\u70FA\u70FB\u70FC\u70FE",
        10,
        "\u710B",
        4,
        "\u7111\u7112\u7114\u7117\u711B",
        10,
        "\u7127",
        7,
        "\u7132\u7133\u7134"
    ],
    [
        "9f80",
        "\u7135\u7137",
        13,
        "\u7146\u7147\u7148\u7149\u714B\u714D\u714F",
        12,
        "\u715D\u715F",
        4,
        "\u7165\u7169",
        4,
        "\u716F\u7170\u7171\u7174\u7175\u7176\u7177\u7179\u717B\u717C\u717E",
        5,
        "\u7185",
        4,
        "\u718B\u718C\u718D\u718E\u7190\u7191\u7192\u7193\u7195\u7196\u7197\u719A",
        4,
        "\u71A1",
        6,
        "\u71A9\u71AA\u71AB\u71AD",
        5,
        "\u71B4\u71B6\u71B7\u71B8\u71BA",
        8,
        "\u71C4",
        9,
        "\u71CF",
        4
    ],
    [
        "a040",
        "\u71D6",
        9,
        "\u71E1\u71E2\u71E3\u71E4\u71E6\u71E8",
        5,
        "\u71EF",
        9,
        "\u71FA",
        11,
        "\u7207",
        19
    ],
    [
        "a080",
        "\u721B\u721C\u721E",
        9,
        "\u7229\u722B\u722D\u722E\u722F\u7232\u7233\u7234\u723A\u723C\u723E\u7240",
        6,
        "\u7249\u724A\u724B\u724E\u724F\u7250\u7251\u7253\u7254\u7255\u7257\u7258\u725A\u725C\u725E\u7260\u7263\u7264\u7265\u7268\u726A\u726B\u726C\u726D\u7270\u7271\u7273\u7274\u7276\u7277\u7278\u727B\u727C\u727D\u7282\u7283\u7285",
        4,
        "\u728C\u728E\u7290\u7291\u7293",
        11,
        "\u72A0",
        11,
        "\u72AE\u72B1\u72B2\u72B3\u72B5\u72BA",
        6,
        "\u72C5\u72C6\u72C7\u72C9\u72CA\u72CB\u72CC\u72CF\u72D1\u72D3\u72D4\u72D5\u72D6\u72D8\u72DA\u72DB"
    ],
    [
        "a1a1",
        "\u3000\u3001\u3002\xb7\u02C9\u02C7\xa8\u3003\u3005\u2014\uFF5E\u2016\u2026\u2018\u2019\u201C\u201D\u3014\u3015\u3008",
        7,
        "\u3016\u3017\u3010\u3011\xb1\xd7\xf7\u2236\u2227\u2228\u2211\u220F\u222A\u2229\u2208\u2237\u221A\u22A5\u2225\u2220\u2312\u2299\u222B\u222E\u2261\u224C\u2248\u223D\u221D\u2260\u226E\u226F\u2264\u2265\u221E\u2235\u2234\u2642\u2640\xb0\u2032\u2033\u2103\uFF04\xa4\uFFE0\uFFE1\u2030\xa7\u2116\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u203B\u2192\u2190\u2191\u2193\u3013"
    ],
    [
        "a2a1",
        "\u2170",
        9
    ],
    [
        "a2b1",
        "\u2488",
        19,
        "\u2474",
        19,
        "\u2460",
        9
    ],
    [
        "a2e5",
        "\u3220",
        9
    ],
    [
        "a2f1",
        "\u2160",
        11
    ],
    [
        "a3a1",
        "\uFF01\uFF02\uFF03\uFFE5\uFF05",
        88,
        "\uFFE3"
    ],
    [
        "a4a1",
        "\u3041",
        82
    ],
    [
        "a5a1",
        "\u30A1",
        85
    ],
    [
        "a6a1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a6c1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a6e0",
        "\uFE35\uFE36\uFE39\uFE3A\uFE3F\uFE40\uFE3D\uFE3E\uFE41\uFE42\uFE43\uFE44"
    ],
    [
        "a6ee",
        "\uFE3B\uFE3C\uFE37\uFE38\uFE31"
    ],
    [
        "a6f4",
        "\uFE33\uFE34"
    ],
    [
        "a7a1",
        "\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "a7d1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "a840",
        "\u02CA\u02CB\u02D9\u2013\u2015\u2025\u2035\u2105\u2109\u2196\u2197\u2198\u2199\u2215\u221F\u2223\u2252\u2266\u2267\u22BF\u2550",
        35,
        "\u2581",
        6
    ],
    [
        "a880",
        "\u2588",
        7,
        "\u2593\u2594\u2595\u25BC\u25BD\u25E2\u25E3\u25E4\u25E5\u2609\u2295\u3012\u301D\u301E"
    ],
    [
        "a8a1",
        "\u0101\xe1\u01CE\xe0\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA\u01DC\xfc\xea\u0251"
    ],
    [
        "a8bd",
        "\u0144\u0148"
    ],
    [
        "a8c0",
        "\u0261"
    ],
    [
        "a8c5",
        "\u3105",
        36
    ],
    [
        "a940",
        "\u3021",
        8,
        "\u32A3\u338E\u338F\u339C\u339D\u339E\u33A1\u33C4\u33CE\u33D1\u33D2\u33D5\uFE30\uFFE2\uFFE4"
    ],
    [
        "a959",
        "\u2121\u3231"
    ],
    [
        "a95c",
        "\u2010"
    ],
    [
        "a960",
        "\u30FC\u309B\u309C\u30FD\u30FE\u3006\u309D\u309E\uFE49",
        9,
        "\uFE54\uFE55\uFE56\uFE57\uFE59",
        8
    ],
    [
        "a980",
        "\uFE62",
        4,
        "\uFE68\uFE69\uFE6A\uFE6B"
    ],
    [
        "a996",
        "\u3007"
    ],
    [
        "a9a4",
        "\u2500",
        75
    ],
    [
        "aa40",
        "\u72DC\u72DD\u72DF\u72E2",
        5,
        "\u72EA\u72EB\u72F5\u72F6\u72F9\u72FD\u72FE\u72FF\u7300\u7302\u7304",
        5,
        "\u730B\u730C\u730D\u730F\u7310\u7311\u7312\u7314\u7318\u7319\u731A\u731F\u7320\u7323\u7324\u7326\u7327\u7328\u732D\u732F\u7330\u7332\u7333\u7335\u7336\u733A\u733B\u733C\u733D\u7340",
        8
    ],
    [
        "aa80",
        "\u7349\u734A\u734B\u734C\u734E\u734F\u7351\u7353\u7354\u7355\u7356\u7358",
        7,
        "\u7361",
        10,
        "\u736E\u7370\u7371"
    ],
    [
        "ab40",
        "\u7372",
        11,
        "\u737F",
        4,
        "\u7385\u7386\u7388\u738A\u738C\u738D\u738F\u7390\u7392\u7393\u7394\u7395\u7397\u7398\u7399\u739A\u739C\u739D\u739E\u73A0\u73A1\u73A3",
        5,
        "\u73AA\u73AC\u73AD\u73B1\u73B4\u73B5\u73B6\u73B8\u73B9\u73BC\u73BD\u73BE\u73BF\u73C1\u73C3",
        4
    ],
    [
        "ab80",
        "\u73CB\u73CC\u73CE\u73D2",
        6,
        "\u73DA\u73DB\u73DC\u73DD\u73DF\u73E1\u73E2\u73E3\u73E4\u73E6\u73E8\u73EA\u73EB\u73EC\u73EE\u73EF\u73F0\u73F1\u73F3",
        4
    ],
    [
        "ac40",
        "\u73F8",
        10,
        "\u7404\u7407\u7408\u740B\u740C\u740D\u740E\u7411",
        8,
        "\u741C",
        5,
        "\u7423\u7424\u7427\u7429\u742B\u742D\u742F\u7431\u7432\u7437",
        4,
        "\u743D\u743E\u743F\u7440\u7442",
        11
    ],
    [
        "ac80",
        "\u744E",
        6,
        "\u7456\u7458\u745D\u7460",
        12,
        "\u746E\u746F\u7471",
        4,
        "\u7478\u7479\u747A"
    ],
    [
        "ad40",
        "\u747B\u747C\u747D\u747F\u7482\u7484\u7485\u7486\u7488\u7489\u748A\u748C\u748D\u748F\u7491",
        10,
        "\u749D\u749F",
        7,
        "\u74AA",
        15,
        "\u74BB",
        12
    ],
    [
        "ad80",
        "\u74C8",
        9,
        "\u74D3",
        8,
        "\u74DD\u74DF\u74E1\u74E5\u74E7",
        6,
        "\u74F0\u74F1\u74F2"
    ],
    [
        "ae40",
        "\u74F3\u74F5\u74F8",
        6,
        "\u7500\u7501\u7502\u7503\u7505",
        7,
        "\u750E\u7510\u7512\u7514\u7515\u7516\u7517\u751B\u751D\u751E\u7520",
        4,
        "\u7526\u7527\u752A\u752E\u7534\u7536\u7539\u753C\u753D\u753F\u7541\u7542\u7543\u7544\u7546\u7547\u7549\u754A\u754D\u7550\u7551\u7552\u7553\u7555\u7556\u7557\u7558"
    ],
    [
        "ae80",
        "\u755D",
        7,
        "\u7567\u7568\u7569\u756B",
        6,
        "\u7573\u7575\u7576\u7577\u757A",
        4,
        "\u7580\u7581\u7582\u7584\u7585\u7587"
    ],
    [
        "af40",
        "\u7588\u7589\u758A\u758C\u758D\u758E\u7590\u7593\u7595\u7598\u759B\u759C\u759E\u75A2\u75A6",
        4,
        "\u75AD\u75B6\u75B7\u75BA\u75BB\u75BF\u75C0\u75C1\u75C6\u75CB\u75CC\u75CE\u75CF\u75D0\u75D1\u75D3\u75D7\u75D9\u75DA\u75DC\u75DD\u75DF\u75E0\u75E1\u75E5\u75E9\u75EC\u75ED\u75EE\u75EF\u75F2\u75F3\u75F5\u75F6\u75F7\u75F8\u75FA\u75FB\u75FD\u75FE\u7602\u7604\u7606\u7607"
    ],
    [
        "af80",
        "\u7608\u7609\u760B\u760D\u760E\u760F\u7611\u7612\u7613\u7614\u7616\u761A\u761C\u761D\u761E\u7621\u7623\u7627\u7628\u762C\u762E\u762F\u7631\u7632\u7636\u7637\u7639\u763A\u763B\u763D\u7641\u7642\u7644"
    ],
    [
        "b040",
        "\u7645",
        6,
        "\u764E",
        5,
        "\u7655\u7657",
        4,
        "\u765D\u765F\u7660\u7661\u7662\u7664",
        6,
        "\u766C\u766D\u766E\u7670",
        7,
        "\u7679\u767A\u767C\u767F\u7680\u7681\u7683\u7685\u7689\u768A\u768C\u768D\u768F\u7690\u7692\u7694\u7695\u7697\u7698\u769A\u769B"
    ],
    [
        "b080",
        "\u769C",
        7,
        "\u76A5",
        8,
        "\u76AF\u76B0\u76B3\u76B5",
        9,
        "\u76C0\u76C1\u76C3\u554A\u963F\u57C3\u6328\u54CE\u5509\u54C0\u7691\u764C\u853C\u77EE\u827E\u788D\u7231\u9698\u978D\u6C28\u5B89\u4FFA\u6309\u6697\u5CB8\u80FA\u6848\u80AE\u6602\u76CE\u51F9\u6556\u71AC\u7FF1\u8884\u50B2\u5965\u61CA\u6FB3\u82AD\u634C\u6252\u53ED\u5427\u7B06\u516B\u75A4\u5DF4\u62D4\u8DCB\u9776\u628A\u8019\u575D\u9738\u7F62\u7238\u767D\u67CF\u767E\u6446\u4F70\u8D25\u62DC\u7A17\u6591\u73ED\u642C\u6273\u822C\u9881\u677F\u7248\u626E\u62CC\u4F34\u74E3\u534A\u529E\u7ECA\u90A6\u5E2E\u6886\u699C\u8180\u7ED1\u68D2\u78C5\u868C\u9551\u508D\u8C24\u82DE\u80DE\u5305\u8912\u5265"
    ],
    [
        "b140",
        "\u76C4\u76C7\u76C9\u76CB\u76CC\u76D3\u76D5\u76D9\u76DA\u76DC\u76DD\u76DE\u76E0",
        4,
        "\u76E6",
        7,
        "\u76F0\u76F3\u76F5\u76F6\u76F7\u76FA\u76FB\u76FD\u76FF\u7700\u7702\u7703\u7705\u7706\u770A\u770C\u770E",
        10,
        "\u771B\u771C\u771D\u771E\u7721\u7723\u7724\u7725\u7727\u772A\u772B"
    ],
    [
        "b180",
        "\u772C\u772E\u7730",
        4,
        "\u7739\u773B\u773D\u773E\u773F\u7742\u7744\u7745\u7746\u7748",
        7,
        "\u7752",
        7,
        "\u775C\u8584\u96F9\u4FDD\u5821\u9971\u5B9D\u62B1\u62A5\u66B4\u8C79\u9C8D\u7206\u676F\u7891\u60B2\u5351\u5317\u8F88\u80CC\u8D1D\u94A1\u500D\u72C8\u5907\u60EB\u7119\u88AB\u5954\u82EF\u672C\u7B28\u5D29\u7EF7\u752D\u6CF5\u8E66\u8FF8\u903C\u9F3B\u6BD4\u9119\u7B14\u5F7C\u78A7\u84D6\u853D\u6BD5\u6BD9\u6BD6\u5E01\u5E87\u75F9\u95ED\u655D\u5F0A\u5FC5\u8F9F\u58C1\u81C2\u907F\u965B\u97AD\u8FB9\u7F16\u8D2C\u6241\u4FBF\u53D8\u535E\u8FA8\u8FA9\u8FAB\u904D\u6807\u5F6A\u8198\u8868\u9CD6\u618B\u522B\u762A\u5F6C\u658C\u6FD2\u6EE8\u5BBE\u6448\u5175\u51B0\u67C4\u4E19\u79C9\u997C\u70B3"
    ],
    [
        "b240",
        "\u775D\u775E\u775F\u7760\u7764\u7767\u7769\u776A\u776D",
        11,
        "\u777A\u777B\u777C\u7781\u7782\u7783\u7786",
        5,
        "\u778F\u7790\u7793",
        11,
        "\u77A1\u77A3\u77A4\u77A6\u77A8\u77AB\u77AD\u77AE\u77AF\u77B1\u77B2\u77B4\u77B6",
        4
    ],
    [
        "b280",
        "\u77BC\u77BE\u77C0",
        12,
        "\u77CE",
        8,
        "\u77D8\u77D9\u77DA\u77DD",
        4,
        "\u77E4\u75C5\u5E76\u73BB\u83E0\u64AD\u62E8\u94B5\u6CE2\u535A\u52C3\u640F\u94C2\u7B94\u4F2F\u5E1B\u8236\u8116\u818A\u6E24\u6CCA\u9A73\u6355\u535C\u54FA\u8865\u57E0\u4E0D\u5E03\u6B65\u7C3F\u90E8\u6016\u64E6\u731C\u88C1\u6750\u624D\u8D22\u776C\u8E29\u91C7\u5F69\u83DC\u8521\u9910\u53C2\u8695\u6B8B\u60ED\u60E8\u707F\u82CD\u8231\u4ED3\u6CA7\u85CF\u64CD\u7CD9\u69FD\u66F9\u8349\u5395\u7B56\u4FA7\u518C\u6D4B\u5C42\u8E6D\u63D2\u53C9\u832C\u8336\u67E5\u78B4\u643D\u5BDF\u5C94\u5DEE\u8BE7\u62C6\u67F4\u8C7A\u6400\u63BA\u8749\u998B\u8C17\u7F20\u94F2\u4EA7\u9610\u98A4\u660C\u7316"
    ],
    [
        "b340",
        "\u77E6\u77E8\u77EA\u77EF\u77F0\u77F1\u77F2\u77F4\u77F5\u77F7\u77F9\u77FA\u77FB\u77FC\u7803",
        5,
        "\u780A\u780B\u780E\u780F\u7810\u7813\u7815\u7819\u781B\u781E\u7820\u7821\u7822\u7824\u7828\u782A\u782B\u782E\u782F\u7831\u7832\u7833\u7835\u7836\u783D\u783F\u7841\u7842\u7843\u7844\u7846\u7848\u7849\u784A\u784B\u784D\u784F\u7851\u7853\u7854\u7858\u7859\u785A"
    ],
    [
        "b380",
        "\u785B\u785C\u785E",
        11,
        "\u786F",
        7,
        "\u7878\u7879\u787A\u787B\u787D",
        6,
        "\u573A\u5C1D\u5E38\u957F\u507F\u80A0\u5382\u655E\u7545\u5531\u5021\u8D85\u6284\u949E\u671D\u5632\u6F6E\u5DE2\u5435\u7092\u8F66\u626F\u64A4\u63A3\u5F7B\u6F88\u90F4\u81E3\u8FB0\u5C18\u6668\u5FF1\u6C89\u9648\u8D81\u886C\u6491\u79F0\u57CE\u6A59\u6210\u5448\u4E58\u7A0B\u60E9\u6F84\u8BDA\u627F\u901E\u9A8B\u79E4\u5403\u75F4\u6301\u5319\u6C60\u8FDF\u5F1B\u9A70\u803B\u9F7F\u4F88\u5C3A\u8D64\u7FC5\u65A5\u70BD\u5145\u51B2\u866B\u5D07\u5BA0\u62BD\u916C\u7574\u8E0C\u7A20\u6101\u7B79\u4EC7\u7EF8\u7785\u4E11\u81ED\u521D\u51FA\u6A71\u53A8\u8E87\u9504\u96CF\u6EC1\u9664\u695A"
    ],
    [
        "b440",
        "\u7884\u7885\u7886\u7888\u788A\u788B\u788F\u7890\u7892\u7894\u7895\u7896\u7899\u789D\u789E\u78A0\u78A2\u78A4\u78A6\u78A8",
        7,
        "\u78B5\u78B6\u78B7\u78B8\u78BA\u78BB\u78BC\u78BD\u78BF\u78C0\u78C2\u78C3\u78C4\u78C6\u78C7\u78C8\u78CC\u78CD\u78CE\u78CF\u78D1\u78D2\u78D3\u78D6\u78D7\u78D8\u78DA",
        9
    ],
    [
        "b480",
        "\u78E4\u78E5\u78E6\u78E7\u78E9\u78EA\u78EB\u78ED",
        4,
        "\u78F3\u78F5\u78F6\u78F8\u78F9\u78FB",
        5,
        "\u7902\u7903\u7904\u7906",
        6,
        "\u7840\u50A8\u77D7\u6410\u89E6\u5904\u63E3\u5DDD\u7A7F\u693D\u4F20\u8239\u5598\u4E32\u75AE\u7A97\u5E62\u5E8A\u95EF\u521B\u5439\u708A\u6376\u9524\u5782\u6625\u693F\u9187\u5507\u6DF3\u7EAF\u8822\u6233\u7EF0\u75B5\u8328\u78C1\u96CC\u8F9E\u6148\u74F7\u8BCD\u6B64\u523A\u8D50\u6B21\u806A\u8471\u56F1\u5306\u4ECE\u4E1B\u51D1\u7C97\u918B\u7C07\u4FC3\u8E7F\u7BE1\u7A9C\u6467\u5D14\u50AC\u8106\u7601\u7CB9\u6DEC\u7FE0\u6751\u5B58\u5BF8\u78CB\u64AE\u6413\u63AA\u632B\u9519\u642D\u8FBE\u7B54\u7629\u6253\u5927\u5446\u6B79\u50A3\u6234\u5E26\u6B86\u4EE3\u8D37\u888B\u5F85\u902E"
    ],
    [
        "b540",
        "\u790D",
        5,
        "\u7914",
        9,
        "\u791F",
        4,
        "\u7925",
        14,
        "\u7935",
        4,
        "\u793D\u793F\u7942\u7943\u7944\u7945\u7947\u794A",
        8,
        "\u7954\u7955\u7958\u7959\u7961\u7963"
    ],
    [
        "b580",
        "\u7964\u7966\u7969\u796A\u796B\u796C\u796E\u7970",
        6,
        "\u7979\u797B",
        4,
        "\u7982\u7983\u7986\u7987\u7988\u7989\u798B\u798C\u798D\u798E\u7990\u7991\u7992\u6020\u803D\u62C5\u4E39\u5355\u90F8\u63B8\u80C6\u65E6\u6C2E\u4F46\u60EE\u6DE1\u8BDE\u5F39\u86CB\u5F53\u6321\u515A\u8361\u6863\u5200\u6363\u8E48\u5012\u5C9B\u7977\u5BFC\u5230\u7A3B\u60BC\u9053\u76D7\u5FB7\u5F97\u7684\u8E6C\u706F\u767B\u7B49\u77AA\u51F3\u9093\u5824\u4F4E\u6EF4\u8FEA\u654C\u7B1B\u72C4\u6DA4\u7FDF\u5AE1\u62B5\u5E95\u5730\u8482\u7B2C\u5E1D\u5F1F\u9012\u7F14\u98A0\u6382\u6EC7\u7898\u70B9\u5178\u975B\u57AB\u7535\u4F43\u7538\u5E97\u60E6\u5960\u6DC0\u6BBF\u7889\u53FC\u96D5\u51CB\u5201\u6389\u540A\u9493\u8C03\u8DCC\u7239\u789F\u8776\u8FED\u8C0D\u53E0"
    ],
    [
        "b640",
        "\u7993",
        6,
        "\u799B",
        11,
        "\u79A8",
        10,
        "\u79B4",
        4,
        "\u79BC\u79BF\u79C2\u79C4\u79C5\u79C7\u79C8\u79CA\u79CC\u79CE\u79CF\u79D0\u79D3\u79D4\u79D6\u79D7\u79D9",
        5,
        "\u79E0\u79E1\u79E2\u79E5\u79E8\u79EA"
    ],
    [
        "b680",
        "\u79EC\u79EE\u79F1",
        6,
        "\u79F9\u79FA\u79FC\u79FE\u79FF\u7A01\u7A04\u7A05\u7A07\u7A08\u7A09\u7A0A\u7A0C\u7A0F",
        4,
        "\u7A15\u7A16\u7A18\u7A19\u7A1B\u7A1C\u4E01\u76EF\u53EE\u9489\u9876\u9F0E\u952D\u5B9A\u8BA2\u4E22\u4E1C\u51AC\u8463\u61C2\u52A8\u680B\u4F97\u606B\u51BB\u6D1E\u515C\u6296\u6597\u9661\u8C46\u9017\u75D8\u90FD\u7763\u6BD2\u728A\u72EC\u8BFB\u5835\u7779\u8D4C\u675C\u9540\u809A\u5EA6\u6E21\u5992\u7AEF\u77ED\u953B\u6BB5\u65AD\u7F0E\u5806\u5151\u961F\u5BF9\u58A9\u5428\u8E72\u6566\u987F\u56E4\u949D\u76FE\u9041\u6387\u54C6\u591A\u593A\u579B\u8EB2\u6735\u8DFA\u8235\u5241\u60F0\u5815\u86FE\u5CE8\u9E45\u4FC4\u989D\u8BB9\u5A25\u6076\u5384\u627C\u904F\u9102\u997F\u6069\u800C\u513F\u8033\u5C14\u9975\u6D31\u4E8C"
    ],
    [
        "b740",
        "\u7A1D\u7A1F\u7A21\u7A22\u7A24",
        14,
        "\u7A34\u7A35\u7A36\u7A38\u7A3A\u7A3E\u7A40",
        5,
        "\u7A47",
        9,
        "\u7A52",
        4,
        "\u7A58",
        16
    ],
    [
        "b780",
        "\u7A69",
        6,
        "\u7A71\u7A72\u7A73\u7A75\u7A7B\u7A7C\u7A7D\u7A7E\u7A82\u7A85\u7A87\u7A89\u7A8A\u7A8B\u7A8C\u7A8E\u7A8F\u7A90\u7A93\u7A94\u7A99\u7A9A\u7A9B\u7A9E\u7AA1\u7AA2\u8D30\u53D1\u7F5A\u7B4F\u4F10\u4E4F\u9600\u6CD5\u73D0\u85E9\u5E06\u756A\u7FFB\u6A0A\u77FE\u9492\u7E41\u51E1\u70E6\u53CD\u8FD4\u8303\u8D29\u72AF\u996D\u6CDB\u574A\u82B3\u65B9\u80AA\u623F\u9632\u59A8\u4EFF\u8BBF\u7EBA\u653E\u83F2\u975E\u5561\u98DE\u80A5\u532A\u8BFD\u5420\u80BA\u5E9F\u6CB8\u8D39\u82AC\u915A\u5429\u6C1B\u5206\u7EB7\u575F\u711A\u6C7E\u7C89\u594B\u4EFD\u5FFF\u6124\u7CAA\u4E30\u5C01\u67AB\u8702\u5CF0\u950B\u98CE\u75AF\u70FD\u9022\u51AF\u7F1D\u8BBD\u5949\u51E4\u4F5B\u5426\u592B\u6577\u80A4\u5B75\u6276\u62C2\u8F90\u5E45\u6C1F\u7B26\u4F0F\u4FD8\u670D"
    ],
    [
        "b840",
        "\u7AA3\u7AA4\u7AA7\u7AA9\u7AAA\u7AAB\u7AAE",
        4,
        "\u7AB4",
        10,
        "\u7AC0",
        10,
        "\u7ACC",
        9,
        "\u7AD7\u7AD8\u7ADA\u7ADB\u7ADC\u7ADD\u7AE1\u7AE2\u7AE4\u7AE7",
        5,
        "\u7AEE\u7AF0\u7AF1\u7AF2\u7AF3"
    ],
    [
        "b880",
        "\u7AF4",
        4,
        "\u7AFB\u7AFC\u7AFE\u7B00\u7B01\u7B02\u7B05\u7B07\u7B09\u7B0C\u7B0D\u7B0E\u7B10\u7B12\u7B13\u7B16\u7B17\u7B18\u7B1A\u7B1C\u7B1D\u7B1F\u7B21\u7B22\u7B23\u7B27\u7B29\u7B2D\u6D6E\u6DAA\u798F\u88B1\u5F17\u752B\u629A\u8F85\u4FEF\u91DC\u65A7\u812F\u8151\u5E9C\u8150\u8D74\u526F\u8986\u8D4B\u590D\u5085\u4ED8\u961C\u7236\u8179\u8D1F\u5BCC\u8BA3\u9644\u5987\u7F1A\u5490\u5676\u560E\u8BE5\u6539\u6982\u9499\u76D6\u6E89\u5E72\u7518\u6746\u67D1\u7AFF\u809D\u8D76\u611F\u79C6\u6562\u8D63\u5188\u521A\u94A2\u7F38\u809B\u7EB2\u5C97\u6E2F\u6760\u7BD9\u768B\u9AD8\u818F\u7F94\u7CD5\u641E\u9550\u7A3F\u544A\u54E5\u6B4C\u6401\u6208\u9E3D\u80F3\u7599\u5272\u9769\u845B\u683C\u86E4\u9601\u9694\u94EC\u4E2A\u5404\u7ED9\u6839\u8DDF\u8015\u66F4\u5E9A\u7FB9"
    ],
    [
        "b940",
        "\u7B2F\u7B30\u7B32\u7B34\u7B35\u7B36\u7B37\u7B39\u7B3B\u7B3D\u7B3F",
        5,
        "\u7B46\u7B48\u7B4A\u7B4D\u7B4E\u7B53\u7B55\u7B57\u7B59\u7B5C\u7B5E\u7B5F\u7B61\u7B63",
        10,
        "\u7B6F\u7B70\u7B73\u7B74\u7B76\u7B78\u7B7A\u7B7C\u7B7D\u7B7F\u7B81\u7B82\u7B83\u7B84\u7B86",
        6,
        "\u7B8E\u7B8F"
    ],
    [
        "b980",
        "\u7B91\u7B92\u7B93\u7B96\u7B98\u7B99\u7B9A\u7B9B\u7B9E\u7B9F\u7BA0\u7BA3\u7BA4\u7BA5\u7BAE\u7BAF\u7BB0\u7BB2\u7BB3\u7BB5\u7BB6\u7BB7\u7BB9",
        7,
        "\u7BC2\u7BC3\u7BC4\u57C2\u803F\u6897\u5DE5\u653B\u529F\u606D\u9F9A\u4F9B\u8EAC\u516C\u5BAB\u5F13\u5DE9\u6C5E\u62F1\u8D21\u5171\u94A9\u52FE\u6C9F\u82DF\u72D7\u57A2\u6784\u8D2D\u591F\u8F9C\u83C7\u5495\u7B8D\u4F30\u6CBD\u5B64\u59D1\u9F13\u53E4\u86CA\u9AA8\u8C37\u80A1\u6545\u987E\u56FA\u96C7\u522E\u74DC\u5250\u5BE1\u6302\u8902\u4E56\u62D0\u602A\u68FA\u5173\u5B98\u51A0\u89C2\u7BA1\u9986\u7F50\u60EF\u704C\u8D2F\u5149\u5E7F\u901B\u7470\u89C4\u572D\u7845\u5F52\u9F9F\u95FA\u8F68\u9B3C\u8BE1\u7678\u6842\u67DC\u8DEA\u8D35\u523D\u8F8A\u6EDA\u68CD\u9505\u90ED\u56FD\u679C\u88F9\u8FC7\u54C8"
    ],
    [
        "ba40",
        "\u7BC5\u7BC8\u7BC9\u7BCA\u7BCB\u7BCD\u7BCE\u7BCF\u7BD0\u7BD2\u7BD4",
        4,
        "\u7BDB\u7BDC\u7BDE\u7BDF\u7BE0\u7BE2\u7BE3\u7BE4\u7BE7\u7BE8\u7BE9\u7BEB\u7BEC\u7BED\u7BEF\u7BF0\u7BF2",
        4,
        "\u7BF8\u7BF9\u7BFA\u7BFB\u7BFD\u7BFF",
        7,
        "\u7C08\u7C09\u7C0A\u7C0D\u7C0E\u7C10",
        5,
        "\u7C17\u7C18\u7C19"
    ],
    [
        "ba80",
        "\u7C1A",
        4,
        "\u7C20",
        5,
        "\u7C28\u7C29\u7C2B",
        12,
        "\u7C39",
        5,
        "\u7C42\u9AB8\u5B69\u6D77\u6C26\u4EA5\u5BB3\u9A87\u9163\u61A8\u90AF\u97E9\u542B\u6DB5\u5BD2\u51FD\u558A\u7F55\u7FF0\u64BC\u634D\u65F1\u61BE\u608D\u710A\u6C57\u6C49\u592F\u676D\u822A\u58D5\u568E\u8C6A\u6BEB\u90DD\u597D\u8017\u53F7\u6D69\u5475\u559D\u8377\u83CF\u6838\u79BE\u548C\u4F55\u5408\u76D2\u8C89\u9602\u6CB3\u6DB8\u8D6B\u8910\u9E64\u8D3A\u563F\u9ED1\u75D5\u5F88\u72E0\u6068\u54FC\u4EA8\u6A2A\u8861\u6052\u8F70\u54C4\u70D8\u8679\u9E3F\u6D2A\u5B8F\u5F18\u7EA2\u5589\u4FAF\u7334\u543C\u539A\u5019\u540E\u547C\u4E4E\u5FFD\u745A\u58F6\u846B\u80E1\u8774\u72D0\u7CCA\u6E56"
    ],
    [
        "bb40",
        "\u7C43",
        9,
        "\u7C4E",
        36,
        "\u7C75",
        5,
        "\u7C7E",
        9
    ],
    [
        "bb80",
        "\u7C88\u7C8A",
        6,
        "\u7C93\u7C94\u7C96\u7C99\u7C9A\u7C9B\u7CA0\u7CA1\u7CA3\u7CA6\u7CA7\u7CA8\u7CA9\u7CAB\u7CAC\u7CAD\u7CAF\u7CB0\u7CB4",
        4,
        "\u7CBA\u7CBB\u5F27\u864E\u552C\u62A4\u4E92\u6CAA\u6237\u82B1\u54D7\u534E\u733E\u6ED1\u753B\u5212\u5316\u8BDD\u69D0\u5F8A\u6000\u6DEE\u574F\u6B22\u73AF\u6853\u8FD8\u7F13\u6362\u60A3\u5524\u75EA\u8C62\u7115\u6DA3\u5BA6\u5E7B\u8352\u614C\u9EC4\u78FA\u8757\u7C27\u7687\u51F0\u60F6\u714C\u6643\u5E4C\u604D\u8C0E\u7070\u6325\u8F89\u5FBD\u6062\u86D4\u56DE\u6BC1\u6094\u6167\u5349\u60E0\u6666\u8D3F\u79FD\u4F1A\u70E9\u6C47\u8BB3\u8BF2\u7ED8\u8364\u660F\u5A5A\u9B42\u6D51\u6DF7\u8C41\u6D3B\u4F19\u706B\u83B7\u6216\u60D1\u970D\u8D27\u7978\u51FB\u573E\u57FA\u673A\u7578\u7A3D\u79EF\u7B95"
    ],
    [
        "bc40",
        "\u7CBF\u7CC0\u7CC2\u7CC3\u7CC4\u7CC6\u7CC9\u7CCB\u7CCE",
        6,
        "\u7CD8\u7CDA\u7CDB\u7CDD\u7CDE\u7CE1",
        6,
        "\u7CE9",
        5,
        "\u7CF0",
        7,
        "\u7CF9\u7CFA\u7CFC",
        13,
        "\u7D0B",
        5
    ],
    [
        "bc80",
        "\u7D11",
        14,
        "\u7D21\u7D23\u7D24\u7D25\u7D26\u7D28\u7D29\u7D2A\u7D2C\u7D2D\u7D2E\u7D30",
        6,
        "\u808C\u9965\u8FF9\u6FC0\u8BA5\u9E21\u59EC\u7EE9\u7F09\u5409\u6781\u68D8\u8F91\u7C4D\u96C6\u53CA\u6025\u75BE\u6C72\u5373\u5AC9\u7EA7\u6324\u51E0\u810A\u5DF1\u84DF\u6280\u5180\u5B63\u4F0E\u796D\u5242\u60B8\u6D4E\u5BC4\u5BC2\u8BA1\u8BB0\u65E2\u5FCC\u9645\u5993\u7EE7\u7EAA\u5609\u67B7\u5939\u4F73\u5BB6\u52A0\u835A\u988A\u8D3E\u7532\u94BE\u5047\u7A3C\u4EF7\u67B6\u9A7E\u5AC1\u6B7C\u76D1\u575A\u5C16\u7B3A\u95F4\u714E\u517C\u80A9\u8270\u5978\u7F04\u8327\u68C0\u67EC\u78B1\u7877\u62E3\u6361\u7B80\u4FED\u526A\u51CF\u8350\u69DB\u9274\u8DF5\u8D31\u89C1\u952E\u7BAD\u4EF6"
    ],
    [
        "bd40",
        "\u7D37",
        54,
        "\u7D6F",
        7
    ],
    [
        "bd80",
        "\u7D78",
        32,
        "\u5065\u8230\u5251\u996F\u6E10\u6E85\u6DA7\u5EFA\u50F5\u59DC\u5C06\u6D46\u6C5F\u7586\u848B\u6868\u5956\u8BB2\u5320\u9171\u964D\u8549\u6912\u7901\u7126\u80F6\u4EA4\u90CA\u6D47\u9A84\u5A07\u56BC\u6405\u94F0\u77EB\u4FA5\u811A\u72E1\u89D2\u997A\u7F34\u7EDE\u527F\u6559\u9175\u8F7F\u8F83\u53EB\u7A96\u63ED\u63A5\u7686\u79F8\u8857\u9636\u622A\u52AB\u8282\u6854\u6770\u6377\u776B\u7AED\u6D01\u7ED3\u89E3\u59D0\u6212\u85C9\u82A5\u754C\u501F\u4ECB\u75A5\u8BEB\u5C4A\u5DFE\u7B4B\u65A4\u91D1\u4ECA\u6D25\u895F\u7D27\u9526\u4EC5\u8C28\u8FDB\u9773\u664B\u7981\u8FD1\u70EC\u6D78"
    ],
    [
        "be40",
        "\u7D99",
        12,
        "\u7DA7",
        6,
        "\u7DAF",
        42
    ],
    [
        "be80",
        "\u7DDA",
        32,
        "\u5C3D\u52B2\u8346\u5162\u830E\u775B\u6676\u9CB8\u4EAC\u60CA\u7CBE\u7CB3\u7ECF\u4E95\u8B66\u666F\u9888\u9759\u5883\u656C\u955C\u5F84\u75C9\u9756\u7ADF\u7ADE\u51C0\u70AF\u7A98\u63EA\u7A76\u7EA0\u7396\u97ED\u4E45\u7078\u4E5D\u9152\u53A9\u6551\u65E7\u81FC\u8205\u548E\u5C31\u759A\u97A0\u62D8\u72D9\u75BD\u5C45\u9A79\u83CA\u5C40\u5480\u77E9\u4E3E\u6CAE\u805A\u62D2\u636E\u5DE8\u5177\u8DDD\u8E1E\u952F\u4FF1\u53E5\u60E7\u70AC\u5267\u6350\u9E43\u5A1F\u5026\u7737\u5377\u7EE2\u6485\u652B\u6289\u6398\u5014\u7235\u89C9\u51B3\u8BC0\u7EDD\u5747\u83CC\u94A7\u519B\u541B\u5CFB"
    ],
    [
        "bf40",
        "\u7DFB",
        62
    ],
    [
        "bf80",
        "\u7E3A\u7E3C",
        4,
        "\u7E42",
        4,
        "\u7E48",
        21,
        "\u4FCA\u7AE3\u6D5A\u90E1\u9A8F\u5580\u5496\u5361\u54AF\u5F00\u63E9\u6977\u51EF\u6168\u520A\u582A\u52D8\u574E\u780D\u770B\u5EB7\u6177\u7CE0\u625B\u6297\u4EA2\u7095\u8003\u62F7\u70E4\u9760\u5777\u82DB\u67EF\u68F5\u78D5\u9897\u79D1\u58F3\u54B3\u53EF\u6E34\u514B\u523B\u5BA2\u8BFE\u80AF\u5543\u57A6\u6073\u5751\u542D\u7A7A\u6050\u5B54\u63A7\u62A0\u53E3\u6263\u5BC7\u67AF\u54ED\u7A9F\u82E6\u9177\u5E93\u88E4\u5938\u57AE\u630E\u8DE8\u80EF\u5757\u7B77\u4FA9\u5FEB\u5BBD\u6B3E\u5321\u7B50\u72C2\u6846\u77FF\u7736\u65F7\u51B5\u4E8F\u76D4\u5CBF\u7AA5\u8475\u594E\u9B41\u5080"
    ],
    [
        "c040",
        "\u7E5E",
        35,
        "\u7E83",
        23,
        "\u7E9C\u7E9D\u7E9E"
    ],
    [
        "c080",
        "\u7EAE\u7EB4\u7EBB\u7EBC\u7ED6\u7EE4\u7EEC\u7EF9\u7F0A\u7F10\u7F1E\u7F37\u7F39\u7F3B",
        6,
        "\u7F43\u7F46",
        9,
        "\u7F52\u7F53\u9988\u6127\u6E83\u5764\u6606\u6346\u56F0\u62EC\u6269\u5ED3\u9614\u5783\u62C9\u5587\u8721\u814A\u8FA3\u5566\u83B1\u6765\u8D56\u84DD\u5A6A\u680F\u62E6\u7BEE\u9611\u5170\u6F9C\u8C30\u63FD\u89C8\u61D2\u7F06\u70C2\u6EE5\u7405\u6994\u72FC\u5ECA\u90CE\u6717\u6D6A\u635E\u52B3\u7262\u8001\u4F6C\u59E5\u916A\u70D9\u6D9D\u52D2\u4E50\u96F7\u956D\u857E\u78CA\u7D2F\u5121\u5792\u64C2\u808B\u7C7B\u6CEA\u68F1\u695E\u51B7\u5398\u68A8\u7281\u9ECE\u7BF1\u72F8\u79BB\u6F13\u7406\u674E\u91CC\u9CA4\u793C\u8389\u8354\u540F\u6817\u4E3D\u5389\u52B1\u783E\u5386\u5229\u5088\u4F8B\u4FD0"
    ],
    [
        "c140",
        "\u7F56\u7F59\u7F5B\u7F5C\u7F5D\u7F5E\u7F60\u7F63",
        4,
        "\u7F6B\u7F6C\u7F6D\u7F6F\u7F70\u7F73\u7F75\u7F76\u7F77\u7F78\u7F7A\u7F7B\u7F7C\u7F7D\u7F7F\u7F80\u7F82",
        7,
        "\u7F8B\u7F8D\u7F8F",
        4,
        "\u7F95",
        4,
        "\u7F9B\u7F9C\u7FA0\u7FA2\u7FA3\u7FA5\u7FA6\u7FA8",
        6,
        "\u7FB1"
    ],
    [
        "c180",
        "\u7FB3",
        4,
        "\u7FBA\u7FBB\u7FBE\u7FC0\u7FC2\u7FC3\u7FC4\u7FC6\u7FC7\u7FC8\u7FC9\u7FCB\u7FCD\u7FCF",
        4,
        "\u7FD6\u7FD7\u7FD9",
        5,
        "\u7FE2\u7FE3\u75E2\u7ACB\u7C92\u6CA5\u96B6\u529B\u7483\u54E9\u4FE9\u8054\u83B2\u8FDE\u9570\u5EC9\u601C\u6D9F\u5E18\u655B\u8138\u94FE\u604B\u70BC\u7EC3\u7CAE\u51C9\u6881\u7CB1\u826F\u4E24\u8F86\u91CF\u667E\u4EAE\u8C05\u64A9\u804A\u50DA\u7597\u71CE\u5BE5\u8FBD\u6F66\u4E86\u6482\u9563\u5ED6\u6599\u5217\u88C2\u70C8\u52A3\u730E\u7433\u6797\u78F7\u9716\u4E34\u90BB\u9CDE\u6DCB\u51DB\u8D41\u541D\u62CE\u73B2\u83F1\u96F6\u9F84\u94C3\u4F36\u7F9A\u51CC\u7075\u9675\u5CAD\u9886\u53E6\u4EE4\u6E9C\u7409\u69B4\u786B\u998F\u7559\u5218\u7624\u6D41\u67F3\u516D\u9F99\u804B\u5499\u7B3C\u7ABF"
    ],
    [
        "c240",
        "\u7FE4\u7FE7\u7FE8\u7FEA\u7FEB\u7FEC\u7FED\u7FEF\u7FF2\u7FF4",
        6,
        "\u7FFD\u7FFE\u7FFF\u8002\u8007\u8008\u8009\u800A\u800E\u800F\u8011\u8013\u801A\u801B\u801D\u801E\u801F\u8021\u8023\u8024\u802B",
        5,
        "\u8032\u8034\u8039\u803A\u803C\u803E\u8040\u8041\u8044\u8045\u8047\u8048\u8049\u804E\u804F\u8050\u8051\u8053\u8055\u8056\u8057"
    ],
    [
        "c280",
        "\u8059\u805B",
        13,
        "\u806B",
        5,
        "\u8072",
        11,
        "\u9686\u5784\u62E2\u9647\u697C\u5A04\u6402\u7BD3\u6F0F\u964B\u82A6\u5362\u9885\u5E90\u7089\u63B3\u5364\u864F\u9C81\u9E93\u788C\u9732\u8DEF\u8D42\u9E7F\u6F5E\u7984\u5F55\u9646\u622E\u9A74\u5415\u94DD\u4FA3\u65C5\u5C65\u5C61\u7F15\u8651\u6C2F\u5F8B\u7387\u6EE4\u7EFF\u5CE6\u631B\u5B6A\u6EE6\u5375\u4E71\u63A0\u7565\u62A1\u8F6E\u4F26\u4ED1\u6CA6\u7EB6\u8BBA\u841D\u87BA\u7F57\u903B\u9523\u7BA9\u9AA1\u88F8\u843D\u6D1B\u9A86\u7EDC\u5988\u9EBB\u739B\u7801\u8682\u9A6C\u9A82\u561B\u5417\u57CB\u4E70\u9EA6\u5356\u8FC8\u8109\u7792\u9992\u86EE\u6EE1\u8513\u66FC\u6162\u6F2B"
    ],
    [
        "c340",
        "\u807E\u8081\u8082\u8085\u8088\u808A\u808D",
        5,
        "\u8094\u8095\u8097\u8099\u809E\u80A3\u80A6\u80A7\u80A8\u80AC\u80B0\u80B3\u80B5\u80B6\u80B8\u80B9\u80BB\u80C5\u80C7",
        4,
        "\u80CF",
        6,
        "\u80D8\u80DF\u80E0\u80E2\u80E3\u80E6\u80EE\u80F5\u80F7\u80F9\u80FB\u80FE\u80FF\u8100\u8101\u8103\u8104\u8105\u8107\u8108\u810B"
    ],
    [
        "c380",
        "\u810C\u8115\u8117\u8119\u811B\u811C\u811D\u811F",
        12,
        "\u812D\u812E\u8130\u8133\u8134\u8135\u8137\u8139",
        4,
        "\u813F\u8C29\u8292\u832B\u76F2\u6C13\u5FD9\u83BD\u732B\u8305\u951A\u6BDB\u77DB\u94C6\u536F\u8302\u5192\u5E3D\u8C8C\u8D38\u4E48\u73AB\u679A\u6885\u9176\u9709\u7164\u6CA1\u7709\u5A92\u9541\u6BCF\u7F8E\u6627\u5BD0\u59B9\u5A9A\u95E8\u95F7\u4EEC\u840C\u8499\u6AAC\u76DF\u9530\u731B\u68A6\u5B5F\u772F\u919A\u9761\u7CDC\u8FF7\u8C1C\u5F25\u7C73\u79D8\u89C5\u6CCC\u871C\u5BC6\u5E42\u68C9\u7720\u7EF5\u5195\u514D\u52C9\u5A29\u7F05\u9762\u82D7\u63CF\u7784\u85D0\u79D2\u6E3A\u5E99\u5999\u8511\u706D\u6C11\u62BF\u76BF\u654F\u60AF\u95FD\u660E\u879F\u9E23\u94ED\u540D\u547D\u8C2C\u6478"
    ],
    [
        "c440",
        "\u8140",
        5,
        "\u8147\u8149\u814D\u814E\u814F\u8152\u8156\u8157\u8158\u815B",
        4,
        "\u8161\u8162\u8163\u8164\u8166\u8168\u816A\u816B\u816C\u816F\u8172\u8173\u8175\u8176\u8177\u8178\u8181\u8183",
        4,
        "\u8189\u818B\u818C\u818D\u818E\u8190\u8192",
        5,
        "\u8199\u819A\u819E",
        4,
        "\u81A4\u81A5"
    ],
    [
        "c480",
        "\u81A7\u81A9\u81AB",
        7,
        "\u81B4",
        5,
        "\u81BC\u81BD\u81BE\u81BF\u81C4\u81C5\u81C7\u81C8\u81C9\u81CB\u81CD",
        6,
        "\u6479\u8611\u6A21\u819C\u78E8\u6469\u9B54\u62B9\u672B\u83AB\u58A8\u9ED8\u6CAB\u6F20\u5BDE\u964C\u8C0B\u725F\u67D0\u62C7\u7261\u4EA9\u59C6\u6BCD\u5893\u66AE\u5E55\u52DF\u6155\u6728\u76EE\u7766\u7267\u7A46\u62FF\u54EA\u5450\u94A0\u90A3\u5A1C\u7EB3\u6C16\u4E43\u5976\u8010\u5948\u5357\u7537\u96BE\u56CA\u6320\u8111\u607C\u95F9\u6DD6\u5462\u9981\u5185\u5AE9\u80FD\u59AE\u9713\u502A\u6CE5\u5C3C\u62DF\u4F60\u533F\u817B\u9006\u6EBA\u852B\u62C8\u5E74\u78BE\u64B5\u637B\u5FF5\u5A18\u917F\u9E1F\u5C3F\u634F\u8042\u5B7D\u556E\u954A\u954D\u6D85\u60A8\u67E0\u72DE\u51DD\u5B81"
    ],
    [
        "c540",
        "\u81D4",
        14,
        "\u81E4\u81E5\u81E6\u81E8\u81E9\u81EB\u81EE",
        4,
        "\u81F5",
        5,
        "\u81FD\u81FF\u8203\u8207",
        4,
        "\u820E\u820F\u8211\u8213\u8215",
        5,
        "\u821D\u8220\u8224\u8225\u8226\u8227\u8229\u822E\u8232\u823A\u823C\u823D\u823F"
    ],
    [
        "c580",
        "\u8240\u8241\u8242\u8243\u8245\u8246\u8248\u824A\u824C\u824D\u824E\u8250",
        7,
        "\u8259\u825B\u825C\u825D\u825E\u8260",
        7,
        "\u8269\u62E7\u6CDE\u725B\u626D\u94AE\u7EBD\u8113\u6D53\u519C\u5F04\u5974\u52AA\u6012\u5973\u6696\u8650\u759F\u632A\u61E6\u7CEF\u8BFA\u54E6\u6B27\u9E25\u6BB4\u85D5\u5455\u5076\u6CA4\u556A\u8DB4\u722C\u5E15\u6015\u7436\u62CD\u6392\u724C\u5F98\u6E43\u6D3E\u6500\u6F58\u76D8\u78D0\u76FC\u7554\u5224\u53DB\u4E53\u5E9E\u65C1\u802A\u80D6\u629B\u5486\u5228\u70AE\u888D\u8DD1\u6CE1\u5478\u80DA\u57F9\u88F4\u8D54\u966A\u914D\u4F69\u6C9B\u55B7\u76C6\u7830\u62A8\u70F9\u6F8E\u5F6D\u84EC\u68DA\u787C\u7BF7\u81A8\u670B\u9E4F\u6367\u78B0\u576F\u7812\u9739\u6279\u62AB\u5288\u7435\u6BD7"
    ],
    [
        "c640",
        "\u826A\u826B\u826C\u826D\u8271\u8275\u8276\u8277\u8278\u827B\u827C\u8280\u8281\u8283\u8285\u8286\u8287\u8289\u828C\u8290\u8293\u8294\u8295\u8296\u829A\u829B\u829E\u82A0\u82A2\u82A3\u82A7\u82B2\u82B5\u82B6\u82BA\u82BB\u82BC\u82BF\u82C0\u82C2\u82C3\u82C5\u82C6\u82C9\u82D0\u82D6\u82D9\u82DA\u82DD\u82E2\u82E7\u82E8\u82E9\u82EA\u82EC\u82ED\u82EE\u82F0\u82F2\u82F3\u82F5\u82F6\u82F8"
    ],
    [
        "c680",
        "\u82FA\u82FC",
        4,
        "\u830A\u830B\u830D\u8310\u8312\u8313\u8316\u8318\u8319\u831D",
        9,
        "\u8329\u832A\u832E\u8330\u8332\u8337\u833B\u833D\u5564\u813E\u75B2\u76AE\u5339\u75DE\u50FB\u5C41\u8B6C\u7BC7\u504F\u7247\u9A97\u98D8\u6F02\u74E2\u7968\u6487\u77A5\u62FC\u9891\u8D2B\u54C1\u8058\u4E52\u576A\u82F9\u840D\u5E73\u51ED\u74F6\u8BC4\u5C4F\u5761\u6CFC\u9887\u5A46\u7834\u9B44\u8FEB\u7C95\u5256\u6251\u94FA\u4EC6\u8386\u8461\u83E9\u84B2\u57D4\u6734\u5703\u666E\u6D66\u8C31\u66DD\u7011\u671F\u6B3A\u6816\u621A\u59BB\u4E03\u51C4\u6F06\u67D2\u6C8F\u5176\u68CB\u5947\u6B67\u7566\u5D0E\u8110\u9F50\u65D7\u7948\u7941\u9A91\u8D77\u5C82\u4E5E\u4F01\u542F\u5951\u780C\u5668\u6C14\u8FC4\u5F03\u6C7D\u6CE3\u8BAB\u6390"
    ],
    [
        "c740",
        "\u833E\u833F\u8341\u8342\u8344\u8345\u8348\u834A",
        4,
        "\u8353\u8355",
        4,
        "\u835D\u8362\u8370",
        6,
        "\u8379\u837A\u837E",
        6,
        "\u8387\u8388\u838A\u838B\u838C\u838D\u838F\u8390\u8391\u8394\u8395\u8396\u8397\u8399\u839A\u839D\u839F\u83A1",
        6,
        "\u83AC\u83AD\u83AE"
    ],
    [
        "c780",
        "\u83AF\u83B5\u83BB\u83BE\u83BF\u83C2\u83C3\u83C4\u83C6\u83C8\u83C9\u83CB\u83CD\u83CE\u83D0\u83D1\u83D2\u83D3\u83D5\u83D7\u83D9\u83DA\u83DB\u83DE\u83E2\u83E3\u83E4\u83E6\u83E7\u83E8\u83EB\u83EC\u83ED\u6070\u6D3D\u7275\u6266\u948E\u94C5\u5343\u8FC1\u7B7E\u4EDF\u8C26\u4E7E\u9ED4\u94B1\u94B3\u524D\u6F5C\u9063\u6D45\u8C34\u5811\u5D4C\u6B20\u6B49\u67AA\u545B\u8154\u7F8C\u5899\u8537\u5F3A\u62A2\u6A47\u9539\u6572\u6084\u6865\u77A7\u4E54\u4FA8\u5DE7\u9798\u64AC\u7FD8\u5CED\u4FCF\u7A8D\u5207\u8304\u4E14\u602F\u7A83\u94A6\u4FB5\u4EB2\u79E6\u7434\u52E4\u82B9\u64D2\u79BD\u5BDD\u6C81\u9752\u8F7B\u6C22\u503E\u537F\u6E05\u64CE\u6674\u6C30\u60C5\u9877\u8BF7\u5E86\u743C\u7A77\u79CB\u4E18\u90B1\u7403\u6C42\u56DA\u914B\u6CC5\u8D8B\u533A\u86C6\u66F2\u8EAF\u5C48\u9A71\u6E20"
    ],
    [
        "c840",
        "\u83EE\u83EF\u83F3",
        4,
        "\u83FA\u83FB\u83FC\u83FE\u83FF\u8400\u8402\u8405\u8407\u8408\u8409\u840A\u8410\u8412",
        5,
        "\u8419\u841A\u841B\u841E",
        5,
        "\u8429",
        7,
        "\u8432",
        5,
        "\u8439\u843A\u843B\u843E",
        7,
        "\u8447\u8448\u8449"
    ],
    [
        "c880",
        "\u844A",
        6,
        "\u8452",
        4,
        "\u8458\u845D\u845E\u845F\u8460\u8462\u8464",
        4,
        "\u846A\u846E\u846F\u8470\u8472\u8474\u8477\u8479\u847B\u847C\u53D6\u5A36\u9F8B\u8DA3\u53BB\u5708\u98A7\u6743\u919B\u6CC9\u5168\u75CA\u62F3\u72AC\u5238\u529D\u7F3A\u7094\u7638\u5374\u9E4A\u69B7\u786E\u96C0\u88D9\u7FA4\u7136\u71C3\u5189\u67D3\u74E4\u58E4\u6518\u56B7\u8BA9\u9976\u6270\u7ED5\u60F9\u70ED\u58EC\u4EC1\u4EBA\u5FCD\u97E7\u4EFB\u8BA4\u5203\u598A\u7EAB\u6254\u4ECD\u65E5\u620E\u8338\u84C9\u8363\u878D\u7194\u6EB6\u5BB9\u7ED2\u5197\u63C9\u67D4\u8089\u8339\u8815\u5112\u5B7A\u5982\u8FB1\u4E73\u6C5D\u5165\u8925\u8F6F\u962E\u854A\u745E\u9510\u95F0\u6DA6\u82E5\u5F31\u6492\u6D12\u8428\u816E\u9CC3\u585E\u8D5B\u4E09\u53C1"
    ],
    [
        "c940",
        "\u847D",
        4,
        "\u8483\u8484\u8485\u8486\u848A\u848D\u848F",
        7,
        "\u8498\u849A\u849B\u849D\u849E\u849F\u84A0\u84A2",
        12,
        "\u84B0\u84B1\u84B3\u84B5\u84B6\u84B7\u84BB\u84BC\u84BE\u84C0\u84C2\u84C3\u84C5\u84C6\u84C7\u84C8\u84CB\u84CC\u84CE\u84CF\u84D2\u84D4\u84D5\u84D7"
    ],
    [
        "c980",
        "\u84D8",
        4,
        "\u84DE\u84E1\u84E2\u84E4\u84E7",
        4,
        "\u84ED\u84EE\u84EF\u84F1",
        10,
        "\u84FD\u84FE\u8500\u8501\u8502\u4F1E\u6563\u6851\u55D3\u4E27\u6414\u9A9A\u626B\u5AC2\u745F\u8272\u6DA9\u68EE\u50E7\u838E\u7802\u6740\u5239\u6C99\u7EB1\u50BB\u5565\u715E\u7B5B\u6652\u73CA\u82EB\u6749\u5C71\u5220\u717D\u886B\u95EA\u9655\u64C5\u8D61\u81B3\u5584\u6C55\u6247\u7F2E\u5892\u4F24\u5546\u8D4F\u664C\u4E0A\u5C1A\u88F3\u68A2\u634E\u7A0D\u70E7\u828D\u52FA\u97F6\u5C11\u54E8\u90B5\u7ECD\u5962\u8D4A\u86C7\u820C\u820D\u8D66\u6444\u5C04\u6151\u6D89\u793E\u8BBE\u7837\u7533\u547B\u4F38\u8EAB\u6DF1\u5A20\u7EC5\u795E\u6C88\u5BA1\u5A76\u751A\u80BE\u614E\u6E17\u58F0\u751F\u7525\u7272\u5347\u7EF3"
    ],
    [
        "ca40",
        "\u8503",
        8,
        "\u850D\u850E\u850F\u8510\u8512\u8514\u8515\u8516\u8518\u8519\u851B\u851C\u851D\u851E\u8520\u8522",
        8,
        "\u852D",
        9,
        "\u853E",
        4,
        "\u8544\u8545\u8546\u8547\u854B",
        10
    ],
    [
        "ca80",
        "\u8557\u8558\u855A\u855B\u855C\u855D\u855F",
        4,
        "\u8565\u8566\u8567\u8569",
        8,
        "\u8573\u8575\u8576\u8577\u8578\u857C\u857D\u857F\u8580\u8581\u7701\u76DB\u5269\u80DC\u5723\u5E08\u5931\u72EE\u65BD\u6E7F\u8BD7\u5C38\u8671\u5341\u77F3\u62FE\u65F6\u4EC0\u98DF\u8680\u5B9E\u8BC6\u53F2\u77E2\u4F7F\u5C4E\u9A76\u59CB\u5F0F\u793A\u58EB\u4E16\u67FF\u4E8B\u62ED\u8A93\u901D\u52BF\u662F\u55DC\u566C\u9002\u4ED5\u4F8D\u91CA\u9970\u6C0F\u5E02\u6043\u5BA4\u89C6\u8BD5\u6536\u624B\u9996\u5B88\u5BFF\u6388\u552E\u53D7\u7626\u517D\u852C\u67A2\u68B3\u6B8A\u6292\u8F93\u53D4\u8212\u6DD1\u758F\u4E66\u8D4E\u5B70\u719F\u85AF\u6691\u66D9\u7F72\u8700\u9ECD\u9F20\u5C5E\u672F\u8FF0\u6811\u675F\u620D\u7AD6\u5885\u5EB6\u6570\u6F31"
    ],
    [
        "cb40",
        "\u8582\u8583\u8586\u8588",
        6,
        "\u8590",
        10,
        "\u859D",
        6,
        "\u85A5\u85A6\u85A7\u85A9\u85AB\u85AC\u85AD\u85B1",
        5,
        "\u85B8\u85BA",
        6,
        "\u85C2",
        6,
        "\u85CA",
        4,
        "\u85D1\u85D2"
    ],
    [
        "cb80",
        "\u85D4\u85D6",
        5,
        "\u85DD",
        6,
        "\u85E5\u85E6\u85E7\u85E8\u85EA",
        14,
        "\u6055\u5237\u800D\u6454\u8870\u7529\u5E05\u6813\u62F4\u971C\u53CC\u723D\u8C01\u6C34\u7761\u7A0E\u542E\u77AC\u987A\u821C\u8BF4\u7855\u6714\u70C1\u65AF\u6495\u5636\u601D\u79C1\u53F8\u4E1D\u6B7B\u8086\u5BFA\u55E3\u56DB\u4F3A\u4F3C\u9972\u5DF3\u677E\u8038\u6002\u9882\u9001\u5B8B\u8BBC\u8BF5\u641C\u8258\u64DE\u55FD\u82CF\u9165\u4FD7\u7D20\u901F\u7C9F\u50F3\u5851\u6EAF\u5BBF\u8BC9\u8083\u9178\u849C\u7B97\u867D\u968B\u968F\u7EE5\u9AD3\u788E\u5C81\u7A57\u9042\u96A7\u795F\u5B59\u635F\u7B0B\u84D1\u68AD\u5506\u7F29\u7410\u7D22\u9501\u6240\u584C\u4ED6\u5B83\u5979\u5854"
    ],
    [
        "cc40",
        "\u85F9\u85FA\u85FC\u85FD\u85FE\u8600",
        4,
        "\u8606",
        10,
        "\u8612\u8613\u8614\u8615\u8617",
        15,
        "\u8628\u862A",
        13,
        "\u8639\u863A\u863B\u863D\u863E\u863F\u8640"
    ],
    [
        "cc80",
        "\u8641",
        11,
        "\u8652\u8653\u8655",
        4,
        "\u865B\u865C\u865D\u865F\u8660\u8661\u8663",
        7,
        "\u736D\u631E\u8E4B\u8E0F\u80CE\u82D4\u62AC\u53F0\u6CF0\u915E\u592A\u6001\u6C70\u574D\u644A\u8D2A\u762B\u6EE9\u575B\u6A80\u75F0\u6F6D\u8C2D\u8C08\u5766\u6BEF\u8892\u78B3\u63A2\u53F9\u70AD\u6C64\u5858\u642A\u5802\u68E0\u819B\u5510\u7CD6\u5018\u8EBA\u6DCC\u8D9F\u70EB\u638F\u6D9B\u6ED4\u7EE6\u8404\u6843\u9003\u6DD8\u9676\u8BA8\u5957\u7279\u85E4\u817E\u75BC\u8A8A\u68AF\u5254\u8E22\u9511\u63D0\u9898\u8E44\u557C\u4F53\u66FF\u568F\u60D5\u6D95\u5243\u5C49\u5929\u6DFB\u586B\u7530\u751C\u606C\u8214\u8146\u6311\u6761\u8FE2\u773A\u8DF3\u8D34\u94C1\u5E16\u5385\u542C\u70C3"
    ],
    [
        "cd40",
        "\u866D\u866F\u8670\u8672",
        6,
        "\u8683",
        6,
        "\u868E",
        4,
        "\u8694\u8696",
        5,
        "\u869E",
        4,
        "\u86A5\u86A6\u86AB\u86AD\u86AE\u86B2\u86B3\u86B7\u86B8\u86B9\u86BB",
        4,
        "\u86C1\u86C2\u86C3\u86C5\u86C8\u86CC\u86CD\u86D2\u86D3\u86D5\u86D6\u86D7\u86DA\u86DC"
    ],
    [
        "cd80",
        "\u86DD\u86E0\u86E1\u86E2\u86E3\u86E5\u86E6\u86E7\u86E8\u86EA\u86EB\u86EC\u86EF\u86F5\u86F6\u86F7\u86FA\u86FB\u86FC\u86FD\u86FF\u8701\u8704\u8705\u8706\u870B\u870C\u870E\u870F\u8710\u8711\u8714\u8716\u6C40\u5EF7\u505C\u4EAD\u5EAD\u633A\u8247\u901A\u6850\u916E\u77B3\u540C\u94DC\u5F64\u7AE5\u6876\u6345\u7B52\u7EDF\u75DB\u5077\u6295\u5934\u900F\u51F8\u79C3\u7A81\u56FE\u5F92\u9014\u6D82\u5C60\u571F\u5410\u5154\u6E4D\u56E2\u63A8\u9893\u817F\u8715\u892A\u9000\u541E\u5C6F\u81C0\u62D6\u6258\u8131\u9E35\u9640\u9A6E\u9A7C\u692D\u59A5\u62D3\u553E\u6316\u54C7\u86D9\u6D3C\u5A03\u74E6\u889C\u6B6A\u5916\u8C4C\u5F2F\u6E7E\u73A9\u987D\u4E38\u70F7\u5B8C\u7897\u633D\u665A\u7696\u60CB\u5B9B\u5A49\u4E07\u8155\u6C6A\u738B\u4EA1\u6789\u7F51\u5F80\u65FA\u671B\u5FD8\u5984\u5A01"
    ],
    [
        "ce40",
        "\u8719\u871B\u871D\u871F\u8720\u8724\u8726\u8727\u8728\u872A\u872B\u872C\u872D\u872F\u8730\u8732\u8733\u8735\u8736\u8738\u8739\u873A\u873C\u873D\u8740",
        6,
        "\u874A\u874B\u874D\u874F\u8750\u8751\u8752\u8754\u8755\u8756\u8758\u875A",
        5,
        "\u8761\u8762\u8766",
        7,
        "\u876F\u8771\u8772\u8773\u8775"
    ],
    [
        "ce80",
        "\u8777\u8778\u8779\u877A\u877F\u8780\u8781\u8784\u8786\u8787\u8789\u878A\u878C\u878E",
        4,
        "\u8794\u8795\u8796\u8798",
        6,
        "\u87A0",
        4,
        "\u5DCD\u5FAE\u5371\u97E6\u8FDD\u6845\u56F4\u552F\u60DF\u4E3A\u6F4D\u7EF4\u82C7\u840E\u59D4\u4F1F\u4F2A\u5C3E\u7EAC\u672A\u851A\u5473\u754F\u80C3\u5582\u9B4F\u4F4D\u6E2D\u8C13\u5C09\u6170\u536B\u761F\u6E29\u868A\u6587\u95FB\u7EB9\u543B\u7A33\u7D0A\u95EE\u55E1\u7FC1\u74EE\u631D\u8717\u6DA1\u7A9D\u6211\u65A1\u5367\u63E1\u6C83\u5DEB\u545C\u94A8\u4E4C\u6C61\u8BEC\u5C4B\u65E0\u829C\u68A7\u543E\u5434\u6BCB\u6B66\u4E94\u6342\u5348\u821E\u4F0D\u4FAE\u575E\u620A\u96FE\u6664\u7269\u52FF\u52A1\u609F\u8BEF\u6614\u7199\u6790\u897F\u7852\u77FD\u6670\u563B\u5438\u9521\u727A"
    ],
    [
        "cf40",
        "\u87A5\u87A6\u87A7\u87A9\u87AA\u87AE\u87B0\u87B1\u87B2\u87B4\u87B6\u87B7\u87B8\u87B9\u87BB\u87BC\u87BE\u87BF\u87C1",
        4,
        "\u87C7\u87C8\u87C9\u87CC",
        4,
        "\u87D4",
        6,
        "\u87DC\u87DD\u87DE\u87DF\u87E1\u87E2\u87E3\u87E4\u87E6\u87E7\u87E8\u87E9\u87EB\u87EC\u87ED\u87EF",
        9
    ],
    [
        "cf80",
        "\u87FA\u87FB\u87FC\u87FD\u87FF\u8800\u8801\u8802\u8804",
        5,
        "\u880B",
        7,
        "\u8814\u8817\u8818\u8819\u881A\u881C",
        4,
        "\u8823\u7A00\u606F\u5E0C\u6089\u819D\u5915\u60DC\u7184\u70EF\u6EAA\u6C50\u7280\u6A84\u88AD\u5E2D\u4E60\u5AB3\u559C\u94E3\u6D17\u7CFB\u9699\u620F\u7EC6\u778E\u867E\u5323\u971E\u8F96\u6687\u5CE1\u4FA0\u72ED\u4E0B\u53A6\u590F\u5413\u6380\u9528\u5148\u4ED9\u9C9C\u7EA4\u54B8\u8D24\u8854\u8237\u95F2\u6D8E\u5F26\u5ACC\u663E\u9669\u73B0\u732E\u53BF\u817A\u9985\u7FA1\u5BAA\u9677\u9650\u7EBF\u76F8\u53A2\u9576\u9999\u7BB1\u8944\u6E58\u4E61\u7FD4\u7965\u8BE6\u60F3\u54CD\u4EAB\u9879\u5DF7\u6A61\u50CF\u5411\u8C61\u8427\u785D\u9704\u524A\u54EE\u56A3\u9500\u6D88\u5BB5\u6DC6\u6653"
    ],
    [
        "d040",
        "\u8824",
        13,
        "\u8833",
        5,
        "\u883A\u883B\u883D\u883E\u883F\u8841\u8842\u8843\u8846",
        5,
        "\u884E",
        5,
        "\u8855\u8856\u8858\u885A",
        6,
        "\u8866\u8867\u886A\u886D\u886F\u8871\u8873\u8874\u8875\u8876\u8878\u8879\u887A"
    ],
    [
        "d080",
        "\u887B\u887C\u8880\u8883\u8886\u8887\u8889\u888A\u888C\u888E\u888F\u8890\u8891\u8893\u8894\u8895\u8897",
        4,
        "\u889D",
        4,
        "\u88A3\u88A5",
        5,
        "\u5C0F\u5B5D\u6821\u8096\u5578\u7B11\u6548\u6954\u4E9B\u6B47\u874E\u978B\u534F\u631F\u643A\u90AA\u659C\u80C1\u8C10\u5199\u68B0\u5378\u87F9\u61C8\u6CC4\u6CFB\u8C22\u5C51\u85AA\u82AF\u950C\u6B23\u8F9B\u65B0\u5FFB\u5FC3\u4FE1\u8845\u661F\u8165\u7329\u60FA\u5174\u5211\u578B\u5F62\u90A2\u884C\u9192\u5E78\u674F\u6027\u59D3\u5144\u51F6\u80F8\u5308\u6C79\u96C4\u718A\u4F11\u4FEE\u7F9E\u673D\u55C5\u9508\u79C0\u8896\u7EE3\u589F\u620C\u9700\u865A\u5618\u987B\u5F90\u8BB8\u84C4\u9157\u53D9\u65ED\u5E8F\u755C\u6064\u7D6E\u5A7F\u7EEA\u7EED\u8F69\u55A7\u5BA3\u60AC\u65CB\u7384"
    ],
    [
        "d140",
        "\u88AC\u88AE\u88AF\u88B0\u88B2",
        4,
        "\u88B8\u88B9\u88BA\u88BB\u88BD\u88BE\u88BF\u88C0\u88C3\u88C4\u88C7\u88C8\u88CA\u88CB\u88CC\u88CD\u88CF\u88D0\u88D1\u88D3\u88D6\u88D7\u88DA",
        4,
        "\u88E0\u88E1\u88E6\u88E7\u88E9",
        6,
        "\u88F2\u88F5\u88F6\u88F7\u88FA\u88FB\u88FD\u88FF\u8900\u8901\u8903",
        5
    ],
    [
        "d180",
        "\u8909\u890B",
        4,
        "\u8911\u8914",
        4,
        "\u891C",
        4,
        "\u8922\u8923\u8924\u8926\u8927\u8928\u8929\u892C\u892D\u892E\u892F\u8931\u8932\u8933\u8935\u8937\u9009\u7663\u7729\u7EDA\u9774\u859B\u5B66\u7A74\u96EA\u8840\u52CB\u718F\u5FAA\u65EC\u8BE2\u5BFB\u9A6F\u5DE1\u6B89\u6C5B\u8BAD\u8BAF\u900A\u8FC5\u538B\u62BC\u9E26\u9E2D\u5440\u4E2B\u82BD\u7259\u869C\u5D16\u8859\u6DAF\u96C5\u54D1\u4E9A\u8BB6\u7109\u54BD\u9609\u70DF\u6DF9\u76D0\u4E25\u7814\u8712\u5CA9\u5EF6\u8A00\u989C\u960E\u708E\u6CBF\u5944\u63A9\u773C\u884D\u6F14\u8273\u5830\u71D5\u538C\u781A\u96C1\u5501\u5F66\u7130\u5BB4\u8C1A\u9A8C\u6B83\u592E\u9E2F\u79E7\u6768\u626C\u4F6F\u75A1\u7F8A\u6D0B\u9633\u6C27\u4EF0\u75D2\u517B\u6837\u6F3E\u9080\u8170\u5996\u7476"
    ],
    [
        "d240",
        "\u8938",
        8,
        "\u8942\u8943\u8945",
        24,
        "\u8960",
        5,
        "\u8967",
        19,
        "\u897C"
    ],
    [
        "d280",
        "\u897D\u897E\u8980\u8982\u8984\u8985\u8987",
        26,
        "\u6447\u5C27\u9065\u7A91\u8C23\u59DA\u54AC\u8200\u836F\u8981\u8000\u6930\u564E\u8036\u7237\u91CE\u51B6\u4E5F\u9875\u6396\u4E1A\u53F6\u66F3\u814B\u591C\u6DB2\u4E00\u58F9\u533B\u63D6\u94F1\u4F9D\u4F0A\u8863\u9890\u5937\u9057\u79FB\u4EEA\u80F0\u7591\u6C82\u5B9C\u59E8\u5F5D\u6905\u8681\u501A\u5DF2\u4E59\u77E3\u4EE5\u827A\u6291\u6613\u9091\u5C79\u4EBF\u5F79\u81C6\u9038\u8084\u75AB\u4EA6\u88D4\u610F\u6BC5\u5FC6\u4E49\u76CA\u6EA2\u8BE3\u8BAE\u8C0A\u8BD1\u5F02\u7FFC\u7FCC\u7ECE\u8335\u836B\u56E0\u6BB7\u97F3\u9634\u59FB\u541F\u94F6\u6DEB\u5BC5\u996E\u5C39\u5F15\u9690"
    ],
    [
        "d340",
        "\u89A2",
        30,
        "\u89C3\u89CD\u89D3\u89D4\u89D5\u89D7\u89D8\u89D9\u89DB\u89DD\u89DF\u89E0\u89E1\u89E2\u89E4\u89E7\u89E8\u89E9\u89EA\u89EC\u89ED\u89EE\u89F0\u89F1\u89F2\u89F4",
        6
    ],
    [
        "d380",
        "\u89FB",
        4,
        "\u8A01",
        5,
        "\u8A08",
        21,
        "\u5370\u82F1\u6A31\u5A74\u9E70\u5E94\u7F28\u83B9\u8424\u8425\u8367\u8747\u8FCE\u8D62\u76C8\u5F71\u9896\u786C\u6620\u54DF\u62E5\u4F63\u81C3\u75C8\u5EB8\u96CD\u8E0A\u86F9\u548F\u6CF3\u6D8C\u6C38\u607F\u52C7\u7528\u5E7D\u4F18\u60A0\u5FE7\u5C24\u7531\u90AE\u94C0\u72B9\u6CB9\u6E38\u9149\u6709\u53CB\u53F3\u4F51\u91C9\u8BF1\u53C8\u5E7C\u8FC2\u6DE4\u4E8E\u76C2\u6986\u865E\u611A\u8206\u4F59\u4FDE\u903E\u9C7C\u6109\u6E1D\u6E14\u9685\u4E88\u5A31\u96E8\u4E0E\u5C7F\u79B9\u5B87\u8BED\u7FBD\u7389\u57DF\u828B\u90C1\u5401\u9047\u55BB\u5CEA\u5FA1\u6108\u6B32\u72F1\u80B2\u8A89"
    ],
    [
        "d440",
        "\u8A1E",
        31,
        "\u8A3F",
        8,
        "\u8A49",
        21
    ],
    [
        "d480",
        "\u8A5F",
        25,
        "\u8A7A",
        6,
        "\u6D74\u5BD3\u88D5\u9884\u8C6B\u9A6D\u9E33\u6E0A\u51A4\u5143\u57A3\u8881\u539F\u63F4\u8F95\u56ED\u5458\u5706\u733F\u6E90\u7F18\u8FDC\u82D1\u613F\u6028\u9662\u66F0\u7EA6\u8D8A\u8DC3\u94A5\u5CB3\u7CA4\u6708\u60A6\u9605\u8018\u4E91\u90E7\u5300\u9668\u5141\u8FD0\u8574\u915D\u6655\u97F5\u5B55\u531D\u7838\u6742\u683D\u54C9\u707E\u5BB0\u8F7D\u518D\u5728\u54B1\u6512\u6682\u8D5E\u8D43\u810F\u846C\u906D\u7CDF\u51FF\u85FB\u67A3\u65E9\u6FA1\u86A4\u8E81\u566A\u9020\u7682\u7076\u71E5\u8D23\u62E9\u5219\u6CFD\u8D3C\u600E\u589E\u618E\u66FE\u8D60\u624E\u55B3\u6E23\u672D\u8F67"
    ],
    [
        "d540",
        "\u8A81",
        7,
        "\u8A8B",
        7,
        "\u8A94",
        46
    ],
    [
        "d580",
        "\u8AC3",
        32,
        "\u94E1\u95F8\u7728\u6805\u69A8\u548B\u4E4D\u70B8\u8BC8\u6458\u658B\u5B85\u7A84\u503A\u5BE8\u77BB\u6BE1\u8A79\u7C98\u6CBE\u76CF\u65A9\u8F97\u5D2D\u5C55\u8638\u6808\u5360\u6218\u7AD9\u6E5B\u7EFD\u6A1F\u7AE0\u5F70\u6F33\u5F20\u638C\u6DA8\u6756\u4E08\u5E10\u8D26\u4ED7\u80C0\u7634\u969C\u62DB\u662D\u627E\u6CBC\u8D75\u7167\u7F69\u5146\u8087\u53EC\u906E\u6298\u54F2\u86F0\u8F99\u8005\u9517\u8517\u8FD9\u6D59\u73CD\u659F\u771F\u7504\u7827\u81FB\u8D1E\u9488\u4FA6\u6795\u75B9\u8BCA\u9707\u632F\u9547\u9635\u84B8\u6323\u7741\u5F81\u72F0\u4E89\u6014\u6574\u62EF\u6B63\u653F"
    ],
    [
        "d640",
        "\u8AE4",
        34,
        "\u8B08",
        27
    ],
    [
        "d680",
        "\u8B24\u8B25\u8B27",
        30,
        "\u5E27\u75C7\u90D1\u8BC1\u829D\u679D\u652F\u5431\u8718\u77E5\u80A2\u8102\u6C41\u4E4B\u7EC7\u804C\u76F4\u690D\u6B96\u6267\u503C\u4F84\u5740\u6307\u6B62\u8DBE\u53EA\u65E8\u7EB8\u5FD7\u631A\u63B7\u81F3\u81F4\u7F6E\u5E1C\u5CD9\u5236\u667A\u79E9\u7A1A\u8D28\u7099\u75D4\u6EDE\u6CBB\u7A92\u4E2D\u76C5\u5FE0\u949F\u8877\u7EC8\u79CD\u80BF\u91CD\u4EF2\u4F17\u821F\u5468\u5DDE\u6D32\u8BCC\u7CA5\u8F74\u8098\u5E1A\u5492\u76B1\u5B99\u663C\u9AA4\u73E0\u682A\u86DB\u6731\u732A\u8BF8\u8BDB\u9010\u7AF9\u70DB\u716E\u62C4\u77A9\u5631\u4E3B\u8457\u67F1\u52A9\u86C0\u8D2E\u94F8\u7B51"
    ],
    [
        "d740",
        "\u8B46",
        31,
        "\u8B67",
        4,
        "\u8B6D",
        25
    ],
    [
        "d780",
        "\u8B87",
        24,
        "\u8BAC\u8BB1\u8BBB\u8BC7\u8BD0\u8BEA\u8C09\u8C1E\u4F4F\u6CE8\u795D\u9A7B\u6293\u722A\u62FD\u4E13\u7816\u8F6C\u64B0\u8D5A\u7BC6\u6869\u5E84\u88C5\u5986\u649E\u58EE\u72B6\u690E\u9525\u8FFD\u8D58\u5760\u7F00\u8C06\u51C6\u6349\u62D9\u5353\u684C\u7422\u8301\u914C\u5544\u7740\u707C\u6D4A\u5179\u54A8\u8D44\u59FF\u6ECB\u6DC4\u5B5C\u7D2B\u4ED4\u7C7D\u6ED3\u5B50\u81EA\u6E0D\u5B57\u9B03\u68D5\u8E2A\u5B97\u7EFC\u603B\u7EB5\u90B9\u8D70\u594F\u63CD\u79DF\u8DB3\u5352\u65CF\u7956\u8BC5\u963B\u7EC4\u94BB\u7E82\u5634\u9189\u6700\u7F6A\u5C0A\u9075\u6628\u5DE6\u4F50\u67DE\u505A\u4F5C\u5750\u5EA7"
    ],
    [
        "d840",
        "\u8C38",
        8,
        "\u8C42\u8C43\u8C44\u8C45\u8C48\u8C4A\u8C4B\u8C4D",
        7,
        "\u8C56\u8C57\u8C58\u8C59\u8C5B",
        5,
        "\u8C63",
        6,
        "\u8C6C",
        6,
        "\u8C74\u8C75\u8C76\u8C77\u8C7B",
        6,
        "\u8C83\u8C84\u8C86\u8C87"
    ],
    [
        "d880",
        "\u8C88\u8C8B\u8C8D",
        6,
        "\u8C95\u8C96\u8C97\u8C99",
        20,
        "\u4E8D\u4E0C\u5140\u4E10\u5EFF\u5345\u4E15\u4E98\u4E1E\u9B32\u5B6C\u5669\u4E28\u79BA\u4E3F\u5315\u4E47\u592D\u723B\u536E\u6C10\u56DF\u80E4\u9997\u6BD3\u777E\u9F17\u4E36\u4E9F\u9F10\u4E5C\u4E69\u4E93\u8288\u5B5B\u556C\u560F\u4EC4\u538D\u539D\u53A3\u53A5\u53AE\u9765\u8D5D\u531A\u53F5\u5326\u532E\u533E\u8D5C\u5366\u5363\u5202\u5208\u520E\u522D\u5233\u523F\u5240\u524C\u525E\u5261\u525C\u84AF\u527D\u5282\u5281\u5290\u5293\u5182\u7F54\u4EBB\u4EC3\u4EC9\u4EC2\u4EE8\u4EE1\u4EEB\u4EDE\u4F1B\u4EF3\u4F22\u4F64\u4EF5\u4F25\u4F27\u4F09\u4F2B\u4F5E\u4F67\u6538\u4F5A\u4F5D"
    ],
    [
        "d940",
        "\u8CAE",
        62
    ],
    [
        "d980",
        "\u8CED",
        32,
        "\u4F5F\u4F57\u4F32\u4F3D\u4F76\u4F74\u4F91\u4F89\u4F83\u4F8F\u4F7E\u4F7B\u4FAA\u4F7C\u4FAC\u4F94\u4FE6\u4FE8\u4FEA\u4FC5\u4FDA\u4FE3\u4FDC\u4FD1\u4FDF\u4FF8\u5029\u504C\u4FF3\u502C\u500F\u502E\u502D\u4FFE\u501C\u500C\u5025\u5028\u507E\u5043\u5055\u5048\u504E\u506C\u507B\u50A5\u50A7\u50A9\u50BA\u50D6\u5106\u50ED\u50EC\u50E6\u50EE\u5107\u510B\u4EDD\u6C3D\u4F58\u4F65\u4FCE\u9FA0\u6C46\u7C74\u516E\u5DFD\u9EC9\u9998\u5181\u5914\u52F9\u530D\u8A07\u5310\u51EB\u5919\u5155\u4EA0\u5156\u4EB3\u886E\u88A4\u4EB5\u8114\u88D2\u7980\u5B34\u8803\u7FB8\u51AB\u51B1\u51BD\u51BC"
    ],
    [
        "da40",
        "\u8D0E",
        14,
        "\u8D20\u8D51\u8D52\u8D57\u8D5F\u8D65\u8D68\u8D69\u8D6A\u8D6C\u8D6E\u8D6F\u8D71\u8D72\u8D78",
        8,
        "\u8D82\u8D83\u8D86\u8D87\u8D88\u8D89\u8D8C",
        4,
        "\u8D92\u8D93\u8D95",
        9,
        "\u8DA0\u8DA1"
    ],
    [
        "da80",
        "\u8DA2\u8DA4",
        12,
        "\u8DB2\u8DB6\u8DB7\u8DB9\u8DBB\u8DBD\u8DC0\u8DC1\u8DC2\u8DC5\u8DC7\u8DC8\u8DC9\u8DCA\u8DCD\u8DD0\u8DD2\u8DD3\u8DD4\u51C7\u5196\u51A2\u51A5\u8BA0\u8BA6\u8BA7\u8BAA\u8BB4\u8BB5\u8BB7\u8BC2\u8BC3\u8BCB\u8BCF\u8BCE\u8BD2\u8BD3\u8BD4\u8BD6\u8BD8\u8BD9\u8BDC\u8BDF\u8BE0\u8BE4\u8BE8\u8BE9\u8BEE\u8BF0\u8BF3\u8BF6\u8BF9\u8BFC\u8BFF\u8C00\u8C02\u8C04\u8C07\u8C0C\u8C0F\u8C11\u8C12\u8C14\u8C15\u8C16\u8C19\u8C1B\u8C18\u8C1D\u8C1F\u8C20\u8C21\u8C25\u8C27\u8C2A\u8C2B\u8C2E\u8C2F\u8C32\u8C33\u8C35\u8C36\u5369\u537A\u961D\u9622\u9621\u9631\u962A\u963D\u963C\u9642\u9649\u9654\u965F\u9667\u966C\u9672\u9674\u9688\u968D\u9697\u96B0\u9097\u909B\u909D\u9099\u90AC\u90A1\u90B4\u90B3\u90B6\u90BA"
    ],
    [
        "db40",
        "\u8DD5\u8DD8\u8DD9\u8DDC\u8DE0\u8DE1\u8DE2\u8DE5\u8DE6\u8DE7\u8DE9\u8DED\u8DEE\u8DF0\u8DF1\u8DF2\u8DF4\u8DF6\u8DFC\u8DFE",
        6,
        "\u8E06\u8E07\u8E08\u8E0B\u8E0D\u8E0E\u8E10\u8E11\u8E12\u8E13\u8E15",
        7,
        "\u8E20\u8E21\u8E24",
        4,
        "\u8E2B\u8E2D\u8E30\u8E32\u8E33\u8E34\u8E36\u8E37\u8E38\u8E3B\u8E3C\u8E3E"
    ],
    [
        "db80",
        "\u8E3F\u8E43\u8E45\u8E46\u8E4C",
        4,
        "\u8E53",
        5,
        "\u8E5A",
        11,
        "\u8E67\u8E68\u8E6A\u8E6B\u8E6E\u8E71\u90B8\u90B0\u90CF\u90C5\u90BE\u90D0\u90C4\u90C7\u90D3\u90E6\u90E2\u90DC\u90D7\u90DB\u90EB\u90EF\u90FE\u9104\u9122\u911E\u9123\u9131\u912F\u9139\u9143\u9146\u520D\u5942\u52A2\u52AC\u52AD\u52BE\u54FF\u52D0\u52D6\u52F0\u53DF\u71EE\u77CD\u5EF4\u51F5\u51FC\u9B2F\u53B6\u5F01\u755A\u5DEF\u574C\u57A9\u57A1\u587E\u58BC\u58C5\u58D1\u5729\u572C\u572A\u5733\u5739\u572E\u572F\u575C\u573B\u5742\u5769\u5785\u576B\u5786\u577C\u577B\u5768\u576D\u5776\u5773\u57AD\u57A4\u578C\u57B2\u57CF\u57A7\u57B4\u5793\u57A0\u57D5\u57D8\u57DA\u57D9\u57D2\u57B8\u57F4\u57EF\u57F8\u57E4\u57DD"
    ],
    [
        "dc40",
        "\u8E73\u8E75\u8E77",
        4,
        "\u8E7D\u8E7E\u8E80\u8E82\u8E83\u8E84\u8E86\u8E88",
        6,
        "\u8E91\u8E92\u8E93\u8E95",
        6,
        "\u8E9D\u8E9F",
        11,
        "\u8EAD\u8EAE\u8EB0\u8EB1\u8EB3",
        6,
        "\u8EBB",
        7
    ],
    [
        "dc80",
        "\u8EC3",
        10,
        "\u8ECF",
        21,
        "\u580B\u580D\u57FD\u57ED\u5800\u581E\u5819\u5844\u5820\u5865\u586C\u5881\u5889\u589A\u5880\u99A8\u9F19\u61FF\u8279\u827D\u827F\u828F\u828A\u82A8\u8284\u828E\u8291\u8297\u8299\u82AB\u82B8\u82BE\u82B0\u82C8\u82CA\u82E3\u8298\u82B7\u82AE\u82CB\u82CC\u82C1\u82A9\u82B4\u82A1\u82AA\u829F\u82C4\u82CE\u82A4\u82E1\u8309\u82F7\u82E4\u830F\u8307\u82DC\u82F4\u82D2\u82D8\u830C\u82FB\u82D3\u8311\u831A\u8306\u8314\u8315\u82E0\u82D5\u831C\u8351\u835B\u835C\u8308\u8392\u833C\u8334\u8331\u839B\u835E\u832F\u834F\u8347\u8343\u835F\u8340\u8317\u8360\u832D\u833A\u8333\u8366\u8365"
    ],
    [
        "dd40",
        "\u8EE5",
        62
    ],
    [
        "dd80",
        "\u8F24",
        32,
        "\u8368\u831B\u8369\u836C\u836A\u836D\u836E\u83B0\u8378\u83B3\u83B4\u83A0\u83AA\u8393\u839C\u8385\u837C\u83B6\u83A9\u837D\u83B8\u837B\u8398\u839E\u83A8\u83BA\u83BC\u83C1\u8401\u83E5\u83D8\u5807\u8418\u840B\u83DD\u83FD\u83D6\u841C\u8438\u8411\u8406\u83D4\u83DF\u840F\u8403\u83F8\u83F9\u83EA\u83C5\u83C0\u8426\u83F0\u83E1\u845C\u8451\u845A\u8459\u8473\u8487\u8488\u847A\u8489\u8478\u843C\u8446\u8469\u8476\u848C\u848E\u8431\u846D\u84C1\u84CD\u84D0\u84E6\u84BD\u84D3\u84CA\u84BF\u84BA\u84E0\u84A1\u84B9\u84B4\u8497\u84E5\u84E3\u850C\u750D\u8538\u84F0\u8539\u851F\u853A"
    ],
    [
        "de40",
        "\u8F45",
        32,
        "\u8F6A\u8F80\u8F8C\u8F92\u8F9D\u8FA0\u8FA1\u8FA2\u8FA4\u8FA5\u8FA6\u8FA7\u8FAA\u8FAC\u8FAD\u8FAE\u8FAF\u8FB2\u8FB3\u8FB4\u8FB5\u8FB7\u8FB8\u8FBA\u8FBB\u8FBC\u8FBF\u8FC0\u8FC3\u8FC6"
    ],
    [
        "de80",
        "\u8FC9",
        4,
        "\u8FCF\u8FD2\u8FD6\u8FD7\u8FDA\u8FE0\u8FE1\u8FE3\u8FE7\u8FEC\u8FEF\u8FF1\u8FF2\u8FF4\u8FF5\u8FF6\u8FFA\u8FFB\u8FFC\u8FFE\u8FFF\u9007\u9008\u900C\u900E\u9013\u9015\u9018\u8556\u853B\u84FF\u84FC\u8559\u8548\u8568\u8564\u855E\u857A\u77A2\u8543\u8572\u857B\u85A4\u85A8\u8587\u858F\u8579\u85AE\u859C\u8585\u85B9\u85B7\u85B0\u85D3\u85C1\u85DC\u85FF\u8627\u8605\u8629\u8616\u863C\u5EFE\u5F08\u593C\u5941\u8037\u5955\u595A\u5958\u530F\u5C22\u5C25\u5C2C\u5C34\u624C\u626A\u629F\u62BB\u62CA\u62DA\u62D7\u62EE\u6322\u62F6\u6339\u634B\u6343\u63AD\u63F6\u6371\u637A\u638E\u63B4\u636D\u63AC\u638A\u6369\u63AE\u63BC\u63F2\u63F8\u63E0\u63FF\u63C4\u63DE\u63CE\u6452\u63C6\u63BE\u6445\u6441\u640B\u641B\u6420\u640C\u6426\u6421\u645E\u6484\u646D\u6496"
    ],
    [
        "df40",
        "\u9019\u901C\u9023\u9024\u9025\u9027",
        5,
        "\u9030",
        4,
        "\u9037\u9039\u903A\u903D\u903F\u9040\u9043\u9045\u9046\u9048",
        4,
        "\u904E\u9054\u9055\u9056\u9059\u905A\u905C",
        5,
        "\u9064\u9066\u9067\u9069\u906A\u906B\u906C\u906F",
        4,
        "\u9076",
        6,
        "\u907E\u9081"
    ],
    [
        "df80",
        "\u9084\u9085\u9086\u9087\u9089\u908A\u908C",
        4,
        "\u9092\u9094\u9096\u9098\u909A\u909C\u909E\u909F\u90A0\u90A4\u90A5\u90A7\u90A8\u90A9\u90AB\u90AD\u90B2\u90B7\u90BC\u90BD\u90BF\u90C0\u647A\u64B7\u64B8\u6499\u64BA\u64C0\u64D0\u64D7\u64E4\u64E2\u6509\u6525\u652E\u5F0B\u5FD2\u7519\u5F11\u535F\u53F1\u53FD\u53E9\u53E8\u53FB\u5412\u5416\u5406\u544B\u5452\u5453\u5454\u5456\u5443\u5421\u5457\u5459\u5423\u5432\u5482\u5494\u5477\u5471\u5464\u549A\u549B\u5484\u5476\u5466\u549D\u54D0\u54AD\u54C2\u54B4\u54D2\u54A7\u54A6\u54D3\u54D4\u5472\u54A3\u54D5\u54BB\u54BF\u54CC\u54D9\u54DA\u54DC\u54A9\u54AA\u54A4\u54DD\u54CF\u54DE\u551B\u54E7\u5520\u54FD\u5514\u54F3\u5522\u5523\u550F\u5511\u5527\u552A\u5567\u558F\u55B5\u5549\u556D\u5541\u5555\u553F\u5550\u553C"
    ],
    [
        "e040",
        "\u90C2\u90C3\u90C6\u90C8\u90C9\u90CB\u90CC\u90CD\u90D2\u90D4\u90D5\u90D6\u90D8\u90D9\u90DA\u90DE\u90DF\u90E0\u90E3\u90E4\u90E5\u90E9\u90EA\u90EC\u90EE\u90F0\u90F1\u90F2\u90F3\u90F5\u90F6\u90F7\u90F9\u90FA\u90FB\u90FC\u90FF\u9100\u9101\u9103\u9105",
        19,
        "\u911A\u911B\u911C"
    ],
    [
        "e080",
        "\u911D\u911F\u9120\u9121\u9124",
        10,
        "\u9130\u9132",
        6,
        "\u913A",
        8,
        "\u9144\u5537\u5556\u5575\u5576\u5577\u5533\u5530\u555C\u558B\u55D2\u5583\u55B1\u55B9\u5588\u5581\u559F\u557E\u55D6\u5591\u557B\u55DF\u55BD\u55BE\u5594\u5599\u55EA\u55F7\u55C9\u561F\u55D1\u55EB\u55EC\u55D4\u55E6\u55DD\u55C4\u55EF\u55E5\u55F2\u55F3\u55CC\u55CD\u55E8\u55F5\u55E4\u8F94\u561E\u5608\u560C\u5601\u5624\u5623\u55FE\u5600\u5627\u562D\u5658\u5639\u5657\u562C\u564D\u5662\u5659\u565C\u564C\u5654\u5686\u5664\u5671\u566B\u567B\u567C\u5685\u5693\u56AF\u56D4\u56D7\u56DD\u56E1\u56F5\u56EB\u56F9\u56FF\u5704\u570A\u5709\u571C\u5E0F\u5E19\u5E14\u5E11\u5E31\u5E3B\u5E3C"
    ],
    [
        "e140",
        "\u9145\u9147\u9148\u9151\u9153\u9154\u9155\u9156\u9158\u9159\u915B\u915C\u915F\u9160\u9166\u9167\u9168\u916B\u916D\u9173\u917A\u917B\u917C\u9180",
        4,
        "\u9186\u9188\u918A\u918E\u918F\u9193",
        6,
        "\u919C",
        5,
        "\u91A4",
        5,
        "\u91AB\u91AC\u91B0\u91B1\u91B2\u91B3\u91B6\u91B7\u91B8\u91B9\u91BB"
    ],
    [
        "e180",
        "\u91BC",
        10,
        "\u91C8\u91CB\u91D0\u91D2",
        9,
        "\u91DD",
        8,
        "\u5E37\u5E44\u5E54\u5E5B\u5E5E\u5E61\u5C8C\u5C7A\u5C8D\u5C90\u5C96\u5C88\u5C98\u5C99\u5C91\u5C9A\u5C9C\u5CB5\u5CA2\u5CBD\u5CAC\u5CAB\u5CB1\u5CA3\u5CC1\u5CB7\u5CC4\u5CD2\u5CE4\u5CCB\u5CE5\u5D02\u5D03\u5D27\u5D26\u5D2E\u5D24\u5D1E\u5D06\u5D1B\u5D58\u5D3E\u5D34\u5D3D\u5D6C\u5D5B\u5D6F\u5D5D\u5D6B\u5D4B\u5D4A\u5D69\u5D74\u5D82\u5D99\u5D9D\u8C73\u5DB7\u5DC5\u5F73\u5F77\u5F82\u5F87\u5F89\u5F8C\u5F95\u5F99\u5F9C\u5FA8\u5FAD\u5FB5\u5FBC\u8862\u5F61\u72AD\u72B0\u72B4\u72B7\u72B8\u72C3\u72C1\u72CE\u72CD\u72D2\u72E8\u72EF\u72E9\u72F2\u72F4\u72F7\u7301\u72F3\u7303\u72FA"
    ],
    [
        "e240",
        "\u91E6",
        62
    ],
    [
        "e280",
        "\u9225",
        32,
        "\u72FB\u7317\u7313\u7321\u730A\u731E\u731D\u7315\u7322\u7339\u7325\u732C\u7338\u7331\u7350\u734D\u7357\u7360\u736C\u736F\u737E\u821B\u5925\u98E7\u5924\u5902\u9963\u9967",
        5,
        "\u9974\u9977\u997D\u9980\u9984\u9987\u998A\u998D\u9990\u9991\u9993\u9994\u9995\u5E80\u5E91\u5E8B\u5E96\u5EA5\u5EA0\u5EB9\u5EB5\u5EBE\u5EB3\u8D53\u5ED2\u5ED1\u5EDB\u5EE8\u5EEA\u81BA\u5FC4\u5FC9\u5FD6\u5FCF\u6003\u5FEE\u6004\u5FE1\u5FE4\u5FFE\u6005\u6006\u5FEA\u5FED\u5FF8\u6019\u6035\u6026\u601B\u600F\u600D\u6029\u602B\u600A\u603F\u6021\u6078\u6079\u607B\u607A\u6042"
    ],
    [
        "e340",
        "\u9246",
        45,
        "\u9275",
        16
    ],
    [
        "e380",
        "\u9286",
        7,
        "\u928F",
        24,
        "\u606A\u607D\u6096\u609A\u60AD\u609D\u6083\u6092\u608C\u609B\u60EC\u60BB\u60B1\u60DD\u60D8\u60C6\u60DA\u60B4\u6120\u6126\u6115\u6123\u60F4\u6100\u610E\u612B\u614A\u6175\u61AC\u6194\u61A7\u61B7\u61D4\u61F5\u5FDD\u96B3\u95E9\u95EB\u95F1\u95F3\u95F5\u95F6\u95FC\u95FE\u9603\u9604\u9606\u9608\u960A\u960B\u960C\u960D\u960F\u9612\u9615\u9616\u9617\u9619\u961A\u4E2C\u723F\u6215\u6C35\u6C54\u6C5C\u6C4A\u6CA3\u6C85\u6C90\u6C94\u6C8C\u6C68\u6C69\u6C74\u6C76\u6C86\u6CA9\u6CD0\u6CD4\u6CAD\u6CF7\u6CF8\u6CF1\u6CD7\u6CB2\u6CE0\u6CD6\u6CFA\u6CEB\u6CEE\u6CB1\u6CD3\u6CEF\u6CFE"
    ],
    [
        "e440",
        "\u92A8",
        5,
        "\u92AF",
        24,
        "\u92C9",
        31
    ],
    [
        "e480",
        "\u92E9",
        32,
        "\u6D39\u6D27\u6D0C\u6D43\u6D48\u6D07\u6D04\u6D19\u6D0E\u6D2B\u6D4D\u6D2E\u6D35\u6D1A\u6D4F\u6D52\u6D54\u6D33\u6D91\u6D6F\u6D9E\u6DA0\u6D5E\u6D93\u6D94\u6D5C\u6D60\u6D7C\u6D63\u6E1A\u6DC7\u6DC5\u6DDE\u6E0E\u6DBF\u6DE0\u6E11\u6DE6\u6DDD\u6DD9\u6E16\u6DAB\u6E0C\u6DAE\u6E2B\u6E6E\u6E4E\u6E6B\u6EB2\u6E5F\u6E86\u6E53\u6E54\u6E32\u6E25\u6E44\u6EDF\u6EB1\u6E98\u6EE0\u6F2D\u6EE2\u6EA5\u6EA7\u6EBD\u6EBB\u6EB7\u6ED7\u6EB4\u6ECF\u6E8F\u6EC2\u6E9F\u6F62\u6F46\u6F47\u6F24\u6F15\u6EF9\u6F2F\u6F36\u6F4B\u6F74\u6F2A\u6F09\u6F29\u6F89\u6F8D\u6F8C\u6F78\u6F72\u6F7C\u6F7A\u6FD1"
    ],
    [
        "e540",
        "\u930A",
        51,
        "\u933F",
        10
    ],
    [
        "e580",
        "\u934A",
        31,
        "\u936B\u6FC9\u6FA7\u6FB9\u6FB6\u6FC2\u6FE1\u6FEE\u6FDE\u6FE0\u6FEF\u701A\u7023\u701B\u7039\u7035\u704F\u705E\u5B80\u5B84\u5B95\u5B93\u5BA5\u5BB8\u752F\u9A9E\u6434\u5BE4\u5BEE\u8930\u5BF0\u8E47\u8B07\u8FB6\u8FD3\u8FD5\u8FE5\u8FEE\u8FE4\u8FE9\u8FE6\u8FF3\u8FE8\u9005\u9004\u900B\u9026\u9011\u900D\u9016\u9021\u9035\u9036\u902D\u902F\u9044\u9051\u9052\u9050\u9068\u9058\u9062\u905B\u66B9\u9074\u907D\u9082\u9088\u9083\u908B\u5F50\u5F57\u5F56\u5F58\u5C3B\u54AB\u5C50\u5C59\u5B71\u5C63\u5C66\u7FBC\u5F2A\u5F29\u5F2D\u8274\u5F3C\u9B3B\u5C6E\u5981\u5983\u598D\u59A9\u59AA\u59A3"
    ],
    [
        "e640",
        "\u936C",
        34,
        "\u9390",
        27
    ],
    [
        "e680",
        "\u93AC",
        29,
        "\u93CB\u93CC\u93CD\u5997\u59CA\u59AB\u599E\u59A4\u59D2\u59B2\u59AF\u59D7\u59BE\u5A05\u5A06\u59DD\u5A08\u59E3\u59D8\u59F9\u5A0C\u5A09\u5A32\u5A34\u5A11\u5A23\u5A13\u5A40\u5A67\u5A4A\u5A55\u5A3C\u5A62\u5A75\u80EC\u5AAA\u5A9B\u5A77\u5A7A\u5ABE\u5AEB\u5AB2\u5AD2\u5AD4\u5AB8\u5AE0\u5AE3\u5AF1\u5AD6\u5AE6\u5AD8\u5ADC\u5B09\u5B17\u5B16\u5B32\u5B37\u5B40\u5C15\u5C1C\u5B5A\u5B65\u5B73\u5B51\u5B53\u5B62\u9A75\u9A77\u9A78\u9A7A\u9A7F\u9A7D\u9A80\u9A81\u9A85\u9A88\u9A8A\u9A90\u9A92\u9A93\u9A96\u9A98\u9A9B\u9A9C\u9A9D\u9A9F\u9AA0\u9AA2\u9AA3\u9AA5\u9AA7\u7E9F\u7EA1\u7EA3\u7EA5\u7EA8\u7EA9"
    ],
    [
        "e740",
        "\u93CE",
        7,
        "\u93D7",
        54
    ],
    [
        "e780",
        "\u940E",
        32,
        "\u7EAD\u7EB0\u7EBE\u7EC0\u7EC1\u7EC2\u7EC9\u7ECB\u7ECC\u7ED0\u7ED4\u7ED7\u7EDB\u7EE0\u7EE1\u7EE8\u7EEB\u7EEE\u7EEF\u7EF1\u7EF2\u7F0D\u7EF6\u7EFA\u7EFB\u7EFE\u7F01\u7F02\u7F03\u7F07\u7F08\u7F0B\u7F0C\u7F0F\u7F11\u7F12\u7F17\u7F19\u7F1C\u7F1B\u7F1F\u7F21",
        6,
        "\u7F2A\u7F2B\u7F2C\u7F2D\u7F2F",
        4,
        "\u7F35\u5E7A\u757F\u5DDB\u753E\u9095\u738E\u7391\u73AE\u73A2\u739F\u73CF\u73C2\u73D1\u73B7\u73B3\u73C0\u73C9\u73C8\u73E5\u73D9\u987C\u740A\u73E9\u73E7\u73DE\u73BA\u73F2\u740F\u742A\u745B\u7426\u7425\u7428\u7430\u742E\u742C"
    ],
    [
        "e840",
        "\u942F",
        14,
        "\u943F",
        43,
        "\u946C\u946D\u946E\u946F"
    ],
    [
        "e880",
        "\u9470",
        20,
        "\u9491\u9496\u9498\u94C7\u94CF\u94D3\u94D4\u94DA\u94E6\u94FB\u951C\u9520\u741B\u741A\u7441\u745C\u7457\u7455\u7459\u7477\u746D\u747E\u749C\u748E\u7480\u7481\u7487\u748B\u749E\u74A8\u74A9\u7490\u74A7\u74D2\u74BA\u97EA\u97EB\u97EC\u674C\u6753\u675E\u6748\u6769\u67A5\u6787\u676A\u6773\u6798\u67A7\u6775\u67A8\u679E\u67AD\u678B\u6777\u677C\u67F0\u6809\u67D8\u680A\u67E9\u67B0\u680C\u67D9\u67B5\u67DA\u67B3\u67DD\u6800\u67C3\u67B8\u67E2\u680E\u67C1\u67FD\u6832\u6833\u6860\u6861\u684E\u6862\u6844\u6864\u6883\u681D\u6855\u6866\u6841\u6867\u6840\u683E\u684A\u6849\u6829\u68B5\u688F\u6874\u6877\u6893\u686B\u68C2\u696E\u68FC\u691F\u6920\u68F9"
    ],
    [
        "e940",
        "\u9527\u9533\u953D\u9543\u9548\u954B\u9555\u955A\u9560\u956E\u9574\u9575\u9577",
        7,
        "\u9580",
        42
    ],
    [
        "e980",
        "\u95AB",
        32,
        "\u6924\u68F0\u690B\u6901\u6957\u68E3\u6910\u6971\u6939\u6960\u6942\u695D\u6984\u696B\u6980\u6998\u6978\u6934\u69CC\u6987\u6988\u69CE\u6989\u6966\u6963\u6979\u699B\u69A7\u69BB\u69AB\u69AD\u69D4\u69B1\u69C1\u69CA\u69DF\u6995\u69E0\u698D\u69FF\u6A2F\u69ED\u6A17\u6A18\u6A65\u69F2\u6A44\u6A3E\u6AA0\u6A50\u6A5B\u6A35\u6A8E\u6A79\u6A3D\u6A28\u6A58\u6A7C\u6A91\u6A90\u6AA9\u6A97\u6AAB\u7337\u7352\u6B81\u6B82\u6B87\u6B84\u6B92\u6B93\u6B8D\u6B9A\u6B9B\u6BA1\u6BAA\u8F6B\u8F6D\u8F71\u8F72\u8F73\u8F75\u8F76\u8F78\u8F77\u8F79\u8F7A\u8F7C\u8F7E\u8F81\u8F82\u8F84\u8F87\u8F8B"
    ],
    [
        "ea40",
        "\u95CC",
        27,
        "\u95EC\u95FF\u9607\u9613\u9618\u961B\u961E\u9620\u9623",
        6,
        "\u962B\u962C\u962D\u962F\u9630\u9637\u9638\u9639\u963A\u963E\u9641\u9643\u964A\u964E\u964F\u9651\u9652\u9653\u9656\u9657"
    ],
    [
        "ea80",
        "\u9658\u9659\u965A\u965C\u965D\u965E\u9660\u9663\u9665\u9666\u966B\u966D",
        4,
        "\u9673\u9678",
        12,
        "\u9687\u9689\u968A\u8F8D\u8F8E\u8F8F\u8F98\u8F9A\u8ECE\u620B\u6217\u621B\u621F\u6222\u6221\u6225\u6224\u622C\u81E7\u74EF\u74F4\u74FF\u750F\u7511\u7513\u6534\u65EE\u65EF\u65F0\u660A\u6619\u6772\u6603\u6615\u6600\u7085\u66F7\u661D\u6634\u6631\u6636\u6635\u8006\u665F\u6654\u6641\u664F\u6656\u6661\u6657\u6677\u6684\u668C\u66A7\u669D\u66BE\u66DB\u66DC\u66E6\u66E9\u8D32\u8D33\u8D36\u8D3B\u8D3D\u8D40\u8D45\u8D46\u8D48\u8D49\u8D47\u8D4D\u8D55\u8D59\u89C7\u89CA\u89CB\u89CC\u89CE\u89CF\u89D0\u89D1\u726E\u729F\u725D\u7266\u726F\u727E\u727F\u7284\u728B\u728D\u728F\u7292\u6308\u6332\u63B0"
    ],
    [
        "eb40",
        "\u968C\u968E\u9691\u9692\u9693\u9695\u9696\u969A\u969B\u969D",
        9,
        "\u96A8",
        7,
        "\u96B1\u96B2\u96B4\u96B5\u96B7\u96B8\u96BA\u96BB\u96BF\u96C2\u96C3\u96C8\u96CA\u96CB\u96D0\u96D1\u96D3\u96D4\u96D6",
        9,
        "\u96E1",
        6,
        "\u96EB"
    ],
    [
        "eb80",
        "\u96EC\u96ED\u96EE\u96F0\u96F1\u96F2\u96F4\u96F5\u96F8\u96FA\u96FB\u96FC\u96FD\u96FF\u9702\u9703\u9705\u970A\u970B\u970C\u9710\u9711\u9712\u9714\u9715\u9717",
        4,
        "\u971D\u971F\u9720\u643F\u64D8\u8004\u6BEA\u6BF3\u6BFD\u6BF5\u6BF9\u6C05\u6C07\u6C06\u6C0D\u6C15\u6C18\u6C19\u6C1A\u6C21\u6C29\u6C24\u6C2A\u6C32\u6535\u6555\u656B\u724D\u7252\u7256\u7230\u8662\u5216\u809F\u809C\u8093\u80BC\u670A\u80BD\u80B1\u80AB\u80AD\u80B4\u80B7\u80E7\u80E8\u80E9\u80EA\u80DB\u80C2\u80C4\u80D9\u80CD\u80D7\u6710\u80DD\u80EB\u80F1\u80F4\u80ED\u810D\u810E\u80F2\u80FC\u6715\u8112\u8C5A\u8136\u811E\u812C\u8118\u8132\u8148\u814C\u8153\u8174\u8159\u815A\u8171\u8160\u8169\u817C\u817D\u816D\u8167\u584D\u5AB5\u8188\u8182\u8191\u6ED5\u81A3\u81AA\u81CC\u6726\u81CA\u81BB"
    ],
    [
        "ec40",
        "\u9721",
        8,
        "\u972B\u972C\u972E\u972F\u9731\u9733",
        4,
        "\u973A\u973B\u973C\u973D\u973F",
        18,
        "\u9754\u9755\u9757\u9758\u975A\u975C\u975D\u975F\u9763\u9764\u9766\u9767\u9768\u976A",
        7
    ],
    [
        "ec80",
        "\u9772\u9775\u9777",
        4,
        "\u977D",
        7,
        "\u9786",
        4,
        "\u978C\u978E\u978F\u9790\u9793\u9795\u9796\u9797\u9799",
        4,
        "\u81C1\u81A6\u6B24\u6B37\u6B39\u6B43\u6B46\u6B59\u98D1\u98D2\u98D3\u98D5\u98D9\u98DA\u6BB3\u5F40\u6BC2\u89F3\u6590\u9F51\u6593\u65BC\u65C6\u65C4\u65C3\u65CC\u65CE\u65D2\u65D6\u7080\u709C\u7096\u709D\u70BB\u70C0\u70B7\u70AB\u70B1\u70E8\u70CA\u7110\u7113\u7116\u712F\u7131\u7173\u715C\u7168\u7145\u7172\u714A\u7178\u717A\u7198\u71B3\u71B5\u71A8\u71A0\u71E0\u71D4\u71E7\u71F9\u721D\u7228\u706C\u7118\u7166\u71B9\u623E\u623D\u6243\u6248\u6249\u793B\u7940\u7946\u7949\u795B\u795C\u7953\u795A\u7962\u7957\u7960\u796F\u7967\u797A\u7985\u798A\u799A\u79A7\u79B3\u5FD1\u5FD0"
    ],
    [
        "ed40",
        "\u979E\u979F\u97A1\u97A2\u97A4",
        6,
        "\u97AC\u97AE\u97B0\u97B1\u97B3\u97B5",
        46
    ],
    [
        "ed80",
        "\u97E4\u97E5\u97E8\u97EE",
        4,
        "\u97F4\u97F7",
        23,
        "\u603C\u605D\u605A\u6067\u6041\u6059\u6063\u60AB\u6106\u610D\u615D\u61A9\u619D\u61CB\u61D1\u6206\u8080\u807F\u6C93\u6CF6\u6DFC\u77F6\u77F8\u7800\u7809\u7817\u7818\u7811\u65AB\u782D\u781C\u781D\u7839\u783A\u783B\u781F\u783C\u7825\u782C\u7823\u7829\u784E\u786D\u7856\u7857\u7826\u7850\u7847\u784C\u786A\u789B\u7893\u789A\u7887\u789C\u78A1\u78A3\u78B2\u78B9\u78A5\u78D4\u78D9\u78C9\u78EC\u78F2\u7905\u78F4\u7913\u7924\u791E\u7934\u9F9B\u9EF9\u9EFB\u9EFC\u76F1\u7704\u770D\u76F9\u7707\u7708\u771A\u7722\u7719\u772D\u7726\u7735\u7738\u7750\u7751\u7747\u7743\u775A\u7768"
    ],
    [
        "ee40",
        "\u980F",
        62
    ],
    [
        "ee80",
        "\u984E",
        32,
        "\u7762\u7765\u777F\u778D\u777D\u7780\u778C\u7791\u779F\u77A0\u77B0\u77B5\u77BD\u753A\u7540\u754E\u754B\u7548\u755B\u7572\u7579\u7583\u7F58\u7F61\u7F5F\u8A48\u7F68\u7F74\u7F71\u7F79\u7F81\u7F7E\u76CD\u76E5\u8832\u9485\u9486\u9487\u948B\u948A\u948C\u948D\u948F\u9490\u9494\u9497\u9495\u949A\u949B\u949C\u94A3\u94A4\u94AB\u94AA\u94AD\u94AC\u94AF\u94B0\u94B2\u94B4\u94B6",
        4,
        "\u94BC\u94BD\u94BF\u94C4\u94C8",
        6,
        "\u94D0\u94D1\u94D2\u94D5\u94D6\u94D7\u94D9\u94D8\u94DB\u94DE\u94DF\u94E0\u94E2\u94E4\u94E5\u94E7\u94E8\u94EA"
    ],
    [
        "ef40",
        "\u986F",
        5,
        "\u988B\u988E\u9892\u9895\u9899\u98A3\u98A8",
        37,
        "\u98CF\u98D0\u98D4\u98D6\u98D7\u98DB\u98DC\u98DD\u98E0",
        4
    ],
    [
        "ef80",
        "\u98E5\u98E6\u98E9",
        30,
        "\u94E9\u94EB\u94EE\u94EF\u94F3\u94F4\u94F5\u94F7\u94F9\u94FC\u94FD\u94FF\u9503\u9502\u9506\u9507\u9509\u950A\u950D\u950E\u950F\u9512",
        4,
        "\u9518\u951B\u951D\u951E\u951F\u9522\u952A\u952B\u9529\u952C\u9531\u9532\u9534\u9536\u9537\u9538\u953C\u953E\u953F\u9542\u9535\u9544\u9545\u9546\u9549\u954C\u954E\u954F\u9552\u9553\u9554\u9556\u9557\u9558\u9559\u955B\u955E\u955F\u955D\u9561\u9562\u9564",
        8,
        "\u956F\u9571\u9572\u9573\u953A\u77E7\u77EC\u96C9\u79D5\u79ED\u79E3\u79EB\u7A06\u5D47\u7A03\u7A02\u7A1E\u7A14"
    ],
    [
        "f040",
        "\u9908",
        4,
        "\u990E\u990F\u9911",
        28,
        "\u992F",
        26
    ],
    [
        "f080",
        "\u994A",
        9,
        "\u9956",
        12,
        "\u9964\u9966\u9973\u9978\u9979\u997B\u997E\u9982\u9983\u9989\u7A39\u7A37\u7A51\u9ECF\u99A5\u7A70\u7688\u768E\u7693\u7699\u76A4\u74DE\u74E0\u752C\u9E20\u9E22\u9E28",
        4,
        "\u9E32\u9E31\u9E36\u9E38\u9E37\u9E39\u9E3A\u9E3E\u9E41\u9E42\u9E44\u9E46\u9E47\u9E48\u9E49\u9E4B\u9E4C\u9E4E\u9E51\u9E55\u9E57\u9E5A\u9E5B\u9E5C\u9E5E\u9E63\u9E66",
        6,
        "\u9E71\u9E6D\u9E73\u7592\u7594\u7596\u75A0\u759D\u75AC\u75A3\u75B3\u75B4\u75B8\u75C4\u75B1\u75B0\u75C3\u75C2\u75D6\u75CD\u75E3\u75E8\u75E6\u75E4\u75EB\u75E7\u7603\u75F1\u75FC\u75FF\u7610\u7600\u7605\u760C\u7617\u760A\u7625\u7618\u7615\u7619"
    ],
    [
        "f140",
        "\u998C\u998E\u999A",
        10,
        "\u99A6\u99A7\u99A9",
        47
    ],
    [
        "f180",
        "\u99D9",
        32,
        "\u761B\u763C\u7622\u7620\u7640\u762D\u7630\u763F\u7635\u7643\u763E\u7633\u764D\u765E\u7654\u765C\u7656\u766B\u766F\u7FCA\u7AE6\u7A78\u7A79\u7A80\u7A86\u7A88\u7A95\u7AA6\u7AA0\u7AAC\u7AA8\u7AAD\u7AB3\u8864\u8869\u8872\u887D\u887F\u8882\u88A2\u88C6\u88B7\u88BC\u88C9\u88E2\u88CE\u88E3\u88E5\u88F1\u891A\u88FC\u88E8\u88FE\u88F0\u8921\u8919\u8913\u891B\u890A\u8934\u892B\u8936\u8941\u8966\u897B\u758B\u80E5\u76B2\u76B4\u77DC\u8012\u8014\u8016\u801C\u8020\u8022\u8025\u8026\u8027\u8029\u8028\u8031\u800B\u8035\u8043\u8046\u804D\u8052\u8069\u8071\u8983\u9878\u9880\u9883"
    ],
    [
        "f240",
        "\u99FA",
        62
    ],
    [
        "f280",
        "\u9A39",
        32,
        "\u9889\u988C\u988D\u988F\u9894\u989A\u989B\u989E\u989F\u98A1\u98A2\u98A5\u98A6\u864D\u8654\u866C\u866E\u867F\u867A\u867C\u867B\u86A8\u868D\u868B\u86AC\u869D\u86A7\u86A3\u86AA\u8693\u86A9\u86B6\u86C4\u86B5\u86CE\u86B0\u86BA\u86B1\u86AF\u86C9\u86CF\u86B4\u86E9\u86F1\u86F2\u86ED\u86F3\u86D0\u8713\u86DE\u86F4\u86DF\u86D8\u86D1\u8703\u8707\u86F8\u8708\u870A\u870D\u8709\u8723\u873B\u871E\u8725\u872E\u871A\u873E\u8748\u8734\u8731\u8729\u8737\u873F\u8782\u8722\u877D\u877E\u877B\u8760\u8770\u874C\u876E\u878B\u8753\u8763\u877C\u8764\u8759\u8765\u8793\u87AF\u87A8\u87D2"
    ],
    [
        "f340",
        "\u9A5A",
        17,
        "\u9A72\u9A83\u9A89\u9A8D\u9A8E\u9A94\u9A95\u9A99\u9AA6\u9AA9",
        6,
        "\u9AB2\u9AB3\u9AB4\u9AB5\u9AB9\u9ABB\u9ABD\u9ABE\u9ABF\u9AC3\u9AC4\u9AC6",
        4,
        "\u9ACD\u9ACE\u9ACF\u9AD0\u9AD2\u9AD4\u9AD5\u9AD6\u9AD7\u9AD9\u9ADA\u9ADB\u9ADC"
    ],
    [
        "f380",
        "\u9ADD\u9ADE\u9AE0\u9AE2\u9AE3\u9AE4\u9AE5\u9AE7\u9AE8\u9AE9\u9AEA\u9AEC\u9AEE\u9AF0",
        8,
        "\u9AFA\u9AFC",
        6,
        "\u9B04\u9B05\u9B06\u87C6\u8788\u8785\u87AD\u8797\u8783\u87AB\u87E5\u87AC\u87B5\u87B3\u87CB\u87D3\u87BD\u87D1\u87C0\u87CA\u87DB\u87EA\u87E0\u87EE\u8816\u8813\u87FE\u880A\u881B\u8821\u8839\u883C\u7F36\u7F42\u7F44\u7F45\u8210\u7AFA\u7AFD\u7B08\u7B03\u7B04\u7B15\u7B0A\u7B2B\u7B0F\u7B47\u7B38\u7B2A\u7B19\u7B2E\u7B31\u7B20\u7B25\u7B24\u7B33\u7B3E\u7B1E\u7B58\u7B5A\u7B45\u7B75\u7B4C\u7B5D\u7B60\u7B6E\u7B7B\u7B62\u7B72\u7B71\u7B90\u7BA6\u7BA7\u7BB8\u7BAC\u7B9D\u7BA8\u7B85\u7BAA\u7B9C\u7BA2\u7BAB\u7BB4\u7BD1\u7BC1\u7BCC\u7BDD\u7BDA\u7BE5\u7BE6\u7BEA\u7C0C\u7BFE\u7BFC\u7C0F\u7C16\u7C0B"
    ],
    [
        "f440",
        "\u9B07\u9B09",
        5,
        "\u9B10\u9B11\u9B12\u9B14",
        10,
        "\u9B20\u9B21\u9B22\u9B24",
        10,
        "\u9B30\u9B31\u9B33",
        7,
        "\u9B3D\u9B3E\u9B3F\u9B40\u9B46\u9B4A\u9B4B\u9B4C\u9B4E\u9B50\u9B52\u9B53\u9B55",
        5
    ],
    [
        "f480",
        "\u9B5B",
        32,
        "\u7C1F\u7C2A\u7C26\u7C38\u7C41\u7C40\u81FE\u8201\u8202\u8204\u81EC\u8844\u8221\u8222\u8223\u822D\u822F\u8228\u822B\u8238\u823B\u8233\u8234\u823E\u8244\u8249\u824B\u824F\u825A\u825F\u8268\u887E\u8885\u8888\u88D8\u88DF\u895E\u7F9D\u7F9F\u7FA7\u7FAF\u7FB0\u7FB2\u7C7C\u6549\u7C91\u7C9D\u7C9C\u7C9E\u7CA2\u7CB2\u7CBC\u7CBD\u7CC1\u7CC7\u7CCC\u7CCD\u7CC8\u7CC5\u7CD7\u7CE8\u826E\u66A8\u7FBF\u7FCE\u7FD5\u7FE5\u7FE1\u7FE6\u7FE9\u7FEE\u7FF3\u7CF8\u7D77\u7DA6\u7DAE\u7E47\u7E9B\u9EB8\u9EB4\u8D73\u8D84\u8D94\u8D91\u8DB1\u8D67\u8D6D\u8C47\u8C49\u914A\u9150\u914E\u914F\u9164"
    ],
    [
        "f540",
        "\u9B7C",
        62
    ],
    [
        "f580",
        "\u9BBB",
        32,
        "\u9162\u9161\u9170\u9169\u916F\u917D\u917E\u9172\u9174\u9179\u918C\u9185\u9190\u918D\u9191\u91A2\u91A3\u91AA\u91AD\u91AE\u91AF\u91B5\u91B4\u91BA\u8C55\u9E7E\u8DB8\u8DEB\u8E05\u8E59\u8E69\u8DB5\u8DBF\u8DBC\u8DBA\u8DC4\u8DD6\u8DD7\u8DDA\u8DDE\u8DCE\u8DCF\u8DDB\u8DC6\u8DEC\u8DF7\u8DF8\u8DE3\u8DF9\u8DFB\u8DE4\u8E09\u8DFD\u8E14\u8E1D\u8E1F\u8E2C\u8E2E\u8E23\u8E2F\u8E3A\u8E40\u8E39\u8E35\u8E3D\u8E31\u8E49\u8E41\u8E42\u8E51\u8E52\u8E4A\u8E70\u8E76\u8E7C\u8E6F\u8E74\u8E85\u8E8F\u8E94\u8E90\u8E9C\u8E9E\u8C78\u8C82\u8C8A\u8C85\u8C98\u8C94\u659B\u89D6\u89DE\u89DA\u89DC"
    ],
    [
        "f640",
        "\u9BDC",
        62
    ],
    [
        "f680",
        "\u9C1B",
        32,
        "\u89E5\u89EB\u89EF\u8A3E\u8B26\u9753\u96E9\u96F3\u96EF\u9706\u9701\u9708\u970F\u970E\u972A\u972D\u9730\u973E\u9F80\u9F83\u9F85",
        5,
        "\u9F8C\u9EFE\u9F0B\u9F0D\u96B9\u96BC\u96BD\u96CE\u96D2\u77BF\u96E0\u928E\u92AE\u92C8\u933E\u936A\u93CA\u938F\u943E\u946B\u9C7F\u9C82\u9C85\u9C86\u9C87\u9C88\u7A23\u9C8B\u9C8E\u9C90\u9C91\u9C92\u9C94\u9C95\u9C9A\u9C9B\u9C9E",
        5,
        "\u9CA5",
        4,
        "\u9CAB\u9CAD\u9CAE\u9CB0",
        7,
        "\u9CBA\u9CBB\u9CBC\u9CBD\u9CC4\u9CC5\u9CC6\u9CC7\u9CCA\u9CCB"
    ],
    [
        "f740",
        "\u9C3C",
        62
    ],
    [
        "f780",
        "\u9C7B\u9C7D\u9C7E\u9C80\u9C83\u9C84\u9C89\u9C8A\u9C8C\u9C8F\u9C93\u9C96\u9C97\u9C98\u9C99\u9C9D\u9CAA\u9CAC\u9CAF\u9CB9\u9CBE",
        4,
        "\u9CC8\u9CC9\u9CD1\u9CD2\u9CDA\u9CDB\u9CE0\u9CE1\u9CCC",
        4,
        "\u9CD3\u9CD4\u9CD5\u9CD7\u9CD8\u9CD9\u9CDC\u9CDD\u9CDF\u9CE2\u977C\u9785\u9791\u9792\u9794\u97AF\u97AB\u97A3\u97B2\u97B4\u9AB1\u9AB0\u9AB7\u9E58\u9AB6\u9ABA\u9ABC\u9AC1\u9AC0\u9AC5\u9AC2\u9ACB\u9ACC\u9AD1\u9B45\u9B43\u9B47\u9B49\u9B48\u9B4D\u9B51\u98E8\u990D\u992E\u9955\u9954\u9ADF\u9AE1\u9AE6\u9AEF\u9AEB\u9AFB\u9AED\u9AF9\u9B08\u9B0F\u9B13\u9B1F\u9B23\u9EBD\u9EBE\u7E3B\u9E82\u9E87\u9E88\u9E8B\u9E92\u93D6\u9E9D\u9E9F\u9EDB\u9EDC\u9EDD\u9EE0\u9EDF\u9EE2\u9EE9\u9EE7\u9EE5\u9EEA\u9EEF\u9F22\u9F2C\u9F2F\u9F39\u9F37\u9F3D\u9F3E\u9F44"
    ],
    [
        "f840",
        "\u9CE3",
        62
    ],
    [
        "f880",
        "\u9D22",
        32
    ],
    [
        "f940",
        "\u9D43",
        62
    ],
    [
        "f980",
        "\u9D82",
        32
    ],
    [
        "fa40",
        "\u9DA3",
        62
    ],
    [
        "fa80",
        "\u9DE2",
        32
    ],
    [
        "fb40",
        "\u9E03",
        27,
        "\u9E24\u9E27\u9E2E\u9E30\u9E34\u9E3B\u9E3C\u9E40\u9E4D\u9E50\u9E52\u9E53\u9E54\u9E56\u9E59\u9E5D\u9E5F\u9E60\u9E61\u9E62\u9E65\u9E6E\u9E6F\u9E72\u9E74",
        9,
        "\u9E80"
    ],
    [
        "fb80",
        "\u9E81\u9E83\u9E84\u9E85\u9E86\u9E89\u9E8A\u9E8C",
        5,
        "\u9E94",
        8,
        "\u9E9E\u9EA0",
        5,
        "\u9EA7\u9EA8\u9EA9\u9EAA"
    ],
    [
        "fc40",
        "\u9EAB",
        8,
        "\u9EB5\u9EB6\u9EB7\u9EB9\u9EBA\u9EBC\u9EBF",
        4,
        "\u9EC5\u9EC6\u9EC7\u9EC8\u9ECA\u9ECB\u9ECC\u9ED0\u9ED2\u9ED3\u9ED5\u9ED6\u9ED7\u9ED9\u9EDA\u9EDE\u9EE1\u9EE3\u9EE4\u9EE6\u9EE8\u9EEB\u9EEC\u9EED\u9EEE\u9EF0",
        8,
        "\u9EFA\u9EFD\u9EFF",
        6
    ],
    [
        "fc80",
        "\u9F06",
        4,
        "\u9F0C\u9F0F\u9F11\u9F12\u9F14\u9F15\u9F16\u9F18\u9F1A",
        5,
        "\u9F21\u9F23",
        8,
        "\u9F2D\u9F2E\u9F30\u9F31"
    ],
    [
        "fd40",
        "\u9F32",
        4,
        "\u9F38\u9F3A\u9F3C\u9F3F",
        4,
        "\u9F45",
        10,
        "\u9F52",
        38
    ],
    [
        "fd80",
        "\u9F79",
        5,
        "\u9F81\u9F82\u9F8D",
        11,
        "\u9F9C\u9F9D\u9F9E\u9FA1",
        4,
        "\uF92C\uF979\uF995\uF9E7\uF9F1"
    ],
    [
        "fe40",
        "\uFA0C\uFA0D\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA18\uFA1F\uFA20\uFA21\uFA23\uFA24\uFA27\uFA28\uFA29"
    ]
];
var $07144aea14354eb9$var$cp936$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$cp936
});
var $07144aea14354eb9$var$gbkAdded = [
    [
        "a140",
        "\uE4C6",
        62
    ],
    [
        "a180",
        "\uE505",
        32
    ],
    [
        "a240",
        "\uE526",
        62
    ],
    [
        "a280",
        "\uE565",
        32
    ],
    [
        "a2ab",
        "\uE766",
        5
    ],
    [
        "a2e3",
        "\u20AC\uE76D"
    ],
    [
        "a2ef",
        "\uE76E\uE76F"
    ],
    [
        "a2fd",
        "\uE770\uE771"
    ],
    [
        "a340",
        "\uE586",
        62
    ],
    [
        "a380",
        "\uE5C5",
        31,
        "\u3000"
    ],
    [
        "a440",
        "\uE5E6",
        62
    ],
    [
        "a480",
        "\uE625",
        32
    ],
    [
        "a4f4",
        "\uE772",
        10
    ],
    [
        "a540",
        "\uE646",
        62
    ],
    [
        "a580",
        "\uE685",
        32
    ],
    [
        "a5f7",
        "\uE77D",
        7
    ],
    [
        "a640",
        "\uE6A6",
        62
    ],
    [
        "a680",
        "\uE6E5",
        32
    ],
    [
        "a6b9",
        "\uE785",
        7
    ],
    [
        "a6d9",
        "\uE78D",
        6
    ],
    [
        "a6ec",
        "\uE794\uE795"
    ],
    [
        "a6f3",
        "\uE796"
    ],
    [
        "a6f6",
        "\uE797",
        8
    ],
    [
        "a740",
        "\uE706",
        62
    ],
    [
        "a780",
        "\uE745",
        32
    ],
    [
        "a7c2",
        "\uE7A0",
        14
    ],
    [
        "a7f2",
        "\uE7AF",
        12
    ],
    [
        "a896",
        "\uE7BC",
        10
    ],
    [
        "a8bc",
        "\uE7C7"
    ],
    [
        "a8bf",
        "\u01F9"
    ],
    [
        "a8c1",
        "\uE7C9\uE7CA\uE7CB\uE7CC"
    ],
    [
        "a8ea",
        "\uE7CD",
        20
    ],
    [
        "a958",
        "\uE7E2"
    ],
    [
        "a95b",
        "\uE7E3"
    ],
    [
        "a95d",
        "\uE7E4\uE7E5\uE7E6"
    ],
    [
        "a989",
        "\u303E\u2FF0",
        11
    ],
    [
        "a997",
        "\uE7F4",
        12
    ],
    [
        "a9f0",
        "\uE801",
        14
    ],
    [
        "aaa1",
        "\uE000",
        93
    ],
    [
        "aba1",
        "\uE05E",
        93
    ],
    [
        "aca1",
        "\uE0BC",
        93
    ],
    [
        "ada1",
        "\uE11A",
        93
    ],
    [
        "aea1",
        "\uE178",
        93
    ],
    [
        "afa1",
        "\uE1D6",
        93
    ],
    [
        "d7fa",
        "\uE810",
        4
    ],
    [
        "f8a1",
        "\uE234",
        93
    ],
    [
        "f9a1",
        "\uE292",
        93
    ],
    [
        "faa1",
        "\uE2F0",
        93
    ],
    [
        "fba1",
        "\uE34E",
        93
    ],
    [
        "fca1",
        "\uE3AC",
        93
    ],
    [
        "fda1",
        "\uE40A",
        93
    ],
    [
        "fe50",
        "\u2E81\uE816\uE817\uE818\u2E84\u3473\u3447\u2E88\u2E8B\uE81E\u359E\u361A\u360E\u2E8C\u2E97\u396E\u3918\uE826\u39CF\u39DF\u3A73\u39D0\uE82B\uE82C\u3B4E\u3C6E\u3CE0\u2EA7\uE831\uE832\u2EAA\u4056\u415F\u2EAE\u4337\u2EB3\u2EB6\u2EB7\uE83B\u43B1\u43AC\u2EBB\u43DD\u44D6\u4661\u464C\uE843"
    ],
    [
        "fe80",
        "\u4723\u4729\u477C\u478D\u2ECA\u4947\u497A\u497D\u4982\u4983\u4985\u4986\u499F\u499B\u49B7\u49B6\uE854\uE855\u4CA3\u4C9F\u4CA0\u4CA1\u4C77\u4CA2\u4D13",
        6,
        "\u4DAE\uE864\uE468",
        93
    ]
];
var $07144aea14354eb9$var$gbkAdded$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$gbkAdded
});
var $07144aea14354eb9$var$uChars = [
    128,
    165,
    169,
    178,
    184,
    216,
    226,
    235,
    238,
    244,
    248,
    251,
    253,
    258,
    276,
    284,
    300,
    325,
    329,
    334,
    364,
    463,
    465,
    467,
    469,
    471,
    473,
    475,
    477,
    506,
    594,
    610,
    712,
    716,
    730,
    930,
    938,
    962,
    970,
    1026,
    1104,
    1106,
    8209,
    8215,
    8218,
    8222,
    8231,
    8241,
    8244,
    8246,
    8252,
    8365,
    8452,
    8454,
    8458,
    8471,
    8482,
    8556,
    8570,
    8596,
    8602,
    8713,
    8720,
    8722,
    8726,
    8731,
    8737,
    8740,
    8742,
    8748,
    8751,
    8760,
    8766,
    8777,
    8781,
    8787,
    8802,
    8808,
    8816,
    8854,
    8858,
    8870,
    8896,
    8979,
    9322,
    9372,
    9548,
    9588,
    9616,
    9622,
    9634,
    9652,
    9662,
    9672,
    9676,
    9680,
    9702,
    9735,
    9738,
    9793,
    9795,
    11906,
    11909,
    11913,
    11917,
    11928,
    11944,
    11947,
    11951,
    11956,
    11960,
    11964,
    11979,
    12284,
    12292,
    12312,
    12319,
    12330,
    12351,
    12436,
    12447,
    12535,
    12543,
    12586,
    12842,
    12850,
    12964,
    13200,
    13215,
    13218,
    13253,
    13263,
    13267,
    13270,
    13384,
    13428,
    13727,
    13839,
    13851,
    14617,
    14703,
    14801,
    14816,
    14964,
    15183,
    15471,
    15585,
    16471,
    16736,
    17208,
    17325,
    17330,
    17374,
    17623,
    17997,
    18018,
    18212,
    18218,
    18301,
    18318,
    18760,
    18811,
    18814,
    18820,
    18823,
    18844,
    18848,
    18872,
    19576,
    19620,
    19738,
    19887,
    40870,
    59244,
    59336,
    59367,
    59413,
    59417,
    59423,
    59431,
    59437,
    59443,
    59452,
    59460,
    59478,
    59493,
    63789,
    63866,
    63894,
    63976,
    63986,
    64016,
    64018,
    64021,
    64025,
    64034,
    64037,
    64042,
    65074,
    65093,
    65107,
    65112,
    65127,
    65132,
    65375,
    65510,
    65536
];
var $07144aea14354eb9$var$gbChars = [
    0,
    36,
    38,
    45,
    50,
    81,
    89,
    95,
    96,
    100,
    103,
    104,
    105,
    109,
    126,
    133,
    148,
    172,
    175,
    179,
    208,
    306,
    307,
    308,
    309,
    310,
    311,
    312,
    313,
    341,
    428,
    443,
    544,
    545,
    558,
    741,
    742,
    749,
    750,
    805,
    819,
    820,
    7922,
    7924,
    7925,
    7927,
    7934,
    7943,
    7944,
    7945,
    7950,
    8062,
    8148,
    8149,
    8152,
    8164,
    8174,
    8236,
    8240,
    8262,
    8264,
    8374,
    8380,
    8381,
    8384,
    8388,
    8390,
    8392,
    8393,
    8394,
    8396,
    8401,
    8406,
    8416,
    8419,
    8424,
    8437,
    8439,
    8445,
    8482,
    8485,
    8496,
    8521,
    8603,
    8936,
    8946,
    9046,
    9050,
    9063,
    9066,
    9076,
    9092,
    9100,
    9108,
    9111,
    9113,
    9131,
    9162,
    9164,
    9218,
    9219,
    11329,
    11331,
    11334,
    11336,
    11346,
    11361,
    11363,
    11366,
    11370,
    11372,
    11375,
    11389,
    11682,
    11686,
    11687,
    11692,
    11694,
    11714,
    11716,
    11723,
    11725,
    11730,
    11736,
    11982,
    11989,
    12102,
    12336,
    12348,
    12350,
    12384,
    12393,
    12395,
    12397,
    12510,
    12553,
    12851,
    12962,
    12973,
    13738,
    13823,
    13919,
    13933,
    14080,
    14298,
    14585,
    14698,
    15583,
    15847,
    16318,
    16434,
    16438,
    16481,
    16729,
    17102,
    17122,
    17315,
    17320,
    17402,
    17418,
    17859,
    17909,
    17911,
    17915,
    17916,
    17936,
    17939,
    17961,
    18664,
    18703,
    18814,
    18962,
    19043,
    33469,
    33470,
    33471,
    33484,
    33485,
    33490,
    33497,
    33501,
    33505,
    33513,
    33520,
    33536,
    33550,
    37845,
    37921,
    37948,
    38029,
    38038,
    38064,
    38065,
    38066,
    38069,
    38075,
    38076,
    38078,
    39108,
    39109,
    39113,
    39114,
    39115,
    39116,
    39265,
    39394,
    189000
];
var $07144aea14354eb9$var$gb18030Ranges = {
    uChars: $07144aea14354eb9$var$uChars,
    gbChars: $07144aea14354eb9$var$gbChars
};
var $07144aea14354eb9$var$gb18030Ranges$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    uChars: $07144aea14354eb9$var$uChars,
    gbChars: $07144aea14354eb9$var$gbChars,
    'default': $07144aea14354eb9$var$gb18030Ranges
});
var $07144aea14354eb9$var$cp949 = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "8141",
        "\uAC02\uAC03\uAC05\uAC06\uAC0B",
        4,
        "\uAC18\uAC1E\uAC1F\uAC21\uAC22\uAC23\uAC25",
        6,
        "\uAC2E\uAC32\uAC33\uAC34"
    ],
    [
        "8161",
        "\uAC35\uAC36\uAC37\uAC3A\uAC3B\uAC3D\uAC3E\uAC3F\uAC41",
        9,
        "\uAC4C\uAC4E",
        5,
        "\uAC55"
    ],
    [
        "8181",
        "\uAC56\uAC57\uAC59\uAC5A\uAC5B\uAC5D",
        18,
        "\uAC72\uAC73\uAC75\uAC76\uAC79\uAC7B",
        4,
        "\uAC82\uAC87\uAC88\uAC8D\uAC8E\uAC8F\uAC91\uAC92\uAC93\uAC95",
        6,
        "\uAC9E\uACA2",
        5,
        "\uACAB\uACAD\uACAE\uACB1",
        6,
        "\uACBA\uACBE\uACBF\uACC0\uACC2\uACC3\uACC5\uACC6\uACC7\uACC9\uACCA\uACCB\uACCD",
        7,
        "\uACD6\uACD8",
        7,
        "\uACE2\uACE3\uACE5\uACE6\uACE9\uACEB\uACED\uACEE\uACF2\uACF4\uACF7",
        4,
        "\uACFE\uACFF\uAD01\uAD02\uAD03\uAD05\uAD07",
        4,
        "\uAD0E\uAD10\uAD12\uAD13"
    ],
    [
        "8241",
        "\uAD14\uAD15\uAD16\uAD17\uAD19\uAD1A\uAD1B\uAD1D\uAD1E\uAD1F\uAD21",
        7,
        "\uAD2A\uAD2B\uAD2E",
        5
    ],
    [
        "8261",
        "\uAD36\uAD37\uAD39\uAD3A\uAD3B\uAD3D",
        6,
        "\uAD46\uAD48\uAD4A",
        5,
        "\uAD51\uAD52\uAD53\uAD55\uAD56\uAD57"
    ],
    [
        "8281",
        "\uAD59",
        7,
        "\uAD62\uAD64",
        7,
        "\uAD6E\uAD6F\uAD71\uAD72\uAD77\uAD78\uAD79\uAD7A\uAD7E\uAD80\uAD83",
        4,
        "\uAD8A\uAD8B\uAD8D\uAD8E\uAD8F\uAD91",
        10,
        "\uAD9E",
        5,
        "\uADA5",
        17,
        "\uADB8",
        7,
        "\uADC2\uADC3\uADC5\uADC6\uADC7\uADC9",
        6,
        "\uADD2\uADD4",
        7,
        "\uADDD\uADDE\uADDF\uADE1\uADE2\uADE3\uADE5",
        18
    ],
    [
        "8341",
        "\uADFA\uADFB\uADFD\uADFE\uAE02",
        5,
        "\uAE0A\uAE0C\uAE0E",
        5,
        "\uAE15",
        7
    ],
    [
        "8361",
        "\uAE1D",
        18,
        "\uAE32\uAE33\uAE35\uAE36\uAE39\uAE3B\uAE3C"
    ],
    [
        "8381",
        "\uAE3D\uAE3E\uAE3F\uAE42\uAE44\uAE47\uAE48\uAE49\uAE4B\uAE4F\uAE51\uAE52\uAE53\uAE55\uAE57",
        4,
        "\uAE5E\uAE62\uAE63\uAE64\uAE66\uAE67\uAE6A\uAE6B\uAE6D\uAE6E\uAE6F\uAE71",
        6,
        "\uAE7A\uAE7E",
        5,
        "\uAE86",
        5,
        "\uAE8D",
        46,
        "\uAEBF\uAEC1\uAEC2\uAEC3\uAEC5",
        6,
        "\uAECE\uAED2",
        5,
        "\uAEDA\uAEDB\uAEDD",
        8
    ],
    [
        "8441",
        "\uAEE6\uAEE7\uAEE9\uAEEA\uAEEC\uAEEE",
        5,
        "\uAEF5\uAEF6\uAEF7\uAEF9\uAEFA\uAEFB\uAEFD",
        8
    ],
    [
        "8461",
        "\uAF06\uAF09\uAF0A\uAF0B\uAF0C\uAF0E\uAF0F\uAF11",
        18
    ],
    [
        "8481",
        "\uAF24",
        7,
        "\uAF2E\uAF2F\uAF31\uAF33\uAF35",
        6,
        "\uAF3E\uAF40\uAF44\uAF45\uAF46\uAF47\uAF4A",
        5,
        "\uAF51",
        10,
        "\uAF5E",
        5,
        "\uAF66",
        18,
        "\uAF7A",
        5,
        "\uAF81\uAF82\uAF83\uAF85\uAF86\uAF87\uAF89",
        6,
        "\uAF92\uAF93\uAF94\uAF96",
        5,
        "\uAF9D",
        26,
        "\uAFBA\uAFBB\uAFBD\uAFBE"
    ],
    [
        "8541",
        "\uAFBF\uAFC1",
        5,
        "\uAFCA\uAFCC\uAFCF",
        4,
        "\uAFD5",
        6,
        "\uAFDD",
        4
    ],
    [
        "8561",
        "\uAFE2",
        5,
        "\uAFEA",
        5,
        "\uAFF2\uAFF3\uAFF5\uAFF6\uAFF7\uAFF9",
        6,
        "\uB002\uB003"
    ],
    [
        "8581",
        "\uB005",
        6,
        "\uB00D\uB00E\uB00F\uB011\uB012\uB013\uB015",
        6,
        "\uB01E",
        9,
        "\uB029",
        26,
        "\uB046\uB047\uB049\uB04B\uB04D\uB04F\uB050\uB051\uB052\uB056\uB058\uB05A\uB05B\uB05C\uB05E",
        29,
        "\uB07E\uB07F\uB081\uB082\uB083\uB085",
        6,
        "\uB08E\uB090\uB092",
        5,
        "\uB09B\uB09D\uB09E\uB0A3\uB0A4"
    ],
    [
        "8641",
        "\uB0A5\uB0A6\uB0A7\uB0AA\uB0B0\uB0B2\uB0B6\uB0B7\uB0B9\uB0BA\uB0BB\uB0BD",
        6,
        "\uB0C6\uB0CA",
        5,
        "\uB0D2"
    ],
    [
        "8661",
        "\uB0D3\uB0D5\uB0D6\uB0D7\uB0D9",
        6,
        "\uB0E1\uB0E2\uB0E3\uB0E4\uB0E6",
        10
    ],
    [
        "8681",
        "\uB0F1",
        22,
        "\uB10A\uB10D\uB10E\uB10F\uB111\uB114\uB115\uB116\uB117\uB11A\uB11E",
        4,
        "\uB126\uB127\uB129\uB12A\uB12B\uB12D",
        6,
        "\uB136\uB13A",
        5,
        "\uB142\uB143\uB145\uB146\uB147\uB149",
        6,
        "\uB152\uB153\uB156\uB157\uB159\uB15A\uB15B\uB15D\uB15E\uB15F\uB161",
        22,
        "\uB17A\uB17B\uB17D\uB17E\uB17F\uB181\uB183",
        4,
        "\uB18A\uB18C\uB18E\uB18F\uB190\uB191\uB195\uB196\uB197\uB199\uB19A\uB19B\uB19D"
    ],
    [
        "8741",
        "\uB19E",
        9,
        "\uB1A9",
        15
    ],
    [
        "8761",
        "\uB1B9",
        18,
        "\uB1CD\uB1CE\uB1CF\uB1D1\uB1D2\uB1D3\uB1D5"
    ],
    [
        "8781",
        "\uB1D6",
        5,
        "\uB1DE\uB1E0",
        7,
        "\uB1EA\uB1EB\uB1ED\uB1EE\uB1EF\uB1F1",
        7,
        "\uB1FA\uB1FC\uB1FE",
        5,
        "\uB206\uB207\uB209\uB20A\uB20D",
        6,
        "\uB216\uB218\uB21A",
        5,
        "\uB221",
        18,
        "\uB235",
        6,
        "\uB23D",
        26,
        "\uB259\uB25A\uB25B\uB25D\uB25E\uB25F\uB261",
        6,
        "\uB26A",
        4
    ],
    [
        "8841",
        "\uB26F",
        4,
        "\uB276",
        5,
        "\uB27D",
        6,
        "\uB286\uB287\uB288\uB28A",
        4
    ],
    [
        "8861",
        "\uB28F\uB292\uB293\uB295\uB296\uB297\uB29B",
        4,
        "\uB2A2\uB2A4\uB2A7\uB2A8\uB2A9\uB2AB\uB2AD\uB2AE\uB2AF\uB2B1\uB2B2\uB2B3\uB2B5\uB2B6\uB2B7"
    ],
    [
        "8881",
        "\uB2B8",
        15,
        "\uB2CA\uB2CB\uB2CD\uB2CE\uB2CF\uB2D1\uB2D3",
        4,
        "\uB2DA\uB2DC\uB2DE\uB2DF\uB2E0\uB2E1\uB2E3\uB2E7\uB2E9\uB2EA\uB2F0\uB2F1\uB2F2\uB2F6\uB2FC\uB2FD\uB2FE\uB302\uB303\uB305\uB306\uB307\uB309",
        6,
        "\uB312\uB316",
        5,
        "\uB31D",
        54,
        "\uB357\uB359\uB35A\uB35D\uB360\uB361\uB362\uB363"
    ],
    [
        "8941",
        "\uB366\uB368\uB36A\uB36C\uB36D\uB36F\uB372\uB373\uB375\uB376\uB377\uB379",
        6,
        "\uB382\uB386",
        5,
        "\uB38D"
    ],
    [
        "8961",
        "\uB38E\uB38F\uB391\uB392\uB393\uB395",
        10,
        "\uB3A2",
        5,
        "\uB3A9\uB3AA\uB3AB\uB3AD"
    ],
    [
        "8981",
        "\uB3AE",
        21,
        "\uB3C6\uB3C7\uB3C9\uB3CA\uB3CD\uB3CF\uB3D1\uB3D2\uB3D3\uB3D6\uB3D8\uB3DA\uB3DC\uB3DE\uB3DF\uB3E1\uB3E2\uB3E3\uB3E5\uB3E6\uB3E7\uB3E9",
        18,
        "\uB3FD",
        18,
        "\uB411",
        6,
        "\uB419\uB41A\uB41B\uB41D\uB41E\uB41F\uB421",
        6,
        "\uB42A\uB42C",
        7,
        "\uB435",
        15
    ],
    [
        "8a41",
        "\uB445",
        10,
        "\uB452\uB453\uB455\uB456\uB457\uB459",
        6,
        "\uB462\uB464\uB466"
    ],
    [
        "8a61",
        "\uB467",
        4,
        "\uB46D",
        18,
        "\uB481\uB482"
    ],
    [
        "8a81",
        "\uB483",
        4,
        "\uB489",
        19,
        "\uB49E",
        5,
        "\uB4A5\uB4A6\uB4A7\uB4A9\uB4AA\uB4AB\uB4AD",
        7,
        "\uB4B6\uB4B8\uB4BA",
        5,
        "\uB4C1\uB4C2\uB4C3\uB4C5\uB4C6\uB4C7\uB4C9",
        6,
        "\uB4D1\uB4D2\uB4D3\uB4D4\uB4D6",
        5,
        "\uB4DE\uB4DF\uB4E1\uB4E2\uB4E5\uB4E7",
        4,
        "\uB4EE\uB4F0\uB4F2",
        5,
        "\uB4F9",
        26,
        "\uB516\uB517\uB519\uB51A\uB51D"
    ],
    [
        "8b41",
        "\uB51E",
        5,
        "\uB526\uB52B",
        4,
        "\uB532\uB533\uB535\uB536\uB537\uB539",
        6,
        "\uB542\uB546"
    ],
    [
        "8b61",
        "\uB547\uB548\uB549\uB54A\uB54E\uB54F\uB551\uB552\uB553\uB555",
        6,
        "\uB55E\uB562",
        8
    ],
    [
        "8b81",
        "\uB56B",
        52,
        "\uB5A2\uB5A3\uB5A5\uB5A6\uB5A7\uB5A9\uB5AC\uB5AD\uB5AE\uB5AF\uB5B2\uB5B6",
        4,
        "\uB5BE\uB5BF\uB5C1\uB5C2\uB5C3\uB5C5",
        6,
        "\uB5CE\uB5D2",
        5,
        "\uB5D9",
        18,
        "\uB5ED",
        18
    ],
    [
        "8c41",
        "\uB600",
        15,
        "\uB612\uB613\uB615\uB616\uB617\uB619",
        4
    ],
    [
        "8c61",
        "\uB61E",
        6,
        "\uB626",
        5,
        "\uB62D",
        6,
        "\uB635",
        5
    ],
    [
        "8c81",
        "\uB63B",
        12,
        "\uB649",
        26,
        "\uB665\uB666\uB667\uB669",
        50,
        "\uB69E\uB69F\uB6A1\uB6A2\uB6A3\uB6A5",
        5,
        "\uB6AD\uB6AE\uB6AF\uB6B0\uB6B2",
        16
    ],
    [
        "8d41",
        "\uB6C3",
        16,
        "\uB6D5",
        8
    ],
    [
        "8d61",
        "\uB6DE",
        17,
        "\uB6F1\uB6F2\uB6F3\uB6F5\uB6F6\uB6F7\uB6F9\uB6FA"
    ],
    [
        "8d81",
        "\uB6FB",
        4,
        "\uB702\uB703\uB704\uB706",
        33,
        "\uB72A\uB72B\uB72D\uB72E\uB731",
        6,
        "\uB73A\uB73C",
        7,
        "\uB745\uB746\uB747\uB749\uB74A\uB74B\uB74D",
        6,
        "\uB756",
        9,
        "\uB761\uB762\uB763\uB765\uB766\uB767\uB769",
        6,
        "\uB772\uB774\uB776",
        5,
        "\uB77E\uB77F\uB781\uB782\uB783\uB785",
        6,
        "\uB78E\uB793\uB794\uB795\uB79A\uB79B\uB79D\uB79E"
    ],
    [
        "8e41",
        "\uB79F\uB7A1",
        6,
        "\uB7AA\uB7AE",
        5,
        "\uB7B6\uB7B7\uB7B9",
        8
    ],
    [
        "8e61",
        "\uB7C2",
        4,
        "\uB7C8\uB7CA",
        19
    ],
    [
        "8e81",
        "\uB7DE",
        13,
        "\uB7EE\uB7EF\uB7F1\uB7F2\uB7F3\uB7F5",
        6,
        "\uB7FE\uB802",
        4,
        "\uB80A\uB80B\uB80D\uB80E\uB80F\uB811",
        6,
        "\uB81A\uB81C\uB81E",
        5,
        "\uB826\uB827\uB829\uB82A\uB82B\uB82D",
        6,
        "\uB836\uB83A",
        5,
        "\uB841\uB842\uB843\uB845",
        11,
        "\uB852\uB854",
        7,
        "\uB85E\uB85F\uB861\uB862\uB863\uB865",
        6,
        "\uB86E\uB870\uB872",
        5,
        "\uB879\uB87A\uB87B\uB87D",
        7
    ],
    [
        "8f41",
        "\uB885",
        7,
        "\uB88E",
        17
    ],
    [
        "8f61",
        "\uB8A0",
        7,
        "\uB8A9",
        6,
        "\uB8B1\uB8B2\uB8B3\uB8B5\uB8B6\uB8B7\uB8B9",
        4
    ],
    [
        "8f81",
        "\uB8BE\uB8BF\uB8C2\uB8C4\uB8C6",
        5,
        "\uB8CD\uB8CE\uB8CF\uB8D1\uB8D2\uB8D3\uB8D5",
        7,
        "\uB8DE\uB8E0\uB8E2",
        5,
        "\uB8EA\uB8EB\uB8ED\uB8EE\uB8EF\uB8F1",
        6,
        "\uB8FA\uB8FC\uB8FE",
        5,
        "\uB905",
        18,
        "\uB919",
        6,
        "\uB921",
        26,
        "\uB93E\uB93F\uB941\uB942\uB943\uB945",
        6,
        "\uB94D\uB94E\uB950\uB952",
        5
    ],
    [
        "9041",
        "\uB95A\uB95B\uB95D\uB95E\uB95F\uB961",
        6,
        "\uB96A\uB96C\uB96E",
        5,
        "\uB976\uB977\uB979\uB97A\uB97B\uB97D"
    ],
    [
        "9061",
        "\uB97E",
        5,
        "\uB986\uB988\uB98B\uB98C\uB98F",
        15
    ],
    [
        "9081",
        "\uB99F",
        12,
        "\uB9AE\uB9AF\uB9B1\uB9B2\uB9B3\uB9B5",
        6,
        "\uB9BE\uB9C0\uB9C2",
        5,
        "\uB9CA\uB9CB\uB9CD\uB9D3",
        4,
        "\uB9DA\uB9DC\uB9DF\uB9E0\uB9E2\uB9E6\uB9E7\uB9E9\uB9EA\uB9EB\uB9ED",
        6,
        "\uB9F6\uB9FB",
        4,
        "\uBA02",
        5,
        "\uBA09",
        11,
        "\uBA16",
        33,
        "\uBA3A\uBA3B\uBA3D\uBA3E\uBA3F\uBA41\uBA43\uBA44\uBA45\uBA46"
    ],
    [
        "9141",
        "\uBA47\uBA4A\uBA4C\uBA4F\uBA50\uBA51\uBA52\uBA56\uBA57\uBA59\uBA5A\uBA5B\uBA5D",
        6,
        "\uBA66\uBA6A",
        5
    ],
    [
        "9161",
        "\uBA72\uBA73\uBA75\uBA76\uBA77\uBA79",
        9,
        "\uBA86\uBA88\uBA89\uBA8A\uBA8B\uBA8D",
        5
    ],
    [
        "9181",
        "\uBA93",
        20,
        "\uBAAA\uBAAD\uBAAE\uBAAF\uBAB1\uBAB3",
        4,
        "\uBABA\uBABC\uBABE",
        5,
        "\uBAC5\uBAC6\uBAC7\uBAC9",
        14,
        "\uBADA",
        33,
        "\uBAFD\uBAFE\uBAFF\uBB01\uBB02\uBB03\uBB05",
        7,
        "\uBB0E\uBB10\uBB12",
        5,
        "\uBB19\uBB1A\uBB1B\uBB1D\uBB1E\uBB1F\uBB21",
        6
    ],
    [
        "9241",
        "\uBB28\uBB2A\uBB2C",
        7,
        "\uBB37\uBB39\uBB3A\uBB3F",
        4,
        "\uBB46\uBB48\uBB4A\uBB4B\uBB4C\uBB4E\uBB51\uBB52"
    ],
    [
        "9261",
        "\uBB53\uBB55\uBB56\uBB57\uBB59",
        7,
        "\uBB62\uBB64",
        7,
        "\uBB6D",
        4
    ],
    [
        "9281",
        "\uBB72",
        21,
        "\uBB89\uBB8A\uBB8B\uBB8D\uBB8E\uBB8F\uBB91",
        18,
        "\uBBA5\uBBA6\uBBA7\uBBA9\uBBAA\uBBAB\uBBAD",
        6,
        "\uBBB5\uBBB6\uBBB8",
        7,
        "\uBBC1\uBBC2\uBBC3\uBBC5\uBBC6\uBBC7\uBBC9",
        6,
        "\uBBD1\uBBD2\uBBD4",
        35,
        "\uBBFA\uBBFB\uBBFD\uBBFE\uBC01"
    ],
    [
        "9341",
        "\uBC03",
        4,
        "\uBC0A\uBC0E\uBC10\uBC12\uBC13\uBC19\uBC1A\uBC20\uBC21\uBC22\uBC23\uBC26\uBC28\uBC2A\uBC2B\uBC2C\uBC2E\uBC2F\uBC32\uBC33\uBC35"
    ],
    [
        "9361",
        "\uBC36\uBC37\uBC39",
        6,
        "\uBC42\uBC46\uBC47\uBC48\uBC4A\uBC4B\uBC4E\uBC4F\uBC51",
        8
    ],
    [
        "9381",
        "\uBC5A\uBC5B\uBC5C\uBC5E",
        37,
        "\uBC86\uBC87\uBC89\uBC8A\uBC8D\uBC8F",
        4,
        "\uBC96\uBC98\uBC9B",
        4,
        "\uBCA2\uBCA3\uBCA5\uBCA6\uBCA9",
        6,
        "\uBCB2\uBCB6",
        5,
        "\uBCBE\uBCBF\uBCC1\uBCC2\uBCC3\uBCC5",
        7,
        "\uBCCE\uBCD2\uBCD3\uBCD4\uBCD6\uBCD7\uBCD9\uBCDA\uBCDB\uBCDD",
        22,
        "\uBCF7\uBCF9\uBCFA\uBCFB\uBCFD"
    ],
    [
        "9441",
        "\uBCFE",
        5,
        "\uBD06\uBD08\uBD0A",
        5,
        "\uBD11\uBD12\uBD13\uBD15",
        8
    ],
    [
        "9461",
        "\uBD1E",
        5,
        "\uBD25",
        6,
        "\uBD2D",
        12
    ],
    [
        "9481",
        "\uBD3A",
        5,
        "\uBD41",
        6,
        "\uBD4A\uBD4B\uBD4D\uBD4E\uBD4F\uBD51",
        6,
        "\uBD5A",
        9,
        "\uBD65\uBD66\uBD67\uBD69",
        22,
        "\uBD82\uBD83\uBD85\uBD86\uBD8B",
        4,
        "\uBD92\uBD94\uBD96\uBD97\uBD98\uBD9B\uBD9D",
        6,
        "\uBDA5",
        10,
        "\uBDB1",
        6,
        "\uBDB9",
        24
    ],
    [
        "9541",
        "\uBDD2\uBDD3\uBDD6\uBDD7\uBDD9\uBDDA\uBDDB\uBDDD",
        11,
        "\uBDEA",
        5,
        "\uBDF1"
    ],
    [
        "9561",
        "\uBDF2\uBDF3\uBDF5\uBDF6\uBDF7\uBDF9",
        6,
        "\uBE01\uBE02\uBE04\uBE06",
        5,
        "\uBE0E\uBE0F\uBE11\uBE12\uBE13"
    ],
    [
        "9581",
        "\uBE15",
        6,
        "\uBE1E\uBE20",
        35,
        "\uBE46\uBE47\uBE49\uBE4A\uBE4B\uBE4D\uBE4F",
        4,
        "\uBE56\uBE58\uBE5C\uBE5D\uBE5E\uBE5F\uBE62\uBE63\uBE65\uBE66\uBE67\uBE69\uBE6B",
        4,
        "\uBE72\uBE76",
        4,
        "\uBE7E\uBE7F\uBE81\uBE82\uBE83\uBE85",
        6,
        "\uBE8E\uBE92",
        5,
        "\uBE9A",
        13,
        "\uBEA9",
        14
    ],
    [
        "9641",
        "\uBEB8",
        23,
        "\uBED2\uBED3"
    ],
    [
        "9661",
        "\uBED5\uBED6\uBED9",
        6,
        "\uBEE1\uBEE2\uBEE6",
        5,
        "\uBEED",
        8
    ],
    [
        "9681",
        "\uBEF6",
        10,
        "\uBF02",
        5,
        "\uBF0A",
        13,
        "\uBF1A\uBF1E",
        33,
        "\uBF42\uBF43\uBF45\uBF46\uBF47\uBF49",
        6,
        "\uBF52\uBF53\uBF54\uBF56",
        44
    ],
    [
        "9741",
        "\uBF83",
        16,
        "\uBF95",
        8
    ],
    [
        "9761",
        "\uBF9E",
        17,
        "\uBFB1",
        7
    ],
    [
        "9781",
        "\uBFB9",
        11,
        "\uBFC6",
        5,
        "\uBFCE\uBFCF\uBFD1\uBFD2\uBFD3\uBFD5",
        6,
        "\uBFDD\uBFDE\uBFE0\uBFE2",
        89,
        "\uC03D\uC03E\uC03F"
    ],
    [
        "9841",
        "\uC040",
        16,
        "\uC052",
        5,
        "\uC059\uC05A\uC05B"
    ],
    [
        "9861",
        "\uC05D\uC05E\uC05F\uC061",
        6,
        "\uC06A",
        15
    ],
    [
        "9881",
        "\uC07A",
        21,
        "\uC092\uC093\uC095\uC096\uC097\uC099",
        6,
        "\uC0A2\uC0A4\uC0A6",
        5,
        "\uC0AE\uC0B1\uC0B2\uC0B7",
        4,
        "\uC0BE\uC0C2\uC0C3\uC0C4\uC0C6\uC0C7\uC0CA\uC0CB\uC0CD\uC0CE\uC0CF\uC0D1",
        6,
        "\uC0DA\uC0DE",
        5,
        "\uC0E6\uC0E7\uC0E9\uC0EA\uC0EB\uC0ED",
        6,
        "\uC0F6\uC0F8\uC0FA",
        5,
        "\uC101\uC102\uC103\uC105\uC106\uC107\uC109",
        6,
        "\uC111\uC112\uC113\uC114\uC116",
        5,
        "\uC121\uC122\uC125\uC128\uC129\uC12A\uC12B\uC12E"
    ],
    [
        "9941",
        "\uC132\uC133\uC134\uC135\uC137\uC13A\uC13B\uC13D\uC13E\uC13F\uC141",
        6,
        "\uC14A\uC14E",
        5,
        "\uC156\uC157"
    ],
    [
        "9961",
        "\uC159\uC15A\uC15B\uC15D",
        6,
        "\uC166\uC16A",
        5,
        "\uC171\uC172\uC173\uC175\uC176\uC177\uC179\uC17A\uC17B"
    ],
    [
        "9981",
        "\uC17C",
        8,
        "\uC186",
        5,
        "\uC18F\uC191\uC192\uC193\uC195\uC197",
        4,
        "\uC19E\uC1A0\uC1A2\uC1A3\uC1A4\uC1A6\uC1A7\uC1AA\uC1AB\uC1AD\uC1AE\uC1AF\uC1B1",
        11,
        "\uC1BE",
        5,
        "\uC1C5\uC1C6\uC1C7\uC1C9\uC1CA\uC1CB\uC1CD",
        6,
        "\uC1D5\uC1D6\uC1D9",
        6,
        "\uC1E1\uC1E2\uC1E3\uC1E5\uC1E6\uC1E7\uC1E9",
        6,
        "\uC1F2\uC1F4",
        7,
        "\uC1FE\uC1FF\uC201\uC202\uC203\uC205",
        6,
        "\uC20E\uC210\uC212",
        5,
        "\uC21A\uC21B\uC21D\uC21E\uC221\uC222\uC223"
    ],
    [
        "9a41",
        "\uC224\uC225\uC226\uC227\uC22A\uC22C\uC22E\uC230\uC233\uC235",
        16
    ],
    [
        "9a61",
        "\uC246\uC247\uC249",
        6,
        "\uC252\uC253\uC255\uC256\uC257\uC259",
        6,
        "\uC261\uC262\uC263\uC264\uC266"
    ],
    [
        "9a81",
        "\uC267",
        4,
        "\uC26E\uC26F\uC271\uC272\uC273\uC275",
        6,
        "\uC27E\uC280\uC282",
        5,
        "\uC28A",
        5,
        "\uC291",
        6,
        "\uC299\uC29A\uC29C\uC29E",
        5,
        "\uC2A6\uC2A7\uC2A9\uC2AA\uC2AB\uC2AE",
        5,
        "\uC2B6\uC2B8\uC2BA",
        33,
        "\uC2DE\uC2DF\uC2E1\uC2E2\uC2E5",
        5,
        "\uC2EE\uC2F0\uC2F2\uC2F3\uC2F4\uC2F5\uC2F7\uC2FA\uC2FD\uC2FE\uC2FF\uC301",
        6,
        "\uC30A\uC30B\uC30E\uC30F"
    ],
    [
        "9b41",
        "\uC310\uC311\uC312\uC316\uC317\uC319\uC31A\uC31B\uC31D",
        6,
        "\uC326\uC327\uC32A",
        8
    ],
    [
        "9b61",
        "\uC333",
        17,
        "\uC346",
        7
    ],
    [
        "9b81",
        "\uC34E",
        25,
        "\uC36A\uC36B\uC36D\uC36E\uC36F\uC371\uC373",
        4,
        "\uC37A\uC37B\uC37E",
        5,
        "\uC385\uC386\uC387\uC389\uC38A\uC38B\uC38D",
        50,
        "\uC3C1",
        22,
        "\uC3DA"
    ],
    [
        "9c41",
        "\uC3DB\uC3DD\uC3DE\uC3E1\uC3E3",
        4,
        "\uC3EA\uC3EB\uC3EC\uC3EE",
        5,
        "\uC3F6\uC3F7\uC3F9",
        5
    ],
    [
        "9c61",
        "\uC3FF",
        8,
        "\uC409",
        6,
        "\uC411",
        9
    ],
    [
        "9c81",
        "\uC41B",
        8,
        "\uC425",
        6,
        "\uC42D\uC42E\uC42F\uC431\uC432\uC433\uC435",
        6,
        "\uC43E",
        9,
        "\uC449",
        26,
        "\uC466\uC467\uC469\uC46A\uC46B\uC46D",
        6,
        "\uC476\uC477\uC478\uC47A",
        5,
        "\uC481",
        18,
        "\uC495",
        6,
        "\uC49D",
        12
    ],
    [
        "9d41",
        "\uC4AA",
        13,
        "\uC4B9\uC4BA\uC4BB\uC4BD",
        8
    ],
    [
        "9d61",
        "\uC4C6",
        25
    ],
    [
        "9d81",
        "\uC4E0",
        8,
        "\uC4EA",
        5,
        "\uC4F2\uC4F3\uC4F5\uC4F6\uC4F7\uC4F9\uC4FB\uC4FC\uC4FD\uC4FE\uC502",
        9,
        "\uC50D\uC50E\uC50F\uC511\uC512\uC513\uC515",
        6,
        "\uC51D",
        10,
        "\uC52A\uC52B\uC52D\uC52E\uC52F\uC531",
        6,
        "\uC53A\uC53C\uC53E",
        5,
        "\uC546\uC547\uC54B\uC54F\uC550\uC551\uC552\uC556\uC55A\uC55B\uC55C\uC55F\uC562\uC563\uC565\uC566\uC567\uC569",
        6,
        "\uC572\uC576",
        5,
        "\uC57E\uC57F\uC581\uC582\uC583\uC585\uC586\uC588\uC589\uC58A\uC58B\uC58E\uC590\uC592\uC593\uC594"
    ],
    [
        "9e41",
        "\uC596\uC599\uC59A\uC59B\uC59D\uC59E\uC59F\uC5A1",
        7,
        "\uC5AA",
        9,
        "\uC5B6"
    ],
    [
        "9e61",
        "\uC5B7\uC5BA\uC5BF",
        4,
        "\uC5CB\uC5CD\uC5CF\uC5D2\uC5D3\uC5D5\uC5D6\uC5D7\uC5D9",
        6,
        "\uC5E2\uC5E4\uC5E6\uC5E7"
    ],
    [
        "9e81",
        "\uC5E8\uC5E9\uC5EA\uC5EB\uC5EF\uC5F1\uC5F2\uC5F3\uC5F5\uC5F8\uC5F9\uC5FA\uC5FB\uC602\uC603\uC604\uC609\uC60A\uC60B\uC60D\uC60E\uC60F\uC611",
        6,
        "\uC61A\uC61D",
        6,
        "\uC626\uC627\uC629\uC62A\uC62B\uC62F\uC631\uC632\uC636\uC638\uC63A\uC63C\uC63D\uC63E\uC63F\uC642\uC643\uC645\uC646\uC647\uC649",
        6,
        "\uC652\uC656",
        5,
        "\uC65E\uC65F\uC661",
        10,
        "\uC66D\uC66E\uC670\uC672",
        5,
        "\uC67A\uC67B\uC67D\uC67E\uC67F\uC681",
        6,
        "\uC68A\uC68C\uC68E",
        5,
        "\uC696\uC697\uC699\uC69A\uC69B\uC69D",
        6,
        "\uC6A6"
    ],
    [
        "9f41",
        "\uC6A8\uC6AA",
        5,
        "\uC6B2\uC6B3\uC6B5\uC6B6\uC6B7\uC6BB",
        4,
        "\uC6C2\uC6C4\uC6C6",
        5,
        "\uC6CE"
    ],
    [
        "9f61",
        "\uC6CF\uC6D1\uC6D2\uC6D3\uC6D5",
        6,
        "\uC6DE\uC6DF\uC6E2",
        5,
        "\uC6EA\uC6EB\uC6ED\uC6EE\uC6EF\uC6F1\uC6F2"
    ],
    [
        "9f81",
        "\uC6F3",
        4,
        "\uC6FA\uC6FB\uC6FC\uC6FE",
        5,
        "\uC706\uC707\uC709\uC70A\uC70B\uC70D",
        6,
        "\uC716\uC718\uC71A",
        5,
        "\uC722\uC723\uC725\uC726\uC727\uC729",
        6,
        "\uC732\uC734\uC736\uC738\uC739\uC73A\uC73B\uC73E\uC73F\uC741\uC742\uC743\uC745",
        4,
        "\uC74B\uC74E\uC750\uC759\uC75A\uC75B\uC75D\uC75E\uC75F\uC761",
        6,
        "\uC769\uC76A\uC76C",
        7,
        "\uC776\uC777\uC779\uC77A\uC77B\uC77F\uC780\uC781\uC782\uC786\uC78B\uC78C\uC78D\uC78F\uC792\uC793\uC795\uC799\uC79B",
        4,
        "\uC7A2\uC7A7",
        4,
        "\uC7AE\uC7AF\uC7B1\uC7B2\uC7B3\uC7B5\uC7B6\uC7B7"
    ],
    [
        "a041",
        "\uC7B8\uC7B9\uC7BA\uC7BB\uC7BE\uC7C2",
        5,
        "\uC7CA\uC7CB\uC7CD\uC7CF\uC7D1",
        6,
        "\uC7D9\uC7DA\uC7DB\uC7DC"
    ],
    [
        "a061",
        "\uC7DE",
        5,
        "\uC7E5\uC7E6\uC7E7\uC7E9\uC7EA\uC7EB\uC7ED",
        13
    ],
    [
        "a081",
        "\uC7FB",
        4,
        "\uC802\uC803\uC805\uC806\uC807\uC809\uC80B",
        4,
        "\uC812\uC814\uC817",
        4,
        "\uC81E\uC81F\uC821\uC822\uC823\uC825",
        6,
        "\uC82E\uC830\uC832",
        5,
        "\uC839\uC83A\uC83B\uC83D\uC83E\uC83F\uC841",
        6,
        "\uC84A\uC84B\uC84E",
        5,
        "\uC855",
        26,
        "\uC872\uC873\uC875\uC876\uC877\uC879\uC87B",
        4,
        "\uC882\uC884\uC888\uC889\uC88A\uC88E",
        5,
        "\uC895",
        7,
        "\uC89E\uC8A0\uC8A2\uC8A3\uC8A4"
    ],
    [
        "a141",
        "\uC8A5\uC8A6\uC8A7\uC8A9",
        18,
        "\uC8BE\uC8BF\uC8C0\uC8C1"
    ],
    [
        "a161",
        "\uC8C2\uC8C3\uC8C5\uC8C6\uC8C7\uC8C9\uC8CA\uC8CB\uC8CD",
        6,
        "\uC8D6\uC8D8\uC8DA",
        5,
        "\uC8E2\uC8E3\uC8E5"
    ],
    [
        "a181",
        "\uC8E6",
        14,
        "\uC8F6",
        5,
        "\uC8FE\uC8FF\uC901\uC902\uC903\uC907",
        4,
        "\uC90E\u3000\u3001\u3002\xb7\u2025\u2026\xa8\u3003\xad\u2015\u2225\uFF3C\u223C\u2018\u2019\u201C\u201D\u3014\u3015\u3008",
        9,
        "\xb1\xd7\xf7\u2260\u2264\u2265\u221E\u2234\xb0\u2032\u2033\u2103\u212B\uFFE0\uFFE1\uFFE5\u2642\u2640\u2220\u22A5\u2312\u2202\u2207\u2261\u2252\xa7\u203B\u2606\u2605\u25CB\u25CF\u25CE\u25C7\u25C6\u25A1\u25A0\u25B3\u25B2\u25BD\u25BC\u2192\u2190\u2191\u2193\u2194\u3013\u226A\u226B\u221A\u223D\u221D\u2235\u222B\u222C\u2208\u220B\u2286\u2287\u2282\u2283\u222A\u2229\u2227\u2228\uFFE2"
    ],
    [
        "a241",
        "\uC910\uC912",
        5,
        "\uC919",
        18
    ],
    [
        "a261",
        "\uC92D",
        6,
        "\uC935",
        18
    ],
    [
        "a281",
        "\uC948",
        7,
        "\uC952\uC953\uC955\uC956\uC957\uC959",
        6,
        "\uC962\uC964",
        7,
        "\uC96D\uC96E\uC96F\u21D2\u21D4\u2200\u2203\xb4\uFF5E\u02C7\u02D8\u02DD\u02DA\u02D9\xb8\u02DB\xa1\xbf\u02D0\u222E\u2211\u220F\xa4\u2109\u2030\u25C1\u25C0\u25B7\u25B6\u2664\u2660\u2661\u2665\u2667\u2663\u2299\u25C8\u25A3\u25D0\u25D1\u2592\u25A4\u25A5\u25A8\u25A7\u25A6\u25A9\u2668\u260F\u260E\u261C\u261E\xb6\u2020\u2021\u2195\u2197\u2199\u2196\u2198\u266D\u2669\u266A\u266C\u327F\u321C\u2116\u33C7\u2122\u33C2\u33D8\u2121\u20AC\xae"
    ],
    [
        "a341",
        "\uC971\uC972\uC973\uC975",
        6,
        "\uC97D",
        10,
        "\uC98A\uC98B\uC98D\uC98E\uC98F"
    ],
    [
        "a361",
        "\uC991",
        6,
        "\uC99A\uC99C\uC99E",
        16
    ],
    [
        "a381",
        "\uC9AF",
        16,
        "\uC9C2\uC9C3\uC9C5\uC9C6\uC9C9\uC9CB",
        4,
        "\uC9D2\uC9D4\uC9D7\uC9D8\uC9DB\uFF01",
        58,
        "\uFFE6\uFF3D",
        32,
        "\uFFE3"
    ],
    [
        "a441",
        "\uC9DE\uC9DF\uC9E1\uC9E3\uC9E5\uC9E6\uC9E8\uC9E9\uC9EA\uC9EB\uC9EE\uC9F2",
        5,
        "\uC9FA\uC9FB\uC9FD\uC9FE\uC9FF\uCA01\uCA02\uCA03\uCA04"
    ],
    [
        "a461",
        "\uCA05\uCA06\uCA07\uCA0A\uCA0E",
        5,
        "\uCA15\uCA16\uCA17\uCA19",
        12
    ],
    [
        "a481",
        "\uCA26\uCA27\uCA28\uCA2A",
        28,
        "\u3131",
        93
    ],
    [
        "a541",
        "\uCA47",
        4,
        "\uCA4E\uCA4F\uCA51\uCA52\uCA53\uCA55",
        6,
        "\uCA5E\uCA62",
        5,
        "\uCA69\uCA6A"
    ],
    [
        "a561",
        "\uCA6B",
        17,
        "\uCA7E",
        5,
        "\uCA85\uCA86"
    ],
    [
        "a581",
        "\uCA87",
        16,
        "\uCA99",
        14,
        "\u2170",
        9
    ],
    [
        "a5b0",
        "\u2160",
        9
    ],
    [
        "a5c1",
        "\u0391",
        16,
        "\u03A3",
        6
    ],
    [
        "a5e1",
        "\u03B1",
        16,
        "\u03C3",
        6
    ],
    [
        "a641",
        "\uCAA8",
        19,
        "\uCABE\uCABF\uCAC1\uCAC2\uCAC3\uCAC5"
    ],
    [
        "a661",
        "\uCAC6",
        5,
        "\uCACE\uCAD0\uCAD2\uCAD4\uCAD5\uCAD6\uCAD7\uCADA",
        5,
        "\uCAE1",
        6
    ],
    [
        "a681",
        "\uCAE8\uCAE9\uCAEA\uCAEB\uCAED",
        6,
        "\uCAF5",
        18,
        "\uCB09\uCB0A\u2500\u2502\u250C\u2510\u2518\u2514\u251C\u252C\u2524\u2534\u253C\u2501\u2503\u250F\u2513\u251B\u2517\u2523\u2533\u252B\u253B\u254B\u2520\u252F\u2528\u2537\u253F\u251D\u2530\u2525\u2538\u2542\u2512\u2511\u251A\u2519\u2516\u2515\u250E\u250D\u251E\u251F\u2521\u2522\u2526\u2527\u2529\u252A\u252D\u252E\u2531\u2532\u2535\u2536\u2539\u253A\u253D\u253E\u2540\u2541\u2543",
        7
    ],
    [
        "a741",
        "\uCB0B",
        4,
        "\uCB11\uCB12\uCB13\uCB15\uCB16\uCB17\uCB19",
        6,
        "\uCB22",
        7
    ],
    [
        "a761",
        "\uCB2A",
        22,
        "\uCB42\uCB43\uCB44"
    ],
    [
        "a781",
        "\uCB45\uCB46\uCB47\uCB4A\uCB4B\uCB4D\uCB4E\uCB4F\uCB51",
        6,
        "\uCB5A\uCB5B\uCB5C\uCB5E",
        5,
        "\uCB65",
        7,
        "\u3395\u3396\u3397\u2113\u3398\u33C4\u33A3\u33A4\u33A5\u33A6\u3399",
        9,
        "\u33CA\u338D\u338E\u338F\u33CF\u3388\u3389\u33C8\u33A7\u33A8\u33B0",
        9,
        "\u3380",
        4,
        "\u33BA",
        5,
        "\u3390",
        4,
        "\u2126\u33C0\u33C1\u338A\u338B\u338C\u33D6\u33C5\u33AD\u33AE\u33AF\u33DB\u33A9\u33AA\u33AB\u33AC\u33DD\u33D0\u33D3\u33C3\u33C9\u33DC\u33C6"
    ],
    [
        "a841",
        "\uCB6D",
        10,
        "\uCB7A",
        14
    ],
    [
        "a861",
        "\uCB89",
        18,
        "\uCB9D",
        6
    ],
    [
        "a881",
        "\uCBA4",
        19,
        "\uCBB9",
        11,
        "\xc6\xd0\xaa\u0126"
    ],
    [
        "a8a6",
        "\u0132"
    ],
    [
        "a8a8",
        "\u013F\u0141\xd8\u0152\xba\xde\u0166\u014A"
    ],
    [
        "a8b1",
        "\u3260",
        27,
        "\u24D0",
        25,
        "\u2460",
        14,
        "\xbd\u2153\u2154\xbc\xbe\u215B\u215C\u215D\u215E"
    ],
    [
        "a941",
        "\uCBC5",
        14,
        "\uCBD5",
        10
    ],
    [
        "a961",
        "\uCBE0\uCBE1\uCBE2\uCBE3\uCBE5\uCBE6\uCBE8\uCBEA",
        18
    ],
    [
        "a981",
        "\uCBFD",
        14,
        "\uCC0E\uCC0F\uCC11\uCC12\uCC13\uCC15",
        6,
        "\uCC1E\uCC1F\uCC20\uCC23\uCC24\xe6\u0111\xf0\u0127\u0131\u0133\u0138\u0140\u0142\xf8\u0153\xdf\xfe\u0167\u014B\u0149\u3200",
        27,
        "\u249C",
        25,
        "\u2474",
        14,
        "\xb9\xb2\xb3\u2074\u207F\u2081\u2082\u2083\u2084"
    ],
    [
        "aa41",
        "\uCC25\uCC26\uCC2A\uCC2B\uCC2D\uCC2F\uCC31",
        6,
        "\uCC3A\uCC3F",
        4,
        "\uCC46\uCC47\uCC49\uCC4A\uCC4B\uCC4D\uCC4E"
    ],
    [
        "aa61",
        "\uCC4F",
        4,
        "\uCC56\uCC5A",
        5,
        "\uCC61\uCC62\uCC63\uCC65\uCC67\uCC69",
        6,
        "\uCC71\uCC72"
    ],
    [
        "aa81",
        "\uCC73\uCC74\uCC76",
        29,
        "\u3041",
        82
    ],
    [
        "ab41",
        "\uCC94\uCC95\uCC96\uCC97\uCC9A\uCC9B\uCC9D\uCC9E\uCC9F\uCCA1",
        6,
        "\uCCAA\uCCAE",
        5,
        "\uCCB6\uCCB7\uCCB9"
    ],
    [
        "ab61",
        "\uCCBA\uCCBB\uCCBD",
        6,
        "\uCCC6\uCCC8\uCCCA",
        5,
        "\uCCD1\uCCD2\uCCD3\uCCD5",
        5
    ],
    [
        "ab81",
        "\uCCDB",
        8,
        "\uCCE5",
        6,
        "\uCCED\uCCEE\uCCEF\uCCF1",
        12,
        "\u30A1",
        85
    ],
    [
        "ac41",
        "\uCCFE\uCCFF\uCD00\uCD02",
        5,
        "\uCD0A\uCD0B\uCD0D\uCD0E\uCD0F\uCD11",
        6,
        "\uCD1A\uCD1C\uCD1E\uCD1F\uCD20"
    ],
    [
        "ac61",
        "\uCD21\uCD22\uCD23\uCD25\uCD26\uCD27\uCD29\uCD2A\uCD2B\uCD2D",
        11,
        "\uCD3A",
        4
    ],
    [
        "ac81",
        "\uCD3F",
        28,
        "\uCD5D\uCD5E\uCD5F\u0410",
        5,
        "\u0401\u0416",
        25
    ],
    [
        "acd1",
        "\u0430",
        5,
        "\u0451\u0436",
        25
    ],
    [
        "ad41",
        "\uCD61\uCD62\uCD63\uCD65",
        6,
        "\uCD6E\uCD70\uCD72",
        5,
        "\uCD79",
        7
    ],
    [
        "ad61",
        "\uCD81",
        6,
        "\uCD89",
        10,
        "\uCD96\uCD97\uCD99\uCD9A\uCD9B\uCD9D\uCD9E\uCD9F"
    ],
    [
        "ad81",
        "\uCDA0\uCDA1\uCDA2\uCDA3\uCDA6\uCDA8\uCDAA",
        5,
        "\uCDB1",
        18,
        "\uCDC5"
    ],
    [
        "ae41",
        "\uCDC6",
        5,
        "\uCDCD\uCDCE\uCDCF\uCDD1",
        16
    ],
    [
        "ae61",
        "\uCDE2",
        5,
        "\uCDE9\uCDEA\uCDEB\uCDED\uCDEE\uCDEF\uCDF1",
        6,
        "\uCDFA\uCDFC\uCDFE",
        4
    ],
    [
        "ae81",
        "\uCE03\uCE05\uCE06\uCE07\uCE09\uCE0A\uCE0B\uCE0D",
        6,
        "\uCE15\uCE16\uCE17\uCE18\uCE1A",
        5,
        "\uCE22\uCE23\uCE25\uCE26\uCE27\uCE29\uCE2A\uCE2B"
    ],
    [
        "af41",
        "\uCE2C\uCE2D\uCE2E\uCE2F\uCE32\uCE34\uCE36",
        19
    ],
    [
        "af61",
        "\uCE4A",
        13,
        "\uCE5A\uCE5B\uCE5D\uCE5E\uCE62",
        5,
        "\uCE6A\uCE6C"
    ],
    [
        "af81",
        "\uCE6E",
        5,
        "\uCE76\uCE77\uCE79\uCE7A\uCE7B\uCE7D",
        6,
        "\uCE86\uCE88\uCE8A",
        5,
        "\uCE92\uCE93\uCE95\uCE96\uCE97\uCE99"
    ],
    [
        "b041",
        "\uCE9A",
        5,
        "\uCEA2\uCEA6",
        5,
        "\uCEAE",
        12
    ],
    [
        "b061",
        "\uCEBB",
        5,
        "\uCEC2",
        19
    ],
    [
        "b081",
        "\uCED6",
        13,
        "\uCEE6\uCEE7\uCEE9\uCEEA\uCEED",
        6,
        "\uCEF6\uCEFA",
        5,
        "\uAC00\uAC01\uAC04\uAC07\uAC08\uAC09\uAC0A\uAC10",
        7,
        "\uAC19",
        4,
        "\uAC20\uAC24\uAC2C\uAC2D\uAC2F\uAC30\uAC31\uAC38\uAC39\uAC3C\uAC40\uAC4B\uAC4D\uAC54\uAC58\uAC5C\uAC70\uAC71\uAC74\uAC77\uAC78\uAC7A\uAC80\uAC81\uAC83\uAC84\uAC85\uAC86\uAC89\uAC8A\uAC8B\uAC8C\uAC90\uAC94\uAC9C\uAC9D\uAC9F\uACA0\uACA1\uACA8\uACA9\uACAA\uACAC\uACAF\uACB0\uACB8\uACB9\uACBB\uACBC\uACBD\uACC1\uACC4\uACC8\uACCC\uACD5\uACD7\uACE0\uACE1\uACE4\uACE7\uACE8\uACEA\uACEC\uACEF\uACF0\uACF1\uACF3\uACF5\uACF6\uACFC\uACFD\uAD00\uAD04\uAD06"
    ],
    [
        "b141",
        "\uCF02\uCF03\uCF05\uCF06\uCF07\uCF09",
        6,
        "\uCF12\uCF14\uCF16",
        5,
        "\uCF1D\uCF1E\uCF1F\uCF21\uCF22\uCF23"
    ],
    [
        "b161",
        "\uCF25",
        6,
        "\uCF2E\uCF32",
        5,
        "\uCF39",
        11
    ],
    [
        "b181",
        "\uCF45",
        14,
        "\uCF56\uCF57\uCF59\uCF5A\uCF5B\uCF5D",
        6,
        "\uCF66\uCF68\uCF6A\uCF6B\uCF6C\uAD0C\uAD0D\uAD0F\uAD11\uAD18\uAD1C\uAD20\uAD29\uAD2C\uAD2D\uAD34\uAD35\uAD38\uAD3C\uAD44\uAD45\uAD47\uAD49\uAD50\uAD54\uAD58\uAD61\uAD63\uAD6C\uAD6D\uAD70\uAD73\uAD74\uAD75\uAD76\uAD7B\uAD7C\uAD7D\uAD7F\uAD81\uAD82\uAD88\uAD89\uAD8C\uAD90\uAD9C\uAD9D\uADA4\uADB7\uADC0\uADC1\uADC4\uADC8\uADD0\uADD1\uADD3\uADDC\uADE0\uADE4\uADF8\uADF9\uADFC\uADFF\uAE00\uAE01\uAE08\uAE09\uAE0B\uAE0D\uAE14\uAE30\uAE31\uAE34\uAE37\uAE38\uAE3A\uAE40\uAE41\uAE43\uAE45\uAE46\uAE4A\uAE4C\uAE4D\uAE4E\uAE50\uAE54\uAE56\uAE5C\uAE5D\uAE5F\uAE60\uAE61\uAE65\uAE68\uAE69\uAE6C\uAE70\uAE78"
    ],
    [
        "b241",
        "\uCF6D\uCF6E\uCF6F\uCF72\uCF73\uCF75\uCF76\uCF77\uCF79",
        6,
        "\uCF81\uCF82\uCF83\uCF84\uCF86",
        5,
        "\uCF8D"
    ],
    [
        "b261",
        "\uCF8E",
        18,
        "\uCFA2",
        5,
        "\uCFA9"
    ],
    [
        "b281",
        "\uCFAA",
        5,
        "\uCFB1",
        18,
        "\uCFC5",
        6,
        "\uAE79\uAE7B\uAE7C\uAE7D\uAE84\uAE85\uAE8C\uAEBC\uAEBD\uAEBE\uAEC0\uAEC4\uAECC\uAECD\uAECF\uAED0\uAED1\uAED8\uAED9\uAEDC\uAEE8\uAEEB\uAEED\uAEF4\uAEF8\uAEFC\uAF07\uAF08\uAF0D\uAF10\uAF2C\uAF2D\uAF30\uAF32\uAF34\uAF3C\uAF3D\uAF3F\uAF41\uAF42\uAF43\uAF48\uAF49\uAF50\uAF5C\uAF5D\uAF64\uAF65\uAF79\uAF80\uAF84\uAF88\uAF90\uAF91\uAF95\uAF9C\uAFB8\uAFB9\uAFBC\uAFC0\uAFC7\uAFC8\uAFC9\uAFCB\uAFCD\uAFCE\uAFD4\uAFDC\uAFE8\uAFE9\uAFF0\uAFF1\uAFF4\uAFF8\uB000\uB001\uB004\uB00C\uB010\uB014\uB01C\uB01D\uB028\uB044\uB045\uB048\uB04A\uB04C\uB04E\uB053\uB054\uB055\uB057\uB059"
    ],
    [
        "b341",
        "\uCFCC",
        19,
        "\uCFE2\uCFE3\uCFE5\uCFE6\uCFE7\uCFE9"
    ],
    [
        "b361",
        "\uCFEA",
        5,
        "\uCFF2\uCFF4\uCFF6",
        5,
        "\uCFFD\uCFFE\uCFFF\uD001\uD002\uD003\uD005",
        5
    ],
    [
        "b381",
        "\uD00B",
        5,
        "\uD012",
        5,
        "\uD019",
        19,
        "\uB05D\uB07C\uB07D\uB080\uB084\uB08C\uB08D\uB08F\uB091\uB098\uB099\uB09A\uB09C\uB09F\uB0A0\uB0A1\uB0A2\uB0A8\uB0A9\uB0AB",
        4,
        "\uB0B1\uB0B3\uB0B4\uB0B5\uB0B8\uB0BC\uB0C4\uB0C5\uB0C7\uB0C8\uB0C9\uB0D0\uB0D1\uB0D4\uB0D8\uB0E0\uB0E5\uB108\uB109\uB10B\uB10C\uB110\uB112\uB113\uB118\uB119\uB11B\uB11C\uB11D\uB123\uB124\uB125\uB128\uB12C\uB134\uB135\uB137\uB138\uB139\uB140\uB141\uB144\uB148\uB150\uB151\uB154\uB155\uB158\uB15C\uB160\uB178\uB179\uB17C\uB180\uB182\uB188\uB189\uB18B\uB18D\uB192\uB193\uB194\uB198\uB19C\uB1A8\uB1CC\uB1D0\uB1D4\uB1DC\uB1DD"
    ],
    [
        "b441",
        "\uD02E",
        5,
        "\uD036\uD037\uD039\uD03A\uD03B\uD03D",
        6,
        "\uD046\uD048\uD04A",
        5
    ],
    [
        "b461",
        "\uD051\uD052\uD053\uD055\uD056\uD057\uD059",
        6,
        "\uD061",
        10,
        "\uD06E\uD06F"
    ],
    [
        "b481",
        "\uD071\uD072\uD073\uD075",
        6,
        "\uD07E\uD07F\uD080\uD082",
        18,
        "\uB1DF\uB1E8\uB1E9\uB1EC\uB1F0\uB1F9\uB1FB\uB1FD\uB204\uB205\uB208\uB20B\uB20C\uB214\uB215\uB217\uB219\uB220\uB234\uB23C\uB258\uB25C\uB260\uB268\uB269\uB274\uB275\uB27C\uB284\uB285\uB289\uB290\uB291\uB294\uB298\uB299\uB29A\uB2A0\uB2A1\uB2A3\uB2A5\uB2A6\uB2AA\uB2AC\uB2B0\uB2B4\uB2C8\uB2C9\uB2CC\uB2D0\uB2D2\uB2D8\uB2D9\uB2DB\uB2DD\uB2E2\uB2E4\uB2E5\uB2E6\uB2E8\uB2EB",
        4,
        "\uB2F3\uB2F4\uB2F5\uB2F7",
        4,
        "\uB2FF\uB300\uB301\uB304\uB308\uB310\uB311\uB313\uB314\uB315\uB31C\uB354\uB355\uB356\uB358\uB35B\uB35C\uB35E\uB35F\uB364\uB365"
    ],
    [
        "b541",
        "\uD095",
        14,
        "\uD0A6\uD0A7\uD0A9\uD0AA\uD0AB\uD0AD",
        5
    ],
    [
        "b561",
        "\uD0B3\uD0B6\uD0B8\uD0BA",
        5,
        "\uD0C2\uD0C3\uD0C5\uD0C6\uD0C7\uD0CA",
        5,
        "\uD0D2\uD0D6",
        4
    ],
    [
        "b581",
        "\uD0DB\uD0DE\uD0DF\uD0E1\uD0E2\uD0E3\uD0E5",
        6,
        "\uD0EE\uD0F2",
        5,
        "\uD0F9",
        11,
        "\uB367\uB369\uB36B\uB36E\uB370\uB371\uB374\uB378\uB380\uB381\uB383\uB384\uB385\uB38C\uB390\uB394\uB3A0\uB3A1\uB3A8\uB3AC\uB3C4\uB3C5\uB3C8\uB3CB\uB3CC\uB3CE\uB3D0\uB3D4\uB3D5\uB3D7\uB3D9\uB3DB\uB3DD\uB3E0\uB3E4\uB3E8\uB3FC\uB410\uB418\uB41C\uB420\uB428\uB429\uB42B\uB434\uB450\uB451\uB454\uB458\uB460\uB461\uB463\uB465\uB46C\uB480\uB488\uB49D\uB4A4\uB4A8\uB4AC\uB4B5\uB4B7\uB4B9\uB4C0\uB4C4\uB4C8\uB4D0\uB4D5\uB4DC\uB4DD\uB4E0\uB4E3\uB4E4\uB4E6\uB4EC\uB4ED\uB4EF\uB4F1\uB4F8\uB514\uB515\uB518\uB51B\uB51C\uB524\uB525\uB527\uB528\uB529\uB52A\uB530\uB531\uB534\uB538"
    ],
    [
        "b641",
        "\uD105",
        7,
        "\uD10E",
        17
    ],
    [
        "b661",
        "\uD120",
        15,
        "\uD132\uD133\uD135\uD136\uD137\uD139\uD13B\uD13C\uD13D\uD13E"
    ],
    [
        "b681",
        "\uD13F\uD142\uD146",
        5,
        "\uD14E\uD14F\uD151\uD152\uD153\uD155",
        6,
        "\uD15E\uD160\uD162",
        5,
        "\uD169\uD16A\uD16B\uD16D\uB540\uB541\uB543\uB544\uB545\uB54B\uB54C\uB54D\uB550\uB554\uB55C\uB55D\uB55F\uB560\uB561\uB5A0\uB5A1\uB5A4\uB5A8\uB5AA\uB5AB\uB5B0\uB5B1\uB5B3\uB5B4\uB5B5\uB5BB\uB5BC\uB5BD\uB5C0\uB5C4\uB5CC\uB5CD\uB5CF\uB5D0\uB5D1\uB5D8\uB5EC\uB610\uB611\uB614\uB618\uB625\uB62C\uB634\uB648\uB664\uB668\uB69C\uB69D\uB6A0\uB6A4\uB6AB\uB6AC\uB6B1\uB6D4\uB6F0\uB6F4\uB6F8\uB700\uB701\uB705\uB728\uB729\uB72C\uB72F\uB730\uB738\uB739\uB73B\uB744\uB748\uB74C\uB754\uB755\uB760\uB764\uB768\uB770\uB771\uB773\uB775\uB77C\uB77D\uB780\uB784\uB78C\uB78D\uB78F\uB790\uB791\uB792\uB796\uB797"
    ],
    [
        "b741",
        "\uD16E",
        13,
        "\uD17D",
        6,
        "\uD185\uD186\uD187\uD189\uD18A"
    ],
    [
        "b761",
        "\uD18B",
        20,
        "\uD1A2\uD1A3\uD1A5\uD1A6\uD1A7"
    ],
    [
        "b781",
        "\uD1A9",
        6,
        "\uD1B2\uD1B4\uD1B6\uD1B7\uD1B8\uD1B9\uD1BB\uD1BD\uD1BE\uD1BF\uD1C1",
        14,
        "\uB798\uB799\uB79C\uB7A0\uB7A8\uB7A9\uB7AB\uB7AC\uB7AD\uB7B4\uB7B5\uB7B8\uB7C7\uB7C9\uB7EC\uB7ED\uB7F0\uB7F4\uB7FC\uB7FD\uB7FF\uB800\uB801\uB807\uB808\uB809\uB80C\uB810\uB818\uB819\uB81B\uB81D\uB824\uB825\uB828\uB82C\uB834\uB835\uB837\uB838\uB839\uB840\uB844\uB851\uB853\uB85C\uB85D\uB860\uB864\uB86C\uB86D\uB86F\uB871\uB878\uB87C\uB88D\uB8A8\uB8B0\uB8B4\uB8B8\uB8C0\uB8C1\uB8C3\uB8C5\uB8CC\uB8D0\uB8D4\uB8DD\uB8DF\uB8E1\uB8E8\uB8E9\uB8EC\uB8F0\uB8F8\uB8F9\uB8FB\uB8FD\uB904\uB918\uB920\uB93C\uB93D\uB940\uB944\uB94C\uB94F\uB951\uB958\uB959\uB95C\uB960\uB968\uB969"
    ],
    [
        "b841",
        "\uD1D0",
        7,
        "\uD1D9",
        17
    ],
    [
        "b861",
        "\uD1EB",
        8,
        "\uD1F5\uD1F6\uD1F7\uD1F9",
        13
    ],
    [
        "b881",
        "\uD208\uD20A",
        5,
        "\uD211",
        24,
        "\uB96B\uB96D\uB974\uB975\uB978\uB97C\uB984\uB985\uB987\uB989\uB98A\uB98D\uB98E\uB9AC\uB9AD\uB9B0\uB9B4\uB9BC\uB9BD\uB9BF\uB9C1\uB9C8\uB9C9\uB9CC\uB9CE",
        4,
        "\uB9D8\uB9D9\uB9DB\uB9DD\uB9DE\uB9E1\uB9E3\uB9E4\uB9E5\uB9E8\uB9EC\uB9F4\uB9F5\uB9F7\uB9F8\uB9F9\uB9FA\uBA00\uBA01\uBA08\uBA15\uBA38\uBA39\uBA3C\uBA40\uBA42\uBA48\uBA49\uBA4B\uBA4D\uBA4E\uBA53\uBA54\uBA55\uBA58\uBA5C\uBA64\uBA65\uBA67\uBA68\uBA69\uBA70\uBA71\uBA74\uBA78\uBA83\uBA84\uBA85\uBA87\uBA8C\uBAA8\uBAA9\uBAAB\uBAAC\uBAB0\uBAB2\uBAB8\uBAB9\uBABB\uBABD\uBAC4\uBAC8\uBAD8\uBAD9\uBAFC"
    ],
    [
        "b941",
        "\uD22A\uD22B\uD22E\uD22F\uD231\uD232\uD233\uD235",
        6,
        "\uD23E\uD240\uD242",
        5,
        "\uD249\uD24A\uD24B\uD24C"
    ],
    [
        "b961",
        "\uD24D",
        14,
        "\uD25D",
        6,
        "\uD265\uD266\uD267\uD268"
    ],
    [
        "b981",
        "\uD269",
        22,
        "\uD282\uD283\uD285\uD286\uD287\uD289\uD28A\uD28B\uD28C\uBB00\uBB04\uBB0D\uBB0F\uBB11\uBB18\uBB1C\uBB20\uBB29\uBB2B\uBB34\uBB35\uBB36\uBB38\uBB3B\uBB3C\uBB3D\uBB3E\uBB44\uBB45\uBB47\uBB49\uBB4D\uBB4F\uBB50\uBB54\uBB58\uBB61\uBB63\uBB6C\uBB88\uBB8C\uBB90\uBBA4\uBBA8\uBBAC\uBBB4\uBBB7\uBBC0\uBBC4\uBBC8\uBBD0\uBBD3\uBBF8\uBBF9\uBBFC\uBBFF\uBC00\uBC02\uBC08\uBC09\uBC0B\uBC0C\uBC0D\uBC0F\uBC11\uBC14",
        4,
        "\uBC1B",
        4,
        "\uBC24\uBC25\uBC27\uBC29\uBC2D\uBC30\uBC31\uBC34\uBC38\uBC40\uBC41\uBC43\uBC44\uBC45\uBC49\uBC4C\uBC4D\uBC50\uBC5D\uBC84\uBC85\uBC88\uBC8B\uBC8C\uBC8E\uBC94\uBC95\uBC97"
    ],
    [
        "ba41",
        "\uD28D\uD28E\uD28F\uD292\uD293\uD294\uD296",
        5,
        "\uD29D\uD29E\uD29F\uD2A1\uD2A2\uD2A3\uD2A5",
        6,
        "\uD2AD"
    ],
    [
        "ba61",
        "\uD2AE\uD2AF\uD2B0\uD2B2",
        5,
        "\uD2BA\uD2BB\uD2BD\uD2BE\uD2C1\uD2C3",
        4,
        "\uD2CA\uD2CC",
        5
    ],
    [
        "ba81",
        "\uD2D2\uD2D3\uD2D5\uD2D6\uD2D7\uD2D9\uD2DA\uD2DB\uD2DD",
        6,
        "\uD2E6",
        9,
        "\uD2F2\uD2F3\uD2F5\uD2F6\uD2F7\uD2F9\uD2FA\uBC99\uBC9A\uBCA0\uBCA1\uBCA4\uBCA7\uBCA8\uBCB0\uBCB1\uBCB3\uBCB4\uBCB5\uBCBC\uBCBD\uBCC0\uBCC4\uBCCD\uBCCF\uBCD0\uBCD1\uBCD5\uBCD8\uBCDC\uBCF4\uBCF5\uBCF6\uBCF8\uBCFC\uBD04\uBD05\uBD07\uBD09\uBD10\uBD14\uBD24\uBD2C\uBD40\uBD48\uBD49\uBD4C\uBD50\uBD58\uBD59\uBD64\uBD68\uBD80\uBD81\uBD84\uBD87\uBD88\uBD89\uBD8A\uBD90\uBD91\uBD93\uBD95\uBD99\uBD9A\uBD9C\uBDA4\uBDB0\uBDB8\uBDD4\uBDD5\uBDD8\uBDDC\uBDE9\uBDF0\uBDF4\uBDF8\uBE00\uBE03\uBE05\uBE0C\uBE0D\uBE10\uBE14\uBE1C\uBE1D\uBE1F\uBE44\uBE45\uBE48\uBE4C\uBE4E\uBE54\uBE55\uBE57\uBE59\uBE5A\uBE5B\uBE60\uBE61\uBE64"
    ],
    [
        "bb41",
        "\uD2FB",
        4,
        "\uD302\uD304\uD306",
        5,
        "\uD30F\uD311\uD312\uD313\uD315\uD317",
        4,
        "\uD31E\uD322\uD323"
    ],
    [
        "bb61",
        "\uD324\uD326\uD327\uD32A\uD32B\uD32D\uD32E\uD32F\uD331",
        6,
        "\uD33A\uD33E",
        5,
        "\uD346\uD347\uD348\uD349"
    ],
    [
        "bb81",
        "\uD34A",
        31,
        "\uBE68\uBE6A\uBE70\uBE71\uBE73\uBE74\uBE75\uBE7B\uBE7C\uBE7D\uBE80\uBE84\uBE8C\uBE8D\uBE8F\uBE90\uBE91\uBE98\uBE99\uBEA8\uBED0\uBED1\uBED4\uBED7\uBED8\uBEE0\uBEE3\uBEE4\uBEE5\uBEEC\uBF01\uBF08\uBF09\uBF18\uBF19\uBF1B\uBF1C\uBF1D\uBF40\uBF41\uBF44\uBF48\uBF50\uBF51\uBF55\uBF94\uBFB0\uBFC5\uBFCC\uBFCD\uBFD0\uBFD4\uBFDC\uBFDF\uBFE1\uC03C\uC051\uC058\uC05C\uC060\uC068\uC069\uC090\uC091\uC094\uC098\uC0A0\uC0A1\uC0A3\uC0A5\uC0AC\uC0AD\uC0AF\uC0B0\uC0B3\uC0B4\uC0B5\uC0B6\uC0BC\uC0BD\uC0BF\uC0C0\uC0C1\uC0C5\uC0C8\uC0C9\uC0CC\uC0D0\uC0D8\uC0D9\uC0DB\uC0DC\uC0DD\uC0E4"
    ],
    [
        "bc41",
        "\uD36A",
        17,
        "\uD37E\uD37F\uD381\uD382\uD383\uD385\uD386\uD387"
    ],
    [
        "bc61",
        "\uD388\uD389\uD38A\uD38B\uD38E\uD392",
        5,
        "\uD39A\uD39B\uD39D\uD39E\uD39F\uD3A1",
        6,
        "\uD3AA\uD3AC\uD3AE"
    ],
    [
        "bc81",
        "\uD3AF",
        4,
        "\uD3B5\uD3B6\uD3B7\uD3B9\uD3BA\uD3BB\uD3BD",
        6,
        "\uD3C6\uD3C7\uD3CA",
        5,
        "\uD3D1",
        5,
        "\uC0E5\uC0E8\uC0EC\uC0F4\uC0F5\uC0F7\uC0F9\uC100\uC104\uC108\uC110\uC115\uC11C",
        4,
        "\uC123\uC124\uC126\uC127\uC12C\uC12D\uC12F\uC130\uC131\uC136\uC138\uC139\uC13C\uC140\uC148\uC149\uC14B\uC14C\uC14D\uC154\uC155\uC158\uC15C\uC164\uC165\uC167\uC168\uC169\uC170\uC174\uC178\uC185\uC18C\uC18D\uC18E\uC190\uC194\uC196\uC19C\uC19D\uC19F\uC1A1\uC1A5\uC1A8\uC1A9\uC1AC\uC1B0\uC1BD\uC1C4\uC1C8\uC1CC\uC1D4\uC1D7\uC1D8\uC1E0\uC1E4\uC1E8\uC1F0\uC1F1\uC1F3\uC1FC\uC1FD\uC200\uC204\uC20C\uC20D\uC20F\uC211\uC218\uC219\uC21C\uC21F\uC220\uC228\uC229\uC22B\uC22D"
    ],
    [
        "bd41",
        "\uD3D7\uD3D9",
        7,
        "\uD3E2\uD3E4",
        7,
        "\uD3EE\uD3EF\uD3F1\uD3F2\uD3F3\uD3F5\uD3F6\uD3F7"
    ],
    [
        "bd61",
        "\uD3F8\uD3F9\uD3FA\uD3FB\uD3FE\uD400\uD402",
        5,
        "\uD409",
        13
    ],
    [
        "bd81",
        "\uD417",
        5,
        "\uD41E",
        25,
        "\uC22F\uC231\uC232\uC234\uC248\uC250\uC251\uC254\uC258\uC260\uC265\uC26C\uC26D\uC270\uC274\uC27C\uC27D\uC27F\uC281\uC288\uC289\uC290\uC298\uC29B\uC29D\uC2A4\uC2A5\uC2A8\uC2AC\uC2AD\uC2B4\uC2B5\uC2B7\uC2B9\uC2DC\uC2DD\uC2E0\uC2E3\uC2E4\uC2EB\uC2EC\uC2ED\uC2EF\uC2F1\uC2F6\uC2F8\uC2F9\uC2FB\uC2FC\uC300\uC308\uC309\uC30C\uC30D\uC313\uC314\uC315\uC318\uC31C\uC324\uC325\uC328\uC329\uC345\uC368\uC369\uC36C\uC370\uC372\uC378\uC379\uC37C\uC37D\uC384\uC388\uC38C\uC3C0\uC3D8\uC3D9\uC3DC\uC3DF\uC3E0\uC3E2\uC3E8\uC3E9\uC3ED\uC3F4\uC3F5\uC3F8\uC408\uC410\uC424\uC42C\uC430"
    ],
    [
        "be41",
        "\uD438",
        7,
        "\uD441\uD442\uD443\uD445",
        14
    ],
    [
        "be61",
        "\uD454",
        7,
        "\uD45D\uD45E\uD45F\uD461\uD462\uD463\uD465",
        7,
        "\uD46E\uD470\uD471\uD472"
    ],
    [
        "be81",
        "\uD473",
        4,
        "\uD47A\uD47B\uD47D\uD47E\uD481\uD483",
        4,
        "\uD48A\uD48C\uD48E",
        5,
        "\uD495",
        8,
        "\uC434\uC43C\uC43D\uC448\uC464\uC465\uC468\uC46C\uC474\uC475\uC479\uC480\uC494\uC49C\uC4B8\uC4BC\uC4E9\uC4F0\uC4F1\uC4F4\uC4F8\uC4FA\uC4FF\uC500\uC501\uC50C\uC510\uC514\uC51C\uC528\uC529\uC52C\uC530\uC538\uC539\uC53B\uC53D\uC544\uC545\uC548\uC549\uC54A\uC54C\uC54D\uC54E\uC553\uC554\uC555\uC557\uC558\uC559\uC55D\uC55E\uC560\uC561\uC564\uC568\uC570\uC571\uC573\uC574\uC575\uC57C\uC57D\uC580\uC584\uC587\uC58C\uC58D\uC58F\uC591\uC595\uC597\uC598\uC59C\uC5A0\uC5A9\uC5B4\uC5B5\uC5B8\uC5B9\uC5BB\uC5BC\uC5BD\uC5BE\uC5C4",
        6,
        "\uC5CC\uC5CE"
    ],
    [
        "bf41",
        "\uD49E",
        10,
        "\uD4AA",
        14
    ],
    [
        "bf61",
        "\uD4B9",
        18,
        "\uD4CD\uD4CE\uD4CF\uD4D1\uD4D2\uD4D3\uD4D5"
    ],
    [
        "bf81",
        "\uD4D6",
        5,
        "\uD4DD\uD4DE\uD4E0",
        7,
        "\uD4E9\uD4EA\uD4EB\uD4ED\uD4EE\uD4EF\uD4F1",
        6,
        "\uD4F9\uD4FA\uD4FC\uC5D0\uC5D1\uC5D4\uC5D8\uC5E0\uC5E1\uC5E3\uC5E5\uC5EC\uC5ED\uC5EE\uC5F0\uC5F4\uC5F6\uC5F7\uC5FC",
        5,
        "\uC605\uC606\uC607\uC608\uC60C\uC610\uC618\uC619\uC61B\uC61C\uC624\uC625\uC628\uC62C\uC62D\uC62E\uC630\uC633\uC634\uC635\uC637\uC639\uC63B\uC640\uC641\uC644\uC648\uC650\uC651\uC653\uC654\uC655\uC65C\uC65D\uC660\uC66C\uC66F\uC671\uC678\uC679\uC67C\uC680\uC688\uC689\uC68B\uC68D\uC694\uC695\uC698\uC69C\uC6A4\uC6A5\uC6A7\uC6A9\uC6B0\uC6B1\uC6B4\uC6B8\uC6B9\uC6BA\uC6C0\uC6C1\uC6C3\uC6C5\uC6CC\uC6CD\uC6D0\uC6D4\uC6DC\uC6DD\uC6E0\uC6E1\uC6E8"
    ],
    [
        "c041",
        "\uD4FE",
        5,
        "\uD505\uD506\uD507\uD509\uD50A\uD50B\uD50D",
        6,
        "\uD516\uD518",
        5
    ],
    [
        "c061",
        "\uD51E",
        25
    ],
    [
        "c081",
        "\uD538\uD539\uD53A\uD53B\uD53E\uD53F\uD541\uD542\uD543\uD545",
        6,
        "\uD54E\uD550\uD552",
        5,
        "\uD55A\uD55B\uD55D\uD55E\uD55F\uD561\uD562\uD563\uC6E9\uC6EC\uC6F0\uC6F8\uC6F9\uC6FD\uC704\uC705\uC708\uC70C\uC714\uC715\uC717\uC719\uC720\uC721\uC724\uC728\uC730\uC731\uC733\uC735\uC737\uC73C\uC73D\uC740\uC744\uC74A\uC74C\uC74D\uC74F\uC751",
        7,
        "\uC75C\uC760\uC768\uC76B\uC774\uC775\uC778\uC77C\uC77D\uC77E\uC783\uC784\uC785\uC787\uC788\uC789\uC78A\uC78E\uC790\uC791\uC794\uC796\uC797\uC798\uC79A\uC7A0\uC7A1\uC7A3\uC7A4\uC7A5\uC7A6\uC7AC\uC7AD\uC7B0\uC7B4\uC7BC\uC7BD\uC7BF\uC7C0\uC7C1\uC7C8\uC7C9\uC7CC\uC7CE\uC7D0\uC7D8\uC7DD\uC7E4\uC7E8\uC7EC\uC800\uC801\uC804\uC808\uC80A"
    ],
    [
        "c141",
        "\uD564\uD566\uD567\uD56A\uD56C\uD56E",
        5,
        "\uD576\uD577\uD579\uD57A\uD57B\uD57D",
        6,
        "\uD586\uD58A\uD58B"
    ],
    [
        "c161",
        "\uD58C\uD58D\uD58E\uD58F\uD591",
        19,
        "\uD5A6\uD5A7"
    ],
    [
        "c181",
        "\uD5A8",
        31,
        "\uC810\uC811\uC813\uC815\uC816\uC81C\uC81D\uC820\uC824\uC82C\uC82D\uC82F\uC831\uC838\uC83C\uC840\uC848\uC849\uC84C\uC84D\uC854\uC870\uC871\uC874\uC878\uC87A\uC880\uC881\uC883\uC885\uC886\uC887\uC88B\uC88C\uC88D\uC894\uC89D\uC89F\uC8A1\uC8A8\uC8BC\uC8BD\uC8C4\uC8C8\uC8CC\uC8D4\uC8D5\uC8D7\uC8D9\uC8E0\uC8E1\uC8E4\uC8F5\uC8FC\uC8FD\uC900\uC904\uC905\uC906\uC90C\uC90D\uC90F\uC911\uC918\uC92C\uC934\uC950\uC951\uC954\uC958\uC960\uC961\uC963\uC96C\uC970\uC974\uC97C\uC988\uC989\uC98C\uC990\uC998\uC999\uC99B\uC99D\uC9C0\uC9C1\uC9C4\uC9C7\uC9C8\uC9CA\uC9D0\uC9D1\uC9D3"
    ],
    [
        "c241",
        "\uD5CA\uD5CB\uD5CD\uD5CE\uD5CF\uD5D1\uD5D3",
        4,
        "\uD5DA\uD5DC\uD5DE",
        5,
        "\uD5E6\uD5E7\uD5E9\uD5EA\uD5EB\uD5ED\uD5EE"
    ],
    [
        "c261",
        "\uD5EF",
        4,
        "\uD5F6\uD5F8\uD5FA",
        5,
        "\uD602\uD603\uD605\uD606\uD607\uD609",
        6,
        "\uD612"
    ],
    [
        "c281",
        "\uD616",
        5,
        "\uD61D\uD61E\uD61F\uD621\uD622\uD623\uD625",
        7,
        "\uD62E",
        9,
        "\uD63A\uD63B\uC9D5\uC9D6\uC9D9\uC9DA\uC9DC\uC9DD\uC9E0\uC9E2\uC9E4\uC9E7\uC9EC\uC9ED\uC9EF\uC9F0\uC9F1\uC9F8\uC9F9\uC9FC\uCA00\uCA08\uCA09\uCA0B\uCA0C\uCA0D\uCA14\uCA18\uCA29\uCA4C\uCA4D\uCA50\uCA54\uCA5C\uCA5D\uCA5F\uCA60\uCA61\uCA68\uCA7D\uCA84\uCA98\uCABC\uCABD\uCAC0\uCAC4\uCACC\uCACD\uCACF\uCAD1\uCAD3\uCAD8\uCAD9\uCAE0\uCAEC\uCAF4\uCB08\uCB10\uCB14\uCB18\uCB20\uCB21\uCB41\uCB48\uCB49\uCB4C\uCB50\uCB58\uCB59\uCB5D\uCB64\uCB78\uCB79\uCB9C\uCBB8\uCBD4\uCBE4\uCBE7\uCBE9\uCC0C\uCC0D\uCC10\uCC14\uCC1C\uCC1D\uCC21\uCC22\uCC27\uCC28\uCC29\uCC2C\uCC2E\uCC30\uCC38\uCC39\uCC3B"
    ],
    [
        "c341",
        "\uD63D\uD63E\uD63F\uD641\uD642\uD643\uD644\uD646\uD647\uD64A\uD64C\uD64E\uD64F\uD650\uD652\uD653\uD656\uD657\uD659\uD65A\uD65B\uD65D",
        4
    ],
    [
        "c361",
        "\uD662",
        4,
        "\uD668\uD66A",
        5,
        "\uD672\uD673\uD675",
        11
    ],
    [
        "c381",
        "\uD681\uD682\uD684\uD686",
        5,
        "\uD68E\uD68F\uD691\uD692\uD693\uD695",
        7,
        "\uD69E\uD6A0\uD6A2",
        5,
        "\uD6A9\uD6AA\uCC3C\uCC3D\uCC3E\uCC44\uCC45\uCC48\uCC4C\uCC54\uCC55\uCC57\uCC58\uCC59\uCC60\uCC64\uCC66\uCC68\uCC70\uCC75\uCC98\uCC99\uCC9C\uCCA0\uCCA8\uCCA9\uCCAB\uCCAC\uCCAD\uCCB4\uCCB5\uCCB8\uCCBC\uCCC4\uCCC5\uCCC7\uCCC9\uCCD0\uCCD4\uCCE4\uCCEC\uCCF0\uCD01\uCD08\uCD09\uCD0C\uCD10\uCD18\uCD19\uCD1B\uCD1D\uCD24\uCD28\uCD2C\uCD39\uCD5C\uCD60\uCD64\uCD6C\uCD6D\uCD6F\uCD71\uCD78\uCD88\uCD94\uCD95\uCD98\uCD9C\uCDA4\uCDA5\uCDA7\uCDA9\uCDB0\uCDC4\uCDCC\uCDD0\uCDE8\uCDEC\uCDF0\uCDF8\uCDF9\uCDFB\uCDFD\uCE04\uCE08\uCE0C\uCE14\uCE19\uCE20\uCE21\uCE24\uCE28\uCE30\uCE31\uCE33\uCE35"
    ],
    [
        "c441",
        "\uD6AB\uD6AD\uD6AE\uD6AF\uD6B1",
        7,
        "\uD6BA\uD6BC",
        7,
        "\uD6C6\uD6C7\uD6C9\uD6CA\uD6CB"
    ],
    [
        "c461",
        "\uD6CD\uD6CE\uD6CF\uD6D0\uD6D2\uD6D3\uD6D5\uD6D6\uD6D8\uD6DA",
        5,
        "\uD6E1\uD6E2\uD6E3\uD6E5\uD6E6\uD6E7\uD6E9",
        4
    ],
    [
        "c481",
        "\uD6EE\uD6EF\uD6F1\uD6F2\uD6F3\uD6F4\uD6F6",
        5,
        "\uD6FE\uD6FF\uD701\uD702\uD703\uD705",
        11,
        "\uD712\uD713\uD714\uCE58\uCE59\uCE5C\uCE5F\uCE60\uCE61\uCE68\uCE69\uCE6B\uCE6D\uCE74\uCE75\uCE78\uCE7C\uCE84\uCE85\uCE87\uCE89\uCE90\uCE91\uCE94\uCE98\uCEA0\uCEA1\uCEA3\uCEA4\uCEA5\uCEAC\uCEAD\uCEC1\uCEE4\uCEE5\uCEE8\uCEEB\uCEEC\uCEF4\uCEF5\uCEF7\uCEF8\uCEF9\uCF00\uCF01\uCF04\uCF08\uCF10\uCF11\uCF13\uCF15\uCF1C\uCF20\uCF24\uCF2C\uCF2D\uCF2F\uCF30\uCF31\uCF38\uCF54\uCF55\uCF58\uCF5C\uCF64\uCF65\uCF67\uCF69\uCF70\uCF71\uCF74\uCF78\uCF80\uCF85\uCF8C\uCFA1\uCFA8\uCFB0\uCFC4\uCFE0\uCFE1\uCFE4\uCFE8\uCFF0\uCFF1\uCFF3\uCFF5\uCFFC\uD000\uD004\uD011\uD018\uD02D\uD034\uD035\uD038\uD03C"
    ],
    [
        "c541",
        "\uD715\uD716\uD717\uD71A\uD71B\uD71D\uD71E\uD71F\uD721",
        6,
        "\uD72A\uD72C\uD72E",
        5,
        "\uD736\uD737\uD739"
    ],
    [
        "c561",
        "\uD73A\uD73B\uD73D",
        6,
        "\uD745\uD746\uD748\uD74A",
        5,
        "\uD752\uD753\uD755\uD75A",
        4
    ],
    [
        "c581",
        "\uD75F\uD762\uD764\uD766\uD767\uD768\uD76A\uD76B\uD76D\uD76E\uD76F\uD771\uD772\uD773\uD775",
        6,
        "\uD77E\uD77F\uD780\uD782",
        5,
        "\uD78A\uD78B\uD044\uD045\uD047\uD049\uD050\uD054\uD058\uD060\uD06C\uD06D\uD070\uD074\uD07C\uD07D\uD081\uD0A4\uD0A5\uD0A8\uD0AC\uD0B4\uD0B5\uD0B7\uD0B9\uD0C0\uD0C1\uD0C4\uD0C8\uD0C9\uD0D0\uD0D1\uD0D3\uD0D4\uD0D5\uD0DC\uD0DD\uD0E0\uD0E4\uD0EC\uD0ED\uD0EF\uD0F0\uD0F1\uD0F8\uD10D\uD130\uD131\uD134\uD138\uD13A\uD140\uD141\uD143\uD144\uD145\uD14C\uD14D\uD150\uD154\uD15C\uD15D\uD15F\uD161\uD168\uD16C\uD17C\uD184\uD188\uD1A0\uD1A1\uD1A4\uD1A8\uD1B0\uD1B1\uD1B3\uD1B5\uD1BA\uD1BC\uD1C0\uD1D8\uD1F4\uD1F8\uD207\uD209\uD210\uD22C\uD22D\uD230\uD234\uD23C\uD23D\uD23F\uD241\uD248\uD25C"
    ],
    [
        "c641",
        "\uD78D\uD78E\uD78F\uD791",
        6,
        "\uD79A\uD79C\uD79E",
        5
    ],
    [
        "c6a1",
        "\uD264\uD280\uD281\uD284\uD288\uD290\uD291\uD295\uD29C\uD2A0\uD2A4\uD2AC\uD2B1\uD2B8\uD2B9\uD2BC\uD2BF\uD2C0\uD2C2\uD2C8\uD2C9\uD2CB\uD2D4\uD2D8\uD2DC\uD2E4\uD2E5\uD2F0\uD2F1\uD2F4\uD2F8\uD300\uD301\uD303\uD305\uD30C\uD30D\uD30E\uD310\uD314\uD316\uD31C\uD31D\uD31F\uD320\uD321\uD325\uD328\uD329\uD32C\uD330\uD338\uD339\uD33B\uD33C\uD33D\uD344\uD345\uD37C\uD37D\uD380\uD384\uD38C\uD38D\uD38F\uD390\uD391\uD398\uD399\uD39C\uD3A0\uD3A8\uD3A9\uD3AB\uD3AD\uD3B4\uD3B8\uD3BC\uD3C4\uD3C5\uD3C8\uD3C9\uD3D0\uD3D8\uD3E1\uD3E3\uD3EC\uD3ED\uD3F0\uD3F4\uD3FC\uD3FD\uD3FF\uD401"
    ],
    [
        "c7a1",
        "\uD408\uD41D\uD440\uD444\uD45C\uD460\uD464\uD46D\uD46F\uD478\uD479\uD47C\uD47F\uD480\uD482\uD488\uD489\uD48B\uD48D\uD494\uD4A9\uD4CC\uD4D0\uD4D4\uD4DC\uD4DF\uD4E8\uD4EC\uD4F0\uD4F8\uD4FB\uD4FD\uD504\uD508\uD50C\uD514\uD515\uD517\uD53C\uD53D\uD540\uD544\uD54C\uD54D\uD54F\uD551\uD558\uD559\uD55C\uD560\uD565\uD568\uD569\uD56B\uD56D\uD574\uD575\uD578\uD57C\uD584\uD585\uD587\uD588\uD589\uD590\uD5A5\uD5C8\uD5C9\uD5CC\uD5D0\uD5D2\uD5D8\uD5D9\uD5DB\uD5DD\uD5E4\uD5E5\uD5E8\uD5EC\uD5F4\uD5F5\uD5F7\uD5F9\uD600\uD601\uD604\uD608\uD610\uD611\uD613\uD614\uD615\uD61C\uD620"
    ],
    [
        "c8a1",
        "\uD624\uD62D\uD638\uD639\uD63C\uD640\uD645\uD648\uD649\uD64B\uD64D\uD651\uD654\uD655\uD658\uD65C\uD667\uD669\uD670\uD671\uD674\uD683\uD685\uD68C\uD68D\uD690\uD694\uD69D\uD69F\uD6A1\uD6A8\uD6AC\uD6B0\uD6B9\uD6BB\uD6C4\uD6C5\uD6C8\uD6CC\uD6D1\uD6D4\uD6D7\uD6D9\uD6E0\uD6E4\uD6E8\uD6F0\uD6F5\uD6FC\uD6FD\uD700\uD704\uD711\uD718\uD719\uD71C\uD720\uD728\uD729\uD72B\uD72D\uD734\uD735\uD738\uD73C\uD744\uD747\uD749\uD750\uD751\uD754\uD756\uD757\uD758\uD759\uD760\uD761\uD763\uD765\uD769\uD76C\uD770\uD774\uD77C\uD77D\uD781\uD788\uD789\uD78C\uD790\uD798\uD799\uD79B\uD79D"
    ],
    [
        "caa1",
        "\u4F3D\u4F73\u5047\u50F9\u52A0\u53EF\u5475\u54E5\u5609\u5AC1\u5BB6\u6687\u67B6\u67B7\u67EF\u6B4C\u73C2\u75C2\u7A3C\u82DB\u8304\u8857\u8888\u8A36\u8CC8\u8DCF\u8EFB\u8FE6\u99D5\u523B\u5374\u5404\u606A\u6164\u6BBC\u73CF\u811A\u89BA\u89D2\u95A3\u4F83\u520A\u58BE\u5978\u59E6\u5E72\u5E79\u61C7\u63C0\u6746\u67EC\u687F\u6F97\u764E\u770B\u78F5\u7A08\u7AFF\u7C21\u809D\u826E\u8271\u8AEB\u9593\u4E6B\u559D\u66F7\u6E34\u78A3\u7AED\u845B\u8910\u874E\u97A8\u52D8\u574E\u582A\u5D4C\u611F\u61BE\u6221\u6562\u67D1\u6A44\u6E1B\u7518\u75B3\u76E3\u77B0\u7D3A\u90AF\u9451\u9452\u9F95"
    ],
    [
        "cba1",
        "\u5323\u5CAC\u7532\u80DB\u9240\u9598\u525B\u5808\u59DC\u5CA1\u5D17\u5EB7\u5F3A\u5F4A\u6177\u6C5F\u757A\u7586\u7CE0\u7D73\u7DB1\u7F8C\u8154\u8221\u8591\u8941\u8B1B\u92FC\u964D\u9C47\u4ECB\u4EF7\u500B\u51F1\u584F\u6137\u613E\u6168\u6539\u69EA\u6F11\u75A5\u7686\u76D6\u7B87\u82A5\u84CB\uF900\u93A7\u958B\u5580\u5BA2\u5751\uF901\u7CB3\u7FB9\u91B5\u5028\u53BB\u5C45\u5DE8\u62D2\u636E\u64DA\u64E7\u6E20\u70AC\u795B\u8DDD\u8E1E\uF902\u907D\u9245\u92F8\u4E7E\u4EF6\u5065\u5DFE\u5EFA\u6106\u6957\u8171\u8654\u8E47\u9375\u9A2B\u4E5E\u5091\u6770\u6840\u5109\u528D\u5292\u6AA2"
    ],
    [
        "cca1",
        "\u77BC\u9210\u9ED4\u52AB\u602F\u8FF2\u5048\u61A9\u63ED\u64CA\u683C\u6A84\u6FC0\u8188\u89A1\u9694\u5805\u727D\u72AC\u7504\u7D79\u7E6D\u80A9\u898B\u8B74\u9063\u9D51\u6289\u6C7A\u6F54\u7D50\u7F3A\u8A23\u517C\u614A\u7B9D\u8B19\u9257\u938C\u4EAC\u4FD3\u501E\u50BE\u5106\u52C1\u52CD\u537F\u5770\u5883\u5E9A\u5F91\u6176\u61AC\u64CE\u656C\u666F\u66BB\u66F4\u6897\u6D87\u7085\u70F1\u749F\u74A5\u74CA\u75D9\u786C\u78EC\u7ADF\u7AF6\u7D45\u7D93\u8015\u803F\u811B\u8396\u8B66\u8F15\u9015\u93E1\u9803\u9838\u9A5A\u9BE8\u4FC2\u5553\u583A\u5951\u5B63\u5C46\u60B8\u6212\u6842\u68B0"
    ],
    [
        "cda1",
        "\u68E8\u6EAA\u754C\u7678\u78CE\u7A3D\u7CFB\u7E6B\u7E7C\u8A08\u8AA1\u8C3F\u968E\u9DC4\u53E4\u53E9\u544A\u5471\u56FA\u59D1\u5B64\u5C3B\u5EAB\u62F7\u6537\u6545\u6572\u66A0\u67AF\u69C1\u6CBD\u75FC\u7690\u777E\u7A3F\u7F94\u8003\u80A1\u818F\u82E6\u82FD\u83F0\u85C1\u8831\u88B4\u8AA5\uF903\u8F9C\u932E\u96C7\u9867\u9AD8\u9F13\u54ED\u659B\u66F2\u688F\u7A40\u8C37\u9D60\u56F0\u5764\u5D11\u6606\u68B1\u68CD\u6EFE\u7428\u889E\u9BE4\u6C68\uF904\u9AA8\u4F9B\u516C\u5171\u529F\u5B54\u5DE5\u6050\u606D\u62F1\u63A7\u653B\u73D9\u7A7A\u86A3\u8CA2\u978F\u4E32\u5BE1\u6208\u679C\u74DC"
    ],
    [
        "cea1",
        "\u79D1\u83D3\u8A87\u8AB2\u8DE8\u904E\u934B\u9846\u5ED3\u69E8\u85FF\u90ED\uF905\u51A0\u5B98\u5BEC\u6163\u68FA\u6B3E\u704C\u742F\u74D8\u7BA1\u7F50\u83C5\u89C0\u8CAB\u95DC\u9928\u522E\u605D\u62EC\u9002\u4F8A\u5149\u5321\u58D9\u5EE3\u66E0\u6D38\u709A\u72C2\u73D6\u7B50\u80F1\u945B\u5366\u639B\u7F6B\u4E56\u5080\u584A\u58DE\u602A\u6127\u62D0\u69D0\u9B41\u5B8F\u7D18\u80B1\u8F5F\u4EA4\u50D1\u54AC\u55AC\u5B0C\u5DA0\u5DE7\u652A\u654E\u6821\u6A4B\u72E1\u768E\u77EF\u7D5E\u7FF9\u81A0\u854E\u86DF\u8F03\u8F4E\u90CA\u9903\u9A55\u9BAB\u4E18\u4E45\u4E5D\u4EC7\u4FF1\u5177\u52FE"
    ],
    [
        "cfa1",
        "\u5340\u53E3\u53E5\u548E\u5614\u5775\u57A2\u5BC7\u5D87\u5ED0\u61FC\u62D8\u6551\u67B8\u67E9\u69CB\u6B50\u6BC6\u6BEC\u6C42\u6E9D\u7078\u72D7\u7396\u7403\u77BF\u77E9\u7A76\u7D7F\u8009\u81FC\u8205\u820A\u82DF\u8862\u8B33\u8CFC\u8EC0\u9011\u90B1\u9264\u92B6\u99D2\u9A45\u9CE9\u9DD7\u9F9C\u570B\u5C40\u83CA\u97A0\u97AB\u9EB4\u541B\u7A98\u7FA4\u88D9\u8ECD\u90E1\u5800\u5C48\u6398\u7A9F\u5BAE\u5F13\u7A79\u7AAE\u828E\u8EAC\u5026\u5238\u52F8\u5377\u5708\u62F3\u6372\u6B0A\u6DC3\u7737\u53A5\u7357\u8568\u8E76\u95D5\u673A\u6AC3\u6F70\u8A6D\u8ECC\u994B\uF906\u6677\u6B78\u8CB4"
    ],
    [
        "d0a1",
        "\u9B3C\uF907\u53EB\u572D\u594E\u63C6\u69FB\u73EA\u7845\u7ABA\u7AC5\u7CFE\u8475\u898F\u8D73\u9035\u95A8\u52FB\u5747\u7547\u7B60\u83CC\u921E\uF908\u6A58\u514B\u524B\u5287\u621F\u68D8\u6975\u9699\u50C5\u52A4\u52E4\u61C3\u65A4\u6839\u69FF\u747E\u7B4B\u82B9\u83EB\u89B2\u8B39\u8FD1\u9949\uF909\u4ECA\u5997\u64D2\u6611\u6A8E\u7434\u7981\u79BD\u82A9\u887E\u887F\u895F\uF90A\u9326\u4F0B\u53CA\u6025\u6271\u6C72\u7D1A\u7D66\u4E98\u5162\u77DC\u80AF\u4F01\u4F0E\u5176\u5180\u55DC\u5668\u573B\u57FA\u57FC\u5914\u5947\u5993\u5BC4\u5C90\u5D0E\u5DF1\u5E7E\u5FCC\u6280\u65D7\u65E3"
    ],
    [
        "d1a1",
        "\u671E\u671F\u675E\u68CB\u68C4\u6A5F\u6B3A\u6C23\u6C7D\u6C82\u6DC7\u7398\u7426\u742A\u7482\u74A3\u7578\u757F\u7881\u78EF\u7941\u7947\u7948\u797A\u7B95\u7D00\u7DBA\u7F88\u8006\u802D\u808C\u8A18\u8B4F\u8C48\u8D77\u9321\u9324\u98E2\u9951\u9A0E\u9A0F\u9A65\u9E92\u7DCA\u4F76\u5409\u62EE\u6854\u91D1\u55AB\u513A\uF90B\uF90C\u5A1C\u61E6\uF90D\u62CF\u62FF\uF90E",
        5,
        "\u90A3\uF914",
        4,
        "\u8AFE\uF919\uF91A\uF91B\uF91C\u6696\uF91D\u7156\uF91E\uF91F\u96E3\uF920\u634F\u637A\u5357\uF921\u678F\u6960\u6E73\uF922\u7537\uF923\uF924\uF925"
    ],
    [
        "d2a1",
        "\u7D0D\uF926\uF927\u8872\u56CA\u5A18\uF928",
        4,
        "\u4E43\uF92D\u5167\u5948\u67F0\u8010\uF92E\u5973\u5E74\u649A\u79CA\u5FF5\u606C\u62C8\u637B\u5BE7\u5BD7\u52AA\uF92F\u5974\u5F29\u6012\uF930\uF931\uF932\u7459\uF933",
        5,
        "\u99D1\uF939",
        10,
        "\u6FC3\uF944\uF945\u81BF\u8FB2\u60F1\uF946\uF947\u8166\uF948\uF949\u5C3F\uF94A",
        7,
        "\u5AE9\u8A25\u677B\u7D10\uF952",
        5,
        "\u80FD\uF958\uF959\u5C3C\u6CE5\u533F\u6EBA\u591A\u8336"
    ],
    [
        "d3a1",
        "\u4E39\u4EB6\u4F46\u55AE\u5718\u58C7\u5F56\u65B7\u65E6\u6A80\u6BB5\u6E4D\u77ED\u7AEF\u7C1E\u7DDE\u86CB\u8892\u9132\u935B\u64BB\u6FBE\u737A\u75B8\u9054\u5556\u574D\u61BA\u64D4\u66C7\u6DE1\u6E5B\u6F6D\u6FB9\u75F0\u8043\u81BD\u8541\u8983\u8AC7\u8B5A\u931F\u6C93\u7553\u7B54\u8E0F\u905D\u5510\u5802\u5858\u5E62\u6207\u649E\u68E0\u7576\u7CD6\u87B3\u9EE8\u4EE3\u5788\u576E\u5927\u5C0D\u5CB1\u5E36\u5F85\u6234\u64E1\u73B3\u81FA\u888B\u8CB8\u968A\u9EDB\u5B85\u5FB7\u60B3\u5012\u5200\u5230\u5716\u5835\u5857\u5C0E\u5C60\u5CF6\u5D8B\u5EA6\u5F92\u60BC\u6311\u6389\u6417\u6843"
    ],
    [
        "d4a1",
        "\u68F9\u6AC2\u6DD8\u6E21\u6ED4\u6FE4\u71FE\u76DC\u7779\u79B1\u7A3B\u8404\u89A9\u8CED\u8DF3\u8E48\u9003\u9014\u9053\u90FD\u934D\u9676\u97DC\u6BD2\u7006\u7258\u72A2\u7368\u7763\u79BF\u7BE4\u7E9B\u8B80\u58A9\u60C7\u6566\u65FD\u66BE\u6C8C\u711E\u71C9\u8C5A\u9813\u4E6D\u7A81\u4EDD\u51AC\u51CD\u52D5\u540C\u61A7\u6771\u6850\u68DF\u6D1E\u6F7C\u75BC\u77B3\u7AE5\u80F4\u8463\u9285\u515C\u6597\u675C\u6793\u75D8\u7AC7\u8373\uF95A\u8C46\u9017\u982D\u5C6F\u81C0\u829A\u9041\u906F\u920D\u5F97\u5D9D\u6A59\u71C8\u767B\u7B49\u85E4\u8B04\u9127\u9A30\u5587\u61F6\uF95B\u7669\u7F85"
    ],
    [
        "d5a1",
        "\u863F\u87BA\u88F8\u908F\uF95C\u6D1B\u70D9\u73DE\u7D61\u843D\uF95D\u916A\u99F1\uF95E\u4E82\u5375\u6B04\u6B12\u703E\u721B\u862D\u9E1E\u524C\u8FA3\u5D50\u64E5\u652C\u6B16\u6FEB\u7C43\u7E9C\u85CD\u8964\u89BD\u62C9\u81D8\u881F\u5ECA\u6717\u6D6A\u72FC\u7405\u746F\u8782\u90DE\u4F86\u5D0D\u5FA0\u840A\u51B7\u63A0\u7565\u4EAE\u5006\u5169\u51C9\u6881\u6A11\u7CAE\u7CB1\u7CE7\u826F\u8AD2\u8F1B\u91CF\u4FB6\u5137\u52F5\u5442\u5EEC\u616E\u623E\u65C5\u6ADA\u6FFE\u792A\u85DC\u8823\u95AD\u9A62\u9A6A\u9E97\u9ECE\u529B\u66C6\u6B77\u701D\u792B\u8F62\u9742\u6190\u6200\u6523\u6F23"
    ],
    [
        "d6a1",
        "\u7149\u7489\u7DF4\u806F\u84EE\u8F26\u9023\u934A\u51BD\u5217\u52A3\u6D0C\u70C8\u88C2\u5EC9\u6582\u6BAE\u6FC2\u7C3E\u7375\u4EE4\u4F36\u56F9\uF95F\u5CBA\u5DBA\u601C\u73B2\u7B2D\u7F9A\u7FCE\u8046\u901E\u9234\u96F6\u9748\u9818\u9F61\u4F8B\u6FA7\u79AE\u91B4\u96B7\u52DE\uF960\u6488\u64C4\u6AD3\u6F5E\u7018\u7210\u76E7\u8001\u8606\u865C\u8DEF\u8F05\u9732\u9B6F\u9DFA\u9E75\u788C\u797F\u7DA0\u83C9\u9304\u9E7F\u9E93\u8AD6\u58DF\u5F04\u6727\u7027\u74CF\u7C60\u807E\u5121\u7028\u7262\u78CA\u8CC2\u8CDA\u8CF4\u96F7\u4E86\u50DA\u5BEE\u5ED6\u6599\u71CE\u7642\u77AD\u804A\u84FC"
    ],
    [
        "d7a1",
        "\u907C\u9B27\u9F8D\u58D8\u5A41\u5C62\u6A13\u6DDA\u6F0F\u763B\u7D2F\u7E37\u851E\u8938\u93E4\u964B\u5289\u65D2\u67F3\u69B4\u6D41\u6E9C\u700F\u7409\u7460\u7559\u7624\u786B\u8B2C\u985E\u516D\u622E\u9678\u4F96\u502B\u5D19\u6DEA\u7DB8\u8F2A\u5F8B\u6144\u6817\uF961\u9686\u52D2\u808B\u51DC\u51CC\u695E\u7A1C\u7DBE\u83F1\u9675\u4FDA\u5229\u5398\u540F\u550E\u5C65\u60A7\u674E\u68A8\u6D6C\u7281\u72F8\u7406\u7483\uF962\u75E2\u7C6C\u7F79\u7FB8\u8389\u88CF\u88E1\u91CC\u91D0\u96E2\u9BC9\u541D\u6F7E\u71D0\u7498\u85FA\u8EAA\u96A3\u9C57\u9E9F\u6797\u6DCB\u7433\u81E8\u9716\u782C"
    ],
    [
        "d8a1",
        "\u7ACB\u7B20\u7C92\u6469\u746A\u75F2\u78BC\u78E8\u99AC\u9B54\u9EBB\u5BDE\u5E55\u6F20\u819C\u83AB\u9088\u4E07\u534D\u5A29\u5DD2\u5F4E\u6162\u633D\u6669\u66FC\u6EFF\u6F2B\u7063\u779E\u842C\u8513\u883B\u8F13\u9945\u9C3B\u551C\u62B9\u672B\u6CAB\u8309\u896A\u977A\u4EA1\u5984\u5FD8\u5FD9\u671B\u7DB2\u7F54\u8292\u832B\u83BD\u8F1E\u9099\u57CB\u59B9\u5A92\u5BD0\u6627\u679A\u6885\u6BCF\u7164\u7F75\u8CB7\u8CE3\u9081\u9B45\u8108\u8C8A\u964C\u9A40\u9EA5\u5B5F\u6C13\u731B\u76F2\u76DF\u840C\u51AA\u8993\u514D\u5195\u52C9\u68C9\u6C94\u7704\u7720\u7DBF\u7DEC\u9762\u9EB5\u6EC5"
    ],
    [
        "d9a1",
        "\u8511\u51A5\u540D\u547D\u660E\u669D\u6927\u6E9F\u76BF\u7791\u8317\u84C2\u879F\u9169\u9298\u9CF4\u8882\u4FAE\u5192\u52DF\u59C6\u5E3D\u6155\u6478\u6479\u66AE\u67D0\u6A21\u6BCD\u6BDB\u725F\u7261\u7441\u7738\u77DB\u8017\u82BC\u8305\u8B00\u8B28\u8C8C\u6728\u6C90\u7267\u76EE\u7766\u7A46\u9DA9\u6B7F\u6C92\u5922\u6726\u8499\u536F\u5893\u5999\u5EDF\u63CF\u6634\u6773\u6E3A\u732B\u7AD7\u82D7\u9328\u52D9\u5DEB\u61AE\u61CB\u620A\u62C7\u64AB\u65E0\u6959\u6B66\u6BCB\u7121\u73F7\u755D\u7E46\u821E\u8302\u856A\u8AA3\u8CBF\u9727\u9D61\u58A8\u9ED8\u5011\u520E\u543B\u554F\u6587"
    ],
    [
        "daa1",
        "\u6C76\u7D0A\u7D0B\u805E\u868A\u9580\u96EF\u52FF\u6C95\u7269\u5473\u5A9A\u5C3E\u5D4B\u5F4C\u5FAE\u672A\u68B6\u6963\u6E3C\u6E44\u7709\u7C73\u7F8E\u8587\u8B0E\u8FF7\u9761\u9EF4\u5CB7\u60B6\u610D\u61AB\u654F\u65FB\u65FC\u6C11\u6CEF\u739F\u73C9\u7DE1\u9594\u5BC6\u871C\u8B10\u525D\u535A\u62CD\u640F\u64B2\u6734\u6A38\u6CCA\u73C0\u749E\u7B94\u7C95\u7E1B\u818A\u8236\u8584\u8FEB\u96F9\u99C1\u4F34\u534A\u53CD\u53DB\u62CC\u642C\u6500\u6591\u69C3\u6CEE\u6F58\u73ED\u7554\u7622\u76E4\u76FC\u78D0\u78FB\u792C\u7D46\u822C\u87E0\u8FD4\u9812\u98EF\u52C3\u62D4\u64A5\u6E24\u6F51"
    ],
    [
        "dba1",
        "\u767C\u8DCB\u91B1\u9262\u9AEE\u9B43\u5023\u508D\u574A\u59A8\u5C28\u5E47\u5F77\u623F\u653E\u65B9\u65C1\u6609\u678B\u699C\u6EC2\u78C5\u7D21\u80AA\u8180\u822B\u82B3\u84A1\u868C\u8A2A\u8B17\u90A6\u9632\u9F90\u500D\u4FF3\uF963\u57F9\u5F98\u62DC\u6392\u676F\u6E43\u7119\u76C3\u80CC\u80DA\u88F4\u88F5\u8919\u8CE0\u8F29\u914D\u966A\u4F2F\u4F70\u5E1B\u67CF\u6822\u767D\u767E\u9B44\u5E61\u6A0A\u7169\u71D4\u756A\uF964\u7E41\u8543\u85E9\u98DC\u4F10\u7B4F\u7F70\u95A5\u51E1\u5E06\u68B5\u6C3E\u6C4E\u6CDB\u72AF\u7BC4\u8303\u6CD5\u743A\u50FB\u5288\u58C1\u64D8\u6A97\u74A7\u7656"
    ],
    [
        "dca1",
        "\u78A7\u8617\u95E2\u9739\uF965\u535E\u5F01\u8B8A\u8FA8\u8FAF\u908A\u5225\u77A5\u9C49\u9F08\u4E19\u5002\u5175\u5C5B\u5E77\u661E\u663A\u67C4\u68C5\u70B3\u7501\u75C5\u79C9\u7ADD\u8F27\u9920\u9A08\u4FDD\u5821\u5831\u5BF6\u666E\u6B65\u6D11\u6E7A\u6F7D\u73E4\u752B\u83E9\u88DC\u8913\u8B5C\u8F14\u4F0F\u50D5\u5310\u535C\u5B93\u5FA9\u670D\u798F\u8179\u832F\u8514\u8907\u8986\u8F39\u8F3B\u99A5\u9C12\u672C\u4E76\u4FF8\u5949\u5C01\u5CEF\u5CF0\u6367\u68D2\u70FD\u71A2\u742B\u7E2B\u84EC\u8702\u9022\u92D2\u9CF3\u4E0D\u4ED8\u4FEF\u5085\u5256\u526F\u5426\u5490\u57E0\u592B\u5A66"
    ],
    [
        "dda1",
        "\u5B5A\u5B75\u5BCC\u5E9C\uF966\u6276\u6577\u65A7\u6D6E\u6EA5\u7236\u7B26\u7C3F\u7F36\u8150\u8151\u819A\u8240\u8299\u83A9\u8A03\u8CA0\u8CE6\u8CFB\u8D74\u8DBA\u90E8\u91DC\u961C\u9644\u99D9\u9CE7\u5317\u5206\u5429\u5674\u58B3\u5954\u596E\u5FFF\u61A4\u626E\u6610\u6C7E\u711A\u76C6\u7C89\u7CDE\u7D1B\u82AC\u8CC1\u96F0\uF967\u4F5B\u5F17\u5F7F\u62C2\u5D29\u670B\u68DA\u787C\u7E43\u9D6C\u4E15\u5099\u5315\u532A\u5351\u5983\u5A62\u5E87\u60B2\u618A\u6249\u6279\u6590\u6787\u69A7\u6BD4\u6BD6\u6BD7\u6BD8\u6CB8\uF968\u7435\u75FA\u7812\u7891\u79D5\u79D8\u7C83\u7DCB\u7FE1\u80A5"
    ],
    [
        "dea1",
        "\u813E\u81C2\u83F2\u871A\u88E8\u8AB9\u8B6C\u8CBB\u9119\u975E\u98DB\u9F3B\u56AC\u5B2A\u5F6C\u658C\u6AB3\u6BAF\u6D5C\u6FF1\u7015\u725D\u73AD\u8CA7\u8CD3\u983B\u6191\u6C37\u8058\u9A01\u4E4D\u4E8B\u4E9B\u4ED5\u4F3A\u4F3C\u4F7F\u4FDF\u50FF\u53F2\u53F8\u5506\u55E3\u56DB\u58EB\u5962\u5A11\u5BEB\u5BFA\u5C04\u5DF3\u5E2B\u5F99\u601D\u6368\u659C\u65AF\u67F6\u67FB\u68AD\u6B7B\u6C99\u6CD7\u6E23\u7009\u7345\u7802\u793E\u7940\u7960\u79C1\u7BE9\u7D17\u7D72\u8086\u820D\u838E\u84D1\u86C7\u88DF\u8A50\u8A5E\u8B1D\u8CDC\u8D66\u8FAD\u90AA\u98FC\u99DF\u9E9D\u524A\uF969\u6714\uF96A"
    ],
    [
        "dfa1",
        "\u5098\u522A\u5C71\u6563\u6C55\u73CA\u7523\u759D\u7B97\u849C\u9178\u9730\u4E77\u6492\u6BBA\u715E\u85A9\u4E09\uF96B\u6749\u68EE\u6E17\u829F\u8518\u886B\u63F7\u6F81\u9212\u98AF\u4E0A\u50B7\u50CF\u511F\u5546\u55AA\u5617\u5B40\u5C19\u5CE0\u5E38\u5E8A\u5EA0\u5EC2\u60F3\u6851\u6A61\u6E58\u723D\u7240\u72C0\u76F8\u7965\u7BB1\u7FD4\u88F3\u89F4\u8A73\u8C61\u8CDE\u971C\u585E\u74BD\u8CFD\u55C7\uF96C\u7A61\u7D22\u8272\u7272\u751F\u7525\uF96D\u7B19\u5885\u58FB\u5DBC\u5E8F\u5EB6\u5F90\u6055\u6292\u637F\u654D\u6691\u66D9\u66F8\u6816\u68F2\u7280\u745E\u7B6E\u7D6E\u7DD6\u7F72"
    ],
    [
        "e0a1",
        "\u80E5\u8212\u85AF\u897F\u8A93\u901D\u92E4\u9ECD\u9F20\u5915\u596D\u5E2D\u60DC\u6614\u6673\u6790\u6C50\u6DC5\u6F5F\u77F3\u78A9\u84C6\u91CB\u932B\u4ED9\u50CA\u5148\u5584\u5B0B\u5BA3\u6247\u657E\u65CB\u6E32\u717D\u7401\u7444\u7487\u74BF\u766C\u79AA\u7DDA\u7E55\u7FA8\u817A\u81B3\u8239\u861A\u87EC\u8A75\u8DE3\u9078\u9291\u9425\u994D\u9BAE\u5368\u5C51\u6954\u6CC4\u6D29\u6E2B\u820C\u859B\u893B\u8A2D\u8AAA\u96EA\u9F67\u5261\u66B9\u6BB2\u7E96\u87FE\u8D0D\u9583\u965D\u651D\u6D89\u71EE\uF96E\u57CE\u59D3\u5BAC\u6027\u60FA\u6210\u661F\u665F\u7329\u73F9\u76DB\u7701\u7B6C"
    ],
    [
        "e1a1",
        "\u8056\u8072\u8165\u8AA0\u9192\u4E16\u52E2\u6B72\u6D17\u7A05\u7B39\u7D30\uF96F\u8CB0\u53EC\u562F\u5851\u5BB5\u5C0F\u5C11\u5DE2\u6240\u6383\u6414\u662D\u68B3\u6CBC\u6D88\u6EAF\u701F\u70A4\u71D2\u7526\u758F\u758E\u7619\u7B11\u7BE0\u7C2B\u7D20\u7D39\u852C\u856D\u8607\u8A34\u900D\u9061\u90B5\u92B7\u97F6\u9A37\u4FD7\u5C6C\u675F\u6D91\u7C9F\u7E8C\u8B16\u8D16\u901F\u5B6B\u5DFD\u640D\u84C0\u905C\u98E1\u7387\u5B8B\u609A\u677E\u6DDE\u8A1F\u8AA6\u9001\u980C\u5237\uF970\u7051\u788E\u9396\u8870\u91D7\u4FEE\u53D7\u55FD\u56DA\u5782\u58FD\u5AC2\u5B88\u5CAB\u5CC0\u5E25\u6101"
    ],
    [
        "e2a1",
        "\u620D\u624B\u6388\u641C\u6536\u6578\u6A39\u6B8A\u6C34\u6D19\u6F31\u71E7\u72E9\u7378\u7407\u74B2\u7626\u7761\u79C0\u7A57\u7AEA\u7CB9\u7D8F\u7DAC\u7E61\u7F9E\u8129\u8331\u8490\u84DA\u85EA\u8896\u8AB0\u8B90\u8F38\u9042\u9083\u916C\u9296\u92B9\u968B\u96A7\u96A8\u96D6\u9700\u9808\u9996\u9AD3\u9B1A\u53D4\u587E\u5919\u5B70\u5BBF\u6DD1\u6F5A\u719F\u7421\u74B9\u8085\u83FD\u5DE1\u5F87\u5FAA\u6042\u65EC\u6812\u696F\u6A53\u6B89\u6D35\u6DF3\u73E3\u76FE\u77AC\u7B4D\u7D14\u8123\u821C\u8340\u84F4\u8563\u8A62\u8AC4\u9187\u931E\u9806\u99B4\u620C\u8853\u8FF0\u9265\u5D07\u5D27"
    ],
    [
        "e3a1",
        "\u5D69\u745F\u819D\u8768\u6FD5\u62FE\u7FD2\u8936\u8972\u4E1E\u4E58\u50E7\u52DD\u5347\u627F\u6607\u7E69\u8805\u965E\u4F8D\u5319\u5636\u59CB\u5AA4\u5C38\u5C4E\u5C4D\u5E02\u5F11\u6043\u65BD\u662F\u6642\u67BE\u67F4\u731C\u77E2\u793A\u7FC5\u8494\u84CD\u8996\u8A66\u8A69\u8AE1\u8C55\u8C7A\u57F4\u5BD4\u5F0F\u606F\u62ED\u690D\u6B96\u6E5C\u7184\u7BD2\u8755\u8B58\u8EFE\u98DF\u98FE\u4F38\u4F81\u4FE1\u547B\u5A20\u5BB8\u613C\u65B0\u6668\u71FC\u7533\u795E\u7D33\u814E\u81E3\u8398\u85AA\u85CE\u8703\u8A0A\u8EAB\u8F9B\uF971\u8FC5\u5931\u5BA4\u5BE6\u6089\u5BE9\u5C0B\u5FC3\u6C81"
    ],
    [
        "e4a1",
        "\uF972\u6DF1\u700B\u751A\u82AF\u8AF6\u4EC0\u5341\uF973\u96D9\u6C0F\u4E9E\u4FC4\u5152\u555E\u5A25\u5CE8\u6211\u7259\u82BD\u83AA\u86FE\u8859\u8A1D\u963F\u96C5\u9913\u9D09\u9D5D\u580A\u5CB3\u5DBD\u5E44\u60E1\u6115\u63E1\u6A02\u6E25\u9102\u9354\u984E\u9C10\u9F77\u5B89\u5CB8\u6309\u664F\u6848\u773C\u96C1\u978D\u9854\u9B9F\u65A1\u8B01\u8ECB\u95BC\u5535\u5CA9\u5DD6\u5EB5\u6697\u764C\u83F4\u95C7\u58D3\u62BC\u72CE\u9D28\u4EF0\u592E\u600F\u663B\u6B83\u79E7\u9D26\u5393\u54C0\u57C3\u5D16\u611B\u66D6\u6DAF\u788D\u827E\u9698\u9744\u5384\u627C\u6396\u6DB2\u7E0A\u814B\u984D"
    ],
    [
        "e5a1",
        "\u6AFB\u7F4C\u9DAF\u9E1A\u4E5F\u503B\u51B6\u591C\u60F9\u63F6\u6930\u723A\u8036\uF974\u91CE\u5F31\uF975\uF976\u7D04\u82E5\u846F\u84BB\u85E5\u8E8D\uF977\u4F6F\uF978\uF979\u58E4\u5B43\u6059\u63DA\u6518\u656D\u6698\uF97A\u694A\u6A23\u6D0B\u7001\u716C\u75D2\u760D\u79B3\u7A70\uF97B\u7F8A\uF97C\u8944\uF97D\u8B93\u91C0\u967D\uF97E\u990A\u5704\u5FA1\u65BC\u6F01\u7600\u79A6\u8A9E\u99AD\u9B5A\u9F6C\u5104\u61B6\u6291\u6A8D\u81C6\u5043\u5830\u5F66\u7109\u8A00\u8AFA\u5B7C\u8616\u4FFA\u513C\u56B4\u5944\u63A9\u6DF9\u5DAA\u696D\u5186\u4E88\u4F59\uF97F\uF980\uF981\u5982\uF982"
    ],
    [
        "e6a1",
        "\uF983\u6B5F\u6C5D\uF984\u74B5\u7916\uF985\u8207\u8245\u8339\u8F3F\u8F5D\uF986\u9918\uF987\uF988\uF989\u4EA6\uF98A\u57DF\u5F79\u6613\uF98B\uF98C\u75AB\u7E79\u8B6F\uF98D\u9006\u9A5B\u56A5\u5827\u59F8\u5A1F\u5BB4\uF98E\u5EF6\uF98F\uF990\u6350\u633B\uF991\u693D\u6C87\u6CBF\u6D8E\u6D93\u6DF5\u6F14\uF992\u70DF\u7136\u7159\uF993\u71C3\u71D5\uF994\u784F\u786F\uF995\u7B75\u7DE3\uF996\u7E2F\uF997\u884D\u8EDF\uF998\uF999\uF99A\u925B\uF99B\u9CF6\uF99C\uF99D\uF99E\u6085\u6D85\uF99F\u71B1\uF9A0\uF9A1\u95B1\u53AD\uF9A2\uF9A3\uF9A4\u67D3\uF9A5\u708E\u7130\u7430\u8276\u82D2"
    ],
    [
        "e7a1",
        "\uF9A6\u95BB\u9AE5\u9E7D\u66C4\uF9A7\u71C1\u8449\uF9A8\uF9A9\u584B\uF9AA\uF9AB\u5DB8\u5F71\uF9AC\u6620\u668E\u6979\u69AE\u6C38\u6CF3\u6E36\u6F41\u6FDA\u701B\u702F\u7150\u71DF\u7370\uF9AD\u745B\uF9AE\u74D4\u76C8\u7A4E\u7E93\uF9AF\uF9B0\u82F1\u8A60\u8FCE\uF9B1\u9348\uF9B2\u9719\uF9B3\uF9B4\u4E42\u502A\uF9B5\u5208\u53E1\u66F3\u6C6D\u6FCA\u730A\u777F\u7A62\u82AE\u85DD\u8602\uF9B6\u88D4\u8A63\u8B7D\u8C6B\uF9B7\u92B3\uF9B8\u9713\u9810\u4E94\u4F0D\u4FC9\u50B2\u5348\u543E\u5433\u55DA\u5862\u58BA\u5967\u5A1B\u5BE4\u609F\uF9B9\u61CA\u6556\u65FF\u6664\u68A7\u6C5A\u6FB3"
    ],
    [
        "e8a1",
        "\u70CF\u71AC\u7352\u7B7D\u8708\u8AA4\u9C32\u9F07\u5C4B\u6C83\u7344\u7389\u923A\u6EAB\u7465\u761F\u7A69\u7E15\u860A\u5140\u58C5\u64C1\u74EE\u7515\u7670\u7FC1\u9095\u96CD\u9954\u6E26\u74E6\u7AA9\u7AAA\u81E5\u86D9\u8778\u8A1B\u5A49\u5B8C\u5B9B\u68A1\u6900\u6D63\u73A9\u7413\u742C\u7897\u7DE9\u7FEB\u8118\u8155\u839E\u8C4C\u962E\u9811\u66F0\u5F80\u65FA\u6789\u6C6A\u738B\u502D\u5A03\u6B6A\u77EE\u5916\u5D6C\u5DCD\u7325\u754F\uF9BA\uF9BB\u50E5\u51F9\u582F\u592D\u5996\u59DA\u5BE5\uF9BC\uF9BD\u5DA2\u62D7\u6416\u6493\u64FE\uF9BE\u66DC\uF9BF\u6A48\uF9C0\u71FF\u7464\uF9C1"
    ],
    [
        "e9a1",
        "\u7A88\u7AAF\u7E47\u7E5E\u8000\u8170\uF9C2\u87EF\u8981\u8B20\u9059\uF9C3\u9080\u9952\u617E\u6B32\u6D74\u7E1F\u8925\u8FB1\u4FD1\u50AD\u5197\u52C7\u57C7\u5889\u5BB9\u5EB8\u6142\u6995\u6D8C\u6E67\u6EB6\u7194\u7462\u7528\u752C\u8073\u8338\u84C9\u8E0A\u9394\u93DE\uF9C4\u4E8E\u4F51\u5076\u512A\u53C8\u53CB\u53F3\u5B87\u5BD3\u5C24\u611A\u6182\u65F4\u725B\u7397\u7440\u76C2\u7950\u7991\u79B9\u7D06\u7FBD\u828B\u85D5\u865E\u8FC2\u9047\u90F5\u91EA\u9685\u96E8\u96E9\u52D6\u5F67\u65ED\u6631\u682F\u715C\u7A36\u90C1\u980A\u4E91\uF9C5\u6A52\u6B9E\u6F90\u7189\u8018\u82B8\u8553"
    ],
    [
        "eaa1",
        "\u904B\u9695\u96F2\u97FB\u851A\u9B31\u4E90\u718A\u96C4\u5143\u539F\u54E1\u5713\u5712\u57A3\u5A9B\u5AC4\u5BC3\u6028\u613F\u63F4\u6C85\u6D39\u6E72\u6E90\u7230\u733F\u7457\u82D1\u8881\u8F45\u9060\uF9C6\u9662\u9858\u9D1B\u6708\u8D8A\u925E\u4F4D\u5049\u50DE\u5371\u570D\u59D4\u5A01\u5C09\u6170\u6690\u6E2D\u7232\u744B\u7DEF\u80C3\u840E\u8466\u853F\u875F\u885B\u8918\u8B02\u9055\u97CB\u9B4F\u4E73\u4F91\u5112\u516A\uF9C7\u552F\u55A9\u5B7A\u5BA5\u5E7C\u5E7D\u5EBE\u60A0\u60DF\u6108\u6109\u63C4\u6538\u6709\uF9C8\u67D4\u67DA\uF9C9\u6961\u6962\u6CB9\u6D27\uF9CA\u6E38\uF9CB"
    ],
    [
        "eba1",
        "\u6FE1\u7336\u7337\uF9CC\u745C\u7531\uF9CD\u7652\uF9CE\uF9CF\u7DAD\u81FE\u8438\u88D5\u8A98\u8ADB\u8AED\u8E30\u8E42\u904A\u903E\u907A\u9149\u91C9\u936E\uF9D0\uF9D1\u5809\uF9D2\u6BD3\u8089\u80B2\uF9D3\uF9D4\u5141\u596B\u5C39\uF9D5\uF9D6\u6F64\u73A7\u80E4\u8D07\uF9D7\u9217\u958F\uF9D8\uF9D9\uF9DA\uF9DB\u807F\u620E\u701C\u7D68\u878D\uF9DC\u57A0\u6069\u6147\u6BB7\u8ABE\u9280\u96B1\u4E59\u541F\u6DEB\u852D\u9670\u97F3\u98EE\u63D6\u6CE3\u9091\u51DD\u61C9\u81BA\u9DF9\u4F9D\u501A\u5100\u5B9C\u610F\u61FF\u64EC\u6905\u6BC5\u7591\u77E3\u7FA9\u8264\u858F\u87FB\u8863\u8ABC"
    ],
    [
        "eca1",
        "\u8B70\u91AB\u4E8C\u4EE5\u4F0A\uF9DD\uF9DE\u5937\u59E8\uF9DF\u5DF2\u5F1B\u5F5B\u6021\uF9E0\uF9E1\uF9E2\uF9E3\u723E\u73E5\uF9E4\u7570\u75CD\uF9E5\u79FB\uF9E6\u800C\u8033\u8084\u82E1\u8351\uF9E7\uF9E8\u8CBD\u8CB3\u9087\uF9E9\uF9EA\u98F4\u990C\uF9EB\uF9EC\u7037\u76CA\u7FCA\u7FCC\u7FFC\u8B1A\u4EBA\u4EC1\u5203\u5370\uF9ED\u54BD\u56E0\u59FB\u5BC5\u5F15\u5FCD\u6E6E\uF9EE\uF9EF\u7D6A\u8335\uF9F0\u8693\u8A8D\uF9F1\u976D\u9777\uF9F2\uF9F3\u4E00\u4F5A\u4F7E\u58F9\u65E5\u6EA2\u9038\u93B0\u99B9\u4EFB\u58EC\u598A\u59D9\u6041\uF9F4\uF9F5\u7A14\uF9F6\u834F\u8CC3\u5165\u5344"
    ],
    [
        "eda1",
        "\uF9F7\uF9F8\uF9F9\u4ECD\u5269\u5B55\u82BF\u4ED4\u523A\u54A8\u59C9\u59FF\u5B50\u5B57\u5B5C\u6063\u6148\u6ECB\u7099\u716E\u7386\u74F7\u75B5\u78C1\u7D2B\u8005\u81EA\u8328\u8517\u85C9\u8AEE\u8CC7\u96CC\u4F5C\u52FA\u56BC\u65AB\u6628\u707C\u70B8\u7235\u7DBD\u828D\u914C\u96C0\u9D72\u5B71\u68E7\u6B98\u6F7A\u76DE\u5C91\u66AB\u6F5B\u7BB4\u7C2A\u8836\u96DC\u4E08\u4ED7\u5320\u5834\u58BB\u58EF\u596C\u5C07\u5E33\u5E84\u5F35\u638C\u66B2\u6756\u6A1F\u6AA3\u6B0C\u6F3F\u7246\uF9FA\u7350\u748B\u7AE0\u7CA7\u8178\u81DF\u81E7\u838A\u846C\u8523\u8594\u85CF\u88DD\u8D13\u91AC\u9577"
    ],
    [
        "eea1",
        "\u969C\u518D\u54C9\u5728\u5BB0\u624D\u6750\u683D\u6893\u6E3D\u6ED3\u707D\u7E21\u88C1\u8CA1\u8F09\u9F4B\u9F4E\u722D\u7B8F\u8ACD\u931A\u4F47\u4F4E\u5132\u5480\u59D0\u5E95\u62B5\u6775\u696E\u6A17\u6CAE\u6E1A\u72D9\u732A\u75BD\u7BB8\u7D35\u82E7\u83F9\u8457\u85F7\u8A5B\u8CAF\u8E87\u9019\u90B8\u96CE\u9F5F\u52E3\u540A\u5AE1\u5BC2\u6458\u6575\u6EF4\u72C4\uF9FB\u7684\u7A4D\u7B1B\u7C4D\u7E3E\u7FDF\u837B\u8B2B\u8CCA\u8D64\u8DE1\u8E5F\u8FEA\u8FF9\u9069\u93D1\u4F43\u4F7A\u50B3\u5168\u5178\u524D\u526A\u5861\u587C\u5960\u5C08\u5C55\u5EDB\u609B\u6230\u6813\u6BBF\u6C08\u6FB1"
    ],
    [
        "efa1",
        "\u714E\u7420\u7530\u7538\u7551\u7672\u7B4C\u7B8B\u7BAD\u7BC6\u7E8F\u8A6E\u8F3E\u8F49\u923F\u9293\u9322\u942B\u96FB\u985A\u986B\u991E\u5207\u622A\u6298\u6D59\u7664\u7ACA\u7BC0\u7D76\u5360\u5CBE\u5E97\u6F38\u70B9\u7C98\u9711\u9B8E\u9EDE\u63A5\u647A\u8776\u4E01\u4E95\u4EAD\u505C\u5075\u5448\u59C3\u5B9A\u5E40\u5EAD\u5EF7\u5F81\u60C5\u633A\u653F\u6574\u65CC\u6676\u6678\u67FE\u6968\u6A89\u6B63\u6C40\u6DC0\u6DE8\u6E1F\u6E5E\u701E\u70A1\u738E\u73FD\u753A\u775B\u7887\u798E\u7A0B\u7A7D\u7CBE\u7D8E\u8247\u8A02\u8AEA\u8C9E\u912D\u914A\u91D8\u9266\u92CC\u9320\u9706\u9756"
    ],
    [
        "f0a1",
        "\u975C\u9802\u9F0E\u5236\u5291\u557C\u5824\u5E1D\u5F1F\u608C\u63D0\u68AF\u6FDF\u796D\u7B2C\u81CD\u85BA\u88FD\u8AF8\u8E44\u918D\u9664\u969B\u973D\u984C\u9F4A\u4FCE\u5146\u51CB\u52A9\u5632\u5F14\u5F6B\u63AA\u64CD\u65E9\u6641\u66FA\u66F9\u671D\u689D\u68D7\u69FD\u6F15\u6F6E\u7167\u71E5\u722A\u74AA\u773A\u7956\u795A\u79DF\u7A20\u7A95\u7C97\u7CDF\u7D44\u7E70\u8087\u85FB\u86A4\u8A54\u8ABF\u8D99\u8E81\u9020\u906D\u91E3\u963B\u96D5\u9CE5\u65CF\u7C07\u8DB3\u93C3\u5B58\u5C0A\u5352\u62D9\u731D\u5027\u5B97\u5F9E\u60B0\u616B\u68D5\u6DD9\u742E\u7A2E\u7D42\u7D9C\u7E31\u816B"
    ],
    [
        "f1a1",
        "\u8E2A\u8E35\u937E\u9418\u4F50\u5750\u5DE6\u5EA7\u632B\u7F6A\u4E3B\u4F4F\u4F8F\u505A\u59DD\u80C4\u546A\u5468\u55FE\u594F\u5B99\u5DDE\u5EDA\u665D\u6731\u67F1\u682A\u6CE8\u6D32\u6E4A\u6F8D\u70B7\u73E0\u7587\u7C4C\u7D02\u7D2C\u7DA2\u821F\u86DB\u8A3B\u8A85\u8D70\u8E8A\u8F33\u9031\u914E\u9152\u9444\u99D0\u7AF9\u7CA5\u4FCA\u5101\u51C6\u57C8\u5BEF\u5CFB\u6659\u6A3D\u6D5A\u6E96\u6FEC\u710C\u756F\u7AE3\u8822\u9021\u9075\u96CB\u99FF\u8301\u4E2D\u4EF2\u8846\u91CD\u537D\u6ADB\u696B\u6C41\u847A\u589E\u618E\u66FE\u62EF\u70DD\u7511\u75C7\u7E52\u84B8\u8B49\u8D08\u4E4B\u53EA"
    ],
    [
        "f2a1",
        "\u54AB\u5730\u5740\u5FD7\u6301\u6307\u646F\u652F\u65E8\u667A\u679D\u67B3\u6B62\u6C60\u6C9A\u6F2C\u77E5\u7825\u7949\u7957\u7D19\u80A2\u8102\u81F3\u829D\u82B7\u8718\u8A8C\uF9FC\u8D04\u8DBE\u9072\u76F4\u7A19\u7A37\u7E54\u8077\u5507\u55D4\u5875\u632F\u6422\u6649\u664B\u686D\u699B\u6B84\u6D25\u6EB1\u73CD\u7468\u74A1\u755B\u75B9\u76E1\u771E\u778B\u79E6\u7E09\u7E1D\u81FB\u852F\u8897\u8A3A\u8CD1\u8EEB\u8FB0\u9032\u93AD\u9663\u9673\u9707\u4F84\u53F1\u59EA\u5AC9\u5E19\u684E\u74C6\u75BE\u79E9\u7A92\u81A3\u86ED\u8CEA\u8DCC\u8FED\u659F\u6715\uF9FD\u57F7\u6F57\u7DDD\u8F2F"
    ],
    [
        "f3a1",
        "\u93F6\u96C6\u5FB5\u61F2\u6F84\u4E14\u4F98\u501F\u53C9\u55DF\u5D6F\u5DEE\u6B21\u6B64\u78CB\u7B9A\uF9FE\u8E49\u8ECA\u906E\u6349\u643E\u7740\u7A84\u932F\u947F\u9F6A\u64B0\u6FAF\u71E6\u74A8\u74DA\u7AC4\u7C12\u7E82\u7CB2\u7E98\u8B9A\u8D0A\u947D\u9910\u994C\u5239\u5BDF\u64E6\u672D\u7D2E\u50ED\u53C3\u5879\u6158\u6159\u61FA\u65AC\u7AD9\u8B92\u8B96\u5009\u5021\u5275\u5531\u5A3C\u5EE0\u5F70\u6134\u655E\u660C\u6636\u66A2\u69CD\u6EC4\u6F32\u7316\u7621\u7A93\u8139\u8259\u83D6\u84BC\u50B5\u57F0\u5BC0\u5BE8\u5F69\u63A1\u7826\u7DB5\u83DC\u8521\u91C7\u91F5\u518A\u67F5\u7B56"
    ],
    [
        "f4a1",
        "\u8CAC\u51C4\u59BB\u60BD\u8655\u501C\uF9FF\u5254\u5C3A\u617D\u621A\u62D3\u64F2\u65A5\u6ECC\u7620\u810A\u8E60\u965F\u96BB\u4EDF\u5343\u5598\u5929\u5DDD\u64C5\u6CC9\u6DFA\u7394\u7A7F\u821B\u85A6\u8CE4\u8E10\u9077\u91E7\u95E1\u9621\u97C6\u51F8\u54F2\u5586\u5FB9\u64A4\u6F88\u7DB4\u8F1F\u8F4D\u9435\u50C9\u5C16\u6CBE\u6DFB\u751B\u77BB\u7C3D\u7C64\u8A79\u8AC2\u581E\u59BE\u5E16\u6377\u7252\u758A\u776B\u8ADC\u8CBC\u8F12\u5EF3\u6674\u6DF8\u807D\u83C1\u8ACB\u9751\u9BD6\uFA00\u5243\u66FF\u6D95\u6EEF\u7DE0\u8AE6\u902E\u905E\u9AD4\u521D\u527F\u54E8\u6194\u6284\u62DB\u68A2"
    ],
    [
        "f5a1",
        "\u6912\u695A\u6A35\u7092\u7126\u785D\u7901\u790E\u79D2\u7A0D\u8096\u8278\u82D5\u8349\u8549\u8C82\u8D85\u9162\u918B\u91AE\u4FC3\u56D1\u71ED\u77D7\u8700\u89F8\u5BF8\u5FD6\u6751\u90A8\u53E2\u585A\u5BF5\u60A4\u6181\u6460\u7E3D\u8070\u8525\u9283\u64AE\u50AC\u5D14\u6700\u589C\u62BD\u63A8\u690E\u6978\u6A1E\u6E6B\u76BA\u79CB\u82BB\u8429\u8ACF\u8DA8\u8FFD\u9112\u914B\u919C\u9310\u9318\u939A\u96DB\u9A36\u9C0D\u4E11\u755C\u795D\u7AFA\u7B51\u7BC9\u7E2E\u84C4\u8E59\u8E74\u8EF8\u9010\u6625\u693F\u7443\u51FA\u672E\u9EDC\u5145\u5FE0\u6C96\u87F2\u885D\u8877\u60B4\u81B5\u8403"
    ],
    [
        "f6a1",
        "\u8D05\u53D6\u5439\u5634\u5A36\u5C31\u708A\u7FE0\u805A\u8106\u81ED\u8DA3\u9189\u9A5F\u9DF2\u5074\u4EC4\u53A0\u60FB\u6E2C\u5C64\u4F88\u5024\u55E4\u5CD9\u5E5F\u6065\u6894\u6CBB\u6DC4\u71BE\u75D4\u75F4\u7661\u7A1A\u7A49\u7DC7\u7DFB\u7F6E\u81F4\u86A9\u8F1C\u96C9\u99B3\u9F52\u5247\u52C5\u98ED\u89AA\u4E03\u67D2\u6F06\u4FB5\u5BE2\u6795\u6C88\u6D78\u741B\u7827\u91DD\u937C\u87C4\u79E4\u7A31\u5FEB\u4ED6\u54A4\u553E\u58AE\u59A5\u60F0\u6253\u62D6\u6736\u6955\u8235\u9640\u99B1\u99DD\u502C\u5353\u5544\u577C\uFA01\u6258\uFA02\u64E2\u666B\u67DD\u6FC1\u6FEF\u7422\u7438\u8A17"
    ],
    [
        "f7a1",
        "\u9438\u5451\u5606\u5766\u5F48\u619A\u6B4E\u7058\u70AD\u7DBB\u8A95\u596A\u812B\u63A2\u7708\u803D\u8CAA\u5854\u642D\u69BB\u5B95\u5E11\u6E6F\uFA03\u8569\u514C\u53F0\u592A\u6020\u614B\u6B86\u6C70\u6CF0\u7B1E\u80CE\u82D4\u8DC6\u90B0\u98B1\uFA04\u64C7\u6FA4\u6491\u6504\u514E\u5410\u571F\u8A0E\u615F\u6876\uFA05\u75DB\u7B52\u7D71\u901A\u5806\u69CC\u817F\u892A\u9000\u9839\u5078\u5957\u59AC\u6295\u900F\u9B2A\u615D\u7279\u95D6\u5761\u5A46\u5DF4\u628A\u64AD\u64FA\u6777\u6CE2\u6D3E\u722C\u7436\u7834\u7F77\u82AD\u8DDB\u9817\u5224\u5742\u677F\u7248\u74E3\u8CA9\u8FA6\u9211"
    ],
    [
        "f8a1",
        "\u962A\u516B\u53ED\u634C\u4F69\u5504\u6096\u6557\u6C9B\u6D7F\u724C\u72FD\u7A17\u8987\u8C9D\u5F6D\u6F8E\u70F9\u81A8\u610E\u4FBF\u504F\u6241\u7247\u7BC7\u7DE8\u7FE9\u904D\u97AD\u9A19\u8CB6\u576A\u5E73\u67B0\u840D\u8A55\u5420\u5B16\u5E63\u5EE2\u5F0A\u6583\u80BA\u853D\u9589\u965B\u4F48\u5305\u530D\u530F\u5486\u54FA\u5703\u5E03\u6016\u629B\u62B1\u6355\uFA06\u6CE1\u6D66\u75B1\u7832\u80DE\u812F\u82DE\u8461\u84B2\u888D\u8912\u900B\u92EA\u98FD\u9B91\u5E45\u66B4\u66DD\u7011\u7206\uFA07\u4FF5\u527D\u5F6A\u6153\u6753\u6A19\u6F02\u74E2\u7968\u8868\u8C79\u98C7\u98C4\u9A43"
    ],
    [
        "f9a1",
        "\u54C1\u7A1F\u6953\u8AF7\u8C4A\u98A8\u99AE\u5F7C\u62AB\u75B2\u76AE\u88AB\u907F\u9642\u5339\u5F3C\u5FC5\u6CCC\u73CC\u7562\u758B\u7B46\u82FE\u999D\u4E4F\u903C\u4E0B\u4F55\u53A6\u590F\u5EC8\u6630\u6CB3\u7455\u8377\u8766\u8CC0\u9050\u971E\u9C15\u58D1\u5B78\u8650\u8B14\u9DB4\u5BD2\u6068\u608D\u65F1\u6C57\u6F22\u6FA3\u701A\u7F55\u7FF0\u9591\u9592\u9650\u97D3\u5272\u8F44\u51FD\u542B\u54B8\u5563\u558A\u6ABB\u6DB5\u7DD8\u8266\u929C\u9677\u9E79\u5408\u54C8\u76D2\u86E4\u95A4\u95D4\u965C\u4EA2\u4F09\u59EE\u5AE6\u5DF7\u6052\u6297\u676D\u6841\u6C86\u6E2F\u7F38\u809B\u822A"
    ],
    [
        "faa1",
        "\uFA08\uFA09\u9805\u4EA5\u5055\u54B3\u5793\u595A\u5B69\u5BB3\u61C8\u6977\u6D77\u7023\u87F9\u89E3\u8A72\u8AE7\u9082\u99ED\u9AB8\u52BE\u6838\u5016\u5E78\u674F\u8347\u884C\u4EAB\u5411\u56AE\u73E6\u9115\u97FF\u9909\u9957\u9999\u5653\u589F\u865B\u8A31\u61B2\u6AF6\u737B\u8ED2\u6B47\u96AA\u9A57\u5955\u7200\u8D6B\u9769\u4FD4\u5CF4\u5F26\u61F8\u665B\u6CEB\u70AB\u7384\u73B9\u73FE\u7729\u774D\u7D43\u7D62\u7E23\u8237\u8852\uFA0A\u8CE2\u9249\u986F\u5B51\u7A74\u8840\u9801\u5ACC\u4FE0\u5354\u593E\u5CFD\u633E\u6D79\u72F9\u8105\u8107\u83A2\u92CF\u9830\u4EA8\u5144\u5211\u578B"
    ],
    [
        "fba1",
        "\u5F62\u6CC2\u6ECE\u7005\u7050\u70AF\u7192\u73E9\u7469\u834A\u87A2\u8861\u9008\u90A2\u93A3\u99A8\u516E\u5F57\u60E0\u6167\u66B3\u8559\u8E4A\u91AF\u978B\u4E4E\u4E92\u547C\u58D5\u58FA\u597D\u5CB5\u5F27\u6236\u6248\u660A\u6667\u6BEB\u6D69\u6DCF\u6E56\u6EF8\u6F94\u6FE0\u6FE9\u705D\u72D0\u7425\u745A\u74E0\u7693\u795C\u7CCA\u7E1E\u80E1\u82A6\u846B\u84BF\u864E\u865F\u8774\u8B77\u8C6A\u93AC\u9800\u9865\u60D1\u6216\u9177\u5A5A\u660F\u6DF7\u6E3E\u743F\u9B42\u5FFD\u60DA\u7B0F\u54C4\u5F18\u6C5E\u6CD3\u6D2A\u70D8\u7D05\u8679\u8A0C\u9D3B\u5316\u548C\u5B05\u6A3A\u706B\u7575"
    ],
    [
        "fca1",
        "\u798D\u79BE\u82B1\u83EF\u8A71\u8B41\u8CA8\u9774\uFA0B\u64F4\u652B\u78BA\u78BB\u7A6B\u4E38\u559A\u5950\u5BA6\u5E7B\u60A3\u63DB\u6B61\u6665\u6853\u6E19\u7165\u74B0\u7D08\u9084\u9A69\u9C25\u6D3B\u6ED1\u733E\u8C41\u95CA\u51F0\u5E4C\u5FA8\u604D\u60F6\u6130\u614C\u6643\u6644\u69A5\u6CC1\u6E5F\u6EC9\u6F62\u714C\u749C\u7687\u7BC1\u7C27\u8352\u8757\u9051\u968D\u9EC3\u532F\u56DE\u5EFB\u5F8A\u6062\u6094\u61F7\u6666\u6703\u6A9C\u6DEE\u6FAE\u7070\u736A\u7E6A\u81BE\u8334\u86D4\u8AA8\u8CC4\u5283\u7372\u5B96\u6A6B\u9404\u54EE\u5686\u5B5D\u6548\u6585\u66C9\u689F\u6D8D\u6DC6"
    ],
    [
        "fda1",
        "\u723B\u80B4\u9175\u9A4D\u4FAF\u5019\u539A\u540E\u543C\u5589\u55C5\u5E3F\u5F8C\u673D\u7166\u73DD\u9005\u52DB\u52F3\u5864\u58CE\u7104\u718F\u71FB\u85B0\u8A13\u6688\u85A8\u55A7\u6684\u714A\u8431\u5349\u5599\u6BC1\u5F59\u5FBD\u63EE\u6689\u7147\u8AF1\u8F1D\u9EBE\u4F11\u643A\u70CB\u7566\u8667\u6064\u8B4E\u9DF8\u5147\u51F6\u5308\u6D36\u80F8\u9ED1\u6615\u6B23\u7098\u75D5\u5403\u5C79\u7D07\u8A16\u6B20\u6B3D\u6B46\u5438\u6070\u6D3D\u7FD5\u8208\u50D6\u51DE\u559C\u566B\u56CD\u59EC\u5B09\u5E0C\u6199\u6198\u6231\u665E\u66E6\u7199\u71B9\u71BA\u72A7\u79A7\u7A00\u7FB2\u8A70"
    ]
];
var $07144aea14354eb9$var$cp949$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$cp949
});
var $07144aea14354eb9$var$cp950 = [
    [
        "0",
        "\u0000",
        127
    ],
    [
        "a140",
        "\u3000\uFF0C\u3001\u3002\uFF0E\u2027\uFF1B\uFF1A\uFF1F\uFF01\uFE30\u2026\u2025\uFE50\uFE51\uFE52\xb7\uFE54\uFE55\uFE56\uFE57\uFF5C\u2013\uFE31\u2014\uFE33\u2574\uFE34\uFE4F\uFF08\uFF09\uFE35\uFE36\uFF5B\uFF5D\uFE37\uFE38\u3014\u3015\uFE39\uFE3A\u3010\u3011\uFE3B\uFE3C\u300A\u300B\uFE3D\uFE3E\u3008\u3009\uFE3F\uFE40\u300C\u300D\uFE41\uFE42\u300E\u300F\uFE43\uFE44\uFE59\uFE5A"
    ],
    [
        "a1a1",
        "\uFE5B\uFE5C\uFE5D\uFE5E\u2018\u2019\u201C\u201D\u301D\u301E\u2035\u2032\uFF03\uFF06\uFF0A\u203B\xa7\u3003\u25CB\u25CF\u25B3\u25B2\u25CE\u2606\u2605\u25C7\u25C6\u25A1\u25A0\u25BD\u25BC\u32A3\u2105\xaf\uFFE3\uFF3F\u02CD\uFE49\uFE4A\uFE4D\uFE4E\uFE4B\uFE4C\uFE5F\uFE60\uFE61\uFF0B\uFF0D\xd7\xf7\xb1\u221A\uFF1C\uFF1E\uFF1D\u2266\u2267\u2260\u221E\u2252\u2261\uFE62",
        4,
        "\uFF5E\u2229\u222A\u22A5\u2220\u221F\u22BF\u33D2\u33D1\u222B\u222E\u2235\u2234\u2640\u2642\u2295\u2299\u2191\u2193\u2190\u2192\u2196\u2197\u2199\u2198\u2225\u2223\uFF0F"
    ],
    [
        "a240",
        "\uFF3C\u2215\uFE68\uFF04\uFFE5\u3012\uFFE0\uFFE1\uFF05\uFF20\u2103\u2109\uFE69\uFE6A\uFE6B\u33D5\u339C\u339D\u339E\u33CE\u33A1\u338E\u338F\u33C4\xb0\u5159\u515B\u515E\u515D\u5161\u5163\u55E7\u74E9\u7CCE\u2581",
        7,
        "\u258F\u258E\u258D\u258C\u258B\u258A\u2589\u253C\u2534\u252C\u2524\u251C\u2594\u2500\u2502\u2595\u250C\u2510\u2514\u2518\u256D"
    ],
    [
        "a2a1",
        "\u256E\u2570\u256F\u2550\u255E\u256A\u2561\u25E2\u25E3\u25E5\u25E4\u2571\u2572\u2573\uFF10",
        9,
        "\u2160",
        9,
        "\u3021",
        8,
        "\u5341\u5344\u5345\uFF21",
        25,
        "\uFF41",
        21
    ],
    [
        "a340",
        "\uFF57\uFF58\uFF59\uFF5A\u0391",
        16,
        "\u03A3",
        6,
        "\u03B1",
        16,
        "\u03C3",
        6,
        "\u3105",
        10
    ],
    [
        "a3a1",
        "\u3110",
        25,
        "\u02D9\u02C9\u02CA\u02C7\u02CB"
    ],
    [
        "a3e1",
        "\u20AC"
    ],
    [
        "a440",
        "\u4E00\u4E59\u4E01\u4E03\u4E43\u4E5D\u4E86\u4E8C\u4EBA\u513F\u5165\u516B\u51E0\u5200\u5201\u529B\u5315\u5341\u535C\u53C8\u4E09\u4E0B\u4E08\u4E0A\u4E2B\u4E38\u51E1\u4E45\u4E48\u4E5F\u4E5E\u4E8E\u4EA1\u5140\u5203\u52FA\u5343\u53C9\u53E3\u571F\u58EB\u5915\u5927\u5973\u5B50\u5B51\u5B53\u5BF8\u5C0F\u5C22\u5C38\u5C71\u5DDD\u5DE5\u5DF1\u5DF2\u5DF3\u5DFE\u5E72\u5EFE\u5F0B\u5F13\u624D"
    ],
    [
        "a4a1",
        "\u4E11\u4E10\u4E0D\u4E2D\u4E30\u4E39\u4E4B\u5C39\u4E88\u4E91\u4E95\u4E92\u4E94\u4EA2\u4EC1\u4EC0\u4EC3\u4EC6\u4EC7\u4ECD\u4ECA\u4ECB\u4EC4\u5143\u5141\u5167\u516D\u516E\u516C\u5197\u51F6\u5206\u5207\u5208\u52FB\u52FE\u52FF\u5316\u5339\u5348\u5347\u5345\u535E\u5384\u53CB\u53CA\u53CD\u58EC\u5929\u592B\u592A\u592D\u5B54\u5C11\u5C24\u5C3A\u5C6F\u5DF4\u5E7B\u5EFF\u5F14\u5F15\u5FC3\u6208\u6236\u624B\u624E\u652F\u6587\u6597\u65A4\u65B9\u65E5\u66F0\u6708\u6728\u6B20\u6B62\u6B79\u6BCB\u6BD4\u6BDB\u6C0F\u6C34\u706B\u722A\u7236\u723B\u7247\u7259\u725B\u72AC\u738B\u4E19"
    ],
    [
        "a540",
        "\u4E16\u4E15\u4E14\u4E18\u4E3B\u4E4D\u4E4F\u4E4E\u4EE5\u4ED8\u4ED4\u4ED5\u4ED6\u4ED7\u4EE3\u4EE4\u4ED9\u4EDE\u5145\u5144\u5189\u518A\u51AC\u51F9\u51FA\u51F8\u520A\u52A0\u529F\u5305\u5306\u5317\u531D\u4EDF\u534A\u5349\u5361\u5360\u536F\u536E\u53BB\u53EF\u53E4\u53F3\u53EC\u53EE\u53E9\u53E8\u53FC\u53F8\u53F5\u53EB\u53E6\u53EA\u53F2\u53F1\u53F0\u53E5\u53ED\u53FB\u56DB\u56DA\u5916"
    ],
    [
        "a5a1",
        "\u592E\u5931\u5974\u5976\u5B55\u5B83\u5C3C\u5DE8\u5DE7\u5DE6\u5E02\u5E03\u5E73\u5E7C\u5F01\u5F18\u5F17\u5FC5\u620A\u6253\u6254\u6252\u6251\u65A5\u65E6\u672E\u672C\u672A\u672B\u672D\u6B63\u6BCD\u6C11\u6C10\u6C38\u6C41\u6C40\u6C3E\u72AF\u7384\u7389\u74DC\u74E6\u7518\u751F\u7528\u7529\u7530\u7531\u7532\u7533\u758B\u767D\u76AE\u76BF\u76EE\u77DB\u77E2\u77F3\u793A\u79BE\u7A74\u7ACB\u4E1E\u4E1F\u4E52\u4E53\u4E69\u4E99\u4EA4\u4EA6\u4EA5\u4EFF\u4F09\u4F19\u4F0A\u4F15\u4F0D\u4F10\u4F11\u4F0F\u4EF2\u4EF6\u4EFB\u4EF0\u4EF3\u4EFD\u4F01\u4F0B\u5149\u5147\u5146\u5148\u5168"
    ],
    [
        "a640",
        "\u5171\u518D\u51B0\u5217\u5211\u5212\u520E\u5216\u52A3\u5308\u5321\u5320\u5370\u5371\u5409\u540F\u540C\u540A\u5410\u5401\u540B\u5404\u5411\u540D\u5408\u5403\u540E\u5406\u5412\u56E0\u56DE\u56DD\u5733\u5730\u5728\u572D\u572C\u572F\u5729\u5919\u591A\u5937\u5938\u5984\u5978\u5983\u597D\u5979\u5982\u5981\u5B57\u5B58\u5B87\u5B88\u5B85\u5B89\u5BFA\u5C16\u5C79\u5DDE\u5E06\u5E76\u5E74"
    ],
    [
        "a6a1",
        "\u5F0F\u5F1B\u5FD9\u5FD6\u620E\u620C\u620D\u6210\u6263\u625B\u6258\u6536\u65E9\u65E8\u65EC\u65ED\u66F2\u66F3\u6709\u673D\u6734\u6731\u6735\u6B21\u6B64\u6B7B\u6C16\u6C5D\u6C57\u6C59\u6C5F\u6C60\u6C50\u6C55\u6C61\u6C5B\u6C4D\u6C4E\u7070\u725F\u725D\u767E\u7AF9\u7C73\u7CF8\u7F36\u7F8A\u7FBD\u8001\u8003\u800C\u8012\u8033\u807F\u8089\u808B\u808C\u81E3\u81EA\u81F3\u81FC\u820C\u821B\u821F\u826E\u8272\u827E\u866B\u8840\u884C\u8863\u897F\u9621\u4E32\u4EA8\u4F4D\u4F4F\u4F47\u4F57\u4F5E\u4F34\u4F5B\u4F55\u4F30\u4F50\u4F51\u4F3D\u4F3A\u4F38\u4F43\u4F54\u4F3C\u4F46\u4F63"
    ],
    [
        "a740",
        "\u4F5C\u4F60\u4F2F\u4F4E\u4F36\u4F59\u4F5D\u4F48\u4F5A\u514C\u514B\u514D\u5175\u51B6\u51B7\u5225\u5224\u5229\u522A\u5228\u52AB\u52A9\u52AA\u52AC\u5323\u5373\u5375\u541D\u542D\u541E\u543E\u5426\u544E\u5427\u5446\u5443\u5433\u5448\u5442\u541B\u5429\u544A\u5439\u543B\u5438\u542E\u5435\u5436\u5420\u543C\u5440\u5431\u542B\u541F\u542C\u56EA\u56F0\u56E4\u56EB\u574A\u5751\u5740\u574D"
    ],
    [
        "a7a1",
        "\u5747\u574E\u573E\u5750\u574F\u573B\u58EF\u593E\u599D\u5992\u59A8\u599E\u59A3\u5999\u5996\u598D\u59A4\u5993\u598A\u59A5\u5B5D\u5B5C\u5B5A\u5B5B\u5B8C\u5B8B\u5B8F\u5C2C\u5C40\u5C41\u5C3F\u5C3E\u5C90\u5C91\u5C94\u5C8C\u5DEB\u5E0C\u5E8F\u5E87\u5E8A\u5EF7\u5F04\u5F1F\u5F64\u5F62\u5F77\u5F79\u5FD8\u5FCC\u5FD7\u5FCD\u5FF1\u5FEB\u5FF8\u5FEA\u6212\u6211\u6284\u6297\u6296\u6280\u6276\u6289\u626D\u628A\u627C\u627E\u6279\u6273\u6292\u626F\u6298\u626E\u6295\u6293\u6291\u6286\u6539\u653B\u6538\u65F1\u66F4\u675F\u674E\u674F\u6750\u6751\u675C\u6756\u675E\u6749\u6746\u6760"
    ],
    [
        "a840",
        "\u6753\u6757\u6B65\u6BCF\u6C42\u6C5E\u6C99\u6C81\u6C88\u6C89\u6C85\u6C9B\u6C6A\u6C7A\u6C90\u6C70\u6C8C\u6C68\u6C96\u6C92\u6C7D\u6C83\u6C72\u6C7E\u6C74\u6C86\u6C76\u6C8D\u6C94\u6C98\u6C82\u7076\u707C\u707D\u7078\u7262\u7261\u7260\u72C4\u72C2\u7396\u752C\u752B\u7537\u7538\u7682\u76EF\u77E3\u79C1\u79C0\u79BF\u7A76\u7CFB\u7F55\u8096\u8093\u809D\u8098\u809B\u809A\u80B2\u826F\u8292"
    ],
    [
        "a8a1",
        "\u828B\u828D\u898B\u89D2\u8A00\u8C37\u8C46\u8C55\u8C9D\u8D64\u8D70\u8DB3\u8EAB\u8ECA\u8F9B\u8FB0\u8FC2\u8FC6\u8FC5\u8FC4\u5DE1\u9091\u90A2\u90AA\u90A6\u90A3\u9149\u91C6\u91CC\u9632\u962E\u9631\u962A\u962C\u4E26\u4E56\u4E73\u4E8B\u4E9B\u4E9E\u4EAB\u4EAC\u4F6F\u4F9D\u4F8D\u4F73\u4F7F\u4F6C\u4F9B\u4F8B\u4F86\u4F83\u4F70\u4F75\u4F88\u4F69\u4F7B\u4F96\u4F7E\u4F8F\u4F91\u4F7A\u5154\u5152\u5155\u5169\u5177\u5176\u5178\u51BD\u51FD\u523B\u5238\u5237\u523A\u5230\u522E\u5236\u5241\u52BE\u52BB\u5352\u5354\u5353\u5351\u5366\u5377\u5378\u5379\u53D6\u53D4\u53D7\u5473\u5475"
    ],
    [
        "a940",
        "\u5496\u5478\u5495\u5480\u547B\u5477\u5484\u5492\u5486\u547C\u5490\u5471\u5476\u548C\u549A\u5462\u5468\u548B\u547D\u548E\u56FA\u5783\u5777\u576A\u5769\u5761\u5766\u5764\u577C\u591C\u5949\u5947\u5948\u5944\u5954\u59BE\u59BB\u59D4\u59B9\u59AE\u59D1\u59C6\u59D0\u59CD\u59CB\u59D3\u59CA\u59AF\u59B3\u59D2\u59C5\u5B5F\u5B64\u5B63\u5B97\u5B9A\u5B98\u5B9C\u5B99\u5B9B\u5C1A\u5C48\u5C45"
    ],
    [
        "a9a1",
        "\u5C46\u5CB7\u5CA1\u5CB8\u5CA9\u5CAB\u5CB1\u5CB3\u5E18\u5E1A\u5E16\u5E15\u5E1B\u5E11\u5E78\u5E9A\u5E97\u5E9C\u5E95\u5E96\u5EF6\u5F26\u5F27\u5F29\u5F80\u5F81\u5F7F\u5F7C\u5FDD\u5FE0\u5FFD\u5FF5\u5FFF\u600F\u6014\u602F\u6035\u6016\u602A\u6015\u6021\u6027\u6029\u602B\u601B\u6216\u6215\u623F\u623E\u6240\u627F\u62C9\u62CC\u62C4\u62BF\u62C2\u62B9\u62D2\u62DB\u62AB\u62D3\u62D4\u62CB\u62C8\u62A8\u62BD\u62BC\u62D0\u62D9\u62C7\u62CD\u62B5\u62DA\u62B1\u62D8\u62D6\u62D7\u62C6\u62AC\u62CE\u653E\u65A7\u65BC\u65FA\u6614\u6613\u660C\u6606\u6602\u660E\u6600\u660F\u6615\u660A"
    ],
    [
        "aa40",
        "\u6607\u670D\u670B\u676D\u678B\u6795\u6771\u679C\u6773\u6777\u6787\u679D\u6797\u676F\u6770\u677F\u6789\u677E\u6790\u6775\u679A\u6793\u677C\u676A\u6772\u6B23\u6B66\u6B67\u6B7F\u6C13\u6C1B\u6CE3\u6CE8\u6CF3\u6CB1\u6CCC\u6CE5\u6CB3\u6CBD\u6CBE\u6CBC\u6CE2\u6CAB\u6CD5\u6CD3\u6CB8\u6CC4\u6CB9\u6CC1\u6CAE\u6CD7\u6CC5\u6CF1\u6CBF\u6CBB\u6CE1\u6CDB\u6CCA\u6CAC\u6CEF\u6CDC\u6CD6\u6CE0"
    ],
    [
        "aaa1",
        "\u7095\u708E\u7092\u708A\u7099\u722C\u722D\u7238\u7248\u7267\u7269\u72C0\u72CE\u72D9\u72D7\u72D0\u73A9\u73A8\u739F\u73AB\u73A5\u753D\u759D\u7599\u759A\u7684\u76C2\u76F2\u76F4\u77E5\u77FD\u793E\u7940\u7941\u79C9\u79C8\u7A7A\u7A79\u7AFA\u7CFE\u7F54\u7F8C\u7F8B\u8005\u80BA\u80A5\u80A2\u80B1\u80A1\u80AB\u80A9\u80B4\u80AA\u80AF\u81E5\u81FE\u820D\u82B3\u829D\u8299\u82AD\u82BD\u829F\u82B9\u82B1\u82AC\u82A5\u82AF\u82B8\u82A3\u82B0\u82BE\u82B7\u864E\u8671\u521D\u8868\u8ECB\u8FCE\u8FD4\u8FD1\u90B5\u90B8\u90B1\u90B6\u91C7\u91D1\u9577\u9580\u961C\u9640\u963F\u963B\u9644"
    ],
    [
        "ab40",
        "\u9642\u96B9\u96E8\u9752\u975E\u4E9F\u4EAD\u4EAE\u4FE1\u4FB5\u4FAF\u4FBF\u4FE0\u4FD1\u4FCF\u4FDD\u4FC3\u4FB6\u4FD8\u4FDF\u4FCA\u4FD7\u4FAE\u4FD0\u4FC4\u4FC2\u4FDA\u4FCE\u4FDE\u4FB7\u5157\u5192\u5191\u51A0\u524E\u5243\u524A\u524D\u524C\u524B\u5247\u52C7\u52C9\u52C3\u52C1\u530D\u5357\u537B\u539A\u53DB\u54AC\u54C0\u54A8\u54CE\u54C9\u54B8\u54A6\u54B3\u54C7\u54C2\u54BD\u54AA\u54C1"
    ],
    [
        "aba1",
        "\u54C4\u54C8\u54AF\u54AB\u54B1\u54BB\u54A9\u54A7\u54BF\u56FF\u5782\u578B\u57A0\u57A3\u57A2\u57CE\u57AE\u5793\u5955\u5951\u594F\u594E\u5950\u59DC\u59D8\u59FF\u59E3\u59E8\u5A03\u59E5\u59EA\u59DA\u59E6\u5A01\u59FB\u5B69\u5BA3\u5BA6\u5BA4\u5BA2\u5BA5\u5C01\u5C4E\u5C4F\u5C4D\u5C4B\u5CD9\u5CD2\u5DF7\u5E1D\u5E25\u5E1F\u5E7D\u5EA0\u5EA6\u5EFA\u5F08\u5F2D\u5F65\u5F88\u5F85\u5F8A\u5F8B\u5F87\u5F8C\u5F89\u6012\u601D\u6020\u6025\u600E\u6028\u604D\u6070\u6068\u6062\u6046\u6043\u606C\u606B\u606A\u6064\u6241\u62DC\u6316\u6309\u62FC\u62ED\u6301\u62EE\u62FD\u6307\u62F1\u62F7"
    ],
    [
        "ac40",
        "\u62EF\u62EC\u62FE\u62F4\u6311\u6302\u653F\u6545\u65AB\u65BD\u65E2\u6625\u662D\u6620\u6627\u662F\u661F\u6628\u6631\u6624\u66F7\u67FF\u67D3\u67F1\u67D4\u67D0\u67EC\u67B6\u67AF\u67F5\u67E9\u67EF\u67C4\u67D1\u67B4\u67DA\u67E5\u67B8\u67CF\u67DE\u67F3\u67B0\u67D9\u67E2\u67DD\u67D2\u6B6A\u6B83\u6B86\u6BB5\u6BD2\u6BD7\u6C1F\u6CC9\u6D0B\u6D32\u6D2A\u6D41\u6D25\u6D0C\u6D31\u6D1E\u6D17"
    ],
    [
        "aca1",
        "\u6D3B\u6D3D\u6D3E\u6D36\u6D1B\u6CF5\u6D39\u6D27\u6D38\u6D29\u6D2E\u6D35\u6D0E\u6D2B\u70AB\u70BA\u70B3\u70AC\u70AF\u70AD\u70B8\u70AE\u70A4\u7230\u7272\u726F\u7274\u72E9\u72E0\u72E1\u73B7\u73CA\u73BB\u73B2\u73CD\u73C0\u73B3\u751A\u752D\u754F\u754C\u754E\u754B\u75AB\u75A4\u75A5\u75A2\u75A3\u7678\u7686\u7687\u7688\u76C8\u76C6\u76C3\u76C5\u7701\u76F9\u76F8\u7709\u770B\u76FE\u76FC\u7707\u77DC\u7802\u7814\u780C\u780D\u7946\u7949\u7948\u7947\u79B9\u79BA\u79D1\u79D2\u79CB\u7A7F\u7A81\u7AFF\u7AFD\u7C7D\u7D02\u7D05\u7D00\u7D09\u7D07\u7D04\u7D06\u7F38\u7F8E\u7FBF\u8004"
    ],
    [
        "ad40",
        "\u8010\u800D\u8011\u8036\u80D6\u80E5\u80DA\u80C3\u80C4\u80CC\u80E1\u80DB\u80CE\u80DE\u80E4\u80DD\u81F4\u8222\u82E7\u8303\u8305\u82E3\u82DB\u82E6\u8304\u82E5\u8302\u8309\u82D2\u82D7\u82F1\u8301\u82DC\u82D4\u82D1\u82DE\u82D3\u82DF\u82EF\u8306\u8650\u8679\u867B\u867A\u884D\u886B\u8981\u89D4\u8A08\u8A02\u8A03\u8C9E\u8CA0\u8D74\u8D73\u8DB4\u8ECD\u8ECC\u8FF0\u8FE6\u8FE2\u8FEA\u8FE5"
    ],
    [
        "ada1",
        "\u8FED\u8FEB\u8FE4\u8FE8\u90CA\u90CE\u90C1\u90C3\u914B\u914A\u91CD\u9582\u9650\u964B\u964C\u964D\u9762\u9769\u97CB\u97ED\u97F3\u9801\u98A8\u98DB\u98DF\u9996\u9999\u4E58\u4EB3\u500C\u500D\u5023\u4FEF\u5026\u5025\u4FF8\u5029\u5016\u5006\u503C\u501F\u501A\u5012\u5011\u4FFA\u5000\u5014\u5028\u4FF1\u5021\u500B\u5019\u5018\u4FF3\u4FEE\u502D\u502A\u4FFE\u502B\u5009\u517C\u51A4\u51A5\u51A2\u51CD\u51CC\u51C6\u51CB\u5256\u525C\u5254\u525B\u525D\u532A\u537F\u539F\u539D\u53DF\u54E8\u5510\u5501\u5537\u54FC\u54E5\u54F2\u5506\u54FA\u5514\u54E9\u54ED\u54E1\u5509\u54EE\u54EA"
    ],
    [
        "ae40",
        "\u54E6\u5527\u5507\u54FD\u550F\u5703\u5704\u57C2\u57D4\u57CB\u57C3\u5809\u590F\u5957\u5958\u595A\u5A11\u5A18\u5A1C\u5A1F\u5A1B\u5A13\u59EC\u5A20\u5A23\u5A29\u5A25\u5A0C\u5A09\u5B6B\u5C58\u5BB0\u5BB3\u5BB6\u5BB4\u5BAE\u5BB5\u5BB9\u5BB8\u5C04\u5C51\u5C55\u5C50\u5CED\u5CFD\u5CFB\u5CEA\u5CE8\u5CF0\u5CF6\u5D01\u5CF4\u5DEE\u5E2D\u5E2B\u5EAB\u5EAD\u5EA7\u5F31\u5F92\u5F91\u5F90\u6059"
    ],
    [
        "aea1",
        "\u6063\u6065\u6050\u6055\u606D\u6069\u606F\u6084\u609F\u609A\u608D\u6094\u608C\u6085\u6096\u6247\u62F3\u6308\u62FF\u634E\u633E\u632F\u6355\u6342\u6346\u634F\u6349\u633A\u6350\u633D\u632A\u632B\u6328\u634D\u634C\u6548\u6549\u6599\u65C1\u65C5\u6642\u6649\u664F\u6643\u6652\u664C\u6645\u6641\u66F8\u6714\u6715\u6717\u6821\u6838\u6848\u6846\u6853\u6839\u6842\u6854\u6829\u68B3\u6817\u684C\u6851\u683D\u67F4\u6850\u6840\u683C\u6843\u682A\u6845\u6813\u6818\u6841\u6B8A\u6B89\u6BB7\u6C23\u6C27\u6C28\u6C26\u6C24\u6CF0\u6D6A\u6D95\u6D88\u6D87\u6D66\u6D78\u6D77\u6D59\u6D93"
    ],
    [
        "af40",
        "\u6D6C\u6D89\u6D6E\u6D5A\u6D74\u6D69\u6D8C\u6D8A\u6D79\u6D85\u6D65\u6D94\u70CA\u70D8\u70E4\u70D9\u70C8\u70CF\u7239\u7279\u72FC\u72F9\u72FD\u72F8\u72F7\u7386\u73ED\u7409\u73EE\u73E0\u73EA\u73DE\u7554\u755D\u755C\u755A\u7559\u75BE\u75C5\u75C7\u75B2\u75B3\u75BD\u75BC\u75B9\u75C2\u75B8\u768B\u76B0\u76CA\u76CD\u76CE\u7729\u771F\u7720\u7728\u77E9\u7830\u7827\u7838\u781D\u7834\u7837"
    ],
    [
        "afa1",
        "\u7825\u782D\u7820\u781F\u7832\u7955\u7950\u7960\u795F\u7956\u795E\u795D\u7957\u795A\u79E4\u79E3\u79E7\u79DF\u79E6\u79E9\u79D8\u7A84\u7A88\u7AD9\u7B06\u7B11\u7C89\u7D21\u7D17\u7D0B\u7D0A\u7D20\u7D22\u7D14\u7D10\u7D15\u7D1A\u7D1C\u7D0D\u7D19\u7D1B\u7F3A\u7F5F\u7F94\u7FC5\u7FC1\u8006\u8018\u8015\u8019\u8017\u803D\u803F\u80F1\u8102\u80F0\u8105\u80ED\u80F4\u8106\u80F8\u80F3\u8108\u80FD\u810A\u80FC\u80EF\u81ED\u81EC\u8200\u8210\u822A\u822B\u8228\u822C\u82BB\u832B\u8352\u8354\u834A\u8338\u8350\u8349\u8335\u8334\u834F\u8332\u8339\u8336\u8317\u8340\u8331\u8328\u8343"
    ],
    [
        "b040",
        "\u8654\u868A\u86AA\u8693\u86A4\u86A9\u868C\u86A3\u869C\u8870\u8877\u8881\u8882\u887D\u8879\u8A18\u8A10\u8A0E\u8A0C\u8A15\u8A0A\u8A17\u8A13\u8A16\u8A0F\u8A11\u8C48\u8C7A\u8C79\u8CA1\u8CA2\u8D77\u8EAC\u8ED2\u8ED4\u8ECF\u8FB1\u9001\u9006\u8FF7\u9000\u8FFA\u8FF4\u9003\u8FFD\u9005\u8FF8\u9095\u90E1\u90DD\u90E2\u9152\u914D\u914C\u91D8\u91DD\u91D7\u91DC\u91D9\u9583\u9662\u9663\u9661"
    ],
    [
        "b0a1",
        "\u965B\u965D\u9664\u9658\u965E\u96BB\u98E2\u99AC\u9AA8\u9AD8\u9B25\u9B32\u9B3C\u4E7E\u507A\u507D\u505C\u5047\u5043\u504C\u505A\u5049\u5065\u5076\u504E\u5055\u5075\u5074\u5077\u504F\u500F\u506F\u506D\u515C\u5195\u51F0\u526A\u526F\u52D2\u52D9\u52D8\u52D5\u5310\u530F\u5319\u533F\u5340\u533E\u53C3\u66FC\u5546\u556A\u5566\u5544\u555E\u5561\u5543\u554A\u5531\u5556\u554F\u5555\u552F\u5564\u5538\u552E\u555C\u552C\u5563\u5533\u5541\u5557\u5708\u570B\u5709\u57DF\u5805\u580A\u5806\u57E0\u57E4\u57FA\u5802\u5835\u57F7\u57F9\u5920\u5962\u5A36\u5A41\u5A49\u5A66\u5A6A\u5A40"
    ],
    [
        "b140",
        "\u5A3C\u5A62\u5A5A\u5A46\u5A4A\u5B70\u5BC7\u5BC5\u5BC4\u5BC2\u5BBF\u5BC6\u5C09\u5C08\u5C07\u5C60\u5C5C\u5C5D\u5D07\u5D06\u5D0E\u5D1B\u5D16\u5D22\u5D11\u5D29\u5D14\u5D19\u5D24\u5D27\u5D17\u5DE2\u5E38\u5E36\u5E33\u5E37\u5EB7\u5EB8\u5EB6\u5EB5\u5EBE\u5F35\u5F37\u5F57\u5F6C\u5F69\u5F6B\u5F97\u5F99\u5F9E\u5F98\u5FA1\u5FA0\u5F9C\u607F\u60A3\u6089\u60A0\u60A8\u60CB\u60B4\u60E6\u60BD"
    ],
    [
        "b1a1",
        "\u60C5\u60BB\u60B5\u60DC\u60BC\u60D8\u60D5\u60C6\u60DF\u60B8\u60DA\u60C7\u621A\u621B\u6248\u63A0\u63A7\u6372\u6396\u63A2\u63A5\u6377\u6367\u6398\u63AA\u6371\u63A9\u6389\u6383\u639B\u636B\u63A8\u6384\u6388\u6399\u63A1\u63AC\u6392\u638F\u6380\u637B\u6369\u6368\u637A\u655D\u6556\u6551\u6559\u6557\u555F\u654F\u6558\u6555\u6554\u659C\u659B\u65AC\u65CF\u65CB\u65CC\u65CE\u665D\u665A\u6664\u6668\u6666\u665E\u66F9\u52D7\u671B\u6881\u68AF\u68A2\u6893\u68B5\u687F\u6876\u68B1\u68A7\u6897\u68B0\u6883\u68C4\u68AD\u6886\u6885\u6894\u689D\u68A8\u689F\u68A1\u6882\u6B32\u6BBA"
    ],
    [
        "b240",
        "\u6BEB\u6BEC\u6C2B\u6D8E\u6DBC\u6DF3\u6DD9\u6DB2\u6DE1\u6DCC\u6DE4\u6DFB\u6DFA\u6E05\u6DC7\u6DCB\u6DAF\u6DD1\u6DAE\u6DDE\u6DF9\u6DB8\u6DF7\u6DF5\u6DC5\u6DD2\u6E1A\u6DB5\u6DDA\u6DEB\u6DD8\u6DEA\u6DF1\u6DEE\u6DE8\u6DC6\u6DC4\u6DAA\u6DEC\u6DBF\u6DE6\u70F9\u7109\u710A\u70FD\u70EF\u723D\u727D\u7281\u731C\u731B\u7316\u7313\u7319\u7387\u7405\u740A\u7403\u7406\u73FE\u740D\u74E0\u74F6"
    ],
    [
        "b2a1",
        "\u74F7\u751C\u7522\u7565\u7566\u7562\u7570\u758F\u75D4\u75D5\u75B5\u75CA\u75CD\u768E\u76D4\u76D2\u76DB\u7737\u773E\u773C\u7736\u7738\u773A\u786B\u7843\u784E\u7965\u7968\u796D\u79FB\u7A92\u7A95\u7B20\u7B28\u7B1B\u7B2C\u7B26\u7B19\u7B1E\u7B2E\u7C92\u7C97\u7C95\u7D46\u7D43\u7D71\u7D2E\u7D39\u7D3C\u7D40\u7D30\u7D33\u7D44\u7D2F\u7D42\u7D32\u7D31\u7F3D\u7F9E\u7F9A\u7FCC\u7FCE\u7FD2\u801C\u804A\u8046\u812F\u8116\u8123\u812B\u8129\u8130\u8124\u8202\u8235\u8237\u8236\u8239\u838E\u839E\u8398\u8378\u83A2\u8396\u83BD\u83AB\u8392\u838A\u8393\u8389\u83A0\u8377\u837B\u837C"
    ],
    [
        "b340",
        "\u8386\u83A7\u8655\u5F6A\u86C7\u86C0\u86B6\u86C4\u86B5\u86C6\u86CB\u86B1\u86AF\u86C9\u8853\u889E\u8888\u88AB\u8892\u8896\u888D\u888B\u8993\u898F\u8A2A\u8A1D\u8A23\u8A25\u8A31\u8A2D\u8A1F\u8A1B\u8A22\u8C49\u8C5A\u8CA9\u8CAC\u8CAB\u8CA8\u8CAA\u8CA7\u8D67\u8D66\u8DBE\u8DBA\u8EDB\u8EDF\u9019\u900D\u901A\u9017\u9023\u901F\u901D\u9010\u9015\u901E\u9020\u900F\u9022\u9016\u901B\u9014"
    ],
    [
        "b3a1",
        "\u90E8\u90ED\u90FD\u9157\u91CE\u91F5\u91E6\u91E3\u91E7\u91ED\u91E9\u9589\u966A\u9675\u9673\u9678\u9670\u9674\u9676\u9677\u966C\u96C0\u96EA\u96E9\u7AE0\u7ADF\u9802\u9803\u9B5A\u9CE5\u9E75\u9E7F\u9EA5\u9EBB\u50A2\u508D\u5085\u5099\u5091\u5080\u5096\u5098\u509A\u6700\u51F1\u5272\u5274\u5275\u5269\u52DE\u52DD\u52DB\u535A\u53A5\u557B\u5580\u55A7\u557C\u558A\u559D\u5598\u5582\u559C\u55AA\u5594\u5587\u558B\u5583\u55B3\u55AE\u559F\u553E\u55B2\u559A\u55BB\u55AC\u55B1\u557E\u5589\u55AB\u5599\u570D\u582F\u582A\u5834\u5824\u5830\u5831\u5821\u581D\u5820\u58F9\u58FA\u5960"
    ],
    [
        "b440",
        "\u5A77\u5A9A\u5A7F\u5A92\u5A9B\u5AA7\u5B73\u5B71\u5BD2\u5BCC\u5BD3\u5BD0\u5C0A\u5C0B\u5C31\u5D4C\u5D50\u5D34\u5D47\u5DFD\u5E45\u5E3D\u5E40\u5E43\u5E7E\u5ECA\u5EC1\u5EC2\u5EC4\u5F3C\u5F6D\u5FA9\u5FAA\u5FA8\u60D1\u60E1\u60B2\u60B6\u60E0\u611C\u6123\u60FA\u6115\u60F0\u60FB\u60F4\u6168\u60F1\u610E\u60F6\u6109\u6100\u6112\u621F\u6249\u63A3\u638C\u63CF\u63C0\u63E9\u63C9\u63C6\u63CD"
    ],
    [
        "b4a1",
        "\u63D2\u63E3\u63D0\u63E1\u63D6\u63ED\u63EE\u6376\u63F4\u63EA\u63DB\u6452\u63DA\u63F9\u655E\u6566\u6562\u6563\u6591\u6590\u65AF\u666E\u6670\u6674\u6676\u666F\u6691\u667A\u667E\u6677\u66FE\u66FF\u671F\u671D\u68FA\u68D5\u68E0\u68D8\u68D7\u6905\u68DF\u68F5\u68EE\u68E7\u68F9\u68D2\u68F2\u68E3\u68CB\u68CD\u690D\u6912\u690E\u68C9\u68DA\u696E\u68FB\u6B3E\u6B3A\u6B3D\u6B98\u6B96\u6BBC\u6BEF\u6C2E\u6C2F\u6C2C\u6E2F\u6E38\u6E54\u6E21\u6E32\u6E67\u6E4A\u6E20\u6E25\u6E23\u6E1B\u6E5B\u6E58\u6E24\u6E56\u6E6E\u6E2D\u6E26\u6E6F\u6E34\u6E4D\u6E3A\u6E2C\u6E43\u6E1D\u6E3E\u6ECB"
    ],
    [
        "b540",
        "\u6E89\u6E19\u6E4E\u6E63\u6E44\u6E72\u6E69\u6E5F\u7119\u711A\u7126\u7130\u7121\u7136\u716E\u711C\u724C\u7284\u7280\u7336\u7325\u7334\u7329\u743A\u742A\u7433\u7422\u7425\u7435\u7436\u7434\u742F\u741B\u7426\u7428\u7525\u7526\u756B\u756A\u75E2\u75DB\u75E3\u75D9\u75D8\u75DE\u75E0\u767B\u767C\u7696\u7693\u76B4\u76DC\u774F\u77ED\u785D\u786C\u786F\u7A0D\u7A08\u7A0B\u7A05\u7A00\u7A98"
    ],
    [
        "b5a1",
        "\u7A97\u7A96\u7AE5\u7AE3\u7B49\u7B56\u7B46\u7B50\u7B52\u7B54\u7B4D\u7B4B\u7B4F\u7B51\u7C9F\u7CA5\u7D5E\u7D50\u7D68\u7D55\u7D2B\u7D6E\u7D72\u7D61\u7D66\u7D62\u7D70\u7D73\u5584\u7FD4\u7FD5\u800B\u8052\u8085\u8155\u8154\u814B\u8151\u814E\u8139\u8146\u813E\u814C\u8153\u8174\u8212\u821C\u83E9\u8403\u83F8\u840D\u83E0\u83C5\u840B\u83C1\u83EF\u83F1\u83F4\u8457\u840A\u83F0\u840C\u83CC\u83FD\u83F2\u83CA\u8438\u840E\u8404\u83DC\u8407\u83D4\u83DF\u865B\u86DF\u86D9\u86ED\u86D4\u86DB\u86E4\u86D0\u86DE\u8857\u88C1\u88C2\u88B1\u8983\u8996\u8A3B\u8A60\u8A55\u8A5E\u8A3C\u8A41"
    ],
    [
        "b640",
        "\u8A54\u8A5B\u8A50\u8A46\u8A34\u8A3A\u8A36\u8A56\u8C61\u8C82\u8CAF\u8CBC\u8CB3\u8CBD\u8CC1\u8CBB\u8CC0\u8CB4\u8CB7\u8CB6\u8CBF\u8CB8\u8D8A\u8D85\u8D81\u8DCE\u8DDD\u8DCB\u8DDA\u8DD1\u8DCC\u8DDB\u8DC6\u8EFB\u8EF8\u8EFC\u8F9C\u902E\u9035\u9031\u9038\u9032\u9036\u9102\u90F5\u9109\u90FE\u9163\u9165\u91CF\u9214\u9215\u9223\u9209\u921E\u920D\u9210\u9207\u9211\u9594\u958F\u958B\u9591"
    ],
    [
        "b6a1",
        "\u9593\u9592\u958E\u968A\u968E\u968B\u967D\u9685\u9686\u968D\u9672\u9684\u96C1\u96C5\u96C4\u96C6\u96C7\u96EF\u96F2\u97CC\u9805\u9806\u9808\u98E7\u98EA\u98EF\u98E9\u98F2\u98ED\u99AE\u99AD\u9EC3\u9ECD\u9ED1\u4E82\u50AD\u50B5\u50B2\u50B3\u50C5\u50BE\u50AC\u50B7\u50BB\u50AF\u50C7\u527F\u5277\u527D\u52DF\u52E6\u52E4\u52E2\u52E3\u532F\u55DF\u55E8\u55D3\u55E6\u55CE\u55DC\u55C7\u55D1\u55E3\u55E4\u55EF\u55DA\u55E1\u55C5\u55C6\u55E5\u55C9\u5712\u5713\u585E\u5851\u5858\u5857\u585A\u5854\u586B\u584C\u586D\u584A\u5862\u5852\u584B\u5967\u5AC1\u5AC9\u5ACC\u5ABE\u5ABD\u5ABC"
    ],
    [
        "b740",
        "\u5AB3\u5AC2\u5AB2\u5D69\u5D6F\u5E4C\u5E79\u5EC9\u5EC8\u5F12\u5F59\u5FAC\u5FAE\u611A\u610F\u6148\u611F\u60F3\u611B\u60F9\u6101\u6108\u614E\u614C\u6144\u614D\u613E\u6134\u6127\u610D\u6106\u6137\u6221\u6222\u6413\u643E\u641E\u642A\u642D\u643D\u642C\u640F\u641C\u6414\u640D\u6436\u6416\u6417\u6406\u656C\u659F\u65B0\u6697\u6689\u6687\u6688\u6696\u6684\u6698\u668D\u6703\u6994\u696D"
    ],
    [
        "b7a1",
        "\u695A\u6977\u6960\u6954\u6975\u6930\u6982\u694A\u6968\u696B\u695E\u6953\u6979\u6986\u695D\u6963\u695B\u6B47\u6B72\u6BC0\u6BBF\u6BD3\u6BFD\u6EA2\u6EAF\u6ED3\u6EB6\u6EC2\u6E90\u6E9D\u6EC7\u6EC5\u6EA5\u6E98\u6EBC\u6EBA\u6EAB\u6ED1\u6E96\u6E9C\u6EC4\u6ED4\u6EAA\u6EA7\u6EB4\u714E\u7159\u7169\u7164\u7149\u7167\u715C\u716C\u7166\u714C\u7165\u715E\u7146\u7168\u7156\u723A\u7252\u7337\u7345\u733F\u733E\u746F\u745A\u7455\u745F\u745E\u7441\u743F\u7459\u745B\u745C\u7576\u7578\u7600\u75F0\u7601\u75F2\u75F1\u75FA\u75FF\u75F4\u75F3\u76DE\u76DF\u775B\u776B\u7766\u775E\u7763"
    ],
    [
        "b840",
        "\u7779\u776A\u776C\u775C\u7765\u7768\u7762\u77EE\u788E\u78B0\u7897\u7898\u788C\u7889\u787C\u7891\u7893\u787F\u797A\u797F\u7981\u842C\u79BD\u7A1C\u7A1A\u7A20\u7A14\u7A1F\u7A1E\u7A9F\u7AA0\u7B77\u7BC0\u7B60\u7B6E\u7B67\u7CB1\u7CB3\u7CB5\u7D93\u7D79\u7D91\u7D81\u7D8F\u7D5B\u7F6E\u7F69\u7F6A\u7F72\u7FA9\u7FA8\u7FA4\u8056\u8058\u8086\u8084\u8171\u8170\u8178\u8165\u816E\u8173\u816B"
    ],
    [
        "b8a1",
        "\u8179\u817A\u8166\u8205\u8247\u8482\u8477\u843D\u8431\u8475\u8466\u846B\u8449\u846C\u845B\u843C\u8435\u8461\u8463\u8469\u846D\u8446\u865E\u865C\u865F\u86F9\u8713\u8708\u8707\u8700\u86FE\u86FB\u8702\u8703\u8706\u870A\u8859\u88DF\u88D4\u88D9\u88DC\u88D8\u88DD\u88E1\u88CA\u88D5\u88D2\u899C\u89E3\u8A6B\u8A72\u8A73\u8A66\u8A69\u8A70\u8A87\u8A7C\u8A63\u8AA0\u8A71\u8A85\u8A6D\u8A62\u8A6E\u8A6C\u8A79\u8A7B\u8A3E\u8A68\u8C62\u8C8A\u8C89\u8CCA\u8CC7\u8CC8\u8CC4\u8CB2\u8CC3\u8CC2\u8CC5\u8DE1\u8DDF\u8DE8\u8DEF\u8DF3\u8DFA\u8DEA\u8DE4\u8DE6\u8EB2\u8F03\u8F09\u8EFE\u8F0A"
    ],
    [
        "b940",
        "\u8F9F\u8FB2\u904B\u904A\u9053\u9042\u9054\u903C\u9055\u9050\u9047\u904F\u904E\u904D\u9051\u903E\u9041\u9112\u9117\u916C\u916A\u9169\u91C9\u9237\u9257\u9238\u923D\u9240\u923E\u925B\u924B\u9264\u9251\u9234\u9249\u924D\u9245\u9239\u923F\u925A\u9598\u9698\u9694\u9695\u96CD\u96CB\u96C9\u96CA\u96F7\u96FB\u96F9\u96F6\u9756\u9774\u9776\u9810\u9811\u9813\u980A\u9812\u980C\u98FC\u98F4"
    ],
    [
        "b9a1",
        "\u98FD\u98FE\u99B3\u99B1\u99B4\u9AE1\u9CE9\u9E82\u9F0E\u9F13\u9F20\u50E7\u50EE\u50E5\u50D6\u50ED\u50DA\u50D5\u50CF\u50D1\u50F1\u50CE\u50E9\u5162\u51F3\u5283\u5282\u5331\u53AD\u55FE\u5600\u561B\u5617\u55FD\u5614\u5606\u5609\u560D\u560E\u55F7\u5616\u561F\u5608\u5610\u55F6\u5718\u5716\u5875\u587E\u5883\u5893\u588A\u5879\u5885\u587D\u58FD\u5925\u5922\u5924\u596A\u5969\u5AE1\u5AE6\u5AE9\u5AD7\u5AD6\u5AD8\u5AE3\u5B75\u5BDE\u5BE7\u5BE1\u5BE5\u5BE6\u5BE8\u5BE2\u5BE4\u5BDF\u5C0D\u5C62\u5D84\u5D87\u5E5B\u5E63\u5E55\u5E57\u5E54\u5ED3\u5ED6\u5F0A\u5F46\u5F70\u5FB9\u6147"
    ],
    [
        "ba40",
        "\u613F\u614B\u6177\u6162\u6163\u615F\u615A\u6158\u6175\u622A\u6487\u6458\u6454\u64A4\u6478\u645F\u647A\u6451\u6467\u6434\u646D\u647B\u6572\u65A1\u65D7\u65D6\u66A2\u66A8\u669D\u699C\u69A8\u6995\u69C1\u69AE\u69D3\u69CB\u699B\u69B7\u69BB\u69AB\u69B4\u69D0\u69CD\u69AD\u69CC\u69A6\u69C3\u69A3\u6B49\u6B4C\u6C33\u6F33\u6F14\u6EFE\u6F13\u6EF4\u6F29\u6F3E\u6F20\u6F2C\u6F0F\u6F02\u6F22"
    ],
    [
        "baa1",
        "\u6EFF\u6EEF\u6F06\u6F31\u6F38\u6F32\u6F23\u6F15\u6F2B\u6F2F\u6F88\u6F2A\u6EEC\u6F01\u6EF2\u6ECC\u6EF7\u7194\u7199\u717D\u718A\u7184\u7192\u723E\u7292\u7296\u7344\u7350\u7464\u7463\u746A\u7470\u746D\u7504\u7591\u7627\u760D\u760B\u7609\u7613\u76E1\u76E3\u7784\u777D\u777F\u7761\u78C1\u789F\u78A7\u78B3\u78A9\u78A3\u798E\u798F\u798D\u7A2E\u7A31\u7AAA\u7AA9\u7AED\u7AEF\u7BA1\u7B95\u7B8B\u7B75\u7B97\u7B9D\u7B94\u7B8F\u7BB8\u7B87\u7B84\u7CB9\u7CBD\u7CBE\u7DBB\u7DB0\u7D9C\u7DBD\u7DBE\u7DA0\u7DCA\u7DB4\u7DB2\u7DB1\u7DBA\u7DA2\u7DBF\u7DB5\u7DB8\u7DAD\u7DD2\u7DC7\u7DAC"
    ],
    [
        "bb40",
        "\u7F70\u7FE0\u7FE1\u7FDF\u805E\u805A\u8087\u8150\u8180\u818F\u8188\u818A\u817F\u8182\u81E7\u81FA\u8207\u8214\u821E\u824B\u84C9\u84BF\u84C6\u84C4\u8499\u849E\u84B2\u849C\u84CB\u84B8\u84C0\u84D3\u8490\u84BC\u84D1\u84CA\u873F\u871C\u873B\u8722\u8725\u8734\u8718\u8755\u8737\u8729\u88F3\u8902\u88F4\u88F9\u88F8\u88FD\u88E8\u891A\u88EF\u8AA6\u8A8C\u8A9E\u8AA3\u8A8D\u8AA1\u8A93\u8AA4"
    ],
    [
        "bba1",
        "\u8AAA\u8AA5\u8AA8\u8A98\u8A91\u8A9A\u8AA7\u8C6A\u8C8D\u8C8C\u8CD3\u8CD1\u8CD2\u8D6B\u8D99\u8D95\u8DFC\u8F14\u8F12\u8F15\u8F13\u8FA3\u9060\u9058\u905C\u9063\u9059\u905E\u9062\u905D\u905B\u9119\u9118\u911E\u9175\u9178\u9177\u9174\u9278\u9280\u9285\u9298\u9296\u927B\u9293\u929C\u92A8\u927C\u9291\u95A1\u95A8\u95A9\u95A3\u95A5\u95A4\u9699\u969C\u969B\u96CC\u96D2\u9700\u977C\u9785\u97F6\u9817\u9818\u98AF\u98B1\u9903\u9905\u990C\u9909\u99C1\u9AAF\u9AB0\u9AE6\u9B41\u9B42\u9CF4\u9CF6\u9CF3\u9EBC\u9F3B\u9F4A\u5104\u5100\u50FB\u50F5\u50F9\u5102\u5108\u5109\u5105\u51DC"
    ],
    [
        "bc40",
        "\u5287\u5288\u5289\u528D\u528A\u52F0\u53B2\u562E\u563B\u5639\u5632\u563F\u5634\u5629\u5653\u564E\u5657\u5674\u5636\u562F\u5630\u5880\u589F\u589E\u58B3\u589C\u58AE\u58A9\u58A6\u596D\u5B09\u5AFB\u5B0B\u5AF5\u5B0C\u5B08\u5BEE\u5BEC\u5BE9\u5BEB\u5C64\u5C65\u5D9D\u5D94\u5E62\u5E5F\u5E61\u5EE2\u5EDA\u5EDF\u5EDD\u5EE3\u5EE0\u5F48\u5F71\u5FB7\u5FB5\u6176\u6167\u616E\u615D\u6155\u6182"
    ],
    [
        "bca1",
        "\u617C\u6170\u616B\u617E\u61A7\u6190\u61AB\u618E\u61AC\u619A\u61A4\u6194\u61AE\u622E\u6469\u646F\u6479\u649E\u64B2\u6488\u6490\u64B0\u64A5\u6493\u6495\u64A9\u6492\u64AE\u64AD\u64AB\u649A\u64AC\u6499\u64A2\u64B3\u6575\u6577\u6578\u66AE\u66AB\u66B4\u66B1\u6A23\u6A1F\u69E8\u6A01\u6A1E\u6A19\u69FD\u6A21\u6A13\u6A0A\u69F3\u6A02\u6A05\u69ED\u6A11\u6B50\u6B4E\u6BA4\u6BC5\u6BC6\u6F3F\u6F7C\u6F84\u6F51\u6F66\u6F54\u6F86\u6F6D\u6F5B\u6F78\u6F6E\u6F8E\u6F7A\u6F70\u6F64\u6F97\u6F58\u6ED5\u6F6F\u6F60\u6F5F\u719F\u71AC\u71B1\u71A8\u7256\u729B\u734E\u7357\u7469\u748B\u7483"
    ],
    [
        "bd40",
        "\u747E\u7480\u757F\u7620\u7629\u761F\u7624\u7626\u7621\u7622\u769A\u76BA\u76E4\u778E\u7787\u778C\u7791\u778B\u78CB\u78C5\u78BA\u78CA\u78BE\u78D5\u78BC\u78D0\u7A3F\u7A3C\u7A40\u7A3D\u7A37\u7A3B\u7AAF\u7AAE\u7BAD\u7BB1\u7BC4\u7BB4\u7BC6\u7BC7\u7BC1\u7BA0\u7BCC\u7CCA\u7DE0\u7DF4\u7DEF\u7DFB\u7DD8\u7DEC\u7DDD\u7DE8\u7DE3\u7DDA\u7DDE\u7DE9\u7D9E\u7DD9\u7DF2\u7DF9\u7F75\u7F77\u7FAF"
    ],
    [
        "bda1",
        "\u7FE9\u8026\u819B\u819C\u819D\u81A0\u819A\u8198\u8517\u853D\u851A\u84EE\u852C\u852D\u8513\u8511\u8523\u8521\u8514\u84EC\u8525\u84FF\u8506\u8782\u8774\u8776\u8760\u8766\u8778\u8768\u8759\u8757\u874C\u8753\u885B\u885D\u8910\u8907\u8912\u8913\u8915\u890A\u8ABC\u8AD2\u8AC7\u8AC4\u8A95\u8ACB\u8AF8\u8AB2\u8AC9\u8AC2\u8ABF\u8AB0\u8AD6\u8ACD\u8AB6\u8AB9\u8ADB\u8C4C\u8C4E\u8C6C\u8CE0\u8CDE\u8CE6\u8CE4\u8CEC\u8CED\u8CE2\u8CE3\u8CDC\u8CEA\u8CE1\u8D6D\u8D9F\u8DA3\u8E2B\u8E10\u8E1D\u8E22\u8E0F\u8E29\u8E1F\u8E21\u8E1E\u8EBA\u8F1D\u8F1B\u8F1F\u8F29\u8F26\u8F2A\u8F1C\u8F1E"
    ],
    [
        "be40",
        "\u8F25\u9069\u906E\u9068\u906D\u9077\u9130\u912D\u9127\u9131\u9187\u9189\u918B\u9183\u92C5\u92BB\u92B7\u92EA\u92AC\u92E4\u92C1\u92B3\u92BC\u92D2\u92C7\u92F0\u92B2\u95AD\u95B1\u9704\u9706\u9707\u9709\u9760\u978D\u978B\u978F\u9821\u982B\u981C\u98B3\u990A\u9913\u9912\u9918\u99DD\u99D0\u99DF\u99DB\u99D1\u99D5\u99D2\u99D9\u9AB7\u9AEE\u9AEF\u9B27\u9B45\u9B44\u9B77\u9B6F\u9D06\u9D09"
    ],
    [
        "bea1",
        "\u9D03\u9EA9\u9EBE\u9ECE\u58A8\u9F52\u5112\u5118\u5114\u5110\u5115\u5180\u51AA\u51DD\u5291\u5293\u52F3\u5659\u566B\u5679\u5669\u5664\u5678\u566A\u5668\u5665\u5671\u566F\u566C\u5662\u5676\u58C1\u58BE\u58C7\u58C5\u596E\u5B1D\u5B34\u5B78\u5BF0\u5C0E\u5F4A\u61B2\u6191\u61A9\u618A\u61CD\u61B6\u61BE\u61CA\u61C8\u6230\u64C5\u64C1\u64CB\u64BB\u64BC\u64DA\u64C4\u64C7\u64C2\u64CD\u64BF\u64D2\u64D4\u64BE\u6574\u66C6\u66C9\u66B9\u66C4\u66C7\u66B8\u6A3D\u6A38\u6A3A\u6A59\u6A6B\u6A58\u6A39\u6A44\u6A62\u6A61\u6A4B\u6A47\u6A35\u6A5F\u6A48\u6B59\u6B77\u6C05\u6FC2\u6FB1\u6FA1"
    ],
    [
        "bf40",
        "\u6FC3\u6FA4\u6FC1\u6FA7\u6FB3\u6FC0\u6FB9\u6FB6\u6FA6\u6FA0\u6FB4\u71BE\u71C9\u71D0\u71D2\u71C8\u71D5\u71B9\u71CE\u71D9\u71DC\u71C3\u71C4\u7368\u749C\u74A3\u7498\u749F\u749E\u74E2\u750C\u750D\u7634\u7638\u763A\u76E7\u76E5\u77A0\u779E\u779F\u77A5\u78E8\u78DA\u78EC\u78E7\u79A6\u7A4D\u7A4E\u7A46\u7A4C\u7A4B\u7ABA\u7BD9\u7C11\u7BC9\u7BE4\u7BDB\u7BE1\u7BE9\u7BE6\u7CD5\u7CD6\u7E0A"
    ],
    [
        "bfa1",
        "\u7E11\u7E08\u7E1B\u7E23\u7E1E\u7E1D\u7E09\u7E10\u7F79\u7FB2\u7FF0\u7FF1\u7FEE\u8028\u81B3\u81A9\u81A8\u81FB\u8208\u8258\u8259\u854A\u8559\u8548\u8568\u8569\u8543\u8549\u856D\u856A\u855E\u8783\u879F\u879E\u87A2\u878D\u8861\u892A\u8932\u8925\u892B\u8921\u89AA\u89A6\u8AE6\u8AFA\u8AEB\u8AF1\u8B00\u8ADC\u8AE7\u8AEE\u8AFE\u8B01\u8B02\u8AF7\u8AED\u8AF3\u8AF6\u8AFC\u8C6B\u8C6D\u8C93\u8CF4\u8E44\u8E31\u8E34\u8E42\u8E39\u8E35\u8F3B\u8F2F\u8F38\u8F33\u8FA8\u8FA6\u9075\u9074\u9078\u9072\u907C\u907A\u9134\u9192\u9320\u9336\u92F8\u9333\u932F\u9322\u92FC\u932B\u9304\u931A"
    ],
    [
        "c040",
        "\u9310\u9326\u9321\u9315\u932E\u9319\u95BB\u96A7\u96A8\u96AA\u96D5\u970E\u9711\u9716\u970D\u9713\u970F\u975B\u975C\u9766\u9798\u9830\u9838\u983B\u9837\u982D\u9839\u9824\u9910\u9928\u991E\u991B\u9921\u991A\u99ED\u99E2\u99F1\u9AB8\u9ABC\u9AFB\u9AED\u9B28\u9B91\u9D15\u9D23\u9D26\u9D28\u9D12\u9D1B\u9ED8\u9ED4\u9F8D\u9F9C\u512A\u511F\u5121\u5132\u52F5\u568E\u5680\u5690\u5685\u5687"
    ],
    [
        "c0a1",
        "\u568F\u58D5\u58D3\u58D1\u58CE\u5B30\u5B2A\u5B24\u5B7A\u5C37\u5C68\u5DBC\u5DBA\u5DBD\u5DB8\u5E6B\u5F4C\u5FBD\u61C9\u61C2\u61C7\u61E6\u61CB\u6232\u6234\u64CE\u64CA\u64D8\u64E0\u64F0\u64E6\u64EC\u64F1\u64E2\u64ED\u6582\u6583\u66D9\u66D6\u6A80\u6A94\u6A84\u6AA2\u6A9C\u6ADB\u6AA3\u6A7E\u6A97\u6A90\u6AA0\u6B5C\u6BAE\u6BDA\u6C08\u6FD8\u6FF1\u6FDF\u6FE0\u6FDB\u6FE4\u6FEB\u6FEF\u6F80\u6FEC\u6FE1\u6FE9\u6FD5\u6FEE\u6FF0\u71E7\u71DF\u71EE\u71E6\u71E5\u71ED\u71EC\u71F4\u71E0\u7235\u7246\u7370\u7372\u74A9\u74B0\u74A6\u74A8\u7646\u7642\u764C\u76EA\u77B3\u77AA\u77B0\u77AC"
    ],
    [
        "c140",
        "\u77A7\u77AD\u77EF\u78F7\u78FA\u78F4\u78EF\u7901\u79A7\u79AA\u7A57\u7ABF\u7C07\u7C0D\u7BFE\u7BF7\u7C0C\u7BE0\u7CE0\u7CDC\u7CDE\u7CE2\u7CDF\u7CD9\u7CDD\u7E2E\u7E3E\u7E46\u7E37\u7E32\u7E43\u7E2B\u7E3D\u7E31\u7E45\u7E41\u7E34\u7E39\u7E48\u7E35\u7E3F\u7E2F\u7F44\u7FF3\u7FFC\u8071\u8072\u8070\u806F\u8073\u81C6\u81C3\u81BA\u81C2\u81C0\u81BF\u81BD\u81C9\u81BE\u81E8\u8209\u8271\u85AA"
    ],
    [
        "c1a1",
        "\u8584\u857E\u859C\u8591\u8594\u85AF\u859B\u8587\u85A8\u858A\u8667\u87C0\u87D1\u87B3\u87D2\u87C6\u87AB\u87BB\u87BA\u87C8\u87CB\u893B\u8936\u8944\u8938\u893D\u89AC\u8B0E\u8B17\u8B19\u8B1B\u8B0A\u8B20\u8B1D\u8B04\u8B10\u8C41\u8C3F\u8C73\u8CFA\u8CFD\u8CFC\u8CF8\u8CFB\u8DA8\u8E49\u8E4B\u8E48\u8E4A\u8F44\u8F3E\u8F42\u8F45\u8F3F\u907F\u907D\u9084\u9081\u9082\u9080\u9139\u91A3\u919E\u919C\u934D\u9382\u9328\u9375\u934A\u9365\u934B\u9318\u937E\u936C\u935B\u9370\u935A\u9354\u95CA\u95CB\u95CC\u95C8\u95C6\u96B1\u96B8\u96D6\u971C\u971E\u97A0\u97D3\u9846\u98B6\u9935\u9A01"
    ],
    [
        "c240",
        "\u99FF\u9BAE\u9BAB\u9BAA\u9BAD\u9D3B\u9D3F\u9E8B\u9ECF\u9EDE\u9EDC\u9EDD\u9EDB\u9F3E\u9F4B\u53E2\u5695\u56AE\u58D9\u58D8\u5B38\u5F5D\u61E3\u6233\u64F4\u64F2\u64FE\u6506\u64FA\u64FB\u64F7\u65B7\u66DC\u6726\u6AB3\u6AAC\u6AC3\u6ABB\u6AB8\u6AC2\u6AAE\u6AAF\u6B5F\u6B78\u6BAF\u7009\u700B\u6FFE\u7006\u6FFA\u7011\u700F\u71FB\u71FC\u71FE\u71F8\u7377\u7375\u74A7\u74BF\u7515\u7656\u7658"
    ],
    [
        "c2a1",
        "\u7652\u77BD\u77BF\u77BB\u77BC\u790E\u79AE\u7A61\u7A62\u7A60\u7AC4\u7AC5\u7C2B\u7C27\u7C2A\u7C1E\u7C23\u7C21\u7CE7\u7E54\u7E55\u7E5E\u7E5A\u7E61\u7E52\u7E59\u7F48\u7FF9\u7FFB\u8077\u8076\u81CD\u81CF\u820A\u85CF\u85A9\u85CD\u85D0\u85C9\u85B0\u85BA\u85B9\u85A6\u87EF\u87EC\u87F2\u87E0\u8986\u89B2\u89F4\u8B28\u8B39\u8B2C\u8B2B\u8C50\u8D05\u8E59\u8E63\u8E66\u8E64\u8E5F\u8E55\u8EC0\u8F49\u8F4D\u9087\u9083\u9088\u91AB\u91AC\u91D0\u9394\u938A\u9396\u93A2\u93B3\u93AE\u93AC\u93B0\u9398\u939A\u9397\u95D4\u95D6\u95D0\u95D5\u96E2\u96DC\u96D9\u96DB\u96DE\u9724\u97A3\u97A6"
    ],
    [
        "c340",
        "\u97AD\u97F9\u984D\u984F\u984C\u984E\u9853\u98BA\u993E\u993F\u993D\u992E\u99A5\u9A0E\u9AC1\u9B03\u9B06\u9B4F\u9B4E\u9B4D\u9BCA\u9BC9\u9BFD\u9BC8\u9BC0\u9D51\u9D5D\u9D60\u9EE0\u9F15\u9F2C\u5133\u56A5\u58DE\u58DF\u58E2\u5BF5\u9F90\u5EEC\u61F2\u61F7\u61F6\u61F5\u6500\u650F\u66E0\u66DD\u6AE5\u6ADD\u6ADA\u6AD3\u701B\u701F\u7028\u701A\u701D\u7015\u7018\u7206\u720D\u7258\u72A2\u7378"
    ],
    [
        "c3a1",
        "\u737A\u74BD\u74CA\u74E3\u7587\u7586\u765F\u7661\u77C7\u7919\u79B1\u7A6B\u7A69\u7C3E\u7C3F\u7C38\u7C3D\u7C37\u7C40\u7E6B\u7E6D\u7E79\u7E69\u7E6A\u7F85\u7E73\u7FB6\u7FB9\u7FB8\u81D8\u85E9\u85DD\u85EA\u85D5\u85E4\u85E5\u85F7\u87FB\u8805\u880D\u87F9\u87FE\u8960\u895F\u8956\u895E\u8B41\u8B5C\u8B58\u8B49\u8B5A\u8B4E\u8B4F\u8B46\u8B59\u8D08\u8D0A\u8E7C\u8E72\u8E87\u8E76\u8E6C\u8E7A\u8E74\u8F54\u8F4E\u8FAD\u908A\u908B\u91B1\u91AE\u93E1\u93D1\u93DF\u93C3\u93C8\u93DC\u93DD\u93D6\u93E2\u93CD\u93D8\u93E4\u93D7\u93E8\u95DC\u96B4\u96E3\u972A\u9727\u9761\u97DC\u97FB\u985E"
    ],
    [
        "c440",
        "\u9858\u985B\u98BC\u9945\u9949\u9A16\u9A19\u9B0D\u9BE8\u9BE7\u9BD6\u9BDB\u9D89\u9D61\u9D72\u9D6A\u9D6C\u9E92\u9E97\u9E93\u9EB4\u52F8\u56A8\u56B7\u56B6\u56B4\u56BC\u58E4\u5B40\u5B43\u5B7D\u5BF6\u5DC9\u61F8\u61FA\u6518\u6514\u6519\u66E6\u6727\u6AEC\u703E\u7030\u7032\u7210\u737B\u74CF\u7662\u7665\u7926\u792A\u792C\u792B\u7AC7\u7AF6\u7C4C\u7C43\u7C4D\u7CEF\u7CF0\u8FAE\u7E7D\u7E7C"
    ],
    [
        "c4a1",
        "\u7E82\u7F4C\u8000\u81DA\u8266\u85FB\u85F9\u8611\u85FA\u8606\u860B\u8607\u860A\u8814\u8815\u8964\u89BA\u89F8\u8B70\u8B6C\u8B66\u8B6F\u8B5F\u8B6B\u8D0F\u8D0D\u8E89\u8E81\u8E85\u8E82\u91B4\u91CB\u9418\u9403\u93FD\u95E1\u9730\u98C4\u9952\u9951\u99A8\u9A2B\u9A30\u9A37\u9A35\u9C13\u9C0D\u9E79\u9EB5\u9EE8\u9F2F\u9F5F\u9F63\u9F61\u5137\u5138\u56C1\u56C0\u56C2\u5914\u5C6C\u5DCD\u61FC\u61FE\u651D\u651C\u6595\u66E9\u6AFB\u6B04\u6AFA\u6BB2\u704C\u721B\u72A7\u74D6\u74D4\u7669\u77D3\u7C50\u7E8F\u7E8C\u7FBC\u8617\u862D\u861A\u8823\u8822\u8821\u881F\u896A\u896C\u89BD\u8B74"
    ],
    [
        "c540",
        "\u8B77\u8B7D\u8D13\u8E8A\u8E8D\u8E8B\u8F5F\u8FAF\u91BA\u942E\u9433\u9435\u943A\u9438\u9432\u942B\u95E2\u9738\u9739\u9732\u97FF\u9867\u9865\u9957\u9A45\u9A43\u9A40\u9A3E\u9ACF\u9B54\u9B51\u9C2D\u9C25\u9DAF\u9DB4\u9DC2\u9DB8\u9E9D\u9EEF\u9F19\u9F5C\u9F66\u9F67\u513C\u513B\u56C8\u56CA\u56C9\u5B7F\u5DD4\u5DD2\u5F4E\u61FF\u6524\u6B0A\u6B61\u7051\u7058\u7380\u74E4\u758A\u766E\u766C"
    ],
    [
        "c5a1",
        "\u79B3\u7C60\u7C5F\u807E\u807D\u81DF\u8972\u896F\u89FC\u8B80\u8D16\u8D17\u8E91\u8E93\u8F61\u9148\u9444\u9451\u9452\u973D\u973E\u97C3\u97C1\u986B\u9955\u9A55\u9A4D\u9AD2\u9B1A\u9C49\u9C31\u9C3E\u9C3B\u9DD3\u9DD7\u9F34\u9F6C\u9F6A\u9F94\u56CC\u5DD6\u6200\u6523\u652B\u652A\u66EC\u6B10\u74DA\u7ACA\u7C64\u7C63\u7C65\u7E93\u7E96\u7E94\u81E2\u8638\u863F\u8831\u8B8A\u9090\u908F\u9463\u9460\u9464\u9768\u986F\u995C\u9A5A\u9A5B\u9A57\u9AD3\u9AD4\u9AD1\u9C54\u9C57\u9C56\u9DE5\u9E9F\u9EF4\u56D1\u58E9\u652C\u705E\u7671\u7672\u77D7\u7F50\u7F88\u8836\u8839\u8862\u8B93\u8B92"
    ],
    [
        "c640",
        "\u8B96\u8277\u8D1B\u91C0\u946A\u9742\u9748\u9744\u97C6\u9870\u9A5F\u9B22\u9B58\u9C5F\u9DF9\u9DFA\u9E7C\u9E7D\u9F07\u9F77\u9F72\u5EF3\u6B16\u7063\u7C6C\u7C6E\u883B\u89C0\u8EA1\u91C1\u9472\u9470\u9871\u995E\u9AD6\u9B23\u9ECC\u7064\u77DA\u8B9A\u9477\u97C9\u9A62\u9A65\u7E9C\u8B9C\u8EAA\u91C5\u947D\u947E\u947C\u9C77\u9C78\u9EF7\u8C54\u947F\u9E1A\u7228\u9A6A\u9B31\u9E1B\u9E1E\u7C72"
    ],
    [
        "c940",
        "\u4E42\u4E5C\u51F5\u531A\u5382\u4E07\u4E0C\u4E47\u4E8D\u56D7\uFA0C\u5C6E\u5F73\u4E0F\u5187\u4E0E\u4E2E\u4E93\u4EC2\u4EC9\u4EC8\u5198\u52FC\u536C\u53B9\u5720\u5903\u592C\u5C10\u5DFF\u65E1\u6BB3\u6BCC\u6C14\u723F\u4E31\u4E3C\u4EE8\u4EDC\u4EE9\u4EE1\u4EDD\u4EDA\u520C\u531C\u534C\u5722\u5723\u5917\u592F\u5B81\u5B84\u5C12\u5C3B\u5C74\u5C73\u5E04\u5E80\u5E82\u5FC9\u6209\u6250\u6C15"
    ],
    [
        "c9a1",
        "\u6C36\u6C43\u6C3F\u6C3B\u72AE\u72B0\u738A\u79B8\u808A\u961E\u4F0E\u4F18\u4F2C\u4EF5\u4F14\u4EF1\u4F00\u4EF7\u4F08\u4F1D\u4F02\u4F05\u4F22\u4F13\u4F04\u4EF4\u4F12\u51B1\u5213\u5209\u5210\u52A6\u5322\u531F\u534D\u538A\u5407\u56E1\u56DF\u572E\u572A\u5734\u593C\u5980\u597C\u5985\u597B\u597E\u5977\u597F\u5B56\u5C15\u5C25\u5C7C\u5C7A\u5C7B\u5C7E\u5DDF\u5E75\u5E84\u5F02\u5F1A\u5F74\u5FD5\u5FD4\u5FCF\u625C\u625E\u6264\u6261\u6266\u6262\u6259\u6260\u625A\u6265\u65EF\u65EE\u673E\u6739\u6738\u673B\u673A\u673F\u673C\u6733\u6C18\u6C46\u6C52\u6C5C\u6C4F\u6C4A\u6C54\u6C4B"
    ],
    [
        "ca40",
        "\u6C4C\u7071\u725E\u72B4\u72B5\u738E\u752A\u767F\u7A75\u7F51\u8278\u827C\u8280\u827D\u827F\u864D\u897E\u9099\u9097\u9098\u909B\u9094\u9622\u9624\u9620\u9623\u4F56\u4F3B\u4F62\u4F49\u4F53\u4F64\u4F3E\u4F67\u4F52\u4F5F\u4F41\u4F58\u4F2D\u4F33\u4F3F\u4F61\u518F\u51B9\u521C\u521E\u5221\u52AD\u52AE\u5309\u5363\u5372\u538E\u538F\u5430\u5437\u542A\u5454\u5445\u5419\u541C\u5425\u5418"
    ],
    [
        "caa1",
        "\u543D\u544F\u5441\u5428\u5424\u5447\u56EE\u56E7\u56E5\u5741\u5745\u574C\u5749\u574B\u5752\u5906\u5940\u59A6\u5998\u59A0\u5997\u598E\u59A2\u5990\u598F\u59A7\u59A1\u5B8E\u5B92\u5C28\u5C2A\u5C8D\u5C8F\u5C88\u5C8B\u5C89\u5C92\u5C8A\u5C86\u5C93\u5C95\u5DE0\u5E0A\u5E0E\u5E8B\u5E89\u5E8C\u5E88\u5E8D\u5F05\u5F1D\u5F78\u5F76\u5FD2\u5FD1\u5FD0\u5FED\u5FE8\u5FEE\u5FF3\u5FE1\u5FE4\u5FE3\u5FFA\u5FEF\u5FF7\u5FFB\u6000\u5FF4\u623A\u6283\u628C\u628E\u628F\u6294\u6287\u6271\u627B\u627A\u6270\u6281\u6288\u6277\u627D\u6272\u6274\u6537\u65F0\u65F4\u65F3\u65F2\u65F5\u6745\u6747"
    ],
    [
        "cb40",
        "\u6759\u6755\u674C\u6748\u675D\u674D\u675A\u674B\u6BD0\u6C19\u6C1A\u6C78\u6C67\u6C6B\u6C84\u6C8B\u6C8F\u6C71\u6C6F\u6C69\u6C9A\u6C6D\u6C87\u6C95\u6C9C\u6C66\u6C73\u6C65\u6C7B\u6C8E\u7074\u707A\u7263\u72BF\u72BD\u72C3\u72C6\u72C1\u72BA\u72C5\u7395\u7397\u7393\u7394\u7392\u753A\u7539\u7594\u7595\u7681\u793D\u8034\u8095\u8099\u8090\u8092\u809C\u8290\u828F\u8285\u828E\u8291\u8293"
    ],
    [
        "cba1",
        "\u828A\u8283\u8284\u8C78\u8FC9\u8FBF\u909F\u90A1\u90A5\u909E\u90A7\u90A0\u9630\u9628\u962F\u962D\u4E33\u4F98\u4F7C\u4F85\u4F7D\u4F80\u4F87\u4F76\u4F74\u4F89\u4F84\u4F77\u4F4C\u4F97\u4F6A\u4F9A\u4F79\u4F81\u4F78\u4F90\u4F9C\u4F94\u4F9E\u4F92\u4F82\u4F95\u4F6B\u4F6E\u519E\u51BC\u51BE\u5235\u5232\u5233\u5246\u5231\u52BC\u530A\u530B\u533C\u5392\u5394\u5487\u547F\u5481\u5491\u5482\u5488\u546B\u547A\u547E\u5465\u546C\u5474\u5466\u548D\u546F\u5461\u5460\u5498\u5463\u5467\u5464\u56F7\u56F9\u576F\u5772\u576D\u576B\u5771\u5770\u5776\u5780\u5775\u577B\u5773\u5774\u5762"
    ],
    [
        "cc40",
        "\u5768\u577D\u590C\u5945\u59B5\u59BA\u59CF\u59CE\u59B2\u59CC\u59C1\u59B6\u59BC\u59C3\u59D6\u59B1\u59BD\u59C0\u59C8\u59B4\u59C7\u5B62\u5B65\u5B93\u5B95\u5C44\u5C47\u5CAE\u5CA4\u5CA0\u5CB5\u5CAF\u5CA8\u5CAC\u5C9F\u5CA3\u5CAD\u5CA2\u5CAA\u5CA7\u5C9D\u5CA5\u5CB6\u5CB0\u5CA6\u5E17\u5E14\u5E19\u5F28\u5F22\u5F23\u5F24\u5F54\u5F82\u5F7E\u5F7D\u5FDE\u5FE5\u602D\u6026\u6019\u6032\u600B"
    ],
    [
        "cca1",
        "\u6034\u600A\u6017\u6033\u601A\u601E\u602C\u6022\u600D\u6010\u602E\u6013\u6011\u600C\u6009\u601C\u6214\u623D\u62AD\u62B4\u62D1\u62BE\u62AA\u62B6\u62CA\u62AE\u62B3\u62AF\u62BB\u62A9\u62B0\u62B8\u653D\u65A8\u65BB\u6609\u65FC\u6604\u6612\u6608\u65FB\u6603\u660B\u660D\u6605\u65FD\u6611\u6610\u66F6\u670A\u6785\u676C\u678E\u6792\u6776\u677B\u6798\u6786\u6784\u6774\u678D\u678C\u677A\u679F\u6791\u6799\u6783\u677D\u6781\u6778\u6779\u6794\u6B25\u6B80\u6B7E\u6BDE\u6C1D\u6C93\u6CEC\u6CEB\u6CEE\u6CD9\u6CB6\u6CD4\u6CAD\u6CE7\u6CB7\u6CD0\u6CC2\u6CBA\u6CC3\u6CC6\u6CED\u6CF2"
    ],
    [
        "cd40",
        "\u6CD2\u6CDD\u6CB4\u6C8A\u6C9D\u6C80\u6CDE\u6CC0\u6D30\u6CCD\u6CC7\u6CB0\u6CF9\u6CCF\u6CE9\u6CD1\u7094\u7098\u7085\u7093\u7086\u7084\u7091\u7096\u7082\u709A\u7083\u726A\u72D6\u72CB\u72D8\u72C9\u72DC\u72D2\u72D4\u72DA\u72CC\u72D1\u73A4\u73A1\u73AD\u73A6\u73A2\u73A0\u73AC\u739D\u74DD\u74E8\u753F\u7540\u753E\u758C\u7598\u76AF\u76F3\u76F1\u76F0\u76F5\u77F8\u77FC\u77F9\u77FB\u77FA"
    ],
    [
        "cda1",
        "\u77F7\u7942\u793F\u79C5\u7A78\u7A7B\u7AFB\u7C75\u7CFD\u8035\u808F\u80AE\u80A3\u80B8\u80B5\u80AD\u8220\u82A0\u82C0\u82AB\u829A\u8298\u829B\u82B5\u82A7\u82AE\u82BC\u829E\u82BA\u82B4\u82A8\u82A1\u82A9\u82C2\u82A4\u82C3\u82B6\u82A2\u8670\u866F\u866D\u866E\u8C56\u8FD2\u8FCB\u8FD3\u8FCD\u8FD6\u8FD5\u8FD7\u90B2\u90B4\u90AF\u90B3\u90B0\u9639\u963D\u963C\u963A\u9643\u4FCD\u4FC5\u4FD3\u4FB2\u4FC9\u4FCB\u4FC1\u4FD4\u4FDC\u4FD9\u4FBB\u4FB3\u4FDB\u4FC7\u4FD6\u4FBA\u4FC0\u4FB9\u4FEC\u5244\u5249\u52C0\u52C2\u533D\u537C\u5397\u5396\u5399\u5398\u54BA\u54A1\u54AD\u54A5\u54CF"
    ],
    [
        "ce40",
        "\u54C3\u830D\u54B7\u54AE\u54D6\u54B6\u54C5\u54C6\u54A0\u5470\u54BC\u54A2\u54BE\u5472\u54DE\u54B0\u57B5\u579E\u579F\u57A4\u578C\u5797\u579D\u579B\u5794\u5798\u578F\u5799\u57A5\u579A\u5795\u58F4\u590D\u5953\u59E1\u59DE\u59EE\u5A00\u59F1\u59DD\u59FA\u59FD\u59FC\u59F6\u59E4\u59F2\u59F7\u59DB\u59E9\u59F3\u59F5\u59E0\u59FE\u59F4\u59ED\u5BA8\u5C4C\u5CD0\u5CD8\u5CCC\u5CD7\u5CCB\u5CDB"
    ],
    [
        "cea1",
        "\u5CDE\u5CDA\u5CC9\u5CC7\u5CCA\u5CD6\u5CD3\u5CD4\u5CCF\u5CC8\u5CC6\u5CCE\u5CDF\u5CF8\u5DF9\u5E21\u5E22\u5E23\u5E20\u5E24\u5EB0\u5EA4\u5EA2\u5E9B\u5EA3\u5EA5\u5F07\u5F2E\u5F56\u5F86\u6037\u6039\u6054\u6072\u605E\u6045\u6053\u6047\u6049\u605B\u604C\u6040\u6042\u605F\u6024\u6044\u6058\u6066\u606E\u6242\u6243\u62CF\u630D\u630B\u62F5\u630E\u6303\u62EB\u62F9\u630F\u630C\u62F8\u62F6\u6300\u6313\u6314\u62FA\u6315\u62FB\u62F0\u6541\u6543\u65AA\u65BF\u6636\u6621\u6632\u6635\u661C\u6626\u6622\u6633\u662B\u663A\u661D\u6634\u6639\u662E\u670F\u6710\u67C1\u67F2\u67C8\u67BA"
    ],
    [
        "cf40",
        "\u67DC\u67BB\u67F8\u67D8\u67C0\u67B7\u67C5\u67EB\u67E4\u67DF\u67B5\u67CD\u67B3\u67F7\u67F6\u67EE\u67E3\u67C2\u67B9\u67CE\u67E7\u67F0\u67B2\u67FC\u67C6\u67ED\u67CC\u67AE\u67E6\u67DB\u67FA\u67C9\u67CA\u67C3\u67EA\u67CB\u6B28\u6B82\u6B84\u6BB6\u6BD6\u6BD8\u6BE0\u6C20\u6C21\u6D28\u6D34\u6D2D\u6D1F\u6D3C\u6D3F\u6D12\u6D0A\u6CDA\u6D33\u6D04\u6D19\u6D3A\u6D1A\u6D11\u6D00\u6D1D\u6D42"
    ],
    [
        "cfa1",
        "\u6D01\u6D18\u6D37\u6D03\u6D0F\u6D40\u6D07\u6D20\u6D2C\u6D08\u6D22\u6D09\u6D10\u70B7\u709F\u70BE\u70B1\u70B0\u70A1\u70B4\u70B5\u70A9\u7241\u7249\u724A\u726C\u7270\u7273\u726E\u72CA\u72E4\u72E8\u72EB\u72DF\u72EA\u72E6\u72E3\u7385\u73CC\u73C2\u73C8\u73C5\u73B9\u73B6\u73B5\u73B4\u73EB\u73BF\u73C7\u73BE\u73C3\u73C6\u73B8\u73CB\u74EC\u74EE\u752E\u7547\u7548\u75A7\u75AA\u7679\u76C4\u7708\u7703\u7704\u7705\u770A\u76F7\u76FB\u76FA\u77E7\u77E8\u7806\u7811\u7812\u7805\u7810\u780F\u780E\u7809\u7803\u7813\u794A\u794C\u794B\u7945\u7944\u79D5\u79CD\u79CF\u79D6\u79CE\u7A80"
    ],
    [
        "d040",
        "\u7A7E\u7AD1\u7B00\u7B01\u7C7A\u7C78\u7C79\u7C7F\u7C80\u7C81\u7D03\u7D08\u7D01\u7F58\u7F91\u7F8D\u7FBE\u8007\u800E\u800F\u8014\u8037\u80D8\u80C7\u80E0\u80D1\u80C8\u80C2\u80D0\u80C5\u80E3\u80D9\u80DC\u80CA\u80D5\u80C9\u80CF\u80D7\u80E6\u80CD\u81FF\u8221\u8294\u82D9\u82FE\u82F9\u8307\u82E8\u8300\u82D5\u833A\u82EB\u82D6\u82F4\u82EC\u82E1\u82F2\u82F5\u830C\u82FB\u82F6\u82F0\u82EA"
    ],
    [
        "d0a1",
        "\u82E4\u82E0\u82FA\u82F3\u82ED\u8677\u8674\u867C\u8673\u8841\u884E\u8867\u886A\u8869\u89D3\u8A04\u8A07\u8D72\u8FE3\u8FE1\u8FEE\u8FE0\u90F1\u90BD\u90BF\u90D5\u90C5\u90BE\u90C7\u90CB\u90C8\u91D4\u91D3\u9654\u964F\u9651\u9653\u964A\u964E\u501E\u5005\u5007\u5013\u5022\u5030\u501B\u4FF5\u4FF4\u5033\u5037\u502C\u4FF6\u4FF7\u5017\u501C\u5020\u5027\u5035\u502F\u5031\u500E\u515A\u5194\u5193\u51CA\u51C4\u51C5\u51C8\u51CE\u5261\u525A\u5252\u525E\u525F\u5255\u5262\u52CD\u530E\u539E\u5526\u54E2\u5517\u5512\u54E7\u54F3\u54E4\u551A\u54FF\u5504\u5508\u54EB\u5511\u5505\u54F1"
    ],
    [
        "d140",
        "\u550A\u54FB\u54F7\u54F8\u54E0\u550E\u5503\u550B\u5701\u5702\u57CC\u5832\u57D5\u57D2\u57BA\u57C6\u57BD\u57BC\u57B8\u57B6\u57BF\u57C7\u57D0\u57B9\u57C1\u590E\u594A\u5A19\u5A16\u5A2D\u5A2E\u5A15\u5A0F\u5A17\u5A0A\u5A1E\u5A33\u5B6C\u5BA7\u5BAD\u5BAC\u5C03\u5C56\u5C54\u5CEC\u5CFF\u5CEE\u5CF1\u5CF7\u5D00\u5CF9\u5E29\u5E28\u5EA8\u5EAE\u5EAA\u5EAC\u5F33\u5F30\u5F67\u605D\u605A\u6067"
    ],
    [
        "d1a1",
        "\u6041\u60A2\u6088\u6080\u6092\u6081\u609D\u6083\u6095\u609B\u6097\u6087\u609C\u608E\u6219\u6246\u62F2\u6310\u6356\u632C\u6344\u6345\u6336\u6343\u63E4\u6339\u634B\u634A\u633C\u6329\u6341\u6334\u6358\u6354\u6359\u632D\u6347\u6333\u635A\u6351\u6338\u6357\u6340\u6348\u654A\u6546\u65C6\u65C3\u65C4\u65C2\u664A\u665F\u6647\u6651\u6712\u6713\u681F\u681A\u6849\u6832\u6833\u683B\u684B\u684F\u6816\u6831\u681C\u6835\u682B\u682D\u682F\u684E\u6844\u6834\u681D\u6812\u6814\u6826\u6828\u682E\u684D\u683A\u6825\u6820\u6B2C\u6B2F\u6B2D\u6B31\u6B34\u6B6D\u8082\u6B88\u6BE6\u6BE4"
    ],
    [
        "d240",
        "\u6BE8\u6BE3\u6BE2\u6BE7\u6C25\u6D7A\u6D63\u6D64\u6D76\u6D0D\u6D61\u6D92\u6D58\u6D62\u6D6D\u6D6F\u6D91\u6D8D\u6DEF\u6D7F\u6D86\u6D5E\u6D67\u6D60\u6D97\u6D70\u6D7C\u6D5F\u6D82\u6D98\u6D2F\u6D68\u6D8B\u6D7E\u6D80\u6D84\u6D16\u6D83\u6D7B\u6D7D\u6D75\u6D90\u70DC\u70D3\u70D1\u70DD\u70CB\u7F39\u70E2\u70D7\u70D2\u70DE\u70E0\u70D4\u70CD\u70C5\u70C6\u70C7\u70DA\u70CE\u70E1\u7242\u7278"
    ],
    [
        "d2a1",
        "\u7277\u7276\u7300\u72FA\u72F4\u72FE\u72F6\u72F3\u72FB\u7301\u73D3\u73D9\u73E5\u73D6\u73BC\u73E7\u73E3\u73E9\u73DC\u73D2\u73DB\u73D4\u73DD\u73DA\u73D7\u73D8\u73E8\u74DE\u74DF\u74F4\u74F5\u7521\u755B\u755F\u75B0\u75C1\u75BB\u75C4\u75C0\u75BF\u75B6\u75BA\u768A\u76C9\u771D\u771B\u7710\u7713\u7712\u7723\u7711\u7715\u7719\u771A\u7722\u7727\u7823\u782C\u7822\u7835\u782F\u7828\u782E\u782B\u7821\u7829\u7833\u782A\u7831\u7954\u795B\u794F\u795C\u7953\u7952\u7951\u79EB\u79EC\u79E0\u79EE\u79ED\u79EA\u79DC\u79DE\u79DD\u7A86\u7A89\u7A85\u7A8B\u7A8C\u7A8A\u7A87\u7AD8\u7B10"
    ],
    [
        "d340",
        "\u7B04\u7B13\u7B05\u7B0F\u7B08\u7B0A\u7B0E\u7B09\u7B12\u7C84\u7C91\u7C8A\u7C8C\u7C88\u7C8D\u7C85\u7D1E\u7D1D\u7D11\u7D0E\u7D18\u7D16\u7D13\u7D1F\u7D12\u7D0F\u7D0C\u7F5C\u7F61\u7F5E\u7F60\u7F5D\u7F5B\u7F96\u7F92\u7FC3\u7FC2\u7FC0\u8016\u803E\u8039\u80FA\u80F2\u80F9\u80F5\u8101\u80FB\u8100\u8201\u822F\u8225\u8333\u832D\u8344\u8319\u8351\u8325\u8356\u833F\u8341\u8326\u831C\u8322"
    ],
    [
        "d3a1",
        "\u8342\u834E\u831B\u832A\u8308\u833C\u834D\u8316\u8324\u8320\u8337\u832F\u8329\u8347\u8345\u834C\u8353\u831E\u832C\u834B\u8327\u8348\u8653\u8652\u86A2\u86A8\u8696\u868D\u8691\u869E\u8687\u8697\u8686\u868B\u869A\u8685\u86A5\u8699\u86A1\u86A7\u8695\u8698\u868E\u869D\u8690\u8694\u8843\u8844\u886D\u8875\u8876\u8872\u8880\u8871\u887F\u886F\u8883\u887E\u8874\u887C\u8A12\u8C47\u8C57\u8C7B\u8CA4\u8CA3\u8D76\u8D78\u8DB5\u8DB7\u8DB6\u8ED1\u8ED3\u8FFE\u8FF5\u9002\u8FFF\u8FFB\u9004\u8FFC\u8FF6\u90D6\u90E0\u90D9\u90DA\u90E3\u90DF\u90E5\u90D8\u90DB\u90D7\u90DC\u90E4\u9150"
    ],
    [
        "d440",
        "\u914E\u914F\u91D5\u91E2\u91DA\u965C\u965F\u96BC\u98E3\u9ADF\u9B2F\u4E7F\u5070\u506A\u5061\u505E\u5060\u5053\u504B\u505D\u5072\u5048\u504D\u5041\u505B\u504A\u5062\u5015\u5045\u505F\u5069\u506B\u5063\u5064\u5046\u5040\u506E\u5073\u5057\u5051\u51D0\u526B\u526D\u526C\u526E\u52D6\u52D3\u532D\u539C\u5575\u5576\u553C\u554D\u5550\u5534\u552A\u5551\u5562\u5536\u5535\u5530\u5552\u5545"
    ],
    [
        "d4a1",
        "\u550C\u5532\u5565\u554E\u5539\u5548\u552D\u553B\u5540\u554B\u570A\u5707\u57FB\u5814\u57E2\u57F6\u57DC\u57F4\u5800\u57ED\u57FD\u5808\u57F8\u580B\u57F3\u57CF\u5807\u57EE\u57E3\u57F2\u57E5\u57EC\u57E1\u580E\u57FC\u5810\u57E7\u5801\u580C\u57F1\u57E9\u57F0\u580D\u5804\u595C\u5A60\u5A58\u5A55\u5A67\u5A5E\u5A38\u5A35\u5A6D\u5A50\u5A5F\u5A65\u5A6C\u5A53\u5A64\u5A57\u5A43\u5A5D\u5A52\u5A44\u5A5B\u5A48\u5A8E\u5A3E\u5A4D\u5A39\u5A4C\u5A70\u5A69\u5A47\u5A51\u5A56\u5A42\u5A5C\u5B72\u5B6E\u5BC1\u5BC0\u5C59\u5D1E\u5D0B\u5D1D\u5D1A\u5D20\u5D0C\u5D28\u5D0D\u5D26\u5D25\u5D0F"
    ],
    [
        "d540",
        "\u5D30\u5D12\u5D23\u5D1F\u5D2E\u5E3E\u5E34\u5EB1\u5EB4\u5EB9\u5EB2\u5EB3\u5F36\u5F38\u5F9B\u5F96\u5F9F\u608A\u6090\u6086\u60BE\u60B0\u60BA\u60D3\u60D4\u60CF\u60E4\u60D9\u60DD\u60C8\u60B1\u60DB\u60B7\u60CA\u60BF\u60C3\u60CD\u60C0\u6332\u6365\u638A\u6382\u637D\u63BD\u639E\u63AD\u639D\u6397\u63AB\u638E\u636F\u6387\u6390\u636E\u63AF\u6375\u639C\u636D\u63AE\u637C\u63A4\u633B\u639F"
    ],
    [
        "d5a1",
        "\u6378\u6385\u6381\u6391\u638D\u6370\u6553\u65CD\u6665\u6661\u665B\u6659\u665C\u6662\u6718\u6879\u6887\u6890\u689C\u686D\u686E\u68AE\u68AB\u6956\u686F\u68A3\u68AC\u68A9\u6875\u6874\u68B2\u688F\u6877\u6892\u687C\u686B\u6872\u68AA\u6880\u6871\u687E\u689B\u6896\u688B\u68A0\u6889\u68A4\u6878\u687B\u6891\u688C\u688A\u687D\u6B36\u6B33\u6B37\u6B38\u6B91\u6B8F\u6B8D\u6B8E\u6B8C\u6C2A\u6DC0\u6DAB\u6DB4\u6DB3\u6E74\u6DAC\u6DE9\u6DE2\u6DB7\u6DF6\u6DD4\u6E00\u6DC8\u6DE0\u6DDF\u6DD6\u6DBE\u6DE5\u6DDC\u6DDD\u6DDB\u6DF4\u6DCA\u6DBD\u6DED\u6DF0\u6DBA\u6DD5\u6DC2\u6DCF\u6DC9"
    ],
    [
        "d640",
        "\u6DD0\u6DF2\u6DD3\u6DFD\u6DD7\u6DCD\u6DE3\u6DBB\u70FA\u710D\u70F7\u7117\u70F4\u710C\u70F0\u7104\u70F3\u7110\u70FC\u70FF\u7106\u7113\u7100\u70F8\u70F6\u710B\u7102\u710E\u727E\u727B\u727C\u727F\u731D\u7317\u7307\u7311\u7318\u730A\u7308\u72FF\u730F\u731E\u7388\u73F6\u73F8\u73F5\u7404\u7401\u73FD\u7407\u7400\u73FA\u73FC\u73FF\u740C\u740B\u73F4\u7408\u7564\u7563\u75CE\u75D2\u75CF"
    ],
    [
        "d6a1",
        "\u75CB\u75CC\u75D1\u75D0\u768F\u7689\u76D3\u7739\u772F\u772D\u7731\u7732\u7734\u7733\u773D\u7725\u773B\u7735\u7848\u7852\u7849\u784D\u784A\u784C\u7826\u7845\u7850\u7964\u7967\u7969\u796A\u7963\u796B\u7961\u79BB\u79FA\u79F8\u79F6\u79F7\u7A8F\u7A94\u7A90\u7B35\u7B47\u7B34\u7B25\u7B30\u7B22\u7B24\u7B33\u7B18\u7B2A\u7B1D\u7B31\u7B2B\u7B2D\u7B2F\u7B32\u7B38\u7B1A\u7B23\u7C94\u7C98\u7C96\u7CA3\u7D35\u7D3D\u7D38\u7D36\u7D3A\u7D45\u7D2C\u7D29\u7D41\u7D47\u7D3E\u7D3F\u7D4A\u7D3B\u7D28\u7F63\u7F95\u7F9C\u7F9D\u7F9B\u7FCA\u7FCB\u7FCD\u7FD0\u7FD1\u7FC7\u7FCF\u7FC9\u801F"
    ],
    [
        "d740",
        "\u801E\u801B\u8047\u8043\u8048\u8118\u8125\u8119\u811B\u812D\u811F\u812C\u811E\u8121\u8115\u8127\u811D\u8122\u8211\u8238\u8233\u823A\u8234\u8232\u8274\u8390\u83A3\u83A8\u838D\u837A\u8373\u83A4\u8374\u838F\u8381\u8395\u8399\u8375\u8394\u83A9\u837D\u8383\u838C\u839D\u839B\u83AA\u838B\u837E\u83A5\u83AF\u8388\u8397\u83B0\u837F\u83A6\u8387\u83AE\u8376\u839A\u8659\u8656\u86BF\u86B7"
    ],
    [
        "d7a1",
        "\u86C2\u86C1\u86C5\u86BA\u86B0\u86C8\u86B9\u86B3\u86B8\u86CC\u86B4\u86BB\u86BC\u86C3\u86BD\u86BE\u8852\u8889\u8895\u88A8\u88A2\u88AA\u889A\u8891\u88A1\u889F\u8898\u88A7\u8899\u889B\u8897\u88A4\u88AC\u888C\u8893\u888E\u8982\u89D6\u89D9\u89D5\u8A30\u8A27\u8A2C\u8A1E\u8C39\u8C3B\u8C5C\u8C5D\u8C7D\u8CA5\u8D7D\u8D7B\u8D79\u8DBC\u8DC2\u8DB9\u8DBF\u8DC1\u8ED8\u8EDE\u8EDD\u8EDC\u8ED7\u8EE0\u8EE1\u9024\u900B\u9011\u901C\u900C\u9021\u90EF\u90EA\u90F0\u90F4\u90F2\u90F3\u90D4\u90EB\u90EC\u90E9\u9156\u9158\u915A\u9153\u9155\u91EC\u91F4\u91F1\u91F3\u91F8\u91E4\u91F9\u91EA"
    ],
    [
        "d840",
        "\u91EB\u91F7\u91E8\u91EE\u957A\u9586\u9588\u967C\u966D\u966B\u9671\u966F\u96BF\u976A\u9804\u98E5\u9997\u509B\u5095\u5094\u509E\u508B\u50A3\u5083\u508C\u508E\u509D\u5068\u509C\u5092\u5082\u5087\u515F\u51D4\u5312\u5311\u53A4\u53A7\u5591\u55A8\u55A5\u55AD\u5577\u5645\u55A2\u5593\u5588\u558F\u55B5\u5581\u55A3\u5592\u55A4\u557D\u558C\u55A6\u557F\u5595\u55A1\u558E\u570C\u5829\u5837"
    ],
    [
        "d8a1",
        "\u5819\u581E\u5827\u5823\u5828\u57F5\u5848\u5825\u581C\u581B\u5833\u583F\u5836\u582E\u5839\u5838\u582D\u582C\u583B\u5961\u5AAF\u5A94\u5A9F\u5A7A\u5AA2\u5A9E\u5A78\u5AA6\u5A7C\u5AA5\u5AAC\u5A95\u5AAE\u5A37\u5A84\u5A8A\u5A97\u5A83\u5A8B\u5AA9\u5A7B\u5A7D\u5A8C\u5A9C\u5A8F\u5A93\u5A9D\u5BEA\u5BCD\u5BCB\u5BD4\u5BD1\u5BCA\u5BCE\u5C0C\u5C30\u5D37\u5D43\u5D6B\u5D41\u5D4B\u5D3F\u5D35\u5D51\u5D4E\u5D55\u5D33\u5D3A\u5D52\u5D3D\u5D31\u5D59\u5D42\u5D39\u5D49\u5D38\u5D3C\u5D32\u5D36\u5D40\u5D45\u5E44\u5E41\u5F58\u5FA6\u5FA5\u5FAB\u60C9\u60B9\u60CC\u60E2\u60CE\u60C4\u6114"
    ],
    [
        "d940",
        "\u60F2\u610A\u6116\u6105\u60F5\u6113\u60F8\u60FC\u60FE\u60C1\u6103\u6118\u611D\u6110\u60FF\u6104\u610B\u624A\u6394\u63B1\u63B0\u63CE\u63E5\u63E8\u63EF\u63C3\u649D\u63F3\u63CA\u63E0\u63F6\u63D5\u63F2\u63F5\u6461\u63DF\u63BE\u63DD\u63DC\u63C4\u63D8\u63D3\u63C2\u63C7\u63CC\u63CB\u63C8\u63F0\u63D7\u63D9\u6532\u6567\u656A\u6564\u655C\u6568\u6565\u658C\u659D\u659E\u65AE\u65D0\u65D2"
    ],
    [
        "d9a1",
        "\u667C\u666C\u667B\u6680\u6671\u6679\u666A\u6672\u6701\u690C\u68D3\u6904\u68DC\u692A\u68EC\u68EA\u68F1\u690F\u68D6\u68F7\u68EB\u68E4\u68F6\u6913\u6910\u68F3\u68E1\u6907\u68CC\u6908\u6970\u68B4\u6911\u68EF\u68C6\u6914\u68F8\u68D0\u68FD\u68FC\u68E8\u690B\u690A\u6917\u68CE\u68C8\u68DD\u68DE\u68E6\u68F4\u68D1\u6906\u68D4\u68E9\u6915\u6925\u68C7\u6B39\u6B3B\u6B3F\u6B3C\u6B94\u6B97\u6B99\u6B95\u6BBD\u6BF0\u6BF2\u6BF3\u6C30\u6DFC\u6E46\u6E47\u6E1F\u6E49\u6E88\u6E3C\u6E3D\u6E45\u6E62\u6E2B\u6E3F\u6E41\u6E5D\u6E73\u6E1C\u6E33\u6E4B\u6E40\u6E51\u6E3B\u6E03\u6E2E\u6E5E"
    ],
    [
        "da40",
        "\u6E68\u6E5C\u6E61\u6E31\u6E28\u6E60\u6E71\u6E6B\u6E39\u6E22\u6E30\u6E53\u6E65\u6E27\u6E78\u6E64\u6E77\u6E55\u6E79\u6E52\u6E66\u6E35\u6E36\u6E5A\u7120\u711E\u712F\u70FB\u712E\u7131\u7123\u7125\u7122\u7132\u711F\u7128\u713A\u711B\u724B\u725A\u7288\u7289\u7286\u7285\u728B\u7312\u730B\u7330\u7322\u7331\u7333\u7327\u7332\u732D\u7326\u7323\u7335\u730C\u742E\u742C\u7430\u742B\u7416"
    ],
    [
        "daa1",
        "\u741A\u7421\u742D\u7431\u7424\u7423\u741D\u7429\u7420\u7432\u74FB\u752F\u756F\u756C\u75E7\u75DA\u75E1\u75E6\u75DD\u75DF\u75E4\u75D7\u7695\u7692\u76DA\u7746\u7747\u7744\u774D\u7745\u774A\u774E\u774B\u774C\u77DE\u77EC\u7860\u7864\u7865\u785C\u786D\u7871\u786A\u786E\u7870\u7869\u7868\u785E\u7862\u7974\u7973\u7972\u7970\u7A02\u7A0A\u7A03\u7A0C\u7A04\u7A99\u7AE6\u7AE4\u7B4A\u7B3B\u7B44\u7B48\u7B4C\u7B4E\u7B40\u7B58\u7B45\u7CA2\u7C9E\u7CA8\u7CA1\u7D58\u7D6F\u7D63\u7D53\u7D56\u7D67\u7D6A\u7D4F\u7D6D\u7D5C\u7D6B\u7D52\u7D54\u7D69\u7D51\u7D5F\u7D4E\u7F3E\u7F3F\u7F65"
    ],
    [
        "db40",
        "\u7F66\u7FA2\u7FA0\u7FA1\u7FD7\u8051\u804F\u8050\u80FE\u80D4\u8143\u814A\u8152\u814F\u8147\u813D\u814D\u813A\u81E6\u81EE\u81F7\u81F8\u81F9\u8204\u823C\u823D\u823F\u8275\u833B\u83CF\u83F9\u8423\u83C0\u83E8\u8412\u83E7\u83E4\u83FC\u83F6\u8410\u83C6\u83C8\u83EB\u83E3\u83BF\u8401\u83DD\u83E5\u83D8\u83FF\u83E1\u83CB\u83CE\u83D6\u83F5\u83C9\u8409\u840F\u83DE\u8411\u8406\u83C2\u83F3"
    ],
    [
        "dba1",
        "\u83D5\u83FA\u83C7\u83D1\u83EA\u8413\u83C3\u83EC\u83EE\u83C4\u83FB\u83D7\u83E2\u841B\u83DB\u83FE\u86D8\u86E2\u86E6\u86D3\u86E3\u86DA\u86EA\u86DD\u86EB\u86DC\u86EC\u86E9\u86D7\u86E8\u86D1\u8848\u8856\u8855\u88BA\u88D7\u88B9\u88B8\u88C0\u88BE\u88B6\u88BC\u88B7\u88BD\u88B2\u8901\u88C9\u8995\u8998\u8997\u89DD\u89DA\u89DB\u8A4E\u8A4D\u8A39\u8A59\u8A40\u8A57\u8A58\u8A44\u8A45\u8A52\u8A48\u8A51\u8A4A\u8A4C\u8A4F\u8C5F\u8C81\u8C80\u8CBA\u8CBE\u8CB0\u8CB9\u8CB5\u8D84\u8D80\u8D89\u8DD8\u8DD3\u8DCD\u8DC7\u8DD6\u8DDC\u8DCF\u8DD5\u8DD9\u8DC8\u8DD7\u8DC5\u8EEF\u8EF7\u8EFA"
    ],
    [
        "dc40",
        "\u8EF9\u8EE6\u8EEE\u8EE5\u8EF5\u8EE7\u8EE8\u8EF6\u8EEB\u8EF1\u8EEC\u8EF4\u8EE9\u902D\u9034\u902F\u9106\u912C\u9104\u90FF\u90FC\u9108\u90F9\u90FB\u9101\u9100\u9107\u9105\u9103\u9161\u9164\u915F\u9162\u9160\u9201\u920A\u9225\u9203\u921A\u9226\u920F\u920C\u9200\u9212\u91FF\u91FD\u9206\u9204\u9227\u9202\u921C\u9224\u9219\u9217\u9205\u9216\u957B\u958D\u958C\u9590\u9687\u967E\u9688"
    ],
    [
        "dca1",
        "\u9689\u9683\u9680\u96C2\u96C8\u96C3\u96F1\u96F0\u976C\u9770\u976E\u9807\u98A9\u98EB\u9CE6\u9EF9\u4E83\u4E84\u4EB6\u50BD\u50BF\u50C6\u50AE\u50C4\u50CA\u50B4\u50C8\u50C2\u50B0\u50C1\u50BA\u50B1\u50CB\u50C9\u50B6\u50B8\u51D7\u527A\u5278\u527B\u527C\u55C3\u55DB\u55CC\u55D0\u55CB\u55CA\u55DD\u55C0\u55D4\u55C4\u55E9\u55BF\u55D2\u558D\u55CF\u55D5\u55E2\u55D6\u55C8\u55F2\u55CD\u55D9\u55C2\u5714\u5853\u5868\u5864\u584F\u584D\u5849\u586F\u5855\u584E\u585D\u5859\u5865\u585B\u583D\u5863\u5871\u58FC\u5AC7\u5AC4\u5ACB\u5ABA\u5AB8\u5AB1\u5AB5\u5AB0\u5ABF\u5AC8\u5ABB\u5AC6"
    ],
    [
        "dd40",
        "\u5AB7\u5AC0\u5ACA\u5AB4\u5AB6\u5ACD\u5AB9\u5A90\u5BD6\u5BD8\u5BD9\u5C1F\u5C33\u5D71\u5D63\u5D4A\u5D65\u5D72\u5D6C\u5D5E\u5D68\u5D67\u5D62\u5DF0\u5E4F\u5E4E\u5E4A\u5E4D\u5E4B\u5EC5\u5ECC\u5EC6\u5ECB\u5EC7\u5F40\u5FAF\u5FAD\u60F7\u6149\u614A\u612B\u6145\u6136\u6132\u612E\u6146\u612F\u614F\u6129\u6140\u6220\u9168\u6223\u6225\u6224\u63C5\u63F1\u63EB\u6410\u6412\u6409\u6420\u6424"
    ],
    [
        "dda1",
        "\u6433\u6443\u641F\u6415\u6418\u6439\u6437\u6422\u6423\u640C\u6426\u6430\u6428\u6441\u6435\u642F\u640A\u641A\u6440\u6425\u6427\u640B\u63E7\u641B\u642E\u6421\u640E\u656F\u6592\u65D3\u6686\u668C\u6695\u6690\u668B\u668A\u6699\u6694\u6678\u6720\u6966\u695F\u6938\u694E\u6962\u6971\u693F\u6945\u696A\u6939\u6942\u6957\u6959\u697A\u6948\u6949\u6935\u696C\u6933\u693D\u6965\u68F0\u6978\u6934\u6969\u6940\u696F\u6944\u6976\u6958\u6941\u6974\u694C\u693B\u694B\u6937\u695C\u694F\u6951\u6932\u6952\u692F\u697B\u693C\u6B46\u6B45\u6B43\u6B42\u6B48\u6B41\u6B9B\uFA0D\u6BFB\u6BFC"
    ],
    [
        "de40",
        "\u6BF9\u6BF7\u6BF8\u6E9B\u6ED6\u6EC8\u6E8F\u6EC0\u6E9F\u6E93\u6E94\u6EA0\u6EB1\u6EB9\u6EC6\u6ED2\u6EBD\u6EC1\u6E9E\u6EC9\u6EB7\u6EB0\u6ECD\u6EA6\u6ECF\u6EB2\u6EBE\u6EC3\u6EDC\u6ED8\u6E99\u6E92\u6E8E\u6E8D\u6EA4\u6EA1\u6EBF\u6EB3\u6ED0\u6ECA\u6E97\u6EAE\u6EA3\u7147\u7154\u7152\u7163\u7160\u7141\u715D\u7162\u7172\u7178\u716A\u7161\u7142\u7158\u7143\u714B\u7170\u715F\u7150\u7153"
    ],
    [
        "dea1",
        "\u7144\u714D\u715A\u724F\u728D\u728C\u7291\u7290\u728E\u733C\u7342\u733B\u733A\u7340\u734A\u7349\u7444\u744A\u744B\u7452\u7451\u7457\u7440\u744F\u7450\u744E\u7442\u7446\u744D\u7454\u74E1\u74FF\u74FE\u74FD\u751D\u7579\u7577\u6983\u75EF\u760F\u7603\u75F7\u75FE\u75FC\u75F9\u75F8\u7610\u75FB\u75F6\u75ED\u75F5\u75FD\u7699\u76B5\u76DD\u7755\u775F\u7760\u7752\u7756\u775A\u7769\u7767\u7754\u7759\u776D\u77E0\u7887\u789A\u7894\u788F\u7884\u7895\u7885\u7886\u78A1\u7883\u7879\u7899\u7880\u7896\u787B\u797C\u7982\u797D\u7979\u7A11\u7A18\u7A19\u7A12\u7A17\u7A15\u7A22\u7A13"
    ],
    [
        "df40",
        "\u7A1B\u7A10\u7AA3\u7AA2\u7A9E\u7AEB\u7B66\u7B64\u7B6D\u7B74\u7B69\u7B72\u7B65\u7B73\u7B71\u7B70\u7B61\u7B78\u7B76\u7B63\u7CB2\u7CB4\u7CAF\u7D88\u7D86\u7D80\u7D8D\u7D7F\u7D85\u7D7A\u7D8E\u7D7B\u7D83\u7D7C\u7D8C\u7D94\u7D84\u7D7D\u7D92\u7F6D\u7F6B\u7F67\u7F68\u7F6C\u7FA6\u7FA5\u7FA7\u7FDB\u7FDC\u8021\u8164\u8160\u8177\u815C\u8169\u815B\u8162\u8172\u6721\u815E\u8176\u8167\u816F"
    ],
    [
        "dfa1",
        "\u8144\u8161\u821D\u8249\u8244\u8240\u8242\u8245\u84F1\u843F\u8456\u8476\u8479\u848F\u848D\u8465\u8451\u8440\u8486\u8467\u8430\u844D\u847D\u845A\u8459\u8474\u8473\u845D\u8507\u845E\u8437\u843A\u8434\u847A\u8443\u8478\u8432\u8445\u8429\u83D9\u844B\u842F\u8442\u842D\u845F\u8470\u8439\u844E\u844C\u8452\u846F\u84C5\u848E\u843B\u8447\u8436\u8433\u8468\u847E\u8444\u842B\u8460\u8454\u846E\u8450\u870B\u8704\u86F7\u870C\u86FA\u86D6\u86F5\u874D\u86F8\u870E\u8709\u8701\u86F6\u870D\u8705\u88D6\u88CB\u88CD\u88CE\u88DE\u88DB\u88DA\u88CC\u88D0\u8985\u899B\u89DF\u89E5\u89E4"
    ],
    [
        "e040",
        "\u89E1\u89E0\u89E2\u89DC\u89E6\u8A76\u8A86\u8A7F\u8A61\u8A3F\u8A77\u8A82\u8A84\u8A75\u8A83\u8A81\u8A74\u8A7A\u8C3C\u8C4B\u8C4A\u8C65\u8C64\u8C66\u8C86\u8C84\u8C85\u8CCC\u8D68\u8D69\u8D91\u8D8C\u8D8E\u8D8F\u8D8D\u8D93\u8D94\u8D90\u8D92\u8DF0\u8DE0\u8DEC\u8DF1\u8DEE\u8DD0\u8DE9\u8DE3\u8DE2\u8DE7\u8DF2\u8DEB\u8DF4\u8F06\u8EFF\u8F01\u8F00\u8F05\u8F07\u8F08\u8F02\u8F0B\u9052\u903F"
    ],
    [
        "e0a1",
        "\u9044\u9049\u903D\u9110\u910D\u910F\u9111\u9116\u9114\u910B\u910E\u916E\u916F\u9248\u9252\u9230\u923A\u9266\u9233\u9265\u925E\u9283\u922E\u924A\u9246\u926D\u926C\u924F\u9260\u9267\u926F\u9236\u9261\u9270\u9231\u9254\u9263\u9250\u9272\u924E\u9253\u924C\u9256\u9232\u959F\u959C\u959E\u959B\u9692\u9693\u9691\u9697\u96CE\u96FA\u96FD\u96F8\u96F5\u9773\u9777\u9778\u9772\u980F\u980D\u980E\u98AC\u98F6\u98F9\u99AF\u99B2\u99B0\u99B5\u9AAD\u9AAB\u9B5B\u9CEA\u9CED\u9CE7\u9E80\u9EFD\u50E6\u50D4\u50D7\u50E8\u50F3\u50DB\u50EA\u50DD\u50E4\u50D3\u50EC\u50F0\u50EF\u50E3\u50E0"
    ],
    [
        "e140",
        "\u51D8\u5280\u5281\u52E9\u52EB\u5330\u53AC\u5627\u5615\u560C\u5612\u55FC\u560F\u561C\u5601\u5613\u5602\u55FA\u561D\u5604\u55FF\u55F9\u5889\u587C\u5890\u5898\u5886\u5881\u587F\u5874\u588B\u587A\u5887\u5891\u588E\u5876\u5882\u5888\u587B\u5894\u588F\u58FE\u596B\u5ADC\u5AEE\u5AE5\u5AD5\u5AEA\u5ADA\u5AED\u5AEB\u5AF3\u5AE2\u5AE0\u5ADB\u5AEC\u5ADE\u5ADD\u5AD9\u5AE8\u5ADF\u5B77\u5BE0"
    ],
    [
        "e1a1",
        "\u5BE3\u5C63\u5D82\u5D80\u5D7D\u5D86\u5D7A\u5D81\u5D77\u5D8A\u5D89\u5D88\u5D7E\u5D7C\u5D8D\u5D79\u5D7F\u5E58\u5E59\u5E53\u5ED8\u5ED1\u5ED7\u5ECE\u5EDC\u5ED5\u5ED9\u5ED2\u5ED4\u5F44\u5F43\u5F6F\u5FB6\u612C\u6128\u6141\u615E\u6171\u6173\u6152\u6153\u6172\u616C\u6180\u6174\u6154\u617A\u615B\u6165\u613B\u616A\u6161\u6156\u6229\u6227\u622B\u642B\u644D\u645B\u645D\u6474\u6476\u6472\u6473\u647D\u6475\u6466\u64A6\u644E\u6482\u645E\u645C\u644B\u6453\u6460\u6450\u647F\u643F\u646C\u646B\u6459\u6465\u6477\u6573\u65A0\u66A1\u66A0\u669F\u6705\u6704\u6722\u69B1\u69B6\u69C9"
    ],
    [
        "e240",
        "\u69A0\u69CE\u6996\u69B0\u69AC\u69BC\u6991\u6999\u698E\u69A7\u698D\u69A9\u69BE\u69AF\u69BF\u69C4\u69BD\u69A4\u69D4\u69B9\u69CA\u699A\u69CF\u69B3\u6993\u69AA\u69A1\u699E\u69D9\u6997\u6990\u69C2\u69B5\u69A5\u69C6\u6B4A\u6B4D\u6B4B\u6B9E\u6B9F\u6BA0\u6BC3\u6BC4\u6BFE\u6ECE\u6EF5\u6EF1\u6F03\u6F25\u6EF8\u6F37\u6EFB\u6F2E\u6F09\u6F4E\u6F19\u6F1A\u6F27\u6F18\u6F3B\u6F12\u6EED\u6F0A"
    ],
    [
        "e2a1",
        "\u6F36\u6F73\u6EF9\u6EEE\u6F2D\u6F40\u6F30\u6F3C\u6F35\u6EEB\u6F07\u6F0E\u6F43\u6F05\u6EFD\u6EF6\u6F39\u6F1C\u6EFC\u6F3A\u6F1F\u6F0D\u6F1E\u6F08\u6F21\u7187\u7190\u7189\u7180\u7185\u7182\u718F\u717B\u7186\u7181\u7197\u7244\u7253\u7297\u7295\u7293\u7343\u734D\u7351\u734C\u7462\u7473\u7471\u7475\u7472\u7467\u746E\u7500\u7502\u7503\u757D\u7590\u7616\u7608\u760C\u7615\u7611\u760A\u7614\u76B8\u7781\u777C\u7785\u7782\u776E\u7780\u776F\u777E\u7783\u78B2\u78AA\u78B4\u78AD\u78A8\u787E\u78AB\u789E\u78A5\u78A0\u78AC\u78A2\u78A4\u7998\u798A\u798B\u7996\u7995\u7994\u7993"
    ],
    [
        "e340",
        "\u7997\u7988\u7992\u7990\u7A2B\u7A4A\u7A30\u7A2F\u7A28\u7A26\u7AA8\u7AAB\u7AAC\u7AEE\u7B88\u7B9C\u7B8A\u7B91\u7B90\u7B96\u7B8D\u7B8C\u7B9B\u7B8E\u7B85\u7B98\u5284\u7B99\u7BA4\u7B82\u7CBB\u7CBF\u7CBC\u7CBA\u7DA7\u7DB7\u7DC2\u7DA3\u7DAA\u7DC1\u7DC0\u7DC5\u7D9D\u7DCE\u7DC4\u7DC6\u7DCB\u7DCC\u7DAF\u7DB9\u7D96\u7DBC\u7D9F\u7DA6\u7DAE\u7DA9\u7DA1\u7DC9\u7F73\u7FE2\u7FE3\u7FE5\u7FDE"
    ],
    [
        "e3a1",
        "\u8024\u805D\u805C\u8189\u8186\u8183\u8187\u818D\u818C\u818B\u8215\u8497\u84A4\u84A1\u849F\u84BA\u84CE\u84C2\u84AC\u84AE\u84AB\u84B9\u84B4\u84C1\u84CD\u84AA\u849A\u84B1\u84D0\u849D\u84A7\u84BB\u84A2\u8494\u84C7\u84CC\u849B\u84A9\u84AF\u84A8\u84D6\u8498\u84B6\u84CF\u84A0\u84D7\u84D4\u84D2\u84DB\u84B0\u8491\u8661\u8733\u8723\u8728\u876B\u8740\u872E\u871E\u8721\u8719\u871B\u8743\u872C\u8741\u873E\u8746\u8720\u8732\u872A\u872D\u873C\u8712\u873A\u8731\u8735\u8742\u8726\u8727\u8738\u8724\u871A\u8730\u8711\u88F7\u88E7\u88F1\u88F2\u88FA\u88FE\u88EE\u88FC\u88F6\u88FB"
    ],
    [
        "e440",
        "\u88F0\u88EC\u88EB\u899D\u89A1\u899F\u899E\u89E9\u89EB\u89E8\u8AAB\u8A99\u8A8B\u8A92\u8A8F\u8A96\u8C3D\u8C68\u8C69\u8CD5\u8CCF\u8CD7\u8D96\u8E09\u8E02\u8DFF\u8E0D\u8DFD\u8E0A\u8E03\u8E07\u8E06\u8E05\u8DFE\u8E00\u8E04\u8F10\u8F11\u8F0E\u8F0D\u9123\u911C\u9120\u9122\u911F\u911D\u911A\u9124\u9121\u911B\u917A\u9172\u9179\u9173\u92A5\u92A4\u9276\u929B\u927A\u92A0\u9294\u92AA\u928D"
    ],
    [
        "e4a1",
        "\u92A6\u929A\u92AB\u9279\u9297\u927F\u92A3\u92EE\u928E\u9282\u9295\u92A2\u927D\u9288\u92A1\u928A\u9286\u928C\u9299\u92A7\u927E\u9287\u92A9\u929D\u928B\u922D\u969E\u96A1\u96FF\u9758\u977D\u977A\u977E\u9783\u9780\u9782\u977B\u9784\u9781\u977F\u97CE\u97CD\u9816\u98AD\u98AE\u9902\u9900\u9907\u999D\u999C\u99C3\u99B9\u99BB\u99BA\u99C2\u99BD\u99C7\u9AB1\u9AE3\u9AE7\u9B3E\u9B3F\u9B60\u9B61\u9B5F\u9CF1\u9CF2\u9CF5\u9EA7\u50FF\u5103\u5130\u50F8\u5106\u5107\u50F6\u50FE\u510B\u510C\u50FD\u510A\u528B\u528C\u52F1\u52EF\u5648\u5642\u564C\u5635\u5641\u564A\u5649\u5646\u5658"
    ],
    [
        "e540",
        "\u565A\u5640\u5633\u563D\u562C\u563E\u5638\u562A\u563A\u571A\u58AB\u589D\u58B1\u58A0\u58A3\u58AF\u58AC\u58A5\u58A1\u58FF\u5AFF\u5AF4\u5AFD\u5AF7\u5AF6\u5B03\u5AF8\u5B02\u5AF9\u5B01\u5B07\u5B05\u5B0F\u5C67\u5D99\u5D97\u5D9F\u5D92\u5DA2\u5D93\u5D95\u5DA0\u5D9C\u5DA1\u5D9A\u5D9E\u5E69\u5E5D\u5E60\u5E5C\u7DF3\u5EDB\u5EDE\u5EE1\u5F49\u5FB2\u618B\u6183\u6179\u61B1\u61B0\u61A2\u6189"
    ],
    [
        "e5a1",
        "\u619B\u6193\u61AF\u61AD\u619F\u6192\u61AA\u61A1\u618D\u6166\u61B3\u622D\u646E\u6470\u6496\u64A0\u6485\u6497\u649C\u648F\u648B\u648A\u648C\u64A3\u649F\u6468\u64B1\u6498\u6576\u657A\u6579\u657B\u65B2\u65B3\u66B5\u66B0\u66A9\u66B2\u66B7\u66AA\u66AF\u6A00\u6A06\u6A17\u69E5\u69F8\u6A15\u69F1\u69E4\u6A20\u69FF\u69EC\u69E2\u6A1B\u6A1D\u69FE\u6A27\u69F2\u69EE\u6A14\u69F7\u69E7\u6A40\u6A08\u69E6\u69FB\u6A0D\u69FC\u69EB\u6A09\u6A04\u6A18\u6A25\u6A0F\u69F6\u6A26\u6A07\u69F4\u6A16\u6B51\u6BA5\u6BA3\u6BA2\u6BA6\u6C01\u6C00\u6BFF\u6C02\u6F41\u6F26\u6F7E\u6F87\u6FC6\u6F92"
    ],
    [
        "e640",
        "\u6F8D\u6F89\u6F8C\u6F62\u6F4F\u6F85\u6F5A\u6F96\u6F76\u6F6C\u6F82\u6F55\u6F72\u6F52\u6F50\u6F57\u6F94\u6F93\u6F5D\u6F00\u6F61\u6F6B\u6F7D\u6F67\u6F90\u6F53\u6F8B\u6F69\u6F7F\u6F95\u6F63\u6F77\u6F6A\u6F7B\u71B2\u71AF\u719B\u71B0\u71A0\u719A\u71A9\u71B5\u719D\u71A5\u719E\u71A4\u71A1\u71AA\u719C\u71A7\u71B3\u7298\u729A\u7358\u7352\u735E\u735F\u7360\u735D\u735B\u7361\u735A\u7359"
    ],
    [
        "e6a1",
        "\u7362\u7487\u7489\u748A\u7486\u7481\u747D\u7485\u7488\u747C\u7479\u7508\u7507\u757E\u7625\u761E\u7619\u761D\u761C\u7623\u761A\u7628\u761B\u769C\u769D\u769E\u769B\u778D\u778F\u7789\u7788\u78CD\u78BB\u78CF\u78CC\u78D1\u78CE\u78D4\u78C8\u78C3\u78C4\u78C9\u799A\u79A1\u79A0\u799C\u79A2\u799B\u6B76\u7A39\u7AB2\u7AB4\u7AB3\u7BB7\u7BCB\u7BBE\u7BAC\u7BCE\u7BAF\u7BB9\u7BCA\u7BB5\u7CC5\u7CC8\u7CCC\u7CCB\u7DF7\u7DDB\u7DEA\u7DE7\u7DD7\u7DE1\u7E03\u7DFA\u7DE6\u7DF6\u7DF1\u7DF0\u7DEE\u7DDF\u7F76\u7FAC\u7FB0\u7FAD\u7FED\u7FEB\u7FEA\u7FEC\u7FE6\u7FE8\u8064\u8067\u81A3\u819F"
    ],
    [
        "e740",
        "\u819E\u8195\u81A2\u8199\u8197\u8216\u824F\u8253\u8252\u8250\u824E\u8251\u8524\u853B\u850F\u8500\u8529\u850E\u8509\u850D\u851F\u850A\u8527\u851C\u84FB\u852B\u84FA\u8508\u850C\u84F4\u852A\u84F2\u8515\u84F7\u84EB\u84F3\u84FC\u8512\u84EA\u84E9\u8516\u84FE\u8528\u851D\u852E\u8502\u84FD\u851E\u84F6\u8531\u8526\u84E7\u84E8\u84F0\u84EF\u84F9\u8518\u8520\u8530\u850B\u8519\u852F\u8662"
    ],
    [
        "e7a1",
        "\u8756\u8763\u8764\u8777\u87E1\u8773\u8758\u8754\u875B\u8752\u8761\u875A\u8751\u875E\u876D\u876A\u8750\u874E\u875F\u875D\u876F\u876C\u877A\u876E\u875C\u8765\u874F\u877B\u8775\u8762\u8767\u8769\u885A\u8905\u890C\u8914\u890B\u8917\u8918\u8919\u8906\u8916\u8911\u890E\u8909\u89A2\u89A4\u89A3\u89ED\u89F0\u89EC\u8ACF\u8AC6\u8AB8\u8AD3\u8AD1\u8AD4\u8AD5\u8ABB\u8AD7\u8ABE\u8AC0\u8AC5\u8AD8\u8AC3\u8ABA\u8ABD\u8AD9\u8C3E\u8C4D\u8C8F\u8CE5\u8CDF\u8CD9\u8CE8\u8CDA\u8CDD\u8CE7\u8DA0\u8D9C\u8DA1\u8D9B\u8E20\u8E23\u8E25\u8E24\u8E2E\u8E15\u8E1B\u8E16\u8E11\u8E19\u8E26\u8E27"
    ],
    [
        "e840",
        "\u8E14\u8E12\u8E18\u8E13\u8E1C\u8E17\u8E1A\u8F2C\u8F24\u8F18\u8F1A\u8F20\u8F23\u8F16\u8F17\u9073\u9070\u906F\u9067\u906B\u912F\u912B\u9129\u912A\u9132\u9126\u912E\u9185\u9186\u918A\u9181\u9182\u9184\u9180\u92D0\u92C3\u92C4\u92C0\u92D9\u92B6\u92CF\u92F1\u92DF\u92D8\u92E9\u92D7\u92DD\u92CC\u92EF\u92C2\u92E8\u92CA\u92C8\u92CE\u92E6\u92CD\u92D5\u92C9\u92E0\u92DE\u92E7\u92D1\u92D3"
    ],
    [
        "e8a1",
        "\u92B5\u92E1\u92C6\u92B4\u957C\u95AC\u95AB\u95AE\u95B0\u96A4\u96A2\u96D3\u9705\u9708\u9702\u975A\u978A\u978E\u9788\u97D0\u97CF\u981E\u981D\u9826\u9829\u9828\u9820\u981B\u9827\u98B2\u9908\u98FA\u9911\u9914\u9916\u9917\u9915\u99DC\u99CD\u99CF\u99D3\u99D4\u99CE\u99C9\u99D6\u99D8\u99CB\u99D7\u99CC\u9AB3\u9AEC\u9AEB\u9AF3\u9AF2\u9AF1\u9B46\u9B43\u9B67\u9B74\u9B71\u9B66\u9B76\u9B75\u9B70\u9B68\u9B64\u9B6C\u9CFC\u9CFA\u9CFD\u9CFF\u9CF7\u9D07\u9D00\u9CF9\u9CFB\u9D08\u9D05\u9D04\u9E83\u9ED3\u9F0F\u9F10\u511C\u5113\u5117\u511A\u5111\u51DE\u5334\u53E1\u5670\u5660\u566E"
    ],
    [
        "e940",
        "\u5673\u5666\u5663\u566D\u5672\u565E\u5677\u571C\u571B\u58C8\u58BD\u58C9\u58BF\u58BA\u58C2\u58BC\u58C6\u5B17\u5B19\u5B1B\u5B21\u5B14\u5B13\u5B10\u5B16\u5B28\u5B1A\u5B20\u5B1E\u5BEF\u5DAC\u5DB1\u5DA9\u5DA7\u5DB5\u5DB0\u5DAE\u5DAA\u5DA8\u5DB2\u5DAD\u5DAF\u5DB4\u5E67\u5E68\u5E66\u5E6F\u5EE9\u5EE7\u5EE6\u5EE8\u5EE5\u5F4B\u5FBC\u619D\u61A8\u6196\u61C5\u61B4\u61C6\u61C1\u61CC\u61BA"
    ],
    [
        "e9a1",
        "\u61BF\u61B8\u618C\u64D7\u64D6\u64D0\u64CF\u64C9\u64BD\u6489\u64C3\u64DB\u64F3\u64D9\u6533\u657F\u657C\u65A2\u66C8\u66BE\u66C0\u66CA\u66CB\u66CF\u66BD\u66BB\u66BA\u66CC\u6723\u6A34\u6A66\u6A49\u6A67\u6A32\u6A68\u6A3E\u6A5D\u6A6D\u6A76\u6A5B\u6A51\u6A28\u6A5A\u6A3B\u6A3F\u6A41\u6A6A\u6A64\u6A50\u6A4F\u6A54\u6A6F\u6A69\u6A60\u6A3C\u6A5E\u6A56\u6A55\u6A4D\u6A4E\u6A46\u6B55\u6B54\u6B56\u6BA7\u6BAA\u6BAB\u6BC8\u6BC7\u6C04\u6C03\u6C06\u6FAD\u6FCB\u6FA3\u6FC7\u6FBC\u6FCE\u6FC8\u6F5E\u6FC4\u6FBD\u6F9E\u6FCA\u6FA8\u7004\u6FA5\u6FAE\u6FBA\u6FAC\u6FAA\u6FCF\u6FBF\u6FB8"
    ],
    [
        "ea40",
        "\u6FA2\u6FC9\u6FAB\u6FCD\u6FAF\u6FB2\u6FB0\u71C5\u71C2\u71BF\u71B8\u71D6\u71C0\u71C1\u71CB\u71D4\u71CA\u71C7\u71CF\u71BD\u71D8\u71BC\u71C6\u71DA\u71DB\u729D\u729E\u7369\u7366\u7367\u736C\u7365\u736B\u736A\u747F\u749A\u74A0\u7494\u7492\u7495\u74A1\u750B\u7580\u762F\u762D\u7631\u763D\u7633\u763C\u7635\u7632\u7630\u76BB\u76E6\u779A\u779D\u77A1\u779C\u779B\u77A2\u77A3\u7795\u7799"
    ],
    [
        "eaa1",
        "\u7797\u78DD\u78E9\u78E5\u78EA\u78DE\u78E3\u78DB\u78E1\u78E2\u78ED\u78DF\u78E0\u79A4\u7A44\u7A48\u7A47\u7AB6\u7AB8\u7AB5\u7AB1\u7AB7\u7BDE\u7BE3\u7BE7\u7BDD\u7BD5\u7BE5\u7BDA\u7BE8\u7BF9\u7BD4\u7BEA\u7BE2\u7BDC\u7BEB\u7BD8\u7BDF\u7CD2\u7CD4\u7CD7\u7CD0\u7CD1\u7E12\u7E21\u7E17\u7E0C\u7E1F\u7E20\u7E13\u7E0E\u7E1C\u7E15\u7E1A\u7E22\u7E0B\u7E0F\u7E16\u7E0D\u7E14\u7E25\u7E24\u7F43\u7F7B\u7F7C\u7F7A\u7FB1\u7FEF\u802A\u8029\u806C\u81B1\u81A6\u81AE\u81B9\u81B5\u81AB\u81B0\u81AC\u81B4\u81B2\u81B7\u81A7\u81F2\u8255\u8256\u8257\u8556\u8545\u856B\u854D\u8553\u8561\u8558"
    ],
    [
        "eb40",
        "\u8540\u8546\u8564\u8541\u8562\u8544\u8551\u8547\u8563\u853E\u855B\u8571\u854E\u856E\u8575\u8555\u8567\u8560\u858C\u8566\u855D\u8554\u8565\u856C\u8663\u8665\u8664\u879B\u878F\u8797\u8793\u8792\u8788\u8781\u8796\u8798\u8779\u8787\u87A3\u8785\u8790\u8791\u879D\u8784\u8794\u879C\u879A\u8789\u891E\u8926\u8930\u892D\u892E\u8927\u8931\u8922\u8929\u8923\u892F\u892C\u891F\u89F1\u8AE0"
    ],
    [
        "eba1",
        "\u8AE2\u8AF2\u8AF4\u8AF5\u8ADD\u8B14\u8AE4\u8ADF\u8AF0\u8AC8\u8ADE\u8AE1\u8AE8\u8AFF\u8AEF\u8AFB\u8C91\u8C92\u8C90\u8CF5\u8CEE\u8CF1\u8CF0\u8CF3\u8D6C\u8D6E\u8DA5\u8DA7\u8E33\u8E3E\u8E38\u8E40\u8E45\u8E36\u8E3C\u8E3D\u8E41\u8E30\u8E3F\u8EBD\u8F36\u8F2E\u8F35\u8F32\u8F39\u8F37\u8F34\u9076\u9079\u907B\u9086\u90FA\u9133\u9135\u9136\u9193\u9190\u9191\u918D\u918F\u9327\u931E\u9308\u931F\u9306\u930F\u937A\u9338\u933C\u931B\u9323\u9312\u9301\u9346\u932D\u930E\u930D\u92CB\u931D\u92FA\u9325\u9313\u92F9\u92F7\u9334\u9302\u9324\u92FF\u9329\u9339\u9335\u932A\u9314\u930C"
    ],
    [
        "ec40",
        "\u930B\u92FE\u9309\u9300\u92FB\u9316\u95BC\u95CD\u95BE\u95B9\u95BA\u95B6\u95BF\u95B5\u95BD\u96A9\u96D4\u970B\u9712\u9710\u9799\u9797\u9794\u97F0\u97F8\u9835\u982F\u9832\u9924\u991F\u9927\u9929\u999E\u99EE\u99EC\u99E5\u99E4\u99F0\u99E3\u99EA\u99E9\u99E7\u9AB9\u9ABF\u9AB4\u9ABB\u9AF6\u9AFA\u9AF9\u9AF7\u9B33\u9B80\u9B85\u9B87\u9B7C\u9B7E\u9B7B\u9B82\u9B93\u9B92\u9B90\u9B7A\u9B95"
    ],
    [
        "eca1",
        "\u9B7D\u9B88\u9D25\u9D17\u9D20\u9D1E\u9D14\u9D29\u9D1D\u9D18\u9D22\u9D10\u9D19\u9D1F\u9E88\u9E86\u9E87\u9EAE\u9EAD\u9ED5\u9ED6\u9EFA\u9F12\u9F3D\u5126\u5125\u5122\u5124\u5120\u5129\u52F4\u5693\u568C\u568D\u5686\u5684\u5683\u567E\u5682\u567F\u5681\u58D6\u58D4\u58CF\u58D2\u5B2D\u5B25\u5B32\u5B23\u5B2C\u5B27\u5B26\u5B2F\u5B2E\u5B7B\u5BF1\u5BF2\u5DB7\u5E6C\u5E6A\u5FBE\u5FBB\u61C3\u61B5\u61BC\u61E7\u61E0\u61E5\u61E4\u61E8\u61DE\u64EF\u64E9\u64E3\u64EB\u64E4\u64E8\u6581\u6580\u65B6\u65DA\u66D2\u6A8D\u6A96\u6A81\u6AA5\u6A89\u6A9F\u6A9B\u6AA1\u6A9E\u6A87\u6A93\u6A8E"
    ],
    [
        "ed40",
        "\u6A95\u6A83\u6AA8\u6AA4\u6A91\u6A7F\u6AA6\u6A9A\u6A85\u6A8C\u6A92\u6B5B\u6BAD\u6C09\u6FCC\u6FA9\u6FF4\u6FD4\u6FE3\u6FDC\u6FED\u6FE7\u6FE6\u6FDE\u6FF2\u6FDD\u6FE2\u6FE8\u71E1\u71F1\u71E8\u71F2\u71E4\u71F0\u71E2\u7373\u736E\u736F\u7497\u74B2\u74AB\u7490\u74AA\u74AD\u74B1\u74A5\u74AF\u7510\u7511\u7512\u750F\u7584\u7643\u7648\u7649\u7647\u76A4\u76E9\u77B5\u77AB\u77B2\u77B7\u77B6"
    ],
    [
        "eda1",
        "\u77B4\u77B1\u77A8\u77F0\u78F3\u78FD\u7902\u78FB\u78FC\u78F2\u7905\u78F9\u78FE\u7904\u79AB\u79A8\u7A5C\u7A5B\u7A56\u7A58\u7A54\u7A5A\u7ABE\u7AC0\u7AC1\u7C05\u7C0F\u7BF2\u7C00\u7BFF\u7BFB\u7C0E\u7BF4\u7C0B\u7BF3\u7C02\u7C09\u7C03\u7C01\u7BF8\u7BFD\u7C06\u7BF0\u7BF1\u7C10\u7C0A\u7CE8\u7E2D\u7E3C\u7E42\u7E33\u9848\u7E38\u7E2A\u7E49\u7E40\u7E47\u7E29\u7E4C\u7E30\u7E3B\u7E36\u7E44\u7E3A\u7F45\u7F7F\u7F7E\u7F7D\u7FF4\u7FF2\u802C\u81BB\u81C4\u81CC\u81CA\u81C5\u81C7\u81BC\u81E9\u825B\u825A\u825C\u8583\u8580\u858F\u85A7\u8595\u85A0\u858B\u85A3\u857B\u85A4\u859A\u859E"
    ],
    [
        "ee40",
        "\u8577\u857C\u8589\u85A1\u857A\u8578\u8557\u858E\u8596\u8586\u858D\u8599\u859D\u8581\u85A2\u8582\u8588\u8585\u8579\u8576\u8598\u8590\u859F\u8668\u87BE\u87AA\u87AD\u87C5\u87B0\u87AC\u87B9\u87B5\u87BC\u87AE\u87C9\u87C3\u87C2\u87CC\u87B7\u87AF\u87C4\u87CA\u87B4\u87B6\u87BF\u87B8\u87BD\u87DE\u87B2\u8935\u8933\u893C\u893E\u8941\u8952\u8937\u8942\u89AD\u89AF\u89AE\u89F2\u89F3\u8B1E"
    ],
    [
        "eea1",
        "\u8B18\u8B16\u8B11\u8B05\u8B0B\u8B22\u8B0F\u8B12\u8B15\u8B07\u8B0D\u8B08\u8B06\u8B1C\u8B13\u8B1A\u8C4F\u8C70\u8C72\u8C71\u8C6F\u8C95\u8C94\u8CF9\u8D6F\u8E4E\u8E4D\u8E53\u8E50\u8E4C\u8E47\u8F43\u8F40\u9085\u907E\u9138\u919A\u91A2\u919B\u9199\u919F\u91A1\u919D\u91A0\u93A1\u9383\u93AF\u9364\u9356\u9347\u937C\u9358\u935C\u9376\u9349\u9350\u9351\u9360\u936D\u938F\u934C\u936A\u9379\u9357\u9355\u9352\u934F\u9371\u9377\u937B\u9361\u935E\u9363\u9367\u9380\u934E\u9359\u95C7\u95C0\u95C9\u95C3\u95C5\u95B7\u96AE\u96B0\u96AC\u9720\u971F\u9718\u971D\u9719\u979A\u97A1\u979C"
    ],
    [
        "ef40",
        "\u979E\u979D\u97D5\u97D4\u97F1\u9841\u9844\u984A\u9849\u9845\u9843\u9925\u992B\u992C\u992A\u9933\u9932\u992F\u992D\u9931\u9930\u9998\u99A3\u99A1\u9A02\u99FA\u99F4\u99F7\u99F9\u99F8\u99F6\u99FB\u99FD\u99FE\u99FC\u9A03\u9ABE\u9AFE\u9AFD\u9B01\u9AFC\u9B48\u9B9A\u9BA8\u9B9E\u9B9B\u9BA6\u9BA1\u9BA5\u9BA4\u9B86\u9BA2\u9BA0\u9BAF\u9D33\u9D41\u9D67\u9D36\u9D2E\u9D2F\u9D31\u9D38\u9D30"
    ],
    [
        "efa1",
        "\u9D45\u9D42\u9D43\u9D3E\u9D37\u9D40\u9D3D\u7FF5\u9D2D\u9E8A\u9E89\u9E8D\u9EB0\u9EC8\u9EDA\u9EFB\u9EFF\u9F24\u9F23\u9F22\u9F54\u9FA0\u5131\u512D\u512E\u5698\u569C\u5697\u569A\u569D\u5699\u5970\u5B3C\u5C69\u5C6A\u5DC0\u5E6D\u5E6E\u61D8\u61DF\u61ED\u61EE\u61F1\u61EA\u61F0\u61EB\u61D6\u61E9\u64FF\u6504\u64FD\u64F8\u6501\u6503\u64FC\u6594\u65DB\u66DA\u66DB\u66D8\u6AC5\u6AB9\u6ABD\u6AE1\u6AC6\u6ABA\u6AB6\u6AB7\u6AC7\u6AB4\u6AAD\u6B5E\u6BC9\u6C0B\u7007\u700C\u700D\u7001\u7005\u7014\u700E\u6FFF\u7000\u6FFB\u7026\u6FFC\u6FF7\u700A\u7201\u71FF\u71F9\u7203\u71FD\u7376"
    ],
    [
        "f040",
        "\u74B8\u74C0\u74B5\u74C1\u74BE\u74B6\u74BB\u74C2\u7514\u7513\u765C\u7664\u7659\u7650\u7653\u7657\u765A\u76A6\u76BD\u76EC\u77C2\u77BA\u78FF\u790C\u7913\u7914\u7909\u7910\u7912\u7911\u79AD\u79AC\u7A5F\u7C1C\u7C29\u7C19\u7C20\u7C1F\u7C2D\u7C1D\u7C26\u7C28\u7C22\u7C25\u7C30\u7E5C\u7E50\u7E56\u7E63\u7E58\u7E62\u7E5F\u7E51\u7E60\u7E57\u7E53\u7FB5\u7FB3\u7FF7\u7FF8\u8075\u81D1\u81D2"
    ],
    [
        "f0a1",
        "\u81D0\u825F\u825E\u85B4\u85C6\u85C0\u85C3\u85C2\u85B3\u85B5\u85BD\u85C7\u85C4\u85BF\u85CB\u85CE\u85C8\u85C5\u85B1\u85B6\u85D2\u8624\u85B8\u85B7\u85BE\u8669\u87E7\u87E6\u87E2\u87DB\u87EB\u87EA\u87E5\u87DF\u87F3\u87E4\u87D4\u87DC\u87D3\u87ED\u87D8\u87E3\u87A4\u87D7\u87D9\u8801\u87F4\u87E8\u87DD\u8953\u894B\u894F\u894C\u8946\u8950\u8951\u8949\u8B2A\u8B27\u8B23\u8B33\u8B30\u8B35\u8B47\u8B2F\u8B3C\u8B3E\u8B31\u8B25\u8B37\u8B26\u8B36\u8B2E\u8B24\u8B3B\u8B3D\u8B3A\u8C42\u8C75\u8C99\u8C98\u8C97\u8CFE\u8D04\u8D02\u8D00\u8E5C\u8E62\u8E60\u8E57\u8E56\u8E5E\u8E65\u8E67"
    ],
    [
        "f140",
        "\u8E5B\u8E5A\u8E61\u8E5D\u8E69\u8E54\u8F46\u8F47\u8F48\u8F4B\u9128\u913A\u913B\u913E\u91A8\u91A5\u91A7\u91AF\u91AA\u93B5\u938C\u9392\u93B7\u939B\u939D\u9389\u93A7\u938E\u93AA\u939E\u93A6\u9395\u9388\u9399\u939F\u938D\u93B1\u9391\u93B2\u93A4\u93A8\u93B4\u93A3\u93A5\u95D2\u95D3\u95D1\u96B3\u96D7\u96DA\u5DC2\u96DF\u96D8\u96DD\u9723\u9722\u9725\u97AC\u97AE\u97A8\u97AB\u97A4\u97AA"
    ],
    [
        "f1a1",
        "\u97A2\u97A5\u97D7\u97D9\u97D6\u97D8\u97FA\u9850\u9851\u9852\u98B8\u9941\u993C\u993A\u9A0F\u9A0B\u9A09\u9A0D\u9A04\u9A11\u9A0A\u9A05\u9A07\u9A06\u9AC0\u9ADC\u9B08\u9B04\u9B05\u9B29\u9B35\u9B4A\u9B4C\u9B4B\u9BC7\u9BC6\u9BC3\u9BBF\u9BC1\u9BB5\u9BB8\u9BD3\u9BB6\u9BC4\u9BB9\u9BBD\u9D5C\u9D53\u9D4F\u9D4A\u9D5B\u9D4B\u9D59\u9D56\u9D4C\u9D57\u9D52\u9D54\u9D5F\u9D58\u9D5A\u9E8E\u9E8C\u9EDF\u9F01\u9F00\u9F16\u9F25\u9F2B\u9F2A\u9F29\u9F28\u9F4C\u9F55\u5134\u5135\u5296\u52F7\u53B4\u56AB\u56AD\u56A6\u56A7\u56AA\u56AC\u58DA\u58DD\u58DB\u5912\u5B3D\u5B3E\u5B3F\u5DC3\u5E70"
    ],
    [
        "f240",
        "\u5FBF\u61FB\u6507\u6510\u650D\u6509\u650C\u650E\u6584\u65DE\u65DD\u66DE\u6AE7\u6AE0\u6ACC\u6AD1\u6AD9\u6ACB\u6ADF\u6ADC\u6AD0\u6AEB\u6ACF\u6ACD\u6ADE\u6B60\u6BB0\u6C0C\u7019\u7027\u7020\u7016\u702B\u7021\u7022\u7023\u7029\u7017\u7024\u701C\u702A\u720C\u720A\u7207\u7202\u7205\u72A5\u72A6\u72A4\u72A3\u72A1\u74CB\u74C5\u74B7\u74C3\u7516\u7660\u77C9\u77CA\u77C4\u77F1\u791D\u791B"
    ],
    [
        "f2a1",
        "\u7921\u791C\u7917\u791E\u79B0\u7A67\u7A68\u7C33\u7C3C\u7C39\u7C2C\u7C3B\u7CEC\u7CEA\u7E76\u7E75\u7E78\u7E70\u7E77\u7E6F\u7E7A\u7E72\u7E74\u7E68\u7F4B\u7F4A\u7F83\u7F86\u7FB7\u7FFD\u7FFE\u8078\u81D7\u81D5\u8264\u8261\u8263\u85EB\u85F1\u85ED\u85D9\u85E1\u85E8\u85DA\u85D7\u85EC\u85F2\u85F8\u85D8\u85DF\u85E3\u85DC\u85D1\u85F0\u85E6\u85EF\u85DE\u85E2\u8800\u87FA\u8803\u87F6\u87F7\u8809\u880C\u880B\u8806\u87FC\u8808\u87FF\u880A\u8802\u8962\u895A\u895B\u8957\u8961\u895C\u8958\u895D\u8959\u8988\u89B7\u89B6\u89F6\u8B50\u8B48\u8B4A\u8B40\u8B53\u8B56\u8B54\u8B4B\u8B55"
    ],
    [
        "f340",
        "\u8B51\u8B42\u8B52\u8B57\u8C43\u8C77\u8C76\u8C9A\u8D06\u8D07\u8D09\u8DAC\u8DAA\u8DAD\u8DAB\u8E6D\u8E78\u8E73\u8E6A\u8E6F\u8E7B\u8EC2\u8F52\u8F51\u8F4F\u8F50\u8F53\u8FB4\u9140\u913F\u91B0\u91AD\u93DE\u93C7\u93CF\u93C2\u93DA\u93D0\u93F9\u93EC\u93CC\u93D9\u93A9\u93E6\u93CA\u93D4\u93EE\u93E3\u93D5\u93C4\u93CE\u93C0\u93D2\u93E7\u957D\u95DA\u95DB\u96E1\u9729\u972B\u972C\u9728\u9726"
    ],
    [
        "f3a1",
        "\u97B3\u97B7\u97B6\u97DD\u97DE\u97DF\u985C\u9859\u985D\u9857\u98BF\u98BD\u98BB\u98BE\u9948\u9947\u9943\u99A6\u99A7\u9A1A\u9A15\u9A25\u9A1D\u9A24\u9A1B\u9A22\u9A20\u9A27\u9A23\u9A1E\u9A1C\u9A14\u9AC2\u9B0B\u9B0A\u9B0E\u9B0C\u9B37\u9BEA\u9BEB\u9BE0\u9BDE\u9BE4\u9BE6\u9BE2\u9BF0\u9BD4\u9BD7\u9BEC\u9BDC\u9BD9\u9BE5\u9BD5\u9BE1\u9BDA\u9D77\u9D81\u9D8A\u9D84\u9D88\u9D71\u9D80\u9D78\u9D86\u9D8B\u9D8C\u9D7D\u9D6B\u9D74\u9D75\u9D70\u9D69\u9D85\u9D73\u9D7B\u9D82\u9D6F\u9D79\u9D7F\u9D87\u9D68\u9E94\u9E91\u9EC0\u9EFC\u9F2D\u9F40\u9F41\u9F4D\u9F56\u9F57\u9F58\u5337\u56B2"
    ],
    [
        "f440",
        "\u56B5\u56B3\u58E3\u5B45\u5DC6\u5DC7\u5EEE\u5EEF\u5FC0\u5FC1\u61F9\u6517\u6516\u6515\u6513\u65DF\u66E8\u66E3\u66E4\u6AF3\u6AF0\u6AEA\u6AE8\u6AF9\u6AF1\u6AEE\u6AEF\u703C\u7035\u702F\u7037\u7034\u7031\u7042\u7038\u703F\u703A\u7039\u7040\u703B\u7033\u7041\u7213\u7214\u72A8\u737D\u737C\u74BA\u76AB\u76AA\u76BE\u76ED\u77CC\u77CE\u77CF\u77CD\u77F2\u7925\u7923\u7927\u7928\u7924\u7929"
    ],
    [
        "f4a1",
        "\u79B2\u7A6E\u7A6C\u7A6D\u7AF7\u7C49\u7C48\u7C4A\u7C47\u7C45\u7CEE\u7E7B\u7E7E\u7E81\u7E80\u7FBA\u7FFF\u8079\u81DB\u81D9\u820B\u8268\u8269\u8622\u85FF\u8601\u85FE\u861B\u8600\u85F6\u8604\u8609\u8605\u860C\u85FD\u8819\u8810\u8811\u8817\u8813\u8816\u8963\u8966\u89B9\u89F7\u8B60\u8B6A\u8B5D\u8B68\u8B63\u8B65\u8B67\u8B6D\u8DAE\u8E86\u8E88\u8E84\u8F59\u8F56\u8F57\u8F55\u8F58\u8F5A\u908D\u9143\u9141\u91B7\u91B5\u91B2\u91B3\u940B\u9413\u93FB\u9420\u940F\u9414\u93FE\u9415\u9410\u9428\u9419\u940D\u93F5\u9400\u93F7\u9407\u940E\u9416\u9412\u93FA\u9409\u93F8\u940A\u93FF"
    ],
    [
        "f540",
        "\u93FC\u940C\u93F6\u9411\u9406\u95DE\u95E0\u95DF\u972E\u972F\u97B9\u97BB\u97FD\u97FE\u9860\u9862\u9863\u985F\u98C1\u98C2\u9950\u994E\u9959\u994C\u994B\u9953\u9A32\u9A34\u9A31\u9A2C\u9A2A\u9A36\u9A29\u9A2E\u9A38\u9A2D\u9AC7\u9ACA\u9AC6\u9B10\u9B12\u9B11\u9C0B\u9C08\u9BF7\u9C05\u9C12\u9BF8\u9C40\u9C07\u9C0E\u9C06\u9C17\u9C14\u9C09\u9D9F\u9D99\u9DA4\u9D9D\u9D92\u9D98\u9D90\u9D9B"
    ],
    [
        "f5a1",
        "\u9DA0\u9D94\u9D9C\u9DAA\u9D97\u9DA1\u9D9A\u9DA2\u9DA8\u9D9E\u9DA3\u9DBF\u9DA9\u9D96\u9DA6\u9DA7\u9E99\u9E9B\u9E9A\u9EE5\u9EE4\u9EE7\u9EE6\u9F30\u9F2E\u9F5B\u9F60\u9F5E\u9F5D\u9F59\u9F91\u513A\u5139\u5298\u5297\u56C3\u56BD\u56BE\u5B48\u5B47\u5DCB\u5DCF\u5EF1\u61FD\u651B\u6B02\u6AFC\u6B03\u6AF8\u6B00\u7043\u7044\u704A\u7048\u7049\u7045\u7046\u721D\u721A\u7219\u737E\u7517\u766A\u77D0\u792D\u7931\u792F\u7C54\u7C53\u7CF2\u7E8A\u7E87\u7E88\u7E8B\u7E86\u7E8D\u7F4D\u7FBB\u8030\u81DD\u8618\u862A\u8626\u861F\u8623\u861C\u8619\u8627\u862E\u8621\u8620\u8629\u861E\u8625"
    ],
    [
        "f640",
        "\u8829\u881D\u881B\u8820\u8824\u881C\u882B\u884A\u896D\u8969\u896E\u896B\u89FA\u8B79\u8B78\u8B45\u8B7A\u8B7B\u8D10\u8D14\u8DAF\u8E8E\u8E8C\u8F5E\u8F5B\u8F5D\u9146\u9144\u9145\u91B9\u943F\u943B\u9436\u9429\u943D\u943C\u9430\u9439\u942A\u9437\u942C\u9440\u9431\u95E5\u95E4\u95E3\u9735\u973A\u97BF\u97E1\u9864\u98C9\u98C6\u98C0\u9958\u9956\u9A39\u9A3D\u9A46\u9A44\u9A42\u9A41\u9A3A"
    ],
    [
        "f6a1",
        "\u9A3F\u9ACD\u9B15\u9B17\u9B18\u9B16\u9B3A\u9B52\u9C2B\u9C1D\u9C1C\u9C2C\u9C23\u9C28\u9C29\u9C24\u9C21\u9DB7\u9DB6\u9DBC\u9DC1\u9DC7\u9DCA\u9DCF\u9DBE\u9DC5\u9DC3\u9DBB\u9DB5\u9DCE\u9DB9\u9DBA\u9DAC\u9DC8\u9DB1\u9DAD\u9DCC\u9DB3\u9DCD\u9DB2\u9E7A\u9E9C\u9EEB\u9EEE\u9EED\u9F1B\u9F18\u9F1A\u9F31\u9F4E\u9F65\u9F64\u9F92\u4EB9\u56C6\u56C5\u56CB\u5971\u5B4B\u5B4C\u5DD5\u5DD1\u5EF2\u6521\u6520\u6526\u6522\u6B0B\u6B08\u6B09\u6C0D\u7055\u7056\u7057\u7052\u721E\u721F\u72A9\u737F\u74D8\u74D5\u74D9\u74D7\u766D\u76AD\u7935\u79B4\u7A70\u7A71\u7C57\u7C5C\u7C59\u7C5B\u7C5A"
    ],
    [
        "f740",
        "\u7CF4\u7CF1\u7E91\u7F4F\u7F87\u81DE\u826B\u8634\u8635\u8633\u862C\u8632\u8636\u882C\u8828\u8826\u882A\u8825\u8971\u89BF\u89BE\u89FB\u8B7E\u8B84\u8B82\u8B86\u8B85\u8B7F\u8D15\u8E95\u8E94\u8E9A\u8E92\u8E90\u8E96\u8E97\u8F60\u8F62\u9147\u944C\u9450\u944A\u944B\u944F\u9447\u9445\u9448\u9449\u9446\u973F\u97E3\u986A\u9869\u98CB\u9954\u995B\u9A4E\u9A53\u9A54\u9A4C\u9A4F\u9A48\u9A4A"
    ],
    [
        "f7a1",
        "\u9A49\u9A52\u9A50\u9AD0\u9B19\u9B2B\u9B3B\u9B56\u9B55\u9C46\u9C48\u9C3F\u9C44\u9C39\u9C33\u9C41\u9C3C\u9C37\u9C34\u9C32\u9C3D\u9C36\u9DDB\u9DD2\u9DDE\u9DDA\u9DCB\u9DD0\u9DDC\u9DD1\u9DDF\u9DE9\u9DD9\u9DD8\u9DD6\u9DF5\u9DD5\u9DDD\u9EB6\u9EF0\u9F35\u9F33\u9F32\u9F42\u9F6B\u9F95\u9FA2\u513D\u5299\u58E8\u58E7\u5972\u5B4D\u5DD8\u882F\u5F4F\u6201\u6203\u6204\u6529\u6525\u6596\u66EB\u6B11\u6B12\u6B0F\u6BCA\u705B\u705A\u7222\u7382\u7381\u7383\u7670\u77D4\u7C67\u7C66\u7E95\u826C\u863A\u8640\u8639\u863C\u8631\u863B\u863E\u8830\u8832\u882E\u8833\u8976\u8974\u8973\u89FE"
    ],
    [
        "f840",
        "\u8B8C\u8B8E\u8B8B\u8B88\u8C45\u8D19\u8E98\u8F64\u8F63\u91BC\u9462\u9455\u945D\u9457\u945E\u97C4\u97C5\u9800\u9A56\u9A59\u9B1E\u9B1F\u9B20\u9C52\u9C58\u9C50\u9C4A\u9C4D\u9C4B\u9C55\u9C59\u9C4C\u9C4E\u9DFB\u9DF7\u9DEF\u9DE3\u9DEB\u9DF8\u9DE4\u9DF6\u9DE1\u9DEE\u9DE6\u9DF2\u9DF0\u9DE2\u9DEC\u9DF4\u9DF3\u9DE8\u9DED\u9EC2\u9ED0\u9EF2\u9EF3\u9F06\u9F1C\u9F38\u9F37\u9F36\u9F43\u9F4F"
    ],
    [
        "f8a1",
        "\u9F71\u9F70\u9F6E\u9F6F\u56D3\u56CD\u5B4E\u5C6D\u652D\u66ED\u66EE\u6B13\u705F\u7061\u705D\u7060\u7223\u74DB\u74E5\u77D5\u7938\u79B7\u79B6\u7C6A\u7E97\u7F89\u826D\u8643\u8838\u8837\u8835\u884B\u8B94\u8B95\u8E9E\u8E9F\u8EA0\u8E9D\u91BE\u91BD\u91C2\u946B\u9468\u9469\u96E5\u9746\u9743\u9747\u97C7\u97E5\u9A5E\u9AD5\u9B59\u9C63\u9C67\u9C66\u9C62\u9C5E\u9C60\u9E02\u9DFE\u9E07\u9E03\u9E06\u9E05\u9E00\u9E01\u9E09\u9DFF\u9DFD\u9E04\u9EA0\u9F1E\u9F46\u9F74\u9F75\u9F76\u56D4\u652E\u65B8\u6B18\u6B19\u6B17\u6B1A\u7062\u7226\u72AA\u77D8\u77D9\u7939\u7C69\u7C6B\u7CF6\u7E9A"
    ],
    [
        "f940",
        "\u7E98\u7E9B\u7E99\u81E0\u81E1\u8646\u8647\u8648\u8979\u897A\u897C\u897B\u89FF\u8B98\u8B99\u8EA5\u8EA4\u8EA3\u946E\u946D\u946F\u9471\u9473\u9749\u9872\u995F\u9C68\u9C6E\u9C6D\u9E0B\u9E0D\u9E10\u9E0F\u9E12\u9E11\u9EA1\u9EF5\u9F09\u9F47\u9F78\u9F7B\u9F7A\u9F79\u571E\u7066\u7C6F\u883C\u8DB2\u8EA6\u91C3\u9474\u9478\u9476\u9475\u9A60\u9C74\u9C73\u9C71\u9C75\u9E14\u9E13\u9EF6\u9F0A"
    ],
    [
        "f9a1",
        "\u9FA4\u7068\u7065\u7CF7\u866A\u883E\u883D\u883F\u8B9E\u8C9C\u8EA9\u8EC9\u974B\u9873\u9874\u98CC\u9961\u99AB\u9A64\u9A66\u9A67\u9B24\u9E15\u9E17\u9F48\u6207\u6B1E\u7227\u864C\u8EA8\u9482\u9480\u9481\u9A69\u9A68\u9B2E\u9E19\u7229\u864B\u8B9F\u9483\u9C79\u9EB7\u7675\u9A6B\u9C7A\u9E1D\u7069\u706A\u9EA4\u9F7E\u9F49\u9F98\u7881\u92B9\u88CF\u58BB\u6052\u7CA7\u5AFA\u2554\u2566\u2557\u2560\u256C\u2563\u255A\u2569\u255D\u2552\u2564\u2555\u255E\u256A\u2561\u2558\u2567\u255B\u2553\u2565\u2556\u255F\u256B\u2562\u2559\u2568\u255C\u2551\u2550\u256D\u256E\u2570\u256F\u2593"
    ]
];
var $07144aea14354eb9$var$cp950$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$cp950
});
var $07144aea14354eb9$var$big5Added = [
    [
        "8740",
        "\u43F0\u4C32\u4603\u45A6\u4578\uD85C\uDE67\u4D77\u45B3\uD85F\uDCB1\u4CE2\uD85F\uDCC5\u3B95\u4736\u4744\u4C47\u4C40\uD850\uDEBF\uD84D\uDE17\uD85C\uDF52\uD85B\uDE8B\uD85C\uDCD2\u4C57\uD868\uDF51\u474F\u45DA\u4C85\uD85F\uDC6C\u4D07\u4AA4\u46A1\uD85A\uDF23\u7225\uD856\uDE54\uD846\uDE63\uD84F\uDE06\uD84F\uDF61\u664D\u56FB"
    ],
    [
        "8767",
        "\u7D95\u591D\uD862\uDFB9\u3DF4\u9734\uD85E\uDFEF\u5BDB\uD847\uDD5E\u5AA4\u3625\uD867\uDEB0\u5AD1\u5BB7\u5CFC\u676E\u8593\uD866\uDD45\u7461\u749D\u3875\uD847\uDD53\uD84D\uDE9E\uD858\uDC21\u3EEC"
    ],
    [
        "87a1",
        "\uD856\uDCDE\u3AF5\u7AFC\u9F97\uD850\uDD61\uD862\uDD0D\uD84C\uDDEA\uD842\uDE8A\uD84C\uDE5E\u430A\u8484\u9F96\u942F\u4930\u8613\u5896\u974A\u9218\u79D0\u7A32\u6660\u6A29\u889D\u744C\u7BC5\u6782\u7A2C\u524F\u9046\u34E6\u73C4\uD857\uDDB9\u74C6\u9FC7\u57B3\u492F\u544C\u4131\uD84D\uDE8E\u5818\u7A72\uD85E\uDF65\u8B8F\u46AE\uD85B\uDE88\u4181\uD857\uDD99\u7BAE\uD849\uDCBC\u9FC8\uD849\uDCC1\uD849\uDCC9\uD849\uDCCC\u9FC9\u8504\uD84D\uDDBB\u40B4\u9FCA\u44E1\uD86B\uDDFF\u62C1\u706E\u9FCB"
    ],
    [
        "8840",
        "\u31C0",
        4,
        "\uD840\uDD0C\u31C5\uD840\uDCD1\uD840\uDCCD\u31C6\u31C7\uD840\uDCCB\uD847\uDFE8\u31C8\uD840\uDCCA\u31C9\u31CA\u31CB\u31CC\uD840\uDD0E\u31CD\u31CE\u0100\xc1\u01CD\xc0\u0112\xc9\u011A\xc8\u014C\xd3\u01D1\xd2\u0FFF\xca\u0304\u1EBE\u0FFF\xca\u030C\u1EC0\xca\u0101\xe1\u01CE\xe0\u0251\u0113\xe9\u011B\xe8\u012B\xed\u01D0\xec\u014D\xf3\u01D2\xf2\u016B\xfa\u01D4\xf9\u01D6\u01D8\u01DA"
    ],
    [
        "88a1",
        "\u01DC\xfc\u0FFF\xea\u0304\u1EBF\u0FFF\xea\u030C\u1EC1\xea\u0261\u23DA\u23DB"
    ],
    [
        "8940",
        "\uD868\uDFA9\uD844\uDD45"
    ],
    [
        "8943",
        "\u650A"
    ],
    [
        "8946",
        "\u4E3D\u6EDD\u9D4E\u91DF"
    ],
    [
        "894c",
        "\uD85D\uDF35\u6491\u4F1A\u4F28\u4FA8\u5156\u5174\u519C\u51E4\u52A1\u52A8\u533B\u534E\u53D1\u53D8\u56E2\u58F0\u5904\u5907\u5932\u5934\u5B66\u5B9E\u5B9F\u5C9A\u5E86\u603B\u6589\u67FE\u6804\u6865\u6D4E\u70BC\u7535\u7EA4\u7EAC\u7EBA\u7EC7\u7ECF\u7EDF\u7F06\u7F37\u827A\u82CF\u836F\u89C6\u8BBE\u8BE2\u8F66\u8F67\u8F6E"
    ],
    [
        "89a1",
        "\u7411\u7CFC\u7DCD\u6946\u7AC9\u5227"
    ],
    [
        "89ab",
        "\u918C\u78B8\u915E\u80BC"
    ],
    [
        "89b0",
        "\u8D0B\u80F6\uD842\uDDE7"
    ],
    [
        "89b5",
        "\u809F\u9EC7\u4CCD\u9DC9\u9E0C\u4C3E\uD867\uDDF6\uD85C\uDC0E\u9E0A\uD868\uDD33\u35C1"
    ],
    [
        "89c1",
        "\u6E9A\u823E\u7519"
    ],
    [
        "89c5",
        "\u4911\u9A6C\u9A8F\u9F99\u7987\uD861\uDC6C\uD847\uDDCA\uD841\uDDD0\uD84A\uDEE6\u4E24\u4E81\u4E80\u4E87\u4EBF\u4EEB\u4F37\u344C\u4FBD\u3E48\u5003\u5088\u347D\u3493\u34A5\u5186\u5905\u51DB\u51FC\u5205\u4E89\u5279\u5290\u5327\u35C7\u53A9\u3551\u53B0\u3553\u53C2\u5423\u356D\u3572\u3681\u5493\u54A3\u54B4\u54B9\u54D0\u54EF\u5518\u5523\u5528\u3598\u553F\u35A5\u35BF\u55D7\u35C5"
    ],
    [
        "8a40",
        "\uD85F\uDD84\u5525"
    ],
    [
        "8a43",
        "\uD843\uDC42\uD843\uDD15\uD854\uDD2B\u5590\uD84B\uDCC6\u39EC\uD840\uDF41\u8E46\uD853\uDDB8\uD865\uDCE5\u4053\uD860\uDCBE\u777A\uD84B\uDC38\u3A34\u47D5\uD860\uDD5D\uD85A\uDDF2\uD853\uDDEA\u64DD\uD843\uDD7C\uD843\uDFB4\uD843\uDCD5\uD844\uDCF4\u648D\u8E7E\uD843\uDE96\uD843\uDC0B\uD843\uDF64\uD84B\uDCA9\uD860\uDE56\uD851\uDCD3"
    ],
    [
        "8a64",
        "\uD843\uDD46\uD866\uDE4D\uD860\uDCE9\u47F4\uD853\uDEA7\uD84B\uDCC2\u9AB2\u3A67\uD865\uDDF4\u3FED\u3506\uD854\uDEC7\uD865\uDFD4\uD85E\uDCC8\uD84B\uDD44\u9D6E\u9815"
    ],
    [
        "8a76",
        "\u43D9\uD858\uDCA5\u64B4\u54E3\uD84B\uDD4C\uD84A\uDFCA\uD844\uDC77\u39FB\uD844\uDC6F"
    ],
    [
        "8aa1",
        "\uD859\uDEDA\uD859\uDF16\uD85E\uDDA0\u64EA\uD854\uDC52\uD843\uDC43\u8E68\uD848\uDDA1\uD862\uDF4C\uD841\uDF31"
    ],
    [
        "8aac",
        "\u480B\uD840\uDDA9\u3FFA\u5873\uD84B\uDD8D"
    ],
    [
        "8ab2",
        "\uD851\uDDC8\uD841\uDCFC\uD858\uDC97\uD843\uDF4C\uD843\uDD96\u5579\u40BB\u43BA"
    ],
    [
        "8abb",
        "\u4AB4\uD84A\uDE66\uD844\uDC9D\u81AA\u98F5\uD843\uDD9C\u6379\u39FE\uD849\uDF75\u8DC0\u56A1\u647C\u3E43"
    ],
    [
        "8ac9",
        "\uD869\uDE01\uD843\uDE09\uD84A\uDECF\uD84B\uDCC9"
    ],
    [
        "8ace",
        "\uD844\uDCC8\uD84E\uDDC2\u3992\u3A06\uD860\uDE9B\u3578\uD857\uDE49\uD848\uDCC7\u5652\uD843\uDF31\uD84B\uDCB2\uD865\uDF20\u34BC\u6C3D\uD853\uDE3B"
    ],
    [
        "8adf",
        "\uD85D\uDD74\uD84B\uDE8B\uD848\uDE08\uD869\uDE5B\uD863\uDCCD\uD843\uDE7A\uD843\uDC34\uD85A\uDC1C\u7F93\uD844\uDCCF\uD84A\uDC03\uD84A\uDD39\u35FB\uD854\uDDE3\uD843\uDE8C\uD843\uDF8D\uD843\uDEAA\u3F93\uD843\uDF30\uD843\uDD47\uD844\uDD4F\uD843\uDE4C"
    ],
    [
        "8af6",
        "\uD843\uDEAB\uD842\uDFA9\uD843\uDD48\uD844\uDCC0\uD844\uDD3D\u3FF9\uD849\uDE96\u6432\uD843\uDFAD"
    ],
    [
        "8b40",
        "\uD84C\uDFF4\uD85D\uDE39\uD84A\uDFCE\uD843\uDD7E\uD843\uDD7F\uD84B\uDC51\uD84B\uDC55\u3A18\uD843\uDE98\uD844\uDCC7\uD843\uDF2E\uD869\uDE32\uD85A\uDF50\uD863\uDCD2\uD863\uDD99\uD863\uDCCA\u95AA\u54CC\u82C4\u55B9"
    ],
    [
        "8b55",
        "\uD867\uDEC3\u9C26\u9AB6\uD85D\uDF5E\uD84B\uDDEE\u7140\u816D\u80EC\u5C1C\uD859\uDD72\u8134\u3797\u535F\uD860\uDCBD\u91B6\uD843\uDEFA\uD843\uDE0F\uD843\uDE77\uD843\uDEFB\u35DD\uD853\uDDEB\u3609\uD843\uDCD6\u56AF\uD849\uDFB5\uD844\uDCC9\uD843\uDE10\uD843\uDE78\uD844\uDC78\uD844\uDD48\uD860\uDE07\uD845\uDC55\uD843\uDE79\uD853\uDE50\uD84B\uDDA4\u5A54\uD844\uDC1D\uD844\uDC1E\uD844\uDCF5\uD844\uDCF6\u579C\uD843\uDE11"
    ],
    [
        "8ba1",
        "\uD85D\uDE94\uD860\uDECD\uD843\uDFB5\uD843\uDE7B\uD854\uDD7E\u3703\uD843\uDFB6\uD844\uDD80\uD854\uDED8\uD868\uDEBD\uD852\uDDDA\uD846\uDC3A\uD850\uDD77\uD860\uDE7C\u5899\u5268\u361A\uD855\uDF3D\u7BB2\u5B68\u4800\u4B2C\u9F27\u49E7\u9C1F\u9B8D\uD856\uDF74\uD84C\uDD3D\u55FB\u35F2\u5689\u4E28\u5902\uD846\uDFC1\uD87E\uDC78\u9751\uD840\uDC86\u4E5B\u4EBB\u353E\u5C23\u5F51\u5FC4\u38FA\u624C\u6535\u6B7A\u6C35\u6C3A\u706C\u722B\u4E2C\u72AD\uD852\uDCE9\u7F52\u793B\u7CF9\u7F53\uD858\uDE6A\u34C1"
    ],
    [
        "8bde",
        "\uD858\uDF4B\u8002\u8080\uD859\uDE12\uD85A\uDD51\u535D\u8864\u89C1\uD85E\uDCB2\u8BA0\u8D1D\u9485\u9578\u957F\u95E8\uD863\uDE0F\u97E6\u9875\u98CE\u98DE\u9963\uD866\uDC10\u9C7C\u9E1F\u9EC4\u6B6F\uF907\u4E37\uD840\uDC87\u961D\u6237\u94A2"
    ],
    [
        "8c40",
        "\u503B\u6DFE\uD867\uDC73\u9FA6\u3DC9\u888F\uD850\uDD4E\u7077\u5CF5\u4B20\uD854\uDDCD\u3559\uD857\uDD30\u6122\uD862\uDE32\u8FA7\u91F6\u7191\u6719\u73BA\uD84C\uDE81\uD868\uDD07\u3C8B\uD846\uDD80\u4B10\u78E4\u7402\u51AE\uD861\uDF0F\u4009\u6A63\uD868\uDEBA\u4223\u860F\uD842\uDE6F\u7A2A\uD866\uDD47\uD862\uDEEA\u9755\u704D\u5324\uD848\uDC7E\u93F4\u76D9\uD862\uDDE3\u9FA7\u77DD\u4EA3\u4FF0\u50BC\u4E2F\u4F17\u9FA8\u5434\u7D8B\u5892\u58D0\uD847\uDDB6\u5E92\u5E99\u5FC2\uD849\uDF12\u658B"
    ],
    [
        "8ca1",
        "\uD84C\uDFF9\u6919\u6A43\uD84F\uDC63\u6CFF"
    ],
    [
        "8ca7",
        "\u7200\uD851\uDD05\u738C\u3EDB\uD852\uDE13\u5B15\u74B9\u8B83\uD857\uDCA4\uD855\uDE95\u7A93\u7BEC\u7CC3\u7E6C\u82F8\u8597\u9FA9\u8890\u9FAA\u8EB9\u9FAB\u8FCF\u855F\u99E0\u9221\u9FAC\uD863\uDDB9\uD845\uDC3F\u4071\u42A2\u5A1A"
    ],
    [
        "8cc9",
        "\u9868\u676B\u4276\u573D"
    ],
    [
        "8cce",
        "\u85D6\uD852\uDD7B\u82BF\uD85C\uDD0D\u4C81\uD85B\uDD74\u5D7B\uD85A\uDF15\uD85B\uDFBE\u9FAD\u9FAE\u5B96\u9FAF\u66E7\u7E5B\u6E57\u79CA\u3D88\u44C3\uD84C\uDE56\uD849\uDF96\u439A\u4536"
    ],
    [
        "8ce6",
        "\u5CD5\uD84E\uDF1A\u8AF9\u5C78\u3D12\uD84D\uDD51\u5D78\u9FB2\u7157\u4558\uD850\uDCEC\uD847\uDE23\u4C77\u3978\u344A\uD840\uDDA4\uD85B\uDC41\u8ACC\u4FB4\uD840\uDE39\u59BF\u816C\u9856\uD866\uDCFA\u5F3B"
    ],
    [
        "8d40",
        "\uD842\uDF9F"
    ],
    [
        "8d42",
        "\uD848\uDDC1\uD862\uDD6D\u4102\u46BB\uD864\uDC79\u3F07\u9FB3\uD868\uDDB5\u40F8\u37D6\u46F7\uD85B\uDC46\u417C\uD861\uDEB2\uD85C\uDFFF\u456D\u38D4\uD855\uDC9A\u4561\u451B\u4D89\u4C7B\u4D76\u45EA\u3FC8\uD852\uDF0F\u3661\u44DE\u44BD\u41ED\u5D3E\u5D48\u5D56\u3DFC\u380F\u5DA4\u5DB9\u3820\u3838\u5E42\u5EBD\u5F25\u5F83\u3908\u3914\u393F\u394D\u60D7\u613D\u5CE5\u3989\u61B7\u61B9\u61CF\u39B8\u622C\u6290\u62E5\u6318\u39F8\u56B1"
    ],
    [
        "8da1",
        "\u3A03\u63E2\u63FB\u6407\u645A\u3A4B\u64C0\u5D15\u5621\u9F9F\u3A97\u6586\u3ABD\u65FF\u6653\u3AF2\u6692\u3B22\u6716\u3B42\u67A4\u6800\u3B58\u684A\u6884\u3B72\u3B71\u3B7B\u6909\u6943\u725C\u6964\u699F\u6985\u3BBC\u69D6\u3BDD\u6A65\u6A74\u6A71\u6A82\u3BEC\u6A99\u3BF2\u6AAB\u6AB5\u6AD4\u6AF6\u6B81\u6BC1\u6BEA\u6C75\u6CAA\u3CCB\u6D02\u6D06\u6D26\u6D81\u3CEF\u6DA4\u6DB1\u6E15\u6E18\u6E29\u6E86\uD862\uDDC0\u6EBB\u6EE2\u6EDA\u9F7F\u6EE8\u6EE9\u6F24\u6F34\u3D46\uD84F\uDF41\u6F81\u6FBE\u3D6A\u3D75\u71B7\u5C99\u3D8A\u702C\u3D91\u7050\u7054\u706F\u707F\u7089\uD840\uDF25\u43C1\u35F1\uD843\uDED8"
    ],
    [
        "8e40",
        "\uD84F\uDED7\u57BE\uD85B\uDED3\u713E\uD855\uDFE0\u364E\u69A2\uD862\uDFE9\u5B74\u7A49\uD856\uDCE1\uD865\uDCD9\u7A65\u7A7D\uD856\uDDAC\u7ABB\u7AB0\u7AC2\u7AC3\u71D1\uD859\uDC8D\u41CA\u7ADA\u7ADD\u7AEA\u41EF\u54B2\uD857\uDC01\u7B0B\u7B55\u7B29\uD854\uDF0E\uD857\uDCFE\u7BA2\u7B6F\u839C\uD856\uDFB4\uD85B\uDC7F\u7BD0\u8421\u7B92\u7BB8\uD857\uDD20\u3DAD\uD857\uDC65\u8492\u7BFA\u7C06\u7C35\uD857\uDCC1\u7C44\u7C83\uD852\uDC82\u7CA6\u667D\uD851\uDD78\u7CC9\u7CC7\u7CE6\u7C74\u7CF3\u7CF5\u7CCE"
    ],
    [
        "8ea1",
        "\u7E67\u451D\uD85B\uDE44\u7D5D\uD85B\uDED6\u748D\u7D89\u7DAB\u7135\u7DB3\u7DD2\uD850\uDC57\uD858\uDC29\u7DE4\u3D13\u7DF5\uD845\uDFF9\u7DE5\uD860\uDF6D\u7E1D\uD858\uDD21\uD858\uDD5A\u7E6E\u7E92\u432B\u946C\u7E27\u7F40\u7F41\u7F47\u7936\uD858\uDED0\u99E1\u7F97\uD858\uDF51\u7FA3\uD845\uDE61\uD840\uDC68\u455C\uD84D\uDF66\u4503\uD860\uDF3A\u7FFA\uD859\uDC89\u8005\u8008\u801D\u8028\u802F\uD868\uDC87\uD85B\uDCC3\u803B\u803C\u8061\uD849\uDF14\u4989\uD859\uDE26\uD84F\uDDE3\uD859\uDEE8\u6725\u80A7\uD862\uDE48\u8107\u811A\u58B0\uD849\uDEF6\u6C7F\uD859\uDC98\uD853\uDFB8\u64E7\uD845\uDC8A\u8218\uD846\uDC5E\u6A53\uD852\uDE65\uD852\uDE95\u447A\u8229\uD842\uDF0D\uD85A\uDE52\uD84F\uDD7E\u4FF9\uD845\uDCFD\u84E2\u8362\uD85A\uDF0A\uD852\uDDA7\uD84D\uDD30\uD845\uDF73\uD84F\uDDF8\u82AA\u691B\uD87E\uDD94\u41DB"
    ],
    [
        "8f40",
        "\u854B\u82D0\u831A\uD843\uDE16\uD845\uDFB4\u36C1\uD84C\uDD7D\uD84D\uDD5A\u827B\u82E2\u8318\uD84F\uDE8B\uD85B\uDDA3\uD85A\uDF05\uD85A\uDF97\uD84D\uDDCE\u3DBF\u831D\u55EC\u8385\u450B\uD85B\uDDA5\u83AC\u83C1\u83D3\u347E\uD85B\uDED4\u6A57\u855A\u3496\uD85B\uDE42\uD84B\uDEEF\u8458\uD856\uDFE4\u8471\u3DD3\u44E4\u6AA7\u844A\uD84F\uDCB5\u7958\u84A8\uD85A\uDF96\uD85B\uDE77\uD85B\uDE43\u84DE\u840F\u8391\u44A0\u8493\u84E4\uD857\uDC91\u4240\uD857\uDCC0\u4543\u8534\u5AF2\uD85B\uDE99\u4527\u8573\u4516\u67BF\u8616"
    ],
    [
        "8fa1",
        "\uD861\uDE25\uD861\uDE3B\u85C1\uD85C\uDC88\u8602\uD845\uDD82\uD85C\uDCCD\uD87E\uDDB2\u456A\u8628\u3648\uD846\uDCA2\u53F7\uD85C\uDF9A\u867E\u8771\uD868\uDCF8\u87EE\uD84B\uDC27\u87B1\u87DA\u880F\u5661\u866C\u6856\u460F\u8845\u8846\uD85D\uDDE0\uD84F\uDDB9\uD85D\uDDE4\u885E\u889C\u465B\u88B4\u88B5\u63C1\u88C5\u7777\uD85D\uDF0F\u8987\u898A\u89A6\u89A9\u89A7\u89BC\uD862\uDE25\u89E7\uD85E\uDD24\uD85E\uDEBD\u8A9C\u7793\u91FE\u8A90\uD85E\uDE59\u7AE9\uD85E\uDF3A\uD84F\uDF8F\u4713\uD85E\uDF38\u717C\u8B0C\u8B1F\uD855\uDC30\uD855\uDD65\u8B3F\u8B4C\u8B4D\u8AA9\uD852\uDE7A\u8B90\u8B9B\u8AAF\uD845\uDEDF\u4615\u884F\u8C9B\uD85F\uDD54\uD85F\uDD8F\uD87E\uDDD4\u3725\uD85F\uDD53\u8CD6\uD85F\uDD98\uD85F\uDDBD\u8D12\u8D03\uD846\uDD10\u8CDB\u705C\u8D11\uD853\uDCC9\u3ED0\u8D77"
    ],
    [
        "9040",
        "\u8DA9\uD860\uDC02\uD844\uDC14\uD852\uDD8A\u3B7C\uD860\uDDBC\uD85C\uDD0C\u7AE7\u8EAD\u8EB6\u8EC3\u92D4\u8F19\u8F2D\uD860\uDF65\uD861\uDC12\u8FA5\u9303\uD868\uDE9F\uD842\uDE50\u8FB3\u492A\uD862\uDDDE\uD861\uDD3D\uD84F\uDDBB\u5EF8\uD84C\uDE62\u8FF9\uD868\uDC14\uD861\uDEBC\uD861\uDD01\uD848\uDF25\u3980\uD85B\uDED7\u9037\uD861\uDD3C\uD85E\uDEBE\u9061\uD861\uDD6C\uD861\uDE0B\u90A8\uD861\uDF13\u90C4\uD861\uDEE6\u90AE\u90FD\u9167\u3AF0\u91A9\u91C4\u7CAC\uD862\uDD33\uD847\uDE89\u920E\u6C9F\u9241\u9262\uD855\uDDB9\u92B9\uD862\uDEC6\uD84F\uDC9B\uD862\uDF0C\uD855\uDDDB"
    ],
    [
        "90a1",
        "\uD843\uDD31\u932C\u936B\uD862\uDEE1\uD862\uDFEB\u708F\u5AC3\uD862\uDEE2\uD862\uDEE5\u4965\u9244\uD862\uDFEC\uD863\uDC39\uD862\uDFFF\u9373\u945B\u8EBC\u9585\u95A6\u9426\u95A0\u6FF6\u42B9\uD849\uDE7A\uD861\uDED8\uD844\uDE7C\uD84F\uDE2E\u49DF\u6C1C\u967B\u9696\u416C\u96A3\uD85B\uDED5\u61DA\u96B6\u78F5\uD862\uDEE0\u96BD\u53CC\u49A1\uD85B\uDCB8\uD840\uDE74\uD859\uDC10\uD864\uDCAF\uD864\uDCE5\uD852\uDED1\uD846\uDD15\uD84C\uDF0A\u9731\u8642\u9736\u4A0F\u453D\u4585\uD852\uDEE9\u7075\u5B41\u971B\u975C\uD864\uDDD5\u9757\u5B4A\uD864\uDDEB\u975F\u9425\u50D0\uD84C\uDCB7\uD84C\uDCBC\u9789\u979F\u97B1\u97BE\u97C0\u97D2\u97E0\uD855\uDC6C\u97EE\u741C\uD865\uDC33\u97FF\u97F5\uD865\uDC1D\uD85E\uDD7A\u4AD1\u9834\u9833\u984B\u9866\u3B0E\uD85C\uDD75\u3D51\uD841\uDE30\uD850\uDD5C"
    ],
    [
        "9140",
        "\uD855\uDF06\u98CA\u98B7\u98C8\u98C7\u4AFF\uD85B\uDD27\uD845\uDED3\u55B0\u98E1\u98E6\u98EC\u9378\u9939\uD852\uDE29\u4B72\uD866\uDC57\uD866\uDD05\u99F5\u9A0C\u9A3B\u9A10\u9A58\uD855\uDF25\u36C4\uD864\uDCB1\uD866\uDFD5\u9AE0\u9AE2\uD866\uDF05\u9AF4\u4C0E\u9B14\u9B2D\uD861\uDE00\u5034\u9B34\uD85A\uDDA8\u38C3\uD84C\uDC7D\u9B50\u9B40\uD867\uDD3E\u5A45\uD846\uDC63\u9B8E\uD850\uDE4B\u9C02\u9BFF\u9C0C\uD867\uDE68\u9DD4\uD867\uDFB7\uD868\uDD92\uD868\uDDAB\uD868\uDCE1\uD868\uDD23\uD868\uDDDF\u9D7E\u9D83\uD868\uDD34\u9E0E\u6888"
    ],
    [
        "91a1",
        "\u9DC4\uD848\uDD5B\uD868\uDD93\uD868\uDE20\uD846\uDD3B\uD868\uDE33\u9D39\uD868\uDCB9\uD868\uDEB4\u9E90\u9E95\u9E9E\u9EA2\u4D34\u9EAA\u9EAF\uD850\uDF64\u9EC1\u3B60\u39E5\u3D1D\u4F32\u37BE\uD863\uDC2B\u9F02\u9F08\u4B96\u9424\uD85B\uDDA2\u9F17\u9F16\u9F39\u569F\u568A\u9F45\u99B8\uD864\uDC8B\u97F2\u847F\u9F62\u9F69\u7ADC\u9F8E\u7216\u4BBE\uD852\uDD75\uD852\uDDBB\u7177\uD852\uDDF8\uD850\uDF48\uD852\uDE51\u739E\uD862\uDFDA\uD846\uDCFA\u799F\uD862\uDD7E\uD863\uDE36\u9369\u93F3\uD862\uDE44\u92EC\u9381\u93CB\uD862\uDD6C\uD851\uDCB9\u7217\u3EEB\u7772\u7A43\u70D0\uD851\uDC73\uD850\uDFF8\u717E\uD845\uDFEF\u70A3\uD846\uDCBE\uD84D\uDD99\u3EC7\uD846\uDC85\uD855\uDC2F\uD845\uDFF8\u3722\uD845\uDEFB\uD846\uDC39\u36E1\uD845\uDF74\uD846\uDCD1\uD857\uDF4B\u3723\uD845\uDEC0\u575B\uD852\uDE25\uD844\uDFFE\uD844\uDEA8"
    ],
    [
        "9240",
        "\uD844\uDFC6\uD845\uDCB6\u8503\uD84D\uDEA6\u8503\u8455\uD852\uDD94\uD85C\uDD65\uD84F\uDE31\uD855\uDD5C\uD84F\uDEFB\uD85C\uDC52\u44F4\uD84D\uDEEE\uD866\uDD9D\uD85B\uDF26\u67F9\u3733\u3C15\u3DE7\u586C\uD846\uDD22\u6810\u4057\uD84D\uDF3F\uD850\uDCE1\uD850\uDC8B\uD850\uDD0F\uD85B\uDC21\u54CB\u569E\uD859\uDEB1\u5692\uD843\uDFDF\uD842\uDFA8\uD843\uDE0D\u93C6\uD862\uDF13\u939C\u4EF8\u512B\u3819\uD851\uDC36\u4EBC\uD841\uDC65\uD840\uDF7F\u4F4B\u4F8A\uD855\uDE51\u5A68\uD840\uDDAB\uD840\uDFCB\u3999\uD840\uDF0A\uD841\uDC14\u3435\u4F29\uD840\uDEC0\uD863\uDEB3\uD840\uDE75\u8ADA\uD840\uDE0C\u4E98"
    ],
    [
        "92a1",
        "\u50CD\u510D\u4FA2\u4F03\uD852\uDE0E\uD84F\uDE8A\u4F42\u502E\u506C\u5081\u4FCC\u4FE5\u5058\u50FC\u5159\u515B\u515D\u515E\u6E76\uD84D\uDD95\uD84F\uDE39\uD84F\uDEBF\u6D72\uD846\uDC84\uD84F\uDE89\u51A8\u51C3\uD841\uDDE0\u44DD\uD841\uDCA3\uD841\uDC92\uD841\uDC91\u8D7A\uD862\uDE9C\uD841\uDF0E\u5259\u52A4\uD842\uDC73\u52E1\u936E\u467A\u718C\uD850\uDF8C\uD843\uDC20\uD852\uDDAC\uD844\uDCE4\u69D1\uD843\uDE1D\u7479\u3EDE\u7499\u7414\u7456\u7398\u4B8E\uD852\uDEBC\uD850\uDC8D\u53D0\u3584\u720F\uD850\uDCC9\u55B4\uD840\uDF45\u54CD\uD842\uDFC6\u571D\u925D\u96F4\u9366\u57DD\u578D\u577F\u363E\u58CB\u5A99\uD862\uDE46\uD845\uDEFA\uD845\uDF6F\uD845\uDF10\u5A2C\u59B8\u928F\u5A7E\u5ACF\u5A12\uD856\uDD46\uD846\uDDF3\uD846\uDC61\uD850\uDE95\u36F5\u6D05\u7443\u5A21\uD857\uDE83"
    ],
    [
        "9340",
        "\u5A81\uD862\uDFD7\uD841\uDC13\u93E0\u748C\uD844\uDF03\u7105\u4972\u9408\uD862\uDDFB\u93BD\u37A0\u5C1E\u5C9E\u5E5E\u5E48\uD846\uDD96\uD846\uDD7C\uD84E\uDEEE\u5ECD\u5B4F\uD846\uDD03\uD846\uDD04\u3701\uD846\uDCA0\u36DD\uD845\uDEFE\u36D3\u812A\uD862\uDE47\uD847\uDDBA\uD84D\uDC72\uD862\uDDA8\u5F0C\u5F0E\uD846\uDD27\uD845\uDFAB\u5A6B\uD845\uDF3B\u5B44\u8614\uD85D\uDDFD\u8860\u607E\uD84A\uDC60\uD849\uDE2B\u5FDB\u3EB8\uD849\uDDAF\uD849\uDDBE\uD864\uDC88\uD85B\uDF73\u61C0\uD840\uDC3E\uD840\uDC46\uD849\uDE1B\u6199\u6198\u6075\uD84B\uDC9B\uD84B\uDD07\uD851\uDED4\uD864\uDD4D"
    ],
    [
        "93a1",
        "\u6471\uD851\uDE65\uD84A\uDF6A\u3A29\uD84A\uDF22\uD84D\uDC50\uD866\uDCEA\uD84B\uDE78\u6337\uD869\uDC5B\u64B6\u6331\u63D1\uD852\uDDE3\uD84B\uDD67\u62A4\uD84B\uDCA1\u643B\u656B\u6972\u3BF4\uD84C\uDC8E\uD84C\uDEAD\uD852\uDD89\uD84C\uDEAB\u550D\uD84C\uDEE0\uD846\uDCD9\uD865\uDC3F\u66CE\uD84C\uDE89\uD84C\uDDB3\u3AE0\u4190\uD855\uDD84\uD862\uDF22\uD855\uDD8F\uD845\uDEFC\uD855\uDD5B\uD855\uDC25\u78EE\uD84C\uDD03\uD846\uDC2A\uD84C\uDE34\u3464\uD84C\uDE0F\uD84C\uDD82\uD850\uDEC9\u668E\uD85B\uDD24\u666B\u4B93\u6630\uD85E\uDC70\uD847\uDDEB\u6663\uD84C\uDED2\uD84C\uDEE1\u661E\uD856\uDC72\u38D1\uD84E\uDC3A\uD84D\uDFBC\u3B99\uD84D\uDFA2\uD84C\uDFFE\u74D0\u3B96\u678F\uD851\uDE2A\u68B6\u681E\u3BC4\u6ABE\u3863\uD84D\uDFD5\uD851\uDC87\u6A33\u6A52\u6AC9\u6B05\uD846\uDD12\u6511\u6898\u6A4C\u3BD7\u6A7A\u6B57\uD84F\uDFC0\uD84F\uDC9A\u93A0\u92F2\uD862\uDFEA\uD862\uDECB"
    ],
    [
        "9440",
        "\u9289\uD860\uDC1E\uD862\uDDDC\u9467\u6DA5\u6F0B\uD852\uDDEC\u6D67\uD84F\uDF7F\u3D8F\u6E04\uD850\uDC3C\u5A3D\u6E0A\u5847\u6D24\u7842\u713B\uD850\uDF1A\uD850\uDE76\u70F1\u7250\u7287\u7294\uD851\uDF8F\uD851\uDF25\u5179\uD852\uDEA4\uD841\uDDEB\u747A\uD84F\uDEF8\uD84D\uDE5F\uD852\uDE4A\uD852\uDD17\uD857\uDFE1\u3F06\u3EB1\uD852\uDEDF\uD863\uDC23\uD84F\uDF35\u60A7\u3EF3\u74CC\u743C\u9387\u7437\u449F\uD85B\uDDEA\u4551\u7583\u3F63\uD853\uDCD9\uD853\uDD06\u3F58\u7555\u7673\uD869\uDDC6\u3B19\u7468\uD862\uDECC\uD852\uDDAB\uD852\uDD8E\u3AFB"
    ],
    [
        "94a1",
        "\u3DCD\uD852\uDE4E\u3EFF\uD852\uDDC5\uD852\uDCF3\u91FA\u5732\u9342\uD862\uDEE3\uD846\uDC64\u50DF\uD854\uDE21\uD854\uDDE7\u7778\uD84C\uDE32\u770E\u770F\u777B\uD851\uDE97\uD84D\uDF81\u3A5E\uD852\uDCF0\u7438\u749B\u3EBF\uD852\uDEBA\uD852\uDEC7\u40C8\uD852\uDE96\uD858\uDDAE\u9307\uD855\uDD81\u781E\u788D\u7888\u78D2\u73D0\u7959\uD85D\uDF41\uD855\uDEE3\u410E\u799B\u8496\u79A5\u6A2D\uD84F\uDEFA\u7A3A\u79F4\u416E\uD845\uDEE6\u4132\u9235\u79F1\uD843\uDD4C\uD852\uDD8C\uD840\uDE99\uD84F\uDDBA\uD845\uDF6E\u3597\u556B\u3570\u36AA\uD840\uDDD4\uD843\uDC0D\u7AE2\u5A59\uD849\uDEF5\uD856\uDEAF\uD856\uDE9C\u5A0D\uD840\uDE5B\u78F0\u5A2A\uD856\uDFC6\u7AFE\u41F9\u7C5D\u7C6D\u4211\uD856\uDFB3\uD857\uDEBC\uD857\uDEA6\u7CCD\uD852\uDDF9\uD845\uDFB0\u7C8E\u7C7C\u7CAE\u6AB2\u7DDC\u7E07\u7DD3\u7F4E\uD858\uDE61"
    ],
    [
        "9540",
        "\uD858\uDD5C\uD85E\uDF48\u7D97\uD857\uDE82\u426A\uD85A\uDF75\uD842\uDD16\u67D6\uD840\uDC4E\uD84D\uDDCF\u57C4\uD859\uDC12\uD858\uDFF8\uD852\uDD62\u7FDD\u7B27\uD842\uDC2C\uD856\uDEE9\uD857\uDD43\u7B0C\uD857\uDE0E\u99E6\u8645\u9A63\u6A1C\uD84D\uDC3F\u39E2\uD852\uDDF7\uD859\uDDAD\u9A1F\uD859\uDDA0\u8480\uD85C\uDD27\uD85B\uDCD1\u44EA\u8137\u4402\u80C6\u8109\u8142\uD859\uDFB4\u98C3\uD85A\uDE42\u8262\u8265\uD85A\uDE51\u8453\uD85B\uDDA7\u8610\uD85C\uDE1B\u5A86\u417F\uD846\uDC40\u5B2B\uD846\uDCA1\u5AE4\uD846\uDCD8\u86A0\uD87E\uDDBC\uD84F\uDD8F\u882D\uD85D\uDC22\u5A02"
    ],
    [
        "95a1",
        "\u886E\u4F45\u8887\u88BF\u88E6\u8965\u894D\uD855\uDE83\u8954\uD85D\uDF85\uD85D\uDF84\uD862\uDFF5\uD862\uDFD9\uD862\uDF9C\uD862\uDDF9\u3EAD\u84A3\u46F5\u46CF\u37F2\u8A3D\u8A1C\uD865\uDC48\u5F4D\u922B\uD850\uDE84\u65D4\u7129\u70C4\uD846\uDC45\u9D6D\u8C9F\u8CE9\uD85F\uDDDC\u599A\u77C3\u59F0\u436E\u36D4\u8E2A\u8EA7\uD853\uDC09\u8F30\u8F4A\u42F4\u6C58\u6FBB\uD848\uDF21\u489B\u6F79\u6E8B\uD845\uDFDA\u9BE9\u36B5\uD852\uDD2F\u90BB\u9097\u5571\u4906\u91BB\u9404\uD862\uDE4B\u4062\uD862\uDEFC\u9427\uD863\uDC1D\uD863\uDC3B\u84E5\u8A2B\u9599\u95A7\u9597\u9596\uD863\uDD34\u7445\u3EC2\uD852\uDCFF\uD852\uDE42\uD850\uDFEA\u3EE7\uD84C\uDE25\u968F\uD863\uDEE7\uD863\uDE66\uD863\uDE65\u3ECC\uD852\uDDED\uD852\uDE78\uD84F\uDFEE\u7412\u746B\u3EFC\u9741\uD864\uDCB0"
    ],
    [
        "9640",
        "\u6847\u4A1D\uD864\uDC93\uD855\uDFDF\u975D\u9368\uD862\uDD89\uD863\uDC26\uD862\uDF2F\uD858\uDFBE\u92BA\u5B11\u8B69\u493C\u73F9\uD850\uDE1B\u979B\u9771\u9938\uD843\uDF26\u5DC1\uD862\uDFC5\uD852\uDEB2\u981F\uD865\uDCDA\u92F6\uD865\uDDD7\u91E5\u44C0\uD862\uDF50\uD852\uDE67\uD862\uDF64\u98DC\uD862\uDE45\u3F00\u922A\u4925\u8414\u993B\u994D\uD85E\uDF06\u3DFD\u999B\u4B6F\u99AA\u9A5C\uD862\uDF65\uD856\uDCC8\u6A8F\u9A21\u5AFE\u9A2F\uD866\uDCF1\u4B90\uD866\uDD48\u99BC\u4BBD\u4B97\u937D\u5872\uD844\uDF02\u5822\uD852\uDDB8"
    ],
    [
        "96a1",
        "\uD845\uDCE8\u7844\uD849\uDF1F\uD84F\uDDB8\u68C5\u3D7D\u9458\u3927\u6150\uD849\uDF81\uD84A\uDD6B\u6107\u9C4F\u9C53\u9C7B\u9C35\u9C10\u9B7F\u9BCF\uD867\uDE2D\u9B9F\uD868\uDDF5\uD868\uDCFE\u9D21\u4CAE\uD850\uDD04\u9E18\u4CB0\u9D0C\uD868\uDDB4\uD868\uDCED\uD868\uDCF3\uD866\uDD2F\u9DA5\u84BD\uD85B\uDE12\uD85B\uDFDF\uD85A\uDF82\u85FC\u4533\uD85B\uDDA4\uD85B\uDE84\uD85B\uDDF0\u8420\u85EE\uD85B\uDE00\uD84D\uDFD7\uD858\uDC64\u79E2\uD84D\uDD9C\uD84D\uDE40\u492D\uD852\uDDDE\u3D62\u93DB\u92BE\u9348\uD840\uDEBF\u78B9\u9277\u944D\u4FE4\u3440\u9064\uD855\uDD5D\u783D\u7854\u78B6\u784B\uD845\uDF57\uD84C\uDDC9\uD852\uDD41\u369A\u4F72\u6FDA\u6FD9\u701E\u701E\u5414\uD850\uDDB5\u57BB\u58F3\u578A\u9D16\u57D7\u7134\u34AF\uD850\uDDAC\u71EB\uD85B\uDC40\uD853\uDF97\u5B28\uD845\uDFB5\uD862\uDE49"
    ],
    [
        "9740",
        "\u610C\u5ACE\u5A0B\u42BC\uD851\uDC88\u372C\u4B7B\uD862\uDDFC\u93BB\u93B8\uD846\uDCD6\uD843\uDF1D\u8472\uD85B\uDCC0\uD845\uDC13\uD850\uDEFA\uD84B\uDC26\uD850\uDFC1\u5994\uD84F\uDDB7\uD859\uDF41\u7DA8\uD858\uDD5B\uD858\uDCA4\uD852\uDDB9\uD852\uDD8B\uD862\uDDFA\u92E5\u73E2\u3EE9\u74B4\uD862\uDF63\uD846\uDC9F\u3EE1\uD852\uDEB3\u6AD8\u73F3\u73FB\u3ED6\uD852\uDE3E\uD852\uDE94\uD845\uDFD9\uD852\uDE66\uD840\uDFA7\uD845\uDC24\uD852\uDDE5\u7448\uD852\uDD16\u70A5\uD852\uDD76\u9284\u73E6\u935F\uD841\uDCFE\u9331\uD862\uDECE\uD862\uDE16\u9386\uD862\uDFE7\uD855\uDDD5\u4935\uD862\uDE82\u716B"
    ],
    [
        "97a1",
        "\uD852\uDD43\uD843\uDCFF\u56A4\uD841\uDE1A\uD842\uDFEB\uD843\uDCB8\u5502\u79C4\uD845\uDFFA\u7DFE\uD845\uDEC2\uD852\uDE50\uD846\uDC52\u452E\u9401\u370A\uD862\uDEC0\uD852\uDDAD\u59B0\uD846\uDCBF\uD846\uDC83\uD85D\uDC84\u5AA1\u36E2\uD84F\uDD5B\u36B0\u925F\u5A79\uD862\uDE81\uD846\uDC62\u9374\u3CCD\uD842\uDEB4\u4A96\u398A\u50F4\u3D69\u3D4C\uD844\uDF9C\u7175\u42FB\uD860\uDE18\u6E0F\uD864\uDCE4\u44EB\u6D57\uD85F\uDE4F\u7067\u6CAF\u3CD6\uD84F\uDFED\uD84F\uDE2D\u6E02\u6F0C\u3D6F\uD840\uDFF5\u7551\u36BC\u34C8\u4680\u3EDA\u4871\u59C4\u926E\u493E\u8F41\uD863\uDC1C\uD85A\uDFC0\u5812\u57C8\u36D6\uD845\uDC52\u70FE\uD850\uDF62\uD852\uDE71\uD84B\uDFE3\uD844\uDEB0\uD848\uDFBD\u68B9\u6967\uD844\uDF98\uD84D\uDCE5\uD85E\uDFF4\uD84D\uDEDF\uD862\uDE83\uD84D\uDFD6\uD84C\uDFFA\uD853\uDC9F\u6A1A\uD84D\uDEAD\uD85B\uDCB7\u843E\u44DF\u44CE"
    ],
    [
        "9840",
        "\uD85B\uDD26\uD85B\uDD51\uD85B\uDC82\uD85B\uDFDE\u6F17\uD85C\uDD09\u833D\uD845\uDF3A\u83ED\uD85B\uDC80\uD85C\uDC53\uD845\uDFDB\u5989\u5A82\uD845\uDFB3\u5A61\u5A71\uD846\uDD05\uD850\uDDFC\u372D\u59EF\uD845\uDF3C\u36C7\u718E\u9390\u669A\uD850\uDEA5\u5A6E\u5A2B\uD850\uDE93\u6A2B\uD84F\uDEF9\uD85D\uDF36\uD851\uDC5B\uD850\uDECA\u711D\uD850\uDE59\uD862\uDDE1\u4FB0\uD85B\uDD28\u5CC2\uD851\uDCCE\uD85F\uDE4D\uD850\uDFBD\u6A0C\uD850\uDE56\uD844\uDF04\u70A6\u7133\uD850\uDFE9\u3DA5\u6CDF\uD87E\uDC25\uD852\uDE4F\u7E65\u59EB\u5D2F\u3DF3\u5F5C\uD852\uDE5D\uD845\uDFDF\u7DA4\u8426"
    ],
    [
        "98a1",
        "\u5485\uD84E\uDEFA\uD84C\uDF00\uD840\uDE14\u577E\uD842\uDCD5\uD841\uDE19\u3FE5\uD847\uDF9E\uD868\uDEB6\u7003\uD864\uDD5B\u5D70\u738F\u7CD3\uD862\uDE59\uD865\uDC20\u4FC8\u7FE7\u72CD\u7310\uD85E\uDEF4\u7338\u7339\uD855\uDEF6\u7341\u7348\u3EA9\uD85E\uDF18\u906C\u71F5\uD852\uDCF2\u73E1\u81F6\u3ECA\u770C\u3ED1\u6CA2\u56FD\u7419\u741E\u741F\u3EE2\u3EF0\u3EF4\u3EFA\u74D3\u3F0E\u3F53\u7542\u756D\u7572\u758D\u3F7C\u75C8\u75DC\u3FC0\u764D\u3FD7\u7674\u3FDC\u767A\uD853\uDF5C\u7188\u5623\u8980\u5869\u401D\u7743\u4039\u6761\u4045\u35DB\u7798\u406A\u406F\u5C5E\u77BE\u77CB\u58F2\u7818\u70B9\u781C\u40A8\u7839\u7847\u7851\u7866\u8448\uD855\uDD35\u7933\u6803\u7932\u4103"
    ],
    [
        "9940",
        "\u4109\u7991\u7999\u8FBB\u7A06\u8FBC\u4167\u7A91\u41B2\u7ABC\u8279\u41C4\u7ACF\u7ADB\u41CF\u4E21\u7B62\u7B6C\u7B7B\u7C12\u7C1B\u4260\u427A\u7C7B\u7C9C\u428C\u7CB8\u4294\u7CED\u8F93\u70C0\uD843\uDCCF\u7DCF\u7DD4\u7DD0\u7DFD\u7FAE\u7FB4\u729F\u4397\u8020\u8025\u7B39\u802E\u8031\u8054\u3DCC\u57B4\u70A0\u80B7\u80E9\u43ED\u810C\u732A\u810E\u8112\u7560\u8114\u4401\u3B39\u8156\u8159\u815A"
    ],
    [
        "99a1",
        "\u4413\u583A\u817C\u8184\u4425\u8193\u442D\u81A5\u57EF\u81C1\u81E4\u8254\u448F\u82A6\u8276\u82CA\u82D8\u82FF\u44B0\u8357\u9669\u698A\u8405\u70F5\u8464\u60E3\u8488\u4504\u84BE\u84E1\u84F8\u8510\u8538\u8552\u453B\u856F\u8570\u85E0\u4577\u8672\u8692\u86B2\u86EF\u9645\u878B\u4606\u4617\u88AE\u88FF\u8924\u8947\u8991\uD85E\uDD67\u8A29\u8A38\u8A94\u8AB4\u8C51\u8CD4\u8CF2\u8D1C\u4798\u585F\u8DC3\u47ED\u4EEE\u8E3A\u55D8\u5754\u8E71\u55F5\u8EB0\u4837\u8ECE\u8EE2\u8EE4\u8EED\u8EF2\u8FB7\u8FC1\u8FCA\u8FCC\u9033\u99C4\u48AD\u98E0\u9213\u491E\u9228\u9258\u926B\u92B1\u92AE\u92BF"
    ],
    [
        "9a40",
        "\u92E3\u92EB\u92F3\u92F4\u92FD\u9343\u9384\u93AD\u4945\u4951\u9EBF\u9417\u5301\u941D\u942D\u943E\u496A\u9454\u9479\u952D\u95A2\u49A7\u95F4\u9633\u49E5\u67A0\u4A24\u9740\u4A35\u97B2\u97C2\u5654\u4AE4\u60E8\u98B9\u4B19\u98F1\u5844\u990E\u9919\u51B4\u991C\u9937\u9942\u995D\u9962\u4B70\u99C5\u4B9D\u9A3C\u9B0F\u7A83\u9B69\u9B81\u9BDD\u9BF1\u9BF4\u4C6D\u9C20\u376F\uD846\uDFC2\u9D49\u9C3A"
    ],
    [
        "9aa1",
        "\u9EFE\u5650\u9D93\u9DBD\u9DC0\u9DFC\u94F6\u8FB6\u9E7B\u9EAC\u9EB1\u9EBD\u9EC6\u94DC\u9EE2\u9EF1\u9EF8\u7AC8\u9F44\uD840\uDC94\uD840\uDEB7\uD840\uDFA0\u691A\u94C3\u59AC\uD841\uDCD7\u5840\u94C1\u37B9\uD841\uDDD5\uD841\uDE15\uD841\uDE76\uD845\uDEBA\u5757\u7173\uD842\uDEC2\uD842\uDECD\uD842\uDFBF\u546A\uD87E\uDC3B\uD842\uDFCB\u549E\uD842\uDFFB\uD843\uDC3B\uD843\uDC53\uD843\uDC65\uD843\uDC7C\u60E7\uD843\uDC8D\u567A\uD843\uDCB5\uD843\uDCDD\uD843\uDCED\uD843\uDD6F\uD843\uDDB2\uD843\uDDC8\u6955\u9C2F\u87A5\uD843\uDE04\uD843\uDE0E\uD843\uDED7\uD843\uDF90\uD843\uDF2D\uD843\uDE73\u5C20\uD843\uDFBC\u5E0B\uD844\uDC5C\uD844\uDC4F\uD844\uDC76\u671E\uD844\uDC7B\uD844\uDC88\uD844\uDC96\u3647\uD844\uDCBF\uD844\uDCD3\uD844\uDD2F\uD844\uDD3B\u5364\u84AD\uD844\uDEE3\uD844\uDF75\uD844\uDF36\u8B81\uD845\uDD77\uD845\uDE19\uD845\uDFC3\uD845\uDFC7\u4E78\u70BB\uD846\uDC2D\uD846\uDD6A"
    ],
    [
        "9b40",
        "\uD846\uDE2D\uD846\uDE45\uD847\uDC2A\uD847\uDC70\uD847\uDCAC\uD847\uDEC8\u62C3\uD847\uDED5\uD847\uDF15\u7198\u6855\uD848\uDC45\u69E9\u36C8\uD848\uDE7C\uD848\uDFD7\uD848\uDFFA\uD849\uDF2A\uD84A\uDC71\uD84A\uDD4F\u82FD\uD84A\uDD67\uD84A\uDD93\uD84A\uDED5\u89A5\uD84A\uDEE8\u8FA0\uD84A\uDF0E\u97B8\uD84A\uDF3F\u9847\u9ABD\uD84B\uDC4C"
    ],
    [
        "9b62",
        "\uD84B\uDC88\uD84B\uDCB7\uD856\uDFE8\uD84B\uDD08\uD84B\uDD12\uD84B\uDDB7\uD84B\uDD95\uD84B\uDE42\uD84B\uDF74\uD84B\uDFCC\uD84C\uDC33\uD84C\uDC66\uD84C\uDF1F\uD84C\uDFDE\u5FB1\u6648\u66BF\uD85E\uDE79\uD84D\uDD67\uD84D\uDDF3\u7201\uD852\uDDBA\u77D7\uD84D\uDE1A\uD84D\uDF16\u7E87\uD840\uDF46\u58B5\u670E"
    ],
    [
        "9ba1",
        "\u6918\uD84E\uDEA7\uD85D\uDE57\uD857\uDFE2\uD84F\uDE11\uD84F\uDEB9\uD85D\uDDFE\uD848\uDC9A\u48D0\u4AB8\uD850\uDD19\uD862\uDE9A\uD850\uDEEE\uD850\uDF0D\uD850\uDC3B\uD850\uDF34\uD850\uDF96\uD852\uDE45\uD841\uDDCA\u51D2\uD841\uDE11\u599F\uD847\uDEA8\u3BBE\uD84F\uDCFF\uD851\uDC04\uD851\uDCD6\u5788\uD851\uDE74\u399B\uD851\uDF2F\uD861\uDDE8\uD866\uDDC9\u3762\uD848\uDDC3\u8B5E\uD862\uDF4E\u99D6\uD852\uDC12\uD852\uDCFB\uD852\uDE15\u7209\uD852\uDEC0\uD843\uDC78\u5965\uD853\uDEA5\uD853\uDF86\uD841\uDF79\u8EDA\uD854\uDC2C\u528F\u573F\u7171\uD854\uDE99\uD855\uDC19\uD84F\uDF4A\uD852\uDEA7\u55BC\uD855\uDC46\uD855\uDC6E\uD85A\uDF52\u91D4\u3473\uD855\uDD3F\uD85D\uDE32\uD855\uDD5E\u4718\uD855\uDD62\uD855\uDD66\uD855\uDFC7\uD852\uDD3F\uD856\uDC5D\u5066\u34FB\uD84C\uDFCC\u60DE\uD856\uDD03\u477C\uD862\uDD48\uD856\uDEAE\uD856\uDF89\uD857\uDC06\uD847\uDD90\u57A1\u7151\u6FB6\uD858\uDD02\uD85F\uDC12\u9056\uD858\uDDB2\uD853\uDF9A\u8B62\uD859\uDC02\uD859\uDC4A"
    ],
    [
        "9c40",
        "\u5D5B\uD85A\uDFF7\u8F36\uD859\uDC84\uD846\uDD1C\u8AEA\uD852\uDDF6\uD859\uDC88\uD84F\uDFEF\uD859\uDD12\u4BC0\uD859\uDDBF\uD859\uDEB5\uD849\uDF1B\u9465\uD855\uDFE1\u6195\u5A27\uD87E\uDCCD\u4FBB\u56B9\uD851\uDD21\uD859\uDEFC\u4E6A\uD852\uDD34\u9656\u6D8F\uD85B\uDCBD\u3618\u8977\uD859\uDF99\uD85A\uDC6E\uD859\uDC11\uD85A\uDC5E\u71DF\uD85A\uDCC7\u7B42\uD864\uDCC0\uD842\uDE11\uD85A\uDD26\u9104\uD85A\uDD39\u7A45\u9DF0\uD85A\uDDFA\u9A26\uD85A\uDE2D\u365F\uD859\uDC69\uD840\uDC21\u7983\uD85A\uDE34\uD85A\uDF5B\u5D2C\uD84D\uDD19\u83CF\uD85A\uDF9D\u46D0\uD85B\uDCA4\u753B\u8865\uD85B\uDDAE\u58B6"
    ],
    [
        "9ca1",
        "\u371C\uD849\uDD8D\uD85C\uDC4B\uD85C\uDDCD\u3C54\uD85C\uDE80\uD85C\uDE85\u9281\uD848\uDD7A\uD85C\uDE8B\u9330\uD85C\uDEE6\uD852\uDDD0\u6C39\u949F\uD85D\uDC50\uD843\uDEF8\u8827\u88F5\uD84A\uDD26\uD861\uDC73\uD845\uDFB1\u6EB8\uD852\uDE2A\uD846\uDC20\u39A4\u36B9\u5C10\u79E3\u453F\u66B6\uD867\uDCAD\uD866\uDCA4\u8943\uD85D\uDFCC\uD85E\uDC58\u56D6\u40DF\uD845\uDE0A\u39A1\uD84D\uDF2F\uD860\uDCE8\uD844\uDFC5\u71AD\u8366\uD85E\uDDDD\uD864\uDDA8\u5A67\u4CB7\uD85C\uDCAF\uD862\uDDAB\uD85E\uDDFD\uD85E\uDE0A\uD85E\uDF0B\uD85F\uDD66\uD850\uDD7A\u7B43\u797E\uD860\uDC09\u6FB5\uD868\uDEDF\u6A03\uD860\uDF18\u53A2\uD85B\uDE07\u93BF\u6836\u975D\uD860\uDD6F\uD860\uDC23\uD85A\uDDB5\uD844\uDFED\uD84C\uDE2F\uD860\uDC48\u5D85\uD863\uDC30\uD860\uDC83\u5715\u9823\uD862\uDD49\u5DAB\uD852\uDD88\u65BE\u69D5\u53D2\uD852\uDEA5\uD84F\uDF81\u3C11\u6736\uD860\uDC90\uD860\uDCF4\uD860\uDD2E\uD847\uDFA1\uD860\uDD4F"
    ],
    [
        "9d40",
        "\uD860\uDD89\uD860\uDDAF\uD860\uDE1A\uD860\uDF06\uD860\uDF2F\uD860\uDF8A\u35CA\uD861\uDC68\uD861\uDEAA\u48FA\u63E6\uD862\uDD56\u7808\u9255\uD862\uDDB8\u43F2\uD862\uDDE7\u43DF\uD862\uDDE8\uD862\uDF46\uD862\uDFD4\u59F8\uD863\uDC09\u8F0B\uD863\uDFC5\uD864\uDCEC\u7B51\uD864\uDD10\uD864\uDD3C\u3DF7\uD864\uDD5E\uD852\uDECA\u8FD0\u728F\u568B\uD865\uDCE7\uD865\uDDE9\uD865\uDDB0\uD865\uDDB8\uD865\uDF32\uD866\uDCD1\uD866\uDD49\uD866\uDD6A\uD866\uDDC3\uD866\uDE28\uD866\uDF0E\uD867\uDD5A\uD867\uDD9B\u7E9F\uD867\uDEF8\uD867\uDF23\u4CA4\u9547\uD868\uDE93\u71A2\uD868\uDEFF\u4D91\u9012\uD869\uDDCB\u4D9C\uD843\uDC9C\u8FBE\u55C1"
    ],
    [
        "9da1",
        "\u8FBA\uD849\uDCB0\u8FB9\uD852\uDE93\u4509\u7E7F\u6F56\u6AB1\u4EEA\u34E4\uD862\uDF2C\uD85E\uDC9D\u373A\u8E80\uD845\uDFF5\uD860\uDC24\uD862\uDF6C\uD862\uDF99\uD85E\uDE3E\uD859\uDEAF\u3DEB\uD85D\uDE55\uD84F\uDCB7\uD855\uDE35\uD856\uDD56\u4E9A\uD857\uDE81\uD858\uDE58\u56BF\uD843\uDE6D\u8E0E\u5B6D\uD84F\uDE88\uD853\uDC9E\u63DE\u62D0\uD845\uDFF6\uD846\uDC7B\u6530\u562D\uD857\uDC4A\u541A\uD854\uDF11\u3DC6\uD867\uDD98\u4C7D\u5622\u561E\u7F49\uD857\uDED8\u5975\uD84F\uDD40\u8770\u4E1C\uD843\uDFEA\uD843\uDD49\uD84D\uDEBA\u8117\u9D5E\u8D18\u763B\u9C45\u764E\u77B9\u9345\u5432\u8148\u82F7\u5625\u8132\u8418\u80BD\u55EA\u7962\u5643\u5416\uD843\uDE9D\u35CE\u5605\u55F1\u66F1\uD860\uDEE2\u362D\u7534\u55F0\u55BA\u5497\u5572\uD843\uDC41\uD843\uDC96\u5ED0\uD854\uDD48\uD843\uDE76\uD84B\uDC62"
    ],
    [
        "9e40",
        "\uD843\uDEA2\u9EAB\u7D5A\u55DE\uD844\uDC75\u629D\u976D\u5494\u8CCD\u71F6\u9176\u63FC\u63B9\u63FE\u5569\uD84A\uDF43\u9C72\uD84B\uDEB3\u519A\u34DF\uD843\uDDA7\u51A7\u544D\u551E\u5513\u7666\u8E2D\uD85A\uDC8A\u75B1\u80B6\u8804\u8786\u88C7\u81B6\u841C\uD844\uDCC1\u44EC\u7304\uD851\uDF06\u5B90\u830B\uD85A\uDC93\u567B\uD849\uDEF4\uD85F\uDD2F\uD850\uDDA3\uD85F\uDD73\uD85B\uDED0\uD85C\uDEB6\u9170\uD844\uDDD9\u9208\uD84F\uDCFC\uD869\uDEA9\uD843\uDEAC\uD843\uDEF9\u7266\uD847\uDCA2\u474E\uD853\uDFC2\uD85F\uDFF9\uD843\uDFEB\u40FA"
    ],
    [
        "9ea1",
        "\u9C5D\u651F\uD84B\uDDA0\u48F3\uD851\uDFE0\uD867\uDD7C\uD843\uDFEC\uD843\uDE0A\u6062\uD85D\uDDA3\uD843\uDFED"
    ],
    [
        "9ead",
        "\uD858\uDC48\uD844\uDD87\u71A3\u7E8E\u9D50\u4E1A\u4E04\u3577\u5B0D\u6CB2\u5367\u36AC\u39DC\u537D\u36A5\uD851\uDE18\u589A\uD852\uDF6E\u822D\u544B\u57AA\uD856\uDE95\uD842\uDD79"
    ],
    [
        "9ec5",
        "\u3A52\uD849\uDC65\u7374\uD867\uDEAC\u4D09\u9BED\uD84F\uDCFE\uD867\uDF30\u4C5B\uD853\uDFA9\uD865\uDD9E\uD867\uDFDE\u845C\uD84F\uDDB6\uD85C\uDEB2\uD859\uDFB3\uD84D\uDF20\u632E\u7D25\uD84F\uDEF7\uD84F\uDE2C\u3A2A\u9008\u52CC\u3E74\u367A\u45E9\uD841\uDC8E\u7640\u5AF0\uD843\uDEB6\u787A\uD85F\uDF2E\u58A7\u40BF\u567C\u9B8B\u5D74\u7654\uD869\uDC34\u9E85\u4CE1\u75F9\u37FB\u6119\uD84C\uDCDA\uD850\uDFF2"
    ],
    [
        "9ef5",
        "\u565D\uD844\uDEA9\u57A7\uD852\uDD63\uD867\uDE06\u5234\uD85C\uDCAE\u35AD\u6C4A\u9D7C"
    ],
    [
        "9f40",
        "\u7C56\u9B39\u57DE\uD845\uDF6C\u5C53\u64D3\uD865\uDCD0\uD858\uDF35\uD85C\uDD64\u86AD\uD843\uDD28\uD85B\uDD22\uD852\uDEE2\uD843\uDD71"
    ],
    [
        "9f4f",
        "\u51FE\uD847\uDF0F\u5D8E\u9703\uD847\uDDD1\u9E81\u904C\u7B1F\u9B02\u5CD1\u7BA3\u6268\u6335\u9AFF\u7BCF\u9B2A\u7C7E\u9B2E\u7C42\u7C86\u9C15\u7BFC\u9B09\u9F17\u9C1B\uD852\uDD3E\u9F5A\u5573\u5BC3\u4FFD\u9E98\u4FF2\u5260\u3E06\u52D1\u5767\u5056\u59B7\u5E12\u97C8\u9DAB\u8F5C\u5469\u97B4\u9940\u97BA\u532C\u6130"
    ],
    [
        "9fa1",
        "\u692C\u53DA\u9C0A\u9D02\u4C3B\u9641\u6980\u50A6\u7546\uD845\uDF6D\u99DA\u5273"
    ],
    [
        "9fae",
        "\u9159\u9681\u915C"
    ],
    [
        "9fb2",
        "\u9151\uD863\uDE97\u637F\uD85B\uDD23\u6ACA\u5611\u918E\u757A\u6285\uD840\uDFFC\u734F\u7C70\uD857\uDC21\uD84F\uDCFD"
    ],
    [
        "9fc1",
        "\uD852\uDD19\u76D6\u9B9D\u4E2A\uD843\uDCD4\u83BE\u8842"
    ],
    [
        "9fc9",
        "\u5C4A\u69C0\u50ED\u577A\u521F\u5DF5\u4ECE\u6C31\uD840\uDDF2\u4F39\u549C\u54DA\u529A\u8D82\u35FE\u5F0C\u35F3"
    ],
    [
        "9fdb",
        "\u6B52\u917C\u9FA5\u9B97\u982E\u98B4\u9ABA\u9EA8\u9E84\u717A\u7B14"
    ],
    [
        "9fe7",
        "\u6BFA\u8818\u7F78"
    ],
    [
        "9feb",
        "\u5620\uD869\uDE4A\u8E77\u9F53"
    ],
    [
        "9ff0",
        "\u8DD4\u8E4F\u9E1C\u8E01\u6282\uD860\uDF7D\u8E28\u8E75\u7AD3\uD852\uDE77\u7A3E\u78D8\u6CEA\u8A67\u7607"
    ],
    [
        "a040",
        "\uD862\uDE5A\u9F26\u6CCE\u87D6\u75C3\uD868\uDEB2\u7853\uD87E\uDC40\u8D0C\u72E2\u7371\u8B2D\u7302\u74F1\u8CEB\uD852\uDEBB\u862F\u5FBA\u88A0\u44B7"
    ],
    [
        "a055",
        "\uD846\uDC3B\uD85B\uDE05"
    ],
    [
        "a058",
        "\u8A7E\uD849\uDD1B"
    ],
    [
        "a05b",
        "\u60FD\u7667\u9AD7\u9D44\u936E\u9B8F\u87F5"
    ],
    [
        "a063",
        "\u880F\u8CF7\u732C\u9721\u9BB0\u35D6\u72B2\u4C07\u7C51\u994A\uD858\uDD59\u6159\u4C04\u9E96\u617D"
    ],
    [
        "a073",
        "\u575F\u616F\u62A6\u6239\u62CE\u3A5C\u61E2\u53AA\uD84C\uDFF5\u6364\u6802\u35D2"
    ],
    [
        "a0a1",
        "\u5D57\uD862\uDFC2\u8FDA\uD863\uDE39"
    ],
    [
        "a0a6",
        "\u50D9\uD847\uDD46\u7906\u5332\u9638\uD843\uDF3B\u4065"
    ],
    [
        "a0ae",
        "\u77FE"
    ],
    [
        "a0b0",
        "\u7CC2\uD857\uDF1A\u7CDA\u7A2D\u8066\u8063\u7D4D\u7505\u74F2\u8994\u821A\u670C\u8062\uD85D\uDC86\u805B\u74F0\u8103\u7724\u8989\uD859\uDFCC\u7553\uD85B\uDED1\u87A9\u87CE\u81C8\u878C\u8A49\u8CAD\u8B43\u772B\u74F8\u84DA\u3635\u69B2\u8DA6"
    ],
    [
        "a0d4",
        "\u89A9\u7468\u6DB9\u87C1\uD850\uDC11\u74E7\u3DDB\u7176\u60A4\u619C\u3CD1\u7162\u6077"
    ],
    [
        "a0e2",
        "\u7F71\uD862\uDF2D\u7250\u60E9\u4B7E\u5220\u3C18\uD84F\uDCC7\uD857\uDED7\uD85D\uDE56\uD855\uDD31\uD846\uDD44\uD844\uDEFE\uD866\uDD03\uD85B\uDDDC\uD85C\uDCAD\u5CC1\uD858\uDDAD\uD862\uDE0F\uD84D\uDE77\uD840\uDCEE\uD85A\uDC46\uD853\uDF0E\u4562\u5B1F\uD858\uDF4C\u9F50\u9EA6\uD858\uDE6B"
    ],
    [
        "a3c0",
        "\u2400",
        31,
        "\u2421"
    ],
    [
        "c6a1",
        "\u2460",
        9,
        "\u2474",
        9,
        "\u2170",
        9,
        "\u4E36\u4E3F\u4E85\u4EA0\u5182\u5196\u51AB\u52F9\u5338\u5369\u53B6\u590A\u5B80\u5DDB\u2F33\u5E7F\u5EF4\u5F50\u5F61\u6534\u65E0\u7592\u7676\u8FB5\u96B6\xa8\u02C6\u30FD\u30FE\u309D\u309E\u3003\u4EDD\u3005\u3006\u3007\u30FC\uFF3B\uFF3D\u273D\u3041",
        23
    ],
    [
        "c740",
        "\u3059",
        58,
        "\u30A1\u30A2\u30A3\u30A4"
    ],
    [
        "c7a1",
        "\u30A5",
        81,
        "\u0410",
        5,
        "\u0401\u0416",
        4
    ],
    [
        "c840",
        "\u041B",
        26,
        "\u0451\u0436",
        25,
        "\u21E7\u21B8\u21B9\u31CF\uD840\uDCCC\u4E5A\uD840\uDC8A\u5202\u4491"
    ],
    [
        "c8a1",
        "\u9FB0\u5188\u9FB1\uD85D\uDE07"
    ],
    [
        "c8cd",
        "\uFFE2\uFFE4\uFF07\uFF02\u3231\u2116\u2121\u309B\u309C\u2E80\u2E84\u2E86\u2E87\u2E88\u2E8A\u2E8C\u2E8D\u2E95\u2E9C\u2E9D\u2EA5\u2EA7\u2EAA\u2EAC\u2EAE\u2EB6\u2EBC\u2EBE\u2EC6\u2ECA\u2ECC\u2ECD\u2ECF\u2ED6\u2ED7\u2EDE\u2EE3"
    ],
    [
        "c8f5",
        "\u0283\u0250\u025B\u0254\u0275\u0153\xf8\u014B\u028A\u026A"
    ],
    [
        "f9fe",
        "\uFFED"
    ],
    [
        "fa40",
        "\uD841\uDD47\u92DB\uD841\uDDDF\uD84F\uDFC5\u854C\u42B5\u73EF\u51B5\u3649\uD852\uDD42\uD862\uDDE4\u9344\uD846\uDDDB\u82EE\uD84F\uDCC8\u783C\u6744\u62DF\uD852\uDD33\uD862\uDDAA\uD840\uDEA0\uD85A\uDFB3\uD844\uDF05\u4FAB\uD849\uDCED\u5008\uD85B\uDD29\uD85E\uDE84\uD84D\uDE00\uD852\uDEB1\uD849\uDD13\u5029\uD840\uDF7E\u5FA4\uD840\uDF80\uD840\uDF47\u6EDB\uD841\uDC1F\u507D\u5101\u347A\u510E\u986C\u3743\u8416\uD852\uDDA4\uD841\uDC87\u5160\uD84C\uDFB4\u516A\uD842\uDFFF\uD848\uDCFC\uD840\uDEE5\uD849\uDD30\uD841\uDD8E\uD84C\uDE33\uD846\uDD83\u5B82\u877D\uD841\uDDB3\uD84F\uDC99\u51B2\u51B8"
    ],
    [
        "faa1",
        "\u9D34\u51C9\u51CF\u51D1\u3CDC\u51D3\uD852\uDEA6\u51B3\u51E2\u5342\u51ED\u83CD\u693E\uD84D\uDF2D\u5F7B\u520B\u5226\u523C\u52B5\u5257\u5294\u52B9\u52C5\u7C15\u8542\u52E0\u860D\uD85A\uDF13\u5305\uD862\uDEDE\u5549\u6ED9\uD84F\uDF80\uD842\uDD54\uD84F\uDFEC\u5333\u5344\uD842\uDFE2\u6CCB\uD845\uDF26\u681B\u73D5\u604A\u3EAA\u38CC\uD845\uDEE8\u71DD\u44A2\u536D\u5374\uD861\uDEAB\u537E\u537F\uD845\uDD96\uD845\uDE13\u77E6\u5393\uD862\uDE9B\u53A0\u53AB\u53AE\u73A7\uD855\uDF72\u3F59\u739C\u53C1\u53C5\u6C49\u4E49\u57FE\u53D9\u3AAB\uD842\uDF8F\u53E0\uD84F\uDFEB\uD84B\uDDA3\u53F6\uD843\uDC77\u5413\u7079\u552B\u6657\u6D5B\u546D\uD85A\uDF53\uD843\uDD74\u555D\u548F\u54A4\u47A6\uD845\uDF0D\uD843\uDEDD\u3DB4\uD843\uDD4D"
    ],
    [
        "fb40",
        "\uD862\uDDBC\uD849\uDE98\u5547\u4CED\u542F\u7417\u5586\u55A9\u5605\uD846\uDCD7\uD850\uDC3A\u4552\uD851\uDC35\u66B3\uD844\uDCB4\u5637\u66CD\uD84C\uDE8A\u66A4\u66AD\u564D\u564F\u78F1\u56F1\u9787\u53FE\u5700\u56EF\u56ED\uD862\uDF66\u3623\uD844\uDE4F\u5746\uD850\uDDA5\u6C6E\u708B\u5742\u36B1\uD85B\uDC7E\u57E6\uD845\uDC16\u5803\uD845\uDC54\uD850\uDF63\u5826\uD852\uDFF5\u585C\u58AA\u3561\u58E0\u58DC\uD844\uDE3C\u58FB\u5BFF\u5743\uD868\uDD50\uD850\uDE78\u93D3\u35A1\u591F\u68A6\u36C3\u6E59"
    ],
    [
        "fba1",
        "\uD845\uDE3E\u5A24\u5553\uD845\uDE92\u8505\u59C9\uD843\uDD4E\uD85B\uDC81\uD85B\uDD2A\uD845\uDFDC\u59D9\uD845\uDFFB\uD845\uDFB2\uD85B\uDDA6\u6D71\uD846\uDC28\uD845\uDED5\u59F9\uD85B\uDE45\u5AAB\u5A63\u36E6\uD852\uDDA9\u5A77\u3708\u5A96\u7465\u5AD3\uD85B\uDFA1\uD849\uDD54\u3D85\uD846\uDD11\u3732\uD845\uDEB8\u5E83\u52D0\u5B76\u6588\u5B7C\uD85E\uDE0E\u4004\u485D\uD840\uDE04\u5BD5\u6160\uD846\uDE34\uD856\uDDCC\uD841\uDDA5\u5BF3\u5B9D\u4D10\u5C05\uD846\uDF44\u5C13\u73CE\u5C14\uD847\uDCA5\uD85A\uDF28\u5C49\u48DD\u5C85\u5CE9\u5CEF\u5D8B\uD847\uDDF9\uD847\uDE37\u5D10\u5D18\u5D46\uD847\uDEA4\u5CBA\u5DD7\u82FC\u382D\uD852\uDD01\uD848\uDC49\uD848\uDD73\u8287\u3836\u3BC2\u5E2E\u6A8A\u5E75\u5E7A\uD851\uDCBC\uD843\uDCD3\u53A6\u4EB7\u5ED0\u53A8\uD845\uDF71\u5E09\u5EF4\uD861\uDC82"
    ],
    [
        "fc40",
        "\u5EF9\u5EFB\u38A0\u5EFC\u683E\u941B\u5F0D\uD840\uDDC1\uD87E\uDC94\u3ADE\u48AE\uD844\uDF3A\u5F3A\uD85A\uDC88\uD848\uDFD0\u5F58\uD849\uDC71\u5F63\u97BD\uD85B\uDE6E\u5F72\u9340\uD862\uDE36\u5FA7\u5DB6\u3D5F\uD854\uDE50\uD847\uDF6A\uD85C\uDCF8\uD849\uDE68\u91D6\uD840\uDE9E\uD862\uDE29\u6031\u6685\uD846\uDC77\u3963\u3DC7\u3639\u5790\uD849\uDFB4\u7971\u3E40\u609E\u60A4\u60B3\uD852\uDD82\uD852\uDD8F\uD85E\uDE53\u74A4\u50E1\u5AA0\u6164\u8424\u6142\uD87E\uDCA6\uD85B\uDED2\u6181\u51F4\uD841\uDE56\u6187\u5BAA\uD84F\uDFB7"
    ],
    [
        "fca1",
        "\uD84A\uDC5F\u61D3\uD862\uDF9D\uD866\uDD5D\u61D0\u3932\uD84A\uDD80\uD84A\uDCC1\u6023\u615C\u651E\u638B\uD840\uDD18\u62C5\uD845\uDF70\u62D5\uD84B\uDE0D\u636C\uD852\uDDDF\u3A17\u6438\u63F8\uD844\uDF8E\uD845\uDFFC\u6490\u6F8A\uD84B\uDE36\u9814\uD850\uDC8C\uD855\uDF1D\u64E1\u64E5\u947B\u3A66\u643A\u3A57\u654D\u6F16\uD852\uDE28\uD852\uDE23\u6585\u656D\u655F\uD84C\uDC7E\u65B5\uD852\uDD40\u4B37\u65D1\u40D8\uD846\uDC29\u65E0\u65E3\u5FDF\uD84D\uDC00\u6618\uD84C\uDDF7\uD84C\uDDF8\u6644\uD84C\uDDA4\uD84C\uDDA5\u664B\uD843\uDE75\u6667\uD854\uDDE6\u6673\u6674\uD847\uDE3D\uD84C\uDE31\uD861\uDDF4\uD84C\uDDC8\uD854\uDF13\u77C5\uD84A\uDCF7\u99A4\u6702\uD850\uDF9C\uD852\uDE21\u3B2B\u69FA\uD84D\uDFC2\u675E\u6767\u6762\uD850\uDDCD\uD864\uDCED\u67D7\u44E9\u6822\u6E50\u923C\u6801\uD84C\uDFE6\uD85B\uDDA0\u685D"
    ],
    [
        "fd40",
        "\uD84D\uDC6F\u69E1\u6A0B\uD862\uDEDF\u6973\u68C3\uD84D\uDDCD\u6901\u6900\u3D32\u3A01\uD84D\uDE3C\u3B80\u67AC\u6961\uD862\uDE4A\u42FC\u6936\u6998\u3BA1\uD840\uDFC9\u8363\u5090\u69F9\uD84D\uDE59\uD848\uDD2A\u6A45\uD84D\uDF03\u6A9D\u3BF3\u67B1\u6AC8\uD864\uDD9C\u3C0D\u6B1D\uD842\uDD23\u60DE\u6B35\u6B74\uD849\uDFCD\u6EB5\uD84E\uDEDB\uD840\uDFB5\uD846\uDD58\u3740\u5421\uD84E\uDF5A\u6BE1\uD84F\uDEFC\u6BDC\u6C37\uD849\uDC8B\uD852\uDCF1\uD85A\uDF51\u6C5A\u8226\u6C79\uD84F\uDDBC\u44C5\uD84F\uDDBD\uD850\uDDA4\uD852\uDD0C\uD852\uDD00"
    ],
    [
        "fda1",
        "\uD84F\uDCC9\u36E5\u3CEB\uD843\uDD32\u9B83\uD84C\uDDF9\uD849\uDC91\u7F8F\u6837\uD85B\uDD25\uD85B\uDDA1\uD85B\uDDEB\u6D96\u6D5C\u6E7C\u6F04\uD852\uDD7F\uD850\uDC85\uD85B\uDE72\u8533\uD85B\uDF74\u51C7\u6C9C\u6E1D\u842E\uD862\uDF21\u6E2F\uD84F\uDE2F\u7453\uD84F\uDF82\u79CC\u6E4F\u5A91\uD84C\uDC4B\u6FF8\u370D\u6F9D\uD84F\uDE30\u6EFA\uD845\uDC97\uD850\uDC3D\u4555\u93F0\u6F44\u6F5C\u3D4E\u6F74\uD864\uDD70\u3D3B\u6F9F\uD850\uDD44\u6FD3\uD850\uDC91\uD850\uDD55\uD850\uDC39\uD84F\uDFF0\uD84F\uDFB4\uD850\uDD3F\u51DF\uD850\uDD56\uD850\uDD57\uD850\uDD40\uD858\uDDDD\u704B\u707E\u70A7\u7081\u70CC\u70D5\u70D6\u70DF\u4104\u3DE8\u71B4\u7196\uD850\uDE77\u712B\u7145\u5A88\u714A\u716E\u5C9C\uD850\uDF65\u714F\u9362\uD850\uDEC1\u712C\uD851\uDC5A\uD852\uDE27\uD852\uDE22\u71BA\uD862\uDFE8\u70BD\u720E"
    ],
    [
        "fe40",
        "\u9442\u7215\u5911\u9443\u7224\u9341\uD855\uDE05\u722E\u7240\uD852\uDD74\u68BD\u7255\u7257\u3E55\uD84C\uDC44\u680D\u6F3D\u7282\u732A\u732B\uD852\uDC23\uD862\uDC2B\u48ED\uD862\uDC04\u7328\u732E\u73CF\u73AA\uD843\uDC3A\uD85A\uDE2E\u73C9\u7449\uD850\uDDE2\uD845\uDEE7\uD852\uDE24\u6623\u36C5\uD852\uDDB7\uD852\uDD8D\uD852\uDDFB\u73F7\u7415\u6903\uD852\uDE26\u7439\uD841\uDDC3\u3ED7\u745C\uD84A\uDCAD\u7460\uD863\uDEB2\u7447\u73E4\u7476\u83B9\u746C\u3730\u7474\u93F1\u6A2C\u7482\u4953\uD852\uDE8C"
    ],
    [
        "fea1",
        "\uD850\uDD5F\uD852\uDE79\uD862\uDF8F\u5B46\uD863\uDC03\uD846\uDC9E\u74C8\uD846\uDD88\u750E\u74E9\u751E\uD863\uDED9\uD846\uDE4B\u5BD7\uD863\uDEAC\u9385\u754D\u754A\u7567\u756E\uD853\uDF82\u3F04\uD853\uDD13\u758E\u745D\u759E\u75B4\u7602\u762C\u7651\u764F\u766F\u7676\uD858\uDFF5\u7690\u81EF\u37F8\uD85A\uDD11\uD85A\uDD0E\u76A1\u76A5\u76B7\u76CC\uD85B\uDF9F\u8462\uD854\uDC9D\uD854\uDD7D\uD847\uDE1C\u771E\u7726\u7740\u64AF\uD854\uDE20\u7758\uD84C\uDEAC\u77AF\uD862\uDD64\uD862\uDD68\uD845\uDEC1\u77F4\u7809\uD844\uDF76\uD852\uDE12\u68CA\u78AF\u78C7\u78D3\u96A5\u792E\uD855\uDDE0\u78D7\u7934\u78B1\uD85D\uDE0C\u8FB8\u8884\uD862\uDF2B\uD858\uDC83\uD849\uDE1C\u7986\u8900\u6902\u7980\uD856\uDC57\u799D\uD85E\uDF39\u793C\u79A9\u6E2A\uD85C\uDD26\u3EA8\u79C6\uD864\uDD0D\u79D4"
    ]
];
var $07144aea14354eb9$var$big5Added$1 = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    'default': $07144aea14354eb9$var$big5Added
});
var $07144aea14354eb9$var$require$$0 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$shiftjis$1);
var $07144aea14354eb9$var$require$$1 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$eucjp$1);
var $07144aea14354eb9$var$require$$2 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$cp936$1);
var $07144aea14354eb9$var$require$$3$1 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$gbkAdded$1);
var $07144aea14354eb9$var$require$$4 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$gb18030Ranges$1);
var $07144aea14354eb9$var$require$$5 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$cp949$1);
var $07144aea14354eb9$var$require$$6 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$cp950$1);
var $07144aea14354eb9$var$require$$7 = $07144aea14354eb9$var$getCjsExportFromNamespace($07144aea14354eb9$var$big5Added$1);
// Tables are not require()-d until they are needed to speed up library load.
// require()-s are direct to support Browserify.
var $07144aea14354eb9$var$dbcsData = {
    // == Japanese/ShiftJIS ====================================================
    // All japanese encodings are based on JIS X set of standards:
    // JIS X 0201 - Single-byte encoding of ASCII + ¥ + Kana chars at 0xA1-0xDF.
    // JIS X 0208 - Main set of 6879 characters, placed in 94x94 plane, to be encoded by 2 bytes. 
    //              Has several variations in 1978, 1983, 1990 and 1997.
    // JIS X 0212 - Supplementary plane of 6067 chars in 94x94 plane. 1990. Effectively dead.
    // JIS X 0213 - Extension and modern replacement of 0208 and 0212. Total chars: 11233.
    //              2 planes, first is superset of 0208, second - revised 0212.
    //              Introduced in 2000, revised 2004. Some characters are in Unicode Plane 2 (0x2xxxx)
    // Byte encodings are:
    //  * Shift_JIS: Compatible with 0201, uses not defined chars in top half as lead bytes for double-byte
    //               encoding of 0208. Lead byte ranges: 0x81-0x9F, 0xE0-0xEF; Trail byte ranges: 0x40-0x7E, 0x80-0x9E, 0x9F-0xFC.
    //               Windows CP932 is a superset of Shift_JIS. Some companies added more chars, notably KDDI.
    //  * EUC-JP:    Up to 3 bytes per character. Used mostly on *nixes.
    //               0x00-0x7F       - lower part of 0201
    //               0x8E, 0xA1-0xDF - upper part of 0201
    //               (0xA1-0xFE)x2   - 0208 plane (94x94).
    //               0x8F, (0xA1-0xFE)x2 - 0212 plane (94x94).
    //  * JIS X 208: 7-bit, direct encoding of 0208. Byte ranges: 0x21-0x7E (94 values). Uncommon.
    //               Used as-is in ISO2022 family.
    //  * ISO2022-JP: Stateful encoding, with escape sequences to switch between ASCII, 
    //                0201-1976 Roman, 0208-1978, 0208-1983.
    //  * ISO2022-JP-1: Adds esc seq for 0212-1990.
    //  * ISO2022-JP-2: Adds esc seq for GB2313-1980, KSX1001-1992, ISO8859-1, ISO8859-7.
    //  * ISO2022-JP-3: Adds esc seq for 0201-1976 Kana set, 0213-2000 Planes 1, 2.
    //  * ISO2022-JP-2004: Adds 0213-2004 Plane 1.
    //
    // After JIS X 0213 appeared, Shift_JIS-2004, EUC-JISX0213 and ISO2022-JP-2004 followed, with just changing the planes.
    //
    // Overall, it seems that it's a mess :( http://www8.plala.or.jp/tkubota1/unicode-symbols-map2.html
    'shiftjis': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$0;
        },
        encodeAdd: {
            "\xA5": 0x5C,
            "\u203E": 0x7E
        },
        encodeSkipVals: [
            {
                from: 0xED40,
                to: 0xF940
            }
        ]
    },
    'csshiftjis': 'shiftjis',
    'mskanji': 'shiftjis',
    'sjis': 'shiftjis',
    'windows31j': 'shiftjis',
    'ms31j': 'shiftjis',
    'xsjis': 'shiftjis',
    'windows932': 'shiftjis',
    'ms932': 'shiftjis',
    '932': 'shiftjis',
    'cp932': 'shiftjis',
    'eucjp': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$1;
        },
        encodeAdd: {
            "\xA5": 0x5C,
            "\u203E": 0x7E
        }
    },
    // TODO: KDDI extension to Shift_JIS
    // TODO: IBM CCSID 942 = CP932, but F0-F9 custom chars and other char changes.
    // TODO: IBM CCSID 943 = Shift_JIS = CP932 with original Shift_JIS lower 128 chars.
    // == Chinese/GBK ==========================================================
    // http://en.wikipedia.org/wiki/GBK
    // We mostly implement W3C recommendation: https://www.w3.org/TR/encoding/#gbk-encoder
    // Oldest GB2312 (1981, ~7600 chars) is a subset of CP936
    'gb2312': 'cp936',
    'gb231280': 'cp936',
    'gb23121980': 'cp936',
    'csgb2312': 'cp936',
    'csiso58gb231280': 'cp936',
    'euccn': 'cp936',
    // Microsoft's CP936 is a subset and approximation of GBK.
    'windows936': 'cp936',
    'ms936': 'cp936',
    '936': 'cp936',
    'cp936': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$2;
        }
    },
    // GBK (~22000 chars) is an extension of CP936 that added user-mapped chars and some other.
    'gbk': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$2.concat($07144aea14354eb9$var$require$$3$1);
        }
    },
    'xgbk': 'gbk',
    'isoir58': 'gbk',
    // GB18030 is an algorithmic extension of GBK.
    // Main source: https://www.w3.org/TR/encoding/#gbk-encoder
    // http://icu-project.org/docs/papers/gb18030.html
    // http://source.icu-project.org/repos/icu/data/trunk/charset/data/xml/gb-18030-2000.xml
    // http://www.khngai.com/chinese/charmap/tblgbk.php?page=0
    'gb18030': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$2.concat($07144aea14354eb9$var$require$$3$1);
        },
        gb18030: function gb18030() {
            return $07144aea14354eb9$var$require$$4;
        },
        encodeSkipVals: [
            0x80
        ],
        encodeAdd: {
            "\u20AC": 0xA2E3
        }
    },
    'chinese': 'gb18030',
    // == Korean ===============================================================
    // EUC-KR, KS_C_5601 and KS X 1001 are exactly the same.
    'windows949': 'cp949',
    'ms949': 'cp949',
    '949': 'cp949',
    'cp949': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$5;
        }
    },
    'cseuckr': 'cp949',
    'csksc56011987': 'cp949',
    'euckr': 'cp949',
    'isoir149': 'cp949',
    'korean': 'cp949',
    'ksc56011987': 'cp949',
    'ksc56011989': 'cp949',
    'ksc5601': 'cp949',
    // == Big5/Taiwan/Hong Kong ================================================
    // There are lots of tables for Big5 and cp950. Please see the following links for history:
    // http://moztw.org/docs/big5/  http://www.haible.de/bruno/charsets/conversion-tables/Big5.html
    // Variations, in roughly number of defined chars:
    //  * Windows CP 950: Microsoft variant of Big5. Canonical: http://www.unicode.org/Public/MAPPINGS/VENDORS/MICSFT/WINDOWS/CP950.TXT
    //  * Windows CP 951: Microsoft variant of Big5-HKSCS-2001. Seems to be never public. http://me.abelcheung.org/articles/research/what-is-cp951/
    //  * Big5-2003 (Taiwan standard) almost superset of cp950.
    //  * Unicode-at-on (UAO) / Mozilla 1.8. Falling out of use on the Web. Not supported by other browsers.
    //  * Big5-HKSCS (-2001, -2004, -2008). Hong Kong standard. 
    //    many unicode code points moved from PUA to Supplementary plane (U+2XXXX) over the years.
    //    Plus, it has 4 combining sequences.
    //    Seems that Mozilla refused to support it for 10 yrs. https://bugzilla.mozilla.org/show_bug.cgi?id=162431 https://bugzilla.mozilla.org/show_bug.cgi?id=310299
    //    because big5-hkscs is the only encoding to include astral characters in non-algorithmic way.
    //    Implementations are not consistent within browsers; sometimes labeled as just big5.
    //    MS Internet Explorer switches from big5 to big5-hkscs when a patch applied.
    //    Great discussion & recap of what's going on https://bugzilla.mozilla.org/show_bug.cgi?id=912470#c31
    //    In the encoder, it might make sense to support encoding old PUA mappings to Big5 bytes seq-s.
    //    Official spec: http://www.ogcio.gov.hk/en/business/tech_promotion/ccli/terms/doc/2003cmp_2008.txt
    //                   http://www.ogcio.gov.hk/tc/business/tech_promotion/ccli/terms/doc/hkscs-2008-big5-iso.txt
    // 
    // Current understanding of how to deal with Big5(-HKSCS) is in the Encoding Standard, http://encoding.spec.whatwg.org/#big5-encoder
    // Unicode mapping (http://www.unicode.org/Public/MAPPINGS/OBSOLETE/EASTASIA/OTHER/BIG5.TXT) is said to be wrong.
    'windows950': 'cp950',
    'ms950': 'cp950',
    '950': 'cp950',
    'cp950': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$6;
        }
    },
    // Big5 has many variations and is an extension of cp950. We use Encoding Standard's as a consensus.
    'big5': 'big5hkscs',
    'big5hkscs': {
        type: '_dbcs',
        table: function table() {
            return $07144aea14354eb9$var$require$$6.concat($07144aea14354eb9$var$require$$7);
        },
        encodeSkipVals: [
            0xa2cc
        ]
    },
    'cnbig5': 'big5hkscs',
    'csbig5': 'big5hkscs',
    'xxbig5': 'big5hkscs'
};
var $07144aea14354eb9$var$encodings = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // We support Browserify by skipping automatic module discovery and requiring modules directly.
    var modules = [
        $07144aea14354eb9$var$internal,
        $07144aea14354eb9$var$utf16,
        $07144aea14354eb9$var$utf7,
        $07144aea14354eb9$var$sbcsCodec,
        $07144aea14354eb9$var$sbcsData,
        $07144aea14354eb9$var$sbcsDataGenerated,
        $07144aea14354eb9$var$dbcsCodec,
        $07144aea14354eb9$var$dbcsData
    ]; // Put all encoding/alias/codec definitions to single object and export it. 
    for(var i = 0; i < modules.length; i++){
        var module = modules[i];
        for(var enc in module)if (Object.prototype.hasOwnProperty.call(module, enc)) exports[enc] = module[enc];
    }
});
var $07144aea14354eb9$var$Buffer$6 = $07144aea14354eb9$var$buffer.Buffer, $07144aea14354eb9$var$Transform$1 = $07144aea14354eb9$var$Stream.Transform; // == Exports ==================================================================
var $07144aea14354eb9$var$streams = function streams(iconv) {
    // Additional Public API.
    iconv.encodeStream = function encodeStream(encoding, options) {
        return new $07144aea14354eb9$var$IconvLiteEncoderStream(iconv.getEncoder(encoding, options), options);
    };
    iconv.decodeStream = function decodeStream(encoding, options) {
        return new $07144aea14354eb9$var$IconvLiteDecoderStream(iconv.getDecoder(encoding, options), options);
    };
    iconv.supportsStreams = true; // Not published yet.
    iconv.IconvLiteEncoderStream = $07144aea14354eb9$var$IconvLiteEncoderStream;
    iconv.IconvLiteDecoderStream = $07144aea14354eb9$var$IconvLiteDecoderStream;
    iconv._collect = $07144aea14354eb9$var$IconvLiteDecoderStream.prototype.collect;
}; // == Encoder stream =======================================================
function $07144aea14354eb9$var$IconvLiteEncoderStream(conv, options) {
    this.conv = conv;
    options = options || {};
    options.decodeStrings = false; // We accept only strings, so we don't need to decode them.
    $07144aea14354eb9$var$Transform$1.call(this, options);
}
$07144aea14354eb9$var$IconvLiteEncoderStream.prototype = Object.create($07144aea14354eb9$var$Transform$1.prototype, {
    constructor: {
        value: $07144aea14354eb9$var$IconvLiteEncoderStream
    }
});
$07144aea14354eb9$var$IconvLiteEncoderStream.prototype._transform = function(chunk, encoding, done) {
    if (typeof chunk != 'string') return done(new Error("Iconv encoding stream needs strings as its input."));
    try {
        var res = this.conv.write(chunk);
        if (res && res.length) this.push(res);
        done();
    } catch (e) {
        done(e);
    }
};
$07144aea14354eb9$var$IconvLiteEncoderStream.prototype._flush = function(done) {
    try {
        var res = this.conv.end();
        if (res && res.length) this.push(res);
        done();
    } catch (e) {
        done(e);
    }
};
$07144aea14354eb9$var$IconvLiteEncoderStream.prototype.collect = function(cb) {
    var chunks = [];
    this.on('error', cb);
    this.on('data', function(chunk) {
        chunks.push(chunk);
    });
    this.on('end', function() {
        cb(null, $07144aea14354eb9$var$Buffer$6.concat(chunks));
    });
    return this;
}; // == Decoder stream =======================================================
function $07144aea14354eb9$var$IconvLiteDecoderStream(conv, options) {
    this.conv = conv;
    options = options || {};
    options.encoding = this.encoding = 'utf8'; // We output strings.
    $07144aea14354eb9$var$Transform$1.call(this, options);
}
$07144aea14354eb9$var$IconvLiteDecoderStream.prototype = Object.create($07144aea14354eb9$var$Transform$1.prototype, {
    constructor: {
        value: $07144aea14354eb9$var$IconvLiteDecoderStream
    }
});
$07144aea14354eb9$var$IconvLiteDecoderStream.prototype._transform = function(chunk, encoding, done) {
    if (!$07144aea14354eb9$var$Buffer$6.isBuffer(chunk)) return done(new Error("Iconv decoding stream needs buffers as its input."));
    try {
        var res = this.conv.write(chunk);
        if (res && res.length) this.push(res, this.encoding);
        done();
    } catch (e) {
        done(e);
    }
};
$07144aea14354eb9$var$IconvLiteDecoderStream.prototype._flush = function(done) {
    try {
        var res = this.conv.end();
        if (res && res.length) this.push(res, this.encoding);
        done();
    } catch (e) {
        done(e);
    }
};
$07144aea14354eb9$var$IconvLiteDecoderStream.prototype.collect = function(cb) {
    var res = '';
    this.on('error', cb);
    this.on('data', function(chunk) {
        res += chunk;
    });
    this.on('end', function() {
        cb(null, res);
    });
    return this;
};
var $07144aea14354eb9$var$Buffer$7 = $07144aea14354eb9$var$buffer.Buffer; // Note: not polyfilled with safer-buffer on a purpose, as overrides Buffer
// == Extend Node primitives to use iconv-lite =================================
var $07144aea14354eb9$var$extendNode = function extendNode(iconv) {
    var original = undefined; // Place to keep original methods.
    // Node authors rewrote Buffer internals to make it compatible with
    // Uint8Array and we cannot patch key functions since then.
    // Note: this does use older Buffer API on a purpose
    iconv.supportsNodeEncodingsExtension = !($07144aea14354eb9$var$Buffer$7.from || new $07144aea14354eb9$var$Buffer$7(0) instanceof Uint8Array);
    iconv.extendNodeEncodings = function extendNodeEncodings() {
        if (original) return;
        original = {};
        if (!iconv.supportsNodeEncodingsExtension) {
            console.error("ACTION NEEDED: require('iconv-lite').extendNodeEncodings() is not supported in your version of Node");
            console.error("See more info at https://github.com/ashtuchkin/iconv-lite/wiki/Node-v4-compatibility");
            return;
        }
        var nodeNativeEncodings = {
            'hex': true,
            'utf8': true,
            'utf-8': true,
            'ascii': true,
            'binary': true,
            'base64': true,
            'ucs2': true,
            'ucs-2': true,
            'utf16le': true,
            'utf-16le': true
        };
        $07144aea14354eb9$var$Buffer$7.isNativeEncoding = function(enc) {
            return enc && nodeNativeEncodings[enc.toLowerCase()];
        }; // -- SlowBuffer -----------------------------------------------------------
        var SlowBuffer = $07144aea14354eb9$var$buffer.SlowBuffer;
        original.SlowBufferToString = SlowBuffer.prototype.toString;
        SlowBuffer.prototype.toString = function(encoding, start, end) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding)) return original.SlowBufferToString.call(this, encoding, start, end); // Otherwise, use our decoding method.
            if (typeof start == 'undefined') start = 0;
            if (typeof end == 'undefined') end = this.length;
            return iconv.decode(this.slice(start, end), encoding);
        };
        original.SlowBufferWrite = SlowBuffer.prototype.write;
        SlowBuffer.prototype.write = function(string, offset, length, encoding) {
            // Support both (string, offset, length, encoding)
            // and the legacy (string, encoding, offset, length)
            if (isFinite(offset)) {
                if (!isFinite(length)) {
                    encoding = length;
                    length = undefined;
                }
            } else {
                // legacy
                var swap = encoding;
                encoding = offset;
                offset = length;
                length = swap;
            }
            offset = +offset || 0;
            var remaining = this.length - offset;
            if (!length) length = remaining;
            else {
                length = +length;
                if (length > remaining) length = remaining;
            }
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding)) return original.SlowBufferWrite.call(this, string, offset, length, encoding);
            if (string.length > 0 && (length < 0 || offset < 0)) throw new RangeError('attempt to write beyond buffer bounds'); // Otherwise, use our encoding method.
            var buf = iconv.encode(string, encoding);
            if (buf.length < length) length = buf.length;
            buf.copy(this, offset, 0, length);
            return length;
        }; // -- Buffer ---------------------------------------------------------------
        original.BufferIsEncoding = $07144aea14354eb9$var$Buffer$7.isEncoding;
        $07144aea14354eb9$var$Buffer$7.isEncoding = function(encoding) {
            return $07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding) || iconv.encodingExists(encoding);
        };
        original.BufferByteLength = $07144aea14354eb9$var$Buffer$7.byteLength;
        $07144aea14354eb9$var$Buffer$7.byteLength = SlowBuffer.byteLength = function(str, encoding) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferByteLength.call(this, str, encoding); // Slow, I know, but we don't have a better way yet.
            return iconv.encode(str, encoding).length;
        };
        original.BufferToString = $07144aea14354eb9$var$Buffer$7.prototype.toString;
        $07144aea14354eb9$var$Buffer$7.prototype.toString = function(encoding, start, end) {
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferToString.call(this, encoding, start, end); // Otherwise, use our decoding method.
            if (typeof start == 'undefined') start = 0;
            if (typeof end == 'undefined') end = this.length;
            return iconv.decode(this.slice(start, end), encoding);
        };
        original.BufferWrite = $07144aea14354eb9$var$Buffer$7.prototype.write;
        $07144aea14354eb9$var$Buffer$7.prototype.write = function(string, offset, length, encoding) {
            var _offset = offset, _length = length, _encoding = encoding; // Support both (string, offset, length, encoding)
            // and the legacy (string, encoding, offset, length)
            if (isFinite(offset)) {
                if (!isFinite(length)) {
                    encoding = length;
                    length = undefined;
                }
            } else {
                // legacy
                var swap = encoding;
                encoding = offset;
                offset = length;
                length = swap;
            }
            encoding = String(encoding || 'utf8').toLowerCase(); // Use native conversion when possible
            if ($07144aea14354eb9$var$Buffer$7.isNativeEncoding(encoding)) return original.BufferWrite.call(this, string, _offset, _length, _encoding);
            offset = +offset || 0;
            var remaining = this.length - offset;
            if (!length) length = remaining;
            else {
                length = +length;
                if (length > remaining) length = remaining;
            }
            if (string.length > 0 && (length < 0 || offset < 0)) throw new RangeError('attempt to write beyond buffer bounds'); // Otherwise, use our encoding method.
            var buf = iconv.encode(string, encoding);
            if (buf.length < length) length = buf.length;
            buf.copy(this, offset, 0, length);
            return length; // TODO: Set _charsWritten.
        }; // -- Readable -------------------------------------------------------------
        if (iconv.supportsStreams) {
            var Readable = $07144aea14354eb9$var$Stream.Readable;
            original.ReadableSetEncoding = Readable.prototype.setEncoding;
            Readable.prototype.setEncoding = function setEncoding(enc, options) {
                // Use our own decoder, it has the same interface.
                // We cannot use original function as it doesn't handle BOM-s.
                this._readableState.decoder = iconv.getDecoder(enc, options);
                this._readableState.encoding = enc;
            };
            Readable.prototype.collect = iconv._collect;
        }
    }; // Remove iconv-lite Node primitive extensions.
    iconv.undoExtendNodeEncodings = function undoExtendNodeEncodings() {
        if (!iconv.supportsNodeEncodingsExtension) return;
        if (!original) throw new Error("require('iconv-lite').undoExtendNodeEncodings(): Nothing to undo; extendNodeEncodings() is not called.");
        delete $07144aea14354eb9$var$Buffer$7.isNativeEncoding;
        var SlowBuffer = $07144aea14354eb9$var$buffer.SlowBuffer;
        SlowBuffer.prototype.toString = original.SlowBufferToString;
        SlowBuffer.prototype.write = original.SlowBufferWrite;
        $07144aea14354eb9$var$Buffer$7.isEncoding = original.BufferIsEncoding;
        $07144aea14354eb9$var$Buffer$7.byteLength = original.BufferByteLength;
        $07144aea14354eb9$var$Buffer$7.prototype.toString = original.BufferToString;
        $07144aea14354eb9$var$Buffer$7.prototype.write = original.BufferWrite;
        if (iconv.supportsStreams) {
            var Readable = $07144aea14354eb9$var$Stream.Readable;
            Readable.prototype.setEncoding = original.ReadableSetEncoding;
            delete Readable.prototype.collect;
        }
        original = undefined;
    };
};
var $07144aea14354eb9$var$lib = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Solution would be installing npm modules "buffer" and "stream" explicitly.
    var Buffer = $07144aea14354eb9$var$safer_1.Buffer;
    var iconv = module.exports; // All codecs and aliases are kept here, keyed by encoding name/alias.
    // They are lazy loaded in `iconv.getCodec` from `encodings/index.js`.
    iconv.encodings = null; // Characters emitted in case of error.
    iconv.defaultCharUnicode = "\uFFFD";
    iconv.defaultCharSingleByte = '?'; // Public API.
    iconv.encode = function encode(str, encoding, options) {
        str = "" + (str || ""); // Ensure string.
        var encoder = iconv.getEncoder(encoding, options);
        var res = encoder.write(str);
        var trail = encoder.end();
        return trail && trail.length > 0 ? Buffer.concat([
            res,
            trail
        ]) : res;
    };
    iconv.decode = function decode(buf, encoding, options) {
        if (typeof buf === 'string') {
            if (!iconv.skipDecodeWarning) {
                console.error('Iconv-lite warning: decode()-ing strings is deprecated. Refer to https://github.com/ashtuchkin/iconv-lite/wiki/Use-Buffers-when-decoding');
                iconv.skipDecodeWarning = true;
            }
            buf = Buffer.from("" + (buf || ""), "binary"); // Ensure buffer.
        }
        var decoder = iconv.getDecoder(encoding, options);
        var res = decoder.write(buf);
        var trail = decoder.end();
        return trail ? res + trail : res;
    };
    iconv.encodingExists = function encodingExists(enc) {
        try {
            iconv.getCodec(enc);
            return true;
        } catch (e) {
            return false;
        }
    }; // Legacy aliases to convert functions
    iconv.toEncoding = iconv.encode;
    iconv.fromEncoding = iconv.decode; // Search for a codec in iconv.encodings. Cache codec data in iconv._codecDataCache.
    iconv._codecDataCache = {};
    iconv.getCodec = function getCodec(encoding) {
        if (!iconv.encodings) iconv.encodings = $07144aea14354eb9$var$encodings; // Lazy load all encoding definitions.
        // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
        var enc = iconv._canonicalizeEncoding(encoding); // Traverse iconv.encodings to find actual codec.
        var codecOptions = {};
        while(true){
            var codec = iconv._codecDataCache[enc];
            if (codec) return codec;
            var codecDef = iconv.encodings[enc];
            switch(typeof codecDef){
                case "string":
                    // Direct alias to other encoding.
                    enc = codecDef;
                    break;
                case "object":
                    // Alias with options. Can be layered.
                    for(var key in codecDef)codecOptions[key] = codecDef[key];
                    if (!codecOptions.encodingName) codecOptions.encodingName = enc;
                    enc = codecDef.type;
                    break;
                case "function":
                    // Codec itself.
                    if (!codecOptions.encodingName) codecOptions.encodingName = enc; // The codec function must load all tables and return object with .encoder and .decoder methods.
                    // It'll be called only once (for each different options object).
                    codec = new codecDef(codecOptions, iconv);
                    iconv._codecDataCache[codecOptions.encodingName] = codec; // Save it to be reused later.
                    return codec;
                default:
                    throw new Error("Encoding not recognized: '" + encoding + "' (searched as: '" + enc + "')");
            }
        }
    };
    iconv._canonicalizeEncoding = function(encoding) {
        // Canonicalize encoding name: strip all non-alphanumeric chars and appended year.
        return ('' + encoding).toLowerCase().replace(/:\d{4}$|[^0-9a-z]/g, "");
    };
    iconv.getEncoder = function getEncoder(encoding, options) {
        var codec = iconv.getCodec(encoding), encoder = new codec.encoder(options, codec);
        if (codec.bomAware && options && options.addBOM) encoder = new $07144aea14354eb9$var$bomHandling.PrependBOM(encoder, options);
        return encoder;
    };
    iconv.getDecoder = function getDecoder(encoding, options) {
        var codec = iconv.getCodec(encoding), decoder = new codec.decoder(options, codec);
        if (codec.bomAware && !(options && options.stripBOM === false)) decoder = new $07144aea14354eb9$var$bomHandling.StripBOM(decoder, options);
        return decoder;
    }; // Load extensions in Node. All of them are omitted in Browserify build via 'browser' field in package.json.
    var nodeVer = typeof $07144aea14354eb9$var$process !== 'undefined' && $07144aea14354eb9$var$process.versions && $07144aea14354eb9$var$process.versions.node;
    if (nodeVer) {
        // Load streaming support in Node v0.10+
        var nodeVerArr = nodeVer.split(".").map(Number);
        if (nodeVerArr[0] > 0 || nodeVerArr[1] >= 10) $07144aea14354eb9$var$streams(iconv);
         // Load Node primitive extensions.
        $07144aea14354eb9$var$extendNode(iconv);
    }
});
var $07144aea14354eb9$var$DecodeStream = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream, iconv;
        try {
            iconv = $07144aea14354eb9$var$lib;
        } catch (_error) {}
        DecodeStream = function() {
            var key;
            function DecodeStream(buffer) {
                this.buffer = buffer;
                this.pos = 0;
                this.length = this.buffer.length;
            }
            DecodeStream.TYPES = {
                UInt8: 1,
                UInt16: 2,
                UInt24: 3,
                UInt32: 4,
                Int8: 1,
                Int16: 2,
                Int24: 3,
                Int32: 4,
                Float: 4,
                Double: 8
            };
            for(key in $07144aea14354eb9$var$buffer_1.prototype)if (key.slice(0, 4) === 'read') (function(key) {
                var bytes;
                bytes = DecodeStream.TYPES[key.replace(/read|[BL]E/g, '')];
                return DecodeStream.prototype[key] = function() {
                    var ret;
                    ret = this.buffer[key](this.pos);
                    this.pos += bytes;
                    return ret;
                };
            })(key);
            DecodeStream.prototype.readString = function(length, encoding) {
                var buf, _byte, i, _i, _ref;
                if (encoding == null) encoding = 'ascii';
                switch(encoding){
                    case 'utf16le':
                    case 'ucs2':
                    case 'utf8':
                    case 'ascii':
                        return this.buffer.toString(encoding, this.pos, this.pos += length);
                    case 'utf16be':
                        buf = new $07144aea14354eb9$var$buffer_1(this.readBuffer(length));
                        for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                            _byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = _byte;
                        }
                        return buf.toString('utf16le');
                    default:
                        buf = this.readBuffer(length);
                        if (iconv) try {
                            return iconv.decode(buf, encoding);
                        } catch (_error) {}
                        return buf;
                }
            };
            DecodeStream.prototype.readBuffer = function(length) {
                return this.buffer.slice(this.pos, this.pos += length);
            };
            DecodeStream.prototype.readUInt24BE = function() {
                return (this.readUInt16BE() << 8) + this.readUInt8();
            };
            DecodeStream.prototype.readUInt24LE = function() {
                return this.readUInt16LE() + (this.readUInt8() << 16);
            };
            DecodeStream.prototype.readInt24BE = function() {
                return (this.readInt16BE() << 8) + this.readUInt8();
            };
            DecodeStream.prototype.readInt24LE = function() {
                return this.readUInt16LE() + (this.readInt8() << 16);
            };
            return DecodeStream;
        }();
        module.exports = DecodeStream;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$EncodeStream = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream$1, EncodeStream, iconv, stream, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        stream = $07144aea14354eb9$var$Stream;
        DecodeStream$1 = $07144aea14354eb9$var$DecodeStream;
        try {
            iconv = $07144aea14354eb9$var$lib;
        } catch (_error) {}
        EncodeStream = function(_super) {
            var key;
            __extends(EncodeStream, _super);
            function EncodeStream(bufferSize) {
                if (bufferSize == null) bufferSize = 65536;
                EncodeStream.__super__.constructor.apply(this, arguments);
                this.buffer = new $07144aea14354eb9$var$buffer_1(bufferSize);
                this.bufferOffset = 0;
                this.pos = 0;
            }
            for(key in $07144aea14354eb9$var$buffer_1.prototype)if (key.slice(0, 5) === 'write') (function(key) {
                var bytes;
                bytes = +DecodeStream$1.TYPES[key.replace(/write|[BL]E/g, '')];
                return EncodeStream.prototype[key] = function(value) {
                    this.ensure(bytes);
                    this.buffer[key](value, this.bufferOffset);
                    this.bufferOffset += bytes;
                    return this.pos += bytes;
                };
            })(key);
            EncodeStream.prototype._read = function() {};
            EncodeStream.prototype.ensure = function(bytes) {
                if (this.bufferOffset + bytes > this.buffer.length) return this.flush();
            };
            EncodeStream.prototype.flush = function() {
                if (this.bufferOffset > 0) {
                    this.push(new $07144aea14354eb9$var$buffer_1(this.buffer.slice(0, this.bufferOffset)));
                    return this.bufferOffset = 0;
                }
            };
            EncodeStream.prototype.writeBuffer = function(buffer) {
                this.flush();
                this.push(buffer);
                return this.pos += buffer.length;
            };
            EncodeStream.prototype.writeString = function(string, encoding) {
                var buf, _byte, i, _i, _ref;
                if (encoding == null) encoding = 'ascii';
                switch(encoding){
                    case 'utf16le':
                    case 'ucs2':
                    case 'utf8':
                    case 'ascii':
                        return this.writeBuffer(new $07144aea14354eb9$var$buffer_1(string, encoding));
                    case 'utf16be':
                        buf = new $07144aea14354eb9$var$buffer_1(string, 'utf16le');
                        for(i = _i = 0, _ref = buf.length - 1; _i < _ref; i = _i += 2){
                            _byte = buf[i];
                            buf[i] = buf[i + 1];
                            buf[i + 1] = _byte;
                        }
                        return this.writeBuffer(buf);
                    default:
                        if (iconv) return this.writeBuffer(iconv.encode(string, encoding));
                        else throw new Error('Install iconv-lite to enable additional string encodings.');
                }
            };
            EncodeStream.prototype.writeUInt24BE = function(val) {
                this.ensure(3);
                this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                this.buffer[this.bufferOffset++] = val & 0xff;
                return this.pos += 3;
            };
            EncodeStream.prototype.writeUInt24LE = function(val) {
                this.ensure(3);
                this.buffer[this.bufferOffset++] = val & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 8 & 0xff;
                this.buffer[this.bufferOffset++] = val >>> 16 & 0xff;
                return this.pos += 3;
            };
            EncodeStream.prototype.writeInt24BE = function(val) {
                if (val >= 0) return this.writeUInt24BE(val);
                else return this.writeUInt24BE(val + 0xffffff + 1);
            };
            EncodeStream.prototype.writeInt24LE = function(val) {
                if (val >= 0) return this.writeUInt24LE(val);
                else return this.writeUInt24LE(val + 0xffffff + 1);
            };
            EncodeStream.prototype.fill = function(val, length) {
                var buf;
                if (length < this.buffer.length) {
                    this.ensure(length);
                    this.buffer.fill(val, this.bufferOffset, this.bufferOffset + length);
                    this.bufferOffset += length;
                    return this.pos += length;
                } else {
                    buf = new $07144aea14354eb9$var$buffer_1(length);
                    buf.fill(val);
                    return this.writeBuffer(buf);
                }
            };
            EncodeStream.prototype.end = function() {
                this.flush();
                return this.push(null);
            };
            return EncodeStream;
        }(stream.Readable);
        module.exports = EncodeStream;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$_Number = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var DecodeStream$1, Fixed, NumberT, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        DecodeStream$1 = $07144aea14354eb9$var$DecodeStream;
        NumberT = function() {
            function NumberT(type, endian) {
                this.type = type;
                this.endian = endian != null ? endian : 'BE';
                this.fn = this.type;
                if (this.type[this.type.length - 1] !== '8') this.fn += this.endian;
            }
            NumberT.prototype.size = function() {
                return DecodeStream$1.TYPES[this.type];
            };
            NumberT.prototype.decode = function(stream) {
                return stream['read' + this.fn]();
            };
            NumberT.prototype.encode = function(stream, val) {
                return stream['write' + this.fn](val);
            };
            return NumberT;
        }();
        exports.Number = NumberT;
        exports.uint8 = new NumberT('UInt8');
        exports.uint16be = exports.uint16 = new NumberT('UInt16', 'BE');
        exports.uint16le = new NumberT('UInt16', 'LE');
        exports.uint24be = exports.uint24 = new NumberT('UInt24', 'BE');
        exports.uint24le = new NumberT('UInt24', 'LE');
        exports.uint32be = exports.uint32 = new NumberT('UInt32', 'BE');
        exports.uint32le = new NumberT('UInt32', 'LE');
        exports.int8 = new NumberT('Int8');
        exports.int16be = exports.int16 = new NumberT('Int16', 'BE');
        exports.int16le = new NumberT('Int16', 'LE');
        exports.int24be = exports.int24 = new NumberT('Int24', 'BE');
        exports.int24le = new NumberT('Int24', 'LE');
        exports.int32be = exports.int32 = new NumberT('Int32', 'BE');
        exports.int32le = new NumberT('Int32', 'LE');
        exports.floatbe = exports["float"] = new NumberT('Float', 'BE');
        exports.floatle = new NumberT('Float', 'LE');
        exports.doublebe = exports["double"] = new NumberT('Double', 'BE');
        exports.doublele = new NumberT('Double', 'LE');
        Fixed = function(_super) {
            __extends(Fixed, _super);
            function Fixed(size, endian, fracBits) {
                if (fracBits == null) fracBits = size >> 1;
                Fixed.__super__.constructor.call(this, "Int" + size, endian);
                this._point = 1 << fracBits;
            }
            Fixed.prototype.decode = function(stream) {
                return Fixed.__super__.decode.call(this, stream) / this._point;
            };
            Fixed.prototype.encode = function(stream, val) {
                return Fixed.__super__.encode.call(this, stream, val * this._point | 0);
            };
            return Fixed;
        }(NumberT);
        exports.Fixed = Fixed;
        exports.fixed16be = exports.fixed16 = new Fixed(16, 'BE');
        exports.fixed16le = new Fixed(16, 'LE');
        exports.fixed32be = exports.fixed32 = new Fixed(32, 'BE');
        exports.fixed32le = new Fixed(32, 'LE');
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$_Number_1 = $07144aea14354eb9$var$_Number.Number;
var $07144aea14354eb9$var$_Number_2 = $07144aea14354eb9$var$_Number.uint8;
var $07144aea14354eb9$var$_Number_3 = $07144aea14354eb9$var$_Number.uint16be;
var $07144aea14354eb9$var$_Number_4 = $07144aea14354eb9$var$_Number.uint16;
var $07144aea14354eb9$var$_Number_5 = $07144aea14354eb9$var$_Number.uint16le;
var $07144aea14354eb9$var$_Number_6 = $07144aea14354eb9$var$_Number.uint24be;
var $07144aea14354eb9$var$_Number_7 = $07144aea14354eb9$var$_Number.uint24;
var $07144aea14354eb9$var$_Number_8 = $07144aea14354eb9$var$_Number.uint24le;
var $07144aea14354eb9$var$_Number_9 = $07144aea14354eb9$var$_Number.uint32be;
var $07144aea14354eb9$var$_Number_10 = $07144aea14354eb9$var$_Number.uint32;
var $07144aea14354eb9$var$_Number_11 = $07144aea14354eb9$var$_Number.uint32le;
var $07144aea14354eb9$var$_Number_12 = $07144aea14354eb9$var$_Number.int8;
var $07144aea14354eb9$var$_Number_13 = $07144aea14354eb9$var$_Number.int16be;
var $07144aea14354eb9$var$_Number_14 = $07144aea14354eb9$var$_Number.int16;
var $07144aea14354eb9$var$_Number_15 = $07144aea14354eb9$var$_Number.int16le;
var $07144aea14354eb9$var$_Number_16 = $07144aea14354eb9$var$_Number.int24be;
var $07144aea14354eb9$var$_Number_17 = $07144aea14354eb9$var$_Number.int24;
var $07144aea14354eb9$var$_Number_18 = $07144aea14354eb9$var$_Number.int24le;
var $07144aea14354eb9$var$_Number_19 = $07144aea14354eb9$var$_Number.int32be;
var $07144aea14354eb9$var$_Number_20 = $07144aea14354eb9$var$_Number.int32;
var $07144aea14354eb9$var$_Number_21 = $07144aea14354eb9$var$_Number.int32le;
var $07144aea14354eb9$var$_Number_22 = $07144aea14354eb9$var$_Number.floatbe;
var $07144aea14354eb9$var$_Number_23 = $07144aea14354eb9$var$_Number.floatle;
var $07144aea14354eb9$var$_Number_24 = $07144aea14354eb9$var$_Number.doublebe;
var $07144aea14354eb9$var$_Number_25 = $07144aea14354eb9$var$_Number.doublele;
var $07144aea14354eb9$var$_Number_26 = $07144aea14354eb9$var$_Number.Fixed;
var $07144aea14354eb9$var$_Number_27 = $07144aea14354eb9$var$_Number.fixed16be;
var $07144aea14354eb9$var$_Number_28 = $07144aea14354eb9$var$_Number.fixed16;
var $07144aea14354eb9$var$_Number_29 = $07144aea14354eb9$var$_Number.fixed16le;
var $07144aea14354eb9$var$_Number_30 = $07144aea14354eb9$var$_Number.fixed32be;
var $07144aea14354eb9$var$_Number_31 = $07144aea14354eb9$var$_Number.fixed32;
var $07144aea14354eb9$var$_Number_32 = $07144aea14354eb9$var$_Number.fixed32le;
var $07144aea14354eb9$var$utils = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var NumberT, PropertyDescriptor;
        NumberT = $07144aea14354eb9$var$_Number.Number;
        exports.resolveLength = function(length, stream, parent) {
            var res;
            if (typeof length === 'number') res = length;
            else if (typeof length === 'function') res = length.call(parent, parent);
            else if (parent && typeof length === 'string') res = parent[length];
            else if (stream && length instanceof NumberT) res = length.decode(stream);
            if (isNaN(res)) throw new Error('Not a fixed size');
            return res;
        };
        PropertyDescriptor = function() {
            function PropertyDescriptor(opts) {
                var key, val;
                if (opts == null) opts = {};
                this.enumerable = true;
                this.configurable = true;
                for(key in opts){
                    val = opts[key];
                    this[key] = val;
                }
            }
            return PropertyDescriptor;
        }();
        exports.PropertyDescriptor = PropertyDescriptor;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$utils_1 = $07144aea14354eb9$var$utils.resolveLength;
var $07144aea14354eb9$var$utils_2 = $07144aea14354eb9$var$utils.PropertyDescriptor;
var $07144aea14354eb9$var$_Array = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var ArrayT, NumberT, utils$1;
        NumberT = $07144aea14354eb9$var$_Number.Number;
        utils$1 = $07144aea14354eb9$var$utils;
        ArrayT = function() {
            function ArrayT(type, length, lengthType) {
                this.type = type;
                this.length = length;
                this.lengthType = lengthType != null ? lengthType : 'count';
            }
            ArrayT.prototype.decode = function(stream, parent) {
                var ctx, i, length, pos, res, target, _i;
                pos = stream.pos;
                res = [];
                ctx = parent;
                if (this.length != null) length = utils$1.resolveLength(this.length, stream, parent);
                if (this.length instanceof NumberT) {
                    Object.defineProperties(res, {
                        parent: {
                            value: parent
                        },
                        _startOffset: {
                            value: pos
                        },
                        _currentOffset: {
                            value: 0,
                            writable: true
                        },
                        _length: {
                            value: length
                        }
                    });
                    ctx = res;
                }
                if (length == null || this.lengthType === 'bytes') {
                    target = length != null ? stream.pos + length : (parent != null ? parent._length : void 0) ? parent._startOffset + parent._length : stream.length;
                    while(stream.pos < target)res.push(this.type.decode(stream, ctx));
                } else for(i = _i = 0; _i < length; i = _i += 1)res.push(this.type.decode(stream, ctx));
                return res;
            };
            ArrayT.prototype.size = function(array, ctx) {
                var item, size, _i, _len;
                if (!array) return this.type.size(null, ctx) * utils$1.resolveLength(this.length, null, ctx);
                size = 0;
                if (this.length instanceof NumberT) {
                    size += this.length.size();
                    ctx = {
                        parent: ctx
                    };
                }
                for(_i = 0, _len = array.length; _i < _len; _i++){
                    item = array[_i];
                    size += this.type.size(item, ctx);
                }
                return size;
            };
            ArrayT.prototype.encode = function(stream, array, parent) {
                var ctx, i, item, ptr, _i, _len;
                ctx = parent;
                if (this.length instanceof NumberT) {
                    ctx = {
                        pointers: [],
                        startOffset: stream.pos,
                        parent: parent
                    };
                    ctx.pointerOffset = stream.pos + this.size(array, ctx);
                    this.length.encode(stream, array.length);
                }
                for(_i = 0, _len = array.length; _i < _len; _i++){
                    item = array[_i];
                    this.type.encode(stream, item, ctx);
                }
                if (this.length instanceof NumberT) {
                    i = 0;
                    while(i < ctx.pointers.length){
                        ptr = ctx.pointers[i++];
                        ptr.type.encode(stream, ptr.val);
                    }
                }
            };
            return ArrayT;
        }();
        module.exports = ArrayT;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$LazyArray = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var ArrayT, LazyArray, LazyArrayT, NumberT, inspect, utils$1, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        ArrayT = $07144aea14354eb9$var$_Array;
        NumberT = $07144aea14354eb9$var$_Number.Number;
        utils$1 = $07144aea14354eb9$var$utils;
        inspect = $07144aea14354eb9$var$require$$3.inspect;
        LazyArrayT = function(_super) {
            __extends(LazyArrayT, _super);
            function LazyArrayT() {
                return LazyArrayT.__super__.constructor.apply(this, arguments);
            }
            LazyArrayT.prototype.decode = function(stream, parent) {
                var length, pos, res;
                pos = stream.pos;
                length = utils$1.resolveLength(this.length, stream, parent);
                if (this.length instanceof NumberT) parent = {
                    parent: parent,
                    _startOffset: pos,
                    _currentOffset: 0,
                    _length: length
                };
                res = new LazyArray(this.type, length, stream, parent);
                stream.pos += length * this.type.size(null, parent);
                return res;
            };
            LazyArrayT.prototype.size = function(val, ctx) {
                if (val instanceof LazyArray) val = val.toArray();
                return LazyArrayT.__super__.size.call(this, val, ctx);
            };
            LazyArrayT.prototype.encode = function(stream, val, ctx) {
                if (val instanceof LazyArray) val = val.toArray();
                return LazyArrayT.__super__.encode.call(this, stream, val, ctx);
            };
            return LazyArrayT;
        }(ArrayT);
        LazyArray = function() {
            function LazyArray(type, length, stream, ctx) {
                this.type = type;
                this.length = length;
                this.stream = stream;
                this.ctx = ctx;
                this.base = this.stream.pos;
                this.items = [];
            }
            LazyArray.prototype.get = function(index) {
                var pos;
                if (index < 0 || index >= this.length) return void 0;
                if (this.items[index] == null) {
                    pos = this.stream.pos;
                    this.stream.pos = this.base + this.type.size(null, this.ctx) * index;
                    this.items[index] = this.type.decode(this.stream, this.ctx);
                    this.stream.pos = pos;
                }
                return this.items[index];
            };
            LazyArray.prototype.toArray = function() {
                var i, _i, _ref, _results;
                _results = [];
                for(i = _i = 0, _ref = this.length; _i < _ref; i = _i += 1)_results.push(this.get(i));
                return _results;
            };
            LazyArray.prototype.inspect = function() {
                return inspect(this.toArray());
            };
            return LazyArray;
        }();
        module.exports = LazyArrayT;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Bitfield = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Bitfield;
        Bitfield = function() {
            function Bitfield(type, flags) {
                this.type = type;
                this.flags = flags != null ? flags : [];
            }
            Bitfield.prototype.decode = function(stream) {
                var flag, i, res, val, _i, _len, _ref;
                val = this.type.decode(stream);
                res = {};
                _ref = this.flags;
                for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                    flag = _ref[i];
                    if (flag != null) res[flag] = !!(val & 1 << i);
                }
                return res;
            };
            Bitfield.prototype.size = function() {
                return this.type.size();
            };
            Bitfield.prototype.encode = function(stream, keys) {
                var flag, i, val, _i, _len, _ref;
                val = 0;
                _ref = this.flags;
                for(i = _i = 0, _len = _ref.length; _i < _len; i = ++_i){
                    flag = _ref[i];
                    if (flag != null) {
                        if (keys[flag]) val |= 1 << i;
                    }
                }
                return this.type.encode(stream, val);
            };
            return Bitfield;
        }();
        module.exports = Bitfield;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$_Boolean = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var BooleanT;
        BooleanT = function() {
            function BooleanT(type) {
                this.type = type;
            }
            BooleanT.prototype.decode = function(stream, parent) {
                return !!this.type.decode(stream, parent);
            };
            BooleanT.prototype.size = function(val, parent) {
                return this.type.size(val, parent);
            };
            BooleanT.prototype.encode = function(stream, val, parent) {
                return this.type.encode(stream, +val, parent);
            };
            return BooleanT;
        }();
        module.exports = BooleanT;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Buffer$8 = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var BufferT, NumberT, utils$1;
        utils$1 = $07144aea14354eb9$var$utils;
        NumberT = $07144aea14354eb9$var$_Number.Number;
        BufferT = function() {
            function BufferT(length) {
                this.length = length;
            }
            BufferT.prototype.decode = function(stream, parent) {
                var length;
                length = utils$1.resolveLength(this.length, stream, parent);
                return stream.readBuffer(length);
            };
            BufferT.prototype.size = function(val, parent) {
                if (!val) return utils$1.resolveLength(this.length, null, parent);
                return val.length;
            };
            BufferT.prototype.encode = function(stream, buf, parent) {
                if (this.length instanceof NumberT) this.length.encode(stream, buf.length);
                return stream.writeBuffer(buf);
            };
            return BufferT;
        }();
        module.exports = BufferT;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Enum = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Enum;
        Enum = function() {
            function Enum(type, options) {
                this.type = type;
                this.options = options != null ? options : [];
            }
            Enum.prototype.decode = function(stream) {
                var index;
                index = this.type.decode(stream);
                return this.options[index] || index;
            };
            Enum.prototype.size = function() {
                return this.type.size();
            };
            Enum.prototype.encode = function(stream, val) {
                var index;
                index = this.options.indexOf(val);
                if (index === -1) throw new Error("Unknown option in enum: " + val);
                return this.type.encode(stream, index);
            };
            return Enum;
        }();
        module.exports = Enum;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Optional = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Optional;
        Optional = function() {
            function Optional(type, condition) {
                this.type = type;
                this.condition = condition != null ? condition : true;
            }
            Optional.prototype.decode = function(stream, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.decode(stream, parent);
            };
            Optional.prototype.size = function(val, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.size(val, parent);
                else return 0;
            };
            Optional.prototype.encode = function(stream, val, parent) {
                var condition;
                condition = this.condition;
                if (typeof condition === 'function') condition = condition.call(parent, parent);
                if (condition) return this.type.encode(stream, val, parent);
            };
            return Optional;
        }();
        module.exports = Optional;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Reserved = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Reserved, utils$1;
        utils$1 = $07144aea14354eb9$var$utils;
        Reserved = function() {
            function Reserved(type, count) {
                this.type = type;
                this.count = count != null ? count : 1;
            }
            Reserved.prototype.decode = function(stream, parent) {
                stream.pos += this.size(null, parent);
                return void 0;
            };
            Reserved.prototype.size = function(data, parent) {
                var count;
                count = utils$1.resolveLength(this.count, null, parent);
                return this.type.size() * count;
            };
            Reserved.prototype.encode = function(stream, val, parent) {
                return stream.fill(0, this.size(val, parent));
            };
            return Reserved;
        }();
        module.exports = Reserved;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$_String = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var NumberT, StringT, utils$1;
        NumberT = $07144aea14354eb9$var$_Number.Number;
        utils$1 = $07144aea14354eb9$var$utils;
        StringT = function() {
            function StringT(length, encoding) {
                this.length = length;
                this.encoding = encoding != null ? encoding : 'ascii';
            }
            StringT.prototype.decode = function(stream, parent) {
                var buffer, encoding, length, pos, string;
                length = (function() {
                    if (this.length != null) return utils$1.resolveLength(this.length, stream, parent);
                    else {
                        buffer = stream.buffer, length = stream.length, pos = stream.pos;
                        while(pos < length && buffer[pos] !== 0x00)++pos;
                        return pos - stream.pos;
                    }
                }).call(this);
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent, parent) || 'ascii';
                string = stream.readString(length, encoding);
                if (this.length == null && stream.pos < stream.length) stream.pos++;
                return string;
            };
            StringT.prototype.size = function(val, parent) {
                var encoding, size;
                if (!val) return utils$1.resolveLength(this.length, null, parent);
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
                if (encoding === 'utf16be') encoding = 'utf16le';
                size = $07144aea14354eb9$var$buffer_1.byteLength(val, encoding);
                if (this.length instanceof NumberT) size += this.length.size();
                if (this.length == null) size++;
                return size;
            };
            StringT.prototype.encode = function(stream, val, parent) {
                var encoding;
                encoding = this.encoding;
                if (typeof encoding === 'function') encoding = encoding.call(parent != null ? parent.val : void 0, parent != null ? parent.val : void 0) || 'ascii';
                if (this.length instanceof NumberT) this.length.encode(stream, $07144aea14354eb9$var$buffer_1.byteLength(val, encoding));
                stream.writeString(val, encoding);
                if (this.length == null) return stream.writeUInt8(0x00);
            };
            return StringT;
        }();
        module.exports = StringT;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Struct = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Struct, utils$1;
        utils$1 = $07144aea14354eb9$var$utils;
        Struct = function() {
            function Struct(fields) {
                this.fields = fields != null ? fields : {};
            }
            Struct.prototype.decode = function(stream, parent, length) {
                var res, _ref;
                if (length == null) length = 0;
                res = this._setup(stream, parent, length);
                this._parseFields(stream, res, this.fields);
                if ((_ref = this.process) != null) _ref.call(res, stream);
                return res;
            };
            Struct.prototype._setup = function(stream, parent, length) {
                var res;
                res = {};
                Object.defineProperties(res, {
                    parent: {
                        value: parent
                    },
                    _startOffset: {
                        value: stream.pos
                    },
                    _currentOffset: {
                        value: 0,
                        writable: true
                    },
                    _length: {
                        value: length
                    }
                });
                return res;
            };
            Struct.prototype._parseFields = function(stream, res, fields) {
                var key, type, val;
                for(key in fields){
                    type = fields[key];
                    if (typeof type === 'function') val = type.call(res, res);
                    else val = type.decode(stream, res);
                    if (val !== void 0) {
                        if (val instanceof utils$1.PropertyDescriptor) Object.defineProperty(res, key, val);
                        else res[key] = val;
                    }
                    res._currentOffset = stream.pos - res._startOffset;
                }
            };
            Struct.prototype.size = function(val, parent, includePointers) {
                var ctx, key, size, type, _ref;
                if (val == null) val = {};
                if (includePointers == null) includePointers = true;
                ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                size = 0;
                _ref = this.fields;
                for(key in _ref){
                    type = _ref[key];
                    if (type.size != null) size += type.size(val[key], ctx);
                }
                if (includePointers) size += ctx.pointerSize;
                return size;
            };
            Struct.prototype.encode = function(stream, val, parent) {
                var ctx, i, key, ptr, type, _ref, _ref1;
                if ((_ref = this.preEncode) != null) _ref.call(val, stream);
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                _ref1 = this.fields;
                for(key in _ref1){
                    type = _ref1[key];
                    if (type.encode != null) type.encode(stream, val[key], ctx);
                }
                i = 0;
                while(i < ctx.pointers.length){
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                }
            };
            return Struct;
        }();
        module.exports = Struct;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$VersionedStruct = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Struct$1, VersionedStruct, __hasProp = {}.hasOwnProperty, __extends = function __extends(child, parent) {
            for(var key in parent)if (__hasProp.call(parent, key)) child[key] = parent[key];
            function ctor() {
                this.constructor = child;
            }
            ctor.prototype = parent.prototype;
            child.prototype = new ctor();
            child.__super__ = parent.prototype;
            return child;
        };
        Struct$1 = $07144aea14354eb9$var$Struct;
        VersionedStruct = function(_super) {
            __extends(VersionedStruct, _super);
            function VersionedStruct(type, versions) {
                this.type = type;
                this.versions = versions != null ? versions : {};
            }
            VersionedStruct.prototype.versionGetter = function(parent) {
                if (typeof this.type === 'string') return this.type.split('.').reduce(function(obj, prop) {
                    if (typeof obj !== 'undefined') return obj[prop];
                    else return void 0;
                }, parent);
            };
            VersionedStruct.prototype.versionSetter = function(parent, version) {
                if (typeof this.type === 'string') return this.type.split('.').reduce(function(obj, prop) {
                    return obj[prop] = version;
                }, parent);
            };
            VersionedStruct.prototype.decode = function(stream, parent, length) {
                var fields, res, _ref;
                if (length == null) length = 0;
                res = this._setup(stream, parent, length);
                if (typeof this.type === 'string') res.version = this.versionGetter(parent);
                else res.version = this.type.decode(stream);
                if (this.versions.header) this._parseFields(stream, res, this.versions.header);
                fields = this.versions[res.version];
                if (fields == null) throw new Error("Unknown version " + res.version);
                if (fields instanceof VersionedStruct) return fields.decode(stream, parent);
                this._parseFields(stream, res, fields);
                if ((_ref = this.process) != null) _ref.call(res, stream);
                return res;
            };
            VersionedStruct.prototype.size = function(val, parent, includePointers) {
                var ctx, fields, key, size, type, _ref;
                if (includePointers == null) includePointers = true;
                if (!val) throw new Error('Not a fixed size');
                ctx = {
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                size = 0;
                if (typeof this.type !== 'string') size += this.type.size(val.version, ctx);
                if (this.versions.header) {
                    _ref = this.versions.header;
                    for(key in _ref){
                        type = _ref[key];
                        if (type.size != null) size += type.size(val[key], ctx);
                    }
                }
                fields = this.versions[val.version];
                if (fields == null) throw new Error("Unknown version " + val.version);
                for(key in fields){
                    type = fields[key];
                    if (type.size != null) size += type.size(val[key], ctx);
                }
                if (includePointers) size += ctx.pointerSize;
                return size;
            };
            VersionedStruct.prototype.encode = function(stream, val, parent) {
                var ctx, fields, i, key, ptr, type, _ref, _ref1;
                if ((_ref = this.preEncode) != null) _ref.call(val, stream);
                ctx = {
                    pointers: [],
                    startOffset: stream.pos,
                    parent: parent,
                    val: val,
                    pointerSize: 0
                };
                ctx.pointerOffset = stream.pos + this.size(val, ctx, false);
                if (typeof this.type !== 'string') this.type.encode(stream, val.version);
                if (this.versions.header) {
                    _ref1 = this.versions.header;
                    for(key in _ref1){
                        type = _ref1[key];
                        if (type.encode != null) type.encode(stream, val[key], ctx);
                    }
                }
                fields = this.versions[val.version];
                for(key in fields){
                    type = fields[key];
                    if (type.encode != null) type.encode(stream, val[key], ctx);
                }
                i = 0;
                while(i < ctx.pointers.length){
                    ptr = ctx.pointers[i++];
                    ptr.type.encode(stream, ptr.val, ptr.parent);
                }
            };
            return VersionedStruct;
        }(Struct$1);
        module.exports = VersionedStruct;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Pointer = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var Pointer, VoidPointer, utils$1;
        utils$1 = $07144aea14354eb9$var$utils;
        Pointer = function() {
            function Pointer(offsetType, type, options) {
                var _base, _base1, _base2, _base3;
                this.offsetType = offsetType;
                this.type = type;
                this.options = options != null ? options : {};
                if (this.type === 'void') this.type = null;
                if ((_base = this.options).type == null) _base.type = 'local';
                if ((_base1 = this.options).allowNull == null) _base1.allowNull = true;
                if ((_base2 = this.options).nullValue == null) _base2.nullValue = 0;
                if ((_base3 = this.options).lazy == null) _base3.lazy = false;
            }
            Pointer.prototype.relativeToGetter = function(ctx) {
                return this.options.relativeTo.split('.').reduce(function(obj, prop) {
                    return obj[prop];
                }, ctx);
            };
            Pointer.prototype.decode = function(stream, ctx) {
                var c, decodeValue, offset, ptr, relative, val;
                offset = this.offsetType.decode(stream, ctx);
                if (offset === this.options.nullValue && this.options.allowNull) return null;
                relative = (function() {
                    switch(this.options.type){
                        case 'local':
                            return ctx._startOffset;
                        case 'immediate':
                            return stream.pos - this.offsetType.size();
                        case 'parent':
                            return ctx.parent._startOffset;
                        default:
                            c = ctx;
                            while(c.parent)c = c.parent;
                            return c._startOffset || 0;
                    }
                }).call(this);
                if (this.options.relativeTo) relative += this.relativeToGetter(ctx);
                ptr = offset + relative;
                if (this.type != null) {
                    val = null;
                    decodeValue = function(_this) {
                        return function() {
                            var pos;
                            if (val != null) return val;
                            pos = stream.pos;
                            stream.pos = ptr;
                            val = _this.type.decode(stream, ctx);
                            stream.pos = pos;
                            return val;
                        };
                    }(this);
                    if (this.options.lazy) return new utils$1.PropertyDescriptor({
                        get: decodeValue
                    });
                    return decodeValue();
                } else return ptr;
            };
            Pointer.prototype.size = function(val, ctx) {
                var parent, type;
                parent = ctx;
                switch(this.options.type){
                    case 'local':
                    case 'immediate':
                        break;
                    case 'parent':
                        ctx = ctx.parent;
                        break;
                    default:
                        while(ctx.parent)ctx = ctx.parent;
                }
                type = this.type;
                if (type == null) {
                    if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                    type = val.type;
                    val = val.value;
                }
                if (val && ctx) ctx.pointerSize += type.size(val, parent);
                return this.offsetType.size();
            };
            Pointer.prototype.encode = function(stream, val, ctx) {
                var parent, relative, type;
                parent = ctx;
                if (val == null) {
                    this.offsetType.encode(stream, this.options.nullValue);
                    return;
                }
                switch(this.options.type){
                    case 'local':
                        relative = ctx.startOffset;
                        break;
                    case 'immediate':
                        relative = stream.pos + this.offsetType.size(val, parent);
                        break;
                    case 'parent':
                        ctx = ctx.parent;
                        relative = ctx.startOffset;
                        break;
                    default:
                        relative = 0;
                        while(ctx.parent)ctx = ctx.parent;
                }
                if (this.options.relativeTo) relative += this.relativeToGetter(parent.val);
                this.offsetType.encode(stream, ctx.pointerOffset - relative);
                type = this.type;
                if (type == null) {
                    if (!(val instanceof VoidPointer)) throw new Error("Must be a VoidPointer");
                    type = val.type;
                    val = val.value;
                }
                ctx.pointers.push({
                    type: type,
                    val: val,
                    parent: parent
                });
                return ctx.pointerOffset += type.size(val, parent);
            };
            return Pointer;
        }();
        VoidPointer = function() {
            function VoidPointer(type, value) {
                this.type = type;
                this.value = value;
            }
            return VoidPointer;
        }();
        exports.Pointer = Pointer;
        exports.VoidPointer = VoidPointer;
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$Pointer_1 = $07144aea14354eb9$var$Pointer.Pointer;
var $07144aea14354eb9$var$Pointer_2 = $07144aea14354eb9$var$Pointer.VoidPointer;
var $07144aea14354eb9$var$restructure = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    // Generated by CoffeeScript 1.7.1
    (function() {
        var key, val, _ref, _ref1;
        exports.EncodeStream = $07144aea14354eb9$var$EncodeStream;
        exports.DecodeStream = $07144aea14354eb9$var$DecodeStream;
        exports.Array = $07144aea14354eb9$var$_Array;
        exports.LazyArray = $07144aea14354eb9$var$LazyArray;
        exports.Bitfield = $07144aea14354eb9$var$Bitfield;
        exports.Boolean = $07144aea14354eb9$var$_Boolean;
        exports.Buffer = $07144aea14354eb9$var$Buffer$8;
        exports.Enum = $07144aea14354eb9$var$Enum;
        exports.Optional = $07144aea14354eb9$var$Optional;
        exports.Reserved = $07144aea14354eb9$var$Reserved;
        exports.String = $07144aea14354eb9$var$_String;
        exports.Struct = $07144aea14354eb9$var$Struct;
        exports.VersionedStruct = $07144aea14354eb9$var$VersionedStruct;
        _ref = $07144aea14354eb9$var$_Number;
        for(key in _ref){
            val = _ref[key];
            exports[key] = val;
        }
        _ref1 = $07144aea14354eb9$var$Pointer;
        for(key in _ref1){
            val = _ref1[key];
            exports[key] = val;
        }
    }).call($07144aea14354eb9$var$commonjsGlobal);
});
var $07144aea14354eb9$var$restructure_1 = $07144aea14354eb9$var$restructure.EncodeStream;
var $07144aea14354eb9$var$restructure_2 = $07144aea14354eb9$var$restructure.DecodeStream;
var $07144aea14354eb9$var$restructure_3 = $07144aea14354eb9$var$restructure.Array;
var $07144aea14354eb9$var$restructure_4 = $07144aea14354eb9$var$restructure.LazyArray;
var $07144aea14354eb9$var$restructure_5 = $07144aea14354eb9$var$restructure.Bitfield;
var $07144aea14354eb9$var$restructure_6 = $07144aea14354eb9$var$restructure.Boolean;
var $07144aea14354eb9$var$restructure_7 = $07144aea14354eb9$var$restructure.Buffer;
var $07144aea14354eb9$var$restructure_8 = $07144aea14354eb9$var$restructure.Enum;
var $07144aea14354eb9$var$restructure_9 = $07144aea14354eb9$var$restructure.Optional;
var $07144aea14354eb9$var$restructure_10 = $07144aea14354eb9$var$restructure.Reserved;
var $07144aea14354eb9$var$restructure_11 = $07144aea14354eb9$var$restructure.String;
var $07144aea14354eb9$var$restructure_12 = $07144aea14354eb9$var$restructure.Struct;
var $07144aea14354eb9$var$restructure_13 = $07144aea14354eb9$var$restructure.VersionedStruct;
var $07144aea14354eb9$var$formats = [];
var $07144aea14354eb9$var$fontkit = {
    logErrors: false,
    registerFormat: function registerFormat(format) {
        $07144aea14354eb9$var$formats.push(format);
    },
    create: function create(uint8ArrayFontData, postscriptName) {
        var buffer = new $07144aea14354eb9$var$buffer_1.from(uint8ArrayFontData);
        for(var i = 0; i < $07144aea14354eb9$var$formats.length; i++){
            var format = $07144aea14354eb9$var$formats[i];
            if (format.probe(buffer)) {
                var font = new format(new $07144aea14354eb9$var$restructure.DecodeStream(buffer));
                if (postscriptName) return font.getFont(postscriptName);
                return font;
            }
        }
        throw new Error('Unknown font format');
    }
};
/**
 * This decorator caches the results of a getter or method such that
 * the results are lazily computed once, and then cached.
 * @private
 */ function $07144aea14354eb9$var$cache(target, key, descriptor) {
    if (descriptor.get) {
        var get = descriptor.get;
        descriptor.get = function() {
            var value = get.call(this);
            Object.defineProperty(this, key, {
                value: value
            });
            return value;
        };
    } else if (typeof descriptor.value === 'function') {
        var fn = descriptor.value;
        return {
            get: function get() {
                var cache = new Map();
                function memoized() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                    var key = args.length > 0 ? args[0] : 'value';
                    if (cache.has(key)) return cache.get(key);
                    var result = fn.apply(this, args);
                    cache.set(key, result);
                    return result;
                }
                Object.defineProperty(this, key, {
                    value: memoized
                });
                return memoized;
            }
        };
    }
}
var $07144aea14354eb9$var$SubHeader = new $07144aea14354eb9$var$restructure.Struct({
    firstCode: $07144aea14354eb9$var$restructure.uint16,
    entryCount: $07144aea14354eb9$var$restructure.uint16,
    idDelta: $07144aea14354eb9$var$restructure.int16,
    idRangeOffset: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$CmapGroup = new $07144aea14354eb9$var$restructure.Struct({
    startCharCode: $07144aea14354eb9$var$restructure.uint32,
    endCharCode: $07144aea14354eb9$var$restructure.uint32,
    glyphID: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$UnicodeValueRange = new $07144aea14354eb9$var$restructure.Struct({
    startUnicodeValue: $07144aea14354eb9$var$restructure.uint24,
    additionalCount: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$UVSMapping = new $07144aea14354eb9$var$restructure.Struct({
    unicodeValue: $07144aea14354eb9$var$restructure.uint24,
    glyphID: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$DefaultUVS = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$UnicodeValueRange, $07144aea14354eb9$var$restructure.uint32);
var $07144aea14354eb9$var$NonDefaultUVS = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$UVSMapping, $07144aea14354eb9$var$restructure.uint32);
var $07144aea14354eb9$var$VarSelectorRecord = new $07144aea14354eb9$var$restructure.Struct({
    varSelector: $07144aea14354eb9$var$restructure.uint24,
    defaultUVS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$DefaultUVS, {
        type: 'parent'
    }),
    nonDefaultUVS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$NonDefaultUVS, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$CmapSubtable = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    0: {
        // Byte encoding
        length: $07144aea14354eb9$var$restructure.uint16,
        // Total table length in bytes (set to 262 for format 0)
        language: $07144aea14354eb9$var$restructure.uint16,
        // Language code for this encoding subtable, or zero if language-independent
        codeMap: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint8, 256)
    },
    2: {
        // High-byte mapping (CJK)
        length: $07144aea14354eb9$var$restructure.uint16,
        language: $07144aea14354eb9$var$restructure.uint16,
        subHeaderKeys: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 256),
        subHeaderCount: function subHeaderCount(t) {
            return Math.max.apply(Math, t.subHeaderKeys);
        },
        subHeaders: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$SubHeader, 'subHeaderCount'),
        glyphIndexArray: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'subHeaderCount')
    },
    4: {
        // Segment mapping to delta values
        length: $07144aea14354eb9$var$restructure.uint16,
        // Total table length in bytes
        language: $07144aea14354eb9$var$restructure.uint16,
        // Language code
        segCountX2: $07144aea14354eb9$var$restructure.uint16,
        segCount: function segCount(t) {
            return t.segCountX2 >> 1;
        },
        searchRange: $07144aea14354eb9$var$restructure.uint16,
        entrySelector: $07144aea14354eb9$var$restructure.uint16,
        rangeShift: $07144aea14354eb9$var$restructure.uint16,
        endCode: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'segCount'),
        reservedPad: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        // This value should be zero
        startCode: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'segCount'),
        idDelta: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.int16, 'segCount'),
        idRangeOffset: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'segCount'),
        glyphIndexArray: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, function(t) {
            return (t.length - t._currentOffset) / 2;
        })
    },
    6: {
        // Trimmed table
        length: $07144aea14354eb9$var$restructure.uint16,
        language: $07144aea14354eb9$var$restructure.uint16,
        firstCode: $07144aea14354eb9$var$restructure.uint16,
        entryCount: $07144aea14354eb9$var$restructure.uint16,
        glyphIndices: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'entryCount')
    },
    8: {
        // mixed 16-bit and 32-bit coverage
        reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        length: $07144aea14354eb9$var$restructure.uint32,
        language: $07144aea14354eb9$var$restructure.uint16,
        is32: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint8, 8192),
        nGroups: $07144aea14354eb9$var$restructure.uint32,
        groups: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$CmapGroup, 'nGroups')
    },
    10: {
        // Trimmed Array
        reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        length: $07144aea14354eb9$var$restructure.uint32,
        language: $07144aea14354eb9$var$restructure.uint32,
        firstCode: $07144aea14354eb9$var$restructure.uint32,
        entryCount: $07144aea14354eb9$var$restructure.uint32,
        glyphIndices: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'numChars')
    },
    12: {
        // Segmented coverage
        reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        length: $07144aea14354eb9$var$restructure.uint32,
        language: $07144aea14354eb9$var$restructure.uint32,
        nGroups: $07144aea14354eb9$var$restructure.uint32,
        groups: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$CmapGroup, 'nGroups')
    },
    13: {
        // Many-to-one range mappings (same as 12 except for group.startGlyphID)
        reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        length: $07144aea14354eb9$var$restructure.uint32,
        language: $07144aea14354eb9$var$restructure.uint32,
        nGroups: $07144aea14354eb9$var$restructure.uint32,
        groups: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$CmapGroup, 'nGroups')
    },
    14: {
        // Unicode Variation Sequences
        length: $07144aea14354eb9$var$restructure.uint32,
        numRecords: $07144aea14354eb9$var$restructure.uint32,
        varSelectors: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$VarSelectorRecord, 'numRecords')
    }
});
var $07144aea14354eb9$var$CmapEntry = new $07144aea14354eb9$var$restructure.Struct({
    platformID: $07144aea14354eb9$var$restructure.uint16,
    // Platform identifier
    encodingID: $07144aea14354eb9$var$restructure.uint16,
    // Platform-specific encoding identifier
    table: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$CmapSubtable, {
        type: 'parent',
        lazy: true
    })
}); // character to glyph mapping
var $07144aea14354eb9$var$cmap = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    numSubtables: $07144aea14354eb9$var$restructure.uint16,
    tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$CmapEntry, 'numSubtables')
});
var $07144aea14354eb9$var$head = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.int32,
    // 0x00010000 (version 1.0)
    revision: $07144aea14354eb9$var$restructure.int32,
    // set by font manufacturer
    checkSumAdjustment: $07144aea14354eb9$var$restructure.uint32,
    magicNumber: $07144aea14354eb9$var$restructure.uint32,
    // set to 0x5F0F3CF5
    flags: $07144aea14354eb9$var$restructure.uint16,
    unitsPerEm: $07144aea14354eb9$var$restructure.uint16,
    // range from 64 to 16384
    created: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int32, 2),
    modified: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int32, 2),
    xMin: $07144aea14354eb9$var$restructure.int16,
    // for all glyph bounding boxes
    yMin: $07144aea14354eb9$var$restructure.int16,
    // for all glyph bounding boxes
    xMax: $07144aea14354eb9$var$restructure.int16,
    // for all glyph bounding boxes
    yMax: $07144aea14354eb9$var$restructure.int16,
    // for all glyph bounding boxes
    macStyle: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
        'bold',
        'italic',
        'underline',
        'outline',
        'shadow',
        'condensed',
        'extended'
    ]),
    lowestRecPPEM: $07144aea14354eb9$var$restructure.uint16,
    // smallest readable size in pixels
    fontDirectionHint: $07144aea14354eb9$var$restructure.int16,
    indexToLocFormat: $07144aea14354eb9$var$restructure.int16,
    // 0 for short offsets, 1 for long
    glyphDataFormat: $07144aea14354eb9$var$restructure.int16 // 0 for current format
});
var $07144aea14354eb9$var$hhea = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.int32,
    ascent: $07144aea14354eb9$var$restructure.int16,
    // Distance from baseline of highest ascender
    descent: $07144aea14354eb9$var$restructure.int16,
    // Distance from baseline of lowest descender
    lineGap: $07144aea14354eb9$var$restructure.int16,
    // Typographic line gap
    advanceWidthMax: $07144aea14354eb9$var$restructure.uint16,
    // Maximum advance width value in 'hmtx' table
    minLeftSideBearing: $07144aea14354eb9$var$restructure.int16,
    // Maximum advance width value in 'hmtx' table
    minRightSideBearing: $07144aea14354eb9$var$restructure.int16,
    // Minimum right sidebearing value
    xMaxExtent: $07144aea14354eb9$var$restructure.int16,
    caretSlopeRise: $07144aea14354eb9$var$restructure.int16,
    // Used to calculate the slope of the cursor (rise/run); 1 for vertical
    caretSlopeRun: $07144aea14354eb9$var$restructure.int16,
    // 0 for vertical
    caretOffset: $07144aea14354eb9$var$restructure.int16,
    // Set to 0 for non-slanted fonts
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.int16, 4),
    metricDataFormat: $07144aea14354eb9$var$restructure.int16,
    // 0 for current format
    numberOfMetrics: $07144aea14354eb9$var$restructure.uint16 // Number of advance widths in 'hmtx' table
});
var $07144aea14354eb9$var$HmtxEntry = new $07144aea14354eb9$var$restructure.Struct({
    advance: $07144aea14354eb9$var$restructure.uint16,
    bearing: $07144aea14354eb9$var$restructure.int16
});
var $07144aea14354eb9$var$hmtx = new $07144aea14354eb9$var$restructure.Struct({
    metrics: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$HmtxEntry, function(t) {
        return t.parent.hhea.numberOfMetrics;
    }),
    bearings: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.hhea.numberOfMetrics;
    })
});
var $07144aea14354eb9$var$maxp = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.int32,
    numGlyphs: $07144aea14354eb9$var$restructure.uint16,
    // The number of glyphs in the font
    maxPoints: $07144aea14354eb9$var$restructure.uint16,
    // Maximum points in a non-composite glyph
    maxContours: $07144aea14354eb9$var$restructure.uint16,
    // Maximum contours in a non-composite glyph
    maxComponentPoints: $07144aea14354eb9$var$restructure.uint16,
    // Maximum points in a composite glyph
    maxComponentContours: $07144aea14354eb9$var$restructure.uint16,
    // Maximum contours in a composite glyph
    maxZones: $07144aea14354eb9$var$restructure.uint16,
    // 1 if instructions do not use the twilight zone, 2 otherwise
    maxTwilightPoints: $07144aea14354eb9$var$restructure.uint16,
    // Maximum points used in Z0
    maxStorage: $07144aea14354eb9$var$restructure.uint16,
    // Number of Storage Area locations
    maxFunctionDefs: $07144aea14354eb9$var$restructure.uint16,
    // Number of FDEFs
    maxInstructionDefs: $07144aea14354eb9$var$restructure.uint16,
    // Number of IDEFs
    maxStackElements: $07144aea14354eb9$var$restructure.uint16,
    // Maximum stack depth
    maxSizeOfInstructions: $07144aea14354eb9$var$restructure.uint16,
    // Maximum byte count for glyph instructions
    maxComponentElements: $07144aea14354eb9$var$restructure.uint16,
    // Maximum number of components referenced at “top level” for any composite glyph
    maxComponentDepth: $07144aea14354eb9$var$restructure.uint16 // Maximum levels of recursion; 1 for simple components
});
/**
 * Gets an encoding name from platform, encoding, and language ids.
 * Returned encoding names can be used in iconv-lite to decode text.
 */ function $07144aea14354eb9$var$getEncoding(platformID, encodingID, languageID) {
    if (languageID === void 0) languageID = 0;
    if (platformID === 1 && $07144aea14354eb9$var$MAC_LANGUAGE_ENCODINGS[languageID]) return $07144aea14354eb9$var$MAC_LANGUAGE_ENCODINGS[languageID];
    return $07144aea14354eb9$var$ENCODINGS[platformID][encodingID];
} // Map of platform ids to encoding ids.
var $07144aea14354eb9$var$ENCODINGS = [
    [
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be',
        'utf16be'
    ],
    // Mappings available at http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/
    // 0	Roman                 17	Malayalam
    // 1	Japanese	            18	Sinhalese
    // 2	Traditional Chinese	  19	Burmese
    // 3	Korean	              20	Khmer
    // 4	Arabic	              21	Thai
    // 5	Hebrew	              22	Laotian
    // 6	Greek	                23	Georgian
    // 7	Russian	              24	Armenian
    // 8	RSymbol	              25	Simplified Chinese
    // 9	Devanagari	          26	Tibetan
    // 10	Gurmukhi	            27	Mongolian
    // 11	Gujarati	            28	Geez
    // 12	Oriya	                29	Slavic
    // 13	Bengali	              30	Vietnamese
    // 14	Tamil	                31	Sindhi
    // 15	Telugu	              32	(Uninterpreted)
    // 16	Kannada
    [
        'macroman',
        'shift-jis',
        'big5',
        'euc-kr',
        'iso-8859-6',
        'iso-8859-8',
        'macgreek',
        'maccyrillic',
        'symbol',
        'Devanagari',
        'Gurmukhi',
        'Gujarati',
        'Oriya',
        'Bengali',
        'Tamil',
        'Telugu',
        'Kannada',
        'Malayalam',
        'Sinhalese',
        'Burmese',
        'Khmer',
        'macthai',
        'Laotian',
        'Georgian',
        'Armenian',
        'gb-2312-80',
        'Tibetan',
        'Mongolian',
        'Geez',
        'maccenteuro',
        'Vietnamese',
        'Sindhi'
    ],
    [
        'ascii'
    ],
    // Docs here: http://msdn.microsoft.com/en-us/library/system.text.encoding(v=vs.110).aspx
    [
        'symbol',
        'utf16be',
        'shift-jis',
        'gb18030',
        'big5',
        'wansung',
        'johab',
        null,
        null,
        null,
        'utf16be'
    ]
]; // Overrides for Mac scripts by language id.
// See http://unicode.org/Public/MAPPINGS/VENDORS/APPLE/Readme.txt
var $07144aea14354eb9$var$MAC_LANGUAGE_ENCODINGS = {
    15: 'maciceland',
    17: 'macturkish',
    18: 'maccroatian',
    24: 'maccenteuro',
    25: 'maccenteuro',
    26: 'maccenteuro',
    27: 'maccenteuro',
    28: 'maccenteuro',
    30: 'maciceland',
    37: 'macromania',
    38: 'maccenteuro',
    39: 'maccenteuro',
    40: 'maccenteuro',
    143: 'macinuit',
    // Unsupported by iconv-lite
    146: 'macgaelic' // Unsupported by iconv-lite
}; // Map of platform ids to BCP-47 language codes.
var $07144aea14354eb9$var$LANGUAGES = [
    [],
    {
        // macintosh
        0: 'en',
        30: 'fo',
        60: 'ks',
        90: 'rw',
        1: 'fr',
        31: 'fa',
        61: 'ku',
        91: 'rn',
        2: 'de',
        32: 'ru',
        62: 'sd',
        92: 'ny',
        3: 'it',
        33: 'zh',
        63: 'bo',
        93: 'mg',
        4: 'nl',
        34: 'nl-BE',
        64: 'ne',
        94: 'eo',
        5: 'sv',
        35: 'ga',
        65: 'sa',
        128: 'cy',
        6: 'es',
        36: 'sq',
        66: 'mr',
        129: 'eu',
        7: 'da',
        37: 'ro',
        67: 'bn',
        130: 'ca',
        8: 'pt',
        38: 'cz',
        68: 'as',
        131: 'la',
        9: 'no',
        39: 'sk',
        69: 'gu',
        132: 'qu',
        10: 'he',
        40: 'si',
        70: 'pa',
        133: 'gn',
        11: 'ja',
        41: 'yi',
        71: 'or',
        134: 'ay',
        12: 'ar',
        42: 'sr',
        72: 'ml',
        135: 'tt',
        13: 'fi',
        43: 'mk',
        73: 'kn',
        136: 'ug',
        14: 'el',
        44: 'bg',
        74: 'ta',
        137: 'dz',
        15: 'is',
        45: 'uk',
        75: 'te',
        138: 'jv',
        16: 'mt',
        46: 'be',
        76: 'si',
        139: 'su',
        17: 'tr',
        47: 'uz',
        77: 'my',
        140: 'gl',
        18: 'hr',
        48: 'kk',
        78: 'km',
        141: 'af',
        19: 'zh-Hant',
        49: 'az-Cyrl',
        79: 'lo',
        142: 'br',
        20: 'ur',
        50: 'az-Arab',
        80: 'vi',
        143: 'iu',
        21: 'hi',
        51: 'hy',
        81: 'id',
        144: 'gd',
        22: 'th',
        52: 'ka',
        82: 'tl',
        145: 'gv',
        23: 'ko',
        53: 'mo',
        83: 'ms',
        146: 'ga',
        24: 'lt',
        54: 'ky',
        84: 'ms-Arab',
        147: 'to',
        25: 'pl',
        55: 'tg',
        85: 'am',
        148: 'el-polyton',
        26: 'hu',
        56: 'tk',
        86: 'ti',
        149: 'kl',
        27: 'es',
        57: 'mn-CN',
        87: 'om',
        150: 'az',
        28: 'lv',
        58: 'mn',
        88: 'so',
        151: 'nn',
        29: 'se',
        59: 'ps',
        89: 'sw'
    },
    [],
    {
        // windows                                        
        0x0436: 'af',
        0x4009: 'en-IN',
        0x0487: 'rw',
        0x0432: 'tn',
        0x041C: 'sq',
        0x1809: 'en-IE',
        0x0441: 'sw',
        0x045B: 'si',
        0x0484: 'gsw',
        0x2009: 'en-JM',
        0x0457: 'kok',
        0x041B: 'sk',
        0x045E: 'am',
        0x4409: 'en-MY',
        0x0412: 'ko',
        0x0424: 'sl',
        0x1401: 'ar-DZ',
        0x1409: 'en-NZ',
        0x0440: 'ky',
        0x2C0A: 'es-AR',
        0x3C01: 'ar-BH',
        0x3409: 'en-PH',
        0x0454: 'lo',
        0x400A: 'es-BO',
        0x0C01: 'ar',
        0x4809: 'en-SG',
        0x0426: 'lv',
        0x340A: 'es-CL',
        0x0801: 'ar-IQ',
        0x1C09: 'en-ZA',
        0x0427: 'lt',
        0x240A: 'es-CO',
        0x2C01: 'ar-JO',
        0x2C09: 'en-TT',
        0x082E: 'dsb',
        0x140A: 'es-CR',
        0x3401: 'ar-KW',
        0x0809: 'en-GB',
        0x046E: 'lb',
        0x1C0A: 'es-DO',
        0x3001: 'ar-LB',
        0x0409: 'en',
        0x042F: 'mk',
        0x300A: 'es-EC',
        0x1001: 'ar-LY',
        0x3009: 'en-ZW',
        0x083E: 'ms-BN',
        0x440A: 'es-SV',
        0x1801: 'ary',
        0x0425: 'et',
        0x043E: 'ms',
        0x100A: 'es-GT',
        0x2001: 'ar-OM',
        0x0438: 'fo',
        0x044C: 'ml',
        0x480A: 'es-HN',
        0x4001: 'ar-QA',
        0x0464: 'fil',
        0x043A: 'mt',
        0x080A: 'es-MX',
        0x0401: 'ar-SA',
        0x040B: 'fi',
        0x0481: 'mi',
        0x4C0A: 'es-NI',
        0x2801: 'ar-SY',
        0x080C: 'fr-BE',
        0x047A: 'arn',
        0x180A: 'es-PA',
        0x1C01: 'aeb',
        0x0C0C: 'fr-CA',
        0x044E: 'mr',
        0x3C0A: 'es-PY',
        0x3801: 'ar-AE',
        0x040C: 'fr',
        0x047C: 'moh',
        0x280A: 'es-PE',
        0x2401: 'ar-YE',
        0x140C: 'fr-LU',
        0x0450: 'mn',
        0x500A: 'es-PR',
        0x042B: 'hy',
        0x180C: 'fr-MC',
        0x0850: 'mn-CN',
        0x0C0A: 'es',
        0x044D: 'as',
        0x100C: 'fr-CH',
        0x0461: 'ne',
        0x040A: 'es',
        0x082C: 'az-Cyrl',
        0x0462: 'fy',
        0x0414: 'nb',
        0x540A: 'es-US',
        0x042C: 'az',
        0x0456: 'gl',
        0x0814: 'nn',
        0x380A: 'es-UY',
        0x046D: 'ba',
        0x0437: 'ka',
        0x0482: 'oc',
        0x200A: 'es-VE',
        0x042D: 'eu',
        0x0C07: 'de-AT',
        0x0448: 'or',
        0x081D: 'sv-FI',
        0x0423: 'be',
        0x0407: 'de',
        0x0463: 'ps',
        0x041D: 'sv',
        0x0845: 'bn',
        0x1407: 'de-LI',
        0x0415: 'pl',
        0x045A: 'syr',
        0x0445: 'bn-IN',
        0x1007: 'de-LU',
        0x0416: 'pt',
        0x0428: 'tg',
        0x201A: 'bs-Cyrl',
        0x0807: 'de-CH',
        0x0816: 'pt-PT',
        0x085F: 'tzm',
        0x141A: 'bs',
        0x0408: 'el',
        0x0446: 'pa',
        0x0449: 'ta',
        0x047E: 'br',
        0x046F: 'kl',
        0x046B: 'qu-BO',
        0x0444: 'tt',
        0x0402: 'bg',
        0x0447: 'gu',
        0x086B: 'qu-EC',
        0x044A: 'te',
        0x0403: 'ca',
        0x0468: 'ha',
        0x0C6B: 'qu',
        0x041E: 'th',
        0x0C04: 'zh-HK',
        0x040D: 'he',
        0x0418: 'ro',
        0x0451: 'bo',
        0x1404: 'zh-MO',
        0x0439: 'hi',
        0x0417: 'rm',
        0x041F: 'tr',
        0x0804: 'zh',
        0x040E: 'hu',
        0x0419: 'ru',
        0x0442: 'tk',
        0x1004: 'zh-SG',
        0x040F: 'is',
        0x243B: 'smn',
        0x0480: 'ug',
        0x0404: 'zh-TW',
        0x0470: 'ig',
        0x103B: 'smj-NO',
        0x0422: 'uk',
        0x0483: 'co',
        0x0421: 'id',
        0x143B: 'smj',
        0x042E: 'hsb',
        0x041A: 'hr',
        0x045D: 'iu',
        0x0C3B: 'se-FI',
        0x0420: 'ur',
        0x101A: 'hr-BA',
        0x085D: 'iu-Latn',
        0x043B: 'se',
        0x0843: 'uz-Cyrl',
        0x0405: 'cs',
        0x083C: 'ga',
        0x083B: 'se-SE',
        0x0443: 'uz',
        0x0406: 'da',
        0x0434: 'xh',
        0x203B: 'sms',
        0x042A: 'vi',
        0x048C: 'prs',
        0x0435: 'zu',
        0x183B: 'sma-NO',
        0x0452: 'cy',
        0x0465: 'dv',
        0x0410: 'it',
        0x1C3B: 'sms',
        0x0488: 'wo',
        0x0813: 'nl-BE',
        0x0810: 'it-CH',
        0x044F: 'sa',
        0x0485: 'sah',
        0x0413: 'nl',
        0x0411: 'ja',
        0x1C1A: 'sr-Cyrl-BA',
        0x0478: 'ii',
        0x0C09: 'en-AU',
        0x044B: 'kn',
        0x0C1A: 'sr',
        0x046A: 'yo',
        0x2809: 'en-BZ',
        0x043F: 'kk',
        0x181A: 'sr-Latn-BA',
        0x1009: 'en-CA',
        0x0453: 'km',
        0x081A: 'sr-Latn',
        0x2409: 'en-029',
        0x0486: 'quc',
        0x046C: 'nso'
    }
];
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$NameRecord = new $07144aea14354eb9$var$restructure.Struct({
    platformID: $07144aea14354eb9$var$restructure.uint16,
    encodingID: $07144aea14354eb9$var$restructure.uint16,
    languageID: $07144aea14354eb9$var$restructure.uint16,
    nameID: $07144aea14354eb9$var$restructure.uint16,
    length: $07144aea14354eb9$var$restructure.uint16,
    string: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$restructure.String('length', function(t) {
        return $07144aea14354eb9$var$getEncoding(t.platformID, t.encodingID, t.languageID);
    }), {
        type: 'parent',
        relativeTo: 'parent.stringOffset',
        allowNull: false
    })
});
var $07144aea14354eb9$var$LangTagRecord = new $07144aea14354eb9$var$restructure.Struct({
    length: $07144aea14354eb9$var$restructure.uint16,
    tag: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$restructure.String('length', 'utf16be'), {
        type: 'parent',
        relativeTo: 'stringOffset'
    })
});
var $07144aea14354eb9$var$NameTable = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    0: {
        count: $07144aea14354eb9$var$restructure.uint16,
        stringOffset: $07144aea14354eb9$var$restructure.uint16,
        records: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$NameRecord, 'count')
    },
    1: {
        count: $07144aea14354eb9$var$restructure.uint16,
        stringOffset: $07144aea14354eb9$var$restructure.uint16,
        records: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$NameRecord, 'count'),
        langTagCount: $07144aea14354eb9$var$restructure.uint16,
        langTags: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LangTagRecord, 'langTagCount')
    }
});
var $07144aea14354eb9$var$NAMES = [
    'copyright',
    'fontFamily',
    'fontSubfamily',
    'uniqueSubfamily',
    'fullName',
    'version',
    'postscriptName',
    'trademark',
    'manufacturer',
    'designer',
    'description',
    'vendorURL',
    'designerURL',
    'license',
    'licenseURL',
    null,
    'preferredFamily',
    'preferredSubfamily',
    'compatibleFull',
    'sampleText',
    'postscriptCIDFontName',
    'wwsFamilyName',
    'wwsSubfamilyName'
];
$07144aea14354eb9$var$NameTable.process = function(stream) {
    var records = {};
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose(this.records), _step; !(_step = _iterator()).done;){
        var record = _step.value;
        // find out what language this is for
        var language = $07144aea14354eb9$var$LANGUAGES[record.platformID][record.languageID];
        if (language == null && this.langTags != null && record.languageID >= 0x8000) language = this.langTags[record.languageID - 0x8000].tag;
        if (language == null) language = record.platformID + '-' + record.languageID;
         // if the nameID is >= 256, it is a font feature record (AAT)
        var key = record.nameID >= 256 ? 'fontFeatures' : $07144aea14354eb9$var$NAMES[record.nameID] || record.nameID;
        if (records[key] == null) records[key] = {};
        var obj = records[key];
        if (record.nameID >= 256) obj = obj[record.nameID] || (obj[record.nameID] = {});
        if (typeof record.string === 'string' || typeof obj[language] !== 'string') obj[language] = record.string;
    }
    this.records = records;
};
$07144aea14354eb9$var$NameTable.preEncode = function() {
    if (Array.isArray(this.records)) return;
    this.version = 0;
    var records = [];
    for(var key in this.records){
        var val = this.records[key];
        if (key === 'fontFeatures') continue;
        records.push({
            platformID: 3,
            encodingID: 1,
            languageID: 0x409,
            nameID: $07144aea14354eb9$var$NAMES.indexOf(key),
            length: $07144aea14354eb9$var$buffer_1.byteLength(val.en, 'utf16le'),
            string: val.en
        });
        if (key === 'postscriptName') records.push({
            platformID: 1,
            encodingID: 0,
            languageID: 0,
            nameID: $07144aea14354eb9$var$NAMES.indexOf(key),
            length: val.en.length,
            string: val.en
        });
    }
    this.records = records;
    this.count = records.length;
    this.stringOffset = $07144aea14354eb9$var$NameTable.size(this, null, false);
};
var $07144aea14354eb9$var$OS2 = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    header: {
        xAvgCharWidth: $07144aea14354eb9$var$restructure.int16,
        // average weighted advance width of lower case letters and space
        usWeightClass: $07144aea14354eb9$var$restructure.uint16,
        // visual weight of stroke in glyphs
        usWidthClass: $07144aea14354eb9$var$restructure.uint16,
        // relative change from the normal aspect ratio (width to height ratio)
        fsType: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
            null,
            'noEmbedding',
            'viewOnly',
            'editable',
            null,
            null,
            null,
            null,
            'noSubsetting',
            'bitmapOnly'
        ]),
        ySubscriptXSize: $07144aea14354eb9$var$restructure.int16,
        // recommended horizontal size in pixels for subscripts
        ySubscriptYSize: $07144aea14354eb9$var$restructure.int16,
        // recommended vertical size in pixels for subscripts
        ySubscriptXOffset: $07144aea14354eb9$var$restructure.int16,
        // recommended horizontal offset for subscripts
        ySubscriptYOffset: $07144aea14354eb9$var$restructure.int16,
        // recommended vertical offset form the baseline for subscripts
        ySuperscriptXSize: $07144aea14354eb9$var$restructure.int16,
        // recommended horizontal size in pixels for superscripts
        ySuperscriptYSize: $07144aea14354eb9$var$restructure.int16,
        // recommended vertical size in pixels for superscripts
        ySuperscriptXOffset: $07144aea14354eb9$var$restructure.int16,
        // recommended horizontal offset for superscripts
        ySuperscriptYOffset: $07144aea14354eb9$var$restructure.int16,
        // recommended vertical offset from the baseline for superscripts
        yStrikeoutSize: $07144aea14354eb9$var$restructure.int16,
        // width of the strikeout stroke
        yStrikeoutPosition: $07144aea14354eb9$var$restructure.int16,
        // position of the strikeout stroke relative to the baseline
        sFamilyClass: $07144aea14354eb9$var$restructure.int16,
        // classification of font-family design
        panose: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 10),
        // describe the visual characteristics of a given typeface
        ulCharRange: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 4),
        vendorID: new $07144aea14354eb9$var$restructure.String(4),
        // four character identifier for the font vendor
        fsSelection: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
            'italic',
            'underscore',
            'negative',
            'outlined',
            'strikeout',
            'bold',
            'regular',
            'useTypoMetrics',
            'wws',
            'oblique'
        ]),
        usFirstCharIndex: $07144aea14354eb9$var$restructure.uint16,
        // The minimum Unicode index in this font
        usLastCharIndex: $07144aea14354eb9$var$restructure.uint16 // The maximum Unicode index in this font
    },
    // The Apple version of this table ends here, but the Microsoft one continues on...
    0: {},
    1: {
        typoAscender: $07144aea14354eb9$var$restructure.int16,
        typoDescender: $07144aea14354eb9$var$restructure.int16,
        typoLineGap: $07144aea14354eb9$var$restructure.int16,
        winAscent: $07144aea14354eb9$var$restructure.uint16,
        winDescent: $07144aea14354eb9$var$restructure.uint16,
        codePageRange: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 2)
    },
    2: {
        // these should be common with version 1 somehow
        typoAscender: $07144aea14354eb9$var$restructure.int16,
        typoDescender: $07144aea14354eb9$var$restructure.int16,
        typoLineGap: $07144aea14354eb9$var$restructure.int16,
        winAscent: $07144aea14354eb9$var$restructure.uint16,
        winDescent: $07144aea14354eb9$var$restructure.uint16,
        codePageRange: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 2),
        xHeight: $07144aea14354eb9$var$restructure.int16,
        capHeight: $07144aea14354eb9$var$restructure.int16,
        defaultChar: $07144aea14354eb9$var$restructure.uint16,
        breakChar: $07144aea14354eb9$var$restructure.uint16,
        maxContent: $07144aea14354eb9$var$restructure.uint16
    },
    5: {
        typoAscender: $07144aea14354eb9$var$restructure.int16,
        typoDescender: $07144aea14354eb9$var$restructure.int16,
        typoLineGap: $07144aea14354eb9$var$restructure.int16,
        winAscent: $07144aea14354eb9$var$restructure.uint16,
        winDescent: $07144aea14354eb9$var$restructure.uint16,
        codePageRange: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 2),
        xHeight: $07144aea14354eb9$var$restructure.int16,
        capHeight: $07144aea14354eb9$var$restructure.int16,
        defaultChar: $07144aea14354eb9$var$restructure.uint16,
        breakChar: $07144aea14354eb9$var$restructure.uint16,
        maxContent: $07144aea14354eb9$var$restructure.uint16,
        usLowerOpticalPointSize: $07144aea14354eb9$var$restructure.uint16,
        usUpperOpticalPointSize: $07144aea14354eb9$var$restructure.uint16
    }
});
var $07144aea14354eb9$var$versions$1 = $07144aea14354eb9$var$OS2.versions;
$07144aea14354eb9$var$versions$1[3] = $07144aea14354eb9$var$versions$1[4] = $07144aea14354eb9$var$versions$1[2];
var $07144aea14354eb9$var$post = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.fixed32, {
    header: {
        // these fields exist at the top of all versions
        italicAngle: $07144aea14354eb9$var$restructure.fixed32,
        // Italic angle in counter-clockwise degrees from the vertical.
        underlinePosition: $07144aea14354eb9$var$restructure.int16,
        // Suggested distance of the top of the underline from the baseline
        underlineThickness: $07144aea14354eb9$var$restructure.int16,
        // Suggested values for the underline thickness
        isFixedPitch: $07144aea14354eb9$var$restructure.uint32,
        // Whether the font is monospaced
        minMemType42: $07144aea14354eb9$var$restructure.uint32,
        // Minimum memory usage when a TrueType font is downloaded as a Type 42 font
        maxMemType42: $07144aea14354eb9$var$restructure.uint32,
        // Maximum memory usage when a TrueType font is downloaded as a Type 42 font
        minMemType1: $07144aea14354eb9$var$restructure.uint32,
        // Minimum memory usage when a TrueType font is downloaded as a Type 1 font
        maxMemType1: $07144aea14354eb9$var$restructure.uint32 // Maximum memory usage when a TrueType font is downloaded as a Type 1 font
    },
    1: {},
    // version 1 has no additional fields
    2: {
        numberOfGlyphs: $07144aea14354eb9$var$restructure.uint16,
        glyphNameIndex: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numberOfGlyphs'),
        names: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.String($07144aea14354eb9$var$restructure.uint8))
    },
    2.5: {
        numberOfGlyphs: $07144aea14354eb9$var$restructure.uint16,
        offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 'numberOfGlyphs')
    },
    3: {},
    // version 3 has no additional fields
    4: {
        map: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, function(t) {
            return t.parent.maxp.numGlyphs;
        })
    }
});
var $07144aea14354eb9$var$cvt = new $07144aea14354eb9$var$restructure.Struct({
    controlValues: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int16)
});
// These instructions are known as the font program. The main use of this table
// is for the definition of functions that are used in many different glyph programs.
var $07144aea14354eb9$var$fpgm = new $07144aea14354eb9$var$restructure.Struct({
    instructions: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8)
});
var $07144aea14354eb9$var$loca = new $07144aea14354eb9$var$restructure.VersionedStruct('head.indexToLocFormat', {
    0: {
        offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16)
    },
    1: {
        offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32)
    }
});
$07144aea14354eb9$var$loca.process = function() {
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] <<= 1;
};
$07144aea14354eb9$var$loca.preEncode = function() {
    if (this.version != null) return; // assume this.offsets is a sorted array
    this.version = this.offsets[this.offsets.length - 1] > 0xffff ? 1 : 0;
    if (this.version === 0) for(var i = 0; i < this.offsets.length; i++)this.offsets[i] >>>= 1;
};
var $07144aea14354eb9$var$prep = new $07144aea14354eb9$var$restructure.Struct({
    controlValueProgram: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8)
});
var $07144aea14354eb9$var$glyf = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Buffer());
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$1(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$1(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$1(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$1(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$1(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$1(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$CFFIndex = /*#__PURE__*/ function() {
    function CFFIndex(type) {
        this.type = type;
    }
    var _proto = CFFIndex.prototype;
    _proto.getCFFVersion = function getCFFVersion(ctx) {
        while(ctx && !ctx.hdrSize)ctx = ctx.parent;
        return ctx ? ctx.version : -1;
    };
    _proto.decode = function decode(stream, parent) {
        var version = this.getCFFVersion(parent);
        var count = version >= 2 ? stream.readUInt32BE() : stream.readUInt16BE();
        if (count === 0) return [];
        var offSize = stream.readUInt8();
        var offsetType;
        if (offSize === 1) offsetType = $07144aea14354eb9$var$restructure.uint8;
        else if (offSize === 2) offsetType = $07144aea14354eb9$var$restructure.uint16;
        else if (offSize === 3) offsetType = $07144aea14354eb9$var$restructure.uint24;
        else if (offSize === 4) offsetType = $07144aea14354eb9$var$restructure.uint32;
        else throw new Error("Bad offset size in CFFIndex: " + offSize + " " + stream.pos);
        var ret = [];
        var startPos = stream.pos + (count + 1) * offSize - 1;
        var start = offsetType.decode(stream);
        for(var i = 0; i < count; i++){
            var end = offsetType.decode(stream);
            if (this.type != null) {
                var pos = stream.pos;
                stream.pos = startPos + start;
                parent.length = end - start;
                ret.push(this.type.decode(stream, parent));
                stream.pos = pos;
            } else ret.push({
                offset: startPos + start,
                length: end - start
            });
            start = end;
        }
        stream.pos = startPos + start;
        return ret;
    };
    _proto.size = function size(arr, parent) {
        var size = 2;
        if (arr.length === 0) return size;
        var type = this.type || new $07144aea14354eb9$var$restructure.Buffer(); // find maximum offset to detminine offset type
        var offset = 1;
        for(var i = 0; i < arr.length; i++){
            var item = arr[i];
            offset += type.size(item, parent);
        }
        var offsetType;
        if (offset <= 0xff) offsetType = $07144aea14354eb9$var$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $07144aea14354eb9$var$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $07144aea14354eb9$var$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $07144aea14354eb9$var$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
        size += 1 + offsetType.size() * (arr.length + 1);
        size += offset - 1;
        return size;
    };
    _proto.encode = function encode(stream, arr, parent) {
        stream.writeUInt16BE(arr.length);
        if (arr.length === 0) return;
        var type = this.type || new $07144aea14354eb9$var$restructure.Buffer(); // find maximum offset to detminine offset type
        var sizes = [];
        var offset = 1;
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$1(arr), _step; !(_step = _iterator()).done;){
            var item = _step.value;
            var s = type.size(item, parent);
            sizes.push(s);
            offset += s;
        }
        var offsetType;
        if (offset <= 0xff) offsetType = $07144aea14354eb9$var$restructure.uint8;
        else if (offset <= 0xffff) offsetType = $07144aea14354eb9$var$restructure.uint16;
        else if (offset <= 0xffffff) offsetType = $07144aea14354eb9$var$restructure.uint24;
        else if (offset <= 0xffffffff) offsetType = $07144aea14354eb9$var$restructure.uint32;
        else throw new Error("Bad offset in CFFIndex");
         // write offset size
        stream.writeUInt8(offsetType.size()); // write elements
        offset = 1;
        offsetType.encode(stream, offset);
        for(var _i = 0, _sizes = sizes; _i < _sizes.length; _i++){
            var size = _sizes[_i];
            offset += size;
            offsetType.encode(stream, offset);
        }
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$1(arr), _step2; !(_step2 = _iterator2()).done;){
            var _item = _step2.value;
            type.encode(stream, _item, parent);
        }
        return;
    };
    return CFFIndex;
}();
var $07144aea14354eb9$var$toStr = Object.prototype.toString;
var $07144aea14354eb9$var$isArguments = function isArguments(value) {
    var str = $07144aea14354eb9$var$toStr.call(value);
    var isArgs = str === '[object Arguments]';
    if (!isArgs) isArgs = str !== '[object Array]' && value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $07144aea14354eb9$var$toStr.call(value.callee) === '[object Function]';
    return isArgs;
};
var $07144aea14354eb9$var$keysShim;
if (!Object.keys) {
    // modified from https://github.com/es-shims/es5-shim
    var $07144aea14354eb9$var$has = Object.prototype.hasOwnProperty;
    var $07144aea14354eb9$var$toStr$1 = Object.prototype.toString;
    var $07144aea14354eb9$var$isArgs = $07144aea14354eb9$var$isArguments; // eslint-disable-line global-require
    var $07144aea14354eb9$var$isEnumerable = Object.prototype.propertyIsEnumerable;
    var $07144aea14354eb9$var$hasDontEnumBug = !$07144aea14354eb9$var$isEnumerable.call({
        toString: null
    }, 'toString');
    var $07144aea14354eb9$var$hasProtoEnumBug = $07144aea14354eb9$var$isEnumerable.call(function() {}, 'prototype');
    var $07144aea14354eb9$var$dontEnums = [
        'toString',
        'toLocaleString',
        'valueOf',
        'hasOwnProperty',
        'isPrototypeOf',
        'propertyIsEnumerable',
        'constructor'
    ];
    var $07144aea14354eb9$var$equalsConstructorPrototype = function equalsConstructorPrototype(o) {
        var ctor = o.constructor;
        return ctor && ctor.prototype === o;
    };
    var $07144aea14354eb9$var$excludedKeys = {
        $applicationCache: true,
        $console: true,
        $external: true,
        $frame: true,
        $frameElement: true,
        $frames: true,
        $innerHeight: true,
        $innerWidth: true,
        $onmozfullscreenchange: true,
        $onmozfullscreenerror: true,
        $outerHeight: true,
        $outerWidth: true,
        $pageXOffset: true,
        $pageYOffset: true,
        $parent: true,
        $scrollLeft: true,
        $scrollTop: true,
        $scrollX: true,
        $scrollY: true,
        $self: true,
        $webkitIndexedDB: true,
        $webkitStorageInfo: true,
        $window: true
    };
    var $07144aea14354eb9$var$hasAutomationEqualityBug = function() {
        /* global window */ if (typeof window === 'undefined') return false;
        for(var k in window)try {
            if (!$07144aea14354eb9$var$excludedKeys['$' + k] && $07144aea14354eb9$var$has.call(window, k) && window[k] !== null && typeof window[k] === 'object') try {
                $07144aea14354eb9$var$equalsConstructorPrototype(window[k]);
            } catch (e) {
                return true;
            }
        } catch (e) {
            return true;
        }
        return false;
    }();
    var $07144aea14354eb9$var$equalsConstructorPrototypeIfNotBuggy = function equalsConstructorPrototypeIfNotBuggy(o) {
        /* global window */ if (typeof window === 'undefined' || !$07144aea14354eb9$var$hasAutomationEqualityBug) return $07144aea14354eb9$var$equalsConstructorPrototype(o);
        try {
            return $07144aea14354eb9$var$equalsConstructorPrototype(o);
        } catch (e) {
            return false;
        }
    };
    $07144aea14354eb9$var$keysShim = function keys(object) {
        var isObject = object !== null && typeof object === 'object';
        var isFunction = $07144aea14354eb9$var$toStr$1.call(object) === '[object Function]';
        var isArguments = $07144aea14354eb9$var$isArgs(object);
        var isString = isObject && $07144aea14354eb9$var$toStr$1.call(object) === '[object String]';
        var theKeys = [];
        if (!isObject && !isFunction && !isArguments) throw new TypeError('Object.keys called on a non-object');
        var skipProto = $07144aea14354eb9$var$hasProtoEnumBug && isFunction;
        if (isString && object.length > 0 && !$07144aea14354eb9$var$has.call(object, 0)) for(var i = 0; i < object.length; ++i)theKeys.push(String(i));
        if (isArguments && object.length > 0) for(var j = 0; j < object.length; ++j)theKeys.push(String(j));
        else {
            for(var name in object)if (!(skipProto && name === 'prototype') && $07144aea14354eb9$var$has.call(object, name)) theKeys.push(String(name));
        }
        if ($07144aea14354eb9$var$hasDontEnumBug) {
            var skipConstructor = $07144aea14354eb9$var$equalsConstructorPrototypeIfNotBuggy(object);
            for(var k = 0; k < $07144aea14354eb9$var$dontEnums.length; ++k)if (!(skipConstructor && $07144aea14354eb9$var$dontEnums[k] === 'constructor') && $07144aea14354eb9$var$has.call(object, $07144aea14354eb9$var$dontEnums[k])) theKeys.push($07144aea14354eb9$var$dontEnums[k]);
        }
        return theKeys;
    };
}
var $07144aea14354eb9$var$implementation = $07144aea14354eb9$var$keysShim;
var $07144aea14354eb9$var$slice = Array.prototype.slice;
var $07144aea14354eb9$var$origKeys = Object.keys;
var $07144aea14354eb9$var$keysShim$1 = $07144aea14354eb9$var$origKeys ? function keys(o) {
    return $07144aea14354eb9$var$origKeys(o);
} : $07144aea14354eb9$var$implementation;
var $07144aea14354eb9$var$originalKeys = Object.keys;
$07144aea14354eb9$var$keysShim$1.shim = function shimObjectKeys() {
    if (Object.keys) {
        var keysWorksWithArguments = function() {
            // Safari 5.0 bug
            var args = Object.keys(arguments);
            return args && args.length === arguments.length;
        }(1, 2);
        if (!keysWorksWithArguments) Object.keys = function keys(object) {
            // eslint-disable-line func-name-matching
            if ($07144aea14354eb9$var$isArguments(object)) return $07144aea14354eb9$var$originalKeys($07144aea14354eb9$var$slice.call(object));
            return $07144aea14354eb9$var$originalKeys(object);
        };
    } else Object.keys = $07144aea14354eb9$var$keysShim$1;
    return Object.keys || $07144aea14354eb9$var$keysShim$1;
};
var $07144aea14354eb9$var$objectKeys = $07144aea14354eb9$var$keysShim$1;
var $07144aea14354eb9$var$hasToStringTag = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $07144aea14354eb9$var$toStr$2 = Object.prototype.toString;
var $07144aea14354eb9$var$isStandardArguments = function isArguments(value) {
    if ($07144aea14354eb9$var$hasToStringTag && value && typeof value === 'object' && Symbol.toStringTag in value) return false;
    return $07144aea14354eb9$var$toStr$2.call(value) === '[object Arguments]';
};
var $07144aea14354eb9$var$isLegacyArguments = function isArguments(value) {
    if ($07144aea14354eb9$var$isStandardArguments(value)) return true;
    return value !== null && typeof value === 'object' && typeof value.length === 'number' && value.length >= 0 && $07144aea14354eb9$var$toStr$2.call(value) !== '[object Array]' && $07144aea14354eb9$var$toStr$2.call(value.callee) === '[object Function]';
};
var $07144aea14354eb9$var$supportsStandardArguments = function() {
    return $07144aea14354eb9$var$isStandardArguments(arguments);
}();
$07144aea14354eb9$var$isStandardArguments.isLegacyArguments = $07144aea14354eb9$var$isLegacyArguments; // for tests
var $07144aea14354eb9$var$isArguments$1 = $07144aea14354eb9$var$supportsStandardArguments ? $07144aea14354eb9$var$isStandardArguments : $07144aea14354eb9$var$isLegacyArguments;
var $07144aea14354eb9$var$hasSymbols = typeof Symbol === 'function' && typeof Symbol('foo') === 'symbol';
var $07144aea14354eb9$var$toStr$3 = Object.prototype.toString;
var $07144aea14354eb9$var$concat = Array.prototype.concat;
var $07144aea14354eb9$var$origDefineProperty = Object.defineProperty;
var $07144aea14354eb9$var$isFunction$1 = function isFunction(fn) {
    return typeof fn === 'function' && $07144aea14354eb9$var$toStr$3.call(fn) === '[object Function]';
};
var $07144aea14354eb9$var$arePropertyDescriptorsSupported = function arePropertyDescriptorsSupported() {
    var obj = {};
    try {
        $07144aea14354eb9$var$origDefineProperty(obj, 'x', {
            enumerable: false,
            value: obj
        }); // eslint-disable-next-line no-unused-vars, no-restricted-syntax
        for(var _ in obj)// jscs:ignore disallowUnusedVariables
        return false;
        return obj.x === obj;
    } catch (e) {
        /* this is IE 8. */ return false;
    }
};
var $07144aea14354eb9$var$supportsDescriptors = $07144aea14354eb9$var$origDefineProperty && $07144aea14354eb9$var$arePropertyDescriptorsSupported();
var $07144aea14354eb9$var$defineProperty = function defineProperty(object, name, value, predicate) {
    if (name in object && (!$07144aea14354eb9$var$isFunction$1(predicate) || !predicate())) return;
    if ($07144aea14354eb9$var$supportsDescriptors) $07144aea14354eb9$var$origDefineProperty(object, name, {
        configurable: true,
        enumerable: false,
        value: value,
        writable: true
    });
    else object[name] = value;
};
var $07144aea14354eb9$var$defineProperties = function defineProperties(object, map) {
    var predicates = arguments.length > 2 ? arguments[2] : {};
    var props = $07144aea14354eb9$var$objectKeys(map);
    if ($07144aea14354eb9$var$hasSymbols) props = $07144aea14354eb9$var$concat.call(props, Object.getOwnPropertySymbols(map));
    for(var i = 0; i < props.length; i += 1)$07144aea14354eb9$var$defineProperty(object, props[i], map[props[i]], predicates[props[i]]);
};
$07144aea14354eb9$var$defineProperties.supportsDescriptors = !!$07144aea14354eb9$var$supportsDescriptors;
var $07144aea14354eb9$var$defineProperties_1 = $07144aea14354eb9$var$defineProperties;
/* eslint no-invalid-this: 1 */ var $07144aea14354eb9$var$ERROR_MESSAGE = 'Function.prototype.bind called on incompatible ';
var $07144aea14354eb9$var$slice$1 = Array.prototype.slice;
var $07144aea14354eb9$var$toStr$4 = Object.prototype.toString;
var $07144aea14354eb9$var$funcType = '[object Function]';
var $07144aea14354eb9$var$implementation$1 = function bind(that) {
    var target = this;
    if (typeof target !== 'function' || $07144aea14354eb9$var$toStr$4.call(target) !== $07144aea14354eb9$var$funcType) throw new TypeError($07144aea14354eb9$var$ERROR_MESSAGE + target);
    var args = $07144aea14354eb9$var$slice$1.call(arguments, 1);
    var bound;
    var binder = function binder() {
        if (this instanceof bound) {
            var result = target.apply(this, args.concat($07144aea14354eb9$var$slice$1.call(arguments)));
            if (Object(result) === result) return result;
            return this;
        } else return target.apply(that, args.concat($07144aea14354eb9$var$slice$1.call(arguments)));
    };
    var boundLength = Math.max(0, target.length - args.length);
    var boundArgs = [];
    for(var i = 0; i < boundLength; i++)boundArgs.push('$' + i);
    bound = Function('binder', 'return function (' + boundArgs.join(',') + '){ return binder.apply(this,arguments); }')(binder);
    if (target.prototype) {
        var Empty = function Empty() {};
        Empty.prototype = target.prototype;
        bound.prototype = new Empty();
        Empty.prototype = null;
    }
    return bound;
};
var $07144aea14354eb9$var$functionBind = Function.prototype.bind || $07144aea14354eb9$var$implementation$1;
/* eslint complexity: [2, 18], max-statements: [2, 33] */ var $07144aea14354eb9$var$shams = function hasSymbols() {
    if (typeof Symbol !== 'function' || typeof Object.getOwnPropertySymbols !== 'function') return false;
    if (typeof Symbol.iterator === 'symbol') return true;
    var obj = {};
    var sym = Symbol('test');
    var symObj = Object(sym);
    if (typeof sym === 'string') return false;
    if (Object.prototype.toString.call(sym) !== '[object Symbol]') return false;
    if (Object.prototype.toString.call(symObj) !== '[object Symbol]') return false;
     // temp disabled per https://github.com/ljharb/object.assign/issues/17
    // if (sym instanceof Symbol) { return false; }
    // temp disabled per https://github.com/WebReflection/get-own-property-symbols/issues/4
    // if (!(symObj instanceof Symbol)) { return false; }
    // if (typeof Symbol.prototype.toString !== 'function') { return false; }
    // if (String(sym) !== Symbol.prototype.toString.call(sym)) { return false; }
    var symVal = 42;
    obj[sym] = symVal;
    for(sym in obj)return false;
     // eslint-disable-line no-restricted-syntax
    if (typeof Object.keys === 'function' && Object.keys(obj).length !== 0) return false;
    if (typeof Object.getOwnPropertyNames === 'function' && Object.getOwnPropertyNames(obj).length !== 0) return false;
    var syms = Object.getOwnPropertySymbols(obj);
    if (syms.length !== 1 || syms[0] !== sym) return false;
    if (!Object.prototype.propertyIsEnumerable.call(obj, sym)) return false;
    if (typeof Object.getOwnPropertyDescriptor === 'function') {
        var descriptor = Object.getOwnPropertyDescriptor(obj, sym);
        if (descriptor.value !== symVal || descriptor.enumerable !== true) return false;
    }
    return true;
};
var $07144aea14354eb9$var$origSymbol = $07144aea14354eb9$var$commonjsGlobal.Symbol;
var $07144aea14354eb9$var$hasSymbols$1 = function hasNativeSymbols() {
    if (typeof $07144aea14354eb9$var$origSymbol !== 'function') return false;
    if (typeof Symbol !== 'function') return false;
    if (typeof $07144aea14354eb9$var$origSymbol('foo') !== 'symbol') return false;
    if (typeof Symbol('bar') !== 'symbol') return false;
    return $07144aea14354eb9$var$shams();
};
/* globals
	Atomics,
	SharedArrayBuffer,
*/ var $07144aea14354eb9$var$undefined$1;
var $07144aea14354eb9$var$$TypeError = TypeError;
var $07144aea14354eb9$var$$gOPD = Object.getOwnPropertyDescriptor;
if ($07144aea14354eb9$var$$gOPD) try {
    $07144aea14354eb9$var$$gOPD({}, '');
} catch (e) {
    $07144aea14354eb9$var$$gOPD = null; // this is IE 8, which has a broken gOPD
}
var $07144aea14354eb9$var$throwTypeError = function throwTypeError() {
    throw new $07144aea14354eb9$var$$TypeError();
};
var $07144aea14354eb9$var$ThrowTypeError = $07144aea14354eb9$var$$gOPD ? function() {
    try {
        // eslint-disable-next-line no-unused-expressions, no-caller, no-restricted-properties
        arguments.callee; // IE 8 does not throw here
        return $07144aea14354eb9$var$throwTypeError;
    } catch (calleeThrows) {
        try {
            // IE 8 throws on Object.getOwnPropertyDescriptor(arguments, '')
            return $07144aea14354eb9$var$$gOPD(arguments, 'callee').get;
        } catch (gOPDthrows) {
            return $07144aea14354eb9$var$throwTypeError;
        }
    }
}() : $07144aea14354eb9$var$throwTypeError;
var $07144aea14354eb9$var$hasSymbols$2 = $07144aea14354eb9$var$hasSymbols$1();
var $07144aea14354eb9$var$getProto = Object.getPrototypeOf || function(x) {
    return x.__proto__;
}; // eslint-disable-line no-proto
var $07144aea14354eb9$var$generatorFunction = $07144aea14354eb9$var$undefined$1;
var $07144aea14354eb9$var$asyncFunction = $07144aea14354eb9$var$undefined$1;
var $07144aea14354eb9$var$asyncGenFunction = $07144aea14354eb9$var$undefined$1;
var $07144aea14354eb9$var$TypedArray = typeof Uint8Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : $07144aea14354eb9$var$getProto(Uint8Array);
var $07144aea14354eb9$var$INTRINSICS = {
    '%Array%': Array,
    '%ArrayBuffer%': typeof ArrayBuffer === 'undefined' ? $07144aea14354eb9$var$undefined$1 : ArrayBuffer,
    '%ArrayBufferPrototype%': typeof ArrayBuffer === 'undefined' ? $07144aea14354eb9$var$undefined$1 : ArrayBuffer.prototype,
    '%ArrayIteratorPrototype%': $07144aea14354eb9$var$hasSymbols$2 ? $07144aea14354eb9$var$getProto([][Symbol.iterator]()) : $07144aea14354eb9$var$undefined$1,
    '%ArrayPrototype%': Array.prototype,
    '%ArrayProto_entries%': Array.prototype.entries,
    '%ArrayProto_forEach%': Array.prototype.forEach,
    '%ArrayProto_keys%': Array.prototype.keys,
    '%ArrayProto_values%': Array.prototype.values,
    '%AsyncFromSyncIteratorPrototype%': $07144aea14354eb9$var$undefined$1,
    '%AsyncFunction%': $07144aea14354eb9$var$asyncFunction,
    '%AsyncFunctionPrototype%': $07144aea14354eb9$var$undefined$1,
    '%AsyncGenerator%': $07144aea14354eb9$var$undefined$1,
    '%AsyncGeneratorFunction%': $07144aea14354eb9$var$asyncGenFunction,
    '%AsyncGeneratorPrototype%': $07144aea14354eb9$var$undefined$1,
    '%AsyncIteratorPrototype%': $07144aea14354eb9$var$undefined$1,
    '%Atomics%': typeof Atomics === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Atomics,
    '%Boolean%': Boolean,
    '%BooleanPrototype%': Boolean.prototype,
    '%DataView%': typeof DataView === 'undefined' ? $07144aea14354eb9$var$undefined$1 : DataView,
    '%DataViewPrototype%': typeof DataView === 'undefined' ? $07144aea14354eb9$var$undefined$1 : DataView.prototype,
    '%Date%': Date,
    '%DatePrototype%': Date.prototype,
    '%decodeURI%': decodeURI,
    '%decodeURIComponent%': decodeURIComponent,
    '%encodeURI%': encodeURI,
    '%encodeURIComponent%': encodeURIComponent,
    '%Error%': Error,
    '%ErrorPrototype%': Error.prototype,
    '%eval%': eval,
    // eslint-disable-line no-eval
    '%EvalError%': EvalError,
    '%EvalErrorPrototype%': EvalError.prototype,
    '%Float32Array%': typeof Float32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Float32Array,
    '%Float32ArrayPrototype%': typeof Float32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Float32Array.prototype,
    '%Float64Array%': typeof Float64Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Float64Array,
    '%Float64ArrayPrototype%': typeof Float64Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Float64Array.prototype,
    '%Function%': Function,
    '%FunctionPrototype%': Function.prototype,
    '%Generator%': $07144aea14354eb9$var$undefined$1,
    '%GeneratorFunction%': $07144aea14354eb9$var$generatorFunction,
    '%GeneratorPrototype%': $07144aea14354eb9$var$undefined$1,
    '%Int8Array%': typeof Int8Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int8Array,
    '%Int8ArrayPrototype%': typeof Int8Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int8Array.prototype,
    '%Int16Array%': typeof Int16Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int16Array,
    '%Int16ArrayPrototype%': typeof Int16Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int8Array.prototype,
    '%Int32Array%': typeof Int32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int32Array,
    '%Int32ArrayPrototype%': typeof Int32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Int32Array.prototype,
    '%isFinite%': isFinite,
    '%isNaN%': isNaN,
    '%IteratorPrototype%': $07144aea14354eb9$var$hasSymbols$2 ? $07144aea14354eb9$var$getProto($07144aea14354eb9$var$getProto([][Symbol.iterator]())) : $07144aea14354eb9$var$undefined$1,
    '%JSON%': typeof JSON === 'object' ? JSON : $07144aea14354eb9$var$undefined$1,
    '%JSONParse%': typeof JSON === 'object' ? JSON.parse : $07144aea14354eb9$var$undefined$1,
    '%Map%': typeof Map === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Map,
    '%MapIteratorPrototype%': typeof Map === 'undefined' || !$07144aea14354eb9$var$hasSymbols$2 ? $07144aea14354eb9$var$undefined$1 : $07144aea14354eb9$var$getProto(new Map()[Symbol.iterator]()),
    '%MapPrototype%': typeof Map === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Map.prototype,
    '%Math%': Math,
    '%Number%': Number,
    '%NumberPrototype%': Number.prototype,
    '%Object%': Object,
    '%ObjectPrototype%': Object.prototype,
    '%ObjProto_toString%': Object.prototype.toString,
    '%ObjProto_valueOf%': Object.prototype.valueOf,
    '%parseFloat%': parseFloat,
    '%parseInt%': parseInt,
    '%Promise%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise,
    '%PromisePrototype%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise.prototype,
    '%PromiseProto_then%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise.prototype.then,
    '%Promise_all%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise.all,
    '%Promise_reject%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise.reject,
    '%Promise_resolve%': typeof Promise === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Promise.resolve,
    '%Proxy%': typeof Proxy === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Proxy,
    '%RangeError%': RangeError,
    '%RangeErrorPrototype%': RangeError.prototype,
    '%ReferenceError%': ReferenceError,
    '%ReferenceErrorPrototype%': ReferenceError.prototype,
    '%Reflect%': typeof Reflect === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Reflect,
    '%RegExp%': RegExp,
    '%RegExpPrototype%': RegExp.prototype,
    '%Set%': typeof Set === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Set,
    '%SetIteratorPrototype%': typeof Set === 'undefined' || !$07144aea14354eb9$var$hasSymbols$2 ? $07144aea14354eb9$var$undefined$1 : $07144aea14354eb9$var$getProto(new Set()[Symbol.iterator]()),
    '%SetPrototype%': typeof Set === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Set.prototype,
    '%SharedArrayBuffer%': typeof SharedArrayBuffer === 'undefined' ? $07144aea14354eb9$var$undefined$1 : SharedArrayBuffer,
    '%SharedArrayBufferPrototype%': typeof SharedArrayBuffer === 'undefined' ? $07144aea14354eb9$var$undefined$1 : SharedArrayBuffer.prototype,
    '%String%': String,
    '%StringIteratorPrototype%': $07144aea14354eb9$var$hasSymbols$2 ? $07144aea14354eb9$var$getProto(''[Symbol.iterator]()) : $07144aea14354eb9$var$undefined$1,
    '%StringPrototype%': String.prototype,
    '%Symbol%': $07144aea14354eb9$var$hasSymbols$2 ? Symbol : $07144aea14354eb9$var$undefined$1,
    '%SymbolPrototype%': $07144aea14354eb9$var$hasSymbols$2 ? Symbol.prototype : $07144aea14354eb9$var$undefined$1,
    '%SyntaxError%': SyntaxError,
    '%SyntaxErrorPrototype%': SyntaxError.prototype,
    '%ThrowTypeError%': $07144aea14354eb9$var$ThrowTypeError,
    '%TypedArray%': $07144aea14354eb9$var$TypedArray,
    '%TypedArrayPrototype%': $07144aea14354eb9$var$TypedArray ? $07144aea14354eb9$var$TypedArray.prototype : $07144aea14354eb9$var$undefined$1,
    '%TypeError%': $07144aea14354eb9$var$$TypeError,
    '%TypeErrorPrototype%': $07144aea14354eb9$var$$TypeError.prototype,
    '%Uint8Array%': typeof Uint8Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint8Array,
    '%Uint8ArrayPrototype%': typeof Uint8Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint8Array.prototype,
    '%Uint8ClampedArray%': typeof Uint8ClampedArray === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint8ClampedArray,
    '%Uint8ClampedArrayPrototype%': typeof Uint8ClampedArray === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint8ClampedArray.prototype,
    '%Uint16Array%': typeof Uint16Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint16Array,
    '%Uint16ArrayPrototype%': typeof Uint16Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint16Array.prototype,
    '%Uint32Array%': typeof Uint32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint32Array,
    '%Uint32ArrayPrototype%': typeof Uint32Array === 'undefined' ? $07144aea14354eb9$var$undefined$1 : Uint32Array.prototype,
    '%URIError%': URIError,
    '%URIErrorPrototype%': URIError.prototype,
    '%WeakMap%': typeof WeakMap === 'undefined' ? $07144aea14354eb9$var$undefined$1 : WeakMap,
    '%WeakMapPrototype%': typeof WeakMap === 'undefined' ? $07144aea14354eb9$var$undefined$1 : WeakMap.prototype,
    '%WeakSet%': typeof WeakSet === 'undefined' ? $07144aea14354eb9$var$undefined$1 : WeakSet,
    '%WeakSetPrototype%': typeof WeakSet === 'undefined' ? $07144aea14354eb9$var$undefined$1 : WeakSet.prototype
};
var $07144aea14354eb9$var$$replace = $07144aea14354eb9$var$functionBind.call(Function.call, String.prototype.replace);
/* adapted from https://github.com/lodash/lodash/blob/4.17.15/dist/lodash.js#L6735-L6744 */ var $07144aea14354eb9$var$rePropName = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g;
var $07144aea14354eb9$var$reEscapeChar = /\\(\\)?/g;
/** Used to match backslashes in property paths. */ var $07144aea14354eb9$var$stringToPath = function stringToPath(string) {
    var result = [];
    $07144aea14354eb9$var$$replace(string, $07144aea14354eb9$var$rePropName, function(match, number, quote, subString) {
        result[result.length] = quote ? $07144aea14354eb9$var$$replace(subString, $07144aea14354eb9$var$reEscapeChar, '$1') : number || match;
    });
    return result;
};
/* end adaptation */ var $07144aea14354eb9$var$getBaseIntrinsic = function getBaseIntrinsic(name, allowMissing) {
    if (!(name in $07144aea14354eb9$var$INTRINSICS)) throw new SyntaxError('intrinsic ' + name + ' does not exist!');
     // istanbul ignore if // hopefully this is impossible to test :-)
    if (typeof $07144aea14354eb9$var$INTRINSICS[name] === 'undefined' && !allowMissing) throw new $07144aea14354eb9$var$$TypeError('intrinsic ' + name + ' exists, but is not available. Please file an issue!');
    return $07144aea14354eb9$var$INTRINSICS[name];
};
var $07144aea14354eb9$var$GetIntrinsic = function GetIntrinsic(name, allowMissing) {
    if (typeof name !== 'string' || name.length === 0) throw new TypeError('intrinsic name must be a non-empty string');
    if (arguments.length > 1 && typeof allowMissing !== 'boolean') throw new TypeError('"allowMissing" argument must be a boolean');
    var parts = $07144aea14354eb9$var$stringToPath(name);
    var value = $07144aea14354eb9$var$getBaseIntrinsic('%' + (parts.length > 0 ? parts[0] : '') + '%', allowMissing);
    for(var i = 1; i < parts.length; i += 1)if (value != null) {
        if ($07144aea14354eb9$var$$gOPD && i + 1 >= parts.length) {
            var desc = $07144aea14354eb9$var$$gOPD(value, parts[i]);
            if (!allowMissing && !(parts[i] in value)) throw new $07144aea14354eb9$var$$TypeError('base intrinsic for ' + name + ' exists, but the property is not available.');
            value = desc ? desc.get || desc.value : value[parts[i]];
        } else value = value[parts[i]];
    }
    return value;
};
var $07144aea14354eb9$var$$Function = $07144aea14354eb9$var$GetIntrinsic('%Function%');
var $07144aea14354eb9$var$$apply = $07144aea14354eb9$var$$Function.apply;
var $07144aea14354eb9$var$$call = $07144aea14354eb9$var$$Function.call;
var $07144aea14354eb9$var$callBind = function callBind() {
    return $07144aea14354eb9$var$functionBind.apply($07144aea14354eb9$var$$call, arguments);
};
var $07144aea14354eb9$var$apply = function applyBind() {
    return $07144aea14354eb9$var$functionBind.apply($07144aea14354eb9$var$$apply, arguments);
};
$07144aea14354eb9$var$callBind.apply = $07144aea14354eb9$var$apply;
var $07144aea14354eb9$var$numberIsNaN = function numberIsNaN(value) {
    return value !== value;
};
var $07144aea14354eb9$var$implementation$2 = function is(a, b) {
    if (a === 0 && b === 0) return 1 / a === 1 / b;
    if (a === b) return true;
    if ($07144aea14354eb9$var$numberIsNaN(a) && $07144aea14354eb9$var$numberIsNaN(b)) return true;
    return false;
};
var $07144aea14354eb9$var$polyfill = function getPolyfill() {
    return typeof Object.is === 'function' ? Object.is : $07144aea14354eb9$var$implementation$2;
};
var $07144aea14354eb9$var$shim = function shimObjectIs() {
    var polyfill$1 = $07144aea14354eb9$var$polyfill();
    $07144aea14354eb9$var$defineProperties_1(Object, {
        is: polyfill$1
    }, {
        is: function testObjectIs() {
            return Object.is !== polyfill$1;
        }
    });
    return polyfill$1;
};
var $07144aea14354eb9$var$polyfill$1 = $07144aea14354eb9$var$callBind($07144aea14354eb9$var$polyfill(), Object);
$07144aea14354eb9$var$defineProperties_1($07144aea14354eb9$var$polyfill$1, {
    getPolyfill: $07144aea14354eb9$var$polyfill,
    implementation: $07144aea14354eb9$var$implementation$2,
    shim: $07144aea14354eb9$var$shim
});
var $07144aea14354eb9$var$objectIs = $07144aea14354eb9$var$polyfill$1;
var $07144aea14354eb9$var$src = $07144aea14354eb9$var$functionBind.call(Function.call, Object.prototype.hasOwnProperty);
var $07144aea14354eb9$var$regexExec = RegExp.prototype.exec;
var $07144aea14354eb9$var$gOPD = Object.getOwnPropertyDescriptor;
var $07144aea14354eb9$var$tryRegexExecCall = function tryRegexExec(value) {
    try {
        var lastIndex = value.lastIndex;
        value.lastIndex = 0; // eslint-disable-line no-param-reassign
        $07144aea14354eb9$var$regexExec.call(value);
        return true;
    } catch (e) {
        return false;
    } finally{
        value.lastIndex = lastIndex; // eslint-disable-line no-param-reassign
    }
};
var $07144aea14354eb9$var$toStr$5 = Object.prototype.toString;
var $07144aea14354eb9$var$regexClass = '[object RegExp]';
var $07144aea14354eb9$var$hasToStringTag$1 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $07144aea14354eb9$var$isRegex = function isRegex(value) {
    if (!value || typeof value !== 'object') return false;
    if (!$07144aea14354eb9$var$hasToStringTag$1) return $07144aea14354eb9$var$toStr$5.call(value) === $07144aea14354eb9$var$regexClass;
    var descriptor = $07144aea14354eb9$var$gOPD(value, 'lastIndex');
    var hasLastIndexDataProperty = descriptor && $07144aea14354eb9$var$src(descriptor, 'value');
    if (!hasLastIndexDataProperty) return false;
    return $07144aea14354eb9$var$tryRegexExecCall(value);
};
var $07144aea14354eb9$var$$Object = Object;
var $07144aea14354eb9$var$$TypeError$1 = TypeError;
var $07144aea14354eb9$var$implementation$3 = function flags() {
    if (this != null && this !== $07144aea14354eb9$var$$Object(this)) throw new $07144aea14354eb9$var$$TypeError$1('RegExp.prototype.flags getter called on non-object');
    var result = '';
    if (this.global) result += 'g';
    if (this.ignoreCase) result += 'i';
    if (this.multiline) result += 'm';
    if (this.dotAll) result += 's';
    if (this.unicode) result += 'u';
    if (this.sticky) result += 'y';
    return result;
};
var $07144aea14354eb9$var$supportsDescriptors$1 = $07144aea14354eb9$var$defineProperties_1.supportsDescriptors;
var $07144aea14354eb9$var$$gOPD$1 = Object.getOwnPropertyDescriptor;
var $07144aea14354eb9$var$$TypeError$2 = TypeError;
var $07144aea14354eb9$var$polyfill$2 = function getPolyfill() {
    if (!$07144aea14354eb9$var$supportsDescriptors$1) throw new $07144aea14354eb9$var$$TypeError$2('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    if (/a/mig.flags === 'gim') {
        var descriptor = $07144aea14354eb9$var$$gOPD$1(RegExp.prototype, 'flags');
        if (descriptor && typeof descriptor.get === 'function' && typeof /a/.dotAll === 'boolean') return descriptor.get;
    }
    return $07144aea14354eb9$var$implementation$3;
};
var $07144aea14354eb9$var$supportsDescriptors$2 = $07144aea14354eb9$var$defineProperties_1.supportsDescriptors;
var $07144aea14354eb9$var$gOPD$1 = Object.getOwnPropertyDescriptor;
var $07144aea14354eb9$var$defineProperty$1 = Object.defineProperty;
var $07144aea14354eb9$var$TypeErr = TypeError;
var $07144aea14354eb9$var$getProto$1 = Object.getPrototypeOf;
var $07144aea14354eb9$var$regex = /a/;
var $07144aea14354eb9$var$shim$1 = function shimFlags() {
    if (!$07144aea14354eb9$var$supportsDescriptors$2 || !$07144aea14354eb9$var$getProto$1) throw new $07144aea14354eb9$var$TypeErr('RegExp.prototype.flags requires a true ES5 environment that supports property descriptors');
    var polyfill = $07144aea14354eb9$var$polyfill$2();
    var proto = $07144aea14354eb9$var$getProto$1($07144aea14354eb9$var$regex);
    var descriptor = $07144aea14354eb9$var$gOPD$1(proto, 'flags');
    if (!descriptor || descriptor.get !== polyfill) $07144aea14354eb9$var$defineProperty$1(proto, 'flags', {
        configurable: true,
        enumerable: false,
        get: polyfill
    });
    return polyfill;
};
var $07144aea14354eb9$var$flagsBound = $07144aea14354eb9$var$callBind($07144aea14354eb9$var$implementation$3);
$07144aea14354eb9$var$defineProperties_1($07144aea14354eb9$var$flagsBound, {
    getPolyfill: $07144aea14354eb9$var$polyfill$2,
    implementation: $07144aea14354eb9$var$implementation$3,
    shim: $07144aea14354eb9$var$shim$1
});
var $07144aea14354eb9$var$regexp_prototype_flags = $07144aea14354eb9$var$flagsBound;
var $07144aea14354eb9$var$getDay = Date.prototype.getDay;
var $07144aea14354eb9$var$tryDateObject = function tryDateGetDayCall(value) {
    try {
        $07144aea14354eb9$var$getDay.call(value);
        return true;
    } catch (e) {
        return false;
    }
};
var $07144aea14354eb9$var$toStr$6 = Object.prototype.toString;
var $07144aea14354eb9$var$dateClass = '[object Date]';
var $07144aea14354eb9$var$hasToStringTag$2 = typeof Symbol === 'function' && typeof Symbol.toStringTag === 'symbol';
var $07144aea14354eb9$var$isDateObject = function isDateObject(value) {
    if (typeof value !== 'object' || value === null) return false;
    return $07144aea14354eb9$var$hasToStringTag$2 ? $07144aea14354eb9$var$tryDateObject(value) : $07144aea14354eb9$var$toStr$6.call(value) === $07144aea14354eb9$var$dateClass;
};
var $07144aea14354eb9$var$getTime = Date.prototype.getTime;
function $07144aea14354eb9$var$deepEqual(actual, expected, options) {
    var opts = options || {}; // 7.1. All identical values are equivalent, as determined by ===.
    if (opts.strict ? $07144aea14354eb9$var$objectIs(actual, expected) : actual === expected) return true;
     // 7.3. Other pairs that do not both pass typeof value == 'object', equivalence is determined by ==.
    if (!actual || !expected || typeof actual !== 'object' && typeof expected !== 'object') return opts.strict ? $07144aea14354eb9$var$objectIs(actual, expected) : actual == expected;
    /*
   * 7.4. For all other Object pairs, including Array objects, equivalence is
   * determined by having the same number of owned properties (as verified
   * with Object.prototype.hasOwnProperty.call), the same set of keys
   * (although not necessarily the same order), equivalent values for every
   * corresponding key, and an identical 'prototype' property. Note: this
   * accounts for both named and indexed properties on Arrays.
   */ // eslint-disable-next-line no-use-before-define
    return $07144aea14354eb9$var$objEquiv(actual, expected, opts);
}
function $07144aea14354eb9$var$isUndefinedOrNull(value) {
    return value === null || value === undefined;
}
function $07144aea14354eb9$var$isBuffer$1(x) {
    if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
    if (typeof x.copy !== 'function' || typeof x.slice !== 'function') return false;
    if (x.length > 0 && typeof x[0] !== 'number') return false;
    return true;
}
function $07144aea14354eb9$var$objEquiv(a, b, opts) {
    /* eslint max-statements: [2, 50] */ var i, key;
    if (typeof a !== typeof b) return false;
    if ($07144aea14354eb9$var$isUndefinedOrNull(a) || $07144aea14354eb9$var$isUndefinedOrNull(b)) return false;
     // an identical 'prototype' property.
    if (a.prototype !== b.prototype) return false;
    if ($07144aea14354eb9$var$isArguments$1(a) !== $07144aea14354eb9$var$isArguments$1(b)) return false;
    var aIsRegex = $07144aea14354eb9$var$isRegex(a);
    var bIsRegex = $07144aea14354eb9$var$isRegex(b);
    if (aIsRegex !== bIsRegex) return false;
    if (aIsRegex || bIsRegex) return a.source === b.source && $07144aea14354eb9$var$regexp_prototype_flags(a) === $07144aea14354eb9$var$regexp_prototype_flags(b);
    if ($07144aea14354eb9$var$isDateObject(a) && $07144aea14354eb9$var$isDateObject(b)) return $07144aea14354eb9$var$getTime.call(a) === $07144aea14354eb9$var$getTime.call(b);
    var aIsBuffer = $07144aea14354eb9$var$isBuffer$1(a);
    var bIsBuffer = $07144aea14354eb9$var$isBuffer$1(b);
    if (aIsBuffer !== bIsBuffer) return false;
    if (aIsBuffer || bIsBuffer) {
        // && would work too, because both are true or both false here
        if (a.length !== b.length) return false;
        for(i = 0; i < a.length; i++){
            if (a[i] !== b[i]) return false;
        }
        return true;
    }
    if (typeof a !== typeof b) return false;
    try {
        var ka = $07144aea14354eb9$var$objectKeys(a);
        var kb = $07144aea14354eb9$var$objectKeys(b);
    } catch (e) {
        // happens when one is a string literal and the other isn't
        return false;
    } // having the same number of owned properties (keys incorporates hasOwnProperty)
    if (ka.length !== kb.length) return false;
     // the same set of keys (although not necessarily the same order),
    ka.sort();
    kb.sort(); // ~~~cheap key test
    for(i = ka.length - 1; i >= 0; i--){
        if (ka[i] != kb[i]) return false;
    } // equivalent values for every corresponding key, and ~~~possibly expensive deep test
    for(i = ka.length - 1; i >= 0; i--){
        key = ka[i];
        if (!$07144aea14354eb9$var$deepEqual(a[key], b[key], opts)) return false;
    }
    return true;
}
var $07144aea14354eb9$var$deepEqual_1 = $07144aea14354eb9$var$deepEqual;
var $07144aea14354eb9$var$FLOAT_EOF = 0xf;
var $07144aea14354eb9$var$FLOAT_LOOKUP = [
    '0',
    '1',
    '2',
    '3',
    '4',
    '5',
    '6',
    '7',
    '8',
    '9',
    '.',
    'E',
    'E-',
    null,
    '-'
];
var $07144aea14354eb9$var$FLOAT_ENCODE_LOOKUP = {
    '.': 10,
    'E': 11,
    'E-': 12,
    '-': 14
};
var $07144aea14354eb9$var$CFFOperand = /*#__PURE__*/ function() {
    function CFFOperand() {}
    CFFOperand.decode = function decode(stream, value) {
        if (32 <= value && value <= 246) return value - 139;
        if (247 <= value && value <= 250) return (value - 247) * 256 + stream.readUInt8() + 108;
        if (251 <= value && value <= 254) return -(value - 251) * 256 - stream.readUInt8() - 108;
        if (value === 28) return stream.readInt16BE();
        if (value === 29) return stream.readInt32BE();
        if (value === 30) {
            var str = '';
            while(true){
                var b = stream.readUInt8();
                var n1 = b >> 4;
                if (n1 === $07144aea14354eb9$var$FLOAT_EOF) break;
                str += $07144aea14354eb9$var$FLOAT_LOOKUP[n1];
                var n2 = b & 15;
                if (n2 === $07144aea14354eb9$var$FLOAT_EOF) break;
                str += $07144aea14354eb9$var$FLOAT_LOOKUP[n2];
            }
            return parseFloat(str);
        }
        return null;
    };
    CFFOperand.size = function size(value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, set to 32768
        if (value.forceLarge) value = 32768;
        if ((value | 0) !== value) {
            // floating point
            var str = '' + value;
            return 1 + Math.ceil((str.length + 1) / 2);
        } else if (-107 <= value && value <= 107) return 1;
        else if (108 <= value && value <= 1131 || -1131 <= value && value <= -108) return 2;
        else if (-32768 <= value && value <= 32767) return 3;
        else return 5;
    };
    CFFOperand.encode = function encode(stream, value) {
        // if the value needs to be forced to the largest size (32 bit)
        // e.g. for unknown pointers, save the old value and set to 32768
        var val = Number(value);
        if (value.forceLarge) {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        } else if ((val | 0) !== val) {
            // floating point
            stream.writeUInt8(30);
            var str = '' + val;
            for(var i = 0; i < str.length; i += 2){
                var c1 = str[i];
                var n1 = $07144aea14354eb9$var$FLOAT_ENCODE_LOOKUP[c1] || +c1;
                if (i === str.length - 1) var n2 = $07144aea14354eb9$var$FLOAT_EOF;
                else {
                    var c2 = str[i + 1];
                    var n2 = $07144aea14354eb9$var$FLOAT_ENCODE_LOOKUP[c2] || +c2;
                }
                stream.writeUInt8(n1 << 4 | n2 & 15);
            }
            if (n2 !== $07144aea14354eb9$var$FLOAT_EOF) return stream.writeUInt8($07144aea14354eb9$var$FLOAT_EOF << 4);
        } else if (-107 <= val && val <= 107) return stream.writeUInt8(val + 139);
        else if (108 <= val && val <= 1131) {
            val -= 108;
            stream.writeUInt8((val >> 8) + 247);
            return stream.writeUInt8(val & 0xff);
        } else if (-1131 <= val && val <= -108) {
            val = -val - 108;
            stream.writeUInt8((val >> 8) + 251);
            return stream.writeUInt8(val & 0xff);
        } else if (-32768 <= val && val <= 32767) {
            stream.writeUInt8(28);
            return stream.writeInt16BE(val);
        } else {
            stream.writeUInt8(29);
            return stream.writeInt32BE(val);
        }
    };
    return CFFOperand;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$2(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$2(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$2(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$2(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$2(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$CFFDict = /*#__PURE__*/ function() {
    function CFFDict(ops) {
        if (ops === void 0) ops = [];
        this.ops = ops;
        this.fields = {};
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(ops), _step; !(_step = _iterator()).done;){
            var field = _step.value;
            var key = Array.isArray(field[0]) ? field[0][0] << 8 | field[0][1] : field[0];
            this.fields[key] = field;
        }
    }
    var _proto = CFFDict.prototype;
    _proto.decodeOperands = function decodeOperands(type, stream, ret, operands) {
        var _this = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this.decodeOperands(type[i], stream, ret, [
                op
            ]);
        });
        else if (type.decode != null) return type.decode(stream, ret, operands);
        else switch(type){
            case 'number':
            case 'offset':
            case 'sid':
                return operands[0];
            case 'boolean':
                return !!operands[0];
            default:
                return operands;
        }
    };
    _proto.encodeOperands = function encodeOperands(type, stream, ctx, operands) {
        var _this2 = this;
        if (Array.isArray(type)) return operands.map(function(op, i) {
            return _this2.encodeOperands(type[i], stream, ctx, op)[0];
        });
        else if (type.encode != null) return type.encode(stream, operands, ctx);
        else if (typeof operands === 'number') return [
            operands
        ];
        else if (typeof operands === 'boolean') return [
            +operands
        ];
        else if (Array.isArray(operands)) return operands;
        else return [
            operands
        ];
    };
    _proto.decode = function decode(stream, parent) {
        var end = stream.pos + parent.length;
        var ret = {};
        var operands = []; // define hidden properties
        Object.defineProperties(ret, {
            parent: {
                value: parent
            },
            _startOffset: {
                value: stream.pos
            }
        }); // fill in defaults
        for(var key in this.fields){
            var field = this.fields[key];
            ret[field[1]] = field[3];
        }
        while(stream.pos < end){
            var b = stream.readUInt8();
            if (b < 28) {
                if (b === 12) b = b << 8 | stream.readUInt8();
                var _field = this.fields[b];
                if (!_field) throw new Error("Unknown operator " + b);
                var val = this.decodeOperands(_field[2], stream, ret, operands);
                if (val != null) {
                    if (val instanceof $07144aea14354eb9$var$utils_2) Object.defineProperty(ret, _field[1], val);
                    else ret[_field[1]] = val;
                }
                operands = [];
            } else operands.push($07144aea14354eb9$var$CFFOperand.decode(stream, b));
        }
        return ret;
    };
    _proto.size = function size(dict, parent, includePointers) {
        if (includePointers === void 0) includePointers = true;
        var ctx = {
            parent: parent,
            val: dict,
            pointerSize: 0,
            startOffset: parent.startOffset || 0
        };
        var len = 0;
        for(var k in this.fields){
            var field = this.fields[k];
            var val = dict[field[1]];
            if (val == null || $07144aea14354eb9$var$deepEqual_1(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], null, ctx, val);
            for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(operands), _step2; !(_step2 = _iterator2()).done;){
                var op = _step2.value;
                len += $07144aea14354eb9$var$CFFOperand.size(op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            len += key.length;
        }
        if (includePointers) len += ctx.pointerSize;
        return len;
    };
    _proto.encode = function encode(stream, dict, parent) {
        var ctx = {
            pointers: [],
            startOffset: stream.pos,
            parent: parent,
            val: dict,
            pointerSize: 0
        };
        ctx.pointerOffset = stream.pos + this.size(dict, ctx, false);
        for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(this.ops), _step3; !(_step3 = _iterator3()).done;){
            var field = _step3.value;
            var val = dict[field[1]];
            if (val == null || $07144aea14354eb9$var$deepEqual_1(val, field[3])) continue;
            var operands = this.encodeOperands(field[2], stream, ctx, val);
            for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(operands), _step4; !(_step4 = _iterator4()).done;){
                var op = _step4.value;
                $07144aea14354eb9$var$CFFOperand.encode(stream, op);
            }
            var key = Array.isArray(field[0]) ? field[0] : [
                field[0]
            ];
            for(var _iterator5 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$2(key), _step5; !(_step5 = _iterator5()).done;){
                var _op = _step5.value;
                stream.writeUInt8(_op);
            }
        }
        var i = 0;
        while(i < ctx.pointers.length){
            var ptr = ctx.pointers[i++];
            ptr.type.encode(stream, ptr.val, ptr.parent);
        }
        return;
    };
    return CFFDict;
}();
function $07144aea14354eb9$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$CFFPointer = /*#__PURE__*/ function(_r$Pointer) {
    $07144aea14354eb9$var$_inheritsLoose(CFFPointer, _r$Pointer);
    function CFFPointer(type, options) {
        if (options === void 0) options = {};
        if (options.type == null) options.type = 'global';
        return _r$Pointer.call(this, null, type, options) || this;
    }
    var _proto = CFFPointer.prototype;
    _proto.decode = function decode(stream, parent, operands) {
        this.offsetType = {
            decode: function decode() {
                return operands[0];
            }
        };
        return _r$Pointer.prototype.decode.call(this, stream, parent, operands);
    };
    _proto.encode = function encode(stream, value, ctx) {
        if (!stream) {
            // compute the size (so ctx.pointerSize is correct)
            this.offsetType = {
                size: function size() {
                    return 0;
                }
            };
            this.size(value, ctx);
            return [
                new $07144aea14354eb9$var$Ptr(0)
            ];
        }
        var ptr = null;
        this.offsetType = {
            encode: function encode(stream, val) {
                return ptr = val;
            }
        };
        _r$Pointer.prototype.encode.call(this, stream, value, ctx);
        return [
            new $07144aea14354eb9$var$Ptr(ptr)
        ];
    };
    return CFFPointer;
}($07144aea14354eb9$var$restructure.Pointer);
var $07144aea14354eb9$var$Ptr = /*#__PURE__*/ function() {
    function Ptr(val) {
        this.val = val;
        this.forceLarge = true;
    }
    var _proto2 = Ptr.prototype;
    _proto2.valueOf = function valueOf() {
        return this.val;
    };
    return Ptr;
}();
var $07144aea14354eb9$var$CFFBlendOp = /*#__PURE__*/ function() {
    function CFFBlendOp() {}
    CFFBlendOp.decode = function decode(stream, parent, operands) {
        var numBlends = operands.pop(); // TODO: actually blend. For now just consume the deltas
        // since we don't use any of the values anyway.
        while(operands.length > numBlends)operands.pop();
    };
    return CFFBlendOp;
}();
var $07144aea14354eb9$var$CFFPrivateDict = new $07144aea14354eb9$var$CFFDict([
    [
        6,
        'BlueValues',
        'delta',
        null
    ],
    [
        7,
        'OtherBlues',
        'delta',
        null
    ],
    [
        8,
        'FamilyBlues',
        'delta',
        null
    ],
    [
        9,
        'FamilyOtherBlues',
        'delta',
        null
    ],
    [
        [
            12,
            9
        ],
        'BlueScale',
        'number',
        0.039625
    ],
    [
        [
            12,
            10
        ],
        'BlueShift',
        'number',
        7
    ],
    [
        [
            12,
            11
        ],
        'BlueFuzz',
        'number',
        1
    ],
    [
        10,
        'StdHW',
        'number',
        null
    ],
    [
        11,
        'StdVW',
        'number',
        null
    ],
    [
        [
            12,
            12
        ],
        'StemSnapH',
        'delta',
        null
    ],
    [
        [
            12,
            13
        ],
        'StemSnapV',
        'delta',
        null
    ],
    [
        [
            12,
            14
        ],
        'ForceBold',
        'boolean',
        false
    ],
    [
        [
            12,
            17
        ],
        'LanguageGroup',
        'number',
        0
    ],
    [
        [
            12,
            18
        ],
        'ExpansionFactor',
        'number',
        0.06
    ],
    [
        [
            12,
            19
        ],
        'initialRandomSeed',
        'number',
        0
    ],
    [
        20,
        'defaultWidthX',
        'number',
        0
    ],
    [
        21,
        'nominalWidthX',
        'number',
        0
    ],
    [
        22,
        'vsindex',
        'number',
        0
    ],
    [
        23,
        'blend',
        $07144aea14354eb9$var$CFFBlendOp,
        null
    ],
    [
        19,
        'Subrs',
        new $07144aea14354eb9$var$CFFPointer(new $07144aea14354eb9$var$CFFIndex(), {
            type: 'local'
        }),
        null
    ]
]);
// Automatically generated from Appendix A of the CFF specification; do
// not edit. Length should be 391.
var $07144aea14354eb9$var$standardStrings = [
    ".notdef",
    "space",
    "exclam",
    "quotedbl",
    "numbersign",
    "dollar",
    "percent",
    "ampersand",
    "quoteright",
    "parenleft",
    "parenright",
    "asterisk",
    "plus",
    "comma",
    "hyphen",
    "period",
    "slash",
    "zero",
    "one",
    "two",
    "three",
    "four",
    "five",
    "six",
    "seven",
    "eight",
    "nine",
    "colon",
    "semicolon",
    "less",
    "equal",
    "greater",
    "question",
    "at",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "bracketleft",
    "backslash",
    "bracketright",
    "asciicircum",
    "underscore",
    "quoteleft",
    "a",
    "b",
    "c",
    "d",
    "e",
    "f",
    "g",
    "h",
    "i",
    "j",
    "k",
    "l",
    "m",
    "n",
    "o",
    "p",
    "q",
    "r",
    "s",
    "t",
    "u",
    "v",
    "w",
    "x",
    "y",
    "z",
    "braceleft",
    "bar",
    "braceright",
    "asciitilde",
    "exclamdown",
    "cent",
    "sterling",
    "fraction",
    "yen",
    "florin",
    "section",
    "currency",
    "quotesingle",
    "quotedblleft",
    "guillemotleft",
    "guilsinglleft",
    "guilsinglright",
    "fi",
    "fl",
    "endash",
    "dagger",
    "daggerdbl",
    "periodcentered",
    "paragraph",
    "bullet",
    "quotesinglbase",
    "quotedblbase",
    "quotedblright",
    "guillemotright",
    "ellipsis",
    "perthousand",
    "questiondown",
    "grave",
    "acute",
    "circumflex",
    "tilde",
    "macron",
    "breve",
    "dotaccent",
    "dieresis",
    "ring",
    "cedilla",
    "hungarumlaut",
    "ogonek",
    "caron",
    "emdash",
    "AE",
    "ordfeminine",
    "Lslash",
    "Oslash",
    "OE",
    "ordmasculine",
    "ae",
    "dotlessi",
    "lslash",
    "oslash",
    "oe",
    "germandbls",
    "onesuperior",
    "logicalnot",
    "mu",
    "trademark",
    "Eth",
    "onehalf",
    "plusminus",
    "Thorn",
    "onequarter",
    "divide",
    "brokenbar",
    "degree",
    "thorn",
    "threequarters",
    "twosuperior",
    "registered",
    "minus",
    "eth",
    "multiply",
    "threesuperior",
    "copyright",
    "Aacute",
    "Acircumflex",
    "Adieresis",
    "Agrave",
    "Aring",
    "Atilde",
    "Ccedilla",
    "Eacute",
    "Ecircumflex",
    "Edieresis",
    "Egrave",
    "Iacute",
    "Icircumflex",
    "Idieresis",
    "Igrave",
    "Ntilde",
    "Oacute",
    "Ocircumflex",
    "Odieresis",
    "Ograve",
    "Otilde",
    "Scaron",
    "Uacute",
    "Ucircumflex",
    "Udieresis",
    "Ugrave",
    "Yacute",
    "Ydieresis",
    "Zcaron",
    "aacute",
    "acircumflex",
    "adieresis",
    "agrave",
    "aring",
    "atilde",
    "ccedilla",
    "eacute",
    "ecircumflex",
    "edieresis",
    "egrave",
    "iacute",
    "icircumflex",
    "idieresis",
    "igrave",
    "ntilde",
    "oacute",
    "ocircumflex",
    "odieresis",
    "ograve",
    "otilde",
    "scaron",
    "uacute",
    "ucircumflex",
    "udieresis",
    "ugrave",
    "yacute",
    "ydieresis",
    "zcaron",
    "exclamsmall",
    "Hungarumlautsmall",
    "dollaroldstyle",
    "dollarsuperior",
    "ampersandsmall",
    "Acutesmall",
    "parenleftsuperior",
    "parenrightsuperior",
    "twodotenleader",
    "onedotenleader",
    "zerooldstyle",
    "oneoldstyle",
    "twooldstyle",
    "threeoldstyle",
    "fouroldstyle",
    "fiveoldstyle",
    "sixoldstyle",
    "sevenoldstyle",
    "eightoldstyle",
    "nineoldstyle",
    "commasuperior",
    "threequartersemdash",
    "periodsuperior",
    "questionsmall",
    "asuperior",
    "bsuperior",
    "centsuperior",
    "dsuperior",
    "esuperior",
    "isuperior",
    "lsuperior",
    "msuperior",
    "nsuperior",
    "osuperior",
    "rsuperior",
    "ssuperior",
    "tsuperior",
    "ff",
    "ffi",
    "ffl",
    "parenleftinferior",
    "parenrightinferior",
    "Circumflexsmall",
    "hyphensuperior",
    "Gravesmall",
    "Asmall",
    "Bsmall",
    "Csmall",
    "Dsmall",
    "Esmall",
    "Fsmall",
    "Gsmall",
    "Hsmall",
    "Ismall",
    "Jsmall",
    "Ksmall",
    "Lsmall",
    "Msmall",
    "Nsmall",
    "Osmall",
    "Psmall",
    "Qsmall",
    "Rsmall",
    "Ssmall",
    "Tsmall",
    "Usmall",
    "Vsmall",
    "Wsmall",
    "Xsmall",
    "Ysmall",
    "Zsmall",
    "colonmonetary",
    "onefitted",
    "rupiah",
    "Tildesmall",
    "exclamdownsmall",
    "centoldstyle",
    "Lslashsmall",
    "Scaronsmall",
    "Zcaronsmall",
    "Dieresissmall",
    "Brevesmall",
    "Caronsmall",
    "Dotaccentsmall",
    "Macronsmall",
    "figuredash",
    "hypheninferior",
    "Ogoneksmall",
    "Ringsmall",
    "Cedillasmall",
    "questiondownsmall",
    "oneeighth",
    "threeeighths",
    "fiveeighths",
    "seveneighths",
    "onethird",
    "twothirds",
    "zerosuperior",
    "foursuperior",
    "fivesuperior",
    "sixsuperior",
    "sevensuperior",
    "eightsuperior",
    "ninesuperior",
    "zeroinferior",
    "oneinferior",
    "twoinferior",
    "threeinferior",
    "fourinferior",
    "fiveinferior",
    "sixinferior",
    "seveninferior",
    "eightinferior",
    "nineinferior",
    "centinferior",
    "dollarinferior",
    "periodinferior",
    "commainferior",
    "Agravesmall",
    "Aacutesmall",
    "Acircumflexsmall",
    "Atildesmall",
    "Adieresissmall",
    "Aringsmall",
    "AEsmall",
    "Ccedillasmall",
    "Egravesmall",
    "Eacutesmall",
    "Ecircumflexsmall",
    "Edieresissmall",
    "Igravesmall",
    "Iacutesmall",
    "Icircumflexsmall",
    "Idieresissmall",
    "Ethsmall",
    "Ntildesmall",
    "Ogravesmall",
    "Oacutesmall",
    "Ocircumflexsmall",
    "Otildesmall",
    "Odieresissmall",
    "OEsmall",
    "Oslashsmall",
    "Ugravesmall",
    "Uacutesmall",
    "Ucircumflexsmall",
    "Udieresissmall",
    "Yacutesmall",
    "Thornsmall",
    "Ydieresissmall",
    "001.000",
    "001.001",
    "001.002",
    "001.003",
    "Black",
    "Bold",
    "Book",
    "Light",
    "Medium",
    "Regular",
    "Roman",
    "Semibold"
];
var $07144aea14354eb9$var$StandardEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    '',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    '',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    '',
    'questiondown',
    '',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    '',
    'ring',
    'cedilla',
    '',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'AE',
    '',
    'ordfeminine',
    '',
    '',
    '',
    '',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    '',
    '',
    '',
    '',
    '',
    'ae',
    '',
    '',
    '',
    'dotlessi',
    '',
    '',
    'lslash',
    'oslash',
    'oe',
    'germandbls'
];
var $07144aea14354eb9$var$ExpertEncoding = [
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    '',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    '',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    '',
    '',
    'isuperior',
    '',
    '',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    '',
    '',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    '',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    '',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    '',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    '',
    '',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    '',
    'Dotaccentsmall',
    '',
    '',
    'Macronsmall',
    '',
    '',
    'figuredash',
    'hypheninferior',
    '',
    '',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    '',
    '',
    '',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    '',
    '',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var $07144aea14354eb9$var$ISOAdobeCharset = [
    '.notdef',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quoteright',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'quoteleft',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'exclamdown',
    'cent',
    'sterling',
    'fraction',
    'yen',
    'florin',
    'section',
    'currency',
    'quotesingle',
    'quotedblleft',
    'guillemotleft',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'endash',
    'dagger',
    'daggerdbl',
    'periodcentered',
    'paragraph',
    'bullet',
    'quotesinglbase',
    'quotedblbase',
    'quotedblright',
    'guillemotright',
    'ellipsis',
    'perthousand',
    'questiondown',
    'grave',
    'acute',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'dieresis',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'emdash',
    'AE',
    'ordfeminine',
    'Lslash',
    'Oslash',
    'OE',
    'ordmasculine',
    'ae',
    'dotlessi',
    'lslash',
    'oslash',
    'oe',
    'germandbls',
    'onesuperior',
    'logicalnot',
    'mu',
    'trademark',
    'Eth',
    'onehalf',
    'plusminus',
    'Thorn',
    'onequarter',
    'divide',
    'brokenbar',
    'degree',
    'thorn',
    'threequarters',
    'twosuperior',
    'registered',
    'minus',
    'eth',
    'multiply',
    'threesuperior',
    'copyright',
    'Aacute',
    'Acircumflex',
    'Adieresis',
    'Agrave',
    'Aring',
    'Atilde',
    'Ccedilla',
    'Eacute',
    'Ecircumflex',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Ntilde',
    'Oacute',
    'Ocircumflex',
    'Odieresis',
    'Ograve',
    'Otilde',
    'Scaron',
    'Uacute',
    'Ucircumflex',
    'Udieresis',
    'Ugrave',
    'Yacute',
    'Ydieresis',
    'Zcaron',
    'aacute',
    'acircumflex',
    'adieresis',
    'agrave',
    'aring',
    'atilde',
    'ccedilla',
    'eacute',
    'ecircumflex',
    'edieresis',
    'egrave',
    'iacute',
    'icircumflex',
    'idieresis',
    'igrave',
    'ntilde',
    'oacute',
    'ocircumflex',
    'odieresis',
    'ograve',
    'otilde',
    'scaron',
    'uacute',
    'ucircumflex',
    'udieresis',
    'ugrave',
    'yacute',
    'ydieresis',
    'zcaron'
];
var $07144aea14354eb9$var$ExpertCharset = [
    '.notdef',
    'space',
    'exclamsmall',
    'Hungarumlautsmall',
    'dollaroldstyle',
    'dollarsuperior',
    'ampersandsmall',
    'Acutesmall',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'questionsmall',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'Circumflexsmall',
    'hyphensuperior',
    'Gravesmall',
    'Asmall',
    'Bsmall',
    'Csmall',
    'Dsmall',
    'Esmall',
    'Fsmall',
    'Gsmall',
    'Hsmall',
    'Ismall',
    'Jsmall',
    'Ksmall',
    'Lsmall',
    'Msmall',
    'Nsmall',
    'Osmall',
    'Psmall',
    'Qsmall',
    'Rsmall',
    'Ssmall',
    'Tsmall',
    'Usmall',
    'Vsmall',
    'Wsmall',
    'Xsmall',
    'Ysmall',
    'Zsmall',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'Tildesmall',
    'exclamdownsmall',
    'centoldstyle',
    'Lslashsmall',
    'Scaronsmall',
    'Zcaronsmall',
    'Dieresissmall',
    'Brevesmall',
    'Caronsmall',
    'Dotaccentsmall',
    'Macronsmall',
    'figuredash',
    'hypheninferior',
    'Ogoneksmall',
    'Ringsmall',
    'Cedillasmall',
    'onequarter',
    'onehalf',
    'threequarters',
    'questiondownsmall',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior',
    'Agravesmall',
    'Aacutesmall',
    'Acircumflexsmall',
    'Atildesmall',
    'Adieresissmall',
    'Aringsmall',
    'AEsmall',
    'Ccedillasmall',
    'Egravesmall',
    'Eacutesmall',
    'Ecircumflexsmall',
    'Edieresissmall',
    'Igravesmall',
    'Iacutesmall',
    'Icircumflexsmall',
    'Idieresissmall',
    'Ethsmall',
    'Ntildesmall',
    'Ogravesmall',
    'Oacutesmall',
    'Ocircumflexsmall',
    'Otildesmall',
    'Odieresissmall',
    'OEsmall',
    'Oslashsmall',
    'Ugravesmall',
    'Uacutesmall',
    'Ucircumflexsmall',
    'Udieresissmall',
    'Yacutesmall',
    'Thornsmall',
    'Ydieresissmall'
];
var $07144aea14354eb9$var$ExpertSubsetCharset = [
    '.notdef',
    'space',
    'dollaroldstyle',
    'dollarsuperior',
    'parenleftsuperior',
    'parenrightsuperior',
    'twodotenleader',
    'onedotenleader',
    'comma',
    'hyphen',
    'period',
    'fraction',
    'zerooldstyle',
    'oneoldstyle',
    'twooldstyle',
    'threeoldstyle',
    'fouroldstyle',
    'fiveoldstyle',
    'sixoldstyle',
    'sevenoldstyle',
    'eightoldstyle',
    'nineoldstyle',
    'colon',
    'semicolon',
    'commasuperior',
    'threequartersemdash',
    'periodsuperior',
    'asuperior',
    'bsuperior',
    'centsuperior',
    'dsuperior',
    'esuperior',
    'isuperior',
    'lsuperior',
    'msuperior',
    'nsuperior',
    'osuperior',
    'rsuperior',
    'ssuperior',
    'tsuperior',
    'ff',
    'fi',
    'fl',
    'ffi',
    'ffl',
    'parenleftinferior',
    'parenrightinferior',
    'hyphensuperior',
    'colonmonetary',
    'onefitted',
    'rupiah',
    'centoldstyle',
    'figuredash',
    'hypheninferior',
    'onequarter',
    'onehalf',
    'threequarters',
    'oneeighth',
    'threeeighths',
    'fiveeighths',
    'seveneighths',
    'onethird',
    'twothirds',
    'zerosuperior',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'foursuperior',
    'fivesuperior',
    'sixsuperior',
    'sevensuperior',
    'eightsuperior',
    'ninesuperior',
    'zeroinferior',
    'oneinferior',
    'twoinferior',
    'threeinferior',
    'fourinferior',
    'fiveinferior',
    'sixinferior',
    'seveninferior',
    'eightinferior',
    'nineinferior',
    'centinferior',
    'dollarinferior',
    'periodinferior',
    'commainferior'
];
// Scripts and Languages #
//########################
var $07144aea14354eb9$var$LangSysTable = new $07144aea14354eb9$var$restructure.Struct({
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    reqFeatureIndex: $07144aea14354eb9$var$restructure.uint16,
    featureCount: $07144aea14354eb9$var$restructure.uint16,
    featureIndexes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'featureCount')
});
var $07144aea14354eb9$var$LangSysRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    langSys: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LangSysTable, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$Script = new $07144aea14354eb9$var$restructure.Struct({
    defaultLangSys: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LangSysTable),
    count: $07144aea14354eb9$var$restructure.uint16,
    langSysRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LangSysRecord, 'count')
});
var $07144aea14354eb9$var$ScriptRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    script: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Script, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$ScriptList = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$ScriptRecord, $07144aea14354eb9$var$restructure.uint16); //#######################
// Features and Lookups #
//#######################
var $07144aea14354eb9$var$Feature = new $07144aea14354eb9$var$restructure.Struct({
    featureParams: $07144aea14354eb9$var$restructure.uint16,
    // pointer
    lookupCount: $07144aea14354eb9$var$restructure.uint16,
    lookupListIndexes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'lookupCount')
});
var $07144aea14354eb9$var$FeatureRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    feature: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Feature, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$FeatureList = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatureRecord, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$LookupFlags = new $07144aea14354eb9$var$restructure.Struct({
    markAttachmentType: $07144aea14354eb9$var$restructure.uint8,
    flags: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint8, [
        'rightToLeft',
        'ignoreBaseGlyphs',
        'ignoreLigatures',
        'ignoreMarks',
        'useMarkFilteringSet'
    ])
});
function $07144aea14354eb9$var$LookupList(SubTable) {
    var Lookup = new $07144aea14354eb9$var$restructure.Struct({
        lookupType: $07144aea14354eb9$var$restructure.uint16,
        flags: $07144aea14354eb9$var$LookupFlags,
        subTableCount: $07144aea14354eb9$var$restructure.uint16,
        subTables: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, SubTable), 'subTableCount'),
        markFilteringSet: new $07144aea14354eb9$var$restructure.Optional($07144aea14354eb9$var$restructure.uint16, function(t) {
            return t.flags.flags.useMarkFilteringSet;
        })
    });
    return new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, Lookup), $07144aea14354eb9$var$restructure.uint16);
} //#################
// Coverage Table #
//#################
var $07144aea14354eb9$var$RangeRecord = new $07144aea14354eb9$var$restructure.Struct({
    start: $07144aea14354eb9$var$restructure.uint16,
    end: $07144aea14354eb9$var$restructure.uint16,
    startCoverageIndex: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$Coverage = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        glyphCount: $07144aea14354eb9$var$restructure.uint16,
        glyphs: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'glyphCount')
    },
    2: {
        rangeCount: $07144aea14354eb9$var$restructure.uint16,
        rangeRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$RangeRecord, 'rangeCount')
    }
}); //#########################
// Class Definition Table #
//#########################
var $07144aea14354eb9$var$ClassRangeRecord = new $07144aea14354eb9$var$restructure.Struct({
    start: $07144aea14354eb9$var$restructure.uint16,
    end: $07144aea14354eb9$var$restructure.uint16,
    "class": $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$ClassDef = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Class array
        startGlyph: $07144aea14354eb9$var$restructure.uint16,
        glyphCount: $07144aea14354eb9$var$restructure.uint16,
        classValueArray: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'glyphCount')
    },
    2: {
        // Class ranges
        classRangeCount: $07144aea14354eb9$var$restructure.uint16,
        classRangeRecord: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$ClassRangeRecord, 'classRangeCount')
    }
}); //###############
// Device Table #
//###############
var $07144aea14354eb9$var$Device = new $07144aea14354eb9$var$restructure.Struct({
    a: $07144aea14354eb9$var$restructure.uint16,
    // startSize for hinting Device, outerIndex for VariationIndex
    b: $07144aea14354eb9$var$restructure.uint16,
    // endSize for Device, innerIndex for VariationIndex
    deltaFormat: $07144aea14354eb9$var$restructure.uint16
}); //#############################################
// Contextual Substitution/Positioning Tables #
//#############################################
var $07144aea14354eb9$var$LookupRecord = new $07144aea14354eb9$var$restructure.Struct({
    sequenceIndex: $07144aea14354eb9$var$restructure.uint16,
    lookupListIndex: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$Rule = new $07144aea14354eb9$var$restructure.Struct({
    glyphCount: $07144aea14354eb9$var$restructure.uint16,
    lookupCount: $07144aea14354eb9$var$restructure.uint16,
    input: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LookupRecord, 'lookupCount')
});
var $07144aea14354eb9$var$RuleSet = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Rule), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$ClassRule = new $07144aea14354eb9$var$restructure.Struct({
    glyphCount: $07144aea14354eb9$var$restructure.uint16,
    lookupCount: $07144aea14354eb9$var$restructure.uint16,
    classes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.glyphCount - 1;
    }),
    lookupRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LookupRecord, 'lookupCount')
});
var $07144aea14354eb9$var$ClassSet = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassRule), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$Context = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Simple context
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        ruleSetCount: $07144aea14354eb9$var$restructure.uint16,
        ruleSets: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$RuleSet), 'ruleSetCount')
    },
    2: {
        // Class-based context
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        classDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
        classSetCnt: $07144aea14354eb9$var$restructure.uint16,
        classSet: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassSet), 'classSetCnt')
    },
    3: {
        glyphCount: $07144aea14354eb9$var$restructure.uint16,
        lookupCount: $07144aea14354eb9$var$restructure.uint16,
        coverages: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'glyphCount'),
        lookupRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LookupRecord, 'lookupCount')
    }
}); //######################################################
// Chaining Contextual Substitution/Positioning Tables #
//######################################################
var $07144aea14354eb9$var$ChainRule = new $07144aea14354eb9$var$restructure.Struct({
    backtrackGlyphCount: $07144aea14354eb9$var$restructure.uint16,
    backtrack: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'backtrackGlyphCount'),
    inputGlyphCount: $07144aea14354eb9$var$restructure.uint16,
    input: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.inputGlyphCount - 1;
    }),
    lookaheadGlyphCount: $07144aea14354eb9$var$restructure.uint16,
    lookahead: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'lookaheadGlyphCount'),
    lookupCount: $07144aea14354eb9$var$restructure.uint16,
    lookupRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LookupRecord, 'lookupCount')
});
var $07144aea14354eb9$var$ChainRuleSet = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ChainRule), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$ChainingContext = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Simple context glyph substitution
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        chainCount: $07144aea14354eb9$var$restructure.uint16,
        chainRuleSets: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ChainRuleSet), 'chainCount')
    },
    2: {
        // Class-based chaining context
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        backtrackClassDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
        inputClassDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
        lookaheadClassDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
        chainCount: $07144aea14354eb9$var$restructure.uint16,
        chainClassSet: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ChainRuleSet), 'chainCount')
    },
    3: {
        // Coverage-based chaining context
        backtrackGlyphCount: $07144aea14354eb9$var$restructure.uint16,
        backtrackCoverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'backtrackGlyphCount'),
        inputGlyphCount: $07144aea14354eb9$var$restructure.uint16,
        inputCoverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'inputGlyphCount'),
        lookaheadGlyphCount: $07144aea14354eb9$var$restructure.uint16,
        lookaheadCoverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'lookaheadGlyphCount'),
        lookupCount: $07144aea14354eb9$var$restructure.uint16,
        lookupRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LookupRecord, 'lookupCount')
    }
});
var $07144aea14354eb9$var$_;
/*******************
 * Variation Store *
 *******************/ var $07144aea14354eb9$var$F2DOT14 = new $07144aea14354eb9$var$restructure.Fixed(16, 'BE', 14);
var $07144aea14354eb9$var$RegionAxisCoordinates = new $07144aea14354eb9$var$restructure.Struct({
    startCoord: $07144aea14354eb9$var$F2DOT14,
    peakCoord: $07144aea14354eb9$var$F2DOT14,
    endCoord: $07144aea14354eb9$var$F2DOT14
});
var $07144aea14354eb9$var$VariationRegionList = new $07144aea14354eb9$var$restructure.Struct({
    axisCount: $07144aea14354eb9$var$restructure.uint16,
    regionCount: $07144aea14354eb9$var$restructure.uint16,
    variationRegions: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$RegionAxisCoordinates, 'axisCount'), 'regionCount')
});
var $07144aea14354eb9$var$DeltaSet = new $07144aea14354eb9$var$restructure.Struct({
    shortDeltas: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int16, function(t) {
        return t.parent.shortDeltaCount;
    }),
    regionDeltas: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int8, function(t) {
        return t.parent.regionIndexCount - t.parent.shortDeltaCount;
    }),
    deltas: function deltas(t) {
        return t.shortDeltas.concat(t.regionDeltas);
    }
});
var $07144aea14354eb9$var$ItemVariationData = new $07144aea14354eb9$var$restructure.Struct({
    itemCount: $07144aea14354eb9$var$restructure.uint16,
    shortDeltaCount: $07144aea14354eb9$var$restructure.uint16,
    regionIndexCount: $07144aea14354eb9$var$restructure.uint16,
    regionIndexes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'regionIndexCount'),
    deltaSets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$DeltaSet, 'itemCount')
});
var $07144aea14354eb9$var$ItemVariationStore = new $07144aea14354eb9$var$restructure.Struct({
    format: $07144aea14354eb9$var$restructure.uint16,
    variationRegionList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$VariationRegionList),
    variationDataCount: $07144aea14354eb9$var$restructure.uint16,
    itemVariationData: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ItemVariationData), 'variationDataCount')
});
/**********************
 * Feature Variations *
 **********************/ var $07144aea14354eb9$var$ConditionTable = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: ($07144aea14354eb9$var$_ = {
        axisIndex: $07144aea14354eb9$var$restructure.uint16
    }, $07144aea14354eb9$var$_["axisIndex"] = $07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$_.filterRangeMinValue = $07144aea14354eb9$var$F2DOT14, $07144aea14354eb9$var$_.filterRangeMaxValue = $07144aea14354eb9$var$F2DOT14, $07144aea14354eb9$var$_)
});
var $07144aea14354eb9$var$ConditionSet = new $07144aea14354eb9$var$restructure.Struct({
    conditionCount: $07144aea14354eb9$var$restructure.uint16,
    conditionTable: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ConditionTable), 'conditionCount')
});
var $07144aea14354eb9$var$FeatureTableSubstitutionRecord = new $07144aea14354eb9$var$restructure.Struct({
    featureIndex: $07144aea14354eb9$var$restructure.uint16,
    alternateFeatureTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$Feature, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$FeatureTableSubstitution = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    substitutionCount: $07144aea14354eb9$var$restructure.uint16,
    substitutions: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatureTableSubstitutionRecord, 'substitutionCount')
});
var $07144aea14354eb9$var$FeatureVariationRecord = new $07144aea14354eb9$var$restructure.Struct({
    conditionSet: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ConditionSet, {
        type: 'parent'
    }),
    featureTableSubstitution: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$FeatureTableSubstitution, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$FeatureVariations = new $07144aea14354eb9$var$restructure.Struct({
    majorVersion: $07144aea14354eb9$var$restructure.uint16,
    minorVersion: $07144aea14354eb9$var$restructure.uint16,
    featureVariationRecordCount: $07144aea14354eb9$var$restructure.uint32,
    featureVariationRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatureVariationRecord, 'featureVariationRecordCount')
});
function $07144aea14354eb9$var$_inheritsLoose$1(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
// otherwise delegates to the provided type.
var $07144aea14354eb9$var$PredefinedOp = /*#__PURE__*/ function() {
    function PredefinedOp(predefinedOps, type) {
        this.predefinedOps = predefinedOps;
        this.type = type;
    }
    var _proto = PredefinedOp.prototype;
    _proto.decode = function decode(stream, parent, operands) {
        if (this.predefinedOps[operands[0]]) return this.predefinedOps[operands[0]];
        return this.type.decode(stream, parent, operands);
    };
    _proto.size = function size(value, ctx) {
        return this.type.size(value, ctx);
    };
    _proto.encode = function encode(stream, value, ctx) {
        var index = this.predefinedOps.indexOf(value);
        if (index !== -1) return index;
        return this.type.encode(stream, value, ctx);
    };
    return PredefinedOp;
}();
var $07144aea14354eb9$var$CFFEncodingVersion = /*#__PURE__*/ function(_r$Number) {
    $07144aea14354eb9$var$_inheritsLoose$1(CFFEncodingVersion, _r$Number);
    function CFFEncodingVersion() {
        return _r$Number.call(this, 'UInt8') || this;
    }
    var _proto2 = CFFEncodingVersion.prototype;
    _proto2.decode = function decode(stream) {
        return $07144aea14354eb9$var$restructure.uint8.decode(stream) & 0x7f;
    };
    return CFFEncodingVersion;
}($07144aea14354eb9$var$restructure.Number);
var $07144aea14354eb9$var$Range1 = new $07144aea14354eb9$var$restructure.Struct({
    first: $07144aea14354eb9$var$restructure.uint16,
    nLeft: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$Range2 = new $07144aea14354eb9$var$restructure.Struct({
    first: $07144aea14354eb9$var$restructure.uint16,
    nLeft: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$CFFCustomEncoding = new $07144aea14354eb9$var$restructure.VersionedStruct(new $07144aea14354eb9$var$CFFEncodingVersion(), {
    0: {
        nCodes: $07144aea14354eb9$var$restructure.uint8,
        codes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 'nCodes')
    },
    1: {
        nRanges: $07144aea14354eb9$var$restructure.uint8,
        ranges: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Range1, 'nRanges')
    } // TODO: supplement?
});
var $07144aea14354eb9$var$CFFEncoding = new $07144aea14354eb9$var$PredefinedOp([
    $07144aea14354eb9$var$StandardEncoding,
    $07144aea14354eb9$var$ExpertEncoding
], new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$CFFCustomEncoding, {
    lazy: true
})); // Decodes an array of ranges until the total
// length is equal to the provided length.
var $07144aea14354eb9$var$RangeArray = /*#__PURE__*/ function(_r$Array) {
    $07144aea14354eb9$var$_inheritsLoose$1(RangeArray, _r$Array);
    function RangeArray() {
        return _r$Array.apply(this, arguments) || this;
    }
    var _proto3 = RangeArray.prototype;
    _proto3.decode = function decode(stream, parent) {
        var length = $07144aea14354eb9$var$utils_1(this.length, stream, parent);
        var count = 0;
        var res = [];
        while(count < length){
            var range = this.type.decode(stream, parent);
            range.offset = count;
            count += range.nLeft + 1;
            res.push(range);
        }
        return res;
    };
    return RangeArray;
}($07144aea14354eb9$var$restructure.Array);
var $07144aea14354eb9$var$CFFCustomCharset = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint8, {
    0: {
        glyphs: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    1: {
        ranges: new $07144aea14354eb9$var$RangeArray($07144aea14354eb9$var$Range1, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    },
    2: {
        ranges: new $07144aea14354eb9$var$RangeArray($07144aea14354eb9$var$Range2, function(t) {
            return t.parent.CharStrings.length - 1;
        })
    }
});
var $07144aea14354eb9$var$CFFCharset = new $07144aea14354eb9$var$PredefinedOp([
    $07144aea14354eb9$var$ISOAdobeCharset,
    $07144aea14354eb9$var$ExpertCharset,
    $07144aea14354eb9$var$ExpertSubsetCharset
], new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$CFFCustomCharset, {
    lazy: true
}));
var $07144aea14354eb9$var$FDRange3 = new $07144aea14354eb9$var$restructure.Struct({
    first: $07144aea14354eb9$var$restructure.uint16,
    fd: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$FDRange4 = new $07144aea14354eb9$var$restructure.Struct({
    first: $07144aea14354eb9$var$restructure.uint32,
    fd: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$FDSelect = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint8, {
    0: {
        fds: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, function(t) {
            return t.parent.CharStrings.length;
        })
    },
    3: {
        nRanges: $07144aea14354eb9$var$restructure.uint16,
        ranges: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FDRange3, 'nRanges'),
        sentinel: $07144aea14354eb9$var$restructure.uint16
    },
    4: {
        nRanges: $07144aea14354eb9$var$restructure.uint32,
        ranges: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FDRange4, 'nRanges'),
        sentinel: $07144aea14354eb9$var$restructure.uint32
    }
});
var $07144aea14354eb9$var$ptr = new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$CFFPrivateDict);
var $07144aea14354eb9$var$CFFPrivateOp = /*#__PURE__*/ function() {
    function CFFPrivateOp() {}
    var _proto4 = CFFPrivateOp.prototype;
    _proto4.decode = function decode(stream, parent, operands) {
        parent.length = operands[0];
        return $07144aea14354eb9$var$ptr.decode(stream, parent, [
            operands[1]
        ]);
    };
    _proto4.size = function size(dict, ctx) {
        return [
            $07144aea14354eb9$var$CFFPrivateDict.size(dict, ctx, false),
            $07144aea14354eb9$var$ptr.size(dict, ctx)[0]
        ];
    };
    _proto4.encode = function encode(stream, dict, ctx) {
        return [
            $07144aea14354eb9$var$CFFPrivateDict.size(dict, ctx, false),
            $07144aea14354eb9$var$ptr.encode(stream, dict, ctx)[0]
        ];
    };
    return CFFPrivateOp;
}();
var $07144aea14354eb9$var$FontDict = new $07144aea14354eb9$var$CFFDict([
    [
        18,
        'Private',
        new $07144aea14354eb9$var$CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var $07144aea14354eb9$var$CFFTopDict = new $07144aea14354eb9$var$CFFDict([
    [
        [
            12,
            30
        ],
        'ROS',
        [
            'sid',
            'sid',
            'number'
        ],
        null
    ],
    [
        0,
        'version',
        'sid',
        null
    ],
    [
        1,
        'Notice',
        'sid',
        null
    ],
    [
        [
            12,
            0
        ],
        'Copyright',
        'sid',
        null
    ],
    [
        2,
        'FullName',
        'sid',
        null
    ],
    [
        3,
        'FamilyName',
        'sid',
        null
    ],
    [
        4,
        'Weight',
        'sid',
        null
    ],
    [
        [
            12,
            1
        ],
        'isFixedPitch',
        'boolean',
        false
    ],
    [
        [
            12,
            2
        ],
        'ItalicAngle',
        'number',
        0
    ],
    [
        [
            12,
            3
        ],
        'UnderlinePosition',
        'number',
        -100
    ],
    [
        [
            12,
            4
        ],
        'UnderlineThickness',
        'number',
        50
    ],
    [
        [
            12,
            5
        ],
        'PaintType',
        'number',
        0
    ],
    [
        [
            12,
            6
        ],
        'CharstringType',
        'number',
        2
    ],
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        13,
        'UniqueID',
        'number',
        null
    ],
    [
        5,
        'FontBBox',
        'array',
        [
            0,
            0,
            0,
            0
        ]
    ],
    [
        [
            12,
            8
        ],
        'StrokeWidth',
        'number',
        0
    ],
    [
        14,
        'XUID',
        'array',
        null
    ],
    [
        15,
        'charset',
        $07144aea14354eb9$var$CFFCharset,
        $07144aea14354eb9$var$ISOAdobeCharset
    ],
    [
        16,
        'Encoding',
        $07144aea14354eb9$var$CFFEncoding,
        $07144aea14354eb9$var$StandardEncoding
    ],
    [
        17,
        'CharStrings',
        new $07144aea14354eb9$var$CFFPointer(new $07144aea14354eb9$var$CFFIndex()),
        null
    ],
    [
        18,
        'Private',
        new $07144aea14354eb9$var$CFFPrivateOp(),
        null
    ],
    [
        [
            12,
            20
        ],
        'SyntheticBase',
        'number',
        null
    ],
    [
        [
            12,
            21
        ],
        'PostScript',
        'sid',
        null
    ],
    [
        [
            12,
            22
        ],
        'BaseFontName',
        'sid',
        null
    ],
    [
        [
            12,
            23
        ],
        'BaseFontBlend',
        'delta',
        null
    ],
    [
        [
            12,
            31
        ],
        'CIDFontVersion',
        'number',
        0
    ],
    [
        [
            12,
            32
        ],
        'CIDFontRevision',
        'number',
        0
    ],
    [
        [
            12,
            33
        ],
        'CIDFontType',
        'number',
        0
    ],
    [
        [
            12,
            34
        ],
        'CIDCount',
        'number',
        8720
    ],
    [
        [
            12,
            35
        ],
        'UIDBase',
        'number',
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $07144aea14354eb9$var$CFFPointer(new $07144aea14354eb9$var$CFFIndex($07144aea14354eb9$var$FontDict)),
        null
    ],
    [
        [
            12,
            38
        ],
        'FontName',
        'sid',
        null
    ]
]);
var $07144aea14354eb9$var$VariationStore = new $07144aea14354eb9$var$restructure.Struct({
    length: $07144aea14354eb9$var$restructure.uint16,
    itemVariationStore: $07144aea14354eb9$var$ItemVariationStore
});
var $07144aea14354eb9$var$CFF2TopDict = new $07144aea14354eb9$var$CFFDict([
    [
        [
            12,
            7
        ],
        'FontMatrix',
        'array',
        [
            0.001,
            0,
            0,
            0.001,
            0,
            0
        ]
    ],
    [
        17,
        'CharStrings',
        new $07144aea14354eb9$var$CFFPointer(new $07144aea14354eb9$var$CFFIndex()),
        null
    ],
    [
        [
            12,
            37
        ],
        'FDSelect',
        new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$FDSelect),
        null
    ],
    [
        [
            12,
            36
        ],
        'FDArray',
        new $07144aea14354eb9$var$CFFPointer(new $07144aea14354eb9$var$CFFIndex($07144aea14354eb9$var$FontDict)),
        null
    ],
    [
        24,
        'vstore',
        new $07144aea14354eb9$var$CFFPointer($07144aea14354eb9$var$VariationStore),
        null
    ],
    [
        25,
        'maxstack',
        'number',
        193
    ]
]);
var $07144aea14354eb9$var$CFFTop = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.fixed16, {
    1: {
        hdrSize: $07144aea14354eb9$var$restructure.uint8,
        offSize: $07144aea14354eb9$var$restructure.uint8,
        nameIndex: new $07144aea14354eb9$var$CFFIndex(new $07144aea14354eb9$var$restructure.String('length')),
        topDictIndex: new $07144aea14354eb9$var$CFFIndex($07144aea14354eb9$var$CFFTopDict),
        stringIndex: new $07144aea14354eb9$var$CFFIndex(new $07144aea14354eb9$var$restructure.String('length')),
        globalSubrIndex: new $07144aea14354eb9$var$CFFIndex()
    },
    2: {
        hdrSize: $07144aea14354eb9$var$restructure.uint8,
        length: $07144aea14354eb9$var$restructure.uint16,
        topDict: $07144aea14354eb9$var$CFF2TopDict,
        globalSubrIndex: new $07144aea14354eb9$var$CFFIndex()
    }
});
function $07144aea14354eb9$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$CFFFont = /*#__PURE__*/ function() {
    function CFFFont(stream) {
        this.stream = stream;
        this.decode();
    }
    CFFFont.decode = function decode(stream) {
        return new CFFFont(stream);
    };
    var _proto = CFFFont.prototype;
    _proto.decode = function decode() {
        var start = this.stream.pos;
        var top = $07144aea14354eb9$var$CFFTop.decode(this.stream);
        for(var key in top){
            var val = top[key];
            this[key] = val;
        }
        if (this.version < 2) {
            if (this.topDictIndex.length !== 1) throw new Error("Only a single font is allowed in CFF");
            this.topDict = this.topDictIndex[0];
        }
        this.isCIDFont = this.topDict.ROS != null;
        return this;
    };
    _proto.string = function string(sid) {
        if (this.version >= 2) return null;
        if (sid < $07144aea14354eb9$var$standardStrings.length) return $07144aea14354eb9$var$standardStrings[sid];
        return this.stringIndex[sid - $07144aea14354eb9$var$standardStrings.length];
    };
    _proto.getCharString = function getCharString(glyph) {
        this.stream.pos = this.topDict.CharStrings[glyph].offset;
        return this.stream.readBuffer(this.topDict.CharStrings[glyph].length);
    };
    _proto.getGlyphName = function getGlyphName(gid) {
        // CFF2 glyph names are in the post table.
        if (this.version >= 2) return null;
         // CID-keyed fonts don't have glyph names
        if (this.isCIDFont) return null;
        var charset = this.topDict.charset;
        if (Array.isArray(charset)) return charset[gid];
        if (gid === 0) return '.notdef';
        gid -= 1;
        switch(charset.version){
            case 0:
                return this.string(charset.glyphs[gid]);
            case 1:
            case 2:
                for(var i = 0; i < charset.ranges.length; i++){
                    var range = charset.ranges[i];
                    if (range.offset <= gid && gid <= range.offset + range.nLeft) return this.string(range.first + (gid - range.offset));
                }
                break;
        }
        return null;
    };
    _proto.fdForGlyph = function fdForGlyph(gid) {
        if (!this.topDict.FDSelect) return null;
        switch(this.topDict.FDSelect.version){
            case 0:
                return this.topDict.FDSelect.fds[gid];
            case 3:
            case 4:
                var ranges = this.topDict.FDSelect.ranges;
                var low = 0;
                var high = ranges.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    if (gid < ranges[mid].first) high = mid - 1;
                    else if (mid < high && gid > ranges[mid + 1].first) low = mid + 1;
                    else return ranges[mid].fd;
                }
            default:
                throw new Error("Unknown FDSelect version: " + this.topDict.FDSelect.version);
        }
    };
    _proto.privateDictForGlyph = function privateDictForGlyph(gid) {
        if (this.topDict.FDSelect) {
            var fd = this.fdForGlyph(gid);
            if (this.topDict.FDArray[fd]) return this.topDict.FDArray[fd].Private;
            return null;
        }
        if (this.version < 2) return this.topDict.Private;
        return this.topDict.FDArray[0].Private;
    };
    $07144aea14354eb9$var$_createClass(CFFFont, [
        {
            key: "postscriptName",
            get: function get() {
                if (this.version < 2) return this.nameIndex[0];
                return null;
            }
        },
        {
            key: "fullName",
            get: function get() {
                return this.string(this.topDict.FullName);
            }
        },
        {
            key: "familyName",
            get: function get() {
                return this.string(this.topDict.FamilyName);
            }
        }
    ]);
    return CFFFont;
}();
var $07144aea14354eb9$var$VerticalOrigin = new $07144aea14354eb9$var$restructure.Struct({
    glyphIndex: $07144aea14354eb9$var$restructure.uint16,
    vertOriginY: $07144aea14354eb9$var$restructure.int16
});
var $07144aea14354eb9$var$VORG = new $07144aea14354eb9$var$restructure.Struct({
    majorVersion: $07144aea14354eb9$var$restructure.uint16,
    minorVersion: $07144aea14354eb9$var$restructure.uint16,
    defaultVertOriginY: $07144aea14354eb9$var$restructure.int16,
    numVertOriginYMetrics: $07144aea14354eb9$var$restructure.uint16,
    metrics: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$VerticalOrigin, 'numVertOriginYMetrics')
});
var $07144aea14354eb9$var$BigMetrics = new $07144aea14354eb9$var$restructure.Struct({
    height: $07144aea14354eb9$var$restructure.uint8,
    width: $07144aea14354eb9$var$restructure.uint8,
    horiBearingX: $07144aea14354eb9$var$restructure.int8,
    horiBearingY: $07144aea14354eb9$var$restructure.int8,
    horiAdvance: $07144aea14354eb9$var$restructure.uint8,
    vertBearingX: $07144aea14354eb9$var$restructure.int8,
    vertBearingY: $07144aea14354eb9$var$restructure.int8,
    vertAdvance: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$SmallMetrics = new $07144aea14354eb9$var$restructure.Struct({
    height: $07144aea14354eb9$var$restructure.uint8,
    width: $07144aea14354eb9$var$restructure.uint8,
    bearingX: $07144aea14354eb9$var$restructure.int8,
    bearingY: $07144aea14354eb9$var$restructure.int8,
    advance: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$EBDTComponent = new $07144aea14354eb9$var$restructure.Struct({
    glyph: $07144aea14354eb9$var$restructure.uint16,
    xOffset: $07144aea14354eb9$var$restructure.int8,
    yOffset: $07144aea14354eb9$var$restructure.int8
});
var $07144aea14354eb9$var$ByteAligned = function ByteAligned() {};
var $07144aea14354eb9$var$BitAligned = function BitAligned() {};
var $07144aea14354eb9$var$glyph = new $07144aea14354eb9$var$restructure.VersionedStruct('version', {
    1: {
        metrics: $07144aea14354eb9$var$SmallMetrics,
        data: $07144aea14354eb9$var$ByteAligned
    },
    2: {
        metrics: $07144aea14354eb9$var$SmallMetrics,
        data: $07144aea14354eb9$var$BitAligned
    },
    // format 3 is deprecated
    // format 4 is not supported by Microsoft
    5: {
        data: $07144aea14354eb9$var$BitAligned
    },
    6: {
        metrics: $07144aea14354eb9$var$BigMetrics,
        data: $07144aea14354eb9$var$ByteAligned
    },
    7: {
        metrics: $07144aea14354eb9$var$BigMetrics,
        data: $07144aea14354eb9$var$BitAligned
    },
    8: {
        metrics: $07144aea14354eb9$var$SmallMetrics,
        pad: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8),
        numComponents: $07144aea14354eb9$var$restructure.uint16,
        components: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$EBDTComponent, 'numComponents')
    },
    9: {
        metrics: $07144aea14354eb9$var$BigMetrics,
        pad: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8),
        numComponents: $07144aea14354eb9$var$restructure.uint16,
        components: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$EBDTComponent, 'numComponents')
    },
    17: {
        metrics: $07144aea14354eb9$var$SmallMetrics,
        dataLen: $07144aea14354eb9$var$restructure.uint32,
        data: new $07144aea14354eb9$var$restructure.Buffer('dataLen')
    },
    18: {
        metrics: $07144aea14354eb9$var$BigMetrics,
        dataLen: $07144aea14354eb9$var$restructure.uint32,
        data: new $07144aea14354eb9$var$restructure.Buffer('dataLen')
    },
    19: {
        dataLen: $07144aea14354eb9$var$restructure.uint32,
        data: new $07144aea14354eb9$var$restructure.Buffer('dataLen')
    }
});
var $07144aea14354eb9$var$SBitLineMetrics = new $07144aea14354eb9$var$restructure.Struct({
    ascender: $07144aea14354eb9$var$restructure.int8,
    descender: $07144aea14354eb9$var$restructure.int8,
    widthMax: $07144aea14354eb9$var$restructure.uint8,
    caretSlopeNumerator: $07144aea14354eb9$var$restructure.int8,
    caretSlopeDenominator: $07144aea14354eb9$var$restructure.int8,
    caretOffset: $07144aea14354eb9$var$restructure.int8,
    minOriginSB: $07144aea14354eb9$var$restructure.int8,
    minAdvanceSB: $07144aea14354eb9$var$restructure.int8,
    maxBeforeBL: $07144aea14354eb9$var$restructure.int8,
    minAfterBL: $07144aea14354eb9$var$restructure.int8,
    pad: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.int8, 2)
});
var $07144aea14354eb9$var$CodeOffsetPair = new $07144aea14354eb9$var$restructure.Struct({
    glyphCode: $07144aea14354eb9$var$restructure.uint16,
    offset: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$IndexSubtable = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    header: {
        imageFormat: $07144aea14354eb9$var$restructure.uint16,
        imageDataOffset: $07144aea14354eb9$var$restructure.uint32
    },
    1: {
        offsetArray: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    2: {
        imageSize: $07144aea14354eb9$var$restructure.uint32,
        bigMetrics: $07144aea14354eb9$var$BigMetrics
    },
    3: {
        offsetArray: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
            return t.parent.lastGlyphIndex - t.parent.firstGlyphIndex + 1;
        })
    },
    4: {
        numGlyphs: $07144aea14354eb9$var$restructure.uint32,
        glyphArray: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$CodeOffsetPair, function(t) {
            return t.numGlyphs + 1;
        })
    },
    5: {
        imageSize: $07144aea14354eb9$var$restructure.uint32,
        bigMetrics: $07144aea14354eb9$var$BigMetrics,
        numGlyphs: $07144aea14354eb9$var$restructure.uint32,
        glyphCodeArray: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numGlyphs')
    }
});
var $07144aea14354eb9$var$IndexSubtableArray = new $07144aea14354eb9$var$restructure.Struct({
    firstGlyphIndex: $07144aea14354eb9$var$restructure.uint16,
    lastGlyphIndex: $07144aea14354eb9$var$restructure.uint16,
    subtable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$IndexSubtable)
});
var $07144aea14354eb9$var$BitmapSizeTable = new $07144aea14354eb9$var$restructure.Struct({
    indexSubTableArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$IndexSubtableArray, 1), {
        type: 'parent'
    }),
    indexTablesSize: $07144aea14354eb9$var$restructure.uint32,
    numberOfIndexSubTables: $07144aea14354eb9$var$restructure.uint32,
    colorRef: $07144aea14354eb9$var$restructure.uint32,
    hori: $07144aea14354eb9$var$SBitLineMetrics,
    vert: $07144aea14354eb9$var$SBitLineMetrics,
    startGlyphIndex: $07144aea14354eb9$var$restructure.uint16,
    endGlyphIndex: $07144aea14354eb9$var$restructure.uint16,
    ppemX: $07144aea14354eb9$var$restructure.uint8,
    ppemY: $07144aea14354eb9$var$restructure.uint8,
    bitDepth: $07144aea14354eb9$var$restructure.uint8,
    flags: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint8, [
        'horizontal',
        'vertical'
    ])
});
var $07144aea14354eb9$var$EBLC = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint32,
    // 0x00020000
    numSizes: $07144aea14354eb9$var$restructure.uint32,
    sizes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$BitmapSizeTable, 'numSizes')
});
var $07144aea14354eb9$var$ImageTable = new $07144aea14354eb9$var$restructure.Struct({
    ppem: $07144aea14354eb9$var$restructure.uint16,
    resolution: $07144aea14354eb9$var$restructure.uint16,
    imageOffsets: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, 'void'), function(t) {
        return t.parent.parent.maxp.numGlyphs + 1;
    })
}); // This is the Apple sbix table, used by the "Apple Color Emoji" font.
// It includes several image tables with images for each bitmap glyph
// of several different sizes.
var $07144aea14354eb9$var$sbix = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    flags: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
        'renderOutlines'
    ]),
    numImgTables: $07144aea14354eb9$var$restructure.uint32,
    imageTables: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ImageTable), 'numImgTables')
});
var $07144aea14354eb9$var$LayerRecord = new $07144aea14354eb9$var$restructure.Struct({
    gid: $07144aea14354eb9$var$restructure.uint16,
    // Glyph ID of layer glyph (must be in z-order from bottom to top).
    paletteIndex: $07144aea14354eb9$var$restructure.uint16 // Index value to use in the appropriate palette. This value must
}); // be less than numPaletteEntries in the CPAL table, except for
// the special case noted below. Each palette entry is 16 bits.
// A palette index of 0xFFFF is a special case indicating that
// the text foreground color should be used.
var $07144aea14354eb9$var$BaseGlyphRecord = new $07144aea14354eb9$var$restructure.Struct({
    gid: $07144aea14354eb9$var$restructure.uint16,
    // Glyph ID of reference glyph. This glyph is for reference only
    // and is not rendered for color.
    firstLayerIndex: $07144aea14354eb9$var$restructure.uint16,
    // Index (from beginning of the Layer Records) to the layer record.
    // There will be numLayers consecutive entries for this base glyph.
    numLayers: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$COLR = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    numBaseGlyphRecords: $07144aea14354eb9$var$restructure.uint16,
    baseGlyphRecord: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$BaseGlyphRecord, 'numBaseGlyphRecords')),
    layerRecords: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$LayerRecord, 'numLayerRecords'), {
        lazy: true
    }),
    numLayerRecords: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$ColorRecord = new $07144aea14354eb9$var$restructure.Struct({
    blue: $07144aea14354eb9$var$restructure.uint8,
    green: $07144aea14354eb9$var$restructure.uint8,
    red: $07144aea14354eb9$var$restructure.uint8,
    alpha: $07144aea14354eb9$var$restructure.uint8
});
var $07144aea14354eb9$var$CPAL = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    header: {
        numPaletteEntries: $07144aea14354eb9$var$restructure.uint16,
        numPalettes: $07144aea14354eb9$var$restructure.uint16,
        numColorRecords: $07144aea14354eb9$var$restructure.uint16,
        colorRecords: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$ColorRecord, 'numColorRecords')),
        colorRecordIndices: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numPalettes')
    },
    0: {},
    1: {
        offsetPaletteTypeArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 'numPalettes')),
        offsetPaletteLabelArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numPalettes')),
        offsetPaletteEntryLabelArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numPaletteEntries'))
    }
});
var $07144aea14354eb9$var$BaseCoord = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Design units only
        coordinate: $07144aea14354eb9$var$restructure.int16 // X or Y value, in design units
    },
    2: {
        // Design units plus contour point
        coordinate: $07144aea14354eb9$var$restructure.int16,
        // X or Y value, in design units
        referenceGlyph: $07144aea14354eb9$var$restructure.uint16,
        // GlyphID of control glyph
        baseCoordPoint: $07144aea14354eb9$var$restructure.uint16 // Index of contour point on the referenceGlyph
    },
    3: {
        // Design units plus Device table
        coordinate: $07144aea14354eb9$var$restructure.int16,
        // X or Y value, in design units
        deviceTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device) // Device table for X or Y value
    }
});
var $07144aea14354eb9$var$BaseValues = new $07144aea14354eb9$var$restructure.Struct({
    defaultIndex: $07144aea14354eb9$var$restructure.uint16,
    // Index of default baseline for this script-same index in the BaseTagList
    baseCoordCount: $07144aea14354eb9$var$restructure.uint16,
    baseCoords: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseCoord), 'baseCoordCount')
});
var $07144aea14354eb9$var$FeatMinMaxRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    // 4-byte feature identification tag-must match FeatureTag in FeatureList
    minCoord: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseCoord, {
        type: 'parent'
    }),
    // May be NULL
    maxCoord: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseCoord, {
        type: 'parent'
    }) // May be NULL
});
var $07144aea14354eb9$var$MinMax = new $07144aea14354eb9$var$restructure.Struct({
    minCoord: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseCoord),
    // May be NULL
    maxCoord: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseCoord),
    // May be NULL
    featMinMaxCount: $07144aea14354eb9$var$restructure.uint16,
    // May be 0
    featMinMaxRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatMinMaxRecord, 'featMinMaxCount') // In alphabetical order
});
var $07144aea14354eb9$var$BaseLangSysRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    // 4-byte language system identification tag
    minMax: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MinMax, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$BaseScript = new $07144aea14354eb9$var$restructure.Struct({
    baseValues: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseValues),
    // May be NULL
    defaultMinMax: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MinMax),
    // May be NULL
    baseLangSysCount: $07144aea14354eb9$var$restructure.uint16,
    // May be 0
    baseLangSysRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$BaseLangSysRecord, 'baseLangSysCount') // in alphabetical order by BaseLangSysTag
});
var $07144aea14354eb9$var$BaseScriptRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    // 4-byte script identification tag
    script: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseScript, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$BaseScriptList = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$BaseScriptRecord, $07144aea14354eb9$var$restructure.uint16); // Array of 4-byte baseline identification tags-must be in alphabetical order
var $07144aea14354eb9$var$BaseTagList = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.String(4), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$Axis = new $07144aea14354eb9$var$restructure.Struct({
    baseTagList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseTagList),
    // May be NULL
    baseScriptList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseScriptList)
});
var $07144aea14354eb9$var$BASE = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint32, {
    header: {
        horizAxis: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Axis),
        // May be NULL
        vertAxis: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Axis) // May be NULL
    },
    0x00010000: {},
    0x00010001: {
        itemVariationStore: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ItemVariationStore)
    }
});
var $07144aea14354eb9$var$AttachPoint = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$AttachList = new $07144aea14354eb9$var$restructure.Struct({
    coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
    glyphCount: $07144aea14354eb9$var$restructure.uint16,
    attachPoints: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$AttachPoint), 'glyphCount')
});
var $07144aea14354eb9$var$CaretValue = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Design units only
        coordinate: $07144aea14354eb9$var$restructure.int16
    },
    2: {
        // Contour point
        caretValuePoint: $07144aea14354eb9$var$restructure.uint16
    },
    3: {
        // Design units plus Device table
        coordinate: $07144aea14354eb9$var$restructure.int16,
        deviceTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device)
    }
});
var $07144aea14354eb9$var$LigGlyph = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$CaretValue), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$LigCaretList = new $07144aea14354eb9$var$restructure.Struct({
    coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
    ligGlyphCount: $07144aea14354eb9$var$restructure.uint16,
    ligGlyphs: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LigGlyph), 'ligGlyphCount')
});
var $07144aea14354eb9$var$MarkGlyphSetsDef = new $07144aea14354eb9$var$restructure.Struct({
    markSetTableFormat: $07144aea14354eb9$var$restructure.uint16,
    markSetCount: $07144aea14354eb9$var$restructure.uint16,
    coverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$Coverage), 'markSetCount')
});
var $07144aea14354eb9$var$GDEF = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint32, {
    header: {
        glyphClassDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
        attachList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$AttachList),
        ligCaretList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LigCaretList),
        markAttachClassDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef)
    },
    0x00010000: {},
    0x00010002: {
        markGlyphSetsDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MarkGlyphSetsDef)
    },
    0x00010003: {
        markGlyphSetsDef: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MarkGlyphSetsDef),
        itemVariationStore: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ItemVariationStore)
    }
});
var $07144aea14354eb9$var$ValueFormat = new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
    'xPlacement',
    'yPlacement',
    'xAdvance',
    'yAdvance',
    'xPlaDevice',
    'yPlaDevice',
    'xAdvDevice',
    'yAdvDevice'
]);
var $07144aea14354eb9$var$types = {
    xPlacement: $07144aea14354eb9$var$restructure.int16,
    yPlacement: $07144aea14354eb9$var$restructure.int16,
    xAdvance: $07144aea14354eb9$var$restructure.int16,
    yAdvance: $07144aea14354eb9$var$restructure.int16,
    xPlaDevice: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yPlaDevice: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    xAdvDevice: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    }),
    yAdvDevice: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device, {
        type: 'global',
        relativeTo: 'rel'
    })
};
var $07144aea14354eb9$var$ValueRecord = /*#__PURE__*/ function() {
    function ValueRecord(key) {
        if (key === void 0) key = 'valueFormat';
        this.key = key;
    }
    var _proto = ValueRecord.prototype;
    _proto.buildStruct = function buildStruct(parent) {
        var struct = parent;
        while(!struct[this.key] && struct.parent)struct = struct.parent;
        if (!struct[this.key]) return;
        var fields = {};
        fields.rel = function() {
            return struct._startOffset;
        };
        var format = struct[this.key];
        for(var key in format)if (format[key]) fields[key] = $07144aea14354eb9$var$types[key];
        return new $07144aea14354eb9$var$restructure.Struct(fields);
    };
    _proto.size = function size(val, ctx) {
        return this.buildStruct(ctx).size(val, ctx);
    };
    _proto.decode = function decode(stream, parent) {
        var res = this.buildStruct(parent).decode(stream, parent);
        delete res.rel;
        return res;
    };
    return ValueRecord;
}();
var $07144aea14354eb9$var$PairValueRecord = new $07144aea14354eb9$var$restructure.Struct({
    secondGlyph: $07144aea14354eb9$var$restructure.uint16,
    value1: new $07144aea14354eb9$var$ValueRecord('valueFormat1'),
    value2: new $07144aea14354eb9$var$ValueRecord('valueFormat2')
});
var $07144aea14354eb9$var$PairSet = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$PairValueRecord, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$Class2Record = new $07144aea14354eb9$var$restructure.Struct({
    value1: new $07144aea14354eb9$var$ValueRecord('valueFormat1'),
    value2: new $07144aea14354eb9$var$ValueRecord('valueFormat2')
});
var $07144aea14354eb9$var$Anchor = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    1: {
        // Design units only
        xCoordinate: $07144aea14354eb9$var$restructure.int16,
        yCoordinate: $07144aea14354eb9$var$restructure.int16
    },
    2: {
        // Design units plus contour point
        xCoordinate: $07144aea14354eb9$var$restructure.int16,
        yCoordinate: $07144aea14354eb9$var$restructure.int16,
        anchorPoint: $07144aea14354eb9$var$restructure.uint16
    },
    3: {
        // Design units plus Device tables
        xCoordinate: $07144aea14354eb9$var$restructure.int16,
        yCoordinate: $07144aea14354eb9$var$restructure.int16,
        xDeviceTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device),
        yDeviceTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Device)
    }
});
var $07144aea14354eb9$var$EntryExitRecord = new $07144aea14354eb9$var$restructure.Struct({
    entryAnchor: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Anchor, {
        type: 'parent'
    }),
    exitAnchor: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Anchor, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$MarkRecord = new $07144aea14354eb9$var$restructure.Struct({
    "class": $07144aea14354eb9$var$restructure.uint16,
    markAnchor: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Anchor, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$MarkArray = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$MarkRecord, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$BaseRecord = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Anchor), function(t) {
    return t.parent.classCount;
});
var $07144aea14354eb9$var$BaseArray = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$BaseRecord, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$ComponentRecord = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Anchor), function(t) {
    return t.parent.parent.classCount;
});
var $07144aea14354eb9$var$LigatureAttach = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$ComponentRecord, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$LigatureArray = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LigatureAttach), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$GPOSLookup = new $07144aea14354eb9$var$restructure.VersionedStruct('lookupType', {
    1: new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
        // Single Adjustment
        1: {
            // Single positioning value
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            valueFormat: $07144aea14354eb9$var$ValueFormat,
            value: new $07144aea14354eb9$var$ValueRecord()
        },
        2: {
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            valueFormat: $07144aea14354eb9$var$ValueFormat,
            valueCount: $07144aea14354eb9$var$restructure.uint16,
            values: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$ValueRecord(), 'valueCount')
        }
    }),
    2: new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
        // Pair Adjustment Positioning
        1: {
            // Adjustments for glyph pairs
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            valueFormat1: $07144aea14354eb9$var$ValueFormat,
            valueFormat2: $07144aea14354eb9$var$ValueFormat,
            pairSetCount: $07144aea14354eb9$var$restructure.uint16,
            pairSets: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$PairSet), 'pairSetCount')
        },
        2: {
            // Class pair adjustment
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            valueFormat1: $07144aea14354eb9$var$ValueFormat,
            valueFormat2: $07144aea14354eb9$var$ValueFormat,
            classDef1: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
            classDef2: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassDef),
            class1Count: $07144aea14354eb9$var$restructure.uint16,
            class2Count: $07144aea14354eb9$var$restructure.uint16,
            classRecords: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$Class2Record, 'class2Count'), 'class1Count')
        }
    }),
    3: {
        // Cursive Attachment Positioning
        format: $07144aea14354eb9$var$restructure.uint16,
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        entryExitCount: $07144aea14354eb9$var$restructure.uint16,
        entryExitRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$EntryExitRecord, 'entryExitCount')
    },
    4: {
        // MarkToBase Attachment Positioning
        format: $07144aea14354eb9$var$restructure.uint16,
        markCoverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        baseCoverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        classCount: $07144aea14354eb9$var$restructure.uint16,
        markArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MarkArray),
        baseArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseArray)
    },
    5: {
        // MarkToLigature Attachment Positioning
        format: $07144aea14354eb9$var$restructure.uint16,
        markCoverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        ligatureCoverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        classCount: $07144aea14354eb9$var$restructure.uint16,
        markArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MarkArray),
        ligatureArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LigatureArray)
    },
    6: {
        // MarkToMark Attachment Positioning
        format: $07144aea14354eb9$var$restructure.uint16,
        mark1Coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        mark2Coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        classCount: $07144aea14354eb9$var$restructure.uint16,
        mark1Array: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$MarkArray),
        mark2Array: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$BaseArray)
    },
    7: $07144aea14354eb9$var$Context,
    // Contextual positioning
    8: $07144aea14354eb9$var$ChainingContext,
    // Chaining contextual positioning
    9: {
        // Extension Positioning
        posFormat: $07144aea14354eb9$var$restructure.uint16,
        lookupType: $07144aea14354eb9$var$restructure.uint16,
        // cannot also be 9
        extension: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$GPOSLookup)
    }
}); // Fix circular reference
$07144aea14354eb9$var$GPOSLookup.versions[9].extension.type = $07144aea14354eb9$var$GPOSLookup;
var $07144aea14354eb9$var$GPOS = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint32, {
    header: {
        scriptList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ScriptList),
        featureList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$FeatureList),
        lookupList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$LookupList($07144aea14354eb9$var$GPOSLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$FeatureVariations)
    }
}); // export GPOSLookup for JSTF table
var $07144aea14354eb9$var$Sequence = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$AlternateSet = $07144aea14354eb9$var$Sequence;
var $07144aea14354eb9$var$Ligature = new $07144aea14354eb9$var$restructure.Struct({
    glyph: $07144aea14354eb9$var$restructure.uint16,
    compCount: $07144aea14354eb9$var$restructure.uint16,
    components: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.compCount - 1;
    })
});
var $07144aea14354eb9$var$LigatureSet = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Ligature), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$GSUBLookup = new $07144aea14354eb9$var$restructure.VersionedStruct('lookupType', {
    1: new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
        // Single Substitution
        1: {
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            deltaGlyphID: $07144aea14354eb9$var$restructure.int16
        },
        2: {
            coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
            glyphCount: $07144aea14354eb9$var$restructure.uint16,
            substitute: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.uint16, 'glyphCount')
        }
    }),
    2: {
        // Multiple Substitution
        substFormat: $07144aea14354eb9$var$restructure.uint16,
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        count: $07144aea14354eb9$var$restructure.uint16,
        sequences: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Sequence), 'count')
    },
    3: {
        // Alternate Substitution
        substFormat: $07144aea14354eb9$var$restructure.uint16,
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        count: $07144aea14354eb9$var$restructure.uint16,
        alternateSet: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$AlternateSet), 'count')
    },
    4: {
        // Ligature Substitution
        substFormat: $07144aea14354eb9$var$restructure.uint16,
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        count: $07144aea14354eb9$var$restructure.uint16,
        ligatureSets: new $07144aea14354eb9$var$restructure.LazyArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$LigatureSet), 'count')
    },
    5: $07144aea14354eb9$var$Context,
    // Contextual Substitution
    6: $07144aea14354eb9$var$ChainingContext,
    // Chaining Contextual Substitution
    7: {
        // Extension Substitution
        substFormat: $07144aea14354eb9$var$restructure.uint16,
        lookupType: $07144aea14354eb9$var$restructure.uint16,
        // cannot also be 7
        extension: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$GSUBLookup)
    },
    8: {
        // Reverse Chaining Contextual Single Substitution
        substFormat: $07144aea14354eb9$var$restructure.uint16,
        coverage: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage),
        backtrackCoverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'backtrackGlyphCount'),
        lookaheadGlyphCount: $07144aea14354eb9$var$restructure.uint16,
        lookaheadCoverage: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Coverage), 'lookaheadGlyphCount'),
        glyphCount: $07144aea14354eb9$var$restructure.uint16,
        substitutes: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'glyphCount')
    }
}); // Fix circular reference
$07144aea14354eb9$var$GSUBLookup.versions[7].extension.type = $07144aea14354eb9$var$GSUBLookup;
var $07144aea14354eb9$var$GSUB = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint32, {
    header: {
        scriptList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ScriptList),
        featureList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$FeatureList),
        lookupList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$LookupList($07144aea14354eb9$var$GSUBLookup))
    },
    0x00010000: {},
    0x00010001: {
        featureVariations: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$FeatureVariations)
    }
});
var $07144aea14354eb9$var$JstfGSUBModList = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$JstfPriority = new $07144aea14354eb9$var$restructure.Struct({
    shrinkageEnableGSUB: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    shrinkageDisableGSUB: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    shrinkageEnableGPOS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    shrinkageDisableGPOS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    shrinkageJstfMax: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$LookupList($07144aea14354eb9$var$GPOSLookup)),
    extensionEnableGSUB: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    extensionDisableGSUB: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    extensionEnableGPOS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    extensionDisableGPOS: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfGSUBModList),
    extensionJstfMax: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$LookupList($07144aea14354eb9$var$GPOSLookup))
});
var $07144aea14354eb9$var$JstfLangSys = new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfPriority), $07144aea14354eb9$var$restructure.uint16);
var $07144aea14354eb9$var$JstfLangSysRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    jstfLangSys: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfLangSys)
});
var $07144aea14354eb9$var$JstfScript = new $07144aea14354eb9$var$restructure.Struct({
    extenderGlyphs: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$restructure.uint16)),
    // array of glyphs to extend line length
    defaultLangSys: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfLangSys),
    langSysCount: $07144aea14354eb9$var$restructure.uint16,
    langSysRecords: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$JstfLangSysRecord, 'langSysCount')
});
var $07144aea14354eb9$var$JstfScriptRecord = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    script: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JstfScript, {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$JSTF = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint32,
    // should be 0x00010000
    scriptCount: $07144aea14354eb9$var$restructure.uint16,
    scriptList: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$JstfScriptRecord, 'scriptCount')
});
var $07144aea14354eb9$var$VariableSizeNumber = /*#__PURE__*/ function() {
    function VariableSizeNumber(size) {
        this._size = size;
    }
    var _proto = VariableSizeNumber.prototype;
    _proto.decode = function decode(stream, parent) {
        switch(this.size(0, parent)){
            case 1:
                return stream.readUInt8();
            case 2:
                return stream.readUInt16BE();
            case 3:
                return stream.readUInt24BE();
            case 4:
                return stream.readUInt32BE();
        }
    };
    _proto.size = function size(val, parent) {
        return $07144aea14354eb9$var$utils_1(this._size, null, parent);
    };
    return VariableSizeNumber;
}();
var $07144aea14354eb9$var$MapDataEntry = new $07144aea14354eb9$var$restructure.Struct({
    entry: new $07144aea14354eb9$var$VariableSizeNumber(function(t) {
        return ((t.parent.entryFormat & 0x0030) >> 4) + 1;
    }),
    outerIndex: function outerIndex(t) {
        return t.entry >> (t.parent.entryFormat & 0x000F) + 1;
    },
    innerIndex: function innerIndex(t) {
        return t.entry & (1 << (t.parent.entryFormat & 0x000F) + 1) - 1;
    }
});
var $07144aea14354eb9$var$DeltaSetIndexMap = new $07144aea14354eb9$var$restructure.Struct({
    entryFormat: $07144aea14354eb9$var$restructure.uint16,
    mapCount: $07144aea14354eb9$var$restructure.uint16,
    mapData: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$MapDataEntry, 'mapCount')
});
var $07144aea14354eb9$var$HVAR = new $07144aea14354eb9$var$restructure.Struct({
    majorVersion: $07144aea14354eb9$var$restructure.uint16,
    minorVersion: $07144aea14354eb9$var$restructure.uint16,
    itemVariationStore: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$ItemVariationStore),
    advanceWidthMapping: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$DeltaSetIndexMap),
    LSBMapping: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$DeltaSetIndexMap),
    RSBMapping: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$DeltaSetIndexMap)
});
var $07144aea14354eb9$var$Signature = new $07144aea14354eb9$var$restructure.Struct({
    format: $07144aea14354eb9$var$restructure.uint32,
    length: $07144aea14354eb9$var$restructure.uint32,
    offset: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$SignatureBlock = new $07144aea14354eb9$var$restructure.Struct({
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16, 2),
    cbSignature: $07144aea14354eb9$var$restructure.uint32,
    // Length (in bytes) of the PKCS#7 packet in pbSignature
    signature: new $07144aea14354eb9$var$restructure.Buffer('cbSignature')
});
var $07144aea14354eb9$var$DSIG = new $07144aea14354eb9$var$restructure.Struct({
    ulVersion: $07144aea14354eb9$var$restructure.uint32,
    // Version number of the DSIG table (0x00000001)
    usNumSigs: $07144aea14354eb9$var$restructure.uint16,
    // Number of signatures in the table
    usFlag: $07144aea14354eb9$var$restructure.uint16,
    // Permission flags
    signatures: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Signature, 'usNumSigs'),
    signatureBlocks: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$SignatureBlock, 'usNumSigs')
});
var $07144aea14354eb9$var$GaspRange = new $07144aea14354eb9$var$restructure.Struct({
    rangeMaxPPEM: $07144aea14354eb9$var$restructure.uint16,
    // Upper limit of range, in ppem
    rangeGaspBehavior: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint16, [
        'grayscale',
        'gridfit',
        'symmetricSmoothing',
        'symmetricGridfit' // only in version 1, for ClearType
    ])
});
var $07144aea14354eb9$var$gasp = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    // set to 0
    numRanges: $07144aea14354eb9$var$restructure.uint16,
    gaspRanges: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$GaspRange, 'numRanges') // Sorted by ppem
});
var $07144aea14354eb9$var$DeviceRecord = new $07144aea14354eb9$var$restructure.Struct({
    pixelSize: $07144aea14354eb9$var$restructure.uint8,
    maximumWidth: $07144aea14354eb9$var$restructure.uint8,
    widths: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, function(t) {
        return t.parent.parent.maxp.numGlyphs;
    })
}); // The Horizontal Device Metrics table stores integer advance widths scaled to particular pixel sizes
var $07144aea14354eb9$var$hdmx = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    numRecords: $07144aea14354eb9$var$restructure.int16,
    sizeDeviceRecord: $07144aea14354eb9$var$restructure.int32,
    records: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$DeviceRecord, 'numRecords')
});
var $07144aea14354eb9$var$KernPair = new $07144aea14354eb9$var$restructure.Struct({
    left: $07144aea14354eb9$var$restructure.uint16,
    right: $07144aea14354eb9$var$restructure.uint16,
    value: $07144aea14354eb9$var$restructure.int16
});
var $07144aea14354eb9$var$ClassTable = new $07144aea14354eb9$var$restructure.Struct({
    firstGlyph: $07144aea14354eb9$var$restructure.uint16,
    nGlyphs: $07144aea14354eb9$var$restructure.uint16,
    offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'nGlyphs'),
    max: function max(t) {
        return t.offsets.length && Math.max.apply(Math, t.offsets);
    }
});
var $07144aea14354eb9$var$Kern2Array = new $07144aea14354eb9$var$restructure.Struct({
    off: function off(t) {
        return t._startOffset - t.parent.parent._startOffset;
    },
    len: function len(t) {
        return ((t.parent.leftTable.max - t.off) / t.parent.rowWidth + 1) * (t.parent.rowWidth / 2);
    },
    values: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.int16, 'len')
});
var $07144aea14354eb9$var$KernSubtable = new $07144aea14354eb9$var$restructure.VersionedStruct('format', {
    0: {
        nPairs: $07144aea14354eb9$var$restructure.uint16,
        searchRange: $07144aea14354eb9$var$restructure.uint16,
        entrySelector: $07144aea14354eb9$var$restructure.uint16,
        rangeShift: $07144aea14354eb9$var$restructure.uint16,
        pairs: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$KernPair, 'nPairs')
    },
    2: {
        rowWidth: $07144aea14354eb9$var$restructure.uint16,
        leftTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassTable, {
            type: 'parent'
        }),
        rightTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassTable, {
            type: 'parent'
        }),
        array: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$Kern2Array, {
            type: 'parent'
        })
    },
    3: {
        glyphCount: $07144aea14354eb9$var$restructure.uint16,
        kernValueCount: $07144aea14354eb9$var$restructure.uint8,
        leftClassCount: $07144aea14354eb9$var$restructure.uint8,
        rightClassCount: $07144aea14354eb9$var$restructure.uint8,
        flags: $07144aea14354eb9$var$restructure.uint8,
        kernValue: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int16, 'kernValueCount'),
        leftClass: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 'glyphCount'),
        rightClass: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 'glyphCount'),
        kernIndex: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, function(t) {
            return t.leftClassCount * t.rightClassCount;
        })
    }
});
var $07144aea14354eb9$var$KernTable = new $07144aea14354eb9$var$restructure.VersionedStruct('version', {
    0: {
        // Microsoft uses this format
        subVersion: $07144aea14354eb9$var$restructure.uint16,
        // Microsoft has an extra sub-table version number
        length: $07144aea14354eb9$var$restructure.uint16,
        // Length of the subtable, in bytes
        format: $07144aea14354eb9$var$restructure.uint8,
        // Format of subtable
        coverage: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint8, [
            'horizontal',
            'minimum',
            'crossStream',
            'override' // If set to 1 the value in this table replaces the accumulated value
        ]),
        subtable: $07144aea14354eb9$var$KernSubtable,
        padding: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8, function(t) {
            return t.length - t._currentOffset;
        })
    },
    1: {
        // Apple uses this format
        length: $07144aea14354eb9$var$restructure.uint32,
        coverage: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint8, [
            null,
            null,
            null,
            null,
            null,
            'variation',
            'crossStream',
            'vertical' // Set if table has vertical kerning values
        ]),
        format: $07144aea14354eb9$var$restructure.uint8,
        tupleIndex: $07144aea14354eb9$var$restructure.uint16,
        subtable: $07144aea14354eb9$var$KernSubtable,
        padding: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8, function(t) {
            return t.length - t._currentOffset;
        })
    }
});
var $07144aea14354eb9$var$kern = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
    0: {
        // Microsoft Version
        nTables: $07144aea14354eb9$var$restructure.uint16,
        tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$KernTable, 'nTables')
    },
    1: {
        // Apple Version
        reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
        // the other half of the version number
        nTables: $07144aea14354eb9$var$restructure.uint32,
        tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$KernTable, 'nTables')
    }
});
// Records the ppem for each glyph at which the scaling becomes linear again,
// despite instructions effecting the advance width
var $07144aea14354eb9$var$LTSH = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    numGlyphs: $07144aea14354eb9$var$restructure.uint16,
    yPels: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 'numGlyphs')
});
// NOTE: The PCLT table is strongly discouraged for OpenType fonts with TrueType outlines
var $07144aea14354eb9$var$PCLT = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    fontNumber: $07144aea14354eb9$var$restructure.uint32,
    pitch: $07144aea14354eb9$var$restructure.uint16,
    xHeight: $07144aea14354eb9$var$restructure.uint16,
    style: $07144aea14354eb9$var$restructure.uint16,
    typeFamily: $07144aea14354eb9$var$restructure.uint16,
    capHeight: $07144aea14354eb9$var$restructure.uint16,
    symbolSet: $07144aea14354eb9$var$restructure.uint16,
    typeface: new $07144aea14354eb9$var$restructure.String(16),
    characterComplement: new $07144aea14354eb9$var$restructure.String(8),
    fileName: new $07144aea14354eb9$var$restructure.String(6),
    strokeWeight: new $07144aea14354eb9$var$restructure.String(1),
    widthType: new $07144aea14354eb9$var$restructure.String(1),
    serifStyle: $07144aea14354eb9$var$restructure.uint8,
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8)
});
// sizes. This is needed in order to match font metrics on Windows.
var $07144aea14354eb9$var$Ratio = new $07144aea14354eb9$var$restructure.Struct({
    bCharSet: $07144aea14354eb9$var$restructure.uint8,
    // Character set
    xRatio: $07144aea14354eb9$var$restructure.uint8,
    // Value to use for x-Ratio
    yStartRatio: $07144aea14354eb9$var$restructure.uint8,
    // Starting y-Ratio value
    yEndRatio: $07144aea14354eb9$var$restructure.uint8 // Ending y-Ratio value
});
var $07144aea14354eb9$var$vTable = new $07144aea14354eb9$var$restructure.Struct({
    yPelHeight: $07144aea14354eb9$var$restructure.uint16,
    // yPelHeight to which values apply
    yMax: $07144aea14354eb9$var$restructure.int16,
    // Maximum value (in pels) for this yPelHeight
    yMin: $07144aea14354eb9$var$restructure.int16 // Minimum value (in pels) for this yPelHeight
});
var $07144aea14354eb9$var$VdmxGroup = new $07144aea14354eb9$var$restructure.Struct({
    recs: $07144aea14354eb9$var$restructure.uint16,
    // Number of height records in this group
    startsz: $07144aea14354eb9$var$restructure.uint8,
    // Starting yPelHeight
    endsz: $07144aea14354eb9$var$restructure.uint8,
    // Ending yPelHeight
    entries: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$vTable, 'recs') // The VDMX records
});
var $07144aea14354eb9$var$VDMX = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    // Version number (0 or 1)
    numRecs: $07144aea14354eb9$var$restructure.uint16,
    // Number of VDMX groups present
    numRatios: $07144aea14354eb9$var$restructure.uint16,
    // Number of aspect ratio groupings
    ratioRanges: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Ratio, 'numRatios'),
    // Ratio ranges
    offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numRatios'),
    // Offset to the VDMX group for this ratio range
    groups: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$VdmxGroup, 'numRecs') // The actual VDMX groupings
});
var $07144aea14354eb9$var$vhea = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    // Version number of the Vertical Header Table
    ascent: $07144aea14354eb9$var$restructure.int16,
    // The vertical typographic ascender for this font
    descent: $07144aea14354eb9$var$restructure.int16,
    // The vertical typographic descender for this font
    lineGap: $07144aea14354eb9$var$restructure.int16,
    // The vertical typographic line gap for this font
    advanceHeightMax: $07144aea14354eb9$var$restructure.int16,
    // The maximum advance height measurement found in the font
    minTopSideBearing: $07144aea14354eb9$var$restructure.int16,
    // The minimum top side bearing measurement found in the font
    minBottomSideBearing: $07144aea14354eb9$var$restructure.int16,
    // The minimum bottom side bearing measurement found in the font
    yMaxExtent: $07144aea14354eb9$var$restructure.int16,
    caretSlopeRise: $07144aea14354eb9$var$restructure.int16,
    // Caret slope (rise/run)
    caretSlopeRun: $07144aea14354eb9$var$restructure.int16,
    caretOffset: $07144aea14354eb9$var$restructure.int16,
    // Set value equal to 0 for nonslanted fonts
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.int16, 4),
    metricDataFormat: $07144aea14354eb9$var$restructure.int16,
    // Set to 0
    numberOfMetrics: $07144aea14354eb9$var$restructure.uint16 // Number of advance heights in the Vertical Metrics table
});
var $07144aea14354eb9$var$VmtxEntry = new $07144aea14354eb9$var$restructure.Struct({
    advance: $07144aea14354eb9$var$restructure.uint16,
    // The advance height of the glyph
    bearing: $07144aea14354eb9$var$restructure.int16 // The top sidebearing of the glyph
}); // Vertical Metrics Table
var $07144aea14354eb9$var$vmtx = new $07144aea14354eb9$var$restructure.Struct({
    metrics: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$VmtxEntry, function(t) {
        return t.parent.vhea.numberOfMetrics;
    }),
    bearings: new $07144aea14354eb9$var$restructure.LazyArray($07144aea14354eb9$var$restructure.int16, function(t) {
        return t.parent.maxp.numGlyphs - t.parent.vhea.numberOfMetrics;
    })
});
var $07144aea14354eb9$var$shortFrac = new $07144aea14354eb9$var$restructure.Fixed(16, 'BE', 14);
var $07144aea14354eb9$var$Correspondence = new $07144aea14354eb9$var$restructure.Struct({
    fromCoord: $07144aea14354eb9$var$shortFrac,
    toCoord: $07144aea14354eb9$var$shortFrac
});
var $07144aea14354eb9$var$Segment = new $07144aea14354eb9$var$restructure.Struct({
    pairCount: $07144aea14354eb9$var$restructure.uint16,
    correspondence: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Correspondence, 'pairCount')
});
var $07144aea14354eb9$var$avar = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    axisCount: $07144aea14354eb9$var$restructure.uint32,
    segment: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Segment, 'axisCount')
});
function $07144aea14354eb9$var$_inheritsLoose$2(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$UnboundedArrayAccessor = /*#__PURE__*/ function() {
    function UnboundedArrayAccessor(type, stream, parent) {
        this.type = type;
        this.stream = stream;
        this.parent = parent;
        this.base = this.stream.pos;
        this._items = [];
    }
    var _proto = UnboundedArrayAccessor.prototype;
    _proto.getItem = function getItem(index) {
        if (this._items[index] == null) {
            var pos = this.stream.pos;
            this.stream.pos = this.base + this.type.size(null, this.parent) * index;
            this._items[index] = this.type.decode(this.stream, this.parent);
            this.stream.pos = pos;
        }
        return this._items[index];
    };
    _proto.inspect = function inspect() {
        return "[UnboundedArray " + this.type.constructor.name + "]";
    };
    return UnboundedArrayAccessor;
}();
var $07144aea14354eb9$var$UnboundedArray = /*#__PURE__*/ function(_r$Array) {
    $07144aea14354eb9$var$_inheritsLoose$2(UnboundedArray, _r$Array);
    function UnboundedArray(type) {
        return _r$Array.call(this, type, 0) || this;
    }
    var _proto2 = UnboundedArray.prototype;
    _proto2.decode = function decode(stream, parent) {
        return new $07144aea14354eb9$var$UnboundedArrayAccessor(this.type, stream, parent);
    };
    return UnboundedArray;
}($07144aea14354eb9$var$restructure.Array);
var $07144aea14354eb9$var$LookupTable = function LookupTable(ValueType) {
    if (ValueType === void 0) ValueType = $07144aea14354eb9$var$restructure.uint16;
    // Helper class that makes internal structures invisible to pointers
    var Shadow = /*#__PURE__*/ function() {
        function Shadow(type) {
            this.type = type;
        }
        var _proto3 = Shadow.prototype;
        _proto3.decode = function decode(stream, ctx) {
            ctx = ctx.parent.parent;
            return this.type.decode(stream, ctx);
        };
        _proto3.size = function size(val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.size(val, ctx);
        };
        _proto3.encode = function encode(stream, val, ctx) {
            ctx = ctx.parent.parent;
            return this.type.encode(stream, val, ctx);
        };
        return Shadow;
    }();
    ValueType = new Shadow(ValueType);
    var BinarySearchHeader = new $07144aea14354eb9$var$restructure.Struct({
        unitSize: $07144aea14354eb9$var$restructure.uint16,
        nUnits: $07144aea14354eb9$var$restructure.uint16,
        searchRange: $07144aea14354eb9$var$restructure.uint16,
        entrySelector: $07144aea14354eb9$var$restructure.uint16,
        rangeShift: $07144aea14354eb9$var$restructure.uint16
    });
    var LookupSegmentSingle = new $07144aea14354eb9$var$restructure.Struct({
        lastGlyph: $07144aea14354eb9$var$restructure.uint16,
        firstGlyph: $07144aea14354eb9$var$restructure.uint16,
        value: ValueType
    });
    var LookupSegmentArray = new $07144aea14354eb9$var$restructure.Struct({
        lastGlyph: $07144aea14354eb9$var$restructure.uint16,
        firstGlyph: $07144aea14354eb9$var$restructure.uint16,
        values: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$restructure.Array(ValueType, function(t) {
            return t.lastGlyph - t.firstGlyph + 1;
        }), {
            type: 'parent'
        })
    });
    var LookupSingle = new $07144aea14354eb9$var$restructure.Struct({
        glyph: $07144aea14354eb9$var$restructure.uint16,
        value: ValueType
    });
    return new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint16, {
        0: {
            values: new $07144aea14354eb9$var$UnboundedArray(ValueType) // length == number of glyphs maybe?
        },
        2: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $07144aea14354eb9$var$restructure.Array(LookupSegmentSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        4: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $07144aea14354eb9$var$restructure.Array(LookupSegmentArray, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        6: {
            binarySearchHeader: BinarySearchHeader,
            segments: new $07144aea14354eb9$var$restructure.Array(LookupSingle, function(t) {
                return t.binarySearchHeader.nUnits;
            })
        },
        8: {
            firstGlyph: $07144aea14354eb9$var$restructure.uint16,
            count: $07144aea14354eb9$var$restructure.uint16,
            values: new $07144aea14354eb9$var$restructure.Array(ValueType, 'count')
        }
    });
};
function $07144aea14354eb9$var$StateTable(entryData, lookupType) {
    if (entryData === void 0) entryData = {};
    if (lookupType === void 0) lookupType = $07144aea14354eb9$var$restructure.uint16;
    var entry = Object.assign({
        newState: $07144aea14354eb9$var$restructure.uint16,
        flags: $07144aea14354eb9$var$restructure.uint16
    }, entryData);
    var Entry = new $07144aea14354eb9$var$restructure.Struct(entry);
    var StateArray = new $07144aea14354eb9$var$UnboundedArray(new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.nClasses;
    }));
    var StateHeader = new $07144aea14354eb9$var$restructure.Struct({
        nClasses: $07144aea14354eb9$var$restructure.uint32,
        classTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$LookupTable(lookupType)),
        stateArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, StateArray),
        entryTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$UnboundedArray(Entry))
    });
    return StateHeader;
} // This is the old version of the StateTable structure
function $07144aea14354eb9$var$StateTable1(entryData, lookupType) {
    if (entryData === void 0) entryData = {};
    if (lookupType === void 0) lookupType = $07144aea14354eb9$var$restructure.uint16;
    var ClassLookupTable = new $07144aea14354eb9$var$restructure.Struct({
        version: function version() {
            return 8;
        },
        // simulate LookupTable
        firstGlyph: $07144aea14354eb9$var$restructure.uint16,
        values: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, $07144aea14354eb9$var$restructure.uint16)
    });
    var entry = Object.assign({
        newStateOffset: $07144aea14354eb9$var$restructure.uint16,
        // convert offset to stateArray index
        newState: function newState(t) {
            return (t.newStateOffset - (t.parent.stateArray.base - t.parent._startOffset)) / t.parent.nClasses;
        },
        flags: $07144aea14354eb9$var$restructure.uint16
    }, entryData);
    var Entry = new $07144aea14354eb9$var$restructure.Struct(entry);
    var StateArray = new $07144aea14354eb9$var$UnboundedArray(new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, function(t) {
        return t.nClasses;
    }));
    var StateHeader1 = new $07144aea14354eb9$var$restructure.Struct({
        nClasses: $07144aea14354eb9$var$restructure.uint16,
        classTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, ClassLookupTable),
        stateArray: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, StateArray),
        entryTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$UnboundedArray(Entry))
    });
    return StateHeader1;
}
var $07144aea14354eb9$var$BslnSubtable = new $07144aea14354eb9$var$restructure.VersionedStruct('format', {
    0: {
        // Distance-based, no mapping
        deltas: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int16, 32)
    },
    1: {
        // Distance-based, with mapping
        deltas: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.int16, 32),
        mappingData: new $07144aea14354eb9$var$LookupTable($07144aea14354eb9$var$restructure.uint16)
    },
    2: {
        // Control point-based, no mapping
        standardGlyph: $07144aea14354eb9$var$restructure.uint16,
        controlPoints: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 32)
    },
    3: {
        // Control point-based, with mapping
        standardGlyph: $07144aea14354eb9$var$restructure.uint16,
        controlPoints: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 32),
        mappingData: new $07144aea14354eb9$var$LookupTable($07144aea14354eb9$var$restructure.uint16)
    }
});
var $07144aea14354eb9$var$bsln = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    format: $07144aea14354eb9$var$restructure.uint16,
    defaultBaseline: $07144aea14354eb9$var$restructure.uint16,
    subtable: $07144aea14354eb9$var$BslnSubtable
});
var $07144aea14354eb9$var$Setting = new $07144aea14354eb9$var$restructure.Struct({
    setting: $07144aea14354eb9$var$restructure.uint16,
    nameIndex: $07144aea14354eb9$var$restructure.int16,
    name: function name(t) {
        return t.parent.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var $07144aea14354eb9$var$FeatureName = new $07144aea14354eb9$var$restructure.Struct({
    feature: $07144aea14354eb9$var$restructure.uint16,
    nSettings: $07144aea14354eb9$var$restructure.uint16,
    settingTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Setting, 'nSettings'), {
        type: 'parent'
    }),
    featureFlags: new $07144aea14354eb9$var$restructure.Bitfield($07144aea14354eb9$var$restructure.uint8, [
        null,
        null,
        null,
        null,
        null,
        null,
        'hasDefault',
        'exclusive'
    ]),
    defaultSetting: $07144aea14354eb9$var$restructure.uint8,
    nameIndex: $07144aea14354eb9$var$restructure.int16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameIndex];
    }
});
var $07144aea14354eb9$var$feat = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    featureNameCount: $07144aea14354eb9$var$restructure.uint16,
    reserved1: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    reserved2: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint32),
    featureNames: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatureName, 'featureNameCount')
});
var $07144aea14354eb9$var$Axis$1 = new $07144aea14354eb9$var$restructure.Struct({
    axisTag: new $07144aea14354eb9$var$restructure.String(4),
    minValue: $07144aea14354eb9$var$restructure.fixed32,
    defaultValue: $07144aea14354eb9$var$restructure.fixed32,
    maxValue: $07144aea14354eb9$var$restructure.fixed32,
    flags: $07144aea14354eb9$var$restructure.uint16,
    nameID: $07144aea14354eb9$var$restructure.uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    }
});
var $07144aea14354eb9$var$Instance = new $07144aea14354eb9$var$restructure.Struct({
    nameID: $07144aea14354eb9$var$restructure.uint16,
    name: function name(t) {
        return t.parent.parent.name.records.fontFeatures[t.nameID];
    },
    flags: $07144aea14354eb9$var$restructure.uint16,
    coord: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.fixed32, function(t) {
        return t.parent.axisCount;
    }),
    postscriptNameID: new $07144aea14354eb9$var$restructure.Optional($07144aea14354eb9$var$restructure.uint16, function(t) {
        return t.parent.instanceSize - t._currentOffset > 0;
    })
});
var $07144aea14354eb9$var$fvar = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    offsetToData: $07144aea14354eb9$var$restructure.uint16,
    countSizePairs: $07144aea14354eb9$var$restructure.uint16,
    axisCount: $07144aea14354eb9$var$restructure.uint16,
    axisSize: $07144aea14354eb9$var$restructure.uint16,
    instanceCount: $07144aea14354eb9$var$restructure.uint16,
    instanceSize: $07144aea14354eb9$var$restructure.uint16,
    axis: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Axis$1, 'axisCount'),
    instance: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Instance, 'instanceCount')
});
var $07144aea14354eb9$var$shortFrac$1 = new $07144aea14354eb9$var$restructure.Fixed(16, 'BE', 14);
var $07144aea14354eb9$var$Offset = /*#__PURE__*/ function() {
    function Offset() {}
    Offset.decode = function decode(stream, parent) {
        // In short format, offsets are multiplied by 2.
        // This doesn't seem to be documented by Apple, but it
        // is implemented this way in Freetype.
        return parent.flags ? stream.readUInt32BE() : stream.readUInt16BE() * 2;
    };
    return Offset;
}();
var $07144aea14354eb9$var$gvar = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    axisCount: $07144aea14354eb9$var$restructure.uint16,
    globalCoordCount: $07144aea14354eb9$var$restructure.uint16,
    globalCoords: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$shortFrac$1, 'axisCount'), 'globalCoordCount')),
    glyphCount: $07144aea14354eb9$var$restructure.uint16,
    flags: $07144aea14354eb9$var$restructure.uint16,
    offsetToData: $07144aea14354eb9$var$restructure.uint32,
    offsets: new $07144aea14354eb9$var$restructure.Array(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$Offset, 'void', {
        relativeTo: 'offsetToData',
        allowNull: false
    }), function(t) {
        return t.glyphCount + 1;
    })
});
var $07144aea14354eb9$var$ClassTable$1 = new $07144aea14354eb9$var$restructure.Struct({
    length: $07144aea14354eb9$var$restructure.uint16,
    coverage: $07144aea14354eb9$var$restructure.uint16,
    subFeatureFlags: $07144aea14354eb9$var$restructure.uint32,
    stateTable: new $07144aea14354eb9$var$StateTable1()
});
var $07144aea14354eb9$var$WidthDeltaRecord = new $07144aea14354eb9$var$restructure.Struct({
    justClass: $07144aea14354eb9$var$restructure.uint32,
    beforeGrowLimit: $07144aea14354eb9$var$restructure.fixed32,
    beforeShrinkLimit: $07144aea14354eb9$var$restructure.fixed32,
    afterGrowLimit: $07144aea14354eb9$var$restructure.fixed32,
    afterShrinkLimit: $07144aea14354eb9$var$restructure.fixed32,
    growFlags: $07144aea14354eb9$var$restructure.uint16,
    shrinkFlags: $07144aea14354eb9$var$restructure.uint16
});
var $07144aea14354eb9$var$WidthDeltaCluster = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$WidthDeltaRecord, $07144aea14354eb9$var$restructure.uint32);
var $07144aea14354eb9$var$ActionData = new $07144aea14354eb9$var$restructure.VersionedStruct('actionType', {
    0: {
        // Decomposition action
        lowerLimit: $07144aea14354eb9$var$restructure.fixed32,
        upperLimit: $07144aea14354eb9$var$restructure.fixed32,
        order: $07144aea14354eb9$var$restructure.uint16,
        glyphs: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$restructure.uint16)
    },
    1: {
        // Unconditional add glyph action
        addGlyph: $07144aea14354eb9$var$restructure.uint16
    },
    2: {
        // Conditional add glyph action
        substThreshold: $07144aea14354eb9$var$restructure.fixed32,
        addGlyph: $07144aea14354eb9$var$restructure.uint16,
        substGlyph: $07144aea14354eb9$var$restructure.uint16
    },
    3: {},
    // Stretch glyph action (no data, not supported by CoreText)
    4: {
        // Ductile glyph action (not supported by CoreText)
        variationAxis: $07144aea14354eb9$var$restructure.uint32,
        minimumLimit: $07144aea14354eb9$var$restructure.fixed32,
        noStretchValue: $07144aea14354eb9$var$restructure.fixed32,
        maximumLimit: $07144aea14354eb9$var$restructure.fixed32
    },
    5: {
        // Repeated add glyph action
        flags: $07144aea14354eb9$var$restructure.uint16,
        glyph: $07144aea14354eb9$var$restructure.uint16
    }
});
var $07144aea14354eb9$var$Action = new $07144aea14354eb9$var$restructure.Struct({
    actionClass: $07144aea14354eb9$var$restructure.uint16,
    actionType: $07144aea14354eb9$var$restructure.uint16,
    actionLength: $07144aea14354eb9$var$restructure.uint32,
    actionData: $07144aea14354eb9$var$ActionData,
    padding: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8, function(t) {
        return t.actionLength - t._currentOffset;
    })
});
var $07144aea14354eb9$var$PostcompensationAction = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Action, $07144aea14354eb9$var$restructure.uint32);
var $07144aea14354eb9$var$PostCompensationTable = new $07144aea14354eb9$var$restructure.Struct({
    lookupTable: new $07144aea14354eb9$var$LookupTable(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$PostcompensationAction))
});
var $07144aea14354eb9$var$JustificationTable = new $07144aea14354eb9$var$restructure.Struct({
    classTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$ClassTable$1, {
        type: 'parent'
    }),
    wdcOffset: $07144aea14354eb9$var$restructure.uint16,
    postCompensationTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$PostCompensationTable, {
        type: 'parent'
    }),
    widthDeltaClusters: new $07144aea14354eb9$var$LookupTable(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$WidthDeltaCluster, {
        type: 'parent',
        relativeTo: 'wdcOffset'
    }))
});
var $07144aea14354eb9$var$just = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint32,
    format: $07144aea14354eb9$var$restructure.uint16,
    horizontal: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JustificationTable),
    vertical: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$JustificationTable)
});
var $07144aea14354eb9$var$LigatureData = {
    action: $07144aea14354eb9$var$restructure.uint16
};
var $07144aea14354eb9$var$ContextualData = {
    markIndex: $07144aea14354eb9$var$restructure.uint16,
    currentIndex: $07144aea14354eb9$var$restructure.uint16
};
var $07144aea14354eb9$var$InsertionData = {
    currentInsertIndex: $07144aea14354eb9$var$restructure.uint16,
    markedInsertIndex: $07144aea14354eb9$var$restructure.uint16
};
var $07144aea14354eb9$var$SubstitutionTable = new $07144aea14354eb9$var$restructure.Struct({
    items: new $07144aea14354eb9$var$UnboundedArray(new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$LookupTable()))
});
var $07144aea14354eb9$var$SubtableData = new $07144aea14354eb9$var$restructure.VersionedStruct('type', {
    0: {
        // Indic Rearrangement Subtable
        stateTable: new $07144aea14354eb9$var$StateTable()
    },
    1: {
        // Contextual Glyph Substitution Subtable
        stateTable: new $07144aea14354eb9$var$StateTable($07144aea14354eb9$var$ContextualData),
        substitutionTable: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$SubstitutionTable)
    },
    2: {
        // Ligature subtable
        stateTable: new $07144aea14354eb9$var$StateTable($07144aea14354eb9$var$LigatureData),
        ligatureActions: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$UnboundedArray($07144aea14354eb9$var$restructure.uint32)),
        components: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$UnboundedArray($07144aea14354eb9$var$restructure.uint16)),
        ligatureList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$UnboundedArray($07144aea14354eb9$var$restructure.uint16))
    },
    4: {
        // Non-contextual Glyph Substitution Subtable
        lookupTable: new $07144aea14354eb9$var$LookupTable()
    },
    5: {
        // Glyph Insertion Subtable
        stateTable: new $07144aea14354eb9$var$StateTable($07144aea14354eb9$var$InsertionData),
        insertionActions: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, new $07144aea14354eb9$var$UnboundedArray($07144aea14354eb9$var$restructure.uint16))
    }
});
var $07144aea14354eb9$var$Subtable = new $07144aea14354eb9$var$restructure.Struct({
    length: $07144aea14354eb9$var$restructure.uint32,
    coverage: $07144aea14354eb9$var$restructure.uint24,
    type: $07144aea14354eb9$var$restructure.uint8,
    subFeatureFlags: $07144aea14354eb9$var$restructure.uint32,
    table: $07144aea14354eb9$var$SubtableData,
    padding: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8, function(t) {
        return t.length - t._currentOffset;
    })
});
var $07144aea14354eb9$var$FeatureEntry = new $07144aea14354eb9$var$restructure.Struct({
    featureType: $07144aea14354eb9$var$restructure.uint16,
    featureSetting: $07144aea14354eb9$var$restructure.uint16,
    enableFlags: $07144aea14354eb9$var$restructure.uint32,
    disableFlags: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$MorxChain = new $07144aea14354eb9$var$restructure.Struct({
    defaultFlags: $07144aea14354eb9$var$restructure.uint32,
    chainLength: $07144aea14354eb9$var$restructure.uint32,
    nFeatureEntries: $07144aea14354eb9$var$restructure.uint32,
    nSubtables: $07144aea14354eb9$var$restructure.uint32,
    features: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$FeatureEntry, 'nFeatureEntries'),
    subtables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Subtable, 'nSubtables')
});
var $07144aea14354eb9$var$morx = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint16,
    unused: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    nChains: $07144aea14354eb9$var$restructure.uint32,
    chains: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$MorxChain, 'nChains')
});
var $07144aea14354eb9$var$OpticalBounds = new $07144aea14354eb9$var$restructure.Struct({
    left: $07144aea14354eb9$var$restructure.int16,
    top: $07144aea14354eb9$var$restructure.int16,
    right: $07144aea14354eb9$var$restructure.int16,
    bottom: $07144aea14354eb9$var$restructure.int16
});
var $07144aea14354eb9$var$opbd = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.fixed32,
    format: $07144aea14354eb9$var$restructure.uint16,
    lookupTable: new $07144aea14354eb9$var$LookupTable($07144aea14354eb9$var$OpticalBounds)
});
var $07144aea14354eb9$var$tables = {};
$07144aea14354eb9$var$tables.cmap = $07144aea14354eb9$var$cmap;
$07144aea14354eb9$var$tables.head = $07144aea14354eb9$var$head;
$07144aea14354eb9$var$tables.hhea = $07144aea14354eb9$var$hhea;
$07144aea14354eb9$var$tables.hmtx = $07144aea14354eb9$var$hmtx;
$07144aea14354eb9$var$tables.maxp = $07144aea14354eb9$var$maxp;
$07144aea14354eb9$var$tables.name = $07144aea14354eb9$var$NameTable;
$07144aea14354eb9$var$tables['OS/2'] = $07144aea14354eb9$var$OS2;
$07144aea14354eb9$var$tables.post = $07144aea14354eb9$var$post; // TrueType Outlines
$07144aea14354eb9$var$tables.fpgm = $07144aea14354eb9$var$fpgm;
$07144aea14354eb9$var$tables.loca = $07144aea14354eb9$var$loca;
$07144aea14354eb9$var$tables.prep = $07144aea14354eb9$var$prep;
$07144aea14354eb9$var$tables['cvt '] = $07144aea14354eb9$var$cvt;
$07144aea14354eb9$var$tables.glyf = $07144aea14354eb9$var$glyf; // PostScript Outlines
$07144aea14354eb9$var$tables['CFF '] = $07144aea14354eb9$var$CFFFont;
$07144aea14354eb9$var$tables['CFF2'] = $07144aea14354eb9$var$CFFFont;
$07144aea14354eb9$var$tables.VORG = $07144aea14354eb9$var$VORG; // Bitmap Glyphs
$07144aea14354eb9$var$tables.EBLC = $07144aea14354eb9$var$EBLC;
$07144aea14354eb9$var$tables.CBLC = $07144aea14354eb9$var$tables.EBLC;
$07144aea14354eb9$var$tables.sbix = $07144aea14354eb9$var$sbix;
$07144aea14354eb9$var$tables.COLR = $07144aea14354eb9$var$COLR;
$07144aea14354eb9$var$tables.CPAL = $07144aea14354eb9$var$CPAL; // Advanced OpenType Tables
$07144aea14354eb9$var$tables.BASE = $07144aea14354eb9$var$BASE;
$07144aea14354eb9$var$tables.GDEF = $07144aea14354eb9$var$GDEF;
$07144aea14354eb9$var$tables.GPOS = $07144aea14354eb9$var$GPOS;
$07144aea14354eb9$var$tables.GSUB = $07144aea14354eb9$var$GSUB;
$07144aea14354eb9$var$tables.JSTF = $07144aea14354eb9$var$JSTF; // OpenType variations tables
$07144aea14354eb9$var$tables.HVAR = $07144aea14354eb9$var$HVAR; // Other OpenType Tables
$07144aea14354eb9$var$tables.DSIG = $07144aea14354eb9$var$DSIG;
$07144aea14354eb9$var$tables.gasp = $07144aea14354eb9$var$gasp;
$07144aea14354eb9$var$tables.hdmx = $07144aea14354eb9$var$hdmx;
$07144aea14354eb9$var$tables.kern = $07144aea14354eb9$var$kern;
$07144aea14354eb9$var$tables.LTSH = $07144aea14354eb9$var$LTSH;
$07144aea14354eb9$var$tables.PCLT = $07144aea14354eb9$var$PCLT;
$07144aea14354eb9$var$tables.VDMX = $07144aea14354eb9$var$VDMX;
$07144aea14354eb9$var$tables.vhea = $07144aea14354eb9$var$vhea;
$07144aea14354eb9$var$tables.vmtx = $07144aea14354eb9$var$vmtx; // Apple Advanced Typography Tables
$07144aea14354eb9$var$tables.avar = $07144aea14354eb9$var$avar;
$07144aea14354eb9$var$tables.bsln = $07144aea14354eb9$var$bsln;
$07144aea14354eb9$var$tables.feat = $07144aea14354eb9$var$feat;
$07144aea14354eb9$var$tables.fvar = $07144aea14354eb9$var$fvar;
$07144aea14354eb9$var$tables.gvar = $07144aea14354eb9$var$gvar;
$07144aea14354eb9$var$tables.just = $07144aea14354eb9$var$just;
$07144aea14354eb9$var$tables.morx = $07144aea14354eb9$var$morx;
$07144aea14354eb9$var$tables.opbd = $07144aea14354eb9$var$opbd;
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$3(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$3(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$3(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$3(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$3(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$3(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$TableEntry = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    checkSum: $07144aea14354eb9$var$restructure.uint32,
    offset: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, 'void', {
        type: 'global'
    }),
    length: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$Directory = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    numTables: $07144aea14354eb9$var$restructure.uint16,
    searchRange: $07144aea14354eb9$var$restructure.uint16,
    entrySelector: $07144aea14354eb9$var$restructure.uint16,
    rangeShift: $07144aea14354eb9$var$restructure.uint16,
    tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$TableEntry, 'numTables')
});
$07144aea14354eb9$var$Directory.process = function() {
    var tables = {};
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$3(this.tables), _step; !(_step = _iterator()).done;){
        var table = _step.value;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
$07144aea14354eb9$var$Directory.preEncode = function(stream) {
    var tables$1 = [];
    for(var tag in this.tables){
        var table = this.tables[tag];
        if (table) tables$1.push({
            tag: tag,
            checkSum: 0,
            offset: new $07144aea14354eb9$var$restructure.VoidPointer($07144aea14354eb9$var$tables[tag], table),
            length: $07144aea14354eb9$var$tables[tag].size(table)
        });
    }
    this.tag = 'true';
    this.numTables = tables$1.length;
    this.tables = tables$1;
    var maxExponentFor2 = Math.floor(Math.log(this.numTables) / Math.LN2);
    var maxPowerOf2 = Math.pow(2, maxExponentFor2);
    this.searchRange = maxPowerOf2 * 16;
    this.entrySelector = Math.log(maxPowerOf2) / Math.LN2;
    this.rangeShift = this.numTables * 16 - this.searchRange;
};
function $07144aea14354eb9$var$binarySearch(arr, cmp) {
    var min = 0;
    var max = arr.length - 1;
    while(min <= max){
        var mid = min + max >> 1;
        var res = cmp(arr[mid]);
        if (res < 0) max = mid - 1;
        else if (res > 0) min = mid + 1;
        else return mid;
    }
    return -1;
}
function $07144aea14354eb9$var$range(index, end) {
    var range = [];
    while(index < end)range.push(index++);
    return range;
}
var $07144aea14354eb9$var$_class;
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$4(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$4(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$4(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$4(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$4(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $07144aea14354eb9$var$CmapProcessor = ($07144aea14354eb9$var$_class = /*#__PURE__*/ function() {
    function CmapProcessor(cmapTable) {
        // Attempt to find a Unicode cmap first
        this.encoding = null;
        this.cmap = this.findSubtable(cmapTable, [
            [
                3,
                10
            ],
            [
                0,
                6
            ],
            [
                0,
                4
            ],
            [
                3,
                1
            ],
            [
                0,
                3
            ],
            [
                0,
                2
            ],
            [
                0,
                1
            ],
            [
                0,
                0
            ]
        ]); // If not unicode cmap was found, and iconv-lite is installed,
        // take the first table with a supported encoding.
        if (!this.cmap && $07144aea14354eb9$var$lib) for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(cmapTable.tables), _step; !(_step = _iterator()).done;){
            var cmap = _step.value;
            var encoding = $07144aea14354eb9$var$getEncoding(cmap.platformID, cmap.encodingID, cmap.table.language - 1);
            if ($07144aea14354eb9$var$lib.encodingExists(encoding)) {
                this.cmap = cmap.table;
                this.encoding = encoding;
            }
        }
        if (!this.cmap) throw new Error("Could not find a supported cmap table");
        this.uvs = this.findSubtable(cmapTable, [
            [
                0,
                5
            ]
        ]);
        if (this.uvs && this.uvs.version !== 14) this.uvs = null;
    }
    var _proto = CmapProcessor.prototype;
    _proto.findSubtable = function findSubtable(cmapTable, pairs) {
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(pairs), _step2; !(_step2 = _iterator2()).done;){
            var _step2$value = _step2.value, platformID = _step2$value[0], encodingID = _step2$value[1];
            for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(cmapTable.tables), _step3; !(_step3 = _iterator3()).done;){
                var cmap = _step3.value;
                if (cmap.platformID === platformID && cmap.encodingID === encodingID) return cmap.table;
            }
        }
        return null;
    };
    _proto.lookup = function lookup(codepoint, variationSelector) {
        // If there is no Unicode cmap in this font, we need to re-encode
        // the codepoint in the encoding that the cmap supports.
        if (this.encoding) {
            var buf = $07144aea14354eb9$var$lib.encode(String.fromCodePoint(codepoint), this.encoding);
            codepoint = 0;
            for(var i = 0; i < buf.length; i++)codepoint = codepoint << 8 | buf[i];
             // Otherwise, try to get a Unicode variation selector for this codepoint if one is provided.
        } else if (variationSelector) {
            var gid = this.getVariationSelector(codepoint, variationSelector);
            if (gid) return gid;
        }
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return cmap.codeMap.get(codepoint) || 0;
            case 4:
                var min = 0;
                var max = cmap.segCount - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    if (codepoint < cmap.startCode.get(mid)) max = mid - 1;
                    else if (codepoint > cmap.endCode.get(mid)) min = mid + 1;
                    else {
                        var rangeOffset = cmap.idRangeOffset.get(mid);
                        var _gid = void 0;
                        if (rangeOffset === 0) _gid = codepoint + cmap.idDelta.get(mid);
                        else {
                            var index = rangeOffset / 2 + (codepoint - cmap.startCode.get(mid)) - (cmap.segCount - mid);
                            _gid = cmap.glyphIndexArray.get(index) || 0;
                            if (_gid !== 0) _gid += cmap.idDelta.get(mid);
                        }
                        return _gid & 0xffff;
                    }
                }
                return 0;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return cmap.glyphIndices.get(codepoint - cmap.firstCode) || 0;
            case 12:
            case 13:
                var _min = 0;
                var _max = cmap.nGroups - 1;
                while(_min <= _max){
                    var _mid = _min + _max >> 1;
                    var group = cmap.groups.get(_mid);
                    if (codepoint < group.startCharCode) _max = _mid - 1;
                    else if (codepoint > group.endCharCode) _min = _mid + 1;
                    else {
                        if (cmap.version === 12) return group.glyphID + (codepoint - group.startCharCode);
                        else return group.glyphID;
                    }
                }
                return 0;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    _proto.getVariationSelector = function getVariationSelector(codepoint, variationSelector) {
        if (!this.uvs) return 0;
        var selectors = this.uvs.varSelectors.toArray();
        var i = $07144aea14354eb9$var$binarySearch(selectors, function(x) {
            return variationSelector - x.varSelector;
        });
        var sel = selectors[i];
        if (i !== -1 && sel.defaultUVS) i = $07144aea14354eb9$var$binarySearch(sel.defaultUVS, function(x) {
            return codepoint < x.startUnicodeValue ? -1 : codepoint > x.startUnicodeValue + x.additionalCount ? 1 : 0;
        });
        if (i !== -1 && sel.nonDefaultUVS) {
            i = $07144aea14354eb9$var$binarySearch(sel.nonDefaultUVS, function(x) {
                return codepoint - x.unicodeValue;
            });
            if (i !== -1) return sel.nonDefaultUVS[i].glyphID;
        }
        return 0;
    };
    _proto.getCharacterSet = function getCharacterSet() {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                return $07144aea14354eb9$var$range(0, cmap.codeMap.length);
            case 4:
                var res = [];
                var endCodes = cmap.endCode.toArray();
                for(var i = 0; i < endCodes.length; i++){
                    var tail = endCodes[i] + 1;
                    var start = cmap.startCode.get(i);
                    res.push.apply(res, $07144aea14354eb9$var$range(start, tail));
                }
                return res;
            case 8:
                throw new Error('TODO: cmap format 8');
            case 6:
            case 10:
                return $07144aea14354eb9$var$range(cmap.firstCode, cmap.firstCode + cmap.glyphIndices.length);
            case 12:
            case 13:
                var _res = [];
                for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step4; !(_step4 = _iterator4()).done;){
                    var group = _step4.value;
                    _res.push.apply(_res, $07144aea14354eb9$var$range(group.startCharCode, group.endCharCode + 1));
                }
                return _res;
            case 14:
                throw new Error('TODO: cmap format 14');
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    _proto.codePointsForGlyph = function codePointsForGlyph(gid) {
        var cmap = this.cmap;
        switch(cmap.version){
            case 0:
                var res = [];
                for(var i = 0; i < 256; i++)if (cmap.codeMap.get(i) === gid) res.push(i);
                return res;
            case 4:
                var _res2 = [];
                for(var _i = 0; _i < cmap.segCount; _i++){
                    var end = cmap.endCode.get(_i);
                    var start = cmap.startCode.get(_i);
                    var rangeOffset = cmap.idRangeOffset.get(_i);
                    var delta = cmap.idDelta.get(_i);
                    for(var c = start; c <= end; c++){
                        var g = 0;
                        if (rangeOffset === 0) g = c + delta;
                        else {
                            var index = rangeOffset / 2 + (c - start) - (cmap.segCount - _i);
                            g = cmap.glyphIndexArray.get(index) || 0;
                            if (g !== 0) g += delta;
                        }
                        if (g === gid) _res2.push(c);
                    }
                }
                return _res2;
            case 12:
                var _res3 = [];
                for(var _iterator5 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step5; !(_step5 = _iterator5()).done;){
                    var group = _step5.value;
                    if (gid >= group.glyphID && gid <= group.glyphID + (group.endCharCode - group.startCharCode)) _res3.push(group.startCharCode + (gid - group.glyphID));
                }
                return _res3;
            case 13:
                var _res4 = [];
                for(var _iterator6 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$4(cmap.groups.toArray()), _step6; !(_step6 = _iterator6()).done;){
                    var _group = _step6.value;
                    if (gid === _group.glyphID) _res4.push.apply(_res4, $07144aea14354eb9$var$range(_group.startCharCode, _group.endCharCode + 1));
                }
                return _res4;
            default:
                throw new Error("Unknown cmap format " + cmap.version);
        }
    };
    return CmapProcessor;
}(), $07144aea14354eb9$var$_applyDecoratedDescriptor($07144aea14354eb9$var$_class.prototype, "getCharacterSet", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class.prototype, "getCharacterSet"), $07144aea14354eb9$var$_class.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor($07144aea14354eb9$var$_class.prototype, "codePointsForGlyph", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class.prototype, "codePointsForGlyph"), $07144aea14354eb9$var$_class.prototype), $07144aea14354eb9$var$_class);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$5(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$5(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$5(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$5(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$5(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$5(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$KernProcessor = /*#__PURE__*/ function() {
    function KernProcessor(font) {
        this.kern = font.kern;
    }
    var _proto = KernProcessor.prototype;
    _proto.process = function process(glyphs, positions) {
        for(var glyphIndex = 0; glyphIndex < glyphs.length - 1; glyphIndex++){
            var left = glyphs[glyphIndex].id;
            var right = glyphs[glyphIndex + 1].id;
            positions[glyphIndex].xAdvance += this.getKerning(left, right);
        }
    };
    _proto.getKerning = function getKerning(left, right) {
        var res = 0;
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$5(this.kern.tables), _step; !(_step = _iterator()).done;){
            var table = _step.value;
            if (table.coverage.crossStream) continue;
            switch(table.version){
                case 0:
                    if (!table.coverage.horizontal) continue;
                    break;
                case 1:
                    if (table.coverage.vertical || table.coverage.variation) continue;
                    break;
                default:
                    throw new Error("Unsupported kerning table version " + table.version);
            }
            var val = 0;
            var s = table.subtable;
            switch(table.format){
                case 0:
                    var pairIdx = $07144aea14354eb9$var$binarySearch(s.pairs, function(pair) {
                        return left - pair.left || right - pair.right;
                    });
                    if (pairIdx >= 0) val = s.pairs[pairIdx].value;
                    break;
                case 2:
                    var leftOffset = 0, rightOffset = 0;
                    if (left >= s.leftTable.firstGlyph && left < s.leftTable.firstGlyph + s.leftTable.nGlyphs) leftOffset = s.leftTable.offsets[left - s.leftTable.firstGlyph];
                    else leftOffset = s.array.off;
                    if (right >= s.rightTable.firstGlyph && right < s.rightTable.firstGlyph + s.rightTable.nGlyphs) rightOffset = s.rightTable.offsets[right - s.rightTable.firstGlyph];
                    var index = (leftOffset + rightOffset - s.array.off) / 2;
                    val = s.array.values.get(index);
                    break;
                case 3:
                    if (left >= s.glyphCount || right >= s.glyphCount) return 0;
                    val = s.kernValue[s.kernIndex[s.leftClass[left] * s.rightClassCount + s.rightClass[right]]];
                    break;
                default:
                    throw new Error("Unsupported kerning sub-table format " + table.format);
            } // Microsoft supports the override flag, which resets the result
            // Otherwise, the sum of the results from all subtables is returned
            if (table.coverage.override) res = val;
            else res += val;
        }
        return res;
    };
    return KernProcessor;
}();
var $07144aea14354eb9$var$TINF_OK = 0;
var $07144aea14354eb9$var$TINF_DATA_ERROR = -3;
function $07144aea14354eb9$var$Tree() {
    this.table = new Uint16Array(16);
    /* table of code length counts */ this.trans = new Uint16Array(288);
/* code -> symbol translation table */ }
function $07144aea14354eb9$var$Data(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $07144aea14354eb9$var$Tree();
    /* dynamic length/symbol tree */ this.dtree = new $07144aea14354eb9$var$Tree();
/* dynamic distance tree */ }
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $07144aea14354eb9$var$sltree = new $07144aea14354eb9$var$Tree();
var $07144aea14354eb9$var$sdtree = new $07144aea14354eb9$var$Tree();
/* extra bits and base tables for length codes */ var $07144aea14354eb9$var$length_bits = new Uint8Array(30);
var $07144aea14354eb9$var$length_base = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $07144aea14354eb9$var$dist_bits = new Uint8Array(30);
var $07144aea14354eb9$var$dist_base = new Uint16Array(30);
/* special ordering of code length codes */ var $07144aea14354eb9$var$clcidx = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $07144aea14354eb9$var$code_tree = new $07144aea14354eb9$var$Tree();
var $07144aea14354eb9$var$lengths = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $07144aea14354eb9$var$tinf_build_bits_base(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $07144aea14354eb9$var$tinf_build_fixed_trees(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $07144aea14354eb9$var$offs = new Uint16Array(16);
function $07144aea14354eb9$var$tinf_build_tree(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $07144aea14354eb9$var$offs[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$07144aea14354eb9$var$offs[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $07144aea14354eb9$var$tinf_getbit(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $07144aea14354eb9$var$tinf_read_bits(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $07144aea14354eb9$var$tinf_decode_symbol(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $07144aea14354eb9$var$tinf_decode_trees(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $07144aea14354eb9$var$tinf_read_bits(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $07144aea14354eb9$var$tinf_read_bits(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $07144aea14354eb9$var$tinf_read_bits(d, 4, 4);
    for(i = 0; i < 19; ++i)$07144aea14354eb9$var$lengths[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $07144aea14354eb9$var$tinf_read_bits(d, 3, 0);
        $07144aea14354eb9$var$lengths[$07144aea14354eb9$var$clcidx[i]] = clen;
    }
    /* build code length tree */ $07144aea14354eb9$var$tinf_build_tree($07144aea14354eb9$var$code_tree, $07144aea14354eb9$var$lengths, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $07144aea14354eb9$var$tinf_decode_symbol(d, $07144aea14354eb9$var$code_tree);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $07144aea14354eb9$var$lengths[num - 1];
                for(length = $07144aea14354eb9$var$tinf_read_bits(d, 2, 3); length; --length)$07144aea14354eb9$var$lengths[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $07144aea14354eb9$var$tinf_read_bits(d, 3, 3); length; --length)$07144aea14354eb9$var$lengths[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $07144aea14354eb9$var$tinf_read_bits(d, 7, 11); length; --length)$07144aea14354eb9$var$lengths[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $07144aea14354eb9$var$lengths[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $07144aea14354eb9$var$tinf_build_tree(lt, $07144aea14354eb9$var$lengths, 0, hlit);
    $07144aea14354eb9$var$tinf_build_tree(dt, $07144aea14354eb9$var$lengths, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $07144aea14354eb9$var$tinf_inflate_block_data(d, lt, dt) {
    while(true){
        var sym = $07144aea14354eb9$var$tinf_decode_symbol(d, lt);
        /* check for end of block */ if (sym === 256) return $07144aea14354eb9$var$TINF_OK;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $07144aea14354eb9$var$tinf_read_bits(d, $07144aea14354eb9$var$length_bits[sym], $07144aea14354eb9$var$length_base[sym]);
            dist = $07144aea14354eb9$var$tinf_decode_symbol(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $07144aea14354eb9$var$tinf_read_bits(d, $07144aea14354eb9$var$dist_bits[dist], $07144aea14354eb9$var$dist_base[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $07144aea14354eb9$var$tinf_inflate_uncompressed_block(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $07144aea14354eb9$var$TINF_DATA_ERROR;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $07144aea14354eb9$var$TINF_OK;
}
/* inflate stream from source to dest */ function $07144aea14354eb9$var$tinf_uncompress(source, dest) {
    var d = new $07144aea14354eb9$var$Data(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $07144aea14354eb9$var$tinf_getbit(d);
        /* read block type (2 bits) */ btype = $07144aea14354eb9$var$tinf_read_bits(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $07144aea14354eb9$var$tinf_inflate_uncompressed_block(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $07144aea14354eb9$var$tinf_inflate_block_data(d, $07144aea14354eb9$var$sltree, $07144aea14354eb9$var$sdtree);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $07144aea14354eb9$var$tinf_decode_trees(d, d.ltree, d.dtree);
                res = $07144aea14354eb9$var$tinf_inflate_block_data(d, d.ltree, d.dtree);
                break;
            default:
                res = $07144aea14354eb9$var$TINF_DATA_ERROR;
        }
        if (res !== $07144aea14354eb9$var$TINF_OK) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $07144aea14354eb9$var$tinf_build_fixed_trees($07144aea14354eb9$var$sltree, $07144aea14354eb9$var$sdtree);
/* build extra bits and base tables */ $07144aea14354eb9$var$tinf_build_bits_base($07144aea14354eb9$var$length_bits, $07144aea14354eb9$var$length_base, 4, 3);
$07144aea14354eb9$var$tinf_build_bits_base($07144aea14354eb9$var$dist_bits, $07144aea14354eb9$var$dist_base, 2, 1);
/* fix a special case */ $07144aea14354eb9$var$length_bits[28] = 0;
$07144aea14354eb9$var$length_base[28] = 258;
var $07144aea14354eb9$var$tinyInflate = $07144aea14354eb9$var$tinf_uncompress;
var $07144aea14354eb9$var$UnicodeTrie, $07144aea14354eb9$var$inflate;
$07144aea14354eb9$var$inflate = $07144aea14354eb9$var$tinyInflate;
$07144aea14354eb9$var$UnicodeTrie = function() {
    var DATA_BLOCK_LENGTH, DATA_GRANULARITY, DATA_MASK, INDEX_1_OFFSET, INDEX_2_BLOCK_LENGTH, INDEX_2_BMP_LENGTH, INDEX_2_MASK, INDEX_SHIFT, LSCP_INDEX_2_LENGTH, LSCP_INDEX_2_OFFSET, OMITTED_BMP_INDEX_1_LENGTH, SHIFT_1, SHIFT_1_2, SHIFT_2, UTF8_2B_INDEX_2_LENGTH, UTF8_2B_INDEX_2_OFFSET;
    SHIFT_1 = 11;
    SHIFT_2 = 5;
    SHIFT_1_2 = SHIFT_1 - SHIFT_2;
    OMITTED_BMP_INDEX_1_LENGTH = 0x10000 >> SHIFT_1;
    INDEX_2_BLOCK_LENGTH = 1 << SHIFT_1_2;
    INDEX_2_MASK = INDEX_2_BLOCK_LENGTH - 1;
    INDEX_SHIFT = 2;
    DATA_BLOCK_LENGTH = 1 << SHIFT_2;
    DATA_MASK = DATA_BLOCK_LENGTH - 1;
    LSCP_INDEX_2_OFFSET = 0x10000 >> SHIFT_2;
    LSCP_INDEX_2_LENGTH = 0x400 >> SHIFT_2;
    INDEX_2_BMP_LENGTH = LSCP_INDEX_2_OFFSET + LSCP_INDEX_2_LENGTH;
    UTF8_2B_INDEX_2_OFFSET = INDEX_2_BMP_LENGTH;
    UTF8_2B_INDEX_2_LENGTH = 32;
    INDEX_1_OFFSET = UTF8_2B_INDEX_2_OFFSET + UTF8_2B_INDEX_2_LENGTH;
    DATA_GRANULARITY = 1 << INDEX_SHIFT;
    function UnicodeTrie(data) {
        var isBuffer, uncompressedLength, view;
        isBuffer = typeof data.readUInt32BE === 'function' && typeof data.slice === 'function';
        if (isBuffer || data instanceof Uint8Array) {
            if (isBuffer) {
                this.highStart = data.readUInt32BE(0);
                this.errorValue = data.readUInt32BE(4);
                uncompressedLength = data.readUInt32BE(8);
                data = data.slice(12);
            } else {
                view = new DataView(data.buffer);
                this.highStart = view.getUint32(0);
                this.errorValue = view.getUint32(4);
                uncompressedLength = view.getUint32(8);
                data = data.subarray(12);
            }
            data = $07144aea14354eb9$var$inflate(data, new Uint8Array(uncompressedLength));
            data = $07144aea14354eb9$var$inflate(data, new Uint8Array(uncompressedLength));
            this.data = new Uint32Array(data.buffer);
        } else this.data = data.data, this.highStart = data.highStart, this.errorValue = data.errorValue;
    }
    UnicodeTrie.prototype.get = function(codePoint) {
        var index;
        if (codePoint < 0 || codePoint > 0x10ffff) return this.errorValue;
        if (codePoint < 0xd800 || codePoint > 0xdbff && codePoint <= 0xffff) {
            index = (this.data[codePoint >> SHIFT_2] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint <= 0xffff) {
            index = (this.data[LSCP_INDEX_2_OFFSET + (codePoint - 0xd800 >> SHIFT_2)] << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        if (codePoint < this.highStart) {
            index = this.data[INDEX_1_OFFSET - OMITTED_BMP_INDEX_1_LENGTH + (codePoint >> SHIFT_1)];
            index = this.data[index + (codePoint >> SHIFT_2 & INDEX_2_MASK)];
            index = (index << INDEX_SHIFT) + (codePoint & DATA_MASK);
            return this.data[index];
        }
        return this.data[this.data.length - DATA_GRANULARITY];
    };
    return UnicodeTrie;
}();
var $07144aea14354eb9$var$unicodeTrie = $07144aea14354eb9$var$UnicodeTrie;
var $07144aea14354eb9$var$base64Arraybuffer = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    /*
   * base64-arraybuffer
   * https://github.com/niklasvh/base64-arraybuffer
   *
   * Copyright (c) 2012 Niklas von Hertzen
   * Licensed under the MIT license.
   */ (function() {
        var chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"; // Use a lookup table to find the index.
        var lookup = new Uint8Array(256);
        for(var i = 0; i < chars.length; i++)lookup[chars.charCodeAt(i)] = i;
        exports.encode = function(arraybuffer) {
            var bytes = new Uint8Array(arraybuffer), i, len = bytes.length, base64 = "";
            for(i = 0; i < len; i += 3){
                base64 += chars[bytes[i] >> 2];
                base64 += chars[(bytes[i] & 3) << 4 | bytes[i + 1] >> 4];
                base64 += chars[(bytes[i + 1] & 15) << 2 | bytes[i + 2] >> 6];
                base64 += chars[bytes[i + 2] & 63];
            }
            if (len % 3 === 2) base64 = base64.substring(0, base64.length - 1) + "=";
            else if (len % 3 === 1) base64 = base64.substring(0, base64.length - 2) + "==";
            return base64;
        };
        exports.decode = function(base64) {
            var bufferLength = base64.length * 0.75, len = base64.length, i, p = 0, encoded1, encoded2, encoded3, encoded4;
            if (base64[base64.length - 1] === "=") {
                bufferLength--;
                if (base64[base64.length - 2] === "=") bufferLength--;
            }
            var arraybuffer = new ArrayBuffer(bufferLength), bytes = new Uint8Array(arraybuffer);
            for(i = 0; i < len; i += 4){
                encoded1 = lookup[base64.charCodeAt(i)];
                encoded2 = lookup[base64.charCodeAt(i + 1)];
                encoded3 = lookup[base64.charCodeAt(i + 2)];
                encoded4 = lookup[base64.charCodeAt(i + 3)];
                bytes[p++] = encoded1 << 2 | encoded2 >> 4;
                bytes[p++] = (encoded2 & 15) << 4 | encoded3 >> 2;
                bytes[p++] = (encoded3 & 3) << 6 | encoded4 & 63;
            }
            return arraybuffer;
        };
    })();
});
var $07144aea14354eb9$var$base64Arraybuffer_1 = $07144aea14354eb9$var$base64Arraybuffer.encode;
var $07144aea14354eb9$var$base64Arraybuffer_2 = $07144aea14354eb9$var$base64Arraybuffer.decode;
var $07144aea14354eb9$var$base64DeflatedData = "eJxtVtty4zYM/Rc/70Ni97LbN1tJ49SXeGI3O93OjgayGBERRXoo0h5Np/9eAKTcpNOHECAFAgfAAZ2/JkcIqnEeVT/55c9JcZx8mnzradk5Wva83clW8bZjraZly8s68lnLZ2y3Nrzla2tedkhL8crGsmVtHXhhLxvLCzvd8N0t3/0my4mvccjCTb5/mhxdV6FF2xQG+j6h3LpQPivna+UVA5lX7qxGWT5joznOQhl34dMQ4KhVXX78fD0e7Z7OyhsYSHt0Acp9rPqjxxPb3rlYGXW1zNsxrBz/61eirNUrb4qiuL3J8jbLaZazLH/I8scsf8ry5yw/Z/klyWn2N83+ptnfNPubZn/T7G+W7WfZfjbaZ//T7H+a/c+yn1n2Mxv9MK5tbAOQfEEPHaQPn7PhlzHBmzGzmzGFaw4j2Nsx2u0I71ZwfezVtba5mlmswEL54vBIrMjYGVtqAFEmtS3x2XWdY6qtISDLhTu5zr0yIx+tVh6DMOjBK9UK504BmZDF4NEYUee+UxaBby9V5ZVwykMlH/dkB6wcNBAsLlErk0PlIedyawO2BrG+U2cyauiLpGYbMKw9RN/FVif1DTxhZT56HNjhATrkyTgoE5uY8rdQg3gmwtIfT9QerSY1QUFJmYEcsFIZxgCWQHEQmp0mZwS2iez9Pmh0p5Q71cW1istfENyaLLkfHhu0wLZPjZaQz9HKhQOlZFyT3EXrOO4iaqzTtwrshXGtdKc4/MbZxpkUf41dFcUMqctcPnUpZROl/ZFiql5li0OKu6Cy5dN9pNpmfQEBWqHJ6ag54JMpC42tFNsD9ZOtHgxw9NTmA75STo1O0HklYjepkSt2l9Q/pJ7YM9IXKe4CuihVH4wLWG6hkZ7uNDR9uQNhQPTQ6+CTrwF0uWaTZ/UGwtvf4DwiL1JenOILKub4RqmgsNzAILy00RiBYBX4csHqcEwVLIhNojyZunwMkEj74Kifx3y6U76Tze9MvfD+vE937wiHl8B7Defsr+/ACgPvTQV9DhaP0Ash6MyOPRRUcxmbk0fHfh67E00XmHLOL4WE3IHpBq+stBkqKq/KHKQiWameo0nLea2HOikbYiODLpdIWmOGk+7fHxeRspDHYqXBOyq5TBInuHcx6FKG9VqirfMfzmg6keiSoMzPqk/T8mjTM4KOOE8dpUv4vx+0oYIx+B5MUP7dCUc7RN9e672Mthm7RYTUHQo1MAHeO0+/Oo7qlp41DW2XhlwDUQZTc3ya/JV2b0LsTTQhfVzpWMOFxlXeM7BBZuCAXkd5s/dY14lnGydGB2iFtHPt+PQr+bZNWaC8PjuIpNpyCUz6IlqFr86z3X0zUPZEgY/9mFsIMtX/7ZOX54B+vOnRBi2uNVx0uaSXmRPdoDxUd/Fk3CC12WNjvzJR03dla1WusIU2Ir/vCi7yX4DQiCMzeOYR/f06+f73P0+ms+k=";
var $07144aea14354eb9$var$base64DeflatedTrie = "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";
// we may be running in a browser so we make an Uint8Array
var $07144aea14354eb9$var$data = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedData))));
var $07144aea14354eb9$var$trieData = (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedTrie));
var $07144aea14354eb9$var$trie = new $07144aea14354eb9$var$unicodeTrie($07144aea14354eb9$var$trieData);
var $07144aea14354eb9$var$log2 = Math.log2 || function(n) {
    return Math.log(n) / Math.LN2;
};
var $07144aea14354eb9$var$bits = function bits(n) {
    return $07144aea14354eb9$var$log2(n) + 1 | 0;
}; // compute the number of bits stored for each field
var $07144aea14354eb9$var$CATEGORY_BITS = $07144aea14354eb9$var$bits($07144aea14354eb9$var$data.categories.length - 1);
var $07144aea14354eb9$var$COMBINING_BITS = $07144aea14354eb9$var$bits($07144aea14354eb9$var$data.combiningClasses.length - 1);
var $07144aea14354eb9$var$SCRIPT_BITS = $07144aea14354eb9$var$bits($07144aea14354eb9$var$data.scripts.length - 1);
var $07144aea14354eb9$var$EAW_BITS = $07144aea14354eb9$var$bits($07144aea14354eb9$var$data.eaw.length - 1);
var $07144aea14354eb9$var$NUMBER_BITS = 10; // compute shift and mask values for each field
var $07144aea14354eb9$var$CATEGORY_SHIFT = $07144aea14354eb9$var$COMBINING_BITS + $07144aea14354eb9$var$SCRIPT_BITS + $07144aea14354eb9$var$EAW_BITS + $07144aea14354eb9$var$NUMBER_BITS;
var $07144aea14354eb9$var$COMBINING_SHIFT = $07144aea14354eb9$var$SCRIPT_BITS + $07144aea14354eb9$var$EAW_BITS + $07144aea14354eb9$var$NUMBER_BITS;
var $07144aea14354eb9$var$SCRIPT_SHIFT = $07144aea14354eb9$var$EAW_BITS + $07144aea14354eb9$var$NUMBER_BITS;
var $07144aea14354eb9$var$EAW_SHIFT = $07144aea14354eb9$var$NUMBER_BITS;
var $07144aea14354eb9$var$CATEGORY_MASK = (1 << $07144aea14354eb9$var$CATEGORY_BITS) - 1;
var $07144aea14354eb9$var$COMBINING_MASK = (1 << $07144aea14354eb9$var$COMBINING_BITS) - 1;
var $07144aea14354eb9$var$SCRIPT_MASK = (1 << $07144aea14354eb9$var$SCRIPT_BITS) - 1;
var $07144aea14354eb9$var$EAW_MASK = (1 << $07144aea14354eb9$var$EAW_BITS) - 1;
var $07144aea14354eb9$var$NUMBER_MASK = (1 << $07144aea14354eb9$var$NUMBER_BITS) - 1;
var $07144aea14354eb9$var$getCategory = function getCategory(codePoint) {
    var val = $07144aea14354eb9$var$trie.get(codePoint);
    return $07144aea14354eb9$var$data.categories[val >> $07144aea14354eb9$var$CATEGORY_SHIFT & $07144aea14354eb9$var$CATEGORY_MASK];
};
var $07144aea14354eb9$var$getCombiningClass = function getCombiningClass(codePoint) {
    var val = $07144aea14354eb9$var$trie.get(codePoint);
    return $07144aea14354eb9$var$data.combiningClasses[val >> $07144aea14354eb9$var$COMBINING_SHIFT & $07144aea14354eb9$var$COMBINING_MASK];
};
var $07144aea14354eb9$var$getScript = function getScript(codePoint) {
    var val = $07144aea14354eb9$var$trie.get(codePoint);
    return $07144aea14354eb9$var$data.scripts[val >> $07144aea14354eb9$var$SCRIPT_SHIFT & $07144aea14354eb9$var$SCRIPT_MASK];
};
var $07144aea14354eb9$var$getEastAsianWidth = function getEastAsianWidth(codePoint) {
    var val = $07144aea14354eb9$var$trie.get(codePoint);
    return $07144aea14354eb9$var$data.eaw[val >> $07144aea14354eb9$var$EAW_SHIFT & $07144aea14354eb9$var$EAW_MASK];
};
var $07144aea14354eb9$var$getNumericValue = function getNumericValue(codePoint) {
    var val = $07144aea14354eb9$var$trie.get(codePoint);
    var num = val & $07144aea14354eb9$var$NUMBER_MASK;
    if (num === 0) return null;
    else if (num <= 50) return num - 1;
    else if (num < 0x1e0) {
        var numerator = (num >> 4) - 12;
        var denominator = (num & 0xf) + 1;
        return numerator / denominator;
    } else if (num < 0x300) {
        val = (num >> 5) - 14;
        var exp = (num & 0x1f) + 2;
        while(exp > 0){
            val *= 10;
            exp--;
        }
        return val;
    } else {
        val = (num >> 2) - 0xbf;
        var _exp = (num & 3) + 1;
        while(_exp > 0){
            val *= 60;
            _exp--;
        }
        return val;
    }
};
var $07144aea14354eb9$var$isAlphabetic = function isAlphabetic(codePoint) {
    var category = $07144aea14354eb9$var$getCategory(codePoint);
    return category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Nl';
};
var $07144aea14354eb9$var$isDigit = function isDigit(codePoint) {
    return $07144aea14354eb9$var$getCategory(codePoint) === 'Nd';
};
var $07144aea14354eb9$var$isPunctuation = function isPunctuation(codePoint) {
    var category = $07144aea14354eb9$var$getCategory(codePoint);
    return category === 'Pc' || category === 'Pd' || category === 'Pe' || category === 'Pf' || category === 'Pi' || category === 'Po' || category === 'Ps';
};
var $07144aea14354eb9$var$isLowerCase = function isLowerCase(codePoint) {
    return $07144aea14354eb9$var$getCategory(codePoint) === 'Ll';
};
var $07144aea14354eb9$var$isUpperCase = function isUpperCase(codePoint) {
    return $07144aea14354eb9$var$getCategory(codePoint) === 'Lu';
};
var $07144aea14354eb9$var$isTitleCase = function isTitleCase(codePoint) {
    return $07144aea14354eb9$var$getCategory(codePoint) === 'Lt';
};
var $07144aea14354eb9$var$isWhiteSpace = function isWhiteSpace(codePoint) {
    var category = $07144aea14354eb9$var$getCategory(codePoint);
    return category === 'Zs' || category === 'Zl' || category === 'Zp';
};
var $07144aea14354eb9$var$isBaseForm = function isBaseForm(codePoint) {
    var category = $07144aea14354eb9$var$getCategory(codePoint);
    return category === 'Nd' || category === 'No' || category === 'Nl' || category === 'Lu' || category === 'Ll' || category === 'Lt' || category === 'Lm' || category === 'Lo' || category === 'Me' || category === 'Mc';
};
var $07144aea14354eb9$var$isMark = function isMark(codePoint) {
    var category = $07144aea14354eb9$var$getCategory(codePoint);
    return category === 'Mn' || category === 'Me' || category === 'Mc';
};
var $07144aea14354eb9$var$unicode = {
    getCategory: $07144aea14354eb9$var$getCategory,
    getCombiningClass: $07144aea14354eb9$var$getCombiningClass,
    getScript: $07144aea14354eb9$var$getScript,
    getEastAsianWidth: $07144aea14354eb9$var$getEastAsianWidth,
    getNumericValue: $07144aea14354eb9$var$getNumericValue,
    isAlphabetic: $07144aea14354eb9$var$isAlphabetic,
    isDigit: $07144aea14354eb9$var$isDigit,
    isPunctuation: $07144aea14354eb9$var$isPunctuation,
    isLowerCase: $07144aea14354eb9$var$isLowerCase,
    isUpperCase: $07144aea14354eb9$var$isUpperCase,
    isTitleCase: $07144aea14354eb9$var$isTitleCase,
    isWhiteSpace: $07144aea14354eb9$var$isWhiteSpace,
    isBaseForm: $07144aea14354eb9$var$isBaseForm,
    isMark: $07144aea14354eb9$var$isMark
};
/**
 * This class is used when GPOS does not define 'mark' or 'mkmk' features
 * for positioning marks relative to base glyphs. It uses the unicode
 * combining class property to position marks.
 *
 * Based on code from Harfbuzz, thanks!
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-fallback.cc
 */ var $07144aea14354eb9$var$UnicodeLayoutEngine = /*#__PURE__*/ function() {
    function UnicodeLayoutEngine(font) {
        this.font = font;
    }
    var _proto = UnicodeLayoutEngine.prototype;
    _proto.positionGlyphs = function positionGlyphs(glyphs, positions) {
        // find each base + mark cluster, and position the marks relative to the base
        var clusterStart = 0;
        var clusterEnd = 0;
        for(var index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.isMark) // TODO: handle ligatures
            clusterEnd = index;
            else {
                if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
                clusterStart = clusterEnd = index;
            }
        }
        if (clusterStart !== clusterEnd) this.positionCluster(glyphs, positions, clusterStart, clusterEnd);
        return positions;
    };
    _proto.positionCluster = function positionCluster(glyphs, positions, clusterStart, clusterEnd) {
        var base = glyphs[clusterStart];
        var baseBox = base.cbox.copy(); // adjust bounding box for ligature glyphs
        if (base.codePoints.length > 1) // LTR. TODO: RTL support.
        baseBox.minX += (base.codePoints.length - 1) * baseBox.width / base.codePoints.length;
        var xOffset = -positions[clusterStart].xAdvance;
        var yOffset = 0;
        var yGap = this.font.unitsPerEm / 16; // position each of the mark glyphs relative to the base glyph
        for(var index = clusterStart + 1; index <= clusterEnd; index++){
            var mark = glyphs[index];
            var markBox = mark.cbox;
            var position = positions[index];
            var combiningClass = this.getCombiningClass(mark.codePoints[0]);
            if (combiningClass !== 'Not_Reordered') {
                position.xOffset = position.yOffset = 0; // x positioning
                switch(combiningClass){
                    case 'Double_Above':
                    case 'Double_Below':
                        // LTR. TODO: RTL support.
                        position.xOffset += baseBox.minX - markBox.width / 2 - markBox.minX;
                        break;
                    case 'Attached_Below_Left':
                    case 'Below_Left':
                    case 'Above_Left':
                        // left align
                        position.xOffset += baseBox.minX - markBox.minX;
                        break;
                    case 'Attached_Above_Right':
                    case 'Below_Right':
                    case 'Above_Right':
                        // right align
                        position.xOffset += baseBox.maxX - markBox.width - markBox.minX;
                        break;
                    default:
                        // Attached_Below, Attached_Above, Below, Above, other
                        // center align
                        position.xOffset += baseBox.minX + (baseBox.width - markBox.width) / 2 - markBox.minX;
                } // y positioning
                switch(combiningClass){
                    case 'Double_Below':
                    case 'Below_Left':
                    case 'Below':
                    case 'Below_Right':
                    case 'Attached_Below_Left':
                    case 'Attached_Below':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Below_Left' || combiningClass === 'Attached_Below') baseBox.minY += yGap;
                        position.yOffset = -baseBox.minY - markBox.maxY;
                        baseBox.minY += markBox.height;
                        break;
                    case 'Double_Above':
                    case 'Above_Left':
                    case 'Above':
                    case 'Above_Right':
                    case 'Attached_Above':
                    case 'Attached_Above_Right':
                        // add a small gap between the glyphs if they are not attached
                        if (combiningClass === 'Attached_Above' || combiningClass === 'Attached_Above_Right') baseBox.maxY += yGap;
                        position.yOffset = baseBox.maxY - markBox.minY;
                        baseBox.maxY += markBox.height;
                        break;
                }
                position.xAdvance = position.yAdvance = 0;
                position.xOffset += xOffset;
                position.yOffset += yOffset;
            } else {
                xOffset -= position.xAdvance;
                yOffset -= position.yAdvance;
            }
        }
        return;
    };
    _proto.getCombiningClass = function getCombiningClass(codePoint) {
        var combiningClass = $07144aea14354eb9$var$unicode.getCombiningClass(codePoint); // Thai / Lao need some per-character work
        if ((codePoint & -256) === 0x0e00) {
            if (combiningClass === 'Not_Reordered') switch(codePoint){
                case 0x0e31:
                case 0x0e34:
                case 0x0e35:
                case 0x0e36:
                case 0x0e37:
                case 0x0e47:
                case 0x0e4c:
                case 0x0e3d:
                case 0x0e4e:
                    return 'Above_Right';
                case 0x0eb1:
                case 0x0eb4:
                case 0x0eb5:
                case 0x0eb6:
                case 0x0eb7:
                case 0x0ebb:
                case 0x0ecc:
                case 0x0ecd:
                    return 'Above';
                case 0x0ebc:
                    return 'Below';
            }
            else if (codePoint === 0x0e3a) // virama
            return 'Below_Right';
        }
        switch(combiningClass){
            // Hebrew
            case 'CCC10':
            case 'CCC11':
            case 'CCC12':
            case 'CCC13':
            case 'CCC14':
            case 'CCC15':
            case 'CCC16':
            case 'CCC17':
            case 'CCC18':
            case 'CCC20':
            case 'CCC22':
                // meteg
                return 'Below';
            case 'CCC23':
                // rafe
                return 'Attached_Above';
            case 'CCC24':
                // shin dot
                return 'Above_Right';
            case 'CCC25':
            case 'CCC19':
                // holam
                return 'Above_Left';
            case 'CCC26':
                // point varika
                return 'Above';
            case 'CCC21':
                break;
            // Arabic and Syriac
            case 'CCC27':
            case 'CCC28':
            case 'CCC30':
            case 'CCC31':
            case 'CCC33':
            case 'CCC34':
            case 'CCC35':
            case 'CCC36':
                // superscript alaph
                return 'Above';
            case 'CCC29':
            case 'CCC32':
                // kasra
                return 'Below';
            // Thai
            case 'CCC103':
                // sara u / sara uu
                return 'Below_Right';
            case 'CCC107':
                // mai
                return 'Above_Right';
            // Lao
            case 'CCC118':
                // sign u / sign uu
                return 'Below';
            case 'CCC122':
                // mai
                return 'Above';
            // Tibetan
            case 'CCC129':
            case 'CCC132':
                // sign u
                return 'Below';
            case 'CCC130':
                // sign i
                return 'Above';
        }
        return combiningClass;
    };
    return UnicodeLayoutEngine;
}();
function $07144aea14354eb9$var$_defineProperties$1(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$1(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$1(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$1(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents a glyph bounding box
 */ var $07144aea14354eb9$var$BBox = /*#__PURE__*/ function() {
    function BBox(minX, minY, maxX, maxY) {
        if (minX === void 0) minX = Infinity;
        if (minY === void 0) minY = Infinity;
        if (maxX === void 0) maxX = -Infinity;
        if (maxY === void 0) maxY = -Infinity;
        /**
     * The minimum X position in the bounding box
     * @type {number}
     */ this.minX = minX;
        /**
     * The minimum Y position in the bounding box
     * @type {number}
     */ this.minY = minY;
        /**
     * The maxmimum X position in the bounding box
     * @type {number}
     */ this.maxX = maxX;
        /**
     * The maxmimum Y position in the bounding box
     * @type {number}
     */ this.maxY = maxY;
    }
    /**
   * The width of the bounding box
   * @type {number}
   */ var _proto = BBox.prototype;
    _proto.addPoint = function addPoint(x, y) {
        if (Math.abs(x) !== Infinity) {
            if (x < this.minX) this.minX = x;
            if (x > this.maxX) this.maxX = x;
        }
        if (Math.abs(y) !== Infinity) {
            if (y < this.minY) this.minY = y;
            if (y > this.maxY) this.maxY = y;
        }
    };
    _proto.copy = function copy() {
        return new BBox(this.minX, this.minY, this.maxX, this.maxY);
    };
    $07144aea14354eb9$var$_createClass$1(BBox, [
        {
            key: "width",
            get: function get() {
                return this.maxX - this.minX;
            }
        },
        {
            key: "height",
            get: function get() {
                return this.maxY - this.minY;
            }
        }
    ]);
    return BBox;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$6(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$6(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$6(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$6(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$6(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$6(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
// Data from http://www.microsoft.com/typography/otspec/scripttags.htm
// and http://www.unicode.org/Public/UNIDATA/PropertyValueAliases.txt.
var $07144aea14354eb9$var$UNICODE_SCRIPTS = {
    Caucasian_Albanian: 'aghb',
    Arabic: 'arab',
    Imperial_Aramaic: 'armi',
    Armenian: 'armn',
    Avestan: 'avst',
    Balinese: 'bali',
    Bamum: 'bamu',
    Bassa_Vah: 'bass',
    Batak: 'batk',
    Bengali: [
        'bng2',
        'beng'
    ],
    Bopomofo: 'bopo',
    Brahmi: 'brah',
    Braille: 'brai',
    Buginese: 'bugi',
    Buhid: 'buhd',
    Chakma: 'cakm',
    Canadian_Aboriginal: 'cans',
    Carian: 'cari',
    Cham: 'cham',
    Cherokee: 'cher',
    Coptic: 'copt',
    Cypriot: 'cprt',
    Cyrillic: 'cyrl',
    Devanagari: [
        'dev2',
        'deva'
    ],
    Deseret: 'dsrt',
    Duployan: 'dupl',
    Egyptian_Hieroglyphs: 'egyp',
    Elbasan: 'elba',
    Ethiopic: 'ethi',
    Georgian: 'geor',
    Glagolitic: 'glag',
    Gothic: 'goth',
    Grantha: 'gran',
    Greek: 'grek',
    Gujarati: [
        'gjr2',
        'gujr'
    ],
    Gurmukhi: [
        'gur2',
        'guru'
    ],
    Hangul: 'hang',
    Han: 'hani',
    Hanunoo: 'hano',
    Hebrew: 'hebr',
    Hiragana: 'hira',
    Pahawh_Hmong: 'hmng',
    Katakana_Or_Hiragana: 'hrkt',
    Old_Italic: 'ital',
    Javanese: 'java',
    Kayah_Li: 'kali',
    Katakana: 'kana',
    Kharoshthi: 'khar',
    Khmer: 'khmr',
    Khojki: 'khoj',
    Kannada: [
        'knd2',
        'knda'
    ],
    Kaithi: 'kthi',
    Tai_Tham: 'lana',
    Lao: 'lao ',
    Latin: 'latn',
    Lepcha: 'lepc',
    Limbu: 'limb',
    Linear_A: 'lina',
    Linear_B: 'linb',
    Lisu: 'lisu',
    Lycian: 'lyci',
    Lydian: 'lydi',
    Mahajani: 'mahj',
    Mandaic: 'mand',
    Manichaean: 'mani',
    Mende_Kikakui: 'mend',
    Meroitic_Cursive: 'merc',
    Meroitic_Hieroglyphs: 'mero',
    Malayalam: [
        'mlm2',
        'mlym'
    ],
    Modi: 'modi',
    Mongolian: 'mong',
    Mro: 'mroo',
    Meetei_Mayek: 'mtei',
    Myanmar: [
        'mym2',
        'mymr'
    ],
    Old_North_Arabian: 'narb',
    Nabataean: 'nbat',
    Nko: 'nko ',
    Ogham: 'ogam',
    Ol_Chiki: 'olck',
    Old_Turkic: 'orkh',
    Oriya: [
        'ory2',
        'orya'
    ],
    Osmanya: 'osma',
    Palmyrene: 'palm',
    Pau_Cin_Hau: 'pauc',
    Old_Permic: 'perm',
    Phags_Pa: 'phag',
    Inscriptional_Pahlavi: 'phli',
    Psalter_Pahlavi: 'phlp',
    Phoenician: 'phnx',
    Miao: 'plrd',
    Inscriptional_Parthian: 'prti',
    Rejang: 'rjng',
    Runic: 'runr',
    Samaritan: 'samr',
    Old_South_Arabian: 'sarb',
    Saurashtra: 'saur',
    Shavian: 'shaw',
    Sharada: 'shrd',
    Siddham: 'sidd',
    Khudawadi: 'sind',
    Sinhala: 'sinh',
    Sora_Sompeng: 'sora',
    Sundanese: 'sund',
    Syloti_Nagri: 'sylo',
    Syriac: 'syrc',
    Tagbanwa: 'tagb',
    Takri: 'takr',
    Tai_Le: 'tale',
    New_Tai_Lue: 'talu',
    Tamil: [
        'tml2',
        'taml'
    ],
    Tai_Viet: 'tavt',
    Telugu: [
        'tel2',
        'telu'
    ],
    Tifinagh: 'tfng',
    Tagalog: 'tglg',
    Thaana: 'thaa',
    Thai: 'thai',
    Tibetan: 'tibt',
    Tirhuta: 'tirh',
    Ugaritic: 'ugar',
    Vai: 'vai ',
    Warang_Citi: 'wara',
    Old_Persian: 'xpeo',
    Cuneiform: 'xsux',
    Yi: 'yi  ',
    Inherited: 'zinh',
    Common: 'zyyy',
    Unknown: 'zzzz'
};
var $07144aea14354eb9$var$OPENTYPE_SCRIPTS = {};
for(var $07144aea14354eb9$var$script in $07144aea14354eb9$var$UNICODE_SCRIPTS){
    var $07144aea14354eb9$var$tag = $07144aea14354eb9$var$UNICODE_SCRIPTS[$07144aea14354eb9$var$script];
    if (Array.isArray($07144aea14354eb9$var$tag)) for(var $07144aea14354eb9$var$_iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$6($07144aea14354eb9$var$tag), $07144aea14354eb9$var$_step; !($07144aea14354eb9$var$_step = $07144aea14354eb9$var$_iterator()).done;){
        var $07144aea14354eb9$var$t = $07144aea14354eb9$var$_step.value;
        $07144aea14354eb9$var$OPENTYPE_SCRIPTS[$07144aea14354eb9$var$t] = $07144aea14354eb9$var$script;
    }
    else $07144aea14354eb9$var$OPENTYPE_SCRIPTS[$07144aea14354eb9$var$tag] = $07144aea14354eb9$var$script;
}
function $07144aea14354eb9$var$fromOpenType(tag) {
    return $07144aea14354eb9$var$OPENTYPE_SCRIPTS[tag];
}
function $07144aea14354eb9$var$forString(string) {
    var len = string.length;
    var idx = 0;
    while(idx < len){
        var code = string.charCodeAt(idx++); // Check if this is a high surrogate
        if (0xd800 <= code && code <= 0xdbff && idx < len) {
            var next = string.charCodeAt(idx); // Check if this is a low surrogate
            if (0xdc00 <= next && next <= 0xdfff) {
                idx++;
                code = ((code & 0x3FF) << 10) + (next & 0x3FF) + 0x10000;
            }
        }
        var _script = $07144aea14354eb9$var$unicode.getScript(code);
        if (_script !== 'Common' && _script !== 'Inherited' && _script !== 'Unknown') return $07144aea14354eb9$var$UNICODE_SCRIPTS[_script];
    }
    return $07144aea14354eb9$var$UNICODE_SCRIPTS.Unknown;
}
function $07144aea14354eb9$var$forCodePoints(codePoints) {
    for(var i = 0; i < codePoints.length; i++){
        var codePoint = codePoints[i];
        var _script2 = $07144aea14354eb9$var$unicode.getScript(codePoint);
        if (_script2 !== 'Common' && _script2 !== 'Inherited' && _script2 !== 'Unknown') return $07144aea14354eb9$var$UNICODE_SCRIPTS[_script2];
    }
    return $07144aea14354eb9$var$UNICODE_SCRIPTS.Unknown;
} // The scripts in this map are written from right to left
var $07144aea14354eb9$var$RTL = {
    arab: true,
    // Arabic
    hebr: true,
    // Hebrew
    syrc: true,
    // Syriac
    thaa: true,
    // Thaana
    cprt: true,
    // Cypriot Syllabary
    khar: true,
    // Kharosthi
    phnx: true,
    // Phoenician
    'nko ': true,
    // N'Ko
    lydi: true,
    // Lydian
    avst: true,
    // Avestan
    armi: true,
    // Imperial Aramaic
    phli: true,
    // Inscriptional Pahlavi
    prti: true,
    // Inscriptional Parthian
    sarb: true,
    // Old South Arabian
    orkh: true,
    // Old Turkic, Orkhon Runic
    samr: true,
    // Samaritan
    mand: true,
    // Mandaic, Mandaean
    merc: true,
    // Meroitic Cursive
    mero: true,
    // Meroitic Hieroglyphs
    // Unicode 7.0 (not listed on http://www.microsoft.com/typography/otspec/scripttags.htm)
    mani: true,
    // Manichaean
    mend: true,
    // Mende Kikakui
    nbat: true,
    // Nabataean
    narb: true,
    // Old North Arabian
    palm: true,
    // Palmyrene
    phlp: true // Psalter Pahlavi
};
function $07144aea14354eb9$var$direction(script) {
    if ($07144aea14354eb9$var$RTL[script]) return 'rtl';
    return 'ltr';
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$7(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$7(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$7(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$7(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$7(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$7(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$2(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$2(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$2(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$2(Constructor, staticProps);
    return Constructor;
}
/**
 * Represents a run of Glyph and GlyphPosition objects.
 * Returned by the font layout method.
 */ var $07144aea14354eb9$var$GlyphRun = /*#__PURE__*/ function() {
    function GlyphRun(glyphs, features, script, language, direction$1) {
        /**
     * An array of Glyph objects in the run
     * @type {Glyph[]}
     */ this.glyphs = glyphs;
        /**
     * An array of GlyphPosition objects for each glyph in the run
     * @type {GlyphPosition[]}
     */ this.positions = null;
        /**
     * The script that was requested for shaping. This was either passed in or detected automatically.
     * @type {string}
     */ this.script = script;
        /**
     * The language requested for shaping, as passed in. If `null`, the default language for the
     * script was used.
     * @type {string}
     */ this.language = language || null;
        /**
     * The direction requested for shaping, as passed in (either ltr or rtl).
     * If `null`, the default direction of the script is used.
     * @type {string}
     */ this.direction = direction$1 || $07144aea14354eb9$var$direction(script);
        /**
     * The features requested during shaping. This is a combination of user
     * specified features and features chosen by the shaper.
     * @type {object}
     */ this.features = {}; // Convert features to an object
        if (Array.isArray(features)) for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$7(features), _step; !(_step = _iterator()).done;){
            var tag = _step.value;
            this.features[tag] = true;
        }
        else if (typeof features === 'object') this.features = features;
    }
    /**
   * The total advance width of the run.
   * @type {number}
   */ $07144aea14354eb9$var$_createClass$2(GlyphRun, [
        {
            key: "advanceWidth",
            get: function get() {
                var width = 0;
                for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$7(this.positions), _step2; !(_step2 = _iterator2()).done;){
                    var position = _step2.value;
                    width += position.xAdvance;
                }
                return width;
            }
        },
        {
            key: "advanceHeight",
            get: function get() {
                var height = 0;
                for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$7(this.positions), _step3; !(_step3 = _iterator3()).done;){
                    var position = _step3.value;
                    height += position.yAdvance;
                }
                return height;
            }
        },
        {
            key: "bbox",
            get: function get() {
                var bbox = new $07144aea14354eb9$var$BBox();
                var x = 0;
                var y = 0;
                for(var index = 0; index < this.glyphs.length; index++){
                    var glyph = this.glyphs[index];
                    var p = this.positions[index];
                    var b = glyph.bbox;
                    bbox.addPoint(b.minX + x + p.xOffset, b.minY + y + p.yOffset);
                    bbox.addPoint(b.maxX + x + p.xOffset, b.maxY + y + p.yOffset);
                    x += p.xAdvance;
                    y += p.yAdvance;
                }
                return bbox;
            }
        }
    ]);
    return GlyphRun;
}();
/**
 * Represents positioning information for a glyph in a GlyphRun.
 */ var $07144aea14354eb9$var$GlyphPosition = function GlyphPosition(xAdvance, yAdvance, xOffset, yOffset) {
    if (xAdvance === void 0) xAdvance = 0;
    if (yAdvance === void 0) yAdvance = 0;
    if (xOffset === void 0) xOffset = 0;
    if (yOffset === void 0) yOffset = 0;
    /**
   * The amount to move the virtual pen in the X direction after rendering this glyph.
   * @type {number}
   */ this.xAdvance = xAdvance;
    /**
   * The amount to move the virtual pen in the Y direction after rendering this glyph.
   * @type {number}
   */ this.yAdvance = yAdvance;
    /**
   * The offset from the pen position in the X direction at which to render this glyph.
   * @type {number}
   */ this.xOffset = xOffset;
    /**
   * The offset from the pen position in the Y direction at which to render this glyph.
   * @type {number}
   */ this.yOffset = yOffset;
};
// see https://developer.apple.com/fonts/TrueType-Reference-Manual/RM09/AppendixF.html
// and /System/Library/Frameworks/CoreText.framework/Versions/A/Headers/SFNTLayoutTypes.h on a Mac
var $07144aea14354eb9$var$features = {
    allTypographicFeatures: {
        code: 0,
        exclusive: false,
        allTypeFeatures: 0
    },
    ligatures: {
        code: 1,
        exclusive: false,
        requiredLigatures: 0,
        commonLigatures: 2,
        rareLigatures: 4,
        // logos: 6
        rebusPictures: 8,
        diphthongLigatures: 10,
        squaredLigatures: 12,
        abbrevSquaredLigatures: 14,
        symbolLigatures: 16,
        contextualLigatures: 18,
        historicalLigatures: 20
    },
    cursiveConnection: {
        code: 2,
        exclusive: true,
        unconnected: 0,
        partiallyConnected: 1,
        cursive: 2
    },
    letterCase: {
        code: 3,
        exclusive: true
    },
    // upperAndLowerCase: 0          # deprecated
    // allCaps: 1                    # deprecated
    // allLowerCase: 2               # deprecated
    // smallCaps: 3                  # deprecated
    // initialCaps: 4                # deprecated
    // initialCapsAndSmallCaps: 5    # deprecated
    verticalSubstitution: {
        code: 4,
        exclusive: false,
        substituteVerticalForms: 0
    },
    linguisticRearrangement: {
        code: 5,
        exclusive: false,
        linguisticRearrangement: 0
    },
    numberSpacing: {
        code: 6,
        exclusive: true,
        monospacedNumbers: 0,
        proportionalNumbers: 1,
        thirdWidthNumbers: 2,
        quarterWidthNumbers: 3
    },
    smartSwash: {
        code: 8,
        exclusive: false,
        wordInitialSwashes: 0,
        wordFinalSwashes: 2,
        // lineInitialSwashes: 4
        // lineFinalSwashes: 6
        nonFinalSwashes: 8
    },
    diacritics: {
        code: 9,
        exclusive: true,
        showDiacritics: 0,
        hideDiacritics: 1,
        decomposeDiacritics: 2
    },
    verticalPosition: {
        code: 10,
        exclusive: true,
        normalPosition: 0,
        superiors: 1,
        inferiors: 2,
        ordinals: 3,
        scientificInferiors: 4
    },
    fractions: {
        code: 11,
        exclusive: true,
        noFractions: 0,
        verticalFractions: 1,
        diagonalFractions: 2
    },
    overlappingCharacters: {
        code: 13,
        exclusive: false,
        preventOverlap: 0
    },
    typographicExtras: {
        code: 14,
        exclusive: false,
        // hyphensToEmDash: 0
        // hyphenToEnDash: 2
        slashedZero: 4
    },
    // formInterrobang: 6
    // smartQuotes: 8
    // periodsToEllipsis: 10
    mathematicalExtras: {
        code: 15,
        exclusive: false,
        // hyphenToMinus: 0
        // asteristoMultiply: 2
        // slashToDivide: 4
        // inequalityLigatures: 6
        // exponents: 8
        mathematicalGreek: 10
    },
    ornamentSets: {
        code: 16,
        exclusive: true,
        noOrnaments: 0,
        dingbats: 1,
        piCharacters: 2,
        fleurons: 3,
        decorativeBorders: 4,
        internationalSymbols: 5,
        mathSymbols: 6
    },
    characterAlternatives: {
        code: 17,
        exclusive: true,
        noAlternates: 0
    },
    // user defined options
    designComplexity: {
        code: 18,
        exclusive: true,
        designLevel1: 0,
        designLevel2: 1,
        designLevel3: 2,
        designLevel4: 3,
        designLevel5: 4
    },
    styleOptions: {
        code: 19,
        exclusive: true,
        noStyleOptions: 0,
        displayText: 1,
        engravedText: 2,
        illuminatedCaps: 3,
        titlingCaps: 4,
        tallCaps: 5
    },
    characterShape: {
        code: 20,
        exclusive: true,
        traditionalCharacters: 0,
        simplifiedCharacters: 1,
        JIS1978Characters: 2,
        JIS1983Characters: 3,
        JIS1990Characters: 4,
        traditionalAltOne: 5,
        traditionalAltTwo: 6,
        traditionalAltThree: 7,
        traditionalAltFour: 8,
        traditionalAltFive: 9,
        expertCharacters: 10,
        JIS2004Characters: 11,
        hojoCharacters: 12,
        NLCCharacters: 13,
        traditionalNamesCharacters: 14
    },
    numberCase: {
        code: 21,
        exclusive: true,
        lowerCaseNumbers: 0,
        upperCaseNumbers: 1
    },
    textSpacing: {
        code: 22,
        exclusive: true,
        proportionalText: 0,
        monospacedText: 1,
        halfWidthText: 2,
        thirdWidthText: 3,
        quarterWidthText: 4,
        altProportionalText: 5,
        altHalfWidthText: 6
    },
    transliteration: {
        code: 23,
        exclusive: true,
        noTransliteration: 0
    },
    // hanjaToHangul: 1
    // hiraganaToKatakana: 2
    // katakanaToHiragana: 3
    // kanaToRomanization: 4
    // romanizationToHiragana: 5
    // romanizationToKatakana: 6
    // hanjaToHangulAltOne: 7
    // hanjaToHangulAltTwo: 8
    // hanjaToHangulAltThree: 9
    annotation: {
        code: 24,
        exclusive: true,
        noAnnotation: 0,
        boxAnnotation: 1,
        roundedBoxAnnotation: 2,
        circleAnnotation: 3,
        invertedCircleAnnotation: 4,
        parenthesisAnnotation: 5,
        periodAnnotation: 6,
        romanNumeralAnnotation: 7,
        diamondAnnotation: 8,
        invertedBoxAnnotation: 9,
        invertedRoundedBoxAnnotation: 10
    },
    kanaSpacing: {
        code: 25,
        exclusive: true,
        fullWidthKana: 0,
        proportionalKana: 1
    },
    ideographicSpacing: {
        code: 26,
        exclusive: true,
        fullWidthIdeographs: 0,
        proportionalIdeographs: 1,
        halfWidthIdeographs: 2
    },
    unicodeDecomposition: {
        code: 27,
        exclusive: false,
        canonicalComposition: 0,
        compatibilityComposition: 2,
        transcodingComposition: 4
    },
    rubyKana: {
        code: 28,
        exclusive: false,
        // noRubyKana: 0     # deprecated - use rubyKanaOff instead
        // rubyKana: 1     # deprecated - use rubyKanaOn instead
        rubyKana: 2
    },
    CJKSymbolAlternatives: {
        code: 29,
        exclusive: true,
        noCJKSymbolAlternatives: 0,
        CJKSymbolAltOne: 1,
        CJKSymbolAltTwo: 2,
        CJKSymbolAltThree: 3,
        CJKSymbolAltFour: 4,
        CJKSymbolAltFive: 5
    },
    ideographicAlternatives: {
        code: 30,
        exclusive: true,
        noIdeographicAlternatives: 0,
        ideographicAltOne: 1,
        ideographicAltTwo: 2,
        ideographicAltThree: 3,
        ideographicAltFour: 4,
        ideographicAltFive: 5
    },
    CJKVerticalRomanPlacement: {
        code: 31,
        exclusive: true,
        CJKVerticalRomanCentered: 0,
        CJKVerticalRomanHBaseline: 1
    },
    italicCJKRoman: {
        code: 32,
        exclusive: false,
        // noCJKItalicRoman: 0     # deprecated - use CJKItalicRomanOff instead
        // CJKItalicRoman: 1     # deprecated - use CJKItalicRomanOn instead
        CJKItalicRoman: 2
    },
    caseSensitiveLayout: {
        code: 33,
        exclusive: false,
        caseSensitiveLayout: 0,
        caseSensitiveSpacing: 2
    },
    alternateKana: {
        code: 34,
        exclusive: false,
        alternateHorizKana: 0,
        alternateVertKana: 2
    },
    stylisticAlternatives: {
        code: 35,
        exclusive: false,
        noStylisticAlternates: 0,
        stylisticAltOne: 2,
        stylisticAltTwo: 4,
        stylisticAltThree: 6,
        stylisticAltFour: 8,
        stylisticAltFive: 10,
        stylisticAltSix: 12,
        stylisticAltSeven: 14,
        stylisticAltEight: 16,
        stylisticAltNine: 18,
        stylisticAltTen: 20,
        stylisticAltEleven: 22,
        stylisticAltTwelve: 24,
        stylisticAltThirteen: 26,
        stylisticAltFourteen: 28,
        stylisticAltFifteen: 30,
        stylisticAltSixteen: 32,
        stylisticAltSeventeen: 34,
        stylisticAltEighteen: 36,
        stylisticAltNineteen: 38,
        stylisticAltTwenty: 40
    },
    contextualAlternates: {
        code: 36,
        exclusive: false,
        contextualAlternates: 0,
        swashAlternates: 2,
        contextualSwashAlternates: 4
    },
    lowerCase: {
        code: 37,
        exclusive: true,
        defaultLowerCase: 0,
        lowerCaseSmallCaps: 1,
        lowerCasePetiteCaps: 2
    },
    upperCase: {
        code: 38,
        exclusive: true,
        defaultUpperCase: 0,
        upperCaseSmallCaps: 1,
        upperCasePetiteCaps: 2
    },
    languageTag: {
        // indices into ltag table
        code: 39,
        exclusive: true
    },
    CJKRomanSpacing: {
        code: 103,
        exclusive: true,
        halfWidthCJKRoman: 0,
        proportionalCJKRoman: 1,
        defaultCJKRoman: 2,
        fullWidthCJKRoman: 3
    }
};
var $07144aea14354eb9$var$feature = function feature(name, selector) {
    return [
        $07144aea14354eb9$var$features[name].code,
        $07144aea14354eb9$var$features[name][selector]
    ];
};
var $07144aea14354eb9$var$OTMapping = {
    rlig: $07144aea14354eb9$var$feature('ligatures', 'requiredLigatures'),
    clig: $07144aea14354eb9$var$feature('ligatures', 'contextualLigatures'),
    dlig: $07144aea14354eb9$var$feature('ligatures', 'rareLigatures'),
    hlig: $07144aea14354eb9$var$feature('ligatures', 'historicalLigatures'),
    liga: $07144aea14354eb9$var$feature('ligatures', 'commonLigatures'),
    hist: $07144aea14354eb9$var$feature('ligatures', 'historicalLigatures'),
    // ??
    smcp: $07144aea14354eb9$var$feature('lowerCase', 'lowerCaseSmallCaps'),
    pcap: $07144aea14354eb9$var$feature('lowerCase', 'lowerCasePetiteCaps'),
    frac: $07144aea14354eb9$var$feature('fractions', 'diagonalFractions'),
    dnom: $07144aea14354eb9$var$feature('fractions', 'diagonalFractions'),
    // ??
    numr: $07144aea14354eb9$var$feature('fractions', 'diagonalFractions'),
    // ??
    afrc: $07144aea14354eb9$var$feature('fractions', 'verticalFractions'),
    // aalt
    // abvf, abvm, abvs, akhn, blwf, blwm, blws, cfar, cjct, cpsp, falt, isol, jalt, ljmo, mset?
    // ltra, ltrm, nukt, pref, pres, pstf, psts, rand, rkrf, rphf, rtla, rtlm, size, tjmo, tnum?
    // unic, vatu, vhal, vjmo, vpal, vrt2
    // dist -> trak table?
    // kern, vkrn -> kern table
    // lfbd + opbd + rtbd -> opbd table?
    // mark, mkmk -> acnt table?
    // locl -> languageTag + ltag table
    "case": $07144aea14354eb9$var$feature('caseSensitiveLayout', 'caseSensitiveLayout'),
    // also caseSensitiveSpacing
    ccmp: $07144aea14354eb9$var$feature('unicodeDecomposition', 'canonicalComposition'),
    // compatibilityComposition?
    cpct: $07144aea14354eb9$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    // guess..., probably not given below
    valt: $07144aea14354eb9$var$feature('CJKVerticalRomanPlacement', 'CJKVerticalRomanCentered'),
    swsh: $07144aea14354eb9$var$feature('contextualAlternates', 'swashAlternates'),
    cswh: $07144aea14354eb9$var$feature('contextualAlternates', 'contextualSwashAlternates'),
    curs: $07144aea14354eb9$var$feature('cursiveConnection', 'cursive'),
    // ??
    c2pc: $07144aea14354eb9$var$feature('upperCase', 'upperCasePetiteCaps'),
    c2sc: $07144aea14354eb9$var$feature('upperCase', 'upperCaseSmallCaps'),
    init: $07144aea14354eb9$var$feature('smartSwash', 'wordInitialSwashes'),
    // ??
    fin2: $07144aea14354eb9$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    medi: $07144aea14354eb9$var$feature('smartSwash', 'nonFinalSwashes'),
    // ??
    med2: $07144aea14354eb9$var$feature('smartSwash', 'nonFinalSwashes'),
    // ??
    fin3: $07144aea14354eb9$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    fina: $07144aea14354eb9$var$feature('smartSwash', 'wordFinalSwashes'),
    // ??
    pkna: $07144aea14354eb9$var$feature('kanaSpacing', 'proportionalKana'),
    half: $07144aea14354eb9$var$feature('textSpacing', 'halfWidthText'),
    // also HalfWidthCJKRoman, HalfWidthIdeographs?
    halt: $07144aea14354eb9$var$feature('textSpacing', 'altHalfWidthText'),
    hkna: $07144aea14354eb9$var$feature('alternateKana', 'alternateHorizKana'),
    vkna: $07144aea14354eb9$var$feature('alternateKana', 'alternateVertKana'),
    // hngl: feature 'transliteration', 'hanjaToHangulSelector' # deprecated
    ital: $07144aea14354eb9$var$feature('italicCJKRoman', 'CJKItalicRoman'),
    lnum: $07144aea14354eb9$var$feature('numberCase', 'upperCaseNumbers'),
    onum: $07144aea14354eb9$var$feature('numberCase', 'lowerCaseNumbers'),
    mgrk: $07144aea14354eb9$var$feature('mathematicalExtras', 'mathematicalGreek'),
    // nalt: not enough info. what type of annotation?
    // ornm: ditto, which ornament style?
    calt: $07144aea14354eb9$var$feature('contextualAlternates', 'contextualAlternates'),
    // or more?
    vrt2: $07144aea14354eb9$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    // oh... below?
    vert: $07144aea14354eb9$var$feature('verticalSubstitution', 'substituteVerticalForms'),
    tnum: $07144aea14354eb9$var$feature('numberSpacing', 'monospacedNumbers'),
    pnum: $07144aea14354eb9$var$feature('numberSpacing', 'proportionalNumbers'),
    sups: $07144aea14354eb9$var$feature('verticalPosition', 'superiors'),
    subs: $07144aea14354eb9$var$feature('verticalPosition', 'inferiors'),
    ordn: $07144aea14354eb9$var$feature('verticalPosition', 'ordinals'),
    pwid: $07144aea14354eb9$var$feature('textSpacing', 'proportionalText'),
    hwid: $07144aea14354eb9$var$feature('textSpacing', 'halfWidthText'),
    qwid: $07144aea14354eb9$var$feature('textSpacing', 'quarterWidthText'),
    // also QuarterWidthNumbers?
    twid: $07144aea14354eb9$var$feature('textSpacing', 'thirdWidthText'),
    // also ThirdWidthNumbers?
    fwid: $07144aea14354eb9$var$feature('textSpacing', 'proportionalText'),
    //??
    palt: $07144aea14354eb9$var$feature('textSpacing', 'altProportionalText'),
    trad: $07144aea14354eb9$var$feature('characterShape', 'traditionalCharacters'),
    smpl: $07144aea14354eb9$var$feature('characterShape', 'simplifiedCharacters'),
    jp78: $07144aea14354eb9$var$feature('characterShape', 'JIS1978Characters'),
    jp83: $07144aea14354eb9$var$feature('characterShape', 'JIS1983Characters'),
    jp90: $07144aea14354eb9$var$feature('characterShape', 'JIS1990Characters'),
    jp04: $07144aea14354eb9$var$feature('characterShape', 'JIS2004Characters'),
    expt: $07144aea14354eb9$var$feature('characterShape', 'expertCharacters'),
    hojo: $07144aea14354eb9$var$feature('characterShape', 'hojoCharacters'),
    nlck: $07144aea14354eb9$var$feature('characterShape', 'NLCCharacters'),
    tnam: $07144aea14354eb9$var$feature('characterShape', 'traditionalNamesCharacters'),
    ruby: $07144aea14354eb9$var$feature('rubyKana', 'rubyKana'),
    titl: $07144aea14354eb9$var$feature('styleOptions', 'titlingCaps'),
    zero: $07144aea14354eb9$var$feature('typographicExtras', 'slashedZero'),
    ss01: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltOne'),
    ss02: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltTwo'),
    ss03: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltThree'),
    ss04: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltFour'),
    ss05: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltFive'),
    ss06: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltSix'),
    ss07: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltSeven'),
    ss08: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltEight'),
    ss09: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltNine'),
    ss10: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltTen'),
    ss11: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltEleven'),
    ss12: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltTwelve'),
    ss13: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltThirteen'),
    ss14: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltFourteen'),
    ss15: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltFifteen'),
    ss16: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltSixteen'),
    ss17: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltSeventeen'),
    ss18: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltEighteen'),
    ss19: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltNineteen'),
    ss20: $07144aea14354eb9$var$feature('stylisticAlternatives', 'stylisticAltTwenty')
}; // salt: feature 'stylisticAlternatives', 'stylisticAltOne' # hmm, which one to choose
// Add cv01-cv99 features
for(var $07144aea14354eb9$var$i$3 = 1; $07144aea14354eb9$var$i$3 <= 99; $07144aea14354eb9$var$i$3++)$07144aea14354eb9$var$OTMapping["cv" + ("00" + $07144aea14354eb9$var$i$3).slice(-2)] = [
    $07144aea14354eb9$var$features.characterAlternatives.code,
    $07144aea14354eb9$var$i$3
];
 // create inverse mapping
var $07144aea14354eb9$var$AATMapping = {};
for(var $07144aea14354eb9$var$ot in $07144aea14354eb9$var$OTMapping){
    var $07144aea14354eb9$var$aat = $07144aea14354eb9$var$OTMapping[$07144aea14354eb9$var$ot];
    if ($07144aea14354eb9$var$AATMapping[$07144aea14354eb9$var$aat[0]] == null) $07144aea14354eb9$var$AATMapping[$07144aea14354eb9$var$aat[0]] = {};
    $07144aea14354eb9$var$AATMapping[$07144aea14354eb9$var$aat[0]][$07144aea14354eb9$var$aat[1]] = $07144aea14354eb9$var$ot;
} // Maps an array of OpenType features to AAT features
// in the form of {featureType:{featureSetting:true}}
function $07144aea14354eb9$var$mapOTToAAT(features) {
    var res = {};
    for(var k in features){
        var r = void 0;
        if (r = $07144aea14354eb9$var$OTMapping[k]) {
            if (res[r[0]] == null) res[r[0]] = {};
            res[r[0]][r[1]] = features[k];
        }
    }
    return res;
} // Maps strings in a [featureType, featureSetting]
// to their equivalent number codes
function $07144aea14354eb9$var$mapFeatureStrings(f) {
    var type = f[0], setting = f[1];
    if (isNaN(type)) var typeCode = $07144aea14354eb9$var$features[type] && $07144aea14354eb9$var$features[type].code;
    else var typeCode = type;
    if (isNaN(setting)) var settingCode = $07144aea14354eb9$var$features[type] && $07144aea14354eb9$var$features[type][setting];
    else var settingCode = setting;
    return [
        typeCode,
        settingCode
    ];
} // Maps AAT features to an array of OpenType features
// Supports both arrays in the form of [[featureType, featureSetting]]
// and objects in the form of {featureType:{featureSetting:true}}
// featureTypes and featureSettings can be either strings or number codes
function $07144aea14354eb9$var$mapAATToOT(features) {
    var res = {};
    if (Array.isArray(features)) for(var k = 0; k < features.length; k++){
        var r = void 0;
        var f = $07144aea14354eb9$var$mapFeatureStrings(features[k]);
        if (r = $07144aea14354eb9$var$AATMapping[f[0]] && $07144aea14354eb9$var$AATMapping[f[0]][f[1]]) res[r] = true;
    }
    else if (typeof features === 'object') for(var type in features){
        var _feature = features[type];
        for(var setting in _feature){
            var _r = void 0;
            var _f = $07144aea14354eb9$var$mapFeatureStrings([
                type,
                setting
            ]);
            if (_feature[setting] && (_r = $07144aea14354eb9$var$AATMapping[_f[0]] && $07144aea14354eb9$var$AATMapping[_f[0]][_f[1]])) res[_r] = true;
        }
    }
    return Object.keys(res);
}
var $07144aea14354eb9$var$_class$1;
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$8(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$8(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$8(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$8(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$8(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$8(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_applyDecoratedDescriptor$1(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $07144aea14354eb9$var$AATLookupTable = ($07144aea14354eb9$var$_class$1 = /*#__PURE__*/ function() {
    function AATLookupTable(table) {
        this.table = table;
    }
    var _proto = AATLookupTable.prototype;
    _proto.lookup = function lookup(glyph) {
        switch(this.table.version){
            case 0:
                // simple array format
                return this.table.values.getItem(glyph);
            case 2:
            case 4:
                var min = 0;
                var max = this.table.binarySearchHeader.nUnits - 1;
                while(min <= max){
                    var mid = min + max >> 1;
                    var seg = this.table.segments[mid]; // special end of search value
                    if (seg.firstGlyph === 0xffff) return null;
                    if (glyph < seg.firstGlyph) max = mid - 1;
                    else if (glyph > seg.lastGlyph) min = mid + 1;
                    else {
                        if (this.table.version === 2) return seg.value;
                        else return seg.values[glyph - seg.firstGlyph];
                    }
                }
                return null;
            case 6:
                // lookup single
                var _min = 0;
                var _max = this.table.binarySearchHeader.nUnits - 1;
                while(_min <= _max){
                    var mid = _min + _max >> 1;
                    var seg = this.table.segments[mid]; // special end of search value
                    if (seg.glyph === 0xffff) return null;
                    if (glyph < seg.glyph) _max = mid - 1;
                    else if (glyph > seg.glyph) _min = mid + 1;
                    else return seg.value;
                }
                return null;
            case 8:
                // lookup trimmed
                return this.table.values[glyph - this.table.firstGlyph];
            default:
                throw new Error("Unknown lookup table format: " + this.table.version);
        }
    };
    _proto.glyphsForValue = function glyphsForValue(classValue) {
        var res = [];
        switch(this.table.version){
            case 2:
            case 4:
                for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$8(this.table.segments), _step; !(_step = _iterator()).done;){
                    var segment = _step.value;
                    if (this.table.version === 2 && segment.value === classValue) res.push.apply(res, $07144aea14354eb9$var$range(segment.firstGlyph, segment.lastGlyph + 1));
                    else {
                        for(var index = 0; index < segment.values.length; index++)if (segment.values[index] === classValue) res.push(segment.firstGlyph + index);
                    }
                }
                break;
            case 6:
                // lookup single
                for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$8(this.table.segments), _step2; !(_step2 = _iterator2()).done;){
                    var _segment = _step2.value;
                    if (_segment.value === classValue) res.push(_segment.glyph);
                }
                break;
            case 8:
                // lookup trimmed
                for(var i = 0; i < this.table.values.length; i++)if (this.table.values[i] === classValue) res.push(this.table.firstGlyph + i);
                break;
            default:
                throw new Error("Unknown lookup table format: " + this.table.version);
        }
        return res;
    };
    return AATLookupTable;
}(), $07144aea14354eb9$var$_applyDecoratedDescriptor$1($07144aea14354eb9$var$_class$1.prototype, "glyphsForValue", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$1.prototype, "glyphsForValue"), $07144aea14354eb9$var$_class$1.prototype), $07144aea14354eb9$var$_class$1);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$9(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$9(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$9(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$9(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$9(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$9(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$START_OF_TEXT_STATE = 0;
var $07144aea14354eb9$var$END_OF_TEXT_CLASS = 0;
var $07144aea14354eb9$var$OUT_OF_BOUNDS_CLASS = 1;
var $07144aea14354eb9$var$DELETED_GLYPH_CLASS = 2;
var $07144aea14354eb9$var$DONT_ADVANCE = 0x4000;
var $07144aea14354eb9$var$AATStateMachine = /*#__PURE__*/ function() {
    function AATStateMachine(stateTable) {
        this.stateTable = stateTable;
        this.lookupTable = new $07144aea14354eb9$var$AATLookupTable(stateTable.classTable);
    }
    var _proto = AATStateMachine.prototype;
    _proto.process = function process(glyphs, reverse, processEntry) {
        var currentState = $07144aea14354eb9$var$START_OF_TEXT_STATE; // START_OF_LINE_STATE is used for kashida glyph insertions sometimes I think?
        var index = reverse ? glyphs.length - 1 : 0;
        var dir = reverse ? -1 : 1;
        while(dir === 1 && index <= glyphs.length || dir === -1 && index >= -1){
            var glyph = null;
            var classCode = $07144aea14354eb9$var$OUT_OF_BOUNDS_CLASS;
            var shouldAdvance = true;
            if (index === glyphs.length || index === -1) classCode = $07144aea14354eb9$var$END_OF_TEXT_CLASS;
            else {
                glyph = glyphs[index];
                if (glyph.id === 0xffff) // deleted glyph
                classCode = $07144aea14354eb9$var$DELETED_GLYPH_CLASS;
                else {
                    classCode = this.lookupTable.lookup(glyph.id);
                    if (classCode == null) classCode = $07144aea14354eb9$var$OUT_OF_BOUNDS_CLASS;
                }
            }
            var row = this.stateTable.stateArray.getItem(currentState);
            var entryIndex = row[classCode];
            var entry = this.stateTable.entryTable.getItem(entryIndex);
            if (classCode !== $07144aea14354eb9$var$END_OF_TEXT_CLASS && classCode !== $07144aea14354eb9$var$DELETED_GLYPH_CLASS) {
                processEntry(glyph, entry, index);
                shouldAdvance = !(entry.flags & $07144aea14354eb9$var$DONT_ADVANCE);
            }
            currentState = entry.newState;
            if (shouldAdvance) index += dir;
        }
        return glyphs;
    };
    _proto.traverse = function traverse(opts, state, visited) {
        if (state === void 0) state = 0;
        if (visited === void 0) visited = new Set();
        if (visited.has(state)) return;
        visited.add(state);
        var _this$stateTable = this.stateTable, nClasses = _this$stateTable.nClasses, stateArray = _this$stateTable.stateArray, entryTable = _this$stateTable.entryTable;
        var row = stateArray.getItem(state); // Skip predefined classes
        for(var classCode = 4; classCode < nClasses; classCode++){
            var entryIndex = row[classCode];
            var entry = entryTable.getItem(entryIndex); // Try all glyphs in the class
            for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$9(this.lookupTable.glyphsForValue(classCode)), _step; !(_step = _iterator()).done;){
                var glyph = _step.value;
                if (opts.enter) opts.enter(glyph, entry);
                if (entry.newState !== 0) this.traverse(opts, entry.newState, visited);
                if (opts.exit) opts.exit(glyph, entry);
            }
        }
    };
    return AATStateMachine;
}();
var $07144aea14354eb9$var$_class$2;
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$a(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$a(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$a(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$a(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$a(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_applyDecoratedDescriptor$2(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
var $07144aea14354eb9$var$MARK_FIRST = 0x8000;
var $07144aea14354eb9$var$MARK_LAST = 0x2000;
var $07144aea14354eb9$var$VERB = 0x000F; // contextual substitution and glyph insertion flag
var $07144aea14354eb9$var$SET_MARK = 0x8000; // ligature entry flags
var $07144aea14354eb9$var$SET_COMPONENT = 0x8000;
var $07144aea14354eb9$var$PERFORM_ACTION = 0x2000; // ligature action masks
var $07144aea14354eb9$var$LAST_MASK = 0x80000000;
var $07144aea14354eb9$var$STORE_MASK = 0x40000000;
var $07144aea14354eb9$var$OFFSET_MASK = 0x3FFFFFFF;
var $07144aea14354eb9$var$REVERSE_DIRECTION = 0x400000;
var $07144aea14354eb9$var$CURRENT_INSERT_BEFORE = 0x0800;
var $07144aea14354eb9$var$MARKED_INSERT_BEFORE = 0x0400;
var $07144aea14354eb9$var$CURRENT_INSERT_COUNT = 0x03E0;
var $07144aea14354eb9$var$MARKED_INSERT_COUNT = 0x001F;
var $07144aea14354eb9$var$AATMorxProcessor = ($07144aea14354eb9$var$_class$2 = /*#__PURE__*/ function() {
    function AATMorxProcessor(font) {
        this.processIndicRearragement = this.processIndicRearragement.bind(this);
        this.processContextualSubstitution = this.processContextualSubstitution.bind(this);
        this.processLigature = this.processLigature.bind(this);
        this.processNoncontextualSubstitutions = this.processNoncontextualSubstitutions.bind(this);
        this.processGlyphInsertion = this.processGlyphInsertion.bind(this);
        this.font = font;
        this.morx = font.morx;
        this.inputCache = null;
    } // Processes an array of glyphs and applies the specified features
    // Features should be in the form of {featureType:{featureSetting:true}}
    var _proto = AATMorxProcessor.prototype;
    _proto.process = function process(glyphs, features) {
        if (features === void 0) features = {};
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step; !(_step = _iterator()).done;){
            var chain = _step.value;
            var flags = chain.defaultFlags; // enable/disable the requested features
            for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(chain.features), _step2; !(_step2 = _iterator2()).done;){
                var feature = _step2.value;
                var f = void 0;
                if ((f = features[feature.featureType]) && f[feature.featureSetting]) {
                    flags &= feature.disableFlags;
                    flags |= feature.enableFlags;
                }
            }
            for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(chain.subtables), _step3; !(_step3 = _iterator3()).done;){
                var subtable = _step3.value;
                if (subtable.subFeatureFlags & flags) this.processSubtable(subtable, glyphs);
            }
        } // remove deleted glyphs
        var index = glyphs.length - 1;
        while(index >= 0){
            if (glyphs[index].id === 0xffff) glyphs.splice(index, 1);
            index--;
        }
        return glyphs;
    };
    _proto.processSubtable = function processSubtable(subtable, glyphs) {
        this.subtable = subtable;
        this.glyphs = glyphs;
        if (this.subtable.type === 4) {
            this.processNoncontextualSubstitutions(this.subtable, this.glyphs);
            return;
        }
        this.ligatureStack = [];
        this.markedGlyph = null;
        this.firstGlyph = null;
        this.lastGlyph = null;
        this.markedIndex = null;
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var reverse = !!(this.subtable.coverage & $07144aea14354eb9$var$REVERSE_DIRECTION);
        return stateMachine.process(this.glyphs, reverse, process);
    };
    _proto.getStateMachine = function getStateMachine(subtable) {
        return new $07144aea14354eb9$var$AATStateMachine(subtable.table.stateTable);
    };
    _proto.getProcessor = function getProcessor() {
        switch(this.subtable.type){
            case 0:
                return this.processIndicRearragement;
            case 1:
                return this.processContextualSubstitution;
            case 2:
                return this.processLigature;
            case 4:
                return this.processNoncontextualSubstitutions;
            case 5:
                return this.processGlyphInsertion;
            default:
                throw new Error("Invalid morx subtable type: " + this.subtable.type);
        }
    };
    _proto.processIndicRearragement = function processIndicRearragement(glyph, entry, index) {
        if (entry.flags & $07144aea14354eb9$var$MARK_FIRST) this.firstGlyph = index;
        if (entry.flags & $07144aea14354eb9$var$MARK_LAST) this.lastGlyph = index;
        $07144aea14354eb9$var$reorderGlyphs(this.glyphs, entry.flags & $07144aea14354eb9$var$VERB, this.firstGlyph, this.lastGlyph);
    };
    _proto.processContextualSubstitution = function processContextualSubstitution(glyph, entry, index) {
        var subsitutions = this.subtable.table.substitutionTable.items;
        if (entry.markIndex !== 0xffff) {
            var lookup = subsitutions.getItem(entry.markIndex);
            var lookupTable = new $07144aea14354eb9$var$AATLookupTable(lookup);
            glyph = this.glyphs[this.markedGlyph];
            var gid = lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[this.markedGlyph] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.currentIndex !== 0xffff) {
            var _lookup = subsitutions.getItem(entry.currentIndex);
            var _lookupTable = new $07144aea14354eb9$var$AATLookupTable(_lookup);
            glyph = this.glyphs[index];
            var gid = _lookupTable.lookup(glyph.id);
            if (gid) this.glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
        }
        if (entry.flags & $07144aea14354eb9$var$SET_MARK) this.markedGlyph = index;
    };
    _proto.processLigature = function processLigature(glyph, entry, index) {
        if (entry.flags & $07144aea14354eb9$var$SET_COMPONENT) this.ligatureStack.push(index);
        if (entry.flags & $07144aea14354eb9$var$PERFORM_ACTION) {
            var _this$ligatureStack;
            var actions = this.subtable.table.ligatureActions;
            var components = this.subtable.table.components;
            var ligatureList = this.subtable.table.ligatureList;
            var actionIndex = entry.action;
            var last = false;
            var ligatureIndex = 0;
            var codePoints = [];
            var ligatureGlyphs = [];
            while(!last){
                var _codePoints;
                var componentGlyph = this.ligatureStack.pop();
                (_codePoints = codePoints).unshift.apply(_codePoints, this.glyphs[componentGlyph].codePoints);
                var action = actions.getItem(actionIndex++);
                last = !!(action & $07144aea14354eb9$var$LAST_MASK);
                var store = !!(action & $07144aea14354eb9$var$STORE_MASK);
                var offset = (action & $07144aea14354eb9$var$OFFSET_MASK) << 2 >> 2; // sign extend 30 to 32 bits
                offset += this.glyphs[componentGlyph].id;
                var component = components.getItem(offset);
                ligatureIndex += component;
                if (last || store) {
                    var ligatureEntry = ligatureList.getItem(ligatureIndex);
                    this.glyphs[componentGlyph] = this.font.getGlyph(ligatureEntry, codePoints);
                    ligatureGlyphs.push(componentGlyph);
                    ligatureIndex = 0;
                    codePoints = [];
                } else this.glyphs[componentGlyph] = this.font.getGlyph(0xffff);
            } // Put ligature glyph indexes back on the stack
            (_this$ligatureStack = this.ligatureStack).push.apply(_this$ligatureStack, ligatureGlyphs);
        }
    };
    _proto.processNoncontextualSubstitutions = function processNoncontextualSubstitutions(subtable, glyphs, index) {
        var lookupTable = new $07144aea14354eb9$var$AATLookupTable(subtable.table.lookupTable);
        for(index = 0; index < glyphs.length; index++){
            var glyph = glyphs[index];
            if (glyph.id !== 0xffff) {
                var gid = lookupTable.lookup(glyph.id);
                if (gid) // 0 means do nothing
                glyphs[index] = this.font.getGlyph(gid, glyph.codePoints);
            }
        }
    };
    _proto._insertGlyphs = function _insertGlyphs(glyphIndex, insertionActionIndex, count, isBefore) {
        var _this$glyphs;
        var insertions = [];
        while(count--){
            var gid = this.subtable.table.insertionActions.getItem(insertionActionIndex++);
            insertions.push(this.font.getGlyph(gid));
        }
        if (!isBefore) glyphIndex++;
        (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
            glyphIndex,
            0
        ].concat(insertions));
    };
    _proto.processGlyphInsertion = function processGlyphInsertion(glyph, entry, index) {
        if (entry.flags & $07144aea14354eb9$var$SET_MARK) this.markedIndex = index;
        if (entry.markedInsertIndex !== 0xffff) {
            var count = (entry.flags & $07144aea14354eb9$var$MARKED_INSERT_COUNT) >>> 5;
            var isBefore = !!(entry.flags & $07144aea14354eb9$var$MARKED_INSERT_BEFORE);
            this._insertGlyphs(this.markedIndex, entry.markedInsertIndex, count, isBefore);
        }
        if (entry.currentInsertIndex !== 0xffff) {
            var _count = (entry.flags & $07144aea14354eb9$var$CURRENT_INSERT_COUNT) >>> 5;
            var _isBefore = !!(entry.flags & $07144aea14354eb9$var$CURRENT_INSERT_BEFORE);
            this._insertGlyphs(index, entry.currentInsertIndex, _count, _isBefore);
        }
    };
    _proto.getSupportedFeatures = function getSupportedFeatures() {
        var features = [];
        for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step4; !(_step4 = _iterator4()).done;){
            var chain = _step4.value;
            for(var _iterator5 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(chain.features), _step5; !(_step5 = _iterator5()).done;){
                var feature = _step5.value;
                features.push([
                    feature.featureType,
                    feature.featureSetting
                ]);
            }
        }
        return features;
    };
    _proto.generateInputs = function generateInputs(gid) {
        if (!this.inputCache) this.generateInputCache();
        return this.inputCache[gid] || [];
    };
    _proto.generateInputCache = function generateInputCache() {
        this.inputCache = {};
        for(var _iterator6 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(this.morx.chains), _step6; !(_step6 = _iterator6()).done;){
            var chain = _step6.value;
            var flags = chain.defaultFlags;
            for(var _iterator7 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$a(chain.subtables), _step7; !(_step7 = _iterator7()).done;){
                var subtable = _step7.value;
                if (subtable.subFeatureFlags & flags) this.generateInputsForSubtable(subtable);
            }
        }
    };
    _proto.generateInputsForSubtable = function generateInputsForSubtable(subtable) {
        var _this = this;
        // Currently, only supporting ligature subtables.
        if (subtable.type !== 2) return;
        var reverse = !!(subtable.coverage & $07144aea14354eb9$var$REVERSE_DIRECTION);
        if (reverse) throw new Error('Reverse subtable, not supported.');
        this.subtable = subtable;
        this.ligatureStack = [];
        var stateMachine = this.getStateMachine(subtable);
        var process = this.getProcessor();
        var input = [];
        var stack = [];
        this.glyphs = [];
        stateMachine.traverse({
            enter: function enter(glyph, entry) {
                var glyphs = _this.glyphs;
                stack.push({
                    glyphs: glyphs.slice(),
                    ligatureStack: _this.ligatureStack.slice()
                }); // Add glyph to input and glyphs to process.
                var g = _this.font.getGlyph(glyph);
                input.push(g);
                glyphs.push(input[input.length - 1]); // Process ligature substitution
                process(glyphs[glyphs.length - 1], entry, glyphs.length - 1); // Add input to result if only one matching (non-deleted) glyph remains.
                var count = 0;
                var found = 0;
                for(var i = 0; i < glyphs.length && count <= 1; i++)if (glyphs[i].id !== 0xffff) {
                    count++;
                    found = glyphs[i].id;
                }
                if (count === 1) {
                    var result = input.map(function(g) {
                        return g.id;
                    });
                    var _cache = _this.inputCache[found];
                    if (_cache) _cache.push(result);
                    else _this.inputCache[found] = [
                        result
                    ];
                }
            },
            exit: function exit() {
                var _stack$pop = stack.pop();
                _this.glyphs = _stack$pop.glyphs;
                _this.ligatureStack = _stack$pop.ligatureStack;
                input.pop();
            }
        });
    };
    return AATMorxProcessor;
}(), $07144aea14354eb9$var$_applyDecoratedDescriptor$2($07144aea14354eb9$var$_class$2.prototype, "getStateMachine", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$2.prototype, "getStateMachine"), $07144aea14354eb9$var$_class$2.prototype), $07144aea14354eb9$var$_class$2);
// reverse the glyphs inside those ranges if specified
// ranges are in [offset, length] format
function $07144aea14354eb9$var$swap(glyphs, rangeA, rangeB, reverseA, reverseB) {
    if (reverseA === void 0) reverseA = false;
    if (reverseB === void 0) reverseB = false;
    var end = glyphs.splice(rangeB[0] - (rangeB[1] - 1), rangeB[1]);
    if (reverseB) end.reverse();
    var start = glyphs.splice.apply(glyphs, [
        rangeA[0],
        rangeA[1]
    ].concat(end));
    if (reverseA) start.reverse();
    glyphs.splice.apply(glyphs, [
        rangeB[0] - (rangeA[1] - 1),
        0
    ].concat(start));
    return glyphs;
}
function $07144aea14354eb9$var$reorderGlyphs(glyphs, verb, firstGlyph, lastGlyph) {
    switch(verb){
        case 0:
            // no change
            return glyphs;
        case 1:
            // Ax => xA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                0
            ]);
        case 2:
            // xD => Dx
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                1
            ]);
        case 3:
            // AxD => DxA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                1
            ]);
        case 4:
            // ABx => xAB
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ]);
        case 5:
            // ABx => xBA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                0
            ], true, false);
        case 6:
            // xCD => CDx
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ]);
        case 7:
            // xCD => DCx
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                0
            ], [
                lastGlyph,
                2
            ], false, true);
        case 8:
            // AxCD => CDxA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ]);
        case 9:
            // AxCD => DCxA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                1
            ], [
                lastGlyph,
                2
            ], false, true);
        case 10:
            // ABxD => DxAB
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ]);
        case 11:
            // ABxD => DxBA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                1
            ], true, false);
        case 12:
            // ABxCD => CDxAB
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ]);
        case 13:
            // ABxCD => CDxBA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, false);
        case 14:
            // ABxCD => DCxAB
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], false, true);
        case 15:
            // ABxCD => DCxBA
            return $07144aea14354eb9$var$swap(glyphs, [
                firstGlyph,
                2
            ], [
                lastGlyph,
                2
            ], true, true);
        default:
            throw new Error("Unknown verb: " + verb);
    }
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$b(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$b(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$b(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$b(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$b(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$b(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$AATLayoutEngine = /*#__PURE__*/ function() {
    function AATLayoutEngine(font) {
        this.font = font;
        this.morxProcessor = new $07144aea14354eb9$var$AATMorxProcessor(font);
        this.fallbackPosition = false;
    }
    var _proto = AATLayoutEngine.prototype;
    _proto.substitute = function substitute(glyphRun) {
        // AAT expects the glyphs to be in visual order prior to morx processing,
        // so reverse the glyphs if the script is right-to-left.
        if (glyphRun.direction === 'rtl') glyphRun.glyphs.reverse();
        this.morxProcessor.process(glyphRun.glyphs, $07144aea14354eb9$var$mapOTToAAT(glyphRun.features));
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return $07144aea14354eb9$var$mapAATToOT(this.morxProcessor.getSupportedFeatures());
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        var glyphStrings = this.morxProcessor.generateInputs(gid);
        var result = new Set();
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$b(glyphStrings), _step; !(_step = _iterator()).done;){
            var glyphs = _step.value;
            this._addStrings(glyphs, 0, result, '');
        }
        return result;
    };
    _proto._addStrings = function _addStrings(glyphs, index, strings, string) {
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(glyphs[index]);
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$b(codePoints), _step2; !(_step2 = _iterator2()).done;){
            var codePoint = _step2.value;
            var s = string + String.fromCodePoint(codePoint);
            if (index < glyphs.length - 1) this._addStrings(glyphs, index + 1, strings, s);
            else strings.add(s);
        }
    };
    return AATLayoutEngine;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$c(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$c(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$c(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$c(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$c(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * ShapingPlans are used by the OpenType shapers to store which
 * features should by applied, and in what order to apply them.
 * The features are applied in groups called stages. A feature
 * can be applied globally to all glyphs, or locally to only
 * specific glyphs.
 *
 * @private
 */ var $07144aea14354eb9$var$ShapingPlan = /*#__PURE__*/ function() {
    function ShapingPlan(font, script, direction) {
        this.font = font;
        this.script = script;
        this.direction = direction;
        this.stages = [];
        this.globalFeatures = {};
        this.allFeatures = {};
    }
    /**
   * Adds the given features to the last stage.
   * Ignores features that have already been applied.
   */ var _proto = ShapingPlan.prototype;
    _proto._addFeatures = function _addFeatures(features, global1) {
        var stageIndex = this.stages.length - 1;
        var stage = this.stages[stageIndex];
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$c(features), _step; !(_step = _iterator()).done;){
            var feature = _step.value;
            if (this.allFeatures[feature] == null) {
                stage.push(feature);
                this.allFeatures[feature] = stageIndex;
                if (global1) this.globalFeatures[feature] = true;
            }
        }
    };
    _proto.add = function add(arg, global1) {
        if (global1 === void 0) global1 = true;
        if (this.stages.length === 0) this.stages.push([]);
        if (typeof arg === 'string') arg = [
            arg
        ];
        if (Array.isArray(arg)) this._addFeatures(arg, global1);
        else if (typeof arg === 'object') {
            this._addFeatures(arg.global || [], true);
            this._addFeatures(arg.local || [], false);
        } else throw new Error("Unsupported argument to ShapingPlan#add");
    };
    _proto.addStage = function addStage(arg, global1) {
        if (typeof arg === 'function') this.stages.push(arg, []);
        else {
            this.stages.push([]);
            this.add(arg, global1);
        }
    };
    _proto.setFeatureOverrides = function setFeatureOverrides(features) {
        if (Array.isArray(features)) this.add(features);
        else if (typeof features === 'object') for(var tag in features){
            if (features[tag]) this.add(tag);
            else if (this.allFeatures[tag] != null) {
                var stage = this.stages[this.allFeatures[tag]];
                stage.splice(stage.indexOf(tag), 1);
                delete this.allFeatures[tag];
                delete this.globalFeatures[tag];
            }
        }
    };
    _proto.assignGlobalFeatures = function assignGlobalFeatures(glyphs) {
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$c(glyphs), _step2; !(_step2 = _iterator2()).done;){
            var glyph = _step2.value;
            for(var feature in this.globalFeatures)glyph.features[feature] = true;
        }
    };
    _proto.process = function process(processor, glyphs, positions) {
        for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$c(this.stages), _step3; !(_step3 = _iterator3()).done;){
            var stage = _step3.value;
            if (typeof stage === 'function') {
                if (!positions) stage(this.font, glyphs, this);
            } else if (stage.length > 0) processor.applyFeatures(stage, glyphs, positions);
        }
    };
    return ShapingPlan;
}();
function $07144aea14354eb9$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $07144aea14354eb9$var$VARIATION_FEATURES = [
    'rvrn'
];
var $07144aea14354eb9$var$COMMON_FEATURES = [
    'ccmp',
    'locl',
    'rlig',
    'mark',
    'mkmk'
];
var $07144aea14354eb9$var$FRACTIONAL_FEATURES = [
    'frac',
    'numr',
    'dnom'
];
var $07144aea14354eb9$var$HORIZONTAL_FEATURES = [
    'calt',
    'clig',
    'liga',
    'rclt',
    'curs',
    'kern'
];
var $07144aea14354eb9$var$DIRECTIONAL_FEATURES = {
    ltr: [
        'ltra',
        'ltrm'
    ],
    rtl: [
        'rtla',
        'rtlm'
    ]
};
var $07144aea14354eb9$var$DefaultShaper = /*#__PURE__*/ function() {
    function DefaultShaper() {}
    DefaultShaper.plan = function plan(_plan, glyphs, features) {
        // Plan the features we want to apply
        this.planPreprocessing(_plan);
        this.planFeatures(_plan);
        this.planPostprocessing(_plan, features); // Assign the global features to all the glyphs
        _plan.assignGlobalFeatures(glyphs); // Assign local features to glyphs
        this.assignFeatures(_plan, glyphs);
    };
    DefaultShaper.planPreprocessing = function planPreprocessing(plan) {
        plan.add({
            global: [].concat($07144aea14354eb9$var$VARIATION_FEATURES, $07144aea14354eb9$var$DIRECTIONAL_FEATURES[plan.direction]),
            local: $07144aea14354eb9$var$FRACTIONAL_FEATURES
        });
    };
    DefaultShaper.planFeatures = function planFeatures(plan) {};
    DefaultShaper.planPostprocessing = function planPostprocessing(plan, userFeatures) {
        plan.add([].concat($07144aea14354eb9$var$COMMON_FEATURES, $07144aea14354eb9$var$HORIZONTAL_FEATURES));
        plan.setFeatureOverrides(userFeatures);
    };
    DefaultShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        // Enable contextual fractions
        for(var i = 0; i < glyphs.length; i++){
            var glyph = glyphs[i];
            if (glyph.codePoints[0] === 0x2044) {
                // fraction slash
                var start = i;
                var end = i + 1; // Apply numerator
                while(start > 0 && $07144aea14354eb9$var$unicode.isDigit(glyphs[start - 1].codePoints[0])){
                    glyphs[start - 1].features.numr = true;
                    glyphs[start - 1].features.frac = true;
                    start--;
                } // Apply denominator
                while(end < glyphs.length && $07144aea14354eb9$var$unicode.isDigit(glyphs[end].codePoints[0])){
                    glyphs[end].features.dnom = true;
                    glyphs[end].features.frac = true;
                    end++;
                } // Apply fraction slash
                glyph.features.frac = true;
                i = end - 1;
            }
        }
    };
    return DefaultShaper;
}();
$07144aea14354eb9$var$_defineProperty($07144aea14354eb9$var$DefaultShaper, "zeroMarkWidths", 'AFTER_GPOS');
var $07144aea14354eb9$var$base64DeflatedTrie$1 = "eJwBDgLx/QAB8AAAAAAAAAA4AAH9AQL+7ZotTMQwFMe77b44QIHA4JBIBAJ5lxASDAmGhHMoBIqgUOBQJAhOIpFIDIogSUgIEolEEgzJ/S/Xkpem3XXXboPbe8kv7a3r63vt69u6XDcWYhvsgn3Qlb//S3kMTsEZuACXoA9uwC24A/fgATyRfs/gTf4e8g4+ZP1Tll+knZlOfsC1pJ4IMQ8WkvLtKool+Los/V2pkN8MwzAMwzAMwzAMw1SP4fefVf7+wTAMwzAMwzC5cjUzYjEnXsFcW4gOOAeP4Ls9alufFWJTCNFrCdFvjepF8NLKbz7XcIbZMJxjOri2leF8s4N79zzPQz30P7DoOMT1o4qct9T/C06m1N9OHP3CwlJliSzQdlM9lNSk3kSjZih1TH2yQvv9JaE2UR/1uXLxLwSTzG0RJFrdxQ9TXKl2QUqbhNgHdDwXoT7Taz7SBHWD/oYkbf1dYyIhOvV+DU/7lWSNz1BxPW5uTO3jxnWVsvedb+zZ+o/L9Vlij95rerbZ7IoMelTe1XNFaJkkhqltphjT9ZrmT5ey34zVGijRbQxlX9n7xPTu1ZQUuY9993Oaf3nqDqnLNUf4SKg1iye005ZLIq1U9UiO5fJOGKfoN42nxnK1NUTOpfbYfNFzqZ5Tfe2wzWOIuLOtQdEov4qWtLhzJes6hI5RXwmZv0zPCps0A45rkwGaMQXv";
function $07144aea14354eb9$var$_inheritsLoose$3(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$trieData$1 = (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedTrie$1));
var $07144aea14354eb9$var$trie$1 = new $07144aea14354eb9$var$unicodeTrie($07144aea14354eb9$var$trieData$1);
var $07144aea14354eb9$var$FEATURES = [
    'isol',
    'fina',
    'fin2',
    'fin3',
    'medi',
    'med2',
    'init'
];
var $07144aea14354eb9$var$ShapingClasses = {
    Non_Joining: 0,
    Left_Joining: 1,
    Right_Joining: 2,
    Dual_Joining: 3,
    Join_Causing: 3,
    ALAPH: 4,
    'DALATH RISH': 5,
    Transparent: 6
};
var $07144aea14354eb9$var$ISOL = 'isol';
var $07144aea14354eb9$var$FINA = 'fina';
var $07144aea14354eb9$var$FIN2 = 'fin2';
var $07144aea14354eb9$var$FIN3 = 'fin3';
var $07144aea14354eb9$var$MEDI = 'medi';
var $07144aea14354eb9$var$MED2 = 'med2';
var $07144aea14354eb9$var$INIT = 'init';
var $07144aea14354eb9$var$NONE = null; // Each entry is [prevAction, curAction, nextState]
var $07144aea14354eb9$var$STATE_TABLE = [
    // State 0: prev was U,  not willing to join.
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$FIN2,
            5
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$INIT,
            $07144aea14354eb9$var$FINA,
            1
        ],
        [
            $07144aea14354eb9$var$INIT,
            $07144aea14354eb9$var$FINA,
            3
        ],
        [
            $07144aea14354eb9$var$INIT,
            $07144aea14354eb9$var$FINA,
            4
        ],
        [
            $07144aea14354eb9$var$INIT,
            $07144aea14354eb9$var$FINA,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$MEDI,
            $07144aea14354eb9$var$FINA,
            1
        ],
        [
            $07144aea14354eb9$var$MEDI,
            $07144aea14354eb9$var$FINA,
            3
        ],
        [
            $07144aea14354eb9$var$MEDI,
            $07144aea14354eb9$var$FINA,
            4
        ],
        [
            $07144aea14354eb9$var$MEDI,
            $07144aea14354eb9$var$FINA,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$MED2,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$MED2,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$MED2,
            $07144aea14354eb9$var$FIN2,
            5
        ],
        [
            $07144aea14354eb9$var$MED2,
            $07144aea14354eb9$var$ISOL,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$ISOL,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$ISOL,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$ISOL,
            $07144aea14354eb9$var$FIN2,
            5
        ],
        [
            $07144aea14354eb9$var$ISOL,
            $07144aea14354eb9$var$ISOL,
            6
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$NONE,
            0
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            1
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            2
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$FIN3,
            5
        ],
        [
            $07144aea14354eb9$var$NONE,
            $07144aea14354eb9$var$ISOL,
            6
        ]
    ]
];
/**
 * This is a shaper for Arabic, and other cursive scripts.
 * It uses data from ArabicShaping.txt in the Unicode database,
 * compiled to a UnicodeTrie by generate-data.coffee.
 *
 * The shaping state machine was ported from Harfbuzz.
 * https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-arabic.cc
 */ var $07144aea14354eb9$var$ArabicShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $07144aea14354eb9$var$_inheritsLoose$3(ArabicShaper, _DefaultShaper);
    function ArabicShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    ArabicShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ccmp',
            'locl'
        ]);
        for(var i = 0; i < $07144aea14354eb9$var$FEATURES.length; i++){
            var feature = $07144aea14354eb9$var$FEATURES[i];
            plan.addStage(feature, false);
        }
        plan.addStage('mset');
    };
    ArabicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        _DefaultShaper.assignFeatures.call(this, plan, glyphs);
        var prev = -1;
        var state = 0;
        var actions = []; // Apply the state machine to map glyphs to features
        for(var i = 0; i < glyphs.length; i++){
            var curAction = void 0, prevAction = void 0;
            var glyph = glyphs[i];
            var type = $07144aea14354eb9$var$getShapingClass(glyph.codePoints[0]);
            if (type === $07144aea14354eb9$var$ShapingClasses.Transparent) {
                actions[i] = $07144aea14354eb9$var$NONE;
                continue;
            }
            var _STATE_TABLE$state$ty = $07144aea14354eb9$var$STATE_TABLE[state][type];
            prevAction = _STATE_TABLE$state$ty[0];
            curAction = _STATE_TABLE$state$ty[1];
            state = _STATE_TABLE$state$ty[2];
            if (prevAction !== $07144aea14354eb9$var$NONE && prev !== -1) actions[prev] = prevAction;
            actions[i] = curAction;
            prev = i;
        } // Apply the chosen features to their respective glyphs
        for(var index = 0; index < glyphs.length; index++){
            var feature = void 0;
            var glyph = glyphs[index];
            if (feature = actions[index]) glyph.features[feature] = true;
        }
    };
    return ArabicShaper;
}($07144aea14354eb9$var$DefaultShaper);
function $07144aea14354eb9$var$getShapingClass(codePoint) {
    var res = $07144aea14354eb9$var$trie$1.get(codePoint);
    if (res) return res - 1;
    var category = $07144aea14354eb9$var$unicode.getCategory(codePoint);
    if (category === 'Mn' || category === 'Me' || category === 'Cf') return $07144aea14354eb9$var$ShapingClasses.Transparent;
    return $07144aea14354eb9$var$ShapingClasses.Non_Joining;
}
function $07144aea14354eb9$var$_defineProperties$3(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$3(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$3(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$3(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$GlyphIterator = /*#__PURE__*/ function() {
    function GlyphIterator(glyphs, options) {
        this.glyphs = glyphs;
        this.reset(options);
    }
    var _proto = GlyphIterator.prototype;
    _proto.reset = function reset(options, index) {
        if (options === void 0) options = {};
        if (index === void 0) index = 0;
        this.options = options;
        this.flags = options.flags || {};
        this.markAttachmentType = options.markAttachmentType || 0;
        this.index = index;
    };
    _proto.shouldIgnore = function shouldIgnore(glyph) {
        return this.flags.ignoreMarks && glyph.isMark || this.flags.ignoreBaseGlyphs && glyph.isBase || this.flags.ignoreLigatures && glyph.isLigature || this.markAttachmentType && glyph.isMark && glyph.markAttachmentType !== this.markAttachmentType;
    };
    _proto.move = function move(dir) {
        this.index += dir;
        while(0 <= this.index && this.index < this.glyphs.length && this.shouldIgnore(this.glyphs[this.index]))this.index += dir;
        if (0 > this.index || this.index >= this.glyphs.length) return null;
        return this.glyphs[this.index];
    };
    _proto.next = function next() {
        return this.move(1);
    };
    _proto.prev = function prev() {
        return this.move(-1);
    };
    _proto.peek = function peek(count) {
        if (count === void 0) count = 1;
        var idx = this.index;
        var res = this.increment(count);
        this.index = idx;
        return res;
    };
    _proto.peekIndex = function peekIndex(count) {
        if (count === void 0) count = 1;
        var idx = this.index;
        this.increment(count);
        var res = this.index;
        this.index = idx;
        return res;
    };
    _proto.increment = function increment(count) {
        if (count === void 0) count = 1;
        var dir = count < 0 ? -1 : 1;
        count = Math.abs(count);
        while(count--)this.move(dir);
        return this.glyphs[this.index];
    };
    $07144aea14354eb9$var$_createClass$3(GlyphIterator, [
        {
            key: "cur",
            get: function get() {
                return this.glyphs[this.index] || null;
            }
        }
    ]);
    return GlyphIterator;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$d(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$d(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$d(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$d(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$d(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$DEFAULT_SCRIPTS = [
    'DFLT',
    'dflt',
    'latn'
];
var $07144aea14354eb9$var$OTProcessor = /*#__PURE__*/ function() {
    function OTProcessor(font, table) {
        this.font = font;
        this.table = table;
        this.script = null;
        this.scriptTag = null;
        this.language = null;
        this.languageTag = null;
        this.features = {};
        this.lookups = {}; // Setup variation substitutions
        this.variationsIndex = font._variationProcessor ? this.findVariationsIndex(font._variationProcessor.normalizedCoords) : -1; // initialize to default script + language
        this.selectScript(); // current context (set by applyFeatures)
        this.glyphs = [];
        this.positions = []; // only used by GPOS
        this.ligatureID = 1;
        this.currentFeature = null;
    }
    var _proto = OTProcessor.prototype;
    _proto.findScript = function findScript(script) {
        if (this.table.scriptList == null) return null;
        if (!Array.isArray(script)) script = [
            script
        ];
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(script), _step; !(_step = _iterator()).done;){
            var s = _step.value;
            for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(this.table.scriptList), _step2; !(_step2 = _iterator2()).done;){
                var entry = _step2.value;
                if (entry.tag === s) return entry;
            }
        }
        return null;
    };
    _proto.selectScript = function selectScript(script, language, direction$1) {
        var changed = false;
        var entry;
        if (!this.script || script !== this.scriptTag) {
            entry = this.findScript(script);
            if (!entry) entry = this.findScript($07144aea14354eb9$var$DEFAULT_SCRIPTS);
            if (!entry) return this.scriptTag;
            this.scriptTag = entry.tag;
            this.script = entry.script;
            this.language = null;
            this.languageTag = null;
            changed = true;
        }
        if (!direction$1 || direction$1 !== this.direction) this.direction = direction$1 || $07144aea14354eb9$var$direction(script);
        if (language && language.length < 4) language += ' '.repeat(4 - language.length);
        if (!language || language !== this.languageTag) {
            this.language = null;
            for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(this.script.langSysRecords), _step3; !(_step3 = _iterator3()).done;){
                var lang = _step3.value;
                if (lang.tag === language) {
                    this.language = lang.langSys;
                    this.languageTag = lang.tag;
                    break;
                }
            }
            if (!this.language) {
                this.language = this.script.defaultLangSys;
                this.languageTag = null;
            }
            changed = true;
        } // Build a feature lookup table
        if (changed) {
            this.features = {};
            if (this.language) for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(this.language.featureIndexes), _step4; !(_step4 = _iterator4()).done;){
                var featureIndex = _step4.value;
                var record = this.table.featureList[featureIndex];
                var substituteFeature = this.substituteFeatureForVariations(featureIndex);
                this.features[record.tag] = substituteFeature || record.feature;
            }
        }
        return this.scriptTag;
    };
    _proto.lookupsForFeatures = function lookupsForFeatures(userFeatures, exclude) {
        if (userFeatures === void 0) userFeatures = [];
        var lookups = [];
        for(var _iterator5 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(userFeatures), _step5; !(_step5 = _iterator5()).done;){
            var tag = _step5.value;
            var feature = this.features[tag];
            if (!feature) continue;
            for(var _iterator6 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(feature.lookupListIndexes), _step6; !(_step6 = _iterator6()).done;){
                var lookupIndex = _step6.value;
                if (exclude && exclude.indexOf(lookupIndex) !== -1) continue;
                lookups.push({
                    feature: tag,
                    index: lookupIndex,
                    lookup: this.table.lookupList.get(lookupIndex)
                });
            }
        }
        lookups.sort(function(a, b) {
            return a.index - b.index;
        });
        return lookups;
    };
    _proto.substituteFeatureForVariations = function substituteFeatureForVariations(featureIndex) {
        if (this.variationsIndex === -1) return null;
        var record = this.table.featureVariations.featureVariationRecords[this.variationsIndex];
        var substitutions = record.featureTableSubstitution.substitutions;
        for(var _iterator7 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(substitutions), _step7; !(_step7 = _iterator7()).done;){
            var substitution = _step7.value;
            if (substitution.featureIndex === featureIndex) return substitution.alternateFeatureTable;
        }
        return null;
    };
    _proto.findVariationsIndex = function findVariationsIndex(coords) {
        var variations = this.table.featureVariations;
        if (!variations) return -1;
        var records = variations.featureVariationRecords;
        for(var i = 0; i < records.length; i++){
            var conditions = records[i].conditionSet.conditionTable;
            if (this.variationConditionsMatch(conditions, coords)) return i;
        }
        return -1;
    };
    _proto.variationConditionsMatch = function variationConditionsMatch(conditions, coords) {
        return conditions.every(function(condition) {
            var coord = condition.axisIndex < coords.length ? coords[condition.axisIndex] : 0;
            return condition.filterRangeMinValue <= coord && coord <= condition.filterRangeMaxValue;
        });
    };
    _proto.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        var lookups = this.lookupsForFeatures(userFeatures);
        this.applyLookups(lookups, glyphs, advances);
    };
    _proto.applyLookups = function applyLookups(lookups, glyphs, positions) {
        this.glyphs = glyphs;
        this.positions = positions;
        this.glyphIterator = new $07144aea14354eb9$var$GlyphIterator(glyphs);
        for(var _iterator8 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(lookups), _step8; !(_step8 = _iterator8()).done;){
            var _step8$value = _step8.value, feature = _step8$value.feature, lookup = _step8$value.lookup;
            this.currentFeature = feature;
            this.glyphIterator.reset(lookup.flags);
            while(this.glyphIterator.index < glyphs.length){
                if (!(feature in this.glyphIterator.cur.features)) {
                    this.glyphIterator.next();
                    continue;
                }
                for(var _iterator9 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(lookup.subTables), _step9; !(_step9 = _iterator9()).done;){
                    var table = _step9.value;
                    var res = this.applyLookup(lookup.lookupType, table);
                    if (res) break;
                }
                this.glyphIterator.next();
            }
        }
    };
    _proto.applyLookup = function applyLookup(lookup, table) {
        throw new Error("applyLookup must be implemented by subclasses");
    };
    _proto.applyLookupList = function applyLookupList(lookupRecords) {
        var options = this.glyphIterator.options;
        var glyphIndex = this.glyphIterator.index;
        for(var _iterator10 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(lookupRecords), _step10; !(_step10 = _iterator10()).done;){
            var lookupRecord = _step10.value;
            // Reset flags and find glyph index for this lookup record
            this.glyphIterator.reset(options, glyphIndex);
            this.glyphIterator.increment(lookupRecord.sequenceIndex); // Get the lookup and setup flags for subtables
            var lookup = this.table.lookupList.get(lookupRecord.lookupListIndex);
            this.glyphIterator.reset(lookup.flags, this.glyphIterator.index); // Apply lookup subtables until one matches
            for(var _iterator11 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(lookup.subTables), _step11; !(_step11 = _iterator11()).done;){
                var table = _step11.value;
                if (this.applyLookup(lookup.lookupType, table)) break;
            }
        }
        this.glyphIterator.reset(options, glyphIndex);
        return true;
    };
    _proto.coverageIndex = function coverageIndex(coverage, glyph) {
        if (glyph == null) glyph = this.glyphIterator.cur.id;
        switch(coverage.version){
            case 1:
                return coverage.glyphs.indexOf(glyph);
            case 2:
                for(var _iterator12 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(coverage.rangeRecords), _step12; !(_step12 = _iterator12()).done;){
                    var range = _step12.value;
                    if (range.start <= glyph && glyph <= range.end) return range.startCoverageIndex + glyph - range.start;
                }
                break;
        }
        return -1;
    };
    _proto.match = function match(sequenceIndex, sequence, fn, matched) {
        var pos = this.glyphIterator.index;
        var glyph = this.glyphIterator.increment(sequenceIndex);
        var idx = 0;
        while(idx < sequence.length && glyph && fn(sequence[idx], glyph)){
            if (matched) matched.push(this.glyphIterator.index);
            idx++;
            glyph = this.glyphIterator.next();
        }
        this.glyphIterator.index = pos;
        if (idx < sequence.length) return false;
        return matched || true;
    };
    _proto.sequenceMatches = function sequenceMatches(sequenceIndex, sequence) {
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            return component === glyph.id;
        });
    };
    _proto.sequenceMatchIndices = function sequenceMatchIndices(sequenceIndex, sequence) {
        var _this = this;
        return this.match(sequenceIndex, sequence, function(component, glyph) {
            // If the current feature doesn't apply to this glyph,
            if (!(_this.currentFeature in glyph.features)) return false;
            return component === glyph.id;
        }, []);
    };
    _proto.coverageSequenceMatches = function coverageSequenceMatches(sequenceIndex, sequence) {
        var _this2 = this;
        return this.match(sequenceIndex, sequence, function(coverage, glyph) {
            return _this2.coverageIndex(coverage, glyph.id) >= 0;
        });
    };
    _proto.getClassID = function getClassID(glyph, classDef) {
        switch(classDef.version){
            case 1:
                // Class array
                var i = glyph - classDef.startGlyph;
                if (i >= 0 && i < classDef.classValueArray.length) return classDef.classValueArray[i];
                break;
            case 2:
                for(var _iterator13 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(classDef.classRangeRecord), _step13; !(_step13 = _iterator13()).done;){
                    var range = _step13.value;
                    if (range.start <= glyph && glyph <= range.end) return range["class"];
                }
                break;
        }
        return 0;
    };
    _proto.classSequenceMatches = function classSequenceMatches(sequenceIndex, sequence, classDef) {
        var _this3 = this;
        return this.match(sequenceIndex, sequence, function(classID, glyph) {
            return classID === _this3.getClassID(glyph.id, classDef);
        });
    };
    _proto.applyContext = function applyContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set = table.ruleSets[index];
                for(var _iterator14 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(set), _step14; !(_step14 = _iterator14()).done;){
                    var rule = _step14.value;
                    if (this.sequenceMatches(1, rule.input)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.classDef);
                if (index === -1) return false;
                set = table.classSet[index];
                for(var _iterator15 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(set), _step15; !(_step15 = _iterator15()).done;){
                    var _rule = _step15.value;
                    if (this.classSequenceMatches(1, _rule.classes, table.classDef)) return this.applyLookupList(_rule.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(0, table.coverages)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    _proto.applyChainingContext = function applyChainingContext(table) {
        switch(table.version){
            case 1:
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var set = table.chainRuleSets[index];
                for(var _iterator16 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(set), _step16; !(_step16 = _iterator16()).done;){
                    var rule = _step16.value;
                    if (this.sequenceMatches(-rule.backtrack.length, rule.backtrack) && this.sequenceMatches(1, rule.input) && this.sequenceMatches(1 + rule.input.length, rule.lookahead)) return this.applyLookupList(rule.lookupRecords);
                }
                break;
            case 2:
                if (this.coverageIndex(table.coverage) === -1) return false;
                index = this.getClassID(this.glyphIterator.cur.id, table.inputClassDef);
                var rules = table.chainClassSet[index];
                if (!rules) return false;
                for(var _iterator17 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$d(rules), _step17; !(_step17 = _iterator17()).done;){
                    var _rule2 = _step17.value;
                    if (this.classSequenceMatches(-_rule2.backtrack.length, _rule2.backtrack, table.backtrackClassDef) && this.classSequenceMatches(1, _rule2.input, table.inputClassDef) && this.classSequenceMatches(1 + _rule2.input.length, _rule2.lookahead, table.lookaheadClassDef)) return this.applyLookupList(_rule2.lookupRecords);
                }
                break;
            case 3:
                if (this.coverageSequenceMatches(-table.backtrackGlyphCount, table.backtrackCoverage) && this.coverageSequenceMatches(0, table.inputCoverage) && this.coverageSequenceMatches(table.inputGlyphCount, table.lookaheadCoverage)) return this.applyLookupList(table.lookupRecords);
                break;
        }
        return false;
    };
    return OTProcessor;
}();
function $07144aea14354eb9$var$_defineProperties$4(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$4(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$4(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$4(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$GlyphInfo = /*#__PURE__*/ function() {
    function GlyphInfo(font, id, codePoints, features) {
        if (codePoints === void 0) codePoints = [];
        this._font = font;
        this.codePoints = codePoints;
        this.id = id;
        this.features = {};
        if (Array.isArray(features)) for(var i = 0; i < features.length; i++){
            var feature = features[i];
            this.features[feature] = true;
        }
        else if (typeof features === 'object') Object.assign(this.features, features);
        this.ligatureID = null;
        this.ligatureComponent = null;
        this.isLigated = false;
        this.cursiveAttachment = null;
        this.markAttachment = null;
        this.shaperInfo = null;
        this.substituted = false;
        this.isMultiplied = false;
    }
    var _proto = GlyphInfo.prototype;
    _proto.copy = function copy() {
        return new GlyphInfo(this._font, this.id, this.codePoints, this.features);
    };
    $07144aea14354eb9$var$_createClass$4(GlyphInfo, [
        {
            key: "id",
            get: function get() {
                return this._id;
            },
            set: function set(id) {
                this._id = id;
                this.substituted = true;
                var GDEF = this._font.GDEF;
                if (GDEF && GDEF.glyphClassDef) {
                    // TODO: clean this up
                    var classID = $07144aea14354eb9$var$OTProcessor.prototype.getClassID(id, GDEF.glyphClassDef);
                    this.isBase = classID === 1;
                    this.isLigature = classID === 2;
                    this.isMark = classID === 3;
                    this.markAttachmentType = GDEF.markAttachClassDef ? $07144aea14354eb9$var$OTProcessor.prototype.getClassID(id, GDEF.markAttachClassDef) : 0;
                } else {
                    this.isMark = this.codePoints.length > 0 && this.codePoints.every($07144aea14354eb9$var$unicode.isMark);
                    this.isBase = !this.isMark;
                    this.isLigature = this.codePoints.length > 1;
                    this.markAttachmentType = 0;
                }
            }
        }
    ]);
    return GlyphInfo;
}();
function $07144aea14354eb9$var$_inheritsLoose$4(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $07144aea14354eb9$var$_defineProperty$1(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * This is a shaper for the Hangul script, used by the Korean language.
 * It does the following:
 *   - decompose if unsupported by the font:
 *     <LV>   -> <L,V>
 *     <LVT>  -> <L,V,T>
 *     <LV,T> -> <L,V,T>
 *
 *   - compose if supported by the font:
 *     <L,V>   -> <LV>
 *     <L,V,T> -> <LVT>
 *     <LV,T>  -> <LVT>
 *
 *   - reorder tone marks (S is any valid syllable):
 *     <S, M> -> <M, S>
 *
 *   - apply ljmo, vjmo, and tjmo OpenType features to decomposed Jamo sequences.
 *
 * This logic is based on the following documents:
 *   - http://www.microsoft.com/typography/OpenTypeDev/hangul/intro.htm
 *   - http://ktug.org/~nomos/harfbuzz-hangul/hangulshaper.pdf
 */ var $07144aea14354eb9$var$HangulShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $07144aea14354eb9$var$_inheritsLoose$4(HangulShaper, _DefaultShaper);
    function HangulShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    HangulShaper.planFeatures = function planFeatures(plan) {
        plan.add([
            'ljmo',
            'vjmo',
            'tjmo'
        ], false);
    };
    HangulShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var state = 0;
        var i = 0;
        while(i < glyphs.length){
            var action = void 0;
            var glyph = glyphs[i];
            var code = glyph.codePoints[0];
            var type = $07144aea14354eb9$var$getType(code);
            var _STATE_TABLE$state$ty = $07144aea14354eb9$var$STATE_TABLE$1[state][type];
            action = _STATE_TABLE$state$ty[0];
            state = _STATE_TABLE$state$ty[1];
            switch(action){
                case $07144aea14354eb9$var$DECOMPOSE:
                    // Decompose the composed syllable if it is not supported by the font.
                    if (!plan.font.hasGlyphForCodePoint(code)) i = $07144aea14354eb9$var$decompose(glyphs, i, plan.font);
                    break;
                case $07144aea14354eb9$var$COMPOSE:
                    // Found a decomposed syllable. Try to compose if supported by the font.
                    i = $07144aea14354eb9$var$compose(glyphs, i, plan.font);
                    break;
                case $07144aea14354eb9$var$TONE_MARK:
                    // Got a valid syllable, followed by a tone mark. Move the tone mark to the beginning of the syllable.
                    $07144aea14354eb9$var$reorderToneMark(glyphs, i, plan.font);
                    break;
                case $07144aea14354eb9$var$INVALID:
                    // Tone mark has no valid syllable to attach to, so insert a dotted circle
                    i = $07144aea14354eb9$var$insertDottedCircle(glyphs, i, plan.font);
                    break;
            }
            i++;
        }
    };
    return HangulShaper;
}($07144aea14354eb9$var$DefaultShaper);
$07144aea14354eb9$var$_defineProperty$1($07144aea14354eb9$var$HangulShaper, "zeroMarkWidths", 'NONE');
var $07144aea14354eb9$var$HANGUL_BASE = 0xac00;
var $07144aea14354eb9$var$HANGUL_END = 0xd7a4;
var $07144aea14354eb9$var$HANGUL_COUNT = $07144aea14354eb9$var$HANGUL_END - $07144aea14354eb9$var$HANGUL_BASE + 1;
var $07144aea14354eb9$var$L_BASE = 0x1100; // lead
var $07144aea14354eb9$var$V_BASE = 0x1161; // vowel
var $07144aea14354eb9$var$T_BASE = 0x11a7; // trail
var $07144aea14354eb9$var$L_COUNT = 19;
var $07144aea14354eb9$var$V_COUNT = 21;
var $07144aea14354eb9$var$T_COUNT = 28;
var $07144aea14354eb9$var$L_END = $07144aea14354eb9$var$L_BASE + $07144aea14354eb9$var$L_COUNT - 1;
var $07144aea14354eb9$var$V_END = $07144aea14354eb9$var$V_BASE + $07144aea14354eb9$var$V_COUNT - 1;
var $07144aea14354eb9$var$T_END = $07144aea14354eb9$var$T_BASE + $07144aea14354eb9$var$T_COUNT - 1;
var $07144aea14354eb9$var$DOTTED_CIRCLE = 0x25cc;
var $07144aea14354eb9$var$isL = function isL(code) {
    return 0x1100 <= code && code <= 0x115f || 0xa960 <= code && code <= 0xa97c;
};
var $07144aea14354eb9$var$isV = function isV(code) {
    return 0x1160 <= code && code <= 0x11a7 || 0xd7b0 <= code && code <= 0xd7c6;
};
var $07144aea14354eb9$var$isT = function isT(code) {
    return 0x11a8 <= code && code <= 0x11ff || 0xd7cb <= code && code <= 0xd7fb;
};
var $07144aea14354eb9$var$isTone = function isTone(code) {
    return 0x302e <= code && code <= 0x302f;
};
var $07144aea14354eb9$var$isLVT = function isLVT(code) {
    return $07144aea14354eb9$var$HANGUL_BASE <= code && code <= $07144aea14354eb9$var$HANGUL_END;
};
var $07144aea14354eb9$var$isLV = function isLV(code) {
    return code - $07144aea14354eb9$var$HANGUL_BASE < $07144aea14354eb9$var$HANGUL_COUNT && (code - $07144aea14354eb9$var$HANGUL_BASE) % $07144aea14354eb9$var$T_COUNT === 0;
};
var $07144aea14354eb9$var$isCombiningL = function isCombiningL(code) {
    return $07144aea14354eb9$var$L_BASE <= code && code <= $07144aea14354eb9$var$L_END;
};
var $07144aea14354eb9$var$isCombiningV = function isCombiningV(code) {
    return $07144aea14354eb9$var$V_BASE <= code && code <= $07144aea14354eb9$var$V_END;
};
var $07144aea14354eb9$var$isCombiningT = function isCombiningT(code) {
    return 1 <= code && code <= $07144aea14354eb9$var$T_END;
}; // Character categories
var $07144aea14354eb9$var$X = 0; // Other character
var $07144aea14354eb9$var$L = 1; // Leading consonant
var $07144aea14354eb9$var$V = 2; // Medial vowel
var $07144aea14354eb9$var$T = 3; // Trailing consonant
var $07144aea14354eb9$var$LV = 4; // Composed <LV> syllable
var $07144aea14354eb9$var$LVT = 5; // Composed <LVT> syllable
var $07144aea14354eb9$var$M = 6; // Tone mark
// This function classifies a character using the above categories.
function $07144aea14354eb9$var$getType(code) {
    if ($07144aea14354eb9$var$isL(code)) return $07144aea14354eb9$var$L;
    if ($07144aea14354eb9$var$isV(code)) return $07144aea14354eb9$var$V;
    if ($07144aea14354eb9$var$isT(code)) return $07144aea14354eb9$var$T;
    if ($07144aea14354eb9$var$isLV(code)) return $07144aea14354eb9$var$LV;
    if ($07144aea14354eb9$var$isLVT(code)) return $07144aea14354eb9$var$LVT;
    if ($07144aea14354eb9$var$isTone(code)) return $07144aea14354eb9$var$M;
    return $07144aea14354eb9$var$X;
} // State machine actions
var $07144aea14354eb9$var$NO_ACTION = 0;
var $07144aea14354eb9$var$DECOMPOSE = 1;
var $07144aea14354eb9$var$COMPOSE = 2;
var $07144aea14354eb9$var$TONE_MARK = 4;
var $07144aea14354eb9$var$INVALID = 5; // Build a state machine that accepts valid syllables, and applies actions along the way.
// The logic this is implementing is documented at the top of the file.
var $07144aea14354eb9$var$STATE_TABLE$1 = [
    // State 0: start state
    [
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            1
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            2
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            3
        ],
        [
            $07144aea14354eb9$var$INVALID,
            0
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            1
        ],
        [
            $07144aea14354eb9$var$COMPOSE,
            2
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            2
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            3
        ],
        [
            $07144aea14354eb9$var$INVALID,
            0
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            1
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$COMPOSE,
            3
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            2
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            3
        ],
        [
            $07144aea14354eb9$var$TONE_MARK,
            0
        ]
    ],
    [
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            1
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$NO_ACTION,
            0
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            2
        ],
        [
            $07144aea14354eb9$var$DECOMPOSE,
            3
        ],
        [
            $07144aea14354eb9$var$TONE_MARK,
            0
        ]
    ]
];
function $07144aea14354eb9$var$getGlyph(font, code, features) {
    return new $07144aea14354eb9$var$GlyphInfo(font, font.glyphForCodePoint(code).id, [
        code
    ], features);
}
function $07144aea14354eb9$var$decompose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyph.codePoints[0];
    var s = code - $07144aea14354eb9$var$HANGUL_BASE;
    var t = $07144aea14354eb9$var$T_BASE + s % $07144aea14354eb9$var$T_COUNT;
    s = s / $07144aea14354eb9$var$T_COUNT | 0;
    var l = $07144aea14354eb9$var$L_BASE + s / $07144aea14354eb9$var$V_COUNT | 0;
    var v = $07144aea14354eb9$var$V_BASE + s % $07144aea14354eb9$var$V_COUNT; // Don't decompose if all of the components are not available
    if (!font.hasGlyphForCodePoint(l) || !font.hasGlyphForCodePoint(v) || t !== $07144aea14354eb9$var$T_BASE && !font.hasGlyphForCodePoint(t)) return i;
     // Replace the current glyph with decomposed L, V, and T glyphs,
    // and apply the proper OpenType features to each component.
    var ljmo = $07144aea14354eb9$var$getGlyph(font, l, glyph.features);
    ljmo.features.ljmo = true;
    var vjmo = $07144aea14354eb9$var$getGlyph(font, v, glyph.features);
    vjmo.features.vjmo = true;
    var insert = [
        ljmo,
        vjmo
    ];
    if (t > $07144aea14354eb9$var$T_BASE) {
        var tjmo = $07144aea14354eb9$var$getGlyph(font, t, glyph.features);
        tjmo.features.tjmo = true;
        insert.push(tjmo);
    }
    glyphs.splice.apply(glyphs, [
        i,
        1
    ].concat(insert));
    return i + insert.length - 1;
}
function $07144aea14354eb9$var$compose(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    var type = $07144aea14354eb9$var$getType(code);
    var prev = glyphs[i - 1].codePoints[0];
    var prevType = $07144aea14354eb9$var$getType(prev); // Figure out what type of syllable we're dealing with
    var lv, ljmo, vjmo, tjmo;
    if (prevType === $07144aea14354eb9$var$LV && type === $07144aea14354eb9$var$T) {
        // <LV,T>
        lv = prev;
        tjmo = glyph;
    } else {
        if (type === $07144aea14354eb9$var$V) {
            // <L,V>
            ljmo = glyphs[i - 1];
            vjmo = glyph;
        } else {
            // <L,V,T>
            ljmo = glyphs[i - 2];
            vjmo = glyphs[i - 1];
            tjmo = glyph;
        }
        var l = ljmo.codePoints[0];
        var v = vjmo.codePoints[0]; // Make sure L and V are combining characters
        if ($07144aea14354eb9$var$isCombiningL(l) && $07144aea14354eb9$var$isCombiningV(v)) lv = $07144aea14354eb9$var$HANGUL_BASE + ((l - $07144aea14354eb9$var$L_BASE) * $07144aea14354eb9$var$V_COUNT + (v - $07144aea14354eb9$var$V_BASE)) * $07144aea14354eb9$var$T_COUNT;
    }
    var t = tjmo && tjmo.codePoints[0] || $07144aea14354eb9$var$T_BASE;
    if (lv != null && (t === $07144aea14354eb9$var$T_BASE || $07144aea14354eb9$var$isCombiningT(t))) {
        var s = lv + (t - $07144aea14354eb9$var$T_BASE); // Replace with a composed glyph if supported by the font,
        // otherwise apply the proper OpenType features to each component.
        if (font.hasGlyphForCodePoint(s)) {
            var del = prevType === $07144aea14354eb9$var$V ? 3 : 2;
            glyphs.splice(i - del + 1, del, $07144aea14354eb9$var$getGlyph(font, s, glyph.features));
            return i - del + 1;
        }
    } // Didn't compose (either a non-combining component or unsupported by font).
    if (ljmo) ljmo.features.ljmo = true;
    if (vjmo) vjmo.features.vjmo = true;
    if (tjmo) tjmo.features.tjmo = true;
    if (prevType === $07144aea14354eb9$var$LV) {
        // Sequence was originally <L,V>, which got combined earlier.
        // Either the T was non-combining, or the LVT glyph wasn't supported.
        // Decompose the glyph again and apply OT features.
        $07144aea14354eb9$var$decompose(glyphs, i - 1, font);
        return i + 1;
    }
    return i;
}
function $07144aea14354eb9$var$getLength(code) {
    switch($07144aea14354eb9$var$getType(code)){
        case $07144aea14354eb9$var$LV:
        case $07144aea14354eb9$var$LVT:
            return 1;
        case $07144aea14354eb9$var$V:
            return 2;
        case $07144aea14354eb9$var$T:
            return 3;
    }
}
function $07144aea14354eb9$var$reorderToneMark(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0]; // Move tone mark to the beginning of the previous syllable, unless it is zero width
    if (font.glyphForCodePoint(code).advanceWidth === 0) return;
    var prev = glyphs[i - 1].codePoints[0];
    var len = $07144aea14354eb9$var$getLength(prev);
    glyphs.splice(i, 1);
    return glyphs.splice(i - len, 0, glyph);
}
function $07144aea14354eb9$var$insertDottedCircle(glyphs, i, font) {
    var glyph = glyphs[i];
    var code = glyphs[i].codePoints[0];
    if (font.hasGlyphForCodePoint($07144aea14354eb9$var$DOTTED_CIRCLE)) {
        var dottedCircle = $07144aea14354eb9$var$getGlyph(font, $07144aea14354eb9$var$DOTTED_CIRCLE, glyph.features); // If the tone mark is zero width, insert the dotted circle before, otherwise after
        var idx = font.glyphForCodePoint(code).advanceWidth === 0 ? i : i + 1;
        glyphs.splice(idx, 0, dottedCircle);
        i++;
    }
    return i;
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$e(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$e(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$e(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$e(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$e(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$e(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$INITIAL_STATE = 1;
var $07144aea14354eb9$var$FAIL_STATE = 0;
/**
 * A StateMachine represents a deterministic finite automaton.
 * It can perform matches over a sequence of values, similar to a regular expression.
 */ var $07144aea14354eb9$var$StateMachine = /*#__PURE__*/ function() {
    function StateMachine(dfa) {
        this.stateTable = dfa.stateTable;
        this.accepting = dfa.accepting;
        this.tags = dfa.tags;
    }
    /**
   * Returns an iterable object that yields pattern matches over the input sequence.
   * Matches are of the form [startIndex, endIndex, tags].
   */ var _proto = StateMachine.prototype;
    _proto.match = function match(str) {
        var _ref;
        var self1 = this;
        return _ref = {}, _ref[Symbol.iterator] = /*#__PURE__*/ regeneratorRuntime.mark(function _callee() {
            var state, startRun, lastAccepting, lastState, p, c;
            return regeneratorRuntime.wrap(function _callee$(_context) {
                while(true)switch(_context.prev = _context.next){
                    case 0:
                        state = $07144aea14354eb9$var$INITIAL_STATE;
                        startRun = null;
                        lastAccepting = null;
                        lastState = null;
                        p = 0;
                    case 5:
                        if (!(p < str.length)) {
                            _context.next = 21;
                            break;
                        }
                        c = str[p];
                        lastState = state;
                        state = self1.stateTable[state][c];
                        if (!(state === $07144aea14354eb9$var$FAIL_STATE)) {
                            _context.next = 15;
                            break;
                        }
                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                            _context.next = 13;
                            break;
                        }
                        _context.next = 13;
                        return [
                            startRun,
                            lastAccepting,
                            self1.tags[lastState]
                        ];
                    case 13:
                        // reset the state as if we started over from the initial state
                        state = self1.stateTable[$07144aea14354eb9$var$INITIAL_STATE][c];
                        startRun = null;
                    case 15:
                        // start a run if not in the failure state
                        if (state !== $07144aea14354eb9$var$FAIL_STATE && startRun == null) startRun = p;
                         // if accepting, mark the potential match end
                        if (self1.accepting[state]) lastAccepting = p;
                         // reset the state to the initial state if we get into the failure state
                        if (state === $07144aea14354eb9$var$FAIL_STATE) state = $07144aea14354eb9$var$INITIAL_STATE;
                    case 18:
                        p++;
                        _context.next = 5;
                        break;
                    case 21:
                        if (!(startRun != null && lastAccepting != null && lastAccepting >= startRun)) {
                            _context.next = 24;
                            break;
                        }
                        _context.next = 24;
                        return [
                            startRun,
                            lastAccepting,
                            self1.tags[state]
                        ];
                    case 24:
                    case "end":
                        return _context.stop();
                }
            }, _callee);
        }), _ref;
    };
    _proto.apply = function apply(str, actions) {
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$e(this.match(str)), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
            for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$e(tags), _step2; !(_step2 = _iterator2()).done;){
                var tag = _step2.value;
                if (typeof actions[tag] === 'function') actions[tag](start, end, str.slice(start, end + 1));
            }
        }
    };
    return StateMachine;
}();
var $07144aea14354eb9$var$dfa = $07144aea14354eb9$var$StateMachine;
// Cateories used in the OpenType spec:
// https://www.microsoft.com/typography/otfntdev/devanot/shaping.aspx
var $07144aea14354eb9$var$CATEGORIES = {
    X: 1,
    C: 2,
    V: 4,
    N: 8,
    H: 16,
    ZWNJ: 32,
    ZWJ: 64,
    M: 128,
    SM: 256,
    VD: 512,
    A: 1024,
    Placeholder: 2048,
    Dotted_Circle: 4096,
    RS: 8192,
    // Register Shifter, used in Khmer OT spec.
    Coeng: 16384,
    // Khmer-style Virama.
    Repha: 32768,
    // Atomically-encoded logical or visual repha.
    Ra: 65536,
    CM: 131072,
    // Consonant-Medial.
    Symbol: 262144 // Avagraha, etc that take marks (SM,A,VD).
}; // Visual positions in a syllable from left to right.
var $07144aea14354eb9$var$POSITIONS = {
    Start: 1,
    Ra_To_Become_Reph: 2,
    Pre_M: 4,
    Pre_C: 8,
    Base_C: 16,
    After_Main: 32,
    Above_C: 64,
    Before_Sub: 128,
    Below_C: 256,
    After_Sub: 512,
    Before_Post: 1024,
    Post_C: 2048,
    After_Post: 4096,
    Final_C: 8192,
    SMVD: 16384,
    End: 32768
};
var $07144aea14354eb9$var$CONSONANT_FLAGS = $07144aea14354eb9$var$CATEGORIES.C | $07144aea14354eb9$var$CATEGORIES.Ra | $07144aea14354eb9$var$CATEGORIES.CM | $07144aea14354eb9$var$CATEGORIES.V | $07144aea14354eb9$var$CATEGORIES.Placeholder | $07144aea14354eb9$var$CATEGORIES.Dotted_Circle;
var $07144aea14354eb9$var$JOINER_FLAGS = $07144aea14354eb9$var$CATEGORIES.ZWJ | $07144aea14354eb9$var$CATEGORIES.ZWNJ;
var $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS = $07144aea14354eb9$var$CATEGORIES.H | $07144aea14354eb9$var$CATEGORIES.Coeng;
var $07144aea14354eb9$var$INDIC_CONFIGS = {
    Default: {
        hasOldSpec: false,
        virama: 0,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Devanagari: {
        hasOldSpec: true,
        virama: 0x094D,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Bengali: {
        hasOldSpec: true,
        virama: 0x09CD,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gurmukhi: {
        hasOldSpec: true,
        virama: 0x0A4D,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.Before_Sub,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Gujarati: {
        hasOldSpec: true,
        virama: 0x0ACD,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.Before_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Oriya: {
        hasOldSpec: true,
        virama: 0x0B4D,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Main,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Tamil: {
        hasOldSpec: true,
        virama: 0x0BCD,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Pre_And_Post'
    },
    Telugu: {
        hasOldSpec: true,
        virama: 0x0C4D,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Post,
        rephMode: 'Explicit',
        blwfMode: 'Post_Only'
    },
    Kannada: {
        hasOldSpec: true,
        virama: 0x0CCD,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Post,
        rephMode: 'Implicit',
        blwfMode: 'Post_Only'
    },
    Malayalam: {
        hasOldSpec: true,
        virama: 0x0D4D,
        basePos: 'Last',
        rephPos: $07144aea14354eb9$var$POSITIONS.After_Main,
        rephMode: 'Log_Repha',
        blwfMode: 'Pre_And_Post'
    },
    // Handled by UniversalShaper
    // Sinhala: {
    //   hasOldSpec: false,
    //   virama: 0x0DCA,
    //   basePos: 'Last_Sinhala',
    //   rephPos: POSITIONS.After_Main,
    //   rephMode: 'Explicit',
    //   blwfMode: 'Pre_And_Post'
    // },
    Khmer: {
        hasOldSpec: false,
        virama: 0x17D2,
        basePos: 'First',
        rephPos: $07144aea14354eb9$var$POSITIONS.Ra_To_Become_Reph,
        rephMode: 'Vis_Repha',
        blwfMode: 'Pre_And_Post'
    }
}; // Additional decompositions that aren't in Unicode
var $07144aea14354eb9$var$INDIC_DECOMPOSITIONS = {
    // Khmer
    0x17BE: [
        0x17C1,
        0x17BE
    ],
    0x17BF: [
        0x17C1,
        0x17BF
    ],
    0x17C0: [
        0x17C1,
        0x17C0
    ],
    0x17C4: [
        0x17C1,
        0x17C4
    ],
    0x17C5: [
        0x17C1,
        0x17C5
    ]
};
var $07144aea14354eb9$var$base64DeflatedIndicMachine = "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";
var $07144aea14354eb9$var$base64DeflatedUseData = "eJzNmVtv2zYUx7+LnvnA+6Vva4a0K5BsWLcWmBEEsqMG3mw5kJUOQ9HvvsOLLUp2owsVwGBCmj8d/nl0DkkzyLdsldfF465aF/vszSL7NUPZL7c/Q/0Rft+9hcr+Xt9AdfXuA9Sfbn5afnXtb/vatqHre1c3bzf/um5V2Mb33jt7//kqjD907Ty/2/n+tBMF0Rs//NqbXnt47UeUz5uNtQ86Hw8zhjF/fb794Bpbu8r6/slOc2tdsZUbeoeyh2K12z7t9ut6vSvh/b9lVGAFcYCGIcoNByP4rI9IEGOR1g5prRA1mDpkyBFppT2ikRUDxDCxA6HhiGEsPTIeiQZR3FgxYhHh3CLCKWJEWHlGpUNUMsSoFg4p4pDCEaIRkh7xBsmARIyOozl2o5nRCCrsEfPIRIgfrThxAwWXFgkObyUY9khHKFiZGDWmAjdcuABI5jyUkiD4bBPDlHSeKA2eKGmzwIxwVkZATIzgHqkISY+sJxySAUhqj0yDnGngEntuIkQa1DI1zUQOSePyAQ1G0kjhEfOIRkh6xCOkPBIRMh7pBhnGHTNMATRUBSoC1UeqMHcpti1BULt42Z6Mqfa2mjNHNbdUcxoojyk7UNmytZ4pgo0NsW0lgtrrQs8EqgL9jrJ9DUfQH/lyU8CzBUazlTu0oAj2C+JQBBBwBWlkEMGIEEQoIgzBHoOdRyQ8JgpB+u0TgyhGlCBKgxZlvvE1txW85yzOUnn0dqKAPXHa/VNBaqBi8APbB0ICSxTOFthdsNUVYnbRI+4tIY3wAM4ZDoGDyImgwOVRjBlP1EwhaPLV9A75ii0I7756O0v9irijeBLLsYKHJeXcowN8DCup/7XN4NceKHlm5WO/8HHfuo+mFi+EwEvPHoN0TaK7D8eX3rWUvjp7zqdXTRPAMTEdeKTO4zLXLXHbHSzOzciAkMM5NygiZ3T7yoRDq1eS/PjhNLmRqza2SNz904twFXnxlE5I9Vxupqp1v+/TvZtZru9lo7tIbMS6XnQuIANETzS7ZbxkfGdyE8gBrkZ3pd4AsGadzSd79o6HR1zxAlB9AfH6rxKRdF3+8mIYVAYsshkW7lw386S0MTEyvmekBW05D93hzgs2xXs+yv1z4n1lyjnUq9n9kkzXG7/eYqO5z56kLP34G7xzFZz1D5iUa+ZZ8bRycpNJEuP9Kevs3fm/LlIOh7MzJMTjGOE7lOWrVfFUr8vH7M3iS77ZF6iunidX6QqXVkGI6vzR/oNgAeHPltXun6K8X22e93VRZRaty4fiqYCqrFt8/992udu0UZ2XD3n10IJnJC8BXYof01H5vC2qfNNnNiZ/A1N6gfDrusq3+T10t+syr4tL8u014PQlAmxZVPd/79YlNMkBO5ni7vv/LbyJLg==";
var $07144aea14354eb9$var$base64DeflatedTrie$2 = "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";
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$f(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$f(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$f(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$f(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$f(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$f(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$5(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $07144aea14354eb9$var$_defineProperty$2(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// we may be running in a browser so we make an Uint8Array
var $07144aea14354eb9$var$indicMachine = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedIndicMachine))));
var $07144aea14354eb9$var$useData = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedUseData))));
var $07144aea14354eb9$var$trieData$2 = (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedTrie$2));
var $07144aea14354eb9$var$decompositions = $07144aea14354eb9$var$useData.decompositions;
var $07144aea14354eb9$var$trie$2 = new $07144aea14354eb9$var$unicodeTrie($07144aea14354eb9$var$trieData$2);
var $07144aea14354eb9$var$stateMachine = new $07144aea14354eb9$var$dfa($07144aea14354eb9$var$indicMachine);
/**
 * The IndicShaper supports indic scripts e.g. Devanagari, Kannada, etc.
 * Based on code from Harfbuzz: https://github.com/behdad/harfbuzz/blob/master/src/hb-ot-shape-complex-indic.cc
 */ var $07144aea14354eb9$var$IndicShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $07144aea14354eb9$var$_inheritsLoose$5(IndicShaper, _DefaultShaper);
    function IndicShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    IndicShaper.planFeatures = function planFeatures(plan) {
        plan.addStage($07144aea14354eb9$var$setupSyllables);
        plan.addStage([
            'locl',
            'ccmp'
        ]);
        plan.addStage($07144aea14354eb9$var$initialReordering);
        plan.addStage('nukt');
        plan.addStage('akhn');
        plan.addStage('rphf', false);
        plan.addStage('rkrf');
        plan.addStage('pref', false);
        plan.addStage('blwf', false);
        plan.addStage('abvf', false);
        plan.addStage('half', false);
        plan.addStage('pstf', false);
        plan.addStage('vatu');
        plan.addStage('cjct');
        plan.addStage('cfar', false);
        plan.addStage($07144aea14354eb9$var$finalReordering);
        plan.addStage({
            local: [
                'init'
            ],
            global: [
                'pres',
                'abvs',
                'blws',
                'psts',
                'haln',
                'dist',
                'abvm',
                'blwm',
                'calt',
                'clig'
            ]
        }); // Setup the indic config for the selected script
        plan.unicodeScript = $07144aea14354eb9$var$fromOpenType(plan.script);
        plan.indicConfig = $07144aea14354eb9$var$INDIC_CONFIGS[plan.unicodeScript] || $07144aea14354eb9$var$INDIC_CONFIGS.Default;
        plan.isOldSpec = plan.indicConfig.hasOldSpec && plan.script[plan.script.length - 1] !== '2'; // TODO: turn off kern (Khmer) and liga features.
    };
    IndicShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            var d = $07144aea14354eb9$var$INDIC_DECOMPOSITIONS[codepoint] || $07144aea14354eb9$var$decompositions[codepoint];
            if (d) {
                var decomposed = d.map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new $07144aea14354eb9$var$GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split matras
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return IndicShaper;
}($07144aea14354eb9$var$DefaultShaper);
$07144aea14354eb9$var$_defineProperty$2($07144aea14354eb9$var$IndicShaper, "zeroMarkWidths", 'NONE');
function $07144aea14354eb9$var$indicCategory(glyph) {
    return $07144aea14354eb9$var$trie$2.get(glyph.codePoints[0]) >> 8;
}
function $07144aea14354eb9$var$indicPosition(glyph) {
    return 1 << ($07144aea14354eb9$var$trie$2.get(glyph.codePoints[0]) & 0xff);
}
var $07144aea14354eb9$var$IndicInfo = function IndicInfo(category, position, syllableType, syllable) {
    this.category = category;
    this.position = position;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function $07144aea14354eb9$var$setupSyllables(font, glyphs) {
    var syllable = 0;
    var last = 0;
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$f($07144aea14354eb9$var$stateMachine.match(glyphs.map($07144aea14354eb9$var$indicCategory))), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
        if (start > last) {
            ++syllable;
            for(var _i = last; _i < start; _i++)glyphs[_i].shaperInfo = new $07144aea14354eb9$var$IndicInfo($07144aea14354eb9$var$CATEGORIES.X, $07144aea14354eb9$var$POSITIONS.End, 'non_indic_cluster', syllable);
        }
        ++syllable; // Create shaper info
        for(var _i2 = start; _i2 <= end; _i2++)glyphs[_i2].shaperInfo = new $07144aea14354eb9$var$IndicInfo(1 << $07144aea14354eb9$var$indicCategory(glyphs[_i2]), $07144aea14354eb9$var$indicPosition(glyphs[_i2]), tags[0], syllable);
        last = end + 1;
    }
    if (last < glyphs.length) {
        ++syllable;
        for(var i = last; i < glyphs.length; i++)glyphs[i].shaperInfo = new $07144aea14354eb9$var$IndicInfo($07144aea14354eb9$var$CATEGORIES.X, $07144aea14354eb9$var$POSITIONS.End, 'non_indic_cluster', syllable);
    }
}
function $07144aea14354eb9$var$isConsonant(glyph) {
    return glyph.shaperInfo.category & $07144aea14354eb9$var$CONSONANT_FLAGS;
}
function $07144aea14354eb9$var$isJoiner(glyph) {
    return glyph.shaperInfo.category & $07144aea14354eb9$var$JOINER_FLAGS;
}
function $07144aea14354eb9$var$isHalantOrCoeng(glyph) {
    return glyph.shaperInfo.category & $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS;
}
function $07144aea14354eb9$var$wouldSubstitute(glyphs, feature) {
    for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$f(glyphs), _step2; !(_step2 = _iterator2()).done;){
        var _glyph$features;
        var glyph = _step2.value;
        glyph.features = (_glyph$features = {}, _glyph$features[feature] = true, _glyph$features);
    }
    var GSUB = glyphs[0]._font._layoutEngine.engine.GSUBProcessor;
    GSUB.applyFeatures([
        feature
    ], glyphs);
    return glyphs.length === 1;
}
function $07144aea14354eb9$var$consonantPosition(font, consonant, virama) {
    var glyphs = [
        virama,
        consonant,
        virama
    ];
    if ($07144aea14354eb9$var$wouldSubstitute(glyphs.slice(0, 2), 'blwf') || $07144aea14354eb9$var$wouldSubstitute(glyphs.slice(1, 3), 'blwf')) return $07144aea14354eb9$var$POSITIONS.Below_C;
    else if ($07144aea14354eb9$var$wouldSubstitute(glyphs.slice(0, 2), 'pstf') || $07144aea14354eb9$var$wouldSubstitute(glyphs.slice(1, 3), 'pstf')) return $07144aea14354eb9$var$POSITIONS.Post_C;
    else if ($07144aea14354eb9$var$wouldSubstitute(glyphs.slice(0, 2), 'pref') || $07144aea14354eb9$var$wouldSubstitute(glyphs.slice(1, 3), 'pref')) return $07144aea14354eb9$var$POSITIONS.Post_C;
    return $07144aea14354eb9$var$POSITIONS.Base_C;
}
function $07144aea14354eb9$var$initialReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    var virama = font.glyphForCodePoint(indicConfig.virama).id;
    if (virama) {
        var info = new $07144aea14354eb9$var$GlyphInfo(font, virama, [
            indicConfig.virama
        ]);
        for(var i = 0; i < glyphs.length; i++)if (glyphs[i].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Base_C) glyphs[i].shaperInfo.position = $07144aea14354eb9$var$consonantPosition(font, glyphs[i].copy(), info);
    }
    for(var start = 0, end = $07144aea14354eb9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $07144aea14354eb9$var$nextSyllable(glyphs, start)){
        var _glyphs$start$shaperI = glyphs[start].shaperInfo, category = _glyphs$start$shaperI.category, syllableType = _glyphs$start$shaperI.syllableType;
        if (syllableType === 'symbol_cluster' || syllableType === 'non_indic_cluster') continue;
        if (syllableType === 'broken_cluster' && dottedCircle) {
            var g = new $07144aea14354eb9$var$GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = new $07144aea14354eb9$var$IndicInfo(1 << $07144aea14354eb9$var$indicCategory(g), $07144aea14354eb9$var$indicPosition(g), glyphs[start].shaperInfo.syllableType, glyphs[start].shaperInfo.syllable); // Insert after possible Repha.
            var _i3 = start;
            while(_i3 < end && glyphs[_i3].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.Repha)_i3++;
            glyphs.splice(_i3++, 0, g);
            end++;
        } // 1. Find base consonant:
        //
        // The shaping engine finds the base consonant of the syllable, using the
        // following algorithm: starting from the end of the syllable, move backwards
        // until a consonant is found that does not have a below-base or post-base
        // form (post-base forms have to follow below-base forms), or that is not a
        // pre-base reordering Ra, or arrive at the first consonant. The consonant
        // stopped at will be the base.
        var base = end;
        var limit = start;
        var hasReph = false; // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        if (indicConfig.rephPos !== $07144aea14354eb9$var$POSITIONS.Ra_To_Become_Reph && features.rphf && start + 3 <= end && (indicConfig.rephMode === 'Implicit' && !$07144aea14354eb9$var$isJoiner(glyphs[start + 2]) || indicConfig.rephMode === 'Explicit' && glyphs[start + 2].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.ZWJ)) {
            // See if it matches the 'rphf' feature.
            var _g = [
                glyphs[start].copy(),
                glyphs[start + 1].copy(),
                glyphs[start + 2].copy()
            ];
            if ($07144aea14354eb9$var$wouldSubstitute(_g.slice(0, 2), 'rphf') || indicConfig.rephMode === 'Explicit' && $07144aea14354eb9$var$wouldSubstitute(_g, 'rphf')) {
                limit += 2;
                while(limit < end && $07144aea14354eb9$var$isJoiner(glyphs[limit]))limit++;
                base = start;
                hasReph = true;
            }
        } else if (indicConfig.rephMode === 'Log_Repha' && glyphs[start].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.Repha) {
            limit++;
            while(limit < end && $07144aea14354eb9$var$isJoiner(glyphs[limit]))limit++;
            base = start;
            hasReph = true;
        }
        switch(indicConfig.basePos){
            case 'Last':
                // starting from the end of the syllable, move backwards
                var _i4 = end;
                var seenBelow = false;
                do {
                    var _info = glyphs[--_i4].shaperInfo; // until a consonant is found
                    if ($07144aea14354eb9$var$isConsonant(glyphs[_i4])) {
                        // that does not have a below-base or post-base form
                        // (post-base forms have to follow below-base forms),
                        if (_info.position !== $07144aea14354eb9$var$POSITIONS.Below_C && (_info.position !== $07144aea14354eb9$var$POSITIONS.Post_C || seenBelow)) {
                            base = _i4;
                            break;
                        } // or that is not a pre-base reordering Ra,
                        //
                        // IMPLEMENTATION NOTES:
                        //
                        // Our pre-base reordering Ra's are marked POS_POST_C, so will be skipped
                        // by the logic above already.
                        //
                        // or arrive at the first consonant. The consonant stopped at will
                        // be the base.
                        if (_info.position === $07144aea14354eb9$var$POSITIONS.Below_C) seenBelow = true;
                        base = _i4;
                    } else if (start < _i4 && _info.category === $07144aea14354eb9$var$CATEGORIES.ZWJ && glyphs[_i4 - 1].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.H) break;
                }while (_i4 > limit);
                break;
            case 'First':
                // The first consonant is always the base.
                base = start; // Mark all subsequent consonants as below.
                for(var _i5 = base + 1; _i5 < end; _i5++)if ($07144aea14354eb9$var$isConsonant(glyphs[_i5])) glyphs[_i5].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.Below_C;
        } // If the syllable starts with Ra + Halant (in a script that has Reph)
        // and has more than one consonant, Ra is excluded from candidates for
        // base consonants.
        //
        //  Only do this for unforced Reph. (ie. not for Ra,H,ZWJ)
        if (hasReph && base === start && limit - base <= 2) hasReph = false;
         // 2. Decompose and reorder Matras:
        //
        // Each matra and any syllable modifier sign in the cluster are moved to the
        // appropriate position relative to the consonant(s) in the cluster. The
        // shaping engine decomposes two- or three-part matras into their constituent
        // parts before any repositioning. Matra characters are classified by which
        // consonant in a conjunct they have affinity for and are reordered to the
        // following positions:
        //
        //   o Before first half form in the syllable
        //   o After subjoined consonants
        //   o After post-form consonant
        //   o After main consonant (for above marks)
        //
        // IMPLEMENTATION NOTES:
        //
        // The normalize() routine has already decomposed matras for us, so we don't
        // need to worry about that.
        // 3.  Reorder marks to canonical order:
        //
        // Adjacent nukta and halant or nukta and vedic sign are always repositioned
        // if necessary, so that the nukta is first.
        //
        // IMPLEMENTATION NOTES:
        //
        // We don't need to do this: the normalize() routine already did this for us.
        // Reorder characters
        for(var _i6 = start; _i6 < base; _i6++){
            var _info2 = glyphs[_i6].shaperInfo;
            _info2.position = Math.min($07144aea14354eb9$var$POSITIONS.Pre_C, _info2.position);
        }
        if (base < end) glyphs[base].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.Base_C;
         // Mark final consonants.  A final consonant is one appearing after a matra,
        // like in Khmer.
        for(var _i7 = base + 1; _i7 < end; _i7++)if (glyphs[_i7].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.M) {
            for(var j = _i7 + 1; j < end; j++)if ($07144aea14354eb9$var$isConsonant(glyphs[j])) {
                glyphs[j].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.Final_C;
                break;
            }
            break;
        }
         // Handle beginning Ra
        if (hasReph) glyphs[start].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.Ra_To_Become_Reph;
         // For old-style Indic script tags, move the first post-base Halant after
        // last consonant.
        //
        // Reports suggest that in some scripts Uniscribe does this only if there
        // is *not* a Halant after last consonant already (eg. Kannada), while it
        // does it unconditionally in other scripts (eg. Malayalam).  We don't
        // currently know about other scripts, so we single out Malayalam for now.
        //
        // Kannada test case:
        // U+0C9A,U+0CCD,U+0C9A,U+0CCD
        // With some versions of Lohit Kannada.
        // https://bugs.freedesktop.org/show_bug.cgi?id=59118
        //
        // Malayalam test case:
        // U+0D38,U+0D4D,U+0D31,U+0D4D,U+0D31,U+0D4D
        // With lohit-ttf-20121122/Lohit-Malayalam.ttf
        if (plan.isOldSpec) {
            var disallowDoubleHalants = plan.unicodeScript !== 'Malayalam';
            for(var _i8 = base + 1; _i8 < end; _i8++)if (glyphs[_i8].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.H) {
                var _j = void 0;
                for(_j = end - 1; _j > _i8; _j--){
                    if ($07144aea14354eb9$var$isConsonant(glyphs[_j]) || disallowDoubleHalants && glyphs[_j].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.H) break;
                }
                if (glyphs[_j].shaperInfo.category !== $07144aea14354eb9$var$CATEGORIES.H && _j > _i8) {
                    // Move Halant to after last consonant.
                    var t = glyphs[_i8];
                    glyphs.splice.apply(glyphs, [
                        _i8,
                        0
                    ].concat(glyphs.splice(_i8 + 1, _j - _i8)));
                    glyphs[_j] = t;
                }
                break;
            }
        } // Attach misc marks to previous char to move with them.
        var lastPos = $07144aea14354eb9$var$POSITIONS.Start;
        for(var _i9 = start; _i9 < end; _i9++){
            var _info3 = glyphs[_i9].shaperInfo;
            if (_info3.category & ($07144aea14354eb9$var$JOINER_FLAGS | $07144aea14354eb9$var$CATEGORIES.N | $07144aea14354eb9$var$CATEGORIES.RS | $07144aea14354eb9$var$CATEGORIES.CM | $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS & _info3.category)) {
                _info3.position = lastPos;
                if (_info3.category === $07144aea14354eb9$var$CATEGORIES.H && _info3.position === $07144aea14354eb9$var$POSITIONS.Pre_M) {
                    // Uniscribe doesn't move the Halant with Left Matra.
                    // TEST: U+092B,U+093F,U+094DE
                    // We follow.  This is important for the Sinhala
                    // U+0DDA split matra since it decomposes to U+0DD9,U+0DCA
                    // where U+0DD9 is a left matra and U+0DCA is the virama.
                    // We don't want to move the virama with the left matra.
                    // TEST: U+0D9A,U+0DDA
                    for(var _j2 = _i9; _j2 > start; _j2--)if (glyphs[_j2 - 1].shaperInfo.position !== $07144aea14354eb9$var$POSITIONS.Pre_M) {
                        _info3.position = glyphs[_j2 - 1].shaperInfo.position;
                        break;
                    }
                }
            } else if (_info3.position !== $07144aea14354eb9$var$POSITIONS.SMVD) lastPos = _info3.position;
        } // For post-base consonants let them own anything before them
        // since the last consonant or matra.
        var last = base;
        for(var _i10 = base + 1; _i10 < end; _i10++){
            if ($07144aea14354eb9$var$isConsonant(glyphs[_i10])) {
                for(var _j3 = last + 1; _j3 < _i10; _j3++)if (glyphs[_j3].shaperInfo.position < $07144aea14354eb9$var$POSITIONS.SMVD) glyphs[_j3].shaperInfo.position = glyphs[_i10].shaperInfo.position;
                last = _i10;
            } else if (glyphs[_i10].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.M) last = _i10;
        }
        var arr = glyphs.slice(start, end);
        arr.sort(function(a, b) {
            return a.shaperInfo.position - b.shaperInfo.position;
        });
        glyphs.splice.apply(glyphs, [
            start,
            arr.length
        ].concat(arr)); // Find base again
        for(var _i11 = start; _i11 < end; _i11++)if (glyphs[_i11].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Base_C) {
            base = _i11;
            break;
        }
         // Setup features now
        // Reph
        for(var _i12 = start; _i12 < end && glyphs[_i12].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Ra_To_Become_Reph; _i12++)glyphs[_i12].features.rphf = true;
         // Pre-base
        var blwf = !plan.isOldSpec && indicConfig.blwfMode === 'Pre_And_Post';
        for(var _i13 = start; _i13 < base; _i13++){
            glyphs[_i13].features.half = true;
            if (blwf) glyphs[_i13].features.blwf = true;
        } // Post-base
        for(var _i14 = base + 1; _i14 < end; _i14++){
            glyphs[_i14].features.abvf = true;
            glyphs[_i14].features.pstf = true;
            glyphs[_i14].features.blwf = true;
        }
        if (plan.isOldSpec && plan.unicodeScript === 'Devanagari') {
            // Old-spec eye-lash Ra needs special handling.  From the
            // spec:
            //
            // "The feature 'below-base form' is applied to consonants
            // having below-base forms and following the base consonant.
            // The exception is vattu, which may appear below half forms
            // as well as below the base glyph. The feature 'below-base
            // form' will be applied to all such occurrences of Ra as well."
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+0915
            // with Sanskrit 2003 font.
            //
            // However, note that Ra,Halant,ZWJ is the correct way to
            // request eyelash form of Ra, so we wouldbn't inhibit it
            // in that sequence.
            //
            // Test case: U+0924,U+094D,U+0930,U+094d,U+200D,U+0915
            for(var _i15 = start; _i15 + 1 < base; _i15++)if (glyphs[_i15].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.Ra && glyphs[_i15 + 1].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.H && (_i15 + 1 === base || glyphs[_i15 + 2].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.ZWJ)) {
                glyphs[_i15].features.blwf = true;
                glyphs[_i15 + 1].features.blwf = true;
            }
        }
        var prefLen = 2;
        if (features.pref && base + prefLen < end) // Find a Halant,Ra sequence and mark it for pre-base reordering processing.
        for(var _i16 = base + 1; _i16 + prefLen - 1 < end; _i16++){
            var _g2 = [
                glyphs[_i16].copy(),
                glyphs[_i16 + 1].copy()
            ];
            if ($07144aea14354eb9$var$wouldSubstitute(_g2, 'pref')) {
                for(var _j4 = 0; _j4 < prefLen; _j4++)glyphs[_i16++].features.pref = true;
                 // Mark the subsequent stuff with 'cfar'.  Used in Khmer.
                // Read the feature spec.
                // This allows distinguishing the following cases with MS Khmer fonts:
                // U+1784,U+17D2,U+179A,U+17D2,U+1782
                // U+1784,U+17D2,U+1782,U+17D2,U+179A
                if (features.cfar) for(; _i16 < end; _i16++)glyphs[_i16].features.cfar = true;
                break;
            }
        }
         // Apply ZWJ/ZWNJ effects
        for(var _i17 = start + 1; _i17 < end; _i17++)if ($07144aea14354eb9$var$isJoiner(glyphs[_i17])) {
            var nonJoiner = glyphs[_i17].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.ZWNJ;
            var _j5 = _i17;
            do {
                _j5--; // ZWJ/ZWNJ should disable CJCT.  They do that by simply
                // being there, since we don't skip them for the CJCT
                // feature (ie. F_MANUAL_ZWJ)
                // A ZWNJ disables HALF.
                if (nonJoiner) delete glyphs[_j5].features.half;
            }while (_j5 > start && !$07144aea14354eb9$var$isConsonant(glyphs[_j5]));
        }
    }
}
function $07144aea14354eb9$var$finalReordering(font, glyphs, plan) {
    var indicConfig = plan.indicConfig;
    var features = font._layoutEngine.engine.GSUBProcessor.features;
    for(var start = 0, end = $07144aea14354eb9$var$nextSyllable(glyphs, 0); start < glyphs.length; start = end, end = $07144aea14354eb9$var$nextSyllable(glyphs, start)){
        // 4. Final reordering:
        //
        // After the localized forms and basic shaping forms GSUB features have been
        // applied (see below), the shaping engine performs some final glyph
        // reordering before applying all the remaining font features to the entire
        // cluster.
        var tryPref = !!features.pref; // Find base again
        var base = start;
        for(; base < end; base++)if (glyphs[base].shaperInfo.position >= $07144aea14354eb9$var$POSITIONS.Base_C) {
            if (tryPref && base + 1 < end) {
                for(var i = base + 1; i < end; i++)if (glyphs[i].features.pref) {
                    if (!(glyphs[i].substituted && glyphs[i].isLigated && !glyphs[i].isMultiplied)) {
                        // Ok, this was a 'pref' candidate but didn't form any.
                        // Base is around here...
                        base = i;
                        while(base < end && $07144aea14354eb9$var$isHalantOrCoeng(glyphs[base]))base++;
                        glyphs[base].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.BASE_C;
                        tryPref = false;
                    }
                    break;
                }
            } // For Malayalam, skip over unformed below- (but NOT post-) forms.
            if (plan.unicodeScript === 'Malayalam') for(var _i18 = base + 1; _i18 < end; _i18++){
                while(_i18 < end && $07144aea14354eb9$var$isJoiner(glyphs[_i18]))_i18++;
                if (_i18 === end || !$07144aea14354eb9$var$isHalantOrCoeng(glyphs[_i18])) break;
                _i18++; // Skip halant.
                while(_i18 < end && $07144aea14354eb9$var$isJoiner(glyphs[_i18]))_i18++;
                if (_i18 < end && $07144aea14354eb9$var$isConsonant(glyphs[_i18]) && glyphs[_i18].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Below_C) {
                    base = _i18;
                    glyphs[base].shaperInfo.position = $07144aea14354eb9$var$POSITIONS.Base_C;
                }
            }
            if (start < base && glyphs[base].shaperInfo.position > $07144aea14354eb9$var$POSITIONS.Base_C) base--;
            break;
        }
        if (base === end && start < base && glyphs[base - 1].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.ZWJ) base--;
        if (base < end) while(start < base && glyphs[base].shaperInfo.category & ($07144aea14354eb9$var$CATEGORIES.N | $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS))base--;
         // o Reorder matras:
        //
        // If a pre-base matra character had been reordered before applying basic
        // features, the glyph can be moved closer to the main consonant based on
        // whether half-forms had been formed. Actual position for the matra is
        // defined as “after last standalone halant glyph, after initial matra
        // position and before the main consonant”. If ZWJ or ZWNJ follow this
        // halant, position is moved after it.
        //
        if (start + 1 < end && start < base) {
            // Otherwise there can't be any pre-base matra characters.
            // If we lost track of base, alas, position before last thingy.
            var newPos = base === end ? base - 2 : base - 1; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
            // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
            // We want to position matra after them.
            if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                while(newPos > start && !(glyphs[newPos].shaperInfo.category & ($07144aea14354eb9$var$CATEGORIES.M | $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS)))newPos--;
                 // If we found no Halant we are done.
                // Otherwise only proceed if the Halant does
                // not belong to the Matra itself!
                if ($07144aea14354eb9$var$isHalantOrCoeng(glyphs[newPos]) && glyphs[newPos].shaperInfo.position !== $07144aea14354eb9$var$POSITIONS.Pre_M) // If ZWJ or ZWNJ follow this halant, position is moved after it.
                {
                    if (newPos + 1 < end && $07144aea14354eb9$var$isJoiner(glyphs[newPos + 1])) newPos++;
                } else newPos = start; // No move.
            }
            if (start < newPos && glyphs[newPos].shaperInfo.position !== $07144aea14354eb9$var$POSITIONS.Pre_M) {
                // Now go see if there's actually any matras...
                for(var _i19 = newPos; _i19 > start; _i19--)if (glyphs[_i19 - 1].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Pre_M) {
                    var oldPos = _i19 - 1;
                    if (oldPos < base && base <= newPos) // Shouldn't actually happen.
                    base--;
                    var tmp = glyphs[oldPos];
                    glyphs.splice.apply(glyphs, [
                        oldPos,
                        0
                    ].concat(glyphs.splice(oldPos + 1, newPos - oldPos)));
                    glyphs[newPos] = tmp;
                    newPos--;
                }
            }
        } // o Reorder reph:
        //
        // Reph’s original position is always at the beginning of the syllable,
        // (i.e. it is not reordered at the character reordering stage). However,
        // it will be reordered according to the basic-forms shaping results.
        // Possible positions for reph, depending on the script, are; after main,
        // before post-base consonant forms, and after post-base consonant forms.
        // Two cases:
        //
        // - If repha is encoded as a sequence of characters (Ra,H or Ra,H,ZWJ), then
        //   we should only move it if the sequence ligated to the repha form.
        //
        // - If repha is encoded separately and in the logical position, we should only
        //   move it if it did NOT ligate.  If it ligated, it's probably the font trying
        //   to make it work without the reordering.
        if (start + 1 < end && glyphs[start].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Ra_To_Become_Reph && glyphs[start].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.Repha !== (glyphs[start].isLigated && !glyphs[start].isMultiplied)) {
            var newRephPos = void 0;
            var rephPos = indicConfig.rephPos;
            var found = false; // 1. If reph should be positioned after post-base consonant forms,
            //    proceed to step 5.
            if (rephPos !== $07144aea14354eb9$var$POSITIONS.After_Post) {
                //  2. If the reph repositioning class is not after post-base: target
                //     position is after the first explicit halant glyph between the
                //     first post-reph consonant and last main consonant. If ZWJ or ZWNJ
                //     are following this halant, position is moved after it. If such
                //     position is found, this is the target position. Otherwise,
                //     proceed to the next step.
                //
                //     Note: in old-implementation fonts, where classifications were
                //     fixed in shaping engine, there was no case where reph position
                //     will be found on this step.
                newRephPos = start + 1;
                while(newRephPos < base && !$07144aea14354eb9$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $07144aea14354eb9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $07144aea14354eb9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                } // 3. If reph should be repositioned after the main consonant: find the
                //    first consonant not ligated with main, or find the first
                //    consonant that is not a potential pre-base reordering Ra.
                if (!found && rephPos === $07144aea14354eb9$var$POSITIONS.After_Main) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && glyphs[newRephPos + 1].shaperInfo.position <= $07144aea14354eb9$var$POSITIONS.After_Main)newRephPos++;
                    found = newRephPos < end;
                } // 4. If reph should be positioned before post-base consonant, find
                //    first post-base classified consonant not ligated with main. If no
                //    consonant is found, the target position should be before the
                //    first matra, syllable modifier sign or vedic sign.
                //
                // This is our take on what step 4 is trying to say (and failing, BADLY).
                if (!found && rephPos === $07144aea14354eb9$var$POSITIONS.After_Sub) {
                    newRephPos = base;
                    while(newRephPos + 1 < end && !(glyphs[newRephPos + 1].shaperInfo.position & ($07144aea14354eb9$var$POSITIONS.Post_C | $07144aea14354eb9$var$POSITIONS.After_Post | $07144aea14354eb9$var$POSITIONS.SMVD)))newRephPos++;
                    found = newRephPos < end;
                }
            } //  5. If no consonant is found in steps 3 or 4, move reph to a position
            //     immediately before the first post-base matra, syllable modifier
            //     sign or vedic sign that has a reordering class after the intended
            //     reph position. For example, if the reordering position for reph
            //     is post-main, it will skip above-base matras that also have a
            //     post-main position.
            if (!found) {
                // Copied from step 2.
                newRephPos = start + 1;
                while(newRephPos < base && !$07144aea14354eb9$var$isHalantOrCoeng(glyphs[newRephPos]))newRephPos++;
                if (newRephPos < base && $07144aea14354eb9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    // ->If ZWJ or ZWNJ are following this halant, position is moved after it.
                    if (newRephPos + 1 < base && $07144aea14354eb9$var$isJoiner(glyphs[newRephPos + 1])) newRephPos++;
                    found = true;
                }
            } // 6. Otherwise, reorder reph to the end of the syllable.
            if (!found) {
                newRephPos = end - 1;
                while(newRephPos > start && glyphs[newRephPos].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.SMVD)newRephPos--;
                 // If the Reph is to be ending up after a Matra,Halant sequence,
                // position it before that Halant so it can interact with the Matra.
                // However, if it's a plain Consonant,Halant we shouldn't do that.
                // Uniscribe doesn't do this.
                // TEST: U+0930,U+094D,U+0915,U+094B,U+094D
                if ($07144aea14354eb9$var$isHalantOrCoeng(glyphs[newRephPos])) {
                    for(var _i20 = base + 1; _i20 < newRephPos; _i20++)if (glyphs[_i20].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.M) newRephPos--;
                }
            }
            var reph = glyphs[start];
            glyphs.splice.apply(glyphs, [
                start,
                0
            ].concat(glyphs.splice(start + 1, newRephPos - start)));
            glyphs[newRephPos] = reph;
            if (start < base && base <= newRephPos) base--;
        } // o Reorder pre-base reordering consonants:
        //
        // If a pre-base reordering consonant is found, reorder it according to
        // the following rules:
        if (tryPref && base + 1 < end) {
            for(var _i21 = base + 1; _i21 < end; _i21++)if (glyphs[_i21].features.pref) {
                // 1. Only reorder a glyph produced by substitution during application
                //    of the <pref> feature. (Note that a font may shape a Ra consonant with
                //    the feature generally but block it in certain contexts.)
                // Note: We just check that something got substituted.  We don't check that
                // the <pref> feature actually did it...
                //
                // Reorder pref only if it ligated.
                if (glyphs[_i21].isLigated && !glyphs[_i21].isMultiplied) {
                    // 2. Try to find a target position the same way as for pre-base matra.
                    //    If it is found, reorder pre-base consonant glyph.
                    //
                    // 3. If position is not found, reorder immediately before main
                    //    consonant.
                    var _newPos = base; // Malayalam / Tamil do not have "half" forms or explicit virama forms.
                    // The glyphs formed by 'half' are Chillus or ligated explicit viramas.
                    // We want to position matra after them.
                    if (plan.unicodeScript !== 'Malayalam' && plan.unicodeScript !== 'Tamil') {
                        while(_newPos > start && !(glyphs[_newPos - 1].shaperInfo.category & ($07144aea14354eb9$var$CATEGORIES.M | $07144aea14354eb9$var$HALANT_OR_COENG_FLAGS)))_newPos--;
                         // In Khmer coeng model, a H,Ra can go *after* matras.  If it goes after a
                        // split matra, it should be reordered to *before* the left part of such matra.
                        if (_newPos > start && glyphs[_newPos - 1].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.M) {
                            var _oldPos2 = _i21;
                            for(var j = base + 1; j < _oldPos2; j++)if (glyphs[j].shaperInfo.category === $07144aea14354eb9$var$CATEGORIES.M) {
                                _newPos--;
                                break;
                            }
                        }
                    }
                    if (_newPos > start && $07144aea14354eb9$var$isHalantOrCoeng(glyphs[_newPos - 1])) // -> If ZWJ or ZWNJ follow this halant, position is moved after it.
                    {
                        if (_newPos < end && $07144aea14354eb9$var$isJoiner(glyphs[_newPos])) _newPos++;
                    }
                    var _oldPos = _i21;
                    var _tmp = glyphs[_oldPos];
                    glyphs.splice.apply(glyphs, [
                        _newPos + 1,
                        0
                    ].concat(glyphs.splice(_newPos, _oldPos - _newPos)));
                    glyphs[_newPos] = _tmp;
                    if (_newPos <= base && base < _oldPos) base++;
                }
                break;
            }
        } // Apply 'init' to the Left Matra if it's a word start.
        if (glyphs[start].shaperInfo.position === $07144aea14354eb9$var$POSITIONS.Pre_M && (!start || !/Cf|Mn/.test($07144aea14354eb9$var$unicode.getCategory(glyphs[start - 1].codePoints[0])))) glyphs[start].features.init = true;
    }
}
function $07144aea14354eb9$var$nextSyllable(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
var $07144aea14354eb9$var$base64DeflatedTrie$3 = "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";
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$g(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$g(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$g(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$g(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$g(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$g(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$6(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
function $07144aea14354eb9$var$_defineProperty$3(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
// we may be running in a browser so we make an Uint8Array
var $07144aea14354eb9$var$useData$1 = JSON.parse(String.fromCharCode.apply(String, (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedUseData))));
var $07144aea14354eb9$var$trieData$3 = (0, (/*@__PURE__*/$parcel$interopDefault($czuCz))).inflate($07144aea14354eb9$var$base64Arraybuffer_2($07144aea14354eb9$var$base64DeflatedTrie$3));
var $07144aea14354eb9$var$categories = $07144aea14354eb9$var$useData$1.categories, $07144aea14354eb9$var$decompositions$1 = $07144aea14354eb9$var$useData$1.decompositions;
var $07144aea14354eb9$var$trie$3 = new $07144aea14354eb9$var$unicodeTrie($07144aea14354eb9$var$trieData$3);
var $07144aea14354eb9$var$stateMachine$1 = new $07144aea14354eb9$var$dfa($07144aea14354eb9$var$useData$1);
/**
 * This shaper is an implementation of the Universal Shaping Engine, which
 * uses Unicode data to shape a number of scripts without a dedicated shaping engine.
 * See https://www.microsoft.com/typography/OpenTypeDev/USE/intro.htm.
 */ var $07144aea14354eb9$var$UniversalShaper = /*#__PURE__*/ function(_DefaultShaper) {
    $07144aea14354eb9$var$_inheritsLoose$6(UniversalShaper, _DefaultShaper);
    function UniversalShaper() {
        return _DefaultShaper.apply(this, arguments) || this;
    }
    UniversalShaper.planFeatures = function planFeatures(plan) {
        plan.addStage($07144aea14354eb9$var$setupSyllables$1); // Default glyph pre-processing group
        plan.addStage([
            'locl',
            'ccmp',
            'nukt',
            'akhn'
        ]); // Reordering group
        plan.addStage($07144aea14354eb9$var$clearSubstitutionFlags);
        plan.addStage([
            'rphf'
        ], false);
        plan.addStage($07144aea14354eb9$var$recordRphf);
        plan.addStage($07144aea14354eb9$var$clearSubstitutionFlags);
        plan.addStage([
            'pref'
        ]);
        plan.addStage($07144aea14354eb9$var$recordPref); // Orthographic unit shaping group
        plan.addStage([
            'rkrf',
            'abvf',
            'blwf',
            'half',
            'pstf',
            'vatu',
            'cjct'
        ]);
        plan.addStage($07144aea14354eb9$var$reorder); // Topographical features
        // Scripts that need this are handled by the Arabic shaper, not implemented here for now.
        // plan.addStage(['isol', 'init', 'medi', 'fina', 'med2', 'fin2', 'fin3'], false);
        // Standard topographic presentation and positional feature application
        plan.addStage([
            'abvs',
            'blws',
            'pres',
            'psts',
            'dist',
            'abvm',
            'blwm'
        ]);
    };
    UniversalShaper.assignFeatures = function assignFeatures(plan, glyphs) {
        var _loop = function _loop(i) {
            var codepoint = glyphs[i].codePoints[0];
            if ($07144aea14354eb9$var$decompositions$1[codepoint]) {
                var decomposed = $07144aea14354eb9$var$decompositions$1[codepoint].map(function(c) {
                    var g = plan.font.glyphForCodePoint(c);
                    return new $07144aea14354eb9$var$GlyphInfo(plan.font, g.id, [
                        c
                    ], glyphs[i].features);
                });
                glyphs.splice.apply(glyphs, [
                    i,
                    1
                ].concat(decomposed));
            }
        };
        // Decompose split vowels
        // TODO: do this in a more general unicode normalizer
        for(var i = glyphs.length - 1; i >= 0; i--)_loop(i);
    };
    return UniversalShaper;
}($07144aea14354eb9$var$DefaultShaper);
$07144aea14354eb9$var$_defineProperty$3($07144aea14354eb9$var$UniversalShaper, "zeroMarkWidths", 'BEFORE_GPOS');
function $07144aea14354eb9$var$useCategory(glyph) {
    return $07144aea14354eb9$var$trie$3.get(glyph.codePoints[0]);
}
var $07144aea14354eb9$var$USEInfo = function USEInfo(category, syllableType, syllable) {
    this.category = category;
    this.syllableType = syllableType;
    this.syllable = syllable;
};
function $07144aea14354eb9$var$setupSyllables$1(font, glyphs) {
    var syllable = 0;
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$g($07144aea14354eb9$var$stateMachine$1.match(glyphs.map($07144aea14354eb9$var$useCategory))), _step; !(_step = _iterator()).done;){
        var _step$value = _step.value, start = _step$value[0], end = _step$value[1], tags = _step$value[2];
        ++syllable; // Create shaper info
        for(var i = start; i <= end; i++)glyphs[i].shaperInfo = new $07144aea14354eb9$var$USEInfo($07144aea14354eb9$var$categories[$07144aea14354eb9$var$useCategory(glyphs[i])], tags[0], syllable);
         // Assign rphf feature
        var limit = glyphs[start].shaperInfo.category === 'R' ? 1 : Math.min(3, end - start);
        for(var _i = start; _i < start + limit; _i++)glyphs[_i].features.rphf = true;
    }
}
function $07144aea14354eb9$var$clearSubstitutionFlags(font, glyphs) {
    for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$g(glyphs), _step2; !(_step2 = _iterator2()).done;){
        var glyph = _step2.value;
        glyph.substituted = false;
    }
}
function $07144aea14354eb9$var$recordRphf(font, glyphs) {
    for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$g(glyphs), _step3; !(_step3 = _iterator3()).done;){
        var glyph = _step3.value;
        if (glyph.substituted && glyph.features.rphf) // Mark a substituted repha.
        glyph.shaperInfo.category = 'R';
    }
}
function $07144aea14354eb9$var$recordPref(font, glyphs) {
    for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$g(glyphs), _step4; !(_step4 = _iterator4()).done;){
        var glyph = _step4.value;
        if (glyph.substituted) // Mark a substituted pref as VPre, as they behave the same way.
        glyph.shaperInfo.category = 'VPre';
    }
}
function $07144aea14354eb9$var$reorder(font, glyphs) {
    var dottedCircle = font.glyphForCodePoint(0x25cc).id;
    for(var start = 0, end = $07144aea14354eb9$var$nextSyllable$1(glyphs, 0); start < glyphs.length; start = end, end = $07144aea14354eb9$var$nextSyllable$1(glyphs, start)){
        var i = void 0, j = void 0;
        var info = glyphs[start].shaperInfo;
        var type = info.syllableType; // Only a few syllable types need reordering.
        if (type !== 'virama_terminated_cluster' && type !== 'standard_cluster' && type !== 'broken_cluster') continue;
         // Insert a dotted circle glyph in broken clusters.
        if (type === 'broken_cluster' && dottedCircle) {
            var g = new $07144aea14354eb9$var$GlyphInfo(font, dottedCircle, [
                0x25cc
            ]);
            g.shaperInfo = info; // Insert after possible Repha.
            for(i = start; i < end && glyphs[i].shaperInfo.category === 'R'; i++);
            glyphs.splice(++i, 0, g);
            end++;
        } // Move things forward.
        if (info.category === 'R' && end - start > 1) // Got a repha. Reorder it to after first base, before first halant.
        for(i = start + 1; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($07144aea14354eb9$var$isBase(info) || $07144aea14354eb9$var$isHalant(glyphs[i])) {
                // If we hit a halant, move before it; otherwise it's a base: move to it's
                // place, and shift things in between backward.
                if ($07144aea14354eb9$var$isHalant(glyphs[i])) i--;
                glyphs.splice.apply(glyphs, [
                    start,
                    0
                ].concat(glyphs.splice(start + 1, i - start), [
                    glyphs[i]
                ]));
                break;
            }
        }
         // Move things back.
        for(i = start, j = end; i < end; i++){
            info = glyphs[i].shaperInfo;
            if ($07144aea14354eb9$var$isBase(info) || $07144aea14354eb9$var$isHalant(glyphs[i])) // If we hit a halant, move after it; otherwise it's a base: move to it's
            // place, and shift things in between backward.
            j = $07144aea14354eb9$var$isHalant(glyphs[i]) ? i + 1 : i;
            else if ((info.category === 'VPre' || info.category === 'VMPre') && j < i) glyphs.splice.apply(glyphs, [
                j,
                1,
                glyphs[i]
            ].concat(glyphs.splice(j, i - j)));
        }
    }
}
function $07144aea14354eb9$var$nextSyllable$1(glyphs, start) {
    if (start >= glyphs.length) return start;
    var syllable = glyphs[start].shaperInfo.syllable;
    while(++start < glyphs.length && glyphs[start].shaperInfo.syllable === syllable);
    return start;
}
function $07144aea14354eb9$var$isHalant(glyph) {
    return glyph.shaperInfo.category === 'H' && !glyph.isLigated;
}
function $07144aea14354eb9$var$isBase(info) {
    return info.category === 'B' || info.category === 'GB';
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$h(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$h(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$h(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$h(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$h(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$h(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$SHAPERS = {
    arab: $07144aea14354eb9$var$ArabicShaper,
    // Arabic
    mong: $07144aea14354eb9$var$ArabicShaper,
    // Mongolian
    syrc: $07144aea14354eb9$var$ArabicShaper,
    // Syriac
    'nko ': $07144aea14354eb9$var$ArabicShaper,
    // N'Ko
    phag: $07144aea14354eb9$var$ArabicShaper,
    // Phags Pa
    mand: $07144aea14354eb9$var$ArabicShaper,
    // Mandaic
    mani: $07144aea14354eb9$var$ArabicShaper,
    // Manichaean
    phlp: $07144aea14354eb9$var$ArabicShaper,
    // Psalter Pahlavi
    hang: $07144aea14354eb9$var$HangulShaper,
    // Hangul
    bng2: $07144aea14354eb9$var$IndicShaper,
    // Bengali
    beng: $07144aea14354eb9$var$IndicShaper,
    // Bengali
    dev2: $07144aea14354eb9$var$IndicShaper,
    // Devanagari
    deva: $07144aea14354eb9$var$IndicShaper,
    // Devanagari
    gjr2: $07144aea14354eb9$var$IndicShaper,
    // Gujarati
    gujr: $07144aea14354eb9$var$IndicShaper,
    // Gujarati
    guru: $07144aea14354eb9$var$IndicShaper,
    // Gurmukhi
    gur2: $07144aea14354eb9$var$IndicShaper,
    // Gurmukhi
    knda: $07144aea14354eb9$var$IndicShaper,
    // Kannada
    knd2: $07144aea14354eb9$var$IndicShaper,
    // Kannada
    mlm2: $07144aea14354eb9$var$IndicShaper,
    // Malayalam
    mlym: $07144aea14354eb9$var$IndicShaper,
    // Malayalam
    ory2: $07144aea14354eb9$var$IndicShaper,
    // Oriya
    orya: $07144aea14354eb9$var$IndicShaper,
    // Oriya
    taml: $07144aea14354eb9$var$IndicShaper,
    // Tamil
    tml2: $07144aea14354eb9$var$IndicShaper,
    // Tamil
    telu: $07144aea14354eb9$var$IndicShaper,
    // Telugu
    tel2: $07144aea14354eb9$var$IndicShaper,
    // Telugu
    khmr: $07144aea14354eb9$var$IndicShaper,
    // Khmer
    bali: $07144aea14354eb9$var$UniversalShaper,
    // Balinese
    batk: $07144aea14354eb9$var$UniversalShaper,
    // Batak
    brah: $07144aea14354eb9$var$UniversalShaper,
    // Brahmi
    bugi: $07144aea14354eb9$var$UniversalShaper,
    // Buginese
    buhd: $07144aea14354eb9$var$UniversalShaper,
    // Buhid
    cakm: $07144aea14354eb9$var$UniversalShaper,
    // Chakma
    cham: $07144aea14354eb9$var$UniversalShaper,
    // Cham
    dupl: $07144aea14354eb9$var$UniversalShaper,
    // Duployan
    egyp: $07144aea14354eb9$var$UniversalShaper,
    // Egyptian Hieroglyphs
    gran: $07144aea14354eb9$var$UniversalShaper,
    // Grantha
    hano: $07144aea14354eb9$var$UniversalShaper,
    // Hanunoo
    java: $07144aea14354eb9$var$UniversalShaper,
    // Javanese
    kthi: $07144aea14354eb9$var$UniversalShaper,
    // Kaithi
    kali: $07144aea14354eb9$var$UniversalShaper,
    // Kayah Li
    khar: $07144aea14354eb9$var$UniversalShaper,
    // Kharoshthi
    khoj: $07144aea14354eb9$var$UniversalShaper,
    // Khojki
    sind: $07144aea14354eb9$var$UniversalShaper,
    // Khudawadi
    lepc: $07144aea14354eb9$var$UniversalShaper,
    // Lepcha
    limb: $07144aea14354eb9$var$UniversalShaper,
    // Limbu
    mahj: $07144aea14354eb9$var$UniversalShaper,
    // Mahajani
    // mand: UniversalShaper, // Mandaic
    // mani: UniversalShaper, // Manichaean
    mtei: $07144aea14354eb9$var$UniversalShaper,
    // Meitei Mayek
    modi: $07144aea14354eb9$var$UniversalShaper,
    // Modi
    // mong: UniversalShaper, // Mongolian
    // 'nko ': UniversalShaper, // N’Ko
    hmng: $07144aea14354eb9$var$UniversalShaper,
    // Pahawh Hmong
    // phag: UniversalShaper, // Phags-pa
    // phlp: UniversalShaper, // Psalter Pahlavi
    rjng: $07144aea14354eb9$var$UniversalShaper,
    // Rejang
    saur: $07144aea14354eb9$var$UniversalShaper,
    // Saurashtra
    shrd: $07144aea14354eb9$var$UniversalShaper,
    // Sharada
    sidd: $07144aea14354eb9$var$UniversalShaper,
    // Siddham
    sinh: $07144aea14354eb9$var$UniversalShaper,
    // Sinhala
    sund: $07144aea14354eb9$var$UniversalShaper,
    // Sundanese
    sylo: $07144aea14354eb9$var$UniversalShaper,
    // Syloti Nagri
    tglg: $07144aea14354eb9$var$UniversalShaper,
    // Tagalog
    tagb: $07144aea14354eb9$var$UniversalShaper,
    // Tagbanwa
    tale: $07144aea14354eb9$var$UniversalShaper,
    // Tai Le
    lana: $07144aea14354eb9$var$UniversalShaper,
    // Tai Tham
    tavt: $07144aea14354eb9$var$UniversalShaper,
    // Tai Viet
    takr: $07144aea14354eb9$var$UniversalShaper,
    // Takri
    tibt: $07144aea14354eb9$var$UniversalShaper,
    // Tibetan
    tfng: $07144aea14354eb9$var$UniversalShaper,
    // Tifinagh
    tirh: $07144aea14354eb9$var$UniversalShaper,
    // Tirhuta
    latn: $07144aea14354eb9$var$DefaultShaper,
    // Latin
    DFLT: $07144aea14354eb9$var$DefaultShaper // Default
};
function $07144aea14354eb9$var$choose(script) {
    if (!Array.isArray(script)) script = [
        script
    ];
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$h(script), _step; !(_step = _iterator()).done;){
        var s = _step.value;
        var shaper = $07144aea14354eb9$var$SHAPERS[s];
        if (shaper) return shaper;
    }
    return $07144aea14354eb9$var$DefaultShaper;
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$i(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$i(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$i(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$i(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$i(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$i(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$7(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$GSUBProcessor = /*#__PURE__*/ function(_OTProcessor) {
    $07144aea14354eb9$var$_inheritsLoose$7(GSUBProcessor, _OTProcessor);
    function GSUBProcessor() {
        return _OTProcessor.apply(this, arguments) || this;
    }
    var _proto = GSUBProcessor.prototype;
    _proto.applyLookup = function applyLookup(lookupType, table) {
        var _this = this;
        switch(lookupType){
            case 1:
                // Single Substitution
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                var glyph = this.glyphIterator.cur;
                switch(table.version){
                    case 1:
                        glyph.id = glyph.id + table.deltaGlyphID & 0xffff;
                        break;
                    case 2:
                        glyph.id = table.substitute.get(index);
                        break;
                }
                return true;
            case 2:
                // Multiple Substitution
                var _index = this.coverageIndex(table.coverage);
                if (_index !== -1) {
                    var _this$glyphs;
                    var sequence = table.sequences.get(_index);
                    this.glyphIterator.cur.id = sequence[0];
                    this.glyphIterator.cur.ligatureComponent = 0;
                    var features = this.glyphIterator.cur.features;
                    var curGlyph = this.glyphIterator.cur;
                    var replacement = sequence.slice(1).map(function(gid, i) {
                        var glyph = new $07144aea14354eb9$var$GlyphInfo(_this.font, gid, undefined, features);
                        glyph.shaperInfo = curGlyph.shaperInfo;
                        glyph.isLigated = curGlyph.isLigated;
                        glyph.ligatureComponent = i + 1;
                        glyph.substituted = true;
                        glyph.isMultiplied = true;
                        return glyph;
                    });
                    (_this$glyphs = this.glyphs).splice.apply(_this$glyphs, [
                        this.glyphIterator.index + 1,
                        0
                    ].concat(replacement));
                    return true;
                }
                return false;
            case 3:
                // Alternate Substitution
                var _index2 = this.coverageIndex(table.coverage);
                if (_index2 !== -1) {
                    var USER_INDEX = 0; // TODO
                    this.glyphIterator.cur.id = table.alternateSet.get(_index2)[USER_INDEX];
                    return true;
                }
                return false;
            case 4:
                // Ligature Substitution
                var _index3 = this.coverageIndex(table.coverage);
                if (_index3 === -1) return false;
                for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$i(table.ligatureSets.get(_index3)), _step; !(_step = _iterator()).done;){
                    var ligature = _step.value;
                    var matched = this.sequenceMatchIndices(1, ligature.components);
                    if (!matched) continue;
                    var _curGlyph = this.glyphIterator.cur; // Concatenate all of the characters the new ligature will represent
                    var characters = _curGlyph.codePoints.slice();
                    for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$i(matched), _step2; !(_step2 = _iterator2()).done;){
                        var _index4 = _step2.value;
                        characters.push.apply(characters, this.glyphs[_index4].codePoints);
                    } // Create the replacement ligature glyph
                    var ligatureGlyph = new $07144aea14354eb9$var$GlyphInfo(this.font, ligature.glyph, characters, _curGlyph.features);
                    ligatureGlyph.shaperInfo = _curGlyph.shaperInfo;
                    ligatureGlyph.isLigated = true;
                    ligatureGlyph.substituted = true; // From Harfbuzz:
                    // - If it *is* a mark ligature, we don't allocate a new ligature id, and leave
                    //   the ligature to keep its old ligature id.  This will allow it to attach to
                    //   a base ligature in GPOS.  Eg. if the sequence is: LAM,LAM,SHADDA,FATHA,HEH,
                    //   and LAM,LAM,HEH for a ligature, they will leave SHADDA and FATHA with a
                    //   ligature id and component value of 2.  Then if SHADDA,FATHA form a ligature
                    //   later, we don't want them to lose their ligature id/component, otherwise
                    //   GPOS will fail to correctly position the mark ligature on top of the
                    //   LAM,LAM,HEH ligature. See https://bugzilla.gnome.org/show_bug.cgi?id=676343
                    //
                    // - If a ligature is formed of components that some of which are also ligatures
                    //   themselves, and those ligature components had marks attached to *their*
                    //   components, we have to attach the marks to the new ligature component
                    //   positions!  Now *that*'s tricky!  And these marks may be following the
                    //   last component of the whole sequence, so we should loop forward looking
                    //   for them and update them.
                    //
                    //   Eg. the sequence is LAM,LAM,SHADDA,FATHA,HEH, and the font first forms a
                    //   'calt' ligature of LAM,HEH, leaving the SHADDA and FATHA with a ligature
                    //   id and component == 1.  Now, during 'liga', the LAM and the LAM-HEH ligature
                    //   form a LAM-LAM-HEH ligature.  We need to reassign the SHADDA and FATHA to
                    //   the new ligature with a component value of 2.
                    //
                    //   This in fact happened to a font...  See https://bugzilla.gnome.org/show_bug.cgi?id=437633
                    var isMarkLigature = _curGlyph.isMark;
                    for(var i = 0; i < matched.length && isMarkLigature; i++)isMarkLigature = this.glyphs[matched[i]].isMark;
                    ligatureGlyph.ligatureID = isMarkLigature ? null : this.ligatureID++;
                    var lastLigID = _curGlyph.ligatureID;
                    var lastNumComps = _curGlyph.codePoints.length;
                    var curComps = lastNumComps;
                    var idx = this.glyphIterator.index + 1; // Set ligatureID and ligatureComponent on glyphs that were skipped in the matched sequence.
                    // This allows GPOS to attach marks to the correct ligature components.
                    for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$i(matched), _step3; !(_step3 = _iterator3()).done;){
                        var matchIndex = _step3.value;
                        // Don't assign new ligature components for mark ligatures (see above)
                        if (isMarkLigature) idx = matchIndex;
                        else while(idx < matchIndex){
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[idx].ligatureComponent || 1, lastNumComps);
                            this.glyphs[idx].ligatureID = ligatureGlyph.ligatureID;
                            this.glyphs[idx].ligatureComponent = ligatureComponent;
                            idx++;
                        }
                        lastLigID = this.glyphs[idx].ligatureID;
                        lastNumComps = this.glyphs[idx].codePoints.length;
                        curComps += lastNumComps;
                        idx++; // skip base glyph
                    } // Adjust ligature components for any marks following
                    if (lastLigID && !isMarkLigature) for(var _i = idx; _i < this.glyphs.length; _i++){
                        if (this.glyphs[_i].ligatureID === lastLigID) {
                            var ligatureComponent = curComps - lastNumComps + Math.min(this.glyphs[_i].ligatureComponent || 1, lastNumComps);
                            this.glyphs[_i].ligatureComponent = ligatureComponent;
                        } else break;
                    }
                     // Delete the matched glyphs, and replace the current glyph with the ligature glyph
                    for(var _i2 = matched.length - 1; _i2 >= 0; _i2--)this.glyphs.splice(matched[_i2], 1);
                    this.glyphs[this.glyphIterator.index] = ligatureGlyph;
                    return true;
                }
                return false;
            case 5:
                // Contextual Substitution
                return this.applyContext(table);
            case 6:
                // Chaining Contextual Substitution
                return this.applyChainingContext(table);
            case 7:
                // Extension Substitution
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error("GSUB lookupType " + lookupType + " is not supported");
        }
    };
    return GSUBProcessor;
}($07144aea14354eb9$var$OTProcessor);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$j(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$j(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$j(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$j(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$j(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$j(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$8(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$GPOSProcessor = /*#__PURE__*/ function(_OTProcessor) {
    $07144aea14354eb9$var$_inheritsLoose$8(GPOSProcessor, _OTProcessor);
    function GPOSProcessor() {
        return _OTProcessor.apply(this, arguments) || this;
    }
    var _proto = GPOSProcessor.prototype;
    _proto.applyPositionValue = function applyPositionValue(sequenceIndex, value) {
        var position = this.positions[this.glyphIterator.peekIndex(sequenceIndex)];
        if (value.xAdvance != null) position.xAdvance += value.xAdvance;
        if (value.yAdvance != null) position.yAdvance += value.yAdvance;
        if (value.xPlacement != null) position.xOffset += value.xPlacement;
        if (value.yPlacement != null) position.yOffset += value.yPlacement;
         // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (value.xPlaDevice) position.xOffset += variationProcessor.getDelta(variationStore, value.xPlaDevice.a, value.xPlaDevice.b);
            if (value.yPlaDevice) position.yOffset += variationProcessor.getDelta(variationStore, value.yPlaDevice.a, value.yPlaDevice.b);
            if (value.xAdvDevice) position.xAdvance += variationProcessor.getDelta(variationStore, value.xAdvDevice.a, value.xAdvDevice.b);
            if (value.yAdvDevice) position.yAdvance += variationProcessor.getDelta(variationStore, value.yAdvDevice.a, value.yAdvDevice.b);
        } // TODO: device tables
    };
    _proto.applyLookup = function applyLookup(lookupType, table) {
        switch(lookupType){
            case 1:
                // Single positioning value
                var index = this.coverageIndex(table.coverage);
                if (index === -1) return false;
                switch(table.version){
                    case 1:
                        this.applyPositionValue(0, table.value);
                        break;
                    case 2:
                        this.applyPositionValue(0, table.values.get(index));
                        break;
                }
                return true;
            case 2:
                // Pair Adjustment Positioning
                var nextGlyph = this.glyphIterator.peek();
                if (!nextGlyph) return false;
                var _index = this.coverageIndex(table.coverage);
                if (_index === -1) return false;
                switch(table.version){
                    case 1:
                        // Adjustments for glyph pairs
                        var set = table.pairSets.get(_index);
                        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$j(set), _step; !(_step = _iterator()).done;){
                            var _pair = _step.value;
                            if (_pair.secondGlyph === nextGlyph.id) {
                                this.applyPositionValue(0, _pair.value1);
                                this.applyPositionValue(1, _pair.value2);
                                return true;
                            }
                        }
                        return false;
                    case 2:
                        // Class pair adjustment
                        var class1 = this.getClassID(this.glyphIterator.cur.id, table.classDef1);
                        var class2 = this.getClassID(nextGlyph.id, table.classDef2);
                        if (class1 === -1 || class2 === -1) return false;
                        var pair = table.classRecords.get(class1).get(class2);
                        this.applyPositionValue(0, pair.value1);
                        this.applyPositionValue(1, pair.value2);
                        return true;
                }
            case 3:
                // Cursive Attachment Positioning
                var nextIndex = this.glyphIterator.peekIndex();
                var _nextGlyph = this.glyphs[nextIndex];
                if (!_nextGlyph) return false;
                var curRecord = table.entryExitRecords[this.coverageIndex(table.coverage)];
                if (!curRecord || !curRecord.exitAnchor) return false;
                var nextRecord = table.entryExitRecords[this.coverageIndex(table.coverage, _nextGlyph.id)];
                if (!nextRecord || !nextRecord.entryAnchor) return false;
                var entry = this.getAnchor(nextRecord.entryAnchor);
                var exit = this.getAnchor(curRecord.exitAnchor);
                var cur = this.positions[this.glyphIterator.index];
                var next = this.positions[nextIndex];
                switch(this.direction){
                    case 'ltr':
                        cur.xAdvance = exit.x + cur.xOffset;
                        var d = entry.x + next.xOffset;
                        next.xAdvance -= d;
                        next.xOffset -= d;
                        break;
                    case 'rtl':
                        d = exit.x + cur.xOffset;
                        cur.xAdvance -= d;
                        cur.xOffset -= d;
                        next.xAdvance = entry.x + next.xOffset;
                        break;
                }
                if (this.glyphIterator.flags.rightToLeft) {
                    this.glyphIterator.cur.cursiveAttachment = nextIndex;
                    cur.yOffset = entry.y - exit.y;
                } else {
                    _nextGlyph.cursiveAttachment = this.glyphIterator.index;
                    cur.yOffset = exit.y - entry.y;
                }
                return true;
            case 4:
                // Mark to base positioning
                var markIndex = this.coverageIndex(table.markCoverage);
                if (markIndex === -1) return false;
                 // search backward for a base glyph
                var baseGlyphIndex = this.glyphIterator.index;
                while(--baseGlyphIndex >= 0 && (this.glyphs[baseGlyphIndex].isMark || this.glyphs[baseGlyphIndex].ligatureComponent > 0));
                if (baseGlyphIndex < 0) return false;
                var baseIndex = this.coverageIndex(table.baseCoverage, this.glyphs[baseGlyphIndex].id);
                if (baseIndex === -1) return false;
                var markRecord = table.markArray[markIndex];
                var baseAnchor = table.baseArray[baseIndex][markRecord["class"]];
                this.applyAnchor(markRecord, baseAnchor, baseGlyphIndex);
                return true;
            case 5:
                // Mark to ligature positioning
                var _markIndex = this.coverageIndex(table.markCoverage);
                if (_markIndex === -1) return false;
                 // search backward for a base glyph
                var _baseGlyphIndex = this.glyphIterator.index;
                while(--_baseGlyphIndex >= 0 && this.glyphs[_baseGlyphIndex].isMark);
                if (_baseGlyphIndex < 0) return false;
                var ligIndex = this.coverageIndex(table.ligatureCoverage, this.glyphs[_baseGlyphIndex].id);
                if (ligIndex === -1) return false;
                var ligAttach = table.ligatureArray[ligIndex];
                var markGlyph = this.glyphIterator.cur;
                var ligGlyph = this.glyphs[_baseGlyphIndex];
                var compIndex = ligGlyph.ligatureID && ligGlyph.ligatureID === markGlyph.ligatureID && markGlyph.ligatureComponent > 0 ? Math.min(markGlyph.ligatureComponent, ligGlyph.codePoints.length) - 1 : ligGlyph.codePoints.length - 1;
                var _markRecord = table.markArray[_markIndex];
                var _baseAnchor = ligAttach[compIndex][_markRecord["class"]];
                this.applyAnchor(_markRecord, _baseAnchor, _baseGlyphIndex);
                return true;
            case 6:
                // Mark to mark positioning
                var mark1Index = this.coverageIndex(table.mark1Coverage);
                if (mark1Index === -1) return false;
                 // get the previous mark to attach to
                var prevIndex = this.glyphIterator.peekIndex(-1);
                var prev = this.glyphs[prevIndex];
                if (!prev || !prev.isMark) return false;
                var _cur = this.glyphIterator.cur; // The following logic was borrowed from Harfbuzz
                var good = false;
                if (_cur.ligatureID === prev.ligatureID) {
                    if (!_cur.ligatureID) // Marks belonging to the same base
                    good = true;
                    else if (_cur.ligatureComponent === prev.ligatureComponent) // Marks belonging to the same ligature component
                    good = true;
                } else // If ligature ids don't match, it may be the case that one of the marks
                // itself is a ligature, in which case match.
                if (_cur.ligatureID && !_cur.ligatureComponent || prev.ligatureID && !prev.ligatureComponent) good = true;
                if (!good) return false;
                var mark2Index = this.coverageIndex(table.mark2Coverage, prev.id);
                if (mark2Index === -1) return false;
                var _markRecord2 = table.mark1Array[mark1Index];
                var _baseAnchor2 = table.mark2Array[mark2Index][_markRecord2["class"]];
                this.applyAnchor(_markRecord2, _baseAnchor2, prevIndex);
                return true;
            case 7:
                // Contextual positioning
                return this.applyContext(table);
            case 8:
                // Chaining contextual positioning
                return this.applyChainingContext(table);
            case 9:
                // Extension positioning
                return this.applyLookup(table.lookupType, table.extension);
            default:
                throw new Error("Unsupported GPOS table: " + lookupType);
        }
    };
    _proto.applyAnchor = function applyAnchor(markRecord, baseAnchor, baseGlyphIndex) {
        var baseCoords = this.getAnchor(baseAnchor);
        var markCoords = this.getAnchor(markRecord.markAnchor);
        var basePos = this.positions[baseGlyphIndex];
        var markPos = this.positions[this.glyphIterator.index];
        markPos.xOffset = baseCoords.x - markCoords.x;
        markPos.yOffset = baseCoords.y - markCoords.y;
        this.glyphIterator.cur.markAttachment = baseGlyphIndex;
    };
    _proto.getAnchor = function getAnchor(anchor) {
        // TODO: contour point, device tables
        var x = anchor.xCoordinate;
        var y = anchor.yCoordinate; // Adjustments for font variations
        var variationProcessor = this.font._variationProcessor;
        var variationStore = this.font.GDEF && this.font.GDEF.itemVariationStore;
        if (variationProcessor && variationStore) {
            if (anchor.xDeviceTable) x += variationProcessor.getDelta(variationStore, anchor.xDeviceTable.a, anchor.xDeviceTable.b);
            if (anchor.yDeviceTable) y += variationProcessor.getDelta(variationStore, anchor.yDeviceTable.a, anchor.yDeviceTable.b);
        }
        return {
            x: x,
            y: y
        };
    };
    _proto.applyFeatures = function applyFeatures(userFeatures, glyphs, advances) {
        _OTProcessor.prototype.applyFeatures.call(this, userFeatures, glyphs, advances);
        for(var i = 0; i < this.glyphs.length; i++)this.fixCursiveAttachment(i);
        this.fixMarkAttachment();
    };
    _proto.fixCursiveAttachment = function fixCursiveAttachment(i) {
        var glyph = this.glyphs[i];
        if (glyph.cursiveAttachment != null) {
            var j = glyph.cursiveAttachment;
            glyph.cursiveAttachment = null;
            this.fixCursiveAttachment(j);
            this.positions[i].yOffset += this.positions[j].yOffset;
        }
    };
    _proto.fixMarkAttachment = function fixMarkAttachment() {
        for(var i = 0; i < this.glyphs.length; i++){
            var glyph = this.glyphs[i];
            if (glyph.markAttachment != null) {
                var j = glyph.markAttachment;
                this.positions[i].xOffset += this.positions[j].xOffset;
                this.positions[i].yOffset += this.positions[j].yOffset;
                if (this.direction === 'ltr') for(var k = j; k < i; k++){
                    this.positions[i].xOffset -= this.positions[k].xAdvance;
                    this.positions[i].yOffset -= this.positions[k].yAdvance;
                }
                else for(var _k = j + 1; _k < i + 1; _k++){
                    this.positions[i].xOffset += this.positions[_k].xAdvance;
                    this.positions[i].yOffset += this.positions[_k].yAdvance;
                }
            }
        }
    };
    return GPOSProcessor;
}($07144aea14354eb9$var$OTProcessor);
var $07144aea14354eb9$var$OTLayoutEngine = /*#__PURE__*/ function() {
    function OTLayoutEngine(font) {
        this.font = font;
        this.glyphInfos = null;
        this.plan = null;
        this.GSUBProcessor = null;
        this.GPOSProcessor = null;
        this.fallbackPosition = true;
        if (font.GSUB) this.GSUBProcessor = new $07144aea14354eb9$var$GSUBProcessor(font, font.GSUB);
        if (font.GPOS) this.GPOSProcessor = new $07144aea14354eb9$var$GPOSProcessor(font, font.GPOS);
    }
    var _proto = OTLayoutEngine.prototype;
    _proto.setup = function setup(glyphRun) {
        var _this = this;
        // Map glyphs to GlyphInfo objects so data can be passed between
        // GSUB and GPOS without mutating the real (shared) Glyph objects.
        this.glyphInfos = glyphRun.glyphs.map(function(glyph) {
            return new $07144aea14354eb9$var$GlyphInfo(_this.font, glyph.id, [].concat(glyph.codePoints));
        }); // Select a script based on what is available in GSUB/GPOS.
        var script = null;
        if (this.GPOSProcessor) script = this.GPOSProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
        if (this.GSUBProcessor) script = this.GSUBProcessor.selectScript(glyphRun.script, glyphRun.language, glyphRun.direction);
         // Choose a shaper based on the script, and setup a shaping plan.
        // This determines which features to apply to which glyphs.
        this.shaper = $07144aea14354eb9$var$choose(script);
        this.plan = new $07144aea14354eb9$var$ShapingPlan(this.font, script, glyphRun.direction);
        this.shaper.plan(this.plan, this.glyphInfos, glyphRun.features); // Assign chosen features to output glyph run
        for(var key in this.plan.allFeatures)glyphRun.features[key] = true;
    };
    _proto.substitute = function substitute(glyphRun) {
        var _this2 = this;
        if (this.GSUBProcessor) {
            this.plan.process(this.GSUBProcessor, this.glyphInfos); // Map glyph infos back to normal Glyph objects
            glyphRun.glyphs = this.glyphInfos.map(function(glyphInfo) {
                return _this2.font.getGlyph(glyphInfo.id, glyphInfo.codePoints);
            });
        }
    };
    _proto.position = function position(glyphRun) {
        if (this.shaper.zeroMarkWidths === 'BEFORE_GPOS') this.zeroMarkAdvances(glyphRun.positions);
        if (this.GPOSProcessor) this.plan.process(this.GPOSProcessor, this.glyphInfos, glyphRun.positions);
        if (this.shaper.zeroMarkWidths === 'AFTER_GPOS') this.zeroMarkAdvances(glyphRun.positions);
         // Reverse the glyphs and positions if the script is right-to-left
        if (glyphRun.direction === 'rtl') {
            glyphRun.glyphs.reverse();
            glyphRun.positions.reverse();
        }
        return this.GPOSProcessor && this.GPOSProcessor.features;
    };
    _proto.zeroMarkAdvances = function zeroMarkAdvances(positions) {
        for(var i = 0; i < this.glyphInfos.length; i++)if (this.glyphInfos[i].isMark) {
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    };
    _proto.cleanup = function cleanup() {
        this.glyphInfos = null;
        this.plan = null;
        this.shaper = null;
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.GSUBProcessor) {
            this.GSUBProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GSUBProcessor.features));
        }
        if (this.GPOSProcessor) {
            this.GPOSProcessor.selectScript(script, language);
            features.push.apply(features, Object.keys(this.GPOSProcessor.features));
        }
        return features;
    };
    return OTLayoutEngine;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$k(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$k(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$k(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$k(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$k(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$k(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$LayoutEngine = /*#__PURE__*/ function() {
    function LayoutEngine(font) {
        this.font = font;
        this.unicodeLayoutEngine = null;
        this.kernProcessor = null; // Choose an advanced layout engine. We try the AAT morx table first since more
        // scripts are currently supported because the shaping logic is built into the font.
        if (this.font.morx) this.engine = new $07144aea14354eb9$var$AATLayoutEngine(this.font);
        else if (this.font.GSUB || this.font.GPOS) this.engine = new $07144aea14354eb9$var$OTLayoutEngine(this.font);
    }
    var _proto = LayoutEngine.prototype;
    _proto.layout = function layout(string, features, script, language, direction) {
        // Make the features parameter optional
        if (typeof features === 'string') {
            direction = language;
            language = script;
            script = features;
            features = [];
        } // Map string to glyphs if needed
        if (typeof string === 'string') {
            // Attempt to detect the script from the string if not provided.
            if (script == null) script = $07144aea14354eb9$var$forString(string);
            var glyphs = this.font.glyphsForString(string);
        } else {
            // Attempt to detect the script from the glyph code points if not provided.
            if (script == null) {
                var codePoints = [];
                for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$k(string), _step; !(_step = _iterator()).done;){
                    var glyph = _step.value;
                    codePoints.push.apply(codePoints, glyph.codePoints);
                }
                script = $07144aea14354eb9$var$forCodePoints(codePoints);
            }
            var glyphs = string;
        }
        var glyphRun = new $07144aea14354eb9$var$GlyphRun(glyphs, features, script, language, direction); // Return early if there are no glyphs
        if (glyphs.length === 0) {
            glyphRun.positions = [];
            return glyphRun;
        } // Setup the advanced layout engine
        if (this.engine && this.engine.setup) this.engine.setup(glyphRun);
         // Substitute and position the glyphs
        this.substitute(glyphRun);
        this.position(glyphRun);
        this.hideDefaultIgnorables(glyphRun.glyphs, glyphRun.positions); // Let the layout engine clean up any state it might have
        if (this.engine && this.engine.cleanup) this.engine.cleanup();
        return glyphRun;
    };
    _proto.substitute = function substitute(glyphRun) {
        // Call the advanced layout engine to make substitutions
        if (this.engine && this.engine.substitute) this.engine.substitute(glyphRun);
    };
    _proto.position = function position(glyphRun) {
        // Get initial glyph positions
        glyphRun.positions = glyphRun.glyphs.map(function(glyph) {
            return new $07144aea14354eb9$var$GlyphPosition(glyph.advanceWidth);
        });
        var positioned = null; // Call the advanced layout engine. Returns the features applied.
        if (this.engine && this.engine.position) positioned = this.engine.position(glyphRun);
         // if there is no GPOS table, use unicode properties to position marks.
        if (!positioned && (!this.engine || this.engine.fallbackPosition)) {
            if (!this.unicodeLayoutEngine) this.unicodeLayoutEngine = new $07144aea14354eb9$var$UnicodeLayoutEngine(this.font);
            this.unicodeLayoutEngine.positionGlyphs(glyphRun.glyphs, glyphRun.positions);
        } // if kerning is not supported by GPOS, do kerning with the TrueType/AAT kern table
        if ((!positioned || !positioned.kern) && glyphRun.features.kern !== false && this.font.kern) {
            if (!this.kernProcessor) this.kernProcessor = new $07144aea14354eb9$var$KernProcessor(this.font);
            this.kernProcessor.process(glyphRun.glyphs, glyphRun.positions);
            glyphRun.features.kern = true;
        }
    };
    _proto.hideDefaultIgnorables = function hideDefaultIgnorables(glyphs, positions) {
        var space = this.font.glyphForCodePoint(0x20);
        for(var i = 0; i < glyphs.length; i++)if (this.isDefaultIgnorable(glyphs[i].codePoints[0])) {
            glyphs[i] = space;
            positions[i].xAdvance = 0;
            positions[i].yAdvance = 0;
        }
    };
    _proto.isDefaultIgnorable = function isDefaultIgnorable(ch) {
        // From DerivedCoreProperties.txt in the Unicode database,
        // minus U+115F, U+1160, U+3164 and U+FFA0, which is what
        // Harfbuzz and Uniscribe do.
        var plane = ch >> 16;
        if (plane === 0) // BMP
        switch(ch >> 8){
            case 0x00:
                return ch === 0x00AD;
            case 0x03:
                return ch === 0x034F;
            case 0x06:
                return ch === 0x061C;
            case 0x17:
                return 0x17B4 <= ch && ch <= 0x17B5;
            case 0x18:
                return 0x180B <= ch && ch <= 0x180E;
            case 0x20:
                return 0x200B <= ch && ch <= 0x200F || 0x202A <= ch && ch <= 0x202E || 0x2060 <= ch && ch <= 0x206F;
            case 0xFE:
                return 0xFE00 <= ch && ch <= 0xFE0F || ch === 0xFEFF;
            case 0xFF:
                return 0xFFF0 <= ch && ch <= 0xFFF8;
            default:
                return false;
        }
        else // Other planes
        switch(plane){
            case 0x01:
                return 0x1BCA0 <= ch && ch <= 0x1BCA3 || 0x1D173 <= ch && ch <= 0x1D17A;
            case 0x0E:
                return 0xE0000 <= ch && ch <= 0xE0FFF;
            default:
                return false;
        }
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        var features = [];
        if (this.engine) features.push.apply(features, this.engine.getAvailableFeatures(script, language));
        if (this.font.kern && features.indexOf('kern') === -1) features.push('kern');
        return features;
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        var result = new Set();
        var codePoints = this.font._cmapProcessor.codePointsForGlyph(gid);
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$k(codePoints), _step2; !(_step2 = _iterator2()).done;){
            var codePoint = _step2.value;
            result.add(String.fromCodePoint(codePoint));
        }
        if (this.engine && this.engine.stringsForGlyph) for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$k(this.engine.stringsForGlyph(gid)), _step3; !(_step3 = _iterator3()).done;){
            var string = _step3.value;
            result.add(string);
        }
        return Array.from(result);
    };
    return LayoutEngine;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$l(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$l(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$l(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$l(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$l(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$l(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$5(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$5(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$5(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$5(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$SVG_COMMANDS = {
    moveTo: 'M',
    lineTo: 'L',
    quadraticCurveTo: 'Q',
    bezierCurveTo: 'C',
    closePath: 'Z'
};
/**
 * Path objects are returned by glyphs and represent the actual
 * vector outlines for each glyph in the font. Paths can be converted
 * to SVG path data strings, or to functions that can be applied to
 * render the path to a graphics context.
 */ var $07144aea14354eb9$var$Path = /*#__PURE__*/ function() {
    function Path() {
        this.commands = [];
        this._bbox = null;
        this._cbox = null;
    }
    /**
   * Compiles the path to a JavaScript function that can be applied with
   * a graphics context in order to render the path.
   * @return {string}
   */ var _proto = Path.prototype;
    _proto.toFunction = function toFunction() {
        var _this = this;
        return function(ctx) {
            return _this.commands.forEach(function(c) {
                return ctx[c.command].apply(ctx, c.args);
            });
        };
    };
    _proto.toSVG = function toSVG() {
        var cmds = this.commands.map(function(c) {
            var args = c.args.map(function(arg) {
                return Math.round(arg * 100) / 100;
            });
            return "" + $07144aea14354eb9$var$SVG_COMMANDS[c.command] + args.join(' ');
        });
        return cmds.join('');
    };
    /**
   * Applies a mapping function to each point in the path.
   * @param {function} fn
   * @return {Path}
   */ _proto.mapPoints = function mapPoints(fn) {
        var path = new Path();
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$l(this.commands), _step; !(_step = _iterator()).done;){
            var c = _step.value;
            var args = [];
            for(var i = 0; i < c.args.length; i += 2){
                var _fn = fn(c.args[i], c.args[i + 1]), x = _fn[0], y = _fn[1];
                args.push(x, y);
            }
            path[c.command].apply(path, args);
        }
        return path;
    };
    _proto.transform = function transform(m0, m1, m2, m3, m4, m5) {
        return this.mapPoints(function(x, y) {
            x = m0 * x + m2 * y + m4;
            y = m1 * x + m3 * y + m5;
            return [
                x,
                y
            ];
        });
    };
    _proto.translate = function translate(x, y) {
        return this.transform(1, 0, 0, 1, x, y);
    };
    _proto.rotate = function rotate(angle) {
        var cos = Math.cos(angle);
        var sin = Math.sin(angle);
        return this.transform(cos, sin, -sin, cos, 0, 0);
    };
    _proto.scale = function scale(scaleX, scaleY) {
        if (scaleY === void 0) scaleY = scaleX;
        return this.transform(scaleX, 0, 0, scaleY, 0, 0);
    };
    $07144aea14354eb9$var$_createClass$5(Path, [
        {
            key: "cbox",
            get: function get() {
                if (!this._cbox) {
                    var cbox = new $07144aea14354eb9$var$BBox();
                    for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$l(this.commands), _step2; !(_step2 = _iterator2()).done;){
                        var command = _step2.value;
                        for(var i = 0; i < command.args.length; i += 2)cbox.addPoint(command.args[i], command.args[i + 1]);
                    }
                    this._cbox = Object.freeze(cbox);
                }
                return this._cbox;
            }
        },
        {
            key: "bbox",
            get: function get() {
                if (this._bbox) return this._bbox;
                var bbox = new $07144aea14354eb9$var$BBox();
                var cx = 0, cy = 0;
                var f = function f(t) {
                    return Math.pow(1 - t, 3) * p0[i] + 3 * Math.pow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * Math.pow(t, 2) * p2[i] + Math.pow(t, 3) * p3[i];
                };
                for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$l(this.commands), _step3; !(_step3 = _iterator3()).done;){
                    var c = _step3.value;
                    switch(c.command){
                        case 'moveTo':
                        case 'lineTo':
                            var _c$args = c.args, x = _c$args[0], y = _c$args[1];
                            bbox.addPoint(x, y);
                            cx = x;
                            cy = y;
                            break;
                        case 'quadraticCurveTo':
                        case 'bezierCurveTo':
                            if (c.command === 'quadraticCurveTo') {
                                // http://fontforge.org/bezier.html
                                var _c$args2 = c.args, qp1x = _c$args2[0], qp1y = _c$args2[1], p3x = _c$args2[2], p3y = _c$args2[3];
                                var cp1x = cx + 2 / 3 * (qp1x - cx); // CP1 = QP0 + 2/3 * (QP1-QP0)
                                var cp1y = cy + 2 / 3 * (qp1y - cy);
                                var cp2x = p3x + 2 / 3 * (qp1x - p3x); // CP2 = QP2 + 2/3 * (QP1-QP2)
                                var cp2y = p3y + 2 / 3 * (qp1y - p3y);
                            } else var _c$args3 = c.args, cp1x = _c$args3[0], cp1y = _c$args3[1], cp2x = _c$args3[2], cp2y = _c$args3[3], p3x = _c$args3[4], p3y = _c$args3[5];
                             // http://blog.hackers-cafe.net/2009/06/how-to-calculate-bezier-curves-bounding.html
                            bbox.addPoint(p3x, p3y);
                            var p0 = [
                                cx,
                                cy
                            ];
                            var p1 = [
                                cp1x,
                                cp1y
                            ];
                            var p2 = [
                                cp2x,
                                cp2y
                            ];
                            var p3 = [
                                p3x,
                                p3y
                            ];
                            for(var i = 0; i <= 1; i++){
                                var b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
                                var a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
                                c = 3 * p1[i] - 3 * p0[i];
                                if (a === 0) {
                                    if (b === 0) continue;
                                    var t = -c / b;
                                    if (0 < t && t < 1) {
                                        if (i === 0) bbox.addPoint(f(t), bbox.maxY);
                                        else if (i === 1) bbox.addPoint(bbox.maxX, f(t));
                                    }
                                    continue;
                                }
                                var b2ac = Math.pow(b, 2) - 4 * c * a;
                                if (b2ac < 0) continue;
                                var t1 = (-b + Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t1 && t1 < 1) {
                                    if (i === 0) bbox.addPoint(f(t1), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t1));
                                }
                                var t2 = (-b - Math.sqrt(b2ac)) / (2 * a);
                                if (0 < t2 && t2 < 1) {
                                    if (i === 0) bbox.addPoint(f(t2), bbox.maxY);
                                    else if (i === 1) bbox.addPoint(bbox.maxX, f(t2));
                                }
                            }
                            cx = p3x;
                            cy = p3y;
                            break;
                    }
                }
                return this._bbox = Object.freeze(bbox);
            }
        }
    ]);
    return Path;
}();
var $07144aea14354eb9$var$_loop = function _loop() {
    var command = $07144aea14354eb9$var$_arr[$07144aea14354eb9$var$_i];
    $07144aea14354eb9$var$Path.prototype[command] = function() {
        this._bbox = this._cbox = null;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        this.commands.push({
            command: command,
            args: args
        });
        return this;
    };
};
for(var $07144aea14354eb9$var$_i = 0, $07144aea14354eb9$var$_arr = [
    'moveTo',
    'lineTo',
    'quadraticCurveTo',
    'bezierCurveTo',
    'closePath'
]; $07144aea14354eb9$var$_i < $07144aea14354eb9$var$_arr.length; $07144aea14354eb9$var$_i++)$07144aea14354eb9$var$_loop();
var $07144aea14354eb9$var$StandardNames = [
    '.notdef',
    '.null',
    'nonmarkingreturn',
    'space',
    'exclam',
    'quotedbl',
    'numbersign',
    'dollar',
    'percent',
    'ampersand',
    'quotesingle',
    'parenleft',
    'parenright',
    'asterisk',
    'plus',
    'comma',
    'hyphen',
    'period',
    'slash',
    'zero',
    'one',
    'two',
    'three',
    'four',
    'five',
    'six',
    'seven',
    'eight',
    'nine',
    'colon',
    'semicolon',
    'less',
    'equal',
    'greater',
    'question',
    'at',
    'A',
    'B',
    'C',
    'D',
    'E',
    'F',
    'G',
    'H',
    'I',
    'J',
    'K',
    'L',
    'M',
    'N',
    'O',
    'P',
    'Q',
    'R',
    'S',
    'T',
    'U',
    'V',
    'W',
    'X',
    'Y',
    'Z',
    'bracketleft',
    'backslash',
    'bracketright',
    'asciicircum',
    'underscore',
    'grave',
    'a',
    'b',
    'c',
    'd',
    'e',
    'f',
    'g',
    'h',
    'i',
    'j',
    'k',
    'l',
    'm',
    'n',
    'o',
    'p',
    'q',
    'r',
    's',
    't',
    'u',
    'v',
    'w',
    'x',
    'y',
    'z',
    'braceleft',
    'bar',
    'braceright',
    'asciitilde',
    'Adieresis',
    'Aring',
    'Ccedilla',
    'Eacute',
    'Ntilde',
    'Odieresis',
    'Udieresis',
    'aacute',
    'agrave',
    'acircumflex',
    'adieresis',
    'atilde',
    'aring',
    'ccedilla',
    'eacute',
    'egrave',
    'ecircumflex',
    'edieresis',
    'iacute',
    'igrave',
    'icircumflex',
    'idieresis',
    'ntilde',
    'oacute',
    'ograve',
    'ocircumflex',
    'odieresis',
    'otilde',
    'uacute',
    'ugrave',
    'ucircumflex',
    'udieresis',
    'dagger',
    'degree',
    'cent',
    'sterling',
    'section',
    'bullet',
    'paragraph',
    'germandbls',
    'registered',
    'copyright',
    'trademark',
    'acute',
    'dieresis',
    'notequal',
    'AE',
    'Oslash',
    'infinity',
    'plusminus',
    'lessequal',
    'greaterequal',
    'yen',
    'mu',
    'partialdiff',
    'summation',
    'product',
    'pi',
    'integral',
    'ordfeminine',
    'ordmasculine',
    'Omega',
    'ae',
    'oslash',
    'questiondown',
    'exclamdown',
    'logicalnot',
    'radical',
    'florin',
    'approxequal',
    'Delta',
    'guillemotleft',
    'guillemotright',
    'ellipsis',
    'nonbreakingspace',
    'Agrave',
    'Atilde',
    'Otilde',
    'OE',
    'oe',
    'endash',
    'emdash',
    'quotedblleft',
    'quotedblright',
    'quoteleft',
    'quoteright',
    'divide',
    'lozenge',
    'ydieresis',
    'Ydieresis',
    'fraction',
    'currency',
    'guilsinglleft',
    'guilsinglright',
    'fi',
    'fl',
    'daggerdbl',
    'periodcentered',
    'quotesinglbase',
    'quotedblbase',
    'perthousand',
    'Acircumflex',
    'Ecircumflex',
    'Aacute',
    'Edieresis',
    'Egrave',
    'Iacute',
    'Icircumflex',
    'Idieresis',
    'Igrave',
    'Oacute',
    'Ocircumflex',
    'apple',
    'Ograve',
    'Uacute',
    'Ucircumflex',
    'Ugrave',
    'dotlessi',
    'circumflex',
    'tilde',
    'macron',
    'breve',
    'dotaccent',
    'ring',
    'cedilla',
    'hungarumlaut',
    'ogonek',
    'caron',
    'Lslash',
    'lslash',
    'Scaron',
    'scaron',
    'Zcaron',
    'zcaron',
    'brokenbar',
    'Eth',
    'eth',
    'Yacute',
    'yacute',
    'Thorn',
    'thorn',
    'minus',
    'multiply',
    'onesuperior',
    'twosuperior',
    'threesuperior',
    'onehalf',
    'onequarter',
    'threequarters',
    'franc',
    'Gbreve',
    'gbreve',
    'Idotaccent',
    'Scedilla',
    'scedilla',
    'Cacute',
    'cacute',
    'Ccaron',
    'ccaron',
    'dcroat'
];
var $07144aea14354eb9$var$_class$3;
function $07144aea14354eb9$var$_defineProperties$6(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$6(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$6(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$6(Constructor, staticProps);
    return Constructor;
}
function $07144aea14354eb9$var$_applyDecoratedDescriptor$3(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * Glyph objects represent a glyph in the font. They have various properties for accessing metrics and
 * the actual vector path the glyph represents, and methods for rendering the glyph to a graphics context.
 *
 * You do not create glyph objects directly. They are created by various methods on the font object.
 * There are several subclasses of the base Glyph class internally that may be returned depending
 * on the font format, but they all inherit from this class.
 */ var $07144aea14354eb9$var$Glyph = ($07144aea14354eb9$var$_class$3 = /*#__PURE__*/ function() {
    function Glyph(id, codePoints, font) {
        /**
     * The glyph id in the font
     * @type {number}
     */ this.id = id;
        /**
     * An array of unicode code points that are represented by this glyph.
     * There can be multiple code points in the case of ligatures and other glyphs
     * that represent multiple visual characters.
     * @type {number[]}
     */ this.codePoints = codePoints;
        this._font = font; // TODO: get this info from GDEF if available
        this.isMark = this.codePoints.length > 0 && this.codePoints.every($07144aea14354eb9$var$unicode.isMark);
        this.isLigature = this.codePoints.length > 1;
    }
    var _proto = Glyph.prototype;
    _proto._getPath = function _getPath() {
        return new $07144aea14354eb9$var$Path();
    };
    _proto._getCBox = function _getCBox() {
        return this.path.cbox;
    };
    _proto._getBBox = function _getBBox() {
        return this.path.bbox;
    };
    _proto._getTableMetrics = function _getTableMetrics(table) {
        if (this.id < table.metrics.length) return table.metrics.get(this.id);
        var metric = table.metrics.get(table.metrics.length - 1);
        var res = {
            advance: metric ? metric.advance : 0,
            bearing: table.bearings.get(this.id - table.metrics.length) || 0
        };
        return res;
    };
    _proto._getMetrics = function _getMetrics(cbox) {
        if (this._metrics) return this._metrics;
        var _this$_getTableMetric = this._getTableMetrics(this._font.hmtx), advanceWidth = _this$_getTableMetric.advance, leftBearing = _this$_getTableMetric.bearing; // For vertical metrics, use vmtx if available, or fall back to global data from OS/2 or hhea
        if (this._font.vmtx) var _this$_getTableMetric2 = this._getTableMetrics(this._font.vmtx), advanceHeight = _this$_getTableMetric2.advance, topBearing = _this$_getTableMetric2.bearing;
        else {
            var os2;
            if (typeof cbox === 'undefined' || cbox === null) cbox = this.cbox;
            if ((os2 = this._font['OS/2']) && os2.version > 0) {
                var advanceHeight = Math.abs(os2.typoAscender - os2.typoDescender);
                var topBearing = os2.typoAscender - cbox.maxY;
            } else {
                var hhea = this._font.hhea;
                var advanceHeight = Math.abs(hhea.ascent - hhea.descent);
                var topBearing = hhea.ascent - cbox.maxY;
            }
        }
        if (this._font._variationProcessor && this._font.HVAR) advanceWidth += this._font._variationProcessor.getAdvanceAdjustment(this.id, this._font.HVAR);
        return this._metrics = {
            advanceWidth: advanceWidth,
            advanceHeight: advanceHeight,
            leftBearing: leftBearing,
            topBearing: topBearing
        };
    };
    /**
   * Returns a path scaled to the given font size.
   * @param {number} size
   * @return {Path}
   */ _proto.getScaledPath = function getScaledPath(size) {
        var scale = 1 / this._font.unitsPerEm * size;
        return this.path.scale(scale);
    };
    _proto._getName = function _getName() {
        var post = this._font.post;
        if (!post) return null;
        switch(post.version){
            case 1:
                return $07144aea14354eb9$var$StandardNames[this.id];
            case 2:
                var id = post.glyphNameIndex[this.id];
                if (id < $07144aea14354eb9$var$StandardNames.length) return $07144aea14354eb9$var$StandardNames[id];
                return post.names[id - $07144aea14354eb9$var$StandardNames.length];
            case 2.5:
                return $07144aea14354eb9$var$StandardNames[this.id + post.offsets[this.id]];
            case 4:
                return String.fromCharCode(post.map[this.id]);
        }
    };
    /**
   * Renders the glyph to the given graphics context, at the specified font size.
   * @param {CanvasRenderingContext2d} ctx
   * @param {number} size
   */ _proto.render = function render(ctx, size) {
        ctx.save();
        var scale = 1 / this._font.head.unitsPerEm * size;
        ctx.scale(scale, scale);
        var fn = this.path.toFunction();
        fn(ctx);
        ctx.fill();
        ctx.restore();
    };
    $07144aea14354eb9$var$_createClass$6(Glyph, [
        {
            key: "cbox",
            get: function get() {
                return this._getCBox();
            }
        },
        {
            key: "bbox",
            get: function get() {
                return this._getBBox();
            }
        },
        {
            key: "path",
            get: function get() {
                // Cache the path so we only decode it once
                // Decoding is actually performed by subclasses
                return this._getPath();
            }
        },
        {
            key: "advanceWidth",
            get: function get() {
                return this._getMetrics().advanceWidth;
            }
        },
        {
            key: "advanceHeight",
            get: function get() {
                return this._getMetrics().advanceHeight;
            }
        },
        {
            key: "ligatureCaretPositions",
            get: function get() {}
        },
        {
            key: "name",
            get: function get() {
                return this._getName();
            }
        }
    ]);
    return Glyph;
}(), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "cbox", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "cbox"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "bbox", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "bbox"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "path", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "path"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "advanceWidth", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "advanceWidth"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "advanceHeight", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "advanceHeight"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$3($07144aea14354eb9$var$_class$3.prototype, "name", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$3.prototype, "name"), $07144aea14354eb9$var$_class$3.prototype), $07144aea14354eb9$var$_class$3);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$m(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$m(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$m(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$m(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$m(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$m(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$9(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$GlyfHeader = new $07144aea14354eb9$var$restructure.Struct({
    numberOfContours: $07144aea14354eb9$var$restructure.int16,
    // if negative, this is a composite glyph
    xMin: $07144aea14354eb9$var$restructure.int16,
    yMin: $07144aea14354eb9$var$restructure.int16,
    xMax: $07144aea14354eb9$var$restructure.int16,
    yMax: $07144aea14354eb9$var$restructure.int16
}); // Flags for simple glyphs
var $07144aea14354eb9$var$ON_CURVE = 1;
var $07144aea14354eb9$var$X_SHORT_VECTOR = 2;
var $07144aea14354eb9$var$Y_SHORT_VECTOR = 4;
var $07144aea14354eb9$var$REPEAT = 8;
var $07144aea14354eb9$var$SAME_X = 16;
var $07144aea14354eb9$var$SAME_Y = 32; // Flags for composite glyphs
var $07144aea14354eb9$var$ARG_1_AND_2_ARE_WORDS = 1;
var $07144aea14354eb9$var$WE_HAVE_A_SCALE = 8;
var $07144aea14354eb9$var$MORE_COMPONENTS = 32;
var $07144aea14354eb9$var$WE_HAVE_AN_X_AND_Y_SCALE = 64;
var $07144aea14354eb9$var$WE_HAVE_A_TWO_BY_TWO = 128;
var $07144aea14354eb9$var$WE_HAVE_INSTRUCTIONS = 256;
var $07144aea14354eb9$var$Point = /*#__PURE__*/ function() {
    function Point(onCurve, endContour, x, y) {
        if (x === void 0) x = 0;
        if (y === void 0) y = 0;
        this.onCurve = onCurve;
        this.endContour = endContour;
        this.x = x;
        this.y = y;
    }
    var _proto = Point.prototype;
    _proto.copy = function copy() {
        return new Point(this.onCurve, this.endContour, this.x, this.y);
    };
    return Point;
}(); // Represents a component in a composite glyph
var $07144aea14354eb9$var$Component = function Component(glyphID, dx, dy) {
    this.glyphID = glyphID;
    this.dx = dx;
    this.dy = dy;
    this.pos = 0;
    this.scaleX = this.scaleY = 1;
    this.scale01 = this.scale10 = 0;
};
/**
 * Represents a TrueType glyph.
 */ var $07144aea14354eb9$var$TTFGlyph = /*#__PURE__*/ function(_Glyph) {
    $07144aea14354eb9$var$_inheritsLoose$9(TTFGlyph, _Glyph);
    function TTFGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto2 = TTFGlyph.prototype;
    // Parses just the glyph header and returns the bounding box
    _proto2._getCBox = function _getCBox(internal) {
        // We need to decode the glyph if variation processing is requested,
        // so it's easier just to recompute the path's cbox after decoding.
        if (this._font._variationProcessor && !internal) return this.path.cbox;
        var stream = this._font._getTableStream('glyf');
        stream.pos += this._font.loca.offsets[this.id];
        var glyph = $07144aea14354eb9$var$GlyfHeader.decode(stream);
        var cbox = new $07144aea14354eb9$var$BBox(glyph.xMin, glyph.yMin, glyph.xMax, glyph.yMax);
        return Object.freeze(cbox);
    } // Parses a single glyph coordinate
    ;
    _proto2._parseGlyphCoord = function _parseGlyphCoord(stream, prev, _short, same) {
        if (_short) {
            var val = stream.readUInt8();
            if (!same) val = -val;
            val += prev;
        } else if (same) var val = prev;
        else var val = prev + stream.readInt16BE();
        return val;
    } // Decodes the glyph data into points for simple glyphs,
    ;
    _proto2._decode = function _decode() {
        var glyfPos = this._font.loca.offsets[this.id];
        var nextPos = this._font.loca.offsets[this.id + 1]; // Nothing to do if there is no data for this glyph
        if (glyfPos === nextPos) return null;
        var stream = this._font._getTableStream('glyf');
        stream.pos += glyfPos;
        var startPos = stream.pos;
        var glyph = $07144aea14354eb9$var$GlyfHeader.decode(stream);
        if (glyph.numberOfContours > 0) this._decodeSimple(glyph, stream);
        else if (glyph.numberOfContours < 0) this._decodeComposite(glyph, stream, startPos);
        return glyph;
    };
    _proto2._decodeSimple = function _decodeSimple(glyph, stream) {
        // this is a simple glyph
        glyph.points = [];
        var endPtsOfContours = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, glyph.numberOfContours).decode(stream);
        glyph.instructions = new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, $07144aea14354eb9$var$restructure.uint16).decode(stream);
        var flags = [];
        var numCoords = endPtsOfContours[endPtsOfContours.length - 1] + 1;
        while(flags.length < numCoords){
            var flag = stream.readUInt8();
            flags.push(flag); // check for repeat flag
            if (flag & $07144aea14354eb9$var$REPEAT) {
                var count = stream.readUInt8();
                for(var j = 0; j < count; j++)flags.push(flag);
            }
        }
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            var point = new $07144aea14354eb9$var$Point(!!(flag & $07144aea14354eb9$var$ON_CURVE), endPtsOfContours.indexOf(i) >= 0, 0, 0);
            glyph.points.push(point);
        }
        var px = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].x = px = this._parseGlyphCoord(stream, px, flag & $07144aea14354eb9$var$X_SHORT_VECTOR, flag & $07144aea14354eb9$var$SAME_X);
        }
        var py = 0;
        for(var i = 0; i < flags.length; i++){
            var flag = flags[i];
            glyph.points[i].y = py = this._parseGlyphCoord(stream, py, flag & $07144aea14354eb9$var$Y_SHORT_VECTOR, flag & $07144aea14354eb9$var$SAME_Y);
        }
        if (this._font._variationProcessor) {
            var points = glyph.points.slice();
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.slice(-4);
        }
        return;
    };
    _proto2._decodeComposite = function _decodeComposite(glyph, stream, offset) {
        if (offset === void 0) offset = 0;
        // this is a composite glyph
        glyph.components = [];
        var haveInstructions = false;
        var flags = $07144aea14354eb9$var$MORE_COMPONENTS;
        while(flags & $07144aea14354eb9$var$MORE_COMPONENTS){
            flags = stream.readUInt16BE();
            var gPos = stream.pos - offset;
            var glyphID = stream.readUInt16BE();
            if (!haveInstructions) haveInstructions = (flags & $07144aea14354eb9$var$WE_HAVE_INSTRUCTIONS) !== 0;
            if (flags & $07144aea14354eb9$var$ARG_1_AND_2_ARE_WORDS) {
                var dx = stream.readInt16BE();
                var dy = stream.readInt16BE();
            } else {
                var dx = stream.readInt8();
                var dy = stream.readInt8();
            }
            var component = new $07144aea14354eb9$var$Component(glyphID, dx, dy);
            component.pos = gPos;
            if (flags & $07144aea14354eb9$var$WE_HAVE_A_SCALE) // fixed number with 14 bits of fraction
            component.scaleX = component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            else if (flags & $07144aea14354eb9$var$WE_HAVE_AN_X_AND_Y_SCALE) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            } else if (flags & $07144aea14354eb9$var$WE_HAVE_A_TWO_BY_TWO) {
                component.scaleX = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale01 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scale10 = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
                component.scaleY = (stream.readUInt8() << 24 | stream.readUInt8() << 16) / 1073741824;
            }
            glyph.components.push(component);
        }
        if (this._font._variationProcessor) {
            var points = [];
            for(var j = 0; j < glyph.components.length; j++){
                var component = glyph.components[j];
                points.push(new $07144aea14354eb9$var$Point(true, true, component.dx, component.dy));
            }
            points.push.apply(points, this._getPhantomPoints(glyph));
            this._font._variationProcessor.transformPoints(this.id, points);
            glyph.phantomPoints = points.splice(-4, 4);
            for(var i = 0; i < points.length; i++){
                var point = points[i];
                glyph.components[i].dx = point.x;
                glyph.components[i].dy = point.y;
            }
        }
        return haveInstructions;
    };
    _proto2._getPhantomPoints = function _getPhantomPoints(glyph) {
        var cbox = this._getCBox(true);
        if (this._metrics == null) this._metrics = $07144aea14354eb9$var$Glyph.prototype._getMetrics.call(this, cbox);
        var _this$_metrics = this._metrics, advanceWidth = _this$_metrics.advanceWidth, advanceHeight = _this$_metrics.advanceHeight, leftBearing = _this$_metrics.leftBearing, topBearing = _this$_metrics.topBearing;
        return [
            new $07144aea14354eb9$var$Point(false, true, glyph.xMin - leftBearing, 0),
            new $07144aea14354eb9$var$Point(false, true, glyph.xMin - leftBearing + advanceWidth, 0),
            new $07144aea14354eb9$var$Point(false, true, 0, glyph.yMax + topBearing),
            new $07144aea14354eb9$var$Point(false, true, 0, glyph.yMax + topBearing + advanceHeight)
        ];
    } // Decodes font data, resolves composite glyphs, and returns an array of contours
    ;
    _proto2._getContours = function _getContours() {
        var glyph = this._decode();
        if (!glyph) return [];
        var points = [];
        if (glyph.numberOfContours < 0) // resolve composite glyphs
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$m(glyph.components), _step; !(_step = _iterator()).done;){
            var component = _step.value;
            var _contours = this._font.getGlyph(component.glyphID)._getContours();
            for(var i = 0; i < _contours.length; i++){
                var contour = _contours[i];
                for(var j = 0; j < contour.length; j++){
                    var _point = contour[j];
                    var x = _point.x * component.scaleX + _point.y * component.scale01 + component.dx;
                    var y = _point.y * component.scaleY + _point.x * component.scale10 + component.dy;
                    points.push(new $07144aea14354eb9$var$Point(_point.onCurve, _point.endContour, x, y));
                }
            }
        }
        else points = glyph.points || [];
         // Recompute and cache metrics if we performed variation processing, and don't have an HVAR table
        if (glyph.phantomPoints && !this._font.directory.tables.HVAR) {
            this._metrics.advanceWidth = glyph.phantomPoints[1].x - glyph.phantomPoints[0].x;
            this._metrics.advanceHeight = glyph.phantomPoints[3].y - glyph.phantomPoints[2].y;
            this._metrics.leftBearing = glyph.xMin - glyph.phantomPoints[0].x;
            this._metrics.topBearing = glyph.phantomPoints[2].y - glyph.yMax;
        }
        var contours = [];
        var cur = [];
        for(var k = 0; k < points.length; k++){
            var point = points[k];
            cur.push(point);
            if (point.endContour) {
                contours.push(cur);
                cur = [];
            }
        }
        return contours;
    };
    _proto2._getMetrics = function _getMetrics() {
        if (this._metrics) return this._metrics;
        var cbox = this._getCBox(true);
        _Glyph.prototype._getMetrics.call(this, cbox);
        if (this._font._variationProcessor && !this._font.HVAR) // No HVAR table, decode the glyph. This triggers recomputation of metrics.
        this.path;
        return this._metrics;
    } // Converts contours to a Path object that can be rendered
    ;
    _proto2._getPath = function _getPath() {
        var contours = this._getContours();
        var path = new $07144aea14354eb9$var$Path();
        for(var i = 0; i < contours.length; i++){
            var contour = contours[i];
            var firstPt = contour[0];
            var lastPt = contour[contour.length - 1];
            var start = 0;
            if (firstPt.onCurve) {
                // The first point will be consumed by the moveTo command, so skip in the loop
                var curvePt = null;
                start = 1;
            } else {
                if (lastPt.onCurve) // Start at the last point if the first point is off curve and the last point is on curve
                firstPt = lastPt;
                else // Start at the middle if both the first and last points are off curve
                firstPt = new $07144aea14354eb9$var$Point(false, false, (firstPt.x + lastPt.x) / 2, (firstPt.y + lastPt.y) / 2);
                var curvePt = firstPt;
            }
            path.moveTo(firstPt.x, firstPt.y);
            for(var j = start; j < contour.length; j++){
                var pt = contour[j];
                var prevPt = j === 0 ? firstPt : contour[j - 1];
                if (prevPt.onCurve && pt.onCurve) path.lineTo(pt.x, pt.y);
                else if (prevPt.onCurve && !pt.onCurve) var curvePt = pt;
                else if (!prevPt.onCurve && !pt.onCurve) {
                    var midX = (prevPt.x + pt.x) / 2;
                    var midY = (prevPt.y + pt.y) / 2;
                    path.quadraticCurveTo(prevPt.x, prevPt.y, midX, midY);
                    var curvePt = pt;
                } else if (!prevPt.onCurve && pt.onCurve) {
                    path.quadraticCurveTo(curvePt.x, curvePt.y, pt.x, pt.y);
                    var curvePt = null;
                } else throw new Error("Unknown TTF path state");
            } // Connect the first and last points
            if (curvePt) path.quadraticCurveTo(curvePt.x, curvePt.y, firstPt.x, firstPt.y);
            path.closePath();
        }
        return path;
    };
    return TTFGlyph;
}($07144aea14354eb9$var$Glyph);
function $07144aea14354eb9$var$_inheritsLoose$a(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Represents an OpenType PostScript glyph, in the Compact Font Format.
 */ var $07144aea14354eb9$var$CFFGlyph = /*#__PURE__*/ function(_Glyph) {
    $07144aea14354eb9$var$_inheritsLoose$a(CFFGlyph, _Glyph);
    function CFFGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto = CFFGlyph.prototype;
    _proto._getName = function _getName() {
        if (this._font.CFF2) return _Glyph.prototype._getName.call(this);
        return this._font['CFF '].getGlyphName(this.id);
    };
    _proto.bias = function bias(s) {
        if (s.length < 1240) return 107;
        else if (s.length < 33900) return 1131;
        else return 32768;
    };
    _proto._getPath = function _getPath() {
        var stream = this._font.stream;
        var pos = stream.pos;
        var cff = this._font.CFF2 || this._font['CFF '];
        var str = cff.topDict.CharStrings[this.id];
        var end = str.offset + str.length;
        stream.pos = str.offset;
        var path = new $07144aea14354eb9$var$Path();
        var stack = [];
        var trans = [];
        var width = null;
        var nStems = 0;
        var x = 0, y = 0;
        var usedGsubrs;
        var usedSubrs;
        var open = false;
        this._usedGsubrs = usedGsubrs = {};
        this._usedSubrs = usedSubrs = {};
        var gsubrs = cff.globalSubrIndex || [];
        var gsubrsBias = this.bias(gsubrs);
        var privateDict = cff.privateDictForGlyph(this.id);
        var subrs = privateDict.Subrs || [];
        var subrsBias = this.bias(subrs);
        var vstore = cff.topDict.vstore && cff.topDict.vstore.itemVariationStore;
        var vsindex = privateDict.vsindex;
        var variationProcessor = this._font._variationProcessor;
        function checkWidth() {
            if (width == null) width = stack.shift() + privateDict.nominalWidthX;
        }
        function parseStems() {
            if (stack.length % 2 !== 0) checkWidth();
            nStems += stack.length >> 1;
            return stack.length = 0;
        }
        function moveTo(x, y) {
            if (open) path.closePath();
            path.moveTo(x, y);
            open = true;
        }
        var parse = function parse() {
            while(stream.pos < end){
                var op = stream.readUInt8();
                if (op < 32) switch(op){
                    case 1:
                    case 3:
                    case 18:
                    case 23:
                        // vstemhm
                        parseStems();
                        break;
                    case 4:
                        // vmoveto
                        if (stack.length > 1) checkWidth();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 5:
                        // rlineto
                        while(stack.length >= 2){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        break;
                    case 6:
                    case 7:
                        // vlineto
                        var phase = op === 6;
                        while(stack.length >= 1){
                            if (phase) x += stack.shift();
                            else y += stack.shift();
                            path.lineTo(x, y);
                            phase = !phase;
                        }
                        break;
                    case 8:
                        // rrcurveto
                        while(stack.length > 0){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 10:
                        // callsubr
                        var index = stack.pop() + subrsBias;
                        var subr = subrs[index];
                        if (subr) {
                            usedSubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 11:
                        // return
                        if (cff.version >= 2) break;
                        return;
                    case 14:
                        // endchar
                        if (cff.version >= 2) break;
                        if (stack.length > 0) checkWidth();
                        if (open) {
                            path.closePath();
                            open = false;
                        }
                        break;
                    case 15:
                        // vsindex
                        if (cff.version < 2) throw new Error('vsindex operator not supported in CFF v1');
                        vsindex = stack.pop();
                        break;
                    case 16:
                        // blend
                        if (cff.version < 2) throw new Error('blend operator not supported in CFF v1');
                        if (!variationProcessor) throw new Error('blend operator in non-variation font');
                        var blendVector = variationProcessor.getBlendVector(vstore, vsindex);
                        var numBlends = stack.pop();
                        var numOperands = numBlends * blendVector.length;
                        var delta = stack.length - numOperands;
                        var base = delta - numBlends;
                        for(var i = 0; i < numBlends; i++){
                            var sum = stack[base + i];
                            for(var j = 0; j < blendVector.length; j++)sum += blendVector[j] * stack[delta++];
                            stack[base + i] = sum;
                        }
                        while(numOperands--)stack.pop();
                        break;
                    case 19:
                    case 20:
                        // cntrmask
                        parseStems();
                        stream.pos += nStems + 7 >> 3;
                        break;
                    case 21:
                        // rmoveto
                        if (stack.length > 2) checkWidth();
                        x += stack.shift();
                        y += stack.shift();
                        moveTo(x, y);
                        break;
                    case 22:
                        // hmoveto
                        if (stack.length > 1) checkWidth();
                        x += stack.shift();
                        moveTo(x, y);
                        break;
                    case 24:
                        // rcurveline
                        while(stack.length >= 8){
                            var c1x = x + stack.shift();
                            var c1y = y + stack.shift();
                            var c2x = c1x + stack.shift();
                            var c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        x += stack.shift();
                        y += stack.shift();
                        path.lineTo(x, y);
                        break;
                    case 25:
                        // rlinecurve
                        while(stack.length >= 8){
                            x += stack.shift();
                            y += stack.shift();
                            path.lineTo(x, y);
                        }
                        var c1x = x + stack.shift();
                        var c1y = y + stack.shift();
                        var c2x = c1x + stack.shift();
                        var c2y = c1y + stack.shift();
                        x = c2x + stack.shift();
                        y = c2y + stack.shift();
                        path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        break;
                    case 26:
                        // vvcurveto
                        if (stack.length % 2) x += stack.shift();
                        while(stack.length >= 4){
                            c1x = x;
                            c1y = y + stack.shift();
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x;
                            y = c2y + stack.shift();
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 27:
                        // hhcurveto
                        if (stack.length % 2) y += stack.shift();
                        while(stack.length >= 4){
                            c1x = x + stack.shift();
                            c1y = y;
                            c2x = c1x + stack.shift();
                            c2y = c1y + stack.shift();
                            x = c2x + stack.shift();
                            y = c2y;
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                        }
                        break;
                    case 28:
                        // shortint
                        stack.push(stream.readInt16BE());
                        break;
                    case 29:
                        // callgsubr
                        index = stack.pop() + gsubrsBias;
                        subr = gsubrs[index];
                        if (subr) {
                            usedGsubrs[index] = true;
                            var p = stream.pos;
                            var e = end;
                            stream.pos = subr.offset;
                            end = subr.offset + subr.length;
                            parse();
                            stream.pos = p;
                            end = e;
                        }
                        break;
                    case 30:
                    case 31:
                        // hvcurveto
                        phase = op === 31;
                        while(stack.length >= 4){
                            if (phase) {
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                y = c2y + stack.shift();
                                x = c2x + (stack.length === 1 ? stack.shift() : 0);
                            } else {
                                c1x = x;
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                x = c2x + stack.shift();
                                y = c2y + (stack.length === 1 ? stack.shift() : 0);
                            }
                            path.bezierCurveTo(c1x, c1y, c2x, c2y, x, y);
                            phase = !phase;
                        }
                        break;
                    case 12:
                        op = stream.readUInt8();
                        switch(op){
                            case 3:
                                // and
                                var a = stack.pop();
                                var b = stack.pop();
                                stack.push(a && b ? 1 : 0);
                                break;
                            case 4:
                                // or
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a || b ? 1 : 0);
                                break;
                            case 5:
                                // not
                                a = stack.pop();
                                stack.push(a ? 0 : 1);
                                break;
                            case 9:
                                // abs
                                a = stack.pop();
                                stack.push(Math.abs(a));
                                break;
                            case 10:
                                // add
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a + b);
                                break;
                            case 11:
                                // sub
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a - b);
                                break;
                            case 12:
                                // div
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a / b);
                                break;
                            case 14:
                                // neg
                                a = stack.pop();
                                stack.push(-a);
                                break;
                            case 15:
                                // eq
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a === b ? 1 : 0);
                                break;
                            case 18:
                                // drop
                                stack.pop();
                                break;
                            case 20:
                                // put
                                var val = stack.pop();
                                var idx = stack.pop();
                                trans[idx] = val;
                                break;
                            case 21:
                                // get
                                idx = stack.pop();
                                stack.push(trans[idx] || 0);
                                break;
                            case 22:
                                // ifelse
                                var s1 = stack.pop();
                                var s2 = stack.pop();
                                var v1 = stack.pop();
                                var v2 = stack.pop();
                                stack.push(v1 <= v2 ? s1 : s2);
                                break;
                            case 23:
                                // random
                                stack.push(Math.random());
                                break;
                            case 24:
                                // mul
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(a * b);
                                break;
                            case 26:
                                // sqrt
                                a = stack.pop();
                                stack.push(Math.sqrt(a));
                                break;
                            case 27:
                                // dup
                                a = stack.pop();
                                stack.push(a, a);
                                break;
                            case 28:
                                // exch
                                a = stack.pop();
                                b = stack.pop();
                                stack.push(b, a);
                                break;
                            case 29:
                                // index
                                idx = stack.pop();
                                if (idx < 0) idx = 0;
                                else if (idx > stack.length - 1) idx = stack.length - 1;
                                stack.push(stack[idx]);
                                break;
                            case 30:
                                // roll
                                var n = stack.pop();
                                var _j = stack.pop();
                                if (_j >= 0) while(_j > 0){
                                    var t = stack[n - 1];
                                    for(var _i = n - 2; _i >= 0; _i--)stack[_i + 1] = stack[_i];
                                    stack[0] = t;
                                    _j--;
                                }
                                else while(_j < 0){
                                    var t = stack[0];
                                    for(var _i2 = 0; _i2 <= n; _i2++)stack[_i2] = stack[_i2 + 1];
                                    stack[n - 1] = t;
                                    _j++;
                                }
                                break;
                            case 34:
                                // hflex
                                c1x = x + stack.shift();
                                c1y = y;
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                var c3x = c2x + stack.shift();
                                var c3y = c2y;
                                var c4x = c3x + stack.shift();
                                var c4y = c3y;
                                var c5x = c4x + stack.shift();
                                var c5y = c4y;
                                var c6x = c5x + stack.shift();
                                var c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 35:
                                // flex
                                var pts = [];
                                for(var _i3 = 0; _i3 <= 5; _i3++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                stack.shift(); // fd
                                break;
                            case 36:
                                // hflex1
                                c1x = x + stack.shift();
                                c1y = y + stack.shift();
                                c2x = c1x + stack.shift();
                                c2y = c1y + stack.shift();
                                c3x = c2x + stack.shift();
                                c3y = c2y;
                                c4x = c3x + stack.shift();
                                c4y = c3y;
                                c5x = c4x + stack.shift();
                                c5y = c4y + stack.shift();
                                c6x = c5x + stack.shift();
                                c6y = c5y;
                                x = c6x;
                                y = c6y;
                                path.bezierCurveTo(c1x, c1y, c2x, c2y, c3x, c3y);
                                path.bezierCurveTo(c4x, c4y, c5x, c5y, c6x, c6y);
                                break;
                            case 37:
                                // flex1
                                var startx = x;
                                var starty = y;
                                pts = [];
                                for(var _i4 = 0; _i4 <= 4; _i4++){
                                    x += stack.shift();
                                    y += stack.shift();
                                    pts.push(x, y);
                                }
                                if (Math.abs(x - startx) > Math.abs(y - starty)) {
                                    // horizontal
                                    x += stack.shift();
                                    y = starty;
                                } else {
                                    x = startx;
                                    y += stack.shift();
                                }
                                pts.push(x, y);
                                path.bezierCurveTo.apply(path, pts.slice(0, 6));
                                path.bezierCurveTo.apply(path, pts.slice(6));
                                break;
                            default:
                                throw new Error("Unknown op: 12 " + op);
                        }
                        break;
                    default:
                        throw new Error("Unknown op: " + op);
                }
                else if (op < 247) stack.push(op - 139);
                else if (op < 251) {
                    var b1 = stream.readUInt8();
                    stack.push((op - 247) * 256 + b1 + 108);
                } else if (op < 255) {
                    var b1 = stream.readUInt8();
                    stack.push(-(op - 251) * 256 - b1 - 108);
                } else stack.push(stream.readInt32BE() / 65536);
            }
        };
        parse();
        if (open) path.closePath();
        return path;
    };
    return CFFGlyph;
}($07144aea14354eb9$var$Glyph);
function $07144aea14354eb9$var$_inheritsLoose$b(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$SBIXImage = new $07144aea14354eb9$var$restructure.Struct({
    originX: $07144aea14354eb9$var$restructure.uint16,
    originY: $07144aea14354eb9$var$restructure.uint16,
    type: new $07144aea14354eb9$var$restructure.String(4),
    data: new $07144aea14354eb9$var$restructure.Buffer(function(t) {
        return t.parent.buflen - t._currentOffset;
    })
});
/**
 * Represents a color (e.g. emoji) glyph in Apple's SBIX format.
 */ var $07144aea14354eb9$var$SBIXGlyph = /*#__PURE__*/ function(_TTFGlyph) {
    $07144aea14354eb9$var$_inheritsLoose$b(SBIXGlyph, _TTFGlyph);
    function SBIXGlyph() {
        return _TTFGlyph.apply(this, arguments) || this;
    }
    var _proto = SBIXGlyph.prototype;
    /**
   * Returns an object representing a glyph image at the given point size.
   * The object has a data property with a Buffer containing the actual image data,
   * along with the image type, and origin.
   *
   * @param {number} size
   * @return {object}
   */ _proto.getImageForSize = function getImageForSize(size) {
        for(var i = 0; i < this._font.sbix.imageTables.length; i++){
            var table = this._font.sbix.imageTables[i];
            if (table.ppem >= size) break;
        }
        var offsets = table.imageOffsets;
        var start = offsets[this.id];
        var end = offsets[this.id + 1];
        if (start === end) return null;
        this._font.stream.pos = start;
        return $07144aea14354eb9$var$SBIXImage.decode(this._font.stream, {
            buflen: end - start
        });
    };
    _proto.render = function render(ctx, size) {
        var img = this.getImageForSize(size);
        if (img != null) {
            var scale = size / this._font.unitsPerEm;
            ctx.image(img.data, {
                height: size,
                x: img.originX,
                y: (this.bbox.minY - img.originY) * scale
            });
        }
        if (this._font.sbix.flags.renderOutlines) _TTFGlyph.prototype.render.call(this, ctx, size);
    };
    return SBIXGlyph;
}($07144aea14354eb9$var$TTFGlyph);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$n(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$n(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$n(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$n(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$n(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$n(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$7(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$7(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$7(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$7(Constructor, staticProps);
    return Constructor;
}
function $07144aea14354eb9$var$_inheritsLoose$c(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$COLRLayer = function COLRLayer(glyph, color) {
    this.glyph = glyph;
    this.color = color;
};
/**
 * Represents a color (e.g. emoji) glyph in Microsoft's COLR format.
 * Each glyph in this format contain a list of colored layers, each
 * of which  is another vector glyph.
 */ var $07144aea14354eb9$var$COLRGlyph = /*#__PURE__*/ function(_Glyph) {
    $07144aea14354eb9$var$_inheritsLoose$c(COLRGlyph, _Glyph);
    function COLRGlyph() {
        return _Glyph.apply(this, arguments) || this;
    }
    var _proto = COLRGlyph.prototype;
    _proto._getBBox = function _getBBox() {
        var bbox = new $07144aea14354eb9$var$BBox();
        for(var i = 0; i < this.layers.length; i++){
            var layer = this.layers[i];
            var b = layer.glyph.bbox;
            bbox.addPoint(b.minX, b.minY);
            bbox.addPoint(b.maxX, b.maxY);
        }
        return bbox;
    };
    _proto.render = function render(ctx, size) {
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$n(this.layers), _step; !(_step = _iterator()).done;){
            var _step$value = _step.value, glyph = _step$value.glyph, color = _step$value.color;
            ctx.fillColor([
                color.red,
                color.green,
                color.blue
            ], color.alpha / 255 * 100);
            glyph.render(ctx, size);
        }
        return;
    };
    $07144aea14354eb9$var$_createClass$7(COLRGlyph, [
        {
            key: "layers",
            get: function get() {
                var cpal = this._font.CPAL;
                var colr = this._font.COLR;
                var low = 0;
                var high = colr.baseGlyphRecord.length - 1;
                while(low <= high){
                    var mid = low + high >> 1;
                    var rec = colr.baseGlyphRecord[mid];
                    if (this.id < rec.gid) high = mid - 1;
                    else if (this.id > rec.gid) low = mid + 1;
                    else {
                        var baseLayer = rec;
                        break;
                    }
                } // if base glyph not found in COLR table,
                // default to normal glyph from glyf or CFF
                if (baseLayer == null) {
                    var g = this._font._getBaseGlyph(this.id);
                    var color = {
                        red: 0,
                        green: 0,
                        blue: 0,
                        alpha: 255
                    };
                    return [
                        new $07144aea14354eb9$var$COLRLayer(g, color)
                    ];
                } // otherwise, return an array of all the layers
                var layers = [];
                for(var i = baseLayer.firstLayerIndex; i < baseLayer.firstLayerIndex + baseLayer.numLayers; i++){
                    var rec = colr.layerRecords[i];
                    var color = cpal.colorRecords[rec.paletteIndex];
                    var g = this._font._getBaseGlyph(rec.gid);
                    layers.push(new $07144aea14354eb9$var$COLRLayer(g, color));
                }
                return layers;
            }
        }
    ]);
    return COLRGlyph;
}($07144aea14354eb9$var$Glyph);
var $07144aea14354eb9$var$TUPLES_SHARE_POINT_NUMBERS = 0x8000;
var $07144aea14354eb9$var$TUPLE_COUNT_MASK = 0x0fff;
var $07144aea14354eb9$var$EMBEDDED_TUPLE_COORD = 0x8000;
var $07144aea14354eb9$var$INTERMEDIATE_TUPLE = 0x4000;
var $07144aea14354eb9$var$PRIVATE_POINT_NUMBERS = 0x2000;
var $07144aea14354eb9$var$TUPLE_INDEX_MASK = 0x0fff;
var $07144aea14354eb9$var$POINTS_ARE_WORDS = 0x80;
var $07144aea14354eb9$var$POINT_RUN_COUNT_MASK = 0x7f;
var $07144aea14354eb9$var$DELTAS_ARE_ZERO = 0x80;
var $07144aea14354eb9$var$DELTAS_ARE_WORDS = 0x40;
var $07144aea14354eb9$var$DELTA_RUN_COUNT_MASK = 0x3f;
/**
 * This class is transforms TrueType glyphs according to the data from
 * the Apple Advanced Typography variation tables (fvar, gvar, and avar).
 * These tables allow infinite adjustments to glyph weight, width, slant,
 * and optical size without the designer needing to specify every exact style.
 *
 * Apple's documentation for these tables is not great, so thanks to the
 * Freetype project for figuring much of this out.
 *
 * @private
 */ var $07144aea14354eb9$var$GlyphVariationProcessor = /*#__PURE__*/ function() {
    function GlyphVariationProcessor(font, coords) {
        this.font = font;
        this.normalizedCoords = this.normalizeCoords(coords);
        this.blendVectors = new Map();
    }
    var _proto = GlyphVariationProcessor.prototype;
    _proto.normalizeCoords = function normalizeCoords(coords) {
        // the default mapping is linear along each axis, in two segments:
        // from the minValue to defaultValue, and from defaultValue to maxValue.
        var normalized = [];
        for(var i = 0; i < this.font.fvar.axis.length; i++){
            var axis = this.font.fvar.axis[i];
            if (coords[i] < axis.defaultValue) normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.defaultValue - axis.minValue + Number.EPSILON));
            else normalized.push((coords[i] - axis.defaultValue + Number.EPSILON) / (axis.maxValue - axis.defaultValue + Number.EPSILON));
        } // if there is an avar table, the normalized value is calculated
        // by interpolating between the two nearest mapped values.
        if (this.font.avar) for(var i = 0; i < this.font.avar.segment.length; i++){
            var segment = this.font.avar.segment[i];
            for(var j = 0; j < segment.correspondence.length; j++){
                var pair = segment.correspondence[j];
                if (j >= 1 && normalized[i] < pair.fromCoord) {
                    var prev = segment.correspondence[j - 1];
                    normalized[i] = ((normalized[i] - prev.fromCoord) * (pair.toCoord - prev.toCoord) + Number.EPSILON) / (pair.fromCoord - prev.fromCoord + Number.EPSILON) + prev.toCoord;
                    break;
                }
            }
        }
        return normalized;
    };
    _proto.transformPoints = function transformPoints(gid, glyphPoints) {
        if (!this.font.fvar || !this.font.gvar) return;
        var gvar = this.font.gvar;
        if (gid >= gvar.glyphCount) return;
        var offset = gvar.offsets[gid];
        if (offset === gvar.offsets[gid + 1]) return;
         // Read the gvar data for this glyph
        var stream = this.font.stream;
        stream.pos = offset;
        if (stream.pos >= stream.length) return;
        var tupleCount = stream.readUInt16BE();
        var offsetToData = offset + stream.readUInt16BE();
        if (tupleCount & $07144aea14354eb9$var$TUPLES_SHARE_POINT_NUMBERS) {
            var here = stream.pos;
            stream.pos = offsetToData;
            var sharedPoints = this.decodePoints();
            offsetToData = stream.pos;
            stream.pos = here;
        }
        var origPoints = glyphPoints.map(function(pt) {
            return pt.copy();
        });
        tupleCount &= $07144aea14354eb9$var$TUPLE_COUNT_MASK;
        for(var i = 0; i < tupleCount; i++){
            var tupleDataSize = stream.readUInt16BE();
            var tupleIndex = stream.readUInt16BE();
            if (tupleIndex & $07144aea14354eb9$var$EMBEDDED_TUPLE_COORD) {
                var tupleCoords = [];
                for(var a = 0; a < gvar.axisCount; a++)tupleCoords.push(stream.readInt16BE() / 16384);
            } else {
                if ((tupleIndex & $07144aea14354eb9$var$TUPLE_INDEX_MASK) >= gvar.globalCoordCount) throw new Error('Invalid gvar table');
                var tupleCoords = gvar.globalCoords[tupleIndex & $07144aea14354eb9$var$TUPLE_INDEX_MASK];
            }
            if (tupleIndex & $07144aea14354eb9$var$INTERMEDIATE_TUPLE) {
                var startCoords = [];
                for(var _a = 0; _a < gvar.axisCount; _a++)startCoords.push(stream.readInt16BE() / 16384);
                var endCoords = [];
                for(var _a2 = 0; _a2 < gvar.axisCount; _a2++)endCoords.push(stream.readInt16BE() / 16384);
            } // Get the factor at which to apply this tuple
            var factor = this.tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords);
            if (factor === 0) {
                offsetToData += tupleDataSize;
                continue;
            }
            var here = stream.pos;
            stream.pos = offsetToData;
            if (tupleIndex & $07144aea14354eb9$var$PRIVATE_POINT_NUMBERS) var points = this.decodePoints();
            else var points = sharedPoints;
             // points.length = 0 means there are deltas for all points
            var nPoints = points.length === 0 ? glyphPoints.length : points.length;
            var xDeltas = this.decodeDeltas(nPoints);
            var yDeltas = this.decodeDeltas(nPoints);
            if (points.length === 0) // all points
            for(var _i = 0; _i < glyphPoints.length; _i++){
                var point = glyphPoints[_i];
                point.x += Math.round(xDeltas[_i] * factor);
                point.y += Math.round(yDeltas[_i] * factor);
            }
            else {
                var outPoints = origPoints.map(function(pt) {
                    return pt.copy();
                });
                var hasDelta = glyphPoints.map(function() {
                    return false;
                });
                for(var _i2 = 0; _i2 < points.length; _i2++){
                    var idx = points[_i2];
                    if (idx < glyphPoints.length) {
                        var _point = outPoints[idx];
                        hasDelta[idx] = true;
                        _point.x += Math.round(xDeltas[_i2] * factor);
                        _point.y += Math.round(yDeltas[_i2] * factor);
                    }
                }
                this.interpolateMissingDeltas(outPoints, origPoints, hasDelta);
                for(var _i3 = 0; _i3 < glyphPoints.length; _i3++){
                    var deltaX = outPoints[_i3].x - origPoints[_i3].x;
                    var deltaY = outPoints[_i3].y - origPoints[_i3].y;
                    glyphPoints[_i3].x += deltaX;
                    glyphPoints[_i3].y += deltaY;
                }
            }
            offsetToData += tupleDataSize;
            stream.pos = here;
        }
    };
    _proto.decodePoints = function decodePoints() {
        var stream = this.font.stream;
        var count = stream.readUInt8();
        if (count & $07144aea14354eb9$var$POINTS_ARE_WORDS) count = (count & $07144aea14354eb9$var$POINT_RUN_COUNT_MASK) << 8 | stream.readUInt8();
        var points = new Uint16Array(count);
        var i = 0;
        var point = 0;
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & $07144aea14354eb9$var$POINT_RUN_COUNT_MASK) + 1;
            var fn = run & $07144aea14354eb9$var$POINTS_ARE_WORDS ? stream.readUInt16 : stream.readUInt8;
            for(var j = 0; j < runCount && i < count; j++){
                point += fn.call(stream);
                points[i++] = point;
            }
        }
        return points;
    };
    _proto.decodeDeltas = function decodeDeltas(count) {
        var stream = this.font.stream;
        var i = 0;
        var deltas = new Int16Array(count);
        while(i < count){
            var run = stream.readUInt8();
            var runCount = (run & $07144aea14354eb9$var$DELTA_RUN_COUNT_MASK) + 1;
            if (run & $07144aea14354eb9$var$DELTAS_ARE_ZERO) i += runCount;
            else {
                var fn = run & $07144aea14354eb9$var$DELTAS_ARE_WORDS ? stream.readInt16BE : stream.readInt8;
                for(var j = 0; j < runCount && i < count; j++)deltas[i++] = fn.call(stream);
            }
        }
        return deltas;
    };
    _proto.tupleFactor = function tupleFactor(tupleIndex, tupleCoords, startCoords, endCoords) {
        var normalized = this.normalizedCoords;
        var gvar = this.font.gvar;
        var factor = 1;
        for(var i = 0; i < gvar.axisCount; i++){
            if (tupleCoords[i] === 0) continue;
            if (normalized[i] === 0) return 0;
            if ((tupleIndex & $07144aea14354eb9$var$INTERMEDIATE_TUPLE) === 0) {
                if (normalized[i] < Math.min(0, tupleCoords[i]) || normalized[i] > Math.max(0, tupleCoords[i])) return 0;
                factor = (factor * normalized[i] + Number.EPSILON) / (tupleCoords[i] + Number.EPSILON);
            } else {
                if (normalized[i] < startCoords[i] || normalized[i] > endCoords[i]) return 0;
                else if (normalized[i] < tupleCoords[i]) factor = factor * (normalized[i] - startCoords[i] + Number.EPSILON) / (tupleCoords[i] - startCoords[i] + Number.EPSILON);
                else factor = factor * (endCoords[i] - normalized[i] + Number.EPSILON) / (endCoords[i] - tupleCoords[i] + Number.EPSILON);
            }
        }
        return factor;
    } // Interpolates points without delta values.
    ;
    _proto.interpolateMissingDeltas = function interpolateMissingDeltas(points, inPoints, hasDelta) {
        if (points.length === 0) return;
        var point = 0;
        while(point < points.length){
            var firstPoint = point; // find the end point of the contour
            var endPoint = point;
            var pt = points[endPoint];
            while(!pt.endContour)pt = points[++endPoint];
             // find the first point that has a delta
            while(point <= endPoint && !hasDelta[point])point++;
            if (point > endPoint) continue;
            var firstDelta = point;
            var curDelta = point;
            point++;
            while(point <= endPoint){
                // find the next point with a delta, and interpolate intermediate points
                if (hasDelta[point]) {
                    this.deltaInterpolate(curDelta + 1, point - 1, curDelta, point, inPoints, points);
                    curDelta = point;
                }
                point++;
            } // shift contour if we only have a single delta
            if (curDelta === firstDelta) this.deltaShift(firstPoint, endPoint, curDelta, inPoints, points);
            else {
                // otherwise, handle the remaining points at the end and beginning of the contour
                this.deltaInterpolate(curDelta + 1, endPoint, curDelta, firstDelta, inPoints, points);
                if (firstDelta > 0) this.deltaInterpolate(firstPoint, firstDelta - 1, curDelta, firstDelta, inPoints, points);
            }
            point = endPoint + 1;
        }
    };
    _proto.deltaInterpolate = function deltaInterpolate(p1, p2, ref1, ref2, inPoints, outPoints) {
        if (p1 > p2) return;
        var iterable = [
            'x',
            'y'
        ];
        for(var i = 0; i < iterable.length; i++){
            var k = iterable[i];
            if (inPoints[ref1][k] > inPoints[ref2][k]) {
                var p = ref1;
                ref1 = ref2;
                ref2 = p;
            }
            var in1 = inPoints[ref1][k];
            var in2 = inPoints[ref2][k];
            var out1 = outPoints[ref1][k];
            var out2 = outPoints[ref2][k]; // If the reference points have the same coordinate but different
            // delta, inferred delta is zero.  Otherwise interpolate.
            if (in1 !== in2 || out1 === out2) {
                var scale = in1 === in2 ? 0 : (out2 - out1) / (in2 - in1);
                for(var _p = p1; _p <= p2; _p++){
                    var out = inPoints[_p][k];
                    if (out <= in1) out += out1 - in1;
                    else if (out >= in2) out += out2 - in2;
                    else out = out1 + (out - in1) * scale;
                    outPoints[_p][k] = out;
                }
            }
        }
    };
    _proto.deltaShift = function deltaShift(p1, p2, ref, inPoints, outPoints) {
        var deltaX = outPoints[ref].x - inPoints[ref].x;
        var deltaY = outPoints[ref].y - inPoints[ref].y;
        if (deltaX === 0 && deltaY === 0) return;
        for(var p = p1; p <= p2; p++)if (p !== ref) {
            outPoints[p].x += deltaX;
            outPoints[p].y += deltaY;
        }
    };
    _proto.getAdvanceAdjustment = function getAdvanceAdjustment(gid, table) {
        var outerIndex, innerIndex;
        if (table.advanceWidthMapping) {
            var idx = gid;
            if (idx >= table.advanceWidthMapping.mapCount) idx = table.advanceWidthMapping.mapCount - 1;
            var entryFormat = table.advanceWidthMapping.entryFormat;
            var _table$advanceWidthMa = table.advanceWidthMapping.mapData[idx];
            outerIndex = _table$advanceWidthMa.outerIndex;
            innerIndex = _table$advanceWidthMa.innerIndex;
        } else {
            outerIndex = 0;
            innerIndex = gid;
        }
        return this.getDelta(table.itemVariationStore, outerIndex, innerIndex);
    } // See pseudo code from `Font Variations Overview'
    ;
    _proto.getDelta = function getDelta(itemStore, outerIndex, innerIndex) {
        if (outerIndex >= itemStore.itemVariationData.length) return 0;
        var varData = itemStore.itemVariationData[outerIndex];
        if (innerIndex >= varData.deltaSets.length) return 0;
        var deltaSet = varData.deltaSets[innerIndex];
        var blendVector = this.getBlendVector(itemStore, outerIndex);
        var netAdjustment = 0;
        for(var master = 0; master < varData.regionIndexCount; master++)netAdjustment += deltaSet.deltas[master] * blendVector[master];
        return netAdjustment;
    };
    _proto.getBlendVector = function getBlendVector(itemStore, outerIndex) {
        var varData = itemStore.itemVariationData[outerIndex];
        if (this.blendVectors.has(varData)) return this.blendVectors.get(varData);
        var normalizedCoords = this.normalizedCoords;
        var blendVector = []; // outer loop steps through master designs to be blended
        for(var master = 0; master < varData.regionIndexCount; master++){
            var scalar = 1;
            var regionIndex = varData.regionIndexes[master];
            var axes = itemStore.variationRegionList.variationRegions[regionIndex]; // inner loop steps through axes in this region
            for(var j = 0; j < axes.length; j++){
                var axis = axes[j];
                var axisScalar = void 0; // compute the scalar contribution of this axis
                // ignore invalid ranges
                if (axis.startCoord > axis.peakCoord || axis.peakCoord > axis.endCoord) axisScalar = 1;
                else if (axis.startCoord < 0 && axis.endCoord > 0 && axis.peakCoord !== 0) axisScalar = 1; // peak of 0 means ignore this axis
                else if (axis.peakCoord === 0) axisScalar = 1; // ignore this region if coords are out of range
                else if (normalizedCoords[j] < axis.startCoord || normalizedCoords[j] > axis.endCoord) axisScalar = 0; // calculate a proportional factor
                else {
                    if (normalizedCoords[j] === axis.peakCoord) axisScalar = 1;
                    else if (normalizedCoords[j] < axis.peakCoord) axisScalar = (normalizedCoords[j] - axis.startCoord + Number.EPSILON) / (axis.peakCoord - axis.startCoord + Number.EPSILON);
                    else axisScalar = (axis.endCoord - normalizedCoords[j] + Number.EPSILON) / (axis.endCoord - axis.peakCoord + Number.EPSILON);
                } // take product of all the axis scalars
                scalar *= axisScalar;
            }
            blendVector[master] = scalar;
        }
        this.blendVectors.set(varData, blendVector);
        return blendVector;
    };
    return GlyphVariationProcessor;
}();
var $07144aea14354eb9$var$clone_1 = $07144aea14354eb9$var$createCommonjsModule(function(module) {
    var clone = function() {
        /**
     * Clones (copies) an Object using deep copying.
     *
     * This function supports circular references by default, but if you are certain
     * there are no circular references in your object, you can save some CPU time
     * by calling clone(obj, false).
     *
     * Caution: if `circular` is false and `parent` contains circular references,
     * your program may enter an infinite loop and crash.
     *
     * @param `parent` - the object to be cloned
     * @param `circular` - set to true if the object to be cloned may contain
     *    circular references. (optional - true by default)
     * @param `depth` - set to a number if the object is only to be cloned to
     *    a particular depth. (optional - defaults to Infinity)
     * @param `prototype` - sets the prototype to be used when cloning an object.
     *    (optional - defaults to parent prototype).
    */ function clone(parent, circular, depth, prototype) {
            var filter;
            if (typeof circular === 'object') {
                depth = circular.depth;
                prototype = circular.prototype;
                filter = circular.filter;
                circular = circular.circular;
            } // maintain two arrays for circular references, where corresponding parents
            // and children have the same index
            var allParents = [];
            var allChildren = [];
            var useBuffer = typeof $07144aea14354eb9$var$buffer_1 != 'undefined';
            if (typeof circular == 'undefined') circular = true;
            if (typeof depth == 'undefined') depth = Infinity; // recurse this function so we don't reset allParents and allChildren
            function _clone(parent, depth) {
                // cloning null always returns null
                if (parent === null) return null;
                if (depth == 0) return parent;
                var child;
                var proto;
                if (typeof parent != 'object') return parent;
                if (clone.__isArray(parent)) child = [];
                else if (clone.__isRegExp(parent)) {
                    child = new RegExp(parent.source, __getRegExpFlags(parent));
                    if (parent.lastIndex) child.lastIndex = parent.lastIndex;
                } else if (clone.__isDate(parent)) child = new Date(parent.getTime());
                else if (useBuffer && $07144aea14354eb9$var$buffer_1.isBuffer(parent)) {
                    if ($07144aea14354eb9$var$buffer_1.allocUnsafe) // Node.js >= 4.5.0
                    child = $07144aea14354eb9$var$buffer_1.allocUnsafe(parent.length);
                    else // Older Node.js versions
                    child = new $07144aea14354eb9$var$buffer_1(parent.length);
                    parent.copy(child);
                    return child;
                } else if (typeof prototype == 'undefined') {
                    proto = Object.getPrototypeOf(parent);
                    child = Object.create(proto);
                } else {
                    child = Object.create(prototype);
                    proto = prototype;
                }
                if (circular) {
                    var index = allParents.indexOf(parent);
                    if (index != -1) return allChildren[index];
                    allParents.push(parent);
                    allChildren.push(child);
                }
                for(var i in parent){
                    var attrs;
                    if (proto) attrs = Object.getOwnPropertyDescriptor(proto, i);
                    if (attrs && attrs.set == null) continue;
                    child[i] = _clone(parent[i], depth - 1);
                }
                return child;
            }
            return _clone(parent, depth);
        }
        /**
     * Simple flat clone using prototype, accepts only objects, usefull for property
     * override on FLAT configuration object (no nested props).
     *
     * USE WITH CAUTION! This may not behave as you wish if you do not know how this
     * works.
     */ clone.clonePrototype = function clonePrototype(parent) {
            if (parent === null) return null;
            var c = function c() {};
            c.prototype = parent;
            return new c();
        }; // private utility functions
        function __objToStr(o) {
            return Object.prototype.toString.call(o);
        }
        clone.__objToStr = __objToStr;
        function __isDate(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Date]';
        }
        clone.__isDate = __isDate;
        function __isArray(o) {
            return typeof o === 'object' && __objToStr(o) === '[object Array]';
        }
        clone.__isArray = __isArray;
        function __isRegExp(o) {
            return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
        }
        clone.__isRegExp = __isRegExp;
        function __getRegExpFlags(re) {
            var flags = '';
            if (re.global) flags += 'g';
            if (re.ignoreCase) flags += 'i';
            if (re.multiline) flags += 'm';
            return flags;
        }
        clone.__getRegExpFlags = __getRegExpFlags;
        return clone;
    }();
    if (module.exports) module.exports = clone;
});
var $07144aea14354eb9$var$Subset = /*#__PURE__*/ function() {
    function Subset(font) {
        this.font = font;
        this.glyphs = [];
        this.mapping = {}; // always include the missing glyph
        this.includeGlyph(0);
    }
    var _proto = Subset.prototype;
    _proto.includeGlyph = function includeGlyph(glyph) {
        if (typeof glyph === 'object') glyph = glyph.id;
        if (this.mapping[glyph] == null) {
            this.glyphs.push(glyph);
            this.mapping[glyph] = this.glyphs.length - 1;
        }
        return this.mapping[glyph];
    };
    _proto.encodeStream = function encodeStream() {
        var _this = this;
        var s = new $07144aea14354eb9$var$restructure.EncodeStream();
        $07144aea14354eb9$var$nextTick(function() {
            _this.encode(s);
            return s.end();
        });
        return s;
    };
    return Subset;
}();
var $07144aea14354eb9$var$ON_CURVE$1 = 1;
var $07144aea14354eb9$var$X_SHORT_VECTOR$1 = 2;
var $07144aea14354eb9$var$Y_SHORT_VECTOR$1 = 4;
var $07144aea14354eb9$var$REPEAT$1 = 8;
var $07144aea14354eb9$var$SAME_X$1 = 16;
var $07144aea14354eb9$var$SAME_Y$1 = 32;
var $07144aea14354eb9$var$Point$1 = /*#__PURE__*/ function() {
    function Point() {}
    Point.size = function size(val) {
        return val >= 0 && val <= 255 ? 1 : 2;
    };
    Point.encode = function encode(stream, value) {
        if (value >= 0 && value <= 255) stream.writeUInt8(value);
        else stream.writeInt16BE(value);
    };
    return Point;
}();
var $07144aea14354eb9$var$Glyf = new $07144aea14354eb9$var$restructure.Struct({
    numberOfContours: $07144aea14354eb9$var$restructure.int16,
    // if negative, this is a composite glyph
    xMin: $07144aea14354eb9$var$restructure.int16,
    yMin: $07144aea14354eb9$var$restructure.int16,
    xMax: $07144aea14354eb9$var$restructure.int16,
    yMax: $07144aea14354eb9$var$restructure.int16,
    endPtsOfContours: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint16, 'numberOfContours'),
    instructions: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, $07144aea14354eb9$var$restructure.uint16),
    flags: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint8, 0),
    xPoints: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Point$1, 0),
    yPoints: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Point$1, 0)
});
/**
 * Encodes TrueType glyph outlines
 */ var $07144aea14354eb9$var$TTFGlyphEncoder = /*#__PURE__*/ function() {
    function TTFGlyphEncoder() {}
    var _proto = TTFGlyphEncoder.prototype;
    _proto.encodeSimple = function encodeSimple(path, instructions) {
        if (instructions === void 0) instructions = [];
        var endPtsOfContours = [];
        var xPoints = [];
        var yPoints = [];
        var flags = [];
        var same = 0;
        var lastX = 0, lastY = 0, lastFlag = 0;
        var pointCount = 0;
        for(var i = 0; i < path.commands.length; i++){
            var c = path.commands[i];
            for(var j = 0; j < c.args.length; j += 2){
                var x = c.args[j];
                var y = c.args[j + 1];
                var flag = 0; // If the ending point of a quadratic curve is the midpoint
                // between the control point and the control point of the next
                // quadratic curve, we can omit the ending point.
                if (c.command === 'quadraticCurveTo' && j === 2) {
                    var next = path.commands[i + 1];
                    if (next && next.command === 'quadraticCurveTo') {
                        var midX = (lastX + next.args[0]) / 2;
                        var midY = (lastY + next.args[1]) / 2;
                        if (x === midX && y === midY) continue;
                    }
                } // All points except control points are on curve.
                if (!(c.command === 'quadraticCurveTo' && j === 0)) flag |= $07144aea14354eb9$var$ON_CURVE$1;
                flag = this._encodePoint(x, lastX, xPoints, flag, $07144aea14354eb9$var$X_SHORT_VECTOR$1, $07144aea14354eb9$var$SAME_X$1);
                flag = this._encodePoint(y, lastY, yPoints, flag, $07144aea14354eb9$var$Y_SHORT_VECTOR$1, $07144aea14354eb9$var$SAME_Y$1);
                if (flag === lastFlag && same < 255) {
                    flags[flags.length - 1] |= $07144aea14354eb9$var$REPEAT$1;
                    same++;
                } else {
                    if (same > 0) {
                        flags.push(same);
                        same = 0;
                    }
                    flags.push(flag);
                    lastFlag = flag;
                }
                lastX = x;
                lastY = y;
                pointCount++;
            }
            if (c.command === 'closePath') endPtsOfContours.push(pointCount - 1);
        } // Close the path if the last command didn't already
        if (path.commands.length > 1 && path.commands[path.commands.length - 1].command !== 'closePath') endPtsOfContours.push(pointCount - 1);
        var bbox = path.bbox;
        var glyf = {
            numberOfContours: endPtsOfContours.length,
            xMin: bbox.minX,
            yMin: bbox.minY,
            xMax: bbox.maxX,
            yMax: bbox.maxY,
            endPtsOfContours: endPtsOfContours,
            instructions: instructions,
            flags: flags,
            xPoints: xPoints,
            yPoints: yPoints
        };
        var size = $07144aea14354eb9$var$Glyf.size(glyf);
        var tail = 4 - size % 4;
        var stream = new $07144aea14354eb9$var$restructure.EncodeStream(size + tail);
        $07144aea14354eb9$var$Glyf.encode(stream, glyf); // Align to 4-byte length
        if (tail !== 0) stream.fill(0, tail);
        return stream.buffer;
    };
    _proto._encodePoint = function _encodePoint(value, last, points, flag, shortFlag, sameFlag) {
        var diff = value - last;
        if (value === last) flag |= sameFlag;
        else {
            if (-255 <= diff && diff <= 255) {
                flag |= shortFlag;
                if (diff < 0) diff = -diff;
                else flag |= sameFlag;
            }
            points.push(diff);
        }
        return flag;
    };
    return TTFGlyphEncoder;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$o(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$o(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$o(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$o(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$o(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$o(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$d(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$TTFSubset = /*#__PURE__*/ function(_Subset) {
    $07144aea14354eb9$var$_inheritsLoose$d(TTFSubset, _Subset);
    function TTFSubset(font) {
        var _this;
        _this = _Subset.call(this, font) || this;
        _this.glyphEncoder = new $07144aea14354eb9$var$TTFGlyphEncoder();
        return _this;
    }
    var _proto = TTFSubset.prototype;
    _proto._addGlyph = function _addGlyph(gid) {
        var glyph = this.font.getGlyph(gid);
        var glyf = glyph._decode(); // get the offset to the glyph from the loca table
        var curOffset = this.font.loca.offsets[gid];
        var nextOffset = this.font.loca.offsets[gid + 1];
        var stream = this.font._getTableStream('glyf');
        stream.pos += curOffset;
        var buffer = stream.readBuffer(nextOffset - curOffset); // if it is a compound glyph, include its components
        if (glyf && glyf.numberOfContours < 0) {
            buffer = new $07144aea14354eb9$var$buffer_1(buffer);
            for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$o(glyf.components), _step; !(_step = _iterator()).done;){
                var component = _step.value;
                gid = this.includeGlyph(component.glyphID);
                buffer.writeUInt16BE(gid, component.pos);
            }
        } else if (glyf && this.font._variationProcessor) // If this is a TrueType variation glyph, re-encode the path
        buffer = this.glyphEncoder.encodeSimple(glyph.path, glyf.instructions);
        this.glyf.push(buffer);
        this.loca.offsets.push(this.offset);
        this.hmtx.metrics.push({
            advance: glyph.advanceWidth,
            bearing: glyph._getMetrics().leftBearing
        });
        this.offset += buffer.length;
        return this.glyf.length - 1;
    };
    _proto.encode = function encode(stream) {
        // tables required by PDF spec:
        //   head, hhea, loca, maxp, cvt , prep, glyf, hmtx, fpgm
        //
        // additional tables required for standalone fonts:
        //   name, cmap, OS/2, post
        this.glyf = [];
        this.offset = 0;
        this.loca = {
            offsets: []
        };
        this.hmtx = {
            metrics: [],
            bearings: []
        }; // include all the glyphs
        // not using a for loop because we need to support adding more
        // glyphs to the array as we go, and CoffeeScript caches the length.
        var i = 0;
        while(i < this.glyphs.length)this._addGlyph(this.glyphs[i++]);
        var maxp = $07144aea14354eb9$var$clone_1(this.font.maxp);
        maxp.numGlyphs = this.glyf.length;
        this.loca.offsets.push(this.offset);
        $07144aea14354eb9$var$tables.loca.preEncode.call(this.loca);
        var head = $07144aea14354eb9$var$clone_1(this.font.head);
        head.indexToLocFormat = this.loca.version;
        var hhea = $07144aea14354eb9$var$clone_1(this.font.hhea);
        hhea.numberOfMetrics = this.hmtx.metrics.length; // map = []
        // for index in [0...256]
        //     if index < @numGlyphs
        //         map[index] = index
        //     else
        //         map[index] = 0
        //
        // cmapTable =
        //     version: 0
        //     length: 262
        //     language: 0
        //     codeMap: map
        //
        // cmap =
        //     version: 0
        //     numSubtables: 1
        //     tables: [
        //         platformID: 1
        //         encodingID: 0
        //         table: cmapTable
        //     ]
        // TODO: subset prep, cvt, fpgm?
        $07144aea14354eb9$var$Directory.encode(stream, {
            tables: {
                head: head,
                hhea: hhea,
                loca: this.loca,
                maxp: maxp,
                'cvt ': this.font['cvt '],
                prep: this.font.prep,
                glyf: this.glyf,
                hmtx: this.hmtx,
                fpgm: this.font.fpgm // name: clone @font.name
            }
        });
    };
    return TTFSubset;
}($07144aea14354eb9$var$Subset);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$p(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$p(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$p(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$p(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$p(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$p(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_inheritsLoose$e(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$CFFSubset = /*#__PURE__*/ function(_Subset) {
    $07144aea14354eb9$var$_inheritsLoose$e(CFFSubset, _Subset);
    function CFFSubset(font) {
        var _this;
        _this = _Subset.call(this, font) || this;
        _this.cff = _this.font['CFF '];
        if (!_this.cff) throw new Error('Not a CFF Font');
        return _this;
    }
    var _proto = CFFSubset.prototype;
    _proto.subsetCharstrings = function subsetCharstrings() {
        this.charstrings = [];
        var gsubrs = {};
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step; !(_step = _iterator()).done;){
            var gid = _step.value;
            this.charstrings.push(this.cff.getCharString(gid));
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedGsubrs)gsubrs[subr] = true;
        }
        this.gsubrs = this.subsetSubrs(this.cff.globalSubrIndex, gsubrs);
    };
    _proto.subsetSubrs = function subsetSubrs(subrs, used) {
        var res = [];
        for(var i = 0; i < subrs.length; i++){
            var subr = subrs[i];
            if (used[i]) {
                this.cff.stream.pos = subr.offset;
                res.push(this.cff.stream.readBuffer(subr.length));
            } else res.push(new $07144aea14354eb9$var$buffer_1([
                11
            ])); // return
        }
        return res;
    };
    _proto.subsetFontdict = function subsetFontdict(topDict) {
        topDict.FDArray = [];
        topDict.FDSelect = {
            version: 0,
            fds: []
        };
        var used_fds = {};
        var used_subrs = [];
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step2; !(_step2 = _iterator2()).done;){
            var gid = _step2.value;
            var fd = this.cff.fdForGlyph(gid);
            if (fd == null) continue;
            if (!used_fds[fd]) {
                topDict.FDArray.push(Object.assign({}, this.cff.topDict.FDArray[fd]));
                used_subrs.push({});
            }
            used_fds[fd] = true;
            topDict.FDSelect.fds.push(topDict.FDArray.length - 1);
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[used_subrs.length - 1][subr] = true;
        }
        for(var i = 0; i < topDict.FDArray.length; i++){
            var dict = topDict.FDArray[i];
            delete dict.FontName;
            if (dict.Private && dict.Private.Subrs) {
                dict.Private = Object.assign({}, dict.Private);
                dict.Private.Subrs = this.subsetSubrs(dict.Private.Subrs, used_subrs[i]);
            }
        }
        return;
    };
    _proto.createCIDFontdict = function createCIDFontdict(topDict) {
        var used_subrs = {};
        for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$p(this.glyphs), _step3; !(_step3 = _iterator3()).done;){
            var gid = _step3.value;
            var glyph = this.font.getGlyph(gid);
            var path = glyph.path; // this causes the glyph to be parsed
            for(var subr in glyph._usedSubrs)used_subrs[subr] = true;
        }
        var privateDict = Object.assign({}, this.cff.topDict.Private);
        if (this.cff.topDict.Private && this.cff.topDict.Private.Subrs) privateDict.Subrs = this.subsetSubrs(this.cff.topDict.Private.Subrs, used_subrs);
        topDict.FDArray = [
            {
                Private: privateDict
            }
        ];
        return topDict.FDSelect = {
            version: 3,
            nRanges: 1,
            ranges: [
                {
                    first: 0,
                    fd: 0
                }
            ],
            sentinel: this.charstrings.length
        };
    };
    _proto.addString = function addString(string) {
        if (!string) return null;
        if (!this.strings) this.strings = [];
        this.strings.push(string);
        return $07144aea14354eb9$var$standardStrings.length + this.strings.length - 1;
    };
    _proto.encode = function encode(stream) {
        this.subsetCharstrings();
        var charset = {
            version: this.charstrings.length > 255 ? 2 : 1,
            ranges: [
                {
                    first: 1,
                    nLeft: this.charstrings.length - 2
                }
            ]
        };
        var topDict = Object.assign({}, this.cff.topDict);
        topDict.Private = null;
        topDict.charset = charset;
        topDict.Encoding = null;
        topDict.CharStrings = this.charstrings;
        for(var _i = 0, _arr = [
            'version',
            'Notice',
            'Copyright',
            'FullName',
            'FamilyName',
            'Weight',
            'PostScript',
            'BaseFontName',
            'FontName'
        ]; _i < _arr.length; _i++){
            var key = _arr[_i];
            topDict[key] = this.addString(this.cff.string(topDict[key]));
        }
        topDict.ROS = [
            this.addString('Adobe'),
            this.addString('Identity'),
            0
        ];
        topDict.CIDCount = this.charstrings.length;
        if (this.cff.isCIDFont) this.subsetFontdict(topDict);
        else this.createCIDFontdict(topDict);
        var top = {
            version: 1,
            hdrSize: this.cff.hdrSize,
            offSize: this.cff.length,
            header: this.cff.header,
            nameIndex: [
                this.cff.postscriptName
            ],
            topDictIndex: [
                topDict
            ],
            stringIndex: this.strings,
            globalSubrIndex: this.gsubrs
        };
        $07144aea14354eb9$var$CFFTop.encode(stream, top);
    };
    return CFFSubset;
}($07144aea14354eb9$var$Subset);
var $07144aea14354eb9$var$_class$4;
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$q(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$q(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$q(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$q(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$q(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$q(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$8(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$8(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$8(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$8(Constructor, staticProps);
    return Constructor;
}
function $07144aea14354eb9$var$_applyDecoratedDescriptor$4(target, property, decorators, descriptor, context) {
    var desc = {};
    Object.keys(descriptor).forEach(function(key) {
        desc[key] = descriptor[key];
    });
    desc.enumerable = !!desc.enumerable;
    desc.configurable = !!desc.configurable;
    if ('value' in desc || desc.initializer) desc.writable = true;
    desc = decorators.slice().reverse().reduce(function(desc, decorator) {
        return decorator(target, property, desc) || desc;
    }, desc);
    if (context && desc.initializer !== void 0) {
        desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
        desc.initializer = undefined;
    }
    if (desc.initializer === void 0) {
        Object.defineProperty(target, property, desc);
        desc = null;
    }
    return desc;
}
/**
 * This is the base class for all SFNT-based font formats in fontkit.
 * It supports TrueType, and PostScript glyphs, and several color glyph formats.
 */ var $07144aea14354eb9$var$TTFFont = ($07144aea14354eb9$var$_class$4 = /*#__PURE__*/ function() {
    TTFFont.probe = function probe(buffer) {
        var format = buffer.toString('ascii', 0, 4);
        return format === 'true' || format === 'OTTO' || format === String.fromCharCode(0, 1, 0, 0);
    };
    function TTFFont(stream, variationCoords) {
        if (variationCoords === void 0) variationCoords = null;
        this.stream = stream;
        this.variationCoords = variationCoords;
        this._directoryPos = this.stream.pos;
        this._tables = {};
        this._glyphs = {};
        this._decodeDirectory(); // define properties for each table to lazily parse
        for(var tag in this.directory.tables){
            var table = this.directory.tables[tag];
            if ($07144aea14354eb9$var$tables[tag] && table.length > 0) Object.defineProperty(this, tag, {
                get: this._getTable.bind(this, table)
            });
        }
    }
    var _proto = TTFFont.prototype;
    _proto._getTable = function _getTable(table) {
        if (!(table.tag in this._tables)) try {
            this._tables[table.tag] = this._decodeTable(table);
        } catch (e) {
            if ($07144aea14354eb9$var$fontkit.logErrors) {
                console.error("Error decoding table " + table.tag);
                console.error(e.stack);
            }
        }
        return this._tables[table.tag];
    };
    _proto._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            return this.stream;
        }
        return null;
    };
    _proto._decodeDirectory = function _decodeDirectory() {
        return this.directory = $07144aea14354eb9$var$Directory.decode(this.stream, {
            _startOffset: 0
        });
    };
    _proto._decodeTable = function _decodeTable(table) {
        var pos = this.stream.pos;
        var stream = this._getTableStream(table.tag);
        var result = $07144aea14354eb9$var$tables[table.tag].decode(stream, this, table.length);
        this.stream.pos = pos;
        return result;
    };
    /**
   * Gets a string from the font's `name` table
   * `lang` is a BCP-47 language code.
   * @return {string}
   */ _proto.getName = function getName(key, lang) {
        if (lang === void 0) lang = 'en';
        var record = this.name.records[key];
        if (record) return record[lang];
        return null;
    };
    /**
   * Returns whether there is glyph in the font for the given unicode code point.
   *
   * @param {number} codePoint
   * @return {boolean}
   */ _proto.hasGlyphForCodePoint = function hasGlyphForCodePoint(codePoint) {
        return !!this._cmapProcessor.lookup(codePoint);
    };
    _proto.glyphForCodePoint = function glyphForCodePoint(codePoint) {
        return this.getGlyph(this._cmapProcessor.lookup(codePoint), [
            codePoint
        ]);
    };
    _proto.glyphsForString = function glyphsForString(string) {
        var glyphs = [];
        var len = string.length;
        var idx = 0;
        var last = -1;
        var state = -1;
        while(idx <= len){
            var code = 0;
            var nextState = 0;
            if (idx < len) {
                // Decode the next codepoint from UTF 16
                code = string.charCodeAt(idx++);
                if (0xd800 <= code && code <= 0xdbff && idx < len) {
                    var next = string.charCodeAt(idx);
                    if (0xdc00 <= next && next <= 0xdfff) {
                        idx++;
                        code = ((code & 0x3ff) << 10) + (next & 0x3ff) + 0x10000;
                    }
                } // Compute the next state: 1 if the next codepoint is a variation selector, 0 otherwise.
                nextState = 0xfe00 <= code && code <= 0xfe0f || 0xe0100 <= code && code <= 0xe01ef ? 1 : 0;
            } else idx++;
            if (state === 0 && nextState === 1) // Variation selector following normal codepoint.
            glyphs.push(this.getGlyph(this._cmapProcessor.lookup(last, code), [
                last,
                code
            ]));
            else if (state === 0 && nextState === 0) // Normal codepoint following normal codepoint.
            glyphs.push(this.glyphForCodePoint(last));
            last = code;
            state = nextState;
        }
        return glyphs;
    };
    /**
   * Returns a GlyphRun object, which includes an array of Glyphs and GlyphPositions for the given string.
   *
   * @param {string} string
   * @param {string[]} [userFeatures]
   * @param {string} [script]
   * @param {string} [language]
   * @param {string} [direction]
   * @return {GlyphRun}
   */ _proto.layout = function layout(string, userFeatures, script, language, direction) {
        return this._layoutEngine.layout(string, userFeatures, script, language, direction);
    };
    _proto.stringsForGlyph = function stringsForGlyph(gid) {
        return this._layoutEngine.stringsForGlyph(gid);
    };
    _proto.getAvailableFeatures = function getAvailableFeatures(script, language) {
        return this._layoutEngine.getAvailableFeatures(script, language);
    };
    _proto._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf) this._glyphs[glyph] = new $07144aea14354eb9$var$TTFGlyph(glyph, characters, this);
            else if (this.directory.tables['CFF '] || this.directory.tables.CFF2) this._glyphs[glyph] = new $07144aea14354eb9$var$CFFGlyph(glyph, characters, this);
        }
        return this._glyphs[glyph] || null;
    };
    _proto.getGlyph = function getGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.sbix) this._glyphs[glyph] = new $07144aea14354eb9$var$SBIXGlyph(glyph, characters, this);
            else if (this.directory.tables.COLR && this.directory.tables.CPAL) this._glyphs[glyph] = new $07144aea14354eb9$var$COLRGlyph(glyph, characters, this);
            else this._getBaseGlyph(glyph, characters);
        }
        return this._glyphs[glyph] || null;
    };
    _proto.createSubset = function createSubset() {
        if (this.directory.tables['CFF ']) return new $07144aea14354eb9$var$CFFSubset(this);
        return new $07144aea14354eb9$var$TTFSubset(this);
    };
    /**
   * Returns a new font with the given variation settings applied.
   * Settings can either be an instance name, or an object containing
   * variation tags as specified by the `variationAxes` property.
   *
   * @param {object} settings
   * @return {TTFFont}
   */ _proto.getVariation = function getVariation(settings) {
        if (!(this.directory.tables.fvar && (this.directory.tables.gvar && this.directory.tables.glyf || this.directory.tables.CFF2))) throw new Error('Variations require a font with the fvar, gvar and glyf, or CFF2 tables.');
        if (typeof settings === 'string') settings = this.namedVariations[settings];
        if (typeof settings !== 'object') throw new Error('Variation settings must be either a variation name or settings object.');
         // normalize the coordinates
        var coords = this.fvar.axis.map(function(axis, i) {
            var axisTag = axis.axisTag.trim();
            if (axisTag in settings) return Math.max(axis.minValue, Math.min(axis.maxValue, settings[axisTag]));
            else return axis.defaultValue;
        });
        var stream = new $07144aea14354eb9$var$restructure.DecodeStream(this.stream.buffer);
        stream.pos = this._directoryPos;
        var font = new TTFFont(stream, coords);
        font._tables = this._tables;
        return font;
    };
    // Standardized format plugin API
    _proto.getFont = function getFont(name) {
        return this.getVariation(name);
    };
    $07144aea14354eb9$var$_createClass$8(TTFFont, [
        {
            key: "postscriptName",
            get: function get() {
                var name = this.name.records.postscriptName;
                if (name) {
                    var lang = Object.keys(name)[0];
                    return name[lang];
                }
                return null;
            }
        },
        {
            key: "fullName",
            get: function get() {
                return this.getName('fullName');
            }
        },
        {
            key: "familyName",
            get: function get() {
                return this.getName('fontFamily');
            }
        },
        {
            key: "subfamilyName",
            get: function get() {
                return this.getName('fontSubfamily');
            }
        },
        {
            key: "copyright",
            get: function get() {
                return this.getName('copyright');
            }
        },
        {
            key: "version",
            get: function get() {
                return this.getName('version');
            }
        },
        {
            key: "ascent",
            get: function get() {
                return this.hhea.ascent;
            }
        },
        {
            key: "descent",
            get: function get() {
                return this.hhea.descent;
            }
        },
        {
            key: "lineGap",
            get: function get() {
                return this.hhea.lineGap;
            }
        },
        {
            key: "underlinePosition",
            get: function get() {
                return this.post.underlinePosition;
            }
        },
        {
            key: "underlineThickness",
            get: function get() {
                return this.post.underlineThickness;
            }
        },
        {
            key: "italicAngle",
            get: function get() {
                return this.post.italicAngle;
            }
        },
        {
            key: "capHeight",
            get: function get() {
                var os2 = this['OS/2'];
                return os2 ? os2.capHeight : this.ascent;
            }
        },
        {
            key: "xHeight",
            get: function get() {
                var os2 = this['OS/2'];
                return os2 ? os2.xHeight : 0;
            }
        },
        {
            key: "numGlyphs",
            get: function get() {
                return this.maxp.numGlyphs;
            }
        },
        {
            key: "unitsPerEm",
            get: function get() {
                return this.head.unitsPerEm;
            }
        },
        {
            key: "bbox",
            get: function get() {
                return Object.freeze(new $07144aea14354eb9$var$BBox(this.head.xMin, this.head.yMin, this.head.xMax, this.head.yMax));
            }
        },
        {
            key: "_cmapProcessor",
            get: function get() {
                return new $07144aea14354eb9$var$CmapProcessor(this.cmap);
            }
        },
        {
            key: "characterSet",
            get: function get() {
                return this._cmapProcessor.getCharacterSet();
            }
        },
        {
            key: "_layoutEngine",
            get: function get() {
                return new $07144aea14354eb9$var$LayoutEngine(this);
            }
        },
        {
            key: "availableFeatures",
            get: function get() {
                return this._layoutEngine.getAvailableFeatures();
            }
        },
        {
            key: "variationAxes",
            get: function get() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$q(this.fvar.axis), _step; !(_step = _iterator()).done;){
                    var axis = _step.value;
                    res[axis.axisTag.trim()] = {
                        name: axis.name.en,
                        min: axis.minValue,
                        "default": axis.defaultValue,
                        max: axis.maxValue
                    };
                }
                return res;
            }
        },
        {
            key: "namedVariations",
            get: function get() {
                var res = {};
                if (!this.fvar) return res;
                for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$q(this.fvar.instance), _step2; !(_step2 = _iterator2()).done;){
                    var instance = _step2.value;
                    var settings = {};
                    for(var i = 0; i < this.fvar.axis.length; i++){
                        var axis = this.fvar.axis[i];
                        settings[axis.axisTag.trim()] = instance.coord[i];
                    }
                    res[instance.name.en] = settings;
                }
                return res;
            }
        },
        {
            key: "_variationProcessor",
            get: function get() {
                if (!this.fvar) return null;
                var variationCoords = this.variationCoords; // Ignore if no variation coords and not CFF2
                if (!variationCoords && !this.CFF2) return null;
                if (!variationCoords) variationCoords = this.fvar.axis.map(function(axis) {
                    return axis.defaultValue;
                });
                return new $07144aea14354eb9$var$GlyphVariationProcessor(this, variationCoords);
            }
        }
    ]);
    return TTFFont;
}(), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "bbox", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "bbox"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "_cmapProcessor", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "_cmapProcessor"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "characterSet", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "characterSet"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "_layoutEngine", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "_layoutEngine"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "variationAxes", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "variationAxes"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "namedVariations", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "namedVariations"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_applyDecoratedDescriptor$4($07144aea14354eb9$var$_class$4.prototype, "_variationProcessor", [
    $07144aea14354eb9$var$cache
], Object.getOwnPropertyDescriptor($07144aea14354eb9$var$_class$4.prototype, "_variationProcessor"), $07144aea14354eb9$var$_class$4.prototype), $07144aea14354eb9$var$_class$4);
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$r(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$r(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$r(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$r(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$r(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$r(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
var $07144aea14354eb9$var$WOFFDirectoryEntry = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    offset: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, 'void', {
        type: 'global'
    }),
    compLength: $07144aea14354eb9$var$restructure.uint32,
    length: $07144aea14354eb9$var$restructure.uint32,
    origChecksum: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$WOFFDirectory = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    // should be 'wOFF'
    flavor: $07144aea14354eb9$var$restructure.uint32,
    length: $07144aea14354eb9$var$restructure.uint32,
    numTables: $07144aea14354eb9$var$restructure.uint16,
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    totalSfntSize: $07144aea14354eb9$var$restructure.uint32,
    majorVersion: $07144aea14354eb9$var$restructure.uint16,
    minorVersion: $07144aea14354eb9$var$restructure.uint16,
    metaOffset: $07144aea14354eb9$var$restructure.uint32,
    metaLength: $07144aea14354eb9$var$restructure.uint32,
    metaOrigLength: $07144aea14354eb9$var$restructure.uint32,
    privOffset: $07144aea14354eb9$var$restructure.uint32,
    privLength: $07144aea14354eb9$var$restructure.uint32,
    tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$WOFFDirectoryEntry, 'numTables')
});
$07144aea14354eb9$var$WOFFDirectory.process = function() {
    var tables = {};
    for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$r(this.tables), _step; !(_step = _iterator()).done;){
        var table = _step.value;
        tables[table.tag] = table;
    }
    this.tables = tables;
};
var $07144aea14354eb9$var$TINF_OK$1 = 0;
var $07144aea14354eb9$var$TINF_DATA_ERROR$1 = -3;
function $07144aea14354eb9$var$Tree$1() {
    this.table = new Uint16Array(16);
    /* table of code length counts */ this.trans = new Uint16Array(288);
/* code -> symbol translation table */ }
function $07144aea14354eb9$var$Data$1(source, dest) {
    this.source = source;
    this.sourceIndex = 0;
    this.tag = 0;
    this.bitcount = 0;
    this.dest = dest;
    this.destLen = 0;
    this.ltree = new $07144aea14354eb9$var$Tree$1();
    /* dynamic length/symbol tree */ this.dtree = new $07144aea14354eb9$var$Tree$1();
/* dynamic distance tree */ }
/* --------------------------------------------------- *
 * -- uninitialized global data (static structures) -- *
 * --------------------------------------------------- */ var $07144aea14354eb9$var$sltree$1 = new $07144aea14354eb9$var$Tree$1();
var $07144aea14354eb9$var$sdtree$1 = new $07144aea14354eb9$var$Tree$1();
/* extra bits and base tables for length codes */ var $07144aea14354eb9$var$length_bits$1 = new Uint8Array(30);
var $07144aea14354eb9$var$length_base$1 = new Uint16Array(30);
/* extra bits and base tables for distance codes */ var $07144aea14354eb9$var$dist_bits$1 = new Uint8Array(30);
var $07144aea14354eb9$var$dist_base$1 = new Uint16Array(30);
/* special ordering of code length codes */ var $07144aea14354eb9$var$clcidx$1 = new Uint8Array([
    16,
    17,
    18,
    0,
    8,
    7,
    9,
    6,
    10,
    5,
    11,
    4,
    12,
    3,
    13,
    2,
    14,
    1,
    15
]);
/* used by tinf_decode_trees, avoids allocations every call */ var $07144aea14354eb9$var$code_tree$1 = new $07144aea14354eb9$var$Tree$1();
var $07144aea14354eb9$var$lengths$1 = new Uint8Array(320);
/* ----------------------- *
 * -- utility functions -- *
 * ----------------------- */ /* build extra bits and base tables */ function $07144aea14354eb9$var$tinf_build_bits_base$1(bits, base, delta, first) {
    var i, sum;
    /* build bits table */ for(i = 0; i < delta; ++i)bits[i] = 0;
    for(i = 0; i < 30 - delta; ++i)bits[i + delta] = i / delta | 0;
    /* build base table */ for(sum = first, i = 0; i < 30; ++i){
        base[i] = sum;
        sum += 1 << bits[i];
    }
}
/* build the fixed huffman trees */ function $07144aea14354eb9$var$tinf_build_fixed_trees$1(lt, dt) {
    var i;
    /* build fixed length tree */ for(i = 0; i < 7; ++i)lt.table[i] = 0;
    lt.table[7] = 24;
    lt.table[8] = 152;
    lt.table[9] = 112;
    for(i = 0; i < 24; ++i)lt.trans[i] = 256 + i;
    for(i = 0; i < 144; ++i)lt.trans[24 + i] = i;
    for(i = 0; i < 8; ++i)lt.trans[168 + i] = 280 + i;
    for(i = 0; i < 112; ++i)lt.trans[176 + i] = 144 + i;
    /* build fixed distance tree */ for(i = 0; i < 5; ++i)dt.table[i] = 0;
    dt.table[5] = 32;
    for(i = 0; i < 32; ++i)dt.trans[i] = i;
}
/* given an array of code lengths, build a tree */ var $07144aea14354eb9$var$offs$1 = new Uint16Array(16);
function $07144aea14354eb9$var$tinf_build_tree$1(t, lengths, off, num) {
    var i, sum;
    /* clear code length count table */ for(i = 0; i < 16; ++i)t.table[i] = 0;
    /* scan symbol lengths, and sum code length counts */ for(i = 0; i < num; ++i)t.table[lengths[off + i]]++;
    t.table[0] = 0;
    /* compute offset table for distribution sort */ for(sum = 0, i = 0; i < 16; ++i){
        $07144aea14354eb9$var$offs$1[i] = sum;
        sum += t.table[i];
    }
    /* create code->symbol translation table (symbols sorted by code) */ for(i = 0; i < num; ++i)if (lengths[off + i]) t.trans[$07144aea14354eb9$var$offs$1[lengths[off + i]]++] = i;
}
/* ---------------------- *
 * -- decode functions -- *
 * ---------------------- */ /* get one bit from source stream */ function $07144aea14354eb9$var$tinf_getbit$1(d) {
    /* check if tag is empty */ if (!d.bitcount--) {
        /* load next tag */ d.tag = d.source[d.sourceIndex++];
        d.bitcount = 7;
    }
    /* shift bit out of tag */ var bit = d.tag & 1;
    d.tag >>>= 1;
    return bit;
}
/* read a num bit value from a stream and add base */ function $07144aea14354eb9$var$tinf_read_bits$1(d, num, base) {
    if (!num) return base;
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var val = d.tag & 0xffff >>> 16 - num;
    d.tag >>>= num;
    d.bitcount -= num;
    return val + base;
}
/* given a data stream and a tree, decode a symbol */ function $07144aea14354eb9$var$tinf_decode_symbol$1(d, t) {
    while(d.bitcount < 24){
        d.tag |= d.source[d.sourceIndex++] << d.bitcount;
        d.bitcount += 8;
    }
    var sum = 0, cur = 0, len = 0;
    var tag = d.tag;
    /* get more bits while code value is above sum */ do {
        cur = 2 * cur + (tag & 1);
        tag >>>= 1;
        ++len;
        sum += t.table[len];
        cur -= t.table[len];
    }while (cur >= 0);
    d.tag = tag;
    d.bitcount -= len;
    return t.trans[sum + cur];
}
/* given a data stream, decode dynamic trees from it */ function $07144aea14354eb9$var$tinf_decode_trees$1(d, lt, dt) {
    var hlit, hdist, hclen;
    var i, num, length;
    /* get 5 bits HLIT (257-286) */ hlit = $07144aea14354eb9$var$tinf_read_bits$1(d, 5, 257);
    /* get 5 bits HDIST (1-32) */ hdist = $07144aea14354eb9$var$tinf_read_bits$1(d, 5, 1);
    /* get 4 bits HCLEN (4-19) */ hclen = $07144aea14354eb9$var$tinf_read_bits$1(d, 4, 4);
    for(i = 0; i < 19; ++i)$07144aea14354eb9$var$lengths$1[i] = 0;
    /* read code lengths for code length alphabet */ for(i = 0; i < hclen; ++i){
        /* get 3 bits code length (0-7) */ var clen = $07144aea14354eb9$var$tinf_read_bits$1(d, 3, 0);
        $07144aea14354eb9$var$lengths$1[$07144aea14354eb9$var$clcidx$1[i]] = clen;
    }
    /* build code length tree */ $07144aea14354eb9$var$tinf_build_tree$1($07144aea14354eb9$var$code_tree$1, $07144aea14354eb9$var$lengths$1, 0, 19);
    /* decode code lengths for the dynamic trees */ for(num = 0; num < hlit + hdist;){
        var sym = $07144aea14354eb9$var$tinf_decode_symbol$1(d, $07144aea14354eb9$var$code_tree$1);
        switch(sym){
            case 16:
                /* copy previous code length 3-6 times (read 2 bits) */ var prev = $07144aea14354eb9$var$lengths$1[num - 1];
                for(length = $07144aea14354eb9$var$tinf_read_bits$1(d, 2, 3); length; --length)$07144aea14354eb9$var$lengths$1[num++] = prev;
                break;
            case 17:
                /* repeat code length 0 for 3-10 times (read 3 bits) */ for(length = $07144aea14354eb9$var$tinf_read_bits$1(d, 3, 3); length; --length)$07144aea14354eb9$var$lengths$1[num++] = 0;
                break;
            case 18:
                /* repeat code length 0 for 11-138 times (read 7 bits) */ for(length = $07144aea14354eb9$var$tinf_read_bits$1(d, 7, 11); length; --length)$07144aea14354eb9$var$lengths$1[num++] = 0;
                break;
            default:
                /* values 0-15 represent the actual code lengths */ $07144aea14354eb9$var$lengths$1[num++] = sym;
                break;
        }
    }
    /* build dynamic trees */ $07144aea14354eb9$var$tinf_build_tree$1(lt, $07144aea14354eb9$var$lengths$1, 0, hlit);
    $07144aea14354eb9$var$tinf_build_tree$1(dt, $07144aea14354eb9$var$lengths$1, hlit, hdist);
}
/* ----------------------------- *
 * -- block inflate functions -- *
 * ----------------------------- */ /* given a stream and two trees, inflate a block of data */ function $07144aea14354eb9$var$tinf_inflate_block_data$1(d, lt, dt) {
    while(true){
        var sym = $07144aea14354eb9$var$tinf_decode_symbol$1(d, lt);
        /* check for end of block */ if (sym === 256) return $07144aea14354eb9$var$TINF_OK$1;
        if (sym < 256) d.dest[d.destLen++] = sym;
        else {
            var length, dist, offs;
            var i;
            sym -= 257;
            /* possibly get more bits from length code */ length = $07144aea14354eb9$var$tinf_read_bits$1(d, $07144aea14354eb9$var$length_bits$1[sym], $07144aea14354eb9$var$length_base$1[sym]);
            dist = $07144aea14354eb9$var$tinf_decode_symbol$1(d, dt);
            /* possibly get more bits from distance code */ offs = d.destLen - $07144aea14354eb9$var$tinf_read_bits$1(d, $07144aea14354eb9$var$dist_bits$1[dist], $07144aea14354eb9$var$dist_base$1[dist]);
            /* copy match */ for(i = offs; i < offs + length; ++i)d.dest[d.destLen++] = d.dest[i];
        }
    }
}
/* inflate an uncompressed block of data */ function $07144aea14354eb9$var$tinf_inflate_uncompressed_block$1(d) {
    var length, invlength;
    var i;
    /* unread from bitbuffer */ while(d.bitcount > 8){
        d.sourceIndex--;
        d.bitcount -= 8;
    }
    /* get length */ length = d.source[d.sourceIndex + 1];
    length = 256 * length + d.source[d.sourceIndex];
    /* get one's complement of length */ invlength = d.source[d.sourceIndex + 3];
    invlength = 256 * invlength + d.source[d.sourceIndex + 2];
    /* check length */ if (length !== (~invlength & 0x0000ffff)) return $07144aea14354eb9$var$TINF_DATA_ERROR$1;
    d.sourceIndex += 4;
    /* copy block */ for(i = length; i; --i)d.dest[d.destLen++] = d.source[d.sourceIndex++];
    /* make sure we start next block on a byte boundary */ d.bitcount = 0;
    return $07144aea14354eb9$var$TINF_OK$1;
}
/* inflate stream from source to dest */ function $07144aea14354eb9$var$tinf_uncompress$1(source, dest) {
    var d = new $07144aea14354eb9$var$Data$1(source, dest);
    var bfinal, btype, res;
    do {
        /* read final block flag */ bfinal = $07144aea14354eb9$var$tinf_getbit$1(d);
        /* read block type (2 bits) */ btype = $07144aea14354eb9$var$tinf_read_bits$1(d, 2, 0);
        /* decompress block */ switch(btype){
            case 0:
                /* decompress uncompressed block */ res = $07144aea14354eb9$var$tinf_inflate_uncompressed_block$1(d);
                break;
            case 1:
                /* decompress block with fixed huffman trees */ res = $07144aea14354eb9$var$tinf_inflate_block_data$1(d, $07144aea14354eb9$var$sltree$1, $07144aea14354eb9$var$sdtree$1);
                break;
            case 2:
                /* decompress block with dynamic huffman trees */ $07144aea14354eb9$var$tinf_decode_trees$1(d, d.ltree, d.dtree);
                res = $07144aea14354eb9$var$tinf_inflate_block_data$1(d, d.ltree, d.dtree);
                break;
            default:
                res = $07144aea14354eb9$var$TINF_DATA_ERROR$1;
        }
        if (res !== $07144aea14354eb9$var$TINF_OK$1) throw new Error('Data error');
    }while (!bfinal);
    if (d.destLen < d.dest.length) {
        if (typeof d.dest.slice === 'function') return d.dest.slice(0, d.destLen);
        else return d.dest.subarray(0, d.destLen);
    }
    return d.dest;
}
/* -------------------- *
 * -- initialization -- *
 * -------------------- */ /* build fixed huffman trees */ $07144aea14354eb9$var$tinf_build_fixed_trees$1($07144aea14354eb9$var$sltree$1, $07144aea14354eb9$var$sdtree$1);
/* build extra bits and base tables */ $07144aea14354eb9$var$tinf_build_bits_base$1($07144aea14354eb9$var$length_bits$1, $07144aea14354eb9$var$length_base$1, 4, 3);
$07144aea14354eb9$var$tinf_build_bits_base$1($07144aea14354eb9$var$dist_bits$1, $07144aea14354eb9$var$dist_base$1, 2, 1);
/* fix a special case */ $07144aea14354eb9$var$length_bits$1[28] = 0;
$07144aea14354eb9$var$length_base$1[28] = 258;
var $07144aea14354eb9$var$tinyInflate$1 = $07144aea14354eb9$var$tinf_uncompress$1;
function $07144aea14354eb9$var$_inheritsLoose$f(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $07144aea14354eb9$var$WOFFFont = /*#__PURE__*/ function(_TTFFont) {
    $07144aea14354eb9$var$_inheritsLoose$f(WOFFFont, _TTFFont);
    function WOFFFont() {
        return _TTFFont.apply(this, arguments) || this;
    }
    WOFFFont.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'wOFF';
    };
    var _proto = WOFFFont.prototype;
    _proto._decodeDirectory = function _decodeDirectory() {
        this.directory = $07144aea14354eb9$var$WOFFDirectory.decode(this.stream, {
            _startOffset: 0
        });
    };
    _proto._getTableStream = function _getTableStream(tag) {
        var table = this.directory.tables[tag];
        if (table) {
            this.stream.pos = table.offset;
            if (table.compLength < table.length) {
                this.stream.pos += 2; // skip deflate header
                var outBuffer = new $07144aea14354eb9$var$buffer_1(table.length);
                var buf = $07144aea14354eb9$var$tinyInflate$1(this.stream.readBuffer(table.compLength - 2), outBuffer);
                return new $07144aea14354eb9$var$restructure.DecodeStream(buf);
            } else return this.stream;
        }
        return null;
    };
    return WOFFFont;
}($07144aea14354eb9$var$TTFFont);
function $07144aea14354eb9$var$BrotliInput(buffer) {
    this.buffer = buffer;
    this.pos = 0;
}
$07144aea14354eb9$var$BrotliInput.prototype.read = function(buf, i, count) {
    if (this.pos + count > this.buffer.length) count = this.buffer.length - this.pos;
    for(var p = 0; p < count; p++)buf[i + p] = this.buffer[this.pos + p];
    this.pos += count;
    return count;
};
var $07144aea14354eb9$var$BrotliInput_1 = $07144aea14354eb9$var$BrotliInput;
function $07144aea14354eb9$var$BrotliOutput(buf) {
    this.buffer = buf;
    this.pos = 0;
}
$07144aea14354eb9$var$BrotliOutput.prototype.write = function(buf, count) {
    if (this.pos + count > this.buffer.length) throw new Error('Output buffer is not large enough');
    this.buffer.set(buf.subarray(0, count), this.pos);
    this.pos += count;
    return count;
};
var $07144aea14354eb9$var$BrotliOutput_1 = $07144aea14354eb9$var$BrotliOutput;
var $07144aea14354eb9$var$streams$1 = {
    BrotliInput: $07144aea14354eb9$var$BrotliInput_1,
    BrotliOutput: $07144aea14354eb9$var$BrotliOutput_1
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Bit reading helpers
*/ var $07144aea14354eb9$var$BROTLI_READ_SIZE = 4096;
var $07144aea14354eb9$var$BROTLI_IBUF_SIZE = 2 * $07144aea14354eb9$var$BROTLI_READ_SIZE + 32;
var $07144aea14354eb9$var$BROTLI_IBUF_MASK = 2 * $07144aea14354eb9$var$BROTLI_READ_SIZE - 1;
var $07144aea14354eb9$var$kBitMask = new Uint32Array([
    0,
    1,
    3,
    7,
    15,
    31,
    63,
    127,
    255,
    511,
    1023,
    2047,
    4095,
    8191,
    16383,
    32767,
    65535,
    131071,
    262143,
    524287,
    1048575,
    2097151,
    4194303,
    8388607,
    16777215
]);
/* Input byte buffer, consist of a ringbuffer and a "slack" region where */ /* bytes from the start of the ringbuffer are copied. */ function $07144aea14354eb9$var$BrotliBitReader(input) {
    this.buf_ = new Uint8Array($07144aea14354eb9$var$BROTLI_IBUF_SIZE);
    this.input_ = input;
    /* input callback */ this.reset();
}
$07144aea14354eb9$var$BrotliBitReader.READ_SIZE = $07144aea14354eb9$var$BROTLI_READ_SIZE;
$07144aea14354eb9$var$BrotliBitReader.IBUF_MASK = $07144aea14354eb9$var$BROTLI_IBUF_MASK;
$07144aea14354eb9$var$BrotliBitReader.prototype.reset = function() {
    this.buf_ptr_ = 0;
    /* next input will write here */ this.val_ = 0;
    /* pre-fetched bits */ this.pos_ = 0;
    /* byte position in stream */ this.bit_pos_ = 0;
    /* current bit-reading position in val_ */ this.bit_end_pos_ = 0;
    /* bit-reading end position from LSB of val_ */ this.eos_ = 0;
    /* input stream is finished */ this.readMoreInput();
    for(var i = 0; i < 4; i++){
        this.val_ |= this.buf_[this.pos_] << 8 * i;
        ++this.pos_;
    }
    return this.bit_end_pos_ > 0;
};
/* Fills up the input ringbuffer by calling the input callback.

   Does nothing if there are at least 32 bytes present after current position.

   Returns 0 if either:
    - the input callback returned an error, or
    - there is no more input and the position is past the end of the stream.

   After encountering the end of the input stream, 32 additional zero bytes are
   copied to the ringbuffer, therefore it is safe to call this function after
   every 32 bytes of input is read.
*/ $07144aea14354eb9$var$BrotliBitReader.prototype.readMoreInput = function() {
    if (this.bit_end_pos_ > 256) return;
    else if (this.eos_) {
        if (this.bit_pos_ > this.bit_end_pos_) throw new Error('Unexpected end of input ' + this.bit_pos_ + ' ' + this.bit_end_pos_);
    } else {
        var dst = this.buf_ptr_;
        var bytes_read = this.input_.read(this.buf_, dst, $07144aea14354eb9$var$BROTLI_READ_SIZE);
        if (bytes_read < 0) throw new Error('Unexpected end of input');
        if (bytes_read < $07144aea14354eb9$var$BROTLI_READ_SIZE) {
            this.eos_ = 1;
            /* Store 32 bytes of zero after the stream end. */ for(var p = 0; p < 32; p++)this.buf_[dst + bytes_read + p] = 0;
        }
        if (dst === 0) {
            /* Copy the head of the ringbuffer to the slack region. */ for(var p = 0; p < 32; p++)this.buf_[($07144aea14354eb9$var$BROTLI_READ_SIZE << 1) + p] = this.buf_[p];
            this.buf_ptr_ = $07144aea14354eb9$var$BROTLI_READ_SIZE;
        } else this.buf_ptr_ = 0;
        this.bit_end_pos_ += bytes_read << 3;
    }
};
/* Guarantees that there are at least 24 bits in the buffer. */ $07144aea14354eb9$var$BrotliBitReader.prototype.fillBitWindow = function() {
    while(this.bit_pos_ >= 8){
        this.val_ >>>= 8;
        this.val_ |= this.buf_[this.pos_ & $07144aea14354eb9$var$BROTLI_IBUF_MASK] << 24;
        ++this.pos_;
        this.bit_pos_ = this.bit_pos_ - 8 >>> 0;
        this.bit_end_pos_ = this.bit_end_pos_ - 8 >>> 0;
    }
};
/* Reads the specified number of bits from Read Buffer. */ $07144aea14354eb9$var$BrotliBitReader.prototype.readBits = function(n_bits) {
    if (32 - this.bit_pos_ < n_bits) this.fillBitWindow();
    var val = this.val_ >>> this.bit_pos_ & $07144aea14354eb9$var$kBitMask[n_bits];
    this.bit_pos_ += n_bits;
    return val;
};
var $07144aea14354eb9$var$bit_reader = $07144aea14354eb9$var$BrotliBitReader;
var $07144aea14354eb9$var$byteLength_1$1 = $07144aea14354eb9$var$byteLength$1;
var $07144aea14354eb9$var$toByteArray_1$1 = $07144aea14354eb9$var$toByteArray$1;
var $07144aea14354eb9$var$fromByteArray_1$1 = $07144aea14354eb9$var$fromByteArray$1;
var $07144aea14354eb9$var$lookup$1 = [];
var $07144aea14354eb9$var$revLookup$1 = [];
var $07144aea14354eb9$var$Arr$1 = typeof Uint8Array !== 'undefined' ? Uint8Array : Array;
var $07144aea14354eb9$var$code$1 = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
for(var $07144aea14354eb9$var$i$4 = 0, $07144aea14354eb9$var$len$1 = $07144aea14354eb9$var$code$1.length; $07144aea14354eb9$var$i$4 < $07144aea14354eb9$var$len$1; ++$07144aea14354eb9$var$i$4){
    $07144aea14354eb9$var$lookup$1[$07144aea14354eb9$var$i$4] = $07144aea14354eb9$var$code$1[$07144aea14354eb9$var$i$4];
    $07144aea14354eb9$var$revLookup$1[$07144aea14354eb9$var$code$1.charCodeAt($07144aea14354eb9$var$i$4)] = $07144aea14354eb9$var$i$4;
} // Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$07144aea14354eb9$var$revLookup$1['-'.charCodeAt(0)] = 62;
$07144aea14354eb9$var$revLookup$1['_'.charCodeAt(0)] = 63;
function $07144aea14354eb9$var$getLens$1(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error('Invalid string. Length must be a multiple of 4');
     // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf('=');
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
} // base64 is 4/3 + up to two characters of the original data
function $07144aea14354eb9$var$byteLength$1(b64) {
    var lens = $07144aea14354eb9$var$getLens$1(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $07144aea14354eb9$var$_byteLength$1(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $07144aea14354eb9$var$toByteArray$1(b64) {
    var tmp;
    var lens = $07144aea14354eb9$var$getLens$1(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $07144aea14354eb9$var$Arr$1($07144aea14354eb9$var$_byteLength$1(b64, validLen, placeHoldersLen));
    var curByte = 0; // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    for(var i = 0; i < len; i += 4){
        tmp = $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i)] << 18 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 1)] << 12 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 2)] << 6 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i)] << 2 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i)] << 10 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 1)] << 4 | $07144aea14354eb9$var$revLookup$1[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $07144aea14354eb9$var$tripletToBase64$1(num) {
    return $07144aea14354eb9$var$lookup$1[num >> 18 & 0x3F] + $07144aea14354eb9$var$lookup$1[num >> 12 & 0x3F] + $07144aea14354eb9$var$lookup$1[num >> 6 & 0x3F] + $07144aea14354eb9$var$lookup$1[num & 0x3F];
}
function $07144aea14354eb9$var$encodeChunk$1(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($07144aea14354eb9$var$tripletToBase64$1(tmp));
    }
    return output.join('');
}
function $07144aea14354eb9$var$fromByteArray$1(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3; // if we have 1 byte left, pad 2 bytes
    var parts = [];
    var maxChunkLength = 16383; // must be multiple of 3
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($07144aea14354eb9$var$encodeChunk$1(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
     // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($07144aea14354eb9$var$lookup$1[tmp >> 2] + $07144aea14354eb9$var$lookup$1[tmp << 4 & 0x3F] + '==');
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($07144aea14354eb9$var$lookup$1[tmp >> 10] + $07144aea14354eb9$var$lookup$1[tmp >> 4 & 0x3F] + $07144aea14354eb9$var$lookup$1[tmp << 2 & 0x3F] + '=');
    }
    return parts.join('');
}
var $07144aea14354eb9$var$base64Js$1 = {
    byteLength: $07144aea14354eb9$var$byteLength_1$1,
    toByteArray: $07144aea14354eb9$var$toByteArray_1$1,
    fromByteArray: $07144aea14354eb9$var$fromByteArray_1$1
};
var $07144aea14354eb9$var$dictionary_bin = "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";
/**
 * The normal dictionary-data.js is quite large, which makes it
 * unsuitable for browser usage. In order to make it smaller,
 * we read dictionary.bin, which is a compressed version of
 * the dictionary, and on initial load, Brotli decompresses
 * it's own dictionary. 😜
 */ var $07144aea14354eb9$var$init = function init(BrotliDecompressBuffer) {
    var compressed = $07144aea14354eb9$var$base64Js$1.toByteArray($07144aea14354eb9$var$dictionary_bin);
    return BrotliDecompressBuffer(compressed);
};
var $07144aea14354eb9$var$dictionaryDataCompressed = {
    init: $07144aea14354eb9$var$init
};
var $07144aea14354eb9$var$dictionary = $07144aea14354eb9$var$createCommonjsModule(function(module, exports) {
    /* Copyright 2013 Google Inc. All Rights Reserved.
  
     Licensed under the Apache License, Version 2.0 (the "License");
     you may not use this file except in compliance with the License.
     You may obtain a copy of the License at
  
     http://www.apache.org/licenses/LICENSE-2.0
  
     Unless required by applicable law or agreed to in writing, software
     distributed under the License is distributed on an "AS IS" BASIS,
     WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
     See the License for the specific language governing permissions and
     limitations under the License.
  
     Collection of static dictionary words.
  */ exports.init = function(BrotliDecompressBuffer) {
        exports.dictionary = $07144aea14354eb9$var$dictionaryDataCompressed.init(BrotliDecompressBuffer);
    };
    exports.offsetsByLength = new Uint32Array([
        0,
        0,
        0,
        0,
        0,
        4096,
        9216,
        21504,
        35840,
        44032,
        53248,
        63488,
        74752,
        87040,
        93696,
        100864,
        104704,
        106752,
        108928,
        113536,
        115968,
        118528,
        119872,
        121280,
        122016
    ]);
    exports.sizeBitsByLength = new Uint8Array([
        0,
        0,
        0,
        0,
        10,
        10,
        11,
        11,
        10,
        10,
        10,
        10,
        10,
        9,
        9,
        8,
        7,
        7,
        8,
        7,
        7,
        6,
        6,
        5,
        5
    ]);
    exports.minDictionaryWordLength = 4;
    exports.maxDictionaryWordLength = 24;
});
var $07144aea14354eb9$var$dictionary_1 = $07144aea14354eb9$var$dictionary.init;
var $07144aea14354eb9$var$dictionary_2 = $07144aea14354eb9$var$dictionary.dictionary;
var $07144aea14354eb9$var$dictionary_3 = $07144aea14354eb9$var$dictionary.offsetsByLength;
var $07144aea14354eb9$var$dictionary_4 = $07144aea14354eb9$var$dictionary.sizeBitsByLength;
var $07144aea14354eb9$var$dictionary_5 = $07144aea14354eb9$var$dictionary.minDictionaryWordLength;
var $07144aea14354eb9$var$dictionary_6 = $07144aea14354eb9$var$dictionary.maxDictionaryWordLength;
function $07144aea14354eb9$var$HuffmanCode(bits, value) {
    this.bits = bits;
    /* number of bits used for this symbol */ this.value = value;
/* symbol value or table offset */ }
var $07144aea14354eb9$var$HuffmanCode_1 = $07144aea14354eb9$var$HuffmanCode;
var $07144aea14354eb9$var$MAX_LENGTH = 15;
/* Returns reverse(reverse(key, len) + 1, len), where reverse(key, len) is the
   bit-wise reversal of the len least significant bits of key. */ function $07144aea14354eb9$var$GetNextKey(key, len) {
    var step = 1 << len - 1;
    while(key & step)step >>= 1;
    return (key & step - 1) + step;
}
/* Stores code in table[0], table[step], table[2*step], ..., table[end] */ /* Assumes that end is an integer multiple of step */ function $07144aea14354eb9$var$ReplicateValue(table, i, step, end, code) {
    do {
        end -= step;
        table[i + end] = new $07144aea14354eb9$var$HuffmanCode(code.bits, code.value);
    }while (end > 0);
}
/* Returns the table width of the next 2nd level table. count is the histogram
   of bit lengths for the remaining symbols, len is the code length of the next
   processed symbol */ function $07144aea14354eb9$var$NextTableBitSize(count, len, root_bits) {
    var left = 1 << len - root_bits;
    while(len < $07144aea14354eb9$var$MAX_LENGTH){
        left -= count[len];
        if (left <= 0) break;
        ++len;
        left <<= 1;
    }
    return len - root_bits;
}
var $07144aea14354eb9$var$BrotliBuildHuffmanTable = function BrotliBuildHuffmanTable(root_table, table, root_bits, code_lengths, code_lengths_size) {
    var start_table = table;
    var code;
    /* current table entry */ var len;
    /* current code length */ var symbol;
    /* symbol index in original or sorted table */ var key;
    /* reversed prefix code */ var step;
    /* step size to replicate values in current table */ var low;
    /* low bits for current root entry */ var mask;
    /* mask for low bits */ var table_bits;
    /* key length of current table */ var table_size;
    /* size of current table */ var total_size;
    /* sum of root table size and 2nd level table sizes */ var sorted;
    /* symbols sorted by code length */ var count = new Int32Array($07144aea14354eb9$var$MAX_LENGTH + 1);
    /* number of codes of each length */ var offset = new Int32Array($07144aea14354eb9$var$MAX_LENGTH + 1);
    /* offsets in sorted table for each length */ sorted = new Int32Array(code_lengths_size);
    /* build histogram of code lengths */ for(symbol = 0; symbol < code_lengths_size; symbol++)count[code_lengths[symbol]]++;
    /* generate offsets into sorted symbol table by code length */ offset[1] = 0;
    for(len = 1; len < $07144aea14354eb9$var$MAX_LENGTH; len++)offset[len + 1] = offset[len] + count[len];
    /* sort symbols by length, by symbol order within each length */ for(symbol = 0; symbol < code_lengths_size; symbol++)if (code_lengths[symbol] !== 0) sorted[offset[code_lengths[symbol]]++] = symbol;
    table_bits = root_bits;
    table_size = 1 << table_bits;
    total_size = table_size;
    /* special case code with only one value */ if (offset[$07144aea14354eb9$var$MAX_LENGTH] === 1) {
        for(key = 0; key < total_size; ++key)root_table[table + key] = new $07144aea14354eb9$var$HuffmanCode(0, sorted[0] & 0xffff);
        return total_size;
    }
    /* fill in root table */ key = 0;
    symbol = 0;
    for(len = 1, step = 2; len <= root_bits; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        code = new $07144aea14354eb9$var$HuffmanCode(len & 0xff, sorted[symbol++] & 0xffff);
        $07144aea14354eb9$var$ReplicateValue(root_table, table + key, step, table_size, code);
        key = $07144aea14354eb9$var$GetNextKey(key, len);
    }
    /* fill in 2nd level tables and add pointers to root table */ mask = total_size - 1;
    low = -1;
    for(len = root_bits + 1, step = 2; len <= $07144aea14354eb9$var$MAX_LENGTH; ++len, step <<= 1)for(; count[len] > 0; --count[len]){
        if ((key & mask) !== low) {
            table += table_size;
            table_bits = $07144aea14354eb9$var$NextTableBitSize(count, len, root_bits);
            table_size = 1 << table_bits;
            total_size += table_size;
            low = key & mask;
            root_table[start_table + low] = new $07144aea14354eb9$var$HuffmanCode(table_bits + root_bits & 0xff, table - start_table - low & 0xffff);
        }
        code = new $07144aea14354eb9$var$HuffmanCode(len - root_bits & 0xff, sorted[symbol++] & 0xffff);
        $07144aea14354eb9$var$ReplicateValue(root_table, table + (key >> root_bits), step, table_size, code);
        key = $07144aea14354eb9$var$GetNextKey(key, len);
    }
    return total_size;
};
var $07144aea14354eb9$var$huffman = {
    HuffmanCode: $07144aea14354eb9$var$HuffmanCode_1,
    BrotliBuildHuffmanTable: $07144aea14354eb9$var$BrotliBuildHuffmanTable
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup table to map the previous two bytes to a context id.

   There are four different context modeling modes defined here:
     CONTEXT_LSB6: context id is the least significant 6 bits of the last byte,
     CONTEXT_MSB6: context id is the most significant 6 bits of the last byte,
     CONTEXT_UTF8: second-order context model tuned for UTF8-encoded text,
     CONTEXT_SIGNED: second-order context model tuned for signed integers.

   The context id for the UTF8 context model is calculated as follows. If p1
   and p2 are the previous two bytes, we calcualte the context as

     context = kContextLookup[p1] | kContextLookup[p2 + 256].

   If the previous two bytes are ASCII characters (i.e. < 128), this will be
   equivalent to

     context = 4 * context1(p1) + context2(p2),

   where context1 is based on the previous byte in the following way:

     0  : non-ASCII control
     1  : \t, \n, \r
     2  : space
     3  : other punctuation
     4  : " '
     5  : %
     6  : ( < [ {
     7  : ) > ] }
     8  : , ; :
     9  : .
     10 : =
     11 : number
     12 : upper-case vowel
     13 : upper-case consonant
     14 : lower-case vowel
     15 : lower-case consonant

   and context2 is based on the second last byte:

     0 : control, space
     1 : punctuation
     2 : upper-case letter, number
     3 : lower-case letter

   If the last byte is ASCII, and the second last byte is not (in a valid UTF8
   stream it will be a continuation byte, value between 128 and 191), the
   context is the same as if the second last byte was an ASCII control or space.

   If the last byte is a UTF8 lead byte (value >= 192), then the next byte will
   be a continuation byte and the context id is 2 or 3 depending on the LSB of
   the last byte and to a lesser extent on the second last byte if it is ASCII.

   If the last byte is a UTF8 continuation byte, the second last byte can be:
     - continuation byte: the next byte is probably ASCII or lead byte (assuming
       4-byte UTF8 characters are rare) and the context id is 0 or 1.
     - lead byte (192 - 207): next byte is ASCII or lead byte, context is 0 or 1
     - lead byte (208 - 255): next byte is continuation byte, context is 2 or 3

   The possible value combinations of the previous two bytes, the range of
   context ids and the type of the next byte is summarized in the table below:

   |--------\-----------------------------------------------------------------|
   |         \                         Last byte                              |
   | Second   \---------------------------------------------------------------|
   | last byte \    ASCII            |   cont. byte        |   lead byte      |
   |            \   (0-127)          |   (128-191)         |   (192-)         |
   |=============|===================|=====================|==================|
   |  ASCII      | next: ASCII/lead  |  not valid          |  next: cont.     |
   |  (0-127)    | context: 4 - 63   |                     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  cont. byte | next: ASCII/lead  |  next: ASCII/lead   |  next: cont.     |
   |  (128-191)  | context: 4 - 63   |  context: 0 - 1     |  context: 2 - 3  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: ASCII/lead   |  not valid       |
   |  (192-207)  |                   |  context: 0 - 1     |                  |
   |-------------|-------------------|---------------------|------------------|
   |  lead byte  | not valid         |  next: cont.        |  not valid       |
   |  (208-)     |                   |  context: 2 - 3     |                  |
   |-------------|-------------------|---------------------|------------------|

   The context id for the signed context mode is calculated as:

     context = (kContextLookup[512 + p1] << 3) | kContextLookup[512 + p2].

   For any context modeling modes, the context ids can be calculated by |-ing
   together two lookups from one table using context model dependent offsets:

     context = kContextLookup[offset1 + p1] | kContextLookup[offset2 + p2].

   where offset1 and offset2 are dependent on the context mode.
*/ /* Common context lookup table for all context modes. */ var $07144aea14354eb9$var$lookup$2 = new Uint8Array([
    /* CONTEXT_UTF8, last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    4,
    4,
    0,
    0,
    4,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    8,
    12,
    16,
    12,
    12,
    20,
    12,
    16,
    24,
    28,
    12,
    12,
    32,
    12,
    36,
    12,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    44,
    32,
    32,
    24,
    40,
    28,
    12,
    12,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    48,
    52,
    52,
    52,
    52,
    52,
    24,
    12,
    28,
    12,
    12,
    12,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    56,
    60,
    60,
    60,
    60,
    60,
    24,
    12,
    28,
    12,
    0,
    /* UTF8 continuation byte range. */ 0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    0,
    1,
    /* UTF8 lead byte range. */ 2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    2,
    3,
    /* CONTEXT_UTF8 second last byte. */ /* ASCII range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    1,
    1,
    1,
    1,
    1,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    1,
    1,
    1,
    1,
    0,
    /* UTF8 continuation byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    /* UTF8 lead byte range. */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    /* CONTEXT_SIGNED, second last byte. */ 0,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    6,
    7,
    /* CONTEXT_SIGNED, last byte, same as the above values shifted by 3 bits. */ 0,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    8,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    16,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    24,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    32,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    40,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    48,
    56,
    /* CONTEXT_LSB6, last byte. */ 0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20,
    21,
    22,
    23,
    24,
    25,
    26,
    27,
    28,
    29,
    30,
    31,
    32,
    33,
    34,
    35,
    36,
    37,
    38,
    39,
    40,
    41,
    42,
    43,
    44,
    45,
    46,
    47,
    48,
    49,
    50,
    51,
    52,
    53,
    54,
    55,
    56,
    57,
    58,
    59,
    60,
    61,
    62,
    63,
    /* CONTEXT_MSB6, last byte. */ 0,
    0,
    0,
    0,
    1,
    1,
    1,
    1,
    2,
    2,
    2,
    2,
    3,
    3,
    3,
    3,
    4,
    4,
    4,
    4,
    5,
    5,
    5,
    5,
    6,
    6,
    6,
    6,
    7,
    7,
    7,
    7,
    8,
    8,
    8,
    8,
    9,
    9,
    9,
    9,
    10,
    10,
    10,
    10,
    11,
    11,
    11,
    11,
    12,
    12,
    12,
    12,
    13,
    13,
    13,
    13,
    14,
    14,
    14,
    14,
    15,
    15,
    15,
    15,
    16,
    16,
    16,
    16,
    17,
    17,
    17,
    17,
    18,
    18,
    18,
    18,
    19,
    19,
    19,
    19,
    20,
    20,
    20,
    20,
    21,
    21,
    21,
    21,
    22,
    22,
    22,
    22,
    23,
    23,
    23,
    23,
    24,
    24,
    24,
    24,
    25,
    25,
    25,
    25,
    26,
    26,
    26,
    26,
    27,
    27,
    27,
    27,
    28,
    28,
    28,
    28,
    29,
    29,
    29,
    29,
    30,
    30,
    30,
    30,
    31,
    31,
    31,
    31,
    32,
    32,
    32,
    32,
    33,
    33,
    33,
    33,
    34,
    34,
    34,
    34,
    35,
    35,
    35,
    35,
    36,
    36,
    36,
    36,
    37,
    37,
    37,
    37,
    38,
    38,
    38,
    38,
    39,
    39,
    39,
    39,
    40,
    40,
    40,
    40,
    41,
    41,
    41,
    41,
    42,
    42,
    42,
    42,
    43,
    43,
    43,
    43,
    44,
    44,
    44,
    44,
    45,
    45,
    45,
    45,
    46,
    46,
    46,
    46,
    47,
    47,
    47,
    47,
    48,
    48,
    48,
    48,
    49,
    49,
    49,
    49,
    50,
    50,
    50,
    50,
    51,
    51,
    51,
    51,
    52,
    52,
    52,
    52,
    53,
    53,
    53,
    53,
    54,
    54,
    54,
    54,
    55,
    55,
    55,
    55,
    56,
    56,
    56,
    56,
    57,
    57,
    57,
    57,
    58,
    58,
    58,
    58,
    59,
    59,
    59,
    59,
    60,
    60,
    60,
    60,
    61,
    61,
    61,
    61,
    62,
    62,
    62,
    62,
    63,
    63,
    63,
    63,
    /* CONTEXT_{M,L}SB6, second last byte, */ 0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0,
    0
]);
var $07144aea14354eb9$var$lookupOffsets = new Uint16Array([
    /* CONTEXT_LSB6 */ 1024,
    1536,
    /* CONTEXT_MSB6 */ 1280,
    1536,
    /* CONTEXT_UTF8 */ 0,
    256,
    /* CONTEXT_SIGNED */ 768,
    512
]);
var $07144aea14354eb9$var$context = {
    lookup: $07144aea14354eb9$var$lookup$2,
    lookupOffsets: $07144aea14354eb9$var$lookupOffsets
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Lookup tables to map prefix codes to value ranges. This is used during
   decoding of the block lengths, literal insertion lengths and copy lengths.
*/ /* Represents the range of values belonging to a prefix code: */ /* [offset, offset + 2^nbits) */ function $07144aea14354eb9$var$PrefixCodeRange(offset, nbits) {
    this.offset = offset;
    this.nbits = nbits;
}
var $07144aea14354eb9$var$kBlockLengthPrefixCode = [
    new $07144aea14354eb9$var$PrefixCodeRange(1, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(5, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(9, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(13, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(17, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(25, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(33, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(41, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(49, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(65, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(81, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(97, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(113, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(145, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(177, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(209, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(241, 6),
    new $07144aea14354eb9$var$PrefixCodeRange(305, 6),
    new $07144aea14354eb9$var$PrefixCodeRange(369, 7),
    new $07144aea14354eb9$var$PrefixCodeRange(497, 8),
    new $07144aea14354eb9$var$PrefixCodeRange(753, 9),
    new $07144aea14354eb9$var$PrefixCodeRange(1265, 10),
    new $07144aea14354eb9$var$PrefixCodeRange(2289, 11),
    new $07144aea14354eb9$var$PrefixCodeRange(4337, 12),
    new $07144aea14354eb9$var$PrefixCodeRange(8433, 13),
    new $07144aea14354eb9$var$PrefixCodeRange(16625, 24)
];
var $07144aea14354eb9$var$kInsertLengthPrefixCode = [
    new $07144aea14354eb9$var$PrefixCodeRange(0, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(1, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(2, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(3, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(4, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(5, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(6, 1),
    new $07144aea14354eb9$var$PrefixCodeRange(8, 1),
    new $07144aea14354eb9$var$PrefixCodeRange(10, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(14, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(18, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(26, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(34, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(50, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(66, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(98, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(130, 6),
    new $07144aea14354eb9$var$PrefixCodeRange(194, 7),
    new $07144aea14354eb9$var$PrefixCodeRange(322, 8),
    new $07144aea14354eb9$var$PrefixCodeRange(578, 9),
    new $07144aea14354eb9$var$PrefixCodeRange(1090, 10),
    new $07144aea14354eb9$var$PrefixCodeRange(2114, 12),
    new $07144aea14354eb9$var$PrefixCodeRange(6210, 14),
    new $07144aea14354eb9$var$PrefixCodeRange(22594, 24)
];
var $07144aea14354eb9$var$kCopyLengthPrefixCode = [
    new $07144aea14354eb9$var$PrefixCodeRange(2, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(3, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(4, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(5, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(6, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(7, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(8, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(9, 0),
    new $07144aea14354eb9$var$PrefixCodeRange(10, 1),
    new $07144aea14354eb9$var$PrefixCodeRange(12, 1),
    new $07144aea14354eb9$var$PrefixCodeRange(14, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(18, 2),
    new $07144aea14354eb9$var$PrefixCodeRange(22, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(30, 3),
    new $07144aea14354eb9$var$PrefixCodeRange(38, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(54, 4),
    new $07144aea14354eb9$var$PrefixCodeRange(70, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(102, 5),
    new $07144aea14354eb9$var$PrefixCodeRange(134, 6),
    new $07144aea14354eb9$var$PrefixCodeRange(198, 7),
    new $07144aea14354eb9$var$PrefixCodeRange(326, 8),
    new $07144aea14354eb9$var$PrefixCodeRange(582, 9),
    new $07144aea14354eb9$var$PrefixCodeRange(1094, 10),
    new $07144aea14354eb9$var$PrefixCodeRange(2118, 24)
];
var $07144aea14354eb9$var$kInsertRangeLut = [
    0,
    0,
    8,
    8,
    0,
    16,
    8,
    16,
    16
];
var $07144aea14354eb9$var$kCopyRangeLut = [
    0,
    8,
    0,
    8,
    16,
    0,
    16,
    8,
    16
];
var $07144aea14354eb9$var$prefix = {
    kBlockLengthPrefixCode: $07144aea14354eb9$var$kBlockLengthPrefixCode,
    kInsertLengthPrefixCode: $07144aea14354eb9$var$kInsertLengthPrefixCode,
    kCopyLengthPrefixCode: $07144aea14354eb9$var$kCopyLengthPrefixCode,
    kInsertRangeLut: $07144aea14354eb9$var$kInsertRangeLut,
    kCopyRangeLut: $07144aea14354eb9$var$kCopyRangeLut
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.

   Transformations on dictionary words.
*/ var $07144aea14354eb9$var$kIdentity = 0;
var $07144aea14354eb9$var$kOmitLast1 = 1;
var $07144aea14354eb9$var$kOmitLast2 = 2;
var $07144aea14354eb9$var$kOmitLast3 = 3;
var $07144aea14354eb9$var$kOmitLast4 = 4;
var $07144aea14354eb9$var$kOmitLast5 = 5;
var $07144aea14354eb9$var$kOmitLast6 = 6;
var $07144aea14354eb9$var$kOmitLast7 = 7;
var $07144aea14354eb9$var$kOmitLast8 = 8;
var $07144aea14354eb9$var$kOmitLast9 = 9;
var $07144aea14354eb9$var$kUppercaseFirst = 10;
var $07144aea14354eb9$var$kUppercaseAll = 11;
var $07144aea14354eb9$var$kOmitFirst1 = 12;
var $07144aea14354eb9$var$kOmitFirst2 = 13;
var $07144aea14354eb9$var$kOmitFirst3 = 14;
var $07144aea14354eb9$var$kOmitFirst4 = 15;
var $07144aea14354eb9$var$kOmitFirst5 = 16;
var $07144aea14354eb9$var$kOmitFirst6 = 17;
var $07144aea14354eb9$var$kOmitFirst7 = 18;
var $07144aea14354eb9$var$kOmitFirst9 = 20;
function $07144aea14354eb9$var$Transform$2(prefix, transform, suffix) {
    this.prefix = new Uint8Array(prefix.length);
    this.transform = transform;
    this.suffix = new Uint8Array(suffix.length);
    for(var i = 0; i < prefix.length; i++)this.prefix[i] = prefix.charCodeAt(i);
    for(var i = 0; i < suffix.length; i++)this.suffix[i] = suffix.charCodeAt(i);
}
var $07144aea14354eb9$var$kTransforms = [
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst1, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " the "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2("s ", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " of "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " and "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst2, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast1, ""),
    new $07144aea14354eb9$var$Transform$2(", ", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ", "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " in "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " to "),
    new $07144aea14354eb9$var$Transform$2("e ", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "\""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "."),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "\">"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "\n"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast3, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "]"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " for "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst3, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast2, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " a "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " that "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ". "),
    new $07144aea14354eb9$var$Transform$2(".", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, ", "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst4, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " with "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "'"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " from "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " by "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst5, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst6, ""),
    new $07144aea14354eb9$var$Transform$2(" the ", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast4, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ". The "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " on "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " as "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " is "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast7, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast1, "ing "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "\n\t"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ":"),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, ". "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ed "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst9, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitFirst7, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast6, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "("),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, ", "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast8, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " at "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ly "),
    new $07144aea14354eb9$var$Transform$2(" the ", $07144aea14354eb9$var$kIdentity, " of "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast5, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kOmitLast9, ""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, ", "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "\""),
    new $07144aea14354eb9$var$Transform$2(".", $07144aea14354eb9$var$kIdentity, "("),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "\">"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "=\""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, "."),
    new $07144aea14354eb9$var$Transform$2(".com/", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2(" the ", $07144aea14354eb9$var$kIdentity, " of the "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "'"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ". This "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, ","),
    new $07144aea14354eb9$var$Transform$2(".", $07144aea14354eb9$var$kIdentity, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "("),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "."),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, " not "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, "=\""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "er "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, " "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "al "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, ""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "='"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "\""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, ". "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, "("),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ful "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, ". "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ive "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "less "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "'"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "est "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, "."),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "\">"),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, "='"),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, ","),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ize "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "."),
    new $07144aea14354eb9$var$Transform$2("\xc2\xa0", $07144aea14354eb9$var$kIdentity, ""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kIdentity, ","),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "=\""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "=\""),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kIdentity, "ous "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, ", "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseFirst, "='"),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, ","),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, "=\""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, ", "),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, ","),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "("),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, ". "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, "."),
    new $07144aea14354eb9$var$Transform$2("", $07144aea14354eb9$var$kUppercaseAll, "='"),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, ". "),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, "=\""),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseAll, "='"),
    new $07144aea14354eb9$var$Transform$2(" ", $07144aea14354eb9$var$kUppercaseFirst, "='")
];
var $07144aea14354eb9$var$kTransforms_1 = $07144aea14354eb9$var$kTransforms;
var $07144aea14354eb9$var$kNumTransforms = $07144aea14354eb9$var$kTransforms.length;
function $07144aea14354eb9$var$ToUpperCase(p, i) {
    if (p[i] < 0xc0) {
        if (p[i] >= 97 && p[i] <= 122) p[i] ^= 32;
        return 1;
    }
    /* An overly simplified uppercasing model for utf-8. */ if (p[i] < 0xe0) {
        p[i + 1] ^= 32;
        return 2;
    }
    /* An arbitrary transform for three byte characters. */ p[i + 2] ^= 5;
    return 3;
}
var $07144aea14354eb9$var$transformDictionaryWord = function transformDictionaryWord(dst, idx, word, len, transform) {
    var prefix = $07144aea14354eb9$var$kTransforms[transform].prefix;
    var suffix = $07144aea14354eb9$var$kTransforms[transform].suffix;
    var t = $07144aea14354eb9$var$kTransforms[transform].transform;
    var skip = t < $07144aea14354eb9$var$kOmitFirst1 ? 0 : t - ($07144aea14354eb9$var$kOmitFirst1 - 1);
    var i = 0;
    var start_idx = idx;
    var uppercase;
    if (skip > len) skip = len;
    var prefix_pos = 0;
    while(prefix_pos < prefix.length)dst[idx++] = prefix[prefix_pos++];
    word += skip;
    len -= skip;
    if (t <= $07144aea14354eb9$var$kOmitLast9) len -= t;
    for(i = 0; i < len; i++)dst[idx++] = $07144aea14354eb9$var$dictionary.dictionary[word + i];
    uppercase = idx - len;
    if (t === $07144aea14354eb9$var$kUppercaseFirst) $07144aea14354eb9$var$ToUpperCase(dst, uppercase);
    else if (t === $07144aea14354eb9$var$kUppercaseAll) while(len > 0){
        var step = $07144aea14354eb9$var$ToUpperCase(dst, uppercase);
        uppercase += step;
        len -= step;
    }
    var suffix_pos = 0;
    while(suffix_pos < suffix.length)dst[idx++] = suffix[suffix_pos++];
    return idx - start_idx;
};
var $07144aea14354eb9$var$transform = {
    kTransforms: $07144aea14354eb9$var$kTransforms_1,
    kNumTransforms: $07144aea14354eb9$var$kNumTransforms,
    transformDictionaryWord: $07144aea14354eb9$var$transformDictionaryWord
};
/* Copyright 2013 Google Inc. All Rights Reserved.

   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at

   http://www.apache.org/licenses/LICENSE-2.0

   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
*/ var $07144aea14354eb9$var$BrotliInput$1 = $07144aea14354eb9$var$streams$1.BrotliInput;
var $07144aea14354eb9$var$BrotliOutput$1 = $07144aea14354eb9$var$streams$1.BrotliOutput;
var $07144aea14354eb9$var$HuffmanCode$1 = $07144aea14354eb9$var$huffman.HuffmanCode;
var $07144aea14354eb9$var$BrotliBuildHuffmanTable$1 = $07144aea14354eb9$var$huffman.BrotliBuildHuffmanTable;
var $07144aea14354eb9$var$kDefaultCodeLength = 8;
var $07144aea14354eb9$var$kCodeLengthRepeatCode = 16;
var $07144aea14354eb9$var$kNumLiteralCodes = 256;
var $07144aea14354eb9$var$kNumInsertAndCopyCodes = 704;
var $07144aea14354eb9$var$kNumBlockLengthCodes = 26;
var $07144aea14354eb9$var$kLiteralContextBits = 6;
var $07144aea14354eb9$var$kDistanceContextBits = 2;
var $07144aea14354eb9$var$HUFFMAN_TABLE_BITS = 8;
var $07144aea14354eb9$var$HUFFMAN_TABLE_MASK = 0xff;
/* Maximum possible Huffman table size for an alphabet size of 704, max code
 * length 15 and root table bits 8. */ var $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE = 1080;
var $07144aea14354eb9$var$CODE_LENGTH_CODES = 18;
var $07144aea14354eb9$var$kCodeLengthCodeOrder = new Uint8Array([
    1,
    2,
    3,
    4,
    0,
    5,
    17,
    6,
    16,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15
]);
var $07144aea14354eb9$var$NUM_DISTANCE_SHORT_CODES = 16;
var $07144aea14354eb9$var$kDistanceShortCodeIndexOffset = new Uint8Array([
    3,
    2,
    1,
    0,
    3,
    3,
    3,
    3,
    3,
    3,
    2,
    2,
    2,
    2,
    2,
    2
]);
var $07144aea14354eb9$var$kDistanceShortCodeValueOffset = new Int8Array([
    0,
    0,
    0,
    0,
    -1,
    1,
    -2,
    2,
    -3,
    3,
    -1,
    1,
    -2,
    2,
    -3,
    3
]);
var $07144aea14354eb9$var$kMaxHuffmanTableSize = new Uint16Array([
    256,
    402,
    436,
    468,
    500,
    534,
    566,
    598,
    630,
    662,
    694,
    726,
    758,
    790,
    822,
    854,
    886,
    920,
    952,
    984,
    1016,
    1048,
    1080
]);
function $07144aea14354eb9$var$DecodeWindowBits(br) {
    var n;
    if (br.readBits(1) === 0) return 16;
    n = br.readBits(3);
    if (n > 0) return 17 + n;
    n = br.readBits(3);
    if (n > 0) return 8 + n;
    return 17;
}
/* Decodes a number in the range [0..255], by reading 1 - 11 bits. */ function $07144aea14354eb9$var$DecodeVarLenUint8(br) {
    if (br.readBits(1)) {
        var nbits = br.readBits(3);
        if (nbits === 0) return 1;
        else return br.readBits(nbits) + (1 << nbits);
    }
    return 0;
}
function $07144aea14354eb9$var$MetaBlockLength() {
    this.meta_block_length = 0;
    this.input_end = 0;
    this.is_uncompressed = 0;
    this.is_metadata = false;
}
function $07144aea14354eb9$var$DecodeMetaBlockLength(br) {
    var out = new $07144aea14354eb9$var$MetaBlockLength();
    var size_nibbles;
    var size_bytes;
    var i;
    out.input_end = br.readBits(1);
    if (out.input_end && br.readBits(1)) return out;
    size_nibbles = br.readBits(2) + 4;
    if (size_nibbles === 7) {
        out.is_metadata = true;
        if (br.readBits(1) !== 0) throw new Error('Invalid reserved bit');
        size_bytes = br.readBits(2);
        if (size_bytes === 0) return out;
        for(i = 0; i < size_bytes; i++){
            var next_byte = br.readBits(8);
            if (i + 1 === size_bytes && size_bytes > 1 && next_byte === 0) throw new Error('Invalid size byte');
            out.meta_block_length |= next_byte << i * 8;
        }
    } else for(i = 0; i < size_nibbles; ++i){
        var next_nibble = br.readBits(4);
        if (i + 1 === size_nibbles && size_nibbles > 4 && next_nibble === 0) throw new Error('Invalid size nibble');
        out.meta_block_length |= next_nibble << i * 4;
    }
    ++out.meta_block_length;
    if (!out.input_end && !out.is_metadata) out.is_uncompressed = br.readBits(1);
    return out;
}
/* Decodes the next Huffman code from bit-stream. */ function $07144aea14354eb9$var$ReadSymbol(table, index, br) {
    var nbits;
    br.fillBitWindow();
    index += br.val_ >>> br.bit_pos_ & $07144aea14354eb9$var$HUFFMAN_TABLE_MASK;
    nbits = table[index].bits - $07144aea14354eb9$var$HUFFMAN_TABLE_BITS;
    if (nbits > 0) {
        br.bit_pos_ += $07144aea14354eb9$var$HUFFMAN_TABLE_BITS;
        index += table[index].value;
        index += br.val_ >>> br.bit_pos_ & (1 << nbits) - 1;
    }
    br.bit_pos_ += table[index].bits;
    return table[index].value;
}
function $07144aea14354eb9$var$ReadHuffmanCodeLengths(code_length_code_lengths, num_symbols, code_lengths, br) {
    var symbol = 0;
    var prev_code_len = $07144aea14354eb9$var$kDefaultCodeLength;
    var repeat = 0;
    var repeat_code_len = 0;
    var space = 32768;
    var table = [];
    for(var i = 0; i < 32; i++)table.push(new $07144aea14354eb9$var$HuffmanCode$1(0, 0));
    $07144aea14354eb9$var$BrotliBuildHuffmanTable$1(table, 0, 5, code_length_code_lengths, $07144aea14354eb9$var$CODE_LENGTH_CODES);
    while(symbol < num_symbols && space > 0){
        var p = 0;
        var code_len;
        br.readMoreInput();
        br.fillBitWindow();
        p += br.val_ >>> br.bit_pos_ & 31;
        br.bit_pos_ += table[p].bits;
        code_len = table[p].value & 0xff;
        if (code_len < $07144aea14354eb9$var$kCodeLengthRepeatCode) {
            repeat = 0;
            code_lengths[symbol++] = code_len;
            if (code_len !== 0) {
                prev_code_len = code_len;
                space -= 32768 >> code_len;
            }
        } else {
            var extra_bits = code_len - 14;
            var old_repeat;
            var repeat_delta;
            var new_len = 0;
            if (code_len === $07144aea14354eb9$var$kCodeLengthRepeatCode) new_len = prev_code_len;
            if (repeat_code_len !== new_len) {
                repeat = 0;
                repeat_code_len = new_len;
            }
            old_repeat = repeat;
            if (repeat > 0) {
                repeat -= 2;
                repeat <<= extra_bits;
            }
            repeat += br.readBits(extra_bits) + 3;
            repeat_delta = repeat - old_repeat;
            if (symbol + repeat_delta > num_symbols) throw new Error('[ReadHuffmanCodeLengths] symbol + repeat_delta > num_symbols');
            for(var x = 0; x < repeat_delta; x++)code_lengths[symbol + x] = repeat_code_len;
            symbol += repeat_delta;
            if (repeat_code_len !== 0) space -= repeat_delta << 15 - repeat_code_len;
        }
    }
    if (space !== 0) throw new Error("[ReadHuffmanCodeLengths] space = " + space);
    for(; symbol < num_symbols; symbol++)code_lengths[symbol] = 0;
}
function $07144aea14354eb9$var$ReadHuffmanCode(alphabet_size, tables, table, br) {
    var table_size = 0;
    var simple_code_or_skip;
    var code_lengths = new Uint8Array(alphabet_size);
    br.readMoreInput();
    /* simple_code_or_skip is used as follows:
     1 for simple code;
     0 for no skipping, 2 skips 2 code lengths, 3 skips 3 code lengths */ simple_code_or_skip = br.readBits(2);
    if (simple_code_or_skip === 1) {
        /* Read symbols, codes & code lengths directly. */ var i;
        var max_bits_counter = alphabet_size - 1;
        var max_bits = 0;
        var symbols = new Int32Array(4);
        var num_symbols = br.readBits(2) + 1;
        while(max_bits_counter){
            max_bits_counter >>= 1;
            ++max_bits;
        }
        for(i = 0; i < num_symbols; ++i){
            symbols[i] = br.readBits(max_bits) % alphabet_size;
            code_lengths[symbols[i]] = 2;
        }
        code_lengths[symbols[0]] = 1;
        switch(num_symbols){
            case 1:
                break;
            case 3:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[1] === symbols[2]) throw new Error('[ReadHuffmanCode] invalid symbols');
                break;
            case 2:
                if (symbols[0] === symbols[1]) throw new Error('[ReadHuffmanCode] invalid symbols');
                code_lengths[symbols[1]] = 1;
                break;
            case 4:
                if (symbols[0] === symbols[1] || symbols[0] === symbols[2] || symbols[0] === symbols[3] || symbols[1] === symbols[2] || symbols[1] === symbols[3] || symbols[2] === symbols[3]) throw new Error('[ReadHuffmanCode] invalid symbols');
                if (br.readBits(1)) {
                    code_lengths[symbols[2]] = 3;
                    code_lengths[symbols[3]] = 3;
                } else code_lengths[symbols[0]] = 2;
                break;
        }
    } else {
        /* Decode Huffman-coded code lengths. */ var i;
        var code_length_code_lengths = new Uint8Array($07144aea14354eb9$var$CODE_LENGTH_CODES);
        var space = 32;
        var num_codes = 0;
        /* Static Huffman code for the code length code lengths */ var huff = [
            new $07144aea14354eb9$var$HuffmanCode$1(2, 0),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 4),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 3),
            new $07144aea14354eb9$var$HuffmanCode$1(3, 2),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 0),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 4),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 3),
            new $07144aea14354eb9$var$HuffmanCode$1(4, 1),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 0),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 4),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 3),
            new $07144aea14354eb9$var$HuffmanCode$1(3, 2),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 0),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 4),
            new $07144aea14354eb9$var$HuffmanCode$1(2, 3),
            new $07144aea14354eb9$var$HuffmanCode$1(4, 5)
        ];
        for(i = simple_code_or_skip; i < $07144aea14354eb9$var$CODE_LENGTH_CODES && space > 0; ++i){
            var code_len_idx = $07144aea14354eb9$var$kCodeLengthCodeOrder[i];
            var p = 0;
            var v;
            br.fillBitWindow();
            p += br.val_ >>> br.bit_pos_ & 15;
            br.bit_pos_ += huff[p].bits;
            v = huff[p].value;
            code_length_code_lengths[code_len_idx] = v;
            if (v !== 0) {
                space -= 32 >> v;
                ++num_codes;
            }
        }
        if (!(num_codes === 1 || space === 0)) throw new Error('[ReadHuffmanCode] invalid num_codes or space');
        $07144aea14354eb9$var$ReadHuffmanCodeLengths(code_length_code_lengths, alphabet_size, code_lengths, br);
    }
    table_size = $07144aea14354eb9$var$BrotliBuildHuffmanTable$1(tables, table, $07144aea14354eb9$var$HUFFMAN_TABLE_BITS, code_lengths, alphabet_size);
    if (table_size === 0) throw new Error("[ReadHuffmanCode] BuildHuffmanTable failed: ");
    return table_size;
}
function $07144aea14354eb9$var$ReadBlockLength(table, index, br) {
    var code;
    var nbits;
    code = $07144aea14354eb9$var$ReadSymbol(table, index, br);
    nbits = $07144aea14354eb9$var$prefix.kBlockLengthPrefixCode[code].nbits;
    return $07144aea14354eb9$var$prefix.kBlockLengthPrefixCode[code].offset + br.readBits(nbits);
}
function $07144aea14354eb9$var$TranslateShortCodes(code, ringbuffer, index) {
    var val;
    if (code < $07144aea14354eb9$var$NUM_DISTANCE_SHORT_CODES) {
        index += $07144aea14354eb9$var$kDistanceShortCodeIndexOffset[code];
        index &= 3;
        val = ringbuffer[index] + $07144aea14354eb9$var$kDistanceShortCodeValueOffset[code];
    } else val = code - $07144aea14354eb9$var$NUM_DISTANCE_SHORT_CODES + 1;
    return val;
}
function $07144aea14354eb9$var$MoveToFront(v, index) {
    var value = v[index];
    var i = index;
    for(; i; --i)v[i] = v[i - 1];
    v[0] = value;
}
function $07144aea14354eb9$var$InverseMoveToFrontTransform(v, v_len) {
    var mtf = new Uint8Array(256);
    var i;
    for(i = 0; i < 256; ++i)mtf[i] = i;
    for(i = 0; i < v_len; ++i){
        var index = v[i];
        v[i] = mtf[index];
        if (index) $07144aea14354eb9$var$MoveToFront(mtf, index);
    }
}
/* Contains a collection of huffman trees with the same alphabet size. */ function $07144aea14354eb9$var$HuffmanTreeGroup(alphabet_size, num_htrees) {
    this.alphabet_size = alphabet_size;
    this.num_htrees = num_htrees;
    this.codes = new Array(num_htrees + num_htrees * $07144aea14354eb9$var$kMaxHuffmanTableSize[alphabet_size + 31 >>> 5]);
    this.htrees = new Uint32Array(num_htrees);
}
$07144aea14354eb9$var$HuffmanTreeGroup.prototype.decode = function(br) {
    var i;
    var table_size;
    var next = 0;
    for(i = 0; i < this.num_htrees; ++i){
        this.htrees[i] = next;
        table_size = $07144aea14354eb9$var$ReadHuffmanCode(this.alphabet_size, this.codes, next, br);
        next += table_size;
    }
};
function $07144aea14354eb9$var$DecodeContextMap(context_map_size, br) {
    var out = {
        num_htrees: null,
        context_map: null
    };
    var use_rle_for_zeros;
    var max_run_length_prefix = 0;
    var table;
    var i;
    br.readMoreInput();
    var num_htrees = out.num_htrees = $07144aea14354eb9$var$DecodeVarLenUint8(br) + 1;
    var context_map = out.context_map = new Uint8Array(context_map_size);
    if (num_htrees <= 1) return out;
    use_rle_for_zeros = br.readBits(1);
    if (use_rle_for_zeros) max_run_length_prefix = br.readBits(4) + 1;
    table = [];
    for(i = 0; i < $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE; i++)table[i] = new $07144aea14354eb9$var$HuffmanCode$1(0, 0);
    $07144aea14354eb9$var$ReadHuffmanCode(num_htrees + max_run_length_prefix, table, 0, br);
    for(i = 0; i < context_map_size;){
        var code;
        br.readMoreInput();
        code = $07144aea14354eb9$var$ReadSymbol(table, 0, br);
        if (code === 0) {
            context_map[i] = 0;
            ++i;
        } else if (code <= max_run_length_prefix) {
            var reps = 1 + (1 << code) + br.readBits(code);
            while(--reps){
                if (i >= context_map_size) throw new Error("[DecodeContextMap] i >= context_map_size");
                context_map[i] = 0;
                ++i;
            }
        } else {
            context_map[i] = code - max_run_length_prefix;
            ++i;
        }
    }
    if (br.readBits(1)) $07144aea14354eb9$var$InverseMoveToFrontTransform(context_map, context_map_size);
    return out;
}
function $07144aea14354eb9$var$DecodeBlockType(max_block_type, trees, tree_type, block_types, ringbuffers, indexes, br) {
    var ringbuffer = tree_type * 2;
    var index = tree_type;
    var type_code = $07144aea14354eb9$var$ReadSymbol(trees, tree_type * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
    var block_type;
    if (type_code === 0) block_type = ringbuffers[ringbuffer + (indexes[index] & 1)];
    else if (type_code === 1) block_type = ringbuffers[ringbuffer + (indexes[index] - 1 & 1)] + 1;
    else block_type = type_code - 2;
    if (block_type >= max_block_type) block_type -= max_block_type;
    block_types[tree_type] = block_type;
    ringbuffers[ringbuffer + (indexes[index] & 1)] = block_type;
    ++indexes[index];
}
function $07144aea14354eb9$var$CopyUncompressedBlockToOutput(output, len, pos, ringbuffer, ringbuffer_mask, br) {
    var rb_size = ringbuffer_mask + 1;
    var rb_pos = pos & ringbuffer_mask;
    var br_pos = br.pos_ & $07144aea14354eb9$var$bit_reader.IBUF_MASK;
    var nbytes;
    /* For short lengths copy byte-by-byte */ if (len < 8 || br.bit_pos_ + (len << 3) < br.bit_end_pos_) {
        while(len-- > 0){
            br.readMoreInput();
            ringbuffer[rb_pos++] = br.readBits(8);
            if (rb_pos === rb_size) {
                output.write(ringbuffer, rb_size);
                rb_pos = 0;
            }
        }
        return;
    }
    if (br.bit_end_pos_ < 32) throw new Error('[CopyUncompressedBlockToOutput] br.bit_end_pos_ < 32');
    /* Copy remaining 0-4 bytes from br.val_ to ringbuffer. */ while(br.bit_pos_ < 32){
        ringbuffer[rb_pos] = br.val_ >>> br.bit_pos_;
        br.bit_pos_ += 8;
        ++rb_pos;
        --len;
    }
    /* Copy remaining bytes from br.buf_ to ringbuffer. */ nbytes = br.bit_end_pos_ - br.bit_pos_ >> 3;
    if (br_pos + nbytes > $07144aea14354eb9$var$bit_reader.IBUF_MASK) {
        var tail = $07144aea14354eb9$var$bit_reader.IBUF_MASK + 1 - br_pos;
        for(var x = 0; x < tail; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
        nbytes -= tail;
        rb_pos += tail;
        len -= tail;
        br_pos = 0;
    }
    for(var x = 0; x < nbytes; x++)ringbuffer[rb_pos + x] = br.buf_[br_pos + x];
    rb_pos += nbytes;
    len -= nbytes;
    /* If we wrote past the logical end of the ringbuffer, copy the tail of the
     ringbuffer to its beginning and flush the ringbuffer to the output. */ if (rb_pos >= rb_size) {
        output.write(ringbuffer, rb_size);
        rb_pos -= rb_size;
        for(var x = 0; x < rb_pos; x++)ringbuffer[x] = ringbuffer[rb_size + x];
    }
    /* If we have more to copy than the remaining size of the ringbuffer, then we
     first fill the ringbuffer from the input and then flush the ringbuffer to
     the output */ while(rb_pos + len >= rb_size){
        nbytes = rb_size - rb_pos;
        if (br.input_.read(ringbuffer, rb_pos, nbytes) < nbytes) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
        output.write(ringbuffer, rb_size);
        len -= nbytes;
        rb_pos = 0;
    }
    /* Copy straight from the input onto the ringbuffer. The ringbuffer will be
     flushed to the output at a later time. */ if (br.input_.read(ringbuffer, rb_pos, len) < len) throw new Error('[CopyUncompressedBlockToOutput] not enough bytes');
    /* Restore the state of the bit reader. */ br.reset();
}
/* Advances the bit reader position to the next byte boundary and verifies
   that any skipped bits are set to zero. */ function $07144aea14354eb9$var$JumpToByteBoundary(br) {
    var new_bit_pos = br.bit_pos_ + 7 & -8;
    var pad_bits = br.readBits(new_bit_pos - br.bit_pos_);
    return pad_bits == 0;
}
function $07144aea14354eb9$var$BrotliDecompressedSize(buffer) {
    var input = new $07144aea14354eb9$var$BrotliInput$1(buffer);
    var br = new $07144aea14354eb9$var$bit_reader(input);
    $07144aea14354eb9$var$DecodeWindowBits(br);
    var out = $07144aea14354eb9$var$DecodeMetaBlockLength(br);
    return out.meta_block_length;
}
var $07144aea14354eb9$var$BrotliDecompressedSize_1 = $07144aea14354eb9$var$BrotliDecompressedSize;
function $07144aea14354eb9$var$BrotliDecompressBuffer(buffer, output_size) {
    var input = new $07144aea14354eb9$var$BrotliInput$1(buffer);
    if (output_size == null) output_size = $07144aea14354eb9$var$BrotliDecompressedSize(buffer);
    var output_buffer = new Uint8Array(output_size);
    var output = new $07144aea14354eb9$var$BrotliOutput$1(output_buffer);
    $07144aea14354eb9$var$BrotliDecompress(input, output);
    if (output.pos < output.buffer.length) output.buffer = output.buffer.subarray(0, output.pos);
    return output.buffer;
}
var $07144aea14354eb9$var$BrotliDecompressBuffer_1 = $07144aea14354eb9$var$BrotliDecompressBuffer;
function $07144aea14354eb9$var$BrotliDecompress(input, output) {
    var i;
    var pos = 0;
    var input_end = 0;
    var window_bits = 0;
    var max_backward_distance;
    var max_distance = 0;
    var ringbuffer_size;
    var ringbuffer_mask;
    var ringbuffer;
    var ringbuffer_end;
    /* This ring buffer holds a few past copy distances that will be used by */ /* some special distance codes. */ var dist_rb = [
        16,
        15,
        11,
        4
    ];
    var dist_rb_idx = 0;
    /* The previous 2 bytes used for context. */ var prev_byte1 = 0;
    var prev_byte2 = 0;
    var hgroup = [
        new $07144aea14354eb9$var$HuffmanTreeGroup(0, 0),
        new $07144aea14354eb9$var$HuffmanTreeGroup(0, 0),
        new $07144aea14354eb9$var$HuffmanTreeGroup(0, 0)
    ];
    var block_type_trees;
    var block_len_trees;
    var br;
    /* We need the slack region for the following reasons:
       - always doing two 8-byte copies for fast backward copying
       - transforms
       - flushing the input ringbuffer when decoding uncompressed blocks */ var kRingBufferWriteAheadSlack = 128 + $07144aea14354eb9$var$bit_reader.READ_SIZE;
    br = new $07144aea14354eb9$var$bit_reader(input);
    /* Decode window size. */ window_bits = $07144aea14354eb9$var$DecodeWindowBits(br);
    max_backward_distance = (1 << window_bits) - 16;
    ringbuffer_size = 1 << window_bits;
    ringbuffer_mask = ringbuffer_size - 1;
    ringbuffer = new Uint8Array(ringbuffer_size + kRingBufferWriteAheadSlack + $07144aea14354eb9$var$dictionary.maxDictionaryWordLength);
    ringbuffer_end = ringbuffer_size;
    block_type_trees = [];
    block_len_trees = [];
    for(var x = 0; x < 3 * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE; x++){
        block_type_trees[x] = new $07144aea14354eb9$var$HuffmanCode$1(0, 0);
        block_len_trees[x] = new $07144aea14354eb9$var$HuffmanCode$1(0, 0);
    }
    while(!input_end){
        var meta_block_remaining_len = 0;
        var is_uncompressed;
        var block_length = [
            268435456,
            268435456,
            268435456
        ];
        var block_type = [
            0
        ];
        var num_block_types = [
            1,
            1,
            1
        ];
        var block_type_rb = [
            0,
            1,
            0,
            1,
            0,
            1
        ];
        var block_type_rb_index = [
            0
        ];
        var distance_postfix_bits;
        var num_direct_distance_codes;
        var distance_postfix_mask;
        var num_distance_codes;
        var context_map = null;
        var context_modes = null;
        var num_literal_htrees;
        var dist_context_map = null;
        var num_dist_htrees;
        var context_offset = 0;
        var context_map_slice = null;
        var literal_htree_index = 0;
        var dist_context_offset = 0;
        var dist_context_map_slice = null;
        var dist_htree_index = 0;
        var context_lookup_offset1 = 0;
        var context_lookup_offset2 = 0;
        var context_mode;
        var htree_command;
        for(i = 0; i < 3; ++i){
            hgroup[i].codes = null;
            hgroup[i].htrees = null;
        }
        br.readMoreInput();
        var _out = $07144aea14354eb9$var$DecodeMetaBlockLength(br);
        meta_block_remaining_len = _out.meta_block_length;
        if (pos + meta_block_remaining_len > output.buffer.length) {
            /* We need to grow the output buffer to fit the additional data. */ var tmp = new Uint8Array(pos + meta_block_remaining_len);
            tmp.set(output.buffer);
            output.buffer = tmp;
        }
        input_end = _out.input_end;
        is_uncompressed = _out.is_uncompressed;
        if (_out.is_metadata) {
            $07144aea14354eb9$var$JumpToByteBoundary(br);
            for(; meta_block_remaining_len > 0; --meta_block_remaining_len){
                br.readMoreInput();
                /* Read one byte and ignore it. */ br.readBits(8);
            }
            continue;
        }
        if (meta_block_remaining_len === 0) continue;
        if (is_uncompressed) {
            br.bit_pos_ = br.bit_pos_ + 7 & -8;
            $07144aea14354eb9$var$CopyUncompressedBlockToOutput(output, meta_block_remaining_len, pos, ringbuffer, ringbuffer_mask, br);
            pos += meta_block_remaining_len;
            continue;
        }
        for(i = 0; i < 3; ++i){
            num_block_types[i] = $07144aea14354eb9$var$DecodeVarLenUint8(br) + 1;
            if (num_block_types[i] >= 2) {
                $07144aea14354eb9$var$ReadHuffmanCode(num_block_types[i] + 2, block_type_trees, i * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
                $07144aea14354eb9$var$ReadHuffmanCode($07144aea14354eb9$var$kNumBlockLengthCodes, block_len_trees, i * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_length[i] = $07144aea14354eb9$var$ReadBlockLength(block_len_trees, i * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
                block_type_rb_index[i] = 1;
            }
        }
        br.readMoreInput();
        distance_postfix_bits = br.readBits(2);
        num_direct_distance_codes = $07144aea14354eb9$var$NUM_DISTANCE_SHORT_CODES + (br.readBits(4) << distance_postfix_bits);
        distance_postfix_mask = (1 << distance_postfix_bits) - 1;
        num_distance_codes = num_direct_distance_codes + (48 << distance_postfix_bits);
        context_modes = new Uint8Array(num_block_types[0]);
        for(i = 0; i < num_block_types[0]; ++i){
            br.readMoreInput();
            context_modes[i] = br.readBits(2) << 1;
        }
        var _o1 = $07144aea14354eb9$var$DecodeContextMap(num_block_types[0] << $07144aea14354eb9$var$kLiteralContextBits, br);
        num_literal_htrees = _o1.num_htrees;
        context_map = _o1.context_map;
        var _o2 = $07144aea14354eb9$var$DecodeContextMap(num_block_types[2] << $07144aea14354eb9$var$kDistanceContextBits, br);
        num_dist_htrees = _o2.num_htrees;
        dist_context_map = _o2.context_map;
        hgroup[0] = new $07144aea14354eb9$var$HuffmanTreeGroup($07144aea14354eb9$var$kNumLiteralCodes, num_literal_htrees);
        hgroup[1] = new $07144aea14354eb9$var$HuffmanTreeGroup($07144aea14354eb9$var$kNumInsertAndCopyCodes, num_block_types[1]);
        hgroup[2] = new $07144aea14354eb9$var$HuffmanTreeGroup(num_distance_codes, num_dist_htrees);
        for(i = 0; i < 3; ++i)hgroup[i].decode(br);
        context_map_slice = 0;
        dist_context_map_slice = 0;
        context_mode = context_modes[block_type[0]];
        context_lookup_offset1 = $07144aea14354eb9$var$context.lookupOffsets[context_mode];
        context_lookup_offset2 = $07144aea14354eb9$var$context.lookupOffsets[context_mode + 1];
        htree_command = hgroup[1].htrees[0];
        while(meta_block_remaining_len > 0){
            var cmd_code;
            var range_idx;
            var insert_code;
            var copy_code;
            var insert_length;
            var copy_length;
            var distance_code;
            var distance;
            var context$1;
            var j;
            var copy_dst;
            br.readMoreInput();
            if (block_length[1] === 0) {
                $07144aea14354eb9$var$DecodeBlockType(num_block_types[1], block_type_trees, 1, block_type, block_type_rb, block_type_rb_index, br);
                block_length[1] = $07144aea14354eb9$var$ReadBlockLength(block_len_trees, $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
                htree_command = hgroup[1].htrees[block_type[1]];
            }
            --block_length[1];
            cmd_code = $07144aea14354eb9$var$ReadSymbol(hgroup[1].codes, htree_command, br);
            range_idx = cmd_code >> 6;
            if (range_idx >= 2) {
                range_idx -= 2;
                distance_code = -1;
            } else distance_code = 0;
            insert_code = $07144aea14354eb9$var$prefix.kInsertRangeLut[range_idx] + (cmd_code >> 3 & 7);
            copy_code = $07144aea14354eb9$var$prefix.kCopyRangeLut[range_idx] + (cmd_code & 7);
            insert_length = $07144aea14354eb9$var$prefix.kInsertLengthPrefixCode[insert_code].offset + br.readBits($07144aea14354eb9$var$prefix.kInsertLengthPrefixCode[insert_code].nbits);
            copy_length = $07144aea14354eb9$var$prefix.kCopyLengthPrefixCode[copy_code].offset + br.readBits($07144aea14354eb9$var$prefix.kCopyLengthPrefixCode[copy_code].nbits);
            prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
            for(j = 0; j < insert_length; ++j){
                br.readMoreInput();
                if (block_length[0] === 0) {
                    $07144aea14354eb9$var$DecodeBlockType(num_block_types[0], block_type_trees, 0, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[0] = $07144aea14354eb9$var$ReadBlockLength(block_len_trees, 0, br);
                    context_offset = block_type[0] << $07144aea14354eb9$var$kLiteralContextBits;
                    context_map_slice = context_offset;
                    context_mode = context_modes[block_type[0]];
                    context_lookup_offset1 = $07144aea14354eb9$var$context.lookupOffsets[context_mode];
                    context_lookup_offset2 = $07144aea14354eb9$var$context.lookupOffsets[context_mode + 1];
                }
                context$1 = $07144aea14354eb9$var$context.lookup[context_lookup_offset1 + prev_byte1] | $07144aea14354eb9$var$context.lookup[context_lookup_offset2 + prev_byte2];
                literal_htree_index = context_map[context_map_slice + context$1];
                --block_length[0];
                prev_byte2 = prev_byte1;
                prev_byte1 = $07144aea14354eb9$var$ReadSymbol(hgroup[0].codes, hgroup[0].htrees[literal_htree_index], br);
                ringbuffer[pos & ringbuffer_mask] = prev_byte1;
                if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                ++pos;
            }
            meta_block_remaining_len -= insert_length;
            if (meta_block_remaining_len <= 0) break;
            if (distance_code < 0) {
                var context$1;
                br.readMoreInput();
                if (block_length[2] === 0) {
                    $07144aea14354eb9$var$DecodeBlockType(num_block_types[2], block_type_trees, 2, block_type, block_type_rb, block_type_rb_index, br);
                    block_length[2] = $07144aea14354eb9$var$ReadBlockLength(block_len_trees, 2 * $07144aea14354eb9$var$HUFFMAN_MAX_TABLE_SIZE, br);
                    dist_context_offset = block_type[2] << $07144aea14354eb9$var$kDistanceContextBits;
                    dist_context_map_slice = dist_context_offset;
                }
                --block_length[2];
                context$1 = (copy_length > 4 ? 3 : copy_length - 2) & 0xff;
                dist_htree_index = dist_context_map[dist_context_map_slice + context$1];
                distance_code = $07144aea14354eb9$var$ReadSymbol(hgroup[2].codes, hgroup[2].htrees[dist_htree_index], br);
                if (distance_code >= num_direct_distance_codes) {
                    var nbits;
                    var postfix;
                    var offset;
                    distance_code -= num_direct_distance_codes;
                    postfix = distance_code & distance_postfix_mask;
                    distance_code >>= distance_postfix_bits;
                    nbits = (distance_code >> 1) + 1;
                    offset = (2 + (distance_code & 1) << nbits) - 4;
                    distance_code = num_direct_distance_codes + (offset + br.readBits(nbits) << distance_postfix_bits) + postfix;
                }
            }
            /* Convert the distance code to the actual distance by possibly looking */ /* up past distnaces from the ringbuffer. */ distance = $07144aea14354eb9$var$TranslateShortCodes(distance_code, dist_rb, dist_rb_idx);
            if (distance < 0) throw new Error('[BrotliDecompress] invalid distance');
            if (pos < max_backward_distance && max_distance !== max_backward_distance) max_distance = pos;
            else max_distance = max_backward_distance;
            copy_dst = pos & ringbuffer_mask;
            if (distance > max_distance) {
                if (copy_length >= $07144aea14354eb9$var$dictionary.minDictionaryWordLength && copy_length <= $07144aea14354eb9$var$dictionary.maxDictionaryWordLength) {
                    var offset = $07144aea14354eb9$var$dictionary.offsetsByLength[copy_length];
                    var word_id = distance - max_distance - 1;
                    var shift = $07144aea14354eb9$var$dictionary.sizeBitsByLength[copy_length];
                    var mask = (1 << shift) - 1;
                    var word_idx = word_id & mask;
                    var transform_idx = word_id >> shift;
                    offset += word_idx * copy_length;
                    if (transform_idx < $07144aea14354eb9$var$transform.kNumTransforms) {
                        var len = $07144aea14354eb9$var$transform.transformDictionaryWord(ringbuffer, copy_dst, offset, copy_length, transform_idx);
                        copy_dst += len;
                        pos += len;
                        meta_block_remaining_len -= len;
                        if (copy_dst >= ringbuffer_end) {
                            output.write(ringbuffer, ringbuffer_size);
                            for(var _x = 0; _x < copy_dst - ringbuffer_end; _x++)ringbuffer[_x] = ringbuffer[ringbuffer_end + _x];
                        }
                    } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                } else throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
            } else {
                if (distance_code > 0) {
                    dist_rb[dist_rb_idx & 3] = distance;
                    ++dist_rb_idx;
                }
                if (copy_length > meta_block_remaining_len) throw new Error("Invalid backward reference. pos: " + pos + " distance: " + distance + " len: " + copy_length + " bytes left: " + meta_block_remaining_len);
                for(j = 0; j < copy_length; ++j){
                    ringbuffer[pos & ringbuffer_mask] = ringbuffer[pos - distance & ringbuffer_mask];
                    if ((pos & ringbuffer_mask) === ringbuffer_mask) output.write(ringbuffer, ringbuffer_size);
                    ++pos;
                    --meta_block_remaining_len;
                }
            }
            /* When we get here, we must have inserted at least one literal and */ /* made a copy of at least length two, therefore accessing the last 2 */ /* bytes is valid. */ prev_byte1 = ringbuffer[pos - 1 & ringbuffer_mask];
            prev_byte2 = ringbuffer[pos - 2 & ringbuffer_mask];
        }
        /* Protect pos from overflow, wrap it around at every GB of input data */ pos &= 0x3fffffff;
    }
    output.write(ringbuffer, pos & ringbuffer_mask);
}
var $07144aea14354eb9$var$BrotliDecompress_1 = $07144aea14354eb9$var$BrotliDecompress;
$07144aea14354eb9$var$dictionary.init($07144aea14354eb9$var$BrotliDecompressBuffer);
var $07144aea14354eb9$var$decode = {
    BrotliDecompressedSize: $07144aea14354eb9$var$BrotliDecompressedSize_1,
    BrotliDecompressBuffer: $07144aea14354eb9$var$BrotliDecompressBuffer_1,
    BrotliDecompress: $07144aea14354eb9$var$BrotliDecompress_1
};
var $07144aea14354eb9$var$decompress = $07144aea14354eb9$var$decode.BrotliDecompressBuffer;
function $07144aea14354eb9$var$_inheritsLoose$g(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Represents a TrueType glyph in the WOFF2 format, which compresses glyphs differently.
 */ var $07144aea14354eb9$var$WOFF2Glyph = /*#__PURE__*/ function(_TTFGlyph) {
    $07144aea14354eb9$var$_inheritsLoose$g(WOFF2Glyph, _TTFGlyph);
    function WOFF2Glyph() {
        return _TTFGlyph.apply(this, arguments) || this;
    }
    var _proto = WOFF2Glyph.prototype;
    _proto._decode = function _decode() {
        // We have to decode in advance (in WOFF2Font), so just return the pre-decoded data.
        return this._font._transformedGlyphs[this.id];
    };
    _proto._getCBox = function _getCBox() {
        return this.path.bbox;
    };
    return WOFF2Glyph;
}($07144aea14354eb9$var$TTFGlyph);
var $07144aea14354eb9$var$Base128 = {
    decode: function decode(stream) {
        var result = 0;
        var iterable = [
            0,
            1,
            2,
            3,
            4
        ];
        for(var j = 0; j < iterable.length; j++){
            var code = stream.readUInt8(); // If any of the top seven bits are set then we're about to overflow.
            if (result & 0xe0000000) throw new Error('Overflow');
            result = result << 7 | code & 0x7f;
            if ((code & 0x80) === 0) return result;
        }
        throw new Error('Bad base 128 number');
    }
};
var $07144aea14354eb9$var$knownTags = [
    'cmap',
    'head',
    'hhea',
    'hmtx',
    'maxp',
    'name',
    'OS/2',
    'post',
    'cvt ',
    'fpgm',
    'glyf',
    'loca',
    'prep',
    'CFF ',
    'VORG',
    'EBDT',
    'EBLC',
    'gasp',
    'hdmx',
    'kern',
    'LTSH',
    'PCLT',
    'VDMX',
    'vhea',
    'vmtx',
    'BASE',
    'GDEF',
    'GPOS',
    'GSUB',
    'EBSC',
    'JSTF',
    'MATH',
    'CBDT',
    'CBLC',
    'COLR',
    'CPAL',
    'SVG ',
    'sbix',
    'acnt',
    'avar',
    'bdat',
    'bloc',
    'bsln',
    'cvar',
    'fdsc',
    'feat',
    'fmtx',
    'fvar',
    'gvar',
    'hsty',
    'just',
    'lcar',
    'mort',
    'morx',
    'opbd',
    'prop',
    'trak',
    'Zapf',
    'Silf',
    'Glat',
    'Gloc',
    'Feat',
    'Sill'
];
var $07144aea14354eb9$var$WOFF2DirectoryEntry = new $07144aea14354eb9$var$restructure.Struct({
    flags: $07144aea14354eb9$var$restructure.uint8,
    customTag: new $07144aea14354eb9$var$restructure.Optional(new $07144aea14354eb9$var$restructure.String(4), function(t) {
        return (t.flags & 0x3f) === 0x3f;
    }),
    tag: function tag(t) {
        return t.customTag || $07144aea14354eb9$var$knownTags[t.flags & 0x3f];
    },
    // || (() => { throw new Error(`Bad tag: ${flags & 0x3f}`); })(); },
    length: $07144aea14354eb9$var$Base128,
    transformVersion: function transformVersion(t) {
        return t.flags >>> 6 & 0x03;
    },
    transformed: function transformed(t) {
        return t.tag === 'glyf' || t.tag === 'loca' ? t.transformVersion === 0 : t.transformVersion !== 0;
    },
    transformLength: new $07144aea14354eb9$var$restructure.Optional($07144aea14354eb9$var$Base128, function(t) {
        return t.transformed;
    })
});
var $07144aea14354eb9$var$WOFF2Directory = new $07144aea14354eb9$var$restructure.Struct({
    tag: new $07144aea14354eb9$var$restructure.String(4),
    // should be 'wOF2'
    flavor: $07144aea14354eb9$var$restructure.uint32,
    length: $07144aea14354eb9$var$restructure.uint32,
    numTables: $07144aea14354eb9$var$restructure.uint16,
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint16),
    totalSfntSize: $07144aea14354eb9$var$restructure.uint32,
    totalCompressedSize: $07144aea14354eb9$var$restructure.uint32,
    majorVersion: $07144aea14354eb9$var$restructure.uint16,
    minorVersion: $07144aea14354eb9$var$restructure.uint16,
    metaOffset: $07144aea14354eb9$var$restructure.uint32,
    metaLength: $07144aea14354eb9$var$restructure.uint32,
    metaOrigLength: $07144aea14354eb9$var$restructure.uint32,
    privOffset: $07144aea14354eb9$var$restructure.uint32,
    privLength: $07144aea14354eb9$var$restructure.uint32,
    tables: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$WOFF2DirectoryEntry, 'numTables')
});
$07144aea14354eb9$var$WOFF2Directory.process = function() {
    var tables = {};
    for(var i = 0; i < this.tables.length; i++){
        var table = this.tables[i];
        tables[table.tag] = table;
    }
    return this.tables = tables;
};
function $07144aea14354eb9$var$_inheritsLoose$h(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
/**
 * Subclass of TTFFont that represents a TTF/OTF font compressed by WOFF2
 * See spec here: http://www.w3.org/TR/WOFF2/
 */ var $07144aea14354eb9$var$WOFF2Font = /*#__PURE__*/ function(_TTFFont) {
    $07144aea14354eb9$var$_inheritsLoose$h(WOFF2Font, _TTFFont);
    function WOFF2Font() {
        return _TTFFont.apply(this, arguments) || this;
    }
    WOFF2Font.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'wOF2';
    };
    var _proto = WOFF2Font.prototype;
    _proto._decodeDirectory = function _decodeDirectory() {
        this.directory = $07144aea14354eb9$var$WOFF2Directory.decode(this.stream);
        this._dataPos = this.stream.pos;
    };
    _proto._decompress = function _decompress() {
        // decompress data and setup table offsets if we haven't already
        if (!this._decompressed) {
            this.stream.pos = this._dataPos;
            var buffer = this.stream.readBuffer(this.directory.totalCompressedSize);
            var decompressedSize = 0;
            for(var tag in this.directory.tables){
                var entry = this.directory.tables[tag];
                entry.offset = decompressedSize;
                decompressedSize += entry.transformLength != null ? entry.transformLength : entry.length;
            }
            var decompressed = $07144aea14354eb9$var$decompress(buffer, decompressedSize);
            if (!decompressed) throw new Error('Error decoding compressed data in WOFF2');
            this.stream = new $07144aea14354eb9$var$restructure.DecodeStream(new $07144aea14354eb9$var$buffer_1(decompressed));
            this._decompressed = true;
        }
    };
    _proto._decodeTable = function _decodeTable(table) {
        this._decompress();
        return _TTFFont.prototype._decodeTable.call(this, table);
    } // Override this method to get a glyph and return our
    ;
    _proto._getBaseGlyph = function _getBaseGlyph(glyph, characters) {
        if (characters === void 0) characters = [];
        if (!this._glyphs[glyph]) {
            if (this.directory.tables.glyf && this.directory.tables.glyf.transformed) {
                if (!this._transformedGlyphs) this._transformGlyfTable();
                return this._glyphs[glyph] = new $07144aea14354eb9$var$WOFF2Glyph(glyph, characters, this);
            } else return _TTFFont.prototype._getBaseGlyph.call(this, glyph, characters);
        }
    };
    _proto._transformGlyfTable = function _transformGlyfTable() {
        this._decompress();
        this.stream.pos = this.directory.tables.glyf.offset;
        var table = $07144aea14354eb9$var$GlyfTable.decode(this.stream);
        var glyphs = [];
        for(var index = 0; index < table.numGlyphs; index++){
            var glyph = {};
            var nContours = table.nContours.readInt16BE();
            glyph.numberOfContours = nContours;
            if (nContours > 0) {
                // simple glyph
                var nPoints = [];
                var totalPoints = 0;
                for(var i = 0; i < nContours; i++){
                    var _r = $07144aea14354eb9$var$read255UInt16(table.nPoints);
                    totalPoints += _r;
                    nPoints.push(totalPoints);
                }
                glyph.points = $07144aea14354eb9$var$decodeTriplet(table.flags, table.glyphs, totalPoints);
                for(var _i = 0; _i < nContours; _i++)glyph.points[nPoints[_i] - 1].endContour = true;
                var instructionSize = $07144aea14354eb9$var$read255UInt16(table.glyphs);
            } else if (nContours < 0) {
                // composite glyph
                var haveInstructions = $07144aea14354eb9$var$TTFGlyph.prototype._decodeComposite.call({
                    _font: this
                }, glyph, table.composites);
                if (haveInstructions) var instructionSize = $07144aea14354eb9$var$read255UInt16(table.glyphs);
            }
            glyphs.push(glyph);
        }
        this._transformedGlyphs = glyphs;
    };
    return WOFF2Font;
}($07144aea14354eb9$var$TTFFont); // Special class that accepts a length and returns a sub-stream for that data
var $07144aea14354eb9$var$Substream = /*#__PURE__*/ function() {
    function Substream(length) {
        this.length = length;
        this._buf = new $07144aea14354eb9$var$restructure.Buffer(length);
    }
    var _proto2 = Substream.prototype;
    _proto2.decode = function decode(stream, parent) {
        return new $07144aea14354eb9$var$restructure.DecodeStream(this._buf.decode(stream, parent));
    };
    return Substream;
}(); // This struct represents the entire glyf table
var $07144aea14354eb9$var$GlyfTable = new $07144aea14354eb9$var$restructure.Struct({
    version: $07144aea14354eb9$var$restructure.uint32,
    numGlyphs: $07144aea14354eb9$var$restructure.uint16,
    indexFormat: $07144aea14354eb9$var$restructure.uint16,
    nContourStreamSize: $07144aea14354eb9$var$restructure.uint32,
    nPointsStreamSize: $07144aea14354eb9$var$restructure.uint32,
    flagStreamSize: $07144aea14354eb9$var$restructure.uint32,
    glyphStreamSize: $07144aea14354eb9$var$restructure.uint32,
    compositeStreamSize: $07144aea14354eb9$var$restructure.uint32,
    bboxStreamSize: $07144aea14354eb9$var$restructure.uint32,
    instructionStreamSize: $07144aea14354eb9$var$restructure.uint32,
    nContours: new $07144aea14354eb9$var$Substream('nContourStreamSize'),
    nPoints: new $07144aea14354eb9$var$Substream('nPointsStreamSize'),
    flags: new $07144aea14354eb9$var$Substream('flagStreamSize'),
    glyphs: new $07144aea14354eb9$var$Substream('glyphStreamSize'),
    composites: new $07144aea14354eb9$var$Substream('compositeStreamSize'),
    bboxes: new $07144aea14354eb9$var$Substream('bboxStreamSize'),
    instructions: new $07144aea14354eb9$var$Substream('instructionStreamSize')
});
var $07144aea14354eb9$var$WORD_CODE = 253;
var $07144aea14354eb9$var$ONE_MORE_BYTE_CODE2 = 254;
var $07144aea14354eb9$var$ONE_MORE_BYTE_CODE1 = 255;
var $07144aea14354eb9$var$LOWEST_U_CODE = 253;
function $07144aea14354eb9$var$read255UInt16(stream) {
    var code = stream.readUInt8();
    if (code === $07144aea14354eb9$var$WORD_CODE) return stream.readUInt16BE();
    if (code === $07144aea14354eb9$var$ONE_MORE_BYTE_CODE1) return stream.readUInt8() + $07144aea14354eb9$var$LOWEST_U_CODE;
    if (code === $07144aea14354eb9$var$ONE_MORE_BYTE_CODE2) return stream.readUInt8() + $07144aea14354eb9$var$LOWEST_U_CODE * 2;
    return code;
}
function $07144aea14354eb9$var$withSign(flag, baseval) {
    return flag & 1 ? baseval : -baseval;
}
function $07144aea14354eb9$var$decodeTriplet(flags, glyphs, nPoints) {
    var y;
    var x = y = 0;
    var res = [];
    for(var i = 0; i < nPoints; i++){
        var dx = 0, dy = 0;
        var flag = flags.readUInt8();
        var onCurve = !(flag >> 7);
        flag &= 0x7f;
        if (flag < 10) {
            dx = 0;
            dy = $07144aea14354eb9$var$withSign(flag, ((flag & 14) << 7) + glyphs.readUInt8());
        } else if (flag < 20) {
            dx = $07144aea14354eb9$var$withSign(flag, ((flag - 10 & 14) << 7) + glyphs.readUInt8());
            dy = 0;
        } else if (flag < 84) {
            var b0 = flag - 20;
            var b1 = glyphs.readUInt8();
            dx = $07144aea14354eb9$var$withSign(flag, 1 + (b0 & 0x30) + (b1 >> 4));
            dy = $07144aea14354eb9$var$withSign(flag >> 1, 1 + ((b0 & 0x0c) << 2) + (b1 & 0x0f));
        } else if (flag < 120) {
            var b0 = flag - 84;
            dx = $07144aea14354eb9$var$withSign(flag, 1 + (b0 / 12 << 8) + glyphs.readUInt8());
            dy = $07144aea14354eb9$var$withSign(flag >> 1, 1 + (b0 % 12 >> 2 << 8) + glyphs.readUInt8());
        } else if (flag < 124) {
            var b1 = glyphs.readUInt8();
            var b2 = glyphs.readUInt8();
            dx = $07144aea14354eb9$var$withSign(flag, (b1 << 4) + (b2 >> 4));
            dy = $07144aea14354eb9$var$withSign(flag >> 1, ((b2 & 0x0f) << 8) + glyphs.readUInt8());
        } else {
            dx = $07144aea14354eb9$var$withSign(flag, glyphs.readUInt16BE());
            dy = $07144aea14354eb9$var$withSign(flag >> 1, glyphs.readUInt16BE());
        }
        x += dx;
        y += dy;
        res.push(new $07144aea14354eb9$var$Point(onCurve, false, x, y));
    }
    return res;
}
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$s(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$s(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$s(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$s(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$s(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$s(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$9(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$9(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$9(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$9(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$TTCHeader = new $07144aea14354eb9$var$restructure.VersionedStruct($07144aea14354eb9$var$restructure.uint32, {
    0x00010000: {
        numFonts: $07144aea14354eb9$var$restructure.uint32,
        offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 'numFonts')
    },
    0x00020000: {
        numFonts: $07144aea14354eb9$var$restructure.uint32,
        offsets: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$restructure.uint32, 'numFonts'),
        dsigTag: $07144aea14354eb9$var$restructure.uint32,
        dsigLength: $07144aea14354eb9$var$restructure.uint32,
        dsigOffset: $07144aea14354eb9$var$restructure.uint32
    }
});
var $07144aea14354eb9$var$TrueTypeCollection = /*#__PURE__*/ function() {
    TrueTypeCollection.probe = function probe(buffer) {
        return buffer.toString('ascii', 0, 4) === 'ttcf';
    };
    function TrueTypeCollection(stream) {
        this.stream = stream;
        if (stream.readString(4) !== 'ttcf') throw new Error('Not a TrueType collection');
        this.header = $07144aea14354eb9$var$TTCHeader.decode(stream);
    }
    var _proto = TrueTypeCollection.prototype;
    _proto.getFont = function getFont(name) {
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$s(this.header.offsets), _step; !(_step = _iterator()).done;){
            var offset = _step.value;
            var stream = new $07144aea14354eb9$var$restructure.DecodeStream(this.stream.buffer);
            stream.pos = offset;
            var font = new $07144aea14354eb9$var$TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    $07144aea14354eb9$var$_createClass$9(TrueTypeCollection, [
        {
            key: "fonts",
            get: function get() {
                var fonts = [];
                for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$s(this.header.offsets), _step2; !(_step2 = _iterator2()).done;){
                    var offset = _step2.value;
                    var stream = new $07144aea14354eb9$var$restructure.DecodeStream(this.stream.buffer);
                    stream.pos = offset;
                    fonts.push(new $07144aea14354eb9$var$TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return TrueTypeCollection;
}();
function $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(o) {
    var i = 0;
    if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) {
        if (Array.isArray(o) || (o = $07144aea14354eb9$var$_unsupportedIterableToArray$t(o))) return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    i = o[Symbol.iterator]();
    return i.next.bind(i);
}
function $07144aea14354eb9$var$_unsupportedIterableToArray$t(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $07144aea14354eb9$var$_arrayLikeToArray$t(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $07144aea14354eb9$var$_arrayLikeToArray$t(o, minLen);
}
function $07144aea14354eb9$var$_arrayLikeToArray$t(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $07144aea14354eb9$var$_defineProperties$a(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $07144aea14354eb9$var$_createClass$a(Constructor, protoProps, staticProps) {
    if (protoProps) $07144aea14354eb9$var$_defineProperties$a(Constructor.prototype, protoProps);
    if (staticProps) $07144aea14354eb9$var$_defineProperties$a(Constructor, staticProps);
    return Constructor;
}
var $07144aea14354eb9$var$DFontName = new $07144aea14354eb9$var$restructure.String($07144aea14354eb9$var$restructure.uint8);
var $07144aea14354eb9$var$DFontData = new $07144aea14354eb9$var$restructure.Struct({
    len: $07144aea14354eb9$var$restructure.uint32,
    buf: new $07144aea14354eb9$var$restructure.Buffer('len')
});
var $07144aea14354eb9$var$Ref = new $07144aea14354eb9$var$restructure.Struct({
    id: $07144aea14354eb9$var$restructure.uint16,
    nameOffset: $07144aea14354eb9$var$restructure.int16,
    attr: $07144aea14354eb9$var$restructure.uint8,
    dataOffset: $07144aea14354eb9$var$restructure.uint24,
    handle: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$Type = new $07144aea14354eb9$var$restructure.Struct({
    name: new $07144aea14354eb9$var$restructure.String(4),
    maxTypeIndex: $07144aea14354eb9$var$restructure.uint16,
    refList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Ref, function(t) {
        return t.maxTypeIndex + 1;
    }), {
        type: 'parent'
    })
});
var $07144aea14354eb9$var$TypeList = new $07144aea14354eb9$var$restructure.Struct({
    length: $07144aea14354eb9$var$restructure.uint16,
    types: new $07144aea14354eb9$var$restructure.Array($07144aea14354eb9$var$Type, function(t) {
        return t.length + 1;
    })
});
var $07144aea14354eb9$var$DFontMap = new $07144aea14354eb9$var$restructure.Struct({
    reserved: new $07144aea14354eb9$var$restructure.Reserved($07144aea14354eb9$var$restructure.uint8, 24),
    typeList: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, $07144aea14354eb9$var$TypeList),
    nameListOffset: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint16, 'void')
});
var $07144aea14354eb9$var$DFontHeader = new $07144aea14354eb9$var$restructure.Struct({
    dataOffset: $07144aea14354eb9$var$restructure.uint32,
    map: new $07144aea14354eb9$var$restructure.Pointer($07144aea14354eb9$var$restructure.uint32, $07144aea14354eb9$var$DFontMap),
    dataLength: $07144aea14354eb9$var$restructure.uint32,
    mapLength: $07144aea14354eb9$var$restructure.uint32
});
var $07144aea14354eb9$var$DFont = /*#__PURE__*/ function() {
    DFont.probe = function probe(buffer) {
        var stream = new $07144aea14354eb9$var$restructure.DecodeStream(buffer);
        try {
            var header = $07144aea14354eb9$var$DFontHeader.decode(stream);
        } catch (e) {
            return false;
        }
        for(var _iterator = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(header.map.typeList.types), _step; !(_step = _iterator()).done;){
            var type = _step.value;
            if (type.name === 'sfnt') return true;
        }
        return false;
    };
    function DFont(stream) {
        this.stream = stream;
        this.header = $07144aea14354eb9$var$DFontHeader.decode(this.stream);
        for(var _iterator2 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(this.header.map.typeList.types), _step2; !(_step2 = _iterator2()).done;){
            var type = _step2.value;
            for(var _iterator3 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(type.refList), _step3; !(_step3 = _iterator3()).done;){
                var ref = _step3.value;
                if (ref.nameOffset >= 0) {
                    this.stream.pos = ref.nameOffset + this.header.map.nameListOffset;
                    ref.name = $07144aea14354eb9$var$DFontName.decode(this.stream);
                } else ref.name = null;
            }
            if (type.name === 'sfnt') this.sfnt = type;
        }
    }
    var _proto = DFont.prototype;
    _proto.getFont = function getFont(name) {
        if (!this.sfnt) return null;
        for(var _iterator4 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(this.sfnt.refList), _step4; !(_step4 = _iterator4()).done;){
            var ref = _step4.value;
            var pos = this.header.dataOffset + ref.dataOffset + 4;
            var stream = new $07144aea14354eb9$var$restructure.DecodeStream(this.stream.buffer.slice(pos));
            var font = new $07144aea14354eb9$var$TTFFont(stream);
            if (font.postscriptName === name) return font;
        }
        return null;
    };
    $07144aea14354eb9$var$_createClass$a(DFont, [
        {
            key: "fonts",
            get: function get() {
                var fonts = [];
                for(var _iterator5 = $07144aea14354eb9$var$_createForOfIteratorHelperLoose$t(this.sfnt.refList), _step5; !(_step5 = _iterator5()).done;){
                    var ref = _step5.value;
                    var pos = this.header.dataOffset + ref.dataOffset + 4;
                    var stream = new $07144aea14354eb9$var$restructure.DecodeStream(this.stream.buffer.slice(pos));
                    fonts.push(new $07144aea14354eb9$var$TTFFont(stream));
                }
                return fonts;
            }
        }
    ]);
    return DFont;
}();
$07144aea14354eb9$var$fontkit.registerFormat($07144aea14354eb9$var$TTFFont);
$07144aea14354eb9$var$fontkit.registerFormat($07144aea14354eb9$var$WOFFFont);
$07144aea14354eb9$var$fontkit.registerFormat($07144aea14354eb9$var$WOFF2Font);
$07144aea14354eb9$var$fontkit.registerFormat($07144aea14354eb9$var$TrueTypeCollection);
$07144aea14354eb9$var$fontkit.registerFormat($07144aea14354eb9$var$DFont);
var $07144aea14354eb9$export$2e2bcd8739ae039 = $07144aea14354eb9$var$fontkit;




var $1d319ccf5aedf40d$exports = {};
$1d319ccf5aedf40d$exports = $parcel$resolve("hTvjn");


function $c51ca12eee6b76ec$export$95da1ffe01c9afc1() {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
        const embedButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('embedButton');
        const imageSpacingSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageSpacingSlider');
        const imageSpacingNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('imageSpacingNumber');
        const columnsSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('columnsSlider');
        const columnsNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('columnsNumber');
        const realtimePreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('realtimePreviewContainer');
        // New inputs for individual margins
        const pageMarginTopSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginTopSlider');
        const pageMarginTopNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginTopNumber');
        const pageMarginBottomSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginBottomSlider');
        const pageMarginBottomNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginBottomNumber');
        const pageMarginLeftSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginLeftSlider');
        const pageMarginLeftNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginLeftNumber');
        const pageMarginRightSlider = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginRightSlider');
        const pageMarginRightNumber = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pageMarginRightNumber');
        if (!embedButton || !pageMarginTopSlider || !pageMarginTopNumber || !pageMarginBottomSlider || !pageMarginBottomNumber || !pageMarginLeftSlider || !pageMarginLeftNumber || !pageMarginRightSlider || !pageMarginRightNumber || !imageSpacingSlider || !imageSpacingNumber || !columnsSlider || !columnsNumber || !realtimePreviewContainer) {
            console.warn("\u30AA\u30D7\u30B7\u30E7\u30F3\u8A2D\u5B9A\u753B\u9762\u306EDOM\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002");
            return;
        }
        function syncInputs(slider, numberInput) {
            slider.value = numberInput.value;
        }
        pageMarginTopSlider.oninput = ()=>{
            pageMarginTopNumber.value = pageMarginTopSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginBottomSlider.oninput = ()=>{
            pageMarginBottomNumber.value = pageMarginBottomSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginLeftSlider.oninput = ()=>{
            pageMarginLeftNumber.value = pageMarginLeftSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginRightSlider.oninput = ()=>{
            pageMarginRightNumber.value = pageMarginRightSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        imageSpacingSlider.oninput = ()=>{
            imageSpacingNumber.value = imageSpacingSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        columnsSlider.oninput = ()=>{
            columnsNumber.value = columnsSlider.value;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginTopNumber.oninput = ()=>{
            syncInputs(pageMarginTopSlider, pageMarginTopNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginBottomNumber.oninput = ()=>{
            syncInputs(pageMarginBottomSlider, pageMarginBottomNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginLeftNumber.oninput = ()=>{
            syncInputs(pageMarginLeftSlider, pageMarginLeftNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        pageMarginRightNumber.oninput = ()=>{
            syncInputs(pageMarginRightSlider, pageMarginRightNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        imageSpacingNumber.oninput = ()=>{
            syncInputs(imageSpacingSlider, imageSpacingNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        columnsNumber.oninput = ()=>{
            syncInputs(columnsSlider, columnsNumber);
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        };
        embedButton.onclick = ()=>(/*#__PURE__*/ 0, /*#__PURE__*/ $1etvo._)(function*() {
                if (!(0, $fb4c7c5aada7368a$export$ca26e1dd869a40e) || (0, $fb4c7c5aada7368a$export$eba19cacbe4413).length === 0) {
                    alert("PDF\u30D5\u30A1\u30A4\u30EB\u3068\u753B\u50CF\u30D5\u30A1\u30A4\u30EB\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
                    return;
                }
                (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'flex';
                try {
                    const pdfBytes = (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f) || (yield (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).arrayBuffer());
                    const pdfDoc = yield $c8198d59b2f6ab16$export$2e2bcd8739ae039.load(pdfBytes); // グローバルなPDFLibを使用
                    const pages = pdfDoc.getPages();
                    // 🔹 日本語フォントなどのカスタムフォントを使う前に登録
                    pdfDoc.registerFontkit((0, $07144aea14354eb9$export$2e2bcd8739ae039));
                    const pageNumber = (0, $fb4c7c5aada7368a$export$9108de792d9756a9);
                    if (pageNumber < 1 || pageNumber > pages.length) {
                        alert(`\u{7121}\u{52B9}\u{306A}\u{30DA}\u{30FC}\u{30B8}\u{756A}\u{53F7}\u{3067}\u{3059}\u{3002}1\u{304B}\u{3089}${pages.length}\u{306E}\u{9593}\u{3067}\u{6307}\u{5B9A}\u{3057}\u{3066}\u{304F}\u{3060}\u{3055}\u{3044}\u{3002}`);
                        (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
                        return;
                    }
                    const targetPage = pages[pageNumber - 1];
                    const { width: pageWidth, height: pageHeight } = targetPage.getSize();
                    const marginTop = parseInt(pageMarginTopNumber.value) || 0;
                    const marginBottom = parseInt(pageMarginBottomNumber.value) || 0;
                    const marginLeft = parseInt(pageMarginLeftNumber.value) || 0;
                    const marginRightTop = parseInt(pageMarginRightNumber.value) || 0;
                    const imageSpacing = parseInt(imageSpacingNumber.value) || 0;
                    const userColumns = parseInt(columnsNumber.value) || 0;
                    const embeddedImages = [];
                    for (const imageObj of (0, $fb4c7c5aada7368a$export$eba19cacbe4413)){
                        let image;
                        if (imageObj.pdfEmbedType === 'image/jpeg') image = yield pdfDoc.embedJpg(imageObj.pdfEmbedBytes);
                        else if (imageObj.pdfEmbedType === 'image/png') image = yield pdfDoc.embedPng(imageObj.pdfEmbedBytes);
                        else {
                            alert(`\u{30B5}\u{30DD}\u{30FC}\u{30C8}\u{3055}\u{308C}\u{3066}\u{3044}\u{306A}\u{3044}\u{753B}\u{50CF}\u{5F62}\u{5F0F}\u{3067}\u{3059}: ${imageObj.file.name} (JPEG, PNG, HEIC\u{306E}\u{307F})`);
                            (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
                            return;
                        }
                        embeddedImages.push(image);
                    }
                    const numImages = embeddedImages.length;
                    const imageAspectRatios = embeddedImages.map((img)=>img.width / img.height);
                    const captionFontSizes = (0, $fb4c7c5aada7368a$export$eba19cacbe4413).map((img)=>img.captionFontSize || 10);
                    const captionMarginTopBottom = 5;
                    const placements = (0, $fb4c7c5aada7368a$export$ae150752c2ffc03c)(numImages, pageWidth, pageHeight, marginTop, marginBottom, marginLeft, marginRightTop, imageSpacing, userColumns, imageAspectRatios, captionFontSizes, captionMarginTopBottom);
                    if (!placements) {
                        alert("\u753B\u50CF\u3092\u30DA\u30FC\u30B8\u306B\u914D\u7F6E\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u30AA\u30D7\u30B7\u30E7\u30F3\u3092\u8ABF\u6574\u3057\u3066\u304F\u3060\u3055\u3044\u3002");
                        (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
                        return;
                    }
                    for(let i = 0; i < numImages; i++){
                        const image = embeddedImages[i];
                        const placement = placements[i];
                        targetPage.drawImage(image, {
                            x: placement.image.x,
                            y: placement.image.y_pdf,
                            width: placement.image.width,
                            height: placement.image.height
                        });
                        if ((0, $fb4c7c5aada7368a$export$eba19cacbe4413)[i].caption) {
                            const captionText = (0, $fb4c7c5aada7368a$export$eba19cacbe4413)[i].caption;
                            const fontSize = (0, $fb4c7c5aada7368a$export$eba19cacbe4413)[i].captionFontSize || 10;
                            let font;
                            const fontFamily = (0, $fb4c7c5aada7368a$export$eba19cacbe4413)[i].captionFontFamily;
                            if (!(0, $fb4c7c5aada7368a$export$3306ededec248893)[fontFamily]) {
                                if (fontFamily === 'NotoSansJP') try {
                                    const fontUrl = new URL($1d319ccf5aedf40d$exports);
                                    const fontBytes = yield fetch(fontUrl).then((res)=>res.arrayBuffer());
                                    console.log('Font bytes length:', fontBytes.byteLength);
                                    (0, $fb4c7c5aada7368a$export$3306ededec248893)[fontFamily] = yield pdfDoc.embedFont(fontBytes);
                                } catch (error) {
                                    console.error("NotoSansJP\u30D5\u30A9\u30F3\u30C8\u306E\u57CB\u3081\u8FBC\u307F\u306B\u5931\u6557\u3057\u307E\u3057\u305F\u3002Helvetica\u306B\u30D5\u30A9\u30FC\u30EB\u30D0\u30C3\u30AF\u3057\u307E\u3059\u3002", error);
                                    (0, $fb4c7c5aada7368a$export$3306ededec248893)[fontFamily] = yield pdfDoc.embedFont($3f3628f4443054b9$export$7dcb046109e65a3d.Helvetica);
                                }
                                else (0, $fb4c7c5aada7368a$export$3306ededec248893)[fontFamily] = yield pdfDoc.embedFont($3f3628f4443054b9$export$7dcb046109e65a3d[fontFamily] || $3f3628f4443054b9$export$7dcb046109e65a3d.Helvetica);
                            }
                            font = (0, $fb4c7c5aada7368a$export$3306ededec248893)[fontFamily];
                            const hexColor = (0, $fb4c7c5aada7368a$export$eba19cacbe4413)[i].captionFontColor || '#000000';
                            const r = parseInt(hexColor.slice(1, 3), 16) / 255;
                            const g = parseInt(hexColor.slice(3, 5), 16) / 255;
                            const b = parseInt(hexColor.slice(5, 7), 16) / 255;
                            const fontColor = $883da9eab467c3c8$export$8972dc0e6ad9238f(r, g, b);
                            let textWidth = font.widthOfTextAtSize(captionText, fontSize);
                            const centeredCaptionX = placement.caption.x + placement.caption.width / 2 - textWidth / 2;
                            targetPage.drawText(captionText, {
                                x: centeredCaptionX,
                                y: placement.caption.y_pdf,
                                font: font,
                                size: fontSize,
                                color: fontColor
                            });
                        }
                    }
                    yield (0, $fb4c7c5aada7368a$export$73192c261dae2ece)((yield pdfDoc.save())); // 処理済みPDFを保存
                    alert("\u753B\u50CF\u3092PDF\u306B\u8CBC\u308A\u4ED8\u3051\u307E\u3057\u305F\u3002");
                    (0, $cdce58d4b9fe69a2$export$901579c443c5a6a5)(); // プレビューを更新
                    (0, $cdce58d4b9fe69a2$export$938c1f6f80bafb78)(); // 画像をクリア
                    (0, $cdce58d4b9fe69a2$export$82766c9801b74cc7)(); // プレビューを更新
                } catch (error) {
                    console.error('Error during PDF processing:', error);
                    alert("PDF\u51E6\u7406\u4E2D\u306B\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002");
                } finally{
                    (0, $fb4c7c5aada7368a$export$63950c2525d2f62b).style.display = 'none';
                }
            })();
        // 初期表示
        (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        if (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e) // PDFのページサイズを取得してプレビューに反映
        try {
            const pdfBytes = yield (0, $fb4c7c5aada7368a$export$ca26e1dd869a40e).arrayBuffer();
            const pdfDoc = yield $c8198d59b2f6ab16$export$2e2bcd8739ae039.load(pdfBytes); // グローバルなPDFLibを使用
            const pages = pdfDoc.getPages();
            const firstPage = pages[0];
            const { width: width, height: height } = firstPage.getSize();
            (0, $fb4c7c5aada7368a$export$725f9d85e8117bbe)({
                width: width,
                height: height
            }); // utils.jsのsetterを使用
            realtimePreviewContainer.style.aspectRatio = `${width} / ${height}`;
            (0, $cdce58d4b9fe69a2$export$82766c9801b74cc7)();
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        } catch (error) {
            console.error("PDF\u306E\u30DA\u30FC\u30B8\u30B5\u30A4\u30BA\u306E\u53D6\u5F97\u306B\u5931\u6557\u3057\u307E\u3057\u305F:", error);
            // pdfPageSize = { width: 595.28, height: 841.89 }; // utils.jsのsetterを使用
            realtimePreviewContainer.style.aspectRatio = `${(0, $fb4c7c5aada7368a$export$4b1af53a3b1595e3).width} / ${(0, $fb4c7c5aada7368a$export$4b1af53a3b1595e3).height}`;
            (0, $fb4c7c5aada7368a$export$313a8a6b1cb8b92)();
        }
        else {
            realtimePreviewContainer.style.backgroundImage = 'none';
            realtimePreviewContainer.style.aspectRatio = `${(0, $fb4c7c5aada7368a$export$4b1af53a3b1595e3).width} / ${(0, $fb4c7c5aada7368a$export$4b1af53a3b1595e3).height}`;
        }
    })();
}



function $e751b78858ddfb14$export$94ebe82eed26c54a() {
    const restartButton = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('restartApp');
    if (!restartButton) {
        console.warn("\u7D50\u679C\u753B\u9762\u306EDOM\u8981\u7D20\u304C\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002");
        return;
    }
    restartButton.onclick = ()=>{
        // 状態をリセットして最初の画面に戻る
        (0, $fb4c7c5aada7368a$export$b538fd7a9cc7f22b)(null);
        (0, $fb4c7c5aada7368a$export$7ec495ac665155d4)([]);
        (0, $fb4c7c5aada7368a$export$73192c261dae2ece)(null);
        window.location.hash = '/pdf-select';
    };
    // 処理済みPDFがあればプレビューを表示
    if (0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f) (0, $fb4c7c5aada7368a$export$708ba2836d544b94)((0, $fb4c7c5aada7368a$export$ac139a6b71f5ce7f));
    else {
        // 直接結果画面に来た場合など、エラーメッセージを表示
        const pdfPreviewContainer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('pdfPreviewContainer');
        const downloadLink = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('downloadLink');
        if (pdfPreviewContainer) pdfPreviewContainer.innerHTML = "<p>\u51E6\u7406\u3055\u308C\u305FPDF\u304C\u3042\u308A\u307E\u305B\u3093\u3002</p>";
        if (downloadLink) downloadLink.style.display = 'none';
    }
}



function $a4d486fa5598ba16$export$ff780c082ce51549() {
    const resizer = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('panel-resizer');
    const panel = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('options-sidebar-panel');
    if (!resizer || !panel) return;
    const handleMouseDown = (e)=>{
        e.preventDefault();
        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };
    const handleMouseMove = (e)=>{
        const newHeight = window.innerHeight - e.clientY;
        const minHeight = 100; // パネルの最小高さ
        const maxHeight = window.innerHeight * 0.8; // パネルの最大高さ
        if (newHeight > minHeight && newHeight < maxHeight) panel.style.height = `${newHeight}px`;
    };
    const handleMouseUp = ()=>{
        document.removeEventListener('mousemove', handleMouseMove);
        document.removeEventListener('mouseup', handleMouseUp);
    };
    resizer.addEventListener('mousedown', handleMouseDown);
}


const $c002b45445107609$export$66b32f6f30eb4b4 = {
    '/': {
        title: "PC\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210 - PDF\u9078\u629E",
        className: 'page-pdf-select',
        render: ()=>`
            <h1>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}</h1>
            <div class="input-group">
                <label for="pdfFile" class="btn btn-border"><span>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}</span></label>
                <input type="file" id="pdfFile" accept="application/pdf" style="display: none;">
                <span id="pdfFileName" class="file-name">\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}</span>
            </div>
            <h2>PDF\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}</h2>
            <div id="pdfPreviewContainer">
                <p>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}\u{3068}\u{3053}\u{3053}\u{306B}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}</p>
            </div>
            <div class="btn-wrap">
                <a id="nextToImageSelect" class="btn btn-stripe"><span>\u{6B21}\u{3078}</span></a>
            </div>
        `,
        onMount: (0, $78afc7a7197e166b$export$38de6a934e5ef13)
    },
    '/pdf-select': {
        title: "PC\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210 - PDF\u9078\u629E",
        className: 'page-pdf-select',
        render: ()=>`
            <h1>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}</h1>
            <div class="input-group">
                <label for="pdfFile" class="btn btn-border"><span>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}</span></label>
                <input type="file" id="pdfFile" accept="application/pdf" style="display: none;">
                <span id="pdfFileName" class="file-name">\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}</span>
            </div>
            <h2>PDF\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}</h2>
            <div id="pdfPreviewContainer">
                <p>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}\u{3068}\u{3053}\u{3053}\u{306B}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}</p>
            </div>
            <div class="btn-wrap">
                <a id="nextToImageSelect" class="btn btn-stripe"><span>\u{6B21}\u{3078}</span></a>
            </div>
        `,
        onMount: (0, $78afc7a7197e166b$export$38de6a934e5ef13)
    },
    '/image-select': {
        title: "PC\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210 - \u753B\u50CF\u914D\u7F6E",
        className: 'page-image-select',
        render: ()=>`
            <div class="image-select-layout">
                <div class="options-sidebar" id="options-sidebar-panel">
                    <div class="panel-resizer" id="panel-resizer"></div>
                    <h1>\u{753B}\u{50CF}\u{914D}\u{7F6E}</h1>
                    <div class="input-group">
                        <label for="imageFiles" class="btn btn-border"><span>\u{753B}\u{50CF}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}</span></label>
                        <input type="file" id="imageFiles" accept="image/*" multiple style="display: none;">
                        <span id="imageFileNames" class="file-name">\u{9078}\u{629E}\u{3055}\u{308C}\u{3066}\u{3044}\u{307E}\u{305B}\u{3093}</span>
                    </div>
                    <div class="input-group">
                        <a id="clearButton" class="btn btn-border"><span>\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{30AF}\u{30EA}\u{30A2}</span></a>
                    </div>
					<details class="accordion">
    					<summary>\u{753B}\u{50CF}\u{4E00}\u{89A7}</summary>
						<div id="imagePreviewContainer" class="image-preview-container sortable-list">
							<p>\u{753B}\u{50CF}\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}\u{3068}\u{3053}\u{3053}\u{306B}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}</p>
						</div>
					</details>
					<details class="accordion options-group">
    					<summary>\u{914D}\u{7F6E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}</summary>
						<div class="accordion-content">
							<div class="inputs-wrapper">
								<label for="pageMarginTop">\u{4E0A}\u{30DE}\u{30FC}\u{30B8}\u{30F3} (pt):</label>
								<div class="input-controls">
									<input type="range" id="pageMarginTopSlider" value="20" min="0" max="500" step="1">
									<input type="number" id="pageMarginTopNumber" value="20" min="0" max="500">
								</div>
							</div>
							<div class="inputs-wrapper">
								<label for="pageMarginBottom">\u{4E0B}\u{30DE}\u{30FC}\u{30B8}\u{30F3} (pt):</label>
								<div class="input-controls">
									<input type="range" id="pageMarginBottomSlider" value="20" min="0" max="500" step="1">
									<input type="number" id="pageMarginBottomNumber" value="20" min="0" max="500">
								</div>
							</div>
							<div class="inputs-wrapper">
								<label for="pageMarginLeft">\u{5DE6}\u{30DE}\u{30FC}\u{30B8}\u{30F3} (pt):</label>
								<div class="input-controls">
									<input type="range" id="pageMarginLeftSlider" value="20" min="0" max="500" step="1">
									<input type="number" id="pageMarginLeftNumber" value="20" min="0" max="500">
								</div>
							</div>
							<div class="inputs-wrapper">
								<label for="pageMarginRight">\u{53F3}\u{30DE}\u{30FC}\u{30B8}\u{30F3} (pt):</label>
								<div class="input-controls">
									<input type="range" id="pageMarginRightSlider" value="20" min="0" max="500" step="1">
									<input type="number" id="pageMarginRightNumber" value="20" min="0" max="500">
								</div>
							</div>
							<div class="inputs-wrapper">
								<label for="imageSpacingNumber">\u{753B}\u{50CF}\u{9593}\u{306E}\u{30B9}\u{30DA}\u{30FC}\u{30B9} (pt):</label>
								<div class="input-controls">
									<input type="range" id="imageSpacingSlider" value="10" min="0" max="50" step="1">
									<input type="number" id="imageSpacingNumber" value="10" min="0" max="50">
								</div>
							</div>
							<div class="inputs-wrapper">
								<label for="columnsNumber">\u{5217}\u{6570} (0\u{3067}\u{81EA}\u{52D5}):</label>
								<div class="input-controls">
									<input type="range" id="columnsSlider" value="0" min="0" max="5" step="1">
									<input type="number" id="columnsNumber" value="0" min="0" max="5">
								</div>
							</div>
						</div>
                    </details>
                </div>
                <div class="preview-main">
                    <button class="sidebar-toggle" id="sidebar-toggle">
                        <span class="bar"></span>
                        <span class="bar"></span>
                        <span class="bar"></span>
                    </button>
                    <h2>\u{753B}\u{50CF}\u{914D}\u{7F6E}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}</h2>
                    <div id="realtimePreviewContainer" class="realtime-preview-container">
                        <p>\u{914D}\u{7F6E}\u{30AA}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{3092}\u{5909}\u{66F4}\u{3059}\u{308B}\u{3068}\u{3053}\u{3053}\u{306B}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}</p>
                    </div>
                    <div id="pdfPageCarousel" class="pdf-page-carousel"></div>
                    <div class="btn-wrap">
                        <a id="prevToPdfSelect" class="btn btn-stripe"><span>\u{524D}\u{3078}</span></a>
                        <a id="embedButton" class="btn btn-stripe"><span>\u{8CBC}\u{308A}\u{4ED8}\u{3051}</span></a>
                        <a id="nextToResult" class="btn btn-stripe"><span>\u{6B21}\u{3078}</span></a>
                    </div>
                </div>
            </div>
        `,
        onMount: ()=>{
            (0, $cdce58d4b9fe69a2$export$bed4af8c9b9c2e64)();
            (0, $c51ca12eee6b76ec$export$95da1ffe01c9afc1)();
            (0, $a4d486fa5598ba16$export$ff780c082ce51549)();
            const sidebarToggle = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('sidebar-toggle');
            const optionsSidebar = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('options-sidebar-panel');
            const previewMain = document.querySelector('.preview-main');
            if (sidebarToggle && optionsSidebar && previewMain) {
                // 初期表示でサイドバーをアクティブにする
                sidebarToggle.classList.add('active');
                optionsSidebar.classList.add('active');
                previewMain.classList.add('sidebar-active');
                sidebarToggle.addEventListener('click', ()=>{
                    sidebarToggle.classList.toggle('active');
                    optionsSidebar.classList.toggle('active');
                    previewMain.classList.toggle('sidebar-active');
                });
            }
        }
    },
    '/result': {
        title: "PC\u30EC\u30DD\u30FC\u30C8\u4F5C\u6210 - \u7D50\u679C",
        className: 'page-result',
        render: ()=>`
            <h1>PDF\u{51E6}\u{7406}\u{7D50}\u{679C}</h1>
            <h2>PDF\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}</h2>
            <div id="pdfPreviewContainer">
                <p>PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{3092}\u{9078}\u{629E}\u{3059}\u{308B}\u{3068}\u{3053}\u{3053}\u{306B}\u{30D7}\u{30EC}\u{30D3}\u{30E5}\u{30FC}\u{304C}\u{8868}\u{793A}\u{3055}\u{308C}\u{307E}\u{3059}\u{3002}</p>
            </div>
            <div class="btn-wrap">
                <a id="downloadLink" class="btn btn-stripe" style="display:none;"><span>\u{30C0}\u{30A6}\u{30F3}\u{30ED}\u{30FC}\u{30C9}</span></a>
                <a id="restartApp" class="btn btn-stripe"><span>\u{6700}\u{521D}\u{304B}\u{3089}\u{3084}\u{308A}\u{76F4}\u{3059}</span></a>
            </div>
        `,
        onMount: (0, $e751b78858ddfb14$export$94ebe82eed26c54a)
    },
    '/about': {
        title: "\u3053\u306E\u30A2\u30D7\u30EA\u306B\u3064\u3044\u3066",
        className: 'page-about',
        render: ()=>`
            <h1>\u{3053}\u{306E}\u{30A2}\u{30D7}\u{30EA}\u{306B}\u{3064}\u{3044}\u{3066}</h1>
            <p>\u{3053}\u{306E}\u{30A2}\u{30D7}\u{30EA}\u{30B1}\u{30FC}\u{30B7}\u{30E7}\u{30F3}\u{306F}\u{3001}PDF\u{30D5}\u{30A1}\u{30A4}\u{30EB}\u{306B}\u{8907}\u{6570}\u{306E}\u{753B}\u{50CF}\u{3092}\u{8CBC}\u{308A}\u{4ED8}\u{3051}\u{308B}\u{305F}\u{3081}\u{306E}\u{30C4}\u{30FC}\u{30EB}\u{3067}\u{3059}\u{3002}</p>
            <p>\u{753B}\u{50CF}\u{306E}\u{4F4D}\u{7F6E}\u{3001}\u{30B5}\u{30A4}\u{30BA}\u{3001}\u{30AD}\u{30E3}\u{30D7}\u{30B7}\u{30E7}\u{30F3}\u{306A}\u{3069}\u{3092}\u{8ABF}\u{6574}\u{3057}\u{3066}\u{3001}\u{30AA}\u{30EA}\u{30B8}\u{30CA}\u{30EB}\u{306E}PDF\u{3092}\u{4F5C}\u{6210}\u{3067}\u{304D}\u{307E}\u{3059}\u{3002}</p>
            <p>HEIC/HEIF\u{5F62}\u{5F0F}\u{306E}\u{753B}\u{50CF}\u{3082}\u{81EA}\u{52D5}\u{7684}\u{306B}JPEG\u{306B}\u{5909}\u{63DB}\u{3057}\u{3066}\u{51E6}\u{7406}\u{3057}\u{307E}\u{3059}\u{3002}</p>
        `,
        onMount: ()=>{
        // 特に初期化するイベントリスナーはない
        }
    }
};
const $c002b45445107609$export$5375cda95f0b0eb4 = ()=>{
    const path = window.location.hash.slice(1) || '/';
    const route = $c002b45445107609$export$66b32f6f30eb4b4[path];
    // 既存のクラスをクリア
    (0, $fb4c7c5aada7368a$export$729c8b7179294ba).className = '';
    if (route) {
        document.title = route.title;
        // 新しいクラスを追加
        if (route.className) (0, $fb4c7c5aada7368a$export$729c8b7179294ba).classList.add(route.className);
        (0, $fb4c7c5aada7368a$export$729c8b7179294ba).innerHTML = route.render();
        route.onMount(); // ビューがDOMに追加された後にイベントリスナーを設定
    } else {
        document.title = '404 Not Found';
        (0, $fb4c7c5aada7368a$export$729c8b7179294ba).innerHTML = "<h1>404 Not Found</h1><p>\u304A\u63A2\u3057\u306E\u30DA\u30FC\u30B8\u306F\u898B\u3064\u304B\u308A\u307E\u305B\u3093\u3067\u3057\u305F\u3002</p>";
    }
};



// ステップナビゲーションを更新する関数
const $5b4fe6348468a5a0$var$updateStepNavigation = ()=>{
    const path = window.location.hash.slice(1) || '/';
    console.log('Current path:', path); // 現在のパスをログ出力
    const stepNavItems = document.querySelectorAll('#step-nav .nav-item');
    stepNavItems.forEach((item)=>{
        item.classList.remove('active');
        item.classList.remove('complete'); // completeクラスもリセット
    });
    const stepOrder = [
        'pdf-select',
        'image-select',
        'result'
    ]; // ステップの順序を定義
    let currentStepIndex = -1;
    // 現在のパスに基づいてアクティブなナビゲーション項目を設定し、現在のステップのインデックスを特定
    if (path === '/' || path === '/pdf-select') {
        const element = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nav-pdf-select');
        console.log('nav-pdf-select element:', element); // 要素の存在を確認
        element === null || element === void 0 ? void 0 : element.classList.add('active');
        currentStepIndex = stepOrder.indexOf('pdf-select');
    } else if (path === '/image-select') {
        const element = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nav-image-select');
        console.log('nav-image-select element:', element); // 要素の存在を確認
        element === null || element === void 0 ? void 0 : element.classList.add('active');
        currentStepIndex = stepOrder.indexOf('image-select');
    } else if (path === '/result') {
        const element = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nav-result');
        console.log('nav-result element:', element); // 要素の存在を確認
        element === null || element === void 0 ? void 0 : element.classList.add('active');
        currentStepIndex = stepOrder.indexOf('result');
    } else if (path === '/about') {
        const element = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('nav-about');
        console.log('nav-about element:', element); // 要素の存在を確認
        element === null || element === void 0 ? void 0 : element.classList.add('active');
    }
    // 現在のステップより前のステップにcompleteクラスを付与
    if (currentStepIndex !== -1) for(let i = 0; i < currentStepIndex; i++){
        const stepId = `nav-${stepOrder[i]}`;
        const element = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)(stepId);
        console.log(`Complete element ${stepId}:`, element); // 要素の存在を確認
        element === null || element === void 0 ? void 0 : element.classList.add('complete');
    }
};
// 初期ロード時とハッシュ変更時にルーターとステップナビゲーションを更新
window.addEventListener('hashchange', ()=>{
    (0, $c002b45445107609$export$5375cda95f0b0eb4)();
    $5b4fe6348468a5a0$var$updateStepNavigation();
});
window.addEventListener('DOMContentLoaded', ()=>{
    (0, $c002b45445107609$export$5375cda95f0b0eb4)();
    $5b4fe6348468a5a0$var$updateStepNavigation(); // 初期ロード時にも更新
    const hamburgerMenu = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('hamburger-menu');
    const mainNav = (0, $fb4c7c5aada7368a$export$d16800b7e59a8051)('main-nav');
    console.log('hamburgerMenu element:', hamburgerMenu); // デバッグログ
    console.log('mainNav element:', mainNav); // デバッグログ
    if (hamburgerMenu && mainNav) {
        hamburgerMenu.addEventListener('click', ()=>{
            console.log('Hamburger menu clicked!'); // デバッグログ
            mainNav.classList.toggle('active');
            hamburgerMenu.classList.toggle('active');
        });
        // ナビゲーションリンクがクリックされたらメニューを閉じる
        mainNav.querySelectorAll('a').forEach((link)=>{
            link.addEventListener('click', ()=>{
                mainNav.classList.remove('active');
                hamburgerMenu.classList.remove('active');
            });
        });
    }
});

})();
//# sourceMappingURL=personal-color-app.ffc14246.js.map
